
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire20d4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire20d4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ayMG0", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1b2ls"));

});
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("f19YE", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", () => $aeeeb04cd6721116$export$22e77b9572c4fded);
$parcel$export(module.exports, "QueryClientProvider", () => $aeeeb04cd6721116$export$45604f0cc8ae667b);

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $aeeeb04cd6721116$export$da112d31b0149f31 = $acw62.createContext(void 0);
var $aeeeb04cd6721116$export$22e77b9572c4fded = (queryClient)=>{
    const client = $acw62.useContext($aeeeb04cd6721116$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $aeeeb04cd6721116$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $acw62.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($aeeeb04cd6721116$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};

});

parcelRegister("aphAM", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $7939e29d663dd3ed$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $7939e29d663dd3ed$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $7939e29d663dd3ed$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $7939e29d663dd3ed$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $7939e29d663dd3ed$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $7939e29d663dd3ed$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $7939e29d663dd3ed$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $7939e29d663dd3ed$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $7939e29d663dd3ed$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $7939e29d663dd3ed$export$5fcee62552a12fbf);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $7939e29d663dd3ed$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $7939e29d663dd3ed$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $7939e29d663dd3ed$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $7939e29d663dd3ed$export$b273b3273281a049);
$parcel$export(module.exports, "Router", () => $7939e29d663dd3ed$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Navigate", () => $7939e29d663dd3ed$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Outlet", () => $7939e29d663dd3ed$export$910ae8079b2c2852);
$parcel$export(module.exports, "Route", () => $7939e29d663dd3ed$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $7939e29d663dd3ed$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $7939e29d663dd3ed$export$52b333d321859367);
/**
 * React Router v6.25.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $2vsP7 = parcelRequire("2vsP7");
function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $2vsP7.matchPath)(pattern, (0, $2vsP7.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2vsP7.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $2vsP7.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $2vsP7.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $2vsP7.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $2vsP7.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $2vsP7.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $2vsP7.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $2vsP7.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $2vsP7.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $2vsP7.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $2vsP7.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $2vsP7.resolveTo)(to, (0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $2vsP7.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $2vsP7.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2vsP7.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $2vsP7.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $2vsP7.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $2vsP7.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $2vsP7.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss
    }).initialize();
}

});
parcelRegister("2vsP7", function(module, exports) {

$parcel$export(module.exports, "Action", () => $1d34d5c4a288b213$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $1d34d5c4a288b213$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $1d34d5c4a288b213$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $1d34d5c4a288b213$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $1d34d5c4a288b213$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $1d34d5c4a288b213$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $1d34d5c4a288b213$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $1d34d5c4a288b213$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $1d34d5c4a288b213$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $1d34d5c4a288b213$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $1d34d5c4a288b213$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $1d34d5c4a288b213$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $1d34d5c4a288b213$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $1d34d5c4a288b213$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $1d34d5c4a288b213$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $1d34d5c4a288b213$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $1d34d5c4a288b213$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $1d34d5c4a288b213$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $1d34d5c4a288b213$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $1d34d5c4a288b213$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $1d34d5c4a288b213$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnMissImpl = init.unstable_patchRoutesOnMiss;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnMissImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnMiss implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && patchRoutesOnMissImpl && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        // We need to run patchRoutesOnMiss in initialize()
        initialized = false;
        initialMatches = [];
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnMiss() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($1d34d5c4a288b213$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $1d34d5c4a288b213$var$ResultType.redirect,
                        response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $1d34d5c4a288b213$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "route-discovery",
                pathname: pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnMissImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else {
                let leafRoute = matches[matches.length - 1].route;
                if (leafRoute.path && (leafRoute.path === "*" || leafRoute.path.endsWith("/*"))) {
                    // If we matched a splat, it might only be because we haven't yet fetched
                    // the children that would match with a higher score, so let's fetch
                    // around and find out
                    let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    return {
                        active: true,
                        matches: partialMatches
                    };
                }
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        let route = partialMatches.length > 0 ? partialMatches[partialMatches.length - 1].route : null;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await $1d34d5c4a288b213$var$loadLazyRouteChildren(patchRoutesOnMissImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            let matchedSplat = false;
            if (newMatches) {
                let leafRoute = newMatches[newMatches.length - 1].route;
                if (leafRoute.index) // If we found an index route, we can stop
                return {
                    type: "success",
                    matches: newMatches
                };
                if (leafRoute.path && leafRoute.path.length > 0) {
                    if (leafRoute.path === "*") // If we found a splat route, we can't be sure there's not a
                    // higher-scoring route down some partial matches trail so we need
                    // to check that out
                    matchedSplat = true;
                    else // If we found a non-splat route, we can stop
                    return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // If we are no longer partially matching anything, this was either a
            // legit splat match above, or it's a 404.  Also avoid loops if the
            // second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.map((m)=>m.route.id).join("-") === newPartialMatches.map((m)=>m.route.id).join("-")) return {
                type: "success",
                matches: matchedSplat ? newMatches : null
            };
            partialMatches = newPartialMatches;
            route = partialMatches[partialMatches.length - 1].route;
            if (route.path === "*") // The splat is still our most accurate partial, so run with it
            return {
                type: "success",
                matches: partialMatches
            };
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isHandlerResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(unstable_dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($1d34d5c4a288b213$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $1d34d5c4a288b213$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnMiss() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function $1d34d5c4a288b213$var$loadLazyRouteChildren(patchRoutesOnMissImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnMissImpl({
                path: path,
                matches: matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && $1d34d5c4a288b213$var$isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = $1d34d5c4a288b213$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = $1d34d5c4a288b213$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $1d34d5c4a288b213$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                });
            };
            return $1d34d5c4a288b213$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$1d34d5c4a288b213$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) return {
        type: $1d34d5c4a288b213$var$ResultType.error,
        error: result,
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : status
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnMiss()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $1d34d5c4a288b213$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectHandlerResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});


parcelRegister("tL0U5", function(module, exports) {
$parcel$export(module.exports, "useApiMutation", () => (parcelRequire("4CoXh")).useApiMutation);
$parcel$export(module.exports, "useApiPolling", () => (parcelRequire("ioTAq")).useApiPolling);
$parcel$export(module.exports, "useApiQuery", () => (parcelRequire("7Y7Q4")).useApiQuery);
$parcel$export(module.exports, "createMutation", () => (parcelRequire("gBHSi")).createMutation);
$parcel$export(module.exports, "createQuery", () => (parcelRequire("kkxkw")).createQuery);
$parcel$export(module.exports, "queryClient", () => (parcelRequire("eX6Sv")).queryClient);
parcelRequire("lhALd");
parcelRequire("i5Lss");

});
parcelRegister("lhALd", function(module, exports) {
$parcel$export(module.exports, "useApiPolling", () => (parcelRequire("ioTAq")).useApiPolling);
$parcel$export(module.exports, "useApiQuery", () => (parcelRequire("7Y7Q4")).useApiQuery);
$parcel$export(module.exports, "useApiMutation", () => (parcelRequire("4CoXh")).useApiMutation);
parcelRequire("UXGeS");
parcelRequire("8y7qB");
parcelRequire("74MPp");

});
parcelRegister("UXGeS", function(module, exports) {
$parcel$export(module.exports, "useApiQuery", () => (parcelRequire("7Y7Q4")).useApiQuery);
$parcel$export(module.exports, "useApiPolling", () => (parcelRequire("ioTAq")).useApiPolling);
parcelRequire("7Y7Q4");
parcelRequire("ioTAq");

});
parcelRegister("7Y7Q4", function(module, exports) {

$parcel$export(module.exports, "useApiQuery", () => $02439eeb5a590932$export$3e0f719c89c826f3);

var $0GZvz = parcelRequire("0GZvz");
var $ba8s2 = parcelRequire("ba8s2");
var $f19YE = parcelRequire("f19YE");

var $5c7W3 = parcelRequire("5c7W3");

var $acw62 = parcelRequire("acw62");
parcelRequire("i5Lss");
var $4gN4F = parcelRequire("4gN4F");
parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");
parcelRequire("kL9vD");
var $edg5W = parcelRequire("edg5W");

var $er80J = parcelRequire("er80J");
function $02439eeb5a590932$export$3e0f719c89c826f3(query, hookOptions) {
    const options = {
        toastsEnabled: true,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($5c7W3)))(query, "queryFn"),
        ...hookOptions
    };
    const [pagination, setPagination] = (0, $acw62.useState)(options.pagination);
    const queryClient = (0, $f19YE.useQueryClient)();
    const session = (0, $edg5W.useSession)();
    const router = (0, $fp4OM.useRouter)();
    const api = (0, $er80J.useApiClient)(options.pagination?.currentUrl);
    const appContext = {
        api: api,
        session: session,
        params: options.params,
        router: router,
        queryClient: queryClient,
        pagination: pagination
    };
    const isWaitingForSession = options.waitForSession && !session.user;
    const isEnabled = (options?.enabled ?? true) && !isWaitingForSession;
    const queryKey = isEnabled ? options.key || query.key || (0, $4gN4F.getCacheKey)(query.queryFn, appContext, options.scope || query.scope) : [
        "disabled"
    ];
    const result = (0, $ba8s2.useQuery)({
        ...options,
        queryKey: queryKey,
        queryFn: isEnabled ? ()=>query.queryFn(appContext) : (0, $0GZvz.skipToken)
    });
    return {
        ...result,
        isLoading: result.isLoading || options.waitForSession && session.isLoading,
        session: session,
        params: options.params,
        router: router,
        queryClient: queryClient,
        queryKey: queryKey,
        setPaginationUrl: (0, $acw62.useCallback)((currentUrl)=>setPagination({
                ...pagination || {},
                currentUrl: currentUrl
            }), [])
    };
}

});
parcelRegister("0GZvz", function(module, exports) {

$parcel$export(module.exports, "isServer", () => $002159551d1c4551$export$6acf61af03e62db);
$parcel$export(module.exports, "noop", () => $002159551d1c4551$export$8793edee2d425525);
$parcel$export(module.exports, "functionalUpdate", () => $002159551d1c4551$export$7f095f455ad5af3f);
$parcel$export(module.exports, "isValidTimeout", () => $002159551d1c4551$export$e539f754e934e270);
$parcel$export(module.exports, "timeUntilStale", () => $002159551d1c4551$export$811b83d62bcf47f0);
$parcel$export(module.exports, "matchQuery", () => $002159551d1c4551$export$c5d1efe363797780);
$parcel$export(module.exports, "hashQueryKeyByOptions", () => $002159551d1c4551$export$cc90ca97bc0d73fd);
$parcel$export(module.exports, "partialMatchKey", () => $002159551d1c4551$export$2f07189bb9fa26a7);
$parcel$export(module.exports, "matchMutation", () => $002159551d1c4551$export$a1ea5fb559f63ae3);
$parcel$export(module.exports, "hashKey", () => $002159551d1c4551$export$1e87d19d4aab5805);
$parcel$export(module.exports, "shallowEqualObjects", () => $002159551d1c4551$export$3e67810a3f0e9f1c);
$parcel$export(module.exports, "sleep", () => $002159551d1c4551$export$e772c8ff12451969);
$parcel$export(module.exports, "replaceData", () => $002159551d1c4551$export$17619bac5b909b23);
$parcel$export(module.exports, "addToEnd", () => $002159551d1c4551$export$ccce65a22a26f2bc);
$parcel$export(module.exports, "addToStart", () => $002159551d1c4551$export$8c6246b73dd61f4a);
$parcel$export(module.exports, "skipToken", () => $002159551d1c4551$export$1aa5a89531b7670d);

// src/utils.ts
var $002159551d1c4551$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $002159551d1c4551$export$8793edee2d425525() {
    return void 0;
}
function $002159551d1c4551$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $002159551d1c4551$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $002159551d1c4551$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $002159551d1c4551$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $002159551d1c4551$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$002159551d1c4551$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $002159551d1c4551$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($002159551d1c4551$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $002159551d1c4551$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$002159551d1c4551$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $002159551d1c4551$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $002159551d1c4551$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $002159551d1c4551$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$002159551d1c4551$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $002159551d1c4551$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$002159551d1c4551$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $002159551d1c4551$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $002159551d1c4551$export$7a8558113332b71e(a) && $002159551d1c4551$export$7a8558113332b71e(b);
    if (array || $002159551d1c4551$export$53b83ca8eaab0383(a) && $002159551d1c4551$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if (!array && a[key] === void 0 && b[key] === void 0 && aItems.includes(key)) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $002159551d1c4551$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $002159551d1c4551$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $002159551d1c4551$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $002159551d1c4551$export$53b83ca8eaab0383(o) {
    if (!$002159551d1c4551$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$002159551d1c4551$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    return true;
}
function $002159551d1c4551$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $002159551d1c4551$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $002159551d1c4551$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) return $002159551d1c4551$export$77a71fc411098696(prevData, data);
    return data;
}
function $002159551d1c4551$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $002159551d1c4551$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $002159551d1c4551$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $002159551d1c4551$export$1aa5a89531b7670d = Symbol();

});

parcelRegister("ba8s2", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $82072f1c97bcdd9c$export$dd0a697e1782aedd);

var $53Inx = parcelRequire("53Inx");

var $2IwFE = parcelRequire("2IwFE");
"use client";
function $82072f1c97bcdd9c$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $2IwFE.useBaseQuery)(options, (0, $53Inx.QueryObserver), queryClient);
}

});
parcelRegister("53Inx", function(module, exports) {

$parcel$export(module.exports, "QueryObserver", () => $3aefa839a50a34b3$export$a06cf8c0066f0d4c);

var $4sZyw = parcelRequire("4sZyw");

var $0GZvz = parcelRequire("0GZvz");

var $aqN4U = parcelRequire("aqN4U");

var $2uOjt = parcelRequire("2uOjt");

var $64BU0 = parcelRequire("64BU0");

var $dxPKP = parcelRequire("dxPKP");
var $3aefa839a50a34b3$var$_client, $3aefa839a50a34b3$var$_currentQuery, $3aefa839a50a34b3$var$_currentQueryInitialState, $3aefa839a50a34b3$var$_currentResult, $3aefa839a50a34b3$var$_currentResultState, $3aefa839a50a34b3$var$_currentResultOptions, $3aefa839a50a34b3$var$_selectError, $3aefa839a50a34b3$var$_selectFn, $3aefa839a50a34b3$var$_selectResult, $3aefa839a50a34b3$var$_lastQueryWithDefinedData, $3aefa839a50a34b3$var$_staleTimeoutId, $3aefa839a50a34b3$var$_refetchIntervalId, $3aefa839a50a34b3$var$_currentRefetchInterval, $3aefa839a50a34b3$var$_trackedProps, $3aefa839a50a34b3$var$_executeFetch, $3aefa839a50a34b3$var$executeFetch_fn, $3aefa839a50a34b3$var$_updateStaleTimeout, $3aefa839a50a34b3$var$updateStaleTimeout_fn, $3aefa839a50a34b3$var$_computeRefetchInterval, $3aefa839a50a34b3$var$computeRefetchInterval_fn, $3aefa839a50a34b3$var$_updateRefetchInterval, $3aefa839a50a34b3$var$updateRefetchInterval_fn, $3aefa839a50a34b3$var$_updateTimers, $3aefa839a50a34b3$var$updateTimers_fn, $3aefa839a50a34b3$var$_clearStaleTimeout, $3aefa839a50a34b3$var$clearStaleTimeout_fn, $3aefa839a50a34b3$var$_clearRefetchInterval, $3aefa839a50a34b3$var$clearRefetchInterval_fn, $3aefa839a50a34b3$var$_updateQuery, $3aefa839a50a34b3$var$updateQuery_fn, $3aefa839a50a34b3$var$_notify, $3aefa839a50a34b3$var$notify_fn;
var $3aefa839a50a34b3$export$a06cf8c0066f0d4c = class extends (0, $64BU0.Subscribable) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_executeFetch);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_updateStaleTimeout);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_computeRefetchInterval);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_updateRefetchInterval);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_updateTimers);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_clearStaleTimeout);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_clearRefetchInterval);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_updateQuery);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_notify);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_client, void 0);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_currentQuery, void 0);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_currentQueryInitialState, void 0);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_currentResult, void 0);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_currentResultState, void 0);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_currentResultOptions, void 0);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_selectError, void 0);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_selectFn, void 0);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_selectResult, void 0);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData, void 0);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_staleTimeoutId, void 0);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_refetchIntervalId, void 0);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_currentRefetchInterval, void 0);
        (0, $4sZyw.__privateAdd)(this, $3aefa839a50a34b3$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_client, client);
        (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_selectError, null);
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery).addObserver(this);
            if ($3aefa839a50a34b3$var$shouldFetchOnMount((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery), this.options)) (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_executeFetch, $3aefa839a50a34b3$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_updateTimers, $3aefa839a50a34b3$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $3aefa839a50a34b3$var$shouldFetchOn((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $3aefa839a50a34b3$var$shouldFetchOn((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_clearStaleTimeout, $3aefa839a50a34b3$var$clearStaleTimeout_fn).call(this);
        (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_clearRefetchInterval, $3aefa839a50a34b3$var$clearRefetchInterval_fn).call(this);
        (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery).removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery);
        this.options = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
        (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_updateQuery, $3aefa839a50a34b3$var$updateQuery_fn).call(this);
        (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $0GZvz.shallowEqualObjects)(this.options, prevOptions)) (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $3aefa839a50a34b3$var$shouldFetchOptionally((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_executeFetch, $3aefa839a50a34b3$var$executeFetch_fn).call(this);
        this.updateResult(notifyOptions);
        if (mounted && ((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_updateStaleTimeout, $3aefa839a50a34b3$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_computeRefetchInterval, $3aefa839a50a34b3$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentRefetchInterval))) (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_updateRefetchInterval, $3aefa839a50a34b3$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_client).getQueryCache().build((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_client), options);
        const result = this.createResult(query, options);
        if ($3aefa839a50a34b3$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_currentResult, result);
            (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_currentResultOptions, this.options);
            (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_currentResultState, (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentResult);
    }
    trackResult(result, onPropTracked) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackProp(key);
                    onPropTracked == null || onPropTracked(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    trackProp(key) {
        (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_client).defaultQueryOptions(options);
        const query = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_client).getQueryCache().build((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_client), defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_executeFetch, $3aefa839a50a34b3$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentResult);
        const prevResultState = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentResultState);
        const prevResultOptions = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQueryInitialState);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $3aefa839a50a34b3$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $3aefa839a50a34b3$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $dxPKP.fetchState)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        if (options.select && newState.data !== void 0) {
            if (prevResult && newState.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_selectFn)) data = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_selectResult);
            else try {
                (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_selectFn, options.select);
                data = options.select(newState.data);
                data = (0, $0GZvz.replaceData)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_selectResult, data);
                (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_selectError, null);
            } catch (selectError) {
                (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_selectError, selectError);
            }
        } else data = newState.data;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData)) : options.placeholderData;
                if (options.select && placeholderData !== void 0) try {
                    placeholderData = options.select(placeholderData);
                    (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_selectError, null);
                } catch (selectError) {
                    (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_selectError, selectError);
                }
            }
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $0GZvz.replaceData)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if ((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_selectError)) {
            error = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_selectError);
            data = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $3aefa839a50a34b3$var$isStale(query, options),
            refetch: this.refetch
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentResult);
        const nextResult = this.createResult((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery), this.options);
        (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_currentResultState, (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery).state);
        (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_currentResultOptions, this.options);
        if ((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentResultState).data !== void 0) (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData, (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery));
        if ((0, $0GZvz.shallowEqualObjects)(nextResult, prevResult)) return;
        (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_currentResult, nextResult);
        const defaultNotifyOptions = {};
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_notify, $3aefa839a50a34b3$var$notify_fn).call(this, {
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_updateTimers, $3aefa839a50a34b3$var$updateTimers_fn).call(this);
    }
};
$3aefa839a50a34b3$var$_client = new WeakMap();
$3aefa839a50a34b3$var$_currentQuery = new WeakMap();
$3aefa839a50a34b3$var$_currentQueryInitialState = new WeakMap();
$3aefa839a50a34b3$var$_currentResult = new WeakMap();
$3aefa839a50a34b3$var$_currentResultState = new WeakMap();
$3aefa839a50a34b3$var$_currentResultOptions = new WeakMap();
$3aefa839a50a34b3$var$_selectError = new WeakMap();
$3aefa839a50a34b3$var$_selectFn = new WeakMap();
$3aefa839a50a34b3$var$_selectResult = new WeakMap();
$3aefa839a50a34b3$var$_lastQueryWithDefinedData = new WeakMap();
$3aefa839a50a34b3$var$_staleTimeoutId = new WeakMap();
$3aefa839a50a34b3$var$_refetchIntervalId = new WeakMap();
$3aefa839a50a34b3$var$_currentRefetchInterval = new WeakMap();
$3aefa839a50a34b3$var$_trackedProps = new WeakMap();
$3aefa839a50a34b3$var$_executeFetch = new WeakSet();
$3aefa839a50a34b3$var$executeFetch_fn = function(fetchOptions) {
    (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_updateQuery, $3aefa839a50a34b3$var$updateQuery_fn).call(this);
    let promise = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $0GZvz.noop));
    return promise;
};
$3aefa839a50a34b3$var$_updateStaleTimeout = new WeakSet();
$3aefa839a50a34b3$var$updateStaleTimeout_fn = function() {
    (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_clearStaleTimeout, $3aefa839a50a34b3$var$clearStaleTimeout_fn).call(this);
    if ((0, $0GZvz.isServer) || (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentResult).isStale || !(0, $0GZvz.isValidTimeout)(this.options.staleTime)) return;
    const time = (0, $0GZvz.timeUntilStale)((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentResult).dataUpdatedAt, this.options.staleTime);
    const timeout = time + 1;
    (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_staleTimeoutId, setTimeout(()=>{
        if (!(0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$3aefa839a50a34b3$var$_computeRefetchInterval = new WeakSet();
$3aefa839a50a34b3$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$3aefa839a50a34b3$var$_updateRefetchInterval = new WeakSet();
$3aefa839a50a34b3$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_clearRefetchInterval, $3aefa839a50a34b3$var$clearRefetchInterval_fn).call(this);
    (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_currentRefetchInterval, nextInterval);
    if ((0, $0GZvz.isServer) || this.options.enabled === false || !(0, $0GZvz.isValidTimeout)((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentRefetchInterval)) || (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentRefetchInterval) === 0) return;
    (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_refetchIntervalId, setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $2uOjt.focusManager).isFocused()) (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_executeFetch, $3aefa839a50a34b3$var$executeFetch_fn).call(this);
    }, (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentRefetchInterval)));
};
$3aefa839a50a34b3$var$_updateTimers = new WeakSet();
$3aefa839a50a34b3$var$updateTimers_fn = function() {
    (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_updateStaleTimeout, $3aefa839a50a34b3$var$updateStaleTimeout_fn).call(this);
    (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_updateRefetchInterval, $3aefa839a50a34b3$var$updateRefetchInterval_fn).call(this, (0, $4sZyw.__privateMethod)(this, $3aefa839a50a34b3$var$_computeRefetchInterval, $3aefa839a50a34b3$var$computeRefetchInterval_fn).call(this));
};
$3aefa839a50a34b3$var$_clearStaleTimeout = new WeakSet();
$3aefa839a50a34b3$var$clearStaleTimeout_fn = function() {
    if ((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_staleTimeoutId)) {
        clearTimeout((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_staleTimeoutId));
        (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_staleTimeoutId, void 0);
    }
};
$3aefa839a50a34b3$var$_clearRefetchInterval = new WeakSet();
$3aefa839a50a34b3$var$clearRefetchInterval_fn = function() {
    if ((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_refetchIntervalId)) {
        clearInterval((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_refetchIntervalId));
        (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_refetchIntervalId, void 0);
    }
};
$3aefa839a50a34b3$var$_updateQuery = new WeakSet();
$3aefa839a50a34b3$var$updateQuery_fn = function() {
    const query = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_client).getQueryCache().build((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_client), this.options);
    if (query === (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery)) return;
    const prevQuery = (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery);
    (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_currentQuery, query);
    (0, $4sZyw.__privateSet)(this, $3aefa839a50a34b3$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$3aefa839a50a34b3$var$_notify = new WeakSet();
$3aefa839a50a34b3$var$notify_fn = function(notifyOptions) {
    (0, $aqN4U.notifyManager).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentResult));
        });
        (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_client).getQueryCache().notify({
            query: (0, $4sZyw.__privateGet)(this, $3aefa839a50a34b3$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $3aefa839a50a34b3$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $3aefa839a50a34b3$var$shouldFetchOnMount(query, options) {
    return $3aefa839a50a34b3$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $3aefa839a50a34b3$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $3aefa839a50a34b3$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $3aefa839a50a34b3$var$isStale(query, options);
    }
    return false;
}
function $3aefa839a50a34b3$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $3aefa839a50a34b3$var$isStale(query, options);
}
function $3aefa839a50a34b3$var$isStale(query, options) {
    return options.enabled !== false && query.isStaleByTime(options.staleTime);
}
function $3aefa839a50a34b3$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $0GZvz.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}

});
parcelRegister("4sZyw", function(module, exports) {

$parcel$export(module.exports, "__privateGet", () => $340986ac0d7e4aac$export$18a094aefa070634);
$parcel$export(module.exports, "__privateAdd", () => $340986ac0d7e4aac$export$addf369becd23283);
$parcel$export(module.exports, "__privateSet", () => $340986ac0d7e4aac$export$42432efe6614d3b4);
$parcel$export(module.exports, "__privateWrapper", () => $340986ac0d7e4aac$export$b1fe7cbb4502036b);
$parcel$export(module.exports, "__privateMethod", () => $340986ac0d7e4aac$export$fa92d15b718fce20);
var $340986ac0d7e4aac$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $340986ac0d7e4aac$export$18a094aefa070634 = (obj, member, getter)=>{
    $340986ac0d7e4aac$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $340986ac0d7e4aac$export$addf369becd23283 = (obj, member, value1)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
};
var $340986ac0d7e4aac$export$42432efe6614d3b4 = (obj, member, value1, setter)=>{
    $340986ac0d7e4aac$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value1) : member.set(obj, value1);
    return value1;
};
var $340986ac0d7e4aac$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $340986ac0d7e4aac$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $340986ac0d7e4aac$export$18a094aefa070634(obj, member, getter);
        }
    });
var $340986ac0d7e4aac$export$fa92d15b718fce20 = (obj, member, method)=>{
    $340986ac0d7e4aac$var$__accessCheck(obj, member, "access private method");
    return method;
};

});

parcelRegister("aqN4U", function(module, exports) {

$parcel$export(module.exports, "notifyManager", () => $798266f99c432533$export$520687f44db6e1ab);

// src/notifyManager.ts
function $798266f99c432533$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = (cb)=>setTimeout(cb, 0);
    const setScheduler = (fn)=>{
        scheduleFn = fn;
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction,
        setScheduler: setScheduler
    };
}
var $798266f99c432533$export$520687f44db6e1ab = $798266f99c432533$export$316a8efd03cd1458();

});

parcelRegister("2uOjt", function(module, exports) {

$parcel$export(module.exports, "focusManager", () => $1d15693d13279fb4$export$6bf54661be5b02cf);

var $4sZyw = parcelRequire("4sZyw");

var $64BU0 = parcelRequire("64BU0");

var $0GZvz = parcelRequire("0GZvz");
var $1d15693d13279fb4$var$_focused, $1d15693d13279fb4$var$_cleanup, $1d15693d13279fb4$var$_setup;
var $1d15693d13279fb4$export$86f1af424b2ca4de = class extends (0, $64BU0.Subscribable) {
    constructor(){
        super();
        (0, $4sZyw.__privateAdd)(this, $1d15693d13279fb4$var$_focused, void 0);
        (0, $4sZyw.__privateAdd)(this, $1d15693d13279fb4$var$_cleanup, void 0);
        (0, $4sZyw.__privateAdd)(this, $1d15693d13279fb4$var$_setup, void 0);
        (0, $4sZyw.__privateSet)(this, $1d15693d13279fb4$var$_setup, (onFocus)=>{
            if (!(0, $0GZvz.isServer) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $4sZyw.__privateGet)(this, $1d15693d13279fb4$var$_cleanup)) this.setEventListener((0, $4sZyw.__privateGet)(this, $1d15693d13279fb4$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $4sZyw.__privateGet)(this, $1d15693d13279fb4$var$_cleanup)) == null || _a.call(this);
            (0, $4sZyw.__privateSet)(this, $1d15693d13279fb4$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $4sZyw.__privateSet)(this, $1d15693d13279fb4$var$_setup, setup);
        (_a = (0, $4sZyw.__privateGet)(this, $1d15693d13279fb4$var$_cleanup)) == null || _a.call(this);
        (0, $4sZyw.__privateSet)(this, $1d15693d13279fb4$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $4sZyw.__privateGet)(this, $1d15693d13279fb4$var$_focused) !== focused;
        if (changed) {
            (0, $4sZyw.__privateSet)(this, $1d15693d13279fb4$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $4sZyw.__privateGet)(this, $1d15693d13279fb4$var$_focused) === "boolean") return (0, $4sZyw.__privateGet)(this, $1d15693d13279fb4$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$1d15693d13279fb4$var$_focused = new WeakMap();
$1d15693d13279fb4$var$_cleanup = new WeakMap();
$1d15693d13279fb4$var$_setup = new WeakMap();
var $1d15693d13279fb4$export$6bf54661be5b02cf = new $1d15693d13279fb4$export$86f1af424b2ca4de();

});
parcelRegister("64BU0", function(module, exports) {

$parcel$export(module.exports, "Subscribable", () => $46c0846a49a6d58e$export$d26086b469ecdbcc);

// src/subscribable.ts
var $46c0846a49a6d58e$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};

});


parcelRegister("dxPKP", function(module, exports) {

$parcel$export(module.exports, "Query", () => $9dc680c629ca4c63$export$62297b13309008b2);
$parcel$export(module.exports, "fetchState", () => $9dc680c629ca4c63$export$f3df9013f2b58bce);

var $4sZyw = parcelRequire("4sZyw");

var $0GZvz = parcelRequire("0GZvz");

var $aqN4U = parcelRequire("aqN4U");

var $jmYZW = parcelRequire("jmYZW");

var $2sIyz = parcelRequire("2sIyz");
var $9dc680c629ca4c63$var$_initialState, $9dc680c629ca4c63$var$_revertState, $9dc680c629ca4c63$var$_cache, $9dc680c629ca4c63$var$_retryer, $9dc680c629ca4c63$var$_observers, $9dc680c629ca4c63$var$_defaultOptions, $9dc680c629ca4c63$var$_abortSignalConsumed, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn;
var $9dc680c629ca4c63$export$62297b13309008b2 = class extends (0, $2sIyz.Removable) {
    constructor(config){
        super();
        (0, $4sZyw.__privateAdd)(this, $9dc680c629ca4c63$var$_dispatch);
        (0, $4sZyw.__privateAdd)(this, $9dc680c629ca4c63$var$_initialState, void 0);
        (0, $4sZyw.__privateAdd)(this, $9dc680c629ca4c63$var$_revertState, void 0);
        (0, $4sZyw.__privateAdd)(this, $9dc680c629ca4c63$var$_cache, void 0);
        (0, $4sZyw.__privateAdd)(this, $9dc680c629ca4c63$var$_retryer, void 0);
        (0, $4sZyw.__privateAdd)(this, $9dc680c629ca4c63$var$_observers, void 0);
        (0, $4sZyw.__privateAdd)(this, $9dc680c629ca4c63$var$_defaultOptions, void 0);
        (0, $4sZyw.__privateAdd)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, void 0);
        (0, $4sZyw.__privateSet)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, false);
        (0, $4sZyw.__privateSet)(this, $9dc680c629ca4c63$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        (0, $4sZyw.__privateSet)(this, $9dc680c629ca4c63$var$_observers, []);
        (0, $4sZyw.__privateSet)(this, $9dc680c629ca4c63$var$_cache, config.cache);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $4sZyw.__privateSet)(this, $9dc680c629ca4c63$var$_initialState, config.state || $9dc680c629ca4c63$var$getDefaultState(this.options));
        this.state = (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...(0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!(0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_observers).length && this.state.fetchStatus === "idle") (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $0GZvz.replaceData)(this.state.data, newData, this.options);
        (0, $4sZyw.__privateMethod)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $4sZyw.__privateMethod)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $0GZvz.noop)).catch((0, $0GZvz.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_initialState));
    }
    isActive() {
        return (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_observers).some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_observers).some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, $0GZvz.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_observers).find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_observers).find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!(0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_observers).includes(observer)) {
            (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if ((0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_observers).includes(observer)) {
            (0, $4sZyw.__privateSet)(this, $9dc680c629ca4c63$var$_observers, (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_observers).filter((x)=>x !== observer));
            if (!(0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_observers).length) {
                if ((0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_retryer)) {
                    if ((0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_abortSignalConsumed)) (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_observers).length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $4sZyw.__privateMethod)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _a, _b, _c;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_retryer)) {
                (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_retryer).continueRetry();
                return (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_observers).find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const queryFnContext = {
            queryKey: this.queryKey,
            meta: this.meta
        };
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $4sZyw.__privateSet)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        addSignalProperty(queryFnContext);
        const fetchFn = ()=>{
            if (!this.options.queryFn || this.options.queryFn === (0, $0GZvz.skipToken)) return Promise.reject(new Error(`Missing queryFn: '${this.options.queryHash}'`));
            (0, $4sZyw.__privateSet)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(this.options.queryFn, queryFnContext, this);
            return this.options.queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_a = this.options.behavior) == null || _a.onFetch(context, this);
        (0, $4sZyw.__privateSet)(this, $9dc680c629ca4c63$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_b = context.fetchOptions) == null ? void 0 : _b.meta)) (0, $4sZyw.__privateMethod)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_c = context.fetchOptions) == null ? void 0 : _c.meta
        });
        const onError = (error)=>{
            var _a2, _b2, _c2, _d;
            if (!((0, $jmYZW.isCancelledError)(error) && error.silent)) (0, $4sZyw.__privateMethod)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            if (!(0, $jmYZW.isCancelledError)(error)) {
                (_b2 = (_a2 = (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_cache).config).onError) == null || _b2.call(_a2, error, this);
                (_d = (_c2 = (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_cache).config).onSettled) == null || _d.call(_c2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) this.scheduleGc();
            this.isFetchingOptimistic = false;
        };
        (0, $4sZyw.__privateSet)(this, $9dc680c629ca4c63$var$_retryer, (0, $jmYZW.createRetryer)({
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _a2, _b2, _c2, _d;
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                this.setData(data);
                (_b2 = (_a2 = (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_cache).config).onSuccess) == null || _b2.call(_a2, data, this);
                (_d = (_c2 = (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_cache).config).onSettled) == null || _d.call(_c2, data, this.state.error, this);
                if (!this.isFetchingOptimistic) this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                (0, $4sZyw.__privateMethod)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $4sZyw.__privateMethod)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $4sZyw.__privateMethod)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        }));
        return (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_retryer).promise;
    }
};
$9dc680c629ca4c63$var$_initialState = new WeakMap();
$9dc680c629ca4c63$var$_revertState = new WeakMap();
$9dc680c629ca4c63$var$_cache = new WeakMap();
$9dc680c629ca4c63$var$_retryer = new WeakMap();
$9dc680c629ca4c63$var$_observers = new WeakMap();
$9dc680c629ca4c63$var$_defaultOptions = new WeakMap();
$9dc680c629ca4c63$var$_abortSignalConsumed = new WeakMap();
$9dc680c629ca4c63$var$_dispatch = new WeakSet();
$9dc680c629ca4c63$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$9dc680c629ca4c63$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const error = action.error;
                if ((0, $jmYZW.isCancelledError)(error) && error.revert && (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_revertState)) return {
                    ...(0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_revertState),
                    fetchStatus: "idle"
                };
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $aqN4U.notifyManager).batch(()=>{
        (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_observers).forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $4sZyw.__privateGet)(this, $9dc680c629ca4c63$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $9dc680c629ca4c63$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $jmYZW.canFetch)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $9dc680c629ca4c63$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}

});
parcelRegister("jmYZW", function(module, exports) {

$parcel$export(module.exports, "canFetch", () => $e19f6352d48643a1$export$61b92f63f30245cf);
$parcel$export(module.exports, "isCancelledError", () => $e19f6352d48643a1$export$986cc6445c1d323);
$parcel$export(module.exports, "createRetryer", () => $e19f6352d48643a1$export$2cbd00fe8a2c8d85);


var $2uOjt = parcelRequire("2uOjt");

var $cSAic = parcelRequire("cSAic");

var $0GZvz = parcelRequire("0GZvz");
function $e19f6352d48643a1$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $e19f6352d48643a1$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $cSAic.onlineManager).isOnline() : true;
}
var $e19f6352d48643a1$export$a8430ed4188f35a9 = class {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $e19f6352d48643a1$export$986cc6445c1d323(value) {
    return value instanceof $e19f6352d48643a1$export$a8430ed4188f35a9;
}
function $e19f6352d48643a1$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved) {
            reject(new $e19f6352d48643a1$export$a8430ed4188f35a9(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $2uOjt.focusManager).isFocused() || config.networkMode !== "always" && !(0, $cSAic.onlineManager).isOnline();
    const resolve = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onSuccess) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onError) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved) return;
            const retry = config.retry ?? ((0, $0GZvz.isServer) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $e19f6352d48643a1$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $0GZvz.sleep)(delay).then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    if ($e19f6352d48643a1$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}

});
parcelRegister("cSAic", function(module, exports) {

$parcel$export(module.exports, "onlineManager", () => $9606ae1cfceeea19$export$b113e788b2dd3fdc);

var $4sZyw = parcelRequire("4sZyw");

var $64BU0 = parcelRequire("64BU0");

var $0GZvz = parcelRequire("0GZvz");
var $9606ae1cfceeea19$var$_online, $9606ae1cfceeea19$var$_cleanup, $9606ae1cfceeea19$var$_setup;
var $9606ae1cfceeea19$export$58774fb55d5ff7fc = class extends (0, $64BU0.Subscribable) {
    constructor(){
        super();
        (0, $4sZyw.__privateAdd)(this, $9606ae1cfceeea19$var$_online, true);
        (0, $4sZyw.__privateAdd)(this, $9606ae1cfceeea19$var$_cleanup, void 0);
        (0, $4sZyw.__privateAdd)(this, $9606ae1cfceeea19$var$_setup, void 0);
        (0, $4sZyw.__privateSet)(this, $9606ae1cfceeea19$var$_setup, (onOnline)=>{
            if (!(0, $0GZvz.isServer) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $4sZyw.__privateGet)(this, $9606ae1cfceeea19$var$_cleanup)) this.setEventListener((0, $4sZyw.__privateGet)(this, $9606ae1cfceeea19$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $4sZyw.__privateGet)(this, $9606ae1cfceeea19$var$_cleanup)) == null || _a.call(this);
            (0, $4sZyw.__privateSet)(this, $9606ae1cfceeea19$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $4sZyw.__privateSet)(this, $9606ae1cfceeea19$var$_setup, setup);
        (_a = (0, $4sZyw.__privateGet)(this, $9606ae1cfceeea19$var$_cleanup)) == null || _a.call(this);
        (0, $4sZyw.__privateSet)(this, $9606ae1cfceeea19$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $4sZyw.__privateGet)(this, $9606ae1cfceeea19$var$_online) !== online;
        if (changed) {
            (0, $4sZyw.__privateSet)(this, $9606ae1cfceeea19$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $4sZyw.__privateGet)(this, $9606ae1cfceeea19$var$_online);
    }
};
$9606ae1cfceeea19$var$_online = new WeakMap();
$9606ae1cfceeea19$var$_cleanup = new WeakMap();
$9606ae1cfceeea19$var$_setup = new WeakMap();
var $9606ae1cfceeea19$export$b113e788b2dd3fdc = new $9606ae1cfceeea19$export$58774fb55d5ff7fc();

});


parcelRegister("2sIyz", function(module, exports) {

$parcel$export(module.exports, "Removable", () => $1cb0c2534af8594c$export$e09608847fcc8c59);

var $4sZyw = parcelRequire("4sZyw");

var $0GZvz = parcelRequire("0GZvz");
var $1cb0c2534af8594c$var$_gcTimeout;
var $1cb0c2534af8594c$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $4sZyw.__privateAdd)(this, $1cb0c2534af8594c$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $0GZvz.isValidTimeout)(this.gcTime)) (0, $4sZyw.__privateSet)(this, $1cb0c2534af8594c$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $0GZvz.isServer) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $4sZyw.__privateGet)(this, $1cb0c2534af8594c$var$_gcTimeout)) {
            clearTimeout((0, $4sZyw.__privateGet)(this, $1cb0c2534af8594c$var$_gcTimeout));
            (0, $4sZyw.__privateSet)(this, $1cb0c2534af8594c$var$_gcTimeout, void 0);
        }
    }
};
$1cb0c2534af8594c$var$_gcTimeout = new WeakMap();

});



parcelRegister("2IwFE", function(module, exports) {

$parcel$export(module.exports, "useBaseQuery", () => $1fa9088b80b7d036$export$fff0865807e996c5);

var $acw62 = parcelRequire("acw62");

var $aqN4U = parcelRequire("aqN4U");

var $dHnxo = parcelRequire("dHnxo");

var $f19YE = parcelRequire("f19YE");

var $bQJ1D = parcelRequire("bQJ1D");

var $051oR = parcelRequire("051oR");

var $9qXUy = parcelRequire("9qXUy");
"use client";
function $1fa9088b80b7d036$export$fff0865807e996c5(options, Observer, queryClient) {
    const client = (0, $f19YE.useQueryClient)(queryClient);
    const isRestoring = (0, $bQJ1D.useIsRestoring)();
    const errorResetBoundary = (0, $dHnxo.useQueryErrorResetBoundary)();
    const defaultedOptions = client.defaultQueryOptions(options);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $9qXUy.ensureStaleTime)(defaultedOptions);
    (0, $051oR.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, $051oR.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $acw62.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>void 0 : observer.subscribe((0, $aqN4U.notifyManager).batchCalls(onStoreChange));
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $acw62.useEffect(()=>{
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $9qXUy.shouldSuspend)(defaultedOptions, result)) throw (0, $9qXUy.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $051oR.getHasError)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash)
    })) throw result.error;
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

});
parcelRegister("dHnxo", function(module, exports) {

$parcel$export(module.exports, "useQueryErrorResetBoundary", () => $9f918c9537253956$export$50dfac555130cafd);

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $9f918c9537253956$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $9f918c9537253956$var$QueryErrorResetBoundaryContext = $acw62.createContext($9f918c9537253956$var$createValue());
var $9f918c9537253956$export$50dfac555130cafd = ()=>$acw62.useContext($9f918c9537253956$var$QueryErrorResetBoundaryContext);
var $9f918c9537253956$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $acw62.useState(()=>$9f918c9537253956$var$createValue());
    return /* @__PURE__ */ (0, $ayMG0.jsx)($9f918c9537253956$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};

});

parcelRegister("bQJ1D", function(module, exports) {

$parcel$export(module.exports, "useIsRestoring", () => $8a077a20b7040cef$export$4da0178d6b5f553);

var $acw62 = parcelRequire("acw62");
"use client";
var $8a077a20b7040cef$var$IsRestoringContext = $acw62.createContext(false);
var $8a077a20b7040cef$export$4da0178d6b5f553 = ()=>$acw62.useContext($8a077a20b7040cef$var$IsRestoringContext);
var $8a077a20b7040cef$export$593807d4e94f9621 = $8a077a20b7040cef$var$IsRestoringContext.Provider;

});

parcelRegister("051oR", function(module, exports) {

$parcel$export(module.exports, "ensurePreventErrorBoundaryRetry", () => $00f18dc4257f8dfa$export$ae8adb3de3d77633);
$parcel$export(module.exports, "useClearResetErrorBoundary", () => $00f18dc4257f8dfa$export$b2b17ca3a1fb0229);
$parcel$export(module.exports, "getHasError", () => $00f18dc4257f8dfa$export$1fbcf724762d607);

var $acw62 = parcelRequire("acw62");

var $e7sZD = parcelRequire("e7sZD");
"use client";
var $00f18dc4257f8dfa$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $00f18dc4257f8dfa$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $acw62.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $00f18dc4257f8dfa$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (0, $e7sZD.shouldThrowError)(throwOnError, [
        result.error,
        query
    ]);
};

});
parcelRegister("e7sZD", function(module, exports) {

$parcel$export(module.exports, "shouldThrowError", () => $a478358a8235bfab$export$2072f68e6c3507cf);
$parcel$export(module.exports, "noop", () => $a478358a8235bfab$export$8793edee2d425525);
// src/utils.ts
function $a478358a8235bfab$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}
function $a478358a8235bfab$export$8793edee2d425525() {}

});


parcelRegister("9qXUy", function(module, exports) {

$parcel$export(module.exports, "ensureStaleTime", () => $6de503da57e511b5$export$2c40a591ad2dafb1);
$parcel$export(module.exports, "shouldSuspend", () => $6de503da57e511b5$export$88d3586dfed64df9);
$parcel$export(module.exports, "fetchOptimistic", () => $6de503da57e511b5$export$defdc11a9c9acfcf);
// src/suspense.ts
var $6de503da57e511b5$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $6de503da57e511b5$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1e3;
    }
};
var $6de503da57e511b5$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $6de503da57e511b5$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $6de503da57e511b5$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });

});



parcelRegister("5c7W3", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $kqX4j = parcelRequire("kqX4j");

var $gSeoX = parcelRequire("gSeoX");

var $4RK0h = parcelRequire("4RK0h");

var $cYlGN = parcelRequire("cYlGN");

var $lJ3Ig = parcelRequire("lJ3Ig");

var $8KK0w = parcelRequire("8KK0w");

var $i0kKc = parcelRequire("i0kKc");
/** Used to compose bitmasks for cloning. */ var $3c843a8ff84cd42d$var$CLONE_DEEP_FLAG = 1, $3c843a8ff84cd42d$var$CLONE_FLAT_FLAG = 2, $3c843a8ff84cd42d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3c843a8ff84cd42d$var$omit = $8KK0w(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $i46jW(paths, function(path) {
        path = $4RK0h(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $cYlGN(object, $i0kKc(object), result);
    if (isDeep) result = $kqX4j(result, $3c843a8ff84cd42d$var$CLONE_DEEP_FLAG | $3c843a8ff84cd42d$var$CLONE_FLAT_FLAG | $3c843a8ff84cd42d$var$CLONE_SYMBOLS_FLAG, $lJ3Ig);
    var length = paths.length;
    while(length--)$gSeoX(result, paths[length]);
    return result;
});
module.exports = $3c843a8ff84cd42d$var$omit;

});
parcelRegister("i46jW", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $d26d80da1ba3948c$var$arrayMap;

});

parcelRegister("kqX4j", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $bFZGr = parcelRequire("bFZGr");

var $5i71d = parcelRequire("5i71d");

var $XXQDs = parcelRequire("XXQDs");

var $1djPb = parcelRequire("1djPb");

var $uQ1Em = parcelRequire("uQ1Em");

var $aA0pv = parcelRequire("aA0pv");

var $hIxJe = parcelRequire("hIxJe");

var $7n7lE = parcelRequire("7n7lE");

var $apVCl = parcelRequire("apVCl");

var $i0kKc = parcelRequire("i0kKc");

var $67A6V = parcelRequire("67A6V");

var $4UmGC = parcelRequire("4UmGC");

var $btuqH = parcelRequire("btuqH");

var $dFJsF = parcelRequire("dFJsF");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $eJObK = parcelRequire("eJObK");

var $lsJ54 = parcelRequire("lsJ54");

var $jZm8C = parcelRequire("jZm8C");

var $LAMcS = parcelRequire("LAMcS");

var $f4lqP = parcelRequire("f4lqP");
/** Used to compose bitmasks for cloning. */ var $ee040e257a097984$var$CLONE_DEEP_FLAG = 1, $ee040e257a097984$var$CLONE_FLAT_FLAG = 2, $ee040e257a097984$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $ee040e257a097984$var$argsTag = "[object Arguments]", $ee040e257a097984$var$arrayTag = "[object Array]", $ee040e257a097984$var$boolTag = "[object Boolean]", $ee040e257a097984$var$dateTag = "[object Date]", $ee040e257a097984$var$errorTag = "[object Error]", $ee040e257a097984$var$funcTag = "[object Function]", $ee040e257a097984$var$genTag = "[object GeneratorFunction]", $ee040e257a097984$var$mapTag = "[object Map]", $ee040e257a097984$var$numberTag = "[object Number]", $ee040e257a097984$var$objectTag = "[object Object]", $ee040e257a097984$var$regexpTag = "[object RegExp]", $ee040e257a097984$var$setTag = "[object Set]", $ee040e257a097984$var$stringTag = "[object String]", $ee040e257a097984$var$symbolTag = "[object Symbol]", $ee040e257a097984$var$weakMapTag = "[object WeakMap]";
var $ee040e257a097984$var$arrayBufferTag = "[object ArrayBuffer]", $ee040e257a097984$var$dataViewTag = "[object DataView]", $ee040e257a097984$var$float32Tag = "[object Float32Array]", $ee040e257a097984$var$float64Tag = "[object Float64Array]", $ee040e257a097984$var$int8Tag = "[object Int8Array]", $ee040e257a097984$var$int16Tag = "[object Int16Array]", $ee040e257a097984$var$int32Tag = "[object Int32Array]", $ee040e257a097984$var$uint8Tag = "[object Uint8Array]", $ee040e257a097984$var$uint8ClampedTag = "[object Uint8ClampedArray]", $ee040e257a097984$var$uint16Tag = "[object Uint16Array]", $ee040e257a097984$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $ee040e257a097984$var$cloneableTags = {};
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$argsTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayBufferTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dataViewTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$boolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dateTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float64Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$mapTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$numberTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$objectTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$regexpTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$setTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$stringTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$symbolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8ClampedTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint32Tag] = true;
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$errorTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$funcTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $ee040e257a097984$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $ee040e257a097984$var$CLONE_DEEP_FLAG, isFlat = bitmask & $ee040e257a097984$var$CLONE_FLAT_FLAG, isFull = bitmask & $ee040e257a097984$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lsJ54(value)) return value;
    var isArr = $o8HxT(value);
    if (isArr) {
        result = $4UmGC(value);
        if (!isDeep) return $aA0pv(value, result);
    } else {
        var tag = $67A6V(value), isFunc = tag == $ee040e257a097984$var$funcTag || tag == $ee040e257a097984$var$genTag;
        if ($f504n(value)) return $uQ1Em(value, isDeep);
        if (tag == $ee040e257a097984$var$objectTag || tag == $ee040e257a097984$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $dFJsF(value);
            if (!isDeep) return isFlat ? $7n7lE(value, $1djPb(result, value)) : $hIxJe(value, $XXQDs(result, value));
        } else {
            if (!$ee040e257a097984$var$cloneableTags[tag]) return object ? value : {};
            result = $btuqH(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $g779E);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($jZm8C(value)) value.forEach(function(subValue) {
        result.add($ee040e257a097984$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($eJObK(value)) value.forEach(function(subValue, key) {
        result.set(key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $i0kKc : $apVCl : isFlat ? $f4lqP : $LAMcS;
    var props = isArr ? undefined : keysFunc(value);
    $bFZGr(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $5i71d(result, key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $ee040e257a097984$var$baseClone;

});
parcelRegister("g779E", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $jZSEZ = parcelRequire("jZSEZ");

var $fm6cW = parcelRequire("fm6cW");

var $b3G1Z = parcelRequire("b3G1Z");

var $5DEbp = parcelRequire("5DEbp");

var $czPDU = parcelRequire("czPDU");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $iYOpJ(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $jZSEZ;
$bbb2d98cae25b61a$var$Stack.prototype["delete"] = $fm6cW;
$bbb2d98cae25b61a$var$Stack.prototype.get = $b3G1Z;
$bbb2d98cae25b61a$var$Stack.prototype.has = $5DEbp;
$bbb2d98cae25b61a$var$Stack.prototype.set = $czPDU;
module.exports = $bbb2d98cae25b61a$var$Stack;

});
parcelRegister("iYOpJ", function(module, exports) {

var $bjX1n = parcelRequire("bjX1n");

var $i2OST = parcelRequire("i2OST");

var $fmh4d = parcelRequire("fmh4d");

var $3AXiV = parcelRequire("3AXiV");

var $lWpQQ = parcelRequire("lWpQQ");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $bjX1n;
$dd14efc87ba1cd5b$var$ListCache.prototype["delete"] = $i2OST;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $fmh4d;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $3AXiV;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $lWpQQ;
module.exports = $dd14efc87ba1cd5b$var$ListCache;

});
parcelRegister("bjX1n", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $83df40714bf7006e$var$listCacheClear;

});

parcelRegister("i2OST", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $d22fe27824ff9351$var$listCacheDelete;

});
parcelRegister("bBnDb", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6TC8i(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $87257b05f5d9ad81$var$assocIndexOf;

});
parcelRegister("6TC8i", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $50557587dab070a0$var$eq;

});



parcelRegister("fmh4d", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b2e6263d81cdc1b3$var$listCacheGet;

});

parcelRegister("3AXiV", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $bBnDb(this.__data__, key) > -1;
}
module.exports = $29e2bc7b7348833e$var$listCacheHas;

});

parcelRegister("lWpQQ", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $ff9311500b60ab72$var$listCacheSet;

});


parcelRegister("jZSEZ", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $iYOpJ;
    this.size = 0;
}
module.exports = $e8ee1d354807980a$var$stackClear;

});

parcelRegister("fm6cW", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $b2ddb9d63293f3a5$var$stackDelete;

});

parcelRegister("b3G1Z", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $80d0940a423a17dc$var$stackGet;

});

parcelRegister("5DEbp", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $010f38d5d914cfa2$var$stackHas;

});

parcelRegister("czPDU", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");

var $6gDBQ = parcelRequire("6gDBQ");
/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $iYOpJ) {
        var pairs = data.__data__;
        if (!$2cJKd || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $6gDBQ(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $9280d00f89f25fa9$var$stackSet;

});
parcelRegister("2cJKd", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $6T08O($23YZo, "Map");
module.exports = $19b02faa57603249$var$Map;

});
parcelRegister("6T08O", function(module, exports) {

var $bhj99 = parcelRequire("bhj99");

var $ii1B1 = parcelRequire("ii1B1");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $ii1B1(object, key);
    return $bhj99(value) ? value : undefined;
}
module.exports = $5037fd2e597c2a03$var$getNative;

});
parcelRegister("bhj99", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $87ifd = parcelRequire("87ifd");

var $lsJ54 = parcelRequire("lsJ54");

var $dqC5h = parcelRequire("dqC5h");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp("^" + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$lsJ54(value) || $87ifd(value)) return false;
    var pattern = $01ubZ(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($dqC5h(value));
}
module.exports = $8360225fb63098b3$var$baseIsNative;

});
parcelRegister("01ubZ", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $lsJ54 = parcelRequire("lsJ54");
/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = "[object AsyncFunction]", $004783abbde551e4$var$funcTag = "[object Function]", $004783abbde551e4$var$genTag = "[object GeneratorFunction]", $004783abbde551e4$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$lsJ54(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $eq6CV(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
module.exports = $004783abbde551e4$var$isFunction;

});
parcelRegister("eq6CV", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $iMn5C = parcelRequire("iMn5C");

var $5tDQy = parcelRequire("5tDQy");
/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = "[object Null]", $a7f8a2555793d7d3$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $iMn5C(value) : $5tDQy(value);
}
module.exports = $a7f8a2555793d7d3$var$baseGetTag;

});
parcelRegister("57wYk", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
module.exports = $3ba72ebe7e4419b5$var$Symbol;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function("return this")();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});



parcelRegister("iMn5C", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
module.exports = $dabe9ecbecc6d0b5$var$getRawTag;

});

parcelRegister("5tDQy", function(module, exports) {
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
module.exports = $3fce91ec3914aaed$var$objectToString;

});


parcelRegister("lsJ54", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $f9ff2e983beb6b86$var$isObject;

});


parcelRegister("87ifd", function(module, exports) {

var $g3dHA = parcelRequire("g3dHA");
/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($g3dHA && $g3dHA.keys && $g3dHA.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
module.exports = $5e8d211f630cd46d$var$isMasked;

});
parcelRegister("g3dHA", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
module.exports = $baf78e1246b3b18f$var$coreJsData;

});


parcelRegister("dqC5h", function(module, exports) {
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $9c6b3ec69362487e$var$toSource;

});


parcelRegister("ii1B1", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d50b255f8680c47a$var$getValue;

});



parcelRegister("6gDBQ", function(module, exports) {

var $j9XgB = parcelRequire("j9XgB");

var $5Rqhl = parcelRequire("5Rqhl");

var $g0JTV = parcelRequire("g0JTV");

var $iaILb = parcelRequire("iaILb");

var $4vfJO = parcelRequire("4vfJO");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $j9XgB;
$4902f64a16640324$var$MapCache.prototype["delete"] = $5Rqhl;
$4902f64a16640324$var$MapCache.prototype.get = $g0JTV;
$4902f64a16640324$var$MapCache.prototype.has = $iaILb;
$4902f64a16640324$var$MapCache.prototype.set = $4vfJO;
module.exports = $4902f64a16640324$var$MapCache;

});
parcelRegister("j9XgB", function(module, exports) {

var $c8dKl = parcelRequire("c8dKl");

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $c8dKl,
        "map": new ($2cJKd || $iYOpJ),
        "string": new $c8dKl
    };
}
module.exports = $df2cd4bc93f21548$var$mapCacheClear;

});
parcelRegister("c8dKl", function(module, exports) {

var $b4nbb = parcelRequire("b4nbb");

var $8ink3 = parcelRequire("8ink3");

var $VQwbj = parcelRequire("VQwbj");

var $19QNA = parcelRequire("19QNA");

var $i8qJC = parcelRequire("i8qJC");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $b4nbb;
$8d50e526a9e9b7fa$var$Hash.prototype["delete"] = $8ink3;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $VQwbj;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $19QNA;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $i8qJC;
module.exports = $8d50e526a9e9b7fa$var$Hash;

});
parcelRegister("b4nbb", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $k1Z3J ? $k1Z3J(null) : {};
    this.size = 0;
}
module.exports = $80f20c637ba11563$var$hashClear;

});
parcelRegister("k1Z3J", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $6T08O(Object, "create");
module.exports = $e95343b7bf5d617b$var$nativeCreate;

});


parcelRegister("8ink3", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $60a2188452e03a76$var$hashDelete;

});

parcelRegister("VQwbj", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($k1Z3J) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $0ade0ffa62051a98$var$hashGet;

});

parcelRegister("19QNA", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $k1Z3J ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
module.exports = $0d7f9677a17b6bef$var$hashHas;

});

parcelRegister("i8qJC", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $k1Z3J && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $d33db65186b62952$var$hashSet;

});



parcelRegister("5Rqhl", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $gxIuO(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $44464964ade29765$var$mapCacheDelete;

});
parcelRegister("gxIuO", function(module, exports) {

var $PZpyR = parcelRequire("PZpyR");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $PZpyR(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $c0b23e5f03c2595b$var$getMapData;

});
parcelRegister("PZpyR", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $09c4668903e66c1d$var$isKeyable;

});



parcelRegister("g0JTV", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $gxIuO(this, key).get(key);
}
module.exports = $ba80406da5503086$var$mapCacheGet;

});

parcelRegister("iaILb", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $gxIuO(this, key).has(key);
}
module.exports = $d3abe18ea687dfb7$var$mapCacheHas;

});

parcelRegister("4vfJO", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $gxIuO(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $347643e3dcfcc207$var$mapCacheSet;

});




parcelRegister("bFZGr", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $88035f224ff89479$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $88035f224ff89479$var$arrayEach;

});

parcelRegister("5i71d", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $6TC8i = parcelRequire("6TC8i");
/** Used for built-in method references. */ var $3da413f0b86c10df$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3da413f0b86c10df$var$hasOwnProperty = $3da413f0b86c10df$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $3da413f0b86c10df$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($3da413f0b86c10df$var$hasOwnProperty.call(object, key) && $6TC8i(objValue, value)) || value === undefined && !(key in object)) $cWbJD(object, key, value);
}
module.exports = $3da413f0b86c10df$var$assignValue;

});
parcelRegister("cWbJD", function(module, exports) {

var $4hwTc = parcelRequire("4hwTc");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96b401257ea00d24$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $4hwTc) $4hwTc(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $96b401257ea00d24$var$baseAssignValue;

});
parcelRegister("4hwTc", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
var $31e24313ace94404$var$defineProperty = function() {
    try {
        var func = $6T08O(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $31e24313ace94404$var$defineProperty;

});



parcelRegister("XXQDs", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0b43ef5c64ba7f70$var$baseAssign(object, source) {
    return object && $cYlGN(source, $LAMcS(source), object);
}
module.exports = $0b43ef5c64ba7f70$var$baseAssign;

});
parcelRegister("cYlGN", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $cWbJD = parcelRequire("cWbJD");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $971be9a5edcd8d07$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $cWbJD(object, key, newValue);
        else $5i71d(object, key, newValue);
    }
    return object;
}
module.exports = $971be9a5edcd8d07$var$copyObject;

});

parcelRegister("LAMcS", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $jViFF = parcelRequire("jViFF");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $eMthh(object) ? $8C60w(object) : $jViFF(object);
}
module.exports = $08f0eaf3fbcb2fde$var$keys;

});
parcelRegister("8C60w", function(module, exports) {

var $fdM6B = parcelRequire("fdM6B");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $iyUuu = parcelRequire("iyUuu");

var $1Q21n = parcelRequire("1Q21n");
/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $o8HxT(value), isArg = !isArr && $aJD6g(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $1Q21n(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $fdM6B(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $iyUuu(key, length)))) result.push(key);
    return result;
}
module.exports = $64568844439edb7f$var$arrayLikeKeys;

});
parcelRegister("fdM6B", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $b14d62a510ae7f2d$var$baseTimes;

});

parcelRegister("aJD6g", function(module, exports) {

var $lB3aj = parcelRequire("lB3aj");

var $8l89S = parcelRequire("8l89S");
/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $lB3aj(function() {
    return arguments;
}()) ? $lB3aj : function(value) {
    return $8l89S(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, "callee") && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $7d0c6fd0eb26be0e$var$isArguments;

});
parcelRegister("lB3aj", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $8l89S(value) && $eq6CV(value) == $fb8f823cdc90f511$var$argsTag;
}
module.exports = $fb8f823cdc90f511$var$baseIsArguments;

});
parcelRegister("8l89S", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $61269cf1f3e020be$var$isObjectLike;

});



parcelRegister("o8HxT", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
module.exports = $0488fde9aa355453$var$isArray;

});

parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("iyUuu", function(module, exports) {
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $d83738e053b5eb08$var$isIndex;

});

parcelRegister("1Q21n", function(module, exports) {

var $dtRoq = parcelRequire("dtRoq");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $91Qdd($156c3727697ab085$var$nodeIsTypedArray) : $dtRoq;
module.exports = $156c3727697ab085$var$isTypedArray;

});
parcelRegister("dtRoq", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $1S9lz = parcelRequire("1S9lz");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = "[object Arguments]", $9d076681a0e29d68$var$arrayTag = "[object Array]", $9d076681a0e29d68$var$boolTag = "[object Boolean]", $9d076681a0e29d68$var$dateTag = "[object Date]", $9d076681a0e29d68$var$errorTag = "[object Error]", $9d076681a0e29d68$var$funcTag = "[object Function]", $9d076681a0e29d68$var$mapTag = "[object Map]", $9d076681a0e29d68$var$numberTag = "[object Number]", $9d076681a0e29d68$var$objectTag = "[object Object]", $9d076681a0e29d68$var$regexpTag = "[object RegExp]", $9d076681a0e29d68$var$setTag = "[object Set]", $9d076681a0e29d68$var$stringTag = "[object String]", $9d076681a0e29d68$var$weakMapTag = "[object WeakMap]";
var $9d076681a0e29d68$var$arrayBufferTag = "[object ArrayBuffer]", $9d076681a0e29d68$var$dataViewTag = "[object DataView]", $9d076681a0e29d68$var$float32Tag = "[object Float32Array]", $9d076681a0e29d68$var$float64Tag = "[object Float64Array]", $9d076681a0e29d68$var$int8Tag = "[object Int8Array]", $9d076681a0e29d68$var$int16Tag = "[object Int16Array]", $9d076681a0e29d68$var$int32Tag = "[object Int32Array]", $9d076681a0e29d68$var$uint8Tag = "[object Uint8Array]", $9d076681a0e29d68$var$uint8ClampedTag = "[object Uint8ClampedArray]", $9d076681a0e29d68$var$uint16Tag = "[object Uint16Array]", $9d076681a0e29d68$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $8l89S(value) && $1S9lz(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$eq6CV(value)];
}
module.exports = $9d076681a0e29d68$var$baseIsTypedArray;

});
parcelRegister("1S9lz", function(module, exports) {
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
module.exports = $15d215b19bcf1187$var$isLength;

});


parcelRegister("91Qdd", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $692cb5474f422969$var$baseUnary;

});

parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("jViFF", function(module, exports) {

var $3wZFp = parcelRequire("3wZFp");

var $Xlg65 = parcelRequire("Xlg65");
/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$3wZFp(object)) return $Xlg65(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $e811d2e210fb58cc$var$baseKeys;

});
parcelRegister("3wZFp", function(module, exports) {
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
module.exports = $292432068be14a79$var$isPrototype;

});

parcelRegister("Xlg65", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $lW2Sc(Object.keys, Object);
module.exports = $0b26005314403d97$var$nativeKeys;

});
parcelRegister("lW2Sc", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $ff813e49bf3cca3d$var$overArg;

});



parcelRegister("eMthh", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $1S9lz = parcelRequire("1S9lz");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $1S9lz(value.length) && !$01ubZ(value);
}
module.exports = $ac2c42592aa05543$var$isArrayLike;

});



parcelRegister("1djPb", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $f4lqP = parcelRequire("f4lqP");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0e266213253a5976$var$baseAssignIn(object, source) {
    return object && $cYlGN(source, $f4lqP(source), object);
}
module.exports = $0e266213253a5976$var$baseAssignIn;

});
parcelRegister("f4lqP", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $4ECPT = parcelRequire("4ECPT");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $af87da9a76941740$var$keysIn(object) {
    return $eMthh(object) ? $8C60w(object, true) : $4ECPT(object);
}
module.exports = $af87da9a76941740$var$keysIn;

});
parcelRegister("4ECPT", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");

var $3wZFp = parcelRequire("3wZFp");

var $7w1ie = parcelRequire("7w1ie");
/** Used for built-in method references. */ var $363905e043db7569$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $363905e043db7569$var$hasOwnProperty = $363905e043db7569$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $363905e043db7569$var$baseKeysIn(object) {
    if (!$lsJ54(object)) return $7w1ie(object);
    var isProto = $3wZFp(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$363905e043db7569$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $363905e043db7569$var$baseKeysIn;

});
parcelRegister("7w1ie", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $578c86548a505f7a$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $578c86548a505f7a$var$nativeKeysIn;

});




parcelRegister("uQ1Em", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("aA0pv", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $7b3d95b0cd9dcb32$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $7b3d95b0cd9dcb32$var$copyArray;

});

parcelRegister("hIxJe", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $6YcYN = parcelRequire("6YcYN");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $ce60b583e6a24a63$var$copySymbols(source, object) {
    return $cYlGN(source, $6YcYN(source), object);
}
module.exports = $ce60b583e6a24a63$var$copySymbols;

});
parcelRegister("6YcYN", function(module, exports) {

var $8H9RZ = parcelRequire("8H9RZ");

var $clnSu = parcelRequire("clnSu");
/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $clnSu : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $8H9RZ($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $51326a29f571e7cd$var$getSymbols;

});
parcelRegister("8H9RZ", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $6549fed720324048$var$arrayFilter;

});

parcelRegister("clnSu", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
module.exports = $8fc9f7df9b0c06bb$var$stubArray;

});



parcelRegister("7n7lE", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $aiaLi = parcelRequire("aiaLi");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $55e06195de8b50ba$var$copySymbolsIn(source, object) {
    return $cYlGN(source, $aiaLi(source), object);
}
module.exports = $55e06195de8b50ba$var$copySymbolsIn;

});
parcelRegister("aiaLi", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $cdnOB = parcelRequire("cdnOB");

var $6YcYN = parcelRequire("6YcYN");

var $clnSu = parcelRequire("clnSu");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $77e3eeed2d30c6bc$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $77e3eeed2d30c6bc$var$getSymbolsIn = !$77e3eeed2d30c6bc$var$nativeGetSymbols ? $clnSu : function(object) {
    var result = [];
    while(object){
        $hynws(result, $6YcYN(object));
        object = $cdnOB(object);
    }
    return result;
};
module.exports = $77e3eeed2d30c6bc$var$getSymbolsIn;

});
parcelRegister("hynws", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $cc77dbb7c08db6a8$var$arrayPush;

});

parcelRegister("cdnOB", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/** Built-in value references. */ var $8e492c1d7a7ea307$var$getPrototype = $lW2Sc(Object.getPrototypeOf, Object);
module.exports = $8e492c1d7a7ea307$var$getPrototype;

});



parcelRegister("apVCl", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $6YcYN = parcelRequire("6YcYN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $ctgi8(object, $LAMcS, $6YcYN);
}
module.exports = $7958eecccfe4cef6$var$getAllKeys;

});
parcelRegister("ctgi8", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $o8HxT = parcelRequire("o8HxT");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $o8HxT(object) ? result : $hynws(result, symbolsFunc(object));
}
module.exports = $9144d49da7a47a72$var$baseGetAllKeys;

});


parcelRegister("i0kKc", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $aiaLi = parcelRequire("aiaLi");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d1b85174ea17081a$var$getAllKeysIn(object) {
    return $ctgi8(object, $f4lqP, $aiaLi);
}
module.exports = $d1b85174ea17081a$var$getAllKeysIn;

});

parcelRegister("67A6V", function(module, exports) {

var $5Ehf1 = parcelRequire("5Ehf1");

var $2cJKd = parcelRequire("2cJKd");

var $f7yH3 = parcelRequire("f7yH3");

var $vH4x0 = parcelRequire("vH4x0");

var $f0N2p = parcelRequire("f0N2p");

var $eq6CV = parcelRequire("eq6CV");

var $dqC5h = parcelRequire("dqC5h");
/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = "[object Map]", $474f685f496bfe31$var$objectTag = "[object Object]", $474f685f496bfe31$var$promiseTag = "[object Promise]", $474f685f496bfe31$var$setTag = "[object Set]", $474f685f496bfe31$var$weakMapTag = "[object WeakMap]";
var $474f685f496bfe31$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $dqC5h($5Ehf1), $474f685f496bfe31$var$mapCtorString = $dqC5h($2cJKd), $474f685f496bfe31$var$promiseCtorString = $dqC5h($f7yH3), $474f685f496bfe31$var$setCtorString = $dqC5h($vH4x0), $474f685f496bfe31$var$weakMapCtorString = $dqC5h($f0N2p);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $eq6CV;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($5Ehf1 && $474f685f496bfe31$var$getTag(new $5Ehf1(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $2cJKd && $474f685f496bfe31$var$getTag(new $2cJKd) != $474f685f496bfe31$var$mapTag || $f7yH3 && $474f685f496bfe31$var$getTag($f7yH3.resolve()) != $474f685f496bfe31$var$promiseTag || $vH4x0 && $474f685f496bfe31$var$getTag(new $vH4x0) != $474f685f496bfe31$var$setTag || $f0N2p && $474f685f496bfe31$var$getTag(new $f0N2p) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $eq6CV(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $dqC5h(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
module.exports = $474f685f496bfe31$var$getTag;

});
parcelRegister("5Ehf1", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $6T08O($23YZo, "DataView");
module.exports = $41ce0ff3b38ee753$var$DataView;

});

parcelRegister("f7yH3", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $6T08O($23YZo, "Promise");
module.exports = $b0226bdea11cb834$var$Promise;

});

parcelRegister("vH4x0", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $6T08O($23YZo, "Set");
module.exports = $05f44e958da968eb$var$Set;

});

parcelRegister("f0N2p", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $6T08O($23YZo, "WeakMap");
module.exports = $aedce50092a1e6a6$var$WeakMap;

});


parcelRegister("4UmGC", function(module, exports) {
/** Used for built-in method references. */ var $392dfd68f4953502$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $392dfd68f4953502$var$hasOwnProperty = $392dfd68f4953502$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $392dfd68f4953502$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $392dfd68f4953502$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $392dfd68f4953502$var$initCloneArray;

});

parcelRegister("btuqH", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");

var $aKTvD = parcelRequire("aKTvD");

var $5IIrB = parcelRequire("5IIrB");

var $jxFRj = parcelRequire("jxFRj");

var $5JAGM = parcelRequire("5JAGM");
/** `Object#toString` result references. */ var $85aa01d56b12d536$var$boolTag = "[object Boolean]", $85aa01d56b12d536$var$dateTag = "[object Date]", $85aa01d56b12d536$var$mapTag = "[object Map]", $85aa01d56b12d536$var$numberTag = "[object Number]", $85aa01d56b12d536$var$regexpTag = "[object RegExp]", $85aa01d56b12d536$var$setTag = "[object Set]", $85aa01d56b12d536$var$stringTag = "[object String]", $85aa01d56b12d536$var$symbolTag = "[object Symbol]";
var $85aa01d56b12d536$var$arrayBufferTag = "[object ArrayBuffer]", $85aa01d56b12d536$var$dataViewTag = "[object DataView]", $85aa01d56b12d536$var$float32Tag = "[object Float32Array]", $85aa01d56b12d536$var$float64Tag = "[object Float64Array]", $85aa01d56b12d536$var$int8Tag = "[object Int8Array]", $85aa01d56b12d536$var$int16Tag = "[object Int16Array]", $85aa01d56b12d536$var$int32Tag = "[object Int32Array]", $85aa01d56b12d536$var$uint8Tag = "[object Uint8Array]", $85aa01d56b12d536$var$uint8ClampedTag = "[object Uint8ClampedArray]", $85aa01d56b12d536$var$uint16Tag = "[object Uint16Array]", $85aa01d56b12d536$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $85aa01d56b12d536$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $85aa01d56b12d536$var$arrayBufferTag:
            return $jjbq1(object);
        case $85aa01d56b12d536$var$boolTag:
        case $85aa01d56b12d536$var$dateTag:
            return new Ctor(+object);
        case $85aa01d56b12d536$var$dataViewTag:
            return $aKTvD(object, isDeep);
        case $85aa01d56b12d536$var$float32Tag:
        case $85aa01d56b12d536$var$float64Tag:
        case $85aa01d56b12d536$var$int8Tag:
        case $85aa01d56b12d536$var$int16Tag:
        case $85aa01d56b12d536$var$int32Tag:
        case $85aa01d56b12d536$var$uint8Tag:
        case $85aa01d56b12d536$var$uint8ClampedTag:
        case $85aa01d56b12d536$var$uint16Tag:
        case $85aa01d56b12d536$var$uint32Tag:
            return $5JAGM(object, isDeep);
        case $85aa01d56b12d536$var$mapTag:
            return new Ctor;
        case $85aa01d56b12d536$var$numberTag:
        case $85aa01d56b12d536$var$stringTag:
            return new Ctor(object);
        case $85aa01d56b12d536$var$regexpTag:
            return $5IIrB(object);
        case $85aa01d56b12d536$var$setTag:
            return new Ctor;
        case $85aa01d56b12d536$var$symbolTag:
            return $jxFRj(object);
    }
}
module.exports = $85aa01d56b12d536$var$initCloneByTag;

});
parcelRegister("jjbq1", function(module, exports) {

var $lx3EF = parcelRequire("lx3EF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e0e8a62ea95bc20a$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $lx3EF(result).set(new $lx3EF(arrayBuffer));
    return result;
}
module.exports = $e0e8a62ea95bc20a$var$cloneArrayBuffer;

});
parcelRegister("lx3EF", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
module.exports = $facf83d1449a27b8$var$Uint8Array;

});


parcelRegister("aKTvD", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $7d49423a2080f7e8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jjbq1(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $7d49423a2080f7e8$var$cloneDataView;

});

parcelRegister("5IIrB", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $42a38980bea1ca34$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $42a38980bea1ca34$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $42a38980bea1ca34$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $42a38980bea1ca34$var$cloneRegExp;

});

parcelRegister("jxFRj", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used to convert symbols to primitives and strings. */ var $e3a191b3227aae5b$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $e3a191b3227aae5b$var$symbolValueOf = $e3a191b3227aae5b$var$symbolProto ? $e3a191b3227aae5b$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $e3a191b3227aae5b$var$cloneSymbol(symbol) {
    return $e3a191b3227aae5b$var$symbolValueOf ? Object($e3a191b3227aae5b$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $e3a191b3227aae5b$var$cloneSymbol;

});

parcelRegister("5JAGM", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $42cd9d64f56ec214$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $jjbq1(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $42cd9d64f56ec214$var$cloneTypedArray;

});


parcelRegister("dFJsF", function(module, exports) {

var $4XGZt = parcelRequire("4XGZt");

var $cdnOB = parcelRequire("cdnOB");

var $3wZFp = parcelRequire("3wZFp");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $9f425e619197b80f$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$3wZFp(object) ? $4XGZt($cdnOB(object)) : {};
}
module.exports = $9f425e619197b80f$var$initCloneObject;

});
parcelRegister("4XGZt", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");
/** Built-in value references. */ var $39ce05228f203f9a$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $39ce05228f203f9a$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$lsJ54(proto)) return {};
        if ($39ce05228f203f9a$var$objectCreate) return $39ce05228f203f9a$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $39ce05228f203f9a$var$baseCreate;

});


parcelRegister("eJObK", function(module, exports) {

var $9ORep = parcelRequire("9ORep");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $abac330771f68232$var$nodeIsMap = $jIny1 && $jIny1.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $abac330771f68232$var$isMap = $abac330771f68232$var$nodeIsMap ? $91Qdd($abac330771f68232$var$nodeIsMap) : $9ORep;
module.exports = $abac330771f68232$var$isMap;

});
parcelRegister("9ORep", function(module, exports) {

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $7262133281c40437$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7262133281c40437$var$baseIsMap(value) {
    return $8l89S(value) && $67A6V(value) == $7262133281c40437$var$mapTag;
}
module.exports = $7262133281c40437$var$baseIsMap;

});


parcelRegister("jZm8C", function(module, exports) {

var $eFk8g = parcelRequire("eFk8g");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $e8d4e2fa1f2b8f08$var$nodeIsSet = $jIny1 && $jIny1.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $e8d4e2fa1f2b8f08$var$isSet = $e8d4e2fa1f2b8f08$var$nodeIsSet ? $91Qdd($e8d4e2fa1f2b8f08$var$nodeIsSet) : $eFk8g;
module.exports = $e8d4e2fa1f2b8f08$var$isSet;

});
parcelRegister("eFk8g", function(module, exports) {

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $aad482e59457493b$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $aad482e59457493b$var$baseIsSet(value) {
    return $8l89S(value) && $67A6V(value) == $aad482e59457493b$var$setTag;
}
module.exports = $aad482e59457493b$var$baseIsSet;

});



parcelRegister("gSeoX", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $hkfXi = parcelRequire("hkfXi");

var $f865s = parcelRequire("f865s");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $c48cdc53eae67a7f$var$baseUnset(object, path) {
    path = $4RK0h(path, object);
    object = $f865s(object, path);
    return object == null || delete object[$6DSvu($hkfXi(path))];
}
module.exports = $c48cdc53eae67a7f$var$baseUnset;

});
parcelRegister("4RK0h", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $kPpic = parcelRequire("kPpic");

var $lnP3M = parcelRequire("lnP3M");

var $l6E2L = parcelRequire("l6E2L");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($o8HxT(value)) return value;
    return $kPpic(value, object) ? [
        value
    ] : $lnP3M($l6E2L(value));
}
module.exports = $38afcbfab85a0553$var$castPath;

});
parcelRegister("kPpic", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($o8HxT(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $9dr3u(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $03e9beb856e9b4cd$var$isKey;

});
parcelRegister("9dr3u", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == "symbol" || $8l89S(value) && $eq6CV(value) == $6b5a5095e0934938$var$symbolTag;
}
module.exports = $6b5a5095e0934938$var$isSymbol;

});


parcelRegister("lnP3M", function(module, exports) {

var $99Rk8 = parcelRequire("99Rk8");
/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $99Rk8(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $f9135a667399ede4$var$stringToPath;

});
parcelRegister("99Rk8", function(module, exports) {

var $23xpV = parcelRequire("23xpV");
/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $23xpV(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $6aae515404bf5dd2$var$memoizeCapped;

});
parcelRegister("23xpV", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");
/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $6gDBQ);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $6gDBQ;
module.exports = $17f5c88c594eac51$var$memoize;

});



parcelRegister("l6E2L", function(module, exports) {

var $kJ9w3 = parcelRequire("kJ9w3");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? "" : $kJ9w3(value);
}
module.exports = $f5d9385a9cc7e413$var$toString;

});
parcelRegister("kJ9w3", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $i46jW = parcelRequire("i46jW");

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($o8HxT(value)) // Recursively convert values (susceptible to call stack limits).
    return $i46jW(value, $f16f644742c27c21$var$baseToString) + "";
    if ($9dr3u(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$f16f644742c27c21$var$INFINITY ? "-0" : result;
}
module.exports = $f16f644742c27c21$var$baseToString;

});



parcelRegister("hkfXi", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $c9d0ae50fd1d1372$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $c9d0ae50fd1d1372$var$last;

});

parcelRegister("f865s", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");

var $1quiu = parcelRequire("1quiu");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $b03c5325a6e99e83$var$parent(object, path) {
    return path.length < 2 ? object : $lJEX1(object, $1quiu(path, 0, -1));
}
module.exports = $b03c5325a6e99e83$var$parent;

});
parcelRegister("lJEX1", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $4RK0h(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$6DSvu(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $fd2d90f592c63519$var$baseGet;

});
parcelRegister("6DSvu", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == "string" || $9dr3u(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$4d60aa8c33155976$var$INFINITY ? "-0" : result;
}
module.exports = $4d60aa8c33155976$var$toKey;

});


parcelRegister("1quiu", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $109fb88fe59de104$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $109fb88fe59de104$var$baseSlice;

});



parcelRegister("lJ3Ig", function(module, exports) {

var $xMy82 = parcelRequire("xMy82");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $fd10ae4394ad99ac$var$customOmitClone(value) {
    return $xMy82(value) ? undefined : value;
}
module.exports = $fd10ae4394ad99ac$var$customOmitClone;

});
parcelRegister("xMy82", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $cdnOB = parcelRequire("cdnOB");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $0658be17f7793a43$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $0658be17f7793a43$var$funcProto = Function.prototype, $0658be17f7793a43$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0658be17f7793a43$var$funcToString = $0658be17f7793a43$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0658be17f7793a43$var$hasOwnProperty = $0658be17f7793a43$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0658be17f7793a43$var$objectCtorString = $0658be17f7793a43$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0658be17f7793a43$var$isPlainObject(value) {
    if (!$8l89S(value) || $eq6CV(value) != $0658be17f7793a43$var$objectTag) return false;
    var proto = $cdnOB(value);
    if (proto === null) return true;
    var Ctor = $0658be17f7793a43$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $0658be17f7793a43$var$funcToString.call(Ctor) == $0658be17f7793a43$var$objectCtorString;
}
module.exports = $0658be17f7793a43$var$isPlainObject;

});


parcelRegister("8KK0w", function(module, exports) {

var $20Rgr = parcelRequire("20Rgr");

var $b86t6 = parcelRequire("b86t6");

var $iGMVy = parcelRequire("iGMVy");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $65f64eb9f31faa0d$var$flatRest(func) {
    return $iGMVy($b86t6(func, undefined, $20Rgr), func + "");
}
module.exports = $65f64eb9f31faa0d$var$flatRest;

});
parcelRegister("20Rgr", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $1774e6065e7ade58$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $fgBHx(array, 1) : [];
}
module.exports = $1774e6065e7ade58$var$flatten;

});
parcelRegister("fgBHx", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $hStNq = parcelRequire("hStNq");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $b1d5985487d54dea$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $hStNq);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $b1d5985487d54dea$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hynws(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $b1d5985487d54dea$var$baseFlatten;

});
parcelRegister("hStNq", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");
/** Built-in value references. */ var $035bd928078475ee$var$spreadableSymbol = $57wYk ? $57wYk.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $035bd928078475ee$var$isFlattenable(value) {
    return $o8HxT(value) || $aJD6g(value) || !!($035bd928078475ee$var$spreadableSymbol && value && value[$035bd928078475ee$var$spreadableSymbol]);
}
module.exports = $035bd928078475ee$var$isFlattenable;

});



parcelRegister("b86t6", function(module, exports) {

var $jpWht = parcelRequire("jpWht");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $81a5758ee0248452$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $81a5758ee0248452$var$overRest(func, start, transform) {
    start = $81a5758ee0248452$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $81a5758ee0248452$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $jpWht(func, this, otherArgs);
    };
}
module.exports = $81a5758ee0248452$var$overRest;

});
parcelRegister("jpWht", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e22d8f7aab4ea8e2$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $e22d8f7aab4ea8e2$var$apply;

});


parcelRegister("iGMVy", function(module, exports) {

var $2yzAw = parcelRequire("2yzAw");

var $7WhTB = parcelRequire("7WhTB");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $d9b21a2cad7f96c2$var$setToString = $7WhTB($2yzAw);
module.exports = $d9b21a2cad7f96c2$var$setToString;

});
parcelRegister("2yzAw", function(module, exports) {

var $9HRmE = parcelRequire("9HRmE");

var $4hwTc = parcelRequire("4hwTc");

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1dca5cc74bf5ffaf$var$baseSetToString = !$4hwTc ? $4Nq5y : function(func, string) {
    return $4hwTc(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $9HRmE(string),
        "writable": true
    });
};
module.exports = $1dca5cc74bf5ffaf$var$baseSetToString;

});
parcelRegister("9HRmE", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $7111863c3c692f0e$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $7111863c3c692f0e$var$constant;

});

parcelRegister("4Nq5y", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
module.exports = $37dff9aa04444f9c$var$identity;

});


parcelRegister("7WhTB", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $5c7bd4e931ae22e5$var$HOT_COUNT = 800, $5c7bd4e931ae22e5$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5c7bd4e931ae22e5$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $5c7bd4e931ae22e5$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $5c7bd4e931ae22e5$var$nativeNow(), remaining = $5c7bd4e931ae22e5$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $5c7bd4e931ae22e5$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $5c7bd4e931ae22e5$var$shortOut;

});




parcelRegister("i5Lss", function(module, exports) {
$parcel$export(module.exports, "createQuery", () => (parcelRequire("kkxkw")).createQuery);
$parcel$export(module.exports, "createApiClient", () => (parcelRequire("2mq6B")).createApiClient);
$parcel$export(module.exports, "getCacheKey", () => (parcelRequire("4gN4F")).getCacheKey);
$parcel$export(module.exports, "createMutation", () => (parcelRequire("gBHSi")).createMutation);
$parcel$export(module.exports, "queryClient", () => (parcelRequire("eX6Sv")).queryClient);
$parcel$export(module.exports, "updateQueriesDataByPattern", () => (parcelRequire("hkj2Z")).updateQueriesDataByPattern);
parcelRequire("kkxkw");
parcelRequire("gjVi8");
parcelRequire("4gN4F");
parcelRequire("gBHSi");
parcelRequire("eX6Sv");
parcelRequire("hkj2Z");

});
parcelRegister("kkxkw", function(module, exports) {

$parcel$export(module.exports, "createQuery", () => $1d2ba47b63a597fc$export$b0bb00bbf9023ec9);
function $1d2ba47b63a597fc$export$b0bb00bbf9023ec9(queryFn, options = {}) {
    return {
        ...{
            ...options,
            waitForSession: options.waitForSession === undefined ? true : options.waitForSession
        },
        queryFn: queryFn
    };
}

});

parcelRegister("gjVi8", function(module, exports) {
$parcel$export(module.exports, "createApiClient", () => (parcelRequire("2mq6B")).createApiClient);
parcelRequire("2mq6B");

});
parcelRegister("2mq6B", function(module, exports) {

$parcel$export(module.exports, "createApiClient", () => $54e0d8e1bd6cd3a0$export$8744222f7aa763e1);

var $9a2Lw = parcelRequire("9a2Lw");
parcelRequire("gCemA");
var $bxdbx = parcelRequire("bxdbx");
var $yrzTx = parcelRequire("yrzTx");
var $eQb4w = parcelRequire("eQb4w");

var $5V56o = parcelRequire("5V56o");

var $f1q41 = parcelRequire("f1q41");

var $7zRAS = parcelRequire("7zRAS");
const $54e0d8e1bd6cd3a0$export$8744222f7aa763e1 = ({ baseURL: baseURL = "https://api2.humcapital.com", token: token, convert: convert = true, withCredentials: withCredentials = true } = {})=>{
    const config = {
        baseURL: baseURL,
        withCredentials: withCredentials
    };
    if (token && withCredentials) config.headers = {
        Authorization: `Bearer ${token}`
    };
    const apiClient = (0, $5V56o.httpClient).create(config);
    // handle errors responded with 2xx responses.
    apiClient.interceptors.response.use((0, $9a2Lw.handleRespondedErrors));
    // extract data on success (only important part).
    apiClient.interceptors.response.use((res)=>{
        (0, $yrzTx.log).info(`${res.config.method} ${res.config.url} : ${res.status} ${res.statusText}`, {
            ...res,
            data: (0, $7zRAS.default)(res.data, [
                "password",
                "ssn",
                "dob"
            ]),
            config: {
                ...res.config,
                headers: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).omit(res.headers, "Authorization")
            }
        });
        return convert ? (0, $bxdbx.camelCased)(res.data) : res.data;
    });
    // handle network errors (4xx & 5xx responses).
    apiClient.interceptors.response.use(undefined, (0, $9a2Lw.handleErrors));
    // Handle both JSON and FormData requests
    apiClient.interceptors.request.use((config)=>{
        const isFormData = config.data instanceof FormData;
        const isBinaryData = config.data instanceof ArrayBuffer;
        const updatedConfig = {
            ...config,
            params: convert ? (0, $eQb4w.snakeCased)(config.params) : config.params,
            data: convert && !isFormData && !isBinaryData ? (0, $eQb4w.snakeCased)(config.data) : config.data
        };
        if (isFormData) updatedConfig.headers.set("Content-Type", "multipart/form-data");
        else updatedConfig.headers.set("Content-Type", updatedConfig.headers["Content-Type"] || "application/json");
        return updatedConfig;
    });
    return apiClient;
};

});
parcelRegister("9a2Lw", function(module, exports) {

$parcel$export(module.exports, "handleErrors", () => $88e517e855760c4d$export$1e36de371b2e3d5a);
$parcel$export(module.exports, "handleRespondedErrors", () => $88e517e855760c4d$export$2748f7fc3a614c71);
/* eslint-disable @typescript-eslint/ban-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ parcelRequire("gCemA");
var $yrzTx = parcelRequire("yrzTx");

var $f1q41 = parcelRequire("f1q41");
/**
 * Composes multiple data handlers into a single, ordered handling mechanism.
 *
 * @param handlers A list of data handlers.
 */ const $88e517e855760c4d$export$93e29cf8295bae08 = (...handlers)=>async (...args)=>{
        let resolved;
        for (const handler of handlers){
            // eslint-disable-next-line no-await-in-loop
            if ((resolved = await handler(...args)) !== undefined) // if handler resolved, shortcut exit.
            return resolved;
        }
        // if no handler resolved/threw, resolve to parent root.
        return args[0];
    };
/**
 * Composes multiple error handlers into a single, ordered handling mechanism.
 *
 * @param handlers A list of error handlers.
 */ const $88e517e855760c4d$export$8b640dab169c4b1a = (...handlers)=>{
    const handle = $88e517e855760c4d$export$93e29cf8295bae08(...handlers);
    return async (error)=>{
        const resolved = await handle(error);
        // Return resolved value, if any.
        if (resolved !== undefined && resolved !== error) return resolved;
        // Rethrow unhandled error.
        $88e517e855760c4d$var$sendError(error);
    };
};
/**
 * Handles failed HTTP requests.
 *
 * i.e.: backend not available.
 */ const $88e517e855760c4d$export$c625bbe513f768f7 = (error)=>{
    if (!error.response) $88e517e855760c4d$var$sendError(error);
};
/**
 * Handles HTTP error responses with a { data: { message } } structure.
 *
 * i.e.: 400 :: { data: { message: 'Invalid credentials' } }
 */ const $88e517e855760c4d$export$c7266c8913679f03 = (v)=>{
    const message = v?.response?.data?.message;
    if (message) $88e517e855760c4d$var$sendError(new Error(message));
};
/**
 * Handles HTTP error responses with a { data: { error } } structure.
 *
 * i.e.: 400 :: { data: { error: 'Invalid credentials' } }
 */ const $88e517e855760c4d$export$c72f8ebfa6eecc98 = ({ response: response })=>{
    if (response && response.data.error) $88e517e855760c4d$var$sendError(new Error(response.data.error));
};
/**
 * Handles HTTP error responses with a { data: { code, description, name } } structure.
 *
 * i.e.: 401 :: { code: 401, name: 'Unauthorized', description: 'The server could not verify...' }
 */ const $88e517e855760c4d$export$bcceac38882ed6d = (v)=>{
    const data = v?.response?.data;
    if (data && data.code) {
        const messages = [
            // in case description is the error string itself
            data.description,
            // in case description is an object containing the message
            typeof data.description === "object" ? data.description.message : null,
            // in case we have a name
            data.name,
            // fallback
            "Unexpected error"
        ];
        $88e517e855760c4d$var$sendError(new Error(messages.find((option)=>typeof option === "string")));
    }
};
/**
 * Default prioritize error handler.
 */ const $88e517e855760c4d$export$1e36de371b2e3d5a = $88e517e855760c4d$export$8b640dab169c4b1a($88e517e855760c4d$export$c625bbe513f768f7, $88e517e855760c4d$export$c72f8ebfa6eecc98, $88e517e855760c4d$export$c7266c8913679f03, $88e517e855760c4d$export$bcceac38882ed6d);
/**
 * Handles HTTP success messages containing an error.
 *
 * i.e.: 200 :: { data: { error: 'Error validating against schema' } }
 */ const $88e517e855760c4d$export$f76019dc73c37aa2 = ({ data: data })=>{
    if (data?.error) $88e517e855760c4d$var$sendError(new Error(data.error));
};
/**
 * Handles HTTP success messages containing and error in array structure.
 *
 * i.e.: 200 :: { data: [{ message: 'user taken' }, 400] }
 */ const $88e517e855760c4d$export$743bafd87b9f64dd = ({ data: data })=>{
    if (data?.[0]?.message && data[1] && data[1] === 400) $88e517e855760c4d$var$sendError(new Error(data[0].message));
};
/**
 * Default prioritize response with error as data (200) handler.
 */ const $88e517e855760c4d$export$2748f7fc3a614c71 = $88e517e855760c4d$export$93e29cf8295bae08($88e517e855760c4d$export$f76019dc73c37aa2, $88e517e855760c4d$export$743bafd87b9f64dd);
const $88e517e855760c4d$var$sendError = (error)=>{
    try {
        if ("response" in error) (0, $yrzTx.log).error(`${error.response?.config.method} ${error.response?.config.url} : ${error.response?.status} ${error.response?.statusText}`, {
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            config: error.response?.config ? {
                url: error.response?.config.url,
                method: error.response?.config.method,
                params: error.response?.config.params,
                headers: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).omit(error.response?.config.headers || {}, "Authorization")
            } : undefined,
            message: error.message
        });
        else {
            // For non-Axios errors
            const errorInfo = {
                name: error.name,
                message: error.message,
                stack: error.stack
            };
            (0, $yrzTx.log).error("Application Error", errorInfo);
        }
    } catch (loggingError) {
        (0, $yrzTx.log).error("Error Logging Failed", {
            originalError: String(error),
            loggingError: String(loggingError)
        });
    }
    throw error;
};

});
parcelRegister("gCemA", function(module, exports) {
$parcel$export(module.exports, "autoCapitalize", () => (parcelRequire("1pwFu")).autoCapitalize);
$parcel$export(module.exports, "camelCased", () => (parcelRequire("bxdbx")).camelCased);
$parcel$export(module.exports, "formatDate", () => (parcelRequire("kdwja")).formatDate);
$parcel$export(module.exports, "formattedUrl", () => (parcelRequire("lvlqo")).formattedUrl);
$parcel$export(module.exports, "getGreeting", () => (parcelRequire("lGvmR")).getGreeting);
$parcel$export(module.exports, "isoDateFormat", () => (parcelRequire("fjko4")).isoDateFormat);
$parcel$export(module.exports, "isoToDate", () => (parcelRequire("fjko4")).isoToDate);
$parcel$export(module.exports, "money", () => (parcelRequire("kdwja")).money);
$parcel$export(module.exports, "parseMarkdownLinks", () => (parcelRequire("hJQbt")).parseMarkdownLinks);
$parcel$export(module.exports, "selectOptionsFromMap", () => (parcelRequire("98Yiq")).selectOptionsFromMap);
$parcel$export(module.exports, "snakeCased", () => (parcelRequire("eQb4w")).snakeCased);
$parcel$export(module.exports, "URL_REGEX", () => (parcelRequire("lvlqo")).URL_REGEX);
$parcel$export(module.exports, "useDebounce", () => (parcelRequire("3ubHA")).useDebounce);
$parcel$export(module.exports, "useFilters", () => (parcelRequire("3y6NQ")).useFilters);
$parcel$export(module.exports, "useFlowState", () => (parcelRequire("4sFVK")).useFlowState);
$parcel$export(module.exports, "useModalState", () => (parcelRequire("7ZRJK")).useModalState);
$parcel$export(module.exports, "useFlags", () => (parcelRequire("7gcOJ")).useFlags);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("fp4OM")).useRouter);
$parcel$export(module.exports, "ddActions", () => (parcelRequire("2bkBK")).ddActions);
$parcel$export(module.exports, "initDataDog", () => (parcelRequire("hytaM")).initDataDog);
$parcel$export(module.exports, "log", () => (parcelRequire("yrzTx")).log);
$parcel$export(module.exports, "QueryStringBuilder", () => (parcelRequire("9O2q1")).QueryStringBuilder);
$parcel$export(module.exports, "asPage", () => (parcelRequire("3qMBE")).asPage);
$parcel$export(module.exports, "V1RedirectWithPath", () => (parcelRequire("fuEBT")).V1RedirectWithPath);
parcelRequire("iuVpE");
parcelRequire("anJVh");
parcelRequire("2bFYF");
parcelRequire("a1Lcn");
parcelRequire("kD2Zf");
parcelRequire("jLMBL");
parcelRequire("4sYx8");
parcelRequire("dUDTx");

});
parcelRegister("iuVpE", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => (parcelRequire("kdwja")).formatDate);
$parcel$export(module.exports, "money", () => (parcelRequire("kdwja")).money);
$parcel$export(module.exports, "isoDateFormat", () => (parcelRequire("fjko4")).isoDateFormat);
$parcel$export(module.exports, "isoToDate", () => (parcelRequire("fjko4")).isoToDate);
$parcel$export(module.exports, "ensureHttps", () => (parcelRequire("lvlqo")).ensureHttps);
$parcel$export(module.exports, "formattedUrl", () => (parcelRequire("lvlqo")).formattedUrl);
$parcel$export(module.exports, "URL_REGEX", () => (parcelRequire("lvlqo")).URL_REGEX);
$parcel$export(module.exports, "useModalState", () => (parcelRequire("7ZRJK")).useModalState);
$parcel$export(module.exports, "useFilters", () => (parcelRequire("3y6NQ")).useFilters);
$parcel$export(module.exports, "useDebounce", () => (parcelRequire("3ubHA")).useDebounce);
$parcel$export(module.exports, "useFlowState", () => (parcelRequire("4sFVK")).useFlowState);
$parcel$export(module.exports, "getGreeting", () => (parcelRequire("lGvmR")).getGreeting);
$parcel$export(module.exports, "selectOptionsFromMap", () => (parcelRequire("98Yiq")).selectOptionsFromMap);
$parcel$export(module.exports, "autoCapitalize", () => (parcelRequire("1pwFu")).autoCapitalize);
$parcel$export(module.exports, "camelCased", () => (parcelRequire("bxdbx")).camelCased);
$parcel$export(module.exports, "snakeCased", () => (parcelRequire("eQb4w")).snakeCased);
$parcel$export(module.exports, "abbreviate", () => (parcelRequire("7op73")).abbreviate);
$parcel$export(module.exports, "validateDOB", () => (parcelRequire("8U1EK")).validateDOB);
$parcel$export(module.exports, "parseMarkdownLinks", () => (parcelRequire("hJQbt")).parseMarkdownLinks);
parcelRequire("fKjfh");
parcelRequire("kdwja");
parcelRequire("cHPRX");
parcelRequire("a3VvM");
parcelRequire("fjko4");
parcelRequire("lvlqo");
parcelRequire("7ZRJK");
parcelRequire("3y6NQ");
parcelRequire("3ubHA");
parcelRequire("4sFVK");
parcelRequire("lGvmR");
parcelRequire("eNziG");
parcelRequire("98Yiq");
parcelRequire("eVw89");
parcelRequire("1pwFu");
parcelRequire("bxdbx");
parcelRequire("eQb4w");
parcelRequire("7op73");
parcelRequire("8U1EK");
parcelRequire("hJQbt");

});
parcelRegister("fKjfh", function(module, exports) {
const $a7fd64e269c41004$export$7c986b1ca206c700 = (obj, key)=>{
    const newObj = {
        ...obj
    };
    delete newObj[key];
    return newObj;
};

});

parcelRegister("kdwja", function(module, exports) {

$parcel$export(module.exports, "formatDate", () => $73e8a05744704762$export$3ae94a2503e890a1);
$parcel$export(module.exports, "money", () => $73e8a05744704762$export$5517df3497010beb);
$parcel$export(module.exports, "longFormMoney", () => $73e8a05744704762$export$c6a307f220722796);

var $gngdn = parcelRequire("gngdn");

var $gogTx = parcelRequire("gogTx");

var $lHTSI = parcelRequire("lHTSI");

var $Jb9bz = parcelRequire("Jb9bz");
(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).extend((0, (/*@__PURE__*/$parcel$interopDefault($gogTx))));
(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).extend((0, (/*@__PURE__*/$parcel$interopDefault($lHTSI))));
(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).extend((0, (/*@__PURE__*/$parcel$interopDefault($Jb9bz))));
// https://github.com/captec/capital/issues/3710
const $73e8a05744704762$var$API_DATE_FORMAT = "YYYY-MM-DD H:mm:ss.SSSSS";
const $73e8a05744704762$export$3ae94a2503e890a1 = (date, { asOfTime: asOfTime = false, hideTime: hideTime = false, parseAsUTC: parseAsUTC = true, dateFormat: dateFormat = $73e8a05744704762$var$API_DATE_FORMAT, outputFormat: outputFormat } = {})=>{
    const parsedDate = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(date, dateFormat);
    const correctDate = parseAsUTC ? parsedDate.utc(true).local() : parsedDate;
    if (outputFormat) return correctDate.format(outputFormat);
    if (hideTime) return correctDate.format("MMM D, YYYY");
    else if (asOfTime) return correctDate.format("MMM YYYY");
    return correctDate.format("MMM D, YYYY, h:mm A");
};
const $73e8a05744704762$export$7c6f8d11db8da768 = (date, { parseAsUTC: parseAsUTC = true, dateFormat: dateFormat = $73e8a05744704762$var$API_DATE_FORMAT } = {})=>{
    const parsedDate = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(date, dateFormat);
    // utc(true) necessary since it fixes safari issue
    const correctDate = parseAsUTC ? parsedDate.utc(true).local() : parsedDate;
    return correctDate.fromNow();
};
const $73e8a05744704762$export$1e32f7407816b987 = (date)=>{
    if (!date || date === "-") return "-";
    const parsedDate = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(date, "MM/DD/YYYY");
    if (!parsedDate.isValid()) return "-";
    return parsedDate.format("MMM D, YYYY");
};
/**
 * i.e.:
 *   10.192  => $10.19
 *   1200400 => $1.2 M
 */ function $73e8a05744704762$export$5517df3497010beb(input, short = true) {
    if (input === null || input === undefined) return "";
    const amount = parseFloat(input);
    const magnitude = Math.abs(amount);
    // Normal formatting for amounts under $100
    if (magnitude < 100) return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
    }).format(amount);
    // Remove cents for amounts over $100
    if (magnitude < 1000000 || !short) return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(amount);
    // Format amounts up to 100 million with M to indicate millions, use up two fraction digits for
    // thousands
    if (magnitude < 100000000) {
        const output = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(amount / 1000000);
        return `${output}M`;
    }
    // Format amounts up to 1 billion with M to indicate millions, without fraction digits
    if (magnitude < 1000000000) {
        const output = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(Math.trunc(amount / 1000000));
        return `${output}M`;
    }
    // Format amounts up to 1 trillion with B to indicate billions without any fraction digits
    if (magnitude < 1000000000000) {
        const output = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(Math.trunc(amount / 1000000000));
        return `${output}B`;
    }
    const output = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(amount / 1000000000000);
    return `${output}T`;
}
function $73e8a05744704762$export$c6a307f220722796(value) {
    if (value === null || value === undefined || value === "" || value === "N/A") return "-";
    // Convert to number if string with strict validation
    let numericValue;
    if (typeof value === "string") {
        const str = value.trim();
        if (!/^-?\d+(\.\d+)?$/.test(str)) return "-";
        numericValue = Number(str);
    } else numericValue = value;
    // Check if conversion resulted in NaN
    if (isNaN(numericValue)) return "-";
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
    }).format(numericValue);
}
function $73e8a05744704762$export$3e1eee59f5dc52be(value, options = {}) {
    const { decimals: decimals = 1, showSign: showSign = false, fallback: fallback = "-", asDecimal: asDecimal = true, negativeStyle: negativeStyle = "parentheses", isPercentage: isPercentage = false } = options;
    if (value === null || value === undefined || value === "" || value === "N/A") return fallback;
    // Convert to number if string with strict validation
    let numericValue;
    if (typeof value === "string") {
        const str = value.trim();
        if (!/^-?\d+(\.\d+)?$/.test(str)) return fallback;
        numericValue = Number(str);
    } else numericValue = value;
    // Check if conversion resulted in NaN
    if (isNaN(numericValue)) return fallback;
    // If already a percentage (e.g., 289.34355 means 289.3%), format directly without multiplying
    if (isPercentage) {
        const roundedValue = Math.round(numericValue * Math.pow(10, decimals)) / Math.pow(10, decimals);
        if (numericValue < 0 && negativeStyle === "parentheses") {
            const positiveFormatted = new Intl.NumberFormat("en-US", {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals
            }).format(Math.abs(roundedValue));
            if (roundedValue === 0) return `${positiveFormatted}%`;
            return `(${positiveFormatted}%)`;
        }
        const formatted = new Intl.NumberFormat("en-US", {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        }).format(roundedValue);
        if (showSign && roundedValue > 0) return `+${formatted}%`;
        return `${formatted}%`;
    }
    // Original logic for decimal values (e.g., 0.289 means 28.9%)
    const percentValue = asDecimal ? numericValue : numericValue / 100;
    const roundedValue = Math.round(percentValue * 100 * Math.pow(10, decimals)) / Math.pow(10, decimals);
    if (numericValue < 0 && negativeStyle === "parentheses") {
        const positiveFormatted = new Intl.NumberFormat("en-US", {
            style: "percent",
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        }).format(Math.abs(percentValue));
        if (roundedValue === 0) return positiveFormatted;
        return `(${positiveFormatted})`;
    }
    const formatted = new Intl.NumberFormat("en-US", {
        style: "percent",
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(percentValue);
    if (showSign && roundedValue > 0) return `+${formatted}`;
    return formatted;
}

});
parcelRegister("gngdn", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("gogTx", function(module, exports) {
!function(t, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var o = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
            if (f) return o.$offset = u, o.$u = 0 === s, o;
            if (0 !== s) {
                var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
            } else o = this.utc();
            return o;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});

});

parcelRegister("lHTSI", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, o = {}, s = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var a = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, f = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], h = function(e) {
        var t = o[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, u = function(e, t) {
        var n, r = o.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, d = {
        A: [
            i,
            function(e) {
                this.afternoon = u(e, !1);
            }
        ],
        a: [
            i,
            function(e) {
                this.afternoon = u(e, !0);
            }
        ],
        S: [
            /\d/,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            n,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            r,
            a("seconds")
        ],
        ss: [
            r,
            a("seconds")
        ],
        m: [
            r,
            a("minutes")
        ],
        mm: [
            r,
            a("minutes")
        ],
        H: [
            r,
            a("hours")
        ],
        h: [
            r,
            a("hours")
        ],
        HH: [
            r,
            a("hours")
        ],
        hh: [
            r,
            a("hours")
        ],
        D: [
            r,
            a("day")
        ],
        DD: [
            n,
            a("day")
        ],
        Do: [
            i,
            function(e) {
                var t = o.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        M: [
            r,
            a("month")
        ],
        MM: [
            n,
            a("month")
        ],
        MMM: [
            i,
            function(e) {
                var t = h("months"), n = (h("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            i,
            function(e) {
                var t = h("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            a("year")
        ],
        YY: [
            n,
            function(e) {
                this.year = s(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            a("year")
        ],
        Z: f,
        ZZ: f
    };
    function c(n) {
        var r, i;
        r = n, i = o && o.formats;
        for(var s = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = s.length, f = 0; f < a; f += 1){
            var h = s[f], u = d[h], c = u && u[0], l = u && u[1];
            s[f] = l ? {
                regex: c,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = s[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var o = i.regex, f = i.parser, h = e.slice(r), u = o.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (s = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, s = e.args;
            this.$u = r;
            var a = s[1];
            if ("string" == typeof a) {
                var f = !0 === s[2], h = !0 === s[3], u = f || h, d = s[2];
                h && (d = s[2]), o = this.$locale(), !f && d && (o = n.Ls[d]), this.$d = function(e, t, n) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var r = c(t)(e), i = r.year, o = r.month, s = r.day, a = r.hours, f = r.minutes, h = r.seconds, u = r.milliseconds, d = r.zone, l = new Date, m = s || (i || o ? 1 : l.getDate()), M = i || l.getFullYear(), Y = 0;
                        i && !o || (Y = o > 0 ? o - 1 : l.getMonth());
                        var p = a || 0, v = f || 0, D = h || 0, g = u || 0;
                        return d ? new Date(Date.UTC(M, Y, m, p, v, D, g + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(M, Y, m, p, v, D, g)) : new Date(M, Y, m, p, v, D, g);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), o = {};
            } else if (a instanceof Array) for(var l = a.length, m = 1; m <= l; m += 1){
                s[1] = a[m - 1];
                var M = n.apply(this, s);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === l && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});

});

parcelRegister("Jb9bz", function(module, exports) {
!function(r, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});

});


parcelRegister("cHPRX", function(module, exports) {

var $e2D7Z = parcelRequire("e2D7Z");
parcelRequire("dRO48");
var $eUiRa = parcelRequire("eUiRa");
const $55a62b986a00baf5$var$getStateValue = (state)=>{
    if (state && state in (0, $eUiRa.US_STATES)) return (0, $eUiRa.US_STATES)[state];
    return null;
};
const $55a62b986a00baf5$var$getCountryValue = (country)=>{
    if (country && country in (0, $e2D7Z.countries)) return (0, $e2D7Z.countries)[country].name;
    return null;
};
const $55a62b986a00baf5$export$273ef55a731d71c3 = (stateName)=>Object.keys((0, $eUiRa.US_STATES)).find((key)=>(0, $eUiRa.US_STATES)[key] === stateName);
const $55a62b986a00baf5$export$265c76c3b8cb4fa3 = (countryName)=>Object.keys((0, $e2D7Z.countries)).find((key)=>(0, $e2D7Z.countries)[key].name === countryName);
const $55a62b986a00baf5$export$e7fd20fad3cf4b5f = (state, country)=>{
    return $55a62b986a00baf5$var$getStateValue(state) || $55a62b986a00baf5$var$getCountryValue(country);
};
const $55a62b986a00baf5$export$e73614aefee32f99 = (data)=>{
    if (data.state === (0, $eUiRa.USStates).OutsideTheUS) return data.country ? (0, $e2D7Z.countries)[data.country].name : "N/A";
    return (0, $eUiRa.US_STATES)[data.state];
};

});
parcelRegister("e2D7Z", function(module, exports) {

$parcel$export(module.exports, "countries", () => $02a35933d3b344e6$export$e5ad74579c86b003);
/*! countries-list v3.1.0 by Annexare | MIT */ var $02a35933d3b344e6$export$1215efa45e6f9581 = {
    AF: "Africa",
    AN: "Antarctica",
    AS: "Asia",
    EU: "Europe",
    NA: "North America",
    OC: "Oceania",
    SA: "South America"
};
var $02a35933d3b344e6$export$e5ad74579c86b003 = {
    AD: {
        name: "Andorra",
        native: "Andorra",
        phone: [
            376
        ],
        continent: "EU",
        capital: "Andorra la Vella",
        currency: [
            "EUR"
        ],
        languages: [
            "ca"
        ]
    },
    AE: {
        name: "United Arab Emirates",
        native: "\u062F\u0648\u0644\u0629 \u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
        phone: [
            971
        ],
        continent: "AS",
        capital: "Abu Dhabi",
        currency: [
            "AED"
        ],
        languages: [
            "ar"
        ]
    },
    AF: {
        name: "Afghanistan",
        native: "\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646",
        phone: [
            93
        ],
        continent: "AS",
        capital: "Kabul",
        currency: [
            "AFN"
        ],
        languages: [
            "ps",
            "uz",
            "tk"
        ]
    },
    AG: {
        name: "Antigua and Barbuda",
        native: "Antigua and Barbuda",
        phone: [
            1268
        ],
        continent: "NA",
        capital: "Saint John's",
        currency: [
            "XCD"
        ],
        languages: [
            "en"
        ]
    },
    AI: {
        name: "Anguilla",
        native: "Anguilla",
        phone: [
            1264
        ],
        continent: "NA",
        capital: "The Valley",
        currency: [
            "XCD"
        ],
        languages: [
            "en"
        ]
    },
    AL: {
        name: "Albania",
        native: "Shqip\xebria",
        phone: [
            355
        ],
        continent: "EU",
        capital: "Tirana",
        currency: [
            "ALL"
        ],
        languages: [
            "sq"
        ]
    },
    AM: {
        name: "Armenia",
        native: "\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576",
        phone: [
            374
        ],
        continent: "AS",
        capital: "Yerevan",
        currency: [
            "AMD"
        ],
        languages: [
            "hy",
            "ru"
        ]
    },
    AO: {
        name: "Angola",
        native: "Angola",
        phone: [
            244
        ],
        continent: "AF",
        capital: "Luanda",
        currency: [
            "AOA"
        ],
        languages: [
            "pt"
        ]
    },
    AQ: {
        name: "Antarctica",
        native: "Antarctica",
        phone: [
            672
        ],
        continent: "AN",
        capital: "",
        currency: [],
        languages: []
    },
    AR: {
        name: "Argentina",
        native: "Argentina",
        phone: [
            54
        ],
        continent: "SA",
        capital: "Buenos Aires",
        currency: [
            "ARS"
        ],
        languages: [
            "es",
            "gn"
        ]
    },
    AS: {
        name: "American Samoa",
        native: "American Samoa",
        phone: [
            1684
        ],
        continent: "OC",
        capital: "Pago Pago",
        currency: [
            "USD"
        ],
        languages: [
            "en",
            "sm"
        ]
    },
    AT: {
        name: "Austria",
        native: "\xd6sterreich",
        phone: [
            43
        ],
        continent: "EU",
        capital: "Vienna",
        currency: [
            "EUR"
        ],
        languages: [
            "de"
        ]
    },
    AU: {
        name: "Australia",
        native: "Australia",
        phone: [
            61
        ],
        continent: "OC",
        capital: "Canberra",
        currency: [
            "AUD"
        ],
        languages: [
            "en"
        ]
    },
    AW: {
        name: "Aruba",
        native: "Aruba",
        phone: [
            297
        ],
        continent: "NA",
        capital: "Oranjestad",
        currency: [
            "AWG"
        ],
        languages: [
            "nl",
            "pa"
        ]
    },
    AX: {
        name: "Aland",
        native: "\xc5land",
        phone: [
            358
        ],
        continent: "EU",
        capital: "Mariehamn",
        currency: [
            "EUR"
        ],
        languages: [
            "sv"
        ],
        partOf: "FI"
    },
    AZ: {
        name: "Azerbaijan",
        native: "Az\u0259rbaycan",
        phone: [
            994
        ],
        continent: "AS",
        continents: [
            "AS",
            "EU"
        ],
        capital: "Baku",
        currency: [
            "AZN"
        ],
        languages: [
            "az"
        ]
    },
    BA: {
        name: "Bosnia and Herzegovina",
        native: "Bosna i Hercegovina",
        phone: [
            387
        ],
        continent: "EU",
        capital: "Sarajevo",
        currency: [
            "BAM"
        ],
        languages: [
            "bs",
            "hr",
            "sr"
        ]
    },
    BB: {
        name: "Barbados",
        native: "Barbados",
        phone: [
            1246
        ],
        continent: "NA",
        capital: "Bridgetown",
        currency: [
            "BBD"
        ],
        languages: [
            "en"
        ]
    },
    BD: {
        name: "Bangladesh",
        native: "Bangladesh",
        phone: [
            880
        ],
        continent: "AS",
        capital: "Dhaka",
        currency: [
            "BDT"
        ],
        languages: [
            "bn"
        ]
    },
    BE: {
        name: "Belgium",
        native: "Belgi\xeb",
        phone: [
            32
        ],
        continent: "EU",
        capital: "Brussels",
        currency: [
            "EUR"
        ],
        languages: [
            "nl",
            "fr",
            "de"
        ]
    },
    BF: {
        name: "Burkina Faso",
        native: "Burkina Faso",
        phone: [
            226
        ],
        continent: "AF",
        capital: "Ouagadougou",
        currency: [
            "XOF"
        ],
        languages: [
            "fr",
            "ff"
        ]
    },
    BG: {
        name: "Bulgaria",
        native: "\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F",
        phone: [
            359
        ],
        continent: "EU",
        capital: "Sofia",
        currency: [
            "BGN"
        ],
        languages: [
            "bg"
        ]
    },
    BH: {
        name: "Bahrain",
        native: "\u200F\u0627\u0644\u0628\u062D\u0631\u064A\u0646",
        phone: [
            973
        ],
        continent: "AS",
        capital: "Manama",
        currency: [
            "BHD"
        ],
        languages: [
            "ar"
        ]
    },
    BI: {
        name: "Burundi",
        native: "Burundi",
        phone: [
            257
        ],
        continent: "AF",
        capital: "Bujumbura",
        currency: [
            "BIF"
        ],
        languages: [
            "fr",
            "rn"
        ]
    },
    BJ: {
        name: "Benin",
        native: "B\xe9nin",
        phone: [
            229
        ],
        continent: "AF",
        capital: "Porto-Novo",
        currency: [
            "XOF"
        ],
        languages: [
            "fr"
        ]
    },
    BL: {
        name: "Saint Barthelemy",
        native: "Saint-Barth\xe9lemy",
        phone: [
            590
        ],
        continent: "NA",
        capital: "Gustavia",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    BM: {
        name: "Bermuda",
        native: "Bermuda",
        phone: [
            1441
        ],
        continent: "NA",
        capital: "Hamilton",
        currency: [
            "BMD"
        ],
        languages: [
            "en"
        ]
    },
    BN: {
        name: "Brunei",
        native: "Negara Brunei Darussalam",
        phone: [
            673
        ],
        continent: "AS",
        capital: "Bandar Seri Begawan",
        currency: [
            "BND"
        ],
        languages: [
            "ms"
        ]
    },
    BO: {
        name: "Bolivia",
        native: "Bolivia",
        phone: [
            591
        ],
        continent: "SA",
        capital: "Sucre",
        currency: [
            "BOB",
            "BOV"
        ],
        languages: [
            "es",
            "ay",
            "qu"
        ]
    },
    BQ: {
        name: "Bonaire",
        native: "Bonaire",
        phone: [
            5997
        ],
        continent: "NA",
        capital: "Kralendijk",
        currency: [
            "USD"
        ],
        languages: [
            "nl"
        ]
    },
    BR: {
        name: "Brazil",
        native: "Brasil",
        phone: [
            55
        ],
        continent: "SA",
        capital: "Bras\xedlia",
        currency: [
            "BRL"
        ],
        languages: [
            "pt"
        ]
    },
    BS: {
        name: "Bahamas",
        native: "Bahamas",
        phone: [
            1242
        ],
        continent: "NA",
        capital: "Nassau",
        currency: [
            "BSD"
        ],
        languages: [
            "en"
        ]
    },
    BT: {
        name: "Bhutan",
        native: "\u02BCbrug-yul",
        phone: [
            975
        ],
        continent: "AS",
        capital: "Thimphu",
        currency: [
            "BTN",
            "INR"
        ],
        languages: [
            "dz"
        ]
    },
    BV: {
        name: "Bouvet Island",
        native: "Bouvet\xf8ya",
        phone: [
            47
        ],
        continent: "AN",
        capital: "",
        currency: [
            "NOK"
        ],
        languages: [
            "no",
            "nb",
            "nn"
        ]
    },
    BW: {
        name: "Botswana",
        native: "Botswana",
        phone: [
            267
        ],
        continent: "AF",
        capital: "Gaborone",
        currency: [
            "BWP"
        ],
        languages: [
            "en",
            "tn"
        ]
    },
    BY: {
        name: "Belarus",
        native: "\u0411\u0435\u043B\u0430\u0440\u0443\u0301\u0441\u044C",
        phone: [
            375
        ],
        continent: "EU",
        capital: "Minsk",
        currency: [
            "BYN"
        ],
        languages: [
            "be",
            "ru"
        ]
    },
    BZ: {
        name: "Belize",
        native: "Belize",
        phone: [
            501
        ],
        continent: "NA",
        capital: "Belmopan",
        currency: [
            "BZD"
        ],
        languages: [
            "en",
            "es"
        ]
    },
    CA: {
        name: "Canada",
        native: "Canada",
        phone: [
            1
        ],
        continent: "NA",
        capital: "Ottawa",
        currency: [
            "CAD"
        ],
        languages: [
            "en",
            "fr"
        ]
    },
    CC: {
        name: "Cocos (Keeling) Islands",
        native: "Cocos (Keeling) Islands",
        phone: [
            61
        ],
        continent: "AS",
        capital: "West Island",
        currency: [
            "AUD"
        ],
        languages: [
            "en"
        ]
    },
    CD: {
        name: "Democratic Republic of the Congo",
        native: "R\xe9publique d\xe9mocratique du Congo",
        phone: [
            243
        ],
        continent: "AF",
        capital: "Kinshasa",
        currency: [
            "CDF"
        ],
        languages: [
            "fr",
            "ln",
            "kg",
            "sw",
            "lu"
        ]
    },
    CF: {
        name: "Central African Republic",
        native: "K\xf6d\xf6r\xf6s\xease t\xee B\xeaafr\xeeka",
        phone: [
            236
        ],
        continent: "AF",
        capital: "Bangui",
        currency: [
            "XAF"
        ],
        languages: [
            "fr",
            "sg"
        ]
    },
    CG: {
        name: "Republic of the Congo",
        native: "R\xe9publique du Congo",
        phone: [
            242
        ],
        continent: "AF",
        capital: "Brazzaville",
        currency: [
            "XAF"
        ],
        languages: [
            "fr",
            "ln"
        ]
    },
    CH: {
        name: "Switzerland",
        native: "Schweiz",
        phone: [
            41
        ],
        continent: "EU",
        capital: "Bern",
        currency: [
            "CHE",
            "CHF",
            "CHW"
        ],
        languages: [
            "de",
            "fr",
            "it"
        ]
    },
    CI: {
        name: "Ivory Coast",
        native: "C\xf4te d'Ivoire",
        phone: [
            225
        ],
        continent: "AF",
        capital: "Yamoussoukro",
        currency: [
            "XOF"
        ],
        languages: [
            "fr"
        ]
    },
    CK: {
        name: "Cook Islands",
        native: "Cook Islands",
        phone: [
            682
        ],
        continent: "OC",
        capital: "Avarua",
        currency: [
            "NZD"
        ],
        languages: [
            "en"
        ]
    },
    CL: {
        name: "Chile",
        native: "Chile",
        phone: [
            56
        ],
        continent: "SA",
        capital: "Santiago",
        currency: [
            "CLF",
            "CLP"
        ],
        languages: [
            "es"
        ]
    },
    CM: {
        name: "Cameroon",
        native: "Cameroon",
        phone: [
            237
        ],
        continent: "AF",
        capital: "Yaound\xe9",
        currency: [
            "XAF"
        ],
        languages: [
            "en",
            "fr"
        ]
    },
    CN: {
        name: "China",
        native: "\u4E2D\u56FD",
        phone: [
            86
        ],
        continent: "AS",
        capital: "Beijing",
        currency: [
            "CNY"
        ],
        languages: [
            "zh"
        ]
    },
    CO: {
        name: "Colombia",
        native: "Colombia",
        phone: [
            57
        ],
        continent: "SA",
        capital: "Bogot\xe1",
        currency: [
            "COP"
        ],
        languages: [
            "es"
        ]
    },
    CR: {
        name: "Costa Rica",
        native: "Costa Rica",
        phone: [
            506
        ],
        continent: "NA",
        capital: "San Jos\xe9",
        currency: [
            "CRC"
        ],
        languages: [
            "es"
        ]
    },
    CU: {
        name: "Cuba",
        native: "Cuba",
        phone: [
            53
        ],
        continent: "NA",
        capital: "Havana",
        currency: [
            "CUC",
            "CUP"
        ],
        languages: [
            "es"
        ]
    },
    CV: {
        name: "Cape Verde",
        native: "Cabo Verde",
        phone: [
            238
        ],
        continent: "AF",
        capital: "Praia",
        currency: [
            "CVE"
        ],
        languages: [
            "pt"
        ]
    },
    CW: {
        name: "Curacao",
        native: "Cura\xe7ao",
        phone: [
            5999
        ],
        continent: "NA",
        capital: "Willemstad",
        currency: [
            "ANG"
        ],
        languages: [
            "nl",
            "pa",
            "en"
        ]
    },
    CX: {
        name: "Christmas Island",
        native: "Christmas Island",
        phone: [
            61
        ],
        continent: "AS",
        capital: "Flying Fish Cove",
        currency: [
            "AUD"
        ],
        languages: [
            "en"
        ]
    },
    CY: {
        name: "Cyprus",
        native: "\u039A\u03CD\u03C0\u03C1\u03BF\u03C2",
        phone: [
            357
        ],
        continent: "EU",
        capital: "Nicosia",
        currency: [
            "EUR"
        ],
        languages: [
            "el",
            "tr",
            "hy"
        ]
    },
    CZ: {
        name: "Czech Republic",
        native: "\u010Cesk\xe1 republika",
        phone: [
            420
        ],
        continent: "EU",
        capital: "Prague",
        currency: [
            "CZK"
        ],
        languages: [
            "cs"
        ]
    },
    DE: {
        name: "Germany",
        native: "Deutschland",
        phone: [
            49
        ],
        continent: "EU",
        capital: "Berlin",
        currency: [
            "EUR"
        ],
        languages: [
            "de"
        ]
    },
    DJ: {
        name: "Djibouti",
        native: "Djibouti",
        phone: [
            253
        ],
        continent: "AF",
        capital: "Djibouti",
        currency: [
            "DJF"
        ],
        languages: [
            "fr",
            "ar"
        ]
    },
    DK: {
        name: "Denmark",
        native: "Danmark",
        phone: [
            45
        ],
        continent: "EU",
        continents: [
            "EU",
            "NA"
        ],
        capital: "Copenhagen",
        currency: [
            "DKK"
        ],
        languages: [
            "da"
        ]
    },
    DM: {
        name: "Dominica",
        native: "Dominica",
        phone: [
            1767
        ],
        continent: "NA",
        capital: "Roseau",
        currency: [
            "XCD"
        ],
        languages: [
            "en"
        ]
    },
    DO: {
        name: "Dominican Republic",
        native: "Rep\xfablica Dominicana",
        phone: [
            1809,
            1829,
            1849
        ],
        continent: "NA",
        capital: "Santo Domingo",
        currency: [
            "DOP"
        ],
        languages: [
            "es"
        ]
    },
    DZ: {
        name: "Algeria",
        native: "\u0627\u0644\u062C\u0632\u0627\u0626\u0631",
        phone: [
            213
        ],
        continent: "AF",
        capital: "Algiers",
        currency: [
            "DZD"
        ],
        languages: [
            "ar"
        ]
    },
    EC: {
        name: "Ecuador",
        native: "Ecuador",
        phone: [
            593
        ],
        continent: "SA",
        capital: "Quito",
        currency: [
            "USD"
        ],
        languages: [
            "es"
        ]
    },
    EE: {
        name: "Estonia",
        native: "Eesti",
        phone: [
            372
        ],
        continent: "EU",
        capital: "Tallinn",
        currency: [
            "EUR"
        ],
        languages: [
            "et"
        ]
    },
    EG: {
        name: "Egypt",
        native: "\u0645\u0635\u0631\u200E",
        phone: [
            20
        ],
        continent: "AF",
        continents: [
            "AF",
            "AS"
        ],
        capital: "Cairo",
        currency: [
            "EGP"
        ],
        languages: [
            "ar"
        ]
    },
    EH: {
        name: "Western Sahara",
        native: "\u0627\u0644\u0635\u062D\u0631\u0627\u0621 \u0627\u0644\u063A\u0631\u0628\u064A\u0629",
        phone: [
            212
        ],
        continent: "AF",
        capital: "El Aai\xfan",
        currency: [
            "MAD",
            "DZD",
            "MRU"
        ],
        languages: [
            "es"
        ]
    },
    ER: {
        name: "Eritrea",
        native: "\u12A4\u122D\u1275\u122B",
        phone: [
            291
        ],
        continent: "AF",
        capital: "Asmara",
        currency: [
            "ERN"
        ],
        languages: [
            "ti",
            "ar",
            "en"
        ]
    },
    ES: {
        name: "Spain",
        native: "Espa\xf1a",
        phone: [
            34
        ],
        continent: "EU",
        capital: "Madrid",
        currency: [
            "EUR"
        ],
        languages: [
            "es",
            "eu",
            "ca",
            "gl",
            "oc"
        ]
    },
    ET: {
        name: "Ethiopia",
        native: "\u12A2\u1275\u12EE\u1335\u12EB",
        phone: [
            251
        ],
        continent: "AF",
        capital: "Addis Ababa",
        currency: [
            "ETB"
        ],
        languages: [
            "am"
        ]
    },
    FI: {
        name: "Finland",
        native: "Suomi",
        phone: [
            358
        ],
        continent: "EU",
        capital: "Helsinki",
        currency: [
            "EUR"
        ],
        languages: [
            "fi",
            "sv"
        ]
    },
    FJ: {
        name: "Fiji",
        native: "Fiji",
        phone: [
            679
        ],
        continent: "OC",
        capital: "Suva",
        currency: [
            "FJD"
        ],
        languages: [
            "en",
            "fj",
            "hi",
            "ur"
        ]
    },
    FK: {
        name: "Falkland Islands",
        native: "Falkland Islands",
        phone: [
            500
        ],
        continent: "SA",
        capital: "Stanley",
        currency: [
            "FKP"
        ],
        languages: [
            "en"
        ]
    },
    FM: {
        name: "Micronesia",
        native: "Micronesia",
        phone: [
            691
        ],
        continent: "OC",
        capital: "Palikir",
        currency: [
            "USD"
        ],
        languages: [
            "en"
        ]
    },
    FO: {
        name: "Faroe Islands",
        native: "F\xf8royar",
        phone: [
            298
        ],
        continent: "EU",
        capital: "T\xf3rshavn",
        currency: [
            "DKK"
        ],
        languages: [
            "fo"
        ]
    },
    FR: {
        name: "France",
        native: "France",
        phone: [
            33
        ],
        continent: "EU",
        capital: "Paris",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    GA: {
        name: "Gabon",
        native: "Gabon",
        phone: [
            241
        ],
        continent: "AF",
        capital: "Libreville",
        currency: [
            "XAF"
        ],
        languages: [
            "fr"
        ]
    },
    GB: {
        name: "United Kingdom",
        native: "United Kingdom",
        phone: [
            44
        ],
        continent: "EU",
        capital: "London",
        currency: [
            "GBP"
        ],
        languages: [
            "en"
        ]
    },
    GD: {
        name: "Grenada",
        native: "Grenada",
        phone: [
            1473
        ],
        continent: "NA",
        capital: "St. George's",
        currency: [
            "XCD"
        ],
        languages: [
            "en"
        ]
    },
    GE: {
        name: "Georgia",
        native: "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD",
        phone: [
            995
        ],
        continent: "AS",
        continents: [
            "AS",
            "EU"
        ],
        capital: "Tbilisi",
        currency: [
            "GEL"
        ],
        languages: [
            "ka"
        ]
    },
    GF: {
        name: "French Guiana",
        native: "Guyane fran\xe7aise",
        phone: [
            594
        ],
        continent: "SA",
        capital: "Cayenne",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    GG: {
        name: "Guernsey",
        native: "Guernsey",
        phone: [
            44
        ],
        continent: "EU",
        capital: "St. Peter Port",
        currency: [
            "GBP"
        ],
        languages: [
            "en",
            "fr"
        ]
    },
    GH: {
        name: "Ghana",
        native: "Ghana",
        phone: [
            233
        ],
        continent: "AF",
        capital: "Accra",
        currency: [
            "GHS"
        ],
        languages: [
            "en"
        ]
    },
    GI: {
        name: "Gibraltar",
        native: "Gibraltar",
        phone: [
            350
        ],
        continent: "EU",
        capital: "Gibraltar",
        currency: [
            "GIP"
        ],
        languages: [
            "en"
        ]
    },
    GL: {
        name: "Greenland",
        native: "Kalaallit Nunaat",
        phone: [
            299
        ],
        continent: "NA",
        capital: "Nuuk",
        currency: [
            "DKK"
        ],
        languages: [
            "kl"
        ]
    },
    GM: {
        name: "Gambia",
        native: "Gambia",
        phone: [
            220
        ],
        continent: "AF",
        capital: "Banjul",
        currency: [
            "GMD"
        ],
        languages: [
            "en"
        ]
    },
    GN: {
        name: "Guinea",
        native: "Guin\xe9e",
        phone: [
            224
        ],
        continent: "AF",
        capital: "Conakry",
        currency: [
            "GNF"
        ],
        languages: [
            "fr",
            "ff"
        ]
    },
    GP: {
        name: "Guadeloupe",
        native: "Guadeloupe",
        phone: [
            590
        ],
        continent: "NA",
        capital: "Basse-Terre",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    GQ: {
        name: "Equatorial Guinea",
        native: "Guinea Ecuatorial",
        phone: [
            240
        ],
        continent: "AF",
        capital: "Malabo",
        currency: [
            "XAF"
        ],
        languages: [
            "es",
            "fr"
        ]
    },
    GR: {
        name: "Greece",
        native: "\u0395\u03BB\u03BB\u03AC\u03B4\u03B1",
        phone: [
            30
        ],
        continent: "EU",
        capital: "Athens",
        currency: [
            "EUR"
        ],
        languages: [
            "el"
        ]
    },
    GS: {
        name: "South Georgia and the South Sandwich Islands",
        native: "South Georgia",
        phone: [
            500
        ],
        continent: "AN",
        capital: "King Edward Point",
        currency: [
            "GBP"
        ],
        languages: [
            "en"
        ]
    },
    GT: {
        name: "Guatemala",
        native: "Guatemala",
        phone: [
            502
        ],
        continent: "NA",
        capital: "Guatemala City",
        currency: [
            "GTQ"
        ],
        languages: [
            "es"
        ]
    },
    GU: {
        name: "Guam",
        native: "Guam",
        phone: [
            1671
        ],
        continent: "OC",
        capital: "Hag\xe5t\xf1a",
        currency: [
            "USD"
        ],
        languages: [
            "en",
            "ch",
            "es"
        ]
    },
    GW: {
        name: "Guinea-Bissau",
        native: "Guin\xe9-Bissau",
        phone: [
            245
        ],
        continent: "AF",
        capital: "Bissau",
        currency: [
            "XOF"
        ],
        languages: [
            "pt"
        ]
    },
    GY: {
        name: "Guyana",
        native: "Guyana",
        phone: [
            592
        ],
        continent: "SA",
        capital: "Georgetown",
        currency: [
            "GYD"
        ],
        languages: [
            "en"
        ]
    },
    HK: {
        name: "Hong Kong",
        native: "\u9999\u6E2F",
        phone: [
            852
        ],
        continent: "AS",
        capital: "City of Victoria",
        currency: [
            "HKD"
        ],
        languages: [
            "zh",
            "en"
        ]
    },
    HM: {
        name: "Heard Island and McDonald Islands",
        native: "Heard Island and McDonald Islands",
        phone: [
            61
        ],
        continent: "AN",
        capital: "",
        currency: [
            "AUD"
        ],
        languages: [
            "en"
        ]
    },
    HN: {
        name: "Honduras",
        native: "Honduras",
        phone: [
            504
        ],
        continent: "NA",
        capital: "Tegucigalpa",
        currency: [
            "HNL"
        ],
        languages: [
            "es"
        ]
    },
    HR: {
        name: "Croatia",
        native: "Hrvatska",
        phone: [
            385
        ],
        continent: "EU",
        capital: "Zagreb",
        currency: [
            "EUR"
        ],
        languages: [
            "hr"
        ]
    },
    HT: {
        name: "Haiti",
        native: "Ha\xefti",
        phone: [
            509
        ],
        continent: "NA",
        capital: "Port-au-Prince",
        currency: [
            "HTG",
            "USD"
        ],
        languages: [
            "fr",
            "ht"
        ]
    },
    HU: {
        name: "Hungary",
        native: "Magyarorsz\xe1g",
        phone: [
            36
        ],
        continent: "EU",
        capital: "Budapest",
        currency: [
            "HUF"
        ],
        languages: [
            "hu"
        ]
    },
    ID: {
        name: "Indonesia",
        native: "Indonesia",
        phone: [
            62
        ],
        continent: "AS",
        capital: "Jakarta",
        currency: [
            "IDR"
        ],
        languages: [
            "id"
        ]
    },
    IE: {
        name: "Ireland",
        native: "\xc9ire",
        phone: [
            353
        ],
        continent: "EU",
        capital: "Dublin",
        currency: [
            "EUR"
        ],
        languages: [
            "ga",
            "en"
        ]
    },
    IL: {
        name: "Israel",
        native: "\u05D9\u05B4\u05E9\u05B0\u05C2\u05E8\u05B8\u05D0\u05B5\u05DC",
        phone: [
            972
        ],
        continent: "AS",
        capital: "Jerusalem",
        currency: [
            "ILS"
        ],
        languages: [
            "he",
            "ar"
        ]
    },
    IM: {
        name: "Isle of Man",
        native: "Isle of Man",
        phone: [
            44
        ],
        continent: "EU",
        capital: "Douglas",
        currency: [
            "GBP"
        ],
        languages: [
            "en",
            "gv"
        ]
    },
    IN: {
        name: "India",
        native: "\u092D\u093E\u0930\u0924",
        phone: [
            91
        ],
        continent: "AS",
        capital: "New Delhi",
        currency: [
            "INR"
        ],
        languages: [
            "hi",
            "en"
        ]
    },
    IO: {
        name: "British Indian Ocean Territory",
        native: "British Indian Ocean Territory",
        phone: [
            246
        ],
        continent: "AS",
        capital: "Diego Garcia",
        currency: [
            "USD"
        ],
        languages: [
            "en"
        ]
    },
    IQ: {
        name: "Iraq",
        native: "\u0627\u0644\u0639\u0631\u0627\u0642",
        phone: [
            964
        ],
        continent: "AS",
        capital: "Baghdad",
        currency: [
            "IQD"
        ],
        languages: [
            "ar",
            "ku"
        ]
    },
    IR: {
        name: "Iran",
        native: "\u0627\u06CC\u0631\u0627\u0646",
        phone: [
            98
        ],
        continent: "AS",
        capital: "Tehran",
        currency: [
            "IRR"
        ],
        languages: [
            "fa"
        ]
    },
    IS: {
        name: "Iceland",
        native: "\xcdsland",
        phone: [
            354
        ],
        continent: "EU",
        capital: "Reykjavik",
        currency: [
            "ISK"
        ],
        languages: [
            "is"
        ]
    },
    IT: {
        name: "Italy",
        native: "Italia",
        phone: [
            39
        ],
        continent: "EU",
        capital: "Rome",
        currency: [
            "EUR"
        ],
        languages: [
            "it"
        ]
    },
    JE: {
        name: "Jersey",
        native: "Jersey",
        phone: [
            44
        ],
        continent: "EU",
        capital: "Saint Helier",
        currency: [
            "GBP"
        ],
        languages: [
            "en",
            "fr"
        ]
    },
    JM: {
        name: "Jamaica",
        native: "Jamaica",
        phone: [
            1876
        ],
        continent: "NA",
        capital: "Kingston",
        currency: [
            "JMD"
        ],
        languages: [
            "en"
        ]
    },
    JO: {
        name: "Jordan",
        native: "\u0627\u0644\u0623\u0631\u062F\u0646",
        phone: [
            962
        ],
        continent: "AS",
        capital: "Amman",
        currency: [
            "JOD"
        ],
        languages: [
            "ar"
        ]
    },
    JP: {
        name: "Japan",
        native: "\u65E5\u672C",
        phone: [
            81
        ],
        continent: "AS",
        capital: "Tokyo",
        currency: [
            "JPY"
        ],
        languages: [
            "ja"
        ]
    },
    KE: {
        name: "Kenya",
        native: "Kenya",
        phone: [
            254
        ],
        continent: "AF",
        capital: "Nairobi",
        currency: [
            "KES"
        ],
        languages: [
            "en",
            "sw"
        ]
    },
    KG: {
        name: "Kyrgyzstan",
        native: "\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D",
        phone: [
            996
        ],
        continent: "AS",
        capital: "Bishkek",
        currency: [
            "KGS"
        ],
        languages: [
            "ky",
            "ru"
        ]
    },
    KH: {
        name: "Cambodia",
        native: "K\xe2mp\u016Dch\xe9a",
        phone: [
            855
        ],
        continent: "AS",
        capital: "Phnom Penh",
        currency: [
            "KHR"
        ],
        languages: [
            "km"
        ]
    },
    KI: {
        name: "Kiribati",
        native: "Kiribati",
        phone: [
            686
        ],
        continent: "OC",
        capital: "South Tarawa",
        currency: [
            "AUD"
        ],
        languages: [
            "en"
        ]
    },
    KM: {
        name: "Comoros",
        native: "Komori",
        phone: [
            269
        ],
        continent: "AF",
        capital: "Moroni",
        currency: [
            "KMF"
        ],
        languages: [
            "ar",
            "fr"
        ]
    },
    KN: {
        name: "Saint Kitts and Nevis",
        native: "Saint Kitts and Nevis",
        phone: [
            1869
        ],
        continent: "NA",
        capital: "Basseterre",
        currency: [
            "XCD"
        ],
        languages: [
            "en"
        ]
    },
    KP: {
        name: "North Korea",
        native: "\uBD81\uD55C",
        phone: [
            850
        ],
        continent: "AS",
        capital: "Pyongyang",
        currency: [
            "KPW"
        ],
        languages: [
            "ko"
        ]
    },
    KR: {
        name: "South Korea",
        native: "\uB300\uD55C\uBBFC\uAD6D",
        phone: [
            82
        ],
        continent: "AS",
        capital: "Seoul",
        currency: [
            "KRW"
        ],
        languages: [
            "ko"
        ]
    },
    KW: {
        name: "Kuwait",
        native: "\u0627\u0644\u0643\u0648\u064A\u062A",
        phone: [
            965
        ],
        continent: "AS",
        capital: "Kuwait City",
        currency: [
            "KWD"
        ],
        languages: [
            "ar"
        ]
    },
    KY: {
        name: "Cayman Islands",
        native: "Cayman Islands",
        phone: [
            1345
        ],
        continent: "NA",
        capital: "George Town",
        currency: [
            "KYD"
        ],
        languages: [
            "en"
        ]
    },
    KZ: {
        name: "Kazakhstan",
        native: "\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D",
        phone: [
            7
        ],
        continent: "AS",
        continents: [
            "AS",
            "EU"
        ],
        capital: "Astana",
        currency: [
            "KZT"
        ],
        languages: [
            "kk",
            "ru"
        ]
    },
    LA: {
        name: "Laos",
        native: "\u0EAA\u0E9B\u0E9B\u0EA5\u0EB2\u0EA7",
        phone: [
            856
        ],
        continent: "AS",
        capital: "Vientiane",
        currency: [
            "LAK"
        ],
        languages: [
            "lo"
        ]
    },
    LB: {
        name: "Lebanon",
        native: "\u0644\u0628\u0646\u0627\u0646",
        phone: [
            961
        ],
        continent: "AS",
        capital: "Beirut",
        currency: [
            "LBP"
        ],
        languages: [
            "ar",
            "fr"
        ]
    },
    LC: {
        name: "Saint Lucia",
        native: "Saint Lucia",
        phone: [
            1758
        ],
        continent: "NA",
        capital: "Castries",
        currency: [
            "XCD"
        ],
        languages: [
            "en"
        ]
    },
    LI: {
        name: "Liechtenstein",
        native: "Liechtenstein",
        phone: [
            423
        ],
        continent: "EU",
        capital: "Vaduz",
        currency: [
            "CHF"
        ],
        languages: [
            "de"
        ]
    },
    LK: {
        name: "Sri Lanka",
        native: "\u015Br\u012B la\u1E43k\u0101va",
        phone: [
            94
        ],
        continent: "AS",
        capital: "Colombo",
        currency: [
            "LKR"
        ],
        languages: [
            "si",
            "ta"
        ]
    },
    LR: {
        name: "Liberia",
        native: "Liberia",
        phone: [
            231
        ],
        continent: "AF",
        capital: "Monrovia",
        currency: [
            "LRD"
        ],
        languages: [
            "en"
        ]
    },
    LS: {
        name: "Lesotho",
        native: "Lesotho",
        phone: [
            266
        ],
        continent: "AF",
        capital: "Maseru",
        currency: [
            "LSL",
            "ZAR"
        ],
        languages: [
            "en",
            "st"
        ]
    },
    LT: {
        name: "Lithuania",
        native: "Lietuva",
        phone: [
            370
        ],
        continent: "EU",
        capital: "Vilnius",
        currency: [
            "EUR"
        ],
        languages: [
            "lt"
        ]
    },
    LU: {
        name: "Luxembourg",
        native: "Luxembourg",
        phone: [
            352
        ],
        continent: "EU",
        capital: "Luxembourg",
        currency: [
            "EUR"
        ],
        languages: [
            "fr",
            "de",
            "lb"
        ]
    },
    LV: {
        name: "Latvia",
        native: "Latvija",
        phone: [
            371
        ],
        continent: "EU",
        capital: "Riga",
        currency: [
            "EUR"
        ],
        languages: [
            "lv"
        ]
    },
    LY: {
        name: "Libya",
        native: "\u200F\u0644\u064A\u0628\u064A\u0627",
        phone: [
            218
        ],
        continent: "AF",
        capital: "Tripoli",
        currency: [
            "LYD"
        ],
        languages: [
            "ar"
        ]
    },
    MA: {
        name: "Morocco",
        native: "\u0627\u0644\u0645\u063A\u0631\u0628",
        phone: [
            212
        ],
        continent: "AF",
        capital: "Rabat",
        currency: [
            "MAD"
        ],
        languages: [
            "ar"
        ]
    },
    MC: {
        name: "Monaco",
        native: "Monaco",
        phone: [
            377
        ],
        continent: "EU",
        capital: "Monaco",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    MD: {
        name: "Moldova",
        native: "Moldova",
        phone: [
            373
        ],
        continent: "EU",
        capital: "Chi\u0219in\u0103u",
        currency: [
            "MDL"
        ],
        languages: [
            "ro"
        ]
    },
    ME: {
        name: "Montenegro",
        native: "\u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430",
        phone: [
            382
        ],
        continent: "EU",
        capital: "Podgorica",
        currency: [
            "EUR"
        ],
        languages: [
            "sr",
            "bs",
            "sq",
            "hr"
        ]
    },
    MF: {
        name: "Saint Martin",
        native: "Saint-Martin",
        phone: [
            590
        ],
        continent: "NA",
        capital: "Marigot",
        currency: [
            "EUR"
        ],
        languages: [
            "en",
            "fr",
            "nl"
        ]
    },
    MG: {
        name: "Madagascar",
        native: "Madagasikara",
        phone: [
            261
        ],
        continent: "AF",
        capital: "Antananarivo",
        currency: [
            "MGA"
        ],
        languages: [
            "fr",
            "mg"
        ]
    },
    MH: {
        name: "Marshall Islands",
        native: "M\u0327aje\u013C",
        phone: [
            692
        ],
        continent: "OC",
        capital: "Majuro",
        currency: [
            "USD"
        ],
        languages: [
            "en",
            "mh"
        ]
    },
    MK: {
        name: "North Macedonia",
        native: "\u0421\u0435\u0432\u0435\u0440\u043D\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430",
        phone: [
            389
        ],
        continent: "EU",
        capital: "Skopje",
        currency: [
            "MKD"
        ],
        languages: [
            "mk"
        ]
    },
    ML: {
        name: "Mali",
        native: "Mali",
        phone: [
            223
        ],
        continent: "AF",
        capital: "Bamako",
        currency: [
            "XOF"
        ],
        languages: [
            "fr"
        ]
    },
    MM: {
        name: "Myanmar (Burma)",
        native: "\u1019\u103C\u1014\u103A\u1019\u102C",
        phone: [
            95
        ],
        continent: "AS",
        capital: "Naypyidaw",
        currency: [
            "MMK"
        ],
        languages: [
            "my"
        ]
    },
    MN: {
        name: "Mongolia",
        native: "\u041C\u043E\u043D\u0433\u043E\u043B \u0443\u043B\u0441",
        phone: [
            976
        ],
        continent: "AS",
        capital: "Ulan Bator",
        currency: [
            "MNT"
        ],
        languages: [
            "mn"
        ]
    },
    MO: {
        name: "Macao",
        native: "\u6FB3\u9580",
        phone: [
            853
        ],
        continent: "AS",
        capital: "",
        currency: [
            "MOP"
        ],
        languages: [
            "zh",
            "pt"
        ]
    },
    MP: {
        name: "Northern Mariana Islands",
        native: "Northern Mariana Islands",
        phone: [
            1670
        ],
        continent: "OC",
        capital: "Saipan",
        currency: [
            "USD"
        ],
        languages: [
            "en",
            "ch"
        ]
    },
    MQ: {
        name: "Martinique",
        native: "Martinique",
        phone: [
            596
        ],
        continent: "NA",
        capital: "Fort-de-France",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    MR: {
        name: "Mauritania",
        native: "\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627",
        phone: [
            222
        ],
        continent: "AF",
        capital: "Nouakchott",
        currency: [
            "MRU"
        ],
        languages: [
            "ar"
        ]
    },
    MS: {
        name: "Montserrat",
        native: "Montserrat",
        phone: [
            1664
        ],
        continent: "NA",
        capital: "Plymouth",
        currency: [
            "XCD"
        ],
        languages: [
            "en"
        ]
    },
    MT: {
        name: "Malta",
        native: "Malta",
        phone: [
            356
        ],
        continent: "EU",
        capital: "Valletta",
        currency: [
            "EUR"
        ],
        languages: [
            "mt",
            "en"
        ]
    },
    MU: {
        name: "Mauritius",
        native: "Maurice",
        phone: [
            230
        ],
        continent: "AF",
        capital: "Port Louis",
        currency: [
            "MUR"
        ],
        languages: [
            "en"
        ]
    },
    MV: {
        name: "Maldives",
        native: "Maldives",
        phone: [
            960
        ],
        continent: "AS",
        capital: "Mal\xe9",
        currency: [
            "MVR"
        ],
        languages: [
            "dv"
        ]
    },
    MW: {
        name: "Malawi",
        native: "Malawi",
        phone: [
            265
        ],
        continent: "AF",
        capital: "Lilongwe",
        currency: [
            "MWK"
        ],
        languages: [
            "en",
            "ny"
        ]
    },
    MX: {
        name: "Mexico",
        native: "M\xe9xico",
        phone: [
            52
        ],
        continent: "NA",
        capital: "Mexico City",
        currency: [
            "MXN"
        ],
        languages: [
            "es"
        ]
    },
    MY: {
        name: "Malaysia",
        native: "Malaysia",
        phone: [
            60
        ],
        continent: "AS",
        capital: "Kuala Lumpur",
        currency: [
            "MYR"
        ],
        languages: [
            "ms"
        ]
    },
    MZ: {
        name: "Mozambique",
        native: "Mo\xe7ambique",
        phone: [
            258
        ],
        continent: "AF",
        capital: "Maputo",
        currency: [
            "MZN"
        ],
        languages: [
            "pt"
        ]
    },
    NA: {
        name: "Namibia",
        native: "Namibia",
        phone: [
            264
        ],
        continent: "AF",
        capital: "Windhoek",
        currency: [
            "NAD",
            "ZAR"
        ],
        languages: [
            "en",
            "af"
        ]
    },
    NC: {
        name: "New Caledonia",
        native: "Nouvelle-Cal\xe9donie",
        phone: [
            687
        ],
        continent: "OC",
        capital: "Noum\xe9a",
        currency: [
            "XPF"
        ],
        languages: [
            "fr"
        ]
    },
    NE: {
        name: "Niger",
        native: "Niger",
        phone: [
            227
        ],
        continent: "AF",
        capital: "Niamey",
        currency: [
            "XOF"
        ],
        languages: [
            "fr"
        ]
    },
    NF: {
        name: "Norfolk Island",
        native: "Norfolk Island",
        phone: [
            672
        ],
        continent: "OC",
        capital: "Kingston",
        currency: [
            "AUD"
        ],
        languages: [
            "en"
        ]
    },
    NG: {
        name: "Nigeria",
        native: "Nigeria",
        phone: [
            234
        ],
        continent: "AF",
        capital: "Abuja",
        currency: [
            "NGN"
        ],
        languages: [
            "en"
        ]
    },
    NI: {
        name: "Nicaragua",
        native: "Nicaragua",
        phone: [
            505
        ],
        continent: "NA",
        capital: "Managua",
        currency: [
            "NIO"
        ],
        languages: [
            "es"
        ]
    },
    NL: {
        name: "Netherlands",
        native: "Nederland",
        phone: [
            31
        ],
        continent: "EU",
        capital: "Amsterdam",
        currency: [
            "EUR"
        ],
        languages: [
            "nl"
        ]
    },
    NO: {
        name: "Norway",
        native: "Norge",
        phone: [
            47
        ],
        continent: "EU",
        capital: "Oslo",
        currency: [
            "NOK"
        ],
        languages: [
            "no",
            "nb",
            "nn"
        ]
    },
    NP: {
        name: "Nepal",
        native: "\u0928\u0947\u092A\u093E\u0932",
        phone: [
            977
        ],
        continent: "AS",
        capital: "Kathmandu",
        currency: [
            "NPR"
        ],
        languages: [
            "ne"
        ]
    },
    NR: {
        name: "Nauru",
        native: "Nauru",
        phone: [
            674
        ],
        continent: "OC",
        capital: "Yaren",
        currency: [
            "AUD"
        ],
        languages: [
            "en",
            "na"
        ]
    },
    NU: {
        name: "Niue",
        native: "Niu\u0113",
        phone: [
            683
        ],
        continent: "OC",
        capital: "Alofi",
        currency: [
            "NZD"
        ],
        languages: [
            "en"
        ]
    },
    NZ: {
        name: "New Zealand",
        native: "New Zealand",
        phone: [
            64
        ],
        continent: "OC",
        capital: "Wellington",
        currency: [
            "NZD"
        ],
        languages: [
            "en",
            "mi"
        ]
    },
    OM: {
        name: "Oman",
        native: "\u0639\u0645\u0627\u0646",
        phone: [
            968
        ],
        continent: "AS",
        capital: "Muscat",
        currency: [
            "OMR"
        ],
        languages: [
            "ar"
        ]
    },
    PA: {
        name: "Panama",
        native: "Panam\xe1",
        phone: [
            507
        ],
        continent: "NA",
        capital: "Panama City",
        currency: [
            "PAB",
            "USD"
        ],
        languages: [
            "es"
        ]
    },
    PE: {
        name: "Peru",
        native: "Per\xfa",
        phone: [
            51
        ],
        continent: "SA",
        capital: "Lima",
        currency: [
            "PEN"
        ],
        languages: [
            "es"
        ]
    },
    PF: {
        name: "French Polynesia",
        native: "Polyn\xe9sie fran\xe7aise",
        phone: [
            689
        ],
        continent: "OC",
        capital: "Papeet\u0113",
        currency: [
            "XPF"
        ],
        languages: [
            "fr"
        ]
    },
    PG: {
        name: "Papua New Guinea",
        native: "Papua Niugini",
        phone: [
            675
        ],
        continent: "OC",
        capital: "Port Moresby",
        currency: [
            "PGK"
        ],
        languages: [
            "en"
        ]
    },
    PH: {
        name: "Philippines",
        native: "Pilipinas",
        phone: [
            63
        ],
        continent: "AS",
        capital: "Manila",
        currency: [
            "PHP"
        ],
        languages: [
            "en"
        ]
    },
    PK: {
        name: "Pakistan",
        native: "Pakistan",
        phone: [
            92
        ],
        continent: "AS",
        capital: "Islamabad",
        currency: [
            "PKR"
        ],
        languages: [
            "en",
            "ur"
        ]
    },
    PL: {
        name: "Poland",
        native: "Polska",
        phone: [
            48
        ],
        continent: "EU",
        capital: "Warsaw",
        currency: [
            "PLN"
        ],
        languages: [
            "pl"
        ]
    },
    PM: {
        name: "Saint Pierre and Miquelon",
        native: "Saint-Pierre-et-Miquelon",
        phone: [
            508
        ],
        continent: "NA",
        capital: "Saint-Pierre",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    PN: {
        name: "Pitcairn Islands",
        native: "Pitcairn Islands",
        phone: [
            64
        ],
        continent: "OC",
        capital: "Adamstown",
        currency: [
            "NZD"
        ],
        languages: [
            "en"
        ]
    },
    PR: {
        name: "Puerto Rico",
        native: "Puerto Rico",
        phone: [
            1787,
            1939
        ],
        continent: "NA",
        capital: "San Juan",
        currency: [
            "USD"
        ],
        languages: [
            "es",
            "en"
        ]
    },
    PS: {
        name: "Palestine",
        native: "\u0641\u0644\u0633\u0637\u064A\u0646",
        phone: [
            970
        ],
        continent: "AS",
        capital: "Ramallah",
        currency: [
            "ILS"
        ],
        languages: [
            "ar"
        ]
    },
    PT: {
        name: "Portugal",
        native: "Portugal",
        phone: [
            351
        ],
        continent: "EU",
        capital: "Lisbon",
        currency: [
            "EUR"
        ],
        languages: [
            "pt"
        ]
    },
    PW: {
        name: "Palau",
        native: "Palau",
        phone: [
            680
        ],
        continent: "OC",
        capital: "Ngerulmud",
        currency: [
            "USD"
        ],
        languages: [
            "en"
        ]
    },
    PY: {
        name: "Paraguay",
        native: "Paraguay",
        phone: [
            595
        ],
        continent: "SA",
        capital: "Asunci\xf3n",
        currency: [
            "PYG"
        ],
        languages: [
            "es",
            "gn"
        ]
    },
    QA: {
        name: "Qatar",
        native: "\u0642\u0637\u0631",
        phone: [
            974
        ],
        continent: "AS",
        capital: "Doha",
        currency: [
            "QAR"
        ],
        languages: [
            "ar"
        ]
    },
    RE: {
        name: "Reunion",
        native: "La R\xe9union",
        phone: [
            262
        ],
        continent: "AF",
        capital: "Saint-Denis",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    RO: {
        name: "Romania",
        native: "Rom\xe2nia",
        phone: [
            40
        ],
        continent: "EU",
        capital: "Bucharest",
        currency: [
            "RON"
        ],
        languages: [
            "ro"
        ]
    },
    RS: {
        name: "Serbia",
        native: "\u0421\u0440\u0431\u0438\u0458\u0430",
        phone: [
            381
        ],
        continent: "EU",
        capital: "Belgrade",
        currency: [
            "RSD"
        ],
        languages: [
            "sr"
        ]
    },
    RU: {
        name: "Russia",
        native: "\u0420\u043E\u0441\u0441\u0438\u044F",
        phone: [
            7
        ],
        continent: "AS",
        continents: [
            "AS",
            "EU"
        ],
        capital: "Moscow",
        currency: [
            "RUB"
        ],
        languages: [
            "ru"
        ]
    },
    RW: {
        name: "Rwanda",
        native: "Rwanda",
        phone: [
            250
        ],
        continent: "AF",
        capital: "Kigali",
        currency: [
            "RWF"
        ],
        languages: [
            "rw",
            "en",
            "fr"
        ]
    },
    SA: {
        name: "Saudi Arabia",
        native: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629",
        phone: [
            966
        ],
        continent: "AS",
        capital: "Riyadh",
        currency: [
            "SAR"
        ],
        languages: [
            "ar"
        ]
    },
    SB: {
        name: "Solomon Islands",
        native: "Solomon Islands",
        phone: [
            677
        ],
        continent: "OC",
        capital: "Honiara",
        currency: [
            "SBD"
        ],
        languages: [
            "en"
        ]
    },
    SC: {
        name: "Seychelles",
        native: "Seychelles",
        phone: [
            248
        ],
        continent: "AF",
        capital: "Victoria",
        currency: [
            "SCR"
        ],
        languages: [
            "fr",
            "en"
        ]
    },
    SD: {
        name: "Sudan",
        native: "\u0627\u0644\u0633\u0648\u062F\u0627\u0646",
        phone: [
            249
        ],
        continent: "AF",
        capital: "Khartoum",
        currency: [
            "SDG"
        ],
        languages: [
            "ar",
            "en"
        ]
    },
    SE: {
        name: "Sweden",
        native: "Sverige",
        phone: [
            46
        ],
        continent: "EU",
        capital: "Stockholm",
        currency: [
            "SEK"
        ],
        languages: [
            "sv"
        ]
    },
    SG: {
        name: "Singapore",
        native: "Singapore",
        phone: [
            65
        ],
        continent: "AS",
        capital: "Singapore",
        currency: [
            "SGD"
        ],
        languages: [
            "en",
            "ms",
            "ta",
            "zh"
        ]
    },
    SH: {
        name: "Saint Helena",
        native: "Saint Helena",
        phone: [
            290
        ],
        continent: "AF",
        capital: "Jamestown",
        currency: [
            "SHP"
        ],
        languages: [
            "en"
        ]
    },
    SI: {
        name: "Slovenia",
        native: "Slovenija",
        phone: [
            386
        ],
        continent: "EU",
        capital: "Ljubljana",
        currency: [
            "EUR"
        ],
        languages: [
            "sl"
        ]
    },
    SJ: {
        name: "Svalbard and Jan Mayen",
        native: "Svalbard og Jan Mayen",
        phone: [
            4779
        ],
        continent: "EU",
        capital: "Longyearbyen",
        currency: [
            "NOK"
        ],
        languages: [
            "no"
        ]
    },
    SK: {
        name: "Slovakia",
        native: "Slovensko",
        phone: [
            421
        ],
        continent: "EU",
        capital: "Bratislava",
        currency: [
            "EUR"
        ],
        languages: [
            "sk"
        ]
    },
    SL: {
        name: "Sierra Leone",
        native: "Sierra Leone",
        phone: [
            232
        ],
        continent: "AF",
        capital: "Freetown",
        currency: [
            "SLL"
        ],
        languages: [
            "en"
        ]
    },
    SM: {
        name: "San Marino",
        native: "San Marino",
        phone: [
            378
        ],
        continent: "EU",
        capital: "City of San Marino",
        currency: [
            "EUR"
        ],
        languages: [
            "it"
        ]
    },
    SN: {
        name: "Senegal",
        native: "S\xe9n\xe9gal",
        phone: [
            221
        ],
        continent: "AF",
        capital: "Dakar",
        currency: [
            "XOF"
        ],
        languages: [
            "fr"
        ]
    },
    SO: {
        name: "Somalia",
        native: "Soomaaliya",
        phone: [
            252
        ],
        continent: "AF",
        capital: "Mogadishu",
        currency: [
            "SOS"
        ],
        languages: [
            "so",
            "ar"
        ]
    },
    SR: {
        name: "Suriname",
        native: "Suriname",
        phone: [
            597
        ],
        continent: "SA",
        capital: "Paramaribo",
        currency: [
            "SRD"
        ],
        languages: [
            "nl"
        ]
    },
    SS: {
        name: "South Sudan",
        native: "South Sudan",
        phone: [
            211
        ],
        continent: "AF",
        capital: "Juba",
        currency: [
            "SSP"
        ],
        languages: [
            "en"
        ]
    },
    ST: {
        name: "Sao Tome and Principe",
        native: "S\xe3o Tom\xe9 e Pr\xedncipe",
        phone: [
            239
        ],
        continent: "AF",
        capital: "S\xe3o Tom\xe9",
        currency: [
            "STN"
        ],
        languages: [
            "pt"
        ]
    },
    SV: {
        name: "El Salvador",
        native: "El Salvador",
        phone: [
            503
        ],
        continent: "NA",
        capital: "San Salvador",
        currency: [
            "SVC",
            "USD"
        ],
        languages: [
            "es"
        ]
    },
    SX: {
        name: "Sint Maarten",
        native: "Sint Maarten",
        phone: [
            1721
        ],
        continent: "NA",
        capital: "Philipsburg",
        currency: [
            "ANG"
        ],
        languages: [
            "nl",
            "en"
        ]
    },
    SY: {
        name: "Syria",
        native: "\u0633\u0648\u0631\u064A\u0627",
        phone: [
            963
        ],
        continent: "AS",
        capital: "Damascus",
        currency: [
            "SYP"
        ],
        languages: [
            "ar"
        ]
    },
    SZ: {
        name: "Eswatini",
        native: "Eswatini",
        phone: [
            268
        ],
        continent: "AF",
        capital: "Lobamba",
        currency: [
            "SZL"
        ],
        languages: [
            "en",
            "ss"
        ]
    },
    TC: {
        name: "Turks and Caicos Islands",
        native: "Turks and Caicos Islands",
        phone: [
            1649
        ],
        continent: "NA",
        capital: "Cockburn Town",
        currency: [
            "USD"
        ],
        languages: [
            "en"
        ]
    },
    TD: {
        name: "Chad",
        native: "Tchad",
        phone: [
            235
        ],
        continent: "AF",
        capital: "N'Djamena",
        currency: [
            "XAF"
        ],
        languages: [
            "fr",
            "ar"
        ]
    },
    TF: {
        name: "French Southern Territories",
        native: "Territoire des Terres australes et antarctiques fr",
        phone: [
            262
        ],
        continent: "AN",
        capital: "Port-aux-Fran\xe7ais",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    TG: {
        name: "Togo",
        native: "Togo",
        phone: [
            228
        ],
        continent: "AF",
        capital: "Lom\xe9",
        currency: [
            "XOF"
        ],
        languages: [
            "fr"
        ]
    },
    TH: {
        name: "Thailand",
        native: "\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22",
        phone: [
            66
        ],
        continent: "AS",
        capital: "Bangkok",
        currency: [
            "THB"
        ],
        languages: [
            "th"
        ]
    },
    TJ: {
        name: "Tajikistan",
        native: "\u0422\u043E\u04B7\u0438\u043A\u0438\u0441\u0442\u043E\u043D",
        phone: [
            992
        ],
        continent: "AS",
        capital: "Dushanbe",
        currency: [
            "TJS"
        ],
        languages: [
            "tg",
            "ru"
        ]
    },
    TK: {
        name: "Tokelau",
        native: "Tokelau",
        phone: [
            690
        ],
        continent: "OC",
        capital: "Fakaofo",
        currency: [
            "NZD"
        ],
        languages: [
            "en"
        ]
    },
    TL: {
        name: "East Timor",
        native: "Timor-Leste",
        phone: [
            670
        ],
        continent: "OC",
        capital: "Dili",
        currency: [
            "USD"
        ],
        languages: [
            "pt"
        ]
    },
    TM: {
        name: "Turkmenistan",
        native: "T\xfcrkmenistan",
        phone: [
            993
        ],
        continent: "AS",
        capital: "Ashgabat",
        currency: [
            "TMT"
        ],
        languages: [
            "tk",
            "ru"
        ]
    },
    TN: {
        name: "Tunisia",
        native: "\u062A\u0648\u0646\u0633",
        phone: [
            216
        ],
        continent: "AF",
        capital: "Tunis",
        currency: [
            "TND"
        ],
        languages: [
            "ar"
        ]
    },
    TO: {
        name: "Tonga",
        native: "Tonga",
        phone: [
            676
        ],
        continent: "OC",
        capital: "Nuku'alofa",
        currency: [
            "TOP"
        ],
        languages: [
            "en",
            "to"
        ]
    },
    TR: {
        name: "Turkey",
        native: "T\xfcrkiye",
        phone: [
            90
        ],
        continent: "AS",
        continents: [
            "AS",
            "EU"
        ],
        capital: "Ankara",
        currency: [
            "TRY"
        ],
        languages: [
            "tr"
        ]
    },
    TT: {
        name: "Trinidad and Tobago",
        native: "Trinidad and Tobago",
        phone: [
            1868
        ],
        continent: "NA",
        capital: "Port of Spain",
        currency: [
            "TTD"
        ],
        languages: [
            "en"
        ]
    },
    TV: {
        name: "Tuvalu",
        native: "Tuvalu",
        phone: [
            688
        ],
        continent: "OC",
        capital: "Funafuti",
        currency: [
            "AUD"
        ],
        languages: [
            "en"
        ]
    },
    TW: {
        name: "Taiwan",
        native: "\u81FA\u7063",
        phone: [
            886
        ],
        continent: "AS",
        capital: "Taipei",
        currency: [
            "TWD"
        ],
        languages: [
            "zh"
        ]
    },
    TZ: {
        name: "Tanzania",
        native: "Tanzania",
        phone: [
            255
        ],
        continent: "AF",
        capital: "Dodoma",
        currency: [
            "TZS"
        ],
        languages: [
            "sw",
            "en"
        ]
    },
    UA: {
        name: "Ukraine",
        native: "\u0423\u043A\u0440\u0430\u0457\u043D\u0430",
        phone: [
            380
        ],
        continent: "EU",
        capital: "Kyiv",
        currency: [
            "UAH"
        ],
        languages: [
            "uk"
        ]
    },
    UG: {
        name: "Uganda",
        native: "Uganda",
        phone: [
            256
        ],
        continent: "AF",
        capital: "Kampala",
        currency: [
            "UGX"
        ],
        languages: [
            "en",
            "sw"
        ]
    },
    UM: {
        name: "U.S. Minor Outlying Islands",
        native: "United States Minor Outlying Islands",
        phone: [
            1
        ],
        continent: "OC",
        capital: "",
        currency: [
            "USD"
        ],
        languages: [
            "en"
        ]
    },
    US: {
        name: "United States",
        native: "United States",
        phone: [
            1
        ],
        continent: "NA",
        capital: "Washington D.C.",
        currency: [
            "USD",
            "USN",
            "USS"
        ],
        languages: [
            "en"
        ]
    },
    UY: {
        name: "Uruguay",
        native: "Uruguay",
        phone: [
            598
        ],
        continent: "SA",
        capital: "Montevideo",
        currency: [
            "UYI",
            "UYU"
        ],
        languages: [
            "es"
        ]
    },
    UZ: {
        name: "Uzbekistan",
        native: "O'zbekiston",
        phone: [
            998
        ],
        continent: "AS",
        capital: "Tashkent",
        currency: [
            "UZS"
        ],
        languages: [
            "uz",
            "ru"
        ]
    },
    VA: {
        name: "Vatican City",
        native: "Vaticano",
        phone: [
            379
        ],
        continent: "EU",
        capital: "Vatican City",
        currency: [
            "EUR"
        ],
        languages: [
            "it",
            "la"
        ]
    },
    VC: {
        name: "Saint Vincent and the Grenadines",
        native: "Saint Vincent and the Grenadines",
        phone: [
            1784
        ],
        continent: "NA",
        capital: "Kingstown",
        currency: [
            "XCD"
        ],
        languages: [
            "en"
        ]
    },
    VE: {
        name: "Venezuela",
        native: "Venezuela",
        phone: [
            58
        ],
        continent: "SA",
        capital: "Caracas",
        currency: [
            "VES"
        ],
        languages: [
            "es"
        ]
    },
    VG: {
        name: "British Virgin Islands",
        native: "British Virgin Islands",
        phone: [
            1284
        ],
        continent: "NA",
        capital: "Road Town",
        currency: [
            "USD"
        ],
        languages: [
            "en"
        ]
    },
    VI: {
        name: "U.S. Virgin Islands",
        native: "United States Virgin Islands",
        phone: [
            1340
        ],
        continent: "NA",
        capital: "Charlotte Amalie",
        currency: [
            "USD"
        ],
        languages: [
            "en"
        ]
    },
    VN: {
        name: "Vietnam",
        native: "Vi\u1EC7t Nam",
        phone: [
            84
        ],
        continent: "AS",
        capital: "Hanoi",
        currency: [
            "VND"
        ],
        languages: [
            "vi"
        ]
    },
    VU: {
        name: "Vanuatu",
        native: "Vanuatu",
        phone: [
            678
        ],
        continent: "OC",
        capital: "Port Vila",
        currency: [
            "VUV"
        ],
        languages: [
            "bi",
            "en",
            "fr"
        ]
    },
    WF: {
        name: "Wallis and Futuna",
        native: "Wallis et Futuna",
        phone: [
            681
        ],
        continent: "OC",
        capital: "Mata-Utu",
        currency: [
            "XPF"
        ],
        languages: [
            "fr"
        ]
    },
    WS: {
        name: "Samoa",
        native: "Samoa",
        phone: [
            685
        ],
        continent: "OC",
        capital: "Apia",
        currency: [
            "WST"
        ],
        languages: [
            "sm",
            "en"
        ]
    },
    XK: {
        name: "Kosovo",
        native: "Republika e Kosov\xebs",
        phone: [
            377,
            381,
            383,
            386
        ],
        continent: "EU",
        capital: "Pristina",
        currency: [
            "EUR"
        ],
        languages: [
            "sq",
            "sr"
        ],
        userAssigned: !0
    },
    YE: {
        name: "Yemen",
        native: "\u0627\u0644\u064A\u064E\u0645\u064E\u0646",
        phone: [
            967
        ],
        continent: "AS",
        capital: "Sana'a",
        currency: [
            "YER"
        ],
        languages: [
            "ar"
        ]
    },
    YT: {
        name: "Mayotte",
        native: "Mayotte",
        phone: [
            262
        ],
        continent: "AF",
        capital: "Mamoudzou",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    ZA: {
        name: "South Africa",
        native: "South Africa",
        phone: [
            27
        ],
        continent: "AF",
        capital: "Pretoria",
        currency: [
            "ZAR"
        ],
        languages: [
            "af",
            "en",
            "nr",
            "st",
            "ss",
            "tn",
            "ts",
            "ve",
            "xh",
            "zu"
        ]
    },
    ZM: {
        name: "Zambia",
        native: "Zambia",
        phone: [
            260
        ],
        continent: "AF",
        capital: "Lusaka",
        currency: [
            "ZMW"
        ],
        languages: [
            "en"
        ]
    },
    ZW: {
        name: "Zimbabwe",
        native: "Zimbabwe",
        phone: [
            263
        ],
        continent: "AF",
        capital: "Harare",
        currency: [
            "USD",
            "ZAR",
            "BWP",
            "GBP",
            "AUD",
            "CNY",
            "INR",
            "JPY"
        ],
        languages: [
            "en",
            "sn",
            "nd"
        ]
    }
};
var $02a35933d3b344e6$export$d0d68bb9ed2c643d = {
    aa: {
        name: "Afar",
        native: "Afar"
    },
    ab: {
        name: "Abkhazian",
        native: "\u0410\u04A7\u0441\u0443\u0430"
    },
    af: {
        name: "Afrikaans",
        native: "Afrikaans"
    },
    ak: {
        name: "Akan",
        native: "Akana"
    },
    am: {
        name: "Amharic",
        native: "\u12A0\u121B\u122D\u129B"
    },
    an: {
        name: "Aragonese",
        native: "Aragon\xe9s"
    },
    ar: {
        name: "Arabic",
        native: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        rtl: 1
    },
    as: {
        name: "Assamese",
        native: "\u0985\u09B8\u09AE\u09C0\u09AF\u09BC\u09BE"
    },
    av: {
        name: "Avar",
        native: "\u0410\u0432\u0430\u0440"
    },
    ay: {
        name: "Aymara",
        native: "Aymar"
    },
    az: {
        name: "Azerbaijani",
        native: "Az\u0259rbaycanca / \u0622\u0630\u0631\u0628\u0627\u064A\u062C\u0627\u0646"
    },
    ba: {
        name: "Bashkir",
        native: "\u0411\u0430\u0448\u04A1\u043E\u0440\u0442"
    },
    be: {
        name: "Belarusian",
        native: "\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F"
    },
    bg: {
        name: "Bulgarian",
        native: "\u0411\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438"
    },
    bh: {
        name: "Bihari",
        native: "\u092D\u094B\u091C\u092A\u0941\u0930\u0940"
    },
    bi: {
        name: "Bislama",
        native: "Bislama"
    },
    bm: {
        name: "Bambara",
        native: "Bamanankan"
    },
    bn: {
        name: "Bengali",
        native: "\u09AC\u09BE\u0982\u09B2\u09BE"
    },
    bo: {
        name: "Tibetan",
        native: "\u0F56\u0F7C\u0F51\u0F0B\u0F61\u0F72\u0F42 / Bod skad"
    },
    br: {
        name: "Breton",
        native: "Brezhoneg"
    },
    bs: {
        name: "Bosnian",
        native: "Bosanski"
    },
    ca: {
        name: "Catalan",
        native: "Catal\xe0"
    },
    ce: {
        name: "Chechen",
        native: "\u041D\u043E\u0445\u0447\u0438\u0439\u043D"
    },
    ch: {
        name: "Chamorro",
        native: "Chamoru"
    },
    co: {
        name: "Corsican",
        native: "Corsu"
    },
    cr: {
        name: "Cree",
        native: "Nehiyaw"
    },
    cs: {
        name: "Czech",
        native: "\u010Ce\u0161tina"
    },
    cu: {
        name: "Old Church Slavonic / Old Bulgarian",
        native: "\u0441\u043B\u043E\u0432\u0463\u043D\u044C\u0441\u043A\u044A / slov\u011Bn\u012Dsk\u016D"
    },
    cv: {
        name: "Chuvash",
        native: "\u0427\u0103\u0432\u0430\u0448"
    },
    cy: {
        name: "Welsh",
        native: "Cymraeg"
    },
    da: {
        name: "Danish",
        native: "Dansk"
    },
    de: {
        name: "German",
        native: "Deutsch"
    },
    dv: {
        name: "Divehi",
        native: "\u078B\u07A8\u0788\u07AC\u0780\u07A8\u0784\u07A6\u0790\u07B0",
        rtl: 1
    },
    dz: {
        name: "Dzongkha",
        native: "\u0F47\u0F7C\u0F44\u0F0B\u0F41"
    },
    ee: {
        name: "Ewe",
        native: "\u0190\u028B\u025B"
    },
    el: {
        name: "Greek",
        native: "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC"
    },
    en: {
        name: "English",
        native: "English"
    },
    eo: {
        name: "Esperanto",
        native: "Esperanto"
    },
    es: {
        name: "Spanish",
        native: "Espa\xf1ol"
    },
    et: {
        name: "Estonian",
        native: "Eesti"
    },
    eu: {
        name: "Basque",
        native: "Euskara"
    },
    fa: {
        name: "Persian",
        native: "\u0641\u0627\u0631\u0633\u06CC",
        rtl: 1
    },
    ff: {
        name: "Peul",
        native: "Fulfulde"
    },
    fi: {
        name: "Finnish",
        native: "Suomi"
    },
    fj: {
        name: "Fijian",
        native: "Na Vosa Vakaviti"
    },
    fo: {
        name: "Faroese",
        native: "F\xf8royskt"
    },
    fr: {
        name: "French",
        native: "Fran\xe7ais"
    },
    fy: {
        name: "West Frisian",
        native: "Frysk"
    },
    ga: {
        name: "Irish",
        native: "Gaeilge"
    },
    gd: {
        name: "Scottish Gaelic",
        native: "G\xe0idhlig"
    },
    gl: {
        name: "Galician",
        native: "Galego"
    },
    gn: {
        name: "Guarani",
        native: "Ava\xf1e'\u1EBD"
    },
    gu: {
        name: "Gujarati",
        native: "\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0"
    },
    gv: {
        name: "Manx",
        native: "Gaelg"
    },
    ha: {
        name: "Hausa",
        native: "\u0647\u064E\u0648\u064F\u0633\u064E",
        rtl: 1
    },
    he: {
        name: "Hebrew",
        native: "\u05E2\u05D1\u05E8\u05D9\u05EA",
        rtl: 1
    },
    hi: {
        name: "Hindi",
        native: "\u0939\u093F\u0928\u094D\u0926\u0940"
    },
    ho: {
        name: "Hiri Motu",
        native: "Hiri Motu"
    },
    hr: {
        name: "Croatian",
        native: "Hrvatski"
    },
    ht: {
        name: "Haitian",
        native: "Kr\xe8yol ayisyen"
    },
    hu: {
        name: "Hungarian",
        native: "Magyar"
    },
    hy: {
        name: "Armenian",
        native: "\u0540\u0561\u0575\u0565\u0580\u0565\u0576"
    },
    hz: {
        name: "Herero",
        native: "Otsiherero"
    },
    ia: {
        name: "Interlingua",
        native: "Interlingua"
    },
    id: {
        name: "Indonesian",
        native: "Bahasa Indonesia"
    },
    ie: {
        name: "Interlingue",
        native: "Interlingue"
    },
    ig: {
        name: "Igbo",
        native: "Igbo"
    },
    ii: {
        name: "Sichuan Yi",
        native: "\uA187\uA259 / \u56DB\u5DDD\u5F5D\u8BED"
    },
    ik: {
        name: "Inupiak",
        native: "I\xf1upiak"
    },
    io: {
        name: "Ido",
        native: "Ido"
    },
    is: {
        name: "Icelandic",
        native: "\xcdslenska"
    },
    it: {
        name: "Italian",
        native: "Italiano"
    },
    iu: {
        name: "Inuktitut",
        native: "\u1403\u14C4\u1483\u144E\u1450\u1466"
    },
    ja: {
        name: "Japanese",
        native: "\u65E5\u672C\u8A9E"
    },
    jv: {
        name: "Javanese",
        native: "Basa Jawa"
    },
    ka: {
        name: "Georgian",
        native: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8"
    },
    kg: {
        name: "Kongo",
        native: "KiKongo"
    },
    ki: {
        name: "Kikuyu",
        native: "G\u0129k\u0169y\u0169"
    },
    kj: {
        name: "Kuanyama",
        native: "Kuanyama"
    },
    kk: {
        name: "Kazakh",
        native: "\u049A\u0430\u0437\u0430\u049B\u0448\u0430"
    },
    kl: {
        name: "Greenlandic",
        native: "Kalaallisut"
    },
    km: {
        name: "Cambodian",
        native: "\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A"
    },
    kn: {
        name: "Kannada",
        native: "\u0C95\u0CA8\u0CCD\u0CA8\u0CA1"
    },
    ko: {
        name: "Korean",
        native: "\uD55C\uAD6D\uC5B4"
    },
    kr: {
        name: "Kanuri",
        native: "Kanuri"
    },
    ks: {
        name: "Kashmiri",
        native: "\u0915\u0936\u094D\u092E\u0940\u0930\u0940 / \u0643\u0634\u0645\u064A\u0631\u064A",
        rtl: 1
    },
    ku: {
        name: "Kurdish",
        native: "Kurd\xee / \u0643\u0648\u0631\u062F\u06CC",
        rtl: 1
    },
    kv: {
        name: "Komi",
        native: "\u041A\u043E\u043C\u0438"
    },
    kw: {
        name: "Cornish",
        native: "Kernewek"
    },
    ky: {
        name: "Kyrgyz",
        native: "\u041A\u044B\u0440\u0433\u044B\u0437\u0447\u0430"
    },
    la: {
        name: "Latin",
        native: "Latina"
    },
    lb: {
        name: "Luxembourgish",
        native: "L\xebtzebuergesch"
    },
    lg: {
        name: "Ganda",
        native: "Luganda"
    },
    li: {
        name: "Limburgian",
        native: "Limburgs"
    },
    ln: {
        name: "Lingala",
        native: "Ling\xe1la"
    },
    lo: {
        name: "Laotian",
        native: "\u0EA5\u0EB2\u0EA7 / Pha xa lao"
    },
    lt: {
        name: "Lithuanian",
        native: "Lietuvi\u0173"
    },
    lu: {
        name: "Luba-Katanga",
        native: "Tshiluba"
    },
    lv: {
        name: "Latvian",
        native: "Latvie\u0161u"
    },
    mg: {
        name: "Malagasy",
        native: "Malagasy"
    },
    mh: {
        name: "Marshallese",
        native: "Kajin Majel / Ebon"
    },
    mi: {
        name: "Maori",
        native: "M\u0101ori"
    },
    mk: {
        name: "Macedonian",
        native: "\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438"
    },
    ml: {
        name: "Malayalam",
        native: "\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02"
    },
    mn: {
        name: "Mongolian",
        native: "\u041C\u043E\u043D\u0433\u043E\u043B"
    },
    mo: {
        name: "Moldovan",
        native: "Moldoveneasc\u0103"
    },
    mr: {
        name: "Marathi",
        native: "\u092E\u0930\u093E\u0920\u0940"
    },
    ms: {
        name: "Malay",
        native: "Bahasa Melayu"
    },
    mt: {
        name: "Maltese",
        native: "bil-Malti"
    },
    my: {
        name: "Burmese",
        native: "\u1019\u103C\u1014\u103A\u1019\u102C\u1005\u102C"
    },
    na: {
        name: "Nauruan",
        native: "Dorerin Naoero"
    },
    nb: {
        name: "Norwegian Bokm\xe5l",
        native: "Norsk bokm\xe5l"
    },
    nd: {
        name: "North Ndebele",
        native: "Sindebele"
    },
    ne: {
        name: "Nepali",
        native: "\u0928\u0947\u092A\u093E\u0932\u0940"
    },
    ng: {
        name: "Ndonga",
        native: "Oshiwambo"
    },
    nl: {
        name: "Dutch",
        native: "Nederlands"
    },
    nn: {
        name: "Norwegian Nynorsk",
        native: "Norsk nynorsk"
    },
    no: {
        name: "Norwegian",
        native: "Norsk"
    },
    nr: {
        name: "South Ndebele",
        native: "isiNdebele"
    },
    nv: {
        name: "Navajo",
        native: "Din\xe9 bizaad"
    },
    ny: {
        name: "Chichewa",
        native: "Chi-Chewa"
    },
    oc: {
        name: "Occitan",
        native: "Occitan"
    },
    oj: {
        name: "Ojibwa",
        native: "\u140A\u14C2\u1511\u14C8\u142F\u14A7\u140E\u14D0 / Anishinaabemowin"
    },
    om: {
        name: "Oromo",
        native: "Oromoo"
    },
    or: {
        name: "Oriya",
        native: "\u0B13\u0B21\u0B3C\u0B3F\u0B06"
    },
    os: {
        name: "Ossetian / Ossetic",
        native: "\u0418\u0440\u043E\u043D\u0430\u0443"
    },
    pa: {
        name: "Panjabi / Punjabi",
        native: "\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40 / \u092A\u0902\u091C\u093E\u092C\u0940 / \u067E\u0646\u062C\u0627\u0628\u064A"
    },
    pi: {
        name: "Pali",
        native: "P\u0101li / \u092A\u093E\u0934\u093F"
    },
    pl: {
        name: "Polish",
        native: "Polski"
    },
    ps: {
        name: "Pashto",
        native: "\u067E\u069A\u062A\u0648",
        rtl: 1
    },
    pt: {
        name: "Portuguese",
        native: "Portugu\xeas"
    },
    qu: {
        name: "Quechua",
        native: "Runa Simi"
    },
    rm: {
        name: "Raeto Romance",
        native: "Rumantsch"
    },
    rn: {
        name: "Kirundi",
        native: "Kirundi"
    },
    ro: {
        name: "Romanian",
        native: "Rom\xe2n\u0103"
    },
    ru: {
        name: "Russian",
        native: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439"
    },
    rw: {
        name: "Rwandi",
        native: "Kinyarwandi"
    },
    sa: {
        name: "Sanskrit",
        native: "\u0938\u0902\u0938\u094D\u0915\u0943\u0924\u092E\u094D"
    },
    sc: {
        name: "Sardinian",
        native: "Sardu"
    },
    sd: {
        name: "Sindhi",
        native: "\u0938\u093F\u0928\u0927\u093F"
    },
    se: {
        name: "Northern Sami",
        native: "S\xe1megiella"
    },
    sg: {
        name: "Sango",
        native: "S\xe4ng\xf6"
    },
    sh: {
        name: "Serbo-Croatian",
        native: "Srpskohrvatski / \u0421\u0440\u043F\u0441\u043A\u043E\u0445\u0440\u0432\u0430\u0442\u0441\u043A\u0438"
    },
    si: {
        name: "Sinhalese",
        native: "\u0DC3\u0DD2\u0D82\u0DC4\u0DBD"
    },
    sk: {
        name: "Slovak",
        native: "Sloven\u010Dina"
    },
    sl: {
        name: "Slovenian",
        native: "Sloven\u0161\u010Dina"
    },
    sm: {
        name: "Samoan",
        native: "Gagana Samoa"
    },
    sn: {
        name: "Shona",
        native: "chiShona"
    },
    so: {
        name: "Somalia",
        native: "Soomaaliga"
    },
    sq: {
        name: "Albanian",
        native: "Shqip"
    },
    sr: {
        name: "Serbian",
        native: "\u0421\u0440\u043F\u0441\u043A\u0438"
    },
    ss: {
        name: "Swati",
        native: "SiSwati"
    },
    st: {
        name: "Southern Sotho",
        native: "Sesotho"
    },
    su: {
        name: "Sundanese",
        native: "Basa Sunda"
    },
    sv: {
        name: "Swedish",
        native: "Svenska"
    },
    sw: {
        name: "Swahili",
        native: "Kiswahili"
    },
    ta: {
        name: "Tamil",
        native: "\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD"
    },
    te: {
        name: "Telugu",
        native: "\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41"
    },
    tg: {
        name: "Tajik",
        native: "\u0422\u043E\u04B7\u0438\u043A\u04E3"
    },
    th: {
        name: "Thai",
        native: "\u0E44\u0E17\u0E22 / Phasa Thai"
    },
    ti: {
        name: "Tigrinya",
        native: "\u1275\u130D\u122D\u129B"
    },
    tk: {
        name: "Turkmen",
        native: "\u0422\u0443\u0440\u043A\u043C\u0435\u043D / \u062A\u0631\u0643\u0645\u0646"
    },
    tl: {
        name: "Tagalog / Filipino",
        native: "Tagalog"
    },
    tn: {
        name: "Tswana",
        native: "Setswana"
    },
    to: {
        name: "Tonga",
        native: "Lea Faka-Tonga"
    },
    tr: {
        name: "Turkish",
        native: "T\xfcrk\xe7e"
    },
    ts: {
        name: "Tsonga",
        native: "Xitsonga"
    },
    tt: {
        name: "Tatar",
        native: "Tatar\xe7a"
    },
    tw: {
        name: "Twi",
        native: "Twi"
    },
    ty: {
        name: "Tahitian",
        native: "Reo M\u0101`ohi"
    },
    ug: {
        name: "Uyghur",
        native: "Uy\u01A3urq\u0259 / \u0626\u06C7\u064A\u063A\u06C7\u0631\u0686\u06D5"
    },
    uk: {
        name: "Ukrainian",
        native: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430"
    },
    ur: {
        name: "Urdu",
        native: "\u0627\u0631\u062F\u0648",
        rtl: 1
    },
    uz: {
        name: "Uzbek",
        native: "O'zbekcha"
    },
    ve: {
        name: "Venda",
        native: "Tshiven\u1E13a"
    },
    vi: {
        name: "Vietnamese",
        native: "Ti\u1EBFng Vi\u1EC7t"
    },
    vo: {
        name: "Volap\xfck",
        native: "Volap\xfck"
    },
    wa: {
        name: "Walloon",
        native: "Walon"
    },
    wo: {
        name: "Wolof",
        native: "Wollof"
    },
    xh: {
        name: "Xhosa",
        native: "isiXhosa"
    },
    yi: {
        name: "Yiddish",
        native: "\u05D9\u05D9\u05B4\u05D3\u05D9\u05E9",
        rtl: 1
    },
    yo: {
        name: "Yoruba",
        native: "Yor\xf9b\xe1"
    },
    za: {
        name: "Zhuang",
        native: "Cuengh / T\xf4\xf4 / \u58EE\u8BED"
    },
    zh: {
        name: "Chinese",
        native: "\u4E2D\u6587"
    },
    zu: {
        name: "Zulu",
        native: "isiZulu"
    }
};
var $02a35933d3b344e6$var$t = {
    AD: "AND",
    AE: "ARE",
    AF: "AFG",
    AG: "ATG",
    AI: "AIA",
    AL: "ALB",
    AM: "ARM",
    AO: "AGO",
    AQ: "ATA",
    AR: "ARG",
    AS: "ASM",
    AT: "AUT",
    AU: "AUS",
    AW: "ABW",
    AX: "ALA",
    AZ: "AZE",
    BA: "BIH",
    BB: "BRB",
    BD: "BGD",
    BE: "BEL",
    BF: "BFA",
    BG: "BGR",
    BH: "BHR",
    BI: "BDI",
    BJ: "BEN",
    BL: "BLM",
    BM: "BMU",
    BN: "BRN",
    BO: "BOL",
    BQ: "BES",
    BR: "BRA",
    BS: "BHS",
    BT: "BTN",
    BV: "BVT",
    BW: "BWA",
    BY: "BLR",
    BZ: "BLZ",
    CA: "CAN",
    CC: "CCK",
    CD: "COD",
    CF: "CAF",
    CG: "COG",
    CH: "CHE",
    CI: "CIV",
    CK: "COK",
    CL: "CHL",
    CM: "CMR",
    CN: "CHN",
    CO: "COL",
    CR: "CRI",
    CU: "CUB",
    CV: "CPV",
    CW: "CUW",
    CX: "CXR",
    CY: "CYP",
    CZ: "CZE",
    DE: "DEU",
    DJ: "DJI",
    DK: "DNK",
    DM: "DMA",
    DO: "DOM",
    DZ: "DZA",
    EC: "ECU",
    EE: "EST",
    EG: "EGY",
    EH: "ESH",
    ER: "ERI",
    ES: "ESP",
    ET: "ETH",
    FI: "FIN",
    FJ: "FJI",
    FK: "FLK",
    FM: "FSM",
    FO: "FRO",
    FR: "FRA",
    GA: "GAB",
    GB: "GBR",
    GD: "GRD",
    GE: "GEO",
    GF: "GUF",
    GG: "GGY",
    GH: "GHA",
    GI: "GIB",
    GL: "GRL",
    GM: "GMB",
    GN: "GIN",
    GP: "GLP",
    GQ: "GNQ",
    GR: "GRC",
    GS: "SGS",
    GT: "GTM",
    GU: "GUM",
    GW: "GNB",
    GY: "GUY",
    HK: "HKG",
    HM: "HMD",
    HN: "HND",
    HR: "HRV",
    HT: "HTI",
    HU: "HUN",
    ID: "IDN",
    IE: "IRL",
    IL: "ISR",
    IM: "IMN",
    IN: "IND",
    IO: "IOT",
    IQ: "IRQ",
    IR: "IRN",
    IS: "ISL",
    IT: "ITA",
    JE: "JEY",
    JM: "JAM",
    JO: "JOR",
    JP: "JPN",
    KE: "KEN",
    KG: "KGZ",
    KH: "KHM",
    KI: "KIR",
    KM: "COM",
    KN: "KNA",
    KP: "PRK",
    KR: "KOR",
    KW: "KWT",
    KY: "CYM",
    KZ: "KAZ",
    LA: "LAO",
    LB: "LBN",
    LC: "LCA",
    LI: "LIE",
    LK: "LKA",
    LR: "LBR",
    LS: "LSO",
    LT: "LTU",
    LU: "LUX",
    LV: "LVA",
    LY: "LBY",
    MA: "MAR",
    MC: "MCO",
    MD: "MDA",
    ME: "MNE",
    MF: "MAF",
    MG: "MDG",
    MH: "MHL",
    MK: "MKD",
    ML: "MLI",
    MM: "MMR",
    MN: "MNG",
    MO: "MAC",
    MP: "MNP",
    MQ: "MTQ",
    MR: "MRT",
    MS: "MSR",
    MT: "MLT",
    MU: "MUS",
    MV: "MDV",
    MW: "MWI",
    MX: "MEX",
    MY: "MYS",
    MZ: "MOZ",
    NA: "NAM",
    NC: "NCL",
    NE: "NER",
    NF: "NFK",
    NG: "NGA",
    NI: "NIC",
    NL: "NLD",
    NO: "NOR",
    NP: "NPL",
    NR: "NRU",
    NU: "NIU",
    NZ: "NZL",
    OM: "OMN",
    PA: "PAN",
    PE: "PER",
    PF: "PYF",
    PG: "PNG",
    PH: "PHL",
    PK: "PAK",
    PL: "POL",
    PM: "SPM",
    PN: "PCN",
    PR: "PRI",
    PS: "PSE",
    PT: "PRT",
    PW: "PLW",
    PY: "PRY",
    QA: "QAT",
    RE: "REU",
    RO: "ROU",
    RS: "SRB",
    RU: "RUS",
    RW: "RWA",
    SA: "SAU",
    SB: "SLB",
    SC: "SYC",
    SD: "SDN",
    SE: "SWE",
    SG: "SGP",
    SH: "SHN",
    SI: "SVN",
    SJ: "SJM",
    SK: "SVK",
    SL: "SLE",
    SM: "SMR",
    SN: "SEN",
    SO: "SOM",
    SR: "SUR",
    SS: "SSD",
    ST: "STP",
    SV: "SLV",
    SX: "SXM",
    SY: "SYR",
    SZ: "SWZ",
    TC: "TCA",
    TD: "TCD",
    TF: "ATF",
    TG: "TGO",
    TH: "THA",
    TJ: "TJK",
    TK: "TKL",
    TL: "TLS",
    TM: "TKM",
    TN: "TUN",
    TO: "TON",
    TR: "TUR",
    TT: "TTO",
    TV: "TUV",
    TW: "TWN",
    TZ: "TZA",
    UA: "UKR",
    UG: "UGA",
    UM: "UMI",
    US: "USA",
    UY: "URY",
    UZ: "UZB",
    VA: "VAT",
    VC: "VCT",
    VE: "VEN",
    VG: "VGB",
    VI: "VIR",
    VN: "VNM",
    VU: "VUT",
    WF: "WLF",
    WS: "WSM",
    XK: "XKX",
    YE: "YEM",
    YT: "MYT",
    ZA: "ZAF",
    ZM: "ZMB",
    ZW: "ZWE"
};
var $02a35933d3b344e6$export$9fa40dab52a2897a = (n)=>({
        ...$02a35933d3b344e6$export$e5ad74579c86b003[n],
        iso2: n,
        iso3: $02a35933d3b344e6$var$t[n]
    }), $02a35933d3b344e6$export$cc292de47df4a76 = ()=>Object.keys($02a35933d3b344e6$export$e5ad74579c86b003).map((n)=>$02a35933d3b344e6$export$9fa40dab52a2897a(n));
var $02a35933d3b344e6$var$s = $02a35933d3b344e6$export$cc292de47df4a76(), $02a35933d3b344e6$export$63fb30b9076ed333 = (n)=>{
    let a = new RegExp("^" + n + "$", "i");
    return $02a35933d3b344e6$var$s.find(({ name: c, native: o })=>a.test(c) || a.test(o))?.iso2 || !1;
};
var $02a35933d3b344e6$var$m = 127397, $02a35933d3b344e6$var$p = /^[A-Z]{2}$/, $02a35933d3b344e6$export$632016834768939e = (n)=>$02a35933d3b344e6$var$p.test(n) ? String.fromCodePoint(...n.split("").map((a)=>$02a35933d3b344e6$var$m + a.toUpperCase().charCodeAt(0))) : "";

});

parcelRegister("dRO48", function(module, exports) {
$parcel$export(module.exports, "SENSITIVE_COUNTRIES", () => (parcelRequire("eUiRa")).SENSITIVE_COUNTRIES);
$parcel$export(module.exports, "US_STATES", () => (parcelRequire("eUiRa")).US_STATES);
$parcel$export(module.exports, "USStates", () => (parcelRequire("eUiRa")).USStates);
$parcel$export(module.exports, "MONTHS", () => (parcelRequire("ktz3T")).MONTHS);
$parcel$export(module.exports, "NAICS_INDUSTRY_GROUP_OPTIONS", () => (parcelRequire("cstYm")).NAICS_INDUSTRY_GROUP_OPTIONS);
parcelRequire("eUiRa");
parcelRequire("ktz3T");
parcelRequire("cstYm");
parcelRequire("7iur0");

});
parcelRegister("eUiRa", function(module, exports) {

$parcel$export(module.exports, "USStates", () => $75fd8d8fab705645$export$282d4ff5ab5b654);
$parcel$export(module.exports, "US_STATES", () => $75fd8d8fab705645$export$e322f0dbe1d2219b);
$parcel$export(module.exports, "SENSITIVE_COUNTRIES", () => $75fd8d8fab705645$export$96cded9719ad4a6e);
var $75fd8d8fab705645$export$282d4ff5ab5b654;
(function(USStates) {
    USStates["Alabama"] = "AL";
    USStates["Alaska"] = "AK";
    USStates["AmericanSamoa"] = "AS";
    USStates["Arizona"] = "AZ";
    USStates["Arkansas"] = "AR";
    USStates["California"] = "CA";
    USStates["Colorado"] = "CO";
    USStates["Connecticut"] = "CT";
    USStates["Delaware"] = "DE";
    USStates["DistrictOfColumbia"] = "DC";
    USStates["FederatedStatesOfMicronesia"] = "FM";
    USStates["Florida"] = "FL";
    USStates["Georgia"] = "GA";
    USStates["Guam"] = "GU";
    USStates["Hawaii"] = "HI";
    USStates["Idaho"] = "ID";
    USStates["Illinois"] = "IL";
    USStates["Indiana"] = "IN";
    USStates["Iowa"] = "IA";
    USStates["Kansas"] = "KS";
    USStates["Kentucky"] = "KY";
    USStates["Louisiana"] = "LA";
    USStates["Maine"] = "ME";
    USStates["MarshallIslands"] = "MH";
    USStates["Maryland"] = "MD";
    USStates["Massachusetts"] = "MA";
    USStates["Michigan"] = "MI";
    USStates["Minnesota"] = "MN";
    USStates["Mississippi"] = "MS";
    USStates["Missouri"] = "MO";
    USStates["Montana"] = "MT";
    USStates["Nebraska"] = "NE";
    USStates["Nevada"] = "NV";
    USStates["NewHampshire"] = "NH";
    USStates["NewJersey"] = "NJ";
    USStates["NewMexico"] = "NM";
    USStates["NewYork"] = "NY";
    USStates["NorthCarolina"] = "NC";
    USStates["NorthDakota"] = "ND";
    USStates["NorthernMarianaIslands"] = "MP";
    USStates["Ohio"] = "OH";
    USStates["Oklahoma"] = "OK";
    USStates["Oregon"] = "OR";
    USStates["Palau"] = "PW";
    USStates["Pennsylvania"] = "PA";
    USStates["PuertoRico"] = "PR";
    USStates["RhodeIsland"] = "RI";
    USStates["SouthCarolina"] = "SC";
    USStates["SouthDakota"] = "SD";
    USStates["Tennessee"] = "TN";
    USStates["Texas"] = "TX";
    USStates["Utah"] = "UT";
    USStates["Vermont"] = "VT";
    USStates["VirginIslands"] = "VI";
    USStates["Virginia"] = "VA";
    USStates["Washington"] = "WA";
    USStates["WestVirginia"] = "WV";
    USStates["Wisconsin"] = "WI";
    USStates["Wyoming"] = "WY";
    USStates["OutsideTheUS"] = "..";
})($75fd8d8fab705645$export$282d4ff5ab5b654 || ($75fd8d8fab705645$export$282d4ff5ab5b654 = {}));
const $75fd8d8fab705645$export$e322f0dbe1d2219b = {
    ["AL"]: "Alabama",
    ["AK"]: "Alaska",
    ["AS"]: "American Samoa",
    ["AZ"]: "Arizona",
    ["AR"]: "Arkansas",
    ["CA"]: "California",
    ["CO"]: "Colorado",
    ["CT"]: "Connecticut",
    ["DE"]: "Delaware",
    ["DC"]: "District of Columbia",
    ["FM"]: "Federated States of Micronesia",
    ["FL"]: "Florida",
    ["GA"]: "Georgia",
    ["GU"]: "Guam",
    ["HI"]: "Hawaii",
    ["ID"]: "Idaho",
    ["IL"]: "Illinois",
    ["IN"]: "Indiana",
    ["IA"]: "Iowa",
    ["KS"]: "Kansas",
    ["KY"]: "Kentucky",
    ["LA"]: "Louisiana",
    ["ME"]: "Maine",
    ["MH"]: "Marshall Islands",
    ["MD"]: "Maryland",
    ["MA"]: "Massachusetts",
    ["MI"]: "Michigan",
    ["MN"]: "Minnesota",
    ["MS"]: "Mississippi",
    ["MO"]: "Missouri",
    ["MT"]: "Montana",
    ["NE"]: "Nebraska",
    ["NV"]: "Nevada",
    ["NH"]: "New Hampshire",
    ["NJ"]: "New Jersey",
    ["NM"]: "New Mexico",
    ["NY"]: "New York",
    ["NC"]: "North Carolina",
    ["ND"]: "North Dakota",
    ["MP"]: "Northern Mariana Islands",
    ["OH"]: "Ohio",
    ["OK"]: "Oklahoma",
    ["OR"]: "Oregon",
    ["PW"]: "Palau",
    ["PA"]: "Pennsylvania",
    ["PR"]: "Puerto Rico",
    ["RI"]: "Rhode Island",
    ["SC"]: "South Carolina",
    ["SD"]: "South Dakota",
    ["TN"]: "Tennessee",
    ["TX"]: "Texas",
    ["UT"]: "Utah",
    ["VT"]: "Vermont",
    ["VI"]: "Virgin Islands",
    ["VA"]: "Virginia",
    ["WA"]: "Washington",
    ["WV"]: "West Virginia",
    ["WI"]: "Wisconsin",
    ["WY"]: "Wyoming"
};
const $75fd8d8fab705645$export$96cded9719ad4a6e = [
    "AF",
    "BY",
    "BA",
    "AL",
    "XK",
    "BG",
    "CD",
    "CF",
    "CN",
    "CU",
    "ET",
    "HK",
    "HR",
    "IR",
    "IQ",
    "LB",
    "LY",
    "ML",
    "MM",
    "MK",
    "ME",
    "NI",
    "KP",
    "RU",
    "RO",
    "RS",
    "SI",
    "SO",
    "SD",
    "SY",
    "VE",
    "YE",
    "ZW"
];

});

parcelRegister("ktz3T", function(module, exports) {

$parcel$export(module.exports, "MONTHS", () => $7df7b635e82d4642$export$f9a766aa2475e8ba);
const $7df7b635e82d4642$export$f9a766aa2475e8ba = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];

});

parcelRegister("cstYm", function(module, exports) {

$parcel$export(module.exports, "NAICS_INDUSTRY_GROUP_OPTIONS", () => $e10b807e652b25a4$export$71dceb76aed77883);
$parcel$export(module.exports, "NAICS_6_DIGIT_CODE", () => $e10b807e652b25a4$export$43aa2d466d19b476);
var $e10b807e652b25a4$export$2dec1da573b70aa9;
(function(NAICSCode) {
    NAICSCode["AgricultureForestry"] = "agriculture_forestry_fishing_and_hunting";
    NAICSCode["Mining"] = "mining";
    NAICSCode["Utilities"] = "utilities";
    NAICSCode["Construction"] = "construction";
    NAICSCode["Manufacturing"] = "manufacturing";
    NAICSCode["WholesaleTrade"] = "wholesale_trade";
    NAICSCode["RetailTrade"] = "retail_trade";
    NAICSCode["TransportationWarehousing"] = "transportation_warehousing";
    NAICSCode["Information"] = "information";
    NAICSCode["FinanceInsurance"] = "finance_insurance";
    NAICSCode["RealEstateRentalAndLeasing"] = "real_estate_rental_and_leasing";
    NAICSCode["ProfessionalScientificTechnicalServices"] = "professional_scientific_technical_services";
    NAICSCode["ManagementCompaniesAndEnterprises"] = "management_companies_and_enterprises";
    NAICSCode["AdministrativeWasteManagementServices"] = "administrative_waste_management_services";
    NAICSCode["EducationalServices"] = "educational_services";
    NAICSCode["HealthCareAndSocialAssistance"] = "health_care_and_social_assistance";
    NAICSCode["ArtsEntertainmentRecreation"] = "arts_entertainment_recreation";
    NAICSCode["AccommodationFoodServices"] = "accommodation_food_services";
    NAICSCode["OtherServices"] = "other_services";
    NAICSCode["PublicAdministration"] = "public_administration";
})($e10b807e652b25a4$export$2dec1da573b70aa9 || ($e10b807e652b25a4$export$2dec1da573b70aa9 = {}));
const $e10b807e652b25a4$export$71dceb76aed77883 = {
    ["agriculture_forestry_fishing_and_hunting"]: "Agriculture, Forestry, Fishing and Hunting",
    ["mining"]: "Mining",
    ["utilities"]: "Utilities",
    ["construction"]: "Construction",
    ["manufacturing"]: "Manufacturing",
    ["wholesale_trade"]: "Wholesale Trade",
    ["retail_trade"]: "Retail Trade",
    ["transportation_warehousing"]: "Transportation and Warehousing",
    ["information"]: "Information",
    ["finance_insurance"]: "Finance and Insurance",
    ["real_estate_rental_and_leasing"]: "Real Estate Rental and Leasing",
    ["professional_scientific_technical_services"]: "Professional, Scientific, and Technical Services",
    ["management_companies_and_enterprises"]: "Management of Companies and Enterprises",
    ["administrative_waste_management_services"]: "Administrative and Waste Management Services",
    ["educational_services"]: "Educational Services",
    ["health_care_and_social_assistance"]: "Health Care and Social Assistance",
    ["arts_entertainment_recreation"]: "Arts, Entertainment, and Recreation",
    ["accommodation_food_services"]: "Accommodation and Food Services",
    ["other_services"]: "Other Services",
    ["public_administration"]: "Public Administration"
};
const $e10b807e652b25a4$export$43aa2d466d19b476 = {
    "111110": "Soybean Farming",
    "111120": "Oilseed (except Soybean) Farming",
    "111130": "Dry Pea and Bean Farming",
    "111140": "Wheat Farming",
    "111150": "Corn Farming",
    "111160": "Rice Farming",
    "111191": "Oilseed and Grain Combination Farming",
    "111199": "All Other Grain Farming",
    "111211": "Potato Farming",
    "111219": "Other Vegetable (except Potato) and Melon Farming",
    "111310": "Orange Groves",
    "111320": "Citrus (except Orange) Groves",
    "111331": "Apple Orchards",
    "111332": "Grape Vineyards",
    "111333": "Strawberry Farming",
    "111334": "Berry (except Strawberry) Farming",
    "111335": "Tree Nut Farming",
    "111336": "Fruit and Tree Nut Combination Farming",
    "111339": "Other Noncitrus Fruit Farming",
    "111411": "Mushroom Production",
    "111419": "Other Food Crops Grown Under Cover",
    "111421": "Nursery and Tree Production",
    "111422": "Floriculture Production",
    "111910": "Tobacco Farming",
    "111920": "Cotton Farming",
    "111930": "Sugarcane Farming",
    "111940": "Hay Farming",
    "111991": "Sugar Beet Farming",
    "111992": "Peanut Farming",
    "111998": "All Other Miscellaneous Crop Farming",
    "112111": "Beef Cattle Ranching and Farming",
    "112112": "Cattle Feedlots",
    "112120": "Dairy Cattle and Milk Production",
    "112130": "Dual-Purpose Cattle Ranching and Farming",
    "112210": "Hog and Pig Farming",
    "112310": "Chicken Egg Production",
    "112320": "Broilers and Other Meat Type Chicken Production",
    "112330": "Turkey Production",
    "112340": "Poultry Hatcheries",
    "112390": "Other Poultry Production",
    "112410": "Sheep Farming",
    "112420": "Goat Farming",
    "112511": "Finfish Farming and Fish Hatcheries",
    "112512": "Shellfish Farming",
    "112519": "Other Aquaculture",
    "112910": "Apiculture",
    "112920": "Horses and Other Equine Production",
    "112930": "Fur-Bearing Animal and Rabbit Production",
    "112990": "All Other Animal Production",
    "113110": "Timber Tract Operations",
    "113210": "Forest Nurseries and Gathering of Forest Products",
    "113310": "Logging",
    "114111": "Finfish Fishing",
    "114112": "Shellfish Fishing",
    "114119": "Other Marine Fishing",
    "114210": "Hunting and Trapping",
    "115111": "Cotton Ginning",
    "115112": "Soil Preparation, Planting, and Cultivating",
    "115113": "Crop Harvesting, Primarily by Machine",
    "115114": "Postharvest Crop Activities (except Cotton Ginning)",
    "115115": "Farm Labor Contractors and Crew Leaders",
    "115116": "Farm Management Services",
    "115210": "Support Activities for Animal Production",
    "115310": "Support Activities for Forestry",
    "211120": "Crude Petroleum Extraction",
    "211130": "Natural Gas Extraction",
    "212114": "Surface Coal Mining",
    "212115": "Underground Coal Mining",
    "212210": "Iron Ore Mining",
    "212220": "Gold Ore and Silver Ore Mining",
    "212230": "Copper, Nickel, Lead, and Zinc Mining",
    "212290": "Other Metal Ore Mining",
    "212311": "Dimension Stone Mining and Quarrying",
    "212312": "Crushed and Broken Limestone Mining and Quarrying",
    "212313": "Crushed and Broken Granite Mining and Quarrying",
    "212319": "Other Crushed and Broken Stone Mining and Quarrying",
    "212321": "Construction Sand and Gravel Mining",
    "212322": "Industrial Sand Mining",
    "212323": "Kaolin, Clay, and Ceramic and Refractory Minerals Mining",
    "212390": "Other Nonmetallic Mineral Mining and Quarrying",
    "213111": "Drilling Oil and Gas Wells",
    "213112": "Support Activities for Oil and Gas Operations",
    "213113": "Support Activities for Coal Mining",
    "213114": "Support Activities for Metal Mining",
    "213115": "Support Activities for Nonmetallic Minerals (except Fuels) Mining",
    "221111": "Hydroelectric Power Generation",
    "221112": "Fossil Fuel Electric Power Generation",
    "221113": "Nuclear Electric Power Generation",
    "221114": "Solar Electric Power Generation",
    "221115": "Wind Electric Power Generation",
    "221116": "Geothermal Electric Power Generation",
    "221117": "Biomass Electric Power Generation",
    "221118": "Other Electric Power Generation",
    "221121": "Electric Bulk Power Transmission and Control",
    "221122": "Electric Power Distribution",
    "221210": "Natural Gas Distribution",
    "221310": "Water Supply and Irrigation Systems",
    "221320": "Sewage Treatment Facilities",
    "221330": "Steam and Air-Conditioning Supply",
    "236115": "New Single-Family Housing Construction (except For-Sale Builders)",
    "236116": "New Multifamily Housing Construction (except For-Sale Builders)",
    "236117": "New Housing For-Sale Builders",
    "236118": "Residential Remodelers",
    "236210": "Industrial Building Construction",
    "236220": "Commercial and Institutional Building Construction",
    "237110": "Water and Sewer Line and Related Structures Construction",
    "237120": "Oil and Gas Pipeline and Related Structures Construction",
    "237130": "Power and Communication Line and Related Structures Construction",
    "237210": "Land Subdivision",
    "237310": "Highway, Street, and Bridge Construction",
    "237990": "Other Heavy and Civil Engineering Construction",
    "238110": "Poured Concrete Foundation and Structure Contractors",
    "238120": "Structural Steel and Precast Concrete Contractors",
    "238130": "Framing Contractors",
    "238140": "Masonry Contractors",
    "238150": "Glass and Glazing Contractors",
    "238160": "Roofing Contractors",
    "238170": "Siding Contractors",
    "238190": "Other Foundation, Structure, and Building Exterior Contractors",
    "238210": "Electrical Contractors and Other Wiring Installation Contractors",
    "238220": "Plumbing, Heating, and Air-Conditioning Contractors",
    "238290": "Other Building Equipment Contractors",
    "238310": "Drywall and Insulation Contractors",
    "238320": "Painting and Wall Covering Contractors",
    "238330": "Flooring Contractors",
    "238340": "Tile and Terrazzo Contractors",
    "238350": "Finish Carpentry Contractors",
    "238390": "Other Building Finishing Contractors",
    "238910": "Site Preparation Contractors",
    "238990": "All Other Specialty Trade Contractors",
    "311111": "Dog and Cat Food Manufacturing",
    "311119": "Other Animal Food Manufacturing",
    "311211": "Flour Milling",
    "311212": "Rice Milling",
    "311213": "Malt Manufacturing",
    "311221": "Wet Corn Milling and Starch Manufacturing",
    "311224": "Soybean and Other Oilseed Processing",
    "311225": "Fats and Oils Refining and Blending",
    "311230": "Breakfast Cereal Manufacturing",
    "311313": "Beet Sugar Manufacturing",
    "311314": "Cane Sugar Manufacturing",
    "311340": "Nonchocolate Confectionery Manufacturing",
    "311351": "Chocolate and Confectionery Manufacturing from Cacao Beans",
    "311352": "Confectionery Manufacturing from Purchased Chocolate",
    "311411": "Frozen Fruit, Juice, and Vegetable Manufacturing",
    "311412": "Frozen Specialty Food Manufacturing",
    "311421": "Fruit and Vegetable Canning",
    "311422": "Specialty Canning",
    "311423": "Dried and Dehydrated Food Manufacturing",
    "311511": "Fluid Milk Manufacturing",
    "311512": "Creamery Butter Manufacturing",
    "311513": "Cheese Manufacturing",
    "311514": "Dry, Condensed, and Evaporated Dairy Product Manufacturing",
    "311520": "Ice Cream and Frozen Dessert Manufacturing",
    "311611": "Animal (except Poultry) Slaughtering",
    "311612": "Meat Processed from Carcasses",
    "311613": "Rendering and Meat Byproduct Processing",
    "311615": "Poultry Processing",
    "311710": "Seafood Product Preparation and Packaging",
    "311811": "Retail Bakeries",
    "311812": "Commercial Bakeries",
    "311813": "Frozen Cakes, Pies, and Other Pastries Manufacturing",
    "311821": "Cookie and Cracker Manufacturing",
    "311824": "Dry Pasta, Dough, and Flour Mixes Manufacturing from Purchased Flour",
    "311830": "Tortilla Manufacturing",
    "311911": "Roasted Nuts and Peanut Butter Manufacturing",
    "311919": "Other Snack Food Manufacturing",
    "311920": "Coffee and Tea Manufacturing",
    "311930": "Flavoring Syrup and Concentrate Manufacturing",
    "311941": "Mayonnaise, Dressing, and Other Prepared Sauce Manufacturing",
    "311942": "Spice and Extract Manufacturing",
    "311991": "Perishable Prepared Food Manufacturing",
    "311999": "All Other Miscellaneous Food Manufacturing",
    "312111": "Soft Drink Manufacturing",
    "312112": "Bottled Water Manufacturing",
    "312113": "Ice Manufacturing",
    "312120": "Breweries",
    "312130": "Wineries",
    "312140": "Distilleries",
    "312230": "Tobacco Manufacturing",
    "313110": "Fiber, Yarn, and Thread Mills",
    "313210": "Broadwoven Fabric Mills",
    "313220": "Narrow Fabric Mills and Schiffli Machine Embroidery",
    "313230": "Nonwoven Fabric Mills",
    "313240": "Knit Fabric Mills",
    "313310": "Textile and Fabric Finishing Mills",
    "313320": "Fabric Coating Mills",
    "314110": "Carpet and Rug Mills",
    "314120": "Curtain and Linen Mills",
    "314910": "Textile Bag and Canvas Mills",
    "314994": "Rope, Cordage, Twine, Tire Cord, and Tire Fabric Mills",
    "314999": "All Other Miscellaneous Textile Product Mills",
    "315120": "Apparel Knitting Mills",
    "315210": "Cut and Sew Apparel Contractors",
    "315250": "Cut and Sew Apparel Manufacturing (except Contractors)",
    "315990": "Apparel Accessories and Other Apparel Manufacturing",
    "316110": "Leather and Hide Tanning and Finishing",
    "316210": "Footwear Manufacturing",
    "316990": "Other Leather and Allied Product Manufacturing",
    "321113": "Sawmills",
    "321114": "Wood Preservation",
    "321211": "Hardwood Veneer and Plywood Manufacturing",
    "321212": "Softwood Veneer and Plywood Manufacturing",
    "321215": "Engineered Wood Member Manufacturing",
    "321219": "Reconstituted Wood Product Manufacturing",
    "321911": "Wood Window and Door Manufacturing",
    "321912": "Cut Stock, Resawing Lumber, and Planing",
    "321918": "Other Millwork (including Flooring)",
    "321920": "Wood Container and Pallet Manufacturing",
    "321991": "Manufactured Home (Mobile Home) Manufacturing",
    "321992": "Prefabricated Wood Building Manufacturing",
    "321999": "All Other Miscellaneous Wood Product Manufacturing",
    "322110": "Pulp Mills",
    "322120": "Paper Mills",
    "322130": "Paperboard Mills",
    "322211": "Corrugated and Solid Fiber Box Manufacturing",
    "322212": "Folding Paperboard Box Manufacturing",
    "322219": "Other Paperboard Container Manufacturing",
    "322220": "Paper Bag and Coated and Treated Paper Manufacturing",
    "322230": "Stationery Product Manufacturing",
    "322291": "Sanitary Paper Product Manufacturing",
    "322299": "All Other Converted Paper Product Manufacturing",
    "323111": "Commercial Printing (except Screen and Books)",
    "323113": "Commercial Screen Printing",
    "323117": "Books Printing",
    "323120": "Support Activities for Printing",
    "324110": "Petroleum Refineries",
    "324121": "Asphalt Paving Mixture and Block Manufacturing",
    "324122": "Asphalt Shingle and Coating Materials Manufacturing",
    "324191": "Petroleum Lubricating Oil and Grease Manufacturing",
    "324199": "All Other Petroleum and Coal Products Manufacturing",
    "325110": "Petrochemical Manufacturing",
    "325120": "Industrial Gas Manufacturing",
    "325130": "Synthetic Dye and Pigment Manufacturing",
    "325180": "Other Basic Inorganic Chemical Manufacturing",
    "325193": "Ethyl Alcohol Manufacturing",
    "325194": "Cyclic Crude, Intermediate, and Gum and Wood Chemical Manufacturing",
    "325199": "All Other Basic Organic Chemical Manufacturing",
    "325211": "Plastics Material and Resin Manufacturing",
    "325212": "Synthetic Rubber Manufacturing",
    "325220": "Artificial and Synthetic Fibers and Filaments Manufacturing",
    "325311": "Nitrogenous Fertilizer Manufacturing",
    "325312": "Phosphatic Fertilizer Manufacturing",
    "325314": "Fertilizer (Mixing Only) Manufacturing",
    "325315": "Compost Manufacturing",
    "325320": "Pesticide and Other Agricultural Chemical Manufacturing",
    "325411": "Medicinal and Botanical Manufacturing",
    "325412": "Pharmaceutical Preparation Manufacturing",
    "325413": "In-Vitro Diagnostic Substance Manufacturing",
    "325414": "Biological Product (except Diagnostic) Manufacturing",
    "325510": "Paint and Coating Manufacturing",
    "325520": "Adhesive Manufacturing",
    "325611": "Soap and Other Detergent Manufacturing",
    "325612": "Polish and Other Sanitation Good Manufacturing",
    "325613": "Surface Active Agent Manufacturing",
    "325620": "Toilet Preparation Manufacturing",
    "325910": "Printing Ink Manufacturing",
    "325920": "Explosives Manufacturing",
    "325991": "Custom Compounding of Purchased Resins",
    "325992": "Photographic Film, Paper, Plate, Chemical, and Copy Toner Manufacturing",
    "325998": "All Other Miscellaneous Chemical Product and Preparation Manufacturing",
    "326111": "Plastics Bag and Pouch Manufacturing",
    "326112": "Plastics Packaging Film and Sheet (including Laminated) Manufacturing",
    "326113": "Unlaminated Plastics Film and Sheet (except Packaging) Manufacturing",
    "326121": "Unlaminated Plastics Profile Shape Manufacturing",
    "326122": "Plastics Pipe and Pipe Fitting Manufacturing",
    "326130": "Laminated Plastics Plate, Sheet (except Packaging), and Shape Manufacturing",
    "326140": "Polystyrene Foam Product Manufacturing",
    "326150": "Urethane and Other Foam Product (except Polystyrene) Manufacturing",
    "326160": "Plastics Bottle Manufacturing",
    "326191": "Plastics Plumbing Fixture Manufacturing",
    "326199": "All Other Plastics Product Manufacturing",
    "326211": "Tire Manufacturing (except Retreading)",
    "326212": "Tire Retreading",
    "326220": "Rubber and Plastics Hoses and Belting Manufacturing",
    "326291": "Rubber Product Manufacturing for Mechanical Use",
    "326299": "All Other Rubber Product Manufacturing",
    "327110": "Pottery, Ceramics, and Plumbing Fixture Manufacturing",
    "327120": "Clay Building Material and Refractories Manufacturing",
    "327211": "Flat Glass Manufacturing",
    "327212": "Other Pressed and Blown Glass and Glassware Manufacturing",
    "327213": "Glass Container Manufacturing",
    "327215": "Glass Product Manufacturing Made of Purchased Glass",
    "327310": "Cement Manufacturing",
    "327320": "Ready-Mix Concrete Manufacturing",
    "327331": "Concrete Block and Brick Manufacturing",
    "327332": "Concrete Pipe Manufacturing",
    "327390": "Other Concrete Product Manufacturing",
    "327410": "Lime Manufacturing",
    "327420": "Gypsum Product Manufacturing",
    "327910": "Abrasive Product Manufacturing",
    "327991": "Cut Stone and Stone Product Manufacturing",
    "327992": "Ground or Treated Mineral and Earth Manufacturing",
    "327993": "Mineral Wool Manufacturing",
    "327999": "All Other Miscellaneous Nonmetallic Mineral Product Manufacturing",
    "331110": "Iron and Steel Mills and Ferroalloy Manufacturing",
    "331210": "Iron and Steel Pipe and Tube Manufacturing from Purchased Steel",
    "331221": "Rolled Steel Shape Manufacturing",
    "331222": "Steel Wire Drawing",
    "331313": "Alumina Refining and Primary Aluminum Production",
    "331314": "Secondary Smelting and Alloying of Aluminum",
    "331315": "Aluminum Sheet, Plate, and Foil Manufacturing",
    "331318": "Other Aluminum Rolling, Drawing, and Extruding",
    "331410": "Nonferrous Metal (except Aluminum) Smelting and Refining",
    "331420": "Copper Rolling, Drawing, Extruding, and Alloying",
    "331491": "Nonferrous Metal (except Copper and Aluminum) Rolling, Drawing, and Extruding",
    "331492": "Secondary Smelting, Refining, and Alloying of Nonferrous Metal (except Copper and Aluminum)",
    "331511": "Iron Foundries",
    "331512": "Steel Investment Foundries",
    "331513": "Steel Foundries (except Investment)",
    "331523": "Nonferrous Metal Die-Casting Foundries",
    "331524": "Aluminum Foundries (except Die-Casting)",
    "331529": "Other Nonferrous Metal Foundries (except Die-Casting)",
    "332111": "Iron and Steel Forging",
    "332112": "Nonferrous Forging",
    "332114": "Custom Roll Forming",
    "332117": "Powder Metallurgy Part Manufacturing",
    "332119": "Metal Crown, Closure, and Other Metal Stamping (except Automotive)",
    "332215": "Metal Kitchen Cookware, Utensil, Cutlery, and Flatware (except Precious) Manufacturing",
    "332216": "Saw Blade and Handtool Manufacturing",
    "332311": "Prefabricated Metal Building and Component Manufacturing",
    "332312": "Fabricated Structural Metal Manufacturing",
    "332313": "Plate Work Manufacturing",
    "332321": "Metal Window and Door Manufacturing",
    "332322": "Sheet Metal Work Manufacturing",
    "332323": "Ornamental and Architectural Metal Work Manufacturing",
    "332410": "Power Boiler and Heat Exchanger Manufacturing",
    "332420": "Metal Tank (Heavy Gauge) Manufacturing",
    "332431": "Metal Can Manufacturing",
    "332439": "Other Metal Container Manufacturing",
    "332510": "Hardware Manufacturing",
    "332613": "Spring Manufacturing",
    "332618": "Other Fabricated Wire Product Manufacturing",
    "332710": "Machine Shops",
    "332721": "Precision Turned Product Manufacturing",
    "332722": "Bolt, Nut, Screw, Rivet, and Washer Manufacturing",
    "332811": "Metal Heat Treating",
    "332812": "Metal Coating, Engraving (except Jewelry and Silverware), and Allied Services to Manufacturers",
    "332813": "Electroplating, Plating, Polishing, Anodizing, and Coloring",
    "332911": "Industrial Valve Manufacturing",
    "332912": "Fluid Power Valve and Hose Fitting Manufacturing",
    "332913": "Plumbing Fixture Fitting and Trim Manufacturing",
    "332919": "Other Metal Valve and Pipe Fitting Manufacturing",
    "332991": "Ball and Roller Bearing Manufacturing",
    "332992": "Small Arms Ammunition Manufacturing",
    "332993": "Ammunition (except Small Arms) Manufacturing",
    "332994": "Small Arms, Ordnance, and Ordnance Accessories Manufacturing",
    "332996": "Fabricated Pipe and Pipe Fitting Manufacturing",
    "332999": "All Other Miscellaneous Fabricated Metal Product Manufacturing",
    "333111": "Farm Machinery and Equipment Manufacturing",
    "333112": "Lawn and Garden Tractor and Home Lawn and Garden Equipment Manufacturing",
    "333120": "Construction Machinery Manufacturing",
    "333131": "Mining Machinery and Equipment Manufacturing",
    "333132": "Oil and Gas Field Machinery and Equipment Manufacturing",
    "333241": "Food Product Machinery Manufacturing",
    "333242": "Semiconductor Machinery Manufacturing",
    "333243": "Sawmill, Woodworking, and Paper Machinery Manufacturing",
    "333248": "All Other Industrial Machinery Manufacturing",
    "333310": "Commercial and Service Industry Machinery Manufacturing",
    "333413": "Industrial and Commercial Fan and Blower and Air Purification Equipment Manufacturing",
    "333414": "Heating Equipment (except Warm Air Furnaces) Manufacturing",
    "333415": "Air-Conditioning and Warm Air Heating Equipment and Commercial and Industrial Refrigeration Equipment Manufacturing",
    "333511": "Industrial Mold Manufacturing",
    "333514": "Special Die and Tool, Die Set, Jig, and Fixture Manufacturing",
    "333515": "Cutting Tool and Machine Tool Accessory Manufacturing",
    "333517": "Machine Tool Manufacturing",
    "333519": "Rolling Mill and Other Metalworking Machinery Manufacturing",
    "333611": "Turbine and Turbine Generator Set Units Manufacturing",
    "333612": "Speed Changer, Industrial High-Speed Drive, and Gear Manufacturing",
    "333613": "Mechanical Power Transmission Equipment Manufacturing",
    "333618": "Other Engine Equipment Manufacturing",
    "333912": "Air and Gas Compressor Manufacturing",
    "333914": "Measuring, Dispensing, and Other Pumping Equipment Manufacturing",
    "333921": "Elevator and Moving Stairway Manufacturing",
    "333922": "Conveyor and Conveying Equipment Manufacturing",
    "333923": "Overhead Traveling Crane, Hoist, and Monorail System Manufacturing",
    "333924": "Industrial Truck, Tractor, Trailer, and Stacker Machinery Manufacturing",
    "333991": "Power-Driven Handtool Manufacturing",
    "333992": "Welding and Soldering Equipment Manufacturing",
    "333993": "Packaging Machinery Manufacturing",
    "333994": "Industrial Process Furnace and Oven Manufacturing",
    "333995": "Fluid Power Cylinder and Actuator Manufacturing",
    "333996": "Fluid Power Pump and Motor Manufacturing",
    "333998": "All Other Miscellaneous General Purpose Machinery Manufacturing",
    "334111": "Electronic Computer Manufacturing",
    "334112": "Computer Storage Device Manufacturing",
    "334118": "Computer Terminal and Other Computer Peripheral Equipment Manufacturing",
    "334210": "Telephone Apparatus Manufacturing",
    "334220": "Radio and Television Broadcasting and Wireless Communications Equipment Manufacturing",
    "334290": "Other Communications Equipment Manufacturing",
    "334310": "Audio and Video Equipment Manufacturing",
    "334412": "Bare Printed Circuit Board Manufacturing",
    "334413": "Semiconductor and Related Device Manufacturing",
    "334416": "Capacitor, Resistor, Coil, Transformer, and Other Inductor Manufacturing",
    "334417": "Electronic Connector Manufacturing",
    "334418": "Printed Circuit Assembly (Electronic Assembly) Manufacturing",
    "334419": "Other Electronic Component Manufacturing",
    "334510": "Electromedical and Electrotherapeutic Apparatus Manufacturing",
    "334511": "Search, Detection, Navigation, Guidance, Aeronautical, and Nautical System and Instrument Manufacturing",
    "334512": "Automatic Environmental Control Manufacturing for Residential, Commercial, and Appliance Use",
    "334513": "Instruments and Related Products Manufacturing for Measuring, Displaying, and Controlling Industrial Process Variables",
    "334514": "Totalizing Fluid Meter and Counting Device Manufacturing",
    "334515": "Instrument Manufacturing for Measuring and Testing Electricity and Electrical Signals",
    "334516": "Analytical Laboratory Instrument Manufacturing",
    "334517": "Irradiation Apparatus Manufacturing",
    "334519": "Other Measuring and Controlling Device Manufacturing",
    "334610": "Manufacturing and Reproducing Magnetic and Optical Media",
    "335131": "Residential Electric Lighting Fixture Manufacturing",
    "335132": "Commercial, Industrial, and Institutional Electric Lighting Fixture Manufacturing",
    "335139": "Electric Lamp Bulb and Other Lighting Equipment Manufacturing",
    "335210": "Small Electrical Appliance Manufacturing",
    "335220": "Major Household Appliance Manufacturing",
    "335311": "Power, Distribution, and Specialty Transformer Manufacturing",
    "335312": "Motor and Generator Manufacturing",
    "335313": "Switchgear and Switchboard Apparatus Manufacturing",
    "335314": "Relay and Industrial Control Manufacturing",
    "335910": "Battery Manufacturing",
    "335921": "Fiber Optic Cable Manufacturing",
    "335929": "Other Communication and Energy Wire Manufacturing",
    "335931": "Current-Carrying Wiring Device Manufacturing",
    "335932": "Noncurrent-Carrying Wiring Device Manufacturing",
    "335991": "Carbon and Graphite Product Manufacturing",
    "335999": "All Other Miscellaneous Electrical Equipment and Component Manufacturing",
    "336110": "Automobile and Light Duty Motor Vehicle Manufacturing",
    "336120": "Heavy Duty Truck Manufacturing",
    "336211": "Motor Vehicle Body Manufacturing",
    "336212": "Truck Trailer Manufacturing",
    "336213": "Motor Home Manufacturing",
    "336214": "Travel Trailer and Camper Manufacturing",
    "336310": "Motor Vehicle Gasoline Engine and Engine Parts Manufacturing",
    "336320": "Motor Vehicle Electrical and Electronic Equipment Manufacturing",
    "336330": "Motor Vehicle Steering and Suspension Components (except Spring) Manufacturing",
    "336340": "Motor Vehicle Brake System Manufacturing",
    "336350": "Motor Vehicle Transmission and Power Train Parts Manufacturing",
    "336360": "Motor Vehicle Seating and Interior Trim Manufacturing",
    "336370": "Motor Vehicle Metal Stamping",
    "336390": "Other Motor Vehicle Parts Manufacturing",
    "336411": "Aircraft Manufacturing",
    "336412": "Aircraft Engine and Engine Parts Manufacturing",
    "336413": "Other Aircraft Parts and Auxiliary Equipment Manufacturing",
    "336414": "Guided Missile and Space Vehicle Manufacturing",
    "336415": "Guided Missile and Space Vehicle Propulsion Unit and Propulsion Unit Parts Manufacturing",
    "336419": "Other Guided Missile and Space Vehicle Parts and Auxiliary Equipment Manufacturing",
    "336510": "Railroad Rolling Stock Manufacturing",
    "336611": "Ship Building and Repairing",
    "336612": "Boat Building",
    "336991": "Motorcycle, Bicycle, and Parts Manufacturing",
    "336992": "Military Armored Vehicle, Tank, and Tank Component Manufacturing",
    "336999": "All Other Transportation Equipment Manufacturing",
    "337110": "Wood Kitchen Cabinet and Countertop Manufacturing",
    "337121": "Upholstered Household Furniture Manufacturing",
    "337122": "Nonupholstered Wood Household Furniture Manufacturing",
    "337126": "Household Furniture (except Wood and Upholstered) Manufacturing",
    "337127": "Institutional Furniture Manufacturing",
    "337211": "Wood Office Furniture Manufacturing",
    "337212": "Custom Architectural Woodwork and Millwork Manufacturing",
    "337214": "Office Furniture (except Wood) Manufacturing",
    "337215": "Showcase, Partition, Shelving, and Locker Manufacturing",
    "337910": "Mattress Manufacturing",
    "337920": "Blind and Shade Manufacturing",
    "339112": "Surgical and Medical Instrument Manufacturing",
    "339113": "Surgical Appliance and Supplies Manufacturing",
    "339114": "Dental Equipment and Supplies Manufacturing",
    "339115": "Ophthalmic Goods Manufacturing",
    "339116": "Dental Laboratories",
    "339910": "Jewelry and Silverware Manufacturing",
    "339920": "Sporting and Athletic Goods Manufacturing",
    "339930": "Doll, Toy, and Game Manufacturing",
    "339940": "Office Supplies (except Paper) Manufacturing",
    "339950": "Sign Manufacturing",
    "339991": "Gasket, Packing, and Sealing Device Manufacturing",
    "339992": "Musical Instrument Manufacturing",
    "339993": "Fastener, Button, Needle, and Pin Manufacturing",
    "339994": "Broom, Brush, and Mop Manufacturing",
    "339995": "Burial Casket Manufacturing",
    "339999": "All Other Miscellaneous Manufacturing",
    "423110": "Automobile and Other Motor Vehicle Merchant Wholesalers",
    "423120": "Motor Vehicle Supplies and New Parts Merchant Wholesalers",
    "423130": "Tire and Tube Merchant Wholesalers",
    "423140": "Motor Vehicle Parts (Used) Merchant Wholesalers",
    "423210": "Furniture Merchant Wholesalers",
    "423220": "Home Furnishing Merchant Wholesalers",
    "423310": "Lumber, Plywood, Millwork, and Wood Panel Merchant Wholesalers",
    "423320": "Brick, Stone, and Related Construction Material Merchant Wholesalers",
    "423330": "Roofing, Siding, and Insulation Material Merchant Wholesalers",
    "423390": "Other Construction Material Merchant Wholesalers",
    "423410": "Photographic Equipment and Supplies Merchant Wholesalers",
    "423420": "Office Equipment Merchant Wholesalers",
    "423430": "Computer and Computer Peripheral Equipment and Software Merchant Wholesalers",
    "423440": "Other Commercial Equipment Merchant Wholesalers",
    "423450": "Medical, Dental, and Hospital Equipment and Supplies Merchant Wholesalers",
    "423460": "Ophthalmic Goods Merchant Wholesalers",
    "423490": "Other Professional Equipment and Supplies Merchant Wholesalers",
    "423510": "Metal Service Centers and Other Metal Merchant Wholesalers",
    "423520": "Coal and Other Mineral and Ore Merchant Wholesalers",
    "423610": "Electrical Apparatus and Equipment, Wiring Supplies, and Related Equipment Merchant Wholesalers",
    "423620": "Household Appliances, Electric Housewares, and Consumer Electronics Merchant Wholesalers",
    "423690": "Other Electronic Parts and Equipment Merchant Wholesalers",
    "423710": "Hardware Merchant Wholesalers",
    "423720": "Plumbing and Heating Equipment and Supplies (Hydronics) Merchant Wholesalers",
    "423730": "Warm Air Heating and Air-Conditioning Equipment and Supplies Merchant Wholesalers",
    "423740": "Refrigeration Equipment and Supplies Merchant Wholesalers",
    "423810": "Construction and Mining (except Oil Well) Machinery and Equipment Merchant Wholesalers",
    "423820": "Farm and Garden Machinery and Equipment Merchant Wholesalers",
    "423830": "Industrial Machinery and Equipment Merchant Wholesalers",
    "423840": "Industrial Supplies Merchant Wholesalers",
    "423850": "Service Establishment Equipment and Supplies Merchant Wholesalers",
    "423860": "Transportation Equipment and Supplies (except Motor Vehicle) Merchant Wholesalers",
    "423910": "Sporting and Recreational Goods and Supplies Merchant Wholesalers",
    "423920": "Toy and Hobby Goods and Supplies Merchant Wholesalers",
    "423930": "Recyclable Material Merchant Wholesalers",
    "423940": "Jewelry, Watch, Precious Stone, and Precious Metal Merchant Wholesalers",
    "423990": "Other Miscellaneous Durable Goods Merchant Wholesalers",
    "424110": "Printing and Writing Paper Merchant Wholesalers",
    "424120": "Stationery and Office Supplies Merchant Wholesalers",
    "424130": "Industrial and Personal Service Paper Merchant Wholesalers",
    "424210": "Drugs and Druggists' Sundries Merchant Wholesalers",
    "424310": "Piece Goods, Notions, and Other Dry Goods Merchant Wholesalers",
    "424340": "Footwear Merchant Wholesalers",
    "424350": "Clothing and Clothing Accessories Merchant Wholesalers",
    "424410": "General Line Grocery Merchant Wholesalers",
    "424420": "Packaged Frozen Food Merchant Wholesalers",
    "424430": "Dairy Product (except Dried or Canned) Merchant Wholesalers",
    "424440": "Poultry and Poultry Product Merchant Wholesalers",
    "424450": "Confectionery Merchant Wholesalers",
    "424460": "Fish and Seafood Merchant Wholesalers",
    "424470": "Meat and Meat Product Merchant Wholesalers",
    "424480": "Fresh Fruit and Vegetable Merchant Wholesalers",
    "424490": "Other Grocery and Related Products Merchant Wholesalers",
    "424510": "Grain and Field Bean Merchant Wholesalers",
    "424520": "Livestock Merchant Wholesalers",
    "424590": "Other Farm Product Raw Material Merchant Wholesalers",
    "424610": "Plastics Materials and Basic Forms and Shapes Merchant Wholesalers",
    "424690": "Other Chemical and Allied Products Merchant Wholesalers",
    "424710": "Petroleum Bulk Stations and Terminals",
    "424720": "Petroleum and Petroleum Products Merchant Wholesalers (except Bulk Stations and Terminals)",
    "424810": "Beer and Ale Merchant Wholesalers",
    "424820": "Wine and Distilled Alcoholic Beverage Merchant Wholesalers",
    "424910": "Farm Supplies Merchant Wholesalers",
    "424920": "Book, Periodical, and Newspaper Merchant Wholesalers",
    "424930": "Flower, Nursery Stock, and Florists' Supplies Merchant Wholesalers",
    "424940": "Tobacco Product and Electronic Cigarette Merchant Wholesalers",
    "424950": "Paint, Varnish, and Supplies Merchant Wholesalers",
    "424990": "Other Miscellaneous Nondurable Goods Merchant Wholesalers",
    "425120": "Wholesale Trade Agents and Brokers",
    "441110": "New Car Dealers",
    "441120": "Used Car Dealers",
    "441210": "Recreational Vehicle Dealers",
    "441222": "Boat Dealers",
    "441227": "Motorcycle, ATV, and All Other Motor Vehicle Dealers",
    "441330": "Automotive Parts and Accessories Retailers",
    "441340": "Tire Dealers",
    "442110": "Furniture Stores",
    "442210": "Floor Covering Stores",
    "442291": "Window Treatment Stores",
    "442299": "All Other Home Furnishings Stores",
    "443141": "Household Appliance Stores",
    "443142": "Electronics Stores",
    "444110": "Home Centers",
    "444120": "Paint and Wallpaper Retailers",
    "444140": "Hardware Retailers",
    "444180": "Other Building Material Dealers",
    "444230": "Outdoor Power Equipment Retailers",
    "444240": "Nursery, Garden Center, and Farm Supply Retailers",
    "445110": "Supermarkets and Other Grocery Retailers (except Convenience Retailers)",
    "445131": "Convenience Retailers",
    "445132": "Vending Machine Operators",
    "445230": "Fruit and Vegetable Retailers",
    "445240": "Meat Retailers",
    "445250": "Fish and Seafood Retailers",
    "445291": "Baked Goods Retailers",
    "445292": "Confectionery and Nut Retailers",
    "445298": "All Other Specialty Food Retailers",
    "445320": "Beer, Wine, and Liquor Retailers",
    "448190": "Other Clothing Stores",
    "449110": "Furniture Retailers",
    "449121": "Floor Covering Retailers",
    "449122": "Window Treatment Retailers",
    "449129": "All Other Home Furnishings Retailers",
    "449210": "Electronics and Appliance Retailers",
    "453220": "Gift, Novelty, and Souvenir Stores",
    "455110": "Department Stores",
    "455211": "Warehouse Clubs and Supercenters",
    "455219": "All Other General Merchandise Retailers",
    "456110": "Pharmacies and Drug Retailers",
    "456120": "Cosmetics, Beauty Supplies, and Perfume Retailers",
    "456130": "Optical Goods Retailers",
    "456191": "Food (Health) Supplement Retailers",
    "456199": "All Other Health and Personal Care Retailers",
    "457110": "Gasoline Stations with Convenience Stores",
    "457120": "Other Gasoline Stations",
    "457210": "Fuel Dealers",
    "458110": "Clothing and Clothing Accessories Retailers",
    "458210": "Shoe Retailers",
    "458310": "Jewelry Retailers",
    "458320": "Luggage and Leather Goods Retailers",
    "459110": "Sporting Goods Retailers",
    "459120": "Hobby, Toy, and Game Retailers",
    "459130": "Sewing, Needlework, and Piece Goods Retailers",
    "459140": "Musical Instrument and Supplies Retailers",
    "459210": "Book Retailers and News Dealers",
    "459310": "Florists",
    "459410": "Office Supplies and Stationery Retailers",
    "459420": "Gift, Novelty, and Souvenir Retailers",
    "459510": "Used Merchandise Retailers",
    "459910": "Pet and Pet Supplies Retailers",
    "459920": "Art Dealers",
    "459930": "Manufactured (Mobile) Home Dealers",
    "459991": "Tobacco, Electronic Cigarette, and Other Smoking Supplies Retailers",
    "459999": "All Other Miscellaneous Retailers",
    "481111": "Scheduled Passenger Air Transportation",
    "481112": "Scheduled Freight Air Transportation",
    "481211": "Nonscheduled Chartered Passenger Air Transportation",
    "481212": "Nonscheduled Chartered Freight Air Transportation",
    "481219": "Other Nonscheduled Air Transportation",
    "482111": "Line-Haul Railroads",
    "482112": "Short Line Railroads",
    "483111": "Deep Sea Freight Transportation",
    "483112": "Deep Sea Passenger Transportation",
    "483113": "Coastal and Great Lakes Freight Transportation",
    "483114": "Coastal and Great Lakes Passenger Transportation",
    "483211": "Inland Water Freight Transportation",
    "483212": "Inland Water Passenger Transportation",
    "484110": "General Freight Trucking, Local",
    "484121": "General Freight Trucking, Long-Distance, Truckload",
    "484122": "General Freight Trucking, Long-Distance, Less Than Truckload",
    "484210": "Used Household and Office Goods Moving",
    "484220": "Specialized Freight (except Used Goods) Trucking, Local",
    "484230": "Specialized Freight (except Used Goods) Trucking, Long-Distance",
    "485111": "Mixed Mode Transit Systems",
    "485112": "Commuter Rail Systems",
    "485113": "Bus and Other Motor Vehicle Transit Systems",
    "485119": "Other Urban Transit Systems",
    "485210": "Interurban and Rural Bus Transportation",
    "485310": "Taxi and Ridesharing Services",
    "485320": "Limousine Service",
    "485410": "School and Employee Bus Transportation",
    "485510": "Charter Bus Industry",
    "485991": "Special Needs Transportation",
    "485999": "All Other Transit and Ground Passenger Transportation",
    "486110": "Pipeline Transportation of Crude Oil",
    "486210": "Pipeline Transportation of Natural Gas",
    "486910": "Pipeline Transportation of Refined Petroleum Products",
    "486990": "All Other Pipeline Transportation",
    "487110": "Scenic and Sightseeing Transportation, Land",
    "487210": "Scenic and Sightseeing Transportation, Water",
    "487990": "Scenic and Sightseeing Transportation, Other",
    "488111": "Air Traffic Control",
    "488119": "Other Airport Operations",
    "488190": "Other Support Activities for Air Transportation",
    "488210": "Support Activities for Rail Transportation",
    "488310": "Port and Harbor Operations",
    "488320": "Marine Cargo Handling",
    "488330": "Navigational Services to Shipping",
    "488390": "Other Support Activities for Water Transportation",
    "488410": "Motor Vehicle Towing",
    "488490": "Other Support Activities for Road Transportation",
    "488510": "Freight Transportation Arrangement",
    "488991": "Packing and Crating",
    "488999": "All Other Support Activities for Transportation",
    "491110": "Postal Service",
    "492110": "Couriers and Express Delivery Services",
    "492210": "Local Messengers and Local Delivery",
    "493110": "General Warehousing and Storage",
    "493120": "Refrigerated Warehousing and Storage",
    "493130": "Farm Product Warehousing and Storage",
    "493190": "Other Warehousing and Storage",
    "512110": "Motion Picture and Video Production",
    "512120": "Motion Picture and Video Distribution",
    "512131": "Motion Picture Theaters (except Drive-Ins)",
    "512132": "Drive-In Motion Picture Theaters",
    "512191": "Teleproduction and Other Postproduction Services",
    "512199": "Other Motion Picture and Video Industries",
    "512230": "Music Publishers",
    "512240": "Sound Recording Studios",
    "512250": "Record Production and Distribution",
    "512290": "Other Sound Recording Industries",
    "513110": "Newspaper Publishers",
    "513120": "Periodical Publishers",
    "513130": "Book Publishers",
    "513140": "Directory and Mailing List Publishers",
    "513191": "Greeting Card Publishers",
    "513199": "All Other Publishers",
    "513210": "Software Publishers",
    "516110": "Radio Broadcasting Stations",
    "516120": "Television Broadcasting Stations",
    "516210": "Media Streaming Distribution Services, Social Networks, and Other Media Networks and Content Providers",
    "517111": "Wired Telecommunications Carriers",
    "517112": "Wireless Telecommunications Carriers (except Satellite)",
    "517121": "Telecommunications Resellers",
    "517122": "Agents for Wireless Telecommunications Services",
    "517410": "Satellite Telecommunications",
    "517810": "All Other Telecommunications",
    "518210": "Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services",
    "519210": "Libraries and Archives",
    "519290": "Web Search Portals and All Other Information Services",
    "521110": "Monetary Authorities-Central Bank",
    "522110": "Commercial Banking",
    "522130": "Credit Unions",
    "522180": "Savings Institutions and Other Depository Credit Intermediation",
    "522210": "Credit Card Issuing",
    "522220": "Sales Financing",
    "522291": "Consumer Lending",
    "522292": "Real Estate Credit",
    "522299": "International, Secondary Market, and All Other Nondepository Credit Intermediation",
    "522310": "Mortgage and Nonmortgage Loan Brokers",
    "522320": "Financial Transactions Processing, Reserve, and Clearinghouse Activities",
    "522390": "Other Activities Related to Credit Intermediation",
    "523150": "Investment Banking and Securities Intermediation",
    "523160": "Commodity Contracts Intermediation",
    "523210": "Securities and Commodity Exchanges",
    "523910": "Miscellaneous Intermediation",
    "523940": "Portfolio Management and Investment Advice",
    "523991": "Trust, Fiduciary, and Custody Activities",
    "523999": "Miscellaneous Financial Investment Activities",
    "524113": "Direct Life Insurance Carriers",
    "524114": "Direct Health and Medical Insurance Carriers",
    "524126": "Direct Property and Casualty Insurance Carriers",
    "524127": "Direct Title Insurance Carriers",
    "524128": "Other Direct Insurance (except Life, Health, and Medical) Carriers",
    "524130": "Reinsurance Carriers",
    "524210": "Insurance Agencies and Brokerages",
    "524291": "Claims Adjusting",
    "524292": "Pharmacy Benefit Management and Other Third Party Administration of Insurance and Pension Funds",
    "524298": "All Other Insurance Related Activities",
    "525110": "Pension Funds",
    "525120": "Health and Welfare Funds",
    "525190": "Other Insurance Funds",
    "525910": "Open-End Investment Funds",
    "525920": "Trusts, Estates, and Agency Accounts",
    "525990": "Other Financial Vehicles",
    "531110": "Lessors of Residential Buildings and Dwellings",
    "531120": "Lessors of Nonresidential Buildings (except Miniwarehouses)",
    "531130": "Lessors of Miniwarehouses and Self-Storage Units",
    "531190": "Lessors of Other Real Estate Property",
    "531210": "Offices of Real Estate Agents and Brokers",
    "531311": "Residential Property Managers",
    "531312": "Nonresidential Property Managers",
    "531320": "Offices of Real Estate Appraisers",
    "531390": "Other Activities Related to Real Estate",
    "532111": "Passenger Car Rental",
    "532112": "Passenger Car Leasing",
    "532120": "Truck, Utility Trailer, and RV (Recreational Vehicle) Rental and Leasing",
    "532210": "Consumer Electronics and Appliances Rental",
    "532281": "Formal Wear and Costume Rental",
    "532282": "Video Tape and Disc Rental",
    "532283": "Home Health Equipment Rental",
    "532284": "Recreational Goods Rental",
    "532289": "All Other Consumer Goods Rental",
    "532310": "General Rental Centers",
    "532411": "Commercial Air, Rail, and Water Transportation Equipment Rental and Leasing",
    "532412": "Construction, Mining, and Forestry Machinery and Equipment Rental and Leasing",
    "532420": "Office Machinery and Equipment Rental and Leasing",
    "532490": "Other Commercial and Industrial Machinery and Equipment Rental and Leasing",
    "533110": "Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)",
    "541110": "Offices of Lawyers",
    "541120": "Offices of Notaries",
    "541191": "Title Abstract and Settlement Offices",
    "541199": "All Other Legal Services",
    "541211": "Offices of Certified Public Accountants",
    "541213": "Tax Preparation Services",
    "541214": "Payroll Services",
    "541219": "Other Accounting Services",
    "541310": "Architectural Services",
    "541320": "Landscape Architectural Services",
    "541330": "Engineering Services",
    "541340": "Drafting Services",
    "541350": "Building Inspection Services",
    "541360": "Geophysical Surveying and Mapping Services",
    "541370": "Surveying and Mapping (except Geophysical) Services",
    "541380": "Testing Laboratories and Services",
    "541410": "Interior Design Services",
    "541420": "Industrial Design Services",
    "541430": "Graphic Design Services",
    "541490": "Other Specialized Design Services",
    "541511": "Custom Computer Programming Services",
    "541512": "Computer Systems Design Services",
    "541513": "Computer Facilities Management Services",
    "541519": "Other Computer Related Services",
    "541611": "Administrative Management and General Management Consulting Services",
    "541612": "Human Resources Consulting Services",
    "541613": "Marketing Consulting Services",
    "541614": "Process, Physical Distribution, and Logistics Consulting Services",
    "541618": "Other Management Consulting Services",
    "541620": "Environmental Consulting Services",
    "541690": "Other Scientific and Technical Consulting Services",
    "541713": "Research and Development in Nanotechnology",
    "541714": "Research and Development in Biotechnology (except Nanobiotechnology)",
    "541715": "Research and Development in the Physical, Engineering, and Life Sciences (except Nanotechnology and Biotechnology)",
    "541720": "Research and Development in the Social Sciences and Humanities",
    "541810": "Advertising Agencies",
    "541820": "Public Relations Agencies",
    "541830": "Media Buying Agencies",
    "541840": "Media Representatives",
    "541850": "Indoor and Outdoor Display Advertising",
    "541860": "Direct Mail Advertising",
    "541870": "Advertising Material Distribution Services",
    "541890": "Other Services Related to Advertising",
    "541910": "Marketing Research and Public Opinion Polling",
    "541921": "Photography Studios, Portrait",
    "541922": "Commercial Photography",
    "541930": "Translation and Interpretation Services",
    "541940": "Veterinary Services",
    "541990": "All Other Professional, Scientific, and Technical Services",
    "551111": "Offices of Bank Holding Companies",
    "551112": "Offices of Other Holding Companies",
    "551114": "Corporate, Subsidiary, and Regional Managing Offices",
    "561110": "Office Administrative Services",
    "561210": "Facilities Support Services",
    "561311": "Employment Placement Agencies",
    "561312": "Executive Search Services",
    "561320": "Temporary Help Services",
    "561330": "Professional Employer Organizations",
    "561410": "Document Preparation Services",
    "561421": "Telephone Answering Services",
    "561422": "Telemarketing Bureaus and Other Contact Centers",
    "561431": "Private Mail Centers",
    "561439": "Other Business Service Centers (including Copy Shops)",
    "561440": "Collection Agencies",
    "561450": "Credit Bureaus",
    "561491": "Repossession Services",
    "561492": "Court Reporting and Stenotype Services",
    "561499": "All Other Business Support Services",
    "561510": "Travel Agencies",
    "561520": "Tour Operators",
    "561591": "Convention and Visitors Bureaus",
    "561599": "All Other Travel Arrangement and Reservation Services",
    "561611": "Investigation and Personal Background Check Services",
    "561612": "Security Guards and Patrol Services",
    "561613": "Armored Car Services",
    "561621": "Security Systems Services (except Locksmiths)",
    "561622": "Locksmiths",
    "561710": "Exterminating and Pest Control Services",
    "561720": "Janitorial Services",
    "561730": "Landscaping Services",
    "561740": "Carpet and Upholstery Cleaning Services",
    "561790": "Other Services to Buildings and Dwellings",
    "561910": "Packaging and Labeling Services",
    "561920": "Convention and Trade Show Organizers",
    "561990": "All Other Support Services",
    "562111": "Solid Waste Collection",
    "562112": "Hazardous Waste Collection",
    "562119": "Other Waste Collection",
    "562211": "Hazardous Waste Treatment and Disposal",
    "562212": "Solid Waste Landfill",
    "562213": "Solid Waste Combustors and Incinerators",
    "562219": "Other Nonhazardous Waste Treatment and Disposal",
    "562910": "Remediation Services",
    "562920": "Materials Recovery Facilities",
    "562991": "Septic Tank and Related Services",
    "562998": "All Other Miscellaneous Waste Management Services",
    "611110": "Elementary and Secondary Schools",
    "611210": "Junior Colleges",
    "611310": "Colleges, Universities, and Professional Schools",
    "611410": "Business and Secretarial Schools",
    "611420": "Computer Training",
    "611430": "Professional and Management Development Training",
    "611511": "Cosmetology and Barber Schools",
    "611512": "Flight Training",
    "611513": "Apprenticeship Training",
    "611519": "Other Technical and Trade Schools",
    "611610": "Fine Arts Schools",
    "611620": "Sports and Recreation Instruction",
    "611630": "Language Schools",
    "611691": "Exam Preparation and Tutoring",
    "611692": "Automobile Driving Schools",
    "611699": "All Other Miscellaneous Schools and Instruction",
    "611710": "Educational Support Services",
    "621111": "Offices of Physicians (except Mental Health Specialists)",
    "621112": "Offices of Physicians, Mental Health Specialists",
    "621210": "Offices of Dentists",
    "621310": "Offices of Chiropractors",
    "621320": "Offices of Optometrists",
    "621330": "Offices of Mental Health Practitioners (except Physicians)",
    "621340": "Offices of Physical, Occupational and Speech Therapists, and Audiologists",
    "621391": "Offices of Podiatrists",
    "621399": "Offices of All Other Miscellaneous Health Practitioners",
    "621410": "Family Planning Centers",
    "621420": "Outpatient Mental Health and Substance Abuse Centers",
    "621491": "HMO Medical Centers",
    "621492": "Kidney Dialysis Centers",
    "621493": "Freestanding Ambulatory Surgical and Emergency Centers",
    "621498": "All Other Outpatient Care Centers",
    "621511": "Medical Laboratories",
    "621512": "Diagnostic Imaging Centers",
    "621610": "Home Health Care Services",
    "621910": "Ambulance Services",
    "621991": "Blood and Organ Banks",
    "621999": "All Other Miscellaneous Ambulatory Health Care Services",
    "622110": "General Medical and Surgical Hospitals",
    "622210": "Psychiatric and Substance Abuse Hospitals",
    "622310": "Specialty (except Psychiatric and Substance Abuse) Hospitals",
    "623110": "Nursing Care Facilities (Skilled Nursing Facilities)",
    "623210": "Residential Intellectual and Developmental Disability Facilities",
    "623220": "Residential Mental Health and Substance Abuse Facilities",
    "623311": "Continuing Care Retirement Communities",
    "623312": "Assisted Living Facilities for the Elderly",
    "623990": "Other Residential Care Facilities",
    "624110": "Child and Youth Services",
    "624120": "Services for the Elderly and Persons with Disabilities",
    "624190": "Other Individual and Family Services",
    "624210": "Community Food Services",
    "624221": "Temporary Shelters",
    "624229": "Other Community Housing Services",
    "624230": "Emergency and Other Relief Services",
    "624310": "Vocational Rehabilitation Services",
    "624410": "Child Care Services",
    "711110": "Theater Companies and Dinner Theaters",
    "711120": "Dance Companies",
    "711130": "Musical Groups and Artists",
    "711190": "Other Performing Arts Companies",
    "711211": "Sports Teams and Clubs",
    "711212": "Racetracks",
    "711219": "Other Spectator Sports",
    "711310": "Promoters of Performing Arts, Sports, and Similar Events with Facilities",
    "711320": "Promoters of Performing Arts, Sports, and Similar Events without Facilities",
    "711410": "Agents and Managers for Artists, Athletes, Entertainers, and Other Public Figures",
    "711510": "Independent Artists, Writers, and Performers",
    "712110": "Museums",
    "712120": "Historical Sites",
    "712130": "Zoos and Botanical Gardens",
    "712190": "Nature Parks and Other Similar Institutions",
    "713110": "Amusement and Theme Parks",
    "713120": "Amusement Arcades",
    "713210": "Casinos (except Casino Hotels)",
    "713290": "Other Gambling Industries",
    "713910": "Golf Courses and Country Clubs",
    "713920": "Skiing Facilities",
    "713930": "Marinas",
    "713940": "Fitness and Recreational Sports Centers",
    "713950": "Bowling Centers",
    "713990": "All Other Amusement and Recreation Industries",
    "721110": "Hotels (except Casino Hotels) and Motels",
    "721120": "Casino Hotels",
    "721191": "Bed-and-Breakfast Inns",
    "721199": "All Other Traveler Accommodation",
    "721211": "RV (Recreational Vehicle) Parks and Campgrounds",
    "721214": "Recreational and Vacation Camps (except Campgrounds)",
    "721310": "Rooming and Boarding Houses, Dormitories, and Workers' Camps",
    "722310": "Food Service Contractors",
    "722320": "Caterers",
    "722330": "Mobile Food Services",
    "722410": "Drinking Places (Alcoholic Beverages)",
    "722511": "Full-Service Restaurants",
    "722513": "Limited-Service Restaurants",
    "722514": "Cafeterias, Grill Buffets, and Buffets",
    "722515": "Snack and Nonalcoholic Beverage Bars",
    "811111": "General Automotive Repair",
    "811114": "Specialized Automotive Repair",
    "811121": "Automotive Body, Paint, and Interior Repair and Maintenance",
    "811122": "Automotive Glass Replacement Shops",
    "811191": "Automotive Oil Change and Lubrication Shops",
    "811192": "Car Washes",
    "811198": "All Other Automotive Repair and Maintenance",
    "811210": "Electronic and Precision Equipment Repair and Maintenance",
    "811310": "Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance",
    "811411": "Home and Garden Equipment Repair and Maintenance",
    "811412": "Appliance Repair and Maintenance",
    "811420": "Reupholstery and Furniture Repair",
    "811430": "Footwear and Leather Goods Repair",
    "811490": "Other Personal and Household Goods Repair and Maintenance",
    "812111": "Barber Shops",
    "812112": "Beauty Salons",
    "812113": "Nail Salons",
    "812191": "Diet and Weight Reducing Centers",
    "812199": "Other Personal Care Services",
    "812210": "Funeral Homes and Funeral Services",
    "812220": "Cemeteries and Crematories",
    "812310": "Coin-Operated Laundries and Drycleaners",
    "812320": "Drycleaning and Laundry Services (except Coin-Operated)",
    "812331": "Linen Supply",
    "812332": "Industrial Launderers",
    "812910": "Pet Care (except Veterinary) Services",
    "812921": "Photofinishing Laboratories (except One-Hour)",
    "812922": "One-Hour Photofinishing",
    "812930": "Parking Lots and Garages",
    "812990": "All Other Personal Services",
    "813110": "Religious Organizations",
    "813211": "Grantmaking Foundations",
    "813212": "Voluntary Health Organizations",
    "813219": "Other Grantmaking and Giving Services",
    "813311": "Human Rights Organizations",
    "813312": "Environment, Conservation and Wildlife Organizations",
    "813319": "Other Social Advocacy Organizations",
    "813410": "Civic and Social Organizations",
    "813910": "Business Associations",
    "813920": "Professional Organizations",
    "813930": "Labor Unions and Similar Labor Organizations",
    "813940": "Political Organizations",
    "813990": "Other Similar Organizations (except Business, Professional, Labor, and Political Organizations)",
    "814110": "Private Households",
    "921110": "Executive Offices",
    "921120": "Legislative Bodies",
    "921130": "Public Finance Activities",
    "921140": "Executive and Legislative Offices, Combined",
    "921150": "American Indian and Alaska Native Tribal Governments",
    "921190": "Other General Government Support",
    "922110": "Courts",
    "922120": "Police Protection",
    "922130": "Legal Counsel and Prosecution",
    "922140": "Correctional Institutions",
    "922150": "Parole Offices and Probation Offices",
    "922160": "Fire Protection",
    "922190": "Other Justice, Public Order, and Safety Activities",
    "923110": "Administration of Education Programs",
    "923120": "Administration of Public Health Programs",
    "923130": "Administration of Human Resource Programs (except Education, Public Health, and Veterans' Affairs Programs)",
    "923140": "Administration of Veterans' Affairs",
    "924110": "Administration of Air and Water Resource and Solid Waste Management Programs",
    "924120": "Administration of Conservation Programs",
    "925110": "Administration of Housing Programs",
    "925120": "Administration of Urban Planning and Community and Rural Development",
    "926110": "Administration of General Economic Programs",
    "926120": "Regulation and Administration of Transportation Programs",
    "926130": "Regulation and Administration of Communications, Electric, Gas, and Other Utilities",
    "926140": "Regulation of Agricultural Marketing and Commodities",
    "926150": "Regulation, Licensing, and Inspection of Miscellaneous Commercial Sectors",
    "927110": "Space Research and Technology",
    "928110": "National Security",
    "928120": "International Affairs"
};

});

parcelRegister("7iur0", function(module, exports) {
const $04c3bc4ea8510ff8$export$c391fea5aabc9bf9 = {
    NEW_TICKET: "https://info.humcapital.com/hum-help-center/kb-tickets/new"
};

});



parcelRegister("a3VvM", function(module, exports) {

var $5sKyw = parcelRequire("5sKyw");
function $a1e704937cfa88f3$export$896f05ac6d3a700c(arr) {
    const obj = {};
    arr.forEach((value)=>{
        const id = (0, $5sKyw.default)();
        obj[id] = {
            ...value,
            id: id
        };
    });
    return obj;
}

});
parcelRegister("5sKyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa3ae484854b431$export$2e2bcd8739ae039);

var $aZg8W = parcelRequire("aZg8W");

var $7qKRb = parcelRequire("7qKRb");

var $2uohp = parcelRequire("2uohp");
function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $aZg8W.default).randomUUID && !buf && !options) return (0, $aZg8W.default).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $7qKRb.default)();
    if (rnds.length < 16) throw new Error("Random bytes length must be >= 16");
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $2uohp.unsafeStringify)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;

});
parcelRegister("aZg8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ffc1f94643dc7e4$export$2e2bcd8739ae039);
const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};

});

parcelRegister("7qKRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f4ee4022ba00e$export$2e2bcd8739ae039);
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        if (typeof crypto === "undefined" || !crypto.getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
        $568f4ee4022ba00e$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}

});

parcelRegister("2uohp", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $1d0137947e8554ce$export$8fb373d660548968);

var $64ZUg = parcelRequire("64ZUg");
const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    return ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset);
    if (!(0, $64ZUg.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;

});
parcelRegister("64ZUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d323206dcbf256$export$2e2bcd8739ae039);

var $4meF0 = parcelRequire("4meF0");
function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $4meF0.default).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;

});
parcelRegister("4meF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c496bfb6c27b56$export$2e2bcd8739ae039);
var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});





parcelRegister("fjko4", function(module, exports) {

$parcel$export(module.exports, "isoDateFormat", () => $89b4526c8ca316e6$export$b0f7439824c9ada5);
$parcel$export(module.exports, "isoToDate", () => $89b4526c8ca316e6$export$c48b34952eaba2d6);
function $89b4526c8ca316e6$export$b0f7439824c9ada5(month, year) {
    // Check if month or year is undefined or null
    if (!month || !year) return null;
    const monthIndex = new Date(`${month} 1, 2000`).getMonth();
    if (isNaN(monthIndex)) throw new Error("Invalid month provided");
    const yearNumber = parseInt(year, 10);
    if (isNaN(yearNumber) || yearNumber < 1000 || yearNumber > 9999) throw new Error("Invalid year provided");
    const date = new Date(yearNumber, monthIndex, 1);
    return date.toISOString();
}
function $89b4526c8ca316e6$export$c48b34952eaba2d6(isoDateString, addZulu = false, withTime = false) {
    if (!isoDateString) return "";
    let date;
    if (addZulu) {
        const cleanDateString = isoDateString.replace(/(\.\d{3})\d+/, "$1");
        date = new Date(cleanDateString + "Z");
    } else if (isoDateString.includes("T")) date = new Date(isoDateString);
    else date = new Date(isoDateString + "T00:00:00");
    if (isNaN(date.getTime())) return "";
    const dateFormatted = date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric"
    });
    if (withTime) {
        const timeFormatted = date.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
            timeZone: "UTC"
        });
        return `${dateFormatted} ${timeFormatted}`;
    }
    return dateFormatted;
}

});

parcelRegister("lvlqo", function(module, exports) {

$parcel$export(module.exports, "formattedUrl", () => $f805a585da42c014$export$84cd001210bf41f4);
$parcel$export(module.exports, "ensureHttps", () => $f805a585da42c014$export$7922d75917fe9d65);
$parcel$export(module.exports, "URL_REGEX", () => $f805a585da42c014$export$820ae0844b3faa33);
function $f805a585da42c014$export$84cd001210bf41f4(url) {
    const trimmedUrl = url?.trim();
    if (!trimmedUrl) return "";
    let domain = trimmedUrl.replace(/(^\w+:|^)\/\//, "");
    domain = domain.replace(/^www\./, "");
    domain = domain.split("/")[0];
    return domain;
}
function $f805a585da42c014$export$7922d75917fe9d65(url) {
    const website = $f805a585da42c014$export$84cd001210bf41f4(url);
    return `https://${website}`;
}
const $f805a585da42c014$export$820ae0844b3faa33 = /^(?:(?:https?):\/\/)?(?:www\.)?[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+(?::\d{1,5})?(?:\/[^\s]*)?$/i;

});

parcelRegister("7ZRJK", function(module, exports) {

$parcel$export(module.exports, "useModalState", () => $c55eca17965e4d82$export$baa48889c42cc6cb);

var $acw62 = parcelRequire("acw62");
function $c55eca17965e4d82$export$baa48889c42cc6cb(initial = false) {
    const [showModal, setShowModal] = (0, $acw62.useState)(initial);
    const toggle = (0, $acw62.useCallback)(()=>{
        setShowModal(!showModal);
    }, [
        showModal,
        setShowModal
    ]);
    const close = (0, $acw62.useCallback)(()=>{
        setShowModal(false);
    }, [
        showModal,
        setShowModal
    ]);
    const open = (0, $acw62.useCallback)(()=>{
        setShowModal(true);
    }, [
        showModal,
        setShowModal
    ]);
    return {
        isOpen: showModal,
        isClosed: !showModal,
        toggle: toggle,
        close: close,
        open: open
    };
}

});

parcelRegister("3y6NQ", function(module, exports) {

$parcel$export(module.exports, "useFilters", () => $7e316827da03d3fe$export$973ca22476b0e05f);

var $r2uF6 = parcelRequire("r2uF6");

var $acw62 = parcelRequire("acw62");
function $7e316827da03d3fe$export$973ca22476b0e05f(atom) {
    const [filters, setFilters] = (0, $r2uF6.useAtom)(atom);
    const set = (0, $acw62.useCallback)((next)=>{
        setFilters({
            ...filters,
            ...next
        });
    }, [
        setFilters,
        filters
    ]);
    return {
        filters: filters,
        setFilters: set
    };
}

});
parcelRegister("r2uF6", function(module, exports) {
"use strict";

var $8dPdT = parcelRequire("8dPdT");

var $1ii2J = parcelRequire("1ii2J");
Object.keys($8dPdT).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call(module.exports, k)) Object.defineProperty(module.exports, k, {
        enumerable: true,
        get: function() {
            return $8dPdT[k];
        }
    });
});
Object.keys($1ii2J).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call(module.exports, k)) Object.defineProperty(module.exports, k, {
        enumerable: true,
        get: function() {
            return $1ii2J[k];
        }
    });
});

});
parcelRegister("8dPdT", function(module, exports) {

$parcel$export(module.exports, "atom", () => $5fc7457900d13db1$export$5fb5cc0d078610b, (v) => $5fc7457900d13db1$export$5fb5cc0d078610b = v);
$parcel$export(module.exports, "createStore", () => $5fc7457900d13db1$export$f51a9068ac82ea43, (v) => $5fc7457900d13db1$export$f51a9068ac82ea43 = v);
$parcel$export(module.exports, "getDefaultStore", () => $5fc7457900d13db1$export$39b2e4393dfcb8aa, (v) => $5fc7457900d13db1$export$39b2e4393dfcb8aa = v);
var $5fc7457900d13db1$export$5fb5cc0d078610b;
var $5fc7457900d13db1$export$f51a9068ac82ea43;
var $5fc7457900d13db1$export$39b2e4393dfcb8aa;
"use strict";
var $5fc7457900d13db1$var$keyCount = 0;
function $5fc7457900d13db1$var$atom(read, write) {
    var key = "atom" + ++$5fc7457900d13db1$var$keyCount;
    var config = {
        toString: function toString() {
            return key;
        }
    };
    if (typeof read === "function") config.read = read;
    else {
        config.init = read;
        config.read = $5fc7457900d13db1$var$defaultRead;
        config.write = $5fc7457900d13db1$var$defaultWrite;
    }
    if (write) config.write = write;
    return config;
}
function $5fc7457900d13db1$var$defaultRead(get) {
    return get(this);
}
function $5fc7457900d13db1$var$defaultWrite(get, set, arg) {
    return set(this, typeof arg === "function" ? arg(get(this)) : arg);
}
function $5fc7457900d13db1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5fc7457900d13db1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5fc7457900d13db1$var$_arrayLikeToArray(o, minLen);
}
function $5fc7457900d13db1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5fc7457900d13db1$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $5fc7457900d13db1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $5fc7457900d13db1$var$isSelfAtom = function isSelfAtom(atom, a) {
    return atom.unstable_is ? atom.unstable_is(a) : a === atom;
};
var $5fc7457900d13db1$var$hasInitialValue = function hasInitialValue(atom) {
    return "init" in atom;
};
var $5fc7457900d13db1$var$isActuallyWritableAtom = function isActuallyWritableAtom(atom) {
    return !!atom.write;
};
var $5fc7457900d13db1$var$cancelPromiseMap = new WeakMap();
var $5fc7457900d13db1$var$registerCancelPromise = function registerCancelPromise(promise, cancel) {
    $5fc7457900d13db1$var$cancelPromiseMap.set(promise, cancel);
    promise.catch(function() {}).finally(function() {
        return $5fc7457900d13db1$var$cancelPromiseMap.delete(promise);
    });
};
var $5fc7457900d13db1$var$cancelPromise = function cancelPromise(promise, next) {
    var cancel = $5fc7457900d13db1$var$cancelPromiseMap.get(promise);
    if (cancel) {
        $5fc7457900d13db1$var$cancelPromiseMap.delete(promise);
        cancel(next);
    }
};
var $5fc7457900d13db1$var$resolvePromise = function resolvePromise(promise, value) {
    promise.status = "fulfilled";
    promise.value = value;
};
var $5fc7457900d13db1$var$rejectPromise = function rejectPromise(promise, e) {
    promise.status = "rejected";
    promise.reason = e;
};
var $5fc7457900d13db1$var$isPromiseLike = function isPromiseLike(x) {
    return typeof (x == null ? void 0 : x.then) === "function";
};
var $5fc7457900d13db1$var$isEqualAtomValue = function isEqualAtomValue(a, b) {
    return !!a && "v" in a && "v" in b && Object.is(a.v, b.v);
};
var $5fc7457900d13db1$var$isEqualAtomError = function isEqualAtomError(a, b) {
    return !!a && "e" in a && "e" in b && Object.is(a.e, b.e);
};
var $5fc7457900d13db1$var$hasPromiseAtomValue = function hasPromiseAtomValue(a) {
    return !!a && "v" in a && a.v instanceof Promise;
};
var $5fc7457900d13db1$var$isEqualPromiseAtomValue = function isEqualPromiseAtomValue(a, b) {
    return "v" in a && "v" in b && a.v.orig && a.v.orig === b.v.orig;
};
var $5fc7457900d13db1$var$returnAtomValue = function returnAtomValue(atomState) {
    if ("e" in atomState) throw atomState.e;
    return atomState.v;
};
var $5fc7457900d13db1$var$createStore$1 = function createStore() {
    var atomStateMap = new WeakMap();
    var mountedMap = new WeakMap();
    var pendingStack = [];
    var pendingMap = new WeakMap();
    var devListenersRev2;
    var mountedAtoms;
    var getAtomState = function getAtomState(atom) {
        return atomStateMap.get(atom);
    };
    var addPendingDependent = function addPendingDependent(atom, atomState) {
        atomState.d.forEach(function(_, a) {
            if (!pendingMap.has(a)) {
                var _pendingStack;
                var aState = getAtomState(a);
                (_pendingStack = pendingStack[pendingStack.length - 1]) == null || _pendingStack.add(a);
                pendingMap.set(a, [
                    aState,
                    new Set()
                ]);
                if (aState) addPendingDependent(a, aState);
            }
            pendingMap.get(a)[1].add(atom);
        });
    };
    var setAtomState = function setAtomState(atom, atomState) {
        var prevAtomState = getAtomState(atom);
        atomStateMap.set(atom, atomState);
        if (!pendingMap.has(atom)) {
            var _pendingStack2;
            (_pendingStack2 = pendingStack[pendingStack.length - 1]) == null || _pendingStack2.add(atom);
            pendingMap.set(atom, [
                prevAtomState,
                new Set()
            ]);
            addPendingDependent(atom, atomState);
        }
        if ($5fc7457900d13db1$var$hasPromiseAtomValue(prevAtomState)) {
            var _next = "v" in atomState ? atomState.v instanceof Promise ? atomState.v : Promise.resolve(atomState.v) : Promise.reject(atomState.e);
            if (prevAtomState.v !== _next) $5fc7457900d13db1$var$cancelPromise(prevAtomState.v, _next);
        }
    };
    var updateDependencies = function updateDependencies(atom, nextAtomState, nextDependencies, keepPreviousDependencies) {
        var dependencies = new Map(keepPreviousDependencies ? nextAtomState.d : null);
        var changed = false;
        nextDependencies.forEach(function(aState, a) {
            if (!aState && $5fc7457900d13db1$var$isSelfAtom(atom, a)) aState = nextAtomState;
            if (aState) {
                dependencies.set(a, aState);
                if (nextAtomState.d.get(a) !== aState) changed = true;
            }
        });
        if (changed || nextAtomState.d.size !== dependencies.size) nextAtomState.d = dependencies;
    };
    var setAtomValue = function setAtomValue(atom, value, nextDependencies, keepPreviousDependencies) {
        var prevAtomState = getAtomState(atom);
        var nextAtomState = {
            d: (prevAtomState == null ? void 0 : prevAtomState.d) || new Map(),
            v: value
        };
        if (nextDependencies) updateDependencies(atom, nextAtomState, nextDependencies, keepPreviousDependencies);
        if ($5fc7457900d13db1$var$isEqualAtomValue(prevAtomState, nextAtomState) && prevAtomState.d === nextAtomState.d) return prevAtomState;
        if ($5fc7457900d13db1$var$hasPromiseAtomValue(prevAtomState) && $5fc7457900d13db1$var$hasPromiseAtomValue(nextAtomState) && $5fc7457900d13db1$var$isEqualPromiseAtomValue(prevAtomState, nextAtomState)) {
            if (prevAtomState.d === nextAtomState.d) return prevAtomState;
            else nextAtomState.v = prevAtomState.v;
        }
        setAtomState(atom, nextAtomState);
        return nextAtomState;
    };
    var setAtomValueOrPromise = function setAtomValueOrPromise(atom, valueOrPromise, nextDependencies, abortPromise) {
        if ($5fc7457900d13db1$var$isPromiseLike(valueOrPromise)) {
            var continuePromise;
            var updatePromiseDependencies = function updatePromiseDependencies() {
                var prevAtomState = getAtomState(atom);
                if (!$5fc7457900d13db1$var$hasPromiseAtomValue(prevAtomState) || prevAtomState.v !== promise) return;
                var nextAtomState = setAtomValue(atom, promise, nextDependencies);
                if (mountedMap.has(atom) && prevAtomState.d !== nextAtomState.d) mountDependencies(atom, nextAtomState, prevAtomState.d);
            };
            var promise = new Promise(function(resolve, reject) {
                var settled = false;
                valueOrPromise.then(function(v) {
                    if (!settled) {
                        settled = true;
                        $5fc7457900d13db1$var$resolvePromise(promise, v);
                        resolve(v);
                        updatePromiseDependencies();
                    }
                }, function(e) {
                    if (!settled) {
                        settled = true;
                        $5fc7457900d13db1$var$rejectPromise(promise, e);
                        reject(e);
                        updatePromiseDependencies();
                    }
                });
                continuePromise = function continuePromise(next) {
                    if (!settled) {
                        settled = true;
                        next.then(function(v) {
                            return $5fc7457900d13db1$var$resolvePromise(promise, v);
                        }, function(e) {
                            return $5fc7457900d13db1$var$rejectPromise(promise, e);
                        });
                        resolve(next);
                    }
                };
            });
            promise.orig = valueOrPromise;
            promise.status = "pending";
            $5fc7457900d13db1$var$registerCancelPromise(promise, function(next) {
                if (next) continuePromise(next);
                abortPromise == null || abortPromise();
            });
            return setAtomValue(atom, promise, nextDependencies, true);
        }
        return setAtomValue(atom, valueOrPromise, nextDependencies);
    };
    var setAtomError = function setAtomError(atom, error, nextDependencies) {
        var prevAtomState = getAtomState(atom);
        var nextAtomState = {
            d: (prevAtomState == null ? void 0 : prevAtomState.d) || new Map(),
            e: error
        };
        if (nextDependencies) updateDependencies(atom, nextAtomState, nextDependencies);
        if ($5fc7457900d13db1$var$isEqualAtomError(prevAtomState, nextAtomState) && prevAtomState.d === nextAtomState.d) return prevAtomState;
        setAtomState(atom, nextAtomState);
        return nextAtomState;
    };
    var readAtomState = function readAtomState(atom, force) {
        var atomState = getAtomState(atom);
        if (!force && atomState) {
            if (mountedMap.has(atom)) return atomState;
            if (Array.from(atomState.d).every(function(_ref) {
                var a = _ref[0], s = _ref[1];
                if (a === atom) return true;
                var aState = readAtomState(a);
                return aState === s || $5fc7457900d13db1$var$isEqualAtomValue(aState, s);
            })) return atomState;
        }
        var nextDependencies = new Map();
        var isSync = true;
        var getter = function getter(a) {
            if ($5fc7457900d13db1$var$isSelfAtom(atom, a)) {
                var _aState = getAtomState(a);
                if (_aState) {
                    nextDependencies.set(a, _aState);
                    return $5fc7457900d13db1$var$returnAtomValue(_aState);
                }
                if ($5fc7457900d13db1$var$hasInitialValue(a)) {
                    nextDependencies.set(a, undefined);
                    return a.init;
                }
                throw new Error("no atom init");
            }
            var aState = readAtomState(a);
            nextDependencies.set(a, aState);
            return $5fc7457900d13db1$var$returnAtomValue(aState);
        };
        var controller;
        var setSelf;
        var options = {
            get signal () {
                if (!controller) controller = new AbortController();
                return controller.signal;
            },
            get setSelf () {
                if (!setSelf && $5fc7457900d13db1$var$isActuallyWritableAtom(atom)) setSelf = function setSelf() {
                    if (!isSync) {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        return writeAtom.apply(void 0, [
                            atom
                        ].concat(args));
                    }
                };
                return setSelf;
            }
        };
        try {
            var valueOrPromise = atom.read(getter, options);
            return setAtomValueOrPromise(atom, valueOrPromise, nextDependencies, function() {
                var _controller;
                return (_controller = controller) == null ? void 0 : _controller.abort();
            });
        } catch (error) {
            return setAtomError(atom, error, nextDependencies);
        } finally{
            isSync = false;
        }
    };
    var readAtom = function readAtom(atom) {
        return $5fc7457900d13db1$var$returnAtomValue(readAtomState(atom));
    };
    var recomputeDependents = function recomputeDependents(atom) {
        var getDependents = function getDependents(a) {
            var _mountedMap$get, _pendingMap$get;
            var dependents = new Set((_mountedMap$get = mountedMap.get(a)) == null ? void 0 : _mountedMap$get.t);
            (_pendingMap$get = pendingMap.get(a)) == null || _pendingMap$get[1].forEach(function(dependent) {
                dependents.add(dependent);
            });
            return dependents;
        };
        var topsortedAtoms = new Array();
        var markedAtoms = new Set();
        var visit = function visit(n) {
            if (markedAtoms.has(n)) return;
            markedAtoms.add(n);
            for(var _iterator = $5fc7457900d13db1$var$_createForOfIteratorHelperLoose(getDependents(n)), _step; !(_step = _iterator()).done;){
                var m = _step.value;
                if (n !== m) visit(m);
            }
            topsortedAtoms.push(n);
        };
        visit(atom);
        var changedAtoms = new Set([
            atom
        ]);
        for(var i = topsortedAtoms.length - 1; i >= 0; --i){
            var _a = topsortedAtoms[i];
            var _prevAtomState = getAtomState(_a);
            if (!_prevAtomState) continue;
            var hasChangedDeps = false;
            for(var _iterator2 = $5fc7457900d13db1$var$_createForOfIteratorHelperLoose(_prevAtomState.d.keys()), _step2; !(_step2 = _iterator2()).done;){
                var dep = _step2.value;
                if (dep !== _a && changedAtoms.has(dep)) {
                    hasChangedDeps = true;
                    break;
                }
            }
            if (hasChangedDeps) {
                var nextAtomState = readAtomState(_a, true);
                if (!$5fc7457900d13db1$var$isEqualAtomValue(_prevAtomState, nextAtomState)) changedAtoms.add(_a);
            }
        }
    };
    var writeAtomState = function writeAtomState(atom) {
        var getter = function getter(a) {
            return $5fc7457900d13db1$var$returnAtomValue(readAtomState(a));
        };
        var setter = function setter(a) {
            var isSync = pendingStack.length > 0;
            if (!isSync) pendingStack.push(new Set([
                a
            ]));
            var r;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            if ($5fc7457900d13db1$var$isSelfAtom(atom, a)) {
                if (!$5fc7457900d13db1$var$hasInitialValue(a)) throw new Error("atom not writable");
                var _prevAtomState2 = getAtomState(a);
                var nextAtomState = setAtomValueOrPromise(a, args[0]);
                if (!$5fc7457900d13db1$var$isEqualAtomValue(_prevAtomState2, nextAtomState)) recomputeDependents(a);
            } else r = writeAtomState.apply(void 0, [
                a
            ].concat(args));
            if (!isSync) var flushed = flushPending(pendingStack.pop());
            return r;
        };
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        var result = atom.write.apply(atom, [
            getter,
            setter
        ].concat(args));
        return result;
    };
    var writeAtom = function writeAtom(atom) {
        pendingStack.push(new Set([
            atom
        ]));
        for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
        var result = writeAtomState.apply(void 0, [
            atom
        ].concat(args));
        var flushed = flushPending(pendingStack.pop());
        return result;
    };
    var mountAtom = function mountAtom(atom, initialDependent, onMountQueue) {
        var _getAtomState;
        var existingMount = mountedMap.get(atom);
        if (existingMount) {
            if (initialDependent) existingMount.t.add(initialDependent);
            return existingMount;
        }
        var queue = onMountQueue || [];
        (_getAtomState = getAtomState(atom)) == null || _getAtomState.d.forEach(function(_, a) {
            if (a !== atom) mountAtom(a, atom, queue);
        });
        readAtomState(atom);
        var mounted = {
            t: new Set(initialDependent && [
                initialDependent
            ]),
            l: new Set()
        };
        mountedMap.set(atom, mounted);
        if ($5fc7457900d13db1$var$isActuallyWritableAtom(atom) && atom.onMount) {
            var onMount = atom.onMount;
            queue.push(function() {
                var onUnmount = onMount(function() {
                    for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
                    return writeAtom.apply(void 0, [
                        atom
                    ].concat(args));
                });
                if (onUnmount) mounted.u = onUnmount;
            });
        }
        if (!onMountQueue) queue.forEach(function(f) {
            return f();
        });
        return mounted;
    };
    var canUnmountAtom = function canUnmountAtom(atom, mounted) {
        return !mounted.l.size && (!mounted.t.size || mounted.t.size === 1 && mounted.t.has(atom));
    };
    var tryUnmountAtom = function tryUnmountAtom(atom, mounted) {
        if (!canUnmountAtom(atom, mounted)) return;
        var onUnmount = mounted.u;
        if (onUnmount) onUnmount();
        mountedMap.delete(atom);
        var atomState = getAtomState(atom);
        if (atomState) {
            if ($5fc7457900d13db1$var$hasPromiseAtomValue(atomState)) $5fc7457900d13db1$var$cancelPromise(atomState.v);
            atomState.d.forEach(function(_, a) {
                if (a !== atom) {
                    var mountedDep = mountedMap.get(a);
                    if (mountedDep) {
                        mountedDep.t.delete(atom);
                        tryUnmountAtom(a, mountedDep);
                    }
                }
            });
        }
    };
    var mountDependencies = function mountDependencies(atom, atomState, prevDependencies) {
        var depSet = new Set(atomState.d.keys());
        var maybeUnmountAtomSet = new Set();
        prevDependencies == null || prevDependencies.forEach(function(_, a) {
            if (depSet.has(a)) {
                depSet.delete(a);
                return;
            }
            maybeUnmountAtomSet.add(a);
            var mounted = mountedMap.get(a);
            if (mounted) mounted.t.delete(atom);
        });
        depSet.forEach(function(a) {
            mountAtom(a, atom);
        });
        maybeUnmountAtomSet.forEach(function(a) {
            var mounted = mountedMap.get(a);
            if (mounted) tryUnmountAtom(a, mounted);
        });
    };
    var flushPending = function flushPending(pendingAtoms) {
        var flushed;
        var pending = [];
        var collectPending = function collectPending(pendingAtom) {
            var _getAtomState2;
            if (!pendingMap.has(pendingAtom)) return;
            var _ref2 = pendingMap.get(pendingAtom), prevAtomState = _ref2[0], dependents = _ref2[1];
            pendingMap.delete(pendingAtom);
            pending.push([
                pendingAtom,
                prevAtomState
            ]);
            dependents.forEach(collectPending);
            (_getAtomState2 = getAtomState(pendingAtom)) == null || _getAtomState2.d.forEach(function(_, a) {
                return collectPending(a);
            });
        };
        pendingAtoms.forEach(collectPending);
        pending.forEach(function(_ref3) {
            var atom = _ref3[0], prevAtomState = _ref3[1];
            var atomState = getAtomState(atom);
            if (!atomState) return;
            if (atomState !== prevAtomState) {
                var mounted = mountedMap.get(atom);
                if (mounted && atomState.d !== (prevAtomState == null ? void 0 : prevAtomState.d)) mountDependencies(atom, atomState, prevAtomState == null ? void 0 : prevAtomState.d);
                if (mounted && !(!$5fc7457900d13db1$var$hasPromiseAtomValue(prevAtomState) && ($5fc7457900d13db1$var$isEqualAtomValue(prevAtomState, atomState) || $5fc7457900d13db1$var$isEqualAtomError(prevAtomState, atomState)))) mounted.l.forEach(function(listener) {
                    return listener();
                });
            }
        });
    };
    var subscribeAtom = function subscribeAtom(atom, listener) {
        var mounted = mountAtom(atom);
        var flushed = flushPending([
            atom
        ]);
        var listeners = mounted.l;
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
            tryUnmountAtom(atom, mounted);
        };
    };
    return {
        get: readAtom,
        set: writeAtom,
        sub: subscribeAtom
    };
};
var $5fc7457900d13db1$var$defaultStore;
var $5fc7457900d13db1$var$getDefaultStore$1 = function getDefaultStore() {
    if (!$5fc7457900d13db1$var$defaultStore) {
        $5fc7457900d13db1$var$defaultStore = $5fc7457900d13db1$var$createStore$1();
        var _ref4;
    }
    return $5fc7457900d13db1$var$defaultStore;
};
var $5fc7457900d13db1$var$createStore = $5fc7457900d13db1$var$createStore$1;
var $5fc7457900d13db1$var$getDefaultStore = $5fc7457900d13db1$var$getDefaultStore$1;
$5fc7457900d13db1$export$5fb5cc0d078610b = $5fc7457900d13db1$var$atom;
$5fc7457900d13db1$export$f51a9068ac82ea43 = $5fc7457900d13db1$var$createStore;
$5fc7457900d13db1$export$39b2e4393dfcb8aa = $5fc7457900d13db1$var$getDefaultStore;

});

parcelRegister("1ii2J", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $0f1577dd80096b6b$export$2881499e37b75b9a, (v) => $0f1577dd80096b6b$export$2881499e37b75b9a = v);
$parcel$export(module.exports, "useAtom", () => $0f1577dd80096b6b$export$83cf7ae8bb57e7ed, (v) => $0f1577dd80096b6b$export$83cf7ae8bb57e7ed = v);
$parcel$export(module.exports, "useAtomValue", () => $0f1577dd80096b6b$export$89a40582f8c436cc, (v) => $0f1577dd80096b6b$export$89a40582f8c436cc = v);
$parcel$export(module.exports, "useSetAtom", () => $0f1577dd80096b6b$export$a247c952d39ea7ea, (v) => $0f1577dd80096b6b$export$a247c952d39ea7ea = v);
$parcel$export(module.exports, "useStore", () => $0f1577dd80096b6b$export$6ccbb43953eebf8, (v) => $0f1577dd80096b6b$export$6ccbb43953eebf8 = v);
var $0f1577dd80096b6b$export$2881499e37b75b9a;
var $0f1577dd80096b6b$export$83cf7ae8bb57e7ed;
var $0f1577dd80096b6b$export$89a40582f8c436cc;
var $0f1577dd80096b6b$export$a247c952d39ea7ea;
var $0f1577dd80096b6b$export$6ccbb43953eebf8;
"use client";
"use strict";

var $acw62 = parcelRequire("acw62");

var $8dPdT = parcelRequire("8dPdT");
var $0f1577dd80096b6b$var$StoreContext = $acw62.createContext(undefined);
var $0f1577dd80096b6b$var$useStore = function useStore(options) {
    var store = $acw62.useContext($0f1577dd80096b6b$var$StoreContext);
    return (options == null ? void 0 : options.store) || store || $8dPdT.getDefaultStore();
};
var $0f1577dd80096b6b$var$Provider = function Provider(_ref) {
    var children = _ref.children, store = _ref.store;
    var storeRef = $acw62.useRef();
    if (!store && !storeRef.current) storeRef.current = $8dPdT.createStore();
    return $acw62.createElement($0f1577dd80096b6b$var$StoreContext.Provider, {
        value: store || storeRef.current
    }, children);
};
var $0f1577dd80096b6b$var$isPromiseLike = function isPromiseLike(x) {
    return typeof (x == null ? void 0 : x.then) === "function";
};
var $0f1577dd80096b6b$var$use = $acw62.use || function(promise) {
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        promise.status = "pending";
        promise.then(function(v) {
            promise.status = "fulfilled";
            promise.value = v;
        }, function(e) {
            promise.status = "rejected";
            promise.reason = e;
        });
        throw promise;
    }
};
function $0f1577dd80096b6b$var$useAtomValue(atom, options) {
    var store = $0f1577dd80096b6b$var$useStore(options);
    var _useReducer = $acw62.useReducer(function(prev) {
        var nextValue = store.get(atom);
        if (Object.is(prev[0], nextValue) && prev[1] === store && prev[2] === atom) return prev;
        return [
            nextValue,
            store,
            atom
        ];
    }, undefined, function() {
        return [
            store.get(atom),
            store,
            atom
        ];
    }), _useReducer$ = _useReducer[0], valueFromReducer = _useReducer$[0], storeFromReducer = _useReducer$[1], atomFromReducer = _useReducer$[2], rerender = _useReducer[1];
    var value = valueFromReducer;
    if (storeFromReducer !== store || atomFromReducer !== atom) {
        rerender();
        value = store.get(atom);
    }
    var delay = options == null ? void 0 : options.delay;
    $acw62.useEffect(function() {
        var unsub = store.sub(atom, function() {
            if (typeof delay === "number") {
                setTimeout(rerender, delay);
                return;
            }
            rerender();
        });
        rerender();
        return unsub;
    }, [
        store,
        atom,
        delay
    ]);
    $acw62.useDebugValue(value);
    return $0f1577dd80096b6b$var$isPromiseLike(value) ? $0f1577dd80096b6b$var$use(value) : value;
}
function $0f1577dd80096b6b$var$useSetAtom(atom, options) {
    var store = $0f1577dd80096b6b$var$useStore(options);
    var setAtom = $acw62.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return store.set.apply(store, [
            atom
        ].concat(args));
    }, [
        store,
        atom
    ]);
    return setAtom;
}
function $0f1577dd80096b6b$var$useAtom(atom, options) {
    return [
        $0f1577dd80096b6b$var$useAtomValue(atom, options),
        $0f1577dd80096b6b$var$useSetAtom(atom, options)
    ];
}
$0f1577dd80096b6b$export$2881499e37b75b9a = $0f1577dd80096b6b$var$Provider;
$0f1577dd80096b6b$export$83cf7ae8bb57e7ed = $0f1577dd80096b6b$var$useAtom;
$0f1577dd80096b6b$export$89a40582f8c436cc = $0f1577dd80096b6b$var$useAtomValue;
$0f1577dd80096b6b$export$a247c952d39ea7ea = $0f1577dd80096b6b$var$useSetAtom;
$0f1577dd80096b6b$export$6ccbb43953eebf8 = $0f1577dd80096b6b$var$useStore;

});



parcelRegister("3ubHA", function(module, exports) {

$parcel$export(module.exports, "useDebounce", () => $7753a178ebca8df9$export$21805fee57372823);

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");
const $7753a178ebca8df9$export$21805fee57372823 = (callback, delay)=>{
    const debouncedCallback = (0, $acw62.useCallback)((0, $f1q41.debounce)(callback, delay), [
        callback,
        delay
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            debouncedCallback.cancel();
        };
    }, [
        debouncedCallback
    ]);
    return debouncedCallback;
};

});
parcelRegister("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});


parcelRegister("4sFVK", function(module, exports) {

$parcel$export(module.exports, "useFlowState", () => $030d3284f6ae8d23$export$76121325b827745d);

var $r2uF6 = parcelRequire("r2uF6");

var $acw62 = parcelRequire("acw62");
function $030d3284f6ae8d23$export$76121325b827745d(atom) {
    const [showModal, setShowModal] = (0, $r2uF6.useAtom)(atom);
    const toggle = (0, $acw62.useCallback)(()=>{
        setShowModal(!showModal);
    }, [
        showModal,
        setShowModal
    ]);
    const close = (0, $acw62.useCallback)(()=>{
        setShowModal(false);
    }, [
        showModal,
        setShowModal
    ]);
    const open = (0, $acw62.useCallback)(()=>{
        setShowModal(true);
    }, [
        showModal,
        setShowModal
    ]);
    return {
        isOpen: showModal,
        isClosed: !showModal,
        toggle: toggle,
        close: close,
        open: open
    };
}

});

parcelRegister("lGvmR", function(module, exports) {

$parcel$export(module.exports, "getGreeting", () => $7e333a4eb43b6043$export$7d40b74701d8a439);
const $7e333a4eb43b6043$export$7d40b74701d8a439 = ()=>{
    const today = new Date();
    const currentHour = today.getHours();
    if (currentHour < 12) return "Good Morning";
    else if (currentHour < 18) return "Good Afternoon";
    else return "Good Evening";
};

});

parcelRegister("eNziG", function(module, exports) {
function $6e740846b0564ef1$export$204749b7c99dc7d2(anEnum) {
    const enumValues = Object.keys(anEnum).map((n)=>Number.parseInt(n)).filter((n)=>!Number.isNaN(n));
    const randomIndex = Math.floor(Math.random() * enumValues.length);
    const randomEnumValue = enumValues[randomIndex];
    return randomEnumValue;
}
function $6e740846b0564ef1$export$ae68b50487fe6299(object) {
    const keys = Object.keys(object);
    const randomKey = keys[Math.floor(Math.random() * keys.length)];
    return object[randomKey];
}

});

parcelRegister("98Yiq", function(module, exports) {

$parcel$export(module.exports, "selectOptionsFromMap", () => $fa39ec168166caae$export$73ea8a5f70a253e1);
const $fa39ec168166caae$export$73ea8a5f70a253e1 = (options)=>Object.entries(options).map(([value, label])=>({
            label: label,
            value: value
        }));

});

parcelRegister("eVw89", function(module, exports) {
/**
 * Transforms an array of objects into a single object where each key represents
 * a path to a specific value in the original array. The resulting object keys
 * are in the format `${arrayName}[${index}].${key}`.
 *
 * @param arrayName - The base name for the array, used in the resulting object keys.
 * @param array - The array of objects to be transformed.
 * @returns An object with keys representing the path to each value in the original array.
 */ function $e6d317f2756322c5$export$d95c535ad1192f9f(arrayName, array) {
    return array.reduce((acc, item, index)=>{
        Object.keys(item).forEach((key)=>{
            acc[`${arrayName}[${index}].${key}`] = item[key];
        });
        return acc;
    }, {});
}

});

parcelRegister("1pwFu", function(module, exports) {

$parcel$export(module.exports, "autoCapitalize", () => $4b4e7ab15c7ab066$export$42034d56c6651516);
function $4b4e7ab15c7ab066$export$42034d56c6651516(node, capitalize = true) {
    if (typeof node !== "string" || node.length === 0 || !capitalize) return node;
    return `${node[0].toUpperCase()}${node.slice(1)}`;
}

});

parcelRegister("bxdbx", function(module, exports) {

$parcel$export(module.exports, "camelCased", () => $49e0ff5a02fc093e$export$751672fcb1faceaa);

var $f1q41 = parcelRequire("f1q41");
function $49e0ff5a02fc093e$export$751672fcb1faceaa(data) {
    if (Array.isArray(data)) return data.map($49e0ff5a02fc093e$export$751672fcb1faceaa);
    if (data === null) return data;
    if (typeof data !== "object") return data;
    const camelizedData = {};
    Object.keys(data).forEach((key)=>{
        const camelKey = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).camelCase(key);
        camelizedData[camelKey] = $49e0ff5a02fc093e$export$751672fcb1faceaa(data[key]);
    });
    return camelizedData;
}

});

parcelRegister("eQb4w", function(module, exports) {

$parcel$export(module.exports, "snakeCased", () => $8ccede76e9f23d15$export$2c134cf240566bbe);

var $f1q41 = parcelRequire("f1q41");
function $8ccede76e9f23d15$export$2c134cf240566bbe(data) {
    if (Array.isArray(data)) return data.map($8ccede76e9f23d15$export$2c134cf240566bbe);
    if (data === null) return data;
    if (typeof data !== "object") return data;
    const snakeCasedData = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).mapKeys(data, (value, key)=>{
        snakeCasedData[(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).snakeCase(key)] = $8ccede76e9f23d15$export$2c134cf240566bbe(value);
    });
    return snakeCasedData;
}

});

parcelRegister("7op73", function(module, exports) {

$parcel$export(module.exports, "abbreviate", () => $36a30b4f317b9907$export$f8e59455b4837291);
function $36a30b4f317b9907$export$f8e59455b4837291(s) {
    let num = parseInt(s, 10);
    const isNegative = num < 0;
    const prefix = isNegative ? "-" : "";
    num = Math.abs(num);
    if (num >= 1000000000000) return prefix + (num / 1000000000000).toFixed(0).replace(/\.0$/, "") + "T";
    else if (num >= 1000000000) return prefix + (num / 1000000000).toFixed(0).replace(/\.0$/, "") + "B";
    else if (num >= 1000000) return prefix + (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
    else if (num >= 1000) return prefix + (num / 1000).toFixed(num > 100000 ? 0 : 1).replace(/\.0$/, "") + "k";
    else return prefix + num.toString();
}

});

parcelRegister("8U1EK", function(module, exports) {

$parcel$export(module.exports, "validateDOB", () => $9c9ade2acaf935ee$export$c6f820d2ba6f8997);
const $9c9ade2acaf935ee$export$c6f820d2ba6f8997 = (value)=>{
    if (!value) return {
        isValid: true,
        message: ""
    };
    const [month, day, year] = value.split("/").map(Number);
    const daysInMonth = {
        1: 31,
        2: 28,
        3: 31,
        4: 30,
        5: 31,
        6: 30,
        7: 31,
        8: 31,
        9: 30,
        10: 31,
        11: 30,
        12: 31
    };
    // Check month
    if (month < 1 || month > 12) return {
        isValid: false,
        message: "Invalid month"
    };
    // Check day
    if (month === 2) {
        const isLeapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        if (day < 1 || day > (isLeapYear ? 29 : 28)) return {
            isValid: false,
            message: "Invalid day for February"
        };
    } else if (day < 1 || day > daysInMonth[month]) return {
        isValid: false,
        message: "Invalid day for this month"
    };
    // Check age
    const today = new Date();
    const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    const hundredYearsAgo = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate());
    const dateToCheck = new Date(year, month - 1, day);
    if (dateToCheck > eighteenYearsAgo) return {
        isValid: false,
        message: "You must be at least 18 years old"
    };
    if (dateToCheck < hundredYearsAgo) return {
        isValid: false,
        message: "Age cannot exceed 100 years"
    };
    return {
        isValid: true,
        message: ""
    };
};

});

parcelRegister("hJQbt", function(module, exports) {

$parcel$export(module.exports, "parseMarkdownLinks", () => $691dfb4118ddf56d$export$7a8feadb0ebe6fb2);
const $691dfb4118ddf56d$export$7a8feadb0ebe6fb2 = (text)=>{
    const markdownLinkRegex = /\(\[([^\]]+)\]\(([^)]+)\)\)|\[([^\]]+)\]\(([^)]+)\)/g;
    const parts = [];
    let lastIndex = 0;
    let match;
    while((match = markdownLinkRegex.exec(text)) !== null){
        if (match.index > lastIndex) parts.push(text.substring(lastIndex, match.index));
        const linkText = match[1] || match[3];
        const linkUrl = match[2] || match[4];
        parts.push({
            text: linkText,
            url: linkUrl
        });
        lastIndex = match.index + match[0].length;
    }
    if (lastIndex < text.length) parts.push(text.substring(lastIndex));
    return parts.length > 0 ? parts : [
        text
    ];
};

});


parcelRegister("anJVh", function(module, exports) {
$parcel$export(module.exports, "useFlags", () => (parcelRequire("7gcOJ")).useFlags);
parcelRequire("7gcOJ");
parcelRequire("4xRaM");

});
parcelRegister("7gcOJ", function(module, exports) {

$parcel$export(module.exports, "useFlags", () => $765bd532e098074b$export$2879604e6aec4ab);

var $jsVqW = parcelRequire("jsVqW");
const $765bd532e098074b$export$7cf24759ccde3447 = (name)=>name.replace(/_/g, "-").replace(/direct/g, "capital");
const $765bd532e098074b$export$2879604e6aec4ab = ()=>{
    const flagsmith = (0, $jsVqW.useFlagsmith)();
    const loadingState = (0, $jsVqW.useFlagsmithLoading)();
    const ready = !!loadingState && !loadingState.error && !loadingState.isFetching && !loadingState.isLoading && [
        "CACHE",
        "SERVER"
    ].includes(loadingState.source);
    const get = (flagNames, defaults = {})=>{
        const normalizedFlagNames = flagNames.map($765bd532e098074b$export$7cf24759ccde3447);
        const normalizedDefaults = Object.entries(defaults).reduce((defs, [k, v])=>({
                [$765bd532e098074b$export$7cf24759ccde3447(k)]: v,
                ...defs
            }), {});
        return normalizedFlagNames.reduce((results, flag)=>({
                ...results,
                [flag]: ready ? flagsmith.hasFeature(flag) : normalizedDefaults[flag] || false
            }), {});
    };
    const values = (flagNames, defaults = {})=>{
        const normalizedDefaults = Object.entries(defaults).reduce((defs, [k, v])=>({
                [$765bd532e098074b$export$7cf24759ccde3447(k)]: v,
                ...defs
            }), {});
        return flagNames.map($765bd532e098074b$export$7cf24759ccde3447).reduce((results, flag)=>({
                ...results,
                [flag]: flagsmith.getValue(flag, {
                    fallback: normalizedDefaults[flag] || null
                })
            }), {});
    };
    const enabled = (flagNames, defaults = {})=>{
        if (typeof flagNames === "string") return get([
            flagNames
        ], defaults)[$765bd532e098074b$export$7cf24759ccde3447(flagNames)];
        else return Object.values(get(flagNames, defaults)).every((f)=>f);
    };
    const value = (flagName, def = null)=>{
        const value = flagsmith.getValue($765bd532e098074b$export$7cf24759ccde3447(flagName), {
            fallback: def
        });
        if (typeof value === "string") try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    };
    return {
        get: get,
        values: values,
        enabled: enabled,
        value: value,
        ready: ready,
        error: !!loadingState?.error,
        loading: !!loadingState?.isLoading
    };
};

});
parcelRegister("jsVqW", function(module, exports) {

!function(t, e) {
    e(module.exports, (parcelRequire("acw62")));
}(module.exports, function(t, e) {
    "use strict";
    function n(t) {
        return t && "object" == typeof t && "default" in t ? t : {
            default: t
        };
    }
    var r = n(e), i = function() {
        return i = Object.assign || function(t) {
            for(var e, n = 1, r = arguments.length; n < r; n++)for(var i in e = arguments[n])Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
            return t;
        }, i.apply(this, arguments);
    }, o = function() {
        function t() {
            this.e = {};
        }
        return t.prototype.generateCallbackId = function() {
            return Math.random().toString(36).substring(7);
        }, t.prototype.on = function(t, e, n) {
            var r = this, i = this.e || (this.e = {}), o = this.generateCallbackId(), a = {
                id: o,
                fn: e,
                ctx: n
            };
            (i[t] || (i[t] = [])).push(a);
            return (function() {
                r.off(t, o);
            }).bind(this);
        }, t.prototype.once = function(t, e, n) {
            var r = this, i = this.generateCallbackId();
            function o() {
                r.off(t, i), e.apply(n, arguments);
            }
            return o._ = e, this.on(t, o, n);
        }, t.prototype.emit = function(t) {
            for(var e = [], n = 1; n < arguments.length; n++)e[n - 1] = arguments[n];
            for(var r = ((this.e || (this.e = {}))[t] || []).slice(), i = r.length, o = 0; o < i; o++)r[o].fn.apply(r[o].ctx, e);
            return this;
        }, t.prototype.off = function(t, e, n) {
            var r = this.e || (this.e = {}), i = r[t], o = [];
            if (i && e) for(var a = 0, u = i.length; a < u; a++)("function" == typeof e && i[a].fn !== e || "string" == typeof e && i[a].id !== e) && o.push(i[a]);
            return o.length ? r[t] = o : delete r[t], this;
        }, t;
    }(), a = new o, u = e.createContext(null), s = function(t) {
        var n = e.useRef(t);
        return n.current || (n.current = t), n.current;
    }, l = function(t) {
        if ("string" == typeof t) return [
            t
        ];
        if ("object" == typeof t && t.hasOwnProperty("length")) return t;
        throw new Error("Flagsmith: please supply an array of strings or a single string of flag keys to useFlags");
    }, f = function(t, e, n) {
        return void 0 === n && (n = []), e.map(function(e) {
            return "".concat(t.getValue(e)).concat(t.hasFeature(e));
        }).concat(n.map(function(e) {
            return "".concat(t.getTrait(e));
        })).join(",");
    };
    t.FlagsmithContext = u, t.FlagsmithProvider = function(t) {
        var n = t.flagsmith, o = t.options, s = t.serverState, l = t.children, f = e.useRef(!0);
        return n && !(null == n ? void 0 : n._trigger) && (n._trigger = function() {
            n.log("React - trigger event received"), a.emit("event");
        }), n && !(null == n ? void 0 : n._triggerLoadingState) && (n._triggerLoadingState = function() {
            a.emit("loading_event");
        }), s && !n.initialised && n.setState(s), f.current && (f.current = !1, o && n.init(i(i({}, o), {
            state: o.state || s,
            onChange: function() {
                for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
                o.onChange && o.onChange.apply(o, t);
            }
        }))), r.default.createElement(u.Provider, {
            value: n
        }, l);
    }, t.useFlags = function(t, n) {
        void 0 === n && (n = []);
        var r = e.useRef(!0), i = s(l(t)), o = s(l(n)), c = e.useContext(u), g = e.useState(f(c, i, o)), h = g[0], d = g[1], p = e.useCallback(function() {
            var t = f(c, i, o);
            t !== h && (null == c || c.log("React - useFlags flags and traits have changed"), d(t));
        }, [
            h
        ]), v = e.useRef(a.once("event", p));
        return r.current && (r.current = !1, null == c || c.log("React - Initialising event listeners")), e.useEffect(function() {
            return function() {
                var t;
                null === (t = v.current) || void 0 === t || t.call(v);
            };
        }, []), e.useMemo(function() {
            var t = {};
            return i.map(function(e) {
                t[e] = {
                    enabled: c.hasFeature(e),
                    value: c.getValue(e)
                };
            }).concat(null == o ? void 0 : o.map(function(e) {
                t[e] = c.getTrait(e);
            })), t;
        }, [
            h
        ]);
    }, t.useFlagsmith = function() {
        var t = e.useContext(u);
        if (!t) throw new Error("useFlagsmith must be used with in a FlagsmithProvider");
        return t;
    }, t.useFlagsmithLoading = function() {
        var t = e.useContext(u), n = e.useState(null == t ? void 0 : t.loadingState), r = n[0], i = n[1], o = e.useState(!1), s = o[0], l = o[1], f = e.useRef(s), c = e.useCallback(function() {
            i(null == t ? void 0 : t.loadingState);
        }, [
            t
        ]);
        return f.current || (a.on("loading_event", c), f.current = !0), e.useEffect(function() {
            return !s && t.initialised && (a.on("loading_event", c), l(!0)), function() {
                s && a.off("loading_event", c);
            };
        }, [
            t,
            s,
            c
        ]), r;
    }, Object.defineProperty(t, "__esModule", {
        value: !0
    });
});

});


parcelRegister("4xRaM", function(module, exports) {

});


parcelRegister("2bFYF", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => (parcelRequire("fp4OM")).useRouter);
parcelRequire("9z5mh");
parcelRequire("fp4OM");

});
parcelRegister("9z5mh", function(module, exports) {

});

parcelRegister("fp4OM", function(module, exports) {

$parcel$export(module.exports, "useRouter", () => $555bc3b744012019$export$9a302a45f65d0572);
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $5ofNJ = parcelRequire("5ofNJ");

var $acw62 = parcelRequire("acw62");
const $555bc3b744012019$export$9a302a45f65d0572 = ()=>{
    const [searchParams, setSearchParams] = (0, $lzNIT.useSearchParams)();
    const navigate = (0, $aphAM.useNavigate)();
    const location = (0, $aphAM.useLocation)();
    const params = (0, $aphAM.useParams)();
    const search = (0, $acw62.useMemo)(()=>{
        return (0, $5ofNJ.default).parse(location.search);
    }, [
        location.search
    ]);
    const updateSearch = (0, $acw62.useCallback)((key, value)=>{
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set(key, value);
        setSearchParams(newSearchParams);
    }, [
        setSearchParams,
        searchParams
    ]);
    const removeSearchParam = (0, $acw62.useCallback)((key)=>{
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.delete(key);
        setSearchParams(newSearchParams);
    }, [
        setSearchParams,
        searchParams
    ]);
    const getPathWithUpdatedSearch = (0, $acw62.useCallback)((key, value)=>{
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set(key, value);
        const newSearch = newSearchParams.toString();
        return `${location.pathname}${newSearch ? `?${newSearch}` : ""}`;
    }, [
        location.pathname,
        searchParams
    ]);
    const getPathWithRemovedSearch = (0, $acw62.useCallback)((key)=>{
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.delete(key);
        const newSearch = newSearchParams.toString();
        return `${location.pathname}${newSearch ? `?${newSearch}` : ""}`;
    }, [
        location.pathname,
        searchParams
    ]);
    const getCurrentPath = (0, $acw62.useCallback)(()=>{
        return `${location.pathname}${location.search}`;
    }, [
        location.pathname,
        location.search
    ]);
    const isPathMatch = (0, $acw62.useCallback)((regex)=>{
        return new RegExp(regex).test(location.pathname);
    }, [
        location.pathname
    ]);
    return {
        ...location,
        asPath: location.pathname + location.search,
        search: search,
        searchString: location.search,
        params: params,
        navigate: navigate,
        updateSearch: updateSearch,
        removeSearchParam: removeSearchParam,
        getPathWithUpdatedSearch: getPathWithUpdatedSearch,
        getPathWithRemovedSearch: getPathWithRemovedSearch,
        getCurrentPath: getCurrentPath,
        isPathMatch: isPathMatch
    };
};

});
parcelRegister("lzNIT", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", () => $040dbb9c344a508d$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $040dbb9c344a508d$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "NavLink", () => $040dbb9c344a508d$export$b0d92dbee9b5b60d);
$parcel$export(module.exports, "useSearchParams", () => $040dbb9c344a508d$export$f1a78c17382fe22a);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("aphAM")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("aphAM")).useNavigate);
/**
 * React Router DOM v6.25.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $2vsP7 = parcelRequire("2vsP7");
var $aphAM = parcelRequire("aphAM");

var $2vsP7 = parcelRequire("2vsP7");
function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $2vsP7.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $aphAM.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $2vsP7.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $aphAM.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $aphAM.useLocation)();
    let routerState = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $2vsP7.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterContext));
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $aphAM.useNavigate)();
    let location = (0, $aphAM.useLocation)();
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $2vsP7.createPath)(location) === (0, $2vsP7.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $aphAM.useLocation)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $aphAM.useNavigate)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let currentRouteId = (0, $aphAM.UNSAFE_useRouteId)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let routeContext = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    !routeContext && (0, $2vsP7.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $aphAM.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $aphAM.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $2vsP7.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $2vsP7.UNSAFE_invariant)(false);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $2vsP7.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $2vsP7.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let location = (0, $aphAM.useLocation)();
    let matches = (0, $aphAM.useMatches)();
    let navigation = (0, $aphAM.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $2vsP7.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $aphAM.useBlocker)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $2vsP7.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $2vsP7.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $2vsP7.matchPath)(path.pathname, nextPath) != null || (0, $2vsP7.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("1u0KT", function(module, exports) {
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});


parcelRegister("5ofNJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ecb7368762fc268$export$2e2bcd8739ae039);

var $1wmL6 = parcelRequire("1wmL6");
var $3ecb7368762fc268$export$2e2bcd8739ae039 = $1wmL6;

});
parcelRegister("1wmL6", function(module, exports) {

$parcel$export(module.exports, "extract", () => $11ba6efd360d635f$export$f9380c9a627682d3);
$parcel$export(module.exports, "parse", () => $11ba6efd360d635f$export$98e6a39c04603d36);
$parcel$export(module.exports, "stringify", () => $11ba6efd360d635f$export$fac44ee5b035f737);
$parcel$export(module.exports, "parseUrl", () => $11ba6efd360d635f$export$7a5253c0f62e0150);
$parcel$export(module.exports, "stringifyUrl", () => $11ba6efd360d635f$export$a8c1621ea79325d3);
$parcel$export(module.exports, "pick", () => $11ba6efd360d635f$export$357523c63a2253b9);
$parcel$export(module.exports, "exclude", () => $11ba6efd360d635f$export$44c361b8ec72ef7f);

var $5yzCy = parcelRequire("5yzCy");

var $KvXt7 = parcelRequire("KvXt7");

var $4IJyT = parcelRequire("4IJyT");
const $11ba6efd360d635f$var$isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const $11ba6efd360d635f$var$strictUriEncode = (string)=>encodeURIComponent(string).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const $11ba6efd360d635f$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $11ba6efd360d635f$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $11ba6efd360d635f$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $11ba6efd360d635f$var$encode(key, options),
                            "[",
                            $11ba6efd360d635f$var$encode(index, options),
                            "]=",
                            $11ba6efd360d635f$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $11ba6efd360d635f$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $11ba6efd360d635f$var$encode(key, options),
                            "[]=",
                            $11ba6efd360d635f$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $11ba6efd360d635f$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $11ba6efd360d635f$var$encode(key, options),
                            ":list=",
                            $11ba6efd360d635f$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $11ba6efd360d635f$var$encode(key, options),
                                keyValueSep,
                                $11ba6efd360d635f$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $11ba6efd360d635f$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $11ba6efd360d635f$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $11ba6efd360d635f$var$encode(key, options),
                            "=",
                            $11ba6efd360d635f$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $11ba6efd360d635f$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)]$/.exec(key);
                key = key.replace(/\[\d*]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[])$/.exec(key);
                key = key.replace(/\[]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $11ba6efd360d635f$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $11ba6efd360d635f$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$11ba6efd360d635f$var$decode(item, options)) : value === null ? value : $11ba6efd360d635f$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[])$/.test(key);
                key = key.replace(/\[]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $11ba6efd360d635f$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$11ba6efd360d635f$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    ...arrayValue
                ];
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [
                    ...[
                        accumulator[key]
                    ].flat(),
                    value
                ];
            };
    }
}
function $11ba6efd360d635f$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $11ba6efd360d635f$var$encode(value, options) {
    if (options.encode) return options.strict ? $11ba6efd360d635f$var$strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function $11ba6efd360d635f$var$decode(value, options) {
    if (options.decode) return (0, $5yzCy.default)(value);
    return value;
}
function $11ba6efd360d635f$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $11ba6efd360d635f$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $11ba6efd360d635f$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $11ba6efd360d635f$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $11ba6efd360d635f$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $11ba6efd360d635f$export$f9380c9a627682d3(input) {
    input = $11ba6efd360d635f$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $11ba6efd360d635f$export$98e6a39c04603d36(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false,
        ...options
    };
    $11ba6efd360d635f$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $11ba6efd360d635f$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== "string") return returnValue;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return returnValue;
    for (const parameter of query.split("&")){
        if (parameter === "") continue;
        const parameter_ = options.decode ? parameter.replace(/\+/g, " ") : parameter;
        let [key, value] = (0, $KvXt7.default)(parameter_, "=");
        if (key === undefined) key = parameter_;
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $11ba6efd360d635f$var$decode(value, options);
        formatter($11ba6efd360d635f$var$decode(key, options), value, returnValue);
    }
    for (const [key, value] of Object.entries(returnValue)){
        if (typeof value === "object" && value !== null) for (const [key2, value2] of Object.entries(value))value[key2] = $11ba6efd360d635f$var$parseValue(value2, options);
        else returnValue[key] = $11ba6efd360d635f$var$parseValue(value, options);
    }
    if (options.sort === false) return returnValue;
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        result[key] = Boolean(value) && typeof value === "object" && !Array.isArray(value) ? $11ba6efd360d635f$var$keysSorter(value) : value;
        return result;
    }, Object.create(null));
}
function $11ba6efd360d635f$export$fac44ee5b035f737(object, options) {
    if (!object) return "";
    options = {
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        ...options
    };
    $11ba6efd360d635f$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $11ba6efd360d635f$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $11ba6efd360d635f$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object))if (!shouldFilter(key)) objectCopy[key] = value;
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $11ba6efd360d635f$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $11ba6efd360d635f$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $11ba6efd360d635f$var$encode(key, options) + "=" + $11ba6efd360d635f$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
}
function $11ba6efd360d635f$export$7a5253c0f62e0150(url, options) {
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = (0, $KvXt7.default)(url, "#");
    if (url_ === undefined) url_ = url;
    return {
        url: url_?.split("?")?.[0] ?? "",
        query: $11ba6efd360d635f$export$98e6a39c04603d36($11ba6efd360d635f$export$f9380c9a627682d3(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: $11ba6efd360d635f$var$decode(hash, options)
        } : {}
    };
}
function $11ba6efd360d635f$export$a8c1621ea79325d3(object, options) {
    options = {
        encode: true,
        strict: true,
        [$11ba6efd360d635f$var$encodeFragmentIdentifier]: true,
        ...options
    };
    const url = $11ba6efd360d635f$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $11ba6efd360d635f$export$f9380c9a627682d3(object.url);
    const query = {
        ...$11ba6efd360d635f$export$98e6a39c04603d36(queryFromUrl, {
            sort: false
        }),
        ...object.query
    };
    let queryString = $11ba6efd360d635f$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $11ba6efd360d635f$var$getHash(object.url);
    if (object.fragmentIdentifier) {
        const urlObjectForFragmentEncode = new URL(url);
        urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
        hash = options[$11ba6efd360d635f$var$encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
    }
    return `${url}${queryString}${hash}`;
}
function $11ba6efd360d635f$export$357523c63a2253b9(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [$11ba6efd360d635f$var$encodeFragmentIdentifier]: false,
        ...options
    };
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $11ba6efd360d635f$export$7a5253c0f62e0150(input, options);
    return $11ba6efd360d635f$export$a8c1621ea79325d3({
        url: url,
        query: (0, $4IJyT.includeKeys)(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
}
function $11ba6efd360d635f$export$44c361b8ec72ef7f(input, filter, options) {
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $11ba6efd360d635f$export$357523c63a2253b9(input, exclusionFilter, options);
}

});
parcelRegister("5yzCy", function(module, exports) {

$parcel$export(module.exports, "default", () => $40bbc24beab9f9b8$export$2e2bcd8739ae039);
const $40bbc24beab9f9b8$var$token = "%[a-f0-9]{2}";
const $40bbc24beab9f9b8$var$singleMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")|([^%]+?)", "gi");
const $40bbc24beab9f9b8$var$multiMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")+", "gi");
function $40bbc24beab9f9b8$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch  {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    const left = components.slice(0, split);
    const right = components.slice(split);
    return Array.prototype.concat.call([], $40bbc24beab9f9b8$var$decodeComponents(left), $40bbc24beab9f9b8$var$decodeComponents(right));
}
function $40bbc24beab9f9b8$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch  {
        let tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        for(let i = 1; i < tokens.length; i++){
            input = $40bbc24beab9f9b8$var$decodeComponents(tokens, i).join("");
            tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        }
        return input;
    }
}
function $40bbc24beab9f9b8$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    const replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    let match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch  {
            const result = $40bbc24beab9f9b8$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    const entries = Object.keys(replaceMap);
    for (const key of entries)// Replace all decoded components
    input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    return input;
}
function $40bbc24beab9f9b8$export$2e2bcd8739ae039(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch  {
        // Fallback to a more advanced decoder
        return $40bbc24beab9f9b8$var$customDecodeURIComponent(encodedURI);
    }
}

});

parcelRegister("KvXt7", function(module, exports) {

$parcel$export(module.exports, "default", () => $08bd16383ca1ef3d$export$2e2bcd8739ae039);
function $08bd16383ca1ef3d$export$2e2bcd8739ae039(string, separator) {
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (string === "" || separator === "") return [];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
}

});

parcelRegister("4IJyT", function(module, exports) {

$parcel$export(module.exports, "includeKeys", () => $36fe9d1ef26e3f64$export$ff05df6c2df24b52);
function $36fe9d1ef26e3f64$export$ff05df6c2df24b52(object, predicate) {
    const result = {};
    if (Array.isArray(predicate)) for (const key of predicate){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor?.enumerable) Object.defineProperty(result, key, descriptor);
    }
    else // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor.enumerable) {
            const value = object[key];
            if (predicate(key, value, object)) Object.defineProperty(result, key, descriptor);
        }
    }
    return result;
}
function $36fe9d1ef26e3f64$export$e87405134ad524be(object, predicate) {
    if (Array.isArray(predicate)) {
        const set = new Set(predicate);
        return $36fe9d1ef26e3f64$export$ff05df6c2df24b52(object, (key)=>!set.has(key));
    }
    return $36fe9d1ef26e3f64$export$ff05df6c2df24b52(object, (key, value, object)=>!predicate(key, value, object));
}

});





parcelRegister("a1Lcn", function(module, exports) {
$parcel$export(module.exports, "initDataDog", () => (parcelRequire("hytaM")).initDataDog);
$parcel$export(module.exports, "log", () => (parcelRequire("yrzTx")).log);
$parcel$export(module.exports, "ddActions", () => (parcelRequire("2bkBK")).ddActions);
parcelRequire("hytaM");
parcelRequire("yrzTx");
parcelRequire("2bkBK");

});
parcelRegister("hytaM", function(module, exports) {

$parcel$export(module.exports, "initDataDog", () => $91f641c4655f6adb$export$325f8a2ac4a631e4);

var $cNbKI = parcelRequire("cNbKI");

var $319l6 = parcelRequire("319l6");
function $91f641c4655f6adb$export$325f8a2ac4a631e4() {
    const site = "datadoghq.com";
    const version = "2.0.0";
    const service = "frontend";
    (0, $cNbKI.datadogRum).init({
        applicationId: "271fa039-6812-427e-8706-572944c94428",
        clientToken: "pub23da6a831ed209aacabc278e2eb6b199",
        site: site,
        service: service,
        version: version,
        env: "prod",
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        defaultPrivacyLevel: "mask-user-input",
        enableExperimentalFeatures: [
            "feature_flags"
        ],
        actionNameAttribute: "dd-action",
        trackSessionAcrossSubdomains: true
    });
    (0, $319l6.datadogLogs).init({
        clientToken: "pub23da6a831ed209aacabc278e2eb6b199",
        site: site,
        service: service,
        version: version,
        env: "prod",
        forwardErrorsToLogs: true,
        forwardConsoleLogs: "all",
        sessionSampleRate: 100,
        trackSessionAcrossSubdomains: true
    });
}

});
parcelRegister("cNbKI", function(module, exports) {

$parcel$export(module.exports, "datadogRum", () => $95032d6edbc0e5a2$export$65cc181beb0d2632);
// Keep the following in sync with packages/rum-slim/src/entries/main.ts

var $ewVF5 = parcelRequire("ewVF5");
var $7ZD4v = parcelRequire("7ZD4v");
parcelRequire("4oXVz");
var $ha0y0 = parcelRequire("ha0y0");
var $2q14q = parcelRequire("2q14q");

var $jIcSw = parcelRequire("jIcSw");

var $3VNwe = parcelRequire("3VNwe");
parcelRequire("l2g7V");
var $3nvYK = parcelRequire("3nvYK");
var $ftUlk = parcelRequire("ftUlk");
var $95032d6edbc0e5a2$var$recorderApi = (0, $3VNwe.makeRecorderApi)((0, $jIcSw.startRecording));
var $95032d6edbc0e5a2$export$65cc181beb0d2632 = (0, $ha0y0.makeRumPublicApi)((0, $2q14q.startRum), $95032d6edbc0e5a2$var$recorderApi, {
    startDeflateWorker: (0, $ftUlk.startDeflateWorker),
    createDeflateEncoder: (0, $3nvYK.createDeflateEncoder)
});
(0, $ewVF5.defineGlobal)((0, $7ZD4v.getGlobalObject)(), "DD_RUM", $95032d6edbc0e5a2$export$65cc181beb0d2632);

});
parcelRegister("ewVF5", function(module, exports) {

$parcel$export(module.exports, "makePublicApi", () => $a940c8408eeade74$export$119e7fe763fbc1d1);
$parcel$export(module.exports, "defineGlobal", () => $a940c8408eeade74$export$884b45263866f2b7);

var $1yDAt = parcelRequire("1yDAt");

var $2wH3Z = parcelRequire("2wH3Z");

var $fkj4Q = parcelRequire("fkj4Q");
function $a940c8408eeade74$export$119e7fe763fbc1d1(stub) {
    var publicApi = (0, $fkj4Q.assign)({
        version: "5.15.0",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function(callback) {
            callback();
        }
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, "_setDebug", {
        get: function() {
            return 0, $2wH3Z.setDebugMode;
        },
        enumerable: false
    });
    return publicApi;
}
function $a940c8408eeade74$export$884b45263866f2b7(global, name, api) {
    var existingGlobalVariable = global[name];
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) existingGlobalVariable.q.forEach(function(fn) {
        return (0, $1yDAt.catchUserErrors)(fn, "onReady callback threw an error:")();
    });
}

});
parcelRegister("1yDAt", function(module, exports) {

$parcel$export(module.exports, "catchUserErrors", () => $1227ac9fbf79b35b$export$a7d71543eda007d0);

var $5IDGB = parcelRequire("5IDGB");
function $1227ac9fbf79b35b$export$a7d71543eda007d0(fn, errorMsg) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        try {
            return fn.apply(void 0, args);
        } catch (err) {
            (0, $5IDGB.display).error(errorMsg, err);
        }
    };
}

});
parcelRegister("5IDGB", function(module, exports) {

$parcel$export(module.exports, "ConsoleApiName", () => $429fd8a62f4aa1b2$export$d37676e8a94e6b40);
$parcel$export(module.exports, "globalConsole", () => $429fd8a62f4aa1b2$export$d07b2d1b8b601164);
$parcel$export(module.exports, "originalConsoleMethods", () => $429fd8a62f4aa1b2$export$77c4ce905194557b);
$parcel$export(module.exports, "display", () => $429fd8a62f4aa1b2$export$79693fdaa4661ff2);
/* eslint-disable local-rules/disallow-side-effects */ /**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */ var $429fd8a62f4aa1b2$export$d37676e8a94e6b40 = {
    log: "log",
    debug: "debug",
    info: "info",
    warn: "warn",
    error: "error"
};
var $429fd8a62f4aa1b2$export$d07b2d1b8b601164 = console;
var $429fd8a62f4aa1b2$export$77c4ce905194557b = {};
Object.keys($429fd8a62f4aa1b2$export$d37676e8a94e6b40).forEach(function(name) {
    $429fd8a62f4aa1b2$export$77c4ce905194557b[name] = $429fd8a62f4aa1b2$export$d07b2d1b8b601164[name];
});
var $429fd8a62f4aa1b2$var$PREFIX = "Datadog Browser SDK:";
var $429fd8a62f4aa1b2$export$79693fdaa4661ff2 = {
    debug: $429fd8a62f4aa1b2$export$77c4ce905194557b.debug.bind($429fd8a62f4aa1b2$export$d07b2d1b8b601164, $429fd8a62f4aa1b2$var$PREFIX),
    log: $429fd8a62f4aa1b2$export$77c4ce905194557b.log.bind($429fd8a62f4aa1b2$export$d07b2d1b8b601164, $429fd8a62f4aa1b2$var$PREFIX),
    info: $429fd8a62f4aa1b2$export$77c4ce905194557b.info.bind($429fd8a62f4aa1b2$export$d07b2d1b8b601164, $429fd8a62f4aa1b2$var$PREFIX),
    warn: $429fd8a62f4aa1b2$export$77c4ce905194557b.warn.bind($429fd8a62f4aa1b2$export$d07b2d1b8b601164, $429fd8a62f4aa1b2$var$PREFIX),
    error: $429fd8a62f4aa1b2$export$77c4ce905194557b.error.bind($429fd8a62f4aa1b2$export$d07b2d1b8b601164, $429fd8a62f4aa1b2$var$PREFIX)
};

});


parcelRegister("2wH3Z", function(module, exports) {

$parcel$export(module.exports, "startMonitorErrorCollection", () => $1d6ff96621fb36bb$export$2fa3dec4f40a39a2);
$parcel$export(module.exports, "setDebugMode", () => $1d6ff96621fb36bb$export$2be227cb6aa211be);
$parcel$export(module.exports, "monitored", () => $1d6ff96621fb36bb$export$efef192ceb8f8a31);
$parcel$export(module.exports, "monitor", () => $1d6ff96621fb36bb$export$ec5b303098bc4b7f);
$parcel$export(module.exports, "callMonitored", () => $1d6ff96621fb36bb$export$b69eb0f8afebfb6d);
$parcel$export(module.exports, "displayIfDebugEnabled", () => $1d6ff96621fb36bb$export$54b26de4de044ec5);

var $5IDGB = parcelRequire("5IDGB");
var $1d6ff96621fb36bb$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $1d6ff96621fb36bb$var$onMonitorErrorCollected;
var $1d6ff96621fb36bb$var$debugMode = false;
function $1d6ff96621fb36bb$export$2fa3dec4f40a39a2(newOnMonitorErrorCollected) {
    $1d6ff96621fb36bb$var$onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function $1d6ff96621fb36bb$export$2be227cb6aa211be(newDebugMode) {
    $1d6ff96621fb36bb$var$debugMode = newDebugMode;
}
function $1d6ff96621fb36bb$export$6c5b5d0667b12cfc() {
    $1d6ff96621fb36bb$var$onMonitorErrorCollected = undefined;
    $1d6ff96621fb36bb$var$debugMode = false;
}
function $1d6ff96621fb36bb$export$efef192ceb8f8a31(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var decorated = $1d6ff96621fb36bb$var$onMonitorErrorCollected ? $1d6ff96621fb36bb$export$ec5b303098bc4b7f(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
function $1d6ff96621fb36bb$export$ec5b303098bc4b7f(fn) {
    return function() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return $1d6ff96621fb36bb$export$b69eb0f8afebfb6d(fn, this, arguments);
    }; // consider output type has input type
}
function $1d6ff96621fb36bb$export$b69eb0f8afebfb6d(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    } catch (e) {
        $1d6ff96621fb36bb$export$54b26de4de044ec5(e);
        if ($1d6ff96621fb36bb$var$onMonitorErrorCollected) try {
            $1d6ff96621fb36bb$var$onMonitorErrorCollected(e);
        } catch (e) {
            $1d6ff96621fb36bb$export$54b26de4de044ec5(e);
        }
    }
}
function $1d6ff96621fb36bb$export$54b26de4de044ec5() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if ($1d6ff96621fb36bb$var$debugMode) (0, $5IDGB.display).error.apply((0, $5IDGB.display), $1d6ff96621fb36bb$var$__spreadArray([
        "[MONITOR]"
    ], args, false));
}

});

parcelRegister("fkj4Q", function(module, exports) {

$parcel$export(module.exports, "includes", () => $b287859a2cd2eacd$export$ee2e0f811dca1807);
$parcel$export(module.exports, "arrayFrom", () => $b287859a2cd2eacd$export$b1a47efd00197c76);
$parcel$export(module.exports, "find", () => $b287859a2cd2eacd$export$71aa6c912b956294);
$parcel$export(module.exports, "findLast", () => $b287859a2cd2eacd$export$296de88ccac4bedb);
$parcel$export(module.exports, "forEach", () => $b287859a2cd2eacd$export$4b80e395e36b5a56);
$parcel$export(module.exports, "objectValues", () => $b287859a2cd2eacd$export$ad1854f4a08c15f8);
$parcel$export(module.exports, "objectEntries", () => $b287859a2cd2eacd$export$6a29ade99f81ec8a);
$parcel$export(module.exports, "startsWith", () => $b287859a2cd2eacd$export$68326237475e9a7d);
$parcel$export(module.exports, "endsWith", () => $b287859a2cd2eacd$export$10fdab3683b55b22);
$parcel$export(module.exports, "assign", () => $b287859a2cd2eacd$export$e6e34fd1f2686227);
function $b287859a2cd2eacd$export$ee2e0f811dca1807(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
function $b287859a2cd2eacd$export$b1a47efd00197c76(arrayLike) {
    if (Array.from) return Array.from(arrayLike);
    var array = [];
    if (arrayLike instanceof Set) arrayLike.forEach(function(item) {
        return array.push(item);
    });
    else for(var i = 0; i < arrayLike.length; i++)array.push(arrayLike[i]);
    return array;
}
function $b287859a2cd2eacd$export$71aa6c912b956294(array, predicate) {
    for(var i = 0; i < array.length; i += 1){
        var item = array[i];
        if (predicate(item, i)) return item;
    }
    return undefined;
}
function $b287859a2cd2eacd$export$296de88ccac4bedb(array, predicate) {
    for(var i = array.length - 1; i >= 0; i -= 1){
        var item = array[i];
        if (predicate(item, i, array)) return item;
    }
    return undefined;
}
function $b287859a2cd2eacd$export$4b80e395e36b5a56(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
function $b287859a2cd2eacd$export$ad1854f4a08c15f8(object) {
    return Object.keys(object).map(function(key) {
        return object[key];
    });
}
function $b287859a2cd2eacd$export$6a29ade99f81ec8a(object) {
    return Object.keys(object).map(function(key) {
        return [
            key,
            object[key]
        ];
    });
}
function $b287859a2cd2eacd$export$68326237475e9a7d(candidate, search) {
    return candidate.slice(0, search.length) === search;
}
function $b287859a2cd2eacd$export$10fdab3683b55b22(candidate, search) {
    return candidate.slice(-search.length) === search;
}
function $b287859a2cd2eacd$export$e6e34fd1f2686227(target) {
    var toAssign = [];
    for(var _i = 1; _i < arguments.length; _i++)toAssign[_i - 1] = arguments[_i];
    toAssign.forEach(function(source) {
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    });
    return target;
}

});


parcelRegister("7ZD4v", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", () => $5d1c89bab7298e4d$export$256479dc0cea61c4);
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */ function $5d1c89bab7298e4d$export$256479dc0cea61c4() {
    if (typeof globalThis === "object") return globalThis;
    Object.defineProperty(Object.prototype, "_dd_temp_", {
        get: function() {
            return this;
        },
        configurable: true
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== "object") {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === "object") globalObject = self;
        else if (typeof window === "object") globalObject = window;
        else globalObject = {};
    }
    return globalObject;
}

});

parcelRegister("4oXVz", function(module, exports) {
$parcel$export(module.exports, "forEachChildNodes", () => (parcelRequire("4TGNe")).forEachChildNodes);
$parcel$export(module.exports, "getParentNode", () => (parcelRequire("4TGNe")).getParentNode);
$parcel$export(module.exports, "hasChildNodes", () => (parcelRequire("4TGNe")).hasChildNodes);
$parcel$export(module.exports, "isElementNode", () => (parcelRequire("4TGNe")).isElementNode);
$parcel$export(module.exports, "isNodeShadowHost", () => (parcelRequire("4TGNe")).isNodeShadowHost);
$parcel$export(module.exports, "isNodeShadowRoot", () => (parcelRequire("4TGNe")).isNodeShadowRoot);
$parcel$export(module.exports, "isTextNode", () => (parcelRequire("4TGNe")).isTextNode);
$parcel$export(module.exports, "cssEscape", () => (parcelRequire("iznpK")).cssEscape);

$parcel$export(module.exports, "makeRumPublicApi", () => (parcelRequire("ha0y0")).makeRumPublicApi);
$parcel$export(module.exports, "startRum", () => (parcelRequire("2q14q")).startRum);
$parcel$export(module.exports, "getMutationObserverConstructor", () => (parcelRequire("2Bt7w")).getMutationObserverConstructor);
$parcel$export(module.exports, "initViewportObservable", () => (parcelRequire("kom4r")).initViewportObservable);
$parcel$export(module.exports, "getViewportDimension", () => (parcelRequire("kom4r")).getViewportDimension);
$parcel$export(module.exports, "getScrollX", () => (parcelRequire("fvpT8")).getScrollX);
$parcel$export(module.exports, "getScrollY", () => (parcelRequire("fvpT8")).getScrollY);
$parcel$export(module.exports, "STABLE_ATTRIBUTES", () => (parcelRequire("l3o7w")).STABLE_ATTRIBUTES);
$parcel$export(module.exports, "getSessionReplayUrl", () => (parcelRequire("dKooA")).getSessionReplayUrl);

var $ha0y0 = parcelRequire("ha0y0");

var $2q14q = parcelRequire("2q14q");

var $54uGZ = parcelRequire("54uGZ");

var $4Voar = parcelRequire("4Voar");

var $2Bt7w = parcelRequire("2Bt7w");

var $kom4r = parcelRequire("kom4r");

var $fvpT8 = parcelRequire("fvpT8");

var $2dzye = parcelRequire("2dzye");

var $l3o7w = parcelRequire("l3o7w");
parcelRequire("4TGNe");
parcelRequire("iznpK");

var $dKooA = parcelRequire("dKooA");

});
parcelRegister("ha0y0", function(module, exports) {

$parcel$export(module.exports, "makeRumPublicApi", () => $c7e3cb8a60bc2b2b$export$27595a139f6e6837);

var $fkj4Q = parcelRequire("fkj4Q");
var $2wH3Z = parcelRequire("2wH3Z");
var $h7dlA = parcelRequire("h7dlA");
var $ly0px = parcelRequire("ly0px");
var $el7hs = parcelRequire("el7hs");
var $96vba = parcelRequire("96vba");
var $4Be0w = parcelRequire("4Be0w");
var $lTIYX = parcelRequire("lTIYX");
var $95XVG = parcelRequire("95XVG");
var $j9iCm = parcelRequire("j9iCm");
var $gurxr = parcelRequire("gurxr");
var $k2pmh = parcelRequire("k2pmh");
var $ewVF5 = parcelRequire("ewVF5");
var $1RdIU = parcelRequire("1RdIU");
var $adV8b = parcelRequire("adV8b");

var $f1XAR = parcelRequire("f1XAR");

var $e8LWu = parcelRequire("e8LWu");
var $c7e3cb8a60bc2b2b$var$RUM_STORAGE_KEY = "rum";
function $c7e3cb8a60bc2b2b$export$27595a139f6e6837(startRumImpl, recorderApi, options) {
    if (options === void 0) options = {};
    var customerDataTrackerManager = (0, $96vba.createCustomerDataTrackerManager)(0 /* CustomerDataCompressionStatus.Unknown */ );
    var globalContextManager = (0, $el7hs.createContextManager)(customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */ ));
    var userContextManager = (0, $el7hs.createContextManager)(customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */ ));
    var trackingConsentState = (0, $95XVG.createTrackingConsentState)();
    function getCommonContext() {
        return (0, $f1XAR.buildCommonContext)(globalContextManager, userContextManager, recorderApi);
    }
    var strategy = (0, $e8LWu.createPreStartStrategy)(options, getCommonContext, trackingConsentState, function(initConfiguration, configuration, deflateWorker, initialViewOptions) {
        if ((0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).CUSTOM_VITALS)) {
            rumPublicApi.startDurationVital = (0, $2wH3Z.monitor)(function(name, options) {
                strategy.startDurationVital({
                    name: (0, $1RdIU.sanitize)(name),
                    startClocks: (options === null || options === void 0 ? void 0 : options.startTime) ? (0, $ly0px.timeStampToClocks)(options.startTime) : (0, $ly0px.clocksNow)(),
                    context: (0, $1RdIU.sanitize)(options === null || options === void 0 ? void 0 : options.context)
                });
            });
            rumPublicApi.stopDurationVital = (0, $2wH3Z.monitor)(function(name, options) {
                strategy.stopDurationVital({
                    name: (0, $1RdIU.sanitize)(name),
                    stopClocks: (options === null || options === void 0 ? void 0 : options.stopTime) ? (0, $ly0px.timeStampToClocks)(options.stopTime) : (0, $ly0px.clocksNow)(),
                    context: (0, $1RdIU.sanitize)(options === null || options === void 0 ? void 0 : options.context)
                });
            });
        }
        if (initConfiguration.storeContextsAcrossPages) {
            (0, $adV8b.storeContextManager)(configuration, globalContextManager, $c7e3cb8a60bc2b2b$var$RUM_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */ );
            (0, $adV8b.storeContextManager)(configuration, userContextManager, $c7e3cb8a60bc2b2b$var$RUM_STORAGE_KEY, 1 /* CustomerDataType.User */ );
        }
        customerDataTrackerManager.setCompressionStatus(deflateWorker ? 1 /* CustomerDataCompressionStatus.Enabled */  : 2 /* CustomerDataCompressionStatus.Disabled */ );
        var startRumResult = startRumImpl(initConfiguration, configuration, recorderApi, customerDataTrackerManager, getCommonContext, initialViewOptions, deflateWorker && options.createDeflateEncoder ? function(streamId) {
            return options.createDeflateEncoder(configuration, deflateWorker, streamId);
        } : (0, $lTIYX.createIdentityEncoder), trackingConsentState);
        recorderApi.onRumStart(startRumResult.lifeCycle, configuration, startRumResult.session, startRumResult.viewContexts, deflateWorker);
        strategy = $c7e3cb8a60bc2b2b$var$createPostStartStrategy(initConfiguration, startRumResult);
        return startRumResult;
    });
    var startView = (0, $2wH3Z.monitor)(function(options) {
        var sanitizedOptions = typeof options === "object" ? options : {
            name: options
        };
        strategy.startView(sanitizedOptions);
    });
    var rumPublicApi = (0, $ewVF5.makePublicApi)({
        init: (0, $2wH3Z.monitor)(function(initConfiguration) {
            return strategy.init(initConfiguration);
        }),
        /**
         * Set the tracking consent of the current user.
         *
         * @param {"granted" | "not-granted"} trackingConsent The user tracking consent
         *
         * Data will be sent only if it is set to "granted". This value won't be stored by the library
         * across page loads: you will need to call this method or set the appropriate `trackingConsent`
         * field in the init() method at each page load.
         *
         * If this method is called before the init() method, the provided value will take precedence
         * over the one provided as initialization parameter.
         */ setTrackingConsent: (0, $2wH3Z.monitor)(function(trackingConsent) {
            return trackingConsentState.update(trackingConsent);
        }),
        setGlobalContextProperty: (0, $2wH3Z.monitor)(function(key, value) {
            return globalContextManager.setContextProperty(key, value);
        }),
        removeGlobalContextProperty: (0, $2wH3Z.monitor)(function(key) {
            return globalContextManager.removeContextProperty(key);
        }),
        getGlobalContext: (0, $2wH3Z.monitor)(function() {
            return globalContextManager.getContext();
        }),
        setGlobalContext: (0, $2wH3Z.monitor)(function(context) {
            return globalContextManager.setContext(context);
        }),
        clearGlobalContext: (0, $2wH3Z.monitor)(function() {
            return globalContextManager.clearContext();
        }),
        getInternalContext: (0, $2wH3Z.monitor)(function(startTime) {
            return strategy.getInternalContext(startTime);
        }),
        getInitConfiguration: (0, $2wH3Z.monitor)(function() {
            return (0, $j9iCm.deepClone)(strategy.initConfiguration);
        }),
        addAction: (0, $2wH3Z.monitor)(function(name, context) {
            strategy.addAction({
                name: (0, $1RdIU.sanitize)(name),
                context: (0, $1RdIU.sanitize)(context),
                startClocks: (0, $ly0px.clocksNow)(),
                type: "custom" /* ActionType.CUSTOM */ 
            });
        }),
        addError: function(error, context) {
            var handlingStack = (0, $4Be0w.createHandlingStack)();
            (0, $2wH3Z.callMonitored)(function() {
                strategy.addError({
                    error: error,
                    handlingStack: handlingStack,
                    context: (0, $1RdIU.sanitize)(context),
                    startClocks: (0, $ly0px.clocksNow)()
                });
            });
        },
        /**
         * Add a custom timing relative to the start of the current view,
         * stored in @view.custom_timings.<timing_name>
         *
         * @param name name of the custom timing
         * @param [time] epoch timestamp of the custom timing (if not set, will use current time)
         *
         * Note: passing a relative time is discouraged since it is actually used as-is but displayed relative to the view start.
         * We currently don't provide a way to retrieve the view start time, so it can be challenging to provide a timing relative to the view start.
         * see https://github.com/DataDog/browser-sdk/issues/2552
         */ addTiming: (0, $2wH3Z.monitor)(function(name, time) {
            // TODO: next major decide to drop relative time support or update its behaviour
            strategy.addTiming((0, $1RdIU.sanitize)(name), time);
        }),
        setUser: (0, $2wH3Z.monitor)(function(newUser) {
            if ((0, $h7dlA.checkUser)(newUser)) userContextManager.setContext((0, $h7dlA.sanitizeUser)(newUser));
        }),
        getUser: (0, $2wH3Z.monitor)(function() {
            return userContextManager.getContext();
        }),
        setUserProperty: (0, $2wH3Z.monitor)(function(key, property) {
            var _a;
            var sanitizedProperty = (0, $h7dlA.sanitizeUser)((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: (0, $2wH3Z.monitor)(function(key) {
            return userContextManager.removeContextProperty(key);
        }),
        clearUser: (0, $2wH3Z.monitor)(function() {
            return userContextManager.clearContext();
        }),
        startView: startView,
        stopSession: (0, $2wH3Z.monitor)(function() {
            strategy.stopSession();
        }),
        /**
         * This feature is currently in beta. For more information see the full [feature flag tracking guide](https://docs.datadoghq.com/real_user_monitoring/feature_flag_tracking/).
         */ addFeatureFlagEvaluation: (0, $2wH3Z.monitor)(function(key, value) {
            strategy.addFeatureFlagEvaluation((0, $1RdIU.sanitize)(key), (0, $1RdIU.sanitize)(value));
        }),
        getSessionReplayLink: (0, $2wH3Z.monitor)(function() {
            return recorderApi.getSessionReplayLink();
        }),
        startSessionReplayRecording: (0, $2wH3Z.monitor)(function() {
            return recorderApi.start();
        }),
        stopSessionReplayRecording: (0, $2wH3Z.monitor)(function() {
            return recorderApi.stop();
        })
    });
    return rumPublicApi;
}
function $c7e3cb8a60bc2b2b$var$createPostStartStrategy(initConfiguration, startRumResult) {
    return (0, $fkj4Q.assign)({
        init: function(initConfiguration) {
            (0, $gurxr.displayAlreadyInitializedError)("DD_RUM", initConfiguration);
        },
        initConfiguration: initConfiguration
    }, startRumResult);
}

});
parcelRegister("h7dlA", function(module, exports) {

$parcel$export(module.exports, "sanitizeUser", () => $c75d7197f8114000$export$cb88b31dcf3267e1);
$parcel$export(module.exports, "checkUser", () => $c75d7197f8114000$export$77a0cf2b32e9e53d);

var $5IDGB = parcelRequire("5IDGB");

var $5DEie = parcelRequire("5DEie");

var $fkj4Q = parcelRequire("fkj4Q");
function $c75d7197f8114000$export$cb88b31dcf3267e1(newUser) {
    // We shallow clone only to prevent mutation of user data.
    var user = (0, $fkj4Q.assign)({}, newUser);
    var keys = [
        "id",
        "name",
        "email"
    ];
    keys.forEach(function(key) {
        if (key in user) user[key] = String(user[key]);
    });
    return user;
}
function $c75d7197f8114000$export$77a0cf2b32e9e53d(newUser) {
    var isValid = (0, $5DEie.getType)(newUser) === "object";
    if (!isValid) (0, $5IDGB.display).error("Unsupported user:", newUser);
    return isValid;
}

});
parcelRegister("5DEie", function(module, exports) {

$parcel$export(module.exports, "getType", () => $41afd9a0399e7c82$export$e2b5c5db9e2009fd);
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */ function $41afd9a0399e7c82$export$e2b5c5db9e2009fd(value) {
    if (value === null) return "null";
    if (Array.isArray(value)) return "array";
    return typeof value;
}

});


parcelRegister("ly0px", function(module, exports) {

$parcel$export(module.exports, "ONE_SECOND", () => $fafd178883cb17fc$export$32c0454ceff7f92d);
$parcel$export(module.exports, "ONE_MINUTE", () => $fafd178883cb17fc$export$35acaebf644db34e);
$parcel$export(module.exports, "ONE_HOUR", () => $fafd178883cb17fc$export$82541edf19e5e3b0);
$parcel$export(module.exports, "relativeToClocks", () => $fafd178883cb17fc$export$6d554362ef4543f2);
$parcel$export(module.exports, "timeStampToClocks", () => $fafd178883cb17fc$export$1208e92a226eb540);
$parcel$export(module.exports, "getRelativeTime", () => $fafd178883cb17fc$export$493c11ff22f45a24);
$parcel$export(module.exports, "dateNow", () => $fafd178883cb17fc$export$ceae11818251d43c);
$parcel$export(module.exports, "addDuration", () => $fafd178883cb17fc$export$c0c581816dedfc70);
$parcel$export(module.exports, "currentDrift", () => $fafd178883cb17fc$export$5dcf4148298ed557);
$parcel$export(module.exports, "toServerDuration", () => $fafd178883cb17fc$export$cc7917ebd320fa93);
$parcel$export(module.exports, "timeStampNow", () => $fafd178883cb17fc$export$71f52cdbbf629086);
$parcel$export(module.exports, "relativeNow", () => $fafd178883cb17fc$export$53cb631b087d9e92);
$parcel$export(module.exports, "clocksNow", () => $fafd178883cb17fc$export$67898643147706d3);
$parcel$export(module.exports, "clocksOrigin", () => $fafd178883cb17fc$export$d8b428538156d05f);
$parcel$export(module.exports, "elapsed", () => $fafd178883cb17fc$export$e04aa69d28450d55);
$parcel$export(module.exports, "looksLikeRelativeTime", () => $fafd178883cb17fc$export$dc53cd187b19c9f8);

var $bQmeT = parcelRequire("bQmeT");
var $fafd178883cb17fc$export$32c0454ceff7f92d = 1000;
var $fafd178883cb17fc$export$35acaebf644db34e = 60 * $fafd178883cb17fc$export$32c0454ceff7f92d;
var $fafd178883cb17fc$export$82541edf19e5e3b0 = 60 * $fafd178883cb17fc$export$35acaebf644db34e;
var $fafd178883cb17fc$export$a97a1358cbb650ab = 24 * $fafd178883cb17fc$export$82541edf19e5e3b0;
var $fafd178883cb17fc$export$99cafda57477293d = 365 * $fafd178883cb17fc$export$a97a1358cbb650ab;
function $fafd178883cb17fc$export$6d554362ef4543f2(relative) {
    return {
        relative: relative,
        timeStamp: $fafd178883cb17fc$var$getCorrectedTimeStamp(relative)
    };
}
function $fafd178883cb17fc$export$1208e92a226eb540(timeStamp) {
    return {
        relative: $fafd178883cb17fc$export$493c11ff22f45a24(timeStamp),
        timeStamp: timeStamp
    };
}
function $fafd178883cb17fc$var$getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = $fafd178883cb17fc$export$ceae11818251d43c() - performance.now();
    // apply correction only for positive drift
    if (correctedOrigin > $fafd178883cb17fc$var$getNavigationStart()) return Math.round($fafd178883cb17fc$export$c0c581816dedfc70(correctedOrigin, relativeTime));
    return $fafd178883cb17fc$export$3eddb21a9c389dec(relativeTime);
}
function $fafd178883cb17fc$export$5dcf4148298ed557() {
    return Math.round($fafd178883cb17fc$export$ceae11818251d43c() - $fafd178883cb17fc$export$c0c581816dedfc70($fafd178883cb17fc$var$getNavigationStart(), performance.now()));
}
function $fafd178883cb17fc$export$cc7917ebd320fa93(duration) {
    if (!(0, $bQmeT.isNumber)(duration)) return duration;
    return (0, $bQmeT.round)(duration * 1e6, 0);
}
function $fafd178883cb17fc$export$ceae11818251d43c() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
function $fafd178883cb17fc$export$71f52cdbbf629086() {
    return $fafd178883cb17fc$export$ceae11818251d43c();
}
function $fafd178883cb17fc$export$53cb631b087d9e92() {
    return performance.now();
}
function $fafd178883cb17fc$export$67898643147706d3() {
    return {
        relative: $fafd178883cb17fc$export$53cb631b087d9e92(),
        timeStamp: $fafd178883cb17fc$export$71f52cdbbf629086()
    };
}
function $fafd178883cb17fc$export$d8b428538156d05f() {
    return {
        relative: 0,
        timeStamp: $fafd178883cb17fc$var$getNavigationStart()
    };
}
function $fafd178883cb17fc$export$e04aa69d28450d55(start, end) {
    return end - start;
}
function $fafd178883cb17fc$export$c0c581816dedfc70(a, b) {
    return a + b;
}
function $fafd178883cb17fc$export$493c11ff22f45a24(timestamp) {
    return timestamp - $fafd178883cb17fc$var$getNavigationStart();
}
function $fafd178883cb17fc$export$3eddb21a9c389dec(relativeTime) {
    return Math.round($fafd178883cb17fc$export$c0c581816dedfc70($fafd178883cb17fc$var$getNavigationStart(), relativeTime));
}
function $fafd178883cb17fc$export$dc53cd187b19c9f8(time) {
    return time < $fafd178883cb17fc$export$99cafda57477293d;
}
/**
 * Navigation start slightly change on some rare cases
 */ var $fafd178883cb17fc$var$navigationStart;
function $fafd178883cb17fc$var$getNavigationStart() {
    if ($fafd178883cb17fc$var$navigationStart === undefined) $fafd178883cb17fc$var$navigationStart = performance.timing.navigationStart;
    return $fafd178883cb17fc$var$navigationStart;
}
function $fafd178883cb17fc$export$4db21cdd0be0ff26() {
    $fafd178883cb17fc$var$navigationStart = undefined;
}

});
parcelRegister("bQmeT", function(module, exports) {

$parcel$export(module.exports, "performDraw", () => $89f5cd41be2839b1$export$72c7afebfef3b500);
$parcel$export(module.exports, "round", () => $89f5cd41be2839b1$export$2077e0241d6afd3c);
$parcel$export(module.exports, "isPercentage", () => $89f5cd41be2839b1$export$d86432a85610ea90);
$parcel$export(module.exports, "isNumber", () => $89f5cd41be2839b1$export$7e4aa119212bc614);
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */ function $89f5cd41be2839b1$export$72c7afebfef3b500(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function $89f5cd41be2839b1$export$2077e0241d6afd3c(num, decimals) {
    return +num.toFixed(decimals);
}
function $89f5cd41be2839b1$export$d86432a85610ea90(value) {
    return $89f5cd41be2839b1$export$7e4aa119212bc614(value) && value >= 0 && value <= 100;
}
function $89f5cd41be2839b1$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}

});


parcelRegister("el7hs", function(module, exports) {

$parcel$export(module.exports, "createContextManager", () => $a708ac9bed8d6582$export$fe3149b78a43e1ad);

var $j9iCm = parcelRequire("j9iCm");

var $5DEie = parcelRequire("5DEie");

var $1RdIU = parcelRequire("1RdIU");

var $4wc1a = parcelRequire("4wc1a");
function $a708ac9bed8d6582$export$fe3149b78a43e1ad(customerDataTracker) {
    var context = {};
    var changeObservable = new (0, $4wc1a.Observable)();
    var contextManager = {
        getContext: function() {
            return (0, $j9iCm.deepClone)(context);
        },
        setContext: function(newContext) {
            if ((0, $5DEie.getType)(newContext) === "object") {
                context = (0, $1RdIU.sanitize)(newContext);
                customerDataTracker.updateCustomerData(context);
            } else contextManager.clearContext();
            changeObservable.notify();
        },
        setContextProperty: function(key, property) {
            context[key] = (0, $1RdIU.sanitize)(property);
            customerDataTracker.updateCustomerData(context);
            changeObservable.notify();
        },
        removeContextProperty: function(key) {
            delete context[key];
            customerDataTracker.updateCustomerData(context);
            changeObservable.notify();
        },
        clearContext: function() {
            context = {};
            customerDataTracker.resetCustomerData();
            changeObservable.notify();
        },
        changeObservable: changeObservable
    };
    return contextManager;
}

});
parcelRegister("j9iCm", function(module, exports) {

$parcel$export(module.exports, "deepClone", () => $df0d4cb06c424d45$export$b7d58db314e0ac27);
$parcel$export(module.exports, "combine", () => $df0d4cb06c424d45$export$1be1fc439b849fdf);

var $5DEie = parcelRequire("5DEie");
function $df0d4cb06c424d45$export$f00f2bc10b5384e6(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) circularReferenceChecker = $df0d4cb06c424d45$var$createCircularReferenceChecker();
    // ignore the source if it is undefined
    if (source === undefined) return destination;
    if (typeof source !== "object" || source === null) // primitive values - just return source
    return source;
    else if (source instanceof Date) return new Date(source.getTime());
    else if (source instanceof RegExp) {
        var flags = source.flags || // old browsers compatibility
        [
            source.global ? "g" : "",
            source.ignoreCase ? "i" : "",
            source.multiline ? "m" : "",
            source.sticky ? "y" : "",
            source.unicode ? "u" : ""
        ].join("");
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) // remove circular references
    return undefined;
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for(var i = 0; i < source.length; ++i)merged_1[i] = $df0d4cb06c424d45$export$f00f2bc10b5384e6(merged_1[i], source[i], circularReferenceChecker);
        return merged_1;
    }
    var merged = (0, $5DEie.getType)(destination) === "object" ? destination : {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) merged[key] = $df0d4cb06c424d45$export$f00f2bc10b5384e6(merged[key], source[key], circularReferenceChecker);
    return merged;
}
function $df0d4cb06c424d45$export$b7d58db314e0ac27(value) {
    return $df0d4cb06c424d45$export$f00f2bc10b5384e6(undefined, value);
}
function $df0d4cb06c424d45$export$1be1fc439b849fdf() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    var destination;
    for(var _a = 0, sources_1 = sources; _a < sources_1.length; _a++){
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) continue;
        destination = $df0d4cb06c424d45$export$f00f2bc10b5384e6(destination, source);
    }
    return destination;
}
function $df0d4cb06c424d45$var$createCircularReferenceChecker() {
    if (typeof WeakSet !== "undefined") {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function(value) {
                var has = set_1.has(value);
                if (!has) set_1.add(value);
                return has;
            }
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function(value) {
            var has = array.indexOf(value) >= 0;
            if (!has) array.push(value);
            return has;
        }
    };
}

});

parcelRegister("1RdIU", function(module, exports) {

$parcel$export(module.exports, "sanitize", () => $15a562dd6816cf15$export$83d2e9e3e4ee39ed);

var $5IDGB = parcelRequire("5IDGB");

var $7S2uk = parcelRequire("7S2uk");

var $1W8NF = parcelRequire("1W8NF");
// The maximum size of a single event is 256KiB. By default, we ensure that user-provided data
// going through sanitize fits inside our events, while leaving room for other contexts, metadata, ...
var $15a562dd6816cf15$var$SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * (0, $7S2uk.ONE_KIBI_BYTE);
// Symbol for the root element of the JSONPath used for visited objects
var $15a562dd6816cf15$var$JSON_PATH_ROOT_ELEMENT = "$";
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
var $15a562dd6816cf15$var$KEY_DECORATION_LENGTH = 3;
function $15a562dd6816cf15$export$83d2e9e3e4ee39ed(source, maxCharacterCount) {
    var _a;
    if (maxCharacterCount === void 0) maxCharacterCount = $15a562dd6816cf15$var$SANITIZE_DEFAULT_MAX_CHARACTER_COUNT;
    // Unbind any toJSON function we may have on [] or {} prototypes
    var restoreObjectPrototypeToJson = (0, $1W8NF.detachToJsonMethod)(Object.prototype);
    var restoreArrayPrototypeToJson = (0, $1W8NF.detachToJsonMethod)(Array.prototype);
    // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
    var containerQueue = [];
    var visitedObjectsWithPath = new WeakMap();
    var sanitizedData = $15a562dd6816cf15$var$sanitizeProcessor(source, $15a562dd6816cf15$var$JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
    var accumulatedCharacterCount = ((_a = JSON.stringify(sanitizedData)) === null || _a === void 0 ? void 0 : _a.length) || 0;
    if (accumulatedCharacterCount > maxCharacterCount) {
        $15a562dd6816cf15$var$warnOverCharacterLimit(maxCharacterCount, "discarded", source);
        return undefined;
    }
    while(containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount){
        var containerToProcess = containerQueue.shift();
        var separatorLength = 0; // 0 for the first element, 1 for subsequent elements
        // Arrays and Objects have to be handled distinctly to ensure
        // we do not pick up non-numerical properties from Arrays
        if (Array.isArray(containerToProcess.source)) for(var key = 0; key < containerToProcess.source.length; key++){
            var targetData = $15a562dd6816cf15$var$sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
            if (targetData !== undefined) accumulatedCharacterCount += JSON.stringify(targetData).length;
            else // When an element of an Array (targetData) is undefined, it is serialized as null:
            // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
            accumulatedCharacterCount += 4;
            accumulatedCharacterCount += separatorLength;
            separatorLength = 1;
            if (accumulatedCharacterCount > maxCharacterCount) {
                $15a562dd6816cf15$var$warnOverCharacterLimit(maxCharacterCount, "truncated", source);
                break;
            }
            containerToProcess.target[key] = targetData;
        }
        else {
            for(var key in containerToProcess.source)if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
                var targetData = $15a562dd6816cf15$var$sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                // When a property of an object has an undefined value, it will be dropped during serialization:
                // JSON.stringify({a:undefined}) => '{}'
                if (targetData !== undefined) {
                    accumulatedCharacterCount += JSON.stringify(targetData).length + separatorLength + key.length + $15a562dd6816cf15$var$KEY_DECORATION_LENGTH;
                    separatorLength = 1;
                }
                if (accumulatedCharacterCount > maxCharacterCount) {
                    $15a562dd6816cf15$var$warnOverCharacterLimit(maxCharacterCount, "truncated", source);
                    break;
                }
                containerToProcess.target[key] = targetData;
            }
        }
    }
    // Rebind detached toJSON functions
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    return sanitizedData;
}
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */ function $15a562dd6816cf15$var$sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
    // Start by handling toJSON, as we want to sanitize its output
    var sourceToSanitize = $15a562dd6816cf15$var$tryToApplyToJSON(source);
    if (!sourceToSanitize || typeof sourceToSanitize !== "object") return $15a562dd6816cf15$var$sanitizePrimitivesAndFunctions(sourceToSanitize);
    var sanitizedSource = $15a562dd6816cf15$var$sanitizeObjects(sourceToSanitize);
    if (sanitizedSource !== "[Object]" && sanitizedSource !== "[Array]" && sanitizedSource !== "[Error]") return sanitizedSource;
    // Handle potential cyclic references
    // We need to use source as sourceToSanitize could be a reference to a new object
    // At this stage, we know the source is an object type
    var sourceAsObject = source;
    if (visitedObjectsWithPath.has(sourceAsObject)) return "[Reference seen at ".concat(visitedObjectsWithPath.get(sourceAsObject), "]");
    // Add processed source to queue
    var currentPath = key !== undefined ? "".concat(parentPath, ".").concat(key) : parentPath;
    var target = Array.isArray(sourceToSanitize) ? [] : {};
    visitedObjectsWithPath.set(sourceAsObject, currentPath);
    queue.push({
        source: sourceToSanitize,
        target: target,
        path: currentPath
    });
    return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */ function $15a562dd6816cf15$var$sanitizePrimitivesAndFunctions(value) {
    // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
    if (typeof value === "bigint") return "[BigInt] ".concat(value.toString());
    // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
    // so it won't prevent stringify from serializing later
    if (typeof value === "function") return "[Function] ".concat(value.name || "unknown");
    // JSON.stringify() does not serialize symbols.
    if (typeof value === "symbol") return "[Symbol] ".concat(value.description || value.toString());
    return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 * - IE11 does not return a distinct type for objects such as Map, WeakMap, ... These objects will pass through and their
 * properties enumerated if any.
 *
 */ function $15a562dd6816cf15$var$sanitizeObjects(value) {
    try {
        // Handle events - Keep a simple implementation to avoid breaking changes
        if (value instanceof Event) return {
            isTrusted: value.isTrusted
        };
        // Handle all remaining object types in a generic way
        var result = Object.prototype.toString.call(value);
        var match = result.match(/\[object (.*)\]/);
        if (match && match[1]) return "[".concat(match[1], "]");
    } catch (_a) {
    // If the previous serialization attempts failed, and we cannot convert using
    // Object.prototype.toString, declare the value unserializable
    }
    return "[Unserializable]";
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */ function $15a562dd6816cf15$var$tryToApplyToJSON(value) {
    var object = value;
    if (object && typeof object.toJSON === "function") try {
        return object.toJSON();
    } catch (_a) {
    // If toJSON fails, we continue by trying to serialize the value manually
    }
    return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */ function $15a562dd6816cf15$var$warnOverCharacterLimit(maxCharacterCount, changeType, source) {
    (0, $5IDGB.display).warn("The data provided has been ".concat(changeType, " as it is over the limit of ").concat(maxCharacterCount, " characters:"), source);
}

});
parcelRegister("7S2uk", function(module, exports) {

$parcel$export(module.exports, "ONE_KIBI_BYTE", () => $5baf81a8b4674c85$export$756c3d65870c899e);
$parcel$export(module.exports, "ONE_MEBI_BYTE", () => $5baf81a8b4674c85$export$377b1474fc07c10f);
$parcel$export(module.exports, "computeBytesCount", () => $5baf81a8b4674c85$export$36cba7c53d8f13a2);
$parcel$export(module.exports, "concatBuffers", () => $5baf81a8b4674c85$export$28e250f55413be00);
var $5baf81a8b4674c85$export$756c3d65870c899e = 1024;
var $5baf81a8b4674c85$export$377b1474fc07c10f = 1024 * $5baf81a8b4674c85$export$756c3d65870c899e;
// eslint-disable-next-line no-control-regex
var $5baf81a8b4674c85$var$HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function $5baf81a8b4674c85$export$36cba7c53d8f13a2(candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!$5baf81a8b4674c85$var$HAS_MULTI_BYTES_CHARACTERS.test(candidate)) return candidate.length;
    if (window.TextEncoder !== undefined) return new TextEncoder().encode(candidate).length;
    return new Blob([
        candidate
    ]).size;
}
function $5baf81a8b4674c85$export$28e250f55413be00(buffers) {
    var length = buffers.reduce(function(total, buffer) {
        return total + buffer.length;
    }, 0);
    var result = new Uint8Array(length);
    var offset = 0;
    for(var _i = 0, buffers_1 = buffers; _i < buffers_1.length; _i++){
        var buffer = buffers_1[_i];
        result.set(buffer, offset);
        offset += buffer.length;
    }
    return result;
}

});

parcelRegister("1W8NF", function(module, exports) {

$parcel$export(module.exports, "jsonStringify", () => $169208b8dc904506$export$1f8609334739c2b6);
$parcel$export(module.exports, "detachToJsonMethod", () => $169208b8dc904506$export$f6ec9d87b663748);

var $aed8w = parcelRequire("aed8w");
function $169208b8dc904506$export$1f8609334739c2b6(value, replacer, space) {
    if (typeof value !== "object" || value === null) return JSON.stringify(value);
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    var restoreObjectPrototypeToJson = $169208b8dc904506$export$f6ec9d87b663748(Object.prototype);
    var restoreArrayPrototypeToJson = $169208b8dc904506$export$f6ec9d87b663748(Array.prototype);
    var restoreValuePrototypeToJson = $169208b8dc904506$export$f6ec9d87b663748(Object.getPrototypeOf(value));
    var restoreValueToJson = $169208b8dc904506$export$f6ec9d87b663748(value);
    try {
        return JSON.stringify(value, replacer, space);
    } catch (_a) {
        return "<error: unable to serialize object>";
    } finally{
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
function $169208b8dc904506$export$f6ec9d87b663748(value) {
    var object = value;
    var objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return function() {
            object.toJSON = objectToJson;
        };
    }
    return 0, $aed8w.noop;
}

});
parcelRegister("aed8w", function(module, exports) {

$parcel$export(module.exports, "throttle", () => $772566d0dfa3645c$export$de363e709c412c8a);
$parcel$export(module.exports, "noop", () => $772566d0dfa3645c$export$8793edee2d425525);

var $d97UU = parcelRequire("d97UU");
function $772566d0dfa3645c$export$de363e709c412c8a(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function() {
            var parameters = [];
            for(var _i = 0; _i < arguments.length; _i++)parameters[_i] = arguments[_i];
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) fn.apply(void 0, parameters);
            else pendingExecutionWithParameters = parameters;
            inWaitPeriod = true;
            pendingTimeoutId = (0, $d97UU.setTimeout)(function() {
                if (needTrailingExecution && pendingExecutionWithParameters) fn.apply(void 0, pendingExecutionWithParameters);
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function() {
            (0, $d97UU.clearTimeout)(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        }
    };
}
function $772566d0dfa3645c$export$8793edee2d425525() {}

});
parcelRegister("d97UU", function(module, exports) {

$parcel$export(module.exports, "setTimeout", () => $02784b622c768a70$export$831dc9f2ab0a617b);
$parcel$export(module.exports, "clearTimeout", () => $02784b622c768a70$export$4e6a25ba7ce9d78e);
$parcel$export(module.exports, "setInterval", () => $02784b622c768a70$export$cda6c73645970615);
$parcel$export(module.exports, "clearInterval", () => $02784b622c768a70$export$5c0dc72231454d02);

var $5sf7S = parcelRequire("5sf7S");

var $2wH3Z = parcelRequire("2wH3Z");

var $7ZD4v = parcelRequire("7ZD4v");
function $02784b622c768a70$export$831dc9f2ab0a617b(callback, delay) {
    return (0, $5sf7S.getZoneJsOriginalValue)((0, $7ZD4v.getGlobalObject)(), "setTimeout")((0, $2wH3Z.monitor)(callback), delay);
}
function $02784b622c768a70$export$4e6a25ba7ce9d78e(timeoutId) {
    (0, $5sf7S.getZoneJsOriginalValue)((0, $7ZD4v.getGlobalObject)(), "clearTimeout")(timeoutId);
}
function $02784b622c768a70$export$cda6c73645970615(callback, delay) {
    return (0, $5sf7S.getZoneJsOriginalValue)((0, $7ZD4v.getGlobalObject)(), "setInterval")((0, $2wH3Z.monitor)(callback), delay);
}
function $02784b622c768a70$export$5c0dc72231454d02(timeoutId) {
    (0, $5sf7S.getZoneJsOriginalValue)((0, $7ZD4v.getGlobalObject)(), "clearInterval")(timeoutId);
}

});
parcelRegister("5sf7S", function(module, exports) {

$parcel$export(module.exports, "getZoneJsOriginalValue", () => $3f8b4cfb9b188c27$export$610f486206760177);

var $7ZD4v = parcelRequire("7ZD4v");
function $3f8b4cfb9b188c27$export$610f486206760177(target, name) {
    var browserWindow = (0, $7ZD4v.getGlobalObject)();
    var original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === "function") original = target[browserWindow.Zone.__symbol__(name)];
    if (!original) original = target[name];
    return original;
}

});





parcelRegister("4wc1a", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $34a3791423ee474f$export$77cea355fa80b5f4);
$parcel$export(module.exports, "mergeObservables", () => $34a3791423ee474f$export$ca54b410f15f44fe);
var $34a3791423ee474f$export$77cea355fa80b5f4 = /** @class */ function() {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function(f) {
        var _this = this;
        if (!this.observers.length && this.onFirstSubscribe) this.onLastUnsubscribe = this.onFirstSubscribe(this) || undefined;
        this.observers.push(f);
        return {
            unsubscribe: function() {
                _this.observers = _this.observers.filter(function(other) {
                    return f !== other;
                });
                if (!_this.observers.length && _this.onLastUnsubscribe) _this.onLastUnsubscribe();
            }
        };
    };
    Observable.prototype.notify = function(data) {
        this.observers.forEach(function(observer) {
            return observer(data);
        });
    };
    return Observable;
}();
function $34a3791423ee474f$export$ca54b410f15f44fe() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return new $34a3791423ee474f$export$77cea355fa80b5f4(function(globalObservable) {
        var subscriptions = observables.map(function(observable) {
            return observable.subscribe(function(data) {
                return globalObservable.notify(data);
            });
        });
        return function() {
            return subscriptions.forEach(function(subscription) {
                return subscription.unsubscribe();
            });
        };
    });
}

});


parcelRegister("96vba", function(module, exports) {

$parcel$export(module.exports, "createCustomerDataTrackerManager", () => $6a0cdc23e79adf0f$export$91e74adeb321d399);

var $7S2uk = parcelRequire("7S2uk");

var $aed8w = parcelRequire("aed8w");

var $1W8NF = parcelRequire("1W8NF");

var $5IDGB = parcelRequire("5IDGB");

var $8PiRA = parcelRequire("8PiRA");
var $6a0cdc23e79adf0f$export$856a8907751d74c7 = 3 * (0, $7S2uk.ONE_KIBI_BYTE);
var $6a0cdc23e79adf0f$export$c5b99750d2340cdd = 16 * (0, $7S2uk.ONE_KIBI_BYTE);
var $6a0cdc23e79adf0f$export$e4441139afa265bd = 200;
function $6a0cdc23e79adf0f$export$91e74adeb321d399(compressionStatus) {
    if (compressionStatus === void 0) compressionStatus = 2 /* CustomerDataCompressionStatus.Disabled */ ;
    var customerDataTrackers = new Map();
    var alreadyWarned = false;
    function checkCustomerDataLimit(initialBytesCount) {
        if (initialBytesCount === void 0) initialBytesCount = 0;
        if (alreadyWarned || compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */ ) return;
        var bytesCountLimit = compressionStatus === 2 /* CustomerDataCompressionStatus.Disabled */  ? $6a0cdc23e79adf0f$export$856a8907751d74c7 : $6a0cdc23e79adf0f$export$c5b99750d2340cdd;
        var bytesCount = initialBytesCount;
        customerDataTrackers.forEach(function(tracker) {
            bytesCount += tracker.getBytesCount();
        });
        if (bytesCount > bytesCountLimit) {
            $6a0cdc23e79adf0f$var$displayCustomerDataLimitReachedWarning(bytesCountLimit);
            alreadyWarned = true;
        }
    }
    return {
        /**
         * Creates a detached tracker. The manager will not store a reference to that tracker, and the
         * bytes count will be counted independently from other detached trackers.
         *
         * This is particularly useful when we don't know when the tracker will be unused, so we don't
         * leak memory (ex: when used in Logger instances).
         */ createDetachedTracker: function() {
            var tracker = $6a0cdc23e79adf0f$export$1cff91322f949d75(function() {
                return checkCustomerDataLimit(tracker.getBytesCount());
            });
            return tracker;
        },
        /**
         * Creates a tracker if it doesn't exist, and returns it.
         */ getOrCreateTracker: function(type) {
            if (!customerDataTrackers.has(type)) customerDataTrackers.set(type, $6a0cdc23e79adf0f$export$1cff91322f949d75(checkCustomerDataLimit));
            return customerDataTrackers.get(type);
        },
        setCompressionStatus: function(newCompressionStatus) {
            if (compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */ ) {
                compressionStatus = newCompressionStatus;
                checkCustomerDataLimit();
            }
        },
        getCompressionStatus: function() {
            return compressionStatus;
        },
        stop: function() {
            customerDataTrackers.forEach(function(tracker) {
                return tracker.stop();
            });
            customerDataTrackers.clear();
        }
    };
}
function $6a0cdc23e79adf0f$export$1cff91322f949d75(checkCustomerDataLimit) {
    var bytesCountCache = 0;
    // Throttle the bytes computation to minimize the impact on performance.
    // Especially useful if the user call context APIs synchronously multiple times in a row
    var _a = (0, $aed8w.throttle)(function(context) {
        bytesCountCache = (0, $7S2uk.computeBytesCount)((0, $1W8NF.jsonStringify)(context));
        checkCustomerDataLimit();
    }, $6a0cdc23e79adf0f$export$e4441139afa265bd), computeBytesCountThrottled = _a.throttled, cancelComputeBytesCount = _a.cancel;
    var resetBytesCount = function() {
        cancelComputeBytesCount();
        bytesCountCache = 0;
    };
    return {
        updateCustomerData: function(context) {
            if ((0, $8PiRA.isEmptyObject)(context)) resetBytesCount();
            else computeBytesCountThrottled(context);
        },
        resetCustomerData: resetBytesCount,
        getBytesCount: function() {
            return bytesCountCache;
        },
        stop: function() {
            cancelComputeBytesCount();
        }
    };
}
function $6a0cdc23e79adf0f$var$displayCustomerDataLimitReachedWarning(bytesCountLimit) {
    (0, $5IDGB.display).warn("Customer data exceeds the recommended ".concat(bytesCountLimit / (0, $7S2uk.ONE_KIBI_BYTE), "KiB threshold. More details: https://docs.datadoghq.com/real_user_monitoring/browser/troubleshooting/#customer-data-exceeds-the-recommended-threshold-warning"));
}

});
parcelRegister("8PiRA", function(module, exports) {

$parcel$export(module.exports, "shallowClone", () => $66d1b7fd2da44c06$export$370e8311c3cdebd9);
$parcel$export(module.exports, "objectHasValue", () => $66d1b7fd2da44c06$export$783ef1184b4cd483);
$parcel$export(module.exports, "isEmptyObject", () => $66d1b7fd2da44c06$export$83b788b1a3698c03);
$parcel$export(module.exports, "mapValues", () => $66d1b7fd2da44c06$export$825e789796ab7275);

var $fkj4Q = parcelRequire("fkj4Q");
function $66d1b7fd2da44c06$export$370e8311c3cdebd9(object) {
    return (0, $fkj4Q.assign)({}, object);
}
function $66d1b7fd2da44c06$export$783ef1184b4cd483(object, value) {
    return Object.keys(object).some(function(key) {
        return object[key] === value;
    });
}
function $66d1b7fd2da44c06$export$83b788b1a3698c03(object) {
    return Object.keys(object).length === 0;
}
function $66d1b7fd2da44c06$export$825e789796ab7275(object, fn) {
    var newObject = {};
    for(var _i = 0, _a = Object.keys(object); _i < _a.length; _i++){
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}

});


parcelRegister("4Be0w", function(module, exports) {

$parcel$export(module.exports, "NO_ERROR_STACK_PRESENT_MESSAGE", () => $35957bb00d7299b7$export$25ad0fcc62fe3571);
$parcel$export(module.exports, "computeRawError", () => $35957bb00d7299b7$export$b8dc46b79c72ee26);
$parcel$export(module.exports, "toStackTraceString", () => $35957bb00d7299b7$export$36ad41d7075a6f2b);
$parcel$export(module.exports, "flattenErrorCauses", () => $35957bb00d7299b7$export$bf9a979d43c83a9);
$parcel$export(module.exports, "tryToGetFingerprint", () => $35957bb00d7299b7$export$1c18937f21a7f1f7);
$parcel$export(module.exports, "formatErrorMessage", () => $35957bb00d7299b7$export$5201d50a34753d71);
$parcel$export(module.exports, "getFileFromStackTraceString", () => $35957bb00d7299b7$export$edc1986890374033);
$parcel$export(module.exports, "createHandlingStack", () => $35957bb00d7299b7$export$46c2cbbc853cd95b);

var $2wH3Z = parcelRequire("2wH3Z");

var $1RdIU = parcelRequire("1RdIU");

var $aed8w = parcelRequire("aed8w");

var $1W8NF = parcelRequire("1W8NF");

var $iJHw0 = parcelRequire("iJHw0");
var $35957bb00d7299b7$export$25ad0fcc62fe3571 = "No stack, consider using an instance of Error";
function $35957bb00d7299b7$export$b8dc46b79c72ee26(_a) {
    var stackTrace = _a.stackTrace, originalError = _a.originalError, handlingStack = _a.handlingStack, startClocks = _a.startClocks, nonErrorPrefix = _a.nonErrorPrefix, source = _a.source, handling = _a.handling;
    var isErrorInstance = originalError instanceof Error;
    var message = $35957bb00d7299b7$var$computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError);
    var stack = $35957bb00d7299b7$var$hasUsableStack(isErrorInstance, stackTrace) ? $35957bb00d7299b7$export$36ad41d7075a6f2b(stackTrace) : $35957bb00d7299b7$export$25ad0fcc62fe3571;
    var causes = isErrorInstance ? $35957bb00d7299b7$export$bf9a979d43c83a9(originalError, source) : undefined;
    var type = stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name;
    var fingerprint = $35957bb00d7299b7$export$1c18937f21a7f1f7(originalError);
    return {
        startClocks: startClocks,
        source: source,
        handling: handling,
        handlingStack: handlingStack,
        originalError: originalError,
        type: type,
        message: message,
        stack: stack,
        causes: causes,
        fingerprint: fingerprint
    };
}
function $35957bb00d7299b7$var$computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
    // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
    // TODO rework tracekit integration to avoid scattering error building logic
    return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name) ? stackTrace.message : !isErrorInstance ? "".concat(nonErrorPrefix, " ").concat((0, $1W8NF.jsonStringify)((0, $1RdIU.sanitize)(originalError))) : "Empty message";
}
function $35957bb00d7299b7$var$hasUsableStack(isErrorInstance, stackTrace) {
    if (stackTrace === undefined) return false;
    if (isErrorInstance) return true;
    // handle cases where tracekit return stack = [] or stack = [{url: undefined, line: undefined, column: undefined}]
    // TODO rework tracekit integration to avoid generating those unusable stack
    return stackTrace.stack.length > 0 && (stackTrace.stack.length > 1 || stackTrace.stack[0].url !== undefined);
}
function $35957bb00d7299b7$export$1c18937f21a7f1f7(originalError) {
    return originalError instanceof Error && "dd_fingerprint" in originalError ? String(originalError.dd_fingerprint) : undefined;
}
function $35957bb00d7299b7$export$36ad41d7075a6f2b(stack) {
    var result = $35957bb00d7299b7$export$5201d50a34753d71(stack);
    stack.stack.forEach(function(frame) {
        var func = frame.func === "?" ? "<anonymous>" : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(", "), ")") : "";
        var line = frame.line ? ":".concat(frame.line) : "";
        var column = frame.line && frame.column ? ":".concat(frame.column) : "";
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
function $35957bb00d7299b7$export$edc1986890374033(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
function $35957bb00d7299b7$export$5201d50a34753d71(stack) {
    return "".concat(stack.name || "Error", ": ").concat(stack.message);
}
function $35957bb00d7299b7$export$46c2cbbc853cd95b() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */ var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) try {
        throw error;
    } catch (e) {
        (0, $aed8w.noop)();
    }
    (0, $2wH3Z.callMonitored)(function() {
        var stackTrace = (0, $iJHw0.computeStackTrace)(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = $35957bb00d7299b7$export$36ad41d7075a6f2b(stackTrace);
    });
    return formattedStack;
}
function $35957bb00d7299b7$export$bf9a979d43c83a9(error, parentSource) {
    var currentError = error;
    var causes = [];
    while((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10){
        var stackTrace = (0, $iJHw0.computeStackTrace)(currentError.cause);
        causes.push({
            message: currentError.cause.message,
            source: parentSource,
            type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
            stack: stackTrace && $35957bb00d7299b7$export$36ad41d7075a6f2b(stackTrace)
        });
        currentError = currentError.cause;
    }
    return causes.length ? causes : undefined;
}

});
parcelRegister("iJHw0", function(module, exports) {

$parcel$export(module.exports, "computeStackTrace", () => $da3e2f31216476b1$export$81296eded4f2ac09);
$parcel$export(module.exports, "computeStackTraceFromOnErrorMessage", () => $da3e2f31216476b1$export$e8e53f0e2ff18afa);
/**
 * Cross-browser stack trace computation.
 *
 * Reference implementation: https://github.com/csnover/TraceKit/blob/04530298073c3823de72deb0b97e7b38ca7bcb59/tracekit.js
 */ 
var $fkj4Q = parcelRequire("fkj4Q");
var $da3e2f31216476b1$var$UNKNOWN_FUNCTION = "?";
function $da3e2f31216476b1$export$81296eded4f2ac09(ex) {
    var stack = [];
    var stackProperty = $da3e2f31216476b1$var$tryToGetString(ex, "stack");
    var exString = String(ex);
    if (stackProperty && (0, $fkj4Q.startsWith)(stackProperty, exString)) stackProperty = stackProperty.slice(exString.length);
    if (stackProperty) stackProperty.split("\n").forEach(function(line) {
        var stackFrame = $da3e2f31216476b1$var$parseChromeLine(line) || $da3e2f31216476b1$var$parseChromeAnonymousLine(line) || $da3e2f31216476b1$var$parseWinLine(line) || $da3e2f31216476b1$var$parseGeckoLine(line);
        if (stackFrame) {
            if (!stackFrame.func && stackFrame.line) stackFrame.func = $da3e2f31216476b1$var$UNKNOWN_FUNCTION;
            stack.push(stackFrame);
        }
    });
    return {
        message: $da3e2f31216476b1$var$tryToGetString(ex, "message"),
        name: $da3e2f31216476b1$var$tryToGetString(ex, "name"),
        stack: stack
    };
}
var $da3e2f31216476b1$var$fileUrl = "((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)";
var $da3e2f31216476b1$var$filePosition = "(?::(\\d+))";
var $da3e2f31216476b1$var$CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat($da3e2f31216476b1$var$fileUrl).concat($da3e2f31216476b1$var$filePosition, "?").concat($da3e2f31216476b1$var$filePosition, "?\\)?\\s*$"), "i");
var $da3e2f31216476b1$var$CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat($da3e2f31216476b1$var$filePosition).concat($da3e2f31216476b1$var$filePosition, "\\)"));
function $da3e2f31216476b1$var$parseChromeLine(line) {
    var parts = $da3e2f31216476b1$var$CHROME_LINE_RE.exec(line);
    if (!parts) return;
    var isNative = parts[2] && parts[2].indexOf("native") === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
    var submatch = $da3e2f31216476b1$var$CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [
            parts[2]
        ] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || $da3e2f31216476b1$var$UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined
    };
}
var $da3e2f31216476b1$var$CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat($da3e2f31216476b1$var$fileUrl).concat($da3e2f31216476b1$var$filePosition, "?").concat($da3e2f31216476b1$var$filePosition, "??\\s*$"), "i");
function $da3e2f31216476b1$var$parseChromeAnonymousLine(line) {
    var parts = $da3e2f31216476b1$var$CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) return;
    return {
        args: [],
        column: parts[3] ? +parts[3] : undefined,
        func: $da3e2f31216476b1$var$UNKNOWN_FUNCTION,
        line: parts[2] ? +parts[2] : undefined,
        url: parts[1]
    };
}
var $da3e2f31216476b1$var$WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function $da3e2f31216476b1$var$parseWinLine(line) {
    var parts = $da3e2f31216476b1$var$WINJS_LINE_RE.exec(line);
    if (!parts) return;
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || $da3e2f31216476b1$var$UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2]
    };
}
var $da3e2f31216476b1$var$GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var $da3e2f31216476b1$var$GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function $da3e2f31216476b1$var$parseGeckoLine(line) {
    var parts = $da3e2f31216476b1$var$GECKO_LINE_RE.exec(line);
    if (!parts) return;
    var isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
    var submatch = $da3e2f31216476b1$var$GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(",") : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || $da3e2f31216476b1$var$UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3]
    };
}
function $da3e2f31216476b1$var$tryToGetString(candidate, property) {
    if (typeof candidate !== "object" || !candidate || !(property in candidate)) return undefined;
    var value = candidate[property];
    return typeof value === "string" ? value : undefined;
}
function $da3e2f31216476b1$export$e8e53f0e2ff18afa(messageObj, url, line, column) {
    var stack = [
        {
            url: url,
            column: column,
            line: line
        }
    ];
    var _a = $da3e2f31216476b1$var$tryToParseMessage(messageObj), name = _a.name, message = _a.message;
    return {
        name: name,
        message: message,
        stack: stack
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var $da3e2f31216476b1$var$ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function $da3e2f31216476b1$var$tryToParseMessage(messageObj) {
    var _a;
    var name;
    var message;
    if (({}).toString.call(messageObj) === "[object String]") _a = $da3e2f31216476b1$var$ERROR_TYPES_RE.exec(messageObj), name = _a[1], message = _a[2];
    return {
        name: name,
        message: message
    };
}

});


parcelRegister("lTIYX", function(module, exports) {

$parcel$export(module.exports, "createIdentityEncoder", () => $ff11a0928c846f93$export$b5341466c7007825);

var $7S2uk = parcelRequire("7S2uk");
function $ff11a0928c846f93$export$b5341466c7007825() {
    var output = "";
    var outputBytesCount = 0;
    return {
        isAsync: false,
        get isEmpty () {
            return !output;
        },
        write: function(data, callback) {
            var additionalEncodedBytesCount = (0, $7S2uk.computeBytesCount)(data);
            outputBytesCount += additionalEncodedBytesCount;
            output += data;
            if (callback) callback(additionalEncodedBytesCount);
        },
        finish: function(callback) {
            callback(this.finishSync());
        },
        finishSync: function() {
            var result = {
                output: output,
                outputBytesCount: outputBytesCount,
                rawBytesCount: outputBytesCount,
                pendingData: ""
            };
            output = "";
            outputBytesCount = 0;
            return result;
        },
        estimateEncodedBytesCount: function(data) {
            return data.length;
        }
    };
}

});

parcelRegister("95XVG", function(module, exports) {

$parcel$export(module.exports, "TrackingConsent", () => $69f3116f372ada5b$export$52745dd8ee2d32b2);
$parcel$export(module.exports, "createTrackingConsentState", () => $69f3116f372ada5b$export$6a999af43d888e18);

var $4wc1a = parcelRequire("4wc1a");
var $69f3116f372ada5b$export$52745dd8ee2d32b2 = {
    GRANTED: "granted",
    NOT_GRANTED: "not-granted"
};
function $69f3116f372ada5b$export$6a999af43d888e18(currentConsent) {
    var observable = new (0, $4wc1a.Observable)();
    return {
        tryToInit: function(trackingConsent) {
            if (!currentConsent) currentConsent = trackingConsent;
        },
        update: function(trackingConsent) {
            currentConsent = trackingConsent;
            observable.notify();
        },
        isGranted: function() {
            return currentConsent === $69f3116f372ada5b$export$52745dd8ee2d32b2.GRANTED;
        },
        observable: observable
    };
}

});

parcelRegister("gurxr", function(module, exports) {

$parcel$export(module.exports, "displayAlreadyInitializedError", () => $c014cf41d8e6d87d$export$b25c854130ebaef9);

var $5IDGB = parcelRequire("5IDGB");
function $c014cf41d8e6d87d$export$b25c854130ebaef9(sdkName, initConfiguration) {
    if (!initConfiguration.silentMultipleInit) (0, $5IDGB.display).error("".concat(sdkName, " is already initialized."));
}

});

parcelRegister("k2pmh", function(module, exports) {

$parcel$export(module.exports, "ExperimentalFeature", () => $e967aa36fccc7e29$export$8c1a7666d5772525);
$parcel$export(module.exports, "addExperimentalFeatures", () => $e967aa36fccc7e29$export$6d36e587aa761763);
$parcel$export(module.exports, "isExperimentalFeatureEnabled", () => $e967aa36fccc7e29$export$ada3eaf101ef7eb6);
$parcel$export(module.exports, "getExperimentalFeatures", () => $e967aa36fccc7e29$export$45a70c97bd86e1c8);
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */ // We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag
// eslint-disable-next-line no-restricted-syntax
var $e967aa36fccc7e29$export$8c1a7666d5772525;
(function(ExperimentalFeature) {
    ExperimentalFeature["PAGEHIDE"] = "pagehide";
    ExperimentalFeature["FEATURE_FLAGS"] = "feature_flags";
    ExperimentalFeature["RESOURCE_PAGE_STATES"] = "resource_page_states";
    ExperimentalFeature["COLLECT_FLUSH_REASON"] = "collect_flush_reason";
    ExperimentalFeature["ZERO_LCP_TELEMETRY"] = "zero_lcp_telemetry";
    ExperimentalFeature["DISABLE_REPLAY_INLINE_CSS"] = "disable_replay_inline_css";
    ExperimentalFeature["WRITABLE_RESOURCE_GRAPHQL"] = "writable_resource_graphql";
    ExperimentalFeature["CUSTOM_VITALS"] = "custom_vitals";
})($e967aa36fccc7e29$export$8c1a7666d5772525 || ($e967aa36fccc7e29$export$8c1a7666d5772525 = {}));
var $e967aa36fccc7e29$var$enabledExperimentalFeatures = new Set();
function $e967aa36fccc7e29$export$6d36e587aa761763(enabledFeatures) {
    enabledFeatures.forEach(function(flag) {
        $e967aa36fccc7e29$var$enabledExperimentalFeatures.add(flag);
    });
}
function $e967aa36fccc7e29$export$ada3eaf101ef7eb6(featureName) {
    return $e967aa36fccc7e29$var$enabledExperimentalFeatures.has(featureName);
}
function $e967aa36fccc7e29$export$4248398637d8b60d() {
    $e967aa36fccc7e29$var$enabledExperimentalFeatures.clear();
}
function $e967aa36fccc7e29$export$45a70c97bd86e1c8() {
    return $e967aa36fccc7e29$var$enabledExperimentalFeatures;
}

});

parcelRegister("adV8b", function(module, exports) {

$parcel$export(module.exports, "storeContextManager", () => $77176f4fd68bc5cf$export$a658cbc041b124d0);

var $hXhfS = parcelRequire("hXhfS");

var $j9iCm = parcelRequire("j9iCm");
var $77176f4fd68bc5cf$var$CONTEXT_STORE_KEY_PREFIX = "_dd_c";
var $77176f4fd68bc5cf$var$storageListeners = [];
function $77176f4fd68bc5cf$export$a658cbc041b124d0(configuration, contextManager, productKey, customerDataType) {
    var storageKey = $77176f4fd68bc5cf$export$c2d6dd7271dc8ae0(productKey, customerDataType);
    $77176f4fd68bc5cf$var$storageListeners.push((0, $hXhfS.addEventListener)(configuration, window, (0, $hXhfS.DOM_EVENT).STORAGE, function(_a) {
        var key = _a.key;
        if (storageKey === key) synchronizeWithStorage();
    }));
    contextManager.changeObservable.subscribe(dumpToStorage);
    contextManager.setContext((0, $j9iCm.combine)(getFromStorage(), contextManager.getContext()));
    function synchronizeWithStorage() {
        contextManager.setContext(getFromStorage());
    }
    function dumpToStorage() {
        localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
    }
    function getFromStorage() {
        var rawContext = localStorage.getItem(storageKey);
        return rawContext !== null ? JSON.parse(rawContext) : {};
    }
}
function $77176f4fd68bc5cf$export$c2d6dd7271dc8ae0(productKey, customerDataType) {
    return "".concat($77176f4fd68bc5cf$var$CONTEXT_STORE_KEY_PREFIX, "_").concat(productKey, "_").concat(customerDataType);
}
function $77176f4fd68bc5cf$export$c82fd872f963a6c() {
    $77176f4fd68bc5cf$var$storageListeners.map(function(listener) {
        return listener.stop();
    });
}

});
parcelRegister("hXhfS", function(module, exports) {

$parcel$export(module.exports, "DOM_EVENT", () => $d12554daef4f5e60$export$54664c6599f7afe2);
$parcel$export(module.exports, "addEventListener", () => $d12554daef4f5e60$export$3f65cefe8380dbea);
$parcel$export(module.exports, "addEventListeners", () => $d12554daef4f5e60$export$40a4ed63e5cb7043);

var $2wH3Z = parcelRequire("2wH3Z");

var $5sf7S = parcelRequire("5sf7S");
var $d12554daef4f5e60$export$54664c6599f7afe2;
(function(DOM_EVENT) {
    DOM_EVENT["BEFORE_UNLOAD"] = "beforeunload";
    DOM_EVENT["CLICK"] = "click";
    DOM_EVENT["DBL_CLICK"] = "dblclick";
    DOM_EVENT["KEY_DOWN"] = "keydown";
    DOM_EVENT["LOAD"] = "load";
    DOM_EVENT["POP_STATE"] = "popstate";
    DOM_EVENT["SCROLL"] = "scroll";
    DOM_EVENT["TOUCH_START"] = "touchstart";
    DOM_EVENT["TOUCH_END"] = "touchend";
    DOM_EVENT["TOUCH_MOVE"] = "touchmove";
    DOM_EVENT["VISIBILITY_CHANGE"] = "visibilitychange";
    DOM_EVENT["PAGE_SHOW"] = "pageshow";
    DOM_EVENT["FREEZE"] = "freeze";
    DOM_EVENT["RESUME"] = "resume";
    DOM_EVENT["DOM_CONTENT_LOADED"] = "DOMContentLoaded";
    DOM_EVENT["POINTER_DOWN"] = "pointerdown";
    DOM_EVENT["POINTER_UP"] = "pointerup";
    DOM_EVENT["POINTER_CANCEL"] = "pointercancel";
    DOM_EVENT["HASH_CHANGE"] = "hashchange";
    DOM_EVENT["PAGE_HIDE"] = "pagehide";
    DOM_EVENT["MOUSE_DOWN"] = "mousedown";
    DOM_EVENT["MOUSE_UP"] = "mouseup";
    DOM_EVENT["MOUSE_MOVE"] = "mousemove";
    DOM_EVENT["FOCUS"] = "focus";
    DOM_EVENT["BLUR"] = "blur";
    DOM_EVENT["CONTEXT_MENU"] = "contextmenu";
    DOM_EVENT["RESIZE"] = "resize";
    DOM_EVENT["CHANGE"] = "change";
    DOM_EVENT["INPUT"] = "input";
    DOM_EVENT["PLAY"] = "play";
    DOM_EVENT["PAUSE"] = "pause";
    DOM_EVENT["SECURITY_POLICY_VIOLATION"] = "securitypolicyviolation";
    DOM_EVENT["SELECTION_CHANGE"] = "selectionchange";
    DOM_EVENT["STORAGE"] = "storage";
})($d12554daef4f5e60$export$54664c6599f7afe2 || ($d12554daef4f5e60$export$54664c6599f7afe2 = {}));
function $d12554daef4f5e60$export$3f65cefe8380dbea(configuration, eventTarget, eventName, listener, options) {
    return $d12554daef4f5e60$export$40a4ed63e5cb7043(configuration, eventTarget, [
        eventName
    ], listener, options);
}
function $d12554daef4f5e60$export$40a4ed63e5cb7043(configuration, eventTarget, eventNames, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var listenerWithMonitor = (0, $2wH3Z.monitor)(function(event) {
        if (!event.isTrusted && !event.__ddIsTrusted && !configuration.allowUntrustedEvents) return;
        if (once) stop();
        listener(event);
    });
    var options = passive ? {
        capture: capture,
        passive: passive
    } : capture;
    var add = (0, $5sf7S.getZoneJsOriginalValue)(eventTarget, "addEventListener");
    eventNames.forEach(function(eventName) {
        return add.call(eventTarget, eventName, listenerWithMonitor, options);
    });
    function stop() {
        var remove = (0, $5sf7S.getZoneJsOriginalValue)(eventTarget, "removeEventListener");
        eventNames.forEach(function(eventName) {
            return remove.call(eventTarget, eventName, listenerWithMonitor, options);
        });
    }
    return {
        stop: stop
    };
}

});


parcelRegister("f1XAR", function(module, exports) {

$parcel$export(module.exports, "buildCommonContext", () => $af152d066fd4f661$export$ef57df7b19d2c9ab);
function $af152d066fd4f661$export$ef57df7b19d2c9ab(globalContextManager, userContextManager, recorderApi) {
    return {
        context: globalContextManager.getContext(),
        user: userContextManager.getContext(),
        hasReplay: recorderApi.isRecording() ? true : undefined
    };
}

});

parcelRegister("e8LWu", function(module, exports) {

$parcel$export(module.exports, "createPreStartStrategy", () => $a4b70066dfc326ec$export$8f7002373dcc6602);

var $fkj4Q = parcelRequire("fkj4Q");
var $kSv4n = parcelRequire("kSv4n");
var $kFaIT = parcelRequire("kFaIT");
var $ly0px = parcelRequire("ly0px");
var $5IDGB = parcelRequire("5IDGB");
var $gurxr = parcelRequire("gurxr");
var $aed8w = parcelRequire("aed8w");
var $eA1KP = parcelRequire("eA1KP");

var $2cNNj = parcelRequire("2cNNj");
function $a4b70066dfc326ec$export$8f7002373dcc6602(_a, getCommonContext, trackingConsentState, doStartRum) {
    var ignoreInitIfSyntheticsWillInjectRum = _a.ignoreInitIfSyntheticsWillInjectRum, startDeflateWorker = _a.startDeflateWorker;
    var bufferApiCalls = new (0, $kSv4n.BoundedBuffer)();
    var firstStartViewCall;
    var deflateWorker;
    var cachedInitConfiguration;
    var cachedConfiguration;
    var trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartRum);
    function tryStartRum() {
        if (!cachedInitConfiguration || !cachedConfiguration || !trackingConsentState.isGranted()) return;
        trackingConsentStateSubscription.unsubscribe();
        var initialViewOptions;
        if (cachedConfiguration.trackViewsManually) {
            if (!firstStartViewCall) return;
            // An initial view is always created when starting RUM.
            // When tracking views automatically, any startView call before RUM start creates an extra
            // view.
            // When tracking views manually, we use the ViewOptions from the first startView call as the
            // initial view options, and we remove the actual startView call so we don't create an extra
            // view.
            bufferApiCalls.remove(firstStartViewCall.callback);
            initialViewOptions = firstStartViewCall.options;
        }
        var startRumResult = doStartRum(cachedInitConfiguration, cachedConfiguration, deflateWorker, initialViewOptions);
        bufferApiCalls.drain(startRumResult);
    }
    return {
        init: function(initConfiguration) {
            if (!initConfiguration) {
                (0, $5IDGB.display).error("Missing configuration");
                return;
            }
            var eventBridgeAvailable = (0, $kFaIT.canUseEventBridge)();
            if (eventBridgeAvailable) initConfiguration = $a4b70066dfc326ec$var$overrideInitConfigurationForBridge(initConfiguration);
            // Expose the initial configuration regardless of initialization success.
            cachedInitConfiguration = initConfiguration;
            if (cachedConfiguration) {
                (0, $gurxr.displayAlreadyInitializedError)("DD_RUM", initConfiguration);
                return;
            }
            // If we are in a Synthetics test configured to automatically inject a RUM instance, we want
            // to completely discard the customer application RUM instance by ignoring their init() call.
            // But, we should not ignore the init() call from the Synthetics-injected RUM instance, so the
            // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
            if (ignoreInitIfSyntheticsWillInjectRum && (0, $eA1KP.willSyntheticsInjectRum)()) return;
            var configuration = (0, $2cNNj.validateAndBuildRumConfiguration)(initConfiguration);
            if (!configuration) return;
            if (!eventBridgeAvailable && !configuration.sessionStoreStrategyType) {
                (0, $5IDGB.display).warn("No storage available for session. We will not send any data.");
                return;
            }
            if (configuration.compressIntakeRequests && !eventBridgeAvailable && startDeflateWorker) {
                deflateWorker = startDeflateWorker(configuration, "Datadog RUM", // Worker initialization can fail asynchronously, especially in Firefox where even CSP
                // issues are reported asynchronously. For now, the SDK will continue its execution even if
                // data won't be sent to Datadog. We could improve this behavior in the future.
                (0, $aed8w.noop));
                if (!deflateWorker) // `startDeflateWorker` should have logged an error message explaining the issue
                return;
            }
            cachedConfiguration = configuration;
            trackingConsentState.tryToInit(configuration.trackingConsent);
            tryStartRum();
        },
        get initConfiguration () {
            return cachedInitConfiguration;
        },
        getInternalContext: (0, $aed8w.noop),
        stopSession: (0, $aed8w.noop),
        addTiming: function(name, time) {
            if (time === void 0) time = (0, $ly0px.timeStampNow)();
            bufferApiCalls.add(function(startRumResult) {
                return startRumResult.addTiming(name, time);
            });
        },
        startView: function(options, startClocks) {
            if (startClocks === void 0) startClocks = (0, $ly0px.clocksNow)();
            var callback = function(startRumResult) {
                startRumResult.startView(options, startClocks);
            };
            bufferApiCalls.add(callback);
            if (!firstStartViewCall) {
                firstStartViewCall = {
                    options: options,
                    callback: callback
                };
                tryStartRum();
            }
        },
        addAction: function(action, commonContext) {
            if (commonContext === void 0) commonContext = getCommonContext();
            bufferApiCalls.add(function(startRumResult) {
                return startRumResult.addAction(action, commonContext);
            });
        },
        addError: function(providedError, commonContext) {
            if (commonContext === void 0) commonContext = getCommonContext();
            bufferApiCalls.add(function(startRumResult) {
                return startRumResult.addError(providedError, commonContext);
            });
        },
        addFeatureFlagEvaluation: function(key, value) {
            bufferApiCalls.add(function(startRumResult) {
                return startRumResult.addFeatureFlagEvaluation(key, value);
            });
        },
        startDurationVital: function(vitalStart) {
            bufferApiCalls.add(function(startRumResult) {
                return startRumResult.startDurationVital(vitalStart);
            });
        },
        stopDurationVital: function(vitalStart) {
            bufferApiCalls.add(function(startRumResult) {
                return startRumResult.stopDurationVital(vitalStart);
            });
        }
    };
}
function $a4b70066dfc326ec$var$overrideInitConfigurationForBridge(initConfiguration) {
    var _a, _b;
    return (0, $fkj4Q.assign)({}, initConfiguration, {
        applicationId: "00000000-aaaa-0000-aaaa-000000000000",
        clientToken: "empty",
        sessionSampleRate: 100,
        defaultPrivacyLevel: (_a = initConfiguration.defaultPrivacyLevel) !== null && _a !== void 0 ? _a : (_b = (0, $kFaIT.getEventBridge)()) === null || _b === void 0 ? void 0 : _b.getPrivacyLevel()
    });
}

});
parcelRegister("kSv4n", function(module, exports) {

$parcel$export(module.exports, "BoundedBuffer", () => $f330f38d49d59161$export$6f427737fb8ce4c5);

var $lHOXU = parcelRequire("lHOXU");
var $f330f38d49d59161$var$BUFFER_LIMIT = 500;
var $f330f38d49d59161$export$6f427737fb8ce4c5 = /** @class */ function() {
    function BoundedBuffer() {
        this.buffer = [];
    }
    BoundedBuffer.prototype.add = function(callback) {
        var length = this.buffer.push(callback);
        if (length > $f330f38d49d59161$var$BUFFER_LIMIT) this.buffer.splice(0, 1);
    };
    BoundedBuffer.prototype.remove = function(callback) {
        (0, $lHOXU.removeItem)(this.buffer, callback);
    };
    BoundedBuffer.prototype.drain = function(arg) {
        this.buffer.forEach(function(callback) {
            return callback(arg);
        });
        this.buffer.length = 0;
    };
    return BoundedBuffer;
}();

});
parcelRegister("lHOXU", function(module, exports) {

$parcel$export(module.exports, "removeDuplicates", () => $fcd525cace9de4ff$export$2e2262a44ac61957);
$parcel$export(module.exports, "removeItem", () => $fcd525cace9de4ff$export$fe2d9b4e03920b4c);

var $fkj4Q = parcelRequire("fkj4Q");
function $fcd525cace9de4ff$export$2e2262a44ac61957(array) {
    var set = new Set();
    array.forEach(function(item) {
        return set.add(item);
    });
    return (0, $fkj4Q.arrayFrom)(set);
}
function $fcd525cace9de4ff$export$fe2d9b4e03920b4c(array, item) {
    var index = array.indexOf(item);
    if (index >= 0) array.splice(index, 1);
}

});


parcelRegister("kFaIT", function(module, exports) {

$parcel$export(module.exports, "getEventBridge", () => $f0aff45a57046ce0$export$86c8e1e7efd0dfc1);
$parcel$export(module.exports, "bridgeSupports", () => $f0aff45a57046ce0$export$c3d8d1f8445a3630);
$parcel$export(module.exports, "canUseEventBridge", () => $f0aff45a57046ce0$export$a8ab916fee43a31b);

var $fkj4Q = parcelRequire("fkj4Q");

var $7ZD4v = parcelRequire("7ZD4v");
function $f0aff45a57046ce0$export$86c8e1e7efd0dfc1() {
    var eventBridgeGlobal = $f0aff45a57046ce0$var$getEventBridgeGlobal();
    if (!eventBridgeGlobal) return;
    return {
        getCapabilities: function() {
            var _a;
            return JSON.parse(((_a = eventBridgeGlobal.getCapabilities) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal)) || "[]");
        },
        getPrivacyLevel: function() {
            var _a;
            return (_a = eventBridgeGlobal.getPrivacyLevel) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal);
        },
        getAllowedWebViewHosts: function() {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function(eventType, event, viewId) {
            var view = viewId ? {
                id: viewId
            } : undefined;
            eventBridgeGlobal.send(JSON.stringify({
                eventType: eventType,
                event: event,
                view: view
            }));
        }
    };
}
function $f0aff45a57046ce0$export$c3d8d1f8445a3630(capability) {
    var bridge = $f0aff45a57046ce0$export$86c8e1e7efd0dfc1();
    return !!bridge && (0, $fkj4Q.includes)(bridge.getCapabilities(), capability);
}
function $f0aff45a57046ce0$export$a8ab916fee43a31b(currentHost) {
    var _a;
    if (currentHost === void 0) currentHost = (_a = (0, $7ZD4v.getGlobalObject)().location) === null || _a === void 0 ? void 0 : _a.hostname;
    var bridge = $f0aff45a57046ce0$export$86c8e1e7efd0dfc1();
    return !!bridge && bridge.getAllowedWebViewHosts().some(function(allowedHost) {
        return currentHost === allowedHost || (0, $fkj4Q.endsWith)(currentHost, ".".concat(allowedHost));
    });
}
function $f0aff45a57046ce0$var$getEventBridgeGlobal() {
    return (0, $7ZD4v.getGlobalObject)().DatadogEventBridge;
}

});

parcelRegister("eA1KP", function(module, exports) {

$parcel$export(module.exports, "willSyntheticsInjectRum", () => $a9d5c9dbe5afd19a$export$749ed8af36cd25e0);
$parcel$export(module.exports, "getSyntheticsTestId", () => $a9d5c9dbe5afd19a$export$8ea5b4a47d6660d5);
$parcel$export(module.exports, "getSyntheticsResultId", () => $a9d5c9dbe5afd19a$export$75da4270a596d87b);

var $4i26u = parcelRequire("4i26u");
var $a9d5c9dbe5afd19a$export$ef391ea72457ea48 = "datadog-synthetics-public-id";
var $a9d5c9dbe5afd19a$export$a2c8b6e1d6d69dc9 = "datadog-synthetics-result-id";
var $a9d5c9dbe5afd19a$export$c8a0c5680e097130 = "datadog-synthetics-injects-rum";
function $a9d5c9dbe5afd19a$export$749ed8af36cd25e0() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || (0, $4i26u.getInitCookie)($a9d5c9dbe5afd19a$export$c8a0c5680e097130));
}
function $a9d5c9dbe5afd19a$export$8ea5b4a47d6660d5() {
    var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || (0, $4i26u.getInitCookie)($a9d5c9dbe5afd19a$export$ef391ea72457ea48);
    return typeof value === "string" ? value : undefined;
}
function $a9d5c9dbe5afd19a$export$75da4270a596d87b() {
    var value = window._DATADOG_SYNTHETICS_RESULT_ID || (0, $4i26u.getInitCookie)($a9d5c9dbe5afd19a$export$a2c8b6e1d6d69dc9);
    return typeof value === "string" ? value : undefined;
}

});
parcelRegister("4i26u", function(module, exports) {

$parcel$export(module.exports, "setCookie", () => $31fa799c5ed9e680$export$110700823644f4a6);
$parcel$export(module.exports, "getCookie", () => $31fa799c5ed9e680$export$4be65e66cfa2648a);
$parcel$export(module.exports, "getInitCookie", () => $31fa799c5ed9e680$export$379e6c34a14280ba);
$parcel$export(module.exports, "deleteCookie", () => $31fa799c5ed9e680$export$b43e45590305ffaa);
$parcel$export(module.exports, "areCookiesAuthorized", () => $31fa799c5ed9e680$export$29b13dee24cadcda);
$parcel$export(module.exports, "getCurrentSite", () => $31fa799c5ed9e680$export$8d7fb5ac3c42095);

var $5IDGB = parcelRequire("5IDGB");

var $ly0px = parcelRequire("ly0px");

var $99fDv = parcelRequire("99fDv");
function $31fa799c5ed9e680$export$110700823644f4a6(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? "none" : "strict";
    var domain = options && options.domain ? ";domain=".concat(options.domain) : "";
    var secure = options && options.secure ? ";secure" : "";
    var partitioned = options && options.partitioned ? ";partitioned" : "";
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure).concat(partitioned);
}
function $31fa799c5ed9e680$export$4be65e66cfa2648a(name) {
    return (0, $99fDv.findCommaSeparatedValue)(document.cookie, name);
}
var $31fa799c5ed9e680$var$initCookieParsed;
function $31fa799c5ed9e680$export$379e6c34a14280ba(name) {
    if (!$31fa799c5ed9e680$var$initCookieParsed) $31fa799c5ed9e680$var$initCookieParsed = (0, $99fDv.findCommaSeparatedValues)(document.cookie);
    return $31fa799c5ed9e680$var$initCookieParsed.get(name);
}
function $31fa799c5ed9e680$export$c97a852288b43516() {
    $31fa799c5ed9e680$var$initCookieParsed = undefined;
}
function $31fa799c5ed9e680$export$b43e45590305ffaa(name, options) {
    $31fa799c5ed9e680$export$110700823644f4a6(name, "", 0, options);
}
function $31fa799c5ed9e680$export$29b13dee24cadcda(options) {
    if (document.cookie === undefined || document.cookie === null) return false;
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat((0, $99fDv.generateUUID)());
        var testCookieValue = "test";
        $31fa799c5ed9e680$export$110700823644f4a6(testCookieName, testCookieValue, (0, $ly0px.ONE_MINUTE), options);
        var isCookieCorrectlySet = $31fa799c5ed9e680$export$4be65e66cfa2648a(testCookieName) === testCookieValue;
        $31fa799c5ed9e680$export$b43e45590305ffaa(testCookieName, options);
        return isCookieCorrectlySet;
    } catch (error) {
        (0, $5IDGB.display).error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */ var $31fa799c5ed9e680$var$getCurrentSiteCache;
function $31fa799c5ed9e680$export$8d7fb5ac3c42095() {
    if ($31fa799c5ed9e680$var$getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat((0, $99fDv.generateUUID)());
        var testCookieValue = "test";
        var domainLevels = window.location.hostname.split(".");
        var candidateDomain = domainLevels.pop();
        while(domainLevels.length && !$31fa799c5ed9e680$export$4be65e66cfa2648a(testCookieName)){
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            $31fa799c5ed9e680$export$110700823644f4a6(testCookieName, testCookieValue, (0, $ly0px.ONE_SECOND), {
                domain: candidateDomain
            });
        }
        $31fa799c5ed9e680$export$b43e45590305ffaa(testCookieName, {
            domain: candidateDomain
        });
        $31fa799c5ed9e680$var$getCurrentSiteCache = candidateDomain;
    }
    return $31fa799c5ed9e680$var$getCurrentSiteCache;
}

});
parcelRegister("99fDv", function(module, exports) {

$parcel$export(module.exports, "generateUUID", () => $01b8047924249a5c$export$e73c8bd0f20705a);
$parcel$export(module.exports, "findCommaSeparatedValue", () => $01b8047924249a5c$export$fe87bb5193f3e70);
$parcel$export(module.exports, "findCommaSeparatedValues", () => $01b8047924249a5c$export$58032b923d63748e);
$parcel$export(module.exports, "safeTruncate", () => $01b8047924249a5c$export$b26462d2f74496cd);
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */ function $01b8047924249a5c$export$e73c8bd0f20705a(placeholder) {
    return placeholder ? (parseInt(placeholder, 10) ^ Math.random() * 16 >> parseInt(placeholder, 10) / 4).toString(16) : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, $01b8047924249a5c$export$e73c8bd0f20705a);
}
var $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE = /([\w-]+)\s*=\s*([^;]+)/g;
function $01b8047924249a5c$export$fe87bb5193f3e70(rawString, name) {
    $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var match = $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            if (match[1] === name) return match[2];
        } else break;
    }
}
function $01b8047924249a5c$export$58032b923d63748e(rawString) {
    var result = new Map();
    $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var match = $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) result.set(match[1], match[2]);
        else break;
    }
    return result;
}
function $01b8047924249a5c$export$b26462d2f74496cd(candidate, length, suffix) {
    if (suffix === void 0) suffix = "";
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength) return candidate;
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}

});



parcelRegister("2cNNj", function(module, exports) {

$parcel$export(module.exports, "validateAndBuildRumConfiguration", () => $19b353e209d4b27b$export$4f016a753eca1880);
$parcel$export(module.exports, "serializeRumConfiguration", () => $19b353e209d4b27b$export$937b8b43e93f9c22);

var $fkj4Q = parcelRequire("fkj4Q");
var $7imKH = parcelRequire("7imKH");
var $5IDGB = parcelRequire("5IDGB");
var $5DEie = parcelRequire("5DEie");
var $fzLbJ = parcelRequire("fzLbJ");
var $bQmeT = parcelRequire("bQmeT");
var $8PiRA = parcelRequire("8PiRA");

var $3IcTI = parcelRequire("3IcTI");
var $19b353e209d4b27b$export$6fcd8876d4ab74f5 = [
    "tracecontext",
    "datadog"
];
function $19b353e209d4b27b$export$4f016a753eca1880(initConfiguration) {
    var _a, _b;
    if (!initConfiguration.applicationId) {
        (0, $5IDGB.display).error("Application ID is not configured, no RUM data will be collected.");
        return;
    }
    if (initConfiguration.sessionReplaySampleRate !== undefined && !(0, $bQmeT.isPercentage)(initConfiguration.sessionReplaySampleRate)) {
        (0, $5IDGB.display).error("Session Replay Sample Rate should be a number between 0 and 100");
        return;
    }
    if (initConfiguration.traceSampleRate !== undefined && !(0, $bQmeT.isPercentage)(initConfiguration.traceSampleRate)) {
        (0, $5IDGB.display).error("Trace Sample Rate should be a number between 0 and 100");
        return;
    }
    if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
        (0, $5IDGB.display).error("Excluded Activity Urls should be an array");
        return;
    }
    var allowedTracingUrls = $19b353e209d4b27b$var$validateAndBuildTracingOptions(initConfiguration);
    if (!allowedTracingUrls) return;
    var baseConfiguration = (0, $7imKH.validateAndBuildConfiguration)(initConfiguration);
    if (!baseConfiguration) return;
    return (0, $fkj4Q.assign)({
        applicationId: initConfiguration.applicationId,
        version: initConfiguration.version,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        sessionReplaySampleRate: (_a = initConfiguration.sessionReplaySampleRate) !== null && _a !== void 0 ? _a : 0,
        startSessionReplayRecordingManually: !!initConfiguration.startSessionReplayRecordingManually,
        traceSampleRate: initConfiguration.traceSampleRate,
        allowedTracingUrls: allowedTracingUrls,
        excludedActivityUrls: (_b = initConfiguration.excludedActivityUrls) !== null && _b !== void 0 ? _b : [],
        workerUrl: initConfiguration.workerUrl,
        compressIntakeRequests: !!initConfiguration.compressIntakeRequests,
        trackUserInteractions: !!initConfiguration.trackUserInteractions,
        trackViewsManually: !!initConfiguration.trackViewsManually,
        trackResources: !!initConfiguration.trackResources,
        trackLongTasks: !!initConfiguration.trackLongTasks,
        subdomain: initConfiguration.subdomain,
        defaultPrivacyLevel: (0, $8PiRA.objectHasValue)((0, $7imKH.DefaultPrivacyLevel), initConfiguration.defaultPrivacyLevel) ? initConfiguration.defaultPrivacyLevel : (0, $7imKH.DefaultPrivacyLevel).MASK,
        customerDataTelemetrySampleRate: 1,
        traceContextInjection: (0, $8PiRA.objectHasValue)((0, $7imKH.TraceContextInjection), initConfiguration.traceContextInjection) ? initConfiguration.traceContextInjection : (0, $7imKH.TraceContextInjection).ALL
    }, baseConfiguration);
}
/**
 * Validates allowedTracingUrls and converts match options to tracing options
 */ function $19b353e209d4b27b$var$validateAndBuildTracingOptions(initConfiguration) {
    if (initConfiguration.allowedTracingUrls !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
            (0, $5IDGB.display).error("Allowed Tracing URLs should be an array");
            return;
        }
        if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
            (0, $5IDGB.display).error("Service needs to be configured when tracing is enabled");
            return;
        }
        // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
        var tracingOptions_1 = [];
        initConfiguration.allowedTracingUrls.forEach(function(option) {
            if ((0, $fzLbJ.isMatchOption)(option)) tracingOptions_1.push({
                match: option,
                propagatorTypes: $19b353e209d4b27b$export$6fcd8876d4ab74f5
            });
            else if ((0, $3IcTI.isTracingOption)(option)) tracingOptions_1.push(option);
            else (0, $5IDGB.display).warn("Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter", option);
        });
        return tracingOptions_1;
    }
    return [];
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls
 */ function $19b353e209d4b27b$var$getSelectedTracingPropagators(configuration) {
    var usedTracingPropagators = new Set();
    if (Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0) configuration.allowedTracingUrls.forEach(function(option) {
        if ((0, $fzLbJ.isMatchOption)(option)) $19b353e209d4b27b$export$6fcd8876d4ab74f5.forEach(function(propagatorType) {
            return usedTracingPropagators.add(propagatorType);
        });
        else if ((0, $5DEie.getType)(option) === "object" && Array.isArray(option.propagatorTypes)) // Ensure we have an array, as we cannot rely on types yet (configuration is provided by users)
        option.propagatorTypes.forEach(function(propagatorType) {
            return usedTracingPropagators.add(propagatorType);
        });
    });
    return (0, $fkj4Q.arrayFrom)(usedTracingPropagators);
}
function $19b353e209d4b27b$export$937b8b43e93f9c22(configuration) {
    var baseSerializedConfiguration = (0, $7imKH.serializeConfiguration)(configuration);
    return (0, $fkj4Q.assign)({
        session_replay_sample_rate: configuration.sessionReplaySampleRate,
        start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
        trace_sample_rate: configuration.traceSampleRate,
        trace_context_injection: configuration.traceContextInjection,
        action_name_attribute: configuration.actionNameAttribute,
        use_allowed_tracing_urls: Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0,
        selected_tracing_propagators: $19b353e209d4b27b$var$getSelectedTracingPropagators(configuration),
        default_privacy_level: configuration.defaultPrivacyLevel,
        use_excluded_activity_urls: Array.isArray(configuration.excludedActivityUrls) && configuration.excludedActivityUrls.length > 0,
        use_worker_url: !!configuration.workerUrl,
        compress_intake_requests: configuration.compressIntakeRequests,
        track_views_manually: configuration.trackViewsManually,
        track_user_interactions: configuration.trackUserInteractions,
        track_resources: configuration.trackResources,
        track_long_task: configuration.trackLongTasks
    }, baseSerializedConfiguration);
}

});
parcelRegister("7imKH", function(module, exports) {

$parcel$export(module.exports, "DefaultPrivacyLevel", () => $54fbdcf742061e48$export$e8c12a778f5ad67c);
$parcel$export(module.exports, "TraceContextInjection", () => $54fbdcf742061e48$export$d060b603b6f9a5d5);
$parcel$export(module.exports, "validateAndBuildConfiguration", () => $54fbdcf742061e48$export$bb3dd6b9741fea90);
$parcel$export(module.exports, "serializeConfiguration", () => $54fbdcf742061e48$export$948cb0730656da11);

var $1yDAt = parcelRequire("1yDAt");

var $5IDGB = parcelRequire("5IDGB");

var $k2pmh = parcelRequire("k2pmh");

var $ly0px = parcelRequire("ly0px");

var $bQmeT = parcelRequire("bQmeT");

var $7S2uk = parcelRequire("7S2uk");

var $8PiRA = parcelRequire("8PiRA");

var $fkj4Q = parcelRequire("fkj4Q");

var $9HnmS = parcelRequire("9HnmS");

var $95XVG = parcelRequire("95XVG");

var $7yltR = parcelRequire("7yltR");
var $54fbdcf742061e48$export$e8c12a778f5ad67c = {
    ALLOW: "allow",
    MASK: "mask",
    MASK_USER_INPUT: "mask-user-input"
};
var $54fbdcf742061e48$export$d060b603b6f9a5d5 = {
    ALL: "all",
    SAMPLED: "sampled"
};
function $54fbdcf742061e48$export$bb3dd6b9741fea90(initConfiguration) {
    var _a, _b, _c, _d;
    if (!initConfiguration || !initConfiguration.clientToken) {
        (0, $5IDGB.display).error("Client Token is not configured, we will not send any data.");
        return;
    }
    if (initConfiguration.sessionSampleRate !== undefined && !(0, $bQmeT.isPercentage)(initConfiguration.sessionSampleRate)) {
        (0, $5IDGB.display).error("Session Sample Rate should be a number between 0 and 100");
        return;
    }
    if (initConfiguration.telemetrySampleRate !== undefined && !(0, $bQmeT.isPercentage)(initConfiguration.telemetrySampleRate)) {
        (0, $5IDGB.display).error("Telemetry Sample Rate should be a number between 0 and 100");
        return;
    }
    if (initConfiguration.telemetryConfigurationSampleRate !== undefined && !(0, $bQmeT.isPercentage)(initConfiguration.telemetryConfigurationSampleRate)) {
        (0, $5IDGB.display).error("Telemetry Configuration Sample Rate should be a number between 0 and 100");
        return;
    }
    if (initConfiguration.trackingConsent !== undefined && !(0, $8PiRA.objectHasValue)((0, $95XVG.TrackingConsent), initConfiguration.trackingConsent)) {
        (0, $5IDGB.display).error('Tracking Consent should be either "granted" or "not-granted"');
        return;
    }
    // Set the experimental feature flags as early as possible, so we can use them in most places
    if (Array.isArray(initConfiguration.enableExperimentalFeatures)) (0, $k2pmh.addExperimentalFeatures)(initConfiguration.enableExperimentalFeatures.filter(function(flag) {
        return (0, $8PiRA.objectHasValue)((0, $k2pmh.ExperimentalFeature), flag);
    }));
    return (0, $fkj4Q.assign)({
        beforeSend: initConfiguration.beforeSend && (0, $1yDAt.catchUserErrors)(initConfiguration.beforeSend, "beforeSend threw an error:"),
        sessionStoreStrategyType: (0, $9HnmS.selectSessionStoreStrategyType)(initConfiguration),
        sessionSampleRate: (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        service: initConfiguration.service,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        allowUntrustedEvents: !!initConfiguration.allowUntrustedEvents,
        trackingConsent: (_d = initConfiguration.trackingConsent) !== null && _d !== void 0 ? _d : (0, $95XVG.TrackingConsent).GRANTED,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */ batchBytesLimit: 16 * (0, $7S2uk.ONE_KIBI_BYTE),
        eventRateLimiterThreshold: 3000,
        maxTelemetryEventsPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */ flushTimeout: 30 * (0, $ly0px.ONE_SECOND),
        /**
         * Logs intake limit
         */ batchMessagesLimit: 50,
        messageBytesLimit: 256 * (0, $7S2uk.ONE_KIBI_BYTE)
    }, (0, $7yltR.computeTransportConfiguration)(initConfiguration));
}
function $54fbdcf742061e48$export$948cb0730656da11(initConfiguration) {
    return {
        session_sample_rate: initConfiguration.sessionSampleRate,
        telemetry_sample_rate: initConfiguration.telemetrySampleRate,
        telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
        use_before_send: !!initConfiguration.beforeSend,
        use_cross_site_session_cookie: initConfiguration.useCrossSiteSessionCookie,
        use_partitioned_cross_site_session_cookie: initConfiguration.usePartitionedCrossSiteSessionCookie,
        use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
        use_proxy: !!initConfiguration.proxy,
        silent_multiple_init: initConfiguration.silentMultipleInit,
        track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
        allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
        store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
        allow_untrusted_events: !!initConfiguration.allowUntrustedEvents,
        tracking_consent: initConfiguration.trackingConsent
    };
}

});
parcelRegister("9HnmS", function(module, exports) {

$parcel$export(module.exports, "selectSessionStoreStrategyType", () => $70fa419824414645$export$2ae22598cc9269e0);
$parcel$export(module.exports, "startSessionStore", () => $70fa419824414645$export$99eabf0f32a21670);

var $d97UU = parcelRequire("d97UU");

var $4wc1a = parcelRequire("4wc1a");

var $ly0px = parcelRequire("ly0px");

var $aed8w = parcelRequire("aed8w");

var $99fDv = parcelRequire("99fDv");

var $5xfjl = parcelRequire("5xfjl");

var $iyblG = parcelRequire("iyblG");

var $24NU9 = parcelRequire("24NU9");

var $f8aZL = parcelRequire("f8aZL");
var $70fa419824414645$export$97790393ff416f6c = (0, $ly0px.ONE_SECOND);
function $70fa419824414645$export$2ae22598cc9269e0(initConfiguration) {
    var sessionStoreStrategyType = (0, $iyblG.selectCookieStrategy)(initConfiguration);
    if (!sessionStoreStrategyType && initConfiguration.allowFallbackToLocalStorage) sessionStoreStrategyType = (0, $24NU9.selectLocalStorageStrategy)();
    return sessionStoreStrategyType;
}
function $70fa419824414645$export$99eabf0f32a21670(sessionStoreStrategyType, productKey, computeSessionState) {
    var renewObservable = new (0, $4wc1a.Observable)();
    var expireObservable = new (0, $4wc1a.Observable)();
    var sessionStoreStrategy = sessionStoreStrategyType.type === "Cookie" ? (0, $iyblG.initCookieStrategy)(sessionStoreStrategyType.cookieOptions) : (0, $24NU9.initLocalStorageStrategy)();
    var clearSession = sessionStoreStrategy.clearSession, retrieveSession = sessionStoreStrategy.retrieveSession;
    var watchSessionTimeoutId = (0, $d97UU.setInterval)(watchSession, $70fa419824414645$export$97790393ff416f6c);
    var sessionCache = retrieveActiveSession();
    var _a = (0, $aed8w.throttle)(function() {
        var isTracked;
        (0, $f8aZL.processSessionStoreOperations)({
            process: function(sessionState) {
                var synchronizedSession = synchronizeSession(sessionState);
                isTracked = expandOrRenewSessionState(synchronizedSession);
                return synchronizedSession;
            },
            after: function(sessionState) {
                if (isTracked && !hasSessionInCache()) renewSessionInCache(sessionState);
                sessionCache = sessionState;
            }
        }, sessionStoreStrategy);
    }, $70fa419824414645$export$97790393ff416f6c), throttledExpandOrRenewSession = _a.throttled, cancelExpandOrRenewSession = _a.cancel;
    function expandSession() {
        (0, $f8aZL.processSessionStoreOperations)({
            process: function(sessionState) {
                return hasSessionInCache() ? synchronizeSession(sessionState) : undefined;
            }
        }, sessionStoreStrategy);
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session store
     * - if the session is not active, clear the session store and expire the session cache
     */ function watchSession() {
        (0, $f8aZL.processSessionStoreOperations)({
            process: function(sessionState) {
                return !isActiveSession(sessionState) ? {} : undefined;
            },
            after: synchronizeSession
        }, sessionStoreStrategy);
    }
    function synchronizeSession(sessionState) {
        if (!isActiveSession(sessionState)) sessionState = {};
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(sessionState)) expireSessionInCache();
            else sessionCache = sessionState;
        }
        return sessionState;
    }
    function expandOrRenewSessionState(sessionState) {
        var _a = computeSessionState(sessionState[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        sessionState[productKey] = trackingType;
        if (isTracked && !sessionState.id) {
            sessionState.id = (0, $99fDv.generateUUID)();
            sessionState.created = String((0, $ly0px.dateNow)());
        }
        return isTracked;
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(sessionState) {
        return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
    }
    function expireSessionInCache() {
        sessionCache = {};
        expireObservable.notify();
    }
    function renewSessionInCache(sessionState) {
        sessionCache = sessionState;
        renewObservable.notify();
    }
    function retrieveActiveSession() {
        var session = retrieveSession();
        if (isActiveSession(session)) return session;
        return {};
    }
    function isActiveSession(sessionState) {
        // created and expire can be undefined for versions which was not storing them
        // these checks could be removed when older versions will not be available/live anymore
        return (sessionState.created === undefined || (0, $ly0px.dateNow)() - Number(sessionState.created) < (0, $5xfjl.SESSION_TIME_OUT_DELAY)) && (sessionState.expire === undefined || (0, $ly0px.dateNow)() < Number(sessionState.expire));
    }
    return {
        expandOrRenewSession: throttledExpandOrRenewSession,
        expandSession: expandSession,
        getSession: function() {
            return sessionCache;
        },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        expire: function() {
            cancelExpandOrRenewSession();
            clearSession();
            synchronizeSession({});
        },
        stop: function() {
            (0, $d97UU.clearInterval)(watchSessionTimeoutId);
        }
    };
}

});
parcelRegister("5xfjl", function(module, exports) {

$parcel$export(module.exports, "SESSION_TIME_OUT_DELAY", () => $407be9496e601c3b$export$324def7afe89d7e8);
$parcel$export(module.exports, "SESSION_EXPIRATION_DELAY", () => $407be9496e601c3b$export$481fdd126dba0912);

var $ly0px = parcelRequire("ly0px");
var $407be9496e601c3b$export$324def7afe89d7e8 = 4 * (0, $ly0px.ONE_HOUR);
var $407be9496e601c3b$export$481fdd126dba0912 = 15 * (0, $ly0px.ONE_MINUTE);

});

parcelRegister("iyblG", function(module, exports) {

$parcel$export(module.exports, "selectCookieStrategy", () => $d814349331ade12d$export$88fc2ec23ae4ccfd);
$parcel$export(module.exports, "initCookieStrategy", () => $d814349331ade12d$export$96a0082cb9ded337);

var $5h91O = parcelRequire("5h91O");

var $4i26u = parcelRequire("4i26u");

var $4DnNL = parcelRequire("4DnNL");

var $5xfjl = parcelRequire("5xfjl");

var $5iH1t = parcelRequire("5iH1t");

var $fQ9VW = parcelRequire("fQ9VW");
function $d814349331ade12d$export$88fc2ec23ae4ccfd(initConfiguration) {
    var cookieOptions = $d814349331ade12d$export$d037e740f60b1dc5(initConfiguration);
    return (0, $4i26u.areCookiesAuthorized)(cookieOptions) ? {
        type: "Cookie",
        cookieOptions: cookieOptions
    } : undefined;
}
function $d814349331ade12d$export$96a0082cb9ded337(cookieOptions) {
    var cookieStore = {
        /**
         * Lock strategy allows mitigating issues due to concurrent access to cookie.
         * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
         */ isLockEnabled: (0, $5h91O.isChromium)(),
        persistSession: $d814349331ade12d$var$persistSessionCookie(cookieOptions),
        retrieveSession: $d814349331ade12d$var$retrieveSessionCookie,
        clearSession: $d814349331ade12d$var$deleteSessionCookie(cookieOptions)
    };
    (0, $4DnNL.tryOldCookiesMigration)(cookieStore);
    return cookieStore;
}
function $d814349331ade12d$var$persistSessionCookie(options) {
    return function(session) {
        (0, $4i26u.setCookie)((0, $fQ9VW.SESSION_STORE_KEY), (0, $5iH1t.toSessionString)(session), (0, $5xfjl.SESSION_EXPIRATION_DELAY), options);
    };
}
function $d814349331ade12d$var$retrieveSessionCookie() {
    var sessionString = (0, $4i26u.getCookie)((0, $fQ9VW.SESSION_STORE_KEY));
    return (0, $5iH1t.toSessionState)(sessionString);
}
function $d814349331ade12d$var$deleteSessionCookie(options) {
    return function() {
        (0, $4i26u.deleteCookie)((0, $fQ9VW.SESSION_STORE_KEY), options);
    };
}
function $d814349331ade12d$export$d037e740f60b1dc5(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure = !!initConfiguration.useSecureSessionCookie || !!initConfiguration.usePartitionedCrossSiteSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.crossSite = !!initConfiguration.usePartitionedCrossSiteSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.partitioned = !!initConfiguration.usePartitionedCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) cookieOptions.domain = (0, $4i26u.getCurrentSite)();
    return cookieOptions;
}

});
parcelRegister("5h91O", function(module, exports) {

$parcel$export(module.exports, "isIE", () => $3d758b2023765aca$export$7e7b1a9668aaed8);
$parcel$export(module.exports, "isChromium", () => $3d758b2023765aca$export$dd401a4677e99039);
$parcel$export(module.exports, "isSafari", () => $3d758b2023765aca$export$95df08bae54cb4df);
function $3d758b2023765aca$export$7e7b1a9668aaed8() {
    return $3d758b2023765aca$var$detectBrowserCached() === 0 /* Browser.IE */ ;
}
function $3d758b2023765aca$export$dd401a4677e99039() {
    return $3d758b2023765aca$var$detectBrowserCached() === 1 /* Browser.CHROMIUM */ ;
}
function $3d758b2023765aca$export$95df08bae54cb4df() {
    return $3d758b2023765aca$var$detectBrowserCached() === 2 /* Browser.SAFARI */ ;
}
var $3d758b2023765aca$var$browserCache;
function $3d758b2023765aca$var$detectBrowserCached() {
    return $3d758b2023765aca$var$browserCache !== null && $3d758b2023765aca$var$browserCache !== void 0 ? $3d758b2023765aca$var$browserCache : $3d758b2023765aca$var$browserCache = $3d758b2023765aca$export$2d31490a0c05f094();
}
function $3d758b2023765aca$export$2d31490a0c05f094(browserWindow) {
    var _a;
    if (browserWindow === void 0) browserWindow = window;
    var userAgent = browserWindow.navigator.userAgent;
    if (browserWindow.chrome || /HeadlessChrome/.test(userAgent)) return 1 /* Browser.CHROMIUM */ ;
    if (// navigator.vendor is deprecated, but it is the most resilient way we found to detect
    // "Apple maintained browsers" (AKA Safari). If one day it gets removed, we still have the
    // useragent test as a semi-working fallback.
    ((_a = browserWindow.navigator.vendor) === null || _a === void 0 ? void 0 : _a.indexOf("Apple")) === 0 || /safari/i.test(userAgent) && !/chrome|android/i.test(userAgent)) return 2 /* Browser.SAFARI */ ;
    if (browserWindow.document.documentMode) return 0 /* Browser.IE */ ;
    return 3 /* Browser.OTHER */ ;
}

});

parcelRegister("4DnNL", function(module, exports) {

$parcel$export(module.exports, "tryOldCookiesMigration", () => $35fd447a749f50ce$export$308239c26bbf40d4);

var $4i26u = parcelRequire("4i26u");

var $fQ9VW = parcelRequire("fQ9VW");

var $5iH1t = parcelRequire("5iH1t");
var $35fd447a749f50ce$export$9b0bbb4e1ef88c6d = "_dd";
var $35fd447a749f50ce$export$4231281e64250ad5 = "_dd_r";
var $35fd447a749f50ce$export$381d62e3ee200c01 = "_dd_l";
var $35fd447a749f50ce$export$50ae25e0cd1ada34 = "rum";
var $35fd447a749f50ce$export$c47fdbea9837fd34 = "logs";
function $35fd447a749f50ce$export$308239c26bbf40d4(cookieStoreStrategy) {
    var sessionString = (0, $4i26u.getInitCookie)((0, $fQ9VW.SESSION_STORE_KEY));
    if (!sessionString) {
        var oldSessionId = (0, $4i26u.getInitCookie)($35fd447a749f50ce$export$9b0bbb4e1ef88c6d);
        var oldRumType = (0, $4i26u.getInitCookie)($35fd447a749f50ce$export$4231281e64250ad5);
        var oldLogsType = (0, $4i26u.getInitCookie)($35fd447a749f50ce$export$381d62e3ee200c01);
        var session = {};
        if (oldSessionId) session.id = oldSessionId;
        if (oldLogsType && /^[01]$/.test(oldLogsType)) session[$35fd447a749f50ce$export$c47fdbea9837fd34] = oldLogsType;
        if (oldRumType && /^[012]$/.test(oldRumType)) session[$35fd447a749f50ce$export$50ae25e0cd1ada34] = oldRumType;
        if (!(0, $5iH1t.isSessionInExpiredState)(session)) {
            (0, $5iH1t.expandSessionState)(session);
            cookieStoreStrategy.persistSession(session);
        }
    }
}

});
parcelRegister("fQ9VW", function(module, exports) {

$parcel$export(module.exports, "SESSION_STORE_KEY", () => $b8836af4b2ff7971$export$dce9f2ddeb0efe71);
var $b8836af4b2ff7971$export$dce9f2ddeb0efe71 = "_dd_s";

});

parcelRegister("5iH1t", function(module, exports) {

$parcel$export(module.exports, "isSessionInExpiredState", () => $3dc0019fbfe25134$export$7b5aaa833707368f);
$parcel$export(module.exports, "expandSessionState", () => $3dc0019fbfe25134$export$112e1a1467f7ca28);
$parcel$export(module.exports, "toSessionString", () => $3dc0019fbfe25134$export$df489f56daf61eef);
$parcel$export(module.exports, "toSessionState", () => $3dc0019fbfe25134$export$fa3c08092be8a0e4);

var $8PiRA = parcelRequire("8PiRA");

var $fkj4Q = parcelRequire("fkj4Q");

var $ly0px = parcelRequire("ly0px");

var $5xfjl = parcelRequire("5xfjl");
var $3dc0019fbfe25134$var$SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var $3dc0019fbfe25134$var$SESSION_ENTRY_SEPARATOR = "&";
function $3dc0019fbfe25134$export$7b5aaa833707368f(session) {
    return (0, $8PiRA.isEmptyObject)(session);
}
function $3dc0019fbfe25134$export$112e1a1467f7ca28(session) {
    session.expire = String((0, $ly0px.dateNow)() + (0, $5xfjl.SESSION_EXPIRATION_DELAY));
}
function $3dc0019fbfe25134$export$df489f56daf61eef(session) {
    return (0, $fkj4Q.objectEntries)(session).map(function(_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    }).join($3dc0019fbfe25134$var$SESSION_ENTRY_SEPARATOR);
}
function $3dc0019fbfe25134$export$fa3c08092be8a0e4(sessionString) {
    var session = {};
    if ($3dc0019fbfe25134$var$isValidSessionString(sessionString)) sessionString.split($3dc0019fbfe25134$var$SESSION_ENTRY_SEPARATOR).forEach(function(entry) {
        var matches = $3dc0019fbfe25134$var$SESSION_ENTRY_REGEXP.exec(entry);
        if (matches !== null) {
            var key = matches[1], value = matches[2];
            session[key] = value;
        }
    });
    return session;
}
function $3dc0019fbfe25134$var$isValidSessionString(sessionString) {
    return !!sessionString && (sessionString.indexOf($3dc0019fbfe25134$var$SESSION_ENTRY_SEPARATOR) !== -1 || $3dc0019fbfe25134$var$SESSION_ENTRY_REGEXP.test(sessionString));
}

});



parcelRegister("24NU9", function(module, exports) {

$parcel$export(module.exports, "selectLocalStorageStrategy", () => $1832aa7f8f61a7ea$export$4d20c6f83e85c567);
$parcel$export(module.exports, "initLocalStorageStrategy", () => $1832aa7f8f61a7ea$export$f96a432ca80663c2);

var $99fDv = parcelRequire("99fDv");

var $5iH1t = parcelRequire("5iH1t");

var $fQ9VW = parcelRequire("fQ9VW");
var $1832aa7f8f61a7ea$var$LOCAL_STORAGE_TEST_KEY = "_dd_test_";
function $1832aa7f8f61a7ea$export$4d20c6f83e85c567() {
    try {
        var id = (0, $99fDv.generateUUID)();
        var testKey = "".concat($1832aa7f8f61a7ea$var$LOCAL_STORAGE_TEST_KEY).concat(id);
        localStorage.setItem(testKey, id);
        var retrievedId = localStorage.getItem(testKey);
        localStorage.removeItem(testKey);
        return id === retrievedId ? {
            type: "LocalStorage"
        } : undefined;
    } catch (e) {
        return undefined;
    }
}
function $1832aa7f8f61a7ea$export$f96a432ca80663c2() {
    return {
        isLockEnabled: false,
        persistSession: $1832aa7f8f61a7ea$var$persistInLocalStorage,
        retrieveSession: $1832aa7f8f61a7ea$var$retrieveSessionFromLocalStorage,
        clearSession: $1832aa7f8f61a7ea$var$clearSessionFromLocalStorage
    };
}
function $1832aa7f8f61a7ea$var$persistInLocalStorage(sessionState) {
    localStorage.setItem((0, $fQ9VW.SESSION_STORE_KEY), (0, $5iH1t.toSessionString)(sessionState));
}
function $1832aa7f8f61a7ea$var$retrieveSessionFromLocalStorage() {
    var sessionString = localStorage.getItem((0, $fQ9VW.SESSION_STORE_KEY));
    return (0, $5iH1t.toSessionState)(sessionString);
}
function $1832aa7f8f61a7ea$var$clearSessionFromLocalStorage() {
    localStorage.removeItem((0, $fQ9VW.SESSION_STORE_KEY));
}

});

parcelRegister("f8aZL", function(module, exports) {

$parcel$export(module.exports, "processSessionStoreOperations", () => $02d7be7ae3d08a12$export$5efeffeb1c7b84cb);

var $d97UU = parcelRequire("d97UU");

var $99fDv = parcelRequire("99fDv");

var $5iH1t = parcelRequire("5iH1t");
var $02d7be7ae3d08a12$export$af5f677cffbf8829 = 10;
var $02d7be7ae3d08a12$export$63e0e5fbdb17b26 = 100;
var $02d7be7ae3d08a12$var$bufferedOperations = [];
var $02d7be7ae3d08a12$var$ongoingOperations;
function $02d7be7ae3d08a12$export$5efeffeb1c7b84cb(operations, sessionStoreStrategy, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) numberOfRetries = 0;
    var isLockEnabled = sessionStoreStrategy.isLockEnabled, retrieveSession = sessionStoreStrategy.retrieveSession, persistSession = sessionStoreStrategy.persistSession, clearSession = sessionStoreStrategy.clearSession;
    if (!$02d7be7ae3d08a12$var$ongoingOperations) $02d7be7ae3d08a12$var$ongoingOperations = operations;
    if (operations !== $02d7be7ae3d08a12$var$ongoingOperations) {
        $02d7be7ae3d08a12$var$bufferedOperations.push(operations);
        return;
    }
    if (isLockEnabled && numberOfRetries >= $02d7be7ae3d08a12$export$63e0e5fbdb17b26) {
        $02d7be7ae3d08a12$var$next(sessionStoreStrategy);
        return;
    }
    var currentLock;
    var currentSession = retrieveSession();
    if (isLockEnabled) {
        // if someone has lock, retry later
        if (currentSession.lock) {
            $02d7be7ae3d08a12$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = (0, $99fDv.generateUUID)();
        currentSession.lock = currentLock;
        persistSession(currentSession);
        // if lock is not acquired, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            $02d7be7ae3d08a12$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentSession);
    if (isLockEnabled) {
        // if lock corrupted after process, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            $02d7be7ae3d08a12$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        if ((0, $5iH1t.isSessionInExpiredState)(processedSession)) clearSession();
        else {
            (0, $5iH1t.expandSessionState)(processedSession);
            persistSession(processedSession);
        }
    }
    if (isLockEnabled) // correctly handle lock around expiration would require to handle this case properly at several levels
    // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
    {
        if (!(processedSession && (0, $5iH1t.isSessionInExpiredState)(processedSession))) {
            // if lock corrupted after persist, retry later
            currentSession = retrieveSession();
            if (currentSession.lock !== currentLock) {
                $02d7be7ae3d08a12$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
                return;
            }
            delete currentSession.lock;
            persistSession(currentSession);
            processedSession = currentSession;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date session state value => the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 || _a.call(operations, processedSession || currentSession);
    $02d7be7ae3d08a12$var$next(sessionStoreStrategy);
}
function $02d7be7ae3d08a12$var$retryLater(operations, sessionStore, currentNumberOfRetries) {
    (0, $d97UU.setTimeout)(function() {
        $02d7be7ae3d08a12$export$5efeffeb1c7b84cb(operations, sessionStore, currentNumberOfRetries + 1);
    }, $02d7be7ae3d08a12$export$af5f677cffbf8829);
}
function $02d7be7ae3d08a12$var$next(sessionStore) {
    $02d7be7ae3d08a12$var$ongoingOperations = undefined;
    var nextOperations = $02d7be7ae3d08a12$var$bufferedOperations.shift();
    if (nextOperations) $02d7be7ae3d08a12$export$5efeffeb1c7b84cb(nextOperations, sessionStore);
}

});


parcelRegister("7yltR", function(module, exports) {

$parcel$export(module.exports, "computeTransportConfiguration", () => $57fc5f00ec8e4fc6$export$2cf2d9e8f31925e6);

var $fkj4Q = parcelRequire("fkj4Q");

var $lrgXo = parcelRequire("lrgXo");

var $5rWG9 = parcelRequire("5rWG9");

var $ahPEX = parcelRequire("ahPEX");
function $57fc5f00ec8e4fc6$export$2cf2d9e8f31925e6(initConfiguration) {
    var site = initConfiguration.site || (0, $ahPEX.INTAKE_SITE_US1);
    var tags = (0, $5rWG9.buildTags)(initConfiguration);
    var endpointBuilders = $57fc5f00ec8e4fc6$var$computeEndpointBuilders(initConfiguration, tags);
    var intakeUrlPrefixes = $57fc5f00ec8e4fc6$var$computeIntakeUrlPrefixes(endpointBuilders, site);
    var replicaConfiguration = $57fc5f00ec8e4fc6$var$computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags);
    return (0, $fkj4Q.assign)({
        isIntakeUrl: function(url) {
            return intakeUrlPrefixes.some(function(intakeEndpoint) {
                return url.indexOf(intakeEndpoint) === 0;
            });
        },
        replica: replicaConfiguration,
        site: site
    }, endpointBuilders);
}
function $57fc5f00ec8e4fc6$var$computeEndpointBuilders(initConfiguration, tags) {
    return {
        logsEndpointBuilder: (0, $lrgXo.createEndpointBuilder)(initConfiguration, "logs", tags),
        rumEndpointBuilder: (0, $lrgXo.createEndpointBuilder)(initConfiguration, "rum", tags),
        sessionReplayEndpointBuilder: (0, $lrgXo.createEndpointBuilder)(initConfiguration, "replay", tags)
    };
}
function $57fc5f00ec8e4fc6$var$computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags) {
    if (!initConfiguration.replica) return;
    var replicaConfiguration = (0, $fkj4Q.assign)({}, initConfiguration, {
        site: (0, $ahPEX.INTAKE_SITE_US1),
        clientToken: initConfiguration.replica.clientToken
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: (0, $lrgXo.createEndpointBuilder)(replicaConfiguration, "logs", tags),
        rumEndpointBuilder: (0, $lrgXo.createEndpointBuilder)(replicaConfiguration, "rum", tags)
    };
    intakeUrlPrefixes.push.apply(intakeUrlPrefixes, (0, $fkj4Q.objectValues)(replicaEndpointBuilders).map(function(builder) {
        return builder.urlPrefix;
    }));
    return (0, $fkj4Q.assign)({
        applicationId: initConfiguration.replica.applicationId
    }, replicaEndpointBuilders);
}
function $57fc5f00ec8e4fc6$var$computeIntakeUrlPrefixes(endpointBuilders, site) {
    var intakeUrlPrefixes = (0, $fkj4Q.objectValues)(endpointBuilders).map(function(builder) {
        return builder.urlPrefix;
    });
    if (site === (0, $ahPEX.INTAKE_SITE_US1)) intakeUrlPrefixes.push("https://".concat((0, $ahPEX.PCI_INTAKE_HOST_US1), "/"));
    return intakeUrlPrefixes;
}

});
parcelRegister("lrgXo", function(module, exports) {

$parcel$export(module.exports, "createEndpointBuilder", () => $f9b945dd035d2e49$export$b84621d9b3dd3f17);

var $ly0px = parcelRequire("ly0px");

var $bVLiF = parcelRequire("bVLiF");

var $k2pmh = parcelRequire("k2pmh");

var $99fDv = parcelRequire("99fDv");

var $ahPEX = parcelRequire("ahPEX");
function $f9b945dd035d2e49$export$b84621d9b3dd3f17(initConfiguration, trackType, configurationTags) {
    var buildUrlWithParameters = $f9b945dd035d2e49$var$createEndpointUrlWithParametersBuilder(initConfiguration, trackType);
    return {
        build: function(api, payload) {
            var parameters = $f9b945dd035d2e49$var$buildEndpointParameters(initConfiguration, trackType, configurationTags, api, payload);
            return buildUrlWithParameters(parameters);
        },
        urlPrefix: buildUrlWithParameters(""),
        trackType: trackType
    };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */ function $f9b945dd035d2e49$var$createEndpointUrlWithParametersBuilder(initConfiguration, trackType) {
    var path = "/api/v2/".concat(trackType);
    var proxy = initConfiguration.proxy;
    if (typeof proxy === "string") {
        var normalizedProxyUrl_1 = (0, $bVLiF.normalizeUrl)(proxy);
        return function(parameters) {
            return "".concat(normalizedProxyUrl_1, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters)));
        };
    }
    if (typeof proxy === "function") return function(parameters) {
        return proxy({
            path: path,
            parameters: parameters
        });
    };
    var host = $f9b945dd035d2e49$var$buildEndpointHost(trackType, initConfiguration);
    return function(parameters) {
        return "https://".concat(host).concat(path, "?").concat(parameters);
    };
}
function $f9b945dd035d2e49$var$buildEndpointHost(trackType, initConfiguration) {
    var _a = initConfiguration.site, site = _a === void 0 ? (0, $ahPEX.INTAKE_SITE_US1) : _a, internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
    if (trackType === "logs" && initConfiguration.usePciIntake && site === (0, $ahPEX.INTAKE_SITE_US1)) return 0, $ahPEX.PCI_INTAKE_HOST_US1;
    if (internalAnalyticsSubdomain && site === (0, $ahPEX.INTAKE_SITE_US1)) return "".concat(internalAnalyticsSubdomain, ".").concat((0, $ahPEX.INTAKE_SITE_US1));
    if (site === (0, $ahPEX.INTAKE_SITE_FED_STAGING)) return "http-intake.logs.".concat(site);
    var domainParts = site.split(".");
    var extension = domainParts.pop();
    return "browser-intake-".concat(domainParts.join("-"), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */ function $f9b945dd035d2e49$var$buildEndpointParameters(_a, trackType, configurationTags, api, _b) {
    var clientToken = _a.clientToken, internalAnalyticsSubdomain = _a.internalAnalyticsSubdomain;
    var retry = _b.retry, flushReason = _b.flushReason, encoding = _b.encoding;
    var tags = [
        "sdk_version:".concat("5.15.0"),
        "api:".concat(api)
    ].concat(configurationTags);
    if (flushReason && (0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).COLLECT_FLUSH_REASON)) tags.push("flush_reason:".concat(flushReason));
    if (retry) tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
    var parameters = [
        "ddsource=browser",
        "ddtags=".concat(encodeURIComponent(tags.join(","))),
        "dd-api-key=".concat(clientToken),
        "dd-evp-origin-version=".concat(encodeURIComponent("5.15.0")),
        "dd-evp-origin=browser",
        "dd-request-id=".concat((0, $99fDv.generateUUID)())
    ];
    if (encoding) parameters.push("dd-evp-encoding=".concat(encoding));
    if (trackType === "rum") parameters.push("batch_time=".concat((0, $ly0px.timeStampNow)()));
    if (internalAnalyticsSubdomain) parameters.reverse();
    return parameters.join("&");
}

});
parcelRegister("bVLiF", function(module, exports) {

$parcel$export(module.exports, "normalizeUrl", () => $8af9b5626c1bb968$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "buildUrl", () => $8af9b5626c1bb968$export$b5cd97dee32de81d);
$parcel$export(module.exports, "isValidUrl", () => $8af9b5626c1bb968$export$bef94a5618bf18bf);
$parcel$export(module.exports, "getPathName", () => $8af9b5626c1bb968$export$ba1b94ff70383687);

var $1W8NF = parcelRequire("1W8NF");
function $8af9b5626c1bb968$export$6535eb414fa2c8b6(url) {
    return $8af9b5626c1bb968$export$b5cd97dee32de81d(url, location.href).href;
}
function $8af9b5626c1bb968$export$bef94a5618bf18bf(url) {
    try {
        return !!$8af9b5626c1bb968$export$b5cd97dee32de81d(url);
    } catch (_a) {
        return false;
    }
}
function $8af9b5626c1bb968$export$ba1b94ff70383687(url) {
    var pathname = $8af9b5626c1bb968$export$b5cd97dee32de81d(url).pathname;
    return pathname[0] === "/" ? pathname : "/".concat(pathname);
}
function $8af9b5626c1bb968$export$b5cd97dee32de81d(url, base) {
    var supportedURL = $8af9b5626c1bb968$var$getSupportedUrl();
    if (supportedURL) try {
        return base !== undefined ? new supportedURL(url, base) : new supportedURL(url);
    } catch (error) {
        throw new Error("Failed to construct URL: ".concat(String(error), " ").concat((0, $1W8NF.jsonStringify)({
            url: url,
            base: base
        })));
    }
    if (base === undefined && !/:/.test(url)) throw new Error("Invalid URL: '".concat(url, "'"));
    var doc = document;
    var anchorElement = doc.createElement("a");
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument("");
        var baseElement = doc.createElement("base");
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
var $8af9b5626c1bb968$var$originalURL = URL;
var $8af9b5626c1bb968$var$isURLSupported;
function $8af9b5626c1bb968$var$getSupportedUrl() {
    if ($8af9b5626c1bb968$var$isURLSupported === undefined) try {
        var url = new $8af9b5626c1bb968$var$originalURL("http://test/path");
        $8af9b5626c1bb968$var$isURLSupported = url.href === "http://test/path";
    } catch (_a) {
        $8af9b5626c1bb968$var$isURLSupported = false;
    }
    return $8af9b5626c1bb968$var$isURLSupported ? $8af9b5626c1bb968$var$originalURL : undefined;
}

});

parcelRegister("ahPEX", function(module, exports) {

$parcel$export(module.exports, "INTAKE_SITE_STAGING", () => $77d3907623da03fc$export$a204b9d5a62f1e2c);
$parcel$export(module.exports, "INTAKE_SITE_FED_STAGING", () => $77d3907623da03fc$export$62cc10d94d5ff7fd);
$parcel$export(module.exports, "INTAKE_SITE_US1", () => $77d3907623da03fc$export$6b79fd7dd2f5fb9a);
$parcel$export(module.exports, "INTAKE_SITE_EU1", () => $77d3907623da03fc$export$7452d85ec570d2ea);
$parcel$export(module.exports, "INTAKE_SITE_US1_FED", () => $77d3907623da03fc$export$241ba7106e833c7b);
$parcel$export(module.exports, "PCI_INTAKE_HOST_US1", () => $77d3907623da03fc$export$e02f42b31d885a8c);
var $77d3907623da03fc$export$a204b9d5a62f1e2c = "datad0g.com";
var $77d3907623da03fc$export$62cc10d94d5ff7fd = "dd0g-gov.com";
var $77d3907623da03fc$export$6b79fd7dd2f5fb9a = "datadoghq.com";
var $77d3907623da03fc$export$7452d85ec570d2ea = "datadoghq.eu";
var $77d3907623da03fc$export$241ba7106e833c7b = "ddog-gov.com";
var $77d3907623da03fc$export$e02f42b31d885a8c = "pci.browser-intake-datadoghq.com";

});


parcelRegister("5rWG9", function(module, exports) {

$parcel$export(module.exports, "buildTags", () => $3f7cfdc5e4c726ca$export$ebabee42db672bb6);

var $5IDGB = parcelRequire("5IDGB");
var $3f7cfdc5e4c726ca$export$4f41fac0b8471c73 = 200;
function $3f7cfdc5e4c726ca$export$ebabee42db672bb6(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) tags.push($3f7cfdc5e4c726ca$export$4478cda40be33ba2("env", env));
    if (service) tags.push($3f7cfdc5e4c726ca$export$4478cda40be33ba2("service", service));
    if (version) tags.push($3f7cfdc5e4c726ca$export$4478cda40be33ba2("version", version));
    if (datacenter) tags.push($3f7cfdc5e4c726ca$export$4478cda40be33ba2("datacenter", datacenter));
    return tags;
}
var $3f7cfdc5e4c726ca$var$FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function $3f7cfdc5e4c726ca$export$4478cda40be33ba2(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = $3f7cfdc5e4c726ca$export$4f41fac0b8471c73 - key.length - 1;
    if (rawValue.length > valueSizeLimit || $3f7cfdc5e4c726ca$var$FORBIDDEN_CHARACTERS.test(rawValue)) (0, $5IDGB.display).warn("".concat(key, " value doesn't meet tag requirements and will be sanitized"));
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, "_");
    return "".concat(key, ":").concat(sanitizedValue);
}

});



parcelRegister("fzLbJ", function(module, exports) {

$parcel$export(module.exports, "isMatchOption", () => $b56eba7faf105c60$export$b620f5b550eaf484);
$parcel$export(module.exports, "matchList", () => $b56eba7faf105c60$export$eb5a30555469227);

var $fkj4Q = parcelRequire("fkj4Q");

var $5IDGB = parcelRequire("5IDGB");

var $5DEie = parcelRequire("5DEie");
function $b56eba7faf105c60$export$b620f5b550eaf484(item) {
    var itemType = (0, $5DEie.getType)(item);
    return itemType === "string" || itemType === "function" || item instanceof RegExp;
}
function $b56eba7faf105c60$export$eb5a30555469227(list, value, useStartsWith) {
    if (useStartsWith === void 0) useStartsWith = false;
    return list.some(function(item) {
        try {
            if (typeof item === "function") return item(value);
            else if (item instanceof RegExp) return item.test(value);
            else if (typeof item === "string") return useStartsWith ? (0, $fkj4Q.startsWith)(value, item) : item === value;
        } catch (e) {
            (0, $5IDGB.display).error(e);
        }
        return false;
    });
}

});

parcelRegister("3IcTI", function(module, exports) {

$parcel$export(module.exports, "isTracingOption", () => $2b3f7c5bb3826872$export$5980e9370742a9f1);
$parcel$export(module.exports, "startTracer", () => $2b3f7c5bb3826872$export$faa83af43a19aa4b);

var $fkj4Q = parcelRequire("fkj4Q");
var $5DEie = parcelRequire("5DEie");
var $fzLbJ = parcelRequire("fzLbJ");
var $bQmeT = parcelRequire("bQmeT");
var $8PiRA = parcelRequire("8PiRA");
var $7imKH = parcelRequire("7imKH");
function $2b3f7c5bb3826872$export$5980e9370742a9f1(item) {
    var expectedItem = item;
    return (0, $5DEie.getType)(expectedItem) === "object" && (0, $fzLbJ.isMatchOption)(expectedItem.match) && Array.isArray(expectedItem.propagatorTypes);
}
function $2b3f7c5bb3826872$export$5fcd137715d2568d(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
        context.traceSampled = undefined;
    }
}
function $2b3f7c5bb3826872$export$faa83af43a19aa4b(configuration, sessionManager) {
    return {
        clearTracingIfNeeded: $2b3f7c5bb3826872$export$5fcd137715d2568d,
        traceFetch: function(context) {
            return $2b3f7c5bb3826872$var$injectHeadersIfTracingAllowed(configuration, context, sessionManager, function(tracingHeaders) {
                var _a;
                if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach(function(key) {
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                } else {
                    context.init = (0, $8PiRA.shallowClone)(context.init);
                    var headers_1 = [];
                    if (context.init.headers instanceof Headers) context.init.headers.forEach(function(value, key) {
                        headers_1.push([
                            key,
                            value
                        ]);
                    });
                    else if (Array.isArray(context.init.headers)) context.init.headers.forEach(function(header) {
                        headers_1.push(header);
                    });
                    else if (context.init.headers) Object.keys(context.init.headers).forEach(function(key) {
                        headers_1.push([
                            key,
                            context.init.headers[key]
                        ]);
                    });
                    context.init.headers = headers_1.concat((0, $fkj4Q.objectEntries)(tracingHeaders));
                }
            });
        },
        traceXhr: function(context, xhr) {
            return $2b3f7c5bb3826872$var$injectHeadersIfTracingAllowed(configuration, context, sessionManager, function(tracingHeaders) {
                Object.keys(tracingHeaders).forEach(function(name) {
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            });
        }
    };
}
function $2b3f7c5bb3826872$var$injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
    if (!$2b3f7c5bb3826872$export$fccc3aa05073f942() || !sessionManager.findTrackedSession()) return;
    var tracingOption = (0, $fkj4Q.find)(configuration.allowedTracingUrls, function(tracingOption) {
        return (0, $fzLbJ.matchList)([
            tracingOption.match
        ], context.url, true);
    });
    if (!tracingOption) return;
    context.traceSampled = !(0, $bQmeT.isNumber)(configuration.traceSampleRate) || (0, $bQmeT.performDraw)(configuration.traceSampleRate);
    if (!context.traceSampled && configuration.traceContextInjection !== (0, $7imKH.TraceContextInjection).ALL) return;
    context.traceId = new $2b3f7c5bb3826872$export$37dfda1e537e7e28();
    context.spanId = new $2b3f7c5bb3826872$export$37dfda1e537e7e28();
    inject($2b3f7c5bb3826872$var$makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, tracingOption.propagatorTypes));
}
function $2b3f7c5bb3826872$export$fccc3aa05073f942() {
    return $2b3f7c5bb3826872$var$getCrypto() !== undefined;
}
function $2b3f7c5bb3826872$var$getCrypto() {
    return window.crypto || window.msCrypto;
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */ function $2b3f7c5bb3826872$var$makeTracingHeaders(traceId, spanId, traceSampled, propagatorTypes) {
    var tracingHeaders = {};
    propagatorTypes.forEach(function(propagatorType) {
        switch(propagatorType){
            case "datadog":
                (0, $fkj4Q.assign)(tracingHeaders, {
                    "x-datadog-origin": "rum",
                    "x-datadog-parent-id": spanId.toDecimalString(),
                    "x-datadog-sampling-priority": traceSampled ? "1" : "0",
                    "x-datadog-trace-id": traceId.toDecimalString()
                });
                break;
            // https://www.w3.org/TR/trace-context/
            case "tracecontext":
                (0, $fkj4Q.assign)(tracingHeaders, {
                    traceparent: "00-0000000000000000".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-0").concat(traceSampled ? "1" : "0")
                });
                break;
            // https://github.com/openzipkin/b3-propagation
            case "b3":
                (0, $fkj4Q.assign)(tracingHeaders, {
                    b3: "".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-").concat(traceSampled ? "1" : "0")
                });
                break;
            case "b3multi":
                (0, $fkj4Q.assign)(tracingHeaders, {
                    "X-B3-TraceId": traceId.toPaddedHexadecimalString(),
                    "X-B3-SpanId": spanId.toPaddedHexadecimalString(),
                    "X-B3-Sampled": traceSampled ? "1" : "0"
                });
                break;
        }
    });
    return tracingHeaders;
}
/* eslint-disable no-bitwise */ var $2b3f7c5bb3826872$export$37dfda1e537e7e28 = /** @class */ function() {
    function TraceIdentifier() {
        this.buffer = new Uint8Array(8);
        $2b3f7c5bb3826872$var$getCrypto().getRandomValues(this.buffer);
        this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
    }
    TraceIdentifier.prototype.toString = function(radix) {
        var high = this.readInt32(0);
        var low = this.readInt32(4);
        var str = "";
        do {
            var mod = high % radix * 4294967296 + low;
            high = Math.floor(high / radix);
            low = Math.floor(mod / radix);
            str = (mod % radix).toString(radix) + str;
        }while (high || low);
        return str;
    };
    /**
     * Format used everywhere except the trace intake
     */ TraceIdentifier.prototype.toDecimalString = function() {
        return this.toString(10);
    };
    /**
     * Format used by OTel headers
     */ TraceIdentifier.prototype.toPaddedHexadecimalString = function() {
        var traceId = this.toString(16);
        return Array(17 - traceId.length).join("0") + traceId;
    };
    TraceIdentifier.prototype.readInt32 = function(offset) {
        return this.buffer[offset] * 16777216 + (this.buffer[offset + 1] << 16) + (this.buffer[offset + 2] << 8) + this.buffer[offset + 3];
    };
    return TraceIdentifier;
}();
 /* eslint-enable no-bitwise */ 
});




parcelRegister("2q14q", function(module, exports) {

$parcel$export(module.exports, "startRum", () => $1c2ed706f8c64922$export$3215a7cbec5ac3e0);

var $fhNdh = parcelRequire("fhNdh");
var $kFaIT = parcelRequire("kFaIT");
var $1gpLX = parcelRequire("1gpLX");
var $cfGi1 = parcelRequire("cfGi1");

var $2Bt7w = parcelRequire("2Bt7w");

var $iSyQp = parcelRequire("iSyQp");

var $8NjHX = parcelRequire("8NjHX");

var $f2Ka5 = parcelRequire("f2Ka5");

var $54uGZ = parcelRequire("54uGZ");

var $4Voar = parcelRequire("4Voar");

var $gQkiu = parcelRequire("gQkiu");

var $bbPM0 = parcelRequire("bbPM0");

var $lpjMX = parcelRequire("lpjMX");

var $lWJEv = parcelRequire("lWJEv");

var $4JFG9 = parcelRequire("4JFG9");

var $3GTFW = parcelRequire("3GTFW");

var $eptxg = parcelRequire("eptxg");

var $degsG = parcelRequire("degsG");

var $axlOu = parcelRequire("axlOu");

var $kXNZh = parcelRequire("kXNZh");

var $3OSU7 = parcelRequire("3OSU7");

var $2cNNj = parcelRequire("2cNNj");

var $7hyCT = parcelRequire("7hyCT");

var $lTMQC = parcelRequire("lTMQC");

var $eZzeR = parcelRequire("eZzeR");

var $btrZp = parcelRequire("btrZp");

var $aSnVp = parcelRequire("aSnVp");

var $5FzGr = parcelRequire("5FzGr");
function $1c2ed706f8c64922$export$3215a7cbec5ac3e0(initConfiguration, configuration, recorderApi, customerDataTrackerManager, getCommonContext, initialViewOptions, createEncoder, // `startRum` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startRum` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState) {
    var cleanupTasks = [];
    var lifeCycle = new (0, $54uGZ.LifeCycle)();
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , function(event) {
        return (0, $cfGi1.sendToExtension)("rum", event);
    });
    var telemetry = $1c2ed706f8c64922$var$startRumTelemetry(configuration);
    telemetry.setContextProvider(function() {
        var _a, _b;
        return {
            application: {
                id: configuration.applicationId
            },
            session: {
                id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id
            },
            view: {
                id: (_b = viewContexts.findView()) === null || _b === void 0 ? void 0 : _b.id
            },
            action: {
                id: actionContexts.findActionId()
            }
        };
    });
    var reportError = function(error) {
        lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
            error: error
        });
        (0, $fhNdh.addTelemetryDebug)("Error reported to customer", {
            "error.message": error.message
        });
    };
    var featureFlagContexts = (0, $7hyCT.startFeatureFlagContexts)(lifeCycle, customerDataTrackerManager.getOrCreateTracker(0 /* CustomerDataType.FeatureFlag */ ));
    var pageExitObservable = (0, $1gpLX.createPageExitObservable)(configuration);
    var pageExitSubscription = pageExitObservable.subscribe(function(event) {
        lifeCycle.notify(11 /* LifeCycleEventType.PAGE_EXITED */ , event);
    });
    cleanupTasks.push(function() {
        return pageExitSubscription.unsubscribe();
    });
    var session = !(0, $kFaIT.canUseEventBridge)() ? (0, $eptxg.startRumSessionManager)(configuration, lifeCycle, trackingConsentState) : (0, $eptxg.startRumSessionManagerStub)();
    if (!(0, $kFaIT.canUseEventBridge)()) {
        var batch_1 = (0, $degsG.startRumBatch)(configuration, lifeCycle, telemetry.observable, reportError, pageExitObservable, session.expireObservable, createEncoder);
        cleanupTasks.push(function() {
            return batch_1.stop();
        });
        (0, $lTMQC.startCustomerDataTelemetry)(configuration, telemetry, lifeCycle, customerDataTrackerManager, batch_1.flushObservable);
    } else (0, $axlOu.startRumEventBridge)(lifeCycle);
    var domMutationObservable = (0, $2Bt7w.createDOMMutationObservable)();
    var locationChangeObservable = (0, $3OSU7.createLocationChangeObservable)(configuration, location);
    var _a = $1c2ed706f8c64922$export$cd2ea6643dad23e3(lifeCycle, configuration, location, session, locationChangeObservable, domMutationObservable, getCommonContext, reportError), viewContexts = _a.viewContexts, pageStateHistory = _a.pageStateHistory, urlContexts = _a.urlContexts, actionContexts = _a.actionContexts, addAction = _a.addAction, stopRumEventCollection = _a.stop;
    cleanupTasks.push(stopRumEventCollection);
    (0, $fhNdh.addTelemetryConfiguration)((0, $2cNNj.serializeRumConfiguration)(initConfiguration));
    (0, $lWJEv.startLongTaskCollection)(lifeCycle, configuration, session);
    (0, $4JFG9.startResourceCollection)(lifeCycle, configuration, session, pageStateHistory);
    var _b = (0, $3GTFW.startViewCollection)(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions), addTiming = _b.addTiming, startView = _b.startView, stopViewCollection = _b.stop;
    cleanupTasks.push(stopViewCollection);
    var addError = (0, $lpjMX.startErrorCollection)(lifeCycle, configuration, pageStateHistory, featureFlagContexts).addError;
    (0, $gQkiu.startRequestCollection)(lifeCycle, configuration, session);
    var stopPerformanceCollection = (0, $iSyQp.startPerformanceCollection)(lifeCycle, configuration).stop;
    cleanupTasks.push(stopPerformanceCollection);
    var vitalCollection = (0, $aSnVp.startVitalCollection)(lifeCycle, pageStateHistory);
    var internalContext = (0, $f2Ka5.startInternalContext)(configuration.applicationId, session, viewContexts, actionContexts, urlContexts);
    return {
        addAction: addAction,
        addError: addError,
        addTiming: addTiming,
        addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
        startView: startView,
        lifeCycle: lifeCycle,
        viewContexts: viewContexts,
        session: session,
        stopSession: function() {
            return session.expire();
        },
        getInternalContext: internalContext.get,
        startDurationVital: vitalCollection.startDurationVital,
        stopDurationVital: vitalCollection.stopDurationVital,
        stop: function() {
            cleanupTasks.forEach(function(task) {
                return task();
            });
        }
    };
}
function $1c2ed706f8c64922$var$startRumTelemetry(configuration) {
    var telemetry = (0, $fhNdh.startTelemetry)("browser-rum-sdk" /* TelemetryService.RUM */ , configuration);
    if ((0, $kFaIT.canUseEventBridge)()) {
        var bridge_1 = (0, $kFaIT.getEventBridge)();
        telemetry.observable.subscribe(function(event) {
            return bridge_1.send("internal_telemetry", event);
        });
    }
    return telemetry;
}
function $1c2ed706f8c64922$export$cd2ea6643dad23e3(lifeCycle, configuration, location1, sessionManager, locationChangeObservable, domMutationObservable, getCommonContext, reportError) {
    var viewContexts = (0, $4Voar.startViewContexts)(lifeCycle);
    var urlContexts = (0, $kXNZh.startUrlContexts)(lifeCycle, locationChangeObservable, location1);
    var pageStateHistory = (0, $eZzeR.startPageStateHistory)(configuration);
    var _a = (0, $bbPM0.startActionCollection)(lifeCycle, domMutationObservable, configuration, pageStateHistory), addAction = _a.addAction, actionContexts = _a.actionContexts;
    var displayContext = (0, $btrZp.startDisplayContext)(configuration);
    var ciVisibilityContext = (0, $5FzGr.startCiVisibilityContext)(configuration);
    (0, $8NjHX.startRumAssembly)(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, ciVisibilityContext, getCommonContext, reportError);
    return {
        viewContexts: viewContexts,
        pageStateHistory: pageStateHistory,
        urlContexts: urlContexts,
        addAction: addAction,
        actionContexts: actionContexts,
        stop: function() {
            ciVisibilityContext.stop();
            displayContext.stop();
            pageStateHistory.stop();
            urlContexts.stop();
            viewContexts.stop();
            pageStateHistory.stop();
        }
    };
}

});
parcelRegister("fhNdh", function(module, exports) {

$parcel$export(module.exports, "startTelemetry", () => $b20e9e3ee3028089$export$a1198c4bba5d5e18);
$parcel$export(module.exports, "addTelemetryError", () => $b20e9e3ee3028089$export$2e825f93958b0e6a);
$parcel$export(module.exports, "isTelemetryReplicationAllowed", () => $b20e9e3ee3028089$export$2b39c4ac778572fb);
$parcel$export(module.exports, "addTelemetryDebug", () => $b20e9e3ee3028089$export$d922954195a17683);
$parcel$export(module.exports, "addTelemetryConfiguration", () => $b20e9e3ee3028089$export$d546dcbd09bc447f);

var $5IDGB = parcelRequire("5IDGB");

var $4Be0w = parcelRequire("4Be0w");

var $k2pmh = parcelRequire("k2pmh");

var $ahPEX = parcelRequire("ahPEX");

var $4wc1a = parcelRequire("4wc1a");

var $ly0px = parcelRequire("ly0px");

var $2wH3Z = parcelRequire("2wH3Z");

var $cfGi1 = parcelRequire("cfGi1");

var $fkj4Q = parcelRequire("fkj4Q");

var $bQmeT = parcelRequire("bQmeT");

var $1W8NF = parcelRequire("1W8NF");

var $j9iCm = parcelRequire("j9iCm");

var $iJHw0 = parcelRequire("iJHw0");

var $82OHb = parcelRequire("82OHb");

var $1RGSv = parcelRequire("1RGSv");
var $b20e9e3ee3028089$var$ALLOWED_FRAME_URLS = [
    "https://www.datadoghq-browser-agent.com",
    "https://www.datad0g-browser-agent.com",
    "https://d3uc069fcn7uxw.cloudfront.net",
    "https://d20xtzwzcl0ceb.cloudfront.net",
    "http://localhost",
    "<anonymous>"
];
var $b20e9e3ee3028089$var$TELEMETRY_EXCLUDED_SITES = [
    (0, $ahPEX.INTAKE_SITE_US1_FED)
];
var $b20e9e3ee3028089$var$telemetryConfiguration = {
    maxEventsPerPage: 0,
    sentEventCount: 0,
    telemetryEnabled: false,
    telemetryConfigurationEnabled: false
};
var $b20e9e3ee3028089$var$onRawTelemetryEventCollected;
function $b20e9e3ee3028089$export$a1198c4bba5d5e18(telemetryService, configuration) {
    var contextProvider;
    var observable = new (0, $4wc1a.Observable)();
    $b20e9e3ee3028089$var$telemetryConfiguration.telemetryEnabled = !(0, $fkj4Q.includes)($b20e9e3ee3028089$var$TELEMETRY_EXCLUDED_SITES, configuration.site) && (0, $bQmeT.performDraw)(configuration.telemetrySampleRate);
    $b20e9e3ee3028089$var$telemetryConfiguration.telemetryConfigurationEnabled = $b20e9e3ee3028089$var$telemetryConfiguration.telemetryEnabled && (0, $bQmeT.performDraw)(configuration.telemetryConfigurationSampleRate);
    var runtimeEnvInfo = $b20e9e3ee3028089$var$getRuntimeEnvInfo();
    $b20e9e3ee3028089$var$onRawTelemetryEventCollected = function(rawEvent) {
        if ($b20e9e3ee3028089$var$telemetryConfiguration.telemetryEnabled) {
            var event_1 = toTelemetryEvent(telemetryService, rawEvent, runtimeEnvInfo);
            observable.notify(event_1);
            (0, $cfGi1.sendToExtension)("telemetry", event_1);
        }
    };
    (0, $2wH3Z.startMonitorErrorCollection)($b20e9e3ee3028089$export$2e825f93958b0e6a);
    (0, $fkj4Q.assign)($b20e9e3ee3028089$var$telemetryConfiguration, {
        maxEventsPerPage: configuration.maxTelemetryEventsPerPage,
        sentEventCount: 0
    });
    function toTelemetryEvent(telemetryService, event, runtimeEnvInfo) {
        return (0, $j9iCm.combine)({
            type: "telemetry",
            date: (0, $ly0px.timeStampNow)(),
            service: telemetryService,
            version: "5.15.0",
            source: "browser",
            _dd: {
                format_version: 2
            },
            telemetry: (0, $j9iCm.combine)(event, {
                runtime_env: runtimeEnvInfo,
                connectivity: (0, $82OHb.getConnectivity)()
            }),
            experimental_features: (0, $fkj4Q.arrayFrom)((0, $k2pmh.getExperimentalFeatures)())
        }, contextProvider !== undefined ? contextProvider() : {});
    }
    return {
        setContextProvider: function(provider) {
            contextProvider = provider;
        },
        observable: observable,
        enabled: $b20e9e3ee3028089$var$telemetryConfiguration.telemetryEnabled
    };
}
function $b20e9e3ee3028089$var$getRuntimeEnvInfo() {
    return {
        is_local_file: window.location.protocol === "file:",
        is_worker: "WorkerGlobalScope" in self
    };
}
function $b20e9e3ee3028089$export$fa01c94923483298() {
    var events = [];
    (0, $fkj4Q.assign)($b20e9e3ee3028089$var$telemetryConfiguration, {
        maxEventsPerPage: Infinity,
        sentEventCount: 0
    });
    $b20e9e3ee3028089$var$onRawTelemetryEventCollected = function(event) {
        events.push(event);
    };
    return events;
}
function $b20e9e3ee3028089$export$bcc442d9456bda5() {
    $b20e9e3ee3028089$var$onRawTelemetryEventCollected = undefined;
}
function $b20e9e3ee3028089$export$2b39c4ac778572fb(configuration) {
    return configuration.site === (0, $ahPEX.INTAKE_SITE_STAGING);
}
function $b20e9e3ee3028089$export$d922954195a17683(message, context) {
    (0, $2wH3Z.displayIfDebugEnabled)((0, $5IDGB.ConsoleApiName).debug, message, context);
    $b20e9e3ee3028089$var$addTelemetry((0, $fkj4Q.assign)({
        type: (0, $1RGSv.TelemetryType).log,
        message: message,
        status: "debug" /* StatusType.debug */ 
    }, context));
}
function $b20e9e3ee3028089$export$2e825f93958b0e6a(e, context) {
    $b20e9e3ee3028089$var$addTelemetry((0, $fkj4Q.assign)({
        type: (0, $1RGSv.TelemetryType).log,
        status: "error" /* StatusType.error */ 
    }, $b20e9e3ee3028089$export$7b5b869ee98c16ab(e), context));
}
function $b20e9e3ee3028089$export$d546dcbd09bc447f(configuration) {
    if ($b20e9e3ee3028089$var$telemetryConfiguration.telemetryConfigurationEnabled) $b20e9e3ee3028089$var$addTelemetry({
        type: (0, $1RGSv.TelemetryType).configuration,
        configuration: configuration
    });
}
function $b20e9e3ee3028089$var$addTelemetry(event) {
    if ($b20e9e3ee3028089$var$onRawTelemetryEventCollected && $b20e9e3ee3028089$var$telemetryConfiguration.sentEventCount < $b20e9e3ee3028089$var$telemetryConfiguration.maxEventsPerPage) {
        $b20e9e3ee3028089$var$telemetryConfiguration.sentEventCount += 1;
        $b20e9e3ee3028089$var$onRawTelemetryEventCollected(event);
    }
}
function $b20e9e3ee3028089$export$7b5b869ee98c16ab(e) {
    if (e instanceof Error) {
        var stackTrace = (0, $iJHw0.computeStackTrace)(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: (0, $4Be0w.toStackTraceString)($b20e9e3ee3028089$export$cb9c82b4610a83c3(stackTrace))
            },
            message: stackTrace.message
        };
    }
    return {
        error: {
            stack: (0, $4Be0w.NO_ERROR_STACK_PRESENT_MESSAGE)
        },
        message: "".concat("Uncaught" /* NonErrorPrefix.UNCAUGHT */ , " ").concat((0, $1W8NF.jsonStringify)(e))
    };
}
function $b20e9e3ee3028089$export$cb9c82b4610a83c3(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter(function(frame) {
        return !frame.url || $b20e9e3ee3028089$var$ALLOWED_FRAME_URLS.some(function(allowedFrameUrl) {
            return (0, $fkj4Q.startsWith)(frame.url, allowedFrameUrl);
        });
    });
    return stackTrace;
}

});
parcelRegister("cfGi1", function(module, exports) {

$parcel$export(module.exports, "sendToExtension", () => $8eb7b09bdabb3e6f$export$528ac5c14fe2fa6b);
function $8eb7b09bdabb3e6f$export$528ac5c14fe2fa6b(type, payload) {
    var callback = window.__ddBrowserSdkExtensionCallback;
    if (callback) callback({
        type: type,
        payload: payload
    });
}

});

parcelRegister("82OHb", function(module, exports) {

$parcel$export(module.exports, "getConnectivity", () => $5db5d5af84f5318f$export$5c86d3b16901f3ce);
function $5db5d5af84f5318f$export$5c86d3b16901f3ce() {
    var _a;
    var navigator = window.navigator;
    return {
        status: navigator.onLine ? "connected" : "not_connected",
        interfaces: navigator.connection && navigator.connection.type ? [
            navigator.connection.type
        ] : undefined,
        effective_type: (_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType
    };
}

});

parcelRegister("1RGSv", function(module, exports) {

$parcel$export(module.exports, "TelemetryType", () => $15bc0061a7f329ff$export$8c1a12d9d019b209);
var $15bc0061a7f329ff$export$8c1a12d9d019b209 = {
    log: "log",
    configuration: "configuration"
};

});


parcelRegister("1gpLX", function(module, exports) {

$parcel$export(module.exports, "PageExitReason", () => $0ebb46f2959d2690$export$69c8658089134213);
$parcel$export(module.exports, "createPageExitObservable", () => $0ebb46f2959d2690$export$ff7f79b1ae5ce683);
$parcel$export(module.exports, "isPageExitReason", () => $0ebb46f2959d2690$export$cbb6b5cdbd0f2b60);

var $k2pmh = parcelRequire("k2pmh");

var $4wc1a = parcelRequire("4wc1a");

var $fkj4Q = parcelRequire("fkj4Q");

var $aed8w = parcelRequire("aed8w");

var $hXhfS = parcelRequire("hXhfS");
var $0ebb46f2959d2690$export$69c8658089134213 = {
    HIDDEN: "visibility_hidden",
    UNLOADING: "before_unload",
    PAGEHIDE: "page_hide",
    FROZEN: "page_frozen"
};
function $0ebb46f2959d2690$export$ff7f79b1ae5ce683(configuration) {
    return new (0, $4wc1a.Observable)(function(observable) {
        var pagehideEnabled = (0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).PAGEHIDE);
        var stopListeners = (0, $hXhfS.addEventListeners)(configuration, window, [
            (0, $hXhfS.DOM_EVENT).VISIBILITY_CHANGE,
            (0, $hXhfS.DOM_EVENT).FREEZE,
            (0, $hXhfS.DOM_EVENT).PAGE_HIDE
        ], function(event) {
            if (event.type === (0, $hXhfS.DOM_EVENT).PAGE_HIDE && pagehideEnabled) /**
                 * Only event that detect page unload events while being compatible with the back/forward cache (bfcache)
                 */ observable.notify({
                reason: $0ebb46f2959d2690$export$69c8658089134213.PAGEHIDE
            });
            else if (event.type === (0, $hXhfS.DOM_EVENT).VISIBILITY_CHANGE && document.visibilityState === "hidden") /**
                 * Only event that guarantee to fire on mobile devices when the page transitions to background state
                 * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
                 */ observable.notify({
                reason: $0ebb46f2959d2690$export$69c8658089134213.HIDDEN
            });
            else if (event.type === (0, $hXhfS.DOM_EVENT).FREEZE) /**
                 * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
                 * Allow to collect events happening between hidden and frozen state.
                 */ observable.notify({
                reason: $0ebb46f2959d2690$export$69c8658089134213.FROZEN
            });
        }, {
            capture: true
        }).stop;
        var stopBeforeUnloadListener = (0, $aed8w.noop);
        if (!pagehideEnabled) stopBeforeUnloadListener = (0, $hXhfS.addEventListener)(configuration, window, (0, $hXhfS.DOM_EVENT).BEFORE_UNLOAD, function() {
            observable.notify({
                reason: $0ebb46f2959d2690$export$69c8658089134213.UNLOADING
            });
        }).stop;
        return function() {
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
}
function $0ebb46f2959d2690$export$cbb6b5cdbd0f2b60(reason) {
    return (0, $fkj4Q.includes)((0, $fkj4Q.objectValues)($0ebb46f2959d2690$export$69c8658089134213), reason);
}

});

parcelRegister("2Bt7w", function(module, exports) {

$parcel$export(module.exports, "createDOMMutationObservable", () => $1e55a02d0fb92a5e$export$e0f9a2ab04194dff);
$parcel$export(module.exports, "getMutationObserverConstructor", () => $1e55a02d0fb92a5e$export$e4f8ebbdf64ea982);

var $5sf7S = parcelRequire("5sf7S");
var $2wH3Z = parcelRequire("2wH3Z");
var $aed8w = parcelRequire("aed8w");
var $4wc1a = parcelRequire("4wc1a");
function $1e55a02d0fb92a5e$export$e0f9a2ab04194dff() {
    var MutationObserver = $1e55a02d0fb92a5e$export$e4f8ebbdf64ea982();
    return new (0, $4wc1a.Observable)(function(observable) {
        if (!MutationObserver) return;
        var observer = new MutationObserver((0, $2wH3Z.monitor)(function() {
            return observable.notify();
        }));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true
        });
        return function() {
            return observer.disconnect();
        };
    });
}
function $1e55a02d0fb92a5e$export$e4f8ebbdf64ea982() {
    var constructor;
    var browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we try to get the original MutationObserver constructor stored by
    // Zone.js.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
        //
        // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
        constructor = (0, $5sf7S.getZoneJsOriginalValue)(browserWindow, "MutationObserver");
        if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
            // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
            // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
            // instance in its properties[4]. Let's get the original MutationObserver constructor from
            // there.
            //
            // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
            var patchedInstance = new browserWindow.MutationObserver((0, $aed8w.noop));
            var originalInstance = (0, $5sf7S.getZoneJsOriginalValue)(patchedInstance, "originalInstance");
            constructor = originalInstance && originalInstance.constructor;
        }
    }
    if (!constructor) constructor = browserWindow.MutationObserver;
    return constructor;
}

});

parcelRegister("iSyQp", function(module, exports) {

$parcel$export(module.exports, "RumPerformanceEntryType", () => $dbe84c7db670842f$export$5241bfb054a2a291);
$parcel$export(module.exports, "supportPerformanceTimingEvent", () => $dbe84c7db670842f$export$c6967607cdac15e8);
$parcel$export(module.exports, "startPerformanceCollection", () => $dbe84c7db670842f$export$4f22ae7bb247104c);

var $hXhfS = parcelRequire("hXhfS");
var $fkj4Q = parcelRequire("fkj4Q");
var $ly0px = parcelRequire("ly0px");
var $bQmeT = parcelRequire("bQmeT");
var $2wH3Z = parcelRequire("2wH3Z");
var $8PiRA = parcelRequire("8PiRA");
var $9h4jO = parcelRequire("9h4jO");
var $d97UU = parcelRequire("d97UU");

var $fisL9 = parcelRequire("fisL9");

var $cOzWl = parcelRequire("cOzWl");
var $dbe84c7db670842f$export$5241bfb054a2a291;
(function(RumPerformanceEntryType) {
    RumPerformanceEntryType["EVENT"] = "event";
    RumPerformanceEntryType["FIRST_INPUT"] = "first-input";
    RumPerformanceEntryType["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
    RumPerformanceEntryType["LAYOUT_SHIFT"] = "layout-shift";
    RumPerformanceEntryType["LONG_TASK"] = "longtask";
    RumPerformanceEntryType["NAVIGATION"] = "navigation";
    RumPerformanceEntryType["PAINT"] = "paint";
    RumPerformanceEntryType["RESOURCE"] = "resource";
})($dbe84c7db670842f$export$5241bfb054a2a291 || ($dbe84c7db670842f$export$5241bfb054a2a291 = {}));
function $dbe84c7db670842f$var$supportPerformanceObject() {
    return window.performance !== undefined && "getEntries" in performance;
}
function $dbe84c7db670842f$export$c6967607cdac15e8(entryType) {
    return window.PerformanceObserver && PerformanceObserver.supportedEntryTypes !== undefined && PerformanceObserver.supportedEntryTypes.includes(entryType);
}
function $dbe84c7db670842f$export$4f22ae7bb247104c(lifeCycle, configuration) {
    var cleanupTasks = [];
    $dbe84c7db670842f$export$7eb7526e9416e27a(configuration, function(timing) {
        $dbe84c7db670842f$var$handleRumPerformanceEntries(lifeCycle, configuration, [
            timing
        ]);
    });
    if ($dbe84c7db670842f$var$supportPerformanceObject()) {
        var performanceEntries_1 = performance.getEntries();
        // Because the performance entry list can be quite large
        // delay the computation to prevent the SDK from blocking the main thread on init
        (0, $d97UU.setTimeout)(function() {
            return $dbe84c7db670842f$var$handleRumPerformanceEntries(lifeCycle, configuration, performanceEntries_1);
        });
    }
    if (window.PerformanceObserver) {
        var handlePerformanceEntryList_1 = (0, $2wH3Z.monitor)(function(entries) {
            return $dbe84c7db670842f$var$handleRumPerformanceEntries(lifeCycle, configuration, entries.getEntries());
        });
        var mainEntries = [
            $dbe84c7db670842f$export$5241bfb054a2a291.RESOURCE,
            $dbe84c7db670842f$export$5241bfb054a2a291.NAVIGATION,
            $dbe84c7db670842f$export$5241bfb054a2a291.LONG_TASK,
            $dbe84c7db670842f$export$5241bfb054a2a291.PAINT
        ];
        var experimentalEntries = [
            $dbe84c7db670842f$export$5241bfb054a2a291.LARGEST_CONTENTFUL_PAINT,
            $dbe84c7db670842f$export$5241bfb054a2a291.FIRST_INPUT,
            $dbe84c7db670842f$export$5241bfb054a2a291.LAYOUT_SHIFT,
            $dbe84c7db670842f$export$5241bfb054a2a291.EVENT
        ];
        try {
            // Experimental entries are not retrieved by performance.getEntries()
            // use a single PerformanceObserver with buffered flag by type
            // to get values that could happen before SDK init
            experimentalEntries.forEach(function(type) {
                var observer = new window.PerformanceObserver(handlePerformanceEntryList_1);
                observer.observe({
                    type: type,
                    buffered: true,
                    // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
                    // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L209
                    durationThreshold: 40
                });
                cleanupTasks.push(function() {
                    return observer.disconnect();
                });
            });
        } catch (e) {
            // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to PerformanceObserver with entryTypes
            mainEntries.push.apply(mainEntries, experimentalEntries);
        }
        var mainObserver_1 = new PerformanceObserver(handlePerformanceEntryList_1);
        mainObserver_1.observe({
            entryTypes: mainEntries
        });
        cleanupTasks.push(function() {
            return mainObserver_1.disconnect();
        });
        if ($dbe84c7db670842f$var$supportPerformanceObject() && "addEventListener" in performance) {
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
            var removePerformanceListener = (0, $hXhfS.addEventListener)(configuration, performance, "resourcetimingbufferfull", function() {
                performance.clearResourceTimings();
            }).stop;
            cleanupTasks.push(removePerformanceListener);
        }
    }
    if (!$dbe84c7db670842f$export$c6967607cdac15e8($dbe84c7db670842f$export$5241bfb054a2a291.NAVIGATION)) $dbe84c7db670842f$var$retrieveNavigationTiming(configuration, function(timing) {
        $dbe84c7db670842f$var$handleRumPerformanceEntries(lifeCycle, configuration, [
            timing
        ]);
    });
    if (!$dbe84c7db670842f$export$c6967607cdac15e8($dbe84c7db670842f$export$5241bfb054a2a291.FIRST_INPUT)) {
        var stopFirstInputTiming = $dbe84c7db670842f$var$retrieveFirstInputTiming(configuration, function(timing) {
            $dbe84c7db670842f$var$handleRumPerformanceEntries(lifeCycle, configuration, [
                timing
            ]);
        }).stop;
        cleanupTasks.push(stopFirstInputTiming);
    }
    return {
        stop: function() {
            cleanupTasks.forEach(function(task) {
                return task();
            });
        }
    };
}
function $dbe84c7db670842f$export$7eb7526e9416e27a(configuration, callback) {
    (0, $9h4jO.runOnReadyState)(configuration, "interactive", function() {
        var timing;
        var forcedAttributes = {
            entryType: $dbe84c7db670842f$export$5241bfb054a2a291.RESOURCE,
            initiatorType: (0, $fisL9.FAKE_INITIAL_DOCUMENT),
            traceId: (0, $cOzWl.getDocumentTraceId)(document),
            toJSON: function() {
                return (0, $fkj4Q.assign)({}, timing, {
                    toJSON: undefined
                });
            }
        };
        if ($dbe84c7db670842f$export$c6967607cdac15e8($dbe84c7db670842f$export$5241bfb054a2a291.NAVIGATION) && performance.getEntriesByType($dbe84c7db670842f$export$5241bfb054a2a291.NAVIGATION).length > 0) {
            var navigationEntry = performance.getEntriesByType($dbe84c7db670842f$export$5241bfb054a2a291.NAVIGATION)[0];
            timing = (0, $fkj4Q.assign)(navigationEntry.toJSON(), forcedAttributes);
        } else {
            var relativePerformanceTiming = $dbe84c7db670842f$var$computeRelativePerformanceTiming();
            timing = (0, $fkj4Q.assign)(relativePerformanceTiming, {
                decodedBodySize: 0,
                encodedBodySize: 0,
                transferSize: 0,
                renderBlockingStatus: "non-blocking",
                duration: relativePerformanceTiming.responseEnd,
                name: window.location.href,
                startTime: 0
            }, forcedAttributes);
        }
        callback(timing);
    });
}
function $dbe84c7db670842f$var$retrieveNavigationTiming(configuration, callback) {
    function sendFakeTiming() {
        callback((0, $fkj4Q.assign)($dbe84c7db670842f$var$computeRelativePerformanceTiming(), {
            entryType: $dbe84c7db670842f$export$5241bfb054a2a291.NAVIGATION
        }));
    }
    (0, $9h4jO.runOnReadyState)(configuration, "complete", function() {
        // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
        (0, $d97UU.setTimeout)(sendFakeTiming);
    });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */ function $dbe84c7db670842f$var$retrieveFirstInputTiming(configuration, callback) {
    var startTimeStamp = (0, $ly0px.dateNow)();
    var timingSent = false;
    var removeEventListeners = (0, $hXhfS.addEventListeners)(configuration, window, [
        (0, $hXhfS.DOM_EVENT).CLICK,
        (0, $hXhfS.DOM_EVENT).MOUSE_DOWN,
        (0, $hXhfS.DOM_EVENT).KEY_DOWN,
        (0, $hXhfS.DOM_EVENT).TOUCH_START,
        (0, $hXhfS.DOM_EVENT).POINTER_DOWN
    ], function(evt) {
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) return;
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        var timing = {
            entryType: $dbe84c7db670842f$export$5241bfb054a2a291.FIRST_INPUT,
            processingStart: (0, $ly0px.relativeNow)(),
            processingEnd: (0, $ly0px.relativeNow)(),
            startTime: evt.timeStamp,
            duration: 0,
            name: ""
        };
        if (evt.type === (0, $hXhfS.DOM_EVENT).POINTER_DOWN) sendTimingIfPointerIsNotCancelled(configuration, timing);
        else sendTiming(timing);
    }, {
        passive: true,
        capture: true
    }).stop;
    return {
        stop: removeEventListeners
    };
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */ function sendTimingIfPointerIsNotCancelled(configuration, timing) {
        (0, $hXhfS.addEventListeners)(configuration, window, [
            (0, $hXhfS.DOM_EVENT).POINTER_UP,
            (0, $hXhfS.DOM_EVENT).POINTER_CANCEL
        ], function(event) {
            if (event.type === (0, $hXhfS.DOM_EVENT).POINTER_UP) sendTiming(timing);
        }, {
            once: true
        });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            var delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < (0, $ly0px.dateNow)() - startTimeStamp) callback(timing);
        }
    }
}
function $dbe84c7db670842f$var$computeRelativePerformanceTiming() {
    var result = {};
    var timing = performance.timing;
    for(var key in timing)if ((0, $bQmeT.isNumber)(timing[key])) {
        var numberKey = key;
        var timingElement = timing[numberKey];
        result[numberKey] = timingElement === 0 ? 0 : (0, $ly0px.getRelativeTime)(timingElement);
    }
    return result;
}
function $dbe84c7db670842f$var$handleRumPerformanceEntries(lifeCycle, configuration, entries) {
    var rumPerformanceEntries = entries.filter(function(entry) {
        return (0, $8PiRA.objectHasValue)($dbe84c7db670842f$export$5241bfb054a2a291, entry.entryType);
    });
    var rumAllowedPerformanceEntries = rumPerformanceEntries.filter(function(entry) {
        return !$dbe84c7db670842f$var$isIncompleteNavigation(entry) && !$dbe84c7db670842f$var$isForbiddenResource(configuration, entry);
    });
    if (rumAllowedPerformanceEntries.length) lifeCycle.notify(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */ , rumAllowedPerformanceEntries);
}
function $dbe84c7db670842f$var$isIncompleteNavigation(entry) {
    return entry.entryType === $dbe84c7db670842f$export$5241bfb054a2a291.NAVIGATION && entry.loadEventEnd <= 0;
}
function $dbe84c7db670842f$var$isForbiddenResource(configuration, entry) {
    return entry.entryType === $dbe84c7db670842f$export$5241bfb054a2a291.RESOURCE && !(0, $fisL9.isAllowedRequestUrl)(configuration, entry.name);
}

});
parcelRegister("9h4jO", function(module, exports) {

$parcel$export(module.exports, "runOnReadyState", () => $6c090d2d29937490$export$12cb733fc911e4f7);

var $hXhfS = parcelRequire("hXhfS");
function $6c090d2d29937490$export$12cb733fc911e4f7(configuration, expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === "complete") callback();
    else {
        var eventName = expectedReadyState === "complete" ? (0, $hXhfS.DOM_EVENT).LOAD : (0, $hXhfS.DOM_EVENT).DOM_CONTENT_LOADED;
        (0, $hXhfS.addEventListener)(configuration, window, eventName, callback, {
            once: true
        });
    }
}

});

parcelRegister("fisL9", function(module, exports) {

$parcel$export(module.exports, "FAKE_INITIAL_DOCUMENT", () => $b22ed8845addf22a$export$dc5d43db6d9a2bce);
$parcel$export(module.exports, "computeResourceKind", () => $b22ed8845addf22a$export$5e78e8490e290d1f);
$parcel$export(module.exports, "isRequestKind", () => $b22ed8845addf22a$export$8bc876d854d05e34);
$parcel$export(module.exports, "computePerformanceResourceDuration", () => $b22ed8845addf22a$export$883ce645d410c918);
$parcel$export(module.exports, "computePerformanceResourceDetails", () => $b22ed8845addf22a$export$6833c1608b6b5e2e);
$parcel$export(module.exports, "toValidEntry", () => $b22ed8845addf22a$export$15341232ff5dd6e5);
$parcel$export(module.exports, "computeSize", () => $b22ed8845addf22a$export$887c770fbe334306);
$parcel$export(module.exports, "isAllowedRequestUrl", () => $b22ed8845addf22a$export$c298da523d6ed600);

var $fhNdh = parcelRequire("fhNdh");
var $ly0px = parcelRequire("ly0px");
var $bVLiF = parcelRequire("bVLiF");
var $fkj4Q = parcelRequire("fkj4Q");
var $b22ed8845addf22a$export$dc5d43db6d9a2bce = "initial_document";
var $b22ed8845addf22a$var$RESOURCE_TYPES = [
    [
        "document" /* ResourceType.DOCUMENT */ ,
        function(initiatorType) {
            return $b22ed8845addf22a$export$dc5d43db6d9a2bce === initiatorType;
        }
    ],
    [
        "xhr" /* ResourceType.XHR */ ,
        function(initiatorType) {
            return "xmlhttprequest" === initiatorType;
        }
    ],
    [
        "fetch" /* ResourceType.FETCH */ ,
        function(initiatorType) {
            return "fetch" === initiatorType;
        }
    ],
    [
        "beacon" /* ResourceType.BEACON */ ,
        function(initiatorType) {
            return "beacon" === initiatorType;
        }
    ],
    [
        "css" /* ResourceType.CSS */ ,
        function(_, path) {
            return /\.css$/i.test(path);
        }
    ],
    [
        "js" /* ResourceType.JS */ ,
        function(_, path) {
            return /\.js$/i.test(path);
        }
    ],
    [
        "image" /* ResourceType.IMAGE */ ,
        function(initiatorType, path) {
            return (0, $fkj4Q.includes)([
                "image",
                "img",
                "icon"
            ], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
        }
    ],
    [
        "font" /* ResourceType.FONT */ ,
        function(_, path) {
            return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null;
        }
    ],
    [
        "media" /* ResourceType.MEDIA */ ,
        function(initiatorType, path) {
            return (0, $fkj4Q.includes)([
                "audio",
                "video"
            ], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
        }
    ]
];
function $b22ed8845addf22a$export$5e78e8490e290d1f(timing) {
    var url = timing.name;
    if (!(0, $bVLiF.isValidUrl)(url)) {
        (0, $fhNdh.addTelemetryDebug)('Failed to construct URL for "'.concat(timing.name, '"'));
        return "other" /* ResourceType.OTHER */ ;
    }
    var path = (0, $bVLiF.getPathName)(url);
    for(var _i = 0, RESOURCE_TYPES_1 = $b22ed8845addf22a$var$RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++){
        var _a = RESOURCE_TYPES_1[_i], type = _a[0], isType = _a[1];
        if (isType(timing.initiatorType, path)) return type;
    }
    return "other" /* ResourceType.OTHER */ ;
}
function $b22ed8845addf22a$var$areInOrder() {
    var numbers = [];
    for(var _i = 0; _i < arguments.length; _i++)numbers[_i] = arguments[_i];
    for(var i = 1; i < numbers.length; i += 1){
        if (numbers[i - 1] > numbers[i]) return false;
    }
    return true;
}
function $b22ed8845addf22a$export$8bc876d854d05e34(timing) {
    return timing.initiatorType === "xmlhttprequest" || timing.initiatorType === "fetch";
}
function $b22ed8845addf22a$export$883ce645d410c918(entry) {
    var duration = entry.duration, startTime = entry.startTime, responseEnd = entry.responseEnd;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) return (0, $ly0px.toServerDuration)((0, $ly0px.elapsed)(startTime, responseEnd));
    return (0, $ly0px.toServerDuration)(duration);
}
function $b22ed8845addf22a$export$6833c1608b6b5e2e(entry) {
    var validEntry = $b22ed8845addf22a$export$15341232ff5dd6e5(entry);
    if (!validEntry) return undefined;
    var startTime = validEntry.startTime, fetchStart = validEntry.fetchStart, redirectStart = validEntry.redirectStart, redirectEnd = validEntry.redirectEnd, domainLookupStart = validEntry.domainLookupStart, domainLookupEnd = validEntry.domainLookupEnd, connectStart = validEntry.connectStart, secureConnectionStart = validEntry.secureConnectionStart, connectEnd = validEntry.connectEnd, requestStart = validEntry.requestStart, responseStart = validEntry.responseStart, responseEnd = validEntry.responseEnd;
    var details = {
        download: $b22ed8845addf22a$var$formatTiming(startTime, responseStart, responseEnd),
        first_byte: $b22ed8845addf22a$var$formatTiming(startTime, requestStart, responseStart)
    };
    // Make sure a connection occurred
    if (connectEnd !== fetchStart) {
        details.connect = $b22ed8845addf22a$var$formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if ($b22ed8845addf22a$var$areInOrder(connectStart, secureConnectionStart, connectEnd)) details.ssl = $b22ed8845addf22a$var$formatTiming(startTime, secureConnectionStart, connectEnd);
    }
    // Make sure a domain lookup occurred
    if (domainLookupEnd !== fetchStart) details.dns = $b22ed8845addf22a$var$formatTiming(startTime, domainLookupStart, domainLookupEnd);
    if ($b22ed8845addf22a$var$hasRedirection(entry)) details.redirect = $b22ed8845addf22a$var$formatTiming(startTime, redirectStart, redirectEnd);
    return details;
}
function $b22ed8845addf22a$export$15341232ff5dd6e5(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    var areCommonTimingsInOrder = $b22ed8845addf22a$var$areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd);
    var areRedirectionTimingsInOrder = $b22ed8845addf22a$var$hasRedirection(entry) ? $b22ed8845addf22a$var$areInOrder(entry.startTime, entry.redirectStart, entry.redirectEnd, entry.fetchStart) : true;
    if (areCommonTimingsInOrder && areRedirectionTimingsInOrder) return entry;
}
function $b22ed8845addf22a$var$hasRedirection(entry) {
    return entry.redirectEnd > entry.startTime;
}
function $b22ed8845addf22a$var$formatTiming(origin, start, end) {
    return {
        duration: (0, $ly0px.toServerDuration)((0, $ly0px.elapsed)(start, end)),
        start: (0, $ly0px.toServerDuration)((0, $ly0px.elapsed)(origin, start))
    };
}
function $b22ed8845addf22a$export$887c770fbe334306(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        var encodedBodySize = entry.encodedBodySize, decodedBodySize = entry.decodedBodySize, transferSize = entry.transferSize;
        return {
            size: decodedBodySize,
            encoded_body_size: encodedBodySize,
            decoded_body_size: decodedBodySize,
            transfer_size: transferSize
        };
    }
    return {
        size: undefined,
        encoded_body_size: undefined,
        decoded_body_size: undefined,
        transfer_size: undefined
    };
}
function $b22ed8845addf22a$export$c298da523d6ed600(configuration, url) {
    return url && !configuration.isIntakeUrl(url);
}

});

parcelRegister("cOzWl", function(module, exports) {

$parcel$export(module.exports, "getDocumentTraceId", () => $9546088253798c5a$export$9600d3c1068ac02c);

var $ly0px = parcelRequire("ly0px");
var $99fDv = parcelRequire("99fDv");

var $4TGNe = parcelRequire("4TGNe");
var $9546088253798c5a$export$f1b0e1c95ecb6961 = 2 * (0, $ly0px.ONE_MINUTE);
function $9546088253798c5a$export$9600d3c1068ac02c(document) {
    var data = $9546088253798c5a$export$cabe353a895a405f(document) || $9546088253798c5a$export$70f194456d3a8998(document);
    if (!data || data.traceTime <= (0, $ly0px.dateNow)() - $9546088253798c5a$export$f1b0e1c95ecb6961) return undefined;
    return data.traceId;
}
function $9546088253798c5a$export$cabe353a895a405f(document) {
    var traceIdMeta = document.querySelector("meta[name=dd-trace-id]");
    var traceTimeMeta = document.querySelector("meta[name=dd-trace-time]");
    return $9546088253798c5a$export$10b75f215ee15e0e(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function $9546088253798c5a$export$70f194456d3a8998(document) {
    var comment = $9546088253798c5a$export$4d376e42fa08c24d(document);
    if (!comment) return undefined;
    return $9546088253798c5a$export$10b75f215ee15e0e((0, $99fDv.findCommaSeparatedValue)(comment, "trace-id"), (0, $99fDv.findCommaSeparatedValue)(comment, "trace-time"));
}
function $9546088253798c5a$export$10b75f215ee15e0e(traceId, rawTraceTime) {
    var traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) return undefined;
    return {
        traceId: traceId,
        traceTime: traceTime
    };
}
function $9546088253798c5a$export$4d376e42fa08c24d(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    for(var i = 0; i < document.childNodes.length; i += 1){
        var comment = $9546088253798c5a$var$getTraceCommentFromNode(document.childNodes[i]);
        if (comment) return comment;
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) for(var i = document.body.childNodes.length - 1; i >= 0; i -= 1){
        var node = document.body.childNodes[i];
        var comment = $9546088253798c5a$var$getTraceCommentFromNode(node);
        if (comment) return comment;
        if (!(0, $4TGNe.isTextNode)(node)) break;
    }
}
function $9546088253798c5a$var$getTraceCommentFromNode(node) {
    if (node && (0, $4TGNe.isCommentNode)(node)) {
        var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) return match[1];
    }
}

});
parcelRegister("4TGNe", function(module, exports) {

$parcel$export(module.exports, "isTextNode", () => $390d7e44cf00bd59$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "isCommentNode", () => $390d7e44cf00bd59$export$575485136eb1b1f);
$parcel$export(module.exports, "isElementNode", () => $390d7e44cf00bd59$export$95fe5d3c5526a812);
$parcel$export(module.exports, "isNodeShadowHost", () => $390d7e44cf00bd59$export$1fde2ba54cd81850);
$parcel$export(module.exports, "isNodeShadowRoot", () => $390d7e44cf00bd59$export$3a98bd54c2ced0bf);
$parcel$export(module.exports, "hasChildNodes", () => $390d7e44cf00bd59$export$13782f450ac5e09a);
$parcel$export(module.exports, "forEachChildNodes", () => $390d7e44cf00bd59$export$522badb50a8fb0b);
$parcel$export(module.exports, "getParentNode", () => $390d7e44cf00bd59$export$4e12058fc4d51d56);
function $390d7e44cf00bd59$export$ccbedd67ef6e9417(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $390d7e44cf00bd59$export$575485136eb1b1f(node) {
    return node.nodeType === Node.COMMENT_NODE;
}
function $390d7e44cf00bd59$export$95fe5d3c5526a812(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $390d7e44cf00bd59$export$1fde2ba54cd81850(node) {
    return $390d7e44cf00bd59$export$95fe5d3c5526a812(node) && Boolean(node.shadowRoot);
}
function $390d7e44cf00bd59$export$3a98bd54c2ced0bf(node) {
    var shadowRoot = node;
    return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && $390d7e44cf00bd59$export$95fe5d3c5526a812(shadowRoot.host);
}
function $390d7e44cf00bd59$export$13782f450ac5e09a(node) {
    return node.childNodes.length > 0 || $390d7e44cf00bd59$export$1fde2ba54cd81850(node);
}
function $390d7e44cf00bd59$export$522badb50a8fb0b(node, callback) {
    var child = node.firstChild;
    while(child){
        callback(child);
        child = child.nextSibling;
    }
    if ($390d7e44cf00bd59$export$1fde2ba54cd81850(node)) callback(node.shadowRoot);
}
function $390d7e44cf00bd59$export$4e12058fc4d51d56(node) {
    return $390d7e44cf00bd59$export$3a98bd54c2ced0bf(node) ? node.host : node.parentNode;
}

});



parcelRegister("8NjHX", function(module, exports) {

$parcel$export(module.exports, "startRumAssembly", () => $66722fe8d7cbabe1$export$1a0bc162690d6539);

var $fkj4Q = parcelRequire("fkj4Q");
var $kFaIT = parcelRequire("kFaIT");
var $j9iCm = parcelRequire("j9iCm");
var $axXk6 = parcelRequire("axXk6");
var $ly0px = parcelRequire("ly0px");
var $5IDGB = parcelRequire("5IDGB");
var $k2pmh = parcelRequire("k2pmh");
var $82OHb = parcelRequire("82OHb");
var $8PiRA = parcelRequire("8PiRA");
var $bQmeT = parcelRequire("bQmeT");

var $e4z7O = parcelRequire("e4z7O");

var $iajsC = parcelRequire("iajsC");
var $66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS = {
    "view.name": "string",
    "view.url": "string",
    "view.referrer": "string"
};
var $66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS = {
    context: "object"
};
var $66722fe8d7cbabe1$var$modifiableFieldPathsByEvent;
function $66722fe8d7cbabe1$export$1a0bc162690d6539(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, ciVisibilityContext, getCommonContext, reportError) {
    var _a, _b;
    $66722fe8d7cbabe1$var$modifiableFieldPathsByEvent = (_a = {}, _a["view" /* RumEventType.VIEW */ ] = $66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS, _a["error" /* RumEventType.ERROR */ ] = (0, $fkj4Q.assign)({
        "error.message": "string",
        "error.stack": "string",
        "error.resource.url": "string",
        "error.fingerprint": "string"
    }, $66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS, $66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS), _a["resource" /* RumEventType.RESOURCE */ ] = (0, $fkj4Q.assign)({
        "resource.url": "string"
    }, (0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).WRITABLE_RESOURCE_GRAPHQL) && {
        "resource.graphql": "object"
    }, $66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS, $66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS), _a["action" /* RumEventType.ACTION */ ] = (0, $fkj4Q.assign)({
        "action.target.name": "string"
    }, $66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS, $66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS), _a["long_task" /* RumEventType.LONG_TASK */ ] = (0, $fkj4Q.assign)({}, $66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS, $66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS), _a["vital" /* RumEventType.VITAL */ ] = (0, $fkj4Q.assign)({}, $66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS, $66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS), _a);
    var eventRateLimiters = (_b = {}, _b["error" /* RumEventType.ERROR */ ] = (0, $axXk6.createEventRateLimiter)("error" /* RumEventType.ERROR */ , configuration.eventRateLimiterThreshold, reportError), _b["action" /* RumEventType.ACTION */ ] = (0, $axXk6.createEventRateLimiter)("action" /* RumEventType.ACTION */ , configuration.eventRateLimiterThreshold, reportError), _b["vital" /* RumEventType.VITAL */ ] = (0, $axXk6.createEventRateLimiter)("vital" /* RumEventType.VITAL */ , configuration.eventRateLimiterThreshold, reportError), _b);
    var syntheticsContext = (0, $e4z7O.getSyntheticsContext)();
    lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , function(_a) {
        var startTime = _a.startTime, rawRumEvent = _a.rawRumEvent, domainContext = _a.domainContext, savedCommonContext = _a.savedCommonContext, customerContext = _a.customerContext;
        var viewContext = viewContexts.findView(startTime);
        var urlContext = urlContexts.findUrl(startTime);
        var session = sessionManager.findTrackedSession(startTime);
        if (session && viewContext && urlContext) {
            var commonContext = savedCommonContext || getCommonContext();
            var actionId = actionContexts.findActionId(startTime);
            var rumContext = {
                _dd: {
                    format_version: 2,
                    drift: (0, $ly0px.currentDrift)(),
                    configuration: {
                        session_sample_rate: (0, $bQmeT.round)(configuration.sessionSampleRate, 3),
                        session_replay_sample_rate: (0, $bQmeT.round)(configuration.sessionReplaySampleRate, 3)
                    },
                    browser_sdk_version: (0, $kFaIT.canUseEventBridge)() ? "5.15.0" : undefined
                },
                application: {
                    id: configuration.applicationId
                },
                date: (0, $ly0px.timeStampNow)(),
                service: viewContext.service || configuration.service,
                version: viewContext.version || configuration.version,
                source: "browser",
                session: {
                    id: session.id,
                    type: syntheticsContext ? "synthetics" /* SessionType.SYNTHETICS */  : ciVisibilityContext.get() ? "ci_test" /* SessionType.CI_TEST */  : "user" /* SessionType.USER */ 
                },
                view: {
                    id: viewContext.id,
                    name: viewContext.name,
                    url: urlContext.url,
                    referrer: urlContext.referrer
                },
                action: $66722fe8d7cbabe1$var$needToAssembleWithAction(rawRumEvent) && actionId ? {
                    id: actionId
                } : undefined,
                synthetics: syntheticsContext,
                ci_test: ciVisibilityContext.get(),
                display: displayContext.get(),
                connectivity: (0, $82OHb.getConnectivity)()
            };
            var serverRumEvent = (0, $j9iCm.combine)(rumContext, rawRumEvent);
            serverRumEvent.context = (0, $j9iCm.combine)(commonContext.context, customerContext);
            if (!("has_replay" in serverRumEvent.session)) serverRumEvent.session.has_replay = commonContext.hasReplay;
            if (serverRumEvent.type === "view") serverRumEvent.session.sampled_for_replay = session.sessionReplayAllowed;
            if (!(0, $8PiRA.isEmptyObject)(commonContext.user)) serverRumEvent.usr = commonContext.user;
            if ($66722fe8d7cbabe1$var$shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
                if ((0, $8PiRA.isEmptyObject)(serverRumEvent.context)) delete serverRumEvent.context;
                lifeCycle.notify(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , serverRumEvent);
            }
        }
    });
}
function $66722fe8d7cbabe1$var$shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        var result = (0, $iajsC.limitModification)(event, $66722fe8d7cbabe1$var$modifiableFieldPathsByEvent[event.type], function(event) {
            return beforeSend(event, domainContext);
        });
        if (result === false && event.type !== "view" /* RumEventType.VIEW */ ) return false;
        if (result === false) (0, $5IDGB.display).warn("Can't dismiss view events using beforeSend!");
    }
    var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}
function $66722fe8d7cbabe1$var$needToAssembleWithAction(event) {
    return [
        "error" /* RumEventType.ERROR */ ,
        "resource" /* RumEventType.RESOURCE */ ,
        "long_task" /* RumEventType.LONG_TASK */ 
    ].indexOf(event.type) !== -1;
}

});
parcelRegister("axXk6", function(module, exports) {

$parcel$export(module.exports, "createEventRateLimiter", () => $7adb00cfa5352eff$export$eafcd5d914e17d69);

var $d97UU = parcelRequire("d97UU");

var $ly0px = parcelRequire("ly0px");

var $1zKlK = parcelRequire("1zKlK");
function $7adb00cfa5352eff$export$eafcd5d914e17d69(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function() {
            if (eventCount === 0) (0, $d97UU.setTimeout)(function() {
                eventCount = 0;
            }, (0, $ly0px.ONE_MINUTE));
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: (0, $1zKlK.ErrorSource).AGENT,
                        startClocks: (0, $ly0px.clocksNow)()
                    });
                } finally{
                    allowNextEvent = false;
                }
            }
            return true;
        }
    };
}

});
parcelRegister("1zKlK", function(module, exports) {

$parcel$export(module.exports, "ErrorSource", () => $125d036ad0d2a2af$export$4f7d2dba9330699b);
var $125d036ad0d2a2af$export$4f7d2dba9330699b = {
    AGENT: "agent",
    CONSOLE: "console",
    CUSTOM: "custom",
    LOGGER: "logger",
    NETWORK: "network",
    SOURCE: "source",
    REPORT: "report"
};

});


parcelRegister("e4z7O", function(module, exports) {

$parcel$export(module.exports, "getSyntheticsContext", () => $a3ecaf80187f9bbd$export$f36825a638794cc1);

var $eA1KP = parcelRequire("eA1KP");
function $a3ecaf80187f9bbd$export$f36825a638794cc1() {
    var testId = (0, $eA1KP.getSyntheticsTestId)();
    var resultId = (0, $eA1KP.getSyntheticsResultId)();
    if (testId && resultId) return {
        test_id: testId,
        result_id: resultId,
        injected: (0, $eA1KP.willSyntheticsInjectRum)()
    };
}

});

parcelRegister("iajsC", function(module, exports) {

$parcel$export(module.exports, "limitModification", () => $d39841a7da10ef40$export$a1733aa00dfb01);

var $j9iCm = parcelRequire("j9iCm");
var $5DEie = parcelRequire("5DEie");
var $fkj4Q = parcelRequire("fkj4Q");
var $1RdIU = parcelRequire("1RdIU");
function $d39841a7da10ef40$export$a1733aa00dfb01(object, modifiableFieldPaths, modifier) {
    var clone = (0, $j9iCm.deepClone)(object);
    var result = modifier(clone);
    (0, $fkj4Q.objectEntries)(modifiableFieldPaths).forEach(function(_a) {
        var fieldPath = _a[0], fieldType = _a[1];
        var newValue = $d39841a7da10ef40$var$get(clone, fieldPath);
        var newType = (0, $5DEie.getType)(newValue);
        if (newType === fieldType) $d39841a7da10ef40$var$set(object, fieldPath, (0, $1RdIU.sanitize)(newValue));
        else if (fieldType === "object" && (newType === "undefined" || newType === "null")) $d39841a7da10ef40$var$set(object, fieldPath, {});
    });
    return result;
}
function $d39841a7da10ef40$var$get(object, path) {
    var current = object;
    for(var _i = 0, _a = path.split("."); _i < _a.length; _i++){
        var field = _a[_i];
        if (!$d39841a7da10ef40$var$isValidObjectContaining(current, field)) return;
        current = current[field];
    }
    return current;
}
function $d39841a7da10ef40$var$set(object, path, value) {
    var current = object;
    var fields = path.split(".");
    for(var i = 0; i < fields.length; i += 1){
        var field = fields[i];
        if (!$d39841a7da10ef40$var$isValidObject(current)) return;
        if (i !== fields.length - 1) current = current[field];
        else current[field] = value;
    }
}
function $d39841a7da10ef40$var$isValidObject(object) {
    return (0, $5DEie.getType)(object) === "object";
}
function $d39841a7da10ef40$var$isValidObjectContaining(object, field) {
    return $d39841a7da10ef40$var$isValidObject(object) && Object.prototype.hasOwnProperty.call(object, field);
}

});


parcelRegister("f2Ka5", function(module, exports) {

$parcel$export(module.exports, "startInternalContext", () => $af3ad9afe3848d81$export$ee941cf091e8459);
/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */ function $af3ad9afe3848d81$export$ee941cf091e8459(applicationId, sessionManager, viewContexts, actionContexts, urlContexts) {
    return {
        get: function(startTime) {
            var viewContext = viewContexts.findView(startTime);
            var urlContext = urlContexts.findUrl(startTime);
            var session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                var actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? {
                        id: actionId
                    } : undefined,
                    view: {
                        id: viewContext.id,
                        name: viewContext.name,
                        referrer: urlContext.referrer,
                        url: urlContext.url
                    }
                };
            }
        }
    };
}

});

parcelRegister("54uGZ", function(module, exports) {

$parcel$export(module.exports, "LifeCycle", () => $3b152250b13a0137$export$6af70476896cbaec);

var $f7eLh = parcelRequire("f7eLh");
var $3b152250b13a0137$export$6af70476896cbaec = (0, $f7eLh.AbstractLifeCycle);

});
parcelRegister("f7eLh", function(module, exports) {

$parcel$export(module.exports, "AbstractLifeCycle", () => $b012f5cc0ca286d9$export$cf0c49d09be0ebd8);
var $b012f5cc0ca286d9$export$cf0c49d09be0ebd8 = /** @class */ function() {
    function AbstractLifeCycle() {
        this.callbacks = {};
    }
    AbstractLifeCycle.prototype.notify = function(eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) eventCallbacks.forEach(function(callback) {
            return callback(data);
        });
    };
    AbstractLifeCycle.prototype.subscribe = function(eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) this.callbacks[eventType] = [];
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function() {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function(other) {
                    return callback !== other;
                });
            }
        };
    };
    return AbstractLifeCycle;
}();

});


parcelRegister("4Voar", function(module, exports) {

$parcel$export(module.exports, "startViewContexts", () => $395f3b6b0412c25e$export$17bf0e3c9aa043e3);

var $5xfjl = parcelRequire("5xfjl");
var $80mka = parcelRequire("80mka");
var $395f3b6b0412c25e$export$f12c747a768c817c = (0, $5xfjl.SESSION_TIME_OUT_DELAY);
function $395f3b6b0412c25e$export$17bf0e3c9aa043e3(lifeCycle) {
    var viewContextHistory = new (0, $80mka.ValueHistory)($395f3b6b0412c25e$export$f12c747a768c817c);
    lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */ , function(view) {
        viewContextHistory.add(buildViewContext(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */ , function(_a) {
        var endClocks = _a.endClocks;
        viewContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , function() {
        viewContextHistory.reset();
    });
    function buildViewContext(view) {
        return {
            service: view.service,
            version: view.version,
            id: view.id,
            name: view.name,
            startClocks: view.startClocks
        };
    }
    return {
        findView: function(startTime) {
            return viewContextHistory.find(startTime);
        },
        stop: function() {
            viewContextHistory.stop();
        }
    };
}

});
parcelRegister("80mka", function(module, exports) {

$parcel$export(module.exports, "ValueHistory", () => $5d3fa3f7dfe2dca0$export$b054dd6fcf79fa19);

var $d97UU = parcelRequire("d97UU");

var $lHOXU = parcelRequire("lHOXU");

var $ly0px = parcelRequire("ly0px");
var $5d3fa3f7dfe2dca0$var$END_OF_TIMES = Infinity;
var $5d3fa3f7dfe2dca0$export$7cf440d5901bea64 = (0, $ly0px.ONE_MINUTE);
/**
 * Store and keep track of values spans. This whole class assumes that values are added in
 * chronological order (i.e. all entries have an increasing start time).
 */ var $5d3fa3f7dfe2dca0$export$b054dd6fcf79fa19 = /** @class */ function() {
    function ValueHistory(expireDelay, maxEntries) {
        var _this = this;
        this.expireDelay = expireDelay;
        this.maxEntries = maxEntries;
        this.entries = [];
        this.clearOldValuesInterval = (0, $d97UU.setInterval)(function() {
            return _this.clearOldValues();
        }, $5d3fa3f7dfe2dca0$export$7cf440d5901bea64);
    }
    /**
     * Add a value to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */ ValueHistory.prototype.add = function(value, startTime) {
        var _this = this;
        var entry = {
            value: value,
            startTime: startTime,
            endTime: $5d3fa3f7dfe2dca0$var$END_OF_TIMES,
            remove: function() {
                (0, $lHOXU.removeItem)(_this.entries, entry);
            },
            close: function(endTime) {
                entry.endTime = endTime;
            }
        };
        if (this.maxEntries && this.entries.length >= this.maxEntries) this.entries.pop();
        this.entries.unshift(entry);
        return entry;
    };
    /**
     * Return the latest value that was active during `startTime`, or the currently active value
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     */ ValueHistory.prototype.find = function(startTime) {
        if (startTime === void 0) startTime = $5d3fa3f7dfe2dca0$var$END_OF_TIMES;
        for(var _i = 0, _a = this.entries; _i < _a.length; _i++){
            var entry = _a[_i];
            if (entry.startTime <= startTime) {
                if (startTime <= entry.endTime) return entry.value;
                break;
            }
        }
    };
    /**
     * Helper function to close the currently active value, if any. This method assumes that entries
     * are not overlapping.
     */ ValueHistory.prototype.closeActive = function(endTime) {
        var latestEntry = this.entries[0];
        if (latestEntry && latestEntry.endTime === $5d3fa3f7dfe2dca0$var$END_OF_TIMES) latestEntry.close(endTime);
    };
    /**
     * Return all values with an active period overlapping with the duration,
     * or all values that were active during `startTime` if no duration is provided,
     * or all currently active values if no `startTime` is provided.
     */ ValueHistory.prototype.findAll = function(startTime, duration) {
        if (startTime === void 0) startTime = $5d3fa3f7dfe2dca0$var$END_OF_TIMES;
        if (duration === void 0) duration = 0;
        var endTime = (0, $ly0px.addDuration)(startTime, duration);
        return this.entries.filter(function(entry) {
            return entry.startTime <= endTime && startTime <= entry.endTime;
        }).map(function(entry) {
            return entry.value;
        });
    };
    /**
     * Remove all entries from this collection.
     */ ValueHistory.prototype.reset = function() {
        this.entries = [];
    };
    /**
     * Stop internal garbage collection of past entries.
     */ ValueHistory.prototype.stop = function() {
        (0, $d97UU.clearInterval)(this.clearOldValuesInterval);
    };
    ValueHistory.prototype.clearOldValues = function() {
        var oldTimeThreshold = (0, $ly0px.relativeNow)() - this.expireDelay;
        while(this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold)this.entries.pop();
    };
    return ValueHistory;
}();

});


parcelRegister("gQkiu", function(module, exports) {

$parcel$export(module.exports, "startRequestCollection", () => $c4313f4d150a5ffa$export$254c90b445eb4949);

var $ly0px = parcelRequire("ly0px");
var $lEdKn = parcelRequire("lEdKn");
var $dX7m0 = parcelRequire("dX7m0");
var $4igFP = parcelRequire("4igFP");
var $8yLbx = parcelRequire("8yLbx");

var $fisL9 = parcelRequire("fisL9");

var $3IcTI = parcelRequire("3IcTI");
var $c4313f4d150a5ffa$var$nextRequestIndex = 1;
function $c4313f4d150a5ffa$export$254c90b445eb4949(lifeCycle, configuration, sessionManager) {
    var tracer = (0, $3IcTI.startTracer)(configuration, sessionManager);
    $c4313f4d150a5ffa$export$cbfd392b1e1a167d(lifeCycle, configuration, tracer);
    $c4313f4d150a5ffa$export$2862eaaabb376c8d(lifeCycle, configuration, tracer);
}
function $c4313f4d150a5ffa$export$cbfd392b1e1a167d(lifeCycle, configuration, tracer) {
    var subscription = (0, $dX7m0.initXhrObservable)(configuration).subscribe(function(rawContext) {
        var context = rawContext;
        if (!(0, $fisL9.isAllowedRequestUrl)(configuration, context.url)) return;
        switch(context.state){
            case "start":
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = $c4313f4d150a5ffa$var$getNextRequestIndex();
                lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */ , {
                    requestIndex: context.requestIndex,
                    url: context.url
                });
                break;
            case "complete":
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: "xhr" /* RequestType.XHR */ ,
                    url: context.url,
                    xhr: context.xhr,
                    isAborted: context.isAborted
                });
                break;
        }
    });
    return {
        stop: function() {
            return subscription.unsubscribe();
        }
    };
}
function $c4313f4d150a5ffa$export$2862eaaabb376c8d(lifeCycle, configuration, tracer) {
    var subscription = (0, $lEdKn.initFetchObservable)().subscribe(function(rawContext) {
        var context = rawContext;
        if (!(0, $fisL9.isAllowedRequestUrl)(configuration, context.url)) return;
        switch(context.state){
            case "start":
                tracer.traceFetch(context);
                context.requestIndex = $c4313f4d150a5ffa$var$getNextRequestIndex();
                lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */ , {
                    requestIndex: context.requestIndex,
                    url: context.url
                });
                break;
            case "resolve":
                $c4313f4d150a5ffa$var$waitForResponseToComplete(context, function(duration) {
                    tracer.clearTracingIfNeeded(context);
                    lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , {
                        duration: duration,
                        method: context.method,
                        requestIndex: context.requestIndex,
                        responseType: context.responseType,
                        spanId: context.spanId,
                        startClocks: context.startClocks,
                        status: context.status,
                        traceId: context.traceId,
                        traceSampled: context.traceSampled,
                        type: "fetch" /* RequestType.FETCH */ ,
                        url: context.url,
                        response: context.response,
                        init: context.init,
                        input: context.input,
                        isAborted: context.isAborted
                    });
                });
                break;
        }
    });
    return {
        stop: function() {
            return subscription.unsubscribe();
        }
    };
}
function $c4313f4d150a5ffa$var$getNextRequestIndex() {
    var result = $c4313f4d150a5ffa$var$nextRequestIndex;
    $c4313f4d150a5ffa$var$nextRequestIndex += 1;
    return result;
}
function $c4313f4d150a5ffa$var$waitForResponseToComplete(context, callback) {
    var clonedResponse = context.response && (0, $8yLbx.tryToClone)(context.response);
    if (!clonedResponse || !clonedResponse.body) // do not try to wait for the response if the clone failed, fetch error or null body
    callback((0, $ly0px.elapsed)(context.startClocks.timeStamp, (0, $ly0px.timeStampNow)()));
    else (0, $4igFP.readBytesFromStream)(clonedResponse.body, function() {
        callback((0, $ly0px.elapsed)(context.startClocks.timeStamp, (0, $ly0px.timeStampNow)()));
    }, {
        bytesLimit: Number.POSITIVE_INFINITY,
        collectStreamBody: false
    });
}

});
parcelRegister("lEdKn", function(module, exports) {

$parcel$export(module.exports, "initFetchObservable", () => $fc27ff42b956d16d$export$68d940e9b7f5282c);

var $35a54 = parcelRequire("35a54");

var $2wH3Z = parcelRequire("2wH3Z");

var $4wc1a = parcelRequire("4wc1a");

var $ly0px = parcelRequire("ly0px");

var $bVLiF = parcelRequire("bVLiF");
var $fc27ff42b956d16d$var$fetchObservable;
function $fc27ff42b956d16d$export$68d940e9b7f5282c() {
    if (!$fc27ff42b956d16d$var$fetchObservable) $fc27ff42b956d16d$var$fetchObservable = $fc27ff42b956d16d$var$createFetchObservable();
    return $fc27ff42b956d16d$var$fetchObservable;
}
function $fc27ff42b956d16d$var$createFetchObservable() {
    return new (0, $4wc1a.Observable)(function(observable) {
        if (!window.fetch) return;
        var stop = (0, $35a54.instrumentMethod)(window, "fetch", function(call) {
            return $fc27ff42b956d16d$var$beforeSend(call, observable);
        }).stop;
        return stop;
    });
}
function $fc27ff42b956d16d$var$beforeSend(_a, observable) {
    var parameters = _a.parameters, onPostCall = _a.onPostCall;
    var input = parameters[0], init = parameters[1];
    var methodFromParams = init && init.method;
    if (methodFromParams === undefined && input instanceof Request) methodFromParams = input.method;
    var method = methodFromParams !== undefined ? String(methodFromParams).toUpperCase() : "GET";
    var url = input instanceof Request ? input.url : (0, $bVLiF.normalizeUrl)(String(input));
    var startClocks = (0, $ly0px.clocksNow)();
    var context = {
        state: "start",
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url
    };
    observable.notify(context);
    // Those properties can be changed by observable subscribers
    parameters[0] = context.input;
    parameters[1] = context.init;
    onPostCall(function(responsePromise) {
        return $fc27ff42b956d16d$var$afterSend(observable, responsePromise, context);
    });
}
function $fc27ff42b956d16d$var$afterSend(observable, responsePromise, startContext) {
    var reportFetch = function(response) {
        var context = startContext;
        context.state = "resolve";
        if ("stack" in response || response instanceof Error) {
            context.status = 0;
            context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
            context.error = response;
        } else if ("status" in response) {
            context.response = response;
            context.responseType = response.type;
            context.status = response.status;
            context.isAborted = false;
        }
        observable.notify(context);
    };
    responsePromise.then((0, $2wH3Z.monitor)(reportFetch), (0, $2wH3Z.monitor)(reportFetch));
}

});
parcelRegister("35a54", function(module, exports) {

$parcel$export(module.exports, "instrumentMethod", () => $23e9a88fc9385609$export$f00f71a511cb3cac);
$parcel$export(module.exports, "instrumentSetter", () => $23e9a88fc9385609$export$2a2b9a3e88aa9011);

var $d97UU = parcelRequire("d97UU");

var $2wH3Z = parcelRequire("2wH3Z");

var $aed8w = parcelRequire("aed8w");

var $fkj4Q = parcelRequire("fkj4Q");
function $23e9a88fc9385609$export$f00f71a511cb3cac(targetPrototype, method, onPreCall) {
    var original = targetPrototype[method];
    if (typeof original !== "function") {
        if ((0, $fkj4Q.startsWith)(method, "on")) original = (0, $aed8w.noop);
        else return {
            stop: (0, $aed8w.noop)
        };
    }
    var instrumentation = $23e9a88fc9385609$var$createInstrumentedMethod(original, onPreCall);
    var instrumentationWrapper = function() {
        if (typeof instrumentation !== "function") return undefined;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
        return instrumentation.apply(this, arguments);
    };
    targetPrototype[method] = instrumentationWrapper;
    return {
        stop: function() {
            if (targetPrototype[method] === instrumentationWrapper) targetPrototype[method] = original;
            else instrumentation = original;
        }
    };
}
function $23e9a88fc9385609$var$createInstrumentedMethod(original, onPreCall) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return function() {
        var parameters = (0, $fkj4Q.arrayFrom)(arguments);
        var postCallCallback;
        (0, $2wH3Z.callMonitored)(onPreCall, null, [
            {
                target: this,
                parameters: parameters,
                onPostCall: function(callback) {
                    postCallCallback = callback;
                }
            }
        ]);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        var result = original.apply(this, parameters);
        if (postCallCallback) (0, $2wH3Z.callMonitored)(postCallCallback, null, [
            result
        ]);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return result;
    };
}
function $23e9a88fc9385609$export$2a2b9a3e88aa9011(targetPrototype, property, after) {
    var originalDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) return {
        stop: (0, $aed8w.noop)
    };
    var stoppedInstrumentation = (0, $aed8w.noop);
    var instrumentation = function(target, value) {
        // put hooked setter into event loop to avoid of set latency
        (0, $d97UU.setTimeout)(function() {
            if (instrumentation !== stoppedInstrumentation) after(target, value);
        }, 0);
    };
    var instrumentationWrapper = function(value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(targetPrototype, property, {
        set: instrumentationWrapper
    });
    return {
        stop: function() {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(targetPrototype, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) Object.defineProperty(targetPrototype, property, originalDescriptor);
            instrumentation = stoppedInstrumentation;
        }
    };
}

});


parcelRegister("dX7m0", function(module, exports) {

$parcel$export(module.exports, "initXhrObservable", () => $a2867d5cdff4f776$export$1b29a115c614eaec);

var $35a54 = parcelRequire("35a54");

var $4wc1a = parcelRequire("4wc1a");

var $ly0px = parcelRequire("ly0px");

var $bVLiF = parcelRequire("bVLiF");

var $8PiRA = parcelRequire("8PiRA");

var $hXhfS = parcelRequire("hXhfS");
var $a2867d5cdff4f776$var$xhrObservable;
var $a2867d5cdff4f776$var$xhrContexts = new WeakMap();
function $a2867d5cdff4f776$export$1b29a115c614eaec(configuration) {
    if (!$a2867d5cdff4f776$var$xhrObservable) $a2867d5cdff4f776$var$xhrObservable = $a2867d5cdff4f776$var$createXhrObservable(configuration);
    return $a2867d5cdff4f776$var$xhrObservable;
}
function $a2867d5cdff4f776$var$createXhrObservable(configuration) {
    return new (0, $4wc1a.Observable)(function(observable) {
        var stopInstrumentingStart = (0, $35a54.instrumentMethod)(XMLHttpRequest.prototype, "open", $a2867d5cdff4f776$var$openXhr).stop;
        var stopInstrumentingSend = (0, $35a54.instrumentMethod)(XMLHttpRequest.prototype, "send", function(call) {
            $a2867d5cdff4f776$var$sendXhr(call, configuration, observable);
        }).stop;
        var stopInstrumentingAbort = (0, $35a54.instrumentMethod)(XMLHttpRequest.prototype, "abort", $a2867d5cdff4f776$var$abortXhr).stop;
        return function() {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
}
function $a2867d5cdff4f776$var$openXhr(_a) {
    var xhr = _a.target, _b = _a.parameters, method = _b[0], url = _b[1];
    $a2867d5cdff4f776$var$xhrContexts.set(xhr, {
        state: "open",
        method: String(method).toUpperCase(),
        url: (0, $bVLiF.normalizeUrl)(String(url))
    });
}
function $a2867d5cdff4f776$var$sendXhr(_a, configuration, observable) {
    var xhr = _a.target;
    var context = $a2867d5cdff4f776$var$xhrContexts.get(xhr);
    if (!context) return;
    var startContext = context;
    startContext.state = "start";
    startContext.startClocks = (0, $ly0px.clocksNow)();
    startContext.isAborted = false;
    startContext.xhr = xhr;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = (0, $35a54.instrumentMethod)(xhr, "onreadystatechange", function() {
        if (xhr.readyState === XMLHttpRequest.DONE) // Try to report the XHR as soon as possible, because the XHR may be mutated by the
        // application during a future event. For example, Angular is calling .abort() on
        // completed requests during an onreadystatechange event, so the status becomes '0'
        // before the request is collected.
        onEnd();
    }).stop;
    var onEnd = function() {
        unsubscribeLoadEndListener();
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) return;
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = "complete";
        completeContext.duration = (0, $ly0px.elapsed)(startContext.startClocks.timeStamp, (0, $ly0px.timeStampNow)());
        completeContext.status = xhr.status;
        observable.notify((0, $8PiRA.shallowClone)(completeContext));
    };
    var unsubscribeLoadEndListener = (0, $hXhfS.addEventListener)(configuration, xhr, "loadend", onEnd).stop;
    observable.notify(startContext);
}
function $a2867d5cdff4f776$var$abortXhr(_a) {
    var xhr = _a.target;
    var context = $a2867d5cdff4f776$var$xhrContexts.get(xhr);
    if (context) context.isAborted = true;
}

});

parcelRegister("4igFP", function(module, exports) {

$parcel$export(module.exports, "readBytesFromStream", () => $3205c6e66a2d76d7$export$ecd154de096317dd);

var $2wH3Z = parcelRequire("2wH3Z");

var $aed8w = parcelRequire("aed8w");
function $3205c6e66a2d76d7$export$ecd154de096317dd(stream, callback, options) {
    var reader = stream.getReader();
    var chunks = [];
    var readBytesCount = 0;
    readMore();
    function readMore() {
        reader.read().then((0, $2wH3Z.monitor)(function(result) {
            if (result.done) {
                onDone();
                return;
            }
            if (options.collectStreamBody) chunks.push(result.value);
            readBytesCount += result.value.length;
            if (readBytesCount > options.bytesLimit) onDone();
            else readMore();
        }), (0, $2wH3Z.monitor)(function(error) {
            return callback(error);
        }));
    }
    function onDone() {
        reader.cancel().catch(// we don't care if cancel fails, but we still need to catch the error to avoid reporting it
        // as an unhandled rejection
        (0, $aed8w.noop));
        var bytes;
        var limitExceeded;
        if (options.collectStreamBody) {
            var completeBuffer_1;
            if (chunks.length === 1) // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
            // use it directly.
            completeBuffer_1 = chunks[0];
            else {
                // else, we need to copy buffers into a larger buffer to concatenate them.
                completeBuffer_1 = new Uint8Array(readBytesCount);
                var offset_1 = 0;
                chunks.forEach(function(chunk) {
                    completeBuffer_1.set(chunk, offset_1);
                    offset_1 += chunk.length;
                });
            }
            bytes = completeBuffer_1.slice(0, options.bytesLimit);
            limitExceeded = completeBuffer_1.length > options.bytesLimit;
        }
        callback(undefined, bytes, limitExceeded);
    }
}

});

parcelRegister("8yLbx", function(module, exports) {

$parcel$export(module.exports, "isServerError", () => $63b619b5581ec78b$export$a7cbe72d7c4012af);
$parcel$export(module.exports, "tryToClone", () => $63b619b5581ec78b$export$8a0df03d5faeada4);
function $63b619b5581ec78b$export$a7cbe72d7c4012af(status) {
    return status >= 500;
}
function $63b619b5581ec78b$export$8a0df03d5faeada4(response) {
    try {
        return response.clone();
    } catch (e) {
        // clone can throw if the response has already been used by another instrumentation or is disturbed
        return;
    }
}

});


parcelRegister("bbPM0", function(module, exports) {

$parcel$export(module.exports, "startActionCollection", () => $8258e1e2c7bf35c9$export$195095f773513078);

var $fkj4Q = parcelRequire("fkj4Q");
var $j9iCm = parcelRequire("j9iCm");
var $99fDv = parcelRequire("99fDv");
var $aed8w = parcelRequire("aed8w");
var $ly0px = parcelRequire("ly0px");

var $6L7jR = parcelRequire("6L7jR");
function $8258e1e2c7bf35c9$export$195095f773513078(lifeCycle, domMutationObservable, configuration, pageStateHistory) {
    lifeCycle.subscribe(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */ , function(action) {
        return lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $8258e1e2c7bf35c9$var$processAction(action, pageStateHistory));
    });
    var actionContexts = {
        findActionId: (0, $aed8w.noop)
    };
    if (configuration.trackUserInteractions) actionContexts = (0, $6L7jR.trackClickActions)(lifeCycle, domMutationObservable, configuration).actionContexts;
    return {
        addAction: function(action, savedCommonContext) {
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , (0, $fkj4Q.assign)({
                savedCommonContext: savedCommonContext
            }, $8258e1e2c7bf35c9$var$processAction(action, pageStateHistory)));
        },
        actionContexts: actionContexts
    };
}
function $8258e1e2c7bf35c9$var$processAction(action, pageStateHistory) {
    var autoActionProperties = $8258e1e2c7bf35c9$var$isAutoAction(action) ? {
        action: {
            id: action.id,
            loading_time: (0, $ly0px.toServerDuration)(action.duration),
            frustration: {
                type: action.frustrationTypes
            },
            error: {
                count: action.counts.errorCount
            },
            long_task: {
                count: action.counts.longTaskCount
            },
            resource: {
                count: action.counts.resourceCount
            }
        },
        _dd: {
            action: {
                target: action.target,
                position: action.position
            }
        }
    } : undefined;
    var customerContext = !$8258e1e2c7bf35c9$var$isAutoAction(action) ? action.context : undefined;
    var actionEvent = (0, $j9iCm.combine)({
        action: {
            id: (0, $99fDv.generateUUID)(),
            target: {
                name: action.name
            },
            type: action.type
        },
        date: action.startClocks.timeStamp,
        type: "action" /* RumEventType.ACTION */ ,
        view: {
            in_foreground: pageStateHistory.wasInPageStateAt("active" /* PageState.ACTIVE */ , action.startClocks.relative)
        }
    }, autoActionProperties);
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startClocks.relative,
        domainContext: $8258e1e2c7bf35c9$var$isAutoAction(action) ? {
            events: action.events
        } : {}
    };
}
function $8258e1e2c7bf35c9$var$isAutoAction(action) {
    return action.type !== "custom" /* ActionType.CUSTOM */ ;
}

});
parcelRegister("6L7jR", function(module, exports) {

$parcel$export(module.exports, "trackClickActions", () => $4ebccf53af8f3992$export$ce3e012cf7d342e2);

var $fkj4Q = parcelRequire("fkj4Q");
var $ly0px = parcelRequire("ly0px");
var $99fDv = parcelRequire("99fDv");
var $4wc1a = parcelRequire("4wc1a");
var $80mka = parcelRequire("80mka");

var $WzabW = parcelRequire("WzabW");

var $7oXOv = parcelRequire("7oXOv");

var $l3o7w = parcelRequire("l3o7w");

var $cNHb8 = parcelRequire("cNHb8");

var $2dzye = parcelRequire("2dzye");

var $fVsF7 = parcelRequire("fVsF7");

var $eV1gO = parcelRequire("eV1gO");
var $4ebccf53af8f3992$export$9ecdfc5cb82b78f3 = 10 * (0, $ly0px.ONE_SECOND);
var $4ebccf53af8f3992$export$403157e9fa778fb6 = 5 * (0, $ly0px.ONE_MINUTE); // arbitrary
function $4ebccf53af8f3992$export$ce3e012cf7d342e2(lifeCycle, domMutationObservable, configuration) {
    var history = new (0, $80mka.ValueHistory)($4ebccf53af8f3992$export$403157e9fa778fb6);
    var stopObservable = new (0, $4wc1a.Observable)();
    var currentClickChain;
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , function() {
        history.reset();
    });
    lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */ , stopClickChain);
    var stopActionEventsListener = (0, $fVsF7.listenActionEvents)(configuration, {
        onPointerDown: function(pointerDownEvent) {
            return $4ebccf53af8f3992$var$processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent);
        },
        onPointerUp: function(_a, startEvent, getUserActivity) {
            var clickActionBase = _a.clickActionBase, hadActivityOnPointerDown = _a.hadActivityOnPointerDown;
            return $4ebccf53af8f3992$var$startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
        }
    }).stop;
    var actionContexts = {
        findActionId: function(startTime) {
            return history.findAll(startTime);
        }
    };
    return {
        stop: function() {
            stopClickChain();
            stopObservable.notify();
            stopActionEventsListener();
        },
        actionContexts: actionContexts
    };
    function appendClickToClickChain(click) {
        if (!currentClickChain || !currentClickChain.tryAppend(click)) {
            var rageClick_1 = click.clone();
            currentClickChain = (0, $cNHb8.createClickChain)(click, function(clicks) {
                $4ebccf53af8f3992$export$4e2c2102bb4a32e4(clicks, rageClick_1);
            });
        }
    }
    function stopClickChain() {
        if (currentClickChain) currentClickChain.stop();
    }
}
function $4ebccf53af8f3992$var$processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent) {
    var clickActionBase = $4ebccf53af8f3992$var$computeClickActionBase(pointerDownEvent, configuration.actionNameAttribute);
    var hadActivityOnPointerDown = false;
    (0, $7oXOv.waitPageActivityEnd)(lifeCycle, domMutationObservable, configuration, function(pageActivityEndEvent) {
        hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
    }, // We don't care about the activity duration, we just want to know whether an activity did happen
    // within the "validation delay" or not. Limit the duration so the callback is called sooner.
    (0, $7oXOv.PAGE_ACTIVITY_VALIDATION_DELAY));
    return {
        clickActionBase: clickActionBase,
        hadActivityOnPointerDown: function() {
            return hadActivityOnPointerDown;
        }
    };
}
function $4ebccf53af8f3992$var$startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
    var click = $4ebccf53af8f3992$var$newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
    appendClickToClickChain(click);
    var stopWaitPageActivityEnd = (0, $7oXOv.waitPageActivityEnd)(lifeCycle, domMutationObservable, configuration, function(pageActivityEndEvent) {
        if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) // If the clock is looking weird, just discard the click
        click.discard();
        else {
            if (pageActivityEndEvent.hadActivity) click.stop(pageActivityEndEvent.end);
            else if (hadActivityOnPointerDown()) click.stop(// using the click start as activity end, so the click will have some activity but its
            // duration will be 0 (as the activity started before the click start)
            click.startClocks.timeStamp);
            else click.stop();
        }
    }, $4ebccf53af8f3992$export$9ecdfc5cb82b78f3).stop;
    var viewEndedSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */ , function(_a) {
        var endClocks = _a.endClocks;
        click.stop(endClocks.timeStamp);
    });
    var stopSubscription = stopObservable.subscribe(function() {
        click.stop();
    });
    click.stopObservable.subscribe(function() {
        viewEndedSubscription.unsubscribe();
        stopWaitPageActivityEnd();
        stopSubscription.unsubscribe();
    });
}
function $4ebccf53af8f3992$var$computeClickActionBase(event, actionNameAttribute) {
    var rect = event.target.getBoundingClientRect();
    return {
        type: "click" /* ActionType.CLICK */ ,
        target: {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            selector: (0, $l3o7w.getSelectorFromElement)(event.target, actionNameAttribute)
        },
        position: {
            // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
            x: Math.round(event.clientX - rect.left),
            y: Math.round(event.clientY - rect.top)
        },
        name: (0, $2dzye.getActionNameFromElement)(event.target, actionNameAttribute)
    };
}
function $4ebccf53af8f3992$var$newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent) {
    var id = (0, $99fDv.generateUUID)();
    var startClocks = (0, $ly0px.clocksNow)();
    var historyEntry = history.add(id, startClocks.relative);
    var eventCountsSubscription = (0, $WzabW.trackEventCounts)({
        lifeCycle: lifeCycle,
        isChildEvent: function(event) {
            return event.action !== undefined && (Array.isArray(event.action.id) ? (0, $fkj4Q.includes)(event.action.id, id) : event.action.id === id);
        }
    });
    var status = 0 /* ClickStatus.ONGOING */ ;
    var activityEndTime;
    var frustrationTypes = [];
    var stopObservable = new (0, $4wc1a.Observable)();
    function stop(newActivityEndTime) {
        if (status !== 0 /* ClickStatus.ONGOING */ ) return;
        activityEndTime = newActivityEndTime;
        status = 1 /* ClickStatus.STOPPED */ ;
        if (activityEndTime) historyEntry.close((0, $ly0px.getRelativeTime)(activityEndTime));
        else historyEntry.remove();
        eventCountsSubscription.stop();
        stopObservable.notify();
    }
    return {
        event: startEvent,
        stop: stop,
        stopObservable: stopObservable,
        get hasError () {
            return eventCountsSubscription.eventCounts.errorCount > 0;
        },
        get hasPageActivity () {
            return activityEndTime !== undefined;
        },
        getUserActivity: getUserActivity,
        addFrustration: function(frustrationType) {
            frustrationTypes.push(frustrationType);
        },
        startClocks: startClocks,
        isStopped: function() {
            return status === 1 /* ClickStatus.STOPPED */  || status === 2 /* ClickStatus.FINALIZED */ ;
        },
        clone: function() {
            return $4ebccf53af8f3992$var$newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
        },
        validate: function(domEvents) {
            stop();
            if (status !== 1 /* ClickStatus.STOPPED */ ) return;
            var _a = eventCountsSubscription.eventCounts, resourceCount = _a.resourceCount, errorCount = _a.errorCount, longTaskCount = _a.longTaskCount;
            var clickAction = (0, $fkj4Q.assign)({
                type: "click" /* ActionType.CLICK */ ,
                duration: activityEndTime && (0, $ly0px.elapsed)(startClocks.timeStamp, activityEndTime),
                startClocks: startClocks,
                id: id,
                frustrationTypes: frustrationTypes,
                counts: {
                    resourceCount: resourceCount,
                    errorCount: errorCount,
                    longTaskCount: longTaskCount
                },
                events: domEvents !== null && domEvents !== void 0 ? domEvents : [
                    startEvent
                ],
                event: startEvent
            }, clickActionBase);
            lifeCycle.notify(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */ , clickAction);
            status = 2 /* ClickStatus.FINALIZED */ ;
        },
        discard: function() {
            stop();
            status = 2 /* ClickStatus.FINALIZED */ ;
        }
    };
}
function $4ebccf53af8f3992$export$4e2c2102bb4a32e4(clicks, rageClick) {
    var isRage = (0, $eV1gO.computeFrustration)(clicks, rageClick).isRage;
    if (isRage) {
        clicks.forEach(function(click) {
            return click.discard();
        });
        rageClick.stop((0, $ly0px.timeStampNow)());
        rageClick.validate(clicks.map(function(click) {
            return click.event;
        }));
    } else {
        rageClick.discard();
        clicks.forEach(function(click) {
            return click.validate();
        });
    }
}

});
parcelRegister("WzabW", function(module, exports) {

$parcel$export(module.exports, "trackEventCounts", () => $0b00b19bfaa2355c$export$a50549f6fbbed49b);

var $aed8w = parcelRequire("aed8w");
function $0b00b19bfaa2355c$export$a50549f6fbbed49b(_a) {
    var lifeCycle = _a.lifeCycle, isChildEvent = _a.isChildEvent, _b = _a.onChange, callback = _b === void 0 ? (0, $aed8w.noop) : _b;
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        actionCount: 0,
        frustrationCount: 0
    };
    var subscription = lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , function(event) {
        var _a;
        if (event.type === "view" || event.type === "vital" || !isChildEvent(event)) return;
        switch(event.type){
            case "error" /* RumEventType.ERROR */ :
                eventCounts.errorCount += 1;
                callback();
                break;
            case "action" /* RumEventType.ACTION */ :
                eventCounts.actionCount += 1;
                if (event.action.frustration) eventCounts.frustrationCount += event.action.frustration.type.length;
                callback();
                break;
            case "long_task" /* RumEventType.LONG_TASK */ :
                eventCounts.longTaskCount += 1;
                callback();
                break;
            case "resource" /* RumEventType.RESOURCE */ :
                if (!((_a = event._dd) === null || _a === void 0 ? void 0 : _a.discarded)) {
                    eventCounts.resourceCount += 1;
                    callback();
                }
                break;
        }
    });
    return {
        stop: function() {
            subscription.unsubscribe();
        },
        eventCounts: eventCounts
    };
}

});

parcelRegister("7oXOv", function(module, exports) {

$parcel$export(module.exports, "PAGE_ACTIVITY_VALIDATION_DELAY", () => $56392c0d6d718cf0$export$a59477b089b98865);
$parcel$export(module.exports, "waitPageActivityEnd", () => $56392c0d6d718cf0$export$4a886e0e421b0302);

var $d97UU = parcelRequire("d97UU");
var $35a54 = parcelRequire("35a54");
var $fzLbJ = parcelRequire("fzLbJ");
var $2wH3Z = parcelRequire("2wH3Z");
var $4wc1a = parcelRequire("4wc1a");
var $ly0px = parcelRequire("ly0px");

var $iSyQp = parcelRequire("iSyQp");
var $56392c0d6d718cf0$export$a59477b089b98865 = 100;
var $56392c0d6d718cf0$export$daa5d178ead00ab = 100;
function $56392c0d6d718cf0$export$4a886e0e421b0302(lifeCycle, domMutationObservable, configuration, pageActivityEndCallback, maxDuration) {
    var pageActivityObservable = $56392c0d6d718cf0$export$48867124286069d5(lifeCycle, domMutationObservable, configuration);
    return $56392c0d6d718cf0$export$580daaeb5ddf2e92(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
function $56392c0d6d718cf0$export$580daaeb5ddf2e92(pageActivityObservable, pageActivityEndCallback, maxDuration) {
    var pageActivityEndTimeoutId;
    var hasCompleted = false;
    var validationTimeoutId = (0, $d97UU.setTimeout)((0, $2wH3Z.monitor)(function() {
        return complete({
            hadActivity: false
        });
    }), $56392c0d6d718cf0$export$a59477b089b98865);
    var maxDurationTimeoutId = maxDuration !== undefined ? (0, $d97UU.setTimeout)((0, $2wH3Z.monitor)(function() {
        return complete({
            hadActivity: true,
            end: (0, $ly0px.timeStampNow)()
        });
    }), maxDuration) : undefined;
    var pageActivitySubscription = pageActivityObservable.subscribe(function(_a) {
        var isBusy = _a.isBusy;
        (0, $d97UU.clearTimeout)(validationTimeoutId);
        (0, $d97UU.clearTimeout)(pageActivityEndTimeoutId);
        var lastChangeTime = (0, $ly0px.timeStampNow)();
        if (!isBusy) pageActivityEndTimeoutId = (0, $d97UU.setTimeout)((0, $2wH3Z.monitor)(function() {
            return complete({
                hadActivity: true,
                end: lastChangeTime
            });
        }), $56392c0d6d718cf0$export$daa5d178ead00ab);
    });
    var stop = function() {
        hasCompleted = true;
        (0, $d97UU.clearTimeout)(validationTimeoutId);
        (0, $d97UU.clearTimeout)(pageActivityEndTimeoutId);
        (0, $d97UU.clearTimeout)(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) return;
        stop();
        pageActivityEndCallback(event);
    }
    return {
        stop: stop
    };
}
function $56392c0d6d718cf0$export$48867124286069d5(lifeCycle, domMutationObservable, configuration) {
    return new (0, $4wc1a.Observable)(function(observable) {
        var subscriptions = [];
        var firstRequestIndex;
        var pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe(notifyPageActivity), lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */ , function(entries) {
            if (entries.some(function(entry) {
                return entry.entryType === (0, $iSyQp.RumPerformanceEntryType).RESOURCE && !$56392c0d6d718cf0$var$isExcludedUrl(configuration, entry.name);
            })) notifyPageActivity();
        }), lifeCycle.subscribe(7 /* LifeCycleEventType.REQUEST_STARTED */ , function(startEvent) {
            if ($56392c0d6d718cf0$var$isExcludedUrl(configuration, startEvent.url)) return;
            if (firstRequestIndex === undefined) firstRequestIndex = startEvent.requestIndex;
            pendingRequestsCount += 1;
            notifyPageActivity();
        }), lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , function(request) {
            if ($56392c0d6d718cf0$var$isExcludedUrl(configuration, request.url) || firstRequestIndex === undefined || // If the request started before the tracking start, ignore it
            request.requestIndex < firstRequestIndex) return;
            pendingRequestsCount -= 1;
            notifyPageActivity();
        }));
        var stopTrackingWindowOpen = $56392c0d6d718cf0$var$trackWindowOpen(notifyPageActivity).stop;
        return function() {
            stopTrackingWindowOpen();
            subscriptions.forEach(function(s) {
                return s.unsubscribe();
            });
        };
        function notifyPageActivity() {
            observable.notify({
                isBusy: pendingRequestsCount > 0
            });
        }
    });
}
function $56392c0d6d718cf0$var$isExcludedUrl(configuration, requestUrl) {
    return (0, $fzLbJ.matchList)(configuration.excludedActivityUrls, requestUrl);
}
function $56392c0d6d718cf0$var$trackWindowOpen(callback) {
    return (0, $35a54.instrumentMethod)(window, "open", callback);
}

});

parcelRegister("l3o7w", function(module, exports) {

$parcel$export(module.exports, "STABLE_ATTRIBUTES", () => $f53c969915647662$export$4ab9e1b4853d6dd7);
$parcel$export(module.exports, "getSelectorFromElement", () => $f53c969915647662$export$2a298c6a007e5e40);

var $iznpK = parcelRequire("iznpK");

var $2dzye = parcelRequire("2dzye");
var $f53c969915647662$export$4ab9e1b4853d6dd7 = [
    (0, $2dzye.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE),
    // Common test attributes (list provided by google recorder)
    "data-testid",
    "data-test",
    "data-qa",
    "data-cy",
    "data-test-id",
    "data-qa-id",
    "data-testing",
    // FullStory decorator attributes:
    "data-component",
    "data-element",
    "data-source-file"
];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
var $f53c969915647662$var$GLOBALLY_UNIQUE_SELECTOR_GETTERS = [
    $f53c969915647662$var$getStableAttributeSelector,
    $f53c969915647662$var$getIDSelector
];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
var $f53c969915647662$var$UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [
    $f53c969915647662$var$getStableAttributeSelector,
    $f53c969915647662$var$getClassSelector,
    $f53c969915647662$var$getTagNameSelector
];
function $f53c969915647662$export$2a298c6a007e5e40(targetElement, actionNameAttribute) {
    var targetElementSelector = "";
    var element = targetElement;
    while(element && element.nodeName !== "HTML"){
        var globallyUniqueSelector = $f53c969915647662$var$findSelector(element, $f53c969915647662$var$GLOBALLY_UNIQUE_SELECTOR_GETTERS, $f53c969915647662$var$isSelectorUniqueGlobally, actionNameAttribute, targetElementSelector);
        if (globallyUniqueSelector) return globallyUniqueSelector;
        var uniqueSelectorAmongChildren = $f53c969915647662$var$findSelector(element, $f53c969915647662$var$UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, $f53c969915647662$var$isSelectorUniqueAmongSiblings, actionNameAttribute, targetElementSelector);
        targetElementSelector = uniqueSelectorAmongChildren || $f53c969915647662$var$combineSelector($f53c969915647662$var$getPositionSelector(element), targetElementSelector);
        element = (0, $iznpK.getParentElement)(element);
    }
    return targetElementSelector;
}
function $f53c969915647662$var$isGeneratedValue(value) {
    // To compute the "URL path group", the backend replaces every URL path parts as a question mark
    // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
    // present.
    //
    // Here, we use the same strategy: if a the value contains a digit, we consider it generated. This
    // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
    // CSS selectors so it should be fine most of the time. We might want to allow customers to
    // provide their own `isGeneratedValue` at some point.
    return /[0-9]/.test(value);
}
function $f53c969915647662$var$getIDSelector(element) {
    if (element.id && !$f53c969915647662$var$isGeneratedValue(element.id)) return "#".concat((0, $iznpK.cssEscape)(element.id));
}
function $f53c969915647662$var$getClassSelector(element) {
    if (element.tagName === "BODY") return;
    var classList = (0, $iznpK.getClassList)(element);
    for(var i = 0; i < classList.length; i += 1){
        var className = classList[i];
        if ($f53c969915647662$var$isGeneratedValue(className)) continue;
        return "".concat((0, $iznpK.cssEscape)(element.tagName), ".").concat((0, $iznpK.cssEscape)(className));
    }
}
function $f53c969915647662$var$getTagNameSelector(element) {
    return (0, $iznpK.cssEscape)(element.tagName);
}
function $f53c969915647662$var$getStableAttributeSelector(element, actionNameAttribute) {
    if (actionNameAttribute) {
        var selector = getAttributeSelector(actionNameAttribute);
        if (selector) return selector;
    }
    for(var _i = 0, STABLE_ATTRIBUTES_1 = $f53c969915647662$export$4ab9e1b4853d6dd7; _i < STABLE_ATTRIBUTES_1.length; _i++){
        var attributeName = STABLE_ATTRIBUTES_1[_i];
        var selector = getAttributeSelector(attributeName);
        if (selector) return selector;
    }
    function getAttributeSelector(attributeName) {
        if (element.hasAttribute(attributeName)) return "".concat((0, $iznpK.cssEscape)(element.tagName), "[").concat(attributeName, '="').concat((0, $iznpK.cssEscape)(element.getAttribute(attributeName)), '"]');
    }
}
function $f53c969915647662$var$getPositionSelector(element) {
    var sibling = (0, $iznpK.getParentElement)(element).firstElementChild;
    var elementIndex = 1;
    while(sibling && sibling !== element){
        if (sibling.tagName === element.tagName) elementIndex += 1;
        sibling = sibling.nextElementSibling;
    }
    return "".concat((0, $iznpK.cssEscape)(element.tagName), ":nth-of-type(").concat(elementIndex, ")");
}
function $f53c969915647662$var$findSelector(element, selectorGetters, predicate, actionNameAttribute, childSelector) {
    for(var _i = 0, selectorGetters_1 = selectorGetters; _i < selectorGetters_1.length; _i++){
        var selectorGetter = selectorGetters_1[_i];
        var elementSelector = selectorGetter(element, actionNameAttribute);
        if (!elementSelector) continue;
        var fullSelector = $f53c969915647662$var$combineSelector(elementSelector, childSelector);
        if (predicate(element, fullSelector)) return fullSelector;
    }
}
/**
 * Check whether the selector is unique among the whole document.
 */ function $f53c969915647662$var$isSelectorUniqueGlobally(element, selector) {
    return element.ownerDocument.querySelectorAll(selector).length === 1;
}
/**
 * Check whether the selector is unique among the element siblings. In other words, it returns true
 * if "ELEMENT_PARENT > SELECTOR" returns a single element.
 *
 * The result will be less accurate on browsers that don't support :scope (i. e. IE): it will check
 * for any element matching the selector contained in the parent (in other words,
 * "ELEMENT_PARENT SELECTOR" returns a single element), regardless of whether the selector is a
 * direct descendent of the element parent. This should not impact results too much: if it
 * inaccurately returns false, we'll just fall back to another strategy.
 */ function $f53c969915647662$var$isSelectorUniqueAmongSiblings(element, selector) {
    return (0, $iznpK.getParentElement)(element).querySelectorAll($f53c969915647662$export$619938c02511e63c() ? $f53c969915647662$var$combineSelector(":scope", selector) : selector).length === 1;
}
function $f53c969915647662$var$combineSelector(parent, child) {
    return child ? "".concat(parent, ">").concat(child) : parent;
}
var $f53c969915647662$var$supportScopeSelectorCache;
function $f53c969915647662$export$619938c02511e63c() {
    if ($f53c969915647662$var$supportScopeSelectorCache === undefined) try {
        document.querySelector(":scope");
        $f53c969915647662$var$supportScopeSelectorCache = true;
    } catch (_a) {
        $f53c969915647662$var$supportScopeSelectorCache = false;
    }
    return $f53c969915647662$var$supportScopeSelectorCache;
}

});
parcelRegister("iznpK", function(module, exports) {

$parcel$export(module.exports, "cssEscape", () => $d84da87a5bdc7a20$export$a5d1f61e0bd5c403);
$parcel$export(module.exports, "elementMatches", () => $d84da87a5bdc7a20$export$c33a404b21a1fad3);
$parcel$export(module.exports, "getParentElement", () => $d84da87a5bdc7a20$export$169e5491001d3ed6);
$parcel$export(module.exports, "getClassList", () => $d84da87a5bdc7a20$export$4b3def1d4726a17a);
// https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/selector/escapeSelector.js
function $d84da87a5bdc7a20$export$a5d1f61e0bd5c403(str) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(str);
    // eslint-disable-next-line no-control-regex
    return str.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return "".concat(ch.slice(0, -1), "\\").concat(ch.charCodeAt(ch.length - 1).toString(16), " ");
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\".concat(ch);
    });
}
function $d84da87a5bdc7a20$export$c33a404b21a1fad3(element, selector) {
    if (element.matches) return element.matches(selector);
    // IE11 support
    if (element.msMatchesSelector) return element.msMatchesSelector(selector);
    return false;
}
function $d84da87a5bdc7a20$export$169e5491001d3ed6(node) {
    if (node.parentElement) return node.parentElement;
    while(node.parentNode){
        if (node.parentNode.nodeType === Node.ELEMENT_NODE) return node.parentNode;
        node = node.parentNode;
    }
    return null;
}
function $d84da87a5bdc7a20$export$4b3def1d4726a17a(element) {
    var _a;
    if (element.classList) return element.classList;
    var classes = (_a = element.getAttribute("class")) === null || _a === void 0 ? void 0 : _a.trim();
    return classes ? classes.split(/\s+/) : [];
}

});

parcelRegister("2dzye", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE", () => $19d85f6358de8c0d$export$e3a045a56698d3f9);
$parcel$export(module.exports, "getActionNameFromElement", () => $19d85f6358de8c0d$export$9c46f8d96b9f088f);

var $fkj4Q = parcelRequire("fkj4Q");
var $5h91O = parcelRequire("5h91O");
var $99fDv = parcelRequire("99fDv");

var $iznpK = parcelRequire("iznpK");
var $19d85f6358de8c0d$export$e3a045a56698d3f9 = "data-dd-action-name";
function $19d85f6358de8c0d$export$9c46f8d96b9f088f(element, userProgrammaticAttribute) {
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, use strategies that are known to return good results. Those strategies will be used on
    //   the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    return $19d85f6358de8c0d$var$getActionNameFromElementProgrammatically(element, $19d85f6358de8c0d$export$e3a045a56698d3f9) || userProgrammaticAttribute && $19d85f6358de8c0d$var$getActionNameFromElementProgrammatically(element, userProgrammaticAttribute) || $19d85f6358de8c0d$var$getActionNameFromElementForStrategies(element, userProgrammaticAttribute, $19d85f6358de8c0d$var$priorityStrategies) || $19d85f6358de8c0d$var$getActionNameFromElementForStrategies(element, userProgrammaticAttribute, $19d85f6358de8c0d$var$fallbackStrategies) || "";
}
function $19d85f6358de8c0d$var$getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    var elementWithAttribute;
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    // If available, use element.closest() to match get the attribute from the element or any of its
    // parent.  Else fallback to a more traditional implementation.
    if ($19d85f6358de8c0d$var$supportsElementClosest()) elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
    else {
        var element = targetElement;
        while(element){
            if (element.hasAttribute(programmaticAttribute)) {
                elementWithAttribute = element;
                break;
            }
            element = (0, $iznpK.getParentElement)(element);
        }
    }
    if (!elementWithAttribute) return;
    var name = elementWithAttribute.getAttribute(programmaticAttribute);
    return $19d85f6358de8c0d$var$truncate($19d85f6358de8c0d$var$normalizeWhitespace(name.trim()));
}
var $19d85f6358de8c0d$var$priorityStrategies = [
    // associated LABEL text
    function(element, userProgrammaticAttribute) {
        // IE does not support element.labels, so we fallback to a CSS selector based on the element id
        // instead
        if ($19d85f6358de8c0d$var$supportsLabelProperty()) {
            if ("labels" in element && element.labels && element.labels.length > 0) return $19d85f6358de8c0d$var$getTextualContent(element.labels[0], userProgrammaticAttribute);
        } else if (element.id) {
            var label = element.ownerDocument && (0, $fkj4Q.find)(element.ownerDocument.querySelectorAll("label"), function(label) {
                return label.htmlFor === element.id;
            });
            return label && $19d85f6358de8c0d$var$getTextualContent(label, userProgrammaticAttribute);
        }
    },
    // INPUT button (and associated) value
    function(element) {
        if (element.nodeName === "INPUT") {
            var input = element;
            var type = input.getAttribute("type");
            if (type === "button" || type === "submit" || type === "reset") return input.value;
        }
    },
    // BUTTON, LABEL or button-like element text
    function(element, userProgrammaticAttribute) {
        if (element.nodeName === "BUTTON" || element.nodeName === "LABEL" || element.getAttribute("role") === "button") return $19d85f6358de8c0d$var$getTextualContent(element, userProgrammaticAttribute);
    },
    function(element) {
        return element.getAttribute("aria-label");
    },
    // associated element text designated by the aria-labelledby attribute
    function(element, userProgrammaticAttribute) {
        var labelledByAttribute = element.getAttribute("aria-labelledby");
        if (labelledByAttribute) return labelledByAttribute.split(/\s+/).map(function(id) {
            return $19d85f6358de8c0d$var$getElementById(element, id);
        }).filter(function(label) {
            return Boolean(label);
        }).map(function(element) {
            return $19d85f6358de8c0d$var$getTextualContent(element, userProgrammaticAttribute);
        }).join(" ");
    },
    function(element) {
        return element.getAttribute("alt");
    },
    function(element) {
        return element.getAttribute("name");
    },
    function(element) {
        return element.getAttribute("title");
    },
    function(element) {
        return element.getAttribute("placeholder");
    },
    // SELECT first OPTION text
    function(element, userProgrammaticAttribute) {
        if ("options" in element && element.options.length > 0) return $19d85f6358de8c0d$var$getTextualContent(element.options[0], userProgrammaticAttribute);
    }
];
var $19d85f6358de8c0d$var$fallbackStrategies = [
    function(element, userProgrammaticAttribute) {
        return $19d85f6358de8c0d$var$getTextualContent(element, userProgrammaticAttribute);
    }
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */ var $19d85f6358de8c0d$var$MAX_PARENTS_TO_CONSIDER = 10;
function $19d85f6358de8c0d$var$getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies) {
    var element = targetElement;
    var recursionCounter = 0;
    while(recursionCounter <= $19d85f6358de8c0d$var$MAX_PARENTS_TO_CONSIDER && element && element.nodeName !== "BODY" && element.nodeName !== "HTML" && element.nodeName !== "HEAD"){
        for(var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++){
            var strategy = strategies_1[_i];
            var name_1 = strategy(element, userProgrammaticAttribute);
            if (typeof name_1 === "string") {
                var trimmedName = name_1.trim();
                if (trimmedName) return $19d85f6358de8c0d$var$truncate($19d85f6358de8c0d$var$normalizeWhitespace(trimmedName));
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === "FORM") break;
        element = (0, $iznpK.getParentElement)(element);
        recursionCounter += 1;
    }
}
function $19d85f6358de8c0d$var$normalizeWhitespace(s) {
    return s.replace(/\s+/g, " ");
}
function $19d85f6358de8c0d$var$truncate(s) {
    return s.length > 100 ? "".concat((0, $99fDv.safeTruncate)(s, 100), " [...]") : s;
}
function $19d85f6358de8c0d$var$getElementById(refElement, id) {
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function $19d85f6358de8c0d$var$getTextualContent(element, userProgrammaticAttribute) {
    if (element.isContentEditable) return;
    if ("innerText" in element) {
        var text_1 = element.innerText;
        var removeTextFromElements = function(query) {
            var list = element.querySelectorAll(query);
            for(var index = 0; index < list.length; index += 1){
                var element_1 = list[index];
                if ("innerText" in element_1) {
                    var textToReplace = element_1.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) text_1 = text_1.replace(textToReplace, "");
                }
            }
        };
        if (!$19d85f6358de8c0d$var$supportsInnerTextScriptAndStyleRemoval()) // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
        // be relatively fast and work in most cases.
        removeTextFromElements("script, style");
        // remove the text of elements with programmatic attribute value
        removeTextFromElements("[".concat($19d85f6358de8c0d$export$e3a045a56698d3f9, "]"));
        if (userProgrammaticAttribute) removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
        return text_1;
    }
    return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */ function $19d85f6358de8c0d$var$supportsInnerTextScriptAndStyleRemoval() {
    return !(0, $5h91O.isIE)();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */ var $19d85f6358de8c0d$var$supportsLabelPropertyResult;
function $19d85f6358de8c0d$var$supportsLabelProperty() {
    if ($19d85f6358de8c0d$var$supportsLabelPropertyResult === undefined) $19d85f6358de8c0d$var$supportsLabelPropertyResult = "labels" in HTMLInputElement.prototype;
    return $19d85f6358de8c0d$var$supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */ var $19d85f6358de8c0d$var$supportsElementClosestResult;
function $19d85f6358de8c0d$var$supportsElementClosest() {
    if ($19d85f6358de8c0d$var$supportsElementClosestResult === undefined) $19d85f6358de8c0d$var$supportsElementClosestResult = "closest" in HTMLElement.prototype;
    return $19d85f6358de8c0d$var$supportsElementClosestResult;
}

});


parcelRegister("cNHb8", function(module, exports) {

$parcel$export(module.exports, "createClickChain", () => $951b8e01832faf5b$export$864c62f6b0bc947);

var $d97UU = parcelRequire("d97UU");
var $ly0px = parcelRequire("ly0px");
var $951b8e01832faf5b$export$1505b1def7b874c6 = (0, $ly0px.ONE_SECOND);
var $951b8e01832faf5b$export$30c5966f4862d434 = 100;
function $951b8e01832faf5b$export$864c62f6b0bc947(firstClick, onFinalize) {
    var bufferedClicks = [];
    var status = 0 /* ClickChainStatus.WaitingForMoreClicks */ ;
    var maxDurationBetweenClicksTimeoutId;
    appendClick(firstClick);
    function appendClick(click) {
        click.stopObservable.subscribe(tryFinalize);
        bufferedClicks.push(click);
        (0, $d97UU.clearTimeout)(maxDurationBetweenClicksTimeoutId);
        maxDurationBetweenClicksTimeoutId = (0, $d97UU.setTimeout)(dontAcceptMoreClick, $951b8e01832faf5b$export$1505b1def7b874c6);
    }
    function tryFinalize() {
        if (status === 1 /* ClickChainStatus.WaitingForClicksToStop */  && bufferedClicks.every(function(click) {
            return click.isStopped();
        })) {
            status = 2 /* ClickChainStatus.Finalized */ ;
            onFinalize(bufferedClicks);
        }
    }
    function dontAcceptMoreClick() {
        (0, $d97UU.clearTimeout)(maxDurationBetweenClicksTimeoutId);
        if (status === 0 /* ClickChainStatus.WaitingForMoreClicks */ ) {
            status = 1 /* ClickChainStatus.WaitingForClicksToStop */ ;
            tryFinalize();
        }
    }
    return {
        tryAppend: function(click) {
            if (status !== 0 /* ClickChainStatus.WaitingForMoreClicks */ ) return false;
            if (bufferedClicks.length > 0 && !$951b8e01832faf5b$var$areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
                dontAcceptMoreClick();
                return false;
            }
            appendClick(click);
            return true;
        },
        stop: function() {
            dontAcceptMoreClick();
        }
    };
}
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */ function $951b8e01832faf5b$var$areEventsSimilar(first, second) {
    return first.target === second.target && $951b8e01832faf5b$var$mouseEventDistance(first, second) <= $951b8e01832faf5b$export$30c5966f4862d434 && first.timeStamp - second.timeStamp <= $951b8e01832faf5b$export$1505b1def7b874c6;
}
function $951b8e01832faf5b$var$mouseEventDistance(origin, other) {
    return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}

});

parcelRegister("fVsF7", function(module, exports) {

$parcel$export(module.exports, "listenActionEvents", () => $b9826997efb4807d$export$8c9c528e477216a0);

var $hXhfS = parcelRequire("hXhfS");
function $b9826997efb4807d$export$8c9c528e477216a0(configuration, _a) {
    var onPointerDown = _a.onPointerDown, onPointerUp = _a.onPointerUp;
    var selectionEmptyAtPointerDown;
    var userActivity = {
        selection: false,
        input: false,
        scroll: false
    };
    var clickContext;
    var listeners = [
        (0, $hXhfS.addEventListener)(configuration, window, (0, $hXhfS.DOM_EVENT).POINTER_DOWN, function(event) {
            if ($b9826997efb4807d$var$isValidPointerEvent(event)) {
                selectionEmptyAtPointerDown = $b9826997efb4807d$var$isSelectionEmpty();
                userActivity = {
                    selection: false,
                    input: false,
                    scroll: false
                };
                clickContext = onPointerDown(event);
            }
        }, {
            capture: true
        }),
        (0, $hXhfS.addEventListener)(configuration, window, (0, $hXhfS.DOM_EVENT).SELECTION_CHANGE, function() {
            if (!selectionEmptyAtPointerDown || !$b9826997efb4807d$var$isSelectionEmpty()) userActivity.selection = true;
        }, {
            capture: true
        }),
        (0, $hXhfS.addEventListener)(configuration, window, (0, $hXhfS.DOM_EVENT).SCROLL, function() {
            userActivity.scroll = true;
        }, {
            capture: true,
            passive: true
        }),
        (0, $hXhfS.addEventListener)(configuration, window, (0, $hXhfS.DOM_EVENT).POINTER_UP, function(event) {
            if ($b9826997efb4807d$var$isValidPointerEvent(event) && clickContext) {
                // Use a scoped variable to make sure the value is not changed by other clicks
                var localUserActivity_1 = userActivity;
                onPointerUp(clickContext, event, function() {
                    return localUserActivity_1;
                });
                clickContext = undefined;
            }
        }, {
            capture: true
        }),
        (0, $hXhfS.addEventListener)(configuration, window, (0, $hXhfS.DOM_EVENT).INPUT, function() {
            userActivity.input = true;
        }, {
            capture: true
        })
    ];
    return {
        stop: function() {
            listeners.forEach(function(listener) {
                return listener.stop();
            });
        }
    };
}
function $b9826997efb4807d$var$isSelectionEmpty() {
    var selection = window.getSelection();
    return !selection || selection.isCollapsed;
}
function $b9826997efb4807d$var$isValidPointerEvent(event) {
    return event.target instanceof Element && // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
    // the future.
    event.isPrimary !== false;
}

});

parcelRegister("eV1gO", function(module, exports) {

$parcel$export(module.exports, "computeFrustration", () => $adc75fc4cdc76a78$export$bd2d8b95c6d3b36c);

var $ly0px = parcelRequire("ly0px");

var $iznpK = parcelRequire("iznpK");
var $adc75fc4cdc76a78$var$MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function $adc75fc4cdc76a78$export$bd2d8b95c6d3b36c(clicks, rageClick) {
    if ($adc75fc4cdc76a78$export$225704fb2a185e45(clicks)) {
        rageClick.addFrustration("rage_click" /* FrustrationType.RAGE_CLICK */ );
        if (clicks.some($adc75fc4cdc76a78$export$e4a368a4d2e950a3)) rageClick.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */ );
        if (rageClick.hasError) rageClick.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */ );
        return {
            isRage: true
        };
    }
    var hasSelectionChanged = clicks.some(function(click) {
        return click.getUserActivity().selection;
    });
    clicks.forEach(function(click) {
        if (click.hasError) click.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */ );
        if ($adc75fc4cdc76a78$export$e4a368a4d2e950a3(click) && // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
        !hasSelectionChanged) click.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */ );
    });
    return {
        isRage: false
    };
}
function $adc75fc4cdc76a78$export$225704fb2a185e45(clicks) {
    if (clicks.some(function(click) {
        return click.getUserActivity().selection || click.getUserActivity().scroll;
    })) return false;
    for(var i = 0; i < clicks.length - ($adc75fc4cdc76a78$var$MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1){
        if (clicks[i + $adc75fc4cdc76a78$var$MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <= (0, $ly0px.ONE_SECOND)) return true;
    }
    return false;
}
var $adc75fc4cdc76a78$var$DEAD_CLICK_EXCLUDE_SELECTOR = // inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),textarea,select,[contenteditable],[contenteditable] *,canvas,a[href],a[href] *';
function $adc75fc4cdc76a78$export$e4a368a4d2e950a3(click) {
    if (click.hasPageActivity || click.getUserActivity().input || click.getUserActivity().scroll) return false;
    return !(0, $iznpK.elementMatches)(click.event.target, $adc75fc4cdc76a78$var$DEAD_CLICK_EXCLUDE_SELECTOR);
}

});



parcelRegister("lpjMX", function(module, exports) {

$parcel$export(module.exports, "startErrorCollection", () => $f95b485e6c21537b$export$243c2bf7ff6b9330);

var $fkj4Q = parcelRequire("fkj4Q");
var $4Be0w = parcelRequire("4Be0w");
var $iJHw0 = parcelRequire("iJHw0");
var $1zKlK = parcelRequire("1zKlK");
var $99fDv = parcelRequire("99fDv");
var $8PiRA = parcelRequire("8PiRA");
var $4wc1a = parcelRequire("4wc1a");
var $WWr2U = parcelRequire("WWr2U");

var $kuCii = parcelRequire("kuCii");

var $lkFYV = parcelRequire("lkFYV");
function $f95b485e6c21537b$export$243c2bf7ff6b9330(lifeCycle, configuration, pageStateHistory, featureFlagContexts) {
    var errorObservable = new (0, $4wc1a.Observable)();
    (0, $kuCii.trackConsoleError)(errorObservable);
    (0, $WWr2U.trackRuntimeError)(errorObservable);
    (0, $lkFYV.trackReportError)(configuration, errorObservable);
    errorObservable.subscribe(function(error) {
        return lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
            error: error
        });
    });
    return $f95b485e6c21537b$export$87a10e29a48f580b(lifeCycle, pageStateHistory, featureFlagContexts);
}
function $f95b485e6c21537b$export$87a10e29a48f580b(lifeCycle, pageStateHistory, featureFlagContexts) {
    lifeCycle.subscribe(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , function(_a) {
        var error = _a.error, customerContext = _a.customerContext, savedCommonContext = _a.savedCommonContext;
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , (0, $fkj4Q.assign)({
            customerContext: customerContext,
            savedCommonContext: savedCommonContext
        }, $f95b485e6c21537b$var$processError(error, pageStateHistory, featureFlagContexts)));
    });
    return {
        addError: function(_a, savedCommonContext) {
            var error = _a.error, handlingStack = _a.handlingStack, startClocks = _a.startClocks, customerContext = _a.context;
            var stackTrace = error instanceof Error ? (0, $iJHw0.computeStackTrace)(error) : undefined;
            var rawError = (0, $4Be0w.computeRawError)({
                stackTrace: stackTrace,
                originalError: error,
                handlingStack: handlingStack,
                startClocks: startClocks,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */ ,
                source: (0, $1zKlK.ErrorSource).CUSTOM,
                handling: "handled" /* ErrorHandling.HANDLED */ 
            });
            lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
                customerContext: customerContext,
                savedCommonContext: savedCommonContext,
                error: rawError
            });
        }
    };
}
function $f95b485e6c21537b$var$processError(error, pageStateHistory, featureFlagContexts) {
    var rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: (0, $99fDv.generateUUID)(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            type: error.type,
            handling: error.handling,
            causes: error.causes,
            source_type: "browser",
            fingerprint: error.fingerprint,
            csp: error.csp
        },
        type: "error" /* RumEventType.ERROR */ ,
        view: {
            in_foreground: pageStateHistory.wasInPageStateAt("active" /* PageState.ACTIVE */ , error.startClocks.relative)
        }
    };
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(error.startClocks.relative);
    if (featureFlagContext && !(0, $8PiRA.isEmptyObject)(featureFlagContext)) rawRumEvent.feature_flags = featureFlagContext;
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext: {
            error: error.originalError
        }
    };
}

});
parcelRegister("WWr2U", function(module, exports) {

$parcel$export(module.exports, "trackRuntimeError", () => $0b12bee99c6c13be$export$5f76c2084a9e04d);

var $35a54 = parcelRequire("35a54");

var $ly0px = parcelRequire("ly0px");

var $iJHw0 = parcelRequire("iJHw0");

var $4Be0w = parcelRequire("4Be0w");

var $1zKlK = parcelRequire("1zKlK");
function $0b12bee99c6c13be$export$5f76c2084a9e04d(errorObservable) {
    var handleRuntimeError = function(stackTrace, originalError) {
        var rawError = (0, $4Be0w.computeRawError)({
            stackTrace: stackTrace,
            originalError: originalError,
            startClocks: (0, $ly0px.clocksNow)(),
            nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */ ,
            source: (0, $1zKlK.ErrorSource).SOURCE,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */ 
        });
        errorObservable.notify(rawError);
    };
    var stopInstrumentingOnError = $0b12bee99c6c13be$export$f636584f9e54fd1(handleRuntimeError).stop;
    var stopInstrumentingOnUnhandledRejection = $0b12bee99c6c13be$export$fac10d06c5b5cb33(handleRuntimeError).stop;
    return {
        stop: function() {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        }
    };
}
function $0b12bee99c6c13be$export$f636584f9e54fd1(callback) {
    return (0, $35a54.instrumentMethod)(window, "onerror", function(_a) {
        var _b = _a.parameters, messageObj = _b[0], url = _b[1], line = _b[2], column = _b[3], errorObj = _b[4];
        var stackTrace;
        if (errorObj instanceof Error) stackTrace = (0, $iJHw0.computeStackTrace)(errorObj);
        else stackTrace = (0, $iJHw0.computeStackTraceFromOnErrorMessage)(messageObj, url, line, column);
        callback(stackTrace, errorObj !== null && errorObj !== void 0 ? errorObj : messageObj);
    });
}
function $0b12bee99c6c13be$export$fac10d06c5b5cb33(callback) {
    return (0, $35a54.instrumentMethod)(window, "onunhandledrejection", function(_a) {
        var e = _a.parameters[0];
        var reason = e.reason || "Empty reason";
        var stack = (0, $iJHw0.computeStackTrace)(reason);
        callback(stack, reason);
    });
}

});

parcelRegister("kuCii", function(module, exports) {

$parcel$export(module.exports, "trackConsoleError", () => $eeb45063442903a5$export$fe4ab68ea26fba82);

var $ly0px = parcelRequire("ly0px");
var $5IDGB = parcelRequire("5IDGB");
var $1zKlK = parcelRequire("1zKlK");
var $crBqg = parcelRequire("crBqg");
function $eeb45063442903a5$export$fe4ab68ea26fba82(errorObservable) {
    var subscription = (0, $crBqg.initConsoleObservable)([
        (0, $5IDGB.ConsoleApiName).error
    ]).subscribe(function(consoleError) {
        return errorObservable.notify({
            startClocks: (0, $ly0px.clocksNow)(),
            message: consoleError.message,
            stack: consoleError.stack,
            fingerprint: consoleError.fingerprint,
            source: (0, $1zKlK.ErrorSource).CONSOLE,
            handling: "handled" /* ErrorHandling.HANDLED */ ,
            handlingStack: consoleError.handlingStack
        });
    });
    return {
        stop: function() {
            subscription.unsubscribe();
        }
    };
}

});
parcelRegister("crBqg", function(module, exports) {

$parcel$export(module.exports, "initConsoleObservable", () => $90f50905b5952746$export$688fb0189cfcddd4);

var $4Be0w = parcelRequire("4Be0w");

var $4wc1a = parcelRequire("4wc1a");

var $5IDGB = parcelRequire("5IDGB");

var $2wH3Z = parcelRequire("2wH3Z");

var $1RdIU = parcelRequire("1RdIU");

var $fkj4Q = parcelRequire("fkj4Q");

var $1W8NF = parcelRequire("1W8NF");

var $iJHw0 = parcelRequire("iJHw0");
var $90f50905b5952746$var$consoleObservablesByApi = {};
function $90f50905b5952746$export$688fb0189cfcddd4(apis) {
    var consoleObservables = apis.map(function(api) {
        if (!$90f50905b5952746$var$consoleObservablesByApi[api]) $90f50905b5952746$var$consoleObservablesByApi[api] = $90f50905b5952746$var$createConsoleObservable(api);
        return $90f50905b5952746$var$consoleObservablesByApi[api];
    });
    return (0, $4wc1a.mergeObservables).apply(void 0, consoleObservables);
}
function $90f50905b5952746$export$1356159d86f98c58() {
    $90f50905b5952746$var$consoleObservablesByApi = {};
}
function $90f50905b5952746$var$createConsoleObservable(api) {
    return new (0, $4wc1a.Observable)(function(observable) {
        var originalConsoleApi = (0, $5IDGB.globalConsole)[api];
        (0, $5IDGB.globalConsole)[api] = function() {
            var params = [];
            for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
            originalConsoleApi.apply(console, params);
            var handlingStack = (0, $4Be0w.createHandlingStack)();
            (0, $2wH3Z.callMonitored)(function() {
                observable.notify($90f50905b5952746$var$buildConsoleLog(params, api, handlingStack));
            });
        };
        return function() {
            (0, $5IDGB.globalConsole)[api] = originalConsoleApi;
        };
    });
}
function $90f50905b5952746$var$buildConsoleLog(params, api, handlingStack) {
    var message = params.map(function(param) {
        return $90f50905b5952746$var$formatConsoleParameters(param);
    }).join(" ");
    var stack;
    var fingerprint;
    var causes;
    if (api === (0, $5IDGB.ConsoleApiName).error) {
        var firstErrorParam = (0, $fkj4Q.find)(params, function(param) {
            return param instanceof Error;
        });
        stack = firstErrorParam ? (0, $4Be0w.toStackTraceString)((0, $iJHw0.computeStackTrace)(firstErrorParam)) : undefined;
        fingerprint = (0, $4Be0w.tryToGetFingerprint)(firstErrorParam);
        causes = firstErrorParam ? (0, $4Be0w.flattenErrorCauses)(firstErrorParam, "console") : undefined;
    }
    return {
        api: api,
        message: message,
        stack: stack,
        handlingStack: handlingStack,
        fingerprint: fingerprint,
        causes: causes
    };
}
function $90f50905b5952746$var$formatConsoleParameters(param) {
    if (typeof param === "string") return (0, $1RdIU.sanitize)(param);
    if (param instanceof Error) return (0, $4Be0w.formatErrorMessage)((0, $iJHw0.computeStackTrace)(param));
    return (0, $1W8NF.jsonStringify)((0, $1RdIU.sanitize)(param), undefined, 2);
}

});


parcelRegister("lkFYV", function(module, exports) {

$parcel$export(module.exports, "trackReportError", () => $f87c07eca9e767df$export$532a6c6a36756d07);

var $ly0px = parcelRequire("ly0px");
var $1zKlK = parcelRequire("1zKlK");
var $3LtP9 = parcelRequire("3LtP9");
function $f87c07eca9e767df$export$532a6c6a36756d07(configuration, errorObservable) {
    var subscription = (0, $3LtP9.initReportObservable)(configuration, [
        (0, $3LtP9.RawReportType).cspViolation,
        (0, $3LtP9.RawReportType).intervention
    ]).subscribe(function(reportError) {
        var rawError = {
            startClocks: (0, $ly0px.clocksNow)(),
            message: reportError.message,
            stack: reportError.stack,
            type: reportError.subtype,
            source: (0, $1zKlK.ErrorSource).REPORT,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */ ,
            originalError: reportError.originalReport
        };
        if (reportError.originalReport.type === "securitypolicyviolation") rawError.csp = {
            disposition: reportError.originalReport.disposition
        };
        return errorObservable.notify(rawError);
    });
    return {
        stop: function() {
            subscription.unsubscribe();
        }
    };
}

});
parcelRegister("3LtP9", function(module, exports) {

$parcel$export(module.exports, "RawReportType", () => $2bdce5556b3f551d$export$1bd494ac7adbb6ce);
$parcel$export(module.exports, "initReportObservable", () => $2bdce5556b3f551d$export$645a986d81bb5490);

var $4Be0w = parcelRequire("4Be0w");

var $2wH3Z = parcelRequire("2wH3Z");

var $4wc1a = parcelRequire("4wc1a");

var $hXhfS = parcelRequire("hXhfS");

var $fkj4Q = parcelRequire("fkj4Q");

var $99fDv = parcelRequire("99fDv");
var $2bdce5556b3f551d$export$1bd494ac7adbb6ce = {
    intervention: "intervention",
    deprecation: "deprecation",
    cspViolation: "csp_violation"
};
function $2bdce5556b3f551d$export$645a986d81bb5490(configuration, apis) {
    var observables = [];
    if ((0, $fkj4Q.includes)(apis, $2bdce5556b3f551d$export$1bd494ac7adbb6ce.cspViolation)) observables.push($2bdce5556b3f551d$var$createCspViolationReportObservable(configuration));
    var reportTypes = apis.filter(function(api) {
        return api !== $2bdce5556b3f551d$export$1bd494ac7adbb6ce.cspViolation;
    });
    if (reportTypes.length) observables.push($2bdce5556b3f551d$var$createReportObservable(reportTypes));
    return (0, $4wc1a.mergeObservables).apply(void 0, observables);
}
function $2bdce5556b3f551d$var$createReportObservable(reportTypes) {
    return new (0, $4wc1a.Observable)(function(observable) {
        if (!window.ReportingObserver) return;
        var handleReports = (0, $2wH3Z.monitor)(function(reports, _) {
            return reports.forEach(function(report) {
                observable.notify($2bdce5556b3f551d$var$buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true
        });
        observer.observe();
        return function() {
            observer.disconnect();
        };
    });
}
function $2bdce5556b3f551d$var$createCspViolationReportObservable(configuration) {
    return new (0, $4wc1a.Observable)(function(observable) {
        var stop = (0, $hXhfS.addEventListener)(configuration, document, (0, $hXhfS.DOM_EVENT).SECURITY_POLICY_VIOLATION, function(event) {
            observable.notify($2bdce5556b3f551d$var$buildRawReportFromCspViolation(event));
        }).stop;
        return stop;
    });
}
function $2bdce5556b3f551d$var$buildRawReportFromReport(report) {
    var type = report.type, body = report.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        originalReport: report,
        stack: $2bdce5556b3f551d$var$buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber)
    };
}
function $2bdce5556b3f551d$var$buildRawReportFromCspViolation(event) {
    var type = $2bdce5556b3f551d$export$1bd494ac7adbb6ce.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: $2bdce5556b3f551d$export$1bd494ac7adbb6ce.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: $2bdce5556b3f551d$var$buildStack(event.effectiveDirective, event.originalPolicy ? "".concat(message, ' of the policy "').concat((0, $99fDv.safeTruncate)(event.originalPolicy, 100, "..."), '"') : "no policy", event.sourceFile, event.lineNumber, event.columnNumber),
        originalReport: event
    };
}
function $2bdce5556b3f551d$var$buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return sourceFile ? (0, $4Be0w.toStackTraceString)({
        name: name,
        message: message,
        stack: [
            {
                func: "?",
                url: sourceFile,
                line: lineNumber !== null && lineNumber !== void 0 ? lineNumber : undefined,
                column: columnNumber !== null && columnNumber !== void 0 ? columnNumber : undefined
            }
        ]
    }) : undefined;
}

});



parcelRegister("lWJEv", function(module, exports) {

$parcel$export(module.exports, "startLongTaskCollection", () => $ffa26d5dc219f735$export$52c09388c428dadc);

var $99fDv = parcelRequire("99fDv");
var $ly0px = parcelRequire("ly0px");

var $iSyQp = parcelRequire("iSyQp");
function $ffa26d5dc219f735$export$52c09388c428dadc(lifeCycle, configuration, sessionManager) {
    lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */ , function(entries) {
        for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
            var entry = entries_1[_i];
            if (entry.entryType !== (0, $iSyQp.RumPerformanceEntryType).LONG_TASK) break;
            var session = sessionManager.findTrackedSession(entry.startTime);
            if (!session || !configuration.trackLongTasks) break;
            var startClocks = (0, $ly0px.relativeToClocks)(entry.startTime);
            var rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: (0, $99fDv.generateUUID)(),
                    duration: (0, $ly0px.toServerDuration)(entry.duration)
                },
                type: "long_task" /* RumEventType.LONG_TASK */ ,
                _dd: {
                    discarded: false
                }
            };
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , {
                rawRumEvent: rawRumEvent,
                startTime: startClocks.relative,
                domainContext: {
                    performanceEntry: entry
                }
            });
        }
    });
}

});

parcelRegister("4JFG9", function(module, exports) {

$parcel$export(module.exports, "startResourceCollection", () => $372bb1efffad81cc$export$7a0c7e0d79d84977);

var $fkj4Q = parcelRequire("fkj4Q");
var $j9iCm = parcelRequire("j9iCm");
var $k2pmh = parcelRequire("k2pmh");
var $99fDv = parcelRequire("99fDv");
var $bQmeT = parcelRequire("bQmeT");
var $ly0px = parcelRequire("ly0px");

var $iSyQp = parcelRequire("iSyQp");

var $5KXj3 = parcelRequire("5KXj3");

var $fisL9 = parcelRequire("fisL9");
function $372bb1efffad81cc$export$7a0c7e0d79d84977(lifeCycle, configuration, sessionManager, pageStateHistory) {
    lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , function(request) {
        var rawEvent = $372bb1efffad81cc$var$processRequest(request, configuration, sessionManager, pageStateHistory);
        if (rawEvent) lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , rawEvent);
    });
    lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */ , function(entries) {
        for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
            var entry = entries_1[_i];
            if (entry.entryType === (0, $iSyQp.RumPerformanceEntryType).RESOURCE && !(0, $fisL9.isRequestKind)(entry)) {
                var rawEvent = $372bb1efffad81cc$var$processResourceEntry(entry, configuration, sessionManager, pageStateHistory);
                if (rawEvent) lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , rawEvent);
            }
        }
    });
}
function $372bb1efffad81cc$var$processRequest(request, configuration, sessionManager, pageStateHistory) {
    var _a;
    var matchingTiming = (0, $5KXj3.matchRequestTiming)(request);
    var startClocks = matchingTiming ? (0, $ly0px.relativeToClocks)(matchingTiming.startTime) : request.startClocks;
    var shouldIndex = $372bb1efffad81cc$var$shouldIndexResource(configuration, sessionManager, startClocks);
    var tracingInfo = $372bb1efffad81cc$var$computeRequestTracingInfo(request, configuration);
    if (!shouldIndex && !tracingInfo) return;
    var type = request.type === "xhr" /* RequestType.XHR */  ? "xhr" /* ResourceType.XHR */  : "fetch" /* ResourceType.FETCH */ ;
    var correspondingTimingOverrides = matchingTiming ? $372bb1efffad81cc$var$computePerformanceEntryMetrics(matchingTiming) : undefined;
    var duration = $372bb1efffad81cc$var$computeRequestDuration(pageStateHistory, startClocks, request.duration);
    var pageStateInfo = $372bb1efffad81cc$var$computePageStateInfo(pageStateHistory, startClocks, (_a = matchingTiming === null || matchingTiming === void 0 ? void 0 : matchingTiming.duration) !== null && _a !== void 0 ? _a : request.duration);
    var resourceEvent = (0, $j9iCm.combine)({
        date: startClocks.timeStamp,
        resource: {
            id: (0, $99fDv.generateUUID)(),
            type: type,
            duration: duration,
            method: request.method,
            status_code: request.status,
            url: request.url
        },
        type: "resource" /* RumEventType.RESOURCE */ ,
        _dd: {
            discarded: !shouldIndex
        }
    }, tracingInfo, correspondingTimingOverrides, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: matchingTiming,
            xhr: request.xhr,
            response: request.response,
            requestInput: request.input,
            requestInit: request.init,
            error: request.error,
            isAborted: request.isAborted
        }
    };
}
function $372bb1efffad81cc$var$processResourceEntry(entry, configuration, sessionManager, pageStateHistory) {
    var startClocks = (0, $ly0px.relativeToClocks)(entry.startTime);
    var shouldIndex = $372bb1efffad81cc$var$shouldIndexResource(configuration, sessionManager, startClocks);
    var tracingInfo = $372bb1efffad81cc$var$computeEntryTracingInfo(entry, configuration);
    if (!shouldIndex && !tracingInfo) return;
    var type = (0, $fisL9.computeResourceKind)(entry);
    var entryMetrics = $372bb1efffad81cc$var$computePerformanceEntryMetrics(entry);
    var pageStateInfo = $372bb1efffad81cc$var$computePageStateInfo(pageStateHistory, startClocks, entry.duration);
    var resourceEvent = (0, $j9iCm.combine)({
        date: startClocks.timeStamp,
        resource: {
            id: (0, $99fDv.generateUUID)(),
            type: type,
            url: entry.name,
            status_code: $372bb1efffad81cc$var$discardZeroStatus(entry.responseStatus)
        },
        type: "resource" /* RumEventType.RESOURCE */ ,
        _dd: {
            discarded: !shouldIndex
        }
    }, tracingInfo, entryMetrics, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: entry
        }
    };
}
function $372bb1efffad81cc$var$shouldIndexResource(configuration, sessionManager, resourceStart) {
    return configuration.trackResources && sessionManager.findTrackedSession(resourceStart.relative);
}
function $372bb1efffad81cc$var$computePerformanceEntryMetrics(timing) {
    var renderBlockingStatus = timing.renderBlockingStatus;
    return {
        resource: (0, $fkj4Q.assign)({
            duration: (0, $fisL9.computePerformanceResourceDuration)(timing),
            render_blocking_status: renderBlockingStatus
        }, (0, $fisL9.computeSize)(timing), (0, $fisL9.computePerformanceResourceDetails)(timing))
    };
}
function $372bb1efffad81cc$var$computeRequestTracingInfo(request, configuration) {
    var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
    if (!hasBeenTraced) return undefined;
    return {
        _dd: {
            span_id: request.spanId.toDecimalString(),
            trace_id: request.traceId.toDecimalString(),
            rule_psr: $372bb1efffad81cc$var$getRulePsr(configuration)
        }
    };
}
function $372bb1efffad81cc$var$computeEntryTracingInfo(entry, configuration) {
    var hasBeenTraced = entry.traceId;
    if (!hasBeenTraced) return undefined;
    return {
        _dd: {
            trace_id: entry.traceId,
            rule_psr: $372bb1efffad81cc$var$getRulePsr(configuration)
        }
    };
}
/**
 * @returns number between 0 and 1 which represents trace sample rate
 */ function $372bb1efffad81cc$var$getRulePsr(configuration) {
    return (0, $bQmeT.isNumber)(configuration.traceSampleRate) ? configuration.traceSampleRate / 100 : undefined;
}
function $372bb1efffad81cc$var$computePageStateInfo(pageStateHistory, startClocks, duration) {
    if (!(0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).RESOURCE_PAGE_STATES)) return;
    return {
        _dd: {
            page_states: pageStateHistory.findAll(startClocks.relative, duration),
            page_was_discarded: String(document.wasDiscarded)
        }
    };
}
function $372bb1efffad81cc$var$computeRequestDuration(pageStateHistory, startClocks, duration) {
    return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */ , startClocks.relative, duration) ? (0, $ly0px.toServerDuration)(duration) : undefined;
}
/**
 * The status is 0 for cross-origin resources without CORS headers, so the status is meaningless, and we shouldn't report it
 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus#cross-origin_response_status_codes
 */ function $372bb1efffad81cc$var$discardZeroStatus(statusCode) {
    return statusCode === 0 ? undefined : statusCode;
}

});
parcelRegister("5KXj3", function(module, exports) {

$parcel$export(module.exports, "matchRequestTiming", () => $430f40a23c1c5d8e$export$e1e748c1442e0aa);

var $ly0px = parcelRequire("ly0px");

var $fisL9 = parcelRequire("fisL9");
function $430f40a23c1c5d8e$export$e1e748c1442e0aa(request) {
    if (!performance || !("getEntriesByName" in performance)) return;
    var sameNameEntries = performance.getEntriesByName(request.url, "resource");
    if (!sameNameEntries.length || !("toJSON" in sameNameEntries[0])) return;
    var candidates = sameNameEntries.map(function(entry) {
        return entry.toJSON();
    }).filter((0, $fisL9.toValidEntry)).filter(function(entry) {
        return $430f40a23c1c5d8e$var$isBetween(entry, request.startClocks.relative, $430f40a23c1c5d8e$var$endTime({
            startTime: request.startClocks.relative,
            duration: request.duration
        }));
    });
    if (candidates.length === 1) return candidates[0];
    return;
}
function $430f40a23c1c5d8e$var$endTime(timing) {
    return (0, $ly0px.addDuration)(timing.startTime, timing.duration);
}
function $430f40a23c1c5d8e$var$isBetween(timing, start, end) {
    var errorMargin = 1;
    return timing.startTime >= start - errorMargin && $430f40a23c1c5d8e$var$endTime(timing) <= (0, $ly0px.addDuration)(end, errorMargin);
}

});


parcelRegister("3GTFW", function(module, exports) {

$parcel$export(module.exports, "startViewCollection", () => $2b007b506741de80$export$794a32d201ece359);

var $8PiRA = parcelRequire("8PiRA");
var $bQmeT = parcelRequire("bQmeT");
var $ly0px = parcelRequire("ly0px");

var $dCrat = parcelRequire("dCrat");
function $2b007b506741de80$export$794a32d201ece359(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions) {
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */ , function(view) {
        return lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $2b007b506741de80$var$processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory));
    });
    return (0, $dCrat.trackViews)(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function $2b007b506741de80$var$processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var replayStats = recorderApi.getReplayStats(view.id);
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(view.startClocks.relative);
    var pageStates = pageStateHistory.findAll(view.startClocks.relative, view.duration);
    var viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
            page_states: pageStates,
            configuration: {
                start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually
            }
        },
        date: view.startClocks.timeStamp,
        type: "view" /* RumEventType.VIEW */ ,
        view: {
            action: {
                count: view.eventCounts.actionCount
            },
            frustration: {
                count: view.eventCounts.frustrationCount
            },
            cumulative_layout_shift: (_a = view.commonViewMetrics.cumulativeLayoutShift) === null || _a === void 0 ? void 0 : _a.value,
            cumulative_layout_shift_target_selector: (_b = view.commonViewMetrics.cumulativeLayoutShift) === null || _b === void 0 ? void 0 : _b.targetSelector,
            first_byte: (0, $ly0px.toServerDuration)((_c = view.initialViewMetrics.navigationTimings) === null || _c === void 0 ? void 0 : _c.firstByte),
            dom_complete: (0, $ly0px.toServerDuration)((_d = view.initialViewMetrics.navigationTimings) === null || _d === void 0 ? void 0 : _d.domComplete),
            dom_content_loaded: (0, $ly0px.toServerDuration)((_e = view.initialViewMetrics.navigationTimings) === null || _e === void 0 ? void 0 : _e.domContentLoaded),
            dom_interactive: (0, $ly0px.toServerDuration)((_f = view.initialViewMetrics.navigationTimings) === null || _f === void 0 ? void 0 : _f.domInteractive),
            error: {
                count: view.eventCounts.errorCount
            },
            first_contentful_paint: (0, $ly0px.toServerDuration)(view.initialViewMetrics.firstContentfulPaint),
            first_input_delay: (0, $ly0px.toServerDuration)((_g = view.initialViewMetrics.firstInput) === null || _g === void 0 ? void 0 : _g.delay),
            first_input_time: (0, $ly0px.toServerDuration)((_h = view.initialViewMetrics.firstInput) === null || _h === void 0 ? void 0 : _h.time),
            first_input_target_selector: (_j = view.initialViewMetrics.firstInput) === null || _j === void 0 ? void 0 : _j.targetSelector,
            interaction_to_next_paint: (0, $ly0px.toServerDuration)((_k = view.commonViewMetrics.interactionToNextPaint) === null || _k === void 0 ? void 0 : _k.value),
            interaction_to_next_paint_target_selector: (_l = view.commonViewMetrics.interactionToNextPaint) === null || _l === void 0 ? void 0 : _l.targetSelector,
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: (0, $ly0px.toServerDuration)((_m = view.initialViewMetrics.largestContentfulPaint) === null || _m === void 0 ? void 0 : _m.value),
            largest_contentful_paint_target_selector: (_o = view.initialViewMetrics.largestContentfulPaint) === null || _o === void 0 ? void 0 : _o.targetSelector,
            load_event: (0, $ly0px.toServerDuration)((_p = view.initialViewMetrics.navigationTimings) === null || _p === void 0 ? void 0 : _p.loadEvent),
            loading_time: $2b007b506741de80$var$discardNegativeDuration((0, $ly0px.toServerDuration)(view.commonViewMetrics.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount
            },
            resource: {
                count: view.eventCounts.resourceCount
            },
            time_spent: (0, $ly0px.toServerDuration)(view.duration)
        },
        feature_flags: featureFlagContext && !(0, $8PiRA.isEmptyObject)(featureFlagContext) ? featureFlagContext : undefined,
        display: view.commonViewMetrics.scroll ? {
            scroll: {
                max_depth: view.commonViewMetrics.scroll.maxDepth,
                max_depth_scroll_top: view.commonViewMetrics.scroll.maxDepthScrollTop,
                max_scroll_height: view.commonViewMetrics.scroll.maxScrollHeight,
                max_scroll_height_time: (0, $ly0px.toServerDuration)(view.commonViewMetrics.scroll.maxScrollHeightTime)
            }
        } : undefined,
        session: {
            has_replay: replayStats ? true : undefined,
            is_active: view.sessionIsActive ? undefined : false
        },
        privacy: {
            replay_level: configuration.defaultPrivacyLevel
        }
    };
    if (!(0, $8PiRA.isEmptyObject)(view.customTimings)) viewEvent.view.custom_timings = (0, $8PiRA.mapValues)(view.customTimings, (0, $ly0px.toServerDuration));
    return {
        rawRumEvent: viewEvent,
        startTime: view.startClocks.relative,
        domainContext: {
            location: view.location
        }
    };
}
function $2b007b506741de80$var$discardNegativeDuration(duration) {
    return (0, $bQmeT.isNumber)(duration) && duration < 0 ? undefined : duration;
}

});
parcelRegister("dCrat", function(module, exports) {

$parcel$export(module.exports, "trackViews", () => $9ea3e5f0d6b2c477$export$a9e93bc2fdba42cf);

var $d97UU = parcelRequire("d97UU");
var $ly0px = parcelRequire("ly0px");
var $5IDGB = parcelRequire("5IDGB");
var $99fDv = parcelRequire("99fDv");
var $aed8w = parcelRequire("aed8w");
var $4wc1a = parcelRequire("4wc1a");
var $1gpLX = parcelRequire("1gpLX");
var $8PiRA = parcelRequire("8PiRA");

var $izjjT = parcelRequire("izjjT");

var $eiU7B = parcelRequire("eiU7B");

var $8pGpX = parcelRequire("8pGpX");
var $9ea3e5f0d6b2c477$export$547e59d66cff6939 = 3000;
var $9ea3e5f0d6b2c477$export$466344df8256a878 = 5 * (0, $ly0px.ONE_MINUTE);
var $9ea3e5f0d6b2c477$export$41ad004d27ab927 = 5 * (0, $ly0px.ONE_MINUTE);
function $9ea3e5f0d6b2c477$export$a9e93bc2fdba42cf(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    var activeViews = new Set();
    var currentView = startNewView("initial_load" /* ViewLoadingType.INITIAL_LOAD */ , (0, $ly0px.clocksOrigin)(), initialViewOptions);
    startViewLifeCycle();
    var locationChangeSubscription;
    if (areViewsTrackedAutomatically) locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
    function startNewView(loadingType, startClocks, viewOptions) {
        var newlyCreatedView = $9ea3e5f0d6b2c477$var$newView(lifeCycle, domMutationObservable, configuration, location, loadingType, startClocks, viewOptions);
        activeViews.add(newlyCreatedView);
        newlyCreatedView.stopObservable.subscribe(function() {
            activeViews.delete(newlyCreatedView);
        });
        return newlyCreatedView;
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , function() {
            // Renew view on session renewal
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */ , undefined, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version
            });
        });
        lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */ , function() {
            currentView.end({
                sessionIsActive: false
            });
        });
        // End the current view on page unload
        lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */ , function(pageExitEvent) {
            if (pageExitEvent.reason === (0, $1gpLX.PageExitReason).UNLOADING || pageExitEvent.reason === (0, $1gpLX.PageExitReason).PAGEHIDE) currentView.end();
        });
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(function(_a) {
            var oldLocation = _a.oldLocation, newLocation = _a.newLocation;
            if ($9ea3e5f0d6b2c477$var$areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */ );
            }
        });
    }
    return {
        addTiming: function(name, time) {
            if (time === void 0) time = (0, $ly0px.timeStampNow)();
            currentView.addTiming(name, time);
        },
        startView: function(options, startClocks) {
            currentView.end({
                endClocks: startClocks
            });
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */ , startClocks, options);
        },
        stop: function() {
            locationChangeSubscription === null || locationChangeSubscription === void 0 || locationChangeSubscription.unsubscribe();
            currentView.end();
            activeViews.forEach(function(view) {
                return view.stop();
            });
        }
    };
}
function $9ea3e5f0d6b2c477$var$newView(lifeCycle, domMutationObservable, configuration, initialLocation, loadingType, startClocks, viewOptions) {
    if (startClocks === void 0) startClocks = (0, $ly0px.clocksNow)();
    // Setup initial values
    var id = (0, $99fDv.generateUUID)();
    var stopObservable = new (0, $4wc1a.Observable)();
    var customTimings = {};
    var documentVersion = 0;
    var endClocks;
    var location = (0, $8PiRA.shallowClone)(initialLocation);
    var sessionIsActive = true;
    var name;
    var service;
    var version;
    if (viewOptions) {
        name = viewOptions.name;
        service = viewOptions.service;
        version = viewOptions.version;
    }
    var viewCreatedEvent = {
        id: id,
        name: name,
        startClocks: startClocks,
        service: service,
        version: version
    };
    lifeCycle.notify(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */ , viewCreatedEvent);
    lifeCycle.notify(3 /* LifeCycleEventType.VIEW_CREATED */ , viewCreatedEvent);
    // Update the view every time the measures are changing
    var _a = (0, $aed8w.throttle)(triggerViewUpdate, $9ea3e5f0d6b2c477$export$547e59d66cff6939, {
        leading: false
    }), scheduleViewUpdate = _a.throttled, cancelScheduleViewUpdate = _a.cancel;
    var _b = (0, $8pGpX.trackCommonViewMetrics)(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, startClocks), setLoadEvent = _b.setLoadEvent, setViewEnd = _b.setViewEnd, stopCommonViewMetricsTracking = _b.stop, stopINPTracking = _b.stopINPTracking, getCommonViewMetrics = _b.getCommonViewMetrics;
    var _c = loadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */  ? (0, $eiU7B.trackInitialViewMetrics)(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate) : {
        stop: (0, $aed8w.noop),
        initialViewMetrics: {}
    }, stopInitialViewMetricsTracking = _c.stop, initialViewMetrics = _c.initialViewMetrics;
    var _d = (0, $izjjT.trackViewEventCounts)(lifeCycle, id, scheduleViewUpdate), stopEventCountsTracking = _d.stop, eventCounts = _d.eventCounts;
    // Session keep alive
    var keepAliveIntervalId = (0, $d97UU.setInterval)(triggerViewUpdate, $9ea3e5f0d6b2c477$export$466344df8256a878);
    // Initial view update
    triggerViewUpdate();
    function triggerViewUpdate() {
        cancelScheduleViewUpdate();
        documentVersion += 1;
        var currentEnd = endClocks === undefined ? (0, $ly0px.timeStampNow)() : endClocks.timeStamp;
        lifeCycle.notify(4 /* LifeCycleEventType.VIEW_UPDATED */ , {
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            service: service,
            version: version,
            loadingType: loadingType,
            location: location,
            startClocks: startClocks,
            commonViewMetrics: getCommonViewMetrics(),
            initialViewMetrics: initialViewMetrics,
            duration: (0, $ly0px.elapsed)(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
            sessionIsActive: sessionIsActive,
            eventCounts: eventCounts
        });
    }
    return {
        name: name,
        service: service,
        version: version,
        stopObservable: stopObservable,
        end: function(options) {
            var _this = this;
            var _a, _b;
            if (options === void 0) options = {};
            if (endClocks) // view already ended
            return;
            endClocks = (_a = options.endClocks) !== null && _a !== void 0 ? _a : (0, $ly0px.clocksNow)();
            sessionIsActive = (_b = options.sessionIsActive) !== null && _b !== void 0 ? _b : true;
            lifeCycle.notify(5 /* LifeCycleEventType.VIEW_ENDED */ , {
                endClocks: endClocks
            });
            lifeCycle.notify(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */ , {
                endClocks: endClocks
            });
            (0, $d97UU.clearInterval)(keepAliveIntervalId);
            setViewEnd(endClocks.relative);
            stopCommonViewMetricsTracking();
            triggerViewUpdate();
            (0, $d97UU.setTimeout)(function() {
                _this.stop();
            }, $9ea3e5f0d6b2c477$export$41ad004d27ab927);
        },
        stop: function() {
            stopInitialViewMetricsTracking();
            stopEventCountsTracking();
            stopINPTracking();
            stopObservable.notify();
        },
        addTiming: function(name, time) {
            if (endClocks) return;
            var relativeTime = (0, $ly0px.looksLikeRelativeTime)(time) ? time : (0, $ly0px.elapsed)(startClocks.timeStamp, time);
            customTimings[$9ea3e5f0d6b2c477$var$sanitizeTiming(name)] = relativeTime;
            scheduleViewUpdate();
        }
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */ function $9ea3e5f0d6b2c477$var$sanitizeTiming(name) {
    var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, "_");
    if (sanitized !== name) (0, $5IDGB.display).warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
    return sanitized;
}
function $9ea3e5f0d6b2c477$var$areDifferentLocation(currentLocation, otherLocation) {
    return currentLocation.pathname !== otherLocation.pathname || !$9ea3e5f0d6b2c477$var$isHashAnAnchor(otherLocation.hash) && $9ea3e5f0d6b2c477$var$getPathFromHash(otherLocation.hash) !== $9ea3e5f0d6b2c477$var$getPathFromHash(currentLocation.hash);
}
function $9ea3e5f0d6b2c477$var$isHashAnAnchor(hash) {
    var correspondingId = hash.substring(1);
    // check if the correspondingId is empty because on Firefox an empty string passed to getElementById() prints a consol warning
    return correspondingId !== "" && !!document.getElementById(correspondingId);
}
function $9ea3e5f0d6b2c477$var$getPathFromHash(hash) {
    var index = hash.indexOf("?");
    return index < 0 ? hash : hash.slice(0, index);
}

});
parcelRegister("izjjT", function(module, exports) {

$parcel$export(module.exports, "trackViewEventCounts", () => $d84a7b6bfd07f92f$export$fcb8a99c2bff4a6b);

var $WzabW = parcelRequire("WzabW");
function $d84a7b6bfd07f92f$export$fcb8a99c2bff4a6b(lifeCycle, viewId, onChange) {
    var _a = (0, $WzabW.trackEventCounts)({
        lifeCycle: lifeCycle,
        isChildEvent: function(event) {
            return event.view.id === viewId;
        },
        onChange: onChange
    }), stop = _a.stop, eventCounts = _a.eventCounts;
    return {
        stop: stop,
        eventCounts: eventCounts
    };
}

});

parcelRegister("eiU7B", function(module, exports) {

$parcel$export(module.exports, "trackInitialViewMetrics", () => $a69e47b74eda2325$export$e0159acaad53a4f8);

var $dFFvN = parcelRequire("dFFvN");

var $1YAhO = parcelRequire("1YAhO");

var $6ScpO = parcelRequire("6ScpO");

var $iSkz6 = parcelRequire("iSkz6");

var $7ODjH = parcelRequire("7ODjH");
function $a69e47b74eda2325$export$e0159acaad53a4f8(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate) {
    var initialViewMetrics = {};
    var stopNavigationTracking = (0, $6ScpO.trackNavigationTimings)(lifeCycle, function(navigationTimings) {
        setLoadEvent(navigationTimings.loadEvent);
        initialViewMetrics.navigationTimings = navigationTimings;
        scheduleViewUpdate();
    }).stop;
    var firstHidden = (0, $7ODjH.trackFirstHidden)(configuration);
    var stopFCPTracking = (0, $dFFvN.trackFirstContentfulPaint)(lifeCycle, firstHidden, function(firstContentfulPaint) {
        initialViewMetrics.firstContentfulPaint = firstContentfulPaint;
        scheduleViewUpdate();
    }).stop;
    var stopLCPTracking = (0, $iSkz6.trackLargestContentfulPaint)(lifeCycle, configuration, firstHidden, window, function(largestContentfulPaint) {
        initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
        scheduleViewUpdate();
    }).stop;
    var stopFIDTracking = (0, $1YAhO.trackFirstInput)(lifeCycle, configuration, firstHidden, function(firstInput) {
        initialViewMetrics.firstInput = firstInput;
        scheduleViewUpdate();
    }).stop;
    function stop() {
        stopNavigationTracking();
        stopFCPTracking();
        stopLCPTracking();
        stopFIDTracking();
        firstHidden.stop();
    }
    return {
        stop: stop,
        initialViewMetrics: initialViewMetrics
    };
}

});
parcelRegister("dFFvN", function(module, exports) {

$parcel$export(module.exports, "trackFirstContentfulPaint", () => $9f3f4e1acb2d1077$export$a43e15ae3a012adf);

var $fkj4Q = parcelRequire("fkj4Q");
var $ly0px = parcelRequire("ly0px");

var $iSyQp = parcelRequire("iSyQp");
var $9f3f4e1acb2d1077$export$2f95fa37b4a92d63 = 10 * (0, $ly0px.ONE_MINUTE);
function $9f3f4e1acb2d1077$export$a43e15ae3a012adf(lifeCycle, firstHidden, callback) {
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */ , function(entries) {
        var fcpEntry = (0, $fkj4Q.find)(entries, function(entry) {
            return entry.entryType === (0, $iSyQp.RumPerformanceEntryType).PAINT && entry.name === "first-contentful-paint" && entry.startTime < firstHidden.timeStamp && entry.startTime < $9f3f4e1acb2d1077$export$2f95fa37b4a92d63;
        });
        if (fcpEntry) callback(fcpEntry.startTime);
    }).unsubscribe;
    return {
        stop: unsubscribeLifeCycle
    };
}

});

parcelRegister("1YAhO", function(module, exports) {

$parcel$export(module.exports, "trackFirstInput", () => $17078abdd4b8eaf3$export$1de7804f73e53e9a);

var $ly0px = parcelRequire("ly0px");
var $fkj4Q = parcelRequire("fkj4Q");

var $4TGNe = parcelRequire("4TGNe");

var $iSyQp = parcelRequire("iSyQp");

var $l3o7w = parcelRequire("l3o7w");
function $17078abdd4b8eaf3$export$1de7804f73e53e9a(lifeCycle, configuration, firstHidden, callback) {
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */ , function(entries) {
        var firstInputEntry = (0, $fkj4Q.find)(entries, function(entry) {
            return entry.entryType === (0, $iSyQp.RumPerformanceEntryType).FIRST_INPUT && entry.startTime < firstHidden.timeStamp;
        });
        if (firstInputEntry) {
            var firstInputDelay = (0, $ly0px.elapsed)(firstInputEntry.startTime, firstInputEntry.processingStart);
            var firstInputTargetSelector = void 0;
            if (firstInputEntry.target && (0, $4TGNe.isElementNode)(firstInputEntry.target)) firstInputTargetSelector = (0, $l3o7w.getSelectorFromElement)(firstInputEntry.target, configuration.actionNameAttribute);
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                delay: firstInputDelay >= 0 ? firstInputDelay : 0,
                time: firstInputEntry.startTime,
                targetSelector: firstInputTargetSelector
            });
        }
    }).unsubscribe;
    return {
        stop: unsubscribeLifeCycle
    };
}

});

parcelRegister("6ScpO", function(module, exports) {

$parcel$export(module.exports, "trackNavigationTimings", () => $50116aa6c1259cb4$export$8e38110c52840b40);

var $ly0px = parcelRequire("ly0px");

var $iSyQp = parcelRequire("iSyQp");
function $50116aa6c1259cb4$export$8e38110c52840b40(lifeCycle, callback) {
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */ , function(entries) {
        for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
            var entry = entries_1[_i];
            if (entry.entryType === (0, $iSyQp.RumPerformanceEntryType).NAVIGATION) callback({
                domComplete: entry.domComplete,
                domContentLoaded: entry.domContentLoadedEventEnd,
                domInteractive: entry.domInteractive,
                loadEvent: entry.loadEventEnd,
                // In some cases the value reported is negative or is larger
                // than the current page time. Ignore these cases:
                // https://github.com/GoogleChrome/web-vitals/issues/137
                // https://github.com/GoogleChrome/web-vitals/issues/162
                firstByte: entry.responseStart >= 0 && entry.responseStart <= (0, $ly0px.relativeNow)() ? entry.responseStart : undefined
            });
        }
    }).unsubscribe;
    return {
        stop: stop
    };
}

});

parcelRegister("iSkz6", function(module, exports) {

$parcel$export(module.exports, "trackLargestContentfulPaint", () => $dbdd38f12feaea8d$export$e39d61369fabf03f);

var $hXhfS = parcelRequire("hXhfS");
var $fhNdh = parcelRequire("fhNdh");
var $k2pmh = parcelRequire("k2pmh");
var $fkj4Q = parcelRequire("fkj4Q");
var $ly0px = parcelRequire("ly0px");

var $iSyQp = parcelRequire("iSyQp");

var $l3o7w = parcelRequire("l3o7w");
var $dbdd38f12feaea8d$export$5486837c6e61d9ac = 10 * (0, $ly0px.ONE_MINUTE);
var $dbdd38f12feaea8d$var$wrongLcpReported = false;
var $dbdd38f12feaea8d$var$previousLcp;
function $dbdd38f12feaea8d$export$e39d61369fabf03f(lifeCycle, configuration, firstHidden, eventTarget, callback) {
    // Ignore entries that come after the first user interaction. According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    var firstInteractionTimestamp = Infinity;
    var stopEventListener = (0, $hXhfS.addEventListeners)(configuration, eventTarget, [
        (0, $hXhfS.DOM_EVENT).POINTER_DOWN,
        (0, $hXhfS.DOM_EVENT).KEY_DOWN
    ], function(event) {
        firstInteractionTimestamp = event.timeStamp;
    }, {
        capture: true,
        once: true
    }).stop;
    var biggestLcpSize = 0;
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */ , function(entries) {
        var lcpEntry = (0, $fkj4Q.findLast)(entries, function(entry) {
            return entry.entryType === (0, $iSyQp.RumPerformanceEntryType).LARGEST_CONTENTFUL_PAINT && entry.startTime < firstInteractionTimestamp && entry.startTime < firstHidden.timeStamp && entry.startTime < $dbdd38f12feaea8d$export$5486837c6e61d9ac && // Ensure to get the LCP entry with the biggest size, see
            // https://bugs.chromium.org/p/chromium/issues/detail?id=1516655
            entry.size > biggestLcpSize;
        });
        if (lcpEntry) {
            var lcpTargetSelector = void 0;
            if (lcpEntry.element) lcpTargetSelector = (0, $l3o7w.getSelectorFromElement)(lcpEntry.element, configuration.actionNameAttribute);
            if ((0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).ZERO_LCP_TELEMETRY)) $dbdd38f12feaea8d$var$monitorLcpEntries(lcpEntry, entries.filter(function(entry) {
                return entry.entryType === (0, $iSyQp.RumPerformanceEntryType).LARGEST_CONTENTFUL_PAINT;
            }));
            callback({
                value: lcpEntry.startTime,
                targetSelector: lcpTargetSelector
            });
            biggestLcpSize = lcpEntry.size;
        }
    }).unsubscribe;
    return {
        stop: function() {
            stopEventListener();
            unsubscribeLifeCycle();
        }
    };
}
function $dbdd38f12feaea8d$var$monitorLcpEntries(lcpEntry, lcpEntries) {
    if ($dbdd38f12feaea8d$var$wrongLcpReported) return;
    var wrongLcpDetected = lcpEntry.startTime === 0 ? "LCP with startTime = 0" : $dbdd38f12feaea8d$var$previousLcp !== undefined && lcpEntry.startTime < $dbdd38f12feaea8d$var$previousLcp.startTime ? "LCP with startTime < previous LCP" : $dbdd38f12feaea8d$var$previousLcp !== undefined && lcpEntry.size < $dbdd38f12feaea8d$var$previousLcp.size ? "LCP with size < previous LCP" : undefined;
    if (wrongLcpDetected) {
        $dbdd38f12feaea8d$var$wrongLcpReported = true;
        (0, $fhNdh.addTelemetryDebug)(wrongLcpDetected, {
            debug: {
                entry: $dbdd38f12feaea8d$var$toSerializableLCP(lcpEntry),
                previousLcp: $dbdd38f12feaea8d$var$previousLcp,
                timeOrigin: performance.timeOrigin,
                now: (0, $ly0px.relativeNow)(),
                lcpEntries: lcpEntries.map($dbdd38f12feaea8d$var$toSerializableLCP)
            }
        });
    }
    $dbdd38f12feaea8d$var$previousLcp = $dbdd38f12feaea8d$var$toSerializableLCP(lcpEntry);
}
function $dbdd38f12feaea8d$var$toSerializableLCP(entry) {
    var jsonEntry = entry.toJSON();
    delete jsonEntry.element;
    return jsonEntry;
}

});

parcelRegister("7ODjH", function(module, exports) {

$parcel$export(module.exports, "trackFirstHidden", () => $5b0bb36cbb3dba14$export$42b1d249aa2dee14);

var $hXhfS = parcelRequire("hXhfS");
function $5b0bb36cbb3dba14$export$42b1d249aa2dee14(configuration, eventTarget) {
    if (eventTarget === void 0) eventTarget = window;
    var timeStamp;
    var stopListeners;
    if (document.visibilityState === "hidden") timeStamp = 0;
    else {
        timeStamp = Infinity;
        stopListeners = (0, $hXhfS.addEventListeners)(configuration, eventTarget, [
            (0, $hXhfS.DOM_EVENT).PAGE_HIDE,
            (0, $hXhfS.DOM_EVENT).VISIBILITY_CHANGE
        ], function(event) {
            if (event.type === (0, $hXhfS.DOM_EVENT).PAGE_HIDE || document.visibilityState === "hidden") {
                timeStamp = event.timeStamp;
                stopListeners();
            }
        }, {
            capture: true
        }).stop;
    }
    return {
        get timeStamp () {
            return timeStamp;
        },
        stop: function() {
            stopListeners === null || stopListeners === void 0 || stopListeners();
        }
    };
}

});


parcelRegister("8pGpX", function(module, exports) {

$parcel$export(module.exports, "trackCommonViewMetrics", () => $62018fc84db9011a$export$b84f637a03e61a8d);

var $b27o3 = parcelRequire("b27o3");

var $eoPDb = parcelRequire("eoPDb");

var $8I4iK = parcelRequire("8I4iK");

var $fc9Xx = parcelRequire("fc9Xx");
function $62018fc84db9011a$export$b84f637a03e61a8d(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    var commonViewMetrics = {};
    var _a = (0, $8I4iK.trackLoadingTime)(lifeCycle, domMutationObservable, configuration, loadingType, viewStart, function(newLoadingTime) {
        commonViewMetrics.loadingTime = newLoadingTime;
        scheduleViewUpdate();
    }), stopLoadingTimeTracking = _a.stop, setLoadEvent = _a.setLoadEvent;
    var stopScrollMetricsTracking = (0, $fc9Xx.trackScrollMetrics)(configuration, viewStart, function(newScrollMetrics) {
        commonViewMetrics.scroll = newScrollMetrics;
    }).stop;
    var stopCLSTracking = (0, $b27o3.trackCumulativeLayoutShift)(configuration, lifeCycle, function(cumulativeLayoutShift) {
        commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
        scheduleViewUpdate();
    }).stop;
    var _b = (0, $eoPDb.trackInteractionToNextPaint)(configuration, viewStart.relative, loadingType, lifeCycle), stopINPTracking = _b.stop, getInteractionToNextPaint = _b.getInteractionToNextPaint, setViewEnd = _b.setViewEnd;
    return {
        stop: function() {
            stopLoadingTimeTracking();
            stopCLSTracking();
            stopScrollMetricsTracking();
        },
        stopINPTracking: stopINPTracking,
        setLoadEvent: setLoadEvent,
        setViewEnd: setViewEnd,
        getCommonViewMetrics: function() {
            commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
            return commonViewMetrics;
        }
    };
}

});
parcelRegister("b27o3", function(module, exports) {

$parcel$export(module.exports, "trackCumulativeLayoutShift", () => $80859c8865436c7c$export$da6e6ed807ae3512);

var $fkj4Q = parcelRequire("fkj4Q");
var $aed8w = parcelRequire("aed8w");
var $ly0px = parcelRequire("ly0px");
var $bQmeT = parcelRequire("bQmeT");

var $4TGNe = parcelRequire("4TGNe");

var $iSyQp = parcelRequire("iSyQp");

var $l3o7w = parcelRequire("l3o7w");
function $80859c8865436c7c$export$da6e6ed807ae3512(configuration, lifeCycle, callback) {
    if (!$80859c8865436c7c$export$fc2cd0a8db29c298()) return {
        stop: (0, $aed8w.noop)
    };
    var maxClsValue = 0;
    // if no layout shift happen the value should be reported as 0
    callback({
        value: 0
    });
    var window = $80859c8865436c7c$var$slidingSessionWindow();
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */ , function(entries) {
        for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
            var entry = entries_1[_i];
            if (entry.entryType === (0, $iSyQp.RumPerformanceEntryType).LAYOUT_SHIFT && !entry.hadRecentInput) {
                window.update(entry);
                if (window.value() > maxClsValue) {
                    maxClsValue = window.value();
                    var cls = (0, $bQmeT.round)(maxClsValue, 4);
                    var clsTarget = window.largestLayoutShiftTarget();
                    var cslTargetSelector = void 0;
                    if (clsTarget && // Check if the CLS target have been removed from the DOM between the time we collect the target reference and when we compute the selector
                    clsTarget.isConnected) cslTargetSelector = (0, $l3o7w.getSelectorFromElement)(clsTarget, configuration.actionNameAttribute);
                    callback({
                        value: cls,
                        targetSelector: cslTargetSelector
                    });
                }
            }
        }
    }).unsubscribe;
    return {
        stop: stop
    };
}
function $80859c8865436c7c$var$slidingSessionWindow() {
    var value = 0;
    var startTime;
    var endTime;
    var largestLayoutShift = 0;
    var largestLayoutShiftTarget;
    var largestLayoutShiftTime;
    return {
        update: function(entry) {
            var _a, _b;
            var shouldCreateNewWindow = startTime === undefined || entry.startTime - endTime >= (0, $ly0px.ONE_SECOND) || entry.startTime - startTime >= 5 * (0, $ly0px.ONE_SECOND);
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                value = entry.value;
                largestLayoutShift = 0;
                largestLayoutShiftTarget = undefined;
            } else {
                value += entry.value;
                endTime = entry.startTime;
            }
            if (entry.value > largestLayoutShift) {
                largestLayoutShift = entry.value;
                largestLayoutShiftTime = entry.startTime;
                if ((_a = entry.sources) === null || _a === void 0 ? void 0 : _a.length) largestLayoutShiftTarget = (_b = (0, $fkj4Q.find)(entry.sources, function(s) {
                    return !!s.node && (0, $4TGNe.isElementNode)(s.node);
                })) === null || _b === void 0 ? void 0 : _b.node;
                else largestLayoutShiftTarget = undefined;
            }
        },
        value: function() {
            return value;
        },
        largestLayoutShiftTarget: function() {
            return largestLayoutShiftTarget;
        },
        largestLayoutShiftTime: function() {
            return largestLayoutShiftTime;
        }
    };
}
function $80859c8865436c7c$export$fc2cd0a8db29c298() {
    return (0, $iSyQp.supportPerformanceTimingEvent)((0, $iSyQp.RumPerformanceEntryType).LAYOUT_SHIFT);
}

});

parcelRegister("eoPDb", function(module, exports) {

$parcel$export(module.exports, "trackInteractionToNextPaint", () => $a7bb5b6dbe4d2a3a$export$21a417d4761d0ac9);

var $aed8w = parcelRequire("aed8w");
var $ly0px = parcelRequire("ly0px");

var $iSyQp = parcelRequire("iSyQp");

var $l3o7w = parcelRequire("l3o7w");

var $4TGNe = parcelRequire("4TGNe");

var $iu7w6 = parcelRequire("iu7w6");
// Arbitrary value to prevent unnecessary memory usage on views with lots of interactions.
var $a7bb5b6dbe4d2a3a$var$MAX_INTERACTION_ENTRIES = 10;
var $a7bb5b6dbe4d2a3a$export$7cc919a034f18bad = 1 * (0, $ly0px.ONE_MINUTE);
function $a7bb5b6dbe4d2a3a$export$21a417d4761d0ac9(configuration, viewStart, viewLoadingType, lifeCycle) {
    if (!$a7bb5b6dbe4d2a3a$export$8abc245381a65a8f()) return {
        getInteractionToNextPaint: function() {
            return undefined;
        },
        setViewEnd: (0, $aed8w.noop),
        stop: (0, $aed8w.noop)
    };
    var _a = $a7bb5b6dbe4d2a3a$export$cd95581cdbd15637(viewLoadingType), getViewInteractionCount = _a.getViewInteractionCount, stopViewInteractionCount = _a.stopViewInteractionCount;
    var viewEnd = Infinity;
    var longestInteractions = $a7bb5b6dbe4d2a3a$var$trackLongestInteractions(getViewInteractionCount);
    var interactionToNextPaint = -1;
    var interactionToNextPaintTargetSelector;
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */ , function(entries) {
        for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
            var entry = entries_1[_i];
            if ((entry.entryType === (0, $iSyQp.RumPerformanceEntryType).EVENT || entry.entryType === (0, $iSyQp.RumPerformanceEntryType).FIRST_INPUT) && entry.interactionId && // Check the entry start time is inside the view bounds because some view interactions can be reported after the view end (if long duration).
            entry.startTime >= viewStart && entry.startTime <= viewEnd) longestInteractions.process(entry);
        }
        var newInteraction = longestInteractions.estimateP98Interaction();
        if (newInteraction && newInteraction.duration !== interactionToNextPaint) {
            interactionToNextPaint = newInteraction.duration;
            if (newInteraction.target && (0, $4TGNe.isElementNode)(newInteraction.target)) interactionToNextPaintTargetSelector = (0, $l3o7w.getSelectorFromElement)(newInteraction.target, configuration.actionNameAttribute);
            else interactionToNextPaintTargetSelector = undefined;
        }
    }).unsubscribe;
    return {
        getInteractionToNextPaint: function() {
            // If no INP duration where captured because of the performanceObserver 40ms threshold
            // but the view interaction count > 0 then report 0
            if (interactionToNextPaint >= 0) return {
                value: Math.min(interactionToNextPaint, $a7bb5b6dbe4d2a3a$export$7cc919a034f18bad),
                targetSelector: interactionToNextPaintTargetSelector
            };
            else if (getViewInteractionCount()) return {
                value: 0
            };
        },
        setViewEnd: function(viewEndTime) {
            viewEnd = viewEndTime;
            stopViewInteractionCount();
        },
        stop: stop
    };
}
function $a7bb5b6dbe4d2a3a$var$trackLongestInteractions(getViewInteractionCount) {
    var longestInteractions = [];
    function sortAndTrimLongestInteractions() {
        longestInteractions.sort(function(a, b) {
            return b.duration - a.duration;
        }).splice($a7bb5b6dbe4d2a3a$var$MAX_INTERACTION_ENTRIES);
    }
    return {
        /**
         * Process the performance entry:
         * - if its duration is long enough, add the performance entry to the list of worst interactions
         * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
         */ process: function(entry) {
            var interactionIndex = longestInteractions.findIndex(function(interaction) {
                return entry.interactionId === interaction.interactionId;
            });
            var minLongestInteraction = longestInteractions[longestInteractions.length - 1];
            if (interactionIndex !== -1) {
                if (entry.duration > longestInteractions[interactionIndex].duration) {
                    longestInteractions[interactionIndex] = entry;
                    sortAndTrimLongestInteractions();
                }
            } else if (longestInteractions.length < $a7bb5b6dbe4d2a3a$var$MAX_INTERACTION_ENTRIES || entry.duration > minLongestInteraction.duration) {
                longestInteractions.push(entry);
                sortAndTrimLongestInteractions();
            }
        },
        /**
         * Compute the p98 longest interaction.
         * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
         */ estimateP98Interaction: function() {
            var interactionIndex = Math.min(longestInteractions.length - 1, Math.floor(getViewInteractionCount() / 50));
            return longestInteractions[interactionIndex];
        }
    };
}
function $a7bb5b6dbe4d2a3a$export$cd95581cdbd15637(viewLoadingType) {
    (0, $iu7w6.initInteractionCountPolyfill)();
    var previousInteractionCount = viewLoadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */  ? 0 : (0, $iu7w6.getInteractionCount)();
    var state = {
        stopped: false
    };
    function computeViewInteractionCount() {
        return (0, $iu7w6.getInteractionCount)() - previousInteractionCount;
    }
    return {
        getViewInteractionCount: function() {
            if (state.stopped) return state.interactionCount;
            return computeViewInteractionCount();
        },
        stopViewInteractionCount: function() {
            state = {
                stopped: true,
                interactionCount: computeViewInteractionCount()
            };
        }
    };
}
function $a7bb5b6dbe4d2a3a$export$8abc245381a65a8f() {
    return (0, $iSyQp.supportPerformanceTimingEvent)((0, $iSyQp.RumPerformanceEntryType).EVENT) && window.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype;
}

});
parcelRegister("iu7w6", function(module, exports) {

$parcel$export(module.exports, "initInteractionCountPolyfill", () => $d750dc04d0ff821b$export$67d90cda6b78a2eb);
$parcel$export(module.exports, "getInteractionCount", () => $d750dc04d0ff821b$export$8a962f2683a476d1);
/**
 * performance.interactionCount polyfill
 *
 * The interactionCount is an integer which counts the total number of distinct user interactions,
 * for which there was a unique interactionId.
 *
 * The interactionCount polyfill is an estimate based on a convention specific to Chrome. Cf: https://github.com/GoogleChrome/web-vitals/pull/213
 * This is currently not an issue as the polyfill is only used for INP which is currently only supported on Chrome.
 * Hopefully when/if other browsers will support INP, they will also implement performance.interactionCount at the same time, so we won't need that polyfill.
 *
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
 */ 
var $2wH3Z = parcelRequire("2wH3Z");
var $d750dc04d0ff821b$var$observer;
var $d750dc04d0ff821b$var$interactionCountEstimate = 0;
var $d750dc04d0ff821b$var$minKnownInteractionId = Infinity;
var $d750dc04d0ff821b$var$maxKnownInteractionId = 0;
function $d750dc04d0ff821b$export$67d90cda6b78a2eb() {
    if ("interactionCount" in performance || $d750dc04d0ff821b$var$observer) return;
    $d750dc04d0ff821b$var$observer = new window.PerformanceObserver((0, $2wH3Z.monitor)(function(entries) {
        entries.getEntries().forEach(function(e) {
            var entry = e;
            if (entry.interactionId) {
                $d750dc04d0ff821b$var$minKnownInteractionId = Math.min($d750dc04d0ff821b$var$minKnownInteractionId, entry.interactionId);
                $d750dc04d0ff821b$var$maxKnownInteractionId = Math.max($d750dc04d0ff821b$var$maxKnownInteractionId, entry.interactionId);
                $d750dc04d0ff821b$var$interactionCountEstimate = ($d750dc04d0ff821b$var$maxKnownInteractionId - $d750dc04d0ff821b$var$minKnownInteractionId) / 7 + 1;
            }
        });
    }));
    $d750dc04d0ff821b$var$observer.observe({
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
}
var $d750dc04d0ff821b$export$8a962f2683a476d1 = function() {
    return $d750dc04d0ff821b$var$observer ? $d750dc04d0ff821b$var$interactionCountEstimate : window.performance.interactionCount || 0;
};

});


parcelRegister("8I4iK", function(module, exports) {

$parcel$export(module.exports, "trackLoadingTime", () => $6575c4fa5823a893$export$58b2b8bfa724cb6f);

var $ly0px = parcelRequire("ly0px");

var $7oXOv = parcelRequire("7oXOv");
function $6575c4fa5823a893$export$58b2b8bfa724cb6f(lifeCycle, domMutationObservable, configuration, loadType, viewStart, callback) {
    var isWaitingForLoadEvent = loadType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */ ;
    var isWaitingForActivityLoadingTime = true;
    var loadingTimeCandidates = [];
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) callback(Math.max.apply(Math, loadingTimeCandidates));
    }
    var stop = (0, $7oXOv.waitPageActivityEnd)(lifeCycle, domMutationObservable, configuration, function(event) {
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) loadingTimeCandidates.push((0, $ly0px.elapsed)(viewStart.timeStamp, event.end));
            invokeCallbackIfAllCandidatesAreReceived();
        }
    }).stop;
    return {
        stop: stop,
        setLoadEvent: function(loadEvent) {
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        }
    };
}

});

parcelRegister("fc9Xx", function(module, exports) {

$parcel$export(module.exports, "trackScrollMetrics", () => $b0ffb3bb8ad90457$export$eeec767135e98c85);

var $hXhfS = parcelRequire("hXhfS");
var $ly0px = parcelRequire("ly0px");
var $2wH3Z = parcelRequire("2wH3Z");
var $4wc1a = parcelRequire("4wc1a");
var $aed8w = parcelRequire("aed8w");

var $fvpT8 = parcelRequire("fvpT8");

var $kom4r = parcelRequire("kom4r");
var $b0ffb3bb8ad90457$export$f01db56fd078c3a8 = (0, $ly0px.ONE_SECOND);
function $b0ffb3bb8ad90457$export$eeec767135e98c85(configuration, viewStart, callback, scrollValues) {
    if (scrollValues === void 0) scrollValues = $b0ffb3bb8ad90457$export$68a7c526e4759c01(configuration);
    var maxScrollDepth = 0;
    var maxScrollHeight = 0;
    var maxScrollHeightTime = 0;
    var subscription = scrollValues.subscribe(function(_a) {
        var scrollDepth = _a.scrollDepth, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight;
        var shouldUpdate = false;
        if (scrollDepth > maxScrollDepth) {
            maxScrollDepth = scrollDepth;
            shouldUpdate = true;
        }
        if (scrollHeight > maxScrollHeight) {
            maxScrollHeight = scrollHeight;
            var now = (0, $ly0px.relativeNow)();
            maxScrollHeightTime = (0, $ly0px.elapsed)(viewStart.relative, now);
            shouldUpdate = true;
        }
        if (shouldUpdate) callback({
            maxDepth: Math.min(maxScrollDepth, maxScrollHeight),
            maxDepthScrollTop: scrollTop,
            maxScrollHeight: maxScrollHeight,
            maxScrollHeightTime: maxScrollHeightTime
        });
    });
    return {
        stop: function() {
            return subscription.unsubscribe();
        }
    };
}
function $b0ffb3bb8ad90457$export$7819cf13be3ef65c() {
    var scrollTop = (0, $fvpT8.getScrollY)();
    var height = (0, $kom4r.getViewportDimension)().height;
    var scrollHeight = Math.round((document.scrollingElement || document.documentElement).scrollHeight);
    var scrollDepth = Math.round(height + scrollTop);
    return {
        scrollHeight: scrollHeight,
        scrollDepth: scrollDepth,
        scrollTop: scrollTop
    };
}
function $b0ffb3bb8ad90457$export$68a7c526e4759c01(configuration, throttleDuration) {
    if (throttleDuration === void 0) throttleDuration = $b0ffb3bb8ad90457$export$f01db56fd078c3a8;
    return new (0, $4wc1a.Observable)(function(observable) {
        function notify() {
            observable.notify($b0ffb3bb8ad90457$export$7819cf13be3ef65c());
        }
        if (window.ResizeObserver) {
            var throttledNotify_1 = (0, $aed8w.throttle)(notify, throttleDuration, {
                leading: false,
                trailing: true
            });
            var observerTarget_1 = document.scrollingElement || document.documentElement;
            var resizeObserver_1 = new ResizeObserver((0, $2wH3Z.monitor)(throttledNotify_1.throttled));
            resizeObserver_1.observe(observerTarget_1);
            var eventListener_1 = (0, $hXhfS.addEventListener)(configuration, window, (0, $hXhfS.DOM_EVENT).SCROLL, throttledNotify_1.throttled, {
                passive: true
            });
            return function() {
                throttledNotify_1.cancel();
                resizeObserver_1.unobserve(observerTarget_1);
                eventListener_1.stop();
            };
        }
    });
}

});
parcelRegister("fvpT8", function(module, exports) {

$parcel$export(module.exports, "getScrollX", () => $b49dd51dc1e7c0f8$export$1a2bd001e684a8d2);
$parcel$export(module.exports, "getScrollY", () => $b49dd51dc1e7c0f8$export$91aaad5752ba6e7);
function $b49dd51dc1e7c0f8$export$1a2bd001e684a8d2() {
    var scrollX;
    var visual = window.visualViewport;
    if (visual) scrollX = visual.pageLeft - visual.offsetLeft;
    else if (window.scrollX !== undefined) scrollX = window.scrollX;
    else scrollX = window.pageXOffset || 0;
    return Math.round(scrollX);
}
function $b49dd51dc1e7c0f8$export$91aaad5752ba6e7() {
    var scrollY;
    var visual = window.visualViewport;
    if (visual) scrollY = visual.pageTop - visual.offsetTop;
    else if (window.scrollY !== undefined) scrollY = window.scrollY;
    else scrollY = window.pageYOffset || 0;
    return Math.round(scrollY);
}

});

parcelRegister("kom4r", function(module, exports) {

$parcel$export(module.exports, "initViewportObservable", () => $ed872b54a9ace364$export$2c24cc613e51a50f);
$parcel$export(module.exports, "getViewportDimension", () => $ed872b54a9ace364$export$e79021d67c61dfbd);

var $hXhfS = parcelRequire("hXhfS");
var $4wc1a = parcelRequire("4wc1a");
var $aed8w = parcelRequire("aed8w");
var $ed872b54a9ace364$var$viewportObservable;
function $ed872b54a9ace364$export$2c24cc613e51a50f(configuration) {
    if (!$ed872b54a9ace364$var$viewportObservable) $ed872b54a9ace364$var$viewportObservable = $ed872b54a9ace364$export$36388875a0cf8990(configuration);
    return $ed872b54a9ace364$var$viewportObservable;
}
function $ed872b54a9ace364$export$36388875a0cf8990(configuration) {
    return new (0, $4wc1a.Observable)(function(observable) {
        var updateDimension = (0, $aed8w.throttle)(function() {
            observable.notify($ed872b54a9ace364$export$e79021d67c61dfbd());
        }, 200).throttled;
        return (0, $hXhfS.addEventListener)(configuration, window, (0, $hXhfS.DOM_EVENT).RESIZE, updateDimension, {
            capture: true,
            passive: true
        }).stop;
    });
}
function $ed872b54a9ace364$export$e79021d67c61dfbd() {
    var visual = window.visualViewport;
    if (visual) return {
        width: Number(visual.width * visual.scale),
        height: Number(visual.height * visual.scale)
    };
    return {
        width: Number(window.innerWidth || 0),
        height: Number(window.innerHeight || 0)
    };
}

});





parcelRegister("eptxg", function(module, exports) {

$parcel$export(module.exports, "startRumSessionManager", () => $a7da4f9da803eca2$export$8d80e7032209d4ab);
$parcel$export(module.exports, "startRumSessionManagerStub", () => $a7da4f9da803eca2$export$d66a130e714b81c0);

var $kFaIT = parcelRequire("kFaIT");
var $aed8w = parcelRequire("aed8w");
var $4wc1a = parcelRequire("4wc1a");
var $bQmeT = parcelRequire("bQmeT");
var $1q2aX = parcelRequire("1q2aX");
var $a7da4f9da803eca2$export$50ae25e0cd1ada34 = "rum";
function $a7da4f9da803eca2$export$8d80e7032209d4ab(configuration, lifeCycle, trackingConsentState) {
    var sessionManager = (0, $1q2aX.startSessionManager)(configuration, $a7da4f9da803eca2$export$50ae25e0cd1ada34, function(rawTrackingType) {
        return $a7da4f9da803eca2$var$computeSessionState(configuration, rawTrackingType);
    }, trackingConsentState);
    sessionManager.expireObservable.subscribe(function() {
        lifeCycle.notify(9 /* LifeCycleEventType.SESSION_EXPIRED */ );
    });
    sessionManager.renewObservable.subscribe(function() {
        lifeCycle.notify(10 /* LifeCycleEventType.SESSION_RENEWED */ );
    });
    return {
        findTrackedSession: function(startTime) {
            var session = sessionManager.findActiveSession(startTime);
            if (!session || !$a7da4f9da803eca2$var$isTypeTracked(session.trackingType)) return;
            return {
                id: session.id,
                sessionReplayAllowed: session.trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ 
            };
        },
        expire: sessionManager.expire,
        expireObservable: sessionManager.expireObservable
    };
}
function $a7da4f9da803eca2$export$d66a130e714b81c0() {
    var session = {
        id: "00000000-aaaa-0000-aaaa-000000000000",
        sessionReplayAllowed: (0, $kFaIT.bridgeSupports)("records" /* BridgeCapability.RECORDS */ )
    };
    return {
        findTrackedSession: function() {
            return session;
        },
        expire: (0, $aed8w.noop),
        expireObservable: new (0, $4wc1a.Observable)()
    };
}
function $a7da4f9da803eca2$var$computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if ($a7da4f9da803eca2$var$hasValidRumSession(rawTrackingType)) trackingType = rawTrackingType;
    else if (!(0, $bQmeT.performDraw)(configuration.sessionSampleRate)) trackingType = "0" /* RumTrackingType.NOT_TRACKED */ ;
    else if (!(0, $bQmeT.performDraw)(configuration.sessionReplaySampleRate)) trackingType = "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ ;
    else trackingType = "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ;
    return {
        trackingType: trackingType,
        isTracked: $a7da4f9da803eca2$var$isTypeTracked(trackingType)
    };
}
function $a7da4f9da803eca2$var$hasValidRumSession(trackingType) {
    return trackingType === "0" /* RumTrackingType.NOT_TRACKED */  || trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */  || trackingType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ ;
}
function $a7da4f9da803eca2$var$isTypeTracked(rumSessionType) {
    return rumSessionType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */  || rumSessionType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ;
}

});
parcelRegister("1q2aX", function(module, exports) {

$parcel$export(module.exports, "startSessionManager", () => $1089e830cf773e23$export$3b6b9a4f35a367c5);

var $4wc1a = parcelRequire("4wc1a");

var $80mka = parcelRequire("80mka");

var $ly0px = parcelRequire("ly0px");

var $hXhfS = parcelRequire("hXhfS");

var $d97UU = parcelRequire("d97UU");

var $5xfjl = parcelRequire("5xfjl");

var $9HnmS = parcelRequire("9HnmS");
var $1089e830cf773e23$export$3d1fb0c94cce8478 = (0, $ly0px.ONE_MINUTE);
var $1089e830cf773e23$var$SESSION_CONTEXT_TIMEOUT_DELAY = (0, $5xfjl.SESSION_TIME_OUT_DELAY);
var $1089e830cf773e23$var$stopCallbacks = [];
function $1089e830cf773e23$export$3b6b9a4f35a367c5(configuration, productKey, computeSessionState, trackingConsentState) {
    var renewObservable = new (0, $4wc1a.Observable)();
    var expireObservable = new (0, $4wc1a.Observable)();
    // TODO - Improve configuration type and remove assertion
    var sessionStore = (0, $9HnmS.startSessionStore)(configuration.sessionStoreStrategyType, productKey, computeSessionState);
    $1089e830cf773e23$var$stopCallbacks.push(function() {
        return sessionStore.stop();
    });
    var sessionContextHistory = new (0, $80mka.ValueHistory)($1089e830cf773e23$var$SESSION_CONTEXT_TIMEOUT_DELAY);
    $1089e830cf773e23$var$stopCallbacks.push(function() {
        return sessionContextHistory.stop();
    });
    sessionStore.renewObservable.subscribe(function() {
        sessionContextHistory.add(buildSessionContext(), (0, $ly0px.relativeNow)());
        renewObservable.notify();
    });
    sessionStore.expireObservable.subscribe(function() {
        expireObservable.notify();
        sessionContextHistory.closeActive((0, $ly0px.relativeNow)());
    });
    // We expand/renew session unconditionally as tracking consent is always granted when the session
    // manager is started.
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), (0, $ly0px.clocksOrigin)().relative);
    trackingConsentState.observable.subscribe(function() {
        if (trackingConsentState.isGranted()) sessionStore.expandOrRenewSession();
        else sessionStore.expire();
    });
    $1089e830cf773e23$var$trackActivity(configuration, function() {
        if (trackingConsentState.isGranted()) sessionStore.expandOrRenewSession();
    });
    $1089e830cf773e23$var$trackVisibility(configuration, function() {
        return sessionStore.expandSession();
    });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey]
        };
    }
    return {
        findActiveSession: function(startTime) {
            return sessionContextHistory.find(startTime);
        },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        expire: sessionStore.expire
    };
}
function $1089e830cf773e23$export$c08596f6814fce4f() {
    $1089e830cf773e23$var$stopCallbacks.forEach(function(e) {
        return e();
    });
    $1089e830cf773e23$var$stopCallbacks = [];
}
function $1089e830cf773e23$var$trackActivity(configuration, expandOrRenewSession) {
    var stop = (0, $hXhfS.addEventListeners)(configuration, window, [
        (0, $hXhfS.DOM_EVENT).CLICK,
        (0, $hXhfS.DOM_EVENT).TOUCH_START,
        (0, $hXhfS.DOM_EVENT).KEY_DOWN,
        (0, $hXhfS.DOM_EVENT).SCROLL
    ], expandOrRenewSession, {
        capture: true,
        passive: true
    }).stop;
    $1089e830cf773e23$var$stopCallbacks.push(stop);
}
function $1089e830cf773e23$var$trackVisibility(configuration, expandSession) {
    var expandSessionWhenVisible = function() {
        if (document.visibilityState === "visible") expandSession();
    };
    var stop = (0, $hXhfS.addEventListener)(configuration, document, (0, $hXhfS.DOM_EVENT).VISIBILITY_CHANGE, expandSessionWhenVisible).stop;
    $1089e830cf773e23$var$stopCallbacks.push(stop);
    var visibilityCheckInterval = (0, $d97UU.setInterval)(expandSessionWhenVisible, $1089e830cf773e23$export$3d1fb0c94cce8478);
    $1089e830cf773e23$var$stopCallbacks.push(function() {
        (0, $d97UU.clearInterval)(visibilityCheckInterval);
    });
}

});


parcelRegister("degsG", function(module, exports) {

$parcel$export(module.exports, "startRumBatch", () => $027c47a5a8d86b5f$export$33e6a2986ce7483);

var $j9iCm = parcelRequire("j9iCm");
var $fhNdh = parcelRequire("fhNdh");
var $a7s0L = parcelRequire("a7s0L");
function $027c47a5a8d86b5f$export$33e6a2986ce7483(configuration, lifeCycle, telemetryEventObservable, reportError, pageExitObservable, sessionExpireObservable, createEncoder) {
    var replica = configuration.replica;
    var batch = (0, $a7s0L.startBatchWithReplica)(configuration, {
        endpoint: configuration.rumEndpointBuilder,
        encoder: createEncoder(2 /* DeflateEncoderStreamId.RUM */ )
    }, replica && {
        endpoint: replica.rumEndpointBuilder,
        transformMessage: function(message) {
            return (0, $j9iCm.combine)(message, {
                application: {
                    id: replica.applicationId
                }
            });
        },
        encoder: createEncoder(3 /* DeflateEncoderStreamId.RUM_REPLICA */ )
    }, reportError, pageExitObservable, sessionExpireObservable);
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , function(serverRumEvent) {
        if (serverRumEvent.type === "view" /* RumEventType.VIEW */ ) batch.upsert(serverRumEvent, serverRumEvent.view.id);
        else batch.add(serverRumEvent);
    });
    telemetryEventObservable.subscribe(function(event) {
        return batch.add(event, (0, $fhNdh.isTelemetryReplicationAllowed)(configuration));
    });
    return batch;
}

});
parcelRegister("a7s0L", function(module, exports) {

$parcel$export(module.exports, "startBatchWithReplica", () => $75e0494d360c41c9$export$b8ccdd9bc4dcc76e);

var $c8B2g = parcelRequire("c8B2g");

var $3qksw = parcelRequire("3qksw");

var $cETgK = parcelRequire("cETgK");
function $75e0494d360c41c9$export$b8ccdd9bc4dcc76e(configuration, primary, replica, reportError, pageExitObservable, sessionExpireObservable) {
    var primaryBatch = createBatch(configuration, primary);
    var replicaBatch = replica && createBatch(configuration, replica);
    function createBatch(configuration, _a) {
        var endpoint = _a.endpoint, encoder = _a.encoder;
        return new (0, $c8B2g.Batch)(encoder, (0, $3qksw.createHttpRequest)(configuration, endpoint, configuration.batchBytesLimit, reportError), (0, $cETgK.createFlushController)({
            messagesLimit: configuration.batchMessagesLimit,
            bytesLimit: configuration.batchBytesLimit,
            durationLimit: configuration.flushTimeout,
            pageExitObservable: pageExitObservable,
            sessionExpireObservable: sessionExpireObservable
        }), configuration.messageBytesLimit);
    }
    return {
        flushObservable: primaryBatch.flushController.flushObservable,
        add: function(message, replicated) {
            if (replicated === void 0) replicated = true;
            primaryBatch.add(message);
            if (replicaBatch && replicated) replicaBatch.add(replica.transformMessage ? replica.transformMessage(message) : message);
        },
        upsert: function(message, key) {
            primaryBatch.upsert(message, key);
            if (replicaBatch) replicaBatch.upsert(replica.transformMessage ? replica.transformMessage(message) : message, key);
        },
        stop: function() {
            primaryBatch.stop();
            replicaBatch === null || replicaBatch === void 0 || replicaBatch.stop();
        }
    };
}

});
parcelRegister("c8B2g", function(module, exports) {

$parcel$export(module.exports, "Batch", () => $8d62f5e28b135c89$export$33b107562567fc47);

var $5IDGB = parcelRequire("5IDGB");

var $fkj4Q = parcelRequire("fkj4Q");

var $1gpLX = parcelRequire("1gpLX");

var $1W8NF = parcelRequire("1W8NF");

var $7S2uk = parcelRequire("7S2uk");
var $8d62f5e28b135c89$export$33b107562567fc47 = /** @class */ function() {
    function Batch(encoder, request, flushController, messageBytesLimit) {
        var _this = this;
        this.encoder = encoder;
        this.request = request;
        this.flushController = flushController;
        this.messageBytesLimit = messageBytesLimit;
        this.upsertBuffer = {};
        this.flushSubscription = this.flushController.flushObservable.subscribe(function(event) {
            return _this.flush(event);
        });
    }
    Batch.prototype.add = function(message) {
        this.addOrUpdate(message);
    };
    Batch.prototype.upsert = function(message, key) {
        this.addOrUpdate(message, key);
    };
    Batch.prototype.stop = function() {
        this.flushSubscription.unsubscribe();
    };
    Batch.prototype.flush = function(event) {
        var upsertMessages = (0, $fkj4Q.objectValues)(this.upsertBuffer).join("\n");
        this.upsertBuffer = {};
        var isPageExit = (0, $1gpLX.isPageExitReason)(event.reason);
        var send = isPageExit ? this.request.sendOnExit : this.request.send;
        if (isPageExit && // Note: checking that the encoder is async is not strictly needed, but it's an optimization:
        // if the encoder is async we need to send two requests in some cases (one for encoded data
        // and the other for non-encoded data). But if it's not async, we don't have to worry about
        // it and always send a single request.
        this.encoder.isAsync) {
            var encoderResult = this.encoder.finishSync();
            // Send encoded messages
            if (encoderResult.outputBytesCount) send($8d62f5e28b135c89$var$formatPayloadFromEncoder(encoderResult, event));
            // Send messages that are not yet encoded at this point
            var pendingMessages = [
                encoderResult.pendingData,
                upsertMessages
            ].filter(Boolean).join("\n");
            if (pendingMessages) send({
                data: pendingMessages,
                bytesCount: (0, $7S2uk.computeBytesCount)(pendingMessages),
                flushReason: event.reason
            });
        } else {
            if (upsertMessages) this.encoder.write(this.encoder.isEmpty ? upsertMessages : "\n".concat(upsertMessages));
            this.encoder.finish(function(encoderResult) {
                send($8d62f5e28b135c89$var$formatPayloadFromEncoder(encoderResult, event));
            });
        }
    };
    Batch.prototype.addOrUpdate = function(message, key) {
        var serializedMessage = (0, $1W8NF.jsonStringify)(message);
        var estimatedMessageBytesCount = this.encoder.estimateEncodedBytesCount(serializedMessage);
        if (estimatedMessageBytesCount >= this.messageBytesLimit) {
            (0, $5IDGB.display).warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB."));
            return;
        }
        if (this.hasMessageFor(key)) this.remove(key);
        this.push(serializedMessage, estimatedMessageBytesCount, key);
    };
    Batch.prototype.push = function(serializedMessage, estimatedMessageBytesCount, key) {
        var _this = this;
        this.flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
        if (key !== undefined) {
            this.upsertBuffer[key] = serializedMessage;
            this.flushController.notifyAfterAddMessage();
        } else this.encoder.write(this.encoder.isEmpty ? serializedMessage : "\n".concat(serializedMessage), function(realMessageBytesCount) {
            _this.flushController.notifyAfterAddMessage(realMessageBytesCount - estimatedMessageBytesCount);
        });
    };
    Batch.prototype.remove = function(key) {
        var removedMessage = this.upsertBuffer[key];
        delete this.upsertBuffer[key];
        var messageBytesCount = this.encoder.estimateEncodedBytesCount(removedMessage);
        this.flushController.notifyAfterRemoveMessage(messageBytesCount);
    };
    Batch.prototype.hasMessageFor = function(key) {
        return key !== undefined && this.upsertBuffer[key] !== undefined;
    };
    return Batch;
}();
function $8d62f5e28b135c89$var$formatPayloadFromEncoder(encoderResult, flushEvent) {
    var data;
    if (typeof encoderResult.output === "string") data = encoderResult.output;
    else data = new Blob([
        encoderResult.output
    ], {
        // This will set the 'Content-Type: text/plain' header. Reasoning:
        // * The intake rejects the request if there is no content type.
        // * The browser will issue CORS preflight requests if we set it to 'application/json', which
        // could induce higher intake load (and maybe has other impacts).
        // * Also it's not quite JSON, since we are concatenating multiple JSON objects separated by
        // new lines.
        type: "text/plain"
    });
    return {
        data: data,
        bytesCount: encoderResult.outputBytesCount,
        encoding: encoderResult.encoding,
        flushReason: flushEvent.reason
    };
}

});

parcelRegister("3qksw", function(module, exports) {

$parcel$export(module.exports, "createHttpRequest", () => $27e3ab8a1341cab4$export$58d47321b4325073);

var $fhNdh = parcelRequire("fhNdh");

var $2wH3Z = parcelRequire("2wH3Z");

var $hXhfS = parcelRequire("hXhfS");

var $4WwWt = parcelRequire("4WwWt");
function $27e3ab8a1341cab4$export$58d47321b4325073(configuration, endpointBuilder, bytesLimit, reportError) {
    var retryState = (0, $4WwWt.newRetryState)();
    var sendStrategyForRetry = function(payload, onResponse) {
        return $27e3ab8a1341cab4$export$4d5d13cecdd8b94d(configuration, endpointBuilder, bytesLimit, payload, onResponse);
    };
    return {
        send: function(payload) {
            (0, $4WwWt.sendWithRetryStrategy)(payload, retryState, sendStrategyForRetry, endpointBuilder.trackType, reportError);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */ sendOnExit: function(payload) {
            $27e3ab8a1341cab4$var$sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload);
        }
    };
}
function $27e3ab8a1341cab4$var$sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload) {
    var canUseBeacon = !!navigator.sendBeacon && payload.bytesCount < bytesLimit;
    if (canUseBeacon) try {
        var beaconUrl = endpointBuilder.build("beacon", payload);
        var isQueued = navigator.sendBeacon(beaconUrl, payload.data);
        if (isQueued) return;
    } catch (e) {
        $27e3ab8a1341cab4$var$reportBeaconError(e);
    }
    var xhrUrl = endpointBuilder.build("xhr", payload);
    $27e3ab8a1341cab4$export$998d51f5856d10f5(configuration, xhrUrl, payload.data);
}
var $27e3ab8a1341cab4$var$hasReportedBeaconError = false;
function $27e3ab8a1341cab4$var$reportBeaconError(e) {
    if (!$27e3ab8a1341cab4$var$hasReportedBeaconError) {
        $27e3ab8a1341cab4$var$hasReportedBeaconError = true;
        (0, $fhNdh.addTelemetryError)(e);
    }
}
function $27e3ab8a1341cab4$export$4d5d13cecdd8b94d(configuration, endpointBuilder, bytesLimit, payload, onResponse) {
    var canUseKeepAlive = $27e3ab8a1341cab4$var$isKeepAliveSupported() && payload.bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        var fetchUrl = endpointBuilder.build("fetch", payload);
        fetch(fetchUrl, {
            method: "POST",
            body: payload.data,
            keepalive: true,
            mode: "cors"
        }).then((0, $2wH3Z.monitor)(function(response) {
            return onResponse === null || onResponse === void 0 ? void 0 : onResponse({
                status: response.status,
                type: response.type
            });
        }), (0, $2wH3Z.monitor)(function() {
            var xhrUrl = endpointBuilder.build("xhr", payload);
            // failed to queue the request
            $27e3ab8a1341cab4$export$998d51f5856d10f5(configuration, xhrUrl, payload.data, onResponse);
        }));
    } else {
        var xhrUrl = endpointBuilder.build("xhr", payload);
        $27e3ab8a1341cab4$export$998d51f5856d10f5(configuration, xhrUrl, payload.data, onResponse);
    }
}
function $27e3ab8a1341cab4$var$isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && "keepalive" in new Request("http://a");
    } catch (_a) {
        return false;
    }
}
function $27e3ab8a1341cab4$export$998d51f5856d10f5(configuration, url, data, onResponse) {
    var request = new XMLHttpRequest();
    request.open("POST", url, true);
    if (data instanceof Blob) // When using a Blob instance, IE does not use its 'type' to define the 'Content-Type' header
    // automatically, so the intake request ends up being rejected with an HTTP status 415
    // Defining the header manually fixes this issue.
    request.setRequestHeader("Content-Type", data.type);
    (0, $hXhfS.addEventListener)(configuration, request, "loadend", function() {
        onResponse === null || onResponse === void 0 || onResponse({
            status: request.status
        });
    }, {
        // prevent multiple onResponse callbacks
        // if the xhr instance is reused by a third party
        once: true
    });
    request.send(data);
}

});
parcelRegister("4WwWt", function(module, exports) {

$parcel$export(module.exports, "sendWithRetryStrategy", () => $399621d7cfb3f6e5$export$96c9f5ab1844e401);
$parcel$export(module.exports, "newRetryState", () => $399621d7cfb3f6e5$export$1663dd4904e17e74);

var $d97UU = parcelRequire("d97UU");

var $ly0px = parcelRequire("ly0px");

var $7S2uk = parcelRequire("7S2uk");

var $8yLbx = parcelRequire("8yLbx");

var $1zKlK = parcelRequire("1zKlK");
var $399621d7cfb3f6e5$export$b0eb5f34be1e4aa5 = 80 * (0, $7S2uk.ONE_KIBI_BYTE);
var $399621d7cfb3f6e5$export$86ca45574dbc49bd = 32;
var $399621d7cfb3f6e5$export$5557f582a01f898f = 3 * (0, $7S2uk.ONE_MEBI_BYTE);
var $399621d7cfb3f6e5$export$ba196f7860333423 = (0, $ly0px.ONE_MINUTE);
var $399621d7cfb3f6e5$export$c3914d5086178577 = (0, $ly0px.ONE_SECOND);
function $399621d7cfb3f6e5$export$96c9f5ab1844e401(payload, state, sendStrategy, trackType, reportError) {
    if (state.transportStatus === 0 /* TransportStatus.UP */  && state.queuedPayloads.size() === 0 && state.bandwidthMonitor.canHandle(payload)) $399621d7cfb3f6e5$var$send(payload, state, sendStrategy, {
        onSuccess: function() {
            return $399621d7cfb3f6e5$var$retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */ , state, sendStrategy, trackType, reportError);
        },
        onFailure: function() {
            state.queuedPayloads.enqueue(payload);
            $399621d7cfb3f6e5$var$scheduleRetry(state, sendStrategy, trackType, reportError);
        }
    });
    else state.queuedPayloads.enqueue(payload);
}
function $399621d7cfb3f6e5$var$scheduleRetry(state, sendStrategy, trackType, reportError) {
    if (state.transportStatus !== 2 /* TransportStatus.DOWN */ ) return;
    (0, $d97UU.setTimeout)(function() {
        var payload = state.queuedPayloads.first();
        $399621d7cfb3f6e5$var$send(payload, state, sendStrategy, {
            onSuccess: function() {
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = $399621d7cfb3f6e5$export$c3914d5086178577;
                $399621d7cfb3f6e5$var$retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */ , state, sendStrategy, trackType, reportError);
            },
            onFailure: function() {
                state.currentBackoffTime = Math.min($399621d7cfb3f6e5$export$ba196f7860333423, state.currentBackoffTime * 2);
                $399621d7cfb3f6e5$var$scheduleRetry(state, sendStrategy, trackType, reportError);
            }
        });
    }, state.currentBackoffTime);
}
function $399621d7cfb3f6e5$var$send(payload, state, sendStrategy, _a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, function(response) {
        state.bandwidthMonitor.remove(payload);
        if (!$399621d7cfb3f6e5$var$shouldRetryRequest(response)) {
            state.transportStatus = 0 /* TransportStatus.UP */ ;
            onSuccess();
        } else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus = state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */  : 2 /* TransportStatus.DOWN */ ;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status
            };
            onFailure();
        }
    });
}
function $399621d7cfb3f6e5$var$retryQueuedPayloads(reason, state, sendStrategy, trackType, reportError) {
    if (reason === 0 /* RetryReason.AFTER_SUCCESS */  && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: "Reached max ".concat(trackType, " events size queued for upload: ").concat($399621d7cfb3f6e5$export$5557f582a01f898f / (0, $7S2uk.ONE_MEBI_BYTE), "MiB"),
            source: (0, $1zKlK.ErrorSource).AGENT,
            startClocks: (0, $ly0px.clocksNow)()
        });
        state.queueFullReported = true;
    }
    var previousQueue = state.queuedPayloads;
    state.queuedPayloads = $399621d7cfb3f6e5$var$newPayloadQueue();
    while(previousQueue.size() > 0)$399621d7cfb3f6e5$export$96c9f5ab1844e401(previousQueue.dequeue(), state, sendStrategy, trackType, reportError);
}
function $399621d7cfb3f6e5$var$shouldRetryRequest(response) {
    return response.type !== "opaque" && (response.status === 0 && !navigator.onLine || response.status === 408 || response.status === 429 || (0, $8yLbx.isServerError)(response.status));
}
function $399621d7cfb3f6e5$export$1663dd4904e17e74() {
    return {
        transportStatus: 0 /* TransportStatus.UP */ ,
        currentBackoffTime: $399621d7cfb3f6e5$export$c3914d5086178577,
        bandwidthMonitor: $399621d7cfb3f6e5$var$newBandwidthMonitor(),
        queuedPayloads: $399621d7cfb3f6e5$var$newPayloadQueue(),
        queueFullReported: false
    };
}
function $399621d7cfb3f6e5$var$newPayloadQueue() {
    var queue = [];
    return {
        bytesCount: 0,
        enqueue: function(payload) {
            if (this.isFull()) return;
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
        },
        first: function() {
            return queue[0];
        },
        dequeue: function() {
            var payload = queue.shift();
            if (payload) this.bytesCount -= payload.bytesCount;
            return payload;
        },
        size: function() {
            return queue.length;
        },
        isFull: function() {
            return this.bytesCount >= $399621d7cfb3f6e5$export$5557f582a01f898f;
        }
    };
}
function $399621d7cfb3f6e5$var$newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle: function(payload) {
            return this.ongoingRequestCount === 0 || this.ongoingByteCount + payload.bytesCount <= $399621d7cfb3f6e5$export$b0eb5f34be1e4aa5 && this.ongoingRequestCount < $399621d7cfb3f6e5$export$86ca45574dbc49bd;
        },
        add: function(payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove: function(payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        }
    };
}

});


parcelRegister("cETgK", function(module, exports) {

$parcel$export(module.exports, "createFlushController", () => $937417c8633ccd25$export$afc20ff9bd852d2b);

var $4wc1a = parcelRequire("4wc1a");

var $d97UU = parcelRequire("d97UU");
function $937417c8633ccd25$export$afc20ff9bd852d2b(_a) {
    var messagesLimit = _a.messagesLimit, bytesLimit = _a.bytesLimit, durationLimit = _a.durationLimit, pageExitObservable = _a.pageExitObservable, sessionExpireObservable = _a.sessionExpireObservable;
    var pageExitSubscription = pageExitObservable.subscribe(function(event) {
        return flush(event.reason);
    });
    var sessionExpireSubscription = sessionExpireObservable.subscribe(function() {
        return flush("session_expire");
    });
    var flushObservable = new (0, $4wc1a.Observable)(function() {
        return function() {
            pageExitSubscription.unsubscribe();
            sessionExpireSubscription.unsubscribe();
        };
    });
    var currentBytesCount = 0;
    var currentMessagesCount = 0;
    function flush(flushReason) {
        if (currentMessagesCount === 0) return;
        var messagesCount = currentMessagesCount;
        var bytesCount = currentBytesCount;
        currentMessagesCount = 0;
        currentBytesCount = 0;
        cancelDurationLimitTimeout();
        flushObservable.notify({
            reason: flushReason,
            messagesCount: messagesCount,
            bytesCount: bytesCount
        });
    }
    var durationLimitTimeoutId;
    function scheduleDurationLimitTimeout() {
        if (durationLimitTimeoutId === undefined) durationLimitTimeoutId = (0, $d97UU.setTimeout)(function() {
            flush("duration_limit");
        }, durationLimit);
    }
    function cancelDurationLimitTimeout() {
        (0, $d97UU.clearTimeout)(durationLimitTimeoutId);
        durationLimitTimeoutId = undefined;
    }
    return {
        flushObservable: flushObservable,
        get messagesCount () {
            return currentMessagesCount;
        },
        /**
         * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right before adding the message, so no flush
         * event can happen after `notifyBeforeAddMessage` and before adding the message.
         *
         * @param estimatedMessageBytesCount: an estimation of the message bytes count once it is
         * actually added.
         */ notifyBeforeAddMessage: function(estimatedMessageBytesCount) {
            if (currentBytesCount + estimatedMessageBytesCount >= bytesLimit) flush("bytes_limit");
            // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
            // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
            // to notify when a flush is needed (for example on page exit).
            currentMessagesCount += 1;
            currentBytesCount += estimatedMessageBytesCount;
            scheduleDurationLimitTimeout();
        },
        /**
         * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
         *
         * This function can be called asynchronously after the message was added, but in this case it
         * should not be called if a flush event occurred in between.
         *
         * @param messageBytesCountDiff: the difference between the estimated message bytes count and
         * its actual bytes count once added to the pool.
         */ notifyAfterAddMessage: function(messageBytesCountDiff) {
            if (messageBytesCountDiff === void 0) messageBytesCountDiff = 0;
            currentBytesCount += messageBytesCountDiff;
            if (currentMessagesCount >= messagesLimit) flush("messages_limit");
            else if (currentBytesCount >= bytesLimit) flush("bytes_limit");
        },
        /**
         * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right after removing the message, so no flush
         * event can happen after removing the message and before `notifyAfterRemoveMessage`.
         *
         * @param messageBytesCount: the message bytes count that was added to the pool. Should
         * correspond to the sum of bytes counts passed to `notifyBeforeAddMessage` and
         * `notifyAfterAddMessage`.
         */ notifyAfterRemoveMessage: function(messageBytesCount) {
            currentBytesCount -= messageBytesCount;
            currentMessagesCount -= 1;
            if (currentMessagesCount === 0) cancelDurationLimitTimeout();
        }
    };
}

});



parcelRegister("axlOu", function(module, exports) {

$parcel$export(module.exports, "startRumEventBridge", () => $7abde8201394e230$export$38cafc1b8954ea9d);

var $kFaIT = parcelRequire("kFaIT");
function $7abde8201394e230$export$38cafc1b8954ea9d(lifeCycle) {
    var bridge = (0, $kFaIT.getEventBridge)();
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , function(serverRumEvent) {
        bridge.send("rum", serverRumEvent);
    });
}

});

parcelRegister("kXNZh", function(module, exports) {

$parcel$export(module.exports, "startUrlContexts", () => $f43017d046384f22$export$a9a4d4dde99a99fd);

var $ly0px = parcelRequire("ly0px");
var $5xfjl = parcelRequire("5xfjl");
var $80mka = parcelRequire("80mka");
var $f43017d046384f22$export$e5d2b82a8e642e14 = (0, $5xfjl.SESSION_TIME_OUT_DELAY);
function $f43017d046384f22$export$a9a4d4dde99a99fd(lifeCycle, locationChangeObservable, location) {
    var urlContextHistory = new (0, $80mka.ValueHistory)($f43017d046384f22$export$e5d2b82a8e642e14);
    var previousViewUrl;
    lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */ , function(_a) {
        var startClocks = _a.startClocks;
        var viewUrl = location.href;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */ , function(_a) {
        var endClocks = _a.endClocks;
        urlContextHistory.closeActive(endClocks.relative);
    });
    var locationChangeSubscription = locationChangeObservable.subscribe(function(_a) {
        var newLocation = _a.newLocation;
        var current = urlContextHistory.find();
        if (current) {
            var changeTime = (0, $ly0px.relativeNow)();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.referrer
            }), changeTime);
        }
    });
    function buildUrlContext(_a) {
        var url = _a.url, referrer = _a.referrer;
        return {
            url: url,
            referrer: referrer
        };
    }
    return {
        findUrl: function(startTime) {
            return urlContextHistory.find(startTime);
        },
        stop: function() {
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        }
    };
}

});

parcelRegister("3OSU7", function(module, exports) {

$parcel$export(module.exports, "createLocationChangeObservable", () => $2c80a16a9ac8d387$export$c2da1b41b3b918ce);

var $hXhfS = parcelRequire("hXhfS");
var $35a54 = parcelRequire("35a54");
var $4wc1a = parcelRequire("4wc1a");
var $8PiRA = parcelRequire("8PiRA");
function $2c80a16a9ac8d387$export$c2da1b41b3b918ce(configuration, location) {
    var currentLocation = (0, $8PiRA.shallowClone)(location);
    return new (0, $4wc1a.Observable)(function(observable) {
        var stopHistoryTracking = $2c80a16a9ac8d387$var$trackHistory(configuration, onLocationChange).stop;
        var stopHashTracking = $2c80a16a9ac8d387$var$trackHash(configuration, onLocationChange).stop;
        function onLocationChange() {
            if (currentLocation.href === location.href) return;
            var newLocation = (0, $8PiRA.shallowClone)(location);
            observable.notify({
                newLocation: newLocation,
                oldLocation: currentLocation
            });
            currentLocation = newLocation;
        }
        return function() {
            stopHistoryTracking();
            stopHashTracking();
        };
    });
}
function $2c80a16a9ac8d387$var$trackHistory(configuration, onHistoryChange) {
    var stopInstrumentingPushState = (0, $35a54.instrumentMethod)(history, "pushState", function(_a) {
        var onPostCall = _a.onPostCall;
        onPostCall(onHistoryChange);
    }).stop;
    var stopInstrumentingReplaceState = (0, $35a54.instrumentMethod)(history, "replaceState", function(_a) {
        var onPostCall = _a.onPostCall;
        onPostCall(onHistoryChange);
    }).stop;
    var removeListener = (0, $hXhfS.addEventListener)(configuration, window, (0, $hXhfS.DOM_EVENT).POP_STATE, onHistoryChange).stop;
    return {
        stop: function() {
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        }
    };
}
function $2c80a16a9ac8d387$var$trackHash(configuration, onHashChange) {
    return (0, $hXhfS.addEventListener)(configuration, window, (0, $hXhfS.DOM_EVENT).HASH_CHANGE, onHashChange);
}

});

parcelRegister("7hyCT", function(module, exports) {

$parcel$export(module.exports, "startFeatureFlagContexts", () => $54d4fafd542dd21e$export$9125b974ef9cfd53);

var $k2pmh = parcelRequire("k2pmh");
var $aed8w = parcelRequire("aed8w");
var $5xfjl = parcelRequire("5xfjl");
var $80mka = parcelRequire("80mka");
var $54d4fafd542dd21e$export$205c45090af638e0 = (0, $5xfjl.SESSION_TIME_OUT_DELAY);
var $54d4fafd542dd21e$export$e4441139afa265bd = 200;
function $54d4fafd542dd21e$export$9125b974ef9cfd53(lifeCycle, customerDataTracker) {
    if (!(0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).FEATURE_FLAGS)) return {
        findFeatureFlagEvaluations: function() {
            return undefined;
        },
        addFeatureFlagEvaluation: (0, $aed8w.noop),
        stop: (0, $aed8w.noop)
    };
    var featureFlagContexts = new (0, $80mka.ValueHistory)($54d4fafd542dd21e$export$205c45090af638e0);
    lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */ , function(_a) {
        var startClocks = _a.startClocks;
        featureFlagContexts.add({}, startClocks.relative);
        customerDataTracker.resetCustomerData();
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */ , function(_a) {
        var endClocks = _a.endClocks;
        featureFlagContexts.closeActive(endClocks.relative);
    });
    return {
        findFeatureFlagEvaluations: function(startTime) {
            return featureFlagContexts.find(startTime);
        },
        addFeatureFlagEvaluation: function(key, value) {
            var currentContext = featureFlagContexts.find();
            if (currentContext) {
                currentContext[key] = value;
                customerDataTracker.updateCustomerData(currentContext);
            }
        },
        stop: function() {
            return customerDataTracker.stop();
        }
    };
}

});

parcelRegister("lTMQC", function(module, exports) {

$parcel$export(module.exports, "startCustomerDataTelemetry", () => $ff14a02fd6cd1ddd$export$7cc15698fd3ea8d2);

var $fhNdh = parcelRequire("fhNdh");
var $fkj4Q = parcelRequire("fkj4Q");
var $ly0px = parcelRequire("ly0px");
var $bQmeT = parcelRequire("bQmeT");
var $d97UU = parcelRequire("d97UU");
var $ff14a02fd6cd1ddd$export$e9b7b62aafe04389 = 10 * (0, $ly0px.ONE_SECOND);
var $ff14a02fd6cd1ddd$var$currentPeriodMeasures;
var $ff14a02fd6cd1ddd$var$currentBatchMeasures;
var $ff14a02fd6cd1ddd$var$batchHasRumEvent;
function $ff14a02fd6cd1ddd$export$7cc15698fd3ea8d2(configuration, telemetry, lifeCycle, customerDataTrackerManager, batchFlushObservable) {
    var customerDataTelemetryEnabled = telemetry.enabled && (0, $bQmeT.performDraw)(configuration.customerDataTelemetrySampleRate);
    if (!customerDataTelemetryEnabled) return;
    $ff14a02fd6cd1ddd$var$initCurrentPeriodMeasures();
    $ff14a02fd6cd1ddd$var$initCurrentBatchMeasures();
    // We measure the data of every view updates even if there could only be one per batch due to the upsert
    // It means that contexts bytes count sums can be higher than it really is
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , function(event) {
        $ff14a02fd6cd1ddd$var$batchHasRumEvent = true;
        $ff14a02fd6cd1ddd$var$updateMeasure($ff14a02fd6cd1ddd$var$currentBatchMeasures.globalContextBytes, customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */ ).getBytesCount());
        $ff14a02fd6cd1ddd$var$updateMeasure($ff14a02fd6cd1ddd$var$currentBatchMeasures.userContextBytes, customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */ ).getBytesCount());
        $ff14a02fd6cd1ddd$var$updateMeasure($ff14a02fd6cd1ddd$var$currentBatchMeasures.featureFlagBytes, (0, $fkj4Q.includes)([
            "view" /* RumEventType.VIEW */ ,
            "error" /* RumEventType.ERROR */ 
        ], event.type) ? customerDataTrackerManager.getOrCreateTracker(0 /* CustomerDataType.FeatureFlag */ ).getBytesCount() : 0);
    });
    batchFlushObservable.subscribe(function(_a) {
        var bytesCount = _a.bytesCount, messagesCount = _a.messagesCount;
        // Don't measure batch that only contains telemetry events to avoid batch sending loop
        // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
        if (!$ff14a02fd6cd1ddd$var$batchHasRumEvent) return;
        $ff14a02fd6cd1ddd$var$currentPeriodMeasures.batchCount += 1;
        $ff14a02fd6cd1ddd$var$updateMeasure($ff14a02fd6cd1ddd$var$currentPeriodMeasures.batchBytesCount, bytesCount);
        $ff14a02fd6cd1ddd$var$updateMeasure($ff14a02fd6cd1ddd$var$currentPeriodMeasures.batchMessagesCount, messagesCount);
        $ff14a02fd6cd1ddd$var$mergeMeasure($ff14a02fd6cd1ddd$var$currentPeriodMeasures.globalContextBytes, $ff14a02fd6cd1ddd$var$currentBatchMeasures.globalContextBytes);
        $ff14a02fd6cd1ddd$var$mergeMeasure($ff14a02fd6cd1ddd$var$currentPeriodMeasures.userContextBytes, $ff14a02fd6cd1ddd$var$currentBatchMeasures.userContextBytes);
        $ff14a02fd6cd1ddd$var$mergeMeasure($ff14a02fd6cd1ddd$var$currentPeriodMeasures.featureFlagBytes, $ff14a02fd6cd1ddd$var$currentBatchMeasures.featureFlagBytes);
        $ff14a02fd6cd1ddd$var$initCurrentBatchMeasures();
    });
    (0, $d97UU.setInterval)($ff14a02fd6cd1ddd$var$sendCurrentPeriodMeasures, $ff14a02fd6cd1ddd$export$e9b7b62aafe04389);
}
function $ff14a02fd6cd1ddd$var$sendCurrentPeriodMeasures() {
    if ($ff14a02fd6cd1ddd$var$currentPeriodMeasures.batchCount === 0) return;
    (0, $fhNdh.addTelemetryDebug)("Customer data measures", $ff14a02fd6cd1ddd$var$currentPeriodMeasures);
    $ff14a02fd6cd1ddd$var$initCurrentPeriodMeasures();
}
function $ff14a02fd6cd1ddd$var$createMeasure() {
    return {
        min: Infinity,
        max: 0,
        sum: 0
    };
}
function $ff14a02fd6cd1ddd$var$updateMeasure(measure, value) {
    measure.sum += value;
    measure.min = Math.min(measure.min, value);
    measure.max = Math.max(measure.max, value);
}
function $ff14a02fd6cd1ddd$var$mergeMeasure(target, source) {
    target.sum += source.sum;
    target.min = Math.min(target.min, source.min);
    target.max = Math.max(target.max, source.max);
}
function $ff14a02fd6cd1ddd$var$initCurrentPeriodMeasures() {
    $ff14a02fd6cd1ddd$var$currentPeriodMeasures = {
        batchCount: 0,
        batchBytesCount: $ff14a02fd6cd1ddd$var$createMeasure(),
        batchMessagesCount: $ff14a02fd6cd1ddd$var$createMeasure(),
        globalContextBytes: $ff14a02fd6cd1ddd$var$createMeasure(),
        userContextBytes: $ff14a02fd6cd1ddd$var$createMeasure(),
        featureFlagBytes: $ff14a02fd6cd1ddd$var$createMeasure()
    };
}
function $ff14a02fd6cd1ddd$var$initCurrentBatchMeasures() {
    $ff14a02fd6cd1ddd$var$batchHasRumEvent = false;
    $ff14a02fd6cd1ddd$var$currentBatchMeasures = {
        globalContextBytes: $ff14a02fd6cd1ddd$var$createMeasure(),
        userContextBytes: $ff14a02fd6cd1ddd$var$createMeasure(),
        featureFlagBytes: $ff14a02fd6cd1ddd$var$createMeasure()
    };
}

});

parcelRegister("eZzeR", function(module, exports) {

$parcel$export(module.exports, "startPageStateHistory", () => $aea218dde2c0f936$export$7f01c272948a14b1);

var $hXhfS = parcelRequire("hXhfS");
var $ly0px = parcelRequire("ly0px");
var $5xfjl = parcelRequire("5xfjl");
var $80mka = parcelRequire("80mka");
var $aea218dde2c0f936$export$491f01a0e9b8b208 = 4000;
var $aea218dde2c0f936$export$b92c7553d298d075 = 500;
var $aea218dde2c0f936$export$20f880bb2b8d10f6 = (0, $5xfjl.SESSION_TIME_OUT_DELAY);
function $aea218dde2c0f936$export$7f01c272948a14b1(configuration, maxPageStateEntriesSelectable) {
    if (maxPageStateEntriesSelectable === void 0) maxPageStateEntriesSelectable = $aea218dde2c0f936$export$b92c7553d298d075;
    var pageStateEntryHistory = new (0, $80mka.ValueHistory)($aea218dde2c0f936$export$20f880bb2b8d10f6, $aea218dde2c0f936$export$491f01a0e9b8b208);
    var currentPageState;
    addPageState($aea218dde2c0f936$var$getPageState(), (0, $ly0px.relativeNow)());
    var stopEventListeners = (0, $hXhfS.addEventListeners)(configuration, window, [
        (0, $hXhfS.DOM_EVENT).PAGE_SHOW,
        (0, $hXhfS.DOM_EVENT).FOCUS,
        (0, $hXhfS.DOM_EVENT).BLUR,
        (0, $hXhfS.DOM_EVENT).VISIBILITY_CHANGE,
        (0, $hXhfS.DOM_EVENT).RESUME,
        (0, $hXhfS.DOM_EVENT).FREEZE,
        (0, $hXhfS.DOM_EVENT).PAGE_HIDE
    ], function(event) {
        addPageState($aea218dde2c0f936$var$computePageState(event), event.timeStamp);
    }, {
        capture: true
    }).stop;
    function addPageState(nextPageState, startTime) {
        if (startTime === void 0) startTime = (0, $ly0px.relativeNow)();
        if (nextPageState === currentPageState) return;
        currentPageState = nextPageState;
        pageStateEntryHistory.closeActive(startTime);
        pageStateEntryHistory.add({
            state: currentPageState,
            startTime: startTime
        }, startTime);
    }
    var pageStateHistory = {
        findAll: function(eventStartTime, duration) {
            var pageStateEntries = pageStateEntryHistory.findAll(eventStartTime, duration);
            if (pageStateEntries.length === 0) return;
            var pageStateServerEntries = [];
            // limit the number of entries to return
            var limit = Math.max(0, pageStateEntries.length - maxPageStateEntriesSelectable);
            // loop page state entries backward to return the selected ones in desc order
            for(var index = pageStateEntries.length - 1; index >= limit; index--){
                var pageState = pageStateEntries[index];
                // compute the start time relative to the event start time (ex: to be relative to the view start time)
                var relativeStartTime = (0, $ly0px.elapsed)(eventStartTime, pageState.startTime);
                pageStateServerEntries.push({
                    state: pageState.state,
                    start: (0, $ly0px.toServerDuration)(relativeStartTime)
                });
            }
            return pageStateServerEntries;
        },
        wasInPageStateAt: function(state, startTime) {
            return pageStateHistory.wasInPageStateDuringPeriod(state, startTime, 0);
        },
        wasInPageStateDuringPeriod: function(state, startTime, duration) {
            return pageStateEntryHistory.findAll(startTime, duration).some(function(pageState) {
                return pageState.state === state;
            });
        },
        addPageState: addPageState,
        stop: function() {
            stopEventListeners();
            pageStateEntryHistory.stop();
        }
    };
    return pageStateHistory;
}
function $aea218dde2c0f936$var$computePageState(event) {
    if (event.type === (0, $hXhfS.DOM_EVENT).FREEZE) return "frozen" /* PageState.FROZEN */ ;
    else if (event.type === (0, $hXhfS.DOM_EVENT).PAGE_HIDE) return event.persisted ? "frozen" /* PageState.FROZEN */  : "terminated" /* PageState.TERMINATED */ ;
    return $aea218dde2c0f936$var$getPageState();
}
function $aea218dde2c0f936$var$getPageState() {
    if (document.visibilityState === "hidden") return "hidden" /* PageState.HIDDEN */ ;
    if (document.hasFocus()) return "active" /* PageState.ACTIVE */ ;
    return "passive" /* PageState.PASSIVE */ ;
}

});

parcelRegister("btrZp", function(module, exports) {

$parcel$export(module.exports, "startDisplayContext", () => $85a81d4aa7a689fa$export$9b255c0d165a033f);

var $kom4r = parcelRequire("kom4r");
function $85a81d4aa7a689fa$export$9b255c0d165a033f(configuration) {
    var viewport = (0, $kom4r.getViewportDimension)();
    var unsubscribeViewport = (0, $kom4r.initViewportObservable)(configuration).subscribe(function(viewportDimension) {
        viewport = viewportDimension;
    }).unsubscribe;
    return {
        get: function() {
            return {
                viewport: viewport
            };
        },
        stop: unsubscribeViewport
    };
}

});

parcelRegister("aSnVp", function(module, exports) {

$parcel$export(module.exports, "startVitalCollection", () => $7eb1818b147a2865$export$1f5a51a997c60d35);

var $j9iCm = parcelRequire("j9iCm");
var $ly0px = parcelRequire("ly0px");
var $99fDv = parcelRequire("99fDv");
function $7eb1818b147a2865$export$1f5a51a997c60d35(lifeCycle, pageStateHistory) {
    var vitalStartsByName = new Map();
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , function() {
        // Discard all the vitals that have not been stopped to avoid memory leaks
        vitalStartsByName.clear();
    });
    function isValid(vital) {
        return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */ , vital.startClocks.relative, vital.value);
    }
    return {
        startDurationVital: function(vitalStart) {
            vitalStartsByName.set(vitalStart.name, vitalStart);
        },
        stopDurationVital: function(vitalStop) {
            var vitalStart = vitalStartsByName.get(vitalStop.name);
            if (!vitalStart) return;
            var vital = $7eb1818b147a2865$var$buildDurationVital(vitalStart, vitalStop);
            vitalStartsByName.delete(vital.name);
            if (isValid(vital)) lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $7eb1818b147a2865$var$processVital(vital));
        }
    };
}
function $7eb1818b147a2865$var$buildDurationVital(vitalStart, vitalStop) {
    return {
        name: vitalStart.name,
        type: "duration" /* VitalType.DURATION */ ,
        startClocks: vitalStart.startClocks,
        value: (0, $ly0px.elapsed)(vitalStart.startClocks.timeStamp, vitalStop.stopClocks.timeStamp),
        context: (0, $j9iCm.combine)(vitalStart.context, vitalStop.context)
    };
}
function $7eb1818b147a2865$var$processVital(vital) {
    var _a;
    return {
        rawRumEvent: {
            date: vital.startClocks.timeStamp,
            vital: {
                id: (0, $99fDv.generateUUID)(),
                type: vital.type,
                name: vital.name,
                custom: (_a = {}, _a[vital.name] = vital.value, _a)
            },
            type: "vital" /* RumEventType.VITAL */ 
        },
        startTime: vital.startClocks.relative,
        customerContext: vital.context,
        domainContext: {}
    };
}

});

parcelRegister("5FzGr", function(module, exports) {

$parcel$export(module.exports, "startCiVisibilityContext", () => $420c7617b51dc43d$export$121aef6278f2cce8);

var $4i26u = parcelRequire("4i26u");

var $6vNTK = parcelRequire("6vNTK");
var $420c7617b51dc43d$export$f848217ffff2b290 = "datadog-ci-visibility-test-execution-id";
function $420c7617b51dc43d$export$121aef6278f2cce8(configuration, cookieObservable) {
    var _a;
    if (cookieObservable === void 0) cookieObservable = (0, $6vNTK.createCookieObservable)(configuration, $420c7617b51dc43d$export$f848217ffff2b290);
    var testExecutionId = (0, $4i26u.getInitCookie)($420c7617b51dc43d$export$f848217ffff2b290) || ((_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env("traceId"));
    var cookieObservableSubscription = cookieObservable.subscribe(function(value) {
        testExecutionId = value;
    });
    return {
        get: function() {
            if (typeof testExecutionId === "string") return {
                test_execution_id: testExecutionId
            };
        },
        stop: function() {
            return cookieObservableSubscription.unsubscribe();
        }
    };
}

});
parcelRegister("6vNTK", function(module, exports) {

$parcel$export(module.exports, "createCookieObservable", () => $4bdc5815cbedd0b5$export$346054de39969c66);

var $hXhfS = parcelRequire("hXhfS");
var $d97UU = parcelRequire("d97UU");
var $fkj4Q = parcelRequire("fkj4Q");
var $99fDv = parcelRequire("99fDv");
var $4wc1a = parcelRequire("4wc1a");
var $ly0px = parcelRequire("ly0px");
function $4bdc5815cbedd0b5$export$346054de39969c66(configuration, cookieName) {
    var detectCookieChangeStrategy = window.cookieStore ? $4bdc5815cbedd0b5$var$listenToCookieStoreChange(configuration) : $4bdc5815cbedd0b5$var$watchCookieFallback;
    return new (0, $4wc1a.Observable)(function(observable) {
        return detectCookieChangeStrategy(cookieName, function(event) {
            return observable.notify(event);
        });
    });
}
function $4bdc5815cbedd0b5$var$listenToCookieStoreChange(configuration) {
    return function(cookieName, callback) {
        var listener = (0, $hXhfS.addEventListener)(configuration, window.cookieStore, (0, $hXhfS.DOM_EVENT).CHANGE, function(event) {
            // Based on our experimentation, we're assuming that entries for the same cookie cannot be in both the 'changed' and 'deleted' arrays.
            // However, due to ambiguity in the specification, we asked for clarification: https://github.com/WICG/cookie-store/issues/226
            var changeEvent = (0, $fkj4Q.find)(event.changed, function(event) {
                return event.name === cookieName;
            }) || (0, $fkj4Q.find)(event.deleted, function(event) {
                return event.name === cookieName;
            });
            if (changeEvent) callback(changeEvent.value);
        });
        return listener.stop;
    };
}
var $4bdc5815cbedd0b5$export$541bea9a14448c32 = (0, $ly0px.ONE_SECOND);
function $4bdc5815cbedd0b5$var$watchCookieFallback(cookieName, callback) {
    var previousCookieValue = (0, $99fDv.findCommaSeparatedValue)(document.cookie, cookieName);
    var watchCookieIntervalId = (0, $d97UU.setInterval)(function() {
        var cookieValue = (0, $99fDv.findCommaSeparatedValue)(document.cookie, cookieName);
        if (cookieValue !== previousCookieValue) callback(cookieValue);
    }, $4bdc5815cbedd0b5$export$541bea9a14448c32);
    return function() {
        (0, $d97UU.clearInterval)(watchCookieIntervalId);
    };
}

});



parcelRegister("dKooA", function(module, exports) {

$parcel$export(module.exports, "getSessionReplayUrl", () => $a0227eab1dbc844e$export$58d09b88d0d4cf52);

var $ahPEX = parcelRequire("ahPEX");
function $a0227eab1dbc844e$export$58d09b88d0d4cf52(configuration, _a) {
    var session = _a.session, viewContext = _a.viewContext, errorType = _a.errorType;
    var sessionId = session ? session.id : "no-session-id";
    var parameters = [];
    if (errorType !== undefined) parameters.push("error-type=".concat(errorType));
    if (viewContext) {
        parameters.push("seed=".concat(viewContext.id));
        parameters.push("from=".concat(viewContext.startClocks.timeStamp));
    }
    var origin = $a0227eab1dbc844e$export$63276db6097e2435(configuration);
    var path = "/rum/replay/sessions/".concat(sessionId);
    return "".concat(origin).concat(path, "?").concat(parameters.join("&"));
}
function $a0227eab1dbc844e$export$63276db6097e2435(rumConfiguration) {
    var site = rumConfiguration.site;
    var subdomain = rumConfiguration.subdomain || $a0227eab1dbc844e$var$getSiteDefaultSubdomain(rumConfiguration);
    return "https://".concat(subdomain ? "".concat(subdomain, ".") : "").concat(site);
}
function $a0227eab1dbc844e$var$getSiteDefaultSubdomain(configuration) {
    switch(configuration.site){
        case 0, $ahPEX.INTAKE_SITE_US1:
        case 0, $ahPEX.INTAKE_SITE_EU1:
            return "app";
        case 0, $ahPEX.INTAKE_SITE_STAGING:
            return "dd";
        default:
            return undefined;
    }
}

});


parcelRegister("jIcSw", function(module, exports) {

$parcel$export(module.exports, "startRecording", () => $e59c1dc0ff977688$export$9be9afda50c84681);

var $fhNdh = parcelRequire("fhNdh");
var $kFaIT = parcelRequire("kFaIT");
var $3qksw = parcelRequire("3qksw");
parcelRequire("FSiSI");
var $jVfR4 = parcelRequire("jVfR4");
parcelRequire("8s77k");
var $7X2dz = parcelRequire("7X2dz");

var $4IfYP = parcelRequire("4IfYP");
function $e59c1dc0ff977688$export$9be9afda50c84681(lifeCycle, configuration, sessionManager, viewContexts, encoder, httpRequest) {
    var cleanupTasks = [];
    var reportError = function(error) {
        lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
            error: error
        });
        (0, $fhNdh.addTelemetryDebug)("Error reported to customer", {
            "error.message": error.message
        });
    };
    var replayRequest = httpRequest || (0, $3qksw.createHttpRequest)(configuration, configuration.sessionReplayEndpointBuilder, (0, $7X2dz.SEGMENT_BYTES_LIMIT), reportError);
    var addRecord;
    if (!(0, $kFaIT.canUseEventBridge)()) {
        var segmentCollection = (0, $7X2dz.startSegmentCollection)(lifeCycle, configuration, sessionManager, viewContexts, replayRequest, encoder);
        addRecord = segmentCollection.addRecord;
        cleanupTasks.push(segmentCollection.stop);
    } else addRecord = (0, $4IfYP.startRecordBridge)(viewContexts).addRecord;
    var stopRecording = (0, $jVfR4.record)({
        emit: addRecord,
        configuration: configuration,
        lifeCycle: lifeCycle,
        viewContexts: viewContexts
    }).stop;
    cleanupTasks.push(stopRecording);
    return {
        stop: function() {
            cleanupTasks.forEach(function(task) {
                return task();
            });
        }
    };
}

});
parcelRegister("FSiSI", function(module, exports) {

$parcel$export(module.exports, "record", () => (parcelRequire("jVfR4")).record);

var $jVfR4 = parcelRequire("jVfR4");
parcelRequire("2yVFW");
var $73YKA = parcelRequire("73YKA");
var $8Updw = parcelRequire("8Updw");

var $g8Vdv = parcelRequire("g8Vdv");

});
parcelRegister("jVfR4", function(module, exports) {

$parcel$export(module.exports, "record", () => $e80fa3a4d7a561db$export$e5185e241753e543);

var $cfGi1 = parcelRequire("cfGi1");

var $j4d5H = parcelRequire("j4d5H");
parcelRequire("68oTy");
var $9znHG = parcelRequire("9znHG");
var $gfGf7 = parcelRequire("gfGf7");
var $fE9XA = parcelRequire("fE9XA");
var $kzezO = parcelRequire("kzezO");
var $8bZL4 = parcelRequire("8bZL4");
var $dm2SK = parcelRequire("dm2SK");
var $6lHNk = parcelRequire("6lHNk");
var $e7o3B = parcelRequire("e7o3B");
var $97NWT = parcelRequire("97NWT");
var $3CnsL = parcelRequire("3CnsL");
var $dLVZm = parcelRequire("dLVZm");

var $g8Vdv = parcelRequire("g8Vdv");

var $kLFSm = parcelRequire("kLFSm");

var $l1W1u = parcelRequire("l1W1u");

var $2wixe = parcelRequire("2wixe");
function $e80fa3a4d7a561db$export$e5185e241753e543(options) {
    var emit = options.emit, configuration = options.configuration, lifeCycle = options.lifeCycle;
    // runtime checks for user options
    if (!emit) throw new Error("emit function is required");
    var emitAndComputeStats = function(record) {
        emit(record);
        (0, $cfGi1.sendToExtension)("record", {
            record: record
        });
        var view = options.viewContexts.findView();
        $j4d5H.addRecord(view.id);
    };
    var elementsScrollPositions = (0, $g8Vdv.createElementsScrollPositions)();
    var shadowRootsController = (0, $kLFSm.initShadowRootsController)(configuration, {
        mutationCb: emitAndComputeStats,
        inputCb: emitAndComputeStats
    });
    var stopFullSnapshots = (0, $l1W1u.startFullSnapshots)(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, function(records) {
        return records.forEach(function(record) {
            return emitAndComputeStats(record);
        });
    }).stop;
    function flushMutations() {
        shadowRootsController.flush();
        mutationTracker.flush();
    }
    var recordIds = (0, $2wixe.initRecordIds)();
    var mutationTracker = (0, $6lHNk.trackMutation)(emitAndComputeStats, configuration, shadowRootsController, document);
    var trackers = [
        mutationTracker,
        (0, $dm2SK.trackMove)(configuration, emitAndComputeStats),
        (0, $8bZL4.trackMouseInteraction)(configuration, emitAndComputeStats, recordIds),
        (0, $e7o3B.trackScroll)(configuration, emitAndComputeStats, elementsScrollPositions),
        (0, $dLVZm.trackViewportResize)(configuration, emitAndComputeStats),
        (0, $fE9XA.trackInput)(configuration, emitAndComputeStats),
        (0, $kzezO.trackMediaInteraction)(configuration, emitAndComputeStats),
        (0, $97NWT.trackStyleSheet)(emitAndComputeStats),
        (0, $9znHG.trackFocus)(configuration, emitAndComputeStats),
        (0, $dLVZm.trackViewportResize)(configuration, emitAndComputeStats),
        (0, $gfGf7.trackFrustration)(lifeCycle, emitAndComputeStats, recordIds),
        (0, $3CnsL.trackViewEnd)(lifeCycle, function(viewEndRecord) {
            flushMutations();
            emitAndComputeStats(viewEndRecord);
        })
    ];
    return {
        stop: function() {
            shadowRootsController.stop();
            trackers.forEach(function(tracker) {
                return tracker.stop();
            });
            stopFullSnapshots();
        },
        flushMutations: flushMutations,
        shadowRootsController: shadowRootsController
    };
}

});
parcelRegister("j4d5H", function(module, exports) {

$parcel$export(module.exports, "getSegmentsCount", () => $de188ba0cd76f643$export$4223f4e280561ccd);
$parcel$export(module.exports, "addSegment", () => $de188ba0cd76f643$export$1c43f9ac826b6462);
$parcel$export(module.exports, "addRecord", () => $de188ba0cd76f643$export$ab0ab92b3cb31c66);
$parcel$export(module.exports, "addWroteData", () => $de188ba0cd76f643$export$ae4fdff69a4959e9);
$parcel$export(module.exports, "getReplayStats", () => $de188ba0cd76f643$export$92ac42d7bd545b2a);
var $de188ba0cd76f643$export$f10444a7271b7f1e = 10;
var $de188ba0cd76f643$var$statsPerView;
function $de188ba0cd76f643$export$4223f4e280561ccd(viewId) {
    return $de188ba0cd76f643$var$getOrCreateReplayStats(viewId).segments_count;
}
function $de188ba0cd76f643$export$1c43f9ac826b6462(viewId) {
    $de188ba0cd76f643$var$getOrCreateReplayStats(viewId).segments_count += 1;
}
function $de188ba0cd76f643$export$ab0ab92b3cb31c66(viewId) {
    $de188ba0cd76f643$var$getOrCreateReplayStats(viewId).records_count += 1;
}
function $de188ba0cd76f643$export$ae4fdff69a4959e9(viewId, additionalBytesCount) {
    $de188ba0cd76f643$var$getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function $de188ba0cd76f643$export$92ac42d7bd545b2a(viewId) {
    return $de188ba0cd76f643$var$statsPerView === null || $de188ba0cd76f643$var$statsPerView === void 0 ? void 0 : $de188ba0cd76f643$var$statsPerView.get(viewId);
}
function $de188ba0cd76f643$export$f6629d8f23dffc10() {
    $de188ba0cd76f643$var$statsPerView = undefined;
}
function $de188ba0cd76f643$var$getOrCreateReplayStats(viewId) {
    if (!$de188ba0cd76f643$var$statsPerView) $de188ba0cd76f643$var$statsPerView = new Map();
    var replayStats;
    if ($de188ba0cd76f643$var$statsPerView.has(viewId)) replayStats = $de188ba0cd76f643$var$statsPerView.get(viewId);
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0
        };
        $de188ba0cd76f643$var$statsPerView.set(viewId, replayStats);
        if ($de188ba0cd76f643$var$statsPerView.size > $de188ba0cd76f643$export$f10444a7271b7f1e) $de188ba0cd76f643$var$deleteOldestStats();
    }
    return replayStats;
}
function $de188ba0cd76f643$var$deleteOldestStats() {
    if (!$de188ba0cd76f643$var$statsPerView) return;
    if ($de188ba0cd76f643$var$statsPerView.keys) $de188ba0cd76f643$var$statsPerView.delete($de188ba0cd76f643$var$statsPerView.keys().next().value);
    else {
        // IE11 doesn't support map.keys
        var isFirst_1 = true;
        $de188ba0cd76f643$var$statsPerView.forEach(function(_value, key) {
            if (isFirst_1) {
                $de188ba0cd76f643$var$statsPerView.delete(key);
                isFirst_1 = false;
            }
        });
    }
}

});

parcelRegister("68oTy", function(module, exports) {

$parcel$export(module.exports, "trackMove", () => (parcelRequire("dm2SK")).trackMove);
$parcel$export(module.exports, "trackMouseInteraction", () => (parcelRequire("8bZL4")).trackMouseInteraction);
$parcel$export(module.exports, "trackScroll", () => (parcelRequire("e7o3B")).trackScroll);
$parcel$export(module.exports, "trackViewportResize", () => (parcelRequire("dLVZm")).trackViewportResize);
$parcel$export(module.exports, "trackMediaInteraction", () => (parcelRequire("kzezO")).trackMediaInteraction);
$parcel$export(module.exports, "trackStyleSheet", () => (parcelRequire("97NWT")).trackStyleSheet);
$parcel$export(module.exports, "trackFocus", () => (parcelRequire("9znHG")).trackFocus);
$parcel$export(module.exports, "trackFrustration", () => (parcelRequire("gfGf7")).trackFrustration);
$parcel$export(module.exports, "trackViewEnd", () => (parcelRequire("3CnsL")).trackViewEnd);
$parcel$export(module.exports, "trackInput", () => (parcelRequire("fE9XA")).trackInput);
$parcel$export(module.exports, "trackMutation", () => (parcelRequire("6lHNk")).trackMutation);

var $dm2SK = parcelRequire("dm2SK");

var $8bZL4 = parcelRequire("8bZL4");

var $e7o3B = parcelRequire("e7o3B");

var $dLVZm = parcelRequire("dLVZm");

var $kzezO = parcelRequire("kzezO");

var $97NWT = parcelRequire("97NWT");

var $9znHG = parcelRequire("9znHG");

var $gfGf7 = parcelRequire("gfGf7");

var $3CnsL = parcelRequire("3CnsL");

var $fE9XA = parcelRequire("fE9XA");

var $6lHNk = parcelRequire("6lHNk");

});
parcelRegister("dm2SK", function(module, exports) {

$parcel$export(module.exports, "trackMove", () => $9b8f90bfb8392fee$export$9dc14b2d5956f1cb);
$parcel$export(module.exports, "tryToComputeCoordinates", () => $9b8f90bfb8392fee$export$3267b4eb1312c189);

var $hXhfS = parcelRequire("hXhfS");
var $fhNdh = parcelRequire("fhNdh");
var $aed8w = parcelRequire("aed8w");
parcelRequire("2yVFW");
var $8P37p = parcelRequire("8P37p");
parcelRequire("aJSOq");
var $kWQO2 = parcelRequire("kWQO2");

var $dHerU = parcelRequire("dHerU");

var $fZRY4 = parcelRequire("fZRY4");

var $HhA2E = parcelRequire("HhA2E");
var $9b8f90bfb8392fee$var$MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
function $9b8f90bfb8392fee$export$9dc14b2d5956f1cb(configuration, moveCb) {
    var _a = (0, $aed8w.throttle)(function(event) {
        var target = (0, $dHerU.getEventTarget)(event);
        if ((0, $8P37p.hasSerializedNode)(target)) {
            var coordinates = $9b8f90bfb8392fee$export$3267b4eb1312c189(event);
            if (!coordinates) return;
            var position = {
                id: (0, $8P37p.getSerializedNodeId)(target),
                timeOffset: 0,
                x: coordinates.x,
                y: coordinates.y
            };
            moveCb((0, $HhA2E.assembleIncrementalSnapshot)((0, $dHerU.isTouchEvent)(event) ? (0, $kWQO2.IncrementalSource).TouchMove : (0, $kWQO2.IncrementalSource).MouseMove, {
                positions: [
                    position
                ]
            }));
        }
    }, $9b8f90bfb8392fee$var$MOUSE_MOVE_OBSERVER_THRESHOLD, {
        trailing: false
    }), updatePosition = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = (0, $hXhfS.addEventListeners)(configuration, document, [
        (0, $hXhfS.DOM_EVENT).MOUSE_MOVE,
        (0, $hXhfS.DOM_EVENT).TOUCH_MOVE
    ], updatePosition, {
        capture: true,
        passive: true
    }).stop;
    return {
        stop: function() {
            removeListener();
            cancelThrottle();
        }
    };
}
function $9b8f90bfb8392fee$export$3267b4eb1312c189(event) {
    var _a = (0, $dHerU.isTouchEvent)(event) ? event.changedTouches[0] : event, x = _a.clientX, y = _a.clientY;
    if (window.visualViewport) {
        var _b = (0, $fZRY4.convertMouseEventToLayoutCoordinates)(x, y), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
        x = visualViewportX;
        y = visualViewportY;
    }
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
        if (event.isTrusted) (0, $fhNdh.addTelemetryDebug)("mouse/touch event without x/y");
        return undefined;
    }
    return {
        x: x,
        y: y
    };
}

});
parcelRegister("2yVFW", function(module, exports) {

$parcel$export(module.exports, "getElementInputValue", () => (parcelRequire("8P37p")).getElementInputValue);
$parcel$export(module.exports, "getSerializedNodeId", () => (parcelRequire("8P37p")).getSerializedNodeId);
$parcel$export(module.exports, "hasSerializedNode", () => (parcelRequire("8P37p")).hasSerializedNode);
$parcel$export(module.exports, "nodeAndAncestorsHaveSerializedNode", () => (parcelRequire("8P37p")).nodeAndAncestorsHaveSerializedNode);
$parcel$export(module.exports, "serializeDocument", () => (parcelRequire("8Updw")).serializeDocument);
$parcel$export(module.exports, "serializeNodeWithId", () => (parcelRequire("73YKA")).serializeNodeWithId);
$parcel$export(module.exports, "serializeAttribute", () => (parcelRequire("1M37u")).serializeAttribute);

var $8P37p = parcelRequire("8P37p");

var $8Updw = parcelRequire("8Updw");

var $73YKA = parcelRequire("73YKA");

var $1M37u = parcelRequire("1M37u");

});
parcelRegister("8P37p", function(module, exports) {

$parcel$export(module.exports, "hasSerializedNode", () => $66c5816c46f245bb$export$baab016255f94f54);
$parcel$export(module.exports, "nodeAndAncestorsHaveSerializedNode", () => $66c5816c46f245bb$export$267b85776945782d);
$parcel$export(module.exports, "getSerializedNodeId", () => $66c5816c46f245bb$export$1cdf184f338e4a7b);
$parcel$export(module.exports, "setSerializedNodeId", () => $66c5816c46f245bb$export$8fed415004211d23);
$parcel$export(module.exports, "getElementInputValue", () => $66c5816c46f245bb$export$9a014d2606da64f5);
$parcel$export(module.exports, "switchToAbsoluteUrl", () => $66c5816c46f245bb$export$f7bc20cfc5b360e4);
$parcel$export(module.exports, "getValidTagName", () => $66c5816c46f245bb$export$b3a58098b2e64dd6);
$parcel$export(module.exports, "censoredImageForSize", () => $66c5816c46f245bb$export$370a3fb2c1e85509);

var $bVLiF = parcelRequire("bVLiF");
parcelRequire("4oXVz");
var $4TGNe = parcelRequire("4TGNe");

var $5u1q4 = parcelRequire("5u1q4");

var $1vks3 = parcelRequire("1vks3");
var $66c5816c46f245bb$var$serializedNodeIds = new WeakMap();
function $66c5816c46f245bb$export$baab016255f94f54(node) {
    return $66c5816c46f245bb$var$serializedNodeIds.has(node);
}
function $66c5816c46f245bb$export$267b85776945782d(node) {
    var current = node;
    while(current){
        if (!$66c5816c46f245bb$export$baab016255f94f54(current) && !(0, $4TGNe.isNodeShadowRoot)(current)) return false;
        current = (0, $4TGNe.getParentNode)(current);
    }
    return true;
}
function $66c5816c46f245bb$export$1cdf184f338e4a7b(node) {
    return $66c5816c46f245bb$var$serializedNodeIds.get(node);
}
function $66c5816c46f245bb$export$8fed415004211d23(node, serializeNodeId) {
    $66c5816c46f245bb$var$serializedNodeIds.set(node, serializeNodeId);
}
function $66c5816c46f245bb$export$9a014d2606da64f5(element, nodePrivacyLevel) {
    /*
     BROWSER SPEC NOTE: <input>, <select>
     For some <input> elements, the `value` is an exceptional property/attribute that has the
     value synced between el.value and el.getAttribute()
     input[type=button,checkbox,hidden,image,radio,reset,submit]
     */ var tagName = element.tagName;
    var value = element.value;
    if ((0, $1vks3.shouldMaskNode)(element, nodePrivacyLevel)) {
        var type = element.type;
        if (tagName === "INPUT" && (type === "button" || type === "submit" || type === "reset")) // Overrule `MASK` privacy level for button-like element values, as they are used during replay
        // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
        return value;
        else if (!value || tagName === "OPTION") // <Option> value provides no benefit
        return;
        return 0, $5u1q4.CENSORED_STRING_MARK;
    }
    if (tagName === "OPTION" || tagName === "SELECT") return element.value;
    if (tagName !== "INPUT" && tagName !== "TEXTAREA") return;
    return value;
}
var $66c5816c46f245bb$export$ba314c99542e79a7 = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm;
var $66c5816c46f245bb$export$23a92ed48cea5444 = /^[A-Za-z]+:|^\/\//;
var $66c5816c46f245bb$export$dbafa72958753fce = /^data:.*,/i;
function $66c5816c46f245bb$export$f7bc20cfc5b360e4(cssText, cssHref) {
    return cssText.replace($66c5816c46f245bb$export$ba314c99542e79a7, function(matchingSubstring, singleQuote, urlWrappedInSingleQuotes, doubleQuote, urlWrappedInDoubleQuotes, urlNotWrappedInQuotes) {
        var url = urlWrappedInSingleQuotes || urlWrappedInDoubleQuotes || urlNotWrappedInQuotes;
        if (!cssHref || !url || $66c5816c46f245bb$export$23a92ed48cea5444.test(url) || $66c5816c46f245bb$export$dbafa72958753fce.test(url)) return matchingSubstring;
        var quote = singleQuote || doubleQuote || "";
        return "url(".concat(quote).concat($66c5816c46f245bb$export$d702eb1cee1bdbbc(url, cssHref)).concat(quote, ")");
    });
}
function $66c5816c46f245bb$export$d702eb1cee1bdbbc(url, baseUrl) {
    try {
        return (0, $bVLiF.buildUrl)(url, baseUrl).href;
    } catch (_) {
        return url;
    }
}
var $66c5816c46f245bb$var$TAG_NAME_REGEX = /[^a-z1-6-_]/;
function $66c5816c46f245bb$export$b3a58098b2e64dd6(tagName) {
    var processedTagName = tagName.toLowerCase().trim();
    if ($66c5816c46f245bb$var$TAG_NAME_REGEX.test(processedTagName)) // if the tag name is odd and we cannot extract
    // anything from the string, then we return a
    // generic div
    return "div";
    return processedTagName;
}
function $66c5816c46f245bb$export$370a3fb2c1e85509(width, height) {
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='".concat(width, "' height='").concat(height, "' style='background-color:silver'%3E%3C/svg%3E");
}

});
parcelRegister("5u1q4", function(module, exports) {

$parcel$export(module.exports, "NodePrivacyLevel", () => $3fe0dafadb2f5954$export$92940eb5f25d0fc5);
$parcel$export(module.exports, "PRIVACY_ATTR_NAME", () => $3fe0dafadb2f5954$export$ff33c64c78e35b2b);
$parcel$export(module.exports, "PRIVACY_ATTR_VALUE_ALLOW", () => $3fe0dafadb2f5954$export$a5095f6ae8c6493c);
$parcel$export(module.exports, "PRIVACY_ATTR_VALUE_MASK", () => $3fe0dafadb2f5954$export$faf6990c986cc1eb);
$parcel$export(module.exports, "PRIVACY_ATTR_VALUE_MASK_USER_INPUT", () => $3fe0dafadb2f5954$export$b06f6b91aa78d012);
$parcel$export(module.exports, "PRIVACY_ATTR_VALUE_HIDDEN", () => $3fe0dafadb2f5954$export$e41cc9b2bd72efb8);
$parcel$export(module.exports, "PRIVACY_CLASS_ALLOW", () => $3fe0dafadb2f5954$export$8969d000edddef45);
$parcel$export(module.exports, "PRIVACY_CLASS_MASK", () => $3fe0dafadb2f5954$export$2b23f72fa96ed218);
$parcel$export(module.exports, "PRIVACY_CLASS_MASK_USER_INPUT", () => $3fe0dafadb2f5954$export$d843e9240f6b2766);
$parcel$export(module.exports, "PRIVACY_CLASS_HIDDEN", () => $3fe0dafadb2f5954$export$9837026857d24cec);
$parcel$export(module.exports, "CENSORED_STRING_MARK", () => $3fe0dafadb2f5954$export$76054905c0914783);
$parcel$export(module.exports, "CENSORED_IMG_MARK", () => $3fe0dafadb2f5954$export$4ab830af01a1bf7e);
$parcel$export(module.exports, "FORM_PRIVATE_TAG_NAMES", () => $3fe0dafadb2f5954$export$b6dba6f930ee071f);

var $7imKH = parcelRequire("7imKH");
var $3fe0dafadb2f5954$export$92940eb5f25d0fc5 = {
    IGNORE: "ignore",
    HIDDEN: "hidden",
    ALLOW: (0, $7imKH.DefaultPrivacyLevel).ALLOW,
    MASK: (0, $7imKH.DefaultPrivacyLevel).MASK,
    MASK_USER_INPUT: (0, $7imKH.DefaultPrivacyLevel).MASK_USER_INPUT
};
var $3fe0dafadb2f5954$export$ff33c64c78e35b2b = "data-dd-privacy";
var $3fe0dafadb2f5954$export$a5095f6ae8c6493c = "allow";
var $3fe0dafadb2f5954$export$faf6990c986cc1eb = "mask";
var $3fe0dafadb2f5954$export$b06f6b91aa78d012 = "mask-user-input";
var $3fe0dafadb2f5954$export$e41cc9b2bd72efb8 = "hidden";
var $3fe0dafadb2f5954$export$8969d000edddef45 = "dd-privacy-allow";
var $3fe0dafadb2f5954$export$2b23f72fa96ed218 = "dd-privacy-mask";
var $3fe0dafadb2f5954$export$d843e9240f6b2766 = "dd-privacy-mask-user-input";
var $3fe0dafadb2f5954$export$9837026857d24cec = "dd-privacy-hidden";
var $3fe0dafadb2f5954$export$76054905c0914783 = "***";
var $3fe0dafadb2f5954$export$4ab830af01a1bf7e = "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==";
var $3fe0dafadb2f5954$export$b6dba6f930ee071f = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true
};

});

parcelRegister("1vks3", function(module, exports) {

$parcel$export(module.exports, "MAX_ATTRIBUTE_VALUE_CHAR_LENGTH", () => $11888cf339131837$export$60afd1bdd3673cde);
$parcel$export(module.exports, "getNodePrivacyLevel", () => $11888cf339131837$export$da439d4b145972be);
$parcel$export(module.exports, "getNodeSelfPrivacyLevel", () => $11888cf339131837$export$c417e854a5c24a6f);
$parcel$export(module.exports, "reducePrivacyLevel", () => $11888cf339131837$export$3e5e4c23b3787dea);
$parcel$export(module.exports, "shouldMaskNode", () => $11888cf339131837$export$f97c617afddc1089);
$parcel$export(module.exports, "getTextContent", () => $11888cf339131837$export$132e79e4118a78e0);
parcelRequire("4oXVz");
var $4TGNe = parcelRequire("4TGNe");

var $5u1q4 = parcelRequire("5u1q4");
var $11888cf339131837$export$60afd1bdd3673cde = 100000;
var $11888cf339131837$var$TEXT_MASKING_CHAR = "x";
function $11888cf339131837$export$da439d4b145972be(node, defaultPrivacyLevel, cache) {
    if (cache && cache.has(node)) return cache.get(node);
    var parentNode = (0, $4TGNe.getParentNode)(node);
    var parentNodePrivacyLevel = parentNode ? $11888cf339131837$export$da439d4b145972be(parentNode, defaultPrivacyLevel, cache) : defaultPrivacyLevel;
    var selfNodePrivacyLevel = $11888cf339131837$export$c417e854a5c24a6f(node);
    var nodePrivacyLevel = $11888cf339131837$export$3e5e4c23b3787dea(selfNodePrivacyLevel, parentNodePrivacyLevel);
    if (cache) cache.set(node, nodePrivacyLevel);
    return nodePrivacyLevel;
}
function $11888cf339131837$export$3e5e4c23b3787dea(childPrivacyLevel, parentNodePrivacyLevel) {
    switch(parentNodePrivacyLevel){
        // These values cannot be overridden
        case (0, $5u1q4.NodePrivacyLevel).HIDDEN:
        case (0, $5u1q4.NodePrivacyLevel).IGNORE:
            return parentNodePrivacyLevel;
    }
    switch(childPrivacyLevel){
        case (0, $5u1q4.NodePrivacyLevel).ALLOW:
        case (0, $5u1q4.NodePrivacyLevel).MASK:
        case (0, $5u1q4.NodePrivacyLevel).MASK_USER_INPUT:
        case (0, $5u1q4.NodePrivacyLevel).HIDDEN:
        case (0, $5u1q4.NodePrivacyLevel).IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
function $11888cf339131837$export$c417e854a5c24a6f(node) {
    // Only Element types can have a privacy level set
    if (!(0, $4TGNe.isElementNode)(node)) return;
    var privAttr = node.getAttribute((0, $5u1q4.PRIVACY_ATTR_NAME));
    // Overrules for replay purpose
    if (node.tagName === "BASE") return (0, $5u1q4.NodePrivacyLevel).ALLOW;
    // Overrules to enforce end-user protection
    if (node.tagName === "INPUT") {
        var inputElement = node;
        if (inputElement.type === "password" || inputElement.type === "email" || inputElement.type === "tel") return (0, $5u1q4.NodePrivacyLevel).MASK;
        if (inputElement.type === "hidden") return (0, $5u1q4.NodePrivacyLevel).MASK;
        var autocomplete = inputElement.getAttribute("autocomplete");
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]
        if (autocomplete && autocomplete.indexOf("cc-") === 0) return (0, $5u1q4.NodePrivacyLevel).MASK;
    }
    // Check HTML privacy attributes and classes
    if (privAttr === (0, $5u1q4.PRIVACY_ATTR_VALUE_HIDDEN) || node.classList.contains((0, $5u1q4.PRIVACY_CLASS_HIDDEN))) return (0, $5u1q4.NodePrivacyLevel).HIDDEN;
    if (privAttr === (0, $5u1q4.PRIVACY_ATTR_VALUE_MASK) || node.classList.contains((0, $5u1q4.PRIVACY_CLASS_MASK))) return (0, $5u1q4.NodePrivacyLevel).MASK;
    if (privAttr === (0, $5u1q4.PRIVACY_ATTR_VALUE_MASK_USER_INPUT) || node.classList.contains((0, $5u1q4.PRIVACY_CLASS_MASK_USER_INPUT))) return (0, $5u1q4.NodePrivacyLevel).MASK_USER_INPUT;
    if (privAttr === (0, $5u1q4.PRIVACY_ATTR_VALUE_ALLOW) || node.classList.contains((0, $5u1q4.PRIVACY_CLASS_ALLOW))) return (0, $5u1q4.NodePrivacyLevel).ALLOW;
    if ($11888cf339131837$export$15d4213dc9444b1(node)) return (0, $5u1q4.NodePrivacyLevel).IGNORE;
}
function $11888cf339131837$export$f97c617afddc1089(node, privacyLevel) {
    switch(privacyLevel){
        case (0, $5u1q4.NodePrivacyLevel).MASK:
        case (0, $5u1q4.NodePrivacyLevel).HIDDEN:
        case (0, $5u1q4.NodePrivacyLevel).IGNORE:
            return true;
        case (0, $5u1q4.NodePrivacyLevel).MASK_USER_INPUT:
            return (0, $4TGNe.isTextNode)(node) ? $11888cf339131837$var$isFormElement(node.parentNode) : $11888cf339131837$var$isFormElement(node);
        default:
            return false;
    }
}
function $11888cf339131837$var$isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) return false;
    var element = node;
    if (element.tagName === "INPUT") switch(element.type){
        case "button":
        case "color":
        case "reset":
        case "submit":
            return false;
    }
    return !!(0, $5u1q4.FORM_PRIVATE_TAG_NAMES)[element.tagName];
}
var $11888cf339131837$export$7aa14ef9d0a56a45 = function(text) {
    return text.replace(/\S/g, $11888cf339131837$var$TEXT_MASKING_CHAR);
};
function $11888cf339131837$export$132e79e4118a78e0(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = textNode.textContent || "";
    if (ignoreWhiteSpace && !textContent.trim()) return;
    var nodePrivacyLevel = parentNodePrivacyLevel;
    var isScript = parentTagName === "SCRIPT";
    if (isScript) // For perf reasons, we don't record script (heuristic)
    textContent = (0, $5u1q4.CENSORED_STRING_MARK);
    else if (nodePrivacyLevel === (0, $5u1q4.NodePrivacyLevel).HIDDEN) // Should never occur, but just in case, we set to CENSORED_MARK.
    textContent = (0, $5u1q4.CENSORED_STRING_MARK);
    else if ($11888cf339131837$export$f97c617afddc1089(textNode, nodePrivacyLevel)) {
        if (// Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === "DATALIST" || parentTagName === "SELECT" || parentTagName === "OPTGROUP") {
            if (!textContent.trim()) return;
        } else if (parentTagName === "OPTION") // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
        textContent = (0, $5u1q4.CENSORED_STRING_MARK);
        else textContent = $11888cf339131837$export$7aa14ef9d0a56a45(textContent);
    }
    return textContent;
}
function $11888cf339131837$export$15d4213dc9444b1(element) {
    if (element.nodeName === "SCRIPT") return true;
    if (element.nodeName === "LINK") {
        var relAttribute = getLowerCaseAttribute("rel");
        return(// Link as script - Ignore only when rel=preload, modulepreload or prefetch
        /preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute("as") === "script" || // Favicons
        relAttribute === "shortcut icon" || relAttribute === "icon");
    }
    if (element.nodeName === "META") {
        var nameAttribute = getLowerCaseAttribute("name");
        var relAttribute = getLowerCaseAttribute("rel");
        var propertyAttribute = getLowerCaseAttribute("property");
        return(// Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) || nameAttribute === "application-name" || relAttribute === "icon" || relAttribute === "apple-touch-icon" || relAttribute === "shortcut icon" || // Description
        nameAttribute === "keywords" || nameAttribute === "description" || // Social
        /^(og|twitter|fb):/.test(propertyAttribute) || /^(og|twitter):/.test(nameAttribute) || nameAttribute === "pinterest" || // Robots
        nameAttribute === "robots" || nameAttribute === "googlebot" || nameAttribute === "bingbot" || // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
        // X-Translated-By
        element.hasAttribute("http-equiv") || // Authorship
        nameAttribute === "author" || nameAttribute === "generator" || nameAttribute === "framework" || nameAttribute === "publisher" || nameAttribute === "progid" || /^article:/.test(propertyAttribute) || /^product:/.test(propertyAttribute) || // Verification
        nameAttribute === "google-site-verification" || nameAttribute === "yandex-verification" || nameAttribute === "csrf-token" || nameAttribute === "p:domain_verify" || nameAttribute === "verify-v1" || nameAttribute === "verification" || nameAttribute === "shopify-checkout-api-token");
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || "").toLowerCase();
    }
    return false;
}

});


parcelRegister("8Updw", function(module, exports) {

$parcel$export(module.exports, "serializeDocument", () => $67c71d4896ac3366$export$6c4b5890a966884d);

var $73YKA = parcelRequire("73YKA");
function $67c71d4896ac3366$export$6c4b5890a966884d(document, configuration, serializationContext) {
    // We are sure that Documents are never ignored, so this function never returns null
    return (0, $73YKA.serializeNodeWithId)(document, {
        serializationContext: serializationContext,
        parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
        configuration: configuration
    });
}

});
parcelRegister("73YKA", function(module, exports) {

$parcel$export(module.exports, "serializeNodeWithId", () => $5247effe67b1adb1$export$27792c824d895cd4);
parcelRequire("4oXVz");
var $4TGNe = parcelRequire("4TGNe");

var $fkj4Q = parcelRequire("fkj4Q");
parcelRequire("aJSOq");
var $kWQO2 = parcelRequire("kWQO2");

var $5u1q4 = parcelRequire("5u1q4");

var $1vks3 = parcelRequire("1vks3");

var $8P37p = parcelRequire("8P37p");

var $6zl0j = parcelRequire("6zl0j");

var $78bll = parcelRequire("78bll");
function $5247effe67b1adb1$export$27792c824d895cd4(node, options) {
    var serializedNode = $5247effe67b1adb1$var$serializeNode(node, options);
    if (!serializedNode) return null;
    // Try to reuse the previous id
    var id = (0, $8P37p.getSerializedNodeId)(node) || $5247effe67b1adb1$export$8ce4034bbb89f82a();
    var serializedNodeWithId = serializedNode;
    serializedNodeWithId.id = id;
    (0, $8P37p.setSerializedNodeId)(node, id);
    if (options.serializedNodeIds) options.serializedNodeIds.add(id);
    return serializedNodeWithId;
}
var $5247effe67b1adb1$var$_nextId = 1;
function $5247effe67b1adb1$export$8ce4034bbb89f82a() {
    return $5247effe67b1adb1$var$_nextId++;
}
function $5247effe67b1adb1$export$6cba1c3abeb370b2(node, options) {
    var result = [];
    (0, $4TGNe.forEachChildNodes)(node, function(childNode) {
        var serializedChildNode = $5247effe67b1adb1$export$27792c824d895cd4(childNode, options);
        if (serializedChildNode) result.push(serializedChildNode);
    });
    return result;
}
function $5247effe67b1adb1$var$serializeNode(node, options) {
    switch(node.nodeType){
        case node.DOCUMENT_NODE:
            return $5247effe67b1adb1$export$91525d3a437a6c5c(node, options);
        case node.DOCUMENT_FRAGMENT_NODE:
            return $5247effe67b1adb1$var$serializeDocumentFragmentNode(node, options);
        case node.DOCUMENT_TYPE_NODE:
            return $5247effe67b1adb1$var$serializeDocumentTypeNode(node);
        case node.ELEMENT_NODE:
            return $5247effe67b1adb1$var$serializeElementNode(node, options);
        case node.TEXT_NODE:
            return $5247effe67b1adb1$var$serializeTextNode(node, options);
        case node.CDATA_SECTION_NODE:
            return $5247effe67b1adb1$var$serializeCDataNode();
    }
}
function $5247effe67b1adb1$export$91525d3a437a6c5c(document, options) {
    return {
        type: (0, $kWQO2.NodeType).Document,
        childNodes: $5247effe67b1adb1$export$6cba1c3abeb370b2(document, options),
        adoptedStyleSheets: (0, $6zl0j.serializeStyleSheets)(document.adoptedStyleSheets)
    };
}
function $5247effe67b1adb1$var$serializeDocumentFragmentNode(element, options) {
    var isShadowRoot = (0, $4TGNe.isNodeShadowRoot)(element);
    if (isShadowRoot) options.serializationContext.shadowRootsController.addShadowRoot(element);
    return {
        type: (0, $kWQO2.NodeType).DocumentFragment,
        childNodes: $5247effe67b1adb1$export$6cba1c3abeb370b2(element, options),
        isShadowRoot: isShadowRoot,
        adoptedStyleSheets: isShadowRoot ? (0, $6zl0j.serializeStyleSheets)(element.adoptedStyleSheets) : undefined
    };
}
function $5247effe67b1adb1$var$serializeDocumentTypeNode(documentType) {
    return {
        type: (0, $kWQO2.NodeType).DocumentType,
        name: documentType.name,
        publicId: documentType.publicId,
        systemId: documentType.systemId
    };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, option selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */ function $5247effe67b1adb1$var$serializeElementNode(element, options) {
    var _a;
    var tagName = (0, $8P37p.getValidTagName)(element.tagName);
    var isSVG = $5247effe67b1adb1$var$isSVGElement(element) || undefined;
    // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
    // parentNodePrivacyLevel option to avoid iterating over all parents
    var nodePrivacyLevel = (0, $1vks3.reducePrivacyLevel)((0, $1vks3.getNodeSelfPrivacyLevel)(element), options.parentNodePrivacyLevel);
    if (nodePrivacyLevel === (0, $5u1q4.NodePrivacyLevel).HIDDEN) {
        var _b = element.getBoundingClientRect(), width = _b.width, height = _b.height;
        return {
            type: (0, $kWQO2.NodeType).Element,
            tagName: tagName,
            attributes: (_a = {
                rr_width: "".concat(width, "px"),
                rr_height: "".concat(height, "px")
            }, _a[0, $5u1q4.PRIVACY_ATTR_NAME] = (0, $5u1q4.PRIVACY_ATTR_VALUE_HIDDEN), _a),
            childNodes: [],
            isSVG: isSVG
        };
    }
    // Ignore Elements like Script and some Link, Metas
    if (nodePrivacyLevel === (0, $5u1q4.NodePrivacyLevel).IGNORE) return;
    var attributes = (0, $78bll.serializeAttributes)(element, nodePrivacyLevel, options);
    var childNodes = [];
    if ((0, $4TGNe.hasChildNodes)(element) && // Do not serialize style children as the css rules are already in the _cssText attribute
    tagName !== "style") {
        // OBJECT POOLING OPTIMIZATION:
        // We should not create a new object systematically as it could impact performances. Try to reuse
        // the same object as much as possible, and clone it only if we need to.
        var childNodesSerializationOptions = void 0;
        if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === "head")) childNodesSerializationOptions = options;
        else childNodesSerializationOptions = (0, $fkj4Q.assign)({}, options, {
            parentNodePrivacyLevel: nodePrivacyLevel,
            ignoreWhiteSpace: tagName === "head"
        });
        childNodes = $5247effe67b1adb1$export$6cba1c3abeb370b2(element, childNodesSerializationOptions);
    }
    return {
        type: (0, $kWQO2.NodeType).Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: childNodes,
        isSVG: isSVG
    };
}
function $5247effe67b1adb1$var$isSVGElement(el) {
    return el.tagName === "svg" || el instanceof SVGElement;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */ function $5247effe67b1adb1$var$serializeTextNode(textNode, options) {
    var textContent = (0, $1vks3.getTextContent)(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
    if (textContent === undefined) return;
    return {
        type: (0, $kWQO2.NodeType).Text,
        textContent: textContent
    };
}
function $5247effe67b1adb1$var$serializeCDataNode() {
    return {
        type: (0, $kWQO2.NodeType).CDATA,
        textContent: ""
    };
}

});
parcelRegister("aJSOq", function(module, exports) {
$parcel$export(module.exports, "IncrementalSource", () => (parcelRequire("kWQO2")).IncrementalSource);
$parcel$export(module.exports, "MediaInteractionType", () => (parcelRequire("kWQO2")).MediaInteractionType);
$parcel$export(module.exports, "MouseInteractionType", () => (parcelRequire("kWQO2")).MouseInteractionType);
$parcel$export(module.exports, "NodeType", () => (parcelRequire("kWQO2")).NodeType);
$parcel$export(module.exports, "RecordType", () => (parcelRequire("kWQO2")).RecordType);
parcelRequire("EWCER");
parcelRequire("kWQO2");

});
parcelRegister("EWCER", function(module, exports) {
/* eslint-disable */ /**
 * DO NOT MODIFY IT BY HAND. Run `yarn rum-events-format:sync` instead.
 */ 
});

parcelRegister("kWQO2", function(module, exports) {

$parcel$export(module.exports, "RecordType", () => $f4022f9fa1e52f9f$export$2edcab8dd1869daa);
$parcel$export(module.exports, "NodeType", () => $f4022f9fa1e52f9f$export$f06e977173f1857c);
$parcel$export(module.exports, "IncrementalSource", () => $f4022f9fa1e52f9f$export$24bb3ebc067ff5e1);
$parcel$export(module.exports, "MouseInteractionType", () => $f4022f9fa1e52f9f$export$4e7964972bb3e05e);
$parcel$export(module.exports, "MediaInteractionType", () => $f4022f9fa1e52f9f$export$df4c88b305317825);
var $f4022f9fa1e52f9f$export$2edcab8dd1869daa = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
    FrustrationRecord: 9
};
var $f4022f9fa1e52f9f$export$f06e977173f1857c = {
    Document: 0,
    DocumentType: 1,
    Element: 2,
    Text: 3,
    CDATA: 4,
    DocumentFragment: 11
};
var $f4022f9fa1e52f9f$export$24bb3ebc067ff5e1 = {
    Mutation: 0,
    MouseMove: 1,
    MouseInteraction: 2,
    Scroll: 3,
    ViewportResize: 4,
    Input: 5,
    TouchMove: 6,
    MediaInteraction: 7,
    StyleSheetRule: 8
};
var $f4022f9fa1e52f9f$export$4e7964972bb3e05e = {
    MouseUp: 0,
    MouseDown: 1,
    Click: 2,
    ContextMenu: 3,
    DblClick: 4,
    Focus: 5,
    Blur: 6,
    TouchStart: 7,
    TouchEnd: 9
};
var $f4022f9fa1e52f9f$export$df4c88b305317825 = {
    Play: 0,
    Pause: 1
};

});


parcelRegister("6zl0j", function(module, exports) {

$parcel$export(module.exports, "serializeStyleSheets", () => $4c864dec2d0fc266$export$5426777f4276f7bf);
function $4c864dec2d0fc266$export$5426777f4276f7bf(cssStyleSheets) {
    if (cssStyleSheets === undefined || cssStyleSheets.length === 0) return undefined;
    return cssStyleSheets.map(function(cssStyleSheet) {
        var rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
        var cssRules = Array.from(rules, function(cssRule) {
            return cssRule.cssText;
        });
        var styleSheet = {
            cssRules: cssRules,
            disabled: cssStyleSheet.disabled || undefined,
            media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined
        };
        return styleSheet;
    });
}

});

parcelRegister("78bll", function(module, exports) {

$parcel$export(module.exports, "serializeAttributes", () => $5312144f41e7d226$export$4954cae66e755861);

var $k2pmh = parcelRequire("k2pmh");
var $5h91O = parcelRequire("5h91O");

var $5u1q4 = parcelRequire("5u1q4");

var $1vks3 = parcelRequire("1vks3");

var $8P37p = parcelRequire("8P37p");

var $1M37u = parcelRequire("1M37u");
function $5312144f41e7d226$export$4954cae66e755861(element, nodePrivacyLevel, options) {
    var _a;
    if (nodePrivacyLevel === (0, $5u1q4.NodePrivacyLevel).HIDDEN) return {};
    var safeAttrs = {};
    var tagName = (0, $8P37p.getValidTagName)(element.tagName);
    var doc = element.ownerDocument;
    for(var i = 0; i < element.attributes.length; i += 1){
        var attribute = element.attributes.item(i);
        var attributeName = attribute.name;
        var attributeValue = (0, $1M37u.serializeAttribute)(element, nodePrivacyLevel, attributeName, options.configuration);
        if (attributeValue !== null) safeAttrs[attributeName] = attributeValue;
    }
    if (element.value && (tagName === "textarea" || tagName === "select" || tagName === "option" || tagName === "input")) {
        var formValue = (0, $8P37p.getElementInputValue)(element, nodePrivacyLevel);
        if (formValue !== undefined) safeAttrs.value = formValue;
    }
    /**
     * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
     */ if (tagName === "option" && nodePrivacyLevel === (0, $5u1q4.NodePrivacyLevel).ALLOW) {
        // For privacy=`MASK`, all the values would be the same, so skip.
        var optionElement = element;
        if (optionElement.selected) safeAttrs.selected = optionElement.selected;
    }
    // remote css
    if (tagName === "link") {
        var stylesheet = Array.from(doc.styleSheets).find(function(s) {
            return s.href === element.href;
        });
        var cssText = $5312144f41e7d226$export$ef1cc196b0353a30(stylesheet);
        if (cssText && stylesheet && !(0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).DISABLE_REPLAY_INLINE_CSS)) safeAttrs._cssText = cssText;
    }
    // dynamic stylesheet
    if (tagName === "style" && element.sheet) {
        var cssText = $5312144f41e7d226$export$ef1cc196b0353a30(element.sheet);
        if (cssText) safeAttrs._cssText = cssText;
    }
    /**
     * Forms: input[type=checkbox,radio]
     * The `checked` property for <input> is a little bit special:
     * 1. el.checked is a setter that returns if truthy.
     * 2. getAttribute returns the string value
     * getAttribute('checked') does not sync with `Element.checked`, so use JS property
     * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
     */ var inputElement = element;
    if (tagName === "input" && (inputElement.type === "radio" || inputElement.type === "checkbox")) {
        if (nodePrivacyLevel === (0, $5u1q4.NodePrivacyLevel).ALLOW) safeAttrs.checked = !!inputElement.checked;
        else if ((0, $1vks3.shouldMaskNode)(inputElement, nodePrivacyLevel)) delete safeAttrs.checked;
    }
    /**
     * Serialize the media playback state
     */ if (tagName === "audio" || tagName === "video") {
        var mediaElement = element;
        safeAttrs.rr_mediaState = mediaElement.paused ? "paused" : "played";
    }
    /**
     * Serialize the scroll state for each element only for full snapshot
     */ var scrollTop;
    var scrollLeft;
    var serializationContext = options.serializationContext;
    switch(serializationContext.status){
        case 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */ :
            scrollTop = Math.round(element.scrollTop);
            scrollLeft = Math.round(element.scrollLeft);
            if (scrollTop || scrollLeft) serializationContext.elementsScrollPositions.set(element, {
                scrollTop: scrollTop,
                scrollLeft: scrollLeft
            });
            break;
        case 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */ :
            if (serializationContext.elementsScrollPositions.has(element)) _a = serializationContext.elementsScrollPositions.get(element), scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft;
            break;
    }
    if (scrollLeft) safeAttrs.rr_scrollLeft = scrollLeft;
    if (scrollTop) safeAttrs.rr_scrollTop = scrollTop;
    return safeAttrs;
}
function $5312144f41e7d226$export$ef1cc196b0353a30(cssStyleSheet) {
    if (!cssStyleSheet) return null;
    var rules;
    try {
        rules = cssStyleSheet.rules || cssStyleSheet.cssRules;
    } catch (_a) {
    // if css is protected by CORS we cannot access cssRules see: https://www.w3.org/TR/cssom-1/#the-cssstylesheet-interface
    }
    if (!rules) return null;
    var styleSheetCssText = Array.from(rules, (0, $5h91O.isSafari)() ? $5312144f41e7d226$var$getCssRuleStringForSafari : $5312144f41e7d226$var$getCssRuleString).join("");
    return (0, $8P37p.switchToAbsoluteUrl)(styleSheetCssText, cssStyleSheet.href);
}
function $5312144f41e7d226$var$getCssRuleStringForSafari(rule) {
    // Safari does not escape attribute selectors containing : properly
    // https://bugs.webkit.org/show_bug.cgi?id=184604
    if ($5312144f41e7d226$var$isCSSStyleRule(rule) && rule.selectorText.includes(":")) {
        // This regex replaces [foo:bar] by [foo\\:bar]
        var escapeColon = /(\[[\w-]+[^\\])(:[^\]]+\])/g;
        return rule.cssText.replace(escapeColon, "$1\\$2");
    }
    return $5312144f41e7d226$var$getCssRuleString(rule);
}
function $5312144f41e7d226$var$getCssRuleString(rule) {
    // If it's an @import rule, try to inline sub-rules recursively with `getCssRulesString`. This
    // operation can fail if the imported stylesheet is protected by CORS, in which case we fallback
    // to the @import rule CSS text.
    return $5312144f41e7d226$var$isCSSImportRule(rule) && $5312144f41e7d226$export$ef1cc196b0353a30(rule.styleSheet) || rule.cssText;
}
function $5312144f41e7d226$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $5312144f41e7d226$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}

});
parcelRegister("1M37u", function(module, exports) {

$parcel$export(module.exports, "serializeAttribute", () => $14acb1a5b2223964$export$d36a50b4e4d32f1a);

var $fkj4Q = parcelRequire("fkj4Q");
parcelRequire("4oXVz");
var $l3o7w = parcelRequire("l3o7w");

var $5u1q4 = parcelRequire("5u1q4");

var $1vks3 = parcelRequire("1vks3");

var $8P37p = parcelRequire("8P37p");
function $14acb1a5b2223964$export$d36a50b4e4d32f1a(element, nodePrivacyLevel, attributeName, configuration) {
    if (nodePrivacyLevel === (0, $5u1q4.NodePrivacyLevel).HIDDEN) // dup condition for direct access case
    return null;
    var attributeValue = element.getAttribute(attributeName);
    if (nodePrivacyLevel === (0, $5u1q4.NodePrivacyLevel).MASK && attributeName !== (0, $5u1q4.PRIVACY_ATTR_NAME) && !(0, $l3o7w.STABLE_ATTRIBUTES).includes(attributeName) && attributeName !== configuration.actionNameAttribute) {
        var tagName = element.tagName;
        switch(attributeName){
            // Mask Attribute text content
            case "title":
            case "alt":
            case "placeholder":
                return 0, $5u1q4.CENSORED_STRING_MARK;
        }
        // mask image URLs
        if (tagName === "IMG" && (attributeName === "src" || attributeName === "srcset")) {
            // generate image with similar dimension than the original to have the same rendering behaviour
            var image = element;
            if (image.naturalWidth > 0) return (0, $8P37p.censoredImageForSize)(image.naturalWidth, image.naturalHeight);
            var _a = element.getBoundingClientRect(), width = _a.width, height = _a.height;
            if (width > 0 || height > 0) return (0, $8P37p.censoredImageForSize)(width, height);
            // if we can't get the image size, fallback to the censored image
            return 0, $5u1q4.CENSORED_IMG_MARK;
        }
        // mask source URLs
        if (tagName === "SOURCE" && (attributeName === "src" || attributeName === "srcset")) return 0, $5u1q4.CENSORED_IMG_MARK;
        // mask <a> URLs
        if (tagName === "A" && attributeName === "href") return 0, $5u1q4.CENSORED_STRING_MARK;
        // mask data-* attributes
        if (attributeValue && (0, $fkj4Q.startsWith)(attributeName, "data-")) // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
        return 0, $5u1q4.CENSORED_STRING_MARK;
    }
    if (!attributeValue || typeof attributeValue !== "string") return attributeValue;
    // Minimum Fix for customer.
    if (attributeValue.length > (0, $1vks3.MAX_ATTRIBUTE_VALUE_CHAR_LENGTH) && attributeValue.slice(0, 5) === "data:") return "data:truncated";
    return attributeValue;
}

});





parcelRegister("dHerU", function(module, exports) {

$parcel$export(module.exports, "isTouchEvent", () => $9f8a7fd13e5b98bd$export$c4dfce035d43d1e0);
$parcel$export(module.exports, "getEventTarget", () => $9f8a7fd13e5b98bd$export$e58f029f0fbfdb29);
parcelRequire("4oXVz");
var $4TGNe = parcelRequire("4TGNe");
function $9f8a7fd13e5b98bd$export$c4dfce035d43d1e0(event) {
    return Boolean(event.changedTouches);
}
function $9f8a7fd13e5b98bd$export$e58f029f0fbfdb29(event) {
    if (event.composed === true && (0, $4TGNe.isNodeShadowHost)(event.target)) return event.composedPath()[0];
    return event.target;
}

});

parcelRegister("fZRY4", function(module, exports) {

$parcel$export(module.exports, "convertMouseEventToLayoutCoordinates", () => $ba566a704a25e63f$export$eb47450612326c2);
$parcel$export(module.exports, "getVisualViewport", () => $ba566a704a25e63f$export$27974520bd71cbc4);
/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */ // Scrollbar widths vary across properties on different devices and browsers
var $ba566a704a25e63f$var$TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */ function $ba566a704a25e63f$var$isVisualViewportFactoredIn(visualViewport) {
    return Math.abs(visualViewport.pageTop - visualViewport.offsetTop - window.scrollY) > $ba566a704a25e63f$var$TOLERANCE || Math.abs(visualViewport.pageLeft - visualViewport.offsetLeft - window.scrollX) > $ba566a704a25e63f$var$TOLERANCE;
}
var $ba566a704a25e63f$export$eb47450612326c2 = function(clientX, clientY) {
    var visualViewport = window.visualViewport;
    var normalized = {
        layoutViewportX: clientX,
        layoutViewportY: clientY,
        visualViewportX: clientX,
        visualViewportY: clientY
    };
    if (!visualViewport) // On old browsers, we cannot normalize, so fallback to clientX/Y
    return normalized;
    else if ($ba566a704a25e63f$var$isVisualViewportFactoredIn(visualViewport)) {
        // Typically Mobile Devices
        normalized.layoutViewportX = Math.round(clientX + visualViewport.offsetLeft);
        normalized.layoutViewportY = Math.round(clientY + visualViewport.offsetTop);
    } else {
        // Typically Desktop Devices
        normalized.visualViewportX = Math.round(clientX - visualViewport.offsetLeft);
        normalized.visualViewportY = Math.round(clientY - visualViewport.offsetTop);
    }
    return normalized;
};
var $ba566a704a25e63f$export$27974520bd71cbc4 = function(visualViewport) {
    return {
        scale: visualViewport.scale,
        offsetLeft: visualViewport.offsetLeft,
        offsetTop: visualViewport.offsetTop,
        pageLeft: visualViewport.pageLeft,
        pageTop: visualViewport.pageTop,
        height: visualViewport.height,
        width: visualViewport.width
    };
};

});

parcelRegister("HhA2E", function(module, exports) {

$parcel$export(module.exports, "assembleIncrementalSnapshot", () => $0821a75a0910c99f$export$8c66addc1bcc799e);

var $fkj4Q = parcelRequire("fkj4Q");
var $ly0px = parcelRequire("ly0px");
parcelRequire("aJSOq");
var $kWQO2 = parcelRequire("kWQO2");
function $0821a75a0910c99f$export$8c66addc1bcc799e(source, data) {
    return {
        data: (0, $fkj4Q.assign)({
            source: source
        }, data),
        type: (0, $kWQO2.RecordType).IncrementalSnapshot,
        timestamp: (0, $ly0px.timeStampNow)()
    };
}

});


parcelRegister("8bZL4", function(module, exports) {

$parcel$export(module.exports, "trackMouseInteraction", () => $5f6f41b3e34579af$export$9b708d0caac77d2e);

var $hXhfS = parcelRequire("hXhfS");
var $fkj4Q = parcelRequire("fkj4Q");

var $5u1q4 = parcelRequire("5u1q4");
parcelRequire("aJSOq");
var $kWQO2 = parcelRequire("kWQO2");

var $HhA2E = parcelRequire("HhA2E");

var $dHerU = parcelRequire("dHerU");

var $1vks3 = parcelRequire("1vks3");
parcelRequire("2yVFW");
var $8P37p = parcelRequire("8P37p");

var $dm2SK = parcelRequire("dm2SK");
var $5f6f41b3e34579af$var$_a;
var $5f6f41b3e34579af$var$eventTypeToMouseInteraction = ($5f6f41b3e34579af$var$_a = {}, // Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
// allows to reference such records from Frustration records.
//
// In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
// used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
// `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
// convey such interaction. This would cleanly solve the issue since we would have
// `PointerInteraction/Up` records that we could reference from `Frustration` records.
$5f6f41b3e34579af$var$_a[(0, $hXhfS.DOM_EVENT).POINTER_UP] = (0, $kWQO2.MouseInteractionType).MouseUp, $5f6f41b3e34579af$var$_a[(0, $hXhfS.DOM_EVENT).MOUSE_DOWN] = (0, $kWQO2.MouseInteractionType).MouseDown, $5f6f41b3e34579af$var$_a[(0, $hXhfS.DOM_EVENT).CLICK] = (0, $kWQO2.MouseInteractionType).Click, $5f6f41b3e34579af$var$_a[(0, $hXhfS.DOM_EVENT).CONTEXT_MENU] = (0, $kWQO2.MouseInteractionType).ContextMenu, $5f6f41b3e34579af$var$_a[(0, $hXhfS.DOM_EVENT).DBL_CLICK] = (0, $kWQO2.MouseInteractionType).DblClick, $5f6f41b3e34579af$var$_a[(0, $hXhfS.DOM_EVENT).FOCUS] = (0, $kWQO2.MouseInteractionType).Focus, $5f6f41b3e34579af$var$_a[(0, $hXhfS.DOM_EVENT).BLUR] = (0, $kWQO2.MouseInteractionType).Blur, $5f6f41b3e34579af$var$_a[(0, $hXhfS.DOM_EVENT).TOUCH_START] = (0, $kWQO2.MouseInteractionType).TouchStart, $5f6f41b3e34579af$var$_a[(0, $hXhfS.DOM_EVENT).TOUCH_END] = (0, $kWQO2.MouseInteractionType).TouchEnd, $5f6f41b3e34579af$var$_a);
function $5f6f41b3e34579af$export$9b708d0caac77d2e(configuration, mouseInteractionCb, recordIds) {
    var handler = function(event) {
        var target = (0, $dHerU.getEventTarget)(event);
        if ((0, $1vks3.getNodePrivacyLevel)(target, configuration.defaultPrivacyLevel) === (0, $5u1q4.NodePrivacyLevel).HIDDEN || !(0, $8P37p.hasSerializedNode)(target)) return;
        var id = (0, $8P37p.getSerializedNodeId)(target);
        var type = $5f6f41b3e34579af$var$eventTypeToMouseInteraction[event.type];
        var interaction;
        if (type !== (0, $kWQO2.MouseInteractionType).Blur && type !== (0, $kWQO2.MouseInteractionType).Focus) {
            var coordinates = (0, $dm2SK.tryToComputeCoordinates)(event);
            if (!coordinates) return;
            interaction = {
                id: id,
                type: type,
                x: coordinates.x,
                y: coordinates.y
            };
        } else interaction = {
            id: id,
            type: type
        };
        var record = (0, $fkj4Q.assign)({
            id: recordIds.getIdForEvent(event)
        }, (0, $HhA2E.assembleIncrementalSnapshot)((0, $kWQO2.IncrementalSource).MouseInteraction, interaction));
        mouseInteractionCb(record);
    };
    return (0, $hXhfS.addEventListeners)(configuration, document, Object.keys($5f6f41b3e34579af$var$eventTypeToMouseInteraction), handler, {
        capture: true,
        passive: true
    });
}

});

parcelRegister("e7o3B", function(module, exports) {

$parcel$export(module.exports, "trackScroll", () => $a474615d6eec2277$export$de1563ff5a1bae99);

var $hXhfS = parcelRequire("hXhfS");
var $aed8w = parcelRequire("aed8w");
parcelRequire("4oXVz");
var $fvpT8 = parcelRequire("fvpT8");

var $dHerU = parcelRequire("dHerU");

var $1vks3 = parcelRequire("1vks3");
parcelRequire("2yVFW");
var $8P37p = parcelRequire("8P37p");
parcelRequire("aJSOq");
var $kWQO2 = parcelRequire("kWQO2");

var $5u1q4 = parcelRequire("5u1q4");

var $HhA2E = parcelRequire("HhA2E");
var $a474615d6eec2277$var$SCROLL_OBSERVER_THRESHOLD = 100;
function $a474615d6eec2277$export$de1563ff5a1bae99(configuration, scrollCb, elementsScrollPositions) {
    var _a = (0, $aed8w.throttle)(function(event) {
        var target = (0, $dHerU.getEventTarget)(event);
        if (!target || (0, $1vks3.getNodePrivacyLevel)(target, configuration.defaultPrivacyLevel) === (0, $5u1q4.NodePrivacyLevel).HIDDEN || !(0, $8P37p.hasSerializedNode)(target)) return;
        var id = (0, $8P37p.getSerializedNodeId)(target);
        var scrollPositions = target === document ? {
            scrollTop: (0, $fvpT8.getScrollY)(),
            scrollLeft: (0, $fvpT8.getScrollX)()
        } : {
            scrollTop: Math.round(target.scrollTop),
            scrollLeft: Math.round(target.scrollLeft)
        };
        elementsScrollPositions.set(target, scrollPositions);
        scrollCb((0, $HhA2E.assembleIncrementalSnapshot)((0, $kWQO2.IncrementalSource).Scroll, {
            id: id,
            x: scrollPositions.scrollLeft,
            y: scrollPositions.scrollTop
        }));
    }, $a474615d6eec2277$var$SCROLL_OBSERVER_THRESHOLD), updatePosition = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = (0, $hXhfS.addEventListener)(configuration, document, (0, $hXhfS.DOM_EVENT).SCROLL, updatePosition, {
        capture: true,
        passive: true
    }).stop;
    return {
        stop: function() {
            removeListener();
            cancelThrottle();
        }
    };
}

});

parcelRegister("dLVZm", function(module, exports) {

$parcel$export(module.exports, "trackViewportResize", () => $a06ca5797aa60810$export$1b4a6a8302e2d23f);

var $hXhfS = parcelRequire("hXhfS");
var $aed8w = parcelRequire("aed8w");
var $ly0px = parcelRequire("ly0px");
parcelRequire("4oXVz");
var $kom4r = parcelRequire("kom4r");
parcelRequire("aJSOq");
var $kWQO2 = parcelRequire("kWQO2");

var $fZRY4 = parcelRequire("fZRY4");

var $HhA2E = parcelRequire("HhA2E");
var $a06ca5797aa60810$var$VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
function $a06ca5797aa60810$export$1b4a6a8302e2d23f(configuration, viewportResizeCb) {
    var viewportResizeSubscription = (0, $kom4r.initViewportObservable)(configuration).subscribe(function(data) {
        viewportResizeCb((0, $HhA2E.assembleIncrementalSnapshot)((0, $kWQO2.IncrementalSource).ViewportResize, data));
    });
    return {
        stop: function() {
            viewportResizeSubscription.unsubscribe();
        }
    };
}
function $a06ca5797aa60810$export$2f8c7dd07e8cd38e(configuration, visualViewportResizeCb) {
    var visualViewport = window.visualViewport;
    if (!visualViewport) return {
        stop: (0, $aed8w.noop)
    };
    var _a = (0, $aed8w.throttle)(function() {
        visualViewportResizeCb({
            data: (0, $fZRY4.getVisualViewport)(visualViewport),
            type: (0, $kWQO2.RecordType).VisualViewport,
            timestamp: (0, $ly0px.timeStampNow)()
        });
    }, $a06ca5797aa60810$var$VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
        trailing: false
    }), updateDimension = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = (0, $hXhfS.addEventListeners)(configuration, visualViewport, [
        (0, $hXhfS.DOM_EVENT).RESIZE,
        (0, $hXhfS.DOM_EVENT).SCROLL
    ], updateDimension, {
        capture: true,
        passive: true
    }).stop;
    return {
        stop: function() {
            removeListener();
            cancelThrottle();
        }
    };
}

});

parcelRegister("kzezO", function(module, exports) {

$parcel$export(module.exports, "trackMediaInteraction", () => $ef9262233214376a$export$400dbd5b48537196);

var $hXhfS = parcelRequire("hXhfS");

var $5u1q4 = parcelRequire("5u1q4");
parcelRequire("aJSOq");
var $kWQO2 = parcelRequire("kWQO2");

var $dHerU = parcelRequire("dHerU");

var $1vks3 = parcelRequire("1vks3");
parcelRequire("2yVFW");
var $8P37p = parcelRequire("8P37p");

var $HhA2E = parcelRequire("HhA2E");
function $ef9262233214376a$export$400dbd5b48537196(configuration, mediaInteractionCb) {
    return (0, $hXhfS.addEventListeners)(configuration, document, [
        (0, $hXhfS.DOM_EVENT).PLAY,
        (0, $hXhfS.DOM_EVENT).PAUSE
    ], function(event) {
        var target = (0, $dHerU.getEventTarget)(event);
        if (!target || (0, $1vks3.getNodePrivacyLevel)(target, configuration.defaultPrivacyLevel) === (0, $5u1q4.NodePrivacyLevel).HIDDEN || !(0, $8P37p.hasSerializedNode)(target)) return;
        mediaInteractionCb((0, $HhA2E.assembleIncrementalSnapshot)((0, $kWQO2.IncrementalSource).MediaInteraction, {
            id: (0, $8P37p.getSerializedNodeId)(target),
            type: event.type === (0, $hXhfS.DOM_EVENT).PLAY ? (0, $kWQO2.MediaInteractionType).Play : (0, $kWQO2.MediaInteractionType).Pause
        }));
    }, {
        capture: true,
        passive: true
    });
}

});

parcelRegister("97NWT", function(module, exports) {

$parcel$export(module.exports, "trackStyleSheet", () => $6a4b8351f494fda2$export$162cc50ed858c13d);

var $35a54 = parcelRequire("35a54");
parcelRequire("aJSOq");
var $kWQO2 = parcelRequire("kWQO2");
parcelRequire("2yVFW");
var $8P37p = parcelRequire("8P37p");

var $HhA2E = parcelRequire("HhA2E");
function $6a4b8351f494fda2$export$162cc50ed858c13d(styleSheetCb) {
    function checkStyleSheetAndCallback(styleSheet, callback) {
        if (styleSheet && (0, $8P37p.hasSerializedNode)(styleSheet.ownerNode)) callback((0, $8P37p.getSerializedNodeId)(styleSheet.ownerNode));
    }
    var instrumentationStoppers = [
        (0, $35a54.instrumentMethod)(CSSStyleSheet.prototype, "insertRule", function(_a) {
            var styleSheet = _a.target, _b = _a.parameters, rule = _b[0], index = _b[1];
            checkStyleSheetAndCallback(styleSheet, function(id) {
                return styleSheetCb((0, $HhA2E.assembleIncrementalSnapshot)((0, $kWQO2.IncrementalSource).StyleSheetRule, {
                    id: id,
                    adds: [
                        {
                            rule: rule,
                            index: index
                        }
                    ]
                }));
            });
        }),
        (0, $35a54.instrumentMethod)(CSSStyleSheet.prototype, "deleteRule", function(_a) {
            var styleSheet = _a.target, index = _a.parameters[0];
            checkStyleSheetAndCallback(styleSheet, function(id) {
                return styleSheetCb((0, $HhA2E.assembleIncrementalSnapshot)((0, $kWQO2.IncrementalSource).StyleSheetRule, {
                    id: id,
                    removes: [
                        {
                            index: index
                        }
                    ]
                }));
            });
        })
    ];
    if (typeof CSSGroupingRule !== "undefined") instrumentGroupingCSSRuleClass(CSSGroupingRule);
    else {
        instrumentGroupingCSSRuleClass(CSSMediaRule);
        instrumentGroupingCSSRuleClass(CSSSupportsRule);
    }
    function instrumentGroupingCSSRuleClass(cls) {
        instrumentationStoppers.push((0, $35a54.instrumentMethod)(cls.prototype, "insertRule", function(_a) {
            var styleSheet = _a.target, _b = _a.parameters, rule = _b[0], index = _b[1];
            checkStyleSheetAndCallback(styleSheet.parentStyleSheet, function(id) {
                var path = $6a4b8351f494fda2$export$5d7dd7838ad576e9(styleSheet);
                if (path) {
                    path.push(index || 0);
                    styleSheetCb((0, $HhA2E.assembleIncrementalSnapshot)((0, $kWQO2.IncrementalSource).StyleSheetRule, {
                        id: id,
                        adds: [
                            {
                                rule: rule,
                                index: path
                            }
                        ]
                    }));
                }
            });
        }), (0, $35a54.instrumentMethod)(cls.prototype, "deleteRule", function(_a) {
            var styleSheet = _a.target, index = _a.parameters[0];
            checkStyleSheetAndCallback(styleSheet.parentStyleSheet, function(id) {
                var path = $6a4b8351f494fda2$export$5d7dd7838ad576e9(styleSheet);
                if (path) {
                    path.push(index);
                    styleSheetCb((0, $HhA2E.assembleIncrementalSnapshot)((0, $kWQO2.IncrementalSource).StyleSheetRule, {
                        id: id,
                        removes: [
                            {
                                index: path
                            }
                        ]
                    }));
                }
            });
        }));
    }
    return {
        stop: function() {
            instrumentationStoppers.forEach(function(stopper) {
                return stopper.stop();
            });
        }
    };
}
function $6a4b8351f494fda2$export$5d7dd7838ad576e9(rule) {
    var path = [];
    var currentRule = rule;
    while(currentRule.parentRule){
        var rules_1 = Array.from(currentRule.parentRule.cssRules);
        var index_1 = rules_1.indexOf(currentRule);
        path.unshift(index_1);
        currentRule = currentRule.parentRule;
    }
    // A rule may not be attached to a stylesheet
    if (!currentRule.parentStyleSheet) return;
    var rules = Array.from(currentRule.parentStyleSheet.cssRules);
    var index = rules.indexOf(currentRule);
    path.unshift(index);
    return path;
}

});

parcelRegister("9znHG", function(module, exports) {

$parcel$export(module.exports, "trackFocus", () => $6f79c4fa77b2feb6$export$7d4f94d31d887582);

var $hXhfS = parcelRequire("hXhfS");
var $ly0px = parcelRequire("ly0px");
parcelRequire("aJSOq");
var $kWQO2 = parcelRequire("kWQO2");
function $6f79c4fa77b2feb6$export$7d4f94d31d887582(configuration, focusCb) {
    return (0, $hXhfS.addEventListeners)(configuration, window, [
        (0, $hXhfS.DOM_EVENT).FOCUS,
        (0, $hXhfS.DOM_EVENT).BLUR
    ], function() {
        focusCb({
            data: {
                has_focus: document.hasFocus()
            },
            type: (0, $kWQO2.RecordType).Focus,
            timestamp: (0, $ly0px.timeStampNow)()
        });
    });
}

});

parcelRegister("gfGf7", function(module, exports) {

$parcel$export(module.exports, "trackFrustration", () => $bd4ed0952a0033c5$export$c3a8b90296cd71cc);
parcelRequire("aJSOq");
var $kWQO2 = parcelRequire("kWQO2");
function $bd4ed0952a0033c5$export$c3a8b90296cd71cc(lifeCycle, frustrationCb, recordIds) {
    var frustrationSubscription = lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , function(data) {
        var _a, _b, _c;
        if (data.rawRumEvent.type === "action" /* RumEventType.ACTION */  && data.rawRumEvent.action.type === "click" /* ActionType.CLICK */  && ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) && "events" in data.domainContext && ((_c = data.domainContext.events) === null || _c === void 0 ? void 0 : _c.length)) frustrationCb({
            timestamp: data.rawRumEvent.date,
            type: (0, $kWQO2.RecordType).FrustrationRecord,
            data: {
                frustrationTypes: data.rawRumEvent.action.frustration.type,
                recordIds: data.domainContext.events.map(function(e) {
                    return recordIds.getIdForEvent(e);
                })
            }
        });
    });
    return {
        stop: function() {
            frustrationSubscription.unsubscribe();
        }
    };
}

});

parcelRegister("3CnsL", function(module, exports) {

$parcel$export(module.exports, "trackViewEnd", () => $2a271ef7d0ccae0b$export$83ef897ea1b996ba);

var $ly0px = parcelRequire("ly0px");
parcelRequire("aJSOq");
var $kWQO2 = parcelRequire("kWQO2");
function $2a271ef7d0ccae0b$export$83ef897ea1b996ba(lifeCycle, viewEndCb) {
    var viewEndSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */ , function() {
        viewEndCb({
            timestamp: (0, $ly0px.timeStampNow)(),
            type: (0, $kWQO2.RecordType).ViewEnd
        });
    });
    return {
        stop: function() {
            viewEndSubscription.unsubscribe();
        }
    };
}

});

parcelRegister("fE9XA", function(module, exports) {

$parcel$export(module.exports, "trackInput", () => $b6425153af858c5d$export$7ffba948d89b71d6);

var $hXhfS = parcelRequire("hXhfS");
var $fkj4Q = parcelRequire("fkj4Q");
var $35a54 = parcelRequire("35a54");
var $aed8w = parcelRequire("aed8w");
parcelRequire("4oXVz");
var $iznpK = parcelRequire("iznpK");

var $5u1q4 = parcelRequire("5u1q4");
parcelRequire("aJSOq");
var $kWQO2 = parcelRequire("kWQO2");

var $dHerU = parcelRequire("dHerU");

var $1vks3 = parcelRequire("1vks3");
parcelRequire("2yVFW");
var $8P37p = parcelRequire("8P37p");

var $HhA2E = parcelRequire("HhA2E");
function $b6425153af858c5d$export$7ffba948d89b71d6(configuration, inputCb, target) {
    if (target === void 0) target = document;
    var defaultPrivacyLevel = configuration.defaultPrivacyLevel;
    var lastInputStateMap = new WeakMap();
    var isShadowRoot = target !== document;
    var stopEventListeners = (0, $hXhfS.addEventListeners)(configuration, target, // The 'input' event bubbles across shadow roots, so we don't have to listen for it on shadow
    // roots since it will be handled by the event listener that we did add to the document. Only
    // the 'change' event is blocked and needs to be handled on shadow roots.
    isShadowRoot ? [
        (0, $hXhfS.DOM_EVENT).CHANGE
    ] : [
        (0, $hXhfS.DOM_EVENT).INPUT,
        (0, $hXhfS.DOM_EVENT).CHANGE
    ], function(event) {
        var target = (0, $dHerU.getEventTarget)(event);
        if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) onElementChange(target);
    }, {
        capture: true,
        passive: true
    }).stop;
    var stopPropertySetterInstrumentation;
    if (!isShadowRoot) {
        var instrumentationStoppers_1 = [
            (0, $35a54.instrumentSetter)(HTMLInputElement.prototype, "value", onElementChange),
            (0, $35a54.instrumentSetter)(HTMLInputElement.prototype, "checked", onElementChange),
            (0, $35a54.instrumentSetter)(HTMLSelectElement.prototype, "value", onElementChange),
            (0, $35a54.instrumentSetter)(HTMLTextAreaElement.prototype, "value", onElementChange),
            (0, $35a54.instrumentSetter)(HTMLSelectElement.prototype, "selectedIndex", onElementChange)
        ];
        stopPropertySetterInstrumentation = function() {
            instrumentationStoppers_1.forEach(function(stopper) {
                return stopper.stop();
            });
        };
    } else stopPropertySetterInstrumentation = (0, $aed8w.noop);
    return {
        stop: function() {
            stopPropertySetterInstrumentation();
            stopEventListeners();
        }
    };
    function onElementChange(target) {
        var nodePrivacyLevel = (0, $1vks3.getNodePrivacyLevel)(target, defaultPrivacyLevel);
        if (nodePrivacyLevel === (0, $5u1q4.NodePrivacyLevel).HIDDEN) return;
        var type = target.type;
        var inputState;
        if (type === "radio" || type === "checkbox") {
            if ((0, $1vks3.shouldMaskNode)(target, nodePrivacyLevel)) return;
            inputState = {
                isChecked: target.checked
            };
        } else {
            var value = (0, $8P37p.getElementInputValue)(target, nodePrivacyLevel);
            if (value === undefined) return;
            inputState = {
                text: value
            };
        }
        // Can be multiple changes on the same node within the same batched mutation observation.
        cbWithDedup(target, inputState);
        // If a radio was checked, other radios with the same name attribute will be unchecked.
        var name = target.name;
        if (type === "radio" && name && target.checked) (0, $fkj4Q.forEach)(document.querySelectorAll('input[type="radio"][name="'.concat((0, $iznpK.cssEscape)(name), '"]')), function(el) {
            if (el !== target) // TODO: Consider the privacy implications for various differing input privacy levels
            cbWithDedup(el, {
                isChecked: false
            });
        });
    }
    /**
     * There can be multiple changes on the same node within the same batched mutation observation.
     */ function cbWithDedup(target, inputState) {
        if (!(0, $8P37p.hasSerializedNode)(target)) return;
        var lastInputState = lastInputStateMap.get(target);
        if (!lastInputState || lastInputState.text !== inputState.text || lastInputState.isChecked !== inputState.isChecked) {
            lastInputStateMap.set(target, inputState);
            inputCb((0, $HhA2E.assembleIncrementalSnapshot)((0, $kWQO2.IncrementalSource).Input, (0, $fkj4Q.assign)({
                id: (0, $8P37p.getSerializedNodeId)(target)
            }, inputState)));
        }
    }
}

});

parcelRegister("6lHNk", function(module, exports) {

$parcel$export(module.exports, "trackMutation", () => $49f6acf317c92d20$export$24d76f013ec44d4c);

var $2wH3Z = parcelRequire("2wH3Z");
var $aed8w = parcelRequire("aed8w");
parcelRequire("4oXVz");
var $4TGNe = parcelRequire("4TGNe");
var $2Bt7w = parcelRequire("2Bt7w");

var $5u1q4 = parcelRequire("5u1q4");
parcelRequire("aJSOq");
var $kWQO2 = parcelRequire("kWQO2");

var $1vks3 = parcelRequire("1vks3");
parcelRequire("2yVFW");
var $8P37p = parcelRequire("8P37p");
var $1M37u = parcelRequire("1M37u");
var $73YKA = parcelRequire("73YKA");

var $9MX6J = parcelRequire("9MX6J");

var $HhA2E = parcelRequire("HhA2E");
function $49f6acf317c92d20$export$24d76f013ec44d4c(mutationCallback, configuration, shadowRootsController, target) {
    var MutationObserver = (0, $2Bt7w.getMutationObserverConstructor)();
    if (!MutationObserver) return {
        stop: (0, $aed8w.noop),
        flush: (0, $aed8w.noop)
    };
    var mutationBatch = (0, $9MX6J.createMutationBatch)(function(mutations) {
        $49f6acf317c92d20$var$processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration, shadowRootsController);
    });
    var observer = new MutationObserver((0, $2wH3Z.monitor)(mutationBatch.addMutations));
    observer.observe(target, {
        attributeOldValue: true,
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return {
        stop: function() {
            observer.disconnect();
            mutationBatch.stop();
        },
        flush: function() {
            mutationBatch.flush();
        }
    };
}
function $49f6acf317c92d20$var$processMutations(mutations, mutationCallback, configuration, shadowRootsController) {
    var nodePrivacyLevelCache = new Map();
    mutations.filter(function(mutation) {
        return mutation.type === "childList";
    }).forEach(function(mutation) {
        mutation.removedNodes.forEach(function(removedNode) {
            $49f6acf317c92d20$var$traverseRemovedShadowDom(removedNode, shadowRootsController.removeShadowRoot);
        });
    });
    // Discard any mutation with a 'target' node that:
    // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
    // part of a mutation occurring in a parent Node
    // * should be hidden or ignored
    var filteredMutations = mutations.filter(function(mutation) {
        return mutation.target.isConnected && (0, $8P37p.nodeAndAncestorsHaveSerializedNode)(mutation.target) && (0, $1vks3.getNodePrivacyLevel)(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache) !== (0, $5u1q4.NodePrivacyLevel).HIDDEN;
    });
    var _a = $49f6acf317c92d20$var$processChildListMutations(filteredMutations.filter(function(mutation) {
        return mutation.type === "childList";
    }), configuration, shadowRootsController, nodePrivacyLevelCache), adds = _a.adds, removes = _a.removes, hasBeenSerialized = _a.hasBeenSerialized;
    var texts = $49f6acf317c92d20$var$processCharacterDataMutations(filteredMutations.filter(function(mutation) {
        return mutation.type === "characterData" && !hasBeenSerialized(mutation.target);
    }), configuration, nodePrivacyLevelCache);
    var attributes = $49f6acf317c92d20$var$processAttributesMutations(filteredMutations.filter(function(mutation) {
        return mutation.type === "attributes" && !hasBeenSerialized(mutation.target);
    }), configuration, nodePrivacyLevelCache);
    if (!texts.length && !attributes.length && !removes.length && !adds.length) return;
    mutationCallback((0, $HhA2E.assembleIncrementalSnapshot)((0, $kWQO2.IncrementalSource).Mutation, {
        adds: adds,
        removes: removes,
        texts: texts,
        attributes: attributes
    }));
}
function $49f6acf317c92d20$var$processChildListMutations(mutations, configuration, shadowRootsController, nodePrivacyLevelCache) {
    // First, we iterate over mutations to collect:
    //
    // * nodes that have been added in the document and not removed by a subsequent mutation
    // * nodes that have been removed from the document but were not added in a previous mutation
    //
    // For this second category, we also collect their previous parent (mutation.target) because we'll
    // need it to emit a 'remove' mutation.
    //
    // Those two categories may overlap: if a node moved from a position to another, it is reported as
    // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
    // the node will be in both sets.
    var addedAndMovedNodes = new Set();
    var removedNodes = new Map();
    var _loop_1 = function(mutation) {
        mutation.addedNodes.forEach(function(node) {
            addedAndMovedNodes.add(node);
        });
        mutation.removedNodes.forEach(function(node) {
            if (!addedAndMovedNodes.has(node)) removedNodes.set(node, mutation.target);
            addedAndMovedNodes.delete(node);
        });
    };
    for(var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++){
        var mutation = mutations_1[_i];
        _loop_1(mutation);
    }
    // Then, we sort nodes that are still in the document by topological order, for two reasons:
    //
    // * We will serialize each added nodes with their descendants. We don't want to serialize a node
    // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
    // a precedent node.
    //
    // * To emit "add" mutations, we need references to the parent and potential next sibling of each
    // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
    // siblings, we want to iterate from last to first. This will ensure that any "next" node is
    // already serialized and have an id.
    var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
    $49f6acf317c92d20$export$3060629b5781df1e(sortedAddedAndMovedNodes);
    // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
    // node ids in a set to be able to skip subsequent related mutations.
    var serializedNodeIds = new Set();
    var addedNodeMutations = [];
    for(var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++){
        var node = sortedAddedAndMovedNodes_1[_a];
        if (hasBeenSerialized(node)) continue;
        var parentNodePrivacyLevel = (0, $1vks3.getNodePrivacyLevel)(node.parentNode, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        if (parentNodePrivacyLevel === (0, $5u1q4.NodePrivacyLevel).HIDDEN || parentNodePrivacyLevel === (0, $5u1q4.NodePrivacyLevel).IGNORE) continue;
        var serializedNode = (0, $73YKA.serializeNodeWithId)(node, {
            serializedNodeIds: serializedNodeIds,
            parentNodePrivacyLevel: parentNodePrivacyLevel,
            serializationContext: {
                status: 2 /* SerializationContextStatus.MUTATION */ ,
                shadowRootsController: shadowRootsController
            },
            configuration: configuration
        });
        if (!serializedNode) continue;
        var parentNode = (0, $4TGNe.getParentNode)(node);
        addedNodeMutations.push({
            nextId: getNextSibling(node),
            parentId: (0, $8P37p.getSerializedNodeId)(parentNode),
            node: serializedNode
        });
    }
    // Finally, we emit remove mutations.
    var removedNodeMutations = [];
    removedNodes.forEach(function(parent, node) {
        if ((0, $8P37p.hasSerializedNode)(node)) removedNodeMutations.push({
            parentId: (0, $8P37p.getSerializedNodeId)(parent),
            id: (0, $8P37p.getSerializedNodeId)(node)
        });
    });
    return {
        adds: addedNodeMutations,
        removes: removedNodeMutations,
        hasBeenSerialized: hasBeenSerialized
    };
    function hasBeenSerialized(node) {
        return (0, $8P37p.hasSerializedNode)(node) && serializedNodeIds.has((0, $8P37p.getSerializedNodeId)(node));
    }
    function getNextSibling(node) {
        var nextSibling = node.nextSibling;
        while(nextSibling){
            if ((0, $8P37p.hasSerializedNode)(nextSibling)) return (0, $8P37p.getSerializedNodeId)(nextSibling);
            nextSibling = nextSibling.nextSibling;
        }
        return null;
    }
}
function $49f6acf317c92d20$var$processCharacterDataMutations(mutations, configuration, nodePrivacyLevelCache) {
    var _a;
    var textMutations = [];
    // Deduplicate mutations based on their target node
    var handledNodes = new Set();
    var filteredMutations = mutations.filter(function(mutation) {
        if (handledNodes.has(mutation.target)) return false;
        handledNodes.add(mutation.target);
        return true;
    });
    // Emit mutations
    for(var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++){
        var mutation = filteredMutations_1[_i];
        var value = mutation.target.textContent;
        if (value === mutation.oldValue) continue;
        var parentNodePrivacyLevel = (0, $1vks3.getNodePrivacyLevel)((0, $4TGNe.getParentNode)(mutation.target), configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        if (parentNodePrivacyLevel === (0, $5u1q4.NodePrivacyLevel).HIDDEN || parentNodePrivacyLevel === (0, $5u1q4.NodePrivacyLevel).IGNORE) continue;
        textMutations.push({
            id: (0, $8P37p.getSerializedNodeId)(mutation.target),
            // TODO: pass a valid "ignoreWhiteSpace" argument
            value: (_a = (0, $1vks3.getTextContent)(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null
        });
    }
    return textMutations;
}
function $49f6acf317c92d20$var$processAttributesMutations(mutations, configuration, nodePrivacyLevelCache) {
    var attributeMutations = [];
    // Deduplicate mutations based on their target node and changed attribute
    var handledElements = new Map();
    var filteredMutations = mutations.filter(function(mutation) {
        var handledAttributes = handledElements.get(mutation.target);
        if (handledAttributes === null || handledAttributes === void 0 ? void 0 : handledAttributes.has(mutation.attributeName)) return false;
        if (!handledAttributes) handledElements.set(mutation.target, new Set([
            mutation.attributeName
        ]));
        else handledAttributes.add(mutation.attributeName);
        return true;
    });
    // Emit mutations
    var emittedMutations = new Map();
    for(var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++){
        var mutation = filteredMutations_2[_i];
        var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
        if (uncensoredValue === mutation.oldValue) continue;
        var privacyLevel = (0, $1vks3.getNodePrivacyLevel)(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        var attributeValue = (0, $1M37u.serializeAttribute)(mutation.target, privacyLevel, mutation.attributeName, configuration);
        var transformedValue = void 0;
        if (mutation.attributeName === "value") {
            var inputValue = (0, $8P37p.getElementInputValue)(mutation.target, privacyLevel);
            if (inputValue === undefined) continue;
            transformedValue = inputValue;
        } else if (typeof attributeValue === "string") transformedValue = attributeValue;
        else transformedValue = null;
        var emittedMutation = emittedMutations.get(mutation.target);
        if (!emittedMutation) {
            emittedMutation = {
                id: (0, $8P37p.getSerializedNodeId)(mutation.target),
                attributes: {}
            };
            attributeMutations.push(emittedMutation);
            emittedMutations.set(mutation.target, emittedMutation);
        }
        emittedMutation.attributes[mutation.attributeName] = transformedValue;
    }
    return attributeMutations;
}
function $49f6acf317c92d20$export$3060629b5781df1e(nodes) {
    nodes.sort(function(a, b) {
        var position = a.compareDocumentPosition(b);
        /* eslint-disable no-bitwise */ if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
        else if (position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
        else if (position & Node.DOCUMENT_POSITION_FOLLOWING) return 1;
        else if (position & Node.DOCUMENT_POSITION_PRECEDING) return -1;
        /* eslint-enable no-bitwise */ return 0;
    });
}
function $49f6acf317c92d20$var$traverseRemovedShadowDom(removedNode, shadowDomRemovedCallback) {
    if ((0, $4TGNe.isNodeShadowHost)(removedNode)) shadowDomRemovedCallback(removedNode.shadowRoot);
    (0, $4TGNe.forEachChildNodes)(removedNode, function(childNode) {
        return $49f6acf317c92d20$var$traverseRemovedShadowDom(childNode, shadowDomRemovedCallback);
    });
}

});
parcelRegister("9MX6J", function(module, exports) {

$parcel$export(module.exports, "createMutationBatch", () => $720672434d5f1bfe$export$b2ea3e1c9a968529);

var $2wH3Z = parcelRequire("2wH3Z");
var $aed8w = parcelRequire("aed8w");
/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */ var $720672434d5f1bfe$var$MUTATION_PROCESS_MAX_DELAY = 100;
function $720672434d5f1bfe$export$b2ea3e1c9a968529(processMutationBatch) {
    var cancelScheduledFlush = (0, $aed8w.noop);
    var pendingMutations = [];
    function flush() {
        cancelScheduledFlush();
        processMutationBatch(pendingMutations);
        pendingMutations = [];
    }
    return {
        addMutations: function(mutations) {
            if (pendingMutations.length === 0) cancelScheduledFlush = $720672434d5f1bfe$var$requestIdleCallback(flush, {
                timeout: $720672434d5f1bfe$var$MUTATION_PROCESS_MAX_DELAY
            });
            pendingMutations.push.apply(pendingMutations, mutations);
        },
        flush: flush,
        stop: function() {
            cancelScheduledFlush();
        }
    };
}
/**
 * Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
 * browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
 * fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
 * browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes efficiently.
 *
 * Note: check both 'requestIdleCallback' and 'cancelIdleCallback' existence because some polyfills only implement 'requestIdleCallback'.
 */ function $720672434d5f1bfe$var$requestIdleCallback(callback, opts) {
    if (window.requestIdleCallback && window.cancelIdleCallback) {
        var id_1 = window.requestIdleCallback((0, $2wH3Z.monitor)(callback), opts);
        return function() {
            return window.cancelIdleCallback(id_1);
        };
    }
    var id = window.requestAnimationFrame((0, $2wH3Z.monitor)(callback));
    return function() {
        return window.cancelAnimationFrame(id);
    };
}

});



parcelRegister("g8Vdv", function(module, exports) {

$parcel$export(module.exports, "createElementsScrollPositions", () => $bc09c6c4b264fe70$export$e1169a2914f55ec7);
function $bc09c6c4b264fe70$export$e1169a2914f55ec7() {
    var scrollPositionsByElement = new WeakMap();
    return {
        set: function(element, scrollPositions) {
            if (element === document && !document.scrollingElement) // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
            // in some cases scrolling elements can not be defined, we don't support those for now
            return;
            scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
        },
        get: function(element) {
            return scrollPositionsByElement.get(element);
        },
        has: function(element) {
            return scrollPositionsByElement.has(element);
        }
    };
}

});

parcelRegister("kLFSm", function(module, exports) {

$parcel$export(module.exports, "initShadowRootsController", () => $f1e8ae18fd501662$export$436c949d161d53cc);
parcelRequire("68oTy");
var $fE9XA = parcelRequire("fE9XA");
var $6lHNk = parcelRequire("6lHNk");
var $f1e8ae18fd501662$export$436c949d161d53cc = function(configuration, _a) {
    var mutationCb = _a.mutationCb, inputCb = _a.inputCb;
    var controllerByShadowRoot = new Map();
    var shadowRootsController = {
        addShadowRoot: function(shadowRoot) {
            if (controllerByShadowRoot.has(shadowRoot)) return;
            var mutationTracker = (0, $6lHNk.trackMutation)(mutationCb, configuration, shadowRootsController, shadowRoot);
            // the change event no do bubble up across the shadow root, we have to listen on the shadow root
            var inputTracker = (0, $fE9XA.trackInput)(configuration, inputCb, shadowRoot);
            controllerByShadowRoot.set(shadowRoot, {
                flush: function() {
                    return mutationTracker.flush();
                },
                stop: function() {
                    mutationTracker.stop();
                    inputTracker.stop();
                }
            });
        },
        removeShadowRoot: function(shadowRoot) {
            var entry = controllerByShadowRoot.get(shadowRoot);
            if (!entry) // unidentified root cause: observed in some cases with shadow DOM added by browser extensions
            return;
            entry.stop();
            controllerByShadowRoot.delete(shadowRoot);
        },
        stop: function() {
            controllerByShadowRoot.forEach(function(_a) {
                var stop = _a.stop;
                return stop();
            });
        },
        flush: function() {
            controllerByShadowRoot.forEach(function(_a) {
                var flush = _a.flush;
                return flush();
            });
        }
    };
    return shadowRootsController;
};

});

parcelRegister("l1W1u", function(module, exports) {

$parcel$export(module.exports, "startFullSnapshots", () => $f4f6b32442ffef0e$export$4955b6cdd7723991);
parcelRequire("4oXVz");
var $fvpT8 = parcelRequire("fvpT8");
var $kom4r = parcelRequire("kom4r");

var $ly0px = parcelRequire("ly0px");
parcelRequire("aJSOq");
var $kWQO2 = parcelRequire("kWQO2");
parcelRequire("2yVFW");
var $8Updw = parcelRequire("8Updw");

var $fZRY4 = parcelRequire("fZRY4");
function $f4f6b32442ffef0e$export$4955b6cdd7723991(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, fullSnapshotCallback) {
    var takeFullSnapshot = function(timestamp, serializationContext) {
        if (timestamp === void 0) timestamp = (0, $ly0px.timeStampNow)();
        if (serializationContext === void 0) serializationContext = {
            status: 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */ ,
            elementsScrollPositions: elementsScrollPositions,
            shadowRootsController: shadowRootsController
        };
        var _a = (0, $kom4r.getViewportDimension)(), width = _a.width, height = _a.height;
        var records = [
            {
                data: {
                    height: height,
                    href: window.location.href,
                    width: width
                },
                type: (0, $kWQO2.RecordType).Meta,
                timestamp: timestamp
            },
            {
                data: {
                    has_focus: document.hasFocus()
                },
                type: (0, $kWQO2.RecordType).Focus,
                timestamp: timestamp
            },
            {
                data: {
                    node: (0, $8Updw.serializeDocument)(document, configuration, serializationContext),
                    initialOffset: {
                        left: (0, $fvpT8.getScrollX)(),
                        top: (0, $fvpT8.getScrollY)()
                    }
                },
                type: (0, $kWQO2.RecordType).FullSnapshot,
                timestamp: timestamp
            }
        ];
        if (window.visualViewport) records.push({
            data: (0, $fZRY4.getVisualViewport)(window.visualViewport),
            type: (0, $kWQO2.RecordType).VisualViewport,
            timestamp: timestamp
        });
        return records;
    };
    fullSnapshotCallback(takeFullSnapshot());
    var unsubscribe = lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_CREATED */ , function(view) {
        flushMutations();
        fullSnapshotCallback(takeFullSnapshot(view.startClocks.timeStamp, {
            shadowRootsController: shadowRootsController,
            status: 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */ ,
            elementsScrollPositions: elementsScrollPositions
        }));
    }).unsubscribe;
    return {
        stop: unsubscribe
    };
}

});

parcelRegister("2wixe", function(module, exports) {

$parcel$export(module.exports, "initRecordIds", () => $1d5cf29b7dc064ad$export$9a1e4d732092db82);
function $1d5cf29b7dc064ad$export$9a1e4d732092db82() {
    var recordIds = new WeakMap();
    var nextId = 1;
    return {
        getIdForEvent: function(event) {
            if (!recordIds.has(event)) recordIds.set(event, nextId++);
            return recordIds.get(event);
        }
    };
}

});



parcelRegister("8s77k", function(module, exports) {

$parcel$export(module.exports, "startSegmentCollection", () => (parcelRequire("7X2dz")).startSegmentCollection);
$parcel$export(module.exports, "SEGMENT_BYTES_LIMIT", () => (parcelRequire("7X2dz")).SEGMENT_BYTES_LIMIT);

var $7X2dz = parcelRequire("7X2dz");

});
parcelRegister("7X2dz", function(module, exports) {

$parcel$export(module.exports, "SEGMENT_BYTES_LIMIT", () => $5c9fc380af7b5cde$export$498b4a5e1a0c6ede);
$parcel$export(module.exports, "startSegmentCollection", () => $5c9fc380af7b5cde$export$4fa4acf70ad1cce9);

var $d97UU = parcelRequire("d97UU");
var $1gpLX = parcelRequire("1gpLX");
var $ly0px = parcelRequire("ly0px");

var $dIeB7 = parcelRequire("dIeB7");

var $i5KAU = parcelRequire("i5KAU");
var $5c9fc380af7b5cde$export$b31f220778239113 = 30 * (0, $ly0px.ONE_SECOND);
var $5c9fc380af7b5cde$export$498b4a5e1a0c6ede = 60000;
function $5c9fc380af7b5cde$export$4fa4acf70ad1cce9(lifeCycle, configuration, sessionManager, viewContexts, httpRequest, encoder) {
    return $5c9fc380af7b5cde$export$a72587c29e6a171e(lifeCycle, function() {
        return $5c9fc380af7b5cde$export$ffabacd17e6fd35a(configuration.applicationId, sessionManager, viewContexts);
    }, httpRequest, encoder);
}
function $5c9fc380af7b5cde$export$a72587c29e6a171e(lifeCycle, getSegmentContext, httpRequest, encoder) {
    var state = {
        status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */ ,
        nextSegmentCreationReason: "init"
    };
    var unsubscribeViewCreated = lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_CREATED */ , function() {
        flushSegment("view_change");
    }).unsubscribe;
    var unsubscribePageExited = lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */ , function(pageExitEvent) {
        flushSegment(pageExitEvent.reason);
    }).unsubscribe;
    function flushSegment(flushReason) {
        if (state.status === 1 /* SegmentCollectionStatus.SegmentPending */ ) {
            state.segment.flush(function(metadata, encoderResult) {
                var payload = (0, $dIeB7.buildReplayPayload)(encoderResult.output, metadata, encoderResult.rawBytesCount);
                if ((0, $1gpLX.isPageExitReason)(flushReason)) httpRequest.sendOnExit(payload);
                else httpRequest.send(payload);
            });
            (0, $d97UU.clearTimeout)(state.expirationTimeoutId);
        }
        if (flushReason !== "stop") state = {
            status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */ ,
            nextSegmentCreationReason: flushReason
        };
        else state = {
            status: 2 /* SegmentCollectionStatus.Stopped */ 
        };
    }
    return {
        addRecord: function(record) {
            if (state.status === 2 /* SegmentCollectionStatus.Stopped */ ) return;
            if (state.status === 0 /* SegmentCollectionStatus.WaitingForInitialRecord */ ) {
                var context = getSegmentContext();
                if (!context) return;
                state = {
                    status: 1 /* SegmentCollectionStatus.SegmentPending */ ,
                    segment: new (0, $i5KAU.Segment)(encoder, context, state.nextSegmentCreationReason),
                    expirationTimeoutId: (0, $d97UU.setTimeout)(function() {
                        flushSegment("segment_duration_limit");
                    }, $5c9fc380af7b5cde$export$b31f220778239113)
                };
            }
            state.segment.addRecord(record, function(encodedBytesCount) {
                if (encodedBytesCount > $5c9fc380af7b5cde$export$498b4a5e1a0c6ede) flushSegment("segment_bytes_limit");
            });
        },
        stop: function() {
            flushSegment("stop");
            unsubscribeViewCreated();
            unsubscribePageExited();
        }
    };
}
function $5c9fc380af7b5cde$export$ffabacd17e6fd35a(applicationId, sessionManager, viewContexts) {
    var session = sessionManager.findTrackedSession();
    var viewContext = viewContexts.findView();
    if (!session || !viewContext) return undefined;
    return {
        application: {
            id: applicationId
        },
        session: {
            id: session.id
        },
        view: {
            id: viewContext.id
        }
    };
}
function $5c9fc380af7b5cde$export$fabe14a3439e20b(newSegmentBytesLimit) {
    if (newSegmentBytesLimit === void 0) newSegmentBytesLimit = 60000;
    $5c9fc380af7b5cde$export$498b4a5e1a0c6ede = newSegmentBytesLimit;
}

});
parcelRegister("dIeB7", function(module, exports) {

$parcel$export(module.exports, "buildReplayPayload", () => $9fbab539f7a5d513$export$b74fe9b7c5190a03);

var $fkj4Q = parcelRequire("fkj4Q");
function $9fbab539f7a5d513$export$b74fe9b7c5190a03(data, metadata, rawSegmentBytesCount) {
    var formData = new FormData();
    formData.append("segment", new Blob([
        data
    ], {
        type: "application/octet-stream"
    }), "".concat(metadata.session.id, "-").concat(metadata.start));
    var metadataAndSegmentSizes = (0, $fkj4Q.assign)({
        raw_segment_size: rawSegmentBytesCount,
        compressed_segment_size: data.byteLength
    }, metadata);
    var serializedMetadataAndSegmentSizes = JSON.stringify(metadataAndSegmentSizes);
    formData.append("event", new Blob([
        serializedMetadataAndSegmentSizes
    ], {
        type: "application/json"
    }));
    return {
        data: formData,
        bytesCount: data.byteLength
    };
}

});

parcelRegister("i5KAU", function(module, exports) {

$parcel$export(module.exports, "Segment", () => $d2bcd6486e08f4b9$export$d53aa5c5ab432700);

var $fkj4Q = parcelRequire("fkj4Q");
parcelRequire("aJSOq");
var $kWQO2 = parcelRequire("kWQO2");

var $j4d5H = parcelRequire("j4d5H");
var $d2bcd6486e08f4b9$export$d53aa5c5ab432700 = /** @class */ function() {
    function Segment(encoder, context, creationReason) {
        this.encoder = encoder;
        this.encodedBytesCount = 0;
        var viewId = context.view.id;
        this.metadata = (0, $fkj4Q.assign)({
            start: Infinity,
            end: -Infinity,
            creation_reason: creationReason,
            records_count: 0,
            has_full_snapshot: false,
            index_in_view: $j4d5H.getSegmentsCount(viewId),
            source: "browser"
        }, context);
        $j4d5H.addSegment(viewId);
    }
    Segment.prototype.addRecord = function(record, callback) {
        var _this = this;
        var _a;
        this.metadata.start = Math.min(this.metadata.start, record.timestamp);
        this.metadata.end = Math.max(this.metadata.end, record.timestamp);
        this.metadata.records_count += 1;
        (_a = this.metadata).has_full_snapshot || (_a.has_full_snapshot = record.type === (0, $kWQO2.RecordType).FullSnapshot);
        var prefix = this.encoder.isEmpty ? '{"records":[' : ",";
        this.encoder.write(prefix + JSON.stringify(record), function(additionalEncodedBytesCount) {
            _this.encodedBytesCount += additionalEncodedBytesCount;
            callback(_this.encodedBytesCount);
        });
    };
    Segment.prototype.flush = function(callback) {
        var _this = this;
        if (this.encoder.isEmpty) throw new Error("Empty segment flushed");
        this.encoder.write("],".concat(JSON.stringify(this.metadata).slice(1), "\n"));
        this.encoder.finish(function(encoderResult) {
            $j4d5H.addWroteData(_this.metadata.view.id, encoderResult.rawBytesCount);
            callback(_this.metadata, encoderResult);
        });
    };
    return Segment;
}();

});



parcelRegister("4IfYP", function(module, exports) {

$parcel$export(module.exports, "startRecordBridge", () => $36e7aacddb9ca9fe$export$f4759b712f6b3c83);

var $kFaIT = parcelRequire("kFaIT");
function $36e7aacddb9ca9fe$export$f4759b712f6b3c83(viewContexts) {
    var bridge = (0, $kFaIT.getEventBridge)();
    return {
        addRecord: function(record) {
            // Get the current active view, not at the time of the record, aligning with the segment logic.
            // This approach could potentially associate the record to an incorrect view, in case the record date is in the past (e.g. frustration records).
            // However the risk is minimal. We could address the issue when potential negative impact are identified.
            var view = viewContexts.findView();
            bridge.send("record", record, view.id);
        }
    };
}

});


parcelRegister("3VNwe", function(module, exports) {

$parcel$export(module.exports, "makeRecorderApi", () => $2dcd1b6060126fce$export$e9b5b20eb46e0952);

var $kFaIT = parcelRequire("kFaIT");
var $aed8w = parcelRequire("aed8w");
var $1gpLX = parcelRequire("1gpLX");
var $9h4jO = parcelRequire("9h4jO");

var $j4d5H = parcelRequire("j4d5H");

var $hj8ld = parcelRequire("hj8ld");
parcelRequire("l2g7V");
var $3nvYK = parcelRequire("3nvYK");
var $ftUlk = parcelRequire("ftUlk");

var $cBqcZ = parcelRequire("cBqcZ");
function $2dcd1b6060126fce$export$e9b5b20eb46e0952(startRecordingImpl, createDeflateWorkerImpl) {
    if ((0, $kFaIT.canUseEventBridge)() && !(0, $kFaIT.bridgeSupports)("records" /* BridgeCapability.RECORDS */ ) || !(0, $cBqcZ.isBrowserSupported)()) return {
        start: (0, $aed8w.noop),
        stop: (0, $aed8w.noop),
        getReplayStats: function() {
            return undefined;
        },
        onRumStart: (0, $aed8w.noop),
        isRecording: function() {
            return false;
        },
        getSessionReplayLink: function() {
            return undefined;
        }
    };
    var state = {
        status: 1 /* RecorderStatus.IntentToStart */ 
    };
    var startStrategy = function() {
        state = {
            status: 1 /* RecorderStatus.IntentToStart */ 
        };
    };
    var stopStrategy = function() {
        state = {
            status: 0 /* RecorderStatus.Stopped */ 
        };
    };
    var getSessionReplayLinkStrategy = (0, $aed8w.noop);
    return {
        start: function() {
            return startStrategy();
        },
        stop: function() {
            return stopStrategy();
        },
        getSessionReplayLink: function() {
            return getSessionReplayLinkStrategy();
        },
        onRumStart: function(lifeCycle, configuration, sessionManager, viewContexts, worker) {
            if (configuration.startSessionReplayRecordingManually) state = {
                status: 0 /* RecorderStatus.Stopped */ 
            };
            lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */ , function() {
                if (state.status === 2 /* RecorderStatus.Starting */  || state.status === 3 /* RecorderStatus.Started */ ) {
                    stopStrategy();
                    state = {
                        status: 1 /* RecorderStatus.IntentToStart */ 
                    };
                }
            });
            // Stop the recorder on page unload to avoid sending records after the page is ended.
            lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */ , function(pageExitEvent) {
                if (pageExitEvent.reason === (0, $1gpLX.PageExitReason).UNLOADING || pageExitEvent.reason === (0, $1gpLX.PageExitReason).PAGEHIDE) stopStrategy();
            });
            lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , function() {
                if (state.status === 1 /* RecorderStatus.IntentToStart */ ) startStrategy();
            });
            var cachedDeflateEncoder;
            function getOrCreateDeflateEncoder() {
                if (!cachedDeflateEncoder) {
                    if (!worker) worker = (0, $ftUlk.startDeflateWorker)(configuration, "Datadog Session Replay", function() {
                        stopStrategy();
                    }, createDeflateWorkerImpl);
                    if (worker) cachedDeflateEncoder = (0, $3nvYK.createDeflateEncoder)(configuration, worker, 1 /* DeflateEncoderStreamId.REPLAY */ );
                }
                return cachedDeflateEncoder;
            }
            startStrategy = function() {
                var session = sessionManager.findTrackedSession();
                if (!session || !session.sessionReplayAllowed) {
                    state = {
                        status: 1 /* RecorderStatus.IntentToStart */ 
                    };
                    return;
                }
                if (state.status === 2 /* RecorderStatus.Starting */  || state.status === 3 /* RecorderStatus.Started */ ) return;
                state = {
                    status: 2 /* RecorderStatus.Starting */ 
                };
                (0, $9h4jO.runOnReadyState)(configuration, "interactive", function() {
                    if (state.status !== 2 /* RecorderStatus.Starting */ ) return;
                    var deflateEncoder = getOrCreateDeflateEncoder();
                    if (!deflateEncoder) {
                        state = {
                            status: 0 /* RecorderStatus.Stopped */ 
                        };
                        return;
                    }
                    var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewContexts, deflateEncoder).stop;
                    state = {
                        status: 3 /* RecorderStatus.Started */ ,
                        stopRecording: stopRecording
                    };
                });
            };
            stopStrategy = function() {
                if (state.status === 0 /* RecorderStatus.Stopped */ ) return;
                if (state.status === 3 /* RecorderStatus.Started */ ) state.stopRecording();
                state = {
                    status: 0 /* RecorderStatus.Stopped */ 
                };
            };
            getSessionReplayLinkStrategy = function() {
                return (0, $hj8ld.getSessionReplayLink)(configuration, sessionManager, viewContexts, state.status !== 0 /* RecorderStatus.Stopped */ );
            };
            if (state.status === 1 /* RecorderStatus.IntentToStart */ ) startStrategy();
        },
        isRecording: function() {
            // The worker is started optimistically, meaning we could have started to record but its
            // initialization fails a bit later. This could happen when:
            // * the worker URL (blob or plain URL) is blocked by CSP in Firefox only (Chromium and Safari
            // throw an exception when instantiating the worker, and IE doesn't care about CSP)
            // * the browser fails to load the worker in case the workerUrl is used
            // * an unexpected error occurs in the Worker before initialization, ex:
            //   * a runtime exception collected by monitor()
            //   * a syntax error notified by the browser via an error event
            // * the worker is unresponsive for some reason and timeouts
            //
            // It is not expected to happen often. Nonetheless, the "replayable" status on RUM events is
            // an important part of the Datadog App:
            // * If we have a false positive (we set has_replay: true even if no replay data is present),
            // we might display broken links to the Session Replay player.
            // * If we have a false negative (we don't set has_replay: true even if replay data is
            // available), it is less noticeable because no link will be displayed.
            //
            // Thus, it is better to have false negative, so let's make sure the worker is correctly
            // initialized before advertizing that we are recording.
            //
            // In the future, when the compression worker will also be used for RUM data, this will be
            // less important since no RUM event will be sent when the worker fails to initialize.
            return (0, $ftUlk.getDeflateWorkerStatus)() === 3 /* DeflateWorkerStatus.Initialized */  && state.status === 3 /* RecorderStatus.Started */ ;
        },
        getReplayStats: function(viewId) {
            return (0, $ftUlk.getDeflateWorkerStatus)() === 3 /* DeflateWorkerStatus.Initialized */  ? (0, $j4d5H.getReplayStats)(viewId) : undefined;
        }
    };
}

});
parcelRegister("hj8ld", function(module, exports) {

$parcel$export(module.exports, "getSessionReplayLink", () => $c99aae6d4d014aa5$export$5070ba0fc541c84);
parcelRequire("4oXVz");
var $dKooA = parcelRequire("dKooA");

var $cBqcZ = parcelRequire("cBqcZ");
function $c99aae6d4d014aa5$export$5070ba0fc541c84(configuration, sessionManager, viewContexts, isRecordingStarted) {
    var session = sessionManager.findTrackedSession();
    var errorType = $c99aae6d4d014aa5$var$getErrorType(session, isRecordingStarted);
    var viewContext = viewContexts.findView();
    return (0, $dKooA.getSessionReplayUrl)(configuration, {
        viewContext: viewContext,
        errorType: errorType,
        session: session
    });
}
function $c99aae6d4d014aa5$var$getErrorType(session, isRecordingStarted) {
    if (!(0, $cBqcZ.isBrowserSupported)()) return "browser-not-supported";
    if (!session) // possibilities:
    // - rum sampled out
    // - session expired (edge case)
    return "rum-not-tracked";
    if (!session.sessionReplayAllowed) // possibilities
    // - replay sampled out
    return "incorrect-session-plan";
    if (!isRecordingStarted) return "replay-not-started";
}

});
parcelRegister("cBqcZ", function(module, exports) {

$parcel$export(module.exports, "isBrowserSupported", () => $92cd453a3fca38f8$export$3fe402ec04821f17);
/**
 * Test for Browser features used while recording
 */ function $92cd453a3fca38f8$export$3fe402ec04821f17() {
    return(// Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === "function" && typeof CSSSupportsRule === "function" && typeof URL.createObjectURL === "function" && "forEach" in NodeList.prototype);
}

});


parcelRegister("l2g7V", function(module, exports) {

$parcel$export(module.exports, "createDeflateEncoder", () => (parcelRequire("3nvYK")).createDeflateEncoder);
$parcel$export(module.exports, "startDeflateWorker", () => (parcelRequire("ftUlk")).startDeflateWorker);
$parcel$export(module.exports, "getDeflateWorkerStatus", () => (parcelRequire("ftUlk")).getDeflateWorkerStatus);

var $3nvYK = parcelRequire("3nvYK");

var $ftUlk = parcelRequire("ftUlk");

});
parcelRegister("3nvYK", function(module, exports) {

$parcel$export(module.exports, "createDeflateEncoder", () => $275c53661b5d2fb2$export$1b838d3ae89a44b8);

var $hXhfS = parcelRequire("hXhfS");
var $fhNdh = parcelRequire("fhNdh");
var $fkj4Q = parcelRequire("fkj4Q");
var $7S2uk = parcelRequire("7S2uk");
function $275c53661b5d2fb2$export$1b838d3ae89a44b8(configuration, worker, streamId) {
    var rawBytesCount = 0;
    var compressedData = [];
    var compressedDataTrailer;
    var nextWriteActionId = 0;
    var pendingWriteActions = [];
    var removeMessageListener = (0, $hXhfS.addEventListener)(configuration, worker, "message", function(_a) {
        var workerResponse = _a.data;
        if (workerResponse.type !== "wrote" || workerResponse.streamId !== streamId) return;
        rawBytesCount += workerResponse.additionalBytesCount;
        compressedData.push(workerResponse.result);
        compressedDataTrailer = workerResponse.trailer;
        var nextPendingAction = pendingWriteActions.shift();
        if (nextPendingAction && nextPendingAction.id === workerResponse.id) {
            if (nextPendingAction.writeCallback) nextPendingAction.writeCallback(workerResponse.result.byteLength);
            else if (nextPendingAction.finishCallback) nextPendingAction.finishCallback();
        } else {
            removeMessageListener();
            (0, $fhNdh.addTelemetryDebug)("Worker responses received out of order.");
        }
    }).stop;
    function consumeResult() {
        var output = compressedData.length === 0 ? new Uint8Array(0) : (0, $7S2uk.concatBuffers)(compressedData.concat(compressedDataTrailer));
        var result = {
            rawBytesCount: rawBytesCount,
            output: output,
            outputBytesCount: output.byteLength,
            encoding: "deflate"
        };
        rawBytesCount = 0;
        compressedData = [];
        return result;
    }
    function sendResetIfNeeded() {
        if (nextWriteActionId > 0) {
            worker.postMessage({
                action: "reset",
                streamId: streamId
            });
            nextWriteActionId = 0;
        }
    }
    return {
        isAsync: true,
        get isEmpty () {
            return nextWriteActionId === 0;
        },
        write: function(data, callback) {
            worker.postMessage({
                action: "write",
                id: nextWriteActionId,
                data: data,
                streamId: streamId
            });
            pendingWriteActions.push({
                id: nextWriteActionId,
                writeCallback: callback,
                data: data
            });
            nextWriteActionId += 1;
        },
        finish: function(callback) {
            sendResetIfNeeded();
            if (!pendingWriteActions.length) callback(consumeResult());
            else {
                // Make sure we do not call any write callback
                pendingWriteActions.forEach(function(pendingWriteAction) {
                    delete pendingWriteAction.writeCallback;
                });
                // Wait for the last action to finish before calling the finish callback
                pendingWriteActions[pendingWriteActions.length - 1].finishCallback = function() {
                    return callback(consumeResult());
                };
            }
        },
        finishSync: function() {
            sendResetIfNeeded();
            var pendingData = pendingWriteActions.map(function(pendingWriteAction) {
                // Make sure we do not call any write or finish callback
                delete pendingWriteAction.writeCallback;
                delete pendingWriteAction.finishCallback;
                return pendingWriteAction.data;
            }).join("");
            return (0, $fkj4Q.assign)(consumeResult(), {
                pendingData: pendingData
            });
        },
        estimateEncodedBytesCount: function(data) {
            // This is a rough estimation of the data size once it'll be encoded by deflate. We observed
            // that if it's the first chunk of data pushed to the stream, the ratio is lower (3-4), but
            // after that the ratio is greater (10+). We chose 8 here, which (on average) seems to produce
            // requests of the expected size.
            return data.length / 8;
        },
        stop: function() {
            removeMessageListener();
        }
    };
}

});

parcelRegister("ftUlk", function(module, exports) {

$parcel$export(module.exports, "startDeflateWorker", () => $b455450598273b03$export$8ad05986c983585a);
$parcel$export(module.exports, "getDeflateWorkerStatus", () => $b455450598273b03$export$c2a4b833556ae71);

var $hXhfS = parcelRequire("hXhfS");
var $fhNdh = parcelRequire("fhNdh");
var $5IDGB = parcelRequire("5IDGB");
var $fkj4Q = parcelRequire("fkj4Q");
var $ly0px = parcelRequire("ly0px");
var $d97UU = parcelRequire("d97UU");
var $b455450598273b03$export$da9b966004898f5b = 10 * (0, $ly0px.ONE_SECOND);
function $b455450598273b03$var$createDeflateWorker(configuration) {
    return new Worker(configuration.workerUrl || URL.createObjectURL(new Blob([
        '!function(){"use strict";function t(t){for(var e=t.reduce((function(t,e){return t+e.length}),0),a=new Uint8Array(e),n=0,r=0,i=t;r<i.length;r++){var s=i[r];a.set(s,n),n+=s.length}return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=256,n=286,r=30,i=15,s=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),_=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),h=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),l=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),o=new Array(576);e(o);var d=new Array(60);e(d);var u=new Array(512);e(u);var f=new Array(256);e(f);var c=new Array(29);e(c);var p,g,w,v=new Array(r);function b(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function m(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(v);var y=function(t){return t<256?u[t]:u[256+(t>>>7)]},k=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},z=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,k(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},x=function(t,e,a){z(t,a[2*e],a[2*e+1])},A=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},E=function(t,e,a){var n,r,s=new Array(16),_=0;for(n=1;n<=i;n++)s[n]=_=_+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=A(s[h]++,h))}},Z=function(t){var e;for(e=0;e<n;e++)t.dyn_ltree[2*e]=0;for(e=0;e<r;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},U=function(t){t.bi_valid>8?k(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},S=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},R=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&S(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!S(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},L=function(t,e,n){var r,i,h,l,o=0;if(0!==t.last_lit)do{r=t.pending_buf[t.d_buf+2*o]<<8|t.pending_buf[t.d_buf+2*o+1],i=t.pending_buf[t.l_buf+o],o++,0===r?x(t,i,e):(h=f[i],x(t,h+a+1,e),0!==(l=s[h])&&(i-=c[h],z(t,i,l)),r--,h=y(r),x(t,h,n),0!==(l=_[h])&&(r-=v[h],z(t,r,l)))}while(o<t.last_lit);x(t,256,e)},F=function(t,e){var a,n,r,s=e.dyn_tree,_=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,o=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==s[2*a]?(t.heap[++t.heap_len]=o=a,t.depth[a]=0):s[2*a+1]=0;for(;t.heap_len<2;)s[2*(r=t.heap[++t.heap_len]=o<2?++o:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=_[2*r+1]);for(e.max_code=o,a=t.heap_len>>1;a>=1;a--)R(t,s,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],R(t,s,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,s[2*r]=s[2*a]+s[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,s[2*a+1]=s[2*n+1]=r,t.heap[1]=r++,R(t,s,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,s,_,h,l=e.dyn_tree,o=e.max_code,d=e.stat_desc.static_tree,u=e.stat_desc.has_stree,f=e.stat_desc.extra_bits,c=e.stat_desc.extra_base,p=e.stat_desc.max_length,g=0;for(s=0;s<=i;s++)t.bl_count[s]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(s=l[2*l[2*(n=t.heap[a])+1]+1]+1)>p&&(s=p,g++),l[2*n+1]=s,n>o||(t.bl_count[s]++,_=0,n>=c&&(_=f[n-c]),h=l[2*n],t.opt_len+=h*(s+_),u&&(t.static_len+=h*(d[2*n+1]+_)));if(0!==g){do{for(s=p-1;0===t.bl_count[s];)s--;t.bl_count[s]--,t.bl_count[s+1]+=2,t.bl_count[p]--,g-=2}while(g>0);for(s=p;0!==s;s--)for(n=t.bl_count[s];0!==n;)(r=t.heap[--a])>o||(l[2*r+1]!==s&&(t.opt_len+=(s-l[2*r+1])*l[2*r],l[2*r+1]=s),n--)}}(t,e),E(s,o,t.bl_count)},T=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++_<h&&r===s||(_<l?t.bl_tree[2*r]+=_:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):_<=10?t.bl_tree[34]++:t.bl_tree[36]++,_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4))},I=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++_<h&&r===s)){if(_<l)do{x(t,r,t.bl_tree)}while(0!=--_);else 0!==r?(r!==i&&(x(t,r,t.bl_tree),_--),x(t,16,t.bl_tree),z(t,_-3,2)):_<=10?(x(t,17,t.bl_tree),z(t,_-3,3)):(x(t,18,t.bl_tree),z(t,_-11,7));_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4)}},N=!1,O=function(t,e,a,n){z(t,0+(n?1:0),3),function(t,e,a,n){U(t),n&&(k(t,a),k(t,~a)),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a,!0)},D=function(t,e,n,r){var i,s,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,n=4093624447;for(e=0;e<=31;e++,n>>>=1)if(1&n&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<a;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),F(t,t.l_desc),F(t,t.d_desc),_=function(t){var e;for(T(t,t.dyn_ltree,t.l_desc.max_code),T(t,t.dyn_dtree,t.d_desc.max_code),F(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*l[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),i=t.opt_len+3+7>>>3,(s=t.static_len+3+7>>>3)<=i&&(i=s)):i=s=n+5,n+4<=i&&-1!==e?O(t,e,n,r):4===t.strategy||s===i?(z(t,2+(r?1:0),3),L(t,o,d)):(z(t,4+(r?1:0),3),function(t,e,a,n){var r;for(z(t,e-257,5),z(t,a-1,5),z(t,n-4,4),r=0;r<n;r++)z(t,t.bl_tree[2*l[r]+1],3);I(t,t.dyn_ltree,e-1),I(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),L(t,t.dyn_ltree,t.dyn_dtree)),Z(t),r&&U(t)},B={_tr_init:function(t){N||(!function(){var t,e,a,l,m,y=new Array(16);for(a=0,l=0;l<28;l++)for(c[l]=a,t=0;t<1<<s[l];t++)f[a++]=l;for(f[a-1]=l,m=0,l=0;l<16;l++)for(v[l]=m,t=0;t<1<<_[l];t++)u[m++]=l;for(m>>=7;l<r;l++)for(v[l]=m<<7,t=0;t<1<<_[l]-7;t++)u[256+m++]=l;for(e=0;e<=i;e++)y[e]=0;for(t=0;t<=143;)o[2*t+1]=8,t++,y[8]++;for(;t<=255;)o[2*t+1]=9,t++,y[9]++;for(;t<=279;)o[2*t+1]=7,t++,y[7]++;for(;t<=287;)o[2*t+1]=8,t++,y[8]++;for(E(o,287,y),t=0;t<r;t++)d[2*t+1]=5,d[2*t]=A(t,5);p=new b(o,s,257,n,i),g=new b(d,_,0,r,i),w=new b(new Array(0),h,0,19,7)}(),N=!0),t.l_desc=new m(t.dyn_ltree,p),t.d_desc=new m(t.dyn_dtree,g),t.bl_desc=new m(t.bl_tree,w),t.bi_buf=0,t.bi_valid=0,Z(t)},_tr_stored_block:O,_tr_flush_block:D,_tr_tally:function(t,e,n){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&n,t.last_lit++,0===e?t.dyn_ltree[2*n]++:(t.matches++,e--,t.dyn_ltree[2*(f[n]+a+1)]++,t.dyn_dtree[2*y(e)]++),t.last_lit===t.lit_bufsize-1},_tr_align:function(t){z(t,2,3),x(t,256,o),function(t){16===t.bi_valid?(k(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},C=function(t,e,a,n){for(var r=65535&t|0,i=t>>>16&65535|0,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16|0},H=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),M=function(t,e,a,n){var r=H,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},Y={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"},K={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8},P=B._tr_init,j=B._tr_stored_block,G=B._tr_flush_block,X=B._tr_tally,W=B._tr_align,q=K.Z_NO_FLUSH,J=K.Z_PARTIAL_FLUSH,Q=K.Z_FULL_FLUSH,V=K.Z_FINISH,$=K.Z_BLOCK,tt=K.Z_OK,et=K.Z_STREAM_END,at=K.Z_STREAM_ERROR,nt=K.Z_DATA_ERROR,rt=K.Z_BUF_ERROR,it=K.Z_DEFAULT_COMPRESSION,st=K.Z_FILTERED,_t=K.Z_HUFFMAN_ONLY,ht=K.Z_RLE,lt=K.Z_FIXED,ot=K.Z_DEFAULT_STRATEGY,dt=K.Z_UNKNOWN,ut=K.Z_DEFLATED,ft=258,ct=262,pt=103,gt=113,wt=666,vt=function(t,e){return t.msg=Y[e],e},bt=function(t){return(t<<1)-(t>4?9:0)},mt=function(t){for(var e=t.length;--e>=0;)t[e]=0},yt=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},kt=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},zt=function(t,e){G(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,kt(t.strm)},xt=function(t,e){t.pending_buf[t.pending++]=e},At=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},Et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,_=t.nice_match,h=t.strstart>t.w_size-ct?t.strstart-(t.w_size-ct):0,l=t.window,o=t.w_mask,d=t.prev,u=t.strstart+ft,f=l[i+s-1],c=l[i+s];t.prev_length>=t.good_match&&(r>>=2),_>t.lookahead&&(_=t.lookahead);do{if(l[(a=e)+s]===c&&l[a+s-1]===f&&l[a]===l[i]&&l[++a]===l[i+1]){i+=2,a++;do{}while(l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&i<u);if(n=ft-(u-i),i=u-ft,n>s){if(t.match_start=e,s=n,n>=_)break;f=l[i+s-1],c=l[i+s]}}}while((e=d[e&o])>h&&0!=--r);return s<=t.lookahead?s:t.lookahead},Zt=function(t){var e,a,n,r,i,s,_,h,l,o,d=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=d+(d-ct)){t.window.set(t.window.subarray(d,d+d),0),t.match_start-=d,t.strstart-=d,t.block_start-=d,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=d?n-d:0}while(--a);e=a=d;do{n=t.prev[--e],t.prev[e]=n>=d?n-d:0}while(--a);r+=d}if(0===t.strm.avail_in)break;if(s=t.strm,_=t.window,h=t.strstart+t.lookahead,l=r,o=void 0,(o=s.avail_in)>l&&(o=l),a=0===o?0:(s.avail_in-=o,_.set(s.input.subarray(s.next_in,s.next_in+o),h),1===s.state.wrap?s.adler=C(s.adler,_,o,h):2===s.state.wrap&&(s.adler=M(s.adler,_,o,h)),s.next_in+=o,s.total_in+=o,o),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=yt(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=yt(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<ct&&0!==t.strm.avail_in)},Ut=function(t,e){for(var a,n;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a)),t.match_length>=3)if(n=X(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=yt(t,t.ins_h,t.window[t.strstart+1]);else n=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2},St=function(t,e){for(var a,n,r;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a),t.match_length<=5&&(t.strategy===st||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=X(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(zt(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=X(t,0,t.window[t.strstart-1]))&&zt(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=X(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2};function Rt(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var Lt=[new Rt(0,0,0,0,(function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(Zt(t),0===t.lookahead&&e===q)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,zt(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-ct&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(zt(t,!1),t.strm.avail_out),1)})),new Rt(4,4,8,4,Ut),new Rt(4,5,16,8,Ut),new Rt(4,6,32,32,Ut),new Rt(4,4,16,16,St),new Rt(8,16,32,32,St),new Rt(8,16,128,128,St),new Rt(8,32,128,256,St),new Rt(32,128,258,1024,St),new Rt(32,258,258,4096,St)];function Ft(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ut,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),mt(this.dyn_ltree),mt(this.dyn_dtree),mt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),mt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),mt(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}var Tt=function(t){if(!t||!t.state)return vt(t,at);t.total_in=t.total_out=0,t.data_type=dt;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:gt,t.adler=2===e.wrap?0:1,e.last_flush=q,P(e),tt},It=function(t){var e,a=Tt(t);return a===tt&&((e=t.state).window_size=2*e.w_size,mt(e.head),e.max_lazy_match=Lt[e.level].max_lazy,e.good_match=Lt[e.level].good_length,e.nice_match=Lt[e.level].nice_length,e.max_chain_length=Lt[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),a},Nt=function(t,e,a,n,r,i){if(!t)return at;var s=1;if(e===it&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||a!==ut||n<8||n>15||e<0||e>9||i<0||i>lt)return vt(t,at);8===n&&(n=9);var _=new Ft;return t.state=_,_.strm=t,_.wrap=s,_.gzhead=null,_.w_bits=n,_.w_size=1<<_.w_bits,_.w_mask=_.w_size-1,_.hash_bits=r+7,_.hash_size=1<<_.hash_bits,_.hash_mask=_.hash_size-1,_.hash_shift=~~((_.hash_bits+3-1)/3),_.window=new Uint8Array(2*_.w_size),_.head=new Uint16Array(_.hash_size),_.prev=new Uint16Array(_.w_size),_.lit_bufsize=1<<r+6,_.pending_buf_size=4*_.lit_bufsize,_.pending_buf=new Uint8Array(_.pending_buf_size),_.d_buf=1*_.lit_bufsize,_.l_buf=3*_.lit_bufsize,_.level=e,_.strategy=i,_.method=a,It(t)},Ot={deflateInit:function(t,e){return Nt(t,e,ut,15,8,ot)},deflateInit2:Nt,deflateReset:It,deflateResetKeep:Tt,deflateSetHeader:function(t,e){return t&&t.state?2!==t.state.wrap?at:(t.state.gzhead=e,tt):at},deflate:function(t,e){var a,n;if(!t||!t.state||e>$||e<0)return t?vt(t,at):at;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===wt&&e!==V)return vt(t,0===t.avail_out?rt:at);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,xt(r,31),xt(r,139),xt(r,8),r.gzhead?(xt(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),xt(r,255&r.gzhead.time),xt(r,r.gzhead.time>>8&255),xt(r,r.gzhead.time>>16&255),xt(r,r.gzhead.time>>24&255),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(xt(r,255&r.gzhead.extra.length),xt(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=M(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,3),r.status=gt);else{var s=ut+(r.w_bits-8<<4)<<8;s|=(r.strategy>=_t||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(s|=32),s+=31-s%31,r.status=gt,At(r,s),0!==r.strstart&&(At(r,t.adler>>>16),At(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending!==r.pending_buf_size));)xt(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=pt)}else r.status=pt;if(r.status===pt&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&kt(t),r.pending+2<=r.pending_buf_size&&(xt(r,255&t.adler),xt(r,t.adler>>8&255),t.adler=0,r.status=gt)):r.status=gt),0!==r.pending){if(kt(t),0===t.avail_out)return r.last_flush=-1,tt}else if(0===t.avail_in&&bt(e)<=bt(i)&&e!==V)return vt(t,rt);if(r.status===wt&&0!==t.avail_in)return vt(t,rt);if(0!==t.avail_in||0!==r.lookahead||e!==q&&r.status!==wt){var _=r.strategy===_t?function(t,e){for(var a;;){if(0===t.lookahead&&(Zt(t),0===t.lookahead)){if(e===q)return 1;break}if(t.match_length=0,a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):r.strategy===ht?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=ft){if(Zt(t),t.lookahead<=ft&&e===q)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+ft;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=ft-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=X(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):Lt[r.level].func(r,e);if(3!==_&&4!==_||(r.status=wt),1===_||3===_)return 0===t.avail_out&&(r.last_flush=-1),tt;if(2===_&&(e===J?W(r):e!==$&&(j(r,0,0,!1),e===Q&&(mt(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),kt(t),0===t.avail_out))return r.last_flush=-1,tt}return e!==V?tt:r.wrap<=0?et:(2===r.wrap?(xt(r,255&t.adler),xt(r,t.adler>>8&255),xt(r,t.adler>>16&255),xt(r,t.adler>>24&255),xt(r,255&t.total_in),xt(r,t.total_in>>8&255),xt(r,t.total_in>>16&255),xt(r,t.total_in>>24&255)):(At(r,t.adler>>>16),At(r,65535&t.adler)),kt(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?tt:et)},deflateEnd:function(t){if(!t||!t.state)return at;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==pt&&e!==gt&&e!==wt?vt(t,at):(t.state=null,e===gt?vt(t,nt):tt)},deflateSetDictionary:function(t,e){var a=e.length;if(!t||!t.state)return at;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return at;if(1===r&&(t.adler=C(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(mt(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,_=t.next_in,h=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,Zt(n);n.lookahead>=3;){var l=n.strstart,o=n.lookahead-2;do{n.ins_h=yt(n,n.ins_h,n.window[l+3-1]),n.prev[l&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=l,l++}while(--o);n.strstart=l,n.lookahead=2,Zt(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=_,t.input=h,t.avail_in=s,n.wrap=r,tt},deflateInfo:"pako deflate (from Nodeca project)"};for(var Dt=new Uint8Array(256),Bt=0;Bt<256;Bt++)Dt[Bt]=Bt>=252?6:Bt>=248?5:Bt>=240?4:Bt>=224?3:Bt>=192?2:1;Dt[254]=Dt[254]=1;var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0},Ht=Object.prototype.toString,Mt=K.Z_NO_FLUSH,Yt=K.Z_SYNC_FLUSH,Kt=K.Z_FULL_FLUSH,Pt=K.Z_FINISH,jt=K.Z_OK,Gt=K.Z_STREAM_END,Xt=K.Z_DEFAULT_COMPRESSION,Wt=K.Z_DEFAULT_STRATEGY,qt=K.Z_DEFLATED;function Jt(){this.options={level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;var e=Ot.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(e!==jt)throw new Error(Y[e]);if(t.header&&Ot.deflateSetHeader(this.strm,t.header),t.dictionary){var a;if(a="[object ArrayBuffer]"===Ht.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(e=Ot.deflateSetDictionary(this.strm,a))!==jt)throw new Error(Y[e]);this._dict_set=!0}}function Qt(t,e,a){try{t.postMessage({type:"errored",error:e,streamId:a})}catch(n){t.postMessage({type:"errored",error:String(e),streamId:a})}}function Vt(t){var e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}Jt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?Pt:Mt,"[object ArrayBuffer]"===Ht.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(n===Yt||n===Kt)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if((a=Ot.deflate(r,n))===Gt)return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=Ot.deflateEnd(this.strm),this.onEnd(a),this.ended=!0,a===jt;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===jt&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,_=t.length;i<_;i++){var h=t[i];r.set(h,s),s+=h.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e){void 0===e&&(e=self);try{var a=new Map;e.addEventListener("message",(function(n){try{var r=function(e,a){switch(a.action){case"init":return{type:"initialized",version:"5.15.0"};case"write":var n=e.get(a.streamId);n||(n=new Jt,e.set(a.streamId,n));var r=n.chunks.length,i=function(t){if("function"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);var e,a,n,r,i,s=t.length,_=0;for(r=0;r<s;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),_+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(_),i=0,r=0;i<_;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,K.Z_SYNC_FLUSH),{type:"wrote",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:Vt(n),additionalBytesCount:i.length};case"reset":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){Qt(e,t,n.data&&"streamId"in n.data?n.data.streamId:void 0)}}))}catch(t){Qt(e,t)}}()}();'
    ])));
}
var $b455450598273b03$var$state = {
    status: 0 /* DeflateWorkerStatus.Nil */ 
};
function $b455450598273b03$export$8ad05986c983585a(configuration, source, onInitializationFailure, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) createDeflateWorkerImpl = $b455450598273b03$var$createDeflateWorker;
    if ($b455450598273b03$var$state.status === 0 /* DeflateWorkerStatus.Nil */ ) // doStartDeflateWorker updates the state to "loading" or "error"
    $b455450598273b03$export$ae2ae5e796988f9a(configuration, source, createDeflateWorkerImpl);
    switch($b455450598273b03$var$state.status){
        case 1 /* DeflateWorkerStatus.Loading */ :
            $b455450598273b03$var$state.initializationFailureCallbacks.push(onInitializationFailure);
            return $b455450598273b03$var$state.worker;
        case 3 /* DeflateWorkerStatus.Initialized */ :
            return $b455450598273b03$var$state.worker;
    }
}
function $b455450598273b03$export$1c93a34ce7f0a4fd() {
    if ($b455450598273b03$var$state.status === 3 /* DeflateWorkerStatus.Initialized */  || $b455450598273b03$var$state.status === 1 /* DeflateWorkerStatus.Loading */ ) $b455450598273b03$var$state.stop();
    $b455450598273b03$var$state = {
        status: 0 /* DeflateWorkerStatus.Nil */ 
    };
}
function $b455450598273b03$export$c2a4b833556ae71() {
    return $b455450598273b03$var$state.status;
}
function $b455450598273b03$export$ae2ae5e796988f9a(configuration, source, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) createDeflateWorkerImpl = $b455450598273b03$var$createDeflateWorker;
    try {
        var worker = createDeflateWorkerImpl(configuration);
        var removeErrorListener_1 = (0, $hXhfS.addEventListener)(configuration, worker, "error", function(error) {
            $b455450598273b03$var$onError(configuration, source, error);
        }).stop;
        var removeMessageListener_1 = (0, $hXhfS.addEventListener)(configuration, worker, "message", function(_a) {
            var data = _a.data;
            if (data.type === "errored") $b455450598273b03$var$onError(configuration, source, data.error, data.streamId);
            else if (data.type === "initialized") $b455450598273b03$var$onInitialized(data.version);
        }).stop;
        worker.postMessage({
            action: "init"
        });
        (0, $d97UU.setTimeout)(function() {
            return $b455450598273b03$var$onTimeout(source);
        }, $b455450598273b03$export$da9b966004898f5b);
        var stop_1 = function() {
            removeErrorListener_1();
            removeMessageListener_1();
        };
        $b455450598273b03$var$state = {
            status: 1 /* DeflateWorkerStatus.Loading */ ,
            worker: worker,
            stop: stop_1,
            initializationFailureCallbacks: []
        };
    } catch (error) {
        $b455450598273b03$var$onError(configuration, source, error);
    }
}
function $b455450598273b03$var$onTimeout(source) {
    if ($b455450598273b03$var$state.status === 1 /* DeflateWorkerStatus.Loading */ ) {
        (0, $5IDGB.display).error("".concat(source, " failed to start: a timeout occurred while initializing the Worker"));
        $b455450598273b03$var$state.initializationFailureCallbacks.forEach(function(callback) {
            return callback();
        });
        $b455450598273b03$var$state = {
            status: 2 /* DeflateWorkerStatus.Error */ 
        };
    }
}
function $b455450598273b03$var$onInitialized(version) {
    if ($b455450598273b03$var$state.status === 1 /* DeflateWorkerStatus.Loading */ ) $b455450598273b03$var$state = {
        status: 3 /* DeflateWorkerStatus.Initialized */ ,
        worker: $b455450598273b03$var$state.worker,
        stop: $b455450598273b03$var$state.stop,
        version: version
    };
}
function $b455450598273b03$var$onError(configuration, source, error, streamId) {
    if ($b455450598273b03$var$state.status === 1 /* DeflateWorkerStatus.Loading */  || $b455450598273b03$var$state.status === 0 /* DeflateWorkerStatus.Nil */ ) {
        (0, $5IDGB.display).error("".concat(source, " failed to start: an error occurred while creating the Worker:"), error);
        if (error instanceof Event || error instanceof Error && $b455450598273b03$var$isMessageCspRelated(error.message)) {
            var baseMessage = void 0;
            if (configuration.workerUrl) baseMessage = "Please make sure the Worker URL ".concat(configuration.workerUrl, " is correct and CSP is correctly configured.");
            else baseMessage = "Please make sure CSP is correctly configured.";
            (0, $5IDGB.display).error("".concat(baseMessage, " See documentation at https://docs.datadoghq.com/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay"));
        } else (0, $fhNdh.addTelemetryError)(error);
        if ($b455450598273b03$var$state.status === 1 /* DeflateWorkerStatus.Loading */ ) $b455450598273b03$var$state.initializationFailureCallbacks.forEach(function(callback) {
            return callback();
        });
        $b455450598273b03$var$state = {
            status: 2 /* DeflateWorkerStatus.Error */ 
        };
    } else (0, $fhNdh.addTelemetryError)(error, {
        worker_version: $b455450598273b03$var$state.status === 3 /* DeflateWorkerStatus.Initialized */  && $b455450598273b03$var$state.version,
        stream_id: streamId
    });
}
function $b455450598273b03$var$isMessageCspRelated(message) {
    return (0, $fkj4Q.includes)(message, "Content Security Policy") || // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
    (0, $fkj4Q.includes)(message, "requires 'TrustedScriptURL'");
}

});




parcelRegister("319l6", function(module, exports) {

$parcel$export(module.exports, "datadogLogs", () => $2328b5add783e02a$export$64696fc4da45d740);

var $ewVF5 = parcelRequire("ewVF5");
var $7ZD4v = parcelRequire("7ZD4v");

var $6ucbP = parcelRequire("6ucbP");

var $22u1E = parcelRequire("22u1E");

var $hVbxe = parcelRequire("hVbxe");
var $2328b5add783e02a$export$64696fc4da45d740 = (0, $6ucbP.makeLogsPublicApi)((0, $22u1E.startLogs));
(0, $ewVF5.defineGlobal)((0, $7ZD4v.getGlobalObject)(), "DD_LOGS", $2328b5add783e02a$export$64696fc4da45d740);

});
parcelRegister("6ucbP", function(module, exports) {

$parcel$export(module.exports, "makeLogsPublicApi", () => $4b8f0012af858341$export$39525f74d82d4cd7);

var $fkj4Q = parcelRequire("fkj4Q");
var $h7dlA = parcelRequire("h7dlA");
var $el7hs = parcelRequire("el7hs");
var $96vba = parcelRequire("96vba");
var $95XVG = parcelRequire("95XVG");
var $j9iCm = parcelRequire("j9iCm");
var $gurxr = parcelRequire("gurxr");
var $ewVF5 = parcelRequire("ewVF5");
var $2wH3Z = parcelRequire("2wH3Z");
var $1RdIU = parcelRequire("1RdIU");
var $adV8b = parcelRequire("adV8b");

var $hVbxe = parcelRequire("hVbxe");

var $iOUkG = parcelRequire("iOUkG");

var $d5UeM = parcelRequire("d5UeM");
var $4b8f0012af858341$var$LOGS_STORAGE_KEY = "logs";
function $4b8f0012af858341$export$39525f74d82d4cd7(startLogsImpl) {
    var customerDataTrackerManager = (0, $96vba.createCustomerDataTrackerManager)();
    var globalContextManager = (0, $el7hs.createContextManager)(customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */ ));
    var userContextManager = (0, $el7hs.createContextManager)(customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */ ));
    var trackingConsentState = (0, $95XVG.createTrackingConsentState)();
    function getCommonContext() {
        return (0, $iOUkG.buildCommonContext)(globalContextManager, userContextManager);
    }
    var strategy = (0, $d5UeM.createPreStartStrategy)(getCommonContext, trackingConsentState, function(initConfiguration, configuration) {
        if (initConfiguration.storeContextsAcrossPages) {
            (0, $adV8b.storeContextManager)(configuration, globalContextManager, $4b8f0012af858341$var$LOGS_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */ );
            (0, $adV8b.storeContextManager)(configuration, userContextManager, $4b8f0012af858341$var$LOGS_STORAGE_KEY, 1 /* CustomerDataType.User */ );
        }
        var startLogsResult = startLogsImpl(initConfiguration, configuration, getCommonContext, trackingConsentState);
        strategy = $4b8f0012af858341$var$createPostStartStrategy(initConfiguration, startLogsResult);
        return startLogsResult;
    });
    var customLoggers = {};
    var mainLogger = new (0, $hVbxe.Logger)(function() {
        var params = [];
        for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
        return strategy.handleLog.apply(strategy, params);
    }, customerDataTrackerManager.createDetachedTracker());
    return (0, $ewVF5.makePublicApi)({
        logger: mainLogger,
        init: (0, $2wH3Z.monitor)(function(initConfiguration) {
            return strategy.init(initConfiguration);
        }),
        /**
         * Set the tracking consent of the current user.
         *
         * @param {"granted" | "not-granted"} trackingConsent The user tracking consent
         *
         * Logs will be sent only if it is set to "granted". This value won't be stored by the library
         * across page loads: you will need to call this method or set the appropriate `trackingConsent`
         * field in the init() method at each page load.
         *
         * If this method is called before the init() method, the provided value will take precedence
         * over the one provided as initialization parameter.
         */ setTrackingConsent: (0, $2wH3Z.monitor)(function(trackingConsent) {
            return trackingConsentState.update(trackingConsent);
        }),
        getGlobalContext: (0, $2wH3Z.monitor)(function() {
            return globalContextManager.getContext();
        }),
        setGlobalContext: (0, $2wH3Z.monitor)(function(context) {
            return globalContextManager.setContext(context);
        }),
        setGlobalContextProperty: (0, $2wH3Z.monitor)(function(key, value) {
            return globalContextManager.setContextProperty(key, value);
        }),
        removeGlobalContextProperty: (0, $2wH3Z.monitor)(function(key) {
            return globalContextManager.removeContextProperty(key);
        }),
        clearGlobalContext: (0, $2wH3Z.monitor)(function() {
            return globalContextManager.clearContext();
        }),
        createLogger: (0, $2wH3Z.monitor)(function(name, conf) {
            if (conf === void 0) conf = {};
            customLoggers[name] = new (0, $hVbxe.Logger)(function() {
                var params = [];
                for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
                return strategy.handleLog.apply(strategy, params);
            }, customerDataTrackerManager.createDetachedTracker(), (0, $1RdIU.sanitize)(name), conf.handler, conf.level, (0, $1RdIU.sanitize)(conf.context));
            return customLoggers[name];
        }),
        getLogger: (0, $2wH3Z.monitor)(function(name) {
            return customLoggers[name];
        }),
        getInitConfiguration: (0, $2wH3Z.monitor)(function() {
            return (0, $j9iCm.deepClone)(strategy.initConfiguration);
        }),
        getInternalContext: (0, $2wH3Z.monitor)(function(startTime) {
            return strategy.getInternalContext(startTime);
        }),
        setUser: (0, $2wH3Z.monitor)(function(newUser) {
            if ((0, $h7dlA.checkUser)(newUser)) userContextManager.setContext((0, $h7dlA.sanitizeUser)(newUser));
        }),
        getUser: (0, $2wH3Z.monitor)(function() {
            return userContextManager.getContext();
        }),
        setUserProperty: (0, $2wH3Z.monitor)(function(key, property) {
            var _a;
            var sanitizedProperty = (0, $h7dlA.sanitizeUser)((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: (0, $2wH3Z.monitor)(function(key) {
            return userContextManager.removeContextProperty(key);
        }),
        clearUser: (0, $2wH3Z.monitor)(function() {
            return userContextManager.clearContext();
        })
    });
}
function $4b8f0012af858341$var$createPostStartStrategy(initConfiguration, startLogsResult) {
    return (0, $fkj4Q.assign)({
        init: function(initConfiguration) {
            (0, $gurxr.displayAlreadyInitializedError)("DD_LOGS", initConfiguration);
        },
        initConfiguration: initConfiguration
    }, startLogsResult);
}

});
parcelRegister("hVbxe", function(module, exports) {

$parcel$export(module.exports, "StatusType", () => $d0c0b52a4da92eb4$export$e35c1996c6f482ad);
$parcel$export(module.exports, "HandlerType", () => $d0c0b52a4da92eb4$export$533bc3391342c4f6);
$parcel$export(module.exports, "STATUSES", () => $d0c0b52a4da92eb4$export$b41c0f52c41112e3);
$parcel$export(module.exports, "Logger", () => $d0c0b52a4da92eb4$export$efa9a398d6368992);

var $ly0px = parcelRequire("ly0px");
var $j9iCm = parcelRequire("j9iCm");
var $4Be0w = parcelRequire("4Be0w");
var $iJHw0 = parcelRequire("iJHw0");
var $el7hs = parcelRequire("el7hs");
var $1zKlK = parcelRequire("1zKlK");
var $2wH3Z = parcelRequire("2wH3Z");
var $1RdIU = parcelRequire("1RdIU");
var $d0c0b52a4da92eb4$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d0c0b52a4da92eb4$export$e35c1996c6f482ad = {
    debug: "debug",
    error: "error",
    info: "info",
    warn: "warn"
};
var $d0c0b52a4da92eb4$export$533bc3391342c4f6 = {
    console: "console",
    http: "http",
    silent: "silent"
};
var $d0c0b52a4da92eb4$export$b41c0f52c41112e3 = Object.keys($d0c0b52a4da92eb4$export$e35c1996c6f482ad);
var $d0c0b52a4da92eb4$export$efa9a398d6368992 = /** @class */ function() {
    function Logger(handleLogStrategy, customerDataTracker, name, handlerType, level, loggerContext) {
        if (handlerType === void 0) handlerType = $d0c0b52a4da92eb4$export$533bc3391342c4f6.http;
        if (level === void 0) level = $d0c0b52a4da92eb4$export$e35c1996c6f482ad.debug;
        if (loggerContext === void 0) loggerContext = {};
        this.handleLogStrategy = handleLogStrategy;
        this.handlerType = handlerType;
        this.level = level;
        this.contextManager = (0, $el7hs.createContextManager)(customerDataTracker);
        this.contextManager.setContext(loggerContext);
        if (name) this.contextManager.setContextProperty("logger", {
            name: name
        });
    }
    Logger.prototype.log = function(message, messageContext, status, error) {
        if (status === void 0) status = $d0c0b52a4da92eb4$export$e35c1996c6f482ad.info;
        var errorContext;
        if (error !== undefined && error !== null) {
            var stackTrace = error instanceof Error ? (0, $iJHw0.computeStackTrace)(error) : undefined;
            var rawError = (0, $4Be0w.computeRawError)({
                stackTrace: stackTrace,
                originalError: error,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */ ,
                source: (0, $1zKlK.ErrorSource).LOGGER,
                handling: "handled" /* ErrorHandling.HANDLED */ ,
                startClocks: (0, $ly0px.clocksNow)()
            });
            errorContext = {
                stack: rawError.stack,
                kind: rawError.type,
                message: rawError.message,
                causes: rawError.causes
            };
        }
        var sanitizedMessageContext = (0, $1RdIU.sanitize)(messageContext);
        var context = errorContext ? (0, $j9iCm.combine)({
            error: errorContext
        }, sanitizedMessageContext) : sanitizedMessageContext;
        this.handleLogStrategy({
            message: (0, $1RdIU.sanitize)(message),
            context: context,
            status: status
        }, this);
    };
    Logger.prototype.debug = function(message, messageContext, error) {
        this.log(message, messageContext, $d0c0b52a4da92eb4$export$e35c1996c6f482ad.debug, error);
    };
    Logger.prototype.info = function(message, messageContext, error) {
        this.log(message, messageContext, $d0c0b52a4da92eb4$export$e35c1996c6f482ad.info, error);
    };
    Logger.prototype.warn = function(message, messageContext, error) {
        this.log(message, messageContext, $d0c0b52a4da92eb4$export$e35c1996c6f482ad.warn, error);
    };
    Logger.prototype.error = function(message, messageContext, error) {
        this.log(message, messageContext, $d0c0b52a4da92eb4$export$e35c1996c6f482ad.error, error);
    };
    Logger.prototype.setContext = function(context) {
        this.contextManager.setContext(context);
    };
    Logger.prototype.getContext = function() {
        return this.contextManager.getContext();
    };
    Logger.prototype.setContextProperty = function(key, value) {
        this.contextManager.setContextProperty(key, value);
    };
    Logger.prototype.removeContextProperty = function(key) {
        this.contextManager.removeContextProperty(key);
    };
    Logger.prototype.clearContext = function() {
        this.contextManager.clearContext();
    };
    Logger.prototype.setHandler = function(handler) {
        this.handlerType = handler;
    };
    Logger.prototype.getHandler = function() {
        return this.handlerType;
    };
    Logger.prototype.setLevel = function(level) {
        this.level = level;
    };
    Logger.prototype.getLevel = function() {
        return this.level;
    };
    $d0c0b52a4da92eb4$var$__decorate([
        (0, $2wH3Z.monitored)
    ], Logger.prototype, "log", null);
    return Logger;
}();

});

parcelRegister("iOUkG", function(module, exports) {

$parcel$export(module.exports, "buildCommonContext", () => $db3897fdb576bc57$export$ef57df7b19d2c9ab);
function $db3897fdb576bc57$export$ef57df7b19d2c9ab(globalContextManager, userContextManager) {
    return {
        view: {
            referrer: document.referrer,
            url: window.location.href
        },
        context: globalContextManager.getContext(),
        user: userContextManager.getContext()
    };
}

});

parcelRegister("d5UeM", function(module, exports) {

$parcel$export(module.exports, "createPreStartStrategy", () => $98875d90a6ff917f$export$8f7002373dcc6602);

var $fkj4Q = parcelRequire("fkj4Q");
var $kSv4n = parcelRequire("kSv4n");
var $kFaIT = parcelRequire("kFaIT");
var $5IDGB = parcelRequire("5IDGB");
var $gurxr = parcelRequire("gurxr");
var $aed8w = parcelRequire("aed8w");
var $ly0px = parcelRequire("ly0px");

var $leBZC = parcelRequire("leBZC");
function $98875d90a6ff917f$export$8f7002373dcc6602(getCommonContext, trackingConsentState, doStartLogs) {
    var bufferApiCalls = new (0, $kSv4n.BoundedBuffer)();
    var cachedInitConfiguration;
    var cachedConfiguration;
    var trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartLogs);
    function tryStartLogs() {
        if (!cachedConfiguration || !cachedInitConfiguration || !trackingConsentState.isGranted()) return;
        trackingConsentStateSubscription.unsubscribe();
        var startLogsResult = doStartLogs(cachedInitConfiguration, cachedConfiguration);
        bufferApiCalls.drain(startLogsResult);
    }
    return {
        init: function(initConfiguration) {
            if (!initConfiguration) {
                (0, $5IDGB.display).error("Missing configuration");
                return;
            }
            if ((0, $kFaIT.canUseEventBridge)()) initConfiguration = $98875d90a6ff917f$var$overrideInitConfigurationForBridge(initConfiguration);
            // Expose the initial configuration regardless of initialization success.
            cachedInitConfiguration = initConfiguration;
            if (cachedConfiguration) {
                (0, $gurxr.displayAlreadyInitializedError)("DD_LOGS", initConfiguration);
                return;
            }
            var configuration = (0, $leBZC.validateAndBuildLogsConfiguration)(initConfiguration);
            if (!configuration) return;
            cachedConfiguration = configuration;
            trackingConsentState.tryToInit(configuration.trackingConsent);
            tryStartLogs();
        },
        get initConfiguration () {
            return cachedInitConfiguration;
        },
        getInternalContext: (0, $aed8w.noop),
        handleLog: function(message, statusType, context, date) {
            if (context === void 0) context = getCommonContext();
            if (date === void 0) date = (0, $ly0px.timeStampNow)();
            bufferApiCalls.add(function(startLogsResult) {
                return startLogsResult.handleLog(message, statusType, context, date);
            });
        }
    };
}
function $98875d90a6ff917f$var$overrideInitConfigurationForBridge(initConfiguration) {
    return (0, $fkj4Q.assign)({}, initConfiguration, {
        clientToken: "empty"
    });
}

});
parcelRegister("leBZC", function(module, exports) {

$parcel$export(module.exports, "validateAndBuildLogsConfiguration", () => $f7586062f738c1b4$export$97b29d6675c29e61);
$parcel$export(module.exports, "serializeLogsConfiguration", () => $f7586062f738c1b4$export$3cd09719b205537a);

var $fkj4Q = parcelRequire("fkj4Q");
var $5IDGB = parcelRequire("5IDGB");
var $7S2uk = parcelRequire("7S2uk");
var $3LtP9 = parcelRequire("3LtP9");
var $lHOXU = parcelRequire("lHOXU");
var $7imKH = parcelRequire("7imKH");
var $f7586062f738c1b4$export$22e00ed24ca2e25e = 32 * (0, $7S2uk.ONE_KIBI_BYTE);
function $f7586062f738c1b4$export$97b29d6675c29e61(initConfiguration) {
    if (initConfiguration.usePciIntake === true && initConfiguration.site && initConfiguration.site !== "datadoghq.com") (0, $5IDGB.display).warn("PCI compliance for Logs is only available for Datadog organizations in the US1 site. Default intake will be used.");
    var baseConfiguration = (0, $7imKH.validateAndBuildConfiguration)(initConfiguration);
    var forwardConsoleLogs = $f7586062f738c1b4$export$68e7946e3a1d7eed(initConfiguration.forwardConsoleLogs, (0, $fkj4Q.objectValues)((0, $5IDGB.ConsoleApiName)), "Forward Console Logs");
    var forwardReports = $f7586062f738c1b4$export$68e7946e3a1d7eed(initConfiguration.forwardReports, (0, $fkj4Q.objectValues)((0, $3LtP9.RawReportType)), "Forward Reports");
    if (!baseConfiguration || !forwardConsoleLogs || !forwardReports) return;
    if (initConfiguration.forwardErrorsToLogs && !(0, $fkj4Q.includes)(forwardConsoleLogs, (0, $5IDGB.ConsoleApiName).error)) forwardConsoleLogs.push((0, $5IDGB.ConsoleApiName).error);
    return (0, $fkj4Q.assign)({
        forwardErrorsToLogs: initConfiguration.forwardErrorsToLogs !== false,
        forwardConsoleLogs: forwardConsoleLogs,
        forwardReports: forwardReports,
        requestErrorResponseLengthLimit: $f7586062f738c1b4$export$22e00ed24ca2e25e
    }, baseConfiguration);
}
function $f7586062f738c1b4$export$68e7946e3a1d7eed(option, allowedValues, label) {
    if (option === undefined) return [];
    if (!(option === "all" || Array.isArray(option) && option.every(function(api) {
        return (0, $fkj4Q.includes)(allowedValues, api);
    }))) {
        (0, $5IDGB.display).error("".concat(label, ' should be "all" or an array with allowed values "').concat(allowedValues.join('", "'), '"'));
        return;
    }
    return option === "all" ? allowedValues : (0, $lHOXU.removeDuplicates)(option);
}
function $f7586062f738c1b4$export$3cd09719b205537a(configuration) {
    var baseSerializedInitConfiguration = (0, $7imKH.serializeConfiguration)(configuration);
    return (0, $fkj4Q.assign)({
        forward_errors_to_logs: configuration.forwardErrorsToLogs,
        forward_console_logs: configuration.forwardConsoleLogs,
        forward_reports: configuration.forwardReports,
        use_pci_intake: configuration.usePciIntake
    }, baseSerializedInitConfiguration);
}

});



parcelRegister("22u1E", function(module, exports) {

$parcel$export(module.exports, "startLogs", () => $17c30f29b8ea5739$export$660a5342b09224dc);

var $kFaIT = parcelRequire("kFaIT");
var $1gpLX = parcelRequire("1gpLX");
var $cfGi1 = parcelRequire("cfGi1");
var $eA1KP = parcelRequire("eA1KP");

var $hO7qg = parcelRequire("hO7qg");

var $EGbAq = parcelRequire("EGbAq");

var $fzjZY = parcelRequire("fzjZY");

var $5NDJ0 = parcelRequire("5NDJ0");

var $hJXJf = parcelRequire("hJXJf");

var $bnyWV = parcelRequire("bnyWV");

var $7QcfF = parcelRequire("7QcfF");

var $f7pcn = parcelRequire("f7pcn");

var $gtZEA = parcelRequire("gtZEA");

var $b4X3T = parcelRequire("b4X3T");

var $bOMs4 = parcelRequire("bOMs4");

var $cgp7x = parcelRequire("cgp7x");

var $gsLOR = parcelRequire("gsLOR");
function $17c30f29b8ea5739$export$660a5342b09224dc(initConfiguration, configuration, getCommonContext, // `startLogs` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startLogs` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState) {
    var lifeCycle = new (0, $7QcfF.LifeCycle)();
    var cleanupTasks = [];
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */ , function(log) {
        return (0, $cfGi1.sendToExtension)("logs", log);
    });
    var reportError = (0, $cgp7x.startReportError)(lifeCycle);
    var pageExitObservable = (0, $1gpLX.createPageExitObservable)(configuration);
    var session = configuration.sessionStoreStrategyType && !(0, $kFaIT.canUseEventBridge)() && !(0, $eA1KP.willSyntheticsInjectRum)() ? (0, $hO7qg.startLogsSessionManager)(configuration, trackingConsentState) : (0, $hO7qg.startLogsSessionManagerStub)(configuration);
    var stopLogsTelemetry = (0, $gsLOR.startLogsTelemetry)(initConfiguration, configuration, reportError, pageExitObservable, session).stop;
    cleanupTasks.push(function() {
        return stopLogsTelemetry();
    });
    (0, $hJXJf.startNetworkErrorCollection)(configuration, lifeCycle);
    (0, $bnyWV.startRuntimeErrorCollection)(configuration, lifeCycle);
    (0, $fzjZY.startConsoleCollection)(configuration, lifeCycle);
    (0, $5NDJ0.startReportCollection)(configuration, lifeCycle);
    var handleLog = (0, $f7pcn.startLoggerCollection)(lifeCycle).handleLog;
    (0, $EGbAq.startLogsAssembly)(session, configuration, lifeCycle, getCommonContext, reportError);
    if (!(0, $kFaIT.canUseEventBridge)()) {
        var stopLogsBatch_1 = (0, $gtZEA.startLogsBatch)(configuration, lifeCycle, reportError, pageExitObservable, session).stop;
        cleanupTasks.push(function() {
            return stopLogsBatch_1();
        });
    } else (0, $b4X3T.startLogsBridge)(lifeCycle);
    var internalContext = (0, $bOMs4.startInternalContext)(session);
    return {
        handleLog: handleLog,
        getInternalContext: internalContext.get,
        stop: function() {
            cleanupTasks.forEach(function(task) {
                return task();
            });
        }
    };
}

});
parcelRegister("hO7qg", function(module, exports) {

$parcel$export(module.exports, "startLogsSessionManager", () => $cf6cdd27f8c9885e$export$3f8657259c35672b);
$parcel$export(module.exports, "startLogsSessionManagerStub", () => $cf6cdd27f8c9885e$export$272a61c5dde71b62);

var $4wc1a = parcelRequire("4wc1a");
var $bQmeT = parcelRequire("bQmeT");
var $1q2aX = parcelRequire("1q2aX");
var $cf6cdd27f8c9885e$export$c47fdbea9837fd34 = "logs";
function $cf6cdd27f8c9885e$export$3f8657259c35672b(configuration, trackingConsentState) {
    var sessionManager = (0, $1q2aX.startSessionManager)(configuration, $cf6cdd27f8c9885e$export$c47fdbea9837fd34, function(rawTrackingType) {
        return $cf6cdd27f8c9885e$var$computeSessionState(configuration, rawTrackingType);
    }, trackingConsentState);
    return {
        findTrackedSession: function(startTime) {
            var session = sessionManager.findActiveSession(startTime);
            return session && session.trackingType === "1" /* LoggerTrackingType.TRACKED */  ? {
                id: session.id
            } : undefined;
        },
        expireObservable: sessionManager.expireObservable
    };
}
function $cf6cdd27f8c9885e$export$272a61c5dde71b62(configuration) {
    var isTracked = $cf6cdd27f8c9885e$var$computeTrackingType(configuration) === "1" /* LoggerTrackingType.TRACKED */ ;
    var session = isTracked ? {} : undefined;
    return {
        findTrackedSession: function() {
            return session;
        },
        expireObservable: new (0, $4wc1a.Observable)()
    };
}
function $cf6cdd27f8c9885e$var$computeTrackingType(configuration) {
    if (!(0, $bQmeT.performDraw)(configuration.sessionSampleRate)) return "0" /* LoggerTrackingType.NOT_TRACKED */ ;
    return "1" /* LoggerTrackingType.TRACKED */ ;
}
function $cf6cdd27f8c9885e$var$computeSessionState(configuration, rawSessionType) {
    var trackingType = $cf6cdd27f8c9885e$var$hasValidLoggerSession(rawSessionType) ? rawSessionType : $cf6cdd27f8c9885e$var$computeTrackingType(configuration);
    return {
        trackingType: trackingType,
        isTracked: trackingType === "1" /* LoggerTrackingType.TRACKED */ 
    };
}
function $cf6cdd27f8c9885e$var$hasValidLoggerSession(trackingType) {
    return trackingType === "0" /* LoggerTrackingType.NOT_TRACKED */  || trackingType === "1" /* LoggerTrackingType.TRACKED */ ;
}

});

parcelRegister("EGbAq", function(module, exports) {

$parcel$export(module.exports, "startLogsAssembly", () => $07a475c731d965b6$export$627391049aa7b21e);

var $j9iCm = parcelRequire("j9iCm");
var $axXk6 = parcelRequire("axXk6");
var $1zKlK = parcelRequire("1zKlK");
var $ly0px = parcelRequire("ly0px");
var $8PiRA = parcelRequire("8PiRA");

var $hVbxe = parcelRequire("hVbxe");

var $j6Koz = parcelRequire("j6Koz");
function $07a475c731d965b6$export$627391049aa7b21e(sessionManager, configuration, lifeCycle, getCommonContext, reportError) {
    var statusWithCustom = (0, $hVbxe.STATUSES).concat([
        "custom"
    ]);
    var logRateLimiters = {};
    statusWithCustom.forEach(function(status) {
        logRateLimiters[status] = (0, $axXk6.createEventRateLimiter)(status, configuration.eventRateLimiterThreshold, reportError);
    });
    lifeCycle.subscribe(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , function(_a) {
        var _b, _c;
        var rawLogsEvent = _a.rawLogsEvent, _d = _a.messageContext, messageContext = _d === void 0 ? undefined : _d, _e = _a.savedCommonContext, savedCommonContext = _e === void 0 ? undefined : _e, domainContext = _a.domainContext;
        var startTime = (0, $ly0px.getRelativeTime)(rawLogsEvent.date);
        var session = sessionManager.findTrackedSession(startTime);
        if (!session) return;
        var commonContext = savedCommonContext || getCommonContext();
        var log = (0, $j9iCm.combine)({
            service: configuration.service,
            session_id: session.id,
            // Insert user first to allow overrides from global context
            usr: !(0, $8PiRA.isEmptyObject)(commonContext.user) ? commonContext.user : undefined,
            view: commonContext.view
        }, commonContext.context, (0, $j6Koz.getRUMInternalContext)(startTime), rawLogsEvent, messageContext);
        if (((_b = configuration.beforeSend) === null || _b === void 0 ? void 0 : _b.call(configuration, log, domainContext)) === false || log.origin !== (0, $1zKlK.ErrorSource).AGENT && ((_c = logRateLimiters[log.status]) !== null && _c !== void 0 ? _c : logRateLimiters["custom"]).isLimitReached()) return;
        lifeCycle.notify(1 /* LifeCycleEventType.LOG_COLLECTED */ , log);
    });
}

});
parcelRegister("j6Koz", function(module, exports) {

$parcel$export(module.exports, "getRUMInternalContext", () => $de9291009dc78894$export$e2386d255c9a7886);

var $fhNdh = parcelRequire("fhNdh");
var $eA1KP = parcelRequire("eA1KP");
var $de9291009dc78894$var$logsSentBeforeRumInjectionTelemetryAdded = false;
function $de9291009dc78894$export$e2386d255c9a7886(startTime) {
    var browserWindow = window;
    if ((0, $eA1KP.willSyntheticsInjectRum)()) {
        var context = getInternalContextFromRumGlobal(browserWindow.DD_RUM_SYNTHETICS);
        if (!context && !$de9291009dc78894$var$logsSentBeforeRumInjectionTelemetryAdded) {
            $de9291009dc78894$var$logsSentBeforeRumInjectionTelemetryAdded = true;
            (0, $fhNdh.addTelemetryDebug)("Logs sent before RUM is injected by the synthetics worker", {
                testId: (0, $eA1KP.getSyntheticsTestId)(),
                resultId: (0, $eA1KP.getSyntheticsResultId)()
            });
        }
        return context;
    }
    return getInternalContextFromRumGlobal(browserWindow.DD_RUM);
    function getInternalContextFromRumGlobal(rumGlobal) {
        if (rumGlobal && rumGlobal.getInternalContext) return rumGlobal.getInternalContext(startTime);
    }
}
function $de9291009dc78894$export$9b06af1b36b3cd98() {
    $de9291009dc78894$var$logsSentBeforeRumInjectionTelemetryAdded = false;
}

});


parcelRegister("fzjZY", function(module, exports) {

$parcel$export(module.exports, "startConsoleCollection", () => $b559a32e85b74c64$export$601e91d68ece5c12);

var $5IDGB = parcelRequire("5IDGB");
var $1zKlK = parcelRequire("1zKlK");
var $crBqg = parcelRequire("crBqg");
var $ly0px = parcelRequire("ly0px");

var $hVbxe = parcelRequire("hVbxe");
var $b559a32e85b74c64$var$_a;
var $b559a32e85b74c64$export$aed7c9a1c59f7d58 = ($b559a32e85b74c64$var$_a = {}, $b559a32e85b74c64$var$_a[(0, $5IDGB.ConsoleApiName).log] = (0, $hVbxe.StatusType).info, $b559a32e85b74c64$var$_a[(0, $5IDGB.ConsoleApiName).debug] = (0, $hVbxe.StatusType).debug, $b559a32e85b74c64$var$_a[(0, $5IDGB.ConsoleApiName).info] = (0, $hVbxe.StatusType).info, $b559a32e85b74c64$var$_a[(0, $5IDGB.ConsoleApiName).warn] = (0, $hVbxe.StatusType).warn, $b559a32e85b74c64$var$_a[(0, $5IDGB.ConsoleApiName).error] = (0, $hVbxe.StatusType).error, $b559a32e85b74c64$var$_a);
function $b559a32e85b74c64$export$601e91d68ece5c12(configuration, lifeCycle) {
    var consoleSubscription = (0, $crBqg.initConsoleObservable)(configuration.forwardConsoleLogs).subscribe(function(log) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , {
            rawLogsEvent: {
                date: (0, $ly0px.timeStampNow)(),
                message: log.message,
                origin: (0, $1zKlK.ErrorSource).CONSOLE,
                error: log.api === (0, $5IDGB.ConsoleApiName).error ? {
                    stack: log.stack,
                    fingerprint: log.fingerprint,
                    causes: log.causes
                } : undefined,
                status: $b559a32e85b74c64$export$aed7c9a1c59f7d58[log.api]
            }
        });
    });
    return {
        stop: function() {
            consoleSubscription.unsubscribe();
        }
    };
}

});

parcelRegister("5NDJ0", function(module, exports) {

$parcel$export(module.exports, "startReportCollection", () => $439057e2cef6be3e$export$764db0aca1d0911);

var $1zKlK = parcelRequire("1zKlK");
var $4Be0w = parcelRequire("4Be0w");
var $3LtP9 = parcelRequire("3LtP9");
var $ly0px = parcelRequire("ly0px");

var $hVbxe = parcelRequire("hVbxe");
var $439057e2cef6be3e$var$_a;
var $439057e2cef6be3e$var$LogStatusForReport = ($439057e2cef6be3e$var$_a = {}, $439057e2cef6be3e$var$_a[(0, $3LtP9.RawReportType).cspViolation] = (0, $hVbxe.StatusType).error, $439057e2cef6be3e$var$_a[(0, $3LtP9.RawReportType).intervention] = (0, $hVbxe.StatusType).error, $439057e2cef6be3e$var$_a[(0, $3LtP9.RawReportType).deprecation] = (0, $hVbxe.StatusType).warn, $439057e2cef6be3e$var$_a);
function $439057e2cef6be3e$export$764db0aca1d0911(configuration, lifeCycle) {
    var reportSubscription = (0, $3LtP9.initReportObservable)(configuration, configuration.forwardReports).subscribe(function(report) {
        var message = report.message;
        var status = $439057e2cef6be3e$var$LogStatusForReport[report.type];
        var error;
        if (status === (0, $hVbxe.StatusType).error) error = {
            kind: report.subtype,
            stack: report.stack
        };
        else if (report.stack) message += " Found in ".concat((0, $4Be0w.getFileFromStackTraceString)(report.stack));
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , {
            rawLogsEvent: {
                date: (0, $ly0px.timeStampNow)(),
                message: message,
                origin: (0, $1zKlK.ErrorSource).REPORT,
                error: error,
                status: status
            }
        });
    });
    return {
        stop: function() {
            reportSubscription.unsubscribe();
        }
    };
}

});

parcelRegister("hJXJf", function(module, exports) {

$parcel$export(module.exports, "startNetworkErrorCollection", () => $cea4f88979234f28$export$d0c7c81096ec95e);

var $iJHw0 = parcelRequire("iJHw0");
var $1zKlK = parcelRequire("1zKlK");
var $lEdKn = parcelRequire("lEdKn");
var $dX7m0 = parcelRequire("dX7m0");
var $8yLbx = parcelRequire("8yLbx");
var $2wH3Z = parcelRequire("2wH3Z");
var $aed8w = parcelRequire("aed8w");
var $4igFP = parcelRequire("4igFP");
var $4Be0w = parcelRequire("4Be0w");

var $hVbxe = parcelRequire("hVbxe");
function $cea4f88979234f28$export$d0c7c81096ec95e(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) return {
        stop: (0, $aed8w.noop)
    };
    var xhrSubscription = (0, $dX7m0.initXhrObservable)(configuration).subscribe(function(context) {
        if (context.state === "complete") handleResponse("xhr" /* RequestType.XHR */ , context);
    });
    var fetchSubscription = (0, $lEdKn.initFetchObservable)().subscribe(function(context) {
        if (context.state === "resolve") handleResponse("fetch" /* RequestType.FETCH */ , context);
    });
    function handleResponse(type, request) {
        if (!configuration.isIntakeUrl(request.url) && ($cea4f88979234f28$var$isRejected(request) || (0, $8yLbx.isServerError)(request.status))) {
            if ("xhr" in request) $cea4f88979234f28$export$f2e44bf057d87410(request.xhr, configuration, onResponseDataAvailable);
            else if (request.response) $cea4f88979234f28$export$10a388a857793df5(request.response, configuration, onResponseDataAvailable);
            else if (request.error) $cea4f88979234f28$export$4dbd4776a6c225a(request.error, configuration, onResponseDataAvailable);
        }
        function onResponseDataAvailable(responseData) {
            var domainContext = {
                isAborted: request.isAborted
            };
            lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , {
                rawLogsEvent: {
                    message: "".concat($cea4f88979234f28$var$format(type), " error ").concat(request.method, " ").concat(request.url),
                    date: request.startClocks.timeStamp,
                    error: {
                        stack: responseData || "Failed to load"
                    },
                    http: {
                        method: request.method,
                        status_code: request.status,
                        url: request.url
                    },
                    status: (0, $hVbxe.StatusType).error,
                    origin: (0, $1zKlK.ErrorSource).NETWORK
                },
                domainContext: domainContext
            });
        }
    }
    return {
        stop: function() {
            xhrSubscription.unsubscribe();
            fetchSubscription.unsubscribe();
        }
    };
}
function $cea4f88979234f28$export$f2e44bf057d87410(xhr, configuration, callback) {
    if (typeof xhr.response === "string") callback($cea4f88979234f28$var$truncateResponseText(xhr.response, configuration));
    else callback(xhr.response);
}
function $cea4f88979234f28$export$4dbd4776a6c225a(error, configuration, callback) {
    callback($cea4f88979234f28$var$truncateResponseText((0, $4Be0w.toStackTraceString)((0, $iJHw0.computeStackTrace)(error)), configuration));
}
function $cea4f88979234f28$export$10a388a857793df5(response, configuration, callback) {
    var clonedResponse = (0, $8yLbx.tryToClone)(response);
    if (!clonedResponse || !clonedResponse.body) // if the clone failed or if the body is null, let's not try to read it.
    callback();
    else if (!window.TextDecoder) // If the browser doesn't support TextDecoder, let's read the whole response then truncate it.
    //
    // This should only be the case on early versions of Edge (before they migrated to Chromium).
    // Even if it could be possible to implement a workaround for the missing TextDecoder API (using
    // a Blob and FileReader), we found another issue preventing us from reading only the first
    // bytes from the response: contrary to other browsers, when reading from the cloned response,
    // if the original response gets canceled, the cloned response is also canceled and we can't
    // know about it.  In the following illustration, the promise returned by `reader.read()` may
    // never be fulfilled:
    //
    // fetch('/').then((response) => {
    //   const reader = response.clone().body.getReader()
    //   readMore()
    //   function readMore() {
    //     reader.read().then(
    //       (result) => {
    //         if (result.done) {
    //           console.log('done')
    //         } else {
    //           readMore()
    //         }
    //       },
    //       () => console.log('error')
    //     )
    //   }
    //   response.body.getReader().cancel()
    // })
    clonedResponse.text().then((0, $2wH3Z.monitor)(function(text) {
        return callback($cea4f88979234f28$var$truncateResponseText(text, configuration));
    }), (0, $2wH3Z.monitor)(function(error) {
        return callback("Unable to retrieve response: ".concat(error));
    }));
    else $cea4f88979234f28$var$truncateResponseStream(clonedResponse.body, configuration.requestErrorResponseLengthLimit, function(error, responseText) {
        if (error) callback("Unable to retrieve response: ".concat(error));
        else callback(responseText);
    });
}
function $cea4f88979234f28$var$isRejected(request) {
    return request.status === 0 && request.responseType !== "opaque";
}
function $cea4f88979234f28$var$truncateResponseText(responseText, configuration) {
    if (responseText.length > configuration.requestErrorResponseLengthLimit) return "".concat(responseText.substring(0, configuration.requestErrorResponseLengthLimit), "...");
    return responseText;
}
function $cea4f88979234f28$var$format(type) {
    if ("xhr" /* RequestType.XHR */  === type) return "XHR";
    return "Fetch";
}
function $cea4f88979234f28$var$truncateResponseStream(stream, bytesLimit, callback) {
    (0, $4igFP.readBytesFromStream)(stream, function(error, bytes, limitExceeded) {
        if (error) callback(error);
        else {
            var responseText = new TextDecoder().decode(bytes);
            if (limitExceeded) responseText += "...";
            callback(undefined, responseText);
        }
    }, {
        bytesLimit: bytesLimit,
        collectStreamBody: true
    });
}

});

parcelRegister("bnyWV", function(module, exports) {

$parcel$export(module.exports, "startRuntimeErrorCollection", () => $848cf3e7ae55d059$export$ae6d2c609a1d871);

var $1zKlK = parcelRequire("1zKlK");
var $aed8w = parcelRequire("aed8w");
var $4wc1a = parcelRequire("4wc1a");
var $WWr2U = parcelRequire("WWr2U");

var $hVbxe = parcelRequire("hVbxe");
function $848cf3e7ae55d059$export$ae6d2c609a1d871(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) return {
        stop: (0, $aed8w.noop)
    };
    var rawErrorObservable = new (0, $4wc1a.Observable)();
    var stopRuntimeErrorTracking = (0, $WWr2U.trackRuntimeError)(rawErrorObservable).stop;
    var rawErrorSubscription = rawErrorObservable.subscribe(function(rawError) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , {
            rawLogsEvent: {
                message: rawError.message,
                date: rawError.startClocks.timeStamp,
                error: {
                    kind: rawError.type,
                    stack: rawError.stack,
                    causes: rawError.causes
                },
                origin: (0, $1zKlK.ErrorSource).SOURCE,
                status: (0, $hVbxe.StatusType).error
            }
        });
    });
    return {
        stop: function() {
            stopRuntimeErrorTracking();
            rawErrorSubscription.unsubscribe();
        }
    };
}

});

parcelRegister("7QcfF", function(module, exports) {

$parcel$export(module.exports, "LifeCycle", () => $5b56e4a7fb4bdb0c$export$6af70476896cbaec);

var $f7eLh = parcelRequire("f7eLh");
var $5b56e4a7fb4bdb0c$export$6af70476896cbaec = (0, $f7eLh.AbstractLifeCycle);

});

parcelRegister("f7pcn", function(module, exports) {

$parcel$export(module.exports, "startLoggerCollection", () => $b01b0e680d5d87bb$export$a909fdf2eb14fa81);

var $j9iCm = parcelRequire("j9iCm");
var $1zKlK = parcelRequire("1zKlK");
var $5IDGB = parcelRequire("5IDGB");
var $fkj4Q = parcelRequire("fkj4Q");
var $ly0px = parcelRequire("ly0px");

var $hVbxe = parcelRequire("hVbxe");
var $b01b0e680d5d87bb$var$_a;
var $b01b0e680d5d87bb$export$33137eb87fdcc0f7 = ($b01b0e680d5d87bb$var$_a = {}, $b01b0e680d5d87bb$var$_a[(0, $hVbxe.StatusType).debug] = 0, $b01b0e680d5d87bb$var$_a[(0, $hVbxe.StatusType).info] = 1, $b01b0e680d5d87bb$var$_a[(0, $hVbxe.StatusType).warn] = 2, $b01b0e680d5d87bb$var$_a[(0, $hVbxe.StatusType).error] = 3, $b01b0e680d5d87bb$var$_a);
function $b01b0e680d5d87bb$export$a909fdf2eb14fa81(lifeCycle) {
    function handleLog(logsMessage, logger, savedCommonContext, savedDate) {
        var messageContext = (0, $j9iCm.combine)(logger.getContext(), logsMessage.context);
        if ($b01b0e680d5d87bb$export$4f612ab7b7b1d133(logsMessage.status, (0, $hVbxe.HandlerType).console, logger)) $b01b0e680d5d87bb$var$displayInConsole(logsMessage, messageContext);
        if ($b01b0e680d5d87bb$export$4f612ab7b7b1d133(logsMessage.status, (0, $hVbxe.HandlerType).http, logger)) lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , {
            rawLogsEvent: {
                date: savedDate || (0, $ly0px.timeStampNow)(),
                message: logsMessage.message,
                status: logsMessage.status,
                origin: (0, $1zKlK.ErrorSource).LOGGER
            },
            messageContext: messageContext,
            savedCommonContext: savedCommonContext
        });
    }
    return {
        handleLog: handleLog
    };
}
function $b01b0e680d5d87bb$export$4f612ab7b7b1d133(status, handlerType, logger) {
    var loggerHandler = logger.getHandler();
    var sanitizedHandlerType = Array.isArray(loggerHandler) ? loggerHandler : [
        loggerHandler
    ];
    return $b01b0e680d5d87bb$export$33137eb87fdcc0f7[status] >= $b01b0e680d5d87bb$export$33137eb87fdcc0f7[logger.getLevel()] && (0, $fkj4Q.includes)(sanitizedHandlerType, handlerType);
}
function $b01b0e680d5d87bb$var$displayInConsole(logsMessage, messageContext) {
    (0, $5IDGB.originalConsoleMethods)[logsMessage.status].call((0, $5IDGB.globalConsole), logsMessage.message, messageContext);
}

});

parcelRegister("gtZEA", function(module, exports) {

$parcel$export(module.exports, "startLogsBatch", () => $bfff2de37815feec$export$e4658c4e9fa6ec0a);

var $lTIYX = parcelRequire("lTIYX");
var $a7s0L = parcelRequire("a7s0L");
function $bfff2de37815feec$export$e4658c4e9fa6ec0a(configuration, lifeCycle, reportError, pageExitObservable, session) {
    var batch = (0, $a7s0L.startBatchWithReplica)(configuration, {
        endpoint: configuration.logsEndpointBuilder,
        encoder: (0, $lTIYX.createIdentityEncoder)()
    }, configuration.replica && {
        endpoint: configuration.replica.logsEndpointBuilder,
        encoder: (0, $lTIYX.createIdentityEncoder)()
    }, reportError, pageExitObservable, session.expireObservable);
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */ , function(serverLogsEvent) {
        batch.add(serverLogsEvent);
    });
    return batch;
}

});

parcelRegister("b4X3T", function(module, exports) {

$parcel$export(module.exports, "startLogsBridge", () => $810de1dcd2ef0be7$export$4849c54cce6266f6);

var $kFaIT = parcelRequire("kFaIT");
function $810de1dcd2ef0be7$export$4849c54cce6266f6(lifeCycle) {
    var bridge = (0, $kFaIT.getEventBridge)();
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */ , function(serverLogsEvent) {
        bridge.send("log", serverLogsEvent);
    });
}

});

parcelRegister("bOMs4", function(module, exports) {

$parcel$export(module.exports, "startInternalContext", () => $89a9f2bb377a8f33$export$ee941cf091e8459);
function $89a9f2bb377a8f33$export$ee941cf091e8459(sessionManager) {
    return {
        get: function(startTime) {
            var trackedSession = sessionManager.findTrackedSession(startTime);
            if (trackedSession) return {
                session_id: trackedSession.id
            };
        }
    };
}

});

parcelRegister("cgp7x", function(module, exports) {

$parcel$export(module.exports, "startReportError", () => $8eda770f30771d58$export$ec67f68cd82e645c);

var $fhNdh = parcelRequire("fhNdh");
var $1zKlK = parcelRequire("1zKlK");

var $hVbxe = parcelRequire("hVbxe");
function $8eda770f30771d58$export$ec67f68cd82e645c(lifeCycle) {
    return function(error) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , {
            rawLogsEvent: {
                message: error.message,
                date: error.startClocks.timeStamp,
                origin: (0, $1zKlK.ErrorSource).AGENT,
                status: (0, $hVbxe.StatusType).error
            }
        });
        (0, $fhNdh.addTelemetryDebug)("Error reported to customer", {
            "error.message": error.message
        });
    };
}

});

parcelRegister("gsLOR", function(module, exports) {

$parcel$export(module.exports, "startLogsTelemetry", () => $bfc45aceebeababc$export$83b27ed75e4578fb);

var $fhNdh = parcelRequire("fhNdh");
var $kFaIT = parcelRequire("kFaIT");
var $lTIYX = parcelRequire("lTIYX");
var $a7s0L = parcelRequire("a7s0L");

var $j6Koz = parcelRequire("j6Koz");

var $leBZC = parcelRequire("leBZC");
function $bfc45aceebeababc$export$83b27ed75e4578fb(initConfiguration, configuration, reportError, pageExitObservable, session) {
    var telemetry = (0, $fhNdh.startTelemetry)("browser-logs-sdk" /* TelemetryService.LOGS */ , configuration);
    telemetry.setContextProvider(function() {
        var _a, _b, _c, _d, _e, _f;
        return {
            application: {
                id: (_a = (0, $j6Koz.getRUMInternalContext)()) === null || _a === void 0 ? void 0 : _a.application_id
            },
            session: {
                id: (_b = session.findTrackedSession()) === null || _b === void 0 ? void 0 : _b.id
            },
            view: {
                id: (_d = (_c = (0, $j6Koz.getRUMInternalContext)()) === null || _c === void 0 ? void 0 : _c.view) === null || _d === void 0 ? void 0 : _d.id
            },
            action: {
                id: (_f = (_e = (0, $j6Koz.getRUMInternalContext)()) === null || _e === void 0 ? void 0 : _e.user_action) === null || _f === void 0 ? void 0 : _f.id
            }
        };
    });
    var cleanupTasks = [];
    if ((0, $kFaIT.canUseEventBridge)()) {
        var bridge_1 = (0, $kFaIT.getEventBridge)();
        var telemetrySubscription_1 = telemetry.observable.subscribe(function(event) {
            return bridge_1.send("internal_telemetry", event);
        });
        cleanupTasks.push(function() {
            return telemetrySubscription_1.unsubscribe();
        });
    } else {
        var telemetryBatch_1 = (0, $a7s0L.startBatchWithReplica)(configuration, {
            endpoint: configuration.rumEndpointBuilder,
            encoder: (0, $lTIYX.createIdentityEncoder)()
        }, configuration.replica && {
            endpoint: configuration.replica.rumEndpointBuilder,
            encoder: (0, $lTIYX.createIdentityEncoder)()
        }, reportError, pageExitObservable, session.expireObservable);
        cleanupTasks.push(function() {
            return telemetryBatch_1.stop();
        });
        var telemetrySubscription_2 = telemetry.observable.subscribe(function(event) {
            return telemetryBatch_1.add(event, (0, $fhNdh.isTelemetryReplicationAllowed)(configuration));
        });
        cleanupTasks.push(function() {
            return telemetrySubscription_2.unsubscribe();
        });
    }
    (0, $fhNdh.addTelemetryConfiguration)((0, $leBZC.serializeLogsConfiguration)(initConfiguration));
    return {
        telemetry: telemetry,
        stop: function() {
            cleanupTasks.forEach(function(task) {
                return task();
            });
        }
    };
}

});




parcelRegister("yrzTx", function(module, exports) {

$parcel$export(module.exports, "log", () => $2f991a4df7bac39f$export$bef1f36f5486a6a3);

var $319l6 = parcelRequire("319l6");
const $2f991a4df7bac39f$export$bef1f36f5486a6a3 = {
    info: (message, context)=>(0, $319l6.datadogLogs).logger.info(message, context),
    error: (message, context)=>(0, $319l6.datadogLogs).logger.error(message, context),
    warn: (message, context)=>(0, $319l6.datadogLogs).logger.warn(message, context),
    debug: (message, context)=>(0, $319l6.datadogLogs).logger.debug(message, context)
};

});

parcelRegister("2bkBK", function(module, exports) {

$parcel$export(module.exports, "ddActions", () => $7d2687e5632ae09f$export$37db00c46c22e8c2);
const $7d2687e5632ae09f$export$37db00c46c22e8c2 = {
    profile: {
        edit: {
            click: "profile:edit:clicked",
            discard: {
                click: "profile:edit:discard:clicked",
                cancel: "profile:edit:discard:cancel",
                confirm: "profile:edit:discard:confirm"
            },
            preview: {
                click: "profile:edit:preview:clicked",
                back: "profile:edit:preview:back"
            },
            publish: {
                click: "profile:edit:publish:clicked"
            }
        },
        share: {
            public: "profile:share:public:link"
        },
        downloadChartbook: {
            click: "profile:download_chartbook:clicked",
            success: "profile:download_chartbook:success",
            fail: "profile:download_chartbook:fail",
            start: "profile:download_chartbook:started"
        },
        financialHighlights: {
            item: {
                delete: "profile:financial_highlights:delete",
                add: "profile:financial_highlights:add"
            }
        },
        hero: {
            callout: {
                delete: "profile:hero:delete",
                add: "profile:hero:add"
            }
        },
        footer: {
            finra: "profile:footer:finra:link",
            help: "profile:footer:help-center:link",
            contact: "profile:footer:contact-hum:link"
        }
    },
    match: {
        accept: "match:accept",
        reject: "match:reject",
        requestInfo: "match:requestInfo",
        teaserViewed: "match:teaserViewed"
    },
    calendly: {
        schedule: "calendly:schedule"
    },
    revenued: {
        offer_viewed: "revenued:offer_viewed",
        submit_success: "revenued:submit_success",
        documents_success: "revenued:documents_success",
        submit_error: "revenued:submit_error",
        documents_error: "revenued:documents_error"
    }
};

});


parcelRegister("kD2Zf", function(module, exports) {
$parcel$export(module.exports, "QueryStringBuilder", () => (parcelRequire("9O2q1")).QueryStringBuilder);
parcelRequire("9O2q1");

});
parcelRegister("9O2q1", function(module, exports) {

$parcel$export(module.exports, "QueryStringBuilder", () => $4864bb7c68504ca7$export$cc4cb4e4da24ef3b);
class $4864bb7c68504ca7$export$cc4cb4e4da24ef3b {
    /**
     * Initializes a new instance of the QueryStringBuilder class.
     */ constructor(){
        this.pairs = [];
    }
    /**
     * Adds a key-value pair to the query string. If the value is undefined, the pair is not added.
     * This method facilitates the creation of parameterized queries.
     * @param {string} key - The key to add to the query string.
     * @param {string|number|boolean|undefined} [val] - The value to associate with the key. If undefined, the key is not added.
     * @return {this} Returns this instance for chaining further calls.
     */ add(key, val) {
        if (val !== undefined) this.pairs.push({
            key: key,
            val: `${val}`
        });
        return this;
    }
    /**
     * Adds a key with a value prefixed by "eq." to indicate equality. Does not add the key if the value is undefined.
     * @param {string} key - The key to add.
     * @param {string|number|boolean|undefined} [val] - The value to be prefixed and associated with the key.
     * @return {this} Returns this instance for chaining.
     */ equals(key, val) {
        return val !== undefined ? this.add(key, `eq.${val}`) : this;
    }
    /**
     * Adds a key with a value prefixed by "like." for fuzzy matching. Does not add the key if the value is undefined.
     * @param {string} key - The key for the query parameter.
     * @param {string|number|boolean|undefined} [val] - The value for partial matching.
     * @return {this} Returns this instance for chaining.
     */ like(key, val) {
        return val !== undefined ? this.add(key, `like.${val}`) : this;
    }
    /**
     * Adds a key with a value prefixed by "ilike." for case-insensitive fuzzy matching. Does not add the key if the value is undefined.
     * @param {string} key - The key for the query parameter.
     * @param {string|number|boolean|undefined} [val] - The value for case-insensitive partial matching.
     * @return {this} Returns this instance for chaining.
     */ ilike(key, val) {
        return val !== undefined ? this.add(key, `ilike.${val}`) : this;
    }
    /**
     * Formats and adds a key with multiple values indicated by "in." prefix. Does not add the key if the values array is undefined.
     * @param {string} key - The key for the query parameter.
     * @param {(string|number)[] | FilterState | false} [collection] - The array of values for the key, or a special filter state object.
     * @return {this} Returns this instance for chaining.
     */ in(key, collection) {
        if (!collection) return this;
        const isFilterState = collection && "filterSet" in collection;
        if (isFilterState) {
            const state = collection;
            if (state.hasSelections) this.#addCollection(key, state.filterSet);
        } else if (Array.isArray(collection)) this.#addCollection(key, collection);
        return this;
    }
    /**
     * A private method to format and add a query parameter with multiple values, prefixed with "in.".
     * This method constructs a string from the values array and adds it to a query parameter
     * identified by the given key. The values are formatted as a comma-separated list enclosed in parentheses,
     * with each value quoted. The method is utilized internally by the 'in' method when the collection
     * argument is not a FilterState or false, indicating a direct array of values to be processed.
     *
     * @private
     * @param {string} key - The key for the query parameter to which the collection will be added.
     * @param {(string | number)[]} vals - An array of values (string or number) that are to be
     * formatted and added as the value for the specified key. The array should not be undefined
     * and is expected to contain at least one value.
     * @returns {void} This method does not return a value. It directly modifies the instance's
     * state by adding a formatted query parameter.
     */ #addCollection(key, vals) {
        const concatenation = vals.reduce((acc, val, index)=>acc + `${index === 0 ? "" : ","}"${val}"`, "");
        this.add(key, `in.(${concatenation})`);
    }
    /**
     * Constructs the query string from added key-value pairs.
     * @return {string} The constructed query string.
     */ build() {
        return this.pairs.map((pair)=>`${pair.key}=${pair.val}`).join("&");
    }
    /**
     * Creates a new QueryStringBuilder instance from a hash object containing key-value pairs.
     * This static method allows for easy instantiation of a query builder with pre-defined parameters.
     * @param {object} hash - The object with key-value pairs to be added to the query string.
     * @return {QueryBuilder} A new instance populated with the hash's key-value pairs.
     */ static fromHash(hash) {
        const query = new $4864bb7c68504ca7$export$cc4cb4e4da24ef3b();
        Object.entries(hash).forEach(([key, val])=>{
            if (val !== undefined) query.add(key, val);
        });
        return query;
    }
}

});


parcelRegister("jLMBL", function(module, exports) {
$parcel$export(module.exports, "NavigationProvider", () => (parcelRequire("7JXNE")).NavigationProvider);
$parcel$export(module.exports, "asPage", () => (parcelRequire("3qMBE")).asPage);
$parcel$export(module.exports, "V1RedirectWithPath", () => (parcelRequire("fuEBT")).V1RedirectWithPath);
parcelRequire("7JXNE");
parcelRequire("3qMBE");
parcelRequire("chdhE");
parcelRequire("ltgJt");
parcelRequire("fuEBT");

});
parcelRegister("7JXNE", function(module, exports) {

$parcel$export(module.exports, "NavigationProvider", () => $c9617aaf566df7eb$export$d91daf425539f32f);
$parcel$export(module.exports, "withNavigation", () => $c9617aaf566df7eb$export$da0e6262da52bedb);

var $ayMG0 = parcelRequire("ayMG0");

var $r2uF6 = parcelRequire("r2uF6");

var $acw62 = parcelRequire("acw62");
parcelRequire("18L7n");
var $doRCL = parcelRequire("doRCL");
parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");

var $edg5W = parcelRequire("edg5W");
parcelRequire("anJVh");
var $7gcOJ = parcelRequire("7gcOJ");
const $c9617aaf566df7eb$export$e54800527b5e5c6e = (0, $r2uF6.atom)({});
const $c9617aaf566df7eb$export$cd92137a111d2f1a = (0, $r2uF6.createStore)();
function $c9617aaf566df7eb$export$d91daf425539f32f({ children: children, showSettings: showSettings = false, showLogout: showLogout = false }) {
    (0, $acw62.useEffect)(()=>{
        $c9617aaf566df7eb$export$cd92137a111d2f1a.set($c9617aaf566df7eb$export$e54800527b5e5c6e, {
            showSettings: showSettings,
            showLogout: showLogout
        });
    }, [
        showSettings,
        showLogout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $r2uF6.Provider), {
        store: $c9617aaf566df7eb$export$cd92137a111d2f1a,
        children: children
    });
}
function $c9617aaf566df7eb$export$da0e6262da52bedb(Page, config = {}) {
    return function(props) {
        const flags = (0, $7gcOJ.useFlags)();
        const [userLinks, setUserLinks] = (0, $r2uF6.useAtom)($c9617aaf566df7eb$export$e54800527b5e5c6e);
        const [navState, setState] = (0, $acw62.useState)({
            navIsVisible: config.navIsVisible === undefined ? true : config.navIsVisible,
            navLinks: config.navLinks || [],
            showLogout: userLinks.showLogout,
            showSettings: userLinks.showSettings
        });
        (0, $acw62.useEffect)(()=>{
            setState((prevState)=>({
                    ...prevState,
                    showLogout: userLinks.showLogout,
                    showSettings: userLinks.showSettings
                }));
        }, [
            userLinks
        ]);
        const router = (0, $fp4OM.useRouter)();
        const { user: user } = (0, $edg5W.useSession)();
        const setNavState = (0, $acw62.useCallback)((config)=>{
            setState((prevState)=>({
                    ...prevState,
                    ...config
                }));
            if (config.showLogout) setUserLinks({
                ...userLinks,
                showLogout: config.showLogout
            });
            if (config.showSettings) setUserLinks({
                ...userLinks,
                showSettings: config.showSettings
            });
        }, [
            setUserLinks,
            setState
        ]);
        const resolvedNavLinks = (0, $acw62.useMemo)(()=>config.navLinks?.map((link)=>{
                if (typeof link === "function") return link({
                    router: router,
                    user: user
                });
                else return link;
            }).filter((link)=>{
                if (!link) return false;
                if (!flags.enabled("enable-credit-boxes") && link.to === "/credit-boxes") return false;
                return true;
            }), [
            user,
            router,
            config.navLinks,
            flags
        ]);
        const firstLetter = (0, $acw62.useMemo)(()=>user?.firstName?.charAt(0).toUpperCase(), [
            user
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                navState.navIsVisible && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $doRCL.NavBar), {
                    title: config.title,
                    links: resolvedNavLinks?.filter((link)=>!!link),
                    showSettings: navState.showSettings,
                    showLogout: navState.showLogout,
                    letter: firstLetter,
                    fixedBar: true,
                    variant: config.variant
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(Page, {
                    ...props,
                    navState: navState,
                    setNavState: setNavState
                })
            ]
        });
    };
}

});
parcelRegister("18L7n", function(module, exports) {
$parcel$export(module.exports, "Badge", () => (parcelRequire("1xSOq")).Badge);
$parcel$export(module.exports, "Card", () => (parcelRequire("bVwXM")).Card);
$parcel$export(module.exports, "Chip", () => (parcelRequire("4qH0K")).Chip);
$parcel$export(module.exports, "Icon", () => (parcelRequire("hUCih")).Icon);
$parcel$export(module.exports, "Illustration", () => (parcelRequire("ddmfx")).Illustration);
$parcel$export(module.exports, "MoreButton", () => (parcelRequire("eEgbe")).MoreButton);
$parcel$export(module.exports, "NavBar", () => (parcelRequire("doRCL")).NavBar);
$parcel$export(module.exports, "Section", () => (parcelRequire("7i7mP")).Section);
$parcel$export(module.exports, "SectionCard", () => (parcelRequire("fdLDL")).SectionCard);
$parcel$export(module.exports, "Spinner", () => (parcelRequire("5Ttm9")).Spinner);
$parcel$export(module.exports, "StickyFooter", () => (parcelRequire("4SyUF")).StickyFooter);
$parcel$export(module.exports, "Toggle", () => (parcelRequire("3djtJ")).Toggle);
$parcel$export(module.exports, "AccordionSection", () => (parcelRequire("a0B35")).AccordionSection);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("cjuU3")).Breadcrumbs);
$parcel$export(module.exports, "CardSkeleton", () => (parcelRequire("aZozk")).CardSkeleton);
$parcel$export(module.exports, "Filterbox", () => (parcelRequire("br4f9")).Filterbox);
$parcel$export(module.exports, "InlineNotification", () => (parcelRequire("arjdk")).InlineNotification);
$parcel$export(module.exports, "MaintenanceBanner", () => (parcelRequire("jg6kN")).MaintenanceBanner);
$parcel$export(module.exports, "Modal", () => (parcelRequire("dtQ0k")).Modal);
$parcel$export(module.exports, "ModalFooter", () => (parcelRequire("41p3a")).ModalFooter);
$parcel$export(module.exports, "NotificationType", () => (parcelRequire("arjdk")).NotificationType);
$parcel$export(module.exports, "PageHeading", () => (parcelRequire("5c1IA")).PageHeading);
$parcel$export(module.exports, "Pagination", () => (parcelRequire("f5Nhr")).Pagination);
$parcel$export(module.exports, "Splash", () => (parcelRequire("gUduC")).Splash);
$parcel$export(module.exports, "StatBox", () => (parcelRequire("eSDZU")).StatBox);
$parcel$export(module.exports, "SubHeading", () => (parcelRequire("fy2Jk")).SubHeading);
$parcel$export(module.exports, "toast", () => (parcelRequire("3oOMC")).toast);
$parcel$export(module.exports, "ToastProvider", () => (parcelRequire("3oOMC")).ToastProvider);
$parcel$export(module.exports, "Chart", () => (parcelRequire("8OvTp")).Chart);
$parcel$export(module.exports, "Checkbox", () => (parcelRequire("29x30")).Checkbox);
$parcel$export(module.exports, "DetailCard", () => (parcelRequire("kE1zm")).DetailCard);
$parcel$export(module.exports, "FilterBar", () => (parcelRequire("9tkgs")).FilterBar);
$parcel$export(module.exports, "Form", () => (parcelRequire("hQ0nj")).Form);
$parcel$export(module.exports, "Input", () => (parcelRequire("bApKI")).Input);
$parcel$export(module.exports, "Money", () => (parcelRequire("7JqhK")).Money);
$parcel$export(module.exports, "MutableList", () => (parcelRequire("9hanQ")).MutableList);
$parcel$export(module.exports, "Percent", () => (parcelRequire("6pNDa")).Percent);
$parcel$export(module.exports, "ProgressDownload", () => (parcelRequire("7dcDb")).ProgressDownload);
$parcel$export(module.exports, "RawInput", () => (parcelRequire("a6Thc")).RawInput);
$parcel$export(module.exports, "RichText", () => (parcelRequire("faxRZ")).RichText);
$parcel$export(module.exports, "Search", () => (parcelRequire("lkwlf")).Search);
$parcel$export(module.exports, "Select", () => (parcelRequire("97C3K")).Select);
$parcel$export(module.exports, "StatWidget", () => (parcelRequire("1l3Yq")).StatWidget);
$parcel$export(module.exports, "Table", () => (parcelRequire("grEu8")).Table);
$parcel$export(module.exports, "TextArea", () => (parcelRequire("1sOsm")).TextArea);
$parcel$export(module.exports, "TextWidget", () => (parcelRequire("9nhU7")).TextWidget);
$parcel$export(module.exports, "Widget", () => (parcelRequire("b7ZjI")).Widget);
$parcel$export(module.exports, "WidgetGrid", () => (parcelRequire("2rl3y")).WidgetGrid);
$parcel$export(module.exports, "Dashboard", () => (parcelRequire("TzpgG")).Dashboard);
$parcel$export(module.exports, "dashboardDrawerAtom", () => (parcelRequire("TzpgG")).dashboardDrawerAtom);
$parcel$export(module.exports, "ErrorPage", () => (parcelRequire("kvGcI")).ErrorPage);
$parcel$export(module.exports, "MultiStepForm", () => (parcelRequire("fEJo6")).MultiStepForm);
$parcel$export(module.exports, "NotFoundPage", () => (parcelRequire("4oMrS")).NotFoundPage);
$parcel$export(module.exports, "ReturnPage", () => (parcelRequire("kbOqr")).ReturnPage);
parcelRequire("azsOi");
parcelRequire("ljFgu");
parcelRequire("8OvTp");
parcelRequire("67PTG");
parcelRequire("agpqr");
parcelRequire("j97Mu");

});
parcelRegister("azsOi", function(module, exports) {
$parcel$export(module.exports, "Icon", () => (parcelRequire("hUCih")).Icon);
$parcel$export(module.exports, "StickyFooter", () => (parcelRequire("4SyUF")).StickyFooter);
$parcel$export(module.exports, "SectionCard", () => (parcelRequire("fdLDL")).SectionCard);
$parcel$export(module.exports, "Card", () => (parcelRequire("bVwXM")).Card);
$parcel$export(module.exports, "Badge", () => (parcelRequire("1xSOq")).Badge);
$parcel$export(module.exports, "Spinner", () => (parcelRequire("5Ttm9")).Spinner);
$parcel$export(module.exports, "MoreButton", () => (parcelRequire("eEgbe")).MoreButton);
$parcel$export(module.exports, "NavBar", () => (parcelRequire("doRCL")).NavBar);
$parcel$export(module.exports, "ProgressBar", () => (parcelRequire("1u8ue")).ProgressBar);
$parcel$export(module.exports, "Tooltip", () => (parcelRequire("kYIgH")).Tooltip);
$parcel$export(module.exports, "TooltipSize", () => (parcelRequire("kYIgH")).TooltipSize);
$parcel$export(module.exports, "Section", () => (parcelRequire("7i7mP")).Section);
$parcel$export(module.exports, "Toggle", () => (parcelRequire("3djtJ")).Toggle);
$parcel$export(module.exports, "Illustration", () => (parcelRequire("ddmfx")).Illustration);
$parcel$export(module.exports, "Chip", () => (parcelRequire("4qH0K")).Chip);
parcelRequire("4aCOh");
parcelRequire("b24po");
parcelRequire("NPGGQ");
parcelRequire("fXNwB");
parcelRequire("ir6LM");
parcelRequire("5R0Xk");
parcelRequire("ajahQ");
parcelRequire("6jolY");
parcelRequire("1s2hs");
parcelRequire("e1IRi");
parcelRequire("5Usd5");
parcelRequire("cL1y1");
parcelRequire("fw0XC");
parcelRequire("4HiyD");
parcelRequire("aJClm");
parcelRequire("bCQeH");
parcelRequire("1g6z2");
parcelRequire("fU1J1");
parcelRequire("8WnAC");
parcelRequire("jduyU");
parcelRequire("bCWR4");
parcelRequire("itiNH");
parcelRequire("d6xYN");

});
parcelRegister("4aCOh", function(module, exports) {
$parcel$export(module.exports, "Icon", () => (parcelRequire("hUCih")).Icon);
parcelRequire("hUCih");
parcelRequire("4zNAn");

});
parcelRegister("hUCih", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $21a1c1b788351b4f$export$f04a61298a47a40f);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $fOCtq = parcelRequire("fOCtq");

var $lWGN4 = parcelRequire("lWGN4");

var $jCccL = parcelRequire("jCccL");

var $kGngf = parcelRequire("kGngf");

var $2QczD = parcelRequire("2QczD");

var $fYu4m = parcelRequire("fYu4m");

var $aq2V2 = parcelRequire("aq2V2");

var $5ET48 = parcelRequire("5ET48");

var $c73Ao = parcelRequire("c73Ao");

var $jtMee = parcelRequire("jtMee");

var $auT2g = parcelRequire("auT2g");

var $5P6RR = parcelRequire("5P6RR");

var $dTV5h = parcelRequire("dTV5h");

var $5jygv = parcelRequire("5jygv");

var $7zcwC = parcelRequire("7zcwC");

var $5AjsM = parcelRequire("5AjsM");

var $uxkWn = parcelRequire("uxkWn");

var $isa9P = parcelRequire("isa9P");

var $ltXxg = parcelRequire("ltXxg");

var $1vUny = parcelRequire("1vUny");

var $d9jdF = parcelRequire("d9jdF");

var $29MDm = parcelRequire("29MDm");

var $ivSLB = parcelRequire("ivSLB");

var $5cv3W = parcelRequire("5cv3W");

var $8wvly = parcelRequire("8wvly");

var $4X14e = parcelRequire("4X14e");

var $5tcok = parcelRequire("5tcok");

var $75mQk = parcelRequire("75mQk");

var $1ecI8 = parcelRequire("1ecI8");

var $khdGy = parcelRequire("khdGy");

var $ar9yo = parcelRequire("ar9yo");

var $3iTnq = parcelRequire("3iTnq");

var $d8WNM = parcelRequire("d8WNM");

var $CfF2d = parcelRequire("CfF2d");

var $cgWtX = parcelRequire("cgWtX");

var $5Pqi8 = parcelRequire("5Pqi8");

var $jQxGd = parcelRequire("jQxGd");

var $6uzQs = parcelRequire("6uzQs");

var $lWtdl = parcelRequire("lWtdl");

var $gqcrB = parcelRequire("gqcrB");

var $fGo7U = parcelRequire("fGo7U");

var $5yov4 = parcelRequire("5yov4");

var $fCOh8 = parcelRequire("fCOh8");

var $4vExK = parcelRequire("4vExK");

var $OUdpF = parcelRequire("OUdpF");

var $51mW3 = parcelRequire("51mW3");

var $eMsNy = parcelRequire("eMsNy");

var $d2FRZ = parcelRequire("d2FRZ");

var $9jy6i = parcelRequire("9jy6i");

var $lhoE4 = parcelRequire("lhoE4");

var $3Rj3m = parcelRequire("3Rj3m");

var $7ad9J = parcelRequire("7ad9J");

var $efLll = parcelRequire("efLll");

var $gHqi6 = parcelRequire("gHqi6");

var $iu7lD = parcelRequire("iu7lD");

var $iBAju = parcelRequire("iBAju");

var $eJiOx = parcelRequire("eJiOx");

var $afndG = parcelRequire("afndG");

var $kg0bP = parcelRequire("kg0bP");

var $cad5S = parcelRequire("cad5S");

var $2Fks6 = parcelRequire("2Fks6");

var $a5wAA = parcelRequire("a5wAA");

var $kr88V = parcelRequire("kr88V");

var $9S4pw = parcelRequire("9S4pw");

var $hAtyA = parcelRequire("hAtyA");

var $9Udyw = parcelRequire("9Udyw");

var $g5Cx4 = parcelRequire("g5Cx4");

var $8UjqE = parcelRequire("8UjqE");

var $h9waA = parcelRequire("h9waA");

var $432Bs = parcelRequire("432Bs");

var $e5JRm = parcelRequire("e5JRm");

var $ajNKJ = parcelRequire("ajNKJ");

var $37uIx = parcelRequire("37uIx");
const $21a1c1b788351b4f$export$f04a61298a47a40f = ({ src: src, width: width = "24", height: height = "24", className: className, onClick: onClick })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: src,
                width: width,
                height: height,
                className: className,
                alt: ""
            })
        })
    });
$21a1c1b788351b4f$export$f04a61298a47a40f.ArrowLeft = (0, $fOCtq.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.ArrowRight = (0, $lWGN4.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Chart = (0, $jCccL.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Chat = (0, $kGngf.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Check = (0, $2QczD.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.ChevronDown = (0, $fYu4m.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.ChevronRight = (0, $aq2V2.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.CircleChart = (0, $5ET48.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.CircleCheck = (0, $c73Ao.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.CircleExclamation = (0, $jtMee.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.CircleFileCheck = (0, $auT2g.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.CircleHand = (0, $5P6RR.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.CirclePuzzle = (0, $dTV5h.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.CircleSignature = (0, $5jygv.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.CircleStar = (0, $7zcwC.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.CircleUser = (0, $5AjsM.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.CircleSearch = (0, $uxkWn.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Close = (0, $isa9P.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.CsvFile = (0, $ltXxg.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.DefaultFile = (0, $d9jdF.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Download = (0, $29MDm.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.ExcelFile = (0, $ivSLB.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.PdfIcon = (0, $1vUny.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.ExternalLink = (0, $5cv3W.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.File = (0, $8wvly.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Folder = (0, $4X14e.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Hum = (0, $75mQk.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.HumConnect = (0, $3iTnq.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.HumConnectError = (0, $1ecI8.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Info = (0, $5tcok.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.MiniArchiveBox = (0, $khdGy.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.MiniArchiveBoxXMark = (0, $ar9yo.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Money = (0, $d8WNM.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Note = (0, $CfF2d.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.NotificationStar = (0, $cgWtX.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Padlock = (0, $5Pqi8.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Pencil = (0, $jQxGd.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Refresh = (0, $6uzQs.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Search = (0, $lWtdl.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.TripleDot = (0, $gqcrB.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.User = (0, $fGo7U.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.VerifyEmail = (0, $5yov4.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.FinancialGrowth = (0, $fCOh8.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.UnsupportedCountry = (0, $4vExK.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.InvestorSignupStepOne = (0, $OUdpF.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.InvestorSignupStepTwo = (0, $51mW3.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.InvestorSignupStepThree = (0, $eMsNy.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.GrphImage = (0, $e5JRm.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.RingOn = (0, $d2FRZ.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.RingOff = (0, $9jy6i.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Building = (0, $lhoE4.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.BarChartup = (0, $3Rj3m.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.LineChartup = (0, $7ad9J.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Tag = (0, $efLll.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Percent = (0, $gHqi6.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.CircleDollar = (0, $iu7lD.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.DollarBill = (0, $iBAju.default);
//Connectors
$21a1c1b788351b4f$export$f04a61298a47a40f.Clearbooks = (0, $eJiOx.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Exact = (0, $afndG.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.FreeAgent = (0, $kg0bP.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Freshbooks = (0, $cad5S.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.KashFlow = (0, $2Fks6.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Kashoo = (0, $a5wAA.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.MDynamics = (0, $kr88V.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Myob = (0, $9S4pw.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Netsuite = (0, $hAtyA.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Pandle = (0, $9Udyw.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Quickbooks = (0, $g5Cx4.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Sage = (0, $8UjqE.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Wave = (0, $h9waA.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.Xero = (0, $432Bs.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.StepInProgress = (0, $ajNKJ.default);
$21a1c1b788351b4f$export$f04a61298a47a40f.MapPin = (0, $37uIx.default);

});
parcelRegister("fOCtq", function(module, exports) {

$parcel$export(module.exports, "default", () => $63cd274a7feacb09$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $63cd274a7feacb09$var$ArrowLeftIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M19 12.2773H5",
                        stroke: "#CBD5E1",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M12 19.2773L5 12.2773L12 5.27734",
                        stroke: "#CBD5E1",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        })
    });
};
var $63cd274a7feacb09$export$2e2bcd8739ae039 = $63cd274a7feacb09$var$ArrowLeftIcon;

});

parcelRegister("lWGN4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b72bc04e42258857$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $b72bc04e42258857$var$ArrowRightIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M3.75 10L16.25 10M16.25 10L10.625 4.375M16.25 10L10.625 15.625",
                    stroke: "#151C23",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            })
        })
    });
};
var $b72bc04e42258857$export$2e2bcd8739ae039 = $b72bc04e42258857$var$ArrowRightIcon;

});

parcelRegister("jCccL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d460360a585465df$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $d460360a585465df$var$ChartIcon = ({ className: className, width: width = "24", height: height = "24", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M12 20V10",
                        stroke: "#92ABFA",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M18 20V4",
                        stroke: "#92ABFA",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M6 20V16",
                        stroke: "#CBD5E1",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        })
    });
};
var $d460360a585465df$export$2e2bcd8739ae039 = $d460360a585465df$var$ChartIcon;

});

parcelRegister("kGngf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58c3d84a75a5e4b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $a58c3d84a75a5e4b$var$ChatIcon = ({ className: className, width: width = "52", height: height = "52", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "52",
                        height: "52",
                        rx: "26",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M25.6692 18C23.4333 18 21.2386 18.1791 19.0989 18.5237C17.6626 18.7551 16.6692 20.0133 16.6692 21.4259V26.5741C16.6692 27.9868 17.6626 29.2449 19.099 29.4763C19.9473 29.6129 20.8044 29.7236 21.6692 29.8073V33.25C21.6692 33.5533 21.8519 33.8268 22.1322 33.9429C22.4124 34.059 22.735 33.9948 22.9495 33.7803L26.5286 30.2013C26.6644 30.0654 26.8524 29.9837 27.0561 29.977C28.8139 29.9185 30.5439 29.7494 32.2394 29.4763C33.6758 29.2449 34.6692 27.9867 34.6692 26.5741V21.4259C34.6692 20.0133 33.6758 18.7551 32.2394 18.5237C30.0998 18.1791 27.9051 18 25.6692 18ZM25.6692 25C26.2215 25 26.6692 24.5523 26.6692 24C26.6692 23.4477 26.2215 23 25.6692 23C25.1169 23 24.6692 23.4477 24.6692 24C24.6692 24.5523 25.1169 25 25.6692 25ZM23.6692 24C23.6692 24.5523 23.2215 25 22.6692 25C22.1169 25 21.6692 24.5523 21.6692 24C21.6692 23.4477 22.1169 23 22.6692 23C23.2215 23 23.6692 23.4477 23.6692 24ZM28.6692 25C29.2215 25 29.6692 24.5523 29.6692 24C29.6692 23.4477 29.2215 23 28.6692 23C28.1169 23 27.6692 23.4477 27.6692 24C27.6692 24.5523 28.1169 25 28.6692 25Z",
                        fill: "#2A313F"
                    })
                ]
            })
        })
    });
};
var $a58c3d84a75a5e4b$export$2e2bcd8739ae039 = $a58c3d84a75a5e4b$var$ChatIcon;

});

parcelRegister("2QczD", function(module, exports) {

$parcel$export(module.exports, "default", () => $aff6eb64893d7e30$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $aff6eb64893d7e30$var$CheckIcon = ({ className: className, width: width = "25", height: height = "25", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.2045 6.15347C19.534 6.4045 19.5976 6.87509 19.3466 7.20457L11.3466 17.7046C11.2154 17.8767 11.0163 17.9838 10.8003 17.9983C10.5844 18.0129 10.3727 17.9334 10.2197 17.7804L5.71967 13.2804C5.42678 12.9875 5.42678 12.5126 5.71967 12.2197C6.01256 11.9268 6.48744 11.9268 6.78033 12.2197L10.6735 16.1129L18.1534 6.29551C18.4045 5.96603 18.8751 5.90243 19.2045 6.15347Z",
                    fill: "#CBD5E1"
                })
            })
        })
    });
};
var $aff6eb64893d7e30$export$2e2bcd8739ae039 = $aff6eb64893d7e30$var$CheckIcon;

});

parcelRegister("fYu4m", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f9ba0a2f4ea2886$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $4f9ba0a2f4ea2886$var$ChevronRightIcon = ({ className: className, width: width = "24", height: height = "24", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.68818 9.33438C7.98676 9.04728 8.46154 9.05659 8.74863 9.35517L12.458 13.2929L16.1674 9.35517C16.4545 9.05659 16.9293 9.04728 17.2278 9.33438C17.5264 9.62147 17.5357 10.0963 17.2486 10.3948L12.9986 14.8948C12.8572 15.0419 12.662 15.125 12.458 15.125C12.254 15.125 12.0588 15.0419 11.9174 14.8948L7.66738 10.3948C7.38029 10.0963 7.3896 9.62147 7.68818 9.33438Z",
                    fill: "#788598"
                })
            })
        })
    });
};
var $4f9ba0a2f4ea2886$export$2e2bcd8739ae039 = $4f9ba0a2f4ea2886$var$ChevronRightIcon;

});

parcelRegister("aq2V2", function(module, exports) {

$parcel$export(module.exports, "default", () => $65f7be9739929bef$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $65f7be9739929bef$var$ChevronRightIcon = ({ className: className, width: width = "24", height: height = "24", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                className: className,
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M9 18L15 12L9 6",
                    stroke: "#788598",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            })
        })
    });
};
var $65f7be9739929bef$export$2e2bcd8739ae039 = $65f7be9739929bef$var$ChevronRightIcon;

});

parcelRegister("5ET48", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cc7f337246b8514$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $7cc7f337246b8514$var$CircleChartIcon = ({ className: className, width: width = "36", height: height = "36", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "36",
                        height: "36",
                        rx: "18",
                        fill: "#1F2630"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M23.5 9.5C22.6716 9.5 22 10.1716 22 11V24C22 24.8284 22.6716 25.5 23.5 25.5H24.5C25.3284 25.5 26 24.8284 26 24V11C26 10.1716 25.3284 9.5 24.5 9.5H23.5Z",
                        fill: "#788598"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M17.5 13.5C16.6716 13.5 16 14.1716 16 15V24C16 24.8284 16.6716 25.5 17.5 25.5H18.5C19.3284 25.5 20 24.8284 20 24V15C20 14.1716 19.3284 13.5 18.5 13.5H17.5Z",
                        fill: "#788598"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M11.5 17.5C10.6716 17.5 10 18.1716 10 19V24C10 24.8284 10.6716 25.5 11.5 25.5H12.5C13.3284 25.5 14 24.8284 14 24V19C14 18.1716 13.3284 17.5 12.5 17.5H11.5Z",
                        fill: "#788598"
                    })
                ]
            })
        })
    });
};
var $7cc7f337246b8514$export$2e2bcd8739ae039 = $7cc7f337246b8514$var$CircleChartIcon;

});

parcelRegister("c73Ao", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ef96f5815ee5a63$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $1ef96f5815ee5a63$var$CircleCheckIcon = ({ className: className, width: width = "20", height: height = "20", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM13.8566 8.19113C14.1002 7.85614 14.0261 7.38708 13.6911 7.14345C13.3561 6.89982 12.8871 6.97388 12.6434 7.30887L9.15969 12.099L7.28033 10.2197C6.98744 9.92678 6.51256 9.92678 6.21967 10.2197C5.92678 10.5126 5.92678 10.9874 6.21967 11.2803L8.71967 13.7803C8.87477 13.9354 9.08999 14.0149 9.30867 13.9977C9.52734 13.9805 9.72754 13.8685 9.85655 13.6911L13.8566 8.19113Z",
                    fill: "#4A66F4"
                })
            })
        })
    });
};
var $1ef96f5815ee5a63$export$2e2bcd8739ae039 = $1ef96f5815ee5a63$var$CircleCheckIcon;

});

parcelRegister("jtMee", function(module, exports) {

$parcel$export(module.exports, "default", () => $2870f3b4a4e3e4be$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $2870f3b4a4e3e4be$var$CircleExclamationIcon = ({ className: className, width: width = "20", height: height = "20", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM10 5C10.4142 5 10.75 5.33579 10.75 5.75V10.25C10.75 10.6642 10.4142 11 10 11C9.58579 11 9.25 10.6642 9.25 10.25V5.75C9.25 5.33579 9.58579 5 10 5ZM10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.44771 13 9 13.4477 9 14C9 14.5523 9.44771 15 10 15Z",
                    fill: "#E29036"
                })
            })
        })
    });
};
var $2870f3b4a4e3e4be$export$2e2bcd8739ae039 = $2870f3b4a4e3e4be$var$CircleExclamationIcon;

});

parcelRegister("auT2g", function(module, exports) {

$parcel$export(module.exports, "default", () => $1396bbd02165b0cc$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $1396bbd02165b0cc$var$CircleFileCheckIcon = ({ className: className, width: width = "52", height: height = "52", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "52",
                        height: "52",
                        rx: "26",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M19 19.5C19 18.6716 19.6716 18 20.5 18H27.3787C27.7765 18 28.158 18.158 28.4393 18.4393L32.5607 22.5607C32.842 22.842 33 23.2235 33 23.6213V32.5C33 33.3284 32.3284 34 31.5 34H20.5C19.6716 34 19 33.3284 19 32.5V19.5ZM29.8566 25.1911C30.1002 24.8561 30.0261 24.3871 29.6911 24.1434C29.3561 23.8998 28.8871 23.9739 28.6434 24.3089L25.1597 29.099L23.2803 27.2197C22.9874 26.9268 22.5126 26.9268 22.2197 27.2197C21.9268 27.5126 21.9268 27.9874 22.2197 28.2803L24.7197 30.7803C24.8748 30.9354 25.09 31.0149 25.3087 30.9977C25.5273 30.9805 25.7275 30.8685 25.8566 30.6911L29.8566 25.1911Z",
                        fill: "#2A313F"
                    })
                ]
            })
        })
    });
};
var $1396bbd02165b0cc$export$2e2bcd8739ae039 = $1396bbd02165b0cc$var$CircleFileCheckIcon;

});

parcelRegister("5P6RR", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b1e5c51b147139$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $69b1e5c51b147139$var$CircleHandIcon = ({ className: className, width: width = "52", height: height = "52", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "52",
                        height: "52",
                        rx: "26",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M22.8661 18.849C22.5899 18.3707 21.9783 18.2068 21.5 18.483C21.0217 18.7591 20.8579 19.3707 21.134 19.849L24.384 25.4782C24.5221 25.7173 24.4401 26.0231 24.201 26.1612C23.9618 26.2992 23.6561 26.2173 23.518 25.9782L20.768 21.215C20.4918 20.7367 19.8802 20.5728 19.402 20.849C18.9237 21.1251 18.7598 21.7367 19.0359 22.215L21.7859 26.9782C21.924 27.2173 21.8421 27.5231 21.6029 27.6612C21.3638 27.7992 21.058 27.7173 20.9199 27.4782L19.1699 24.4471C18.8938 23.9688 18.2822 23.8049 17.8039 24.081C17.3256 24.3572 17.1617 24.9688 17.4379 25.4471L20.9379 31.5092C22.8709 34.8573 27.152 36.0044 30.5 34.0714C33.8481 32.1384 34.9952 27.8573 33.0622 24.5092L31.0622 21.0451C30.7861 20.5668 30.1745 20.403 29.6962 20.6791C29.2179 20.9553 29.054 21.5668 29.3302 22.0451L31.0802 25.0762C31.2182 25.3154 31.1363 25.6212 30.8971 25.7592C30.658 25.8973 30.3522 25.8154 30.2141 25.5762L25.9641 18.215C25.688 17.7367 25.0764 17.5728 24.5981 17.849C24.1198 18.1251 23.9559 18.7367 24.2321 19.215L26.9821 23.9782C27.1202 24.2173 27.0382 24.5231 26.7991 24.6612C26.5599 24.7992 26.2541 24.7173 26.1161 24.4782L22.8661 18.849Z",
                        fill: "#2A313F"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M30.4863 16.8633C30.4863 16.8633 31.1325 17.1556 32.2404 18.2635C33.3483 19.3714 34.0825 21.087 34.0825 21.087",
                        stroke: "#2A313F",
                        strokeWidth: "1.5",
                        strokeLinecap: "round"
                    })
                ]
            })
        })
    });
};
var $69b1e5c51b147139$export$2e2bcd8739ae039 = $69b1e5c51b147139$var$CircleHandIcon;

});

parcelRegister("dTV5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $585f021d928405d9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $585f021d928405d9$var$CirclePuzzleIcon = ({ className: className, width: width = "52", height: height = "52", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "52",
                        height: "52",
                        rx: "26",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M25.375 20.4474C25.375 20.1515 25.22 19.884 25.0407 19.6485C24.8566 19.4068 24.75 19.12 24.75 18.8125C24.75 17.9496 25.5895 17.25 26.625 17.25C27.6605 17.25 28.5 17.9496 28.5 18.8125C28.5 19.12 28.3934 19.4068 28.2093 19.6485C28.03 19.884 27.875 20.1515 27.875 20.4474C27.875 20.7244 28.1064 20.9455 28.3829 20.929C29.9751 20.834 31.5415 20.6444 33.0768 20.3658C33.2458 20.3352 33.4199 20.3754 33.5583 20.477C33.6967 20.5786 33.7872 20.7328 33.8086 20.9031C33.9952 22.3944 34.1011 23.9105 34.1216 25.447C34.1256 25.7523 33.8778 25.9999 33.5724 26C33.2765 26 33.009 25.845 32.7735 25.6657C32.5317 25.4816 32.245 25.375 31.9375 25.375C31.0746 25.375 30.375 26.2145 30.375 27.25C30.375 28.2855 31.0746 29.125 31.9375 29.125C32.245 29.125 32.5317 29.0184 32.7735 28.8343C33.009 28.655 33.2765 28.5 33.5724 28.5C33.8311 28.5 34.0365 28.7181 34.0179 28.9761C33.919 30.3415 33.7526 31.6884 33.522 33.0134C33.4767 33.2733 33.2732 33.4768 33.0134 33.522C31.4974 33.7858 29.9528 33.9656 28.3846 34.0564C28.1071 34.0724 27.875 33.8504 27.875 33.5724C27.875 33.2765 28.03 33.009 28.2093 32.7735C28.3934 32.5318 28.5 32.245 28.5 31.9375C28.5 31.0746 27.6605 30.375 26.625 30.375C25.5895 30.375 24.75 31.0746 24.75 31.9375C24.75 32.245 24.8566 32.5318 25.0407 32.7735C25.22 33.009 25.375 33.2765 25.375 33.5724C25.375 33.8738 25.1283 34.1171 24.8271 34.1086C23.5025 34.071 22.1937 33.97 20.9034 33.8085C20.7331 33.7871 20.5789 33.6966 20.4773 33.5582C20.3757 33.4198 20.3355 33.2457 20.3661 33.0767C20.6102 31.7317 20.786 30.3628 20.8897 28.9736C20.9088 28.7171 20.7047 28.5 20.4474 28.5C20.1515 28.5 19.884 28.655 19.6485 28.8343C19.4068 29.0184 19.12 29.125 18.8125 29.125C17.9496 29.125 17.25 28.2855 17.25 27.25C17.25 26.2145 17.9496 25.375 18.8125 25.375C19.12 25.375 19.4068 25.4816 19.6485 25.6657C19.884 25.845 20.1515 26 20.4474 26C20.7528 26 21.0006 25.7525 20.9964 25.4472C20.9778 24.0904 20.8905 22.7502 20.738 21.4302C20.7161 21.2407 20.782 21.0515 20.9169 20.9166C21.0519 20.7816 21.241 20.7157 21.4306 20.7376C22.5492 20.8669 23.6822 20.9493 24.8276 20.9828C25.1285 20.9916 25.375 20.7485 25.375 20.4474Z",
                        fill: "#2A313F"
                    })
                ]
            })
        })
    });
};
var $585f021d928405d9$export$2e2bcd8739ae039 = $585f021d928405d9$var$CirclePuzzleIcon;

});

parcelRegister("5jygv", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb3ff1c858aee606$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $cb3ff1c858aee606$var$CircleSignatureIcon = ({ className: className, width: width = "52", height: height = "52", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "52",
                        height: "52",
                        rx: "26",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M25.8134 24.6443L24.5516 27.7987C24.3883 28.2069 24.7934 28.6119 25.2015 28.4487L28.356 27.1869C28.859 26.9857 29.3158 26.6845 29.6989 26.3014L34.4995 21.5002C35.3279 20.6718 35.3279 19.3287 34.4995 18.5002C33.671 17.6718 32.3279 17.6718 31.4995 18.5002L26.6989 23.3014C26.3158 23.6845 26.0146 24.1413 25.8134 24.6443ZM21.0339 26.9733C19.6222 26.9733 18.6225 28.6387 19.112 30.6874C19.2816 31.3974 19.5941 31.9925 19.9716 32.4722C19.9118 32.4849 19.8576 32.4931 19.8103 32.4977H17.7549C17.3407 32.4977 17.0049 32.8335 17.0049 33.2477C17.0049 33.6619 17.3407 33.9977 17.7549 33.9977H19.8415C19.8597 33.9977 19.878 33.997 19.8962 33.9957C20.2495 33.9698 20.7429 33.8492 21.2556 33.5838C21.7174 33.8456 22.1994 33.9977 22.6236 33.9977C23.1552 33.9977 23.7823 33.8287 24.2873 33.5265C24.5949 33.3423 24.9396 33.0538 25.1406 32.6572C25.3156 33.006 25.5914 33.2661 25.8422 33.444C26.2551 33.7367 26.7291 33.9058 27.0513 33.979C27.1058 33.9914 27.1616 33.9977 27.2175 33.9977H31.7747C32.189 33.9977 32.5247 33.6619 32.5247 33.2477C32.5247 32.8335 32.189 32.4977 31.7747 32.4977H27.3103C27.1336 32.4484 26.8971 32.3531 26.7098 32.2203C26.4898 32.0643 26.4611 31.9527 26.4611 31.8975C26.4611 30.8774 25.9406 30.1499 25.1935 30.1139C25.1814 30.1133 25.1694 30.113 25.1573 30.113C24.83 30.113 24.4562 30.2617 24.1834 30.5947C23.906 30.9334 23.7861 31.3932 23.812 31.9335C23.8122 31.9369 23.8138 32.0617 23.5169 32.2394C23.2397 32.4053 22.8781 32.4977 22.6236 32.4977C22.6122 32.4977 22.5993 32.4971 22.5853 32.4958C22.8867 32.1199 23.1486 31.6597 23.3352 31.1002C24.0448 28.9714 22.7881 26.9733 21.0339 26.9733ZM21.9121 30.6258C21.7599 31.0824 21.5353 31.4349 21.2851 31.7042C20.9731 31.3594 20.7063 30.9053 20.5709 30.3388C20.3873 29.5704 20.5105 29.0743 20.6649 28.8018C20.8325 28.5061 21.0199 28.4733 21.0339 28.4733C21.4766 28.4733 22.3948 29.1777 21.9121 30.6258ZM25.3486 31.5387L25.3474 31.5405C25.3481 31.5392 25.3486 31.5386 25.3486 31.5387Z",
                        fill: "#2A313F"
                    })
                ]
            })
        })
    });
};
var $cb3ff1c858aee606$export$2e2bcd8739ae039 = $cb3ff1c858aee606$var$CircleSignatureIcon;

});

parcelRegister("7zcwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $eba4a944354149f1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $eba4a944354149f1$var$CircleStarIcon = ({ className: className, width: width = "36", height: height = "36", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "36",
                        height: "36",
                        rx: "18",
                        fill: "#1F2630"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M18.8679 10.623C18.5468 9.85094 17.4532 9.85094 17.1321 10.623L15.3013 15.0247L10.5492 15.4057C9.71574 15.4725 9.37779 16.5126 10.0128 17.0566L13.6334 20.158L12.5272 24.7952C12.3332 25.6085 13.218 26.2514 13.9316 25.8155L18 23.3305L22.0684 25.8155C22.782 26.2514 23.6668 25.6085 23.4728 24.7952L22.3666 20.158L25.9872 17.0566C26.6222 16.5126 26.2842 15.4725 25.4508 15.4057L20.6987 15.0247L18.8679 10.623Z",
                        fill: "#788598"
                    })
                ]
            })
        })
    });
};
var $eba4a944354149f1$export$2e2bcd8739ae039 = $eba4a944354149f1$var$CircleStarIcon;

});

parcelRegister("5AjsM", function(module, exports) {

$parcel$export(module.exports, "default", () => $512084e95210e946$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $512084e95210e946$var$CircleUserIcon = ({ className: className, width: width = "52", height: height = "52", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "52",
                        height: "52",
                        rx: "26",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M25.6689 24.25C27.3258 24.25 28.6689 22.9069 28.6689 21.25C28.6689 19.5931 27.3258 18.25 25.6689 18.25C24.0121 18.25 22.6689 19.5931 22.6689 21.25C22.6689 22.9069 24.0121 24.25 25.6689 24.25Z",
                        fill: "#2A313F"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M19.1341 30.7435C18.9392 31.2516 19.1133 31.821 19.5431 32.1546C21.2355 33.468 23.361 34.25 25.6691 34.25C27.9795 34.25 30.107 33.4664 31.8002 32.1506C32.2298 31.8167 32.4035 31.2471 32.2083 30.7392C31.199 28.1135 28.6531 26.25 25.672 26.25C22.6893 26.25 20.1422 28.1156 19.1341 30.7435Z",
                        fill: "#2A313F"
                    })
                ]
            })
        })
    });
};
var $512084e95210e946$export$2e2bcd8739ae039 = $512084e95210e946$var$CircleUserIcon;

});

parcelRegister("uxkWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8351ace198ee18e9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $8351ace198ee18e9$var$CircleSearchIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "none",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "40",
                        height: "40",
                        rx: "20",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M19 13.5C15.9624 13.5 13.5 15.9624 13.5 19C13.5 22.0376 15.9624 24.5 19 24.5C20.519 24.5 21.893 23.8852 22.8891 22.8891C23.8852 21.893 24.5 20.519 24.5 19C24.5 15.9624 22.0376 13.5 19 13.5ZM12 19C12 15.134 15.134 12 19 12C22.866 12 26 15.134 26 19C26 20.6625 25.4197 22.1906 24.4517 23.3911L27.7803 26.7197C28.0732 27.0126 28.0732 27.4874 27.7803 27.7803C27.4874 28.0732 27.0126 28.0732 26.7197 27.7803L23.3911 24.4517C22.1906 25.4197 20.6625 26 19 26C15.134 26 12 22.866 12 19Z",
                        fill: "#0C1014"
                    })
                ]
            })
        })
    });
};
var $8351ace198ee18e9$export$2e2bcd8739ae039 = $8351ace198ee18e9$var$CircleSearchIcon;

});

parcelRegister("isa9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $b796865545175a1e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
const $b796865545175a1e$var$CloseIcon = ({ className: className, width: width = "20", height: height = "20", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                className: (0, $9QePP.default)("my-2 size-6 stroke-gray-200 hover:stroke-white lg:m-0 lg:size-4", className),
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M4.72461 15.5117L14.7246 5.51172M4.72461 5.51172L14.7246 15.5117",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            })
        })
    });
};
var $b796865545175a1e$export$2e2bcd8739ae039 = $b796865545175a1e$var$CloseIcon;

});
parcelRegister("9QePP", function(module, exports) {

$parcel$export(module.exports, "clsx", () => $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});


parcelRegister("ltXxg", function(module, exports) {

$parcel$export(module.exports, "default", () => $362de28dfc0846f9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $362de28dfc0846f9$var$CsvFileIcon = ({ className: className, width: width = "25", height: height = "25", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M5.08929 1.5H14.0315C14.3805 1.5 14.7186 1.62168 14.9875 1.8441L20.456 6.36674C20.8005 6.6517 21 7.07551 21 7.52264V21.3917C21 23.3613 20.977 23.5 18.9107 23.5H5.08929C3.023 23.5 3 23.3613 3 21.3917V3.60833C3 1.63874 3.023 1.5 5.08929 1.5Z",
                        fill: "#2A313F"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M9.36736 13.0475C9.39247 13.1647 9.29867 13.2696 9.17887 13.2696H8.53097C8.43138 13.2696 8.34925 13.1955 8.32042 13.1001C8.29992 13.0324 8.27321 12.9693 8.24028 12.9109C8.18134 12.8048 8.10567 12.7146 8.01327 12.6401C7.92087 12.5657 7.81414 12.5087 7.69307 12.4691C7.57359 12.4295 7.44375 12.4097 7.30356 12.4097C7.05027 12.4097 6.82963 12.4723 6.64165 12.5974C6.45367 12.7209 6.3079 12.9014 6.20435 13.139C6.1008 13.3749 6.04903 13.6615 6.04903 13.9988C6.04903 14.3456 6.1008 14.637 6.20435 14.8729C6.30949 15.1089 6.45606 15.287 6.64404 15.4074C6.83202 15.5277 7.04947 15.5879 7.29639 15.5879C7.43499 15.5879 7.56323 15.5697 7.68112 15.5333C7.8006 15.4968 7.90654 15.4438 7.99893 15.3741C8.09133 15.3029 8.1678 15.2165 8.22833 15.1152C8.26337 15.0581 8.29232 14.9964 8.3152 14.9302C8.34682 14.8386 8.42786 14.7687 8.52469 14.7692L9.17932 14.7721C9.29896 14.7727 9.3922 14.8779 9.36334 14.994C9.32723 15.1393 9.27308 15.281 9.2009 15.4192C9.09416 15.6251 8.94999 15.8096 8.76838 15.9727C8.58837 16.1342 8.3733 16.2625 8.12319 16.3575C7.87467 16.4509 7.5935 16.4976 7.27967 16.4976C6.84317 16.4976 6.45287 16.3994 6.10877 16.2031C5.76626 16.0067 5.49544 15.7225 5.29631 15.3504C5.09877 14.9782 5 14.5277 5 13.9988C5 13.4683 5.10036 13.017 5.30109 12.6449C5.50181 12.2728 5.77423 11.9893 6.11833 11.7945C6.46243 11.5982 6.84954 11.5 7.27967 11.5C7.56323 11.5 7.82609 11.5396 8.06823 11.6188C8.31197 11.6979 8.52783 11.8135 8.71581 11.9656C8.90379 12.116 9.05672 12.3005 9.17461 12.519C9.26173 12.6783 9.32598 12.8545 9.36736 13.0475Z",
                        fill: "#788598"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M12.9818 12.9656C12.8791 12.9656 12.797 12.8857 12.7612 12.7894C12.7205 12.6801 12.6517 12.59 12.5547 12.519C12.4097 12.4129 12.213 12.3599 11.9645 12.3599C11.7956 12.3599 11.653 12.3836 11.5367 12.4311C11.4204 12.477 11.3312 12.5412 11.2691 12.6235C11.2085 12.7059 11.1783 12.7993 11.1783 12.9038C11.1751 12.9909 11.1934 13.0669 11.2332 13.1318C11.2747 13.1968 11.3312 13.253 11.4029 13.3005C11.4746 13.3464 11.5574 13.3868 11.6514 13.4216C11.7454 13.4549 11.8458 13.4834 11.9525 13.5071L12.3922 13.6116C12.6057 13.6591 12.8016 13.7225 12.98 13.8017C13.1585 13.8808 13.313 13.9782 13.4436 14.0938C13.5742 14.2094 13.6754 14.3456 13.7471 14.5024C13.8204 14.6591 13.8578 14.8389 13.8594 15.0416C13.8578 15.3393 13.7813 15.5974 13.63 15.8159C13.4803 16.0329 13.2636 16.2015 12.98 16.3219C12.6981 16.4406 12.3579 16.5 11.9597 16.5C11.5646 16.5 11.2205 16.4398 10.9274 16.3195C10.6358 16.1991 10.408 16.021 10.244 15.785C10.1141 15.5952 10.0336 15.3695 10.0024 15.1079C9.98914 14.9964 10.0806 14.9038 10.1929 14.9038H10.8027C10.9079 14.9038 10.9918 14.9865 11.0204 15.0877C11.0443 15.1722 11.081 15.2471 11.1305 15.3124C11.2149 15.42 11.3272 15.5016 11.4674 15.557C11.6092 15.6108 11.7693 15.6378 11.9477 15.6378C12.123 15.6378 12.2751 15.6124 12.4041 15.5618C12.5348 15.5111 12.6359 15.4406 12.7076 15.3504C12.7793 15.2601 12.8151 15.1564 12.8151 15.0392C12.8151 14.9299 12.7825 14.8381 12.7172 14.7637C12.6535 14.6892 12.5595 14.6259 12.4352 14.5736C12.3125 14.5214 12.162 14.4739 11.9836 14.4311L11.4507 14.2981C11.0381 14.1983 10.7123 14.0424 10.4734 13.8302C10.2344 13.618 10.1157 13.3321 10.1173 12.9727C10.1157 12.6781 10.1946 12.4208 10.3539 12.2007C10.5148 11.9806 10.7354 11.8088 11.0158 11.6853C11.2962 11.5618 11.6148 11.5 11.9716 11.5C12.3348 11.5 12.6519 11.5618 12.9227 11.6853C13.1951 11.8088 13.407 11.9806 13.5583 12.2007C13.6733 12.368 13.746 12.5554 13.7764 12.763C13.7926 12.8736 13.7009 12.9656 13.5892 12.9656H12.9818Z",
                        fill: "#788598"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M15.2935 11.5665C15.3805 11.5665 15.4575 11.6227 15.484 11.7055L16.6224 15.2625H16.6678L17.8084 11.7054C17.835 11.6227 17.912 11.5665 17.9989 11.5665H18.719C18.8565 11.5665 18.953 11.7021 18.9079 11.832L17.313 16.4311H15.9796L14.3824 11.8321C14.3372 11.7022 14.4337 11.5665 14.5713 11.5665H15.2935Z",
                        fill: "#788598"
                    })
                ]
            })
        })
    });
};
var $362de28dfc0846f9$export$2e2bcd8739ae039 = $362de28dfc0846f9$var$CsvFileIcon;

});

parcelRegister("1vUny", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fc850dd552f8ca5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $0fc850dd552f8ca5$var$PdfFileIcon = ({ className: className, width: width = "25", height: height = "25", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: "0 0 50 50",
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M10.1786 2.5H28.6029C28.9519 2.5 29.29 2.62168 29.5589 2.8441L41.456 12.6834C41.8005 12.9684 42 13.3922 42 13.8393V42.2833C42 46.2225 41.954 46.5 37.8214 46.5H10.1786C6.04601 46.5 6 46.2225 6 42.2833V6.71667C6 2.77747 6.04601 2.5 10.1786 2.5Z",
                        fill: "#2A313F"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M10.2155 32.5C10.0965 32.5 10 32.4035 10 32.2845V22.7155C10 22.5965 10.0965 22.5 10.2155 22.5H14.3275C15.1594 22.5 15.8681 22.6449 16.4537 22.9346C17.0393 23.221 17.4856 23.6198 17.7927 24.1309C18.1033 24.6387 18.2586 25.2246 18.2586 25.8887C18.2586 26.5527 18.1015 27.1387 17.7873 27.6465C17.4731 28.1543 17.0179 28.5498 16.4216 28.833C15.8289 29.1162 15.1112 29.2578 14.2686 29.2578H11.5103V27.5635H13.8936C14.34 27.5635 14.7077 27.4935 14.9969 27.3535C15.2897 27.2103 15.5075 27.0133 15.6503 26.7627C15.7967 26.5088 15.8699 26.2174 15.8699 25.8887C15.8699 25.5566 15.7967 25.2669 15.6503 25.0195C15.5075 24.7689 15.2897 24.5752 14.9969 24.4385C14.7042 24.2985 14.3328 24.2285 13.8829 24.2285H12.3191V32.2845C12.3191 32.4035 12.2226 32.5 12.1036 32.5H10.2155Z",
                        fill: "#788598"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M23.6532 32.5H19.9804C19.8614 32.5 19.7649 32.4035 19.7649 32.2845V22.7155C19.7649 22.5965 19.8614 22.5 19.9804 22.5H23.6853C24.7886 22.5 25.7384 22.7002 26.5346 23.1006C27.3308 23.4977 27.9432 24.069 28.3717 24.8145C28.8037 25.5599 29.0197 26.4518 29.0197 27.4902C29.0197 28.5319 28.8037 29.4271 28.3717 30.1758C27.9432 30.9245 27.3273 31.499 26.5239 31.8994C25.7241 32.2998 24.7672 32.5 23.6532 32.5ZM22.084 30.6885H23.5568C24.2423 30.6885 24.819 30.5778 25.2867 30.3564C25.758 30.1318 26.1115 29.7852 26.3472 29.3164C26.5864 28.8444 26.706 28.2357 26.706 27.4902C26.706 26.7513 26.5864 26.1475 26.3472 25.6787C26.1115 25.21 25.7598 24.8649 25.2921 24.6436C24.8243 24.4222 24.2477 24.3115 23.5622 24.3115H22.084V30.6885Z",
                        fill: "#788598"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M30.953 32.5C30.834 32.5 30.7376 32.4035 30.7376 32.2845V22.7155C30.7376 22.5965 30.834 22.5 30.953 22.5H37.7845C37.9035 22.5 38 22.5965 38 22.7155V24.0277C38 24.1467 37.9035 24.2432 37.7845 24.2432H33.0566V26.626H37.3025C37.4215 26.626 37.518 26.7224 37.518 26.8414V28.1537C37.518 28.2727 37.4215 28.3691 37.3025 28.3691H33.0566V32.2845C33.0566 32.4035 32.9602 32.5 32.8412 32.5H30.953Z",
                        fill: "#788598"
                    })
                ]
            })
        })
    });
};
var $0fc850dd552f8ca5$export$2e2bcd8739ae039 = $0fc850dd552f8ca5$var$PdfFileIcon;

});

parcelRegister("d9jdF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5951647bcc81000f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $5951647bcc81000f$var$DefaultFileIcon = ({ className: className, width: width = "25", height: height = "25", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M5.08929 1.5H14.0315C14.3805 1.5 14.7186 1.62168 14.9875 1.8441L20.456 6.36674C20.8005 6.6517 21 7.07551 21 7.52264V21.3917C21 23.3613 20.977 23.5 18.9107 23.5H5.08929C3.023 23.5 3 23.3613 3 21.3917V3.60833C3 1.63874 3.023 1.5 5.08929 1.5Z",
                        fill: "#2A313F"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "6",
                        y: "11.5",
                        width: "9",
                        height: "2",
                        rx: "1",
                        fill: "#788598"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "6",
                        y: "15.5",
                        width: "5",
                        height: "2",
                        rx: "1",
                        fill: "#788598"
                    })
                ]
            })
        })
    });
};
var $5951647bcc81000f$export$2e2bcd8739ae039 = $5951647bcc81000f$var$DefaultFileIcon;

});

parcelRegister("29MDm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6201f8bea0a73f0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
const $b6201f8bea0a73f0$var$DownloadIcon = ({ className: className, width: width = "24", height: height = "24", onClick: onClick, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                fill: "none",
                className: (0, $9QePP.default)("stroke-slate-400 hover:stroke-white", className),
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15",
                        stroke: "currentStroke",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M7 10L12 15L17 10",
                        stroke: "currentStroke",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M12 15V3",
                        stroke: "currentStroke",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        })
    });
};
var $b6201f8bea0a73f0$export$2e2bcd8739ae039 = $b6201f8bea0a73f0$var$DownloadIcon;

});

parcelRegister("ivSLB", function(module, exports) {

$parcel$export(module.exports, "default", () => $34b2759042195482$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $34b2759042195482$var$ExcelFileIcon = ({ className: className, width: width = "25", height: height = "25", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: "0 0 50 50",
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M10.1786 2.5H28.6029C28.9519 2.5 29.29 2.62168 29.5589 2.8441L41.456 12.6834C41.8005 12.9684 42 13.3922 42 13.8393V42.2833C42 46.2225 41.954 46.5 37.8214 46.5H10.1786C6.04601 46.5 6 46.2225 6 42.2833V6.71667C6 2.77747 6.04601 2.5 10.1786 2.5Z",
                        fill: "#2A313F"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M14.1779 22.633C14.2499 22.633 14.3163 22.6717 14.3518 22.7342L16.1781 25.9489H16.2511L18.0864 22.7339C18.122 22.6715 18.1883 22.633 18.2601 22.633H20.0254C20.1799 22.633 20.2761 22.8008 20.1979 22.9341L17.5236 27.4976L20.2568 32.0594C20.3367 32.1927 20.2407 32.3622 20.0853 32.3622H18.2823C18.2108 32.3622 18.1448 32.3241 18.109 32.2622L16.2511 29.0416H16.1781L14.3201 32.2622C14.2844 32.3241 14.2183 32.3622 14.1469 32.3622H12.3535C12.198 32.3622 12.102 32.1925 12.1821 32.0592L14.9237 27.4976L12.2326 22.9346C12.154 22.8013 12.2501 22.633 12.4049 22.633H14.1779Z",
                        fill: "#788598"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M21.8242 32.3622C21.7137 32.3622 21.6242 32.2727 21.6242 32.1622V22.833C21.6242 22.7226 21.7137 22.633 21.8242 22.633H23.3992C23.5096 22.633 23.5992 22.7226 23.5992 22.833V30.6663H27.4039C27.5144 30.6663 27.6039 30.7558 27.6039 30.8663V32.1622C27.6039 32.2727 27.5144 32.3622 27.4039 32.3622H21.8242Z",
                        fill: "#788598"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M34.1612 25.4311C34.0581 25.4311 33.9735 25.3522 33.9521 25.2514C33.8889 24.9536 33.7414 24.7158 33.5096 24.538C33.2329 24.3258 32.8573 24.2197 32.3829 24.2197C32.0606 24.2197 31.7885 24.2672 31.5665 24.3622C31.3445 24.4541 31.1742 24.5823 31.0556 24.747C30.9401 24.9117 30.8823 25.0986 30.8823 25.3076C30.8762 25.4818 30.9112 25.6338 30.9872 25.7637C31.0663 25.8935 31.1742 26.0059 31.3111 26.101C31.4479 26.1928 31.606 26.2736 31.7854 26.3432C31.9648 26.4097 32.1564 26.4667 32.3601 26.5143L33.1994 26.7233C33.6069 26.8183 33.9809 26.945 34.3215 27.1033C34.662 27.2617 34.957 27.4565 35.2063 27.6876C35.4557 27.9188 35.6488 28.1912 35.7856 28.5048C35.9255 28.8183 35.997 29.1778 36 29.5831C35.997 30.1785 35.851 30.6948 35.5621 31.1318C35.2763 31.5657 34.8627 31.903 34.3215 32.1437C33.7832 32.3812 33.134 32.5 32.3738 32.5C31.6197 32.5 30.9629 32.3797 30.4034 32.139C29.8469 31.8983 29.4121 31.542 29.0989 31.0701C28.8194 30.642 28.6596 30.1225 28.6197 29.5118C28.6123 29.3999 28.7031 29.3076 28.8152 29.3076H30.3346C30.44 29.3076 30.526 29.3897 30.5425 29.4938C30.5812 29.7389 30.6641 29.9492 30.7911 30.1247C30.9522 30.3401 31.1666 30.5032 31.4342 30.614C31.7049 30.7217 32.0104 30.7755 32.351 30.7755C32.6855 30.7755 32.9759 30.7249 33.2222 30.6235C33.4716 30.5222 33.6646 30.3812 33.8015 30.2007C33.9383 30.0202 34.0067 29.8127 34.0067 29.5784C34.0067 29.3599 33.9444 29.1762 33.8197 29.0273C33.6981 28.8785 33.5187 28.7518 33.2815 28.6473C33.0474 28.5428 32.76 28.4477 32.4194 28.3622L31.4023 28.0962C30.6147 27.8967 29.9929 27.5847 29.5367 27.1603C29.0806 26.7359 28.8541 26.1643 28.8571 25.4454C28.8541 24.8563 29.0046 24.3416 29.3087 23.9014C29.6158 23.4612 30.037 23.1176 30.5721 22.8705C31.1073 22.6235 31.7155 22.5 32.3966 22.5C33.0899 22.5 33.6951 22.6235 34.212 22.8705C34.732 23.1176 35.1364 23.4612 35.4253 23.9014C35.6799 24.2895 35.8259 24.7318 35.8632 25.2281C35.8715 25.3395 35.7808 25.4311 35.6691 25.4311H34.1612Z",
                        fill: "#788598"
                    })
                ]
            })
        })
    });
};
var $34b2759042195482$export$2e2bcd8739ae039 = $34b2759042195482$var$ExcelFileIcon;

});

parcelRegister("5cv3W", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eea1bf7bf2df70d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $8eea1bf7bf2df70d$var$ExternalLinkIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M21.1477 14.75C21.5619 14.75 21.8977 14.4142 21.8977 14C21.8977 13.5858 21.5619 13.25 21.1477 13.25V14.75ZM26.3977 18.5C26.3977 18.0858 26.0619 17.75 25.6477 17.75C25.2335 17.75 24.8977 18.0858 24.8977 18.5H26.3977ZM14.6174 23.9697C14.3245 24.2626 14.3245 24.7374 14.6174 25.0303C14.9103 25.3232 15.3851 25.3232 15.678 25.0303L14.6174 23.9697ZM28.6477 11H29.3977C29.3977 10.8011 29.3187 10.6103 29.178 10.4697C29.0374 10.329 28.8466 10.25 28.6477 10.25V11ZM23.3977 10.25C22.9835 10.25 22.6477 10.5858 22.6477 11C22.6477 11.4142 22.9835 11.75 23.3977 11.75V10.25ZM27.8977 16.25C27.8977 16.6642 28.2335 17 28.6477 17C29.0619 17 29.3977 16.6642 29.3977 16.25H27.8977ZM23.3977 28.25H12.8977V29.75H23.3977V28.25ZM11.3977 26.75V16.25H9.89771V26.75H11.3977ZM12.8977 14.75H21.1477V13.25H12.8977V14.75ZM24.8977 18.5V26.75H26.3977V18.5H24.8977ZM12.8977 28.25C12.0693 28.25 11.3977 27.5784 11.3977 26.75H9.89771C9.89771 28.4069 11.2409 29.75 12.8977 29.75V28.25ZM23.3977 29.75C25.0546 29.75 26.3977 28.4069 26.3977 26.75H24.8977C24.8977 27.5784 24.2261 28.25 23.3977 28.25V29.75ZM11.3977 16.25C11.3977 15.4216 12.0693 14.75 12.8977 14.75V13.25C11.2409 13.25 9.89771 14.5931 9.89771 16.25H11.3977ZM15.678 25.0303L29.178 11.5303L28.1174 10.4697L14.6174 23.9697L15.678 25.0303ZM28.6477 10.25L23.3977 10.25V11.75L28.6477 11.75V10.25ZM27.8977 11V16.25H29.3977V11H27.8977Z",
                    fill: "currentColor"
                })
            })
        })
    });
};
var $8eea1bf7bf2df70d$export$2e2bcd8739ae039 = $8eea1bf7bf2df70d$var$ExternalLinkIcon;

});

parcelRegister("8wvly", function(module, exports) {

$parcel$export(module.exports, "default", () => $05403358eb9a3b76$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $05403358eb9a3b76$var$FileIcon = ({ className: className, width: width = "52", height: height = "52", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "52",
                        height: "52",
                        rx: "26",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.4999 17.5C19.6715 17.5 18.9999 18.1716 18.9999 19V32C18.9999 32.8284 19.6715 33.5 20.4999 33.5H31.4999C32.3283 33.5 32.9999 32.8284 32.9999 32V23.1213C32.9999 22.7235 32.8418 22.342 32.5605 22.0607L28.4392 17.9393C28.1579 17.658 27.7764 17.5 27.3786 17.5H20.4999ZM22.7499 26C22.3357 26 21.9999 26.3358 21.9999 26.75C21.9999 27.1642 22.3357 27.5 22.7499 27.5H29.2499C29.6641 27.5 29.9999 27.1642 29.9999 26.75C29.9999 26.3358 29.6641 26 29.2499 26H22.7499ZM22.7499 29C22.3357 29 21.9999 29.3358 21.9999 29.75C21.9999 30.1642 22.3357 30.5 22.7499 30.5H29.2499C29.6641 30.5 29.9999 30.1642 29.9999 29.75C29.9999 29.3358 29.6641 29 29.2499 29H22.7499Z",
                        fill: "#2A313F"
                    })
                ]
            })
        })
    });
};
var $05403358eb9a3b76$export$2e2bcd8739ae039 = $05403358eb9a3b76$var$FileIcon;

});

parcelRegister("4X14e", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d393614a7f8ca84$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $0d393614a7f8ca84$var$FolderIcon = ({ className: className, width: width = "25", height: height = "25", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M19.5 21a3 3 0 003-3v-4.5a3 3 0 00-3-3h-15a3 3 0 00-3 3V18a3 3 0 003 3h15zM1.5 10.146V6a3 3 0 013-3h5.379a2.25 2.25 0 011.59.659l2.122 2.121c.14.141.331.22.53.22H19.5a3 3 0 013 3v1.146A4.483 4.483 0 0019.5 9h-15a4.483 4.483 0 00-3 1.146z"
                })
            })
        })
    });
};
var $0d393614a7f8ca84$export$2e2bcd8739ae039 = $0d393614a7f8ca84$var$FolderIcon;

});

parcelRegister("5tcok", function(module, exports) {

$parcel$export(module.exports, "default", () => $01235e6674c60203$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $01235e6674c60203$var$InfoIcon = ({ className: className, width: width = "25", height: height = "24" })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 25 24",
        fill: "currentColor",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.5 16L2.5 22.5L9 20.5L4.5 16Z",
                fill: "#7E899A"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M3.5 12C3.5 6.47715 7.97715 2 13.5 2C19.0228 2 23.5 6.47715 23.5 12C23.5 17.5228 19.0228 22 13.5 22C7.97715 22 3.5 17.5228 3.5 12Z",
                fill: "#788598"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.66793 13.5547C7.36158 13.0952 7.48576 12.4743 7.94528 12.1679C8.40481 11.8616 9.02568 11.9858 9.33203 12.4453C10.4891 14.1808 11.8543 15 13.5 15C15.1457 15 16.5109 14.1808 17.6679 12.4453C17.9743 11.9858 18.5952 11.8616 19.0547 12.1679C19.5142 12.4743 19.6384 13.0952 19.332 13.5547C17.8224 15.8191 15.8543 17 13.5 17C11.1457 17 9.17757 15.8191 7.66793 13.5547Z",
                fill: "#7E899A"
            })
        ]
    });
};
var $01235e6674c60203$export$2e2bcd8739ae039 = $01235e6674c60203$var$InfoIcon;

});

parcelRegister("75mQk", function(module, exports) {

$parcel$export(module.exports, "default", () => $07d2d932d2ee196c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $07d2d932d2ee196c$var$Hum = ({ className: className, width: width = "24", height: height = "24", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM26.2667 11.1066V10.5288H17.6889C16.5333 10.5288 15.6 10.8844 15.2 11.5066L14.5778 12.7066C12.8357 11.3438 10.7001 10.5799 8.48889 10.5288H8.31111L12.7556 16.2177L8.35555 24.84L8.84444 25.1066L9.33333 24.1733C10.1778 22.6177 11.0222 21.2844 12.8889 20.4844C17.9535 18.2383 18.7851 15.6868 19.4484 13.6514C19.4545 13.6327 19.4606 13.6141 19.4667 13.5955C19.5434 13.3048 19.6476 13.0221 19.7778 12.7511C20.2667 11.3288 20.8889 11.1511 23.1111 11.1066H26.2667ZM17.6516 11.6506C17.7633 11.6586 17.8696 11.7015 17.9556 11.7733C18.0436 11.8386 18.1112 11.9276 18.1506 12.0299C18.1899 12.1322 18.1994 12.2436 18.1778 12.3511C18.1597 12.437 18.1223 12.5177 18.0684 12.587C18.0145 12.6563 17.9455 12.7124 17.8667 12.7511L17.6 12.84C17.5348 12.8426 17.4698 12.8321 17.4087 12.8092C17.3477 12.7863 17.2918 12.7514 17.2444 12.7066C17.1598 12.6286 17.0954 12.5313 17.0567 12.4229C17.018 12.3145 17.0061 12.1984 17.0222 12.0844C17.0398 12.0037 17.0776 11.9287 17.132 11.8665C17.1864 11.8044 17.2557 11.757 17.3333 11.7288C17.4286 11.67 17.5399 11.6426 17.6516 11.6506Z",
                    fill: "white"
                })
            })
        })
    });
};
var $07d2d932d2ee196c$export$2e2bcd8739ae039 = $07d2d932d2ee196c$var$Hum;

});

parcelRegister("1ecI8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9276b54d9900617f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $9276b54d9900617f$var$HumConnectErrorIcon = ({ className: className, width: width = "140", height: height = "140", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "23.5149",
                        cy: "116.561",
                        r: "1.27068",
                        fill: "#151C23",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "4.30847",
                        cy: "70.5146",
                        r: "1.27068",
                        fill: "#151C23",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "52.05",
                        cy: "110.526",
                        r: "1.27068",
                        fill: "#151C23",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "110.647",
                        cy: "88.4336",
                        r: "1.27068",
                        fill: "#151C23",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "39.7",
                        cy: "39.8896",
                        r: "1.27068",
                        fill: "#151C23",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "23.5149",
                        cy: "23.6543",
                        r: "1.27068",
                        fill: "#151C23",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "70.0144",
                        cy: "4.66504",
                        r: "1.27068",
                        fill: "#151C23",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "116.209",
                        cy: "23.71",
                        r: "1.27068",
                        fill: "#151C23",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "135.653",
                        cy: "70.3037",
                        r: "1.27068",
                        fill: "#151C23",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "116.209",
                        cy: "116.561",
                        r: "1.27068",
                        fill: "#151C23",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "69.8596",
                        cy: "135.942",
                        r: "1.27068",
                        fill: "#151C23",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "4.09783",
                        y1: "70.9908",
                        x2: "23.2236",
                        y2: "23.8074",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "4.52049",
                        y1: "70.3024",
                        x2: "70.2264",
                        y2: "135.941",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "70.2524",
                        y1: "136.416",
                        x2: "116.09",
                        y2: "116.496",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "116.316",
                        y1: "116.956",
                        x2: "115.916",
                        y2: "23.9219",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "116.095",
                        y1: "24.1984",
                        x2: "69.7456",
                        y2: "5.15376",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "23.3254",
                        y1: "23.4035",
                        x2: "69.9021",
                        y2: "4.59752",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "23.5715",
                        y1: "116.926",
                        x2: "23.2149",
                        y2: "23.6826",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "23.4365",
                        y1: "116.842",
                        x2: "116.208",
                        y2: "116.471",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "135.986",
                        y1: "70.7277",
                        x2: "69.8031",
                        y2: "5.08917",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "135.975",
                        y1: "70.7272",
                        x2: "70.0713",
                        y2: "136.366",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "69.8967",
                        y1: "136.364",
                        x2: "23.5754",
                        y2: "116.598",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "22.9028",
                        y1: "116.193",
                        x2: "4.03121",
                        y2: "70.4919",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "3.94691",
                        y1: "70.3022",
                        x2: "69.8025",
                        y2: "4.66368",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "23.6748",
                        y1: "23.3895",
                        x2: "116.617",
                        y2: "23.6218",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "115.597",
                        y1: "23.57",
                        x2: "135.928",
                        y2: "70.3951",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "135.93",
                        y1: "70.6304",
                        x2: "116.493",
                        y2: "117.108",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "39.8839",
                        y1: "39.9753",
                        x2: "70.0441",
                        y2: "70.1127",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "69.7133",
                        y1: "70.3824",
                        x2: "110.768",
                        y2: "88.3701",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "69.8677",
                        y1: "70.7775",
                        x2: "52.3249",
                        y2: "110.857",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "70.0402",
                        y1: "70.7734",
                        x2: "39.0799",
                        y2: "101.233",
                        stroke: "#FF8A8A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "28.8115",
                        y1: "111.53",
                        x2: "14.0928",
                        y2: "125.843",
                        stroke: "#FF8A8A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "23.4959",
                        y1: "50.3784",
                        x2: "10.4645",
                        y2: "44.7859",
                        stroke: "#FF8A8A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "52.0452",
                        y1: "62.5919",
                        x2: "33.1581",
                        y2: "54.5484",
                        stroke: "#FF8A8A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "88.2797",
                        y1: "70.3037",
                        x2: "106.205",
                        y2: "70.3037",
                        stroke: "#FF8A8A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "118.209",
                        y1: "70.3037",
                        x2: "125.934",
                        y2: "70.3037",
                        stroke: "#FF8A8A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "19.8931",
                        cy: "92.2793",
                        r: "2",
                        fill: "#FF6B6B"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "15.1609",
                        cy: "125.205",
                        r: "2",
                        fill: "#FF6B6B"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "69.926",
                        cy: "125.205",
                        r: "2",
                        fill: "#FF6B6B"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "116.216",
                        cy: "116.56",
                        r: "2",
                        fill: "#FF6B6B"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "124.558",
                        cy: "70.5137",
                        r: "2",
                        fill: "#FF6B6B"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "130.259",
                        cy: "44.0244",
                        r: "2",
                        fill: "#FF6B6B"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "96.311",
                        cy: "10.1904",
                        r: "2",
                        fill: "#FF6B6B"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "69.8596",
                        cy: "27.3447",
                        r: "2",
                        fill: "#FF6B6B"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "9.92212",
                        cy: "44.3262",
                        r: "2",
                        fill: "#FF6B6B"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        clipPath: "url(#clip0_1839_17125)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "48.0358",
                                y: "48.5361",
                                width: "43.9572",
                                height: "43.9572",
                                rx: "21.9786",
                                fill: "#151C23"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M91.9929 70.5147C91.9929 82.6532 82.1528 92.4933 70.0143 92.4933C57.8759 92.4933 48.0358 82.6532 48.0358 70.5147C48.0358 58.3763 57.8759 48.5361 70.0143 48.5361C82.1528 48.5361 91.9929 58.3763 91.9929 70.5147ZM84.1173 63.7991V63.0054H72.3343C70.747 63.0054 69.4649 63.4938 68.9154 64.3485L68.0607 65.9969C65.6677 64.1248 62.7341 63.0756 59.6966 63.0054H59.4524L65.5576 70.82L59.5135 82.664L60.185 83.0303L60.8566 81.7482C62.0166 79.6114 63.1766 77.7799 65.7407 76.681C72.6979 73.5956 73.8401 70.0907 74.7514 67.2947L74.7764 67.218C74.8818 66.8187 75.0249 66.4303 75.2037 66.058C75.8753 64.1043 76.73 63.8601 79.7826 63.7991H84.1173ZM72.2831 64.5463C72.4365 64.5573 72.5826 64.6162 72.7006 64.7148C72.8216 64.8046 72.9145 64.9268 72.9685 65.0674C73.0226 65.2079 73.0355 65.3609 73.0059 65.5085C72.9811 65.6266 72.9297 65.7374 72.8557 65.8326C72.7816 65.9278 72.6868 66.0049 72.5785 66.058L72.2122 66.1801C72.1227 66.1837 72.0334 66.1693 71.9495 66.1379C71.8656 66.1064 71.7889 66.0585 71.7238 65.9969C71.6076 65.8898 71.519 65.7561 71.4659 65.6072C71.4127 65.4583 71.3965 65.2987 71.4185 65.1422C71.4427 65.0313 71.4946 64.9284 71.5693 64.843C71.644 64.7575 71.7392 64.6925 71.8459 64.6538C71.9768 64.573 72.1297 64.5354 72.2831 64.5463Z",
                                fill: "#FCFDFE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_1839_17125",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "48.0358",
                                y: "48.5361",
                                width: "43.9572",
                                height: "43.9572",
                                rx: "21.9786",
                                fill: "white"
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $9276b54d9900617f$export$2e2bcd8739ae039 = $9276b54d9900617f$var$HumConnectErrorIcon;

});

parcelRegister("khdGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $9981fc60b7287c6a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $9981fc60b7287c6a$var$MiniArchiveBoxIcon = ({ className: className, width: width = "20", height: height = "18", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M3.64771 5C3.09542 5 2.64771 5.44772 2.64771 6V7C2.64771 7.55228 3.09542 8 3.64771 8H19.6477C20.2 8 20.6477 7.55228 20.6477 7V6C20.6477 5.44772 20.2 5 19.6477 5H3.64771Z",
                        fill: "#788598"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M3.64771 9.5H19.6477L18.8362 17.2094C18.729 18.2273 17.8707 19 16.8472 19H6.44823C5.42471 19 4.56636 18.2273 4.45922 17.2094L3.64771 9.5ZM8.64771 13C8.64771 12.4477 9.09542 12 9.64771 12H13.6477C14.2 12 14.6477 12.4477 14.6477 13C14.6477 13.5523 14.2 14 13.6477 14H9.64771C9.09542 14 8.64771 13.5523 8.64771 13Z",
                        fill: "#788598"
                    })
                ]
            })
        })
    });
};
var $9981fc60b7287c6a$export$2e2bcd8739ae039 = $9981fc60b7287c6a$var$MiniArchiveBoxIcon;

});

parcelRegister("ar9yo", function(module, exports) {

$parcel$export(module.exports, "default", () => $77ab3006bbbc1805$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $77ab3006bbbc1805$var$MiniArchiveBoxXIcon = ({ className: className, width: width = "20", height: height = "18", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M2 3C1.44772 3 1 3.44772 1 4V5C1 5.55228 1.44772 6 2 6H18C18.5523 6 19 5.55228 19 5V4C19 3.44772 18.5523 3 18 3H2Z",
                        fill: "#788598"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M2 7.5H18L17.1885 15.2094C17.0813 16.2273 16.223 17 15.1995 17H4.80052C3.77701 17 2.91866 16.2273 2.81151 15.2094L2 7.5ZM7.21967 9.21967C7.51256 8.92678 7.98744 8.92678 8.28033 9.21967L10 10.9393L11.7197 9.21967C12.0126 8.92678 12.4874 8.92678 12.7803 9.21967C13.0732 9.51256 13.0732 9.98744 12.7803 10.2803L11.0607 12L12.7803 13.7197C13.0732 14.0126 13.0732 14.4874 12.7803 14.7803C12.4874 15.0732 12.0126 15.0732 11.7197 14.7803L10 13.0607L8.28033 14.7803C7.98744 15.0732 7.51256 15.0732 7.21967 14.7803C6.92678 14.4874 6.92678 14.0126 7.21967 13.7197L8.93934 12L7.21967 10.2803C6.92678 9.98744 6.92678 9.51256 7.21967 9.21967Z",
                        fill: "#788598"
                    })
                ]
            })
        })
    });
};
var $77ab3006bbbc1805$export$2e2bcd8739ae039 = $77ab3006bbbc1805$var$MiniArchiveBoxXIcon;

});

parcelRegister("3iTnq", function(module, exports) {

$parcel$export(module.exports, "default", () => $473e20871faae1af$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $473e20871faae1af$var$HumConnectIcon = ({ className: className, width: width = "140", height: height = "140", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "23.5149",
                        cy: "116.561",
                        r: "1.27068",
                        fill: "#3E4758",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "4.30847",
                        cy: "70.5146",
                        r: "1.27068",
                        fill: "#3E4758",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "52.05",
                        cy: "110.526",
                        r: "1.27068",
                        fill: "#3E4758",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "110.647",
                        cy: "88.4336",
                        r: "1.27068",
                        fill: "#3E4758",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "39.7",
                        cy: "39.8896",
                        r: "1.27068",
                        fill: "#3E4758",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "23.5149",
                        cy: "23.6543",
                        r: "1.27068",
                        fill: "#3E4758",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "70.0144",
                        cy: "4.66504",
                        r: "1.27068",
                        fill: "#3E4758",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "116.209",
                        cy: "23.71",
                        r: "1.27068",
                        fill: "#3E4758",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "135.653",
                        cy: "70.3037",
                        r: "1.27068",
                        fill: "#3E4758",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "116.209",
                        cy: "116.561",
                        r: "1.27068",
                        fill: "#3E4758",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "69.8596",
                        cy: "135.942",
                        r: "1.27068",
                        fill: "#3E4758",
                        stroke: "#3E4758",
                        strokeWidth: "1.45863"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "4.09783",
                        y1: "70.9908",
                        x2: "23.2236",
                        y2: "23.8074",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "4.52049",
                        y1: "70.3024",
                        x2: "70.2264",
                        y2: "135.941",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "70.2524",
                        y1: "136.416",
                        x2: "116.09",
                        y2: "116.496",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "116.316",
                        y1: "116.956",
                        x2: "115.916",
                        y2: "23.9219",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "116.095",
                        y1: "24.1984",
                        x2: "69.7456",
                        y2: "5.15376",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "23.3254",
                        y1: "23.4035",
                        x2: "69.9021",
                        y2: "4.59752",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "23.5715",
                        y1: "116.926",
                        x2: "23.2149",
                        y2: "23.6826",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "23.4365",
                        y1: "116.842",
                        x2: "116.208",
                        y2: "116.471",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "135.986",
                        y1: "70.7277",
                        x2: "69.8031",
                        y2: "5.08917",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "135.975",
                        y1: "70.7272",
                        x2: "70.0713",
                        y2: "136.366",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "69.8967",
                        y1: "136.364",
                        x2: "23.5754",
                        y2: "116.598",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "22.9028",
                        y1: "116.193",
                        x2: "4.03121",
                        y2: "70.4919",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "3.94691",
                        y1: "70.3022",
                        x2: "69.8025",
                        y2: "4.66368",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "23.6748",
                        y1: "23.3895",
                        x2: "116.617",
                        y2: "23.6218",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "115.597",
                        y1: "23.57",
                        x2: "135.928",
                        y2: "70.3951",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "135.93",
                        y1: "70.6304",
                        x2: "116.493",
                        y2: "117.108",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "39.8839",
                        y1: "39.9753",
                        x2: "70.0441",
                        y2: "70.1127",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "69.7133",
                        y1: "70.3824",
                        x2: "110.768",
                        y2: "88.3701",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "69.8677",
                        y1: "70.7775",
                        x2: "52.3249",
                        y2: "110.857",
                        stroke: "#3E4758",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "70.2198",
                        y1: "70.5169",
                        x2: "69.8639",
                        y2: "125.207",
                        stroke: "#F1F5F9"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "70.0414",
                        y1: "70.7722",
                        x2: "15.1584",
                        y2: "125.134",
                        stroke: "#F1F5F9"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        opacity: "0.5",
                        x1: "69.787",
                        y1: "70.785",
                        x2: "49.8392",
                        y2: "79.1865",
                        stroke: "#F1F5F9"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "69.4305",
                        y1: "70.8343",
                        x2: "10.4597",
                        y2: "44.7831",
                        stroke: "#F1F5F9"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "69.7479",
                        y1: "70.5059",
                        x2: "69.7479",
                        y2: "27.9204",
                        stroke: "#F1F5F9"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "69.4693",
                        y1: "70.3023",
                        x2: "96.1903",
                        y2: "10.3548",
                        stroke: "#F1F5F9"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        opacity: "0.5",
                        x1: "69.7341",
                        y1: "70.0441",
                        x2: "90.0759",
                        y2: "61.5899",
                        stroke: "#F1F5F9"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "69.926",
                        y1: "70.3037",
                        x2: "123.107",
                        y2: "70.3037",
                        stroke: "#F1F5F9"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        opacity: "0.5",
                        x1: "70.285",
                        y1: "70.0992",
                        x2: "85.5981",
                        y2: "85.8959",
                        stroke: "#F1F5F9"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "19.8931",
                        cy: "92.2793",
                        r: "2",
                        fill: "#F5F7FB"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "15.1609",
                        cy: "125.205",
                        r: "2",
                        fill: "#F5F7FB"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "69.926",
                        cy: "125.205",
                        r: "2",
                        fill: "#F5F7FB"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "116.216",
                        cy: "116.56",
                        r: "2",
                        fill: "#F5F7FB"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "124.558",
                        cy: "70.5137",
                        r: "2",
                        fill: "#F5F7FB"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "130.259",
                        cy: "44.0244",
                        r: "2",
                        fill: "#F5F7FB"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "96.311",
                        cy: "10.1904",
                        r: "2",
                        fill: "#F5F7FB"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "69.8596",
                        cy: "27.3447",
                        r: "2",
                        fill: "#F5F7FB"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "9.92212",
                        cy: "44.3262",
                        r: "2",
                        fill: "#F5F7FB"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        clipPath: "url(#clip0_1839_17222)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "48.0358",
                                y: "48.5361",
                                width: "43.9572",
                                height: "43.9572",
                                rx: "21.9786",
                                fill: "#151C23"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M91.9929 70.5147C91.9929 82.6532 82.1528 92.4933 70.0143 92.4933C57.8759 92.4933 48.0358 82.6532 48.0358 70.5147C48.0358 58.3763 57.8759 48.5361 70.0143 48.5361C82.1528 48.5361 91.9929 58.3763 91.9929 70.5147ZM84.1173 63.7991V63.0054H72.3343C70.747 63.0054 69.4649 63.4938 68.9154 64.3485L68.0607 65.9969C65.6677 64.1248 62.7341 63.0756 59.6966 63.0054H59.4524L65.5576 70.82L59.5135 82.664L60.185 83.0303L60.8566 81.7482C62.0166 79.6114 63.1766 77.7799 65.7407 76.681C72.6979 73.5956 73.8401 70.0907 74.7514 67.2947L74.7764 67.218C74.8818 66.8187 75.0249 66.4303 75.2037 66.058C75.8753 64.1043 76.73 63.8601 79.7826 63.7991H84.1173ZM72.2831 64.5463C72.4365 64.5573 72.5826 64.6162 72.7006 64.7148C72.8216 64.8046 72.9145 64.9268 72.9685 65.0674C73.0226 65.2079 73.0355 65.3609 73.0059 65.5085C72.9811 65.6266 72.9297 65.7374 72.8557 65.8326C72.7816 65.9278 72.6868 66.0049 72.5785 66.058L72.2122 66.1801C72.1227 66.1837 72.0334 66.1693 71.9495 66.1379C71.8656 66.1064 71.7889 66.0585 71.7238 65.9969C71.6076 65.8898 71.519 65.7561 71.4659 65.6072C71.4127 65.4583 71.3965 65.2987 71.4185 65.1422C71.4427 65.0313 71.4946 64.9284 71.5693 64.843C71.644 64.7575 71.7392 64.6925 71.8459 64.6538C71.9768 64.573 72.1297 64.5354 72.2831 64.5463Z",
                                fill: "#FCFDFE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_1839_17222",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "48.0358",
                                y: "48.5361",
                                width: "43.9572",
                                height: "43.9572",
                                rx: "21.9786",
                                fill: "white"
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $473e20871faae1af$export$2e2bcd8739ae039 = $473e20871faae1af$var$HumConnectIcon;

});

parcelRegister("d8WNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6dcc1d56fd7bc42$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $e6dcc1d56fd7bc42$var$MoneyIcon = ({ className: className, width: width = "52", height: height = "52", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "52",
                        height: "52",
                        rx: "26",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M26.7498 26.3176V28.9324C27.1815 28.8527 27.5744 28.7046 27.8875 28.4999C28.3697 28.1846 28.4998 27.852 28.4998 27.625C28.4998 27.398 28.3697 27.0654 27.8875 26.7501C27.5744 26.5454 27.1815 26.3973 26.7498 26.3176Z",
                        fill: "#2A313F"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M24.3295 24.1195C24.3833 24.1754 24.4445 24.2305 24.5139 24.2842C24.7219 24.4448 24.9734 24.5678 25.2499 24.6469V22.1031C25.1753 22.1245 25.1026 22.149 25.032 22.1766C24.9871 22.1942 24.943 22.213 24.9 22.233C24.7598 22.2982 24.6301 22.3761 24.5139 22.4659C24.1365 22.7576 23.9999 23.0925 23.9999 23.375C23.9999 23.5589 24.0577 23.7649 24.2022 23.9668C24.2389 24.0181 24.2811 24.0691 24.3295 24.1195Z",
                        fill: "#2A313F"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M33.9999 25.5C33.9999 29.9183 30.4182 33.5 25.9999 33.5C21.5816 33.5 17.9999 29.9183 17.9999 25.5C17.9999 21.0817 21.5816 17.5 25.9999 17.5C30.4182 17.5 33.9999 21.0817 33.9999 25.5ZM25.9998 19.5C26.414 19.5 26.7498 19.8358 26.7498 20.25V20.5658C27.3421 20.6711 27.9181 20.9043 28.4029 21.2789C28.8292 21.6083 29.1465 22.0184 29.3281 22.479C29.48 22.8643 29.2907 23.2999 28.9054 23.4517C28.52 23.6036 28.0845 23.4144 27.9326 23.029C27.8598 22.8444 27.7199 22.6467 27.4858 22.4659C27.2778 22.3052 27.0263 22.1823 26.7498 22.1031V24.7994C27.4479 24.8923 28.1326 25.1182 28.7084 25.4947C29.4954 26.0093 29.9998 26.7644 29.9998 27.625C29.9998 28.4856 29.4954 29.2407 28.7084 29.7553C28.1326 30.1318 27.4479 30.3577 26.7498 30.4506V30.75C26.7498 31.1642 26.414 31.5 25.9998 31.5C25.5856 31.5 25.2498 31.1642 25.2498 30.75V30.4506C24.5517 30.3577 23.8671 30.1318 23.2913 29.7553C22.8088 29.4398 22.4336 29.0376 22.2133 28.5672C22.0376 28.192 22.1993 27.7455 22.5744 27.5699C22.9495 27.3942 23.396 27.5559 23.5717 27.931C23.6525 28.1035 23.8168 28.3067 24.1122 28.4999C24.4252 28.7046 24.8182 28.8526 25.2498 28.9324V26.1842C24.6575 26.0789 24.0815 25.8457 23.5967 25.4711C22.9002 24.9329 22.4998 24.1802 22.4998 23.375C22.4998 22.5698 22.9002 21.8171 23.5967 21.2789C24.0815 20.9043 24.6575 20.6711 25.2498 20.5658V20.25C25.2498 19.8358 25.5856 19.5 25.9998 19.5Z",
                        fill: "#2A313F"
                    })
                ]
            })
        })
    });
};
var $e6dcc1d56fd7bc42$export$2e2bcd8739ae039 = $e6dcc1d56fd7bc42$var$MoneyIcon;

});

parcelRegister("CfF2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ca8fce28d24f94c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $2ca8fce28d24f94c$var$NoteIcon = ({ className: className, width: width = "40", height: height = "40" })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        role: "img",
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "currentColor",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                width: "40",
                height: "40",
                rx: "20",
                fill: "#1F2630"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14 11C12.3431 11 11 12.3431 11 14V23C11 24.6569 12.3431 26 14 26H26.0249L28.3178 28.2929C28.9478 28.9229 30.0249 28.4767 30.0249 27.5858V23L30 23.0098C30 23.0065 30 23.0033 30 23V14C30 12.3431 28.6569 11 27 11H14Z",
                fill: "#788598"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.5 20C14.6716 20 14 19.3284 14 18.5C14 17.6716 14.6716 17 15.5 17C16.3284 17 17 17.6716 17 18.5C17 19.3284 16.3284 20 15.5 20ZM20.5 20C19.6716 20 19 19.3284 19 18.5C19 17.6716 19.6716 17 20.5 17C21.3284 17 22 17.6716 22 18.5C22 19.3284 21.3284 20 20.5 20ZM25.5 20C24.6716 20 24 19.3284 24 18.5C24 17.6716 24.6716 17 25.5 17C26.3284 17 27 17.6716 27 18.5C27 19.3284 26.3284 20 25.5 20Z",
                fill: "#3E4758"
            })
        ]
    });
};
var $2ca8fce28d24f94c$export$2e2bcd8739ae039 = $2ca8fce28d24f94c$var$NoteIcon;

});

parcelRegister("cgWtX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6796a30ed4739a0b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $6796a30ed4739a0b$var$StarIcon = ({ className: className, width: width = "18", height: height = "16", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.86804 0.622956C9.54694 -0.149059 8.45329 -0.149059 8.13219 0.622956L6.3014 5.02472L1.54932 5.4057C0.715863 5.47251 0.377908 6.51263 1.01291 7.05658L4.63349 10.158L3.52735 14.7952C3.33334 15.6085 4.21812 16.2514 4.93167 15.8155L9.00011 13.3305L13.0686 15.8155C13.7821 16.2514 14.6669 15.6085 14.4729 14.7952L13.3667 10.158L16.9873 7.05658C17.6223 6.51263 17.2844 5.47251 16.4509 5.4057L11.6988 5.02472L9.86804 0.622956Z",
                    fill: "#1D8427"
                })
            })
        })
    });
};
var $6796a30ed4739a0b$export$2e2bcd8739ae039 = $6796a30ed4739a0b$var$StarIcon;

});

parcelRegister("5Pqi8", function(module, exports) {

$parcel$export(module.exports, "default", () => $40a66ac236e0d9c0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $40a66ac236e0d9c0$var$Padlock = ({ className: className, width: width = "16", height: height = "16", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M12.6667 7.33337H3.33333C2.59695 7.33337 2 7.93033 2 8.66671V13.3334C2 14.0698 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0698 14 13.3334V8.66671C14 7.93033 13.403 7.33337 12.6667 7.33337Z",
                        stroke: "#CBD5E1",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M4.66602 7.33337V4.66671C4.66602 3.78265 5.01721 2.93481 5.64233 2.30968C6.26745 1.68456 7.11529 1.33337 7.99935 1.33337C8.8834 1.33337 9.73125 1.68456 10.3564 2.30968C10.9815 2.93481 11.3327 3.78265 11.3327 4.66671V7.33337",
                        stroke: "#CBD5E1",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        })
    });
};
var $40a66ac236e0d9c0$export$2e2bcd8739ae039 = $40a66ac236e0d9c0$var$Padlock;

});

parcelRegister("jQxGd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3b2250ccc394a6e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $f3b2250ccc394a6e$var$PencilIcon = ({ className: className, width: width = "24", height: height = "24", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M4.36428 17.0123L3.10249 20.1668C2.93923 20.5749 3.34427 20.98 3.75243 20.8167L6.90689 19.5549C7.40986 19.3537 7.86671 19.0525 8.24976 18.6694L19.1689 7.75072C19.9974 6.92229 19.9974 5.57914 19.1689 4.75072C18.3405 3.92229 16.9974 3.92229 16.1689 4.75071L5.24976 15.6694C4.86671 16.0525 4.56546 16.5093 4.36428 17.0123Z",
                    fill: "currentColor"
                })
            })
        })
    });
};
var $f3b2250ccc394a6e$export$2e2bcd8739ae039 = $f3b2250ccc394a6e$var$PencilIcon;

});

parcelRegister("6uzQs", function(module, exports) {

$parcel$export(module.exports, "default", () => $2da9d6f2f3d06011$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $2da9d6f2f3d06011$var$RefreshIcon = ({ className: className, width: width = "24", height: height = "24", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "none",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M15.6705 9.34838H20.6631V9.3466M2.63184 19.6444V14.6517M2.63184 14.6517L7.62448 14.6517M2.63184 14.6517L5.81273 17.8347C6.80325 18.827 8.06031 19.58 9.51206 19.969C13.9132 21.1482 18.4369 18.5364 19.6162 14.1353M3.67843 9.86481C4.8577 5.46371 9.38148 2.85191 13.7826 4.03118C15.2343 4.42017 16.4914 5.17309 17.4819 6.16547L20.6631 9.3466M20.6631 4.35577V9.3466",
                    stroke: "#CBD5E1",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            })
        })
    });
};
var $2da9d6f2f3d06011$export$2e2bcd8739ae039 = $2da9d6f2f3d06011$var$RefreshIcon;

});

parcelRegister("lWtdl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9cd60df46706c2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $ba9cd60df46706c2$var$SearchIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11 5.5C7.96243 5.5 5.5 7.96243 5.5 11C5.5 14.0376 7.96243 16.5 11 16.5C12.519 16.5 13.893 15.8852 14.8891 14.8891C15.8852 13.893 16.5 12.519 16.5 11C16.5 7.96243 14.0376 5.5 11 5.5ZM4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11C18 12.6625 17.4197 14.1906 16.4517 15.3911L19.7803 18.7197C20.0732 19.0126 20.0732 19.4874 19.7803 19.7803C19.4874 20.0732 19.0126 20.0732 18.7197 19.7803L15.3911 16.4517C14.1906 17.4197 12.6625 18 11 18C7.13401 18 4 14.866 4 11Z",
                    fill: "#788598"
                })
            })
        })
    });
};
var $ba9cd60df46706c2$export$2e2bcd8739ae039 = $ba9cd60df46706c2$var$SearchIcon;

});

parcelRegister("gqcrB", function(module, exports) {

$parcel$export(module.exports, "default", () => $1976e06336ceb891$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $1976e06336ceb891$var$TripleDotIcon = ({ className: className, width: width = "25", height: height = "25", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M12.1523 13.5C12.7046 13.5 13.1523 13.0523 13.1523 12.5C13.1523 11.9477 12.7046 11.5 12.1523 11.5C11.6001 11.5 11.1523 11.9477 11.1523 12.5C11.1523 13.0523 11.6001 13.5 12.1523 13.5Z",
                        stroke: "#CBD5E1",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M19.1523 13.5C19.7046 13.5 20.1523 13.0523 20.1523 12.5C20.1523 11.9477 19.7046 11.5 19.1523 11.5C18.6001 11.5 18.1523 11.9477 18.1523 12.5C18.1523 13.0523 18.6001 13.5 19.1523 13.5Z",
                        stroke: "#CBD5E1",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M5.15234 13.5C5.70463 13.5 6.15234 13.0523 6.15234 12.5C6.15234 11.9477 5.70463 11.5 5.15234 11.5C4.60006 11.5 4.15234 11.9477 4.15234 12.5C4.15234 13.0523 4.60006 13.5 5.15234 13.5Z",
                        stroke: "#CBD5E1",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        })
    });
};
var $1976e06336ceb891$export$2e2bcd8739ae039 = $1976e06336ceb891$var$TripleDotIcon;

});

parcelRegister("fGo7U", function(module, exports) {

$parcel$export(module.exports, "default", () => $729192fc39ff9f35$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $729192fc39ff9f35$var$UserIcon = ({ className: className, width: width = "25", height: height = "25", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M12.1692 10.25C13.826 10.25 15.1692 8.90685 15.1692 7.25C15.1692 5.59315 13.826 4.25 12.1692 4.25C10.5123 4.25 9.16919 5.59315 9.16919 7.25C9.16919 8.90685 10.5123 10.25 12.1692 10.25Z",
                        fill: "#788598"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M5.63436 16.7435C5.43948 17.2516 5.61354 17.821 6.04339 18.1546C7.73575 19.468 9.86121 20.25 12.1693 20.25C14.4798 20.25 16.6072 19.4664 18.3004 18.1506C18.73 17.8167 18.9037 17.2471 18.7085 16.7392C17.6993 14.1135 15.1534 12.25 12.1723 12.25C9.18951 12.25 6.64248 14.1156 5.63436 16.7435Z",
                        fill: "#788598"
                    })
                ]
            })
        })
    });
};
var $729192fc39ff9f35$export$2e2bcd8739ae039 = $729192fc39ff9f35$var$UserIcon;

});

parcelRegister("5yov4", function(module, exports) {

$parcel$export(module.exports, "default", () => $14703dcb72506853$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $14703dcb72506853$var$VerifyEmail = ({ className: className, width: width = "200", height: height = "200" })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "currentColor",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "142.4",
                cy: "80.8",
                r: "27.2",
                fill: "#343E4F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "49.1996",
                cy: "161.2",
                r: "11.6",
                fill: "#343E4F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "30.7993",
                cy: "44.4",
                r: "6",
                fill: "#343E4F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "92.225",
                cy: "100",
                r: "61.6",
                fill: "#1F2630"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M90.4212 111.083C91.9499 112.482 94.2942 112.482 95.8229 111.083L125.446 83.9656C126.721 82.7988 127.001 81.1785 126.556 79.7959C127.89 81.2253 128.707 83.1442 128.707 85.2538V116.541C128.707 120.959 125.125 124.541 120.707 124.541H65.5376C61.1193 124.541 57.5376 120.959 57.5376 116.541V85.2538C57.5376 83.1442 58.3542 81.2253 59.6886 79.7959C59.2428 81.1785 59.523 82.7988 60.7977 83.9656L90.4212 111.083Z",
                fill: "#404D64"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M90.5318 111.082C92.0605 112.482 94.4048 112.482 95.9335 111.082L125.557 83.9654C126.832 82.7986 127.112 81.1783 126.666 79.7957C125.206 78.2316 123.126 77.2537 120.817 77.2537H65.6482C63.3396 77.2537 61.2594 78.2316 59.7992 79.7957C59.3534 81.1784 59.6336 82.7986 60.9083 83.9654L90.5318 111.082Z",
                fill: "#546686"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "60.7997",
                cy: "82.4",
                r: "9.6",
                fill: "#2042F6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M62.3439 78.0909V87.4H59.8167V80.4182H59.7621L57.7257 81.6364V79.4909L60.0167 78.0909H62.3439Z",
                fill: "white"
            })
        ]
    });
};
var $14703dcb72506853$export$2e2bcd8739ae039 = $14703dcb72506853$var$VerifyEmail;

});

parcelRegister("fCOh8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d061c4d39f9c0d43$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $d061c4d39f9c0d43$var$FinancialGrowth = ({ className: className, width: width = "200", height: height = "200" })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#clip0_1319_21753)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "200",
                        height: "200",
                        transform: "translate(0.320312)",
                        fill: "#12181E"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        clipPath: "url(#clip1_1319_21753)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                clipPath: "url(#clip2_1319_21753)",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "87.8203",
                                        cy: "56.5",
                                        r: "1.5",
                                        fill: "#AEC3FC"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "96.8203",
                                        cy: "56.5",
                                        r: "1.5",
                                        fill: "#AEC3FC"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "105.82",
                                        cy: "56.5",
                                        r: "1.5",
                                        fill: "#AEC3FC"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                clipPath: "url(#clip3_1319_21753)",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "87.8203",
                                        cy: "65.5",
                                        r: "1.5",
                                        fill: "#AEC3FC"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "96.8203",
                                        cy: "65.5",
                                        r: "1.5",
                                        fill: "#AEC3FC"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "105.82",
                                        cy: "65.5",
                                        r: "1.5",
                                        fill: "#AEC3FC"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                clipPath: "url(#clip4_1319_21753)",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "87.8203",
                                        cy: "74.5",
                                        r: "1.5",
                                        fill: "#AEC3FC"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "96.8203",
                                        cy: "74.5",
                                        r: "1.5",
                                        fill: "#AEC3FC"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "105.82",
                                        cy: "74.5",
                                        r: "1.5",
                                        fill: "#AEC3FC"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                clipPath: "url(#clip5_1319_21753)",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "87.8203",
                                        cy: "83.5",
                                        r: "1.5",
                                        fill: "#AEC3FC"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "96.8203",
                                        cy: "83.5",
                                        r: "1.5",
                                        fill: "#AEC3FC"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "105.82",
                                        cy: "83.5",
                                        r: "1.5",
                                        fill: "#AEC3FC"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                clipPath: "url(#clip6_1319_21753)",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "87.8203",
                                        cy: "92.5",
                                        r: "1.5",
                                        fill: "#AEC3FC"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "96.8203",
                                        cy: "92.5",
                                        r: "1.5",
                                        fill: "#AEC3FC"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                clipPath: "url(#clip7_1319_21753)",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                    cx: "87.8203",
                                    cy: "101.5",
                                    r: "1.5",
                                    fill: "#AEC3FC"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "120.32",
                        y: "36",
                        width: "25",
                        height: "91",
                        fill: "#4A66F4"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "120.32",
                        y: "36",
                        width: "25",
                        height: "91",
                        fill: "url(#pattern0)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M42.99 58.4909C46.9055 57.2875 50.391 55.9787 53.1503 54.7058C50.1736 54.9838 46.5711 55.5831 42.6556 56.4821C45.4459 53.476 47.8133 50.5946 49.5692 48.1064C47.1301 49.8395 44.3087 52.1672 41.3655 54.9095C42.2853 50.9063 42.8993 47.2218 43.1788 44.187C41.9293 46.9126 40.6465 50.3429 39.4639 54.1952C38.2647 50.2662 36.9603 46.7687 35.6918 44C35.9976 47.3009 36.6999 51.3737 37.7582 55.7869C34.2918 52.438 30.933 49.6142 28.0901 47.5958C29.9391 50.2135 32.4691 53.2723 35.4529 56.4485C31.2937 55.4681 27.457 54.8136 24.3203 54.5212C27.2253 55.8612 30.9401 57.2396 35.1089 58.4933C31.0166 59.7326 27.371 61.0894 24.509 62.4103C27.6935 62.113 31.5971 61.4418 35.8303 60.4374C32.9038 63.5633 30.4217 66.5694 28.6013 69.1463C31.2101 67.2909 34.2584 64.7523 37.4238 61.7582C36.4467 65.9341 35.7945 69.7816 35.503 72.9291C36.8385 70.0141 38.2121 66.2865 39.4615 62.1034C40.6966 66.2098 42.0488 69.8679 43.3651 72.7397C43.0975 69.8487 42.5266 66.368 41.6785 62.5853C44.3231 64.9968 46.8482 67.0632 49.058 68.6333C47.3308 66.1858 45.0111 63.3548 42.2781 60.4015C46.2677 61.3244 49.9395 61.9404 52.9639 62.2209C50.2477 60.9672 46.8291 59.6775 42.99 58.4909Z",
                        fill: "#FF6B6B"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "181.554",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "181.554",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "181.554",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "181.554",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "181.554",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "181.554",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 181.554C109.379 182.03 108.993 182.415 108.518 182.415C108.042 182.415 107.656 182.03 107.656 181.554C107.656 181.078 108.042 180.693 108.518 180.693C108.993 180.693 109.379 181.078 109.379 181.554Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 181.554C112.824 182.03 112.439 182.415 111.963 182.415C111.487 182.415 111.102 182.03 111.102 181.554C111.102 181.078 111.487 180.693 111.963 180.693C112.439 180.693 112.824 181.078 112.824 181.554Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "178.108",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "178.108",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "178.108",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "178.108",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "178.108",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "178.108",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 178.108C109.379 178.584 108.993 178.97 108.518 178.97C108.042 178.97 107.656 178.584 107.656 178.108C107.656 177.633 108.042 177.247 108.518 177.247C108.993 177.247 109.379 177.633 109.379 178.108Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 178.108C112.824 178.584 112.439 178.97 111.963 178.97C111.487 178.97 111.102 178.584 111.102 178.108C111.102 177.633 111.487 177.247 111.963 177.247C112.439 177.247 112.824 177.633 112.824 178.108Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "174.663",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "174.663",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "174.663",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "174.663",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "174.663",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "174.663",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 174.663C109.379 175.138 108.993 175.524 108.518 175.524C108.042 175.524 107.656 175.138 107.656 174.663C107.656 174.187 108.042 173.801 108.518 173.801C108.993 173.801 109.379 174.187 109.379 174.663Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 174.663C112.824 175.138 112.439 175.524 111.963 175.524C111.487 175.524 111.102 175.138 111.102 174.663C111.102 174.187 111.487 173.801 111.963 173.801C112.439 173.801 112.824 174.187 112.824 174.663Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "171.218",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "171.218",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "171.218",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "171.218",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "171.218",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "171.218",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 171.218C109.379 171.693 108.993 172.079 108.518 172.079C108.042 172.079 107.656 171.693 107.656 171.218C107.656 170.742 108.042 170.356 108.518 170.356C108.993 170.356 109.379 170.742 109.379 171.218Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 171.218C112.824 171.693 112.439 172.079 111.963 172.079C111.487 172.079 111.102 171.693 111.102 171.218C111.102 170.742 111.487 170.356 111.963 170.356C112.439 170.356 112.824 170.742 112.824 171.218Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "167.773",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "167.772",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "167.772",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "167.772",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "167.772",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "167.772",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 167.772C109.379 168.248 108.993 168.633 108.518 168.633C108.042 168.633 107.656 168.248 107.656 167.772C107.656 167.296 108.042 166.911 108.518 166.911C108.993 166.911 109.379 167.296 109.379 167.772Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 167.772C112.824 168.248 112.439 168.633 111.963 168.633C111.487 168.633 111.102 168.248 111.102 167.772C111.102 167.296 111.487 166.911 111.963 166.911C112.439 166.911 112.824 167.296 112.824 167.772Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "164.327",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "164.327",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "164.327",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "164.327",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "164.327",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "164.327",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 164.327C109.379 164.802 108.993 165.188 108.518 165.188C108.042 165.188 107.656 164.802 107.656 164.327C107.656 163.851 108.042 163.465 108.518 163.465C108.993 163.465 109.379 163.851 109.379 164.327Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 164.327C112.824 164.802 112.439 165.188 111.963 165.188C111.487 165.188 111.102 164.802 111.102 164.327C111.102 163.851 111.487 163.465 111.963 163.465C112.439 163.465 112.824 163.851 112.824 164.327Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "160.882",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "160.881",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "160.881",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "160.881",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "160.881",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "160.881",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 160.881C109.379 161.357 108.993 161.742 108.518 161.742C108.042 161.742 107.656 161.357 107.656 160.881C107.656 160.405 108.042 160.02 108.518 160.02C108.993 160.02 109.379 160.405 109.379 160.881Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 160.881C112.824 161.357 112.439 161.742 111.963 161.742C111.487 161.742 111.102 161.357 111.102 160.881C111.102 160.405 111.487 160.02 111.963 160.02C112.439 160.02 112.824 160.405 112.824 160.881Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "157.436",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "157.436",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "157.436",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "157.436",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "157.436",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "157.436",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 157.436C109.379 157.911 108.993 158.297 108.518 158.297C108.042 158.297 107.656 157.911 107.656 157.436C107.656 156.96 108.042 156.574 108.518 156.574C108.993 156.574 109.379 156.96 109.379 157.436Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 157.436C112.824 157.911 112.439 158.297 111.963 158.297C111.487 158.297 111.102 157.911 111.102 157.436C111.102 156.96 111.487 156.574 111.963 156.574C112.439 156.574 112.824 156.96 112.824 157.436Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "153.99",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "153.99",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "153.99",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "153.99",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "153.99",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "153.99",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 153.99C109.379 154.466 108.993 154.851 108.518 154.851C108.042 154.851 107.656 154.466 107.656 153.99C107.656 153.514 108.042 153.128 108.518 153.128C108.993 153.128 109.379 153.514 109.379 153.99Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 153.99C112.824 154.466 112.439 154.851 111.963 154.851C111.487 154.851 111.102 154.466 111.102 153.99C111.102 153.514 111.487 153.128 111.963 153.128C112.439 153.128 112.824 153.514 112.824 153.99Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "150.544",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "150.544",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "150.544",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "150.544",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "150.544",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "150.544",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 150.544C109.379 151.02 108.993 151.405 108.518 151.405C108.042 151.405 107.656 151.02 107.656 150.544C107.656 150.068 108.042 149.683 108.518 149.683C108.993 149.683 109.379 150.068 109.379 150.544Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 150.544C112.824 151.02 112.439 151.405 111.963 151.405C111.487 151.405 111.102 151.02 111.102 150.544C111.102 150.068 111.487 149.683 111.963 149.683C112.439 149.683 112.824 150.068 112.824 150.544Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "147.1",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "147.099",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "147.099",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "147.099",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "147.099",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "147.099",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 147.099C109.379 147.574 108.993 147.96 108.518 147.96C108.042 147.96 107.656 147.574 107.656 147.099C107.656 146.623 108.042 146.237 108.518 146.237C108.993 146.237 109.379 146.623 109.379 147.099Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 147.099C112.824 147.574 112.439 147.96 111.963 147.96C111.487 147.96 111.102 147.574 111.102 147.099C111.102 146.623 111.487 146.237 111.963 146.237C112.439 146.237 112.824 146.623 112.824 147.099Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "143.653",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "143.653",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "143.653",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "143.653",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "143.653",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "143.653",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.381 143.653C109.381 144.129 108.995 144.515 108.52 144.515C108.044 144.515 107.658 144.129 107.658 143.653C107.658 143.177 108.044 142.792 108.52 142.792C108.995 142.792 109.381 143.177 109.381 143.653Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 143.653C112.824 144.129 112.439 144.515 111.963 144.515C111.487 144.515 111.102 144.129 111.102 143.653C111.102 143.177 111.487 142.792 111.963 142.792C112.439 142.792 112.824 143.177 112.824 143.653Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "140.208",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "140.208",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "140.208",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "140.208",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "140.208",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "140.208",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 140.208C109.379 140.684 108.993 141.07 108.518 141.07C108.042 141.07 107.656 140.684 107.656 140.208C107.656 139.732 108.042 139.347 108.518 139.347C108.993 139.347 109.379 139.732 109.379 140.208Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 140.208C112.824 140.684 112.439 141.07 111.963 141.07C111.487 141.07 111.102 140.684 111.102 140.208C111.102 139.732 111.487 139.347 111.963 139.347C112.439 139.347 112.824 139.732 112.824 140.208Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "136.763",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "136.762",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "136.762",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "136.762",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "136.762",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "136.762",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 136.763C109.379 137.238 108.993 137.624 108.518 137.624C108.042 137.624 107.656 137.238 107.656 136.763C107.656 136.287 108.042 135.901 108.518 135.901C108.993 135.901 109.379 136.287 109.379 136.763Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 136.763C112.824 137.238 112.439 137.624 111.963 137.624C111.487 137.624 111.102 137.238 111.102 136.763C111.102 136.287 111.487 135.901 111.963 135.901C112.439 135.901 112.824 136.287 112.824 136.763Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "133.317",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "133.317",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "133.317",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "133.317",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "133.317",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "133.317",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 133.317C109.379 133.793 108.993 134.178 108.518 134.178C108.042 134.178 107.656 133.793 107.656 133.317C107.656 132.841 108.042 132.456 108.518 132.456C108.993 132.456 109.379 132.841 109.379 133.317Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 133.317C112.824 133.793 112.439 134.178 111.963 134.178C111.487 134.178 111.102 133.793 111.102 133.317C111.102 132.841 111.487 132.456 111.963 132.456C112.439 132.456 112.824 132.841 112.824 133.317Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "129.872",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "129.871",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "129.871",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "129.871",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "129.871",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "129.871",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 129.871C109.379 130.347 108.993 130.733 108.518 130.733C108.042 130.733 107.656 130.347 107.656 129.871C107.656 129.395 108.042 129.01 108.518 129.01C108.993 129.01 109.379 129.395 109.379 129.871Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 129.871C112.824 130.347 112.439 130.733 111.963 130.733C111.487 130.733 111.102 130.347 111.102 129.871C111.102 129.395 111.487 129.01 111.963 129.01C112.439 129.01 112.824 129.395 112.824 129.871Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "126.426",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "126.425",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "126.425",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "126.425",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "126.425",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "126.425",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 126.425C109.379 126.901 108.993 127.287 108.518 127.287C108.042 127.287 107.656 126.901 107.656 126.425C107.656 125.95 108.042 125.564 108.518 125.564C108.993 125.564 109.379 125.95 109.379 126.425Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 126.425C112.824 126.901 112.439 127.287 111.963 127.287C111.487 127.287 111.102 126.901 111.102 126.425C111.102 125.95 111.487 125.564 111.963 125.564C112.439 125.564 112.824 125.95 112.824 126.425Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "87.8458",
                        cy: "122.98",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "91.2911",
                        cy: "122.98",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "94.7364",
                        cy: "122.98",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "98.1817",
                        cy: "122.98",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "101.627",
                        cy: "122.98",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "105.072",
                        cy: "122.98",
                        r: "0.86138",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M109.379 122.98C109.379 123.456 108.993 123.842 108.518 123.842C108.042 123.842 107.656 123.456 107.656 122.98C107.656 122.504 108.042 122.119 108.518 122.119C108.993 122.119 109.379 122.504 109.379 122.98Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.824 122.98C112.824 123.456 112.439 123.842 111.963 123.842C111.487 123.842 111.102 123.456 111.102 122.98C111.102 122.504 111.487 122.119 111.963 122.119C112.439 122.119 112.824 122.504 112.824 122.98Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M121.829 162.031H35.3438V182.719H121.829V162.031Z",
                        fill: "#2841ED"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M121.825 183.752H35.3399C34.769 183.752 34.3203 183.298 34.3203 182.721V162.032C34.3203 161.455 34.769 161.001 35.3399 161.001H121.825C122.396 161.001 122.845 161.455 122.845 162.032V182.721C122.845 183.278 122.376 183.752 121.825 183.752ZM36.3596 181.689H120.806V163.064H36.3596V181.689Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M107.305 183.751C106.734 183.751 106.285 183.297 106.285 182.72V162.031C106.285 161.454 106.734 161 107.305 161C107.876 161 108.324 161.454 108.324 162.031V182.72C108.324 183.277 107.855 183.751 107.305 183.751Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M92.9259 183.751C92.3549 183.751 91.9062 183.297 91.9062 182.72V162.031C91.9062 161.454 92.3549 161 92.9259 161C93.4969 161 93.9455 161.454 93.9455 162.031V182.72C93.9455 183.277 93.4969 183.751 92.9259 183.751Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M78.5743 183.751C78.0033 183.751 77.5547 183.297 77.5547 182.72V162.031C77.5547 161.454 78.0033 161 78.5743 161C79.1453 161 79.594 161.454 79.594 162.031V182.72C79.594 183.277 79.1453 183.751 78.5743 183.751Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M64.2149 183.751C63.644 183.751 63.1953 183.297 63.1953 182.72V162.031C63.1953 161.454 63.644 161 64.2149 161C64.7859 161 65.2346 161.454 65.2346 162.031V182.72C65.2346 183.277 64.7859 183.751 64.2149 183.751Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M49.8595 183.751C49.2885 183.751 48.8398 183.297 48.8398 182.72V162.031C48.8398 161.454 49.2885 161 49.8595 161C50.4305 161 50.8791 161.454 50.8791 162.031V182.72C50.8791 183.277 50.4305 183.751 49.8595 183.751Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M121.824 161H107.222C106.917 161 106.631 161.144 106.427 161.371C106.244 161.619 106.162 161.928 106.223 162.237C107.997 171.128 113.503 178.821 121.334 183.359C121.497 183.442 121.66 183.504 121.844 183.504C122.028 183.504 122.191 183.462 122.354 183.359C122.66 183.173 122.864 182.843 122.864 182.472V162.052C122.843 161.454 122.374 161 121.824 161Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M157.077 137.732C157.077 162.621 156.031 182.85 136.15 183.443C135.863 183.443 120.634 183.463 120.347 183.463C100.055 183.463 83.6172 162.988 83.6172 137.753C83.6172 112.517 100.055 92.0422 120.347 92.0422C120.429 92.0422 136.293 92.0422 136.396 92.0422C156.564 92.1853 157.077 112.578 157.077 137.732Z",
                        fill: "#1026E0"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M120.344 184.464C110.219 184.464 100.709 179.581 93.576 170.692C86.4842 161.885 82.5898 150.176 82.5898 137.732C82.5898 125.288 86.4842 113.579 93.576 104.772C100.709 95.8837 110.219 91 120.344 91C120.508 91 136.291 91 136.393 91C141.517 91.0409 145.576 92.3282 148.773 94.9029C151.684 97.2527 153.795 100.604 155.271 105.201C157.894 113.375 158.099 124.307 158.099 137.732C158.099 149.911 157.874 161.537 155.045 170.018C151.909 179.458 145.74 184.178 136.188 184.444C135.86 184.464 120.508 184.464 120.344 184.464ZM120.344 93.0229C100.647 93.0229 84.6395 113.069 84.6395 137.712C84.6395 162.355 100.647 182.4 120.344 182.4C121.103 182.4 135.696 182.4 136.127 182.38C154.635 181.849 156.049 163.52 156.049 137.691C156.049 124.43 155.844 113.682 153.323 105.774C150.556 97.1301 145.166 93.0638 136.393 92.9821C136.188 93.0229 121.636 93.0229 120.344 93.0229Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M124.093 94.474C123.909 94.1062 123.499 93.8814 123.089 93.9223C122.372 93.9836 105.401 95.5365 98.9032 99.2759C92.3238 103.056 86.6463 116.645 86.4003 117.217C86.2773 117.523 86.2978 117.891 86.5028 118.177C86.6873 118.463 87.0152 118.627 87.3637 118.627H103.166C103.453 118.627 103.74 118.504 103.945 118.279L123.95 95.6183C124.216 95.2913 124.278 94.8418 124.093 94.474Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M132.129 97.3754H104.705C104.131 97.3754 103.68 96.9259 103.68 96.3537C103.68 95.7816 104.131 95.332 104.705 95.332H132.129C132.703 95.332 133.154 95.7816 133.154 96.3537C133.154 96.9259 132.682 97.3754 132.129 97.3754Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M122.495 106.489H95.2553C94.6814 106.489 94.2305 106.04 94.2305 105.468C94.2305 104.895 94.6814 104.446 95.2553 104.446H122.475C123.049 104.446 123.5 104.895 123.5 105.468C123.5 106.04 123.049 106.489 122.495 106.489Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M115.73 118.607H88.4897C87.9158 118.607 87.4648 118.157 87.4648 117.585C87.4648 117.013 87.9158 116.563 88.4897 116.563H115.73C116.303 116.563 116.754 117.013 116.754 117.585C116.754 118.157 116.283 118.607 115.73 118.607Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.042 131.909H84.7201C84.1462 131.909 83.6953 131.459 83.6953 130.887C83.6953 130.315 84.1462 129.866 84.7201 129.866H112.042C112.616 129.866 113.067 130.315 113.067 130.887C113.067 131.459 112.595 131.909 112.042 131.909Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M132.129 180.112H104.705C104.131 180.112 103.68 179.662 103.68 179.09C103.68 178.518 104.131 178.068 104.705 178.068H132.129C132.703 178.068 133.154 178.518 133.154 179.09C133.154 179.662 132.682 180.112 132.129 180.112Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M122.495 171.672H95.2553C94.6814 171.672 94.2305 171.223 94.2305 170.65C94.2305 170.078 94.6814 169.629 95.2553 169.629H122.475C123.049 169.629 123.5 170.078 123.5 170.65C123.5 171.223 123.049 171.672 122.495 171.672Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M115.73 160.434H88.4897C87.9158 160.434 87.4648 159.984 87.4648 159.412C87.4648 158.84 87.9158 158.39 88.4897 158.39H115.73C116.303 158.39 116.754 158.84 116.754 159.412C116.754 159.984 116.283 160.434 115.73 160.434Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M112.042 148.112H84.7201C84.1462 148.112 83.6953 147.663 83.6953 147.091C83.6953 146.518 84.1462 146.069 84.7201 146.069H112.042C112.616 146.069 113.067 146.518 113.067 147.091C113.067 147.663 112.595 148.112 112.042 148.112Z",
                        fill: "#0C1014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M136.148 183.443C156.433 183.443 172.878 162.978 172.878 137.732C172.878 112.487 156.433 92.022 136.148 92.022C115.862 92.022 99.418 112.487 99.418 137.732C99.418 162.978 115.862 183.443 136.148 183.443Z",
                        fill: "#AEC3FC"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M107.977 108.523C102.634 116.461 99.418 126.691 99.418 137.855C99.418 163.1 115.862 183.566 136.148 183.566C144.011 183.566 151.297 180.491 157.271 175.254C155.675 174.456 154.11 173.495 152.575 172.341C144.07 165.931 136.392 153.708 127.674 132.649C122.117 119.204 115.136 112.529 107.977 108.523Z",
                        fill: "#92ABFA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M136.152 172.919C151.774 172.919 164.438 157.166 164.438 137.732C164.438 118.299 151.774 102.545 136.152 102.545C120.531 102.545 107.867 118.299 107.867 137.732C107.867 157.166 120.531 172.919 136.152 172.919Z",
                        fill: "#EBF1FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M139.059 114.725V119.616C142.639 120.046 145.325 121.385 147.927 123.351L145.275 129.019C143.534 127.697 141.429 126.59 139.059 126.127V134.572C144.264 135.58 148.308 138.439 148.209 144.471C148.076 151.015 144.065 154.552 139.092 155.461V160.7H134.368V155.593C130.605 155.196 126.825 153.693 124.223 151.148L127.14 145.529C128.848 147.148 131.433 148.619 134.351 149.131V140.604L134.119 140.554C128.914 139.53 125.151 136.721 125.25 130.424C125.333 124.442 129.113 120.575 134.351 119.682V114.725H139.059ZM134.334 133.581V126.276C132.362 126.855 131.119 128.177 131.085 130.094C131.052 131.945 132.246 132.92 134.334 133.581ZM139.059 141.629V148.95C141.015 148.371 142.308 147.066 142.357 145.083C142.374 143.347 141.197 142.306 139.059 141.629Z",
                        fill: "#1026E0"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("pattern", {
                        id: "pattern0",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("use", {
                            xlinkHref: "#image0_1319_21753",
                            transform: "matrix(0.00808889 0 0 0.00222222 -1.32 0)"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip0_1319_21753",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "200",
                            height: "200",
                            fill: "white",
                            transform: "translate(0.320312)"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip1_1319_21753",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "24",
                            height: "60",
                            fill: "white",
                            transform: "translate(86.3203 55)"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip2_1319_21753",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "24",
                            height: "9",
                            fill: "white",
                            transform: "translate(86.3203 55)"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip3_1319_21753",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "24",
                            height: "9",
                            fill: "white",
                            transform: "translate(86.3203 64)"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip4_1319_21753",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "24",
                            height: "9",
                            fill: "white",
                            transform: "translate(86.3203 73)"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip5_1319_21753",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "24",
                            height: "9",
                            fill: "white",
                            transform: "translate(86.3203 82)"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip6_1319_21753",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "24",
                            height: "9",
                            fill: "white",
                            transform: "translate(86.3203 91)"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip7_1319_21753",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "24",
                            height: "9",
                            fill: "white",
                            transform: "translate(86.3203 100)"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("image", {
                        id: "image0_1319_21753",
                        width: "450",
                        height: "450",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
};
var $d061c4d39f9c0d43$export$2e2bcd8739ae039 = $d061c4d39f9c0d43$var$FinancialGrowth;

});

parcelRegister("4vExK", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb9a42a6f88e7445$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $cb9a42a6f88e7445$var$UnsupportedCountry = ({ className: className, width: width = "186", height: height = "186" })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "currentColor",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": "Unsupported country image",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#clip0_1652_22981)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M151.497 34.6601C119.399 2.42181 67.2399 2.30949 35.0016 34.4073C2.76337 66.5052 2.65104 118.664 34.7489 150.902C34.8331 150.987 34.9174 151.071 35.0016 151.155C67.0995 183.394 119.259 183.506 151.497 151.408C183.735 119.31 183.847 67.1511 151.75 34.9128C151.665 34.8286 151.581 34.7443 151.497 34.6601Z",
                        fill: "#48536B"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M99.8048 107.003L89.9445 102.071C89.6426 101.924 89.453 101.615 89.4565 101.282C89.4495 96.662 85.704 92.9166 81.0845 92.9096H80.1403C79.9051 92.9096 79.6804 92.8148 79.5155 92.6498L78.4834 91.6178C76.9179 90.0417 74.7836 89.1606 72.5616 89.1641H66.1062C62.933 89.1536 60.0265 90.9473 58.6188 93.7906L56.8427 97.3395C56.7584 97.5115 56.618 97.6484 56.446 97.7362L52.8971 99.5124C50.0538 100.923 48.2565 103.826 48.2706 107V110.226C48.2706 111.879 48.7585 113.494 49.6782 114.87L55.7088 123.912C56.5162 125.123 57.629 126.103 58.9313 126.756L62.761 128.672C63.0628 128.82 63.2524 129.128 63.2489 129.462V144.23C63.2489 145.528 63.5543 146.81 64.1335 147.975L67.054 153.816C67.4577 154.62 67.9842 155.357 68.6231 155.993L73.2215 160.591C75.77 163.143 79.6629 163.775 82.8853 162.16L85.3636 160.921C87.6803 159.773 89.3302 157.611 89.8286 155.073L92.8545 139.944C92.8896 139.772 92.9738 139.614 93.0967 139.491L98.8219 133.766C99.7381 132.846 100.433 131.726 100.844 130.494L104.003 121.013C104.287 120.16 104.435 119.265 104.435 118.362V114.487C104.445 111.314 102.652 108.407 99.8083 107L99.8048 107.003Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M138.148 33.0106C136.705 33.0632 135.29 33.4213 133.995 34.0637L127.266 37.4265C126.301 37.9109 125.42 38.5498 124.654 39.315L118.255 45.7142C116.36 47.6063 115.296 50.1758 115.296 52.8576C115.303 58.4319 119.821 62.9496 125.395 62.9567H126.525C128.094 62.9567 129.642 62.5881 131.046 61.8895L137.344 58.7373C137.709 58.5583 138.109 58.4635 138.516 58.4635H143.371C144.063 58.4635 144.726 58.7408 145.217 59.2288L145.99 60.001C147.889 61.8895 150.455 62.9531 153.13 62.9602H161.881L169.214 60.8154C166.268 53.8791 162.33 47.2623 157.395 41.186C155.639 39.0237 153.758 36.9315 151.754 34.9167C151.669 34.8324 151.585 34.7482 151.501 34.6639C150.139 33.2949 148.742 31.9856 147.31 30.7324",
                        fill: "#1B222B"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M99.8048 107.004L89.9445 102.072C89.6426 101.924 89.453 101.616 89.4565 101.282C89.4495 96.6625 85.704 92.9171 81.0845 92.91H80.1403C79.9051 92.91 79.6804 92.8153 79.5155 92.6503L78.4834 91.6183C76.9179 90.0422 74.7836 89.1611 72.5616 89.1646H66.1062C62.933 89.1541 60.0265 90.9478 58.6188 93.7911L56.8427 97.34C56.7584 97.512 56.618 97.6489 56.446 97.7367L52.8971 99.5129C50.0538 100.924 48.2565 103.827 48.2706 107V110.226C48.2706 111.88 48.7585 113.494 49.6782 114.87L55.7088 123.913C56.5162 125.124 57.629 126.103 58.9313 126.756L62.761 128.673C63.0628 128.82 63.2524 129.129 63.2489 129.462V144.23C63.2489 145.529 63.5543 146.81 64.1335 147.976L67.054 153.817C67.4577 154.621 67.9842 155.358 68.6231 155.993L73.2215 160.591C75.77 163.143 79.6629 163.775 82.8853 162.161L85.3636 160.921C87.6803 159.774 89.3302 157.611 89.8286 155.073L92.8545 139.944C92.8896 139.772 92.9738 139.614 93.0967 139.491L98.8219 133.766C99.7381 132.846 100.433 131.727 100.844 130.494L104.003 121.013C104.287 120.16 104.435 119.265 104.435 118.363V114.488C104.445 111.314 102.652 108.408 99.8083 107L99.8048 107.004Z",
                        fill: "#1B222B"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M151.498 151.409C162.597 140.358 169.888 126.928 173.37 112.75C176.684 99.2531 176.54 85.0786 172.938 71.6343L164.808 70.8164H150.581C150.178 70.8164 149.777 70.7497 149.395 70.6234L141.381 67.952C139.356 67.2781 137.179 67.1938 135.105 67.7134L123.493 70.6163C122.246 70.9288 121.064 71.4518 119.996 72.1644L113.179 76.7102C110.048 78.7882 108.17 82.2985 108.174 86.058V92.0641C108.174 93.2716 108.37 94.4721 108.753 95.6165L110.403 100.573C111.926 105.164 116.223 108.264 121.064 108.257H121.386C123.131 108.257 124.848 107.85 126.406 107.07L128.969 105.789C130.819 104.866 133.069 105.617 133.992 107.467C134.252 107.987 134.385 108.559 134.385 109.141V110.233C134.385 111.978 134.792 113.694 135.571 115.253L141.483 127.075C141.742 127.595 141.876 128.164 141.876 128.743V136.992C141.876 138.199 142.072 139.4 142.455 140.548C142.48 140.622 142.504 140.692 142.536 140.765L145.035 146.951L151.501 151.405L151.498 151.409Z",
                        fill: "#1B222B"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M53.7435 20.4053C47.0214 24.0665 40.7029 28.7351 35.0022 34.4077C24.9277 44.4401 17.9915 56.4276 14.1934 69.1558L20.9682 73.319C21.6316 73.5788 22.3161 73.7788 23.0147 73.9193L25.191 80.4484C25.9914 82.8529 27.6236 84.8888 29.7965 86.1947L41.7489 93.3626C45.9191 95.876 51.2653 95.2195 54.7018 91.769L54.9054 91.5654C58.1384 88.3394 58.9387 83.4075 56.8957 79.3251C56.4534 78.4475 56.4534 77.4155 56.8957 76.5379L58.2858 73.7543C58.5315 73.2664 58.8966 72.8521 59.3494 72.5503L68.7113 66.309C68.8201 66.2388 68.9324 66.1721 69.0483 66.1159L87.3367 56.9717C90.9418 55.1885 93.2164 51.5097 93.2024 47.487V47.3536C93.1954 41.502 88.453 36.7561 82.6014 36.7491H74.9771C73.7941 36.7491 72.7165 36.0821 72.1935 35.022L71.1263 32.8948C70.3295 31.3082 69.1501 29.9427 67.6933 28.9282L61.9084 24.9125L53.747 20.4123L53.7435 20.4053Z",
                        fill: "#1B222B"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M137.792 59.3061C137.825 59.3246 137.851 59.3389 137.869 59.3489L137.899 59.3654C138.14 59.4947 138.439 59.4937 138.68 59.3658L138.711 59.3489C138.729 59.3389 138.755 59.3246 138.788 59.3061C138.853 59.2691 138.946 59.2152 139.064 59.1445C139.298 59.0033 139.629 58.795 140.025 58.5218C140.814 57.9763 141.868 57.1669 142.924 56.1097C145.026 54.0054 147.209 50.8439 147.209 46.778C147.209 41.9613 143.216 38.0566 138.29 38.0566C133.364 38.0566 129.371 41.9613 129.371 46.778C129.371 50.8439 131.554 54.0054 133.656 56.1097C134.712 57.1669 135.766 57.9763 136.555 58.5218C136.951 58.795 137.282 59.0033 137.516 59.1445C137.634 59.2152 137.727 59.2691 137.792 59.3061ZM138.29 49.9494C140.081 49.9494 141.533 48.5295 141.533 46.778C141.533 45.0265 140.081 43.6066 138.29 43.6066C136.499 43.6066 135.047 45.0265 135.047 46.778C135.047 48.5295 136.499 49.9494 138.29 49.9494Z",
                fill: "#8C9FB6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M65.5503 67.333C65.5829 67.3515 65.6086 67.3657 65.6267 67.3758L65.6569 67.3922C65.8979 67.5216 66.1968 67.5206 66.4379 67.3926L66.4689 67.3758C66.4871 67.3657 66.5127 67.3515 66.5454 67.333C66.6107 67.296 66.704 67.242 66.8213 67.1714C67.0559 67.0301 67.387 66.8219 67.7825 66.5487C68.5722 66.0031 69.6259 65.1938 70.6819 64.1365C72.7837 62.0323 74.9667 58.8707 74.9667 54.8048C74.9667 49.9882 70.9736 46.0835 66.0478 46.0835C61.122 46.0835 57.1289 49.9882 57.1289 54.8048C57.1289 58.8707 59.312 62.0323 61.4137 64.1365C62.4697 65.1938 63.5234 66.0031 64.3131 66.5487C64.7086 66.8219 65.0398 67.0301 65.2743 67.1714C65.3916 67.242 65.485 67.296 65.5503 67.333ZM66.0478 57.9762C67.839 57.9762 69.2911 56.5564 69.2911 54.8048C69.2911 53.0533 67.839 51.6334 66.0478 51.6334C64.2566 51.6334 62.8046 53.0533 62.8046 54.8048C62.8046 56.5564 64.2566 57.9762 66.0478 57.9762Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M92.3061 129.759C92.3388 129.778 92.3644 129.793 92.3826 129.803L92.4128 129.821C92.6537 129.955 92.9526 129.954 93.1938 129.821L93.2248 129.803C93.2429 129.793 93.2686 129.778 93.3013 129.759C93.3666 129.72 93.4599 129.664 93.5772 129.591C93.8118 129.443 94.1429 129.226 94.5384 128.942C95.3281 128.374 96.3818 127.531 97.4378 126.429C99.5396 124.237 101.723 120.944 101.723 116.709C101.723 111.691 97.7295 107.624 92.8037 107.624C87.8779 107.624 83.8848 111.691 83.8848 116.709C83.8848 120.944 86.0678 124.237 88.1696 126.429C89.2256 127.531 90.2793 128.374 91.069 128.942C91.4645 129.226 91.7956 129.443 92.0302 129.591C92.1475 129.664 92.2408 129.72 92.3061 129.759ZM92.8037 120.012C94.5949 120.012 96.0469 118.533 96.0469 116.709C96.0469 114.884 94.5949 113.405 92.8037 113.405C91.0125 113.405 89.5604 114.884 89.5604 116.709C89.5604 118.533 91.0125 120.012 92.8037 120.012Z",
                fill: "#8C9FB6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0_1652_22981",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "165",
                        height: "165",
                        fill: "white",
                        transform: "translate(10.75 10.408)"
                    })
                })
            })
        ]
    });
};
var $cb9a42a6f88e7445$export$2e2bcd8739ae039 = $cb9a42a6f88e7445$var$UnsupportedCountry;

});

parcelRegister("OUdpF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fcf743898abdd4c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $3fcf743898abdd4c$var$InvestorSignupStepOne = ({ className: className, width: width = "200", height: height = "184" })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "currentColor",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#clip0_1602_19650)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        filter: "url(#filter0_b_1602_19650)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            x: "29.3546",
                            y: "123.184",
                            width: "133.657",
                            height: "28.8159",
                            rx: "4.39656",
                            fill: "#343C47",
                            fillOpacity: "0.5"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M40.4064 138.296V140.142C40.7111 140.086 40.9886 139.981 41.2096 139.837C41.5501 139.614 41.642 139.379 41.642 139.219C41.642 139.059 41.5501 138.824 41.2096 138.601C40.9886 138.457 40.7111 138.352 40.4064 138.296Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M38.6975 136.744C38.7355 136.784 38.7787 136.822 38.8277 136.86C38.9745 136.974 39.1522 137.061 39.3474 137.116V135.32C39.2947 135.335 39.2434 135.353 39.1935 135.372C39.1618 135.385 39.1307 135.398 39.1003 135.412C39.0014 135.458 38.9097 135.513 38.8277 135.577C38.5612 135.782 38.4648 136.019 38.4648 136.218C38.4648 136.348 38.5056 136.494 38.6076 136.636C38.6335 136.672 38.6634 136.708 38.6975 136.744Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M45.5253 137.719C45.5253 140.838 42.9964 143.367 39.8769 143.367C36.7574 143.367 34.2285 140.838 34.2285 137.719C34.2285 134.599 36.7574 132.07 39.8769 132.07C42.9964 132.07 45.5253 134.599 45.5253 137.719ZM39.8768 133.482C40.1693 133.482 40.4064 133.72 40.4064 134.012V134.235C40.8246 134.309 41.2312 134.474 41.5736 134.738C41.8745 134.971 42.0986 135.261 42.2268 135.586C42.334 135.858 42.2004 136.165 41.9283 136.273C41.6562 136.38 41.3487 136.246 41.2415 135.974C41.1901 135.844 41.0913 135.704 40.926 135.576C40.7792 135.463 40.6016 135.376 40.4064 135.32V137.224C40.8993 137.29 41.3827 137.449 41.7892 137.715C42.3449 138.078 42.701 138.611 42.701 139.219C42.701 139.827 42.3449 140.36 41.7892 140.723C41.3827 140.989 40.8993 141.148 40.4064 141.214V141.425C40.4064 141.718 40.1693 141.955 39.8768 141.955C39.5844 141.955 39.3473 141.718 39.3473 141.425V141.214C38.8544 141.148 38.371 140.989 37.9645 140.723C37.6238 140.5 37.3589 140.216 37.2034 139.884C37.0793 139.619 37.1935 139.304 37.4583 139.18C37.7232 139.056 38.0384 139.17 38.1625 139.435C38.2195 139.557 38.3355 139.7 38.5441 139.837C38.7651 139.981 39.0426 140.086 39.3473 140.142V138.202C38.9291 138.127 38.5225 137.963 38.1801 137.698C37.6884 137.318 37.4057 136.787 37.4057 136.218C37.4057 135.65 37.6884 135.118 38.1801 134.738C38.5225 134.474 38.9291 134.309 39.3473 134.235V134.012C39.3473 133.72 39.5844 133.482 39.8768 133.482Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "51.3982",
                        y: "136.183",
                        width: "105.944",
                        height: "3.97291",
                        rx: "1.98646",
                        fill: "#12181E"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "51.3982",
                        y: "136.183",
                        width: "105.944",
                        height: "3.97291",
                        rx: "1.98646",
                        fill: "#12181E"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "51.3982",
                        y: "136.183",
                        width: "105.944",
                        height: "3.97291",
                        rx: "1.98646",
                        fill: "#12181E"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "51.3982",
                        y: "136.183",
                        width: "33.1076",
                        height: "3.97291",
                        rx: "1.98646",
                        fill: "#AEC3FC"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "25",
                        y: "128",
                        width: "138",
                        height: "29",
                        fill: "url(#paint0_linear_1602_19650)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        filter: "url(#filter1_d_1602_19650)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                filter: "url(#filter2_b_1602_19650)",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    x: "58.5078",
                                    y: "78.4471",
                                    width: "140.492",
                                    height: "30.2896",
                                    rx: "4.39656",
                                    fill: "#343C47",
                                    fillOpacity: "0.5"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M70.1248 94.3319V96.2724C70.4451 96.2132 70.7368 96.1034 70.9691 95.9514C71.327 95.7174 71.4236 95.4706 71.4236 95.3021C71.4236 95.1336 71.327 94.8868 70.9691 94.6528C70.7368 94.5009 70.4451 94.391 70.1248 94.3319Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M68.3285 92.7005C68.3684 92.742 68.4139 92.7829 68.4654 92.8227C68.6197 92.942 68.8064 93.0332 69.0116 93.0919V91.2041C68.9563 91.2199 68.9023 91.2381 68.8499 91.2586C68.8166 91.2716 68.7839 91.2856 68.7519 91.3005C68.6479 91.3488 68.5516 91.4067 68.4654 91.4733C68.1853 91.6897 68.0839 91.9383 68.0839 92.148C68.0839 92.2844 68.1268 92.4374 68.234 92.5872C68.2613 92.6253 68.2926 92.6631 68.3285 92.7005Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M75.5055 93.7251C75.5055 97.0041 72.8473 99.6623 69.5682 99.6623C66.2892 99.6623 63.631 97.0041 63.631 93.7251C63.631 90.446 66.2892 87.7878 69.5682 87.7878C72.8473 87.7878 75.5055 90.446 75.5055 93.7251ZM69.5682 89.2721C69.8756 89.2721 70.1248 89.5213 70.1248 89.8287V90.0631C70.5644 90.1412 70.9918 90.3143 71.3517 90.5924C71.668 90.8368 71.9035 91.1411 72.0383 91.483C72.151 91.769 72.0105 92.0922 71.7245 92.2049C71.4385 92.3177 71.1153 92.1772 71.0026 91.8912C70.9486 91.7542 70.8447 91.6075 70.671 91.4733C70.5167 91.354 70.33 91.2628 70.1248 91.204V93.2051C70.6429 93.2741 71.151 93.4417 71.5783 93.7211C72.1624 94.103 72.5368 94.6634 72.5368 95.3021C72.5368 95.9409 72.1624 96.5013 71.5783 96.8832C71.151 97.1626 70.6429 97.3302 70.1248 97.3991V97.6214C70.1248 97.9288 69.8756 98.178 69.5682 98.178C69.2608 98.178 69.0116 97.9288 69.0116 97.6214V97.3991C68.4935 97.3302 67.9854 97.1626 67.558 96.8832C67.1999 96.649 66.9215 96.3505 66.758 96.0014C66.6276 95.723 66.7476 95.3916 67.026 95.2612C67.3044 95.1308 67.6357 95.2508 67.7661 95.5292C67.8261 95.6573 67.948 95.8081 68.1672 95.9514C68.3996 96.1034 68.6912 96.2132 69.0116 96.2724V94.2328C68.572 94.1547 68.1445 93.9816 67.7847 93.7036C67.2678 93.3042 66.9706 92.7455 66.9706 92.148C66.9706 91.5504 67.2678 90.9918 67.7847 90.5924C68.1445 90.3143 68.572 90.1412 69.0116 90.0631V89.8287C69.0116 89.5213 69.2608 89.2721 69.5682 89.2721Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "80",
                                y: "92",
                                width: "113",
                                height: "4",
                                rx: "2",
                                fill: "#12181E"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "80",
                                y: "92",
                                width: "113",
                                height: "4",
                                rx: "2",
                                fill: "#12181E"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "80",
                                y: "92",
                                width: "113",
                                height: "4",
                                rx: "2",
                                fill: "#12181E"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "80",
                                y: "92",
                                width: "98",
                                height: "4",
                                rx: "2",
                                fill: "#AEC3FC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        filter: "url(#filter3_d_1602_19650)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                filter: "url(#filter4_b_1602_19650)",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    x: "1",
                                    y: "27",
                                    width: "172.145",
                                    height: "37.1139",
                                    rx: "4.39656",
                                    fill: "#29303D"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.2343 46.4636V48.8414C15.6269 48.7689 15.9842 48.6342 16.2689 48.4481C16.7074 48.1613 16.8257 47.8589 16.8257 47.6525C16.8257 47.446 16.7074 47.1436 16.2689 46.8569C15.9842 46.6707 15.6269 46.5361 15.2343 46.4636Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M13.0334 44.4647C13.0823 44.5156 13.138 44.5657 13.2011 44.6144C13.3902 44.7606 13.619 44.8723 13.8703 44.9443V42.6311C13.8026 42.6505 13.7364 42.6728 13.6722 42.6979C13.6314 42.7139 13.5913 42.731 13.5521 42.7492C13.4247 42.8085 13.3067 42.8794 13.2011 42.961C12.8578 43.2262 12.7336 43.5308 12.7336 43.7877C12.7336 43.9549 12.7862 44.1423 12.9176 44.3259C12.951 44.3725 12.9894 44.4189 13.0334 44.4647Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M21.8273 45.7201C21.8273 49.7379 18.5702 52.995 14.5524 52.995C10.5346 52.995 7.27747 49.7379 7.27747 45.7201C7.27747 41.7023 10.5346 38.4452 14.5524 38.4452C18.5702 38.4452 21.8273 41.7023 21.8273 45.7201ZM14.5523 40.2639C14.929 40.2639 15.2343 40.5693 15.2343 40.9459V41.2331C15.773 41.3288 16.2967 41.5409 16.7376 41.8816C17.1252 42.1811 17.4138 42.554 17.5789 42.9729C17.717 43.3233 17.5449 43.7193 17.1945 43.8575C16.8441 43.9956 16.448 43.8235 16.3099 43.4731C16.2437 43.3052 16.1165 43.1254 15.9036 42.961C15.7145 42.8148 15.4857 42.7031 15.2343 42.6311V45.083C15.8691 45.1675 16.4918 45.3729 17.0154 45.7152C17.731 46.1832 18.1898 46.8698 18.1898 47.6525C18.1898 48.4351 17.731 49.1218 17.0154 49.5897C16.4918 49.9321 15.8691 50.1375 15.2343 50.2219V50.4942C15.2343 50.8709 14.929 51.1763 14.5523 51.1763C14.1756 51.1763 13.8703 50.8709 13.8703 50.4942V50.2219C13.2355 50.1375 12.6129 49.9321 12.0893 49.5897C11.6505 49.3028 11.3093 48.937 11.109 48.5092C10.9492 48.1681 11.0962 47.7621 11.4373 47.6023C11.7784 47.4426 12.1845 47.5896 12.3442 47.9307C12.4177 48.0876 12.5672 48.2724 12.8358 48.4481C13.1205 48.6342 13.4778 48.7689 13.8703 48.8414V46.3422C13.3317 46.2466 12.8079 46.0345 12.367 45.6938C11.7336 45.2044 11.3695 44.5199 11.3695 43.7877C11.3695 43.0555 11.7336 42.371 12.367 41.8816C12.8079 41.5409 13.3317 41.3288 13.8703 41.2331V40.9459C13.8703 40.5693 14.1756 40.2639 14.5523 40.2639Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "28",
                                y: "44",
                                width: "137",
                                height: "5",
                                rx: "2.5",
                                fill: "#12181E"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "28",
                                y: "44",
                                width: "137",
                                height: "5",
                                rx: "2.5",
                                fill: "#12181E"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "28",
                                y: "44",
                                width: "137",
                                height: "5",
                                rx: "2.5",
                                fill: "#12181E"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "28",
                                y: "44",
                                width: "94",
                                height: "5",
                                rx: "2.5",
                                fill: "#AEC3FC"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter0_b_1602_19650",
                        x: "25.3546",
                        y: "119.184",
                        width: "141.657",
                        height: "36.8159",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_1602_19650"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_1602_19650",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter1_d_1602_19650",
                        x: "54.5078",
                        y: "78.4471",
                        width: "148.492",
                        height: "38.2896",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1602_19650"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1602_19650",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter2_b_1602_19650",
                        x: "54.5078",
                        y: "74.4471",
                        width: "148.492",
                        height: "38.2896",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_1602_19650"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_1602_19650",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter3_d_1602_19650",
                        x: "-3",
                        y: "27",
                        width: "180.145",
                        height: "45.1139",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1602_19650"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1602_19650",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter4_b_1602_19650",
                        x: "-3",
                        y: "23",
                        width: "180.145",
                        height: "45.1139",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_1602_19650"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_1602_19650",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                        id: "paint0_linear_1602_19650",
                        x1: "128.651",
                        y1: "148.233",
                        x2: "128.651",
                        y2: "126.314",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                stopColor: "#12181E"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                offset: "1",
                                stopColor: "#12181E",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip0_1602_19650",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "200",
                            height: "184",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};
var $3fcf743898abdd4c$export$2e2bcd8739ae039 = $3fcf743898abdd4c$var$InvestorSignupStepOne;

});

parcelRegister("51mW3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c88f79cfbe3dce12$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $c88f79cfbe3dce12$var$InvestorSignupStepTwo = ({ className: className, width: width = "200", height: height = "184" })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "currentColor",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#clip0_1602_19726)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        opacity: "0.5",
                        filter: "url(#filter0_dd_1602_19726)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            y: "124.091",
                            width: "56.0927",
                            height: "56.0927",
                            rx: "28.0464",
                            fill: "#92ABFA"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M18.6157 142.323C18.2138 142.323 17.8879 142.656 17.8879 143.066C17.8879 143.476 18.2138 143.808 18.6157 143.808V160.143H17.8879C17.486 160.143 17.1602 160.476 17.1602 160.886C17.1602 161.296 17.486 161.628 17.8879 161.628H30.26V143.808C30.662 143.808 30.9878 143.476 30.9878 143.066C30.9878 142.656 30.662 142.323 30.26 142.323H18.6157ZM22.2545 159.401V157.173C22.2545 156.763 22.5804 156.431 22.9823 156.431H25.8934C26.2953 156.431 26.6212 156.763 26.6212 157.173V159.401C26.6212 159.811 26.2953 160.143 25.8934 160.143H22.9823C22.5804 160.143 22.2545 159.811 22.2545 159.401ZM21.5268 146.778C21.5268 146.368 21.8526 146.036 22.2545 146.036H22.9823C23.3843 146.036 23.7101 146.368 23.7101 146.778C23.7101 147.188 23.3843 147.521 22.9823 147.521H22.2545C21.8526 147.521 21.5268 147.188 21.5268 146.778ZM22.2545 149.006C21.8526 149.006 21.5268 149.338 21.5268 149.748C21.5268 150.158 21.8526 150.491 22.2545 150.491H22.9823C23.3843 150.491 23.7101 150.158 23.7101 149.748C23.7101 149.338 23.3843 149.006 22.9823 149.006H22.2545ZM21.5268 152.718C21.5268 152.308 21.8526 151.976 22.2545 151.976H22.9823C23.3843 151.976 23.7101 152.308 23.7101 152.718C23.7101 153.128 23.3843 153.461 22.9823 153.461H22.2545C21.8526 153.461 21.5268 153.128 21.5268 152.718ZM25.8934 146.036C25.4915 146.036 25.1656 146.368 25.1656 146.778C25.1656 147.188 25.4915 147.521 25.8934 147.521H26.6212C27.0231 147.521 27.3489 147.188 27.3489 146.778C27.3489 146.368 27.0231 146.036 26.6212 146.036H25.8934ZM25.1656 149.748C25.1656 149.338 25.4915 149.006 25.8934 149.006H26.6212C27.0231 149.006 27.3489 149.338 27.3489 149.748C27.3489 150.158 27.0231 150.491 26.6212 150.491H25.8934C25.4915 150.491 25.1656 150.158 25.1656 149.748ZM25.8934 151.976C25.4915 151.976 25.1656 152.308 25.1656 152.718C25.1656 153.128 25.4915 153.461 25.8934 153.461H26.6212C27.0231 153.461 27.3489 153.128 27.3489 152.718C27.3489 152.308 27.0231 151.976 26.6212 151.976H25.8934Z",
                        fill: "#FCFDFE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M31.7156 146.778V161.628H36.8099C37.2119 161.628 37.5377 161.296 37.5377 160.886C37.5377 160.476 37.2119 160.143 36.8099 160.143H36.0822V148.263C36.4841 148.263 36.8099 147.931 36.8099 147.521C36.8099 147.111 36.4841 146.778 36.0822 146.778H31.7156ZM33.1711 151.233C33.1711 150.823 33.4969 150.491 33.8989 150.491H33.9061C34.3081 150.491 34.6339 150.823 34.6339 151.233V151.241C34.6339 151.651 34.3081 151.983 33.9061 151.983H33.8989C33.4969 151.983 33.1711 151.651 33.1711 151.241V151.233ZM33.8989 153.461C33.4969 153.461 33.1711 153.793 33.1711 154.203V154.211C33.1711 154.621 33.4969 154.953 33.8989 154.953H33.9061C34.3081 154.953 34.6339 154.621 34.6339 154.211V154.203C34.6339 153.793 34.3081 153.461 33.9061 153.461H33.8989ZM33.1711 157.173C33.1711 156.763 33.4969 156.431 33.8989 156.431H33.9061C34.3081 156.431 34.6339 156.763 34.6339 157.173V157.181C34.6339 157.591 34.3081 157.923 33.9061 157.923H33.8989C33.4969 157.923 33.1711 157.591 33.1711 157.181V157.173Z",
                        fill: "#FCFDFE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        opacity: "0.75",
                        filter: "url(#filter1_dd_1602_19726)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            x: "173.591",
                            y: "69.8538",
                            width: "18.0051",
                            height: "18.0051",
                            rx: "9.00254",
                            fill: "#92ABFA"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M179.566 75.7062C179.437 75.7062 179.332 75.8129 179.332 75.9445C179.332 76.0761 179.437 76.1828 179.566 76.1828V81.4262H179.332C179.203 81.4262 179.099 81.5329 179.099 81.6645C179.099 81.7961 179.203 81.9028 179.332 81.9028H183.304V76.1828C183.433 76.1828 183.537 76.0761 183.537 75.9445C183.537 75.8129 183.433 75.7062 183.304 75.7062H179.566ZM180.734 81.1878V80.4728C180.734 80.3412 180.838 80.2345 180.967 80.2345H181.902C182.031 80.2345 182.135 80.3412 182.135 80.4728V81.1878C182.135 81.3195 182.031 81.4262 181.902 81.4262H180.967C180.838 81.4262 180.734 81.3195 180.734 81.1878ZM180.5 77.1362C180.5 77.0045 180.605 76.8978 180.734 76.8978H180.967C181.096 76.8978 181.201 77.0045 181.201 77.1362C181.201 77.2678 181.096 77.3745 180.967 77.3745H180.734C180.605 77.3745 180.5 77.2678 180.5 77.1362ZM180.734 77.8512C180.605 77.8512 180.5 77.9579 180.5 78.0895C180.5 78.2211 180.605 78.3278 180.734 78.3278H180.967C181.096 78.3278 181.201 78.2211 181.201 78.0895C181.201 77.9579 181.096 77.8512 180.967 77.8512H180.734ZM180.5 79.0428C180.5 78.9112 180.605 78.8045 180.734 78.8045H180.967C181.096 78.8045 181.201 78.9112 181.201 79.0428C181.201 79.1745 181.096 79.2812 180.967 79.2812H180.734C180.605 79.2812 180.5 79.1745 180.5 79.0428ZM181.902 76.8978C181.773 76.8978 181.668 77.0045 181.668 77.1362C181.668 77.2678 181.773 77.3745 181.902 77.3745H182.135C182.265 77.3745 182.369 77.2678 182.369 77.1362C182.369 77.0045 182.265 76.8978 182.135 76.8978H181.902ZM181.668 78.0895C181.668 77.9579 181.773 77.8512 181.902 77.8512H182.135C182.265 77.8512 182.369 77.9579 182.369 78.0895C182.369 78.2211 182.265 78.3278 182.135 78.3278H181.902C181.773 78.3278 181.668 78.2211 181.668 78.0895ZM181.902 78.8045C181.773 78.8045 181.668 78.9112 181.668 79.0428C181.668 79.1745 181.773 79.2812 181.902 79.2812H182.135C182.265 79.2812 182.369 79.1745 182.369 79.0428C182.369 78.9112 182.265 78.8045 182.135 78.8045H181.902Z",
                        fill: "#FCFDFE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M183.771 77.1362V81.9028H185.406C185.535 81.9028 185.64 81.7961 185.64 81.6645C185.64 81.5329 185.535 81.4262 185.406 81.4262H185.172V77.6128C185.301 77.6128 185.406 77.5061 185.406 77.3745C185.406 77.2429 185.301 77.1362 185.172 77.1362H183.771ZM184.238 78.5662C184.238 78.4345 184.343 78.3278 184.472 78.3278H184.474C184.603 78.3278 184.707 78.4345 184.707 78.5662V78.5685C184.707 78.7002 184.603 78.8069 184.474 78.8069H184.472C184.343 78.8069 184.238 78.7002 184.238 78.5685V78.5662ZM184.472 79.2812C184.343 79.2812 184.238 79.3879 184.238 79.5195V79.5219C184.238 79.6535 184.343 79.7602 184.472 79.7602H184.474C184.603 79.7602 184.707 79.6535 184.707 79.5219V79.5195C184.707 79.3879 184.603 79.2812 184.474 79.2812H184.472ZM184.238 80.4728C184.238 80.3412 184.343 80.2345 184.472 80.2345H184.474C184.603 80.2345 184.707 80.3412 184.707 80.4728V80.4752C184.707 80.6068 184.603 80.7136 184.474 80.7136H184.472C184.343 80.7136 184.238 80.6068 184.238 80.4752V80.4728Z",
                        fill: "#FCFDFE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        filter: "url(#filter2_d_1602_19726)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            x: "30.2427",
                            y: "28.5251",
                            width: "139.886",
                            height: "117.726",
                            rx: "3.86059",
                            fill: "#29303D"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "46.7992",
                        cy: "42.3752",
                        r: "1.75619",
                        fill: "#4A66F4"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M52.4932 39.7629V38.8505H57.9298V39.7629H55.738V45.8752H54.6816V39.7629H52.4932ZM65.0814 42.3629C65.0814 43.1129 64.9442 43.7577 64.6698 44.2974C64.3953 44.8348 64.0192 45.2487 63.5413 45.5391C63.0656 45.8272 62.5248 45.9713 61.9188 45.9713C61.3106 45.9713 60.7675 45.8272 60.2896 45.5391C59.8139 45.2487 59.4389 44.8336 59.1645 44.294C58.8901 43.7543 58.7529 43.1106 58.7529 42.3629C58.7529 41.6128 58.8901 40.9691 59.1645 40.4317C59.4389 39.8921 59.8139 39.4782 60.2896 39.1901C60.7675 38.8996 61.3106 38.7544 61.9188 38.7544C62.5248 38.7544 63.0656 38.8996 63.5413 39.1901C64.0192 39.4782 64.3953 39.8921 64.6698 40.4317C64.9442 40.9691 65.0814 41.6128 65.0814 42.3629ZM64.0318 42.3629C64.0318 41.7912 63.9392 41.3098 63.7539 40.9188C63.571 40.5255 63.3195 40.2282 62.9993 40.027C62.6815 39.8235 62.3213 39.7217 61.9188 39.7217C61.5141 39.7217 61.1528 39.8235 60.835 40.027C60.5171 40.2282 60.2656 40.5255 60.0803 40.9188C59.8974 41.3098 59.8059 41.7912 59.8059 42.3629C59.8059 42.9345 59.8974 43.417 60.0803 43.8103C60.2656 44.2014 60.5171 44.4986 60.835 44.7022C61.1528 44.9034 61.5141 45.004 61.9188 45.004C62.3213 45.004 62.6815 44.9034 62.9993 44.7022C63.3195 44.4986 63.571 44.2014 63.7539 43.8103C63.9392 43.417 64.0318 42.9345 64.0318 42.3629ZM66.5433 45.8752V38.8505H69.0472C69.5937 38.8505 70.0465 38.9499 70.4055 39.1489C70.7645 39.3478 71.0332 39.62 71.2116 39.9652C71.3899 40.3083 71.4791 40.6947 71.4791 41.1246C71.4791 41.5568 71.3888 41.9455 71.2082 42.2908C71.0298 42.6338 70.76 42.9059 70.3987 43.1072C70.0397 43.3061 69.588 43.4056 69.0438 43.4056H67.3219V42.5069H68.9477C69.293 42.5069 69.5732 42.4475 69.7881 42.3286C70.0031 42.2074 70.1608 42.0427 70.2615 41.8346C70.3621 41.6265 70.4124 41.3899 70.4124 41.1246C70.4124 40.8593 70.3621 40.6238 70.2615 40.418C70.1608 40.2122 70.0019 40.051 69.7847 39.9344C69.5697 39.8178 69.2862 39.7594 68.934 39.7594H67.6032V45.8752H66.5433ZM77.7816 45.9713C77.3517 45.9713 76.9652 45.8889 76.6222 45.7243C76.2815 45.5574 76.0094 45.3287 75.8059 45.0383C75.6024 44.7479 75.4937 44.4163 75.48 44.0436H76.509C76.5342 44.3454 76.668 44.5935 76.9103 44.7879C77.1527 44.9823 77.4431 45.0795 77.7816 45.0795C78.0514 45.0795 78.2904 45.0177 78.4985 44.8942C78.7088 44.7685 78.8735 44.5958 78.9924 44.3763C79.1136 44.1568 79.1742 43.9064 79.1742 43.6251C79.1742 43.3393 79.1124 43.0843 78.989 42.8602C78.8655 42.6361 78.6951 42.46 78.4779 42.332C78.2629 42.2039 78.016 42.1388 77.737 42.1365C77.5243 42.1365 77.3105 42.1731 77.0956 42.2462C76.8806 42.3194 76.7068 42.4154 76.5742 42.5344L75.6035 42.3903L75.998 38.8505H79.8602V39.7594H76.8795L76.6565 41.7249H76.6977C76.8349 41.5922 77.0167 41.4813 77.2431 41.3921C77.4717 41.303 77.7164 41.2584 77.9771 41.2584C78.4047 41.2584 78.7854 41.3601 79.1193 41.5637C79.4554 41.7672 79.7196 42.045 79.9116 42.3972C80.106 42.747 80.2021 43.1495 80.1998 43.6045C80.2021 44.0596 80.0992 44.4655 79.8911 44.8222C79.6853 45.1789 79.3994 45.4602 79.0335 45.666C78.67 45.8695 78.2526 45.9713 77.7816 45.9713ZM85.2598 44.5581V44.1876C85.2621 43.9224 85.3181 43.68 85.4279 43.4605C85.5399 43.2387 85.7023 43.0614 85.915 42.9288C86.1276 42.7939 86.386 42.7264 86.6901 42.7264C87.0011 42.7264 87.2618 42.7928 87.4722 42.9254C87.6826 43.058 87.8415 43.2352 87.949 43.457C88.0587 43.6789 88.1136 43.9224 88.1136 44.1876V44.5581C88.1136 44.8233 88.0587 45.0669 87.949 45.2887C87.8392 45.5082 87.678 45.6854 87.4653 45.8203C87.255 45.953 86.9966 46.0193 86.6901 46.0193C86.3814 46.0193 86.1208 45.953 85.9081 45.8203C85.6954 45.6854 85.5342 45.5082 85.4245 45.2887C85.317 45.0669 85.2621 44.8233 85.2598 44.5581ZM86.059 44.1876V44.5581C86.0613 44.7547 86.1082 44.9331 86.1997 45.0932C86.2934 45.2532 86.4569 45.3333 86.6901 45.3333C86.9211 45.3333 87.0823 45.2532 87.1738 45.0932C87.2653 44.9331 87.311 44.7547 87.311 44.5581V44.1876C87.311 43.991 87.2664 43.8126 87.1772 43.6526C87.0903 43.4925 86.928 43.4125 86.6901 43.4125C86.4615 43.4125 86.2991 43.4925 86.2031 43.6526C86.1093 43.8126 86.0613 43.991 86.059 44.1876ZM81.7269 40.5381V40.1676C81.7269 39.9024 81.7817 39.6588 81.8915 39.437C82.0036 39.2152 82.1659 39.038 82.3786 38.9054C82.5935 38.7727 82.8531 38.7064 83.1572 38.7064C83.4682 38.7064 83.7289 38.7727 83.9392 38.9054C84.1496 39.038 84.3085 39.2152 84.416 39.437C84.5235 39.6588 84.5772 39.9024 84.5772 40.1676V40.5381C84.5772 40.8033 84.5224 41.0469 84.4126 41.2687C84.3051 41.4882 84.145 41.6654 83.9324 41.8003C83.722 41.933 83.4636 41.9993 83.1572 41.9993C82.8462 41.9993 82.5844 41.933 82.3717 41.8003C82.1613 41.6654 82.0013 41.4882 81.8915 41.2687C81.7817 41.0469 81.7269 40.8033 81.7269 40.5381ZM82.5295 40.1676V40.5381C82.5295 40.7347 82.5752 40.9131 82.6667 41.0732C82.7605 41.2332 82.9239 41.3133 83.1572 41.3133C83.3859 41.3133 83.5459 41.2332 83.6374 41.0732C83.7312 40.9131 83.778 40.7347 83.778 40.5381V40.1676C83.778 39.971 83.7334 39.7926 83.6443 39.6325C83.5551 39.4725 83.3927 39.3924 83.1572 39.3924C82.9285 39.3924 82.7662 39.4725 82.6701 39.6325C82.5764 39.7926 82.5295 39.971 82.5295 40.1676ZM82.0116 45.8752L86.8411 38.8505H87.6609L82.8313 45.8752H82.0116Z",
                        fill: "#FCFDFE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M51.7102 119.243C47.8856 119.243 44.7852 122.344 44.7852 126.168C44.7852 129.993 47.8856 133.093 51.7102 133.093C55.5348 133.093 58.6352 129.993 58.6352 126.168C58.6352 122.344 55.5348 119.243 51.7102 119.243ZM52.2429 121.907C52.2429 121.612 52.0044 121.374 51.7102 121.374C51.416 121.374 51.1775 121.612 51.1775 121.907V126.168C51.1775 126.462 51.416 126.701 51.7102 126.701H54.9064C55.2006 126.701 55.439 126.462 55.439 126.168C55.439 125.874 55.2006 125.635 54.9064 125.635H52.2429V121.907Z",
                        fill: "#FCFDFE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "66.2529",
                        y: "124.091",
                        width: "57.4777",
                        height: "4.15502",
                        rx: "2.07751",
                        fill: "#7E899A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M50.5856 106.667C50.6081 106.68 50.6258 106.69 50.6383 106.697L50.6591 106.709C50.825 106.801 51.0309 106.801 51.197 106.709L51.2184 106.697C51.2309 106.69 51.2486 106.68 51.271 106.667C51.316 106.641 51.3803 106.602 51.4611 106.552C51.6227 106.451 51.8507 106.303 52.1232 106.109C52.6671 105.721 53.3929 105.144 54.1202 104.392C55.5679 102.894 57.0715 100.644 57.0715 97.7503C57.0715 94.3221 54.3211 91.5429 50.9283 91.5429C47.5355 91.5429 44.7852 94.3221 44.7852 97.7503C44.7852 100.644 46.2888 102.894 47.7365 104.392C48.4638 105.144 49.1896 105.721 49.7335 106.109C50.0059 106.303 50.234 106.451 50.3955 106.552C50.4764 106.602 50.5406 106.641 50.5856 106.667ZM50.9283 100.007C52.1621 100.007 53.1622 98.9969 53.1622 97.7503C53.1622 96.5036 52.1621 95.4931 50.9283 95.4931C49.6946 95.4931 48.6944 96.5036 48.6944 97.7503C48.6944 98.9969 49.6946 100.007 50.9283 100.007Z",
                        fill: "#FCFDFE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "66.2529",
                        y: "97.083",
                        width: "83.7929",
                        height: "4.15502",
                        rx: "2.07751",
                        fill: "#7E899A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M50.6189 69.7393C50.7803 69.614 50.972 69.5228 51.1775 69.4659V71.4069C50.9681 71.3488 50.7769 71.2562 50.6189 71.1335C50.3393 70.9163 50.2311 70.6607 50.2311 70.4364C50.2311 70.2121 50.3393 69.9565 50.6189 69.7393Z",
                        fill: "#FCFDFE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M52.2429 74.5419V72.5812C52.4895 72.6398 52.7143 72.7391 52.8973 72.8733C53.2002 73.0954 53.3083 73.3496 53.3083 73.5615C53.3083 73.7734 53.2002 74.0276 52.8973 74.2497C52.7143 74.3839 52.4895 74.4832 52.2429 74.5419Z",
                        fill: "#FCFDFE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M51.7102 65.2278C47.8856 65.2278 44.7852 68.2594 44.7852 71.999C44.7852 75.7386 47.8856 78.7701 51.7102 78.7701C55.5348 78.7701 58.6352 75.7386 58.6352 71.999C58.6352 68.2594 55.5348 65.2278 51.7102 65.2278ZM52.2429 67.8321C52.2429 67.5445 52.0044 67.3113 51.7102 67.3113C51.416 67.3113 51.1775 67.5445 51.1775 67.8321V68.3985C50.7322 68.4757 50.3077 68.6507 49.9563 68.9237C49.4503 69.3167 49.1657 69.8609 49.1657 70.4364C49.1657 71.0119 49.4503 71.5561 49.9563 71.9491C50.3131 72.2263 50.739 72.3983 51.1775 72.4742V74.5418C50.9309 74.4832 50.7062 74.3839 50.5233 74.2497L49.899 73.792C49.6637 73.6194 49.3298 73.666 49.1533 73.8961C48.9767 74.1262 49.0244 74.4527 49.2598 74.6253L49.884 75.0831C50.2627 75.3608 50.7144 75.5308 51.1775 75.6035V76.1658C51.1775 76.4535 51.416 76.6867 51.7102 76.6867C52.0044 76.6867 52.2429 76.4535 52.2429 76.1658V75.6036C52.7061 75.5308 53.1578 75.3609 53.5365 75.0831C54.0657 74.695 54.3737 74.1494 54.3737 73.5615C54.3737 72.9736 54.0657 72.428 53.5365 72.0399C53.1578 71.7622 52.7061 71.5922 52.2429 71.5195V69.4659C52.4483 69.5229 52.6399 69.614 52.8012 69.7393L53.0959 69.9682C53.3263 70.1472 53.6614 70.1096 53.8444 69.8844C54.0274 69.6591 53.989 69.3315 53.7586 69.1526L53.4639 68.9237C53.1126 68.6508 52.6881 68.4757 52.2429 68.3986V67.8321Z",
                        fill: "#FCFDFE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "66.9456",
                        y: "70.0754",
                        width: "34.6252",
                        height: "4.15502",
                        rx: "2.07751",
                        fill: "#7E899A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        filter: "url(#filter3_dd_1602_19726)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            x: "8.40405",
                            y: "8.76392",
                            width: "36.2184",
                            height: "36.2184",
                            rx: "18.1092",
                            fill: "#92ABFA"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.424 20.5365C20.1644 20.5365 19.954 20.7511 19.954 21.0159C19.954 21.2807 20.1644 21.4953 20.424 21.4953V32.0427H19.954C19.6945 32.0427 19.4841 32.2573 19.4841 32.5221C19.4841 32.7869 19.6945 33.0015 19.954 33.0015H27.9426V21.4953C28.2021 21.4953 28.4125 21.2807 28.4125 21.0159C28.4125 20.7511 28.2021 20.5365 27.9426 20.5365H20.424ZM22.7735 31.5632V30.125C22.7735 29.8602 22.9839 29.6455 23.2434 29.6455H25.1231C25.3826 29.6455 25.593 29.8602 25.593 30.125V31.5632C25.593 31.828 25.3826 32.0427 25.1231 32.0427H23.2434C22.9839 32.0427 22.7735 31.828 22.7735 31.5632ZM22.3036 23.413C22.3036 23.1482 22.514 22.9336 22.7735 22.9336H23.2434C23.503 22.9336 23.7133 23.1482 23.7133 23.413C23.7133 23.6778 23.503 23.8924 23.2434 23.8924H22.7735C22.514 23.8924 22.3036 23.6778 22.3036 23.413ZM22.7735 24.8513C22.514 24.8513 22.3036 25.0659 22.3036 25.3307C22.3036 25.5955 22.514 25.8101 22.7735 25.8101H23.2434C23.503 25.8101 23.7133 25.5955 23.7133 25.3307C23.7133 25.0659 23.503 24.8513 23.2434 24.8513H22.7735ZM22.3036 27.2484C22.3036 26.9836 22.514 26.769 22.7735 26.769H23.2434C23.503 26.769 23.7133 26.9836 23.7133 27.2484C23.7133 27.5132 23.503 27.7278 23.2434 27.7278H22.7735C22.514 27.7278 22.3036 27.5132 22.3036 27.2484ZM25.1231 22.9336C24.8636 22.9336 24.6532 23.1482 24.6532 23.413C24.6532 23.6778 24.8636 23.8924 25.1231 23.8924H25.593C25.8525 23.8924 26.0629 23.6778 26.0629 23.413C26.0629 23.1482 25.8525 22.9336 25.593 22.9336H25.1231ZM24.6532 25.3307C24.6532 25.0659 24.8636 24.8513 25.1231 24.8513H25.593C25.8525 24.8513 26.0629 25.0659 26.0629 25.3307C26.0629 25.5955 25.8525 25.8101 25.593 25.8101H25.1231C24.8636 25.8101 24.6532 25.5955 24.6532 25.3307ZM25.1231 26.769C24.8636 26.769 24.6532 26.9836 24.6532 27.2484C24.6532 27.5132 24.8636 27.7278 25.1231 27.7278H25.593C25.8525 27.7278 26.0629 27.5132 26.0629 27.2484C26.0629 26.9836 25.8525 26.769 25.593 26.769H25.1231Z",
                        fill: "#FCFDFE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M28.8824 23.413V33.0015H32.1718C32.4313 33.0015 32.6417 32.7869 32.6417 32.5221C32.6417 32.2573 32.4313 32.0427 32.1718 32.0427H31.7019V24.3719C31.9614 24.3719 32.1718 24.1572 32.1718 23.8924C32.1718 23.6277 31.9614 23.413 31.7019 23.413H28.8824ZM29.8222 26.2896C29.8222 26.0248 30.0326 25.8101 30.2921 25.8101H30.2968C30.5563 25.8101 30.7667 26.0248 30.7667 26.2896V26.2944C30.7667 26.5591 30.5563 26.7738 30.2968 26.7738H30.2921C30.0326 26.7738 29.8222 26.5591 29.8222 26.2944V26.2896ZM30.2921 27.7278C30.0326 27.7278 29.8222 27.9425 29.8222 28.2073V28.2121C29.8222 28.4768 30.0326 28.6915 30.2921 28.6915H30.2968C30.5563 28.6915 30.7667 28.4768 30.7667 28.2121V28.2073C30.7667 27.9425 30.5563 27.7278 30.2968 27.7278H30.2921ZM29.8222 30.125C29.8222 29.8602 30.0326 29.6455 30.2921 29.6455H30.2968C30.5563 29.6455 30.7667 29.8602 30.7667 30.125V30.1298C30.7667 30.3945 30.5563 30.6092 30.2968 30.6092H30.2921C30.0326 30.6092 29.8222 30.3945 29.8222 30.1298V30.125Z",
                        fill: "#FCFDFE"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter0_dd_1602_19726",
                        x: "-17.9707",
                        y: "118.1",
                        width: "92.0341",
                        height: "92.034",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "0.499185"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0470588 0 0 0 0 0.0627451 0 0 0 0 0.0784314 0 0 0 0.81 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1602_19726"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feMorphology", {
                                radius: "5.99022",
                                operator: "erode",
                                in: "SourceAlpha",
                                result: "effect2_dropShadow_1602_19726"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "11.9804"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "11.9804"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0470588 0 0 0 0 0.0627451 0 0 0 0 0.0784314 0 0 0 0.85 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect1_dropShadow_1602_19726",
                                result: "effect2_dropShadow_1602_19726"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow_1602_19726",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter1_dd_1602_19726",
                        x: "155.62",
                        y: "63.8635",
                        width: "53.9464",
                        height: "53.9464",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "0.499185"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0470588 0 0 0 0 0.0627451 0 0 0 0 0.0784314 0 0 0 0.81 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1602_19726"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feMorphology", {
                                radius: "5.99022",
                                operator: "erode",
                                in: "SourceAlpha",
                                result: "effect2_dropShadow_1602_19726"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "11.9804"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "11.9804"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0470588 0 0 0 0 0.0627451 0 0 0 0 0.0784314 0 0 0 0.85 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect1_dropShadow_1602_19726",
                                result: "effect2_dropShadow_1602_19726"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow_1602_19726",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter2_d_1602_19726",
                        x: "26.7303",
                        y: "28.5251",
                        width: "146.91",
                        height: "124.75",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "3.51238"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "1.75619"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1602_19726"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1602_19726",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter3_dd_1602_19726",
                        x: "-9.5666",
                        y: "2.7737",
                        width: "72.1598",
                        height: "72.1597",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "0.499185"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0470588 0 0 0 0 0.0627451 0 0 0 0 0.0784314 0 0 0 0.81 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1602_19726"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feMorphology", {
                                radius: "5.99022",
                                operator: "erode",
                                in: "SourceAlpha",
                                result: "effect2_dropShadow_1602_19726"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "11.9804"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "11.9804"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0470588 0 0 0 0 0.0627451 0 0 0 0 0.0784314 0 0 0 0.85 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect1_dropShadow_1602_19726",
                                result: "effect2_dropShadow_1602_19726"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow_1602_19726",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip0_1602_19726",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "200",
                            height: "184",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};
var $c88f79cfbe3dce12$export$2e2bcd8739ae039 = $c88f79cfbe3dce12$var$InvestorSignupStepTwo;

});

parcelRegister("eMsNy", function(module, exports) {

$parcel$export(module.exports, "default", () => $01c1919617a3dc6b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $01c1919617a3dc6b$var$InvestorSignupStepThree = ({ className: className, width: width = "200", height: height = "184" })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "currentColor",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#clip0_1602_19672)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "33.2126",
                        y: "35.796",
                        width: "148.225",
                        height: "127.872",
                        rx: "3.9783",
                        fill: "#1F2630"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        opacity: "0.75",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M47.8633 155.442V117.654C47.8633 117.396 48.0719 117.188 48.3293 117.188H57.1643C57.4216 117.188 57.6303 117.396 57.6303 117.654V155.442H47.8633Z",
                                fill: "#AEC3FC"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M62.5139 155.442V113.584C62.5139 113.327 62.7226 113.118 62.9799 113.118H71.001C71.2584 113.118 71.467 113.327 71.467 113.584V155.442H62.5139Z",
                                fill: "#AEC3FC"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M76.3503 155.442V116.84C76.3503 116.582 76.559 116.374 76.8164 116.374H85.6513C85.9087 116.374 86.1174 116.582 86.1174 116.84V155.442H76.3503Z",
                                fill: "#AEC3FC"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M90.187 155.442V107.073C90.187 106.815 90.3957 106.607 90.653 106.607H99.488C99.7454 106.607 99.954 106.815 99.954 107.073V155.442H90.187Z",
                                fill: "#AEC3FC"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M104.838 155.442V94.8641C104.838 94.6067 105.046 94.3981 105.304 94.3981H113.325C113.582 94.3981 113.791 94.6067 113.791 94.8641V155.442H104.838Z",
                                fill: "#2042F6"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M118.177 155.441V78.6434C118.177 78.3861 118.385 78.1774 118.643 78.1774H127.586C127.844 78.1774 128.052 78.3861 128.052 78.6434V155.441H118.177Z",
                                fill: "#AEC3FC"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M132.991 155.441V71.6191C132.991 71.3617 133.199 71.1531 133.457 71.1531H142.401C142.658 71.1531 142.867 71.3617 142.867 71.6191V155.441H132.991Z",
                                fill: "#AEC3FC"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M146.98 155.441V63.8151C146.98 63.5577 147.189 63.3491 147.446 63.3491H156.39C156.647 63.3491 156.856 63.5577 156.856 63.8151V155.441H146.98Z",
                                fill: "#AEC3FC"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M161.794 155.441V57.5712C161.794 57.3138 162.003 57.1052 162.26 57.1052H171.204C171.461 57.1052 171.67 57.3138 171.67 57.5712V155.441H161.794Z",
                                fill: "#AEC3FC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        filter: "url(#filter0_bd_1602_19672)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            x: "1.87671",
                            y: "20.3316",
                            width: "62.6717",
                            height: "62.6717",
                            rx: "3.9783",
                            fill: "#343C47",
                            fillOpacity: "0.5",
                            shapeRendering: "crispEdges"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        filter: "url(#filter1_d_1602_19672)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M33.2125 75.678C46.4731 75.678 57.223 64.9281 57.223 51.6674C57.223 38.4067 46.4731 27.6568 33.2125 27.6568C19.9518 27.6568 9.2019 38.4067 9.2019 51.6674C9.2019 64.9281 19.9518 75.678 33.2125 75.678ZM33.2125 66.7249C41.5285 66.7249 48.27 59.9834 48.27 51.6674C48.27 43.3514 41.5285 36.6099 33.2125 36.6099C24.8965 36.6099 18.155 43.3514 18.155 51.6674C18.155 59.9834 24.8965 66.7249 33.2125 66.7249Z",
                            fill: "#343E4F"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("mask", {
                        id: "mask0_1602_19672",
                        style: {
                            maskType: "alpha"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "9",
                        y: "27",
                        width: "49",
                        height: "49",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M33.2125 75.678C46.4731 75.678 57.223 64.9281 57.223 51.6674C57.223 38.4067 46.4731 27.6568 33.2125 27.6568C19.9518 27.6568 9.2019 38.4067 9.2019 51.6674C9.2019 64.9281 19.9518 75.678 33.2125 75.678ZM33.2125 66.7249C41.5285 66.7249 48.27 59.9834 48.27 51.6674C48.27 43.3514 41.5285 36.6099 33.2125 36.6099C24.8965 36.6099 18.155 43.3514 18.155 51.6674C18.155 59.9834 24.8965 66.7249 33.2125 66.7249Z",
                            fill: "#4A66F4"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        mask: "url(#mask0_1602_19672)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M32.8057 27.6568H7.57422V75.678H24.4971L23.943 76.6377L48.1449 90.6107L60.7606 68.7596L36.5587 54.7867L32.8057 61.2871V27.6568Z",
                            fill: "#4A66F4"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        opacity: "0.7",
                        x: "104.837",
                        y: "93.5841",
                        width: "8.95309",
                        height: "61.8577",
                        fill: "#677283"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        filter: "url(#filter2_bd_1602_19672)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            x: "108.093",
                            y: "83.0032",
                            width: "69.9969",
                            height: "21.9758",
                            rx: "1.80973",
                            fill: "#343C47"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "167.439",
                        y1: "90.4194",
                        x2: "114.314",
                        y2: "90.4194",
                        stroke: "white",
                        strokeWidth: "1.80973",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "170.097",
                        y1: "94.489",
                        x2: "114.314",
                        y2: "94.489",
                        stroke: "white",
                        strokeWidth: "1.80973",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "157.692",
                        y1: "98.5586",
                        x2: "114.314",
                        y2: "98.5586",
                        stroke: "white",
                        strokeWidth: "1.80973",
                        strokeLinecap: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter0_bd_1602_19672",
                        x: "-1.74276",
                        y: "16.7121",
                        width: "69.9106",
                        height: "73.5301",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: "1.80973"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_1602_19672"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "3.61947"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "1.80973"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect1_backgroundBlur_1602_19672",
                                result: "effect2_dropShadow_1602_19672"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow_1602_19672",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter1_d_1602_19672",
                        x: "5.58244",
                        y: "27.6568",
                        width: "55.2602",
                        height: "55.2601",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "3.61947"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "1.80973"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1602_19672"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1602_19672",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter2_bd_1602_19672",
                        x: "104.474",
                        y: "79.3837",
                        width: "77.2358",
                        height: "32.8342",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: "1.80973"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_1602_19672"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "3.61947"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "1.80973"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect1_backgroundBlur_1602_19672",
                                result: "effect2_dropShadow_1602_19672"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow_1602_19672",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip0_1602_19672",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "200",
                            height: "184",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};
var $01c1919617a3dc6b$export$2e2bcd8739ae039 = $01c1919617a3dc6b$var$InvestorSignupStepThree;

});

parcelRegister("d2FRZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa2286a7d4dde55$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $4aa2286a7d4dde55$var$RingOnIcon = ({ className: className, width: width = "18", height: height = "18", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "transparent",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z",
                    stroke: "#2841ED",
                    strokeWidth: "3"
                })
            })
        })
    });
};
var $4aa2286a7d4dde55$export$2e2bcd8739ae039 = $4aa2286a7d4dde55$var$RingOnIcon;

});

parcelRegister("9jy6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6c5a56bd867ef43$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $e6c5a56bd867ef43$var$RingOffIcon = ({ className: className, width: width = "18", height: height = "18", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "transparent",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z",
                    stroke: "#363F4F",
                    strokeWidth: "3"
                })
            })
        })
    });
};
var $e6c5a56bd867ef43$export$2e2bcd8739ae039 = $e6c5a56bd867ef43$var$RingOffIcon;

});

parcelRegister("lhoE4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab0d0b2c53a4e811$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $ab0d0b2c53a4e811$var$BuildingIcon = ({ className: className, width: width = "30", height: height = "30" })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
        fallback: null,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            role: "img",
            width: width,
            height: height,
            viewBox: `0 0 ${width} ${height}`,
            fill: "none",
            className: className,
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.25 2.5C7.14543 2.5 6.25 3.39543 6.25 4.5V26.25H13.125V22.25C13.125 21.6977 13.5727 21.25 14.125 21.25H15.875C16.4273 21.25 16.875 21.6977 16.875 22.25V26.25H23.75V4.5C23.75 3.39543 22.8546 2.5 21.75 2.5H8.25ZM11 5C10.4477 5 10 5.44772 10 6V7.75C10 8.30228 10.4477 8.75 11 8.75H12.75C13.3023 8.75 13.75 8.30228 13.75 7.75V6C13.75 5.44772 13.3023 5 12.75 5H11ZM16.25 6C16.25 5.44772 16.6977 5 17.25 5H19C19.5523 5 20 5.44772 20 6V7.75C20 8.30228 19.5523 8.75 19 8.75H17.25C16.6977 8.75 16.25 8.30228 16.25 7.75V6ZM11 10C10.4477 10 10 10.4477 10 11V12.75C10 13.3023 10.4477 13.75 11 13.75H12.75C13.3023 13.75 13.75 13.3023 13.75 12.75V11C13.75 10.4477 13.3023 10 12.75 10H11ZM10 16C10 15.4477 10.4477 15 11 15H12.75C13.3023 15 13.75 15.4477 13.75 16V17.75C13.75 18.3023 13.3023 18.75 12.75 18.75H11C10.4477 18.75 10 18.3023 10 17.75V16ZM17.25 15C16.6977 15 16.25 15.4477 16.25 16V17.75C16.25 18.3023 16.6977 18.75 17.25 18.75H19C19.5523 18.75 20 18.3023 20 17.75V16C20 15.4477 19.5523 15 19 15H17.25ZM16.25 11C16.25 10.4477 16.6977 10 17.25 10H19C19.5523 10 20 10.4477 20 11V12.75C20 13.3023 19.5523 13.75 19 13.75H17.25C16.6977 13.75 16.25 13.3023 16.25 12.75V11Z",
                    fill: "#29303D"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M3.75 28.7351C3.75 27.3626 4.86261 26.25 6.23509 26.25H23.7649C25.1374 26.25 26.25 27.3626 26.25 28.7351C26.25 28.7433 26.2433 28.75 26.2351 28.75H3.76491C3.75668 28.75 3.75 28.7433 3.75 28.7351Z",
                    fill: "#677283"
                })
            ]
        })
    });
};
var $ab0d0b2c53a4e811$export$2e2bcd8739ae039 = $ab0d0b2c53a4e811$var$BuildingIcon;

});

parcelRegister("3Rj3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $aae2279e96d1e637$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $aae2279e96d1e637$var$BarChartupIcon = ({ className: className, width: width = "52", height: height = "52", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "none",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "52",
                        height: "52",
                        rx: "26",
                        fill: "#3E4758"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "30.1666",
                        y: "19.3333",
                        width: "2.5",
                        height: "10.8333",
                        rx: "1.25",
                        fill: "#CBD5E1"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "26",
                        y: "23.5",
                        width: "2.5",
                        height: "6.66667",
                        rx: "1.25",
                        fill: "#CBD5E1"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M20.1667 31.8333H32.6667C33.1269 31.8333 33.5 32.2064 33.5 32.6667C33.5 33.1269 33.1269 33.5 32.6667 33.5H19.3333C18.8731 33.5 18.5 33.1269 18.5 32.6667V19.3333C18.5 18.8731 18.8731 18.5 19.3333 18.5C19.7936 18.5 20.1667 18.8731 20.1667 19.3333V31.8333Z",
                        fill: "#CBD5E1"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "21.8334",
                        y: "25.1667",
                        width: "2.5",
                        height: "5",
                        rx: "1.25",
                        fill: "#CBD5E1"
                    })
                ]
            })
        })
    });
};
var $aae2279e96d1e637$export$2e2bcd8739ae039 = $aae2279e96d1e637$var$BarChartupIcon;

});

parcelRegister("7ad9J", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e6bc56d6e2cd514$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $4e6bc56d6e2cd514$var$LineChartupIcon = ({ className: className, width: width = "52", height: height = "52", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "none",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "52",
                        height: "52",
                        rx: "26",
                        fill: "#3E4758"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M20.1667 31.8333H32.6667C33.1269 31.8333 33.5 32.2064 33.5 32.6667C33.5 33.1269 33.1269 33.5 32.6667 33.5H19.3333C18.8731 33.5 18.5 33.1269 18.5 32.6667V19.3333C18.5 18.8731 18.8731 18.5 19.3333 18.5C19.7936 18.5 20.1667 18.8731 20.1667 19.3333V31.8333Z",
                        fill: "#CBD5E1"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M23.2747 28.2366C22.9599 28.5724 22.4325 28.5894 22.0968 28.2746C21.761 27.9598 21.744 27.4325 22.0588 27.0967L25.1838 23.7634C25.4882 23.4387 25.9941 23.4105 26.3326 23.6994L28.7991 25.8041L32.0126 21.7336C32.2978 21.3724 32.8218 21.3107 33.1831 21.5959C33.5443 21.8811 33.606 22.4051 33.3208 22.7664L29.5708 27.5164C29.2779 27.8874 28.7354 27.9407 28.3758 27.6339L25.8557 25.4835L23.2747 28.2366Z",
                        fill: "#CBD5E1"
                    })
                ]
            })
        })
    });
};
var $4e6bc56d6e2cd514$export$2e2bcd8739ae039 = $4e6bc56d6e2cd514$var$LineChartupIcon;

});

parcelRegister("efLll", function(module, exports) {

$parcel$export(module.exports, "default", () => $49f86b003b29c9db$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $49f86b003b29c9db$var$TagIcon = ({ className: className, width: width = "52", height: height = "52", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "none",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "52",
                        height: "52",
                        rx: "26",
                        fill: "#3E4758"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M24.3057 33.0607L18.9356 27.6906C18.3548 27.1063 18.3548 26.1627 18.9356 25.5785L25.6773 18.9504C25.9575 18.675 26.3346 18.5206 26.7275 18.5206H32.1062C32.9335 18.5206 33.6041 19.1913 33.6041 20.0186V25.3819C33.6041 25.7839 33.4426 26.169 33.1558 26.4506L26.4253 33.0607C26.1443 33.3419 25.763 33.5 25.3655 33.5C24.9679 33.5 24.5866 33.3419 24.3057 33.0607ZM31.6069 22.0158C31.6069 22.8431 30.9362 23.5138 30.1089 23.5138C29.2816 23.5138 28.611 22.8431 28.611 22.0158C28.611 21.1885 29.2816 20.5179 30.1089 20.5179C30.9362 20.5179 31.6069 21.1885 31.6069 22.0158Z",
                        fill: "#CBD5E1"
                    })
                ]
            })
        })
    });
};
var $49f86b003b29c9db$export$2e2bcd8739ae039 = $49f86b003b29c9db$var$TagIcon;

});

parcelRegister("gHqi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $56081ac6d5e21852$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $56081ac6d5e21852$var$PercentIcon = ({ className: className, width: width = "52", height: height = "52", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "none",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "52",
                        height: "52",
                        rx: "26",
                        fill: "#3E4758"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M31.2656 20.7401C30.7395 20.214 29.8866 20.2136 29.3601 20.7393L20.7982 29.2881C20.2674 29.818 20.2671 30.6779 20.7974 31.2082C21.3277 31.7385 22.1876 31.7382 22.7175 31.2075L31.2663 22.6456C31.792 22.1191 31.7917 21.2662 31.2656 20.7401Z",
                        fill: "#CBD5E1"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.775 24.2143C23.1224 24.2143 24.2142 23.1227 24.2142 21.7738C24.2142 20.4249 23.1224 19.3333 21.775 19.3333C20.4276 19.3333 19.3333 20.4249 19.3333 21.7738C19.3333 23.1227 20.4276 24.2143 21.775 24.2143ZM30.2274 32.6667C31.5748 32.6667 32.6666 31.5751 32.6666 30.2262C32.6666 28.8748 31.5748 27.7857 30.2274 27.7857C28.8799 27.7857 27.7856 28.8748 27.7856 30.2262C27.7856 31.5751 28.8799 32.6667 30.2274 32.6667Z",
                        fill: "#CBD5E1"
                    })
                ]
            })
        })
    });
};
var $56081ac6d5e21852$export$2e2bcd8739ae039 = $56081ac6d5e21852$var$PercentIcon;

});

parcelRegister("iu7lD", function(module, exports) {

$parcel$export(module.exports, "default", () => $232dbd87180c9d51$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $232dbd87180c9d51$var$CircleDollarIcon = ({ className: className, width: width = "52", height: height = "52", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "none",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "52",
                        height: "52",
                        rx: "26",
                        fill: "#3E4758"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M26.7498 26.3176V28.9324C27.1815 28.8527 27.5744 28.7046 27.8875 28.4999C28.3697 28.1846 28.4998 27.852 28.4998 27.625C28.4998 27.398 28.3697 27.0654 27.8875 26.7501C27.5744 26.5454 27.1815 26.3973 26.7498 26.3176Z",
                        fill: "#CBD5E1"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M24.3295 24.1195C24.3833 24.1754 24.4445 24.2305 24.5139 24.2842C24.7219 24.4448 24.9734 24.5678 25.2499 24.6469V22.1031C25.1753 22.1245 25.1026 22.149 25.032 22.1766C24.9871 22.1942 24.943 22.213 24.9 22.233C24.7598 22.2982 24.6301 22.3761 24.5139 22.4659C24.1365 22.7576 23.9999 23.0925 23.9999 23.375C23.9999 23.5589 24.0577 23.7649 24.2022 23.9668C24.2389 24.0181 24.2811 24.0691 24.3295 24.1195Z",
                        fill: "#CBD5E1"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M33.9999 25.5C33.9999 29.9183 30.4182 33.5 25.9999 33.5C21.5816 33.5 17.9999 29.9183 17.9999 25.5C17.9999 21.0817 21.5816 17.5 25.9999 17.5C30.4182 17.5 33.9999 21.0817 33.9999 25.5ZM25.9998 19.5C26.414 19.5 26.7498 19.8358 26.7498 20.25V20.5658C27.3421 20.6711 27.9181 20.9043 28.4029 21.2789C28.8292 21.6083 29.1465 22.0184 29.3281 22.479C29.48 22.8643 29.2907 23.2999 28.9054 23.4517C28.52 23.6036 28.0845 23.4144 27.9326 23.029C27.8598 22.8444 27.7199 22.6467 27.4858 22.4659C27.2778 22.3052 27.0263 22.1823 26.7498 22.1031V24.7994C27.4479 24.8923 28.1326 25.1182 28.7084 25.4947C29.4954 26.0093 29.9998 26.7644 29.9998 27.625C29.9998 28.4856 29.4954 29.2407 28.7084 29.7553C28.1326 30.1318 27.4479 30.3577 26.7498 30.4506V30.75C26.7498 31.1642 26.414 31.5 25.9998 31.5C25.5856 31.5 25.2498 31.1642 25.2498 30.75V30.4506C24.5517 30.3577 23.8671 30.1318 23.2913 29.7553C22.8088 29.4398 22.4336 29.0376 22.2133 28.5672C22.0376 28.192 22.1993 27.7455 22.5744 27.5699C22.9495 27.3942 23.396 27.5559 23.5717 27.931C23.6525 28.1035 23.8168 28.3067 24.1122 28.4999C24.4252 28.7046 24.8182 28.8526 25.2498 28.9324V26.1842C24.6575 26.0789 24.0815 25.8457 23.5967 25.4711C22.9002 24.9329 22.4998 24.1802 22.4998 23.375C22.4998 22.5698 22.9002 21.8171 23.5967 21.2789C24.0815 20.9043 24.6575 20.6711 25.2498 20.5658V20.25C25.2498 19.8358 25.5856 19.5 25.9998 19.5Z",
                        fill: "#CBD5E1"
                    })
                ]
            })
        })
    });
};
var $232dbd87180c9d51$export$2e2bcd8739ae039 = $232dbd87180c9d51$var$CircleDollarIcon;

});

parcelRegister("iBAju", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2966b63360cd6df$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $e2966b63360cd6df$var$DollarBillIcon = ({ className: className, width: width = "52", height: height = "52", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "none",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "52",
                        height: "52",
                        rx: "26",
                        fill: "#3E4758"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M17.7195 30.4552C17.7195 30.7754 17.9329 30.9951 18.2594 30.9951H33.7407C34.0671 30.9951 34.2806 30.7754 34.2806 30.4552V21.0572C34.2806 20.7308 34.0671 20.5173 33.7407 20.5173H18.2594C17.9329 20.5173 17.7195 20.7308 17.7195 21.0572V30.4552ZM19.0441 29.3252V22.1872C19.0441 21.9549 19.1634 21.8419 19.3831 21.8419H32.6232C32.8367 21.8419 32.9622 21.9549 32.9622 22.1872V29.3252C32.9622 29.5512 32.8367 29.6705 32.6232 29.6705H19.3831C19.1634 29.6705 19.0441 29.5512 19.0441 29.3252ZM19.7347 28.8355C19.7347 28.9297 19.7849 28.9736 19.8728 28.9736H24.5498C23.9409 28.3207 23.583 27.1844 23.583 25.7468C23.583 24.3217 23.9409 23.1917 24.5436 22.5325H19.8728C19.7849 22.5325 19.7347 22.5827 19.7347 22.6706V28.8355ZM27.4377 28.9736H32.1335C32.2152 28.9736 32.2654 28.9297 32.2654 28.8355V22.6706C32.2654 22.5827 32.2152 22.5325 32.1335 22.5325H27.444C28.0655 23.1917 28.4296 24.3217 28.4296 25.7468C28.4296 27.1844 28.0592 28.3207 27.4377 28.9736ZM24.3741 25.7468C24.3741 27.6239 25.027 28.8355 25.9749 28.8355C26.9606 28.8355 27.6323 27.6239 27.6323 25.7468C27.6323 23.876 26.9606 22.6706 25.9749 22.6706C25.027 22.6706 24.3741 23.876 24.3741 25.7468Z",
                        fill: "#CBD5E1"
                    })
                ]
            })
        })
    });
};
var $e2966b63360cd6df$export$2e2bcd8739ae039 = $e2966b63360cd6df$var$DollarBillIcon;

});

parcelRegister("eJiOx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1394f9e328e5e71$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $b1394f9e328e5e71$var$ClearbooksIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        clipPath: "url(#clip0_1771_3963)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M28.7455 16.6582H19.8139C18.5748 16.6582 17.5615 17.6721 17.5615 18.9106V30.5478C17.5615 31.7863 18.5748 32.8002 19.8139 32.8002H28.7455C29.9847 32.8002 30.9979 31.7863 30.9979 30.5478V18.9113C30.9979 17.6727 29.9847 16.6588 28.7455 16.6588V16.6582ZM29.7255 30.2853C29.7255 30.9049 29.2185 31.4112 28.5989 31.4112H19.9637C19.3441 31.4112 18.8378 30.9049 18.8378 30.2853V19.1737C18.8378 18.5541 19.3441 18.0472 19.9637 18.0472H28.5983C29.2179 18.0472 29.7248 18.5541 29.7248 19.1737V30.286L29.7255 30.2853Z",
                                fill: "#268CC0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M11.4048 21.9513C10.7852 21.9513 10.2783 21.4443 10.2783 20.8254V9.71309C10.2783 9.0935 10.7852 8.5872 11.4048 8.5872H20.0394C20.659 8.5872 21.1653 9.0935 21.1653 9.71309V10.9894H22.439V9.45066C22.439 8.21212 21.4258 7.19824 20.1866 7.19824H11.2544C10.0152 7.19824 9.00195 8.21212 9.00195 9.45066V21.0872C9.00195 22.3264 10.0152 23.3409 11.2544 23.3409H12.2305V21.9519H11.4048V21.9513Z",
                                fill: "#D92A2D"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.8345 26.7566C15.2155 26.7566 14.7092 26.2503 14.7092 25.6307V14.5184C14.7092 13.8988 15.2155 13.3919 15.8345 13.3919H24.4697C25.0893 13.3919 25.5956 13.8988 25.5956 14.5184V15.5694H26.868V14.256C26.868 13.0168 25.8548 12.0029 24.6163 12.0029H15.6841C14.4455 12.0029 13.4316 13.0168 13.4316 14.256V25.8931C13.4316 27.1317 14.4462 28.1449 15.6841 28.1449H16.36V26.7566H15.8345Z",
                                fill: "#F3B21D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_1771_3963",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                width: "21.9961",
                                height: "25.6029",
                                fill: "white",
                                transform: "translate(9.00195 7.19824)"
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $b1394f9e328e5e71$export$2e2bcd8739ae039 = $b1394f9e328e5e71$var$ClearbooksIcon;

});

parcelRegister("afndG", function(module, exports) {

$parcel$export(module.exports, "default", () => $35def12fe2523ab5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $35def12fe2523ab5$var$ExactIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M31.0003 12.002H8.99902V18.002H31.0003V12.002ZM31.0003 21.9998H8.99902V27.9995H31.0003V21.9998Z",
                    fill: "#E2161F"
                })
            })
        })
    });
};
var $35def12fe2523ab5$export$2e2bcd8739ae039 = $35def12fe2523ab5$var$ExactIcon;

});

parcelRegister("kg0bP", function(module, exports) {

$parcel$export(module.exports, "default", () => $19fc3bb7b4fc9a23$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $19fc3bb7b4fc9a23$var$FreeAgentIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        clipPath: "url(#clip0_1771_4077)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M25.2522 14.458L23.2737 19.8092L25.1795 24.6244H21.5064L20.123 28.3248H26.6163L27.9065 31.5084H31.9964L25.2522 14.458Z",
                                fill: "#7CC04A"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M27.077 8.64684C23.3546 7.91333 21.5201 9.90547 20.8853 11.5302C20.7619 11.8428 20.6001 12.2664 19.7295 14.5465C19.0289 6.86448 11.7513 14.094 8.15097 10.0686C7.58335 13.5456 8.83101 13.9638 8.83101 13.9638C8.55954 15.0908 9.65501 16.3165 10.5544 16.1629C11.3579 19.9141 19.2661 14.5026 17.3973 20.6381C15.6191 25.2996 13.2554 31.4995 13.2554 31.4995H17.6976C17.6976 31.4995 23.8714 14.9701 24.2293 14.2037C24.7119 13.1741 26.2461 12.7723 27.4718 13.6361L29.065 9.23091C28.2451 8.90186 27.5788 8.74419 27.0756 8.64684H27.077ZM17.9225 16.4906C16.4993 14.4505 12.9236 17.3338 12.1558 15.0442C11.2495 15.2389 10.915 14.1927 11.1357 13.8212C11.1357 13.8212 10.383 13.7047 10.4667 12.6352C13.1964 14.445 18.4818 9.88902 17.9238 16.492L17.9225 16.4906Z",
                                fill: "#007ABF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_1771_4077",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                width: "23.9934",
                                height: "23.0186",
                                fill: "white",
                                transform: "translate(8.00293 8.49023)"
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $19fc3bb7b4fc9a23$export$2e2bcd8739ae039 = $19fc3bb7b4fc9a23$var$FreeAgentIcon;

});

parcelRegister("cad5S", function(module, exports) {

$parcel$export(module.exports, "default", () => $46da0431fe74e260$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $46da0431fe74e260$var$FreshbooksIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        clipPath: "url(#clip0_1771_4569)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M14.6289 9.80273H28.1738V29.9644H14.6289V9.80273Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M17.976 7C11.9042 7 7 11.9042 7 17.976V33H22.024C28.0958 33 33 28.0958 33 22.024V7H17.976ZM26.8503 11.5928C26.8503 13.6168 25.2156 15.1737 23.2695 15.1737H19.3772V18.2874H24.5928V21.8683H19.4551V29.3413H15.1737V10.6587H19.3772V14.006C19.5329 12.1377 21.0898 10.6587 22.9581 10.6587H26.8503V11.5928Z",
                                fill: "#0075DD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_1771_4569",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                width: "26",
                                height: "26",
                                fill: "white",
                                transform: "translate(7 7)"
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $46da0431fe74e260$export$2e2bcd8739ae039 = $46da0431fe74e260$var$FreshbooksIcon;

});

parcelRegister("2Fks6", function(module, exports) {

$parcel$export(module.exports, "default", () => $36037036a9afd9e7$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $36037036a9afd9e7$var$KashFlowIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        clipPath: "url(#clip0_1771_4104)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M22.2392 16.9409C22.2392 16.9409 9.25874 7.98407 8.49891 22.6799C8.49891 22.6799 6.36909 16.5667 10.9626 12.7273C10.9626 12.7273 16.0109 8.17979 23.448 12.8481L24.2769 10.1484L29.7742 18.3454L21.2664 19.6003C21.2664 19.6003 22.0032 18.0115 22.2392 16.9466V16.9409Z",
                                fill: "#E5426E"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M17.7605 23.0546C17.7605 23.0546 30.7467 32.0113 31.5008 17.3213C31.5008 17.3213 33.6364 23.4345 29.0371 27.2739C29.0371 27.2739 23.9888 31.8214 16.5517 27.153L15.7228 29.8527L10.2773 21.6615L18.7851 20.4527C18.7851 20.4067 18.1001 21.9896 17.7663 23.0603L17.7605 23.0546Z",
                                fill: "#E5426E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_1771_4104",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                width: "23.9922",
                                height: "19.7153",
                                fill: "white",
                                transform: "translate(8.00391 10.1426)"
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $36037036a9afd9e7$export$2e2bcd8739ae039 = $36037036a9afd9e7$var$KashFlowIcon;

});

parcelRegister("a5wAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a635bf4fbccafa2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $0a635bf4fbccafa2$var$KashooIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        clipPath: "url(#clip0_1771_4810)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M29.0817 28.9901L21.8896 19.9739L29.0557 11.0098H10.9189V28.9901H29.0817Z",
                            fill: "#FFB700"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_1771_4810",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                width: "18.1628",
                                height: "17.9804",
                                fill: "white",
                                transform: "translate(10.9189 11.0098)"
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $0a635bf4fbccafa2$export$2e2bcd8739ae039 = $0a635bf4fbccafa2$var$KashooIcon;

});

parcelRegister("kr88V", function(module, exports) {

$parcel$export(module.exports, "default", () => $50395af3b4fd1dd0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $50395af3b4fd1dd0$var$MDynamicsIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        clipPath: "url(#clip0_1771_3993)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M23.3297 16.9873L24.3465 15.881C23.5221 15.0782 22.408 14.5699 21.2541 14.3478C21.2475 14.3466 21.2411 14.3454 21.2348 14.3442C21.0078 14.3017 21.0031 14.3008 21.0031 14.0654C21.0025 13.8606 21.0029 13.6559 21.0034 13.4512C21.0042 13.0576 21.0051 12.6639 20.9987 12.2703C20.9956 12.1029 21.0466 12.0094 21.2012 11.9419C23.9601 10.6449 22.4661 6.31125 19.4898 7.09254C17.1743 7.66728 16.9556 11.0361 19.1003 11.9615C19.2164 12.0151 19.2984 12.0691 19.2984 12.2156C19.2965 12.515 19.2966 12.8145 19.2967 13.1139C19.2969 13.4466 19.297 13.7792 19.2944 14.1119C19.293 14.282 19.2593 14.2965 19.0861 14.3397C19.0216 14.3558 18.9568 14.3715 18.892 14.3871C18.6375 14.4487 18.3825 14.5103 18.1374 14.5986C16.2809 15.2543 14.8601 16.9198 14.4747 18.8479C14.4251 19.0895 14.4177 19.0915 14.1774 19.0915C13.9371 19.0921 13.6969 19.0919 13.4566 19.0916C13.0219 19.091 12.5872 19.0905 12.1525 19.0953C11.9844 19.0973 11.898 19.0382 11.8268 18.8847C11.2149 17.3403 8.67229 16.8746 7.54474 18.4203C6.08612 20.0989 7.77187 22.9949 10.0033 22.4701C11.0955 22.2722 11.4459 21.6895 11.6956 21.2742C11.8424 21.0302 11.9543 20.844 12.1616 20.8279C12.4728 20.8358 12.7853 20.8331 13.0977 20.8305C13.5251 20.8269 13.9525 20.8233 14.3772 20.8465C14.8321 23.2501 16.5874 25.2126 19.0345 25.68L19.0455 25.6824C19.2951 25.7363 19.2991 25.7372 19.2991 26.0033C19.2996 26.1747 19.2979 26.3463 19.2962 26.5181C19.2925 26.8854 19.2888 27.2533 19.3072 27.6212C19.3227 27.9266 19.2225 28.0765 18.9437 28.2115C16.3106 29.5094 17.8462 33.6302 20.7003 32.9181C22.9585 32.4689 23.3388 29.1068 21.2238 28.1828C21.055 28.1011 20.995 28.0002 20.9987 27.8142C21.0067 27.3905 21.0053 26.9653 21.0038 26.5402C21.0033 26.3749 21.0027 26.2096 21.0027 26.0445L21.0027 26.0423C21.003 25.715 21.0031 25.7092 21.3119 25.6513C22.4512 25.4299 23.4562 24.8612 24.2662 24.0367L23.3074 22.9588C20.84 25.6469 16.0754 24.0769 15.8095 20.4125C15.4254 16.4598 20.5471 14.3654 23.3297 16.9873ZM19.3362 10.1714C18.5418 8.5822 20.971 7.79383 21.1691 9.60378V9.60411C21.1559 10.5835 19.8677 11.0499 19.3362 10.1714ZM20.1428 29.4284C18.8249 29.444 18.8458 31.4557 20.1387 31.4841C21.4225 31.4443 21.4347 29.4578 20.1428 29.4284ZM9.58654 18.9593C8.21297 18.9839 8.31793 21.0179 9.56022 21.0142C10.8575 20.996 10.866 19.0045 9.58654 18.9593ZM22.3091 18.8272C21.1981 16.4479 17.6511 17.43 17.7301 19.9716C17.668 22.6219 21.2484 23.5277 22.3409 21.0664C22.4131 20.9075 22.4937 20.8349 22.6763 20.8349C24.4898 20.8423 26.3032 20.8423 28.1166 20.8349C28.3036 20.8339 28.3876 20.9122 28.4517 21.0664C30.1513 24.3914 34.5704 21.3941 32.5812 18.458C31.6207 16.9798 29.125 17.1874 28.472 18.8768C28.3782 19.1019 28.2462 19.158 28.0144 19.158C26.9485 19.1523 25.8826 19.1525 24.8167 19.1526C24.1535 19.1527 23.4903 19.1528 22.8272 19.1515C22.6064 19.1512 22.5239 19.1652 22.473 19.1315C22.4222 19.0979 22.4028 19.0169 22.3091 18.8272ZM30.6609 18.9484C29.6485 18.9987 29.3596 20.4762 30.286 20.9193C31.7514 21.5018 32.1543 19.0304 30.6609 18.9484ZM19.2306 19.9824C19.2289 21.2112 20.9022 21.3877 21.108 20.1647C21.3055 18.7439 19.2913 18.4911 19.2306 19.9824Z",
                            fill: "#3D3E91"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_1771_3993",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                width: "26.0854",
                                height: "26",
                                fill: "white",
                                transform: "translate(7 7)"
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $50395af3b4fd1dd0$export$2e2bcd8739ae039 = $50395af3b4fd1dd0$var$MDynamicsIcon;

});

parcelRegister("9S4pw", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f208b7ec61edf22$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $0f208b7ec61edf22$var$MyobIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M30.8878 18.2255C30.0401 18.2255 29.35 18.9945 29.35 19.9507C29.35 20.8872 30.0401 21.6462 30.8878 21.6364C31.7356 21.6364 32.4257 20.9266 32.4257 19.9507C32.4257 18.9747 31.7356 18.2255 30.8878 18.2255ZM27.8023 15.3076C27.822 14.9725 27.9896 14.2627 29.0346 14.2627H29.35V17.5059C29.8133 17.0623 30.4245 16.806 31.1146 16.806C32.6918 16.806 33.9733 18.1664 33.9733 19.9408C33.9733 21.7152 32.6918 23.0658 31.1146 23.0658C30.3851 23.0658 29.7443 22.7897 29.281 22.2968V22.356C29.2712 22.5729 29.1331 22.9475 28.5417 22.9376H27.8023V15.3076ZM8.72742 16.7863C9.54562 16.7863 10.2061 17.1117 10.6398 17.6341C11.0933 17.1117 11.7735 16.7765 12.5523 16.7765C14.2281 16.7765 15.2237 17.8806 15.2237 19.4578V21.735C15.2139 22.7503 14.5337 22.9179 14.1887 22.9376H13.6859V19.4282C13.6859 19.0931 13.5676 18.2847 12.5523 18.2847C11.8819 18.2847 11.389 18.7481 11.389 19.4282V21.7646C11.3595 22.7503 10.6891 22.9179 10.354 22.9376H9.85121V19.4282C9.85121 19.0931 9.74278 18.2847 8.72742 18.2847C8.03737 18.2847 7.56419 18.7481 7.56419 19.4282V21.7547C7.54448 22.7503 6.87414 22.9179 6.52912 22.9376H6.02637V19.4578C6.02637 17.9397 7.09101 16.7765 8.72742 16.7863ZM18.3684 21.1828L19.6598 17.5946C19.9161 16.9341 20.5273 16.9144 20.5766 16.9144H21.6511L18.7824 24.0318C18.2501 25.3626 17.4418 25.7174 16.3771 25.7372L15.8054 24.3275V24.3176C16.6334 24.3669 17.0277 24.1796 17.3037 23.4896L17.353 23.3417C17.4286 23.115 17.4499 22.9878 17.3821 22.7694C17.3801 22.7672 17.3728 22.7587 17.3728 22.7502C17.3629 22.7404 17.3629 22.7305 17.3629 22.7305L17.3662 22.7341L14.9872 16.9144H16.1898C16.1898 16.9144 16.7418 16.875 16.9587 17.4664L18.3684 21.1828ZM22.7946 19.9506C22.7946 18.9155 23.455 18.186 24.2732 18.186C25.0914 18.186 25.7519 18.9056 25.7519 19.9506C25.7519 20.9955 25.0914 21.6658 24.2732 21.6658C23.455 21.6658 22.7946 20.9659 22.7946 19.9506ZM21.2567 19.9407C21.2567 21.7349 22.6073 23.0755 24.2732 23.0755C25.9392 23.0755 27.2996 21.7349 27.2996 19.9407C27.2996 18.1466 25.9392 16.7862 24.2732 16.7862C22.6073 16.7764 21.2567 18.1466 21.2567 19.9407Z",
                        fill: "url(#paint0_linear_1771_4789)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint0_linear_1771_4789",
                            x1: "6.02637",
                            y1: "18.6642",
                            x2: "33.9734",
                            y2: "18.6642",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.36",
                                    stopColor: "#6100A5"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.46",
                                    stopColor: "#7001A0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.64",
                                    stopColor: "#980293"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.89",
                                    stopColor: "#D9057E"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.97",
                                    stopColor: "#ED0677"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $0f208b7ec61edf22$export$2e2bcd8739ae039 = $0f208b7ec61edf22$var$MyobIcon;

});

parcelRegister("hAtyA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8178e3810b88d08$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $b8178e3810b88d08$var$NetsuiteIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        clipPath: "url(#clip0_1771_3944)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M9.7521 14.8662H14.1758V25.3755H16.3781V29.4818H9.75098V14.8662H9.7521ZM30.229 24.5356H25.8053V14.0263H23.603V9.91992H30.2301V24.5356H30.229Z",
                                fill: "#BACCDB"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M8.72461 8.91211H22.7055V20.915L17.3298 13.9896H8.72461V8.91211ZM31.2367 30.5093H17.2558V18.5064L22.6315 25.4318H31.2367",
                                fill: "#125580"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_1771_3944",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                width: "28",
                                height: "28",
                                fill: "white",
                                transform: "translate(6 6)"
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $b8178e3810b88d08$export$2e2bcd8739ae039 = $b8178e3810b88d08$var$NetsuiteIcon;

});

parcelRegister("9Udyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $628a80cc026c2ebd$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $628a80cc026c2ebd$var$PandleIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.04 22.4572L19.9989 27.6304L28.9595 22.4572V12.1126L19.9989 6.93945L11.04 12.1126V22.4572ZM17.6641 15.9353L19.9989 14.5865L22.3354 15.9353V18.6346L19.9989 19.9833L17.6641 18.6346V15.9353ZM15.7132 29.0143V31.7118L13.3766 33.0606L11.04 31.7118V29.0143L13.3766 27.6655L15.7132 29.0143Z",
                    fill: "#03A9F5"
                })
            })
        })
    });
};
var $628a80cc026c2ebd$export$2e2bcd8739ae039 = $628a80cc026c2ebd$var$PandleIcon;

});

parcelRegister("g5Cx4", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bdf20e348d1151$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $77bdf20e348d1151$var$QuickbooksIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        clipPath: "url(#clip0_1771_3927)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M7 20C7 12.8212 12.8212 7 20 7C27.1788 7 33 12.8212 33 20C33 27.1788 27.1788 33 20 33C12.8212 33 7 27.1788 7 20Z",
                                fill: "#2DA44A"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M24.3332 14.947H23.6133V16.8257H24.3332C26.0885 16.8257 27.5078 18.2518 27.5078 20.0002C27.5078 21.7555 26.0817 23.1748 24.3332 23.1748H22.5985C22.5985 23.1748 22.5985 13.5414 22.5985 13.3494C22.5985 12.3141 21.7552 11.4707 20.7198 11.4707V25.0467C20.7198 25.0467 22.6602 25.0467 24.3332 25.0467C27.1239 25.0467 29.3865 22.784 29.3865 19.9934C29.3934 17.2096 27.1239 14.947 24.3332 14.947ZM10.6064 20.0002C10.6064 22.7909 12.8691 25.0535 15.6597 25.0535H16.3797V23.1748H15.6597C13.9044 23.1748 12.4851 21.7487 12.4851 20.0002C12.4851 18.245 13.9113 16.8257 15.6597 16.8257H17.3944C17.3944 16.8257 17.3944 26.4591 17.3944 26.6511C17.3944 27.6864 18.2378 28.5298 19.2731 28.5298V14.9538C19.2731 14.9538 17.3327 14.9538 15.6597 14.9538C12.876 14.947 10.6064 17.2096 10.6064 20.0002Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_1771_3927",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                width: "26",
                                height: "26",
                                fill: "white",
                                transform: "translate(7 7)"
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $77bdf20e348d1151$export$2e2bcd8739ae039 = $77bdf20e348d1151$var$QuickbooksIcon;

});

parcelRegister("8UjqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d5f10f1c52f2020$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $3d5f10f1c52f2020$var$SageIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        clipPath: "url(#clip0_1771_4132)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M30.3668 16C28.207 16 26.7979 17.4789 26.7979 19.9239C26.7979 22.9605 28.9563 23.828 30.5048 23.828C31.6682 23.828 32.7724 23.3548 33.5703 22.5161L32.5752 21.521C32.0428 21.9943 31.4316 22.2808 30.5246 22.2808C29.3218 22.2808 28.5133 21.5815 28.5133 20.614H33.8766C33.8661 20.6048 34.8034 16 30.3668 16ZM28.5133 19.2929C28.5133 17.9915 29.4992 17.3711 30.5535 17.3711C31.6077 17.3711 32.5647 18.0112 32.5647 19.2929H28.5133Z",
                                fill: "#00DC06"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M10.6189 19.1654C9.92877 19.0773 7.94645 19.1562 7.94645 18.2492C7.94645 17.7168 8.78381 17.421 9.54361 17.421C10.352 17.4105 11.1408 17.6379 11.8112 18.0717L12.8457 17.0464C12.5421 16.7992 11.4076 16 9.54492 16C7.84786 16 6.32037 16.8873 6.32037 18.307C6.32037 20.4852 8.95338 20.4852 10.0471 20.5943C10.7175 20.664 11.3182 20.7034 11.3182 21.3541C11.3182 21.9654 10.3915 22.3006 9.67243 22.3006C8.49855 22.3006 7.79922 21.9154 7.10909 21.2949L6.00488 22.4084C6.96186 23.3351 8.25274 23.8373 9.58436 23.828C11.5562 23.828 12.9864 22.9605 12.9864 21.2148C12.9864 20.0606 12.2069 19.3718 10.6202 19.1641",
                                fill: "#00DC06"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.2776 16.0002C15.1839 15.9897 14.1086 16.3643 13.2515 17.0453L14.2873 18.0811C14.8697 17.6473 15.569 17.4212 16.2881 17.4304C17.6 17.4304 17.9943 17.9523 17.9943 18.5452V19.2839H15.6571C14.7895 19.2839 13.0938 19.5008 13.0938 21.4043C13.0938 22.8042 13.8917 23.8296 15.8056 23.8296C16.7626 23.8296 17.4922 23.5246 17.9943 22.9225V23.6824H19.6901V18.6621C19.6888 16.9072 18.6148 16.0002 16.2776 16.0002ZM18.0022 20.9389C18.0022 22.3875 16.9664 22.3087 16.0501 22.3087C15.1339 22.3087 14.5226 22.0628 14.5226 21.4108C14.5226 20.8101 15.0064 20.6024 16.012 20.6024H18.0035V20.9376L18.0022 20.9389Z",
                                fill: "#00DC06"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M24.9245 16.1577V16.9964C24.3422 16.3352 23.6521 16 22.7161 16C21.1084 16 20.2803 16.8978 20.0042 17.864C19.8951 18.2189 19.8662 18.8999 19.8662 19.9055C19.8662 20.8519 19.8767 21.7195 20.2014 22.3794C20.6641 23.3062 21.7789 23.828 22.7148 23.828C23.6508 23.828 24.3908 23.4731 24.9232 22.8619V23.3351C24.9232 23.8872 24.7352 24.2513 24.3816 24.5379C24.0267 24.8231 23.5837 25.0019 22.9619 25.0019C22.3993 25.0019 21.8682 24.697 21.562 24.4801L20.4183 25.6237C21.1571 26.2244 22.0352 26.6293 22.9909 26.6385C23.9071 26.6582 24.8049 26.3625 25.524 25.7814C26.2036 25.2491 26.6387 24.2329 26.6387 23.1682V16.1577H24.9232H24.9245ZM24.9245 19.9042C24.9245 20.4852 24.914 20.919 24.8654 21.1464C24.7563 21.6301 24.2042 22.2703 23.1999 22.2703C22.9435 22.2703 21.6619 22.1218 21.5133 21.0084C21.4739 20.6442 21.4542 20.2696 21.4634 19.9042C21.4634 19.0366 21.5028 18.7605 21.5422 18.5436C21.6303 18.1098 22.2035 17.4591 23.1986 17.4591C24.4119 17.4591 24.8062 18.2873 24.8641 18.6133C24.914 19.0379 24.9324 19.4704 24.9232 19.9042",
                                fill: "#00DC06"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_1771_4132",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                width: "27.947",
                                height: "10.6385",
                                fill: "white",
                                transform: "translate(6.00488 16)"
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $3d5f10f1c52f2020$export$2e2bcd8739ae039 = $3d5f10f1c52f2020$var$SageIcon;

});

parcelRegister("h9waA", function(module, exports) {

$parcel$export(module.exports, "default", () => $69cbd88a93031dd8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $69cbd88a93031dd8$var$WaveIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        clipPath: "url(#clip0_1771_4113)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M10.0022 26.0899C11.4046 26.5358 12.9008 25.82 13.3291 24.4998L14.9134 19.3657C15.3417 18.0455 14.5437 16.602 13.1472 16.1561L13.0299 16.1209C11.6275 15.675 10.1313 16.3908 9.70297 17.711L8.11873 22.8451C7.6904 24.1653 8.48838 25.6087 9.88486 26.0547L10.0022 26.0899Z",
                                fill: "#084F99"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M26.7242 11.5033C27.0234 10.7815 27.575 10.23 28.2263 9.93661C28.2615 9.91901 28.2908 9.90728 28.326 9.88967C28.3436 9.88381 28.3612 9.87794 28.3847 9.8662C28.9186 9.66084 29.5112 9.62563 30.0804 9.80166L30.1977 9.83687C31.6001 10.2828 32.3453 11.8788 31.8524 13.3867C31.8524 13.3867 28.015 26.3423 28.015 26.354C27.0117 29.3347 23.8315 30.8779 21.0854 30.1034C21.0854 30.1034 20.3461 29.8863 20.041 29.6633C22.7636 29.0766 26.1843 12.8058 26.73 11.4915L26.7242 11.5033Z",
                                fill: "#5EB7FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M10.4478 27.8039C11.0404 27.9917 11.6507 28.0034 12.2257 27.8684C12.3196 27.8508 12.4076 27.8215 12.4956 27.7922C13.6222 27.4342 14.5962 26.513 15.0069 25.2398L17.9935 15.3764C18.4864 13.8802 20.0295 13.0177 21.4201 13.4577L21.5375 13.4929C22.9398 13.9389 23.685 15.5348 23.1921 17.0428C23.1921 17.0428 20.3464 26.3898 19.9532 27.1702C17.0488 32.4275 11.5979 29.8575 10.0547 27.6572C10.1427 27.6924 10.2307 27.7276 10.3246 27.757L10.4419 27.7922L10.4478 27.8039Z",
                                fill: "#1479FB"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_1771_4113",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                width: "23.9983",
                                height: "20.6186",
                                fill: "white",
                                transform: "translate(8.00098 9.69043)"
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $69cbd88a93031dd8$export$2e2bcd8739ae039 = $69cbd88a93031dd8$var$WaveIcon;

});

parcelRegister("432Bs", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd1c68f0ee71d992$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $dd1c68f0ee71d992$var$XeroIcon = ({ className: className, width: width = "40", height: height = "40", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "currentColor",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M20 7C12.8207 7 7 12.8207 7 20C7 27.1793 12.8207 33 20 33C27.1793 33 33 27.1793 33 20C33 12.8207 27.1793 7 20 7ZM27.1337 22.8763C25.525 22.8763 24.2196 21.5697 24.2196 19.9632C24.2196 18.3544 25.5272 17.0479 27.1337 17.0479C28.7425 17.0479 30.0479 18.3555 30.0479 19.9632C30.0479 21.5708 28.7403 22.8763 27.1337 22.8763ZM15.1575 22.8643C15.0503 22.8643 14.9495 22.8199 14.8683 22.7387L12.655 20.5287L10.432 22.7463C10.3573 22.8199 10.2587 22.8632 10.1525 22.8632C9.93367 22.8632 9.75383 22.6834 9.75383 22.4646C9.75383 22.3573 9.79717 22.2577 9.87408 22.1797L12.0841 19.9588L9.87625 17.7413C9.795 17.6665 9.75383 17.5658 9.75383 17.4585C9.75383 17.2386 9.93367 17.062 10.1525 17.062C10.2587 17.062 10.3562 17.1021 10.432 17.1757L12.6583 19.3944L14.8769 17.179C14.9517 17.1021 15.0524 17.062 15.1586 17.062C15.3872 17.062 15.5648 17.2408 15.5648 17.4585C15.5648 17.5647 15.5334 17.6622 15.4522 17.738L13.2248 19.9643L15.4511 22.1862C15.5248 22.2609 15.5638 22.3595 15.5638 22.4657C15.5638 22.6845 15.385 22.8643 15.1683 22.8643H15.1575ZM23.8426 17.8908C22.9803 18.0002 22.8871 18.4064 22.8871 19.4117V22.431C22.8871 22.6498 22.7083 22.8275 22.4906 22.8275C22.2707 22.8275 22.093 22.6488 22.0919 22.431V17.5235C22.0919 17.3025 22.2653 17.127 22.4841 17.127C22.6639 17.127 22.8264 17.2624 22.8589 17.4401C23.1514 17.2137 23.5089 17.0967 23.8664 17.0967H23.9802C24.1914 17.0967 24.3691 17.2754 24.3691 17.4953C24.3691 17.7131 24.1914 17.8767 23.9628 17.8843C23.9628 17.8843 23.8653 17.8843 23.7852 17.8929L23.8426 17.8908ZM20.494 20.2795H16.3438C16.3438 20.3001 16.347 20.3196 16.3503 20.3413C16.3719 20.455 16.399 20.5698 16.4402 20.6771C16.6503 21.2523 17.2689 22.0583 18.4216 22.0746C18.7791 22.0713 19.1052 21.9814 19.3966 21.8265C19.6241 21.6965 19.8202 21.5329 19.9653 21.3628C20.0141 21.3 20.0628 21.2415 20.0953 21.1808C20.2903 20.9328 20.5341 20.9793 20.6803 21.0909C20.858 21.2372 20.8753 21.5145 20.7291 21.7084L20.7118 21.7258C20.4843 22.0183 20.2405 22.262 19.9653 22.4408C19.6891 22.6184 19.3966 22.7484 19.0868 22.8145C18.7292 22.912 18.388 22.9272 18.0305 22.8795C16.8443 22.7333 15.853 21.872 15.5605 20.702C15.4955 20.4745 15.463 20.247 15.463 20.0033C15.463 19.077 15.9191 18.167 16.6818 17.6145C17.6405 16.9483 18.9405 16.8995 19.9318 17.5332C20.6143 17.972 21.053 18.6393 21.2155 19.4518C21.2968 19.9058 21.0617 20.2622 20.494 20.2795ZM27.1337 17.8713C25.9811 17.8713 25.0418 18.8083 25.0418 19.9632C25.0418 21.1158 25.98 22.0551 27.1337 22.0551C28.2875 22.0551 29.2257 21.1158 29.2257 19.9632C29.2257 18.8094 28.2875 17.8691 27.1337 17.8691V17.8713ZM27.1337 20.6825C26.7362 20.6825 26.4123 20.3608 26.4123 19.961C26.4123 19.5634 26.7372 19.2406 27.1337 19.2406C27.5313 19.2406 27.8563 19.5645 27.8563 19.961C27.8563 20.3608 27.5313 20.6836 27.1337 20.6825ZM18.4238 17.8626C17.4379 17.8626 16.6124 18.5375 16.3806 19.4508V19.4833H20.4713C20.2513 18.557 19.4172 17.8648 18.4227 17.8648V17.8626H18.4238Z",
                        fill: "#13B5EA"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M27.1299 22.8781C25.5212 22.8781 24.2157 21.5716 24.2157 19.9651C24.2157 18.3563 25.5233 17.0498 27.1299 17.0498C28.7387 17.0498 30.0441 18.3574 30.0441 19.9651C30.0441 21.5727 28.7365 22.8781 27.1299 22.8781ZM15.1537 22.8662C15.0464 22.8662 14.9457 22.8218 14.8644 22.7406L12.6512 20.5306L10.4282 22.7481C10.3534 22.8218 10.2548 22.8651 10.1487 22.8651C9.92983 22.8651 9.75 22.6853 9.75 22.4665C9.75 22.3592 9.79333 22.2596 9.87025 22.1816L12.0803 19.9607L9.87242 17.7431C9.79117 17.6684 9.75 17.5676 9.75 17.4604C9.75 17.2405 9.92983 17.0639 10.1487 17.0639C10.2548 17.0639 10.3523 17.104 10.4282 17.1776L12.6544 19.3963L14.8731 17.1809C14.9478 17.104 15.0486 17.0639 15.1547 17.0639C15.3833 17.0639 15.561 17.2426 15.561 17.4604C15.561 17.5666 15.5296 17.6641 15.4483 17.7399L13.221 19.9661L15.4473 22.1881C15.5209 22.2628 15.5599 22.3614 15.5599 22.4676C15.5599 22.6864 15.3812 22.8662 15.1645 22.8662H15.1537ZM23.8388 17.8926C22.9764 18.0021 22.8833 18.4083 22.8833 19.4136V22.4329C22.8833 22.6517 22.7045 22.8294 22.4867 22.8294C22.2668 22.8294 22.0892 22.6506 22.0881 22.4329V17.5254C22.0881 17.3044 22.2614 17.1289 22.4803 17.1289C22.6601 17.1289 22.8226 17.2643 22.8551 17.442C23.1476 17.2156 23.5051 17.0986 23.8626 17.0986H23.9763C24.1876 17.0986 24.3653 17.2773 24.3653 17.4972C24.3653 17.715 24.1876 17.8786 23.959 17.8861C23.959 17.8861 23.8615 17.8861 23.7813 17.8948L23.8388 17.8926ZM20.4902 20.2814H16.3399C16.3399 20.302 16.3432 20.3215 16.3464 20.3431C16.3681 20.4569 16.3952 20.5717 16.4363 20.679C16.6465 21.2542 17.2651 22.0602 18.4178 22.0765C18.7753 22.0732 19.1013 21.9833 19.3927 21.8284C19.6202 21.6984 19.8163 21.5348 19.9615 21.3647C20.0103 21.3019 20.059 21.2434 20.0915 21.1827C20.2865 20.9346 20.5303 20.9812 20.6765 21.0928C20.8542 21.2391 20.8715 21.5164 20.7253 21.7103L20.7079 21.7276C20.4804 22.0201 20.2367 22.2639 19.9615 22.4426C19.6853 22.6203 19.3927 22.7503 19.0829 22.8164C18.7254 22.9139 18.3842 22.9291 18.0267 22.8814C16.8404 22.7351 15.8492 21.8739 15.5567 20.7039C15.4917 20.4764 15.4592 20.2489 15.4592 20.0051C15.4592 19.0789 15.9152 18.1689 16.6779 17.6164C17.6367 16.9501 18.9367 16.9014 19.9279 17.5351C20.6104 17.9739 21.0492 18.6412 21.2117 19.4537C21.2929 19.9076 21.0578 20.2641 20.4902 20.2814ZM27.1299 17.8731C25.9772 17.8731 25.038 18.8102 25.038 19.9651C25.038 21.1177 25.9762 22.057 27.1299 22.057C28.2837 22.057 29.2218 21.1177 29.2218 19.9651C29.2218 18.8113 28.2837 17.871 27.1299 17.871V17.8731ZM27.1299 20.6844C26.7323 20.6844 26.4084 20.3626 26.4084 19.9629C26.4084 19.5653 26.7334 19.2425 27.1299 19.2425C27.5275 19.2425 27.8525 19.5664 27.8525 19.9629C27.8525 20.3626 27.5275 20.6855 27.1299 20.6844ZM18.4199 17.8645C17.4341 17.8645 16.6086 18.5394 16.3767 19.4526V19.4851H20.4674C20.2475 18.5589 19.4133 17.8666 18.4188 17.8666V17.8645H18.4199Z",
                        fill: "white"
                    })
                ]
            })
        })
    });
};
var $dd1c68f0ee71d992$export$2e2bcd8739ae039 = $dd1c68f0ee71d992$var$XeroIcon;

});

parcelRegister("e5JRm", function(module, exports) {

$parcel$export(module.exports, "default", () => $77872a9552c12fe0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $77872a9552c12fe0$var$GraphImage = ({ className: className, width: width = "250", height: height = "220" })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "currentColor",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M116.196 121.649L122.938 78.7574L125.683 117.583L125.691 117.699L125.732 117.803L130.432 129.604L131.793 129.405L134.555 121.152L141.953 118.254L141.973 118.246L141.993 118.237L145.599 116.592L145.66 116.564L145.717 116.526L149.217 114.178L149.352 114.088L149.449 113.951L152.283 109.937L155.816 111.172L155.867 111.19L155.921 111.199L159.855 111.852L160.183 111.907L160.465 111.667L163.888 108.754L163.937 108.712L163.98 108.663L166.813 105.442L170.607 108.185L170.845 108.357L171.149 108.28L174.854 107.348L174.766 106.541L174.884 107.343L177.732 106.511L177.514 105.028L174.691 105.852L174.691 105.85L171.29 106.705L167.235 103.773L166.736 103.413L166.271 103.941L163.017 107.642L159.925 110.273L156.373 109.684L152.38 108.287L151.868 108.109L151.512 108.613L148.417 112.996L145.109 115.215L141.584 116.823L133.83 119.86L133.455 120.007L133.321 120.407L131.083 127.094L127.128 117.162L123.948 72.1959L122.503 72.3168L114.913 120.609L111.74 119.616L111.323 119.485L110.979 119.843L107.802 123.148L104.597 124.031L100.638 121.776L100.258 121.56L99.8641 121.855L96.7054 124.22L93.0283 123.182L93.0035 123.175L92.978 123.17L89.0264 122.398L88.9485 122.382L88.8672 122.386L85.3674 122.556L80.9327 117.338L80.2752 116.564L79.7382 117.584L76.7254 123.307L76.6713 123.41L76.6453 123.521L74.3785 133.242L71.1688 134.527L71.1688 134.527L71.1624 134.529L67.6752 135.961L63.9731 135.915L63.7955 135.913L63.6268 135.999L60.0472 137.827L59.9385 137.883L59.8472 137.969L56.5461 141.097L53.1873 143.021L49.5806 143.9L49.4602 143.929L49.3504 143.997L45.9174 146.127L42.6054 147.131L38.6818 145.065L38.415 144.924L38.1101 145.048L30.994 147.948L27.2872 147.904L27.0572 147.901L26.8512 148.041L23.3927 150.391L21.7816 151.248C21.4055 151.448 21.2164 151.914 21.3591 152.29C21.5019 152.666 21.9226 152.809 22.2987 152.609L23.9497 151.732L23.9897 151.71L24.0276 151.685L27.3182 149.448L30.9386 149.492L31.0822 149.493L31.2225 149.436L38.1739 146.604L42.0633 148.652L42.296 148.774L42.5673 148.692L46.2498 147.576L46.3488 147.546L46.4399 147.489L49.854 145.372L53.4466 144.496L53.5529 144.47L53.6516 144.414L57.1979 142.383L57.2869 142.332L57.363 142.26L60.6491 139.146L63.9513 137.459L67.6205 137.504L67.7652 137.506L67.9064 137.448L71.5285 135.961L71.5349 135.959L75.1584 134.508L75.5785 134.34L75.6847 133.884L78.0318 123.819L80.4536 119.22L84.4275 123.896L84.6242 124.127L84.9375 124.112L88.6693 123.931L92.5176 124.683L96.5 125.807L96.8302 125.9L97.1364 125.671L100.207 123.371L104.016 125.54L104.246 125.671L104.519 125.596L108.212 124.579L108.427 124.52L108.591 124.35L111.589 121.231L115.193 122.359L116.042 122.625L116.196 121.649ZM223.317 93.2045C223.715 93.0884 223.989 92.6622 223.928 92.2525C223.868 91.8429 223.497 91.6049 223.099 91.721L220.251 92.5525L220.469 94.036L223.317 93.2045ZM213.55 96.0557L219.247 94.3928L219.028 92.9093L213.332 94.5722L213.55 96.0557ZM206.631 98.0755L212.328 96.4125L212.109 94.929L206.413 96.592L206.631 98.0755ZM199.712 100.095L205.409 98.4323L205.19 96.9488L199.494 98.6117L199.712 100.095ZM192.793 102.115L198.49 100.452L198.271 98.9685L192.575 100.631L192.793 102.115ZM185.874 104.135L191.571 102.472L191.352 100.988L185.656 102.651L185.874 104.135ZM178.955 106.154L184.652 104.491L184.433 103.008L178.737 104.671L178.955 106.154Z",
                fill: "#92ABFA"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M117.013 145.727L116.761 145.182L116.175 145.308L112.23 146.156L111.952 146.216L111.783 146.444L108.309 151.164L104.976 148.357L104.804 148.212L104.581 148.185L100.632 147.721L100.435 147.698L100.252 147.775L96.4211 149.392L88.6502 149.958L88.6157 149.961L88.5817 149.966L84.6366 150.622L84.6359 150.622L76.7879 151.934L72.8855 152.094L72.8008 152.097L72.719 152.12L68.9156 153.157L65.1124 152.696L64.7624 152.653L64.5064 152.896L61.1126 156.11L57.6787 152.393L57.4606 152.157L57.1391 152.152L53.194 152.093L53.194 152.093H53.1828H49.3002L45.4128 151.44L45.2851 151.419L45.1575 151.442L41.2827 152.129L33.5232 152.021L29.6365 151.303L29.5717 151.291L29.5058 151.29L25.5607 151.261L25.4212 151.26L25.2906 151.309L21.3415 152.797L21.3415 152.797L21.3392 152.798L21.1298 152.878C20.7427 153.025 20.5484 153.459 20.6958 153.846C20.8431 154.233 21.2764 154.427 21.6635 154.28L21.8706 154.201L21.8729 154.2L25.6891 152.762L29.4287 152.79L33.313 153.507L33.3754 153.519L33.4388 153.52L41.333 153.63L41.4043 153.631L41.4745 153.619L45.2921 152.941L49.1135 153.583L49.1751 153.593H49.2377H53.1772L56.7952 153.647L60.5261 157.685L61.0414 158.243L61.5927 157.721L65.2818 154.227L68.8809 154.664L69.0267 154.681L69.1685 154.643L73.0318 153.589L76.8961 153.431L76.9428 153.429L76.989 153.421L84.8825 152.102L84.8832 152.102L88.7936 151.452L96.6533 150.879L96.7766 150.871L96.8905 150.822L100.653 149.234L104.182 149.649L107.955 152.827L108.567 153.343L109.042 152.698L112.823 147.563L115.903 146.901L119.58 154.852L123.51 167.516L124.956 167.467L128.758 151.46L132.088 151.603L132.13 151.605L132.172 151.602L140.027 151.067L143.933 151.205L144.046 151.209L144.156 151.18L147.964 150.149L151.629 150.587L155.456 152.587L155.927 152.833L156.315 152.47L160.071 148.963L163.517 148.667L167.178 150.853L171.057 154.73L171.458 155.13L171.953 154.854L179.265 150.772L178.534 149.462L171.717 153.268L168.173 149.726L168.107 149.66L168.027 149.613L164.078 147.255L163.87 147.131L163.629 147.151L159.684 147.49L159.426 147.513L159.236 147.689L155.68 151.011L152.201 149.194L152.08 149.13L151.943 149.114L147.998 148.642L147.854 148.625L147.713 148.663L143.873 149.702L140.041 149.566L140.003 149.565L139.964 149.567L132.111 150.103L128.204 149.935L127.585 149.908L127.442 150.511L124.13 164.454L120.998 154.36L120.983 154.313L120.962 154.268L117.013 145.727ZM211.992 148.438L211.844 148.308L211.646 148.314L210.325 148.356L210.357 149.355L211.481 149.32L212.386 150.114L213.046 149.362L211.992 148.438ZM206.393 149.481L209.036 149.397L209.004 148.398L206.361 148.482L206.393 149.481ZM202.429 149.607L205.071 149.523L205.04 148.524L202.397 148.608L202.429 149.607ZM198.465 149.733L201.107 149.649L201.076 148.65L198.433 148.734L198.465 149.733ZM194.501 149.859L197.143 149.775L197.112 148.776L194.469 148.86L194.501 149.859ZM190.536 149.985L193.179 149.901L193.147 148.902L190.505 148.985L190.536 149.985ZM186.572 150.111L189.215 150.027L189.183 149.027L186.541 149.111L186.572 150.111ZM182.608 150.237L185.251 150.153L185.219 149.153L182.577 149.237L182.608 150.237ZM179.966 150.321L181.287 150.279L181.255 149.279L179.934 149.321L179.966 150.321ZM213.44 151.038L214.493 151.962L214.635 152.086H214.823H216.361V151.086H215.011L214.099 150.286L213.44 151.038ZM217.899 152.086H220.975V151.086H217.899V152.086ZM222.513 152.086H224.051C224.327 152.086 224.551 151.862 224.551 151.586C224.551 151.31 224.327 151.086 224.051 151.086H222.513V152.086Z",
                fill: "#2042F6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M94.8675 174.117L94.388 173.706L93.9013 174.108L89.3469 177.876L80.0946 178.183L80.0816 178.183L80.0687 178.184L75.312 178.507L75.3074 178.507L65.9191 179.202L61.2749 178.107L61.1759 178.084L61.0742 178.087L46.8218 178.63L46.8179 178.63L42.3234 178.755L37.7795 175.403L37.3592 175.093L36.9226 175.379L32.3588 178.377L27.8589 178.307L23.1285 177.964L22.8099 177.941L22.5724 178.155L20.8947 179.665C20.5869 179.942 20.5619 180.416 20.8391 180.724C21.1162 181.032 21.5904 181.057 21.8983 180.78L23.3386 179.483L27.7717 179.805L27.7931 179.806L27.8144 179.807L32.5662 179.88L32.7968 179.884L32.9895 179.757L37.3094 176.92L41.6408 180.115L41.8487 180.268L42.1069 180.261L46.8634 180.129L46.8634 180.129L46.8711 180.129L61.0296 179.59L65.6871 180.689L65.7995 180.715L65.9147 180.707L75.4136 180.003L75.4182 180.003L80.1573 179.681L89.6525 179.366L89.9084 179.358L90.1057 179.195L94.3708 175.667L98.6478 179.333L98.8224 179.483L99.0509 179.509L103.803 180.051L103.842 180.056L103.881 180.056L108.503 180.099L113.13 181.855L113.428 181.969L113.716 181.832L118.263 179.685L122.796 180.349L122.871 180.36L122.946 180.356L132.455 179.82L132.513 179.817L132.57 179.805L137.247 178.802L146.679 178.722L146.848 178.72L147 178.646L151.368 176.525L155.761 179.495L155.953 179.625L156.184 179.624L160.936 179.602L160.989 179.601L161.041 179.594L165.631 178.921L170.222 180.324L170.38 180.373L170.544 180.35L175.226 179.7L179.902 179.996L179.95 179.245V179.806H181.286V178.806H179.977L179.997 178.499L175.245 178.198L175.169 178.194L175.095 178.204L170.502 178.841L165.908 177.438L165.747 177.388L165.581 177.413L160.876 178.102L156.409 178.123L151.849 175.04L151.491 174.798L151.102 174.987L146.497 177.223L137.158 177.302L137.082 177.303L137.007 177.319L132.312 178.326L122.938 178.854L118.256 178.168L118.032 178.135L117.828 178.232L113.364 180.34L108.91 178.649L108.785 178.602L108.651 178.6L103.934 178.557L99.4495 178.044L94.8675 174.117ZM182.622 179.806H185.295V178.806H182.622V179.806ZM186.631 179.806H189.304V178.806H186.631V179.806ZM190.641 179.806H193.313V178.806H190.641V179.806ZM194.65 179.806H197.323V178.806H194.65V179.806ZM198.659 179.806H201.332V178.806H198.659V179.806ZM202.668 179.806H205.341V178.806H202.668V179.806ZM206.677 179.806H209.35V178.806H206.677V179.806ZM210.686 179.806H213.359V178.806H210.686V179.806ZM214.696 179.806H217.368V178.806H214.696V179.806ZM218.705 179.806H221.378V178.806H218.705V179.806ZM222.714 179.806H224.05C224.326 179.806 224.55 179.582 224.55 179.306C224.55 179.03 224.326 178.806 224.05 178.806H222.714V179.806Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                filter: "url(#filter0_d_1609_19763)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: "127",
                    cy: "77",
                    r: "34",
                    fill: "#343C47"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("mask", {
                id: "mask0_1609_19763",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "93",
                y: "43",
                width: "68",
                height: "68",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: "127",
                    cy: "77",
                    r: "34",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                mask: "url(#mask0_1609_19763)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M109.848 149.048L123.506 62.1553L129.068 140.823L129.085 141.055L129.167 141.262L138.673 165.131L141.394 164.732L146.983 148.031L161.954 142.166L161.995 142.15L162.034 142.132L169.328 138.806L169.45 138.75L169.563 138.674L176.643 133.925L176.914 133.743L177.107 133.471L182.847 125.341L190.004 127.843L190.105 127.878L190.213 127.896L198.17 129.217L198.827 129.326L199.391 128.846L206.314 122.955L206.413 122.872L206.499 122.774L212.239 116.247L219.923 121.803L220.398 122.146L221.007 121.993L228.501 120.108L228.326 118.508L228.451 119.356L231.331 118.515L231.113 117.031L228.256 117.865L228.173 117.111L221.289 118.843L213.082 112.909L212.085 112.188L211.155 113.246L204.571 120.732L198.311 126.059L191.118 124.866L183.04 122.041L182.017 121.684L181.305 122.693L175.044 131.56L168.348 136.051L161.217 139.304L145.534 145.448L144.783 145.742L144.516 146.54L139.974 160.11L131.958 139.98L125.527 49.0323L122.638 49.2741L107.282 146.969L100.846 144.954L100.011 144.693L99.3244 145.407L92.8941 152.097L86.401 153.884L78.3884 149.322L77.6292 148.889L76.8414 149.479L70.446 154.268L63.0015 152.167L62.9518 152.153L62.9008 152.143L54.9085 150.58L54.7528 150.55L54.5901 150.557L47.5047 150.902L38.5309 140.342L37.216 138.795L36.142 140.835L30.0485 152.409L29.9403 152.615L29.8884 152.837L25.3013 172.508L18.8001 175.11L18.8001 175.11L18.7873 175.116L11.7311 178.013L4.24038 177.921L3.88517 177.916L3.54775 178.088L-3.69209 181.785L-3.90948 181.896L-4.09201 182.069L-10.7704 188.398L-17.5679 192.291L-24.8649 194.069L-25.1057 194.128L-25.3254 194.264L-32.2706 198.572L-38.9777 200.605L-46.9184 196.423L-47.4521 196.142L-48.0619 196.391L-62.4575 202.257L-69.9579 202.167L-70.4179 202.162L-70.8298 202.442L-77.8256 207.196L-81.085 208.928C-81.8372 209.328 -82.2155 210.262 -81.9299 211.014C-81.6443 211.766 -80.803 212.051 -80.0508 211.651L-76.7115 209.877L-76.6316 209.834L-76.5558 209.783L-69.8959 205.257L-62.5683 205.344L-62.2811 205.348L-62.0006 205.233L-47.9343 199.501L-40.0618 203.647L-39.5964 203.893L-39.0538 203.728L-31.606 201.47L-31.4078 201.41L-31.2257 201.297L-24.3181 197.012L-17.0493 195.241L-16.8366 195.189L-16.6394 195.076L-9.46675 190.968L-9.28889 190.866L-9.13653 190.722L-2.48829 184.422L4.19675 181.009L11.6217 181.1L11.9111 181.103L12.1936 180.987L19.5195 177.98L19.5323 177.975L26.861 175.04L27.7013 174.704L27.9138 173.793L32.6614 153.434L37.5727 144.105L45.6249 153.58L46.0183 154.043L46.645 154.013L54.1945 153.646L61.98 155.169L70.0351 157.442L70.6954 157.629L71.3079 157.17L77.5279 152.512L85.24 156.904L85.6988 157.165L86.2457 157.015L93.7149 154.959L94.1441 154.841L94.4717 154.5L100.543 148.183L107.842 150.468L109.541 151L109.848 149.048ZM326.408 90.7609C326.806 90.6448 327.079 90.2186 327.019 89.8089C326.959 89.3992 326.588 89.1613 326.19 89.2774L323.309 90.1182L323.528 91.6017L326.408 90.7609ZM316.531 93.6442L322.292 91.9625L322.073 90.479L316.312 92.1607L316.531 93.6442ZM309.534 95.6867L315.295 94.005L315.076 92.5215L309.315 94.2032L309.534 95.6867ZM302.537 97.7292L308.298 96.0475L308.079 94.564L302.318 96.2457L302.537 97.7292ZM295.54 99.7717L301.301 98.09L301.082 96.6065L295.322 98.2882L295.54 99.7717ZM288.543 101.814L294.304 100.132L294.085 98.649L288.325 100.331L288.543 101.814ZM281.546 103.857L287.307 102.175L287.089 100.691L281.328 102.373L281.546 103.857ZM274.549 105.899L280.31 104.217L280.092 102.734L274.331 104.416L274.549 105.899ZM267.552 107.942L273.313 106.26L273.095 104.776L267.334 106.458L267.552 107.942ZM260.555 109.984L266.316 108.302L266.098 106.819L260.337 108.501L260.555 109.984ZM253.558 112.027L259.319 110.345L259.101 108.861L253.34 110.543L253.558 112.027ZM246.561 114.069L252.322 112.387L252.104 110.904L246.343 112.586L246.561 114.069ZM239.564 116.112L245.325 114.43L245.107 112.946L239.346 114.628L239.564 116.112ZM232.567 118.154L238.328 116.472L238.11 114.989L232.349 116.671L232.567 118.154Z",
                    fill: "#92ABFA"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                filter: "url(#filter1_d_1609_19763)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        filter: "url(#filter2_bd_1609_19763)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            x: "137",
                            y: "65",
                            width: "77.3561",
                            height: "24.2862",
                            rx: "2",
                            fill: "#343C47"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "202.585",
                        y1: "73.1959",
                        x2: "143.875",
                        y2: "73.1959",
                        stroke: "white",
                        strokeWidth: "2",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "205.523",
                        y1: "77.6934",
                        x2: "143.875",
                        y2: "77.6934",
                        stroke: "white",
                        strokeWidth: "2",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "191.814",
                        y1: "82.1908",
                        x2: "143.875",
                        y2: "82.1908",
                        stroke: "white",
                        strokeWidth: "2",
                        strokeLinecap: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter0_d_1609_19763",
                        x: "89",
                        y: "43",
                        width: "76",
                        height: "76",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1609_19763"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1609_19763",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter1_d_1609_19763",
                        x: "133",
                        y: "65",
                        width: "85.3561",
                        height: "32.2863",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1609_19763"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1609_19763",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter2_bd_1609_19763",
                        x: "133",
                        y: "61",
                        width: "85.3561",
                        height: "36.2863",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_1609_19763"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect1_backgroundBlur_1609_19763",
                                result: "effect2_dropShadow_1609_19763"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow_1609_19763",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $77872a9552c12fe0$export$2e2bcd8739ae039 = $77872a9552c12fe0$var$GraphImage;

});

parcelRegister("ajNKJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $805a73a0f373c347$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $805a73a0f373c347$var$StepInProgress = ({ className: className, width: width = "24", height: height = "24", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "none",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12Z",
                        stroke: "#6B7280",
                        strokeWidth: "3"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("mask", {
                        id: "mask0_36381_900",
                        style: {
                            maskType: "alpha"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "12",
                        y: "3",
                        width: "9",
                        height: "9",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3V12H21Z",
                            fill: "#4BCA81"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        mask: "url(#mask0_36381_900)"
                    })
                ]
            })
        })
    });
};
var $805a73a0f373c347$export$2e2bcd8739ae039 = $805a73a0f373c347$var$StepInProgress;

});

parcelRegister("37uIx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b820ace77d10e56d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $b820ace77d10e56d$var$MapPinIcon = ({ className: className, width: width = "24", height: height = "24", onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                role: "img",
                width: width,
                height: height,
                viewBox: `0 0 ${width} ${height}`,
                fill: "none",
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.359 21.183L11.3618 21.1842C11.5589 21.27 11.6689 21.25 11.6689 21.25C11.6689 21.25 11.7789 21.27 11.9769 21.1839L11.9789 21.183L11.9846 21.1804L12.0028 21.172C12.0178 21.165 12.0386 21.1552 12.0649 21.1426C12.1173 21.1173 12.1915 21.0806 12.2843 21.0322C12.4697 20.9355 12.7302 20.7919 13.0406 20.5995C13.6602 20.2155 14.4863 19.6326 15.3144 18.8344C16.9711 17.2376 18.6689 14.7425 18.6689 11.25C18.6689 7.38401 15.5349 4.25 11.6689 4.25C7.80295 4.25 4.66895 7.38401 4.66895 11.25C4.66895 14.7425 6.36678 17.2376 8.02346 18.8344C8.85158 19.6326 9.67771 20.2155 10.2973 20.5995C10.6077 20.7919 10.8682 20.9355 11.0536 21.0322C11.1464 21.0806 11.2206 21.1173 11.273 21.1426C11.2993 21.1552 11.3201 21.165 11.3351 21.172L11.3533 21.1804L11.359 21.183ZM11.6689 13.5C12.9116 13.5 13.9189 12.4926 13.9189 11.25C13.9189 10.0074 12.9116 9 11.6689 9C10.4263 9 9.41895 10.0074 9.41895 11.25C9.41895 12.4926 10.4263 13.5 11.6689 13.5Z",
                    fill: "white"
                })
            })
        })
    });
};
var $b820ace77d10e56d$export$2e2bcd8739ae039 = $b820ace77d10e56d$var$MapPinIcon;

});


parcelRegister("4zNAn", function(module, exports) {

});


parcelRegister("b24po", function(module, exports) {
$parcel$export(module.exports, "StickyFooter", () => (parcelRequire("4SyUF")).StickyFooter);
parcelRequire("4SyUF");

});
parcelRegister("4SyUF", function(module, exports) {

$parcel$export(module.exports, "StickyFooter", () => $278d7c39f8918e53$export$de401b45f203ff7f);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
parcelRequire("acw62");
function $278d7c39f8918e53$export$de401b45f203ff7f({ testId: testId, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("bg-default border-default z-30 w-full py-4", "border-t", "fixed bottom-0"),
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: (0, $9QePP.default)("mx-4", "flex flex-col", "justify-center", "sm:mx-0 sm:flex-row"),
            children: children
        })
    });
}

});


parcelRegister("NPGGQ", function(module, exports) {
$parcel$export(module.exports, "SectionCard", () => (parcelRequire("fdLDL")).SectionCard);
parcelRequire("fdLDL");

});
parcelRegister("fdLDL", function(module, exports) {

$parcel$export(module.exports, "SectionCard", () => $9147f75bcc06e1fc$export$69ed894a7932b604);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
parcelRequire("acw62");
function $9147f75bcc06e1fc$export$69ed894a7932b604({ children: children, className: className, testId: testId }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("bg-surface-dark", "border-default border", "p-8", className),
        "data-testid": testId,
        children: children
    });
}

});


parcelRegister("fXNwB", function(module, exports) {
$parcel$export(module.exports, "Card", () => (parcelRequire("bVwXM")).Card);
parcelRequire("bVwXM");

});
parcelRegister("bVwXM", function(module, exports) {

$parcel$export(module.exports, "Card", () => $12ad924c41c82e8f$export$60332b2344f7fe41);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
parcelRequire("acw62");
function $12ad924c41c82e8f$export$60332b2344f7fe41({ children: children, className: className, testId: testId, onClick: onClick }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": testId,
        className: (0, $9QePP.default)("bg-secondary", "", "p-6", "rounded-lg", className),
        onClick: onClick,
        children: children
    });
}

});


parcelRegister("ir6LM", function(module, exports) {
$parcel$export(module.exports, "Badge", () => (parcelRequire("1xSOq")).Badge);
parcelRequire("1xSOq");

});
parcelRegister("1xSOq", function(module, exports) {

$parcel$export(module.exports, "Badge", () => $06d37cf80e1cdb4b$export$37acb3580601e69a);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $bvcna = parcelRequire("bvcna");
function $06d37cf80e1cdb4b$export$37acb3580601e69a({ children: children, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $bvcna.twMerge)("w-max rounded-[14px] bg-green-200 px-2 py-1 uppercase", className),
        children: children
    });
}

});
parcelRegister("bvcna", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: "Module"
});
const $85fc2fe65ff21506$var$CLASS_PART_SEPARATOR = "-";
function $85fc2fe65ff21506$var$createClassUtils(config) {
    const classMap = $85fc2fe65ff21506$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    function getClassGroupId(className) {
        const classParts = className.split($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === "" && classParts.length !== 1) classParts.shift();
        return $85fc2fe65ff21506$var$getGroupRecursive(classParts, classMap) || $85fc2fe65ff21506$var$getGroupIdForArbitraryProperty(className);
    }
    function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
        const conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [
            ...conflicts,
            ...conflictingClassGroupModifiers[classGroupId]
        ];
        return conflicts;
    }
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
}
function $85fc2fe65ff21506$var$getGroupRecursive(classParts, classPartObject) {
    if (classParts.length === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[0];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    const classGroupFromNextClassPart = nextClassPartObject ? $85fc2fe65ff21506$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    const classRest = classParts.join($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
    return classPartObject.validators.find(({ validator: validator })=>validator(classRest))?.classGroupId;
}
const $85fc2fe65ff21506$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
function $85fc2fe65ff21506$var$getGroupIdForArbitraryProperty(className) {
    if ($85fc2fe65ff21506$var$arbitraryPropertyRegex.test(className)) {
        const arbitraryPropertyClassName = $85fc2fe65ff21506$var$arbitraryPropertyRegex.exec(className)[1];
        const property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(":"));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return "arbitrary.." + property;
    }
}
/**
 * Exported for testing only
 */ function $85fc2fe65ff21506$var$createClassMap(config) {
    const { theme: theme, prefix: prefix } = config;
    const classMap = {
        nextPart: new Map(),
        validators: []
    };
    const prefixedClassGroupEntries = $85fc2fe65ff21506$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(([classGroupId, classGroup])=>{
        $85fc2fe65ff21506$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
}
function $85fc2fe65ff21506$var$processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
    classGroup.forEach((classDefinition)=>{
        if (typeof classDefinition === "string") {
            const classPartObjectToEdit = classDefinition === "" ? classPartObject : $85fc2fe65ff21506$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === "function") {
            if ($85fc2fe65ff21506$var$isThemeGetter(classDefinition)) {
                $85fc2fe65ff21506$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(([key, classGroup])=>{
            $85fc2fe65ff21506$var$processClassesRecursively(classGroup, $85fc2fe65ff21506$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
}
function $85fc2fe65ff21506$var$getPart(classPartObject, path) {
    let currentClassPartObject = classPartObject;
    path.split($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR).forEach((pathPart)=>{
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
}
function $85fc2fe65ff21506$var$isThemeGetter(func) {
    return func.isThemeGetter;
}
function $85fc2fe65ff21506$var$getPrefixedClassGroupEntries(classGroupEntries, prefix) {
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(([classGroupId, classGroup])=>{
        const prefixedClassGroup = classGroup.map((classDefinition)=>{
            if (typeof classDefinition === "string") return prefix + classDefinition;
            if (typeof classDefinition === "object") return Object.fromEntries(Object.entries(classDefinition).map(([key, value])=>[
                    prefix + key,
                    value
                ]));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
}
// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
function $85fc2fe65ff21506$var$createLruCache(maxCacheSize) {
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = new Map();
    let previousCache = new Map();
    function update(key, value) {
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    }
    return {
        get (key) {
            let value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
}
const $85fc2fe65ff21506$var$IMPORTANT_MODIFIER = "!";
function $85fc2fe65ff21506$var$createSplitModifiers(config) {
    const separator = config.separator;
    const isSeparatorSingleCharacter = separator.length === 1;
    const firstSeparatorCharacter = separator[0];
    const separatorLength = separator.length;
    // splitModifiers inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    return function splitModifiers(className) {
        const modifiers = [];
        let bracketDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        for(let index = 0; index < className.length; index++){
            let currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === "/") {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === "[") bracketDepth++;
            else if (currentCharacter === "]") bracketDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        const hasImportantModifier = baseClassNameWithImportantModifier.startsWith($85fc2fe65ff21506$var$IMPORTANT_MODIFIER);
        const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    };
}
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ function $85fc2fe65ff21506$var$sortModifiers(modifiers) {
    if (modifiers.length <= 1) return modifiers;
    const sortedModifiers = [];
    let unsortedModifiers = [];
    modifiers.forEach((modifier)=>{
        const isArbitraryVariant = modifier[0] === "[";
        if (isArbitraryVariant) {
            sortedModifiers.push(...unsortedModifiers.sort(), modifier);
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push(...unsortedModifiers.sort());
    return sortedModifiers;
}
function $85fc2fe65ff21506$var$createConfigUtils(config) {
    return {
        cache: $85fc2fe65ff21506$var$createLruCache(config.cacheSize),
        splitModifiers: $85fc2fe65ff21506$var$createSplitModifiers(config),
        ...$85fc2fe65ff21506$var$createClassUtils(config)
    };
}
const $85fc2fe65ff21506$var$SPLIT_CLASSES_REGEX = /\s+/;
function $85fc2fe65ff21506$var$mergeClassList(classList, configUtils) {
    const { splitModifiers: splitModifiers, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = new Set();
    return classList.trim().split($85fc2fe65ff21506$var$SPLIT_CLASSES_REGEX).map((originalClassName)=>{
        const { modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = splitModifiers(originalClassName);
        let classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        if (!classGroupId) {
            if (!maybePostfixModifierPosition) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            hasPostfixModifier = false;
        }
        const variantModifier = $85fc2fe65ff21506$var$sortModifiers(modifiers).join(":");
        const modifierId = hasImportantModifier ? variantModifier + $85fc2fe65ff21506$var$IMPORTANT_MODIFIER : variantModifier;
        return {
            isTailwindClass: true,
            modifierId: modifierId,
            classGroupId: classGroupId,
            originalClassName: originalClassName,
            hasPostfixModifier: hasPostfixModifier
        };
    }).reverse()// Last class in conflict wins, so we need to filter conflicting classes in reverse order.
    .filter((parsed)=>{
        if (!parsed.isTailwindClass) return true;
        const { modifierId: modifierId, classGroupId: classGroupId, hasPostfixModifier: hasPostfixModifier } = parsed;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.has(classId)) return false;
        classGroupsInConflict.add(classId);
        getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach((group)=>classGroupsInConflict.add(modifierId + group));
        return true;
    }).reverse().map((parsed)=>parsed.originalClassName).join(" ");
}
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $85fc2fe65ff21506$var$twJoin() {
    let index = 0;
    let argument;
    let resolvedValue;
    let string = "";
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $85fc2fe65ff21506$var$toValue(argument)) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $85fc2fe65ff21506$var$toValue(mix) {
    if (typeof mix === "string") return mix;
    let resolvedValue;
    let string = "";
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $85fc2fe65ff21506$var$toValue(mix[k])) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $85fc2fe65ff21506$var$createTailwindMerge(createConfigFirst, ...createConfigRest) {
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall = initTailwindMerge;
    function initTailwindMerge(classList) {
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $85fc2fe65ff21506$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    }
    function tailwindMerge(classList) {
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $85fc2fe65ff21506$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    }
    return function callTailwindMerge() {
        return functionToCall($85fc2fe65ff21506$var$twJoin.apply(null, arguments));
    };
}
function $85fc2fe65ff21506$var$fromTheme(key) {
    const themeGetter = (theme)=>theme[key] || [];
    themeGetter.isThemeGetter = true;
    return themeGetter;
}
const $85fc2fe65ff21506$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const $85fc2fe65ff21506$var$fractionRegex = /^\d+\/\d+$/;
const $85fc2fe65ff21506$var$stringLengths = /*#__PURE__*/ new Set([
    "px",
    "full",
    "screen"
]);
const $85fc2fe65ff21506$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $85fc2fe65ff21506$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $85fc2fe65ff21506$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $85fc2fe65ff21506$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $85fc2fe65ff21506$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function $85fc2fe65ff21506$var$isLength(value) {
    return $85fc2fe65ff21506$var$isNumber(value) || $85fc2fe65ff21506$var$stringLengths.has(value) || $85fc2fe65ff21506$var$fractionRegex.test(value);
}
function $85fc2fe65ff21506$var$isArbitraryLength(value) {
    return $85fc2fe65ff21506$var$getIsArbitraryValue(value, "length", $85fc2fe65ff21506$var$isLengthOnly);
}
function $85fc2fe65ff21506$var$isNumber(value) {
    return Boolean(value) && !Number.isNaN(Number(value));
}
function $85fc2fe65ff21506$var$isArbitraryNumber(value) {
    return $85fc2fe65ff21506$var$getIsArbitraryValue(value, "number", $85fc2fe65ff21506$var$isNumber);
}
function $85fc2fe65ff21506$var$isInteger(value) {
    return Boolean(value) && Number.isInteger(Number(value));
}
function $85fc2fe65ff21506$var$isPercent(value) {
    return value.endsWith("%") && $85fc2fe65ff21506$var$isNumber(value.slice(0, -1));
}
function $85fc2fe65ff21506$var$isArbitraryValue(value) {
    return $85fc2fe65ff21506$var$arbitraryValueRegex.test(value);
}
function $85fc2fe65ff21506$var$isTshirtSize(value) {
    return $85fc2fe65ff21506$var$tshirtUnitRegex.test(value);
}
const $85fc2fe65ff21506$var$sizeLabels = /*#__PURE__*/ new Set([
    "length",
    "size",
    "percentage"
]);
function $85fc2fe65ff21506$var$isArbitrarySize(value) {
    return $85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$sizeLabels, $85fc2fe65ff21506$var$isNever);
}
function $85fc2fe65ff21506$var$isArbitraryPosition(value) {
    return $85fc2fe65ff21506$var$getIsArbitraryValue(value, "position", $85fc2fe65ff21506$var$isNever);
}
const $85fc2fe65ff21506$var$imageLabels = /*#__PURE__*/ new Set([
    "image",
    "url"
]);
function $85fc2fe65ff21506$var$isArbitraryImage(value) {
    return $85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$imageLabels, $85fc2fe65ff21506$var$isImage);
}
function $85fc2fe65ff21506$var$isArbitraryShadow(value) {
    return $85fc2fe65ff21506$var$getIsArbitraryValue(value, "", $85fc2fe65ff21506$var$isShadow);
}
function $85fc2fe65ff21506$var$isAny() {
    return true;
}
function $85fc2fe65ff21506$var$getIsArbitraryValue(value, label, testValue) {
    const result = $85fc2fe65ff21506$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return typeof label === "string" ? result[1] === label : label.has(result[1]);
        return testValue(result[2]);
    }
    return false;
}
function $85fc2fe65ff21506$var$isLengthOnly(value) {
    // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    return $85fc2fe65ff21506$var$lengthUnitRegex.test(value) && !$85fc2fe65ff21506$var$colorFunctionRegex.test(value);
}
function $85fc2fe65ff21506$var$isNever() {
    return false;
}
function $85fc2fe65ff21506$var$isShadow(value) {
    return $85fc2fe65ff21506$var$shadowRegex.test(value);
}
function $85fc2fe65ff21506$var$isImage(value) {
    return $85fc2fe65ff21506$var$imageRegex.test(value);
}
const $85fc2fe65ff21506$var$validators = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $85fc2fe65ff21506$var$isAny,
    isArbitraryImage: $85fc2fe65ff21506$var$isArbitraryImage,
    isArbitraryLength: $85fc2fe65ff21506$var$isArbitraryLength,
    isArbitraryNumber: $85fc2fe65ff21506$var$isArbitraryNumber,
    isArbitraryPosition: $85fc2fe65ff21506$var$isArbitraryPosition,
    isArbitraryShadow: $85fc2fe65ff21506$var$isArbitraryShadow,
    isArbitrarySize: $85fc2fe65ff21506$var$isArbitrarySize,
    isArbitraryValue: $85fc2fe65ff21506$var$isArbitraryValue,
    isInteger: $85fc2fe65ff21506$var$isInteger,
    isLength: $85fc2fe65ff21506$var$isLength,
    isNumber: $85fc2fe65ff21506$var$isNumber,
    isPercent: $85fc2fe65ff21506$var$isPercent,
    isTshirtSize: $85fc2fe65ff21506$var$isTshirtSize
}, Symbol.toStringTag, {
    value: "Module"
});
function $85fc2fe65ff21506$var$getDefaultConfig() {
    const colors = $85fc2fe65ff21506$var$fromTheme("colors");
    const spacing = $85fc2fe65ff21506$var$fromTheme("spacing");
    const blur = $85fc2fe65ff21506$var$fromTheme("blur");
    const brightness = $85fc2fe65ff21506$var$fromTheme("brightness");
    const borderColor = $85fc2fe65ff21506$var$fromTheme("borderColor");
    const borderRadius = $85fc2fe65ff21506$var$fromTheme("borderRadius");
    const borderSpacing = $85fc2fe65ff21506$var$fromTheme("borderSpacing");
    const borderWidth = $85fc2fe65ff21506$var$fromTheme("borderWidth");
    const contrast = $85fc2fe65ff21506$var$fromTheme("contrast");
    const grayscale = $85fc2fe65ff21506$var$fromTheme("grayscale");
    const hueRotate = $85fc2fe65ff21506$var$fromTheme("hueRotate");
    const invert = $85fc2fe65ff21506$var$fromTheme("invert");
    const gap = $85fc2fe65ff21506$var$fromTheme("gap");
    const gradientColorStops = $85fc2fe65ff21506$var$fromTheme("gradientColorStops");
    const gradientColorStopPositions = $85fc2fe65ff21506$var$fromTheme("gradientColorStopPositions");
    const inset = $85fc2fe65ff21506$var$fromTheme("inset");
    const margin = $85fc2fe65ff21506$var$fromTheme("margin");
    const opacity = $85fc2fe65ff21506$var$fromTheme("opacity");
    const padding = $85fc2fe65ff21506$var$fromTheme("padding");
    const saturate = $85fc2fe65ff21506$var$fromTheme("saturate");
    const scale = $85fc2fe65ff21506$var$fromTheme("scale");
    const sepia = $85fc2fe65ff21506$var$fromTheme("sepia");
    const skew = $85fc2fe65ff21506$var$fromTheme("skew");
    const space = $85fc2fe65ff21506$var$fromTheme("space");
    const translate = $85fc2fe65ff21506$var$fromTheme("translate");
    const getOverscroll = ()=>[
            "auto",
            "contain",
            "none"
        ];
    const getOverflow = ()=>[
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ];
    const getSpacingWithAutoAndArbitrary = ()=>[
            "auto",
            $85fc2fe65ff21506$var$isArbitraryValue,
            spacing
        ];
    const getSpacingWithArbitrary = ()=>[
            $85fc2fe65ff21506$var$isArbitraryValue,
            spacing
        ];
    const getLengthWithEmptyAndArbitrary = ()=>[
            "",
            $85fc2fe65ff21506$var$isLength,
            $85fc2fe65ff21506$var$isArbitraryLength
        ];
    const getNumberWithAutoAndArbitrary = ()=>[
            "auto",
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const getPositions = ()=>[
            "bottom",
            "center",
            "left",
            "left-bottom",
            "left-top",
            "right",
            "right-bottom",
            "right-top",
            "top"
        ];
    const getLineStyles = ()=>[
            "solid",
            "dashed",
            "dotted",
            "double",
            "none"
        ];
    const getBlendModes = ()=>[
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity",
            "plus-lighter"
        ];
    const getAlign = ()=>[
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch"
        ];
    const getZeroAndEmpty = ()=>[
            "",
            "0",
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const getBreaks = ()=>[
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ];
    const getNumber = ()=>[
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryNumber
        ];
    const getNumberAndArbitrary = ()=>[
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    return {
        cacheSize: 500,
        separator: ":",
        theme: {
            colors: [
                $85fc2fe65ff21506$var$isAny
            ],
            spacing: [
                $85fc2fe65ff21506$var$isLength,
                $85fc2fe65ff21506$var$isArbitraryLength
            ],
            blur: [
                "none",
                "",
                $85fc2fe65ff21506$var$isTshirtSize,
                $85fc2fe65ff21506$var$isArbitraryValue
            ],
            brightness: getNumber(),
            borderColor: [
                colors
            ],
            borderRadius: [
                "none",
                "",
                "full",
                $85fc2fe65ff21506$var$isTshirtSize,
                $85fc2fe65ff21506$var$isArbitraryValue
            ],
            borderSpacing: getSpacingWithArbitrary(),
            borderWidth: getLengthWithEmptyAndArbitrary(),
            contrast: getNumber(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: getSpacingWithArbitrary(),
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                $85fc2fe65ff21506$var$isPercent,
                $85fc2fe65ff21506$var$isArbitraryLength
            ],
            inset: getSpacingWithAutoAndArbitrary(),
            margin: getSpacingWithAutoAndArbitrary(),
            opacity: getNumber(),
            padding: getSpacingWithArbitrary(),
            saturate: getNumber(),
            scale: getNumber(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: getSpacingWithArbitrary(),
            translate: getSpacingWithArbitrary()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        "video",
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                "container"
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $85fc2fe65ff21506$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ "break-after": [
                {
                    "break-after": getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ "break-before": [
                {
                    "break-before": getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        "right",
                        "left",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ "object-position": [
                {
                    object: [
                        ...getPositions(),
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-x": [
                {
                    "overflow-x": getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-y": [
                {
                    "overflow-y": getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-x": [
                {
                    "overscroll-x": getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-y": [
                {
                    "overscroll-y": getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-x": [
                {
                    "inset-x": [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-y": [
                {
                    "inset-y": [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        "auto",
                        $85fc2fe65ff21506$var$isInteger,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAutoAndArbitrary()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ "flex-wrap": [
                {
                    flex: [
                        "wrap",
                        "wrap-reverse",
                        "nowrap"
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        "1",
                        "auto",
                        "initial",
                        "none",
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        "first",
                        "last",
                        "none",
                        $85fc2fe65ff21506$var$isInteger,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ "grid-cols": [
                {
                    "grid-cols": [
                        $85fc2fe65ff21506$var$isAny
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start-end": [
                {
                    col: [
                        "auto",
                        {
                            span: [
                                "full",
                                $85fc2fe65ff21506$var$isInteger,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ]
                        },
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start": [
                {
                    "col-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-end": [
                {
                    "col-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ "grid-rows": [
                {
                    "grid-rows": [
                        $85fc2fe65ff21506$var$isAny
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start-end": [
                {
                    row: [
                        "auto",
                        {
                            span: [
                                $85fc2fe65ff21506$var$isInteger,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ]
                        },
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start": [
                {
                    "row-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-end": [
                {
                    "row-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ "auto-cols": [
                {
                    "auto-cols": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ "auto-rows": [
                {
                    "auto-rows": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ "gap-x": [
                {
                    "gap-x": [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ "gap-y": [
                {
                    "gap-y": [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ "justify-content": [
                {
                    justify: [
                        "normal",
                        ...getAlign()
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ "justify-items": [
                {
                    "justify-items": [
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ "align-content": [
                {
                    content: [
                        "normal",
                        ...getAlign(),
                        "baseline"
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ "align-items": [
                {
                    items: [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ "align-self": [
                {
                    self: [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ "place-content": [
                {
                    "place-content": [
                        ...getAlign(),
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ "place-items": [
                {
                    "place-items": [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ "place-self": [
                {
                    "place-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ "space-x": [
                {
                    "space-x": [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ "space-y": [
                {
                    "space-y": [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-y-reverse": [
                "space-y-reverse"
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        "auto",
                        "min",
                        "max",
                        "fit",
                        "svw",
                        "lvw",
                        "dvw",
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ "min-w": [
                {
                    "min-w": [
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ "max-w": [
                {
                    "max-w": [
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        spacing,
                        "none",
                        "full",
                        "min",
                        "max",
                        "fit",
                        "prose",
                        {
                            screen: [
                                $85fc2fe65ff21506$var$isTshirtSize
                            ]
                        },
                        $85fc2fe65ff21506$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ "min-h": [
                {
                    "min-h": [
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ "max-h": [
                {
                    "max-h": [
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */ size: [
                {
                    size: [
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ "font-size": [
                {
                    text: [
                        "base",
                        $85fc2fe65ff21506$var$isTshirtSize,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ "font-weight": [
                {
                    font: [
                        "thin",
                        "extralight",
                        "light",
                        "normal",
                        "medium",
                        "semibold",
                        "bold",
                        "extrabold",
                        "black",
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ "font-family": [
                {
                    font: [
                        $85fc2fe65ff21506$var$isAny
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-normal": [
                "normal-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-ordinal": [
                "ordinal"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractons"
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        "tighter",
                        "tight",
                        "normal",
                        "wide",
                        "wider",
                        "widest",
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ "line-clamp": [
                {
                    "line-clamp": [
                        "none",
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        "none",
                        "tight",
                        "snug",
                        "normal",
                        "relaxed",
                        "loose",
                        $85fc2fe65ff21506$var$isLength,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ "list-image": [
                {
                    "list-image": [
                        "none",
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ "list-style-type": [
                {
                    list: [
                        "none",
                        "disc",
                        "decimal",
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ "placeholder-color": [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ "placeholder-opacity": [
                {
                    "placeholder-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ "text-color": [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ "text-opacity": [
                {
                    "text-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ "text-decoration-style": [
                {
                    decoration: [
                        ...getLineStyles(),
                        "wavy"
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ "text-decoration-thickness": [
                {
                    decoration: [
                        "auto",
                        "from-font",
                        $85fc2fe65ff21506$var$isLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ "underline-offset": [
                {
                    "underline-offset": [
                        "auto",
                        $85fc2fe65ff21506$var$isLength,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ "text-decoration-color": [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ "text-wrap": [
                {
                    text: [
                        "wrap",
                        "nowrap",
                        "balance",
                        "pretty"
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: getSpacingWithArbitrary()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        "none",
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ "bg-opacity": [
                {
                    "bg-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ "bg-position": [
                {
                    bg: [
                        ...getPositions(),
                        $85fc2fe65ff21506$var$isArbitraryPosition
                    ]
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ "bg-repeat": [
                {
                    bg: [
                        "no-repeat",
                        {
                            repeat: [
                                "",
                                "x",
                                "y",
                                "round",
                                "space"
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ "bg-size": [
                {
                    bg: [
                        "auto",
                        "cover",
                        "contain",
                        $85fc2fe65ff21506$var$isArbitrarySize
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            "gradient-to": [
                                "t",
                                "tr",
                                "r",
                                "br",
                                "b",
                                "bl",
                                "l",
                                "tl"
                            ]
                        },
                        $85fc2fe65ff21506$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ "bg-color": [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from-pos": [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via-pos": [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to-pos": [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from": [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via": [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to": [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-s": [
                {
                    "rounded-s": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-e": [
                {
                    "rounded-e": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-t": [
                {
                    "rounded-t": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-r": [
                {
                    "rounded-r": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-b": [
                {
                    "rounded-b": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-l": [
                {
                    "rounded-l": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ss": [
                {
                    "rounded-ss": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-se": [
                {
                    "rounded-se": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ee": [
                {
                    "rounded-ee": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-es": [
                {
                    "rounded-es": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tl": [
                {
                    "rounded-tl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tr": [
                {
                    "rounded-tr": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-br": [
                {
                    "rounded-br": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-bl": [
                {
                    "rounded-bl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w": [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-x": [
                {
                    "border-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-y": [
                {
                    "border-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-s": [
                {
                    "border-s": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-e": [
                {
                    "border-e": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-t": [
                {
                    "border-t": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-r": [
                {
                    "border-r": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-b": [
                {
                    "border-b": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-l": [
                {
                    "border-l": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ "border-opacity": [
                {
                    "border-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ "border-style": [
                {
                    border: [
                        ...getLineStyles(),
                        "hidden"
                    ]
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x": [
                {
                    "divide-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y": [
                {
                    "divide-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ "divide-opacity": [
                {
                    "divide-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ "divide-style": [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color": [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-x": [
                {
                    "border-x": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-y": [
                {
                    "border-y": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-t": [
                {
                    "border-t": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-r": [
                {
                    "border-r": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-b": [
                {
                    "border-b": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-l": [
                {
                    "border-l": [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ "divide-color": [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ "outline-style": [
                {
                    outline: [
                        "",
                        ...getLineStyles()
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ "outline-offset": [
                {
                    "outline-offset": [
                        $85fc2fe65ff21506$var$isLength,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ "outline-w": [
                {
                    outline: [
                        $85fc2fe65ff21506$var$isLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ "outline-color": [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w": [
                {
                    ring: getLengthWithEmptyAndArbitrary()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w-inset": [
                "ring-inset"
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ "ring-color": [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ "ring-opacity": [
                {
                    "ring-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ "ring-offset-w": [
                {
                    "ring-offset": [
                        $85fc2fe65ff21506$var$isLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ "ring-offset-color": [
                {
                    "ring-offset": [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        $85fc2fe65ff21506$var$isTshirtSize,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ "shadow-color": [
                {
                    shadow: [
                        $85fc2fe65ff21506$var$isAny
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ "mix-blend": [
                {
                    "mix-blend": getBlendModes()
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ "bg-blend": [
                {
                    "bg-blend": getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        $85fc2fe65ff21506$var$isTshirtSize,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ "hue-rotate": [
                {
                    "hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ "backdrop-blur": [
                {
                    "backdrop-blur": [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing": [
                {
                    "border-spacing": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-x": [
                {
                    "border-spacing-x": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-y": [
                {
                    "border-spacing-y": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        "none",
                        "all",
                        "",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        "linear",
                        "in",
                        "out",
                        "in-out",
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        "none",
                        "spin",
                        "ping",
                        "pulse",
                        "bounce",
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        "",
                        "gpu",
                        "none"
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ "scale-x": [
                {
                    "scale-x": [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ "scale-y": [
                {
                    "scale-y": [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        $85fc2fe65ff21506$var$isInteger,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ "translate-x": [
                {
                    "translate-x": [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ "translate-y": [
                {
                    "translate-y": [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ "skew-x": [
                {
                    "skew-x": [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ "skew-y": [
                {
                    "skew-y": [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ "transform-origin": [
                {
                    origin: [
                        "center",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left",
                        "top-left",
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        "auto",
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ "caret-color": [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ "pointer-events": [
                {
                    "pointer-events": [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        "none",
                        "y",
                        "x",
                        ""
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-m": [
                {
                    "scroll-m": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mx": [
                {
                    "scroll-mx": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-my": [
                {
                    "scroll-my": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ms": [
                {
                    "scroll-ms": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-me": [
                {
                    "scroll-me": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mt": [
                {
                    "scroll-mt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mr": [
                {
                    "scroll-mr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mb": [
                {
                    "scroll-mb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ml": [
                {
                    "scroll-ml": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-p": [
                {
                    "scroll-p": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-px": [
                {
                    "scroll-px": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-py": [
                {
                    "scroll-py": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-ps": [
                {
                    "scroll-ps": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pe": [
                {
                    "scroll-pe": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pt": [
                {
                    "scroll-pt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pr": [
                {
                    "scroll-pr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pb": [
                {
                    "scroll-pb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pl": [
                {
                    "scroll-pl": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "manipulation"
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-x": [
                {
                    "touch-pan": [
                        "x",
                        "left",
                        "right"
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-y": [
                {
                    "touch-pan": [
                        "y",
                        "up",
                        "down"
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-pz": [
                "touch-pinch-zoom"
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        "none"
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ "stroke-w": [
                {
                    stroke: [
                        $85fc2fe65ff21506$var$isLength,
                        $85fc2fe65ff21506$var$isArbitraryLength,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        "none"
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                "sr-only",
                "not-sr-only"
            ],
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ "forced-color-adjust": [
                {
                    "forced-color-adjust": [
                        "auto",
                        "none"
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            size: [
                "w",
                "h"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            "line-clamp": [
                "display",
                "overflow"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-s",
                "border-w-e",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ],
            touch: [
                "touch-x",
                "touch-y",
                "touch-pz"
            ],
            "touch-x": [
                "touch"
            ],
            "touch-y": [
                "touch"
            ],
            "touch-pz": [
                "touch"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        }
    };
}
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ function $85fc2fe65ff21506$var$mergeConfigs(baseConfig, { cacheSize: cacheSize, prefix: prefix, separator: separator, extend: extend = {}, override: override = {} }) {
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, "cacheSize", cacheSize);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, "prefix", prefix);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, "separator", separator);
    for(const configKey in override)$85fc2fe65ff21506$var$overrideConfigProperties(baseConfig[configKey], override[configKey]);
    for(const key in extend)$85fc2fe65ff21506$var$mergeConfigProperties(baseConfig[key], extend[key]);
    return baseConfig;
}
function $85fc2fe65ff21506$var$overrideProperty(baseObject, overrideKey, overrideValue) {
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
}
function $85fc2fe65ff21506$var$overrideConfigProperties(baseObject, overrideObject) {
    if (overrideObject) for(const key in overrideObject)$85fc2fe65ff21506$var$overrideProperty(baseObject, key, overrideObject[key]);
}
function $85fc2fe65ff21506$var$mergeConfigProperties(baseObject, mergeObject) {
    if (mergeObject) for(const key in mergeObject){
        const mergeValue = mergeObject[key];
        if (mergeValue !== undefined) baseObject[key] = (baseObject[key] || []).concat(mergeValue);
    }
}
function $85fc2fe65ff21506$var$extendTailwindMerge(configExtension, ...createConfig) {
    return typeof configExtension === "function" ? $85fc2fe65ff21506$var$createTailwindMerge($85fc2fe65ff21506$var$getDefaultConfig, configExtension, ...createConfig) : $85fc2fe65ff21506$var$createTailwindMerge(()=>$85fc2fe65ff21506$var$mergeConfigs($85fc2fe65ff21506$var$getDefaultConfig(), configExtension), ...createConfig);
}
const $85fc2fe65ff21506$var$twMerge = /*#__PURE__*/ $85fc2fe65ff21506$var$createTailwindMerge($85fc2fe65ff21506$var$getDefaultConfig);
module.exports.createTailwindMerge = $85fc2fe65ff21506$var$createTailwindMerge;
module.exports.extendTailwindMerge = $85fc2fe65ff21506$var$extendTailwindMerge;
module.exports.fromTheme = $85fc2fe65ff21506$var$fromTheme;
module.exports.getDefaultConfig = $85fc2fe65ff21506$var$getDefaultConfig;
module.exports.mergeConfigs = $85fc2fe65ff21506$var$mergeConfigs;
module.exports.twJoin = $85fc2fe65ff21506$var$twJoin;
module.exports.twMerge = $85fc2fe65ff21506$var$twMerge;
module.exports.validators = $85fc2fe65ff21506$var$validators;

});



parcelRegister("5R0Xk", function(module, exports) {
$parcel$export(module.exports, "Spinner", () => (parcelRequire("5Ttm9")).Spinner);
parcelRequire("5Ttm9");

});
parcelRegister("5Ttm9", function(module, exports) {

$parcel$export(module.exports, "Spinner", () => $26f870cc44541b9c$export$7f7cbe89f1eacd2);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
function $26f870cc44541b9c$export$7f7cbe89f1eacd2({ className: className, fullScreen: fullScreen = false, testId: testId }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)({
            "relative flex h-screen w-full items-center justify-center": fullScreen
        }),
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            role: "status",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                "aria-hidden": "true",
                className: `size-4 animate-spin fill-gray-600 text-gray-200 ${className}`,
                viewBox: "0 0 100 101",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                        fill: "currentFill"
                    })
                ]
            })
        })
    });
}

});


parcelRegister("ajahQ", function(module, exports) {
parcelRequire("5VTVQ");

});
parcelRegister("5VTVQ", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");
function $e7983bb217f573d6$export$c86715117507e8e5({ onChange: onChange, placeholder: placeholder, name: name, id: id, value: value, className: className, testId: testId, multiline: multiline }) {
    const [focused, setFocus] = (0, $acw62.useState)(false);
    const Root = multiline ? "textarea" : "input";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("w-full", className),
        "data-testid": testId,
        children: [
            placeholder && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: (0, $9QePP.default)("ui-element text-disabledTextColor pb-1 pl-4 text-[12px]", {
                    "opacity-0": !focused
                }),
                children: placeholder
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(Root, {
                type: "text",
                name: name,
                id: id,
                value: value,
                className: (0, $9QePP.default)(`border-default w-full rounded border bg-transparent p-3 pl-4 outline-none
                    focus:ring-transparent`, {
                    "placeholder:text-transparent": focused
                }),
                placeholder: !value ? placeholder : undefined,
                onFocus: ()=>setFocus(true),
                onBlur: ()=>setFocus(false),
                onChange: (e)=>onChange(e.target.value)
            })
        ]
    });
}

});


parcelRegister("6jolY", function(module, exports) {
$parcel$export(module.exports, "MoreButton", () => (parcelRequire("eEgbe")).MoreButton);
parcelRequire("eEgbe");

});
parcelRegister("eEgbe", function(module, exports) {

$parcel$export(module.exports, "MoreButton", () => $6d8d97ed8dc4bdec$export$7f94856880993f27);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $hjTZz = parcelRequire("hjTZz");
var $iymfR = parcelRequire("iymfR");
parcelRequire("4aCOh");
var $hUCih = parcelRequire("hUCih");

var $9QePP = parcelRequire("9QePP");
var $6d8d97ed8dc4bdec$export$8d0d3baf6324ac05;
(function(ItemTextPosition) {
    ItemTextPosition["LEFT"] = "left";
    ItemTextPosition["RIGHT"] = "right";
})($6d8d97ed8dc4bdec$export$8d0d3baf6324ac05 || ($6d8d97ed8dc4bdec$export$8d0d3baf6324ac05 = {}));
function $6d8d97ed8dc4bdec$export$7f94856880993f27({ items: items, disabled: disabled }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hjTZz.Menu), {
        as: "div",
        className: "relative inline-block text-left",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjTZz.Menu).Button, {
                    "data-testid": "morebutton",
                    className: (0, $9QePP.default)("w-full cursor-pointer !bg-transparent px-4 py-2", "text-sm text-gray-700", "inline-flex justify-center font-medium"),
                    disabled: disabled,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).TripleDot, {
                        className: "text-icon-subdued -rotate-90"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition), {
                as: (0, $acw62.Fragment),
                enter: "transition ease-out duration-100",
                enterFrom: "transform opacity-0 scale-95",
                enterTo: "transform opacity-100 scale-100",
                leave: "transition ease-in duration-75",
                leaveFrom: "transform opacity-100 scale-100",
                leaveTo: "transform opacity-0 scale-95",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjTZz.Menu).Items, {
                    className: (0, $9QePP.default)("bg-surface-default z-10 mt-2 w-56", "shadow-default absolute right-0 origin-top-right rounded-md"),
                    children: items.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjTZz.Menu).Item, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>{
                                    item.onClick();
                                },
                                className: (0, $9QePP.default)("md secondary my-1 w-full", item.position === "right" ? "justify-end" : "justify-start", !item.position && "justify-center"),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "ui-element cursor-pointer text-left",
                                    children: item.label
                                })
                            })
                        }, item.label))
                })
            })
        ]
    });
}

});
parcelRegister("hjTZz", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $c9bfa4e2da6232f7$export$d9b273488cd8ce6f);

var $kd7LS = parcelRequire("kd7LS");

var $6o6B3 = parcelRequire("6o6B3");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $cE9hP = parcelRequire("cE9hP");

var $hd1nN = parcelRequire("hd1nN");

var $5Ai9V = parcelRequire("5Ai9V");

var $dfvrc = parcelRequire("dfvrc");

var $114Mg = parcelRequire("114Mg");

var $acw62 = parcelRequire("acw62");

var $keKjn = parcelRequire("keKjn");

var $8KgIp = parcelRequire("8KgIp");

var $dcp2r = parcelRequire("dcp2r");

var $23pTr = parcelRequire("23pTr");

var $5IEAk = parcelRequire("5IEAk");

var $gm4XX = parcelRequire("gm4XX");

var $hZodg = parcelRequire("hZodg");

var $6mpbl = parcelRequire("6mpbl");

var $jN7sP = parcelRequire("jN7sP");

var $ipity = parcelRequire("ipity");

var $bdknl = parcelRequire("bdknl");

var $1nOiu = parcelRequire("1nOiu");

var $34Str = parcelRequire("34Str");

var $auuNT = parcelRequire("auuNT");

var $5fYEB = parcelRequire("5fYEB");

var $fLrGx = parcelRequire("fLrGx");

var $1COYr = parcelRequire("1COYr");

var $hsQxB = parcelRequire("hsQxB");

var $6Ngq1 = parcelRequire("6Ngq1");

var $ebRQH = parcelRequire("ebRQH");

var $iGb09 = parcelRequire("iGb09");

var $6AKlm = parcelRequire("6AKlm");

var $5qg9U = parcelRequire("5qg9U");

var $e9NTc = parcelRequire("e9NTc");
"use client";
var $c9bfa4e2da6232f7$var$qe = ((r)=>(r[r.Open = 0] = "Open", r[r.Closed = 1] = "Closed", r))($c9bfa4e2da6232f7$var$qe || {}), $c9bfa4e2da6232f7$var$ze = ((r)=>(r[r.Pointer = 0] = "Pointer", r[r.Other = 1] = "Other", r))($c9bfa4e2da6232f7$var$ze || {}), $c9bfa4e2da6232f7$var$Ye = ((a)=>(a[a.OpenMenu = 0] = "OpenMenu", a[a.CloseMenu = 1] = "CloseMenu", a[a.GoToItem = 2] = "GoToItem", a[a.Search = 3] = "Search", a[a.ClearSearch = 4] = "ClearSearch", a[a.RegisterItem = 5] = "RegisterItem", a[a.UnregisterItem = 6] = "UnregisterItem", a[a.SetButtonElement = 7] = "SetButtonElement", a[a.SetItemsElement = 8] = "SetItemsElement", a))($c9bfa4e2da6232f7$var$Ye || {});
function $c9bfa4e2da6232f7$var$j(e, n = (r)=>r) {
    let r = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, l = (0, $hsQxB.sortByDomNode)(n(e.items.slice()), (u)=>u.dataRef.current.domRef.current), o = r ? l.indexOf(r) : null;
    return o === -1 && (o = null), {
        items: l,
        activeItemIndex: o
    };
}
let $c9bfa4e2da6232f7$var$Ze = {
    [1] (e) {
        return e.menuState === 1 ? e : {
            ...e,
            activeItemIndex: null,
            menuState: 1
        };
    },
    [0] (e) {
        return e.menuState === 0 ? e : {
            ...e,
            __demoMode: !1,
            menuState: 0
        };
    },
    [2]: (e, n)=>{
        var u, p, s, m, a;
        if (e.menuState === 1) return e;
        let r = {
            ...e,
            searchQuery: "",
            activationTrigger: (u = n.trigger) != null ? u : 1,
            __demoMode: !1
        };
        if (n.focus === (0, $fLrGx.Focus).Nothing) return {
            ...r,
            activeItemIndex: null
        };
        if (n.focus === (0, $fLrGx.Focus).Specific) return {
            ...r,
            activeItemIndex: e.items.findIndex((t)=>t.id === n.id)
        };
        if (n.focus === (0, $fLrGx.Focus).Previous) {
            let t = e.activeItemIndex;
            if (t !== null) {
                let d = e.items[t].dataRef.current.domRef, f = (0, $fLrGx.calculateActiveIndex)(n, {
                    resolveItems: ()=>e.items,
                    resolveActiveIndex: ()=>e.activeItemIndex,
                    resolveId: (c)=>c.id,
                    resolveDisabled: (c)=>c.dataRef.current.disabled
                });
                if (f !== null) {
                    let c = e.items[f].dataRef.current.domRef;
                    if (((p = d.current) == null ? void 0 : p.previousElementSibling) === c.current || ((s = c.current) == null ? void 0 : s.previousElementSibling) === null) return {
                        ...r,
                        activeItemIndex: f
                    };
                }
            }
        } else if (n.focus === (0, $fLrGx.Focus).Next) {
            let t = e.activeItemIndex;
            if (t !== null) {
                let d = e.items[t].dataRef.current.domRef, f = (0, $fLrGx.calculateActiveIndex)(n, {
                    resolveItems: ()=>e.items,
                    resolveActiveIndex: ()=>e.activeItemIndex,
                    resolveId: (c)=>c.id,
                    resolveDisabled: (c)=>c.dataRef.current.disabled
                });
                if (f !== null) {
                    let c = e.items[f].dataRef.current.domRef;
                    if (((m = d.current) == null ? void 0 : m.nextElementSibling) === c.current || ((a = c.current) == null ? void 0 : a.nextElementSibling) === null) return {
                        ...r,
                        activeItemIndex: f
                    };
                }
            }
        }
        let l = $c9bfa4e2da6232f7$var$j(e), o = (0, $fLrGx.calculateActiveIndex)(n, {
            resolveItems: ()=>l.items,
            resolveActiveIndex: ()=>l.activeItemIndex,
            resolveId: (t)=>t.id,
            resolveDisabled: (t)=>t.dataRef.current.disabled
        });
        return {
            ...r,
            ...l,
            activeItemIndex: o
        };
    },
    [3]: (e, n)=>{
        let l = e.searchQuery !== "" ? 0 : 1, o = e.searchQuery + n.value.toLowerCase(), p = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + l).concat(e.items.slice(0, e.activeItemIndex + l)) : e.items).find((m)=>{
            var a;
            return ((a = m.dataRef.current.textValue) == null ? void 0 : a.startsWith(o)) && !m.dataRef.current.disabled;
        }), s = p ? e.items.indexOf(p) : -1;
        return s === -1 || s === e.activeItemIndex ? {
            ...e,
            searchQuery: o
        } : {
            ...e,
            searchQuery: o,
            activeItemIndex: s,
            activationTrigger: 1
        };
    },
    [4] (e) {
        return e.searchQuery === "" ? e : {
            ...e,
            searchQuery: "",
            searchActiveItemIndex: null
        };
    },
    [5]: (e, n)=>{
        let r = $c9bfa4e2da6232f7$var$j(e, (l)=>[
                ...l,
                {
                    id: n.id,
                    dataRef: n.dataRef
                }
            ]);
        return {
            ...e,
            ...r
        };
    },
    [6]: (e, n)=>{
        let r = $c9bfa4e2da6232f7$var$j(e, (l)=>{
            let o = l.findIndex((u)=>u.id === n.id);
            return o !== -1 && l.splice(o, 1), l;
        });
        return {
            ...e,
            ...r,
            activationTrigger: 1
        };
    },
    [7]: (e, n)=>e.buttonElement === n.element ? e : {
            ...e,
            buttonElement: n.element
        },
    [8]: (e, n)=>e.itemsElement === n.element ? e : {
            ...e,
            itemsElement: n.element
        }
}, $c9bfa4e2da6232f7$var$Q = (0, $acw62.createContext)(null);
$c9bfa4e2da6232f7$var$Q.displayName = "MenuContext";
function $c9bfa4e2da6232f7$var$w(e) {
    let n = (0, $acw62.useContext)($c9bfa4e2da6232f7$var$Q);
    if (n === null) {
        let r = new Error(`<${e} /> is missing a parent <Menu /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(r, $c9bfa4e2da6232f7$var$w), r;
    }
    return n;
}
function $c9bfa4e2da6232f7$var$et(e, n) {
    return (0, $6Ngq1.match)(n.type, $c9bfa4e2da6232f7$var$Ze, e, n);
}
let $c9bfa4e2da6232f7$var$tt = (0, $acw62.Fragment);
function $c9bfa4e2da6232f7$var$nt(e, n) {
    let { __demoMode: r = !1, ...l } = e, o = (0, $acw62.useReducer)($c9bfa4e2da6232f7$var$et, {
        __demoMode: r,
        menuState: r ? 0 : 1,
        buttonElement: null,
        itemsElement: null,
        items: [],
        searchQuery: "",
        activeItemIndex: null,
        activationTrigger: 1
    }), [{ menuState: u, itemsElement: p, buttonElement: s }, m] = o, a = (0, $6mpbl.useSyncRefs)(n);
    (0, $23pTr.useOutsideClick)(u === 0, [
        s,
        p
    ], (b, S)=>{
        m({
            type: 1
        }), (0, $hsQxB.isFocusableElement)(S, (0, $hsQxB.FocusableMode).Loose) || (b.preventDefault(), s == null || s.focus());
    });
    let d = (0, $114Mg.useEvent)(()=>{
        m({
            type: 1
        });
    }), f = (0, $acw62.useMemo)(()=>({
            open: u === 0,
            close: d
        }), [
        u,
        d
    ]), c = {
        ref: a
    }, A = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $34Str.FloatingProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c9bfa4e2da6232f7$var$Q.Provider, {
        value: o
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $auuNT.OpenClosedProvider), {
        value: (0, $6Ngq1.match)(u, {
            [0]: (0, $auuNT.State).Open,
            [1]: (0, $auuNT.State).Closed
        })
    }, A({
        ourProps: c,
        theirProps: l,
        slot: f,
        defaultTag: $c9bfa4e2da6232f7$var$tt,
        name: "Menu"
    }))));
}
let $c9bfa4e2da6232f7$var$rt = "button";
function $c9bfa4e2da6232f7$var$ot(e, n) {
    var h;
    let r = (0, $acw62.useId)(), { id: l = `headlessui-menu-button-${r}`, disabled: o = !1, autoFocus: u = !1, ...p } = e, [s, m] = $c9bfa4e2da6232f7$var$w("Menu.Button"), a = (0, $34Str.useFloatingReferenceProps)(), t = (0, $6mpbl.useSyncRefs)(n, (0, $34Str.useFloatingReference)(), (0, $114Mg.useEvent)((T)=>m({
            type: 7,
            element: T
        }))), d = (0, $114Mg.useEvent)((T)=>{
        switch(T.key){
            case (0, $6AKlm.Keys).Space:
            case (0, $6AKlm.Keys).Enter:
            case (0, $6AKlm.Keys).ArrowDown:
                T.preventDefault(), T.stopPropagation(), (0, $1u0KT.flushSync)(()=>m({
                        type: 0
                    })), m({
                    type: 2,
                    focus: (0, $fLrGx.Focus).First
                });
                break;
            case (0, $6AKlm.Keys).ArrowUp:
                T.preventDefault(), T.stopPropagation(), (0, $1u0KT.flushSync)(()=>m({
                        type: 0
                    })), m({
                    type: 2,
                    focus: (0, $fLrGx.Focus).Last
                });
                break;
        }
    }), f = (0, $114Mg.useEvent)((T)=>{
        switch(T.key){
            case (0, $6AKlm.Keys).Space:
                T.preventDefault();
                break;
        }
    }), c = (0, $114Mg.useEvent)((T)=>{
        var F;
        if ((0, $5fYEB.isDisabledReactIssue7711)(T.currentTarget)) return T.preventDefault();
        o || (s.menuState === 0 ? ((0, $1u0KT.flushSync)(()=>m({
                type: 1
            })), (F = s.buttonElement) == null || F.focus({
            preventScroll: !0
        })) : (T.preventDefault(), m({
            type: 0
        })));
    }), { isFocusVisible: A, focusProps: b } = (0, $kd7LS.useFocusRing)({
        autoFocus: u
    }), { isHovered: S, hoverProps: D } = (0, $6o6B3.useHover)({
        isDisabled: o
    }), { pressed: M, pressProps: P } = (0, $cE9hP.useActivePress)({
        disabled: o
    }), v = (0, $acw62.useMemo)(()=>({
            open: s.menuState === 0,
            active: M || s.menuState === 0,
            disabled: o,
            hover: S,
            focus: A,
            autofocus: u
        }), [
        s,
        S,
        A,
        M,
        o,
        u
    ]), C = (0, $ebRQH.mergeProps)(a(), {
        ref: t,
        id: l,
        type: (0, $gm4XX.useResolveButtonType)(e, s.buttonElement),
        "aria-haspopup": "menu",
        "aria-controls": (h = s.itemsElement) == null ? void 0 : h.id,
        "aria-expanded": s.menuState === 0,
        disabled: o || void 0,
        autoFocus: u,
        onKeyDown: d,
        onKeyUp: f,
        onClick: c
    }, b, D, P);
    return (0, $ebRQH.useRender)()({
        ourProps: C,
        theirProps: p,
        slot: v,
        defaultTag: $c9bfa4e2da6232f7$var$rt,
        name: "Menu.Button"
    });
}
let $c9bfa4e2da6232f7$var$at = "div", $c9bfa4e2da6232f7$var$lt = (0, $ebRQH.RenderFeatures).RenderStrategy | (0, $ebRQH.RenderFeatures).Static;
function $c9bfa4e2da6232f7$var$it(e, n) {
    var J, V;
    let r = (0, $acw62.useId)(), { id: l = `headlessui-menu-items-${r}`, anchor: o, portal: u = !1, modal: p = !0, transition: s = !1, ...m } = e, a = (0, $34Str.useResolvedAnchor)(o), [t, d] = $c9bfa4e2da6232f7$var$w("Menu.Items"), [f, c] = (0, $34Str.useFloatingPanel)(a), A = (0, $34Str.useFloatingPanelProps)(), [b, S] = (0, $acw62.useState)(null), D = (0, $6mpbl.useSyncRefs)(n, a ? f : null, (0, $114Mg.useEvent)((i)=>d({
            type: 8,
            element: i
        })), S), M = (0, $5IEAk.useOwnerDocument)(t.itemsElement);
    a && (u = !0);
    let P = (0, $auuNT.useOpenClosed)(), [v, C] = (0, $bdknl.useTransition)(s, b, P !== null ? (P & (0, $auuNT.State).Open) === (0, $auuNT.State).Open : t.menuState === 0);
    (0, $dcp2r.useOnDisappear)(v, t.buttonElement, ()=>{
        d({
            type: 1
        });
    });
    let O = t.__demoMode ? !1 : p && t.menuState === 0;
    (0, $hZodg.useScrollLock)(O, M);
    let h = t.__demoMode ? !1 : p && t.menuState === 0;
    (0, $keKjn.useInertOthers)(h, {
        allowed: (0, $acw62.useCallback)(()=>[
                t.buttonElement,
                t.itemsElement
            ], [
            t.buttonElement,
            t.itemsElement
        ])
    });
    let T = t.menuState !== 0, K = (0, $hd1nN.useDidElementMove)(T, t.buttonElement) ? !1 : v;
    (0, $acw62.useEffect)(()=>{
        let i = t.itemsElement;
        i && t.menuState === 0 && i !== (M == null ? void 0 : M.activeElement) && i.focus({
            preventScroll: !0
        });
    }, [
        t.menuState,
        t.itemsElement,
        M
    ]), (0, $1nOiu.useTreeWalker)(t.menuState === 0, {
        container: t.itemsElement,
        accept (i) {
            return i.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : i.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (i) {
            i.setAttribute("role", "none");
        }
    });
    let I = (0, $5Ai9V.useDisposables)(), G = (0, $114Mg.useEvent)((i)=>{
        var X, $, q;
        switch(I.dispose(), i.key){
            case (0, $6AKlm.Keys).Space:
                if (t.searchQuery !== "") return i.preventDefault(), i.stopPropagation(), d({
                    type: 3,
                    value: i.key
                });
            case (0, $6AKlm.Keys).Enter:
                if (i.preventDefault(), i.stopPropagation(), d({
                    type: 1
                }), t.activeItemIndex !== null) {
                    let { dataRef: ue } = t.items[t.activeItemIndex];
                    ($ = (X = ue.current) == null ? void 0 : X.domRef.current) == null || $.click();
                }
                (0, $hsQxB.restoreFocusIfNecessary)(t.buttonElement);
                break;
            case (0, $6AKlm.Keys).ArrowDown:
                return i.preventDefault(), i.stopPropagation(), d({
                    type: 2,
                    focus: (0, $fLrGx.Focus).Next
                });
            case (0, $6AKlm.Keys).ArrowUp:
                return i.preventDefault(), i.stopPropagation(), d({
                    type: 2,
                    focus: (0, $fLrGx.Focus).Previous
                });
            case (0, $6AKlm.Keys).Home:
            case (0, $6AKlm.Keys).PageUp:
                return i.preventDefault(), i.stopPropagation(), d({
                    type: 2,
                    focus: (0, $fLrGx.Focus).First
                });
            case (0, $6AKlm.Keys).End:
            case (0, $6AKlm.Keys).PageDown:
                return i.preventDefault(), i.stopPropagation(), d({
                    type: 2,
                    focus: (0, $fLrGx.Focus).Last
                });
            case (0, $6AKlm.Keys).Escape:
                i.preventDefault(), i.stopPropagation(), (0, $1u0KT.flushSync)(()=>d({
                        type: 1
                    })), (q = t.buttonElement) == null || q.focus({
                    preventScroll: !0
                });
                break;
            case (0, $6AKlm.Keys).Tab:
                i.preventDefault(), i.stopPropagation(), (0, $1u0KT.flushSync)(()=>d({
                        type: 1
                    })), (0, $hsQxB.focusFrom)(t.buttonElement, i.shiftKey ? (0, $hsQxB.Focus).Previous : (0, $hsQxB.Focus).Next);
                break;
            default:
                i.key.length === 1 && (d({
                    type: 3,
                    value: i.key
                }), I.setTimeout(()=>d({
                        type: 4
                    }), 350));
                break;
        }
    }), ae = (0, $114Mg.useEvent)((i)=>{
        switch(i.key){
            case (0, $6AKlm.Keys).Space:
                i.preventDefault();
                break;
        }
    }), le = (0, $acw62.useMemo)(()=>({
            open: t.menuState === 0
        }), [
        t.menuState
    ]), ie = (0, $ebRQH.mergeProps)(a ? A() : {}, {
        "aria-activedescendant": t.activeItemIndex === null || (J = t.items[t.activeItemIndex]) == null ? void 0 : J.id,
        "aria-labelledby": (V = t.buttonElement) == null ? void 0 : V.id,
        id: l,
        onKeyDown: G,
        onKeyUp: ae,
        role: "menu",
        tabIndex: t.menuState === 0 ? 0 : void 0,
        ref: D,
        style: {
            ...m.style,
            ...c,
            "--button-width": (0, $dfvrc.useElementSize)(t.buttonElement, !0).width
        },
        ...(0, $bdknl.transitionDataAttributes)(C)
    }), se = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e9NTc.Portal), {
        enabled: u ? e.static || v : !1
    }, se({
        ourProps: ie,
        theirProps: m,
        slot: le,
        defaultTag: $c9bfa4e2da6232f7$var$at,
        features: $c9bfa4e2da6232f7$var$lt,
        visible: K,
        name: "Menu.Items"
    }));
}
let $c9bfa4e2da6232f7$var$st = (0, $acw62.Fragment);
function $c9bfa4e2da6232f7$var$ut(e, n) {
    let r = (0, $acw62.useId)(), { id: l = `headlessui-menu-item-${r}`, disabled: o = !1, ...u } = e, [p, s] = $c9bfa4e2da6232f7$var$w("Menu.Item"), m = p.activeItemIndex !== null ? p.items[p.activeItemIndex].id === l : !1, a = (0, $acw62.useRef)(null), t = (0, $6mpbl.useSyncRefs)(n, a);
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!p.__demoMode && p.menuState === 0 && m && p.activationTrigger !== 0) return (0, $1COYr.disposables)().requestAnimationFrame(()=>{
            var I, G;
            (G = (I = a.current) == null ? void 0 : I.scrollIntoView) == null || G.call(I, {
                block: "nearest"
            });
        });
    }, [
        p.__demoMode,
        a,
        m,
        p.menuState,
        p.activationTrigger,
        p.activeItemIndex
    ]);
    let d = (0, $jN7sP.useTextValue)(a), f = (0, $acw62.useRef)({
        disabled: o,
        domRef: a,
        get textValue () {
            return d();
        }
    });
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        f.current.disabled = o;
    }, [
        f,
        o
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>(s({
            type: 5,
            id: l,
            dataRef: f
        }), ()=>s({
                type: 6,
                id: l
            })), [
        f,
        l
    ]);
    let c = (0, $114Mg.useEvent)(()=>{
        s({
            type: 1
        });
    }), A = (0, $114Mg.useEvent)((I)=>{
        if (o) return I.preventDefault();
        s({
            type: 1
        }), (0, $hsQxB.restoreFocusIfNecessary)(p.buttonElement);
    }), b = (0, $114Mg.useEvent)(()=>{
        if (o) return s({
            type: 2,
            focus: (0, $fLrGx.Focus).Nothing
        });
        s({
            type: 2,
            focus: (0, $fLrGx.Focus).Specific,
            id: l
        });
    }), S = (0, $ipity.useTrackedPointer)(), D = (0, $114Mg.useEvent)((I)=>{
        S.update(I), !o && (m || s({
            type: 2,
            focus: (0, $fLrGx.Focus).Specific,
            id: l,
            trigger: 0
        }));
    }), M = (0, $114Mg.useEvent)((I)=>{
        S.wasMoved(I) && (o || m || s({
            type: 2,
            focus: (0, $fLrGx.Focus).Specific,
            id: l,
            trigger: 0
        }));
    }), P = (0, $114Mg.useEvent)((I)=>{
        S.wasMoved(I) && (o || m && s({
            type: 2,
            focus: (0, $fLrGx.Focus).Nothing
        }));
    }), [v, C] = (0, $5qg9U.useLabels)(), [O, h] = (0, $iGb09.useDescriptions)(), T = (0, $acw62.useMemo)(()=>({
            active: m,
            focus: m,
            disabled: o,
            close: c
        }), [
        m,
        o,
        c
    ]), F = {
        id: l,
        ref: t,
        role: "menuitem",
        tabIndex: o === !0 ? void 0 : -1,
        "aria-disabled": o === !0 ? !0 : void 0,
        "aria-labelledby": v,
        "aria-describedby": O,
        disabled: void 0,
        onClick: A,
        onFocus: b,
        onPointerEnter: D,
        onMouseEnter: D,
        onPointerMove: M,
        onMouseMove: M,
        onPointerLeave: P,
        onMouseLeave: P
    }, K = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(C, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(h, null, K({
        ourProps: F,
        theirProps: u,
        slot: T,
        defaultTag: $c9bfa4e2da6232f7$var$st,
        name: "Menu.Item"
    })));
}
let $c9bfa4e2da6232f7$var$pt = "div";
function $c9bfa4e2da6232f7$var$mt(e, n) {
    let [r, l] = (0, $5qg9U.useLabels)(), o = e, u = {
        ref: n,
        "aria-labelledby": r,
        role: "group"
    }, p = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(l, null, p({
        ourProps: u,
        theirProps: o,
        slot: {},
        defaultTag: $c9bfa4e2da6232f7$var$pt,
        name: "Menu.Section"
    }));
}
let $c9bfa4e2da6232f7$var$dt = "header";
function $c9bfa4e2da6232f7$var$ct(e, n) {
    let r = (0, $acw62.useId)(), { id: l = `headlessui-menu-heading-${r}`, ...o } = e, u = (0, $5qg9U.useLabelContext)();
    (0, $8KgIp.useIsoMorphicEffect)(()=>u.register(l), [
        l,
        u.register
    ]);
    let p = {
        id: l,
        ref: n,
        role: "presentation",
        ...u.props
    };
    return (0, $ebRQH.useRender)()({
        ourProps: p,
        theirProps: o,
        slot: {},
        defaultTag: $c9bfa4e2da6232f7$var$dt,
        name: "Menu.Heading"
    });
}
let $c9bfa4e2da6232f7$var$ft = "div";
function $c9bfa4e2da6232f7$var$Tt(e, n) {
    let r = e, l = {
        ref: n,
        role: "separator"
    };
    return (0, $ebRQH.useRender)()({
        ourProps: l,
        theirProps: r,
        slot: {},
        defaultTag: $c9bfa4e2da6232f7$var$ft,
        name: "Menu.Separator"
    });
}
let $c9bfa4e2da6232f7$var$yt = (0, $ebRQH.forwardRefWithAs)($c9bfa4e2da6232f7$var$nt), $c9bfa4e2da6232f7$export$266a769812832828 = (0, $ebRQH.forwardRefWithAs)($c9bfa4e2da6232f7$var$ot), $c9bfa4e2da6232f7$export$15a41fea157b048a = (0, $ebRQH.forwardRefWithAs)($c9bfa4e2da6232f7$var$it), $c9bfa4e2da6232f7$export$2ce376c2cc3355c8 = (0, $ebRQH.forwardRefWithAs)($c9bfa4e2da6232f7$var$ut), $c9bfa4e2da6232f7$export$4b1545b4f2016d26 = (0, $ebRQH.forwardRefWithAs)($c9bfa4e2da6232f7$var$mt), $c9bfa4e2da6232f7$export$ef9631cf12896f8 = (0, $ebRQH.forwardRefWithAs)($c9bfa4e2da6232f7$var$ct), $c9bfa4e2da6232f7$export$1cec7dcdd713e220 = (0, $ebRQH.forwardRefWithAs)($c9bfa4e2da6232f7$var$Tt), $c9bfa4e2da6232f7$export$d9b273488cd8ce6f = Object.assign($c9bfa4e2da6232f7$var$yt, {
    Button: $c9bfa4e2da6232f7$export$266a769812832828,
    Items: $c9bfa4e2da6232f7$export$15a41fea157b048a,
    Item: $c9bfa4e2da6232f7$export$2ce376c2cc3355c8,
    Section: $c9bfa4e2da6232f7$export$4b1545b4f2016d26,
    Heading: $c9bfa4e2da6232f7$export$ef9631cf12896f8,
    Separator: $c9bfa4e2da6232f7$export$1cec7dcdd713e220
});

});
parcelRegister("kd7LS", function(module, exports) {

$parcel$export(module.exports, "useFocusRing", () => $eb6b0cc1c3f8613d$export$4e328f61c538687f);

var $fVRQv = parcelRequire("fVRQv");
var $jexLh = parcelRequire("jexLh");
var $3oYR0 = parcelRequire("3oYR0");

var $acw62 = parcelRequire("acw62");
function $eb6b0cc1c3f8613d$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (0, $acw62.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $fVRQv.isFocusVisible)()
    });
    let [isFocused, setFocused] = (0, $acw62.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, $acw62.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, $acw62.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $fVRQv.useFocusVisibleListener)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = (0, $jexLh.useFocus)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = (0, $3oYR0.useFocusWithin)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}

});
parcelRegister("fVRQv", function(module, exports) {

$parcel$export(module.exports, "isFocusVisible", () => $b995f28c9a72ee4c$export$b9b3dfddab17db27);
$parcel$export(module.exports, "useFocusVisibleListener", () => $b995f28c9a72ee4c$export$ec71b4b83ac08ec3);

var $kvYeA = parcelRequire("kvYeA");
var $fOgJj = parcelRequire("fOgJj");
var $dS2bP = parcelRequire("dS2bP");

var $acw62 = parcelRequire("acw62");

var $bVPQr = parcelRequire("bVPQr");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = null;
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $b995f28c9a72ee4c$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $fOgJj.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $dS2bP.isVirtualClick)(e)) {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $b995f28c9a72ee4c$export$d90243b58daecda7.get((0, $kvYeA.getOwnerWindow)(element))) return;
    const windowObject = (0, $kvYeA.getOwnerWindow)(element);
    const documentObject = (0, $kvYeA.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $b995f28c9a72ee4c$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $kvYeA.getOwnerWindow)(element);
    const documentObject = (0, $kvYeA.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$b995f28c9a72ee4c$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $b995f28c9a72ee4c$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $b995f28c9a72ee4c$export$d90243b58daecda7.delete(windowObject);
};
function $b995f28c9a72ee4c$export$2f1888112f558a7d(element) {
    const documentObject = (0, $kvYeA.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $b995f28c9a72ee4c$export$2f1888112f558a7d();
function $b995f28c9a72ee4c$export$b9b3dfddab17db27() {
    return $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $b995f28c9a72ee4c$export$630ff653c5ada6a9() {
    return $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality;
}
function $b995f28c9a72ee4c$export$8397ddfc504fdb9a(modality) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = modality;
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $b995f28c9a72ee4c$export$98e20ec92f614cfe() {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $acw62.useState)($b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality);
    (0, $acw62.useEffect)(()=>{
        let handler = ()=>{
            setModality($b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality);
        };
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $bVPQr.useIsSSR)() ? null : modality;
}
const $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $kvYeA.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $kvYeA.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $kvYeA.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $kvYeA.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $b995f28c9a72ee4c$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(autoFocus || $b995f28c9a72ee4c$export$b9b3dfddab17db27());
    $b995f28c9a72ee4c$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $b995f28c9a72ee4c$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $acw62.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($b995f28c9a72ee4c$export$b9b3dfddab17db27());
        };
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});
parcelRegister("kvYeA", function(module, exports) {

$parcel$export(module.exports, "getOwnerDocument", () => $eef56d26e56a84a0$export$b204af158042fbac);
$parcel$export(module.exports, "getOwnerWindow", () => $eef56d26e56a84a0$export$f21a1ffae260145a);
const $eef56d26e56a84a0$export$b204af158042fbac = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $eef56d26e56a84a0$export$f21a1ffae260145a = (el)=>{
    if (el && "window" in el && el.window === el) return el;
    const doc = $eef56d26e56a84a0$export$b204af158042fbac(el);
    return doc.defaultView || window;
};

});

parcelRegister("fOgJj", function(module, exports) {

$parcel$export(module.exports, "isMac", () => $b82880ba168cba95$export$9ac100e40613ea10);
$parcel$export(module.exports, "isAndroid", () => $b82880ba168cba95$export$a11b0059900ceec8);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === "undefined" || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $b82880ba168cba95$var$$c87311424ea30a05$var$cached(fn) {
    let res = null;
    return ()=>{
        if (res == null) res = fn();
        return res;
    };
}
const $b82880ba168cba95$export$9ac100e40613ea10 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
});
const $b82880ba168cba95$export$186c6964ca17d99 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
});
const $b82880ba168cba95$export$7bef049ce92e4224 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $b82880ba168cba95$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
const $b82880ba168cba95$export$fedb369cb70207f1 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$export$186c6964ca17d99() || $b82880ba168cba95$export$7bef049ce92e4224();
});
const $b82880ba168cba95$export$e1865c3bedcd822b = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$export$9ac100e40613ea10() || $b82880ba168cba95$export$fedb369cb70207f1();
});
const $b82880ba168cba95$export$78551043582a6a98 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$b82880ba168cba95$export$6446a186d09e379e();
});
const $b82880ba168cba95$export$6446a186d09e379e = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
});
const $b82880ba168cba95$export$a11b0059900ceec8 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
});
const $b82880ba168cba95$export$b7d78993b74f766d = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/Firefox/i);
});

});

parcelRegister("dS2bP", function(module, exports) {

$parcel$export(module.exports, "isVirtualClick", () => $a192045deeaea2b6$export$60278871457622de);

var $fOgJj = parcelRequire("fOgJj");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a192045deeaea2b6$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $fOgJj.isAndroid)() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $a192045deeaea2b6$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $fOgJj.isAndroid)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}

});

parcelRegister("bVPQr", function(module, exports) {

$parcel$export(module.exports, "useIsSSR", () => $8afd3bdc2bd65163$export$535bd6ca7f90a273);

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext);
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false);
// This is only used in React < 18.
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(cur === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $acw62.useState)(true);
    let value = (0, $acw62.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext ? "" : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") (0, $acw62.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $8afd3bdc2bd65163$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId"] === "function") {
        if (!$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $acw62.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext && !$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    let counter = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    let [didSSR] = (0, $acw62.useState)($8afd3bdc2bd65163$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? "react-aria" : `react-aria${$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $8afd3bdc2bd65163$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId"] === "function" ? $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useModernSSRSafeId : $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $8afd3bdc2bd65163$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useSyncExternalStore"] === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useSyncExternalStore"]($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$subscribe, $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getSnapshot, $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext);
}

});


parcelRegister("jexLh", function(module, exports) {

$parcel$export(module.exports, "useFocus", () => $e009837ee384a76a$export$f8168d8dd8fd66e6);

var $1s9dc = parcelRequire("1s9dc");

var $acw62 = parcelRequire("acw62");

var $kvYeA = parcelRequire("kvYeA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $e009837ee384a76a$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $acw62.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $1s9dc.useSyntheticBlurEvent)(onBlur);
    const onFocus = (0, $acw62.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $kvYeA.getOwnerDocument)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

});
parcelRegister("1s9dc", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", () => $10ef8d441d7454cf$export$715c682d09d639cc);

var $acw62 = parcelRequire("acw62");

var $369I5 = parcelRequire("369I5");
var $4AOPT = parcelRequire("4AOPT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $10ef8d441d7454cf$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $10ef8d441d7454cf$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $acw62.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $4AOPT.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $369I5.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $acw62.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $10ef8d441d7454cf$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});
parcelRegister("369I5", function(module, exports) {

$parcel$export(module.exports, "useEffectEvent", () => $241976d88b767e6b$export$7f54fc3180508a52);

var $4AOPT = parcelRequire("4AOPT");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $241976d88b767e6b$export$7f54fc3180508a52(fn) {
    const ref = (0, $acw62.useRef)(null);
    (0, $4AOPT.useLayoutEffect)(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $acw62.useCallback)((...args)=>{
        const f = ref.current;
        return f === null || f === void 0 ? void 0 : f(...args);
    }, []);
}

});
parcelRegister("4AOPT", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $3581f530a27f457c$export$e5c5a5f917a5871c);

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3581f530a27f457c$export$e5c5a5f917a5871c = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : ()=>{};

});




parcelRegister("3oYR0", function(module, exports) {

$parcel$export(module.exports, "useFocusWithin", () => $27a2d14f8c063b81$export$420e68273165f4ec);

var $1s9dc = parcelRequire("1s9dc");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $27a2d14f8c063b81$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $acw62.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $acw62.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = (0, $1s9dc.useSyntheticBlurEvent)(onBlur);
    let onFocus = (0, $acw62.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}

});


parcelRegister("6o6B3", function(module, exports) {

$parcel$export(module.exports, "useHover", () => $4a6a19e952a3e910$export$ae780daf29e6d456);

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $4a6a19e952a3e910$var$$6179b936705e76d3$var$hoverCount = 0;
function $4a6a19e952a3e910$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $4a6a19e952a3e910$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $4a6a19e952a3e910$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $4a6a19e952a3e910$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $4a6a19e952a3e910$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $4a6a19e952a3e910$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $4a6a19e952a3e910$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $4a6a19e952a3e910$var$$6179b936705e76d3$var$hoverCount--;
        if ($4a6a19e952a3e910$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $4a6a19e952a3e910$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $4a6a19e952a3e910$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $4a6a19e952a3e910$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $acw62.useState)(false);
    let state = (0, $acw62.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, $acw62.useEffect)($4a6a19e952a3e910$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $acw62.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if ($4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $acw62.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}

});

parcelRegister("cE9hP", function(module, exports) {

$parcel$export(module.exports, "useActivePress", () => $93506c8f84360949$export$73224eeef4bbe873);

var $acw62 = parcelRequire("acw62");

var $gxwGc = parcelRequire("gxwGc");

var $5Ai9V = parcelRequire("5Ai9V");

var $114Mg = parcelRequire("114Mg");
function $93506c8f84360949$var$E(e) {
    let t = e.width / 2, n = e.height / 2;
    return {
        top: e.clientY - n,
        right: e.clientX + t,
        bottom: e.clientY + n,
        left: e.clientX - t
    };
}
function $93506c8f84360949$var$P(e, t) {
    return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function $93506c8f84360949$export$73224eeef4bbe873({ disabled: e = !1 } = {}) {
    let t = (0, $acw62.useRef)(null), [n, l] = (0, $acw62.useState)(!1), r = (0, $5Ai9V.useDisposables)(), o = (0, $114Mg.useEvent)(()=>{
        t.current = null, l(!1), r.dispose();
    }), f = (0, $114Mg.useEvent)((s)=>{
        if (r.dispose(), t.current === null) {
            t.current = s.currentTarget, l(!0);
            {
                let i = (0, $gxwGc.getOwnerDocument)(s.currentTarget);
                r.addEventListener(i, "pointerup", o, !1), r.addEventListener(i, "pointermove", (c)=>{
                    if (t.current) {
                        let p = $93506c8f84360949$var$E(c);
                        l($93506c8f84360949$var$P(p, t.current.getBoundingClientRect()));
                    }
                }, !1), r.addEventListener(i, "pointercancel", o, !1);
            }
        }
    });
    return {
        pressed: n,
        pressProps: e ? {} : {
            onPointerDown: f,
            onPointerUp: o,
            onClick: o
        }
    };
}

});
parcelRegister("gxwGc", function(module, exports) {

$parcel$export(module.exports, "getOwnerDocument", () => $c0a913ecfa4bf5e5$export$b204af158042fbac);

var $Iy8e1 = parcelRequire("Iy8e1");
function $c0a913ecfa4bf5e5$export$b204af158042fbac(r) {
    return (0, $Iy8e1.env).isServer ? null : r instanceof Node ? r.ownerDocument : r != null && r.hasOwnProperty("current") && r.current instanceof Node ? r.current.ownerDocument : document;
}

});
parcelRegister("Iy8e1", function(module, exports) {

$parcel$export(module.exports, "env", () => $085e96034c813fbf$export$a7b6bc01c63cdfc3);
var $085e96034c813fbf$var$i = Object.defineProperty;
var $085e96034c813fbf$var$d = (t, e, n)=>e in t ? $085e96034c813fbf$var$i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n;
var $085e96034c813fbf$var$r = (t, e, n)=>($085e96034c813fbf$var$d(t, typeof e != "symbol" ? e + "" : e, n), n);
class $085e96034c813fbf$var$o {
    constructor(){
        $085e96034c813fbf$var$r(this, "current", this.detect());
        $085e96034c813fbf$var$r(this, "handoffState", "pending");
        $085e96034c813fbf$var$r(this, "currentId", 0);
    }
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
}
let $085e96034c813fbf$export$a7b6bc01c63cdfc3 = new $085e96034c813fbf$var$o;

});


parcelRegister("5Ai9V", function(module, exports) {

$parcel$export(module.exports, "useDisposables", () => $410e668b7f520622$export$fd183955ff4b45d9);

var $acw62 = parcelRequire("acw62");

var $1COYr = parcelRequire("1COYr");
function $410e668b7f520622$export$fd183955ff4b45d9() {
    let [e] = (0, $acw62.useState)((0, $1COYr.disposables));
    return (0, $acw62.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}

});
parcelRegister("1COYr", function(module, exports) {

$parcel$export(module.exports, "disposables", () => $12f0e1633d904536$export$12b26c28a05aa001);

var $eJKgu = parcelRequire("eJKgu");
function $12f0e1633d904536$export$12b26c28a05aa001() {
    let n = [], r = {
        addEventListener (e, t, s, a) {
            return e.addEventListener(t, s, a), r.add(()=>e.removeEventListener(t, s, a));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, $eJKgu.microTask)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, s) {
            let a = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: s
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: a
                });
            });
        },
        group (e) {
            let t = $12f0e1633d904536$export$12b26c28a05aa001();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return n.includes(e) || n.push(e), ()=>{
                let t = n.indexOf(e);
                if (t >= 0) for (let s of n.splice(t, 1))s();
            };
        },
        dispose () {
            for (let e of n.splice(0))e();
        }
    };
    return r;
}

});
parcelRegister("eJKgu", function(module, exports) {

$parcel$export(module.exports, "microTask", () => $aba927e9b3929756$export$a5ff0d6a738703ca);
function $aba927e9b3929756$export$a5ff0d6a738703ca(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}

});



parcelRegister("114Mg", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => $0bd9972698c32399$export$90fc3a17d93f704c);

var $acw62 = parcelRequire("acw62");

var $ltgxC = parcelRequire("ltgxC");
let $0bd9972698c32399$export$90fc3a17d93f704c = function(t) {
    let e = (0, $ltgxC.useLatestValue)(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((...r)=>e.current(...r), [
        e
    ]);
};

});
parcelRegister("ltgxC", function(module, exports) {

$parcel$export(module.exports, "useLatestValue", () => $fa1923261638cacc$export$86c4283a11f23f95);

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");
function $fa1923261638cacc$export$86c4283a11f23f95(e) {
    let r = (0, $acw62.useRef)(e);
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}

});
parcelRegister("8KgIp", function(module, exports) {

$parcel$export(module.exports, "useIsoMorphicEffect", () => $65df95ec9b1bb6a8$export$ce5ed857c741fd71);

var $acw62 = parcelRequire("acw62");

var $Iy8e1 = parcelRequire("Iy8e1");
let $65df95ec9b1bb6a8$export$ce5ed857c741fd71 = (e, t)=>{
    (0, $Iy8e1.env).isServer ? (0, $acw62.useEffect)(e, t) : (0, $acw62.useLayoutEffect)(e, t);
};

});




parcelRegister("hd1nN", function(module, exports) {

$parcel$export(module.exports, "useDidElementMove", () => $c874b9231cf882e4$export$d0b9dbca977c73d5);

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");
function $c874b9231cf882e4$export$d0b9dbca977c73d5(n, t) {
    let e = (0, $acw62.useRef)({
        left: 0,
        top: 0
    });
    if ((0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!t) return;
        let r = t.getBoundingClientRect();
        r && (e.current = r);
    }, [
        n,
        t
    ]), t == null || !n || t === document.activeElement) return !1;
    let o = t.getBoundingClientRect();
    return o.top !== e.current.top || o.left !== e.current.left;
}

});

parcelRegister("dfvrc", function(module, exports) {

$parcel$export(module.exports, "useElementSize", () => $9a550ff5f236cb70$export$2b86bedf890eab8);

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");
function $9a550ff5f236cb70$var$f(e) {
    if (e === null) return {
        width: 0,
        height: 0
    };
    let { width: t, height: r } = e.getBoundingClientRect();
    return {
        width: t,
        height: r
    };
}
function $9a550ff5f236cb70$export$2b86bedf890eab8(e, t = !1) {
    let [r, u] = (0, $acw62.useReducer)(()=>({}), {}), i = (0, $acw62.useMemo)(()=>$9a550ff5f236cb70$var$f(e), [
        e,
        r
    ]);
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!e) return;
        let n = new ResizeObserver(u);
        return n.observe(e), ()=>{
            n.disconnect();
        };
    }, [
        e
    ]), t ? {
        width: `${i.width}px`,
        height: `${i.height}px`
    } : i;
}

});

parcelRegister("keKjn", function(module, exports) {

$parcel$export(module.exports, "useInertOthers", () => $ebb909f7f690e57e$export$af489fa7e5283cc3);

var $1COYr = parcelRequire("1COYr");

var $gxwGc = parcelRequire("gxwGc");

var $g6SeH = parcelRequire("g6SeH");

var $8KgIp = parcelRequire("8KgIp");
let $ebb909f7f690e57e$var$f = new Map, $ebb909f7f690e57e$var$u = new Map;
function $ebb909f7f690e57e$var$h(t) {
    var e;
    let r = (e = $ebb909f7f690e57e$var$u.get(t)) != null ? e : 0;
    return $ebb909f7f690e57e$var$u.set(t, r + 1), r !== 0 ? ()=>$ebb909f7f690e57e$var$m(t) : ($ebb909f7f690e57e$var$f.set(t, {
        "aria-hidden": t.getAttribute("aria-hidden"),
        inert: t.inert
    }), t.setAttribute("aria-hidden", "true"), t.inert = !0, ()=>$ebb909f7f690e57e$var$m(t));
}
function $ebb909f7f690e57e$var$m(t) {
    var i;
    let r = (i = $ebb909f7f690e57e$var$u.get(t)) != null ? i : 1;
    if (r === 1 ? $ebb909f7f690e57e$var$u.delete(t) : $ebb909f7f690e57e$var$u.set(t, r - 1), r !== 1) return;
    let e = $ebb909f7f690e57e$var$f.get(t);
    e && (e["aria-hidden"] === null ? t.removeAttribute("aria-hidden") : t.setAttribute("aria-hidden", e["aria-hidden"]), t.inert = e.inert, $ebb909f7f690e57e$var$f.delete(t));
}
function $ebb909f7f690e57e$export$af489fa7e5283cc3(t, { allowed: r, disallowed: e } = {}) {
    let i = (0, $g6SeH.useIsTopLayer)(t, "inert-others");
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        var d, c;
        if (!i) return;
        let a = (0, $1COYr.disposables)();
        for (let n of (d = e == null ? void 0 : e()) != null ? d : [])n && a.add($ebb909f7f690e57e$var$h(n));
        let s = (c = r == null ? void 0 : r()) != null ? c : [];
        for (let n of s){
            if (!n) continue;
            let l = (0, $gxwGc.getOwnerDocument)(n);
            if (!l) continue;
            let o = n.parentElement;
            for(; o && o !== l.body;){
                for (let p of o.children)s.some((E)=>p.contains(E)) || a.add($ebb909f7f690e57e$var$h(p));
                o = o.parentElement;
            }
        }
        return a.dispose;
    }, [
        i,
        r,
        e
    ]);
}

});
parcelRegister("g6SeH", function(module, exports) {

$parcel$export(module.exports, "useIsTopLayer", () => $bba7470f70c82a20$export$5f5dd115998e0b80);

var $acw62 = parcelRequire("acw62");

var $8SQCc = parcelRequire("8SQCc");

var $7AV3X = parcelRequire("7AV3X");

var $8KgIp = parcelRequire("8KgIp");

var $gCqoX = parcelRequire("gCqoX");
let $bba7470f70c82a20$var$p = new (0, $8SQCc.DefaultMap)(()=>(0, $7AV3X.createStore)(()=>[], {
        ADD (r) {
            return this.includes(r) ? this : [
                ...this,
                r
            ];
        },
        REMOVE (r) {
            let e = this.indexOf(r);
            if (e === -1) return this;
            let t = this.slice();
            return t.splice(e, 1), t;
        }
    }));
function $bba7470f70c82a20$export$5f5dd115998e0b80(r, e) {
    let t = $bba7470f70c82a20$var$p.get(e), i = (0, $acw62.useId)(), h = (0, $gCqoX.useStore)(t);
    if ((0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (r) return t.dispatch("ADD", i), ()=>t.dispatch("REMOVE", i);
    }, [
        t,
        r
    ]), !r) return !1;
    let s = h.indexOf(i), o = h.length;
    return s === -1 && (s = o, o += 1), s === o - 1;
}

});
parcelRegister("8SQCc", function(module, exports) {

$parcel$export(module.exports, "DefaultMap", () => $677c2e1e5f56d429$export$674cd7dcb504ac5c);
class $677c2e1e5f56d429$export$674cd7dcb504ac5c extends Map {
    constructor(t){
        super();
        this.factory = t;
    }
    get(t) {
        let e = super.get(t);
        return e === void 0 && (e = this.factory(t), this.set(t, e)), e;
    }
}

});

parcelRegister("7AV3X", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $587828ac89f0168d$export$f51a9068ac82ea43);
function $587828ac89f0168d$export$f51a9068ac82ea43(o, r) {
    let t = o(), n = new Set;
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return n.add(e), ()=>n.delete(e);
        },
        dispatch (e, ...s) {
            let i = r[e].call(t, ...s);
            i && (t = i, n.forEach((c)=>c()));
        }
    };
}

});

parcelRegister("gCqoX", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $c194acc02d991b55$export$6ccbb43953eebf8);

var $acw62 = parcelRequire("acw62");
function $c194acc02d991b55$export$6ccbb43953eebf8(t) {
    return (0, $acw62.useSyncExternalStore)(t.subscribe, t.getSnapshot, t.getSnapshot);
}

});



parcelRegister("dcp2r", function(module, exports) {

$parcel$export(module.exports, "useOnDisappear", () => $99bfd16f3cd33a1b$export$b41b9097915aa006);

var $acw62 = parcelRequire("acw62");

var $1COYr = parcelRequire("1COYr");

var $ltgxC = parcelRequire("ltgxC");
function $99bfd16f3cd33a1b$export$b41b9097915aa006(s, n, l) {
    let i = (0, $ltgxC.useLatestValue)((t)=>{
        let e = t.getBoundingClientRect();
        e.x === 0 && e.y === 0 && e.width === 0 && e.height === 0 && l();
    });
    (0, $acw62.useEffect)(()=>{
        if (!s) return;
        let t = n === null ? null : n instanceof HTMLElement ? n : n.current;
        if (!t) return;
        let e = (0, $1COYr.disposables)();
        if (typeof ResizeObserver != "undefined") {
            let r = new ResizeObserver(()=>i.current(t));
            r.observe(t), e.add(()=>r.disconnect());
        }
        if (typeof IntersectionObserver != "undefined") {
            let r = new IntersectionObserver(()=>i.current(t));
            r.observe(t), e.add(()=>r.disconnect());
        }
        return ()=>e.dispose();
    }, [
        n,
        i,
        s
    ]);
}

});

parcelRegister("23pTr", function(module, exports) {

$parcel$export(module.exports, "useOutsideClick", () => $17eff26b89e4b024$export$71b2224f1ce5e08e);

var $acw62 = parcelRequire("acw62");

var $hsQxB = parcelRequire("hsQxB");

var $8UjaS = parcelRequire("8UjaS");

var $fA3F6 = parcelRequire("fA3F6");

var $g6SeH = parcelRequire("g6SeH");

var $ltgxC = parcelRequire("ltgxC");

var $5vI4D = parcelRequire("5vI4D");
const $17eff26b89e4b024$var$E = 30;
function $17eff26b89e4b024$export$71b2224f1ce5e08e(p, f, C) {
    let u = (0, $g6SeH.useIsTopLayer)(p, "outside-click"), m = (0, $ltgxC.useLatestValue)(C), s = (0, $acw62.useCallback)(function(e, n) {
        if (e.defaultPrevented) return;
        let r = n(e);
        if (r === null || !r.getRootNode().contains(r) || !r.isConnected) return;
        let h = function l(o) {
            return typeof o == "function" ? l(o()) : Array.isArray(o) || o instanceof Set ? o : [
                o
            ];
        }(f);
        for (let l of h)if (l !== null && (l.contains(r) || e.composed && e.composedPath().includes(l))) return;
        return !(0, $hsQxB.isFocusableElement)(r, (0, $hsQxB.FocusableMode).Loose) && r.tabIndex !== -1 && e.preventDefault(), m.current(e, r);
    }, [
        m,
        f
    ]), i = (0, $acw62.useRef)(null);
    (0, $fA3F6.useDocumentEvent)(u, "pointerdown", (t)=>{
        var e, n;
        i.current = ((n = (e = t.composedPath) == null ? void 0 : e.call(t)) == null ? void 0 : n[0]) || t.target;
    }, !0), (0, $fA3F6.useDocumentEvent)(u, "mousedown", (t)=>{
        var e, n;
        i.current = ((n = (e = t.composedPath) == null ? void 0 : e.call(t)) == null ? void 0 : n[0]) || t.target;
    }, !0), (0, $fA3F6.useDocumentEvent)(u, "click", (t)=>{
        (0, $8UjaS.isMobile)() || i.current && (s(t, ()=>i.current), i.current = null);
    }, !0);
    let a = (0, $acw62.useRef)({
        x: 0,
        y: 0
    });
    (0, $fA3F6.useDocumentEvent)(u, "touchstart", (t)=>{
        a.current.x = t.touches[0].clientX, a.current.y = t.touches[0].clientY;
    }, !0), (0, $fA3F6.useDocumentEvent)(u, "touchend", (t)=>{
        let e = {
            x: t.changedTouches[0].clientX,
            y: t.changedTouches[0].clientY
        };
        if (!(Math.abs(e.x - a.current.x) >= $17eff26b89e4b024$var$E || Math.abs(e.y - a.current.y) >= $17eff26b89e4b024$var$E)) return s(t, ()=>t.target instanceof HTMLElement ? t.target : null);
    }, !0), (0, $5vI4D.useWindowEvent)(u, "blur", (t)=>s(t, ()=>window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}

});
parcelRegister("hsQxB", function(module, exports) {

$parcel$export(module.exports, "focusableSelector", () => $cb6dceb64e6c0606$export$acea64b1933eb668);
$parcel$export(module.exports, "Focus", () => $cb6dceb64e6c0606$export$807a7eae502106e7);
$parcel$export(module.exports, "FocusResult", () => $cb6dceb64e6c0606$export$abf286375dfa6dbd);
$parcel$export(module.exports, "getFocusableElements", () => $cb6dceb64e6c0606$export$433aaa1f216cf32d);
$parcel$export(module.exports, "FocusableMode", () => $cb6dceb64e6c0606$export$27112a34f2f8402d);
$parcel$export(module.exports, "isFocusableElement", () => $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5);
$parcel$export(module.exports, "restoreFocusIfNecessary", () => $cb6dceb64e6c0606$export$46388676ec35ab85);
$parcel$export(module.exports, "focusElement", () => $cb6dceb64e6c0606$export$5fed9cc43865dc7e);
$parcel$export(module.exports, "sortByDomNode", () => $cb6dceb64e6c0606$export$20305e96f91bf103);
$parcel$export(module.exports, "focusFrom", () => $cb6dceb64e6c0606$export$7fb6c844b485e870);
$parcel$export(module.exports, "focusIn", () => $cb6dceb64e6c0606$export$82e1f4f412218a1d);

var $1COYr = parcelRequire("1COYr");

var $6Ngq1 = parcelRequire("6Ngq1");

var $gxwGc = parcelRequire("gxwGc");
let $cb6dceb64e6c0606$export$acea64b1933eb668 = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(","), $cb6dceb64e6c0606$var$p = [
    "[data-autofocus]"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $cb6dceb64e6c0606$export$807a7eae502106e7 = ((n)=>(n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n[n.AutoFocus = 64] = "AutoFocus", n))($cb6dceb64e6c0606$export$807a7eae502106e7 || {}), $cb6dceb64e6c0606$export$abf286375dfa6dbd = ((o)=>(o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))($cb6dceb64e6c0606$export$abf286375dfa6dbd || {}), $cb6dceb64e6c0606$var$y = ((t)=>(t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))($cb6dceb64e6c0606$var$y || {});
function $cb6dceb64e6c0606$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($cb6dceb64e6c0606$export$acea64b1933eb668)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
function $cb6dceb64e6c0606$export$89622d0e8d475962(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($cb6dceb64e6c0606$var$p)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $cb6dceb64e6c0606$export$27112a34f2f8402d = ((t)=>(t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))($cb6dceb64e6c0606$export$27112a34f2f8402d || {});
function $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5(e, r = 0) {
    var t;
    return e === ((t = (0, $gxwGc.getOwnerDocument)(e)) == null ? void 0 : t.body) ? !1 : (0, $6Ngq1.match)(r, {
        [0] () {
            return e.matches($cb6dceb64e6c0606$export$acea64b1933eb668);
        },
        [1] () {
            let u = e;
            for(; u !== null;){
                if (u.matches($cb6dceb64e6c0606$export$acea64b1933eb668)) return !0;
                u = u.parentElement;
            }
            return !1;
        }
    });
}
function $cb6dceb64e6c0606$export$46388676ec35ab85(e) {
    let r = (0, $gxwGc.getOwnerDocument)(e);
    (0, $1COYr.disposables)().nextFrame(()=>{
        r && !$cb6dceb64e6c0606$export$ff1ec1c740b3c8d5(r.activeElement, 0) && $cb6dceb64e6c0606$export$5fed9cc43865dc7e(e);
    });
}
var $cb6dceb64e6c0606$var$H = ((t)=>(t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))($cb6dceb64e6c0606$var$H || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e)=>{
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e)=>{
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function $cb6dceb64e6c0606$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $cb6dceb64e6c0606$var$w = [
    "textarea",
    "input"
].join(",");
function $cb6dceb64e6c0606$var$O(e) {
    var r, t;
    return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, $cb6dceb64e6c0606$var$w)) != null ? t : !1;
}
function $cb6dceb64e6c0606$export$20305e96f91bf103(e, r = (t)=>t) {
    return e.slice().sort((t, u)=>{
        let o = r(t), c = r(u);
        if (o === null || c === null) return 0;
        let l = o.compareDocumentPosition(c);
        return l & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : l & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $cb6dceb64e6c0606$export$7fb6c844b485e870(e, r) {
    return $cb6dceb64e6c0606$export$82e1f4f412218a1d($cb6dceb64e6c0606$export$433aaa1f216cf32d(), r, {
        relativeTo: e
    });
}
function $cb6dceb64e6c0606$export$82e1f4f412218a1d(e, r, { sorted: t = !0, relativeTo: u = null, skipElements: o = [] } = {}) {
    let c = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, l = Array.isArray(e) ? t ? $cb6dceb64e6c0606$export$20305e96f91bf103(e) : e : r & 64 ? $cb6dceb64e6c0606$export$89622d0e8d475962(e) : $cb6dceb64e6c0606$export$433aaa1f216cf32d(e);
    o.length > 0 && l.length > 1 && (l = l.filter((s)=>!o.some((a)=>a != null && "current" in a ? (a == null ? void 0 : a.current) === s : a === s))), u = u != null ? u : c.activeElement;
    let n = (()=>{
        if (r & 5) return 1;
        if (r & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), x = (()=>{
        if (r & 1) return 0;
        if (r & 2) return Math.max(0, l.indexOf(u)) - 1;
        if (r & 4) return Math.max(0, l.indexOf(u)) + 1;
        if (r & 8) return l.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), M = r & 32 ? {
        preventScroll: !0
    } : {}, m = 0, d = l.length, i;
    do {
        if (m >= d || m + d <= 0) return 0;
        let s = x + m;
        if (r & 16) s = (s + d) % d;
        else {
            if (s < 0) return 3;
            if (s >= d) return 1;
        }
        i = l[s], i == null || i.focus(M), m += n;
    }while (i !== c.activeElement);
    return r & 6 && $cb6dceb64e6c0606$var$O(i) && i.select(), 2;
}

});
parcelRegister("6Ngq1", function(module, exports) {

$parcel$export(module.exports, "match", () => $4f240e1aafd2c298$export$4659b591c19bdf3d);
function $4f240e1aafd2c298$export$4659b591c19bdf3d(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, $4f240e1aafd2c298$export$4659b591c19bdf3d), t;
}

});


parcelRegister("8UjaS", function(module, exports) {

$parcel$export(module.exports, "isIOS", () => $67c26d51fee0b51a$export$fedb369cb70207f1);
$parcel$export(module.exports, "isMobile", () => $67c26d51fee0b51a$export$d0a8044dce8ff2fc);
function $67c26d51fee0b51a$export$fedb369cb70207f1() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $67c26d51fee0b51a$export$a11b0059900ceec8() {
    return /Android/gi.test(window.navigator.userAgent);
}
function $67c26d51fee0b51a$export$d0a8044dce8ff2fc() {
    return $67c26d51fee0b51a$export$fedb369cb70207f1() || $67c26d51fee0b51a$export$a11b0059900ceec8();
}

});

parcelRegister("fA3F6", function(module, exports) {

$parcel$export(module.exports, "useDocumentEvent", () => $b57d0f015e93db3a$export$55d2b5df396a097b);

var $acw62 = parcelRequire("acw62");

var $ltgxC = parcelRequire("ltgxC");
function $b57d0f015e93db3a$export$55d2b5df396a097b(t, e, o, n) {
    let u = (0, $ltgxC.useLatestValue)(o);
    (0, $acw62.useEffect)(()=>{
        if (!t) return;
        function r(m) {
            u.current(m);
        }
        return document.addEventListener(e, r, n), ()=>document.removeEventListener(e, r, n);
    }, [
        t,
        e,
        n
    ]);
}

});

parcelRegister("5vI4D", function(module, exports) {

$parcel$export(module.exports, "useWindowEvent", () => $40320926a37dc1cc$export$ee579bb285b8d4aa);

var $acw62 = parcelRequire("acw62");

var $ltgxC = parcelRequire("ltgxC");
function $40320926a37dc1cc$export$ee579bb285b8d4aa(t, e, o, n) {
    let i = (0, $ltgxC.useLatestValue)(o);
    (0, $acw62.useEffect)(()=>{
        if (!t) return;
        function r(d) {
            i.current(d);
        }
        return window.addEventListener(e, r, n), ()=>window.removeEventListener(e, r, n);
    }, [
        t,
        e,
        n
    ]);
}

});


parcelRegister("5IEAk", function(module, exports) {

$parcel$export(module.exports, "useOwnerDocument", () => $42a08b28a285ca8e$export$dd9fbcea3de0ae36);

var $acw62 = parcelRequire("acw62");

var $gxwGc = parcelRequire("gxwGc");
function $42a08b28a285ca8e$export$dd9fbcea3de0ae36(...e) {
    return (0, $acw62.useMemo)(()=>(0, $gxwGc.getOwnerDocument)(...e), [
        ...e
    ]);
}

});

parcelRegister("gm4XX", function(module, exports) {

$parcel$export(module.exports, "useResolveButtonType", () => $be828d8bf9bb25ca$export$53652b2b272efe9c);

var $acw62 = parcelRequire("acw62");
function $be828d8bf9bb25ca$export$53652b2b272efe9c(t, u) {
    return (0, $acw62.useMemo)(()=>{
        var n;
        if (t.type) return t.type;
        let r = (n = t.as) != null ? n : "button";
        if (typeof r == "string" && r.toLowerCase() === "button" || (u == null ? void 0 : u.tagName) === "BUTTON" && !u.hasAttribute("type")) return "button";
    }, [
        t.type,
        t.as,
        u
    ]);
}

});

parcelRegister("hZodg", function(module, exports) {

$parcel$export(module.exports, "useScrollLock", () => $d18aea5eab300f7b$export$e47ba1b900da5d3b);

var $cfajG = parcelRequire("cfajG");

var $g6SeH = parcelRequire("g6SeH");
function $d18aea5eab300f7b$export$e47ba1b900da5d3b(e, c, n = ()=>[
        document.body
    ]) {
    let r = (0, $g6SeH.useIsTopLayer)(e, "scroll-lock");
    (0, $cfajG.useDocumentOverflowLockedEffect)(r, c, (t)=>{
        var o;
        return {
            containers: [
                ...(o = t.containers) != null ? o : [],
                n
            ]
        };
    });
}

});
parcelRegister("cfajG", function(module, exports) {

$parcel$export(module.exports, "useDocumentOverflowLockedEffect", () => $8e9ee35f9b752cd8$export$bb0ae4a42bcd9e0);

var $gCqoX = parcelRequire("gCqoX");

var $8KgIp = parcelRequire("8KgIp");

var $270j5 = parcelRequire("270j5");
function $8e9ee35f9b752cd8$export$bb0ae4a42bcd9e0(r, e, n = ()=>({
        containers: []
    })) {
    let f = (0, $gCqoX.useStore)((0, $270j5.overflows)), o = e ? f.get(e) : void 0, i = o ? o.count > 0 : !1;
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!(!e || !r)) return (0, $270j5.overflows).dispatch("PUSH", e, n), ()=>(0, $270j5.overflows).dispatch("POP", e, n);
    }, [
        r,
        e
    ]), i;
}

});
parcelRegister("270j5", function(module, exports) {

$parcel$export(module.exports, "overflows", () => $189c7921f80dd74a$export$a4161f418919b5aa);

var $1COYr = parcelRequire("1COYr");

var $7AV3X = parcelRequire("7AV3X");

var $g695P = parcelRequire("g695P");

var $g4l2L = parcelRequire("g4l2L");

var $imLcn = parcelRequire("imLcn");
function $189c7921f80dd74a$var$m(e) {
    let n = {};
    for (let t of e)Object.assign(n, t(n));
    return n;
}
let $189c7921f80dd74a$export$a4161f418919b5aa = (0, $7AV3X.createStore)(()=>new Map, {
    PUSH (e, n) {
        var o;
        let t = (o = this.get(e)) != null ? o : {
            doc: e,
            count: 0,
            d: (0, $1COYr.disposables)(),
            meta: new Set
        };
        return t.count++, t.meta.add(n), this.set(e, t), this;
    },
    POP (e, n) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(n)), this;
    },
    SCROLL_PREVENT ({ doc: e, d: n, meta: t }) {
        let o = {
            doc: e,
            d: n,
            meta: $189c7921f80dd74a$var$m(t)
        }, c = [
            (0, $g4l2L.handleIOSLocking)(),
            (0, $g695P.adjustScrollbarPadding)(),
            (0, $imLcn.preventScroll)()
        ];
        c.forEach(({ before: r })=>r == null ? void 0 : r(o)), c.forEach(({ after: r })=>r == null ? void 0 : r(o));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
$189c7921f80dd74a$export$a4161f418919b5aa.subscribe(()=>{
    let e = $189c7921f80dd74a$export$a4161f418919b5aa.getSnapshot(), n = new Map;
    for (let [t] of e)n.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let o = n.get(t.doc) === "hidden", c = t.count !== 0;
        (c && !o || !c && o) && $189c7921f80dd74a$export$a4161f418919b5aa.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && $189c7921f80dd74a$export$a4161f418919b5aa.dispatch("TEARDOWN", t);
    }
});

});
parcelRegister("g695P", function(module, exports) {

$parcel$export(module.exports, "adjustScrollbarPadding", () => $bb844292a519e22f$export$110627fb35ef9205);
function $bb844292a519e22f$export$110627fb35ef9205() {
    let r;
    return {
        before ({ doc: e }) {
            var l;
            let o = e.documentElement, t = (l = e.defaultView) != null ? l : window;
            r = Math.max(0, t.innerWidth - o.clientWidth);
        },
        after ({ doc: e, d: o }) {
            let t = e.documentElement, l = Math.max(0, t.clientWidth - t.offsetWidth), n = Math.max(0, r - l);
            o.style(t, "paddingRight", `${n}px`);
        }
    };
}

});

parcelRegister("g4l2L", function(module, exports) {

$parcel$export(module.exports, "handleIOSLocking", () => $bb2d57db10996691$export$e3a523dfabf27286);

var $1COYr = parcelRequire("1COYr");

var $8UjaS = parcelRequire("8UjaS");
function $bb2d57db10996691$export$e3a523dfabf27286() {
    return (0, $8UjaS.isIOS)() ? {
        before ({ doc: r, d: n, meta: c }) {
            function o(a) {
                return c.containers.flatMap((l)=>l()).some((l)=>l.contains(a));
            }
            n.microTask(()=>{
                var s;
                if (window.getComputedStyle(r.documentElement).scrollBehavior !== "auto") {
                    let t = (0, $1COYr.disposables)();
                    t.style(r.documentElement, "scrollBehavior", "auto"), n.add(()=>n.microTask(()=>t.dispose()));
                }
                let a = (s = window.scrollY) != null ? s : window.pageYOffset, l = null;
                n.addEventListener(r, "click", (t)=>{
                    if (t.target instanceof HTMLElement) try {
                        let e = t.target.closest("a");
                        if (!e) return;
                        let { hash: f } = new URL(e.href), i = r.querySelector(f);
                        i && !o(i) && (l = i);
                    } catch  {}
                }, !0), n.addEventListener(r, "touchstart", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (o(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && o(e.parentElement);)e = e.parentElement;
                            n.style(e, "overscrollBehavior", "contain");
                        } else n.style(t.target, "touchAction", "none");
                    }
                }), n.addEventListener(r, "touchmove", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (t.target.tagName === "INPUT") return;
                        if (o(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && e.dataset.headlessuiPortal !== "" && !(e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);)e = e.parentElement;
                            e.dataset.headlessuiPortal === "" && t.preventDefault();
                        } else t.preventDefault();
                    }
                }, {
                    passive: !1
                }), n.add(()=>{
                    var e;
                    let t = (e = window.scrollY) != null ? e : window.pageYOffset;
                    a !== t && window.scrollTo(0, a), l && l.isConnected && (l.scrollIntoView({
                        block: "nearest"
                    }), l = null);
                });
            });
        }
    } : {};
}

});

parcelRegister("imLcn", function(module, exports) {

$parcel$export(module.exports, "preventScroll", () => $d5eee4b72f55118b$export$d8b6ff28805e84e9);
function $d5eee4b72f55118b$export$d8b6ff28805e84e9() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}

});




parcelRegister("6mpbl", function(module, exports) {

$parcel$export(module.exports, "optionalRef", () => $4a1854c6a3ad5196$export$7029785b750eb74);
$parcel$export(module.exports, "useSyncRefs", () => $4a1854c6a3ad5196$export$f6a25a78204acc7e);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");
let $4a1854c6a3ad5196$var$u = Symbol();
function $4a1854c6a3ad5196$export$7029785b750eb74(t, n = !0) {
    return Object.assign(t, {
        [$4a1854c6a3ad5196$var$u]: n
    });
}
function $4a1854c6a3ad5196$export$f6a25a78204acc7e(...t) {
    let n = (0, $acw62.useRef)(t);
    (0, $acw62.useEffect)(()=>{
        n.current = t;
    }, [
        t
    ]);
    let c = (0, $114Mg.useEvent)((e)=>{
        for (let o of n.current)o != null && (typeof o == "function" ? o(e) : o.current = e);
    });
    return t.every((e)=>e == null || (e == null ? void 0 : e[$4a1854c6a3ad5196$var$u])) ? void 0 : c;
}

});

parcelRegister("jN7sP", function(module, exports) {

$parcel$export(module.exports, "useTextValue", () => $e688621b6eb177ca$export$f6862afd851a1cf4);

var $acw62 = parcelRequire("acw62");

var $dAaur = parcelRequire("dAaur");

var $114Mg = parcelRequire("114Mg");
function $e688621b6eb177ca$export$f6862afd851a1cf4(c) {
    let t = (0, $acw62.useRef)(""), r = (0, $acw62.useRef)("");
    return (0, $114Mg.useEvent)(()=>{
        let e = c.current;
        if (!e) return "";
        let u = e.innerText;
        if (t.current === u) return r.current;
        let n = (0, $dAaur.getTextValue)(e).trim().toLowerCase();
        return t.current = u, r.current = n, n;
    });
}

});
parcelRegister("dAaur", function(module, exports) {

$parcel$export(module.exports, "getTextValue", () => $9e36c641751eb2c7$export$6ca03cb7b75bfa13);
let $9e36c641751eb2c7$var$a = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function $9e36c641751eb2c7$var$o(e) {
    var r, i;
    let n = (r = e.innerText) != null ? r : "", t = e.cloneNode(!0);
    if (!(t instanceof HTMLElement)) return n;
    let u = !1;
    for (let f of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))f.remove(), u = !0;
    let l = u ? (i = t.innerText) != null ? i : "" : n;
    return $9e36c641751eb2c7$var$a.test(l) && (l = l.replace($9e36c641751eb2c7$var$a, "")), l;
}
function $9e36c641751eb2c7$export$6ca03cb7b75bfa13(e) {
    let n = e.getAttribute("aria-label");
    if (typeof n == "string") return n.trim();
    let t = e.getAttribute("aria-labelledby");
    if (t) {
        let u = t.split(" ").map((l)=>{
            let r = document.getElementById(l);
            if (r) {
                let i = r.getAttribute("aria-label");
                return typeof i == "string" ? i.trim() : $9e36c641751eb2c7$var$o(r).trim();
            }
            return null;
        }).filter(Boolean);
        if (u.length > 0) return u.join(", ");
    }
    return $9e36c641751eb2c7$var$o(e).trim();
}

});


parcelRegister("ipity", function(module, exports) {

$parcel$export(module.exports, "useTrackedPointer", () => $d668e4b1d0c2f85c$export$24ebee078bde85c3);

var $acw62 = parcelRequire("acw62");
function $d668e4b1d0c2f85c$var$t(e) {
    return [
        e.screenX,
        e.screenY
    ];
}
function $d668e4b1d0c2f85c$export$24ebee078bde85c3() {
    let e = (0, $acw62.useRef)([
        -1,
        -1
    ]);
    return {
        wasMoved (r) {
            let n = $d668e4b1d0c2f85c$var$t(r);
            return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
        },
        update (r) {
            e.current = $d668e4b1d0c2f85c$var$t(r);
        }
    };
}

});

parcelRegister("bdknl", function(module, exports) {

$parcel$export(module.exports, "transitionDataAttributes", () => $82a0b6c20b323075$export$c291d481c40a2fc3);
$parcel$export(module.exports, "useTransition", () => $82a0b6c20b323075$export$7b286972b8d8ccbf);

var $acw62 = parcelRequire("acw62");

var $1COYr = parcelRequire("1COYr");

var $5Ai9V = parcelRequire("5Ai9V");

var $b1fZr = parcelRequire("b1fZr");

var $8KgIp = parcelRequire("8KgIp");

var $hPtJY = parcelRequire("hPtJY");
var $82a0b6c20b323075$var$T, $82a0b6c20b323075$var$b;
typeof $hPtJY != "undefined" && typeof globalThis != "undefined" && typeof Element != "undefined" && (($82a0b6c20b323075$var$T = $hPtJY == null ? void 0 : $hPtJY.env) == null ? void 0 : $82a0b6c20b323075$var$T["NODE_ENV"]) === "test" && typeof (($82a0b6c20b323075$var$b = Element == null ? void 0 : Element.prototype) == null ? void 0 : $82a0b6c20b323075$var$b.getAnimations) == "undefined" && (Element.prototype.getAnimations = function() {
    return console.warn([
        "Headless UI has polyfilled `Element.prototype.getAnimations` for your tests.",
        "Please install a proper polyfill e.g. `jsdom-testing-mocks`, to silence these warnings.",
        "",
        "Example usage:",
        "```js",
        "import { mockAnimationsApi } from 'jsdom-testing-mocks'",
        "mockAnimationsApi()",
        "```"
    ].join(`
`)), [];
});
var $82a0b6c20b323075$var$L = ((r)=>(r[r.None = 0] = "None", r[r.Closed = 1] = "Closed", r[r.Enter = 2] = "Enter", r[r.Leave = 4] = "Leave", r))($82a0b6c20b323075$var$L || {});
function $82a0b6c20b323075$export$c291d481c40a2fc3(t) {
    let n = {};
    for(let e in t)t[e] === !0 && (n[`data-${e}`] = "");
    return n;
}
function $82a0b6c20b323075$export$7b286972b8d8ccbf(t, n, e, i) {
    let [r, o] = (0, $acw62.useState)(e), { hasFlag: s, addFlag: a, removeFlag: l } = (0, $b1fZr.useFlags)(t && r ? 3 : 0), u = (0, $acw62.useRef)(!1), f = (0, $acw62.useRef)(!1), E = (0, $5Ai9V.useDisposables)();
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        var d;
        if (t) {
            if (e && o(!0), !n) {
                e && a(3);
                return;
            }
            return (d = i == null ? void 0 : i.start) == null || d.call(i, e), $82a0b6c20b323075$var$C(n, {
                inFlight: u,
                prepare () {
                    f.current ? f.current = !1 : f.current = u.current, u.current = !0, !f.current && (e ? (a(3), l(4)) : (a(4), l(2)));
                },
                run () {
                    f.current ? e ? (l(3), a(4)) : (l(4), a(3)) : e ? l(1) : a(1);
                },
                done () {
                    var p;
                    f.current && typeof n.getAnimations == "function" && n.getAnimations().length > 0 || (u.current = !1, l(7), e || o(!1), (p = i == null ? void 0 : i.end) == null || p.call(i, e));
                }
            });
        }
    }, [
        t,
        e,
        n,
        E
    ]), t ? [
        r,
        {
            closed: s(1),
            enter: s(2),
            leave: s(4),
            transition: s(2) || s(4)
        }
    ] : [
        e,
        {
            closed: void 0,
            enter: void 0,
            leave: void 0,
            transition: void 0
        }
    ];
}
function $82a0b6c20b323075$var$C(t, { prepare: n, run: e, done: i, inFlight: r }) {
    let o = (0, $1COYr.disposables)();
    return $82a0b6c20b323075$var$j(t, {
        prepare: n,
        inFlight: r
    }), o.nextFrame(()=>{
        e(), o.requestAnimationFrame(()=>{
            o.add($82a0b6c20b323075$var$M(t, i));
        });
    }), o.dispose;
}
function $82a0b6c20b323075$var$M(t, n) {
    var o, s;
    let e = (0, $1COYr.disposables)();
    if (!t) return e.dispose;
    let i = !1;
    e.add(()=>{
        i = !0;
    });
    let r = (s = (o = t.getAnimations) == null ? void 0 : o.call(t).filter((a)=>a instanceof CSSTransition)) != null ? s : [];
    return r.length === 0 ? (n(), e.dispose) : (Promise.allSettled(r.map((a)=>a.finished)).then(()=>{
        i || n();
    }), e.dispose);
}
function $82a0b6c20b323075$var$j(t, { inFlight: n, prepare: e }) {
    if (n != null && n.current) {
        e();
        return;
    }
    let i = t.style.transition;
    t.style.transition = "none", e(), t.offsetHeight, t.style.transition = i;
}

});
parcelRegister("b1fZr", function(module, exports) {

$parcel$export(module.exports, "useFlags", () => $805c30fc151c4831$export$2879604e6aec4ab);

var $acw62 = parcelRequire("acw62");
function $805c30fc151c4831$export$2879604e6aec4ab(u = 0) {
    let [t, l] = (0, $acw62.useState)(u), g = (0, $acw62.useCallback)((e)=>l(e), [
        t
    ]), s = (0, $acw62.useCallback)((e)=>l((a)=>a | e), [
        t
    ]), m = (0, $acw62.useCallback)((e)=>(t & e) === e, [
        t
    ]), n = (0, $acw62.useCallback)((e)=>l((a)=>a & ~e), [
        l
    ]), F = (0, $acw62.useCallback)((e)=>l((a)=>a ^ e), [
        l
    ]);
    return {
        flags: t,
        setFlag: g,
        addFlag: s,
        hasFlag: m,
        removeFlag: n,
        toggleFlag: F
    };
}

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("1nOiu", function(module, exports) {

$parcel$export(module.exports, "useTreeWalker", () => $101ef4628501ab0d$export$b0abce39eb34b36);

var $acw62 = parcelRequire("acw62");

var $gxwGc = parcelRequire("gxwGc");

var $8KgIp = parcelRequire("8KgIp");
function $101ef4628501ab0d$export$b0abce39eb34b36(c, { container: e, accept: t, walk: r }) {
    let o = (0, $acw62.useRef)(t), l = (0, $acw62.useRef)(r);
    (0, $acw62.useEffect)(()=>{
        o.current = t, l.current = r;
    }, [
        t,
        r
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!e || !c) return;
        let n = (0, $gxwGc.getOwnerDocument)(e);
        if (!n) return;
        let f = o.current, p = l.current, i = Object.assign((m)=>f(m), {
            acceptNode: f
        }), u = n.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, i, !1);
        for(; u.nextNode();)p(u.currentNode);
    }, [
        e,
        c,
        o,
        l
    ]);
}

});

parcelRegister("34Str", function(module, exports) {

$parcel$export(module.exports, "useResolvedAnchor", () => $23dc003753f08df2$export$ee5342e485f0bdb0);
$parcel$export(module.exports, "useFloatingReference", () => $23dc003753f08df2$export$916a28f343467e85);
$parcel$export(module.exports, "useFloatingReferenceProps", () => $23dc003753f08df2$export$c7931d5027a8ead4);
$parcel$export(module.exports, "useFloatingPanelProps", () => $23dc003753f08df2$export$106e71f938eae412);
$parcel$export(module.exports, "useFloatingPanel", () => $23dc003753f08df2$export$aff4be9ef2a28e43);
$parcel$export(module.exports, "FloatingProvider", () => $23dc003753f08df2$export$e473aa84737d3250);

var $618j3 = parcelRequire("618j3");
var $33OG6 = parcelRequire("33OG6");
var $5rxG7 = parcelRequire("5rxG7");
var $33OG6 = parcelRequire("33OG6");

var $acw62 = parcelRequire("acw62");

var $5Ai9V = parcelRequire("5Ai9V");

var $114Mg = parcelRequire("114Mg");

var $8KgIp = parcelRequire("8KgIp");
let $23dc003753f08df2$var$y = (0, $acw62.createContext)({
    styles: void 0,
    setReference: ()=>{},
    setFloating: ()=>{},
    getReferenceProps: ()=>({}),
    getFloatingProps: ()=>({}),
    slot: {}
});
$23dc003753f08df2$var$y.displayName = "FloatingContext";
let $23dc003753f08df2$var$H = (0, $acw62.createContext)(null);
$23dc003753f08df2$var$H.displayName = "PlacementContext";
function $23dc003753f08df2$export$ee5342e485f0bdb0(e) {
    return (0, $acw62.useMemo)(()=>e ? typeof e == "string" ? {
            to: e
        } : e : null, [
        e
    ]);
}
function $23dc003753f08df2$export$916a28f343467e85() {
    return (0, $acw62.useContext)($23dc003753f08df2$var$y).setReference;
}
function $23dc003753f08df2$export$c7931d5027a8ead4() {
    return (0, $acw62.useContext)($23dc003753f08df2$var$y).getReferenceProps;
}
function $23dc003753f08df2$export$106e71f938eae412() {
    let { getFloatingProps: e, slot: t } = (0, $acw62.useContext)($23dc003753f08df2$var$y);
    return (0, $acw62.useCallback)((...n)=>Object.assign({}, e(...n), {
            "data-anchor": t.anchor
        }), [
        e,
        t
    ]);
}
function $23dc003753f08df2$export$aff4be9ef2a28e43(e = null) {
    e === !1 && (e = null), typeof e == "string" && (e = {
        to: e
    });
    let t = (0, $acw62.useContext)($23dc003753f08df2$var$H), n = (0, $acw62.useMemo)(()=>e, [
        JSON.stringify(e, (r, o)=>{
            var u;
            return (u = o == null ? void 0 : o.outerHTML) != null ? u : o;
        })
    ]);
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        t == null || t(n != null ? n : null);
    }, [
        t,
        n
    ]);
    let l = (0, $acw62.useContext)($23dc003753f08df2$var$y);
    return (0, $acw62.useMemo)(()=>[
            l.setFloating,
            e ? l.styles : {}
        ], [
        l.setFloating,
        e,
        l.styles
    ]);
}
let $23dc003753f08df2$var$q = 4;
function $23dc003753f08df2$export$e473aa84737d3250({ children: e, enabled: t = !0 }) {
    let [n, l] = (0, $acw62.useState)(null), [r, o] = (0, $acw62.useState)(0), u = (0, $acw62.useRef)(null), [f, s] = (0, $acw62.useState)(null);
    $23dc003753f08df2$var$pe(f);
    let i = t && n !== null && f !== null, { to: F = "bottom", gap: E = 0, offset: v = 0, padding: c = 0, inner: P } = $23dc003753f08df2$var$ce(n, f), [a, p = "center"] = F.split(" ");
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        i && o(0);
    }, [
        i
    ]);
    let { refs: b, floatingStyles: w, context: g } = (0, $5rxG7.useFloating)({
        open: i,
        placement: a === "selection" ? p === "center" ? "bottom" : `bottom-${p}` : p === "center" ? `${a}` : `${a}-${p}`,
        strategy: "absolute",
        transform: !1,
        middleware: [
            (0, $33OG6.offset)({
                mainAxis: a === "selection" ? 0 : E,
                crossAxis: v
            }),
            (0, $33OG6.shift)({
                padding: c
            }),
            a !== "selection" && (0, $33OG6.flip)({
                padding: c
            }),
            a === "selection" && P ? (0, $5rxG7.inner)({
                ...P,
                padding: c,
                overflowRef: u,
                offset: r,
                minItemsVisible: $23dc003753f08df2$var$q,
                referenceOverflowThreshold: c,
                onFallbackChange (h) {
                    var O, W;
                    if (!h) return;
                    let d = g.elements.floating;
                    if (!d) return;
                    let T = parseFloat(getComputedStyle(d).scrollPaddingBottom) || 0, $ = Math.min($23dc003753f08df2$var$q, d.childElementCount), L = 0, N = 0;
                    for (let m of (W = (O = g.elements.floating) == null ? void 0 : O.childNodes) != null ? W : [])if (m instanceof HTMLElement) {
                        let x = m.offsetTop, k = x + m.clientHeight + T, S = d.scrollTop, U = S + d.clientHeight;
                        if (x >= S && k <= U) $--;
                        else {
                            N = Math.max(0, Math.min(k, U) - Math.max(x, S)), L = m.clientHeight;
                            break;
                        }
                    }
                    $ >= 1 && o((m)=>{
                        let x = L * $ - N + T;
                        return m >= x ? m : x;
                    });
                }
            }) : null,
            (0, $33OG6.size)({
                padding: c,
                apply ({ availableWidth: h, availableHeight: d, elements: T }) {
                    Object.assign(T.floating.style, {
                        overflow: "auto",
                        maxWidth: `${h}px`,
                        maxHeight: `min(var(--anchor-max-height, 100vh), ${d}px)`
                    });
                }
            })
        ].filter(Boolean),
        whileElementsMounted: (0, $618j3.autoUpdate)
    }), [I = a, B = p] = g.placement.split("-");
    a === "selection" && (I = "selection");
    let G = (0, $acw62.useMemo)(()=>({
            anchor: [
                I,
                B
            ].filter(Boolean).join(" ")
        }), [
        I,
        B
    ]), K = (0, $5rxG7.useInnerOffset)(g, {
        overflowRef: u,
        onChange: o
    }), { getReferenceProps: Q, getFloatingProps: X } = (0, $5rxG7.useInteractions)([
        K
    ]), Y = (0, $114Mg.useEvent)((h)=>{
        s(h), b.setFloating(h);
    });
    return $acw62.createElement($23dc003753f08df2$var$H.Provider, {
        value: l
    }, $acw62.createElement($23dc003753f08df2$var$y.Provider, {
        value: {
            setFloating: Y,
            setReference: b.setReference,
            styles: w,
            getReferenceProps: Q,
            getFloatingProps: X,
            slot: G
        }
    }, e));
}
function $23dc003753f08df2$var$pe(e) {
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!e) return;
        let t = new MutationObserver(()=>{
            let n = window.getComputedStyle(e).maxHeight, l = parseFloat(n);
            if (isNaN(l)) return;
            let r = parseInt(n);
            isNaN(r) || l !== r && (e.style.maxHeight = `${Math.ceil(l)}px`);
        });
        return t.observe(e, {
            attributes: !0,
            attributeFilter: [
                "style"
            ]
        }), ()=>{
            t.disconnect();
        };
    }, [
        e
    ]);
}
function $23dc003753f08df2$var$ce(e, t) {
    var o, u, f;
    let n = $23dc003753f08df2$var$V((o = e == null ? void 0 : e.gap) != null ? o : "var(--anchor-gap, 0)", t), l = $23dc003753f08df2$var$V((u = e == null ? void 0 : e.offset) != null ? u : "var(--anchor-offset, 0)", t), r = $23dc003753f08df2$var$V((f = e == null ? void 0 : e.padding) != null ? f : "var(--anchor-padding, 0)", t);
    return {
        ...e,
        gap: n,
        offset: l,
        padding: r
    };
}
function $23dc003753f08df2$var$V(e, t, n) {
    let l = (0, $5Ai9V.useDisposables)(), r = (0, $114Mg.useEvent)((s, i)=>{
        if (s == null) return [
            n,
            null
        ];
        if (typeof s == "number") return [
            s,
            null
        ];
        if (typeof s == "string") {
            if (!i) return [
                n,
                null
            ];
            let F = $23dc003753f08df2$var$J(s, i);
            return [
                F,
                (E)=>{
                    let v = $23dc003753f08df2$var$D(s);
                    {
                        let c = v.map((P)=>window.getComputedStyle(i).getPropertyValue(P));
                        l.requestAnimationFrame(function P() {
                            l.nextFrame(P);
                            let a = !1;
                            for (let [b, w] of v.entries()){
                                let g = window.getComputedStyle(i).getPropertyValue(w);
                                if (c[b] !== g) {
                                    c[b] = g, a = !0;
                                    break;
                                }
                            }
                            if (!a) return;
                            let p = $23dc003753f08df2$var$J(s, i);
                            F !== p && (E(p), F = p);
                        });
                    }
                    return l.dispose;
                }
            ];
        }
        return [
            n,
            null
        ];
    }), o = (0, $acw62.useMemo)(()=>r(e, t)[0], [
        e,
        t
    ]), [u = o, f] = (0, $acw62.useState)();
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        let [s, i] = r(e, t);
        if (f(s), !!i) return i(f);
    }, [
        e,
        t
    ]), u;
}
function $23dc003753f08df2$var$D(e) {
    let t = /var\((.*)\)/.exec(e);
    if (t) {
        let n = t[1].indexOf(",");
        if (n === -1) return [
            t[1]
        ];
        let l = t[1].slice(0, n).trim(), r = t[1].slice(n + 1).trim();
        return r ? [
            l,
            ...$23dc003753f08df2$var$D(r)
        ] : [
            l
        ];
    }
    return [];
}
function $23dc003753f08df2$var$J(e, t) {
    let n = document.createElement("div");
    t.appendChild(n), n.style.setProperty("margin-top", "0px", "important"), n.style.setProperty("margin-top", e, "important");
    let l = parseFloat(window.getComputedStyle(n).marginTop) || 0;
    return t.removeChild(n), l;
}

});
parcelRegister("618j3", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $461947879dcdbcd4$export$deee3a793edee05f);
$parcel$export(module.exports, "detectOverflow", () => $461947879dcdbcd4$export$37b6bde19b108ecc);
$parcel$export(module.exports, "offset", () => $461947879dcdbcd4$export$cc800923e997bb8);
$parcel$export(module.exports, "autoPlacement", () => $461947879dcdbcd4$export$91fb6ecbd551914);
$parcel$export(module.exports, "shift", () => $461947879dcdbcd4$export$fba63a578e423eb);
$parcel$export(module.exports, "flip", () => $461947879dcdbcd4$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $461947879dcdbcd4$export$346677f925de839c);
$parcel$export(module.exports, "hide", () => $461947879dcdbcd4$export$fe8985bb6374093c);
$parcel$export(module.exports, "arrow", () => $461947879dcdbcd4$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "inline", () => $461947879dcdbcd4$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "limitShift", () => $461947879dcdbcd4$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "computePosition", () => $461947879dcdbcd4$export$48a53dcb22e581d0);
$parcel$export(module.exports, "getOverflowAncestors", () => (parcelRequire("33bLr")).getOverflowAncestors);

var $cZ41y = parcelRequire("cZ41y");
var $1obCQ = parcelRequire("1obCQ");

var $1obCQ = parcelRequire("1obCQ");

var $33bLr = parcelRequire("33bLr");
function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $33bLr.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $33bLr.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $1obCQ.round)(width) !== offsetWidth || (0, $1obCQ.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $33bLr.isElement)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $33bLr.isHTMLElement)(domElement)) return (0, $1obCQ.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $1obCQ.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $1obCQ.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $1obCQ.createCoords)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $33bLr.getWindow)(element);
    if (!(0, $33bLr.isWebKit)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $33bLr.getWindow)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $1obCQ.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $33bLr.isElement)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $1obCQ.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $33bLr.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $33bLr.isElement)(offsetParent) ? (0, $33bLr.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $33bLr.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $33bLr.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $33bLr.getWindow)(currentIFrame);
            currentIFrame = (0, $33bLr.getFrameElement)(currentWin);
        }
    }
    return (0, $1obCQ.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $461947879dcdbcd4$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $33bLr.getNodeScroll)(element).scrollLeft;
    if (!rect) return $461947879dcdbcd4$var$getBoundingClientRect((0, $33bLr.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $461947879dcdbcd4$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $33bLr.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $33bLr.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $1obCQ.createCoords)(1);
    const offsets = (0, $1obCQ.createCoords)(0);
    const isOffsetParentAnElement = (0, $33bLr.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $33bLr.getNodeName)(offsetParent) !== "body" || (0, $33bLr.isOverflowElement)(documentElement)) scroll = (0, $33bLr.getNodeScroll)(offsetParent);
        if ((0, $33bLr.isHTMLElement)(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll, true) : (0, $1obCQ.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $33bLr.getDocumentElement)(element);
    const scroll = (0, $33bLr.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $1obCQ.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $1obCQ.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $33bLr.getComputedStyle)(body).direction === "rtl") x += (0, $1obCQ.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $33bLr.getWindow)(element);
    const html = (0, $33bLr.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $33bLr.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $33bLr.isHTMLElement)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $1obCQ.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $461947879dcdbcd4$var$getDocumentRect((0, $33bLr.getDocumentElement)(element));
    else if ((0, $33bLr.isElement)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $1obCQ.rectToClientRect)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $33bLr.getParentNode)(element);
    if (parentNode === stopNode || !(0, $33bLr.isElement)(parentNode) || (0, $33bLr.isLastTraversableNode)(parentNode)) return false;
    return (0, $33bLr.getComputedStyle)(parentNode).position === "fixed" || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $33bLr.getOverflowAncestors)(element, [], false).filter((el)=>(0, $33bLr.isElement)(el) && (0, $33bLr.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $33bLr.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $33bLr.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $33bLr.isElement)(currentNode) && !(0, $33bLr.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $33bLr.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $33bLr.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $33bLr.isOverflowElement)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $33bLr.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $33bLr.isTopLayer)(element) ? [] : $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $1obCQ.max)(rect.top, accRect.top);
        accRect.right = (0, $1obCQ.min)(rect.right, accRect.right);
        accRect.bottom = (0, $1obCQ.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $1obCQ.max)(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $33bLr.isHTMLElement)(offsetParent);
    const documentElement = (0, $33bLr.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $1obCQ.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $33bLr.getNodeName)(offsetParent) !== "body" || (0, $33bLr.isOverflowElement)(documentElement)) scroll = (0, $33bLr.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $1obCQ.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$isStaticPositioned(element) {
    return (0, $33bLr.getComputedStyle)(element).position === "static";
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $33bLr.isHTMLElement)(element) || (0, $33bLr.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $33bLr.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const win = (0, $33bLr.getWindow)(element);
    if ((0, $33bLr.isTopLayer)(element)) return win;
    if (!(0, $33bLr.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $33bLr.getParentNode)(element);
        while(svgOffsetParent && !(0, $33bLr.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $33bLr.isElement)(svgOffsetParent) && !$461947879dcdbcd4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $33bLr.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $33bLr.isTableElement)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent))offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $33bLr.isLastTraversableNode)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent) && !(0, $33bLr.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $33bLr.getContainingBlock)(element) || win;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $33bLr.getComputedStyle)(element).direction === "rtl";
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $33bLr.getDocumentElement,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $33bLr.isElement,
    isRTL: $461947879dcdbcd4$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $33bLr.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $1obCQ.floor)(top);
        const insetRight = (0, $1obCQ.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $1obCQ.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $1obCQ.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $1obCQ.max)(0, (0, $1obCQ.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $33bLr.getOverflowAncestors)(referenceEl) : [],
        ...(0, $33bLr.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $461947879dcdbcd4$export$37b6bde19b108ecc = (0, $cZ41y.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $461947879dcdbcd4$export$cc800923e997bb8 = (0, $cZ41y.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $cZ41y.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $cZ41y.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $cZ41y.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $cZ41y.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $cZ41y.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $cZ41y.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $cZ41y.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $cZ41y.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $cZ41y.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("cZ41y", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $973e4da43f2a375d$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $973e4da43f2a375d$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $973e4da43f2a375d$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $973e4da43f2a375d$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $973e4da43f2a375d$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $973e4da43f2a375d$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $973e4da43f2a375d$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $973e4da43f2a375d$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $973e4da43f2a375d$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $973e4da43f2a375d$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $973e4da43f2a375d$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("1obCQ")).rectToClientRect);

var $1obCQ = parcelRequire("1obCQ");
function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $1obCQ.getSideAxis)(placement);
    const alignmentAxis = (0, $1obCQ.getAlignmentAxis)(placement);
    const alignLength = (0, $1obCQ.getAxisLength)(alignmentAxis);
    const side = (0, $1obCQ.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $1obCQ.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $1obCQ.evaluate)(options, state);
    const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $1obCQ.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $1obCQ.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $1obCQ.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $1obCQ.getAlignmentAxis)(placement);
            const length = (0, $1obCQ.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $1obCQ.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $1obCQ.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $1obCQ.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $1obCQ.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $1obCQ.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $1obCQ.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $1obCQ.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $1obCQ.getAlignment)(placement) === alignment || (autoAlignment ? (0, $1obCQ.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $1obCQ.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $1obCQ.placements) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $1obCQ.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $1obCQ.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $1obCQ.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $1obCQ.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $1obCQ.getSide)(placement);
            const initialSideAxis = (0, $1obCQ.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $1obCQ.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $1obCQ.getOppositePlacement)(initialPlacement)
            ] : (0, $1obCQ.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $1obCQ.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $1obCQ.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $1obCQ.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $1obCQ.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $1obCQ.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $1obCQ.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $1obCQ.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $1obCQ.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $1obCQ.rectToClientRect)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $1obCQ.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $1obCQ.rectToClientRect)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $1obCQ.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $1obCQ.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $1obCQ.getSide)(placement) === "left";
                    const maxRight = (0, $1obCQ.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $1obCQ.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $1obCQ.getSide)(placement);
    const alignment = (0, $1obCQ.getAlignment)(placement);
    const isVertical = (0, $1obCQ.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $1obCQ.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $1obCQ.getSideAxis)((0, $1obCQ.getSide)(placement));
            const mainAxis = (0, $1obCQ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $1obCQ.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $1obCQ.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $1obCQ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $1obCQ.getSideAxis)(placement);
            const mainAxis = (0, $1obCQ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $1obCQ.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $1obCQ.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $1obCQ.getSide)(placement);
            const alignment = (0, $1obCQ.getAlignment)(placement);
            const isYAxis = (0, $1obCQ.getSideAxis)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $1obCQ.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $1obCQ.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $1obCQ.max)(overflow.left, 0);
                const xMax = (0, $1obCQ.max)(overflow.right, 0);
                const yMin = (0, $1obCQ.max)(overflow.top, 0);
                const yMax = (0, $1obCQ.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $1obCQ.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $1obCQ.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("1obCQ", function(module, exports) {

$parcel$export(module.exports, "sides", () => $10310cf078d13212$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $10310cf078d13212$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $10310cf078d13212$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $10310cf078d13212$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $10310cf078d13212$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $10310cf078d13212$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $10310cf078d13212$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $10310cf078d13212$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $10310cf078d13212$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $10310cf078d13212$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $10310cf078d13212$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $10310cf078d13212$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $10310cf078d13212$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $10310cf078d13212$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $10310cf078d13212$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $10310cf078d13212$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $10310cf078d13212$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $10310cf078d13212$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $10310cf078d13212$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $10310cf078d13212$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $10310cf078d13212$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $10310cf078d13212$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $10310cf078d13212$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($10310cf078d13212$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$10310cf078d13212$var$oppositeAlignmentMap[alignment]);
}
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$10310cf078d13212$var$oppositeSideMap[side]);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("33bLr", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $238ac70369f38756$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $238ac70369f38756$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $238ac70369f38756$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $238ac70369f38756$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $238ac70369f38756$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $238ac70369f38756$export$af51f0f06c0f328a);
$parcel$export(module.exports, "isOverflowElement", () => $238ac70369f38756$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $238ac70369f38756$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $238ac70369f38756$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $238ac70369f38756$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $238ac70369f38756$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $238ac70369f38756$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $238ac70369f38756$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $238ac70369f38756$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $238ac70369f38756$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $238ac70369f38756$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $238ac70369f38756$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $238ac70369f38756$export$7bf1f8740e3e34af);
function $238ac70369f38756$var$hasWindow() {
    return typeof window !== "undefined";
}
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    if (!$238ac70369f38756$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($238ac70369f38756$export$651544f548703224(element));
}
function $238ac70369f38756$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $238ac70369f38756$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $238ac70369f38756$export$78551043582a6a98();
    const css = $238ac70369f38756$export$45a5e7f76e0caa8d(elementOrCss) ? $238ac70369f38756$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($238ac70369f38756$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $238ac70369f38756$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $238ac70369f38756$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("33OG6", function(module, exports) {

$parcel$export(module.exports, "useFloating", () => $23a8f689f1d4c3be$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "offset", () => $23a8f689f1d4c3be$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $23a8f689f1d4c3be$export$fba63a578e423eb);
$parcel$export(module.exports, "flip", () => $23a8f689f1d4c3be$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $23a8f689f1d4c3be$export$346677f925de839c);

var $618j3 = parcelRequire("618j3");
var $33bLr = parcelRequire("33bLr");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $23a8f689f1d4c3be$var$index = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $23a8f689f1d4c3be$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$23a8f689f1d4c3be$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$23a8f689f1d4c3be$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $23a8f689f1d4c3be$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $23a8f689f1d4c3be$var$roundByDPR(element, value) {
    const dpr = $23a8f689f1d4c3be$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $23a8f689f1d4c3be$var$useLatestRef(value) {
    const ref = $acw62.useRef(value);
    $23a8f689f1d4c3be$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $23a8f689f1d4c3be$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $acw62.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $acw62.useState(middleware);
    if (!$23a8f689f1d4c3be$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $acw62.useState(null);
    const [_floating, _setFloating] = $acw62.useState(null);
    const setReference = $acw62.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $acw62.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $acw62.useRef(null);
    const floatingRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $23a8f689f1d4c3be$var$useLatestRef(whileElementsMounted);
    const platformRef = $23a8f689f1d4c3be$var$useLatestRef(platform);
    const openRef = $23a8f689f1d4c3be$var$useLatestRef(open);
    const update = $acw62.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $618j3.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$23a8f689f1d4c3be$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $1u0KT.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $23a8f689f1d4c3be$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $acw62.useRef(false);
    $23a8f689f1d4c3be$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $23a8f689f1d4c3be$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $acw62.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $acw62.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $acw62.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $23a8f689f1d4c3be$var$roundByDPR(elements.floating, data.x);
        const y = $23a8f689f1d4c3be$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$23a8f689f1d4c3be$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $acw62.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23a8f689f1d4c3be$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $618j3.arrow)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $618j3.arrow)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $23a8f689f1d4c3be$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $618j3.offset)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $23a8f689f1d4c3be$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $618j3.shift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $23a8f689f1d4c3be$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $618j3.limitShift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $23a8f689f1d4c3be$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $618j3.flip)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $23a8f689f1d4c3be$export$346677f925de839c = (options, deps)=>({
        ...(0, $618j3.size)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $23a8f689f1d4c3be$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $618j3.autoPlacement)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $23a8f689f1d4c3be$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $618j3.hide)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $23a8f689f1d4c3be$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $618j3.inline)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23a8f689f1d4c3be$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$23a8f689f1d4c3be$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });

});

parcelRegister("5rxG7", function(module, exports) {

$parcel$export(module.exports, "useFloating", () => $3f69993268aa5b7a$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "useInteractions", () => $3f69993268aa5b7a$export$a519f7794e446ddd);
$parcel$export(module.exports, "inner", () => $3f69993268aa5b7a$export$4ae363f1d88fb658);
$parcel$export(module.exports, "useInnerOffset", () => $3f69993268aa5b7a$export$3d74b0dda7cc82ff);
$parcel$export(module.exports, "offset", () => (parcelRequire("33OG6")).offset);

var $acw62 = parcelRequire("acw62");

var $4wHOx = parcelRequire("4wHOx");

var $1obCQ = parcelRequire("1obCQ");

var $33bLr = parcelRequire("33bLr");

var $e8HHX = parcelRequire("e8HHX");

var $1u0KT = parcelRequire("1u0KT");

var $618j3 = parcelRequire("618j3");
var $33bLr = parcelRequire("33bLr");
var $33OG6 = parcelRequire("33OG6");
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $3f69993268aa5b7a$export$74665b213cb5c4cf(refs) {
    return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === "function") ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $3f69993268aa5b7a$var$SafeReact = {
    ...$acw62
};
const $3f69993268aa5b7a$var$useInsertionEffect = $3f69993268aa5b7a$var$SafeReact.useInsertionEffect;
const $3f69993268aa5b7a$var$useSafeInsertionEffect = $3f69993268aa5b7a$var$useInsertionEffect || ((fn)=>fn());
function $3f69993268aa5b7a$var$useEffectEvent(callback) {
    const ref = $acw62.useRef(()=>{});
    $3f69993268aa5b7a$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $acw62.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
const $3f69993268aa5b7a$var$ARROW_UP = "ArrowUp";
const $3f69993268aa5b7a$var$ARROW_DOWN = "ArrowDown";
const $3f69993268aa5b7a$var$ARROW_LEFT = "ArrowLeft";
const $3f69993268aa5b7a$var$ARROW_RIGHT = "ArrowRight";
function $3f69993268aa5b7a$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndices) {
    return $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndices) {
    return $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && $3f69993268aa5b7a$var$isDisabled(list, index, disabledIndices));
    return index;
}
function $3f69993268aa5b7a$var$getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $3f69993268aa5b7a$var$ARROW_UP) {
        stop && (0, $4wHOx.stopEvent)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($3f69993268aa5b7a$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $3f69993268aa5b7a$var$ARROW_DOWN) {
        stop && (0, $4wHOx.stopEvent)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($3f69993268aa5b7a$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === "both") {
        const prevRow = (0, $1obCQ.floor)(prevIndex / cols);
        if (event.key === $3f69993268aa5b7a$var$ARROW_RIGHT) {
            stop && (0, $4wHOx.stopEvent)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $3f69993268aa5b7a$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($3f69993268aa5b7a$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === $3f69993268aa5b7a$var$ARROW_LEFT) {
            stop && (0, $4wHOx.stopEvent)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $3f69993268aa5b7a$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($3f69993268aa5b7a$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $1obCQ.floor)(maxIndex / cols) === prevRow;
        if ($3f69993268aa5b7a$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === $3f69993268aa5b7a$var$ARROW_LEFT ? maxIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $3f69993268aa5b7a$var$buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $3f69993268aa5b7a$var$getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case "tl":
            return firstCellIndex;
        case "tr":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case "bl":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case "br":
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $3f69993268aa5b7a$var$getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $3f69993268aa5b7a$var$isDisabled(list, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    const element = list[index];
    return element == null || element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true";
}
let $3f69993268aa5b7a$var$rafId = 0;
function $3f69993268aa5b7a$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($3f69993268aa5b7a$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $3f69993268aa5b7a$var$rafId = requestAnimationFrame(exec);
}
var $3f69993268aa5b7a$var$index = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $3f69993268aa5b7a$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $3f69993268aa5b7a$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $3f69993268aa5b7a$var$FloatingListContext = /*#__PURE__*/ $acw62.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $3f69993268aa5b7a$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [map, setMap] = $acw62.useState(()=>new Map());
    const register = $acw62.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $acw62.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $3f69993268aa5b7a$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($3f69993268aa5b7a$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$3f69993268aa5b7a$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingListContext.Provider, {
        value: $acw62.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $3f69993268aa5b7a$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $acw62.useContext($3f69993268aa5b7a$var$FloatingListContext);
    const [index$1, setIndex] = $acw62.useState(null);
    const componentRef = $acw62.useRef(null);
    const ref = $acw62.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $acw62.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
function $3f69993268aa5b7a$var$renderJsx(render, computedProps) {
    if (typeof render === "function") return render(computedProps);
    if (render) return /*#__PURE__*/ $acw62.cloneElement(render, computedProps);
    return /*#__PURE__*/ $acw62.createElement("div", computedProps);
}
const $3f69993268aa5b7a$var$CompositeContext = /*#__PURE__*/ $acw62.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $3f69993268aa5b7a$var$horizontalKeys = [
    $3f69993268aa5b7a$var$ARROW_LEFT,
    $3f69993268aa5b7a$var$ARROW_RIGHT
];
const $3f69993268aa5b7a$var$verticalKeys = [
    $3f69993268aa5b7a$var$ARROW_UP,
    $3f69993268aa5b7a$var$ARROW_DOWN
];
const $3f69993268aa5b7a$var$allKeys = [
    ...$3f69993268aa5b7a$var$horizontalKeys,
    ...$3f69993268aa5b7a$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $3f69993268aa5b7a$export$43586241d9db0c6d = /*#__PURE__*/ $acw62.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = "both", loop: loop = true, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $acw62.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = $3f69993268aa5b7a$var$useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $acw62.useRef([]);
    const renderElementProps = render && typeof render !== "function" ? render.props : {};
    const contextValue = $acw62.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$3f69993268aa5b7a$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = $3f69993268aa5b7a$var$getMinIndex(elementsRef, disabledIndices);
        const maxIndex = $3f69993268aa5b7a$var$getMaxIndex(elementsRef, disabledIndices);
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $3f69993268aa5b7a$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$3f69993268aa5b7a$var$isDisabled(elementsRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$3f69993268aa5b7a$var$isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[$3f69993268aa5b7a$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $3f69993268aa5b7a$var$getCellIndices([
                    ...disabledIndices || elementsRef.current.map((_, index)=>$3f69993268aa5b7a$var$isDisabled(elementsRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $3f69993268aa5b7a$var$getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $3f69993268aa5b7a$var$ARROW_DOWN ? "bl" : event.key === $3f69993268aa5b7a$var$ARROW_RIGHT ? "tr" : "tl")
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                $3f69993268aa5b7a$var$ARROW_RIGHT
            ],
            vertical: [
                $3f69993268aa5b7a$var$ARROW_DOWN
            ],
            both: [
                $3f69993268aa5b7a$var$ARROW_RIGHT,
                $3f69993268aa5b7a$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                $3f69993268aa5b7a$var$ARROW_LEFT
            ],
            vertical: [
                $3f69993268aa5b7a$var$ARROW_UP
            ],
            both: [
                $3f69993268aa5b7a$var$ARROW_LEFT,
                $3f69993268aa5b7a$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $3f69993268aa5b7a$var$allKeys : ({
            horizontal: $3f69993268aa5b7a$var$horizontalKeys,
            vertical: $3f69993268aa5b7a$var$verticalKeys,
            both: $3f69993268aa5b7a$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !$3f69993268aa5b7a$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            // Wait for FocusManager `returnFocus` to execute.
            queueMicrotask(()=>{
                $3f69993268aa5b7a$var$enqueueFocus(elementsRef.current[nextIndex]);
            });
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        "aria-orientation": orientation === "both" ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$export$ffe15b0e64951704, {
        elementsRef: elementsRef
    }, $3f69993268aa5b7a$var$renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $3f69993268aa5b7a$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $acw62.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== "function" ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $acw62.useContext($3f69993268aa5b7a$var$CompositeContext);
    const { ref: ref, index: index } = $3f69993268aa5b7a$export$dcdc7ff5149f7d1a();
    const mergedRef = $3f69993268aa5b7a$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        "data-active": isActive ? "" : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $3f69993268aa5b7a$var$renderJsx(render, computedProps);
});
function $3f69993268aa5b7a$var$_extends() {
    $3f69993268aa5b7a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3f69993268aa5b7a$var$_extends.apply(this, arguments);
}
let $3f69993268aa5b7a$var$serverHandoffComplete = false;
let $3f69993268aa5b7a$var$count = 0;
const $3f69993268aa5b7a$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $3f69993268aa5b7a$var$count++;
function $3f69993268aa5b7a$var$useFloatingId() {
    const [id, setId] = $acw62.useState(()=>$3f69993268aa5b7a$var$serverHandoffComplete ? $3f69993268aa5b7a$var$genId() : undefined);
    $3f69993268aa5b7a$var$index(()=>{
        if (id == null) setId($3f69993268aa5b7a$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $acw62.useEffect(()=>{
        $3f69993268aa5b7a$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $3f69993268aa5b7a$var$useReactId = $3f69993268aa5b7a$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $3f69993268aa5b7a$export$f680877a34711e37 = $3f69993268aa5b7a$var$useReactId || $3f69993268aa5b7a$var$useFloatingId;
let $3f69993268aa5b7a$var$devMessageSet;
function $3f69993268aa5b7a$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet = $3f69993268aa5b7a$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $3f69993268aa5b7a$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $3f69993268aa5b7a$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet3 = $3f69993268aa5b7a$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $3f69993268aa5b7a$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $3f69993268aa5b7a$export$33511391554732bc = /*#__PURE__*/ $acw62.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $3f69993268aa5b7a$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $acw62.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    $3f69993268aa5b7a$var$index(()=>{
        if (!floating) return;
        const isRTL = (0, $33bLr.getComputedStyle)(floating).direction === "rtl";
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split("-");
    const isVerticalSide = side === "top" || side === "bottom";
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === "end" ? "bottom" : "top";
    let xOffsetProp = computedStaticOffset && alignment === "end" ? "right" : "left";
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === "end" ? "left" : "right";
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : "";
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : "";
    const dValue = d || "M0,0" + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + " Z";
    const rotation = {
        top: isCustomShape ? "rotate(180deg)" : "",
        left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
        bottom: isCustomShape ? "" : "rotate(180deg)",
        right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
    }[side];
    return /*#__PURE__*/ $acw62.createElement("svg", $3f69993268aa5b7a$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: "absolute",
            pointerEvents: "none",
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(" "),
            ...restStyle
        }
    }), computedStrokeWidth > 0 && /*#__PURE__*/ $acw62.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : "none",
        d: dValue
    }), /*#__PURE__*/ $acw62.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function $3f69993268aa5b7a$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $3f69993268aa5b7a$var$FloatingNodeContext = /*#__PURE__*/ $acw62.createContext(null);
const $3f69993268aa5b7a$var$FloatingTreeContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $3f69993268aa5b7a$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $acw62.useContext($3f69993268aa5b7a$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $3f69993268aa5b7a$export$db0c2a7c7a2a4f69 = ()=>$acw62.useContext($3f69993268aa5b7a$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3f69993268aa5b7a$export$9b136e0e758a42f4(customParentId) {
    const id = $3f69993268aa5b7a$export$f680877a34711e37();
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const reactParentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $3f69993268aa5b7a$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3f69993268aa5b7a$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingNodeContext.Provider, {
        value: $acw62.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3f69993268aa5b7a$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $acw62.useRef([]);
    const addNode = $acw62.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $acw62.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $acw62.useState(()=>$3f69993268aa5b7a$var$createPubSub())[0];
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingTreeContext.Provider, {
        value: $acw62.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $3f69993268aa5b7a$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $3f69993268aa5b7a$var$useLatestRef(value) {
    const ref = (0, $acw62.useRef)(value);
    $3f69993268aa5b7a$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $3f69993268aa5b7a$var$safePolygonIdentifier = /*#__PURE__*/ $3f69993268aa5b7a$var$createAttribute("safe-polygon");
function $3f69993268aa5b7a$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $4wHOx.isMouseLikePointerType)(pointerType)) return 0;
    if (typeof value === "number") return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $3f69993268aa5b7a$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const handleCloseRef = $3f69993268aa5b7a$var$useLatestRef(handleClose);
    const delayRef = $3f69993268aa5b7a$var$useLatestRef(delay);
    const openRef = $3f69993268aa5b7a$var$useLatestRef(open);
    const pointerTypeRef = $acw62.useRef();
    const timeoutRef = $acw62.useRef(-1);
    const handlerRef = $acw62.useRef();
    const restTimeoutRef = $acw62.useRef(-1);
    const blockMouseMoveRef = $acw62.useRef(true);
    const performedPointerEventsMutationRef = $acw62.useRef(false);
    const unbindMouseMoveRef = $acw62.useRef(()=>{});
    const restTimeoutPendingRef = $acw62.useRef(false);
    const isHoverOpen = $acw62.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes("mouse")) && type !== "mousedown";
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, "hover");
        }
        const html = (0, $4wHOx.getDocument)(elements.floating).documentElement;
        html.addEventListener("mouseleave", onLeave);
        return ()=>{
            html.removeEventListener("mouseleave", onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $acw62.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = "hover";
        const closeDelay = $3f69993268aa5b7a$var$getDelay(delayRef.current, "close", pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $3f69993268aa5b7a$var$useEffectEvent(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = $3f69993268aa5b7a$var$useEffectEvent(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $4wHOx.getDocument)(elements.floating).body;
            body.style.pointerEvents = "";
            body.removeAttribute($3f69993268aa5b7a$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function isClickLikeOpenEvent() {
            return dataRef.current.openEvent ? [
                "click",
                "mousedown"
            ].includes(dataRef.current.openEvent.type) : false;
        }
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $4wHOx.isMouseLikePointerType)(pointerTypeRef.current) || restMs > 0 && !$3f69993268aa5b7a$var$getDelay(delayRef.current, "open")) return;
            const openDelay = $3f69993268aa5b7a$var$getDelay(delayRef.current, "open", pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, "hover");
            }, openDelay);
            else onOpenChange(true, event, "hover");
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = (0, $4wHOx.getDocument)(elements.floating);
            clearTimeout(restTimeoutRef.current);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        closeWithDelay(event, true, "safe-polygon");
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener("mousemove", handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener("mousemove", handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === "touch" ? !(0, $4wHOx.contains)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    closeWithDelay(event);
                }
            })(event);
        }
        if ((0, $33bLr.isElement)(elements.domReference)) {
            var _elements$floating;
            const ref = elements.domReference;
            open && ref.addEventListener("mouseleave", onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener("mouseleave", onScrollMouseLeave);
            move && ref.addEventListener("mousemove", onMouseEnter, {
                once: true
            });
            ref.addEventListener("mouseenter", onMouseEnter);
            ref.addEventListener("mouseleave", onMouseLeave);
            return ()=>{
                var _elements$floating2;
                open && ref.removeEventListener("mouseleave", onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener("mouseleave", onScrollMouseLeave);
                move && ref.removeEventListener("mousemove", onMouseEnter);
                ref.removeEventListener("mouseenter", onMouseEnter);
                ref.removeEventListener("mouseleave", onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $3f69993268aa5b7a$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $33bLr.isElement)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $4wHOx.getDocument)(elements.floating).body;
                body.setAttribute($3f69993268aa5b7a$var$safePolygonIdentifier, "");
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = "";
                body.style.pointerEvents = "none";
                ref.style.pointerEvents = "auto";
                floatingEl.style.pointerEvents = "auto";
                return ()=>{
                    body.style.pointerEvents = "";
                    ref.style.pointerEvents = "";
                    floatingEl.style.pointerEvents = "";
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $acw62.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, "hover");
                }
                if (mouseOnly && !(0, $4wHOx.isMouseLikePointerType)(pointerTypeRef.current)) return;
                if (open || restMs === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === "touch") handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMs
    ]);
    const floating = $acw62.useMemo(()=>({
            onMouseEnter () {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave (event) {
                closeWithDelay(event.nativeEvent, false);
            }
        }), [
        closeWithDelay
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
const $3f69993268aa5b7a$var$NOOP = ()=>{};
const $3f69993268aa5b7a$var$FloatingDelayGroupContext = /*#__PURE__*/ $acw62.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $3f69993268aa5b7a$var$NOOP,
    setState: $3f69993268aa5b7a$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $3f69993268aa5b7a$export$e2411914b150383d = ()=>$acw62.useContext($3f69993268aa5b7a$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $3f69993268aa5b7a$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $acw62.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $acw62.useRef(null);
    const setCurrentId = $acw62.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $3f69993268aa5b7a$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingDelayGroupContext.Provider, {
        value: $acw62.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $3f69993268aa5b7a$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $3f69993268aa5b7a$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $3f69993268aa5b7a$var$getDelay(initialDelay, "close")
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (setCurrentId === $3f69993268aa5b7a$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
function $3f69993268aa5b7a$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $3f69993268aa5b7a$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $3f69993268aa5b7a$var$getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $3f69993268aa5b7a$var$getChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $3f69993268aa5b7a$var$counterMap = /*#__PURE__*/ new WeakMap();
let $3f69993268aa5b7a$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $3f69993268aa5b7a$var$markerMap = {};
let $3f69993268aa5b7a$var$lockCount$1 = 0;
const $3f69993268aa5b7a$var$supportsInert = ()=>typeof HTMLElement !== "undefined" && "inert" in HTMLElement.prototype;
const $3f69993268aa5b7a$var$unwrapHost = (node)=>node && (node.host || $3f69993268aa5b7a$var$unwrapHost(node.parentNode));
const $3f69993268aa5b7a$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $3f69993268aa5b7a$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $3f69993268aa5b7a$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = "data-floating-ui-inert";
    const controlAttribute = inert ? "inert" : ariaHidden ? "aria-hidden" : null;
    const avoidElements = $3f69993268aa5b7a$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$3f69993268aa5b7a$var$markerMap[markerName]) $3f69993268aa5b7a$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $3f69993268aa5b7a$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $33bLr.getNodeName)(node) === "script") return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== "false";
                const counterValue = ($3f69993268aa5b7a$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $3f69993268aa5b7a$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $3f69993268aa5b7a$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, "");
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, "true");
            }
        });
    }
    $3f69993268aa5b7a$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterValue = ($3f69993268aa5b7a$var$counterMap.get(element) || 0) - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $3f69993268aa5b7a$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$3f69993268aa5b7a$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $3f69993268aa5b7a$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $3f69993268aa5b7a$var$lockCount$1--;
        if (!$3f69993268aa5b7a$var$lockCount$1) {
            $3f69993268aa5b7a$var$counterMap = new WeakMap();
            $3f69993268aa5b7a$var$counterMap = new WeakMap();
            $3f69993268aa5b7a$var$uncontrolledElementsSet = new WeakSet();
            $3f69993268aa5b7a$var$markerMap = {};
        }
    };
}
function $3f69993268aa5b7a$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = (0, $4wHOx.getDocument)(avoidElements[0]).body;
    return $3f69993268aa5b7a$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll("[aria-live]"))), body, ariaHidden, inert);
}
const $3f69993268aa5b7a$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
    });
function $3f69993268aa5b7a$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $e8HHX.tabbable)(container, $3f69993268aa5b7a$var$getTabbableOptions());
    if (direction === "prev") allTabbable.reverse();
    const activeIndex = allTabbable.indexOf((0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $3f69993268aa5b7a$var$getNextTabbable() {
    return $3f69993268aa5b7a$var$getTabbableIn(document.body, "next");
}
function $3f69993268aa5b7a$var$getPreviousTabbable() {
    return $3f69993268aa5b7a$var$getTabbableIn(document.body, "prev");
}
function $3f69993268aa5b7a$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $4wHOx.contains)(containerElement, relatedTarget);
}
function $3f69993268aa5b7a$var$disableFocusInside(container) {
    const tabbableElements = (0, $e8HHX.tabbable)(container, $3f69993268aa5b7a$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute("tabindex") || "";
        element.setAttribute("tabindex", "-1");
    });
}
function $3f69993268aa5b7a$var$enableFocusInside(container) {
    const elements = container.querySelectorAll("[data-tabindex]");
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute("tabindex", tabindex);
        else element.removeAttribute("tabindex");
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $3f69993268aa5b7a$var$HIDDEN_STYLES = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "fixed",
    whiteSpace: "nowrap",
    width: "1px",
    top: 0,
    left: 0
};
let $3f69993268aa5b7a$var$timeoutId;
function $3f69993268aa5b7a$var$setActiveElementOnTab(event) {
    if (event.key === "Tab") {
        event.target;
        clearTimeout($3f69993268aa5b7a$var$timeoutId);
    }
}
const $3f69993268aa5b7a$var$FocusGuard = /*#__PURE__*/ $acw62.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $acw62.useState();
    $3f69993268aa5b7a$var$index(()=>{
        if ((0, $4wHOx.isSafari)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole("button");
        document.addEventListener("keydown", $3f69993268aa5b7a$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener("keydown", $3f69993268aa5b7a$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        "aria-hidden": role ? undefined : true,
        [$3f69993268aa5b7a$var$createAttribute("focus-guard")]: "",
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $acw62.createElement("span", $3f69993268aa5b7a$var$_extends({}, props, restProps));
});
const $3f69993268aa5b7a$var$PortalContext = /*#__PURE__*/ $acw62.createContext(null);
const $3f69993268aa5b7a$var$attr = /*#__PURE__*/ $3f69993268aa5b7a$var$createAttribute("portal");
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $3f69993268aa5b7a$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $3f69993268aa5b7a$export$f680877a34711e37();
    const portalContext = $3f69993268aa5b7a$var$usePortalContext();
    const [portalNode, setPortalNode] = $acw62.useState(null);
    const portalNodeRef = $acw62.useRef(null);
    $3f69993268aa5b7a$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($3f69993268aa5b7a$var$attr, "");
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $33bLr.isElement)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement("div");
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($3f69993268aa5b7a$var$attr, "");
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $3f69993268aa5b7a$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $3f69993268aa5b7a$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $acw62.useState(null);
    const beforeOutsideRef = $acw62.useRef(null);
    const afterOutsideRef = $acw62.useRef(null);
    const beforeInsideRef = $acw62.useRef(null);
    const afterInsideRef = $acw62.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $acw62.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $3f69993268aa5b7a$var$isOutsideEvent(event)) {
                const focusing = event.type === "focusin";
                const manageFocus = focusing ? $3f69993268aa5b7a$var$enableFocusInside : $3f69993268aa5b7a$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener("focusin", onFocus, true);
        portalNode.addEventListener("focusout", onFocus, true);
        return ()=>{
            portalNode.removeEventListener("focusin", onFocus, true);
            portalNode.removeEventListener("focusout", onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $acw62.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        $3f69993268aa5b7a$var$enableFocusInside(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$PortalContext.Provider, {
        value: $acw62.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $3f69993268aa5b7a$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement("span", {
        "aria-owns": portalNode.id,
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ $1u0KT.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $3f69993268aa5b7a$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, "focus-out"));
            }
        }
    }));
}
const $3f69993268aa5b7a$var$usePortalContext = ()=>$acw62.useContext($3f69993268aa5b7a$var$PortalContext);
const $3f69993268aa5b7a$var$FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable";
function $3f69993268aa5b7a$var$getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($3f69993268aa5b7a$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $3f69993268aa5b7a$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
const $3f69993268aa5b7a$var$LIST_LIMIT = 20;
let $3f69993268aa5b7a$var$previouslyFocusedElements = [];
function $3f69993268aa5b7a$var$addPreviouslyFocusedElement(element) {
    $3f69993268aa5b7a$var$previouslyFocusedElements = $3f69993268aa5b7a$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    let tabbableEl = element;
    if (!tabbableEl || (0, $33bLr.getNodeName)(tabbableEl) === "body") return;
    if (!(0, $e8HHX.isTabbable)(tabbableEl, $3f69993268aa5b7a$var$getTabbableOptions())) {
        const tabbableChild = (0, $e8HHX.tabbable)(tabbableEl, $3f69993268aa5b7a$var$getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    $3f69993268aa5b7a$var$previouslyFocusedElements.push(tabbableEl);
    if ($3f69993268aa5b7a$var$previouslyFocusedElements.length > $3f69993268aa5b7a$var$LIST_LIMIT) $3f69993268aa5b7a$var$previouslyFocusedElements = $3f69993268aa5b7a$var$previouslyFocusedElements.slice(-$3f69993268aa5b7a$var$LIST_LIMIT);
}
function $3f69993268aa5b7a$var$getPreviouslyFocusedElement() {
    return $3f69993268aa5b7a$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
const $3f69993268aa5b7a$var$VisuallyHiddenDismiss = /*#__PURE__*/ $acw62.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $acw62.createElement("button", $3f69993268aa5b7a$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $3f69993268aa5b7a$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        "content"
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = props;
    const { open: open, refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, floatingId: floatingId, elements: { domReference: domReference, floating: floating } } = context;
    const ignoreInitialFocus = typeof initialFocus === "number" && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $4wHOx.isTypeableCombobox)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = $3f69993268aa5b7a$var$supportsInert() ? _guards : true;
    const orderRef = $3f69993268aa5b7a$var$useLatestRef(order);
    const initialFocusRef = $3f69993268aa5b7a$var$useLatestRef(initialFocus);
    const returnFocusRef = $3f69993268aa5b7a$var$useLatestRef(returnFocus);
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const portalContext = $3f69993268aa5b7a$var$usePortalContext();
    const startDismissButtonRef = $acw62.useRef(null);
    const endDismissButtonRef = $acw62.useRef(null);
    const preventReturnFocusRef = $acw62.useRef(false);
    const isPointerDownRef = $acw62.useRef(false);
    const tabbableIndexRef = $acw62.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = $3f69993268aa5b7a$var$getFloatingFocusElement(floating);
    const getTabbableContent = $3f69993268aa5b7a$var$useEffectEvent(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $e8HHX.tabbable)(container, $3f69993268aa5b7a$var$getTabbableOptions()) : [];
    });
    const getTabbableElements = $3f69993268aa5b7a$var$useEffectEvent((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === "reference") return domReference;
            if (floatingFocusElement && type === "floating") return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $acw62.useEffect(()=>{
        preventReturnFocusRef.current = false;
    }, [
        disabled
    ]);
    $acw62.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === "Tab") {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $4wHOx.contains)(floatingFocusElement, (0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $4wHOx.stopEvent)(event);
                const els = getTabbableElements();
                const target = (0, $4wHOx.getTarget)(event);
                if (orderRef.current[0] === "reference" && target === domReference) {
                    (0, $4wHOx.stopEvent)(event);
                    if (event.shiftKey) $3f69993268aa5b7a$var$enqueueFocus(els[els.length - 1]);
                    else $3f69993268aa5b7a$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === "floating" && target === floatingFocusElement && event.shiftKey) {
                    (0, $4wHOx.stopEvent)(event);
                    $3f69993268aa5b7a$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $4wHOx.getDocument)(floatingFocusElement);
        doc.addEventListener("keydown", onKeyDown);
        return ()=>{
            doc.removeEventListener("keydown", onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $acw62.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $4wHOx.getTarget)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener("focusin", handleFocusIn);
        return ()=>{
            floating.removeEventListener("focusin", handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $acw62.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !((0, $4wHOx.contains)(domReference, relatedTarget) || (0, $4wHOx.contains)(floating, relatedTarget) || (0, $4wHOx.contains)(relatedTarget, floating) || (0, $4wHOx.contains)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($3f69993268aa5b7a$var$createAttribute("focus-guard")) || tree && ($3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $4wHOx.contains)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $4wHOx.contains)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $3f69993268aa5b7a$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(floatingFocusElement)) === (0, $4wHOx.getDocument)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $33bLr.isHTMLElement)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $33bLr.isHTMLElement)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $3f69993268aa5b7a$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, "focus-out");
                }
            });
        }
        if (floating && (0, $33bLr.isHTMLElement)(domReference)) {
            domReference.addEventListener("focusout", handleFocusOutside);
            domReference.addEventListener("pointerdown", handlePointerDown);
            floating.addEventListener("focusout", handleFocusOutside);
            return ()=>{
                domReference.removeEventListener("focusout", handleFocusOutside);
                domReference.removeEventListener("pointerdown", handlePointerDown);
                floating.removeEventListener("focusout", handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox
    ]);
    $acw62.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $3f69993268aa5b7a$var$createAttribute("portal") + "]")) || []);
        if (floating) {
            const insideElements = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes("reference") || isUntrappedTypeableCombobox ? domReference : null
            ].filter((x)=>x != null);
            const cleanup = modal || isUntrappedTypeableCombobox ? $3f69993268aa5b7a$var$markOthers(insideElements, guards, !guards) : $3f69993268aa5b7a$var$markOthers(insideElements);
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled || !(0, $33bLr.isHTMLElement)(floatingFocusElement)) return;
        const doc = (0, $4wHOx.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $4wHOx.activeElement)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $4wHOx.contains)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $3f69993268aa5b7a$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled || !floatingFocusElement) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $4wHOx.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $4wHOx.activeElement)(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        $3f69993268aa5b7a$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { open: open, reason: reason, event: event, nested: nested } = _ref;
            if (open) openEvent = event;
            if (reason === "escape-key" && refs.domReference.current) $3f69993268aa5b7a$var$addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === "hover" && event.type === "mouseleave") preventReturnFocusRef.current = true;
            if (reason !== "outside-press") return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, $4wHOx.isVirtualClick)(event) || (0, $4wHOx.isVirtualPointerEvent)(event));
        }
        events.on("openchange", onOpenChange);
        const fallbackEl = doc.createElement("span");
        fallbackEl.setAttribute("tabindex", "-1");
        fallbackEl.setAttribute("aria-hidden", "true");
        Object.assign(fallbackEl.style, $3f69993268aa5b7a$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement("afterend", fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === "boolean") return $3f69993268aa5b7a$var$getPreviouslyFocusedElement() || fallbackEl;
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off("openchange", onOpenChange);
            const activeEl = (0, $4wHOx.activeElement)(doc);
            const isFocusInsideFloatingTree = (0, $4wHOx.contains)(floating, activeEl) || tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return (0, $4wHOx.contains)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                "click",
                "mousedown"
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) $3f69993268aa5b7a$var$addPreviouslyFocusedElement(refs.domReference.current);
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $33bLr.isHTMLElement)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) returnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId,
        isInsidePortal,
        domReference
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        if (typeof MutationObserver !== "function") return;
        if (ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floatingFocusElement.getAttribute("tabindex");
            const tabbableContent = getTabbableContent();
            const activeEl = (0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(floating));
            const tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes("floating") || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
                if (tabIndex !== "0") floatingFocusElement.setAttribute("tabindex", "0");
            } else if (tabIndex !== "-1") floatingFocusElement.setAttribute("tabindex", "-1");
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$VisuallyHiddenDismiss, {
            ref: location === "start" ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === "string" ? visuallyHiddenDismiss : "Dismiss");
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $3f69993268aa5b7a$var$enqueueFocus(order[0] === "reference" ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $3f69993268aa5b7a$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton("start"), children, renderDismissButton("end"), shouldRenderGuards && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $3f69993268aa5b7a$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $3f69993268aa5b7a$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
let $3f69993268aa5b7a$var$lockCount = 0;
function $3f69993268aa5b7a$var$enableScrollLock() {
    const isIOS = /iP(hone|ad|od)|iOS/.test((0, $4wHOx.getPlatform)());
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? "paddingLeft" : "paddingRight";
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = "hidden";
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: "fixed",
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: "0"
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: "",
            [paddingProp]: ""
        });
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: "",
                top: "",
                left: "",
                right: ""
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $3f69993268aa5b7a$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $3f69993268aa5b7a$export$a35954495955337b = /*#__PURE__*/ $acw62.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    $3f69993268aa5b7a$var$index(()=>{
        if (!lockScroll) return;
        $3f69993268aa5b7a$var$lockCount++;
        if ($3f69993268aa5b7a$var$lockCount === 1) $3f69993268aa5b7a$var$cleanup = $3f69993268aa5b7a$var$enableScrollLock();
        return ()=>{
            $3f69993268aa5b7a$var$lockCount--;
            if ($3f69993268aa5b7a$var$lockCount === 0) $3f69993268aa5b7a$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ $acw62.createElement("div", $3f69993268aa5b7a$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: "fixed",
            overflow: "auto",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $3f69993268aa5b7a$var$isButtonTarget(event) {
    return (0, $33bLr.isHTMLElement)(event.target) && event.target.tagName === "BUTTON";
}
function $3f69993268aa5b7a$var$isSpaceIgnored(element) {
    return (0, $4wHOx.isTypeableElement)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $3f69993268aa5b7a$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = "click", toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true } = props;
    const pointerTypeRef = $acw62.useRef();
    const didKeyDownRef = $acw62.useRef(false);
    const reference = $acw62.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === "click") return;
                if ((0, $4wHOx.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "mousedown" : true)) onOpenChange(false, event.nativeEvent, "click");
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === "mousedown" && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $4wHOx.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "click" : true)) onOpenChange(false, event.nativeEvent, "click");
                else onOpenChange(true, event.nativeEvent, "click");
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $3f69993268aa5b7a$var$isButtonTarget(event)) return;
                if (event.key === " " && !$3f69993268aa5b7a$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event.key === "Enter") {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $3f69993268aa5b7a$var$isButtonTarget(event) || $3f69993268aa5b7a$var$isSpaceIgnored(domReference)) return;
                if (event.key === " " && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        toggle
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $3f69993268aa5b7a$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === "x" || data.axis === "both";
            const isYAxis = data.axis === "y" || data.axis === "both";
            const canTrackCursorOnAutoUpdate = [
                "mouseenter",
                "mousemove"
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || "") && data.pointerType !== "touch";
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === "y" ? domRect.width : 0;
                height = data.axis === "x" ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === "x" ? domRect.height : height;
                width = data.axis === "y" ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $3f69993268aa5b7a$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $3f69993268aa5b7a$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = "both", x: x = null, y: y = null } = props;
    const initialRef = $acw62.useRef(false);
    const cleanupListenerRef = $acw62.useRef(null);
    const [pointerType, setPointerType] = $acw62.useState();
    const [reactive, setReactive] = $acw62.useState([]);
    const setReference = $3f69993268aa5b7a$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$3f69993268aa5b7a$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($3f69993268aa5b7a$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $4wHOx.isMouseLikePointerType)(pointerType) ? floating : open;
    const addListener = $acw62.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $33bLr.getWindow)(floating);
        function handleMouseMove(event) {
            const target = (0, $4wHOx.getTarget)(event);
            if (!(0, $4wHOx.contains)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $3f69993268aa5b7a$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener("mousemove", handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $acw62.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $acw62.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $acw62.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $acw62.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $3f69993268aa5b7a$var$bubbleHandlerKeys = {
    pointerdown: "onPointerDown",
    mousedown: "onMouseDown",
    click: "onClick"
};
const $3f69993268aa5b7a$var$captureHandlerKeys = {
    pointerdown: "onPointerDownCapture",
    mousedown: "onMouseDownCapture",
    click: "onClickCapture"
};
const $3f69993268aa5b7a$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === "boolean" ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === "boolean" ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $3f69993268aa5b7a$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = "pointerdown", referencePress: referencePress = false, referencePressEvent: referencePressEvent = "pointerdown", ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const outsidePressFn = $3f69993268aa5b7a$var$useEffectEvent(typeof unstable_outsidePress === "function" ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $acw62.useRef(false);
    const endedOrStartedInsideRef = $acw62.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $3f69993268aa5b7a$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $3f69993268aa5b7a$var$normalizeProp(capture);
    const isComposingRef = $acw62.useRef(false);
    const closeOnEscapeKeyDown = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== "Escape") return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $4wHOx.isReactEvent)(event) ? event.nativeEvent : event, "escape-key");
    });
    const closeOnEscapeKeyDownCapture = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $4wHOx.getTarget)(event)) == null || _getTarget.removeEventListener("keydown", callback);
        };
        (_getTarget2 = (0, $4wHOx.getTarget)(event)) == null || _getTarget2.addEventListener("keydown", callback);
    });
    const closeOnPressOutside = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === "click" && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === "function" && !outsidePress(event)) return;
        const target = (0, $4wHOx.getTarget)(event);
        const inertSelector = "[" + $3f69993268aa5b7a$var$createAttribute("inert") + "]";
        const markers = (0, $4wHOx.getDocument)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $33bLr.isElement)(target) ? target : null;
        while(targetRootAncestor && !(0, $33bLr.isLastTraversableNode)(targetRootAncestor)){
            const nextParent = (0, $33bLr.getParentNode)(targetRootAncestor);
            if ((0, $33bLr.isLastTraversableNode)(nextParent) || !(0, $33bLr.isElement)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $33bLr.isElement)(target) && !(0, $4wHOx.isRootElement)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $4wHOx.contains)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $4wHOx.contains)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $33bLr.isHTMLElement)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = (0, $33bLr.getComputedStyle)(target).direction === "rtl";
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $4wHOx.isEventTargetWithin)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $4wHOx.isEventTargetWithin)(event, elements.floating) || (0, $4wHOx.isEventTargetWithin)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, "outside-press");
    });
    const closeOnPressOutsideCapture = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $4wHOx.getTarget)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $4wHOx.getTarget)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $acw62.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, "ancestor-scroll");
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $33bLr.isWebKit)() ? 5 : 0);
        }
        const doc = (0, $4wHOx.getDocument)(elements.floating);
        if (escapeKey) {
            doc.addEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener("compositionstart", handleCompositionStart);
            doc.addEventListener("compositionend", handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $33bLr.isElement)(elements.domReference)) ancestors = (0, $33bLr.getOverflowAncestors)(elements.domReference);
            if ((0, $33bLr.isElement)(elements.floating)) ancestors = ancestors.concat((0, $33bLr.getOverflowAncestors)(elements.floating));
            if (!(0, $33bLr.isElement)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $33bLr.getOverflowAncestors)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener("scroll", onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener("compositionstart", handleCompositionStart);
                doc.removeEventListener("compositionend", handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener("scroll", onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $acw62.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $acw62.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            [$3f69993268aa5b7a$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                if (referencePress) onOpenChange(false, event.nativeEvent, "reference-press");
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $acw62.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [$3f69993268aa5b7a$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                insideReactTreeRef.current = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $3f69993268aa5b7a$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $3f69993268aa5b7a$export$f680877a34711e37();
    const dataRef = $acw62.useRef({});
    const [events] = $acw62.useState(()=>$3f69993268aa5b7a$var$createPubSub());
    const nested = $3f69993268aa5b7a$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $acw62.useState(elementsProp.reference);
    const onOpenChange = $3f69993268aa5b7a$var$useEffectEvent((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit("openchange", {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $acw62.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $acw62.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $acw62.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $3f69993268aa5b7a$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $3f69993268aa5b7a$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $acw62.useState(null);
    const [positionReference, _setPositionReference] = $acw62.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $acw62.useRef(null);
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    $3f69993268aa5b7a$var$index(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $33OG6.useFloating)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $acw62.useCallback((node)=>{
        const computedPositionReference = (0, $33bLr.isElement)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $acw62.useCallback((node)=>{
        if ((0, $33bLr.isElement)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $33bLr.isElement)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $33bLr.isElement)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $acw62.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $acw62.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $acw62.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $acw62.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $3f69993268aa5b7a$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $acw62.useRef(false);
    const timeoutRef = $acw62.useRef();
    const keyboardModalityRef = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $33bLr.getWindow)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $33bLr.isHTMLElement)(elements.domReference) && elements.domReference === (0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener("blur", onBlur);
        win.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            win.removeEventListener("blur", onBlur);
            win.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === "reference-press" || reason === "escape-key") blockFocusRef.current = true;
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const reference = $acw62.useMemo(()=>({
            onPointerDown (event) {
                if ((0, $4wHOx.isVirtualPointerEvent)(event.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $4wHOx.getTarget)(event.nativeEvent);
                if (visibleOnly && (0, $33bLr.isElement)(target)) try {
                    // Mac Safari unreliably matches `:focus-visible` on the reference
                    // if focus was outside the page initially - use the fallback
                    // instead.
                    if ((0, $4wHOx.isSafari)() && (0, $4wHOx.isMac)()) throw Error();
                    if (!target.matches(":focus-visible")) return;
                } catch (e) {
                    // Old browsers will throw an error when using `:focus-visible`.
                    if (!keyboardModalityRef.current && !(0, $4wHOx.isTypeableElement)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, "focus");
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $33bLr.isElement)(relatedTarget) && relatedTarget.hasAttribute($3f69993268aa5b7a$var$createAttribute("focus-guard")) && relatedTarget.getAttribute("data-type") === "outside";
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $4wHOx.activeElement)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $4wHOx.contains)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $4wHOx.contains)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, "focus");
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $3f69993268aa5b7a$var$ACTIVE_KEY = "active";
const $3f69993268aa5b7a$var$SELECTED_KEY = "selected";
function $3f69993268aa5b7a$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === "item";
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$3f69993268aa5b7a$var$ACTIVE_KEY]: _, [$3f69993268aa5b7a$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === "floating" && {
            tabIndex: -1,
            [$3f69993268aa5b7a$var$FOCUSABLE_ATTRIBUTE]: ""
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === "function") return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $3f69993268aa5b7a$var$ACTIVE_KEY,
                    $3f69993268aa5b7a$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf("on") === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === "function") {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $3f69993268aa5b7a$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, "reference"), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, "floating"), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, "item"), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $acw62.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $3f69993268aa5b7a$var$isPreventScrollSupported = false;
function $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case "vertical":
            return vertical;
        case "horizontal":
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $3f69993268aa5b7a$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $3f69993268aa5b7a$var$ARROW_UP || key === $3f69993268aa5b7a$var$ARROW_DOWN;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_LEFT || key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
function $3f69993268aa5b7a$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $3f69993268aa5b7a$var$ARROW_DOWN;
    const horizontal = rtl ? key === $3f69993268aa5b7a$var$ARROW_LEFT : key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal) || key === "Enter" || key === " " || key === "";
}
function $3f69993268aa5b7a$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $3f69993268aa5b7a$var$ARROW_LEFT : key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_DOWN;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
function $3f69993268aa5b7a$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $3f69993268aa5b7a$var$ARROW_RIGHT : key === $3f69993268aa5b7a$var$ARROW_LEFT;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_UP;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $3f69993268aa5b7a$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = "auto", focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = "vertical", cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = $3f69993268aa5b7a$var$getFloatingFocusElement(elements.floating);
    const floatingFocusElementRef = $3f69993268aa5b7a$var$useLatestRef(floatingFocusElement);
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const onNavigate = $3f69993268aa5b7a$var$useEffectEvent(unstable_onNavigate);
    const typeableComboboxReference = (0, $4wHOx.isTypeableCombobox)(elements.domReference);
    const focusItemOnOpenRef = $acw62.useRef(focusItemOnOpen);
    const indexRef = $acw62.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $acw62.useRef(null);
    const isPointerModalityRef = $acw62.useRef(true);
    const previousOnNavigateRef = $acw62.useRef(onNavigate);
    const previousMountedRef = $acw62.useRef(!!elements.floating);
    const previousOpenRef = $acw62.useRef(open);
    const forceSyncFocus = $acw62.useRef(false);
    const forceScrollIntoViewRef = $acw62.useRef(false);
    const disabledIndicesRef = $3f69993268aa5b7a$var$useLatestRef(disabledIndices);
    const latestOpenRef = $3f69993268aa5b7a$var$useLatestRef(open);
    const scrollItemIntoViewRef = $3f69993268aa5b7a$var$useLatestRef(scrollItemIntoView);
    const selectedIndexRef = $3f69993268aa5b7a$var$useLatestRef(selectedIndex);
    const [activeId, setActiveId] = $acw62.useState();
    const [virtualId, setVirtualId] = $acw62.useState();
    const focusItem = $3f69993268aa5b7a$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        function runFocus(item) {
            if (virtual) {
                setActiveId(item.id);
                tree == null || tree.events.emit("virtualfocus", item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $3f69993268aa5b7a$var$enqueueFocus(item, {
                preventScroll: true,
                // Mac Safari does not move the virtual cursor unless the focus call
                // is sync. However, for the very first focus call, we need to wait
                // for the position to be ready in order to prevent unwanted
                // scrolling. This means the virtual cursor will not move to the first
                // item when first opening the floating element, but will on
                // subsequent calls. `preventScroll` is supported in modern Safari,
                // so we can use that instead.
                // iOS Safari must be async or the first item will not be focused.
                sync: (0, $4wHOx.isMac)() && (0, $4wHOx.isSafari)() ? $3f69993268aa5b7a$var$isPreventScrollSupported || forceSyncFocus.current : false
            });
        }
        const initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        requestAnimationFrame(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === "boolean" ? {
                block: "nearest",
                inline: "nearest"
            } : scrollIntoViewOptions);
        });
    });
    $3f69993268aa5b7a$var$index(()=>{
        document.createElement("div").focus({
            get preventScroll () {
                $3f69993268aa5b7a$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndexRef.current != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $3f69993268aa5b7a$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndicesRef.current) : $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $3f69993268aa5b7a$var$index(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $4wHOx.contains)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on("virtualfocus", handleVirtualFocus);
        return ()=>{
            tree.events.off("virtualfocus", handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!elements.floating;
    });
    $3f69993268aa5b7a$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        previousOpenRef.current = open;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $acw62.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === "touch") return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $3f69993268aa5b7a$var$enqueueFocus(floatingFocusElementRef.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        floatingFocusElementRef,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const commonOnKeyDown = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocus.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $3f69993268aa5b7a$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
            (0, $4wHOx.stopEvent)(event);
            onOpenChange(false, event.nativeEvent, "list-navigation");
            if ((0, $33bLr.isHTMLElement)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit("virtualfocus", elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndices);
        const maxIndex = $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === "Home") {
                (0, $4wHOx.stopEvent)(event);
                indexRef.current = minIndex;
                onNavigate(indexRef.current);
            }
            if (event.key === "End") {
                (0, $4wHOx.stopEvent)(event);
                indexRef.current = maxIndex;
                onNavigate(indexRef.current);
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $3f69993268aa5b7a$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$3f69993268aa5b7a$var$isDisabled(listRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$3f69993268aa5b7a$var$isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[$3f69993268aa5b7a$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $3f69993268aa5b7a$var$getCellIndices([
                    ...disabledIndices || listRef.current.map((_, index)=>$3f69993268aa5b7a$var$isDisabled(listRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $3f69993268aa5b7a$var$getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $3f69993268aa5b7a$var$ARROW_DOWN ? "bl" : event.key === $3f69993268aa5b7a$var$ARROW_RIGHT ? "tr" : "tl"),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate(indexRef.current);
            }
            if (orientation === "both") return;
        }
        if ($3f69993268aa5b7a$var$isMainOrientationKey(event.key, orientation)) {
            (0, $4wHOx.stopEvent)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $4wHOx.activeElement)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $3f69993268aa5b7a$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(indexRef.current);
                return;
            }
            if ($3f69993268aa5b7a$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ($3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
            else onNavigate(indexRef.current);
        }
    });
    const ariaActiveDescendantProp = $acw62.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            "aria-activedescendant": virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $acw62.useMemo(()=>{
        return {
            "aria-orientation": orientation === "both" ? undefined : orientation,
            ...!(0, $4wHOx.isTypeableCombobox)(elements.domReference) && ariaActiveDescendantProp,
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        elements.domReference,
        orientation
    ]);
    const reference = $acw62.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === "auto" && (0, $4wHOx.isVirtualClick)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === "auto" && (0, $4wHOx.isVirtualPointerEvent)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith("Arrow");
                const isHomeOrEndKey = [
                    "Home",
                    "End"
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $3f69993268aa5b7a$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $3f69993268aa5b7a$var$isCrossOrientationCloseKey(event.key, orientation, rtl);
                const isMainKey = $3f69993268aa5b7a$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === "Enter" || event.key.trim() === "";
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? $3f69993268aa5b7a$var$getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent("keydown", {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $4wHOx.stopEvent)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $4wHOx.stopEvent)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        (0, $4wHOx.stopEvent)(event);
                        if (open) {
                            indexRef.current = $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndicesRef.current);
                            onNavigate(indexRef.current);
                        } else onOpenChange(true, event.nativeEvent, "list-navigation");
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $4wHOx.stopEvent)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, "list-navigation");
                    else commonOnKeyDown(event);
                    if (open) onNavigate(indexRef.current);
                }
            },
            onFocus () {
                if (open && !virtual) onNavigate(null);
            },
            onPointerDown: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $3f69993268aa5b7a$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        "select",
        "listbox"
    ],
    [
        "combobox",
        "listbox"
    ],
    [
        "label",
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $3f69993268aa5b7a$export$f66572793fa256a1(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = "dialog" } = props;
    const ariaRole = (_componentRoleToAriaR = $3f69993268aa5b7a$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const referenceId = $3f69993268aa5b7a$export$f680877a34711e37();
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $acw62.useMemo(()=>{
        if (ariaRole === "tooltip" || role === "label") return {
            ["aria-" + (role === "label" ? "labelledby" : "describedby")]: open ? floatingId : undefined
        };
        return {
            "aria-expanded": open ? "true" : "false",
            "aria-haspopup": ariaRole === "alertdialog" ? "dialog" : ariaRole,
            "aria-controls": open ? floatingId : undefined,
            ...ariaRole === "listbox" && {
                role: "combobox"
            },
            ...ariaRole === "menu" && {
                id: referenceId
            },
            ...ariaRole === "menu" && isNested && {
                role: "menuitem"
            },
            ...role === "select" && {
                "aria-autocomplete": "none"
            },
            ...role === "combobox" && {
                "aria-autocomplete": "list"
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $acw62.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === "tooltip" || role === "label") return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === "menu" && {
                "aria-labelledby": referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $acw62.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: "option",
            ...active && {
                id: floatingId + "-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case "select":
                return {
                    ...commonProps,
                    "aria-selected": active && selected
                };
            case "combobox":
                return {
                    ...commonProps,
                    ...active && {
                        "aria-selected": true
                    }
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $3f69993268aa5b7a$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? "-" : "") + $.toLowerCase());
function $3f69993268aa5b7a$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === "function" ? valueOrFn(args) : valueOrFn;
}
function $3f69993268aa5b7a$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $acw62.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $acw62.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $3f69993268aa5b7a$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === "number";
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $acw62.useState("unmounted");
    const isMounted = $3f69993268aa5b7a$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === "close") setStatus("unmounted");
    $3f69993268aa5b7a$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus("initial");
            const frame = requestAnimationFrame(()=>{
                setStatus("open");
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus("close");
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $3f69993268aa5b7a$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split("-")[0];
    const fnArgs = $acw62.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === "number";
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $acw62.useState(()=>({
            ...$3f69993268aa5b7a$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$3f69993268aa5b7a$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $3f69993268aa5b7a$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $3f69993268aa5b7a$var$useLatestRef(unstable_initial);
    const openRef = $3f69993268aa5b7a$var$useLatestRef(unstable_open);
    const closeRef = $3f69993268aa5b7a$var$useLatestRef(unstable_close);
    const commonRef = $3f69993268aa5b7a$var$useLatestRef(unstable_common);
    $3f69993268aa5b7a$var$index(()=>{
        const initialStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = "";
            return acc;
        }, {});
        if (status === "initial") setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === "open") setStyles({
            transitionProperty: Object.keys(openStyles).map($3f69993268aa5b7a$var$camelCaseToKebabCase).join(","),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === "close") {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($3f69993268aa5b7a$var$camelCaseToKebabCase).join(","),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $3f69993268aa5b7a$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $acw62.useRef();
    const stringRef = $acw62.useRef("");
    const prevIndexRef = $acw62.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $acw62.useRef(null);
    const onMatch = $3f69993268aa5b7a$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $3f69993268aa5b7a$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $3f69993268aa5b7a$var$useLatestRef(findMatch);
    const ignoreKeysRef = $3f69993268aa5b7a$var$useLatestRef(ignoreKeys);
    $3f69993268aa5b7a$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = "";
        }
    }, [
        open
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === "") {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = $3f69993268aa5b7a$var$useEffectEvent((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== " ") {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === " ") (0, $4wHOx.stopEvent)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== " ") {
            (0, $4wHOx.stopEvent)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(()=>{
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== " ") {
            stringRef.current = "";
            setTypingChange(false);
        }
    });
    const reference = $acw62.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $acw62.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === " ") setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $3f69993268aa5b7a$export$4ae363f1d88fb658 = (props)=>({
        name: "inner",
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(props, state);
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $33OG6.offset)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await (0, $618j3.detectOverflow)($3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await (0, $618j3.detectOverflow)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: "reference"
            });
            const diffY = (0, $1obCQ.max)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $1obCQ.round);
            const maxHeight = rounder((0, $1obCQ.max)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $1obCQ.max)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $1obCQ.min)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $1u0KT.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await (0, $618j3.detectOverflow)($3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $3f69993268aa5b7a$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $3f69993268aa5b7a$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $acw62.useRef(false);
    const prevScrollTopRef = $acw62.useRef(null);
    const initialOverflowRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? "max" : "min";
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $1u0KT.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $4wHOx.getUserAgent)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener("wheel", onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener("wheel", onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $acw62.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $1u0KT.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $acw62.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $3f69993268aa5b7a$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $3f69993268aa5b7a$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $3f69993268aa5b7a$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = (0, $4wHOx.getTarget)(event);
            const isLeave = event.type === "mouseleave";
            const isOverFloatingEl = (0, $4wHOx.contains)(elements.floating, target);
            const isOverReferenceEl = (0, $4wHOx.contains)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split("-")[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $3f69993268aa5b7a$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $33bLr.isElement)(event.relatedTarget) && (0, $4wHOx.contains)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === "top" && y >= refRect.bottom - 1 || side === "bottom" && y <= refRect.top + 1 || side === "left" && x >= refRect.right - 1 || side === "right" && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case "top":
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case "bottom":
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case "left":
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case "right":
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case "top":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "bottom":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "left":
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case "right":
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($3f69993268aa5b7a$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$3f69993268aa5b7a$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}

});
parcelRegister("4wHOx", function(module, exports) {

$parcel$export(module.exports, "activeElement", () => $34bc2325b4db944b$export$da980962bd2147a4);
$parcel$export(module.exports, "contains", () => $34bc2325b4db944b$export$2344b14b097df817);
$parcel$export(module.exports, "getPlatform", () => $34bc2325b4db944b$export$867a782338812cb4);
$parcel$export(module.exports, "getUserAgent", () => $34bc2325b4db944b$export$7935961ef7719cb0);
$parcel$export(module.exports, "isVirtualClick", () => $34bc2325b4db944b$export$60278871457622de);
$parcel$export(module.exports, "isVirtualPointerEvent", () => $34bc2325b4db944b$export$29bf1b5f2c56cf63);
$parcel$export(module.exports, "isSafari", () => $34bc2325b4db944b$export$95df08bae54cb4df);
$parcel$export(module.exports, "isMac", () => $34bc2325b4db944b$export$9ac100e40613ea10);
$parcel$export(module.exports, "isMouseLikePointerType", () => $34bc2325b4db944b$export$81cf264172d31e51);
$parcel$export(module.exports, "isReactEvent", () => $34bc2325b4db944b$export$94781ce41a161222);
$parcel$export(module.exports, "isRootElement", () => $34bc2325b4db944b$export$7b296c28e0fa3aed);
$parcel$export(module.exports, "getDocument", () => $34bc2325b4db944b$export$f65ca476c09acec0);
$parcel$export(module.exports, "isEventTargetWithin", () => $34bc2325b4db944b$export$43c3154d5bf2c6c2);
$parcel$export(module.exports, "getTarget", () => $34bc2325b4db944b$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isTypeableElement", () => $34bc2325b4db944b$export$42ad131c32f0fb8d);
$parcel$export(module.exports, "stopEvent", () => $34bc2325b4db944b$export$7ae4cd3a66c1e050);
$parcel$export(module.exports, "isTypeableCombobox", () => $34bc2325b4db944b$export$259ba5ae38188551);

var $33bLr = parcelRequire("33bLr");
function $34bc2325b4db944b$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $34bc2325b4db944b$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $33bLr.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function $34bc2325b4db944b$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $34bc2325b4db944b$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(" ");
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $34bc2325b4db944b$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($34bc2325b4db944b$export$a11b0059900ceec8() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $34bc2325b4db944b$export$29bf1b5f2c56cf63(event) {
    if ($34bc2325b4db944b$export$c8f880a2d81914c4()) return false;
    return !$34bc2325b4db944b$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $34bc2325b4db944b$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "touch";
}
function $34bc2325b4db944b$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $34bc2325b4db944b$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($34bc2325b4db944b$export$867a782338812cb4()) || re.test($34bc2325b4db944b$export$7935961ef7719cb0());
}
function $34bc2325b4db944b$export$9ac100e40613ea10() {
    return $34bc2325b4db944b$export$867a782338812cb4().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function $34bc2325b4db944b$export$c8f880a2d81914c4() {
    return $34bc2325b4db944b$export$7935961ef7719cb0().includes("jsdom/");
}
function $34bc2325b4db944b$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        "mouse",
        "pen"
    ];
    if (!strict) values.push("", undefined);
    return values.includes(pointerType);
}
function $34bc2325b4db944b$export$94781ce41a161222(event) {
    return "nativeEvent" in event;
}
function $34bc2325b4db944b$export$7b296c28e0fa3aed(element) {
    return element.matches("html,body");
}
function $34bc2325b4db944b$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $34bc2325b4db944b$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ("composedPath" in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $34bc2325b4db944b$export$c22522a4dfa48e9c(event) {
    if ("composedPath" in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $34bc2325b4db944b$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $34bc2325b4db944b$export$42ad131c32f0fb8d(element) {
    return (0, $33bLr.isHTMLElement)(element) && element.matches($34bc2325b4db944b$export$78b3d091ff376bc);
}
function $34bc2325b4db944b$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $34bc2325b4db944b$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute("role") === "combobox" && $34bc2325b4db944b$export$42ad131c32f0fb8d(element);
}

});

parcelRegister("e8HHX", function(module, exports) {

$parcel$export(module.exports, "tabbable", () => $a4b3b7902c9a987d$export$17100aea90429aa7);
$parcel$export(module.exports, "isTabbable", () => $a4b3b7902c9a987d$export$bebd5a1431fec25d);
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $a4b3b7902c9a987d$var$candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var $a4b3b7902c9a987d$var$candidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.join(",");
var $a4b3b7902c9a987d$var$NoElement = typeof Element === "undefined";
var $a4b3b7902c9a987d$var$matches = $a4b3b7902c9a987d$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $a4b3b7902c9a987d$var$getRootNode = !$a4b3b7902c9a987d$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $a4b3b7902c9a987d$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($a4b3b7902c9a987d$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($a4b3b7902c9a987d$var$candidateSelector));
    if (includeContainer && $a4b3b7902c9a987d$var$matches.call(el, $a4b3b7902c9a987d$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $a4b3b7902c9a987d$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($a4b3b7902c9a987d$var$isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $a4b3b7902c9a987d$var$matches.call(element, $a4b3b7902c9a987d$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$a4b3b7902c9a987d$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $a4b3b7902c9a987d$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $a4b3b7902c9a987d$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $a4b3b7902c9a987d$var$isContentEditable(node)) && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $a4b3b7902c9a987d$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $a4b3b7902c9a987d$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $a4b3b7902c9a987d$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $a4b3b7902c9a987d$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $a4b3b7902c9a987d$var$isHiddenInput = function isHiddenInput(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === "hidden";
};
var $a4b3b7902c9a987d$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $a4b3b7902c9a987d$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $a4b3b7902c9a987d$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $a4b3b7902c9a987d$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $a4b3b7902c9a987d$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $a4b3b7902c9a987d$var$isRadio = function isRadio(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === "radio";
};
var $a4b3b7902c9a987d$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $a4b3b7902c9a987d$var$isRadio(node) && !$a4b3b7902c9a987d$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $a4b3b7902c9a987d$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $a4b3b7902c9a987d$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $a4b3b7902c9a987d$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $a4b3b7902c9a987d$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $a4b3b7902c9a987d$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $a4b3b7902c9a987d$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($a4b3b7902c9a987d$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $a4b3b7902c9a987d$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $a4b3b7902c9a987d$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($a4b3b7902c9a987d$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $a4b3b7902c9a987d$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $a4b3b7902c9a987d$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $a4b3b7902c9a987d$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $a4b3b7902c9a987d$var$isInert(node) || $a4b3b7902c9a987d$var$isHiddenInput(node) || $a4b3b7902c9a987d$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $a4b3b7902c9a987d$var$isDetailsWithSummary(node) || $a4b3b7902c9a987d$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($a4b3b7902c9a987d$var$isNonTabbableRadio(node) || $a4b3b7902c9a987d$export$a4672efddb4181b8(node) < 0 || !$a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $a4b3b7902c9a987d$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $a4b3b7902c9a987d$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($a4b3b7902c9a987d$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $a4b3b7902c9a987d$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $a4b3b7902c9a987d$var$isValidShadowRootTabbable
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $a4b3b7902c9a987d$var$sortByOrder(candidates);
};
var $a4b3b7902c9a987d$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $a4b3b7902c9a987d$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$candidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable(options, node);
};
var $a4b3b7902c9a987d$var$focusableCandidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.concat("iframe").join(",");
var $a4b3b7902c9a987d$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$focusableCandidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node);
};

});



parcelRegister("auuNT", function(module, exports) {

$parcel$export(module.exports, "State", () => $7a3499b4b3c6f184$export$7254cc27399e90bd);
$parcel$export(module.exports, "useOpenClosed", () => $7a3499b4b3c6f184$export$fc6fdf0ecf360e);
$parcel$export(module.exports, "OpenClosedProvider", () => $7a3499b4b3c6f184$export$2a0ed818b175f558);
$parcel$export(module.exports, "ResetOpenClosedProvider", () => $7a3499b4b3c6f184$export$6748feed729c7cf3);

var $acw62 = parcelRequire("acw62");
let $7a3499b4b3c6f184$var$n = (0, $acw62.createContext)(null);
$7a3499b4b3c6f184$var$n.displayName = "OpenClosedContext";
var $7a3499b4b3c6f184$export$7254cc27399e90bd = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($7a3499b4b3c6f184$export$7254cc27399e90bd || {});
function $7a3499b4b3c6f184$export$fc6fdf0ecf360e() {
    return (0, $acw62.useContext)($7a3499b4b3c6f184$var$n);
}
function $7a3499b4b3c6f184$export$2a0ed818b175f558({ value: o, children: t }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7a3499b4b3c6f184$var$n.Provider, {
        value: o
    }, t);
}
function $7a3499b4b3c6f184$export$6748feed729c7cf3({ children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7a3499b4b3c6f184$var$n.Provider, {
        value: null
    }, o);
}

});

parcelRegister("5fYEB", function(module, exports) {

$parcel$export(module.exports, "isDisabledReactIssue7711", () => $3d3d670dbe2ceed6$export$db61f031a278447c);
function $3d3d670dbe2ceed6$export$db61f031a278447c(n) {
    let e = n.parentElement, l = null;
    for(; e && !(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
    let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return t && $3d3d670dbe2ceed6$var$i(l) ? !1 : t;
}
function $3d3d670dbe2ceed6$var$i(n) {
    if (!n) return !1;
    let e = n.previousElementSibling;
    for(; e !== null;){
        if (e instanceof HTMLLegendElement) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}

});

parcelRegister("fLrGx", function(module, exports) {

$parcel$export(module.exports, "Focus", () => $b7a0b87cd8a0fa3d$export$807a7eae502106e7);
$parcel$export(module.exports, "calculateActiveIndex", () => $b7a0b87cd8a0fa3d$export$c6b4626b54936d5e);
function $b7a0b87cd8a0fa3d$var$u(l) {
    throw new Error("Unexpected object: " + l);
}
var $b7a0b87cd8a0fa3d$export$807a7eae502106e7 = ((i)=>(i[i.First = 0] = "First", i[i.Previous = 1] = "Previous", i[i.Next = 2] = "Next", i[i.Last = 3] = "Last", i[i.Specific = 4] = "Specific", i[i.Nothing = 5] = "Nothing", i))($b7a0b87cd8a0fa3d$export$807a7eae502106e7 || {});
function $b7a0b87cd8a0fa3d$export$c6b4626b54936d5e(l, n) {
    let t = n.resolveItems();
    if (t.length <= 0) return null;
    let r = n.resolveActiveIndex(), s = r != null ? r : -1;
    switch(l.focus){
        case 0:
            for(let e = 0; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 1:
            s === -1 && (s = t.length);
            for(let e = s - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 2:
            for(let e = s + 1; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 3:
            for(let e = t.length - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 4:
            for(let e = 0; e < t.length; ++e)if (n.resolveId(t[e], e, t) === l.id) return e;
            return r;
        case 5:
            return null;
        default:
            $b7a0b87cd8a0fa3d$var$u(l);
    }
}

});

parcelRegister("ebRQH", function(module, exports) {

$parcel$export(module.exports, "RenderFeatures", () => $a54bdd13402af126$export$ba0ea3f20e7bf777);
$parcel$export(module.exports, "RenderStrategy", () => $a54bdd13402af126$export$80c0a745e59f7989);
$parcel$export(module.exports, "useRender", () => $a54bdd13402af126$export$e25bb1e5b53cbdff);
$parcel$export(module.exports, "compact", () => $a54bdd13402af126$export$8e16b83750b44988);
$parcel$export(module.exports, "mergeProps", () => $a54bdd13402af126$export$9d1611c77c2fe928);
$parcel$export(module.exports, "forwardRefWithAs", () => $a54bdd13402af126$export$e43f39796049410c);

var $acw62 = parcelRequire("acw62");

var $4Mkm0 = parcelRequire("4Mkm0");

var $6Ngq1 = parcelRequire("6Ngq1");
var $a54bdd13402af126$export$ba0ea3f20e7bf777 = ((a)=>(a[a.None = 0] = "None", a[a.RenderStrategy = 1] = "RenderStrategy", a[a.Static = 2] = "Static", a))($a54bdd13402af126$export$ba0ea3f20e7bf777 || {}), $a54bdd13402af126$export$80c0a745e59f7989 = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))($a54bdd13402af126$export$80c0a745e59f7989 || {});
function $a54bdd13402af126$export$e25bb1e5b53cbdff() {
    let r = $a54bdd13402af126$var$C();
    return (0, $acw62.useCallback)((n)=>$a54bdd13402af126$var$A({
            mergeRefs: r,
            ...n
        }), [
        r
    ]);
}
function $a54bdd13402af126$var$A({ ourProps: r, theirProps: n, slot: e, defaultTag: a, features: s, visible: t = !0, name: l, mergeRefs: i }) {
    i = i != null ? i : $a54bdd13402af126$var$U;
    let o = $a54bdd13402af126$var$P(n, r);
    if (t) return $a54bdd13402af126$var$R(o, e, a, l, i);
    let y = s != null ? s : 0;
    if (y & 2) {
        let { static: f = !1, ...u } = o;
        if (f) return $a54bdd13402af126$var$R(u, e, a, l, i);
    }
    if (y & 1) {
        let { unmount: f = !0, ...u } = o;
        return (0, $6Ngq1.match)(f ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return $a54bdd13402af126$var$R({
                    ...u,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, e, a, l, i);
            }
        });
    }
    return $a54bdd13402af126$var$R(o, e, a, l, i);
}
function $a54bdd13402af126$var$R(r, n = {}, e, a, s) {
    let { as: t = e, children: l, refName: i = "ref", ...o } = $a54bdd13402af126$var$h(r, [
        "unmount",
        "static"
    ]), y = r.ref !== void 0 ? {
        [i]: r.ref
    } : {}, f = typeof l == "function" ? l(n) : l;
    "className" in o && o.className && typeof o.className == "function" && (o.className = o.className(n)), o["aria-labelledby"] && o["aria-labelledby"] === o.id && (o["aria-labelledby"] = void 0);
    let u = {};
    if (n) {
        let d = !1, p = [];
        for (let [c, T] of Object.entries(n))typeof T == "boolean" && (d = !0), T === !0 && p.push(c.replace(/([A-Z])/g, (g)=>`-${g.toLowerCase()}`));
        if (d) {
            u["data-headlessui-state"] = p.join(" ");
            for (let c of p)u[`data-${c}`] = "";
        }
    }
    if (t === (0, $acw62.Fragment) && (Object.keys($a54bdd13402af126$export$8e16b83750b44988(o)).length > 0 || Object.keys($a54bdd13402af126$export$8e16b83750b44988(u)).length > 0)) {
        if (!(0, $acw62.isValidElement)(f) || Array.isArray(f) && f.length > 1) {
            if (Object.keys($a54bdd13402af126$export$8e16b83750b44988(o)).length > 0) throw new Error([
                'Passing props on "Fragment"!',
                "",
                `The current component <${a} /> is rendering a "Fragment".`,
                "However we need to passthrough the following props:",
                Object.keys($a54bdd13402af126$export$8e16b83750b44988(o)).concat(Object.keys($a54bdd13402af126$export$8e16b83750b44988(u))).map((d)=>`  - ${d}`).join(`
`),
                "",
                "You can apply a few solutions:",
                [
                    'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                    "Render a single element as the child so that we can forward the props onto that element."
                ].map((d)=>`  - ${d}`).join(`
`)
            ].join(`
`));
        } else {
            let d = f.props, p = d == null ? void 0 : d.className, c = typeof p == "function" ? (...F)=>(0, $4Mkm0.classNames)(p(...F), o.className) : (0, $4Mkm0.classNames)(p, o.className), T = c ? {
                className: c
            } : {}, g = $a54bdd13402af126$var$P(f.props, $a54bdd13402af126$export$8e16b83750b44988($a54bdd13402af126$var$h(o, [
                "ref"
            ])));
            for(let F in u)F in g && delete u[F];
            return (0, $acw62.cloneElement)(f, Object.assign({}, g, u, y, {
                ref: s(f.ref, y.ref)
            }, T));
        }
    }
    return (0, $acw62.createElement)(t, Object.assign({}, $a54bdd13402af126$var$h(o, [
        "ref"
    ]), t !== (0, $acw62.Fragment) && y, t !== (0, $acw62.Fragment) && u), f);
}
function $a54bdd13402af126$var$C() {
    let r = (0, $acw62.useRef)([]), n = (0, $acw62.useCallback)((e)=>{
        for (let a of r.current)a != null && (typeof a == "function" ? a(e) : a.current = e);
    }, []);
    return (...e)=>{
        if (!e.every((a)=>a == null)) return r.current = e, n;
    };
}
function $a54bdd13402af126$var$U(...r) {
    return r.every((n)=>n == null) ? void 0 : (n)=>{
        for (let e of r)e != null && (typeof e == "function" ? e(n) : e.current = n);
    };
}
function $a54bdd13402af126$var$P(...r) {
    var a;
    if (r.length === 0) return {};
    if (r.length === 1) return r[0];
    let n = {}, e = {};
    for (let s of r)for(let t in s)t.startsWith("on") && typeof s[t] == "function" ? ((a = e[t]) != null || (e[t] = []), e[t].push(s[t])) : n[t] = s[t];
    if (n.disabled || n["aria-disabled"]) for(let s in e)/^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(s) && (e[s] = [
        (t)=>{
            var l;
            return (l = t == null ? void 0 : t.preventDefault) == null ? void 0 : l.call(t);
        }
    ]);
    for(let s in e)Object.assign(n, {
        [s] (t, ...l) {
            let i = e[s];
            for (let o of i){
                if ((t instanceof Event || (t == null ? void 0 : t.nativeEvent) instanceof Event) && t.defaultPrevented) return;
                o(t, ...l);
            }
        }
    });
    return n;
}
function $a54bdd13402af126$export$9d1611c77c2fe928(...r) {
    var a;
    if (r.length === 0) return {};
    if (r.length === 1) return r[0];
    let n = {}, e = {};
    for (let s of r)for(let t in s)t.startsWith("on") && typeof s[t] == "function" ? ((a = e[t]) != null || (e[t] = []), e[t].push(s[t])) : n[t] = s[t];
    for(let s in e)Object.assign(n, {
        [s] (...t) {
            let l = e[s];
            for (let i of l)i == null || i(...t);
        }
    });
    return n;
}
function $a54bdd13402af126$export$e43f39796049410c(r) {
    var n;
    return Object.assign((0, $acw62.forwardRef)(r), {
        displayName: (n = r.displayName) != null ? n : r.name
    });
}
function $a54bdd13402af126$export$8e16b83750b44988(r) {
    let n = Object.assign({}, r);
    for(let e in n)n[e] === void 0 && delete n[e];
    return n;
}
function $a54bdd13402af126$var$h(r, n = []) {
    let e = Object.assign({}, r);
    for (let a of n)a in e && delete e[a];
    return e;
}

});
parcelRegister("4Mkm0", function(module, exports) {

$parcel$export(module.exports, "classNames", () => $37ab6efe1f53a2e0$export$ce4ab0c55987d1ff);
function $37ab6efe1f53a2e0$export$ce4ab0c55987d1ff(...r) {
    return Array.from(new Set(r.flatMap((n)=>typeof n == "string" ? n.split(" ") : []))).filter(Boolean).join(" ");
}

});


parcelRegister("iGb09", function(module, exports) {

$parcel$export(module.exports, "useDescribedBy", () => $d994aee5798540d7$export$899851af1363628);
$parcel$export(module.exports, "useDescriptions", () => $d994aee5798540d7$export$babde88292020af7);
$parcel$export(module.exports, "Description", () => $d994aee5798540d7$export$393edc798c47379d);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");

var $6mpbl = parcelRequire("6mpbl");

var $brAF4 = parcelRequire("brAF4");

var $ebRQH = parcelRequire("ebRQH");
"use client";
let $d994aee5798540d7$var$a = (0, $acw62.createContext)(null);
$d994aee5798540d7$var$a.displayName = "DescriptionContext";
function $d994aee5798540d7$var$f() {
    let r = (0, $acw62.useContext)($d994aee5798540d7$var$a);
    if (r === null) {
        let e = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(e, $d994aee5798540d7$var$f), e;
    }
    return r;
}
function $d994aee5798540d7$export$899851af1363628() {
    var r, e;
    return (e = (r = (0, $acw62.useContext)($d994aee5798540d7$var$a)) == null ? void 0 : r.value) != null ? e : void 0;
}
function $d994aee5798540d7$export$babde88292020af7() {
    let [r, e] = (0, $acw62.useState)([]);
    return [
        r.length > 0 ? r.join(" ") : void 0,
        (0, $acw62.useMemo)(()=>function(t) {
                let i = (0, $114Mg.useEvent)((n)=>(e((s)=>[
                            ...s,
                            n
                        ]), ()=>e((s)=>{
                            let o = s.slice(), p = o.indexOf(n);
                            return p !== -1 && o.splice(p, 1), o;
                        }))), l = (0, $acw62.useMemo)(()=>({
                        register: i,
                        slot: t.slot,
                        name: t.name,
                        props: t.props,
                        value: t.value
                    }), [
                    i,
                    t.slot,
                    t.name,
                    t.props,
                    t.value
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d994aee5798540d7$var$a.Provider, {
                    value: l
                }, t.children);
            }, [
            e
        ])
    ];
}
let $d994aee5798540d7$var$S = "p";
function $d994aee5798540d7$var$C(r, e) {
    let d = (0, $acw62.useId)(), t = (0, $brAF4.useDisabled)(), { id: i = `headlessui-description-${d}`, ...l } = r, n = $d994aee5798540d7$var$f(), s = (0, $6mpbl.useSyncRefs)(e);
    (0, $8KgIp.useIsoMorphicEffect)(()=>n.register(i), [
        i,
        n.register
    ]);
    let o = t || !1, p = (0, $acw62.useMemo)(()=>({
            ...n.slot,
            disabled: o
        }), [
        n.slot,
        o
    ]), D = {
        ref: s,
        ...n.props,
        id: i
    };
    return (0, $ebRQH.useRender)()({
        ourProps: D,
        theirProps: l,
        slot: p,
        defaultTag: $d994aee5798540d7$var$S,
        name: n.name || "Description"
    });
}
let $d994aee5798540d7$var$_ = (0, $ebRQH.forwardRefWithAs)($d994aee5798540d7$var$C), $d994aee5798540d7$export$393edc798c47379d = Object.assign($d994aee5798540d7$var$_, {});

});
parcelRegister("brAF4", function(module, exports) {

$parcel$export(module.exports, "useDisabled", () => $854ea7886afe8ac8$export$c763bb7a184a0f11);

var $acw62 = parcelRequire("acw62");
let $854ea7886afe8ac8$var$e = (0, $acw62.createContext)(void 0);
function $854ea7886afe8ac8$export$c763bb7a184a0f11() {
    return (0, $acw62.useContext)($854ea7886afe8ac8$var$e);
}
function $854ea7886afe8ac8$export$a4d3bd77f4efe5ad({ value: t, children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($854ea7886afe8ac8$var$e.Provider, {
        value: t
    }, o);
}

});


parcelRegister("6AKlm", function(module, exports) {

$parcel$export(module.exports, "Keys", () => $4cca0dbc68b0507a$export$4b0075e5ea5e1f26);
var $4cca0dbc68b0507a$export$4b0075e5ea5e1f26 = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))($4cca0dbc68b0507a$export$4b0075e5ea5e1f26 || {});

});

parcelRegister("5qg9U", function(module, exports) {

$parcel$export(module.exports, "useLabelContext", () => $3f2bea42b2459559$export$feddbbf47baabdb9);
$parcel$export(module.exports, "useLabelledBy", () => $3f2bea42b2459559$export$1f86aee6764cddb2);
$parcel$export(module.exports, "useLabels", () => $3f2bea42b2459559$export$d6875122194c7b44);
$parcel$export(module.exports, "Label", () => $3f2bea42b2459559$export$b04be29aa201d4f5);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");

var $6mpbl = parcelRequire("6mpbl");

var $brAF4 = parcelRequire("brAF4");

var $jpbxo = parcelRequire("jpbxo");

var $ebRQH = parcelRequire("ebRQH");
"use client";
let $3f2bea42b2459559$var$c = (0, $acw62.createContext)(null);
$3f2bea42b2459559$var$c.displayName = "LabelContext";
function $3f2bea42b2459559$export$feddbbf47baabdb9() {
    let r = (0, $acw62.useContext)($3f2bea42b2459559$var$c);
    if (r === null) {
        let l = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(l, $3f2bea42b2459559$export$feddbbf47baabdb9), l;
    }
    return r;
}
function $3f2bea42b2459559$export$1f86aee6764cddb2(r) {
    var a, e, o;
    let l = (e = (a = (0, $acw62.useContext)($3f2bea42b2459559$var$c)) == null ? void 0 : a.value) != null ? e : void 0;
    return ((o = r == null ? void 0 : r.length) != null ? o : 0) > 0 ? [
        l,
        ...r
    ].filter(Boolean).join(" ") : l;
}
function $3f2bea42b2459559$export$d6875122194c7b44({ inherit: r = !1 } = {}) {
    let l = $3f2bea42b2459559$export$1f86aee6764cddb2(), [a, e] = (0, $acw62.useState)([]), o = r ? [
        l,
        ...a
    ].filter(Boolean) : a;
    return [
        o.length > 0 ? o.join(" ") : void 0,
        (0, $acw62.useMemo)(()=>function(t) {
                let s = (0, $114Mg.useEvent)((i)=>(e((p)=>[
                            ...p,
                            i
                        ]), ()=>e((p)=>{
                            let u = p.slice(), d = u.indexOf(i);
                            return d !== -1 && u.splice(d, 1), u;
                        }))), m = (0, $acw62.useMemo)(()=>({
                        register: s,
                        slot: t.slot,
                        name: t.name,
                        props: t.props,
                        value: t.value
                    }), [
                    s,
                    t.slot,
                    t.name,
                    t.props,
                    t.value
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3f2bea42b2459559$var$c.Provider, {
                    value: m
                }, t.children);
            }, [
            e
        ])
    ];
}
let $3f2bea42b2459559$var$N = "label";
function $3f2bea42b2459559$var$G(r, l) {
    var y;
    let a = (0, $acw62.useId)(), e = $3f2bea42b2459559$export$feddbbf47baabdb9(), o = (0, $jpbxo.useProvidedId)(), g = (0, $brAF4.useDisabled)(), { id: t = `headlessui-label-${a}`, htmlFor: s = o != null ? o : (y = e.props) == null ? void 0 : y.htmlFor, passive: m = !1, ...i } = r, p = (0, $6mpbl.useSyncRefs)(l);
    (0, $8KgIp.useIsoMorphicEffect)(()=>e.register(t), [
        t,
        e.register
    ]);
    let u = (0, $114Mg.useEvent)((L)=>{
        let b = L.currentTarget;
        if (b instanceof HTMLLabelElement && L.preventDefault(), e.props && "onClick" in e.props && typeof e.props.onClick == "function" && e.props.onClick(L), b instanceof HTMLLabelElement) {
            let n = document.getElementById(b.htmlFor);
            if (n) {
                let E = n.getAttribute("disabled");
                if (E === "true" || E === "") return;
                let x = n.getAttribute("aria-disabled");
                if (x === "true" || x === "") return;
                (n instanceof HTMLInputElement && (n.type === "radio" || n.type === "checkbox") || n.role === "radio" || n.role === "checkbox" || n.role === "switch") && n.click(), n.focus({
                    preventScroll: !0
                });
            }
        }
    }), d = g || !1, C = (0, $acw62.useMemo)(()=>({
            ...e.slot,
            disabled: d
        }), [
        e.slot,
        d
    ]), f = {
        ref: p,
        ...e.props,
        id: t,
        htmlFor: s,
        onClick: u
    };
    return m && ("onClick" in f && (delete f.htmlFor, delete f.onClick), "onClick" in i && delete i.onClick), (0, $ebRQH.useRender)()({
        ourProps: f,
        theirProps: i,
        slot: C,
        defaultTag: s ? $3f2bea42b2459559$var$N : "div",
        name: e.name || "Label"
    });
}
let $3f2bea42b2459559$var$U = (0, $ebRQH.forwardRefWithAs)($3f2bea42b2459559$var$G), $3f2bea42b2459559$export$b04be29aa201d4f5 = Object.assign($3f2bea42b2459559$var$U, {});

});
parcelRegister("jpbxo", function(module, exports) {

$parcel$export(module.exports, "useProvidedId", () => $e2094d3f1733ff55$export$6ba3910d268310db);

var $acw62 = parcelRequire("acw62");
let $e2094d3f1733ff55$var$e = (0, $acw62.createContext)(void 0);
function $e2094d3f1733ff55$export$6ba3910d268310db() {
    return (0, $acw62.useContext)($e2094d3f1733ff55$var$e);
}
function $e2094d3f1733ff55$export$6be90bcb437e928f({ id: t, children: r }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e2094d3f1733ff55$var$e.Provider, {
        value: t
    }, r);
}

});


parcelRegister("e9NTc", function(module, exports) {

$parcel$export(module.exports, "useNestedPortals", () => $a4e89ae9835d0556$export$26b8c35244a70b37);
$parcel$export(module.exports, "PortalGroup", () => $a4e89ae9835d0556$export$84c667e5e4409848);
$parcel$export(module.exports, "Portal", () => $a4e89ae9835d0556$export$602eac185826482c);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $114Mg = parcelRequire("114Mg");

var $8KgIp = parcelRequire("8KgIp");

var $3XIoH = parcelRequire("3XIoH");

var $5IEAk = parcelRequire("5IEAk");

var $b8md9 = parcelRequire("b8md9");

var $6mpbl = parcelRequire("6mpbl");

var $aQyzu = parcelRequire("aQyzu");

var $Iy8e1 = parcelRequire("Iy8e1");

var $ebRQH = parcelRequire("ebRQH");
"use client";
function $a4e89ae9835d0556$var$N(u) {
    let r = (0, $aQyzu.usePortalRoot)(), n = (0, $acw62.useContext)($a4e89ae9835d0556$var$v), e = (0, $5IEAk.useOwnerDocument)(u), [o, l] = (0, $acw62.useState)(()=>{
        var t;
        if (!r && n !== null) return (t = n.current) != null ? t : null;
        if ((0, $Iy8e1.env).isServer) return null;
        let p = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (p) return p;
        if (e === null) return null;
        let a = e.createElement("div");
        return a.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(a);
    });
    return (0, $acw62.useEffect)(()=>{
        o !== null && (e != null && e.body.contains(o) || e == null || e.body.appendChild(o));
    }, [
        o,
        e
    ]), (0, $acw62.useEffect)(()=>{
        r || n !== null && l(n.current);
    }, [
        n,
        l,
        r
    ]), o;
}
let $a4e89ae9835d0556$var$M = (0, $acw62.Fragment), $a4e89ae9835d0556$var$S = (0, $ebRQH.forwardRefWithAs)(function(r, n) {
    let e = r, o = (0, $acw62.useRef)(null), l = (0, $6mpbl.useSyncRefs)((0, $6mpbl.optionalRef)((i)=>{
        o.current = i;
    }), n), p = (0, $5IEAk.useOwnerDocument)(o), a = $a4e89ae9835d0556$var$N(o), [t] = (0, $acw62.useState)(()=>{
        var i;
        return (0, $Iy8e1.env).isServer ? null : (i = p == null ? void 0 : p.createElement("div")) != null ? i : null;
    }), s = (0, $acw62.useContext)($a4e89ae9835d0556$var$y), b = (0, $b8md9.useServerHandoffComplete)();
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        !a || !t || a.contains(t) || (t.setAttribute("data-headlessui-portal", ""), a.appendChild(t));
    }, [
        a,
        t
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (t && s) return s.register(t);
    }, [
        s,
        t
    ]), (0, $3XIoH.useOnUnmount)(()=>{
        var i;
        !a || !t || (t instanceof Node && a.contains(t) && a.removeChild(t), a.childNodes.length <= 0 && ((i = a.parentElement) == null || i.removeChild(a)));
    });
    let H = (0, $ebRQH.useRender)();
    return b ? !a || !t ? null : (0, $1u0KT.createPortal)(H({
        ourProps: {
            ref: l
        },
        theirProps: e,
        slot: {},
        defaultTag: $a4e89ae9835d0556$var$M,
        name: "Portal"
    }), t) : null;
});
function $a4e89ae9835d0556$var$j(u, r) {
    let n = (0, $6mpbl.useSyncRefs)(r), { enabled: e = !0, ...o } = u, l = (0, $ebRQH.useRender)();
    return e ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a4e89ae9835d0556$var$S, {
        ...o,
        ref: n
    }) : l({
        ourProps: {
            ref: n
        },
        theirProps: o,
        slot: {},
        defaultTag: $a4e89ae9835d0556$var$M,
        name: "Portal"
    });
}
let $a4e89ae9835d0556$var$W = (0, $acw62.Fragment), $a4e89ae9835d0556$var$v = (0, $acw62.createContext)(null);
function $a4e89ae9835d0556$var$I(u, r) {
    let { target: n, ...e } = u, l = {
        ref: (0, $6mpbl.useSyncRefs)(r)
    }, p = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a4e89ae9835d0556$var$v.Provider, {
        value: n
    }, p({
        ourProps: l,
        theirProps: e,
        defaultTag: $a4e89ae9835d0556$var$W,
        name: "Popover.Group"
    }));
}
let $a4e89ae9835d0556$var$y = (0, $acw62.createContext)(null);
function $a4e89ae9835d0556$export$26b8c35244a70b37() {
    let u = (0, $acw62.useContext)($a4e89ae9835d0556$var$y), r = (0, $acw62.useRef)([]), n = (0, $114Mg.useEvent)((l)=>(r.current.push(l), u && u.register(l), ()=>e(l))), e = (0, $114Mg.useEvent)((l)=>{
        let p = r.current.indexOf(l);
        p !== -1 && r.current.splice(p, 1), u && u.unregister(l);
    }), o = (0, $acw62.useMemo)(()=>({
            register: n,
            unregister: e,
            portals: r
        }), [
        n,
        e,
        r
    ]);
    return [
        r,
        (0, $acw62.useMemo)(()=>function({ children: p }) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a4e89ae9835d0556$var$y.Provider, {
                    value: o
                }, p);
            }, [
            o
        ])
    ];
}
let $a4e89ae9835d0556$var$J = (0, $ebRQH.forwardRefWithAs)($a4e89ae9835d0556$var$j), $a4e89ae9835d0556$export$84c667e5e4409848 = (0, $ebRQH.forwardRefWithAs)($a4e89ae9835d0556$var$I), $a4e89ae9835d0556$export$602eac185826482c = Object.assign($a4e89ae9835d0556$var$J, {
    Group: $a4e89ae9835d0556$export$84c667e5e4409848
});

});
parcelRegister("3XIoH", function(module, exports) {

$parcel$export(module.exports, "useOnUnmount", () => $2e29522f6fc857e9$export$cd059ee7fd0e9f3d);

var $acw62 = parcelRequire("acw62");

var $eJKgu = parcelRequire("eJKgu");

var $114Mg = parcelRequire("114Mg");
function $2e29522f6fc857e9$export$cd059ee7fd0e9f3d(t) {
    let r = (0, $114Mg.useEvent)(t), e = (0, $acw62.useRef)(!1);
    (0, $acw62.useEffect)(()=>(e.current = !1, ()=>{
            e.current = !0, (0, $eJKgu.microTask)(()=>{
                e.current && r();
            });
        }), [
        r
    ]);
}

});

parcelRegister("b8md9", function(module, exports) {

$parcel$export(module.exports, "useServerHandoffComplete", () => $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa);

var $acw62 = parcelRequire("acw62");

var $Iy8e1 = parcelRequire("Iy8e1");
function $81b1abbf8717f9cc$var$s() {
    let r = typeof document == "undefined";
    return "useSyncExternalStore" in $acw62 ? ((o)=>o.useSyncExternalStore)($acw62)(()=>()=>{}, ()=>!1, ()=>!r) : !1;
}
function $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa() {
    let r = $81b1abbf8717f9cc$var$s(), [e, n] = $acw62.useState((0, $Iy8e1.env).isHandoffComplete);
    return e && (0, $Iy8e1.env).isHandoffComplete === !1 && n(!1), $acw62.useEffect(()=>{
        e !== !0 && n(!0);
    }, [
        e
    ]), $acw62.useEffect(()=>(0, $Iy8e1.env).handoff(), []), r ? !1 : e;
}

});

parcelRegister("aQyzu", function(module, exports) {

$parcel$export(module.exports, "usePortalRoot", () => $7e5993dca17d6628$export$6ecd3efa4eebe261);
$parcel$export(module.exports, "ForcePortalRoot", () => $7e5993dca17d6628$export$8f2af6644e3a3c93);

var $acw62 = parcelRequire("acw62");
let $7e5993dca17d6628$var$e = (0, $acw62.createContext)(!1);
function $7e5993dca17d6628$export$6ecd3efa4eebe261() {
    return (0, $acw62.useContext)($7e5993dca17d6628$var$e);
}
function $7e5993dca17d6628$export$8f2af6644e3a3c93(o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7e5993dca17d6628$var$e.Provider, {
        value: o.force
    }, o.children);
}

});



parcelRegister("iymfR", function(module, exports) {

$parcel$export(module.exports, "TransitionChild", () => $d81caa4f4b5ad364$export$b8acc0f6b9e8ca5d);
$parcel$export(module.exports, "Transition", () => $d81caa4f4b5ad364$export$be58926105124dd4);

var $acw62 = parcelRequire("acw62");

var $5Ai9V = parcelRequire("5Ai9V");

var $114Mg = parcelRequire("114Mg");

var $brBI7 = parcelRequire("brBI7");

var $8KgIp = parcelRequire("8KgIp");

var $ltgxC = parcelRequire("ltgxC");

var $b8md9 = parcelRequire("b8md9");

var $6mpbl = parcelRequire("6mpbl");

var $bdknl = parcelRequire("bdknl");

var $auuNT = parcelRequire("auuNT");

var $4Mkm0 = parcelRequire("4Mkm0");

var $6Ngq1 = parcelRequire("6Ngq1");

var $ebRQH = parcelRequire("ebRQH");
"use client";
function $d81caa4f4b5ad364$var$ue(e) {
    var t;
    return !!(e.enter || e.enterFrom || e.enterTo || e.leave || e.leaveFrom || e.leaveTo) || ((t = e.as) != null ? t : $d81caa4f4b5ad364$var$de) !== (0, $acw62.Fragment) || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(e.children) === 1;
}
let $d81caa4f4b5ad364$var$w = (0, $acw62.createContext)(null);
$d81caa4f4b5ad364$var$w.displayName = "TransitionContext";
var $d81caa4f4b5ad364$var$_e = ((n)=>(n.Visible = "visible", n.Hidden = "hidden", n))($d81caa4f4b5ad364$var$_e || {});
function $d81caa4f4b5ad364$var$De() {
    let e = (0, $acw62.useContext)($d81caa4f4b5ad364$var$w);
    if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return e;
}
function $d81caa4f4b5ad364$var$He() {
    let e = (0, $acw62.useContext)($d81caa4f4b5ad364$var$M);
    if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return e;
}
let $d81caa4f4b5ad364$var$M = (0, $acw62.createContext)(null);
$d81caa4f4b5ad364$var$M.displayName = "NestingContext";
function $d81caa4f4b5ad364$var$U(e) {
    return "children" in e ? $d81caa4f4b5ad364$var$U(e.children) : e.current.filter(({ el: t })=>t.current !== null).filter(({ state: t })=>t === "visible").length > 0;
}
function $d81caa4f4b5ad364$var$Te(e, t) {
    let n = (0, $ltgxC.useLatestValue)(e), l = (0, $acw62.useRef)([]), S = (0, $brBI7.useIsMounted)(), R = (0, $5Ai9V.useDisposables)(), d = (0, $114Mg.useEvent)((o, i = (0, $ebRQH.RenderStrategy).Hidden)=>{
        let a = l.current.findIndex(({ el: s })=>s === o);
        a !== -1 && ((0, $6Ngq1.match)(i, {
            [(0, $ebRQH.RenderStrategy).Unmount] () {
                l.current.splice(a, 1);
            },
            [(0, $ebRQH.RenderStrategy).Hidden] () {
                l.current[a].state = "hidden";
            }
        }), R.microTask(()=>{
            var s;
            !$d81caa4f4b5ad364$var$U(l) && S.current && ((s = n.current) == null || s.call(n));
        }));
    }), y = (0, $114Mg.useEvent)((o)=>{
        let i = l.current.find(({ el: a })=>a === o);
        return i ? i.state !== "visible" && (i.state = "visible") : l.current.push({
            el: o,
            state: "visible"
        }), ()=>d(o, (0, $ebRQH.RenderStrategy).Unmount);
    }), p = (0, $acw62.useRef)([]), c = (0, $acw62.useRef)(Promise.resolve()), C = (0, $acw62.useRef)({
        enter: [],
        leave: []
    }), h = (0, $114Mg.useEvent)((o, i, a)=>{
        p.current.splice(0), t && (t.chains.current[i] = t.chains.current[i].filter(([s])=>s !== o)), t == null || t.chains.current[i].push([
            o,
            new Promise((s)=>{
                p.current.push(s);
            })
        ]), t == null || t.chains.current[i].push([
            o,
            new Promise((s)=>{
                Promise.all(C.current[i].map(([r, f])=>f)).then(()=>s());
            })
        ]), i === "enter" ? c.current = c.current.then(()=>t == null ? void 0 : t.wait.current).then(()=>a(i)) : a(i);
    }), g = (0, $114Mg.useEvent)((o, i, a)=>{
        Promise.all(C.current[i].splice(0).map(([s, r])=>r)).then(()=>{
            var s;
            (s = p.current.shift()) == null || s();
        }).then(()=>a(i));
    });
    return (0, $acw62.useMemo)(()=>({
            children: l,
            register: y,
            unregister: d,
            onStart: h,
            onStop: g,
            wait: c,
            chains: C
        }), [
        y,
        d,
        l,
        h,
        g,
        C,
        c
    ]);
}
let $d81caa4f4b5ad364$var$de = (0, $acw62.Fragment), $d81caa4f4b5ad364$var$fe = (0, $ebRQH.RenderFeatures).RenderStrategy;
function $d81caa4f4b5ad364$var$Ae(e, t) {
    var ee, te;
    let { transition: n = !0, beforeEnter: l, afterEnter: S, beforeLeave: R, afterLeave: d, enter: y, enterFrom: p, enterTo: c, entered: C, leave: h, leaveFrom: g, leaveTo: o, ...i } = e, [a, s] = (0, $acw62.useState)(null), r = (0, $acw62.useRef)(null), f = $d81caa4f4b5ad364$var$ue(e), j = (0, $6mpbl.useSyncRefs)(...f ? [
        r,
        t,
        s
    ] : t === null ? [] : [
        t
    ]), H = (ee = i.unmount) == null || ee ? (0, $ebRQH.RenderStrategy).Unmount : (0, $ebRQH.RenderStrategy).Hidden, { show: u, appear: z, initial: K } = $d81caa4f4b5ad364$var$De(), [v, G] = (0, $acw62.useState)(u ? "visible" : "hidden"), Q = $d81caa4f4b5ad364$var$He(), { register: A, unregister: I } = Q;
    (0, $8KgIp.useIsoMorphicEffect)(()=>A(r), [
        A,
        r
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (H === (0, $ebRQH.RenderStrategy).Hidden && r.current) {
            if (u && v !== "visible") {
                G("visible");
                return;
            }
            return (0, $6Ngq1.match)(v, {
                ["hidden"]: ()=>I(r),
                ["visible"]: ()=>A(r)
            });
        }
    }, [
        v,
        r,
        A,
        I,
        u,
        H
    ]);
    let B = (0, $b8md9.useServerHandoffComplete)();
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (f && B && v === "visible" && r.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        r,
        v,
        B,
        f
    ]);
    let ce = K && !z, Y = z && u && K, W = (0, $acw62.useRef)(!1), L = $d81caa4f4b5ad364$var$Te(()=>{
        W.current || (G("hidden"), I(r));
    }, Q), Z = (0, $114Mg.useEvent)((k)=>{
        W.current = !0;
        let F = k ? "enter" : "leave";
        L.onStart(r, F, (_)=>{
            _ === "enter" ? l == null || l() : _ === "leave" && (R == null || R());
        });
    }), $ = (0, $114Mg.useEvent)((k)=>{
        let F = k ? "enter" : "leave";
        W.current = !1, L.onStop(r, F, (_)=>{
            _ === "enter" ? S == null || S() : _ === "leave" && (d == null || d());
        }), F === "leave" && !$d81caa4f4b5ad364$var$U(L) && (G("hidden"), I(r));
    });
    (0, $acw62.useEffect)(()=>{
        f && n || (Z(u), $(u));
    }, [
        u,
        f,
        n
    ]);
    let pe = (()=>!(!n || !f || !B || ce))(), [, T] = (0, $bdknl.useTransition)(pe, a, u, {
        start: Z,
        end: $
    }), Ce = (0, $ebRQH.compact)({
        ref: j,
        className: ((te = (0, $4Mkm0.classNames)(i.className, Y && y, Y && p, T.enter && y, T.enter && T.closed && p, T.enter && !T.closed && c, T.leave && h, T.leave && !T.closed && g, T.leave && T.closed && o, !T.transition && u && C)) == null ? void 0 : te.trim()) || void 0,
        ...(0, $bdknl.transitionDataAttributes)(T)
    }), N = 0;
    v === "visible" && (N |= (0, $auuNT.State).Open), v === "hidden" && (N |= (0, $auuNT.State).Closed), T.enter && (N |= (0, $auuNT.State).Opening), T.leave && (N |= (0, $auuNT.State).Closing);
    let he = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d81caa4f4b5ad364$var$M.Provider, {
        value: L
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $auuNT.OpenClosedProvider), {
        value: N
    }, he({
        ourProps: Ce,
        theirProps: i,
        defaultTag: $d81caa4f4b5ad364$var$de,
        features: $d81caa4f4b5ad364$var$fe,
        visible: v === "visible",
        name: "Transition.Child"
    })));
}
function $d81caa4f4b5ad364$var$Ie(e, t) {
    let { show: n, appear: l = !1, unmount: S = !0, ...R } = e, d = (0, $acw62.useRef)(null), y = $d81caa4f4b5ad364$var$ue(e), p = (0, $6mpbl.useSyncRefs)(...y ? [
        d,
        t
    ] : t === null ? [] : [
        t
    ]);
    (0, $b8md9.useServerHandoffComplete)();
    let c = (0, $auuNT.useOpenClosed)();
    if (n === void 0 && c !== null && (n = (c & (0, $auuNT.State).Open) === (0, $auuNT.State).Open), n === void 0) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [C, h] = (0, $acw62.useState)(n ? "visible" : "hidden"), g = $d81caa4f4b5ad364$var$Te(()=>{
        n || h("hidden");
    }), [o, i] = (0, $acw62.useState)(!0), a = (0, $acw62.useRef)([
        n
    ]);
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        o !== !1 && a.current[a.current.length - 1] !== n && (a.current.push(n), i(!1));
    }, [
        a,
        n
    ]);
    let s = (0, $acw62.useMemo)(()=>({
            show: n,
            appear: l,
            initial: o
        }), [
        n,
        l,
        o
    ]);
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        n ? h("visible") : !$d81caa4f4b5ad364$var$U(g) && d.current !== null && h("hidden");
    }, [
        n,
        g
    ]);
    let r = {
        unmount: S
    }, f = (0, $114Mg.useEvent)(()=>{
        var u;
        o && i(!1), (u = e.beforeEnter) == null || u.call(e);
    }), j = (0, $114Mg.useEvent)(()=>{
        var u;
        o && i(!1), (u = e.beforeLeave) == null || u.call(e);
    }), H = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d81caa4f4b5ad364$var$M.Provider, {
        value: g
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d81caa4f4b5ad364$var$w.Provider, {
        value: s
    }, H({
        ourProps: {
            ...r,
            as: (0, $acw62.Fragment),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d81caa4f4b5ad364$var$me, {
                ref: p,
                ...r,
                ...R,
                beforeEnter: f,
                beforeLeave: j
            })
        },
        theirProps: {},
        defaultTag: (0, $acw62.Fragment),
        features: $d81caa4f4b5ad364$var$fe,
        visible: C === "visible",
        name: "Transition"
    })));
}
function $d81caa4f4b5ad364$var$Le(e, t) {
    let n = (0, $acw62.useContext)($d81caa4f4b5ad364$var$w) !== null, l = (0, $auuNT.useOpenClosed)() !== null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, !n && l ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d81caa4f4b5ad364$var$X, {
        ref: t,
        ...e
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d81caa4f4b5ad364$var$me, {
        ref: t,
        ...e
    }));
}
let $d81caa4f4b5ad364$var$X = (0, $ebRQH.forwardRefWithAs)($d81caa4f4b5ad364$var$Ie), $d81caa4f4b5ad364$var$me = (0, $ebRQH.forwardRefWithAs)($d81caa4f4b5ad364$var$Ae), $d81caa4f4b5ad364$export$b8acc0f6b9e8ca5d = (0, $ebRQH.forwardRefWithAs)($d81caa4f4b5ad364$var$Le), $d81caa4f4b5ad364$export$be58926105124dd4 = Object.assign($d81caa4f4b5ad364$var$X, {
    Child: $d81caa4f4b5ad364$export$b8acc0f6b9e8ca5d,
    Root: $d81caa4f4b5ad364$var$X
});

});
parcelRegister("brBI7", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $854f77de70ff8db2$export$80c2a3957bcb42ea);

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");
function $854f77de70ff8db2$export$80c2a3957bcb42ea() {
    let e = (0, $acw62.useRef)(!1);
    return (0, $8KgIp.useIsoMorphicEffect)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}

});




parcelRegister("1s2hs", function(module, exports) {
parcelRequire("3jtCD");

});
parcelRegister("3jtCD", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
function $2c15b21067918b4b$export$fac6735783df9523({ children: children, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("flex", "justify-center", "items-center", "bg-orange-200", "rounded", "p-1", "w-8", "h-8", "cursor-pointer", className),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "body-s cursor-pointer text-orange-800",
            children: children
        })
    });
}

});


parcelRegister("e1IRi", function(module, exports) {
$parcel$export(module.exports, "NavBar", () => (parcelRequire("doRCL")).NavBar);
parcelRequire("doRCL");

});
parcelRegister("doRCL", function(module, exports) {

$parcel$export(module.exports, "NavBar", () => $780b2e48d27cfe38$export$ef8da11641c635de);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $5wAlp = parcelRequire("5wAlp");
var $ZZYjn = parcelRequire("ZZYjn");
var $ihuRA = parcelRequire("ihuRA");

var $9QePP = parcelRequire("9QePP");

var $lzNIT = parcelRequire("lzNIT");
parcelRequire("4aCOh");
var $hUCih = parcelRequire("hUCih");

var $sfIWp = parcelRequire("sfIWp");
parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");
const $780b2e48d27cfe38$var$DefaultLogo = /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
    href: "/",
    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).Hum, {
        width: "32",
        height: "32"
    })
});
function $780b2e48d27cfe38$var$Link({ to: to, label: label, external: external }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.NavLink), {
        to: to,
        reloadDocument: !!external,
        className: "navlink-item",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: (0, $9QePP.default)("body-s", // isActive ? "text-color" : "subdued",
            "hover:text-color", "cursor-pointer px-3 pb-2"),
            children: label
        })
    }, to);
}
function $780b2e48d27cfe38$export$ef8da11641c635de({ title: title, links: links = [], logo: logo = $780b2e48d27cfe38$var$DefaultLogo, fixedBar: fixedBar, background: background = "bg-default", className: className, showSettings: showSettings = false, showLogout: showLogout = false, variant: variant = "default" }) {
    const [open, setOpen] = (0, $acw62.useState)(false);
    const router = (0, $fp4OM.useRouter)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)(background, className),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $sfIWp.MobileNavMenu), {
                open: open,
                close: ()=>setOpen(false),
                links: links,
                showLogout: showLogout,
                showSettings: showSettings
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("header", {
                className: `${fixedBar ? "fixed" : "relative"} z-40 w-full`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
                    "aria-label": "Top",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: background,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `max-w-8xl px-6 py-4`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: (0, $9QePP.default)("flex justify-between", variant === "public" ? "items-center" : "items-end", {
                                        "lg:justify-start": links.length > 0
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mr-6 lg:flex lg:items-center",
                                            children: logo
                                        }),
                                        title && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: (0, $9QePP.default)("body-s mr-auto hidden lg:block", variant !== "public" && "subdued"),
                                            children: title
                                        }),
                                        links.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "hidden h-full grow lg:flex",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: (0, $9QePP.default)("h-full", "flex justify-center space-x-4"),
                                                children: links.map(({ to: to, label: label, external: external })=>/*#__PURE__*/ (0, $ayMG0.jsx)($780b2e48d27cfe38$var$Link, {
                                                        to: to,
                                                        label: label,
                                                        external: external
                                                    }, to))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center justify-end",
                                            children: [
                                                (links.length > 0 || showSettings || showLogout) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "flex items-center lg:hidden",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        "data-testid": "mobile:open-menu-btn",
                                                        className: `rounded-md ${background} secondary p-2 text-gray-400`,
                                                        onClick: ()=>setOpen(true),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ZZYjn.default), {
                                                            className: "size-6",
                                                            "aria-hidden": "true"
                                                        })
                                                    })
                                                }),
                                                variant === "public" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "flex items-center justify-end",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "flex items-center lg:ml-8",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "flex space-x-2",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "flex gap-6",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        className: "secondary lg",
                                                                        onClick: ()=>router.navigate("/signup"),
                                                                        children: "Sign Up"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        className: "lg",
                                                                        onClick: ()=>router.navigate("/login"),
                                                                        children: "Log In"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "hidden items-center justify-end lg:flex",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "flex items-center lg:ml-8",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex space-x-2",
                                                            children: [
                                                                showSettings && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                    className: (0, $9QePP.default)("xs", "quiet", "hover:text-slate-200", "group"),
                                                                    onClick: ()=>router.updateSearch("settings", "open"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ihuRA.default), {
                                                                            className: "xs size-6 group-hover:stroke-slate-200"
                                                                        }),
                                                                        "Settings"
                                                                    ]
                                                                }),
                                                                showLogout && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.NavLink), {
                                                                    to: "/logout",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                        className: (0, $9QePP.default)("xs", "quiet ", "hover:text-slate-300", "group"),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5wAlp.default), {
                                                                                className: "xs size-6 group-hover:stroke-slate-200"
                                                                            }),
                                                                            "Logout"
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
}

});
parcelRegister("5wAlp", function(module, exports) {

$parcel$export(module.exports, "default", () => $405c222800bcdcdd$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $405c222800bcdcdd$var$ArrowRightStartOnRectangleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"
    }));
}
const $405c222800bcdcdd$var$ForwardRef = $acw62.forwardRef($405c222800bcdcdd$var$ArrowRightStartOnRectangleIcon);
var $405c222800bcdcdd$export$2e2bcd8739ae039 = $405c222800bcdcdd$var$ForwardRef;

});

parcelRegister("ZZYjn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ba5c4ec0e202528$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $0ba5c4ec0e202528$var$Bars3Icon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    }));
}
const $0ba5c4ec0e202528$var$ForwardRef = $acw62.forwardRef($0ba5c4ec0e202528$var$Bars3Icon);
var $0ba5c4ec0e202528$export$2e2bcd8739ae039 = $0ba5c4ec0e202528$var$ForwardRef;

});

parcelRegister("ihuRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4f1c1568523d6e5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $d4f1c1568523d6e5$var$Cog6ToothIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    }));
}
const $d4f1c1568523d6e5$var$ForwardRef = $acw62.forwardRef($d4f1c1568523d6e5$var$Cog6ToothIcon);
var $d4f1c1568523d6e5$export$2e2bcd8739ae039 = $d4f1c1568523d6e5$var$ForwardRef;

});

parcelRegister("sfIWp", function(module, exports) {

$parcel$export(module.exports, "MobileNavMenu", () => $3d4c65523d647719$export$8b76171eb393dbc9);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");

var $lLzDP = parcelRequire("lLzDP");
var $iymfR = parcelRequire("iymfR");

var $5wAlp = parcelRequire("5wAlp");
var $ihuRA = parcelRequire("ihuRA");
var $cVodR = parcelRequire("cVodR");

var $9QePP = parcelRequire("9QePP");

var $lzNIT = parcelRequire("lzNIT");
function $3d4c65523d647719$export$8b76171eb393dbc9({ open: open, close: close, links: links = [], showLogout: showLogout = false, showSettings: showSettings = false }) {
    const router = (0, $fp4OM.useRouter)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition).Root, {
        show: open,
        as: (0, $ayMG0.Fragment),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lLzDP.Dialog), {
            as: "div",
            className: "relative lg:hidden",
            onClose: close,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition).Child, {
                    as: (0, $ayMG0.Fragment),
                    enter: "transition-opacity ease-linear duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "transition-opacity ease-linear duration-300",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "fixed inset-0 bg-transparent"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "fixed inset-0 z-[2000] flex",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition).Child, {
                        as: (0, $ayMG0.Fragment),
                        enter: "transition ease-in-out duration-300 transform",
                        enterFrom: "-translate-x-full",
                        enterTo: "translate-x-0",
                        leave: "transition ease-in-out duration-300 transform",
                        leaveFrom: "translate-x-0",
                        leaveTo: "-translate-x-full",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lLzDP.Dialog).Panel, {
                            className: `bg-default relative flex w-full max-w-xs flex-col overflow-y-auto pb-12 shadow-xl`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex px-4 pb-2 pt-5",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        type: "button",
                                        onClick: close,
                                        className: (0, $9QePP.default)("quiet", "relative rounded-md", "focus:outline-none focus:ring-2 focus:ring-slate-100 focus:ring-offset-2"),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "absolute -inset-2.5"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "sr-only",
                                                children: "Close panel"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVodR.default), {
                                                "aria-hidden": "true",
                                                className: "size-6 stroke-white hover:stroke-black"
                                            })
                                        ]
                                    })
                                }),
                                links.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    id: "nav-links",
                                    className: "space-y-6 px-4 py-6",
                                    children: links.map(({ to: to, label: label, external: external })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "flow-root",
                                            "data-testid": `mobile:link-item-${label}`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.NavLink), {
                                                to: to,
                                                reloadDocument: !!external,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "subdued body-s hover:text-color-default cursor-pointer",
                                                    children: label
                                                })
                                            })
                                        }, to))
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: (0, $9QePP.default)("px-4 py-6", links.length > 0 && "border-default border-t", "space-y-6"),
                                    children: [
                                        showSettings && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "flow-root",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                className: (0, $9QePP.default)("xs", "quiet", "hover:text-slate-200", "group"),
                                                onClick: ()=>router.updateSearch("settings", "open"),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ihuRA.default), {
                                                        className: "xs size-6 group-hover:stroke-slate-200"
                                                    }),
                                                    "Settings"
                                                ]
                                            })
                                        }),
                                        showLogout && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "flow-root",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.NavLink), {
                                                to: "/logout",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    className: (0, $9QePP.default)("xs", "quiet ", "hover:text-slate-300", "group"),
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5wAlp.default), {
                                                            className: "xs size-6  group-hover:stroke-slate-200"
                                                        }),
                                                        "Logout"
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}

});
parcelRegister("lLzDP", function(module, exports) {

$parcel$export(module.exports, "DialogPanel", () => $fd89a26ac969b4f3$export$46512663428d955a);
$parcel$export(module.exports, "DialogBackdrop", () => $fd89a26ac969b4f3$export$91fffd879a9415f4);
$parcel$export(module.exports, "DialogTitle", () => $fd89a26ac969b4f3$export$16f7638e4a34b909);
$parcel$export(module.exports, "Dialog", () => $fd89a26ac969b4f3$export$3ddf2d174ce01153);

var $acw62 = parcelRequire("acw62");

var $jYrXf = parcelRequire("jYrXf");

var $114Mg = parcelRequire("114Mg");

var $acw62 = parcelRequire("acw62");

var $keKjn = parcelRequire("keKjn");

var $6QXOx = parcelRequire("6QXOx");

var $dcp2r = parcelRequire("dcp2r");

var $23pTr = parcelRequire("23pTr");

var $5IEAk = parcelRequire("5IEAk");

var $jbIlv = parcelRequire("jbIlv");

var $hZodg = parcelRequire("hZodg");

var $b8md9 = parcelRequire("b8md9");

var $6mpbl = parcelRequire("6mpbl");

var $5ETDl = parcelRequire("5ETDl");

var $auuNT = parcelRequire("auuNT");

var $aQyzu = parcelRequire("aQyzu");

var $6Ngq1 = parcelRequire("6Ngq1");

var $ebRQH = parcelRequire("ebRQH");

var $iGb09 = parcelRequire("iGb09");

var $4T0AR = parcelRequire("4T0AR");

var $e9NTc = parcelRequire("e9NTc");

var $iymfR = parcelRequire("iymfR");
"use client";
var $fd89a26ac969b4f3$var$Oe = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($fd89a26ac969b4f3$var$Oe || {}), $fd89a26ac969b4f3$var$he = ((t)=>(t[t.SetTitleId = 0] = "SetTitleId", t))($fd89a26ac969b4f3$var$he || {});
let $fd89a26ac969b4f3$var$Se = {
    [0] (e, t) {
        return e.titleId === t.id ? e : {
            ...e,
            titleId: t.id
        };
    }
}, $fd89a26ac969b4f3$var$k = (0, $acw62.createContext)(null);
$fd89a26ac969b4f3$var$k.displayName = "DialogContext";
function $fd89a26ac969b4f3$var$O(e) {
    let t = (0, $acw62.useContext)($fd89a26ac969b4f3$var$k);
    if (t === null) {
        let o = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $fd89a26ac969b4f3$var$O), o;
    }
    return t;
}
function $fd89a26ac969b4f3$var$Ie(e, t) {
    return (0, $6Ngq1.match)(t.type, $fd89a26ac969b4f3$var$Se, e, t);
}
let $fd89a26ac969b4f3$var$V = (0, $ebRQH.forwardRefWithAs)(function(t, o) {
    let a = (0, $acw62.useId)(), { id: l = `headlessui-dialog-${a}`, open: i, onClose: p, initialFocus: d, role: s = "dialog", autoFocus: f = !0, __demoMode: u = !1, unmount: P = !1, ...h } = t, R = (0, $acw62.useRef)(!1);
    s = function() {
        return s === "dialog" || s === "alertdialog" ? s : (R.current || (R.current = !0, console.warn(`Invalid role [${s}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
    }();
    let c = (0, $auuNT.useOpenClosed)();
    i === void 0 && c !== null && (i = (c & (0, $auuNT.State).Open) === (0, $auuNT.State).Open);
    let T = (0, $acw62.useRef)(null), S = (0, $6mpbl.useSyncRefs)(T, o), F = (0, $5IEAk.useOwnerDocument)(T), g = i ? 0 : 1, [b, q] = (0, $acw62.useReducer)($fd89a26ac969b4f3$var$Ie, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, $acw62.createRef)()
    }), m = (0, $114Mg.useEvent)(()=>p(!1)), w = (0, $114Mg.useEvent)((r)=>q({
            type: 0,
            id: r
        })), D = (0, $b8md9.useServerHandoffComplete)() ? g === 0 : !1, [z, Q] = (0, $e9NTc.useNestedPortals)(), Z = {
        get current () {
            var r;
            return (r = b.panelRef.current) != null ? r : T.current;
        }
    }, v = (0, $jbIlv.useMainTreeNode)(), { resolveContainers: I } = (0, $jbIlv.useRootContainers)({
        mainTreeNode: v,
        portals: z,
        defaultContainers: [
            Z
        ]
    }), B = c !== null ? (c & (0, $auuNT.State).Closing) === (0, $auuNT.State).Closing : !1;
    (0, $keKjn.useInertOthers)(u || B ? !1 : D, {
        allowed: (0, $114Mg.useEvent)(()=>{
            var r, H;
            return [
                (H = (r = T.current) == null ? void 0 : r.closest("[data-headlessui-portal]")) != null ? H : null
            ];
        }),
        disallowed: (0, $114Mg.useEvent)(()=>{
            var r;
            return [
                (r = v == null ? void 0 : v.closest("body > *:not(#headlessui-portal-root)")) != null ? r : null
            ];
        })
    }), (0, $23pTr.useOutsideClick)(D, I, (r)=>{
        r.preventDefault(), m();
    }), (0, $jYrXf.useEscape)(D, F == null ? void 0 : F.defaultView, (r)=>{
        r.preventDefault(), r.stopPropagation(), document.activeElement && "blur" in document.activeElement && typeof document.activeElement.blur == "function" && document.activeElement.blur(), m();
    }), (0, $hZodg.useScrollLock)(u || B ? !1 : D, F, I), (0, $dcp2r.useOnDisappear)(D, T, m);
    let [ee, te] = (0, $iGb09.useDescriptions)(), oe = (0, $acw62.useMemo)(()=>[
            {
                dialogState: g,
                close: m,
                setTitleId: w,
                unmount: P
            },
            b
        ], [
        g,
        b,
        m,
        w,
        P
    ]), U = (0, $acw62.useMemo)(()=>({
            open: g === 0
        }), [
        g
    ]), ne = {
        ref: S,
        id: l,
        role: s,
        tabIndex: -1,
        "aria-modal": u ? void 0 : g === 0 ? !0 : void 0,
        "aria-labelledby": b.titleId,
        "aria-describedby": ee,
        unmount: P
    }, re = !(0, $6QXOx.useIsTouchDevice)(), y = (0, $4T0AR.FocusTrapFeatures).None;
    D && !u && (y |= (0, $4T0AR.FocusTrapFeatures).RestoreFocus, y |= (0, $4T0AR.FocusTrapFeatures).TabLock, f && (y |= (0, $4T0AR.FocusTrapFeatures).AutoFocus), re && (y |= (0, $4T0AR.FocusTrapFeatures).InitialFocus));
    let le = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $auuNT.ResetOpenClosedProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQyzu.ForcePortalRoot), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e9NTc.Portal), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fd89a26ac969b4f3$var$k.Provider, {
        value: oe
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e9NTc.PortalGroup), {
        target: T
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQyzu.ForcePortalRoot), {
        force: !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(te, {
        slot: U
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Q, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4T0AR.FocusTrap), {
        initialFocus: d,
        initialFocusFallback: T,
        containers: I,
        features: y
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5ETDl.CloseProvider), {
        value: m
    }, le({
        ourProps: ne,
        theirProps: h,
        slot: U,
        defaultTag: $fd89a26ac969b4f3$var$Me,
        features: $fd89a26ac969b4f3$var$Ge,
        visible: g === 0,
        name: "Dialog"
    })))))))))));
}), $fd89a26ac969b4f3$var$Me = "div", $fd89a26ac969b4f3$var$Ge = (0, $ebRQH.RenderFeatures).RenderStrategy | (0, $ebRQH.RenderFeatures).Static;
function $fd89a26ac969b4f3$var$ke(e, t) {
    let { transition: o = !1, open: a, ...l } = e, i = (0, $auuNT.useOpenClosed)(), p = e.hasOwnProperty("open") || i !== null, d = e.hasOwnProperty("onClose");
    if (!p && !d) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!p) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!d) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (!i && typeof e.open != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${e.open}`);
    if (typeof e.onClose != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${e.onClose}`);
    return (a !== void 0 || o) && !l.static ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jbIlv.MainTreeProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iymfR.Transition), {
        show: a,
        transition: o,
        unmount: l.unmount
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fd89a26ac969b4f3$var$V, {
        ref: t,
        ...l
    }))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jbIlv.MainTreeProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fd89a26ac969b4f3$var$V, {
        ref: t,
        open: a,
        ...l
    }));
}
let $fd89a26ac969b4f3$var$we = "div";
function $fd89a26ac969b4f3$var$Be(e, t) {
    let o = (0, $acw62.useId)(), { id: a = `headlessui-dialog-panel-${o}`, transition: l = !1, ...i } = e, [{ dialogState: p, unmount: d }, s] = $fd89a26ac969b4f3$var$O("Dialog.Panel"), f = (0, $6mpbl.useSyncRefs)(t, s.panelRef), u = (0, $acw62.useMemo)(()=>({
            open: p === 0
        }), [
        p
    ]), P = (0, $114Mg.useEvent)((S)=>{
        S.stopPropagation();
    }), h = {
        ref: f,
        id: a,
        onClick: P
    }, R = l ? (0, $iymfR.TransitionChild) : (0, $acw62.Fragment), c = l ? {
        unmount: d
    } : {}, T = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(R, {
        ...c
    }, T({
        ourProps: h,
        theirProps: i,
        slot: u,
        defaultTag: $fd89a26ac969b4f3$var$we,
        name: "Dialog.Panel"
    }));
}
let $fd89a26ac969b4f3$var$Ue = "div";
function $fd89a26ac969b4f3$var$He(e, t) {
    let { transition: o = !1, ...a } = e, [{ dialogState: l, unmount: i }] = $fd89a26ac969b4f3$var$O("Dialog.Backdrop"), p = (0, $acw62.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]), d = {
        ref: t,
        "aria-hidden": !0
    }, s = o ? (0, $iymfR.TransitionChild) : (0, $acw62.Fragment), f = o ? {
        unmount: i
    } : {}, u = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(s, {
        ...f
    }, u({
        ourProps: d,
        theirProps: a,
        slot: p,
        defaultTag: $fd89a26ac969b4f3$var$Ue,
        name: "Dialog.Backdrop"
    }));
}
let $fd89a26ac969b4f3$var$Ne = "h2";
function $fd89a26ac969b4f3$var$We(e, t) {
    let o = (0, $acw62.useId)(), { id: a = `headlessui-dialog-title-${o}`, ...l } = e, [{ dialogState: i, setTitleId: p }] = $fd89a26ac969b4f3$var$O("Dialog.Title"), d = (0, $6mpbl.useSyncRefs)(t);
    (0, $acw62.useEffect)(()=>(p(a), ()=>p(null)), [
        a,
        p
    ]);
    let s = (0, $acw62.useMemo)(()=>({
            open: i === 0
        }), [
        i
    ]), f = {
        ref: d,
        id: a
    };
    return (0, $ebRQH.useRender)()({
        ourProps: f,
        theirProps: l,
        slot: s,
        defaultTag: $fd89a26ac969b4f3$var$Ne,
        name: "Dialog.Title"
    });
}
let $fd89a26ac969b4f3$var$$e = (0, $ebRQH.forwardRefWithAs)($fd89a26ac969b4f3$var$ke), $fd89a26ac969b4f3$export$46512663428d955a = (0, $ebRQH.forwardRefWithAs)($fd89a26ac969b4f3$var$Be), $fd89a26ac969b4f3$export$91fffd879a9415f4 = (0, $ebRQH.forwardRefWithAs)($fd89a26ac969b4f3$var$He), $fd89a26ac969b4f3$export$16f7638e4a34b909 = (0, $ebRQH.forwardRefWithAs)($fd89a26ac969b4f3$var$We), $fd89a26ac969b4f3$export$94e94c2ec2c954d5 = (0, $iGb09.Description), $fd89a26ac969b4f3$export$3ddf2d174ce01153 = Object.assign($fd89a26ac969b4f3$var$$e, {
    Panel: $fd89a26ac969b4f3$export$46512663428d955a,
    Title: $fd89a26ac969b4f3$export$16f7638e4a34b909,
    Description: (0, $iGb09.Description)
});

});
parcelRegister("jYrXf", function(module, exports) {

$parcel$export(module.exports, "useEscape", () => $e8a94e1c7fcf4260$export$3875fddb67014c13);

var $6AKlm = parcelRequire("6AKlm");

var $lwoRo = parcelRequire("lwoRo");

var $g6SeH = parcelRequire("g6SeH");
function $e8a94e1c7fcf4260$export$3875fddb67014c13(o, r = typeof document != "undefined" ? document.defaultView : null, t) {
    let n = (0, $g6SeH.useIsTopLayer)(o, "escape");
    (0, $lwoRo.useEventListener)(r, "keydown", (e)=>{
        n && (e.defaultPrevented || e.key === (0, $6AKlm.Keys).Escape && t(e));
    });
}

});
parcelRegister("lwoRo", function(module, exports) {

$parcel$export(module.exports, "useEventListener", () => $faafded37f338b1b$export$7080b3e976bc91ab);

var $acw62 = parcelRequire("acw62");

var $ltgxC = parcelRequire("ltgxC");
function $faafded37f338b1b$export$7080b3e976bc91ab(n, e, a, t) {
    let i = (0, $ltgxC.useLatestValue)(a);
    (0, $acw62.useEffect)(()=>{
        n = n != null ? n : window;
        function r(o) {
            i.current(o);
        }
        return n.addEventListener(e, r, t), ()=>n.removeEventListener(e, r, t);
    }, [
        n,
        e,
        t
    ]);
}

});


parcelRegister("6QXOx", function(module, exports) {

$parcel$export(module.exports, "useIsTouchDevice", () => $4fd5ff3f074a68f3$export$2706b359107dd58d);

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");
function $4fd5ff3f074a68f3$export$2706b359107dd58d() {
    var t;
    let [e] = (0, $acw62.useState)(()=>typeof window != "undefined" && typeof window.matchMedia == "function" ? window.matchMedia("(pointer: coarse)") : null), [o, c] = (0, $acw62.useState)((t = e == null ? void 0 : e.matches) != null ? t : !1);
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!e) return;
        function n(r) {
            c(r.matches);
        }
        return e.addEventListener("change", n), ()=>e.removeEventListener("change", n);
    }, [
        e
    ]), o;
}

});

parcelRegister("jbIlv", function(module, exports) {

$parcel$export(module.exports, "useRootContainers", () => $df81719180936f93$export$445f2d1a3d9b1b9f);
$parcel$export(module.exports, "MainTreeProvider", () => $df81719180936f93$export$61c2c570df73dc80);
$parcel$export(module.exports, "useMainTreeNode", () => $df81719180936f93$export$64db24433d7f4942);

var $acw62 = parcelRequire("acw62");

var $k9Al5 = parcelRequire("k9Al5");

var $gxwGc = parcelRequire("gxwGc");

var $114Mg = parcelRequire("114Mg");

var $5IEAk = parcelRequire("5IEAk");
function $df81719180936f93$export$445f2d1a3d9b1b9f({ defaultContainers: l = [], portals: n, mainTreeNode: o } = {}) {
    let r = (0, $5IEAk.useOwnerDocument)(o), u = (0, $114Mg.useEvent)(()=>{
        var i, c;
        let t = [];
        for (let e of l)e !== null && (e instanceof HTMLElement ? t.push(e) : "current" in e && e.current instanceof HTMLElement && t.push(e.current));
        if (n != null && n.current) for (let e of n.current)t.push(e);
        for (let e of (i = r == null ? void 0 : r.querySelectorAll("html > *, body > *")) != null ? i : [])e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (o && (e.contains(o) || e.contains((c = o == null ? void 0 : o.getRootNode()) == null ? void 0 : c.host)) || t.some((m)=>e.contains(m)) || t.push(e));
        return t;
    });
    return {
        resolveContainers: u,
        contains: (0, $114Mg.useEvent)((t)=>u().some((i)=>i.contains(t)))
    };
}
let $df81719180936f93$var$a = (0, $acw62.createContext)(null);
function $df81719180936f93$export$61c2c570df73dc80({ children: l, node: n }) {
    let [o, r] = (0, $acw62.useState)(null), u = $df81719180936f93$export$64db24433d7f4942(n != null ? n : o);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($df81719180936f93$var$a.Provider, {
        value: u
    }, l, u === null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        features: (0, $k9Al5.HiddenFeatures).Hidden,
        ref: (t)=>{
            var i, c;
            if (t) {
                for (let e of (c = (i = (0, $gxwGc.getOwnerDocument)(t)) == null ? void 0 : i.querySelectorAll("html > *, body > *")) != null ? c : [])if (e !== document.body && e !== document.head && e instanceof HTMLElement && e != null && e.contains(t)) {
                    r(e);
                    break;
                }
            }
        }
    }));
}
function $df81719180936f93$export$64db24433d7f4942(l = null) {
    var n;
    return (n = (0, $acw62.useContext)($df81719180936f93$var$a)) != null ? n : l;
}

});
parcelRegister("k9Al5", function(module, exports) {

$parcel$export(module.exports, "HiddenFeatures", () => $eac0d614a77ee96b$export$4e7f8864c6a16d8a);
$parcel$export(module.exports, "Hidden", () => $eac0d614a77ee96b$export$8dc98ba7eadeaa56);

var $ebRQH = parcelRequire("ebRQH");
let $eac0d614a77ee96b$var$a = "span";
var $eac0d614a77ee96b$export$4e7f8864c6a16d8a = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($eac0d614a77ee96b$export$4e7f8864c6a16d8a || {});
function $eac0d614a77ee96b$var$l(t, r) {
    var n;
    let { features: d = 1, ...e } = t, o = {
        ref: r,
        "aria-hidden": (d & 2) === 2 ? !0 : (n = e["aria-hidden"]) != null ? n : void 0,
        hidden: (d & 4) === 4 ? !0 : void 0,
        style: {
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0",
            ...(d & 4) === 4 && (d & 2) !== 2 && {
                display: "none"
            }
        }
    };
    return (0, $ebRQH.useRender)()({
        ourProps: o,
        theirProps: e,
        slot: {},
        defaultTag: $eac0d614a77ee96b$var$a,
        name: "Hidden"
    });
}
let $eac0d614a77ee96b$export$8dc98ba7eadeaa56 = (0, $ebRQH.forwardRefWithAs)($eac0d614a77ee96b$var$l);

});


parcelRegister("5ETDl", function(module, exports) {

$parcel$export(module.exports, "CloseProvider", () => $41ebd7de5602bb69$export$dd2a80b78bebbe1d);

var $acw62 = parcelRequire("acw62");
"use client";
let $41ebd7de5602bb69$var$e = (0, $acw62.createContext)(()=>{});
function $41ebd7de5602bb69$export$4e99330e6f37bca2() {
    return (0, $acw62.useContext)($41ebd7de5602bb69$var$e);
}
function $41ebd7de5602bb69$export$dd2a80b78bebbe1d({ value: t, children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($41ebd7de5602bb69$var$e.Provider, {
        value: t
    }, o);
}

});

parcelRegister("4T0AR", function(module, exports) {

$parcel$export(module.exports, "FocusTrapFeatures", () => $38ecc25572962dee$export$a5e9a012c73650bd);
$parcel$export(module.exports, "FocusTrap", () => $38ecc25572962dee$export$34eba2437817a67b);

var $acw62 = parcelRequire("acw62");

var $5Ai9V = parcelRequire("5Ai9V");

var $114Mg = parcelRequire("114Mg");

var $lwoRo = parcelRequire("lwoRo");

var $brBI7 = parcelRequire("brBI7");

var $g6SeH = parcelRequire("g6SeH");

var $3XIoH = parcelRequire("3XIoH");

var $5IEAk = parcelRequire("5IEAk");

var $b8md9 = parcelRequire("b8md9");

var $6mpbl = parcelRequire("6mpbl");

var $3nJyP = parcelRequire("3nJyP");

var $lEQT2 = parcelRequire("lEQT2");

var $k9Al5 = parcelRequire("k9Al5");

var $2C9FE = parcelRequire("2C9FE");

var $hsQxB = parcelRequire("hsQxB");

var $6Ngq1 = parcelRequire("6Ngq1");

var $eJKgu = parcelRequire("eJKgu");

var $ebRQH = parcelRequire("ebRQH");
"use client";
function $38ecc25572962dee$var$U(o) {
    if (!o) return new Set;
    if (typeof o == "function") return new Set(o());
    let e = new Set;
    for (let t of o.current)t.current instanceof HTMLElement && e.add(t.current);
    return e;
}
let $38ecc25572962dee$var$Z = "div";
var $38ecc25572962dee$export$a5e9a012c73650bd = ((n)=>(n[n.None = 0] = "None", n[n.InitialFocus = 1] = "InitialFocus", n[n.TabLock = 2] = "TabLock", n[n.FocusLock = 4] = "FocusLock", n[n.RestoreFocus = 8] = "RestoreFocus", n[n.AutoFocus = 16] = "AutoFocus", n))($38ecc25572962dee$export$a5e9a012c73650bd || {});
function $38ecc25572962dee$var$$(o, e) {
    let t = (0, $acw62.useRef)(null), r = (0, $6mpbl.useSyncRefs)(t, e), { initialFocus: s, initialFocusFallback: a, containers: n, features: u = 15, ...f } = o;
    (0, $b8md9.useServerHandoffComplete)() || (u = 0);
    let l = (0, $5IEAk.useOwnerDocument)(t);
    $38ecc25572962dee$var$ee(u, {
        ownerDocument: l
    });
    let i = $38ecc25572962dee$var$te(u, {
        ownerDocument: l,
        container: t,
        initialFocus: s,
        initialFocusFallback: a
    });
    $38ecc25572962dee$var$re(u, {
        ownerDocument: l,
        container: t,
        containers: n,
        previousActiveElement: i
    });
    let R = (0, $3nJyP.useTabDirection)(), g = (0, $114Mg.useEvent)((c)=>{
        let m = t.current;
        if (!m) return;
        ((G)=>G())(()=>{
            (0, $6Ngq1.match)(R.current, {
                [(0, $3nJyP.Direction).Forwards]: ()=>{
                    (0, $hsQxB.focusIn)(m, (0, $hsQxB.Focus).First, {
                        skipElements: [
                            c.relatedTarget,
                            a
                        ]
                    });
                },
                [(0, $3nJyP.Direction).Backwards]: ()=>{
                    (0, $hsQxB.focusIn)(m, (0, $hsQxB.Focus).Last, {
                        skipElements: [
                            c.relatedTarget,
                            a
                        ]
                    });
                }
            });
        });
    }), v = (0, $g6SeH.useIsTopLayer)(!!(u & 2), "focus-trap#tab-lock"), N = (0, $5Ai9V.useDisposables)(), F = (0, $acw62.useRef)(!1), k = {
        ref: r,
        onKeyDown (c) {
            c.key == "Tab" && (F.current = !0, N.requestAnimationFrame(()=>{
                F.current = !1;
            }));
        },
        onBlur (c) {
            if (!(u & 4)) return;
            let m = $38ecc25572962dee$var$U(n);
            t.current instanceof HTMLElement && m.add(t.current);
            let d = c.relatedTarget;
            d instanceof HTMLElement && d.dataset.headlessuiFocusGuard !== "true" && ($38ecc25572962dee$var$I(m, d) || (F.current ? (0, $hsQxB.focusIn)(t.current, (0, $6Ngq1.match)(R.current, {
                [(0, $3nJyP.Direction).Forwards]: ()=>(0, $hsQxB.Focus).Next,
                [(0, $3nJyP.Direction).Backwards]: ()=>(0, $hsQxB.Focus).Previous
            }) | (0, $hsQxB.Focus).WrapAround, {
                relativeTo: c.target
            }) : c.target instanceof HTMLElement && (0, $hsQxB.focusElement)(c.target)));
        }
    }, B = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, v && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: g,
        features: (0, $k9Al5.HiddenFeatures).Focusable
    }), B({
        ourProps: k,
        theirProps: f,
        defaultTag: $38ecc25572962dee$var$Z,
        name: "FocusTrap"
    }), v && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: g,
        features: (0, $k9Al5.HiddenFeatures).Focusable
    }));
}
let $38ecc25572962dee$var$D = (0, $ebRQH.forwardRefWithAs)($38ecc25572962dee$var$$), $38ecc25572962dee$export$34eba2437817a67b = Object.assign($38ecc25572962dee$var$D, {
    features: $38ecc25572962dee$export$a5e9a012c73650bd
});
function $38ecc25572962dee$var$w(o = !0) {
    let e = (0, $acw62.useRef)((0, $2C9FE.history).slice());
    return (0, $lEQT2.useWatch)(([t], [r])=>{
        r === !0 && t === !1 && (0, $eJKgu.microTask)(()=>{
            e.current.splice(0);
        }), r === !1 && t === !0 && (e.current = (0, $2C9FE.history).slice());
    }, [
        o,
        (0, $2C9FE.history),
        e
    ]), (0, $114Mg.useEvent)(()=>{
        var t;
        return (t = e.current.find((r)=>r != null && r.isConnected)) != null ? t : null;
    });
}
function $38ecc25572962dee$var$ee(o, { ownerDocument: e }) {
    let t = !!(o & 8), r = $38ecc25572962dee$var$w(t);
    (0, $lEQT2.useWatch)(()=>{
        t || (e == null ? void 0 : e.activeElement) === (e == null ? void 0 : e.body) && (0, $hsQxB.focusElement)(r());
    }, [
        t
    ]), (0, $3XIoH.useOnUnmount)(()=>{
        t && (0, $hsQxB.focusElement)(r());
    });
}
function $38ecc25572962dee$var$te(o, { ownerDocument: e, container: t, initialFocus: r, initialFocusFallback: s }) {
    let a = (0, $acw62.useRef)(null), n = (0, $g6SeH.useIsTopLayer)(!!(o & 1), "focus-trap#initial-focus"), u = (0, $brBI7.useIsMounted)();
    return (0, $lEQT2.useWatch)(()=>{
        if (o === 0) return;
        if (!n) {
            s != null && s.current && (0, $hsQxB.focusElement)(s.current);
            return;
        }
        let f = t.current;
        f && (0, $eJKgu.microTask)(()=>{
            if (!u.current) return;
            let l = e == null ? void 0 : e.activeElement;
            if (r != null && r.current) {
                if ((r == null ? void 0 : r.current) === l) {
                    a.current = l;
                    return;
                }
            } else if (f.contains(l)) {
                a.current = l;
                return;
            }
            if (r != null && r.current) (0, $hsQxB.focusElement)(r.current);
            else {
                if (o & 16) {
                    if ((0, $hsQxB.focusIn)(f, (0, $hsQxB.Focus).First | (0, $hsQxB.Focus).AutoFocus) !== (0, $hsQxB.FocusResult).Error) return;
                } else if ((0, $hsQxB.focusIn)(f, (0, $hsQxB.Focus).First) !== (0, $hsQxB.FocusResult).Error) return;
                if (s != null && s.current && ((0, $hsQxB.focusElement)(s.current), (e == null ? void 0 : e.activeElement) === s.current)) return;
                console.warn("There are no focusable elements inside the <FocusTrap />");
            }
            a.current = e == null ? void 0 : e.activeElement;
        });
    }, [
        s,
        n,
        o
    ]), a;
}
function $38ecc25572962dee$var$re(o, { ownerDocument: e, container: t, containers: r, previousActiveElement: s }) {
    let a = (0, $brBI7.useIsMounted)(), n = !!(o & 4);
    (0, $lwoRo.useEventListener)(e == null ? void 0 : e.defaultView, "focus", (u)=>{
        if (!n || !a.current) return;
        let f = $38ecc25572962dee$var$U(r);
        t.current instanceof HTMLElement && f.add(t.current);
        let l = s.current;
        if (!l) return;
        let i = u.target;
        i && i instanceof HTMLElement ? $38ecc25572962dee$var$I(f, i) ? (s.current = i, (0, $hsQxB.focusElement)(i)) : (u.preventDefault(), u.stopPropagation(), (0, $hsQxB.focusElement)(l)) : (0, $hsQxB.focusElement)(s.current);
    }, !0);
}
function $38ecc25572962dee$var$I(o, e) {
    for (let t of o)if (t.contains(e)) return !0;
    return !1;
}

});
parcelRegister("3nJyP", function(module, exports) {

$parcel$export(module.exports, "Direction", () => $2766dc79ae4166c9$export$cacd6541cfeeb6c1);
$parcel$export(module.exports, "useTabDirection", () => $2766dc79ae4166c9$export$19b797546aece48f);

var $acw62 = parcelRequire("acw62");

var $5vI4D = parcelRequire("5vI4D");
var $2766dc79ae4166c9$export$cacd6541cfeeb6c1 = ((r)=>(r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))($2766dc79ae4166c9$export$cacd6541cfeeb6c1 || {});
function $2766dc79ae4166c9$export$19b797546aece48f() {
    let e = (0, $acw62.useRef)(0);
    return (0, $5vI4D.useWindowEvent)(!0, "keydown", (r)=>{
        r.key === "Tab" && (e.current = r.shiftKey ? 1 : 0);
    }, !0), e;
}

});

parcelRegister("lEQT2", function(module, exports) {

$parcel$export(module.exports, "useWatch", () => $fc465b9f88c2456a$export$3c773aa2b84f29e0);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");
function $fc465b9f88c2456a$export$3c773aa2b84f29e0(u, t) {
    let e = (0, $acw62.useRef)([]), r = (0, $114Mg.useEvent)(u);
    (0, $acw62.useEffect)(()=>{
        let o = [
            ...e.current
        ];
        for (let [a, l] of t.entries())if (e.current[a] !== l) {
            let n = r(t, o);
            return e.current = t, n;
        }
    }, [
        r,
        ...t
    ]);
}

});

parcelRegister("2C9FE", function(module, exports) {

$parcel$export(module.exports, "history", () => $1e76a1cad0cb58a8$export$55abd4691b317664);

var $ixVas = parcelRequire("ixVas");

var $hsQxB = parcelRequire("hsQxB");
let $1e76a1cad0cb58a8$export$55abd4691b317664 = [];
(0, $ixVas.onDocumentReady)(()=>{
    function e(t) {
        if (!(t.target instanceof HTMLElement) || t.target === document.body || $1e76a1cad0cb58a8$export$55abd4691b317664[0] === t.target) return;
        let n = t.target;
        n = n.closest((0, $hsQxB.focusableSelector)), $1e76a1cad0cb58a8$export$55abd4691b317664.unshift(n != null ? n : t.target), $1e76a1cad0cb58a8$export$55abd4691b317664 = $1e76a1cad0cb58a8$export$55abd4691b317664.filter((o)=>o != null && o.isConnected), $1e76a1cad0cb58a8$export$55abd4691b317664.splice(10);
    }
    window.addEventListener("click", e, {
        capture: !0
    }), window.addEventListener("mousedown", e, {
        capture: !0
    }), window.addEventListener("focus", e, {
        capture: !0
    }), document.body.addEventListener("click", e, {
        capture: !0
    }), document.body.addEventListener("mousedown", e, {
        capture: !0
    }), document.body.addEventListener("focus", e, {
        capture: !0
    });
});

});
parcelRegister("ixVas", function(module, exports) {

$parcel$export(module.exports, "onDocumentReady", () => $d807a76564ed2203$export$a6a2315df743a26b);
function $d807a76564ed2203$export$a6a2315df743a26b(n) {
    function e() {
        document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
    }
    typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e), e());
}

});




parcelRegister("cVodR", function(module, exports) {

$parcel$export(module.exports, "default", () => $968d99013e9e02bc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $968d99013e9e02bc$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 18 18 6M6 6l12 12"
    }));
}
const $968d99013e9e02bc$var$ForwardRef = $acw62.forwardRef($968d99013e9e02bc$var$XMarkIcon);
var $968d99013e9e02bc$export$2e2bcd8739ae039 = $968d99013e9e02bc$var$ForwardRef;

});




parcelRegister("5Usd5", function(module, exports) {
parcelRequire("5dBnq");

});
parcelRegister("5dBnq", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $89d2b7aa66a1f45d$export$fcc7818a78919c8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: ref,
        className: `custom-scrollbar z-10 mb-12 size-full overflow-y-scroll ${className}`,
        children: children
    });
});

});


parcelRegister("cL1y1", function(module, exports) {
parcelRequire("lW8aw");

});
parcelRegister("lW8aw", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $4c55bc3383bcee05$export$1f74963c34e8bfec({ testId: testId, className: className, message: message, isBoxless: isBoxless }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)(!isBoxless && "rounded-lozenge border-default border bg-gray-600", "p-4", "text-center", "box-border", className),
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "body-s subdued leading-none",
            children: message
        })
    });
}

});


parcelRegister("fw0XC", function(module, exports) {
$parcel$export(module.exports, "ProgressBar", () => (parcelRequire("1u8ue")).ProgressBar);
parcelRequire("1u8ue");

});
parcelRegister("1u8ue", function(module, exports) {

$parcel$export(module.exports, "ProgressBar", () => $5f0dd536a42c2824$export$c17561cb55d4db30);

var $ayMG0 = parcelRequire("ayMG0");
function $5f0dd536a42c2824$export$c17561cb55d4db30({ testId: testId }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "block",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "progress-bar"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "subdued body-s ml-1 mt-4",
                children: "Gathering data. This process should only take a couple of minutes. Please wait..."
            })
        ]
    });
}

});


parcelRegister("4HiyD", function(module, exports) {
parcelRequire("j86O4");

});
parcelRegister("j86O4", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
function $8dd99caa45b8c8a0$export$6c4845e528748967({ testId: testId, children: children, fixedBar: fixedBar }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)(fixedBar ? "pt-20" : "pt-8", "px-4 pb-8", "w-full", "h-full", "fixed", "lg:max-w-[280px]", "max-w-[200px]", "flex", "flex-col", "gap-y-3", "border-r", "border-default"),
        "data-testid": testId,
        children: children
    });
}
$8dd99caa45b8c8a0$export$6c4845e528748967.Content = ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "ml-[200px] pt-[48px] lg:ml-[280px]",
        children: children
    });
$8dd99caa45b8c8a0$export$6c4845e528748967.Item = ({ children: children, className: className, onClick: onClick, testId: testId, active: active })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("px-4 py-3", "rounded-default", "cursor-pointer", "hover:bg-onSurface-pressed", active && "bg-onSurface-pressed", "[&>*]:cursor-pointer", "flex", "items-center", "justify-between", className),
        onClick: onClick,
        "data-testid": testId,
        children: children
    });

});


parcelRegister("aJClm", function(module, exports) {
$parcel$export(module.exports, "Tooltip", () => (parcelRequire("kYIgH")).Tooltip);
$parcel$export(module.exports, "TooltipSize", () => (parcelRequire("kYIgH")).TooltipSize);
parcelRequire("kYIgH");

});
parcelRegister("kYIgH", function(module, exports) {

$parcel$export(module.exports, "TooltipSize", () => $6e2e188aafee49aa$export$581c3da91e5a0d5);
$parcel$export(module.exports, "Tooltip", () => $6e2e188aafee49aa$export$28c660c63b792dea);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ahYsj = parcelRequire("ahYsj");
var $iymfR = parcelRequire("iymfR");

var $9QePP = parcelRequire("9QePP");
var $6e2e188aafee49aa$export$581c3da91e5a0d5;
(function(TooltipSize) {
    TooltipSize["XS"] = "w-[80px]";
    TooltipSize["SM"] = "w-[120px]";
    TooltipSize["MD"] = "w-[160px]";
    TooltipSize["LG"] = "w-[220px]";
    TooltipSize["XL"] = "w-[550px]";
})($6e2e188aafee49aa$export$581c3da91e5a0d5 || ($6e2e188aafee49aa$export$581c3da91e5a0d5 = {}));
function $6e2e188aafee49aa$export$28c660c63b792dea({ testId: testId, content: content, size: size, children: children, position: position }) {
    const buttonRef = (0, $acw62.useRef)(null);
    const timeoutDuration = 200;
    let timeout;
    const closePopover = ()=>{
        return buttonRef.current?.dispatchEvent(new KeyboardEvent("keydown", {
            key: "Escape",
            bubbles: true,
            cancelable: true
        }));
    };
    const onMouseEnter = (open)=>{
        clearTimeout(timeout);
        if (open) return;
        return buttonRef.current?.click();
    };
    const onMouseLeave = (open)=>{
        if (!open) return;
        timeout = setTimeout(()=>closePopover(), timeoutDuration);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ahYsj.Popover), {
            className: "relative",
            children: ({ open: open })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ahYsj.Popover).Button, {
                            as: "div",
                            className: "outline-0",
                            ref: buttonRef,
                            onMouseEnter: onMouseEnter.bind(null, open),
                            onMouseLeave: onMouseLeave.bind(null, open),
                            children: children
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition), {
                            as: (0, $acw62.Fragment),
                            enter: "transition ease-out duration-500",
                            enterFrom: "opacity-0 translate-y-1",
                            enterTo: "opacity-100 translate-y-0",
                            leave: "transition ease-in duration-450",
                            leaveFrom: "opacity-100 translate-y-0",
                            leaveTo: "opacity-0 translate-y-1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ahYsj.Popover).Panel, {
                                className: (0, $9QePP.default)(position === "top" ? "top-[-40px]" : "bottom-[-10px]", "shadow-boxShadow rounded-cta absolute z-10 min-w-[128px] bg-white px-4 py-2", size),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "body-s text-center text-black",
                                    children: content
                                })
                            })
                        })
                    ]
                })
        })
    });
}

});
parcelRegister("ahYsj", function(module, exports) {

$parcel$export(module.exports, "Popover", () => $77da6324ebaeb061$export$5b6b19405a83ff9d);

var $kd7LS = parcelRequire("kd7LS");

var $6o6B3 = parcelRequire("6o6B3");

var $acw62 = parcelRequire("acw62");

var $cE9hP = parcelRequire("cE9hP");

var $dfvrc = parcelRequire("dfvrc");

var $114Mg = parcelRequire("114Mg");

var $lwoRo = parcelRequire("lwoRo");

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");

var $ltgxC = parcelRequire("ltgxC");

var $dcp2r = parcelRequire("dcp2r");

var $23pTr = parcelRequire("23pTr");

var $5IEAk = parcelRequire("5IEAk");

var $gm4XX = parcelRequire("gm4XX");

var $jbIlv = parcelRequire("jbIlv");

var $hZodg = parcelRequire("hZodg");

var $6mpbl = parcelRequire("6mpbl");

var $3nJyP = parcelRequire("3nJyP");

var $bdknl = parcelRequire("bdknl");

var $5ETDl = parcelRequire("5ETDl");

var $34Str = parcelRequire("34Str");

var $k9Al5 = parcelRequire("k9Al5");

var $auuNT = parcelRequire("auuNT");

var $5fYEB = parcelRequire("5fYEB");

var $hsQxB = parcelRequire("hsQxB");

var $6Ngq1 = parcelRequire("6Ngq1");


var $gxwGc = parcelRequire("gxwGc");

var $ebRQH = parcelRequire("ebRQH");

var $6AKlm = parcelRequire("6AKlm");

var $e9NTc = parcelRequire("e9NTc");
"use client";
var $77da6324ebaeb061$var$lt = ((f)=>(f[f.Open = 0] = "Open", f[f.Closed = 1] = "Closed", f))($77da6324ebaeb061$var$lt || {}), $77da6324ebaeb061$var$at = ((p)=>(p[p.TogglePopover = 0] = "TogglePopover", p[p.ClosePopover = 1] = "ClosePopover", p[p.SetButton = 2] = "SetButton", p[p.SetButtonId = 3] = "SetButtonId", p[p.SetPanel = 4] = "SetPanel", p[p.SetPanelId = 5] = "SetPanelId", p))($77da6324ebaeb061$var$at || {});
let $77da6324ebaeb061$var$pt = {
    [0]: (o)=>({
            ...o,
            popoverState: (0, $6Ngq1.match)(o.popoverState, {
                [0]: 1,
                [1]: 0
            }),
            __demoMode: !1
        }),
    [1] (o) {
        return o.popoverState === 1 ? o : {
            ...o,
            popoverState: 1,
            __demoMode: !1
        };
    },
    [2] (o, a) {
        return o.button === a.button ? o : {
            ...o,
            button: a.button
        };
    },
    [3] (o, a) {
        return o.buttonId === a.buttonId ? o : {
            ...o,
            buttonId: a.buttonId
        };
    },
    [4] (o, a) {
        return o.panel === a.panel ? o : {
            ...o,
            panel: a.panel
        };
    },
    [5] (o, a) {
        return o.panelId === a.panelId ? o : {
            ...o,
            panelId: a.panelId
        };
    }
}, $77da6324ebaeb061$var$Ee = (0, $acw62.createContext)(null);
$77da6324ebaeb061$var$Ee.displayName = "PopoverContext";
function $77da6324ebaeb061$var$se(o) {
    let a = (0, $acw62.useContext)($77da6324ebaeb061$var$Ee);
    if (a === null) {
        let f = new Error(`<${o} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(f, $77da6324ebaeb061$var$se), f;
    }
    return a;
}
let $77da6324ebaeb061$var$ue = (0, $acw62.createContext)(null);
$77da6324ebaeb061$var$ue.displayName = "PopoverAPIContext";
function $77da6324ebaeb061$var$be(o) {
    let a = (0, $acw62.useContext)($77da6324ebaeb061$var$ue);
    if (a === null) {
        let f = new Error(`<${o} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(f, $77da6324ebaeb061$var$be), f;
    }
    return a;
}
let $77da6324ebaeb061$var$ge = (0, $acw62.createContext)(null);
$77da6324ebaeb061$var$ge.displayName = "PopoverGroupContext";
function $77da6324ebaeb061$var$Me() {
    return (0, $acw62.useContext)($77da6324ebaeb061$var$ge);
}
let $77da6324ebaeb061$var$ie = (0, $acw62.createContext)(null);
$77da6324ebaeb061$var$ie.displayName = "PopoverPanelContext";
function $77da6324ebaeb061$var$st() {
    return (0, $acw62.useContext)($77da6324ebaeb061$var$ie);
}
function $77da6324ebaeb061$var$ut(o, a) {
    return (0, $6Ngq1.match)(a.type, $77da6324ebaeb061$var$pt, o, a);
}
let $77da6324ebaeb061$var$it = "div";
function $77da6324ebaeb061$var$dt(o, a) {
    var J;
    let { __demoMode: f = !1, ...C } = o, T = (0, $acw62.useRef)(null), S = (0, $6mpbl.useSyncRefs)(a, (0, $6mpbl.optionalRef)((t)=>{
        T.current = t;
    })), p = (0, $acw62.useRef)([]), l = (0, $acw62.useReducer)($77da6324ebaeb061$var$ut, {
        __demoMode: f,
        popoverState: f ? 0 : 1,
        buttons: p,
        button: null,
        buttonId: null,
        panel: null,
        panelId: null,
        beforePanelSentinel: (0, $acw62.createRef)(),
        afterPanelSentinel: (0, $acw62.createRef)(),
        afterButtonSentinel: (0, $acw62.createRef)()
    }), [{ popoverState: c, button: d, buttonId: r, panel: s, panelId: R, beforePanelSentinel: m, afterPanelSentinel: h, afterButtonSentinel: P }, n] = l, v = (0, $5IEAk.useOwnerDocument)((J = T.current) != null ? J : d), g = (0, $acw62.useMemo)(()=>{
        if (!d || !s) return !1;
        for (let E of document.querySelectorAll("body > *"))if (Number(E == null ? void 0 : E.contains(d)) ^ Number(E == null ? void 0 : E.contains(s))) return !0;
        let t = (0, $hsQxB.getFocusableElements)(), e = t.indexOf(d), u = (e + t.length - 1) % t.length, i = (e + 1) % t.length, A = t[u], x = t[i];
        return !s.contains(A) && !s.contains(x);
    }, [
        d,
        s
    ]), _ = (0, $ltgxC.useLatestValue)(r), L = (0, $ltgxC.useLatestValue)(R), I = (0, $acw62.useMemo)(()=>({
            buttonId: _,
            panelId: L,
            close: ()=>n({
                    type: 1
                })
        }), [
        _,
        L,
        n
    ]), M = $77da6324ebaeb061$var$Me(), k = M == null ? void 0 : M.registerPopover, B = (0, $114Mg.useEvent)(()=>{
        var t;
        return (t = M == null ? void 0 : M.isFocusWithinPopoverGroup()) != null ? t : (v == null ? void 0 : v.activeElement) && ((d == null ? void 0 : d.contains(v.activeElement)) || (s == null ? void 0 : s.contains(v.activeElement)));
    });
    (0, $acw62.useEffect)(()=>k == null ? void 0 : k(I), [
        k,
        I
    ]);
    let [U, O] = (0, $e9NTc.useNestedPortals)(), N = (0, $jbIlv.useMainTreeNode)(d), w = (0, $jbIlv.useRootContainers)({
        mainTreeNode: N,
        portals: U,
        defaultContainers: [
            d,
            s
        ]
    });
    (0, $lwoRo.useEventListener)(v == null ? void 0 : v.defaultView, "focus", (t)=>{
        var e, u, i, A, x, E;
        t.target !== window && t.target instanceof HTMLElement && c === 0 && (B() || d && s && (w.contains(t.target) || (u = (e = m.current) == null ? void 0 : e.contains) != null && u.call(e, t.target) || (A = (i = h.current) == null ? void 0 : i.contains) != null && A.call(i, t.target) || (E = (x = P.current) == null ? void 0 : x.contains) != null && E.call(x, t.target) || n({
            type: 1
        })));
    }, !0), (0, $23pTr.useOutsideClick)(c === 0, w.resolveContainers, (t, e)=>{
        n({
            type: 1
        }), (0, $hsQxB.isFocusableElement)(e, (0, $hsQxB.FocusableMode).Loose) || (t.preventDefault(), d == null || d.focus());
    });
    let F = (0, $114Mg.useEvent)((t)=>{
        n({
            type: 1
        });
        let e = (()=>t ? t instanceof HTMLElement ? t : "current" in t && t.current instanceof HTMLElement ? t.current : d : d)();
        e == null || e.focus();
    }), Q = (0, $acw62.useMemo)(()=>({
            close: F,
            isPortalled: g
        }), [
        F,
        g
    ]), K = (0, $acw62.useMemo)(()=>({
            open: c === 0,
            close: F
        }), [
        c,
        F
    ]), Z = {
        ref: S
    }, $ = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jbIlv.MainTreeProvider), {
        node: N
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $34Str.FloatingProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77da6324ebaeb061$var$ie.Provider, {
        value: null
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77da6324ebaeb061$var$Ee.Provider, {
        value: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77da6324ebaeb061$var$ue.Provider, {
        value: Q
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5ETDl.CloseProvider), {
        value: F
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $auuNT.OpenClosedProvider), {
        value: (0, $6Ngq1.match)(c, {
            [0]: (0, $auuNT.State).Open,
            [1]: (0, $auuNT.State).Closed
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(O, null, $({
        ourProps: Z,
        theirProps: C,
        slot: K,
        defaultTag: $77da6324ebaeb061$var$it,
        name: "Popover"
    })))))))));
}
let $77da6324ebaeb061$var$Pt = "button";
function $77da6324ebaeb061$var$ft(o, a) {
    let f = (0, $acw62.useId)(), { id: C = `headlessui-popover-button-${f}`, disabled: T = !1, autoFocus: S = !1, ...p } = o, [l, c] = $77da6324ebaeb061$var$se("Popover.Button"), { isPortalled: d } = $77da6324ebaeb061$var$be("Popover.Button"), r = (0, $acw62.useRef)(null), s = `headlessui-focus-sentinel-${(0, $acw62.useId)()}`, R = $77da6324ebaeb061$var$Me(), m = R == null ? void 0 : R.closeOthers, P = $77da6324ebaeb061$var$st() !== null;
    (0, $acw62.useEffect)(()=>{
        if (!P) return c({
            type: 3,
            buttonId: C
        }), ()=>{
            c({
                type: 3,
                buttonId: null
            });
        };
    }, [
        P,
        C,
        c
    ]);
    let [n] = (0, $acw62.useState)(()=>Symbol()), v = (0, $6mpbl.useSyncRefs)(r, a, (0, $34Str.useFloatingReference)(), (0, $114Mg.useEvent)((e)=>{
        if (!P) {
            if (e) l.buttons.current.push(n);
            else {
                let u = l.buttons.current.indexOf(n);
                u !== -1 && l.buttons.current.splice(u, 1);
            }
            l.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), e && c({
                type: 2,
                button: e
            });
        }
    })), g = (0, $6mpbl.useSyncRefs)(r, a), _ = (0, $5IEAk.useOwnerDocument)(r), L = (0, $114Mg.useEvent)((e)=>{
        var u, i, A;
        if (P) {
            if (l.popoverState === 1) return;
            switch(e.key){
                case (0, $6AKlm.Keys).Space:
                case (0, $6AKlm.Keys).Enter:
                    e.preventDefault(), (i = (u = e.target).click) == null || i.call(u), c({
                        type: 1
                    }), (A = l.button) == null || A.focus();
                    break;
            }
        } else switch(e.key){
            case (0, $6AKlm.Keys).Space:
            case (0, $6AKlm.Keys).Enter:
                e.preventDefault(), e.stopPropagation(), l.popoverState === 1 && (m == null || m(l.buttonId)), c({
                    type: 0
                });
                break;
            case (0, $6AKlm.Keys).Escape:
                if (l.popoverState !== 0) return m == null ? void 0 : m(l.buttonId);
                if (!r.current || _ != null && _.activeElement && !r.current.contains(_.activeElement)) return;
                e.preventDefault(), e.stopPropagation(), c({
                    type: 1
                });
                break;
        }
    }), I = (0, $114Mg.useEvent)((e)=>{
        P || e.key === (0, $6AKlm.Keys).Space && e.preventDefault();
    }), M = (0, $114Mg.useEvent)((e)=>{
        var u, i;
        (0, $5fYEB.isDisabledReactIssue7711)(e.currentTarget) || T || (P ? (c({
            type: 1
        }), (u = l.button) == null || u.focus()) : (e.preventDefault(), e.stopPropagation(), l.popoverState === 1 && (m == null || m(l.buttonId)), c({
            type: 0
        }), (i = l.button) == null || i.focus()));
    }), k = (0, $114Mg.useEvent)((e)=>{
        e.preventDefault(), e.stopPropagation();
    }), { isFocusVisible: B, focusProps: U } = (0, $kd7LS.useFocusRing)({
        autoFocus: S
    }), { isHovered: O, hoverProps: N } = (0, $6o6B3.useHover)({
        isDisabled: T
    }), { pressed: w, pressProps: Y } = (0, $cE9hP.useActivePress)({
        disabled: T
    }), F = l.popoverState === 0, Q = (0, $acw62.useMemo)(()=>({
            open: F,
            active: w || F,
            disabled: T,
            hover: O,
            focus: B,
            autofocus: S
        }), [
        F,
        O,
        B,
        w,
        T,
        S
    ]), K = (0, $gm4XX.useResolveButtonType)(o, l.button), Z = P ? (0, $ebRQH.mergeProps)({
        ref: g,
        type: K,
        onKeyDown: L,
        onClick: M,
        disabled: T || void 0,
        autoFocus: S
    }, U, N, Y) : (0, $ebRQH.mergeProps)({
        ref: v,
        id: l.buttonId,
        type: K,
        "aria-expanded": l.popoverState === 0,
        "aria-controls": l.panel ? l.panelId : void 0,
        disabled: T || void 0,
        autoFocus: S,
        onKeyDown: L,
        onKeyUp: I,
        onClick: M,
        onMouseDown: k
    }, U, N, Y), $ = (0, $3nJyP.useTabDirection)(), J = (0, $114Mg.useEvent)(()=>{
        let e = l.panel;
        if (!e) return;
        function u() {
            (0, $6Ngq1.match)($.current, {
                [(0, $3nJyP.Direction).Forwards]: ()=>(0, $hsQxB.focusIn)(e, (0, $hsQxB.Focus).First),
                [(0, $3nJyP.Direction).Backwards]: ()=>(0, $hsQxB.focusIn)(e, (0, $hsQxB.Focus).Last)
            }) === (0, $hsQxB.FocusResult).Error && (0, $hsQxB.focusIn)((0, $hsQxB.getFocusableElements)().filter((A)=>A.dataset.headlessuiFocusGuard !== "true"), (0, $6Ngq1.match)($.current, {
                [(0, $3nJyP.Direction).Forwards]: (0, $hsQxB.Focus).Next,
                [(0, $3nJyP.Direction).Backwards]: (0, $hsQxB.Focus).Previous
            }), {
                relativeTo: l.button
            });
        }
        u();
    }), t = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, t({
        ourProps: Z,
        theirProps: p,
        slot: Q,
        defaultTag: $77da6324ebaeb061$var$Pt,
        name: "Popover.Button"
    }), F && !P && d && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        id: s,
        ref: l.afterButtonSentinel,
        features: (0, $k9Al5.HiddenFeatures).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: J
    }));
}
let $77da6324ebaeb061$var$ct = "div", $77da6324ebaeb061$var$vt = (0, $ebRQH.RenderFeatures).RenderStrategy | (0, $ebRQH.RenderFeatures).Static;
function $77da6324ebaeb061$var$Oe(o, a) {
    let f = (0, $acw62.useId)(), { id: C = `headlessui-popover-backdrop-${f}`, transition: T = !1, ...S } = o, [{ popoverState: p }, l] = $77da6324ebaeb061$var$se("Popover.Backdrop"), [c, d] = (0, $acw62.useState)(null), r = (0, $6mpbl.useSyncRefs)(a, d), s = (0, $auuNT.useOpenClosed)(), [R, m] = (0, $bdknl.useTransition)(T, c, s !== null ? (s & (0, $auuNT.State).Open) === (0, $auuNT.State).Open : p === 0), h = (0, $114Mg.useEvent)((g)=>{
        if ((0, $5fYEB.isDisabledReactIssue7711)(g.currentTarget)) return g.preventDefault();
        l({
            type: 1
        });
    }), P = (0, $acw62.useMemo)(()=>({
            open: p === 0
        }), [
        p
    ]), n = {
        ref: r,
        id: C,
        "aria-hidden": !0,
        onClick: h,
        ...(0, $bdknl.transitionDataAttributes)(m)
    };
    return (0, $ebRQH.useRender)()({
        ourProps: n,
        theirProps: S,
        slot: P,
        defaultTag: $77da6324ebaeb061$var$ct,
        features: $77da6324ebaeb061$var$vt,
        visible: R,
        name: "Popover.Backdrop"
    });
}
let $77da6324ebaeb061$var$Tt = "div", $77da6324ebaeb061$var$mt = (0, $ebRQH.RenderFeatures).RenderStrategy | (0, $ebRQH.RenderFeatures).Static;
function $77da6324ebaeb061$var$yt(o, a) {
    let f = (0, $acw62.useId)(), { id: C = `headlessui-popover-panel-${f}`, focus: T = !1, anchor: S, portal: p = !1, modal: l = !1, transition: c = !1, ...d } = o, [r, s] = $77da6324ebaeb061$var$se("Popover.Panel"), { close: R, isPortalled: m } = $77da6324ebaeb061$var$be("Popover.Panel"), h = `headlessui-focus-sentinel-before-${f}`, P = `headlessui-focus-sentinel-after-${f}`, n = (0, $acw62.useRef)(null), v = (0, $34Str.useResolvedAnchor)(S), [g, _] = (0, $34Str.useFloatingPanel)(v), L = (0, $34Str.useFloatingPanelProps)();
    v && (p = !0);
    let [I, M] = (0, $acw62.useState)(null), k = (0, $6mpbl.useSyncRefs)(n, a, v ? g : null, (0, $114Mg.useEvent)((t)=>s({
            type: 4,
            panel: t
        })), M), B = (0, $5IEAk.useOwnerDocument)(n);
    (0, $8KgIp.useIsoMorphicEffect)(()=>(s({
            type: 5,
            panelId: C
        }), ()=>{
            s({
                type: 5,
                panelId: null
            });
        }), [
        C,
        s
    ]);
    let U = (0, $auuNT.useOpenClosed)(), [O, N] = (0, $bdknl.useTransition)(c, I, U !== null ? (U & (0, $auuNT.State).Open) === (0, $auuNT.State).Open : r.popoverState === 0);
    (0, $dcp2r.useOnDisappear)(O, r.button, ()=>{
        s({
            type: 1
        });
    });
    let w = r.__demoMode ? !1 : l && O;
    (0, $hZodg.useScrollLock)(w, B);
    let Y = (0, $114Mg.useEvent)((t)=>{
        var e;
        switch(t.key){
            case (0, $6AKlm.Keys).Escape:
                if (r.popoverState !== 0 || !n.current || B != null && B.activeElement && !n.current.contains(B.activeElement)) return;
                t.preventDefault(), t.stopPropagation(), s({
                    type: 1
                }), (e = r.button) == null || e.focus();
                break;
        }
    });
    (0, $acw62.useEffect)(()=>{
        var t;
        o.static || r.popoverState === 1 && ((t = o.unmount) == null || t) && s({
            type: 4,
            panel: null
        });
    }, [
        r.popoverState,
        o.unmount,
        o.static,
        s
    ]), (0, $acw62.useEffect)(()=>{
        if (r.__demoMode || !T || r.popoverState !== 0 || !n.current) return;
        let t = B == null ? void 0 : B.activeElement;
        n.current.contains(t) || (0, $hsQxB.focusIn)(n.current, (0, $hsQxB.Focus).First);
    }, [
        r.__demoMode,
        T,
        n.current,
        r.popoverState
    ]);
    let F = (0, $acw62.useMemo)(()=>({
            open: r.popoverState === 0,
            close: R
        }), [
        r.popoverState,
        R
    ]), Q = (0, $ebRQH.mergeProps)(v ? L() : {}, {
        ref: k,
        id: C,
        onKeyDown: Y,
        onBlur: T && r.popoverState === 0 ? (t)=>{
            var u, i, A, x, E;
            let e = t.relatedTarget;
            e && n.current && ((u = n.current) != null && u.contains(e) || (s({
                type: 1
            }), ((A = (i = r.beforePanelSentinel.current) == null ? void 0 : i.contains) != null && A.call(i, e) || (E = (x = r.afterPanelSentinel.current) == null ? void 0 : x.contains) != null && E.call(x, e)) && e.focus({
                preventScroll: !0
            })));
        } : void 0,
        tabIndex: -1,
        style: {
            ...d.style,
            ..._,
            "--button-width": (0, $dfvrc.useElementSize)(r.button, !0).width
        },
        ...(0, $bdknl.transitionDataAttributes)(N)
    }), K = (0, $3nJyP.useTabDirection)(), Z = (0, $114Mg.useEvent)(()=>{
        let t = n.current;
        if (!t) return;
        function e() {
            (0, $6Ngq1.match)(K.current, {
                [(0, $3nJyP.Direction).Forwards]: ()=>{
                    var i;
                    (0, $hsQxB.focusIn)(t, (0, $hsQxB.Focus).First) === (0, $hsQxB.FocusResult).Error && ((i = r.afterPanelSentinel.current) == null || i.focus());
                },
                [(0, $3nJyP.Direction).Backwards]: ()=>{
                    var u;
                    (u = r.button) == null || u.focus({
                        preventScroll: !0
                    });
                }
            });
        }
        e();
    }), $ = (0, $114Mg.useEvent)(()=>{
        let t = n.current;
        if (!t) return;
        function e() {
            (0, $6Ngq1.match)(K.current, {
                [(0, $3nJyP.Direction).Forwards]: ()=>{
                    if (!r.button) return;
                    let u = (0, $hsQxB.getFocusableElements)(), i = u.indexOf(r.button), A = u.slice(0, i + 1), E = [
                        ...u.slice(i + 1),
                        ...A
                    ];
                    for (let de of E.slice())if (de.dataset.headlessuiFocusGuard === "true" || I != null && I.contains(de)) {
                        let Se = E.indexOf(de);
                        Se !== -1 && E.splice(Se, 1);
                    }
                    (0, $hsQxB.focusIn)(E, (0, $hsQxB.Focus).First, {
                        sorted: !1
                    });
                },
                [(0, $3nJyP.Direction).Backwards]: ()=>{
                    var i;
                    (0, $hsQxB.focusIn)(t, (0, $hsQxB.Focus).Previous) === (0, $hsQxB.FocusResult).Error && ((i = r.button) == null || i.focus());
                }
            });
        }
        e();
    }), J = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $auuNT.ResetOpenClosedProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77da6324ebaeb061$var$ie.Provider, {
        value: C
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77da6324ebaeb061$var$ue.Provider, {
        value: {
            close: R,
            isPortalled: m
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e9NTc.Portal), {
        enabled: p ? o.static || O : !1
    }, O && m && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        id: h,
        ref: r.beforePanelSentinel,
        features: (0, $k9Al5.HiddenFeatures).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: Z
    }), J({
        ourProps: Q,
        theirProps: d,
        slot: F,
        defaultTag: $77da6324ebaeb061$var$Tt,
        features: $77da6324ebaeb061$var$mt,
        visible: O,
        name: "Popover.Panel"
    }), O && m && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        id: P,
        ref: r.afterPanelSentinel,
        features: (0, $k9Al5.HiddenFeatures).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: $
    })))));
}
let $77da6324ebaeb061$var$Et = "div";
function $77da6324ebaeb061$var$bt(o, a) {
    let f = (0, $acw62.useRef)(null), C = (0, $6mpbl.useSyncRefs)(f, a), [T, S] = (0, $acw62.useState)([]), p = (0, $114Mg.useEvent)((P)=>{
        S((n)=>{
            let v = n.indexOf(P);
            if (v !== -1) {
                let g = n.slice();
                return g.splice(v, 1), g;
            }
            return n;
        });
    }), l = (0, $114Mg.useEvent)((P)=>(S((n)=>[
                ...n,
                P
            ]), ()=>p(P))), c = (0, $114Mg.useEvent)(()=>{
        var v;
        let P = (0, $gxwGc.getOwnerDocument)(f);
        if (!P) return !1;
        let n = P.activeElement;
        return (v = f.current) != null && v.contains(n) ? !0 : T.some((g)=>{
            var _, L;
            return ((_ = P.getElementById(g.buttonId.current)) == null ? void 0 : _.contains(n)) || ((L = P.getElementById(g.panelId.current)) == null ? void 0 : L.contains(n));
        });
    }), d = (0, $114Mg.useEvent)((P)=>{
        for (let n of T)n.buttonId.current !== P && n.close();
    }), r = (0, $acw62.useMemo)(()=>({
            registerPopover: l,
            unregisterPopover: p,
            isFocusWithinPopoverGroup: c,
            closeOthers: d
        }), [
        l,
        p,
        c,
        d
    ]), s = (0, $acw62.useMemo)(()=>({}), []), R = o, m = {
        ref: C
    }, h = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jbIlv.MainTreeProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77da6324ebaeb061$var$ge.Provider, {
        value: r
    }, h({
        ourProps: m,
        theirProps: R,
        slot: s,
        defaultTag: $77da6324ebaeb061$var$Et,
        name: "Popover.Group"
    })));
}
let $77da6324ebaeb061$var$gt = (0, $ebRQH.forwardRefWithAs)($77da6324ebaeb061$var$dt), $77da6324ebaeb061$export$c71dc08a6f474856 = (0, $ebRQH.forwardRefWithAs)($77da6324ebaeb061$var$ft), $77da6324ebaeb061$export$ec8dd1b2334697d6 = (0, $ebRQH.forwardRefWithAs)($77da6324ebaeb061$var$Oe), $77da6324ebaeb061$export$c1dfca41042a7ba8 = (0, $ebRQH.forwardRefWithAs)($77da6324ebaeb061$var$Oe), $77da6324ebaeb061$export$479aa83e4f119f19 = (0, $ebRQH.forwardRefWithAs)($77da6324ebaeb061$var$yt), $77da6324ebaeb061$export$97015eea9f4d03a9 = (0, $ebRQH.forwardRefWithAs)($77da6324ebaeb061$var$bt), $77da6324ebaeb061$export$5b6b19405a83ff9d = Object.assign($77da6324ebaeb061$var$gt, {
    Button: $77da6324ebaeb061$export$c71dc08a6f474856,
    Backdrop: $77da6324ebaeb061$export$c1dfca41042a7ba8,
    Overlay: $77da6324ebaeb061$export$ec8dd1b2334697d6,
    Panel: $77da6324ebaeb061$export$479aa83e4f119f19,
    Group: $77da6324ebaeb061$export$97015eea9f4d03a9
});

});



parcelRegister("bCQeH", function(module, exports) {
parcelRequire("kF5Cx");

});
parcelRegister("kF5Cx", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $ae1ae858e27f484b$export$7f64fe02d2d45e7({ testId: testId, className: className, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("border-default flex rounded-full border p-6", className),
        "data-testid": testId,
        children: children
    });
}

});


parcelRegister("1g6z2", function(module, exports) {
parcelRequire("7fddG");

});
parcelRegister("7fddG", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $22i8b = parcelRequire("22i8b");

var $lrVF0 = parcelRequire("lrVF0");

var $9QePP = parcelRequire("9QePP");
var $d77ad1c7d654c4ae$export$e3e192396a66c679;
(function(FieldMode) {
    FieldMode["TEXT"] = "text";
    FieldMode["PASSWORD"] = "password";
    FieldMode["MONEY"] = "money";
    FieldMode["TEXTAREA"] = "textarea";
})($d77ad1c7d654c4ae$export$e3e192396a66c679 || ($d77ad1c7d654c4ae$export$e3e192396a66c679 = {}));
const $d77ad1c7d654c4ae$export$a455218a85c89869 = ({ label: label, className: className, name: name, type: type = "text", control: control, error: error, placeholder: placeholder, required: required = false })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            label && /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                className: "subdued",
                "data-testid": name,
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `mt-2 ${className}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22i8b.Controller), {
                        name: name,
                        control: control,
                        defaultValue: "",
                        render: ({ field: { ref: ref, onChange: onChange, ...rest } })=>{
                            if (type === "money") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lrVF0.NumericFormat), {
                                getInputRef: ref,
                                allowNegative: false,
                                thousandSeparator: ",",
                                required: required,
                                prefix: "$",
                                decimalScale: 0,
                                id: name,
                                onValueChange: (v)=>{
                                    onChange(Number(v.value));
                                },
                                type: "text",
                                ...rest,
                                placeholder: placeholder,
                                className: (0, $9QePP.default)("bg-secondary w-full px-4 py-3", "ring-1 ring-inset ring-slate-300 dark:ring-slate-700", "subdued block rounded-md border-0", "focus:ring-interactive placeholder:text-disabledTextColor focus:ring-2 focus:ring-inset focus:placeholder:text-transparent")
                            });
                            else if (type === "textarea") return /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                onChange: onChange,
                                ref: ref,
                                required: required,
                                id: name,
                                ...rest,
                                rows: 4,
                                placeholder: placeholder,
                                className: (0, $9QePP.default)("bg-secondary w-full px-4 py-3", "ring-1 ring-inset ring-slate-300 dark:ring-slate-700", "subdued block rounded-md border-0", "focus:ring-interactive placeholder:text-disabledTextColor focus:ring-2 focus:ring-inset focus:placeholder:text-transparent")
                            });
                            else return /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                onChange: onChange,
                                ref: ref,
                                required: required,
                                id: name,
                                type: type,
                                ...rest,
                                placeholder: placeholder,
                                className: (0, $9QePP.default)("bg-secondary w-full px-4 py-3", "ring-1 ring-inset ring-slate-300 dark:ring-slate-700", "subdued block rounded-md border-0", "focus:ring-interactive placeholder:text-disabledTextColor focus:ring-2 focus:ring-inset focus:placeholder:text-transparent")
                            });
                        }
                    }),
                    error && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-micro text-interactive-destructive-default mt-1",
                        children: error
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("22i8b", function(module, exports) {

$parcel$export(module.exports, "Controller", () => $0d70f179cf56e662$export$bd0bf19f25da8474);

var $acw62 = parcelRequire("acw62");
var $0d70f179cf56e662$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $0d70f179cf56e662$var$isDateObject = (value1)=>value1 instanceof Date;
var $0d70f179cf56e662$var$isNullOrUndefined = (value1)=>value1 == null;
const $0d70f179cf56e662$var$isObjectType = (value1)=>typeof value1 === "object";
var $0d70f179cf56e662$var$isObject = (value1)=>!$0d70f179cf56e662$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $0d70f179cf56e662$var$isObjectType(value1) && !$0d70f179cf56e662$var$isDateObject(value1);
var $0d70f179cf56e662$var$getEventValue = (event)=>$0d70f179cf56e662$var$isObject(event) && event.target ? $0d70f179cf56e662$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $0d70f179cf56e662$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $0d70f179cf56e662$var$isNameInFieldArray = (names, name)=>names.has($0d70f179cf56e662$var$getNodeParentName(name));
var $0d70f179cf56e662$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $0d70f179cf56e662$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $0d70f179cf56e662$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $0d70f179cf56e662$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($0d70f179cf56e662$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $0d70f179cf56e662$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$0d70f179cf56e662$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $0d70f179cf56e662$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $0d70f179cf56e662$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $0d70f179cf56e662$var$isUndefined = (val)=>val === undefined;
var $0d70f179cf56e662$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$0d70f179cf56e662$var$isObject(object)) return defaultValue;
    const result = $0d70f179cf56e662$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$0d70f179cf56e662$var$isNullOrUndefined(result) ? result : result[key], object);
    return $0d70f179cf56e662$var$isUndefined(result) || result === object ? $0d70f179cf56e662$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $0d70f179cf56e662$var$isBoolean = (value1)=>typeof value1 === "boolean";
const $0d70f179cf56e662$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $0d70f179cf56e662$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $0d70f179cf56e662$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $0d70f179cf56e662$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($0d70f179cf56e662$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0d70f179cf56e662$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $0d70f179cf56e662$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $0d70f179cf56e662$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $0d70f179cf56e662$var$isEmptyObject = (value1)=>$0d70f179cf56e662$var$isObject(value1) && !Object.keys(value1).length;
var $0d70f179cf56e662$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $0d70f179cf56e662$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all));
};
var $0d70f179cf56e662$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $0d70f179cf56e662$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $0d70f179cf56e662$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $0d70f179cf56e662$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$606f11b2eb45ecc6(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    _name.current = name;
    $0d70f179cf56e662$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $0d70f179cf56e662$var$shouldSubscribeByName(_name.current, value1.name, exact) && $0d70f179cf56e662$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $0d70f179cf56e662$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $0d70f179cf56e662$var$isString = (value1)=>typeof value1 === "string";
var $0d70f179cf56e662$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($0d70f179cf56e662$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $0d70f179cf56e662$export$3c773aa2b84f29e0(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    _name.current = name;
    $0d70f179cf56e662$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($0d70f179cf56e662$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._removeUnmounted());
    return value1;
}
var $0d70f179cf56e662$var$isKey = (value1)=>/^\w*$/.test(value1);
var $0d70f179cf56e662$var$stringToPath = (input)=>$0d70f179cf56e662$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var $0d70f179cf56e662$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $0d70f179cf56e662$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$e8c786024a2b0a79(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $0d70f179cf56e662$var$isNameInFieldArray(control._names.array, name);
    const value1 = $0d70f179cf56e662$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name, $0d70f179cf56e662$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $0d70f179cf56e662$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$0d70f179cf56e662$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($0d70f179cf56e662$var$isUndefined($0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name))) $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name,
            value: $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$0d70f179cf56e662$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $0d70f179cf56e662$var$getEventValue(event),
                        name: name
                    },
                    type: $0d70f179cf56e662$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $0d70f179cf56e662$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $0d70f179cf56e662$export$bd0bf19f25da8474 = (props)=>props.render($0d70f179cf56e662$export$e8c786024a2b0a79(props));
const $0d70f179cf56e662$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$a7fed597f4b8afd8(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $0d70f179cf56e662$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            for (const name of control._names.mount)formData.append(name, $0d70f179cf56e662$export$3988ae62b71be9a3(data, name));
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $0d70f179cf56e662$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $0d70f179cf56e662$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $0d70f179cf56e662$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $0d70f179cf56e662$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$0d70f179cf56e662$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $0d70f179cf56e662$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $0d70f179cf56e662$var$VALIDATION_MODE.all,
        isOnTouch: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onTouched
    });
var $0d70f179cf56e662$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $0d70f179cf56e662$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) break;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) break;
                else $0d70f179cf56e662$var$iterateFieldsByAction(currentField, action);
            } else if ($0d70f179cf56e662$var$isObject(currentField)) $0d70f179cf56e662$var$iterateFieldsByAction(currentField, action);
        }
    }
};
var $0d70f179cf56e662$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(errors, name));
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $0d70f179cf56e662$var$isFileInput = (element)=>element.type === "file";
var $0d70f179cf56e662$var$isFunction = (value1)=>typeof value1 === "function";
var $0d70f179cf56e662$var$isHTMLElement = (value1)=>{
    if (!$0d70f179cf56e662$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $0d70f179cf56e662$var$isMessage = (value1)=>$0d70f179cf56e662$var$isString(value1);
var $0d70f179cf56e662$var$isRadioInput = (element)=>element.type === "radio";
var $0d70f179cf56e662$var$isRegex = (value1)=>value1 instanceof RegExp;
const $0d70f179cf56e662$var$defaultResult = {
    value: false,
    isValid: false
};
const $0d70f179cf56e662$var$validResult = {
    value: true,
    isValid: true
};
var $0d70f179cf56e662$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$0d70f179cf56e662$var$isUndefined(options[0].attributes.value) ? $0d70f179cf56e662$var$isUndefined(options[0].value) || options[0].value === "" ? $0d70f179cf56e662$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $0d70f179cf56e662$var$validResult : $0d70f179cf56e662$var$defaultResult;
    }
    return $0d70f179cf56e662$var$defaultResult;
};
const $0d70f179cf56e662$var$defaultReturn = {
    isValid: false,
    value: null
};
var $0d70f179cf56e662$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $0d70f179cf56e662$var$defaultReturn) : $0d70f179cf56e662$var$defaultReturn;
function $0d70f179cf56e662$var$getValidateError(result, ref, type = "validate") {
    if ($0d70f179cf56e662$var$isMessage(result) || Array.isArray(result) && result.every($0d70f179cf56e662$var$isMessage) || $0d70f179cf56e662$var$isBoolean(result) && !result) return {
        type: type,
        message: $0d70f179cf56e662$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $0d70f179cf56e662$var$getValueAndMessage = (validationData)=>$0d70f179cf56e662$var$isObject(validationData) && !$0d70f179cf56e662$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $0d70f179cf56e662$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($0d70f179cf56e662$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $0d70f179cf56e662$var$isRadioInput(ref);
    const isCheckBox = $0d70f179cf56e662$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $0d70f179cf56e662$var$isFileInput(ref)) && $0d70f179cf56e662$var$isUndefined(ref.value) && $0d70f179cf56e662$var$isUndefined(inputValue) || $0d70f179cf56e662$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $0d70f179cf56e662$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.maxLength, minType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $0d70f179cf56e662$var$isNullOrUndefined(inputValue)) || $0d70f179cf56e662$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$0d70f179cf56e662$var$getCheckboxValue(refs).isValid || isRadio && !$0d70f179cf56e662$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $0d70f179cf56e662$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $0d70f179cf56e662$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$0d70f179cf56e662$var$isNullOrUndefined(min) || !$0d70f179cf56e662$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $0d70f179cf56e662$var$getValueAndMessage(max);
        const minOutput = $0d70f179cf56e662$var$getValueAndMessage(min);
        if (!$0d70f179cf56e662$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$0d70f179cf56e662$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$0d70f179cf56e662$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($0d70f179cf56e662$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($0d70f179cf56e662$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.max, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($0d70f179cf56e662$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(maxLength);
        const minLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(minLength);
        const exceedMax = !$0d70f179cf56e662$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$0d70f179cf56e662$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $0d70f179cf56e662$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $0d70f179cf56e662$var$getValueAndMessage(pattern);
        if ($0d70f179cf56e662$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($0d70f179cf56e662$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $0d70f179cf56e662$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($0d70f179cf56e662$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$0d70f179cf56e662$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $0d70f179cf56e662$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$0d70f179cf56e662$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var $0d70f179cf56e662$var$appendAt = (data, value1)=>[
        ...data,
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1)
    ];
var $0d70f179cf56e662$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $0d70f179cf56e662$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $0d70f179cf56e662$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($0d70f179cf56e662$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $0d70f179cf56e662$var$prependAt = (data, value1)=>[
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...$0d70f179cf56e662$var$convertToArrayPayload(data)
    ];
function $0d70f179cf56e662$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $0d70f179cf56e662$var$compact(temp).length ? temp : [];
}
var $0d70f179cf56e662$var$removeArrayAt = (data, index)=>$0d70f179cf56e662$var$isUndefined(index) ? [] : $0d70f179cf56e662$var$removeAtIndexes(data, $0d70f179cf56e662$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $0d70f179cf56e662$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function $0d70f179cf56e662$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $0d70f179cf56e662$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $0d70f179cf56e662$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$0d70f179cf56e662$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $0d70f179cf56e662$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $0d70f179cf56e662$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($0d70f179cf56e662$var$isObject(childObject) && $0d70f179cf56e662$var$isEmptyObject(childObject) || Array.isArray(childObject) && $0d70f179cf56e662$var$isEmptyArray(childObject))) $0d70f179cf56e662$var$unset(object, paths.slice(0, -1));
    return object;
}
var $0d70f179cf56e662$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$310131896651d559(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control._getFieldArray(name).map($0d70f179cf56e662$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $0d70f179cf56e662$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $0d70f179cf56e662$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($0d70f179cf56e662$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $0d70f179cf56e662$var$appendAt(ids.current, appendValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$appendAt, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, 0, options);
        ids.current = $0d70f179cf56e662$var$prependAt(ids.current, prependValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$prependAt, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $0d70f179cf56e662$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, index, options);
        ids.current = $0d70f179cf56e662$var$insert(ids.current, index, insertValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$insert, {
            argA: index,
            argB: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $0d70f179cf56e662$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $0d70f179cf56e662$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $0d70f179cf56e662$var$cloneObject(value1);
        const updatedFieldArrayValues = $0d70f179cf56e662$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $0d70f179cf56e662$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($0d70f179cf56e662$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        control._state.action = false;
        $0d70f179cf56e662$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$0d70f179cf56e662$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $0d70f179cf56e662$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $0d70f179cf56e662$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $0d70f179cf56e662$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($0d70f179cf56e662$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $0d70f179cf56e662$var$getValidationModes(control._options.mode).isOnSubmit)) $0d70f179cf56e662$var$validateField(field, control._formValues, control._options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$0d70f179cf56e662$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $0d70f179cf56e662$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $0d70f179cf56e662$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        !$0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $0d70f179cf56e662$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var $0d70f179cf56e662$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $0d70f179cf56e662$var$isPrimitive = (value1)=>$0d70f179cf56e662$var$isNullOrUndefined(value1) || !$0d70f179cf56e662$var$isObjectType(value1);
function $0d70f179cf56e662$var$deepEqual(object1, object2) {
    if ($0d70f179cf56e662$var$isPrimitive(object1) || $0d70f179cf56e662$var$isPrimitive(object2)) return object1 === object2;
    if ($0d70f179cf56e662$var$isDateObject(object1) && $0d70f179cf56e662$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($0d70f179cf56e662$var$isDateObject(val1) && $0d70f179cf56e662$var$isDateObject(val2) || $0d70f179cf56e662$var$isObject(val1) && $0d70f179cf56e662$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$0d70f179cf56e662$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $0d70f179cf56e662$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $0d70f179cf56e662$var$isRadioOrCheckbox = (ref)=>$0d70f179cf56e662$var$isRadioInput(ref) || $0d70f179cf56e662$var$isCheckBoxInput(ref);
var $0d70f179cf56e662$var$live = (ref)=>$0d70f179cf56e662$var$isHTMLElement(ref) && ref.isConnected;
var $0d70f179cf56e662$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($0d70f179cf56e662$var$isFunction(data[key])) return true;
    }
    return false;
};
function $0d70f179cf56e662$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($0d70f179cf56e662$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $0d70f179cf56e662$var$isObject(data[key]) && !$0d70f179cf56e662$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $0d70f179cf56e662$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$0d70f179cf56e662$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($0d70f179cf56e662$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $0d70f179cf56e662$var$isObject(data[key]) && !$0d70f179cf56e662$var$objectHasFunction(data[key])) {
            if ($0d70f179cf56e662$var$isUndefined(formValues) || $0d70f179cf56e662$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $0d70f179cf56e662$var$markFieldsDirty(data[key], []) : {
                ...$0d70f179cf56e662$var$markFieldsDirty(data[key])
            };
            else $0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(data[key], $0d70f179cf56e662$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$0d70f179cf56e662$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $0d70f179cf56e662$var$getDirtyFields = (defaultValues, formValues)=>$0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $0d70f179cf56e662$var$markFieldsDirty(formValues));
var $0d70f179cf56e662$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$0d70f179cf56e662$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $0d70f179cf56e662$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $0d70f179cf56e662$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($0d70f179cf56e662$var$isFileInput(ref)) return ref.files;
    if ($0d70f179cf56e662$var$isRadioInput(ref)) return $0d70f179cf56e662$var$getRadioValue(_f.refs).value;
    if ($0d70f179cf56e662$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($0d70f179cf56e662$var$isCheckBoxInput(ref)) return $0d70f179cf56e662$var$getCheckboxValue(_f.refs).value;
    return $0d70f179cf56e662$var$getFieldValueAs($0d70f179cf56e662$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $0d70f179cf56e662$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        field && $0d70f179cf56e662$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $0d70f179cf56e662$var$getRuleValue = (rule)=>$0d70f179cf56e662$var$isUndefined(rule) ? rule : $0d70f179cf56e662$var$isRegex(rule) ? rule.source : $0d70f179cf56e662$var$isObject(rule) ? $0d70f179cf56e662$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $0d70f179cf56e662$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, name) {
    const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
    if (error || $0d70f179cf56e662$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $0d70f179cf56e662$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $0d70f179cf56e662$var$unsetEmptyArray = (ref, name)=>!$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(ref, name)).length && $0d70f179cf56e662$var$unset(ref, name);
const $0d70f179cf56e662$var$defaultOptions = {
    mode: $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $0d70f179cf56e662$var$createFormControl(props = {}) {
    let _options = {
        ...$0d70f179cf56e662$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $0d70f179cf56e662$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $0d70f179cf56e662$var$isObject(_options.defaultValues) || $0d70f179cf56e662$var$isObject(_options.values) ? $0d70f179cf56e662$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $0d70f179cf56e662$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $0d70f179cf56e662$var$createSubject(),
        array: $0d70f179cf56e662$var$createSubject(),
        state: $0d70f179cf56e662$var$createSubject()
    };
    const validationModeBeforeSubmit = $0d70f179cf56e662$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $0d70f179cf56e662$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $0d70f179cf56e662$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (_proxyFormState.isValidating || _proxyFormState.validatingFields) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $0d70f179cf56e662$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$0d70f179cf56e662$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $0d70f179cf56e662$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, $0d70f179cf56e662$var$isUndefined(value1) ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $0d70f179cf56e662$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $0d70f179cf56e662$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        const disabledField = !!($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name) && $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)._f.disabled);
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = disabledField || $0d70f179cf56e662$var$deepEqual($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = !!(!disabledField && $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, name));
            isCurrentFieldPristine || disabledField ? $0d70f179cf56e662$var$unset(_formState.dirtyFields, name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $0d70f179cf56e662$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        if ((error ? !$0d70f179cf56e662$var$deepEqual(previousFieldError, error) : previousFieldError) || !$0d70f179cf56e662$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $0d70f179cf56e662$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _executeSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $0d70f179cf56e662$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await $0d70f179cf56e662$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($0d70f179cf56e662$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $0d70f179cf56e662$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $0d70f179cf56e662$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$0d70f179cf56e662$var$live(ref)) : !$0d70f179cf56e662$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, data), !$0d70f179cf56e662$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$0d70f179cf56e662$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $0d70f179cf56e662$var$isUndefined(defaultValue) ? _defaultValues : $0d70f179cf56e662$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, $0d70f179cf56e662$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $0d70f179cf56e662$var$isHTMLElement(fieldReference.ref) && $0d70f179cf56e662$var$isNullOrUndefined(value1) ? "" : value1;
                if ($0d70f179cf56e662$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($0d70f179cf56e662$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($0d70f179cf56e662$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$0d70f179cf56e662$var$isPrimitive(fieldValue) || field && !field._f) && !$0d70f179cf56e662$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $0d70f179cf56e662$var$cloneObject(value1);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$0d70f179cf56e662$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $0d70f179cf56e662$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: _state.mount ? name : undefined,
            values: {
                ..._formValues
            }
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $0d70f179cf56e662$var$getFieldValue(field._f) : $0d70f179cf56e662$var$getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, fieldValue);
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $0d70f179cf56e662$var$EVENTS.BLUR || event.type === $0d70f179cf56e662$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$0d70f179cf56e662$var$hasValidation(field._f) && !_options.resolver && !$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $0d70f179cf56e662$var$skipValidation(isBlurEvent, $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $0d70f179cf56e662$var$isWatched(name, _names, isBlurEvent);
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$0d70f179cf56e662$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $0d70f179cf56e662$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $0d70f179cf56e662$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($0d70f179cf56e662$var$isUndefined(name) ? name : fieldNames);
            isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$0d70f179cf56e662$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $0d70f179cf56e662$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._state.mount ? _formValues : {}
        };
        return $0d70f179cf56e662$var$isUndefined(fieldNames) ? values : $0d70f179cf56e662$var$isString(fieldNames) ? $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            isValidating: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).validatingFields, name),
            error: $0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && $0d70f179cf56e662$var$convertToArrayPayload(name).forEach((inputName)=>$0d70f179cf56e662$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$0d70f179cf56e662$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $0d70f179cf56e662$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $0d70f179cf56e662$var$unset(_fields, fieldName);
                $0d70f179cf56e662$var$unset(_formValues, fieldName);
            }
            !options.keepError && $0d70f179cf56e662$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $0d70f179cf56e662$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $0d70f179cf56e662$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $0d70f179cf56e662$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $0d70f179cf56e662$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields, value: value1 })=>{
        if ($0d70f179cf56e662$var$isBoolean(disabled)) {
            const inputValue = disabled ? undefined : $0d70f179cf56e662$var$isUndefined(value1) ? $0d70f179cf56e662$var$getFieldValue(field ? field._f : $0d70f179cf56e662$export$3988ae62b71be9a3(fields, name)._f) : value1;
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $0d70f179cf56e662$var$isBoolean(options.disabled);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: options.disabled,
            name: name,
            value: options.value
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $0d70f179cf56e662$var$getRuleValue(options.min),
                max: $0d70f179cf56e662$var$getRuleValue(options.max),
                minLength: $0d70f179cf56e662$var$getRuleValue(options.minLength),
                maxLength: $0d70f179cf56e662$var$getRuleValue(options.maxLength),
                pattern: $0d70f179cf56e662$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $0d70f179cf56e662$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $0d70f179cf56e662$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($0d70f179cf56e662$var$live),
                                    fieldRef,
                                    ...Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($0d70f179cf56e662$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $0d70f179cf56e662$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($0d70f179cf56e662$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $0d70f179cf56e662$var$iterateFieldsByAction(_fields, (ref, name)=>{
                let requiredDisabledState = disabled;
                const currentField = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                if (currentField && $0d70f179cf56e662$var$isBoolean(currentField._f.disabled)) requiredDisabledState || (requiredDisabledState = currentField._f.disabled);
                ref.disabled = requiredDisabledState;
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $0d70f179cf56e662$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $0d70f179cf56e662$var$unset(_formState.errors, "root");
            if ($0d70f179cf56e662$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $0d70f179cf56e662$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)) {
            if ($0d70f179cf56e662$var$isUndefined(options.defaultValue)) setValue(name, $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $0d70f179cf56e662$export$adaa4cf7ef1b65be(_defaultValues, name, $0d70f179cf56e662$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $0d70f179cf56e662$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $0d70f179cf56e662$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $0d70f179cf56e662$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $0d70f179cf56e662$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $0d70f179cf56e662$var$cloneObject(updatedValues);
        const isEmptyResetValues = $0d70f179cf56e662$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) for (const fieldName of _names.mount)$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(values, fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($0d70f179cf56e662$var$isWeb && $0d70f179cf56e662$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($0d70f179cf56e662$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $0d70f179cf56e662$var$cloneObject(_defaultValues) : {} : $0d70f179cf56e662$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$0d70f179cf56e662$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? [] : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $0d70f179cf56e662$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($0d70f179cf56e662$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$0d70f179cf56e662$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            _setErrors: _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $0d70f179cf56e662$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: $0d70f179cf56e662$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$0d70f179cf56e662$var$createFormControl(props),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $0d70f179cf56e662$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($0d70f179cf56e662$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.values && !$0d70f179cf56e662$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        props.shouldUnregister && control._subjects.values.next({
            values: control._getWatch()
        });
    }, [
        props.shouldUnregister,
        control
    ]);
    _formControl.current.formState = $0d70f179cf56e662$var$getProxyFormState(formState, control);
    return _formControl.current;
}

});

parcelRegister("lrVF0", function(module, exports) {

$parcel$export(module.exports, "NumericFormat", () => $f9d8d8bd3b422c11$export$3437cf0602f97db7);
/**
 * react-number-format - 5.3.4
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2024 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */ 
var $acw62 = parcelRequire("acw62");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $f9d8d8bd3b422c11$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $f9d8d8bd3b422c11$var$SourceType;
(function(SourceType) {
    SourceType["event"] = "event";
    SourceType["props"] = "prop";
})($f9d8d8bd3b422c11$var$SourceType || ($f9d8d8bd3b422c11$var$SourceType = {}));
// basic noop function
function $f9d8d8bd3b422c11$var$noop() {}
function $f9d8d8bd3b422c11$var$memoizeOnce(cb) {
    var lastArgs;
    var lastValue = undefined;
    return function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        if (lastArgs && args.length === lastArgs.length && args.every(function(value, index) {
            return value === lastArgs[index];
        })) return lastValue;
        lastArgs = args;
        lastValue = cb.apply(void 0, args);
        return lastValue;
    };
}
function $f9d8d8bd3b422c11$var$charIsNumber(char) {
    return !!(char || "").match(/\d/);
}
function $f9d8d8bd3b422c11$var$isNil(val) {
    return val === null || val === undefined;
}
function $f9d8d8bd3b422c11$var$isNanValue(val) {
    return typeof val === "number" && isNaN(val);
}
function $f9d8d8bd3b422c11$var$isNotValidValue(val) {
    return $f9d8d8bd3b422c11$var$isNil(val) || $f9d8d8bd3b422c11$var$isNanValue(val) || typeof val === "number" && !isFinite(val);
}
function $f9d8d8bd3b422c11$var$escapeRegExp(str) {
    return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function $f9d8d8bd3b422c11$var$getThousandsGroupRegex(thousandsGroupStyle) {
    switch(thousandsGroupStyle){
        case "lakh":
            return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
        case "wan":
            return /(\d)(?=(\d{4})+(?!\d))/g;
        case "thousand":
        default:
            return /(\d)(?=(\d{3})+(?!\d))/g;
    }
}
function $f9d8d8bd3b422c11$var$applyThousandSeparator(str, thousandSeparator, thousandsGroupStyle) {
    var thousandsGroupRegex = $f9d8d8bd3b422c11$var$getThousandsGroupRegex(thousandsGroupStyle);
    var index = str.search(/[1-9]/);
    index = index === -1 ? str.length : index;
    return str.substring(0, index) + str.substring(index, str.length).replace(thousandsGroupRegex, "$1" + thousandSeparator);
}
function $f9d8d8bd3b422c11$var$usePersistentCallback(cb) {
    var callbackRef = (0, $acw62.useRef)(cb);
    // keep the callback ref upto date
    callbackRef.current = cb;
    /**
     * initialize a persistent callback which never changes
     * through out the component lifecycle
     */ var persistentCbRef = (0, $acw62.useRef)(function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return callbackRef.current.apply(callbackRef, args);
    });
    return persistentCbRef.current;
}
//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function $f9d8d8bd3b422c11$var$splitDecimal(numStr, allowNegative) {
    if (allowNegative === void 0) allowNegative = true;
    var hasNegation = numStr[0] === "-";
    var addNegation = hasNegation && allowNegative;
    numStr = numStr.replace("-", "");
    var parts = numStr.split(".");
    var beforeDecimal = parts[0];
    var afterDecimal = parts[1] || "";
    return {
        beforeDecimal: beforeDecimal,
        afterDecimal: afterDecimal,
        hasNegation: hasNegation,
        addNegation: addNegation
    };
}
function $f9d8d8bd3b422c11$var$fixLeadingZero(numStr) {
    if (!numStr) return numStr;
    var isNegative = numStr[0] === "-";
    if (isNegative) numStr = numStr.substring(1, numStr.length);
    var parts = numStr.split(".");
    var beforeDecimal = parts[0].replace(/^0+/, "") || "0";
    var afterDecimal = parts[1] || "";
    return "" + (isNegative ? "-" : "") + beforeDecimal + (afterDecimal ? "." + afterDecimal : "");
}
/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */ function $f9d8d8bd3b422c11$var$limitToScale(numStr, scale, fixedDecimalScale) {
    var str = "";
    var filler = fixedDecimalScale ? "0" : "";
    for(var i = 0; i <= scale - 1; i++)str += numStr[i] || filler;
    return str;
}
function $f9d8d8bd3b422c11$var$repeat(str, count) {
    return Array(count + 1).join(str);
}
function $f9d8d8bd3b422c11$var$toNumericString(num) {
    var _num = num + ""; // typecast number to string
    // store the sign and remove it from the number.
    var sign = _num[0] === "-" ? "-" : "";
    if (sign) _num = _num.substring(1);
    // split the number into cofficient and exponent
    var ref = _num.split(/[eE]/g);
    var coefficient = ref[0];
    var exponent = ref[1];
    // covert exponent to number;
    exponent = Number(exponent);
    // if there is no exponent part or its 0, return the coffiecient with sign
    if (!exponent) return sign + coefficient;
    coefficient = coefficient.replace(".", "");
    /**
     * for scientific notation the current decimal index will be after first number (index 0)
     * So effective decimal index will always be 1 + exponent value
     */ var decimalIndex = 1 + exponent;
    var coffiecientLn = coefficient.length;
    if (decimalIndex < 0) // if decimal index is less then 0 add preceding 0s
    // add 1 as join will have
    coefficient = "0." + $f9d8d8bd3b422c11$var$repeat("0", Math.abs(decimalIndex)) + coefficient;
    else if (decimalIndex >= coffiecientLn) // if decimal index is less then 0 add leading 0s
    coefficient = coefficient + $f9d8d8bd3b422c11$var$repeat("0", decimalIndex - coffiecientLn);
    else // else add decimal point at proper index
    coefficient = (coefficient.substring(0, decimalIndex) || "0") + "." + coefficient.substring(decimalIndex);
    return sign + coefficient;
}
/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */ function $f9d8d8bd3b422c11$var$roundToPrecision(numStr, scale, fixedDecimalScale) {
    //if number is empty don't do anything return empty string
    if ([
        "",
        "-"
    ].indexOf(numStr) !== -1) return numStr;
    var shouldHaveDecimalSeparator = (numStr.indexOf(".") !== -1 || fixedDecimalScale) && scale;
    var ref = $f9d8d8bd3b422c11$var$splitDecimal(numStr);
    var beforeDecimal = ref.beforeDecimal;
    var afterDecimal = ref.afterDecimal;
    var hasNegation = ref.hasNegation;
    var floatValue = parseFloat("0." + (afterDecimal || "0"));
    var floatValueStr = afterDecimal.length <= scale ? "0." + afterDecimal : floatValue.toFixed(scale);
    var roundedDecimalParts = floatValueStr.split(".");
    var intPart = beforeDecimal;
    // if we have cary over from rounding decimal part, add that on before decimal
    if (beforeDecimal && Number(roundedDecimalParts[0])) intPart = beforeDecimal.split("").reverse().reduce(function(roundedStr, current, idx) {
        if (roundedStr.length > idx) return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
        return current + roundedStr;
    }, roundedDecimalParts[0]);
    var decimalPart = $f9d8d8bd3b422c11$var$limitToScale(roundedDecimalParts[1] || "", scale, fixedDecimalScale);
    var negation = hasNegation ? "-" : "";
    var decimalSeparator = shouldHaveDecimalSeparator ? "." : "";
    return "" + negation + intPart + decimalSeparator + decimalPart;
}
/** set the caret positon in an input field **/ function $f9d8d8bd3b422c11$var$setCaretPosition(el, caretPos) {
    el.value = el.value;
    // ^ this is used to not only get 'focus', but
    // to make sure we don't have it everything -selected-
    // (it causes an issue in chrome, and having it doesn't hurt any other browser)
    if (el !== null) {
        /* @ts-ignore */ if (el.createTextRange) {
            /* @ts-ignore */ var range = el.createTextRange();
            range.move("character", caretPos);
            range.select();
            return true;
        }
        // (el.selectionStart === 0 added for Firefox bug)
        if (el.selectionStart || el.selectionStart === 0) {
            el.focus();
            el.setSelectionRange(caretPos, caretPos);
            return true;
        }
        // fail city, fortunately this never happens (as far as I've tested) :)
        el.focus();
        return false;
    }
}
var $f9d8d8bd3b422c11$var$findChangeRange = $f9d8d8bd3b422c11$var$memoizeOnce(function(prevValue, newValue) {
    var i = 0, j = 0;
    var prevLength = prevValue.length;
    var newLength = newValue.length;
    while(prevValue[i] === newValue[i] && i < prevLength)i++;
    //check what has been changed from last
    while(prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] && newLength - j > i && prevLength - j > i)j++;
    return {
        from: {
            start: i,
            end: prevLength - j
        },
        to: {
            start: i,
            end: newLength - j
        }
    };
});
/*
  Returns a number whose value is limited to the given range
*/ function $f9d8d8bd3b422c11$var$clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
function $f9d8d8bd3b422c11$var$geInputCaretPosition(el) {
    /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/ return Math.max(el.selectionStart, el.selectionEnd);
}
function $f9d8d8bd3b422c11$var$addInputMode() {
    return typeof navigator !== "undefined" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function $f9d8d8bd3b422c11$var$getDefaultChangeMeta(value) {
    return {
        from: {
            start: 0,
            end: 0
        },
        to: {
            start: 0,
            end: value.length
        },
        lastValue: ""
    };
}
function $f9d8d8bd3b422c11$var$getMaskAtIndex(mask, index) {
    if (mask === void 0) mask = " ";
    if (typeof mask === "string") return mask;
    return mask[index] || " ";
}
function $f9d8d8bd3b422c11$var$defaultIsCharacterSame(ref) {
    var currentValue = ref.currentValue;
    var formattedValue = ref.formattedValue;
    var currentValueIndex = ref.currentValueIndex;
    var formattedValueIndex = ref.formattedValueIndex;
    return currentValue[currentValueIndex] === formattedValue[formattedValueIndex];
}
function $f9d8d8bd3b422c11$var$getCaretPosition(newFormattedValue, lastFormattedValue, curValue, curCaretPos, boundary, isValidInputCharacter, /**
 * format function can change the character, the caret engine relies on mapping old value and new value
 * In such case if character is changed, parent can tell which chars are equivalent
 * Some example, all allowedDecimalCharacters are updated to decimalCharacters, 2nd case if user is coverting
 * number to different numeric system.
 */ isCharacterSame) {
    if (isCharacterSame === void 0) isCharacterSame = $f9d8d8bd3b422c11$var$defaultIsCharacterSame;
    /**
     * if something got inserted on empty value, add the formatted character before the current value,
     * This is to avoid the case where typed character is present on format characters
     */ var firstAllowedPosition = boundary.findIndex(function(b) {
        return b;
    });
    var prefixFormat = newFormattedValue.slice(0, firstAllowedPosition);
    if (!lastFormattedValue && !curValue.startsWith(prefixFormat)) {
        lastFormattedValue = prefixFormat;
        curValue = prefixFormat + curValue;
        curCaretPos = curCaretPos + prefixFormat.length;
    }
    var curValLn = curValue.length;
    var formattedValueLn = newFormattedValue.length;
    // create index map
    var addedIndexMap = {};
    var indexMap = new Array(curValLn);
    for(var i = 0; i < curValLn; i++){
        indexMap[i] = -1;
        for(var j = 0, jLn = formattedValueLn; j < jLn; j++){
            var isCharSame = isCharacterSame({
                currentValue: curValue,
                lastValue: lastFormattedValue,
                formattedValue: newFormattedValue,
                currentValueIndex: i,
                formattedValueIndex: j
            });
            if (isCharSame && addedIndexMap[j] !== true) {
                indexMap[i] = j;
                addedIndexMap[j] = true;
                break;
            }
        }
    }
    /**
     * For current caret position find closest characters (left and right side)
     * which are properly mapped to formatted value.
     * The idea is that the new caret position will exist always in the boundary of
     * that mapped index
     */ var pos = curCaretPos;
    while(pos < curValLn && (indexMap[pos] === -1 || !isValidInputCharacter(curValue[pos])))pos++;
    // if the caret position is on last keep the endIndex as last for formatted value
    var endIndex = pos === curValLn || indexMap[pos] === -1 ? formattedValueLn : indexMap[pos];
    pos = curCaretPos - 1;
    while(pos > 0 && indexMap[pos] === -1)pos--;
    var startIndex = pos === -1 || indexMap[pos] === -1 ? 0 : indexMap[pos] + 1;
    /**
     * case where a char is added on suffix and removed from middle, example 2sq345 becoming $2,345 sq
     * there is still a mapping but the order of start index and end index is changed
     */ if (startIndex > endIndex) return endIndex;
    /**
     * given the current caret position if it closer to startIndex
     * keep the new caret position on start index or keep it closer to endIndex
     */ return curCaretPos - startIndex < endIndex - curCaretPos ? startIndex : endIndex;
}
/* This keeps the caret within typing area so people can't type in between prefix or suffix or format characters */ function $f9d8d8bd3b422c11$var$getCaretPosInBoundary(value, caretPos, boundary, direction) {
    var valLn = value.length;
    // clamp caret position to [0, value.length]
    caretPos = $f9d8d8bd3b422c11$var$clamp(caretPos, 0, valLn);
    if (direction === "left") {
        while(caretPos >= 0 && !boundary[caretPos])caretPos--;
        // if we don't find any suitable caret position on left, set it on first allowed position
        if (caretPos === -1) caretPos = boundary.indexOf(true);
    } else {
        while(caretPos <= valLn && !boundary[caretPos])caretPos++;
        // if we don't find any suitable caret position on right, set it on last allowed position
        if (caretPos > valLn) caretPos = boundary.lastIndexOf(true);
    }
    // if we still don't find caret position, set it at the end of value
    if (caretPos === -1) caretPos = valLn;
    return caretPos;
}
function $f9d8d8bd3b422c11$var$caretUnknownFormatBoundary(formattedValue) {
    var boundaryAry = Array.from({
        length: formattedValue.length + 1
    }).map(function() {
        return true;
    });
    for(var i = 0, ln = boundaryAry.length; i < ln; i++)// consider caret to be in boundary if it is before or after numeric value
    boundaryAry[i] = Boolean($f9d8d8bd3b422c11$var$charIsNumber(formattedValue[i]) || $f9d8d8bd3b422c11$var$charIsNumber(formattedValue[i - 1]));
    return boundaryAry;
}
function $f9d8d8bd3b422c11$var$useInternalValues(value, defaultValue, valueIsNumericString, format, removeFormatting, onValueChange) {
    if (onValueChange === void 0) onValueChange = $f9d8d8bd3b422c11$var$noop;
    var getValues = $f9d8d8bd3b422c11$var$usePersistentCallback(function(value, valueIsNumericString) {
        var formattedValue, numAsString;
        if ($f9d8d8bd3b422c11$var$isNotValidValue(value)) {
            numAsString = "";
            formattedValue = "";
        } else if (typeof value === "number" || valueIsNumericString) {
            numAsString = typeof value === "number" ? $f9d8d8bd3b422c11$var$toNumericString(value) : value;
            formattedValue = format(numAsString);
        } else {
            numAsString = removeFormatting(value, undefined);
            formattedValue = format(numAsString);
        }
        return {
            formattedValue: formattedValue,
            numAsString: numAsString
        };
    });
    var ref = (0, $acw62.useState)(function() {
        return getValues($f9d8d8bd3b422c11$var$isNil(value) ? defaultValue : value, valueIsNumericString);
    });
    var values = ref[0];
    var setValues = ref[1];
    var _onValueChange = function(newValues, sourceInfo) {
        if (newValues.formattedValue !== values.formattedValue) setValues({
            formattedValue: newValues.formattedValue,
            numAsString: newValues.value
        });
        // call parent on value change if only if formatted value is changed
        onValueChange(newValues, sourceInfo);
    };
    // if value is switch from controlled to uncontrolled, use the internal state's value to format with new props
    var _value = value;
    var _valueIsNumericString = valueIsNumericString;
    if ($f9d8d8bd3b422c11$var$isNil(value)) {
        _value = values.numAsString;
        _valueIsNumericString = true;
    }
    var newValues = getValues(_value, _valueIsNumericString);
    (0, $acw62.useMemo)(function() {
        setValues(newValues);
    }, [
        newValues.formattedValue
    ]);
    return [
        values,
        _onValueChange
    ];
}
function $f9d8d8bd3b422c11$var$defaultRemoveFormatting(value) {
    return value.replace(/[^0-9]/g, "");
}
function $f9d8d8bd3b422c11$var$defaultFormat(value) {
    return value;
}
function $f9d8d8bd3b422c11$export$dd1caf9b8ccbc158(props) {
    var type = props.type;
    if (type === void 0) type = "text";
    var displayType = props.displayType;
    if (displayType === void 0) displayType = "input";
    var customInput = props.customInput;
    var renderText = props.renderText;
    var getInputRef = props.getInputRef;
    var format = props.format;
    if (format === void 0) format = $f9d8d8bd3b422c11$var$defaultFormat;
    var removeFormatting = props.removeFormatting;
    if (removeFormatting === void 0) removeFormatting = $f9d8d8bd3b422c11$var$defaultRemoveFormatting;
    var defaultValue = props.defaultValue;
    var valueIsNumericString = props.valueIsNumericString;
    var onValueChange = props.onValueChange;
    var isAllowed = props.isAllowed;
    var onChange = props.onChange;
    if (onChange === void 0) onChange = $f9d8d8bd3b422c11$var$noop;
    var onKeyDown = props.onKeyDown;
    if (onKeyDown === void 0) onKeyDown = $f9d8d8bd3b422c11$var$noop;
    var onMouseUp = props.onMouseUp;
    if (onMouseUp === void 0) onMouseUp = $f9d8d8bd3b422c11$var$noop;
    var onFocus = props.onFocus;
    if (onFocus === void 0) onFocus = $f9d8d8bd3b422c11$var$noop;
    var onBlur = props.onBlur;
    if (onBlur === void 0) onBlur = $f9d8d8bd3b422c11$var$noop;
    var propValue = props.value;
    var getCaretBoundary = props.getCaretBoundary;
    if (getCaretBoundary === void 0) getCaretBoundary = $f9d8d8bd3b422c11$var$caretUnknownFormatBoundary;
    var isValidInputCharacter = props.isValidInputCharacter;
    if (isValidInputCharacter === void 0) isValidInputCharacter = $f9d8d8bd3b422c11$var$charIsNumber;
    var isCharacterSame = props.isCharacterSame;
    var otherProps = $f9d8d8bd3b422c11$var$__rest(props, [
        "type",
        "displayType",
        "customInput",
        "renderText",
        "getInputRef",
        "format",
        "removeFormatting",
        "defaultValue",
        "valueIsNumericString",
        "onValueChange",
        "isAllowed",
        "onChange",
        "onKeyDown",
        "onMouseUp",
        "onFocus",
        "onBlur",
        "value",
        "getCaretBoundary",
        "isValidInputCharacter",
        "isCharacterSame"
    ]);
    var ref = $f9d8d8bd3b422c11$var$useInternalValues(propValue, defaultValue, Boolean(valueIsNumericString), format, removeFormatting, onValueChange);
    var ref_0 = ref[0];
    var formattedValue = ref_0.formattedValue;
    var numAsString = ref_0.numAsString;
    var onFormattedValueChange = ref[1];
    var lastUpdatedValue = (0, $acw62.useRef)({
        formattedValue: formattedValue,
        numAsString: numAsString
    });
    var _onValueChange = function(values, source) {
        lastUpdatedValue.current = {
            formattedValue: values.formattedValue,
            numAsString: values.value
        };
        onFormattedValueChange(values, source);
    };
    var ref$1 = (0, $acw62.useState)(false);
    var mounted = ref$1[0];
    var setMounted = ref$1[1];
    var focusedElm = (0, $acw62.useRef)(null);
    var timeout = (0, $acw62.useRef)({
        setCaretTimeout: null,
        focusTimeout: null
    });
    (0, $acw62.useEffect)(function() {
        setMounted(true);
        return function() {
            clearTimeout(timeout.current.setCaretTimeout);
            clearTimeout(timeout.current.focusTimeout);
        };
    }, []);
    var _format = format;
    var getValueObject = function(formattedValue, numAsString) {
        var floatValue = parseFloat(numAsString);
        return {
            formattedValue: formattedValue,
            value: numAsString,
            floatValue: isNaN(floatValue) ? undefined : floatValue
        };
    };
    var setPatchedCaretPosition = function(el, caretPos, currentValue) {
        // don't reset the caret position when the whole input content is selected
        if (el.selectionStart === 0 && el.selectionEnd === el.value.length) return;
        /* setting caret position within timeout of 0ms is required for mobile chrome,
        otherwise browser resets the caret position after we set it
        We are also setting it without timeout so that in normal browser we don't see the flickering */ $f9d8d8bd3b422c11$var$setCaretPosition(el, caretPos);
        timeout.current.setCaretTimeout = setTimeout(function() {
            if (el.value === currentValue && el.selectionStart !== caretPos) $f9d8d8bd3b422c11$var$setCaretPosition(el, caretPos);
        }, 0);
    };
    /* This keeps the caret within typing area so people can't type in between prefix or suffix */ var correctCaretPosition = function(value, caretPos, direction) {
        return $f9d8d8bd3b422c11$var$getCaretPosInBoundary(value, caretPos, getCaretBoundary(value), direction);
    };
    var getNewCaretPosition = function(inputValue, newFormattedValue, caretPos) {
        var caretBoundary = getCaretBoundary(newFormattedValue);
        var updatedCaretPos = $f9d8d8bd3b422c11$var$getCaretPosition(newFormattedValue, formattedValue, inputValue, caretPos, caretBoundary, isValidInputCharacter, isCharacterSame);
        //correct caret position if its outside of editable area
        updatedCaretPos = $f9d8d8bd3b422c11$var$getCaretPosInBoundary(newFormattedValue, updatedCaretPos, caretBoundary);
        return updatedCaretPos;
    };
    var updateValueAndCaretPosition = function(params) {
        var newFormattedValue = params.formattedValue;
        if (newFormattedValue === void 0) newFormattedValue = "";
        var input = params.input;
        var source = params.source;
        var event = params.event;
        var numAsString = params.numAsString;
        var caretPos;
        if (input) {
            var inputValue = params.inputValue || input.value;
            var currentCaretPosition = $f9d8d8bd3b422c11$var$geInputCaretPosition(input);
            /**
             * set the value imperatively, this is required for IE fix
             * This is also required as if new caret position is beyond the previous value.
             * Caret position will not be set correctly
             */ input.value = newFormattedValue;
            //get the caret position
            caretPos = getNewCaretPosition(inputValue, newFormattedValue, currentCaretPosition);
            //set caret position imperatively
            if (caretPos !== undefined) setPatchedCaretPosition(input, caretPos, newFormattedValue);
        }
        if (newFormattedValue !== formattedValue) // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
        _onValueChange(getValueObject(newFormattedValue, numAsString), {
            event: event,
            source: source
        });
    };
    /**
     * if the formatted value is not synced to parent, or if the formatted value is different from last synced value sync it
     * we also don't need to sync to the parent if no formatting is applied
     * if the formatting props is removed, in which case last formatted value will be different from the numeric string value
     * in such case we need to inform the parent.
     */ (0, $acw62.useEffect)(function() {
        var ref = lastUpdatedValue.current;
        var lastFormattedValue = ref.formattedValue;
        var lastNumAsString = ref.numAsString;
        if (formattedValue !== lastFormattedValue && (formattedValue !== numAsString || lastFormattedValue !== lastNumAsString)) _onValueChange(getValueObject(formattedValue, numAsString), {
            event: undefined,
            source: $f9d8d8bd3b422c11$var$SourceType.props
        });
    }, [
        formattedValue,
        numAsString
    ]);
    // also if formatted value is changed from the props, we need to update the caret position
    // keep the last caret position if element is focused
    var currentCaretPosition = focusedElm.current ? $f9d8d8bd3b422c11$var$geInputCaretPosition(focusedElm.current) : undefined;
    // needed to prevent warning with useLayoutEffect on server
    var useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
    useIsomorphicLayoutEffect(function() {
        var input = focusedElm.current;
        if (formattedValue !== lastUpdatedValue.current.formattedValue && input) {
            var caretPos = getNewCaretPosition(lastUpdatedValue.current.formattedValue, formattedValue, currentCaretPosition);
            /**
             * set the value imperatively, as we set the caret position as well imperatively.
             * This is to keep value and caret position in sync
             */ input.value = formattedValue;
            setPatchedCaretPosition(input, caretPos, formattedValue);
        }
    }, [
        formattedValue
    ]);
    var formatInputValue = function(inputValue, event, source) {
        var changeRange = $f9d8d8bd3b422c11$var$findChangeRange(formattedValue, inputValue);
        var changeMeta = Object.assign(Object.assign({}, changeRange), {
            lastValue: formattedValue
        });
        var _numAsString = removeFormatting(inputValue, changeMeta);
        var _formattedValue = _format(_numAsString);
        // formatting can remove some of the number chars, so we need to fine number string again
        _numAsString = removeFormatting(_formattedValue, undefined);
        if (isAllowed && !isAllowed(getValueObject(_formattedValue, _numAsString))) {
            //reset the caret position
            var input = event.target;
            var currentCaretPosition = $f9d8d8bd3b422c11$var$geInputCaretPosition(input);
            var caretPos = getNewCaretPosition(inputValue, formattedValue, currentCaretPosition);
            input.value = formattedValue;
            setPatchedCaretPosition(input, caretPos, formattedValue);
            return false;
        }
        updateValueAndCaretPosition({
            formattedValue: _formattedValue,
            numAsString: _numAsString,
            inputValue: inputValue,
            event: event,
            source: source,
            input: event.target
        });
        return true;
    };
    var _onChange = function(e) {
        var el = e.target;
        var inputValue = el.value;
        var changed = formatInputValue(inputValue, e, $f9d8d8bd3b422c11$var$SourceType.event);
        if (changed) onChange(e);
    };
    var _onKeyDown = function(e) {
        var el = e.target;
        var key = e.key;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        if (value === void 0) value = "";
        var expectedCaretPosition;
        //Handle backspace and delete against non numerical/decimal characters or arrow keys
        if (key === "ArrowLeft" || key === "Backspace") expectedCaretPosition = Math.max(selectionStart - 1, 0);
        else if (key === "ArrowRight") expectedCaretPosition = Math.min(selectionStart + 1, value.length);
        else if (key === "Delete") expectedCaretPosition = selectionStart;
        //if expectedCaretPosition is not set it means we don't want to Handle keyDown
        // also if multiple characters are selected don't handle
        if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
        }
        var newCaretPosition = expectedCaretPosition;
        if (key === "ArrowLeft" || key === "ArrowRight") {
            var direction = key === "ArrowLeft" ? "left" : "right";
            newCaretPosition = correctCaretPosition(value, expectedCaretPosition, direction);
            // arrow left or right only moves the caret, so no need to handle the event, if we are handling it manually
            if (newCaretPosition !== expectedCaretPosition) e.preventDefault();
        } else if (key === "Delete" && !isValidInputCharacter(value[expectedCaretPosition])) // in case of delete go to closest caret boundary on the right side
        newCaretPosition = correctCaretPosition(value, expectedCaretPosition, "right");
        else if (key === "Backspace" && !isValidInputCharacter(value[expectedCaretPosition])) // in case of backspace go to closest caret boundary on the left side
        newCaretPosition = correctCaretPosition(value, expectedCaretPosition, "left");
        if (newCaretPosition !== expectedCaretPosition) setPatchedCaretPosition(el, newCaretPosition, value);
        /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
                Remove this when you find different solution */ /* @ts-ignore */ if (e.isUnitTestRun) setPatchedCaretPosition(el, newCaretPosition, value);
        onKeyDown(e);
    };
    /** required to handle the caret position when click anywhere within the input **/ var _onMouseUp = function(e) {
        var el = e.target;
        /**
         * NOTE: we have to give default value for value as in case when custom input is provided
         * value can come as undefined when nothing is provided on value prop.
         */ var correctCaretPositionIfRequired = function() {
            var selectionStart = el.selectionStart;
            var selectionEnd = el.selectionEnd;
            var value = el.value;
            if (value === void 0) value = "";
            if (selectionStart === selectionEnd) {
                var caretPosition = correctCaretPosition(value, selectionStart);
                if (caretPosition !== selectionStart) setPatchedCaretPosition(el, caretPosition, value);
            }
        };
        correctCaretPositionIfRequired();
        // try to correct after selection has updated by browser
        // this case is required when user clicks on some position while a text is selected on input
        requestAnimationFrame(function() {
            correctCaretPositionIfRequired();
        });
        onMouseUp(e);
    };
    var _onFocus = function(e) {
        // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
        // (onFocus event target selectionStart is always 0 before setTimeout)
        if (e.persist) e.persist();
        var el = e.target;
        var currentTarget = e.currentTarget;
        focusedElm.current = el;
        timeout.current.focusTimeout = setTimeout(function() {
            var selectionStart = el.selectionStart;
            var selectionEnd = el.selectionEnd;
            var value = el.value;
            if (value === void 0) value = "";
            var caretPosition = correctCaretPosition(value, selectionStart);
            //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
            if (caretPosition !== selectionStart && !(selectionStart === 0 && selectionEnd === value.length)) setPatchedCaretPosition(el, caretPosition, value);
            onFocus(Object.assign(Object.assign({}, e), {
                currentTarget: currentTarget
            }));
        }, 0);
    };
    var _onBlur = function(e) {
        focusedElm.current = null;
        clearTimeout(timeout.current.focusTimeout);
        clearTimeout(timeout.current.setCaretTimeout);
        onBlur(e);
    };
    // add input mode on element based on format prop and device once the component is mounted
    var inputMode = mounted && $f9d8d8bd3b422c11$var$addInputMode() ? "numeric" : undefined;
    var inputProps = Object.assign({
        inputMode: inputMode
    }, otherProps, {
        type: type,
        value: formattedValue,
        onChange: _onChange,
        onKeyDown: _onKeyDown,
        onMouseUp: _onMouseUp,
        onFocus: _onFocus,
        onBlur: _onBlur
    });
    if (displayType === "text") return renderText ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, renderText(formattedValue, otherProps) || null) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({}, otherProps, {
        ref: getInputRef
    }), formattedValue);
    else if (customInput) {
        var CustomInput = customInput;
        /* @ts-ignore */ return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CustomInput, Object.assign({}, inputProps, {
            ref: getInputRef
        }));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", Object.assign({}, inputProps, {
        ref: getInputRef
    }));
}
function $f9d8d8bd3b422c11$export$8afdc6404de1eded(numStr, props) {
    var decimalScale = props.decimalScale;
    var fixedDecimalScale = props.fixedDecimalScale;
    var prefix = props.prefix;
    if (prefix === void 0) prefix = "";
    var suffix = props.suffix;
    if (suffix === void 0) suffix = "";
    var allowNegative = props.allowNegative;
    var thousandsGroupStyle = props.thousandsGroupStyle;
    if (thousandsGroupStyle === void 0) thousandsGroupStyle = "thousand";
    // don't apply formatting on empty string or '-'
    if (numStr === "" || numStr === "-") return numStr;
    var ref = $f9d8d8bd3b422c11$var$getSeparators(props);
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    /**
     * Keep the decimal separator
     * when decimalScale is not defined or non zero and the numStr has decimal in it
     * Or if decimalScale is > 0 and fixeDecimalScale is true (even if numStr has no decimal)
     */ var hasDecimalSeparator = decimalScale !== 0 && numStr.indexOf(".") !== -1 || decimalScale && fixedDecimalScale;
    var ref$1 = $f9d8d8bd3b422c11$var$splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$1.beforeDecimal;
    var afterDecimal = ref$1.afterDecimal;
    var addNegation = ref$1.addNegation; // eslint-disable-line prefer-const
    //apply decimal precision if its defined
    if (decimalScale !== undefined) afterDecimal = $f9d8d8bd3b422c11$var$limitToScale(afterDecimal, decimalScale, !!fixedDecimalScale);
    if (thousandSeparator) beforeDecimal = $f9d8d8bd3b422c11$var$applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    //add prefix and suffix when there is a number present
    if (prefix) beforeDecimal = prefix + beforeDecimal;
    if (suffix) afterDecimal = afterDecimal + suffix;
    //restore negation sign
    if (addNegation) beforeDecimal = "-" + beforeDecimal;
    numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || "") + afterDecimal;
    return numStr;
}
function $f9d8d8bd3b422c11$var$getSeparators(props) {
    var decimalSeparator = props.decimalSeparator;
    if (decimalSeparator === void 0) decimalSeparator = ".";
    var thousandSeparator = props.thousandSeparator;
    var allowedDecimalSeparators = props.allowedDecimalSeparators;
    if (thousandSeparator === true) thousandSeparator = ",";
    if (!allowedDecimalSeparators) allowedDecimalSeparators = [
        decimalSeparator,
        "."
    ];
    return {
        decimalSeparator: decimalSeparator,
        thousandSeparator: thousandSeparator,
        allowedDecimalSeparators: allowedDecimalSeparators
    };
}
function $f9d8d8bd3b422c11$var$handleNegation(value, allowNegative) {
    if (value === void 0) value = "";
    var negationRegex = new RegExp("(-)");
    var doubleNegationRegex = new RegExp("(-)(.)*(-)");
    // Check number has '-' value
    var hasNegation = negationRegex.test(value);
    // Check number has 2 or more '-' values
    var removeNegation = doubleNegationRegex.test(value);
    //remove negation
    value = value.replace(/-/g, "");
    if (hasNegation && !removeNegation && allowNegative) value = "-" + value;
    return value;
}
function $f9d8d8bd3b422c11$var$getNumberRegex(decimalSeparator, global) {
    return new RegExp("(^-)|[0-9]|" + $f9d8d8bd3b422c11$var$escapeRegExp(decimalSeparator), global ? "g" : undefined);
}
function $f9d8d8bd3b422c11$var$isNumericString(val, prefix, suffix) {
    // for empty value we can always treat it as numeric string
    if (val === "") return true;
    return !(prefix === null || prefix === void 0 ? void 0 : prefix.match(/\d/)) && !(suffix === null || suffix === void 0 ? void 0 : suffix.match(/\d/)) && typeof val === "string" && !isNaN(Number(val));
}
function $f9d8d8bd3b422c11$export$bd06c53c8882f574(value, changeMeta, props) {
    var assign;
    if (changeMeta === void 0) changeMeta = $f9d8d8bd3b422c11$var$getDefaultChangeMeta(value);
    var allowNegative = props.allowNegative;
    var prefix = props.prefix;
    if (prefix === void 0) prefix = "";
    var suffix = props.suffix;
    if (suffix === void 0) suffix = "";
    var decimalScale = props.decimalScale;
    var from = changeMeta.from;
    var to = changeMeta.to;
    var start = to.start;
    var end = to.end;
    var ref = $f9d8d8bd3b422c11$var$getSeparators(props);
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var decimalSeparator = ref.decimalSeparator;
    var isBeforeDecimalSeparator = value[end] === decimalSeparator;
    /**
     * If only a number is added on empty input which matches with the prefix or suffix,
     * then don't remove it, just return the same
     */ if ($f9d8d8bd3b422c11$var$charIsNumber(value) && (value === prefix || value === suffix) && changeMeta.lastValue === "") return value;
    /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */ if (end - start === 1 && allowedDecimalSeparators.indexOf(value[start]) !== -1) {
        var separator = decimalScale === 0 ? "" : decimalSeparator;
        value = value.substring(0, start) + separator + value.substring(start + 1, value.length);
    }
    var stripNegation = function(value, start, end) {
        /**
         * if prefix starts with - we don't allow negative number to avoid confusion
         * if suffix starts with - and the value length is same as suffix length, then the - sign is from the suffix
         * In other cases, if the value starts with - then it is a negation
         */ var hasNegation = false;
        var hasDoubleNegation = false;
        if (prefix.startsWith("-")) hasNegation = false;
        else if (value.startsWith("--")) {
            hasNegation = false;
            hasDoubleNegation = true;
        } else if (suffix.startsWith("-") && value.length === suffix.length) hasNegation = false;
        else if (value[0] === "-") hasNegation = true;
        var charsToRemove = hasNegation ? 1 : 0;
        if (hasDoubleNegation) charsToRemove = 2;
        // remove negation/double negation from start to simplify prefix logic as negation comes before prefix
        if (charsToRemove) {
            value = value.substring(charsToRemove);
            // account for the removal of the negation for start and end index
            start -= charsToRemove;
            end -= charsToRemove;
        }
        return {
            value: value,
            start: start,
            end: end,
            hasNegation: hasNegation
        };
    };
    var toMetadata = stripNegation(value, start, end);
    var hasNegation = toMetadata.hasNegation;
    assign = toMetadata, value = assign.value, start = assign.start, end = assign.end;
    var ref$1 = stripNegation(changeMeta.lastValue, from.start, from.end);
    var fromStart = ref$1.start;
    var fromEnd = ref$1.end;
    var lastValue = ref$1.value;
    // if only prefix and suffix part is updated reset the value to last value
    // if the changed range is from suffix in the updated value, and the the suffix starts with the same characters, allow the change
    var updatedSuffixPart = value.substring(start, end);
    if (value.length && lastValue.length && (fromStart > lastValue.length - suffix.length || fromEnd < prefix.length) && !(updatedSuffixPart && suffix.startsWith(updatedSuffixPart))) value = lastValue;
    /**
     * remove prefix
     * Remove whole prefix part if its present on the value
     * If the prefix is partially deleted (in which case change start index will be less the prefix length)
     * Remove only partial part of prefix.
     */ var startIndex = 0;
    if (value.startsWith(prefix)) startIndex += prefix.length;
    else if (start < prefix.length) startIndex = start;
    value = value.substring(startIndex);
    // account for deleted prefix for end
    end -= startIndex;
    /**
     * Remove suffix
     * Remove whole suffix part if its present on the value
     * If the suffix is partially deleted (in which case change end index will be greater than the suffixStartIndex)
     * remove the partial part of suffix
     */ var endIndex = value.length;
    var suffixStartIndex = value.length - suffix.length;
    if (value.endsWith(suffix)) endIndex = suffixStartIndex;
    else if (end > suffixStartIndex) endIndex = end;
    else if (end > value.length - suffix.length) endIndex = end;
    value = value.substring(0, endIndex);
    // add the negation back and handle for double negation
    value = $f9d8d8bd3b422c11$var$handleNegation(hasNegation ? "-" + value : value, allowNegative);
    // remove non numeric characters
    value = (value.match($f9d8d8bd3b422c11$var$getNumberRegex(decimalSeparator, true)) || []).join("");
    // replace the decimalSeparator with ., and only keep the first separator, ignore following ones
    var firstIndex = value.indexOf(decimalSeparator);
    value = value.replace(new RegExp($f9d8d8bd3b422c11$var$escapeRegExp(decimalSeparator), "g"), function(match, index) {
        return index === firstIndex ? "." : "";
    });
    //check if beforeDecimal got deleted and there is nothing after decimal,
    //clear all numbers in such case while keeping the - sign
    var ref$2 = $f9d8d8bd3b422c11$var$splitDecimal(value, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const
    //clear only if something got deleted before decimal (cursor is before decimal)
    if (to.end - to.start < from.end - from.start && beforeDecimal === "" && isBeforeDecimalSeparator && !parseFloat(afterDecimal)) value = addNegation ? "-" : "";
    return value;
}
function $f9d8d8bd3b422c11$export$ce26457d42b8fa52(formattedValue, props) {
    var prefix = props.prefix;
    if (prefix === void 0) prefix = "";
    var suffix = props.suffix;
    if (suffix === void 0) suffix = "";
    var boundaryAry = Array.from({
        length: formattedValue.length + 1
    }).map(function() {
        return true;
    });
    var hasNegation = formattedValue[0] === "-";
    // fill for prefix and negation
    boundaryAry.fill(false, 0, prefix.length + (hasNegation ? 1 : 0));
    // fill for suffix
    var valLn = formattedValue.length;
    boundaryAry.fill(false, valLn - suffix.length + 1, valLn + 1);
    return boundaryAry;
}
function $f9d8d8bd3b422c11$var$validateAndUpdateProps(props) {
    var ref = $f9d8d8bd3b422c11$var$getSeparators(props);
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    // eslint-disable-next-line prefer-const
    var prefix = props.prefix;
    if (prefix === void 0) prefix = "";
    var allowNegative = props.allowNegative;
    if (allowNegative === void 0) allowNegative = true;
    if (thousandSeparator === decimalSeparator) throw new Error("\n        Decimal separator can't be same as thousand separator.\n        thousandSeparator: " + thousandSeparator + ' (thousandSeparator = {true} is same as thousandSeparator = ",")\n        decimalSeparator: ' + decimalSeparator + " (default value for decimalSeparator is .)\n     ");
    if (prefix.startsWith("-") && allowNegative) {
        // TODO: throw error in next major version
        console.error("\n      Prefix can't start with '-' when allowNegative is true.\n      prefix: " + prefix + "\n      allowNegative: " + allowNegative + "\n    ");
        allowNegative = false;
    }
    return Object.assign(Object.assign({}, props), {
        allowNegative: allowNegative
    });
}
function $f9d8d8bd3b422c11$export$2fb051e8b03d5d2d(props) {
    // validate props
    props = $f9d8d8bd3b422c11$var$validateAndUpdateProps(props);
    var _decimalSeparator = props.decimalSeparator;
    var _allowedDecimalSeparators = props.allowedDecimalSeparators;
    var thousandsGroupStyle = props.thousandsGroupStyle;
    var suffix = props.suffix;
    var allowNegative = props.allowNegative;
    var allowLeadingZeros = props.allowLeadingZeros;
    var onKeyDown = props.onKeyDown;
    if (onKeyDown === void 0) onKeyDown = $f9d8d8bd3b422c11$var$noop;
    var onBlur = props.onBlur;
    if (onBlur === void 0) onBlur = $f9d8d8bd3b422c11$var$noop;
    var thousandSeparator = props.thousandSeparator;
    var decimalScale = props.decimalScale;
    var fixedDecimalScale = props.fixedDecimalScale;
    var prefix = props.prefix;
    if (prefix === void 0) prefix = "";
    var defaultValue = props.defaultValue;
    var value = props.value;
    var valueIsNumericString = props.valueIsNumericString;
    var onValueChange = props.onValueChange;
    var restProps = $f9d8d8bd3b422c11$var$__rest(props, [
        "decimalSeparator",
        "allowedDecimalSeparators",
        "thousandsGroupStyle",
        "suffix",
        "allowNegative",
        "allowLeadingZeros",
        "onKeyDown",
        "onBlur",
        "thousandSeparator",
        "decimalScale",
        "fixedDecimalScale",
        "prefix",
        "defaultValue",
        "value",
        "valueIsNumericString",
        "onValueChange"
    ]);
    // get derived decimalSeparator and allowedDecimalSeparators
    var ref = $f9d8d8bd3b422c11$var$getSeparators(props);
    var decimalSeparator = ref.decimalSeparator;
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var _format = function(numStr) {
        return $f9d8d8bd3b422c11$export$8afdc6404de1eded(numStr, props);
    };
    var _removeFormatting = function(inputValue, changeMeta) {
        return $f9d8d8bd3b422c11$export$bd06c53c8882f574(inputValue, changeMeta, props);
    };
    var _value = $f9d8d8bd3b422c11$var$isNil(value) ? defaultValue : value;
    // try to figure out isValueNumericString based on format prop and value
    var _valueIsNumericString = valueIsNumericString !== null && valueIsNumericString !== void 0 ? valueIsNumericString : $f9d8d8bd3b422c11$var$isNumericString(_value, prefix, suffix);
    if (!$f9d8d8bd3b422c11$var$isNil(value)) _valueIsNumericString = _valueIsNumericString || typeof value === "number";
    else if (!$f9d8d8bd3b422c11$var$isNil(defaultValue)) _valueIsNumericString = _valueIsNumericString || typeof defaultValue === "number";
    var roundIncomingValueToPrecision = function(value) {
        if ($f9d8d8bd3b422c11$var$isNotValidValue(value)) return value;
        if (typeof value === "number") value = $f9d8d8bd3b422c11$var$toNumericString(value);
        /**
         * only round numeric or float string values coming through props,
         * we don't need to do it for onChange events, as we want to prevent typing there
         */ if (_valueIsNumericString && typeof decimalScale === "number") return $f9d8d8bd3b422c11$var$roundToPrecision(value, decimalScale, Boolean(fixedDecimalScale));
        return value;
    };
    var ref$1 = $f9d8d8bd3b422c11$var$useInternalValues(roundIncomingValueToPrecision(value), roundIncomingValueToPrecision(defaultValue), Boolean(_valueIsNumericString), _format, _removeFormatting, onValueChange);
    var ref$1_0 = ref$1[0];
    var numAsString = ref$1_0.numAsString;
    var formattedValue = ref$1_0.formattedValue;
    var _onValueChange = ref$1[1];
    var _onKeyDown = function(e) {
        var el = e.target;
        var key = e.key;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        if (value === void 0) value = "";
        // if multiple characters are selected and user hits backspace, no need to handle anything manually
        if (selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
        }
        // if user hits backspace, while the cursor is before prefix, and the input has negation, remove the negation
        if (key === "Backspace" && value[0] === "-" && selectionStart === prefix.length + 1 && allowNegative) // bring the cursor to after negation
        $f9d8d8bd3b422c11$var$setCaretPosition(el, 1);
        // don't allow user to delete decimal separator when decimalScale and fixedDecimalScale is set
        if (decimalScale && fixedDecimalScale) {
            if (key === "Backspace" && value[selectionStart - 1] === decimalSeparator) {
                $f9d8d8bd3b422c11$var$setCaretPosition(el, selectionStart - 1);
                e.preventDefault();
            } else if (key === "Delete" && value[selectionStart] === decimalSeparator) e.preventDefault();
        }
        // if user presses the allowed decimal separator before the separator, move the cursor after the separator
        if ((allowedDecimalSeparators === null || allowedDecimalSeparators === void 0 ? void 0 : allowedDecimalSeparators.includes(key)) && value[selectionStart] === decimalSeparator) $f9d8d8bd3b422c11$var$setCaretPosition(el, selectionStart + 1);
        var _thousandSeparator = thousandSeparator === true ? "," : thousandSeparator;
        // move cursor when delete or backspace is pressed before/after thousand separator
        if (key === "Backspace" && value[selectionStart - 1] === _thousandSeparator) $f9d8d8bd3b422c11$var$setCaretPosition(el, selectionStart - 1);
        if (key === "Delete" && value[selectionStart] === _thousandSeparator) $f9d8d8bd3b422c11$var$setCaretPosition(el, selectionStart + 1);
        onKeyDown(e);
    };
    var _onBlur = function(e) {
        var _value = numAsString;
        // if there no no numeric value, clear the input
        if (!_value.match(/\d/g)) _value = "";
        // clear leading 0s
        if (!allowLeadingZeros) _value = $f9d8d8bd3b422c11$var$fixLeadingZero(_value);
        // apply fixedDecimalScale on blur event
        if (fixedDecimalScale && decimalScale) _value = $f9d8d8bd3b422c11$var$roundToPrecision(_value, decimalScale, fixedDecimalScale);
        if (_value !== numAsString) {
            var formattedValue = $f9d8d8bd3b422c11$export$8afdc6404de1eded(_value, props);
            _onValueChange({
                formattedValue: formattedValue,
                value: _value,
                floatValue: parseFloat(_value)
            }, {
                event: e,
                source: $f9d8d8bd3b422c11$var$SourceType.event
            });
        }
        onBlur(e);
    };
    var isValidInputCharacter = function(inputChar) {
        if (inputChar === decimalSeparator) return true;
        return $f9d8d8bd3b422c11$var$charIsNumber(inputChar);
    };
    var isCharacterSame = function(ref) {
        var currentValue = ref.currentValue;
        var lastValue = ref.lastValue;
        var formattedValue = ref.formattedValue;
        var currentValueIndex = ref.currentValueIndex;
        var formattedValueIndex = ref.formattedValueIndex;
        var curChar = currentValue[currentValueIndex];
        var newChar = formattedValue[formattedValueIndex];
        /**
         * NOTE: as thousand separator and allowedDecimalSeparators can be same, we need to check on
         * typed range if we have typed any character from allowedDecimalSeparators, in that case we
         * consider different characters like , and . same within the range of updated value.
         */ var typedRange = $f9d8d8bd3b422c11$var$findChangeRange(lastValue, currentValue);
        var to = typedRange.to;
        if (currentValueIndex >= to.start && currentValueIndex < to.end && allowedDecimalSeparators && allowedDecimalSeparators.includes(curChar) && newChar === decimalSeparator) return true;
        return curChar === newChar;
    };
    return Object.assign(Object.assign({}, restProps), {
        value: formattedValue,
        valueIsNumericString: false,
        isValidInputCharacter: isValidInputCharacter,
        isCharacterSame: isCharacterSame,
        onValueChange: _onValueChange,
        format: _format,
        removeFormatting: _removeFormatting,
        getCaretBoundary: function(formattedValue) {
            return $f9d8d8bd3b422c11$export$ce26457d42b8fa52(formattedValue, props);
        },
        onKeyDown: _onKeyDown,
        onBlur: _onBlur
    });
}
function $f9d8d8bd3b422c11$export$3437cf0602f97db7(props) {
    var numericFormatProps = $f9d8d8bd3b422c11$export$2fb051e8b03d5d2d(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f9d8d8bd3b422c11$export$dd1caf9b8ccbc158, Object.assign({}, numericFormatProps));
}
function $f9d8d8bd3b422c11$export$4b8d05d749baae10(numStr, props) {
    var format = props.format;
    var allowEmptyFormatting = props.allowEmptyFormatting;
    var mask = props.mask;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = "#";
    if (numStr === "" && !allowEmptyFormatting) return "";
    var hashCount = 0;
    var formattedNumberAry = format.split("");
    for(var i = 0, ln = format.length; i < ln; i++)if (format[i] === patternChar) {
        formattedNumberAry[i] = numStr[hashCount] || $f9d8d8bd3b422c11$var$getMaskAtIndex(mask, hashCount);
        hashCount += 1;
    }
    return formattedNumberAry.join("");
}
function $f9d8d8bd3b422c11$export$63600a84c223a8ea(value, changeMeta, props) {
    if (changeMeta === void 0) changeMeta = $f9d8d8bd3b422c11$var$getDefaultChangeMeta(value);
    var format = props.format;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = "#";
    var from = changeMeta.from;
    var to = changeMeta.to;
    var lastValue = changeMeta.lastValue;
    if (lastValue === void 0) lastValue = "";
    var isNumericSlot = function(caretPos) {
        return format[caretPos] === patternChar;
    };
    var removeFormatChar = function(string, startIndex) {
        var str = "";
        for(var i = 0; i < string.length; i++)if (isNumericSlot(startIndex + i) && $f9d8d8bd3b422c11$var$charIsNumber(string[i])) str += string[i];
        return str;
    };
    var extractNumbers = function(str) {
        return str.replace(/[^0-9]/g, "");
    };
    // if format doesn't have any number, remove all the non numeric characters
    if (!format.match(/\d/)) return extractNumbers(value);
    /**
     * if user paste the whole formatted text in an empty input, check if matches to the pattern
     * and remove the format characters, if there is a mismatch on the pattern, do plane number extract
     */ if (lastValue === "" && value.length === format.length) {
        var str = "";
        for(var i = 0; i < value.length; i++){
            if (isNumericSlot(i)) {
                if ($f9d8d8bd3b422c11$var$charIsNumber(value[i])) str += value[i];
            } else if (value[i] !== format[i]) // if there is a mismatch on the pattern, do plane number extract
            return extractNumbers(value);
        }
        return str;
    }
    /**
     * For partial change,
     * where ever there is a change on the input, we can break the number in three parts
     * 1st: left part which is unchanged
     * 2nd: middle part which is changed
     * 3rd: right part which is unchanged
     *
     * The first and third section will be same as last value, only the middle part will change
     * We can consider on the change part all the new characters are non format characters.
     * And on the first and last section it can have partial format characters.
     *
     * We pick first and last section from the lastValue (as that has 1-1 mapping with format)
     * and middle one from the update value.
     */ var firstSection = lastValue.substring(0, from.start);
    var middleSection = value.substring(to.start, to.end);
    var lastSection = lastValue.substring(from.end);
    return "" + removeFormatChar(firstSection, 0) + extractNumbers(middleSection) + removeFormatChar(lastSection, from.end);
}
function $f9d8d8bd3b422c11$export$cbab503a3360c264(formattedValue, props) {
    var format = props.format;
    var mask = props.mask;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = "#";
    var boundaryAry = Array.from({
        length: formattedValue.length + 1
    }).map(function() {
        return true;
    });
    var hashCount = 0;
    var firstEmptySlot = -1;
    var maskAndIndexMap = {};
    format.split("").forEach(function(char, index) {
        var maskAtIndex = undefined;
        if (char === patternChar) {
            hashCount++;
            maskAtIndex = $f9d8d8bd3b422c11$var$getMaskAtIndex(mask, hashCount - 1);
            if (firstEmptySlot === -1 && formattedValue[index] === maskAtIndex) firstEmptySlot = index;
        }
        maskAndIndexMap[index] = maskAtIndex;
    });
    var isPosAllowed = function(pos) {
        // the position is allowed if the position is not masked and valid number area
        return format[pos] === patternChar && formattedValue[pos] !== maskAndIndexMap[pos];
    };
    for(var i = 0, ln = boundaryAry.length; i < ln; i++)// consider caret to be in boundary if it is before or after numeric value
    // Note: on pattern based format its denoted by patternCharacter
    // we should also allow user to put cursor on first empty slot
    boundaryAry[i] = i === firstEmptySlot || isPosAllowed(i) || isPosAllowed(i - 1);
    // the first patternChar position is always allowed
    boundaryAry[format.indexOf(patternChar)] = true;
    return boundaryAry;
}
function $f9d8d8bd3b422c11$var$validateProps(props) {
    var mask = props.mask;
    if (mask) {
        var maskAsStr = mask === "string" ? mask : mask.toString();
        if (maskAsStr.match(/\d/g)) throw new Error("Mask " + mask + " should not contain numeric character;");
    }
}
function $f9d8d8bd3b422c11$var$isNumericString$1(val, format) {
    //we can treat empty string as numeric string
    if (val === "") return true;
    return !(format === null || format === void 0 ? void 0 : format.match(/\d/)) && typeof val === "string" && (!!val.match(/^\d+$/) || val === "");
}
function $f9d8d8bd3b422c11$export$1290cfe2185b28c0(props) {
    var mask = props.mask;
    var allowEmptyFormatting = props.allowEmptyFormatting;
    var formatProp = props.format;
    var inputMode = props.inputMode;
    if (inputMode === void 0) inputMode = "numeric";
    var onKeyDown = props.onKeyDown;
    if (onKeyDown === void 0) onKeyDown = $f9d8d8bd3b422c11$var$noop;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = "#";
    var value = props.value;
    var defaultValue = props.defaultValue;
    var valueIsNumericString = props.valueIsNumericString;
    var restProps = $f9d8d8bd3b422c11$var$__rest(props, [
        "mask",
        "allowEmptyFormatting",
        "format",
        "inputMode",
        "onKeyDown",
        "patternChar",
        "value",
        "defaultValue",
        "valueIsNumericString"
    ]);
    // validate props
    $f9d8d8bd3b422c11$var$validateProps(props);
    var _getCaretBoundary = function(formattedValue) {
        return $f9d8d8bd3b422c11$export$cbab503a3360c264(formattedValue, props);
    };
    var _onKeyDown = function(e) {
        var key = e.key;
        var el = e.target;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        // if multiple characters are selected and user hits backspace, no need to handle anything manually
        if (selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
        }
        // bring the cursor to closest numeric section
        var caretPos = selectionStart;
        // if backspace is pressed after the format characters, bring it to numeric section
        // if delete is pressed before the format characters, bring it to numeric section
        if (key === "Backspace" || key === "Delete") {
            var direction = "right";
            if (key === "Backspace") {
                while(caretPos > 0 && formatProp[caretPos - 1] !== patternChar)caretPos--;
                direction = "left";
            } else {
                var formatLn = formatProp.length;
                while(caretPos < formatLn && formatProp[caretPos] !== patternChar)caretPos++;
                direction = "right";
            }
            caretPos = $f9d8d8bd3b422c11$var$getCaretPosInBoundary(value, caretPos, _getCaretBoundary(value), direction);
        } else if (formatProp[caretPos] !== patternChar && key !== "ArrowLeft" && key !== "ArrowRight") // if user is typing on format character position, bring user to next allowed caret position
        caretPos = $f9d8d8bd3b422c11$var$getCaretPosInBoundary(value, caretPos + 1, _getCaretBoundary(value), "right");
        // if we changing caret position, set the caret position
        if (caretPos !== selectionStart) $f9d8d8bd3b422c11$var$setCaretPosition(el, caretPos);
        onKeyDown(e);
    };
    // try to figure out isValueNumericString based on format prop and value
    var _value = $f9d8d8bd3b422c11$var$isNil(value) ? defaultValue : value;
    var isValueNumericString = valueIsNumericString !== null && valueIsNumericString !== void 0 ? valueIsNumericString : $f9d8d8bd3b422c11$var$isNumericString$1(_value, formatProp);
    var _props = Object.assign(Object.assign({}, props), {
        valueIsNumericString: isValueNumericString
    });
    return Object.assign(Object.assign({}, restProps), {
        value: value,
        defaultValue: defaultValue,
        valueIsNumericString: isValueNumericString,
        inputMode: inputMode,
        format: function(numStr) {
            return $f9d8d8bd3b422c11$export$4b8d05d749baae10(numStr, _props);
        },
        removeFormatting: function(inputValue, changeMeta) {
            return $f9d8d8bd3b422c11$export$63600a84c223a8ea(inputValue, changeMeta, _props);
        },
        getCaretBoundary: _getCaretBoundary,
        onKeyDown: _onKeyDown
    });
}
function $f9d8d8bd3b422c11$export$9e8c774149e1782b(props) {
    var patternFormatProps = $f9d8d8bd3b422c11$export$1290cfe2185b28c0(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f9d8d8bd3b422c11$export$dd1caf9b8ccbc158, Object.assign({}, patternFormatProps));
}

});



parcelRegister("fU1J1", function(module, exports) {
parcelRequire("9yf9c");

});
parcelRegister("9yf9c", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $j9H4k = parcelRequire("j9H4k");
var $iymfR = parcelRequire("iymfR");

var $ckP3P = parcelRequire("ckP3P");
var $8kHHN = parcelRequire("8kHHN");

var $22i8b = parcelRequire("22i8b");

var $acw62 = parcelRequire("acw62");
function $3be6f31d6edacb3c$export$d55b50a564d0b931({ testId: testId, name: name, className: className, control: control, options: options, placeholder: placeholder }) {
    const [selected, setSelected] = (0, $acw62.useState)("");
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22i8b.Controller), {
        control: control,
        name: name,
        defaultValue: "",
        render: ({ field: field })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $j9H4k.Listbox), {
                ...field,
                value: field.value,
                onChange: (e)=>{
                    field.onChange(e);
                    setSelected(e);
                },
                children: ({ open: open })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $j9H4k.Listbox).Button, {
                                    className: (0, $9QePP.default)("focus:ring-interactive bg-secondary relative w-full cursor-pointer rounded-md py-3 pl-4 pr-10 text-left ring-1 ring-inset ring-slate-300 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500 dark:ring-slate-700", className),
                                    "data-testid": testId,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "body-s subdued cursor-pointer",
                                            children: field.value || selected || placeholder || "Select an option"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: (0, $9QePP.default)("pr-2", "pointer-events-none absolute inset-y-0 right-0 flex items-center"),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8kHHN.default), {
                                                className: "size-5 text-gray-400",
                                                "aria-hidden": "true"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition), {
                                    show: open,
                                    as: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment,
                                    enter: "transition ease-out duration-100",
                                    enterFrom: "transform opacity-0 scale-95",
                                    enterTo: "transform opacity-100 scale-100",
                                    leave: "transition ease-in duration-75",
                                    leaveFrom: "transform opacity-100 scale-100",
                                    leaveTo: "transform opacity-0 scale-95",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j9H4k.Listbox).Options, {
                                        static: true,
                                        className: (0, $9QePP.default)("absolute z-10 mt-1 max-h-60 w-full py-1", "rounded-md ring-1 ring-inset ring-slate-300 focus:outline-none dark:ring-slate-700", "custom-scrollbar bg-secondary overflow-auto"),
                                        children: options.map(({ label: label, value: value })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $j9H4k.Listbox).Option, {
                                                className: ({ active: active })=>(0, $9QePP.default)(active ? "bg-slate-800" : "bg-secondary", "relative cursor-pointer select-none py-2 pl-10 pr-4"),
                                                value: value,
                                                children: ({ selected: selected, active: active })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "body-s subdued block cursor-pointer",
                                                                children: label
                                                            }),
                                                            selected ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: (0, $9QePP.default)(active ? "subdued" : "subdued", "absolute inset-y-0 left-0 flex items-center pl-3"),
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ckP3P.default), {
                                                                    className: "size-5",
                                                                    "aria-hidden": "true"
                                                                })
                                                            }) : null
                                                        ]
                                                    })
                                            }, value))
                                    })
                                })
                            ]
                        })
                    })
            })
    });
}

});
parcelRegister("j9H4k", function(module, exports) {

$parcel$export(module.exports, "ListboxButton", () => $df20442161b20eb0$export$1e1e59bb4b882447);
$parcel$export(module.exports, "ListboxOptions", () => $df20442161b20eb0$export$ea8d88fc73d4fb81);
$parcel$export(module.exports, "ListboxOption", () => $df20442161b20eb0$export$68e891bae1a5b917);
$parcel$export(module.exports, "Listbox", () => $df20442161b20eb0$export$8bad31ff872c7659);

var $kd7LS = parcelRequire("kd7LS");

var $6o6B3 = parcelRequire("6o6B3");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $cE9hP = parcelRequire("cE9hP");

var $ePQFN = parcelRequire("ePQFN");

var $h26ct = parcelRequire("h26ct");

var $3X9lW = parcelRequire("3X9lW");

var $hd1nN = parcelRequire("hd1nN");

var $5Ai9V = parcelRequire("5Ai9V");

var $dfvrc = parcelRequire("dfvrc");

var $114Mg = parcelRequire("114Mg");

var $acw62 = parcelRequire("acw62");

var $keKjn = parcelRequire("keKjn");

var $8KgIp = parcelRequire("8KgIp");

var $ltgxC = parcelRequire("ltgxC");

var $dcp2r = parcelRequire("dcp2r");

var $23pTr = parcelRequire("23pTr");

var $5IEAk = parcelRequire("5IEAk");

var $gm4XX = parcelRequire("gm4XX");

var $hZodg = parcelRequire("hZodg");

var $6mpbl = parcelRequire("6mpbl");

var $jN7sP = parcelRequire("jN7sP");

var $ipity = parcelRequire("ipity");

var $bdknl = parcelRequire("bdknl");

var $brAF4 = parcelRequire("brAF4");

var $34Str = parcelRequire("34Str");

var $dBJH0 = parcelRequire("dBJH0");

var $9UPTU = parcelRequire("9UPTU");

var $jpbxo = parcelRequire("jpbxo");

var $auuNT = parcelRequire("auuNT");

var $5fYEB = parcelRequire("5fYEB");

var $fLrGx = parcelRequire("fLrGx");

var $1COYr = parcelRequire("1COYr");

var $hsQxB = parcelRequire("hsQxB");

var $7FnlJ = parcelRequire("7FnlJ");

var $6Ngq1 = parcelRequire("6Ngq1");

var $gxwGc = parcelRequire("gxwGc");

var $ebRQH = parcelRequire("ebRQH");

var $iGb09 = parcelRequire("iGb09");

var $6AKlm = parcelRequire("6AKlm");

var $5qg9U = parcelRequire("5qg9U");

var $e9NTc = parcelRequire("e9NTc");
"use client";
var $df20442161b20eb0$var$gt = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($df20442161b20eb0$var$gt || {}), $df20442161b20eb0$var$Lt = ((o)=>(o[o.Single = 0] = "Single", o[o.Multi = 1] = "Multi", o))($df20442161b20eb0$var$Lt || {}), $df20442161b20eb0$var$St = ((o)=>(o[o.Pointer = 0] = "Pointer", o[o.Other = 1] = "Other", o))($df20442161b20eb0$var$St || {}), $df20442161b20eb0$var$Et = ((n)=>(n[n.OpenListbox = 0] = "OpenListbox", n[n.CloseListbox = 1] = "CloseListbox", n[n.GoToOption = 2] = "GoToOption", n[n.Search = 3] = "Search", n[n.ClearSearch = 4] = "ClearSearch", n[n.RegisterOption = 5] = "RegisterOption", n[n.UnregisterOption = 6] = "UnregisterOption", n[n.SetButtonElement = 7] = "SetButtonElement", n[n.SetOptionsElement = 8] = "SetOptionsElement", n))($df20442161b20eb0$var$Et || {});
function $df20442161b20eb0$var$be(e, i = (o)=>o) {
    let o = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = (0, $hsQxB.sortByDomNode)(i(e.options.slice()), (m)=>m.dataRef.current.domRef.current), a = o ? r.indexOf(o) : null;
    return a === -1 && (a = null), {
        options: r,
        activeOptionIndex: a
    };
}
let $df20442161b20eb0$var$Pt = {
    [1] (e) {
        return e.dataRef.current.disabled || e.listboxState === 1 ? e : {
            ...e,
            activeOptionIndex: null,
            listboxState: 1,
            __demoMode: !1
        };
    },
    [0] (e) {
        if (e.dataRef.current.disabled || e.listboxState === 0) return e;
        let i = e.activeOptionIndex, { isSelected: o } = e.dataRef.current, r = e.options.findIndex((a)=>o(a.dataRef.current.value));
        return r !== -1 && (i = r), {
            ...e,
            listboxState: 0,
            activeOptionIndex: i,
            __demoMode: !1
        };
    },
    [2] (e, i) {
        var m, x, d, p, n;
        if (e.dataRef.current.disabled || e.listboxState === 1) return e;
        let o = {
            ...e,
            searchQuery: "",
            activationTrigger: (m = i.trigger) != null ? m : 1,
            __demoMode: !1
        };
        if (i.focus === (0, $fLrGx.Focus).Nothing) return {
            ...o,
            activeOptionIndex: null
        };
        if (i.focus === (0, $fLrGx.Focus).Specific) return {
            ...o,
            activeOptionIndex: e.options.findIndex((u)=>u.id === i.id)
        };
        if (i.focus === (0, $fLrGx.Focus).Previous) {
            let u = e.activeOptionIndex;
            if (u !== null) {
                let P = e.options[u].dataRef.current.domRef, t = (0, $fLrGx.calculateActiveIndex)(i, {
                    resolveItems: ()=>e.options,
                    resolveActiveIndex: ()=>e.activeOptionIndex,
                    resolveId: (s)=>s.id,
                    resolveDisabled: (s)=>s.dataRef.current.disabled
                });
                if (t !== null) {
                    let s = e.options[t].dataRef.current.domRef;
                    if (((x = P.current) == null ? void 0 : x.previousElementSibling) === s.current || ((d = s.current) == null ? void 0 : d.previousElementSibling) === null) return {
                        ...o,
                        activeOptionIndex: t
                    };
                }
            }
        } else if (i.focus === (0, $fLrGx.Focus).Next) {
            let u = e.activeOptionIndex;
            if (u !== null) {
                let P = e.options[u].dataRef.current.domRef, t = (0, $fLrGx.calculateActiveIndex)(i, {
                    resolveItems: ()=>e.options,
                    resolveActiveIndex: ()=>e.activeOptionIndex,
                    resolveId: (s)=>s.id,
                    resolveDisabled: (s)=>s.dataRef.current.disabled
                });
                if (t !== null) {
                    let s = e.options[t].dataRef.current.domRef;
                    if (((p = P.current) == null ? void 0 : p.nextElementSibling) === s.current || ((n = s.current) == null ? void 0 : n.nextElementSibling) === null) return {
                        ...o,
                        activeOptionIndex: t
                    };
                }
            }
        }
        let r = $df20442161b20eb0$var$be(e), a = (0, $fLrGx.calculateActiveIndex)(i, {
            resolveItems: ()=>r.options,
            resolveActiveIndex: ()=>r.activeOptionIndex,
            resolveId: (u)=>u.id,
            resolveDisabled: (u)=>u.dataRef.current.disabled
        });
        return {
            ...o,
            ...r,
            activeOptionIndex: a
        };
    },
    [3]: (e, i)=>{
        if (e.dataRef.current.disabled || e.listboxState === 1) return e;
        let r = e.searchQuery !== "" ? 0 : 1, a = e.searchQuery + i.value.toLowerCase(), x = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + r).concat(e.options.slice(0, e.activeOptionIndex + r)) : e.options).find((p)=>{
            var n;
            return !p.dataRef.current.disabled && ((n = p.dataRef.current.textValue) == null ? void 0 : n.startsWith(a));
        }), d = x ? e.options.indexOf(x) : -1;
        return d === -1 || d === e.activeOptionIndex ? {
            ...e,
            searchQuery: a
        } : {
            ...e,
            searchQuery: a,
            activeOptionIndex: d,
            activationTrigger: 1
        };
    },
    [4] (e) {
        return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : {
            ...e,
            searchQuery: ""
        };
    },
    [5]: (e, i)=>{
        let o = {
            id: i.id,
            dataRef: i.dataRef
        }, r = $df20442161b20eb0$var$be(e, (a)=>[
                ...a,
                o
            ]);
        return e.activeOptionIndex === null && e.dataRef.current.isSelected(i.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(o)), {
            ...e,
            ...r
        };
    },
    [6]: (e, i)=>{
        let o = $df20442161b20eb0$var$be(e, (r)=>{
            let a = r.findIndex((m)=>m.id === i.id);
            return a !== -1 && r.splice(a, 1), r;
        });
        return {
            ...e,
            ...o,
            activationTrigger: 1
        };
    },
    [7]: (e, i)=>e.buttonElement === i.element ? e : {
            ...e,
            buttonElement: i.element
        },
    [8]: (e, i)=>e.optionsElement === i.element ? e : {
            ...e,
            optionsElement: i.element
        }
}, $df20442161b20eb0$var$Te = (0, $acw62.createContext)(null);
$df20442161b20eb0$var$Te.displayName = "ListboxActionsContext";
function $df20442161b20eb0$var$Z(e) {
    let i = (0, $acw62.useContext)($df20442161b20eb0$var$Te);
    if (i === null) {
        let o = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $df20442161b20eb0$var$Z), o;
    }
    return i;
}
let $df20442161b20eb0$var$ee = (0, $acw62.createContext)(null);
$df20442161b20eb0$var$ee.displayName = "ListboxDataContext";
function $df20442161b20eb0$var$Q(e) {
    let i = (0, $acw62.useContext)($df20442161b20eb0$var$ee);
    if (i === null) {
        let o = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $df20442161b20eb0$var$Q), o;
    }
    return i;
}
function $df20442161b20eb0$var$Rt(e, i) {
    return (0, $6Ngq1.match)(i.type, $df20442161b20eb0$var$Pt, e, i);
}
let $df20442161b20eb0$var$At = (0, $acw62.Fragment);
function $df20442161b20eb0$var$ht(e, i) {
    var me;
    let o = (0, $brAF4.useDisabled)(), { value: r, defaultValue: a, form: m, name: x, onChange: d, by: p, invalid: n = !1, disabled: u = o || !1, horizontal: P = !1, multiple: t = !1, __demoMode: s = !1, ...F } = e;
    const M = P ? "horizontal" : "vertical";
    let h = (0, $6mpbl.useSyncRefs)(i), D = (0, $3X9lW.useDefaultValue)(a), [O = t ? [] : void 0, g] = (0, $h26ct.useControllable)(r, d, D), [R, y] = (0, $acw62.useReducer)($df20442161b20eb0$var$Rt, {
        dataRef: (0, $acw62.createRef)(),
        listboxState: s ? 0 : 1,
        options: [],
        searchQuery: "",
        activeOptionIndex: null,
        activationTrigger: 1,
        optionsVisible: !1,
        buttonElement: null,
        optionsElement: null,
        __demoMode: s
    }), B = (0, $acw62.useRef)({
        static: !1,
        hold: !1
    }), w = (0, $acw62.useRef)(new Map), _ = (0, $ePQFN.useByComparator)(p), b = (0, $acw62.useCallback)((f)=>(0, $6Ngq1.match)(c.mode, {
            [1]: ()=>O.some((S)=>_(S, f)),
            [0]: ()=>_(O, f)
        }), [
        O
    ]), c = (0, $acw62.useMemo)(()=>({
            ...R,
            value: O,
            disabled: u,
            invalid: n,
            mode: t ? 1 : 0,
            orientation: M,
            compare: _,
            isSelected: b,
            optionsPropsRef: B,
            listRef: w
        }), [
        O,
        u,
        n,
        t,
        R,
        w
    ]);
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        R.dataRef.current = c;
    }, [
        c
    ]);
    let N = c.listboxState === 0;
    (0, $23pTr.useOutsideClick)(N, [
        c.buttonElement,
        c.optionsElement
    ], (f, S)=>{
        var C;
        y({
            type: 1
        }), (0, $hsQxB.isFocusableElement)(S, (0, $hsQxB.FocusableMode).Loose) || (f.preventDefault(), (C = c.buttonElement) == null || C.focus());
    });
    let L = (0, $acw62.useMemo)(()=>({
            open: c.listboxState === 0,
            disabled: u,
            invalid: n,
            value: O
        }), [
        c,
        u,
        O,
        n
    ]), H = (0, $114Mg.useEvent)((f)=>{
        let S = c.options.find((C)=>C.id === f);
        S && K(S.dataRef.current.value);
    }), te = (0, $114Mg.useEvent)(()=>{
        if (c.activeOptionIndex !== null) {
            let { dataRef: f, id: S } = c.options[c.activeOptionIndex];
            K(f.current.value), y({
                type: 2,
                focus: (0, $fLrGx.Focus).Specific,
                id: S
            });
        }
    }), oe = (0, $114Mg.useEvent)(()=>y({
            type: 0
        })), X = (0, $114Mg.useEvent)(()=>y({
            type: 1
        })), J = (0, $5Ai9V.useDisposables)(), ne = (0, $114Mg.useEvent)((f, S, C)=>{
        J.dispose(), J.microTask(()=>f === (0, $fLrGx.Focus).Specific ? y({
                type: 2,
                focus: (0, $fLrGx.Focus).Specific,
                id: S,
                trigger: C
            }) : y({
                type: 2,
                focus: f,
                trigger: C
            }));
    }), ie = (0, $114Mg.useEvent)((f, S)=>(y({
            type: 5,
            id: f,
            dataRef: S
        }), ()=>y({
                type: 6,
                id: f
            }))), K = (0, $114Mg.useEvent)((f)=>(0, $6Ngq1.match)(c.mode, {
            [0] () {
                return g == null ? void 0 : g(f);
            },
            [1] () {
                let S = c.value.slice(), C = S.findIndex((Re)=>_(Re, f));
                return C === -1 ? S.push(f) : S.splice(C, 1), g == null ? void 0 : g(S);
            }
        })), re = (0, $114Mg.useEvent)((f)=>y({
            type: 3,
            value: f
        })), $ = (0, $114Mg.useEvent)(()=>y({
            type: 4
        })), q = (0, $114Mg.useEvent)((f)=>{
        y({
            type: 7,
            element: f
        });
    }), l = (0, $114Mg.useEvent)((f)=>{
        y({
            type: 8,
            element: f
        });
    }), I = (0, $acw62.useMemo)(()=>({
            onChange: K,
            registerOption: ie,
            goToOption: ne,
            closeListbox: X,
            openListbox: oe,
            selectActiveOption: te,
            selectOption: H,
            search: re,
            clearSearch: $,
            setButtonElement: q,
            setOptionsElement: l
        }), []), [G, le] = (0, $5qg9U.useLabels)({
        inherit: !0
    }), Se = {
        ref: h
    }, Ee = (0, $acw62.useCallback)(()=>{
        if (D !== void 0) return g == null ? void 0 : g(D);
    }, [
        g,
        D
    ]), Pe = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(le, {
        value: G,
        props: {
            htmlFor: (me = c.buttonElement) == null ? void 0 : me.id
        },
        slot: {
            open: c.listboxState === 0,
            disabled: u
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $34Str.FloatingProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($df20442161b20eb0$var$Te.Provider, {
        value: I
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($df20442161b20eb0$var$ee.Provider, {
        value: c
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $auuNT.OpenClosedProvider), {
        value: (0, $6Ngq1.match)(c.listboxState, {
            [0]: (0, $auuNT.State).Open,
            [1]: (0, $auuNT.State).Closed
        })
    }, x != null && O != null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dBJH0.FormFields), {
        disabled: u,
        data: {
            [x]: O
        },
        form: m,
        onReset: Ee
    }), Pe({
        ourProps: Se,
        theirProps: F,
        slot: L,
        defaultTag: $df20442161b20eb0$var$At,
        name: "Listbox"
    }))))));
}
let $df20442161b20eb0$var$Dt = "button";
function $df20442161b20eb0$var$_t(e, i) {
    var N;
    let o = $df20442161b20eb0$var$Q("Listbox.Button"), r = $df20442161b20eb0$var$Z("Listbox.Button"), a = (0, $acw62.useId)(), m = (0, $jpbxo.useProvidedId)(), { id: x = m || `headlessui-listbox-button-${a}`, disabled: d = o.disabled || !1, autoFocus: p = !1, ...n } = e, u = (0, $6mpbl.useSyncRefs)(i, (0, $34Str.useFloatingReference)(), r.setButtonElement), P = (0, $34Str.useFloatingReferenceProps)(), t = (0, $114Mg.useEvent)((L)=>{
        switch(L.key){
            case (0, $6AKlm.Keys).Enter:
                (0, $7FnlJ.attemptSubmit)(L.currentTarget);
                break;
            case (0, $6AKlm.Keys).Space:
            case (0, $6AKlm.Keys).ArrowDown:
                L.preventDefault(), (0, $1u0KT.flushSync)(()=>r.openListbox()), o.value || r.goToOption((0, $fLrGx.Focus).First);
                break;
            case (0, $6AKlm.Keys).ArrowUp:
                L.preventDefault(), (0, $1u0KT.flushSync)(()=>r.openListbox()), o.value || r.goToOption((0, $fLrGx.Focus).Last);
                break;
        }
    }), s = (0, $114Mg.useEvent)((L)=>{
        switch(L.key){
            case (0, $6AKlm.Keys).Space:
                L.preventDefault();
                break;
        }
    }), F = (0, $114Mg.useEvent)((L)=>{
        var H;
        if ((0, $5fYEB.isDisabledReactIssue7711)(L.currentTarget)) return L.preventDefault();
        o.listboxState === 0 ? ((0, $1u0KT.flushSync)(()=>r.closeListbox()), (H = o.buttonElement) == null || H.focus({
            preventScroll: !0
        })) : (L.preventDefault(), r.openListbox());
    }), M = (0, $114Mg.useEvent)((L)=>L.preventDefault()), h = (0, $5qg9U.useLabelledBy)([
        x
    ]), D = (0, $iGb09.useDescribedBy)(), { isFocusVisible: O, focusProps: g } = (0, $kd7LS.useFocusRing)({
        autoFocus: p
    }), { isHovered: R, hoverProps: y } = (0, $6o6B3.useHover)({
        isDisabled: d
    }), { pressed: B, pressProps: w } = (0, $cE9hP.useActivePress)({
        disabled: d
    }), _ = (0, $acw62.useMemo)(()=>({
            open: o.listboxState === 0,
            active: B || o.listboxState === 0,
            disabled: d,
            invalid: o.invalid,
            value: o.value,
            hover: R,
            focus: O,
            autofocus: p
        }), [
        o.listboxState,
        o.value,
        d,
        R,
        O,
        B,
        o.invalid,
        p
    ]), b = (0, $ebRQH.mergeProps)(P(), {
        ref: u,
        id: x,
        type: (0, $gm4XX.useResolveButtonType)(e, o.buttonElement),
        "aria-haspopup": "listbox",
        "aria-controls": (N = o.optionsElement) == null ? void 0 : N.id,
        "aria-expanded": o.listboxState === 0,
        "aria-labelledby": h,
        "aria-describedby": D,
        disabled: d || void 0,
        autoFocus: p,
        onKeyDown: t,
        onKeyUp: s,
        onKeyPress: M,
        onClick: F
    }, g, y, w);
    return (0, $ebRQH.useRender)()({
        ourProps: b,
        theirProps: n,
        slot: _,
        defaultTag: $df20442161b20eb0$var$Dt,
        name: "Listbox.Button"
    });
}
let $df20442161b20eb0$var$Le = (0, $acw62.createContext)(!1), $df20442161b20eb0$var$It = "div", $df20442161b20eb0$var$Ct = (0, $ebRQH.RenderFeatures).RenderStrategy | (0, $ebRQH.RenderFeatures).Static;
function $df20442161b20eb0$var$Ft(e, i) {
    var $, q;
    let o = (0, $acw62.useId)(), { id: r = `headlessui-listbox-options-${o}`, anchor: a, portal: m = !1, modal: x = !0, transition: d = !1, ...p } = e, n = (0, $34Str.useResolvedAnchor)(a), [u, P] = (0, $acw62.useState)(null);
    n && (m = !0);
    let t = $df20442161b20eb0$var$Q("Listbox.Options"), s = $df20442161b20eb0$var$Z("Listbox.Options"), F = (0, $5IEAk.useOwnerDocument)(t.optionsElement), M = (0, $auuNT.useOpenClosed)(), [h, D] = (0, $bdknl.useTransition)(d, u, M !== null ? (M & (0, $auuNT.State).Open) === (0, $auuNT.State).Open : t.listboxState === 0);
    (0, $dcp2r.useOnDisappear)(h, t.buttonElement, s.closeListbox);
    let O = t.__demoMode ? !1 : x && t.listboxState === 0;
    (0, $hZodg.useScrollLock)(O, F);
    let g = t.__demoMode ? !1 : x && t.listboxState === 0;
    (0, $keKjn.useInertOthers)(g, {
        allowed: (0, $acw62.useCallback)(()=>[
                t.buttonElement,
                t.optionsElement
            ], [
            t.buttonElement,
            t.optionsElement
        ])
    });
    let R = t.listboxState !== 0, B = (0, $hd1nN.useDidElementMove)(R, t.buttonElement) ? !1 : h, w = h && t.listboxState === 1, _ = (0, $9UPTU.useFrozenData)(w, t.value), b = (0, $114Mg.useEvent)((l)=>t.compare(_, l)), c = (0, $acw62.useMemo)(()=>{
        var I;
        if (n == null || !((I = n == null ? void 0 : n.to) != null && I.includes("selection"))) return null;
        let l = t.options.findIndex((G)=>b(G.dataRef.current.value));
        return l === -1 && (l = 0), l;
    }, [
        n,
        t.options
    ]), N = (()=>{
        if (n == null) return;
        if (c === null) return {
            ...n,
            inner: void 0
        };
        let l = Array.from(t.listRef.current.values());
        return {
            ...n,
            inner: {
                listRef: {
                    current: l
                },
                index: c
            }
        };
    })(), [L, H] = (0, $34Str.useFloatingPanel)(N), te = (0, $34Str.useFloatingPanelProps)(), oe = (0, $6mpbl.useSyncRefs)(i, n ? L : null, s.setOptionsElement, P), X = (0, $5Ai9V.useDisposables)();
    (0, $acw62.useEffect)(()=>{
        var I;
        let l = t.optionsElement;
        l && t.listboxState === 0 && l !== ((I = (0, $gxwGc.getOwnerDocument)(l)) == null ? void 0 : I.activeElement) && (l == null || l.focus({
            preventScroll: !0
        }));
    }, [
        t.listboxState,
        t.optionsElement
    ]);
    let J = (0, $114Mg.useEvent)((l)=>{
        var I, G;
        switch(X.dispose(), l.key){
            case (0, $6AKlm.Keys).Space:
                if (t.searchQuery !== "") return l.preventDefault(), l.stopPropagation(), s.search(l.key);
            case (0, $6AKlm.Keys).Enter:
                if (l.preventDefault(), l.stopPropagation(), t.activeOptionIndex !== null) {
                    let { dataRef: le } = t.options[t.activeOptionIndex];
                    s.onChange(le.current.value);
                }
                t.mode === 0 && ((0, $1u0KT.flushSync)(()=>s.closeListbox()), (I = t.buttonElement) == null || I.focus({
                    preventScroll: !0
                }));
                break;
            case (0, $6Ngq1.match)(t.orientation, {
                vertical: (0, $6AKlm.Keys).ArrowDown,
                horizontal: (0, $6AKlm.Keys).ArrowRight
            }):
                return l.preventDefault(), l.stopPropagation(), s.goToOption((0, $fLrGx.Focus).Next);
            case (0, $6Ngq1.match)(t.orientation, {
                vertical: (0, $6AKlm.Keys).ArrowUp,
                horizontal: (0, $6AKlm.Keys).ArrowLeft
            }):
                return l.preventDefault(), l.stopPropagation(), s.goToOption((0, $fLrGx.Focus).Previous);
            case (0, $6AKlm.Keys).Home:
            case (0, $6AKlm.Keys).PageUp:
                return l.preventDefault(), l.stopPropagation(), s.goToOption((0, $fLrGx.Focus).First);
            case (0, $6AKlm.Keys).End:
            case (0, $6AKlm.Keys).PageDown:
                return l.preventDefault(), l.stopPropagation(), s.goToOption((0, $fLrGx.Focus).Last);
            case (0, $6AKlm.Keys).Escape:
                l.preventDefault(), l.stopPropagation(), (0, $1u0KT.flushSync)(()=>s.closeListbox()), (G = t.buttonElement) == null || G.focus({
                    preventScroll: !0
                });
                return;
            case (0, $6AKlm.Keys).Tab:
                l.preventDefault(), l.stopPropagation(), (0, $1u0KT.flushSync)(()=>s.closeListbox()), (0, $hsQxB.focusFrom)(t.buttonElement, l.shiftKey ? (0, $hsQxB.Focus).Previous : (0, $hsQxB.Focus).Next);
                break;
            default:
                l.key.length === 1 && (s.search(l.key), X.setTimeout(()=>s.clearSearch(), 350));
                break;
        }
    }), ne = ($ = t.buttonElement) == null ? void 0 : $.id, ie = (0, $acw62.useMemo)(()=>({
            open: t.listboxState === 0
        }), [
        t.listboxState
    ]), K = (0, $ebRQH.mergeProps)(n ? te() : {}, {
        id: r,
        ref: oe,
        "aria-activedescendant": t.activeOptionIndex === null || (q = t.options[t.activeOptionIndex]) == null ? void 0 : q.id,
        "aria-multiselectable": t.mode === 1 ? !0 : void 0,
        "aria-labelledby": ne,
        "aria-orientation": t.orientation,
        onKeyDown: J,
        role: "listbox",
        tabIndex: t.listboxState === 0 ? 0 : void 0,
        style: {
            ...p.style,
            ...H,
            "--button-width": (0, $dfvrc.useElementSize)(t.buttonElement, !0).width
        },
        ...(0, $bdknl.transitionDataAttributes)(D)
    }), re = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e9NTc.Portal), {
        enabled: m ? e.static || h : !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($df20442161b20eb0$var$ee.Provider, {
        value: t.mode === 1 ? t : {
            ...t,
            isSelected: b
        }
    }, re({
        ourProps: K,
        theirProps: p,
        slot: ie,
        defaultTag: $df20442161b20eb0$var$It,
        features: $df20442161b20eb0$var$Ct,
        visible: B,
        name: "Listbox.Options"
    })));
}
let $df20442161b20eb0$var$Mt = "div";
function $df20442161b20eb0$var$Bt(e, i) {
    let o = (0, $acw62.useId)(), { id: r = `headlessui-listbox-option-${o}`, disabled: a = !1, value: m, ...x } = e, d = (0, $acw62.useContext)($df20442161b20eb0$var$Le) === !0, p = $df20442161b20eb0$var$Q("Listbox.Option"), n = $df20442161b20eb0$var$Z("Listbox.Option"), u = p.activeOptionIndex !== null ? p.options[p.activeOptionIndex].id === r : !1, P = p.isSelected(m), t = (0, $acw62.useRef)(null), s = (0, $jN7sP.useTextValue)(t), F = (0, $ltgxC.useLatestValue)({
        disabled: a,
        value: m,
        domRef: t,
        get textValue () {
            return s();
        }
    }), M = (0, $6mpbl.useSyncRefs)(i, t, (b)=>{
        b ? p.listRef.current.set(r, b) : p.listRef.current.delete(r);
    });
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!p.__demoMode && p.listboxState === 0 && u && p.activationTrigger !== 0) return (0, $1COYr.disposables)().requestAnimationFrame(()=>{
            var b, c;
            (c = (b = t.current) == null ? void 0 : b.scrollIntoView) == null || c.call(b, {
                block: "nearest"
            });
        });
    }, [
        t,
        u,
        p.__demoMode,
        p.listboxState,
        p.activationTrigger,
        p.activeOptionIndex
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!d) return n.registerOption(r, F);
    }, [
        F,
        r,
        d
    ]);
    let h = (0, $114Mg.useEvent)((b)=>{
        var c;
        if (a) return b.preventDefault();
        n.onChange(m), p.mode === 0 && ((0, $1u0KT.flushSync)(()=>n.closeListbox()), (c = p.buttonElement) == null || c.focus({
            preventScroll: !0
        }));
    }), D = (0, $114Mg.useEvent)(()=>{
        if (a) return n.goToOption((0, $fLrGx.Focus).Nothing);
        n.goToOption((0, $fLrGx.Focus).Specific, r);
    }), O = (0, $ipity.useTrackedPointer)(), g = (0, $114Mg.useEvent)((b)=>{
        O.update(b), !a && (u || n.goToOption((0, $fLrGx.Focus).Specific, r, 0));
    }), R = (0, $114Mg.useEvent)((b)=>{
        O.wasMoved(b) && (a || u || n.goToOption((0, $fLrGx.Focus).Specific, r, 0));
    }), y = (0, $114Mg.useEvent)((b)=>{
        O.wasMoved(b) && (a || u && n.goToOption((0, $fLrGx.Focus).Nothing));
    }), B = (0, $acw62.useMemo)(()=>({
            active: u,
            focus: u,
            selected: P,
            disabled: a,
            selectedOption: P && d
        }), [
        u,
        P,
        a,
        d
    ]), w = d ? {} : {
        id: r,
        ref: M,
        role: "option",
        tabIndex: a === !0 ? void 0 : -1,
        "aria-disabled": a === !0 ? !0 : void 0,
        "aria-selected": P,
        disabled: void 0,
        onClick: h,
        onFocus: D,
        onPointerEnter: g,
        onMouseEnter: g,
        onPointerMove: R,
        onMouseMove: R,
        onPointerLeave: y,
        onMouseLeave: y
    }, _ = (0, $ebRQH.useRender)();
    return !P && d ? null : _({
        ourProps: w,
        theirProps: x,
        slot: B,
        defaultTag: $df20442161b20eb0$var$Mt,
        name: "Listbox.Option"
    });
}
let $df20442161b20eb0$var$wt = (0, $acw62.Fragment);
function $df20442161b20eb0$var$kt(e, i) {
    let { options: o, placeholder: r, ...a } = e, x = {
        ref: (0, $6mpbl.useSyncRefs)(i)
    }, d = $df20442161b20eb0$var$Q("ListboxSelectedOption"), p = (0, $acw62.useMemo)(()=>({}), []), n = d.value === void 0 || d.value === null || d.mode === 1 && Array.isArray(d.value) && d.value.length === 0, u = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($df20442161b20eb0$var$Le.Provider, {
        value: !0
    }, u({
        ourProps: x,
        theirProps: {
            ...a,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, r && n ? r : o)
        },
        slot: p,
        defaultTag: $df20442161b20eb0$var$wt,
        name: "ListboxSelectedOption"
    }));
}
let $df20442161b20eb0$var$Ut = (0, $ebRQH.forwardRefWithAs)($df20442161b20eb0$var$ht), $df20442161b20eb0$export$1e1e59bb4b882447 = (0, $ebRQH.forwardRefWithAs)($df20442161b20eb0$var$_t), $df20442161b20eb0$export$3b435d19b0be2a59 = (0, $5qg9U.Label), $df20442161b20eb0$export$ea8d88fc73d4fb81 = (0, $ebRQH.forwardRefWithAs)($df20442161b20eb0$var$Ft), $df20442161b20eb0$export$68e891bae1a5b917 = (0, $ebRQH.forwardRefWithAs)($df20442161b20eb0$var$Bt), $df20442161b20eb0$export$867366afc1aaaf63 = (0, $ebRQH.forwardRefWithAs)($df20442161b20eb0$var$kt), $df20442161b20eb0$export$8bad31ff872c7659 = Object.assign($df20442161b20eb0$var$Ut, {
    Button: $df20442161b20eb0$export$1e1e59bb4b882447,
    Label: $df20442161b20eb0$export$3b435d19b0be2a59,
    Options: $df20442161b20eb0$export$ea8d88fc73d4fb81,
    Option: $df20442161b20eb0$export$68e891bae1a5b917,
    SelectedOption: $df20442161b20eb0$export$867366afc1aaaf63
});

});
parcelRegister("ePQFN", function(module, exports) {

$parcel$export(module.exports, "useByComparator", () => $acceafe1d565f09b$export$988f0cf1b37580ae);

var $acw62 = parcelRequire("acw62");
function $acceafe1d565f09b$var$l(e, r) {
    return e !== null && r !== null && typeof e == "object" && typeof r == "object" && "id" in e && "id" in r ? e.id === r.id : e === r;
}
function $acceafe1d565f09b$export$988f0cf1b37580ae(e = $acceafe1d565f09b$var$l) {
    return (0, $acw62.useCallback)((r, t)=>{
        if (typeof e == "string") {
            let o = e;
            return (r == null ? void 0 : r[o]) === (t == null ? void 0 : t[o]);
        }
        return e(r, t);
    }, [
        e
    ]);
}

});

parcelRegister("h26ct", function(module, exports) {

$parcel$export(module.exports, "useControllable", () => $c6676ed1f400443a$export$454217e89aea72b);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");
function $c6676ed1f400443a$export$454217e89aea72b(l, r, c) {
    let [i, s] = (0, $acw62.useState)(c), e = l !== void 0, t = (0, $acw62.useRef)(e), u = (0, $acw62.useRef)(!1), d = (0, $acw62.useRef)(!1);
    return e && !t.current && !u.current ? (u.current = !0, t.current = e, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e && t.current && !d.current && (d.current = !0, t.current = e, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [
        e ? l : i,
        (0, $114Mg.useEvent)((n)=>(e || s(n), r == null ? void 0 : r(n)))
    ];
}

});

parcelRegister("3X9lW", function(module, exports) {

$parcel$export(module.exports, "useDefaultValue", () => $2e0e230f066909d2$export$8a91ee242b6d0fe3);

var $acw62 = parcelRequire("acw62");
function $2e0e230f066909d2$export$8a91ee242b6d0fe3(e) {
    let [t] = (0, $acw62.useState)(e);
    return t;
}

});

parcelRegister("dBJH0", function(module, exports) {

$parcel$export(module.exports, "FormFields", () => $9e822caca6037577$export$125d0b248abd3e88);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $5Ai9V = parcelRequire("5Ai9V");

var $7FnlJ = parcelRequire("7FnlJ");

var $ebRQH = parcelRequire("ebRQH");

var $k9Al5 = parcelRequire("k9Al5");
let $9e822caca6037577$var$f = (0, $acw62.createContext)(null);
function $9e822caca6037577$export$172bce5caea3d96f(t) {
    let [e, r] = (0, $acw62.useState)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e822caca6037577$var$f.Provider, {
        value: {
            target: e
        }
    }, t.children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        features: (0, $k9Al5.HiddenFeatures).Hidden,
        ref: r
    }));
}
function $9e822caca6037577$export$ddeacde93f925346({ children: t }) {
    let e = (0, $acw62.useContext)($9e822caca6037577$var$f);
    if (!e) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, t);
    let { target: r } = e;
    return r ? (0, $1u0KT.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, t), r) : null;
}
function $9e822caca6037577$export$125d0b248abd3e88({ data: t, form: e, disabled: r, onReset: n, overrides: F }) {
    let [i, a] = (0, $acw62.useState)(null), p = (0, $5Ai9V.useDisposables)();
    return (0, $acw62.useEffect)(()=>{
        if (n && i) return p.addEventListener(i, "reset", n);
    }, [
        i,
        e,
        n
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e822caca6037577$export$ddeacde93f925346, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e822caca6037577$var$C, {
        setForm: a,
        formId: e
    }), (0, $7FnlJ.objectToFormEntries)(t).map(([s, v])=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
            features: (0, $k9Al5.HiddenFeatures).Hidden,
            ...(0, $ebRQH.compact)({
                key: s,
                as: "input",
                type: "hidden",
                hidden: !0,
                readOnly: !0,
                form: e,
                disabled: r,
                name: s,
                value: v,
                ...F
            })
        })));
}
function $9e822caca6037577$var$C({ setForm: t, formId: e }) {
    return (0, $acw62.useEffect)(()=>{
        if (e) {
            let r = document.getElementById(e);
            r && t(r);
        }
    }, [
        t,
        e
    ]), e ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        features: (0, $k9Al5.HiddenFeatures).Hidden,
        as: "input",
        type: "hidden",
        hidden: !0,
        readOnly: !0,
        ref: (r)=>{
            if (!r) return;
            let n = r.closest("form");
            n && t(n);
        }
    });
}

});
parcelRegister("7FnlJ", function(module, exports) {

$parcel$export(module.exports, "objectToFormEntries", () => $594e79751740d704$export$bc22b3e852574dab);
$parcel$export(module.exports, "attemptSubmit", () => $594e79751740d704$export$ee02894bdc79dd36);
function $594e79751740d704$export$bc22b3e852574dab(i = {}, s = null, t = []) {
    for (let [r, n] of Object.entries(i))$594e79751740d704$var$o(t, $594e79751740d704$var$f(s, r), n);
    return t;
}
function $594e79751740d704$var$f(i, s) {
    return i ? i + "[" + s + "]" : s;
}
function $594e79751740d704$var$o(i, s, t) {
    if (Array.isArray(t)) for (let [r, n] of t.entries())$594e79751740d704$var$o(i, $594e79751740d704$var$f(s, r.toString()), n);
    else t instanceof Date ? i.push([
        s,
        t.toISOString()
    ]) : typeof t == "boolean" ? i.push([
        s,
        t ? "1" : "0"
    ]) : typeof t == "string" ? i.push([
        s,
        t
    ]) : typeof t == "number" ? i.push([
        s,
        `${t}`
    ]) : t == null ? i.push([
        s,
        ""
    ]) : $594e79751740d704$export$bc22b3e852574dab(t, s, i);
}
function $594e79751740d704$export$ee02894bdc79dd36(i) {
    var t, r;
    let s = (t = i == null ? void 0 : i.form) != null ? t : i.closest("form");
    if (s) {
        for (let n of s.elements)if (n !== i && (n.tagName === "INPUT" && n.type === "submit" || n.tagName === "BUTTON" && n.type === "submit" || n.nodeName === "INPUT" && n.type === "image")) {
            n.click();
            return;
        }
        (r = s.requestSubmit) == null || r.call(s);
    }
}

});


parcelRegister("9UPTU", function(module, exports) {

$parcel$export(module.exports, "useFrozenData", () => $73819a70e276dbaa$export$1a771eb6e04a3c48);

var $acw62 = parcelRequire("acw62");
function $73819a70e276dbaa$export$824932a86c309819({ children: o, freeze: e }) {
    let n = $73819a70e276dbaa$export$1a771eb6e04a3c48(e, o);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, n);
}
function $73819a70e276dbaa$export$1a771eb6e04a3c48(o, e) {
    let [n, t] = (0, $acw62.useState)(e);
    return !o && n !== e && t(e), o ? n : e;
}

});


parcelRegister("ckP3P", function(module, exports) {

$parcel$export(module.exports, "default", () => $8faef5e48f16404b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $8faef5e48f16404b$var$CheckIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z",
        clipRule: "evenodd"
    }));
}
const $8faef5e48f16404b$var$ForwardRef = $acw62.forwardRef($8faef5e48f16404b$var$CheckIcon);
var $8faef5e48f16404b$export$2e2bcd8739ae039 = $8faef5e48f16404b$var$ForwardRef;

});

parcelRegister("8kHHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $611217fafa9138af$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $611217fafa9138af$var$ChevronUpDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M10.53 3.47a.75.75 0 0 0-1.06 0L6.22 6.72a.75.75 0 0 0 1.06 1.06L10 5.06l2.72 2.72a.75.75 0 1 0 1.06-1.06l-3.25-3.25Zm-4.31 9.81 3.25 3.25a.75.75 0 0 0 1.06 0l3.25-3.25a.75.75 0 1 0-1.06-1.06L10 14.94l-2.72-2.72a.75.75 0 0 0-1.06 1.06Z",
        clipRule: "evenodd"
    }));
}
const $611217fafa9138af$var$ForwardRef = $acw62.forwardRef($611217fafa9138af$var$ChevronUpDownIcon);
var $611217fafa9138af$export$2e2bcd8739ae039 = $611217fafa9138af$var$ForwardRef;

});



parcelRegister("8WnAC", function(module, exports) {
$parcel$export(module.exports, "Section", () => (parcelRequire("7i7mP")).Section);
parcelRequire("7i7mP");

});
parcelRegister("7i7mP", function(module, exports) {

$parcel$export(module.exports, "Section", () => $d0ae3bb0c77129f2$export$6e2c8f0811a474ce);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $bvcna = parcelRequire("bvcna");
function $d0ae3bb0c77129f2$export$6e2c8f0811a474ce({ testId: testId, className: className, children: children, title: title, secondaryBg: secondaryBg }) {
    const sectionClasses = "hum-container pt-20 pb-20 px-8 lg:px-0";
    return /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: (0, $9QePP.default)((0, $bvcna.twMerge)(!secondaryBg && sectionClasses, secondaryBg && "bg-secondary", className)),
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, $9QePP.default)(secondaryBg && sectionClasses),
            children: [
                title && /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "mb-8 text-left",
                    children: title
                }),
                children
            ]
        })
    });
}

});


parcelRegister("jduyU", function(module, exports) {
$parcel$export(module.exports, "Toggle", () => (parcelRequire("3djtJ")).Toggle);
parcelRequire("3djtJ");

});
parcelRegister("3djtJ", function(module, exports) {

$parcel$export(module.exports, "Toggle", () => $ed58dec150ce84d8$export$bea8ebba691c5813);

var $ayMG0 = parcelRequire("ayMG0");

var $c0bfv = parcelRequire("c0bfv");

var $9QePP = parcelRequire("9QePP");
function $ed58dec150ce84d8$export$bea8ebba691c5813({ testId: testId, className: className, checked: checked = false, onChange: onChange }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0bfv.Switch), {
        as: "div",
        "data-testid": testId,
        checked: checked,
        onChange: onChange,
        className: (0, $9QePP.default)(checked ? "bg-brand-500" : "bg-slate-600 dark:bg-slate-900", `relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent
                transition-colors duration-200 ease-in-out focus:outline-none`, className),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            "aria-hidden": "true",
            className: (0, $9QePP.default)(checked ? "translate-x-5" : "translate-x-0", `pointer-events-none inline-block size-5 rounded-full bg-white shadow ring-0
                    transition duration-200 ease-in-out`)
        })
    });
}

});
parcelRegister("c0bfv", function(module, exports) {

$parcel$export(module.exports, "Switch", () => $8bce35f563baeffd$export$b5d5cf8927ab7262);

var $kd7LS = parcelRequire("kd7LS");

var $6o6B3 = parcelRequire("6o6B3");

var $acw62 = parcelRequire("acw62");

var $cE9hP = parcelRequire("cE9hP");

var $h26ct = parcelRequire("h26ct");

var $3X9lW = parcelRequire("3X9lW");

var $5Ai9V = parcelRequire("5Ai9V");

var $114Mg = parcelRequire("114Mg");

var $acw62 = parcelRequire("acw62");

var $gm4XX = parcelRequire("gm4XX");

var $6mpbl = parcelRequire("6mpbl");

var $brAF4 = parcelRequire("brAF4");

var $dBJH0 = parcelRequire("dBJH0");

var $jpbxo = parcelRequire("jpbxo");

var $5fYEB = parcelRequire("5fYEB");

var $7FnlJ = parcelRequire("7FnlJ");

var $ebRQH = parcelRequire("ebRQH");

var $iGb09 = parcelRequire("iGb09");

var $6AKlm = parcelRequire("6AKlm");

var $5qg9U = parcelRequire("5qg9U");
"use client";
let $8bce35f563baeffd$var$E = (0, $acw62.createContext)(null);
$8bce35f563baeffd$var$E.displayName = "GroupContext";
let $8bce35f563baeffd$var$De = (0, $acw62.Fragment);
function $8bce35f563baeffd$var$ge(n) {
    var u;
    let [o, s] = (0, $acw62.useState)(null), [h, b] = (0, $5qg9U.useLabels)(), [T, t] = (0, $iGb09.useDescriptions)(), p = (0, $acw62.useMemo)(()=>({
            switch: o,
            setSwitch: s
        }), [
        o,
        s
    ]), y = {}, S = n, c = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(t, {
        name: "Switch.Description",
        value: T
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(b, {
        name: "Switch.Label",
        value: h,
        props: {
            htmlFor: (u = p.switch) == null ? void 0 : u.id,
            onClick (d) {
                o && (d.currentTarget instanceof HTMLLabelElement && d.preventDefault(), o.click(), o.focus({
                    preventScroll: !0
                }));
            }
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8bce35f563baeffd$var$E.Provider, {
        value: p
    }, c({
        ourProps: y,
        theirProps: S,
        slot: {},
        defaultTag: $8bce35f563baeffd$var$De,
        name: "Switch.Group"
    }))));
}
let $8bce35f563baeffd$var$ve = "button";
function $8bce35f563baeffd$var$xe(n, o) {
    var L;
    let s = (0, $acw62.useId)(), h = (0, $jpbxo.useProvidedId)(), b = (0, $brAF4.useDisabled)(), { id: T = h || `headlessui-switch-${s}`, disabled: t = b || !1, checked: p, defaultChecked: y, onChange: S, name: c, value: u, form: d, autoFocus: m = !1, ...F } = n, _ = (0, $acw62.useContext)($8bce35f563baeffd$var$E), [H, k] = (0, $acw62.useState)(null), M = (0, $acw62.useRef)(null), U = (0, $6mpbl.useSyncRefs)(M, o, _ === null ? null : _.setSwitch, k), l = (0, $3X9lW.useDefaultValue)(y), [a, r] = (0, $h26ct.useControllable)(p, S, l != null ? l : !1), I = (0, $5Ai9V.useDisposables)(), [P, D] = (0, $acw62.useState)(!1), g = (0, $114Mg.useEvent)(()=>{
        D(!0), r == null || r(!a), I.nextFrame(()=>{
            D(!1);
        });
    }), B = (0, $114Mg.useEvent)((e)=>{
        if ((0, $5fYEB.isDisabledReactIssue7711)(e.currentTarget)) return e.preventDefault();
        e.preventDefault(), g();
    }), K = (0, $114Mg.useEvent)((e)=>{
        e.key === (0, $6AKlm.Keys).Space ? (e.preventDefault(), g()) : e.key === (0, $6AKlm.Keys).Enter && (0, $7FnlJ.attemptSubmit)(e.currentTarget);
    }), W = (0, $114Mg.useEvent)((e)=>e.preventDefault()), O = (0, $5qg9U.useLabelledBy)(), N = (0, $iGb09.useDescribedBy)(), { isFocusVisible: v, focusProps: J } = (0, $kd7LS.useFocusRing)({
        autoFocus: m
    }), { isHovered: x, hoverProps: V } = (0, $6o6B3.useHover)({
        isDisabled: t
    }), { pressed: C, pressProps: X } = (0, $cE9hP.useActivePress)({
        disabled: t
    }), j = (0, $acw62.useMemo)(()=>({
            checked: a,
            disabled: t,
            hover: x,
            focus: v,
            active: C,
            autofocus: m,
            changing: P
        }), [
        a,
        x,
        v,
        C,
        t,
        P,
        m
    ]), $ = (0, $ebRQH.mergeProps)({
        id: T,
        ref: U,
        role: "switch",
        type: (0, $gm4XX.useResolveButtonType)(n, H),
        tabIndex: n.tabIndex === -1 ? 0 : (L = n.tabIndex) != null ? L : 0,
        "aria-checked": a,
        "aria-labelledby": O,
        "aria-describedby": N,
        disabled: t || void 0,
        autoFocus: m,
        onClick: B,
        onKeyUp: K,
        onKeyPress: W
    }, J, V, X), q = (0, $acw62.useCallback)(()=>{
        if (l !== void 0) return r == null ? void 0 : r(l);
    }, [
        r,
        l
    ]), z = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, c != null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dBJH0.FormFields), {
        disabled: t,
        data: {
            [c]: u || "on"
        },
        overrides: {
            type: "checkbox",
            checked: a
        },
        form: d,
        onReset: q
    }), z({
        ourProps: $,
        theirProps: F,
        slot: j,
        defaultTag: $8bce35f563baeffd$var$ve,
        name: "Switch"
    }));
}
let $8bce35f563baeffd$var$Ce = (0, $ebRQH.forwardRefWithAs)($8bce35f563baeffd$var$xe), $8bce35f563baeffd$export$1b8cf0fbf52a628d = $8bce35f563baeffd$var$ge, $8bce35f563baeffd$export$39c63c162e5f0cd = (0, $5qg9U.Label), $8bce35f563baeffd$export$3a20efcbfef43af = (0, $iGb09.Description), $8bce35f563baeffd$export$b5d5cf8927ab7262 = Object.assign($8bce35f563baeffd$var$Ce, {
    Group: $8bce35f563baeffd$export$1b8cf0fbf52a628d,
    Label: $8bce35f563baeffd$export$39c63c162e5f0cd,
    Description: $8bce35f563baeffd$export$3a20efcbfef43af
});

});



parcelRegister("bCWR4", function(module, exports) {
$parcel$export(module.exports, "Illustration", () => (parcelRequire("ddmfx")).Illustration);
parcelRequire("ddmfx");

});
parcelRegister("ddmfx", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $929857008c462826$export$d43c2e2ca9b2c105);

var $lY6pw = parcelRequire("lY6pw");

var $7KOyR = parcelRequire("7KOyR");

var $fgMgQ = parcelRequire("fgMgQ");

var $csBxw = parcelRequire("csBxw");

var $aAgjf = parcelRequire("aAgjf");

var $kQ1KK = parcelRequire("kQ1KK");

var $h9qCx = parcelRequire("h9qCx");
const $929857008c462826$export$d43c2e2ca9b2c105 = {
    HandShake: $7KOyR.HandShake,
    HumLogo: $fgMgQ.HumLogo,
    Graphics: $lY6pw.Graphics,
    List: $csBxw.List,
    NoResults: $aAgjf.NoResults,
    VerifyEmail: $h9qCx.VerifyEmail,
    SignedFile: $kQ1KK.SignedFile
};

});
parcelRegister("lY6pw", function(module, exports) {

$parcel$export(module.exports, "Graphics", () => $eed9df8a6226b2f9$export$29d3e417456abdad);

var $ayMG0 = parcelRequire("ayMG0");
const $eed9df8a6226b2f9$export$29d3e417456abdad = ({ className: className })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "152",
        height: "120",
        viewBox: "0 0 152 120",
        fill: "none",
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                filter: "url(#filter0_d_255_3142)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "18",
                        y: "0.321777",
                        width: "130",
                        height: "102",
                        rx: "5",
                        fill: "#4A66F4"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        filter: "url(#filter1_bd_255_3142)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            x: "4",
                            y: "24.3218",
                            width: "103.448",
                            height: "87.3563",
                            rx: "5",
                            fill: "#EBF1FF"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M13.1955 34.0919V101.908H98.2529",
                        stroke: "#AFB5EB",
                        strokeWidth: "3",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M17.7932 82.9425L37.474 70.8736L57.1548 74.8966L73.9413 54.7816L98.2529 42.7126",
                        stroke: "#77F1A1",
                        strokeWidth: "3",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M17.7932 95.5862L39.7893 93.1521H60.6279L82.0452 85.2413L98.2529 86.4584",
                        stroke: "#09168E",
                        strokeWidth: "3",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M17.7932 93.2873L37.0296 81.2625L59.1807 83.3845L79.583 69.9451L99.4023 65.701",
                        stroke: "#2042F6",
                        strokeWidth: "3",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        filter: "url(#filter2_bd_255_3142)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            x: "57",
                            y: "10.3218",
                            width: "80",
                            height: "53",
                            rx: "5",
                            fill: "white",
                            fillOpacity: "0.9",
                            shapeRendering: "crispEdges"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "69",
                        y: "24.3218",
                        width: "51",
                        height: "5",
                        rx: "2.5",
                        fill: "#7E899A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "69",
                        y: "34.3218",
                        width: "56",
                        height: "5",
                        rx: "2.5",
                        fill: "#7E899A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "69",
                        y: "44.3218",
                        width: "38",
                        height: "5",
                        rx: "2.5",
                        fill: "#7E899A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter0_d_255_3142",
                        x: "0",
                        y: "0.321777",
                        width: "152",
                        height: "119.356",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_255_3142"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_255_3142",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter1_bd_255_3142",
                        x: "-6",
                        y: "14.3218",
                        width: "123.448",
                        height: "107.356",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_255_3142"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect1_backgroundBlur_255_3142",
                                result: "effect2_dropShadow_255_3142"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow_255_3142",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter2_bd_255_3142",
                        x: "47",
                        y: "0.321777",
                        width: "100",
                        height: "73",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_255_3142"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect1_backgroundBlur_255_3142",
                                result: "effect2_dropShadow_255_3142"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow_255_3142",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("7KOyR", function(module, exports) {

$parcel$export(module.exports, "HandShake", () => $a41b96c2d28066b2$export$7fc97100406a0f2f);

var $ayMG0 = parcelRequire("ayMG0");
const $a41b96c2d28066b2$export$7fc97100406a0f2f = ({ className: className })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "448",
        height: "171",
        viewBox: "0 0 448 171",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M253.268 152.348C251.527 155.612 248.716 158.21 245.369 159.842C242.055 161.507 238.24 162.207 234.558 161.807C232.516 161.607 230.474 161.008 228.667 160.075C227.797 159.642 227.027 160.941 227.897 161.374C231.512 163.206 235.629 163.772 239.645 163.206C243.562 162.64 247.344 160.941 250.356 158.343C252.063 156.878 253.502 155.079 254.573 153.114C255.042 152.248 253.737 151.482 253.268 152.348Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M262.64 156.378C259.36 161.974 253.938 166.27 247.745 168.302C246.005 168.868 244.231 169.268 242.39 169.468C241.988 169.501 241.654 169.768 241.654 170.201C241.654 170.567 241.988 171 242.39 170.934C249.285 170.167 255.778 166.87 260.431 161.774C261.736 160.342 262.941 158.743 263.912 157.078C264.414 156.312 263.109 155.546 262.64 156.378Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M260.933 138.792C260.933 138.792 260.966 138.792 260.966 138.759C261.033 138.725 261.1 138.659 261.134 138.625C261.201 138.559 261.267 138.492 261.301 138.426C261.334 138.359 261.368 138.259 261.401 138.192C261.401 138.159 261.435 138.126 261.435 138.092C261.435 138.026 261.468 137.893 261.468 137.826C261.468 137.726 261.435 137.626 261.435 137.56C261.401 137.426 261.368 137.326 261.301 137.226C261.167 136.96 260.899 136.76 260.598 136.66C260.498 136.627 260.397 136.627 260.297 136.627C260.263 136.627 260.196 136.627 260.163 136.627C260.063 136.627 259.962 136.66 259.862 136.66C259.761 136.694 259.661 136.727 259.594 136.76C259.46 136.827 259.326 136.927 259.226 137.027C259.192 137.06 259.159 137.093 259.125 137.127C259.058 137.193 258.992 137.293 258.925 137.393C258.858 137.493 258.824 137.56 258.824 137.659C258.791 137.759 258.791 137.859 258.824 137.959C258.858 138.059 258.891 138.126 258.958 138.226C259.025 138.292 259.092 138.359 259.159 138.426C259.326 138.525 259.561 138.559 259.728 138.492C259.929 138.426 260.063 138.326 260.163 138.159C260.196 138.126 260.196 138.092 260.23 138.092C260.196 138.159 260.163 138.192 260.096 138.259C260.129 138.192 260.196 138.126 260.263 138.092C260.196 138.126 260.163 138.159 260.096 138.226C260.163 138.192 260.196 138.159 260.263 138.126C260.196 138.159 260.129 138.192 260.096 138.192C260.163 138.159 260.196 138.159 260.263 138.159C260.196 138.159 260.129 138.192 260.063 138.192C260.129 138.192 260.163 138.192 260.23 138.192C260.163 138.192 260.096 138.159 260.029 138.159C260.063 138.159 260.129 138.192 260.163 138.192C260.096 138.159 260.029 138.126 259.996 138.126C260.029 138.126 260.063 138.159 260.063 138.159C259.996 138.126 259.962 138.092 259.895 138.026C259.929 138.059 259.962 138.092 259.962 138.092C259.929 138.026 259.895 137.993 259.828 137.926C259.862 137.959 259.895 137.993 259.895 138.059C259.862 137.993 259.828 137.926 259.828 137.893C259.862 137.926 259.862 137.993 259.862 138.026C259.862 137.959 259.828 137.893 259.828 137.826C259.828 137.859 259.828 137.926 259.828 137.959C259.828 137.893 259.862 137.826 259.862 137.759C259.862 137.793 259.862 137.826 259.828 137.859C259.862 137.793 259.895 137.726 259.895 137.693C259.895 137.726 259.862 137.759 259.862 137.759C259.895 137.693 259.929 137.659 259.996 137.593C259.996 137.626 259.962 137.626 259.929 137.659C259.996 137.626 260.029 137.593 260.096 137.526C260.096 137.526 260.063 137.56 260.029 137.56C259.929 137.593 259.862 137.659 259.828 137.759C259.761 137.826 259.728 137.926 259.694 138.026C259.661 138.126 259.661 138.226 259.694 138.326C259.694 138.426 259.728 138.525 259.795 138.592C259.895 138.759 260.063 138.892 260.23 138.925C260.297 138.925 260.364 138.958 260.431 138.958C260.698 138.892 260.832 138.859 260.933 138.792Z",
                fill: "#080808"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M453.891 34.8062V78.1057C443.482 80.5038 431.834 82.8021 420.588 85.1669C419.651 85.3667 418.714 85.5666 417.777 85.7664C414.396 86.4659 411.049 87.1986 407.802 87.9314C407.133 88.0646 406.497 88.2311 405.828 88.3644C405.158 88.5309 404.489 88.6642 403.819 88.8307C401.51 89.3636 399.2 89.8632 396.857 90.3628C395.284 90.6959 393.711 91.029 392.105 91.3287C388.055 92.1281 383.971 92.9275 379.888 93.6936C378.649 93.9267 377.411 94.1599 376.173 94.4263C373.729 94.8926 371.286 95.3922 368.842 95.8918C368.14 96.0251 367.437 96.1916 366.734 96.3248C365.997 96.4914 365.228 96.6246 364.491 96.7911C362.516 97.2241 360.575 97.6238 358.634 98.0901C357.831 98.2567 357.061 98.4565 356.257 98.6564C350.3 100.089 344.375 101.721 338.585 103.652C337.882 103.886 337.179 104.119 336.443 104.385C334.769 104.951 333.129 105.584 331.489 106.217C328.644 107.35 325.665 108.982 322.586 110.447C321.983 110.747 321.381 111.013 320.779 111.28C317.164 112.912 313.482 114.111 309.834 113.878C306.654 113.678 305.114 103.952 304.11 100.422C304.043 100.188 303.976 99.9887 303.909 99.8221C302.637 96.1583 301.232 92.5278 299.659 88.9639C298.788 86.9322 297.851 84.9337 296.88 82.9686C294.337 77.7393 290.99 72.7765 289.483 67.1143C287.944 61.4187 303.809 64.9493 306.085 65.1158C315.758 65.8153 325.464 65.1158 335.137 63.5837C336.376 63.3839 337.648 63.184 338.886 62.9509C340.928 62.5845 343.003 62.1848 345.045 61.7518C346.283 61.4853 347.555 61.2189 348.793 60.9191C357.563 58.954 366.299 56.5559 374.968 54.1577C376.106 53.858 377.244 53.5249 378.382 53.2251C382.063 52.2259 385.745 51.1934 389.393 50.2608C390.699 49.9277 392.038 49.5946 393.343 49.2615C393.812 49.1283 394.28 49.0284 394.749 48.9285L406.798 46.064L409.777 45.3646L450.745 35.6388L452.72 35.1725L453.891 34.8062Z",
                fill: "#35BC82"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M453.891 34.8062V78.1057C443.482 80.5038 431.834 82.8021 420.588 85.1669C419.651 85.3667 418.714 85.5666 417.777 85.7664C414.396 86.4659 411.049 87.1986 407.802 87.9314C407.133 88.0646 406.497 88.2311 405.828 88.3644C405.158 88.5309 404.489 88.6642 403.819 88.8307C401.51 89.3636 399.2 89.8632 396.857 90.3628C395.284 90.6959 393.711 91.029 392.105 91.3287C388.055 92.1281 383.971 92.9275 379.888 93.6936C378.649 93.9267 377.411 94.1599 376.173 94.4263C373.729 94.8926 371.286 95.3922 368.842 95.8918C368.14 96.0251 367.437 96.1916 366.734 96.3248C365.997 96.4914 365.228 96.6246 364.491 96.7911C362.516 97.2241 360.575 97.6238 358.634 98.0901C357.831 98.2567 357.061 98.4565 356.257 98.6564C350.3 100.089 344.375 101.721 338.585 103.652C337.882 103.886 337.179 104.119 336.443 104.385C334.769 104.951 333.129 105.584 331.489 106.217C328.644 107.35 325.665 108.982 322.586 110.447C321.983 110.747 321.381 111.013 320.779 111.28C317.164 112.912 313.482 114.111 309.834 113.878C306.654 113.678 305.114 103.952 304.11 100.422C304.043 100.188 303.976 99.9887 303.909 99.8221C302.637 96.1583 301.232 92.5278 299.659 88.9639C298.788 86.9322 297.851 84.9337 296.88 82.9686C294.337 77.7393 290.99 72.7765 289.483 67.1143C287.944 61.4187 303.809 64.9493 306.085 65.1158C315.758 65.8153 325.464 65.1158 335.137 63.5837C336.376 63.3839 337.648 63.184 338.886 62.9509C340.928 62.5845 343.003 62.1848 345.045 61.7518C346.283 61.4853 347.555 61.2189 348.793 60.9191C357.563 58.954 366.299 56.5559 374.968 54.1577C376.106 53.858 377.244 53.5249 378.382 53.2251C382.063 52.2259 385.745 51.1934 389.393 50.2608C390.699 49.9277 392.038 49.5946 393.343 49.2615C393.812 49.1283 394.28 49.0284 394.749 48.9285L406.798 46.064L409.777 45.3646L450.745 35.6388L452.72 35.1725L453.891 34.8062Z",
                fill: "url(#paint0_linear)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M453.891 34.8062V78.1057C443.482 80.5038 431.834 82.8021 420.588 85.1669C419.651 85.3667 418.714 85.5666 417.777 85.7664C414.396 86.4659 411.049 87.1986 407.802 87.9314C407.133 88.0646 406.497 88.2311 405.828 88.3644C405.158 88.5309 404.489 88.6642 403.819 88.8307C401.51 89.3636 399.2 89.8632 396.857 90.3628C395.284 90.6959 393.711 91.029 392.105 91.3287C388.055 92.1281 383.971 92.9275 379.888 93.6936C378.649 93.9267 377.411 94.1599 376.173 94.4263C373.729 94.8926 371.286 95.3922 368.842 95.8918C368.14 96.0251 367.437 96.1916 366.734 96.3248C365.997 96.4914 365.228 96.6246 364.491 96.7911C362.516 97.2241 360.575 97.6238 358.634 98.0901C357.831 98.2567 357.061 98.4565 356.257 98.6564C350.3 100.089 344.375 101.721 338.585 103.652C337.882 103.886 337.179 104.119 336.443 104.385C334.769 104.951 333.129 105.584 331.489 106.217C328.644 107.35 325.665 108.982 322.586 110.447C321.983 110.747 321.381 111.013 320.779 111.28C317.164 112.912 313.482 114.111 309.834 113.878C306.654 113.678 305.114 103.952 304.11 100.422C304.043 100.188 303.976 99.9887 303.909 99.8221C302.637 96.1583 301.232 92.5278 299.659 88.9639C298.788 86.9322 297.851 84.9337 296.88 82.9686C294.337 77.7393 290.99 72.7765 289.483 67.1143C287.944 61.4187 303.809 64.9493 306.085 65.1158C315.758 65.8153 325.464 65.1158 335.137 63.5837C336.376 63.3839 337.648 63.184 338.886 62.9509C340.928 62.5845 343.003 62.1848 345.045 61.7518C346.283 61.4853 347.555 61.2189 348.793 60.9191C357.563 58.954 366.299 56.5559 374.968 54.1577C376.106 53.858 377.244 53.5249 378.382 53.2251C382.063 52.2259 385.745 51.1934 389.393 50.2608C390.699 49.9277 392.038 49.5946 393.343 49.2615C393.812 49.1283 394.28 49.0284 394.749 48.9285L406.798 46.064L409.777 45.3646L450.745 35.6388L452.72 35.1725L453.891 34.8062Z",
                fill: "url(#pattern0)",
                fillOpacity: "0.4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M259.36 91.0956C255.142 94.9592 249.452 96.991 243.762 97.1908C238.106 97.3907 232.215 95.7586 227.763 92.1947C225.588 90.4294 223.044 87.4318 223.981 84.4008C224.149 83.8346 224.517 83.0352 225.186 82.902C225.722 82.802 226.291 83.1018 226.659 83.5015C227.83 84.7006 227.094 86.699 226.558 88.0313C224.182 93.4937 219.597 97.6904 214.208 100.122C211.53 101.321 208.585 102.187 205.639 102.453C205.003 102.52 204.401 102.487 204.334 101.721C204.3 100.988 204.836 100.255 205.204 99.6556C206.175 98.19 207.212 96.7578 208.116 95.259C209.957 92.1947 211.463 88.9639 212.735 85.6332C213.672 83.1351 214.543 80.6038 215.948 78.3389C216.618 77.2397 217.454 76.2405 218.459 75.4411C219.563 74.5418 220.868 73.9756 222.274 73.6092C225.822 72.61 229.604 72.7432 233.219 73.3428C236.968 73.9756 240.616 75.0414 244.231 76.2405C247.879 77.4396 251.427 78.9051 254.875 80.5371C257.987 82.0027 261.268 83.2683 264.648 83.9678C268.163 84.6673 271.744 84.7672 275.292 84.3675C279.141 83.9345 282.923 82.9686 286.505 81.4364C288.647 80.5371 290.789 79.4713 292.563 77.9392C292.83 77.706 293.132 77.4396 293.199 77.0732C293.366 76.4736 292.864 76.0073 292.295 76.0073C291.324 75.974 291.324 77.4729 292.295 77.5062C292.228 77.5062 292.128 77.4063 291.96 77.1731C291.759 76.9066 291.659 76.9066 291.759 76.6402C291.759 76.6069 291.893 76.4736 291.793 76.5736C291.659 76.7068 291.525 76.84 291.391 76.9399C291.09 77.2064 290.688 77.4729 290.287 77.7393C289.383 78.3389 288.446 78.8718 287.475 79.3381C283.894 81.0701 279.978 82.2025 276.028 82.7354C272.38 83.235 268.665 83.2017 265.05 82.469C261.468 81.7362 258.155 80.3706 254.875 78.8385C251.226 77.1398 247.478 75.6743 243.662 74.4419C239.98 73.2428 236.198 72.177 232.315 71.6441C228.5 71.1112 224.483 71.1445 220.835 72.4101C218.057 73.3761 215.948 75.3412 214.476 77.8392C213.003 80.304 212.099 83.0352 211.095 85.6998C209.756 89.1637 208.083 92.4945 206.108 95.6254C205.606 96.3914 205.104 97.1575 204.568 97.8903C204.066 98.623 203.531 99.3225 203.162 100.155C202.828 100.921 202.66 101.754 202.962 102.553C203.296 103.419 204.1 103.886 205.003 103.919C205.807 103.952 206.677 103.786 207.48 103.652C208.25 103.519 209.02 103.353 209.756 103.186C211.296 102.82 212.769 102.287 214.208 101.687C219.898 99.2892 224.885 94.9925 227.563 89.3636C228.332 87.7315 229.136 85.7997 228.6 83.9678C228.199 82.5356 226.726 81.3032 225.186 81.4031C223.345 81.5364 222.475 83.4682 222.308 85.0669C222.14 86.6657 222.676 88.2978 223.513 89.6634C225.153 92.4279 227.931 94.4263 230.742 95.8585C233.453 97.2241 236.399 98.0901 239.411 98.4565C245.403 99.2226 251.728 97.9569 256.849 94.7594C258.088 93.9933 259.293 93.094 260.364 92.0948C261.167 91.5286 260.096 90.4627 259.36 91.0956Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M127.82 109.748C130.297 110.58 132.773 111.413 135.284 112.212C139.802 104.585 142.38 96.1583 145.225 87.7982C148.337 78.6386 151.216 69.3792 153.994 60.0864C151.785 59.5868 149.208 60.1864 146.999 59.9532C144.154 59.6201 144.154 59.9532 144.154 59.9532L125.745 108.249L127.82 109.748Z",
                fill: "#FF5600"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M201.522 46.9968C196.703 47.7296 192.117 49.9612 188.536 53.2586C187.498 54.1912 186.561 55.2571 185.724 56.3562C185.49 56.6893 185.657 57.1889 185.992 57.3887C186.394 57.6219 186.762 57.4553 187.03 57.1223C189.808 53.4918 193.757 50.7939 198.108 49.3617C199.347 48.962 200.652 48.6622 201.924 48.4624C202.326 48.3958 202.56 47.8961 202.46 47.5298C202.326 47.0968 201.924 46.9302 201.522 46.9968Z",
                fill: "#FCFCFC"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M220.099 50.727C216.952 49.861 213.572 49.8943 210.392 50.5271C207.145 51.16 203.966 52.5256 201.422 54.6572C200.016 55.7897 198.845 57.2219 197.974 58.7873C197.506 59.62 198.811 60.3861 199.28 59.5534C202.225 54.1576 208.852 51.6263 214.777 51.5929C216.45 51.5929 218.09 51.7595 219.697 52.1925C220.634 52.4256 221.036 50.9934 220.099 50.727Z",
                fill: "#FCFCFC"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M338.15 103.253C340.727 100.588 339.957 95.2258 343.606 93.3606C345.313 92.4946 347.421 92.9276 349.128 93.7936C350.835 94.6596 352.308 95.9253 354.015 96.758C357.964 98.7231 363.018 98.2568 366.533 95.5589C367.102 96.225 368.307 95.9586 368.842 95.2591C369.88 93.8935 369.646 91.4954 370.282 89.9299C371.52 86.899 372.256 83.5682 371.52 80.404C370.784 77.2398 368.34 74.3088 365.094 73.7759C362.449 73.3429 359.638 74.7085 358.266 76.9734C356.893 79.2716 357.061 82.3359 358.634 84.5008C359.772 86.0663 368.34 90.6627 366.265 92.9276C363.922 95.459 360.24 96.8246 356.86 95.7254C353.279 94.5597 350.634 91.562 346.785 90.9958C345.045 90.7293 343.237 90.9625 341.798 92.0283C340.225 93.1941 339.422 95.0593 338.652 96.8246C337.648 99.1894 336.61 101.787 336.543 104.352C337.213 104.052 337.715 103.686 338.15 103.253Z",
                fill: "#2CA870"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M419.35 65.7155C416.907 62.9177 413.091 61.4188 409.409 62.2515C405.828 63.0842 403.585 66.2151 402.815 69.6458C401.979 73.3429 402.614 77.2065 403.552 80.8037C404.221 83.3351 405.058 85.8331 405.828 88.3312C406.464 88.1979 407.133 88.0314 407.802 87.8982C407.702 87.6317 407.635 87.3319 407.535 87.0655C406.33 83.2351 404.957 79.4048 404.556 75.4079C404.221 72.3103 404.455 68.6132 406.631 66.1485C409.041 63.4506 413.091 63.4839 415.969 65.4157C418.915 67.3808 420.555 70.978 420.923 74.4087C421.325 78.0392 420.454 81.8029 418.413 84.8672C418.212 85.167 418.011 85.4667 417.777 85.7665C418.714 85.5667 419.651 85.3668 420.588 85.167C424.103 79.205 423.969 71.0113 419.35 65.7155ZM403.853 88.7975C404.522 88.6309 405.192 88.4977 405.861 88.3312L396.858 90.3296C399.2 89.83 401.543 89.3304 403.853 88.7975ZM387.687 88.8641C384.038 88.9307 380.725 90.2963 377.947 92.6611C377.311 93.194 376.708 93.7936 376.173 94.3931C377.411 94.16 378.649 93.8935 379.888 93.6603C382.063 91.995 384.607 90.9291 387.452 90.8625C389.025 90.8292 390.565 90.9958 392.105 91.2955C393.678 90.9625 395.284 90.6627 396.858 90.3296C393.845 89.5635 390.799 88.8308 387.687 88.8641Z",
                fill: "#2CA870"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M335.104 63.5506C334.2 64.4832 333.397 65.5157 332.56 66.5149C330.552 68.9797 328.41 71.6442 325.163 72.4769C321.582 73.4095 317.8 72.2771 314.252 71.8108C310.536 71.3112 306.721 71.3445 303.675 73.8092C300.428 76.4072 299.257 80.7705 299.29 84.7673C299.29 86.1663 299.458 87.5652 299.658 88.9641L304.077 100.455C304.411 100.755 304.746 101.021 305.148 101.254C305.583 101.521 306.319 101.388 306.52 100.888C307.624 98.3901 310.972 98.057 313.248 99.1561C316.394 100.655 317.9 104.385 319.138 107.416C319.674 108.715 320.209 110.014 320.745 111.347L322.552 110.514C322.352 110.014 322.151 109.515 321.95 109.015C321.18 107.117 320.444 105.185 319.507 103.353C318 100.355 315.657 97.3575 312.143 96.758C309.7 96.325 306.855 96.9245 305.348 98.9563C303.039 96.9578 302.47 93.4606 301.934 90.5961C301.198 86.5326 300.696 82.0361 302.704 78.2391C303.541 76.6737 304.713 75.3414 306.319 74.542C307.792 73.7759 309.465 73.5761 311.072 73.6094C314.553 73.676 317.9 74.7085 321.381 74.8751C324.828 75.0416 327.941 74.109 330.518 71.8441C332.828 69.779 334.501 67.1477 336.644 64.9162C337.313 64.2167 338.049 63.5506 338.853 63.0176L345.011 61.8186C345.078 61.8186 345.112 61.8519 345.179 61.8519C349.229 62.7512 352.442 65.6156 355.588 68.1803C357.161 69.446 358.868 70.5451 360.977 70.5784C363.018 70.645 364.993 69.779 366.633 68.6133C369.746 66.3817 371.754 63.0843 373.696 59.8867C375.068 57.6218 376.474 55.2237 378.348 53.3252C377.21 53.625 376.072 53.958 374.934 54.2578C373.528 56.123 372.39 58.1881 371.185 60.1532C369.177 63.4506 366.667 67.2477 362.751 68.3801C360.542 69.013 358.701 68.1803 356.994 66.7814C355.287 65.3825 353.613 63.9502 351.772 62.7512C350.835 62.1183 349.798 61.5521 348.76 61.0525L335.104 63.5506Z",
                fill: "#2CA870"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M409.743 45.2981C409.743 45.2981 409.743 45.3314 409.71 45.3314C407.936 48.0959 405.493 50.494 402.346 51.5599C398.598 52.8589 394.782 51.6931 391.1 50.6939C390.498 50.5273 389.929 50.3941 389.326 50.2276C390.632 49.8945 391.971 49.5614 393.276 49.2284C395.92 49.9611 398.631 50.5607 401.342 49.7946C403.518 49.1617 405.325 47.7295 406.765 46.0309L409.743 45.2981Z",
                fill: "#2CA870"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M452.686 35.0728C453.122 36.0054 453.523 36.9713 453.891 37.9372C454.561 39.6359 455.096 41.3678 455.464 43.1331C456.134 46.3306 456.201 49.6281 455.331 52.7923C454.996 54.0246 454.494 55.2237 453.891 56.3561C453.188 57.6551 452.352 58.8542 451.415 59.9867C449.674 62.085 447.532 63.8836 445.222 65.3491C442.712 66.9812 439.834 68.48 436.855 68.913C433.976 69.346 430.863 68.6799 428.889 66.415C427.952 65.3824 427.316 64.0501 427.316 62.6512C427.282 61.2856 427.885 59.9867 428.788 58.9874C429.659 58.0215 430.93 57.3554 432.269 57.3221C433.675 57.2888 435.181 58.0881 435.784 59.3538C436.52 60.8526 435.884 62.5846 434.913 63.817C434.077 64.8828 432.805 65.6489 431.466 65.882C431.432 65.882 431.399 65.882 431.365 65.882C430.863 65.9487 430.395 65.6822 430.228 65.1826C430.194 65.0827 430.194 64.9494 430.194 64.8162C429.759 64.2833 429.458 63.6505 429.357 62.951C429.223 62.1516 429.525 61.1524 430.094 60.453C430.462 60.02 430.763 59.7868 431.232 59.5203C431.6 59.3205 431.968 59.2206 432.437 59.2539C432.805 59.2539 433.273 59.4204 433.608 59.7202C433.976 60.02 434.177 60.3863 434.11 60.8859C434.01 61.9185 433.24 62.8511 432.403 63.384C431.935 63.6838 431.499 63.8503 430.93 63.9502C430.529 64.0168 430.261 64.4165 430.194 64.8162C430.529 65.2159 430.897 65.5823 431.365 65.882C432.102 66.3817 432.939 66.7147 433.809 66.9146C434.344 67.0145 435.081 67.0478 435.717 67.0145C436.386 66.9812 437.089 66.848 437.725 66.6481C439.131 66.2817 440.436 65.6822 441.708 65.0161C445.959 62.8178 449.841 59.6203 452.117 55.3569C453.088 53.5583 453.691 51.5932 453.891 49.5615C453.958 49.0951 453.958 48.5955 453.992 48.0959C453.992 47.3632 453.958 46.6304 453.891 45.8976C453.691 43.7327 453.155 41.6343 452.419 39.6026C451.917 38.2036 451.348 36.838 450.712 35.4724L452.686 35.0728Z",
                fill: "#2CA870"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M-3.4856 78.9386L105.461 107.916C112.557 109.382 119.586 111.18 126.481 113.312L144.622 64.683L147.233 57.6885C142.915 57.7218 138.631 57.6552 134.313 57.4886C124.004 57.1223 113.729 56.1563 103.52 54.6908L-3.4856 30.3098",
                fill: "url(#paint1_linear)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M-3.4856 78.9386L105.461 107.916C112.557 109.382 119.586 111.18 126.481 113.312L144.622 64.683L147.233 57.6885C142.915 57.7218 138.631 57.6552 134.313 57.4886C124.004 57.1223 113.729 56.1563 103.52 54.6908L-3.4856 30.3098",
                fill: "url(#pattern1)",
                fillOpacity: "0.4",
                style: {
                    mixBlendMode: "overlay"
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("mask", {
                id: "mask0",
                "mask-type": "alpha",
                maskUnits: "userSpaceOnUse",
                x: "-4",
                y: "30",
                width: "152",
                height: "84",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M-3.4856 78.9386L105.461 107.916C112.557 109.382 119.586 111.18 126.481 113.312L144.622 64.683L147.233 57.6885C142.915 57.7218 138.631 57.6552 134.313 57.4886C124.004 57.1223 113.729 56.1563 103.52 54.6908L-3.4856 30.3098",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                mask: "url(#mask0)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M58.9036 53.8249C62.1168 55.8566 66.8027 54.924 70.4175 54.7908C74.9026 54.6575 79.3542 54.491 83.8393 54.3578C84.2744 52.8589 84.7095 51.3268 85.1446 49.828C80.2579 51.7598 75.0699 53.3919 70.384 55.7567C66.6353 57.6552 63.2213 61.3523 63.8907 65.8155C64.4597 69.7791 68.2754 72.4104 71.8233 73.676C75.6389 75.0083 80.2914 75.7078 82.6008 79.4049C83.2703 78.0393 83.9062 76.6404 84.5756 75.2748C82.0318 76.0409 79.4881 76.8069 76.9443 77.573C74.7352 78.2391 72.4592 78.7721 70.3506 79.738C66.468 81.5366 64.1585 85.5668 64.8614 89.8301C66.4345 99.3893 78.8856 98.7898 83.1364 106.184C83.9397 104.785 84.743 103.386 85.5463 102.021C79.7558 101.688 73.6976 102.853 70.7187 108.349C69.5138 110.581 69.0452 113.212 70.1163 115.577C71.0869 117.708 73.0952 119.307 75.5051 119.207C76.6765 119.141 77.5802 118.108 77.9484 117.076C78.1827 116.443 78.417 114.577 77.2121 114.644C74.5679 114.777 71.8902 111.646 73.6642 109.215C75.8063 106.251 80.5257 106.384 83.7723 106.55C85.5463 106.65 87.019 103.819 86.1822 102.387C84.4083 99.3227 81.3624 97.4575 78.2831 95.9587C75.1704 94.4265 71.4886 92.9943 69.4803 89.9967C68.7105 88.8309 67.9742 87.0989 68.3089 85.6667C68.6436 84.3677 70.3171 83.8348 71.4886 83.4351C75.5051 82.1028 79.6219 80.9704 83.6719 79.738C85.1111 79.305 86.5504 77.0401 85.6467 75.6079C81.7641 69.4127 72.7605 71.1447 68.4762 65.549C67.7399 64.6164 66.97 63.1842 67.606 61.9852C68.2754 60.7528 70.0828 60.02 71.2877 59.4538C75.5051 57.522 79.9567 55.9898 84.2744 54.2912C85.3454 53.8915 86.0818 52.9922 86.383 51.893C86.5504 51.2602 86.6508 49.728 85.5797 49.7613C81.329 49.8946 77.0782 50.0278 72.8274 50.1943C70.7522 50.261 68.677 50.3276 66.6019 50.3942C64.7944 50.4275 63.0205 50.4941 61.4474 49.4949C59.7069 48.4291 57.1631 52.7257 58.9036 53.8249Z",
                        fill: "#806920"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M-0.607119 41.9341C-1.879 42.2339 -2.9166 41.8675 -3.88725 41.0348C-4.59013 42.5337 -5.29302 43.9992 -5.9959 45.498C1.86971 45.1983 9.80227 46.1975 17.2997 48.5956C17.8687 47.1301 18.4042 45.6646 18.9732 44.199C14.0865 45.8644 9.26673 47.8961 4.74819 50.4608C1.09989 52.5259 -2.9166 55.9565 -2.88313 60.5196C-2.84965 65.2826 1.80277 67.2477 5.48455 68.9797C10.6725 71.4111 15.8605 73.8093 21.0484 76.2407C21.6174 74.7752 22.153 73.3097 22.722 71.8441C17.9691 72.6102 13.2163 73.4096 8.46344 74.1757C4.78166 74.7752 1.06642 75.8743 -0.372824 79.7047C-1.97942 83.9014 1.23377 87.1655 4.01184 89.8301C7.32543 93.0609 10.8399 96.0253 14.5886 98.7565C15.1576 97.291 15.6931 95.8254 16.2621 94.3599C12.2122 95.2592 8.1622 96.4916 4.44696 98.3235C1.36765 99.8223 -1.64471 102.387 -2.48148 105.851C-3.35171 109.581 -0.807943 111.946 1.80277 114.178C5.01596 116.942 8.53038 119.307 12.2791 121.272C14.12 122.238 16.5968 117.875 14.7894 116.942C11.9779 115.477 9.33368 113.811 6.82337 111.913C5.51802 110.914 4.2796 109.881 3.07466 108.749C2.27136 107.983 0.932533 106.85 0.966003 105.651C0.966003 103.686 4.61431 102.387 6.05355 101.787C9.06591 100.522 12.2122 99.5892 15.4253 98.8897C16.8981 98.5566 18.6385 95.5923 17.0989 94.4932C14.1535 92.3615 11.3419 90.0633 8.69773 87.5985C7.45932 86.4328 6.2209 85.267 5.04943 84.0346C4.41348 83.3685 2.3383 81.1702 2.84036 80.0711C3.04119 79.6381 4.98249 79.2384 5.58496 79.1051C7.19155 78.7721 8.86509 78.5389 10.5051 78.2725C14.3208 77.6396 18.103 77.0401 21.9187 76.4072C23.224 76.2074 25.3327 72.8101 23.5922 72.0107C19.4084 70.0455 15.2245 68.1137 11.0072 66.1486C9.06591 65.2493 7.05767 64.3833 5.14984 63.3841C3.7106 62.6513 2.10401 61.752 1.23377 60.3198C-0.640589 57.2222 3.97836 55.1238 6.15396 53.9581C10.0031 51.893 13.9861 50.1944 18.1365 48.7954C19.0736 48.4624 19.81 47.6297 20.1447 46.6971C20.3455 46.1309 20.6468 44.632 19.81 44.3989C12.0113 41.9341 3.91142 40.7684 -4.28889 41.0681C-6.02937 41.1348 -8.00414 44.199 -6.39755 45.5313C-4.95831 46.6971 -3.21783 46.9968 -1.44389 46.5972C0.363532 46.0309 1.86971 41.3679 -0.607119 41.9341Z",
                        fill: "#806920"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M20.7136 116.209C29.9515 117.908 39.3568 118.341 48.7286 118.708C49.1637 117.209 49.5988 115.677 50.0339 114.178C46.2518 115.21 42.3692 116.376 39.089 118.608C35.9428 120.773 31.8594 125.103 33.6333 129.233C36.4783 135.827 46.0509 134.628 49.7662 140.357C50.5695 138.958 51.3728 137.559 52.1761 136.194C48.4608 135.994 44.7456 136.294 41.1307 137.193C38.1184 137.926 34.3697 138.925 32.3614 141.49C30.4536 143.921 30.5875 146.985 33.1313 148.851C34.537 149.883 36.2775 150.416 37.8506 151.116C39.7919 151.948 41.6997 152.748 43.641 153.58C45.5823 154.413 47.9922 150.05 46.1514 149.25C43.5072 148.118 40.863 147.019 38.2523 145.886C37.3151 145.487 36.2775 145.087 35.4742 144.421C35.3738 144.354 34.5036 143.322 34.6374 143.288C34.5705 143.521 34.4701 143.721 34.4031 143.954C34.604 143.788 34.8383 143.655 35.0726 143.555C39.5911 141.123 45.4819 140.524 50.5025 140.824C52.2095 140.924 53.8496 138.059 52.9124 136.66C49.7997 131.897 43.641 131.631 39.2899 128.533C38.3527 127.867 36.5453 126.402 36.9804 125.136C37.382 124.003 38.9886 122.904 39.9593 122.305C42.7708 120.539 46.0175 119.64 49.1637 118.774C50.4691 118.408 52.7785 114.344 50.4691 114.244C41.0973 113.845 31.692 113.412 22.4541 111.746C20.5463 111.28 18.4711 115.81 20.7136 116.209Z",
                        fill: "#FF5600"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M28.0438 35.6723C35.9094 37.7374 43.8419 39.536 51.8414 41.0015C51.9753 39.6692 52.0757 38.3036 52.2096 36.9713C48.896 40.3354 44.0093 40.9016 39.9259 42.9C36.0433 44.7986 32.2945 48.3291 31.5582 52.7257C30.7884 57.3221 33.9681 61.0525 37.5829 63.4507C41.432 66.0153 46.051 67.2477 50.5026 68.4135C50.9377 66.9146 51.3728 65.3825 51.8079 63.8837C47.691 64.3833 43.708 65.549 39.9928 67.4143C36.6123 69.1129 32.1272 71.5777 31.9264 75.841C31.759 79.8379 36.1102 82.5025 38.9552 84.5342C42.4696 87.0656 46.2518 89.164 50.2348 90.896C50.8038 89.4304 51.3393 87.9649 51.9083 86.4994C46.6869 88.3313 40.6287 87.0323 36.1437 90.8626C32.8301 93.6938 30.9892 99.7224 34.9387 102.787C36.4784 103.986 39.1226 99.7557 37.449 98.4567C36.5118 97.724 36.0433 96.3917 36.4784 95.2592C36.947 93.9602 38.654 93.3274 39.8589 92.961C43.5072 91.8619 47.4568 92.2282 51.0716 90.9626C52.1761 90.5962 54.6529 87.3987 52.7451 86.566C49.6658 85.2337 46.7204 83.6683 43.9089 81.8363C41.2982 80.171 38.018 78.2392 36.2106 75.6745C36.0098 75.408 35.4408 74.5087 35.5077 74.3422C35.6081 73.9425 36.7796 73.3763 37.1143 73.1764C38.4531 72.3104 39.8924 71.5777 41.3651 70.9115C44.4109 69.5459 47.6576 68.7466 50.9712 68.3802C52.5778 68.1803 54.3852 64.4166 52.2765 63.8504C48.5613 62.8845 44.7791 61.8519 41.432 59.9534C38.7878 58.4546 34.2358 55.0905 35.2065 51.4933C36.0433 48.2958 40.3944 46.7637 43.139 45.7978C46.7873 44.4988 50.5026 43.2331 53.2472 40.4353C54.017 39.6359 55.6236 36.7715 53.6154 36.4051C45.6159 34.9396 37.6833 33.141 29.8177 31.0759C27.9434 30.6429 25.8012 35.1061 28.0438 35.6723Z",
                        fill: "#806920"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M88.1237 90.6295C98.8343 86.566 109.612 81.9362 121.059 80.4041C122.599 80.2043 124.506 75.9076 122.364 75.8743C118.046 75.8077 113.762 75.2415 109.578 74.1756C107.771 73.7093 105.997 73.1764 104.424 72.2105C103.587 71.7109 101.177 70.0788 101.545 68.7798C101.813 67.8805 104.257 67.0812 105.026 66.6815C107.001 65.7156 108.942 64.7496 110.917 63.7837C115.034 61.752 119.151 59.7202 123.301 57.6885C124.272 57.2222 125.209 55.7234 125.075 54.6242C124.808 52.6258 123.603 51.6599 121.695 51.2269C119.251 50.6606 116.574 50.6939 114.063 50.4608C109.445 50.0278 104.558 49.1618 101.11 45.7645C97.8637 42.5669 97.529 38.3702 100.307 34.773C103.353 30.8428 108.039 28.5112 111.553 25.0806C112.323 24.3478 113.494 22.5492 112.624 21.4501C110.08 18.2526 105.294 18.6523 102.817 15.4215C99.9054 11.6577 101.311 6.99469 104.056 3.59734C104.658 2.83127 105.395 1.33244 104.692 0.399837C103.989 -0.53277 102.717 0.333222 102.215 0.999369C98.7674 5.29602 96.1566 11.3246 98.3657 16.7537C99.3029 19.0187 100.843 20.8172 103.119 21.8831C105.294 22.8823 107.972 23.282 109.545 25.2138C109.913 24.0148 110.248 22.7824 110.616 21.5833C106.733 25.347 101.78 27.9117 98.4327 32.1751C95.3868 36.072 93.4121 41.3679 95.5877 46.1308C97.462 50.2943 101.612 52.8256 105.897 53.9914C108.708 54.7574 111.587 54.9906 114.465 55.2237C115.302 55.2904 121.226 55.2237 121.427 56.656C122.03 55.6234 122.599 54.6242 123.201 53.5917C118.18 56.0564 113.193 58.5212 108.173 61.0192C104.19 62.9844 98.7004 64.8163 97.9641 69.8457C97.3616 73.9758 101.244 76.6737 104.692 77.8394C109.813 79.5714 115.201 80.3708 120.59 80.4707C121.025 78.9719 121.461 77.4398 121.896 75.9409C110.449 77.4731 99.6711 82.1028 88.9605 86.1663C87.8225 86.5993 86.9857 87.6651 86.7849 88.8642C86.651 89.6302 86.9857 91.0958 88.1237 90.6295Z",
                        fill: "#806920"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M121.025 98.4565C120.289 97.8902 119.385 97.5905 118.415 97.757C117.611 97.8902 116.909 98.3565 116.407 98.9561C115.67 99.8221 115.269 101.054 115.235 102.187C115.202 102.986 115.436 103.852 115.971 104.452C116.842 105.451 118.314 105.618 119.62 105.518C120.825 105.418 122.163 105.051 122.799 103.985C123.201 103.286 123.235 102.387 123.034 101.587C122.766 100.455 122.03 99.2225 121.025 98.4565Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M110.181 96.5914C109.378 96.1917 108.44 96.0918 107.604 96.3916C106.533 96.758 105.696 97.8238 105.629 98.9562C105.562 99.9554 106.131 100.888 107.102 101.221C108.173 101.587 109.511 101.288 110.482 100.722C111.051 100.388 111.553 99.9221 111.721 99.2893C112.022 98.1569 111.152 97.091 110.181 96.5914Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M139.334 105.384C148.304 103.752 157.642 104.119 166.479 106.35C168.989 106.983 171.466 107.783 173.876 108.715C174.344 108.882 174.813 108.449 174.813 107.982C174.813 107.017 174.813 106.051 174.846 105.118C174.344 105.118 173.842 105.118 173.34 105.118C173.307 107.383 173.842 109.481 174.712 111.58C175.783 114.144 177.089 116.609 178.461 119.04C181.139 123.77 184.318 128.233 188.101 132.164C191.883 136.094 196.334 139.491 201.288 141.889C203.665 143.055 206.175 144.021 208.786 144.687C210.995 145.253 213.739 145.553 215.614 143.954C217.187 142.622 217.756 139.824 215.915 138.459C213.438 136.66 211.262 134.528 209.12 132.33C208.752 132.697 208.417 133.03 208.049 133.396C209.857 135.028 211.697 136.66 213.505 138.292C214.241 138.958 214.978 139.691 215.814 140.224C218.157 141.756 220.902 142.955 223.713 143.088C226.257 143.222 228.968 142.156 230.006 139.691C230.341 138.892 230.709 137.493 229.939 136.893C229.772 136.76 229.604 136.66 229.437 136.527C227.295 134.928 225.119 133.329 222.977 131.731C221.069 130.298 219.161 128.899 217.254 127.467C216.986 127.9 216.752 128.333 216.484 128.766C220.433 131.531 224.316 134.395 228.366 136.993C230.307 138.259 232.349 139.258 234.558 139.991C236.734 140.69 239.077 141.356 241.386 141.29C243.294 141.257 245.302 140.657 246.708 139.291C247.913 138.092 248.281 136.26 247.712 134.662C247.109 132.93 245.269 131.764 243.662 131.031C241.888 130.232 239.98 129.765 238.24 128.899C233.822 126.668 231.412 122.371 228.734 118.441C228.734 118.707 228.734 118.941 228.734 119.207C228.768 119.14 228.834 119.04 228.868 118.974C228.667 119.107 228.433 119.207 228.232 119.34C232.081 119.54 235.863 120.639 239.244 122.504C240.884 123.404 242.424 124.503 243.829 125.735C245.168 126.934 246.306 128.3 247.411 129.699C248.448 130.998 249.553 132.297 251.026 133.13C252.398 133.896 254.038 134.162 255.611 133.962C257.05 133.796 258.389 133.13 258.992 131.764C259.694 130.132 259.293 128.067 258.757 126.435C257.519 122.738 254.841 119.673 252.364 116.742C249.62 113.445 246.607 110.347 244.164 106.783C242.357 104.152 240.549 100.955 237.369 99.8221C236.198 99.4225 235.027 99.0894 233.855 98.723C230.106 97.5572 226.324 96.3915 222.575 95.2257C222.509 95.1924 222.408 95.1591 222.341 95.1591C221.404 94.8593 221.002 96.3249 221.94 96.5913C225.119 97.5572 228.265 98.5565 231.445 99.5224C233.119 100.022 234.759 100.555 236.432 101.055C238.508 101.687 239.98 103.253 241.219 104.985C242.189 106.35 243.06 107.783 244.097 109.115C245.436 110.847 246.842 112.479 248.247 114.144C250.825 117.142 253.569 120.106 255.678 123.47C256.649 125.036 257.485 126.701 257.787 128.533C258.021 129.865 258.021 131.597 256.548 132.197C255.343 132.697 253.703 132.563 252.532 132.13C251.026 131.564 249.921 130.298 248.917 129.099C247.846 127.8 246.875 126.501 245.67 125.336C244.365 124.037 242.892 122.904 241.319 121.938C238.206 119.973 234.658 118.641 231.01 118.108C230.106 117.975 229.169 117.875 228.265 117.841C227.998 117.841 227.763 118.008 227.63 118.208C227.596 118.274 227.529 118.374 227.496 118.441C227.362 118.641 227.362 118.974 227.496 119.207C229.772 122.504 231.813 126.102 235.027 128.6C236.533 129.765 238.173 130.565 239.947 131.198C241.62 131.797 243.327 132.297 244.767 133.329C245.402 133.762 246.072 134.362 246.34 135.095C246.574 135.794 246.607 136.627 246.34 137.326C245.737 138.825 243.729 139.558 242.256 139.724C240.081 139.958 237.838 139.358 235.763 138.725C233.688 138.092 231.78 137.26 229.939 136.127C227.797 134.828 225.789 133.329 223.713 131.897C221.571 130.398 219.429 128.933 217.321 127.434C216.517 126.868 215.814 128.167 216.551 128.733C220.266 131.497 223.948 134.229 227.663 136.993C228.199 137.393 228.734 137.793 229.236 138.159C229.102 137.959 229.002 137.726 228.868 137.526C229.203 140.057 226.592 141.523 224.349 141.59C221.605 141.656 218.927 140.424 216.685 138.958C215.948 138.492 215.312 137.859 214.643 137.26C213.538 136.26 212.4 135.261 211.296 134.262C210.559 133.596 209.823 132.963 209.087 132.297C208.384 131.664 207.346 132.663 208.016 133.363C209.756 135.161 211.53 136.927 213.471 138.492C213.94 138.858 214.409 139.258 214.911 139.591C215.212 139.791 215.379 140.024 215.48 140.391C215.647 141.123 215.312 141.956 214.81 142.522C213.338 144.188 210.593 143.588 208.752 143.088C206.342 142.422 203.966 141.523 201.723 140.391C192.586 135.827 185.624 128.133 180.469 119.473C178.997 117.009 177.658 114.477 176.453 111.846C175.449 109.648 174.779 107.45 174.813 105.051C174.813 104.085 173.34 104.085 173.307 105.051C173.273 106.017 173.273 106.95 173.273 107.916C173.574 107.683 173.909 107.45 174.21 107.183C165.508 103.786 156.036 102.32 146.731 102.886C144.087 103.053 141.476 103.353 138.899 103.819C137.995 104.119 138.397 105.551 139.334 105.384Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M186.293 129.099C184.386 130.731 181.942 132.397 179.298 131.497C178.26 131.131 177.29 130.265 177.256 129.099C177.189 127.934 177.825 126.834 178.461 125.902C179.331 124.603 180.436 123.437 181.641 122.438C181.239 122.371 180.838 122.338 180.469 122.271C182.21 125.036 184.151 127.667 186.293 130.132C186.929 130.865 188 129.799 187.364 129.066C185.289 126.701 183.448 124.17 181.775 121.505C181.507 121.072 180.972 121.039 180.603 121.339C179.331 122.405 178.227 123.637 177.256 125.003C176.419 126.168 175.683 127.601 175.75 129.066C175.917 132.397 179.733 133.729 182.545 132.996C184.386 132.497 185.925 131.331 187.364 130.132C187.666 129.865 187.632 129.333 187.364 129.066C187.03 128.8 186.595 128.833 186.293 129.099Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M193.222 135.961C192.686 136.66 192.084 137.226 191.381 137.759C191.347 137.793 191.08 137.959 191.314 137.826C191.247 137.859 191.18 137.892 191.147 137.959C191.046 138.026 190.912 138.092 190.812 138.159C190.544 138.325 190.276 138.459 190.009 138.625C189.071 139.125 187.866 139.591 186.862 139.691C186.595 139.724 186.36 139.724 186.092 139.724C185.825 139.724 185.791 139.724 185.49 139.624C185.256 139.558 185.256 139.558 184.988 139.391C184.954 139.358 184.921 139.325 184.888 139.325C184.988 139.391 184.888 139.291 184.854 139.291C184.821 139.258 184.754 139.225 184.72 139.158C184.72 139.158 184.586 138.992 184.653 139.092C184.352 138.692 184.218 138.226 184.185 137.659C184.118 136.86 184.285 136.127 184.553 135.394C185.189 133.596 186.394 131.964 187.699 130.565C187.331 130.565 186.996 130.565 186.628 130.565C188.67 132.896 190.946 135.028 193.389 136.927C193.724 137.193 194.159 137.226 194.46 136.927C194.728 136.66 194.795 136.127 194.46 135.861C192.017 133.962 189.774 131.797 187.699 129.499C187.431 129.199 186.896 129.199 186.628 129.499C185.256 130.965 184.051 132.63 183.281 134.495C182.645 136.061 182.377 137.959 183.181 139.525C184.519 142.156 188.101 141.223 190.209 140.224C190.879 139.924 191.548 139.558 192.184 139.092C192.351 138.958 192.586 138.792 192.82 138.625C193.021 138.459 193.255 138.292 193.456 138.092C193.891 137.693 194.226 137.226 194.594 136.76C194.828 136.427 194.628 135.927 194.326 135.727C193.858 135.494 193.456 135.661 193.222 135.961Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M193.623 135.794C192.15 136.56 191.079 137.759 190.51 139.225C189.975 140.591 190.109 142.089 190.812 143.355C191.515 144.587 192.719 145.42 194.125 145.553C195.531 145.72 196.87 145.12 197.941 144.221C199.112 143.222 199.949 141.79 200.284 140.324C200.518 139.391 199.045 138.992 198.845 139.924C198.409 141.756 196.937 143.855 194.895 144.054C192.719 144.254 191.247 142.056 191.816 140.058C192.184 138.759 193.121 137.726 194.393 137.06C195.23 136.66 194.46 135.361 193.623 135.794Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M180.871 121.672C180.737 121.772 180.603 121.838 180.469 121.905C180.436 121.905 180.403 121.938 180.369 121.938C180.369 121.938 180.469 121.905 180.369 121.938C180.302 121.971 180.202 122.005 180.135 122.005C180.068 122.038 179.967 122.038 179.9 122.071C179.867 122.071 179.834 122.071 179.8 122.105C179.8 122.105 179.9 122.105 179.834 122.105C179.666 122.105 179.499 122.138 179.331 122.105C179.298 122.105 179.131 122.105 179.164 122.105C179.231 122.105 179.064 122.071 179.03 122.071C178.863 122.038 178.696 122.005 178.562 121.938C178.528 121.938 178.495 121.905 178.461 121.905C178.461 121.905 178.562 121.938 178.461 121.905C178.394 121.872 178.327 121.838 178.26 121.805C178.193 121.772 178.127 121.705 178.06 121.672C178.06 121.672 177.959 121.605 178.026 121.638C178.093 121.672 177.959 121.605 177.959 121.572C177.859 121.472 177.725 121.372 177.624 121.239C177.691 121.339 177.624 121.239 177.591 121.205C177.558 121.139 177.524 121.072 177.491 121.039C177.39 120.872 177.491 121.106 177.457 120.972C177.424 120.906 177.424 120.839 177.39 120.806C177.357 120.739 177.357 120.673 177.357 120.606C177.357 120.539 177.323 120.339 177.323 120.473C177.29 120.173 177.29 119.873 177.323 119.573C177.323 119.44 177.323 119.64 177.323 119.507C177.323 119.44 177.357 119.374 177.357 119.307C177.39 119.14 177.424 118.974 177.491 118.841C177.524 118.741 177.558 118.674 177.591 118.574C177.591 118.541 177.624 118.508 177.624 118.474C177.658 118.374 177.591 118.574 177.624 118.474C177.691 118.308 177.758 118.174 177.859 118.041C177.892 117.975 177.926 117.908 177.993 117.841C178.026 117.808 178.026 117.775 178.06 117.775C178.026 117.841 178.026 117.841 178.06 117.775C178.16 117.642 178.26 117.542 178.394 117.442C178.696 117.175 178.662 116.642 178.394 116.376C178.093 116.076 177.658 116.109 177.323 116.376C176.219 117.308 175.683 119.04 175.817 120.439C175.884 121.239 176.152 121.971 176.754 122.571C177.323 123.137 178.093 123.47 178.863 123.604C179.834 123.737 180.838 123.57 181.607 123.004C181.942 122.771 182.11 122.338 181.875 121.971C181.708 121.638 181.206 121.439 180.871 121.672Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M252.331 118.075C255.979 118.374 259.694 117.975 263.276 117.309C267.024 116.609 270.74 115.51 274.288 114.144C277.534 112.912 280.647 111.38 283.626 109.614C286.739 107.816 289.818 105.917 293.132 104.518C296.679 103.02 300.629 102.12 304.411 103.319C305.348 103.619 305.75 102.154 304.813 101.887C297.717 99.6223 290.487 103.919 284.563 107.383C281.618 109.115 278.672 110.78 275.493 112.113C271.978 113.578 268.363 114.711 264.648 115.543C260.632 116.443 256.448 116.942 252.331 116.609C251.929 116.576 251.594 116.975 251.594 117.342C251.594 117.741 251.929 118.041 252.331 118.075Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M258.188 108.316C256.347 106.284 256.782 102.853 258.891 101.188C259.226 100.921 259.159 100.388 258.891 100.122C258.59 99.8222 258.155 99.8555 257.82 100.122C255.042 102.32 254.774 106.783 257.117 109.348C257.753 110.081 258.824 109.015 258.188 108.316Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M151.049 69.2459C153.827 70.7114 156.672 72.0104 159.517 73.3427C162.194 74.6084 164.872 75.8408 167.65 76.9066C173.072 79.005 178.963 80.2373 184.754 79.0383C189.942 77.9724 194.46 75.0747 199.079 72.61C201.322 71.4109 203.598 70.3117 206.041 69.5457C207.848 68.9795 209.723 68.5132 211.597 68.2134C215.045 67.7138 219.429 67.7804 221.605 70.9113C221.906 71.3443 222.14 71.7773 222.341 72.2436C222.508 72.61 223.044 72.7099 223.379 72.51C223.747 72.2769 223.814 71.8439 223.646 71.4775C222.843 69.6456 221.404 68.1801 219.563 67.414C217.722 66.6146 215.68 66.4148 213.706 66.5147C209.455 66.7146 205.171 68.0135 201.322 69.7788C196.569 71.9771 192.218 75.0747 187.23 76.7734C184.586 77.6727 181.842 78.0724 179.064 77.9724C176.152 77.8725 173.307 77.2064 170.562 76.3071C167.75 75.3745 165.039 74.2087 162.362 72.943C159.584 71.644 156.772 70.3784 154.027 69.0128C153.291 68.6464 152.588 68.28 151.852 67.8803C150.948 67.5139 150.178 68.8129 151.049 69.2459Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M240.482 42.0007C241.788 37.0712 243.093 32.175 244.432 27.2455C243.93 27.1789 243.461 27.1123 242.959 27.0457C242.993 27.4454 243.06 27.8784 243.093 28.2781C243.127 28.6777 243.394 29.0108 243.829 29.0108C244.198 29.0108 244.633 28.6777 244.566 28.2781C244.532 27.8784 244.465 27.4454 244.432 27.0457C244.398 26.6793 244.164 26.3462 243.762 26.3129C243.394 26.2796 243.026 26.4795 242.926 26.8458C241.62 31.7753 240.315 36.6715 238.976 41.601C238.775 42.5336 240.215 42.9333 240.482 42.0007Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M249.151 46.4306C255.645 38.9364 262.105 31.4423 268.598 23.9814C270.439 21.8497 272.28 19.7181 274.154 17.5864C273.752 17.2866 273.351 16.9869 272.983 16.6871C272.849 16.9869 272.681 17.3199 272.547 17.6197C272.38 17.9861 272.447 18.4191 272.815 18.6522C273.15 18.8521 273.685 18.7522 273.853 18.3858C273.987 18.086 274.154 17.7529 274.288 17.4532C274.455 17.1201 274.422 16.7204 274.087 16.4873C273.819 16.2874 273.351 16.2541 273.083 16.5539C266.59 24.048 260.096 31.5422 253.603 39.0696C251.762 41.2013 249.921 43.333 248.08 45.4314C247.444 46.0975 248.515 47.1633 249.151 46.4306Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("pattern", {
                        id: "pattern0",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("use", {
                            xlinkHref: "#image0",
                            transform: "translate(0 -0.539896) scale(0.00166667 0.00346632)"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("pattern", {
                        id: "pattern1",
                        patternContentUnits: "objectBoundingBox",
                        width: "0.668761",
                        height: "1.21437",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("use", {
                            xlinkHref: "#image1",
                            transform: "scale(0.00130617 0.00237181)"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                        id: "paint0_linear",
                        x1: "371.635",
                        y1: "34.8062",
                        x2: "371.635",
                        y2: "113.907",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                stopColor: "#35BC82"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                offset: "0.864583",
                                stopColor: "#009278"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                        id: "paint1_linear",
                        x1: "10.4408",
                        y1: "35.1458",
                        x2: "10.4408",
                        y2: "95.598",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                stopColor: "#B7972F"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B7972F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("image", {
                        id: "image0",
                        width: "600",
                        height: "600",
                        xlinkHref: "data:image/png;base64,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"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("image", {
                        id: "image1",
                        width: "512",
                        height: "512",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("fgMgQ", function(module, exports) {

$parcel$export(module.exports, "HumLogo", () => $9a5010f376b438ce$export$83f83bfad8452605);

var $ayMG0 = parcelRequire("ayMG0");
const $9a5010f376b438ce$export$83f83bfad8452605 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "108",
        height: "46",
        viewBox: "0 0 108 46",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M43.0759 0.077484V1.44482H35.5928C30.3018 1.48198 28.8082 1.94271 27.5672 5.32385C27.3294 5.96292 27.1139 6.6317 26.891 7.34508C25.3081 12.2867 23.3389 18.4323 11.1371 23.8124C6.65615 25.789 4.7092 28.9695 2.65079 32.6479L1.49898 34.855L0.287712 34.2382L10.8398 13.6838L0.280273 0.0700684H0.629535C8.07548 0.0997927 13.3144 3.80047 15.2167 5.19751C15.2167 5.19751 16.3611 2.85671 16.7178 2.3291C17.6616 0.924626 19.8686 0.0849224 22.6255 0.0849224C23.4355 0.0849224 43.0759 0.077484 43.0759 0.077484ZM23.272 3.03506C22.8485 2.69323 22.2986 2.62636 21.7933 2.85672C21.4068 3.02764 21.1244 3.3769 21.0353 3.78561C20.9164 4.32808 21.0947 4.85568 21.5183 5.19751C21.7709 5.40558 22.0756 5.50962 22.3952 5.50962C22.5958 5.50962 22.8039 5.46502 23.0045 5.37585C23.3909 5.20493 23.6733 4.85569 23.7625 4.43955C23.8665 3.90451 23.6882 3.37689 23.272 3.03506Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M42.2133 44.3519H49.5031V33.6511C49.5031 20.9737 36.744 24.823 36.744 24.823V14.0925H29.4541V44.3519H36.744V34.3274C36.744 32.8189 37.9701 31.5927 39.4786 31.5927C40.9871 31.5927 42.2133 32.8189 42.2133 34.3274V44.3519Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M99.9894 44.3445H107.279V34.3199C107.279 28.7912 102.784 24.2954 97.2548 24.2954C94.9512 24.2954 92.7887 25.0534 90.9904 26.495L90.8789 26.5842L90.7674 26.495C88.9691 25.0534 86.8067 24.2954 84.503 24.2954C78.9743 24.2954 74.4785 28.7912 74.4785 34.3199V44.3445H81.7684V34.3199C81.7684 32.8114 82.9945 31.5853 84.503 31.5853C86.0115 31.5853 87.2377 32.8114 87.2377 34.3199V44.3445H94.5276V34.3199C94.5276 32.8114 95.7537 31.5853 97.2622 31.5853C98.7707 31.5853 99.9968 32.8114 99.9968 34.3199V44.3445H99.9894Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.9629 35.1151L51.9703 35.2191C52.0149 37.8571 53.0776 40.3317 54.9651 42.1895C56.8525 44.0472 59.3494 45.0653 61.9948 45.0653C64.6403 45.0653 67.1372 44.0398 69.0247 42.1895C70.9047 40.3391 71.9674 37.8646 72.0194 35.2191L72.0268 35.0408V25.1946H64.7221V35.0408C64.7221 36.5493 63.4959 37.7754 61.9874 37.7754C60.4789 37.7754 59.2528 36.5493 59.2528 35.0408V25.1946H51.9629V35.1151Z",
                fill: "white"
            })
        ]
    });
};

});

parcelRegister("csBxw", function(module, exports) {

$parcel$export(module.exports, "List", () => $63c1102880b0f643$export$54c2e3dc7acea9f5);

var $ayMG0 = parcelRequire("ayMG0");
const $63c1102880b0f643$export$54c2e3dc7acea9f5 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "120",
        height: "109",
        viewBox: "0 0 120 109",
        fill: "none",
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                filter: "url(#filter0_d_454_5299)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "4.5",
                        width: "102",
                        height: "90",
                        rx: "5",
                        fill: "#2042F6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        filter: "url(#filter1_bd_454_5299)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            x: "12.5",
                            y: "7",
                            width: "103",
                            height: "94",
                            rx: "5",
                            fill: "white",
                            fillOpacity: "0.95",
                            shapeRendering: "crispEdges"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "36.5",
                        y: "17",
                        width: "70",
                        height: "5",
                        rx: "2.5",
                        fill: "#788598"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "36.5",
                        y: "27",
                        width: "32",
                        height: "5",
                        rx: "2.5",
                        fill: "#788598"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        filter: "url(#filter2_b_454_5299)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                            cx: "26.5",
                            cy: "25",
                            r: "5",
                            fill: "#77F1A1"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        filter: "url(#filter3_b_454_5299)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                            cx: "26.5",
                            cy: "55",
                            r: "5",
                            fill: "#77F1A1"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        opacity: "0.6",
                        filter: "url(#filter4_b_454_5299)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                            cx: "26.5",
                            cy: "85",
                            r: "5",
                            fill: "#CBD5E1"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "36.5",
                        y: "47",
                        width: "70",
                        height: "5",
                        rx: "2.5",
                        fill: "#788598"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "36.5",
                        y: "57",
                        width: "70",
                        height: "5",
                        rx: "2.5",
                        fill: "#788598"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        opacity: "0.6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "36.5",
                                y: "77",
                                width: "70",
                                height: "5",
                                rx: "2.5",
                                fill: "#CBD5E1"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "36.5",
                                y: "87",
                                width: "51",
                                height: "5",
                                rx: "2.5",
                                fill: "#CBD5E1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter0_d_454_5299",
                        x: "0.5",
                        y: "0",
                        width: "119",
                        height: "109",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_454_5299"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_454_5299",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter1_bd_454_5299",
                        x: "2.5",
                        y: "-3",
                        width: "123",
                        height: "114",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_454_5299"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect1_backgroundBlur_454_5299",
                                result: "effect2_dropShadow_454_5299"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow_454_5299",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter2_b_454_5299",
                        x: "17.5",
                        y: "16",
                        width: "18",
                        height: "18",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_454_5299"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_454_5299",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter3_b_454_5299",
                        x: "17.5",
                        y: "46",
                        width: "18",
                        height: "18",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_454_5299"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_454_5299",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter4_b_454_5299",
                        x: "17.5",
                        y: "76",
                        width: "18",
                        height: "18",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_454_5299"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_454_5299",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("aAgjf", function(module, exports) {

$parcel$export(module.exports, "NoResults", () => $66b30db7e28a991c$export$ef6006467f04ee41);

var $ayMG0 = parcelRequire("ayMG0");
const $66b30db7e28a991c$export$ef6006467f04ee41 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "123",
        height: "96",
        viewBox: "0 0 123 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                filter: "url(#filter0_d_791_8555)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "6",
                        y: "10",
                        width: "103.648",
                        height: "69.3586",
                        rx: "5",
                        fill: "#09168E"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        filter: "url(#filter1_b_791_8555)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            x: "14.5724",
                            y: "18.5723",
                            width: "104.428",
                            height: "69.3586",
                            rx: "5",
                            fill: "#DDE5FE",
                            fillOpacity: "0.85"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "44",
                        y: "64",
                        width: "19",
                        height: "18",
                        rx: "3",
                        fill: "#2042F6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "68",
                        y: "46",
                        width: "20",
                        height: "36",
                        rx: "3",
                        fill: "#2042F6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "93",
                        y: "27",
                        width: "19",
                        height: "55",
                        rx: "3",
                        fill: "#2042F6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        filter: "url(#filter2_bd_791_8555)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            x: "4",
                            y: "4",
                            width: "54",
                            height: "49",
                            rx: "5",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M30.9843 44.611C39.8832 44.611 47.2284 37.2659 47.2284 28.3827C47.2284 19.4994 39.8675 12.1543 30.9686 12.1543C22.0854 12.1543 14.7559 19.4994 14.7559 28.3827C14.7559 37.2659 22.1011 44.611 30.9843 44.611ZM30.6076 31.6158C29.5875 31.6158 29.0225 31.1449 29.0225 30.2033V30.0306C29.0225 28.5553 29.87 27.7235 31.0314 26.9074C32.4125 25.95 33.0874 25.4321 33.0874 24.4276C33.0874 23.3447 32.2556 22.6227 30.9686 22.6227C30.0269 22.6227 29.3363 23.0935 28.8184 23.894C28.3162 24.459 28.0808 24.9455 27.1391 24.9455C26.37 24.9455 25.7422 24.4433 25.7422 23.6586C25.7422 23.3447 25.805 23.0622 25.9149 22.7796C26.4328 21.2416 28.3162 19.986 31.1255 19.986C34.0448 19.986 36.5088 21.5398 36.5088 24.2706C36.5088 26.154 35.473 27.0957 33.8407 28.1473C32.8049 28.8221 32.2085 29.3871 32.1614 30.2347C32.1614 30.2817 32.1457 30.3602 32.1457 30.423C32.0986 31.0979 31.5179 31.6158 30.6076 31.6158ZM30.5919 36.6381C29.5247 36.6381 28.6458 35.8691 28.6458 34.8332C28.6458 33.7974 29.509 33.0283 30.5919 33.0283C31.6592 33.0283 32.5224 33.7974 32.5224 34.8332C32.5224 35.8848 31.6435 36.6381 30.5919 36.6381Z",
                        fill: "#92ABFA"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter0_d_791_8555",
                        x: "0",
                        y: "4",
                        width: "123",
                        height: "91.9307",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_791_8555"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_791_8555",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter1_b_791_8555",
                        x: "10.5724",
                        y: "14.5723",
                        width: "112.428",
                        height: "77.3584",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_791_8555"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_791_8555",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter2_bd_791_8555",
                        x: "-6",
                        y: "-6",
                        width: "74",
                        height: "69",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_791_8555"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feMorphology", {
                                radius: "1",
                                operator: "dilate",
                                in: "SourceAlpha",
                                result: "effect2_dropShadow_791_8555"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dx: "2",
                                dy: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "2.5"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect1_backgroundBlur_791_8555",
                                result: "effect2_dropShadow_791_8555"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow_791_8555",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("kQ1KK", function(module, exports) {

$parcel$export(module.exports, "SignedFile", () => $2dbf28460418cd72$export$a554bf5bf9470c9b);

var $ayMG0 = parcelRequire("ayMG0");
const $2dbf28460418cd72$export$a554bf5bf9470c9b = ({ className: className })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "125",
        height: "110",
        viewBox: "0 0 125 110",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M113.735 83.4973C113.735 94.9555 109.884 105.501 103.5 114.019C100.054 118.582 95.6961 122.536 90.8316 125.68C82.9268 130.851 73.5019 133.893 63.3676 133.893C35.4982 133.893 13 111.281 13 83.4973C13 55.6123 35.4982 33 63.3676 33C73.5019 33 82.9268 36.042 90.8316 41.112C95.6961 44.2554 99.9525 48.3114 103.5 52.8744C109.985 61.3921 113.735 72.0391 113.735 83.4973Z",
                        fill: "#1E1E1E"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M95.7758 17.1448H28.1829V110H95.7654V17.1448H95.7758Z",
                        fill: "#393939"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M37.1188 43.8467C36.7022 43.8467 36.2751 43.4217 36.2751 43.0071C36.2751 42.5821 36.6917 42.1675 37.1188 42.1675H86.8396C87.2562 42.1675 87.6832 42.5925 87.6832 43.0071C87.6832 43.4321 87.2666 43.8467 86.8396 43.8467H37.1188Z",
                        fill: "#7C7C7C"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M37.1188 50.1595C36.7022 50.1595 36.2751 49.7345 36.2751 49.3198C36.2751 48.9052 36.6917 48.4802 37.1188 48.4802H86.8396C87.2562 48.4802 87.6832 48.9052 87.6832 49.3198C87.6832 49.7345 87.2666 50.1595 86.8396 50.1595H37.1188Z",
                        fill: "#7C7C7C"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M37.1188 56.472C36.7022 56.472 36.2751 56.047 36.2751 55.6323C36.2751 55.2177 36.6917 54.7927 37.1188 54.7927H86.8396C87.2562 54.7927 87.6832 55.2177 87.6832 55.6323C87.6832 56.047 87.2666 56.472 86.8396 56.472H37.1188Z",
                        fill: "#7C7C7C"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M37.1188 62.7847C36.7022 62.7847 36.2751 62.3597 36.2751 61.9451C36.2751 61.5305 36.6917 61.1055 37.1188 61.1055H86.8396C87.2562 61.1055 87.6832 61.5305 87.6832 61.9451C87.6832 62.3597 87.2666 62.7847 86.8396 62.7847H37.1188Z",
                        fill: "#7C7C7C"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M37.1188 69.1907C36.7022 69.1907 36.2751 68.7657 36.2751 68.3511C36.2751 67.9365 36.6917 67.5115 37.1188 67.5115H86.8396C87.2562 67.5115 87.6832 67.9365 87.6832 68.3511C87.6832 68.7657 87.2666 69.1907 86.8396 69.1907H37.1188Z",
                        fill: "#7C7C7C"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M37.1188 75.5032C36.7022 75.5032 36.2751 75.0782 36.2751 74.6636C36.2751 74.249 36.6917 73.824 37.1188 73.824H58.9797C59.3963 73.824 59.8233 74.249 59.8233 74.6636C59.8233 75.0782 59.4067 75.5032 58.9797 75.5032H37.1188Z",
                        fill: "#7C7C7C"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M73.5918 27.9769H50.3665C49.8457 27.9769 49.4187 27.5519 49.4187 27.0336C49.4187 26.505 49.8353 26.0903 50.3665 26.0903H73.5918C74.1125 26.0903 74.5395 26.5153 74.5395 27.0336C74.5395 27.5519 74.1229 27.9769 73.5918 27.9769Z",
                        fill: "#7C7C7C"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M67.7074 32.911H56.251C55.7302 32.911 55.3032 32.486 55.3032 31.9677C55.3032 31.439 55.7198 31.0244 56.251 31.0244H67.7074C68.2282 31.0244 68.6552 31.4494 68.6552 31.9677C68.6552 32.4963 68.2282 32.911 67.7074 32.911Z",
                        fill: "#7C7C7C"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M82.8403 94.7522C82.632 93.2803 82.5279 92.2334 81.476 91.912C79.7992 91.487 79.268 93.6949 77.6953 95.3845C77.1746 95.9131 76.4351 96.3278 75.7998 96.7528C75.5915 96.8564 75.1645 97.0637 75.0604 96.6491C74.6438 95.3845 75.0604 96.0168 76.8517 94.0162C77.6954 93.073 78.2161 91.912 78.0078 90.5438C77.9037 89.7041 77.3725 88.9682 76.5393 88.6468C75.6957 88.3359 74.8625 88.4395 74.2272 89.1755C72.7587 90.9584 73.1753 92.0157 73.0711 94.6485C73.0711 94.8559 72.967 95.0735 72.7587 95.1772C71.2902 96.0168 69.7071 96.5454 67.9261 96.7528C67.9261 96.6491 67.9261 96.6491 67.9261 96.6491C68.8739 95.3845 70.759 93.1766 71.186 89.3932C71.3943 87.9213 71.3943 86.553 70.6653 85.1847C69.3009 82.6659 65.6244 82.9768 63.9372 86.0243C62.2604 89.2895 62.5729 94.3272 64.885 97.1674C64.3642 97.5924 63.9372 98.007 63.4165 98.3283C63.104 98.5357 62.9999 99.0643 63.2082 99.3753C63.4165 99.8003 64.0518 99.9039 64.4684 99.5826C66.1452 98.2143 66.041 98.318 66.2598 98.2143C66.5722 98.1107 66.8951 98.2143 67.2075 98.2143C68.3636 98.2143 69.103 98.1107 69.9362 98.007C70.3528 97.9034 73.1961 96.8461 73.3002 96.8461C73.3002 96.8461 73.3003 96.9497 73.4044 97.0534C73.7169 98.2143 74.3522 98.6289 75.6124 98.5253C76.5601 98.4216 77.4037 97.9966 78.1328 97.3643C78.9764 96.5247 80.3407 94.8455 81.0802 93.8919C81.2885 94.6278 81.2885 95.2601 81.4968 95.8924C81.9134 97.0534 83.0695 97.2607 83.8089 96.3174C84.6525 95.3741 84.965 94.1095 85.9127 93.5809C86.2252 93.4772 86.4335 93.1559 86.4335 92.8449C86.4335 92.2126 85.7982 91.9017 85.2774 92.109C84.1005 92.648 83.4756 93.6949 82.8403 94.7522ZM66.2389 96.2241C65.3953 95.1772 65.0829 94.0162 64.8746 92.7516C64.458 90.8547 64.6663 88.9682 65.3953 87.1749C65.8119 86.2317 66.3431 85.4957 67.395 85.278C68.4469 85.0707 69.1863 85.278 69.3946 86.3249C70.2278 89.9115 68.7593 93.3839 66.2389 96.2241ZM75.0604 90.7511C75.6957 89.4865 76.4247 90.6474 76.3206 91.1761C76.1123 91.8084 75.7998 92.337 75.477 92.8553C75.2687 93.1663 75.0604 93.3839 74.7375 93.6949C74.6438 92.5443 74.6438 91.5907 75.0604 90.7511Z",
                        fill: "#7698f3"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M116.585 54.8962C119.001 54.9999 121.313 55.3212 123.625 55.9432C124.677 56.2541 124.677 56.3682 124.042 57.3114C122.573 59.4157 121.094 61.4162 119.834 63.6241C118.053 66.5679 117.106 65.7283 112.585 67.0966L116.585 68.0399C116.689 68.0399 116.689 68.0399 116.793 68.1435C117.001 68.3508 117.106 68.6722 116.897 68.8795C116.262 69.8227 115.637 70.7764 115.002 71.7197C110.273 78.0323 103.337 82.3444 95.5571 83.8163C94.5052 84.0236 93.5574 84.7596 93.1408 85.7132C92.1931 87.6102 91.3494 89.4967 90.4121 91.3936C90.0997 92.0259 89.4643 92.2332 88.8395 91.9223C88.2041 91.6113 87.9958 90.979 88.3187 90.3467C88.8395 89.1857 89.3706 88.0351 89.8914 86.9779C90.308 86.0346 90.2038 85.0809 89.8914 84.1377C89.3706 82.4584 88.9436 80.7688 88.8395 78.9859C88.8395 77.3067 89.1519 75.5135 89.5789 73.8342C90.3184 71.0977 91.3703 68.4752 92.9429 66.1533L93.0471 66.0497C93.1512 66.0497 93.3595 66.0497 93.3595 66.257C93.4637 66.682 93.5678 66.9929 93.7761 67.5216C93.9844 66.5783 94.2969 65.521 94.7239 64.4741C94.828 64.0491 95.1405 63.6345 95.4634 63.2095C97.1402 61.5302 99.0357 60.0583 101.139 58.8974H101.244C101.348 58.8974 101.452 59.001 101.452 59.1047C101.452 59.737 101.452 60.4729 101.452 61.1053C102.296 59.8406 103.243 58.7937 104.285 57.6328C104.597 57.3218 105.024 57.0005 105.441 56.8968C106.805 56.3682 108.274 55.9535 109.648 55.7359",
                        stroke: "#7698f3",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M88.9435 80.1263C88.9435 79.7013 88.8394 79.2867 88.8394 78.9653C88.8394 77.2861 89.1518 75.4928 89.5788 73.8136C90.3183 71.0771 91.3702 68.4546 92.9428 66.1327L93.047 66.029C93.1511 66.029 93.3594 66.029 93.3594 66.2363C93.4636 66.6613 93.5677 66.9723 93.776 67.5009C93.9843 66.5577 94.2968 65.5004 94.7238 64.4534C94.8279 64.0285 95.1404 63.6138 95.4633 63.1888C97.1401 61.5096 99.0356 60.0377 101.139 58.8767H101.244C101.348 58.8767 101.452 58.9804 101.452 59.0841C101.452 59.7164 101.452 60.4523 101.452 61.0846C102.295 59.82 103.243 58.7731 104.285 57.6121C104.597 57.3012 105.024 56.9798 105.441 56.8762C107.013 56.3475 108.492 55.9329 110.065 55.6116",
                        stroke: "#7698f3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M117.741 54.8962C119.741 54.9999 121.73 55.4249 123.625 55.9432C124.677 56.2541 124.677 56.3682 124.042 57.3114C122.573 59.4157 121.094 61.4162 119.834 63.6241C118.053 66.5679 117.106 65.7283 112.585 67.0966L116.585 68.0399C116.689 68.0399 116.689 68.0399 116.793 68.1435C117.001 68.3508 117.106 68.6722 116.897 68.8795C116.262 69.8227 115.637 70.7764 115.002 71.7197C110.273 78.0323 103.337 82.3444 95.5571 83.8163C94.5052 84.0236 93.5574 84.7596 93.1408 85.7132C92.1931 87.6102 91.3494 89.4967 90.4121 91.3936C90.0997 92.0259 89.4643 92.2332 88.8395 91.9223C88.2041 91.6113 87.9958 90.979 88.3187 90.3467C88.8395 89.1857 89.3706 88.0351 89.8914 86.9779C90.308 86.0346 90.2038 85.0809 89.8914 84.1377C89.7872 83.9304 89.7872 83.7127 89.6831 83.5054",
                        stroke: "#7698f3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M113.012 55C113.117 55 113.325 55 113.429 55",
                        stroke: "#7698f3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M105.128 66.3503C98.0879 71.5021 93.672 78.9653 89.8914 86.9572",
                        stroke: "#7698f3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M113.117 62.0486C111.221 62.7845 109.44 63.6242 107.753 64.5674",
                        stroke: "#7698f3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "125",
                        height: "110",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("h9qCx", function(module, exports) {

$parcel$export(module.exports, "VerifyEmail", () => $0665697b80857c24$export$3d3197b723615cc);

var $ayMG0 = parcelRequire("ayMG0");
const $0665697b80857c24$export$3d3197b723615cc = ({ className: className })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "142",
        height: "115",
        viewBox: "0 0 142 115",
        fill: "none",
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                filter: "url(#filter0_d_36200_4699)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "25",
                        y: "18.0791",
                        width: "103.648",
                        height: "69.3586",
                        rx: "5",
                        fill: "#09168E"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        filter: "url(#filter1_b_36200_4699)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            x: "33.5724",
                            y: "26.6514",
                            width: "104.428",
                            height: "69.3586",
                            rx: "5",
                            fill: "#DDE5FE",
                            fillOpacity: "0.85"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "64.7449",
                        y: "87.4375",
                        width: "19.4828",
                        height: "19.4828",
                        rx: "3",
                        fill: "#2042F6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "88.9034",
                        y: "66.3965",
                        width: "20.2621",
                        height: "40.5241",
                        rx: "3",
                        fill: "#2042F6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "113.841",
                        y: "45.355",
                        width: "19.4828",
                        height: "61.5655",
                        rx: "3",
                        fill: "#2042F6"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        filter: "url(#filter2_bd_36200_4699)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            x: "4",
                            y: "4.0791",
                            width: "96",
                            height: "49",
                            rx: "5",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M30.7049 26.4447C29.5614 26.4447 28.6344 25.5177 28.6344 24.3742V14.0218C28.6344 12.8783 29.5667 11.9357 30.6987 12.0972C37.0512 13.003 42.0761 18.0279 42.9819 24.3804C43.1434 25.5124 42.2008 26.4447 41.0573 26.4447H30.7049Z",
                        fill: "#77F1A1"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M22.4291 16.2382C23.5611 16.0767 24.4934 17.0192 24.4934 18.1627V28.5152C24.4934 29.6587 25.4204 30.5857 26.5639 30.5857H36.9164C38.0599 30.5857 39.0024 31.518 38.8409 32.65C37.8389 39.6767 31.7971 45.0791 24.4934 45.0791C16.4889 45.0791 10 38.5902 10 30.5857C10 23.282 15.4024 17.2402 22.4291 16.2382Z",
                        fill: "#00057F"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "52",
                        y: "21.0791",
                        width: "39",
                        height: "5",
                        rx: "2.5",
                        fill: "#7E899A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "59",
                        y: "28.0791",
                        width: "24",
                        height: "5",
                        rx: "2.5",
                        fill: "#7E899A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter0_d_36200_4699",
                        x: "0",
                        y: "4.0791",
                        width: "142",
                        height: "110.841",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_36200_4699"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_36200_4699",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter1_b_36200_4699",
                        x: "29.5724",
                        y: "22.6514",
                        width: "112.428",
                        height: "77.3584",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_36200_4699"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_36200_4699",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "filter2_bd_36200_4699",
                        x: "-6",
                        y: "-5.9209",
                        width: "116",
                        height: "69",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_36200_4699"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feMorphology", {
                                radius: "1",
                                operator: "dilate",
                                in: "SourceAlpha",
                                result: "effect2_dropShadow_36200_4699"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dx: "2",
                                dy: "2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                stdDeviation: "2.5"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect1_backgroundBlur_36200_4699",
                                result: "effect2_dropShadow_36200_4699"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow_36200_4699",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("itiNH", function(module, exports) {
parcelRequire("gGwtt");

});
parcelRegister("gGwtt", function(module, exports) {

$parcel$export(module.exports, "Markdown", () => $276ea66f29c3f179$export$7460c8b7e4ce9582);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $htkMF = parcelRequire("htkMF");

var $7KOXg = parcelRequire("7KOXg");

var $lFVtV = parcelRequire("lFVtV");
var $7OeFl = parcelRequire("7OeFl");
const $276ea66f29c3f179$var$sanitizeSchema = {
    ...(0, $7OeFl.defaultSchema),
    tagNames: [
        ...(0, $7OeFl.defaultSchema).tagNames || [],
        "table",
        "thead",
        "tbody",
        "tr",
        "th",
        "td"
    ]
};
const $276ea66f29c3f179$var$components = {
    strong: ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
            className: "font-bold text-white",
            children: children
        }),
    em: ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("em", {
            className: "italic",
            children: children
        }),
    table: ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "my-4 overflow-x-auto",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
                className: "min-w-full border-collapse border border-slate-700",
                children: children
            })
        }),
    thead: ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
            className: "bg-slate-800",
            children: children
        }),
    tbody: ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
            children: children
        }),
    tr: ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
            className: "border-b border-slate-700",
            children: children
        }),
    th: ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
            className: (0, $9QePP.default)("px-4 py-2", "border border-slate-700", "text-left font-semibold"),
            children: children
        }),
    td: ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
            className: "border border-slate-700 px-4 py-2",
            children: children
        }),
    p: ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "body-s",
            children: children
        }),
    h1: ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
            className: "heading-l my-2",
            children: children
        }),
    h2: ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
            className: "heading-m my-2",
            children: children
        }),
    h3: ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "heading-s my-2",
            children: children
        }),
    ul: ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            className: (0, $9QePP.default)("body-s list-disc space-y-2 pl-6"),
            children: children
        }),
    ol: ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("ol", {
            className: (0, $9QePP.default)("body-s list-decimal space-y-2 pl-6"),
            children: children
        }),
    li: ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: "body-s subdued",
            children: children
        }),
    br: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
};
function $276ea66f29c3f179$export$7460c8b7e4ce9582({ testId: testId, className: className, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $htkMF.ReactMarkdown), {
        className: (0, $9QePP.default)(className, "body-s", "cursor-default", "subdued"),
        components: $276ea66f29c3f179$var$components,
        remarkPlugins: [
            (0, $7KOXg.default)
        ],
        rehypePlugins: [
            [
                (0, $lFVtV.default),
                $276ea66f29c3f179$var$sanitizeSchema
            ]
        ],
        "data-testid": testId,
        children: children
    });
}

});
parcelRegister("htkMF", function(module, exports) {

$parcel$export(module.exports, "ReactMarkdown", () => $cb8544603a0b034a$export$83ef7ab426386201);
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options | undefined} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */ 
var $acw62 = parcelRequire("acw62");

var $kfsOU = parcelRequire("kfsOU");

var $hBHqC = parcelRequire("hBHqC");

var $3F7xF = parcelRequire("3F7xF");

var $kMNw8 = parcelRequire("kMNw8");

var $c9Z8w = parcelRequire("c9Z8w");

var $9LDLu = parcelRequire("9LDLu");

var $2Hi3l = parcelRequire("2Hi3l");

var $i5UZr = parcelRequire("i5UZr");
const $cb8544603a0b034a$var$own = {}.hasOwnProperty;
const $cb8544603a0b034a$var$changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md";
/** @type {Record<string, Deprecation>} */ const $cb8544603a0b034a$var$deprecated = {
    plugins: {
        to: "remarkPlugins",
        id: "change-plugins-to-remarkplugins"
    },
    renderers: {
        to: "components",
        id: "change-renderers-to-components"
    },
    astPlugins: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    allowDangerousHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    escapeHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    source: {
        to: "children",
        id: "change-source-to-children"
    },
    allowNode: {
        to: "allowElement",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    allowedTypes: {
        to: "allowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    disallowedTypes: {
        to: "disallowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    includeNodeIndex: {
        to: "includeElementIndex",
        id: "change-includenodeindex-to-includeelementindex"
    }
};
function $cb8544603a0b034a$export$83ef7ab426386201(options) {
    for(const key in $cb8544603a0b034a$var$deprecated)if ($cb8544603a0b034a$var$own.call($cb8544603a0b034a$var$deprecated, key) && $cb8544603a0b034a$var$own.call(options, key)) {
        const deprecation = $cb8544603a0b034a$var$deprecated[key];
        console.warn(`[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : "remove"} \`${key}\` (see <${$cb8544603a0b034a$var$changelog}#${deprecation.id}> for more info)`);
        delete $cb8544603a0b034a$var$deprecated[key];
    }
    const processor = (0, $hBHqC.unified)().use((0, $3F7xF.default)).use(options.remarkPlugins || []).use((0, $kMNw8.default), {
        ...options.remarkRehypeOptions,
        allowDangerousHtml: true
    }).use(options.rehypePlugins || []).use((0, $2Hi3l.default), options);
    const file = new (0, $kfsOU.VFile)();
    if (typeof options.children === "string") file.value = options.children;
    else if (options.children !== undefined && options.children !== null) console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`);
    const hastNode = processor.runSync(processor.parse(file), file);
    if (hastNode.type !== "root") throw new TypeError("Expected a `root` node");
    /** @type {ReactElement} */ let result = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, (0, $i5UZr.childrenToReact)({
        options: options,
        schema: (0, $9LDLu.html),
        listDepth: 0
    }, hastNode));
    if (options.className) result = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: options.className
    }, result);
    return result;
}
$cb8544603a0b034a$export$83ef7ab426386201.propTypes = {
    // Core options:
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    // Layout options:
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    // Filter options:
    allowElement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    allowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    disallowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    unwrapDisallowed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    // Plugin options:
    remarkPlugins: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
        ]))
    ])),
    rehypePlugins: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
        ]))
    ])),
    // Transform options:
    sourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    rawSourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    skipHtml: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    includeElementIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    transformLinkUri: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ]),
    linkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    transformImageUri: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};

});
parcelRegister("kfsOU", function(module, exports) {

$parcel$export(module.exports, "VFile", () => $ebdb906eb43ac433$export$93dff69eb10dc7ce);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {Record<string, unknown> & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {'ascii' | 'utf8' | 'utf-8' | 'utf16le' | 'ucs2' | 'ucs-2' | 'base64' | 'base64url' | 'latin1' | 'binary' | 'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *
 *   This is a copy of the types from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Options | URL | Value | VFile} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {Value | null | undefined} [value]
 *   Set `value`.
 * @property {string | null | undefined} [cwd]
 *   Set `cwd`.
 * @property {Array<string> | null | undefined} [history]
 *   Set `history`.
 * @property {URL | string | null | undefined} [path]
 *   Set `path`.
 * @property {string | null | undefined} [basename]
 *   Set `basename`.
 * @property {string | null | undefined} [stem]
 *   Set `stem`.
 * @property {string | null | undefined} [extname]
 *   Set `extname`.
 * @property {string | null | undefined} [dirname]
 *   Set `dirname`.
 * @property {Data | null | undefined} [data]
 *   Set `data`.
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template {ReporterSettings} Settings
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ 
var $7B5Ea = parcelRequire("7B5Ea");

var $bpyKL = parcelRequire("bpyKL");

var $9haXP = parcelRequire("9haXP");

var $4lnqT = parcelRequire("4lnqT");
parcelRequire("dzJSz");
var $k7DYN = parcelRequire("k7DYN");
var $dzJSz = parcelRequire("dzJSz");
/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 *
 * @type {Array<'basename' | 'dirname' | 'extname' | 'history' | 'path' | 'stem'>}
 */ const $ebdb906eb43ac433$var$order = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
class $ebdb906eb43ac433$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if (typeof value === "string" || $ebdb906eb43ac433$var$buffer(value)) options = {
            value: value
        };
        else if ((0, $k7DYN.isUrl)(value)) options = {
            path: value
        };
        else options = value;
        /**
     * Place to store custom information (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * List of filepaths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $4lnqT.proc).cwd();
        /* eslint-disable no-unused-expressions */ /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $ebdb906eb43ac433$var$order.length){
            const prop = $ebdb906eb43ac433$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === "history" ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$ebdb906eb43ac433$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */ set path(path) {
        if ((0, $k7DYN.isUrl)(path)) path = (0, $dzJSz.urlToPath)(path);
        $ebdb906eb43ac433$var$assertNonEmpty(path, "path");
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the parent path (example: `'~'`).
   */ get dirname() {
        return typeof this.path === "string" ? (0, $9haXP.path).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */ set dirname(dirname) {
        $ebdb906eb43ac433$var$assertPath(this.basename, "dirname");
        this.path = (0, $9haXP.path).join(dirname || "", this.basename);
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */ get basename() {
        return typeof this.path === "string" ? (0, $9haXP.path).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set basename(basename) {
        $ebdb906eb43ac433$var$assertNonEmpty(basename, "basename");
        $ebdb906eb43ac433$var$assertPart(basename, "basename");
        this.path = (0, $9haXP.path).join(this.dirname || "", basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   */ get extname() {
        return typeof this.path === "string" ? (0, $9haXP.path).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */ set extname(extname) {
        $ebdb906eb43ac433$var$assertPart(extname, "extname");
        $ebdb906eb43ac433$var$assertPath(this.dirname, "extname");
        if (extname) {
            if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error("`extname` must start with `.`");
            if (extname.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
        }
        this.path = (0, $9haXP.path).join(this.dirname, this.stem + (extname || ""));
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */ get stem() {
        return typeof this.path === "string" ? (0, $9haXP.path).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set stem(stem) {
        $ebdb906eb43ac433$var$assertNonEmpty(stem, "stem");
        $ebdb906eb43ac433$var$assertPart(stem, "stem");
        this.path = (0, $9haXP.path).join(this.dirname || "", stem + (this.extname || ""));
    }
    /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        return (this.value || "").toString(encoding || undefined);
    }
    /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(reason, place, origin) {
        const message = new (0, $bpyKL.VFileMessage)(reason, place, origin);
        if (this.path) {
            message.name = this.path + ":" + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = null;
        return message;
    }
    /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */ fail(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = true;
        throw message;
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {void}
 *   Nothing.
 */ function $ebdb906eb43ac433$var$assertPart(part, name) {
    if (part && part.includes((0, $9haXP.path).sep)) throw new Error("`" + name + "` cannot be a path: did not expect `" + (0, $9haXP.path).sep + "`");
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $ebdb906eb43ac433$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $ebdb906eb43ac433$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}
/**
 * Assert `value` is a buffer.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Buffer}
 *   Whether `value` is a Node.js buffer.
 */ function $ebdb906eb43ac433$var$buffer(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7B5Ea)))(value);
}

});
parcelRegister("7B5Ea", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};

});

parcelRegister("bpyKL", function(module, exports) {

$parcel$export(module.exports, "VFileMessage", () => $84ecfcc79391545c$export$752e5c445fe834ef);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ 
var $f9WaX = parcelRequire("f9WaX");
class $84ecfcc79391545c$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // To do: next major: expose `undefined` everywhere instead of `null`.
    constructor(reason, place, origin){
        /** @type {[string | null, string | null]} */ const parts = [
            null,
            null
        ];
        /** @type {Position} */ let position = {
            // @ts-expect-error: we always follows the structure of `position`.
            start: {
                line: null,
                column: null
            },
            // @ts-expect-error: "
            end: {
                line: null,
                column: null
            }
        };
        super();
        if (typeof place === "string") {
            origin = place;
            place = undefined;
        }
        if (typeof origin === "string") {
            const index = origin.indexOf(":");
            if (index === -1) parts[1] = origin;
            else {
                parts[0] = origin.slice(0, index);
                parts[1] = origin.slice(index + 1);
            }
        }
        if (place) {
            // Node.
            if ("type" in place || "position" in place) {
                if (place.position) // To do: next major: deep clone.
                // @ts-expect-error: looks like a position.
                position = place.position;
            } else if ("start" in place || "end" in place) // @ts-expect-error: looks like a position.
            // To do: next major: deep clone.
            position = place;
            else if ("line" in place || "column" in place) // To do: next major: deep clone.
            position.start = place;
        }
        // Fields from `Error`.
        /**
     * Serialized positional info of error.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $f9WaX.stringifyPosition)(place) || "1:1";
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = typeof reason === "object" ? reason.message : reason;
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = "";
        if (typeof reason === "object" && reason.stack) this.stack = reason.stack;
        /**
     * Reason for message.
     *
     * > 👉 **Note**: you should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /* eslint-disable no-unused-expressions */ /**
     * State of problem.
     *
     * * `true` — marks associated file as no longer processable (error)
     * * `false` — necessitates a (potential) change (warning)
     * * `null | undefined` — for things that might not need changing (info)
     *
     * @type {boolean | null | undefined}
     */ this.fatal;
        /**
     * Starting line of error.
     *
     * @type {number | null}
     */ this.line = position.start.line;
        /**
     * Starting column of error.
     *
     * @type {number | null}
     */ this.column = position.start.column;
        /**
     * Full unist position.
     *
     * @type {Position | null}
     */ this.position = position;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | null}
     */ this.source = parts[0];
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | null}
     */ this.ruleId = parts[1];
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | null}
     */ this.file;
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | null}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | null}
     */ this.expected;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | null}
     */ this.url;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | null}
     */ this.note;
    /* eslint-enable no-unused-expressions */ }
}
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.file = "";
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.name = "";
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.reason = "";
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.message = "";
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.stack = "";
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.fatal = null;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.column = null;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.line = null;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.source = null;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.ruleId = null;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.position = null;

});
parcelRegister("f9WaX", function(module, exports) {

$parcel$export(module.exports, "stringifyPosition", () => $b094d2c4d032c594$export$c304dd45fe166145);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Position | PositionLike | Point | PointLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $b094d2c4d032c594$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ("position" in value || "type" in value) return $b094d2c4d032c594$var$position(value.position);
    // Position.
    if ("start" in value || "end" in value) return $b094d2c4d032c594$var$position(value);
    // Point.
    if ("line" in value || "column" in value) return $b094d2c4d032c594$var$point(value);
    // ?
    return "";
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $b094d2c4d032c594$var$point(point) {
    return $b094d2c4d032c594$var$index(point && point.line) + ":" + $b094d2c4d032c594$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $b094d2c4d032c594$var$position(pos) {
    return $b094d2c4d032c594$var$point(pos && pos.start) + "-" + $b094d2c4d032c594$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $b094d2c4d032c594$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}

});


parcelRegister("9haXP", function(module, exports) {

$parcel$export(module.exports, "path", () => $6c0e34cf2f183349$export$bb654e07daaf8c3a);
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $6c0e34cf2f183349$export$bb654e07daaf8c3a = {
    basename: $6c0e34cf2f183349$var$basename,
    dirname: $6c0e34cf2f183349$var$dirname,
    extname: $6c0e34cf2f183349$var$extname,
    join: $6c0e34cf2f183349$var$join,
    sep: "/"
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $6c0e34cf2f183349$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    $6c0e34cf2f183349$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? "" : path.slice(start, end);
    }
    if (ext === path) return "";
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $6c0e34cf2f183349$var$dirname(path) {
    $6c0e34cf2f183349$var$assertPath(path);
    if (path.length === 0) return ".";
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? "/" : "." : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? "//" : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $6c0e34cf2f183349$var$extname(path) {
    $6c0e34cf2f183349$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $6c0e34cf2f183349$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $6c0e34cf2f183349$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + "/" + segments[index];
    }
    return joined === undefined ? "." : $6c0e34cf2f183349$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $6c0e34cf2f183349$var$normalize(path) {
    $6c0e34cf2f183349$var$assertPath(path);
    const absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $6c0e34cf2f183349$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = ".";
    if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += "/";
    return absolute ? "/" + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $6c0e34cf2f183349$var$normalizeString(path, allowAboveRoot) {
    let result = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf("/");
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = "";
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = "";
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + "/.." : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += "/" + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $6c0e34cf2f183349$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 

});

parcelRegister("4lnqT", function(module, exports) {

$parcel$export(module.exports, "proc", () => $329b4cd6854e87dd$export$97a5aaf482767187);
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $329b4cd6854e87dd$export$97a5aaf482767187 = {
    cwd: $329b4cd6854e87dd$var$cwd
};
function $329b4cd6854e87dd$var$cwd() {
    return "/";
}

});

parcelRegister("dzJSz", function(module, exports) {

$parcel$export(module.exports, "urlToPath", () => $028cf007d1b71fb0$export$9b2b676c902de799);
$parcel$export(module.exports, "isUrl", () => (parcelRequire("k7DYN")).isUrl);
/// <reference lib="dom" />

var $k7DYN = parcelRequire("k7DYN");
function $028cf007d1b71fb0$export$9b2b676c902de799(path) {
    if (typeof path === "string") path = new URL(path);
    else if (!(0, $k7DYN.isUrl)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + "`");
        error.code = "ERR_INVALID_ARG_TYPE";
        throw error;
    }
    if (path.protocol !== "file:") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError("The URL must be of scheme file");
        error.code = "ERR_INVALID_URL_SCHEME";
        throw error;
    }
    return $028cf007d1b71fb0$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $028cf007d1b71fb0$var$getPathFromURLPosix(url) {
    if (url.hostname !== "") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = "ERR_INVALID_FILE_URL_HOST";
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.charCodeAt(index) === 37 /* `%` */  && pathname.charCodeAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.charCodeAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError("File URL path must not include encoded / characters");
            error.code = "ERR_INVALID_FILE_URL_PATH";
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}

});
parcelRegister("k7DYN", function(module, exports) {

$parcel$export(module.exports, "isUrl", () => $ea6379392cbaeecd$export$8304a22d431f958);
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */ /**
 * Check if `fileUrlOrPath` looks like a URL.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function $ea6379392cbaeecd$export$8304a22d431f958(fileUrlOrPath) {
    return fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && // @ts-expect-error: indexable.
    fileUrlOrPath.href && // @ts-expect-error: indexable.
    fileUrlOrPath.origin;
}

});



parcelRegister("hBHqC", function(module, exports) {

$parcel$export(module.exports, "unified", () => $cd17945441716b11$export$7cc1b2fe10c52bb);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */ 
var $knL6O = parcelRequire("knL6O");

var $7B5Ea = parcelRequire("7B5Ea");

var $1XwqA = parcelRequire("1XwqA");

var $lJ4VN = parcelRequire("lJ4VN");

var $gL3sl = parcelRequire("gL3sl");

var $kfsOU = parcelRequire("kfsOU");
const $cd17945441716b11$export$7cc1b2fe10c52bb = $cd17945441716b11$var$base().freeze();
const $cd17945441716b11$var$own = {}.hasOwnProperty;
// Function to create the first processor.
/**
 * @returns {Processor}
 */ function $cd17945441716b11$var$base() {
    const transformers = (0, $gL3sl.trough)();
    /** @type {Processor['attachers']} */ const attachers = [];
    /** @type {Record<string, unknown>} */ let namespace = {};
    /** @type {boolean|undefined} */ let frozen;
    let freezeIndex = -1;
    // Data management.
    // @ts-expect-error: overloads are handled.
    processor.data = data;
    processor.Parser = undefined;
    processor.Compiler = undefined;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    // @ts-expect-error: overloads are handled.
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    // @ts-expect-error: overloads are handled.
    processor.run = run;
    processor.runSync = runSync;
    // @ts-expect-error: overloads are handled.
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    /** @type {Processor} */ function processor() {
        const destination = $cd17945441716b11$var$base();
        let index = -1;
        while(++index < attachers.length)destination.use(...attachers[index]);
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($1XwqA)))(true, {}, namespace));
        return destination;
    }
    /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */ function data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $cd17945441716b11$var$assertUnfrozen("data", frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $cd17945441716b11$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $cd17945441716b11$var$assertUnfrozen("data", frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    /** @type {Processor['freeze']} */ function freeze() {
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            const [attacher, ...options] = attachers[freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            /** @type {Transformer|void} */ const transformer = attacher.call(processor, ...options);
            if (typeof transformer === "function") transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Number.POSITIVE_INFINITY;
        return processor;
    }
    /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */ function use(value, ...options) {
        /** @type {Record<string, unknown>|undefined} */ let settings;
        $cd17945441716b11$var$assertUnfrozen("use", frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin(value, ...options);
        else if (typeof value === "object") {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError("Expected usable value, not `" + value + "`");
        if (settings) namespace.settings = Object.assign(namespace.settings || {}, settings);
        return processor;
        /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */ function add(value) {
            if (typeof value === "function") addPlugin(value);
            else if (typeof value === "object") {
                if (Array.isArray(value)) {
                    const [plugin, ...options] = value;
                    addPlugin(plugin, ...options);
                } else addPreset(value);
            } else throw new TypeError("Expected usable value, not `" + value + "`");
        }
        /**
     * @param {Preset} result
     * @returns {void}
     */ function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = Object.assign(settings || {}, result.settings);
        }
        /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
        }
        /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */ function addPlugin(plugin, value) {
            let index = -1;
            /** @type {Processor['attachers'][number]|undefined} */ let entry;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entry = attachers[index];
                break;
            }
            if (entry) {
                if ((0, $lJ4VN.default)(entry[1]) && (0, $lJ4VN.default)(value)) value = (0, (/*@__PURE__*/$parcel$interopDefault($1XwqA)))(true, entry[1], value);
                entry[1] = value;
            } else // @ts-expect-error: fine.
            attachers.push([
                ...arguments
            ]);
        }
    }
    /** @type {Processor['parse']} */ function parse(doc) {
        processor.freeze();
        const file = $cd17945441716b11$var$vfile(doc);
        const Parser = processor.Parser;
        $cd17945441716b11$var$assertParser("parse", Parser);
        if ($cd17945441716b11$var$newable(Parser, "parse")) // @ts-expect-error: `newable` checks this.
        return new Parser(String(file), file).parse();
        // @ts-expect-error: `newable` checks this.
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    /** @type {Processor['stringify']} */ function stringify(node, doc) {
        processor.freeze();
        const file = $cd17945441716b11$var$vfile(doc);
        const Compiler = processor.Compiler;
        $cd17945441716b11$var$assertCompiler("stringify", Compiler);
        $cd17945441716b11$var$assertNode(node);
        if ($cd17945441716b11$var$newable(Compiler, "compile")) // @ts-expect-error: `newable` checks this.
        return new Compiler(node, file).compile();
        // @ts-expect-error: `newable` checks this.
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */ function run(node, doc, callback) {
        $cd17945441716b11$var$assertNode(node);
        processor.freeze();
        if (!callback && typeof doc === "function") {
            callback = doc;
            doc = undefined;
        }
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
            transformers.run(node, $cd17945441716b11$var$vfile(doc), done);
            /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */ function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, tree, file);
            }
        }
    }
    /** @type {Processor['runSync']} */ function runSync(node, file) {
        /** @type {Node|undefined} */ let result;
        /** @type {boolean|undefined} */ let complete;
        processor.run(node, file, done);
        $cd17945441716b11$var$assertDone("runSync", "run", complete);
        // @ts-expect-error: we either bailed on an error or have a tree.
        return result;
        /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */ function done(error, tree) {
            (0, $knL6O.bail)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */ function process(doc, callback) {
        processor.freeze();
        $cd17945441716b11$var$assertParser("process", processor.Parser);
        $cd17945441716b11$var$assertCompiler("process", processor.Compiler);
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            const file = $cd17945441716b11$var$vfile(doc);
            processor.run(processor.parse(file), file, (error, tree, file)=>{
                if (error || !tree || !file) done(error);
                else {
                    /** @type {unknown} */ const result = processor.stringify(tree, file);
                    if (result === undefined || result === null) ;
                    else if ($cd17945441716b11$var$looksLikeAVFileValue(result)) file.value = result;
                    else file.result = result;
                    done(error, file);
                }
            });
            /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */ function done(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, file);
            }
        }
    }
    /** @type {Processor['processSync']} */ function processSync(doc) {
        /** @type {boolean|undefined} */ let complete;
        processor.freeze();
        $cd17945441716b11$var$assertParser("processSync", processor.Parser);
        $cd17945441716b11$var$assertCompiler("processSync", processor.Compiler);
        const file = $cd17945441716b11$var$vfile(doc);
        processor.process(file, done);
        $cd17945441716b11$var$assertDone("processSync", "process", complete);
        return file;
        /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */ function done(error) {
            complete = true;
            (0, $knL6O.bail)(error);
        }
    }
}
/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */ function $cd17945441716b11$var$newable(value, name) {
    return typeof value === "function" && // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    ($cd17945441716b11$var$keys(value.prototype) || name in value.prototype);
}
/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */ function $cd17945441716b11$var$keys(value) {
    /** @type {string} */ let key;
    for(key in value){
        if ($cd17945441716b11$var$own.call(value, key)) return true;
    }
    return false;
}
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $cd17945441716b11$var$assertParser(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Parser`");
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $cd17945441716b11$var$assertCompiler(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Compiler`");
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $cd17945441716b11$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot call `" + name + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $cd17945441716b11$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $lJ4VN.default)(node) || typeof node.type !== "string") throw new TypeError("Expected node, got `" + node + "`");
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $cd17945441716b11$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}
/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */ function $cd17945441716b11$var$vfile(value) {
    return $cd17945441716b11$var$looksLikeAVFile(value) ? value : new (0, $kfsOU.VFile)(value);
}
/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */ function $cd17945441716b11$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === "object" && "message" in value && "messages" in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */ function $cd17945441716b11$var$looksLikeAVFileValue(value) {
    return typeof value === "string" || (0, (/*@__PURE__*/$parcel$interopDefault($7B5Ea)))(value);
}

});
parcelRegister("knL6O", function(module, exports) {

$parcel$export(module.exports, "bail", () => $ed6a7f7e034afcf2$export$dd911e13ecb11e05);
/**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $ed6a7f7e034afcf2$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}

});

parcelRegister("1XwqA", function(module, exports) {
"use strict";
var $16d474a0815e976d$var$hasOwn = Object.prototype.hasOwnProperty;
var $16d474a0815e976d$var$toStr = Object.prototype.toString;
var $16d474a0815e976d$var$defineProperty = Object.defineProperty;
var $16d474a0815e976d$var$gOPD = Object.getOwnPropertyDescriptor;
var $16d474a0815e976d$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $16d474a0815e976d$var$toStr.call(arr) === "[object Array]";
};
var $16d474a0815e976d$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $16d474a0815e976d$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $16d474a0815e976d$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $16d474a0815e976d$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $16d474a0815e976d$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $16d474a0815e976d$var$setProperty = function setProperty(target, options) {
    if ($16d474a0815e976d$var$defineProperty && options.name === "__proto__") $16d474a0815e976d$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $16d474a0815e976d$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$16d474a0815e976d$var$hasOwn.call(obj, name)) return void 0;
        else if ($16d474a0815e976d$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $16d474a0815e976d$var$gOPD(obj, name).value;
    }
    return obj[name];
};
module.exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $16d474a0815e976d$var$getProperty(target, name);
            copy = $16d474a0815e976d$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($16d474a0815e976d$var$isPlainObject(copy) || (copyIsArray = $16d474a0815e976d$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $16d474a0815e976d$var$isArray(src) ? src : [];
                    } else clone = src && $16d474a0815e976d$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $16d474a0815e976d$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $16d474a0815e976d$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};

});

parcelRegister("lJ4VN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd11a02fceb57d58$export$2e2bcd8739ae039);
function $fd11a02fceb57d58$export$2e2bcd8739ae039(value) {
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}

});

parcelRegister("gL3sl", function(module, exports) {

$parcel$export(module.exports, "trough", () => $c333b7763c7c24e2$export$91b56f5ca106aa43);
// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.
/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */ function $c333b7763c7c24e2$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== "function") throw new TypeError("Expected function as last argument, not " + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $c333b7763c7c24e2$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== "function") throw new TypeError("Expected `middelware` to be a function, not " + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $c333b7763c7c24e2$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result && result.then && typeof result.then === "function") result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}

});


parcelRegister("3F7xF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aab0d1dd6b1383c$export$2e2bcd8739ae039);
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */ 
var $32C5u = parcelRequire("32C5u");
function $2aab0d1dd6b1383c$export$2e2bcd8739ae039(options) {
    /** @type {import('unified').ParserFunction<Root>} */ const parser = (doc)=>{
        // Assume options.
        const settings = /** @type {Options} */ this.data("settings");
        return (0, $32C5u.fromMarkdown)(doc, Object.assign({}, settings, options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: this.data("micromarkExtensions") || [],
            mdastExtensions: this.data("fromMarkdownExtensions") || []
        }));
    };
    Object.assign(this, {
        Parser: parser
    });
}

});
parcelRegister("32C5u", function(module, exports) {

$parcel$export(module.exports, "fromMarkdown", () => $236f1a66ed1dd212$export$d744d789c09bfde6);
/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').StaticPhrasingContent} StaticPhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Root | Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 *
 * @typedef {Omit<UnistParent, 'type' | 'children'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | undefined | null | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Node | Fragment>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {<Key extends keyof CompileData>(key: Key) => CompileData[Key]} getData
 *   Get data from the key/value store.
 * @property {<Key extends keyof CompileData>(key: Key, value?: CompileData[Key]) => void} setData
 *   Set data into the key/value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<Kind extends Node>(this: CompileContext, node: Kind, token: Token, onError?: OnEnterError) => Kind} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ // To do: micromark: create a registry of tokens?
// To do: next major: don’t return given `Node` from `enter`.
// To do: next major: remove setter/getter.

var $apdnY = parcelRequire("apdnY");

var $2JaIP = parcelRequire("2JaIP");

var $hFzKD = parcelRequire("hFzKD");

var $6Jw5n = parcelRequire("6Jw5n");

var $34rZa = parcelRequire("34rZa");

var $1lC1m = parcelRequire("1lC1m");

var $9HErY = parcelRequire("9HErY");

var $gxs7E = parcelRequire("gxs7E");

var $f9WaX = parcelRequire("f9WaX");
const $236f1a66ed1dd212$var$own = {}.hasOwnProperty;
const $236f1a66ed1dd212$export$d744d789c09bfde6 = /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */ /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */ function(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return $236f1a66ed1dd212$var$compiler(options)((0, $6Jw5n.postprocess)((0, $2JaIP.parse)(options).document().write((0, $hFzKD.preprocess)()(value, encoding, true))));
};
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $236f1a66ed1dd212$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $236f1a66ed1dd212$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: "root",
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === "enter") listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($236f1a66ed1dd212$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $236f1a66ed1dd212$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $236f1a66ed1dd212$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $236f1a66ed1dd212$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            if (event[1].type === "listUnordered" || event[1].type === "listOrdered" || event[1].type === "blockQuote") {
                if (event[0] === "enter") containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === "lineEndingBlank") {
                if (event[0] === "enter") {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === "linePrefix" || event[1].type === "listItemValue" || event[1].type === "listItemMarker" || event[1].type === "listItemPrefix" || event[1].type === "listItemPrefixWhitespace") ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === "exit") continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        "exit",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    listItem = {
                        type: "listItem",
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    // @ts-expect-error: `listItem` is most definitely defined, TS...
                    events.splice(index, 0, [
                        "enter",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Set data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @param {CompileData[Key]} [value]
   *   New value.
   * @returns {void}
   *   Nothing.
   */ function setData(key, value) {
        data[key] = value;
    }
    /**
   * Get data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @returns {CompileData[Key]}
   *   Value.
   */ function getData(key) {
        return data[key];
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Node} create
   *   Create a node.
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {void}
   */ function buffer() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    /**
   * @template {Node} Kind
   *   Node type.
   * @this {CompileContext}
   *   Context.
   * @param {Kind} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {Kind}
   *   The given node.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
        parent.children.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        // @ts-expect-error: `end` will be patched later.
        node.position = {
            start: $236f1a66ed1dd212$var$point(token.start)
        };
        return node;
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {Node}
   *   The closed node.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error("Cannot close `" + token.type + "` (" + (0, $f9WaX.stringifyPosition)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $236f1a66ed1dd212$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $236f1a66ed1dd212$var$point(token.end);
        return node;
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $apdnY.toString)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        setData("expectingFirstListItemValue", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData("expectingFirstListItemValue")) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            setData("expectingFirstListItemValue");
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData("flowCodeInside")) return;
        this.buffer();
        setData("flowCodeInside", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        setData("flowCodeInside");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, "");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $9HErY.normalizeIdentifier)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData("setextHeadingSlurpLineEnding", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        setData("setextHeadingSlurpLineEnding");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        let tail = node.children[node.children.length - 1];
        if (!tail || tail.type !== "text") {
            // Add a new text node.
            tail = text();
            // @ts-expect-error: we’ll add `end` later.
            tail.position = {
                start: $236f1a66ed1dd212$var$point(token.start)
            };
            // @ts-expect-error: Assume `parent` accepts `text`.
            node.children.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $236f1a66ed1dd212$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData("atHardBreak")) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $236f1a66ed1dd212$var$point(token.end);
            setData("atHardBreak");
            return;
        }
        if (!getData("setextHeadingSlurpLineEnding") && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        setData("atHardBreak", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $1lC1m.decodeString)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $9HErY.normalizeIdentifier)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        setData("inReference", true);
        if (node.type === "link") {
            /** @type {Array<StaticPhrasingContent>} */ // @ts-expect-error: Assume static phrasing content.
            const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        setData("inReference");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        setData("referenceType", "collapsed");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $9HErY.normalizeIdentifier)(this.sliceSerialize(token)).toLowerCase();
        setData("referenceType", "full");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        setData("characterReferenceType", token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = getData("characterReferenceType");
        /** @type {string} */ let value;
        if (type) {
            value = (0, $34rZa.decodeNumericCharacterReference)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            setData("characterReferenceType");
        } else {
            const result = (0, $gxs7E.decodeNamedCharacterReference)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $236f1a66ed1dd212$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = "mailto:" + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: "blockquote",
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: "emphasis",
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        // @ts-expect-error `depth` will be set later.
        return {
            type: "heading",
            depth: undefined,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: "break"
        };
    }
    /** @returns {HTML} */ function html() {
        return {
            type: "html",
            value: ""
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: "list",
            ordered: token.type === "listOrdered",
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: "listItem",
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: "paragraph",
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: "strong",
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: "text",
            value: ""
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: "thematicBreak"
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $236f1a66ed1dd212$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Extension | Array<Extension>>} extensions
 * @returns {void}
 */ function $236f1a66ed1dd212$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $236f1a66ed1dd212$var$configure(combined, value);
        else $236f1a66ed1dd212$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {void}
 */ function $236f1a66ed1dd212$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($236f1a66ed1dd212$var$own.call(extension, key)) {
        if (key === "canContainEols") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "transforms") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "enter" || key === "exit") {
            const right = extension[key];
            if (right) Object.assign(combined[key], right);
        }
    }
}
/** @type {OnEnterError} */ function $236f1a66ed1dd212$var$defaultOnError(left, right) {
    if (left) throw new Error("Cannot close `" + left.type + "` (" + (0, $f9WaX.stringifyPosition)({
        start: left.start,
        end: left.end
    }) + "): a different token (`" + right.type + "`, " + (0, $f9WaX.stringifyPosition)({
        start: right.start,
        end: right.end
    }) + ") is open");
    else throw new Error("Cannot close document, a token (`" + right.type + "`, " + (0, $f9WaX.stringifyPosition)({
        start: right.start,
        end: right.end
    }) + ") is still open");
}

});
parcelRegister("apdnY", function(module, exports) {

$parcel$export(module.exports, "toString", () => $79369f5237095e86$export$f84e8e69fd4488a5);
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s.
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML.
 */ /** @type {Options} */ const $79369f5237095e86$var$emptyOptions = {};
function $79369f5237095e86$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $79369f5237095e86$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === "boolean" ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === "boolean" ? settings.includeHtml : true;
    return $79369f5237095e86$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $79369f5237095e86$var$one(value, includeImageAlt, includeHtml) {
    if ($79369f5237095e86$var$node(value)) {
        if ("value" in value) return value.type === "html" && !includeHtml ? "" : value.value;
        if (includeImageAlt && "alt" in value && value.alt) return value.alt;
        if ("children" in value) return $79369f5237095e86$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $79369f5237095e86$var$all(value, includeImageAlt, includeHtml);
    return "";
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $79369f5237095e86$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $79369f5237095e86$var$one(values[index], includeImageAlt, includeHtml);
    return result.join("");
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Node}
 *   Whether `value` is a node.
 */ function $79369f5237095e86$var$node(value) {
    return Boolean(value && typeof value === "object");
}

});

parcelRegister("2JaIP", function(module, exports) {

$parcel$export(module.exports, "parse", () => $1fc819ea965a3f81$export$98e6a39c04603d36);
/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */ 
var $1BzS9 = parcelRequire("1BzS9");

var $1YYHd = parcelRequire("1YYHd");

var $4vIRz = parcelRequire("4vIRz");

var $jugKX = parcelRequire("jugKX");

var $2JBld = parcelRequire("2JBld");

var $6oDSH = parcelRequire("6oDSH");

var $8tRNW = parcelRequire("8tRNW");
function $1fc819ea965a3f81$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $1BzS9.combineExtensions)([
        $8tRNW,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $1YYHd.content)),
        document: create((0, $4vIRz.document)),
        flow: create((0, $jugKX.flow)),
        string: create((0, $2JBld.string)),
        text: create((0, $2JBld.text))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $6oDSH.createTokenizer)(parser, initial, from);
        }
    }
}

});
parcelRegister("1BzS9", function(module, exports) {

$parcel$export(module.exports, "combineExtensions", () => $12b512a5203a7cce$export$86a865d89ef3c690);
$parcel$export(module.exports, "combineHtmlExtensions", () => $12b512a5203a7cce$export$eaf8c406dfb0a620);
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */ 
var $Ux2lp = parcelRequire("Ux2lp");
const $12b512a5203a7cce$var$hasOwnProperty = {}.hasOwnProperty;
function $12b512a5203a7cce$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$12b512a5203a7cce$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $12b512a5203a7cce$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $12b512a5203a7cce$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$12b512a5203a7cce$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $12b512a5203a7cce$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {void}
 */ function $12b512a5203a7cce$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === "after" ? existing : before).push(list[index]);
    (0, $Ux2lp.splice)(existing, 0, 0, before);
}
function $12b512a5203a7cce$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$12b512a5203a7cce$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $12b512a5203a7cce$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $12b512a5203a7cce$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}

});
parcelRegister("Ux2lp", function(module, exports) {

$parcel$export(module.exports, "splice", () => $0a9edb7ff3ef159f$export$869882364835d202);
$parcel$export(module.exports, "push", () => $0a9edb7ff3ef159f$export$4cbf152802aa238);
/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {void}
 *   Nothing.
 */ function $0a9edb7ff3ef159f$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $0a9edb7ff3ef159f$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $0a9edb7ff3ef159f$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}

});


parcelRegister("1YYHd", function(module, exports) {

$parcel$export(module.exports, "content", () => $171a79fbb1402b9a$export$a7db06668cad9adb);
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
const $171a79fbb1402b9a$export$a7db06668cad9adb = {
    tokenize: $171a79fbb1402b9a$var$initializeContent
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $171a79fbb1402b9a$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $8GWoH.factorySpace)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}

});
parcelRegister("8GWoH", function(module, exports) {

$parcel$export(module.exports, "factorySpace", () => $653f8b80711d97d0$export$ae105c1eb063a0a2);
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
var $5Lprs = parcelRequire("5Lprs");
function $653f8b80711d97d0$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $5Lprs.markdownSpace)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}

});
parcelRegister("5Lprs", function(module, exports) {

$parcel$export(module.exports, "asciiAlpha", () => $432513c48b12fdfc$export$d65d6b62c24d5436);
$parcel$export(module.exports, "asciiAlphanumeric", () => $432513c48b12fdfc$export$75c76db11865a9f4);
$parcel$export(module.exports, "asciiAtext", () => $432513c48b12fdfc$export$4397998b34fe597d);
$parcel$export(module.exports, "asciiControl", () => $432513c48b12fdfc$export$67dbf494fc8394df);
$parcel$export(module.exports, "asciiDigit", () => $432513c48b12fdfc$export$ca8b5b1a6c320e6e);
$parcel$export(module.exports, "asciiHexDigit", () => $432513c48b12fdfc$export$eca2752363989806);
$parcel$export(module.exports, "asciiPunctuation", () => $432513c48b12fdfc$export$35794a7d1db99380);
$parcel$export(module.exports, "markdownLineEnding", () => $432513c48b12fdfc$export$34a1dff1c0936953);
$parcel$export(module.exports, "markdownLineEndingOrSpace", () => $432513c48b12fdfc$export$a30284361b3814b7);
$parcel$export(module.exports, "markdownSpace", () => $432513c48b12fdfc$export$2c6cf65c1127992a);
$parcel$export(module.exports, "unicodePunctuation", () => $432513c48b12fdfc$export$aa04114dd888a7a0);
$parcel$export(module.exports, "unicodeWhitespace", () => $432513c48b12fdfc$export$a0ff789c034ffdf4);
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
var $1Vlly = parcelRequire("1Vlly");
const $432513c48b12fdfc$export$d65d6b62c24d5436 = $432513c48b12fdfc$var$regexCheck(/[A-Za-z]/);
const $432513c48b12fdfc$export$75c76db11865a9f4 = $432513c48b12fdfc$var$regexCheck(/[\dA-Za-z]/);
const $432513c48b12fdfc$export$4397998b34fe597d = $432513c48b12fdfc$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $432513c48b12fdfc$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $432513c48b12fdfc$export$ca8b5b1a6c320e6e = $432513c48b12fdfc$var$regexCheck(/\d/);
const $432513c48b12fdfc$export$eca2752363989806 = $432513c48b12fdfc$var$regexCheck(/[\dA-Fa-f]/);
const $432513c48b12fdfc$export$35794a7d1db99380 = $432513c48b12fdfc$var$regexCheck(/[!-/:-@[-`{-~]/);
function $432513c48b12fdfc$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $432513c48b12fdfc$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $432513c48b12fdfc$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $432513c48b12fdfc$export$aa04114dd888a7a0 = $432513c48b12fdfc$var$regexCheck((0, $1Vlly.unicodePunctuationRegex));
const $432513c48b12fdfc$export$a0ff789c034ffdf4 = $432513c48b12fdfc$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */ function $432513c48b12fdfc$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && regex.test(String.fromCharCode(code));
    }
}

});
parcelRegister("1Vlly", function(module, exports) {

$parcel$export(module.exports, "unicodePunctuationRegex", () => $166bac51b6e2a8af$export$85b5101f24802e8c);
// This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
/**
 * Regular expression that matches a unicode punctuation character.
 */ const $166bac51b6e2a8af$export$85b5101f24802e8c = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;

});




parcelRegister("4vIRz", function(module, exports) {

$parcel$export(module.exports, "document", () => $348cdb85d1aeadd1$export$5a7bfc01df82fcd1);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");

var $Ux2lp = parcelRequire("Ux2lp");
const $348cdb85d1aeadd1$export$5a7bfc01df82fcd1 = {
    tokenize: $348cdb85d1aeadd1$var$initializeDocument
};
/** @type {Construct} */ const $348cdb85d1aeadd1$var$containerConstruct = {
    tokenize: $348cdb85d1aeadd1$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $348cdb85d1aeadd1$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $Ux2lp.splice)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($348cdb85d1aeadd1$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($348cdb85d1aeadd1$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            contentType: "flow",
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {void}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $Ux2lp.splice)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {void}
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $348cdb85d1aeadd1$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $8GWoH.factorySpace)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4);
}

});

parcelRegister("jugKX", function(module, exports) {

$parcel$export(module.exports, "flow", () => $e2fdd11cbe455c51$export$ccc7b0636abaffc3);
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ 
var $eRfeJ = parcelRequire("eRfeJ");
var $j7la5 = parcelRequire("j7la5");

var $8GWoH = parcelRequire("8GWoH");

const $e2fdd11cbe455c51$export$ccc7b0636abaffc3 = {
    tokenize: $e2fdd11cbe455c51$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $e2fdd11cbe455c51$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $eRfeJ.blankLine), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $8GWoH.factorySpace)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $j7la5.content), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}

});
parcelRegister("eRfeJ", function(module, exports) {

$parcel$export(module.exports, "blankLine", () => $ad11d598ddddec2e$export$d50d28ce3ab2a612);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
const $ad11d598ddddec2e$export$d50d28ce3ab2a612 = {
    tokenize: $ad11d598ddddec2e$var$tokenizeBlankLine,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ad11d598ddddec2e$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $5Lprs.markdownLineEnding)(code) ? ok(code) : nok(code);
    }
}

});

parcelRegister("j7la5", function(module, exports) {

$parcel$export(module.exports, "content", () => $deaf16079a1807fb$export$a7db06668cad9adb);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");

var $iNbDn = parcelRequire("iNbDn");
const $deaf16079a1807fb$export$a7db06668cad9adb = {
    tokenize: $deaf16079a1807fb$var$tokenizeContent,
    resolve: $deaf16079a1807fb$var$resolveContent
};
/** @type {Construct} */ const $deaf16079a1807fb$var$continuationConstruct = {
    tokenize: $deaf16079a1807fb$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $deaf16079a1807fb$var$resolveContent(events) {
    (0, $iNbDn.subtokenize)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $deaf16079a1807fb$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $5Lprs.markdownLineEnding)(code)) return effects.check($deaf16079a1807fb$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $deaf16079a1807fb$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $8GWoH.factorySpace)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}

});
parcelRegister("iNbDn", function(module, exports) {

$parcel$export(module.exports, "subtokenize", () => $dae5d3de466990fa$export$12949d1dd00fddf4);
/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */ 
var $Ux2lp = parcelRequire("Ux2lp");
function $dae5d3de466990fa$export$12949d1dd00fddf4(events) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index];
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === "enter") {
            if (event[1].contentType) {
                Object.assign(jumps, $dae5d3de466990fa$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === "enter") {
                        if (lineIndex) events[lineIndex][1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events[lineIndex][1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                (0, $Ux2lp.splice)(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $dae5d3de466990fa$var$subcontent(events, eventIndex) {
    const token = events[eventIndex][1];
    const context = events[eventIndex][2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === "exit" && childEvents[index - 1][0] === "enter" && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        (0, $Ux2lp.splice)(events, start, 2, slice);
    }
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}

});



parcelRegister("2JBld", function(module, exports) {

$parcel$export(module.exports, "resolver", () => $1fdcbfee479a4092$export$50397835cbfdbc24);
$parcel$export(module.exports, "string", () => $1fdcbfee479a4092$export$22b082955e083ec3);
$parcel$export(module.exports, "text", () => $1fdcbfee479a4092$export$6f093cfa640b7166);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ const $1fdcbfee479a4092$export$50397835cbfdbc24 = {
    resolveAll: $1fdcbfee479a4092$var$createResolver()
};
const $1fdcbfee479a4092$export$22b082955e083ec3 = $1fdcbfee479a4092$var$initializeFactory("string");
const $1fdcbfee479a4092$export$6f093cfa640b7166 = $1fdcbfee479a4092$var$initializeFactory("text");
/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */ function $1fdcbfee479a4092$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $1fdcbfee479a4092$var$createResolver(field === "text" ? $1fdcbfee479a4092$var$resolveAllLineSuffixes : undefined)
    };
    /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */ function $1fdcbfee479a4092$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $1fdcbfee479a4092$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === "string") {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    "enter",
                    token,
                    context
                ], [
                    "exit",
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}

});

parcelRegister("6oDSH", function(module, exports) {

$parcel$export(module.exports, "createTokenizer", () => $4a83eb91ec5d6b95$export$ae34f10ee4b29837);
/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @callback Restore
 * @returns {void}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */ 
var $5Lprs = parcelRequire("5Lprs");

var $Ux2lp = parcelRequire("Ux2lp");

var $8f02Z = parcelRequire("8f02Z");
function $4a83eb91ec5d6b95$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | void}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $Ux2lp.push)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $8f02Z.resolveAll)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $4a83eb91ec5d6b95$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $4a83eb91ec5d6b95$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { line: line, column: column, offset: offset, _index: _index, _bufferIndex: _bufferIndex } = point;
        return {
            line: line,
            column: column,
            offset: offset,
            _index: _index,
            _bufferIndex: _bufferIndex
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === "string") {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            "enter",
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            "exit",
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? handleListOfConstructs(constructs) : "tokenize" in constructs ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $Ux2lp.splice)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {void}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */ function $4a83eb91ec5d6b95$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === "string") view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */ function $4a83eb91ec5d6b95$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === "string") value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "	";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join("");
}

});
parcelRegister("8f02Z", function(module, exports) {

$parcel$export(module.exports, "resolveAll", () => $5fffc2d235733349$export$3ff61ec196ff408b);
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $5fffc2d235733349$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}

});


parcelRegister("8tRNW", function(module, exports) {

$parcel$export(module.exports, "document", () => $62cac499df3c25a0$export$5a7bfc01df82fcd1);
$parcel$export(module.exports, "contentInitial", () => $62cac499df3c25a0$export$5a2181fb44b58173);
$parcel$export(module.exports, "flowInitial", () => $62cac499df3c25a0$export$cf8bead395eff824);
$parcel$export(module.exports, "flow", () => $62cac499df3c25a0$export$ccc7b0636abaffc3);
$parcel$export(module.exports, "string", () => $62cac499df3c25a0$export$22b082955e083ec3);
$parcel$export(module.exports, "text", () => $62cac499df3c25a0$export$6f093cfa640b7166);
$parcel$export(module.exports, "insideSpan", () => $62cac499df3c25a0$export$d44f260a3f9b69f5);
$parcel$export(module.exports, "attentionMarkers", () => $62cac499df3c25a0$export$b9c0b60d74426aea);
$parcel$export(module.exports, "disable", () => $62cac499df3c25a0$export$e20fbacbb41798b);
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ 
var $eIIGZ = parcelRequire("eIIGZ");
var $807ia = parcelRequire("807ia");
var $acnAX = parcelRequire("acnAX");
var $7ITXU = parcelRequire("7ITXU");
var $hIELq = parcelRequire("hIELq");
var $2qoAc = parcelRequire("2qoAc");
var $eHPOy = parcelRequire("eHPOy");
var $1XgoW = parcelRequire("1XgoW");
var $ix9Ua = parcelRequire("ix9Ua");
var $1d2Fb = parcelRequire("1d2Fb");
var $e7bPJ = parcelRequire("e7bPJ");
var $aMDJK = parcelRequire("aMDJK");
var $fAOFU = parcelRequire("fAOFU");
var $2yvw6 = parcelRequire("2yvw6");
var $l3YSx = parcelRequire("l3YSx");
var $ifBjz = parcelRequire("ifBjz");
var $9shNq = parcelRequire("9shNq");
var $7twjg = parcelRequire("7twjg");
var $cfK44 = parcelRequire("cfK44");
var $eBJ0T = parcelRequire("eBJ0T");

var $2JBld = parcelRequire("2JBld");
const $62cac499df3c25a0$export$5a7bfc01df82fcd1 = {
    [42]: (0, $7twjg.list),
    [43]: (0, $7twjg.list),
    [45]: (0, $7twjg.list),
    [48]: (0, $7twjg.list),
    [49]: (0, $7twjg.list),
    [50]: (0, $7twjg.list),
    [51]: (0, $7twjg.list),
    [52]: (0, $7twjg.list),
    [53]: (0, $7twjg.list),
    [54]: (0, $7twjg.list),
    [55]: (0, $7twjg.list),
    [56]: (0, $7twjg.list),
    [57]: (0, $7twjg.list),
    [62]: (0, $acnAX.blockQuote)
};
const $62cac499df3c25a0$export$5a2181fb44b58173 = {
    [91]: (0, $ix9Ua.definition)
};
const $62cac499df3c25a0$export$cf8bead395eff824 = {
    [-2]: (0, $eHPOy.codeIndented),
    [-1]: (0, $eHPOy.codeIndented),
    [32]: (0, $eHPOy.codeIndented)
};
const $62cac499df3c25a0$export$ccc7b0636abaffc3 = {
    [35]: (0, $e7bPJ.headingAtx),
    [42]: (0, $eBJ0T.thematicBreak),
    [45]: [
        (0, $cfK44.setextUnderline),
        (0, $eBJ0T.thematicBreak)
    ],
    [60]: (0, $aMDJK.htmlFlow),
    [61]: (0, $cfK44.setextUnderline),
    [95]: (0, $eBJ0T.thematicBreak),
    [96]: (0, $2qoAc.codeFenced),
    [126]: (0, $2qoAc.codeFenced)
};
const $62cac499df3c25a0$export$22b082955e083ec3 = {
    [38]: (0, $hIELq.characterReference),
    [92]: (0, $7ITXU.characterEscape)
};
const $62cac499df3c25a0$export$6f093cfa640b7166 = {
    [-5]: (0, $9shNq.lineEnding),
    [-4]: (0, $9shNq.lineEnding),
    [-3]: (0, $9shNq.lineEnding),
    [33]: (0, $l3YSx.labelStartImage),
    [38]: (0, $hIELq.characterReference),
    [42]: (0, $eIIGZ.attention),
    [60]: [
        (0, $807ia.autolink),
        (0, $fAOFU.htmlText)
    ],
    [91]: (0, $ifBjz.labelStartLink),
    [92]: [
        (0, $1d2Fb.hardBreakEscape),
        (0, $7ITXU.characterEscape)
    ],
    [93]: (0, $2yvw6.labelEnd),
    [95]: (0, $eIIGZ.attention),
    [96]: (0, $1XgoW.codeText)
};
const $62cac499df3c25a0$export$d44f260a3f9b69f5 = {
    null: [
        (0, $eIIGZ.attention),
        (0, $2JBld.resolver)
    ]
};
const $62cac499df3c25a0$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $62cac499df3c25a0$export$e20fbacbb41798b = {
    null: []
};

});
parcelRegister("eIIGZ", function(module, exports) {

$parcel$export(module.exports, "attention", () => $ab77d7b684ccca7a$export$45b92471da762af7);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $Ux2lp = parcelRequire("Ux2lp");

var $i5TSH = parcelRequire("i5TSH");

var $8f02Z = parcelRequire("8f02Z");
const $ab77d7b684ccca7a$export$45b92471da762af7 = {
    name: "attention",
    tokenize: $ab77d7b684ccca7a$var$tokenizeAttention,
    resolveAll: $ab77d7b684ccca7a$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ function $ab77d7b684ccca7a$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $ab77d7b684ccca7a$var$movePoint(start, -use);
            $ab77d7b684ccca7a$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $Ux2lp.push)(nextEvents, [
                [
                    "enter",
                    events[open][1],
                    context
                ],
                [
                    "exit",
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $Ux2lp.push)(nextEvents, [
                [
                    "enter",
                    group,
                    context
                ],
                [
                    "enter",
                    openingSequence,
                    context
                ],
                [
                    "exit",
                    openingSequence,
                    context
                ],
                [
                    "enter",
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $Ux2lp.push)(nextEvents, (0, $8f02Z.resolveAll)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $Ux2lp.push)(nextEvents, [
                [
                    "exit",
                    text,
                    context
                ],
                [
                    "enter",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $Ux2lp.push)(nextEvents, [
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $Ux2lp.splice)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ab77d7b684ccca7a$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $i5TSH.classifyCharacter)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter("attentionSequence");
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit("attentionSequence");
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $i5TSH.classifyCharacter)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */ function $ab77d7b684ccca7a$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

});
parcelRegister("i5TSH", function(module, exports) {

$parcel$export(module.exports, "classifyCharacter", () => $d2c40a75b3c1060a$export$e3902bc0d835cad0);
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
var $5Lprs = parcelRequire("5Lprs");
function $d2c40a75b3c1060a$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $5Lprs.markdownLineEndingOrSpace)(code) || (0, $5Lprs.unicodeWhitespace)(code)) return 1;
    if ((0, $5Lprs.unicodePunctuation)(code)) return 2;
}

});


parcelRegister("807ia", function(module, exports) {

$parcel$export(module.exports, "autolink", () => $5d33fad6991aa1ad$export$17ddf85e4c916ad6);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $5Lprs = parcelRequire("5Lprs");
const $5d33fad6991aa1ad$export$17ddf85e4c916ad6 = {
    name: "autolink",
    tokenize: $5d33fad6991aa1ad$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5d33fad6991aa1ad$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $5Lprs.asciiAlphanumeric)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $5Lprs.asciiAlphanumeric)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $5Lprs.asciiControl)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $5Lprs.asciiAtext)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $5Lprs.asciiAlphanumeric)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $5Lprs.asciiAlphanumeric)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

});

parcelRegister("acnAX", function(module, exports) {

$parcel$export(module.exports, "blockQuote", () => $76cd53d8c5b717c4$export$200dcd0a5903c968);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
const $76cd53d8c5b717c4$export$200dcd0a5903c968 = {
    name: "blockQuote",
    tokenize: $76cd53d8c5b717c4$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $76cd53d8c5b717c4$var$tokenizeBlockQuoteContinuation
    },
    exit: $76cd53d8c5b717c4$var$exit
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $76cd53d8c5b717c4$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $76cd53d8c5b717c4$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $5Lprs.markdownSpace)(code)) // Always populated by defaults.
        return (0, $8GWoH.factorySpace)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($76cd53d8c5b717c4$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $76cd53d8c5b717c4$var$exit(effects) {
    effects.exit("blockQuote");
}

});

parcelRegister("7ITXU", function(module, exports) {

$parcel$export(module.exports, "characterEscape", () => $59f80dfce403f5de$export$2005478564e78d96);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $5Lprs = parcelRequire("5Lprs");
const $59f80dfce403f5de$export$2005478564e78d96 = {
    name: "characterEscape",
    tokenize: $59f80dfce403f5de$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $59f80dfce403f5de$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $5Lprs.asciiPunctuation)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

});

parcelRegister("hIELq", function(module, exports) {

$parcel$export(module.exports, "characterReference", () => $ce662a9402db28e3$export$e31905600aaf3d8e);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $gxs7E = parcelRequire("gxs7E");

var $5Lprs = parcelRequire("5Lprs");
const $ce662a9402db28e3$export$e31905600aaf3d8e = {
    name: "characterReference",
    tokenize: $ce662a9402db28e3$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ce662a9402db28e3$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $5Lprs.asciiAlphanumeric);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $5Lprs.asciiHexDigit);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $5Lprs.asciiDigit);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $5Lprs.asciiAlphanumeric) && !(0, $gxs7E.decodeNamedCharacterReference)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

});
parcelRegister("gxs7E", function(module, exports) {

$parcel$export(module.exports, "decodeNamedCharacterReference", () => $c0a58af43f6129ac$export$289b6a6320f709b4);

var $9Cvfm = parcelRequire("9Cvfm");
const $c0a58af43f6129ac$var$own = {}.hasOwnProperty;
function $c0a58af43f6129ac$export$289b6a6320f709b4(value) {
    return $c0a58af43f6129ac$var$own.call((0, $9Cvfm.characterEntities), value) ? (0, $9Cvfm.characterEntities)[value] : false;
}

});
parcelRegister("9Cvfm", function(module, exports) {

$parcel$export(module.exports, "characterEntities", () => $700fe69a73962be8$export$ec810d1aafce79a7);
/**
 * Map of named character references.
 *
 * @type {Record<string, string>}
 */ const $700fe69a73962be8$export$ec810d1aafce79a7 = {
    AElig: "\xc6",
    AMP: "&",
    Aacute: "\xc1",
    Abreve: "\u0102",
    Acirc: "\xc2",
    Acy: "\u0410",
    Afr: "\uD835\uDD04",
    Agrave: "\xc0",
    Alpha: "\u0391",
    Amacr: "\u0100",
    And: "\u2A53",
    Aogon: "\u0104",
    Aopf: "\uD835\uDD38",
    ApplyFunction: "\u2061",
    Aring: "\xc5",
    Ascr: "\uD835\uDC9C",
    Assign: "\u2254",
    Atilde: "\xc3",
    Auml: "\xc4",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    Barwed: "\u2306",
    Bcy: "\u0411",
    Because: "\u2235",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    Bfr: "\uD835\uDD05",
    Bopf: "\uD835\uDD39",
    Breve: "\u02D8",
    Bscr: "\u212C",
    Bumpeq: "\u224E",
    CHcy: "\u0427",
    COPY: "\xa9",
    Cacute: "\u0106",
    Cap: "\u22D2",
    CapitalDifferentialD: "\u2145",
    Cayleys: "\u212D",
    Ccaron: "\u010C",
    Ccedil: "\xc7",
    Ccirc: "\u0108",
    Cconint: "\u2230",
    Cdot: "\u010A",
    Cedilla: "\xb8",
    CenterDot: "\xb7",
    Cfr: "\u212D",
    Chi: "\u03A7",
    CircleDot: "\u2299",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    Colon: "\u2237",
    Colone: "\u2A74",
    Congruent: "\u2261",
    Conint: "\u222F",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    Coproduct: "\u2210",
    CounterClockwiseContourIntegral: "\u2233",
    Cross: "\u2A2F",
    Cscr: "\uD835\uDC9E",
    Cup: "\u22D3",
    CupCap: "\u224D",
    DD: "\u2145",
    DDotrahd: "\u2911",
    DJcy: "\u0402",
    DScy: "\u0405",
    DZcy: "\u040F",
    Dagger: "\u2021",
    Darr: "\u21A1",
    Dashv: "\u2AE4",
    Dcaron: "\u010E",
    Dcy: "\u0414",
    Del: "\u2207",
    Delta: "\u0394",
    Dfr: "\uD835\uDD07",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: "`",
    DiacriticalTilde: "\u02DC",
    Diamond: "\u22C4",
    DifferentialD: "\u2146",
    Dopf: "\uD835\uDD3B",
    Dot: "\xa8",
    DotDot: "\u20DC",
    DotEqual: "\u2250",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xa8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    Downarrow: "\u21D3",
    Dscr: "\uD835\uDC9F",
    Dstrok: "\u0110",
    ENG: "\u014A",
    ETH: "\xd0",
    Eacute: "\xc9",
    Ecaron: "\u011A",
    Ecirc: "\xca",
    Ecy: "\u042D",
    Edot: "\u0116",
    Efr: "\uD835\uDD08",
    Egrave: "\xc8",
    Element: "\u2208",
    Emacr: "\u0112",
    EmptySmallSquare: "\u25FB",
    EmptyVerySmallSquare: "\u25AB",
    Eogon: "\u0118",
    Eopf: "\uD835\uDD3C",
    Epsilon: "\u0395",
    Equal: "\u2A75",
    EqualTilde: "\u2242",
    Equilibrium: "\u21CC",
    Escr: "\u2130",
    Esim: "\u2A73",
    Eta: "\u0397",
    Euml: "\xcb",
    Exists: "\u2203",
    ExponentialE: "\u2147",
    Fcy: "\u0424",
    Ffr: "\uD835\uDD09",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    Fopf: "\uD835\uDD3D",
    ForAll: "\u2200",
    Fouriertrf: "\u2131",
    Fscr: "\u2131",
    GJcy: "\u0403",
    GT: ">",
    Gamma: "\u0393",
    Gammad: "\u03DC",
    Gbreve: "\u011E",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    Gcy: "\u0413",
    Gdot: "\u0120",
    Gfr: "\uD835\uDD0A",
    Gg: "\u22D9",
    Gopf: "\uD835\uDD3E",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\uD835\uDCA2",
    Gt: "\u226B",
    HARDcy: "\u042A",
    Hacek: "\u02C7",
    Hat: "^",
    Hcirc: "\u0124",
    Hfr: "\u210C",
    HilbertSpace: "\u210B",
    Hopf: "\u210D",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    Hstrok: "\u0126",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    IEcy: "\u0415",
    IJlig: "\u0132",
    IOcy: "\u0401",
    Iacute: "\xcd",
    Icirc: "\xce",
    Icy: "\u0418",
    Idot: "\u0130",
    Ifr: "\u2111",
    Igrave: "\xcc",
    Im: "\u2111",
    Imacr: "\u012A",
    ImaginaryI: "\u2148",
    Implies: "\u21D2",
    Int: "\u222C",
    Integral: "\u222B",
    Intersection: "\u22C2",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    Iogon: "\u012E",
    Iopf: "\uD835\uDD40",
    Iota: "\u0399",
    Iscr: "\u2110",
    Itilde: "\u0128",
    Iukcy: "\u0406",
    Iuml: "\xcf",
    Jcirc: "\u0134",
    Jcy: "\u0419",
    Jfr: "\uD835\uDD0D",
    Jopf: "\uD835\uDD41",
    Jscr: "\uD835\uDCA5",
    Jsercy: "\u0408",
    Jukcy: "\u0404",
    KHcy: "\u0425",
    KJcy: "\u040C",
    Kappa: "\u039A",
    Kcedil: "\u0136",
    Kcy: "\u041A",
    Kfr: "\uD835\uDD0E",
    Kopf: "\uD835\uDD42",
    Kscr: "\uD835\uDCA6",
    LJcy: "\u0409",
    LT: "<",
    Lacute: "\u0139",
    Lambda: "\u039B",
    Lang: "\u27EA",
    Laplacetrf: "\u2112",
    Larr: "\u219E",
    Lcaron: "\u013D",
    Lcedil: "\u013B",
    Lcy: "\u041B",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    LeftRightArrow: "\u2194",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    Leftarrow: "\u21D0",
    Leftrightarrow: "\u21D4",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    LessLess: "\u2AA1",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    Lfr: "\uD835\uDD0F",
    Ll: "\u22D8",
    Lleftarrow: "\u21DA",
    Lmidot: "\u013F",
    LongLeftArrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    LongRightArrow: "\u27F6",
    Longleftarrow: "\u27F8",
    Longleftrightarrow: "\u27FA",
    Longrightarrow: "\u27F9",
    Lopf: "\uD835\uDD43",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    Lscr: "\u2112",
    Lsh: "\u21B0",
    Lstrok: "\u0141",
    Lt: "\u226A",
    Map: "\u2905",
    Mcy: "\u041C",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    MinusPlus: "\u2213",
    Mopf: "\uD835\uDD44",
    Mscr: "\u2133",
    Mu: "\u039C",
    NJcy: "\u040A",
    Nacute: "\u0143",
    Ncaron: "\u0147",
    Ncedil: "\u0145",
    Ncy: "\u041D",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: "\n",
    Nfr: "\uD835\uDD11",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xa0",
    Nopf: "\u2115",
    Not: "\u2AEC",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    Nscr: "\uD835\uDCA9",
    Ntilde: "\xd1",
    Nu: "\u039D",
    OElig: "\u0152",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Ocy: "\u041E",
    Odblac: "\u0150",
    Ofr: "\uD835\uDD12",
    Ograve: "\xd2",
    Omacr: "\u014C",
    Omega: "\u03A9",
    Omicron: "\u039F",
    Oopf: "\uD835\uDD46",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    Or: "\u2A54",
    Oscr: "\uD835\uDCAA",
    Oslash: "\xd8",
    Otilde: "\xd5",
    Otimes: "\u2A37",
    Ouml: "\xd6",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    PartialD: "\u2202",
    Pcy: "\u041F",
    Pfr: "\uD835\uDD13",
    Phi: "\u03A6",
    Pi: "\u03A0",
    PlusMinus: "\xb1",
    Poincareplane: "\u210C",
    Popf: "\u2119",
    Pr: "\u2ABB",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    Prime: "\u2033",
    Product: "\u220F",
    Proportion: "\u2237",
    Proportional: "\u221D",
    Pscr: "\uD835\uDCAB",
    Psi: "\u03A8",
    QUOT: '"',
    Qfr: "\uD835\uDD14",
    Qopf: "\u211A",
    Qscr: "\uD835\uDCAC",
    RBarr: "\u2910",
    REG: "\xae",
    Racute: "\u0154",
    Rang: "\u27EB",
    Rarr: "\u21A0",
    Rarrtl: "\u2916",
    Rcaron: "\u0158",
    Rcedil: "\u0156",
    Rcy: "\u0420",
    Re: "\u211C",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    Rfr: "\u211C",
    Rho: "\u03A1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    Rightarrow: "\u21D2",
    Ropf: "\u211D",
    RoundImplies: "\u2970",
    Rrightarrow: "\u21DB",
    Rscr: "\u211B",
    Rsh: "\u21B1",
    RuleDelayed: "\u29F4",
    SHCHcy: "\u0429",
    SHcy: "\u0428",
    SOFTcy: "\u042C",
    Sacute: "\u015A",
    Sc: "\u2ABC",
    Scaron: "\u0160",
    Scedil: "\u015E",
    Scirc: "\u015C",
    Scy: "\u0421",
    Sfr: "\uD835\uDD16",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    Sigma: "\u03A3",
    SmallCircle: "\u2218",
    Sopf: "\uD835\uDD4A",
    Sqrt: "\u221A",
    Square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    Sscr: "\uD835\uDCAE",
    Star: "\u22C6",
    Sub: "\u22D0",
    Subset: "\u22D0",
    SubsetEqual: "\u2286",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    Sup: "\u22D1",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    Supset: "\u22D1",
    THORN: "\xde",
    TRADE: "\u2122",
    TSHcy: "\u040B",
    TScy: "\u0426",
    Tab: "	",
    Tau: "\u03A4",
    Tcaron: "\u0164",
    Tcedil: "\u0162",
    Tcy: "\u0422",
    Tfr: "\uD835\uDD17",
    Therefore: "\u2234",
    Theta: "\u0398",
    ThickSpace: "\u205F\u200A",
    ThinSpace: "\u2009",
    Tilde: "\u223C",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    Topf: "\uD835\uDD4B",
    TripleDot: "\u20DB",
    Tscr: "\uD835\uDCAF",
    Tstrok: "\u0166",
    Uacute: "\xda",
    Uarr: "\u219F",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    Ubreve: "\u016C",
    Ucirc: "\xdb",
    Ucy: "\u0423",
    Udblac: "\u0170",
    Ufr: "\uD835\uDD18",
    Ugrave: "\xd9",
    Umacr: "\u016A",
    UnderBar: "_",
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    Uopf: "\uD835\uDD4C",
    UpArrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    UpEquilibrium: "\u296E",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    Uparrow: "\u21D1",
    Updownarrow: "\u21D5",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    Upsilon: "\u03A5",
    Uring: "\u016E",
    Uscr: "\uD835\uDCB0",
    Utilde: "\u0168",
    Uuml: "\xdc",
    VDash: "\u22AB",
    Vbar: "\u2AEB",
    Vcy: "\u0412",
    Vdash: "\u22A9",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    Verbar: "\u2016",
    Vert: "\u2016",
    VerticalBar: "\u2223",
    VerticalLine: "|",
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\uD835\uDD19",
    Vopf: "\uD835\uDD4D",
    Vscr: "\uD835\uDCB1",
    Vvdash: "\u22AA",
    Wcirc: "\u0174",
    Wedge: "\u22C0",
    Wfr: "\uD835\uDD1A",
    Wopf: "\uD835\uDD4E",
    Wscr: "\uD835\uDCB2",
    Xfr: "\uD835\uDD1B",
    Xi: "\u039E",
    Xopf: "\uD835\uDD4F",
    Xscr: "\uD835\uDCB3",
    YAcy: "\u042F",
    YIcy: "\u0407",
    YUcy: "\u042E",
    Yacute: "\xdd",
    Ycirc: "\u0176",
    Ycy: "\u042B",
    Yfr: "\uD835\uDD1C",
    Yopf: "\uD835\uDD50",
    Yscr: "\uD835\uDCB4",
    Yuml: "\u0178",
    ZHcy: "\u0416",
    Zacute: "\u0179",
    Zcaron: "\u017D",
    Zcy: "\u0417",
    Zdot: "\u017B",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    Zfr: "\u2128",
    Zopf: "\u2124",
    Zscr: "\uD835\uDCB5",
    aacute: "\xe1",
    abreve: "\u0103",
    ac: "\u223E",
    acE: "\u223E\u0333",
    acd: "\u223F",
    acirc: "\xe2",
    acute: "\xb4",
    acy: "\u0430",
    aelig: "\xe6",
    af: "\u2061",
    afr: "\uD835\uDD1E",
    agrave: "\xe0",
    alefsym: "\u2135",
    aleph: "\u2135",
    alpha: "\u03B1",
    amacr: "\u0101",
    amalg: "\u2A3F",
    amp: "&",
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xc5",
    angzarr: "\u237C",
    aogon: "\u0105",
    aopf: "\uD835\uDD52",
    ap: "\u2248",
    apE: "\u2A70",
    apacir: "\u2A6F",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    approx: "\u2248",
    approxeq: "\u224A",
    aring: "\xe5",
    ascr: "\uD835\uDCB6",
    ast: "*",
    asymp: "\u2248",
    asympeq: "\u224D",
    atilde: "\xe3",
    auml: "\xe4",
    awconint: "\u2233",
    awint: "\u2A11",
    bNot: "\u2AED",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    barvee: "\u22BD",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    bfr: "\uD835\uDD1F",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bnot: "\u2310",
    bopf: "\uD835\uDD53",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxDL: "\u2557",
    boxDR: "\u2554",
    boxDl: "\u2556",
    boxDr: "\u2553",
    boxH: "\u2550",
    boxHD: "\u2566",
    boxHU: "\u2569",
    boxHd: "\u2564",
    boxHu: "\u2567",
    boxUL: "\u255D",
    boxUR: "\u255A",
    boxUl: "\u255C",
    boxUr: "\u2559",
    boxV: "\u2551",
    boxVH: "\u256C",
    boxVL: "\u2563",
    boxVR: "\u2560",
    boxVh: "\u256B",
    boxVl: "\u2562",
    boxVr: "\u255F",
    boxbox: "\u29C9",
    boxdL: "\u2555",
    boxdR: "\u2552",
    boxdl: "\u2510",
    boxdr: "\u250C",
    boxh: "\u2500",
    boxhD: "\u2565",
    boxhU: "\u2568",
    boxhd: "\u252C",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxuL: "\u255B",
    boxuR: "\u2558",
    boxul: "\u2518",
    boxur: "\u2514",
    boxv: "\u2502",
    boxvH: "\u256A",
    boxvL: "\u2561",
    boxvR: "\u255E",
    boxvh: "\u253C",
    boxvl: "\u2524",
    boxvr: "\u251C",
    bprime: "\u2035",
    breve: "\u02D8",
    brvbar: "\xa6",
    bscr: "\uD835\uDCB7",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: "\\",
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    bumpeq: "\u224F",
    cacute: "\u0107",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    ccaps: "\u2A4D",
    ccaron: "\u010D",
    ccedil: "\xe7",
    ccirc: "\u0109",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    cdot: "\u010B",
    cedil: "\xb8",
    cemptyv: "\u29B2",
    cent: "\xa2",
    centerdot: "\xb7",
    cfr: "\uD835\uDD20",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    chi: "\u03C7",
    cir: "\u25CB",
    cirE: "\u29C3",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledR: "\xae",
    circledS: "\u24C8",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    clubs: "\u2663",
    clubsuit: "\u2663",
    colon: ":",
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ",",
    commat: "@",
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    conint: "\u222E",
    copf: "\uD835\uDD54",
    coprod: "\u2210",
    copy: "\xa9",
    copysr: "\u2117",
    crarr: "\u21B5",
    cross: "\u2717",
    cscr: "\uD835\uDCB8",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xa4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    dArr: "\u21D3",
    dHar: "\u2965",
    dagger: "\u2020",
    daleth: "\u2138",
    darr: "\u2193",
    dash: "\u2010",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    dcaron: "\u010F",
    dcy: "\u0434",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    ddotseq: "\u2A77",
    deg: "\xb0",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    dfr: "\uD835\uDD21",
    dharl: "\u21C3",
    dharr: "\u21C2",
    diam: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xa8",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: "$",
    dopf: "\uD835\uDD55",
    dot: "\u02D9",
    doteq: "\u2250",
    doteqdot: "\u2251",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    downarrow: "\u2193",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    dscr: "\uD835\uDCB9",
    dscy: "\u0455",
    dsol: "\u29F6",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    eDDot: "\u2A77",
    eDot: "\u2251",
    eacute: "\xe9",
    easter: "\u2A6E",
    ecaron: "\u011B",
    ecir: "\u2256",
    ecirc: "\xea",
    ecolon: "\u2255",
    ecy: "\u044D",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    efr: "\uD835\uDD22",
    eg: "\u2A9A",
    egrave: "\xe8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    emptyv: "\u2205",
    emsp13: "\u2004",
    emsp14: "\u2005",
    emsp: "\u2003",
    eng: "\u014B",
    ensp: "\u2002",
    eogon: "\u0119",
    eopf: "\uD835\uDD56",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    equals: "=",
    equest: "\u225F",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erDot: "\u2253",
    erarr: "\u2971",
    escr: "\u212F",
    esdot: "\u2250",
    esim: "\u2242",
    eta: "\u03B7",
    eth: "\xf0",
    euml: "\xeb",
    euro: "\u20AC",
    excl: "!",
    exist: "\u2203",
    expectation: "\u2130",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    ffr: "\uD835\uDD23",
    filig: "\uFB01",
    fjlig: "fj",
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    fopf: "\uD835\uDD57",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    fpartint: "\u2A0D",
    frac12: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    fscr: "\uD835\uDCBB",
    gE: "\u2267",
    gEl: "\u2A8C",
    gacute: "\u01F5",
    gamma: "\u03B3",
    gammad: "\u03DD",
    gap: "\u2A86",
    gbreve: "\u011F",
    gcirc: "\u011D",
    gcy: "\u0433",
    gdot: "\u0121",
    ge: "\u2265",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    gfr: "\uD835\uDD24",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    gjcy: "\u0453",
    gl: "\u2277",
    glE: "\u2A92",
    gla: "\u2AA5",
    glj: "\u2AA4",
    gnE: "\u2269",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    gopf: "\uD835\uDD58",
    grave: "`",
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    gt: ">",
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    hArr: "\u21D4",
    hairsp: "\u200A",
    half: "\xbd",
    hamilt: "\u210B",
    hardcy: "\u044A",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    hbar: "\u210F",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    hfr: "\uD835\uDD25",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    hopf: "\uD835\uDD59",
    horbar: "\u2015",
    hscr: "\uD835\uDCBD",
    hslash: "\u210F",
    hstrok: "\u0127",
    hybull: "\u2043",
    hyphen: "\u2010",
    iacute: "\xed",
    ic: "\u2063",
    icirc: "\xee",
    icy: "\u0438",
    iecy: "\u0435",
    iexcl: "\xa1",
    iff: "\u21D4",
    ifr: "\uD835\uDD26",
    igrave: "\xec",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    ijlig: "\u0133",
    imacr: "\u012B",
    image: "\u2111",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    intercal: "\u22BA",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    iocy: "\u0451",
    iogon: "\u012F",
    iopf: "\uD835\uDD5A",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xbf",
    iscr: "\uD835\uDCBE",
    isin: "\u2208",
    isinE: "\u22F9",
    isindot: "\u22F5",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    itilde: "\u0129",
    iukcy: "\u0456",
    iuml: "\xef",
    jcirc: "\u0135",
    jcy: "\u0439",
    jfr: "\uD835\uDD27",
    jmath: "\u0237",
    jopf: "\uD835\uDD5B",
    jscr: "\uD835\uDCBF",
    jsercy: "\u0458",
    jukcy: "\u0454",
    kappa: "\u03BA",
    kappav: "\u03F0",
    kcedil: "\u0137",
    kcy: "\u043A",
    kfr: "\uD835\uDD28",
    kgreen: "\u0138",
    khcy: "\u0445",
    kjcy: "\u045C",
    kopf: "\uD835\uDD5C",
    kscr: "\uD835\uDCC0",
    lAarr: "\u21DA",
    lArr: "\u21D0",
    lAtail: "\u291B",
    lBarr: "\u290E",
    lE: "\u2266",
    lEg: "\u2A8B",
    lHar: "\u2962",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    lambda: "\u03BB",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    laquo: "\xab",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: "{",
    lbrack: "[",
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    lcaron: "\u013E",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: "{",
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    le: "\u2264",
    leftarrow: "\u2190",
    leftarrowtail: "\u21A2",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    leftthreetimes: "\u22CB",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    lessgtr: "\u2276",
    lesssim: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    lfr: "\uD835\uDD29",
    lg: "\u2276",
    lgE: "\u2A91",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    ljcy: "\u0459",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    llhard: "\u296B",
    lltri: "\u25FA",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnE: "\u2268",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    longleftarrow: "\u27F5",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    lopf: "\uD835\uDD5D",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: "_",
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: "(",
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    lscr: "\uD835\uDCC1",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: "[",
    lsquo: "\u2018",
    lsquor: "\u201A",
    lstrok: "\u0142",
    lt: "<",
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltrPar: "\u2996",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    mDDot: "\u223A",
    macr: "\xaf",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    mcy: "\u043C",
    mdash: "\u2014",
    measuredangle: "\u2221",
    mfr: "\uD835\uDD2A",
    mho: "\u2127",
    micro: "\xb5",
    mid: "\u2223",
    midast: "*",
    midcir: "\u2AF0",
    middot: "\xb7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    mopf: "\uD835\uDD5E",
    mp: "\u2213",
    mscr: "\uD835\uDCC2",
    mstpos: "\u223E",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nGg: "\u22D9\u0338",
    nGt: "\u226B\u20D2",
    nGtv: "\u226B\u0338",
    nLeftarrow: "\u21CD",
    nLeftrightarrow: "\u21CE",
    nLl: "\u22D8\u0338",
    nLt: "\u226A\u20D2",
    nLtv: "\u226A\u0338",
    nRightarrow: "\u21CF",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nabla: "\u2207",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xa0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    ncaron: "\u0148",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    neArr: "\u21D7",
    nearhk: "\u2924",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    nexist: "\u2204",
    nexists: "\u2204",
    nfr: "\uD835\uDD2B",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    ngsim: "\u2275",
    ngt: "\u226F",
    ngtr: "\u226F",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlE: "\u2266\u0338",
    nlarr: "\u219A",
    nldr: "\u2025",
    nle: "\u2270",
    nleftarrow: "\u219A",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nlsim: "\u2274",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nmid: "\u2224",
    nopf: "\uD835\uDD5F",
    not: "\xac",
    notin: "\u2209",
    notinE: "\u22F9\u0338",
    notindot: "\u22F5\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    nscr: "\uD835\uDCC3",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    ntilde: "\xf1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    nu: "\u03BD",
    num: "#",
    numero: "\u2116",
    numsp: "\u2007",
    nvDash: "\u22AD",
    nvHarr: "\u2904",
    nvap: "\u224D\u20D2",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwArr: "\u21D6",
    nwarhk: "\u2923",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    oS: "\u24C8",
    oacute: "\xf3",
    oast: "\u229B",
    ocir: "\u229A",
    ocirc: "\xf4",
    ocy: "\u043E",
    odash: "\u229D",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    oelig: "\u0153",
    ofcir: "\u29BF",
    ofr: "\uD835\uDD2C",
    ogon: "\u02DB",
    ograve: "\xf2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    omacr: "\u014D",
    omega: "\u03C9",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    oopf: "\uD835\uDD60",
    opar: "\u29B7",
    operp: "\u29B9",
    oplus: "\u2295",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oscr: "\u2134",
    oslash: "\xf8",
    osol: "\u2298",
    otilde: "\xf5",
    otimes: "\u2297",
    otimesas: "\u2A36",
    ouml: "\xf6",
    ovbar: "\u233D",
    par: "\u2225",
    para: "\xb6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    pcy: "\u043F",
    percnt: "%",
    period: ".",
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    pfr: "\uD835\uDD2D",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: "+",
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    plusmn: "\xb1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xb1",
    pointint: "\u2A15",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    pr: "\u227A",
    prE: "\u2AB3",
    prap: "\u2AB7",
    prcue: "\u227C",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    prime: "\u2032",
    primes: "\u2119",
    prnE: "\u2AB5",
    prnap: "\u2AB9",
    prnsim: "\u22E8",
    prod: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    pscr: "\uD835\uDCC5",
    psi: "\u03C8",
    puncsp: "\u2008",
    qfr: "\uD835\uDD2E",
    qint: "\u2A0C",
    qopf: "\uD835\uDD62",
    qprime: "\u2057",
    qscr: "\uD835\uDCC6",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: "?",
    questeq: "\u225F",
    quot: '"',
    rAarr: "\u21DB",
    rArr: "\u21D2",
    rAtail: "\u291C",
    rBarr: "\u290F",
    rHar: "\u2964",
    race: "\u223D\u0331",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xbb",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: "}",
    rbrack: "]",
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    rcaron: "\u0159",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: "}",
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    reg: "\xae",
    rfisht: "\u297D",
    rfloor: "\u230B",
    rfr: "\uD835\uDD2F",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    rho: "\u03C1",
    rhov: "\u03F1",
    rightarrow: "\u2192",
    rightarrowtail: "\u21A3",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    rightthreetimes: "\u22CC",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    ropf: "\uD835\uDD63",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    rpar: ")",
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    rsaquo: "\u203A",
    rscr: "\uD835\uDCC7",
    rsh: "\u21B1",
    rsqb: "]",
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    ruluhar: "\u2968",
    rx: "\u211E",
    sacute: "\u015B",
    sbquo: "\u201A",
    sc: "\u227B",
    scE: "\u2AB4",
    scap: "\u2AB8",
    scaron: "\u0161",
    sccue: "\u227D",
    sce: "\u2AB0",
    scedil: "\u015F",
    scirc: "\u015D",
    scnE: "\u2AB6",
    scnap: "\u2ABA",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    seArr: "\u21D8",
    searhk: "\u2925",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xa7",
    semi: ";",
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    sfr: "\uD835\uDD30",
    sfrown: "\u2322",
    sharp: "\u266F",
    shchcy: "\u0449",
    shcy: "\u0448",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    shy: "\xad",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    softcy: "\u044C",
    sol: "/",
    solb: "\u29C4",
    solbar: "\u233F",
    sopf: "\uD835\uDD64",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    square: "\u25A1",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    sscr: "\uD835\uDCC8",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xaf",
    sub: "\u2282",
    subE: "\u2AC5",
    subdot: "\u2ABD",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    sum: "\u2211",
    sung: "\u266A",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    sup: "\u2283",
    supE: "\u2AC6",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supe: "\u2287",
    supedot: "\u2AC4",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swArr: "\u21D9",
    swarhk: "\u2926",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xdf",
    target: "\u2316",
    tau: "\u03C4",
    tbrk: "\u23B4",
    tcaron: "\u0165",
    tcedil: "\u0163",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    tfr: "\uD835\uDD31",
    there4: "\u2234",
    therefore: "\u2234",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    thinsp: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    thorn: "\xfe",
    tilde: "\u02DC",
    times: "\xd7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    topf: "\uD835\uDD65",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    tscr: "\uD835\uDCC9",
    tscy: "\u0446",
    tshcy: "\u045B",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    uArr: "\u21D1",
    uHar: "\u2963",
    uacute: "\xfa",
    uarr: "\u2191",
    ubrcy: "\u045E",
    ubreve: "\u016D",
    ucirc: "\xfb",
    ucy: "\u0443",
    udarr: "\u21C5",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    ufr: "\uD835\uDD32",
    ugrave: "\xf9",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    umacr: "\u016B",
    uml: "\xa8",
    uogon: "\u0173",
    uopf: "\uD835\uDD66",
    uparrow: "\u2191",
    updownarrow: "\u2195",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    upsi: "\u03C5",
    upsih: "\u03D2",
    upsilon: "\u03C5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    uring: "\u016F",
    urtri: "\u25F9",
    uscr: "\uD835\uDCCA",
    utdot: "\u22F0",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    uuml: "\xfc",
    uwangle: "\u29A7",
    vArr: "\u21D5",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    vDash: "\u22A8",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    vcy: "\u0432",
    vdash: "\u22A2",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    verbar: "|",
    vert: "|",
    vfr: "\uD835\uDD33",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    vopf: "\uD835\uDD67",
    vprop: "\u221D",
    vrtri: "\u22B3",
    vscr: "\uD835\uDCCB",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    vzigzag: "\u299A",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    wfr: "\uD835\uDD34",
    wopf: "\uD835\uDD68",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    wscr: "\uD835\uDCCC",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    xfr: "\uD835\uDD35",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    xopf: "\uD835\uDD69",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    xscr: "\uD835\uDCCD",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    yacute: "\xfd",
    yacy: "\u044F",
    ycirc: "\u0177",
    ycy: "\u044B",
    yen: "\xa5",
    yfr: "\uD835\uDD36",
    yicy: "\u0457",
    yopf: "\uD835\uDD6A",
    yscr: "\uD835\uDCCE",
    yucy: "\u044E",
    yuml: "\xff",
    zacute: "\u017A",
    zcaron: "\u017E",
    zcy: "\u0437",
    zdot: "\u017C",
    zeetrf: "\u2128",
    zeta: "\u03B6",
    zfr: "\uD835\uDD37",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    zopf: "\uD835\uDD6B",
    zscr: "\uD835\uDCCF",
    zwj: "\u200D",
    zwnj: "\u200C"
};

});



parcelRegister("2qoAc", function(module, exports) {

$parcel$export(module.exports, "codeFenced", () => $1c411422dc205d23$export$c23e4921f8d87e7c);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
/** @type {Construct} */ const $1c411422dc205d23$var$nonLazyContinuation = {
    tokenize: $1c411422dc205d23$var$tokenizeNonLazyContinuation,
    partial: true
};
const $1c411422dc205d23$export$c23e4921f8d87e7c = {
    name: "codeFenced",
    tokenize: $1c411422dc205d23$var$tokenizeCodeFenced,
    concrete: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1c411422dc205d23$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        tokenize: tokenizeCloseStart,
        partial: true
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($1c411422dc205d23$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $8GWoH.factorySpace)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) return effects.check($1c411422dc205d23$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1c411422dc205d23$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

});

parcelRegister("eHPOy", function(module, exports) {

$parcel$export(module.exports, "codeIndented", () => $ab4d46130bbbc8bd$export$47910b7ab28d1853);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
const $ab4d46130bbbc8bd$export$47910b7ab28d1853 = {
    name: "codeIndented",
    tokenize: $ab4d46130bbbc8bd$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $ab4d46130bbbc8bd$var$furtherStart = {
    tokenize: $ab4d46130bbbc8bd$var$tokenizeFurtherStart,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ab4d46130bbbc8bd$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $8GWoH.factorySpace)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $5Lprs.markdownLineEnding)(code)) return effects.attempt($ab4d46130bbbc8bd$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ab4d46130bbbc8bd$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $8GWoH.factorySpace)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $5Lprs.markdownLineEnding)(code) ? furtherStart(code) : nok(code);
    }
}

});

parcelRegister("1XgoW", function(module, exports) {

$parcel$export(module.exports, "codeText", () => $16c806108f267846$export$d24f93e715f9df88);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $5Lprs = parcelRequire("5Lprs");
const $16c806108f267846$export$d24f93e715f9df88 = {
    name: "codeText",
    tokenize: $16c806108f267846$var$tokenizeCodeText,
    resolve: $16c806108f267846$var$resolveCodeText,
    previous: $16c806108f267846$var$previous
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $16c806108f267846$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $16c806108f267846$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $16c806108f267846$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter("space");
            effects.consume(code);
            effects.exit("space");
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

});

parcelRegister("ix9Ua", function(module, exports) {

$parcel$export(module.exports, "definition", () => $d7e2fdfd86ff4dd4$export$69f215ed977cdb73);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $flE5d = parcelRequire("flE5d");

var $i8rQF = parcelRequire("i8rQF");

var $8GWoH = parcelRequire("8GWoH");

var $kXx8i = parcelRequire("kXx8i");

var $5Jc1R = parcelRequire("5Jc1R");

var $5Lprs = parcelRequire("5Lprs");

var $9HErY = parcelRequire("9HErY");
const $d7e2fdfd86ff4dd4$export$69f215ed977cdb73 = {
    name: "definition",
    tokenize: $d7e2fdfd86ff4dd4$var$tokenizeDefinition
};
/** @type {Construct} */ const $d7e2fdfd86ff4dd4$var$titleBefore = {
    tokenize: $d7e2fdfd86ff4dd4$var$tokenizeTitleBefore,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d7e2fdfd86ff4dd4$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $i8rQF.factoryLabel).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $9HErY.normalizeIdentifier)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $5Lprs.markdownLineEndingOrSpace)(code) ? (0, $5Jc1R.factoryWhitespace)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $flE5d.factoryDestination)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($d7e2fdfd86ff4dd4$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d7e2fdfd86ff4dd4$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $5Lprs.markdownLineEndingOrSpace)(code) ? (0, $5Jc1R.factoryWhitespace)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $kXx8i.factoryTitle)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $5Lprs.markdownLineEnding)(code) ? ok(code) : nok(code);
    }
}

});
parcelRegister("flE5d", function(module, exports) {

$parcel$export(module.exports, "factoryDestination", () => $b2c7e8deac525d60$export$2e6c8deaa96af245);
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
var $5Lprs = parcelRequire("5Lprs");
function $b2c7e8deac525d60$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $5Lprs.asciiControl)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $5Lprs.markdownLineEnding)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $5Lprs.markdownLineEndingOrSpace)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $5Lprs.asciiControl)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}

});

parcelRegister("i8rQF", function(module, exports) {

$parcel$export(module.exports, "factoryLabel", () => $d33e937ae1ea4ed4$export$7b768614d8ba97a7);
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
var $5Lprs = parcelRequire("5Lprs");
function $d33e937ae1ea4ed4$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && "_hiddenFootnoteSupport" in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $5Lprs.markdownLineEnding)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $5Lprs.markdownSpace)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}

});

parcelRegister("kXx8i", function(module, exports) {

$parcel$export(module.exports, "factoryTitle", () => $f42304cc65ff93d0$export$f970569cc855e483);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
function $f42304cc65ff93d0$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $8GWoH.factorySpace)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}

});

parcelRegister("5Jc1R", function(module, exports) {

$parcel$export(module.exports, "factoryWhitespace", () => $42ba7c725dbf102d$export$1f27bd1aa33ce173);
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
function $42ba7c725dbf102d$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $5Lprs.markdownSpace)(code)) return (0, $8GWoH.factorySpace)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}

});

parcelRegister("9HErY", function(module, exports) {

$parcel$export(module.exports, "normalizeIdentifier", () => $710781c0cdec9f6d$export$806d55e226cfcd08);
/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $710781c0cdec9f6d$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, "")// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}

});


parcelRegister("1d2Fb", function(module, exports) {

$parcel$export(module.exports, "hardBreakEscape", () => $0e19123aa1bdeff9$export$86c573ab9e06f418);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $5Lprs = parcelRequire("5Lprs");
const $0e19123aa1bdeff9$export$86c573ab9e06f418 = {
    name: "hardBreakEscape",
    tokenize: $0e19123aa1bdeff9$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0e19123aa1bdeff9$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

});

parcelRegister("e7bPJ", function(module, exports) {

$parcel$export(module.exports, "headingAtx", () => $a46ae5f97ae33c5d$export$3871e9deb360695c);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");

var $Ux2lp = parcelRequire("Ux2lp");
const $a46ae5f97ae33c5d$export$3871e9deb360695c = {
    name: "headingAtx",
    tokenize: $a46ae5f97ae33c5d$var$tokenizeHeadingAtx,
    resolve: $a46ae5f97ae33c5d$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $a46ae5f97ae33c5d$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $Ux2lp.splice)(events, contentStart, contentEnd - contentStart + 1, [
            [
                "enter",
                content,
                context
            ],
            [
                "enter",
                text,
                context
            ],
            [
                "exit",
                text,
                context
            ],
            [
                "exit",
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a46ae5f97ae33c5d$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $5Lprs.markdownLineEndingOrSpace)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $5Lprs.markdownSpace)(code)) return (0, $8GWoH.factorySpace)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $5Lprs.markdownLineEndingOrSpace)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

});

parcelRegister("aMDJK", function(module, exports) {

$parcel$export(module.exports, "htmlFlow", () => $7d9d35fac2b6ebcc$export$476ac411cb7d0d8f);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $5Lprs = parcelRequire("5Lprs");

var $9Lzi7 = parcelRequire("9Lzi7");

var $eRfeJ = parcelRequire("eRfeJ");
const $7d9d35fac2b6ebcc$export$476ac411cb7d0d8f = {
    name: "htmlFlow",
    tokenize: $7d9d35fac2b6ebcc$var$tokenizeHtmlFlow,
    resolveTo: $7d9d35fac2b6ebcc$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $7d9d35fac2b6ebcc$var$blankLineBefore = {
    tokenize: $7d9d35fac2b6ebcc$var$tokenizeBlankLineBefore,
    partial: true
};
const $7d9d35fac2b6ebcc$var$nonLazyContinuationStart = {
    tokenize: $7d9d35fac2b6ebcc$var$tokenizeNonLazyContinuationStart,
    partial: true
};
/** @type {Resolver} */ function $7d9d35fac2b6ebcc$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7d9d35fac2b6ebcc$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $5Lprs.markdownLineEndingOrSpace)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $9Lzi7.htmlRawNames).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $9Lzi7.htmlBlockNames).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $5Lprs.asciiAlphanumeric)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $5Lprs.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $5Lprs.markdownLineEndingOrSpace)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $5Lprs.markdownSpace)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $5Lprs.markdownLineEnding)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($7d9d35fac2b6ebcc$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($7d9d35fac2b6ebcc$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = "";
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $9Lzi7.htmlRawNames).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $5Lprs.asciiAlpha)(code) && buffer.length < 8) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7d9d35fac2b6ebcc$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7d9d35fac2b6ebcc$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $eRfeJ.blankLine), ok, nok);
    }
}

});
parcelRegister("9Lzi7", function(module, exports) {

$parcel$export(module.exports, "htmlBlockNames", () => $71c3e0f388301604$export$7364aee1c59d1879);
$parcel$export(module.exports, "htmlRawNames", () => $71c3e0f388301604$export$948e66da505d080);
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $71c3e0f388301604$export$7364aee1c59d1879 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
const $71c3e0f388301604$export$948e66da505d080 = [
    "pre",
    "script",
    "style",
    "textarea"
];

});


parcelRegister("fAOFU", function(module, exports) {

$parcel$export(module.exports, "htmlText", () => $b5a186cf1fccfac7$export$398af27f284914fe);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
const $b5a186cf1fccfac7$export$398af27f284914fe = {
    name: "htmlText",
    tokenize: $b5a186cf1fccfac7$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b5a186cf1fccfac7$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $5Lprs.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $5Lprs.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $5Lprs.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $5Lprs.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $5Lprs.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $5Lprs.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

});

parcelRegister("2yvw6", function(module, exports) {

$parcel$export(module.exports, "labelEnd", () => $1dc73455d0df3be9$export$470a5dafbbf62654);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $flE5d = parcelRequire("flE5d");

var $i8rQF = parcelRequire("i8rQF");

var $kXx8i = parcelRequire("kXx8i");

var $5Jc1R = parcelRequire("5Jc1R");

var $5Lprs = parcelRequire("5Lprs");

var $Ux2lp = parcelRequire("Ux2lp");

var $9HErY = parcelRequire("9HErY");

var $8f02Z = parcelRequire("8f02Z");
const $1dc73455d0df3be9$export$470a5dafbbf62654 = {
    name: "labelEnd",
    tokenize: $1dc73455d0df3be9$var$tokenizeLabelEnd,
    resolveTo: $1dc73455d0df3be9$var$resolveToLabelEnd,
    resolveAll: $1dc73455d0df3be9$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $1dc73455d0df3be9$var$resourceConstruct = {
    tokenize: $1dc73455d0df3be9$var$tokenizeResource
};
/** @type {Construct} */ const $1dc73455d0df3be9$var$referenceFullConstruct = {
    tokenize: $1dc73455d0df3be9$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $1dc73455d0df3be9$var$referenceCollapsedConstruct = {
    tokenize: $1dc73455d0df3be9$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $1dc73455d0df3be9$var$resolveAllLabelEnd(events) {
    let index = -1;
    while(++index < events.length){
        const token = events[index][1];
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $1dc73455d0df3be9$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            "enter",
            group,
            context
        ],
        [
            "enter",
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $Ux2lp.push)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $Ux2lp.push)(media, [
        [
            "enter",
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $Ux2lp.push)(media, (0, $8f02Z.resolveAll)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $Ux2lp.push)(media, [
        [
            "exit",
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            "exit",
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $Ux2lp.push)(media, events.slice(close + 1));
    // Media close.
    media = (0, $Ux2lp.push)(media, [
        [
            "exit",
            group,
            context
        ]
    ]);
    (0, $Ux2lp.splice)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1dc73455d0df3be9$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $9HErY.normalizeIdentifier)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($1dc73455d0df3be9$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($1dc73455d0df3be9$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($1dc73455d0df3be9$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1dc73455d0df3be9$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $5Lprs.markdownLineEndingOrSpace)(code) ? (0, $5Jc1R.factoryWhitespace)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $flE5d.factoryDestination)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $5Lprs.markdownLineEndingOrSpace)(code) ? (0, $5Jc1R.factoryWhitespace)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $kXx8i.factoryTitle)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $5Lprs.markdownLineEndingOrSpace)(code) ? (0, $5Jc1R.factoryWhitespace)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1dc73455d0df3be9$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $i8rQF.factoryLabel).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $9HErY.normalizeIdentifier)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1dc73455d0df3be9$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

});

parcelRegister("l3YSx", function(module, exports) {

$parcel$export(module.exports, "labelStartImage", () => $f5591a0a77ea393a$export$3d754936e25aa5f5);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $2yvw6 = parcelRequire("2yvw6");
const $f5591a0a77ea393a$export$3d754936e25aa5f5 = {
    name: "labelStartImage",
    tokenize: $f5591a0a77ea393a$var$tokenizeLabelStartImage,
    resolveAll: (0, $2yvw6.labelEnd).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f5591a0a77ea393a$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

});

parcelRegister("ifBjz", function(module, exports) {

$parcel$export(module.exports, "labelStartLink", () => $d496929de41504d8$export$5c0cee0701a3b584);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $2yvw6 = parcelRequire("2yvw6");
const $d496929de41504d8$export$5c0cee0701a3b584 = {
    name: "labelStartLink",
    tokenize: $d496929de41504d8$var$tokenizeLabelStartLink,
    resolveAll: (0, $2yvw6.labelEnd).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d496929de41504d8$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

});

parcelRegister("9shNq", function(module, exports) {

$parcel$export(module.exports, "lineEnding", () => $6e24888a23d546e6$export$8e62e0ad51c97b2);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

const $6e24888a23d546e6$export$8e62e0ad51c97b2 = {
    name: "lineEnding",
    tokenize: $6e24888a23d546e6$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6e24888a23d546e6$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $8GWoH.factorySpace)(effects, ok, "linePrefix");
    }
}

});

parcelRegister("7twjg", function(module, exports) {

$parcel$export(module.exports, "list", () => $57144dde063f82cb$export$8837f4fc672e936d);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");

var $eRfeJ = parcelRequire("eRfeJ");

var $eBJ0T = parcelRequire("eBJ0T");
const $57144dde063f82cb$export$8837f4fc672e936d = {
    name: "list",
    tokenize: $57144dde063f82cb$var$tokenizeListStart,
    continuation: {
        tokenize: $57144dde063f82cb$var$tokenizeListContinuation
    },
    exit: $57144dde063f82cb$var$tokenizeListEnd
};
/** @type {Construct} */ const $57144dde063f82cb$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $57144dde063f82cb$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $57144dde063f82cb$var$indentConstruct = {
    tokenize: $57144dde063f82cb$var$tokenizeIndent,
    partial: true
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $57144dde063f82cb$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $5Lprs.asciiDigit)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $eBJ0T.thematicBreak), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $5Lprs.asciiDigit)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $eRfeJ.blankLine), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($57144dde063f82cb$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $57144dde063f82cb$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $eRfeJ.blankLine), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $8GWoH.factorySpace)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $5Lprs.markdownSpace)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($57144dde063f82cb$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $8GWoH.factorySpace)(effects, effects.attempt($57144dde063f82cb$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $57144dde063f82cb$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $8GWoH.factorySpace)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */ function $57144dde063f82cb$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $57144dde063f82cb$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $8GWoH.factorySpace)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $5Lprs.markdownSpace)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

});
parcelRegister("eBJ0T", function(module, exports) {

$parcel$export(module.exports, "thematicBreak", () => $aa27701f1509407c$export$ba7b13e047416c03);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
const $aa27701f1509407c$export$ba7b13e047416c03 = {
    name: "thematicBreak",
    tokenize: $aa27701f1509407c$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $aa27701f1509407c$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $5Lprs.markdownLineEnding)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}

});


parcelRegister("cfK44", function(module, exports) {

$parcel$export(module.exports, "setextUnderline", () => $8eba9e38644cd781$export$e104e2de391dfde9);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
const $8eba9e38644cd781$export$e104e2de391dfde9 = {
    name: "setextUnderline",
    tokenize: $8eba9e38644cd781$var$tokenizeSetextUnderline,
    resolveTo: $8eba9e38644cd781$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $8eba9e38644cd781$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === "enter") {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            "enter",
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            "exit",
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        "exit",
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8eba9e38644cd781$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}

});



parcelRegister("hFzKD", function(module, exports) {

$parcel$export(module.exports, "preprocess", () => $cdd1ff6afd8515e5$export$fc37fe19dfda43ee);
/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */ const $cdd1ff6afd8515e5$var$search = /[\0\t\n\r]/g;
function $cdd1ff6afd8515e5$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = "";
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        // @ts-expect-error `Buffer` does allow an encoding.
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = "";
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $cdd1ff6afd8515e5$var$search.lastIndex = startPosition;
            match = $cdd1ff6afd8515e5$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}

});

parcelRegister("6Jw5n", function(module, exports) {

$parcel$export(module.exports, "postprocess", () => $4e6fd59d488c6494$export$bd0e6e1378a871d7);
/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
var $iNbDn = parcelRequire("iNbDn");
function $4e6fd59d488c6494$export$bd0e6e1378a871d7(events) {
    while(!(0, $iNbDn.subtokenize)(events));
    return events;
}

});

parcelRegister("34rZa", function(module, exports) {

$parcel$export(module.exports, "decodeNumericCharacterReference", () => $23c7742930bb7617$export$15a69557afac2c20);
/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCharCode(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $23c7742930bb7617$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 /* eslint-enable no-bitwise */  || // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCharCode(code);
}

});

parcelRegister("1lC1m", function(module, exports) {

$parcel$export(module.exports, "decodeString", () => $0fb53ec7385928f9$export$a0fb664af7d0cc44);

var $gxs7E = parcelRequire("gxs7E");

var $34rZa = parcelRequire("34rZa");
const $0fb53ec7385928f9$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $0fb53ec7385928f9$export$a0fb664af7d0cc44(value) {
    return value.replace($0fb53ec7385928f9$var$characterEscapeOrReference, $0fb53ec7385928f9$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $0fb53ec7385928f9$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $34rZa.decodeNumericCharacterReference)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $gxs7E.decodeNamedCharacterReference)($2) || $0;
}

});



parcelRegister("kMNw8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f21eb379270d044c$export$2e2bcd8739ae039);
/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */ 
var $aQILc = parcelRequire("aQILc");
// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(
/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */ const $f21eb379270d044c$var$remarkRehype = /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */ function(destination, options) {
    return destination && "run" in destination ? $f21eb379270d044c$var$bridge(destination, options) : $f21eb379270d044c$var$mutate(destination || options);
};
var $f21eb379270d044c$export$2e2bcd8739ae039 = $f21eb379270d044c$var$remarkRehype;
/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */ function $f21eb379270d044c$var$bridge(destination, options) {
    return (node, file, next)=>{
        destination.run((0, $aQILc.toHast)(node, options), file, (error)=>{
            next(error);
        });
    };
}
/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */ function $f21eb379270d044c$var$mutate(options) {
    // @ts-expect-error: assume a corresponding node is returned by `toHast`.
    return (node)=>(0, $aQILc.toHast)(node, options);
}

});
parcelRegister("aQILc", function(module, exports) {

$parcel$export(module.exports, "toHast", () => $7e617b312af6d4e3$export$c0e4c5cf07538633);
/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Root} HastRoot
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Root} MdastRoot
 *
 * @typedef {import('./state.js').Options} Options
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 */ 
var $kkbmd = parcelRequire("kkbmd");

var $bZbw8 = parcelRequire("bZbw8");
function $7e617b312af6d4e3$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $bZbw8.createState)(tree, options);
    const node = state.one(tree, null);
    const foot = (0, $kkbmd.footer)(state);
    if (foot) // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push({
        type: "text",
        value: "\n"
    }, foot);
    // To do: next major: always return root?
    return Array.isArray(node) ? {
        type: "root",
        children: node
    } : node;
}

});
parcelRegister("kkbmd", function(module, exports) {

$parcel$export(module.exports, "footer", () => $ecbe7c366eca1f30$export$adb608be33961c98);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ 
var $8sB1o = parcelRequire("8sB1o");
function $ecbe7c366eca1f30$export$adb608be33961c98(state) {
    /** @type {Array<ElementContent>} */ const listItems = [];
    let index = -1;
    while(++index < state.footnoteOrder.length){
        const def = state.footnoteById[state.footnoteOrder[index]];
        if (!def) continue;
        const content = state.all(def);
        const id = String(def.identifier).toUpperCase();
        const safeId = (0, $8sB1o.normalizeUri)(id.toLowerCase());
        let referenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        while(++referenceIndex <= state.footnoteCounts[id]){
            /** @type {Element} */ const backReference = {
                type: "element",
                tagName: "a",
                properties: {
                    href: "#" + state.clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : ""),
                    dataFootnoteBackref: true,
                    className: [
                        "data-footnote-backref"
                    ],
                    ariaLabel: state.footnoteBackLabel
                },
                children: [
                    {
                        type: "text",
                        value: "\u21A9"
                    }
                ]
            };
            if (referenceIndex > 1) backReference.children.push({
                type: "element",
                tagName: "sup",
                children: [
                    {
                        type: "text",
                        value: String(referenceIndex)
                    }
                ]
            });
            if (backReferences.length > 0) backReferences.push({
                type: "text",
                value: " "
            });
            backReferences.push(backReference);
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === "element" && tail.tagName === "p") {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === "text") tailTail.value += " ";
            else tail.children.push({
                type: "text",
                value: " "
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: "element",
            tagName: "li",
            properties: {
                id: state.clobberPrefix + "fn-" + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(def, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: "element",
        tagName: "section",
        properties: {
            dataFootnotes: true,
            className: [
                "footnotes"
            ]
        },
        children: [
            {
                type: "element",
                tagName: state.footnoteLabelTagName,
                properties: {
                    // To do: use structured clone.
                    ...JSON.parse(JSON.stringify(state.footnoteLabelProperties)),
                    id: "footnote-label"
                },
                children: [
                    {
                        type: "text",
                        value: state.footnoteLabel
                    }
                ]
            },
            {
                type: "text",
                value: "\n"
            },
            {
                type: "element",
                tagName: "ol",
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: "text",
                value: "\n"
            }
        ]
    };
}

});
parcelRegister("8sB1o", function(module, exports) {

$parcel$export(module.exports, "sanitizeUri", () => $628da7f4dfdef27c$export$d130a2d684099e5a);
$parcel$export(module.exports, "normalizeUri", () => $628da7f4dfdef27c$export$e42a3e39590d28b5);

var $5Lprs = parcelRequire("5Lprs");

var $8OFFA = parcelRequire("8OFFA");
function $628da7f4dfdef27c$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $8OFFA.encode)($628da7f4dfdef27c$export$e42a3e39590d28b5(url || ""));
    if (!protocol) return value;
    const colon = value.indexOf(":");
    const questionMark = value.indexOf("?");
    const numberSign = value.indexOf("#");
    const slash = value.indexOf("/");
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return "";
}
function $628da7f4dfdef27c$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = "";
        // A correct percent encoded value.
        if (code === 37 && (0, $5Lprs.asciiAlphanumeric)(value.charCodeAt(index + 1)) && (0, $5Lprs.asciiAlphanumeric)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = "";
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join("") + value.slice(start);
}

});
parcelRegister("8OFFA", function(module, exports) {

$parcel$export(module.exports, "encode", () => $66b350feb28b9f84$export$c564cdbbe6da493);
const $66b350feb28b9f84$var$characterReferences = {
    '"': "quot",
    "&": "amp",
    "<": "lt",
    ">": "gt"
};
function $66b350feb28b9f84$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return "&" + $66b350feb28b9f84$var$characterReferences[value] + ";";
    }
}

});



parcelRegister("bZbw8", function(module, exports) {

$parcel$export(module.exports, "createState", () => $8b9e53555aca6b47$export$e6a0daad8304de);
/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} MdastRoot
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 * @typedef {Extract<MdastNodes, MdastParent>} MdastParents
 *
 * @typedef EmbeddedHastFields
 *   hast fields.
 * @property {string | null | undefined} [hName]
 *   Generate a specific element with this tag name instead.
 * @property {HastProperties | null | undefined} [hProperties]
 *   Generate an element with these properties instead.
 * @property {Array<HastElementContent> | null | undefined} [hChildren]
 *   Generate an element with this content instead.
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} MdastData
 *   mdast data with embedded hast fields.
 *
 * @typedef {MdastNodes & {data?: MdastData | null | undefined}} MdastNodeWithData
 *   mdast node with embedded hast data.
 *
 * @typedef PointLike
 *   Point-like value.
 * @property {number | null | undefined} [line]
 *   Line.
 * @property {number | null | undefined} [column]
 *   Column.
 * @property {number | null | undefined} [offset]
 *   Offset.
 *
 * @typedef PositionLike
 *   Position-like value.
 * @property {PointLike | null | undefined} [start]
 *   Point-like value.
 * @property {PointLike | null | undefined} [end]
 *   Point-like value.
 *
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | null | undefined} parent
 *   Parent of `node`.
 * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
 *   hast node.
 *
 * @callback HFunctionProps
 *   Signature of `state` for when props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {HastProperties} props
 *   Properties.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @callback HFunctionNoProps
 *   Signature of `state` for when no props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @typedef HFields
 *   Info on `state`.
 * @property {boolean} dangerous
 *   Whether HTML is allowed.
 * @property {string} clobberPrefix
 *   Prefix to use to prevent DOM clobbering.
 * @property {string} footnoteLabel
 *   Label to use to introduce the footnote section.
 * @property {string} footnoteLabelTagName
 *   HTML used for the footnote label.
 * @property {HastProperties} footnoteLabelProperties
 *   Properties on the HTML tag used for the footnote label.
 * @property {string} footnoteBackLabel
 *   Label to use from backreferences back to their footnote call.
 * @property {(identifier: string) => MdastDefinition | null} definition
 *   Definition cache.
 * @property {Record<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Record<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {Handler} unknownHandler
 *   Handler for any none not in `passThrough` or otherwise handled.
 * @property {(from: MdastNodes, node: HastNodes) => void} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => Type | HastElement} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {(node: MdastNodes, parent: MdastParents | null | undefined) => HastElementContent | Array<HastElementContent> | null | undefined} one
 *   Transform an mdast node to hast.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastContent>(nodes: Array<Type>, loose?: boolean | null | undefined) => Array<Type | HastText>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 * @property {(left: MdastNodeWithData | PositionLike | null | undefined, right: HastElementContent) => HastElementContent} augment
 *   Like `state` but lower-level and usable on non-elements.
 *   Deprecated: use `patch` and `applyData`.
 * @property {Array<string>} passThrough
 *   List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree.
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent it from
 *   *clobbering*.
 * @property {string | null | undefined} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call (affects
 *   screen readers).
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section (affects screen readers).
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (note that `id: 'footnote-label'`
 *   is always added as footnote calls use it with `aria-describedby` to
 *   provide an accessible label).
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   Tag name to use for the footnote label.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes.
 * @property {Array<string> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Handle nodes.
 *
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} State
 *   Info passed around.
 */ 
var $6qkIL = parcelRequire("6qkIL");

var $bvXuE = parcelRequire("bvXuE");

var $3ZDbL = parcelRequire("3ZDbL");

var $jyH67 = parcelRequire("jyH67");

var $fRzrI = parcelRequire("fRzrI");
const $8b9e53555aca6b47$var$own = {}.hasOwnProperty;
function $8b9e53555aca6b47$export$e6a0daad8304de(tree, options) {
    const settings = options || {};
    const dangerous = settings.allowDangerousHtml || false;
    /** @type {Record<string, MdastFootnoteDefinition>} */ const footnoteById = {};
    // To do: next major: add `options` to state, remove:
    // `dangerous`, `clobberPrefix`, `footnoteLabel`, `footnoteLabelTagName`,
    // `footnoteLabelProperties`, `footnoteBackLabel`, `passThrough`,
    // `unknownHandler`.
    // To do: next major: move to `state.options.allowDangerousHtml`.
    state.dangerous = dangerous;
    // To do: next major: move to `state.options`.
    state.clobberPrefix = settings.clobberPrefix === undefined || settings.clobberPrefix === null ? "user-content-" : settings.clobberPrefix;
    // To do: next major: move to `state.options`.
    state.footnoteLabel = settings.footnoteLabel || "Footnotes";
    // To do: next major: move to `state.options`.
    state.footnoteLabelTagName = settings.footnoteLabelTagName || "h2";
    // To do: next major: move to `state.options`.
    state.footnoteLabelProperties = settings.footnoteLabelProperties || {
        className: [
            "sr-only"
        ]
    };
    // To do: next major: move to `state.options`.
    state.footnoteBackLabel = settings.footnoteBackLabel || "Back to content";
    // To do: next major: move to `state.options`.
    state.unknownHandler = settings.unknownHandler;
    // To do: next major: move to `state.options`.
    state.passThrough = settings.passThrough;
    state.handlers = {
        ...(0, $fRzrI.handlers),
        ...settings.handlers
    };
    // To do: next major: replace utility with `definitionById` object, so we
    // only walk once (as we need footnotes too).
    state.definition = (0, $jyH67.definitions)(tree);
    state.footnoteById = footnoteById;
    /** @type {Array<string>} */ state.footnoteOrder = [];
    /** @type {Record<string, number>} */ state.footnoteCounts = {};
    state.patch = $8b9e53555aca6b47$var$patch;
    state.applyData = $8b9e53555aca6b47$var$applyData;
    state.one = oneBound;
    state.all = allBound;
    state.wrap = $8b9e53555aca6b47$export$4997ffc0176396a6;
    // To do: next major: remove `augment`.
    state.augment = augment;
    (0, $6qkIL.visit)(tree, "footnoteDefinition", (definition)=>{
        const id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$8b9e53555aca6b47$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    });
    // @ts-expect-error Hush, it’s fine!
    return state;
    /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   *
   * @param {MdastNodeWithData | PositionLike | null | undefined} left
   * @param {HastElementContent} right
   * @returns {HastElementContent}
   */ /* c8 ignore start */ // To do: next major: remove.
    function augment(left, right) {
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && "data" in left && left.data) {
            /** @type {MdastData} */ const data = left.data;
            if (data.hName) {
                if (right.type !== "element") right = {
                    type: "element",
                    tagName: "",
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === "element" && data.hProperties) right.properties = {
                ...right.properties,
                ...data.hProperties
            };
            if ("children" in right && right.children && data.hChildren) right.children = data.hChildren;
        }
        if (left) {
            const ctx = "type" in left ? left : {
                position: left
            };
            if (!(0, $3ZDbL.generated)(ctx)) // @ts-expect-error: fine.
            right.position = {
                start: (0, $bvXuE.pointStart)(ctx),
                end: (0, $bvXuE.pointEnd)(ctx)
            };
        }
        return right;
    }
    /* c8 ignore stop */ /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */ /* c8 ignore start */ // To do: next major: remove.
    function state(node, tagName, props, children) {
        if (Array.isArray(props)) {
            children = props;
            props = {};
        }
        // @ts-expect-error augmenting an element yields an element.
        return augment(node, {
            type: "element",
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    /* c8 ignore stop */ /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | null | undefined} [parent]
   *   Parent of `node`.
   * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
   *   Resulting hast node.
   */ function oneBound(node, parent) {
        // @ts-expect-error: that’s a state :)
        return $8b9e53555aca6b47$export$80bf7733f1207381(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function allBound(parent) {
        // @ts-expect-error: that’s a state :)
        return $8b9e53555aca6b47$export$84bf76cd7afc7469(state, parent);
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {void}
 *   Nothing.
 */ function $8b9e53555aca6b47$var$patch(from, to) {
    if (from.position) to.position = (0, $bvXuE.position)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {Type | HastElement}
 *   Nothing.
 */ function $8b9e53555aca6b47$var$applyData(from, to) {
    /** @type {Type | HastElement} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === "string") {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === "element") result.tagName = hName;
            else result = {
                type: "element",
                tagName: hName,
                properties: {},
                children: []
            };
        }
        if (result.type === "element" && hProperties) result.properties = {
            ...result.properties,
            ...hProperties
        };
        if ("children" in result && result.children && hChildren !== null && hChildren !== undefined) // @ts-expect-error: assume valid children are defined.
        result.children = hChildren;
    }
    return result;
}
function $8b9e53555aca6b47$export$80bf7733f1207381(state, node, parent) {
    const type = node && node.type;
    // Fail on non-nodes.
    if (!type) throw new Error("Expected node, got `" + node + "`");
    if ($8b9e53555aca6b47$var$own.call(state.handlers, type)) return state.handlers[type](state, node, parent);
    if (state.passThrough && state.passThrough.includes(type)) // To do: next major: deep clone.
    // @ts-expect-error: types of passed through nodes are expected to be added manually.
    return "children" in node ? {
        ...node,
        children: $8b9e53555aca6b47$export$84bf76cd7afc7469(state, node)
    } : node;
    if (state.unknownHandler) return state.unknownHandler(state, node, parent);
    return $8b9e53555aca6b47$var$defaultUnknownHandler(state, node);
}
function $8b9e53555aca6b47$export$84bf76cd7afc7469(state, parent) {
    /** @type {Array<HastElementContent>} */ const values = [];
    if ("children" in parent) {
        const nodes = parent.children;
        let index = -1;
        while(++index < nodes.length){
            const result = $8b9e53555aca6b47$export$80bf7733f1207381(state, nodes[index], parent);
            // To do: see if we van clean this? Can we merge texts?
            if (result) {
                if (index && nodes[index - 1].type === "break") {
                    if (!Array.isArray(result) && result.type === "text") result.value = result.value.replace(/^\s+/, "");
                    if (!Array.isArray(result) && result.type === "element") {
                        const head = result.children[0];
                        if (head && head.type === "text") head.value = head.value.replace(/^\s+/, "");
                    }
                }
                if (Array.isArray(result)) values.push(...result);
                else values.push(result);
            }
        }
    }
    return values;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastText | HastElement}
 *   Resulting hast node.
 */ function $8b9e53555aca6b47$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastText | HastElement} */ const result = "value" in node && !($8b9e53555aca6b47$var$own.call(data, "hProperties") || $8b9e53555aca6b47$var$own.call(data, "hChildren")) ? {
        type: "text",
        value: node.value
    } : {
        type: "element",
        tagName: "div",
        properties: {},
        children: $8b9e53555aca6b47$export$84bf76cd7afc7469(state, node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $8b9e53555aca6b47$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<Type | HastText>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: "text",
        value: "\n"
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: "text",
            value: "\n"
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: "text",
        value: "\n"
    });
    return result;
}

});
parcelRegister("6qkIL", function(module, exports) {

$parcel$export(module.exports, "visit", () => $4ad53e9051b55a53$export$bf638b60ea8b89b7);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * Check if `Child` can be a child of `Ancestor`.
 *
 * Returns the ancestor when `Child` can be a child of `Ancestor`, or returns
 * `never`.
 *
 * @template {Node} Ancestor
 *   Node type.
 * @template {Node} Child
 *   Node type.
 * @typedef {(
 *   Ancestor extends Parent
 *     ? Child extends Ancestor['children'][number]
 *       ? Ancestor
 *       : never
 *     : never
 * )} ParentsOf
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends Node ? number | null : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends Node ? Ancestor | null : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * Build a typed `Visitor` function from a node and all possible parents.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Visited
 *   Node type.
 * @template {Parent} Ancestor
 *   Parent type.
 * @typedef {Visitor<Visited, ParentsOf<Ancestor, Visited>>} BuildVisitorFromMatch
 */ /**
 * Build a typed `Visitor` function from a list of descendants and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     import('unist-util-visit-parents/complex-types.js').Matches<Descendant, Check>,
 *     Extract<Descendant, Parent>
 *   >
 * )} BuildVisitorFromDescendants
 */ /**
 * Build a typed `Visitor` function from a tree and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} [Tree=Node]
 *   Node type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     import('unist-util-visit-parents/complex-types.js').InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 */ 
var $imX1f = parcelRequire("imX1f");
const $4ad53e9051b55a53$export$bf638b60ea8b89b7 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    (0, $imX1f.visitParents)(tree, test, overload, reverse);
    /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        return visitor(node, parent ? parent.children.indexOf(node) : null, parent);
    }
};

});
parcelRegister("imX1f", function(module, exports) {

$parcel$export(module.exports, "EXIT", () => $d5f8100665f1cd06$export$7f100f842f565dc9);
$parcel$export(module.exports, "visitParents", () => $d5f8100665f1cd06$export$70008a21eb6de899);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */ /**
 * @typedef {boolean | 'skip'} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<Ancestor>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * @template {Node} [Tree=Node]
 *   Tree type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {Visitor<import('./complex-types.js').Matches<import('./complex-types.js').InclusiveDescendant<Tree>, Check>, Extract<import('./complex-types.js').InclusiveDescendant<Tree>, Parent>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 */ 
var $cWBD6 = parcelRequire("cWBD6");

var $23Fte = parcelRequire("23Fte");
const $d5f8100665f1cd06$export$f4d8133c446fe484 = true;
const $d5f8100665f1cd06$export$7f100f842f565dc9 = false;
const $d5f8100665f1cd06$export$8773f85c2fb2c116 = "skip";
const $d5f8100665f1cd06$export$70008a21eb6de899 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor<Node>} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
    }
    const is = (0, $cWBD6.convert)(test);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
       * @param {Node} node
       * @param {number | undefined} index
       * @param {Array<Parent>} parents
       */ function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */ // @ts-expect-error: hush
        const value = node && typeof node === "object" ? node : {};
        if (typeof value.type === "string") {
            const name = // `hast`
            typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            Object.defineProperty(visit, "name", {
                value: "node (" + (0, $23Fte.color)(node.type + (name ? "<" + name + ">" : "")) + ")"
            });
        }
        return visit;
        function visit() {
            /** @type {ActionTuple} */ let result = [];
            /** @type {ActionTuple} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<Parent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $d5f8100665f1cd06$var$toResult(visitor(node, parents));
                if (result[0] === $d5f8100665f1cd06$export$7f100f842f565dc9) return result;
            }
            // @ts-expect-error looks like a parent.
            if (node.children && result[0] !== $d5f8100665f1cd06$export$8773f85c2fb2c116) {
                // @ts-expect-error looks like a parent.
                offset = (reverse ? node.children.length : -1) + step;
                // @ts-expect-error looks like a parent.
                grandparents = parents.concat(node);
                // @ts-expect-error looks like a parent.
                while(offset > -1 && offset < node.children.length){
                    // @ts-expect-error looks like a parent.
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $d5f8100665f1cd06$export$7f100f842f565dc9) return subresult;
                    offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
};
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */ function $d5f8100665f1cd06$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === "number") return [
        $d5f8100665f1cd06$export$f4d8133c446fe484,
        value
    ];
    return [
        value
    ];
}

});
parcelRegister("cWBD6", function(module, exports) {

$parcel$export(module.exports, "convert", () => $96c8174c61624bc3$export$9c68d69a4c5bbcf9);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @typedef {Record<string, unknown>} Props
 * @typedef {null | undefined | string | Props | TestFunctionAnything | Array<string | Props | TestFunctionAnything>} Test
 *   Check for an arbitrary node, unaware of TypeScript inferral.
 *
 * @callback TestFunctionAnything
 *   Check if a node passes a test, unaware of TypeScript inferral.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | void}
 *   Whether this node passes the test.
 */ /**
 * @template {Node} Kind
 *   Node type.
 * @typedef {Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind> | Array<Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind>>} PredicateTest
 *   Check for a node that can be inferred by TypeScript.
 */ /**
 * Check if a node passes a certain test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback TestFunctionPredicate
 *   Complex test function for a node that can be inferred by TypeScript.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this node passes the test.
 */ /**
 * @callback AssertAnything
 *   Check that an arbitrary value is a node, unaware of TypeScript inferral.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if a node is a node and passes a certain node test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback AssertPredicate
 *   Check that an arbitrary value is a specific node, aware of TypeScript.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param node
 *   Thing to check, typically `Node`.
 * @param test
 *   A check for a specific node.
 * @param index
 *   The node’s position in its parent.
 * @param parent
 *   The node’s parent.
 * @returns
 *   Whether `node` is a node and passes a test.
 */ const $96c8174c61624bc3$export$226b3eccf92c9ed9 = /**
   * @type {(
   *   (() => false) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index: number, parent: Parent, context?: unknown) => node is Kind) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index?: null | undefined, parent?: null | undefined, context?: unknown) => node is Kind) &
   *   ((node: unknown, test: Test, index: number, parent: Parent, context?: unknown) => boolean) &
   *   ((node: unknown, test?: Test, index?: null | undefined, parent?: null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function is(node, test, index, parent, context) {
    const check = $96c8174c61624bc3$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== "number" || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error("Expected positive finite index");
    if (parent !== undefined && parent !== null && (!is(parent) || !parent.children)) throw new Error("Expected parent node");
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error("Expected both parent and index");
    // @ts-expect-error Looks like a node.
    return node && node.type && typeof node.type === "string" ? Boolean(check.call(context, node, index, parent)) : false;
};
const $96c8174c61624bc3$export$9c68d69a4c5bbcf9 = /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {AssertAnything}
     */ function(test) {
    if (test === undefined || test === null) return $96c8174c61624bc3$var$ok;
    if (typeof test === "string") return $96c8174c61624bc3$var$typeFactory(test);
    if (typeof test === "object") return Array.isArray(test) ? $96c8174c61624bc3$var$anyFactory(test) : $96c8174c61624bc3$var$propsFactory(test);
    if (typeof test === "function") return $96c8174c61624bc3$var$castFactory(test);
    throw new Error("Expected function, string, or object as test");
};
/**
 * @param {Array<string | Props | TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */ function $96c8174c61624bc3$var$anyFactory(tests) {
    /** @type {Array<AssertAnything>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $96c8174c61624bc3$export$9c68d69a4c5bbcf9(tests[index]);
    return $96c8174c61624bc3$var$castFactory(any);
    /**
   * @this {unknown}
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].call(this, ...parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */ function $96c8174c61624bc3$var$propsFactory(check) {
    return $96c8174c61624bc3$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        /** @type {string} */ let key;
        for(key in check){
            // @ts-expect-error: hush, it sure works as an index.
            if (node[key] !== check[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {AssertAnything}
 */ function $96c8174c61624bc3$var$typeFactory(check) {
    return $96c8174c61624bc3$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */ function $96c8174c61624bc3$var$castFactory(check) {
    return assertion;
    /**
   * @this {unknown}
   * @param {unknown} node
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function assertion(node, ...parameters) {
        return Boolean(node && typeof node === "object" && "type" in node && // @ts-expect-error: fine.
        Boolean(check.call(this, node, ...parameters)));
    }
}
function $96c8174c61624bc3$var$ok() {
    return true;
}

});

parcelRegister("23Fte", function(module, exports) {

$parcel$export(module.exports, "color", () => $17fc07be418e6e2a$export$35e9368ef982300f);
/**
 * @param {string} d
 * @returns {string}
 */ function $17fc07be418e6e2a$export$35e9368ef982300f(d) {
    return d;
}

});



parcelRegister("bvXuE", function(module, exports) {

$parcel$export(module.exports, "pointStart", () => $8620bd174654fbbb$export$771bf3e4949bfbee);
$parcel$export(module.exports, "pointEnd", () => $8620bd174654fbbb$export$da309cdce9dc2a25);
$parcel$export(module.exports, "position", () => $8620bd174654fbbb$export$5880b8b5730aff45);
/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $8620bd174654fbbb$export$771bf3e4949bfbee = $8620bd174654fbbb$var$point("start");
const $8620bd174654fbbb$export$da309cdce9dc2a25 = $8620bd174654fbbb$var$point("end");
function $8620bd174654fbbb$export$5880b8b5730aff45(node) {
    return {
        start: $8620bd174654fbbb$export$771bf3e4949bfbee(node),
        end: $8620bd174654fbbb$export$da309cdce9dc2a25(node)
    };
}
/**
 * Get the positional info of `node`.
 *
 * @param {'start' | 'end'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $8620bd174654fbbb$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {NodeLike | Node | null | undefined} [node]
   * @returns {Point}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        // To do: next major: don’t return points when invalid.
        return {
            // @ts-expect-error: in practice, null is allowed.
            line: point.line || null,
            // @ts-expect-error: in practice, null is allowed.
            column: point.column || null,
            // @ts-expect-error: in practice, null is allowed.
            offset: point.offset > -1 ? point.offset : null
        };
    }
}

});

parcelRegister("3ZDbL", function(module, exports) {

$parcel$export(module.exports, "generated", () => $2e8577aa1764555c$export$41ad1363166ec91a);
/**
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef NodeLike
 * @property {PositionLike | null | undefined} [position]
 */ /**
 * Check if `node` is generated.
 *
 * @param {NodeLike | null | undefined} [node]
 *   Node to check.
 * @returns {boolean}
 *   Whether `node` is generated (does not have positional info).
 */ function $2e8577aa1764555c$export$41ad1363166ec91a(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}

});

parcelRegister("jyH67", function(module, exports) {

$parcel$export(module.exports, "definitions", () => $e3d29f9dd459ad71$export$d79264f26953ec1);
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Definition} Definition
 */ /**
 * @typedef {Root | Content} Node
 *
 * @callback GetDefinition
 *   Get a definition by identifier.
 * @param {string | null | undefined} [identifier]
 *   Identifier of definition.
 * @returns {Definition | null}
 *   Definition corresponding to `identifier` or `null`.
 */ 
var $6qkIL = parcelRequire("6qkIL");
const $e3d29f9dd459ad71$var$own = {}.hasOwnProperty;
function $e3d29f9dd459ad71$export$d79264f26953ec1(tree) {
    /** @type {Record<string, Definition>} */ const cache = Object.create(null);
    if (!tree || !tree.type) throw new Error("mdast-util-definitions expected node");
    (0, $6qkIL.visit)(tree, "definition", (definition)=>{
        const id = $e3d29f9dd459ad71$var$clean(definition.identifier);
        if (id && !$e3d29f9dd459ad71$var$own.call(cache, id)) cache[id] = definition;
    });
    return definition;
    /** @type {GetDefinition} */ function definition(identifier) {
        const id = $e3d29f9dd459ad71$var$clean(identifier);
        // To do: next major: return `undefined` when not found.
        return id && $e3d29f9dd459ad71$var$own.call(cache, id) ? cache[id] : null;
    }
}
/**
 * @param {string | null | undefined} [value]
 * @returns {string}
 */ function $e3d29f9dd459ad71$var$clean(value) {
    return String(value || "").toUpperCase();
}

});

parcelRegister("fRzrI", function(module, exports) {

$parcel$export(module.exports, "handlers", () => $b8c74d1900518a9c$export$455ce229eb3d2472);

var $2o8Xt = parcelRequire("2o8Xt");

var $6KzeL = parcelRequire("6KzeL");

var $3sTkr = parcelRequire("3sTkr");

var $b9yEm = parcelRequire("b9yEm");

var $jEbG0 = parcelRequire("jEbG0");

var $fVybA = parcelRequire("fVybA");

var $lnXzF = parcelRequire("lnXzF");

var $4bz9C = parcelRequire("4bz9C");

var $6OZbd = parcelRequire("6OZbd");

var $fjbMz = parcelRequire("fjbMz");

var $XPRqY = parcelRequire("XPRqY");

var $hMRr0 = parcelRequire("hMRr0");

var $a7gsl = parcelRequire("a7gsl");

var $jYZ1B = parcelRequire("jYZ1B");

var $1GLMG = parcelRequire("1GLMG");

var $3QY08 = parcelRequire("3QY08");

var $dnuY7 = parcelRequire("dnuY7");

var $ilFhN = parcelRequire("ilFhN");

var $31s29 = parcelRequire("31s29");

var $6h3Vy = parcelRequire("6h3Vy");

var $h6Wpg = parcelRequire("h6Wpg");

var $ea5MT = parcelRequire("ea5MT");

var $4T8VE = parcelRequire("4T8VE");

var $7Ohuf = parcelRequire("7Ohuf");
const $b8c74d1900518a9c$export$455ce229eb3d2472 = {
    blockquote: $2o8Xt.blockquote,
    break: (0, $6KzeL.hardBreak),
    code: $3sTkr.code,
    delete: (0, $b9yEm.strikethrough),
    emphasis: $jEbG0.emphasis,
    footnoteReference: $fVybA.footnoteReference,
    footnote: $lnXzF.footnote,
    heading: $4bz9C.heading,
    html: $6OZbd.html,
    imageReference: $fjbMz.imageReference,
    image: $XPRqY.image,
    inlineCode: $hMRr0.inlineCode,
    linkReference: $a7gsl.linkReference,
    link: $jYZ1B.link,
    listItem: $1GLMG.listItem,
    list: $3QY08.list,
    paragraph: $dnuY7.paragraph,
    root: $ilFhN.root,
    strong: $31s29.strong,
    table: $6h3Vy.table,
    tableCell: $ea5MT.tableCell,
    tableRow: $h6Wpg.tableRow,
    text: $4T8VE.text,
    thematicBreak: $7Ohuf.thematicBreak,
    toml: $b8c74d1900518a9c$var$ignore,
    yaml: $b8c74d1900518a9c$var$ignore,
    definition: $b8c74d1900518a9c$var$ignore,
    footnoteDefinition: $b8c74d1900518a9c$var$ignore
};
// Return nothing for nodes that are ignored.
function $b8c74d1900518a9c$var$ignore() {
    // To do: next major: return `undefined`.
    return null;
}

});
parcelRegister("2o8Xt", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $1bd4c59182a8c0db$export$67dc04e652a298ca);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $1bd4c59182a8c0db$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "blockquote",
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("6KzeL", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $4ea25f56bc4ab4db$export$371da9dd35aba193);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $4ea25f56bc4ab4db$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "br",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: "text",
            value: "\n"
        }
    ];
}

});

parcelRegister("3sTkr", function(module, exports) {

$parcel$export(module.exports, "code", () => $285ee7bbb15a7216$export$6565f9f03506010b);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $285ee7bbb15a7216$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + "\n" : "";
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    const lang = node.lang ? node.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null;
    /** @type {Properties} */ const properties = {};
    if (lang) properties.className = [
        "language-" + lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: "element",
        tagName: "code",
        properties: properties,
        children: [
            {
                type: "text",
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: "element",
        tagName: "pre",
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}

});

parcelRegister("b9yEm", function(module, exports) {

$parcel$export(module.exports, "strikethrough", () => $81eb69b9c3065727$export$19426ff118fe8be);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $81eb69b9c3065727$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "del",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("jEbG0", function(module, exports) {

$parcel$export(module.exports, "emphasis", () => $e4dacf711536e63a$export$bef81ba411953b51);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $e4dacf711536e63a$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "em",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("fVybA", function(module, exports) {

$parcel$export(module.exports, "footnoteReference", () => $b986b283d4b2303e$export$7f87ee744075c1ba);
/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('hast').Element} Element
 * @typedef {import('../state.js').State} State
 */ 
var $8sB1o = parcelRequire("8sB1o");
function $b986b283d4b2303e$export$7f87ee744075c1ba(state, node) {
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $8sB1o.normalizeUri)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    if (index === -1) {
        state.footnoteOrder.push(id);
        state.footnoteCounts[id] = 1;
        counter = state.footnoteOrder.length;
    } else {
        state.footnoteCounts[id]++;
        counter = index + 1;
    }
    const reuseCounter = state.footnoteCounts[id];
    /** @type {Element} */ const link = {
        type: "element",
        tagName: "a",
        properties: {
            href: "#" + state.clobberPrefix + "fn-" + safeId,
            id: state.clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : ""),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                "footnote-label"
            ]
        },
        children: [
            {
                type: "text",
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: "element",
        tagName: "sup",
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}

});

parcelRegister("lnXzF", function(module, exports) {

$parcel$export(module.exports, "footnote", () => $f919f527085484c8$export$3b6a720baa2c20ec);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../state.js').State} State
 */ 
var $fVybA = parcelRequire("fVybA");
function $f919f527085484c8$export$3b6a720baa2c20ec(state, node) {
    const footnoteById = state.footnoteById;
    let no = 1;
    while(no in footnoteById)no++;
    const identifier = String(no);
    footnoteById[identifier] = {
        type: "footnoteDefinition",
        identifier: identifier,
        children: [
            {
                type: "paragraph",
                children: node.children
            }
        ],
        position: node.position
    };
    return (0, $fVybA.footnoteReference)(state, {
        type: "footnoteReference",
        identifier: identifier,
        position: node.position
    });
}

});

parcelRegister("4bz9C", function(module, exports) {

$parcel$export(module.exports, "heading", () => $30c3755df1644b4f$export$46e4a324ac90507f);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $30c3755df1644b4f$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "h" + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("6OZbd", function(module, exports) {

$parcel$export(module.exports, "html", () => $4f76de9e9e350bdd$export$c0bb0b647f701bb5);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').HTML} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Raw | Element | null}
 *   hast node.
 */ function $4f76de9e9e350bdd$export$c0bb0b647f701bb5(state, node) {
    if (state.dangerous) {
        /** @type {Raw} */ const result = {
            type: "raw",
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    // To do: next major: return `undefined`.
    return null;
}

});

parcelRegister("fjbMz", function(module, exports) {

$parcel$export(module.exports, "imageReference", () => $b251c51d74b9f110$export$f281796f6bc3b8db);
/**
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
var $8sB1o = parcelRequire("8sB1o");

var $80HTi = parcelRequire("80HTi");
function $b251c51d74b9f110$export$f281796f6bc3b8db(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $80HTi.revert)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $8sB1o.normalizeUri)(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});
parcelRegister("80HTi", function(module, exports) {

$parcel$export(module.exports, "revert", () => $5d505ea70f5e99b6$export$3fdd26f3d9e7dc78);
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Reference} Reference
 * @typedef {import('mdast').Root} Root
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Reference>} References
 */ // To do: next major: always return array.
/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {References} node
 *   Reference node (image, link).
 * @returns {ElementContent | Array<ElementContent>}
 *   hast content.
 */ function $5d505ea70f5e99b6$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = "]";
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return {
        type: "text",
        value: "![" + node.alt + suffix
    };
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift({
        type: "text",
        value: "["
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push({
        type: "text",
        value: suffix
    });
    return contents;
}

});


parcelRegister("XPRqY", function(module, exports) {

$parcel$export(module.exports, "image", () => $0b3dbd491b361aee$export$5c452ff88e35e47d);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
var $8sB1o = parcelRequire("8sB1o");
function $0b3dbd491b361aee$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $8sB1o.normalizeUri)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("hMRr0", function(module, exports) {

$parcel$export(module.exports, "inlineCode", () => $cf305e5b7c8359a2$export$91b9bee19a0d8569);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $cf305e5b7c8359a2$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: "text",
        value: node.value.replace(/\r?\n|\r/g, " ")
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "code",
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("a7gsl", function(module, exports) {

$parcel$export(module.exports, "linkReference", () => $75d752b13cef91bc$export$e6c469b1b7b2bc6a);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 
var $8sB1o = parcelRequire("8sB1o");

var $80HTi = parcelRequire("80HTi");
function $75d752b13cef91bc$export$e6c469b1b7b2bc6a(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $80HTi.revert)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $8sB1o.normalizeUri)(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("jYZ1B", function(module, exports) {

$parcel$export(module.exports, "link", () => $e8c2f52cedd42914$export$9c30223ca0a664fb);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
var $8sB1o = parcelRequire("8sB1o");
function $e8c2f52cedd42914$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $8sB1o.normalizeUri)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("1GLMG", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $13aec79dac1baed0$export$76c7e83ecc9cdf05);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $13aec79dac1baed0$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $13aec79dac1baed0$var$listLoose(parent) : $13aec79dac1baed0$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === "boolean") {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === "element" && head.tagName === "p") paragraph = head;
        else {
            paragraph = {
                type: "element",
                tagName: "p",
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: "text",
            value: " "
        });
        paragraph.children.unshift({
            type: "element",
            tagName: "input",
            properties: {
                type: "checkbox",
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            "task-list-item"
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== "element" || child.tagName !== "p") children.push({
            type: "text",
            value: "\n"
        });
        if (child.type === "element" && child.tagName === "p" && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== "element" || tail.tagName !== "p")) children.push({
        type: "text",
        value: "\n"
    });
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "li",
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $13aec79dac1baed0$var$listLoose(node) {
    let loose = false;
    if (node.type === "list") {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $13aec79dac1baed0$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $13aec79dac1baed0$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}

});

parcelRegister("3QY08", function(module, exports) {

$parcel$export(module.exports, "list", () => $2ce4c566da0bf73a$export$8837f4fc672e936d);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $2ce4c566da0bf73a$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === "number" && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === "element" && child.tagName === "li" && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes("task-list-item")) {
            properties.className = [
                "contains-task-list"
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: node.ordered ? "ol" : "ul",
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("dnuY7", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $9bd5720f45948cca$export$9c206ddddb32a9b);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $9bd5720f45948cca$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "p",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("ilFhN", function(module, exports) {

$parcel$export(module.exports, "root", () => $d5ba36b5f339f923$export$e8e78c978b129247);
/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastRoot | HastElement}
 *   hast node.
 */ function $d5ba36b5f339f923$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: "root",
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("31s29", function(module, exports) {

$parcel$export(module.exports, "strong", () => $233735fbc90e542a$export$59ae2c325a998f89);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $233735fbc90e542a$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "strong",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("6h3Vy", function(module, exports) {

$parcel$export(module.exports, "table", () => $49176076ea45e866$export$9852986a3ec5f6a0);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
var $bvXuE = parcelRequire("bvXuE");
function $49176076ea45e866$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: "element",
            tagName: "thead",
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: "element",
            tagName: "tbody",
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $bvXuE.pointStart)(node.children[1]);
        const end = (0, $bvXuE.pointEnd)(node.children[node.children.length - 1]);
        if (start.line && end.line) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "table",
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("h6Wpg", function(module, exports) {

$parcel$export(module.exports, "tableRow", () => $c7504d83ca4d4f24$export$ce666bf02318c957);
/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $c7504d83ca4d4f24$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? "th" : "td";
    const align = parent && parent.type === "table" ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: "element",
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(node, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "tr",
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("ea5MT", function(module, exports) {

$parcel$export(module.exports, "tableCell", () => $a4f67d27f2f98679$export$e1e720e5f4603e6a);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $a4f67d27f2f98679$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "td",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("4T8VE", function(module, exports) {

$parcel$export(module.exports, "text", () => $38f3398cf7219e31$export$6f093cfa640b7166);
/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ 
var $dUAea = parcelRequire("dUAea");
function $38f3398cf7219e31$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: "text",
        value: (0, $dUAea.trimLines)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});
parcelRegister("dUAea", function(module, exports) {

$parcel$export(module.exports, "trimLines", () => $a20c9b53bbfad667$export$a771f20bdd13def9);
const $a20c9b53bbfad667$var$tab = 9 /* `\t` */ ;
const $a20c9b53bbfad667$var$space = 32 /* ` ` */ ;
function $a20c9b53bbfad667$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($a20c9b53bbfad667$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($a20c9b53bbfad667$var$trimLine(source.slice(last), last > 0, false));
    return lines.join("");
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $a20c9b53bbfad667$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $a20c9b53bbfad667$var$tab || code === $a20c9b53bbfad667$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $a20c9b53bbfad667$var$tab || code === $a20c9b53bbfad667$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : "";
}

});


parcelRegister("7Ohuf", function(module, exports) {

$parcel$export(module.exports, "thematicBreak", () => $5afac477886e2ad8$export$ba7b13e047416c03);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $5afac477886e2ad8$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "hr",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});





parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("9LDLu", function(module, exports) {

$parcel$export(module.exports, "html", () => $01d5cbc38ad1c0e8$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "svg", () => $01d5cbc38ad1c0e8$export$7ed1367e7fa1ad68);
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ 
var $cOWZl = parcelRequire("cOWZl");

var $7hVQP = parcelRequire("7hVQP");

var $dp35F = parcelRequire("dp35F");

var $9cvpo = parcelRequire("9cvpo");

var $cnARV = parcelRequire("cnARV");

var $9M0Ux = parcelRequire("9M0Ux");

var $b5au4 = parcelRequire("b5au4");

var $dLz4Z = parcelRequire("dLz4Z");

var $i5Okx = parcelRequire("i5Okx");

const $01d5cbc38ad1c0e8$export$c0bb0b647f701bb5 = (0, $cOWZl.merge)([
    (0, $dp35F.xml),
    (0, $7hVQP.xlink),
    (0, $9cvpo.xmlns),
    (0, $cnARV.aria),
    (0, $9M0Ux.html)
], "html");
const $01d5cbc38ad1c0e8$export$7ed1367e7fa1ad68 = (0, $cOWZl.merge)([
    (0, $dp35F.xml),
    (0, $7hVQP.xlink),
    (0, $9cvpo.xmlns),
    (0, $cnARV.aria),
    (0, $b5au4.svg)
], "svg");

});
parcelRegister("cOWZl", function(module, exports) {

$parcel$export(module.exports, "merge", () => $9557e96728c042cf$export$4950aa0f605343fb);
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ 
var $kf7Oc = parcelRequire("kf7Oc");
function $9557e96728c042cf$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $kf7Oc.Schema)(property, normal, space);
}

});
parcelRegister("kf7Oc", function(module, exports) {

$parcel$export(module.exports, "Schema", () => $ebcb43fb277eac89$export$19342e026b58ebb7);
/**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $ebcb43fb277eac89$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $ebcb43fb277eac89$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $ebcb43fb277eac89$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $ebcb43fb277eac89$export$19342e026b58ebb7.prototype.space = null;

});


parcelRegister("7hVQP", function(module, exports) {

$parcel$export(module.exports, "xlink", () => $54e6fef78f3cbe14$export$2bd1230ec7600845);

var $dhyvo = parcelRequire("dhyvo");
const $54e6fef78f3cbe14$export$2bd1230ec7600845 = (0, $dhyvo.create)({
    space: "xlink",
    transform (_, prop) {
        return "xlink:" + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});

});
parcelRegister("dhyvo", function(module, exports) {

$parcel$export(module.exports, "create", () => $9ab7a0f2f5273cb1$export$185802fd694ee1f5);
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ 
var $jZGR1 = parcelRequire("jZGR1");

var $kf7Oc = parcelRequire("kf7Oc");

var $j4RPW = parcelRequire("j4RPW");
const $9ab7a0f2f5273cb1$var$own = {}.hasOwnProperty;
function $9ab7a0f2f5273cb1$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($9ab7a0f2f5273cb1$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $j4RPW.DefinedInfo)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $jZGR1.normalize)(prop)] = prop;
        normal[(0, $jZGR1.normalize)(info.attribute)] = prop;
    }
    return new (0, $kf7Oc.Schema)(property, normal, definition.space);
}

});
parcelRegister("jZGR1", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $e8e4f4c42f412e49$export$a3295358bff77e);
/**
 * @param {string} value
 * @returns {string}
 */ function $e8e4f4c42f412e49$export$a3295358bff77e(value) {
    return value.toLowerCase();
}

});

parcelRegister("j4RPW", function(module, exports) {

$parcel$export(module.exports, "DefinedInfo", () => $de3826e2cce515f8$export$ea6b9f0064e88c9b);

var $7kNqS = parcelRequire("7kNqS");

var $aCrbx = parcelRequire("aCrbx");
/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $de3826e2cce515f8$var$checks = Object.keys($aCrbx);
class $de3826e2cce515f8$export$ea6b9f0064e88c9b extends (0, $7kNqS.Info) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $de3826e2cce515f8$var$mark(this, "space", space);
        if (typeof mask === "number") while(++index < $de3826e2cce515f8$var$checks.length){
            const check = $de3826e2cce515f8$var$checks[index];
            $de3826e2cce515f8$var$mark(this, $de3826e2cce515f8$var$checks[index], (mask & $aCrbx[check]) === $aCrbx[check]);
        }
    }
}
$de3826e2cce515f8$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $de3826e2cce515f8$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}

});
parcelRegister("7kNqS", function(module, exports) {

$parcel$export(module.exports, "Info", () => $5570beed4f72c7cb$export$c4868e4a24d48fad);
class $5570beed4f72c7cb$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.space = null;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.boolean = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.booleanish = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.number = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.defined = false;

});

parcelRegister("aCrbx", function(module, exports) {

$parcel$export(module.exports, "boolean", () => $7bb28a628b951544$export$4a21f16c33752377);
$parcel$export(module.exports, "booleanish", () => $7bb28a628b951544$export$55e9e1fbc638dc8f);
$parcel$export(module.exports, "overloadedBoolean", () => $7bb28a628b951544$export$242ac3d3042558aa);
$parcel$export(module.exports, "number", () => $7bb28a628b951544$export$98e628dec113755e);
$parcel$export(module.exports, "spaceSeparated", () => $7bb28a628b951544$export$ab8645c862eb5a3e);
$parcel$export(module.exports, "commaSeparated", () => $7bb28a628b951544$export$9c8d678629b3d3);
$parcel$export(module.exports, "commaOrSpaceSeparated", () => $7bb28a628b951544$export$2ad25cfebf36cacd);
let $7bb28a628b951544$var$powers = 0;
const $7bb28a628b951544$export$4a21f16c33752377 = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$55e9e1fbc638dc8f = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$242ac3d3042558aa = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$98e628dec113755e = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$ab8645c862eb5a3e = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$9c8d678629b3d3 = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$2ad25cfebf36cacd = $7bb28a628b951544$var$increment();
function $7bb28a628b951544$var$increment() {
    return 2 ** ++$7bb28a628b951544$var$powers;
}

});




parcelRegister("dp35F", function(module, exports) {

$parcel$export(module.exports, "xml", () => $9c2001df32d7e0eb$export$f2913fe8983302e);

var $dhyvo = parcelRequire("dhyvo");
const $9c2001df32d7e0eb$export$f2913fe8983302e = (0, $dhyvo.create)({
    space: "xml",
    transform (_, prop) {
        return "xml:" + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});

});

parcelRegister("9cvpo", function(module, exports) {

$parcel$export(module.exports, "xmlns", () => $6b2d9925b04ededa$export$e20c24a128671213);

var $dhyvo = parcelRequire("dhyvo");

var $kPKic = parcelRequire("kPKic");
const $6b2d9925b04ededa$export$e20c24a128671213 = (0, $dhyvo.create)({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: (0, $kPKic.caseInsensitiveTransform),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});

});
parcelRegister("kPKic", function(module, exports) {

$parcel$export(module.exports, "caseInsensitiveTransform", () => $f2ac7ad36db76cd1$export$32b9e4cec9c208e1);

var $luIs3 = parcelRequire("luIs3");
function $f2ac7ad36db76cd1$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $luIs3.caseSensitiveTransform)(attributes, property.toLowerCase());
}

});
parcelRegister("luIs3", function(module, exports) {

$parcel$export(module.exports, "caseSensitiveTransform", () => $fa5ee16f731231fb$export$5b10b3bc32d7efbc);
/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $fa5ee16f731231fb$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}

});



parcelRegister("cnARV", function(module, exports) {

$parcel$export(module.exports, "aria", () => $90343b68c9a7ed34$export$4d2d26490572750a);

var $aCrbx = parcelRequire("aCrbx");

var $dhyvo = parcelRequire("dhyvo");
const $90343b68c9a7ed34$export$4d2d26490572750a = (0, $dhyvo.create)({
    transform (_, prop) {
        return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $aCrbx.booleanish),
        ariaAutoComplete: null,
        ariaBusy: (0, $aCrbx.booleanish),
        ariaChecked: (0, $aCrbx.booleanish),
        ariaColCount: (0, $aCrbx.number),
        ariaColIndex: (0, $aCrbx.number),
        ariaColSpan: (0, $aCrbx.number),
        ariaControls: (0, $aCrbx.spaceSeparated),
        ariaCurrent: null,
        ariaDescribedBy: (0, $aCrbx.spaceSeparated),
        ariaDetails: null,
        ariaDisabled: (0, $aCrbx.booleanish),
        ariaDropEffect: (0, $aCrbx.spaceSeparated),
        ariaErrorMessage: null,
        ariaExpanded: (0, $aCrbx.booleanish),
        ariaFlowTo: (0, $aCrbx.spaceSeparated),
        ariaGrabbed: (0, $aCrbx.booleanish),
        ariaHasPopup: null,
        ariaHidden: (0, $aCrbx.booleanish),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $aCrbx.spaceSeparated),
        ariaLevel: (0, $aCrbx.number),
        ariaLive: null,
        ariaModal: (0, $aCrbx.booleanish),
        ariaMultiLine: (0, $aCrbx.booleanish),
        ariaMultiSelectable: (0, $aCrbx.booleanish),
        ariaOrientation: null,
        ariaOwns: (0, $aCrbx.spaceSeparated),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $aCrbx.number),
        ariaPressed: (0, $aCrbx.booleanish),
        ariaReadOnly: (0, $aCrbx.booleanish),
        ariaRelevant: null,
        ariaRequired: (0, $aCrbx.booleanish),
        ariaRoleDescription: (0, $aCrbx.spaceSeparated),
        ariaRowCount: (0, $aCrbx.number),
        ariaRowIndex: (0, $aCrbx.number),
        ariaRowSpan: (0, $aCrbx.number),
        ariaSelected: (0, $aCrbx.booleanish),
        ariaSetSize: (0, $aCrbx.number),
        ariaSort: null,
        ariaValueMax: (0, $aCrbx.number),
        ariaValueMin: (0, $aCrbx.number),
        ariaValueNow: (0, $aCrbx.number),
        ariaValueText: null,
        role: null
    }
});

});

parcelRegister("9M0Ux", function(module, exports) {

$parcel$export(module.exports, "html", () => $71d94da779c1399e$export$c0bb0b647f701bb5);

var $aCrbx = parcelRequire("aCrbx");

var $dhyvo = parcelRequire("dhyvo");

var $kPKic = parcelRequire("kPKic");
const $71d94da779c1399e$export$c0bb0b647f701bb5 = (0, $dhyvo.create)({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: (0, $kPKic.caseInsensitiveTransform),
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $aCrbx.commaSeparated),
        acceptCharset: (0, $aCrbx.spaceSeparated),
        accessKey: (0, $aCrbx.spaceSeparated),
        action: null,
        allow: null,
        allowFullScreen: (0, $aCrbx.boolean),
        allowPaymentRequest: (0, $aCrbx.boolean),
        allowUserMedia: (0, $aCrbx.boolean),
        alt: null,
        as: null,
        async: (0, $aCrbx.boolean),
        autoCapitalize: null,
        autoComplete: (0, $aCrbx.spaceSeparated),
        autoFocus: (0, $aCrbx.boolean),
        autoPlay: (0, $aCrbx.boolean),
        blocking: (0, $aCrbx.spaceSeparated),
        capture: null,
        charSet: null,
        checked: (0, $aCrbx.boolean),
        cite: null,
        className: (0, $aCrbx.spaceSeparated),
        cols: (0, $aCrbx.number),
        colSpan: null,
        content: null,
        contentEditable: (0, $aCrbx.booleanish),
        controls: (0, $aCrbx.boolean),
        controlsList: (0, $aCrbx.spaceSeparated),
        coords: (0, $aCrbx.number) | (0, $aCrbx.commaSeparated),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $aCrbx.boolean),
        defer: (0, $aCrbx.boolean),
        dir: null,
        dirName: null,
        disabled: (0, $aCrbx.boolean),
        download: (0, $aCrbx.overloadedBoolean),
        draggable: (0, $aCrbx.booleanish),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $aCrbx.boolean),
        formTarget: null,
        headers: (0, $aCrbx.spaceSeparated),
        height: (0, $aCrbx.number),
        hidden: (0, $aCrbx.boolean),
        high: (0, $aCrbx.number),
        href: null,
        hrefLang: null,
        htmlFor: (0, $aCrbx.spaceSeparated),
        httpEquiv: (0, $aCrbx.spaceSeparated),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $aCrbx.boolean),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $aCrbx.boolean),
        itemId: null,
        itemProp: (0, $aCrbx.spaceSeparated),
        itemRef: (0, $aCrbx.spaceSeparated),
        itemScope: (0, $aCrbx.boolean),
        itemType: (0, $aCrbx.spaceSeparated),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $aCrbx.boolean),
        low: (0, $aCrbx.number),
        manifest: null,
        max: null,
        maxLength: (0, $aCrbx.number),
        media: null,
        method: null,
        min: null,
        minLength: (0, $aCrbx.number),
        multiple: (0, $aCrbx.boolean),
        muted: (0, $aCrbx.boolean),
        name: null,
        nonce: null,
        noModule: (0, $aCrbx.boolean),
        noValidate: (0, $aCrbx.boolean),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $aCrbx.boolean),
        optimum: (0, $aCrbx.number),
        pattern: null,
        ping: (0, $aCrbx.spaceSeparated),
        placeholder: null,
        playsInline: (0, $aCrbx.boolean),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $aCrbx.boolean),
        referrerPolicy: null,
        rel: (0, $aCrbx.spaceSeparated),
        required: (0, $aCrbx.boolean),
        reversed: (0, $aCrbx.boolean),
        rows: (0, $aCrbx.number),
        rowSpan: (0, $aCrbx.number),
        sandbox: (0, $aCrbx.spaceSeparated),
        scope: null,
        scoped: (0, $aCrbx.boolean),
        seamless: (0, $aCrbx.boolean),
        selected: (0, $aCrbx.boolean),
        shadowRootClonable: (0, $aCrbx.boolean),
        shadowRootDelegatesFocus: (0, $aCrbx.boolean),
        shadowRootMode: null,
        shape: null,
        size: (0, $aCrbx.number),
        sizes: null,
        slot: null,
        span: (0, $aCrbx.number),
        spellCheck: (0, $aCrbx.booleanish),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $aCrbx.number),
        step: null,
        style: null,
        tabIndex: (0, $aCrbx.number),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $aCrbx.boolean),
        useMap: null,
        value: (0, $aCrbx.booleanish),
        width: (0, $aCrbx.number),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $aCrbx.spaceSeparated),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $aCrbx.number),
        borderColor: null,
        bottomMargin: (0, $aCrbx.number),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $aCrbx.boolean),
        declare: (0, $aCrbx.boolean),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $aCrbx.number),
        leftMargin: (0, $aCrbx.number),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $aCrbx.number),
        marginWidth: (0, $aCrbx.number),
        noResize: (0, $aCrbx.boolean),
        noHref: (0, $aCrbx.boolean),
        noShade: (0, $aCrbx.boolean),
        noWrap: (0, $aCrbx.boolean),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $aCrbx.number),
        rules: null,
        scheme: null,
        scrolling: (0, $aCrbx.booleanish),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $aCrbx.number),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $aCrbx.number),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $aCrbx.boolean),
        disableRemotePlayback: (0, $aCrbx.boolean),
        prefix: null,
        property: null,
        results: (0, $aCrbx.number),
        security: null,
        unselectable: null
    }
});

});

parcelRegister("b5au4", function(module, exports) {

$parcel$export(module.exports, "svg", () => $81184b40caf3b243$export$7ed1367e7fa1ad68);

var $aCrbx = parcelRequire("aCrbx");

var $dhyvo = parcelRequire("dhyvo");

var $luIs3 = parcelRequire("luIs3");
const $81184b40caf3b243$export$7ed1367e7fa1ad68 = (0, $dhyvo.create)({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        transformOrigin: "transform-origin",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: (0, $luIs3.caseSensitiveTransform),
    properties: {
        about: (0, $aCrbx.commaOrSpaceSeparated),
        accentHeight: (0, $aCrbx.number),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $aCrbx.number),
        amplitude: (0, $aCrbx.number),
        arabicForm: null,
        ascent: (0, $aCrbx.number),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $aCrbx.number),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $aCrbx.number),
        by: null,
        calcMode: null,
        capHeight: (0, $aCrbx.number),
        className: (0, $aCrbx.spaceSeparated),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $aCrbx.number),
        diffuseConstant: (0, $aCrbx.number),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $aCrbx.number),
        dominantBaseline: null,
        download: (0, $aCrbx.boolean),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $aCrbx.number),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $aCrbx.number),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $aCrbx.number),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $aCrbx.commaSeparated),
        g2: (0, $aCrbx.commaSeparated),
        glyphName: (0, $aCrbx.commaSeparated),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $aCrbx.number),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $aCrbx.number),
        horizOriginX: (0, $aCrbx.number),
        horizOriginY: (0, $aCrbx.number),
        id: null,
        ideographic: (0, $aCrbx.number),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $aCrbx.number),
        k: (0, $aCrbx.number),
        k1: (0, $aCrbx.number),
        k2: (0, $aCrbx.number),
        k3: (0, $aCrbx.number),
        k4: (0, $aCrbx.number),
        kernelMatrix: (0, $aCrbx.commaOrSpaceSeparated),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $aCrbx.number),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $aCrbx.number),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $aCrbx.number),
        overlineThickness: (0, $aCrbx.number),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $aCrbx.number),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $aCrbx.spaceSeparated),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $aCrbx.number),
        pointsAtY: (0, $aCrbx.number),
        pointsAtZ: (0, $aCrbx.number),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $aCrbx.commaOrSpaceSeparated),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $aCrbx.commaOrSpaceSeparated),
        rev: (0, $aCrbx.commaOrSpaceSeparated),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $aCrbx.commaOrSpaceSeparated),
        requiredFeatures: (0, $aCrbx.commaOrSpaceSeparated),
        requiredFonts: (0, $aCrbx.commaOrSpaceSeparated),
        requiredFormats: (0, $aCrbx.commaOrSpaceSeparated),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $aCrbx.number),
        specularExponent: (0, $aCrbx.number),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $aCrbx.number),
        strikethroughThickness: (0, $aCrbx.number),
        string: null,
        stroke: null,
        strokeDashArray: (0, $aCrbx.commaOrSpaceSeparated),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $aCrbx.number),
        strokeOpacity: (0, $aCrbx.number),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $aCrbx.number),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $aCrbx.commaOrSpaceSeparated),
        tabIndex: (0, $aCrbx.number),
        tableValues: null,
        target: null,
        targetX: (0, $aCrbx.number),
        targetY: (0, $aCrbx.number),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $aCrbx.commaOrSpaceSeparated),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $aCrbx.number),
        underlineThickness: (0, $aCrbx.number),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $aCrbx.number),
        values: null,
        vAlphabetic: (0, $aCrbx.number),
        vMathematical: (0, $aCrbx.number),
        vectorEffect: null,
        vHanging: (0, $aCrbx.number),
        vIdeographic: (0, $aCrbx.number),
        version: null,
        vertAdvY: (0, $aCrbx.number),
        vertOriginX: (0, $aCrbx.number),
        vertOriginY: (0, $aCrbx.number),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $aCrbx.number),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});

});

parcelRegister("dLz4Z", function(module, exports) {

$parcel$export(module.exports, "find", () => $a05ae03077f3d80b$export$71aa6c912b956294);
/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ 
var $jZGR1 = parcelRequire("jZGR1");

var $j4RPW = parcelRequire("j4RPW");

var $7kNqS = parcelRequire("7kNqS");
const $a05ae03077f3d80b$var$valid = /^data[-\w.:]+$/i;
const $a05ae03077f3d80b$var$dash = /-[a-z]/g;
const $a05ae03077f3d80b$var$cap = /[A-Z]/g;
function $a05ae03077f3d80b$export$71aa6c912b956294(schema, value) {
    const normal = (0, $jZGR1.normalize)(value);
    let prop = value;
    let Type = (0, $7kNqS.Info);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === "data" && $a05ae03077f3d80b$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") {
            // Turn it into a property.
            const rest = value.slice(5).replace($a05ae03077f3d80b$var$dash, $a05ae03077f3d80b$var$camelcase);
            prop = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$a05ae03077f3d80b$var$dash.test(rest)) {
                let dashes = rest.replace($a05ae03077f3d80b$var$cap, $a05ae03077f3d80b$var$kebab);
                if (dashes.charAt(0) !== "-") dashes = "-" + dashes;
                value = "data" + dashes;
            }
        }
        Type = (0, $j4RPW.DefinedInfo);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $a05ae03077f3d80b$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $a05ae03077f3d80b$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

});

parcelRegister("i5Okx", function(module, exports) {

$parcel$export(module.exports, "hastToReact", () => $d2bfbc2ede41b173$export$d8abd7e5fb6871f9);
/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $d2bfbc2ede41b173$export$d8abd7e5fb6871f9 = {
    classId: "classID",
    dataType: "datatype",
    itemId: "itemID",
    strokeDashArray: "strokeDasharray",
    strokeDashOffset: "strokeDashoffset",
    strokeLineCap: "strokeLinecap",
    strokeLineJoin: "strokeLinejoin",
    strokeMiterLimit: "strokeMiterlimit",
    typeOf: "typeof",
    xLinkActuate: "xlinkActuate",
    xLinkArcRole: "xlinkArcrole",
    xLinkHref: "xlinkHref",
    xLinkRole: "xlinkRole",
    xLinkShow: "xlinkShow",
    xLinkTitle: "xlinkTitle",
    xLinkType: "xlinkType",
    xmlnsXLink: "xmlnsXlink"
};

});


parcelRegister("2Hi3l", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f6d99e229d437d1$export$2e2bcd8739ae039);

var $6qkIL = parcelRequire("6qkIL");
function $1f6d99e229d437d1$export$2e2bcd8739ae039(options) {
    if (options.allowedElements && options.disallowedElements) throw new TypeError("Only one of `allowedElements` and `disallowedElements` should be defined");
    if (options.allowedElements || options.disallowedElements || options.allowElement) return (tree)=>{
        (0, $6qkIL.visit)(tree, "element", (node, index, parent_)=>{
            const parent = /** @type {Element|Root} */ parent_;
            /** @type {boolean|undefined} */ let remove;
            if (options.allowedElements) remove = !options.allowedElements.includes(node.tagName);
            else if (options.disallowedElements) remove = options.disallowedElements.includes(node.tagName);
            if (!remove && options.allowElement && typeof index === "number") remove = !options.allowElement(node, index, parent);
            if (remove && typeof index === "number") {
                if (options.unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
            return undefined;
        });
    };
}

});

parcelRegister("i5UZr", function(module, exports) {

$parcel$export(module.exports, "childrenToReact", () => $d2c4e6a13f14eb77$export$4b745c302603ab5d);
/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */ /**
 * @template {import('react').ElementType} T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */ /**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types.js').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'td'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: false}} TableDataCellProps
 * @typedef {ComponentPropsWithoutRef<'th'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: true}} TableHeaderCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableDataCellProps>} TableDataCellComponent
 * @typedef {ComponentType<TableHeaderCellProps>} TableHeaderCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableDataCellComponent|ReactMarkdownNames} td
 * @property {TableHeaderCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types.js').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */ 
var $acw62 = parcelRequire("acw62");

var $4jPKB = parcelRequire("4jPKB");

var $fWRhB = parcelRequire("fWRhB");

var $dLz4Z = parcelRequire("dLz4Z");
var $i5Okx = parcelRequire("i5Okx");
var $9LDLu = parcelRequire("9LDLu");

var $4T1Yz = parcelRequire("4T1Yz");

var $ath1E = parcelRequire("ath1E");

var $9BYkS = parcelRequire("9BYkS");

var $1hTyX = parcelRequire("1hTyX");
const $d2c4e6a13f14eb77$var$own = {}.hasOwnProperty;
// The table-related elements that must not contain whitespace text according
// to React.
const $d2c4e6a13f14eb77$var$tableElements = new Set([
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr"
]);
function $d2c4e6a13f14eb77$export$4b745c302603ab5d(context, node) {
    /** @type {Array<ReactNode>} */ const children = [];
    let childIndex = -1;
    /** @type {Comment|Doctype|Element|Raw|Text} */ let child;
    while(++childIndex < node.children.length){
        child = node.children[childIndex];
        if (child.type === "element") children.push($d2c4e6a13f14eb77$var$toReact(context, child, childIndex, node));
        else if (child.type === "text") // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we drop it.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        // See: <https://github.com/remarkjs/react-markdown/issues/576>.
        {
            if (node.type !== "element" || !$d2c4e6a13f14eb77$var$tableElements.has(node.tagName) || !(0, $fWRhB.whitespace)(child)) children.push(child.value);
        } else if (child.type === "raw" && !context.options.skipHtml) // Default behavior is to show (encoded) HTML.
        children.push(child.value);
    }
    return children;
}
/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */ function $d2c4e6a13f14eb77$var$toReact(context, node, index, parent) {
    const options = context.options;
    const transform = options.transformLinkUri === undefined ? (0, $1hTyX.uriTransformer) : options.transformLinkUri;
    const parentSchema = context.schema;
    /** @type {ReactMarkdownNames} */ // @ts-expect-error assume a known HTML/SVG element.
    const name = node.tagName;
    /** @type {Record<string, unknown>} */ const properties = {};
    let schema = parentSchema;
    /** @type {string} */ let property;
    if (parentSchema.space === "html" && name === "svg") {
        schema = (0, $9LDLu.svg);
        context.schema = schema;
    }
    if (node.properties) {
        for(property in node.properties)if ($d2c4e6a13f14eb77$var$own.call(node.properties, property)) $d2c4e6a13f14eb77$var$addProperty(properties, property, node.properties[property], context);
    }
    if (name === "ol" || name === "ul") context.listDepth++;
    const children = $d2c4e6a13f14eb77$export$4b745c302603ab5d(context, node);
    if (name === "ol" || name === "ul") context.listDepth--;
    // Restore parent schema.
    context.schema = parentSchema;
    // Nodes created by plugins do not have positional info, in which case we use
    // an object that matches the position interface.
    const position = node.position || {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    const component = options.components && $d2c4e6a13f14eb77$var$own.call(options.components, name) ? options.components[name] : name;
    const basic = typeof component === "string" || component === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4jPKB))).isValidElementType(component)) throw new TypeError(`Component for name \`${name}\` not defined or is not renderable`);
    properties.key = index;
    if (name === "a" && options.linkTarget) properties.target = typeof options.linkTarget === "function" ? options.linkTarget(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null) : options.linkTarget;
    if (name === "a" && transform) properties.href = transform(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "code" && parent.type === "element" && parent.tagName !== "pre") properties.inline = true;
    if (!basic && (name === "h1" || name === "h2" || name === "h3" || name === "h4" || name === "h5" || name === "h6")) properties.level = Number.parseInt(name.charAt(1), 10);
    if (name === "img" && options.transformImageUri) properties.src = options.transformImageUri(String(properties.src || ""), String(properties.alt || ""), typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "li" && parent.type === "element") {
        const input = $d2c4e6a13f14eb77$var$getInputElement(node);
        properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
        properties.index = $d2c4e6a13f14eb77$var$getElementsBeforeCount(parent, node);
        properties.ordered = parent.tagName === "ol";
    }
    if (!basic && (name === "ol" || name === "ul")) {
        properties.ordered = name === "ol";
        properties.depth = context.listDepth;
    }
    if (name === "td" || name === "th") {
        if (properties.align) {
            if (!properties.style) properties.style = {};
            // @ts-expect-error assume `style` is an object
            properties.style.textAlign = properties.align;
            delete properties.align;
        }
        if (!basic) properties.isHeader = name === "th";
    }
    if (!basic && name === "tr" && parent.type === "element") properties.isHeader = Boolean(parent.tagName === "thead");
    // If `sourcePos` is given, pass source information (line/column info from markdown source).
    if (options.sourcePos) properties["data-sourcepos"] = $d2c4e6a13f14eb77$var$flattenPosition(position);
    if (!basic && options.rawSourcePos) properties.sourcePosition = node.position;
    // If `includeElementIndex` is given, pass node index info to components.
    if (!basic && options.includeElementIndex) {
        properties.index = $d2c4e6a13f14eb77$var$getElementsBeforeCount(parent, node);
        properties.siblingCount = $d2c4e6a13f14eb77$var$getElementsBeforeCount(parent);
    }
    if (!basic) properties.node = node;
    // Ensure no React warnings are emitted for void elements w/ children.
    return children.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, properties, children) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, properties);
}
/**
 * @param {Element|Root} node
 * @returns {Element?}
 */ function $d2c4e6a13f14eb77$var$getInputElement(node) {
    let index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        if (child.type === "element" && child.tagName === "input") return child;
    }
    return null;
}
/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */ function $d2c4e6a13f14eb77$var$getElementsBeforeCount(parent, node) {
    let index = -1;
    let count = 0;
    while(++index < parent.children.length){
        if (parent.children[index] === node) break;
        if (parent.children[index].type === "element") count++;
    }
    return count;
}
/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */ function $d2c4e6a13f14eb77$var$addProperty(props, prop, value, ctx) {
    const info = (0, $dLz4Z.find)(ctx.schema, prop);
    let result = value;
    // Ignore nullish and `NaN` values.
    // eslint-disable-next-line no-self-compare
    if (result === null || result === undefined || result !== result) return;
    // Accept `array`.
    // Most props are space-separated.
    if (Array.isArray(result)) result = info.commaSeparated ? (0, $ath1E.stringify)(result) : (0, $4T1Yz.stringify)(result);
    if (info.property === "style" && typeof result === "string") result = $d2c4e6a13f14eb77$var$parseStyle(result);
    if (info.space && info.property) props[$d2c4e6a13f14eb77$var$own.call((0, $i5Okx.hastToReact), info.property) ? (0, $i5Okx.hastToReact)[info.property] : info.property] = result;
    else if (info.attribute) props[info.attribute] = result;
}
/**
 * @param {string} value
 * @returns {Record<string, string>}
 */ function $d2c4e6a13f14eb77$var$parseStyle(value) {
    /** @type {Record<string, string>} */ const result = {};
    try {
        (0, $9BYkS.default)(value, iterator);
    } catch  {
    // Silent.
    }
    return result;
    /**
   * @param {string} name
   * @param {string} v
   */ function iterator(name, v) {
        const k = name.slice(0, 4) === "-ms-" ? `ms-${name.slice(4)}` : name;
        result[k.replace(/-([a-z])/g, $d2c4e6a13f14eb77$var$styleReplacer)] = v;
    }
}
/**
 * @param {unknown} _
 * @param {string} $1
 */ function $d2c4e6a13f14eb77$var$styleReplacer(_, $1) {
    return $1.toUpperCase();
}
/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */ function $d2c4e6a13f14eb77$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ":",
        pos.start.column,
        "-",
        pos.end.line,
        ":",
        pos.end.column
    ].map(String).join("");
}

});
parcelRegister("4jPKB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9cCWX"));

});
parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $6b3372b60d35b33f$export$998bcd577473dd93, (v) => $6b3372b60d35b33f$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $6b3372b60d35b33f$export$3d6c20d97e46b957, (v) => $6b3372b60d35b33f$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$998bcd577473dd93;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$3d6c20d97e46b957;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = Symbol.for("react.element"), $6b3372b60d35b33f$var$c = Symbol.for("react.portal"), $6b3372b60d35b33f$var$d = Symbol.for("react.fragment"), $6b3372b60d35b33f$var$e = Symbol.for("react.strict_mode"), $6b3372b60d35b33f$var$f = Symbol.for("react.profiler"), $6b3372b60d35b33f$var$g = Symbol.for("react.provider"), $6b3372b60d35b33f$var$h = Symbol.for("react.context"), $6b3372b60d35b33f$var$k = Symbol.for("react.server_context"), $6b3372b60d35b33f$var$l = Symbol.for("react.forward_ref"), $6b3372b60d35b33f$var$m = Symbol.for("react.suspense"), $6b3372b60d35b33f$var$n = Symbol.for("react.suspense_list"), $6b3372b60d35b33f$var$p = Symbol.for("react.memo"), $6b3372b60d35b33f$var$q = Symbol.for("react.lazy"), $6b3372b60d35b33f$var$t = Symbol.for("react.offscreen"), $6b3372b60d35b33f$var$u;
$6b3372b60d35b33f$var$u = Symbol.for("react.module.reference");
function $6b3372b60d35b33f$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $6b3372b60d35b33f$var$b:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$d:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$h:
                            case $6b3372b60d35b33f$var$l:
                            case $6b3372b60d35b33f$var$q:
                            case $6b3372b60d35b33f$var$p:
                            case $6b3372b60d35b33f$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $6b3372b60d35b33f$var$c:
                return r;
        }
    }
}
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$b;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$q;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$998bcd577473dd93 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$92387174baf9b227 = function() {
    return !1;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = function() {
    return !1;
};
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$b;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$q;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$m;
};
$6b3372b60d35b33f$export$3d6c20d97e46b957 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$d || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$n || a === $6b3372b60d35b33f$var$t || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$q || a.$$typeof === $6b3372b60d35b33f$var$p || a.$$typeof === $6b3372b60d35b33f$var$g || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$l || a.$$typeof === $6b3372b60d35b33f$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$v;

});


parcelRegister("fWRhB", function(module, exports) {

$parcel$export(module.exports, "whitespace", () => $b9c59aaa17277982$export$7af1228ff777d175);
/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {unknown} thing
 *   Thing to check (typically `Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`).
 *   If a node is passed it must be a `Text` node, whose `value` field is
 *   checked.
 */ function $b9c59aaa17277982$export$7af1228ff777d175(thing) {
    /** @type {string} */ const value = // @ts-expect-error looks like a node.
    thing && typeof thing === "object" && thing.type === "text" ? thing.value || "" : thing;
    // HTML whitespace expression.
    // See <https://infra.spec.whatwg.org/#ascii-whitespace>.
    return typeof value === "string" && value.replace(/[ \t\n\f\r]/g, "") === "";
}

});

parcelRegister("4T1Yz", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $38edd4def83e695e$export$fac44ee5b035f737);
/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $38edd4def83e695e$export$98e6a39c04603d36(value) {
    const input = String(value || "").trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $38edd4def83e695e$export$fac44ee5b035f737(values) {
    return values.join(" ").trim();
}

});

parcelRegister("ath1E", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $79f9d1c25aee8303$export$fac44ee5b035f737);
/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $79f9d1c25aee8303$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || "");
    let index = input.indexOf(",");
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(",", start);
    }
    return tokens;
}
function $79f9d1c25aee8303$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === "" ? [
        ...values,
        ""
    ] : values;
    return input.join((settings.padRight ? " " : "") + "," + (settings.padLeft === false ? "" : " ")).trim();
}

});

parcelRegister("9BYkS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8da4e934f9d6258$export$2e2bcd8739ae039);

var $8SsuU = parcelRequire("8SsuU");
var $d8da4e934f9d6258$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8SsuU)));

});
parcelRegister("8SsuU", function(module, exports) {

var $dvUl4 = parcelRequire("dvUl4");
/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $676978e4775c0e9c$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $dvUl4(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
module.exports = $676978e4775c0e9c$var$StyleToObject;
module.exports.default = $676978e4775c0e9c$var$StyleToObject; // ESM support

});
parcelRegister("dvUl4", function(module, exports) {
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $9d69df5777ad44b8$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $9d69df5777ad44b8$var$NEWLINE_REGEX = /\n/g;
var $9d69df5777ad44b8$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $9d69df5777ad44b8$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $9d69df5777ad44b8$var$COLON_REGEX = /^:\s*/;
var $9d69df5777ad44b8$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $9d69df5777ad44b8$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $9d69df5777ad44b8$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $9d69df5777ad44b8$var$NEWLINE = "\n";
var $9d69df5777ad44b8$var$FORWARD_SLASH = "/";
var $9d69df5777ad44b8$var$ASTERISK = "*";
var $9d69df5777ad44b8$var$EMPTY_STRING = "";
// types
var $9d69df5777ad44b8$var$TYPE_COMMENT = "comment";
var $9d69df5777ad44b8$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ module.exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($9d69df5777ad44b8$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($9d69df5777ad44b8$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($9d69df5777ad44b8$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($9d69df5777ad44b8$var$FORWARD_SLASH != style.charAt(0) || $9d69df5777ad44b8$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($9d69df5777ad44b8$var$EMPTY_STRING != style.charAt(i) && ($9d69df5777ad44b8$var$ASTERISK != style.charAt(i) || $9d69df5777ad44b8$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($9d69df5777ad44b8$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $9d69df5777ad44b8$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($9d69df5777ad44b8$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($9d69df5777ad44b8$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($9d69df5777ad44b8$var$VALUE_REGEX);
        var ret = pos({
            type: $9d69df5777ad44b8$var$TYPE_DECLARATION,
            property: $9d69df5777ad44b8$var$trim(prop[0].replace($9d69df5777ad44b8$var$COMMENT_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING)),
            value: val ? $9d69df5777ad44b8$var$trim(val[0].replace($9d69df5777ad44b8$var$COMMENT_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING)) : $9d69df5777ad44b8$var$EMPTY_STRING
        });
        // ;
        match($9d69df5777ad44b8$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $9d69df5777ad44b8$var$trim(str) {
    return str ? str.replace($9d69df5777ad44b8$var$TRIM_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING) : $9d69df5777ad44b8$var$EMPTY_STRING;
}

});



parcelRegister("1hTyX", function(module, exports) {

$parcel$export(module.exports, "uriTransformer", () => $0f027a92973e6333$export$b83532a10e2e268b);
const $0f027a92973e6333$var$protocols = [
    "http",
    "https",
    "mailto",
    "tel"
];
function $0f027a92973e6333$export$b83532a10e2e268b(uri) {
    const url = (uri || "").trim();
    const first = url.charAt(0);
    if (first === "#" || first === "/") return url;
    const colon = url.indexOf(":");
    if (colon === -1) return url;
    let index = -1;
    while(++index < $0f027a92973e6333$var$protocols.length){
        const protocol = $0f027a92973e6333$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf("?");
    if (index !== -1 && colon > index) return url;
    index = url.indexOf("#");
    if (index !== -1 && colon > index) return url;
    // eslint-disable-next-line no-script-url
    return "javascript:void(0)";
}

});



parcelRegister("7KOXg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a545addcc5524a2$export$2e2bcd8739ae039);
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('micromark-extension-gfm').Options & import('mdast-util-gfm').Options} Options
 */ 
var $kAshv = parcelRequire("kAshv");

var $cHYOo = parcelRequire("cHYOo");
function $5a545addcc5524a2$export$2e2bcd8739ae039(options = {}) {
    const data = this.data();
    add("micromarkExtensions", (0, $kAshv.gfm)(options));
    add("fromMarkdownExtensions", (0, $cHYOo.gfmFromMarkdown)());
    add("toMarkdownExtensions", (0, $cHYOo.gfmToMarkdown)(options));
    /**
   * @param {string} field
   * @param {unknown} value
   */ function add(field, value) {
        const list = /** @type {unknown[]} */ // Other extensions
        /* c8 ignore next 2 */ data[field] ? data[field] : data[field] = [];
        list.push(value);
    }
}

});
parcelRegister("kAshv", function(module, exports) {

$parcel$export(module.exports, "gfm", () => $efcd1b8103398179$export$59ffe8c4d7a4aab2);
/**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ 
var $1BzS9 = parcelRequire("1BzS9");

var $bAFbu = parcelRequire("bAFbu");
var $cSlKP = parcelRequire("cSlKP");

var $ff40j = parcelRequire("ff40j");
var $ef6mF = parcelRequire("ef6mF");

var $cbea7 = parcelRequire("cbea7");
var $7dHSJ = parcelRequire("7dHSJ");

var $jZAvr = parcelRequire("jZAvr");
var $lNIEw = parcelRequire("lNIEw");

var $bcIIy = parcelRequire("bcIIy");

var $f8iSc = parcelRequire("f8iSc");
var $bgkSC = parcelRequire("bgkSC");
function $efcd1b8103398179$export$59ffe8c4d7a4aab2(options) {
    return (0, $1BzS9.combineExtensions)([
        (0, $bAFbu.gfmAutolinkLiteral),
        (0, $ff40j.gfmFootnote)(),
        (0, $cbea7.gfmStrikethrough)(options),
        (0, $jZAvr.gfmTable),
        (0, $f8iSc.gfmTaskListItem)
    ]);
}
function $efcd1b8103398179$export$6983b82e6105d62a(options) {
    return (0, $1BzS9.combineHtmlExtensions)([
        (0, $cSlKP.gfmAutolinkLiteralHtml),
        (0, $ef6mF.gfmFootnoteHtml)(options),
        (0, $7dHSJ.gfmStrikethroughHtml),
        (0, $lNIEw.gfmTableHtml),
        (0, $bcIIy.gfmTagfilterHtml),
        (0, $bgkSC.gfmTaskListItemHtml)
    ]);
}

});
parcelRegister("bAFbu", function(module, exports) {

$parcel$export(module.exports, "gfmAutolinkLiteral", () => $870300dc21c8be50$export$608123d9b549151);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $5Lprs = parcelRequire("5Lprs");
const $870300dc21c8be50$var$wwwPrefix = {
    tokenize: $870300dc21c8be50$var$tokenizeWwwPrefix,
    partial: true
};
const $870300dc21c8be50$var$domain = {
    tokenize: $870300dc21c8be50$var$tokenizeDomain,
    partial: true
};
const $870300dc21c8be50$var$path = {
    tokenize: $870300dc21c8be50$var$tokenizePath,
    partial: true
};
const $870300dc21c8be50$var$trail = {
    tokenize: $870300dc21c8be50$var$tokenizeTrail,
    partial: true
};
const $870300dc21c8be50$var$emailDomainDotTrail = {
    tokenize: $870300dc21c8be50$var$tokenizeEmailDomainDotTrail,
    partial: true
};
const $870300dc21c8be50$var$wwwAutolink = {
    tokenize: $870300dc21c8be50$var$tokenizeWwwAutolink,
    previous: $870300dc21c8be50$var$previousWww
};
const $870300dc21c8be50$var$protocolAutolink = {
    tokenize: $870300dc21c8be50$var$tokenizeProtocolAutolink,
    previous: $870300dc21c8be50$var$previousProtocol
};
const $870300dc21c8be50$var$emailAutolink = {
    tokenize: $870300dc21c8be50$var$tokenizeEmailAutolink,
    previous: $870300dc21c8be50$var$previousEmail
};
/** @type {ConstructRecord} */ const $870300dc21c8be50$var$text = {};
const $870300dc21c8be50$export$608123d9b549151 = {
    text: $870300dc21c8be50$var$text
};
/** @type {Code} */ let $870300dc21c8be50$var$code = 48;
// Add alphanumerics.
while($870300dc21c8be50$var$code < 123){
    $870300dc21c8be50$var$text[$870300dc21c8be50$var$code] = $870300dc21c8be50$var$emailAutolink;
    $870300dc21c8be50$var$code++;
    if ($870300dc21c8be50$var$code === 58) $870300dc21c8be50$var$code = 65;
    else if ($870300dc21c8be50$var$code === 91) $870300dc21c8be50$var$code = 97;
}
$870300dc21c8be50$var$text[43] = $870300dc21c8be50$var$emailAutolink;
$870300dc21c8be50$var$text[45] = $870300dc21c8be50$var$emailAutolink;
$870300dc21c8be50$var$text[46] = $870300dc21c8be50$var$emailAutolink;
$870300dc21c8be50$var$text[95] = $870300dc21c8be50$var$emailAutolink;
$870300dc21c8be50$var$text[72] = [
    $870300dc21c8be50$var$emailAutolink,
    $870300dc21c8be50$var$protocolAutolink
];
$870300dc21c8be50$var$text[104] = [
    $870300dc21c8be50$var$emailAutolink,
    $870300dc21c8be50$var$protocolAutolink
];
$870300dc21c8be50$var$text[87] = [
    $870300dc21c8be50$var$emailAutolink,
    $870300dc21c8be50$var$wwwAutolink
];
$870300dc21c8be50$var$text[119] = [
    $870300dc21c8be50$var$emailAutolink,
    $870300dc21c8be50$var$wwwAutolink
];
// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.
/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $870300dc21c8be50$var$tokenizeEmailAutolink(effects, ok, nok) {
    const self = this;
    /** @type {boolean | undefined} */ let dot;
    /** @type {boolean} */ let data;
    return start;
    /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (!$870300dc21c8be50$var$gfmAtext(code) || !$870300dc21c8be50$var$previousEmail.call(self, self.previous) || $870300dc21c8be50$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkEmail");
        return atext(code);
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function atext(code) {
        if ($870300dc21c8be50$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        if (code === 64) {
            effects.consume(code);
            return emailDomain;
        }
        return nok(code);
    }
    /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */ function emailDomain(code) {
        // Dot followed by alphanumerical (not `-` or `_`).
        if (code === 46) return effects.check($870300dc21c8be50$var$emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
        // Alphanumerical, `-`, and `_`.
        if (code === 45 || code === 95 || (0, $5Lprs.asciiAlphanumeric)(code)) {
            data = true;
            effects.consume(code);
            return emailDomain;
        }
        // To do: `/` if xmpp.
        // Note: normally we’d truncate trailing punctuation from the link.
        // However, email autolink literals cannot contain any of those markers,
        // except for `.`, but that can only occur if it isn’t trailing.
        // So we can ignore truncating!
        return emailDomainAfter(code);
    }
    /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */ function emailDomainDot(code) {
        effects.consume(code);
        dot = true;
        return emailDomain;
    }
    /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */ function emailDomainAfter(code) {
        // Domain must not be empty, must include a dot, and must end in alphabetical.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
        if (data && dot && (0, $5Lprs.asciiAlpha)(self.previous)) {
            effects.exit("literalAutolinkEmail");
            effects.exit("literalAutolink");
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $870300dc21c8be50$var$tokenizeWwwAutolink(effects, ok, nok) {
    const self = this;
    return wwwStart;
    /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function wwwStart(code) {
        if (code !== 87 && code !== 119 || !$870300dc21c8be50$var$previousWww.call(self, self.previous) || $870300dc21c8be50$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkWww");
        // Note: we *check*, so we can discard the `www.` we parsed.
        // If it worked, we consider it as a part of the domain.
        return effects.check($870300dc21c8be50$var$wwwPrefix, effects.attempt($870300dc21c8be50$var$domain, effects.attempt($870300dc21c8be50$var$path, wwwAfter), nok), nok)(code);
    }
    /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */ function wwwAfter(code) {
        effects.exit("literalAutolinkWww");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $870300dc21c8be50$var$tokenizeProtocolAutolink(effects, ok, nok) {
    const self = this;
    let buffer = "";
    let seen = false;
    return protocolStart;
    /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function protocolStart(code) {
        if ((code === 72 || code === 104) && $870300dc21c8be50$var$previousProtocol.call(self, self.previous) && !$870300dc21c8be50$var$previousUnbalanced(self.events)) {
            effects.enter("literalAutolink");
            effects.enter("literalAutolinkHttp");
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        return nok(code);
    }
    /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */ function protocolPrefixInside(code) {
        // `5` is size of `https`
        if ((0, $5Lprs.asciiAlpha)(code) && buffer.length < 5) {
            // @ts-expect-error: definitely number.
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        if (code === 58) {
            const protocol = buffer.toLowerCase();
            if (protocol === "http" || protocol === "https") {
                effects.consume(code);
                return protocolSlashesInside;
            }
        }
        return nok(code);
    }
    /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */ function protocolSlashesInside(code) {
        if (code === 47) {
            effects.consume(code);
            if (seen) return afterProtocol;
            seen = true;
            return protocolSlashesInside;
        }
        return nok(code);
    }
    /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */ function afterProtocol(code) {
        // To do: this is different from `markdown-rs`:
        // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
        return code === null || (0, $5Lprs.asciiControl)(code) || (0, $5Lprs.markdownLineEndingOrSpace)(code) || (0, $5Lprs.unicodeWhitespace)(code) || (0, $5Lprs.unicodePunctuation)(code) ? nok(code) : effects.attempt($870300dc21c8be50$var$domain, effects.attempt($870300dc21c8be50$var$path, protocolAfter), nok)(code);
    }
    /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */ function protocolAfter(code) {
        effects.exit("literalAutolinkHttp");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $870300dc21c8be50$var$tokenizeWwwPrefix(effects, ok, nok) {
    let size = 0;
    return wwwPrefixInside;
    /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */ function wwwPrefixInside(code) {
        if ((code === 87 || code === 119) && size < 3) {
            size++;
            effects.consume(code);
            return wwwPrefixInside;
        }
        if (code === 46 && size === 3) {
            effects.consume(code);
            return wwwPrefixAfter;
        }
        return nok(code);
    }
    /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */ function wwwPrefixAfter(code) {
        // If there is *anything*, we can link.
        return code === null ? nok(code) : ok(code);
    }
}
/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $870300dc21c8be50$var$tokenizeDomain(effects, ok, nok) {
    /** @type {boolean | undefined} */ let underscoreInLastSegment;
    /** @type {boolean | undefined} */ let underscoreInLastLastSegment;
    /** @type {boolean | undefined} */ let seen;
    return domainInside;
    /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */ function domainInside(code) {
        // Check whether this marker, which is a trailing punctuation
        // marker, optionally followed by more trailing markers, and then
        // followed by an end.
        if (code === 46 || code === 95) return effects.check($870300dc21c8be50$var$trail, domainAfter, domainAtPunctuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
        if (code === null || (0, $5Lprs.markdownLineEndingOrSpace)(code) || (0, $5Lprs.unicodeWhitespace)(code) || code !== 45 && (0, $5Lprs.unicodePunctuation)(code)) return domainAfter(code);
        seen = true;
        effects.consume(code);
        return domainInside;
    }
    /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */ function domainAtPunctuation(code) {
        // There is an underscore in the last segment of the domain
        if (code === 95) underscoreInLastSegment = true;
        else {
            underscoreInLastLastSegment = underscoreInLastSegment;
            underscoreInLastSegment = undefined;
        }
        effects.consume(code);
        return domainInside;
    }
    /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */ function domainAfter(code) {
        // Note: that’s GH says a dot is needed, but it’s not true:
        // <https://github.com/github/cmark-gfm/issues/279>
        if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) return nok(code);
        return ok(code);
    }
}
/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $870300dc21c8be50$var$tokenizePath(effects, ok) {
    let sizeOpen = 0;
    let sizeClose = 0;
    return pathInside;
    /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */ function pathInside(code) {
        if (code === 40) {
            sizeOpen++;
            effects.consume(code);
            return pathInside;
        }
        // To do: `markdown-rs` also needs this.
        // If this is a paren, and there are less closings than openings,
        // we don’t check for a trail.
        if (code === 41 && sizeClose < sizeOpen) return pathAtPunctuation(code);
        // Check whether this trailing punctuation marker is optionally
        // followed by more trailing markers, and then followed
        // by an end.
        if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) return effects.check($870300dc21c8be50$var$trail, ok, pathAtPunctuation)(code);
        if (code === null || (0, $5Lprs.markdownLineEndingOrSpace)(code) || (0, $5Lprs.unicodeWhitespace)(code)) return ok(code);
        effects.consume(code);
        return pathInside;
    }
    /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */ function pathAtPunctuation(code) {
        // Count closing parens.
        if (code === 41) sizeClose++;
        effects.consume(code);
        return pathInside;
    }
}
/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $870300dc21c8be50$var$tokenizeTrail(effects, ok, nok) {
    return trail;
    /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */ function trail(code) {
        // Regular trailing punctuation.
        if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
            effects.consume(code);
            return trail;
        }
        // `&` followed by one or more alphabeticals and then a `;`, is
        // as a whole considered as trailing punctuation.
        // In all other cases, it is considered as continuation of the URL.
        if (code === 38) {
            effects.consume(code);
            return trailCharRefStart;
        }
        // Needed because we allow literals after `[`, as we fix:
        // <https://github.com/github/cmark-gfm/issues/278>.
        // Check that it is not followed by `(` or `[`.
        if (code === 93) {
            effects.consume(code);
            return trailBracketAfter;
        }
        if (// `<` is an end.
        code === 60 || // So is whitespace.
        code === null || (0, $5Lprs.markdownLineEndingOrSpace)(code) || (0, $5Lprs.unicodeWhitespace)(code)) return ok(code);
        return nok(code);
    }
    /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailBracketAfter(code) {
        // Whitespace or something that could start a resource or reference is the end.
        // Switch back to trail otherwise.
        if (code === null || code === 40 || code === 91 || (0, $5Lprs.markdownLineEndingOrSpace)(code) || (0, $5Lprs.unicodeWhitespace)(code)) return ok(code);
        return trail(code);
    }
    /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefStart(code) {
        // When non-alpha, it’s not a trail.
        return (0, $5Lprs.asciiAlpha)(code) ? trailCharRefInside(code) : nok(code);
    }
    /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefInside(code) {
        // Switch back to trail if this is well-formed.
        if (code === 59) {
            effects.consume(code);
            return trail;
        }
        if ((0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            return trailCharRefInside;
        }
        // It’s not a trail.
        return nok(code);
    }
}
/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $870300dc21c8be50$var$tokenizeEmailDomainDotTrail(effects, ok, nok) {
    return start;
    /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Must be dot.
        effects.consume(code);
        return after;
    }
    /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Not a trail if alphanumeric.
        return (0, $5Lprs.asciiAlphanumeric)(code) ? nok(code) : ok(code);
    }
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */ function $870300dc21c8be50$var$previousWww(code) {
    return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || (0, $5Lprs.markdownLineEndingOrSpace)(code);
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */ function $870300dc21c8be50$var$previousProtocol(code) {
    return !(0, $5Lprs.asciiAlpha)(code);
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $870300dc21c8be50$var$previousEmail(code) {
    // Do not allow a slash “inside” atext.
    // The reference code is a bit weird, but that’s what it results in.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
    // Other than slash, every preceding character is allowed.
    return !(code === 47 || $870300dc21c8be50$var$gfmAtext(code));
}
/**
 * @param {Code} code
 * @returns {boolean}
 */ function $870300dc21c8be50$var$gfmAtext(code) {
    return code === 43 || code === 45 || code === 46 || code === 95 || (0, $5Lprs.asciiAlphanumeric)(code);
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */ function $870300dc21c8be50$var$previousUnbalanced(events) {
    let index = events.length;
    let result = false;
    while(index--){
        const token = events[index][1];
        if ((token.type === "labelLink" || token.type === "labelImage") && !token._balanced) {
            result = true;
            break;
        }
        // If we’ve seen this token, and it was marked as not having any unbalanced
        // bracket before it, we can exit.
        if (token._gfmAutolinkLiteralWalkedInto) {
            result = false;
            break;
        }
    }
    if (events.length > 0 && !result) // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
    return result;
}

});

parcelRegister("cSlKP", function(module, exports) {

$parcel$export(module.exports, "gfmAutolinkLiteralHtml", () => $95fb6725110a34a2$export$999603f1f1c3d2f9);
/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').Handle} Handle
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ 
var $8sB1o = parcelRequire("8sB1o");
const $95fb6725110a34a2$export$999603f1f1c3d2f9 = {
    exit: {
        literalAutolinkEmail: $95fb6725110a34a2$var$literalAutolinkEmail,
        literalAutolinkHttp: $95fb6725110a34a2$var$literalAutolinkHttp,
        literalAutolinkWww: $95fb6725110a34a2$var$literalAutolinkWww
    }
};
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $95fb6725110a34a2$var$literalAutolinkWww(token) {
    $95fb6725110a34a2$var$anchorFromToken.call(this, token, "http://");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $95fb6725110a34a2$var$literalAutolinkEmail(token) {
    $95fb6725110a34a2$var$anchorFromToken.call(this, token, "mailto:");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $95fb6725110a34a2$var$literalAutolinkHttp(token) {
    $95fb6725110a34a2$var$anchorFromToken.call(this, token);
}
/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {void}
 */ function $95fb6725110a34a2$var$anchorFromToken(token, protocol) {
    const url = this.sliceSerialize(token);
    this.tag('<a href="' + (0, $8sB1o.sanitizeUri)((protocol || "") + url) + '">');
    this.raw(this.encode(url));
    this.tag("</a>");
}

});

parcelRegister("ff40j", function(module, exports) {

$parcel$export(module.exports, "gfmFootnote", () => $b18b5cd617a1e719$export$c82499b6656305df);
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $eRfeJ = parcelRequire("eRfeJ");

var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");

var $9HErY = parcelRequire("9HErY");
const $b18b5cd617a1e719$var$indent = {
    tokenize: $b18b5cd617a1e719$var$tokenizeIndent,
    partial: true
};
function $b18b5cd617a1e719$export$c82499b6656305df() {
    /** @type {Extension} */ return {
        document: {
            [91]: {
                tokenize: $b18b5cd617a1e719$var$tokenizeDefinitionStart,
                continuation: {
                    tokenize: $b18b5cd617a1e719$var$tokenizeDefinitionContinuation
                },
                exit: $b18b5cd617a1e719$var$gfmFootnoteDefinitionEnd
            }
        },
        text: {
            [91]: {
                tokenize: $b18b5cd617a1e719$var$tokenizeGfmFootnoteCall
            },
            [93]: {
                add: "after",
                tokenize: $b18b5cd617a1e719$var$tokenizePotentialGfmFootnoteCall,
                resolveTo: $b18b5cd617a1e719$var$resolveToPotentialGfmFootnoteCall
            }
        }
    };
}
// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b18b5cd617a1e719$var$tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {Token} */ let labelStart;
    // Find an opening.
    while(index--){
        const token = self.events[index][1];
        if (token.type === "labelImage") {
            labelStart = token;
            break;
        }
        // Exit if we’ve walked far enough.
        if (token.type === "gfmFootnoteCall" || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") break;
    }
    return start;
    /**
   * @type {State}
   */ function start(code) {
        if (!labelStart || !labelStart._balanced) return nok(code);
        const id = (0, $9HErY.normalizeIdentifier)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }));
        if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) return nok(code);
        effects.enter("gfmFootnoteCallLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallLabelMarker");
        return ok(code);
    }
}
// To do: remove after micromark update.
/** @type {Resolver} */ function $b18b5cd617a1e719$var$resolveToPotentialGfmFootnoteCall(events, context) {
    let index = events.length;
    /** @type {Token | undefined} */ let labelStart;
    // Find an opening.
    while(index--)if (events[index][1].type === "labelImage" && events[index][0] === "enter") {
        labelStart = events[index][1];
        break;
    }
    // Change the `labelImageMarker` to a `data`.
    events[index + 1][1].type = "data";
    events[index + 3][1].type = "gfmFootnoteCallLabelMarker";
    // The whole (without `!`):
    /** @type {Token} */ const call = {
        type: "gfmFootnoteCall",
        start: Object.assign({}, events[index + 3][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // The `^` marker
    /** @type {Token} */ const marker = {
        type: "gfmFootnoteCallMarker",
        start: Object.assign({}, events[index + 3][1].end),
        end: Object.assign({}, events[index + 3][1].end)
    };
    // Increment the end 1 character.
    marker.end.column++;
    marker.end.offset++;
    marker.end._bufferIndex++;
    /** @type {Token} */ const string = {
        type: "gfmFootnoteCallString",
        start: Object.assign({}, marker.end),
        end: Object.assign({}, events[events.length - 1][1].start)
    };
    /** @type {Token} */ const chunk = {
        type: "chunkString",
        contentType: "string",
        start: Object.assign({}, string.start),
        end: Object.assign({}, string.end)
    };
    /** @type {Array<Event>} */ const replacement = [
        // Take the `labelImageMarker` (now `data`, the `!`)
        events[index + 1],
        events[index + 2],
        [
            "enter",
            call,
            context
        ],
        // The `[`
        events[index + 3],
        events[index + 4],
        // The `^`.
        [
            "enter",
            marker,
            context
        ],
        [
            "exit",
            marker,
            context
        ],
        // Everything in between.
        [
            "enter",
            string,
            context
        ],
        [
            "enter",
            chunk,
            context
        ],
        [
            "exit",
            chunk,
            context
        ],
        [
            "exit",
            string,
            context
        ],
        // The ending (`]`, properly parsed and labelled).
        events[events.length - 2],
        events[events.length - 1],
        [
            "exit",
            call,
            context
        ]
    ];
    events.splice(index, events.length - index + 1, ...replacement);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b18b5cd617a1e719$var$tokenizeGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    let size = 0;
    /** @type {boolean} */ let data;
    // Note: the implementation of `markdown-rs` is different, because it houses
    // core *and* extensions in one project.
    // Therefore, it can include footnote logic inside `label-end`.
    // We can’t do that, but luckily, we can parse footnotes in a simpler way than
    // needed for labels.
    return start;
    /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("gfmFootnoteCall");
        effects.enter("gfmFootnoteCallLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallLabelMarker");
        return callStart;
    }
    /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function callStart(code) {
        if (code !== 94) return nok(code);
        effects.enter("gfmFootnoteCallMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallMarker");
        effects.enter("gfmFootnoteCallString");
        effects.enter("chunkString").contentType = "string";
        return callData;
    }
    /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */ function callData(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $5Lprs.markdownLineEndingOrSpace)(code)) return nok(code);
        if (code === 93) {
            effects.exit("chunkString");
            const token = effects.exit("gfmFootnoteCallString");
            if (!defined.includes((0, $9HErY.normalizeIdentifier)(self.sliceSerialize(token)))) return nok(code);
            effects.enter("gfmFootnoteCallLabelMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteCallLabelMarker");
            effects.exit("gfmFootnoteCall");
            return ok;
        }
        if (!(0, $5Lprs.markdownLineEndingOrSpace)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? callEscape : callData;
    }
    /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */ function callEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return callData;
        }
        return callData(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b18b5cd617a1e719$var$tokenizeDefinitionStart(effects, ok, nok) {
    const self = this;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {string} */ let identifier;
    let size = 0;
    /** @type {boolean | undefined} */ let data;
    return start;
    /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("gfmFootnoteDefinition")._container = true;
        effects.enter("gfmFootnoteDefinitionLabel");
        effects.enter("gfmFootnoteDefinitionLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteDefinitionLabelMarker");
        return labelAtMarker;
    }
    /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */ function labelAtMarker(code) {
        if (code === 94) {
            effects.enter("gfmFootnoteDefinitionMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteDefinitionMarker");
            effects.enter("gfmFootnoteDefinitionLabelString");
            effects.enter("chunkString").contentType = "string";
            return labelInside;
        }
        return nok(code);
    }
    /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $5Lprs.markdownLineEndingOrSpace)(code)) return nok(code);
        if (code === 93) {
            effects.exit("chunkString");
            const token = effects.exit("gfmFootnoteDefinitionLabelString");
            identifier = (0, $9HErY.normalizeIdentifier)(self.sliceSerialize(token));
            effects.enter("gfmFootnoteDefinitionLabelMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteDefinitionLabelMarker");
            effects.exit("gfmFootnoteDefinitionLabel");
            return labelAfter;
        }
        if (!(0, $5Lprs.markdownLineEndingOrSpace)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
    /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            if (!defined.includes(identifier)) defined.push(identifier);
            // Any whitespace after the marker is eaten, forming indented code
            // is not possible.
            // No space is also fine, just like a block quote marker.
            return (0, $8GWoH.factorySpace)(effects, whitespaceAfter, "gfmFootnoteDefinitionWhitespace");
        }
        return nok(code);
    }
    /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */ function whitespaceAfter(code) {
        // `markdown-rs` has a wrapping token for the prefix that is closed here.
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b18b5cd617a1e719$var$tokenizeDefinitionContinuation(effects, ok, nok) {
    /// Start of footnote definition continuation.
    ///
    /// ```markdown
    ///   | [^a]: b
    /// > |     c
    ///     ^
    /// ```
    //
    // Either a blank line, which is okay, or an indented thing.
    return effects.check((0, $eRfeJ.blankLine), ok, effects.attempt($b18b5cd617a1e719$var$indent, ok, nok));
}
/** @type {Exiter} */ function $b18b5cd617a1e719$var$gfmFootnoteDefinitionEnd(effects) {
    effects.exit("gfmFootnoteDefinition");
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b18b5cd617a1e719$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $8GWoH.factorySpace)(effects, afterPrefix, "gfmFootnoteDefinitionIndent", 5);
    /**
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "gfmFootnoteDefinitionIndent" && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code) : nok(code);
    }
}

});

parcelRegister("ef6mF", function(module, exports) {

$parcel$export(module.exports, "gfmFootnoteHtml", () => $a5e76749417ac891$export$a731a1f6cf81900c);
/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @callback BackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   * `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   * `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   * `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {string} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent them from
 *   *clobbering*.
 *
 *   The default is `'user-content-'`.
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {string} [label='Footnotes']
 *   Textual label to use for the footnotes section.
 *
 *   The default value is `'Footnotes'`.
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different attributes with the `labelAttributes` option.
 * @property {string} [labelAttributes='class="sr-only"']
 *   Attributes to use on the footnote label.
 *
 *   Change it to show the label and add other attributes.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different attributes.
 *
 *   > 👉 **Note**: `id="footnote-label"` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string} [labelTagName='h2']
 *   HTML tag name to use for the footnote label element.
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different attributes with the `labelAttributes` option.
 * @property {BackLabelTemplate | string} [backLabel]
 *   Textual label to describe the backreference back to references.
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *  }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `aria-label` attribute on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 */ 
var $9HErY = parcelRequire("9HErY");

var $8sB1o = parcelRequire("8sB1o");
const $a5e76749417ac891$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $a5e76749417ac891$var$emptyOptions = {};
function $a5e76749417ac891$export$a18c77a47f4154b6(referenceIndex, rereferenceIndex) {
    return "Back to reference " + (referenceIndex + 1) + (rereferenceIndex > 1 ? "-" + rereferenceIndex : "");
}
function $a5e76749417ac891$export$a731a1f6cf81900c(options) {
    const config = options || $a5e76749417ac891$var$emptyOptions;
    const label = config.label || "Footnotes";
    const labelTagName = config.labelTagName || "h2";
    const labelAttributes = config.labelAttributes === null || config.labelAttributes === undefined ? 'class="sr-only"' : config.labelAttributes;
    const backLabel = config.backLabel || $a5e76749417ac891$export$a18c77a47f4154b6;
    const clobberPrefix = config.clobberPrefix === null || config.clobberPrefix === undefined ? "user-content-" : config.clobberPrefix;
    return {
        enter: {
            gfmFootnoteDefinition () {
                const stack = this.getData("tightStack");
                stack.push(false);
            },
            gfmFootnoteDefinitionLabelString () {
                this.buffer();
            },
            gfmFootnoteCallString () {
                this.buffer();
            }
        },
        exit: {
            gfmFootnoteDefinition () {
                let definitions = this.getData("gfmFootnoteDefinitions");
                const footnoteStack = this.getData("gfmFootnoteDefinitionStack");
                const tightStack = this.getData("tightStack");
                const current = footnoteStack.pop();
                const value = this.resume();
                if (!definitions) this.setData("gfmFootnoteDefinitions", definitions = {});
                if (!$a5e76749417ac891$var$own.call(definitions, current)) definitions[current] = value;
                tightStack.pop();
                this.setData("slurpOneLineEnding", true);
                // “Hack” to prevent a line ending from showing up if we’re in a definition in
                // an empty list item.
                this.setData("lastWasTag");
            },
            gfmFootnoteDefinitionLabelString (token) {
                let footnoteStack = /** @type {Array<string>} */ this.getData("gfmFootnoteDefinitionStack");
                if (!footnoteStack) this.setData("gfmFootnoteDefinitionStack", footnoteStack = []);
                footnoteStack.push((0, $9HErY.normalizeIdentifier)(this.sliceSerialize(token)));
                this.resume() // Drop the label.
                ;
                this.buffer() // Get ready for a value.
                ;
            },
            gfmFootnoteCallString (token) {
                let calls = this.getData("gfmFootnoteCallOrder");
                let counts = this.getData("gfmFootnoteCallCounts");
                const id = (0, $9HErY.normalizeIdentifier)(this.sliceSerialize(token));
                /** @type {number} */ let counter;
                this.resume();
                if (!calls) this.setData("gfmFootnoteCallOrder", calls = []);
                if (!counts) this.setData("gfmFootnoteCallCounts", counts = {});
                const index = calls.indexOf(id);
                const safeId = (0, $8sB1o.sanitizeUri)(id.toLowerCase());
                if (index === -1) {
                    calls.push(id);
                    counts[id] = 1;
                    counter = calls.length;
                } else {
                    counts[id]++;
                    counter = index + 1;
                }
                const reuseCounter = counts[id];
                this.tag('<sup><a href="#' + clobberPrefix + "fn-" + safeId + '" id="' + clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : "") + '" data-footnote-ref="" aria-describedby="footnote-label">' + String(counter) + "</a></sup>");
            },
            null () {
                const calls = /** @type {Array<string>} */ this.getData("gfmFootnoteCallOrder") || [];
                const counts = /** @type {Record<string, number>} */ this.getData("gfmFootnoteCallCounts") || {};
                const definitions = /** @type {Record<string, string>} */ this.getData("gfmFootnoteDefinitions") || {};
                let index = -1;
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('<section data-footnotes="" class="footnotes"><' + labelTagName + ' id="footnote-label"' + (labelAttributes ? " " + labelAttributes : "") + ">");
                    this.raw(this.encode(label));
                    this.tag("</" + labelTagName + ">");
                    this.lineEndingIfNeeded();
                    this.tag("<ol>");
                }
                while(++index < calls.length){
                    // Called definitions are always defined.
                    const id = calls[index];
                    const safeId = (0, $8sB1o.sanitizeUri)(id.toLowerCase());
                    let referenceIndex = 0;
                    /** @type {Array<string>} */ const references = [];
                    while(++referenceIndex <= counts[id])references.push('<a href="#' + clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : "") + '" data-footnote-backref="" aria-label="' + this.encode(typeof backLabel === "string" ? backLabel : backLabel(index, referenceIndex)) + '" class="data-footnote-backref">\u21A9' + (referenceIndex > 1 ? "<sup>" + referenceIndex + "</sup>" : "") + "</a>");
                    const reference = references.join(" ");
                    let injected = false;
                    this.lineEndingIfNeeded();
                    this.tag('<li id="' + clobberPrefix + "fn-" + safeId + '">');
                    this.lineEndingIfNeeded();
                    this.tag(definitions[id].replace(/<\/p>(?:\r?\n|\r)?$/, (/** @type {string} */ $0)=>{
                        injected = true;
                        return " " + reference + $0;
                    }));
                    if (!injected) {
                        this.lineEndingIfNeeded();
                        this.tag(reference);
                    }
                    this.lineEndingIfNeeded();
                    this.tag("</li>");
                }
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag("</ol>");
                    this.lineEndingIfNeeded();
                    this.tag("</section>");
                }
            }
        }
    };
}

});

parcelRegister("cbea7", function(module, exports) {

$parcel$export(module.exports, "gfmStrikethrough", () => $8de17f6af7e064b6$export$8bbec8ea1400a00e);
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean} [singleTilde=true]
 *   Whether to support strikethrough with a single tilde.
 *
 *   Single tildes work on github.com, but are technically prohibited by the
 *   GFM spec.
 */ 
var $Ux2lp = parcelRequire("Ux2lp");

var $i5TSH = parcelRequire("i5TSH");

var $8f02Z = parcelRequire("8f02Z");
function $8de17f6af7e064b6$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === "enter" && events[index][1].type === "strikethroughSequenceTemporary" && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === "exit" && events[open][1].type === "strikethroughSequenceTemporary" && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = "strikethroughSequence";
                events[open][1].type = "strikethroughSequence";
                /** @type {Token} */ const strikethrough = {
                    type: "strikethrough",
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: "strikethroughText",
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        "enter",
                        strikethrough,
                        context
                    ],
                    [
                        "enter",
                        events[open][1],
                        context
                    ],
                    [
                        "exit",
                        events[open][1],
                        context
                    ],
                    [
                        "enter",
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $Ux2lp.splice)(nextEvents, nextEvents.length, 0, (0, $8f02Z.resolveAll)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $Ux2lp.splice)(nextEvents, nextEvents.length, 0, [
                    [
                        "exit",
                        text,
                        context
                    ],
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        strikethrough,
                        context
                    ]
                ]);
                (0, $Ux2lp.splice)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === "strikethroughSequenceTemporary") events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter("strikethroughSequenceTemporary");
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $i5TSH.classifyCharacter)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit("strikethroughSequenceTemporary");
            const after = (0, $i5TSH.classifyCharacter)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}

});

parcelRegister("7dHSJ", function(module, exports) {

$parcel$export(module.exports, "gfmStrikethroughHtml", () => $541bc950d159d0d0$export$58acedca46108820);
/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ // To do: next major: expose function instead of object.
/**
 * Extension for `micromark` that can be passed in `htmlExtensions`, to
 * support GFM strikethrough when serializing to HTML.
 *
 * @type {HtmlExtension}
 */ const $541bc950d159d0d0$export$58acedca46108820 = {
    enter: {
        strikethrough () {
            this.tag("<del>");
        }
    },
    exit: {
        strikethrough () {
            this.tag("</del>");
        }
    }
};

});

parcelRegister("jZAvr", function(module, exports) {

$parcel$export(module.exports, "gfmTable", () => $e8e0082f4ed3192c$export$e36cebda627bf2dd);
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");

var $22QIA = parcelRequire("22QIA");

var $bo8g3 = parcelRequire("bo8g3");
const $e8e0082f4ed3192c$export$e36cebda627bf2dd = {
    flow: {
        null: {
            tokenize: $e8e0082f4ed3192c$var$tokenizeTable,
            resolveAll: $e8e0082f4ed3192c$var$resolveTable
        }
    }
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e8e0082f4ed3192c$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === "tableHead" || tail === "tableRow" ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter("tableHead");
        effects.enter("tableRow");
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit("tableRow");
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $5Lprs.markdownSpace)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $8GWoH.factorySpace)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $5Lprs.markdownLineEndingOrSpace)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter("tableDelimiterRow");
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $5Lprs.markdownSpace)(code)) return (0, $8GWoH.factorySpace)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $5Lprs.markdownSpace)(code)) return (0, $8GWoH.factorySpace)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter("tableDelimiterFiller");
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit("tableDelimiterFiller");
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit("tableDelimiterFiller");
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $5Lprs.markdownSpace)(code)) return (0, $8GWoH.factorySpace)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit("tableDelimiterRow");
            effects.exit("tableHead");
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter("tableRow");
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return bodyRowBreak;
        }
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("tableRow");
            return ok(code);
        }
        if ((0, $5Lprs.markdownSpace)(code)) return (0, $8GWoH.factorySpace)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $5Lprs.markdownLineEndingOrSpace)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ // eslint-disable-next-line complexity
function $e8e0082f4ed3192c$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $22QIA.EditMap)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === "enter") {
            // Start of head.
            if (token.type === "tableHead") {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $e8e0082f4ed3192c$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: "table",
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        "enter",
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: "tableBody",
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            "enter",
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === "tableDelimiterRow" ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $e8e0082f4ed3192c$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === "tableCellDivider") {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $e8e0082f4ed3192c$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === "tableHead") {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $e8e0082f4ed3192c$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $e8e0082f4ed3192c$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) cell[3] = index;
    }
    if (lastTableEnd !== 0) $e8e0082f4ed3192c$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === "enter" && event[1].type === "table") event[1]._align = (0, $bo8g3.gfmTableAlign)(context.events, index);
    }
    return events;
}
/// Generate a cell.
/**
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {Range} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $e8e0082f4ed3192c$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? "tableHeader" : rowKind === 2 ? "tableDelimiter" : "tableData";
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = "tableContent";
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $e8e0082f4ed3192c$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $e8e0082f4ed3192c$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            "enter",
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $e8e0082f4ed3192c$var$getPoint(context.events, range[2]);
        const relatedEnd = $e8e0082f4ed3192c$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                "enter",
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                "exit",
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $e8e0082f4ed3192c$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $e8e0082f4ed3192c$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $e8e0082f4ed3192c$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            "exit",
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        "exit",
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {readonly Point}
 */ function $e8e0082f4ed3192c$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === "enter" ? "start" : "end";
    return event[1][side];
}

});
parcelRegister("22QIA", function(module, exports) {

$parcel$export(module.exports, "EditMap", () => $17d4a96c5c2b61f6$export$9348908dd4518b4a);
/**
 * @typedef {import('micromark-util-types').Event} Event
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $17d4a96c5c2b61f6$export$9348908dd4518b4a {
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {void}
   */ add(index, remove, add) {
        $17d4a96c5c2b61f6$var$addImpl(this, index, remove, add);
    }
    // To do: not used here.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {void}
    //  */
    // addBefore(index, remove, add) {
    //   addImpl(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {void}
   */ consume(events) {
        this.map.sort((a, b)=>a[0] - b[0]);
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]));
            // eslint-disable-next-line unicorn/no-array-push-push
            vecs.push(this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push([
            ...events
        ]);
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            events.push(...slice);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {void}
 */ function $17d4a96c5c2b61f6$var$addImpl(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       console.log('to do: links?', add, rmCurr)
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }

});

parcelRegister("bo8g3", function(module, exports) {

$parcel$export(module.exports, "gfmTableAlign", () => $84a857714c6d1171$export$bbf4fe2c547a4878);
/**
 * @typedef {import('micromark-util-types').Event} Event
 */ /**
 * @typedef {'left' | 'center' | 'right' | 'none'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {Array<Align>}
 */ function $84a857714c6d1171$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === "enter") // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === "tableContent") align.push(events[index + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
            } else if (event[1].type === "tableContent") {
                if (events[index - 1][1].type === "tableDelimiterMarker") {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === "left" ? "center" : "right";
                }
            } else if (event[1].type === "tableDelimiterRow") break;
        } else if (event[0] === "enter" && event[1].type === "tableDelimiterRow") inDelimiterRow = true;
        index += 1;
    }
    return align;
}

});


parcelRegister("lNIEw", function(module, exports) {

$parcel$export(module.exports, "gfmTableHtml", () => $fdf0cfa5379dfe0c$export$c64626c032567c7f);
/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @typedef {import('./infer.js').Align} Align
 */ const $fdf0cfa5379dfe0c$var$alignment = {
    none: "",
    left: ' align="left"',
    right: ' align="right"',
    center: ' align="center"'
};
const $fdf0cfa5379dfe0c$export$c64626c032567c7f = {
    enter: {
        table (token) {
            const tableAlign = token._align;
            this.lineEndingIfNeeded();
            this.tag("<table>");
            this.setData("tableAlign", tableAlign);
        },
        tableBody () {
            this.tag("<tbody>");
        },
        tableData () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            const align = $fdf0cfa5379dfe0c$var$alignment[tableAlign[tableColumn]];
            if (align === undefined) // Capture results to ignore them.
            this.buffer();
            else {
                this.lineEndingIfNeeded();
                this.tag("<td" + align + ">");
            }
        },
        tableHead () {
            this.lineEndingIfNeeded();
            this.tag("<thead>");
        },
        tableHeader () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            const align = $fdf0cfa5379dfe0c$var$alignment[tableAlign[tableColumn]];
            this.lineEndingIfNeeded();
            this.tag("<th" + align + ">");
        },
        tableRow () {
            this.setData("tableColumn", 0);
            this.lineEndingIfNeeded();
            this.tag("<tr>");
        }
    },
    exit: {
        // Overwrite the default code text data handler to unescape escaped pipes when
        // they are in tables.
        codeTextData (token) {
            let value = this.sliceSerialize(token);
            if (this.getData("tableAlign")) value = value.replace(/\\([\\|])/g, $fdf0cfa5379dfe0c$var$replace);
            this.raw(this.encode(value));
        },
        table () {
            this.setData("tableAlign");
            // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
            // but we do need to reset it to match a funky newline GH generates for
            // list items combined with tables.
            this.setData("slurpAllLineEndings");
            this.lineEndingIfNeeded();
            this.tag("</table>");
        },
        tableBody () {
            this.lineEndingIfNeeded();
            this.tag("</tbody>");
        },
        tableData () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            if (tableColumn in tableAlign) {
                this.tag("</td>");
                this.setData("tableColumn", tableColumn + 1);
            } else // Stop capturing.
            this.resume();
        },
        tableHead () {
            this.lineEndingIfNeeded();
            this.tag("</thead>");
        },
        tableHeader () {
            const tableColumn = this.getData("tableColumn");
            this.tag("</th>");
            this.setData("tableColumn", tableColumn + 1);
        },
        tableRow () {
            const tableAlign = this.getData("tableAlign");
            let tableColumn = this.getData("tableColumn");
            while(tableColumn < tableAlign.length){
                this.lineEndingIfNeeded();
                this.tag("<td" + $fdf0cfa5379dfe0c$var$alignment[tableAlign[tableColumn]] + "></td>");
                tableColumn++;
            }
            this.setData("tableColumn", tableColumn);
            this.lineEndingIfNeeded();
            this.tag("</tr>");
        }
    }
};
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $fdf0cfa5379dfe0c$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}

});

parcelRegister("bcIIy", function(module, exports) {

$parcel$export(module.exports, "gfmTagfilterHtml", () => $828380b1cc355827$export$c9bf87ea36d00682);
/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ // An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
const $828380b1cc355827$var$reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
const $828380b1cc355827$var$reText = new RegExp("^" + $828380b1cc355827$var$reFlow.source, "i");
const $828380b1cc355827$export$c9bf87ea36d00682 = {
    exit: {
        htmlFlowData (token) {
            $828380b1cc355827$var$exitHtmlData.call(this, token, $828380b1cc355827$var$reFlow);
        },
        htmlTextData (token) {
            $828380b1cc355827$var$exitHtmlData.call(this, token, $828380b1cc355827$var$reText);
        }
    }
};
/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 */ function $828380b1cc355827$var$exitHtmlData(token, filter) {
    let value = this.sliceSerialize(token);
    if (this.options.allowDangerousHtml) value = value.replace(filter, "&lt;$1$2");
    this.raw(this.encode(value));
}

});

parcelRegister("f8iSc", function(module, exports) {

$parcel$export(module.exports, "gfmTaskListItem", () => $b0463e2b7dbcb345$export$2912e8b2802475ff);
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
const $b0463e2b7dbcb345$var$tasklistCheck = {
    tokenize: $b0463e2b7dbcb345$var$tokenizeTasklistCheck
};
const $b0463e2b7dbcb345$export$2912e8b2802475ff = {
    text: {
        [91]: $b0463e2b7dbcb345$var$tasklistCheck
    }
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b0463e2b7dbcb345$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter("taskListCheck");
        effects.enter("taskListCheckMarker");
        effects.consume(code);
        effects.exit("taskListCheckMarker");
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $5Lprs.markdownLineEndingOrSpace)(code)) {
            effects.enter("taskListCheckValueUnchecked");
            effects.consume(code);
            effects.exit("taskListCheckValueUnchecked");
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter("taskListCheckValueChecked");
            effects.consume(code);
            effects.exit("taskListCheckValueChecked");
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter("taskListCheckMarker");
            effects.consume(code);
            effects.exit("taskListCheckMarker");
            effects.exit("taskListCheck");
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $5Lprs.markdownLineEnding)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $5Lprs.markdownSpace)(code)) return effects.check({
            tokenize: $b0463e2b7dbcb345$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b0463e2b7dbcb345$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $8GWoH.factorySpace)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}

});

parcelRegister("bgkSC", function(module, exports) {

$parcel$export(module.exports, "gfmTaskListItemHtml", () => $833162a9c651eda0$export$4b6a13e2af1b08ed);
/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ // To do: next major: expose function to make extension.
/**
 * Extension for `micromark` that can be passed in `htmlExtensions` to
 * support GFM task list items when serializing to HTML.
 *
 * @type {HtmlExtension}
 */ const $833162a9c651eda0$export$4b6a13e2af1b08ed = {
    enter: {
        taskListCheck () {
            this.tag('<input type="checkbox" disabled="" ');
        }
    },
    exit: {
        taskListCheck () {
            this.tag("/>");
        },
        taskListCheckValueChecked () {
            this.tag('checked="" ');
        }
    }
};

});


parcelRegister("cHYOo", function(module, exports) {

$parcel$export(module.exports, "gfmFromMarkdown", () => $9408ac2a2d3d2fde$export$95adae814eb7433e);
$parcel$export(module.exports, "gfmToMarkdown", () => $9408ac2a2d3d2fde$export$ea77de6901e7c72b);
/**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * @typedef {import('mdast-util-gfm-table').Options} Options
 *   Configuration.
 */ 
var $jtufP = parcelRequire("jtufP");

var $7fiso = parcelRequire("7fiso");

var $6gFBX = parcelRequire("6gFBX");

var $aW3Cb = parcelRequire("aW3Cb");

var $6uTsi = parcelRequire("6uTsi");
function $9408ac2a2d3d2fde$export$95adae814eb7433e() {
    return [
        (0, $jtufP.gfmAutolinkLiteralFromMarkdown),
        (0, $7fiso.gfmFootnoteFromMarkdown)(),
        (0, $6gFBX.gfmStrikethroughFromMarkdown),
        (0, $aW3Cb.gfmTableFromMarkdown),
        (0, $6uTsi.gfmTaskListItemFromMarkdown)
    ];
}
function $9408ac2a2d3d2fde$export$ea77de6901e7c72b(options) {
    return {
        extensions: [
            (0, $jtufP.gfmAutolinkLiteralToMarkdown),
            (0, $7fiso.gfmFootnoteToMarkdown)(),
            (0, $6gFBX.gfmStrikethroughToMarkdown),
            (0, $aW3Cb.gfmTableToMarkdown)(options),
            (0, $6uTsi.gfmTaskListItemToMarkdown)
        ]
    };
}

});
parcelRegister("jtufP", function(module, exports) {

$parcel$export(module.exports, "gfmAutolinkLiteralFromMarkdown", () => $e2d831a13731c0dd$export$b6afdfff2163546f);
$parcel$export(module.exports, "gfmAutolinkLiteralToMarkdown", () => $e2d831a13731c0dd$export$d3ace9096b01c39d);
/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-from-markdown').Transform} FromMarkdownTransform
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-find-and-replace').ReplaceFunction} ReplaceFunction
 * @typedef {import('mdast-util-find-and-replace').RegExpMatchObject} RegExpMatchObject
 */ 
var $i2eI2 = parcelRequire("i2eI2");

var $egS8u = parcelRequire("egS8u");

var $5Lprs = parcelRequire("5Lprs");
/** @type {ConstructName} */ const $e2d831a13731c0dd$var$inConstruct = "phrasing";
/** @type {Array<ConstructName>} */ const $e2d831a13731c0dd$var$notInConstruct = [
    "autolink",
    "link",
    "image",
    "label"
];
const $e2d831a13731c0dd$export$b6afdfff2163546f = {
    transforms: [
        $e2d831a13731c0dd$var$transformGfmAutolinkLiterals
    ],
    enter: {
        literalAutolink: $e2d831a13731c0dd$var$enterLiteralAutolink,
        literalAutolinkEmail: $e2d831a13731c0dd$var$enterLiteralAutolinkValue,
        literalAutolinkHttp: $e2d831a13731c0dd$var$enterLiteralAutolinkValue,
        literalAutolinkWww: $e2d831a13731c0dd$var$enterLiteralAutolinkValue
    },
    exit: {
        literalAutolink: $e2d831a13731c0dd$var$exitLiteralAutolink,
        literalAutolinkEmail: $e2d831a13731c0dd$var$exitLiteralAutolinkEmail,
        literalAutolinkHttp: $e2d831a13731c0dd$var$exitLiteralAutolinkHttp,
        literalAutolinkWww: $e2d831a13731c0dd$var$exitLiteralAutolinkWww
    }
};
const $e2d831a13731c0dd$export$d3ace9096b01c39d = {
    unsafe: [
        {
            character: "@",
            before: "[+\\-.\\w]",
            after: "[\\-.\\w]",
            inConstruct: $e2d831a13731c0dd$var$inConstruct,
            notInConstruct: $e2d831a13731c0dd$var$notInConstruct
        },
        {
            character: ".",
            before: "[Ww]",
            after: "[\\-.\\w]",
            inConstruct: $e2d831a13731c0dd$var$inConstruct,
            notInConstruct: $e2d831a13731c0dd$var$notInConstruct
        },
        {
            character: ":",
            before: "[ps]",
            after: "\\/",
            inConstruct: $e2d831a13731c0dd$var$inConstruct,
            notInConstruct: $e2d831a13731c0dd$var$notInConstruct
        }
    ]
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $e2d831a13731c0dd$var$enterLiteralAutolink(token) {
    this.enter({
        type: "link",
        title: null,
        url: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $e2d831a13731c0dd$var$enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $e2d831a13731c0dd$var$exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $e2d831a13731c0dd$var$exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    const node = /** @type {Link} */ this.stack[this.stack.length - 1];
    node.url = "http://" + this.sliceSerialize(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $e2d831a13731c0dd$var$exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $e2d831a13731c0dd$var$exitLiteralAutolink(token) {
    this.exit(token);
}
/** @type {FromMarkdownTransform} */ function $e2d831a13731c0dd$var$transformGfmAutolinkLiterals(tree) {
    (0, $egS8u.findAndReplace)(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi,
            $e2d831a13731c0dd$var$findUrl
        ],
        [
            /([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g,
            $e2d831a13731c0dd$var$findEmail
        ]
    ], {
        ignore: [
            "link",
            "linkReference"
        ]
    });
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Link | Array<PhrasingContent> | false}
 */ // eslint-disable-next-line max-params
function $e2d831a13731c0dd$var$findUrl(_, protocol, domain, path, match) {
    let prefix = "";
    // Not an expected previous character.
    if (!$e2d831a13731c0dd$var$previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = "";
        prefix = "http://";
    }
    if (!$e2d831a13731c0dd$var$isCorrectDomain(domain)) return false;
    const parts = $e2d831a13731c0dd$var$splitUrl(domain + path);
    if (!parts[0]) return false;
    /** @type {Link} */ const result = {
        type: "link",
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: "text",
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) return [
        result,
        {
            type: "text",
            value: parts[1]
        }
    ];
    return result;
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */ function $e2d831a13731c0dd$var$findEmail(_, atext, label, match) {
    if (// Not an expected previous character.
    !$e2d831a13731c0dd$var$previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)) return false;
    return {
        type: "link",
        title: null,
        url: "mailto:" + atext + "@" + label,
        children: [
            {
                type: "text",
                value: atext + "@" + label
            }
        ]
    };
}
/**
 * @param {string} domain
 * @returns {boolean}
 */ function $e2d831a13731c0dd$var$isCorrectDomain(domain) {
    const parts = domain.split(".");
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */ function $e2d831a13731c0dd$var$splitUrl(url) {
    const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
    if (!trailExec) return [
        url,
        undefined
    ];
    url = url.slice(0, trailExec.index);
    let trail = trailExec[0];
    let closingParenIndex = trail.indexOf(")");
    const openingParens = (0, $i2eI2.ccount)(url, "(");
    let closingParens = (0, $i2eI2.ccount)(url, ")");
    while(closingParenIndex !== -1 && openingParens > closingParens){
        url += trail.slice(0, closingParenIndex + 1);
        trail = trail.slice(closingParenIndex + 1);
        closingParenIndex = trail.indexOf(")");
        closingParens++;
    }
    return [
        url,
        trail
    ];
}
/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */ function $e2d831a13731c0dd$var$previous(match, email) {
    const code = match.input.charCodeAt(match.index - 1);
    return (match.index === 0 || (0, $5Lprs.unicodeWhitespace)(code) || (0, $5Lprs.unicodePunctuation)(code)) && (!email || code !== 47);
}

});
parcelRegister("i2eI2", function(module, exports) {

$parcel$export(module.exports, "ccount", () => $d213d2d8a1d4dc2a$export$fa42eaa97a352e23);
/**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $d213d2d8a1d4dc2a$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== "string") throw new TypeError("Expected character");
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}

});

parcelRegister("egS8u", function(module, exports) {

$parcel$export(module.exports, "findAndReplace", () => $a63c8d941f8d83a2$export$fb306ebf003fc574);
/**
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Text} Text
 * @typedef {import('unist-util-visit-parents').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Content | Root} Node
 * @typedef {Extract<Node, MdastParent>} Parent
 * @typedef {Exclude<Parent, Root>} ContentParent
 *
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[Root, ...Array<ContentParent>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | undefined | null}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {string | RegExp} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 * @typedef {Record<string, Replace>} FindAndReplaceSchema
 *   Several find and replaces, in object form.
 * @typedef {[Find, Replace]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 * @typedef {string | ReplaceFunction} Replace
 *   Thing to replace with.
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore.
 */ 
var $luw0C = parcelRequire("luw0C");

var $imX1f = parcelRequire("imX1f");

var $cWBD6 = parcelRequire("cWBD6");
const $a63c8d941f8d83a2$var$own = {}.hasOwnProperty;
const $a63c8d941f8d83a2$export$fb306ebf003fc574 = /**
   * @type {(
   *   (<Tree extends Node>(tree: Tree, find: Find, replace?: Replace | null | undefined, options?: Options | null | undefined) => Tree) &
   *   (<Tree extends Node>(tree: Tree, schema: FindAndReplaceSchema | FindAndReplaceList, options?: Options | null | undefined) => Tree)
   * )}
   **/ /**
     * @template {Node} Tree
     * @param {Tree} tree
     * @param {Find | FindAndReplaceSchema | FindAndReplaceList} find
     * @param {Replace | Options | null | undefined} [replace]
     * @param {Options | null | undefined} [options]
     * @returns {Tree}
     */ function(tree, find, replace, options) {
    /** @type {Options | null | undefined} */ let settings;
    /** @type {FindAndReplaceSchema|FindAndReplaceList} */ let schema;
    if (typeof find === "string" || find instanceof RegExp) {
        // @ts-expect-error don’t expect options twice.
        schema = [
            [
                find,
                replace
            ]
        ];
        settings = options;
    } else {
        schema = find;
        // @ts-expect-error don’t expect replace twice.
        settings = replace;
    }
    if (!settings) settings = {};
    const ignored = (0, $cWBD6.convert)(settings.ignore || []);
    const pairs = $a63c8d941f8d83a2$var$toPairs(schema);
    let pairIndex = -1;
    while(++pairIndex < pairs.length)(0, $imX1f.visitParents)(tree, "text", visitor);
    // To do next major: don’t return the given tree.
    return tree;
    /** @type {import('unist-util-visit-parents/complex-types.js').BuildVisitor<Root, 'text'>} */ function visitor(node, parents) {
        let index = -1;
        /** @type {Parent | undefined} */ let grandparent;
        while(++index < parents.length){
            const parent = parents[index];
            if (ignored(parent, // @ts-expect-error: TS doesn’t understand but it’s perfect.
            grandparent ? grandparent.children.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        if (grandparent) return handler(node, parents);
    }
    /**
       * Handle a text node which is not in an ignored parent.
       *
       * @param {Text} node
       *   Text node.
       * @param {Array<Parent>} parents
       *   Parents.
       * @returns {VisitorResult}
       *   Result.
       */ function handler(node, parents) {
        const parent = parents[parents.length - 1];
        const find = pairs[pairIndex][0];
        const replace = pairs[pairIndex][1];
        let start = 0;
        // @ts-expect-error: TS is wrong, some of these children can be text.
        const index = parent.children.indexOf(node);
        let change = false;
        /** @type {Array<PhrasingContent>} */ let nodes = [];
        find.lastIndex = 0;
        let match = find.exec(node.value);
        while(match){
            const position = match.index;
            /** @type {RegExpMatchObject} */ const matchObject = {
                index: match.index,
                input: match.input,
                // @ts-expect-error: stack is fine.
                stack: [
                    ...parents,
                    node
                ]
            };
            let value = replace(...match, matchObject);
            if (typeof value === "string") value = value.length > 0 ? {
                type: "text",
                value: value
            } : undefined;
            // It wasn’t a match after all.
            if (value !== false) {
                if (start !== position) nodes.push({
                    type: "text",
                    value: node.value.slice(start, position)
                });
                if (Array.isArray(value)) nodes.push(...value);
                else if (value) nodes.push(value);
                start = position + match[0].length;
                change = true;
            }
            if (!find.global) break;
            match = find.exec(node.value);
        }
        if (change) {
            if (start < node.value.length) nodes.push({
                type: "text",
                value: node.value.slice(start)
            });
            parent.children.splice(index, 1, ...nodes);
        } else nodes = [
            node
        ];
        return index + nodes.length;
    }
};
/**
 * Turn a schema into pairs.
 *
 * @param {FindAndReplaceSchema | FindAndReplaceList} schema
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */ function $a63c8d941f8d83a2$var$toPairs(schema) {
    /** @type {Pairs} */ const result = [];
    if (typeof schema !== "object") throw new TypeError("Expected array or object as schema");
    if (Array.isArray(schema)) {
        let index = -1;
        while(++index < schema.length)result.push([
            $a63c8d941f8d83a2$var$toExpression(schema[index][0]),
            $a63c8d941f8d83a2$var$toFunction(schema[index][1])
        ]);
    } else {
        /** @type {string} */ let key;
        for(key in schema)if ($a63c8d941f8d83a2$var$own.call(schema, key)) result.push([
            $a63c8d941f8d83a2$var$toExpression(key),
            $a63c8d941f8d83a2$var$toFunction(schema[key])
        ]);
    }
    return result;
}
/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */ function $a63c8d941f8d83a2$var$toExpression(find) {
    return typeof find === "string" ? new RegExp((0, $luw0C.default)(find), "g") : find;
}
/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */ function $a63c8d941f8d83a2$var$toFunction(replace) {
    return typeof replace === "function" ? replace : ()=>replace;
}

});
parcelRegister("luw0C", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa553a9daaa2884b$export$2e2bcd8739ae039);
function $fa553a9daaa2884b$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}

});



parcelRegister("7fiso", function(module, exports) {

$parcel$export(module.exports, "gfmFootnoteFromMarkdown", () => $5468404d1b202a98$export$c9d5ad4bdf6ff801);
$parcel$export(module.exports, "gfmFootnoteToMarkdown", () => $5468404d1b202a98$export$3727766a73a6c09f);
/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Map} Map
 */ 
var $9HErY = parcelRequire("9HErY");

var $Xl6Y9 = parcelRequire("Xl6Y9");

var $g5QCV = parcelRequire("g5QCV");

var $ebQRQ = parcelRequire("ebQRQ");

var $gsbWy = parcelRequire("gsbWy");

var $932TR = parcelRequire("932TR");
$5468404d1b202a98$var$footnoteReference.peek = $5468404d1b202a98$var$footnoteReferencePeek;
function $5468404d1b202a98$export$c9d5ad4bdf6ff801() {
    return {
        enter: {
            gfmFootnoteDefinition: $5468404d1b202a98$var$enterFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $5468404d1b202a98$var$enterFootnoteDefinitionLabelString,
            gfmFootnoteCall: $5468404d1b202a98$var$enterFootnoteCall,
            gfmFootnoteCallString: $5468404d1b202a98$var$enterFootnoteCallString
        },
        exit: {
            gfmFootnoteDefinition: $5468404d1b202a98$var$exitFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $5468404d1b202a98$var$exitFootnoteDefinitionLabelString,
            gfmFootnoteCall: $5468404d1b202a98$var$exitFootnoteCall,
            gfmFootnoteCallString: $5468404d1b202a98$var$exitFootnoteCallString
        }
    };
}
function $5468404d1b202a98$export$3727766a73a6c09f() {
    return {
        // This is on by default already.
        unsafe: [
            {
                character: "[",
                inConstruct: [
                    "phrasing",
                    "label",
                    "reference"
                ]
            }
        ],
        handlers: {
            footnoteDefinition: $5468404d1b202a98$var$footnoteDefinition,
            footnoteReference: $5468404d1b202a98$var$footnoteReference
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $5468404d1b202a98$var$enterFootnoteDefinition(token) {
    this.enter({
        type: "footnoteDefinition",
        identifier: "",
        label: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $5468404d1b202a98$var$enterFootnoteDefinitionLabelString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $5468404d1b202a98$var$exitFootnoteDefinitionLabelString(token) {
    const label = this.resume();
    const node = /** @type {FootnoteDefinition} */ this.stack[this.stack.length - 1];
    node.label = label;
    node.identifier = (0, $9HErY.normalizeIdentifier)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $5468404d1b202a98$var$exitFootnoteDefinition(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $5468404d1b202a98$var$enterFootnoteCall(token) {
    this.enter({
        type: "footnoteReference",
        identifier: "",
        label: ""
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $5468404d1b202a98$var$enterFootnoteCallString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $5468404d1b202a98$var$exitFootnoteCallString(token) {
    const label = this.resume();
    const node = /** @type {FootnoteDefinition} */ this.stack[this.stack.length - 1];
    node.label = label;
    node.identifier = (0, $9HErY.normalizeIdentifier)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $5468404d1b202a98$var$exitFootnoteCall(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */ function $5468404d1b202a98$var$footnoteReference(node, _, context, safeOptions) {
    const tracker = (0, $932TR.track)(safeOptions);
    let value = tracker.move("[^");
    const exit = context.enter("footnoteReference");
    const subexit = context.enter("reference");
    value += tracker.move((0, $gsbWy.safe)(context, (0, $Xl6Y9.association)(node), {
        ...tracker.current(),
        before: value,
        after: "]"
    }));
    subexit();
    exit();
    value += tracker.move("]");
    return value;
}
/** @type {ToMarkdownHandle} */ function $5468404d1b202a98$var$footnoteReferencePeek() {
    return "[";
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteDefinition} node
 */ function $5468404d1b202a98$var$footnoteDefinition(node, _, context, safeOptions) {
    const tracker = (0, $932TR.track)(safeOptions);
    let value = tracker.move("[^");
    const exit = context.enter("footnoteDefinition");
    const subexit = context.enter("label");
    value += tracker.move((0, $gsbWy.safe)(context, (0, $Xl6Y9.association)(node), {
        ...tracker.current(),
        before: value,
        after: "]"
    }));
    subexit();
    value += tracker.move("]:" + (node.children && node.children.length > 0 ? " " : ""));
    tracker.shift(4);
    value += tracker.move((0, $ebQRQ.indentLines)((0, $g5QCV.containerFlow)(node, context, tracker.current()), $5468404d1b202a98$var$map));
    exit();
    return value;
}
/** @type {Map} */ function $5468404d1b202a98$var$map(line, index, blank) {
    if (index === 0) return line;
    return (blank ? "" : "    ") + line;
}

});
parcelRegister("Xl6Y9", function(module, exports) {

$parcel$export(module.exports, "association", () => $0b25e316b3cdae32$export$c4ca1a6065421754);
/**
 * @typedef {import('../types.js').AssociationId} AssociationId
 */ 
var $1lC1m = parcelRequire("1lC1m");
function $0b25e316b3cdae32$export$c4ca1a6065421754(node) {
    if (node.label || !node.identifier) return node.label || "";
    return (0, $1lC1m.decodeString)(node.identifier);
}

});

parcelRegister("g5QCV", function(module, exports) {

$parcel$export(module.exports, "containerFlow", () => $bb75ef93e8a9948e$export$134f7fdacfea8b16);
/**
 * @typedef {import('../types.js').FlowContent} FlowContent
 * @typedef {import('../types.js').Node} Node
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').TrackFields} TrackFields
 */ /**
 * @param {Parent & {children: Array<FlowContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $bb75ef93e8a9948e$export$134f7fdacfea8b16(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    const tracker = state.createTracker(info);
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    indexStack.push(-1);
    while(++index < children.length){
        const child = children[index];
        indexStack[indexStack.length - 1] = index;
        results.push(tracker.move(state.handle(child, parent, state, {
            before: "\n",
            after: "\n",
            ...tracker.current()
        })));
        if (child.type !== "list") state.bulletLastUsed = undefined;
        if (index < children.length - 1) results.push(tracker.move($bb75ef93e8a9948e$var$between(child, children[index + 1], parent, state)));
    }
    indexStack.pop();
    return results.join("");
}
/**
 * @param {Node} left
 * @param {Node} right
 * @param {Parent} parent
 * @param {State} state
 * @returns {string}
 */ function $bb75ef93e8a9948e$var$between(left, right, parent, state) {
    let index = state.join.length;
    while(index--){
        const result = state.join[index](left, right, parent, state);
        if (result === true || result === 1) break;
        if (typeof result === "number") return "\n".repeat(1 + result);
        if (result === false) return "\n\n<!---->\n\n";
    }
    return "\n\n";
}

});

parcelRegister("ebQRQ", function(module, exports) {

$parcel$export(module.exports, "indentLines", () => $a54b1a24f5b42795$export$7c3cf23d514b264a);
/**
 * @typedef {import('../types.js').IndentLines} IndentLines
 */ const $a54b1a24f5b42795$var$eol = /\r?\n|\r/g;
function $a54b1a24f5b42795$export$7c3cf23d514b264a(value, map) {
    /** @type {Array<string>} */ const result = [];
    let start = 0;
    let line = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = $a54b1a24f5b42795$var$eol.exec(value)){
        one(value.slice(start, match.index));
        result.push(match[0]);
        start = match.index + match[0].length;
        line++;
    }
    one(value.slice(start));
    return result.join("");
    /**
   * @param {string} value
   */ function one(value) {
        result.push(map(value, line, !value));
    }
}

});

parcelRegister("gsbWy", function(module, exports) {

$parcel$export(module.exports, "safe", () => $bfa88698ff257257$export$170b8c323eee7bec);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').SafeConfig} SafeConfig
 */ 
var $hd1IU = parcelRequire("hd1IU");

var $dE4NC = parcelRequire("dE4NC");
function $bfa88698ff257257$export$170b8c323eee7bec(state, input, config) {
    const value = (config.before || "") + (input || "") + (config.after || "");
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const result = [];
    /** @type {Record<number, {before: boolean, after: boolean}>} */ const infos = {};
    let index = -1;
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        if (!(0, $dE4NC.patternInScope)(state.stack, pattern)) continue;
        const expression = (0, $hd1IU.patternCompile)(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        while(match = expression.exec(value)){
            const before = "before" in pattern || Boolean(pattern.atBreak);
            const after = "after" in pattern;
            const position = match.index + (before ? match[1].length : 0);
            if (positions.includes(position)) {
                if (infos[position].before && !before) infos[position].before = false;
                if (infos[position].after && !after) infos[position].after = false;
            } else {
                positions.push(position);
                infos[position] = {
                    before: before,
                    after: after
                };
            }
        }
    }
    positions.sort($bfa88698ff257257$var$numerical);
    let start = config.before ? config.before.length : 0;
    const end = value.length - (config.after ? config.after.length : 0);
    index = -1;
    while(++index < positions.length){
        const position = positions[index];
        // Character before or after matched:
        if (position < start || position >= end) continue;
        // If this character is supposed to be escaped because it has a condition on
        // the next character, and the next character is definitly being escaped,
        // then skip this escape.
        if (position + 1 < end && positions[index + 1] === position + 1 && infos[position].after && !infos[position + 1].before && !infos[position + 1].after || positions[index - 1] === position - 1 && infos[position].before && !infos[position - 1].before && !infos[position - 1].after) continue;
        if (start !== position) // If we have to use a character reference, an ampersand would be more
        // correct, but as backslashes only care about punctuation, either will
        // do the trick
        result.push($bfa88698ff257257$var$escapeBackslashes(value.slice(start, position), "\\"));
        start = position;
        if (/[!-/:-@[-`{-~]/.test(value.charAt(position)) && (!config.encode || !config.encode.includes(value.charAt(position)))) // Character escape.
        result.push("\\");
        else {
            // Character reference.
            result.push("&#x" + value.charCodeAt(position).toString(16).toUpperCase() + ";");
            start++;
        }
    }
    result.push($bfa88698ff257257$var$escapeBackslashes(value.slice(start, end), config.after));
    return result.join("");
}
/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */ function $bfa88698ff257257$var$numerical(a, b) {
    return a - b;
}
/**
 * @param {string} value
 * @param {string} after
 * @returns {string}
 */ function $bfa88698ff257257$var$escapeBackslashes(value, after) {
    const expression = /\\(?=[!-/:-@[-`{-~])/g;
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const results = [];
    const whole = value + after;
    let index = -1;
    let start = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = expression.exec(whole))positions.push(match.index);
    while(++index < positions.length){
        if (start !== positions[index]) results.push(value.slice(start, positions[index]));
        results.push("\\");
        start = positions[index];
    }
    results.push(value.slice(start));
    return results.join("");
}

});
parcelRegister("hd1IU", function(module, exports) {

$parcel$export(module.exports, "patternCompile", () => $c874fcc3f337e271$export$7993761911514c15);
/**
 * @typedef {import('../types.js').Unsafe} Unsafe
 */ /**
 * @param {Unsafe} pattern
 * @returns {RegExp}
 */ function $c874fcc3f337e271$export$7993761911514c15(pattern) {
    if (!pattern._compiled) {
        const before = (pattern.atBreak ? "[\\r\\n][\\t ]*" : "") + (pattern.before ? "(?:" + pattern.before + ")" : "");
        pattern._compiled = new RegExp((before ? "(" + before + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? "\\" : "") + pattern.character + (pattern.after ? "(?:" + pattern.after + ")" : ""), "g");
    }
    return pattern._compiled;
}

});

parcelRegister("dE4NC", function(module, exports) {

$parcel$export(module.exports, "patternInScope", () => $9ef2bbd8ad36e1e9$export$78221a09424368d);
/**
 * @typedef {import('../types.js').Unsafe} Unsafe
 * @typedef {import('../types.js').ConstructName} ConstructName
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $9ef2bbd8ad36e1e9$export$78221a09424368d(stack, pattern) {
    return $9ef2bbd8ad36e1e9$var$listInScope(stack, pattern.inConstruct, true) && !$9ef2bbd8ad36e1e9$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $9ef2bbd8ad36e1e9$var$listInScope(stack, list, none) {
    if (typeof list === "string") list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}

});


parcelRegister("932TR", function(module, exports) {

$parcel$export(module.exports, "track", () => $6966a4bac7e40d15$export$6b2a7d5132615086);
/**
 * @typedef {import('../types.js').CreateTracker} CreateTracker
 * @typedef {import('../types.js').TrackCurrent} TrackCurrent
 * @typedef {import('../types.js').TrackMove} TrackMove
 * @typedef {import('../types.js').TrackShift} TrackShift
 */ /**
 * Track positional info in the output.
 *
 * @type {CreateTracker}
 */ function $6966a4bac7e40d15$export$6b2a7d5132615086(config) {
    // Defaults are used to prevent crashes when older utilities somehow activate
    // this code.
    /* c8 ignore next 5 */ const options = config || {};
    const now = options.now || {};
    let lineShift = options.lineShift || 0;
    let line = now.line || 1;
    let column = now.column || 1;
    return {
        move: move,
        current: current,
        shift: shift
    };
    /**
   * Get the current tracked info.
   *
   * @type {TrackCurrent}
   */ function current() {
        return {
            now: {
                line: line,
                column: column
            },
            lineShift: lineShift
        };
    }
    /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @type {TrackShift}
   */ function shift(value) {
        lineShift += value;
    }
    /**
   * Move past some generated markdown.
   *
   * @type {TrackMove}
   */ function move(input) {
        // eslint-disable-next-line unicorn/prefer-default-parameters
        const value = input || "";
        const chunks = value.split(/\r?\n|\r/g);
        const tail = chunks[chunks.length - 1];
        line += chunks.length - 1;
        column = chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift;
        return value;
    }
}

});


parcelRegister("6gFBX", function(module, exports) {

$parcel$export(module.exports, "gfmStrikethroughFromMarkdown", () => $490483cfdd6b5d27$export$34d64e709dd0b9bb);
$parcel$export(module.exports, "gfmStrikethroughToMarkdown", () => $490483cfdd6b5d27$export$1632835bd2c84956);
/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ 
var $8Rca2 = parcelRequire("8Rca2");

var $932TR = parcelRequire("932TR");
// To do: next major: expose functions.
// To do: next major: use `state`, state utilities.
/**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ const $490483cfdd6b5d27$var$constructsWithoutStrikethrough = [
    "autolink",
    "destinationLiteral",
    "destinationRaw",
    "reference",
    "titleQuote",
    "titleApostrophe"
];
$490483cfdd6b5d27$var$handleDelete.peek = $490483cfdd6b5d27$var$peekDelete;
const $490483cfdd6b5d27$export$34d64e709dd0b9bb = {
    canContainEols: [
        "delete"
    ],
    enter: {
        strikethrough: $490483cfdd6b5d27$var$enterStrikethrough
    },
    exit: {
        strikethrough: $490483cfdd6b5d27$var$exitStrikethrough
    }
};
const $490483cfdd6b5d27$export$1632835bd2c84956 = {
    unsafe: [
        {
            character: "~",
            inConstruct: "phrasing",
            notInConstruct: $490483cfdd6b5d27$var$constructsWithoutStrikethrough
        }
    ],
    handlers: {
        delete: $490483cfdd6b5d27$var$handleDelete
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $490483cfdd6b5d27$var$enterStrikethrough(token) {
    this.enter({
        type: "delete",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $490483cfdd6b5d27$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $490483cfdd6b5d27$var$handleDelete(node, _, context, safeOptions) {
    const tracker = (0, $932TR.track)(safeOptions);
    const exit = context.enter("strikethrough");
    let value = tracker.move("~~");
    value += (0, $8Rca2.containerPhrasing)(node, context, {
        ...tracker.current(),
        before: value,
        after: "~"
    });
    value += tracker.move("~~");
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $490483cfdd6b5d27$var$peekDelete() {
    return "~";
}

});
parcelRegister("8Rca2", function(module, exports) {

$parcel$export(module.exports, "containerPhrasing", () => $672cb4db25cfb369$export$f4090a9439f37631);
/**
 * @typedef {import('../types.js').Handle} Handle
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').PhrasingContent} PhrasingContent
 * @typedef {import('../types.js').State} State
 */ /**
 * Serialize the children of a parent that contains phrasing children.
 *
 * These children will be joined flush together.
 *
 * @param {Parent & {children: Array<PhrasingContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Info} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined together.
 */ function $672cb4db25cfb369$export$f4090a9439f37631(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    let before = info.before;
    indexStack.push(-1);
    let tracker = state.createTracker(info);
    while(++index < children.length){
        const child = children[index];
        /** @type {string} */ let after;
        indexStack[indexStack.length - 1] = index;
        if (index + 1 < children.length) {
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            let handle = state.handle.handlers[children[index + 1].type];
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            if (handle && handle.peek) handle = handle.peek;
            after = handle ? handle(children[index + 1], parent, state, {
                before: "",
                after: "",
                ...tracker.current()
            }).charAt(0) : "";
        } else after = info.after;
        // In some cases, html (text) can be found in phrasing right after an eol.
        // When we’d serialize that, in most cases that would be seen as html
        // (flow).
        // As we can’t escape or so to prevent it from happening, we take a somewhat
        // reasonable approach: replace that eol with a space.
        // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
        if (results.length > 0 && (before === "\r" || before === "\n") && child.type === "html") {
            results[results.length - 1] = results[results.length - 1].replace(/(\r?\n|\r)$/, " ");
            before = " ";
            // To do: does this work to reset tracker?
            tracker = state.createTracker(info);
            tracker.move(results.join(""));
        }
        results.push(tracker.move(state.handle(child, parent, state, {
            ...tracker.current(),
            before: before,
            after: after
        })));
        before = results[results.length - 1].slice(-1);
    }
    indexStack.pop();
    return results.join("");
}

});


parcelRegister("aW3Cb", function(module, exports) {

$parcel$export(module.exports, "gfmTableFromMarkdown", () => $7f6220023e6c5bbd$export$8bd0ec8ecf6adb7d);
$parcel$export(module.exports, "gfmTableToMarkdown", () => $7f6220023e6c5bbd$export$dafcad76ea6e0045);
/**
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').InlineCode} InlineCode
 *
 * @typedef {import('markdown-table').MarkdownTableOptions} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Context} ToMarkdownContext
 * @typedef {import('mdast-util-to-markdown').SafeOptions} SafeOptions
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells.
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters.
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells
 */ 
var $8Rca2 = parcelRequire("8Rca2");

var $btXGe = parcelRequire("btXGe");

var $hrF9c = parcelRequire("hrF9c");
const $7f6220023e6c5bbd$export$8bd0ec8ecf6adb7d = {
    enter: {
        table: $7f6220023e6c5bbd$var$enterTable,
        tableData: $7f6220023e6c5bbd$var$enterCell,
        tableHeader: $7f6220023e6c5bbd$var$enterCell,
        tableRow: $7f6220023e6c5bbd$var$enterRow
    },
    exit: {
        codeText: $7f6220023e6c5bbd$var$exitCodeText,
        table: $7f6220023e6c5bbd$var$exitTable,
        tableData: $7f6220023e6c5bbd$var$exit,
        tableHeader: $7f6220023e6c5bbd$var$exit,
        tableRow: $7f6220023e6c5bbd$var$exit
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7f6220023e6c5bbd$var$enterTable(token) {
    /** @type {Array<'left' | 'right' | 'center' | 'none'>} */ // @ts-expect-error: `align` is custom.
    const align = token._align;
    this.enter({
        type: "table",
        align: align.map((d)=>d === "none" ? null : d),
        children: []
    }, token);
    this.setData("inTable", true);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7f6220023e6c5bbd$var$exitTable(token) {
    this.exit(token);
    this.setData("inTable");
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7f6220023e6c5bbd$var$enterRow(token) {
    this.enter({
        type: "tableRow",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7f6220023e6c5bbd$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7f6220023e6c5bbd$var$enterCell(token) {
    this.enter({
        type: "tableCell",
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7f6220023e6c5bbd$var$exitCodeText(token) {
    let value = this.resume();
    if (this.getData("inTable")) value = value.replace(/\\([\\|])/g, $7f6220023e6c5bbd$var$replace);
    const node = /** @type {InlineCode} */ this.stack[this.stack.length - 1];
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $7f6220023e6c5bbd$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}
function $7f6220023e6c5bbd$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? " " : "|";
    return {
        unsafe: [
            {
                character: "\r",
                inConstruct: "tableCell"
            },
            {
                character: "\n",
                inConstruct: "tableCell"
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: "|",
                after: "[	 :-]"
            },
            // A pipe in a cell must be encoded.
            {
                character: "|",
                inConstruct: "tableCell"
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ":",
                after: "-"
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: "-",
                after: "[:|-]"
            }
        ],
        handlers: {
            table: handleTable,
            tableRow: handleTableRow,
            tableCell: handleTableCell,
            inlineCode: inlineCodeWithTable
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, context, safeOptions) {
        return serializeData(handleTableAsData(node, context, safeOptions), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, context, safeOptions) {
        const row = handleTableRowAsData(node, context, safeOptions);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf("\n"));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, context, safeOptions) {
        const exit = context.enter("tableCell");
        const subexit = context.enter("phrasing");
        const value = (0, $8Rca2.containerPhrasing)(node, context, {
            ...safeOptions,
            before: around,
            after: around
        });
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $hrF9c.markdownTable)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */ function handleTableAsData(node, context, safeOptions) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = context.enter("table");
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], context, safeOptions);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */ function handleTableRowAsData(node, context, safeOptions) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = context.enter("tableRow");
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, context, safeOptions);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, context) {
        let value = (0, $btXGe.inlineCode)(node, parent, context);
        if (context.stack.includes("tableCell")) value = value.replace(/\|/g, "\\$&");
        return value;
    }
}

});
parcelRegister("btXGe", function(module, exports) {

$parcel$export(module.exports, "inlineCode", () => $85c0b25e011fb514$export$91b9bee19a0d8569);
/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 */ 
var $hd1IU = parcelRequire("hd1IU");
$85c0b25e011fb514$export$91b9bee19a0d8569.peek = $85c0b25e011fb514$var$inlineCodePeek;
function $85c0b25e011fb514$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || "";
    let sequence = "`";
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp("(^|[^`])" + sequence + "([^`]|$)").test(value))sequence += "`";
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = " " + value + " ";
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = (0, $hd1IU.patternCompile)(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + " " + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $85c0b25e011fb514$var$inlineCodePeek() {
    return "`";
}

});

parcelRegister("hrF9c", function(module, exports) {

$parcel$export(module.exports, "markdownTable", () => $cb34e05222debc2c$export$cdb7288612c4f3d6);
// To do: next major: remove.
/**
 * @typedef {Options} MarkdownTableOptions
 *   Configuration.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [alignDelimiters=true]
 *   Whether to align the delimiters (default: `true`);
 *   they are aligned by default:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {ReadonlyArray<string | null | undefined> | string | null | undefined} [align]
 *   How to align columns (default: `''`);
 *   one style for all columns or styles for their respective columns;
 *   each style is either `'l'` (left), `'r'` (right), or `'c'` (center);
 *   other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left;
 *   *only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean | null | undefined} [delimiterEnd=true]
 *   Whether to end each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean | null | undefined} [delimiterStart=true]
 *   Whether to begin each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean | null | undefined} [padding=true]
 *   Whether to add a space of padding between delimiters and cells
 *   (default: `true`).
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {((value: string) => number) | null | undefined} [stringLength]
 *   Function to detect the length of table cell content (optional);
 *   this is used when aligning the delimiters (`|`) between table cells;
 *   full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source;
 *   to fix this, you can pass this function,
 *   which receives the cell content and returns its “visible” size;
 *   note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @param {string} value
 *   Cell value.
 * @returns {number}
 *   Cell size.
 */ function $cb34e05222debc2c$var$defaultStringLength(value) {
    return value.length;
}
function $cb34e05222debc2c$export$cdb7288612c4f3d6(table, options) {
    const settings = options || {};
    // To do: next major: change to spread.
    const align = (settings.align || []).concat();
    const stringLength = settings.stringLength || $cb34e05222debc2c$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $cb34e05222debc2c$var$serialize(table[rowIndex][columnIndex]);
            if (settings.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === "object" && "length" in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $cb34e05222debc2c$var$toAlignment(align[columnIndex]);
    else {
        const code = $cb34e05222debc2c$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = "";
        let after = "";
        if (code === 99 /* `c` */ ) {
            before = ":";
            after = ":";
        } else if (code === 108 /* `l` */ ) before = ":";
        else if (code === 114 /* `r` */ ) after = ":";
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = settings.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + "-".repeat(size) + after;
        if (settings.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || "";
            let before = "";
            let after = "";
            if (settings.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = " ".repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = " ".repeat(size / 2 + 0.5);
                        after = " ".repeat(size / 2 - 0.5);
                    } else {
                        before = " ".repeat(size / 2);
                        after = before;
                    }
                } else after = " ".repeat(size);
            }
            if (settings.delimiterStart !== false && !columnIndex) line.push("|");
            if (settings.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(settings.alignDelimiters === false && cell === "") && (settings.delimiterStart !== false || columnIndex)) line.push(" ");
            if (settings.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (settings.alignDelimiters !== false) line.push(after);
            if (settings.padding !== false) line.push(" ");
            if (settings.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push("|");
        }
        lines.push(settings.delimiterEnd === false ? line.join("").replace(/ +$/, "") : line.join(""));
    }
    return lines.join("\n");
}
/**
 * @param {string | null | undefined} [value]
 *   Value to serialize.
 * @returns {string}
 *   Result.
 */ function $cb34e05222debc2c$var$serialize(value) {
    return value === null || value === undefined ? "" : String(value);
}
/**
 * @param {string | null | undefined} value
 *   Value.
 * @returns {number}
 *   Alignment.
 */ function $cb34e05222debc2c$var$toAlignment(value) {
    const code = typeof value === "string" ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}

});


parcelRegister("6uTsi", function(module, exports) {

$parcel$export(module.exports, "gfmTaskListItemFromMarkdown", () => $4bb08fb2c9b2cb2b$export$a427a608608b215f);
$parcel$export(module.exports, "gfmTaskListItemToMarkdown", () => $4bb08fb2c9b2cb2b$export$9975722e7e834b78);
/**
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ /**
 * @typedef {Extract<Root | Content, Parent>} Parents
 */ 
var $kWqww = parcelRequire("kWqww");

var $932TR = parcelRequire("932TR");
const $4bb08fb2c9b2cb2b$export$a427a608608b215f = {
    exit: {
        taskListCheckValueChecked: $4bb08fb2c9b2cb2b$var$exitCheck,
        taskListCheckValueUnchecked: $4bb08fb2c9b2cb2b$var$exitCheck,
        paragraph: $4bb08fb2c9b2cb2b$var$exitParagraphWithTaskListItem
    }
};
const $4bb08fb2c9b2cb2b$export$9975722e7e834b78 = {
    unsafe: [
        {
            atBreak: true,
            character: "-",
            after: "[:|-]"
        }
    ],
    handlers: {
        listItem: $4bb08fb2c9b2cb2b$var$listItemWithTaskListItem
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4bb08fb2c9b2cb2b$var$exitCheck(token) {
    const node = /** @type {ListItem} */ this.stack[this.stack.length - 2];
    // We’re always in a paragraph, in a list item.
    node.checked = token.type === "taskListCheckValueChecked";
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4bb08fb2c9b2cb2b$var$exitParagraphWithTaskListItem(token) {
    const parent = /** @type {Parents} */ this.stack[this.stack.length - 2];
    if (parent && parent.type === "listItem" && typeof parent.checked === "boolean") {
        const node = /** @type {Paragraph} */ this.stack[this.stack.length - 1];
        const head = node.children[0];
        if (head && head.type === "text") {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === "paragraph") {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === "number") {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $4bb08fb2c9b2cb2b$var$listItemWithTaskListItem(node, parent, context, safeOptions) {
    const head = node.children[0];
    const checkable = typeof node.checked === "boolean" && head && head.type === "paragraph";
    const checkbox = "[" + (node.checked ? "x" : " ") + "] ";
    const tracker = (0, $932TR.track)(safeOptions);
    if (checkable) tracker.move(checkbox);
    let value = (0, $kWqww.listItem)(node, parent, context, {
        ...safeOptions,
        ...tracker.current()
    });
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}

});
parcelRegister("kWqww", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $f3edcc74c0b233fe$export$76c7e83ecc9cdf05);
/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ 
var $9OG6d = parcelRequire("9OG6d");

var $8Gq65 = parcelRequire("8Gq65");
function $f3edcc74c0b233fe$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $8Gq65.checkListItemIndent)(state);
    let bullet = state.bulletCurrent || (0, $9OG6d.checkBullet)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === "list" && parent.ordered) bullet = (typeof parent.start === "number" && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === "tab" || listItemIndent === "mixed" && (parent && parent.type === "list" && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + " ".repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter("listItem");
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? "" : " ".repeat(size)) + line;
        return (blank ? bullet : bullet + " ".repeat(size - bullet.length)) + line;
    }
}

});
parcelRegister("9OG6d", function(module, exports) {

$parcel$export(module.exports, "checkBullet", () => $72597098fa7e90b1$export$7425517207a4d0ae);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $72597098fa7e90b1$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || "*";
    if (marker !== "*" && marker !== "+" && marker !== "-") throw new Error("Cannot serialize items with `" + marker + "` for `options.bullet`, expected `*`, `+`, or `-`");
    return marker;
}

});

parcelRegister("8Gq65", function(module, exports) {

$parcel$export(module.exports, "checkListItemIndent", () => $65267d532af6493a$export$2d5358b63da92261);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $65267d532af6493a$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || "tab";
    // To do: remove in a major.
    // @ts-expect-error: deprecated.
    if (style === 1 || style === "1") return "one";
    if (style !== "tab" && style !== "one" && style !== "mixed") throw new Error("Cannot serialize items with `" + style + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`");
    return style;
}

});





parcelRegister("lFVtV", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc7a03f5c6f30434$export$2e2bcd8739ae039);
/**
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast-util-sanitize').Schema} Schema
 */ 
var $dz6YI = parcelRequire("dz6YI");
function $fc7a03f5c6f30434$export$2e2bcd8739ae039(options) {
    /**
   * @param {Root} tree
   *   Tree.
   * @returns {Root}
   *   New tree.
   */ return function(tree) {
        // Assume root in -> root out.
        const result = /** @type {Root} */ (0, $dz6YI.sanitize)(tree, options);
        return result;
    };
}

});
parcelRegister("dz6YI", function(module, exports) {

$parcel$export(module.exports, "sanitize", () => $9e03f5008c34193d$export$83d2e9e3e4ee39ed);
/**
 * @import {
 *   Comment,
 *   Doctype,
 *   ElementContent,
 *   Element,
 *   Nodes,
 *   Properties,
 *   RootContent,
 *   Root,
 *   Text
 * } from 'hast'
 */ /**
 * @typedef {[string, ...Array<Exclude<Properties[keyof Properties], Array<any>> | RegExp>] | string} PropertyDefinition
 *   Definition for a property.
 *
 * @typedef Schema
 *   Schema that defines what nodes and properties are allowed.
 *
 *   The default schema is `defaultSchema`, which follows how GitHub cleans.
 *   If any top-level key is missing in the given schema, the corresponding
 *   value of the default schema is used.
 *
 *   To extend the standard schema with a few changes, clone `defaultSchema`
 *   like so:
 *
 *   ```js
 *   import deepmerge from 'deepmerge'
 *   import {h} from 'hastscript'
 *   import {defaultSchema, sanitize} from 'hast-util-sanitize'
 *
 *   // This allows `className` on all elements.
 *   const schema = deepmerge(defaultSchema, {attributes: {'*': ['className']}})
 *
 *   const tree = sanitize(h('div', {className: ['foo']}), schema)
 *
 *   // `tree` still has `className`.
 *   console.log(tree)
 *   // {
 *   //   type: 'element',
 *   //   tagName: 'div',
 *   //   properties: {className: ['foo']},
 *   //   children: []
 *   // }
 *   ```
 * @property {boolean | null | undefined} [allowComments=false]
 *   Whether to allow comment nodes (default: `false`).
 *
 *   For example:
 *
 *   ```js
 *   allowComments: true
 *   ```
 * @property {boolean | null | undefined} [allowDoctypes=false]
 *   Whether to allow doctype nodes (default: `false`).
 *
 *   For example:
 *
 *   ```js
 *   allowDoctypes: true
 *   ```
 * @property {Record<string, Array<string>> | null | undefined} [ancestors]
 *   Map of tag names to a list of tag names which are required ancestors
 *   (default: `defaultSchema.ancestors`).
 *
 *   Elements with these tag names will be ignored if they occur outside of one
 *   of their allowed parents.
 *
 *   For example:
 *
 *   ```js
 *   ancestors: {
 *     tbody: ['table'],
 *     // …
 *     tr: ['table']
 *   }
 *   ```
 * @property {Record<string, Array<PropertyDefinition>> | null | undefined} [attributes]
 *   Map of tag names to allowed property names (default:
 *   `defaultSchema.attributes`).
 *
 *   The special key `'*'` as a tag name defines property names allowed on all
 *   elements.
 *
 *   The special value `'data*'` as a property name can be used to allow all
 *   `data` properties.
 *
 *   For example:
 *
 *   ```js
 *   attributes: {
 *     'ariaDescribedBy', 'ariaLabel', 'ariaLabelledBy', …, 'href'
 *     // …
 *     '*': [
 *       'abbr',
 *       'accept',
 *       'acceptCharset',
 *       // …
 *       'vAlign',
 *       'value',
 *       'width'
 *     ]
 *   }
 *   ```
 *
 *   Instead of a single string in the array, which allows any property value
 *   for the field, you can use an array to allow several values.
 *   For example, `input: ['type']` allows `type` set to any value on `input`s.
 *   But `input: [['type', 'checkbox', 'radio']]` allows `type` when set to
 *   `'checkbox'` or `'radio'`.
 *
 *   You can use regexes, so for example `span: [['className', /^hljs-/]]`
 *   allows any class that starts with `hljs-` on `span`s.
 *
 *   When comma- or space-separated values are used (such as `className`), each
 *   value in is checked individually.
 *   For example, to allow certain classes on `span`s for syntax highlighting,
 *   use `span: [['className', 'number', 'operator', 'token']]`.
 *   This will allow `'number'`, `'operator'`, and `'token'` classes, but drop
 *   others.
 * @property {Array<string> | null | undefined} [clobber]
 *   List of property names that clobber (default: `defaultSchema.clobber`).
 *
 *   For example:
 *
 *   ```js
 *   clobber: ['ariaDescribedBy', 'ariaLabelledBy', 'id', 'name']
 *   ```
 * @property {string | null | undefined} [clobberPrefix]
 *   Prefix to use before clobbering properties (default:
 *   `defaultSchema.clobberPrefix`).
 *
 *   For example:
 *
 *   ```js
 *   clobberPrefix: 'user-content-'
 *   ```
 * @property {Record<string, Array<string> | null | undefined> | null | undefined} [protocols]
 *   Map of *property names* to allowed protocols (default:
 *   `defaultSchema.protocols`).
 *
 *   This defines URLs that are always allowed to have local URLs (relative to
 *   the current website, such as `this`, `#this`, `/this`, or `?this`), and
 *   only allowed to have remote URLs (such as `https://example.com`) if they
 *   use a known protocol.
 *
 *   For example:
 *
 *   ```js
 *   protocols: {
 *     cite: ['http', 'https'],
 *     // …
 *     src: ['http', 'https']
 *   }
 *   ```
 * @property {Record<string, Record<string, Properties[keyof Properties]>> | null | undefined} [required]
 *   Map of tag names to required property names with a default value
 *   (default: `defaultSchema.required`).
 *
 *   This defines properties that must be set.
 *   If a field does not exist (after the element was made safe), these will be
 *   added with the given value.
 *
 *   For example:
 *
 *   ```js
 *   required: {
 *     input: {disabled: true, type: 'checkbox'}
 *   }
 *   ```
 *
 *   > 👉 **Note**: properties are first checked based on `schema.attributes`,
 *   > then on `schema.required`.
 *   > That means properties could be removed by `attributes` and then added
 *   > again with `required`.
 * @property {Array<string> | null | undefined} [strip]
 *   List of tag names to strip from the tree (default: `defaultSchema.strip`).
 *
 *   By default, unsafe elements (those not in `schema.tagNames`) are replaced
 *   by what they contain.
 *   This option can drop their contents.
 *
 *   For example:
 *
 *   ```js
 *   strip: ['script']
 *   ```
 * @property {Array<string> | null | undefined} [tagNames]
 *   List of allowed tag names (default: `defaultSchema.tagNames`).
 *
 *   For example:
 *
 *   ```js
 *   tagNames: [
 *     'a',
 *     'b',
 *     // …
 *     'ul',
 *     'var'
 *   ]
 *   ```
 *
 * @typedef State
 *   Info passed around.
 * @property {Readonly<Schema>} schema
 *   Schema.
 * @property {Array<string>} stack
 *   Tag names of ancestors.
 */ 
var $lWKwn = parcelRequire("lWKwn");

var $g7Bfx = parcelRequire("g7Bfx");

var $7OeFl = parcelRequire("7OeFl");
const $9e03f5008c34193d$var$own = {}.hasOwnProperty;
function $9e03f5008c34193d$export$83d2e9e3e4ee39ed(node, options) {
    /** @type {Nodes} */ let result = {
        type: "root",
        children: []
    };
    /** @type {State} */ const state = {
        schema: options ? {
            ...(0, $7OeFl.defaultSchema),
            ...options
        } : (0, $7OeFl.defaultSchema),
        stack: []
    };
    const replace = $9e03f5008c34193d$var$transform(state, node);
    if (replace) {
        if (Array.isArray(replace)) {
            if (replace.length === 1) result = replace[0];
            else result.children = replace;
        } else result = replace;
    }
    return result;
}
/**
 * Sanitize `node`.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<unknown>} node
 *   Unsafe node.
 * @returns {Array<ElementContent> | Nodes | undefined}
 *   Safe result.
 */ function $9e03f5008c34193d$var$transform(state, node) {
    if (node && typeof node === "object") {
        const unsafe = /** @type {Record<string, Readonly<unknown>>} */ node;
        const type = typeof unsafe.type === "string" ? unsafe.type : "";
        switch(type){
            case "comment":
                return $9e03f5008c34193d$var$comment(state, unsafe);
            case "doctype":
                return $9e03f5008c34193d$var$doctype(state, unsafe);
            case "element":
                return $9e03f5008c34193d$var$element(state, unsafe);
            case "root":
                return $9e03f5008c34193d$var$root(state, unsafe);
            case "text":
                return $9e03f5008c34193d$var$text(state, unsafe);
            default:
        }
    }
}
/**
 * Make a safe comment.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe comment-like value.
 * @returns {Comment | undefined}
 *   Safe comment (if with `allowComments`).
 */ function $9e03f5008c34193d$var$comment(state, unsafe) {
    if (state.schema.allowComments) {
        // See <https://html.spec.whatwg.org/multipage/parsing.html#serialising-html-fragments>
        const result = typeof unsafe.value === "string" ? unsafe.value : "";
        const index = result.indexOf("-->");
        const value = index < 0 ? result : result.slice(0, index);
        /** @type {Comment} */ const node = {
            type: "comment",
            value: value
        };
        $9e03f5008c34193d$var$patch(node, unsafe);
        return node;
    }
}
/**
 * Make a safe doctype.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe doctype-like value.
 * @returns {Doctype | undefined}
 *   Safe doctype (if with `allowDoctypes`).
 */ function $9e03f5008c34193d$var$doctype(state, unsafe) {
    if (state.schema.allowDoctypes) {
        /** @type {Doctype} */ const node = {
            type: "doctype"
        };
        $9e03f5008c34193d$var$patch(node, unsafe);
        return node;
    }
}
/**
 * Make a safe element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe element-like value.
 * @returns {Array<ElementContent> | Element | undefined}
 *   Safe element.
 */ function $9e03f5008c34193d$var$element(state, unsafe) {
    const name = typeof unsafe.tagName === "string" ? unsafe.tagName : "";
    state.stack.push(name);
    const content = /** @type {Array<ElementContent>} */ $9e03f5008c34193d$var$children(state, unsafe.children);
    const properties_ = $9e03f5008c34193d$var$properties(state, unsafe.properties);
    state.stack.pop();
    let safeElement = false;
    if (name && name !== "*" && (!state.schema.tagNames || state.schema.tagNames.includes(name))) {
        safeElement = true;
        // Some nodes can break out of their context if they don’t have a certain
        // ancestor.
        if (state.schema.ancestors && $9e03f5008c34193d$var$own.call(state.schema.ancestors, name)) {
            const ancestors = state.schema.ancestors[name];
            let index = -1;
            safeElement = false;
            while(++index < ancestors.length)if (state.stack.includes(ancestors[index])) safeElement = true;
        }
    }
    if (!safeElement) return state.schema.strip && !state.schema.strip.includes(name) ? content : undefined;
    /** @type {Element} */ const node = {
        type: "element",
        tagName: name,
        properties: properties_,
        children: content
    };
    $9e03f5008c34193d$var$patch(node, unsafe);
    return node;
}
/**
 * Make a safe root.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe root-like value.
 * @returns {Root}
 *   Safe root.
 */ function $9e03f5008c34193d$var$root(state, unsafe) {
    const content = /** @type {Array<RootContent>} */ $9e03f5008c34193d$var$children(state, unsafe.children);
    /** @type {Root} */ const node = {
        type: "root",
        children: content
    };
    $9e03f5008c34193d$var$patch(node, unsafe);
    return node;
}
/**
 * Make a safe text.
 *
 * @param {State} _
 *   Info passed around.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe text-like value.
 * @returns {Text}
 *   Safe text.
 */ function $9e03f5008c34193d$var$text(_, unsafe) {
    const value = typeof unsafe.value === "string" ? unsafe.value : "";
    /** @type {Text} */ const node = {
        type: "text",
        value: value
    };
    $9e03f5008c34193d$var$patch(node, unsafe);
    return node;
}
/**
 * Make children safe.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<unknown>} children
 *   Unsafe value.
 * @returns {Array<Nodes>}
 *   Safe children.
 */ function $9e03f5008c34193d$var$children(state, children) {
    /** @type {Array<Nodes>} */ const results = [];
    if (Array.isArray(children)) {
        const childrenUnknown = /** @type {Array<Readonly<unknown>>} */ children;
        let index = -1;
        while(++index < childrenUnknown.length){
            const value = $9e03f5008c34193d$var$transform(state, childrenUnknown[index]);
            if (value) {
                if (Array.isArray(value)) results.push(...value);
                else results.push(value);
            }
        }
    }
    return results;
}
/**
 * Make element properties safe.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<unknown>} properties
 *   Unsafe value.
 * @returns {Properties}
 *   Safe value.
 */ function $9e03f5008c34193d$var$properties(state, properties) {
    const tagName = state.stack[state.stack.length - 1];
    const attributes = state.schema.attributes;
    const required = state.schema.required;
    const specific = attributes && $9e03f5008c34193d$var$own.call(attributes, tagName) ? attributes[tagName] : undefined;
    const defaults = attributes && $9e03f5008c34193d$var$own.call(attributes, "*") ? attributes["*"] : undefined;
    const properties_ = /** @type {Readonly<Record<string, Readonly<unknown>>>} */ properties && typeof properties === "object" ? properties : {};
    /** @type {Properties} */ const result = {};
    /** @type {string} */ let key;
    for(key in properties_)if ($9e03f5008c34193d$var$own.call(properties_, key)) {
        const unsafe = properties_[key];
        let safe = $9e03f5008c34193d$var$propertyValue(state, $9e03f5008c34193d$var$findDefinition(specific, key), key, unsafe);
        if (safe === null || safe === undefined) safe = $9e03f5008c34193d$var$propertyValue(state, $9e03f5008c34193d$var$findDefinition(defaults, key), key, unsafe);
        if (safe !== null && safe !== undefined) result[key] = safe;
    }
    if (required && $9e03f5008c34193d$var$own.call(required, tagName)) {
        const properties = required[tagName];
        for(key in properties)if ($9e03f5008c34193d$var$own.call(properties, key) && !$9e03f5008c34193d$var$own.call(result, key)) result[key] = properties[key];
    }
    return result;
}
/**
 * Sanitize a property value.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<PropertyDefinition> | undefined} definition
 *   Definition.
 * @param {string} key
 *   Field name.
 * @param {Readonly<unknown>} value
 *   Unsafe value (but an array).
 * @returns {Array<number | string> | boolean | number | string | undefined}
 *   Safe value.
 */ function $9e03f5008c34193d$var$propertyValue(state, definition, key, value) {
    return definition ? Array.isArray(value) ? $9e03f5008c34193d$var$propertyValueMany(state, definition, key, value) : $9e03f5008c34193d$var$propertyValuePrimitive(state, definition, key, value) : undefined;
}
/**
 * Sanitize a property value which is a list.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<PropertyDefinition>} definition
 *   Definition.
 * @param {string} key
 *   Field name.
 * @param {Readonly<Array<Readonly<unknown>>>} values
 *   Unsafe value (but an array).
 * @returns {Array<number | string>}
 *   Safe value.
 */ function $9e03f5008c34193d$var$propertyValueMany(state, definition, key, values) {
    let index = -1;
    /** @type {Array<number | string>} */ const result = [];
    while(++index < values.length){
        const value = $9e03f5008c34193d$var$propertyValuePrimitive(state, definition, key, values[index]);
        if (typeof value === "number" || typeof value === "string") result.push(value);
    }
    return result;
}
/**
 * Sanitize a property value which is a primitive.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<PropertyDefinition>} definition
 *   Definition.
 * @param {string} key
 *   Field name.
 * @param {Readonly<unknown>} value
 *   Unsafe value (but not an array).
 * @returns {boolean | number | string | undefined}
 *   Safe value.
 */ function $9e03f5008c34193d$var$propertyValuePrimitive(state, definition, key, value) {
    if (typeof value !== "boolean" && typeof value !== "number" && typeof value !== "string") return;
    if (!$9e03f5008c34193d$var$safeProtocol(state, key, value)) return;
    // Just a string, or only one item in an array, means all values are OK.
    // More than one item means an allow list.
    if (typeof definition === "object" && definition.length > 1) {
        let ok = false;
        let index = 0 // Ignore `key`, which is the first item.
        ;
        while(++index < definition.length){
            const allowed = definition[index];
            // Expression.
            if (allowed && typeof allowed === "object" && "flags" in allowed) {
                if (allowed.test(String(value))) {
                    ok = true;
                    break;
                }
            } else if (allowed === value) {
                ok = true;
                break;
            }
        }
        if (!ok) return;
    }
    return state.schema.clobber && state.schema.clobberPrefix && state.schema.clobber.includes(key) ? state.schema.clobberPrefix + value : value;
}
/**
 * Check whether `value` is a safe URL.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} key
 *   Field name.
 * @param {Readonly<unknown>} value
 *   Unsafe value.
 * @returns {boolean}
 *   Whether it’s a safe value.
 */ function $9e03f5008c34193d$var$safeProtocol(state, key, value) {
    const protocols = state.schema.protocols && $9e03f5008c34193d$var$own.call(state.schema.protocols, key) ? state.schema.protocols[key] : undefined;
    // No protocols defined? Then everything is fine.
    if (!protocols || protocols.length === 0) return true;
    const url = String(value);
    const colon = url.indexOf(":");
    const questionMark = url.indexOf("?");
    const numberSign = url.indexOf("#");
    const slash = url.indexOf("/");
    if (colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign) return true;
    let index = -1;
    while(++index < protocols.length){
        const protocol = protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length) === protocol) return true;
    }
    return false;
}
/**
 * Add data and position.
 *
 * @param {Nodes} node
 *   Node to patch safe data and position on.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe node-like value.
 * @returns {undefined}
 *   Nothing.
 */ function $9e03f5008c34193d$var$patch(node, unsafe) {
    const cleanPosition = (0, $g7Bfx.position)(// @ts-expect-error: looks like a node.
    unsafe);
    if (unsafe.data) node.data = (0, $lWKwn.default)(unsafe.data);
    if (cleanPosition) node.position = cleanPosition;
}
/**
 *
 * @param {Readonly<Array<PropertyDefinition>> | undefined} definitions
 * @param {string} key
 * @returns {Readonly<PropertyDefinition> | undefined}
 */ function $9e03f5008c34193d$var$findDefinition(definitions, key) {
    /** @type {PropertyDefinition | undefined} */ let dataDefault;
    let index = -1;
    if (definitions) while(++index < definitions.length){
        const entry = definitions[index];
        const name = typeof entry === "string" ? entry : entry[0];
        if (name === key) return entry;
        if (name === "data*") dataDefault = entry;
    }
    if (key.length > 4 && key.slice(0, 4).toLowerCase() === "data") return dataDefault;
}

});
parcelRegister("lWKwn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffa319e7789dae9d$export$2e2bcd8739ae039);

var $lJ47n = parcelRequire("lJ47n");

var $7Z0Dv = parcelRequire("7Z0Dv");
var /**
 * @typedef {Array<string,any>} Record a type representation
 */ /**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */ $ffa319e7789dae9d$export$2e2bcd8739ae039 = typeof structuredClone === "function" ? /* c8 ignore start */ (any, options)=>options && ("json" in options || "lossy" in options) ? (0, $lJ47n.deserialize)((0, $7Z0Dv.serialize)(any, options)) : structuredClone(any) : (any, options)=>(0, $lJ47n.deserialize)((0, $7Z0Dv.serialize)(any, options));

});
parcelRegister("lJ47n", function(module, exports) {

$parcel$export(module.exports, "deserialize", () => $fd10feb1f7983dd3$export$efcd34ab6248d3cd);

var $60gwx = parcelRequire("60gwx");
const $fd10feb1f7983dd3$var$env = typeof self === "object" ? self : globalThis;
const $fd10feb1f7983dd3$var$deserializer = ($, _)=>{
    const as = (out, index)=>{
        $.set(index, out);
        return out;
    };
    const unpair = (index)=>{
        if ($.has(index)) return $.get(index);
        const [type, value] = _[index];
        switch(type){
            case 0, $60gwx.PRIMITIVE:
            case 0, $60gwx.VOID:
                return as(value, index);
            case 0, $60gwx.ARRAY:
                {
                    const arr = as([], index);
                    for (const index of value)arr.push(unpair(index));
                    return arr;
                }
            case 0, $60gwx.OBJECT:
                {
                    const object = as({}, index);
                    for (const [key, index] of value)object[unpair(key)] = unpair(index);
                    return object;
                }
            case 0, $60gwx.DATE:
                return as(new Date(value), index);
            case 0, $60gwx.REGEXP:
                {
                    const { source: source, flags: flags } = value;
                    return as(new RegExp(source, flags), index);
                }
            case 0, $60gwx.MAP:
                {
                    const map = as(new Map, index);
                    for (const [key, index] of value)map.set(unpair(key), unpair(index));
                    return map;
                }
            case 0, $60gwx.SET:
                {
                    const set = as(new Set, index);
                    for (const index of value)set.add(unpair(index));
                    return set;
                }
            case 0, $60gwx.ERROR:
                {
                    const { name: name, message: message } = value;
                    return as(new $fd10feb1f7983dd3$var$env[name](message), index);
                }
            case 0, $60gwx.BIGINT:
                return as(BigInt(value), index);
            case "BigInt":
                return as(Object(BigInt(value)), index);
        }
        return as(new $fd10feb1f7983dd3$var$env[type](value), index);
    };
    return unpair;
};
const $fd10feb1f7983dd3$export$efcd34ab6248d3cd = (serialized)=>$fd10feb1f7983dd3$var$deserializer(new Map, serialized)(0);

});
parcelRegister("60gwx", function(module, exports) {

$parcel$export(module.exports, "VOID", () => $45ef8f746872a9d4$export$1cd1943b3a73bbe8);
$parcel$export(module.exports, "PRIMITIVE", () => $45ef8f746872a9d4$export$a44b4f3d5b73db95);
$parcel$export(module.exports, "ARRAY", () => $45ef8f746872a9d4$export$b119f07080a207ba);
$parcel$export(module.exports, "OBJECT", () => $45ef8f746872a9d4$export$8b8a958a7f6f130c);
$parcel$export(module.exports, "DATE", () => $45ef8f746872a9d4$export$501a7fac1df67a49);
$parcel$export(module.exports, "REGEXP", () => $45ef8f746872a9d4$export$cd2b220b1ea851b2);
$parcel$export(module.exports, "MAP", () => $45ef8f746872a9d4$export$ce970371e0e850bc);
$parcel$export(module.exports, "SET", () => $45ef8f746872a9d4$export$5e8f180ef0142226);
$parcel$export(module.exports, "ERROR", () => $45ef8f746872a9d4$export$103bedf43ba882db);
$parcel$export(module.exports, "BIGINT", () => $45ef8f746872a9d4$export$9f2207c8fceeefa8);
const $45ef8f746872a9d4$export$1cd1943b3a73bbe8 = -1;
const $45ef8f746872a9d4$export$a44b4f3d5b73db95 = 0;
const $45ef8f746872a9d4$export$b119f07080a207ba = 1;
const $45ef8f746872a9d4$export$8b8a958a7f6f130c = 2;
const $45ef8f746872a9d4$export$501a7fac1df67a49 = 3;
const $45ef8f746872a9d4$export$cd2b220b1ea851b2 = 4;
const $45ef8f746872a9d4$export$ce970371e0e850bc = 5;
const $45ef8f746872a9d4$export$5e8f180ef0142226 = 6;
const $45ef8f746872a9d4$export$103bedf43ba882db = 7;
const $45ef8f746872a9d4$export$9f2207c8fceeefa8 = 8; // export const SYMBOL = 9;

});


parcelRegister("7Z0Dv", function(module, exports) {

$parcel$export(module.exports, "serialize", () => $5cfeb93cc24b886f$export$dfdc1655ccc5b9cb);

var $60gwx = parcelRequire("60gwx");
const $5cfeb93cc24b886f$var$EMPTY = "";
const { toString: $5cfeb93cc24b886f$var$toString } = {};
const { keys: $5cfeb93cc24b886f$var$keys } = Object;
const $5cfeb93cc24b886f$var$typeOf = (value)=>{
    const type = typeof value;
    if (type !== "object" || !value) return [
        (0, $60gwx.PRIMITIVE),
        type
    ];
    const asString = $5cfeb93cc24b886f$var$toString.call(value).slice(8, -1);
    switch(asString){
        case "Array":
            return [
                (0, $60gwx.ARRAY),
                $5cfeb93cc24b886f$var$EMPTY
            ];
        case "Object":
            return [
                (0, $60gwx.OBJECT),
                $5cfeb93cc24b886f$var$EMPTY
            ];
        case "Date":
            return [
                (0, $60gwx.DATE),
                $5cfeb93cc24b886f$var$EMPTY
            ];
        case "RegExp":
            return [
                (0, $60gwx.REGEXP),
                $5cfeb93cc24b886f$var$EMPTY
            ];
        case "Map":
            return [
                (0, $60gwx.MAP),
                $5cfeb93cc24b886f$var$EMPTY
            ];
        case "Set":
            return [
                (0, $60gwx.SET),
                $5cfeb93cc24b886f$var$EMPTY
            ];
    }
    if (asString.includes("Array")) return [
        (0, $60gwx.ARRAY),
        asString
    ];
    if (asString.includes("Error")) return [
        (0, $60gwx.ERROR),
        asString
    ];
    return [
        (0, $60gwx.OBJECT),
        asString
    ];
};
const $5cfeb93cc24b886f$var$shouldSkip = ([TYPE, type])=>TYPE === (0, $60gwx.PRIMITIVE) && (type === "function" || type === "symbol");
const $5cfeb93cc24b886f$var$serializer = (strict, json, $, _)=>{
    const as = (out, value)=>{
        const index = _.push(out) - 1;
        $.set(value, index);
        return index;
    };
    const pair = (value)=>{
        if ($.has(value)) return $.get(value);
        let [TYPE, type] = $5cfeb93cc24b886f$var$typeOf(value);
        switch(TYPE){
            case 0, $60gwx.PRIMITIVE:
                {
                    let entry = value;
                    switch(type){
                        case "bigint":
                            TYPE = (0, $60gwx.BIGINT);
                            entry = value.toString();
                            break;
                        case "function":
                        case "symbol":
                            if (strict) throw new TypeError("unable to serialize " + type);
                            entry = null;
                            break;
                        case "undefined":
                            return as([
                                (0, $60gwx.VOID)
                            ], value);
                    }
                    return as([
                        TYPE,
                        entry
                    ], value);
                }
            case 0, $60gwx.ARRAY:
                {
                    if (type) return as([
                        type,
                        [
                            ...value
                        ]
                    ], value);
                    const arr = [];
                    const index = as([
                        TYPE,
                        arr
                    ], value);
                    for (const entry of value)arr.push(pair(entry));
                    return index;
                }
            case 0, $60gwx.OBJECT:
                {
                    if (type) switch(type){
                        case "BigInt":
                            return as([
                                type,
                                value.toString()
                            ], value);
                        case "Boolean":
                        case "Number":
                        case "String":
                            return as([
                                type,
                                value.valueOf()
                            ], value);
                    }
                    if (json && "toJSON" in value) return pair(value.toJSON());
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const key of $5cfeb93cc24b886f$var$keys(value))if (strict || !$5cfeb93cc24b886f$var$shouldSkip($5cfeb93cc24b886f$var$typeOf(value[key]))) entries.push([
                        pair(key),
                        pair(value[key])
                    ]);
                    return index;
                }
            case 0, $60gwx.DATE:
                return as([
                    TYPE,
                    value.toISOString()
                ], value);
            case 0, $60gwx.REGEXP:
                {
                    const { source: source, flags: flags } = value;
                    return as([
                        TYPE,
                        {
                            source: source,
                            flags: flags
                        }
                    ], value);
                }
            case 0, $60gwx.MAP:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const [key, entry] of value)if (strict || !($5cfeb93cc24b886f$var$shouldSkip($5cfeb93cc24b886f$var$typeOf(key)) || $5cfeb93cc24b886f$var$shouldSkip($5cfeb93cc24b886f$var$typeOf(entry)))) entries.push([
                        pair(key),
                        pair(entry)
                    ]);
                    return index;
                }
            case 0, $60gwx.SET:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const entry of value)if (strict || !$5cfeb93cc24b886f$var$shouldSkip($5cfeb93cc24b886f$var$typeOf(entry))) entries.push(pair(entry));
                    return index;
                }
        }
        const { message: message } = value;
        return as([
            TYPE,
            {
                name: type,
                message: message
            }
        ], value);
    };
    return pair;
};
const $5cfeb93cc24b886f$export$dfdc1655ccc5b9cb = (value, { json: json, lossy: lossy } = {})=>{
    const _ = [];
    return $5cfeb93cc24b886f$var$serializer(!(json || lossy), !!json, new Map, _)(value), _;
};

});


parcelRegister("g7Bfx", function(module, exports) {

$parcel$export(module.exports, "position", () => $bbca31c5046a61f5$export$5880b8b5730aff45);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $bbca31c5046a61f5$export$da309cdce9dc2a25 = $bbca31c5046a61f5$var$point("end");
const $bbca31c5046a61f5$export$771bf3e4949bfbee = $bbca31c5046a61f5$var$point("start");
/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $bbca31c5046a61f5$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        if (typeof point.line === "number" && point.line > 0 && typeof point.column === "number" && point.column > 0) return {
            line: point.line,
            column: point.column,
            offset: typeof point.offset === "number" && point.offset > -1 ? point.offset : undefined
        };
    }
}
function $bbca31c5046a61f5$export$5880b8b5730aff45(node) {
    const start = $bbca31c5046a61f5$export$771bf3e4949bfbee(node);
    const end = $bbca31c5046a61f5$export$da309cdce9dc2a25(node);
    if (start && end) return {
        start: start,
        end: end
    };
}

});

parcelRegister("7OeFl", function(module, exports) {

$parcel$export(module.exports, "defaultSchema", () => $5af89439992181f1$export$1db618b7b2275ea1);
/**
 * @import {Schema} from 'hast-util-sanitize'
 */ // Couple of ARIA attributes allowed in several, but not all, places.
const $5af89439992181f1$var$aria = [
    "ariaDescribedBy",
    "ariaLabel",
    "ariaLabelledBy"
];
const $5af89439992181f1$export$1db618b7b2275ea1 = {
    ancestors: {
        tbody: [
            "table"
        ],
        td: [
            "table"
        ],
        th: [
            "table"
        ],
        thead: [
            "table"
        ],
        tfoot: [
            "table"
        ],
        tr: [
            "table"
        ]
    },
    attributes: {
        a: [
            ...$5af89439992181f1$var$aria,
            // Note: these 3 are used by GFM footnotes, they do work on all links.
            "dataFootnoteBackref",
            "dataFootnoteRef",
            [
                "className",
                "data-footnote-backref"
            ],
            "href"
        ],
        blockquote: [
            "cite"
        ],
        // Note: this class is not normally allowed by GH, when manually writing
        // `code` as HTML in markdown, they adds it some other way.
        // We can’t do that, so we have to allow it.
        code: [
            [
                "className",
                /^language-./
            ]
        ],
        del: [
            "cite"
        ],
        div: [
            "itemScope",
            "itemType"
        ],
        dl: [
            ...$5af89439992181f1$var$aria
        ],
        // Note: this is used by GFM footnotes.
        h2: [
            [
                "className",
                "sr-only"
            ]
        ],
        img: [
            ...$5af89439992181f1$var$aria,
            "longDesc",
            "src"
        ],
        // Note: `input` is not normally allowed by GH, when manually writing
        // it in markdown, they add it from tasklists some other way.
        // We can’t do that, so we have to allow it.
        input: [
            [
                "disabled",
                true
            ],
            [
                "type",
                "checkbox"
            ]
        ],
        ins: [
            "cite"
        ],
        // Note: this class is not normally allowed by GH, when manually writing
        // `li` as HTML in markdown, they adds it some other way.
        // We can’t do that, so we have to allow it.
        li: [
            [
                "className",
                "task-list-item"
            ]
        ],
        // Note: this class is not normally allowed by GH, when manually writing
        // `ol` as HTML in markdown, they adds it some other way.
        // We can’t do that, so we have to allow it.
        ol: [
            ...$5af89439992181f1$var$aria,
            [
                "className",
                "contains-task-list"
            ]
        ],
        q: [
            "cite"
        ],
        section: [
            "dataFootnotes",
            [
                "className",
                "footnotes"
            ]
        ],
        source: [
            "srcSet"
        ],
        summary: [
            ...$5af89439992181f1$var$aria
        ],
        table: [
            ...$5af89439992181f1$var$aria
        ],
        // Note: this class is not normally allowed by GH, when manually writing
        // `ol` as HTML in markdown, they adds it some other way.
        // We can’t do that, so we have to allow it.
        ul: [
            ...$5af89439992181f1$var$aria,
            [
                "className",
                "contains-task-list"
            ]
        ],
        "*": [
            "abbr",
            "accept",
            "acceptCharset",
            "accessKey",
            "action",
            "align",
            "alt",
            "axis",
            "border",
            "cellPadding",
            "cellSpacing",
            "char",
            "charOff",
            "charSet",
            "checked",
            "clear",
            "colSpan",
            "color",
            "cols",
            "compact",
            "coords",
            "dateTime",
            "dir",
            // Note: `disabled` is technically allowed on all elements by GH.
            // But it is useless on everything except `input`.
            // Because `input`s are normally not allowed, but we allow them for
            // checkboxes due to tasklists, we allow `disabled` only there.
            "encType",
            "frame",
            "hSpace",
            "headers",
            "height",
            "hrefLang",
            "htmlFor",
            "id",
            "isMap",
            "itemProp",
            "label",
            "lang",
            "maxLength",
            "media",
            "method",
            "multiple",
            "name",
            "noHref",
            "noShade",
            "noWrap",
            "open",
            "prompt",
            "readOnly",
            "rev",
            "rowSpan",
            "rows",
            "rules",
            "scope",
            "selected",
            "shape",
            "size",
            "span",
            "start",
            "summary",
            "tabIndex",
            "title",
            "useMap",
            "vAlign",
            "value",
            "width"
        ]
    },
    clobber: [
        "ariaDescribedBy",
        "ariaLabelledBy",
        "id",
        "name"
    ],
    clobberPrefix: "user-content-",
    protocols: {
        cite: [
            "http",
            "https"
        ],
        href: [
            "http",
            "https",
            "irc",
            "ircs",
            "mailto",
            "xmpp"
        ],
        longDesc: [
            "http",
            "https"
        ],
        src: [
            "http",
            "https"
        ]
    },
    required: {
        input: {
            disabled: true,
            type: "checkbox"
        }
    },
    strip: [
        "script"
    ],
    tagNames: [
        "a",
        "b",
        "blockquote",
        "br",
        "code",
        "dd",
        "del",
        "details",
        "div",
        "dl",
        "dt",
        "em",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hr",
        "i",
        "img",
        // Note: `input` is not normally allowed by GH, when manually writing
        // it in markdown, they add it from tasklists some other way.
        // We can’t do that, so we have to allow it.
        "input",
        "ins",
        "kbd",
        "li",
        "ol",
        "p",
        "picture",
        "pre",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "section",
        "source",
        "span",
        "strike",
        "strong",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "tfoot",
        "th",
        "thead",
        "tr",
        "tt",
        "ul",
        "var"
    ]
};

});





parcelRegister("d6xYN", function(module, exports) {
$parcel$export(module.exports, "Chip", () => (parcelRequire("4qH0K")).Chip);
parcelRequire("4qH0K");

});
parcelRegister("4qH0K", function(module, exports) {

$parcel$export(module.exports, "Chip", () => $9ac7ed50dd10687d$export$5a7f9a6004988d01);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $9ac7ed50dd10687d$export$5a7f9a6004988d01({ text: text, testId: testId, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("body-s rounded-lg bg-slate-200 px-2 py-1 text-slate-900", className),
        "data-testid": testId,
        children: text
    });
}

});



parcelRegister("ljFgu", function(module, exports) {
$parcel$export(module.exports, "AccordionSection", () => (parcelRequire("a0B35")).AccordionSection);
$parcel$export(module.exports, "StatBox", () => (parcelRequire("eSDZU")).StatBox);
$parcel$export(module.exports, "InlineNotification", () => (parcelRequire("arjdk")).InlineNotification);
$parcel$export(module.exports, "NotificationType", () => (parcelRequire("arjdk")).NotificationType);
$parcel$export(module.exports, "Modal", () => (parcelRequire("dtQ0k")).Modal);
$parcel$export(module.exports, "ModalFooter", () => (parcelRequire("41p3a")).ModalFooter);
$parcel$export(module.exports, "toast", () => (parcelRequire("3oOMC")).toast);
$parcel$export(module.exports, "ToastProvider", () => (parcelRequire("3oOMC")).ToastProvider);
$parcel$export(module.exports, "Splash", () => (parcelRequire("gUduC")).Splash);
$parcel$export(module.exports, "Filterbox", () => (parcelRequire("br4f9")).Filterbox);
$parcel$export(module.exports, "PageHeading", () => (parcelRequire("5c1IA")).PageHeading);
$parcel$export(module.exports, "SubHeading", () => (parcelRequire("fy2Jk")).SubHeading);
$parcel$export(module.exports, "FilterIndicator", () => (parcelRequire("93iCJ")).FilterIndicator);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("cjuU3")).Breadcrumbs);
$parcel$export(module.exports, "MaintenanceBanner", () => (parcelRequire("jg6kN")).MaintenanceBanner);
$parcel$export(module.exports, "CardSkeleton", () => (parcelRequire("aZozk")).CardSkeleton);
$parcel$export(module.exports, "Pagination", () => (parcelRequire("f5Nhr")).Pagination);
parcelRequire("gJXdT");
parcelRequire("frTO5");
parcelRequire("jQCFN");
parcelRequire("5ZNlc");
parcelRequire("3jkAh");
parcelRequire("g4SRA");
parcelRequire("9mMXU");
parcelRequire("1WlUv");
parcelRequire("kJFOS");
parcelRequire("hZYzm");
parcelRequire("43ogP");
parcelRequire("k4jVw");
parcelRequire("7YWCG");
parcelRequire("cibhe");
parcelRequire("bXUQS");
parcelRequire("6jU26");
parcelRequire("hAMzH");
parcelRequire("4mtEF");
parcelRequire("eoXvj");
parcelRequire("7bOCJ");
parcelRequire("kcbxz");
parcelRequire("62A7U");
parcelRequire("gCgkb");
parcelRequire("lS2QC");

});
parcelRegister("gJXdT", function(module, exports) {
$parcel$export(module.exports, "AccordionSection", () => (parcelRequire("a0B35")).AccordionSection);
parcelRequire("a0B35");

});
parcelRegister("a0B35", function(module, exports) {

$parcel$export(module.exports, "AccordionSection", () => $a61d677d31744991$export$838c90d61e85d9b4);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $aiOQx = parcelRequire("aiOQx");

var $aq2V2 = parcelRequire("aq2V2");
parcelRequire("azsOi");
var $bVwXM = parcelRequire("bVwXM");

var $9QePP = parcelRequire("9QePP");
const $a61d677d31744991$export$838c90d61e85d9b4 = ({ title: title, description: description, children: children, open: open = false, className: className })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aiOQx.Disclosure), {
        defaultOpen: open,
        children: ({ open: open })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aiOQx.Disclosure).Button, {
                        className: (0, $9QePP.default)("w-full", className),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bVwXM.Card), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center justify-between text-left",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                children: title
                                            }),
                                            description && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "body-m mr-8 mt-2",
                                                children: description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aq2V2.default), {
                                        className: (0, $9QePP.default)("cursor-pointer", "transition duration-300 ease-in-out", open ? "rotate-90" : "")
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aiOQx.Disclosure).Panel, {
                        className: "w-full",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "px-2 md:px-6",
                            children: children
                        })
                    })
                ]
            })
    });
};

});
parcelRegister("aiOQx", function(module, exports) {

$parcel$export(module.exports, "Disclosure", () => $780306decd8ad6d8$export$74a362b31437ec83);

var $kd7LS = parcelRequire("kd7LS");

var $6o6B3 = parcelRequire("6o6B3");

var $acw62 = parcelRequire("acw62");

var $cE9hP = parcelRequire("cE9hP");

var $114Mg = parcelRequire("114Mg");

var $acw62 = parcelRequire("acw62");

var $gm4XX = parcelRequire("gm4XX");

var $6mpbl = parcelRequire("6mpbl");

var $bdknl = parcelRequire("bdknl");

var $5ETDl = parcelRequire("5ETDl");

var $auuNT = parcelRequire("auuNT");

var $5fYEB = parcelRequire("5fYEB");

var $6Ngq1 = parcelRequire("6Ngq1");

var $gxwGc = parcelRequire("gxwGc");

var $ebRQH = parcelRequire("ebRQH");

var $3vRkM = parcelRequire("3vRkM");

var $6AKlm = parcelRequire("6AKlm");
"use client";
var $780306decd8ad6d8$var$ce = ((l)=>(l[l.Open = 0] = "Open", l[l.Closed = 1] = "Closed", l))($780306decd8ad6d8$var$ce || {}), $780306decd8ad6d8$var$de = ((n)=>(n[n.ToggleDisclosure = 0] = "ToggleDisclosure", n[n.CloseDisclosure = 1] = "CloseDisclosure", n[n.SetButtonId = 2] = "SetButtonId", n[n.SetPanelId = 3] = "SetPanelId", n[n.SetButtonElement = 4] = "SetButtonElement", n[n.SetPanelElement = 5] = "SetPanelElement", n))($780306decd8ad6d8$var$de || {});
let $780306decd8ad6d8$var$Te = {
    [0]: (e)=>({
            ...e,
            disclosureState: (0, $6Ngq1.match)(e.disclosureState, {
                [0]: 1,
                [1]: 0
            })
        }),
    [1]: (e)=>e.disclosureState === 1 ? e : {
            ...e,
            disclosureState: 1
        },
    [2] (e, t) {
        return e.buttonId === t.buttonId ? e : {
            ...e,
            buttonId: t.buttonId
        };
    },
    [3] (e, t) {
        return e.panelId === t.panelId ? e : {
            ...e,
            panelId: t.panelId
        };
    },
    [4] (e, t) {
        return e.buttonElement === t.element ? e : {
            ...e,
            buttonElement: t.element
        };
    },
    [5] (e, t) {
        return e.panelElement === t.element ? e : {
            ...e,
            panelElement: t.element
        };
    }
}, $780306decd8ad6d8$var$_ = (0, $acw62.createContext)(null);
$780306decd8ad6d8$var$_.displayName = "DisclosureContext";
function $780306decd8ad6d8$var$M(e) {
    let t = (0, $acw62.useContext)($780306decd8ad6d8$var$_);
    if (t === null) {
        let l = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(l, $780306decd8ad6d8$var$M), l;
    }
    return t;
}
let $780306decd8ad6d8$var$F = (0, $acw62.createContext)(null);
$780306decd8ad6d8$var$F.displayName = "DisclosureAPIContext";
function $780306decd8ad6d8$var$J(e) {
    let t = (0, $acw62.useContext)($780306decd8ad6d8$var$F);
    if (t === null) {
        let l = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(l, $780306decd8ad6d8$var$J), l;
    }
    return t;
}
let $780306decd8ad6d8$var$H = (0, $acw62.createContext)(null);
$780306decd8ad6d8$var$H.displayName = "DisclosurePanelContext";
function $780306decd8ad6d8$var$fe() {
    return (0, $acw62.useContext)($780306decd8ad6d8$var$H);
}
function $780306decd8ad6d8$var$me(e, t) {
    return (0, $6Ngq1.match)(t.type, $780306decd8ad6d8$var$Te, e, t);
}
let $780306decd8ad6d8$var$De = (0, $acw62.Fragment);
function $780306decd8ad6d8$var$ye(e, t) {
    let { defaultOpen: l = !1, ...p } = e, i = (0, $acw62.useRef)(null), c = (0, $6mpbl.useSyncRefs)(t, (0, $6mpbl.optionalRef)((a)=>{
        i.current = a;
    }, e.as === void 0 || e.as === (0, $acw62.Fragment))), n = (0, $acw62.useReducer)($780306decd8ad6d8$var$me, {
        disclosureState: l ? 0 : 1,
        buttonElement: null,
        panelElement: null,
        buttonId: null,
        panelId: null
    }), [{ disclosureState: o, buttonId: r }, m] = n, s = (0, $114Mg.useEvent)((a)=>{
        m({
            type: 1
        });
        let d = (0, $gxwGc.getOwnerDocument)(i);
        if (!d || !r) return;
        let T = (()=>a ? a instanceof HTMLElement ? a : a.current instanceof HTMLElement ? a.current : d.getElementById(r) : d.getElementById(r))();
        T == null || T.focus();
    }), E = (0, $acw62.useMemo)(()=>({
            close: s
        }), [
        s
    ]), f = (0, $acw62.useMemo)(()=>({
            open: o === 0,
            close: s
        }), [
        o,
        s
    ]), D = {
        ref: c
    }, S = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($780306decd8ad6d8$var$_.Provider, {
        value: n
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($780306decd8ad6d8$var$F.Provider, {
        value: E
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5ETDl.CloseProvider), {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $auuNT.OpenClosedProvider), {
        value: (0, $6Ngq1.match)(o, {
            [0]: (0, $auuNT.State).Open,
            [1]: (0, $auuNT.State).Closed
        })
    }, S({
        ourProps: D,
        theirProps: p,
        slot: f,
        defaultTag: $780306decd8ad6d8$var$De,
        name: "Disclosure"
    })))));
}
let $780306decd8ad6d8$var$Pe = "button";
function $780306decd8ad6d8$var$Ee(e, t) {
    let l = (0, $acw62.useId)(), { id: p = `headlessui-disclosure-button-${l}`, disabled: i = !1, autoFocus: c = !1, ...n } = e, [o, r] = $780306decd8ad6d8$var$M("Disclosure.Button"), m = $780306decd8ad6d8$var$fe(), s = m === null ? !1 : m === o.panelId, E = (0, $acw62.useRef)(null), f = (0, $6mpbl.useSyncRefs)(E, t, (0, $114Mg.useEvent)((u)=>{
        if (!s) return r({
            type: 4,
            element: u
        });
    }));
    (0, $acw62.useEffect)(()=>{
        if (!s) return r({
            type: 2,
            buttonId: p
        }), ()=>{
            r({
                type: 2,
                buttonId: null
            });
        };
    }, [
        p,
        r,
        s
    ]);
    let D = (0, $114Mg.useEvent)((u)=>{
        var g;
        if (s) {
            if (o.disclosureState === 1) return;
            switch(u.key){
                case (0, $6AKlm.Keys).Space:
                case (0, $6AKlm.Keys).Enter:
                    u.preventDefault(), u.stopPropagation(), r({
                        type: 0
                    }), (g = o.buttonElement) == null || g.focus();
                    break;
            }
        } else switch(u.key){
            case (0, $6AKlm.Keys).Space:
            case (0, $6AKlm.Keys).Enter:
                u.preventDefault(), u.stopPropagation(), r({
                    type: 0
                });
                break;
        }
    }), S = (0, $114Mg.useEvent)((u)=>{
        switch(u.key){
            case (0, $6AKlm.Keys).Space:
                u.preventDefault();
                break;
        }
    }), a = (0, $114Mg.useEvent)((u)=>{
        var g;
        (0, $5fYEB.isDisabledReactIssue7711)(u.currentTarget) || i || (s ? (r({
            type: 0
        }), (g = o.buttonElement) == null || g.focus()) : r({
            type: 0
        }));
    }), { isFocusVisible: d, focusProps: T } = (0, $kd7LS.useFocusRing)({
        autoFocus: c
    }), { isHovered: b, hoverProps: h } = (0, $6o6B3.useHover)({
        isDisabled: i
    }), { pressed: U, pressProps: N } = (0, $cE9hP.useActivePress)({
        disabled: i
    }), X = (0, $acw62.useMemo)(()=>({
            open: o.disclosureState === 0,
            hover: b,
            active: U,
            disabled: i,
            focus: d,
            autofocus: c
        }), [
        o,
        b,
        U,
        d,
        i,
        c
    ]), k = (0, $gm4XX.useResolveButtonType)(e, o.buttonElement), V = s ? (0, $ebRQH.mergeProps)({
        ref: f,
        type: k,
        disabled: i || void 0,
        autoFocus: c,
        onKeyDown: D,
        onClick: a
    }, T, h, N) : (0, $ebRQH.mergeProps)({
        ref: f,
        id: p,
        type: k,
        "aria-expanded": o.disclosureState === 0,
        "aria-controls": o.panelElement ? o.panelId : void 0,
        disabled: i || void 0,
        autoFocus: c,
        onKeyDown: D,
        onKeyUp: S,
        onClick: a
    }, T, h, N);
    return (0, $ebRQH.useRender)()({
        ourProps: V,
        theirProps: n,
        slot: X,
        defaultTag: $780306decd8ad6d8$var$Pe,
        name: "Disclosure.Button"
    });
}
let $780306decd8ad6d8$var$Se = "div", $780306decd8ad6d8$var$ge = (0, $ebRQH.RenderFeatures).RenderStrategy | (0, $ebRQH.RenderFeatures).Static;
function $780306decd8ad6d8$var$Ae(e, t) {
    let l = (0, $acw62.useId)(), { id: p = `headlessui-disclosure-panel-${l}`, transition: i = !1, ...c } = e, [n, o] = $780306decd8ad6d8$var$M("Disclosure.Panel"), { close: r } = $780306decd8ad6d8$var$J("Disclosure.Panel"), [m, s] = (0, $acw62.useState)(null), E = (0, $6mpbl.useSyncRefs)(t, (0, $114Mg.useEvent)((b)=>{
        (0, $3vRkM.startTransition)(()=>o({
                type: 5,
                element: b
            }));
    }), s);
    (0, $acw62.useEffect)(()=>(o({
            type: 3,
            panelId: p
        }), ()=>{
            o({
                type: 3,
                panelId: null
            });
        }), [
        p,
        o
    ]);
    let f = (0, $auuNT.useOpenClosed)(), [D, S] = (0, $bdknl.useTransition)(i, m, f !== null ? (f & (0, $auuNT.State).Open) === (0, $auuNT.State).Open : n.disclosureState === 0), a = (0, $acw62.useMemo)(()=>({
            open: n.disclosureState === 0,
            close: r
        }), [
        n.disclosureState,
        r
    ]), d = {
        ref: E,
        id: p,
        ...(0, $bdknl.transitionDataAttributes)(S)
    }, T = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $auuNT.ResetOpenClosedProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($780306decd8ad6d8$var$H.Provider, {
        value: n.panelId
    }, T({
        ourProps: d,
        theirProps: c,
        slot: a,
        defaultTag: $780306decd8ad6d8$var$Se,
        features: $780306decd8ad6d8$var$ge,
        visible: D,
        name: "Disclosure.Panel"
    })));
}
let $780306decd8ad6d8$var$be = (0, $ebRQH.forwardRefWithAs)($780306decd8ad6d8$var$ye), $780306decd8ad6d8$export$4edbb1575344e6fc = (0, $ebRQH.forwardRefWithAs)($780306decd8ad6d8$var$Ee), $780306decd8ad6d8$export$feabaa331e1d464c = (0, $ebRQH.forwardRefWithAs)($780306decd8ad6d8$var$Ae), $780306decd8ad6d8$export$74a362b31437ec83 = Object.assign($780306decd8ad6d8$var$be, {
    Button: $780306decd8ad6d8$export$4edbb1575344e6fc,
    Panel: $780306decd8ad6d8$export$feabaa331e1d464c
});

});
parcelRegister("3vRkM", function(module, exports) {

$parcel$export(module.exports, "startTransition", () => $28eda363e18564ac$export$7568632d0d33d16d);

var $acw62 = parcelRequire("acw62");
var $28eda363e18564ac$var$t;
let $28eda363e18564ac$export$7568632d0d33d16d = ($28eda363e18564ac$var$t = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).startTransition) != null ? $28eda363e18564ac$var$t : function(i) {
    i();
};

});




parcelRegister("frTO5", function(module, exports) {
parcelRequire("2bmGn");

});
parcelRegister("2bmGn", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
parcelRequire("azsOi");
var $1xSOq = parcelRequire("1xSOq");
function $7e2f89a525c38d1e$export$4f4f3f54397fa02({ title: title, description: description, icon: icon, className: className, onClick: onClick, testId: testId, selected: selected = false, beta: beta = false, connected: connected = false, disabled: disabled = false }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        role: "button",
        className: (0, $9QePP.default)("border", "rounded", "h-16 px-4 py-3", "flex items-center justify-start", disabled ? "cursor-not-allowed" : "cursor-pointer", "bg-surface-subdued", selected ? "border-cta-primary-default" : "border-default", disabled ? "opacity-50" : "", className),
        onClick: onClick,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(icon, {
                className: "mr-4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grow overflow-auto ",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: (0, $9QePP.default)("body-s truncate text-gray-100", disabled ? "cursor-not-allowed" : "cursor-pointer"),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: (0, $9QePP.default)("lozenge truncate text-gray-300", disabled ? "cursor-not-allowed" : "cursor-pointer"),
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex gap-1",
                children: [
                    beta && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1xSOq.Badge), {
                        className: "bg-icon-disabled flex h-4 items-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "lozenge text-[#FCFDFE]",
                            children: "Beta"
                        })
                    }),
                    connected && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1xSOq.Badge), {
                        className: "flex h-4 items-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "lozenge text-[#151C23]",
                            children: "Connected"
                        })
                    })
                ]
            })
        ]
    }, "connector-item:" + title);
}

});


parcelRegister("jQCFN", function(module, exports) {
$parcel$export(module.exports, "StatBox", () => (parcelRequire("eSDZU")).StatBox);
parcelRequire("eSDZU");

});
parcelRegister("eSDZU", function(module, exports) {

$parcel$export(module.exports, "StatBox", () => $58830b6ac1d7ca5e$export$3af0837dcb468370);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
parcelRequire("gCemA");
var $1pwFu = parcelRequire("1pwFu");
function $58830b6ac1d7ca5e$export$3af0837dcb468370({ title: title, value: value, description: description, secondary: secondary, icon: icon, testId: testId, truncate: truncate = true, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)(!truncate ? "max-w-72" : "max-w-60", "h-auto px-5 py-4", {
            "border-default rounded-lg border bg-slate-800": !secondary
        }, className),
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, $9QePP.default)(icon && "flex items-center gap-6"),
            children: [
                icon && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: icon
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "body-s",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mt-2 flex items-start",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: (0, $9QePP.default)(truncate ? "truncate" : "whitespace-normal", "mr-2", secondary ? "text-color" : "text-brand-300"),
                                    "data-testid": `${testId}:value`,
                                    children: (0, $1pwFu.autoCapitalize)(value, true)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "body-micro subdued",
                                    "data-testid": `${testId}:description`,
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

});


parcelRegister("5ZNlc", function(module, exports) {
$parcel$export(module.exports, "InlineNotification", () => (parcelRequire("arjdk")).InlineNotification);
$parcel$export(module.exports, "NotificationType", () => (parcelRequire("arjdk")).NotificationType);
parcelRequire("arjdk");

});
parcelRegister("arjdk", function(module, exports) {

$parcel$export(module.exports, "NotificationType", () => $ae254368544b3ad2$export$9130146a86a85749);
$parcel$export(module.exports, "InlineNotification", () => $ae254368544b3ad2$export$cae1c58733dbe1ed);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("azsOi");
var $hUCih = parcelRequire("hUCih");

var $acw62 = parcelRequire("acw62");

var $5bWDk = parcelRequire("5bWDk");

var $9QePP = parcelRequire("9QePP");

var $bvcna = parcelRequire("bvcna");
var $ae254368544b3ad2$export$9130146a86a85749;
(function(NotificationType) {
    NotificationType["COMPLETED"] = "COMPLETED";
    NotificationType["NEW"] = "NEW";
    NotificationType["WARNING"] = "WARNING";
})($ae254368544b3ad2$export$9130146a86a85749 || ($ae254368544b3ad2$export$9130146a86a85749 = {}));
const $ae254368544b3ad2$export$cae1c58733dbe1ed = ({ type: type, children: children, arrow: arrow, onClick: onClick, testId: testId, className: className, sticky: sticky })=>{
    const config = (0, $5bWDk.getNotificationConfig)(type);
    if (!config) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $bvcna.twMerge)(config.bg, arrow && "cursor-pointer", "mb-10 rounded-xl p-4", sticky ? "sticky top-0 w-full" : "relative", className),
        "data-testid": testId,
        onClick: (e)=>{
            if (onClick && arrow) onClick(e);
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex items-center justify-between",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center justify-start",
                    children: [
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(config.icon, {
                            className: "mr-4"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                            className: (0, $9QePP.default)("heading-s", arrow && "cursor-pointer", "text-[#151C23]"),
                            children: children
                        })
                    ]
                }),
                arrow && !config.noIcon && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).ArrowRight, {
                    className: "text-[#151C23]",
                    height: "20",
                    width: "20"
                })
            ]
        })
    });
};

});
parcelRegister("5bWDk", function(module, exports) {

$parcel$export(module.exports, "getNotificationConfig", () => $d85ce20f1693d58c$export$732a9f22bea78098);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("5ZNlc");
var $arjdk = parcelRequire("arjdk");
parcelRequire("azsOi");
var $hUCih = parcelRequire("hUCih");
const $d85ce20f1693d58c$export$732a9f22bea78098 = (type)=>{
    switch(type){
        case (0, $arjdk.NotificationType).COMPLETED:
            return {
                bg: "bg-blue-200",
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).CircleCheck, {
                    width: "20",
                    height: "20",
                    className: "text-blue-400"
                })
            };
        case (0, $arjdk.NotificationType).NEW:
            return {
                bg: "bg-green-200",
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).NotificationStar, {
                    className: "text-green-700"
                })
            };
        case (0, $arjdk.NotificationType).WARNING:
            return {
                noIcon: true,
                bg: "bg-orange-300",
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).CircleExclamation, {
                    width: "20",
                    height: "20",
                    className: "text-orange-700"
                })
            };
        default:
            return null;
    }
};

});



parcelRegister("3jkAh", function(module, exports) {
$parcel$export(module.exports, "Modal", () => (parcelRequire("dtQ0k")).Modal);
$parcel$export(module.exports, "ModalFooter", () => (parcelRequire("41p3a")).ModalFooter);
parcelRequire("dtQ0k");
parcelRequire("41p3a");
parcelRequire("lDB6w");

});
parcelRegister("dtQ0k", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $6dc24d1648141058$export$2b77a92f1a5ad772);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lLzDP = parcelRequire("lLzDP");
var $iymfR = parcelRequire("iymfR");

var $9QePP = parcelRequire("9QePP");

var $ieIGP = parcelRequire("ieIGP");
function $6dc24d1648141058$export$2b77a92f1a5ad772({ testId: testId, title: title, titleClassName: titleClassName, description: description, icon: icon, isOpen: isOpen, onClose: onClose = ()=>{}, children: children, withTransitions: withTransitions = false, wide: wide = false, preventClose: preventClose = false, className: className }) {
    return withTransitions ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition).Root, {
        show: isOpen,
        as: (0, $acw62.Fragment),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lLzDP.Dialog), {
            as: "div",
            className: "relative z-50",
            onClose: !preventClose ? onClose : ()=>{},
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition).Child, {
                    as: (0, $acw62.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-40",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-40",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "fixed inset-0 bg-slate-900 opacity-40"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "fixed inset-0 z-10 overflow-y-auto",
                    "data-testid": testId,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex min-h-full items-center justify-center text-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition).Child, {
                            as: (0, $acw62.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lLzDP.Dialog).Panel, {
                                className: (0, $9QePP.default)("shadow-default bg-default border-default relative rounded-lg border text-left transition-all dark:bg-slate-800", wide ? "w-[516px]" : "w-[424px]", className),
                                children: [
                                    title && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "p-8",
                                        children: [
                                            icon && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "mx-auto flex items-center justify-center",
                                                children: icon
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "mt-3 sm:mt-5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lLzDP.Dialog).Title, {
                                                        as: "h4",
                                                        className: (0, $9QePP.default)("font-pageheading pageheading", titleClassName),
                                                        children: title
                                                    }),
                                                    description && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "mt-2",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "subdued body-m",
                                                            children: description
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    children
                                ]
                            })
                        })
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ieIGP.Modal), {
        testId: testId,
        title: title,
        description: description,
        isOpen: isOpen,
        wide: wide,
        className: className,
        children: children
    });
}

});
parcelRegister("ieIGP", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $fe2969de4b87bd4c$export$2b77a92f1a5ad772);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $fe2969de4b87bd4c$export$2b77a92f1a5ad772({ testId: testId, title: title, description: description, isOpen: isOpen, children: children, wide: wide = false, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("relative z-50", {
            hidden: !isOpen
        }),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fixed inset-0 bg-slate-900 opacity-60"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fixed inset-0 z-10 overflow-y-auto",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex min-h-full items-center justify-center text-center",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: (0, $9QePP.default)(`shadow-default relative rounded-lg
                            border-none text-left transition-all`, wide ? "w-[514px]" : "w-[424px]", className),
                        children: [
                            title && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "p-8",
                                children: [
                                    title && /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        children: title
                                    }),
                                    description && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mt-4 text-wrap",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "body-m subdued",
                                            children: description
                                        })
                                    })
                                ]
                            }),
                            children
                        ]
                    })
                })
            })
        ]
    });
}

});


parcelRegister("41p3a", function(module, exports) {

$parcel$export(module.exports, "ModalFooter", () => $1ea46001e244695a$export$519437715052e656);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
parcelRequire("acw62");
function $1ea46001e244695a$export$519437715052e656({ children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("bg-default px-6 py-4 dark:bg-slate-800", "flex items-center justify-between rounded-b-lg"),
        children: children
    });
}

});

parcelRegister("lDB6w", function(module, exports) {

});


parcelRegister("g4SRA", function(module, exports) {
$parcel$export(module.exports, "toast", () => (parcelRequire("3oOMC")).toast);
$parcel$export(module.exports, "ToastProvider", () => (parcelRequire("3oOMC")).ToastProvider);
parcelRequire("9cOPt");
parcelRequire("jfDk4");
parcelRequire("3oOMC");

});
parcelRegister("9cOPt", function(module, exports) {

$parcel$export(module.exports, "ToastType", () => $8d7f7ff44ec65ae0$export$c51572c5ecf1a162);
$parcel$export(module.exports, "ToastNotification", () => $8d7f7ff44ec65ae0$export$a3da9dbcac6e20c3);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $iz2Db = parcelRequire("iz2Db");
var $jUGPl = parcelRequire("jUGPl");
var $amck3 = parcelRequire("amck3");
var $eVhSR = parcelRequire("eVhSR");
var $9OXPW = parcelRequire("9OXPW");
var $3sEVh = parcelRequire("3sEVh");
var $7KX8i = parcelRequire("7KX8i");

var $iymfR = parcelRequire("iymfR");

var $9QePP = parcelRequire("9QePP");
parcelRequire("gCemA");
var $1pwFu = parcelRequire("1pwFu");
var $8d7f7ff44ec65ae0$export$c51572c5ecf1a162;
(function(ToastType) {
    ToastType["SUCCESS"] = "success";
    ToastType["ERROR"] = "error";
    ToastType["INFO"] = "info";
    ToastType["WARNING"] = "warning";
    ToastType["TIP"] = "tip";
    ToastType["UPDATING"] = "updating";
})($8d7f7ff44ec65ae0$export$c51572c5ecf1a162 || ($8d7f7ff44ec65ae0$export$c51572c5ecf1a162 = {}));
function $8d7f7ff44ec65ae0$export$a3da9dbcac6e20c3({ type: type = "info", message: message, description: description, onDismiss: onDismiss, onUndo: onUndo, closeable: closeable = true, duration: duration = 5000 }) {
    const [show, setShow] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const dismiss = ()=>{
        setShow(false);
        setTimeout(()=>{
            onDismiss && onDismiss();
        }, 200);
    };
    const undo = ()=>{
        onUndo && onUndo();
        dismiss();
    };
    (0, $acw62.useEffect)(()=>{
        setShow(true);
        const timer = setTimeout(dismiss, duration);
        return ()=>clearTimeout(timer);
    }, []);
    const iconByType = {
        ["success"]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jUGPl.default), {
            className: "size-6 fill-[#10B981] text-[#23922F]",
            "aria-hidden": "true"
        }),
        ["error"]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eVhSR.default), {
            className: "size-6 fill-[#EF4444] text-[#C01F05]",
            "aria-hidden": "true"
        }),
        ["info"]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9OXPW.default), {
            className: "size-6 fill-[#3B82F6] text-brand-500",
            "aria-hidden": "true"
        }),
        ["warning"]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $amck3.default), {
            className: "size-6 fill-[#F59E0B] text-[#E29036]",
            "aria-hidden": "true"
        }),
        ["tip"]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3sEVh.default), {
            className: "size-6 fill-[#3E4758] text-[#3E4758]",
            "aria-hidden": "true"
        }),
        ["updating"]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iz2Db.default), {
            className: "size-6 fill-[#93C5FD] text-[#93C5FD]",
            "aria-hidden": "true"
        })
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition), {
        show: show,
        as: (0, $acw62.Fragment),
        enter: "transform ease-out duration-300 transition",
        enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
        enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
        leave: "transition ease-out duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: (0, $9QePP.default)("w-full bg-white", "ring-1 ring-black/5", "shadow-default pointer-events-auto max-w-sm overflow-hidden rounded-lg"),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "p-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-start",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "shrink-0",
                            children: iconByType[type]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "ml-3 w-0 flex-1 pt-0.5",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                    className: (0, $9QePP.default)("heading-s text-[#0F172A]"),
                                    children: (0, $1pwFu.autoCapitalize)(message, true)
                                }),
                                description && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: (0, $9QePP.default)("mt-1", "body-s subdued text-slate-900 first-letter:uppercase"),
                                    children: (0, $1pwFu.autoCapitalize)(description, true)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "ml-4 flex shrink-0",
                            children: [
                                onUndo && type === "success" && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    className: "mr-2 bg-none",
                                    onClick: undo,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "ui-element cursor-pointer text-[#3E4758]",
                                        children: "Undo"
                                    })
                                }),
                                closeable && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "button",
                                    className: "quiet inline-flex rounded-md text-gray-500",
                                    onClick: dismiss,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "sr-only",
                                            children: "Close"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7KX8i.default), {
                                            className: "size-6 fill-slate-900",
                                            "aria-hidden": "true"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}

});
parcelRegister("iz2Db", function(module, exports) {

$parcel$export(module.exports, "default", () => $d83d895abc8ae8e7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $d83d895abc8ae8e7$var$ArrowPathIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M15.312 11.424a5.5 5.5 0 0 1-9.201 2.466l-.312-.311h2.433a.75.75 0 0 0 0-1.5H3.989a.75.75 0 0 0-.75.75v4.242a.75.75 0 0 0 1.5 0v-2.43l.31.31a7 7 0 0 0 11.712-3.138.75.75 0 0 0-1.449-.39Zm1.23-3.723a.75.75 0 0 0 .219-.53V2.929a.75.75 0 0 0-1.5 0V5.36l-.31-.31A7 7 0 0 0 3.239 8.188a.75.75 0 1 0 1.448.389A5.5 5.5 0 0 1 13.89 6.11l.311.31h-2.432a.75.75 0 0 0 0 1.5h4.243a.75.75 0 0 0 .53-.219Z",
        clipRule: "evenodd"
    }));
}
const $d83d895abc8ae8e7$var$ForwardRef = $acw62.forwardRef($d83d895abc8ae8e7$var$ArrowPathIcon);
var $d83d895abc8ae8e7$export$2e2bcd8739ae039 = $d83d895abc8ae8e7$var$ForwardRef;

});

parcelRegister("jUGPl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f477e2cdb760ee$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $e7f477e2cdb760ee$var$CheckCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z",
        clipRule: "evenodd"
    }));
}
const $e7f477e2cdb760ee$var$ForwardRef = $acw62.forwardRef($e7f477e2cdb760ee$var$CheckCircleIcon);
var $e7f477e2cdb760ee$export$2e2bcd8739ae039 = $e7f477e2cdb760ee$var$ForwardRef;

});

parcelRegister("amck3", function(module, exports) {

$parcel$export(module.exports, "default", () => $78a5846ef4f7892b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $78a5846ef4f7892b$var$ExclamationCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8-5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 10 5Zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
    }));
}
const $78a5846ef4f7892b$var$ForwardRef = $acw62.forwardRef($78a5846ef4f7892b$var$ExclamationCircleIcon);
var $78a5846ef4f7892b$export$2e2bcd8739ae039 = $78a5846ef4f7892b$var$ForwardRef;

});

parcelRegister("eVhSR", function(module, exports) {

$parcel$export(module.exports, "default", () => $add442e6506ada9a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $add442e6506ada9a$var$ExclamationTriangleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
    }));
}
const $add442e6506ada9a$var$ForwardRef = $acw62.forwardRef($add442e6506ada9a$var$ExclamationTriangleIcon);
var $add442e6506ada9a$export$2e2bcd8739ae039 = $add442e6506ada9a$var$ForwardRef;

});

parcelRegister("9OXPW", function(module, exports) {

$parcel$export(module.exports, "default", () => $726732e43fc7950f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $726732e43fc7950f$var$InformationCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z",
        clipRule: "evenodd"
    }));
}
const $726732e43fc7950f$var$ForwardRef = $acw62.forwardRef($726732e43fc7950f$var$InformationCircleIcon);
var $726732e43fc7950f$export$2e2bcd8739ae039 = $726732e43fc7950f$var$ForwardRef;

});

parcelRegister("3sEVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2853bb0dab4793a5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $2853bb0dab4793a5$var$LightBulbIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M10 1a6 6 0 0 0-3.815 10.631C7.237 12.5 8 13.443 8 14.456v.644a.75.75 0 0 0 .572.729 6.016 6.016 0 0 0 2.856 0A.75.75 0 0 0 12 15.1v-.644c0-1.013.762-1.957 1.815-2.825A6 6 0 0 0 10 1ZM8.863 17.414a.75.75 0 0 0-.226 1.483 9.066 9.066 0 0 0 2.726 0 .75.75 0 0 0-.226-1.483 7.553 7.553 0 0 1-2.274 0Z"
    }));
}
const $2853bb0dab4793a5$var$ForwardRef = $acw62.forwardRef($2853bb0dab4793a5$var$LightBulbIcon);
var $2853bb0dab4793a5$export$2e2bcd8739ae039 = $2853bb0dab4793a5$var$ForwardRef;

});

parcelRegister("7KX8i", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a5ab2d913bb7407$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $5a5ab2d913bb7407$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"
    }));
}
const $5a5ab2d913bb7407$var$ForwardRef = $acw62.forwardRef($5a5ab2d913bb7407$var$XMarkIcon);
var $5a5ab2d913bb7407$export$2e2bcd8739ae039 = $5a5ab2d913bb7407$var$ForwardRef;

});


parcelRegister("jfDk4", function(module, exports) {

$parcel$export(module.exports, "ToastContainer", () => $b61726f2ddbc859d$export$f2815235e76a62b9);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
parcelRequire("acw62");
const $b61726f2ddbc859d$export$f2815235e76a62b9 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "aria-live": "assertive",
        className: (0, $9QePP.default)("z-[1000] px-8 py-6 pt-20", "pointer-events-none fixed inset-0 flex items-start"),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: (0, $9QePP.default)("w-full", "flex flex-col", "items-center space-y-4", "sm:items-end"),
            children: children
        })
    });
};

});

parcelRegister("3oOMC", function(module, exports) {

$parcel$export(module.exports, "toast", () => $6a2117317a8e404a$export$b410431fab84fa58);
$parcel$export(module.exports, "ToastProvider", () => $6a2117317a8e404a$export$f5d03d415824e0e);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $jfDk4 = parcelRequire("jfDk4");

var $9cOPt = parcelRequire("9cOPt");

var $r2uF6 = parcelRequire("r2uF6");

var $kBJxW = parcelRequire("kBJxW");
const $6a2117317a8e404a$export$e80fa18a42ed98ef = (0, $r2uF6.createStore)();
const $6a2117317a8e404a$export$12972e612ad7cf0 = (0, $r2uF6.atom)([]);
const $6a2117317a8e404a$var$pushToast = (type, message, options)=>{
    const toasts = $6a2117317a8e404a$export$e80fa18a42ed98ef.get($6a2117317a8e404a$export$12972e612ad7cf0);
    if (!toasts.find((toast)=>toast.type === type && toast.message === message)) $6a2117317a8e404a$export$e80fa18a42ed98ef.set($6a2117317a8e404a$export$12972e612ad7cf0, [
        ...toasts,
        {
            type: type,
            message: message,
            options: options,
            id: (0, $kBJxW.nanoid)()
        }
    ]);
};
const $6a2117317a8e404a$var$clearToastById = (id)=>{
    const toasts = $6a2117317a8e404a$export$e80fa18a42ed98ef.get($6a2117317a8e404a$export$12972e612ad7cf0);
    $6a2117317a8e404a$export$e80fa18a42ed98ef.set($6a2117317a8e404a$export$12972e612ad7cf0, toasts.filter((toast)=>toast.id !== id));
};
const $6a2117317a8e404a$export$b410431fab84fa58 = {
    success: (message, options)=>{
        $6a2117317a8e404a$var$pushToast((0, $9cOPt.ToastType).SUCCESS, message, options);
    },
    error: (message, options)=>{
        $6a2117317a8e404a$var$pushToast((0, $9cOPt.ToastType).ERROR, message, options);
    },
    info: (message, options)=>{
        $6a2117317a8e404a$var$pushToast((0, $9cOPt.ToastType).INFO, message, options);
    },
    warning: (message, options)=>{
        $6a2117317a8e404a$var$pushToast((0, $9cOPt.ToastType).WARNING, message, options);
    },
    tip: (message, options)=>{
        $6a2117317a8e404a$var$pushToast((0, $9cOPt.ToastType).TIP, message, options);
    },
    updating: (message, options)=>{
        $6a2117317a8e404a$var$pushToast((0, $9cOPt.ToastType).UPDATING, message, options);
    },
    generic: (args, options)=>{
        $6a2117317a8e404a$var$pushToast(args.type || (0, $9cOPt.ToastType).SUCCESS, args.message, options);
    }
};
const $6a2117317a8e404a$var$ToastList = ()=>{
    const toasts = (0, $r2uF6.useAtom)($6a2117317a8e404a$export$12972e612ad7cf0)[0];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: toasts.map((toast)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9cOPt.ToastNotification), {
                type: toast.type,
                message: toast.message,
                description: toast.options?.description,
                onUndo: toast.options?.onUndo,
                onDismiss: ()=>$6a2117317a8e404a$var$clearToastById(toast.id),
                closeable: toast.options?.closeable,
                duration: toast.options?.duration
            }, toast.id))
    });
};
const $6a2117317a8e404a$export$f5d03d415824e0e = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $r2uF6.Provider), {
        store: $6a2117317a8e404a$export$e80fa18a42ed98ef,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfDk4.ToastContainer), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($6a2117317a8e404a$var$ToastList, {})
        })
    });
};

});
parcelRegister("kBJxW", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $f00a97eed1786a48$export$ac4959f4f1338dfc);

var $kT1FK = parcelRequire("kT1FK");
let $f00a97eed1786a48$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $f00a97eed1786a48$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $f00a97eed1786a48$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$f00a97eed1786a48$export$a5cee9e955a615e5(alphabet, size, $f00a97eed1786a48$export$4385e60b38654f68);
let $f00a97eed1786a48$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");

});
parcelRegister("kT1FK", function(module, exports) {
let $f34a3dcdc8494601$export$2b646eea95309f00 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";

});




parcelRegister("9mMXU", function(module, exports) {
parcelRequire("8SdWj");

});
parcelRegister("8SdWj", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
function $2a9ce7ca4ab749bb$export$bddbba65b6fc456({ testId: testId, className: className, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("dl", {
        className: (0, $9QePP.default)("grid", "gap-4", "grid-cols-1", "[&>dt]:white-space-nowrap", "[&>dt]:col-span-1", "[&>dd]:col-span-2", "[&>dd]:break-words", "md:grid-cols-3", className),
        "data-testid": testId,
        children: children
    });
}
$2a9ce7ca4ab749bb$export$bddbba65b6fc456.Item = ({ label: label, description: description, forceCapitalization: forceCapitalization })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                className: "white-space-nowrap col-span-1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "body-m subdued",
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                className: "col-span-2 break-words",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: (0, $9QePP.default)("body-m", forceCapitalization && "capitalize"),
                    children: description
                })
            })
        ]
    });

});


parcelRegister("1WlUv", function(module, exports) {
parcelRequire("8msw5");

});
parcelRegister("8msw5", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
function $9786ba8435b714bb$export$b04644a04c64ee0c({ testId: testId, className: className, title: title, primaryAction: primaryAction, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("block", "w-full", "border", "border-default", "rounded-default", "mb-6", "p-6", className),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("flex", "justify-between", "items-center", "mb-8", "cursor-default"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                        className: "heading-l",
                        children: title
                    }),
                    primaryAction ? /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "inline-flex gap-2",
                        "data-testid": `${testId}:primary-action-button`,
                        disabled: primaryAction.disabled,
                        onClick: ()=>primaryAction.onClick(),
                        children: [
                            primaryAction.icon,
                            primaryAction.text
                        ]
                    }) : null
                ]
            }),
            children
        ]
    });
}

});


parcelRegister("kJFOS", function(module, exports) {
$parcel$export(module.exports, "Splash", () => (parcelRequire("gUduC")).Splash);
parcelRequire("gUduC");

});
parcelRegister("gUduC", function(module, exports) {

$parcel$export(module.exports, "Splash", () => $33c0b957b82eda74$export$5369222715ad40d);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
function $33c0b957b82eda74$export$5369222715ad40d({ testId: testId, className: className, graphic: graphic, title: title, subtitle: subtitle, action: action }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("flex", "flex-col", "justify-between", "text-center", "px-4", className),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex flex-col justify-start",
                children: graphic
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "mt-10",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "subdued body-m mt-3 max-w-md",
                children: subtitle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mt-6",
                children: action
            })
        ]
    });
}

});


parcelRegister("hZYzm", function(module, exports) {
parcelRequire("d85Mg");

});
parcelRegister("d85Mg", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("gCemA");
var $1pwFu = parcelRequire("1pwFu");

var $9QePP = parcelRequire("9QePP");
parcelRequire("acw62");
function $adaf5654548024ad$export$378bdba467504f76({ testId: testId, title: title, description: description, children: children, onClick: onClick }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("mt-8 h-full bg-gray-600 p-6", "flex flex-col", "rounded-lozenge box-border cursor-pointer", "hover:bg-[#96b2ce1f] md:min-h-44 md:flex-row"),
        "data-testid": testId,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("w-full pt-5", "border-[#677283]", "max-md:border-b max-md:pb-5 md:w-[248px] md:max-w-[248px] md:border-r md:pr-6"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-s subdued mt-2",
                        children: description.length > 90 ? (0, $1pwFu.autoCapitalize)(`${description.slice(0, 90)}...`, true) : (0, $1pwFu.autoCapitalize)(description, true)
                    })
                ]
            }),
            children
        ]
    });
}
$adaf5654548024ad$export$378bdba467504f76.Content = ({ location: location, industryVertical: industryVertical, targetRaise: targetRaise, timeFrame: timeFrame })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("grid grid-cols-2", "flex-1 gap-4", "max-md:mt-4 md:pl-7"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "col-span-2 md:col-span-1 ",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-micro subdued",
                        children: "Location"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-s",
                        children: location
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "col-span-2 md:col-span-1 ",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-micro subdued",
                        children: "Industry Vertical"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-s",
                        children: industryVertical
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "col-span-2 md:col-span-1 ",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-micro subdued",
                        children: "Target raise"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-s",
                        children: targetRaise
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "col-span-2 md:col-span-1 ",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-micro subdued",
                        children: "Time frame"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-s",
                        children: timeFrame
                    })
                ]
            })
        ]
    });

});


parcelRegister("43ogP", function(module, exports) {
parcelRequire("dwlnw");

});
parcelRegister("dwlnw", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
parcelRequire("4aCOh");
var $hUCih = parcelRequire("hUCih");
parcelRequire("azsOi");
var $1u8ue = parcelRequire("1u8ue");
function $0930d8d14d260166$export$b4d53e3c170c4bc4({ name: name, testId: testId, className: className, onClickDownload: onClickDownload, isDownloadingFile: isDownloadingFile }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("block", "my-8", "box-border", "rounded-default", "p-5", "bg-gray-700", "cursor-pointer", "shadow-default", className),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between",
                onClick: onClickDownload,
                "data-testid": testId,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).CsvFile, {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "subdued body-m ml-2",
                                children: name ? `${name} Company Financials` : "Standardized financials and chartbook"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex items-center justify-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).Download, {})
                    })
                ]
            }),
            isDownloadingFile && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1u8ue.ProgressBar), {})
        ]
    });
}

});


parcelRegister("k4jVw", function(module, exports) {
parcelRequire("42KIP");

});
parcelRegister("42KIP", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
function $a93e99bc4b8c4912$export$c34e163a8f9e36a8({ testId: testId, number: number, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mb-6 flex items-start last:mb-0",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: (0, $9QePP.default)("body-micro bg-primary-500 mr-4 p-4", "border-default border", "flex size-8 items-center justify-center rounded-full text-white"),
                children: number
            }),
            children
        ]
    });
}

});


parcelRegister("7YWCG", function(module, exports) {
parcelRequire("g284I");

});
parcelRegister("g284I", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $jg6IF = parcelRequire("jg6IF");
parcelRequire("azsOi");
var $kYIgH = parcelRequire("kYIgH");

var $9QePP = parcelRequire("9QePP");
function $e01cb33ee25f4adc$export$9a2d2127c53f4c49({ testId: testId, text: text }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mt-5",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: (0, $9QePP.default)("ui-element pb-1 pl-4", "text-disabledTextColor text-[12px]"),
                children: "License key"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("w-full bg-transparent p-3 pl-4", "border-default border", "flex justify-between rounded outline-none", "focus:ring-transparent"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "ui-element subdued",
                        children: text
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kYIgH.Tooltip), {
                        content: "Copy",
                        size: (0, $kYIgH.TooltipSize).XS,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jg6IF.default), {
                            onClick: ()=>{
                                navigator.clipboard.writeText(text);
                            },
                            className: "hover:stroke-defaultTextColor size-6 cursor-pointer stroke-[#788598]"
                        })
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("jg6IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e054b94b72b99235$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $e054b94b72b99235$var$DocumentDuplicateIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
    }));
}
const $e054b94b72b99235$var$ForwardRef = $acw62.forwardRef($e054b94b72b99235$var$DocumentDuplicateIcon);
var $e054b94b72b99235$export$2e2bcd8739ae039 = $e054b94b72b99235$var$ForwardRef;

});



parcelRegister("cibhe", function(module, exports) {
parcelRequire("d671F");

});
parcelRegister("d671F", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $iymfR = parcelRequire("iymfR");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");
function $0fbf2e8ddfb83bce$export$dba9fa4aa656a7cd({ testId: testId, className: className, title: title, description: description, icon: icon, actions: actions }) {
    const [showBanner, setShowBanner] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setTimeout(()=>{
            setShowBanner(true);
        }, 1000);
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition), {
                appear: true,
                as: "div",
                show: showBanner,
                enter: "transition ease-out duration-500 transform origin-top",
                enterFrom: "-translate-y-5",
                enterTo: "translate-y-0",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "bg-secondary",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, $9QePP.default)(className, "mx-auto max-w-2xl px-4 py-11 md:px-0 lg:max-w-4xl"),
                        "data-testid": testId,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: (0, $9QePP.default)("flex flex-col", "items-start justify-around", "lg:flex-row lg:items-center"),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mr-4 hidden lg:block",
                                            children: icon
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    children: title
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "subdued body-l mt-2",
                                                    children: description
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center pt-5 lg:pt-0",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "md mr-4",
                                            onClick: actions.primary.onClick,
                                            children: actions.primary.label
                                        }),
                                        actions.secondary && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "quiet md",
                                            onClick: actions.secondary.onClick,
                                            children: actions.secondary.label
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            !showBanner && //This is a hack to prevent the page from jumping when the banner is shown
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "h-[180px]"
            })
        ]
    });
}

});


parcelRegister("bXUQS", function(module, exports) {
$parcel$export(module.exports, "Filterbox", () => (parcelRequire("br4f9")).Filterbox);
parcelRequire("br4f9");
parcelRequire("acZNw");

});
parcelRegister("br4f9", function(module, exports) {

$parcel$export(module.exports, "Filterbox", () => $d1071411761ec160$export$fcf79cfb83a16e90);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $j9H4k = parcelRequire("j9H4k");
var $iymfR = parcelRequire("iymfR");

var $iXFxr = parcelRequire("iXFxr");

var $gdWue = parcelRequire("gdWue");

var $9QePP = parcelRequire("9QePP");
const $d1071411761ec160$var$SELECT_ALL = "select-all";
function $d1071411761ec160$export$fcf79cfb83a16e90({ testId: testId, title: title, options: options, onChange: onChange, className: className, defaultSelections: defaultSelections }) {
    const { selected: selected, toggleSelectAll: toggleSelectAll, selectAll: selectAll, updateClickedOption: updateClickedOption, updateCheckedOption: updateCheckedOption } = (0, $gdWue.useFilterBox)({
        options: options,
        onChange: onChange,
        defaultSelections: defaultSelections
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": testId,
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j9H4k.Listbox), {
            value: Array.from(selected),
            multiple: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "relative mt-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $j9H4k.Listbox).Button, {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "ui-element subdued cursor-pointer pr-10",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: (0, $9QePP.default)("pr-2", "pointer-events-none absolute inset-y-0 right-0 flex items-center"),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iXFxr.default), {
                                    className: "size-5 text-gray-400",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition), {
                        as: (0, $acw62.Fragment),
                        enter: "transition ease-out duration-100",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "transition ease-in duration-100",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $j9H4k.Listbox).Options, {
                            className: (0, $9QePP.default)("bg-secondary z-10 mt-2 w-full p-2 py-1", "ring-1 ring-inset ring-slate-300 dark:ring-slate-700", "absolute right-0 min-w-[300px] overflow-auto rounded-lg shadow-400", "focus:outline-none sm:min-w-[348px]"),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j9H4k.Listbox).Option, {
                                    className: (0, $9QePP.default)("p-2", "relative cursor-pointer select-none rounded", "hover:bg-default"),
                                    value: $d1071411761ec160$var$SELECT_ALL,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "flex w-full items-center justify-between",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex w-full items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    "data-testid": `${$d1071411761ec160$var$SELECT_ALL}-checkbox`,
                                                    id: $d1071411761ec160$var$SELECT_ALL,
                                                    type: "checkbox",
                                                    checked: selectAll,
                                                    onChange: ()=>toggleSelectAll(),
                                                    className: (0, $9QePP.default)("bg-default", "border-2 border-gray-400", "size-4 rounded text-blue-500", "focus:ring-0 focus:ring-offset-0")
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    htmlFor: $d1071411761ec160$var$SELECT_ALL,
                                                    className: "w-full",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "ui-element ml-4 block cursor-pointer",
                                                        children: "Select All"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }, $d1071411761ec160$var$SELECT_ALL),
                                options.map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $j9H4k.Listbox).Option, {
                                        className: (0, $9QePP.default)("relative cursor-pointer select-none rounded", "hover:bg-default"),
                                        onClick: ()=>updateClickedOption(option),
                                        value: option.value,
                                        children: ({ selected: checked })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: (0, $9QePP.default)("w-full p-2", "group flex items-center justify-between"),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "checkbox",
                                                                "data-testid": `${option.value}-checkbox`,
                                                                checked: checked,
                                                                onChange: ()=>updateCheckedOption(checked, option),
                                                                className: (0, $9QePP.default)("bg-transparent", "border-2 border-gray-400", "size-4 rounded text-blue-500", "focus:ring-0 focus:ring-offset-0")
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                htmlFor: option.value,
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "ui-element ml-4 block cursor-pointer",
                                                                    children: option.label
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: (0, $9QePP.default)("ui-element ml-4", "hidden cursor-pointer", "group-hover:block"),
                                                        "data-testid": `${option.value}-ONLY`,
                                                        children: "ONLY"
                                                    })
                                                ]
                                            })
                                    }, option.value))
                            ]
                        })
                    })
                ]
            })
        })
    });
}

});
parcelRegister("iXFxr", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcddf554cab09b71$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $dcddf554cab09b71$var$ChevronDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z",
        clipRule: "evenodd"
    }));
}
const $dcddf554cab09b71$var$ForwardRef = $acw62.forwardRef($dcddf554cab09b71$var$ChevronDownIcon);
var $dcddf554cab09b71$export$2e2bcd8739ae039 = $dcddf554cab09b71$var$ForwardRef;

});

parcelRegister("gdWue", function(module, exports) {

$parcel$export(module.exports, "useFilterBox", () => $2d9587d11b493da2$export$befd78c4624415ed);

var $acw62 = parcelRequire("acw62");
function $2d9587d11b493da2$export$befd78c4624415ed({ options: options, onChange: onChange, defaultSelections: defaultSelections }) {
    const values = Array.from(new Set(options.map(({ value: value })=>value)));
    const [selected, setSelected] = (0, $acw62.useState)(new Set(defaultSelections || values));
    const [selectAll, setSelectAll] = (0, $acw62.useState)(false);
    const toggleSelectAll = ()=>{
        setSelected((prevSelected)=>prevSelected.size === values.length ? new Set() : new Set(values));
        setSelectAll(!selectAll);
    };
    const updateClickedOption = (option)=>{
        setSelectAll(false);
        setSelected(new Set([
            option.value
        ]));
    };
    const updateCheckedOption = (checked, option)=>{
        const newSelected = new Set(selected);
        checked ? newSelected.delete(option.value) : newSelected.add(option.value);
        setSelected(newSelected);
    };
    (0, $acw62.useEffect)(()=>{
        if (!selectAll && selected.size === values.length) setSelectAll(true);
        const isNullSet = selected.size === 0;
        const isFullSet = selected.size === values.length;
        onChange({
            filterSet: Array.from(selected),
            isFullSet: isFullSet,
            isNullSet: isNullSet,
            hasSelections: !isFullSet && !isNullSet,
            isSelected: (val)=>selected.has(val),
            isOnly: (val)=>selected.size === 1 && selected.has(val)
        });
    }, [
        selected,
        selectAll,
        setSelectAll
    ]);
    return {
        toggleSelectAll: toggleSelectAll,
        updateClickedOption: updateClickedOption,
        updateCheckedOption: updateCheckedOption,
        selected: selected,
        selectAll: selectAll
    };
}

});


parcelRegister("acZNw", function(module, exports) {

});


parcelRegister("6jU26", function(module, exports) {
$parcel$export(module.exports, "PageHeading", () => (parcelRequire("5c1IA")).PageHeading);
parcelRequire("5c1IA");

});
parcelRegister("5c1IA", function(module, exports) {

$parcel$export(module.exports, "PageHeading", () => $012cda9e95375215$export$9716a88f5535df7c);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $bvcna = parcelRequire("bvcna");
function $012cda9e95375215$export$9716a88f5535df7c({ title: title, children: children, testId: testId, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)((0, $bvcna.twMerge)("flex flex-col justify-between gap-4 sm:flex-row sm:items-center", className)),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                className: "w-1/2",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("flex flex-col", "gap-4", "sm:flex-row sm:items-center"),
                children: children
            })
        ]
    });
}

});


parcelRegister("hAMzH", function(module, exports) {
$parcel$export(module.exports, "SubHeading", () => (parcelRequire("fy2Jk")).SubHeading);
parcelRequire("fy2Jk");

});
parcelRegister("fy2Jk", function(module, exports) {

$parcel$export(module.exports, "SubHeading", () => $dc6cb3df7b5f579b$export$210dc657affc8afd);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $3GnlZ = parcelRequire("3GnlZ");

var $d8ZkG = parcelRequire("d8ZkG");
function $dc6cb3df7b5f579b$export$210dc657affc8afd({ children: children, testId: testId, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("my-10 flex items-center gap-2 sm:gap-14", className),
        "data-testid": testId,
        children: children
    });
}
$dc6cb3df7b5f579b$export$210dc657affc8afd.Data = (0, $d8ZkG.SubHeadingData);
$dc6cb3df7b5f579b$export$210dc657affc8afd.Accessory = (0, $3GnlZ.SubHeadingAccessory);

});
parcelRegister("3GnlZ", function(module, exports) {

$parcel$export(module.exports, "SubHeadingAccessory", () => $90e79636a6e6f37b$export$b86fad93be69ddd8);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $90e79636a6e6f37b$export$b86fad93be69ddd8({ text: text, onClick: onClick, testId: testId, className: className }) {
    if (onClick) return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        role: "button",
        onClick: onClick,
        className: (0, $9QePP.default)("subdued pl-1", className),
        "data-testid": testId,
        children: text
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        className: (0, $9QePP.default)(className, "body-micro subdued"),
        "data-testid": testId,
        children: text
    });
}

});

parcelRegister("d8ZkG", function(module, exports) {

$parcel$export(module.exports, "SubHeadingData", () => $dec6d05f8d631339$export$cd7fef8980a2690);

var $ayMG0 = parcelRequire("ayMG0");
function $dec6d05f8d631339$export$cd7fef8980a2690({ label: label, value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "subdued ui-element",
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-baseline gap-x-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        children: value
                    }),
                    children
                ]
            })
        ]
    });
}

});



parcelRegister("4mtEF", function(module, exports) {
$parcel$export(module.exports, "FilterIndicator", () => (parcelRequire("93iCJ")).FilterIndicator);
parcelRequire("93iCJ");

});
parcelRegister("93iCJ", function(module, exports) {

$parcel$export(module.exports, "FilterIndicator", () => $2181c7baae060ebe$export$55643fa4da3ef265);

var $ayMG0 = parcelRequire("ayMG0");

var $eVhSR = parcelRequire("eVhSR");

var $9QePP = parcelRequire("9QePP");
parcelRequire("5R0Xk");
var $5Ttm9 = parcelRequire("5Ttm9");
parcelRequire("aJClm");
var $kYIgH = parcelRequire("kYIgH");
function $2181c7baae060ebe$export$55643fa4da3ef265({ isFiltering: isFiltering, filterText: filterText = "Updating...", hasError: hasError, className: className, hideOnMobile: hideOnMobile = false }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("flex items-center gap-4", hideOnMobile && "hidden sm:flex", className),
        children: [
            hasError && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eVhSR.default), {
                        width: 20,
                        className: "subdued"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kYIgH.Tooltip), {
                        position: "top",
                        size: (0, $kYIgH.TooltipSize).XL,
                        content: "There was an error while filtering. Please try again or refresh your browser.",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-button subdued",
                            children: "Filter error"
                        })
                    })
                ]
            }),
            isFiltering && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "subdued text-button",
                        children: filterText
                    })
                ]
            })
        ]
    });
}

});


parcelRegister("eoXvj", function(module, exports) {
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("cjuU3")).Breadcrumbs);
parcelRequire("cjuU3");

});
parcelRegister("cjuU3", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $8771e484ea4d47db$export$2dc68d50d56fbbd);

var $ayMG0 = parcelRequire("ayMG0");

var $QdLEB = parcelRequire("QdLEB");

var $9QePP = parcelRequire("9QePP");

var $lzNIT = parcelRequire("lzNIT");
function $8771e484ea4d47db$export$2dc68d50d56fbbd({ pages: pages, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
        className: (0, $9QePP.default)("flex min-w-0", className),
        "aria-label": "Breadcrumb",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("ol", {
            role: "list",
            className: (0, $9QePP.default)("flex flex-nowrap", "min-w-0 items-center space-x-3"),
            children: pages.map((page, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    className: (0, $9QePP.default)(page.truncate ? "min-w-0 shrink" : "shrink-0"),
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex min-w-0 items-center",
                        children: [
                            i > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QdLEB.default), {
                                className: "size-5 shrink-0 text-gray-400",
                                "aria-hidden": "true"
                            }),
                            page.href && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                to: page.href,
                                className: (0, $9QePP.default)("text-link block", page.truncate && "min-w-0 truncate", i > 0 && "ml-3"),
                                "aria-current": "page",
                                children: page.name
                            }),
                            !page.href && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: (0, $9QePP.default)("ui-element block", "subdued", page.truncate && "min-w-0 truncate", i > 0 && "ml-3"),
                                children: page.name
                            })
                        ]
                    })
                }, page.name))
        })
    });
}

});
parcelRegister("QdLEB", function(module, exports) {

$parcel$export(module.exports, "default", () => $09cf89676d665655$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $09cf89676d665655$var$ChevronRightIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z",
        clipRule: "evenodd"
    }));
}
const $09cf89676d665655$var$ForwardRef = $acw62.forwardRef($09cf89676d665655$var$ChevronRightIcon);
var $09cf89676d665655$export$2e2bcd8739ae039 = $09cf89676d665655$var$ForwardRef;

});



parcelRegister("7bOCJ", function(module, exports) {
$parcel$export(module.exports, "MaintenanceBanner", () => (parcelRequire("jg6kN")).MaintenanceBanner);
parcelRequire("jg6kN");

});
parcelRegister("jg6kN", function(module, exports) {

$parcel$export(module.exports, "MaintenanceBanner", () => $479b9ba2019a73a4$export$394f2c5524088a22);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $479b9ba2019a73a4$export$394f2c5524088a22({ message: message = "We are planning scheduled maintenance at 10PM EST. We expect it to last ~1 hour.", title: title = "Scheduled Maintenance" }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("bg-cta-primary-default z-[1000] w-full px-6 py-2.5", "sticky top-0 flex items-center justify-between gap-x-6", "sm:pr-3.5 lg:pl-8"),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "text-sm leading-6 text-white",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                href: "#",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                        className: "font-semibold",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        viewBox: "0 0 2 2",
                        className: (0, $9QePP.default)("mx-2 size-0.5", "inline fill-current"),
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                            cx: 1,
                            cy: 1,
                            r: 1
                        })
                    }),
                    message
                ]
            })
        })
    });
}

});


parcelRegister("kcbxz", function(module, exports) {
$parcel$export(module.exports, "CardSkeleton", () => (parcelRequire("aZozk")).CardSkeleton);
parcelRequire("aZozk");

});
parcelRegister("aZozk", function(module, exports) {

$parcel$export(module.exports, "CardSkeleton", () => $f46c3c554fef9908$export$cd0b2ec2a6af7313);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("azsOi");
var $bVwXM = parcelRequire("bVwXM");

var $9QePP = parcelRequire("9QePP");
function $f46c3c554fef9908$export$cd0b2ec2a6af7313({ testId: testId, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bVwXM.Card), {
        className: (0, $9QePP.default)("animate-pulse", className),
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex-1 space-y-6 py-1",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "h-2 rounded bg-slate-700"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "space-y-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid grid-cols-3 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "col-span-2 h-2 rounded bg-slate-700"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "col-span-1 h-2 rounded bg-slate-700"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "h-2 rounded bg-slate-700"
                        })
                    ]
                })
            ]
        })
    });
}

});


parcelRegister("62A7U", function(module, exports) {
parcelRequire("a8P3J");

});
parcelRegister("a8P3J", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $9dEbd = parcelRequire("9dEbd");

var $9QePP = parcelRequire("9QePP");
function $c3b06fb395bb8982$export$915dca69d0056fc2({ testId: testId, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)(className, "ui-element subdued", "bg-slate-50/10 px-6 py-1", "flex items-center gap-2", "rounded-full shadow-tooltip ring-1 ring-slate-200"),
        "data-testid": testId,
        children: [
            "Scroll ",
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9dEbd.default), {
                className: "size-4"
            })
        ]
    });
}

});
parcelRegister("9dEbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b647edcf4c8f707$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $6b647edcf4c8f707$var$ArrowDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M10 3a.75.75 0 0 1 .75.75v10.638l3.96-4.158a.75.75 0 1 1 1.08 1.04l-5.25 5.5a.75.75 0 0 1-1.08 0l-5.25-5.5a.75.75 0 1 1 1.08-1.04l3.96 4.158V3.75A.75.75 0 0 1 10 3Z",
        clipRule: "evenodd"
    }));
}
const $6b647edcf4c8f707$var$ForwardRef = $acw62.forwardRef($6b647edcf4c8f707$var$ArrowDownIcon);
var $6b647edcf4c8f707$export$2e2bcd8739ae039 = $6b647edcf4c8f707$var$ForwardRef;

});



parcelRegister("gCgkb", function(module, exports) {
parcelRequire("8BAn0");

});
parcelRegister("8BAn0", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $1oBsS = parcelRequire("1oBsS");
var $3tRFv = parcelRequire("3tRFv");
parcelRequire("5R0Xk");
var $5Ttm9 = parcelRequire("5Ttm9");
const $01e51a8b33699dac$export$5183a05b90bb817d = ({ steps: steps, currentStep: currentStep, isError: isError, showSpinner: showSpinner = true, className: className = "" })=>{
    const progress = currentStep / (steps.length - 1) * 100;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("w-full", className),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("relative h-2 w-full overflow-hidden rounded-full bg-slate-100/20"),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: (0, $9QePP.default)("absolute h-full rounded-full bg-brand-400 transition-all duration-500 ease-in-out"),
                    style: {
                        width: `${progress === 100 ? 100 : progress + 3}%`
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "relative mt-4 flex justify-between",
                children: steps.map((step, index)=>{
                    const isCurrent = index === currentStep;
                    const isLast = index === steps.length - 1;
                    const isCompleted = index < currentStep || currentStep === steps.length - 1;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2 transition-[width] duration-500 ease-in-out",
                        children: [
                            (!isCurrent || isLast) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1oBsS.default), {
                                className: (0, $9QePP.default)("fade-container relative z-10 size-4", !isCompleted && "invisible opacity-0")
                            }),
                            isCurrent && showSpinner && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {}),
                            isError && isCurrent && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3tRFv.default), {
                                className: "fade-container size-4 self-end fill-red-500 stroke-red-500"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: (0, $9QePP.default)("ui-label mt-1 transition-colors duration-300", isError && isCurrent && "text-red-500"),
                                children: step
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};

});
parcelRegister("1oBsS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1045181073ad00d2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $1045181073ad00d2$var$CheckIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z",
        clipRule: "evenodd"
    }));
}
const $1045181073ad00d2$var$ForwardRef = $acw62.forwardRef($1045181073ad00d2$var$CheckIcon);
var $1045181073ad00d2$export$2e2bcd8739ae039 = $1045181073ad00d2$var$ForwardRef;

});

parcelRegister("3tRFv", function(module, exports) {

$parcel$export(module.exports, "default", () => $288db5f145d66c42$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $288db5f145d66c42$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z",
        clipRule: "evenodd"
    }));
}
const $288db5f145d66c42$var$ForwardRef = $acw62.forwardRef($288db5f145d66c42$var$XMarkIcon);
var $288db5f145d66c42$export$2e2bcd8739ae039 = $288db5f145d66c42$var$ForwardRef;

});



parcelRegister("lS2QC", function(module, exports) {
$parcel$export(module.exports, "Pagination", () => (parcelRequire("f5Nhr")).Pagination);
parcelRequire("f5Nhr");

});
parcelRegister("f5Nhr", function(module, exports) {

$parcel$export(module.exports, "Pagination", () => $9236609bd2d0ea8c$export$68f5e1453c188a82);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $jLakY = parcelRequire("jLakY");
var $QdLEB = parcelRequire("QdLEB");
function $9236609bd2d0ea8c$export$68f5e1453c188a82({ currentPage: currentPage, totalPages: totalPages, onPageChange: onPageChange, className: className, testId: testId }) {
    const getVisiblePages = ()=>{
        if (totalPages <= 5) return Array.from({
            length: totalPages
        }, (_, i)=>i + 1);
        const pages = [];
        if (currentPage <= 3) pages.push(1, 2, 3, 4, totalPages);
        else if (currentPage >= totalPages - 2) pages.push(1, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
        else pages.push(1, currentPage - 1, currentPage, currentPage + 1, totalPages);
        return pages;
    };
    if (totalPages <= 1) return null;
    const visiblePages = getVisiblePages();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("flex items-center justify-between gap-1", className),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>onPageChange(currentPage - 1),
                disabled: currentPage <= 1,
                className: "secondary sm",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jLakY.default), {
                    className: "size-6"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex items-center gap-2",
                children: visiblePages.map((pageNumber)=>{
                    const isCurrentPage = pageNumber === currentPage;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>onPageChange(pageNumber),
                        className: (0, $9QePP.default)("sm", isCurrentPage ? "" : "secondary"),
                        children: pageNumber
                    }, pageNumber);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>onPageChange(currentPage + 1),
                disabled: currentPage >= totalPages,
                className: "secondary sm",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QdLEB.default), {
                    className: "size-6"
                })
            })
        ]
    });
}

});
parcelRegister("jLakY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e62a6cddb6964319$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $e62a6cddb6964319$var$ChevronLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z",
        clipRule: "evenodd"
    }));
}
const $e62a6cddb6964319$var$ForwardRef = $acw62.forwardRef($e62a6cddb6964319$var$ChevronLeftIcon);
var $e62a6cddb6964319$export$2e2bcd8739ae039 = $e62a6cddb6964319$var$ForwardRef;

});




parcelRegister("8OvTp", function(module, exports) {
$parcel$export(module.exports, "ProgressDownload", () => (parcelRequire("7dcDb")).ProgressDownload);
$parcel$export(module.exports, "DetailCard", () => (parcelRequire("kE1zm")).DetailCard);
$parcel$export(module.exports, "Table", () => (parcelRequire("grEu8")).Table);
$parcel$export(module.exports, "FilterBar", () => (parcelRequire("9tkgs")).FilterBar);
$parcel$export(module.exports, "Search", () => (parcelRequire("lkwlf")).Search);
$parcel$export(module.exports, "Checkbox", () => (parcelRequire("29x30")).Checkbox);
$parcel$export(module.exports, "Form", () => (parcelRequire("hQ0nj")).Form);
$parcel$export(module.exports, "Input", () => (parcelRequire("bApKI")).Input);
$parcel$export(module.exports, "Money", () => (parcelRequire("7JqhK")).Money);
$parcel$export(module.exports, "MutableList", () => (parcelRequire("9hanQ")).MutableList);
$parcel$export(module.exports, "Percent", () => (parcelRequire("6pNDa")).Percent);
$parcel$export(module.exports, "RawInput", () => (parcelRequire("a6Thc")).RawInput);
$parcel$export(module.exports, "RichText", () => (parcelRequire("faxRZ")).RichText);
$parcel$export(module.exports, "Select", () => (parcelRequire("97C3K")).Select);
$parcel$export(module.exports, "TextArea", () => (parcelRequire("1sOsm")).TextArea);
$parcel$export(module.exports, "StatWidget", () => (parcelRequire("1l3Yq")).StatWidget);
$parcel$export(module.exports, "TextWidget", () => (parcelRequire("9nhU7")).TextWidget);
$parcel$export(module.exports, "Widget", () => (parcelRequire("b7ZjI")).Widget);
$parcel$export(module.exports, "WidgetGrid", () => (parcelRequire("2rl3y")).WidgetGrid);
$parcel$export(module.exports, "DropZone", () => (parcelRequire("bVQej")).DropZone);
$parcel$export(module.exports, "DropdownMenu", () => (parcelRequire("bZayu")).DropdownMenu);

$parcel$export(module.exports, "Chart", () => $3b9bb98132050c76$re_export$Chart);
$parcel$export(module.exports, "ActiveEmptyState", () => (parcelRequire("bCrQI")).default);
parcelRequire("ib5Pc");
parcelRequire("fKxk7");
parcelRequire("bnopv");
parcelRequire("4SYbb");
parcelRequire("20nGc");
parcelRequire("ab1kZ");
parcelRequire("dChYn");
parcelRequire("ii2jZ");
parcelRequire("kYQGR");
parcelRequire("dDsB8");
parcelRequire("5rtdy");
parcelRequire("hpkLA");

var $bCrQI = parcelRequire("bCrQI");
parcelRequire("gZNMM");
parcelRequire("j4C8j");

});
parcelRegister("ib5Pc", function(module, exports) {
parcelRequire("S3Pb6");

});
parcelRegister("S3Pb6", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
parcelRequire("acw62");
function $a123db6d2a3e233e$export$c9e4449cfc3bfc22({ children: children, testId: testId }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": testId,
        className: (0, $9QePP.default)("flex flex-col items-center xl:flex-row", "gap-[42px] lg:gap-10 xl:gap-[120px]", "h-screen p-16 pt-8", "first:flex first:w-full first:flex-col first:gap-3", "lg:first:max-w-[400px]", "last:w-full lg:last:max-w-[500px]"),
        children: children
    });
}
$a123db6d2a3e233e$export$c9e4449cfc3bfc22.LeftContent = ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: (0, $9QePP.default)("bg-secondary", "relative", "md:fixed md:h-full md:w-[480px] md:max-w-[320px] md:p-6 lg:max-w-[480px]"),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("h-full", "flex flex-col", "justify-between", "max-sm:px-8 max-sm:py-10"),
                children: children
            })
        })
    });
$a123db6d2a3e233e$export$c9e4449cfc3bfc22.Footer = ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "mb-16 hidden md:block lg:mx-14",
        children: children
    });
$a123db6d2a3e233e$export$c9e4449cfc3bfc22.FooterMobile = ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "mb-2 mt-5 block md:hidden",
        children: children
    });
$a123db6d2a3e233e$export$c9e4449cfc3bfc22.Header = ({ title: title, subtitle: subtitle })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lg:mx-14",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "hidden md:block",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "block md:hidden",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "body-m subdued mt-2",
                children: subtitle
            })
        ]
    });
$a123db6d2a3e233e$export$c9e4449cfc3bfc22.RightContent = ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("px-6 pb-10 pt-4", "flex flex-col", "items-center justify-center", "max-sm:flex-1 md:ml-[320px] md:min-h-screen md:px-4 md:pt-10 lg:ml-[480px]"),
        children: children
    });

});


parcelRegister("fKxk7", function(module, exports) {
$parcel$export(module.exports, "ProgressDownload", () => (parcelRequire("7dcDb")).ProgressDownload);
parcelRequire("7dcDb");

});
parcelRegister("7dcDb", function(module, exports) {

$parcel$export(module.exports, "ProgressDownload", () => $47bc50e23987e677$export$6389f391847fc793);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
parcelRequire("azsOi");
var $hUCih = parcelRequire("hUCih");
var $5Ttm9 = parcelRequire("5Ttm9");

var $ckP3P = parcelRequire("ckP3P");
var $eVhSR = parcelRequire("eVhSR");

var $iymfR = parcelRequire("iymfR");

var $dKUtl = parcelRequire("dKUtl");
const $47bc50e23987e677$var$DEFAULT_TEXT = {
    [(0, $dKUtl.CreditBoxStatus).Running]: "Gathering data. This process should only take a couple of minutes. Please wait...",
    [(0, $dKUtl.CreditBoxStatus).Success]: "Success!",
    [(0, $dKUtl.CreditBoxStatus).Failure]: "Error: data mapping is still processing. Please try again later and contact us if the error persists"
};
function $47bc50e23987e677$export$6389f391847fc793({ isPolling: isPolling, isFailure: isFailure, isSuccess: isSuccess, text: text, title: title = "Download", onCancel: onCancel, onClose: onClose, testId: testId, className: className }) {
    const [show, setShow] = (0, $acw62.useState)(false);
    const [state, setState] = (0, $acw62.useState)((0, $dKUtl.CreditBoxStatus).Pending);
    const [displayText, setDisplayText] = (0, $acw62.useState)("");
    const handleClose = (0, $acw62.useCallback)(()=>{
        setShow(false);
        setState((0, $dKUtl.CreditBoxStatus).Pending);
        setDisplayText("");
        onClose?.();
    }, [
        onClose
    ]);
    const handleCancel = (0, $acw62.useCallback)(()=>{
        setShow(false);
        setState((0, $dKUtl.CreditBoxStatus).Pending);
        setDisplayText("");
        onCancel?.();
    }, [
        onCancel
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isPolling) {
            setState((0, $dKUtl.CreditBoxStatus).Running);
            setShow(true);
        } else if (isFailure) {
            setState((0, $dKUtl.CreditBoxStatus).Failure);
            setShow(true);
        } else if (isSuccess) {
            setState((0, $dKUtl.CreditBoxStatus).Success);
            setShow(true);
        }
    }, [
        isPolling,
        isSuccess,
        isFailure
    ]);
    (0, $acw62.useEffect)(()=>{
        if (state !== (0, $dKUtl.CreditBoxStatus).Pending) setDisplayText(text || $47bc50e23987e677$var$DEFAULT_TEXT[state]);
    }, [
        state,
        text
    ]);
    (0, $acw62.useEffect)(()=>{
        if (state === (0, $dKUtl.CreditBoxStatus).Success) {
            const timer = setTimeout(()=>{
                handleClose();
            }, 2000);
            return ()=>clearTimeout(timer);
        }
    }, [
        state,
        handleClose
    ]);
    const isRunning = state === (0, $dKUtl.CreditBoxStatus).Running;
    const isComplete = state === (0, $dKUtl.CreditBoxStatus).Success || state === (0, $dKUtl.CreditBoxStatus).Failure;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition), {
            as: (0, $acw62.Fragment),
            show: show,
            enter: "transform transition duration-[600ms]",
            enterFrom: "translate-y-[200px]",
            enterTo: "translate-y-0",
            leave: "transform transition duration-[600ms]",
            leaveFrom: "translate-y-2",
            leaveTo: "translate-y-[200px]",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("w-full", "max-w-[468px]", "bg-gray-700", "rounded-[8px]", "border", "border-default", "p-6", "fixed", "z-50", "bottom-[32px]", "right-[32px]", "shadow-default", className),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                className: "heading-m",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    isRunning && onCancel && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "secondary",
                                        onClick: handleCancel,
                                        children: "Cancel"
                                    }),
                                    isComplete && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).Close, {
                                        className: "ml-5 cursor-pointer",
                                        onClick: handleClose
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt-4 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: (0, $9QePP.default)("subdued ui-element mr-2 overflow-hidden text-ellipsis"),
                                children: displayText
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex",
                                children: [
                                    state === (0, $dKUtl.CreditBoxStatus).Failure && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eVhSR.default), {
                                        "data-testid": "polling-error-icon",
                                        fill: "#FF8A8A",
                                        width: 16
                                    }),
                                    state === (0, $dKUtl.CreditBoxStatus).Success && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ckP3P.default), {
                                        "data-testid": "polling-success-icon",
                                        fill: "#72C681",
                                        width: 16
                                    }),
                                    isRunning && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {})
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

});
parcelRegister("dKUtl", function(module, exports) {

$parcel$export(module.exports, "COMING_SOON", () => $47380f62d26dae41$export$b0409bb9b247a093);
$parcel$export(module.exports, "CreditBoxStatus", () => $47380f62d26dae41$export$28bf03bb72e140b7);
$parcel$export(module.exports, "CreditBoxResult", () => $47380f62d26dae41$export$35f7ed012e275ac6);
$parcel$export(module.exports, "CreditBoxSearchType", () => $47380f62d26dae41$export$d0b14d6c66dc825d);
$parcel$export(module.exports, "PAGE_SIZE", () => $47380f62d26dae41$export$8ec3d08588d2eeda);
$parcel$export(module.exports, "HUM_FUND_ID", () => $47380f62d26dae41$export$e3727c59a7619dd3);
const $47380f62d26dae41$export$b0409bb9b247a093 = "coming soon";
var $47380f62d26dae41$export$59adc39451e8173b;
(function(ReportType) {
    ReportType["TALCOTT"] = "talcott_credit_box_v1";
    ReportType["PEAK_ROCK"] = "peakrock_investor_test";
})($47380f62d26dae41$export$59adc39451e8173b || ($47380f62d26dae41$export$59adc39451e8173b = {}));
var $47380f62d26dae41$export$1c3efd9d3bf546e8;
(function(InvestorName) {
    InvestorName["TALCOTT"] = "Talcott";
    InvestorName["PEAK_ROCK"] = "Peak Rock";
})($47380f62d26dae41$export$1c3efd9d3bf546e8 || ($47380f62d26dae41$export$1c3efd9d3bf546e8 = {}));
var $47380f62d26dae41$export$b5f5e2416a41156;
(function(InvestorTestRating) {
    InvestorTestRating["TRUE"] = "TRUE";
    InvestorTestRating["FALSE"] = "FALSE";
})($47380f62d26dae41$export$b5f5e2416a41156 || ($47380f62d26dae41$export$b5f5e2416a41156 = {}));
var $47380f62d26dae41$export$28bf03bb72e140b7;
(function(CreditBoxStatus) {
    CreditBoxStatus["Pending"] = "PENDING";
    CreditBoxStatus["Started"] = "STARTED";
    CreditBoxStatus["Success"] = "SUCCESS";
    CreditBoxStatus["Failure"] = "FAILURE";
    CreditBoxStatus["Running"] = "RUNNING";
})($47380f62d26dae41$export$28bf03bb72e140b7 || ($47380f62d26dae41$export$28bf03bb72e140b7 = {}));
var $47380f62d26dae41$export$35f7ed012e275ac6;
(function(CreditBoxResult) {
    CreditBoxResult["PASS"] = "PASS";
    CreditBoxResult["FAIL"] = "FAIL";
})($47380f62d26dae41$export$35f7ed012e275ac6 || ($47380f62d26dae41$export$35f7ed012e275ac6 = {}));
var $47380f62d26dae41$export$8f6e13253020b885;
(function(CreditBoxRunStatus) {
    CreditBoxRunStatus["PASS"] = "PASS";
    CreditBoxRunStatus["FAIL"] = "FAIL";
})($47380f62d26dae41$export$8f6e13253020b885 || ($47380f62d26dae41$export$8f6e13253020b885 = {}));
var $47380f62d26dae41$export$d0b14d6c66dc825d;
(function(CreditBoxSearchType) {
    CreditBoxSearchType["INVESTORS"] = "investors";
    CreditBoxSearchType["OPPORTUNITIES"] = "opportunities";
})($47380f62d26dae41$export$d0b14d6c66dc825d || ($47380f62d26dae41$export$d0b14d6c66dc825d = {}));
const $47380f62d26dae41$export$8ec3d08588d2eeda = 1000;
const $47380f62d26dae41$export$35a95e9253e433f9 = [
    "06851878-cdbf-7f09-8000-1706f9d5bb0b",
    "0686387b-3b5a-7966-8000-8eda73642004",
    "0686387b-3d41-776b-8000-47d8cee7195c",
    "0686387b-3794-7425-8000-88d25deae4f2"
];
const $47380f62d26dae41$export$e3727c59a7619dd3 = "e087596e-0b65-41f3-b4a3-3992bb600d2d";

});



parcelRegister("bnopv", function(module, exports) {

var $2mJUK = parcelRequire("2mJUK");
parcelRequire("8oIro");
const $a501a0283cdea30e$export$6641a57d5874d0cd = Object.values((0, (/*@__PURE__*/$parcel$interopDefault($2mJUK))).theme.extend.colors.chart);

});
parcelRegister("2mJUK", function(module, exports) {
/** @type {import('tailwindcss').Config} */ const $1b9140755002168e$var$brand = "#0112C2";


module.exports = {
    darkMode: "selector",
    theme: {
        extend: {
            screens: {
                xtall: {
                    raw: "(min-height: 800px)"
                },
                tall: {
                    raw: "(max-height: 799px)"
                },
                "m-height": {
                    raw: "(max-height: 699px)"
                },
                short: {
                    raw: "(max-height: 600px)"
                }
            },
            colors: {
                brand: {
                    DEFAULT: $1b9140755002168e$var$brand,
                    50: "#EBF1FF",
                    100: "#CCDBFD",
                    200: "#AEC3FC",
                    300: "#92ABFA",
                    400: "#4A66F4",
                    500: "#2841ED",
                    600: "#1026E0",
                    700: $1b9140755002168e$var$brand,
                    800: "#00057F",
                    900: "#0F172A"
                },
                chart: {
                    1: {
                        default: "#2841ED",
                        negative: "#D9F1FF"
                    },
                    2: {
                        default: "#08BDBA",
                        negative: "#D9F1FF"
                    },
                    3: {
                        default: "#DFBF03",
                        negative: "#D9F1FF"
                    },
                    4: {
                        default: "#FF6B6B",
                        negative: "#D9F1FF"
                    },
                    5: {
                        default: "#DA348F",
                        negative: "#D9F1FF"
                    },
                    6: {
                        default: "#AEC3FC",
                        negative: "#D9F1FF"
                    },
                    7: {
                        default: "#28A138",
                        negative: "#D9F1FF"
                    },
                    8: {
                        default: "#F9A43F",
                        negative: "#D9F1FF"
                    },
                    9: {
                        default: "#B215DA",
                        negative: "#D9F1FF"
                    },
                    10: {
                        default: "#FFC777",
                        negative: "#D9F1FF"
                    },
                    11: {
                        default: "#007D79",
                        negative: "#D9F1FF"
                    },
                    12: {
                        default: "#99D7A5",
                        negative: "#D9F1FF"
                    }
                }
            },
            fontFamily: {
                "supera-black": "Supera Gothic Black",
                "supera-bold": "Supera Gothic Bold",
                "supera-extra-bold": "Supera Gothic Extra Bold",
                inter: "Inter"
            },
            boxShadow: {
                tooltip: "0px 8px 12px 0px rgba(12, 16, 20, 0.85), 0px 0px 1px 0px rgba(12, 16, 20, 0.81)",
                400: "0 12px 24px -6px rgba(12, 16, 20, 0.85), 0 0 1px 0 rgba(12, 16, 20, 0.81)",
                "search-bar": "0 0 8px 0 rgba(0, 0, 0, 0.25)"
            }
        }
    },
    plugins: [
        (parcelRequire("hLol2")),
        (parcelRequire("2WIDq"))
    ],
    content: [
        "./src/**/*.{js,jsx,ts,tsx,html}"
    ]
};

});
parcelRegister("hLol2", function(module, exports) {

var $lbtLX = parcelRequire("lbtLX");

var $8lbaV = parcelRequire("8lbaV");

var $byT7c = parcelRequire("byT7c");

var $5pY61 = parcelRequire("5pY61");
const [$cee9b48d0a30a8e0$var$baseFontSize, { lineHeight: $cee9b48d0a30a8e0$var$baseLineHeight }] = $byT7c.fontSize.base;
const { spacing: $cee9b48d0a30a8e0$var$spacing, borderWidth: $cee9b48d0a30a8e0$var$borderWidth, borderRadius: $cee9b48d0a30a8e0$var$borderRadius } = $byT7c;
function $cee9b48d0a30a8e0$var$resolveColor(color, opacityVariableName) {
    return color.replace("<alpha-value>", `var(${opacityVariableName}, 1)`);
}
const $cee9b48d0a30a8e0$var$forms = $8lbaV.withOptions(function(options = {
    strategy: undefined
}) {
    return function({ addBase: addBase, addComponents: addComponents, theme: theme }) {
        const strategy = options.strategy === undefined ? [
            "base",
            "class"
        ] : [
            options.strategy
        ];
        const rules = [
            {
                base: [
                    "[type='text']",
                    "input:where(:not([type]))",
                    "[type='email']",
                    "[type='url']",
                    "[type='password']",
                    "[type='number']",
                    "[type='date']",
                    "[type='datetime-local']",
                    "[type='month']",
                    "[type='search']",
                    "[type='tel']",
                    "[type='time']",
                    "[type='week']",
                    "[multiple]",
                    "textarea",
                    "select"
                ],
                class: [
                    ".form-input",
                    ".form-textarea",
                    ".form-select",
                    ".form-multiselect"
                ],
                styles: {
                    appearance: "none",
                    "background-color": "#fff",
                    "border-color": $cee9b48d0a30a8e0$var$resolveColor(theme("colors.gray.500", $5pY61.gray[500]), "--tw-border-opacity"),
                    "border-width": $cee9b48d0a30a8e0$var$borderWidth["DEFAULT"],
                    "border-radius": $cee9b48d0a30a8e0$var$borderRadius.none,
                    "padding-top": $cee9b48d0a30a8e0$var$spacing[2],
                    "padding-right": $cee9b48d0a30a8e0$var$spacing[3],
                    "padding-bottom": $cee9b48d0a30a8e0$var$spacing[2],
                    "padding-left": $cee9b48d0a30a8e0$var$spacing[3],
                    "font-size": $cee9b48d0a30a8e0$var$baseFontSize,
                    "line-height": $cee9b48d0a30a8e0$var$baseLineHeight,
                    "--tw-shadow": "0 0 #0000",
                    "&:focus": {
                        outline: "2px solid transparent",
                        "outline-offset": "2px",
                        "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
                        "--tw-ring-offset-width": "0px",
                        "--tw-ring-offset-color": "#fff",
                        "--tw-ring-color": $cee9b48d0a30a8e0$var$resolveColor(theme("colors.blue.600", $5pY61.blue[600]), "--tw-ring-opacity"),
                        "--tw-ring-offset-shadow": `var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)`,
                        "--tw-ring-shadow": `var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)`,
                        "box-shadow": `var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)`,
                        "border-color": $cee9b48d0a30a8e0$var$resolveColor(theme("colors.blue.600", $5pY61.blue[600]), "--tw-border-opacity")
                    }
                }
            },
            {
                base: [
                    "input::placeholder",
                    "textarea::placeholder"
                ],
                class: [
                    ".form-input::placeholder",
                    ".form-textarea::placeholder"
                ],
                styles: {
                    color: $cee9b48d0a30a8e0$var$resolveColor(theme("colors.gray.500", $5pY61.gray[500]), "--tw-text-opacity"),
                    opacity: "1"
                }
            },
            {
                base: [
                    "::-webkit-datetime-edit-fields-wrapper"
                ],
                class: [
                    ".form-input::-webkit-datetime-edit-fields-wrapper"
                ],
                styles: {
                    padding: "0"
                }
            },
            {
                // Unfortunate hack until https://bugs.webkit.org/show_bug.cgi?id=198959 is fixed.
                // This sucks because users can't change line-height with a utility on date inputs now.
                // Reference: https://github.com/twbs/bootstrap/pull/31993
                base: [
                    "::-webkit-date-and-time-value"
                ],
                class: [
                    ".form-input::-webkit-date-and-time-value"
                ],
                styles: {
                    "min-height": "1.5em"
                }
            },
            {
                // In Safari on iOS date and time inputs are centered instead of left-aligned and can't be
                // changed with `text-align` utilities on the input by default. Resetting this to `inherit`
                // makes them left-aligned by default and makes it possible to override the alignment with
                // utility classes without using an arbitrary variant to target the pseudo-elements.
                base: [
                    "::-webkit-date-and-time-value"
                ],
                class: [
                    ".form-input::-webkit-date-and-time-value"
                ],
                styles: {
                    "text-align": "inherit"
                }
            },
            {
                // In Safari on macOS date time inputs that are set to `display: block` have unexpected
                // extra bottom spacing. This can be corrected by setting the `::-webkit-datetime-edit`
                // pseudo-element to `display: inline-flex`, instead of the browser default of
                // `display: inline-block`.
                base: [
                    "::-webkit-datetime-edit"
                ],
                class: [
                    ".form-input::-webkit-datetime-edit"
                ],
                styles: {
                    display: "inline-flex"
                }
            },
            {
                // In Safari on macOS date time inputs are 4px taller than normal inputs
                // This is because there is extra padding on the datetime-edit and datetime-edit-{part}-field pseudo elements
                // See https://github.com/tailwindlabs/tailwindcss-forms/issues/95
                base: [
                    "::-webkit-datetime-edit",
                    "::-webkit-datetime-edit-year-field",
                    "::-webkit-datetime-edit-month-field",
                    "::-webkit-datetime-edit-day-field",
                    "::-webkit-datetime-edit-hour-field",
                    "::-webkit-datetime-edit-minute-field",
                    "::-webkit-datetime-edit-second-field",
                    "::-webkit-datetime-edit-millisecond-field",
                    "::-webkit-datetime-edit-meridiem-field"
                ],
                class: [
                    ".form-input::-webkit-datetime-edit",
                    ".form-input::-webkit-datetime-edit-year-field",
                    ".form-input::-webkit-datetime-edit-month-field",
                    ".form-input::-webkit-datetime-edit-day-field",
                    ".form-input::-webkit-datetime-edit-hour-field",
                    ".form-input::-webkit-datetime-edit-minute-field",
                    ".form-input::-webkit-datetime-edit-second-field",
                    ".form-input::-webkit-datetime-edit-millisecond-field",
                    ".form-input::-webkit-datetime-edit-meridiem-field"
                ],
                styles: {
                    "padding-top": 0,
                    "padding-bottom": 0
                }
            },
            {
                base: [
                    "select"
                ],
                class: [
                    ".form-select"
                ],
                styles: {
                    "background-image": `url("${$lbtLX(`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path stroke="${$cee9b48d0a30a8e0$var$resolveColor(theme("colors.gray.500", $5pY61.gray[500]), "--tw-stroke-opacity")}" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 8l4 4 4-4"/></svg>`)}")`,
                    "background-position": `right ${$cee9b48d0a30a8e0$var$spacing[2]} center`,
                    "background-repeat": `no-repeat`,
                    "background-size": `1.5em 1.5em`,
                    "padding-right": $cee9b48d0a30a8e0$var$spacing[10],
                    "print-color-adjust": `exact`
                }
            },
            {
                base: [
                    "[multiple]",
                    '[size]:where(select:not([size="1"]))'
                ],
                class: [
                    '.form-select:where([size]:not([size="1"]))'
                ],
                styles: {
                    "background-image": "initial",
                    "background-position": "initial",
                    "background-repeat": "unset",
                    "background-size": "initial",
                    "padding-right": $cee9b48d0a30a8e0$var$spacing[3],
                    "print-color-adjust": "unset"
                }
            },
            {
                base: [
                    `[type='checkbox']`,
                    `[type='radio']`
                ],
                class: [
                    ".form-checkbox",
                    ".form-radio"
                ],
                styles: {
                    appearance: "none",
                    padding: "0",
                    "print-color-adjust": "exact",
                    display: "inline-block",
                    "vertical-align": "middle",
                    "background-origin": "border-box",
                    "user-select": "none",
                    "flex-shrink": "0",
                    height: $cee9b48d0a30a8e0$var$spacing[4],
                    width: $cee9b48d0a30a8e0$var$spacing[4],
                    color: $cee9b48d0a30a8e0$var$resolveColor(theme("colors.blue.600", $5pY61.blue[600]), "--tw-text-opacity"),
                    "background-color": "#fff",
                    "border-color": $cee9b48d0a30a8e0$var$resolveColor(theme("colors.gray.500", $5pY61.gray[500]), "--tw-border-opacity"),
                    "border-width": $cee9b48d0a30a8e0$var$borderWidth["DEFAULT"],
                    "--tw-shadow": "0 0 #0000"
                }
            },
            {
                base: [
                    `[type='checkbox']`
                ],
                class: [
                    ".form-checkbox"
                ],
                styles: {
                    "border-radius": $cee9b48d0a30a8e0$var$borderRadius["none"]
                }
            },
            {
                base: [
                    `[type='radio']`
                ],
                class: [
                    ".form-radio"
                ],
                styles: {
                    "border-radius": "100%"
                }
            },
            {
                base: [
                    `[type='checkbox']:focus`,
                    `[type='radio']:focus`
                ],
                class: [
                    ".form-checkbox:focus",
                    ".form-radio:focus"
                ],
                styles: {
                    outline: "2px solid transparent",
                    "outline-offset": "2px",
                    "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
                    "--tw-ring-offset-width": "2px",
                    "--tw-ring-offset-color": "#fff",
                    "--tw-ring-color": $cee9b48d0a30a8e0$var$resolveColor(theme("colors.blue.600", $5pY61.blue[600]), "--tw-ring-opacity"),
                    "--tw-ring-offset-shadow": `var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)`,
                    "--tw-ring-shadow": `var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)`,
                    "box-shadow": `var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)`
                }
            },
            {
                base: [
                    `[type='checkbox']:checked`,
                    `[type='radio']:checked`
                ],
                class: [
                    ".form-checkbox:checked",
                    ".form-radio:checked"
                ],
                styles: {
                    "border-color": `transparent`,
                    "background-color": `currentColor`,
                    "background-size": `100% 100%`,
                    "background-position": `center`,
                    "background-repeat": `no-repeat`
                }
            },
            {
                base: [
                    `[type='checkbox']:checked`
                ],
                class: [
                    ".form-checkbox:checked"
                ],
                styles: {
                    "background-image": `url("${$lbtLX(`<svg viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><path d="M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z"/></svg>`)}")`,
                    "@media (forced-colors: active) ": {
                        appearance: "auto"
                    }
                }
            },
            {
                base: [
                    `[type='radio']:checked`
                ],
                class: [
                    ".form-radio:checked"
                ],
                styles: {
                    "background-image": `url("${$lbtLX(`<svg viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="3"/></svg>`)}")`,
                    "@media (forced-colors: active) ": {
                        appearance: "auto"
                    }
                }
            },
            {
                base: [
                    `[type='checkbox']:checked:hover`,
                    `[type='checkbox']:checked:focus`,
                    `[type='radio']:checked:hover`,
                    `[type='radio']:checked:focus`
                ],
                class: [
                    ".form-checkbox:checked:hover",
                    ".form-checkbox:checked:focus",
                    ".form-radio:checked:hover",
                    ".form-radio:checked:focus"
                ],
                styles: {
                    "border-color": "transparent",
                    "background-color": "currentColor"
                }
            },
            {
                base: [
                    `[type='checkbox']:indeterminate`
                ],
                class: [
                    ".form-checkbox:indeterminate"
                ],
                styles: {
                    "background-image": `url("${$lbtLX(`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h8"/></svg>`)}")`,
                    "border-color": `transparent`,
                    "background-color": `currentColor`,
                    "background-size": `100% 100%`,
                    "background-position": `center`,
                    "background-repeat": `no-repeat`,
                    "@media (forced-colors: active) ": {
                        appearance: "auto"
                    }
                }
            },
            {
                base: [
                    `[type='checkbox']:indeterminate:hover`,
                    `[type='checkbox']:indeterminate:focus`
                ],
                class: [
                    ".form-checkbox:indeterminate:hover",
                    ".form-checkbox:indeterminate:focus"
                ],
                styles: {
                    "border-color": "transparent",
                    "background-color": "currentColor"
                }
            },
            {
                base: [
                    `[type='file']`
                ],
                class: null,
                styles: {
                    background: "unset",
                    "border-color": "inherit",
                    "border-width": "0",
                    "border-radius": "0",
                    padding: "0",
                    "font-size": "unset",
                    "line-height": "inherit"
                }
            },
            {
                base: [
                    `[type='file']:focus`
                ],
                class: null,
                styles: {
                    outline: [
                        `1px solid ButtonText`,
                        `1px auto -webkit-focus-ring-color`
                    ]
                }
            }
        ];
        const getStrategyRules = (strategy)=>rules.map((rule)=>{
                if (rule[strategy] === null) return null;
                return {
                    [rule[strategy]]: rule.styles
                };
            }).filter(Boolean);
        if (strategy.includes("base")) addBase(getStrategyRules("base"));
        if (strategy.includes("class")) addComponents(getStrategyRules("class"));
    };
});
module.exports = $cee9b48d0a30a8e0$var$forms;

});
parcelRegister("lbtLX", function(module, exports) {

var $16UoX = parcelRequire("16UoX");
var $f6c1b841fb12b616$var$REGEX = {
    whitespace: /\s+/g,
    urlHexPairs: /%[\dA-F]{2}/g,
    quotes: /"/g
};
function $f6c1b841fb12b616$var$collapseWhitespace(str) {
    return str.trim().replace($f6c1b841fb12b616$var$REGEX.whitespace, " ");
}
function $f6c1b841fb12b616$var$dataURIPayload(string) {
    return encodeURIComponent(string).replace($f6c1b841fb12b616$var$REGEX.urlHexPairs, $f6c1b841fb12b616$var$specialHexEncode);
}
// `#` gets converted to `%23`, so quite a few CSS named colors are shorter than
// their equivalent URL-encoded hex codes.
function $f6c1b841fb12b616$var$colorCodeToShorterNames(string) {
    Object.keys($16UoX).forEach(function(key) {
        if ($16UoX[key].test(string)) string = string.replace($16UoX[key], key);
    });
    return string;
}
function $f6c1b841fb12b616$var$specialHexEncode(match) {
    switch(match){
        case "%20":
            return " ";
        case "%3D":
            return "=";
        case "%3A":
            return ":";
        case "%2F":
            return "/";
        default:
            return match.toLowerCase(); // compresses better
    }
}
function $f6c1b841fb12b616$var$svgToTinyDataUri(svgString) {
    if (typeof svgString !== "string") throw new TypeError("Expected a string, but received " + typeof svgString);
    // Strip the Byte-Order Mark if the SVG has one
    if (svgString.charCodeAt(0) === 0xfeff) svgString = svgString.slice(1);
    var body = $f6c1b841fb12b616$var$colorCodeToShorterNames($f6c1b841fb12b616$var$collapseWhitespace(svgString)).replace($f6c1b841fb12b616$var$REGEX.quotes, "'");
    return "data:image/svg+xml," + $f6c1b841fb12b616$var$dataURIPayload(body);
}
$f6c1b841fb12b616$var$svgToTinyDataUri.toSrcset = function toSrcset(svgString) {
    return $f6c1b841fb12b616$var$svgToTinyDataUri(svgString).replace(/ /g, "%20");
};
module.exports = $f6c1b841fb12b616$var$svgToTinyDataUri;

});
parcelRegister("16UoX", function(module, exports) {
module.exports = {
    aqua: /#00ffff(ff)?(?!\w)|#0ff(f)?(?!\w)/gi,
    azure: /#f0ffff(ff)?(?!\w)/gi,
    beige: /#f5f5dc(ff)?(?!\w)/gi,
    bisque: /#ffe4c4(ff)?(?!\w)/gi,
    black: /#000000(ff)?(?!\w)|#000(f)?(?!\w)/gi,
    blue: /#0000ff(ff)?(?!\w)|#00f(f)?(?!\w)/gi,
    brown: /#a52a2a(ff)?(?!\w)/gi,
    coral: /#ff7f50(ff)?(?!\w)/gi,
    cornsilk: /#fff8dc(ff)?(?!\w)/gi,
    crimson: /#dc143c(ff)?(?!\w)/gi,
    cyan: /#00ffff(ff)?(?!\w)|#0ff(f)?(?!\w)/gi,
    darkblue: /#00008b(ff)?(?!\w)/gi,
    darkcyan: /#008b8b(ff)?(?!\w)/gi,
    darkgrey: /#a9a9a9(ff)?(?!\w)/gi,
    darkred: /#8b0000(ff)?(?!\w)/gi,
    deeppink: /#ff1493(ff)?(?!\w)/gi,
    dimgrey: /#696969(ff)?(?!\w)/gi,
    gold: /#ffd700(ff)?(?!\w)/gi,
    green: /#008000(ff)?(?!\w)/gi,
    grey: /#808080(ff)?(?!\w)/gi,
    honeydew: /#f0fff0(ff)?(?!\w)/gi,
    hotpink: /#ff69b4(ff)?(?!\w)/gi,
    indigo: /#4b0082(ff)?(?!\w)/gi,
    ivory: /#fffff0(ff)?(?!\w)/gi,
    khaki: /#f0e68c(ff)?(?!\w)/gi,
    lavender: /#e6e6fa(ff)?(?!\w)/gi,
    lime: /#00ff00(ff)?(?!\w)|#0f0(f)?(?!\w)/gi,
    linen: /#faf0e6(ff)?(?!\w)/gi,
    maroon: /#800000(ff)?(?!\w)/gi,
    moccasin: /#ffe4b5(ff)?(?!\w)/gi,
    navy: /#000080(ff)?(?!\w)/gi,
    oldlace: /#fdf5e6(ff)?(?!\w)/gi,
    olive: /#808000(ff)?(?!\w)/gi,
    orange: /#ffa500(ff)?(?!\w)/gi,
    orchid: /#da70d6(ff)?(?!\w)/gi,
    peru: /#cd853f(ff)?(?!\w)/gi,
    pink: /#ffc0cb(ff)?(?!\w)/gi,
    plum: /#dda0dd(ff)?(?!\w)/gi,
    purple: /#800080(ff)?(?!\w)/gi,
    red: /#ff0000(ff)?(?!\w)|#f00(f)?(?!\w)/gi,
    salmon: /#fa8072(ff)?(?!\w)/gi,
    seagreen: /#2e8b57(ff)?(?!\w)/gi,
    seashell: /#fff5ee(ff)?(?!\w)/gi,
    sienna: /#a0522d(ff)?(?!\w)/gi,
    silver: /#c0c0c0(ff)?(?!\w)/gi,
    skyblue: /#87ceeb(ff)?(?!\w)/gi,
    snow: /#fffafa(ff)?(?!\w)/gi,
    tan: /#d2b48c(ff)?(?!\w)/gi,
    teal: /#008080(ff)?(?!\w)/gi,
    thistle: /#d8bfd8(ff)?(?!\w)/gi,
    tomato: /#ff6347(ff)?(?!\w)/gi,
    violet: /#ee82ee(ff)?(?!\w)/gi,
    wheat: /#f5deb3(ff)?(?!\w)/gi,
    white: /#ffffff(ff)?(?!\w)|#fff(f)?(?!\w)/gi
};

});


parcelRegister("8lbaV", function(module, exports) {

var $8WBdE = parcelRequire("8WBdE");
module.exports = ($8WBdE.__esModule ? $8WBdE : {
    default: $8WBdE
}).default;

});
parcelRegister("8WBdE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $68309c70610faae3$var$_default;
    }
});

const $68309c70610faae3$var$_createPlugin = /*#__PURE__*/ $68309c70610faae3$var$_interop_require_default((parcelRequire("3cejm")));
function $68309c70610faae3$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $68309c70610faae3$var$_default = $68309c70610faae3$var$_createPlugin.default;

});
parcelRegister("3cejm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $253d97ffc5d4aad4$var$_default;
    }
});
function $253d97ffc5d4aad4$var$createPlugin(plugin, config) {
    return {
        handler: plugin,
        config: config
    };
}
$253d97ffc5d4aad4$var$createPlugin.withOptions = function(pluginFunction, configFunction = ()=>({})) {
    const optionsFunction = function(options) {
        return {
            __options: options,
            handler: pluginFunction(options),
            config: configFunction(options)
        };
    };
    optionsFunction.__isOptionsFunction = true;
    // Expose plugin dependencies so that `object-hash` returns a different
    // value if anything here changes, to ensure a rebuild is triggered.
    optionsFunction.__pluginFunction = pluginFunction;
    optionsFunction.__configFunction = configFunction;
    return optionsFunction;
};
const $253d97ffc5d4aad4$var$_default = $253d97ffc5d4aad4$var$createPlugin;

});



parcelRegister("byT7c", function(module, exports) {

var $jX1R5 = parcelRequire("jX1R5");
module.exports = ($jX1R5.__esModule ? $jX1R5 : {
    default: $jX1R5
}).default;

});
parcelRegister("jX1R5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e864f76c33337421$var$_default;
    }
});

var $cvNqS = parcelRequire("cvNqS");

const $e864f76c33337421$var$_configfull = /*#__PURE__*/ $e864f76c33337421$var$_interop_require_default((parcelRequire("lqERx")));
function $e864f76c33337421$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e864f76c33337421$var$_default = (0, $cvNqS.cloneDeep)($e864f76c33337421$var$_configfull.default.theme);

});
parcelRegister("cvNqS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "cloneDeep", {
    enumerable: true,
    get: function() {
        return $91beb98971690b40$var$cloneDeep;
    }
});
function $91beb98971690b40$var$cloneDeep(value) {
    if (Array.isArray(value)) return value.map((child)=>$91beb98971690b40$var$cloneDeep(child));
    if (typeof value === "object" && value !== null) return Object.fromEntries(Object.entries(value).map(([k, v])=>[
            k,
            $91beb98971690b40$var$cloneDeep(v)
        ]));
    return value;
}

});

parcelRegister("lqERx", function(module, exports) {
module.exports = {
    content: [],
    presets: [],
    darkMode: "media",
    theme: {
        accentColor: ({ theme: theme })=>({
                ...theme("colors"),
                auto: "auto"
            }),
        animation: {
            none: "none",
            spin: "spin 1s linear infinite",
            ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
            pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
            bounce: "bounce 1s infinite"
        },
        aria: {
            busy: 'busy="true"',
            checked: 'checked="true"',
            disabled: 'disabled="true"',
            expanded: 'expanded="true"',
            hidden: 'hidden="true"',
            pressed: 'pressed="true"',
            readonly: 'readonly="true"',
            required: 'required="true"',
            selected: 'selected="true"'
        },
        aspectRatio: {
            auto: "auto",
            square: "1 / 1",
            video: "16 / 9"
        },
        backdropBlur: ({ theme: theme })=>theme("blur"),
        backdropBrightness: ({ theme: theme })=>theme("brightness"),
        backdropContrast: ({ theme: theme })=>theme("contrast"),
        backdropGrayscale: ({ theme: theme })=>theme("grayscale"),
        backdropHueRotate: ({ theme: theme })=>theme("hueRotate"),
        backdropInvert: ({ theme: theme })=>theme("invert"),
        backdropOpacity: ({ theme: theme })=>theme("opacity"),
        backdropSaturate: ({ theme: theme })=>theme("saturate"),
        backdropSepia: ({ theme: theme })=>theme("sepia"),
        backgroundColor: ({ theme: theme })=>theme("colors"),
        backgroundImage: {
            none: "none",
            "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
            "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
            "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
            "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
            "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
            "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
            "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
            "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
        },
        backgroundOpacity: ({ theme: theme })=>theme("opacity"),
        backgroundPosition: {
            bottom: "bottom",
            center: "center",
            left: "left",
            "left-bottom": "left bottom",
            "left-top": "left top",
            right: "right",
            "right-bottom": "right bottom",
            "right-top": "right top",
            top: "top"
        },
        backgroundSize: {
            auto: "auto",
            cover: "cover",
            contain: "contain"
        },
        blur: {
            0: "0",
            none: "0",
            sm: "4px",
            DEFAULT: "8px",
            md: "12px",
            lg: "16px",
            xl: "24px",
            "2xl": "40px",
            "3xl": "64px"
        },
        borderColor: ({ theme: theme })=>({
                ...theme("colors"),
                DEFAULT: theme("colors.gray.200", "currentColor")
            }),
        borderOpacity: ({ theme: theme })=>theme("opacity"),
        borderRadius: {
            none: "0px",
            sm: "0.125rem",
            DEFAULT: "0.25rem",
            md: "0.375rem",
            lg: "0.5rem",
            xl: "0.75rem",
            "2xl": "1rem",
            "3xl": "1.5rem",
            full: "9999px"
        },
        borderSpacing: ({ theme: theme })=>({
                ...theme("spacing")
            }),
        borderWidth: {
            DEFAULT: "1px",
            0: "0px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        boxShadow: {
            sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
            DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
            md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
            lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
            xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
            "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
            inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
            none: "none"
        },
        boxShadowColor: ({ theme: theme })=>theme("colors"),
        brightness: {
            0: "0",
            50: ".5",
            75: ".75",
            90: ".9",
            95: ".95",
            100: "1",
            105: "1.05",
            110: "1.1",
            125: "1.25",
            150: "1.5",
            200: "2"
        },
        caretColor: ({ theme: theme })=>theme("colors"),
        colors: ({ colors: colors })=>({
                inherit: colors.inherit,
                current: colors.current,
                transparent: colors.transparent,
                black: colors.black,
                white: colors.white,
                slate: colors.slate,
                gray: colors.gray,
                zinc: colors.zinc,
                neutral: colors.neutral,
                stone: colors.stone,
                red: colors.red,
                orange: colors.orange,
                amber: colors.amber,
                yellow: colors.yellow,
                lime: colors.lime,
                green: colors.green,
                emerald: colors.emerald,
                teal: colors.teal,
                cyan: colors.cyan,
                sky: colors.sky,
                blue: colors.blue,
                indigo: colors.indigo,
                violet: colors.violet,
                purple: colors.purple,
                fuchsia: colors.fuchsia,
                pink: colors.pink,
                rose: colors.rose
            }),
        columns: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            "3xs": "16rem",
            "2xs": "18rem",
            xs: "20rem",
            sm: "24rem",
            md: "28rem",
            lg: "32rem",
            xl: "36rem",
            "2xl": "42rem",
            "3xl": "48rem",
            "4xl": "56rem",
            "5xl": "64rem",
            "6xl": "72rem",
            "7xl": "80rem"
        },
        container: {},
        content: {
            none: "none"
        },
        contrast: {
            0: "0",
            50: ".5",
            75: ".75",
            100: "1",
            125: "1.25",
            150: "1.5",
            200: "2"
        },
        cursor: {
            auto: "auto",
            default: "default",
            pointer: "pointer",
            wait: "wait",
            text: "text",
            move: "move",
            help: "help",
            "not-allowed": "not-allowed",
            none: "none",
            "context-menu": "context-menu",
            progress: "progress",
            cell: "cell",
            crosshair: "crosshair",
            "vertical-text": "vertical-text",
            alias: "alias",
            copy: "copy",
            "no-drop": "no-drop",
            grab: "grab",
            grabbing: "grabbing",
            "all-scroll": "all-scroll",
            "col-resize": "col-resize",
            "row-resize": "row-resize",
            "n-resize": "n-resize",
            "e-resize": "e-resize",
            "s-resize": "s-resize",
            "w-resize": "w-resize",
            "ne-resize": "ne-resize",
            "nw-resize": "nw-resize",
            "se-resize": "se-resize",
            "sw-resize": "sw-resize",
            "ew-resize": "ew-resize",
            "ns-resize": "ns-resize",
            "nesw-resize": "nesw-resize",
            "nwse-resize": "nwse-resize",
            "zoom-in": "zoom-in",
            "zoom-out": "zoom-out"
        },
        divideColor: ({ theme: theme })=>theme("borderColor"),
        divideOpacity: ({ theme: theme })=>theme("borderOpacity"),
        divideWidth: ({ theme: theme })=>theme("borderWidth"),
        dropShadow: {
            sm: "0 1px 1px rgb(0 0 0 / 0.05)",
            DEFAULT: [
                "0 1px 2px rgb(0 0 0 / 0.1)",
                "0 1px 1px rgb(0 0 0 / 0.06)"
            ],
            md: [
                "0 4px 3px rgb(0 0 0 / 0.07)",
                "0 2px 2px rgb(0 0 0 / 0.06)"
            ],
            lg: [
                "0 10px 8px rgb(0 0 0 / 0.04)",
                "0 4px 3px rgb(0 0 0 / 0.1)"
            ],
            xl: [
                "0 20px 13px rgb(0 0 0 / 0.03)",
                "0 8px 5px rgb(0 0 0 / 0.08)"
            ],
            "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
            none: "0 0 #0000"
        },
        fill: ({ theme: theme })=>({
                none: "none",
                ...theme("colors")
            }),
        flex: {
            1: "1 1 0%",
            auto: "1 1 auto",
            initial: "0 1 auto",
            none: "none"
        },
        flexBasis: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                "1/5": "20%",
                "2/5": "40%",
                "3/5": "60%",
                "4/5": "80%",
                "1/6": "16.666667%",
                "2/6": "33.333333%",
                "3/6": "50%",
                "4/6": "66.666667%",
                "5/6": "83.333333%",
                "1/12": "8.333333%",
                "2/12": "16.666667%",
                "3/12": "25%",
                "4/12": "33.333333%",
                "5/12": "41.666667%",
                "6/12": "50%",
                "7/12": "58.333333%",
                "8/12": "66.666667%",
                "9/12": "75%",
                "10/12": "83.333333%",
                "11/12": "91.666667%",
                full: "100%"
            }),
        flexGrow: {
            0: "0",
            DEFAULT: "1"
        },
        flexShrink: {
            0: "0",
            DEFAULT: "1"
        },
        fontFamily: {
            sans: [
                "ui-sans-serif",
                "system-ui",
                "sans-serif",
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
                '"Noto Color Emoji"'
            ],
            serif: [
                "ui-serif",
                "Georgia",
                "Cambria",
                '"Times New Roman"',
                "Times",
                "serif"
            ],
            mono: [
                "ui-monospace",
                "SFMono-Regular",
                "Menlo",
                "Monaco",
                "Consolas",
                '"Liberation Mono"',
                '"Courier New"',
                "monospace"
            ]
        },
        fontSize: {
            xs: [
                "0.75rem",
                {
                    lineHeight: "1rem"
                }
            ],
            sm: [
                "0.875rem",
                {
                    lineHeight: "1.25rem"
                }
            ],
            base: [
                "1rem",
                {
                    lineHeight: "1.5rem"
                }
            ],
            lg: [
                "1.125rem",
                {
                    lineHeight: "1.75rem"
                }
            ],
            xl: [
                "1.25rem",
                {
                    lineHeight: "1.75rem"
                }
            ],
            "2xl": [
                "1.5rem",
                {
                    lineHeight: "2rem"
                }
            ],
            "3xl": [
                "1.875rem",
                {
                    lineHeight: "2.25rem"
                }
            ],
            "4xl": [
                "2.25rem",
                {
                    lineHeight: "2.5rem"
                }
            ],
            "5xl": [
                "3rem",
                {
                    lineHeight: "1"
                }
            ],
            "6xl": [
                "3.75rem",
                {
                    lineHeight: "1"
                }
            ],
            "7xl": [
                "4.5rem",
                {
                    lineHeight: "1"
                }
            ],
            "8xl": [
                "6rem",
                {
                    lineHeight: "1"
                }
            ],
            "9xl": [
                "8rem",
                {
                    lineHeight: "1"
                }
            ]
        },
        fontWeight: {
            thin: "100",
            extralight: "200",
            light: "300",
            normal: "400",
            medium: "500",
            semibold: "600",
            bold: "700",
            extrabold: "800",
            black: "900"
        },
        gap: ({ theme: theme })=>theme("spacing"),
        gradientColorStops: ({ theme: theme })=>theme("colors"),
        gradientColorStopPositions: {
            "0%": "0%",
            "5%": "5%",
            "10%": "10%",
            "15%": "15%",
            "20%": "20%",
            "25%": "25%",
            "30%": "30%",
            "35%": "35%",
            "40%": "40%",
            "45%": "45%",
            "50%": "50%",
            "55%": "55%",
            "60%": "60%",
            "65%": "65%",
            "70%": "70%",
            "75%": "75%",
            "80%": "80%",
            "85%": "85%",
            "90%": "90%",
            "95%": "95%",
            "100%": "100%"
        },
        grayscale: {
            0: "0",
            DEFAULT: "100%"
        },
        gridAutoColumns: {
            auto: "auto",
            min: "min-content",
            max: "max-content",
            fr: "minmax(0, 1fr)"
        },
        gridAutoRows: {
            auto: "auto",
            min: "min-content",
            max: "max-content",
            fr: "minmax(0, 1fr)"
        },
        gridColumn: {
            auto: "auto",
            "span-1": "span 1 / span 1",
            "span-2": "span 2 / span 2",
            "span-3": "span 3 / span 3",
            "span-4": "span 4 / span 4",
            "span-5": "span 5 / span 5",
            "span-6": "span 6 / span 6",
            "span-7": "span 7 / span 7",
            "span-8": "span 8 / span 8",
            "span-9": "span 9 / span 9",
            "span-10": "span 10 / span 10",
            "span-11": "span 11 / span 11",
            "span-12": "span 12 / span 12",
            "span-full": "1 / -1"
        },
        gridColumnEnd: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13"
        },
        gridColumnStart: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13"
        },
        gridRow: {
            auto: "auto",
            "span-1": "span 1 / span 1",
            "span-2": "span 2 / span 2",
            "span-3": "span 3 / span 3",
            "span-4": "span 4 / span 4",
            "span-5": "span 5 / span 5",
            "span-6": "span 6 / span 6",
            "span-7": "span 7 / span 7",
            "span-8": "span 8 / span 8",
            "span-9": "span 9 / span 9",
            "span-10": "span 10 / span 10",
            "span-11": "span 11 / span 11",
            "span-12": "span 12 / span 12",
            "span-full": "1 / -1"
        },
        gridRowEnd: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13"
        },
        gridRowStart: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13"
        },
        gridTemplateColumns: {
            none: "none",
            subgrid: "subgrid",
            1: "repeat(1, minmax(0, 1fr))",
            2: "repeat(2, minmax(0, 1fr))",
            3: "repeat(3, minmax(0, 1fr))",
            4: "repeat(4, minmax(0, 1fr))",
            5: "repeat(5, minmax(0, 1fr))",
            6: "repeat(6, minmax(0, 1fr))",
            7: "repeat(7, minmax(0, 1fr))",
            8: "repeat(8, minmax(0, 1fr))",
            9: "repeat(9, minmax(0, 1fr))",
            10: "repeat(10, minmax(0, 1fr))",
            11: "repeat(11, minmax(0, 1fr))",
            12: "repeat(12, minmax(0, 1fr))"
        },
        gridTemplateRows: {
            none: "none",
            subgrid: "subgrid",
            1: "repeat(1, minmax(0, 1fr))",
            2: "repeat(2, minmax(0, 1fr))",
            3: "repeat(3, minmax(0, 1fr))",
            4: "repeat(4, minmax(0, 1fr))",
            5: "repeat(5, minmax(0, 1fr))",
            6: "repeat(6, minmax(0, 1fr))",
            7: "repeat(7, minmax(0, 1fr))",
            8: "repeat(8, minmax(0, 1fr))",
            9: "repeat(9, minmax(0, 1fr))",
            10: "repeat(10, minmax(0, 1fr))",
            11: "repeat(11, minmax(0, 1fr))",
            12: "repeat(12, minmax(0, 1fr))"
        },
        height: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                "1/5": "20%",
                "2/5": "40%",
                "3/5": "60%",
                "4/5": "80%",
                "1/6": "16.666667%",
                "2/6": "33.333333%",
                "3/6": "50%",
                "4/6": "66.666667%",
                "5/6": "83.333333%",
                full: "100%",
                screen: "100vh",
                svh: "100svh",
                lvh: "100lvh",
                dvh: "100dvh",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        hueRotate: {
            0: "0deg",
            15: "15deg",
            30: "30deg",
            60: "60deg",
            90: "90deg",
            180: "180deg"
        },
        inset: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                full: "100%"
            }),
        invert: {
            0: "0",
            DEFAULT: "100%"
        },
        keyframes: {
            spin: {
                to: {
                    transform: "rotate(360deg)"
                }
            },
            ping: {
                "75%, 100%": {
                    transform: "scale(2)",
                    opacity: "0"
                }
            },
            pulse: {
                "50%": {
                    opacity: ".5"
                }
            },
            bounce: {
                "0%, 100%": {
                    transform: "translateY(-25%)",
                    animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
                },
                "50%": {
                    transform: "none",
                    animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
                }
            }
        },
        letterSpacing: {
            tighter: "-0.05em",
            tight: "-0.025em",
            normal: "0em",
            wide: "0.025em",
            wider: "0.05em",
            widest: "0.1em"
        },
        lineHeight: {
            none: "1",
            tight: "1.25",
            snug: "1.375",
            normal: "1.5",
            relaxed: "1.625",
            loose: "2",
            3: ".75rem",
            4: "1rem",
            5: "1.25rem",
            6: "1.5rem",
            7: "1.75rem",
            8: "2rem",
            9: "2.25rem",
            10: "2.5rem"
        },
        listStyleType: {
            none: "none",
            disc: "disc",
            decimal: "decimal"
        },
        listStyleImage: {
            none: "none"
        },
        margin: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing")
            }),
        lineClamp: {
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6"
        },
        maxHeight: ({ theme: theme })=>({
                ...theme("spacing"),
                none: "none",
                full: "100%",
                screen: "100vh",
                svh: "100svh",
                lvh: "100lvh",
                dvh: "100dvh",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        maxWidth: ({ theme: theme, breakpoints: breakpoints })=>({
                ...theme("spacing"),
                none: "none",
                xs: "20rem",
                sm: "24rem",
                md: "28rem",
                lg: "32rem",
                xl: "36rem",
                "2xl": "42rem",
                "3xl": "48rem",
                "4xl": "56rem",
                "5xl": "64rem",
                "6xl": "72rem",
                "7xl": "80rem",
                full: "100%",
                min: "min-content",
                max: "max-content",
                fit: "fit-content",
                prose: "65ch",
                ...breakpoints(theme("screens"))
            }),
        minHeight: ({ theme: theme })=>({
                ...theme("spacing"),
                full: "100%",
                screen: "100vh",
                svh: "100svh",
                lvh: "100lvh",
                dvh: "100dvh",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        minWidth: ({ theme: theme })=>({
                ...theme("spacing"),
                full: "100%",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        objectPosition: {
            bottom: "bottom",
            center: "center",
            left: "left",
            "left-bottom": "left bottom",
            "left-top": "left top",
            right: "right",
            "right-bottom": "right bottom",
            "right-top": "right top",
            top: "top"
        },
        opacity: {
            0: "0",
            5: "0.05",
            10: "0.1",
            15: "0.15",
            20: "0.2",
            25: "0.25",
            30: "0.3",
            35: "0.35",
            40: "0.4",
            45: "0.45",
            50: "0.5",
            55: "0.55",
            60: "0.6",
            65: "0.65",
            70: "0.7",
            75: "0.75",
            80: "0.8",
            85: "0.85",
            90: "0.9",
            95: "0.95",
            100: "1"
        },
        order: {
            first: "-9999",
            last: "9999",
            none: "0",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12"
        },
        outlineColor: ({ theme: theme })=>theme("colors"),
        outlineOffset: {
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        outlineWidth: {
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        padding: ({ theme: theme })=>theme("spacing"),
        placeholderColor: ({ theme: theme })=>theme("colors"),
        placeholderOpacity: ({ theme: theme })=>theme("opacity"),
        ringColor: ({ theme: theme })=>({
                DEFAULT: theme("colors.blue.500", "#3b82f6"),
                ...theme("colors")
            }),
        ringOffsetColor: ({ theme: theme })=>theme("colors"),
        ringOffsetWidth: {
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        ringOpacity: ({ theme: theme })=>({
                DEFAULT: "0.5",
                ...theme("opacity")
            }),
        ringWidth: {
            DEFAULT: "3px",
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        rotate: {
            0: "0deg",
            1: "1deg",
            2: "2deg",
            3: "3deg",
            6: "6deg",
            12: "12deg",
            45: "45deg",
            90: "90deg",
            180: "180deg"
        },
        saturate: {
            0: "0",
            50: ".5",
            100: "1",
            150: "1.5",
            200: "2"
        },
        scale: {
            0: "0",
            50: ".5",
            75: ".75",
            90: ".9",
            95: ".95",
            100: "1",
            105: "1.05",
            110: "1.1",
            125: "1.25",
            150: "1.5"
        },
        screens: {
            sm: "640px",
            md: "768px",
            lg: "1024px",
            xl: "1280px",
            "2xl": "1536px"
        },
        scrollMargin: ({ theme: theme })=>({
                ...theme("spacing")
            }),
        scrollPadding: ({ theme: theme })=>theme("spacing"),
        sepia: {
            0: "0",
            DEFAULT: "100%"
        },
        skew: {
            0: "0deg",
            1: "1deg",
            2: "2deg",
            3: "3deg",
            6: "6deg",
            12: "12deg"
        },
        space: ({ theme: theme })=>({
                ...theme("spacing")
            }),
        spacing: {
            px: "1px",
            0: "0px",
            0.5: "0.125rem",
            1: "0.25rem",
            1.5: "0.375rem",
            2: "0.5rem",
            2.5: "0.625rem",
            3: "0.75rem",
            3.5: "0.875rem",
            4: "1rem",
            5: "1.25rem",
            6: "1.5rem",
            7: "1.75rem",
            8: "2rem",
            9: "2.25rem",
            10: "2.5rem",
            11: "2.75rem",
            12: "3rem",
            14: "3.5rem",
            16: "4rem",
            20: "5rem",
            24: "6rem",
            28: "7rem",
            32: "8rem",
            36: "9rem",
            40: "10rem",
            44: "11rem",
            48: "12rem",
            52: "13rem",
            56: "14rem",
            60: "15rem",
            64: "16rem",
            72: "18rem",
            80: "20rem",
            96: "24rem"
        },
        stroke: ({ theme: theme })=>({
                none: "none",
                ...theme("colors")
            }),
        strokeWidth: {
            0: "0",
            1: "1",
            2: "2"
        },
        supports: {},
        data: {},
        textColor: ({ theme: theme })=>theme("colors"),
        textDecorationColor: ({ theme: theme })=>theme("colors"),
        textDecorationThickness: {
            auto: "auto",
            "from-font": "from-font",
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        textIndent: ({ theme: theme })=>({
                ...theme("spacing")
            }),
        textOpacity: ({ theme: theme })=>theme("opacity"),
        textUnderlineOffset: {
            auto: "auto",
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        transformOrigin: {
            center: "center",
            top: "top",
            "top-right": "top right",
            right: "right",
            "bottom-right": "bottom right",
            bottom: "bottom",
            "bottom-left": "bottom left",
            left: "left",
            "top-left": "top left"
        },
        transitionDelay: {
            0: "0s",
            75: "75ms",
            100: "100ms",
            150: "150ms",
            200: "200ms",
            300: "300ms",
            500: "500ms",
            700: "700ms",
            1000: "1000ms"
        },
        transitionDuration: {
            DEFAULT: "150ms",
            0: "0s",
            75: "75ms",
            100: "100ms",
            150: "150ms",
            200: "200ms",
            300: "300ms",
            500: "500ms",
            700: "700ms",
            1000: "1000ms"
        },
        transitionProperty: {
            none: "none",
            all: "all",
            DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
            colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
            opacity: "opacity",
            shadow: "box-shadow",
            transform: "transform"
        },
        transitionTimingFunction: {
            DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
            linear: "linear",
            in: "cubic-bezier(0.4, 0, 1, 1)",
            out: "cubic-bezier(0, 0, 0.2, 1)",
            "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
        },
        translate: ({ theme: theme })=>({
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                full: "100%"
            }),
        size: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                "1/5": "20%",
                "2/5": "40%",
                "3/5": "60%",
                "4/5": "80%",
                "1/6": "16.666667%",
                "2/6": "33.333333%",
                "3/6": "50%",
                "4/6": "66.666667%",
                "5/6": "83.333333%",
                "1/12": "8.333333%",
                "2/12": "16.666667%",
                "3/12": "25%",
                "4/12": "33.333333%",
                "5/12": "41.666667%",
                "6/12": "50%",
                "7/12": "58.333333%",
                "8/12": "66.666667%",
                "9/12": "75%",
                "10/12": "83.333333%",
                "11/12": "91.666667%",
                full: "100%",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        width: ({ theme: theme })=>({
                auto: "auto",
                ...theme("spacing"),
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                "1/5": "20%",
                "2/5": "40%",
                "3/5": "60%",
                "4/5": "80%",
                "1/6": "16.666667%",
                "2/6": "33.333333%",
                "3/6": "50%",
                "4/6": "66.666667%",
                "5/6": "83.333333%",
                "1/12": "8.333333%",
                "2/12": "16.666667%",
                "3/12": "25%",
                "4/12": "33.333333%",
                "5/12": "41.666667%",
                "6/12": "50%",
                "7/12": "58.333333%",
                "8/12": "66.666667%",
                "9/12": "75%",
                "10/12": "83.333333%",
                "11/12": "91.666667%",
                full: "100%",
                screen: "100vw",
                svw: "100svw",
                lvw: "100lvw",
                dvw: "100dvw",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        willChange: {
            auto: "auto",
            scroll: "scroll-position",
            contents: "contents",
            transform: "transform"
        },
        zIndex: {
            auto: "auto",
            0: "0",
            10: "10",
            20: "20",
            30: "30",
            40: "40",
            50: "50"
        }
    },
    plugins: []
};

});



parcelRegister("5pY61", function(module, exports) {

var $7ybDy = parcelRequire("7ybDy");
module.exports = ($7ybDy.__esModule ? $7ybDy : {
    default: $7ybDy
}).default;

});
parcelRegister("7ybDy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $57f4bc3f97ccace5$var$_default;
    }
});

const $57f4bc3f97ccace5$var$_log = /*#__PURE__*/ $57f4bc3f97ccace5$var$_interop_require_default((parcelRequire("7pWKZ")));
function $57f4bc3f97ccace5$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $57f4bc3f97ccace5$var$warn({ version: version, from: from, to: to }) {
    $57f4bc3f97ccace5$var$_log.default.warn(`${from}-color-renamed`, [
        `As of Tailwind CSS ${version}, \`${from}\` has been renamed to \`${to}\`.`,
        "Update your configuration file to silence this warning."
    ]);
}
const $57f4bc3f97ccace5$var$_default = {
    inherit: "inherit",
    current: "currentColor",
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    slate: {
        50: "#f8fafc",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b",
        600: "#475569",
        700: "#334155",
        800: "#1e293b",
        900: "#0f172a",
        950: "#020617"
    },
    gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827",
        950: "#030712"
    },
    zinc: {
        50: "#fafafa",
        100: "#f4f4f5",
        200: "#e4e4e7",
        300: "#d4d4d8",
        400: "#a1a1aa",
        500: "#71717a",
        600: "#52525b",
        700: "#3f3f46",
        800: "#27272a",
        900: "#18181b",
        950: "#09090b"
    },
    neutral: {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#e5e5e5",
        300: "#d4d4d4",
        400: "#a3a3a3",
        500: "#737373",
        600: "#525252",
        700: "#404040",
        800: "#262626",
        900: "#171717",
        950: "#0a0a0a"
    },
    stone: {
        50: "#fafaf9",
        100: "#f5f5f4",
        200: "#e7e5e4",
        300: "#d6d3d1",
        400: "#a8a29e",
        500: "#78716c",
        600: "#57534e",
        700: "#44403c",
        800: "#292524",
        900: "#1c1917",
        950: "#0c0a09"
    },
    red: {
        50: "#fef2f2",
        100: "#fee2e2",
        200: "#fecaca",
        300: "#fca5a5",
        400: "#f87171",
        500: "#ef4444",
        600: "#dc2626",
        700: "#b91c1c",
        800: "#991b1b",
        900: "#7f1d1d",
        950: "#450a0a"
    },
    orange: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#fed7aa",
        300: "#fdba74",
        400: "#fb923c",
        500: "#f97316",
        600: "#ea580c",
        700: "#c2410c",
        800: "#9a3412",
        900: "#7c2d12",
        950: "#431407"
    },
    amber: {
        50: "#fffbeb",
        100: "#fef3c7",
        200: "#fde68a",
        300: "#fcd34d",
        400: "#fbbf24",
        500: "#f59e0b",
        600: "#d97706",
        700: "#b45309",
        800: "#92400e",
        900: "#78350f",
        950: "#451a03"
    },
    yellow: {
        50: "#fefce8",
        100: "#fef9c3",
        200: "#fef08a",
        300: "#fde047",
        400: "#facc15",
        500: "#eab308",
        600: "#ca8a04",
        700: "#a16207",
        800: "#854d0e",
        900: "#713f12",
        950: "#422006"
    },
    lime: {
        50: "#f7fee7",
        100: "#ecfccb",
        200: "#d9f99d",
        300: "#bef264",
        400: "#a3e635",
        500: "#84cc16",
        600: "#65a30d",
        700: "#4d7c0f",
        800: "#3f6212",
        900: "#365314",
        950: "#1a2e05"
    },
    green: {
        50: "#f0fdf4",
        100: "#dcfce7",
        200: "#bbf7d0",
        300: "#86efac",
        400: "#4ade80",
        500: "#22c55e",
        600: "#16a34a",
        700: "#15803d",
        800: "#166534",
        900: "#14532d",
        950: "#052e16"
    },
    emerald: {
        50: "#ecfdf5",
        100: "#d1fae5",
        200: "#a7f3d0",
        300: "#6ee7b7",
        400: "#34d399",
        500: "#10b981",
        600: "#059669",
        700: "#047857",
        800: "#065f46",
        900: "#064e3b",
        950: "#022c22"
    },
    teal: {
        50: "#f0fdfa",
        100: "#ccfbf1",
        200: "#99f6e4",
        300: "#5eead4",
        400: "#2dd4bf",
        500: "#14b8a6",
        600: "#0d9488",
        700: "#0f766e",
        800: "#115e59",
        900: "#134e4a",
        950: "#042f2e"
    },
    cyan: {
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4",
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63",
        950: "#083344"
    },
    sky: {
        50: "#f0f9ff",
        100: "#e0f2fe",
        200: "#bae6fd",
        300: "#7dd3fc",
        400: "#38bdf8",
        500: "#0ea5e9",
        600: "#0284c7",
        700: "#0369a1",
        800: "#075985",
        900: "#0c4a6e",
        950: "#082f49"
    },
    blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
        950: "#172554"
    },
    indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81",
        950: "#1e1b4b"
    },
    violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6fe",
        300: "#c4b5fd",
        400: "#a78bfa",
        500: "#8b5cf6",
        600: "#7c3aed",
        700: "#6d28d9",
        800: "#5b21b6",
        900: "#4c1d95",
        950: "#2e1065"
    },
    purple: {
        50: "#faf5ff",
        100: "#f3e8ff",
        200: "#e9d5ff",
        300: "#d8b4fe",
        400: "#c084fc",
        500: "#a855f7",
        600: "#9333ea",
        700: "#7e22ce",
        800: "#6b21a8",
        900: "#581c87",
        950: "#3b0764"
    },
    fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f5d0fe",
        300: "#f0abfc",
        400: "#e879f9",
        500: "#d946ef",
        600: "#c026d3",
        700: "#a21caf",
        800: "#86198f",
        900: "#701a75",
        950: "#4a044e"
    },
    pink: {
        50: "#fdf2f8",
        100: "#fce7f3",
        200: "#fbcfe8",
        300: "#f9a8d4",
        400: "#f472b6",
        500: "#ec4899",
        600: "#db2777",
        700: "#be185d",
        800: "#9d174d",
        900: "#831843",
        950: "#500724"
    },
    rose: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337",
        950: "#4c0519"
    },
    get lightBlue () {
        $57f4bc3f97ccace5$var$warn({
            version: "v2.2",
            from: "lightBlue",
            to: "sky"
        });
        return this.sky;
    },
    get warmGray () {
        $57f4bc3f97ccace5$var$warn({
            version: "v3.0",
            from: "warmGray",
            to: "stone"
        });
        return this.stone;
    },
    get trueGray () {
        $57f4bc3f97ccace5$var$warn({
            version: "v3.0",
            from: "trueGray",
            to: "neutral"
        });
        return this.neutral;
    },
    get coolGray () {
        $57f4bc3f97ccace5$var$warn({
            version: "v3.0",
            from: "coolGray",
            to: "gray"
        });
        return this.gray;
    },
    get blueGray () {
        $57f4bc3f97ccace5$var$warn({
            version: "v3.0",
            from: "blueGray",
            to: "slate"
        });
        return this.slate;
    }
};

});
parcelRegister("7pWKZ", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $5668721651034315$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$5668721651034315$var$_export(module.exports, {
    dim: function() {
        return $5668721651034315$var$dim;
    },
    default: function() {
        return $5668721651034315$var$_default;
    }
});

const $5668721651034315$var$_picocolors = /*#__PURE__*/ $5668721651034315$var$_interop_require_default((parcelRequire("lrcwG")));
function $5668721651034315$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let $5668721651034315$var$alreadyShown = new Set();
function $5668721651034315$var$log(type, messages, key) {
    typeof $hPtJY !== "undefined" && undefined;
    if (key && $5668721651034315$var$alreadyShown.has(key)) return;
    if (key) $5668721651034315$var$alreadyShown.add(key);
    console.warn("");
    messages.forEach((message)=>console.warn(type, "-", message));
}
function $5668721651034315$var$dim(input) {
    return $5668721651034315$var$_picocolors.default.dim(input);
}
const $5668721651034315$var$_default = {
    info (key, messages) {
        $5668721651034315$var$log($5668721651034315$var$_picocolors.default.bold($5668721651034315$var$_picocolors.default.cyan("info")), ...Array.isArray(key) ? [
            key
        ] : [
            messages,
            key
        ]);
    },
    warn (key, messages) {
        $5668721651034315$var$log($5668721651034315$var$_picocolors.default.bold($5668721651034315$var$_picocolors.default.yellow("warn")), ...Array.isArray(key) ? [
            key
        ] : [
            messages,
            key
        ]);
    },
    risk (key, messages) {
        $5668721651034315$var$log($5668721651034315$var$_picocolors.default.bold($5668721651034315$var$_picocolors.default.magenta("risk")), ...Array.isArray(key) ? [
            key
        ] : [
            messages,
            key
        ]);
    }
};

});
parcelRegister("lrcwG", function(module, exports) {
var $f9b5d605f52d8009$var$x = String;
var $f9b5d605f52d8009$var$create = function() {
    return {
        isColorSupported: false,
        reset: $f9b5d605f52d8009$var$x,
        bold: $f9b5d605f52d8009$var$x,
        dim: $f9b5d605f52d8009$var$x,
        italic: $f9b5d605f52d8009$var$x,
        underline: $f9b5d605f52d8009$var$x,
        inverse: $f9b5d605f52d8009$var$x,
        hidden: $f9b5d605f52d8009$var$x,
        strikethrough: $f9b5d605f52d8009$var$x,
        black: $f9b5d605f52d8009$var$x,
        red: $f9b5d605f52d8009$var$x,
        green: $f9b5d605f52d8009$var$x,
        yellow: $f9b5d605f52d8009$var$x,
        blue: $f9b5d605f52d8009$var$x,
        magenta: $f9b5d605f52d8009$var$x,
        cyan: $f9b5d605f52d8009$var$x,
        white: $f9b5d605f52d8009$var$x,
        gray: $f9b5d605f52d8009$var$x,
        bgBlack: $f9b5d605f52d8009$var$x,
        bgRed: $f9b5d605f52d8009$var$x,
        bgGreen: $f9b5d605f52d8009$var$x,
        bgYellow: $f9b5d605f52d8009$var$x,
        bgBlue: $f9b5d605f52d8009$var$x,
        bgMagenta: $f9b5d605f52d8009$var$x,
        bgCyan: $f9b5d605f52d8009$var$x,
        bgWhite: $f9b5d605f52d8009$var$x
    };
};
module.exports = $f9b5d605f52d8009$var$create();
module.exports.createColors = $f9b5d605f52d8009$var$create;

});





parcelRegister("2WIDq", function(module, exports) {

var $8lbaV = parcelRequire("8lbaV");

var $cGTR8 = parcelRequire("cGTR8");
var $22539f1686be5421$require$addBaseStyles = $cGTR8.addBaseStyles;
var $22539f1686be5421$require$addBaseSizeUtilities = $cGTR8.addBaseSizeUtilities;
var $22539f1686be5421$require$addColorUtilities = $cGTR8.addColorUtilities;
var $22539f1686be5421$require$addRoundedUtilities = $cGTR8.addRoundedUtilities;
var $22539f1686be5421$require$addSizeUtilities = $cGTR8.addSizeUtilities;

var $eTzFF = parcelRequire("eTzFF");
var $22539f1686be5421$require$addVariantOverrides = $eTzFF.addVariantOverrides;
module.exports = $8lbaV.withOptions((options = {})=>(tailwind)=>{
        let preferredStrategy = options.preferredStrategy ?? "standard";
        if (preferredStrategy !== "standard" && preferredStrategy !== "pseudoelements") {
            // eslint-disable-next-line no-console
            console.warn("WARNING: tailwind-scrollbar preferredStrategy should be 'standard' or 'pseudoelements'");
            preferredStrategy = "standard";
        }
        $22539f1686be5421$require$addBaseStyles(tailwind, preferredStrategy);
        $22539f1686be5421$require$addBaseSizeUtilities(tailwind, preferredStrategy);
        $22539f1686be5421$require$addColorUtilities(tailwind);
        $22539f1686be5421$require$addVariantOverrides(tailwind);
        if (options.nocompatible) {
            $22539f1686be5421$require$addRoundedUtilities(tailwind);
            $22539f1686be5421$require$addSizeUtilities(tailwind);
        }
    });

});
parcelRegister("cGTR8", function(module, exports) {

var $96NiW = parcelRequire("96NiW");

var $6aa7u = parcelRequire("6aa7u");
parcelRequire("eEm14");

var $ksr4W = parcelRequire("ksr4W");
var $93d4bc22b1162aff$require$importDefault = $ksr4W.importDefault;
// Tailwind Play will import these internal imports as ES6 imports, while most
// other workflows will import them as CommonJS imports.
const $93d4bc22b1162aff$var$flattenColorPalette = $93d4bc22b1162aff$require$importDefault($96NiW);
const $93d4bc22b1162aff$var$toColorValue = $93d4bc22b1162aff$require$importDefault($6aa7u);
const $93d4bc22b1162aff$var$COMPONENTS = [
    "track",
    "thumb",
    "corner"
];
/**
 * @param {Record<never, unknown>} properties - The properties to assign
 * @param {boolean} preferPseudoElements - If true, only browsers that cannot
 *    use pseudoelements will specify scrollbar properties
 * @returns {Record<string, unknown>} - The generated CSS rules
 */ const $93d4bc22b1162aff$var$scrollbarProperties = (properties, preferPseudoElements)=>{
    if (preferPseudoElements) return {
        "@supports (-moz-appearance:none)": properties
    };
    return properties;
};
/**
 * Base resets to make the plugin's utilities work
 *
 * @param {typedefs.TailwindPlugin} tailwind - Tailwind's plugin object
 * @param {'standard' | 'peseudoelements'} preferredStrategy - The preferred
 *    scrollbar styling strategy: standards track or pseudoelements
 */ const $93d4bc22b1162aff$var$addBaseStyles = ({ addBase: addBase }, preferredStrategy)=>{
    addBase({
        "*": $93d4bc22b1162aff$var$scrollbarProperties({
            "scrollbar-color": "initial",
            "scrollbar-width": "initial"
        }, preferredStrategy === "pseudoelements")
    });
};
/**
 * Generates utilties that tell an element what to do with
 * --scrollbar-track and --scrollbar-thumb custom properties
 *
 * @returns {Record<string, unknown>} - The generated CSS
 */ const $93d4bc22b1162aff$var$generateBaseUtilities = ()=>({
        ...Object.fromEntries($93d4bc22b1162aff$var$COMPONENTS.map((component)=>{
            const base = `&::-webkit-scrollbar-${component}`;
            return [
                [
                    base,
                    {
                        "background-color": `var(--scrollbar-${component})`,
                        "border-radius": `var(--scrollbar-${component}-radius)`
                    }
                ],
                [
                    `${base}:hover`,
                    {
                        "background-color": `var(--scrollbar-${component}-hover, var(--scrollbar-${component}))`
                    }
                ],
                [
                    `${base}:active`,
                    {
                        "background-color": `var(--scrollbar-${component}-active, var(--scrollbar-${component}-hover, var(--scrollbar-${component})))`
                    }
                ]
            ];
        }).flat())
    });
/**
 * Utilities for initializing a custom styled scrollbar, which implicitly set
 * the scrollbar's size
 *
 * @param {object} options - Options
 * @param {boolean} options.preferPseudoElements - If true, only browsers that
 *    cannot use pseudoelements will specify scrollbar-width
 * @returns {Record<string, unknown>} - Base size utilities for scrollbars
 */ const $93d4bc22b1162aff$var$generateScrollbarSizeUtilities = ({ preferPseudoElements: preferPseudoElements })=>({
        ".scrollbar": {
            ...$93d4bc22b1162aff$var$generateBaseUtilities(),
            ...$93d4bc22b1162aff$var$scrollbarProperties({
                "scrollbar-width": "auto",
                "scrollbar-color": "var(--scrollbar-thumb, initial) var(--scrollbar-track, initial)"
            }, preferPseudoElements),
            "&::-webkit-scrollbar": {
                display: "block",
                width: "var(--scrollbar-width, 16px)",
                height: "var(--scrollbar-height, 16px)"
            }
        },
        ".scrollbar-thin": {
            ...$93d4bc22b1162aff$var$generateBaseUtilities(),
            ...$93d4bc22b1162aff$var$scrollbarProperties({
                "scrollbar-width": "thin",
                "scrollbar-color": "var(--scrollbar-thumb, initial) var(--scrollbar-track, initial)"
            }, preferPseudoElements),
            "&::-webkit-scrollbar": {
                display: "block",
                width: "8px",
                height: "8px"
            }
        },
        ".scrollbar-none": {
            ...$93d4bc22b1162aff$var$scrollbarProperties({
                "scrollbar-width": "none"
            }, preferPseudoElements),
            "&::-webkit-scrollbar": {
                display: "none"
            }
        }
    });
/**
 * Adds scrollbar-COMPONENT-COLOR utilities for every scrollbar component.
 *
 * @param {typedefs.TailwindPlugin} tailwind - Tailwind's plugin object
 */ const $93d4bc22b1162aff$var$addColorUtilities = ({ matchUtilities: matchUtilities, theme: theme })=>{
    const themeColors = $93d4bc22b1162aff$var$flattenColorPalette(theme("colors"));
    const colors = Object.fromEntries(Object.entries(themeColors).map(([k, v])=>[
            k,
            $93d4bc22b1162aff$var$toColorValue(v)
        ]));
    $93d4bc22b1162aff$var$COMPONENTS.forEach((component)=>{
        matchUtilities({
            [`scrollbar-${component}`]: (value)=>{
                const color = $93d4bc22b1162aff$var$toColorValue(value);
                return {
                    [`--scrollbar-${component}`]: `${color} !important`
                };
            }
        }, {
            values: colors,
            type: "color"
        });
    });
};
/**
 * Adds scrollbar-COMPONENT-rounded-VALUE utilities for every scrollbar
 * component.
 *
 * @param {typedefs.TailwindPlugin} tailwind - Tailwind's plugin object
 */ const $93d4bc22b1162aff$var$addRoundedUtilities = ({ theme: theme, matchUtilities: matchUtilities })=>{
    $93d4bc22b1162aff$var$COMPONENTS.forEach((component)=>{
        matchUtilities({
            [`scrollbar-${component}-rounded`]: (value)=>({
                    [`--scrollbar-${component}-radius`]: value
                })
        }, {
            values: theme("borderRadius")
        });
    });
};
/**
 * @param {typedefs.TailwindPlugin} tailwind - Tailwind's plugin object
 * @param {'standard' | 'peseudoelements'} preferredStrategy - The preferred
 *    scrollbar styling strategy: standards track or pseudoelements
 */ const $93d4bc22b1162aff$var$addBaseSizeUtilities = ({ addUtilities: addUtilities }, preferredStrategy)=>{
    addUtilities($93d4bc22b1162aff$var$generateScrollbarSizeUtilities({
        preferPseudoElements: preferredStrategy === "pseudoelements"
    }));
};
/**
 * Adds scrollbar-w-* and scrollbar-h-* utilities
 *
 * @param {typedefs.TailwindPlugin} tailwind - Tailwind's plugin object
 */ const $93d4bc22b1162aff$var$addSizeUtilities = ({ matchUtilities: matchUtilities, theme: theme })=>{
    [
        "width",
        "height"
    ].forEach((dimension)=>{
        matchUtilities({
            [`scrollbar-${dimension[0]}`]: (value)=>({
                    [`--scrollbar-${dimension}`]: value
                })
        }, {
            values: theme(dimension)
        });
    });
};
module.exports = {
    addBaseStyles: $93d4bc22b1162aff$var$addBaseStyles,
    addBaseSizeUtilities: $93d4bc22b1162aff$var$addBaseSizeUtilities,
    addColorUtilities: $93d4bc22b1162aff$var$addColorUtilities,
    addRoundedUtilities: $93d4bc22b1162aff$var$addRoundedUtilities,
    addSizeUtilities: $93d4bc22b1162aff$var$addSizeUtilities
};

});
parcelRegister("96NiW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6a1aeb7303b096b8$var$_default;
    }
});
const $6a1aeb7303b096b8$var$flattenColorPalette = (colors)=>Object.assign({}, ...Object.entries(colors !== null && colors !== void 0 ? colors : {}).flatMap(([color, values])=>typeof values == "object" ? Object.entries($6a1aeb7303b096b8$var$flattenColorPalette(values)).map(([number, hex])=>({
                [color + (number === "DEFAULT" ? "" : `-${number}`)]: hex
            })) : [
            {
                [`${color}`]: values
            }
        ]));
const $6a1aeb7303b096b8$var$_default = $6a1aeb7303b096b8$var$flattenColorPalette;

});

parcelRegister("6aa7u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $47cb86db0e7b70fb$var$toColorValue;
    }
});
function $47cb86db0e7b70fb$var$toColorValue(maybeFunction) {
    return typeof maybeFunction === "function" ? maybeFunction({}) : maybeFunction;
}

});

parcelRegister("eEm14", function(module, exports) {
/**
 * @typedef {object} TailwindPlugin
 * @property {Function} matchUtilities - Adds utilities to tailwind
 * @property {Function} theme - Accesses tailwind's theme
 * @property {Function} addVariant - Adds a variant to tailwind
 * @property {Function} config - Accesses tailwind's configuration
 */ var $aaa5e118dae3a083$export$8c71a0fc387acb22;
$aaa5e118dae3a083$export$8c71a0fc387acb22 = {};

});

parcelRegister("ksr4W", function(module, exports) {
/**
 * Gets the underlying default import of a module.
 *
 * This is used to handle internal imoprts from Tailwind, since Tailwind Play
 * handles these imports differently.
 *
 * @template T
 * @param {T | { __esModule: unknown, default: T }} mod The module
 * @returns {T} The bare export
 */ // eslint-disable-next-line no-underscore-dangle
const $ee4b6d6e13514cac$var$importDefault = (mod)=>mod && mod.__esModule ? mod.default : mod;
module.exports = {
    importDefault: $ee4b6d6e13514cac$var$importDefault
};

});


parcelRegister("eTzFF", function(module, exports) {
// This import doesn't work on Tailwind Play. Move to typescript might fix it
// on its own, so for now, we just won't check flags on Tailwind Play.

var $e7TKg = parcelRequire("e7TKg");
var $ad81df4a92735b33$require$flagEnabled = $e7TKg.flagEnabled;
parcelRequire("eEm14");
/**
 * @typedef {object} VariantOverride
 * @property {string} variant - The variant name as it appears in the utitlity
 * @property {string} defaultFormat - The format for non-scrollbar utilities
 * @property {string} scrollbarFormat - The format for scrollbar utilities
 */ /**
 * The variants tailwind-scrollbar cares about. hover and focus are the real
 * targets, but we include the others so that their relative order can be
 * preserved.
 */ const $ad81df4a92735b33$var$variants = [
    "hover",
    "focus",
    "focus-visible",
    "active",
    "enabled",
    "disabled"
];
/**
 * Gets the variant format string used by Tailwind for a variant.
 *
 * @param {string} variant The name of the variant
 * @param {typedefs.TailwindPlugin.config} config - Tailwind's configuration
 * @returns {string} The variant format string
 */ const $ad81df4a92735b33$var$getDefaultFormat = (variant, config)=>{
    if (variant === "hover" && $ad81df4a92735b33$require$flagEnabled && $ad81df4a92735b33$require$flagEnabled(config(), "hoverOnlyWhenSupported")) return "@media (hover: hover) and (pointer: fine) { &:hover }";
    return `&:${variant}`;
};
/**
 * Gets the variant format string that should be used if a rule is detected to
 * target a scrollbar
 *
 * @param {string} variant The name of the variant
 * @param {typedefs.TailwindPlugin.config} config - Tailwind's configuration
 * @returns {string} The variant format string
 */ const $ad81df4a92735b33$var$getScrollbarFormat = (variant, config)=>{
    if (variant === "hover" && $ad81df4a92735b33$require$flagEnabled && $ad81df4a92735b33$require$flagEnabled(config(), "hoverOnlyWhenSupported")) return "@media (hover: hover) and (pointer: fine) { & }";
    return "&";
};
/**
 * Modifies the way variant utilities are generated for scrollbars.
 *
 * Tailwind isn't very good at styling arbitrary pseudo classes of pseudo
 * elements, so scrollbar colour classes keep track of a default, hover, and
 * active state and use the cascade to determine which one to use. Instead of
 * trying to style a pseudo class, scrollbar utilities modify the name of the
 * property that is being applied and apply directly to the original class.
 *
 * @param {typedefs.TailwindPlugin} tailwind - Tailwind's plugin object
 */ const $ad81df4a92735b33$var$addVariantOverrides = ({ addVariant: addVariant, config: config })=>{
    $ad81df4a92735b33$var$variants.forEach((variant)=>{
        addVariant(variant, ({ container: container })=>{
            const suffix = `-${variant}`;
            let found = false;
            container.walkRules((rule)=>{
                rule.walkDecls(/^--scrollbar-/, (decl)=>{
                    found = true;
                    if (!decl.prop.endsWith(suffix)) /* eslint-disable-next-line no-param-reassign */ decl.prop += suffix;
                });
            });
            if (found) return $ad81df4a92735b33$var$getScrollbarFormat(variant, config);
            return $ad81df4a92735b33$var$getDefaultFormat(variant, config);
        });
    });
};
module.exports = {
    addVariantOverrides: $ad81df4a92735b33$var$addVariantOverrides
};

});
parcelRegister("e7TKg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $a48cf5fc00c854b7$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$a48cf5fc00c854b7$var$_export(module.exports, {
    flagEnabled: function() {
        return $a48cf5fc00c854b7$var$flagEnabled;
    },
    issueFlagNotices: function() {
        return $a48cf5fc00c854b7$var$issueFlagNotices;
    },
    default: function() {
        return $a48cf5fc00c854b7$var$_default;
    }
});

const $a48cf5fc00c854b7$var$_picocolors = /*#__PURE__*/ $a48cf5fc00c854b7$var$_interop_require_default((parcelRequire("lrcwG")));

const $a48cf5fc00c854b7$var$_log = /*#__PURE__*/ $a48cf5fc00c854b7$var$_interop_require_default((parcelRequire("7pWKZ")));
function $a48cf5fc00c854b7$var$_interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let $a48cf5fc00c854b7$var$defaults = {
    optimizeUniversalDefaults: false,
    generalizedModifiers: true,
    disableColorOpacityUtilitiesByDefault: false,
    relativeContentPathsByDefault: false
};
let $a48cf5fc00c854b7$var$featureFlags = {
    future: [
        "hoverOnlyWhenSupported",
        "respectDefaultRingColorOpacity",
        "disableColorOpacityUtilitiesByDefault",
        "relativeContentPathsByDefault"
    ],
    experimental: [
        "optimizeUniversalDefaults",
        "generalizedModifiers"
    ]
};
function $a48cf5fc00c854b7$var$flagEnabled(config, flag) {
    if ($a48cf5fc00c854b7$var$featureFlags.future.includes(flag)) {
        var _config_future;
        var _config_future_flag, _ref;
        return config.future === "all" || ((_ref = (_config_future_flag = config === null || config === void 0 ? void 0 : (_config_future = config.future) === null || _config_future === void 0 ? void 0 : _config_future[flag]) !== null && _config_future_flag !== void 0 ? _config_future_flag : $a48cf5fc00c854b7$var$defaults[flag]) !== null && _ref !== void 0 ? _ref : false);
    }
    if ($a48cf5fc00c854b7$var$featureFlags.experimental.includes(flag)) {
        var _config_experimental;
        var _config_experimental_flag, _ref1;
        return config.experimental === "all" || ((_ref1 = (_config_experimental_flag = config === null || config === void 0 ? void 0 : (_config_experimental = config.experimental) === null || _config_experimental === void 0 ? void 0 : _config_experimental[flag]) !== null && _config_experimental_flag !== void 0 ? _config_experimental_flag : $a48cf5fc00c854b7$var$defaults[flag]) !== null && _ref1 !== void 0 ? _ref1 : false);
    }
    return false;
}
function $a48cf5fc00c854b7$var$experimentalFlagsEnabled(config) {
    if (config.experimental === "all") return $a48cf5fc00c854b7$var$featureFlags.experimental;
    var _config_experimental;
    return Object.keys((_config_experimental = config === null || config === void 0 ? void 0 : config.experimental) !== null && _config_experimental !== void 0 ? _config_experimental : {}).filter((flag)=>$a48cf5fc00c854b7$var$featureFlags.experimental.includes(flag) && config.experimental[flag]);
}
function $a48cf5fc00c854b7$var$issueFlagNotices(config) {
    if ($a48cf5fc00c854b7$var$experimentalFlagsEnabled(config).length > 0) {
        let changes = $a48cf5fc00c854b7$var$experimentalFlagsEnabled(config).map((s)=>$a48cf5fc00c854b7$var$_picocolors.default.yellow(s)).join(", ");
        $a48cf5fc00c854b7$var$_log.default.warn("experimental-flags-enabled", [
            `You have enabled experimental features: ${changes}`,
            "Experimental features in Tailwind CSS are not covered by semver, may introduce breaking changes, and can change at any time."
        ]);
    }
}
const $a48cf5fc00c854b7$var$_default = $a48cf5fc00c854b7$var$featureFlags;

});




parcelRegister("8oIro", function(module, exports) {

});


parcelRegister("4SYbb", function(module, exports) {
$parcel$export(module.exports, "DetailCard", () => (parcelRequire("kE1zm")).DetailCard);
parcelRequire("kE1zm");

});
parcelRegister("kE1zm", function(module, exports) {

$parcel$export(module.exports, "DetailCard", () => $6744c5f0c9f6d6e9$export$63aaec23c0ca5ec3);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
parcelRequire("azsOi");
var $bVwXM = parcelRequire("bVwXM");
var $5Ttm9 = parcelRequire("5Ttm9");
function $6744c5f0c9f6d6e9$export$63aaec23c0ca5ec3({ title: title, details: details, children: children, testId: testId, className: className, transparent: transparent = false }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bVwXM.Card), {
        className: (0, $9QePP.default)("flex flex-col md:flex-row", "h-full p-8 md:min-h-44", "border-default border", transparent && "bg-transparent", className),
        testId: testId,
        children: [
            title && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("w-full md:w-[136px] md:max-w-[136px]", "max-md:pb-3 md:pr-8", "box-content flex items-center", "border-default max-md:border-b md:border-r"),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("grid grid-cols-2", "flex-1 gap-4", "max-md:mt-4 md:px-8"),
                children: details.map((detail)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "col-span-2 md:col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-micro subdued",
                                children: detail.label
                            }),
                            !detail.isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-s",
                                children: detail.value
                            }),
                            detail.isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {})
                        ]
                    }, detail.label))
            }),
            children && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("flex flex-col", "gap-5 gap-y-3", "items-center justify-center", "max-md:mt-4"),
                children: children
            })
        ]
    });
}

});


parcelRegister("20nGc", function(module, exports) {
$parcel$export(module.exports, "Table", () => (parcelRequire("grEu8")).Table);
parcelRequire("grEu8");

});
parcelRegister("grEu8", function(module, exports) {

$parcel$export(module.exports, "Table", () => $30abf7d0e66a90fe$export$54ec01a60f47d33d);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $f778b = parcelRequire("f778b");

var $61cJZ = parcelRequire("61cJZ");

var $755iF = parcelRequire("755iF");

var $cNIlN = parcelRequire("cNIlN");
function $30abf7d0e66a90fe$export$54ec01a60f47d33d({ testId: testId, className: className, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
        className: (0, $9QePP.default)("min-w-full divide-y divide-slate-300 dark:divide-slate-700", className),
        "data-testid": testId,
        children: children
    });
}
$30abf7d0e66a90fe$export$54ec01a60f47d33d.Head = (0, $61cJZ.TableHead);
$30abf7d0e66a90fe$export$54ec01a60f47d33d.Body = (0, $f778b.TableBody);
$30abf7d0e66a90fe$export$54ec01a60f47d33d.Row = (0, $755iF.TableRow);
$30abf7d0e66a90fe$export$54ec01a60f47d33d.Data = (0, $cNIlN.TableData);

});
parcelRegister("f778b", function(module, exports) {

$parcel$export(module.exports, "TableBody", () => $607020dc53b2c0a4$export$76ccd210b9029917);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $607020dc53b2c0a4$export$76ccd210b9029917({ children: children, testId: testId, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
        className: (0, $9QePP.default)("divide-y divide-slate-300 bg-transparent dark:divide-slate-700", className),
        "data-testid": testId,
        children: children
    });
}

});

parcelRegister("61cJZ", function(module, exports) {

$parcel$export(module.exports, "TableHead", () => $560dd801d051a553$export$2f4a7be4f0dcc2);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $560dd801d051a553$export$2f4a7be4f0dcc2({ labels: labels, className: className, testId: testId, hideOnMobile: hideOnMobile = false, sticky: sticky = true }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
        className: (0, $9QePP.default)(hideOnMobile && "hidden sm:table-header-group", className),
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
            children: labels.map((label)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    scope: "col",
                    className: (0, $9QePP.default)("bg-default py-3.5 pl-4 pr-3 sm:pl-0", "text-left", sticky && "z-8 sticky top-0"),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        children: label
                    })
                }, label))
        })
    });
}

});

parcelRegister("755iF", function(module, exports) {

$parcel$export(module.exports, "TableRow", () => $a6a1402d94b568cb$export$b05581f4e764e162);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $a6a1402d94b568cb$export$b05581f4e764e162({ children: children, testId: testId, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
        className: (0, $9QePP.default)(className),
        "data-testid": testId,
        children: children
    });
}

});

parcelRegister("cNIlN", function(module, exports) {

$parcel$export(module.exports, "TableData", () => $8cd4158008f39332$export$21bb50d99dad8897);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $8cd4158008f39332$export$21bb50d99dad8897({ children: children, testId: testId, className: className, subdued: subdued = false, hideOnMobile: hideOnMobile = false }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
        className: (0, $9QePP.default)("whitespace-nowrap py-5 pl-4 pr-3 sm:pl-0", hideOnMobile && "hidden sm:table-cell", className),
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: (0, $9QePP.default)("grid", "font-body", "font-bodyWeight", "text-bodySSize", "leading-bodyS", "tracking-body", "cursor-default", "text-defaultTextColor", subdued && "subdued"),
            children: children
        })
    });
}

});



parcelRegister("ab1kZ", function(module, exports) {
$parcel$export(module.exports, "FilterBar", () => (parcelRequire("9tkgs")).FilterBar);
parcelRequire("9tkgs");

});
parcelRegister("9tkgs", function(module, exports) {

$parcel$export(module.exports, "FilterBar", () => $912ae5051ff1eaa6$export$56a20ec2552ffba2);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
parcelRequire("ljFgu");
var $93iCJ = parcelRequire("93iCJ");
function $912ae5051ff1eaa6$export$56a20ec2552ffba2({ testId: testId, className: className, children: children, isFiltering: isFiltering = false, appliedFilters: appliedFilters, title: title }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("mb-2 w-full", className),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("mb-5 mt-2", "flex flex-col", "sm:flex-row sm:justify-between"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $93iCJ.FilterIndicator), {
                        isFiltering: isFiltering
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("w-full", "flex flex-col", "items-baseline gap-x-3", "sm:flex-row"),
                children: [
                    title && /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        children: title
                    }),
                    appliedFilters && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "ui-element",
                        children: appliedFilters
                    })
                ]
            })
        ]
    });
}

});


parcelRegister("dChYn", function(module, exports) {
$parcel$export(module.exports, "Search", () => (parcelRequire("lkwlf")).Search);
parcelRequire("lkwlf");

});
parcelRegister("lkwlf", function(module, exports) {

$parcel$export(module.exports, "Search", () => $bdb7f80112e77034$export$4b85d3515bd863a5);

var $1qg5T = parcelRequire("1qg5T");

var $8VMzV = parcelRequire("8VMzV");

var $68FhC = parcelRequire("68FhC");

var $1xiuI = parcelRequire("1xiuI");

var $kPqfL = parcelRequire("kPqfL");

var $27usi = parcelRequire("27usi");

var $bzdpT = parcelRequire("bzdpT");
const $bdb7f80112e77034$export$4b85d3515bd863a5 = {
    Header: (0, $1qg5T.SearchHeader),
    Error: (0, $8VMzV.SearchError),
    Loading: (0, $68FhC.SearchLoading),
    Results: (0, $1xiuI.SearchResultsBody),
    RadioResult: (0, $kPqfL.SearchRadioResult),
    CheckboxResult: (0, $27usi.SearchCheckboxResult),
    Bar: (0, $bzdpT.SearchBar)
};

});
parcelRegister("1qg5T", function(module, exports) {

$parcel$export(module.exports, "SearchHeader", () => $226645de232edebf$export$8a9b225579f9b6a7);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $226645de232edebf$export$8a9b225579f9b6a7({ testId: testId, title: title, description: description, children: children, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)(className),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)(description && "my-3 sm:my-5", "flex items-center justify-between"),
                children: [
                    description && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-m",
                        children: description
                    }),
                    children
                ]
            })
        ]
    });
}

});

parcelRegister("8VMzV", function(module, exports) {

$parcel$export(module.exports, "SearchError", () => $d157be11b0838d72$export$930da00ff8e1539f);

var $ayMG0 = parcelRequire("ayMG0");

var $2TuUj = parcelRequire("2TuUj");

var $9QePP = parcelRequire("9QePP");
function $d157be11b0838d72$export$930da00ff8e1539f({ className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("flex items-center", className),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2TuUj.default), {
                width: 20,
                className: "subdued mr-4",
                role: "icon"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-button subdued",
                children: "Error fetching results"
            })
        ]
    });
}

});
parcelRegister("2TuUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $21b8b15e318774d2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $21b8b15e318774d2$var$ExclamationTriangleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
        clipRule: "evenodd"
    }));
}
const $21b8b15e318774d2$var$ForwardRef = $acw62.forwardRef($21b8b15e318774d2$var$ExclamationTriangleIcon);
var $21b8b15e318774d2$export$2e2bcd8739ae039 = $21b8b15e318774d2$var$ForwardRef;

});


parcelRegister("68FhC", function(module, exports) {

$parcel$export(module.exports, "SearchLoading", () => $9b3443f91adc87f1$export$8934683688a2f019);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
parcelRequire("azsOi");
var $5Ttm9 = parcelRequire("5Ttm9");
function $9b3443f91adc87f1$export$8934683688a2f019({ className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("flex items-center", className),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
                className: "mr-4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-button subdued",
                children: "Searching..."
            })
        ]
    });
}

});

parcelRegister("1xiuI", function(module, exports) {

$parcel$export(module.exports, "SearchResultsBody", () => $fb6eb5af4be50b83$export$8865580599ad9345);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $bvcna = parcelRequire("bvcna");
function $fb6eb5af4be50b83$export$8865580599ad9345({ testId: testId, className: className, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)((0, $bvcna.twMerge)(`custom-scrollbar bg-onSurface-active h-[300px] overflow-y-scroll rounded-lg p-2
                shadow-400`, className)),
        "data-testid": testId,
        children: children
    });
}

});

parcelRegister("kPqfL", function(module, exports) {

$parcel$export(module.exports, "SearchRadioResult", () => $cc2ddbbdbabb2d8d$export$1932ebac82ab7753);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $cc2ddbbdbabb2d8d$export$1932ebac82ab7753({ testId: testId, className: className, id: id, name: name, onChange: onChange, children: children, disabled: disabled }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("flex items-center p-3", className),
        role: "listitem",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                id: id.toString(),
                name: "selected",
                type: "radio",
                defaultChecked: false,
                className: (0, $9QePP.default)("bg-onSurface-active mr-2", "border-2 border-gray-400", "size-4 text-blue-500", "focus:ring-0 focus:ring-offset-0"),
                onChange: onChange,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                htmlFor: id.toString(),
                className: (0, $9QePP.default)(disabled && "text-gray-500", "mr-2"),
                children: [
                    name,
                    children
                ]
            })
        ]
    });
}

});

parcelRegister("27usi", function(module, exports) {

$parcel$export(module.exports, "SearchCheckboxResult", () => $551744251161536a$export$c5729a2f620f98ca);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $551744251161536a$export$c5729a2f620f98ca({ testId: testId, id: id, name: name, onChange: onChange, children: children, disabled: disabled, className: className, checked: checked }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("flex items-center p-3", className),
        role: "listitem",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                id: id.toString(),
                name: name,
                type: "checkbox",
                role: "checkbox",
                className: (0, $9QePP.default)("bg-onSurface-active mr-2", "border-2 border-gray-400", "size-4 text-blue-500", "focus:ring-0 focus:ring-offset-0 disabled:cursor-not-allowed disabled:border-transparent disabled:bg-slate-400 disabled:dark:bg-slate-900"),
                "data-testid": id.toString(),
                onChange: onChange,
                disabled: disabled,
                checked: checked
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                htmlFor: id.toString(),
                className: (0, $9QePP.default)("mr-2"),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: (0, $9QePP.default)("ui-element", disabled && "text-gray-400"),
                            children: name
                        }),
                        children
                    ]
                })
            })
        ]
    });
}

});

parcelRegister("bzdpT", function(module, exports) {

$parcel$export(module.exports, "SearchBar", () => $cb68a577eec5d704$export$79d13b60110f33be);

var $ayMG0 = parcelRequire("ayMG0");

var $fd4Y7 = parcelRequire("fd4Y7");

var $9QePP = parcelRequire("9QePP");

var $bvcna = parcelRequire("bvcna");
const $cb68a577eec5d704$export$79d13b60110f33be = ({ placeholder: placeholder, searchHandler: searchHandler, className: className, secondary: secondary = false, defaultValue: defaultValue })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)((0, $bvcna.twMerge)("relative flex items-center", className)),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "text",
                className: "w-full",
                placeholder: placeholder,
                onChange: (e)=>searchHandler(e.target.value),
                defaultValue: defaultValue
            }),
            secondary && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("pr-3 pt-1", "pointer-events-none absolute inset-y-0 right-0 flex items-center"),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fd4Y7.default), {
                    className: "size-5 text-slate-500"
                })
            })
        ]
    });
};

});
parcelRegister("fd4Y7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b12bec93b109b848$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $b12bec93b109b848$var$MagnifyingGlassIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
    }));
}
const $b12bec93b109b848$var$ForwardRef = $acw62.forwardRef($b12bec93b109b848$var$MagnifyingGlassIcon);
var $b12bec93b109b848$export$2e2bcd8739ae039 = $b12bec93b109b848$var$ForwardRef;

});




parcelRegister("ii2jZ", function(module, exports) {
$parcel$export(module.exports, "Form", () => (parcelRequire("hQ0nj")).Form);
$parcel$export(module.exports, "Input", () => (parcelRequire("bApKI")).Input);
$parcel$export(module.exports, "RawInput", () => (parcelRequire("a6Thc")).RawInput);
$parcel$export(module.exports, "Money", () => (parcelRequire("7JqhK")).Money);
$parcel$export(module.exports, "Percent", () => (parcelRequire("6pNDa")).Percent);
$parcel$export(module.exports, "MutableList", () => (parcelRequire("9hanQ")).MutableList);
$parcel$export(module.exports, "Checkbox", () => (parcelRequire("29x30")).Checkbox);
$parcel$export(module.exports, "TextArea", () => (parcelRequire("1sOsm")).TextArea);
$parcel$export(module.exports, "Select", () => (parcelRequire("97C3K")).Select);
$parcel$export(module.exports, "RichText", () => (parcelRequire("faxRZ")).RichText);
parcelRequire("hQ0nj");
parcelRequire("bApKI");
parcelRequire("a6Thc");
parcelRequire("7JqhK");
parcelRequire("6pNDa");
parcelRequire("9hanQ");
parcelRequire("29x30");
parcelRequire("1sOsm");
parcelRequire("97C3K");
parcelRequire("faxRZ");

});
parcelRegister("hQ0nj", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $f06ff232fac9041c$export$c24727297075ec6a);
$parcel$export(module.exports, "Form", () => $f06ff232fac9041c$export$a7fed597f4b8afd8);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3nBkL = parcelRequire("3nBkL");

var $k8Nfm = parcelRequire("k8Nfm");
const $f06ff232fac9041c$export$c24727297075ec6a = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
function $f06ff232fac9041c$export$a7fed597f4b8afd8({ id: id, schema: schema, onSubmit: onSubmit, onChange: onChange, children: children, defaultValues: defaultValues, ...props }) {
    const form = (0, $3nBkL.useForm)({
        schema: schema,
        onChange: onChange,
        defaultValues: defaultValues
    });
    const { data: data, isValid: isValid } = form;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f06ff232fac9041c$export$c24727297075ec6a.Provider, {
        value: form,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
            ...props,
            onSubmit: (e)=>{
                e.preventDefault();
                e.stopPropagation();
                onSubmit && onSubmit(data);
            },
            id: id,
            "data-testid": id,
            children: (0, $acw62.Children).map(children, (child)=>{
                if (/*#__PURE__*/ (0, $acw62.isValidElement)(child) && child.type === "button") {
                    const { disabled: disabled, ...otherProps } = child.props;
                    const isSubmitButton = child.props.type === "submit";
                    return /*#__PURE__*/ (0, $acw62.cloneElement)(child, {
                        ...otherProps,
                        disabled: isSubmitButton && !isValid || disabled
                    });
                }
                return child;
            })
        })
    });
}
$f06ff232fac9041c$export$a7fed597f4b8afd8.Modal = (0, $k8Nfm.FormModal);

});
parcelRegister("3nBkL", function(module, exports) {

$parcel$export(module.exports, "useForm", () => $d0652e356e9cd167$export$87c0cf8eb5a167e0);

var $acw62 = parcelRequire("acw62");

var $hXCJe = parcelRequire("hXCJe");

var $6f2mm = parcelRequire("6f2mm");

var $f1q41 = parcelRequire("f1q41");
function $d0652e356e9cd167$export$87c0cf8eb5a167e0({ schema: schema, defaultValues: defaultValues, onChange: onChange }) {
    const flattenedDefaultValues = (0, $6f2mm.flattenObject)(defaultValues || {});
    const [values, setValues] = (0, $acw62.useState)(flattenedDefaultValues);
    const [isDirty, setIsDirty] = (0, $acw62.useState)(false);
    const prevState = (0, $acw62.useRef)();
    const updateValue = (0, $acw62.useCallback)((key, value)=>{
        setValues((prevValues)=>({
                ...prevValues,
                [key]: value
            }));
        setIsDirty(true);
    }, [
        setValues,
        setIsDirty,
        schema
    ]);
    const mergeValues = (0, $acw62.useCallback)((vals)=>{
        const flattenedVals = (0, $6f2mm.flattenObject)(vals);
        setValues((prevValues)=>({
                ...prevValues,
                ...flattenedVals
            }));
        setIsDirty(true);
    }, [
        setValues,
        setIsDirty,
        schema
    ]);
    const replaceValues = (0, $acw62.useCallback)((vals)=>{
        const flattenedVals = (0, $6f2mm.flattenObject)(vals);
        setValues(flattenedVals);
        setIsDirty(true);
    }, [
        setValues,
        setIsDirty,
        schema
    ]);
    const validate = (0, $acw62.useCallback)(()=>(0, $hXCJe.validateSchema)(values, schema), [
        values,
        schema
    ]);
    const state = (0, $acw62.useMemo)(()=>{
        const { isValid: isValid, errors: errors } = validate();
        return {
            isValid: isValid,
            errors: errors,
            isDirty: isDirty,
            isPristine: !isDirty,
            canSubmit: isDirty && isValid,
            values: values,
            data: (0, $6f2mm.unflattenObject)(values),
            updateValue: updateValue,
            mergeValues: mergeValues,
            replaceValues: replaceValues,
            schema: schema
        };
    }, [
        values,
        isDirty,
        schema
    ]);
    (0, $acw62.useEffect)(()=>{
        if (prevState.current && !(0, $f1q41.isEqual)(prevState.current.values, state.values)) onChange && onChange(state);
        prevState.current = state;
    }, [
        onChange,
        state
    ]);
    return {
        ...state,
        validate: validate
    };
}

});
parcelRegister("hXCJe", function(module, exports) {

$parcel$export(module.exports, "validateSchema", () => $4170f08178a49695$export$4741711f07dbb8e7);

var $hEJWZ = parcelRequire("hEJWZ");

var $6f2mm = parcelRequire("6f2mm");
function $4170f08178a49695$export$4741711f07dbb8e7(value, schema, unflatten = true) {
    try {
        schema.validateSync(unflatten ? (0, $6f2mm.unflattenObject)(value) : value, {
            abortEarly: false
        });
    } catch (err) {
        if (err instanceof (0, $hEJWZ.ValidationError)) return {
            isValid: false,
            errors: err.inner.reduce((acc, cur)=>{
                if (cur.path) acc[cur.path] = cur.message;
                return acc;
            }, {})
        };
        // Handle unexpected errors
        console.error("Unexpected error:", err);
    }
    return {
        isValid: true,
        errors: null
    };
}

});
parcelRegister("hEJWZ", function(module, exports) {

$parcel$export(module.exports, "ValidationError", () => $cda9d0e1103d595f$export$2191b9da168c6cf0);
$parcel$export(module.exports, "isSchema", () => $cda9d0e1103d595f$export$213e2a3e7c4f326e);
$parcel$export(module.exports, "reach", () => $cda9d0e1103d595f$export$cfedb76369cc7782);
$parcel$export(module.exports, "mixed", () => $cda9d0e1103d595f$export$9b30b6294c1449a8);
$parcel$export(module.exports, "string", () => $cda9d0e1103d595f$export$22b082955e083ec3);
$parcel$export(module.exports, "number", () => $cda9d0e1103d595f$export$98e628dec113755e);
$parcel$export(module.exports, "object", () => $cda9d0e1103d595f$export$be5493f9613cbbe);
$parcel$export(module.exports, "array", () => $cda9d0e1103d595f$export$2f23118c22fb2630);
$parcel$export(module.exports, "boolean", () => $cda9d0e1103d595f$export$87b259aa03e3d267);

var $Sk64T = parcelRequire("Sk64T");

var $i6Lf0 = parcelRequire("i6Lf0");

var $dYCFZ = parcelRequire("dYCFZ");
const $cda9d0e1103d595f$var$toString = Object.prototype.toString;
const $cda9d0e1103d595f$var$errorToString = Error.prototype.toString;
const $cda9d0e1103d595f$var$regExpToString = RegExp.prototype.toString;
const $cda9d0e1103d595f$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $cda9d0e1103d595f$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $cda9d0e1103d595f$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $cda9d0e1103d595f$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $cda9d0e1103d595f$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $cda9d0e1103d595f$var$symbolToString.call(val).replace($cda9d0e1103d595f$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $cda9d0e1103d595f$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $cda9d0e1103d595f$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $cda9d0e1103d595f$var$regExpToString.call(val);
    return null;
}
function $cda9d0e1103d595f$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $cda9d0e1103d595f$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $cda9d0e1103d595f$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $cda9d0e1103d595f$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $cda9d0e1103d595f$var$_Symbol$toStringTag, $cda9d0e1103d595f$var$_Symbol$hasInstance, $cda9d0e1103d595f$var$_Symbol$toStringTag2;
let $cda9d0e1103d595f$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$cda9d0e1103d595f$var$_Symbol$toStringTag = Symbol.toStringTag;
class $cda9d0e1103d595f$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$cda9d0e1103d595f$var$_Symbol$toStringTag] = "Error";
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $cda9d0e1103d595f$var$toArray(errorOrErrors).forEach((err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$cda9d0e1103d595f$var$_Symbol$hasInstance = Symbol.hasInstance;
$cda9d0e1103d595f$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $cda9d0e1103d595f$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = Object.assign({}, params, {
            path: path
        });
        if (typeof message === "string") return message.replace($cda9d0e1103d595f$var$strReg, (_, key)=>$cda9d0e1103d595f$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $cda9d0e1103d595f$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$cda9d0e1103d595f$var$_Symbol$toStringTag2] = "Error";
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $cda9d0e1103d595f$export$2191b9da168c6cf0);
    }
    static [$cda9d0e1103d595f$var$_Symbol$hasInstance](inst) {
        return $cda9d0e1103d595f$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
}
let $cda9d0e1103d595f$var$mixed = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    defined: "${path} must be defined",
    notNull: "${path} cannot be null",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(originalValue, true)}\`).` : ".";
        return type !== "mixed" ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $cda9d0e1103d595f$var$string = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    datetime: "${path} must be a valid ISO date-time",
    datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $cda9d0e1103d595f$var$number = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $cda9d0e1103d595f$var$date = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $cda9d0e1103d595f$var$boolean = {
    isValue: "${path} field must be ${value}"
};
let $cda9d0e1103d595f$var$object = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let $cda9d0e1103d595f$var$array = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
let $cda9d0e1103d595f$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $cda9d0e1103d595f$export$2191b9da168c6cf0.formatError($cda9d0e1103d595f$var$mixed.notType, params);
    }
};
var $cda9d0e1103d595f$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $cda9d0e1103d595f$var$mixed,
    string: $cda9d0e1103d595f$var$string,
    number: $cda9d0e1103d595f$var$number,
    date: $cda9d0e1103d595f$var$date,
    object: $cda9d0e1103d595f$var$object,
    array: $cda9d0e1103d595f$var$array,
    boolean: $cda9d0e1103d595f$var$boolean,
    tuple: $cda9d0e1103d595f$var$tuple
});
const $cda9d0e1103d595f$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $cda9d0e1103d595f$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        return new $cda9d0e1103d595f$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
}
const $cda9d0e1103d595f$var$prefixes = {
    context: "$",
    value: "."
};
function $cda9d0e1103d595f$export$eff4d24c3ff7876e(key, options) {
    return new $cda9d0e1103d595f$var$Reference(key, options);
}
class $cda9d0e1103d595f$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $cda9d0e1103d595f$var$prefixes.context;
        this.isValue = this.key[0] === $cda9d0e1103d595f$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $cda9d0e1103d595f$var$prefixes.context : this.isValue ? $cda9d0e1103d595f$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $Sk64T.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$cda9d0e1103d595f$var$Reference.prototype.__isYupRef = true;
const $cda9d0e1103d595f$var$isAbsent = (value)=>value == null;
function $cda9d0e1103d595f$var$createValidation(config) {
    function validate({ value: value, path: path = "", options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $cda9d0e1103d595f$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $cda9d0e1103d595f$export$2191b9da168c6cf0($cda9d0e1103d595f$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $cda9d0e1103d595f$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === "function") {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $cda9d0e1103d595f$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $Sk64T.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === "tuple";
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $cda9d0e1103d595f$export$cfedb76369cc7782(obj, path, value, context) {
    return $cda9d0e1103d595f$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $cda9d0e1103d595f$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($cda9d0e1103d595f$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $cda9d0e1103d595f$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $cda9d0e1103d595f$var$clone(src, seen = new Map()) {
    if ($cda9d0e1103d595f$export$213e2a3e7c4f326e(src) || !src || typeof src !== "object") return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $cda9d0e1103d595f$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $cda9d0e1103d595f$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($cda9d0e1103d595f$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $cda9d0e1103d595f$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $cda9d0e1103d595f$var$ReferenceSet();
        this._blacklist = new $cda9d0e1103d595f$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($cda9d0e1103d595f$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $cda9d0e1103d595f$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === "ignore-optionality";
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $cda9d0e1103d595f$var$isAbsent(result)) return result;
            let formattedValue = $cda9d0e1103d595f$export$5790025c6e6c2ba6(value);
            let formattedResult = $cda9d0e1103d595f$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError("Must include `key` or `index` for nested validations");
        const isIndex = typeof k === "number";
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? "index" : "key"]: k,
            path: isIndex || k.includes(".") ? `${parentPath || ""}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : "") + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $cda9d0e1103d595f$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $cda9d0e1103d595f$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this, options) : $cda9d0e1103d595f$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "nullable",
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "optionality",
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $cda9d0e1103d595f$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $cda9d0e1103d595f$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $cda9d0e1103d595f$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $cda9d0e1103d595f$var$mixed.default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = $cda9d0e1103d595f$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = $cda9d0e1103d595f$var$toArray(keys).map((key)=>new $cda9d0e1103d595f$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === "function" ? new $cda9d0e1103d595f$var$Condition(deps, options) : $cda9d0e1103d595f$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "typeError",
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $cda9d0e1103d595f$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "oneOf",
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $cda9d0e1103d595f$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
}
// @ts-expect-error
$cda9d0e1103d595f$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $cda9d0e1103d595f$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[alias] = $cda9d0e1103d595f$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[alias] = $cda9d0e1103d595f$export$19342e026b58ebb7.prototype.notOneOf;
const $cda9d0e1103d595f$var$returnsTrue = ()=>true;
function $cda9d0e1103d595f$export$9b30b6294c1449a8(spec) {
    return new $cda9d0e1103d595f$export$1e88358c94ddec71(spec);
}
class $cda9d0e1103d595f$export$1e88358c94ddec71 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === "function" ? {
            type: "mixed",
            check: spec
        } : Object.assign({
            type: "mixed",
            check: $cda9d0e1103d595f$var$returnsTrue
        }, spec));
    }
}
$cda9d0e1103d595f$export$9b30b6294c1449a8.prototype = $cda9d0e1103d595f$export$1e88358c94ddec71.prototype;
function $cda9d0e1103d595f$export$87b259aa03e3d267() {
    return new $cda9d0e1103d595f$export$c7980688f11e1f49();
}
class $cda9d0e1103d595f$export$c7980688f11e1f49 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "boolean",
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === "boolean";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $cda9d0e1103d595f$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return $cda9d0e1103d595f$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $cda9d0e1103d595f$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return $cda9d0e1103d595f$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$cda9d0e1103d595f$export$87b259aa03e3d267.prototype = $cda9d0e1103d595f$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $cda9d0e1103d595f$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $cda9d0e1103d595f$var$parseIsoDate(date) {
    const struct = $cda9d0e1103d595f$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== "Z" && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === "+") totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $cda9d0e1103d595f$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $cda9d0e1103d595f$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $cda9d0e1103d595f$var$toNumber(regexResult[1]),
        month: $cda9d0e1103d595f$var$toNumber(regexResult[2], 1) - 1,
        day: $cda9d0e1103d595f$var$toNumber(regexResult[3], 1),
        hour: $cda9d0e1103d595f$var$toNumber(regexResult[4]),
        minute: $cda9d0e1103d595f$var$toNumber(regexResult[5]),
        second: $cda9d0e1103d595f$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $cda9d0e1103d595f$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $cda9d0e1103d595f$var$toNumber(regexResult[10]),
        minuteOffset: $cda9d0e1103d595f$var$toNumber(regexResult[11])
    };
}
function $cda9d0e1103d595f$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $cda9d0e1103d595f$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $cda9d0e1103d595f$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $cda9d0e1103d595f$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $cda9d0e1103d595f$var$yearMonthDay = "^\\d{4}-\\d{2}-\\d{2}";
let $cda9d0e1103d595f$var$hourMinuteSecond = "\\d{2}:\\d{2}:\\d{2}";
let $cda9d0e1103d595f$var$zOrOffset = "(([+-]\\d{2}(:?\\d{2})?)|Z)";
let $cda9d0e1103d595f$var$rIsoDateTime = new RegExp(`${$cda9d0e1103d595f$var$yearMonthDay}T${$cda9d0e1103d595f$var$hourMinuteSecond}(\\.\\d+)?${$cda9d0e1103d595f$var$zOrOffset}$`);
let $cda9d0e1103d595f$var$isTrimmed = (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.trim();
let $cda9d0e1103d595f$var$objStringTag = ({}).toString();
function $cda9d0e1103d595f$export$22b082955e083ec3() {
    return new $cda9d0e1103d595f$export$49bf8b2ede5138eb();
}
class $cda9d0e1103d595f$export$49bf8b2ede5138eb extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "string",
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === "string";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $cda9d0e1103d595f$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $cda9d0e1103d595f$var$mixed.required,
                name: "required",
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== "required");
            return schema;
        });
    }
    length(length, message = $cda9d0e1103d595f$var$string.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $cda9d0e1103d595f$var$string.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$string.max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || $cda9d0e1103d595f$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $cda9d0e1103d595f$var$string.email) {
        return this.matches($cda9d0e1103d595f$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $cda9d0e1103d595f$var$string.url) {
        return this.matches($cda9d0e1103d595f$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $cda9d0e1103d595f$var$string.uuid) {
        return this.matches($cda9d0e1103d595f$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = "";
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === "object") ({ message: message = "", allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($cda9d0e1103d595f$var$rIsoDateTime, {
            name: "datetime",
            message: message || $cda9d0e1103d595f$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: "datetime_offset",
            message: message || $cda9d0e1103d595f$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $cda9d0e1103d595f$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: "datetime_precision",
            message: message || $cda9d0e1103d595f$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $cda9d0e1103d595f$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = $cda9d0e1103d595f$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $cda9d0e1103d595f$var$isTrimmed
        });
    }
    lowercase(message = $cda9d0e1103d595f$var$string.lowercase) {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $cda9d0e1103d595f$var$string.uppercase) {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$cda9d0e1103d595f$export$22b082955e083ec3.prototype = $cda9d0e1103d595f$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $cda9d0e1103d595f$var$isNaN$1 = (value)=>value != +value;
function $cda9d0e1103d595f$export$98e628dec113755e() {
    return new $cda9d0e1103d595f$export$f192ec5e9228ab19();
}
class $cda9d0e1103d595f$export$f192ec5e9228ab19 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "number",
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === "number" && !$cda9d0e1103d595f$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $cda9d0e1103d595f$var$number.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$number.max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $cda9d0e1103d595f$var$number.lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $cda9d0e1103d595f$var$number.moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $cda9d0e1103d595f$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $cda9d0e1103d595f$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $cda9d0e1103d595f$var$number.integer) {
        return this.test({
            name: "integer",
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round";
        // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$cda9d0e1103d595f$export$98e628dec113755e.prototype = $cda9d0e1103d595f$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $cda9d0e1103d595f$var$invalidDate = new Date("");
let $cda9d0e1103d595f$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $cda9d0e1103d595f$export$324d90190a8b822a() {
    return new $cda9d0e1103d595f$export$18ec3cc5a157503f();
}
class $cda9d0e1103d595f$export$18ec3cc5a157503f extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "date",
            check (v) {
                return $cda9d0e1103d595f$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $cda9d0e1103d595f$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $cda9d0e1103d595f$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$cda9d0e1103d595f$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $cda9d0e1103d595f$var$date.min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$date.max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$cda9d0e1103d595f$export$18ec3cc5a157503f.INVALID_DATE = $cda9d0e1103d595f$var$invalidDate;
$cda9d0e1103d595f$export$324d90190a8b822a.prototype = $cda9d0e1103d595f$export$18ec3cc5a157503f.prototype;
$cda9d0e1103d595f$export$324d90190a8b822a.INVALID_DATE = $cda9d0e1103d595f$var$invalidDate;
// @ts-expect-error
function $cda9d0e1103d595f$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $Sk64T.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($cda9d0e1103d595f$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($cda9d0e1103d595f$export$213e2a3e7c4f326e(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($dYCFZ))).array(Array.from(nodes), edges).reverse();
}
function $cda9d0e1103d595f$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $cda9d0e1103d595f$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $cda9d0e1103d595f$var$findIndex(keys, a) - $cda9d0e1103d595f$var$findIndex(keys, b);
    };
}
const $cda9d0e1103d595f$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== "string") return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $cda9d0e1103d595f$var$deepPartial(schema) {
    if ("fields" in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $cda9d0e1103d595f$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === "array") {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $cda9d0e1103d595f$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === "tuple") return schema.optional().clone({
        types: schema.spec.types.map($cda9d0e1103d595f$var$deepPartial)
    });
    if ("optional" in schema) return schema.optional();
    return schema;
}
const $cda9d0e1103d595f$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $Sk64T.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $Sk64T.getter)((0, $Sk64T.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $cda9d0e1103d595f$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $cda9d0e1103d595f$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $cda9d0e1103d595f$var$defaultSort = $cda9d0e1103d595f$var$sortByKeyOrder([]);
function $cda9d0e1103d595f$export$be5493f9613cbbe(spec) {
    return new $cda9d0e1103d595f$export$18b4fc70ec7eccf8(spec);
}
class $cda9d0e1103d595f$export$18b4fc70ec7eccf8 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: "object",
            check (value) {
                return $cda9d0e1103d595f$var$isObject(value) || typeof value === "function";
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $cda9d0e1103d595f$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $cda9d0e1103d595f$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$cda9d0e1103d595f$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $cda9d0e1103d595f$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ("default" in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && "getDefault" in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $cda9d0e1103d595f$var$sortFields(shape, excludedEdges);
        next._sortErrors = $cda9d0e1103d595f$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = "optional" in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $cda9d0e1103d595f$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $Sk64T.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($cda9d0e1103d595f$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($cda9d0e1103d595f$var$parseJson);
    }
    noUnknown(noAllow = true, message = $cda9d0e1103d595f$var$object.noUnknown) {
        if (typeof noAllow !== "boolean") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $cda9d0e1103d595f$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $cda9d0e1103d595f$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $i6Lf0.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $i6Lf0.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $i6Lf0.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$cda9d0e1103d595f$export$be5493f9613cbbe.prototype = $cda9d0e1103d595f$export$18b4fc70ec7eccf8.prototype;
function $cda9d0e1103d595f$export$2f23118c22fb2630(type) {
    return new $cda9d0e1103d595f$export$4347112b8447a7d(type);
}
class $cda9d0e1103d595f$export$4347112b8447a7d extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: "array",
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($cda9d0e1103d595f$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + $cda9d0e1103d595f$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $cda9d0e1103d595f$var$array.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $cda9d0e1103d595f$var$array.min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $cda9d0e1103d595f$var$array.max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$cda9d0e1103d595f$export$2f23118c22fb2630.prototype = $cda9d0e1103d595f$export$4347112b8447a7d.prototype;
// @ts-ignore
function $cda9d0e1103d595f$export$65e3907585753458(schemas) {
    return new $cda9d0e1103d595f$export$411c3b3687e8ecc8(schemas);
}
class $cda9d0e1103d595f$export$411c3b3687e8ecc8 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: "tuple",
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($cda9d0e1103d595f$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ""}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$cda9d0e1103d595f$export$65e3907585753458.prototype = $cda9d0e1103d595f$export$411c3b3687e8ecc8.prototype;
function $cda9d0e1103d595f$export$488013bae63b21da(builder) {
    return new $cda9d0e1103d595f$var$Lazy(builder);
}
class $cda9d0e1103d595f$var$Lazy {
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError("lazy() functions must return a valid schema");
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $cda9d0e1103d595f$var$Lazy(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return this._resolve(value, options).validate(value, options);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: "lazy",
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
}
function $cda9d0e1103d595f$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $cda9d0e1103d595f$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $cda9d0e1103d595f$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$cda9d0e1103d595f$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}

});
parcelRegister("Sk64T", function(module, exports) {
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $0a34a21cae127bf5$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$0a34a21cae127bf5$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$0a34a21cae127bf5$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$0a34a21cae127bf5$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $0a34a21cae127bf5$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $0a34a21cae127bf5$var$DIGIT_REGEX = /^\d+$/, $0a34a21cae127bf5$var$LEAD_DIGIT_REGEX = /^\d/, $0a34a21cae127bf5$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $0a34a21cae127bf5$var$MAX_CACHE_SIZE = 512;
var $0a34a21cae127bf5$var$pathCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$setCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$getCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE);
var $0a34a21cae127bf5$var$config;
module.exports = {
    Cache: $0a34a21cae127bf5$var$Cache,
    split: $0a34a21cae127bf5$var$split,
    normalizePath: $0a34a21cae127bf5$var$normalizePath,
    setter: function(path) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$setCache.get(path) || $0a34a21cae127bf5$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$getCache.get(path) || $0a34a21cae127bf5$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($0a34a21cae127bf5$var$isQuoted(part) || $0a34a21cae127bf5$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $0a34a21cae127bf5$var$forEach(Array.isArray(path) ? path : $0a34a21cae127bf5$var$split(path), cb, thisArg);
    }
};
function $0a34a21cae127bf5$var$normalizePath(path) {
    return $0a34a21cae127bf5$var$pathCache.get(path) || $0a34a21cae127bf5$var$pathCache.set(path, $0a34a21cae127bf5$var$split(path).map(function(part) {
        return part.replace($0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $0a34a21cae127bf5$var$split(path) {
    return path.match($0a34a21cae127bf5$var$SPLIT_REGEX) || [
        ""
    ];
}
function $0a34a21cae127bf5$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($0a34a21cae127bf5$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $0a34a21cae127bf5$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $0a34a21cae127bf5$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $0a34a21cae127bf5$var$hasLeadingNumber(part) {
    return part.match($0a34a21cae127bf5$var$LEAD_DIGIT_REGEX) && !part.match($0a34a21cae127bf5$var$DIGIT_REGEX);
}
function $0a34a21cae127bf5$var$hasSpecialChars(part) {
    return $0a34a21cae127bf5$var$SPEC_CHAR_REGEX.test(part);
}
function $0a34a21cae127bf5$var$shouldBeQuoted(part) {
    return !$0a34a21cae127bf5$var$isQuoted(part) && ($0a34a21cae127bf5$var$hasLeadingNumber(part) || $0a34a21cae127bf5$var$hasSpecialChars(part));
}

});

parcelRegister("i6Lf0", function(module, exports) {
const $d2ed6e977f19f182$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $d2ed6e977f19f182$var$words = (str)=>str.match($d2ed6e977f19f182$var$reWords) || [];
const $d2ed6e977f19f182$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $d2ed6e977f19f182$var$join = (str, d)=>$d2ed6e977f19f182$var$words(str).join(d).toLowerCase();
const $d2ed6e977f19f182$var$camelCase = (str)=>$d2ed6e977f19f182$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, "");
const $d2ed6e977f19f182$var$pascalCase = (str)=>$d2ed6e977f19f182$var$upperFirst($d2ed6e977f19f182$var$camelCase(str));
const $d2ed6e977f19f182$var$snakeCase = (str)=>$d2ed6e977f19f182$var$join(str, "_");
const $d2ed6e977f19f182$var$kebabCase = (str)=>$d2ed6e977f19f182$var$join(str, "-");
const $d2ed6e977f19f182$var$sentenceCase = (str)=>$d2ed6e977f19f182$var$upperFirst($d2ed6e977f19f182$var$join(str, " "));
const $d2ed6e977f19f182$var$titleCase = (str)=>$d2ed6e977f19f182$var$words(str).map($d2ed6e977f19f182$var$upperFirst).join(" ");
module.exports = {
    words: $d2ed6e977f19f182$var$words,
    upperFirst: $d2ed6e977f19f182$var$upperFirst,
    camelCase: $d2ed6e977f19f182$var$camelCase,
    pascalCase: $d2ed6e977f19f182$var$pascalCase,
    snakeCase: $d2ed6e977f19f182$var$snakeCase,
    kebabCase: $d2ed6e977f19f182$var$kebabCase,
    sentenceCase: $d2ed6e977f19f182$var$sentenceCase,
    titleCase: $d2ed6e977f19f182$var$titleCase
};

});

parcelRegister("dYCFZ", function(module, exports) {
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ module.exports = function(edges) {
    return $a2cee144eac47a21$var$toposort($a2cee144eac47a21$var$uniqueNodes(edges), edges);
};
module.exports.array = $a2cee144eac47a21$var$toposort;
function $a2cee144eac47a21$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $a2cee144eac47a21$var$makeOutgoingEdges(edges), nodesHash = $a2cee144eac47a21$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $a2cee144eac47a21$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $a2cee144eac47a21$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $a2cee144eac47a21$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}

});


parcelRegister("6f2mm", function(module, exports) {

$parcel$export(module.exports, "unflattenObject", () => $de83d8f5a9aac518$export$d8669a1344423b58);
$parcel$export(module.exports, "flattenObject", () => $de83d8f5a9aac518$export$de7358b4991653b1);
$parcel$export(module.exports, "findLength", () => $de83d8f5a9aac518$export$21508e55fd416102);
$parcel$export(module.exports, "isRequired", () => $de83d8f5a9aac518$export$669b575c90eb8624);
$parcel$export(module.exports, "hasRequiredField", () => $de83d8f5a9aac518$export$d200b8371bb1948e);

var $hEJWZ = parcelRequire("hEJWZ");
function $de83d8f5a9aac518$export$d8669a1344423b58(flatObject) {
    const nestedObject = {};
    for(const key in flatObject)if (Object.prototype.hasOwnProperty.call(flatObject, key)) {
        const value = flatObject[key];
        const keys = key.split(/\.|\[|\]\.?/).filter(Boolean);
        keys.reduce((acc, k, i)=>{
            if (i === keys.length - 1) acc[k] = value;
            else if (!acc[k]) acc[k] = isNaN(Number(keys[i + 1])) ? {} : [];
            return acc[k];
        }, nestedObject);
    }
    return nestedObject;
}
function $de83d8f5a9aac518$export$de7358b4991653b1(nestedObject, parentKey = "", result = {}) {
    for(const key in nestedObject)if (Object.prototype.hasOwnProperty.call(nestedObject, key)) {
        const newKey = parentKey ? `${parentKey}.${key}` : key;
        if (typeof nestedObject[key] === "object" && nestedObject[key] !== null && !Array.isArray(nestedObject[key])) $de83d8f5a9aac518$export$de7358b4991653b1(nestedObject[key], newKey, result);
        else if (Array.isArray(nestedObject[key])) {
            nestedObject[key].forEach((item, index)=>{
                $de83d8f5a9aac518$export$de7358b4991653b1(item, `${newKey}[${index}]`, result);
            });
            if (nestedObject[key].length === 0) result[newKey] = [];
        } else result[newKey] = nestedObject[key];
    }
    return result;
}
function $de83d8f5a9aac518$export$21508e55fd416102(obj, key) {
    const regex = new RegExp(`${key}\\[(\\d+)\\]`);
    let maxIndex = null;
    for(const objKey in obj)if (objKey.startsWith(key) && regex.test(objKey)) {
        const match = objKey.match(regex);
        const index = parseInt(match[1], 10);
        if (maxIndex === null || index > maxIndex) maxIndex = index;
    }
    return maxIndex === null ? maxIndex : maxIndex + 1;
}
const $de83d8f5a9aac518$var$getArraySegment = (segment)=>{
    const arrayMatch = segment.match(/(.+)\[(\d+)\]/);
    return arrayMatch ? arrayMatch[1] : segment;
};
const $de83d8f5a9aac518$var$getFieldByPath = (schemaDescription, path)=>{
    let currentSchema = schemaDescription;
    for (const segment of path){
        const arraySegment = $de83d8f5a9aac518$var$getArraySegment(segment);
        if (currentSchema && currentSchema.fields && currentSchema.fields[arraySegment]) {
            currentSchema = currentSchema.fields[arraySegment];
            if (currentSchema.type === "array") {
                if (segment === arraySegment) break;
                else currentSchema = currentSchema.innerType;
            }
        } else return null;
    }
    return currentSchema || null;
};
const $de83d8f5a9aac518$export$669b575c90eb8624 = (schema, fieldName)=>{
    if (!(0, $hEJWZ.isSchema)(schema)) return true;
    const path = fieldName.split(".");
    const schemaDescription = schema.describe();
    const fieldSchema = $de83d8f5a9aac518$var$getFieldByPath(schemaDescription, path);
    return fieldSchema ? !fieldSchema.optional : false;
};
const $de83d8f5a9aac518$export$d200b8371bb1948e = (schema)=>{
    const { fields: fields } = schema.describe();
    for(const key in fields){
        //@ts-expect-error yup lib typing
        if (!fields[key].optional) return true;
    }
    return false;
}; // Example usage
 // const values = {
 //   "callouts[0].name": "Name 1",
 //   "callouts[0].value": 0,
 //   "callouts[1].name": "Name 2",
 // };
 // console.log(findMaxIndex(values, "callouts")); // Output: 1
 // console.log(findMaxIndex(values, "highlights")); // Output: 0
 // console.log(findMaxIndex(values, "name")); // Output: null
 // const values = {
 //   "callouts[0].name": "Name 1",
 //   "callouts[0].value": 0,
 //   "callouts[1].name": "Name 2",
 //   "highlights[0].icon": "dollar",
 //   name: "Deal name",
 // };
 // const nestedValues = {
 //   callouts: [{ name: "Name 1", value: 0 }, { name: "Name 2" }],
 //   highlights: [{ icon: "dollar" }],
 //   name: "Deal name",
 // };
 // console.log(
 //   JSON.stringify(unflattenObject(values)) === JSON.stringify(nestedValues)
 // );
 // console.log(
 //   JSON.stringify(flattenObject(nestedValues)) === JSON.stringify(values)
 // );

});



parcelRegister("k8Nfm", function(module, exports) {

$parcel$export(module.exports, "FormModal", () => $9620551cbe573af7$export$f96f65abaf57736e);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("3jkAh");
var $dtQ0k = parcelRequire("dtQ0k");
var $41p3a = parcelRequire("41p3a");
parcelRequire("5R0Xk");
var $5Ttm9 = parcelRequire("5Ttm9");

var $hQ0nj = parcelRequire("hQ0nj");

var $acw62 = parcelRequire("acw62");

var $6f2mm = parcelRequire("6f2mm");
function $9620551cbe573af7$export$f96f65abaf57736e({ id: id, isOpen: isOpen, title: title, description: description, schema: schema, children: children, submitPending: submitPending = false, onChange: onChange, onSubmit: onSubmit, onCancel: onCancel, cancelLabel: cancelLabel = "Cancel", submitLabel: submitLabel = "Save", ...rest }) {
    const hasRequired = (0, $6f2mm.hasRequiredField)(schema);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dtQ0k.Modal), {
        isOpen: isOpen,
        title: title,
        description: description,
        className: "w-[702px]",
        withTransitions: true,
        testId: `modal:${id}`,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hQ0nj.Form), {
            id: id,
            schema: schema,
            onChange: onChange,
            onSubmit: onSubmit,
            ...rest,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "px-8",
                    children: [
                        children,
                        hasRequired && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mt-2 flex items-baseline gap-1",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "ui-element text-red-400",
                                    children: "*"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "body-micro",
                                    children: "Required fields"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($9620551cbe573af7$var$FormModalFooter, {
                    formId: id,
                    cancelLabel: cancelLabel,
                    submitLabel: submitLabel,
                    onCancel: onCancel,
                    submitPending: submitPending
                })
            ]
        })
    });
}
function $9620551cbe573af7$var$FormModalFooter({ formId: formId, onCancel: onCancel, submitPending: submitPending, cancelLabel: cancelLabel, submitLabel: submitLabel }) {
    const form = (0, $acw62.useContext)((0, $hQ0nj.FormContext));
    if (!form) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $41p3a.ModalFooter), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: "secondary",
                onClick: onCancel,
                children: cancelLabel
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                className: "inline-flex gap-2",
                disabled: !form.canSubmit,
                type: "submit",
                form: formId,
                children: [
                    submitLabel,
                    submitPending && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {})
                ]
            })
        ]
    });
}

});


parcelRegister("bApKI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $092dae7f98e3bc3e$export$f5b8910cec6cf069);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $a6Thc = parcelRequire("a6Thc");

var $hQ0nj = parcelRequire("hQ0nj");

var $6f2mm = parcelRequire("6f2mm");
function $092dae7f98e3bc3e$export$f5b8910cec6cf069({ number: number = false, readonly: readonly = false, parent: parent = "", ...props }) {
    const [touched, setTouched] = (0, $acw62.useState)(false);
    const name = parent ? `${parent}.${props.name}` : props.name;
    const form = (0, $acw62.useContext)((0, $hQ0nj.FormContext));
    if (!form) return null;
    const error = form.errors?.[name] || "";
    const showError = touched && error && !error.toLowerCase().includes("required");
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6Thc.RawInput), {
        ...props,
        name: name,
        readOnly: readonly,
        mask: props.mask,
        maskChar: props.maskChar,
        placeholder: props.placeholder,
        required: (0, $6f2mm.isRequired)(form.schema, name),
        onChange: (e)=>{
            let value = e.target.value;
            if (number) {
                const stringValue = e.target.value;
                if (stringValue === "" || stringValue === "-" || stringValue.endsWith(".")) value = stringValue;
                else {
                    const numValue = parseFloat(stringValue);
                    value = isNaN(numValue) ? stringValue : numValue;
                }
            }
            setTouched(true);
            form.updateValue(name, value);
        },
        disabled: props.disabled,
        onBlur: ()=>setTouched(true),
        value: form.values[name] || "",
        errorMessage: showError ? form.errors?.[name] : undefined,
        showErrorRing: Boolean(touched && error),
        tooltip: props.tooltip
    });
}

});
parcelRegister("a6Thc", function(module, exports) {

$parcel$export(module.exports, "RawInput", () => $9a1688934b91ebb6$export$e8a9bd730955d900);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $9RcbH = parcelRequire("9RcbH");

var $bhkIv = parcelRequire("bhkIv");

var $dHBXt = parcelRequire("dHBXt");

var $j46bT = parcelRequire("j46bT");
function $9a1688934b91ebb6$export$e8a9bd730955d900({ name: name, label: label, errorMessage: errorMessage, showErrorRing: showErrorRing, required: required, placeholder: placeholder, mask: mask, maskChar: maskChar, tooltip: tooltip, showLabel: showLabel = true, ...props }) {
    const describedBy = props["aria-describedby"] || `${name}-error`;
    const InputComponent = mask ? (0, (/*@__PURE__*/$parcel$interopDefault($dHBXt))) : "input";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    showLabel && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bhkIv.Label), {
                        name: name,
                        label: label,
                        required: required
                    }),
                    tooltip && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "tt-trigger group hidden md:block",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j46bT.default), {
                                className: "size-4 fill-gray-500"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "tt-container tt-bottom",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tt",
                                    children: tooltip
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(InputComponent, {
                id: name,
                "data-testid": `input-${name}`,
                name: name,
                mask: mask || "",
                maskChar: maskChar,
                disabled: props.disabled,
                placeholder: placeholder || "",
                className: (0, $9QePP.default)("border-default rounded border outline-none", "placeholder:text-slate-500", "focus:ring-transparent focus:placeholder:text-transparent", (errorMessage || showErrorRing) && "ml-px border-transparent ring-1 ring-red-600 focus:border-transparent focus:ring-red-600", props.disabled && "cursor-not-allowed bg-white/20"),
                "aria-required": required,
                required: required,
                ...props
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("overflow-hidden transition-all duration-300", errorMessage ? "h-6 opacity-100" : "h-0 opacity-0"),
                children: errorMessage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9RcbH.ErrorMessage), {
                    id: describedBy,
                    message: errorMessage
                })
            })
        ]
    });
}

});
parcelRegister("9RcbH", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", () => $6b29217f5123af13$export$915e9e7bd4f0f96d);

var $ayMG0 = parcelRequire("ayMG0");
function $6b29217f5123af13$export$915e9e7bd4f0f96d({ id: id, message: message }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        id: id,
        className: "ui-element subdued",
        children: message
    });
}

});

parcelRegister("bhkIv", function(module, exports) {

$parcel$export(module.exports, "Label", () => $6e23b41b6efa8bd1$export$b04be29aa201d4f5);

var $ayMG0 = parcelRequire("ayMG0");
function $6e23b41b6efa8bd1$export$b04be29aa201d4f5({ name: name, label: label, required: required = false }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex gap-1",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                htmlFor: name,
                children: label
            }),
            required && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "sr-only",
                        children: `${label} is required`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "ui-element text-red-400",
                        children: "*"
                    })
                ]
            })
        ]
    });
}

});

parcelRegister("dHBXt", function(module, exports) {

module.exports = (parcelRequire("c2cFF"));

});
parcelRegister("c2cFF", function(module, exports) {
"use strict";
function $8c2f801fb933983e$var$_interopDefault(e) {
    return e && "object" == typeof e && "default" in e ? e["default"] : e;
}

var $8c2f801fb933983e$var$React = $8c2f801fb933983e$var$_interopDefault((parcelRequire("acw62")));

var $1u0KT = parcelRequire("1u0KT");
function $8c2f801fb933983e$var$_defaults2(e, t) {
    for(var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++){
        var i = n[a], r = Object.getOwnPropertyDescriptor(t, i);
        r && r.configurable && e[i] === undefined && Object.defineProperty(e, i, r);
    }
    return e;
}
function $8c2f801fb933983e$var$_extends() {
    return ($8c2f801fb933983e$var$_extends = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var a in n)Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
        }
        return e;
    }).apply(this, arguments);
}
function $8c2f801fb933983e$var$_inheritsLoose(e, t) {
    e.prototype = Object.create(t.prototype), $8c2f801fb933983e$var$_defaults2(e.prototype.constructor = e, t);
}
function $8c2f801fb933983e$var$_objectWithoutPropertiesLoose(e, t) {
    if (null == e) return {};
    var n, a, i = {}, r = Object.keys(e);
    for(a = 0; a < r.length; a++)n = r[a], 0 <= t.indexOf(n) || (i[n] = e[n]);
    return i;
}
function $8c2f801fb933983e$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
var $8c2f801fb933983e$var$invariant = function(e, t, n, a, i, r, o, s) {
    if (!e) {
        var l;
        if (t === undefined) l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var u = [
                n,
                a,
                i,
                r,
                o,
                s
            ], c = 0;
            (l = new Error(t.replace(/%s/g, function() {
                return u[c++];
            }))).name = "Invariant Violation";
        }
        throw l.framesToPop = 1, l;
    }
}, $8c2f801fb933983e$var$invariant_1 = $8c2f801fb933983e$var$invariant;
function $8c2f801fb933983e$var$setInputSelection(e, t, n) {
    if ("selectionStart" in e && "selectionEnd" in e) e.selectionStart = t, e.selectionEnd = n;
    else {
        var a = e.createTextRange();
        a.collapse(!0), a.moveStart("character", t), a.moveEnd("character", n - t), a.select();
    }
}
function $8c2f801fb933983e$var$getInputSelection(e) {
    var t = 0, n = 0;
    if ("selectionStart" in e && "selectionEnd" in e) t = e.selectionStart, n = e.selectionEnd;
    else {
        var a = document.selection.createRange();
        a.parentElement() === e && (t = -a.moveStart("character", -e.value.length), n = -a.moveEnd("character", -e.value.length));
    }
    return {
        start: t,
        end: n,
        length: n - t
    };
}
var $8c2f801fb933983e$var$defaultFormatChars = {
    9: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]"
}, $8c2f801fb933983e$var$defaultMaskChar = "_";
function $8c2f801fb933983e$var$parseMask(e, t, n) {
    var a = "", i = "", r = null, o = [];
    if (t === undefined && (t = $8c2f801fb933983e$var$defaultMaskChar), null == n && (n = $8c2f801fb933983e$var$defaultFormatChars), !e || "string" != typeof e) return {
        maskChar: t,
        formatChars: n,
        mask: null,
        prefix: null,
        lastEditablePosition: null,
        permanents: []
    };
    var s = !1;
    return e.split("").forEach(function(e) {
        s = !s && "\\" === e || (s || !n[e] ? (o.push(a.length), a.length === o.length - 1 && (i += e)) : r = a.length + 1, a += e, !1);
    }), {
        maskChar: t,
        formatChars: n,
        prefix: i,
        mask: a,
        lastEditablePosition: r,
        permanents: o
    };
}
function $8c2f801fb933983e$var$isPermanentCharacter(e, t) {
    return -1 !== e.permanents.indexOf(t);
}
function $8c2f801fb933983e$var$isAllowedCharacter(e, t, n) {
    var a = e.mask, i = e.formatChars;
    if (!n) return !1;
    if ($8c2f801fb933983e$var$isPermanentCharacter(e, t)) return a[t] === n;
    var r = i[a[t]];
    return new RegExp(r).test(n);
}
function $8c2f801fb933983e$var$isEmpty(n, e) {
    return e.split("").every(function(e, t) {
        return $8c2f801fb933983e$var$isPermanentCharacter(n, t) || !$8c2f801fb933983e$var$isAllowedCharacter(n, t, e);
    });
}
function $8c2f801fb933983e$var$getFilledLength(e, t) {
    var n = e.maskChar, a = e.prefix;
    if (!n) {
        for(; t.length > a.length && $8c2f801fb933983e$var$isPermanentCharacter(e, t.length - 1);)t = t.slice(0, t.length - 1);
        return t.length;
    }
    for(var i = a.length, r = t.length; r >= a.length; r--){
        var o = t[r];
        if (!$8c2f801fb933983e$var$isPermanentCharacter(e, r) && $8c2f801fb933983e$var$isAllowedCharacter(e, r, o)) {
            i = r + 1;
            break;
        }
    }
    return i;
}
function $8c2f801fb933983e$var$isFilled(e, t) {
    return $8c2f801fb933983e$var$getFilledLength(e, t) === e.mask.length;
}
function $8c2f801fb933983e$var$formatValue(e, t) {
    var n = e.maskChar, a = e.mask, i = e.prefix;
    if (!n) {
        for((t = $8c2f801fb933983e$var$insertString(e, "", t, 0)).length < i.length && (t = i); t.length < a.length && $8c2f801fb933983e$var$isPermanentCharacter(e, t.length);)t += a[t.length];
        return t;
    }
    if (t) return $8c2f801fb933983e$var$insertString(e, $8c2f801fb933983e$var$formatValue(e, ""), t, 0);
    for(var r = 0; r < a.length; r++)$8c2f801fb933983e$var$isPermanentCharacter(e, r) ? t += a[r] : t += n;
    return t;
}
function $8c2f801fb933983e$var$clearRange(n, e, a, t) {
    var i = a + t, r = n.maskChar, o = n.mask, s = n.prefix, l = e.split("");
    if (r) return l.map(function(e, t) {
        return t < a || i <= t ? e : $8c2f801fb933983e$var$isPermanentCharacter(n, t) ? o[t] : r;
    }).join("");
    for(var u = i; u < l.length; u++)$8c2f801fb933983e$var$isPermanentCharacter(n, u) && (l[u] = "");
    return a = Math.max(s.length, a), l.splice(a, i - a), e = l.join(""), $8c2f801fb933983e$var$formatValue(n, e);
}
function $8c2f801fb933983e$var$insertString(r, o, e, s) {
    var l = r.mask, u = r.maskChar, c = r.prefix, t = e.split(""), h = $8c2f801fb933983e$var$isFilled(r, o);
    return !u && s > o.length && (o += l.slice(o.length, s)), t.every(function(e) {
        for(; i = e, $8c2f801fb933983e$var$isPermanentCharacter(r, a = s) && i !== l[a];){
            if (s >= o.length && (o += l[s]), t = e, n = s, u && $8c2f801fb933983e$var$isPermanentCharacter(r, n) && t === u) return !0;
            if (++s >= l.length) return !1;
        }
        var t, n, a, i;
        return !$8c2f801fb933983e$var$isAllowedCharacter(r, s, e) && e !== u || (s < o.length ? o = u || h || s < c.length ? o.slice(0, s) + e + o.slice(s + 1) : (o = o.slice(0, s) + e + o.slice(s), $8c2f801fb933983e$var$formatValue(r, o)) : u || (o += e), ++s < l.length);
    }), o;
}
function $8c2f801fb933983e$var$getInsertStringLength(a, e, t, i) {
    var r = a.mask, o = a.maskChar, n = t.split(""), s = i;
    return n.every(function(e) {
        for(; n = e, $8c2f801fb933983e$var$isPermanentCharacter(a, t = i) && n !== r[t];)if (++i >= r.length) return !1;
        var t, n;
        return ($8c2f801fb933983e$var$isAllowedCharacter(a, i, e) || e === o) && i++, i < r.length;
    }), i - s;
}
function $8c2f801fb933983e$var$getLeftEditablePosition(e, t) {
    for(var n = t; 0 <= n; --n)if (!$8c2f801fb933983e$var$isPermanentCharacter(e, n)) return n;
    return null;
}
function $8c2f801fb933983e$var$getRightEditablePosition(e, t) {
    for(var n = e.mask, a = t; a < n.length; ++a)if (!$8c2f801fb933983e$var$isPermanentCharacter(e, a)) return a;
    return null;
}
function $8c2f801fb933983e$var$getStringValue(e) {
    return e || 0 === e ? e + "" : "";
}
function $8c2f801fb933983e$var$processChange(e, t, n, a, i) {
    var r = e.mask, o = e.prefix, s = e.lastEditablePosition, l = t, u = "", c = 0, h = 0, f = Math.min(i.start, n.start);
    if (n.end > i.start ? h = (c = $8c2f801fb933983e$var$getInsertStringLength(e, a, u = l.slice(i.start, n.end), f)) ? i.length : 0 : l.length < a.length && (h = a.length - l.length), l = a, h) {
        if (1 === h && !i.length) f = i.start === n.start ? $8c2f801fb933983e$var$getRightEditablePosition(e, n.start) : $8c2f801fb933983e$var$getLeftEditablePosition(e, n.start);
        l = $8c2f801fb933983e$var$clearRange(e, l, f, h);
    }
    return l = $8c2f801fb933983e$var$insertString(e, l, u, f), (f += c) >= r.length ? f = r.length : f < o.length && !c ? f = o.length : f >= o.length && f < s && c && (f = $8c2f801fb933983e$var$getRightEditablePosition(e, f)), u || (u = null), {
        value: l = $8c2f801fb933983e$var$formatValue(e, l),
        enteredString: u,
        selection: {
            start: f,
            end: f
        }
    };
}
function $8c2f801fb933983e$var$isWindowsPhoneBrowser() {
    var e = new RegExp("windows", "i"), t = new RegExp("phone", "i"), n = navigator.userAgent;
    return e.test(n) && t.test(n);
}
function $8c2f801fb933983e$var$isFunction(e) {
    return "function" == typeof e;
}
function $8c2f801fb933983e$var$getRequestAnimationFrame() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
}
function $8c2f801fb933983e$var$getCancelAnimationFrame() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
}
function $8c2f801fb933983e$var$defer(e) {
    return (!!$8c2f801fb933983e$var$getCancelAnimationFrame() ? $8c2f801fb933983e$var$getRequestAnimationFrame() : function() {
        return setTimeout(e, 1e3 / 60);
    })(e);
}
function $8c2f801fb933983e$var$cancelDefer(e) {
    ($8c2f801fb933983e$var$getCancelAnimationFrame() || clearTimeout)(e);
}
var $8c2f801fb933983e$var$InputElement = function(c) {
    function e(e) {
        var f = c.call(this, e) || this;
        f.focused = !1, f.mounted = !1, f.previousSelection = null, f.selectionDeferId = null, f.saveSelectionLoopDeferId = null, f.saveSelectionLoop = function() {
            f.previousSelection = f.getSelection(), f.saveSelectionLoopDeferId = $8c2f801fb933983e$var$defer(f.saveSelectionLoop);
        }, f.runSaveSelectionLoop = function() {
            null === f.saveSelectionLoopDeferId && f.saveSelectionLoop();
        }, f.stopSaveSelectionLoop = function() {
            null !== f.saveSelectionLoopDeferId && ($8c2f801fb933983e$var$cancelDefer(f.saveSelectionLoopDeferId), f.saveSelectionLoopDeferId = null, f.previousSelection = null);
        }, f.getInputDOMNode = function() {
            if (!f.mounted) return null;
            var e = $1u0KT.findDOMNode($8c2f801fb933983e$var$_assertThisInitialized($8c2f801fb933983e$var$_assertThisInitialized(f))), t = "undefined" != typeof window && e instanceof window.Element;
            if (e && !t) return null;
            if ("INPUT" !== e.nodeName && (e = e.querySelector("input")), !e) throw new Error("react-input-mask: inputComponent doesn't contain input node");
            return e;
        }, f.getInputValue = function() {
            var e = f.getInputDOMNode();
            return e ? e.value : null;
        }, f.setInputValue = function(e) {
            var t = f.getInputDOMNode();
            t && (f.value = e, t.value = e);
        }, f.setCursorToEnd = function() {
            var e = $8c2f801fb933983e$var$getFilledLength(f.maskOptions, f.value), t = $8c2f801fb933983e$var$getRightEditablePosition(f.maskOptions, e);
            null !== t && f.setCursorPosition(t);
        }, f.setSelection = function(e, t, n) {
            void 0 === n && (n = {});
            var a = f.getInputDOMNode(), i = f.isFocused();
            a && i && (n.deferred || $8c2f801fb933983e$var$setInputSelection(a, e, t), null !== f.selectionDeferId && $8c2f801fb933983e$var$cancelDefer(f.selectionDeferId), f.selectionDeferId = $8c2f801fb933983e$var$defer(function() {
                f.selectionDeferId = null, $8c2f801fb933983e$var$setInputSelection(a, e, t);
            }), f.previousSelection = {
                start: e,
                end: t,
                length: Math.abs(t - e)
            });
        }, f.getSelection = function() {
            return $8c2f801fb933983e$var$getInputSelection(f.getInputDOMNode());
        }, f.getCursorPosition = function() {
            return f.getSelection().start;
        }, f.setCursorPosition = function(e) {
            f.setSelection(e, e);
        }, f.isFocused = function() {
            return f.focused;
        }, f.getBeforeMaskedValueChangeConfig = function() {
            var e = f.maskOptions, t = e.mask, n = e.maskChar, a = e.permanents, i = e.formatChars;
            return {
                mask: t,
                maskChar: n,
                permanents: a,
                alwaysShowMask: !!f.props.alwaysShowMask,
                formatChars: i
            };
        }, f.isInputAutofilled = function(e, t, n, a) {
            var i = f.getInputDOMNode();
            try {
                if (i.matches(":-webkit-autofill")) return !0;
            } catch (r) {}
            return !f.focused || a.end < n.length && t.end === e.length;
        }, f.onChange = function(e) {
            var t = $8c2f801fb933983e$var$_assertThisInitialized($8c2f801fb933983e$var$_assertThisInitialized(f)).beforePasteState, n = $8c2f801fb933983e$var$_assertThisInitialized($8c2f801fb933983e$var$_assertThisInitialized(f)).previousSelection, a = f.props.beforeMaskedValueChange, i = f.getInputValue(), r = f.value, o = f.getSelection();
            f.isInputAutofilled(i, o, r, n) && (r = $8c2f801fb933983e$var$formatValue(f.maskOptions, ""), n = {
                start: 0,
                end: 0,
                length: 0
            }), t && (n = t.selection, r = t.value, o = {
                start: n.start + i.length,
                end: n.start + i.length,
                length: 0
            }, i = r.slice(0, n.start) + i + r.slice(n.end), f.beforePasteState = null);
            var s = $8c2f801fb933983e$var$processChange(f.maskOptions, i, o, r, n), l = s.enteredString, u = s.selection, c = s.value;
            if ($8c2f801fb933983e$var$isFunction(a)) {
                var h = a({
                    value: c,
                    selection: u
                }, {
                    value: r,
                    selection: n
                }, l, f.getBeforeMaskedValueChangeConfig());
                c = h.value, u = h.selection;
            }
            f.setInputValue(c), $8c2f801fb933983e$var$isFunction(f.props.onChange) && f.props.onChange(e), f.isWindowsPhoneBrowser ? f.setSelection(u.start, u.end, {
                deferred: !0
            }) : f.setSelection(u.start, u.end);
        }, f.onFocus = function(e) {
            var t = f.props.beforeMaskedValueChange, n = f.maskOptions, a = n.mask, i = n.prefix;
            if (f.focused = !0, f.mounted = !0, a) {
                if (f.value) $8c2f801fb933983e$var$getFilledLength(f.maskOptions, f.value) < f.maskOptions.mask.length && f.setCursorToEnd();
                else {
                    var r = $8c2f801fb933983e$var$formatValue(f.maskOptions, i), o = $8c2f801fb933983e$var$formatValue(f.maskOptions, r), s = $8c2f801fb933983e$var$getFilledLength(f.maskOptions, o), l = $8c2f801fb933983e$var$getRightEditablePosition(f.maskOptions, s), u = {
                        start: l,
                        end: l
                    };
                    if ($8c2f801fb933983e$var$isFunction(t)) {
                        var c = t({
                            value: o,
                            selection: u
                        }, {
                            value: f.value,
                            selection: null
                        }, null, f.getBeforeMaskedValueChangeConfig());
                        o = c.value, u = c.selection;
                    }
                    var h = o !== f.getInputValue();
                    h && f.setInputValue(o), h && $8c2f801fb933983e$var$isFunction(f.props.onChange) && f.props.onChange(e), f.setSelection(u.start, u.end);
                }
                f.runSaveSelectionLoop();
            }
            $8c2f801fb933983e$var$isFunction(f.props.onFocus) && f.props.onFocus(e);
        }, f.onBlur = function(e) {
            var t = f.props.beforeMaskedValueChange, n = f.maskOptions.mask;
            if (f.stopSaveSelectionLoop(), f.focused = !1, n && !f.props.alwaysShowMask && $8c2f801fb933983e$var$isEmpty(f.maskOptions, f.value)) {
                var a = "";
                if ($8c2f801fb933983e$var$isFunction(t)) a = t({
                    value: a,
                    selection: null
                }, {
                    value: f.value,
                    selection: f.previousSelection
                }, null, f.getBeforeMaskedValueChangeConfig()).value;
                var i = a !== f.getInputValue();
                i && f.setInputValue(a), i && $8c2f801fb933983e$var$isFunction(f.props.onChange) && f.props.onChange(e);
            }
            $8c2f801fb933983e$var$isFunction(f.props.onBlur) && f.props.onBlur(e);
        }, f.onMouseDown = function(e) {
            if (!f.focused && document.addEventListener) {
                f.mouseDownX = e.clientX, f.mouseDownY = e.clientY, f.mouseDownTime = (new Date).getTime();
                var r = function r(e) {
                    if (document.removeEventListener("mouseup", r), f.focused) {
                        var t = Math.abs(e.clientX - f.mouseDownX), n = Math.abs(e.clientY - f.mouseDownY), a = Math.max(t, n), i = (new Date).getTime() - f.mouseDownTime;
                        (a <= 10 && i <= 200 || a <= 5 && i <= 300) && f.setCursorToEnd();
                    }
                };
                document.addEventListener("mouseup", r);
            }
            $8c2f801fb933983e$var$isFunction(f.props.onMouseDown) && f.props.onMouseDown(e);
        }, f.onPaste = function(e) {
            $8c2f801fb933983e$var$isFunction(f.props.onPaste) && f.props.onPaste(e), e.defaultPrevented || (f.beforePasteState = {
                value: f.getInputValue(),
                selection: f.getSelection()
            }, f.setInputValue(""));
        }, f.handleRef = function(e) {
            null == f.props.children && $8c2f801fb933983e$var$isFunction(f.props.inputRef) && f.props.inputRef(e);
        };
        var t = e.mask, n = e.maskChar, a = e.formatChars, i = e.alwaysShowMask, r = e.beforeMaskedValueChange, o = e.defaultValue, s = e.value;
        f.maskOptions = $8c2f801fb933983e$var$parseMask(t, n, a), null == o && (o = ""), null == s && (s = o);
        var l = $8c2f801fb933983e$var$getStringValue(s);
        if (f.maskOptions.mask && (i || l) && (l = $8c2f801fb933983e$var$formatValue(f.maskOptions, l), $8c2f801fb933983e$var$isFunction(r))) {
            var u = e.value;
            null == e.value && (u = o), l = r({
                value: l,
                selection: null
            }, {
                value: u = $8c2f801fb933983e$var$getStringValue(u),
                selection: null
            }, null, f.getBeforeMaskedValueChangeConfig()).value;
        }
        return f.value = l, f;
    }
    $8c2f801fb933983e$var$_inheritsLoose(e, c);
    var t = e.prototype;
    return t.componentDidMount = function() {
        this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = $8c2f801fb933983e$var$isWindowsPhoneBrowser(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, t.componentDidUpdate = function() {
        var e = this.previousSelection, t = this.props, n = t.beforeMaskedValueChange, a = t.alwaysShowMask, i = t.mask, r = t.maskChar, o = t.formatChars, s = this.maskOptions, l = a || this.isFocused(), u = null != this.props.value, c = u ? $8c2f801fb933983e$var$getStringValue(this.props.value) : this.value, h = e ? e.start : null;
        if (this.maskOptions = $8c2f801fb933983e$var$parseMask(i, r, o), this.maskOptions.mask) {
            !s.mask && this.isFocused() && this.runSaveSelectionLoop();
            var f = this.maskOptions.mask && this.maskOptions.mask !== s.mask;
            if (s.mask || u || (c = this.getInputValue()), (f || this.maskOptions.mask && (c || l)) && (c = $8c2f801fb933983e$var$formatValue(this.maskOptions, c)), f) {
                var p = $8c2f801fb933983e$var$getFilledLength(this.maskOptions, c);
                (null === h || p < h) && (h = $8c2f801fb933983e$var$isFilled(this.maskOptions, c) ? p : $8c2f801fb933983e$var$getRightEditablePosition(this.maskOptions, p));
            }
            !this.maskOptions.mask || !$8c2f801fb933983e$var$isEmpty(this.maskOptions, c) || l || u && this.props.value || (c = "");
            var d = {
                start: h,
                end: h
            };
            if ($8c2f801fb933983e$var$isFunction(n)) {
                var m = n({
                    value: c,
                    selection: d
                }, {
                    value: this.value,
                    selection: this.previousSelection
                }, null, this.getBeforeMaskedValueChangeConfig());
                c = m.value, d = m.selection;
            }
            this.value = c;
            var g = this.getInputValue() !== this.value;
            g ? (this.setInputValue(this.value), this.forceUpdate()) : f && this.forceUpdate();
            var v = !1;
            null != d.start && null != d.end && (v = !e || e.start !== d.start || e.end !== d.end), (v || g) && this.setSelection(d.start, d.end);
        } else s.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
    }, t.componentWillUnmount = function() {
        this.mounted = !1, null !== this.selectionDeferId && $8c2f801fb933983e$var$cancelDefer(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, t.render = function() {
        var t, e = this.props, n = (e.mask, e.alwaysShowMask, e.maskChar, e.formatChars, e.inputRef, e.beforeMaskedValueChange, e.children), a = $8c2f801fb933983e$var$_objectWithoutPropertiesLoose(e, [
            "mask",
            "alwaysShowMask",
            "maskChar",
            "formatChars",
            "inputRef",
            "beforeMaskedValueChange",
            "children"
        ]);
        if (n) {
            $8c2f801fb933983e$var$isFunction(n) || $8c2f801fb933983e$var$invariant_1(!1);
            var i = [
                "onChange",
                "onPaste",
                "onMouseDown",
                "onFocus",
                "onBlur",
                "value",
                "disabled",
                "readOnly"
            ], r = $8c2f801fb933983e$var$_extends({}, a);
            i.forEach(function(e) {
                return delete r[e];
            }), t = n(r), i.filter(function(e) {
                return null != t.props[e] && t.props[e] !== a[e];
            }).length && $8c2f801fb933983e$var$invariant_1(!1);
        } else t = $8c2f801fb933983e$var$React.createElement("input", $8c2f801fb933983e$var$_extends({
            ref: this.handleRef
        }, a));
        var o = {
            onFocus: this.onFocus,
            onBlur: this.onBlur
        };
        return this.maskOptions.mask && (a.disabled || a.readOnly || (o.onChange = this.onChange, o.onPaste = this.onPaste, o.onMouseDown = this.onMouseDown), null != a.value && (o.value = this.value)), t = $8c2f801fb933983e$var$React.cloneElement(t, o);
    }, e;
}($8c2f801fb933983e$var$React.Component);
module.exports = $8c2f801fb933983e$var$InputElement;

});


parcelRegister("j46bT", function(module, exports) {

$parcel$export(module.exports, "default", () => $de133166822b59c9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $de133166822b59c9$var$InformationCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
        clipRule: "evenodd"
    }));
}
const $de133166822b59c9$var$ForwardRef = $acw62.forwardRef($de133166822b59c9$var$InformationCircleIcon);
var $de133166822b59c9$export$2e2bcd8739ae039 = $de133166822b59c9$var$ForwardRef;

});



parcelRegister("7JqhK", function(module, exports) {

$parcel$export(module.exports, "Money", () => $cf10304534cd6863$export$d26bcf891bc220f6);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $hQ0nj = parcelRequire("hQ0nj");

var $lrVF0 = parcelRequire("lrVF0");

var $9QePP = parcelRequire("9QePP");

var $6f2mm = parcelRequire("6f2mm");

var $9RcbH = parcelRequire("9RcbH");
function $cf10304534cd6863$export$d26bcf891bc220f6({ label: label, readonly: readonly = false, placeholder: placeholder, parent: parent = "", ...props }) {
    const [touched, setTouched] = (0, $acw62.useState)(false);
    const [inputError, setInputError] = (0, $acw62.useState)(false);
    const form = (0, $acw62.useContext)((0, $hQ0nj.FormContext));
    const name = parent ? `${parent}.${props.name}` : props.name;
    if (!form) return null;
    const error = form.errors?.[name] || "";
    const showError = !inputError && touched && error && !error.toLowerCase().includes("required");
    const showErrorRing = touched && (error || inputError);
    const describedBy = `${name}-error`;
    const required = (0, $6f2mm.isRequired)(form.schema, name);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex gap-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    required && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "ui-element text-red-400",
                        children: "*"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lrVF0.NumericFormat), {
                "aria-describedby": describedBy,
                allowNegative: false,
                thousandSeparator: ",",
                prefix: "$",
                decimalScale: 0,
                name: name,
                id: name,
                disabled: props.disabled,
                onValueChange: (v)=>{
                    const value = v.value;
                    form.updateValue(name, value ? +value : undefined);
                },
                value: form.values[name] ?? "",
                type: "text",
                placeholder: placeholder,
                readOnly: readonly,
                onBlur: ()=>{
                    setInputError(false);
                },
                onFocus: ()=>{
                    setTouched(true);
                },
                isAllowed: (value)=>{
                    if (value.floatValue || value.value === "") {
                        setInputError(false);
                        return true;
                    } else {
                        setInputError(true);
                        return false;
                    }
                },
                className: (0, $9QePP.default)("mb-1 mt-2 w-full bg-slate-900 p-2 pl-3 text-white", "border-default rounded border outline-none", "placeholder:text-slate-500", "focus:ring-transparent focus:placeholder:text-transparent", showErrorRing && "ring-1 ring-red-600", props.disabled && "cursor-not-allowed"),
                required: required,
                "aria-required": required
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("overflow-hidden transition-all duration-300", showError ? "h-6 opacity-100" : "h-0 opacity-0"),
                children: [
                    showError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9RcbH.ErrorMessage), {
                        id: describedBy,
                        message: error
                    }),
                    inputError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9RcbH.ErrorMessage), {
                        id: describedBy,
                        message: "Only numeric values are accepted"
                    })
                ]
            })
        ]
    });
}

});

parcelRegister("6pNDa", function(module, exports) {

$parcel$export(module.exports, "Percent", () => $a5b873309db47055$export$cbc348af47898b5e);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $hQ0nj = parcelRequire("hQ0nj");

var $lrVF0 = parcelRequire("lrVF0");

var $9QePP = parcelRequire("9QePP");

var $6f2mm = parcelRequire("6f2mm");

var $9RcbH = parcelRequire("9RcbH");
function $a5b873309db47055$export$cbc348af47898b5e({ label: label, readonly: readonly = false, placeholder: placeholder, parent: parent = "", ...props }) {
    const [touched, setTouched] = (0, $acw62.useState)(false);
    const [inputError, setInputError] = (0, $acw62.useState)(false);
    const form = (0, $acw62.useContext)((0, $hQ0nj.FormContext));
    const name = parent ? `${parent}.${props.name}` : props.name;
    if (!form) return null;
    const error = form.errors?.[name] || "";
    const showError = !inputError && touched && error && !error.toLowerCase().includes("required");
    const showErrorRing = touched && (error || inputError);
    const describedBy = `${name}-error`;
    const required = (0, $6f2mm.isRequired)(form.schema, name);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex gap-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    required && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "ui-element text-red-400",
                        children: "*"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lrVF0.NumericFormat), {
                "aria-describedby": describedBy,
                allowNegative: true,
                thousandSeparator: ",",
                suffix: "%",
                decimalScale: 2,
                name: name,
                id: name,
                disabled: props.disabled,
                onValueChange: (v)=>{
                    const value = v.value;
                    form.updateValue(name, value ? +value : undefined);
                },
                value: form.values[name] ?? "",
                type: "text",
                placeholder: placeholder,
                readOnly: readonly,
                onBlur: ()=>{
                    setInputError(false);
                },
                onFocus: ()=>{
                    setTouched(true);
                },
                isAllowed: (value)=>{
                    if (value.floatValue !== undefined || value.value === "") {
                        setInputError(false);
                        return true;
                    } else {
                        setInputError(true);
                        return false;
                    }
                },
                className: (0, $9QePP.default)("mb-1 mt-2 w-full bg-slate-900 p-2 pl-3 text-white", "border-default rounded border outline-none", "placeholder:text-slate-500", "focus:ring-transparent focus:placeholder:text-transparent", showErrorRing && "ring-1 ring-red-600", props.disabled && "cursor-not-allowed"),
                required: required,
                "aria-required": required
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("overflow-hidden transition-all duration-300", showError ? "h-6 opacity-100" : "h-0 opacity-0"),
                children: [
                    showError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9RcbH.ErrorMessage), {
                        id: describedBy,
                        message: error
                    }),
                    inputError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9RcbH.ErrorMessage), {
                        id: describedBy,
                        message: "Only numeric values are accepted"
                    })
                ]
            })
        ]
    });
}

});

parcelRegister("9hanQ", function(module, exports) {

$parcel$export(module.exports, "MutableList", () => $9016687d8a00b396$export$44f43cb3d5b595ad);

var $acw62 = parcelRequire("acw62");

var $hQ0nj = parcelRequire("hQ0nj");

var $hEJWZ = parcelRequire("hEJWZ");

var $6f2mm = parcelRequire("6f2mm");

var $f1q41 = parcelRequire("f1q41");
function $9016687d8a00b396$export$44f43cb3d5b595ad({ name: name, children: children }) {
    const form = (0, $acw62.useContext)((0, $hQ0nj.FormContext));
    const length = (0, $acw62.useMemo)(()=>(0, $6f2mm.findLength)(form?.values, name) || 0, [
        form?.values
    ]);
    const addItem = (0, $acw62.useCallback)(()=>{
        if (!form?.schema) return;
        const schemaField = $hEJWZ.reach(form?.schema, name);
        if (!(0, $hEJWZ.isSchema)(schemaField)) return;
        // @ts-expect-error - we know this is an object schema
        const next = Object.keys(schemaField.innerType.fields).reduce((acc, key)=>{
            acc[`${name}[${length}].${key}`] = "";
            return acc;
        }, {});
        form?.mergeValues(next);
    }, [
        form?.mergeValues,
        length
    ]);
    const removeItem = (0, $acw62.useCallback)((index)=>{
        const matcher = `${name}[`;
        const matches = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).pickBy(form?.values, (value, key)=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(key, matcher));
        const filtered = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).pickBy(form?.values, (value, key)=>!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(key, matcher));
        const o = (0, $6f2mm.unflattenObject)(matches);
        // Access the correct nested array
        const pathArray = name.split(".");
        const lastKey = pathArray.pop();
        if (!lastKey) {
            console.error("Invalid path:", name);
            return;
        }
        let parentObject = o;
        if (pathArray.length > 0) parentObject = pathArray.reduce((acc, key)=>acc[key], o);
        if (!parentObject || !Array.isArray(parentObject[lastKey])) {
            console.error(`Expected ${lastKey} to be an array`);
            return;
        }
        parentObject[lastKey] = parentObject[lastKey].filter((_, i)=>i !== index);
        // Re-index the keys to maintain the correct order
        const updated = Object.keys(parentObject[lastKey]).reduce((acc, key)=>{
            const item = parentObject[lastKey][key];
            Object.keys(item).forEach((subKey)=>{
                acc[`${name}[${key}].${subKey}`] = item[subKey];
            });
            return acc;
        }, {});
        form?.replaceValues({
            ...filtered,
            ...updated
        });
    }, [
        form,
        name
    ]);
    const items = Array.from({
        length: length
    }).map((_, index)=>({
            parent: `${name}[${index}]`,
            remove: ()=>removeItem(index)
        }));
    if (!form) return null;
    return children({
        items: items,
        addItem: addItem,
        removeItem: removeItem
    });
}

});

parcelRegister("29x30", function(module, exports) {

$parcel$export(module.exports, "Checkbox", () => $d090edb7be1619ef$export$48513f6b9f8ce62d);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ch4fl = parcelRequire("ch4fl");

var $hQ0nj = parcelRequire("hQ0nj");

var $6f2mm = parcelRequire("6f2mm");
function $d090edb7be1619ef$export$48513f6b9f8ce62d({ parent: parent = "", ...props }) {
    const [touched, setTouched] = (0, $acw62.useState)(false);
    const name = parent ? `${parent}.${props.name}` : props.name;
    const form = (0, $acw62.useContext)((0, $hQ0nj.FormContext));
    if (!form) return null;
    const error = form.errors?.[name] || "";
    const showError = touched && error && !error.toLowerCase().includes("required");
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ch4fl.RawCheckbox), {
        ...props,
        name: name,
        onChange: (e)=>{
            const value = e.target.checked;
            setTouched(true);
            form.updateValue(name, value);
            props.onChange?.(e);
        },
        checked: form.values[name] || false,
        required: (0, $6f2mm.isRequired)(form.schema, name),
        errorMessage: showError ? form.errors?.[name] : undefined,
        showErrorRing: Boolean(touched && error)
    });
}

});
parcelRegister("ch4fl", function(module, exports) {

$parcel$export(module.exports, "RawCheckbox", () => $c4577948422f5fa6$export$a990f26dff2bc762);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $9RcbH = parcelRequire("9RcbH");

var $bhkIv = parcelRequire("bhkIv");
function $c4577948422f5fa6$export$a990f26dff2bc762({ name: name, label: label, errorMessage: errorMessage, showErrorRing: showErrorRing, required: required, ...props }) {
    const describedBy = props["aria-describedby"] || `${name}-error`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "relative flex items-end gap-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                    id: name,
                    name: name,
                    type: "checkbox",
                    "aria-required": required,
                    className: (0, $9QePP.default)("ml-1 size-4 cursor-pointer rounded bg-transparent text-blue-500", "border-default checked:border-default border-2", "ring-0 focus:ring-0", (errorMessage || showErrorRing) && "ring-1 ring-red-600"),
                    ...props
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bhkIv.Label), {
                name: name,
                label: label,
                required: required
            }),
            errorMessage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9RcbH.ErrorMessage), {
                id: describedBy,
                message: errorMessage
            })
        ]
    });
}

});


parcelRegister("1sOsm", function(module, exports) {

$parcel$export(module.exports, "TextArea", () => $3ca57ea259e308ab$export$f5c9f3c2c4054eec);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $789ZE = parcelRequire("789ZE");

var $hQ0nj = parcelRequire("hQ0nj");

var $6f2mm = parcelRequire("6f2mm");
function $3ca57ea259e308ab$export$f5c9f3c2c4054eec({ parent: parent = "", ...props }) {
    const [touched, setTouched] = (0, $acw62.useState)(false);
    const name = parent ? `${parent}.${props.name}` : props.name;
    const form = (0, $acw62.useContext)((0, $hQ0nj.FormContext));
    if (!form) return null;
    const error = form.errors?.[name] || "";
    const showError = touched && error && !error.toLowerCase().includes("required");
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $789ZE.RawTextArea), {
        ...props,
        name: name,
        placeholder: props.placeholder,
        required: (0, $6f2mm.isRequired)(form.schema, name),
        onChange: (e)=>{
            setTouched(true);
            form.updateValue(name, e.target.value);
        },
        onBlur: ()=>setTouched(true),
        value: form.values[name] || "",
        errorMessage: showError ? form.errors?.[name] : undefined,
        showErrorRing: Boolean(touched && error)
    });
}

});
parcelRegister("789ZE", function(module, exports) {

$parcel$export(module.exports, "RawTextArea", () => $0026365f574e29fe$export$624e564665f48f09);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $9RcbH = parcelRequire("9RcbH");

var $bhkIv = parcelRequire("bhkIv");
function $0026365f574e29fe$export$624e564665f48f09({ name: name, label: label, errorMessage: errorMessage, showErrorRing: showErrorRing, required: required, placeholder: placeholder, ...props }) {
    const describedBy = props["aria-describedby"] || `${name}-error`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mb-3 flex flex-col",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bhkIv.Label), {
                name: name,
                label: label,
                required: required
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                id: name,
                "data-testid": `textarea-${name}`,
                name: name,
                placeholder: placeholder,
                className: (0, $9QePP.default)("mb-1 mt-2 w-full bg-slate-900 p-2 pl-3 text-white", "border-default rounded border outline-none", "placeholder:text-slate-500", "focus:ring-transparent focus:placeholder:text-transparent", (errorMessage || showErrorRing) && "ring-1 ring-red-600"),
                "aria-required": required,
                required: required,
                ...props
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "h-6",
                children: errorMessage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9RcbH.ErrorMessage), {
                    id: describedBy,
                    message: errorMessage
                })
            })
        ]
    });
}

});


parcelRegister("97C3K", function(module, exports) {

$parcel$export(module.exports, "Select", () => $f8f1a545e27c5e3b$export$ef9b1a59e592288f);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jqf3H = parcelRequire("jqf3H");

var $hQ0nj = parcelRequire("hQ0nj");

var $6f2mm = parcelRequire("6f2mm");
const $f8f1a545e27c5e3b$var$flattenOptions = (options)=>options.reduce((acc, option)=>{
        if ("groupLabel" in option) return [
            ...acc,
            ...option.options
        ];
        return [
            ...acc,
            option
        ];
    }, []);
function $f8f1a545e27c5e3b$export$ef9b1a59e592288f({ parent: parent = "", multiple: multiple = false, ...props }) {
    const [touched, setTouched] = (0, $acw62.useState)(false);
    const name = parent ? `${parent}.${props.name}` : props.name;
    const form = (0, $acw62.useContext)((0, $hQ0nj.FormContext));
    if (!form) return null;
    const flatOptions = $f8f1a545e27c5e3b$var$flattenOptions(props.options);
    const selectedOptions = multiple ? form.values[name] ? flatOptions.filter((option)=>form.values[name]?.includes(option.value)) : [] : form.values[name] ? flatOptions.find((option)=>option.value === form.values[name]) || null : null;
    const error = form.errors?.[name] || "";
    const showError = touched && error && !error.toLowerCase().includes("required");
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jqf3H.RawSelect), {
        ...props,
        name: name,
        disabled: props.disabled,
        testId: props.testId,
        className: props.className,
        label: props.label,
        placeholder: props.placeholder,
        options: props.options,
        selected: selectedOptions,
        multiple: multiple,
        onChange: (selected)=>{
            if (multiple) form.updateValue(name, selected.map((option)=>option.value));
            else form.updateValue(name, selected.value);
        },
        onBlur: ()=>setTouched(true),
        errorMessage: showError ? form.errors?.[name] : undefined,
        required: (0, $6f2mm.isRequired)(form.schema, name),
        showErrorRing: Boolean(touched && error)
    });
}

});
parcelRegister("jqf3H", function(module, exports) {

$parcel$export(module.exports, "RawSelect", () => $291326689d44ef38$export$580685105790cbdd);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $j9H4k = parcelRequire("j9H4k");
var $e9NTc = parcelRequire("e9NTc");
var $iymfR = parcelRequire("iymfR");

var $ckP3P = parcelRequire("ckP3P");
var $8kHHN = parcelRequire("8kHHN");
var $7KX8i = parcelRequire("7KX8i");

var $9RcbH = parcelRequire("9RcbH");

var $bhkIv = parcelRequire("bhkIv");
function $291326689d44ef38$export$580685105790cbdd({ testId: testId, name: name, showErrorRing: showErrorRing, placeholder: placeholder = "Select an option", label: label, options: options, selected: selected, onChange: onChange, errorMessage: errorMessage, required: required, ariaDescribedby: ariaDescribedby, onBlur: onBlur, disabled: disabled, multiple: multiple = false }) {
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const describedBy = ariaDescribedby || `${testId}-error`;
    const [position, setPosition] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>({
            top: 0,
            left: 0,
            width: 0,
            isAbove: false
        }));
    const updatePosition = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!buttonRef.current) return;
        const rect = buttonRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const spaceBelow = viewportHeight - rect.bottom;
        const spaceAbove = rect.top;
        setPosition({
            top: rect.bottom,
            left: rect.left,
            width: rect.width,
            isAbove: spaceBelow < 300 && spaceAbove > spaceBelow
        });
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const options = {
            capture: true
        };
        window.addEventListener("scroll", updatePosition, options);
        window.addEventListener("resize", updatePosition);
        return ()=>{
            window.removeEventListener("scroll", updatePosition, options);
            window.removeEventListener("resize", updatePosition);
        };
    }, [
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j9H4k.Listbox), {
        value: selected,
        onChange: onChange,
        disabled: disabled,
        multiple: multiple,
        children: ({ open: open })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bhkIv.Label), {
                        required: required,
                        name: name,
                        label: label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $j9H4k.ListboxButton), {
                        ref: buttonRef,
                        "aria-haspopup": "listbox",
                        className: (0, $9QePP.default)("secondary relative mb-1 mt-2 w-full cursor-pointer", (errorMessage || showErrorRing) && "ml-px ring-1 ring-red-600", disabled && "cursor-not-allowed"),
                        "data-testid": testId,
                        onBlur: onBlur,
                        onClick: updatePosition,
                        "aria-describedby": describedBy,
                        children: [
                            multiple ? Array.isArray(selected) && selected.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex flex-wrap gap-2",
                                children: selected.map((option)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: (0, $9QePP.default)("bg-slate-800 px-2 py-1", "flex items-center gap-1 rounded"),
                                        children: [
                                            option.label,
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p-1",
                                                onClick: (e)=>{
                                                    e.stopPropagation();
                                                    if (Array.isArray(selected)) {
                                                        const newSelected = selected.filter((item)=>item.value !== option.value);
                                                        onChange(newSelected);
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7KX8i.default), {
                                                    className: "size-3 text-gray-400 hover:text-gray-200"
                                                })
                                            })
                                        ]
                                    }, option.value))
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-small subdued",
                                children: placeholder
                            }) : selected ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-small",
                                children: selected.label
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-small subdued",
                                children: placeholder
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: (0, $9QePP.default)("pr-2", "pointer-events-none absolute inset-y-0 right-0 flex items-center"),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8kHHN.default), {
                                    className: "size-5 text-gray-400",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9NTc.Portal), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition), {
                            show: open,
                            as: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment,
                            enter: "transition ease-out duration-200",
                            enterFrom: "opacity-0 translate-y-1",
                            enterTo: "opacity-100 translate-y-0",
                            leave: "transition ease-in duration-150",
                            leaveFrom: "opacity-100 translate-y-0",
                            leaveTo: "opacity-0 translate-y-1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "fixed inset-0",
                                style: {
                                    zIndex: 9999
                                },
                                onClick: (e)=>e.target === e.currentTarget && buttonRef.current?.click(),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        top: position.isAbove ? "auto" : position.top,
                                        bottom: position.isAbove ? `${window.innerHeight - position.top}px` : "auto",
                                        left: position.left,
                                        width: position.width,
                                        zIndex: 10000
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j9H4k.ListboxOptions), {
                                        className: (0, $9QePP.default)("fixed", "max-h-[300px] overflow-auto", "rounded-md shadow-lg", "bg-white dark:bg-slate-800", "border border-slate-200 dark:border-slate-700", "custom-scrollbar", position.isAbove ? "bottom-0" : "top-0"),
                                        style: {
                                            width: position.width,
                                            left: position.left,
                                            top: position.isAbove ? "auto" : position.top,
                                            bottom: position.isAbove ? `${window.innerHeight - position.top}px` : "auto"
                                        },
                                        children: options.map((optionOrGroup)=>"groupLabel" in optionOrGroup ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: (0, $9QePP.default)("bg-secondary body-micro p-2", "subdued font-bold uppercase"),
                                                        children: optionOrGroup.groupLabel
                                                    }),
                                                    optionOrGroup.options.map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $j9H4k.ListboxOption), {
                                                            className: ({ focus: focus })=>(0, $9QePP.default)(focus ? "bg-slate-800" : "bg-secondary", "relative cursor-pointer select-none py-2 pl-10 pr-4"),
                                                            value: option,
                                                            children: ({ selected: selected, focus: focus })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                    children: [
                                                                        typeof option.label === "string" ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "body-small block cursor-pointer",
                                                                            children: option.label
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            children: option.label
                                                                        }),
                                                                        selected ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: (0, $9QePP.default)(focus ? "subdued" : "subdued", "absolute inset-y-0 left-0 flex items-center pl-3"),
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ckP3P.default), {
                                                                                className: "size-5",
                                                                                "aria-hidden": "true"
                                                                            })
                                                                        }) : null
                                                                    ]
                                                                })
                                                        }, option.value))
                                                ]
                                            }, optionOrGroup.groupLabel || "group-unique-key") : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j9H4k.ListboxOption), {
                                                className: ({ active: active })=>(0, $9QePP.default)(active ? "bg-slate-800" : "bg-secondary", "relative cursor-pointer select-none py-2 pl-10 pr-4"),
                                                value: optionOrGroup,
                                                children: ({ selected: selected, active: active })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            typeof optionOrGroup.label === "string" ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "body-small block cursor-pointer",
                                                                children: optionOrGroup.label
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                children: optionOrGroup.label
                                                            }),
                                                            selected ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: (0, $9QePP.default)(active ? "subdued" : "subdued", "absolute inset-y-0 left-0 flex items-center pl-3"),
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ckP3P.default), {
                                                                    className: "size-5",
                                                                    "aria-hidden": "true"
                                                                })
                                                            }) : null
                                                        ]
                                                    })
                                            }, optionOrGroup.value))
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, $9QePP.default)("overflow-hidden transition-all duration-300", errorMessage ? "h-6 opacity-100" : "h-0 opacity-0"),
                        children: errorMessage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9RcbH.ErrorMessage), {
                            id: describedBy,
                            message: errorMessage
                        })
                    })
                ]
            })
    });
}

});


parcelRegister("faxRZ", function(module, exports) {

$parcel$export(module.exports, "RichText", () => $66ee21d44c973e84$export$f284d8638abd8920);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $hQ0nj = parcelRequire("hQ0nj");

var $6f2mm = parcelRequire("6f2mm");

var $6dgcr = parcelRequire("6dgcr");

var $bhkIv = parcelRequire("bhkIv");

var $9RcbH = parcelRequire("9RcbH");
function $66ee21d44c973e84$export$f284d8638abd8920({ parent: parent = "", ...props }) {
    const [touched, setTouched] = (0, $acw62.useState)(false);
    const name = parent ? `${parent}.${props.name}` : props.name;
    const form = (0, $acw62.useContext)((0, $hQ0nj.FormContext));
    if (!form) return null;
    const error = form.errors?.[name] || "";
    const showError = touched && error && !error.toLowerCase().includes("required");
    const describedBy = props["aria-describedby"] || `${name}-error`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "my-3 flex flex-col",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bhkIv.Label), {
                name: name,
                label: props.label,
                required: (0, $6f2mm.isRequired)(form.schema, name)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6dgcr.TrixEditor), {
                value: form.values[name] || "",
                onChange: (value)=>{
                    setTouched(true);
                    form.updateValue(name, value);
                }
            }),
            showError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9RcbH.ErrorMessage), {
                id: describedBy,
                message: error
            })
        ]
    });
}

});
parcelRegister("6dgcr", function(module, exports) {

$parcel$export(module.exports, "TrixEditor", () => $e980abbe7ffa3928$export$ba1ea3784ea3400d);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

const $e980abbe7ffa3928$export$ba1ea3784ea3400d = ({ value: value, onChange: onChange })=>{
    const editorRef = (0, $acw62.useRef)(null);
    const contentId = (0, $acw62.useRef)(`trix-content-${Math.random().toString(36).substring(2, 11)}`);
    (0, $acw62.useEffect)(()=>{
        if (typeof window !== "undefined") (parcelRequire("fXB3h")).then(()=>{
            const handleChange = ()=>{
                const editorElement = editorRef.current?.querySelector("trix-editor");
                const htmlContent = editorElement.innerHTML;
                onChange(htmlContent);
            };
            const editorElement = editorRef.current?.querySelector("trix-editor");
            editorElement?.addEventListener("trix-change", handleChange);
            return ()=>{
                editorElement?.removeEventListener("trix-change", handleChange);
            };
        });
    }, [
        onChange
    ]);
    (0, $acw62.useEffect)(()=>{
        if (typeof window !== "undefined" && editorRef.current) {
            const editorElement = editorRef.current.querySelector("trix-editor");
            try {
                if (editorElement?.editor && typeof editorElement.editor.getHTML === "function") {
                    const currentHtml = editorElement.editor.getHTML() || "";
                    if (value !== currentHtml) editorElement.editor.loadHTML(value || "");
                }
            } catch (err) {
                console.error("Trix editor error:", err);
                setTimeout(()=>{
                    try {
                        if (editorElement?.editor && typeof editorElement.editor.getHTML === "function") editorElement.editor.loadHTML(value || "");
                    } catch (e) {
                        console.error("Trix editor error:", e);
                    }
                }, 100);
            }
        }
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: editorRef,
        className: "trix-editor-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                id: contentId.current,
                type: "hidden",
                value: value
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("trix-editor", {
                input: contentId.current
            })
        ]
    });
};

});
parcelRegister("fXB3h", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gllT6").then(()=>parcelRequire("4W1w1"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});





parcelRegister("kYQGR", function(module, exports) {
$parcel$export(module.exports, "WidgetGrid", () => (parcelRequire("2rl3y")).WidgetGrid);
$parcel$export(module.exports, "ExpandableWidget", () => (parcelRequire("9txcC")).ExpandableWidget);
$parcel$export(module.exports, "Widget", () => (parcelRequire("b7ZjI")).Widget);
$parcel$export(module.exports, "StatWidget", () => (parcelRequire("1l3Yq")).StatWidget);
$parcel$export(module.exports, "TextWidget", () => (parcelRequire("9nhU7")).TextWidget);
parcelRequire("2rl3y");
parcelRequire("9txcC");
parcelRequire("b7ZjI");
parcelRequire("1l3Yq");
parcelRequire("9nhU7");

});
parcelRegister("2rl3y", function(module, exports) {

$parcel$export(module.exports, "WidgetGrid", () => $1ede5609b9bbb5f7$export$57fa681bad920276);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $fRJCp = parcelRequire("fRJCp");

var $9QePP = parcelRequire("9QePP");
function $1ede5609b9bbb5f7$export$57fa681bad920276({ children: children, key: key }) {
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children);
    const originalPositions = Array.from({
        length: childrenArray.length
    }, (_, i)=>i);
    const [order] = (0, $acw62.useState)(originalPositions);
    const [selected] = (0, $acw62.useState)(null);
    // const handleClick = (originalPosition, currentPosition) => {
    //     setSelected(selected === originalPosition ? null : originalPosition);
    //     if (originalPosition !== currentPosition) {
    //         setOrder(move(order, currentPosition, originalPosition));
    //     } else if (originalPosition % 2 !== 0) {
    //         setOrder(move(order, originalPosition, originalPosition - 1));
    //     }
    // };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
        layout: true,
        initial: {
            opacity: 0
        },
        animate: {
            y: 0,
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        transition: {
            duration: 0.3
        },
        className: (0, $9QePP.default)("grid grid-cols-2 gap-8", "w-full"),
        children: order.map((originalPosition)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                layout: true,
                // onClick={() =>
                //     handleClick(originalPosition, currentPosition)
                // }
                className: (0, $9QePP.default)("col-span-1 rounded", selected === originalPosition && "col-span-2"),
                children: childrenArray[originalPosition]
            }, originalPosition))
    }, key);
}

});
parcelRegister("fRJCp", function(module, exports) {

$parcel$export(module.exports, "motion", () => $a93b6401f922fd1e$export$e25e478948902b8b);

var $lqm1a = parcelRequire("lqm1a");

var $hrSjo = parcelRequire("hrSjo");

var $i2j08 = parcelRequire("i2j08");

var $iLse2 = parcelRequire("iLse2");

var $crTFY = parcelRequire("crTFY");

var $80qKP = parcelRequire("80qKP");

var $6LgnS = parcelRequire("6LgnS");

var $1T5yZ = parcelRequire("1T5yZ");
const $a93b6401f922fd1e$var$preloadedFeatures = {
    ...(0, $crTFY.animations),
    ...(0, $iLse2.gestureAnimations),
    ...(0, $80qKP.drag),
    ...(0, $1T5yZ.layout)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $a93b6401f922fd1e$export$e25e478948902b8b = /*@__PURE__*/ (0, $hrSjo.createMotionProxy)((Component, config)=>(0, $i2j08.createDomMotionConfig)(Component, config, $a93b6401f922fd1e$var$preloadedFeatures, (0, $6LgnS.createDomVisualElement)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $a93b6401f922fd1e$export$546614c4a05701f9(key) {
    return (0, $lqm1a.createMotionComponent)((0, $i2j08.createDomMotionConfig)(key, {
        forwardMotionProps: false
    }, $a93b6401f922fd1e$var$preloadedFeatures, (0, $6LgnS.createDomVisualElement)));
}

});
parcelRegister("lqm1a", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", () => $b40dad60036091a1$export$46b7e4b9dc6110c3);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7iCGF = parcelRequire("7iCGF");

var $e3EFx = parcelRequire("e3EFx");

var $ju9rq = parcelRequire("ju9rq");

var $1mSqb = parcelRequire("1mSqb");

var $2XQbq = parcelRequire("2XQbq");

var $a6eQe = parcelRequire("a6eQe");

var $4L0T5 = parcelRequire("4L0T5");

var $cNR5T = parcelRequire("cNR5T");

var $3WGFy = parcelRequire("3WGFy");

var $ctb6w = parcelRequire("ctb6w");


var $7bH6a = parcelRequire("7bH6a");
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $b40dad60036091a1$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $a6eQe.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $acw62.useContext)((0, $7iCGF.MotionConfigContext)),
            ...props,
            layoutId: $b40dad60036091a1$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $2XQbq.useCreateMotionContext)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $4L0T5.isBrowser)) {
            $b40dad60036091a1$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $b40dad60036091a1$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $ju9rq.useVisualElement)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $ayMG0.jsxs)((0, $e3EFx.MotionContext).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $ayMG0.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $1mSqb.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefComponent = (0, $acw62.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $ctb6w.motionComponentSymbol] = Component;
    return ForwardRefComponent;
}
function $b40dad60036091a1$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $acw62.useContext)((0, $cNR5T.LayoutGroupContext)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $b40dad60036091a1$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $acw62.useContext)((0, $3WGFy.LazyContext)).strict;
}
function $b40dad60036091a1$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $7bH6a.featureDefinitions);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}

});
parcelRegister("7iCGF", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", () => $3bbbde5b328b4154$export$22a697fb29aac98d);

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ const $3bbbde5b328b4154$export$22a697fb29aac98d = (0, $acw62.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});

});

parcelRegister("e3EFx", function(module, exports) {

$parcel$export(module.exports, "MotionContext", () => $3ce32ada97cfc8f7$export$2285bbca2c666415);

var $acw62 = parcelRequire("acw62");
const $3ce32ada97cfc8f7$export$2285bbca2c666415 = (0, $acw62.createContext)({});

});

parcelRegister("ju9rq", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", () => $7fb0f4644b9cc8ad$export$dc0335d73ab0b115);

var $acw62 = parcelRequire("acw62");

var $gtJis = parcelRequire("gtJis");

var $e3EFx = parcelRequire("e3EFx");

var $6S63t = parcelRequire("6S63t");

var $3WGFy = parcelRequire("3WGFy");

var $7iCGF = parcelRequire("7iCGF");

var $7vTbr = parcelRequire("7vTbr");

var $6AsEf = parcelRequire("6AsEf");

var $cg30p = parcelRequire("cg30p");

var $9lcvq = parcelRequire("9lcvq");
let $7fb0f4644b9cc8ad$var$scheduleHandoffComplete = false;
function $7fb0f4644b9cc8ad$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    const { visualElement: parent } = (0, $acw62.useContext)((0, $e3EFx.MotionContext));
    const lazyContext = (0, $acw62.useContext)((0, $3WGFy.LazyContext));
    const presenceContext = (0, $acw62.useContext)((0, $gtJis.PresenceContext));
    const reducedMotionConfig = (0, $acw62.useContext)((0, $7iCGF.MotionConfigContext)).reducedMotion;
    const visualElementRef = (0, $acw62.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $acw62.useContext)((0, $9lcvq.SwitchLayoutGroupContext));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $7fb0f4644b9cc8ad$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    (0, $acw62.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const wantsHandoff = (0, $acw62.useRef)(Boolean(props[0, $7vTbr.optimizedAppearDataAttribute] && !window.HandoffComplete));
    (0, $6S63t.useIsomorphicLayoutEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        (0, $6AsEf.microtask).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $acw62.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            wantsHandoff.current = false;
            // This ensures all future calls to animateChanges() will run in useEffect
            if (!$7fb0f4644b9cc8ad$var$scheduleHandoffComplete) {
                $7fb0f4644b9cc8ad$var$scheduleHandoffComplete = true;
                queueMicrotask($7fb0f4644b9cc8ad$var$completeHandoff);
            }
        }
    });
    return visualElement;
}
function $7fb0f4644b9cc8ad$var$completeHandoff() {
    window.HandoffComplete = true;
}
function $7fb0f4644b9cc8ad$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $7fb0f4644b9cc8ad$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $cg30p.isRefObject)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $7fb0f4644b9cc8ad$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $7fb0f4644b9cc8ad$var$getClosestProjectingNode(visualElement.parent);
}

});
parcelRegister("gtJis", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", () => $dba5d94a982c4145$export$f224e4635b6f8ce2);

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ const $dba5d94a982c4145$export$f224e4635b6f8ce2 = (0, $acw62.createContext)(null);

});

parcelRegister("6S63t", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $9c674755a93db746$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");

var $4L0T5 = parcelRequire("4L0T5");
const $9c674755a93db746$export$700979bc83e7db82 = (0, $4L0T5.isBrowser) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);

});
parcelRegister("4L0T5", function(module, exports) {

$parcel$export(module.exports, "isBrowser", () => $784730508f12f72c$export$4e09c449d6c407f7);
const $784730508f12f72c$export$4e09c449d6c407f7 = typeof window !== "undefined";

});


parcelRegister("3WGFy", function(module, exports) {

$parcel$export(module.exports, "LazyContext", () => $410b846e117db9e1$export$40f10139ecf1f171);

var $acw62 = parcelRequire("acw62");
const $410b846e117db9e1$export$40f10139ecf1f171 = (0, $acw62.createContext)({
    strict: false
});

});

parcelRegister("7vTbr", function(module, exports) {

$parcel$export(module.exports, "optimizedAppearDataAttribute", () => $5fd2b57c27674a98$export$8592e1c077c890a6);

var $4kYgl = parcelRequire("4kYgl");
const $5fd2b57c27674a98$export$ed7b8fa9dbf0105d = "framerAppearId";
const $5fd2b57c27674a98$export$8592e1c077c890a6 = "data-" + (0, $4kYgl.camelToDash)($5fd2b57c27674a98$export$ed7b8fa9dbf0105d);

});
parcelRegister("4kYgl", function(module, exports) {

$parcel$export(module.exports, "camelToDash", () => $9dc069bda924fd3f$export$9fd24a634729c672);
/**
 * Convert camelCase to dash-case properties.
 */ const $9dc069bda924fd3f$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();

});


parcelRegister("6AsEf", function(module, exports) {

$parcel$export(module.exports, "microtask", () => $6b94e2cfb50380ff$export$bb76eed83315504c);

var $9nOst = parcelRequire("9nOst");
const { schedule: $6b94e2cfb50380ff$export$bb76eed83315504c, cancel: $6b94e2cfb50380ff$export$3252729004b8456e } = (0, $9nOst.createRenderBatcher)(queueMicrotask, false);

});
parcelRegister("9nOst", function(module, exports) {

$parcel$export(module.exports, "createRenderBatcher", () => $d022ffbd5a1b0ae4$export$510b0596a933801a);

var $abtYf = parcelRequire("abtYf");

var $8hB3t = parcelRequire("8hB3t");
const $d022ffbd5a1b0ae4$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $d022ffbd5a1b0ae4$var$maxElapsed = 40;
function $d022ffbd5a1b0ae4$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $d022ffbd5a1b0ae4$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $8hB3t.createRenderStep)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $abtYf.MotionGlobalConfig).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $d022ffbd5a1b0ae4$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $d022ffbd5a1b0ae4$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $d022ffbd5a1b0ae4$export$71ecace0a033b35a.length; i++)steps[$d022ffbd5a1b0ae4$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}

});
parcelRegister("abtYf", function(module, exports) {

$parcel$export(module.exports, "MotionGlobalConfig", () => $f69e8e67d72e77c2$export$dd826089e3c5e502);
const $f69e8e67d72e77c2$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};

});

parcelRegister("8hB3t", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", () => $f4ac54c83388ba0d$export$b995e5e85f5c8289);
function $f4ac54c83388ba0d$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

});



parcelRegister("cg30p", function(module, exports) {

$parcel$export(module.exports, "isRefObject", () => $d157673547c2a934$export$dedd81df7bc1307);
function $d157673547c2a934$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});

parcelRegister("9lcvq", function(module, exports) {

$parcel$export(module.exports, "SwitchLayoutGroupContext", () => $c612a166b65a9c69$export$da5f7b802957459a);

var $acw62 = parcelRequire("acw62");
/**
 * Internal, exported only for usage in Framer
 */ const $c612a166b65a9c69$export$da5f7b802957459a = (0, $acw62.createContext)({});

});


parcelRegister("1mSqb", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", () => $88efa764bb00537b$export$c684914703d321fd);

var $acw62 = parcelRequire("acw62");

var $cg30p = parcelRequire("cg30p");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $88efa764bb00537b$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $acw62.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $cg30p.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

});

parcelRegister("2XQbq", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", () => $4cb87fa0b981df8c$export$c5638d843b37a176);

var $acw62 = parcelRequire("acw62");

var $e3EFx = parcelRequire("e3EFx");

var $aZXLC = parcelRequire("aZXLC");
function $4cb87fa0b981df8c$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $aZXLC.getCurrentTreeVariants)(props, (0, $acw62.useContext)((0, $e3EFx.MotionContext)));
    return (0, $acw62.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(initial),
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(animate)
    ]);
}
function $4cb87fa0b981df8c$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("aZXLC", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", () => $9e57028cf0cad086$export$12fc32fc096a04a3);

var $dLd38 = parcelRequire("dLd38");

var $jeuUs = parcelRequire("jeuUs");
function $9e57028cf0cad086$export$12fc32fc096a04a3(props, context) {
    if ((0, $jeuUs.isControllingVariants)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $dLd38.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $dLd38.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});
parcelRegister("dLd38", function(module, exports) {

$parcel$export(module.exports, "isVariantLabel", () => $a35be4d5814e7c66$export$720b90e312cea233);
/**
 * Decides if the supplied variable is variant label
 */ function $a35be4d5814e7c66$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}

});

parcelRegister("jeuUs", function(module, exports) {

$parcel$export(module.exports, "isControllingVariants", () => $06b1046bf0f33e63$export$4b3c3bd8d910d78d);
$parcel$export(module.exports, "isVariantNode", () => $06b1046bf0f33e63$export$ce46fa4165cdec40);

var $k8Lf0 = parcelRequire("k8Lf0");

var $dLd38 = parcelRequire("dLd38");

var $fNC3C = parcelRequire("fNC3C");
function $06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) {
    return (0, $k8Lf0.isAnimationControls)(props.animate) || (0, $fNC3C.variantProps).some((name)=>(0, $dLd38.isVariantLabel)(props[name]));
}
function $06b1046bf0f33e63$export$ce46fa4165cdec40(props) {
    return Boolean($06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) || props.variants);
}

});
parcelRegister("k8Lf0", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", () => $1e5344c7f0db9c8f$export$aa71198ceeaf53ce);
function $1e5344c7f0db9c8f$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}

});

parcelRegister("fNC3C", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", () => $0172fb3d3512f551$export$16e45afcc206d3a8);
$parcel$export(module.exports, "variantProps", () => $0172fb3d3512f551$export$1405a65085f40b9);
const $0172fb3d3512f551$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $0172fb3d3512f551$export$1405a65085f40b9 = [
    "initial",
    ...$0172fb3d3512f551$export$16e45afcc206d3a8
];

});




parcelRegister("a6eQe", function(module, exports) {

$parcel$export(module.exports, "loadFeatures", () => $b9879783068c1762$export$449561ec5703cdc8);

var $7bH6a = parcelRequire("7bH6a");
function $b9879783068c1762$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $7bH6a.featureDefinitions)[key] = {
        ...(0, $7bH6a.featureDefinitions)[key],
        ...features[key]
    };
}

});
parcelRegister("7bH6a", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", () => $a8d82256030e9525$export$65570e08d843624d);
const $a8d82256030e9525$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $a8d82256030e9525$export$65570e08d843624d = {};
for(const key in $a8d82256030e9525$var$featureProps)$a8d82256030e9525$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$a8d82256030e9525$var$featureProps[key].some((name)=>!!props[name])
};

});


parcelRegister("cNR5T", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", () => $4ae202aab5791dbc$export$a3579ca508007a95);

var $acw62 = parcelRequire("acw62");
const $4ae202aab5791dbc$export$a3579ca508007a95 = (0, $acw62.createContext)({});

});

parcelRegister("ctb6w", function(module, exports) {

$parcel$export(module.exports, "motionComponentSymbol", () => $9b94ea54d3350cc1$export$28e2e4cce424ae23);
const $9b94ea54d3350cc1$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");

});


parcelRegister("hrSjo", function(module, exports) {

$parcel$export(module.exports, "createMotionProxy", () => $16a09bb264d348bb$export$a28d6df673050e18);

var $lqm1a = parcelRequire("lqm1a");
/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $16a09bb264d348bb$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $lqm1a.createMotionComponent)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}

});

parcelRegister("i2j08", function(module, exports) {

$parcel$export(module.exports, "createDomMotionConfig", () => $73e3a8d89278ed7b$export$732916c0e88175fb);

var $9GusU = parcelRequire("9GusU");

var $fFVoM = parcelRequire("fFVoM");

var $AO3i6 = parcelRequire("AO3i6");

var $jCKYH = parcelRequire("jCKYH");
function $73e3a8d89278ed7b$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $9GusU.isSVGComponent)(Component) ? (0, $AO3i6.svgMotionConfig) : (0, $jCKYH.htmlMotionConfig);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $fFVoM.createUseRender)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}

});
parcelRegister("9GusU", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", () => $ca4ea6365adee72d$export$88f3fc2fd3766989);

var $2jNiu = parcelRequire("2jNiu");
function $ca4ea6365adee72d$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $2jNiu.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}

});
parcelRegister("2jNiu", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", () => $1d85745fbdd79bfa$export$40209c4c512158e6);
/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $1d85745fbdd79bfa$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];

});


parcelRegister("fFVoM", function(module, exports) {

$parcel$export(module.exports, "createUseRender", () => $dc80cb5954e76638$export$5d29104eefd89cc8);

var $acw62 = parcelRequire("acw62");

var $aZIZO = parcelRequire("aZIZO");

var $8RV9d = parcelRequire("8RV9d");

var $9GusU = parcelRequire("9GusU");

var $cc1pG = parcelRequire("cc1pG");

var $jqFCw = parcelRequire("jqFCw");
function $dc80cb5954e76638$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $9GusU.isSVGComponent)(Component) ? (0, $cc1pG.useSVGProps) : (0, $aZIZO.useHTMLProps);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $8RV9d.filterProps)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $acw62.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $acw62.useMemo)(()=>(0, $jqFCw.isMotionValue)(children) ? children.get() : children, [
            children
        ]);
        return (0, $acw62.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}

});
parcelRegister("aZIZO", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", () => $81d8dfeeb8038b0d$export$40dafdb8630c956b);
$parcel$export(module.exports, "useHTMLProps", () => $81d8dfeeb8038b0d$export$57be0a314572d87d);

var $acw62 = parcelRequire("acw62");

var $8tTaz = parcelRequire("8tTaz");

var $jqFCw = parcelRequire("jqFCw");

var $9U95V = parcelRequire("9U95V");

var $fiQRA = parcelRequire("fiQRA");
function $81d8dfeeb8038b0d$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $jqFCw.isMotionValue)(source[key]) && !(0, $8tTaz.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $81d8dfeeb8038b0d$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $acw62.useMemo)(()=>{
        const state = (0, $fiQRA.createHtmlRenderState)();
        (0, $9U95V.buildHTMLStyles)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $81d8dfeeb8038b0d$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $81d8dfeeb8038b0d$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $81d8dfeeb8038b0d$var$useInitialMotionValues(props, visualState));
    return style;
}
function $81d8dfeeb8038b0d$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $81d8dfeeb8038b0d$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}

});
parcelRegister("8tTaz", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", () => $443c859766df5778$export$6d27ce8e3de1c3cf);

var $i0qI9 = parcelRequire("i0qI9");

var $5f0mC = parcelRequire("5f0mC");
function $443c859766df5778$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $5f0mC.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $i0qI9.scaleCorrectors)[key] || key === "opacity");
}

});
parcelRegister("i0qI9", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", () => $eced91e16bda42df$export$91ddd985b97788d1);
$parcel$export(module.exports, "addScaleCorrector", () => $eced91e16bda42df$export$de9e7791c71225fd);
const $eced91e16bda42df$export$91ddd985b97788d1 = {};
function $eced91e16bda42df$export$de9e7791c71225fd(correctors) {
    Object.assign($eced91e16bda42df$export$91ddd985b97788d1, correctors);
}

});

parcelRegister("5f0mC", function(module, exports) {

$parcel$export(module.exports, "transformPropOrder", () => $ac502869c4d3e65a$export$280dc01950909d86);
$parcel$export(module.exports, "transformProps", () => $ac502869c4d3e65a$export$7b42a0094fb00b6e);
/**
 * Generate a list of every possible transform key.
 */ const $ac502869c4d3e65a$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $ac502869c4d3e65a$export$7b42a0094fb00b6e = new Set($ac502869c4d3e65a$export$280dc01950909d86);

});


parcelRegister("jqFCw", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", () => $55c3387a92452647$export$605d60a2578142d3);
const $55c3387a92452647$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);

});

parcelRegister("9U95V", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", () => $a883e7c624291d03$export$bb517f8b40f8e99d);

var $et7Or = parcelRequire("et7Or");

var $dAJIO = parcelRequire("dAJIO");

var $5f0mC = parcelRequire("5f0mC");

var $mpKah = parcelRequire("mpKah");

var $hsgeP = parcelRequire("hsgeP");
function $a883e7c624291d03$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $dAJIO.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $hsgeP.numberValueTypes)[key];
        const valueAsType = (0, $mpKah.getValueAsType)(value, valueType);
        if ((0, $5f0mC.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $et7Or.buildTransform)(state.transform, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

});
parcelRegister("et7Or", function(module, exports) {

$parcel$export(module.exports, "buildTransform", () => $1724c99b9b724858$export$bdc96e0d5c8f914);

var $5f0mC = parcelRequire("5f0mC");
const $1724c99b9b724858$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $1724c99b9b724858$var$numTransforms = (0, $5f0mC.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $1724c99b9b724858$export$bdc96e0d5c8f914(transform, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $1724c99b9b724858$var$numTransforms; i++){
        const key = (0, $5f0mC.transformPropOrder)[i];
        if (transform[key] !== undefined) {
            const transformName = $1724c99b9b724858$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}

});

parcelRegister("dAJIO", function(module, exports) {

$parcel$export(module.exports, "isCSSVariableName", () => $f9c5e88311214d2a$export$9de1236619d9e756);
$parcel$export(module.exports, "isCSSVariableToken", () => $f9c5e88311214d2a$export$31f9caa2600b5723);
const $f9c5e88311214d2a$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $f9c5e88311214d2a$export$9de1236619d9e756 = $f9c5e88311214d2a$var$checkStringStartsWith("--");
const $f9c5e88311214d2a$var$startsAsVariableToken = $f9c5e88311214d2a$var$checkStringStartsWith("var(--");
const $f9c5e88311214d2a$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $f9c5e88311214d2a$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $f9c5e88311214d2a$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $f9c5e88311214d2a$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

});

parcelRegister("mpKah", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", () => $a19b1277e1098e3a$export$453ef540a9a1bd6b);
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $a19b1277e1098e3a$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};

});

parcelRegister("hsgeP", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", () => $d5c56ef81d4ff9c2$export$eec14432cd1cb67b);

var $inZFJ = parcelRequire("inZFJ");

var $hZcVt = parcelRequire("hZcVt");

var $bt85H = parcelRequire("bt85H");
const $d5c56ef81d4ff9c2$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $hZcVt.px),
    borderTopWidth: (0, $hZcVt.px),
    borderRightWidth: (0, $hZcVt.px),
    borderBottomWidth: (0, $hZcVt.px),
    borderLeftWidth: (0, $hZcVt.px),
    borderRadius: (0, $hZcVt.px),
    radius: (0, $hZcVt.px),
    borderTopLeftRadius: (0, $hZcVt.px),
    borderTopRightRadius: (0, $hZcVt.px),
    borderBottomRightRadius: (0, $hZcVt.px),
    borderBottomLeftRadius: (0, $hZcVt.px),
    // Positioning props
    width: (0, $hZcVt.px),
    maxWidth: (0, $hZcVt.px),
    height: (0, $hZcVt.px),
    maxHeight: (0, $hZcVt.px),
    size: (0, $hZcVt.px),
    top: (0, $hZcVt.px),
    right: (0, $hZcVt.px),
    bottom: (0, $hZcVt.px),
    left: (0, $hZcVt.px),
    // Spacing props
    padding: (0, $hZcVt.px),
    paddingTop: (0, $hZcVt.px),
    paddingRight: (0, $hZcVt.px),
    paddingBottom: (0, $hZcVt.px),
    paddingLeft: (0, $hZcVt.px),
    margin: (0, $hZcVt.px),
    marginTop: (0, $hZcVt.px),
    marginRight: (0, $hZcVt.px),
    marginBottom: (0, $hZcVt.px),
    marginLeft: (0, $hZcVt.px),
    // Transform props
    rotate: (0, $hZcVt.degrees),
    rotateX: (0, $hZcVt.degrees),
    rotateY: (0, $hZcVt.degrees),
    rotateZ: (0, $hZcVt.degrees),
    scale: $inZFJ.scale,
    scaleX: (0, $inZFJ.scale),
    scaleY: (0, $inZFJ.scale),
    scaleZ: (0, $inZFJ.scale),
    skew: (0, $hZcVt.degrees),
    skewX: (0, $hZcVt.degrees),
    skewY: (0, $hZcVt.degrees),
    distance: (0, $hZcVt.px),
    translateX: (0, $hZcVt.px),
    translateY: (0, $hZcVt.px),
    translateZ: (0, $hZcVt.px),
    x: (0, $hZcVt.px),
    y: (0, $hZcVt.px),
    z: (0, $hZcVt.px),
    perspective: (0, $hZcVt.px),
    transformPerspective: (0, $hZcVt.px),
    opacity: (0, $inZFJ.alpha),
    originX: (0, $hZcVt.progressPercentage),
    originY: (0, $hZcVt.progressPercentage),
    originZ: (0, $hZcVt.px),
    // Misc
    zIndex: (0, $bt85H.int),
    backgroundPositionX: (0, $hZcVt.px),
    backgroundPositionY: (0, $hZcVt.px),
    // SVG
    fillOpacity: (0, $inZFJ.alpha),
    strokeOpacity: (0, $inZFJ.alpha),
    numOctaves: (0, $bt85H.int)
};

});
parcelRegister("inZFJ", function(module, exports) {

$parcel$export(module.exports, "number", () => $965bce4b5aab9d94$export$98e628dec113755e);
$parcel$export(module.exports, "alpha", () => $965bce4b5aab9d94$export$58f0f39f63f3cf42);
$parcel$export(module.exports, "scale", () => $965bce4b5aab9d94$export$dcdf75081b88279d);

var $8wzur = parcelRequire("8wzur");
const $965bce4b5aab9d94$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $965bce4b5aab9d94$export$58f0f39f63f3cf42 = {
    ...$965bce4b5aab9d94$export$98e628dec113755e,
    transform: (v)=>(0, $8wzur.clamp)(0, 1, v)
};
const $965bce4b5aab9d94$export$dcdf75081b88279d = {
    ...$965bce4b5aab9d94$export$98e628dec113755e,
    default: 1
};

});
parcelRegister("8wzur", function(module, exports) {

$parcel$export(module.exports, "clamp", () => $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4);
const $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

});


parcelRegister("hZcVt", function(module, exports) {

$parcel$export(module.exports, "degrees", () => $25ca921ba8e55794$export$41fc368e1a942b97);
$parcel$export(module.exports, "percent", () => $25ca921ba8e55794$export$626336c2cd4b14de);
$parcel$export(module.exports, "px", () => $25ca921ba8e55794$export$91c0eda1d06bf008);
$parcel$export(module.exports, "vh", () => $25ca921ba8e55794$export$f91e8c45a95a32f2);
$parcel$export(module.exports, "vw", () => $25ca921ba8e55794$export$aed3d7b7d206c196);
$parcel$export(module.exports, "progressPercentage", () => $25ca921ba8e55794$export$44e2e1705876d7ed);

var $j9l1I = parcelRequire("j9l1I");
const $25ca921ba8e55794$var$createUnitType = (unit)=>({
        test: (v)=>(0, $j9l1I.isString)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $25ca921ba8e55794$export$41fc368e1a942b97 = $25ca921ba8e55794$var$createUnitType("deg");
const $25ca921ba8e55794$export$626336c2cd4b14de = $25ca921ba8e55794$var$createUnitType("%");
const $25ca921ba8e55794$export$91c0eda1d06bf008 = $25ca921ba8e55794$var$createUnitType("px");
const $25ca921ba8e55794$export$f91e8c45a95a32f2 = $25ca921ba8e55794$var$createUnitType("vh");
const $25ca921ba8e55794$export$aed3d7b7d206c196 = $25ca921ba8e55794$var$createUnitType("vw");
const $25ca921ba8e55794$export$44e2e1705876d7ed = {
    ...$25ca921ba8e55794$export$626336c2cd4b14de,
    parse: (v)=>$25ca921ba8e55794$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$25ca921ba8e55794$export$626336c2cd4b14de.transform(v * 100)
};

});
parcelRegister("j9l1I", function(module, exports) {

$parcel$export(module.exports, "sanitize", () => $9d068be114f1d873$export$83d2e9e3e4ee39ed);
$parcel$export(module.exports, "floatRegex", () => $9d068be114f1d873$export$2444ca58c08448e4);
$parcel$export(module.exports, "colorRegex", () => $9d068be114f1d873$export$740b69c5fad25dba);
$parcel$export(module.exports, "singleColorRegex", () => $9d068be114f1d873$export$ed808ff6ecd39e8d);
$parcel$export(module.exports, "isString", () => $9d068be114f1d873$export$844ec244b1367d54);
$parcel$export(module.exports, "isNullish", () => $9d068be114f1d873$export$b931b78cbb3caf86);
/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $9d068be114f1d873$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $9d068be114f1d873$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
const $9d068be114f1d873$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
const $9d068be114f1d873$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function $9d068be114f1d873$export$844ec244b1367d54(v) {
    return typeof v === "string";
}
function $9d068be114f1d873$export$b931b78cbb3caf86(v) {
    return v == null;
}

});


parcelRegister("bt85H", function(module, exports) {

$parcel$export(module.exports, "int", () => $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e);

var $inZFJ = parcelRequire("inZFJ");
const $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e = {
    ...(0, $inZFJ.number),
    transform: Math.round
};

});



parcelRegister("fiQRA", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", () => $57bb451bc3d87577$export$8940b483cf52eeda);
const $57bb451bc3d87577$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });

});


parcelRegister("8RV9d", function(module, exports) {

$parcel$export(module.exports, "filterProps", () => $05db6db4ebcdf5f1$export$d697c39a2985a4c);

var $nQeJi = parcelRequire("nQeJi");
let $05db6db4ebcdf5f1$var$shouldForward = (key)=>!(0, $nQeJi.isValidMotionProp)(key);
function $05db6db4ebcdf5f1$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $05db6db4ebcdf5f1$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $nQeJi.isValidMotionProp)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $05db6db4ebcdf5f1$export$59d6962c470509a5($05db6db4ebcdf5f1$import$c6bce8c37c642938$2e2bcd8739ae039);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $05db6db4ebcdf5f1$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($05db6db4ebcdf5f1$var$shouldForward(key) || forwardMotionProps === true && (0, $nQeJi.isValidMotionProp)(key) || !isDom && !(0, $nQeJi.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}

});
parcelRegister("nQeJi", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", () => $c4bee6acbf082b7d$export$2f9c46555243bf04);
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $c4bee6acbf082b7d$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $c4bee6acbf082b7d$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $c4bee6acbf082b7d$var$validMotionProps.has(key);
}

});


parcelRegister("cc1pG", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", () => $268dc116ac4d3a3d$export$84309c4f53cb1bd5);

var $acw62 = parcelRequire("acw62");

var $aZIZO = parcelRequire("aZIZO");

var $2g66t = parcelRequire("2g66t");

var $g9aPP = parcelRequire("g9aPP");

var $gix33 = parcelRequire("gix33");
function $268dc116ac4d3a3d$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $acw62.useMemo)(()=>{
        const state = (0, $g9aPP.createSvgRenderState)();
        (0, $2g66t.buildSVGAttrs)(state, visualState, (0, $gix33.isSVGTag)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $aZIZO.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}

});
parcelRegister("2g66t", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", () => $59f141cfaf6fcabb$export$5475d24f125d7053);

var $9U95V = parcelRequire("9U95V");

var $4DYGO = parcelRequire("4DYGO");

var $kc1Jt = parcelRequire("kc1Jt");
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $59f141cfaf6fcabb$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $9U95V.buildHTMLStyles)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $4DYGO.calcSVGTransformOrigin)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $kc1Jt.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("4DYGO", function(module, exports) {

$parcel$export(module.exports, "calcSVGTransformOrigin", () => $2860344bf6c6c49f$export$d4fbcfc8e5472155);

var $hZcVt = parcelRequire("hZcVt");
function $2860344bf6c6c49f$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $hZcVt.px).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $2860344bf6c6c49f$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $2860344bf6c6c49f$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $2860344bf6c6c49f$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}

});

parcelRegister("kc1Jt", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", () => $f5fdba1fd96a9ba7$export$311b43f666da1d82);

var $hZcVt = parcelRequire("hZcVt");
const $f5fdba1fd96a9ba7$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $f5fdba1fd96a9ba7$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $f5fdba1fd96a9ba7$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $f5fdba1fd96a9ba7$var$dashKeys : $f5fdba1fd96a9ba7$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $hZcVt.px).transform(-offset);
    // Build the dash array
    const pathLength = (0, $hZcVt.px).transform(length);
    const pathSpacing = (0, $hZcVt.px).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

});


parcelRegister("g9aPP", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", () => $b7a2547211637b3c$export$41be8b43e1c4d4f9);

var $fiQRA = parcelRequire("fiQRA");
const $b7a2547211637b3c$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $fiQRA.createHtmlRenderState)(),
        attrs: {}
    });

});

parcelRegister("gix33", function(module, exports) {

$parcel$export(module.exports, "isSVGTag", () => $c139bf35362d2174$export$6328ce7565ea1049);
const $c139bf35362d2174$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";

});



parcelRegister("AO3i6", function(module, exports) {

$parcel$export(module.exports, "svgMotionConfig", () => $fde6d634ecc7ed6c$export$44dabd3fae512e85);

var $daTxn = parcelRequire("daTxn");

var $JEDlr = parcelRequire("JEDlr");

var $hac5G = parcelRequire("hac5G");

var $g9aPP = parcelRequire("g9aPP");

var $2g66t = parcelRequire("2g66t");

var $gix33 = parcelRequire("gix33");

var $hjgf3 = parcelRequire("hjgf3");
const $fde6d634ecc7ed6c$export$44dabd3fae512e85 = {
    useVisualState: (0, $hac5G.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $JEDlr.scrapeMotionValuesFromProps),
        createRenderState: (0, $g9aPP.createSvgRenderState),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $hjgf3.frame).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $hjgf3.frame).render(()=>{
                (0, $2g66t.buildSVGAttrs)(renderState, latestValues, (0, $gix33.isSVGTag)(instance.tagName), props.transformTemplate);
                (0, $daTxn.renderSVG)(instance, renderState);
            });
        }
    })
};

});
parcelRegister("daTxn", function(module, exports) {

$parcel$export(module.exports, "renderSVG", () => $9422342e44092cf6$export$c5f8399d19a7394b);

var $4kYgl = parcelRequire("4kYgl");

var $fMnH3 = parcelRequire("fMnH3");

var $945PB = parcelRequire("945PB");
function $9422342e44092cf6$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $fMnH3.renderHTML)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $945PB.camelCaseAttributes).has(key) ? (0, $4kYgl.camelToDash)(key) : key, renderState.attrs[key]);
}

});
parcelRegister("fMnH3", function(module, exports) {

$parcel$export(module.exports, "renderHTML", () => $a52b6fc2f3af305f$export$1a32bf6229c258c0);
function $a52b6fc2f3af305f$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}

});

parcelRegister("945PB", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", () => $ea3ecc5fb2887a0f$export$28931db5d57958e5);
/**
 * A set of attribute names that are always read/written as camel case.
 */ const $ea3ecc5fb2887a0f$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

});


parcelRegister("JEDlr", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", () => $eac085b45c9e0925$export$16da615486abaa45);

var $jqFCw = parcelRequire("jqFCw");

var $eZ617 = parcelRequire("eZ617");

var $5f0mC = parcelRequire("5f0mC");
function $eac085b45c9e0925$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $eZ617.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    for(const key in props)if ((0, $jqFCw.isMotionValue)(props[key]) || (0, $jqFCw.isMotionValue)(prevProps[key])) {
        const targetKey = (0, $5f0mC.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});
parcelRegister("eZ617", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", () => $a8ee53e44f8c4ac8$export$16da615486abaa45);

var $8tTaz = parcelRequire("8tTaz");

var $jqFCw = parcelRequire("jqFCw");
function $a8ee53e44f8c4ac8$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $jqFCw.isMotionValue)(style[key]) || prevProps.style && (0, $jqFCw.isMotionValue)(prevProps.style[key]) || (0, $8tTaz.isForcedMotionValue)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    /**
     * If the willChange style has been manually set as a string, set
     * applyWillChange to false to prevent it from automatically being applied.
     */ if (visualElement && style && typeof style.willChange === "string") visualElement.applyWillChange = false;
    return newValues;
}

});


parcelRegister("hac5G", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", () => $5c26ebcca6422185$export$e91e107bc6d03a8e);

var $acw62 = parcelRequire("acw62");

var $k8Lf0 = parcelRequire("k8Lf0");

var $gtJis = parcelRequire("gtJis");

var $iIE6Y = parcelRequire("iIE6Y");

var $aTYEI = parcelRequire("aTYEI");

var $cz2ac = parcelRequire("cz2ac");

var $e3EFx = parcelRequire("e3EFx");

var $jeuUs = parcelRequire("jeuUs");

var $8dCaR = parcelRequire("8dCaR");

var $8DEVZ = parcelRequire("8DEVZ");
function $5c26ebcca6422185$var$makeState({ applyWillChange: applyWillChange = false, scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext, isStatic) {
    const state = {
        latestValues: $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, isStatic ? false : applyWillChange, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $5c26ebcca6422185$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $acw62.useContext)((0, $e3EFx.MotionContext));
        const presenceContext = (0, $acw62.useContext)((0, $gtJis.PresenceContext));
        const make = ()=>$5c26ebcca6422185$var$makeState(config, props, context, presenceContext, isStatic);
        return isStatic ? make() : (0, $aTYEI.useConstant)(make);
    };
function $5c26ebcca6422185$var$addWillChange(willChange, name) {
    const memberName = (0, $8dCaR.getWillChangeName)(name);
    if (memberName) (0, $8DEVZ.addUniqueItem)(willChange, memberName);
}
function $5c26ebcca6422185$var$forEachDefinition(props, definition, callback) {
    const list = Array.isArray(definition) ? definition : [
        definition
    ];
    for(let i = 0; i < list.length; i++){
        const resolved = (0, $iIE6Y.resolveVariantFromProps)(props, list[i]);
        if (resolved) {
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            callback(target, transitionEnd);
        }
    }
}
function $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, shouldApplyWillChange, scrapeMotionValues) {
    var _a;
    const values = {};
    const willChange = [];
    const applyWillChange = shouldApplyWillChange && ((_a = props.style) === null || _a === void 0 ? void 0 : _a.willChange) === undefined;
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $cz2ac.resolveMotionValue)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $jeuUs.isControllingVariants)(props);
    const isVariantNode$1 = (0, $jeuUs.isVariantNode)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $k8Lf0.isAnimationControls)(variantToSet)) $5c26ebcca6422185$var$forEachDefinition(props, variantToSet, (target, transitionEnd)=>{
        for(const key in target){
            let valueTarget = target[key];
            if (Array.isArray(valueTarget)) {
                /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                valueTarget = valueTarget[index];
            }
            if (valueTarget !== null) values[key] = valueTarget;
        }
        for(const key in transitionEnd)values[key] = transitionEnd[key];
    });
    // Add animating values to will-change
    if (applyWillChange) {
        if (animate && initial !== false && !(0, $k8Lf0.isAnimationControls)(animate)) $5c26ebcca6422185$var$forEachDefinition(props, animate, (target)=>{
            for(const key in target)$5c26ebcca6422185$var$addWillChange(willChange, key);
        });
        if (willChange.length) values.willChange = willChange.join(",");
    }
    return values;
}

});
parcelRegister("iIE6Y", function(module, exports) {

$parcel$export(module.exports, "resolveVariantFromProps", () => $abbf779fde460163$export$d68f140c4d9b48bc);
function $abbf779fde460163$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $abbf779fde460163$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $abbf779fde460163$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $abbf779fde460163$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}

});

parcelRegister("aTYEI", function(module, exports) {

$parcel$export(module.exports, "useConstant", () => $40f5fd83135889a9$export$fe4300aa8eebea86);

var $acw62 = parcelRequire("acw62");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $40f5fd83135889a9$export$fe4300aa8eebea86(init) {
    const ref = (0, $acw62.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});

parcelRegister("cz2ac", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", () => $18cbbcef55016eac$export$fcc2206ecb6d74b);

var $lyAek = parcelRequire("lyAek");

var $jqFCw = parcelRequire("jqFCw");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $18cbbcef55016eac$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $jqFCw.isMotionValue)(value) ? value.get() : value;
    return (0, $lyAek.isCustomValue)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

});
parcelRegister("lyAek", function(module, exports) {

$parcel$export(module.exports, "isCustomValue", () => $21f654501c04362b$export$2f308ad9864b3ac9);
$parcel$export(module.exports, "resolveFinalValueInKeyframes", () => $21f654501c04362b$export$5485128c47bd48bb);

var $eT2fJ = parcelRequire("eT2fJ");
const $21f654501c04362b$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $21f654501c04362b$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $eT2fJ.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
};

});
parcelRegister("eT2fJ", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", () => $ef59b2359a289b82$export$9153ad4c4999f4a0);
const $ef59b2359a289b82$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};

});



parcelRegister("8dCaR", function(module, exports) {

$parcel$export(module.exports, "getWillChangeName", () => $30237768cea4eeef$export$b3f9dd865b560c6);

var $f7T4G = parcelRequire("f7T4G");

var $4kYgl = parcelRequire("4kYgl");

var $5f0mC = parcelRequire("5f0mC");
function $30237768cea4eeef$export$b3f9dd865b560c6(name) {
    if ((0, $5f0mC.transformProps).has(name)) return "transform";
    else if ((0, $f7T4G.acceleratedValues).has(name)) return (0, $4kYgl.camelToDash)(name);
}

});
parcelRegister("f7T4G", function(module, exports) {

$parcel$export(module.exports, "acceleratedValues", () => $3ba99b92464523da$export$a27eefbd8fb5e404);
/**
 * A list of values that can be hardware-accelerated.
 */ const $3ba99b92464523da$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);

});


parcelRegister("8DEVZ", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", () => $f9c6cc6428ae273c$export$20e507e47fae79fd);
$parcel$export(module.exports, "removeItem", () => $f9c6cc6428ae273c$export$fe2d9b4e03920b4c);
function $f9c6cc6428ae273c$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $f9c6cc6428ae273c$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $f9c6cc6428ae273c$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});


parcelRegister("hjgf3", function(module, exports) {

$parcel$export(module.exports, "frame", () => $9f96722ff12dbfe7$export$2cef06c20297c17d);
$parcel$export(module.exports, "cancelFrame", () => $9f96722ff12dbfe7$export$ec99c0ef4978dccb);
$parcel$export(module.exports, "frameData", () => $9f96722ff12dbfe7$export$fff89137e9e818ce);
$parcel$export(module.exports, "steps", () => $9f96722ff12dbfe7$export$be3f796aed065412);

var $h4EQ1 = parcelRequire("h4EQ1");

var $9nOst = parcelRequire("9nOst");
const { schedule: $9f96722ff12dbfe7$export$2cef06c20297c17d, cancel: $9f96722ff12dbfe7$export$ec99c0ef4978dccb, state: $9f96722ff12dbfe7$export$fff89137e9e818ce, steps: $9f96722ff12dbfe7$export$be3f796aed065412 } = (0, $9nOst.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $h4EQ1.noop), true);

});
parcelRegister("h4EQ1", function(module, exports) {

$parcel$export(module.exports, "noop", () => $448ce039afb5ec07$export$8793edee2d425525);
const $448ce039afb5ec07$export$8793edee2d425525 = (any)=>any;

});



parcelRegister("jCKYH", function(module, exports) {

$parcel$export(module.exports, "htmlMotionConfig", () => $dcb38e10dcfb6316$export$e13ea21d87ea57c8);

var $hac5G = parcelRequire("hac5G");

var $eZ617 = parcelRequire("eZ617");

var $fiQRA = parcelRequire("fiQRA");
const $dcb38e10dcfb6316$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $hac5G.makeUseVisualState)({
        applyWillChange: true,
        scrapeMotionValuesFromProps: $eZ617.scrapeMotionValuesFromProps,
        createRenderState: (0, $fiQRA.createHtmlRenderState)
    })
};

});


parcelRegister("iLse2", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", () => $5e115984cd871deb$export$e5b72898e5a201f1);

var $72IWG = parcelRequire("72IWG");

var $h4wJ8 = parcelRequire("h4wJ8");

var $gXiQM = parcelRequire("gXiQM");

var $k23r0 = parcelRequire("k23r0");
const $5e115984cd871deb$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $k23r0.InViewFeature)
    },
    tap: {
        Feature: (0, $gXiQM.PressGesture)
    },
    focus: {
        Feature: (0, $h4wJ8.FocusGesture)
    },
    hover: {
        Feature: (0, $72IWG.HoverGesture)
    }
};

});
parcelRegister("72IWG", function(module, exports) {

$parcel$export(module.exports, "HoverGesture", () => $dfb80d799aa36175$export$93a81ea037eac456);

var $18XBr = parcelRequire("18XBr");

var $eJKMP = parcelRequire("eJKMP");

var $bYmgt = parcelRequire("bYmgt");

var $7xT8i = parcelRequire("7xT8i");

var $hjgf3 = parcelRequire("hjgf3");
function $dfb80d799aa36175$var$addHoverEvent(node, isActive) {
    const eventName = isActive ? "pointerenter" : "pointerleave";
    const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $bYmgt.isDragActive)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        const callback = props[callbackName];
        if (callback) (0, $hjgf3.frame).postRender(()=>callback(event, info));
    };
    return (0, $18XBr.addPointerEvent)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $dfb80d799aa36175$export$93a81ea037eac456 extends (0, $7xT8i.Feature) {
    mount() {
        this.unmount = (0, $eJKMP.pipe)($dfb80d799aa36175$var$addHoverEvent(this.node, true), $dfb80d799aa36175$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}

});
parcelRegister("18XBr", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", () => $7fd40e38993f1c69$export$fcff2e64e6676b81);

var $lNCq3 = parcelRequire("lNCq3");

var $2BisC = parcelRequire("2BisC");
function $7fd40e38993f1c69$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $lNCq3.addDomEvent)(target, eventName, (0, $2BisC.addPointerInfo)(handler), options);
}

});
parcelRegister("lNCq3", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", () => $43ace1b5a11c3a40$export$b1d829ddf82884aa);
function $43ace1b5a11c3a40$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}

});

parcelRegister("2BisC", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", () => $23ab615c547792c0$export$12f84bb882d06e1a);
$parcel$export(module.exports, "addPointerInfo", () => $23ab615c547792c0$export$c404e80f92c98d29);

var $gHFPX = parcelRequire("gHFPX");
function $23ab615c547792c0$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[`${pointType}X`],
            y: event[`${pointType}Y`]
        }
    };
}
const $23ab615c547792c0$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $gHFPX.isPrimaryPointer)(event) && handler(event, $23ab615c547792c0$export$12f84bb882d06e1a(event));
};

});
parcelRegister("gHFPX", function(module, exports) {

$parcel$export(module.exports, "isPrimaryPointer", () => $6b2f8b101475710a$export$a4cf9c8a4b063a6e);
const $6b2f8b101475710a$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};

});



parcelRegister("eJKMP", function(module, exports) {

$parcel$export(module.exports, "pipe", () => $21841eadb135946f$export$a4627e546088548d);
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $21841eadb135946f$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $21841eadb135946f$export$a4627e546088548d = (...transformers)=>transformers.reduce($21841eadb135946f$var$combineFunctions);

});

parcelRegister("bYmgt", function(module, exports) {

$parcel$export(module.exports, "getGlobalLock", () => $df8cc4eab047d382$export$2b7959ed03c1a3fe);
$parcel$export(module.exports, "isDragActive", () => $df8cc4eab047d382$export$1b3dd616664938e4);
function $df8cc4eab047d382$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $df8cc4eab047d382$var$globalHorizontalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragHorizontal");
const $df8cc4eab047d382$var$globalVerticalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragVertical");
function $df8cc4eab047d382$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $df8cc4eab047d382$var$globalVerticalLock();
    else if (drag === "x") lock = $df8cc4eab047d382$var$globalHorizontalLock();
    else {
        const openHorizontal = $df8cc4eab047d382$var$globalHorizontalLock();
        const openVertical = $df8cc4eab047d382$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $df8cc4eab047d382$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $df8cc4eab047d382$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}

});

parcelRegister("7xT8i", function(module, exports) {

$parcel$export(module.exports, "Feature", () => $5b9241b1e863e695$export$6e91cf7616333d5);
class $5b9241b1e863e695$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}

});


parcelRegister("h4wJ8", function(module, exports) {

$parcel$export(module.exports, "FocusGesture", () => $46d14c2f8ccf5da4$export$d4826db40d47595b);

var $lNCq3 = parcelRequire("lNCq3");

var $7xT8i = parcelRequire("7xT8i");

var $eJKMP = parcelRequire("eJKMP");
class $46d14c2f8ccf5da4$export$d4826db40d47595b extends (0, $7xT8i.Feature) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $eJKMP.pipe)((0, $lNCq3.addDomEvent)(this.node.current, "focus", ()=>this.onFocus()), (0, $lNCq3.addDomEvent)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}

});

parcelRegister("gXiQM", function(module, exports) {

$parcel$export(module.exports, "PressGesture", () => $b3902e3e20ea107a$export$f026abdbba7f0c9e);

var $2BisC = parcelRequire("2BisC");

var $lNCq3 = parcelRequire("lNCq3");

var $18XBr = parcelRequire("18XBr");

var $7xT8i = parcelRequire("7xT8i");

var $eJKMP = parcelRequire("eJKMP");

var $bYmgt = parcelRequire("bYmgt");

var $l2YMH = parcelRequire("l2YMH");

var $h4EQ1 = parcelRequire("h4EQ1");

var $hjgf3 = parcelRequire("hjgf3");
function $b3902e3e20ea107a$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $2BisC.extractEventInfo)(syntheticPointerEvent));
}
class $b3902e3e20ea107a$export$f026abdbba7f0c9e extends (0, $7xT8i.Feature) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $h4EQ1.noop);
        this.removeEndListeners = (0, $h4EQ1.noop);
        this.removeAccessibleListeners = (0, $h4EQ1.noop);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ const handler = !globalTapTarget && !(0, $l2YMH.isNodeOrChild)(this.node.current, endEvent.target) ? onTapCancel : onTap;
                if (handler) (0, $hjgf3.frame).update(()=>handler(endEvent, endInfo));
            };
            const removePointerUpListener = (0, $18XBr.addPointerEvent)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $18XBr.addPointerEvent)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $eJKMP.pipe)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $b3902e3e20ea107a$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $hjgf3.frame).postRender(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $lNCq3.addDomEvent)(this.node.current, "keyup", handleKeyup);
                $b3902e3e20ea107a$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $lNCq3.addDomEvent)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $b3902e3e20ea107a$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $lNCq3.addDomEvent)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $eJKMP.pipe)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $hjgf3.frame).postRender(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $bYmgt.isDragActive)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $hjgf3.frame).postRender(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $18XBr.addPointerEvent)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $lNCq3.addDomEvent)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $eJKMP.pipe)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}

});
parcelRegister("l2YMH", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", () => $ae5289b89bf4fd95$export$e841ada32ff745b);
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $ae5289b89bf4fd95$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $ae5289b89bf4fd95$export$e841ada32ff745b(parent, child.parentElement);
};

});


parcelRegister("k23r0", function(module, exports) {

$parcel$export(module.exports, "InViewFeature", () => $3926a5d0685d183c$export$150851c8cc2f0c72);

var $7xT8i = parcelRequire("7xT8i");

var $fUEqC = parcelRequire("fUEqC");
const $3926a5d0685d183c$var$thresholdNames = {
    some: 0,
    all: 1
};
class $3926a5d0685d183c$export$150851c8cc2f0c72 extends (0, $7xT8i.Feature) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $3926a5d0685d183c$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $fUEqC.observeIntersection)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($3926a5d0685d183c$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $3926a5d0685d183c$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}

});
parcelRegister("fUEqC", function(module, exports) {

$parcel$export(module.exports, "observeIntersection", () => $577133ec08d9e334$export$b2bcd62fb7925aa5);
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $577133ec08d9e334$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $577133ec08d9e334$var$observers = new WeakMap();
const $577133ec08d9e334$var$fireObserverCallback = (entry)=>{
    const callback = $577133ec08d9e334$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $577133ec08d9e334$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($577133ec08d9e334$var$fireObserverCallback);
};
function $577133ec08d9e334$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$577133ec08d9e334$var$observers.has(lookupRoot)) $577133ec08d9e334$var$observers.set(lookupRoot, {});
    const rootObservers = $577133ec08d9e334$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($577133ec08d9e334$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $577133ec08d9e334$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $577133ec08d9e334$var$initIntersectionObserver(options);
    $577133ec08d9e334$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $577133ec08d9e334$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

});



parcelRegister("crTFY", function(module, exports) {

$parcel$export(module.exports, "animations", () => $03e8b675a1009b68$export$7f9953c70dacfd7f);

var $fOUJv = parcelRequire("fOUJv");

var $aH0w0 = parcelRequire("aH0w0");
const $03e8b675a1009b68$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $fOUJv.AnimationFeature)
    },
    exit: {
        Feature: (0, $aH0w0.ExitAnimationFeature)
    }
};

});
parcelRegister("fOUJv", function(module, exports) {

$parcel$export(module.exports, "AnimationFeature", () => $bfc36aed86970b83$export$b45b3fe5caabdca);

var $k8Lf0 = parcelRequire("k8Lf0");

var $dOx92 = parcelRequire("dOx92");

var $7xT8i = parcelRequire("7xT8i");
class $bfc36aed86970b83$export$b45b3fe5caabdca extends (0, $7xT8i.Feature) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $dOx92.createAnimationState)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $k8Lf0.isAnimationControls)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}

});
parcelRegister("dOx92", function(module, exports) {

$parcel$export(module.exports, "createAnimationState", () => $351ff45a987b08cc$export$bb53502b7a672aa8);

var $k8Lf0 = parcelRequire("k8Lf0");

var $eT2fJ = parcelRequire("eT2fJ");

var $3aeKv = parcelRequire("3aeKv");

var $dLd38 = parcelRequire("dLd38");

var $2KqtA = parcelRequire("2KqtA");

var $fNC3C = parcelRequire("fNC3C");

var $ihLoT = parcelRequire("ihLoT");
const $351ff45a987b08cc$var$reversePriorityOrder = [
    ...(0, $fNC3C.variantPriorityOrder)
].reverse();
const $351ff45a987b08cc$var$numAnimationTypes = (0, $fNC3C.variantPriorityOrder).length;
function $351ff45a987b08cc$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $ihLoT.animateVisualElement)(visualElement, animation, options)));
}
function $351ff45a987b08cc$export$bb53502b7a672aa8(visualElement) {
    let animate = $351ff45a987b08cc$var$animateList(visualElement);
    let state = $351ff45a987b08cc$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $2KqtA.resolveVariant)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $351ff45a987b08cc$var$numAnimationTypes; i++){
            const type = $351ff45a987b08cc$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $dLd38.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $k8Lf0.isAnimationControls)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $351ff45a987b08cc$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $eT2fJ.isKeyframesTarget)(next) && (0, $eT2fJ.isKeyframesTarget)(prev)) valueHasChanged = !(0, $3aeKv.shallowCompare)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $351ff45a987b08cc$var$createState();
            isInitialRender = true;
        }
    };
}
function $351ff45a987b08cc$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $3aeKv.shallowCompare)(next, prev);
    return false;
}
function $351ff45a987b08cc$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $351ff45a987b08cc$var$createState() {
    return {
        animate: $351ff45a987b08cc$var$createTypeState(true),
        whileInView: $351ff45a987b08cc$var$createTypeState(),
        whileHover: $351ff45a987b08cc$var$createTypeState(),
        whileTap: $351ff45a987b08cc$var$createTypeState(),
        whileDrag: $351ff45a987b08cc$var$createTypeState(),
        whileFocus: $351ff45a987b08cc$var$createTypeState(),
        exit: $351ff45a987b08cc$var$createTypeState()
    };
}

});
parcelRegister("3aeKv", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", () => $21ec58272207c53a$export$90e866afbd6b9f1a);
function $21ec58272207c53a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRegister("2KqtA", function(module, exports) {

$parcel$export(module.exports, "resolveVariant", () => $58c1fda9d3891d8d$export$7b1b1c981f4f0558);

var $iIE6Y = parcelRequire("iIE6Y");
function $58c1fda9d3891d8d$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $iIE6Y.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

});

parcelRegister("ihLoT", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", () => $7d7d5f8a14d3a662$export$ff62cf473653f109);

var $2KqtA = parcelRequire("2KqtA");

var $foFDd = parcelRequire("foFDd");

var $h0scq = parcelRequire("h0scq");
function $7d7d5f8a14d3a662$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $h0scq.animateVariant)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $h0scq.animateVariant)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $2KqtA.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $foFDd.animateTarget)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}

});
parcelRegister("foFDd", function(module, exports) {

$parcel$export(module.exports, "animateTarget", () => $14d5e29c1a7af8ca$export$68cacfeee78d98d2);

var $5f0mC = parcelRequire("5f0mC");

var $cTXJe = parcelRequire("cTXJe");

var $87OLY = parcelRequire("87OLY");

var $bUTXm = parcelRequire("bUTXm");

var $7AeP3 = parcelRequire("7AeP3");

var $8VmYs = parcelRequire("8VmYs");

var $hjgf3 = parcelRequire("hjgf3");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $14d5e29c1a7af8ca$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $14d5e29c1a7af8ca$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $14d5e29c1a7af8ca$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...(0, $bUTXm.getValueTransition)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.HandoffAppearAnimations) {
            const appearId = (0, $7AeP3.getOptimisedAppearId)(visualElement);
            if (appearId) {
                const elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $hjgf3.frame));
                if (elapsed !== null) {
                    valueTransition.elapsed = elapsed;
                    isHandoff = true;
                }
            }
        }
        value.start((0, $cTXJe.animateMotionValue)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $5f0mC.transformProps).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff, (0, $8VmYs.addValueToWillChange)(visualElement, key)));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $hjgf3.frame).update(()=>{
            transitionEnd && (0, $87OLY.setTarget)(visualElement, transitionEnd);
        });
    });
    return animations;
}

});
parcelRegister("cTXJe", function(module, exports) {

$parcel$export(module.exports, "animateMotionValue", () => $9e7a9f8af70c9aa6$export$90b3dfc33ff3548);

var $iNwSi = parcelRequire("iNwSi");

var $kSXzE = parcelRequire("kSXzE");

var $bUTXm = parcelRequire("bUTXm");

var $abtYf = parcelRequire("abtYf");

var $cImAs = parcelRequire("cImAs");

var $9gqMU = parcelRequire("9gqMU");

var $hjgf3 = parcelRequire("hjgf3");

var $iRfYW = parcelRequire("iRfYW");

var $6jdFX = parcelRequire("6jdFX");

var $i4JaE = parcelRequire("i4JaE");
const $9e7a9f8af70c9aa6$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff, /**
 * Currently used to remove values from will-change when an animation ends.
 * Preferably this would be handled by event listeners on the MotionValue
 * but these aren't consistent enough yet when considering the different ways
 * an animation can be cancelled.
 */ onEnd)=>(onComplete)=>{
        const valueTransition = (0, $bUTXm.getValueTransition)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $iNwSi.secondsToMilliseconds)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
                onEnd && onEnd();
            },
            onStop: onEnd,
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $bUTXm.isTransitionDefined)(valueTransition)) options = {
            ...options,
            ...(0, $kSXzE.getDefaultTransition)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $iNwSi.secondsToMilliseconds)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $iNwSi.secondsToMilliseconds)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $cImAs.instantAnimationState).current || (0, $abtYf.MotionGlobalConfig).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $9gqMU.getFinalKeyframe)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $hjgf3.frame).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $i4JaE.GroupPlaybackControls)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $iRfYW.AcceleratedAnimation).supports(options)) return new (0, $iRfYW.AcceleratedAnimation)(options);
        else return new (0, $6jdFX.MainThreadAnimation)(options);
    };

});
parcelRegister("iNwSi", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", () => $083454c8244247d6$export$fc3e7e8557f8c8c7);
$parcel$export(module.exports, "millisecondsToSeconds", () => $083454c8244247d6$export$f64c3bfbc58eec0f);
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $083454c8244247d6$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $083454c8244247d6$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

});

parcelRegister("kSXzE", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", () => $5f1d5ca1d398e82d$export$262124b154b9f1c0);

var $5f0mC = parcelRequire("5f0mC");
const $5f1d5ca1d398e82d$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $5f1d5ca1d398e82d$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $5f1d5ca1d398e82d$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $5f1d5ca1d398e82d$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $5f1d5ca1d398e82d$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $5f1d5ca1d398e82d$var$keyframesTransition;
    else if ((0, $5f0mC.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? $5f1d5ca1d398e82d$var$criticallyDampedSpring(keyframes[1]) : $5f1d5ca1d398e82d$var$underDampedSpring;
    return $5f1d5ca1d398e82d$var$ease;
};

});

parcelRegister("bUTXm", function(module, exports) {

$parcel$export(module.exports, "isTransitionDefined", () => $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7);
$parcel$export(module.exports, "getValueTransition", () => $ec9bae3b9c638c7a$export$7c1391340308742e);
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $ec9bae3b9c638c7a$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}

});

parcelRegister("cImAs", function(module, exports) {

$parcel$export(module.exports, "instantAnimationState", () => $77818709e1bb6833$export$888a3d84909f9e3d);
const $77818709e1bb6833$export$888a3d84909f9e3d = {
    current: false
};

});

parcelRegister("9gqMU", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", () => $b7455746a6cabbfe$export$14de59408fad90b);
const $b7455746a6cabbfe$var$isNotNull = (value)=>value !== null;
function $b7455746a6cabbfe$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($b7455746a6cabbfe$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

});

parcelRegister("iRfYW", function(module, exports) {

$parcel$export(module.exports, "AcceleratedAnimation", () => $b5becce7483d72ec$export$2a45abb4e6513325);

var $8x9V3 = parcelRequire("8x9V3");

var $53Cqv = parcelRequire("53Cqv");

var $jw16H = parcelRequire("jw16H");

var $h4EQ1 = parcelRequire("h4EQ1");

var $iNwSi = parcelRequire("iNwSi");

var $d3jhS = parcelRequire("d3jhS");

var $6jdFX = parcelRequire("6jdFX");

var $f7T4G = parcelRequire("f7T4G");

var $dg6Fz = parcelRequire("dg6Fz");

var $ggB8d = parcelRequire("ggB8d");

var $9gqMU = parcelRequire("9gqMU");
const $b5becce7483d72ec$var$supportsWaapi = (0, $jw16H.memo)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $b5becce7483d72ec$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $b5becce7483d72ec$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $b5becce7483d72ec$var$requiresPregeneratedKeyframes(options) {
    return options.type === "spring" || !(0, $ggB8d.isWaapiSupportedEasing)(options.ease);
}
function $b5becce7483d72ec$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $6jdFX.MainThreadAnimation)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $b5becce7483d72ec$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $b5becce7483d72ec$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $b5becce7483d72ec$var$sampleDelta,
        ease: "linear"
    };
}
class $b5becce7483d72ec$export$2a45abb4e6513325 extends (0, $d3jhS.BaseAnimation) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, keyframes: keyframes } = this.options;
        this.resolver = new (0, $53Cqv.DOMKeyframesResolver)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($b5becce7483d72ec$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, ...options } = this.options;
            const pregeneratedAnimation = $b5becce7483d72ec$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $dg6Fz.animateStyle)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = (0, $8x9V3.time).now();
        if (this.pendingTimeline) {
            animation.timeline = this.pendingTimeline;
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $9gqMU.getFinalKeyframe)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $iNwSi.millisecondsToSeconds)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $iNwSi.millisecondsToSeconds)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $iNwSi.secondsToMilliseconds)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $h4EQ1.noop;
            const { animation: animation } = resolved;
            animation.timeline = timeline;
            animation.onfinish = null;
        }
        return 0, $h4EQ1.noop;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, ...options } = this.options;
            const sampleAnimation = new (0, $6jdFX.MainThreadAnimation)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $iNwSi.secondsToMilliseconds)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $b5becce7483d72ec$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $b5becce7483d72ec$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        return $b5becce7483d72ec$var$supportsWaapi() && name && (0, $f7T4G.acceleratedValues).has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}

});
parcelRegister("8x9V3", function(module, exports) {

$parcel$export(module.exports, "time", () => $86c10e7c9731f599$export$2da9be4cfdb689b1);

var $abtYf = parcelRequire("abtYf");

var $hjgf3 = parcelRequire("hjgf3");
let $86c10e7c9731f599$var$now;
function $86c10e7c9731f599$var$clearTime() {
    $86c10e7c9731f599$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $86c10e7c9731f599$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($86c10e7c9731f599$var$now === undefined) $86c10e7c9731f599$export$2da9be4cfdb689b1.set((0, $hjgf3.frameData).isProcessing || (0, $abtYf.MotionGlobalConfig).useManualTiming ? (0, $hjgf3.frameData).timestamp : performance.now());
        return $86c10e7c9731f599$var$now;
    },
    set: (newTime)=>{
        $86c10e7c9731f599$var$now = newTime;
        queueMicrotask($86c10e7c9731f599$var$clearTime);
    }
};

});

parcelRegister("53Cqv", function(module, exports) {

$parcel$export(module.exports, "DOMKeyframesResolver", () => $5195dabd429072c3$export$4983792d11b61017);

var $9pPQO = parcelRequire("9pPQO");

var $lFblP = parcelRequire("lFblP");

var $dAJIO = parcelRequire("dAJIO");

var $bFZFs = parcelRequire("bFZFs");

var $4Vyka = parcelRequire("4Vyka");

var $h9WaA = parcelRequire("h9WaA");

var $6KPea = parcelRequire("6KPea");
class $5195dabd429072c3$export$4983792d11b61017 extends (0, $h9WaA.KeyframeResolver) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue){
        super(unresolvedKeyframes, onComplete, name, motionValue, motionValue === null || motionValue === void 0 ? void 0 : motionValue.owner, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $dAJIO.isCSSVariableToken)(keyframe)) {
                    const resolved = (0, $lFblP.getVariableValue)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $bFZFs.positionalKeys).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $4Vyka.findDimensionValueType)(origin);
        const targetType = (0, $4Vyka.findDimensionValueType)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $bFZFs.isNumOrPxType)(originType) && (0, $bFZFs.isNumOrPxType)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $9pPQO.isNone)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $6KPea.makeNoneKeyframesAnimatable)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $bFZFs.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $bFZFs.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}

});
parcelRegister("9pPQO", function(module, exports) {

$parcel$export(module.exports, "isNone", () => $e0feaef7a76d9154$export$e56af863d5645d5f);

var $e2LUE = parcelRequire("e2LUE");
function $e0feaef7a76d9154$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $e2LUE.isZeroValueString)(value);
    else return true;
}

});
parcelRegister("e2LUE", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", () => $933209bc9c035719$export$ade84c85e44a6cb1);
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $933209bc9c035719$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);

});


parcelRegister("lFblP", function(module, exports) {

$parcel$export(module.exports, "getVariableValue", () => $ac0e5a3978f40f61$export$289398774300c991);

var $6Wt9F = parcelRequire("6Wt9F");

var $bjEgh = parcelRequire("bjEgh");

var $dAJIO = parcelRequire("dAJIO");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $ac0e5a3978f40f61$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current) {
    const match = $ac0e5a3978f40f61$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $ac0e5a3978f40f61$var$maxDepth = 4;
function $ac0e5a3978f40f61$export$289398774300c991(current, element, depth = 1) {
    (0, $6Wt9F.invariant)(depth <= $ac0e5a3978f40f61$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $bjEgh.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $dAJIO.isCSSVariableToken)(fallback) ? $ac0e5a3978f40f61$export$289398774300c991(fallback, element, depth + 1) : fallback;
}

});
parcelRegister("6Wt9F", function(module, exports) {

$parcel$export(module.exports, "warning", () => $bf99d85f7a843912$export$491112666e282270);
$parcel$export(module.exports, "invariant", () => $bf99d85f7a843912$export$f5708dca728d7177);

var $h4EQ1 = parcelRequire("h4EQ1");
let $bf99d85f7a843912$export$491112666e282270 = (0, $h4EQ1.noop);
let $bf99d85f7a843912$export$f5708dca728d7177 = (0, $h4EQ1.noop);
var $bf99d85f7a843912$var$check, $bf99d85f7a843912$var$message, $bf99d85f7a843912$var$check1, $bf99d85f7a843912$var$message1;

});

parcelRegister("bjEgh", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", () => $d56714d1e4e43615$export$65583ed5a868f2d9);
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $d56714d1e4e43615$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

});


parcelRegister("bFZFs", function(module, exports) {

$parcel$export(module.exports, "positionalKeys", () => $a731b8aa4fe311d9$export$c66c0d5db2a205d);
$parcel$export(module.exports, "isNumOrPxType", () => $a731b8aa4fe311d9$export$8e5250d1aa9bf370);
$parcel$export(module.exports, "removeNonTranslationalTransform", () => $a731b8aa4fe311d9$export$39d4bc9655f3f632);
$parcel$export(module.exports, "positionalValues", () => $a731b8aa4fe311d9$export$781d46a8aa670d52);

var $5f0mC = parcelRequire("5f0mC");

var $inZFJ = parcelRequire("inZFJ");

var $hZcVt = parcelRequire("hZcVt");
const $a731b8aa4fe311d9$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $a731b8aa4fe311d9$export$8e5250d1aa9bf370 = (v)=>v === (0, $inZFJ.number) || v === (0, $hZcVt.px);
const $a731b8aa4fe311d9$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $a731b8aa4fe311d9$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $a731b8aa4fe311d9$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $a731b8aa4fe311d9$var$nonTranslationalTransformKeys = (0, $5f0mC.transformPropOrder).filter((key)=>!$a731b8aa4fe311d9$var$transformKeys.has(key));
function $a731b8aa4fe311d9$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $a731b8aa4fe311d9$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $a731b8aa4fe311d9$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $a731b8aa4fe311d9$var$getTranslateFromMatrix(4, 13),
    y: $a731b8aa4fe311d9$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$a731b8aa4fe311d9$export$781d46a8aa670d52.translateX = $a731b8aa4fe311d9$export$781d46a8aa670d52.x;
$a731b8aa4fe311d9$export$781d46a8aa670d52.translateY = $a731b8aa4fe311d9$export$781d46a8aa670d52.y;

});

parcelRegister("4Vyka", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", () => $a90ec5e4ad59372f$export$d176691c1998a1f5);
$parcel$export(module.exports, "findDimensionValueType", () => $a90ec5e4ad59372f$export$eefdd52e3ccae428);

var $inZFJ = parcelRequire("inZFJ");

var $hZcVt = parcelRequire("hZcVt");

var $cobvw = parcelRequire("cobvw");

var $2RKFx = parcelRequire("2RKFx");
/**
 * A list of value types commonly used for dimensions
 */ const $a90ec5e4ad59372f$export$d176691c1998a1f5 = [
    (0, $inZFJ.number),
    (0, $hZcVt.px),
    (0, $hZcVt.percent),
    (0, $hZcVt.degrees),
    (0, $hZcVt.vw),
    (0, $hZcVt.vh),
    (0, $2RKFx.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $a90ec5e4ad59372f$export$eefdd52e3ccae428 = (v)=>$a90ec5e4ad59372f$export$d176691c1998a1f5.find((0, $cobvw.testValueType)(v));

});
parcelRegister("cobvw", function(module, exports) {

$parcel$export(module.exports, "testValueType", () => $a1e2618328995be8$export$6eae4d0a6a7ca7cd);
/**
 * Tests a provided value against a ValueType
 */ const $a1e2618328995be8$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);

});

parcelRegister("2RKFx", function(module, exports) {

$parcel$export(module.exports, "auto", () => $c231a4375b038d3c$export$dfb5619354ba860);
/**
 * ValueType for "auto"
 */ const $c231a4375b038d3c$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};

});


parcelRegister("h9WaA", function(module, exports) {

$parcel$export(module.exports, "flushKeyframeResolvers", () => $5e6ac566d022e9ed$export$78b96d2a12593b05);
$parcel$export(module.exports, "KeyframeResolver", () => $5e6ac566d022e9ed$export$74d34ca3182f1750);

var $bFZFs = parcelRequire("bFZFs");

var $hjgf3 = parcelRequire("hjgf3");
const $5e6ac566d022e9ed$var$toResolve = new Set();
let $5e6ac566d022e9ed$var$isScheduled = false;
let $5e6ac566d022e9ed$var$anyNeedsMeasurement = false;
function $5e6ac566d022e9ed$var$measureAllKeyframes() {
    if ($5e6ac566d022e9ed$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($5e6ac566d022e9ed$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $bFZFs.removeNonTranslationalTransform)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $5e6ac566d022e9ed$var$anyNeedsMeasurement = false;
    $5e6ac566d022e9ed$var$isScheduled = false;
    $5e6ac566d022e9ed$var$toResolve.forEach((resolver)=>resolver.complete());
    $5e6ac566d022e9ed$var$toResolve.clear();
}
function $5e6ac566d022e9ed$var$readAllKeyframes() {
    $5e6ac566d022e9ed$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $5e6ac566d022e9ed$var$anyNeedsMeasurement = true;
    });
}
function $5e6ac566d022e9ed$export$78b96d2a12593b05() {
    $5e6ac566d022e9ed$var$readAllKeyframes();
    $5e6ac566d022e9ed$var$measureAllKeyframes();
}
class $5e6ac566d022e9ed$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $5e6ac566d022e9ed$var$toResolve.add(this);
            if (!$5e6ac566d022e9ed$var$isScheduled) {
                $5e6ac566d022e9ed$var$isScheduled = true;
                (0, $hjgf3.frame).read($5e6ac566d022e9ed$var$readAllKeyframes);
                (0, $hjgf3.frame).resolveKeyframes($5e6ac566d022e9ed$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $5e6ac566d022e9ed$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $5e6ac566d022e9ed$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}

});

parcelRegister("6KPea", function(module, exports) {

$parcel$export(module.exports, "makeNoneKeyframesAnimatable", () => $cfbe3d130e69a018$export$8cc4958f8e540f37);

var $518Z9 = parcelRequire("518Z9");

var $adXv8 = parcelRequire("adXv8");
/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $cfbe3d130e69a018$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $cfbe3d130e69a018$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$cfbe3d130e69a018$var$invalidTemplates.has(keyframe) && (0, $518Z9.analyseComplexValue)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $adXv8.getAnimatableNone)(name, animatableTemplate);
}

});
parcelRegister("518Z9", function(module, exports) {

$parcel$export(module.exports, "analyseComplexValue", () => $b7b50ce2c2d54405$export$b61fc7c44bf646d5);
$parcel$export(module.exports, "complex", () => $b7b50ce2c2d54405$export$83a0e34f1302825b);

var $4pDEO = parcelRequire("4pDEO");

var $j9l1I = parcelRequire("j9l1I");
function $b7b50ce2c2d54405$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $j9l1I.isString)(v) && (((_a = v.match((0, $j9l1I.floatRegex))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $j9l1I.colorRegex))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $b7b50ce2c2d54405$var$NUMBER_TOKEN = "number";
const $b7b50ce2c2d54405$var$COLOR_TOKEN = "color";
const $b7b50ce2c2d54405$var$VAR_TOKEN = "var";
const $b7b50ce2c2d54405$var$VAR_FUNCTION_TOKEN = "var(";
const $b7b50ce2c2d54405$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $b7b50ce2c2d54405$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $b7b50ce2c2d54405$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($b7b50ce2c2d54405$var$complexRegex, (parsedValue)=>{
        if ((0, $4pDEO.color).test(parsedValue)) {
            indexes.color.push(i);
            types.push($b7b50ce2c2d54405$var$COLOR_TOKEN);
            values.push((0, $4pDEO.color).parse(parsedValue));
        } else if (parsedValue.startsWith($b7b50ce2c2d54405$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($b7b50ce2c2d54405$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($b7b50ce2c2d54405$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $b7b50ce2c2d54405$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($b7b50ce2c2d54405$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $b7b50ce2c2d54405$var$parseComplexValue(v) {
    return $b7b50ce2c2d54405$export$b61fc7c44bf646d5(v).values;
}
function $b7b50ce2c2d54405$var$createTransformer(source) {
    const { split: split, types: types } = $b7b50ce2c2d54405$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $b7b50ce2c2d54405$var$NUMBER_TOKEN) output += (0, $j9l1I.sanitize)(v[i]);
                else if (type === $b7b50ce2c2d54405$var$COLOR_TOKEN) output += (0, $4pDEO.color).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $b7b50ce2c2d54405$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $b7b50ce2c2d54405$var$getAnimatableNone(v) {
    const parsed = $b7b50ce2c2d54405$var$parseComplexValue(v);
    const transformer = $b7b50ce2c2d54405$var$createTransformer(v);
    return transformer(parsed.map($b7b50ce2c2d54405$var$convertNumbersToZero));
}
const $b7b50ce2c2d54405$export$83a0e34f1302825b = {
    test: $b7b50ce2c2d54405$var$test,
    parse: $b7b50ce2c2d54405$var$parseComplexValue,
    createTransformer: $b7b50ce2c2d54405$var$createTransformer,
    getAnimatableNone: $b7b50ce2c2d54405$var$getAnimatableNone
};

});
parcelRegister("4pDEO", function(module, exports) {

$parcel$export(module.exports, "color", () => $d8fe6ea9e8bd3d9c$export$35e9368ef982300f);

var $j9l1I = parcelRequire("j9l1I");

var $cZF0k = parcelRequire("cZF0k");

var $7jJFT = parcelRequire("7jJFT");

var $bLvBX = parcelRequire("bLvBX");
const $d8fe6ea9e8bd3d9c$export$35e9368ef982300f = {
    test: (v)=>(0, $bLvBX.rgba).test(v) || (0, $cZF0k.hex).test(v) || (0, $7jJFT.hsla).test(v),
    parse: (v)=>{
        if ((0, $bLvBX.rgba).test(v)) return (0, $bLvBX.rgba).parse(v);
        else if ((0, $7jJFT.hsla).test(v)) return (0, $7jJFT.hsla).parse(v);
        else return (0, $cZF0k.hex).parse(v);
    },
    transform: (v)=>{
        return (0, $j9l1I.isString)(v) ? v : v.hasOwnProperty("red") ? (0, $bLvBX.rgba).transform(v) : (0, $7jJFT.hsla).transform(v);
    }
};

});
parcelRegister("cZF0k", function(module, exports) {

$parcel$export(module.exports, "hex", () => $875e9bff470aaa65$export$834dfc94dde4b3d8);

var $bLvBX = parcelRequire("bLvBX");

var $ebQMX = parcelRequire("ebQMX");
function $875e9bff470aaa65$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $875e9bff470aaa65$export$834dfc94dde4b3d8 = {
    test: (0, $ebQMX.isColorString)("#"),
    parse: $875e9bff470aaa65$var$parseHex,
    transform: (0, $bLvBX.rgba).transform
};

});
parcelRegister("bLvBX", function(module, exports) {

$parcel$export(module.exports, "rgba", () => $c79d1e7d77418d04$export$4e46ac54fc82cf3b);

var $8wzur = parcelRequire("8wzur");

var $inZFJ = parcelRequire("inZFJ");

var $j9l1I = parcelRequire("j9l1I");

var $ebQMX = parcelRequire("ebQMX");
const $c79d1e7d77418d04$var$clampRgbUnit = (v)=>(0, $8wzur.clamp)(0, 255, v);
const $c79d1e7d77418d04$export$7a99c86b5b1f4c9e = {
    ...(0, $inZFJ.number),
    transform: (v)=>Math.round($c79d1e7d77418d04$var$clampRgbUnit(v))
};
const $c79d1e7d77418d04$export$4e46ac54fc82cf3b = {
    test: (0, $ebQMX.isColorString)("rgb", "red"),
    parse: (0, $ebQMX.splitColor)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(red) + ", " + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(green) + ", " + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $j9l1I.sanitize)((0, $inZFJ.alpha).transform(alpha$1)) + ")"
};

});
parcelRegister("ebQMX", function(module, exports) {

$parcel$export(module.exports, "isColorString", () => $ded99e01d9b518c0$export$2c8400d58aca05e);
$parcel$export(module.exports, "splitColor", () => $ded99e01d9b518c0$export$73d6f35be992df24);

var $j9l1I = parcelRequire("j9l1I");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $ded99e01d9b518c0$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $j9l1I.isString)(v) && (0, $j9l1I.singleColorRegex).test(v) && v.startsWith(type) || testProp && !(0, $j9l1I.isNullish)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $ded99e01d9b518c0$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $j9l1I.isString)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $j9l1I.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

});



parcelRegister("7jJFT", function(module, exports) {

$parcel$export(module.exports, "hsla", () => $8bf8a43b3506d305$export$810b04175080204c);

var $inZFJ = parcelRequire("inZFJ");

var $hZcVt = parcelRequire("hZcVt");

var $j9l1I = parcelRequire("j9l1I");

var $ebQMX = parcelRequire("ebQMX");
const $8bf8a43b3506d305$export$810b04175080204c = {
    test: (0, $ebQMX.isColorString)("hsl", "hue"),
    parse: (0, $ebQMX.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $hZcVt.percent).transform((0, $j9l1I.sanitize)(saturation)) + ", " + (0, $hZcVt.percent).transform((0, $j9l1I.sanitize)(lightness)) + ", " + (0, $j9l1I.sanitize)((0, $inZFJ.alpha).transform(alpha$1)) + ")";
    }
};

});



parcelRegister("adXv8", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", () => $ca0a3798777df465$export$cea0cedcb94873b5);

var $518Z9 = parcelRequire("518Z9");

var $bKeX0 = parcelRequire("bKeX0");

var $h8BN3 = parcelRequire("h8BN3");
function $ca0a3798777df465$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $h8BN3.getDefaultValueType)(key);
    if (defaultValueType !== (0, $bKeX0.filter)) defaultValueType = (0, $518Z9.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

});
parcelRegister("bKeX0", function(module, exports) {

$parcel$export(module.exports, "filter", () => $c55938f2e5f09a1e$export$3dea766d36a8935f);

var $518Z9 = parcelRequire("518Z9");

var $j9l1I = parcelRequire("j9l1I");
/**
 * Properties that should default to 1 or 100%
 */ const $c55938f2e5f09a1e$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $c55938f2e5f09a1e$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $j9l1I.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $c55938f2e5f09a1e$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $c55938f2e5f09a1e$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $c55938f2e5f09a1e$export$3dea766d36a8935f = {
    ...(0, $518Z9.complex),
    getAnimatableNone: (v)=>{
        const functions = v.match($c55938f2e5f09a1e$var$functionRegex);
        return functions ? functions.map($c55938f2e5f09a1e$var$applyDefaultFilter).join(" ") : v;
    }
};

});

parcelRegister("h8BN3", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", () => $6da1de6e0a9a8c9d$export$67d1babe0338d23b);

var $4pDEO = parcelRequire("4pDEO");

var $bKeX0 = parcelRequire("bKeX0");

var $hsgeP = parcelRequire("hsgeP");
/**
 * A map of default value types for common values
 */ const $6da1de6e0a9a8c9d$export$98cd7c72c5a731fb = {
    ...(0, $hsgeP.numberValueTypes),
    color: // Color props
    $4pDEO.color,
    backgroundColor: (0, $4pDEO.color),
    outlineColor: (0, $4pDEO.color),
    fill: (0, $4pDEO.color),
    stroke: (0, $4pDEO.color),
    // Border props
    borderColor: (0, $4pDEO.color),
    borderTopColor: (0, $4pDEO.color),
    borderRightColor: (0, $4pDEO.color),
    borderBottomColor: (0, $4pDEO.color),
    borderLeftColor: (0, $4pDEO.color),
    filter: $bKeX0.filter,
    WebkitFilter: (0, $bKeX0.filter)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $6da1de6e0a9a8c9d$export$67d1babe0338d23b = (key)=>$6da1de6e0a9a8c9d$export$98cd7c72c5a731fb[key];

});




parcelRegister("jw16H", function(module, exports) {

$parcel$export(module.exports, "memo", () => $af0183976178f4ae$export$7c73462e0d25e514);
function $af0183976178f4ae$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}

});

parcelRegister("d3jhS", function(module, exports) {

$parcel$export(module.exports, "BaseAnimation", () => $a4b13d1078db032d$export$d1e4f34b9c2550c1);

var $h9WaA = parcelRequire("h9WaA");

var $cImAs = parcelRequire("cImAs");

var $7uLxm = parcelRequire("7uLxm");

var $9gqMU = parcelRequire("9gqMU");
class $a4b13d1078db032d$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $h9WaA.flushKeyframeResolvers)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $7uLxm.canAnimate)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $cImAs.instantAnimationState).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $9gqMU.getFinalKeyframe)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}

});
parcelRegister("7uLxm", function(module, exports) {

$parcel$export(module.exports, "canAnimate", () => $a0c445b5dae442d5$export$1b109e6c9968df4f);

var $6Wt9F = parcelRequire("6Wt9F");

var $fyA1E = parcelRequire("fyA1E");
function $a0c445b5dae442d5$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $a0c445b5dae442d5$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $fyA1E.isAnimatable)(originKeyframe, name);
    const isTargetAnimatable = (0, $fyA1E.isAnimatable)(targetKeyframe, name);
    (0, $6Wt9F.warning)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $a0c445b5dae442d5$var$hasKeyframesChanged(keyframes) || type === "spring" && velocity;
}

});
parcelRegister("fyA1E", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", () => $ef4086713d7b0bdb$export$65676b58b122bc38);

var $518Z9 = parcelRequire("518Z9");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $ef4086713d7b0bdb$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $518Z9.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});



parcelRegister("6jdFX", function(module, exports) {

$parcel$export(module.exports, "MainThreadAnimation", () => $4dff3825d962577e$export$fd98d9cca67a58bc);

var $h9WaA = parcelRequire("h9WaA");

var $6Ckew = parcelRequire("6Ckew");

var $8A3UL = parcelRequire("8A3UL");

var $i79jZ = parcelRequire("i79jZ");

var $d3jhS = parcelRequire("d3jhS");

var $eJKMP = parcelRequire("eJKMP");

var $hcp38 = parcelRequire("hcp38");

var $6JEX4 = parcelRequire("6JEX4");

var $iNwSi = parcelRequire("iNwSi");

var $8wzur = parcelRequire("8wzur");


var $1YqPI = parcelRequire("1YqPI");

var $9gqMU = parcelRequire("9gqMU");
const $4dff3825d962577e$var$generators = {
    decay: (0, $8A3UL.inertia),
    inertia: $8A3UL.inertia,
    tween: (0, $i79jZ.keyframes),
    keyframes: (0, $i79jZ.keyframes),
    spring: $6Ckew.spring
};
const $4dff3825d962577e$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $4dff3825d962577e$export$fd98d9cca67a58bc extends (0, $d3jhS.BaseAnimation) {
    constructor({ KeyframeResolver: KeyframeResolver$1 = (0, $h9WaA.KeyframeResolver), ...options }){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, keyframes: keyframes } = this.options;
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        if (name && motionValue && motionValue.owner) this.resolver = motionValue.owner.resolveKeyframes(keyframes, onResolved, name, motionValue);
        else this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = $4dff3825d962577e$var$generators[type] || (0, $i79jZ.keyframes);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $i79jZ.keyframes) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $eJKMP.pipe)($4dff3825d962577e$var$percentToProgress, (0, $hcp38.mix)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $6JEX4.calcGeneratorDuration)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $8wzur.clamp)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $9gqMU.getFinalKeyframe)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $iNwSi.millisecondsToSeconds)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $iNwSi.millisecondsToSeconds)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $iNwSi.secondsToMilliseconds)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $iNwSi.millisecondsToSeconds)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $1YqPI.frameloopDriver), onPlay: onPlay } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime || this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $4dff3825d962577e$export$ee9b76de7353d815(options) {
    return new $4dff3825d962577e$export$fd98d9cca67a58bc(options);
}

});
parcelRegister("6Ckew", function(module, exports) {

$parcel$export(module.exports, "spring", () => $74970353647274e4$export$b36281d89752ae66);

var $iNwSi = parcelRequire("iNwSi");

var $1qz3j = parcelRequire("1qz3j");

var $3bi11 = parcelRequire("3bi11");
const $74970353647274e4$var$durationKeys = [
    "duration",
    "bounce"
];
const $74970353647274e4$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $74970353647274e4$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $74970353647274e4$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$74970353647274e4$var$isSpringType(options, $74970353647274e4$var$physicsKeys) && $74970353647274e4$var$isSpringType(options, $74970353647274e4$var$durationKeys)) {
        const derived = (0, $3bi11.findSpring)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $74970353647274e4$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $74970353647274e4$var$getSpringOptions({
        ...options,
        velocity: -(0, $iNwSi.millisecondsToSeconds)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $iNwSi.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $3bi11.calcAngularFreq)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $1qz3j.calcGeneratorVelocity)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}

});
parcelRegister("1qz3j", function(module, exports) {

$parcel$export(module.exports, "calcGeneratorVelocity", () => $8896dd99c5adcd8e$export$854187271d233eb5);

var $iIau7 = parcelRequire("iIau7");
const $8896dd99c5adcd8e$var$velocitySampleDuration = 5; // ms
function $8896dd99c5adcd8e$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $8896dd99c5adcd8e$var$velocitySampleDuration, 0);
    return (0, $iIau7.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

});
parcelRegister("iIau7", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", () => $acbc43562ac6dbd8$export$eab0632f7ad4f9d7);
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $acbc43562ac6dbd8$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});


parcelRegister("3bi11", function(module, exports) {

$parcel$export(module.exports, "findSpring", () => $18564078b4b5453e$export$b15f158dc6d6f458);
$parcel$export(module.exports, "calcAngularFreq", () => $18564078b4b5453e$export$5f679887c3a78b15);

var $6Wt9F = parcelRequire("6Wt9F");

var $8wzur = parcelRequire("8wzur");

var $iNwSi = parcelRequire("iNwSi");
const $18564078b4b5453e$var$safeMin = 0.001;
const $18564078b4b5453e$export$a3cdb76e84ee608e = 0.01;
const $18564078b4b5453e$export$1824b851fad8862b = 10.0;
const $18564078b4b5453e$export$ff08f2d53484465 = 0.05;
const $18564078b4b5453e$export$201ca48e54038115 = 1;
function $18564078b4b5453e$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $6Wt9F.warning)(duration <= (0, $iNwSi.secondsToMilliseconds)($18564078b4b5453e$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $8wzur.clamp)($18564078b4b5453e$export$ff08f2d53484465, $18564078b4b5453e$export$201ca48e54038115, dampingRatio);
    duration = (0, $8wzur.clamp)($18564078b4b5453e$export$a3cdb76e84ee608e, $18564078b4b5453e$export$1824b851fad8862b, (0, $iNwSi.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $18564078b4b5453e$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $18564078b4b5453e$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $18564078b4b5453e$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $18564078b4b5453e$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$18564078b4b5453e$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $18564078b4b5453e$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $iNwSi.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $18564078b4b5453e$var$rootIterations = 12;
function $18564078b4b5453e$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $18564078b4b5453e$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $18564078b4b5453e$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});


parcelRegister("8A3UL", function(module, exports) {

$parcel$export(module.exports, "inertia", () => $32590f88ff47d1eb$export$ee3ff3a17106998);

var $6Ckew = parcelRequire("6Ckew");

var $1qz3j = parcelRequire("1qz3j");
function $32590f88ff47d1eb$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $6Ckew.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $1qz3j.calcGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

});

parcelRegister("i79jZ", function(module, exports) {

$parcel$export(module.exports, "keyframes", () => $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e);

var $1YhPd = parcelRequire("1YhPd");

var $I9DwK = parcelRequire("I9DwK");

var $j7Hy9 = parcelRequire("j7Hy9");

var $luPYy = parcelRequire("luPYy");

var $dvtkA = parcelRequire("dvtkA");

var $27Vrw = parcelRequire("27Vrw");
function $c1d90d9dcdf1c489$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $1YhPd.easeInOut)).splice(0, values.length - 1);
}
function $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $I9DwK.isEasingArray)(ease) ? ease.map((0, $j7Hy9.easingDefinitionToFunction)) : (0, $j7Hy9.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $27Vrw.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $dvtkA.defaultOffset)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $luPYy.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $c1d90d9dcdf1c489$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

});
parcelRegister("1YhPd", function(module, exports) {

$parcel$export(module.exports, "easeIn", () => $c24ef35c6cea05c0$export$929e5a82286172a6);
$parcel$export(module.exports, "easeOut", () => $c24ef35c6cea05c0$export$57636bb43b1ccbb0);
$parcel$export(module.exports, "easeInOut", () => $c24ef35c6cea05c0$export$c07234257a03d5e9);

var $dDzVK = parcelRequire("dDzVK");
const $c24ef35c6cea05c0$export$929e5a82286172a6 = (0, $dDzVK.cubicBezier)(0.42, 0, 1, 1);
const $c24ef35c6cea05c0$export$57636bb43b1ccbb0 = (0, $dDzVK.cubicBezier)(0, 0, 0.58, 1);
const $c24ef35c6cea05c0$export$c07234257a03d5e9 = (0, $dDzVK.cubicBezier)(0.42, 0, 0.58, 1);

});
parcelRegister("dDzVK", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", () => $cdee14e408821ec6$export$2c575fa1d20488bd);

var $h4EQ1 = parcelRequire("h4EQ1");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $cdee14e408821ec6$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $cdee14e408821ec6$var$subdivisionPrecision = 0.0000001;
const $cdee14e408821ec6$var$subdivisionMaxIterations = 12;
function $cdee14e408821ec6$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $cdee14e408821ec6$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $cdee14e408821ec6$var$subdivisionPrecision && ++i < $cdee14e408821ec6$var$subdivisionMaxIterations);
    return currentT;
}
function $cdee14e408821ec6$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $h4EQ1.noop;
    const getTForX = (aX)=>$cdee14e408821ec6$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $cdee14e408821ec6$var$calcBezier(getTForX(t), mY1, mY2);
}

});


parcelRegister("I9DwK", function(module, exports) {

$parcel$export(module.exports, "isEasingArray", () => $b8e36ee1e1d53e83$export$216948827bbdc797);
const $b8e36ee1e1d53e83$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});

parcelRegister("j7Hy9", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", () => $15a4078bfbf4856a$export$ef97fe084f156ca4);

var $6Wt9F = parcelRequire("6Wt9F");

var $dDzVK = parcelRequire("dDzVK");

var $h4EQ1 = parcelRequire("h4EQ1");

var $1YhPd = parcelRequire("1YhPd");

var $b8jOu = parcelRequire("b8jOu");

var $hxXTy = parcelRequire("hxXTy");

var $9x5tT = parcelRequire("9x5tT");
const $15a4078bfbf4856a$var$easingLookup = {
    linear: (0, $h4EQ1.noop),
    easeIn: $1YhPd.easeIn,
    easeInOut: $1YhPd.easeInOut,
    easeOut: $1YhPd.easeOut,
    circIn: $b8jOu.circIn,
    circInOut: $b8jOu.circInOut,
    circOut: $b8jOu.circOut,
    backIn: $hxXTy.backIn,
    backInOut: $hxXTy.backInOut,
    backOut: $hxXTy.backOut,
    anticipate: $9x5tT.anticipate
};
const $15a4078bfbf4856a$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $6Wt9F.invariant)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $dDzVK.cubicBezier)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $6Wt9F.invariant)($15a4078bfbf4856a$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $15a4078bfbf4856a$var$easingLookup[definition];
    }
    return definition;
};

});
parcelRegister("b8jOu", function(module, exports) {

$parcel$export(module.exports, "circIn", () => $66a2361fd99a4040$export$e444123e42d03385);
$parcel$export(module.exports, "circOut", () => $66a2361fd99a4040$export$c8d67a19199d1a50);
$parcel$export(module.exports, "circInOut", () => $66a2361fd99a4040$export$30d3455eee55bed5);

var $16RfV = parcelRequire("16RfV");

var $6q2JQ = parcelRequire("6q2JQ");
const $66a2361fd99a4040$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $66a2361fd99a4040$export$c8d67a19199d1a50 = (0, $6q2JQ.reverseEasing)($66a2361fd99a4040$export$e444123e42d03385);
const $66a2361fd99a4040$export$30d3455eee55bed5 = (0, $16RfV.mirrorEasing)($66a2361fd99a4040$export$e444123e42d03385);

});
parcelRegister("16RfV", function(module, exports) {

$parcel$export(module.exports, "mirrorEasing", () => $6fc2fca13a5370f0$export$f946554fb8aeaf0d);
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $6fc2fca13a5370f0$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

});

parcelRegister("6q2JQ", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", () => $daf16ad73b68faf0$export$2c07eeff45156d4d);
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $daf16ad73b68faf0$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);

});


parcelRegister("hxXTy", function(module, exports) {

$parcel$export(module.exports, "backOut", () => $a7ddcde2a4282efd$export$77edfce482316a60);
$parcel$export(module.exports, "backIn", () => $a7ddcde2a4282efd$export$b01116c84cdfe1a2);
$parcel$export(module.exports, "backInOut", () => $a7ddcde2a4282efd$export$ddc5fd596f6c71b2);

var $dDzVK = parcelRequire("dDzVK");

var $16RfV = parcelRequire("16RfV");

var $6q2JQ = parcelRequire("6q2JQ");
const $a7ddcde2a4282efd$export$77edfce482316a60 = (0, $dDzVK.cubicBezier)(0.33, 1.53, 0.69, 0.99);
const $a7ddcde2a4282efd$export$b01116c84cdfe1a2 = (0, $6q2JQ.reverseEasing)($a7ddcde2a4282efd$export$77edfce482316a60);
const $a7ddcde2a4282efd$export$ddc5fd596f6c71b2 = (0, $16RfV.mirrorEasing)($a7ddcde2a4282efd$export$b01116c84cdfe1a2);

});

parcelRegister("9x5tT", function(module, exports) {

$parcel$export(module.exports, "anticipate", () => $5e5a5cfe1fa796ef$export$6b0af63b873d419e);

var $hxXTy = parcelRequire("hxXTy");
const $5e5a5cfe1fa796ef$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $hxXTy.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

});


parcelRegister("luPYy", function(module, exports) {

$parcel$export(module.exports, "interpolate", () => $ec602dd05d6627bc$export$89e29e4ab65e70a9);

var $6Wt9F = parcelRequire("6Wt9F");

var $8wzur = parcelRequire("8wzur");

var $eJKMP = parcelRequire("eJKMP");

var $ciW0c = parcelRequire("ciW0c");

var $h4EQ1 = parcelRequire("h4EQ1");

var $hcp38 = parcelRequire("hcp38");
function $ec602dd05d6627bc$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $hcp38.mix);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $h4EQ1.noop) : ease;
            mixer = (0, $eJKMP.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $ec602dd05d6627bc$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $6Wt9F.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $ec602dd05d6627bc$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $ciW0c.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $8wzur.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

});
parcelRegister("ciW0c", function(module, exports) {

$parcel$export(module.exports, "progress", () => $3a28fe0c82ae45f8$export$504d7abb21fa8c9);
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $3a28fe0c82ae45f8$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});

parcelRegister("hcp38", function(module, exports) {

$parcel$export(module.exports, "mix", () => $522550ed033be3a1$export$2c9e8a9632a706b2);

var $7vg1y = parcelRequire("7vg1y");

var $lrCGe = parcelRequire("lrCGe");
function $522550ed033be3a1$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $lrCGe.mixNumber)(from, to, p);
    const mixer = (0, $7vg1y.getMixer)(from);
    return mixer(from, to);
}

});
parcelRegister("7vg1y", function(module, exports) {

$parcel$export(module.exports, "getMixer", () => $01cf713761d5c075$export$36ec24672cd098e0);

var $lrCGe = parcelRequire("lrCGe");

var $c39Hd = parcelRequire("c39Hd");

var $eJKMP = parcelRequire("eJKMP");

var $6Wt9F = parcelRequire("6Wt9F");

var $4pDEO = parcelRequire("4pDEO");

var $518Z9 = parcelRequire("518Z9");

var $dAJIO = parcelRequire("dAJIO");

var $Z5rdf = parcelRequire("Z5rdf");

var $gekQH = parcelRequire("gekQH");
function $01cf713761d5c075$var$mixNumber(a, b) {
    return (p)=>(0, $lrCGe.mixNumber)(a, b, p);
}
function $01cf713761d5c075$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $01cf713761d5c075$var$mixNumber;
    else if (typeof a === "string") return (0, $dAJIO.isCSSVariableToken)(a) ? (0, $gekQH.mixImmediate) : (0, $4pDEO.color).test(a) ? (0, $c39Hd.mixColor) : $01cf713761d5c075$export$65516310a87d8205;
    else if (Array.isArray(a)) return $01cf713761d5c075$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $4pDEO.color).test(a) ? (0, $c39Hd.mixColor) : $01cf713761d5c075$export$ebc23b6840c51ba1;
    return 0, $gekQH.mixImmediate;
}
function $01cf713761d5c075$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$01cf713761d5c075$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $01cf713761d5c075$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $01cf713761d5c075$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $01cf713761d5c075$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $01cf713761d5c075$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $518Z9.complex).createTransformer(target);
    const originStats = (0, $518Z9.analyseComplexValue)(origin);
    const targetStats = (0, $518Z9.analyseComplexValue)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $Z5rdf.invisibleValues).has(origin) && !targetStats.values.length || (0, $Z5rdf.invisibleValues).has(target) && !originStats.values.length) return (0, $Z5rdf.mixVisibility)(origin, target);
        return (0, $eJKMP.pipe)($01cf713761d5c075$export$3bbefa2f402845c4($01cf713761d5c075$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $6Wt9F.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $gekQH.mixImmediate)(origin, target);
    }
};

});
parcelRegister("lrCGe", function(module, exports) {

$parcel$export(module.exports, "mixNumber", () => $c7567ac386f9de45$export$3bb0b4ff1037b8dd);
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $c7567ac386f9de45$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};

});

parcelRegister("c39Hd", function(module, exports) {

$parcel$export(module.exports, "mixColor", () => $318bff9c4d633c4a$export$51e568cf5c039bac);

var $lrCGe = parcelRequire("lrCGe");

var $6Wt9F = parcelRequire("6Wt9F");

var $6DvUR = parcelRequire("6DvUR");

var $cZF0k = parcelRequire("cZF0k");

var $bLvBX = parcelRequire("bLvBX");

var $7jJFT = parcelRequire("7jJFT");

var $gekQH = parcelRequire("gekQH");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $318bff9c4d633c4a$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $318bff9c4d633c4a$var$colorTypes = [
    (0, $cZF0k.hex),
    (0, $bLvBX.rgba),
    (0, $7jJFT.hsla)
];
const $318bff9c4d633c4a$var$getColorType = (v)=>$318bff9c4d633c4a$var$colorTypes.find((type)=>type.test(v));
function $318bff9c4d633c4a$var$asRGBA(color) {
    const type = $318bff9c4d633c4a$var$getColorType(color);
    (0, $6Wt9F.warning)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $7jJFT.hsla)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $6DvUR.hslaToRgba)(model);
    return model;
}
const $318bff9c4d633c4a$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $318bff9c4d633c4a$var$asRGBA(from);
    const toRGBA = $318bff9c4d633c4a$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $gekQH.mixImmediate)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $318bff9c4d633c4a$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $318bff9c4d633c4a$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $318bff9c4d633c4a$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $lrCGe.mixNumber)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $bLvBX.rgba).transform(blended);
    };
};

});
parcelRegister("6DvUR", function(module, exports) {

$parcel$export(module.exports, "hslaToRgba", () => $fd6f5ba04ea8bac3$export$6ae64dbcd6bfc33e);
// Adapted from https://gist.github.com/mjackson/5311256
function $fd6f5ba04ea8bac3$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $fd6f5ba04ea8bac3$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue + 1 / 3);
        green = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue);
        blue = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

});

parcelRegister("gekQH", function(module, exports) {

$parcel$export(module.exports, "mixImmediate", () => $d10f5c110742187b$export$a6f92d4bae65c0f1);
function $d10f5c110742187b$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}

});


parcelRegister("Z5rdf", function(module, exports) {

$parcel$export(module.exports, "invisibleValues", () => $af5aaeace9224a20$export$e5a55ae567dd4ac7);
$parcel$export(module.exports, "mixVisibility", () => $af5aaeace9224a20$export$fed62ccc3fb1a568);
const $af5aaeace9224a20$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $af5aaeace9224a20$export$fed62ccc3fb1a568(origin, target) {
    if ($af5aaeace9224a20$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}

});




parcelRegister("dvtkA", function(module, exports) {

$parcel$export(module.exports, "defaultOffset", () => $481477152292f1a1$export$24dbcec0b26e6d9d);

var $cCvqC = parcelRequire("cCvqC");
function $481477152292f1a1$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $cCvqC.fillOffset)(offset, arr.length - 1);
    return offset;
}

});
parcelRegister("cCvqC", function(module, exports) {

$parcel$export(module.exports, "fillOffset", () => $a4ecf42dec726852$export$dafee61230cf05c6);

var $lrCGe = parcelRequire("lrCGe");

var $ciW0c = parcelRequire("ciW0c");
function $a4ecf42dec726852$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $ciW0c.progress)(0, remaining, i);
        offset.push((0, $lrCGe.mixNumber)(min, 1, offsetProgress));
    }
}

});


parcelRegister("27Vrw", function(module, exports) {

$parcel$export(module.exports, "convertOffsetToTimes", () => $d61eba3ef0284b9c$export$2a91b4e3a4539316);
function $d61eba3ef0284b9c$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}

});


parcelRegister("6JEX4", function(module, exports) {

$parcel$export(module.exports, "calcGeneratorDuration", () => $506ba0ac589a486f$export$cbdd6b3d40ea54e2);
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $506ba0ac589a486f$export$f4ff70a5b4808fd8 = 20000;
function $506ba0ac589a486f$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $506ba0ac589a486f$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $506ba0ac589a486f$export$f4ff70a5b4808fd8 ? Infinity : duration;
}

});

parcelRegister("1YqPI", function(module, exports) {

$parcel$export(module.exports, "frameloopDriver", () => $c47eea579f7e92c3$export$c1033964b5ad7fef);

var $8x9V3 = parcelRequire("8x9V3");

var $hjgf3 = parcelRequire("hjgf3");
const $c47eea579f7e92c3$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $hjgf3.frame).update(passTimestamp, true),
        stop: ()=>(0, $hjgf3.cancelFrame)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $hjgf3.frameData).isProcessing ? (0, $hjgf3.frameData).timestamp : (0, $8x9V3.time).now()
    };
};

});


parcelRegister("dg6Fz", function(module, exports) {

$parcel$export(module.exports, "animateStyle", () => $db913f3e2f893030$export$c76cd972d26986f9);

var $ggB8d = parcelRequire("ggB8d");
function $db913f3e2f893030$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $ggB8d.mapEasingToNativeEasing)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}

});
parcelRegister("ggB8d", function(module, exports) {

$parcel$export(module.exports, "isWaapiSupportedEasing", () => $877fa42e69510d34$export$fcdd8f3f2160beda);
$parcel$export(module.exports, "mapEasingToNativeEasing", () => $877fa42e69510d34$export$916ea73bcd3a6030);

var $aasK2 = parcelRequire("aasK2");
function $877fa42e69510d34$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && easing in $877fa42e69510d34$export$2cf569f5e2221176 || (0, $aasK2.isBezierDefinition)(easing) || Array.isArray(easing) && easing.every($877fa42e69510d34$export$fcdd8f3f2160beda));
}
const $877fa42e69510d34$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $877fa42e69510d34$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $877fa42e69510d34$var$mapEasingToNativeEasingWithDefault(easing) {
    return $877fa42e69510d34$export$916ea73bcd3a6030(easing) || $877fa42e69510d34$export$2cf569f5e2221176.easeOut;
}
function $877fa42e69510d34$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    else if ((0, $aasK2.isBezierDefinition)(easing)) return $877fa42e69510d34$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map($877fa42e69510d34$var$mapEasingToNativeEasingWithDefault);
    else return $877fa42e69510d34$export$2cf569f5e2221176[easing];
}

});
parcelRegister("aasK2", function(module, exports) {

$parcel$export(module.exports, "isBezierDefinition", () => $8a5eba8ea233e901$export$ff43f99925d7366b);
const $8a5eba8ea233e901$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";

});




parcelRegister("i4JaE", function(module, exports) {

$parcel$export(module.exports, "GroupPlaybackControls", () => $dbc7ce14b01dea73$export$c1e41718f71efe41);

var $3Wmfr = parcelRequire("3Wmfr");

var $19iwC = parcelRequire("19iwC");
class $dbc7ce14b01dea73$export$c1e41718f71efe41 {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const cancelAll = this.animations.map((animation)=>{
            if ((0, $19iwC.supportsScrollTimeline)() && animation.attachTimeline) animation.attachTimeline(timeline);
            else {
                animation.pause();
                return (0, $3Wmfr.observeTimeline)((progress)=>{
                    animation.time = animation.duration * progress;
                }, timeline);
            }
        });
        return ()=>{
            cancelAll.forEach((cancelTimeline, i)=>{
                if (cancelTimeline) cancelTimeline();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}

});
parcelRegister("3Wmfr", function(module, exports) {

$parcel$export(module.exports, "observeTimeline", () => $e28c0d669afb858f$export$b4f1bbab0c442a76);

var $hjgf3 = parcelRequire("hjgf3");
function $e28c0d669afb858f$export$b4f1bbab0c442a76(update, timeline) {
    let prevProgress;
    const onFrame = ()=>{
        const { currentTime: currentTime } = timeline;
        const percentage = currentTime === null ? 0 : currentTime.value;
        const progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, $hjgf3.frame).update(onFrame, true);
    return ()=>(0, $hjgf3.cancelFrame)(onFrame);
}

});

parcelRegister("19iwC", function(module, exports) {

$parcel$export(module.exports, "supportsScrollTimeline", () => $600453809b90c7ce$export$20d68f04f30763a5);

var $jw16H = parcelRequire("jw16H");
const $600453809b90c7ce$export$20d68f04f30763a5 = (0, $jw16H.memo)(()=>window.ScrollTimeline !== undefined);

});



parcelRegister("87OLY", function(module, exports) {

$parcel$export(module.exports, "setTarget", () => $ea04fe669600292a$export$1f61c53461aff4a5);

var $lyAek = parcelRequire("lyAek");

var $9s8eJ = parcelRequire("9s8eJ");

var $2KqtA = parcelRequire("2KqtA");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $ea04fe669600292a$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $9s8eJ.motionValue)(value));
}
function $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $2KqtA.resolveVariant)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $lyAek.resolveFinalValueInKeyframes)(target[key]);
        $ea04fe669600292a$var$setMotionValue(visualElement, key, value);
    }
}

});
parcelRegister("9s8eJ", function(module, exports) {

$parcel$export(module.exports, "MotionValue", () => $e32104bb79321603$export$8cea36d14ee64562);
$parcel$export(module.exports, "motionValue", () => $e32104bb79321603$export$ce8bdc721e76545f);

var $es3uG = parcelRequire("es3uG");

var $iIau7 = parcelRequire("iIau7");


var $8x9V3 = parcelRequire("8x9V3");

var $hjgf3 = parcelRequire("hjgf3");
/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $e32104bb79321603$var$MAX_VELOCITY_DELTA = 30;
const $e32104bb79321603$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $e32104bb79321603$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $e32104bb79321603$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.3.19";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $8x9V3.time).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $8x9V3.time).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $e32104bb79321603$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $es3uG.SubscriptionManager)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $hjgf3.frame).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($e32104bb79321603$export$67fcd818a264039d.current) $e32104bb79321603$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $8x9V3.time).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $e32104bb79321603$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $e32104bb79321603$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $iIau7.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $e32104bb79321603$export$ce8bdc721e76545f(init, options) {
    return new $e32104bb79321603$export$8cea36d14ee64562(init, options);
}

});
parcelRegister("es3uG", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", () => $ad746ac6e5aa4783$export$e7dff9482a5fd23c);

var $8DEVZ = parcelRequire("8DEVZ");
class $ad746ac6e5aa4783$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $8DEVZ.addUniqueItem)(this.subscriptions, handler);
        return ()=>(0, $8DEVZ.removeItem)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

});



parcelRegister("7AeP3", function(module, exports) {

$parcel$export(module.exports, "getOptimisedAppearId", () => $59a52f0eed0e0e03$export$5f8d21e84d1d84fc);

var $7vTbr = parcelRequire("7vTbr");
function $59a52f0eed0e0e03$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.getProps()[0, $7vTbr.optimizedAppearDataAttribute];
}

});

parcelRegister("8VmYs", function(module, exports) {

$parcel$export(module.exports, "addValueToWillChange", () => $74e7c7f6c49b7323$export$3ac5aed310be0bee);

var $9A7I6 = parcelRequire("9A7I6");

var $3emDC = parcelRequire("3emDC");
function $74e7c7f6c49b7323$export$3ac5aed310be0bee(visualElement, key) {
    var _a;
    if (!visualElement.applyWillChange) return;
    let willChange = visualElement.getValue("willChange");
    /**
     * If we haven't created a willChange MotionValue, and the we haven't been
     * manually provided one, create one.
     */ if (!willChange && !((_a = visualElement.props.style) === null || _a === void 0 ? void 0 : _a.willChange)) {
        willChange = new (0, $9A7I6.WillChangeMotionValue)("auto");
        visualElement.addValue("willChange", willChange);
    }
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $3emDC.isWillChangeMotionValue)(willChange)) return willChange.add(key);
}

});
parcelRegister("9A7I6", function(module, exports) {

$parcel$export(module.exports, "WillChangeMotionValue", () => $6a6d9b692feab770$export$3fe5fa490af65f85);

var $9s8eJ = parcelRequire("9s8eJ");

var $8dCaR = parcelRequire("8dCaR");

var $8DEVZ = parcelRequire("8DEVZ");
class $6a6d9b692feab770$export$3fe5fa490af65f85 extends (0, $9s8eJ.MotionValue) {
    constructor(){
        super(...arguments);
        this.output = [];
        this.counts = new Map();
    }
    add(name) {
        const styleName = (0, $8dCaR.getWillChangeName)(name);
        if (!styleName) return;
        /**
         * Update counter. Each value has an indepdent counter
         * as multiple sources could be requesting the same value
         * gets added to will-change.
         */ const prevCount = this.counts.get(styleName) || 0;
        this.counts.set(styleName, prevCount + 1);
        if (prevCount === 0) {
            this.output.push(styleName);
            this.update();
        }
        /**
         * Prevents the remove function from being called multiple times.
         */ let hasRemoved = false;
        return ()=>{
            if (hasRemoved) return;
            hasRemoved = true;
            const newCount = this.counts.get(styleName) - 1;
            this.counts.set(styleName, newCount);
            if (newCount === 0) {
                (0, $8DEVZ.removeItem)(this.output, styleName);
                this.update();
            }
        };
    }
    update() {
        this.set(this.output.length ? this.output.join(", ") : "auto");
    }
}

});

parcelRegister("3emDC", function(module, exports) {

$parcel$export(module.exports, "isWillChangeMotionValue", () => $d94f283b675f700d$export$98397f3adbf6259f);

var $jqFCw = parcelRequire("jqFCw");
function $d94f283b675f700d$export$98397f3adbf6259f(value) {
    return Boolean((0, $jqFCw.isMotionValue)(value) && value.add);
}

});



parcelRegister("h0scq", function(module, exports) {

$parcel$export(module.exports, "animateVariant", () => $697c3fc694c39c2d$export$4709dc300705b2af);

var $2KqtA = parcelRequire("2KqtA");

var $foFDd = parcelRequire("foFDd");
function $697c3fc694c39c2d$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $2KqtA.resolveVariant)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $foFDd.animateTarget)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $697c3fc694c39c2d$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $697c3fc694c39c2d$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($697c3fc694c39c2d$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($697c3fc694c39c2d$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $697c3fc694c39c2d$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}

});




parcelRegister("aH0w0", function(module, exports) {

$parcel$export(module.exports, "ExitAnimationFeature", () => $7ad505f20eee7073$export$4989d1eb6104cc6c);

var $7xT8i = parcelRequire("7xT8i");
let $7ad505f20eee7073$var$id = 0;
class $7ad505f20eee7073$export$4989d1eb6104cc6c extends (0, $7xT8i.Feature) {
    constructor(){
        super(...arguments);
        this.id = $7ad505f20eee7073$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}

});


parcelRegister("80qKP", function(module, exports) {

$parcel$export(module.exports, "drag", () => $fc1974bcfc4fde1a$export$d7d5d435647ed5a0);

var $l80Yy = parcelRequire("l80Yy");

var $4LY9s = parcelRequire("4LY9s");

var $aTisU = parcelRequire("aTisU");

var $9ycLt = parcelRequire("9ycLt");
const $fc1974bcfc4fde1a$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $4LY9s.PanGesture)
    },
    drag: {
        Feature: (0, $l80Yy.DragGesture),
        ProjectionNode: (0, $9ycLt.HTMLProjectionNode),
        MeasureLayout: $aTisU.MeasureLayout
    }
};

});
parcelRegister("l80Yy", function(module, exports) {

$parcel$export(module.exports, "DragGesture", () => $abae7830ca84eed8$export$5d97dc2872682820);

var $7xT8i = parcelRequire("7xT8i");

var $h4EQ1 = parcelRequire("h4EQ1");

var $4Zpic = parcelRequire("4Zpic");
class $abae7830ca84eed8$export$5d97dc2872682820 extends (0, $7xT8i.Feature) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $h4EQ1.noop);
        this.removeListeners = (0, $h4EQ1.noop);
        this.controls = new (0, $4Zpic.VisualElementDragControls)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $h4EQ1.noop);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}

});
parcelRegister("4Zpic", function(module, exports) {

$parcel$export(module.exports, "VisualElementDragControls", () => $59924ee873defaad$export$86bff71f18910307);

var $6Wt9F = parcelRequire("6Wt9F");

var $cO49Q = parcelRequire("cO49Q");

var $bYmgt = parcelRequire("bYmgt");

var $cg30p = parcelRequire("cg30p");

var $18XBr = parcelRequire("18XBr");

var $j55Mj = parcelRequire("j55Mj");

var $8v3iT = parcelRequire("8v3iT");

var $tnnCU = parcelRequire("tnnCU");

var $dJ8Md = parcelRequire("dJ8Md");

var $2BisC = parcelRequire("2BisC");

var $iaeDY = parcelRequire("iaeDY");

var $lNCq3 = parcelRequire("lNCq3");

var $8BLfb = parcelRequire("8BLfb");

var $lrCGe = parcelRequire("lrCGe");

var $hZcVt = parcelRequire("hZcVt");

var $cTXJe = parcelRequire("cTXJe");

var $5BRFk = parcelRequire("5BRFk");

var $8VmYs = parcelRequire("8VmYs");

var $hjgf3 = parcelRequire("hjgf3");
const $59924ee873defaad$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $59924ee873defaad$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $8v3iT.createBox)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $2BisC.extractEventInfo)(event, "page").point);
        };
        const onStart = (event, info)=>{
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $bYmgt.getGlobalLock)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $tnnCU.eachAxis)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $hZcVt.percent).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $8BLfb.calcLength)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $hjgf3.frame).postRender(()=>onDragStart(event, info));
            (_a = this.removeWillChange) === null || _a === void 0 || _a.call(this);
            this.removeWillChange = (0, $8VmYs.addValueToWillChange)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $59924ee873defaad$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $tnnCU.eachAxis)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $cO49Q.PanSession)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $5BRFk.getContextWindow)(this.visualElement)
        });
    }
    stop(event, info) {
        var _a;
        (_a = this.removeWillChange) === null || _a === void 0 || _a.call(this);
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $hjgf3.frame).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $j55Mj.applyConstraints)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $cg30p.isRefObject)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $j55Mj.calcRelativeConstraints)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $j55Mj.resolveDragElastic)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $tnnCU.eachAxis)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $j55Mj.rebaseAxisConstraints)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $cg30p.isRefObject)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $6Wt9F.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $dJ8Md.measurePageBox)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $j55Mj.calcViewportConstraints)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $iaeDY.convertBoxToBoundingBox)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $iaeDY.convertBoundingBoxToBox)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $tnnCU.eachAxis)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $cTXJe.animateMotionValue)(axis, axisValue, 0, transition, this.visualElement, false, (0, $8VmYs.addValueToWillChange)(this.visualElement, axis)));
    }
    stopAnimation() {
        (0, $tnnCU.eachAxis)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $tnnCU.eachAxis)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $tnnCU.eachAxis)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $lrCGe.mixNumber)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $cg30p.isRefObject)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $tnnCU.eachAxis)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $j55Mj.calcOrigin)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $tnnCU.eachAxis)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $lrCGe.mixNumber)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $59924ee873defaad$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $18XBr.addPointerEvent)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $cg30p.isRefObject)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $hjgf3.frame).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $lNCq3.addDomEvent)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $tnnCU.eachAxis)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $j55Mj.defaultElastic), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $59924ee873defaad$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $59924ee873defaad$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

});
parcelRegister("cO49Q", function(module, exports) {

$parcel$export(module.exports, "PanSession", () => $2bb1a5b2e1002b2e$export$d9c66232c9c4689c);

var $2BisC = parcelRequire("2BisC");

var $iNwSi = parcelRequire("iNwSi");

var $18XBr = parcelRequire("18XBr");

var $eJKMP = parcelRequire("eJKMP");

var $dcGcG = parcelRequire("dcGcG");

var $gHFPX = parcelRequire("gHFPX");

var $hjgf3 = parcelRequire("hjgf3");
/**
 * @internal
 */ class $2bb1a5b2e1002b2e$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $2bb1a5b2e1002b2e$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $dcGcG.distance2D)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $hjgf3.frameData);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $hjgf3.frame).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $2bb1a5b2e1002b2e$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $gHFPX.isPrimaryPointer)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $2BisC.extractEventInfo)(event);
        const initialInfo = $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $hjgf3.frameData);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $2bb1a5b2e1002b2e$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $eJKMP.pipe)((0, $18XBr.addPointerEvent)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $18XBr.addPointerEvent)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $18XBr.addPointerEvent)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $hjgf3.cancelFrame)(this.updatePoint);
    }
}
function $2bb1a5b2e1002b2e$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $2bb1a5b2e1002b2e$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $2bb1a5b2e1002b2e$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $2bb1a5b2e1002b2e$var$subtractPoint(point, $2bb1a5b2e1002b2e$var$lastDevicePoint(history)),
        offset: $2bb1a5b2e1002b2e$var$subtractPoint(point, $2bb1a5b2e1002b2e$var$startDevicePoint(history)),
        velocity: $2bb1a5b2e1002b2e$var$getVelocity(history, 0.1)
    };
}
function $2bb1a5b2e1002b2e$var$startDevicePoint(history) {
    return history[0];
}
function $2bb1a5b2e1002b2e$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $2bb1a5b2e1002b2e$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $2bb1a5b2e1002b2e$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $iNwSi.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $iNwSi.millisecondsToSeconds)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

});
parcelRegister("dcGcG", function(module, exports) {

$parcel$export(module.exports, "distance2D", () => $8eeaeb5692ba8175$export$503a1d513f12e38b);
const $8eeaeb5692ba8175$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $8eeaeb5692ba8175$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.x, b.x);
    const yDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

});


parcelRegister("j55Mj", function(module, exports) {

$parcel$export(module.exports, "applyConstraints", () => $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3);
$parcel$export(module.exports, "calcRelativeConstraints", () => $2df0cf7aa8fef8fc$export$4e9195bf7793bc78);
$parcel$export(module.exports, "calcViewportConstraints", () => $2df0cf7aa8fef8fc$export$4228500f19d4cdf7);
$parcel$export(module.exports, "calcOrigin", () => $2df0cf7aa8fef8fc$export$13abbfca044ca46d);
$parcel$export(module.exports, "rebaseAxisConstraints", () => $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87);
$parcel$export(module.exports, "defaultElastic", () => $2df0cf7aa8fef8fc$export$a3366d3bac43a742);
$parcel$export(module.exports, "resolveDragElastic", () => $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22);

var $ciW0c = parcelRequire("ciW0c");

var $8BLfb = parcelRequire("8BLfb");

var $8wzur = parcelRequire("8wzur");

var $lrCGe = parcelRequire("lrCGe");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $lrCGe.mixNumber)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $lrCGe.mixNumber)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $2df0cf7aa8fef8fc$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $2df0cf7aa8fef8fc$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.x, left, right),
        y: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $2df0cf7aa8fef8fc$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $2df0cf7aa8fef8fc$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $8BLfb.calcLength)(source);
    const targetLength = (0, $8BLfb.calcLength)(target);
    if (targetLength > sourceLength) origin = (0, $ciW0c.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $ciW0c.progress)(source.min, source.max - targetLength, target.min);
    return (0, $8wzur.clamp)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $2df0cf7aa8fef8fc$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22(dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742;
    return {
        x: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

});
parcelRegister("8BLfb", function(module, exports) {

$parcel$export(module.exports, "calcLength", () => $b352f7cdd42c49d7$export$c1c127004b72a37);
$parcel$export(module.exports, "isNear", () => $b352f7cdd42c49d7$export$28d0384c4b79bde2);
$parcel$export(module.exports, "calcBoxDelta", () => $b352f7cdd42c49d7$export$c0d25e96fc67d310);
$parcel$export(module.exports, "calcRelativeBox", () => $b352f7cdd42c49d7$export$426154f9d100f99);
$parcel$export(module.exports, "calcRelativePosition", () => $b352f7cdd42c49d7$export$2785bfcc929c5650);

var $lrCGe = parcelRequire("lrCGe");
const $b352f7cdd42c49d7$var$SCALE_PRECISION = 0.0001;
const $b352f7cdd42c49d7$var$SCALE_MIN = 1 - $b352f7cdd42c49d7$var$SCALE_PRECISION;
const $b352f7cdd42c49d7$var$SCALE_MAX = 1 + $b352f7cdd42c49d7$var$SCALE_PRECISION;
const $b352f7cdd42c49d7$var$TRANSLATE_PRECISION = 0.01;
const $b352f7cdd42c49d7$var$TRANSLATE_MIN = 0 - $b352f7cdd42c49d7$var$TRANSLATE_PRECISION;
const $b352f7cdd42c49d7$var$TRANSLATE_MAX = 0 + $b352f7cdd42c49d7$var$TRANSLATE_PRECISION;
function $b352f7cdd42c49d7$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $b352f7cdd42c49d7$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $lrCGe.mixNumber)(source.min, source.max, delta.origin);
    delta.scale = $b352f7cdd42c49d7$export$c1c127004b72a37(target) / $b352f7cdd42c49d7$export$c1c127004b72a37(source);
    delta.translate = (0, $lrCGe.mixNumber)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $b352f7cdd42c49d7$var$SCALE_MIN && delta.scale <= $b352f7cdd42c49d7$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $b352f7cdd42c49d7$var$TRANSLATE_MIN && delta.translate <= $b352f7cdd42c49d7$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $b352f7cdd42c49d7$export$c0d25e96fc67d310(delta, source, target, origin) {
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $b352f7cdd42c49d7$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(relative);
}
function $b352f7cdd42c49d7$export$426154f9d100f99(target, relative, parent) {
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(layout);
}
function $b352f7cdd42c49d7$export$2785bfcc929c5650(target, layout, parent) {
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}

});


parcelRegister("8v3iT", function(module, exports) {

$parcel$export(module.exports, "createDelta", () => $a3727e4e12b23353$export$3d227df54007d73a);
$parcel$export(module.exports, "createBox", () => $a3727e4e12b23353$export$6459fc9e86be362e);
const $a3727e4e12b23353$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $a3727e4e12b23353$export$3d227df54007d73a = ()=>({
        x: $a3727e4e12b23353$export$ff25708b37f72782(),
        y: $a3727e4e12b23353$export$ff25708b37f72782()
    });
const $a3727e4e12b23353$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $a3727e4e12b23353$export$6459fc9e86be362e = ()=>({
        x: $a3727e4e12b23353$export$6db76765312617ac(),
        y: $a3727e4e12b23353$export$6db76765312617ac()
    });

});

parcelRegister("tnnCU", function(module, exports) {

$parcel$export(module.exports, "eachAxis", () => $247f90d2510fbc55$export$b789de563eb43b1);
function $247f90d2510fbc55$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

});

parcelRegister("dJ8Md", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", () => $4ca2f8055771ddf4$export$d8718b6a7e5c624e);
$parcel$export(module.exports, "measurePageBox", () => $4ca2f8055771ddf4$export$6a597be7a7940a96);

var $iaeDY = parcelRequire("iaeDY");

var $fxwRw = parcelRequire("fxwRw");
function $4ca2f8055771ddf4$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $iaeDY.convertBoundingBoxToBox)((0, $iaeDY.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $4ca2f8055771ddf4$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $4ca2f8055771ddf4$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $fxwRw.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, $fxwRw.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

});
parcelRegister("iaeDY", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", () => $0e0401fe38bd0bd1$export$d3955c6a8f65a36b);
$parcel$export(module.exports, "convertBoxToBoundingBox", () => $0e0401fe38bd0bd1$export$b6b9cd4198191a47);
$parcel$export(module.exports, "transformBoxPoints", () => $0e0401fe38bd0bd1$export$21543fb75483a50);
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $0e0401fe38bd0bd1$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $0e0401fe38bd0bd1$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $0e0401fe38bd0bd1$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});

parcelRegister("fxwRw", function(module, exports) {

$parcel$export(module.exports, "scalePoint", () => $d8332eb74969584e$export$2290ec7febe36dd6);
$parcel$export(module.exports, "applyBoxDelta", () => $d8332eb74969584e$export$d80074982803af5c);
$parcel$export(module.exports, "applyTreeDeltas", () => $d8332eb74969584e$export$e2a980535c55eabb);
$parcel$export(module.exports, "transformBox", () => $d8332eb74969584e$export$58b16271041fbfb);
$parcel$export(module.exports, "translateAxis", () => $d8332eb74969584e$export$a807a5ce5ebb3895);

var $lrCGe = parcelRequire("lrCGe");

var $3xchP = parcelRequire("3xchP");
/**
 * Scales a point based on a factor and an originPoint
 */ function $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $d8332eb74969584e$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $d8332eb74969584e$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $d8332eb74969584e$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $d8332eb74969584e$export$d80074982803af5c(box, { x: x, y: y }) {
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $d8332eb74969584e$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $d8332eb74969584e$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $d8332eb74969584e$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $d8332eb74969584e$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $d8332eb74969584e$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $3xchP.hasTransform)(node.latestValues)) $d8332eb74969584e$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $d8332eb74969584e$var$TREE_SCALE_SNAP_MAX && treeScale.x > $d8332eb74969584e$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $d8332eb74969584e$var$TREE_SCALE_SNAP_MAX && treeScale.y > $d8332eb74969584e$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $d8332eb74969584e$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $d8332eb74969584e$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $lrCGe.mixNumber)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $d8332eb74969584e$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $d8332eb74969584e$export$58b16271041fbfb(box, transform) {
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}

});
parcelRegister("3xchP", function(module, exports) {

$parcel$export(module.exports, "hasScale", () => $fe0ee806cd19fc1f$export$bdf30dca883ea463);
$parcel$export(module.exports, "hasTransform", () => $fe0ee806cd19fc1f$export$a545127cf1fbb600);
$parcel$export(module.exports, "has2DTranslate", () => $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f);
function $fe0ee806cd19fc1f$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fe0ee806cd19fc1f$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$fe0ee806cd19fc1f$var$isIdentityScale(scale) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleX) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleY);
}
function $fe0ee806cd19fc1f$export$a545127cf1fbb600(values) {
    return $fe0ee806cd19fc1f$export$bdf30dca883ea463(values) || $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) {
    return $fe0ee806cd19fc1f$var$is2DTranslate(values.x) || $fe0ee806cd19fc1f$var$is2DTranslate(values.y);
}
function $fe0ee806cd19fc1f$var$is2DTranslate(value) {
    return value && value !== "0%";
}

});



parcelRegister("5BRFk", function(module, exports) {

$parcel$export(module.exports, "getContextWindow", () => $763b481d779908b7$export$d533d84f9871c879);
// Fixes https://github.com/framer/motion/issues/2270
const $763b481d779908b7$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};

});



parcelRegister("4LY9s", function(module, exports) {

$parcel$export(module.exports, "PanGesture", () => $d43ff984f7bd7f1a$export$b4f8f1ee75ce5859);

var $cO49Q = parcelRequire("cO49Q");

var $18XBr = parcelRequire("18XBr");

var $7xT8i = parcelRequire("7xT8i");

var $h4EQ1 = parcelRequire("h4EQ1");

var $5BRFk = parcelRequire("5BRFk");

var $hjgf3 = parcelRequire("hjgf3");
const $d43ff984f7bd7f1a$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $hjgf3.frame).postRender(()=>handler(event, info));
    };
class $d43ff984f7bd7f1a$export$b4f8f1ee75ce5859 extends (0, $7xT8i.Feature) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $h4EQ1.noop);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $cO49Q.PanSession)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $5BRFk.getContextWindow)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $d43ff984f7bd7f1a$var$asyncHandler(onPanSessionStart),
            onStart: $d43ff984f7bd7f1a$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $hjgf3.frame).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $18XBr.addPointerEvent)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}

});

parcelRegister("aTisU", function(module, exports) {

$parcel$export(module.exports, "MeasureLayout", () => $cdf2a2ac04e7ce67$export$779f5fb01ad751cd);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $iL8MI = parcelRequire("iL8MI");

var $cNR5T = parcelRequire("cNR5T");

var $9lcvq = parcelRequire("9lcvq");

var $9CWXG = parcelRequire("9CWXG");

var $5g4ML = parcelRequire("5g4ML");

var $kUOYE = parcelRequire("kUOYE");

var $i0qI9 = parcelRequire("i0qI9");

var $6AsEf = parcelRequire("6AsEf");

var $hjgf3 = parcelRequire("hjgf3");
class $cdf2a2ac04e7ce67$var$MeasureLayoutWithContext extends (0, $acw62.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $i0qI9.addScaleCorrector)($cdf2a2ac04e7ce67$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $9CWXG.globalProjectionState).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $hjgf3.frame).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $6AsEf.microtask).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $cdf2a2ac04e7ce67$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $iL8MI.usePresence)();
    const layoutGroup = (0, $acw62.useContext)((0, $cNR5T.LayoutGroupContext));
    return (0, $ayMG0.jsx)($cdf2a2ac04e7ce67$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $acw62.useContext)((0, $9lcvq.SwitchLayoutGroupContext)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $cdf2a2ac04e7ce67$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $5g4ML.correctBorderRadius),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $5g4ML.correctBorderRadius),
    borderTopRightRadius: (0, $5g4ML.correctBorderRadius),
    borderBottomLeftRadius: (0, $5g4ML.correctBorderRadius),
    borderBottomRightRadius: (0, $5g4ML.correctBorderRadius),
    boxShadow: (0, $kUOYE.correctBoxShadow)
};

});
parcelRegister("iL8MI", function(module, exports) {

$parcel$export(module.exports, "usePresence", () => $bc77fac60b5d77cc$export$2a8c16d82a0a0e26);

var $acw62 = parcelRequire("acw62");

var $gtJis = parcelRequire("gtJis");
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $bc77fac60b5d77cc$export$2a8c16d82a0a0e26() {
    const context = (0, $acw62.useContext)((0, $gtJis.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $acw62.useId)();
    (0, $acw62.useEffect)(()=>register(id), []);
    const safeToRemove = (0, $acw62.useCallback)(()=>onExitComplete && onExitComplete(id), [
        id,
        onExitComplete
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $bc77fac60b5d77cc$export$8249053f690ea39a() {
    return $bc77fac60b5d77cc$export$ee27c052bca048fb((0, $acw62.useContext)((0, $gtJis.PresenceContext)));
}
function $bc77fac60b5d77cc$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}

});

parcelRegister("9CWXG", function(module, exports) {

$parcel$export(module.exports, "globalProjectionState", () => $b29dc04080b74d0c$export$97db156a3ed1593b);
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $b29dc04080b74d0c$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};

});

parcelRegister("5g4ML", function(module, exports) {

$parcel$export(module.exports, "correctBorderRadius", () => $967b202c839557ef$export$5eafb6257a5844c);

var $hZcVt = parcelRequire("hZcVt");
function $967b202c839557ef$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $967b202c839557ef$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $hZcVt.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $967b202c839557ef$export$fafff692be55225d(latest, node.target.x);
        const y = $967b202c839557ef$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};

});

parcelRegister("kUOYE", function(module, exports) {

$parcel$export(module.exports, "correctBoxShadow", () => $a42cd9e0ef50cb70$export$eb0bc629e74dcf8);

var $lrCGe = parcelRequire("lrCGe");

var $518Z9 = parcelRequire("518Z9");
const $a42cd9e0ef50cb70$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $518Z9.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $518Z9.complex).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $lrCGe.mixNumber)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};

});


parcelRegister("9ycLt", function(module, exports) {

$parcel$export(module.exports, "HTMLProjectionNode", () => $a3289660bde9b219$export$b61a9eb3dbde8858);

var $15nIA = parcelRequire("15nIA");

var $h0X6O = parcelRequire("h0X6O");
const $a3289660bde9b219$export$b91509fcf893b648 = {
    current: undefined
};
const $a3289660bde9b219$export$b61a9eb3dbde8858 = (0, $15nIA.createProjectionNode)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$a3289660bde9b219$export$b91509fcf893b648.current) {
            const documentNode = new (0, $h0X6O.DocumentProjectionNode)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $a3289660bde9b219$export$b91509fcf893b648.current = documentNode;
        }
        return $a3289660bde9b219$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});

});
parcelRegister("15nIA", function(module, exports) {

$parcel$export(module.exports, "createProjectionNode", () => $d2ca41ba1b84bcfe$export$a84b61f69daa9da0);

var $es3uG = parcelRequire("es3uG");

var $kKryO = parcelRequire("kKryO");

var $96kmk = parcelRequire("96kmk");

var $fxwRw = parcelRequire("fxwRw");

var $8BLfb = parcelRequire("8BLfb");

var $lldi8 = parcelRequire("lldi8");

var $bUTXm = parcelRequire("bUTXm");

var $hPJ9o = parcelRequire("hPJ9o");

var $24cVq = parcelRequire("24cVq");

var $i0qI9 = parcelRequire("i0qI9");

var $cjbno = parcelRequire("cjbno");

var $tnnCU = parcelRequire("tnnCU");

var $3xchP = parcelRequire("3xchP");

var $73AdZ = parcelRequire("73AdZ");

var $cz2ac = parcelRequire("cz2ac");

var $9CWXG = parcelRequire("9CWXG");

var $bMx57 = parcelRequire("bMx57");

var $lrCGe = parcelRequire("lrCGe");

var $5ihuF = parcelRequire("5ihuF");

var $hJ5aM = parcelRequire("hJ5aM");

var $8wzur = parcelRequire("8wzur");

var $hjgf3 = parcelRequire("hjgf3");

var $h4EQ1 = parcelRequire("h4EQ1");

var $8x9V3 = parcelRequire("8x9V3");

var $6AsEf = parcelRequire("6AsEf");

var $7AeP3 = parcelRequire("7AeP3");

var $8v3iT = parcelRequire("8v3iT");
const $d2ca41ba1b84bcfe$var$metrics = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
const $d2ca41ba1b84bcfe$var$isDebug = typeof window !== "undefined" && window.MotionDebug !== undefined;
const $d2ca41ba1b84bcfe$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $d2ca41ba1b84bcfe$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $d2ca41ba1b84bcfe$var$animationTarget = 1000;
let $d2ca41ba1b84bcfe$var$id = 0;
function $d2ca41ba1b84bcfe$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $d2ca41ba1b84bcfe$var$isOptimisedAppearTree(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return false;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return false;
    else if ((0, $7AeP3.getOptimisedAppearId)(visualElement)) return true;
    else if (projectionNode.parent && !projectionNode.parent.hasCheckedOptimisedAppear) return $d2ca41ba1b84bcfe$var$isOptimisedAppearTree(projectionNode.parent);
    else return false;
}
function $d2ca41ba1b84bcfe$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $d2ca41ba1b84bcfe$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ($d2ca41ba1b84bcfe$var$isDebug) $d2ca41ba1b84bcfe$var$metrics.totalNodes = $d2ca41ba1b84bcfe$var$metrics.resolvedTargetDeltas = $d2ca41ba1b84bcfe$var$metrics.recalculatedProjection = 0;
                this.nodes.forEach($d2ca41ba1b84bcfe$export$131f2f0cc5fe9609);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$resolveTargetDelta);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$calcProjection);
                this.nodes.forEach($d2ca41ba1b84bcfe$export$c2664f37bc951031);
                if ($d2ca41ba1b84bcfe$var$isDebug) window.MotionDebug.record($d2ca41ba1b84bcfe$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $73AdZ.FlatTree)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $es3uG.SubscriptionManager)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $5ihuF.isSVGElement)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $bMx57.delay)(resizeUnblockUpdate, 250);
                    if ((0, $9CWXG.globalProjectionState).hasAnimatedSinceResize) {
                        (0, $9CWXG.globalProjectionState).hasAnimatedSinceResize = false;
                        this.nodes.forEach($d2ca41ba1b84bcfe$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $d2ca41ba1b84bcfe$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $hPJ9o.boxEqualsRounded)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $bUTXm.getValueTransition)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $d2ca41ba1b84bcfe$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $hjgf3.cancelFrame)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($d2ca41ba1b84bcfe$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.HandoffCancelAllAnimations && $d2ca41ba1b84bcfe$var$isOptimisedAppearTree(this)) window.HandoffCancelAllAnimations();
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($d2ca41ba1b84bcfe$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($d2ca41ba1b84bcfe$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($d2ca41ba1b84bcfe$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($d2ca41ba1b84bcfe$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $8x9V3.time).now();
            (0, $hjgf3.frameData).delta = (0, $8wzur.clamp)(0, 1000 / 60, now - (0, $hjgf3.frameData).timestamp);
            (0, $hjgf3.frameData).timestamp = now;
            (0, $hjgf3.frameData).isProcessing = true;
            (0, $hjgf3.steps).update.process((0, $hjgf3.frameData));
            (0, $hjgf3.steps).preRender.process((0, $hjgf3.frameData));
            (0, $hjgf3.steps).render.process((0, $hjgf3.frameData));
            (0, $hjgf3.frameData).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $6AsEf.microtask).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($d2ca41ba1b84bcfe$var$clearSnapshot);
            this.sharedNodes.forEach($d2ca41ba1b84bcfe$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $hjgf3.frame).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $hjgf3.frame).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $8v3iT.createBox)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $hPJ9o.isDeltaZero)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $3xchP.hasTransform)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $d2ca41ba1b84bcfe$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $8v3iT.createBox)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some($d2ca41ba1b84bcfe$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $fxwRw.translateAxis)(box.x, scroll.offset.x);
                    (0, $fxwRw.translateAxis)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = (0, $8v3iT.createBox)();
            (0, $96kmk.copyBoxInto)(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $96kmk.copyBoxInto)(boxWithoutScroll, box);
                    (0, $fxwRw.translateAxis)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $fxwRw.translateAxis)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $8v3iT.createBox)();
            (0, $96kmk.copyBoxInto)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $fxwRw.transformBox)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $3xchP.hasTransform)(node.latestValues)) continue;
                (0, $fxwRw.transformBox)(withTransforms, node.latestValues);
            }
            if ((0, $3xchP.hasTransform)(this.latestValues)) (0, $fxwRw.transformBox)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $8v3iT.createBox)();
            (0, $96kmk.copyBoxInto)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $3xchP.hasTransform)(node.latestValues)) continue;
                (0, $3xchP.hasScale)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $8v3iT.createBox)();
                const nodeBox = node.measurePageBox();
                (0, $96kmk.copyBoxInto)(sourceBox, nodeBox);
                (0, $lldi8.removeBoxTransforms)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $3xchP.hasTransform)(this.latestValues)) (0, $lldi8.removeBoxTransforms)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $hjgf3.frameData).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $hjgf3.frameData).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $8v3iT.createBox)();
                    this.relativeTargetOrigin = (0, $8v3iT.createBox)();
                    (0, $8BLfb.calcRelativePosition)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $96kmk.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $8v3iT.createBox)();
                this.targetWithTransforms = (0, $8v3iT.createBox)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $8BLfb.calcRelativeBox)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $96kmk.copyBoxInto)(this.target, this.layout.layoutBox);
                (0, $fxwRw.applyBoxDelta)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $96kmk.copyBoxInto)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $8v3iT.createBox)();
                    this.relativeTargetOrigin = (0, $8v3iT.createBox)();
                    (0, $8BLfb.calcRelativePosition)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $96kmk.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ($d2ca41ba1b84bcfe$var$isDebug) $d2ca41ba1b84bcfe$var$metrics.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $3xchP.hasScale)(this.parent.latestValues) || (0, $3xchP.has2DTranslate)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $hjgf3.frameData).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $96kmk.copyBoxInto)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $fxwRw.applyTreeDeltas)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $8v3iT.createBox)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $96kmk.copyAxisDeltaInto)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $96kmk.copyAxisDeltaInto)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $8BLfb.calcBoxDelta)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $hPJ9o.axisDeltaEquals)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $hPJ9o.axisDeltaEquals)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ($d2ca41ba1b84bcfe$var$isDebug) $d2ca41ba1b84bcfe$var$metrics.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 || _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $8v3iT.createDelta)();
            this.projectionDelta = (0, $8v3iT.createDelta)();
            this.projectionDeltaWithTransform = (0, $8v3iT.createDelta)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $8v3iT.createDelta)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $8v3iT.createBox)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($d2ca41ba1b84bcfe$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $8BLfb.calcRelativePosition)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $hPJ9o.boxEquals)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $8v3iT.createBox)();
                    (0, $96kmk.copyBoxInto)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $kKryO.mixValues)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $hjgf3.cancelFrame)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $hjgf3.frame).update(()=>{
                (0, $9CWXG.globalProjectionState).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $hJ5aM.animateSingleValue)(0, $d2ca41ba1b84bcfe$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($d2ca41ba1b84bcfe$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $8v3iT.createBox)();
                const xLength = (0, $8BLfb.calcLength)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $8BLfb.calcLength)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $96kmk.copyBoxInto)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $fxwRw.transformBox)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $8BLfb.calcBoxDelta)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $24cVq.NodeStack)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $d2ca41ba1b84bcfe$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $d2ca41ba1b84bcfe$var$transformAxes.length; i++){
                $d2ca41ba1b84bcfe$var$resetDistortingTransform(`rotate${$d2ca41ba1b84bcfe$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $d2ca41ba1b84bcfe$var$resetDistortingTransform(`skew${$d2ca41ba1b84bcfe$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $d2ca41ba1b84bcfe$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $cz2ac.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $cz2ac.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $3xchP.hasTransform)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $cjbno.buildProjectionTransform)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $i0qI9.scaleCorrectors){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $i0qI9.scaleCorrectors)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $cz2ac.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $d2ca41ba1b84bcfe$var$updateLayout(node) {
    node.updateLayout();
}
function $d2ca41ba1b84bcfe$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $tnnCU.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $8BLfb.calcLength)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $tnnCU.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $8BLfb.calcLength)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $8v3iT.createDelta)();
        (0, $8BLfb.calcBoxDelta)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $8v3iT.createDelta)();
        if (isShared) (0, $8BLfb.calcBoxDelta)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $8BLfb.calcBoxDelta)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $hPJ9o.isDeltaZero)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $8v3iT.createBox)();
                    (0, $8BLfb.calcRelativePosition)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $8v3iT.createBox)();
                    (0, $8BLfb.calcRelativePosition)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $hPJ9o.boxEqualsRounded)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $d2ca41ba1b84bcfe$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ($d2ca41ba1b84bcfe$var$isDebug) $d2ca41ba1b84bcfe$var$metrics.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $d2ca41ba1b84bcfe$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $d2ca41ba1b84bcfe$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $d2ca41ba1b84bcfe$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $d2ca41ba1b84bcfe$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $d2ca41ba1b84bcfe$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $d2ca41ba1b84bcfe$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $d2ca41ba1b84bcfe$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $d2ca41ba1b84bcfe$var$calcProjection(node) {
    node.calcProjection();
}
function $d2ca41ba1b84bcfe$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $d2ca41ba1b84bcfe$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $lrCGe.mixNumber)(delta.translate, 0, p);
    output.scale = (0, $lrCGe.mixNumber)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $lrCGe.mixNumber)(from.min, to.min, p);
    output.max = (0, $lrCGe.mixNumber)(from.max, to.max, p);
}
function $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(output, from, to, p) {
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $d2ca41ba1b84bcfe$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $d2ca41ba1b84bcfe$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $d2ca41ba1b84bcfe$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $d2ca41ba1b84bcfe$var$roundPoint = $d2ca41ba1b84bcfe$var$userAgentContains("applewebkit/") && !$d2ca41ba1b84bcfe$var$userAgentContains("chrome/") ? Math.round : (0, $h4EQ1.noop);
function $d2ca41ba1b84bcfe$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $d2ca41ba1b84bcfe$var$roundPoint(axis.min);
    axis.max = $d2ca41ba1b84bcfe$var$roundPoint(axis.max);
}
function $d2ca41ba1b84bcfe$var$roundBox(box) {
    $d2ca41ba1b84bcfe$var$roundAxis(box.x);
    $d2ca41ba1b84bcfe$var$roundAxis(box.y);
}
function $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $8BLfb.isNear)((0, $hPJ9o.aspectRatio)(snapshot), (0, $hPJ9o.aspectRatio)(layout), 0.2);
}
function $d2ca41ba1b84bcfe$var$checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}

});
parcelRegister("kKryO", function(module, exports) {

$parcel$export(module.exports, "mixValues", () => $82b1c16a20b13fa0$export$739e279c17d51c3d);

var $b8jOu = parcelRequire("b8jOu");

var $ciW0c = parcelRequire("ciW0c");

var $lrCGe = parcelRequire("lrCGe");

var $h4EQ1 = parcelRequire("h4EQ1");

var $hZcVt = parcelRequire("hZcVt");
const $82b1c16a20b13fa0$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $82b1c16a20b13fa0$var$numBorders = $82b1c16a20b13fa0$var$borders.length;
const $82b1c16a20b13fa0$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $82b1c16a20b13fa0$var$isPx = (value)=>typeof value === "number" || (0, $hZcVt.px).test(value);
function $82b1c16a20b13fa0$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $lrCGe.mixNumber)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $82b1c16a20b13fa0$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $lrCGe.mixNumber)(follow.opacity !== undefined ? follow.opacity : 1, 0, $82b1c16a20b13fa0$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $lrCGe.mixNumber)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $82b1c16a20b13fa0$var$numBorders; i++){
        const borderLabel = `border${$82b1c16a20b13fa0$var$borders[i]}Radius`;
        let followRadius = $82b1c16a20b13fa0$var$getRadius(follow, borderLabel);
        let leadRadius = $82b1c16a20b13fa0$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $82b1c16a20b13fa0$var$isPx(followRadius) === $82b1c16a20b13fa0$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $lrCGe.mixNumber)($82b1c16a20b13fa0$var$asNumber(followRadius), $82b1c16a20b13fa0$var$asNumber(leadRadius), progress), 0);
            if ((0, $hZcVt.percent).test(leadRadius) || (0, $hZcVt.percent).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $lrCGe.mixNumber)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $82b1c16a20b13fa0$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $82b1c16a20b13fa0$var$easeCrossfadeIn = $82b1c16a20b13fa0$var$compress(0, 0.5, (0, $b8jOu.circOut));
const $82b1c16a20b13fa0$var$easeCrossfadeOut = $82b1c16a20b13fa0$var$compress(0.5, 0.95, (0, $h4EQ1.noop));
function $82b1c16a20b13fa0$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $ciW0c.progress)(min, max, p));
    };
}

});

parcelRegister("96kmk", function(module, exports) {

$parcel$export(module.exports, "copyBoxInto", () => $5960d81994414d5a$export$c53fd88f45d77e4b);
$parcel$export(module.exports, "copyAxisDeltaInto", () => $5960d81994414d5a$export$8ead6a7d6b225ef);
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$c53fd88f45d77e4b(box, originBox) {
    $5960d81994414d5a$export$a0230ae482601ae8(box.x, originBox.x);
    $5960d81994414d5a$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}

});

parcelRegister("lldi8", function(module, exports) {

$parcel$export(module.exports, "removeBoxTransforms", () => $db628fcc785b8b87$export$73e1ad0a9694e25c);

var $lrCGe = parcelRequire("lrCGe");

var $hZcVt = parcelRequire("hZcVt");

var $fxwRw = parcelRequire("fxwRw");
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $db628fcc785b8b87$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $fxwRw.scalePoint)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $fxwRw.scalePoint)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $hZcVt.percent).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $lrCGe.mixNumber)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $lrCGe.mixNumber)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $db628fcc785b8b87$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $db628fcc785b8b87$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $db628fcc785b8b87$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $db628fcc785b8b87$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.x, transforms, $db628fcc785b8b87$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.y, transforms, $db628fcc785b8b87$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

});

parcelRegister("hPJ9o", function(module, exports) {

$parcel$export(module.exports, "isDeltaZero", () => $b070f9c5f268d45c$export$a7ec7642fe550fb6);
$parcel$export(module.exports, "boxEquals", () => $b070f9c5f268d45c$export$8d5cf76bb7daff09);
$parcel$export(module.exports, "boxEqualsRounded", () => $b070f9c5f268d45c$export$ef641b782d85522);
$parcel$export(module.exports, "aspectRatio", () => $b070f9c5f268d45c$export$c5706146bc63213);
$parcel$export(module.exports, "axisDeltaEquals", () => $b070f9c5f268d45c$export$444620505e28fe92);

var $8BLfb = parcelRequire("8BLfb");
function $b070f9c5f268d45c$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $b070f9c5f268d45c$export$a7ec7642fe550fb6(delta) {
    return $b070f9c5f268d45c$var$isAxisDeltaZero(delta.x) && $b070f9c5f268d45c$var$isAxisDeltaZero(delta.y);
}
function $b070f9c5f268d45c$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $b070f9c5f268d45c$export$8d5cf76bb7daff09(a, b) {
    return $b070f9c5f268d45c$export$7a9a6f114ddd0fdb(a.x, b.x) && $b070f9c5f268d45c$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $b070f9c5f268d45c$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $b070f9c5f268d45c$export$ef641b782d85522(a, b) {
    return $b070f9c5f268d45c$export$22adf28bfca1c186(a.x, b.x) && $b070f9c5f268d45c$export$22adf28bfca1c186(a.y, b.y);
}
function $b070f9c5f268d45c$export$c5706146bc63213(box) {
    return (0, $8BLfb.calcLength)(box.x) / (0, $8BLfb.calcLength)(box.y);
}
function $b070f9c5f268d45c$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}

});

parcelRegister("24cVq", function(module, exports) {

$parcel$export(module.exports, "NodeStack", () => $a040ab986103db06$export$39be5b2d82fc9dc7);

var $8DEVZ = parcelRequire("8DEVZ");
class $a040ab986103db06$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $8DEVZ.addUniqueItem)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $8DEVZ.removeItem)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}

});

parcelRegister("cjbno", function(module, exports) {

$parcel$export(module.exports, "buildProjectionTransform", () => $0214cdf9d4bb801d$export$d33653b270fe725c);
function $0214cdf9d4bb801d$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}

});

parcelRegister("73AdZ", function(module, exports) {

$parcel$export(module.exports, "FlatTree", () => $e21f5e6c9473a18c$export$1465d17e3de78a96);

var $8DEVZ = parcelRequire("8DEVZ");

var $f5OKq = parcelRequire("f5OKq");
class $e21f5e6c9473a18c$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $8DEVZ.addUniqueItem)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $8DEVZ.removeItem)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $f5OKq.compareByDepth));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}

});
parcelRegister("f5OKq", function(module, exports) {

$parcel$export(module.exports, "compareByDepth", () => $8e214807702da081$export$d689d9dec5ad338);
const $8e214807702da081$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;

});


parcelRegister("bMx57", function(module, exports) {

$parcel$export(module.exports, "delay", () => $fab50a206e6cc096$export$1391212d75b2ee65);

var $8x9V3 = parcelRequire("8x9V3");

var $hjgf3 = parcelRequire("hjgf3");
/**
 * Timeout defined in ms
 */ function $fab50a206e6cc096$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $8x9V3.time).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $hjgf3.cancelFrame)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $hjgf3.frame).read(checkElapsed, true);
    return ()=>(0, $hjgf3.cancelFrame)(checkElapsed);
}

});

parcelRegister("5ihuF", function(module, exports) {

$parcel$export(module.exports, "isSVGElement", () => $c4715fe9f944e8b8$export$17eda790a720ec57);
function $c4715fe9f944e8b8$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}

});

parcelRegister("hJ5aM", function(module, exports) {

$parcel$export(module.exports, "animateSingleValue", () => $f5de8fc8cd768a38$export$335a17c977067b99);

var $cTXJe = parcelRequire("cTXJe");

var $9s8eJ = parcelRequire("9s8eJ");

var $jqFCw = parcelRequire("jqFCw");
function $f5de8fc8cd768a38$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $jqFCw.isMotionValue)(value) ? value : (0, $9s8eJ.motionValue)(value);
    motionValue$1.start((0, $cTXJe.animateMotionValue)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

});


parcelRegister("h0X6O", function(module, exports) {

$parcel$export(module.exports, "DocumentProjectionNode", () => $6e97f3a9a89d5fc1$export$2d029a49a09b6177);

var $15nIA = parcelRequire("15nIA");

var $lNCq3 = parcelRequire("lNCq3");
const $6e97f3a9a89d5fc1$export$2d029a49a09b6177 = (0, $15nIA.createProjectionNode)({
    attachResizeListener: (ref, notify)=>(0, $lNCq3.addDomEvent)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});

});



parcelRegister("6LgnS", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", () => $2f8881102ac6dde9$export$56ba0183203348f5);

var $acw62 = parcelRequire("acw62");

var $6BFDr = parcelRequire("6BFDr");

var $4Cs3T = parcelRequire("4Cs3T");

var $9GusU = parcelRequire("9GusU");
const $2f8881102ac6dde9$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $9GusU.isSVGComponent)(Component) ? new (0, $4Cs3T.SVGVisualElement)(options) : new (0, $6BFDr.HTMLVisualElement)(options, {
        allowProjection: Component !== (0, $acw62.Fragment)
    });
};

});
parcelRegister("6BFDr", function(module, exports) {

$parcel$export(module.exports, "HTMLVisualElement", () => $bce82b8bf0dbf6b7$export$23fea75b03ac16b3);

var $9U95V = parcelRequire("9U95V");

var $dAJIO = parcelRequire("dAJIO");

var $5f0mC = parcelRequire("5f0mC");

var $eZ617 = parcelRequire("eZ617");

var $fMnH3 = parcelRequire("fMnH3");

var $h8BN3 = parcelRequire("h8BN3");

var $dJ8Md = parcelRequire("dJ8Md");

var $lPHQ9 = parcelRequire("lPHQ9");

var $jqFCw = parcelRequire("jqFCw");
function $bce82b8bf0dbf6b7$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $bce82b8bf0dbf6b7$export$23fea75b03ac16b3 extends (0, $lPHQ9.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.applyWillChange = true;
        this.renderInstance = (0, $fMnH3.renderHTML);
    }
    readValueFromInstance(instance, key) {
        if ((0, $5f0mC.transformProps).has(key)) {
            const defaultType = (0, $h8BN3.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $bce82b8bf0dbf6b7$export$3735103072e4a80(instance);
            const value = ((0, $dAJIO.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $dJ8Md.measureViewportBox)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $9U95V.buildHTMLStyles)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $eZ617.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $jqFCw.isMotionValue)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}

});
parcelRegister("lPHQ9", function(module, exports) {

$parcel$export(module.exports, "DOMVisualElement", () => $28a1ebc4c0bc036f$export$e49735c2a366bdc7);

var $1EkDY = parcelRequire("1EkDY");

var $53Cqv = parcelRequire("53Cqv");
class $28a1ebc4c0bc036f$export$e49735c2a366bdc7 extends (0, $1EkDY.VisualElement) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $53Cqv.DOMKeyframesResolver);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
}

});
parcelRegister("1EkDY", function(module, exports) {

$parcel$export(module.exports, "VisualElement", () => $e66750f3fb0f96bb$export$fa8b653c0f3714e5);

var $jktlv = parcelRequire("jktlv");

var $jsjPs = parcelRequire("jsjPs");

var $es3uG = parcelRequire("es3uG");

var $9s8eJ = parcelRequire("9s8eJ");

var $jqFCw = parcelRequire("jqFCw");

var $5f0mC = parcelRequire("5f0mC");

var $jeuUs = parcelRequire("jeuUs");

var $dLd38 = parcelRequire("dLd38");

var $jyqX9 = parcelRequire("jyqX9");

var $iIE6Y = parcelRequire("iIE6Y");


var $7bH6a = parcelRequire("7bH6a");

var $fNC3C = parcelRequire("fNC3C");

var $02Gao = parcelRequire("02Gao");

var $h9WaA = parcelRequire("h9WaA");

var $bjEgh = parcelRequire("bjEgh");

var $e2LUE = parcelRequire("e2LUE");

var $82f3D = parcelRequire("82f3D");

var $518Z9 = parcelRequire("518Z9");

var $adXv8 = parcelRequire("adXv8");

var $8v3iT = parcelRequire("8v3iT");

var $hjgf3 = parcelRequire("hjgf3");
const $e66750f3fb0f96bb$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $e66750f3fb0f96bb$var$numVariantProps = (0, $fNC3C.variantProps).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $e66750f3fb0f96bb$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * If true, will-change will be applied to the element. Only HTMLVisualElements
         * currently support this.
         */ this.applyWillChange = false;
        this.resolveKeyframes = (keyframes, // We use an onComplete callback here rather than a Promise as a Promise
        // resolution is a microtask and we want to retain the ability to force
        // the resolution of keyframes synchronously.
        onComplete, name, value)=>{
            return new this.KeyframeResolver(keyframes, onComplete, name, value, this);
        };
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $h9WaA.KeyframeResolver);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            this.isRenderScheduled = false;
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.isRenderScheduled = false;
        this.scheduleRender = ()=>{
            if (!this.isRenderScheduled) {
                this.isRenderScheduled = true;
                (0, $hjgf3.frame).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $jeuUs.isControllingVariants)(props);
        this.isVariantNode = (0, $jeuUs.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $jqFCw.isMotionValue)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $02Gao.visualElementStore).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $jsjPs.hasReducedMotionListener).current) (0, $jktlv.initPrefersReducedMotion)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $jsjPs.prefersReducedMotion).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $02Gao.visualElementStore).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $hjgf3.cancelFrame)(this.notifyUpdate);
        (0, $hjgf3.cancelFrame)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $5f0mC.transformProps).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $hjgf3.frame).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $7bH6a.featureDefinitions){
            const featureDefinition = (0, $7bH6a.featureDefinitions)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $8v3iT.createBox)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $e66750f3fb0f96bb$var$propEventHandlers.length; i++){
            const key = $e66750f3fb0f96bb$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $jyqX9.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $e66750f3fb0f96bb$var$numVariantProps; i++){
            const name = (0, $fNC3C.variantProps)[i];
            const prop = this.props[name];
            if ((0, $dLd38.isVariantLabel)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $9s8eJ.motionValue)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $bjEgh.isNumericalString)(value) || (0, $e2LUE.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $82f3D.findValueType)(value) && (0, $518Z9.complex).test(target)) value = (0, $adXv8.getAnimatableNone)(key, target);
            this.setBaseTarget(key, (0, $jqFCw.isMotionValue)(value) ? value.get() : value);
        }
        return (0, $jqFCw.isMotionValue)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $iIE6Y.resolveVariantFromProps)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $jqFCw.isMotionValue)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $es3uG.SubscriptionManager)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}

});
parcelRegister("jktlv", function(module, exports) {

$parcel$export(module.exports, "initPrefersReducedMotion", () => $402b11b96c54cb2c$export$ca9f41fb23dded3d);

var $4L0T5 = parcelRequire("4L0T5");

var $jsjPs = parcelRequire("jsjPs");
function $402b11b96c54cb2c$export$ca9f41fb23dded3d() {
    (0, $jsjPs.hasReducedMotionListener).current = true;
    if (!(0, $4L0T5.isBrowser)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $jsjPs.prefersReducedMotion).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $jsjPs.prefersReducedMotion).current = false;
}

});
parcelRegister("jsjPs", function(module, exports) {

$parcel$export(module.exports, "prefersReducedMotion", () => $5d1c3a7750a03ec7$export$ff7706047246b98b);
$parcel$export(module.exports, "hasReducedMotionListener", () => $5d1c3a7750a03ec7$export$6476d16e2fd2d0db);
// Does this device prefer reduced motion? Returns `null` server-side.
const $5d1c3a7750a03ec7$export$ff7706047246b98b = {
    current: null
};
const $5d1c3a7750a03ec7$export$6476d16e2fd2d0db = {
    current: false
};

});


parcelRegister("jyqX9", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", () => $69635cdb8982f9d2$export$9a552858d5197f6e);


var $9s8eJ = parcelRequire("9s8eJ");

var $jqFCw = parcelRequire("jqFCw");
function $69635cdb8982f9d2$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $jqFCw.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $jqFCw.isMotionValue)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $9s8eJ.motionValue)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $9s8eJ.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});

parcelRegister("02Gao", function(module, exports) {

$parcel$export(module.exports, "visualElementStore", () => $a4ccbde0d696dfdf$export$bc2a978a17abfdde);
const $a4ccbde0d696dfdf$export$bc2a978a17abfdde = new WeakMap();

});

parcelRegister("82f3D", function(module, exports) {

$parcel$export(module.exports, "findValueType", () => $0bb49f6c51badae3$export$950e7e59ea1ffed7);

var $4pDEO = parcelRequire("4pDEO");

var $518Z9 = parcelRequire("518Z9");

var $4Vyka = parcelRequire("4Vyka");

var $cobvw = parcelRequire("cobvw");
/**
 * A list of all ValueTypes
 */ const $0bb49f6c51badae3$var$valueTypes = [
    ...(0, $4Vyka.dimensionValueTypes),
    (0, $4pDEO.color),
    (0, $518Z9.complex)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $0bb49f6c51badae3$export$950e7e59ea1ffed7 = (v)=>$0bb49f6c51badae3$var$valueTypes.find((0, $cobvw.testValueType)(v));

});




parcelRegister("4Cs3T", function(module, exports) {

$parcel$export(module.exports, "SVGVisualElement", () => $a0798b9f9973cb35$export$86bcdffbaf733d84);

var $JEDlr = parcelRequire("JEDlr");

var $lPHQ9 = parcelRequire("lPHQ9");

var $2g66t = parcelRequire("2g66t");

var $4kYgl = parcelRequire("4kYgl");

var $945PB = parcelRequire("945PB");

var $5f0mC = parcelRequire("5f0mC");

var $daTxn = parcelRequire("daTxn");

var $h8BN3 = parcelRequire("h8BN3");

var $8v3iT = parcelRequire("8v3iT");

var $gix33 = parcelRequire("gix33");
class $a0798b9f9973cb35$export$86bcdffbaf733d84 extends (0, $lPHQ9.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $8v3iT.createBox);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $5f0mC.transformProps).has(key)) {
            const defaultType = (0, $h8BN3.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $945PB.camelCaseAttributes).has(key) ? (0, $4kYgl.camelToDash)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $JEDlr.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $2g66t.buildSVGAttrs)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $daTxn.renderSVG)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $gix33.isSVGTag)(instance.tagName);
        super.mount(instance);
    }
}

});


parcelRegister("1T5yZ", function(module, exports) {

$parcel$export(module.exports, "layout", () => $2c407ffdaf3c120a$export$b3219800bda33a1f);

var $9ycLt = parcelRequire("9ycLt");

var $aTisU = parcelRequire("aTisU");
const $2c407ffdaf3c120a$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $9ycLt.HTMLProjectionNode),
        MeasureLayout: $aTisU.MeasureLayout
    }
};

});



parcelRegister("9txcC", function(module, exports) {

$parcel$export(module.exports, "ExpandableWidget", () => $5d97ccb9e3577e0d$export$ee129128ca6ca840);

var $ayMG0 = parcelRequire("ayMG0");

var $2hw4u = parcelRequire("2hw4u");
var $fRJCp = parcelRequire("fRJCp");

var $acw62 = parcelRequire("acw62");

var $b7ZjI = parcelRequire("b7ZjI");
function $5d97ccb9e3577e0d$export$ee129128ca6ca840({ layoutId: layoutId, children: children, accented: accented = false }) {
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7ZjI.Widget), {
        accented: accented,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2hw4u.AnimatePresence), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                layout: true,
                layoutId: layoutId,
                exit: {
                    y: -10,
                    opacity: 0
                },
                transition: {
                    duration: 0.3
                },
                children: children({
                    isExpanded: isExpanded,
                    expand: ()=>setIsExpanded(true),
                    collapse: ()=>setIsExpanded(false)
                })
            })
        })
    });
}

});
parcelRegister("2hw4u", function(module, exports) {

$parcel$export(module.exports, "AnimatePresence", () => $06516233abcfeeff$export$3ae376d12526dd6f);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bgzvU = parcelRequire("bgzvU");

var $cNR5T = parcelRequire("cNR5T");

var $6Wt9F = parcelRequire("6Wt9F");

var $aTYEI = parcelRequire("aTYEI");

var $hPDJS = parcelRequire("hPDJS");

var $6S63t = parcelRequire("6S63t");
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $06516233abcfeeff$export$3ae376d12526dd6f = ({ children: children, exitBeforeEnter: exitBeforeEnter, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $6Wt9F.invariant)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $acw62.useMemo)(()=>(0, $hPDJS.onlyElements)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = presentChildren.map((0, $hPDJS.getChildKey));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $acw62.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $acw62.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $aTYEI.useConstant)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $acw62.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $acw62.useState)(presentChildren);
    (0, $6S63t.useIsomorphicLayoutEffect)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $hPDJS.getChildKey)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $hPDJS.getChildKey)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $hPDJS.onlyElements)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $acw62.useContext)((0, $cNR5T.LayoutGroupContext));
    return (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $hPDJS.getChildKey)(child);
            const isPresent = presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 || forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $ayMG0.jsx)((0, $bgzvU.PresenceChild), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: isPresent ? undefined : custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                children: child
            }, key);
        })
    });
};

});
parcelRegister("bgzvU", function(module, exports) {

$parcel$export(module.exports, "PresenceChild", () => $f57f9e9f321f3a7c$export$979daf65881a382a);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $gtJis = parcelRequire("gtJis");

var $aTYEI = parcelRequire("aTYEI");

var $bezNd = parcelRequire("bezNd");
const $f57f9e9f321f3a7c$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $aTYEI.useConstant)($f57f9e9f321f3a7c$var$newChildrenMap);
    const id = (0, $acw62.useId)();
    const context = (0, $acw62.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random()
    ] : [
        isPresent
    ]);
    (0, $acw62.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $acw62.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $ayMG0.jsx)((0, $bezNd.PopChild), {
        isPresent: isPresent,
        children: children
    });
    return (0, $ayMG0.jsx)((0, $gtJis.PresenceContext).Provider, {
        value: context,
        children: children
    });
};
function $f57f9e9f321f3a7c$var$newChildrenMap() {
    return new Map();
}

});
parcelRegister("bezNd", function(module, exports) {

$parcel$export(module.exports, "PopChild", () => $6f8c626e496e1918$export$1d6cdde0c6816c6d);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7iCGF = parcelRequire("7iCGF");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $6f8c626e496e1918$var$PopChildMeasure extends $acw62.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $6f8c626e496e1918$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $acw62.useId)();
    const ref = (0, $acw62.useRef)(null);
    const size = (0, $acw62.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const { nonce: nonce } = (0, $acw62.useContext)((0, $7iCGF.MotionConfigContext));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $acw62.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $ayMG0.jsx)($6f8c626e496e1918$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $acw62.cloneElement(children, {
            ref: ref
        })
    });
}

});


parcelRegister("hPDJS", function(module, exports) {

$parcel$export(module.exports, "getChildKey", () => $2a41914a8628d3e4$export$10e61aed958678dd);
$parcel$export(module.exports, "onlyElements", () => $2a41914a8628d3e4$export$872a3a1281f4b357);

var $acw62 = parcelRequire("acw62");
const $2a41914a8628d3e4$export$10e61aed958678dd = (child)=>child.key || "";
function $2a41914a8628d3e4$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $acw62.Children).forEach(children, (child)=>{
        if ((0, $acw62.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}

});


parcelRegister("b7ZjI", function(module, exports) {

$parcel$export(module.exports, "Widget", () => $fecde2c58cf7825e$export$a829527ff4e4114a);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $fRJCp = parcelRequire("fRJCp");
function $fecde2c58cf7825e$export$a829527ff4e4114a({ children: children, accented: accented = false, header: header }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fRJCp.motion).div, {
        layout: true,
        className: (0, $9QePP.default)("bg-secondary h-full p-6", "hover:border-default border border-transparent", "rounded", accented && "bg-slate-700"),
        children: [
            header && /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "heading-l mb-5",
                children: header
            }),
            children
        ]
    });
}

});


parcelRegister("1l3Yq", function(module, exports) {

$parcel$export(module.exports, "StatWidget", () => $be80b25bc858ca99$export$6197b369bdf10e51);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("kYQGR");
var $b7ZjI = parcelRequire("b7ZjI");

var $9QePP = parcelRequire("9QePP");
function $be80b25bc858ca99$export$6197b369bdf10e51({ label: label, stat: stat, accented: accented = false }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7ZjI.Widget), {
        accented: accented,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, $9QePP.default)("grid h-full grid-cols-2", "items-center gap-10 rounded"),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "subheading subdued leading-snug",
                    children: label
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "display-s",
                    children: stat
                })
            ]
        })
    });
}

});

parcelRegister("9nhU7", function(module, exports) {

$parcel$export(module.exports, "TextWidget", () => $02969c1c3afc55c0$export$e95904fb377b5ee2);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("kYQGR");
var $b7ZjI = parcelRequire("b7ZjI");
function $02969c1c3afc55c0$export$e95904fb377b5ee2({ header: header, children: children, accented: accented = false }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7ZjI.Widget), {
        accented: accented,
        header: header,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "body-s",
            children: children
        })
    });
}

});


parcelRegister("dDsB8", function(module, exports) {
parcelRequire("eUyBx");

});
parcelRegister("eUyBx", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");

var $9QePP = parcelRequire("9QePP");
const $4cb46918d93e7ad0$export$1ba59dacbcbf90fe = ({ options: options })=>{
    const router = (0, $fp4OM.useRouter)();
    const selectedOption = router.pathname;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("pt-14", "hidden", "lg:fixed lg:inset-y-0 lg:flex lg:w-72 lg:flex-col"),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: (0, $9QePP.default)("bg-[#F8FAFC0F] p-6", "flex flex-col", "grow gap-y-5 overflow-y-auto"),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
                className: "flex flex-1 flex-col",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                    role: "list",
                    className: "flex flex-col gap-y-4",
                    children: options.map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                onClick: ()=>router.navigate(option.path),
                                className: (0, $9QePP.default)("flex items-center justify-between", "body-s", "hover:bg-slate-700", "rounded-lg", "p-3", selectedOption === option.path && "bg-slate-700"),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: option.label
                                })
                            })
                        }, option.path))
                })
            })
        })
    });
};

});


parcelRegister("5rtdy", function(module, exports) {

$parcel$export(module.exports, "DropZone", () => (parcelRequire("bVQej")).DropZone);

var $bVQej = parcelRequire("bVQej");

});
parcelRegister("bVQej", function(module, exports) {

$parcel$export(module.exports, "DropZone", () => $b9bc3932e511604c$export$3c6489d84dc98b6);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $e81mU = parcelRequire("e81mU");

var $hS4Ss = parcelRequire("hS4Ss");

var $9QePP = parcelRequire("9QePP");

var $dVEPf = parcelRequire("dVEPf");
const $b9bc3932e511604c$export$3c6489d84dc98b6 = ({ title: title, label: label, file: file, onFileUpload: onFileUpload, onRemove: onRemove, className: className, testid: testid, extensions: extensions, description: description })=>{
    const onDrop = (0, $acw62.useCallback)((acceptedFiles)=>{
        onFileUpload && onFileUpload(acceptedFiles[0]);
    }, [
        file
    ]);
    let allowedExtensions = label ? label : "All formats accepted";
    if (extensions && !label) {
        if (extensions.length > 1) allowedExtensions = `${extensions.slice(0, -1).map((e)=>e.toLocaleUpperCase()).join(", ")} or ${extensions.slice(-1)[0].toLocaleUpperCase()} files only`;
        else allowedExtensions = `${extensions[0].toLocaleUpperCase()} files only`;
    }
    const accept = extensions ? extensions.map((extension)=>(0, (/*@__PURE__*/$parcel$interopDefault($e81mU))).types[extension]).reduce((types, mimetype)=>({
            ...types,
            [mimetype]: (0, (/*@__PURE__*/$parcel$interopDefault($e81mU))).extensions[mimetype].map((t)=>"." + t)
        }), {}) : extensions;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        "data-testid": testid,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "rounded",
            children: [
                title && /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "heading-s mb-2",
                    children: title
                }),
                description && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "body-s mb-8",
                    children: description
                }),
                file ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hS4Ss.FileItem), {
                    file: file,
                    onRemove: onRemove
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dVEPf.default), {
                        onDrop: onDrop,
                        maxFiles: 1,
                        accept: accept,
                        children: ({ getRootProps: getRootProps, getInputProps: getInputProps, isDragActive: isDragActive, isFocused: isFocused, fileRejections: fileRejections })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        ...getRootProps({
                                            className: (0, $9QePP.default)(isDragActive || isFocused ? "border-gray-500 bg-gray-600" : "bg-surface-subdued border-borderColor", "mt-4", "body-s border-default rounded border border-dashed", "flex min-h-[11.5rem] flex-col items-center justify-center")
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                ...getInputProps()
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "text-center",
                                                children: [
                                                    "Drop files or ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                        children: "browse"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "ui-label subdued mb-2",
                                                        children: allowedExtensions
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    fileRejections.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "ui-element mt-4 break-words bg-red-500",
                                        children: fileRejections[0].errors[0].message
                                    })
                                ]
                            })
                    })
                })
            ]
        })
    });
};

});
parcelRegister("e81mU", function(module, exports) {

$parcel$export(module.exports, "charset", () => $a492dfc6de9a2ef8$export$e4c823724462c3fd, (v) => $a492dfc6de9a2ef8$export$e4c823724462c3fd = v);
$parcel$export(module.exports, "charsets", () => $a492dfc6de9a2ef8$export$48d2c0a44ea41a2f, (v) => $a492dfc6de9a2ef8$export$48d2c0a44ea41a2f = v);
$parcel$export(module.exports, "contentType", () => $a492dfc6de9a2ef8$export$8019223850b8bf78, (v) => $a492dfc6de9a2ef8$export$8019223850b8bf78 = v);
$parcel$export(module.exports, "extension", () => $a492dfc6de9a2ef8$export$1b45514b112dd749, (v) => $a492dfc6de9a2ef8$export$1b45514b112dd749 = v);
$parcel$export(module.exports, "extensions", () => $a492dfc6de9a2ef8$export$cc3e2d3244e01b7f, (v) => $a492dfc6de9a2ef8$export$cc3e2d3244e01b7f = v);
$parcel$export(module.exports, "lookup", () => $a492dfc6de9a2ef8$export$dfc7155ac0343b8, (v) => $a492dfc6de9a2ef8$export$dfc7155ac0343b8 = v);
$parcel$export(module.exports, "types", () => $a492dfc6de9a2ef8$export$b14ad400b1d09e0f, (v) => $a492dfc6de9a2ef8$export$b14ad400b1d09e0f = v);
/*!
 * mime-types
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $a492dfc6de9a2ef8$export$e4c823724462c3fd;
var $a492dfc6de9a2ef8$export$48d2c0a44ea41a2f;
var $a492dfc6de9a2ef8$export$8019223850b8bf78;
var $a492dfc6de9a2ef8$export$1b45514b112dd749;
var $a492dfc6de9a2ef8$export$cc3e2d3244e01b7f;
var $a492dfc6de9a2ef8$export$dfc7155ac0343b8;
var $a492dfc6de9a2ef8$export$b14ad400b1d09e0f;
"use strict";

var $dBdNK = parcelRequire("dBdNK");

var $59kwG = parcelRequire("59kwG");
var $a492dfc6de9a2ef8$require$extname = $59kwG.extname;
/**
 * Module variables.
 * @private
 */ var $a492dfc6de9a2ef8$var$EXTRACT_TYPE_REGEXP = /^\s*([^;\s]*)(?:;|\s|$)/;
var $a492dfc6de9a2ef8$var$TEXT_TYPE_REGEXP = /^text\//i;
$a492dfc6de9a2ef8$export$e4c823724462c3fd = $a492dfc6de9a2ef8$var$charset;
$a492dfc6de9a2ef8$export$48d2c0a44ea41a2f = {
    lookup: $a492dfc6de9a2ef8$var$charset
};
$a492dfc6de9a2ef8$export$8019223850b8bf78 = $a492dfc6de9a2ef8$var$contentType;
$a492dfc6de9a2ef8$export$1b45514b112dd749 = $a492dfc6de9a2ef8$var$extension;
$a492dfc6de9a2ef8$export$cc3e2d3244e01b7f = Object.create(null);
$a492dfc6de9a2ef8$export$dfc7155ac0343b8 = $a492dfc6de9a2ef8$var$lookup;
$a492dfc6de9a2ef8$export$b14ad400b1d09e0f = Object.create(null);
// Populate the extensions/types maps
$a492dfc6de9a2ef8$var$populateMaps($a492dfc6de9a2ef8$export$cc3e2d3244e01b7f, $a492dfc6de9a2ef8$export$b14ad400b1d09e0f);
/**
 * Get the default charset for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */ function $a492dfc6de9a2ef8$var$charset(type) {
    if (!type || typeof type !== "string") return false;
    // TODO: use media-typer
    var match = $a492dfc6de9a2ef8$var$EXTRACT_TYPE_REGEXP.exec(type);
    var mime = match && $dBdNK[match[1].toLowerCase()];
    if (mime && mime.charset) return mime.charset;
    // default text/* to utf-8
    if (match && $a492dfc6de9a2ef8$var$TEXT_TYPE_REGEXP.test(match[1])) return "UTF-8";
    return false;
}
/**
 * Create a full Content-Type header given a MIME type or extension.
 *
 * @param {string} str
 * @return {boolean|string}
 */ function $a492dfc6de9a2ef8$var$contentType(str) {
    // TODO: should this even be in this module?
    if (!str || typeof str !== "string") return false;
    var mime = str.indexOf("/") === -1 ? $a492dfc6de9a2ef8$export$dfc7155ac0343b8(str) : str;
    if (!mime) return false;
    // TODO: use content-type or other module
    if (mime.indexOf("charset") === -1) {
        var charset = $a492dfc6de9a2ef8$export$e4c823724462c3fd(mime);
        if (charset) mime += "; charset=" + charset.toLowerCase();
    }
    return mime;
}
/**
 * Get the default extension for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */ function $a492dfc6de9a2ef8$var$extension(type) {
    if (!type || typeof type !== "string") return false;
    // TODO: use media-typer
    var match = $a492dfc6de9a2ef8$var$EXTRACT_TYPE_REGEXP.exec(type);
    // get extensions
    var exts = match && $a492dfc6de9a2ef8$export$cc3e2d3244e01b7f[match[1].toLowerCase()];
    if (!exts || !exts.length) return false;
    return exts[0];
}
/**
 * Lookup the MIME type for a file path/extension.
 *
 * @param {string} path
 * @return {boolean|string}
 */ function $a492dfc6de9a2ef8$var$lookup(path) {
    if (!path || typeof path !== "string") return false;
    // get the extension ("ext" or ".ext" or full path)
    var extension = $a492dfc6de9a2ef8$require$extname("x." + path).toLowerCase().substr(1);
    if (!extension) return false;
    return $a492dfc6de9a2ef8$export$b14ad400b1d09e0f[extension] || false;
}
/**
 * Populate the extensions and types maps.
 * @private
 */ function $a492dfc6de9a2ef8$var$populateMaps(extensions, types) {
    // source preference (least -> most)
    var preference = [
        "nginx",
        "apache",
        undefined,
        "iana"
    ];
    Object.keys($dBdNK).forEach(function forEachMimeType(type) {
        var mime = $dBdNK[type];
        var exts = mime.extensions;
        if (!exts || !exts.length) return;
        // mime -> extensions
        extensions[type] = exts;
        // extension -> mime
        for(var i = 0; i < exts.length; i++){
            var extension = exts[i];
            if (types[extension]) {
                var from = preference.indexOf($dBdNK[types[extension]].source);
                var to = preference.indexOf(mime.source);
                if (types[extension] !== "application/octet-stream" && (from > to || from === to && types[extension].substr(0, 12) === "application/")) continue;
            }
            // set the extension -> mime
            types[extension] = type;
        }
    });
}

});
parcelRegister("dBdNK", function(module, exports) {
/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 */ 
module.exports = (parcelRequire("7FYWA"));

});
parcelRegister("7FYWA", function(module, exports) {
module.exports = JSON.parse('{"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/3gpp-ims+xml":{"source":"iana","compressible":true},"application/3gpphal+json":{"source":"iana","compressible":true},"application/3gpphalforms+json":{"source":"iana","compressible":true},"application/a2l":{"source":"iana"},"application/ace+cbor":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/activity+json":{"source":"iana","compressible":true},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/alto-updatestreamcontrol+json":{"source":"iana","compressible":true},"application/alto-updatestreamparams+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/at+jwt":{"source":"iana"},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","compressible":true,"extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana","compressible":true,"extensions":["atomdeleted"]},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","compressible":true,"extensions":["atomsvc"]},"application/atsc-dwd+xml":{"source":"iana","compressible":true,"extensions":["dwd"]},"application/atsc-dynamic-event-message":{"source":"iana"},"application/atsc-held+xml":{"source":"iana","compressible":true,"extensions":["held"]},"application/atsc-rdt+json":{"source":"iana","compressible":true},"application/atsc-rsat+xml":{"source":"iana","compressible":true,"extensions":["rsat"]},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana","compressible":true},"application/bacnet-xdd+zip":{"source":"iana","compressible":false},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana","compressible":true,"extensions":["xcs"]},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/captive+json":{"source":"iana","compressible":true},"application/cbor":{"source":"iana"},"application/cbor-seq":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana","compressible":true},"application/ccxml+xml":{"source":"iana","compressible":true,"extensions":["ccxml"]},"application/cdfx+xml":{"source":"iana","compressible":true,"extensions":["cdfx"]},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana","compressible":true},"application/cellml+xml":{"source":"iana","compressible":true},"application/cfw":{"source":"iana"},"application/city+json":{"source":"iana","compressible":true},"application/clr":{"source":"iana"},"application/clue+xml":{"source":"iana","compressible":true},"application/clue_info+xml":{"source":"iana","compressible":true},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana","compressible":true},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/conference-info+xml":{"source":"iana","compressible":true},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cpl+xml":{"source":"iana","compressible":true,"extensions":["cpl"]},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana","compressible":true},"application/cstadata+xml":{"source":"iana","compressible":true},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cwt":{"source":"iana"},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","compressible":true,"extensions":["mpd"]},"application/dash-patch+xml":{"source":"iana","compressible":true,"extensions":["mpp"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","compressible":true,"extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana","compressible":true},"application/dicom":{"source":"iana"},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana","compressible":true},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/dns+json":{"source":"iana","compressible":true},"application/dns-message":{"source":"iana"},"application/docbook+xml":{"source":"apache","compressible":true,"extensions":["dbk"]},"application/dots+cbor":{"source":"iana"},"application/dskpp+xml":{"source":"iana","compressible":true},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","compressible":true,"extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/ecmascript":{"source":"iana","compressible":true,"extensions":["es","ecma"]},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/elm+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/elm+xml":{"source":"iana","compressible":true},"application/emergencycalldata.cap+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/emergencycalldata.comment+xml":{"source":"iana","compressible":true},"application/emergencycalldata.control+xml":{"source":"iana","compressible":true},"application/emergencycalldata.deviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.providerinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.serviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.veds+xml":{"source":"iana","compressible":true},"application/emma+xml":{"source":"iana","compressible":true,"extensions":["emma"]},"application/emotionml+xml":{"source":"iana","compressible":true,"extensions":["emotionml"]},"application/encaprtp":{"source":"iana"},"application/epp+xml":{"source":"iana","compressible":true},"application/epub+zip":{"source":"iana","compressible":false,"extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/expect-ct-report+json":{"source":"iana","compressible":true},"application/express":{"source":"iana","extensions":["exp"]},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdt+xml":{"source":"iana","compressible":true,"extensions":["fdt"]},"application/fhir+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/fhir+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/flexfec":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false},"application/framework-attributes+xml":{"source":"iana","compressible":true},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geopackage+sqlite3":{"source":"iana"},"application/geoxacml+xml":{"source":"iana","compressible":true},"application/gltf-buffer":{"source":"iana"},"application/gml+xml":{"source":"iana","compressible":true,"extensions":["gml"]},"application/gpx+xml":{"source":"apache","compressible":true,"extensions":["gpx"]},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana","compressible":true},"application/hjson":{"extensions":["hjson"]},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana","compressible":true},"application/ibe-pkg-reply+xml":{"source":"iana","compressible":true},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","compressible":true,"extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana","compressible":true,"extensions":["its"]},"application/java-archive":{"source":"apache","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/jscalendar+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana","compressible":true},"application/kpml-response+xml":{"source":"iana","compressible":true},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana","compressible":true,"extensions":["lgr"]},"application/link-format":{"source":"iana"},"application/load-control+xml":{"source":"iana","compressible":true},"application/lost+xml":{"source":"iana","compressible":true,"extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana","compressible":true},"application/lpf+zip":{"source":"iana","compressible":false},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","compressible":true,"extensions":["mads"]},"application/manifest+json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","compressible":true,"extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","compressible":true,"extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana","compressible":true},"application/mathml-presentation+xml":{"source":"iana","compressible":true},"application/mbms-associated-procedure-description+xml":{"source":"iana","compressible":true},"application/mbms-deregister+xml":{"source":"iana","compressible":true},"application/mbms-envelope+xml":{"source":"iana","compressible":true},"application/mbms-msk+xml":{"source":"iana","compressible":true},"application/mbms-msk-response+xml":{"source":"iana","compressible":true},"application/mbms-protection-description+xml":{"source":"iana","compressible":true},"application/mbms-reception-report+xml":{"source":"iana","compressible":true},"application/mbms-register+xml":{"source":"iana","compressible":true},"application/mbms-register-response+xml":{"source":"iana","compressible":true},"application/mbms-schedule+xml":{"source":"iana","compressible":true},"application/mbms-user-service-description+xml":{"source":"iana","compressible":true},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana","compressible":true,"extensions":["mpf"]},"application/media_control+xml":{"source":"iana","compressible":true},"application/mediaservercontrol+xml":{"source":"iana","compressible":true,"extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","compressible":true,"extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","compressible":true,"extensions":["meta4"]},"application/mets+xml":{"source":"iana","compressible":true,"extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mipc":{"source":"iana"},"application/missing-blocks+cbor-seq":{"source":"iana"},"application/mmt-aei+xml":{"source":"iana","compressible":true,"extensions":["maei"]},"application/mmt-usd+xml":{"source":"iana","compressible":true,"extensions":["musd"]},"application/mods+xml":{"source":"iana","compressible":true,"extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana","compressible":true},"application/mrb-publish+xml":{"source":"iana","compressible":true},"application/msc-ivr+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msc-mixer+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/multipart-core":{"source":"iana"},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana","extensions":["nq"]},"application/n-triples":{"source":"iana","extensions":["nt"]},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana","charset":"US-ASCII"},"application/news-groupinfo":{"source":"iana","charset":"US-ASCII"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana","compressible":true},"application/node":{"source":"iana","extensions":["cjs"]},"application/nss":{"source":"iana"},"application/oauth-authz-req+jwt":{"source":"iana"},"application/oblivious-dns-message":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":false,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odm+xml":{"source":"iana","compressible":true},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","compressible":true,"extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/omdoc+xml":{"source":"apache","compressible":true,"extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg"]},"application/opc-nodeset+xml":{"source":"iana","compressible":true},"application/oscore":{"source":"iana"},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p21":{"source":"iana"},"application/p21+zip":{"source":"iana","compressible":false},"application/p2p-overlay+xml":{"source":"iana","compressible":true,"extensions":["relo"]},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","compressible":true,"extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pem-certificate-chain":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana","extensions":["asc"]},"application/pgp-signature":{"source":"iana","extensions":["asc","sig"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pidf-diff+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkcs8-encrypted":{"source":"iana"},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","compressible":true,"extensions":["pls"]},"application/poc-settings+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana","compressible":true},"application/provenance+xml":{"source":"iana","compressible":true,"extensions":["provx"]},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.cyn":{"source":"iana","charset":"7-BIT"},"application/prs.hpub+zip":{"source":"iana","compressible":false},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana","compressible":true},"application/pskc+xml":{"source":"iana","compressible":true,"extensions":["pskcxml"]},"application/pvd+json":{"source":"iana","compressible":true},"application/qsig":{"source":"iana"},"application/raml+yaml":{"compressible":true,"extensions":["raml"]},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf","owl"]},"application/reginfo+xml":{"source":"iana","compressible":true,"extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"iana"},"application/reputon+json":{"source":"iana","compressible":true},"application/resource-lists+xml":{"source":"iana","compressible":true,"extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","compressible":true,"extensions":["rld"]},"application/rfc+xml":{"source":"iana","compressible":true},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana","compressible":true},"application/rls-services+xml":{"source":"iana","compressible":true,"extensions":["rs"]},"application/route-apd+xml":{"source":"iana","compressible":true,"extensions":["rapd"]},"application/route-s-tsid+xml":{"source":"iana","compressible":true,"extensions":["sls"]},"application/route-usd+xml":{"source":"iana","compressible":true,"extensions":["rusd"]},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","compressible":true,"extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana","compressible":true},"application/samlmetadata+xml":{"source":"iana","compressible":true},"application/sarif+json":{"source":"iana","compressible":true},"application/sarif-external-properties+json":{"source":"iana","compressible":true},"application/sbe":{"source":"iana"},"application/sbml+xml":{"source":"iana","compressible":true,"extensions":["sbml"]},"application/scaip+xml":{"source":"iana","compressible":true},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/secevent+jwt":{"source":"iana"},"application/senml+cbor":{"source":"iana"},"application/senml+json":{"source":"iana","compressible":true},"application/senml+xml":{"source":"iana","compressible":true,"extensions":["senmlx"]},"application/senml-etch+cbor":{"source":"iana"},"application/senml-etch+json":{"source":"iana","compressible":true},"application/senml-exi":{"source":"iana"},"application/sensml+cbor":{"source":"iana"},"application/sensml+json":{"source":"iana","compressible":true},"application/sensml+xml":{"source":"iana","compressible":true,"extensions":["sensmlx"]},"application/sensml-exi":{"source":"iana"},"application/sep+xml":{"source":"iana","compressible":true},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","compressible":true,"extensions":["shf"]},"application/sieve":{"source":"iana","extensions":["siv","sieve"]},"application/simple-filter+xml":{"source":"iana","compressible":true},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/sipc":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"iana"},"application/smil+xml":{"source":"iana","compressible":true,"extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","compressible":true,"extensions":["srx"]},"application/spdx+json":{"source":"iana","compressible":true},"application/spirits-event+xml":{"source":"iana","compressible":true},"application/sql":{"source":"iana"},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","compressible":true,"extensions":["grxml"]},"application/sru+xml":{"source":"iana","compressible":true,"extensions":["sru"]},"application/ssdl+xml":{"source":"apache","compressible":true,"extensions":["ssdl"]},"application/ssml+xml":{"source":"iana","compressible":true,"extensions":["ssml"]},"application/stix+json":{"source":"iana","compressible":true},"application/swid+xml":{"source":"iana","compressible":true,"extensions":["swidtag"]},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/taxii+json":{"source":"iana","compressible":true},"application/td+json":{"source":"iana","compressible":true},"application/tei+xml":{"source":"iana","compressible":true,"extensions":["tei","teicorpus"]},"application/tetra_isi":{"source":"iana"},"application/thraud+xml":{"source":"iana","compressible":true,"extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/tlsrpt+gzip":{"source":"iana"},"application/tlsrpt+json":{"source":"iana","compressible":true},"application/tnauthlist":{"source":"iana"},"application/token-introspection+jwt":{"source":"iana"},"application/toml":{"compressible":true,"extensions":["toml"]},"application/trickle-ice-sdpfrag":{"source":"iana"},"application/trig":{"source":"iana","extensions":["trig"]},"application/ttml+xml":{"source":"iana","compressible":true,"extensions":["ttml"]},"application/tve-trigger":{"source":"iana"},"application/tzif":{"source":"iana"},"application/tzif-leap":{"source":"iana"},"application/ubjson":{"compressible":false,"extensions":["ubj"]},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana","compressible":true},"application/urc-ressheet+xml":{"source":"iana","compressible":true,"extensions":["rsheet"]},"application/urc-targetdesc+xml":{"source":"iana","compressible":true,"extensions":["td"]},"application/urc-uisocketdesc+xml":{"source":"iana","compressible":true},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana","compressible":true},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana","compressible":true,"extensions":["1km"]},"application/vnd.3gpp-prose+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-v2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.5gnas":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.bsf+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gmop+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gtpc":{"source":"iana"},"application/vnd.3gpp.interworking-data":{"source":"iana"},"application/vnd.3gpp.lpp":{"source":"iana"},"application/vnd.3gpp.mc-signalling-ear":{"source":"iana"},"application/vnd.3gpp.mcdata-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-payload":{"source":"iana"},"application/vnd.3gpp.mcdata-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-signalling":{"source":"iana"},"application/vnd.3gpp.mcdata-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-floor-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-signed+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-init-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-transmission-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mid-call+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ngap":{"source":"iana"},"application/vnd.3gpp.pfcp":{"source":"iana"},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.s1ap":{"source":"iana"},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ussd+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","compressible":false,"extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","compressible":true,"extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"iana","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.afpc.afplinedata":{"source":"iana"},"application/vnd.afpc.afplinedata-pagedef":{"source":"iana"},"application/vnd.afpc.cmoca-cmresource":{"source":"iana"},"application/vnd.afpc.foca-charset":{"source":"iana"},"application/vnd.afpc.foca-codedfont":{"source":"iana"},"application/vnd.afpc.foca-codepage":{"source":"iana"},"application/vnd.afpc.modca":{"source":"iana"},"application/vnd.afpc.modca-cmtable":{"source":"iana"},"application/vnd.afpc.modca-formdef":{"source":"iana"},"application/vnd.afpc.modca-mediummap":{"source":"iana"},"application/vnd.afpc.modca-objectcontainer":{"source":"iana"},"application/vnd.afpc.modca-overlay":{"source":"iana"},"application/vnd.afpc.modca-pagesegment":{"source":"iana"},"application/vnd.age":{"source":"iana","extensions":["age"]},"application/vnd.ah-barcode":{"source":"iana"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amadeus+json":{"source":"iana","compressible":true},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana","compressible":true},"application/vnd.android.ota":{"source":"iana"},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.arrow.file":{"source":"iana"},"application/vnd.apache.arrow.stream":{"source":"iana"},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.aplextor.warrp+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","compressible":true,"extensions":["mpkg"]},"application/vnd.apple.keynote":{"source":"iana","extensions":["key"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.numbers":{"source":"iana","extensions":["numbers"]},"application/vnd.apple.pages":{"source":"iana","extensions":["pages"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"iana"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artisan+json":{"source":"iana","compressible":true},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avalon+json":{"source":"iana","compressible":true},"application/vnd.avistar+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmml+xml":{"source":"iana","compressible":true,"extensions":["bmml"]},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.banana-accounting":{"source":"iana"},"application/vnd.bbf.usp.error":{"source":"iana"},"application/vnd.bbf.usp.msg":{"source":"iana"},"application/vnd.bbf.usp.msg+json":{"source":"iana","compressible":true},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana","compressible":true},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.bpf":{"source":"iana"},"application/vnd.bpf3":{"source":"iana"},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.byu.uapi+json":{"source":"iana","compressible":true},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","compressible":true,"extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.ciedi":{"source":"iana"},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana","compressible":true,"extensions":["csl"]},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collabio.xodocuments.document":{"source":"iana"},"application/vnd.collabio.xodocuments.document-template":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation-template":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet-template":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana","compressible":false},"application/vnd.comicbook-rar":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","compressible":true,"extensions":["wbs"]},"application/vnd.cryptii.pipe+json":{"source":"iana","compressible":true},"application/vnd.crypto-shade-file":{"source":"iana"},"application/vnd.cryptomator.encrypted":{"source":"iana"},"application/vnd.cryptomator.vault":{"source":"iana"},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana","compressible":true},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana","compressible":true},"application/vnd.cybank":{"source":"iana"},"application/vnd.cyclonedx+json":{"source":"iana","compressible":true},"application/vnd.cyclonedx+xml":{"source":"iana","compressible":true},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana","compressible":false},"application/vnd.d3m-dataset":{"source":"iana"},"application/vnd.d3m-problem":{"source":"iana"},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.dbf":{"source":"iana","extensions":["dbf"]},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","compressible":true,"extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume.movie":{"source":"iana"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana","compressible":true},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbisl+xml":{"source":"iana","compressible":true},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-container+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-generic+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-init+xml":{"source":"iana","compressible":true},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecip.rlp":{"source":"iana"},"application/vnd.eclipse.ditto+json":{"source":"iana","compressible":true},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.emclient.accessrequest+xml":{"source":"iana","compressible":true},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana","compressible":true},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana","compressible":false},"application/vnd.eszigno3+xml":{"source":"iana","compressible":true,"extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.asic-e+zip":{"source":"iana","compressible":false},"application/vnd.etsi.asic-s+zip":{"source":"iana","compressible":false},"application/vnd.etsi.cug+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvcommand+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvservice+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsync+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mcid+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana","compressible":true},"application/vnd.etsi.pstn+xml":{"source":"iana","compressible":true},"application/vnd.etsi.sci+xml":{"source":"iana","compressible":true},"application/vnd.etsi.simservs+xml":{"source":"iana","compressible":true},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana","compressible":true},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eu.kasparian.car+json":{"source":"iana","compressible":true},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.exstream-empower+zip":{"source":"iana","compressible":false},"application/vnd.exstream-package":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.familysearch.gedcom+zip":{"source":"iana","compressible":false},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"iana","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.ffsns":{"source":"iana"},"application/vnd.ficlab.flb+zip":{"source":"iana","compressible":false},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.frogans.fnc":{"source":"iana","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"iana","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujifilm.fb.docuworks":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.binder":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.container":{"source":"iana"},"application/vnd.fujifilm.fb.jfi+xml":{"source":"iana","compressible":true},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.futoin+cbor":{"source":"iana"},"application/vnd.futoin+json":{"source":"iana","compressible":true},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.gentics.grd+json":{"source":"iana","compressible":true},"application/vnd.geo+json":{"source":"iana","compressible":true},"application/vnd.geocube+xml":{"source":"iana","compressible":true},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.slides":{"source":"iana"},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"iana","compressible":true},"application/vnd.gov.sk.e-form+zip":{"source":"iana","compressible":false},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana","compressible":true},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","compressible":true,"extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","compressible":true,"extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hl7cda+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hl7v2+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper+json":{"source":"iana","compressible":true},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"iana"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"iana","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana","compressible":false},"application/vnd.imagemeter.image+zip":{"source":"iana","compressible":false},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana","compressible":true},"application/vnd.informix-visionary":{"source":"iana"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana","compressible":true},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana","compressible":true},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","compressible":true,"extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.iso11783-10+zip":{"source":"iana","compressible":false},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las":{"source":"iana"},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","compressible":true,"extensions":["lasxml"]},"application/vnd.laszip":{"source":"iana"},"application/vnd.leap+json":{"source":"iana","compressible":true},"application/vnd.liberty-request+xml":{"source":"iana","compressible":true},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","compressible":true,"extensions":["lbe"]},"application/vnd.logipipe.circuit+zip":{"source":"iana","compressible":false},"application/vnd.loom":{"source":"iana"},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana","extensions":["mvt"]},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.license+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxar.archive.3tz+zip":{"source":"iana","compressible":false},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana","compressible":true},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana","compressible":true},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana","compressible":true},"application/vnd.ms-printing.printticket+xml":{"source":"apache","compressible":true},"application/vnd.ms-printschematicket+xml":{"source":"iana","compressible":true},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.nacamar.ybrid+json":{"source":"iana","compressible":true},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nebumind.line":{"source":"iana"},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nimn":{"source":"iana"},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana","compressible":true},"application/vnd.nokia.iptv.config+xml":{"source":"iana","compressible":true},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana","compressible":true},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana","compressible":true,"extensions":["ac"]},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"iana","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana","compressible":true},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"iana","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oci.image.manifest.v1+json":{"source":"iana","compressible":true},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana","compressible":true},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana","compressible":true},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana","compressible":true},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana","compressible":true},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.oipf.spdlist+xml":{"source":"iana","compressible":true},"application/vnd.oipf.ueprofile+xml":{"source":"iana","compressible":true},"application/vnd.oipf.userprofile+xml":{"source":"iana","compressible":true},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.imd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sprov+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-pcc+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana","compressible":true},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","compressible":true,"extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana","compressible":true},"application/vnd.oma.group-usage-list+xml":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+cbor":{"source":"iana"},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.final-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.groups+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana","compressible":true},"application/vnd.oma.xcap-directory+xml":{"source":"iana","compressible":true},"application/vnd.omads-email+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-file+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-folder+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana","compressible":true,"extensions":["obgx"]},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana","compressible":true,"extensions":["osm"]},"application/vnd.opentimestamps.ots":{"source":"iana"},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"iana","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"iana","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"iana","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana","compressible":true},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana","compressible":true},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos.xml":{"source":"iana"},"application/vnd.patentdive":{"source":"iana"},"application/vnd.patientecommsdoc":{"source":"iana"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana","compressible":true},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.psfs":{"source":"iana"},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana","compressible":true},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana","compressible":true},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana","extensions":["rar"]},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","compressible":true,"extensions":["musicxml"]},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.resilient.logic":{"source":"iana"},"application/vnd.restful+json":{"source":"iana","compressible":true},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","compressible":true,"extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sar":{"source":"iana"},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.seis+json":{"source":"iana","compressible":true},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shade-save-file":{"source":"iana"},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.shootproof+json":{"source":"iana","compressible":true},"application/vnd.shopkick+json":{"source":"iana","compressible":true},"application/vnd.shp":{"source":"iana"},"application/vnd.shx":{"source":"iana"},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.snesdev-page-table":{"source":"iana"},"application/vnd.software602.filler.form+xml":{"source":"iana","compressible":true,"extensions":["fo"]},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","compressible":true,"extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sqlite3":{"source":"iana"},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.sycle+xml":{"source":"iana","compressible":true},"application/vnd.syft+json":{"source":"iana","compressible":true},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","charset":"UTF-8","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["ddf"]},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.think-cell.ppttc+json":{"source":"iana","compressible":true},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana","compressible":true},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","compressible":true,"extensions":["uoml"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.veritone.aion+json":{"source":"iana","compressible":true},"application/vnd.veryant.thin":{"source":"iana"},"application/vnd.ves.encrypted":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","charset":"UTF-8","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.dpp":{"source":"iana"},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana","compressible":true},"application/vnd.wv.ssp+xml":{"source":"iana","compressible":true},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana","compressible":true},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","compressible":true,"extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.youtube.yt":{"source":"iana"},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","compressible":true,"extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","compressible":true,"extensions":["vxml"]},"application/voucher-cms+json":{"source":"iana","compressible":true},"application/vq-rtcpxr":{"source":"iana"},"application/wasm":{"source":"iana","compressible":true,"extensions":["wasm"]},"application/watcherinfo+xml":{"source":"iana","compressible":true,"extensions":["wif"]},"application/webpush-options+json":{"source":"iana","compressible":true},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","compressible":true,"extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","compressible":true,"extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","compressible":true,"extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","compressible":true,"extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","compressible":true,"extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-iwork-keynote-sffkey":{"extensions":["key"]},"application/x-iwork-numbers-sffnumbers":{"extensions":["numbers"]},"application/x-iwork-pages-sffpages":{"extensions":["pages"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-keepass2":{"extensions":["kdbx"]},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-pki-message":{"source":"iana"},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"iana","extensions":["der","crt","pem"]},"application/x-x509-ca-ra-cert":{"source":"iana"},"application/x-x509-next-ca-cert":{"source":"iana"},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","compressible":true,"extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana","compressible":true},"application/xaml+xml":{"source":"apache","compressible":true,"extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana","compressible":true,"extensions":["xav"]},"application/xcap-caps+xml":{"source":"iana","compressible":true,"extensions":["xca"]},"application/xcap-diff+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana","compressible":true,"extensions":["xel"]},"application/xcap-error+xml":{"source":"iana","compressible":true},"application/xcap-ns+xml":{"source":"iana","compressible":true,"extensions":["xns"]},"application/xcon-conference-info+xml":{"source":"iana","compressible":true},"application/xcon-conference-info-diff+xml":{"source":"iana","compressible":true},"application/xenc+xml":{"source":"iana","compressible":true,"extensions":["xenc"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache","compressible":true},"application/xliff+xml":{"source":"iana","compressible":true,"extensions":["xlf"]},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana","compressible":true},"application/xmpp+xml":{"source":"iana","compressible":true},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","compressible":true,"extensions":["xpl"]},"application/xslt+xml":{"source":"iana","compressible":true,"extensions":["xsl","xslt"]},"application/xspf+xml":{"source":"apache","compressible":true,"extensions":["xspf"]},"application/xv+xml":{"source":"iana","compressible":true,"extensions":["mxml","xhvml","xvml","xvm"]},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana","compressible":true},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana","compressible":true},"application/yin+xml":{"source":"iana","compressible":true,"extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zlib":{"source":"iana"},"application/zstd":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/aac":{"source":"iana"},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana","extensions":["amr"]},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/flexfec":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/mhas":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/mobile-xmf":{"source":"iana","extensions":["mxmf"]},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx","opus"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/scip":{"source":"iana"},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sofa":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tetra_acelp":{"source":"iana"},"audio/tetra_acelp_bb":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/tsvcis":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/usac":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dts.uhd":{"source":"iana"},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"iana"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/collection":{"source":"iana","extensions":["ttc"]},"font/otf":{"source":"iana","compressible":true,"extensions":["otf"]},"font/sfnt":{"source":"iana"},"font/ttf":{"source":"iana","compressible":true,"extensions":["ttf"]},"font/woff":{"source":"iana","extensions":["woff"]},"font/woff2":{"source":"iana","extensions":["woff2"]},"image/aces":{"source":"iana","extensions":["exr"]},"image/apng":{"compressible":false,"extensions":["apng"]},"image/avci":{"source":"iana","extensions":["avci"]},"image/avcs":{"source":"iana","extensions":["avcs"]},"image/avif":{"source":"iana","compressible":false,"extensions":["avif"]},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana","extensions":["drle"]},"image/emf":{"source":"iana","extensions":["emf"]},"image/fits":{"source":"iana","extensions":["fits"]},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/heic":{"source":"iana","extensions":["heic"]},"image/heic-sequence":{"source":"iana","extensions":["heics"]},"image/heif":{"source":"iana","extensions":["heif"]},"image/heif-sequence":{"source":"iana","extensions":["heifs"]},"image/hej2k":{"source":"iana","extensions":["hej2"]},"image/hsj2":{"source":"iana","extensions":["hsj2"]},"image/ief":{"source":"iana","extensions":["ief"]},"image/jls":{"source":"iana","extensions":["jls"]},"image/jp2":{"source":"iana","compressible":false,"extensions":["jp2","jpg2"]},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpeg","jpg","jpe"]},"image/jph":{"source":"iana","extensions":["jph"]},"image/jphc":{"source":"iana","extensions":["jhc"]},"image/jpm":{"source":"iana","compressible":false,"extensions":["jpm"]},"image/jpx":{"source":"iana","compressible":false,"extensions":["jpx","jpf"]},"image/jxr":{"source":"iana","extensions":["jxr"]},"image/jxra":{"source":"iana","extensions":["jxra"]},"image/jxrs":{"source":"iana","extensions":["jxrs"]},"image/jxs":{"source":"iana","extensions":["jxs"]},"image/jxsc":{"source":"iana","extensions":["jxsc"]},"image/jxsi":{"source":"iana","extensions":["jxsi"]},"image/jxss":{"source":"iana","extensions":["jxss"]},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/ktx2":{"source":"iana","extensions":["ktx2"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif"]},"image/prs.pti":{"source":"iana","extensions":["pti"]},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana","extensions":["t38"]},"image/tiff":{"source":"iana","compressible":false,"extensions":["tif","tiff"]},"image/tiff-fx":{"source":"iana","extensions":["tfx"]},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana","extensions":["azv"]},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana","compressible":true,"extensions":["ico"]},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-dds":{"compressible":true,"extensions":["dds"]},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.pco.b16":{"source":"iana","extensions":["b16"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana","extensions":["tap"]},"image/vnd.valve.source.texture":{"source":"iana","extensions":["vtf"]},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana","extensions":["pcx"]},"image/webp":{"source":"apache","extensions":["webp"]},"image/wmf":{"source":"iana","extensions":["wmf"]},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana","extensions":["disposition-notification"]},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana","extensions":["u8msg"]},"message/global-delivery-status":{"source":"iana","extensions":["u8dsn"]},"message/global-disposition-notification":{"source":"iana","extensions":["u8mdn"]},"message/global-headers":{"source":"iana","extensions":["u8hdr"]},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/news":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime"]},"message/s-http":{"source":"iana"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"iana"},"message/vnd.wfa.wsc":{"source":"iana","extensions":["wsc"]},"model/3mf":{"source":"iana","extensions":["3mf"]},"model/e57":{"source":"iana"},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"source":"iana","compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/mtl":{"source":"iana","extensions":["mtl"]},"model/obj":{"source":"iana","extensions":["obj"]},"model/step":{"source":"iana"},"model/step+xml":{"source":"iana","compressible":true,"extensions":["stpx"]},"model/step+zip":{"source":"iana","compressible":false,"extensions":["stpz"]},"model/step-xml+zip":{"source":"iana","compressible":false,"extensions":["stpxz"]},"model/stl":{"source":"iana","extensions":["stl"]},"model/vnd.collada+xml":{"source":"iana","compressible":true,"extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana","compressible":true},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana","extensions":["ogex"]},"model/vnd.parasolid.transmit.binary":{"source":"iana","extensions":["x_b"]},"model/vnd.parasolid.transmit.text":{"source":"iana","extensions":["x_t"]},"model/vnd.pytha.pyox":{"source":"iana"},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.sap.vds":{"source":"iana","extensions":["vds"]},"model/vnd.usdz+zip":{"source":"iana","compressible":false,"extensions":["usdz"]},"model/vnd.valve.source.compiled-map":{"source":"iana","extensions":["bsp"]},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana","extensions":["x3db"]},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana","extensions":["x3dv"]},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana"},"multipart/multilingual":{"source":"iana"},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/cql":{"source":"iana"},"text/cql-expression":{"source":"iana"},"text/cql-identifier":{"source":"iana"},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"iana"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/fhirpath":{"source":"iana"},"text/flexfec":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/gff3":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","compressible":true},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"compressible":true,"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["markdown","md"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mdx":{"compressible":true,"extensions":["mdx"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana","charset":"UTF-8"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana","charset":"UTF-8"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/shaclc":{"source":"iana"},"text/shex":{"source":"iana","extensions":["shex"]},"text/slim":{"extensions":["slim","slm"]},"text/spdx":{"source":"iana","extensions":["spdx"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","charset":"UTF-8","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana","charset":"UTF-8"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana","charset":"UTF-8"},"text/vnd.familysearch.gedcom":{"source":"iana","extensions":["ged"]},"text/vnd.ficlab.flt":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.gml":{"source":"iana"},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.hans":{"source":"iana"},"text/vnd.hgl":{"source":"iana"},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.senx.warpscript":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"iana"},"text/vnd.sosi":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","charset":"UTF-8","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana","charset":"UTF-8"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vtt":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"compressible":true,"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/av1":{"source":"iana"},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/ffv1":{"source":"iana"},"video/flexfec":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/iso.segment":{"source":"iana","extensions":["m4s"]},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/jxsv":{"source":"iana"},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/scip":{"source":"iana"},"video/smpte291":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vc2":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.mp4vr":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"iana"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vnd.youtube.yt":{"source":"iana"},"video/vp8":{"source":"iana"},"video/vp9":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}');

});


parcelRegister("59kwG", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $3bfdb7183e8721d6$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $3bfdb7183e8721d6$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $3bfdb7183e8721d6$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $3bfdb7183e8721d6$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $hPtJY.cwd();
                path = cwd;
            }
            $3bfdb7183e8721d6$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $3bfdb7183e8721d6$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $3bfdb7183e8721d6$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $3bfdb7183e8721d6$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $3bfdb7183e8721d6$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $3bfdb7183e8721d6$var$assertPath(from);
        $3bfdb7183e8721d6$var$assertPath(to);
        if (from === to) return "";
        from = $3bfdb7183e8721d6$var$posix.resolve(from);
        to = $3bfdb7183e8721d6$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $3bfdb7183e8721d6$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $3bfdb7183e8721d6$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$3bfdb7183e8721d6$var$posix.posix = $3bfdb7183e8721d6$var$posix;
module.exports = $3bfdb7183e8721d6$var$posix;

});


parcelRegister("hS4Ss", function(module, exports) {

$parcel$export(module.exports, "FileItem", () => $1a2d89f6044444bf$export$a964e6adf466d4a6);

var $ayMG0 = parcelRequire("ayMG0");

var $isa9P = parcelRequire("isa9P");
const $1a2d89f6044444bf$export$a964e6adf466d4a6 = ({ file: file, onRemove: onRemove })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center justify-between p-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "body-s",
                    children: file.name
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $isa9P.default), {
                onClick: onRemove
            })
        ]
    });

});

parcelRegister("dVEPf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a24044586ed82795$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("cTZhp");
var $7YOG8 = parcelRequire("7YOG8");

var $eEukq = parcelRequire("eEukq");
var $a24044586ed82795$var$_excluded = [
    "children"
], $a24044586ed82795$var$_excluded2 = [
    "open"
], $a24044586ed82795$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $a24044586ed82795$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $a24044586ed82795$var$_toConsumableArray(arr) {
    return $a24044586ed82795$var$_arrayWithoutHoles(arr) || $a24044586ed82795$var$_iterableToArray(arr) || $a24044586ed82795$var$_unsupportedIterableToArray(arr) || $a24044586ed82795$var$_nonIterableSpread();
}
function $a24044586ed82795$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a24044586ed82795$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a24044586ed82795$var$_arrayLikeToArray(arr);
}
function $a24044586ed82795$var$_slicedToArray(arr, i) {
    return $a24044586ed82795$var$_arrayWithHoles(arr) || $a24044586ed82795$var$_iterableToArrayLimit(arr, i) || $a24044586ed82795$var$_unsupportedIterableToArray(arr, i) || $a24044586ed82795$var$_nonIterableRest();
}
function $a24044586ed82795$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
}
function $a24044586ed82795$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a24044586ed82795$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a24044586ed82795$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a24044586ed82795$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a24044586ed82795$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a24044586ed82795$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a24044586ed82795$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a24044586ed82795$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a24044586ed82795$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a24044586ed82795$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $a24044586ed82795$var$Dropzone = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $a24044586ed82795$var$_objectWithoutProperties(_ref, $a24044586ed82795$var$_excluded);
    var _useDropzone = $a24044586ed82795$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $a24044586ed82795$var$_objectWithoutProperties(_useDropzone, $a24044586ed82795$var$_excluded2);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, children($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$a24044586ed82795$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $a24044586ed82795$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $7YOG8.fromEvent),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: false,
    autoFocus: false
};
$a24044586ed82795$var$Dropzone.defaultProps = $a24044586ed82795$var$defaultProps;
$a24044586ed82795$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $a24044586ed82795$export$2e2bcd8739ae039 = $a24044586ed82795$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $a24044586ed82795$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
};
function $a24044586ed82795$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $acw62.useMemo)(function() {
        return (0, $eEukq.acceptPropAsAcceptAttr)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $acw62.useMemo)(function() {
        return (0, $eEukq.pickerOptionsFromAccept)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $a24044586ed82795$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $a24044586ed82795$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $acw62.useRef)(null);
    var inputRef = (0, $acw62.useRef)(null);
    var _useReducer = (0, $acw62.useReducer)($a24044586ed82795$var$reducer, $a24044586ed82795$var$initialState), _useReducer2 = $a24044586ed82795$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $acw62.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $eEukq.canUseFileSystemAccessAPI)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $acw62.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $acw62.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $acw62.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $eEukq.onDocumentDragOver), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $eEukq.onDocumentDragOver));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Auto focus the root when autoFocus is true
    (0, $acw62.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $acw62.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($a24044586ed82795$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $eEukq.isEvtWithFiles)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $eEukq.isPropagationStopped)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $eEukq.allFilesAccepted)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $eEukq.isEvtWithFiles)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $eEukq.isEvtWithFiles)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $acw62.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $eEukq.fileAccepted)(file, acceptAttr), _fileAccepted2 = $a24044586ed82795$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $eEukq.fileMatchSize)(file, minSize, maxSize), _fileMatchSize2 = $a24044586ed82795$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $eEukq.TOO_MANY_FILES_REJECTION)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            isDragReject: fileRejections.length > 0,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $eEukq.isEvtWithFiles)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $eEukq.isPropagationStopped)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $acw62.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $eEukq.isAbort)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $eEukq.isSecurityError)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $acw62.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $acw62.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $eEukq.isIeOrEdge)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref2, $a24044586ed82795$var$_excluded3);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $eEukq.composeEventHandlers)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $eEukq.composeEventHandlers)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $eEukq.composeEventHandlers)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $eEukq.composeEventHandlers)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $eEukq.composeEventHandlers)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $eEukq.composeEventHandlers)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $eEukq.composeEventHandlers)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $eEukq.composeEventHandlers)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $acw62.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref3, $a24044586ed82795$var$_excluded4);
            var inputProps = $a24044586ed82795$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    border: 0,
                    clip: "rect(0, 0, 0, 0)",
                    clipPath: "inset(50%)",
                    height: "1px",
                    margin: "0 -1px -1px 0",
                    overflow: "hidden",
                    padding: 0,
                    position: "absolute",
                    width: "1px",
                    whiteSpace: "nowrap"
                },
                onChange: composeHandler((0, $eEukq.composeEventHandlers)(onChange, onDropCb)),
                onClick: composeHandler((0, $eEukq.composeEventHandlers)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $a24044586ed82795$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections,
                isDragReject: action.isDragReject
            });
        case "reset":
            return $a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState);
        default:
            return state;
    }
}
function $a24044586ed82795$var$noop() {}

});
parcelRegister("cTZhp", function(module, exports) {

$parcel$export(module.exports, "fromEvent", () => (parcelRequire("7YOG8")).fromEvent);

var $7YOG8 = parcelRequire("7YOG8");

});
parcelRegister("7YOG8", function(module, exports) {

$parcel$export(module.exports, "fromEvent", () => $5cf572b3062ef12c$export$a36e16046ae8f1bb);

var $8yCCp = parcelRequire("8yCCp");

var $13eIt = parcelRequire("13eIt");
const $5cf572b3062ef12c$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    ".DS_Store",
    "Thumbs.db" // Windows
];
function $5cf572b3062ef12c$export$a36e16046ae8f1bb(evt) {
    return (0, $8yCCp.__awaiter)(this, void 0, void 0, function*() {
        if ($5cf572b3062ef12c$var$isObject(evt) && $5cf572b3062ef12c$var$isDataTransfer(evt.dataTransfer)) return $5cf572b3062ef12c$var$getDataTransferFiles(evt.dataTransfer, evt.type);
        else if ($5cf572b3062ef12c$var$isChangeEvt(evt)) return $5cf572b3062ef12c$var$getInputFiles(evt);
        else if (Array.isArray(evt) && evt.every((item)=>"getFile" in item && typeof item.getFile === "function")) return $5cf572b3062ef12c$var$getFsHandleFiles(evt);
        return [];
    });
}
function $5cf572b3062ef12c$var$isDataTransfer(value) {
    return $5cf572b3062ef12c$var$isObject(value);
}
function $5cf572b3062ef12c$var$isChangeEvt(value) {
    return $5cf572b3062ef12c$var$isObject(value) && $5cf572b3062ef12c$var$isObject(value.target);
}
function $5cf572b3062ef12c$var$isObject(v) {
    return typeof v === "object" && v !== null;
}
function $5cf572b3062ef12c$var$getInputFiles(evt) {
    return $5cf572b3062ef12c$var$fromList(evt.target.files).map((file)=>(0, $13eIt.toFileWithPath)(file));
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $5cf572b3062ef12c$var$getFsHandleFiles(handles) {
    return (0, $8yCCp.__awaiter)(this, void 0, void 0, function*() {
        const files = yield Promise.all(handles.map((h)=>h.getFile()));
        return files.map((file)=>(0, $13eIt.toFileWithPath)(file));
    });
}
function $5cf572b3062ef12c$var$getDataTransferFiles(dt, type) {
    return (0, $8yCCp.__awaiter)(this, void 0, void 0, function*() {
        // IE11 does not support dataTransfer.items
        // See https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/items#Browser_compatibility
        if (dt.items) {
            const items = $5cf572b3062ef12c$var$fromList(dt.items).filter((item)=>item.kind === "file");
            // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
            // only 'dragstart' and 'drop' has access to the data (source node)
            if (type !== "drop") return items;
            const files = yield Promise.all(items.map($5cf572b3062ef12c$var$toFilePromises));
            return $5cf572b3062ef12c$var$noIgnoredFiles($5cf572b3062ef12c$var$flatten(files));
        }
        return $5cf572b3062ef12c$var$noIgnoredFiles($5cf572b3062ef12c$var$fromList(dt.files).map((file)=>(0, $13eIt.toFileWithPath)(file)));
    });
}
function $5cf572b3062ef12c$var$noIgnoredFiles(files) {
    return files.filter((file)=>$5cf572b3062ef12c$var$FILES_TO_IGNORE.indexOf(file.name) === -1);
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $5cf572b3062ef12c$var$fromList(items) {
    if (items === null) return [];
    const files = [];
    // tslint:disable: prefer-for-of
    for(let i = 0; i < items.length; i++){
        const file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $5cf572b3062ef12c$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== "function") return $5cf572b3062ef12c$var$fromDataTransferItem(item);
    const entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $5cf572b3062ef12c$var$fromDirEntry(entry);
    return $5cf572b3062ef12c$var$fromDataTransferItem(item, entry);
}
function $5cf572b3062ef12c$var$flatten(items) {
    return items.reduce((acc, files)=>[
            ...acc,
            ...Array.isArray(files) ? $5cf572b3062ef12c$var$flatten(files) : [
                files
            ]
        ], []);
}
function $5cf572b3062ef12c$var$fromDataTransferItem(item, entry) {
    return (0, $8yCCp.__awaiter)(this, void 0, void 0, function*() {
        var _a;
        // Check if we're in a secure context; due to a bug in Chrome (as far as we know)
        // the browser crashes when calling this API (yet to be confirmed as a consistent behaviour).
        //
        // See:
        // - https://issues.chromium.org/issues/40186242
        // - https://github.com/react-dropzone/react-dropzone/issues/1397
        if (globalThis.isSecureContext && typeof item.getAsFileSystemHandle === "function") {
            const h = yield item.getAsFileSystemHandle();
            if (h === null) throw new Error(`${item} is not a File`);
            // It seems that the handle can be `undefined` (see https://github.com/react-dropzone/file-selector/issues/120),
            // so we check if it isn't; if it is, the code path continues to the next API (`getAsFile`).
            if (h !== undefined) {
                const file = yield h.getFile();
                file.handle = h;
                return (0, $13eIt.toFileWithPath)(file);
            }
        }
        const file = item.getAsFile();
        if (!file) throw new Error(`${item} is not a File`);
        const fwp = (0, $13eIt.toFileWithPath)(file, (_a = entry === null || entry === void 0 ? void 0 : entry.fullPath) !== null && _a !== void 0 ? _a : undefined);
        return fwp;
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $5cf572b3062ef12c$var$fromEntry(entry) {
    return (0, $8yCCp.__awaiter)(this, void 0, void 0, function*() {
        return entry.isDirectory ? $5cf572b3062ef12c$var$fromDirEntry(entry) : $5cf572b3062ef12c$var$fromFileEntry(entry);
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $5cf572b3062ef12c$var$fromDirEntry(entry) {
    const reader = entry.createReader();
    return new Promise((resolve, reject)=>{
        const entries = [];
        function readEntries() {
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries((batch)=>(0, $8yCCp.__awaiter)(this, void 0, void 0, function*() {
                    if (!batch.length) // Done reading directory
                    try {
                        const files = yield Promise.all(entries);
                        resolve(files);
                    } catch (err) {
                        reject(err);
                    }
                    else {
                        const items = Promise.all(batch.map($5cf572b3062ef12c$var$fromEntry));
                        entries.push(items);
                        // Continue reading
                        readEntries();
                    }
                }), (err)=>{
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $5cf572b3062ef12c$var$fromFileEntry(entry) {
    return (0, $8yCCp.__awaiter)(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            entry.file((file)=>{
                const fwp = (0, $13eIt.toFileWithPath)(file, entry.fullPath);
                resolve(fwp);
            }, (err)=>{
                reject(err);
            });
        });
    });
}

});
parcelRegister("8yCCp", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $63af748d0fde9ea7$export$1050f835b63b671e);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $63af748d0fde9ea7$var$extendStatics = function(d, b) {
    $63af748d0fde9ea7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $63af748d0fde9ea7$var$extendStatics(d, b);
};
function $63af748d0fde9ea7$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $63af748d0fde9ea7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $63af748d0fde9ea7$export$18ce0697a983be9b = function() {
    $63af748d0fde9ea7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $63af748d0fde9ea7$export$18ce0697a983be9b.apply(this, arguments);
};
function $63af748d0fde9ea7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $63af748d0fde9ea7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $63af748d0fde9ea7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $63af748d0fde9ea7$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $63af748d0fde9ea7$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $63af748d0fde9ea7$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $63af748d0fde9ea7$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $63af748d0fde9ea7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $63af748d0fde9ea7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $63af748d0fde9ea7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $63af748d0fde9ea7$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $63af748d0fde9ea7$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $63af748d0fde9ea7$export$45d3717a4c69092e(o, m, p);
}
function $63af748d0fde9ea7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $63af748d0fde9ea7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $63af748d0fde9ea7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($63af748d0fde9ea7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $63af748d0fde9ea7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $63af748d0fde9ea7$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $63af748d0fde9ea7$export$10c90e4f7922046c(v) {
    return this instanceof $63af748d0fde9ea7$export$10c90e4f7922046c ? (this.v = v, this) : new $63af748d0fde9ea7$export$10c90e4f7922046c(v);
}
function $63af748d0fde9ea7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $63af748d0fde9ea7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $63af748d0fde9ea7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $63af748d0fde9ea7$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $63af748d0fde9ea7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $63af748d0fde9ea7$export$19a8beecd37a4c45 === "function" ? $63af748d0fde9ea7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $63af748d0fde9ea7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $63af748d0fde9ea7$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $63af748d0fde9ea7$var$ownKeys = function(o) {
    $63af748d0fde9ea7$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $63af748d0fde9ea7$var$ownKeys(o);
};
function $63af748d0fde9ea7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $63af748d0fde9ea7$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $63af748d0fde9ea7$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $63af748d0fde9ea7$var$__setModuleDefault(result, mod);
    return result;
}
function $63af748d0fde9ea7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $63af748d0fde9ea7$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $63af748d0fde9ea7$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $63af748d0fde9ea7$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $63af748d0fde9ea7$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $63af748d0fde9ea7$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $63af748d0fde9ea7$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $63af748d0fde9ea7$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $63af748d0fde9ea7$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $63af748d0fde9ea7$export$2e2bcd8739ae039 = {
    __extends: $63af748d0fde9ea7$export$a8ba968b8961cb8a,
    __assign: $63af748d0fde9ea7$export$18ce0697a983be9b,
    __rest: $63af748d0fde9ea7$export$3c9a16f847548506,
    __decorate: $63af748d0fde9ea7$export$29e00dfd3077644b,
    __param: $63af748d0fde9ea7$export$d5ad3fd78186038f,
    __esDecorate: $63af748d0fde9ea7$export$3a84e1ae4e97e9b0,
    __runInitializers: $63af748d0fde9ea7$export$d831c04e792af3d,
    __propKey: $63af748d0fde9ea7$export$6a2a36740a146cb8,
    __setFunctionName: $63af748d0fde9ea7$export$d1a06452d3489bc7,
    __metadata: $63af748d0fde9ea7$export$f1db080c865becb9,
    __awaiter: $63af748d0fde9ea7$export$1050f835b63b671e,
    __generator: $63af748d0fde9ea7$export$67ebef60e6f28a6,
    __createBinding: $63af748d0fde9ea7$export$45d3717a4c69092e,
    __exportStar: $63af748d0fde9ea7$export$f33643c0debef087,
    __values: $63af748d0fde9ea7$export$19a8beecd37a4c45,
    __read: $63af748d0fde9ea7$export$8d051b38c9118094,
    __spread: $63af748d0fde9ea7$export$afc72e2116322959,
    __spreadArrays: $63af748d0fde9ea7$export$6388937ca91ccae8,
    __spreadArray: $63af748d0fde9ea7$export$1216008129fb82ed,
    __await: $63af748d0fde9ea7$export$10c90e4f7922046c,
    __asyncGenerator: $63af748d0fde9ea7$export$e427f37a30a4de9b,
    __asyncDelegator: $63af748d0fde9ea7$export$bbd80228419bb833,
    __asyncValues: $63af748d0fde9ea7$export$e3b29a3d6162315f,
    __makeTemplateObject: $63af748d0fde9ea7$export$4fb47efe1390b86f,
    __importStar: $63af748d0fde9ea7$export$c21735bcef00d192,
    __importDefault: $63af748d0fde9ea7$export$da59b14a69baef04,
    __classPrivateFieldGet: $63af748d0fde9ea7$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $63af748d0fde9ea7$export$d40a35129aaff81f,
    __classPrivateFieldIn: $63af748d0fde9ea7$export$81fdc39f203e4e04,
    __addDisposableResource: $63af748d0fde9ea7$export$88ac25d8e944e405,
    __disposeResources: $63af748d0fde9ea7$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $63af748d0fde9ea7$export$889dfb5d17574b0b
};

});

parcelRegister("13eIt", function(module, exports) {

$parcel$export(module.exports, "toFileWithPath", () => $0c417c97818a47bb$export$8cc09085015f0dc7);
const $0c417c97818a47bb$export$db0345794bfc14ed = new Map([
    // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
    [
        "1km",
        "application/vnd.1000minds.decision-model+xml"
    ],
    [
        "3dml",
        "text/vnd.in3d.3dml"
    ],
    [
        "3ds",
        "image/x-3ds"
    ],
    [
        "3g2",
        "video/3gpp2"
    ],
    [
        "3gp",
        "video/3gp"
    ],
    [
        "3gpp",
        "video/3gpp"
    ],
    [
        "3mf",
        "model/3mf"
    ],
    [
        "7z",
        "application/x-7z-compressed"
    ],
    [
        "7zip",
        "application/x-7z-compressed"
    ],
    [
        "123",
        "application/vnd.lotus-1-2-3"
    ],
    [
        "aab",
        "application/x-authorware-bin"
    ],
    [
        "aac",
        "audio/x-acc"
    ],
    [
        "aam",
        "application/x-authorware-map"
    ],
    [
        "aas",
        "application/x-authorware-seg"
    ],
    [
        "abw",
        "application/x-abiword"
    ],
    [
        "ac",
        "application/vnd.nokia.n-gage.ac+xml"
    ],
    [
        "ac3",
        "audio/ac3"
    ],
    [
        "acc",
        "application/vnd.americandynamics.acc"
    ],
    [
        "ace",
        "application/x-ace-compressed"
    ],
    [
        "acu",
        "application/vnd.acucobol"
    ],
    [
        "acutc",
        "application/vnd.acucorp"
    ],
    [
        "adp",
        "audio/adpcm"
    ],
    [
        "aep",
        "application/vnd.audiograph"
    ],
    [
        "afm",
        "application/x-font-type1"
    ],
    [
        "afp",
        "application/vnd.ibm.modcap"
    ],
    [
        "ahead",
        "application/vnd.ahead.space"
    ],
    [
        "ai",
        "application/pdf"
    ],
    [
        "aif",
        "audio/x-aiff"
    ],
    [
        "aifc",
        "audio/x-aiff"
    ],
    [
        "aiff",
        "audio/x-aiff"
    ],
    [
        "air",
        "application/vnd.adobe.air-application-installer-package+zip"
    ],
    [
        "ait",
        "application/vnd.dvb.ait"
    ],
    [
        "ami",
        "application/vnd.amiga.ami"
    ],
    [
        "amr",
        "audio/amr"
    ],
    [
        "apk",
        "application/vnd.android.package-archive"
    ],
    [
        "apng",
        "image/apng"
    ],
    [
        "appcache",
        "text/cache-manifest"
    ],
    [
        "application",
        "application/x-ms-application"
    ],
    [
        "apr",
        "application/vnd.lotus-approach"
    ],
    [
        "arc",
        "application/x-freearc"
    ],
    [
        "arj",
        "application/x-arj"
    ],
    [
        "asc",
        "application/pgp-signature"
    ],
    [
        "asf",
        "video/x-ms-asf"
    ],
    [
        "asm",
        "text/x-asm"
    ],
    [
        "aso",
        "application/vnd.accpac.simply.aso"
    ],
    [
        "asx",
        "video/x-ms-asf"
    ],
    [
        "atc",
        "application/vnd.acucorp"
    ],
    [
        "atom",
        "application/atom+xml"
    ],
    [
        "atomcat",
        "application/atomcat+xml"
    ],
    [
        "atomdeleted",
        "application/atomdeleted+xml"
    ],
    [
        "atomsvc",
        "application/atomsvc+xml"
    ],
    [
        "atx",
        "application/vnd.antix.game-component"
    ],
    [
        "au",
        "audio/x-au"
    ],
    [
        "avi",
        "video/x-msvideo"
    ],
    [
        "avif",
        "image/avif"
    ],
    [
        "aw",
        "application/applixware"
    ],
    [
        "azf",
        "application/vnd.airzip.filesecure.azf"
    ],
    [
        "azs",
        "application/vnd.airzip.filesecure.azs"
    ],
    [
        "azv",
        "image/vnd.airzip.accelerator.azv"
    ],
    [
        "azw",
        "application/vnd.amazon.ebook"
    ],
    [
        "b16",
        "image/vnd.pco.b16"
    ],
    [
        "bat",
        "application/x-msdownload"
    ],
    [
        "bcpio",
        "application/x-bcpio"
    ],
    [
        "bdf",
        "application/x-font-bdf"
    ],
    [
        "bdm",
        "application/vnd.syncml.dm+wbxml"
    ],
    [
        "bdoc",
        "application/x-bdoc"
    ],
    [
        "bed",
        "application/vnd.realvnc.bed"
    ],
    [
        "bh2",
        "application/vnd.fujitsu.oasysprs"
    ],
    [
        "bin",
        "application/octet-stream"
    ],
    [
        "blb",
        "application/x-blorb"
    ],
    [
        "blorb",
        "application/x-blorb"
    ],
    [
        "bmi",
        "application/vnd.bmi"
    ],
    [
        "bmml",
        "application/vnd.balsamiq.bmml+xml"
    ],
    [
        "bmp",
        "image/bmp"
    ],
    [
        "book",
        "application/vnd.framemaker"
    ],
    [
        "box",
        "application/vnd.previewsystems.box"
    ],
    [
        "boz",
        "application/x-bzip2"
    ],
    [
        "bpk",
        "application/octet-stream"
    ],
    [
        "bpmn",
        "application/octet-stream"
    ],
    [
        "bsp",
        "model/vnd.valve.source.compiled-map"
    ],
    [
        "btif",
        "image/prs.btif"
    ],
    [
        "buffer",
        "application/octet-stream"
    ],
    [
        "bz",
        "application/x-bzip"
    ],
    [
        "bz2",
        "application/x-bzip2"
    ],
    [
        "c",
        "text/x-c"
    ],
    [
        "c4d",
        "application/vnd.clonk.c4group"
    ],
    [
        "c4f",
        "application/vnd.clonk.c4group"
    ],
    [
        "c4g",
        "application/vnd.clonk.c4group"
    ],
    [
        "c4p",
        "application/vnd.clonk.c4group"
    ],
    [
        "c4u",
        "application/vnd.clonk.c4group"
    ],
    [
        "c11amc",
        "application/vnd.cluetrust.cartomobile-config"
    ],
    [
        "c11amz",
        "application/vnd.cluetrust.cartomobile-config-pkg"
    ],
    [
        "cab",
        "application/vnd.ms-cab-compressed"
    ],
    [
        "caf",
        "audio/x-caf"
    ],
    [
        "cap",
        "application/vnd.tcpdump.pcap"
    ],
    [
        "car",
        "application/vnd.curl.car"
    ],
    [
        "cat",
        "application/vnd.ms-pki.seccat"
    ],
    [
        "cb7",
        "application/x-cbr"
    ],
    [
        "cba",
        "application/x-cbr"
    ],
    [
        "cbr",
        "application/x-cbr"
    ],
    [
        "cbt",
        "application/x-cbr"
    ],
    [
        "cbz",
        "application/x-cbr"
    ],
    [
        "cc",
        "text/x-c"
    ],
    [
        "cco",
        "application/x-cocoa"
    ],
    [
        "cct",
        "application/x-director"
    ],
    [
        "ccxml",
        "application/ccxml+xml"
    ],
    [
        "cdbcmsg",
        "application/vnd.contact.cmsg"
    ],
    [
        "cda",
        "application/x-cdf"
    ],
    [
        "cdf",
        "application/x-netcdf"
    ],
    [
        "cdfx",
        "application/cdfx+xml"
    ],
    [
        "cdkey",
        "application/vnd.mediastation.cdkey"
    ],
    [
        "cdmia",
        "application/cdmi-capability"
    ],
    [
        "cdmic",
        "application/cdmi-container"
    ],
    [
        "cdmid",
        "application/cdmi-domain"
    ],
    [
        "cdmio",
        "application/cdmi-object"
    ],
    [
        "cdmiq",
        "application/cdmi-queue"
    ],
    [
        "cdr",
        "application/cdr"
    ],
    [
        "cdx",
        "chemical/x-cdx"
    ],
    [
        "cdxml",
        "application/vnd.chemdraw+xml"
    ],
    [
        "cdy",
        "application/vnd.cinderella"
    ],
    [
        "cer",
        "application/pkix-cert"
    ],
    [
        "cfs",
        "application/x-cfs-compressed"
    ],
    [
        "cgm",
        "image/cgm"
    ],
    [
        "chat",
        "application/x-chat"
    ],
    [
        "chm",
        "application/vnd.ms-htmlhelp"
    ],
    [
        "chrt",
        "application/vnd.kde.kchart"
    ],
    [
        "cif",
        "chemical/x-cif"
    ],
    [
        "cii",
        "application/vnd.anser-web-certificate-issue-initiation"
    ],
    [
        "cil",
        "application/vnd.ms-artgalry"
    ],
    [
        "cjs",
        "application/node"
    ],
    [
        "cla",
        "application/vnd.claymore"
    ],
    [
        "class",
        "application/octet-stream"
    ],
    [
        "clkk",
        "application/vnd.crick.clicker.keyboard"
    ],
    [
        "clkp",
        "application/vnd.crick.clicker.palette"
    ],
    [
        "clkt",
        "application/vnd.crick.clicker.template"
    ],
    [
        "clkw",
        "application/vnd.crick.clicker.wordbank"
    ],
    [
        "clkx",
        "application/vnd.crick.clicker"
    ],
    [
        "clp",
        "application/x-msclip"
    ],
    [
        "cmc",
        "application/vnd.cosmocaller"
    ],
    [
        "cmdf",
        "chemical/x-cmdf"
    ],
    [
        "cml",
        "chemical/x-cml"
    ],
    [
        "cmp",
        "application/vnd.yellowriver-custom-menu"
    ],
    [
        "cmx",
        "image/x-cmx"
    ],
    [
        "cod",
        "application/vnd.rim.cod"
    ],
    [
        "coffee",
        "text/coffeescript"
    ],
    [
        "com",
        "application/x-msdownload"
    ],
    [
        "conf",
        "text/plain"
    ],
    [
        "cpio",
        "application/x-cpio"
    ],
    [
        "cpp",
        "text/x-c"
    ],
    [
        "cpt",
        "application/mac-compactpro"
    ],
    [
        "crd",
        "application/x-mscardfile"
    ],
    [
        "crl",
        "application/pkix-crl"
    ],
    [
        "crt",
        "application/x-x509-ca-cert"
    ],
    [
        "crx",
        "application/x-chrome-extension"
    ],
    [
        "cryptonote",
        "application/vnd.rig.cryptonote"
    ],
    [
        "csh",
        "application/x-csh"
    ],
    [
        "csl",
        "application/vnd.citationstyles.style+xml"
    ],
    [
        "csml",
        "chemical/x-csml"
    ],
    [
        "csp",
        "application/vnd.commonspace"
    ],
    [
        "csr",
        "application/octet-stream"
    ],
    [
        "css",
        "text/css"
    ],
    [
        "cst",
        "application/x-director"
    ],
    [
        "csv",
        "text/csv"
    ],
    [
        "cu",
        "application/cu-seeme"
    ],
    [
        "curl",
        "text/vnd.curl"
    ],
    [
        "cww",
        "application/prs.cww"
    ],
    [
        "cxt",
        "application/x-director"
    ],
    [
        "cxx",
        "text/x-c"
    ],
    [
        "dae",
        "model/vnd.collada+xml"
    ],
    [
        "daf",
        "application/vnd.mobius.daf"
    ],
    [
        "dart",
        "application/vnd.dart"
    ],
    [
        "dataless",
        "application/vnd.fdsn.seed"
    ],
    [
        "davmount",
        "application/davmount+xml"
    ],
    [
        "dbf",
        "application/vnd.dbf"
    ],
    [
        "dbk",
        "application/docbook+xml"
    ],
    [
        "dcr",
        "application/x-director"
    ],
    [
        "dcurl",
        "text/vnd.curl.dcurl"
    ],
    [
        "dd2",
        "application/vnd.oma.dd2+xml"
    ],
    [
        "ddd",
        "application/vnd.fujixerox.ddd"
    ],
    [
        "ddf",
        "application/vnd.syncml.dmddf+xml"
    ],
    [
        "dds",
        "image/vnd.ms-dds"
    ],
    [
        "deb",
        "application/x-debian-package"
    ],
    [
        "def",
        "text/plain"
    ],
    [
        "deploy",
        "application/octet-stream"
    ],
    [
        "der",
        "application/x-x509-ca-cert"
    ],
    [
        "dfac",
        "application/vnd.dreamfactory"
    ],
    [
        "dgc",
        "application/x-dgc-compressed"
    ],
    [
        "dic",
        "text/x-c"
    ],
    [
        "dir",
        "application/x-director"
    ],
    [
        "dis",
        "application/vnd.mobius.dis"
    ],
    [
        "disposition-notification",
        "message/disposition-notification"
    ],
    [
        "dist",
        "application/octet-stream"
    ],
    [
        "distz",
        "application/octet-stream"
    ],
    [
        "djv",
        "image/vnd.djvu"
    ],
    [
        "djvu",
        "image/vnd.djvu"
    ],
    [
        "dll",
        "application/octet-stream"
    ],
    [
        "dmg",
        "application/x-apple-diskimage"
    ],
    [
        "dmn",
        "application/octet-stream"
    ],
    [
        "dmp",
        "application/vnd.tcpdump.pcap"
    ],
    [
        "dms",
        "application/octet-stream"
    ],
    [
        "dna",
        "application/vnd.dna"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docm",
        "application/vnd.ms-word.template.macroEnabled.12"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    [
        "dot",
        "application/msword"
    ],
    [
        "dotm",
        "application/vnd.ms-word.template.macroEnabled.12"
    ],
    [
        "dotx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.template"
    ],
    [
        "dp",
        "application/vnd.osgi.dp"
    ],
    [
        "dpg",
        "application/vnd.dpgraph"
    ],
    [
        "dra",
        "audio/vnd.dra"
    ],
    [
        "drle",
        "image/dicom-rle"
    ],
    [
        "dsc",
        "text/prs.lines.tag"
    ],
    [
        "dssc",
        "application/dssc+der"
    ],
    [
        "dtb",
        "application/x-dtbook+xml"
    ],
    [
        "dtd",
        "application/xml-dtd"
    ],
    [
        "dts",
        "audio/vnd.dts"
    ],
    [
        "dtshd",
        "audio/vnd.dts.hd"
    ],
    [
        "dump",
        "application/octet-stream"
    ],
    [
        "dvb",
        "video/vnd.dvb.file"
    ],
    [
        "dvi",
        "application/x-dvi"
    ],
    [
        "dwd",
        "application/atsc-dwd+xml"
    ],
    [
        "dwf",
        "model/vnd.dwf"
    ],
    [
        "dwg",
        "image/vnd.dwg"
    ],
    [
        "dxf",
        "image/vnd.dxf"
    ],
    [
        "dxp",
        "application/vnd.spotfire.dxp"
    ],
    [
        "dxr",
        "application/x-director"
    ],
    [
        "ear",
        "application/java-archive"
    ],
    [
        "ecelp4800",
        "audio/vnd.nuera.ecelp4800"
    ],
    [
        "ecelp7470",
        "audio/vnd.nuera.ecelp7470"
    ],
    [
        "ecelp9600",
        "audio/vnd.nuera.ecelp9600"
    ],
    [
        "ecma",
        "application/ecmascript"
    ],
    [
        "edm",
        "application/vnd.novadigm.edm"
    ],
    [
        "edx",
        "application/vnd.novadigm.edx"
    ],
    [
        "efif",
        "application/vnd.picsel"
    ],
    [
        "ei6",
        "application/vnd.pg.osasli"
    ],
    [
        "elc",
        "application/octet-stream"
    ],
    [
        "emf",
        "image/emf"
    ],
    [
        "eml",
        "message/rfc822"
    ],
    [
        "emma",
        "application/emma+xml"
    ],
    [
        "emotionml",
        "application/emotionml+xml"
    ],
    [
        "emz",
        "application/x-msmetafile"
    ],
    [
        "eol",
        "audio/vnd.digital-winds"
    ],
    [
        "eot",
        "application/vnd.ms-fontobject"
    ],
    [
        "eps",
        "application/postscript"
    ],
    [
        "epub",
        "application/epub+zip"
    ],
    [
        "es",
        "application/ecmascript"
    ],
    [
        "es3",
        "application/vnd.eszigno3+xml"
    ],
    [
        "esa",
        "application/vnd.osgi.subsystem"
    ],
    [
        "esf",
        "application/vnd.epson.esf"
    ],
    [
        "et3",
        "application/vnd.eszigno3+xml"
    ],
    [
        "etx",
        "text/x-setext"
    ],
    [
        "eva",
        "application/x-eva"
    ],
    [
        "evy",
        "application/x-envoy"
    ],
    [
        "exe",
        "application/octet-stream"
    ],
    [
        "exi",
        "application/exi"
    ],
    [
        "exp",
        "application/express"
    ],
    [
        "exr",
        "image/aces"
    ],
    [
        "ext",
        "application/vnd.novadigm.ext"
    ],
    [
        "ez",
        "application/andrew-inset"
    ],
    [
        "ez2",
        "application/vnd.ezpix-album"
    ],
    [
        "ez3",
        "application/vnd.ezpix-package"
    ],
    [
        "f",
        "text/x-fortran"
    ],
    [
        "f4v",
        "video/mp4"
    ],
    [
        "f77",
        "text/x-fortran"
    ],
    [
        "f90",
        "text/x-fortran"
    ],
    [
        "fbs",
        "image/vnd.fastbidsheet"
    ],
    [
        "fcdt",
        "application/vnd.adobe.formscentral.fcdt"
    ],
    [
        "fcs",
        "application/vnd.isac.fcs"
    ],
    [
        "fdf",
        "application/vnd.fdf"
    ],
    [
        "fdt",
        "application/fdt+xml"
    ],
    [
        "fe_launch",
        "application/vnd.denovo.fcselayout-link"
    ],
    [
        "fg5",
        "application/vnd.fujitsu.oasysgp"
    ],
    [
        "fgd",
        "application/x-director"
    ],
    [
        "fh",
        "image/x-freehand"
    ],
    [
        "fh4",
        "image/x-freehand"
    ],
    [
        "fh5",
        "image/x-freehand"
    ],
    [
        "fh7",
        "image/x-freehand"
    ],
    [
        "fhc",
        "image/x-freehand"
    ],
    [
        "fig",
        "application/x-xfig"
    ],
    [
        "fits",
        "image/fits"
    ],
    [
        "flac",
        "audio/x-flac"
    ],
    [
        "fli",
        "video/x-fli"
    ],
    [
        "flo",
        "application/vnd.micrografx.flo"
    ],
    [
        "flv",
        "video/x-flv"
    ],
    [
        "flw",
        "application/vnd.kde.kivio"
    ],
    [
        "flx",
        "text/vnd.fmi.flexstor"
    ],
    [
        "fly",
        "text/vnd.fly"
    ],
    [
        "fm",
        "application/vnd.framemaker"
    ],
    [
        "fnc",
        "application/vnd.frogans.fnc"
    ],
    [
        "fo",
        "application/vnd.software602.filler.form+xml"
    ],
    [
        "for",
        "text/x-fortran"
    ],
    [
        "fpx",
        "image/vnd.fpx"
    ],
    [
        "frame",
        "application/vnd.framemaker"
    ],
    [
        "fsc",
        "application/vnd.fsc.weblaunch"
    ],
    [
        "fst",
        "image/vnd.fst"
    ],
    [
        "ftc",
        "application/vnd.fluxtime.clip"
    ],
    [
        "fti",
        "application/vnd.anser-web-funds-transfer-initiation"
    ],
    [
        "fvt",
        "video/vnd.fvt"
    ],
    [
        "fxp",
        "application/vnd.adobe.fxp"
    ],
    [
        "fxpl",
        "application/vnd.adobe.fxp"
    ],
    [
        "fzs",
        "application/vnd.fuzzysheet"
    ],
    [
        "g2w",
        "application/vnd.geoplan"
    ],
    [
        "g3",
        "image/g3fax"
    ],
    [
        "g3w",
        "application/vnd.geospace"
    ],
    [
        "gac",
        "application/vnd.groove-account"
    ],
    [
        "gam",
        "application/x-tads"
    ],
    [
        "gbr",
        "application/rpki-ghostbusters"
    ],
    [
        "gca",
        "application/x-gca-compressed"
    ],
    [
        "gdl",
        "model/vnd.gdl"
    ],
    [
        "gdoc",
        "application/vnd.google-apps.document"
    ],
    [
        "geo",
        "application/vnd.dynageo"
    ],
    [
        "geojson",
        "application/geo+json"
    ],
    [
        "gex",
        "application/vnd.geometry-explorer"
    ],
    [
        "ggb",
        "application/vnd.geogebra.file"
    ],
    [
        "ggt",
        "application/vnd.geogebra.tool"
    ],
    [
        "ghf",
        "application/vnd.groove-help"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "gim",
        "application/vnd.groove-identity-message"
    ],
    [
        "glb",
        "model/gltf-binary"
    ],
    [
        "gltf",
        "model/gltf+json"
    ],
    [
        "gml",
        "application/gml+xml"
    ],
    [
        "gmx",
        "application/vnd.gmx"
    ],
    [
        "gnumeric",
        "application/x-gnumeric"
    ],
    [
        "gpg",
        "application/gpg-keys"
    ],
    [
        "gph",
        "application/vnd.flographit"
    ],
    [
        "gpx",
        "application/gpx+xml"
    ],
    [
        "gqf",
        "application/vnd.grafeq"
    ],
    [
        "gqs",
        "application/vnd.grafeq"
    ],
    [
        "gram",
        "application/srgs"
    ],
    [
        "gramps",
        "application/x-gramps-xml"
    ],
    [
        "gre",
        "application/vnd.geometry-explorer"
    ],
    [
        "grv",
        "application/vnd.groove-injector"
    ],
    [
        "grxml",
        "application/srgs+xml"
    ],
    [
        "gsf",
        "application/x-font-ghostscript"
    ],
    [
        "gsheet",
        "application/vnd.google-apps.spreadsheet"
    ],
    [
        "gslides",
        "application/vnd.google-apps.presentation"
    ],
    [
        "gtar",
        "application/x-gtar"
    ],
    [
        "gtm",
        "application/vnd.groove-tool-message"
    ],
    [
        "gtw",
        "model/vnd.gtw"
    ],
    [
        "gv",
        "text/vnd.graphviz"
    ],
    [
        "gxf",
        "application/gxf"
    ],
    [
        "gxt",
        "application/vnd.geonext"
    ],
    [
        "gz",
        "application/gzip"
    ],
    [
        "gzip",
        "application/gzip"
    ],
    [
        "h",
        "text/x-c"
    ],
    [
        "h261",
        "video/h261"
    ],
    [
        "h263",
        "video/h263"
    ],
    [
        "h264",
        "video/h264"
    ],
    [
        "hal",
        "application/vnd.hal+xml"
    ],
    [
        "hbci",
        "application/vnd.hbci"
    ],
    [
        "hbs",
        "text/x-handlebars-template"
    ],
    [
        "hdd",
        "application/x-virtualbox-hdd"
    ],
    [
        "hdf",
        "application/x-hdf"
    ],
    [
        "heic",
        "image/heic"
    ],
    [
        "heics",
        "image/heic-sequence"
    ],
    [
        "heif",
        "image/heif"
    ],
    [
        "heifs",
        "image/heif-sequence"
    ],
    [
        "hej2",
        "image/hej2k"
    ],
    [
        "held",
        "application/atsc-held+xml"
    ],
    [
        "hh",
        "text/x-c"
    ],
    [
        "hjson",
        "application/hjson"
    ],
    [
        "hlp",
        "application/winhlp"
    ],
    [
        "hpgl",
        "application/vnd.hp-hpgl"
    ],
    [
        "hpid",
        "application/vnd.hp-hpid"
    ],
    [
        "hps",
        "application/vnd.hp-hps"
    ],
    [
        "hqx",
        "application/mac-binhex40"
    ],
    [
        "hsj2",
        "image/hsj2"
    ],
    [
        "htc",
        "text/x-component"
    ],
    [
        "htke",
        "application/vnd.kenameaapp"
    ],
    [
        "htm",
        "text/html"
    ],
    [
        "html",
        "text/html"
    ],
    [
        "hvd",
        "application/vnd.yamaha.hv-dic"
    ],
    [
        "hvp",
        "application/vnd.yamaha.hv-voice"
    ],
    [
        "hvs",
        "application/vnd.yamaha.hv-script"
    ],
    [
        "i2g",
        "application/vnd.intergeo"
    ],
    [
        "icc",
        "application/vnd.iccprofile"
    ],
    [
        "ice",
        "x-conference/x-cooltalk"
    ],
    [
        "icm",
        "application/vnd.iccprofile"
    ],
    [
        "ico",
        "image/x-icon"
    ],
    [
        "ics",
        "text/calendar"
    ],
    [
        "ief",
        "image/ief"
    ],
    [
        "ifb",
        "text/calendar"
    ],
    [
        "ifm",
        "application/vnd.shana.informed.formdata"
    ],
    [
        "iges",
        "model/iges"
    ],
    [
        "igl",
        "application/vnd.igloader"
    ],
    [
        "igm",
        "application/vnd.insors.igm"
    ],
    [
        "igs",
        "model/iges"
    ],
    [
        "igx",
        "application/vnd.micrografx.igx"
    ],
    [
        "iif",
        "application/vnd.shana.informed.interchange"
    ],
    [
        "img",
        "application/octet-stream"
    ],
    [
        "imp",
        "application/vnd.accpac.simply.imp"
    ],
    [
        "ims",
        "application/vnd.ms-ims"
    ],
    [
        "in",
        "text/plain"
    ],
    [
        "ini",
        "text/plain"
    ],
    [
        "ink",
        "application/inkml+xml"
    ],
    [
        "inkml",
        "application/inkml+xml"
    ],
    [
        "install",
        "application/x-install-instructions"
    ],
    [
        "iota",
        "application/vnd.astraea-software.iota"
    ],
    [
        "ipfix",
        "application/ipfix"
    ],
    [
        "ipk",
        "application/vnd.shana.informed.package"
    ],
    [
        "irm",
        "application/vnd.ibm.rights-management"
    ],
    [
        "irp",
        "application/vnd.irepository.package+xml"
    ],
    [
        "iso",
        "application/x-iso9660-image"
    ],
    [
        "itp",
        "application/vnd.shana.informed.formtemplate"
    ],
    [
        "its",
        "application/its+xml"
    ],
    [
        "ivp",
        "application/vnd.immervision-ivp"
    ],
    [
        "ivu",
        "application/vnd.immervision-ivu"
    ],
    [
        "jad",
        "text/vnd.sun.j2me.app-descriptor"
    ],
    [
        "jade",
        "text/jade"
    ],
    [
        "jam",
        "application/vnd.jam"
    ],
    [
        "jar",
        "application/java-archive"
    ],
    [
        "jardiff",
        "application/x-java-archive-diff"
    ],
    [
        "java",
        "text/x-java-source"
    ],
    [
        "jhc",
        "image/jphc"
    ],
    [
        "jisp",
        "application/vnd.jisp"
    ],
    [
        "jls",
        "image/jls"
    ],
    [
        "jlt",
        "application/vnd.hp-jlyt"
    ],
    [
        "jng",
        "image/x-jng"
    ],
    [
        "jnlp",
        "application/x-java-jnlp-file"
    ],
    [
        "joda",
        "application/vnd.joost.joda-archive"
    ],
    [
        "jp2",
        "image/jp2"
    ],
    [
        "jpe",
        "image/jpeg"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpf",
        "image/jpx"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "jpg2",
        "image/jp2"
    ],
    [
        "jpgm",
        "video/jpm"
    ],
    [
        "jpgv",
        "video/jpeg"
    ],
    [
        "jph",
        "image/jph"
    ],
    [
        "jpm",
        "video/jpm"
    ],
    [
        "jpx",
        "image/jpx"
    ],
    [
        "js",
        "application/javascript"
    ],
    [
        "json",
        "application/json"
    ],
    [
        "json5",
        "application/json5"
    ],
    [
        "jsonld",
        "application/ld+json"
    ],
    // https://jsonlines.org/
    [
        "jsonl",
        "application/jsonl"
    ],
    [
        "jsonml",
        "application/jsonml+json"
    ],
    [
        "jsx",
        "text/jsx"
    ],
    [
        "jxr",
        "image/jxr"
    ],
    [
        "jxra",
        "image/jxra"
    ],
    [
        "jxrs",
        "image/jxrs"
    ],
    [
        "jxs",
        "image/jxs"
    ],
    [
        "jxsc",
        "image/jxsc"
    ],
    [
        "jxsi",
        "image/jxsi"
    ],
    [
        "jxss",
        "image/jxss"
    ],
    [
        "kar",
        "audio/midi"
    ],
    [
        "karbon",
        "application/vnd.kde.karbon"
    ],
    [
        "kdb",
        "application/octet-stream"
    ],
    [
        "kdbx",
        "application/x-keepass2"
    ],
    [
        "key",
        "application/x-iwork-keynote-sffkey"
    ],
    [
        "kfo",
        "application/vnd.kde.kformula"
    ],
    [
        "kia",
        "application/vnd.kidspiration"
    ],
    [
        "kml",
        "application/vnd.google-earth.kml+xml"
    ],
    [
        "kmz",
        "application/vnd.google-earth.kmz"
    ],
    [
        "kne",
        "application/vnd.kinar"
    ],
    [
        "knp",
        "application/vnd.kinar"
    ],
    [
        "kon",
        "application/vnd.kde.kontour"
    ],
    [
        "kpr",
        "application/vnd.kde.kpresenter"
    ],
    [
        "kpt",
        "application/vnd.kde.kpresenter"
    ],
    [
        "kpxx",
        "application/vnd.ds-keypoint"
    ],
    [
        "ksp",
        "application/vnd.kde.kspread"
    ],
    [
        "ktr",
        "application/vnd.kahootz"
    ],
    [
        "ktx",
        "image/ktx"
    ],
    [
        "ktx2",
        "image/ktx2"
    ],
    [
        "ktz",
        "application/vnd.kahootz"
    ],
    [
        "kwd",
        "application/vnd.kde.kword"
    ],
    [
        "kwt",
        "application/vnd.kde.kword"
    ],
    [
        "lasxml",
        "application/vnd.las.las+xml"
    ],
    [
        "latex",
        "application/x-latex"
    ],
    [
        "lbd",
        "application/vnd.llamagraphics.life-balance.desktop"
    ],
    [
        "lbe",
        "application/vnd.llamagraphics.life-balance.exchange+xml"
    ],
    [
        "les",
        "application/vnd.hhe.lesson-player"
    ],
    [
        "less",
        "text/less"
    ],
    [
        "lgr",
        "application/lgr+xml"
    ],
    [
        "lha",
        "application/octet-stream"
    ],
    [
        "link66",
        "application/vnd.route66.link66+xml"
    ],
    [
        "list",
        "text/plain"
    ],
    [
        "list3820",
        "application/vnd.ibm.modcap"
    ],
    [
        "listafp",
        "application/vnd.ibm.modcap"
    ],
    [
        "litcoffee",
        "text/coffeescript"
    ],
    [
        "lnk",
        "application/x-ms-shortcut"
    ],
    [
        "log",
        "text/plain"
    ],
    [
        "lostxml",
        "application/lost+xml"
    ],
    [
        "lrf",
        "application/octet-stream"
    ],
    [
        "lrm",
        "application/vnd.ms-lrm"
    ],
    [
        "ltf",
        "application/vnd.frogans.ltf"
    ],
    [
        "lua",
        "text/x-lua"
    ],
    [
        "luac",
        "application/x-lua-bytecode"
    ],
    [
        "lvp",
        "audio/vnd.lucent.voice"
    ],
    [
        "lwp",
        "application/vnd.lotus-wordpro"
    ],
    [
        "lzh",
        "application/octet-stream"
    ],
    [
        "m1v",
        "video/mpeg"
    ],
    [
        "m2a",
        "audio/mpeg"
    ],
    [
        "m2v",
        "video/mpeg"
    ],
    [
        "m3a",
        "audio/mpeg"
    ],
    [
        "m3u",
        "text/plain"
    ],
    [
        "m3u8",
        "application/vnd.apple.mpegurl"
    ],
    [
        "m4a",
        "audio/x-m4a"
    ],
    [
        "m4p",
        "application/mp4"
    ],
    [
        "m4s",
        "video/iso.segment"
    ],
    [
        "m4u",
        "application/vnd.mpegurl"
    ],
    [
        "m4v",
        "video/x-m4v"
    ],
    [
        "m13",
        "application/x-msmediaview"
    ],
    [
        "m14",
        "application/x-msmediaview"
    ],
    [
        "m21",
        "application/mp21"
    ],
    [
        "ma",
        "application/mathematica"
    ],
    [
        "mads",
        "application/mads+xml"
    ],
    [
        "maei",
        "application/mmt-aei+xml"
    ],
    [
        "mag",
        "application/vnd.ecowin.chart"
    ],
    [
        "maker",
        "application/vnd.framemaker"
    ],
    [
        "man",
        "text/troff"
    ],
    [
        "manifest",
        "text/cache-manifest"
    ],
    [
        "map",
        "application/json"
    ],
    [
        "mar",
        "application/octet-stream"
    ],
    [
        "markdown",
        "text/markdown"
    ],
    [
        "mathml",
        "application/mathml+xml"
    ],
    [
        "mb",
        "application/mathematica"
    ],
    [
        "mbk",
        "application/vnd.mobius.mbk"
    ],
    [
        "mbox",
        "application/mbox"
    ],
    [
        "mc1",
        "application/vnd.medcalcdata"
    ],
    [
        "mcd",
        "application/vnd.mcd"
    ],
    [
        "mcurl",
        "text/vnd.curl.mcurl"
    ],
    [
        "md",
        "text/markdown"
    ],
    [
        "mdb",
        "application/x-msaccess"
    ],
    [
        "mdi",
        "image/vnd.ms-modi"
    ],
    [
        "mdx",
        "text/mdx"
    ],
    [
        "me",
        "text/troff"
    ],
    [
        "mesh",
        "model/mesh"
    ],
    [
        "meta4",
        "application/metalink4+xml"
    ],
    [
        "metalink",
        "application/metalink+xml"
    ],
    [
        "mets",
        "application/mets+xml"
    ],
    [
        "mfm",
        "application/vnd.mfmp"
    ],
    [
        "mft",
        "application/rpki-manifest"
    ],
    [
        "mgp",
        "application/vnd.osgeo.mapguide.package"
    ],
    [
        "mgz",
        "application/vnd.proteus.magazine"
    ],
    [
        "mid",
        "audio/midi"
    ],
    [
        "midi",
        "audio/midi"
    ],
    [
        "mie",
        "application/x-mie"
    ],
    [
        "mif",
        "application/vnd.mif"
    ],
    [
        "mime",
        "message/rfc822"
    ],
    [
        "mj2",
        "video/mj2"
    ],
    [
        "mjp2",
        "video/mj2"
    ],
    [
        "mjs",
        "application/javascript"
    ],
    [
        "mk3d",
        "video/x-matroska"
    ],
    [
        "mka",
        "audio/x-matroska"
    ],
    [
        "mkd",
        "text/x-markdown"
    ],
    [
        "mks",
        "video/x-matroska"
    ],
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mlp",
        "application/vnd.dolby.mlp"
    ],
    [
        "mmd",
        "application/vnd.chipnuts.karaoke-mmd"
    ],
    [
        "mmf",
        "application/vnd.smaf"
    ],
    [
        "mml",
        "text/mathml"
    ],
    [
        "mmr",
        "image/vnd.fujixerox.edmics-mmr"
    ],
    [
        "mng",
        "video/x-mng"
    ],
    [
        "mny",
        "application/x-msmoney"
    ],
    [
        "mobi",
        "application/x-mobipocket-ebook"
    ],
    [
        "mods",
        "application/mods+xml"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "movie",
        "video/x-sgi-movie"
    ],
    [
        "mp2",
        "audio/mpeg"
    ],
    [
        "mp2a",
        "audio/mpeg"
    ],
    [
        "mp3",
        "audio/mpeg"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "mp4a",
        "audio/mp4"
    ],
    [
        "mp4s",
        "application/mp4"
    ],
    [
        "mp4v",
        "video/mp4"
    ],
    [
        "mp21",
        "application/mp21"
    ],
    [
        "mpc",
        "application/vnd.mophun.certificate"
    ],
    [
        "mpd",
        "application/dash+xml"
    ],
    [
        "mpe",
        "video/mpeg"
    ],
    [
        "mpeg",
        "video/mpeg"
    ],
    [
        "mpg",
        "video/mpeg"
    ],
    [
        "mpg4",
        "video/mp4"
    ],
    [
        "mpga",
        "audio/mpeg"
    ],
    [
        "mpkg",
        "application/vnd.apple.installer+xml"
    ],
    [
        "mpm",
        "application/vnd.blueice.multipass"
    ],
    [
        "mpn",
        "application/vnd.mophun.application"
    ],
    [
        "mpp",
        "application/vnd.ms-project"
    ],
    [
        "mpt",
        "application/vnd.ms-project"
    ],
    [
        "mpy",
        "application/vnd.ibm.minipay"
    ],
    [
        "mqy",
        "application/vnd.mobius.mqy"
    ],
    [
        "mrc",
        "application/marc"
    ],
    [
        "mrcx",
        "application/marcxml+xml"
    ],
    [
        "ms",
        "text/troff"
    ],
    [
        "mscml",
        "application/mediaservercontrol+xml"
    ],
    [
        "mseed",
        "application/vnd.fdsn.mseed"
    ],
    [
        "mseq",
        "application/vnd.mseq"
    ],
    [
        "msf",
        "application/vnd.epson.msf"
    ],
    [
        "msg",
        "application/vnd.ms-outlook"
    ],
    [
        "msh",
        "model/mesh"
    ],
    [
        "msi",
        "application/x-msdownload"
    ],
    [
        "msl",
        "application/vnd.mobius.msl"
    ],
    [
        "msm",
        "application/octet-stream"
    ],
    [
        "msp",
        "application/octet-stream"
    ],
    [
        "msty",
        "application/vnd.muvee.style"
    ],
    [
        "mtl",
        "model/mtl"
    ],
    [
        "mts",
        "model/vnd.mts"
    ],
    [
        "mus",
        "application/vnd.musician"
    ],
    [
        "musd",
        "application/mmt-usd+xml"
    ],
    [
        "musicxml",
        "application/vnd.recordare.musicxml+xml"
    ],
    [
        "mvb",
        "application/x-msmediaview"
    ],
    [
        "mvt",
        "application/vnd.mapbox-vector-tile"
    ],
    [
        "mwf",
        "application/vnd.mfer"
    ],
    [
        "mxf",
        "application/mxf"
    ],
    [
        "mxl",
        "application/vnd.recordare.musicxml"
    ],
    [
        "mxmf",
        "audio/mobile-xmf"
    ],
    [
        "mxml",
        "application/xv+xml"
    ],
    [
        "mxs",
        "application/vnd.triscape.mxs"
    ],
    [
        "mxu",
        "video/vnd.mpegurl"
    ],
    [
        "n-gage",
        "application/vnd.nokia.n-gage.symbian.install"
    ],
    [
        "n3",
        "text/n3"
    ],
    [
        "nb",
        "application/mathematica"
    ],
    [
        "nbp",
        "application/vnd.wolfram.player"
    ],
    [
        "nc",
        "application/x-netcdf"
    ],
    [
        "ncx",
        "application/x-dtbncx+xml"
    ],
    [
        "nfo",
        "text/x-nfo"
    ],
    [
        "ngdat",
        "application/vnd.nokia.n-gage.data"
    ],
    [
        "nitf",
        "application/vnd.nitf"
    ],
    [
        "nlu",
        "application/vnd.neurolanguage.nlu"
    ],
    [
        "nml",
        "application/vnd.enliven"
    ],
    [
        "nnd",
        "application/vnd.noblenet-directory"
    ],
    [
        "nns",
        "application/vnd.noblenet-sealer"
    ],
    [
        "nnw",
        "application/vnd.noblenet-web"
    ],
    [
        "npx",
        "image/vnd.net-fpx"
    ],
    [
        "nq",
        "application/n-quads"
    ],
    [
        "nsc",
        "application/x-conference"
    ],
    [
        "nsf",
        "application/vnd.lotus-notes"
    ],
    [
        "nt",
        "application/n-triples"
    ],
    [
        "ntf",
        "application/vnd.nitf"
    ],
    [
        "numbers",
        "application/x-iwork-numbers-sffnumbers"
    ],
    [
        "nzb",
        "application/x-nzb"
    ],
    [
        "oa2",
        "application/vnd.fujitsu.oasys2"
    ],
    [
        "oa3",
        "application/vnd.fujitsu.oasys3"
    ],
    [
        "oas",
        "application/vnd.fujitsu.oasys"
    ],
    [
        "obd",
        "application/x-msbinder"
    ],
    [
        "obgx",
        "application/vnd.openblox.game+xml"
    ],
    [
        "obj",
        "model/obj"
    ],
    [
        "oda",
        "application/oda"
    ],
    [
        "odb",
        "application/vnd.oasis.opendocument.database"
    ],
    [
        "odc",
        "application/vnd.oasis.opendocument.chart"
    ],
    [
        "odf",
        "application/vnd.oasis.opendocument.formula"
    ],
    [
        "odft",
        "application/vnd.oasis.opendocument.formula-template"
    ],
    [
        "odg",
        "application/vnd.oasis.opendocument.graphics"
    ],
    [
        "odi",
        "application/vnd.oasis.opendocument.image"
    ],
    [
        "odm",
        "application/vnd.oasis.opendocument.text-master"
    ],
    [
        "odp",
        "application/vnd.oasis.opendocument.presentation"
    ],
    [
        "ods",
        "application/vnd.oasis.opendocument.spreadsheet"
    ],
    [
        "odt",
        "application/vnd.oasis.opendocument.text"
    ],
    [
        "oga",
        "audio/ogg"
    ],
    [
        "ogex",
        "model/vnd.opengex"
    ],
    [
        "ogg",
        "audio/ogg"
    ],
    [
        "ogv",
        "video/ogg"
    ],
    [
        "ogx",
        "application/ogg"
    ],
    [
        "omdoc",
        "application/omdoc+xml"
    ],
    [
        "onepkg",
        "application/onenote"
    ],
    [
        "onetmp",
        "application/onenote"
    ],
    [
        "onetoc",
        "application/onenote"
    ],
    [
        "onetoc2",
        "application/onenote"
    ],
    [
        "opf",
        "application/oebps-package+xml"
    ],
    [
        "opml",
        "text/x-opml"
    ],
    [
        "oprc",
        "application/vnd.palm"
    ],
    [
        "opus",
        "audio/ogg"
    ],
    [
        "org",
        "text/x-org"
    ],
    [
        "osf",
        "application/vnd.yamaha.openscoreformat"
    ],
    [
        "osfpvg",
        "application/vnd.yamaha.openscoreformat.osfpvg+xml"
    ],
    [
        "osm",
        "application/vnd.openstreetmap.data+xml"
    ],
    [
        "otc",
        "application/vnd.oasis.opendocument.chart-template"
    ],
    [
        "otf",
        "font/otf"
    ],
    [
        "otg",
        "application/vnd.oasis.opendocument.graphics-template"
    ],
    [
        "oth",
        "application/vnd.oasis.opendocument.text-web"
    ],
    [
        "oti",
        "application/vnd.oasis.opendocument.image-template"
    ],
    [
        "otp",
        "application/vnd.oasis.opendocument.presentation-template"
    ],
    [
        "ots",
        "application/vnd.oasis.opendocument.spreadsheet-template"
    ],
    [
        "ott",
        "application/vnd.oasis.opendocument.text-template"
    ],
    [
        "ova",
        "application/x-virtualbox-ova"
    ],
    [
        "ovf",
        "application/x-virtualbox-ovf"
    ],
    [
        "owl",
        "application/rdf+xml"
    ],
    [
        "oxps",
        "application/oxps"
    ],
    [
        "oxt",
        "application/vnd.openofficeorg.extension"
    ],
    [
        "p",
        "text/x-pascal"
    ],
    [
        "p7a",
        "application/x-pkcs7-signature"
    ],
    [
        "p7b",
        "application/x-pkcs7-certificates"
    ],
    [
        "p7c",
        "application/pkcs7-mime"
    ],
    [
        "p7m",
        "application/pkcs7-mime"
    ],
    [
        "p7r",
        "application/x-pkcs7-certreqresp"
    ],
    [
        "p7s",
        "application/pkcs7-signature"
    ],
    [
        "p8",
        "application/pkcs8"
    ],
    [
        "p10",
        "application/x-pkcs10"
    ],
    [
        "p12",
        "application/x-pkcs12"
    ],
    [
        "pac",
        "application/x-ns-proxy-autoconfig"
    ],
    [
        "pages",
        "application/x-iwork-pages-sffpages"
    ],
    [
        "pas",
        "text/x-pascal"
    ],
    [
        "paw",
        "application/vnd.pawaafile"
    ],
    [
        "pbd",
        "application/vnd.powerbuilder6"
    ],
    [
        "pbm",
        "image/x-portable-bitmap"
    ],
    [
        "pcap",
        "application/vnd.tcpdump.pcap"
    ],
    [
        "pcf",
        "application/x-font-pcf"
    ],
    [
        "pcl",
        "application/vnd.hp-pcl"
    ],
    [
        "pclxl",
        "application/vnd.hp-pclxl"
    ],
    [
        "pct",
        "image/x-pict"
    ],
    [
        "pcurl",
        "application/vnd.curl.pcurl"
    ],
    [
        "pcx",
        "image/x-pcx"
    ],
    [
        "pdb",
        "application/x-pilot"
    ],
    [
        "pde",
        "text/x-processing"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "pem",
        "application/x-x509-user-cert"
    ],
    [
        "pfa",
        "application/x-font-type1"
    ],
    [
        "pfb",
        "application/x-font-type1"
    ],
    [
        "pfm",
        "application/x-font-type1"
    ],
    [
        "pfr",
        "application/font-tdpfr"
    ],
    [
        "pfx",
        "application/x-pkcs12"
    ],
    [
        "pgm",
        "image/x-portable-graymap"
    ],
    [
        "pgn",
        "application/x-chess-pgn"
    ],
    [
        "pgp",
        "application/pgp"
    ],
    [
        "php",
        "application/x-httpd-php"
    ],
    [
        "php3",
        "application/x-httpd-php"
    ],
    [
        "php4",
        "application/x-httpd-php"
    ],
    [
        "phps",
        "application/x-httpd-php-source"
    ],
    [
        "phtml",
        "application/x-httpd-php"
    ],
    [
        "pic",
        "image/x-pict"
    ],
    [
        "pkg",
        "application/octet-stream"
    ],
    [
        "pki",
        "application/pkixcmp"
    ],
    [
        "pkipath",
        "application/pkix-pkipath"
    ],
    [
        "pkpass",
        "application/vnd.apple.pkpass"
    ],
    [
        "pl",
        "application/x-perl"
    ],
    [
        "plb",
        "application/vnd.3gpp.pic-bw-large"
    ],
    [
        "plc",
        "application/vnd.mobius.plc"
    ],
    [
        "plf",
        "application/vnd.pocketlearn"
    ],
    [
        "pls",
        "application/pls+xml"
    ],
    [
        "pm",
        "application/x-perl"
    ],
    [
        "pml",
        "application/vnd.ctc-posml"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "pnm",
        "image/x-portable-anymap"
    ],
    [
        "portpkg",
        "application/vnd.macports.portpkg"
    ],
    [
        "pot",
        "application/vnd.ms-powerpoint"
    ],
    [
        "potm",
        "application/vnd.ms-powerpoint.presentation.macroEnabled.12"
    ],
    [
        "potx",
        "application/vnd.openxmlformats-officedocument.presentationml.template"
    ],
    [
        "ppa",
        "application/vnd.ms-powerpoint"
    ],
    [
        "ppam",
        "application/vnd.ms-powerpoint.addin.macroEnabled.12"
    ],
    [
        "ppd",
        "application/vnd.cups-ppd"
    ],
    [
        "ppm",
        "image/x-portable-pixmap"
    ],
    [
        "pps",
        "application/vnd.ms-powerpoint"
    ],
    [
        "ppsm",
        "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"
    ],
    [
        "ppsx",
        "application/vnd.openxmlformats-officedocument.presentationml.slideshow"
    ],
    [
        "ppt",
        "application/powerpoint"
    ],
    [
        "pptm",
        "application/vnd.ms-powerpoint.presentation.macroEnabled.12"
    ],
    [
        "pptx",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ],
    [
        "pqa",
        "application/vnd.palm"
    ],
    [
        "prc",
        "application/x-pilot"
    ],
    [
        "pre",
        "application/vnd.lotus-freelance"
    ],
    [
        "prf",
        "application/pics-rules"
    ],
    [
        "provx",
        "application/provenance+xml"
    ],
    [
        "ps",
        "application/postscript"
    ],
    [
        "psb",
        "application/vnd.3gpp.pic-bw-small"
    ],
    [
        "psd",
        "application/x-photoshop"
    ],
    [
        "psf",
        "application/x-font-linux-psf"
    ],
    [
        "pskcxml",
        "application/pskc+xml"
    ],
    [
        "pti",
        "image/prs.pti"
    ],
    [
        "ptid",
        "application/vnd.pvi.ptid1"
    ],
    [
        "pub",
        "application/x-mspublisher"
    ],
    [
        "pvb",
        "application/vnd.3gpp.pic-bw-var"
    ],
    [
        "pwn",
        "application/vnd.3m.post-it-notes"
    ],
    [
        "pya",
        "audio/vnd.ms-playready.media.pya"
    ],
    [
        "pyv",
        "video/vnd.ms-playready.media.pyv"
    ],
    [
        "qam",
        "application/vnd.epson.quickanime"
    ],
    [
        "qbo",
        "application/vnd.intu.qbo"
    ],
    [
        "qfx",
        "application/vnd.intu.qfx"
    ],
    [
        "qps",
        "application/vnd.publishare-delta-tree"
    ],
    [
        "qt",
        "video/quicktime"
    ],
    [
        "qwd",
        "application/vnd.quark.quarkxpress"
    ],
    [
        "qwt",
        "application/vnd.quark.quarkxpress"
    ],
    [
        "qxb",
        "application/vnd.quark.quarkxpress"
    ],
    [
        "qxd",
        "application/vnd.quark.quarkxpress"
    ],
    [
        "qxl",
        "application/vnd.quark.quarkxpress"
    ],
    [
        "qxt",
        "application/vnd.quark.quarkxpress"
    ],
    [
        "ra",
        "audio/x-realaudio"
    ],
    [
        "ram",
        "audio/x-pn-realaudio"
    ],
    [
        "raml",
        "application/raml+yaml"
    ],
    [
        "rapd",
        "application/route-apd+xml"
    ],
    [
        "rar",
        "application/x-rar"
    ],
    [
        "ras",
        "image/x-cmu-raster"
    ],
    [
        "rcprofile",
        "application/vnd.ipunplugged.rcprofile"
    ],
    [
        "rdf",
        "application/rdf+xml"
    ],
    [
        "rdz",
        "application/vnd.data-vision.rdz"
    ],
    [
        "relo",
        "application/p2p-overlay+xml"
    ],
    [
        "rep",
        "application/vnd.businessobjects"
    ],
    [
        "res",
        "application/x-dtbresource+xml"
    ],
    [
        "rgb",
        "image/x-rgb"
    ],
    [
        "rif",
        "application/reginfo+xml"
    ],
    [
        "rip",
        "audio/vnd.rip"
    ],
    [
        "ris",
        "application/x-research-info-systems"
    ],
    [
        "rl",
        "application/resource-lists+xml"
    ],
    [
        "rlc",
        "image/vnd.fujixerox.edmics-rlc"
    ],
    [
        "rld",
        "application/resource-lists-diff+xml"
    ],
    [
        "rm",
        "audio/x-pn-realaudio"
    ],
    [
        "rmi",
        "audio/midi"
    ],
    [
        "rmp",
        "audio/x-pn-realaudio-plugin"
    ],
    [
        "rms",
        "application/vnd.jcp.javame.midlet-rms"
    ],
    [
        "rmvb",
        "application/vnd.rn-realmedia-vbr"
    ],
    [
        "rnc",
        "application/relax-ng-compact-syntax"
    ],
    [
        "rng",
        "application/xml"
    ],
    [
        "roa",
        "application/rpki-roa"
    ],
    [
        "roff",
        "text/troff"
    ],
    [
        "rp9",
        "application/vnd.cloanto.rp9"
    ],
    [
        "rpm",
        "audio/x-pn-realaudio-plugin"
    ],
    [
        "rpss",
        "application/vnd.nokia.radio-presets"
    ],
    [
        "rpst",
        "application/vnd.nokia.radio-preset"
    ],
    [
        "rq",
        "application/sparql-query"
    ],
    [
        "rs",
        "application/rls-services+xml"
    ],
    [
        "rsa",
        "application/x-pkcs7"
    ],
    [
        "rsat",
        "application/atsc-rsat+xml"
    ],
    [
        "rsd",
        "application/rsd+xml"
    ],
    [
        "rsheet",
        "application/urc-ressheet+xml"
    ],
    [
        "rss",
        "application/rss+xml"
    ],
    [
        "rtf",
        "text/rtf"
    ],
    [
        "rtx",
        "text/richtext"
    ],
    [
        "run",
        "application/x-makeself"
    ],
    [
        "rusd",
        "application/route-usd+xml"
    ],
    [
        "rv",
        "video/vnd.rn-realvideo"
    ],
    [
        "s",
        "text/x-asm"
    ],
    [
        "s3m",
        "audio/s3m"
    ],
    [
        "saf",
        "application/vnd.yamaha.smaf-audio"
    ],
    [
        "sass",
        "text/x-sass"
    ],
    [
        "sbml",
        "application/sbml+xml"
    ],
    [
        "sc",
        "application/vnd.ibm.secure-container"
    ],
    [
        "scd",
        "application/x-msschedule"
    ],
    [
        "scm",
        "application/vnd.lotus-screencam"
    ],
    [
        "scq",
        "application/scvp-cv-request"
    ],
    [
        "scs",
        "application/scvp-cv-response"
    ],
    [
        "scss",
        "text/x-scss"
    ],
    [
        "scurl",
        "text/vnd.curl.scurl"
    ],
    [
        "sda",
        "application/vnd.stardivision.draw"
    ],
    [
        "sdc",
        "application/vnd.stardivision.calc"
    ],
    [
        "sdd",
        "application/vnd.stardivision.impress"
    ],
    [
        "sdkd",
        "application/vnd.solent.sdkm+xml"
    ],
    [
        "sdkm",
        "application/vnd.solent.sdkm+xml"
    ],
    [
        "sdp",
        "application/sdp"
    ],
    [
        "sdw",
        "application/vnd.stardivision.writer"
    ],
    [
        "sea",
        "application/octet-stream"
    ],
    [
        "see",
        "application/vnd.seemail"
    ],
    [
        "seed",
        "application/vnd.fdsn.seed"
    ],
    [
        "sema",
        "application/vnd.sema"
    ],
    [
        "semd",
        "application/vnd.semd"
    ],
    [
        "semf",
        "application/vnd.semf"
    ],
    [
        "senmlx",
        "application/senml+xml"
    ],
    [
        "sensmlx",
        "application/sensml+xml"
    ],
    [
        "ser",
        "application/java-serialized-object"
    ],
    [
        "setpay",
        "application/set-payment-initiation"
    ],
    [
        "setreg",
        "application/set-registration-initiation"
    ],
    [
        "sfd-hdstx",
        "application/vnd.hydrostatix.sof-data"
    ],
    [
        "sfs",
        "application/vnd.spotfire.sfs"
    ],
    [
        "sfv",
        "text/x-sfv"
    ],
    [
        "sgi",
        "image/sgi"
    ],
    [
        "sgl",
        "application/vnd.stardivision.writer-global"
    ],
    [
        "sgm",
        "text/sgml"
    ],
    [
        "sgml",
        "text/sgml"
    ],
    [
        "sh",
        "application/x-sh"
    ],
    [
        "shar",
        "application/x-shar"
    ],
    [
        "shex",
        "text/shex"
    ],
    [
        "shf",
        "application/shf+xml"
    ],
    [
        "shtml",
        "text/html"
    ],
    [
        "sid",
        "image/x-mrsid-image"
    ],
    [
        "sieve",
        "application/sieve"
    ],
    [
        "sig",
        "application/pgp-signature"
    ],
    [
        "sil",
        "audio/silk"
    ],
    [
        "silo",
        "model/mesh"
    ],
    [
        "sis",
        "application/vnd.symbian.install"
    ],
    [
        "sisx",
        "application/vnd.symbian.install"
    ],
    [
        "sit",
        "application/x-stuffit"
    ],
    [
        "sitx",
        "application/x-stuffitx"
    ],
    [
        "siv",
        "application/sieve"
    ],
    [
        "skd",
        "application/vnd.koan"
    ],
    [
        "skm",
        "application/vnd.koan"
    ],
    [
        "skp",
        "application/vnd.koan"
    ],
    [
        "skt",
        "application/vnd.koan"
    ],
    [
        "sldm",
        "application/vnd.ms-powerpoint.slide.macroenabled.12"
    ],
    [
        "sldx",
        "application/vnd.openxmlformats-officedocument.presentationml.slide"
    ],
    [
        "slim",
        "text/slim"
    ],
    [
        "slm",
        "text/slim"
    ],
    [
        "sls",
        "application/route-s-tsid+xml"
    ],
    [
        "slt",
        "application/vnd.epson.salt"
    ],
    [
        "sm",
        "application/vnd.stepmania.stepchart"
    ],
    [
        "smf",
        "application/vnd.stardivision.math"
    ],
    [
        "smi",
        "application/smil"
    ],
    [
        "smil",
        "application/smil"
    ],
    [
        "smv",
        "video/x-smv"
    ],
    [
        "smzip",
        "application/vnd.stepmania.package"
    ],
    [
        "snd",
        "audio/basic"
    ],
    [
        "snf",
        "application/x-font-snf"
    ],
    [
        "so",
        "application/octet-stream"
    ],
    [
        "spc",
        "application/x-pkcs7-certificates"
    ],
    [
        "spdx",
        "text/spdx"
    ],
    [
        "spf",
        "application/vnd.yamaha.smaf-phrase"
    ],
    [
        "spl",
        "application/x-futuresplash"
    ],
    [
        "spot",
        "text/vnd.in3d.spot"
    ],
    [
        "spp",
        "application/scvp-vp-response"
    ],
    [
        "spq",
        "application/scvp-vp-request"
    ],
    [
        "spx",
        "audio/ogg"
    ],
    [
        "sql",
        "application/x-sql"
    ],
    [
        "src",
        "application/x-wais-source"
    ],
    [
        "srt",
        "application/x-subrip"
    ],
    [
        "sru",
        "application/sru+xml"
    ],
    [
        "srx",
        "application/sparql-results+xml"
    ],
    [
        "ssdl",
        "application/ssdl+xml"
    ],
    [
        "sse",
        "application/vnd.kodak-descriptor"
    ],
    [
        "ssf",
        "application/vnd.epson.ssf"
    ],
    [
        "ssml",
        "application/ssml+xml"
    ],
    [
        "sst",
        "application/octet-stream"
    ],
    [
        "st",
        "application/vnd.sailingtracker.track"
    ],
    [
        "stc",
        "application/vnd.sun.xml.calc.template"
    ],
    [
        "std",
        "application/vnd.sun.xml.draw.template"
    ],
    [
        "stf",
        "application/vnd.wt.stf"
    ],
    [
        "sti",
        "application/vnd.sun.xml.impress.template"
    ],
    [
        "stk",
        "application/hyperstudio"
    ],
    [
        "stl",
        "model/stl"
    ],
    [
        "stpx",
        "model/step+xml"
    ],
    [
        "stpxz",
        "model/step-xml+zip"
    ],
    [
        "stpz",
        "model/step+zip"
    ],
    [
        "str",
        "application/vnd.pg.format"
    ],
    [
        "stw",
        "application/vnd.sun.xml.writer.template"
    ],
    [
        "styl",
        "text/stylus"
    ],
    [
        "stylus",
        "text/stylus"
    ],
    [
        "sub",
        "text/vnd.dvb.subtitle"
    ],
    [
        "sus",
        "application/vnd.sus-calendar"
    ],
    [
        "susp",
        "application/vnd.sus-calendar"
    ],
    [
        "sv4cpio",
        "application/x-sv4cpio"
    ],
    [
        "sv4crc",
        "application/x-sv4crc"
    ],
    [
        "svc",
        "application/vnd.dvb.service"
    ],
    [
        "svd",
        "application/vnd.svd"
    ],
    [
        "svg",
        "image/svg+xml"
    ],
    [
        "svgz",
        "image/svg+xml"
    ],
    [
        "swa",
        "application/x-director"
    ],
    [
        "swf",
        "application/x-shockwave-flash"
    ],
    [
        "swi",
        "application/vnd.aristanetworks.swi"
    ],
    [
        "swidtag",
        "application/swid+xml"
    ],
    [
        "sxc",
        "application/vnd.sun.xml.calc"
    ],
    [
        "sxd",
        "application/vnd.sun.xml.draw"
    ],
    [
        "sxg",
        "application/vnd.sun.xml.writer.global"
    ],
    [
        "sxi",
        "application/vnd.sun.xml.impress"
    ],
    [
        "sxm",
        "application/vnd.sun.xml.math"
    ],
    [
        "sxw",
        "application/vnd.sun.xml.writer"
    ],
    [
        "t",
        "text/troff"
    ],
    [
        "t3",
        "application/x-t3vm-image"
    ],
    [
        "t38",
        "image/t38"
    ],
    [
        "taglet",
        "application/vnd.mynfc"
    ],
    [
        "tao",
        "application/vnd.tao.intent-module-archive"
    ],
    [
        "tap",
        "image/vnd.tencent.tap"
    ],
    [
        "tar",
        "application/x-tar"
    ],
    [
        "tcap",
        "application/vnd.3gpp2.tcap"
    ],
    [
        "tcl",
        "application/x-tcl"
    ],
    [
        "td",
        "application/urc-targetdesc+xml"
    ],
    [
        "teacher",
        "application/vnd.smart.teacher"
    ],
    [
        "tei",
        "application/tei+xml"
    ],
    [
        "teicorpus",
        "application/tei+xml"
    ],
    [
        "tex",
        "application/x-tex"
    ],
    [
        "texi",
        "application/x-texinfo"
    ],
    [
        "texinfo",
        "application/x-texinfo"
    ],
    [
        "text",
        "text/plain"
    ],
    [
        "tfi",
        "application/thraud+xml"
    ],
    [
        "tfm",
        "application/x-tex-tfm"
    ],
    [
        "tfx",
        "image/tiff-fx"
    ],
    [
        "tga",
        "image/x-tga"
    ],
    [
        "tgz",
        "application/x-tar"
    ],
    [
        "thmx",
        "application/vnd.ms-officetheme"
    ],
    [
        "tif",
        "image/tiff"
    ],
    [
        "tiff",
        "image/tiff"
    ],
    [
        "tk",
        "application/x-tcl"
    ],
    [
        "tmo",
        "application/vnd.tmobile-livetv"
    ],
    [
        "toml",
        "application/toml"
    ],
    [
        "torrent",
        "application/x-bittorrent"
    ],
    [
        "tpl",
        "application/vnd.groove-tool-template"
    ],
    [
        "tpt",
        "application/vnd.trid.tpt"
    ],
    [
        "tr",
        "text/troff"
    ],
    [
        "tra",
        "application/vnd.trueapp"
    ],
    [
        "trig",
        "application/trig"
    ],
    [
        "trm",
        "application/x-msterminal"
    ],
    [
        "ts",
        "video/mp2t"
    ],
    [
        "tsd",
        "application/timestamped-data"
    ],
    [
        "tsv",
        "text/tab-separated-values"
    ],
    [
        "ttc",
        "font/collection"
    ],
    [
        "ttf",
        "font/ttf"
    ],
    [
        "ttl",
        "text/turtle"
    ],
    [
        "ttml",
        "application/ttml+xml"
    ],
    [
        "twd",
        "application/vnd.simtech-mindmapper"
    ],
    [
        "twds",
        "application/vnd.simtech-mindmapper"
    ],
    [
        "txd",
        "application/vnd.genomatix.tuxedo"
    ],
    [
        "txf",
        "application/vnd.mobius.txf"
    ],
    [
        "txt",
        "text/plain"
    ],
    [
        "u8dsn",
        "message/global-delivery-status"
    ],
    [
        "u8hdr",
        "message/global-headers"
    ],
    [
        "u8mdn",
        "message/global-disposition-notification"
    ],
    [
        "u8msg",
        "message/global"
    ],
    [
        "u32",
        "application/x-authorware-bin"
    ],
    [
        "ubj",
        "application/ubjson"
    ],
    [
        "udeb",
        "application/x-debian-package"
    ],
    [
        "ufd",
        "application/vnd.ufdl"
    ],
    [
        "ufdl",
        "application/vnd.ufdl"
    ],
    [
        "ulx",
        "application/x-glulx"
    ],
    [
        "umj",
        "application/vnd.umajin"
    ],
    [
        "unityweb",
        "application/vnd.unity"
    ],
    [
        "uoml",
        "application/vnd.uoml+xml"
    ],
    [
        "uri",
        "text/uri-list"
    ],
    [
        "uris",
        "text/uri-list"
    ],
    [
        "urls",
        "text/uri-list"
    ],
    [
        "usdz",
        "model/vnd.usdz+zip"
    ],
    [
        "ustar",
        "application/x-ustar"
    ],
    [
        "utz",
        "application/vnd.uiq.theme"
    ],
    [
        "uu",
        "text/x-uuencode"
    ],
    [
        "uva",
        "audio/vnd.dece.audio"
    ],
    [
        "uvd",
        "application/vnd.dece.data"
    ],
    [
        "uvf",
        "application/vnd.dece.data"
    ],
    [
        "uvg",
        "image/vnd.dece.graphic"
    ],
    [
        "uvh",
        "video/vnd.dece.hd"
    ],
    [
        "uvi",
        "image/vnd.dece.graphic"
    ],
    [
        "uvm",
        "video/vnd.dece.mobile"
    ],
    [
        "uvp",
        "video/vnd.dece.pd"
    ],
    [
        "uvs",
        "video/vnd.dece.sd"
    ],
    [
        "uvt",
        "application/vnd.dece.ttml+xml"
    ],
    [
        "uvu",
        "video/vnd.uvvu.mp4"
    ],
    [
        "uvv",
        "video/vnd.dece.video"
    ],
    [
        "uvva",
        "audio/vnd.dece.audio"
    ],
    [
        "uvvd",
        "application/vnd.dece.data"
    ],
    [
        "uvvf",
        "application/vnd.dece.data"
    ],
    [
        "uvvg",
        "image/vnd.dece.graphic"
    ],
    [
        "uvvh",
        "video/vnd.dece.hd"
    ],
    [
        "uvvi",
        "image/vnd.dece.graphic"
    ],
    [
        "uvvm",
        "video/vnd.dece.mobile"
    ],
    [
        "uvvp",
        "video/vnd.dece.pd"
    ],
    [
        "uvvs",
        "video/vnd.dece.sd"
    ],
    [
        "uvvt",
        "application/vnd.dece.ttml+xml"
    ],
    [
        "uvvu",
        "video/vnd.uvvu.mp4"
    ],
    [
        "uvvv",
        "video/vnd.dece.video"
    ],
    [
        "uvvx",
        "application/vnd.dece.unspecified"
    ],
    [
        "uvvz",
        "application/vnd.dece.zip"
    ],
    [
        "uvx",
        "application/vnd.dece.unspecified"
    ],
    [
        "uvz",
        "application/vnd.dece.zip"
    ],
    [
        "vbox",
        "application/x-virtualbox-vbox"
    ],
    [
        "vbox-extpack",
        "application/x-virtualbox-vbox-extpack"
    ],
    [
        "vcard",
        "text/vcard"
    ],
    [
        "vcd",
        "application/x-cdlink"
    ],
    [
        "vcf",
        "text/x-vcard"
    ],
    [
        "vcg",
        "application/vnd.groove-vcard"
    ],
    [
        "vcs",
        "text/x-vcalendar"
    ],
    [
        "vcx",
        "application/vnd.vcx"
    ],
    [
        "vdi",
        "application/x-virtualbox-vdi"
    ],
    [
        "vds",
        "model/vnd.sap.vds"
    ],
    [
        "vhd",
        "application/x-virtualbox-vhd"
    ],
    [
        "vis",
        "application/vnd.visionary"
    ],
    [
        "viv",
        "video/vnd.vivo"
    ],
    [
        "vlc",
        "application/videolan"
    ],
    [
        "vmdk",
        "application/x-virtualbox-vmdk"
    ],
    [
        "vob",
        "video/x-ms-vob"
    ],
    [
        "vor",
        "application/vnd.stardivision.writer"
    ],
    [
        "vox",
        "application/x-authorware-bin"
    ],
    [
        "vrml",
        "model/vrml"
    ],
    [
        "vsd",
        "application/vnd.visio"
    ],
    [
        "vsf",
        "application/vnd.vsf"
    ],
    [
        "vss",
        "application/vnd.visio"
    ],
    [
        "vst",
        "application/vnd.visio"
    ],
    [
        "vsw",
        "application/vnd.visio"
    ],
    [
        "vtf",
        "image/vnd.valve.source.texture"
    ],
    [
        "vtt",
        "text/vtt"
    ],
    [
        "vtu",
        "model/vnd.vtu"
    ],
    [
        "vxml",
        "application/voicexml+xml"
    ],
    [
        "w3d",
        "application/x-director"
    ],
    [
        "wad",
        "application/x-doom"
    ],
    [
        "wadl",
        "application/vnd.sun.wadl+xml"
    ],
    [
        "war",
        "application/java-archive"
    ],
    [
        "wasm",
        "application/wasm"
    ],
    [
        "wav",
        "audio/x-wav"
    ],
    [
        "wax",
        "audio/x-ms-wax"
    ],
    [
        "wbmp",
        "image/vnd.wap.wbmp"
    ],
    [
        "wbs",
        "application/vnd.criticaltools.wbs+xml"
    ],
    [
        "wbxml",
        "application/wbxml"
    ],
    [
        "wcm",
        "application/vnd.ms-works"
    ],
    [
        "wdb",
        "application/vnd.ms-works"
    ],
    [
        "wdp",
        "image/vnd.ms-photo"
    ],
    [
        "weba",
        "audio/webm"
    ],
    [
        "webapp",
        "application/x-web-app-manifest+json"
    ],
    [
        "webm",
        "video/webm"
    ],
    [
        "webmanifest",
        "application/manifest+json"
    ],
    [
        "webp",
        "image/webp"
    ],
    [
        "wg",
        "application/vnd.pmi.widget"
    ],
    [
        "wgt",
        "application/widget"
    ],
    [
        "wks",
        "application/vnd.ms-works"
    ],
    [
        "wm",
        "video/x-ms-wm"
    ],
    [
        "wma",
        "audio/x-ms-wma"
    ],
    [
        "wmd",
        "application/x-ms-wmd"
    ],
    [
        "wmf",
        "image/wmf"
    ],
    [
        "wml",
        "text/vnd.wap.wml"
    ],
    [
        "wmlc",
        "application/wmlc"
    ],
    [
        "wmls",
        "text/vnd.wap.wmlscript"
    ],
    [
        "wmlsc",
        "application/vnd.wap.wmlscriptc"
    ],
    [
        "wmv",
        "video/x-ms-wmv"
    ],
    [
        "wmx",
        "video/x-ms-wmx"
    ],
    [
        "wmz",
        "application/x-msmetafile"
    ],
    [
        "woff",
        "font/woff"
    ],
    [
        "woff2",
        "font/woff2"
    ],
    [
        "word",
        "application/msword"
    ],
    [
        "wpd",
        "application/vnd.wordperfect"
    ],
    [
        "wpl",
        "application/vnd.ms-wpl"
    ],
    [
        "wps",
        "application/vnd.ms-works"
    ],
    [
        "wqd",
        "application/vnd.wqd"
    ],
    [
        "wri",
        "application/x-mswrite"
    ],
    [
        "wrl",
        "model/vrml"
    ],
    [
        "wsc",
        "message/vnd.wfa.wsc"
    ],
    [
        "wsdl",
        "application/wsdl+xml"
    ],
    [
        "wspolicy",
        "application/wspolicy+xml"
    ],
    [
        "wtb",
        "application/vnd.webturbo"
    ],
    [
        "wvx",
        "video/x-ms-wvx"
    ],
    [
        "x3d",
        "model/x3d+xml"
    ],
    [
        "x3db",
        "model/x3d+fastinfoset"
    ],
    [
        "x3dbz",
        "model/x3d+binary"
    ],
    [
        "x3dv",
        "model/x3d-vrml"
    ],
    [
        "x3dvz",
        "model/x3d+vrml"
    ],
    [
        "x3dz",
        "model/x3d+xml"
    ],
    [
        "x32",
        "application/x-authorware-bin"
    ],
    [
        "x_b",
        "model/vnd.parasolid.transmit.binary"
    ],
    [
        "x_t",
        "model/vnd.parasolid.transmit.text"
    ],
    [
        "xaml",
        "application/xaml+xml"
    ],
    [
        "xap",
        "application/x-silverlight-app"
    ],
    [
        "xar",
        "application/vnd.xara"
    ],
    [
        "xav",
        "application/xcap-att+xml"
    ],
    [
        "xbap",
        "application/x-ms-xbap"
    ],
    [
        "xbd",
        "application/vnd.fujixerox.docuworks.binder"
    ],
    [
        "xbm",
        "image/x-xbitmap"
    ],
    [
        "xca",
        "application/xcap-caps+xml"
    ],
    [
        "xcs",
        "application/calendar+xml"
    ],
    [
        "xdf",
        "application/xcap-diff+xml"
    ],
    [
        "xdm",
        "application/vnd.syncml.dm+xml"
    ],
    [
        "xdp",
        "application/vnd.adobe.xdp+xml"
    ],
    [
        "xdssc",
        "application/dssc+xml"
    ],
    [
        "xdw",
        "application/vnd.fujixerox.docuworks"
    ],
    [
        "xel",
        "application/xcap-el+xml"
    ],
    [
        "xenc",
        "application/xenc+xml"
    ],
    [
        "xer",
        "application/patch-ops-error+xml"
    ],
    [
        "xfdf",
        "application/vnd.adobe.xfdf"
    ],
    [
        "xfdl",
        "application/vnd.xfdl"
    ],
    [
        "xht",
        "application/xhtml+xml"
    ],
    [
        "xhtml",
        "application/xhtml+xml"
    ],
    [
        "xhvml",
        "application/xv+xml"
    ],
    [
        "xif",
        "image/vnd.xiff"
    ],
    [
        "xl",
        "application/excel"
    ],
    [
        "xla",
        "application/vnd.ms-excel"
    ],
    [
        "xlam",
        "application/vnd.ms-excel.addin.macroEnabled.12"
    ],
    [
        "xlc",
        "application/vnd.ms-excel"
    ],
    [
        "xlf",
        "application/xliff+xml"
    ],
    [
        "xlm",
        "application/vnd.ms-excel"
    ],
    [
        "xls",
        "application/vnd.ms-excel"
    ],
    [
        "xlsb",
        "application/vnd.ms-excel.sheet.binary.macroEnabled.12"
    ],
    [
        "xlsm",
        "application/vnd.ms-excel.sheet.macroEnabled.12"
    ],
    [
        "xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    [
        "xlt",
        "application/vnd.ms-excel"
    ],
    [
        "xltm",
        "application/vnd.ms-excel.template.macroEnabled.12"
    ],
    [
        "xltx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.template"
    ],
    [
        "xlw",
        "application/vnd.ms-excel"
    ],
    [
        "xm",
        "audio/xm"
    ],
    [
        "xml",
        "application/xml"
    ],
    [
        "xns",
        "application/xcap-ns+xml"
    ],
    [
        "xo",
        "application/vnd.olpc-sugar"
    ],
    [
        "xop",
        "application/xop+xml"
    ],
    [
        "xpi",
        "application/x-xpinstall"
    ],
    [
        "xpl",
        "application/xproc+xml"
    ],
    [
        "xpm",
        "image/x-xpixmap"
    ],
    [
        "xpr",
        "application/vnd.is-xpr"
    ],
    [
        "xps",
        "application/vnd.ms-xpsdocument"
    ],
    [
        "xpw",
        "application/vnd.intercon.formnet"
    ],
    [
        "xpx",
        "application/vnd.intercon.formnet"
    ],
    [
        "xsd",
        "application/xml"
    ],
    [
        "xsl",
        "application/xml"
    ],
    [
        "xslt",
        "application/xslt+xml"
    ],
    [
        "xsm",
        "application/vnd.syncml+xml"
    ],
    [
        "xspf",
        "application/xspf+xml"
    ],
    [
        "xul",
        "application/vnd.mozilla.xul+xml"
    ],
    [
        "xvm",
        "application/xv+xml"
    ],
    [
        "xvml",
        "application/xv+xml"
    ],
    [
        "xwd",
        "image/x-xwindowdump"
    ],
    [
        "xyz",
        "chemical/x-xyz"
    ],
    [
        "xz",
        "application/x-xz"
    ],
    [
        "yaml",
        "text/yaml"
    ],
    [
        "yang",
        "application/yang"
    ],
    [
        "yin",
        "application/yin+xml"
    ],
    [
        "yml",
        "text/yaml"
    ],
    [
        "ymp",
        "text/x-suse-ymp"
    ],
    [
        "z",
        "application/x-compress"
    ],
    [
        "z1",
        "application/x-zmachine"
    ],
    [
        "z2",
        "application/x-zmachine"
    ],
    [
        "z3",
        "application/x-zmachine"
    ],
    [
        "z4",
        "application/x-zmachine"
    ],
    [
        "z5",
        "application/x-zmachine"
    ],
    [
        "z6",
        "application/x-zmachine"
    ],
    [
        "z7",
        "application/x-zmachine"
    ],
    [
        "z8",
        "application/x-zmachine"
    ],
    [
        "zaz",
        "application/vnd.zzazz.deck+xml"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "zir",
        "application/vnd.zul"
    ],
    [
        "zirz",
        "application/vnd.zul"
    ],
    [
        "zmm",
        "application/vnd.handheld-entertainment+xml"
    ],
    [
        "zsh",
        "text/x-scriptzsh"
    ]
]);
function $0c417c97818a47bb$export$8cc09085015f0dc7(file, path, h) {
    const f = $0c417c97818a47bb$var$withMimeType(file);
    const { webkitRelativePath: webkitRelativePath } = file;
    const p = typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : `./${file.name}`;
    if (typeof f.path !== "string") $0c417c97818a47bb$var$setObjProp(f, "path", p);
    if (h !== undefined) Object.defineProperty(f, "handle", {
        value: h,
        writable: false,
        configurable: false,
        enumerable: true
    });
    // Always populate a relative path so that even electron apps have access to a relativePath value
    $0c417c97818a47bb$var$setObjProp(f, "relativePath", p);
    return f;
}
function $0c417c97818a47bb$var$withMimeType(file) {
    const { name: name } = file;
    const hasExtension = name && name.lastIndexOf(".") !== -1;
    if (hasExtension && !file.type) {
        const ext = name.split(".").pop().toLowerCase();
        const type = $0c417c97818a47bb$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, "type", {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}
function $0c417c97818a47bb$var$setObjProp(f, key, value) {
    Object.defineProperty(f, key, {
        value: value,
        writable: false,
        configurable: false,
        enumerable: true
    });
}

});



parcelRegister("eEukq", function(module, exports) {

$parcel$export(module.exports, "TOO_MANY_FILES_REJECTION", () => $aaac53b849ab07d4$export$1e1e1b6120329fe);
$parcel$export(module.exports, "fileAccepted", () => $aaac53b849ab07d4$export$b511db3632effe58);
$parcel$export(module.exports, "fileMatchSize", () => $aaac53b849ab07d4$export$860631d45ba43fd9);
$parcel$export(module.exports, "allFilesAccepted", () => $aaac53b849ab07d4$export$6a0bb4322c81a197);
$parcel$export(module.exports, "isPropagationStopped", () => $aaac53b849ab07d4$export$8d6d6472146de265);
$parcel$export(module.exports, "isEvtWithFiles", () => $aaac53b849ab07d4$export$52f1fc875a1e5986);
$parcel$export(module.exports, "onDocumentDragOver", () => $aaac53b849ab07d4$export$2ead263d6635cecc);
$parcel$export(module.exports, "isIeOrEdge", () => $aaac53b849ab07d4$export$d3498e653911f962);
$parcel$export(module.exports, "composeEventHandlers", () => $aaac53b849ab07d4$export$b9ecd428b558ff10);
$parcel$export(module.exports, "canUseFileSystemAccessAPI", () => $aaac53b849ab07d4$export$858af2af50e1eaf8);
$parcel$export(module.exports, "pickerOptionsFromAccept", () => $aaac53b849ab07d4$export$8ce4bd13c494743e);
$parcel$export(module.exports, "acceptPropAsAcceptAttr", () => $aaac53b849ab07d4$export$1278288bcefb97b9);
$parcel$export(module.exports, "isAbort", () => $aaac53b849ab07d4$export$72580c77a176a18f);
$parcel$export(module.exports, "isSecurityError", () => $aaac53b849ab07d4$export$c4f82d4432e209a9);

var $0dzo3 = parcelRequire("0dzo3");
function $aaac53b849ab07d4$var$_toConsumableArray(arr) {
    return $aaac53b849ab07d4$var$_arrayWithoutHoles(arr) || $aaac53b849ab07d4$var$_iterableToArray(arr) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr) || $aaac53b849ab07d4$var$_nonIterableSpread();
}
function $aaac53b849ab07d4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $aaac53b849ab07d4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $aaac53b849ab07d4$var$_arrayLikeToArray(arr);
}
function $aaac53b849ab07d4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aaac53b849ab07d4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aaac53b849ab07d4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $aaac53b849ab07d4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aaac53b849ab07d4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aaac53b849ab07d4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aaac53b849ab07d4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $aaac53b849ab07d4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $aaac53b849ab07d4$var$_typeof(obj);
}
function $aaac53b849ab07d4$var$_slicedToArray(arr, i) {
    return $aaac53b849ab07d4$var$_arrayWithHoles(arr) || $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr, i) || $aaac53b849ab07d4$var$_nonIterableRest();
}
function $aaac53b849ab07d4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
}
function $aaac53b849ab07d4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $aaac53b849ab07d4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $aaac53b849ab07d4$var$accepts = typeof (0, $0dzo3.default) === "function" ? (0, $0dzo3.default) : (0, $0dzo3.default).default; // Error codes
var $aaac53b849ab07d4$export$d2c35cc369247232 = "file-invalid-type";
var $aaac53b849ab07d4$export$d7bd1185abe1e87c = "file-too-large";
var $aaac53b849ab07d4$export$8bd5ec6ed990dc9 = "file-too-small";
var $aaac53b849ab07d4$export$3271ef1d2dd155f9 = "too-many-files";
var $aaac53b849ab07d4$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $aaac53b849ab07d4$export$d2c35cc369247232,
    FileTooLarge: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
    FileTooSmall: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
    TooManyFiles: $aaac53b849ab07d4$export$3271ef1d2dd155f9
};
var $aaac53b849ab07d4$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr() {
    var accept = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var acceptArr = accept.split(",");
    var msg = acceptArr.length > 1 ? "one of ".concat(acceptArr.join(", ")) : acceptArr[0];
    return {
        code: $aaac53b849ab07d4$export$d2c35cc369247232,
        message: "File type must be ".concat(msg)
    };
};
var $aaac53b849ab07d4$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$1e1e1b6120329fe = {
    code: $aaac53b849ab07d4$export$3271ef1d2dd155f9,
    message: "Too many files"
};
function $aaac53b849ab07d4$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || $aaac53b849ab07d4$var$accepts(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $aaac53b849ab07d4$export$bc0bbda045f09b5a(accept)
    ];
}
function $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($aaac53b849ab07d4$var$isDefined(file.size)) {
        if ($aaac53b849ab07d4$var$isDefined(minSize) && $aaac53b849ab07d4$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($aaac53b849ab07d4$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($aaac53b849ab07d4$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $aaac53b849ab07d4$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $aaac53b849ab07d4$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $aaac53b849ab07d4$export$b511db3632effe58(file, accept), _fileAccepted2 = $aaac53b849ab07d4$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $aaac53b849ab07d4$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $aaac53b849ab07d4$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $aaac53b849ab07d4$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $aaac53b849ab07d4$export$f9006bf02b243736(item) {
    return $aaac53b849ab07d4$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $aaac53b849ab07d4$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $aaac53b849ab07d4$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $aaac53b849ab07d4$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $aaac53b849ab07d4$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $aaac53b849ab07d4$var$isIe(userAgent) || $aaac53b849ab07d4$var$isEdge(userAgent);
}
function $aaac53b849ab07d4$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$aaac53b849ab07d4$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $aaac53b849ab07d4$export$8d6d6472146de265(event);
        });
    };
}
function $aaac53b849ab07d4$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $aaac53b849ab07d4$export$8ce4bd13c494743e(accept) {
    if ($aaac53b849ab07d4$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $aaac53b849ab07d4$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$aaac53b849ab07d4$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn('Skipped "'.concat(mimeType, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.'));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($aaac53b849ab07d4$export$42c2be5a6d408120)) {
                console.warn('Skipped "'.concat(mimeType, '" because an invalid file extension was provided.'));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $aaac53b849ab07d4$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $aaac53b849ab07d4$var$_objectSpread($aaac53b849ab07d4$var$_objectSpread({}, agg), {}, $aaac53b849ab07d4$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $aaac53b849ab07d4$export$1278288bcefb97b9(accept) {
    if ($aaac53b849ab07d4$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $aaac53b849ab07d4$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($aaac53b849ab07d4$var$_toConsumableArray(a), [
            mimeType
        ], $aaac53b849ab07d4$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $aaac53b849ab07d4$export$69c8ec3250e1cfbf(v) || $aaac53b849ab07d4$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $aaac53b849ab07d4$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $aaac53b849ab07d4$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $aaac53b849ab07d4$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || v === "application/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $aaac53b849ab07d4$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 

});
parcelRegister("0dzo3", function(module, exports) {

$parcel$export(module.exports, "default", () => $000a86df99a95c54$export$2e2bcd8739ae039, (v) => $000a86df99a95c54$export$2e2bcd8739ae039 = v);
var $000a86df99a95c54$export$1e511d4a378977f5;
var $000a86df99a95c54$export$2e2bcd8739ae039;
"use strict";
$000a86df99a95c54$export$1e511d4a378977f5 = true;
$000a86df99a95c54$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
        if (acceptedFilesArray.length === 0) return true;
        var fileName = file.name || "";
        var mimeType = (file.type || "").toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, "");
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === ".") return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith("/*")) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, "");
            return mimeType === validType;
        });
    }
    return true;
};

});





parcelRegister("hpkLA", function(module, exports) {
parcelRequire("4IZRg");
parcelRequire("gEbPi");

});
parcelRegister("4IZRg", function(module, exports) {

$parcel$export(module.exports, "Accordion", () => $a84cdd358aacd380$export$a766cd26d0d69044);

var $ayMG0 = parcelRequire("ayMG0");

var $bVdX9 = parcelRequire("bVdX9");

var $2hw4u = parcelRequire("2hw4u");
var $fRJCp = parcelRequire("fRJCp");

var $9QePP = parcelRequire("9QePP");
const $a84cdd358aacd380$export$a766cd26d0d69044 = ({ i: i, isOpen: isOpen, onClick: onClick, children: children, leaderColor: leaderColor })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mb-2 ",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fRJCp.motion).header, {
                initial: false,
                onClick: ()=>onClick(i),
                className: (0, $9QePP.default)("bg-accent h-8 w-full px-3", "lozenge subdued flex cursor-pointer items-center justify-between", isOpen && "mb-2"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            leaderColor && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    backgroundColor: leaderColor
                                },
                                className: "size-2 shrink-0 rounded-full"
                            }),
                            i
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                        animate: {
                            rotate: isOpen ? 0 : 180
                        },
                        transition: {
                            duration: 0.2,
                            ease: "easeInOut"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bVdX9.default), {
                            className: "size-4"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2hw4u.AnimatePresence), {
                initial: false,
                children: isOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).section, {
                    initial: "collapsed",
                    animate: "open",
                    exit: "collapsed",
                    variants: {
                        open: {
                            opacity: 1,
                            height: "auto",
                            transition: {
                                opacity: {
                                    duration: 0.6,
                                    ease: [
                                        0.04,
                                        0.62,
                                        0.23,
                                        0.98
                                    ]
                                },
                                height: {
                                    duration: 0.2,
                                    ease: [
                                        0.04,
                                        0.62,
                                        0.23,
                                        0.98
                                    ]
                                }
                            }
                        },
                        collapsed: {
                            opacity: 0,
                            height: 0,
                            transition: {
                                opacity: {
                                    duration: 0.2,
                                    ease: [
                                        0.04,
                                        0.62,
                                        0.23,
                                        0.98
                                    ]
                                },
                                height: {
                                    duration: 0.6,
                                    ease: [
                                        0.04,
                                        0.62,
                                        0.23,
                                        0.98
                                    ]
                                }
                            }
                        }
                    },
                    children: children
                }, "content")
            })
        ]
    });
};

});
parcelRegister("bVdX9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8adfd75e55196f6e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $8adfd75e55196f6e$var$ChevronUpIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m4.5 15.75 7.5-7.5 7.5 7.5"
    }));
}
const $8adfd75e55196f6e$var$ForwardRef = $acw62.forwardRef($8adfd75e55196f6e$var$ChevronUpIcon);
var $8adfd75e55196f6e$export$2e2bcd8739ae039 = $8adfd75e55196f6e$var$ForwardRef;

});


parcelRegister("gEbPi", function(module, exports) {

$parcel$export(module.exports, "useAccordionList", () => $648a42525f0d6830$export$68b8935ebd900b76);

var $acw62 = parcelRequire("acw62");
function $648a42525f0d6830$export$68b8935ebd900b76({ allowMultiple: allowMultiple = false, initialExpanded: initialExpanded = [] }) {
    const [expanded, setExpanded] = (0, $acw62.useState)(initialExpanded);
    (0, $acw62.useEffect)(()=>{
        setExpanded(initialExpanded);
    }, [
        initialExpanded
    ]);
    const onClick = (0, $acw62.useCallback)((i)=>{
        if (allowMultiple) {
            if (!expanded.includes(i)) setExpanded((prev)=>[
                    ...prev,
                    i
                ]);
            else setExpanded((prev)=>prev.filter((id)=>id !== i));
        } else if (expanded.includes(i)) setExpanded([]);
        else setExpanded([
            i
        ]);
    }, [
        allowMultiple,
        expanded,
        setExpanded
    ]);
    return {
        expanded: expanded,
        setExpanded: setExpanded,
        onClick: onClick
    };
}

});


parcelRegister("bCrQI", function(module, exports) {

$parcel$export(module.exports, "default", () => $840c75a4c108a878$export$2e2bcd8739ae039);

var $iMNXR = parcelRequire("iMNXR");

var $4U8mO = parcelRequire("4U8mO");

var $gpKgp = parcelRequire("gpKgp");
var $840c75a4c108a878$export$2e2bcd8739ae039 = {
    Container: (0, $iMNXR.ActiveEmptyStateContainer),
    RecentlyViewedList: $4U8mO.RecentlyViewedList,
    RecentlyViewedItem: $4U8mO.RecentlyViewedItem,
    QuickActionList: $gpKgp.QuickActionList,
    QuickActionItem: $gpKgp.QuickActionItem
};

});
parcelRegister("iMNXR", function(module, exports) {

$parcel$export(module.exports, "ActiveEmptyStateContainer", () => $684e17290e1463a1$export$290fb96c93c577fa);
/* eslint-disable tailwindcss/enforces-negative-arbitrary-values */ 
var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $2hw4u = parcelRequire("2hw4u");
var $fRJCp = parcelRequire("fRJCp");
function $684e17290e1463a1$export$290fb96c93c577fa({ title: title, description: description, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2hw4u.AnimatePresence), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            exit: {
                opacity: 0
            },
            transition: {
                duration: 1.5,
                ease: "easeInOut"
            },
            className: "flex size-full items-center justify-center",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("max-w-[700px]", "flex flex-col justify-center", "h-full gap-9"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col gap-2.5",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "display-m",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-m subdued",
                                children: description
                            })
                        ]
                    }),
                    children
                ]
            })
        })
    });
}

});

parcelRegister("4U8mO", function(module, exports) {

$parcel$export(module.exports, "RecentlyViewedList", () => $706c4a9f683934ee$export$3faddd67537ad7de);
$parcel$export(module.exports, "RecentlyViewedItem", () => $706c4a9f683934ee$export$8ea691f39ada37d);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $lzNIT = parcelRequire("lzNIT");
function $706c4a9f683934ee$export$3faddd67537ad7de({ title: title = "Recently viewed", children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex w-full flex-col gap-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "lozenge",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                className: "-mx-4 flex flex-col gap-4",
                children: children
            })
        ]
    });
}
function $706c4a9f683934ee$export$8ea691f39ada37d({ href: href, children: children, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: "card w-full",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
            to: href,
            className: (0, $9QePP.default)("flex cursor-pointer items-center gap-4", className),
            children: children
        })
    });
}

});

parcelRegister("gpKgp", function(module, exports) {

$parcel$export(module.exports, "QuickActionList", () => $e3976099b942f4e6$export$fe3c1261cd9e9acc);
$parcel$export(module.exports, "QuickActionItem", () => $e3976099b942f4e6$export$588a67e64705f13d);

var $ayMG0 = parcelRequire("ayMG0");

var $ggKhH = parcelRequire("ggKhH");

var $9QePP = parcelRequire("9QePP");

var $lzNIT = parcelRequire("lzNIT");
function $e3976099b942f4e6$export$fe3c1261cd9e9acc({ title: title = "Quick actions", children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "lozenge",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                className: "-mx-4",
                children: children
            })
        ]
    });
}
function $e3976099b942f4e6$export$588a67e64705f13d({ href: href, label: label, isLoading: isLoading }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
        className: "card w-full cursor-pointer",
        children: [
            href && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lzNIT.Link), {
                to: href,
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ggKhH.default), {
                        className: "stroke-default size-4"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: label
                    })
                ]
            }),
            isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("bg-selected h-5 w-[300px]", "animate-pulse rounded")
            })
        ]
    });
}

});
parcelRegister("ggKhH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd820b171ebe1162$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $bd820b171ebe1162$var$PlusIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 4.5v15m7.5-7.5h-15"
    }));
}
const $bd820b171ebe1162$var$ForwardRef = $acw62.forwardRef($bd820b171ebe1162$var$PlusIcon);
var $bd820b171ebe1162$export$2e2bcd8739ae039 = $bd820b171ebe1162$var$ForwardRef;

});



parcelRegister("gZNMM", function(module, exports) {
$parcel$export(module.exports, "DropdownMenu", () => (parcelRequire("bZayu")).DropdownMenu);
parcelRequire("bZayu");

});
parcelRegister("bZayu", function(module, exports) {

$parcel$export(module.exports, "DropdownMenu", () => $3941693d35c702fa$export$e44a253a59704894);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $dA5Dq = parcelRequire("dA5Dq");
function $3941693d35c702fa$export$e44a253a59704894({ items: items, selectedOptionId: selectedOptionId, className: className, placeholder: placeholder = "Select..." }) {
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const menuRef = (0, $acw62.useRef)(null);
    const buttonRef = (0, $acw62.useRef)(null);
    const [menuPosition, setMenuPosition] = (0, $acw62.useState)({
        top: 0,
        left: 0
    });
    const [isPositioned, setIsPositioned] = (0, $acw62.useState)(false);
    const toggleMenu = ()=>{
        if (isOpen) setIsPositioned(false);
        setIsOpen(!isOpen);
    };
    (0, $acw62.useEffect)(()=>{
        if (isOpen && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setMenuPosition({
                top: rect.bottom + 4,
                left: rect.left
            });
            setIsPositioned(true);
        }
    }, [
        isOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) {
                setIsOpen(false);
                setIsPositioned(false);
            }
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen
    ]);
    const selectedItem = items.find((item)=>item.type === "item" && item.id === selectedOptionId);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: " ",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    ref: buttonRef,
                    onClick: toggleMenu,
                    className: (0, $9QePP.default)("flex w-fit cursor-pointer items-center justify-between gap-4 rounded-md border border-slate-600 px-4 py-1", "subdued transition-colors hover:text-gray-300", className || "body-s"),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "flex flex-1 items-center gap-2",
                            children: [
                                selectedItem?.icon,
                                selectedItem?.label || placeholder
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dA5Dq.default), {
                            className: (0, $9QePP.default)("size-3 transition-transform duration-200", isOpen && "rotate-180")
                        })
                    ]
                }),
                isOpen && /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    ref: menuRef,
                    style: {
                        position: "fixed",
                        top: `${menuPosition.top}px`,
                        left: `${menuPosition.left}px`,
                        opacity: isPositioned ? 1 : 0
                    },
                    className: (0, $9QePP.default)("bg-slate-800 pr-3", "rounded-lg shadow-400", "custom-scrollbar max-h-[400px] overflow-auto p-2", "min-w-[160px]", "flex flex-col gap-1", "z-[10000000]"),
                    children: items.map((entry, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                            children: [
                                entry.type === "divider" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "my-1 h-px bg-slate-600"
                                }, entry.id),
                                entry.type === "header" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: (0, $9QePP.default)("mb-1 px-2 py-1.5", "bg-default-overlay-7 lozenge subdued", index !== 0 && "mt-2"),
                                    children: entry.label
                                }, entry.id),
                                entry.type === "item" && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>{
                                        entry.onClick?.();
                                        setIsOpen(false);
                                    },
                                    className: (0, $9QePP.default)("flex h-[36px] w-full items-center gap-2 rounded-md px-2 py-1.5", "menu-item body-micro cursor-pointer hover:bg-slate-600", selectedOptionId === entry.id && "bg-selected"),
                                    role: "menuitem",
                                    children: [
                                        entry.icon,
                                        entry.label
                                    ]
                                }, entry.id)
                            ]
                        }, entry.id))
                }), document.body)
            ]
        })
    });
}

});
parcelRegister("dA5Dq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e33022247bf2fb5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $9e33022247bf2fb5$var$ChevronDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m19.5 8.25-7.5 7.5-7.5-7.5"
    }));
}
const $9e33022247bf2fb5$var$ForwardRef = $acw62.forwardRef($9e33022247bf2fb5$var$ChevronDownIcon);
var $9e33022247bf2fb5$export$2e2bcd8739ae039 = $9e33022247bf2fb5$var$ForwardRef;

});



parcelRegister("j4C8j", function(module, exports) {
$parcel$export(module.exports, "FloatingMenu", () => (parcelRequire("dkTlU")).FloatingMenu);
$parcel$export(module.exports, "FloatingMenuCommand", () => (parcelRequire("dkTlU")).FloatingMenuCommand);
parcelRequire("dkTlU");

});
parcelRegister("dkTlU", function(module, exports) {

$parcel$export(module.exports, "FloatingMenu", () => $14adc83ecd0ef784$export$695cda69e78edecd);
$parcel$export(module.exports, "FloatingMenuCommand", () => $14adc83ecd0ef784$export$e5bb800d42046587);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $5lq00 = parcelRequire("5lq00");

var $acw62 = parcelRequire("acw62");
function $14adc83ecd0ef784$export$695cda69e78edecd({ children: children, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("menu", {
        className: (0, $9QePP.default)("p-2 px-4", "bg-[rgba(255,255,255,0.02)]", "border border-[rgba(100,116,139,0.12)]", "flex cursor-pointer gap-4 rounded-[10px]", "shadow-[0_2px_3px_0_rgba(0,0,0,0.25)]", className),
        children: children
    });
}
function $14adc83ecd0ef784$export$e5bb800d42046587({ icon: icon, text: text, command: command }) {
    (0, $5lq00.useHotkey)({
        command: command
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "tt-trigger group",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                type: "button",
                className: (0, $9QePP.default)("xs h-5", "quiet flex cursor-pointer items-center gap-2"),
                onClick: ()=>command.onClick(),
                role: "menuitem",
                children: [
                    icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(icon, {
                        className: (0, $9QePP.default)("cursor-pointer stroke-slate-300 group-hover:stroke-white", icon?.props?.className)
                    }),
                    text && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "text-subdued body-s hover:text-default cursor-pointer",
                        children: text
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("z-[100]", "tt-container tt-bottom", "rounded-[10px] ring-0"),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "tt flex items-center justify-center",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-s w-fit whitespace-nowrap text-nowrap",
                        children: command.label
                    })
                })
            })
        ]
    });
}

});
parcelRegister("5lq00", function(module, exports) {

$parcel$export(module.exports, "getShortcutDisplay", () => $aa406711e7208bee$export$259b74f0075ff64);
$parcel$export(module.exports, "useHotkey", () => $aa406711e7208bee$export$2311405e600c7d91);

var $acw62 = parcelRequire("acw62");
const $aa406711e7208bee$var$isMac = ()=>navigator.platform.toUpperCase().indexOf("MAC") >= 0;
const $aa406711e7208bee$export$259b74f0075ff64 = (shortcut)=>{
    if ($aa406711e7208bee$var$isMac() && shortcut.mac) return shortcut.mac;
    if (!$aa406711e7208bee$var$isMac() && shortcut.windows) return shortcut.windows;
    return shortcut.key;
};
const $aa406711e7208bee$var$getModifierKey = (e)=>{
    return $aa406711e7208bee$var$isMac() ? e.metaKey : e.ctrlKey;
};
function $aa406711e7208bee$export$2311405e600c7d91({ command: command }) {
    (0, $acw62.useEffect)(()=>{
        if (command) {
            const handleKeyDown = (e)=>{
                const modifierKey = $aa406711e7208bee$var$getModifierKey(e);
                const key = command.shortcut.key.toLowerCase();
                if (modifierKey && e.key.toLowerCase() === key) {
                    e.preventDefault();
                    command.onClick();
                }
            };
            document.addEventListener("keydown", handleKeyDown);
            return ()=>document.removeEventListener("keydown", handleKeyDown);
        }
    }, [
        command
    ]);
}

});




parcelRegister("67PTG", function(module, exports) {
$parcel$export(module.exports, "NotFoundPage", () => (parcelRequire("4oMrS")).NotFoundPage);
$parcel$export(module.exports, "ErrorPage", () => (parcelRequire("kvGcI")).ErrorPage);
$parcel$export(module.exports, "Dashboard", () => (parcelRequire("TzpgG")).Dashboard);
$parcel$export(module.exports, "dashboardDrawerAtom", () => (parcelRequire("TzpgG")).dashboardDrawerAtom);
$parcel$export(module.exports, "MultiStepForm", () => (parcelRequire("fEJo6")).MultiStepForm);
$parcel$export(module.exports, "ReturnPage", () => (parcelRequire("kbOqr")).ReturnPage);
parcelRequire("5PYuT");
parcelRequire("Sw3Wo");
parcelRequire("hgDT7");
parcelRequire("fEJo6");
parcelRequire("gDrdl");
parcelRequire("6rC3k");

});
parcelRegister("5PYuT", function(module, exports) {
$parcel$export(module.exports, "NotFoundPage", () => (parcelRequire("4oMrS")).NotFoundPage);
parcelRequire("4oMrS");

});
parcelRegister("4oMrS", function(module, exports) {

$parcel$export(module.exports, "NotFoundPage", () => $9b89c49475c81c95$export$31641b61980e511f);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $9b89c49475c81c95$export$31641b61980e511f() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
        className: (0, $9QePP.default)("px-6 py-24", "grid min-h-full place-items-center", "sm:py-32 lg:px-8"),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-cta-primary-default text-base font-semibold",
                    children: "404"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: (0, $9QePP.default)("mt-4", "text-defaultTextColor text-3xl", "font-bold tracking-tight", "sm:text-5xl"),
                    children: "Page not found"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "subdued mt-6 text-base leading-7",
                    children: "Sorry, we couldn\u2019t find the page you\u2019re looking for."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: (0, $9QePP.default)("mt-10", "flex items-center justify-center gap-x-6"),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: "/",
                            className: (0, $9QePP.default)("bg-cta-primary-default px-3.5 py-2.5", "text-sm text-white", "rounded-md font-semibold shadow-sm", "focus-visible:outline-cta-primary-default hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"),
                            children: "Go back home"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                            href: "mailto:hello@humcapital.com",
                            className: "link text-sm font-semibold",
                            children: [
                                "Contact support ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: "\u2192"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

});


parcelRegister("Sw3Wo", function(module, exports) {
$parcel$export(module.exports, "ErrorPage", () => (parcelRequire("kvGcI")).ErrorPage);
parcelRequire("kvGcI");

});
parcelRegister("kvGcI", function(module, exports) {

$parcel$export(module.exports, "ErrorPage", () => $80f4f53ed5595c0d$export$c120a0e80fd44ca6);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $80f4f53ed5595c0d$export$c120a0e80fd44ca6() {
    const title = "Sorry, something went wrong";
    const message = "There was a problem loading this page. If the problem persists, please contact support.";
    return /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
        className: (0, $9QePP.default)("px-6 py-24", "grid min-h-full place-items-center", "sm:py-32 lg:px-8"),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "mt-4",
                    children: title
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "subdued mt-6 text-base leading-7",
                    children: message
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: (0, $9QePP.default)("mt-10", "flex items-center justify-center gap-x-6"),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>window.location.reload(),
                            className: "sm",
                            children: "Refresh Page"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                            href: "mailto:hello@humcapital.com",
                            className: "link text-sm font-semibold",
                            children: [
                                "Contact support ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: "\u2192"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

});


parcelRegister("hgDT7", function(module, exports) {
$parcel$export(module.exports, "Dashboard", () => (parcelRequire("TzpgG")).Dashboard);
$parcel$export(module.exports, "dashboardDrawerAtom", () => (parcelRequire("TzpgG")).dashboardDrawerAtom);
parcelRequire("TzpgG");

});
parcelRegister("TzpgG", function(module, exports) {

$parcel$export(module.exports, "dashboardDrawerAtom", () => $3505ce9773f17a46$export$25a626bf11f356c8);
$parcel$export(module.exports, "Dashboard", () => $3505ce9773f17a46$export$fe82a520fc33e5f4);
/* eslint-disable react/no-unknown-property */ /* eslint-disable tailwindcss/migration-from-tailwind-2 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $bWapG = parcelRequire("bWapG");
var $8a7OE = parcelRequire("8a7OE");

var $9QePP = parcelRequire("9QePP");

var $5mL0X = parcelRequire("5mL0X");
var $fRJCp = parcelRequire("fRJCp");

var $r2uF6 = parcelRequire("r2uF6");
const $3505ce9773f17a46$export$25a626bf11f356c8 = (0, $r2uF6.atom)(true);
function $3505ce9773f17a46$export$fe82a520fc33e5f4({ children: children }) {
    const [menuOpen, setMenuOpen] = (0, $r2uF6.useAtom)($3505ce9773f17a46$export$25a626bf11f356c8);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5mL0X.LayoutGroup), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, $9QePP.default)("h-screen px-4 pt-8", "flex overflow-clip"),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "h-full pb-6",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fRJCp.motion).div, {
                        className: (0, $9QePP.default)("h-full p-6", "flex flex-col", menuOpen ? "w-[320px]" : "w-fit", "border-default bg-slate-50 bg-opacity-[6%]"),
                        style: {
                            borderRadius: "6px",
                            padding: "24px"
                        },
                        layout: "size",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fRJCp.motion).div, {
                                className: (0, $9QePP.default)("flex w-full", menuOpen ? "justify-between" : "items-center justify-center"),
                                layout: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                                        layout: true,
                                        className: (0, $9QePP.default)("mb-6"),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            width: "26",
                                            height: "26",
                                            viewBox: "0 0 26 26",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                    clipPath: "url(#clip0_36708_843)",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                        clipPath: "url(#clip1_36708_843)",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13ZM21.3417 9.0278V8.55836H14.3722C13.4333 8.55836 12.675 8.84725 12.35 9.3528L11.8444 10.3278C10.429 9.22048 8.69385 8.59987 6.89723 8.55836H6.75278L10.3639 13.1806L6.78889 20.1861L7.18612 20.4028L7.58334 19.6445C8.26945 18.3806 8.95556 17.2972 10.4722 16.6472C14.5872 14.8223 15.2629 12.7492 15.8019 11.0954L15.8167 11.05C15.8791 10.8138 15.9637 10.5841 16.0694 10.3639C16.4667 9.20836 16.9722 9.06392 18.7778 9.0278H21.3417ZM14.3419 9.46979C14.4327 9.47628 14.5191 9.51115 14.5889 9.56947C14.6604 9.62253 14.7154 9.69485 14.7473 9.77797C14.7793 9.8611 14.787 9.9516 14.7695 10.0389C14.7548 10.1087 14.7244 10.1743 14.6806 10.2306C14.6368 10.2869 14.5807 10.3325 14.5167 10.3639L14.3 10.4361C14.2471 10.4383 14.1942 10.4298 14.1446 10.4112C14.095 10.3926 14.0496 10.3642 14.0111 10.3278C13.9424 10.2644 13.89 10.1853 13.8586 10.0973C13.8271 10.0092 13.8175 9.91484 13.8306 9.82225C13.8449 9.75666 13.8755 9.69576 13.9197 9.64524C13.9639 9.59472 14.0202 9.55623 14.0833 9.53336C14.1607 9.48555 14.2512 9.46331 14.3419 9.46979Z",
                                                            fill: "white"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                            id: "clip0_36708_843",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                width: "26",
                                                                height: "26",
                                                                fill: "white"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                            id: "clip1_36708_843",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                width: "26",
                                                                height: "26",
                                                                fill: "white"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    menuOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                                        initial: {
                                            opacity: 0
                                        },
                                        animate: {
                                            y: 0,
                                            opacity: 1
                                        },
                                        exit: {
                                            opacity: 0
                                        },
                                        transition: {
                                            duration: 0.4
                                        },
                                        onClick: ()=>setMenuOpen(false),
                                        className: "cursor-pointer",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bWapG.default), {
                                            height: 24,
                                            width: 24,
                                            className: "fill-gray-300 hover:fill-white"
                                        })
                                    })
                                ]
                            }),
                            !menuOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                                layout: "size",
                                className: (0, $9QePP.default)("bg-secondary border-default size-8 h-8 cursor-pointer", "border-default flex items-center justify-center border"),
                                style: {
                                    borderRadius: "80px"
                                },
                                onClick: ()=>setMenuOpen(true),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a7OE.default), {
                                    width: 18,
                                    height: 18
                                })
                            }),
                            menuOpen && children[0]
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                    layout: true,
                    layoutScroll: true,
                    className: (0, $9QePP.default)("size-full px-8 pb-8", "scrollbar scrollbar-track-transparent scrollbar-thumb-slate-600", "overflow-auto"),
                    children: children[1]
                })
            ]
        })
    });
}

});
parcelRegister("bWapG", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b0d305b9025ec6c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $8b0d305b9025ec6c$var$ChevronDoubleLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M4.72 9.47a.75.75 0 0 0 0 1.06l4.25 4.25a.75.75 0 1 0 1.06-1.06L6.31 10l3.72-3.72a.75.75 0 1 0-1.06-1.06L4.72 9.47Zm9.25-4.25L9.72 9.47a.75.75 0 0 0 0 1.06l4.25 4.25a.75.75 0 1 0 1.06-1.06L11.31 10l3.72-3.72a.75.75 0 0 0-1.06-1.06Z",
        clipRule: "evenodd"
    }));
}
const $8b0d305b9025ec6c$var$ForwardRef = $acw62.forwardRef($8b0d305b9025ec6c$var$ChevronDoubleLeftIcon);
var $8b0d305b9025ec6c$export$2e2bcd8739ae039 = $8b0d305b9025ec6c$var$ForwardRef;

});

parcelRegister("8a7OE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f1552018762e5c2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $5f1552018762e5c2$var$ListBulletIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M6 4.75A.75.75 0 0 1 6.75 4h10.5a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 4.75ZM6 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 10Zm0 5.25a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1-.75-.75ZM1.99 4.75a1 1 0 0 1 1-1H3a1 1 0 0 1 1 1v.01a1 1 0 0 1-1 1h-.01a1 1 0 0 1-1-1v-.01ZM1.99 15.25a1 1 0 0 1 1-1H3a1 1 0 0 1 1 1v.01a1 1 0 0 1-1 1h-.01a1 1 0 0 1-1-1v-.01ZM1.99 10a1 1 0 0 1 1-1H3a1 1 0 0 1 1 1v.01a1 1 0 0 1-1 1h-.01a1 1 0 0 1-1-1V10Z",
        clipRule: "evenodd"
    }));
}
const $5f1552018762e5c2$var$ForwardRef = $acw62.forwardRef($5f1552018762e5c2$var$ListBulletIcon);
var $5f1552018762e5c2$export$2e2bcd8739ae039 = $5f1552018762e5c2$var$ForwardRef;

});

parcelRegister("5mL0X", function(module, exports) {

$parcel$export(module.exports, "LayoutGroup", () => $f38e3304a6cbbfa3$export$7fe0cbe305f29bb4);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $cNR5T = parcelRequire("cNR5T");

var $e9he3 = parcelRequire("e9he3");

var $1kT8Y = parcelRequire("1kT8Y");

var $97p2i = parcelRequire("97p2i");
const $f38e3304a6cbbfa3$var$shouldInheritGroup = (inherit)=>inherit === true;
const $f38e3304a6cbbfa3$var$shouldInheritId = (inherit)=>$f38e3304a6cbbfa3$var$shouldInheritGroup(inherit === true) || inherit === "id";
const $f38e3304a6cbbfa3$export$7fe0cbe305f29bb4 = ({ children: children, id: id, inherit: inherit = true })=>{
    const layoutGroupContext = (0, $acw62.useContext)((0, $cNR5T.LayoutGroupContext));
    const deprecatedLayoutGroupContext = (0, $acw62.useContext)((0, $e9he3.DeprecatedLayoutGroupContext));
    const [forceRender, key] = (0, $1kT8Y.useForceUpdate)();
    const context = (0, $acw62.useRef)(null);
    const upstreamId = layoutGroupContext.id || deprecatedLayoutGroupContext;
    if (context.current === null) {
        if ($f38e3304a6cbbfa3$var$shouldInheritId(inherit) && upstreamId) id = id ? upstreamId + "-" + id : upstreamId;
        context.current = {
            id: id,
            group: $f38e3304a6cbbfa3$var$shouldInheritGroup(inherit) ? layoutGroupContext.group || (0, $97p2i.nodeGroup)() : (0, $97p2i.nodeGroup)()
        };
    }
    const memoizedContext = (0, $acw62.useMemo)(()=>({
            ...context.current,
            forceRender: forceRender
        }), [
        key
    ]);
    return (0, $ayMG0.jsx)((0, $cNR5T.LayoutGroupContext).Provider, {
        value: memoizedContext,
        children: children
    });
};

});
parcelRegister("e9he3", function(module, exports) {

$parcel$export(module.exports, "DeprecatedLayoutGroupContext", () => $bc54d4fcbe865063$export$f3b8df5418bf8d44);

var $acw62 = parcelRequire("acw62");
/**
 * Note: Still used by components generated by old versions of Framer
 *
 * @deprecated
 */ const $bc54d4fcbe865063$export$f3b8df5418bf8d44 = (0, $acw62.createContext)(null);

});

parcelRegister("1kT8Y", function(module, exports) {

$parcel$export(module.exports, "useForceUpdate", () => $0316e1262c81ebb4$export$91db9bc4f8ac944a);

var $acw62 = parcelRequire("acw62");

var $fMJ90 = parcelRequire("fMJ90");

var $hjgf3 = parcelRequire("hjgf3");
function $0316e1262c81ebb4$export$91db9bc4f8ac944a() {
    const isMounted = (0, $fMJ90.useIsMounted)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $acw62.useState)(0);
    const forceRender = (0, $acw62.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $acw62.useCallback)(()=>(0, $hjgf3.frame).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}

});
parcelRegister("fMJ90", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c0a2e592950340df$export$80c2a3957bcb42ea);

var $acw62 = parcelRequire("acw62");

var $6S63t = parcelRequire("6S63t");
function $c0a2e592950340df$export$80c2a3957bcb42ea() {
    const isMounted = (0, $acw62.useRef)(false);
    (0, $6S63t.useIsomorphicLayoutEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}

});


parcelRegister("97p2i", function(module, exports) {

$parcel$export(module.exports, "nodeGroup", () => $44632392a5c0b426$export$df39f9da6f278ce7);
const $44632392a5c0b426$var$notify = (node)=>!node.isLayoutDirty && node.willUpdate(false);
function $44632392a5c0b426$export$df39f9da6f278ce7() {
    const nodes = new Set();
    const subscriptions = new WeakMap();
    const dirtyAll = ()=>nodes.forEach($44632392a5c0b426$var$notify);
    return {
        add: (node)=>{
            nodes.add(node);
            subscriptions.set(node, node.addEventListener("willUpdate", dirtyAll));
        },
        remove: (node)=>{
            nodes.delete(node);
            const unsubscribe = subscriptions.get(node);
            if (unsubscribe) {
                unsubscribe();
                subscriptions.delete(node);
            }
            dirtyAll();
        },
        dirty: dirtyAll
    };
}

});




parcelRegister("fEJo6", function(module, exports) {

$parcel$export(module.exports, "MultiStepForm", () => $a4dcf30522ef12a9$export$b4f292864edeb82b);

var $fwck7 = parcelRequire("fwck7");

var $4d3zV = parcelRequire("4d3zV");

var $4EalK = parcelRequire("4EalK");

var $iXzzd = parcelRequire("iXzzd");

var $8yHvn = parcelRequire("8yHvn");

var $bruOF = parcelRequire("bruOF");

var $3HPvp = parcelRequire("3HPvp");

var $kEKBb = parcelRequire("kEKBb");
const $a4dcf30522ef12a9$export$b4f292864edeb82b = {
    Container: $fwck7.Container,
    Step: $4EalK.Step,
    Steps: $4d3zV.Steps,
    Header: $iXzzd.Header,
    Video: $8yHvn.Video,
    TextBlock: $bruOF.TextBlock,
    MobileSteps: $3HPvp.MobileSteps,
    MobileStep: $3HPvp.MobileStep,
    Bifold: $kEKBb.Bifold
};

});
parcelRegister("fwck7", function(module, exports) {

$parcel$export(module.exports, "Container", () => $e6bafab8ddf37154$export$42a852a2b6b56249);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $2hw4u = parcelRequire("2hw4u");
var $fRJCp = parcelRequire("fRJCp");
const $e6bafab8ddf37154$export$42a852a2b6b56249 = ({ children: children, centered: centered, className: className })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2hw4u.AnimatePresence), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).main, {
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            exit: {
                opacity: 0
            },
            className: (0, $9QePP.default)("min-h-screen lg:max-h-screen lg:overflow-hidden", centered ? "flex justify-center px-10 lg:px-0" : "px-10 pt-20 lg:px-[100px] xl:px-[180px] 2xl:px-[300px]", className),
            children: children
        })
    });
};

});

parcelRegister("4d3zV", function(module, exports) {

$parcel$export(module.exports, "Steps", () => $58064bd42f84e700$export$fb587a27d5a722e7);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
const $58064bd42f84e700$export$fb587a27d5a722e7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("border-y border-slate-700", "flex-col", "items-start justify-start", "divide-y divide-slate-700", "hidden lg:flex"),
        children: children
    });
};

});

parcelRegister("4EalK", function(module, exports) {

$parcel$export(module.exports, "Step", () => $0e431f86c93fd7b0$export$fd55ce593607084a);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("18L7n");
var $hUCih = parcelRequire("hUCih");

var $9QePP = parcelRequire("9QePP");
const $0e431f86c93fd7b0$export$fd55ce593607084a = ({ active: active = false, completed: completed = false, text: text })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex w-full gap-8 py-7",
        children: [
            active && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).MapPin, {}),
            completed && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).Check, {}),
            !active && !completed && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).StepInProgress, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: (0, $9QePP.default)("heading-m", {
                    subdued: !active
                }),
                children: text
            })
        ]
    });
};

});

parcelRegister("iXzzd", function(module, exports) {

$parcel$export(module.exports, "Header", () => $c39a9729eee7b95f$export$8b251419efc915eb);

var $ayMG0 = parcelRequire("ayMG0");
const $c39a9729eee7b95f$export$8b251419efc915eb = ({ title: title, description: description })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "display-s lg:display-l mb-4 lg:mb-6",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "body-l lg:mb-6",
                children: description
            })
        ]
    });
};

});

parcelRegister("8yHvn", function(module, exports) {

$parcel$export(module.exports, "Video", () => $6d49d8e3cd2f7e1c$export$ae01dedf5c052bb);

var $ayMG0 = parcelRequire("ayMG0");

var $5HdXb = parcelRequire("5HdXb");

var $7LrgD = parcelRequire("7LrgD");

var $9QePP = parcelRequire("9QePP");
const $6d49d8e3cd2f7e1c$export$ae01dedf5c052bb = ({ src: src, isNotPlaying: isNotPlaying, onPlay: onPlay, videoId: videoId })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("w-full", "h-full", "mb-8", "relative inline-block overflow-hidden rounded"),
        children: [
            isNotPlaying && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                role: "button",
                onClick: onPlay,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        width: "100%",
                        src: src,
                        className: (0, $9QePP.default)("no-lazy", "rounded", "overflow-hidden", "peer transition-transform duration-200 hover:scale-125"),
                        alt: "investor video",
                        decoding: "async",
                        srcSet: "https://humcapital.com/wp-content/uploads/2023/01/Investor-Video-thumbnail.png 880w, https://humcapital.com/wp-content/uploads/2023/01/Investor-Video-thumbnail-300x169.png 300w, https://humcapital.com/wp-content/uploads/2023/01/Investor-Video-thumbnail-600x338.png 600w, https://humcapital.com/wp-content/uploads/2023/01/Investor-Video-thumbnail-768x432.png 768w, https://humcapital.com/wp-content/uploads/2023/01/Investor-Video-thumbnail-400x225.png 400w, https://humcapital.com/wp-content/uploads/2023/01/Investor-Video-thumbnail-110x62.png 110w",
                        sizes: "(max-width: 880px) 100vw, 880px"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5HdXb.default), {
                        height: 88,
                        className: (0, $9QePP.default)("-translate-x-1/2 -translate-y-1/2", "absolute left-1/2 top-1/2 z-10 fill-slate-500 hover:fill-slate-600")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7LrgD.default), {
                video: videoId,
                width: "500",
                showTitle: false,
                showPortrait: false,
                paused: isNotPlaying,
                responsive: true,
                className: (0, $9QePP.default)("rounded", {
                    hidden: isNotPlaying
                })
            })
        ]
    });
};

});
parcelRegister("5HdXb", function(module, exports) {

$parcel$export(module.exports, "default", () => $425bcacc5e6c16fd$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $425bcacc5e6c16fd$var$PlayCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.024-.983a1.125 1.125 0 0 1 0 1.966l-5.603 3.113A1.125 1.125 0 0 1 9 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113Z",
        clipRule: "evenodd"
    }));
}
const $425bcacc5e6c16fd$var$ForwardRef = $acw62.forwardRef($425bcacc5e6c16fd$var$PlayCircleIcon);
var $425bcacc5e6c16fd$export$2e2bcd8739ae039 = $425bcacc5e6c16fd$var$ForwardRef;

});

parcelRegister("7LrgD", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a7212ee265a9400$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $jrbHC = parcelRequire("jrbHC");
function $5a7212ee265a9400$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $5a7212ee265a9400$var$_setPrototypeOf(t, o);
}
function $5a7212ee265a9400$var$_setPrototypeOf(t, e) {
    return $5a7212ee265a9400$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $5a7212ee265a9400$var$_setPrototypeOf(t, e);
}
var $5a7212ee265a9400$var$eventNames = {
    play: "onPlay",
    playing: "onPlaying",
    pause: "onPause",
    ended: "onEnd",
    timeupdate: "onTimeUpdate",
    progress: "onProgress",
    seeked: "onSeeked",
    texttrackchange: "onTextTrackChange",
    cuechange: "onCueChange",
    cuepoint: "onCuePoint",
    volumechange: "onVolumeChange",
    playbackratechange: "onPlaybackRateChange",
    error: "onError",
    loaded: "onLoaded"
};
var $5a7212ee265a9400$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function Vimeo(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.refContainer = _this.refContainer.bind(_this);
        return _this;
    }
    $5a7212ee265a9400$var$_inheritsLoose(Vimeo, _React$Component);
    var _proto = Vimeo.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.createPlayer();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this2 = this;
        // eslint-disable-next-line react/destructuring-assignment
        var changes = Object.keys(this.props).filter(function(name) {
            return _this2.props[name] !== prevProps[name];
        });
        this.updateProps(changes);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.player.destroy();
    } /**
   * @private
   */ ;
    _proto.getInitialOptions = function getInitialOptions() {
        var _ref;
        var video = this.props.video;
        var videoType = /^https?:/i.test(video) ? "url" : "id";
        /* eslint-disable react/destructuring-assignment */ return _ref = {}, _ref[videoType] = video, _ref.width = this.props.width, _ref.height = this.props.height, _ref.autopause = this.props.autopause, _ref.autoplay = this.props.autoplay, _ref.byline = this.props.showByline, _ref.color = this.props.color, _ref.controls = this.props.controls, _ref.loop = this.props.loop, _ref.portrait = this.props.showPortrait, _ref.title = this.props.showTitle, _ref.muted = this.props.muted, _ref.background = this.props.background, _ref.responsive = this.props.responsive, _ref.dnt = this.props.dnt, _ref.speed = this.props.speed, _ref.keyboard = this.props.keyboard, _ref.pip = this.props.pip, _ref.playsinline = this.props.playsInline, _ref.quality = this.props.quality, _ref.texttrack = this.props.textTrack, _ref.transparent = this.props.transparent, _ref;
    /* eslint-enable react/destructuring-assignment */ } /**
   * @private
   */ ;
    _proto.updateProps = function updateProps(propNames) {
        var _this3 = this;
        var player = this.player;
        propNames.forEach(function(name) {
            // eslint-disable-next-line react/destructuring-assignment
            var value = _this3.props[name];
            switch(name){
                case "autopause":
                    player.setAutopause(value);
                    break;
                case "color":
                    player.setColor(value);
                    break;
                case "loop":
                    player.setLoop(value);
                    break;
                case "volume":
                    player.setVolume(value);
                    break;
                case "paused":
                    player.getPaused().then(function(paused) {
                        if (value && !paused) return player.pause();
                        if (!value && paused) return player.play();
                        return null;
                    });
                    break;
                case "width":
                case "height":
                    player.element[name] = value;
                    break;
                case "video":
                    if (value) {
                        var start = _this3.props.start;
                        var loaded = player.loadVideo(value);
                        // Set the start time only when loading a new video.
                        // It seems like this has to be done after the video has loaded, else it just starts at
                        // the beginning!
                        if (typeof start === "number") loaded.then(function() {
                            player.setCurrentTime(start);
                        });
                    } else player.unload();
                    break;
                case "playbackRate":
                    player.setPlaybackRate(value);
                    break;
                case "quality":
                    player.setQuality(value);
                    break;
            }
        });
    } /**
   * @private
   */ ;
    _proto.createPlayer = function createPlayer() {
        var _this4 = this;
        var _this$props = this.props, start = _this$props.start, volume = _this$props.volume, playbackRate = _this$props.playbackRate;
        this.player = new (0, $jrbHC.default)(this.container, this.getInitialOptions());
        Object.keys($5a7212ee265a9400$var$eventNames).forEach(function(dmName) {
            var reactName = $5a7212ee265a9400$var$eventNames[dmName];
            _this4.player.on(dmName, function(event) {
                // eslint-disable-next-line react/destructuring-assignment
                var handler = _this4.props[reactName];
                if (handler) handler(event);
            });
        });
        var _this$props2 = this.props, onError = _this$props2.onError, onReady = _this$props2.onReady;
        this.player.ready().then(function() {
            if (onReady) onReady(_this4.player);
        }, function(err) {
            if (onError) onError(err);
            else throw err;
        });
        if (typeof start === "number") this.player.setCurrentTime(start);
        if (typeof volume === "number") this.updateProps([
            "volume"
        ]);
        if (typeof playbackRate === "number") this.updateProps([
            "playbackRate"
        ]);
    } /**
   * @private
   */ ;
    _proto.refContainer = function refContainer(container) {
        this.container = container;
    };
    _proto.render = function render() {
        var _this$props3 = this.props, id = _this$props3.id, className = _this$props3.className, style = _this$props3.style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            id: id,
            className: className,
            style: style,
            ref: this.refContainer
        });
    };
    return Vimeo;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$5a7212ee265a9400$export$2e2bcd8739ae039.defaultProps = {
    autopause: true,
    autoplay: false,
    showByline: true,
    controls: true,
    loop: false,
    showPortrait: true,
    showTitle: true,
    muted: false,
    background: false,
    responsive: false,
    dnt: false,
    speed: false,
    keyboard: true,
    pip: false,
    playsInline: true,
    transparent: true
};

});
parcelRegister("jrbHC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2699dd4b9c01f75$export$2e2bcd8739ae039);
/*! @vimeo/player v2.23.0 | (c) 2024 Vimeo | MIT License | https://github.com/vimeo/player.js */ function $e2699dd4b9c01f75$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e2699dd4b9c01f75$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e2699dd4b9c01f75$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e2699dd4b9c01f75$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e2699dd4b9c01f75$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e2699dd4b9c01f75$var$_regeneratorRuntime() {
    $e2699dd4b9c01f75$var$_regeneratorRuntime = function() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self1, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self1, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self1, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self1, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self1, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self1, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function $e2699dd4b9c01f75$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $e2699dd4b9c01f75$var$_asyncToGenerator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                $e2699dd4b9c01f75$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $e2699dd4b9c01f75$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $e2699dd4b9c01f75$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e2699dd4b9c01f75$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e2699dd4b9c01f75$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e2699dd4b9c01f75$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e2699dd4b9c01f75$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e2699dd4b9c01f75$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e2699dd4b9c01f75$var$_defineProperty(obj, key, value) {
    key = $e2699dd4b9c01f75$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e2699dd4b9c01f75$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e2699dd4b9c01f75$var$_setPrototypeOf(subClass, superClass);
}
function $e2699dd4b9c01f75$var$_getPrototypeOf(o) {
    $e2699dd4b9c01f75$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e2699dd4b9c01f75$var$_getPrototypeOf(o);
}
function $e2699dd4b9c01f75$var$_setPrototypeOf(o, p) {
    $e2699dd4b9c01f75$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e2699dd4b9c01f75$var$_setPrototypeOf(o, p);
}
function $e2699dd4b9c01f75$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e2699dd4b9c01f75$var$_construct(Parent, args, Class) {
    if ($e2699dd4b9c01f75$var$_isNativeReflectConstruct()) $e2699dd4b9c01f75$var$_construct = Reflect.construct.bind();
    else $e2699dd4b9c01f75$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $e2699dd4b9c01f75$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $e2699dd4b9c01f75$var$_construct.apply(null, arguments);
}
function $e2699dd4b9c01f75$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $e2699dd4b9c01f75$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $e2699dd4b9c01f75$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$e2699dd4b9c01f75$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $e2699dd4b9c01f75$var$_construct(Class, arguments, $e2699dd4b9c01f75$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $e2699dd4b9c01f75$var$_setPrototypeOf(Wrapper, Class);
    };
    return $e2699dd4b9c01f75$var$_wrapNativeSuper(Class);
}
function $e2699dd4b9c01f75$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $e2699dd4b9c01f75$var$_possibleConstructorReturn(self1, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e2699dd4b9c01f75$var$_assertThisInitialized(self1);
}
function $e2699dd4b9c01f75$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e2699dd4b9c01f75$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e2699dd4b9c01f75$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e2699dd4b9c01f75$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e2699dd4b9c01f75$var$_possibleConstructorReturn(this, result);
    };
}
function $e2699dd4b9c01f75$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e2699dd4b9c01f75$var$_toPropertyKey(arg) {
    var key = $e2699dd4b9c01f75$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
/**
 * @module lib/functions
 */ /**
 * Check to see this is a node environment.
 * @type {Boolean}
 */ /* global global */ var $e2699dd4b9c01f75$var$isNode = typeof $parcel$global !== "undefined" && ({}).toString.call($parcel$global) === "[object global]";
/**
 * Get the name of the method for a given getter or setter.
 *
 * @param {string} prop The name of the property.
 * @param {string} type Either “get” or “set”.
 * @return {string}
 */ function $e2699dd4b9c01f75$var$getMethodName(prop, type) {
    if (prop.indexOf(type.toLowerCase()) === 0) return prop;
    return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
}
/**
 * Check to see if the object is a DOM Element.
 *
 * @param {*} element The object to check.
 * @return {boolean}
 */ function $e2699dd4b9c01f75$var$isDomElement(element) {
    return Boolean(element && element.nodeType === 1 && "nodeName" in element && element.ownerDocument && element.ownerDocument.defaultView);
}
/**
 * Check to see whether the value is a number.
 *
 * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
 * @param {*} value The value to check.
 * @param {boolean} integer Check if the value is an integer.
 * @return {boolean}
 */ function $e2699dd4b9c01f75$var$isInteger(value) {
    // eslint-disable-next-line eqeqeq
    return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
}
/**
 * Check to see if the URL is a Vimeo url.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */ function $e2699dd4b9c01f75$var$isVimeoUrl(url) {
    return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.videoji\.hk))(?=$|\/)/.test(url);
}
/**
 * Check to see if the URL is for a Vimeo embed.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */ function $e2699dd4b9c01f75$var$isVimeoEmbed(url) {
    var expr = /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.videoji\.hk))\/video\/\d+/;
    return expr.test(url);
}
function $e2699dd4b9c01f75$var$getOembedDomain(url) {
    var match = (url || "").match(/^(?:https?:)?(?:\/\/)?([^/?]+)/);
    var domain = (match && match[1] || "").replace("player.", "");
    if (domain.endsWith(".videoji.hk")) return domain;
    return "vimeo.com";
}
/**
 * Get the Vimeo URL from an element.
 * The element must have either a data-vimeo-id or data-vimeo-url attribute.
 *
 * @param {object} oEmbedParameters The oEmbed parameters.
 * @return {string}
 */ function $e2699dd4b9c01f75$var$getVimeoUrl() {
    var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id = oEmbedParameters.id;
    var url = oEmbedParameters.url;
    var idOrUrl = id || url;
    if (!idOrUrl) throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
    if ($e2699dd4b9c01f75$var$isInteger(idOrUrl)) return "https://vimeo.com/".concat(idOrUrl);
    if ($e2699dd4b9c01f75$var$isVimeoUrl(idOrUrl)) return idOrUrl.replace("http:", "https:");
    if (id) throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
    throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
}
/* eslint-disable max-params */ /**
 * A utility method for attaching and detaching event handlers
 *
 * @param {EventTarget} target
 * @param {string | string[]} eventName
 * @param {function} callback
 * @param {'addEventListener' | 'on'} onName
 * @param {'removeEventListener' | 'off'} offName
 * @return {{cancel: (function(): void)}}
 */ var $e2699dd4b9c01f75$var$subscribe = function subscribe(target, eventName, callback) {
    var onName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "addEventListener";
    var offName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "removeEventListener";
    var eventNames = typeof eventName === "string" ? [
        eventName
    ] : eventName;
    eventNames.forEach(function(evName) {
        target[onName](evName, callback);
    });
    return {
        cancel: function cancel() {
            return eventNames.forEach(function(evName) {
                return target[offName](evName, callback);
            });
        }
    };
};
var $e2699dd4b9c01f75$var$arrayIndexOfSupport = typeof Array.prototype.indexOf !== "undefined";
var $e2699dd4b9c01f75$var$postMessageSupport = typeof window !== "undefined" && typeof window.postMessage !== "undefined";
if (!$e2699dd4b9c01f75$var$isNode && (!$e2699dd4b9c01f75$var$arrayIndexOfSupport || !$e2699dd4b9c01f75$var$postMessageSupport)) throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
var $e2699dd4b9c01f75$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $e2699dd4b9c01f75$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */ (function(self1) {
    if (self1.WeakMap) return;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var hasDefine = Object.defineProperty && function() {
        try {
            // Avoid IE8's broken Object.defineProperty
            return Object.defineProperty({}, "x", {
                value: 1
            }).x === 1;
        } catch (e) {}
    }();
    var defineProperty = function(object, name, value) {
        if (hasDefine) Object.defineProperty(object, name, {
            configurable: true,
            writable: true,
            value: value
        });
        else object[name] = value;
    };
    self1.WeakMap = function() {
        // ECMA-262 23.3 WeakMap Objects
        function WeakMap1() {
            if (this === void 0) throw new TypeError("Constructor WeakMap requires 'new'");
            defineProperty(this, "_id", genId("_WeakMap"));
            // ECMA-262 23.3.1.1 WeakMap([iterable])
            if (arguments.length > 0) // Currently, WeakMap `iterable` argument is not supported
            throw new TypeError("WeakMap iterable is not supported");
        }
        // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
        defineProperty(WeakMap1.prototype, "delete", function(key) {
            checkInstance(this, "delete");
            if (!isObject(key)) return false;
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                delete key[this._id];
                return true;
            }
            return false;
        });
        // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
        defineProperty(WeakMap1.prototype, "get", function(key) {
            checkInstance(this, "get");
            if (!isObject(key)) return void 0;
            var entry = key[this._id];
            if (entry && entry[0] === key) return entry[1];
            return void 0;
        });
        // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
        defineProperty(WeakMap1.prototype, "has", function(key) {
            checkInstance(this, "has");
            if (!isObject(key)) return false;
            var entry = key[this._id];
            if (entry && entry[0] === key) return true;
            return false;
        });
        // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
        defineProperty(WeakMap1.prototype, "set", function(key, value) {
            checkInstance(this, "set");
            if (!isObject(key)) throw new TypeError("Invalid value used as weak map key");
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                entry[1] = value;
                return this;
            }
            defineProperty(key, this._id, [
                key,
                value
            ]);
            return this;
        });
        function checkInstance(x, methodName) {
            if (!isObject(x) || !hasOwnProperty.call(x, "_id")) throw new TypeError(methodName + " method called on incompatible receiver " + typeof x);
        }
        function genId(prefix) {
            return prefix + "_" + rand() + "." + rand();
        }
        function rand() {
            return Math.random().toString().substring(2);
        }
        defineProperty(WeakMap1, "_polyfill", true);
        return WeakMap1;
    }();
    function isObject(x) {
        return Object(x) === x;
    }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $e2699dd4b9c01f75$var$commonjsGlobal !== "undefined" ? $e2699dd4b9c01f75$var$commonjsGlobal : $e2699dd4b9c01f75$var$commonjsGlobal);
var $e2699dd4b9c01f75$var$npo_src = $e2699dd4b9c01f75$var$createCommonjsModule(function(module) {
    /*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/ (function UMD(name, context, definition) {
        // special form of UMD for polyfilling across evironments
        context[name] = context[name] || definition();
        if (module.exports) module.exports = context[name];
    })("Promise", typeof $e2699dd4b9c01f75$var$commonjsGlobal != "undefined" ? $e2699dd4b9c01f75$var$commonjsGlobal : $e2699dd4b9c01f75$var$commonjsGlobal, function DEF() {
        var builtInProp, cycle, scheduling_queue, ToString = Object.prototype.toString, timer = typeof setImmediate != "undefined" ? function timer(fn) {
            return setImmediate(fn);
        } : setTimeout;
        // dammit, IE8.
        try {
            Object.defineProperty({}, "x", {});
            builtInProp = function builtInProp(obj, name, val, config) {
                return Object.defineProperty(obj, name, {
                    value: val,
                    writable: true,
                    configurable: config !== false
                });
            };
        } catch (err) {
            builtInProp = function builtInProp(obj, name, val) {
                obj[name] = val;
                return obj;
            };
        }
        // Note: using a queue instead of array for efficiency
        scheduling_queue = function Queue() {
            var first, last, item;
            function Item(fn, self1) {
                this.fn = fn;
                this.self = self1;
                this.next = void 0;
            }
            return {
                add: function add(fn, self1) {
                    item = new Item(fn, self1);
                    if (last) last.next = item;
                    else first = item;
                    last = item;
                    item = void 0;
                },
                drain: function drain() {
                    var f = first;
                    first = last = cycle = void 0;
                    while(f){
                        f.fn.call(f.self);
                        f = f.next;
                    }
                }
            };
        }();
        function schedule(fn, self1) {
            scheduling_queue.add(fn, self1);
            if (!cycle) cycle = timer(scheduling_queue.drain);
        }
        // promise duck typing
        function isThenable(o) {
            var _then, o_type = typeof o;
            if (o != null && (o_type == "object" || o_type == "function")) _then = o.then;
            return typeof _then == "function" ? _then : false;
        }
        function notify() {
            for(var i = 0; i < this.chain.length; i++)notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
            this.chain.length = 0;
        }
        // NOTE: This is a separate function to isolate
        // the `try..catch` so that other code can be
        // optimized better
        function notifyIsolated(self1, cb, chain) {
            var ret, _then;
            try {
                if (cb === false) chain.reject(self1.msg);
                else {
                    if (cb === true) ret = self1.msg;
                    else ret = cb.call(void 0, self1.msg);
                    if (ret === chain.promise) chain.reject(TypeError("Promise-chain cycle"));
                    else if (_then = isThenable(ret)) _then.call(ret, chain.resolve, chain.reject);
                    else chain.resolve(ret);
                }
            } catch (err) {
                chain.reject(err);
            }
        }
        function resolve(msg) {
            var _then, self1 = this;
            // already triggered?
            if (self1.triggered) return;
            self1.triggered = true;
            // unwrap
            if (self1.def) self1 = self1.def;
            try {
                if (_then = isThenable(msg)) schedule(function() {
                    var def_wrapper = new MakeDefWrapper(self1);
                    try {
                        _then.call(msg, function $resolve$() {
                            resolve.apply(def_wrapper, arguments);
                        }, function $reject$() {
                            reject.apply(def_wrapper, arguments);
                        });
                    } catch (err) {
                        reject.call(def_wrapper, err);
                    }
                });
                else {
                    self1.msg = msg;
                    self1.state = 1;
                    if (self1.chain.length > 0) schedule(notify, self1);
                }
            } catch (err) {
                reject.call(new MakeDefWrapper(self1), err);
            }
        }
        function reject(msg) {
            var self1 = this;
            // already triggered?
            if (self1.triggered) return;
            self1.triggered = true;
            // unwrap
            if (self1.def) self1 = self1.def;
            self1.msg = msg;
            self1.state = 2;
            if (self1.chain.length > 0) schedule(notify, self1);
        }
        function iteratePromises(Constructor, arr, resolver, rejecter) {
            for(var idx = 0; idx < arr.length; idx++)(function IIFE(idx) {
                Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
                    resolver(idx, msg);
                }, rejecter);
            })(idx);
        }
        function MakeDefWrapper(self1) {
            this.def = self1;
            this.triggered = false;
        }
        function MakeDef(self1) {
            this.promise = self1;
            this.state = 0;
            this.triggered = false;
            this.chain = [];
            this.msg = void 0;
        }
        function Promise1(executor) {
            if (typeof executor != "function") throw TypeError("Not a function");
            if (this.__NPO__ !== 0) throw TypeError("Not a promise");
            // instance shadowing the inherited "brand"
            // to signal an already "initialized" promise
            this.__NPO__ = 1;
            var def = new MakeDef(this);
            this["then"] = function then(success, failure) {
                var o = {
                    success: typeof success == "function" ? success : true,
                    failure: typeof failure == "function" ? failure : false
                };
                // Note: `then(..)` itself can be borrowed to be used against
                // a different promise constructor for making the chained promise,
                // by substituting a different `this` binding.
                o.promise = new this.constructor(function extractChain(resolve, reject) {
                    if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                    o.resolve = resolve;
                    o.reject = reject;
                });
                def.chain.push(o);
                if (def.state !== 0) schedule(notify, def);
                return o.promise;
            };
            this["catch"] = function $catch$(failure) {
                return this.then(void 0, failure);
            };
            try {
                executor.call(void 0, function publicResolve(msg) {
                    resolve.call(def, msg);
                }, function publicReject(msg) {
                    reject.call(def, msg);
                });
            } catch (err) {
                reject.call(def, err);
            }
        }
        var PromisePrototype = builtInProp({}, "constructor", Promise1, /*configurable=*/ false);
        // Note: Android 4 cannot use `Object.defineProperty(..)` here
        Promise1.prototype = PromisePrototype;
        // built-in "brand" to signal an "uninitialized" promise
        builtInProp(PromisePrototype, "__NPO__", 0, /*configurable=*/ false);
        builtInProp(Promise1, "resolve", function Promise$resolve(msg) {
            var Constructor = this;
            // spec mandated checks
            // note: best "isPromise" check that's practical for now
            if (msg && typeof msg == "object" && msg.__NPO__ === 1) return msg;
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                resolve(msg);
            });
        });
        builtInProp(Promise1, "reject", function Promise$reject(msg) {
            return new this(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                reject(msg);
            });
        });
        builtInProp(Promise1, "all", function Promise$all(arr) {
            var Constructor = this;
            // spec mandated checks
            if (ToString.call(arr) != "[object Array]") return Constructor.reject(TypeError("Not an array"));
            if (arr.length === 0) return Constructor.resolve([]);
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                var len = arr.length, msgs = Array(len), count = 0;
                iteratePromises(Constructor, arr, function resolver(idx, msg) {
                    msgs[idx] = msg;
                    if (++count === len) resolve(msgs);
                }, reject);
            });
        });
        builtInProp(Promise1, "race", function Promise$race(arr) {
            var Constructor = this;
            // spec mandated checks
            if (ToString.call(arr) != "[object Array]") return Constructor.reject(TypeError("Not an array"));
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                iteratePromises(Constructor, arr, function resolver(idx, msg) {
                    resolve(msg);
                }, reject);
            });
        });
        return Promise1;
    });
});
/**
 * @module lib/callbacks
 */ var $e2699dd4b9c01f75$var$callbackMap = new WeakMap();
/**
 * Store a callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
 *        The callback to call or an object with resolve and reject functions for a promise.
 * @return {void}
 */ function $e2699dd4b9c01f75$var$storeCallback(player, name, callback) {
    var playerCallbacks = $e2699dd4b9c01f75$var$callbackMap.get(player.element) || {};
    if (!(name in playerCallbacks)) playerCallbacks[name] = [];
    playerCallbacks[name].push(callback);
    $e2699dd4b9c01f75$var$callbackMap.set(player.element, playerCallbacks);
}
/**
 * Get the callbacks for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @return {function[]}
 */ function $e2699dd4b9c01f75$var$getCallbacks(player, name) {
    var playerCallbacks = $e2699dd4b9c01f75$var$callbackMap.get(player.element) || {};
    return playerCallbacks[name] || [];
}
/**
 * Remove a stored callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @param {function} [callback] The specific callback to remove.
 * @return {boolean} Was this the last callback?
 */ function $e2699dd4b9c01f75$var$removeCallback(player, name, callback) {
    var playerCallbacks = $e2699dd4b9c01f75$var$callbackMap.get(player.element) || {};
    if (!playerCallbacks[name]) return true;
    // If no callback is passed, remove all callbacks for the event
    if (!callback) {
        playerCallbacks[name] = [];
        $e2699dd4b9c01f75$var$callbackMap.set(player.element, playerCallbacks);
        return true;
    }
    var index = playerCallbacks[name].indexOf(callback);
    if (index !== -1) playerCallbacks[name].splice(index, 1);
    $e2699dd4b9c01f75$var$callbackMap.set(player.element, playerCallbacks);
    return playerCallbacks[name] && playerCallbacks[name].length === 0;
}
/**
 * Return the first stored callback for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @return {function} The callback, or false if there were none
 */ function $e2699dd4b9c01f75$var$shiftCallbacks(player, name) {
    var playerCallbacks = $e2699dd4b9c01f75$var$getCallbacks(player, name);
    if (playerCallbacks.length < 1) return false;
    var callback = playerCallbacks.shift();
    $e2699dd4b9c01f75$var$removeCallback(player, name, callback);
    return callback;
}
/**
 * Move callbacks associated with an element to another element.
 *
 * @param {HTMLElement} oldElement The old element.
 * @param {HTMLElement} newElement The new element.
 * @return {void}
 */ function $e2699dd4b9c01f75$var$swapCallbacks(oldElement, newElement) {
    var playerCallbacks = $e2699dd4b9c01f75$var$callbackMap.get(oldElement);
    $e2699dd4b9c01f75$var$callbackMap.set(newElement, playerCallbacks);
    $e2699dd4b9c01f75$var$callbackMap.delete(oldElement);
}
/**
 * @module lib/postmessage
 */ /**
 * Parse a message received from postMessage.
 *
 * @param {*} data The data received from postMessage.
 * @return {object}
 */ function $e2699dd4b9c01f75$var$parseMessageData(data) {
    if (typeof data === "string") try {
        data = JSON.parse(data);
    } catch (error) {
        // If the message cannot be parsed, throw the error as a warning
        console.warn(error);
        return {};
    }
    return data;
}
/**
 * Post a message to the specified target.
 *
 * @param {Player} player The player object to use.
 * @param {string} method The API method to call.
 * @param {object} params The parameters to send to the player.
 * @return {void}
 */ function $e2699dd4b9c01f75$var$postMessage(player, method, params) {
    if (!player.element.contentWindow || !player.element.contentWindow.postMessage) return;
    var message = {
        method: method
    };
    if (params !== undefined) message.value = params;
    // IE 8 and 9 do not support passing messages, so stringify them
    var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
    if (ieVersion >= 8 && ieVersion < 10) message = JSON.stringify(message);
    player.element.contentWindow.postMessage(message, player.origin);
}
/**
 * Parse the data received from a message event.
 *
 * @param {Player} player The player that received the message.
 * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
 * @return {void}
 */ function $e2699dd4b9c01f75$var$processData(player, data) {
    data = $e2699dd4b9c01f75$var$parseMessageData(data);
    var callbacks = [];
    var param;
    if (data.event) {
        if (data.event === "error") {
            var promises = $e2699dd4b9c01f75$var$getCallbacks(player, data.data.method);
            promises.forEach(function(promise) {
                var error = new Error(data.data.message);
                error.name = data.data.name;
                promise.reject(error);
                $e2699dd4b9c01f75$var$removeCallback(player, data.data.method, promise);
            });
        }
        callbacks = $e2699dd4b9c01f75$var$getCallbacks(player, "event:".concat(data.event));
        param = data.data;
    } else if (data.method) {
        var callback = $e2699dd4b9c01f75$var$shiftCallbacks(player, data.method);
        if (callback) {
            callbacks.push(callback);
            param = data.value;
        }
    }
    callbacks.forEach(function(callback) {
        try {
            if (typeof callback === "function") {
                callback.call(player, param);
                return;
            }
            callback.resolve(param);
        } catch (e) {
        // empty
        }
    });
}
/**
 * @module lib/embed
 */ var $e2699dd4b9c01f75$var$oEmbedParameters = [
    "airplay",
    "audio_tracks",
    "autopause",
    "autoplay",
    "background",
    "byline",
    "cc",
    "chapter_id",
    "chapters",
    "chromecast",
    "color",
    "colors",
    "controls",
    "dnt",
    "end_time",
    "fullscreen",
    "height",
    "id",
    "interactive_params",
    "keyboard",
    "loop",
    "maxheight",
    "maxwidth",
    "muted",
    "play_button_position",
    "playsinline",
    "portrait",
    "progress_bar",
    "quality_selector",
    "responsive",
    "speed",
    "start_time",
    "texttrack",
    "title",
    "transcript",
    "transparent",
    "url",
    "vimeo_logo",
    "volume",
    "watch_full_video",
    "width"
];
/**
 * Get the 'data-vimeo'-prefixed attributes from an element as an object.
 *
 * @param {HTMLElement} element The element.
 * @param {Object} [defaults={}] The default values to use.
 * @return {Object<string, string>}
 */ function $e2699dd4b9c01f75$var$getOEmbedParameters(element) {
    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $e2699dd4b9c01f75$var$oEmbedParameters.reduce(function(params, param) {
        var value = element.getAttribute("data-vimeo-".concat(param));
        if (value || value === "") params[param] = value === "" ? 1 : value;
        return params;
    }, defaults);
}
/**
 * Create an embed from oEmbed data inside an element.
 *
 * @param {object} data The oEmbed data.
 * @param {HTMLElement} element The element to put the iframe in.
 * @return {HTMLIFrameElement} The iframe embed.
 */ function $e2699dd4b9c01f75$var$createEmbed(_ref, element) {
    var html = _ref.html;
    if (!element) throw new TypeError("An element must be provided");
    if (element.getAttribute("data-vimeo-initialized") !== null) return element.querySelector("iframe");
    var div = document.createElement("div");
    div.innerHTML = html;
    element.appendChild(div.firstChild);
    element.setAttribute("data-vimeo-initialized", "true");
    return element.querySelector("iframe");
}
/**
 * Make an oEmbed call for the specified URL.
 *
 * @param {string} videoUrl The vimeo.com url for the video.
 * @param {Object} [params] Parameters to pass to oEmbed.
 * @param {HTMLElement} element The element.
 * @return {Promise}
 */ function $e2699dd4b9c01f75$var$getOEmbedData(videoUrl) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var element = arguments.length > 2 ? arguments[2] : undefined;
    return new Promise(function(resolve, reject) {
        if (!$e2699dd4b9c01f75$var$isVimeoUrl(videoUrl)) throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
        var domain = $e2699dd4b9c01f75$var$getOembedDomain(videoUrl);
        var url = "https://".concat(domain, "/api/oembed.json?url=").concat(encodeURIComponent(videoUrl));
        for(var param in params)if (params.hasOwnProperty(param)) url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
        var xhr = "XDomainRequest" in window ? new XDomainRequest() : new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.onload = function() {
            if (xhr.status === 404) {
                reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
                return;
            }
            if (xhr.status === 403) {
                reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
                return;
            }
            try {
                var json = JSON.parse(xhr.responseText);
                // Check api response for 403 on oembed
                if (json.domain_status_code === 403) {
                    // We still want to create the embed to give users visual feedback
                    $e2699dd4b9c01f75$var$createEmbed(json, element);
                    reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
                    return;
                }
                resolve(json);
            } catch (error) {
                reject(error);
            }
        };
        xhr.onerror = function() {
            var status = xhr.status ? " (".concat(xhr.status, ")") : "";
            reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
        };
        xhr.send();
    });
}
/**
 * Initialize all embeds within a specific element
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $e2699dd4b9c01f75$var$initializeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    var elements = [].slice.call(parent.querySelectorAll("[data-vimeo-id], [data-vimeo-url]"));
    var handleError = function handleError(error) {
        if ("console" in window && console.error) console.error("There was an error creating an embed: ".concat(error));
    };
    elements.forEach(function(element) {
        try {
            // Skip any that have data-vimeo-defer
            if (element.getAttribute("data-vimeo-defer") !== null) return;
            var params = $e2699dd4b9c01f75$var$getOEmbedParameters(element);
            var url = $e2699dd4b9c01f75$var$getVimeoUrl(params);
            $e2699dd4b9c01f75$var$getOEmbedData(url, params, element).then(function(data) {
                return $e2699dd4b9c01f75$var$createEmbed(data, element);
            }).catch(handleError);
        } catch (error) {
            handleError(error);
        }
    });
}
/**
 * Resize embeds when messaged by the player.
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $e2699dd4b9c01f75$var$resizeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    // Prevent execution if users include the player.js script multiple times.
    if (window.VimeoPlayerResizeEmbeds_) return;
    window.VimeoPlayerResizeEmbeds_ = true;
    var onMessage = function onMessage(event) {
        if (!$e2699dd4b9c01f75$var$isVimeoUrl(event.origin)) return;
        // 'spacechange' is fired only on embeds with cards
        if (!event.data || event.data.event !== "spacechange") return;
        var iframes = parent.querySelectorAll("iframe");
        for(var i = 0; i < iframes.length; i++){
            if (iframes[i].contentWindow !== event.source) continue;
            // Change padding-bottom of the enclosing div to accommodate
            // card carousel without distorting aspect ratio
            var space = iframes[i].parentElement;
            space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
            break;
        }
    };
    window.addEventListener("message", onMessage);
}
/**
 * Add chapters to existing metadata for Google SEO
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $e2699dd4b9c01f75$var$initAppendVideoMetadata() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoSeoMetadataAppended) return;
    window.VimeoSeoMetadataAppended = true;
    var onMessage = function onMessage(event) {
        if (!$e2699dd4b9c01f75$var$isVimeoUrl(event.origin)) return;
        var data = $e2699dd4b9c01f75$var$parseMessageData(event.data);
        if (!data || data.event !== "ready") return;
        var iframes = parent.querySelectorAll("iframe");
        for(var i = 0; i < iframes.length; i++){
            var iframe = iframes[i];
            // Initiate appendVideoMetadata if iframe is a Vimeo embed
            var isValidMessageSource = iframe.contentWindow === event.source;
            if ($e2699dd4b9c01f75$var$isVimeoEmbed(iframe.src) && isValidMessageSource) {
                var player = new $e2699dd4b9c01f75$var$Player(iframe);
                player.callMethod("appendVideoMetadata", window.location.href);
            }
        }
    };
    window.addEventListener("message", onMessage);
}
/**
 * Seek to time indicated by vimeo_t query parameter if present in URL
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $e2699dd4b9c01f75$var$checkUrlTimeParam() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoCheckedUrlTimeParam) return;
    window.VimeoCheckedUrlTimeParam = true;
    var handleError = function handleError(error) {
        if ("console" in window && console.error) console.error("There was an error getting video Id: ".concat(error));
    };
    var onMessage = function onMessage(event) {
        if (!$e2699dd4b9c01f75$var$isVimeoUrl(event.origin)) return;
        var data = $e2699dd4b9c01f75$var$parseMessageData(event.data);
        if (!data || data.event !== "ready") return;
        var iframes = parent.querySelectorAll("iframe");
        var _loop = function _loop() {
            var iframe = iframes[i];
            var isValidMessageSource = iframe.contentWindow === event.source;
            if ($e2699dd4b9c01f75$var$isVimeoEmbed(iframe.src) && isValidMessageSource) {
                var player = new $e2699dd4b9c01f75$var$Player(iframe);
                player.getVideoId().then(function(videoId) {
                    var matches = new RegExp("[?&]vimeo_t_".concat(videoId, "=([^&#]*)")).exec(window.location.href);
                    if (matches && matches[1]) {
                        var sec = decodeURI(matches[1]);
                        player.setCurrentTime(sec);
                    }
                    return;
                }).catch(handleError);
            }
        };
        for(var i = 0; i < iframes.length; i++)_loop();
    };
    window.addEventListener("message", onMessage);
}
/* MIT License

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
Terms */ function $e2699dd4b9c01f75$var$initializeScreenfull() {
    var fn = function() {
        var val;
        var fnMap = [
            [
                "requestFullscreen",
                "exitFullscreen",
                "fullscreenElement",
                "fullscreenEnabled",
                "fullscreenchange",
                "fullscreenerror"
            ],
            // New WebKit
            [
                "webkitRequestFullscreen",
                "webkitExitFullscreen",
                "webkitFullscreenElement",
                "webkitFullscreenEnabled",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            // Old WebKit
            [
                "webkitRequestFullScreen",
                "webkitCancelFullScreen",
                "webkitCurrentFullScreenElement",
                "webkitCancelFullScreen",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "mozRequestFullScreen",
                "mozCancelFullScreen",
                "mozFullScreenElement",
                "mozFullScreenEnabled",
                "mozfullscreenchange",
                "mozfullscreenerror"
            ],
            [
                "msRequestFullscreen",
                "msExitFullscreen",
                "msFullscreenElement",
                "msFullscreenEnabled",
                "MSFullscreenChange",
                "MSFullscreenError"
            ]
        ];
        var i = 0;
        var l = fnMap.length;
        var ret = {};
        for(; i < l; i++){
            val = fnMap[i];
            if (val && val[1] in document) {
                for(i = 0; i < val.length; i++)ret[fnMap[0][i]] = val[i];
                return ret;
            }
        }
        return false;
    }();
    var eventNameMap = {
        fullscreenchange: fn.fullscreenchange,
        fullscreenerror: fn.fullscreenerror
    };
    var screenfull = {
        request: function request(element) {
            return new Promise(function(resolve, reject) {
                var onFullScreenEntered = function onFullScreenEntered() {
                    screenfull.off("fullscreenchange", onFullScreenEntered);
                    resolve();
                };
                screenfull.on("fullscreenchange", onFullScreenEntered);
                element = element || document.documentElement;
                var returnPromise = element[fn.requestFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenEntered).catch(reject);
            });
        },
        exit: function exit() {
            return new Promise(function(resolve, reject) {
                if (!screenfull.isFullscreen) {
                    resolve();
                    return;
                }
                var onFullScreenExit = function onFullScreenExit() {
                    screenfull.off("fullscreenchange", onFullScreenExit);
                    resolve();
                };
                screenfull.on("fullscreenchange", onFullScreenExit);
                var returnPromise = document[fn.exitFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenExit).catch(reject);
            });
        },
        on: function on(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) document.addEventListener(eventName, callback);
        },
        off: function off(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) document.removeEventListener(eventName, callback);
        }
    };
    Object.defineProperties(screenfull, {
        isFullscreen: {
            get: function get() {
                return Boolean(document[fn.fullscreenElement]);
            }
        },
        element: {
            enumerable: true,
            get: function get() {
                return document[fn.fullscreenElement];
            }
        },
        isEnabled: {
            enumerable: true,
            get: function get() {
                // Coerce to boolean in case of old WebKit
                return Boolean(document[fn.fullscreenEnabled]);
            }
        }
    });
    return screenfull;
}
/** @typedef {import('./timing-src-connector.types').PlayerControls} PlayerControls */ /** @typedef {import('./timing-object.types').TimingObject} TimingObject */ /** @typedef {import('./timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */ /** @typedef {(msg: string) => any} Logger */ /** @typedef {import('timing-object.types').TConnectionState} TConnectionState */ /**
 * @type {TimingSrcConnectorOptions}
 *
 * For details on these properties and their effects, see the typescript definition referenced above.
 */ var $e2699dd4b9c01f75$var$defaultOptions = {
    role: "viewer",
    autoPlayMuted: true,
    allowedDrift: 0.3,
    maxAllowedDrift: 1,
    minCheckInterval: 0.1,
    maxRateAdjustment: 0.2,
    maxTimeToCatchUp: 1
};
/**
 * There's a proposed W3C spec for the Timing Object which would introduce a new set of APIs that would simplify time-synchronization tasks for browser applications.
 *
 * Proposed spec: https://webtiming.github.io/timingobject/
 * V3 Spec: https://timingsrc.readthedocs.io/en/latest/
 * Demuxed talk: https://www.youtube.com/watch?v=cZSjDaGDmX8
 *
 * This class makes it easy to connect Vimeo.Player to a provided TimingObject via Vimeo.Player.setTimingSrc(myTimingObject, options) and the synchronization will be handled automatically.
 *
 * There are 5 general responsibilities in TimingSrcConnector:
 *
 * 1. `updatePlayer()` which sets the player's currentTime, playbackRate and pause/play state based on current state of the TimingObject.
 * 2. `updateTimingObject()` which sets the TimingObject's position and velocity from the player's state.
 * 3. `playerUpdater` which listens for change events on the TimingObject and will respond by calling updatePlayer.
 * 4. `timingObjectUpdater` which listens to the player events of seeked, play and pause and will respond by calling `updateTimingObject()`.
 * 5. `maintainPlaybackPosition` this is code that constantly monitors the player to make sure it's always in sync with the TimingObject. This is needed because videos will generally not play with precise time accuracy and there will be some drift which becomes more noticeable over longer periods (as noted in the timing-object spec). More details on this method below.
 */ var $e2699dd4b9c01f75$var$TimingSrcConnector = /*#__PURE__*/ function(_EventTarget) {
    $e2699dd4b9c01f75$var$_inherits(TimingSrcConnector, _EventTarget);
    var _super = $e2699dd4b9c01f75$var$_createSuper(TimingSrcConnector);
    /**
   * @param {PlayerControls} player
   * @param {TimingObject} timingObject
   * @param {TimingSrcConnectorOptions} options
   * @param {Logger} logger
   */ function TimingSrcConnector(_player, timingObject) {
        var _this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var logger = arguments.length > 3 ? arguments[3] : undefined;
        $e2699dd4b9c01f75$var$_classCallCheck(this, TimingSrcConnector);
        _this = _super.call(this);
        $e2699dd4b9c01f75$var$_defineProperty($e2699dd4b9c01f75$var$_assertThisInitialized(_this), "logger", void 0);
        $e2699dd4b9c01f75$var$_defineProperty($e2699dd4b9c01f75$var$_assertThisInitialized(_this), "speedAdjustment", 0);
        /**
     * @param {PlayerControls} player
     * @param {number} newAdjustment
     * @return {Promise<void>}
     */ $e2699dd4b9c01f75$var$_defineProperty($e2699dd4b9c01f75$var$_assertThisInitialized(_this), "adjustSpeed", /*#__PURE__*/ function() {
            var _ref = $e2699dd4b9c01f75$var$_asyncToGenerator(/*#__PURE__*/ $e2699dd4b9c01f75$var$_regeneratorRuntime().mark(function _callee(player, newAdjustment) {
                var newPlaybackRate;
                return $e2699dd4b9c01f75$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!(_this.speedAdjustment === newAdjustment)) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return");
                        case 2:
                            _context.next = 4;
                            return player.getPlaybackRate();
                        case 4:
                            _context.t0 = _context.sent;
                            _context.t1 = _this.speedAdjustment;
                            _context.t2 = _context.t0 - _context.t1;
                            _context.t3 = newAdjustment;
                            newPlaybackRate = _context.t2 + _context.t3;
                            _this.log("New playbackRate:  ".concat(newPlaybackRate));
                            _context.next = 12;
                            return player.setPlaybackRate(newPlaybackRate);
                        case 12:
                            _this.speedAdjustment = newAdjustment;
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x, _x2) {
                return _ref.apply(this, arguments);
            };
        }());
        _this.logger = logger;
        _this.init(timingObject, _player, $e2699dd4b9c01f75$var$_objectSpread2($e2699dd4b9c01f75$var$_objectSpread2({}, $e2699dd4b9c01f75$var$defaultOptions), options));
        return _this;
    }
    $e2699dd4b9c01f75$var$_createClass(TimingSrcConnector, [
        {
            key: "disconnect",
            value: function disconnect() {
                this.dispatchEvent(new Event("disconnect"));
            }
        },
        {
            key: "init",
            value: function() {
                var _init = $e2699dd4b9c01f75$var$_asyncToGenerator(/*#__PURE__*/ $e2699dd4b9c01f75$var$_regeneratorRuntime().mark(function _callee2(timingObject, player, options) {
                    var _this2 = this;
                    var playerUpdater, positionSync, timingObjectUpdater;
                    return $e2699dd4b9c01f75$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.waitForTOReadyState(timingObject, "open");
                            case 2:
                                if (!(options.role === "viewer")) {
                                    _context2.next = 10;
                                    break;
                                }
                                _context2.next = 5;
                                return this.updatePlayer(timingObject, player, options);
                            case 5:
                                playerUpdater = $e2699dd4b9c01f75$var$subscribe(timingObject, "change", function() {
                                    return _this2.updatePlayer(timingObject, player, options);
                                });
                                positionSync = this.maintainPlaybackPosition(timingObject, player, options);
                                this.addEventListener("disconnect", function() {
                                    positionSync.cancel();
                                    playerUpdater.cancel();
                                });
                                _context2.next = 14;
                                break;
                            case 10:
                                _context2.next = 12;
                                return this.updateTimingObject(timingObject, player);
                            case 12:
                                timingObjectUpdater = $e2699dd4b9c01f75$var$subscribe(player, [
                                    "seeked",
                                    "play",
                                    "pause",
                                    "ratechange"
                                ], function() {
                                    return _this2.updateTimingObject(timingObject, player);
                                }, "on", "off");
                                this.addEventListener("disconnect", function() {
                                    return timingObjectUpdater.cancel();
                                });
                            case 14:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function init(_x3, _x4, _x5) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "updateTimingObject",
            value: function() {
                var _updateTimingObject = $e2699dd4b9c01f75$var$_asyncToGenerator(/*#__PURE__*/ $e2699dd4b9c01f75$var$_regeneratorRuntime().mark(function _callee3(timingObject, player) {
                    return $e2699dd4b9c01f75$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                _context3.t0 = timingObject;
                                _context3.next = 3;
                                return player.getCurrentTime();
                            case 3:
                                _context3.t1 = _context3.sent;
                                _context3.next = 6;
                                return player.getPaused();
                            case 6:
                                if (!_context3.sent) {
                                    _context3.next = 10;
                                    break;
                                }
                                _context3.t2 = 0;
                                _context3.next = 13;
                                break;
                            case 10:
                                _context3.next = 12;
                                return player.getPlaybackRate();
                            case 12:
                                _context3.t2 = _context3.sent;
                            case 13:
                                _context3.t3 = _context3.t2;
                                _context3.t4 = {
                                    position: _context3.t1,
                                    velocity: _context3.t3
                                };
                                _context3.t0.update.call(_context3.t0, _context3.t4);
                            case 16:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function updateTimingObject(_x6, _x7) {
                    return _updateTimingObject.apply(this, arguments);
                }
                return updateTimingObject;
            }()
        },
        {
            key: "updatePlayer",
            value: function() {
                var _updatePlayer = $e2699dd4b9c01f75$var$_asyncToGenerator(/*#__PURE__*/ $e2699dd4b9c01f75$var$_regeneratorRuntime().mark(function _callee5(timingObject, player, options) {
                    var _timingObject$query, position, velocity;
                    return $e2699dd4b9c01f75$var$_regeneratorRuntime().wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                _timingObject$query = timingObject.query(), position = _timingObject$query.position, velocity = _timingObject$query.velocity;
                                if (typeof position === "number") player.setCurrentTime(position);
                                if (!(typeof velocity === "number")) {
                                    _context5.next = 25;
                                    break;
                                }
                                if (!(velocity === 0)) {
                                    _context5.next = 11;
                                    break;
                                }
                                _context5.next = 6;
                                return player.getPaused();
                            case 6:
                                _context5.t0 = _context5.sent;
                                if (!(_context5.t0 === false)) {
                                    _context5.next = 9;
                                    break;
                                }
                                player.pause();
                            case 9:
                                _context5.next = 25;
                                break;
                            case 11:
                                if (!(velocity > 0)) {
                                    _context5.next = 25;
                                    break;
                                }
                                _context5.next = 14;
                                return player.getPaused();
                            case 14:
                                _context5.t1 = _context5.sent;
                                if (!(_context5.t1 === true)) {
                                    _context5.next = 19;
                                    break;
                                }
                                _context5.next = 18;
                                return player.play().catch(/*#__PURE__*/ function() {
                                    var _ref2 = $e2699dd4b9c01f75$var$_asyncToGenerator(/*#__PURE__*/ $e2699dd4b9c01f75$var$_regeneratorRuntime().mark(function _callee4(err) {
                                        return $e2699dd4b9c01f75$var$_regeneratorRuntime().wrap(function _callee4$(_context4) {
                                            while(true)switch(_context4.prev = _context4.next){
                                                case 0:
                                                    if (!(err.name === "NotAllowedError" && options.autoPlayMuted)) {
                                                        _context4.next = 5;
                                                        break;
                                                    }
                                                    _context4.next = 3;
                                                    return player.setMuted(true);
                                                case 3:
                                                    _context4.next = 5;
                                                    return player.play().catch(function(err2) {
                                                        return console.error("Couldn't play the video from TimingSrcConnector. Error:", err2);
                                                    });
                                                case 5:
                                                case "end":
                                                    return _context4.stop();
                                            }
                                        }, _callee4);
                                    }));
                                    return function(_x11) {
                                        return _ref2.apply(this, arguments);
                                    };
                                }());
                            case 18:
                                this.updatePlayer(timingObject, player, options);
                            case 19:
                                _context5.next = 21;
                                return player.getPlaybackRate();
                            case 21:
                                _context5.t2 = _context5.sent;
                                _context5.t3 = velocity;
                                if (!(_context5.t2 !== _context5.t3)) {
                                    _context5.next = 25;
                                    break;
                                }
                                player.setPlaybackRate(velocity);
                            case 25:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updatePlayer(_x8, _x9, _x10) {
                    return _updatePlayer.apply(this, arguments);
                }
                return updatePlayer;
            }()
        },
        {
            key: "maintainPlaybackPosition",
            value: function maintainPlaybackPosition(timingObject, player, options) {
                var _this3 = this;
                var allowedDrift = options.allowedDrift, maxAllowedDrift = options.maxAllowedDrift, minCheckInterval = options.minCheckInterval, maxRateAdjustment = options.maxRateAdjustment, maxTimeToCatchUp = options.maxTimeToCatchUp;
                var syncInterval = Math.min(maxTimeToCatchUp, Math.max(minCheckInterval, maxAllowedDrift)) * 1000;
                var check = /*#__PURE__*/ function() {
                    var _ref3 = $e2699dd4b9c01f75$var$_asyncToGenerator(/*#__PURE__*/ $e2699dd4b9c01f75$var$_regeneratorRuntime().mark(function _callee6() {
                        var diff, diffAbs, min, max, adjustment;
                        return $e2699dd4b9c01f75$var$_regeneratorRuntime().wrap(function _callee6$(_context6) {
                            while(true)switch(_context6.prev = _context6.next){
                                case 0:
                                    _context6.t0 = timingObject.query().velocity === 0;
                                    if (_context6.t0) {
                                        _context6.next = 6;
                                        break;
                                    }
                                    _context6.next = 4;
                                    return player.getPaused();
                                case 4:
                                    _context6.t1 = _context6.sent;
                                    _context6.t0 = _context6.t1 === true;
                                case 6:
                                    if (!_context6.t0) {
                                        _context6.next = 8;
                                        break;
                                    }
                                    return _context6.abrupt("return");
                                case 8:
                                    _context6.t2 = timingObject.query().position;
                                    _context6.next = 11;
                                    return player.getCurrentTime();
                                case 11:
                                    _context6.t3 = _context6.sent;
                                    diff = _context6.t2 - _context6.t3;
                                    diffAbs = Math.abs(diff);
                                    _this3.log("Drift: ".concat(diff));
                                    if (!(diffAbs > maxAllowedDrift)) {
                                        _context6.next = 22;
                                        break;
                                    }
                                    _context6.next = 18;
                                    return _this3.adjustSpeed(player, 0);
                                case 18:
                                    player.setCurrentTime(timingObject.query().position);
                                    _this3.log("Resync by currentTime");
                                    _context6.next = 29;
                                    break;
                                case 22:
                                    if (!(diffAbs > allowedDrift)) {
                                        _context6.next = 29;
                                        break;
                                    }
                                    min = diffAbs / maxTimeToCatchUp;
                                    max = maxRateAdjustment;
                                    adjustment = min < max ? (max - min) / 2 : max;
                                    _context6.next = 28;
                                    return _this3.adjustSpeed(player, adjustment * Math.sign(diff));
                                case 28:
                                    _this3.log("Resync by playbackRate");
                                case 29:
                                case "end":
                                    return _context6.stop();
                            }
                        }, _callee6);
                    }));
                    return function check() {
                        return _ref3.apply(this, arguments);
                    };
                }();
                var interval = setInterval(function() {
                    return check();
                }, syncInterval);
                return {
                    cancel: function cancel() {
                        return clearInterval(interval);
                    }
                };
            }
        },
        {
            key: "log",
            value: function log(msg) {
                var _this$logger;
                (_this$logger = this.logger) === null || _this$logger === void 0 || _this$logger.call(this, "TimingSrcConnector: ".concat(msg));
            }
        },
        {
            key: "waitForTOReadyState",
            value: /**
     * @param {TimingObject} timingObject
     * @param {TConnectionState} state
     * @return {Promise<void>}
     */ function waitForTOReadyState(timingObject, state) {
                return new Promise(function(resolve) {
                    var check = function check() {
                        if (timingObject.readyState === state) resolve();
                        else timingObject.addEventListener("readystatechange", check, {
                            once: true
                        });
                    };
                    check();
                });
            }
        }
    ]);
    return TimingSrcConnector;
}(/*#__PURE__*/ $e2699dd4b9c01f75$var$_wrapNativeSuper(EventTarget));
var $e2699dd4b9c01f75$var$playerMap = new WeakMap();
var $e2699dd4b9c01f75$var$readyMap = new WeakMap();
var $e2699dd4b9c01f75$var$screenfull = {};
var $e2699dd4b9c01f75$var$Player = /*#__PURE__*/ function() {
    /**
   * Create a Player.
   *
   * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
   *        player iframe, and id, or a jQuery object.
   * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
   * @return {Player}
   */ function Player(element) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $e2699dd4b9c01f75$var$_classCallCheck(this, Player);
        /* global jQuery */ if (window.jQuery && element instanceof jQuery) {
            if (element.length > 1 && window.console && console.warn) console.warn("A jQuery object with multiple elements was passed, using the first element.");
            element = element[0];
        }
        // Find an element by ID
        if (typeof document !== "undefined" && typeof element === "string") element = document.getElementById(element);
        // Not an element!
        if (!$e2699dd4b9c01f75$var$isDomElement(element)) throw new TypeError("You must pass either a valid element or a valid id.");
        // Already initialized an embed in this div, so grab the iframe
        if (element.nodeName !== "IFRAME") {
            var iframe = element.querySelector("iframe");
            if (iframe) element = iframe;
        }
        // iframe url is not a Vimeo url
        if (element.nodeName === "IFRAME" && !$e2699dd4b9c01f75$var$isVimeoUrl(element.getAttribute("src") || "")) throw new Error("The player element passed isn\u2019t a Vimeo embed.");
        // If there is already a player object in the map, return that
        if ($e2699dd4b9c01f75$var$playerMap.has(element)) return $e2699dd4b9c01f75$var$playerMap.get(element);
        this._window = element.ownerDocument.defaultView;
        this.element = element;
        this.origin = "*";
        var readyPromise = new $e2699dd4b9c01f75$var$npo_src(function(resolve, reject) {
            _this._onMessage = function(event) {
                if (!$e2699dd4b9c01f75$var$isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) return;
                if (_this.origin === "*") _this.origin = event.origin;
                var data = $e2699dd4b9c01f75$var$parseMessageData(event.data);
                var isError = data && data.event === "error";
                var isReadyError = isError && data.data && data.data.method === "ready";
                if (isReadyError) {
                    var error = new Error(data.data.message);
                    error.name = data.data.name;
                    reject(error);
                    return;
                }
                var isReadyEvent = data && data.event === "ready";
                var isPingResponse = data && data.method === "ping";
                if (isReadyEvent || isPingResponse) {
                    _this.element.setAttribute("data-ready", "true");
                    resolve();
                    return;
                }
                $e2699dd4b9c01f75$var$processData(_this, data);
            };
            _this._window.addEventListener("message", _this._onMessage);
            if (_this.element.nodeName !== "IFRAME") {
                var params = $e2699dd4b9c01f75$var$getOEmbedParameters(element, options);
                var url = $e2699dd4b9c01f75$var$getVimeoUrl(params);
                $e2699dd4b9c01f75$var$getOEmbedData(url, params, element).then(function(data) {
                    var iframe = $e2699dd4b9c01f75$var$createEmbed(data, element);
                    // Overwrite element with the new iframe,
                    // but store reference to the original element
                    _this.element = iframe;
                    _this._originalElement = element;
                    $e2699dd4b9c01f75$var$swapCallbacks(element, iframe);
                    $e2699dd4b9c01f75$var$playerMap.set(_this.element, _this);
                    return data;
                }).catch(reject);
            }
        });
        // Store a copy of this Player in the map
        $e2699dd4b9c01f75$var$readyMap.set(this, readyPromise);
        $e2699dd4b9c01f75$var$playerMap.set(this.element, this);
        // Send a ping to the iframe so the ready promise will be resolved if
        // the player is already ready.
        if (this.element.nodeName === "IFRAME") $e2699dd4b9c01f75$var$postMessage(this, "ping");
        if ($e2699dd4b9c01f75$var$screenfull.isEnabled) {
            var exitFullscreen = function exitFullscreen() {
                return $e2699dd4b9c01f75$var$screenfull.exit();
            };
            this.fullscreenchangeHandler = function() {
                if ($e2699dd4b9c01f75$var$screenfull.isFullscreen) $e2699dd4b9c01f75$var$storeCallback(_this, "event:exitFullscreen", exitFullscreen);
                else $e2699dd4b9c01f75$var$removeCallback(_this, "event:exitFullscreen", exitFullscreen);
                // eslint-disable-next-line
                _this.ready().then(function() {
                    $e2699dd4b9c01f75$var$postMessage(_this, "fullscreenchange", $e2699dd4b9c01f75$var$screenfull.isFullscreen);
                });
            };
            $e2699dd4b9c01f75$var$screenfull.on("fullscreenchange", this.fullscreenchangeHandler);
        }
        return this;
    }
    /**
   * Get a promise for a method.
   *
   * @param {string} name The API method to call.
   * @param {Object} [args={}] Arguments to send via postMessage.
   * @return {Promise}
   */ $e2699dd4b9c01f75$var$_createClass(Player, [
        {
            key: "callMethod",
            value: function callMethod(name) {
                var _this2 = this;
                var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return new $e2699dd4b9c01f75$var$npo_src(function(resolve, reject) {
                    // We are storing the resolve/reject handlers to call later, so we
                    // can’t return here.
                    // eslint-disable-next-line promise/always-return
                    return _this2.ready().then(function() {
                        $e2699dd4b9c01f75$var$storeCallback(_this2, name, {
                            resolve: resolve,
                            reject: reject
                        });
                        $e2699dd4b9c01f75$var$postMessage(_this2, name, args);
                    }).catch(reject);
                });
            }
        },
        {
            key: "get",
            value: function get(name) {
                var _this3 = this;
                return new $e2699dd4b9c01f75$var$npo_src(function(resolve, reject) {
                    name = $e2699dd4b9c01f75$var$getMethodName(name, "get");
                    // We are storing the resolve/reject handlers to call later, so we
                    // can’t return here.
                    // eslint-disable-next-line promise/always-return
                    return _this3.ready().then(function() {
                        $e2699dd4b9c01f75$var$storeCallback(_this3, name, {
                            resolve: resolve,
                            reject: reject
                        });
                        $e2699dd4b9c01f75$var$postMessage(_this3, name);
                    }).catch(reject);
                });
            }
        },
        {
            key: "set",
            value: function set(name, value) {
                var _this4 = this;
                return new $e2699dd4b9c01f75$var$npo_src(function(resolve, reject) {
                    name = $e2699dd4b9c01f75$var$getMethodName(name, "set");
                    if (value === undefined || value === null) throw new TypeError("There must be a value to set.");
                    // We are storing the resolve/reject handlers to call later, so we
                    // can’t return here.
                    // eslint-disable-next-line promise/always-return
                    return _this4.ready().then(function() {
                        $e2699dd4b9c01f75$var$storeCallback(_this4, name, {
                            resolve: resolve,
                            reject: reject
                        });
                        $e2699dd4b9c01f75$var$postMessage(_this4, name, value);
                    }).catch(reject);
                });
            }
        },
        {
            key: "on",
            value: function on(eventName, callback) {
                if (!eventName) throw new TypeError("You must pass an event name.");
                if (!callback) throw new TypeError("You must pass a callback function.");
                if (typeof callback !== "function") throw new TypeError("The callback must be a function.");
                var callbacks = $e2699dd4b9c01f75$var$getCallbacks(this, "event:".concat(eventName));
                if (callbacks.length === 0) this.callMethod("addEventListener", eventName).catch(function() {
                // Ignore the error. There will be an error event fired that
                // will trigger the error callback if they are listening.
                });
                $e2699dd4b9c01f75$var$storeCallback(this, "event:".concat(eventName), callback);
            }
        },
        {
            key: "off",
            value: function off(eventName, callback) {
                if (!eventName) throw new TypeError("You must pass an event name.");
                if (callback && typeof callback !== "function") throw new TypeError("The callback must be a function.");
                var lastCallback = $e2699dd4b9c01f75$var$removeCallback(this, "event:".concat(eventName), callback);
                // If there are no callbacks left, remove the listener
                if (lastCallback) this.callMethod("removeEventListener", eventName).catch(function(e) {
                // Ignore the error. There will be an error event fired that
                // will trigger the error callback if they are listening.
                });
            }
        },
        {
            key: "loadVideo",
            value: function loadVideo(options) {
                return this.callMethod("loadVideo", options);
            }
        },
        {
            key: "ready",
            value: function ready() {
                var readyPromise = $e2699dd4b9c01f75$var$readyMap.get(this) || new $e2699dd4b9c01f75$var$npo_src(function(resolve, reject) {
                    reject(new Error("Unknown player. Probably unloaded."));
                });
                return $e2699dd4b9c01f75$var$npo_src.resolve(readyPromise);
            }
        },
        {
            key: "addCuePoint",
            value: function addCuePoint(time) {
                var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return this.callMethod("addCuePoint", {
                    time: time,
                    data: data
                });
            }
        },
        {
            key: "removeCuePoint",
            value: function removeCuePoint(id) {
                return this.callMethod("removeCuePoint", id);
            }
        },
        {
            key: "enableTextTrack",
            value: function enableTextTrack(language, kind) {
                if (!language) throw new TypeError("You must pass a language.");
                return this.callMethod("enableTextTrack", {
                    language: language,
                    kind: kind
                });
            }
        },
        {
            key: "disableTextTrack",
            value: function disableTextTrack() {
                return this.callMethod("disableTextTrack");
            }
        },
        {
            key: "pause",
            value: function pause() {
                return this.callMethod("pause");
            }
        },
        {
            key: "play",
            value: function play() {
                return this.callMethod("play");
            }
        },
        {
            key: "requestFullscreen",
            value: function requestFullscreen() {
                if ($e2699dd4b9c01f75$var$screenfull.isEnabled) return $e2699dd4b9c01f75$var$screenfull.request(this.element);
                return this.callMethod("requestFullscreen");
            }
        },
        {
            key: "exitFullscreen",
            value: function exitFullscreen() {
                if ($e2699dd4b9c01f75$var$screenfull.isEnabled) return $e2699dd4b9c01f75$var$screenfull.exit();
                return this.callMethod("exitFullscreen");
            }
        },
        {
            key: "getFullscreen",
            value: function getFullscreen() {
                if ($e2699dd4b9c01f75$var$screenfull.isEnabled) return $e2699dd4b9c01f75$var$npo_src.resolve($e2699dd4b9c01f75$var$screenfull.isFullscreen);
                return this.get("fullscreen");
            }
        },
        {
            key: "requestPictureInPicture",
            value: function requestPictureInPicture() {
                return this.callMethod("requestPictureInPicture");
            }
        },
        {
            key: "exitPictureInPicture",
            value: function exitPictureInPicture() {
                return this.callMethod("exitPictureInPicture");
            }
        },
        {
            key: "getPictureInPicture",
            value: function getPictureInPicture() {
                return this.get("pictureInPicture");
            }
        },
        {
            key: "remotePlaybackPrompt",
            value: function remotePlaybackPrompt() {
                return this.callMethod("remotePlaybackPrompt");
            }
        },
        {
            key: "unload",
            value: function unload() {
                return this.callMethod("unload");
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this5 = this;
                return new $e2699dd4b9c01f75$var$npo_src(function(resolve) {
                    $e2699dd4b9c01f75$var$readyMap.delete(_this5);
                    $e2699dd4b9c01f75$var$playerMap.delete(_this5.element);
                    if (_this5._originalElement) {
                        $e2699dd4b9c01f75$var$playerMap.delete(_this5._originalElement);
                        _this5._originalElement.removeAttribute("data-vimeo-initialized");
                    }
                    if (_this5.element && _this5.element.nodeName === "IFRAME" && _this5.element.parentNode) {
                        // If we've added an additional wrapper div, remove that from the DOM.
                        // If not, just remove the iframe element.
                        if (_this5.element.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== _this5.element.parentNode) _this5.element.parentNode.parentNode.removeChild(_this5.element.parentNode);
                        else _this5.element.parentNode.removeChild(_this5.element);
                    }
                    // If the clip is private there is a case where the element stays the
                    // div element. Destroy should reset the div and remove the iframe child.
                    if (_this5.element && _this5.element.nodeName === "DIV" && _this5.element.parentNode) {
                        _this5.element.removeAttribute("data-vimeo-initialized");
                        var iframe = _this5.element.querySelector("iframe");
                        if (iframe && iframe.parentNode) {
                            // If we've added an additional wrapper div, remove that from the DOM.
                            // If not, just remove the iframe element.
                            if (iframe.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== iframe.parentNode) iframe.parentNode.parentNode.removeChild(iframe.parentNode);
                            else iframe.parentNode.removeChild(iframe);
                        }
                    }
                    _this5._window.removeEventListener("message", _this5._onMessage);
                    if ($e2699dd4b9c01f75$var$screenfull.isEnabled) $e2699dd4b9c01f75$var$screenfull.off("fullscreenchange", _this5.fullscreenchangeHandler);
                    resolve();
                });
            }
        },
        {
            key: "getAutopause",
            value: function getAutopause() {
                return this.get("autopause");
            }
        },
        {
            key: "setAutopause",
            value: function setAutopause(autopause) {
                return this.set("autopause", autopause);
            }
        },
        {
            key: "getBuffered",
            value: function getBuffered() {
                return this.get("buffered");
            }
        },
        {
            key: "getCameraProps",
            value: function getCameraProps() {
                return this.get("cameraProps");
            }
        },
        {
            key: "setCameraProps",
            value: function setCameraProps(camera) {
                return this.set("cameraProps", camera);
            }
        },
        {
            key: "getChapters",
            value: function getChapters() {
                return this.get("chapters");
            }
        },
        {
            key: "getCurrentChapter",
            value: function getCurrentChapter() {
                return this.get("currentChapter");
            }
        },
        {
            key: "getColor",
            value: function getColor() {
                return this.get("color");
            }
        },
        {
            key: "getColors",
            value: function getColors() {
                return $e2699dd4b9c01f75$var$npo_src.all([
                    this.get("colorOne"),
                    this.get("colorTwo"),
                    this.get("colorThree"),
                    this.get("colorFour")
                ]);
            }
        },
        {
            key: "setColor",
            value: function setColor(color) {
                return this.set("color", color);
            }
        },
        {
            key: "setColors",
            value: function setColors(colors) {
                if (!Array.isArray(colors)) return new $e2699dd4b9c01f75$var$npo_src(function(resolve, reject) {
                    return reject(new TypeError("Argument must be an array."));
                });
                var nullPromise = new $e2699dd4b9c01f75$var$npo_src(function(resolve) {
                    return resolve(null);
                });
                var colorPromises = [
                    colors[0] ? this.set("colorOne", colors[0]) : nullPromise,
                    colors[1] ? this.set("colorTwo", colors[1]) : nullPromise,
                    colors[2] ? this.set("colorThree", colors[2]) : nullPromise,
                    colors[3] ? this.set("colorFour", colors[3]) : nullPromise
                ];
                return $e2699dd4b9c01f75$var$npo_src.all(colorPromises);
            }
        },
        {
            key: "getCuePoints",
            value: function getCuePoints() {
                return this.get("cuePoints");
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                return this.get("currentTime");
            }
        },
        {
            key: "setCurrentTime",
            value: function setCurrentTime(currentTime) {
                return this.set("currentTime", currentTime);
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return this.get("duration");
            }
        },
        {
            key: "getEnded",
            value: function getEnded() {
                return this.get("ended");
            }
        },
        {
            key: "getLoop",
            value: function getLoop() {
                return this.get("loop");
            }
        },
        {
            key: "setLoop",
            value: function setLoop(loop) {
                return this.set("loop", loop);
            }
        },
        {
            key: "setMuted",
            value: function setMuted(muted) {
                return this.set("muted", muted);
            }
        },
        {
            key: "getMuted",
            value: function getMuted() {
                return this.get("muted");
            }
        },
        {
            key: "getPaused",
            value: function getPaused() {
                return this.get("paused");
            }
        },
        {
            key: "getPlaybackRate",
            value: function getPlaybackRate() {
                return this.get("playbackRate");
            }
        },
        {
            key: "setPlaybackRate",
            value: function setPlaybackRate(playbackRate) {
                return this.set("playbackRate", playbackRate);
            }
        },
        {
            key: "getPlayed",
            value: function getPlayed() {
                return this.get("played");
            }
        },
        {
            key: "getQualities",
            value: function getQualities() {
                return this.get("qualities");
            }
        },
        {
            key: "getQuality",
            value: function getQuality() {
                return this.get("quality");
            }
        },
        {
            key: "setQuality",
            value: function setQuality(quality) {
                return this.set("quality", quality);
            }
        },
        {
            key: "getRemotePlaybackAvailability",
            value: function getRemotePlaybackAvailability() {
                return this.get("remotePlaybackAvailability");
            }
        },
        {
            key: "getRemotePlaybackState",
            value: function getRemotePlaybackState() {
                return this.get("remotePlaybackState");
            }
        },
        {
            key: "getSeekable",
            value: function getSeekable() {
                return this.get("seekable");
            }
        },
        {
            key: "getSeeking",
            value: function getSeeking() {
                return this.get("seeking");
            }
        },
        {
            key: "getTextTracks",
            value: function getTextTracks() {
                return this.get("textTracks");
            }
        },
        {
            key: "getVideoEmbedCode",
            value: function getVideoEmbedCode() {
                return this.get("videoEmbedCode");
            }
        },
        {
            key: "getVideoId",
            value: function getVideoId() {
                return this.get("videoId");
            }
        },
        {
            key: "getVideoTitle",
            value: function getVideoTitle() {
                return this.get("videoTitle");
            }
        },
        {
            key: "getVideoWidth",
            value: function getVideoWidth() {
                return this.get("videoWidth");
            }
        },
        {
            key: "getVideoHeight",
            value: function getVideoHeight() {
                return this.get("videoHeight");
            }
        },
        {
            key: "getVideoUrl",
            value: function getVideoUrl() {
                return this.get("videoUrl");
            }
        },
        {
            key: "getVolume",
            value: function getVolume() {
                return this.get("volume");
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                return this.set("volume", volume);
            }
        },
        {
            key: "setTimingSrc",
            value: function() {
                var _setTimingSrc = $e2699dd4b9c01f75$var$_asyncToGenerator(/*#__PURE__*/ $e2699dd4b9c01f75$var$_regeneratorRuntime().mark(function _callee(timingObject, options) {
                    var _this6 = this;
                    var connector;
                    return $e2699dd4b9c01f75$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (timingObject) {
                                    _context.next = 2;
                                    break;
                                }
                                throw new TypeError("A Timing Object must be provided.");
                            case 2:
                                _context.next = 4;
                                return this.ready();
                            case 4:
                                connector = new $e2699dd4b9c01f75$var$TimingSrcConnector(this, timingObject, options);
                                $e2699dd4b9c01f75$var$postMessage(this, "notifyTimingObjectConnect");
                                connector.addEventListener("disconnect", function() {
                                    return $e2699dd4b9c01f75$var$postMessage(_this6, "notifyTimingObjectDisconnect");
                                });
                                return _context.abrupt("return", connector);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function setTimingSrc(_x, _x2) {
                    return _setTimingSrc.apply(this, arguments);
                }
                return setTimingSrc;
            }()
        }
    ]);
    return Player;
}(); // Setup embed only if this is not a node environment
if (!$e2699dd4b9c01f75$var$isNode) {
    $e2699dd4b9c01f75$var$screenfull = $e2699dd4b9c01f75$var$initializeScreenfull();
    $e2699dd4b9c01f75$var$initializeEmbeds();
    $e2699dd4b9c01f75$var$resizeEmbeds();
    $e2699dd4b9c01f75$var$initAppendVideoMetadata();
    $e2699dd4b9c01f75$var$checkUrlTimeParam();
}
var $e2699dd4b9c01f75$export$2e2bcd8739ae039 = $e2699dd4b9c01f75$var$Player;

});



parcelRegister("bruOF", function(module, exports) {

$parcel$export(module.exports, "TextBlock", () => $7ae54eefe6fe4daf$export$2db84c782bfb16e2);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
const $7ae54eefe6fe4daf$export$2db84c782bfb16e2 = ({ title: title, description: description, className: className })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: (0, $9QePP.default)("mb-4 text-pretty", className),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "heading-m mb-1",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "body-s",
                children: description
            })
        ]
    });
};

});

parcelRegister("3HPvp", function(module, exports) {

$parcel$export(module.exports, "MobileStep", () => $c2861c04b83516d6$export$7767e8950b82228);
$parcel$export(module.exports, "MobileSteps", () => $c2861c04b83516d6$export$d307cdbe35e3302a);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
const $c2861c04b83516d6$export$7767e8950b82228 = ({ active: active })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)(active ? "w-3/5 bg-brand-50" : "w-1/5 bg-slate-600", "rounded py-1 transition-all ease-in-out")
    });
};
const $c2861c04b83516d6$export$d307cdbe35e3302a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("mb-5 mt-3 w-full", "flex gap-4", "lg:hidden"),
        children: children
    });
};

});

parcelRegister("kEKBb", function(module, exports) {

$parcel$export(module.exports, "Bifold", () => $bce6cdd73bb8d973$export$f1d8c65073d8b59a);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
const $bce6cdd73bb8d973$export$f1d8c65073d8b59a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("flex min-h-full flex-col justify-center lg:flex-row", "gap-5 lg:gap-[100px] xl:gap-[120px]", "[&>*:first-child]:flex [&>*:first-child]:w-full [&>*:first-child]:flex-col [&>*:first-child]:gap-3", "lg:[&>*:first-child]:w-[400px]", "[&>*:last-child]:w-full lg:[&>*:last-child]:max-w-[520px]", "lg:[&>*:last-child]:mb-0", "lg:[&>*:last-child]:fade-container", "[&>*:last-child]:mb-4 lg:[&>*:last-child]:pr-4", "lg:[&>*:last-child]:box-content"),
        children: children
    });
};

});


parcelRegister("gDrdl", function(module, exports) {
$parcel$export(module.exports, "ReturnPage", () => (parcelRequire("kbOqr")).ReturnPage);
parcelRequire("kbOqr");

});
parcelRegister("kbOqr", function(module, exports) {

$parcel$export(module.exports, "ReturnPage", () => $01a37e38c5ba466a$export$f08c23ea6c80e91f);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("bCWR4");
var $ddmfx = parcelRequire("ddmfx");

var $lzNIT = parcelRequire("lzNIT");

var $9QePP = parcelRequire("9QePP");

var $jLakY = parcelRequire("jLakY");
function $01a37e38c5ba466a$export$f08c23ea6c80e91f({ title: title, description: description, href: href, linkText: linkText }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
        className: (0, $9QePP.default)("px-6 py-24", "grid min-h-full place-items-center", "sm:py-32 lg:px-8"),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-col items-center text-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddmfx.Illustration).Graphics, {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: (0, $9QePP.default)("mt-4", "display-m", "sm:display-s"),
                    children: title
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "body-s mt-6 max-w-[672px]",
                    children: description
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: (0, $9QePP.default)("mt-10", "flex items-center justify-center gap-x-6"),
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lzNIT.Link), {
                        to: href,
                        className: (0, $9QePP.default)("mb-6", "group flex items-center gap-2.5"),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jLakY.default), {
                                className: "size-4 group-hover:fill-brand-400 group-hover:stroke-brand-400"
                            }),
                            linkText
                        ]
                    })
                })
            ]
        })
    });
}

});


parcelRegister("6rC3k", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");
function $382abec7070448e3$export$900d6118d6e87fe5({ title: title, description: description, graphic: graphic, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
        className: (0, $9QePP.default)("px-6 py-24", "grid h-[99vh] place-items-center", "sm:py-32 lg:px-8"),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-col items-center text-center",
            children: [
                graphic,
                title && /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: (0, $9QePP.default)("display-m", "sm:display-s"),
                    children: title
                }),
                description && (typeof description === "function" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(description(), (child)=>{
                    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child) && child.type === "p") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
                        ...child.props,
                        className: (0, $9QePP.default)(child.props.className, "body-s mt-6 w-[672px]")
                    });
                    return child;
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "body-s mt-6 max-w-[672px]",
                    children: description
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: (0, $9QePP.default)("mt-10 w-full", "flex flex-col items-center justify-center gap-x-6"),
                    children: children
                })
            ]
        })
    });
}

});


parcelRegister("agpqr", function(module, exports) {
parcelRequire("gTdVG");

});
parcelRegister("gTdVG", function(module, exports) {
const $3608805b393bc77e$export$93d4e7f90805808f = ()=>{
    return {};
};

});


parcelRegister("j97Mu", function(module, exports) {
parcelRequire("8hzej");

});
parcelRegister("8hzej", function(module, exports) {

var $C3MXw = parcelRequire("C3MXw");

var $acw62 = parcelRequire("acw62");
const $9ddf2f3bf9bffd58$export$7afd5d02ec38ddc6 = ()=>{
    (0, $acw62.useEffect)(()=>{
        (0, $C3MXw.default)({
            angle: 90,
            particleCount: 150,
            startVelocity: 40,
            ticks: 500,
            gravity: 0.9,
            spread: 1000,
            zIndex: 9999,
            origin: {
                y: 0.5,
                x: 0.5
            }
        });
    }, []);
};

});
parcelRegister("C3MXw", function(module, exports) {

$parcel$export(module.exports, "default", () => $947b03da4811c942$export$2e2bcd8739ae039);
// canvas-confetti v1.9.2 built on 2023-11-25T06:01:06.267Z
var $947b03da4811c942$var$module = {};
// source content
/* globals Map */ (function main(global, module, isWorker, workerSize) {
    var canUseWorker = !!(global.Worker && global.Blob && global.Promise && global.OffscreenCanvas && global.OffscreenCanvasRenderingContext2D && global.HTMLCanvasElement && global.HTMLCanvasElement.prototype.transferControlToOffscreen && global.URL && global.URL.createObjectURL);
    var canUsePaths = typeof Path2D === "function" && typeof DOMMatrix === "function";
    var canDrawBitmap = function() {
        // this mostly supports ssr
        if (!global.OffscreenCanvas) return false;
        var canvas = new OffscreenCanvas(1, 1);
        var ctx = canvas.getContext("2d");
        ctx.fillRect(0, 0, 1, 1);
        var bitmap = canvas.transferToImageBitmap();
        try {
            ctx.createPattern(bitmap, "no-repeat");
        } catch (e) {
            return false;
        }
        return true;
    }();
    function noop() {}
    // create a promise if it exists, otherwise, just
    // call the function directly
    function promise(func) {
        var ModulePromise = module.exports.Promise;
        var Prom = ModulePromise !== void 0 ? ModulePromise : global.Promise;
        if (typeof Prom === "function") return new Prom(func);
        func(noop, noop);
        return null;
    }
    var bitmapMapper = function(skipTransform, map) {
        // see https://github.com/catdad/canvas-confetti/issues/209
        // creating canvases is actually pretty expensive, so we should create a
        // 1:1 map for bitmap:canvas, so that we can animate the confetti in
        // a performant manner, but also not store them forever so that we don't
        // have a memory leak
        return {
            transform: function(bitmap) {
                if (skipTransform) return bitmap;
                if (map.has(bitmap)) return map.get(bitmap);
                var canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
                var ctx = canvas.getContext("2d");
                ctx.drawImage(bitmap, 0, 0);
                map.set(bitmap, canvas);
                return canvas;
            },
            clear: function() {
                map.clear();
            }
        };
    }(canDrawBitmap, new Map());
    var raf = function() {
        var TIME = Math.floor(1000 / 60);
        var frame, cancel;
        var frames = {};
        var lastFrameTime = 0;
        if (typeof requestAnimationFrame === "function" && typeof cancelAnimationFrame === "function") {
            frame = function(cb) {
                var id = Math.random();
                frames[id] = requestAnimationFrame(function onFrame(time) {
                    if (lastFrameTime === time || lastFrameTime + TIME - 1 < time) {
                        lastFrameTime = time;
                        delete frames[id];
                        cb();
                    } else frames[id] = requestAnimationFrame(onFrame);
                });
                return id;
            };
            cancel = function(id) {
                if (frames[id]) cancelAnimationFrame(frames[id]);
            };
        } else {
            frame = function(cb) {
                return setTimeout(cb, TIME);
            };
            cancel = function(timer) {
                return clearTimeout(timer);
            };
        }
        return {
            frame: frame,
            cancel: cancel
        };
    }();
    var getWorker = function() {
        var worker;
        var prom;
        var resolves = {};
        function decorate(worker) {
            function execute(options, callback) {
                worker.postMessage({
                    options: options || {},
                    callback: callback
                });
            }
            worker.init = function initWorker(canvas) {
                var offscreen = canvas.transferControlToOffscreen();
                worker.postMessage({
                    canvas: offscreen
                }, [
                    offscreen
                ]);
            };
            worker.fire = function fireWorker(options, size, done) {
                if (prom) {
                    execute(options, null);
                    return prom;
                }
                var id = Math.random().toString(36).slice(2);
                prom = promise(function(resolve) {
                    function workerDone(msg) {
                        if (msg.data.callback !== id) return;
                        delete resolves[id];
                        worker.removeEventListener("message", workerDone);
                        prom = null;
                        bitmapMapper.clear();
                        done();
                        resolve();
                    }
                    worker.addEventListener("message", workerDone);
                    execute(options, id);
                    resolves[id] = workerDone.bind(null, {
                        data: {
                            callback: id
                        }
                    });
                });
                return prom;
            };
            worker.reset = function resetWorker() {
                worker.postMessage({
                    reset: true
                });
                for(var id in resolves){
                    resolves[id]();
                    delete resolves[id];
                }
            };
        }
        return function() {
            if (worker) return worker;
            if (!isWorker && canUseWorker) {
                var code = [
                    "var CONFETTI, SIZE = {}, module = {};",
                    "(" + main.toString() + ")(this, module, true, SIZE);",
                    "onmessage = function(msg) {",
                    "  if (msg.data.options) {",
                    "    CONFETTI(msg.data.options).then(function () {",
                    "      if (msg.data.callback) {",
                    "        postMessage({ callback: msg.data.callback });",
                    "      }",
                    "    });",
                    "  } else if (msg.data.reset) {",
                    "    CONFETTI && CONFETTI.reset();",
                    "  } else if (msg.data.resize) {",
                    "    SIZE.width = msg.data.resize.width;",
                    "    SIZE.height = msg.data.resize.height;",
                    "  } else if (msg.data.canvas) {",
                    "    SIZE.width = msg.data.canvas.width;",
                    "    SIZE.height = msg.data.canvas.height;",
                    "    CONFETTI = module.exports.create(msg.data.canvas);",
                    "  }",
                    "}"
                ].join("\n");
                try {
                    worker = new Worker(URL.createObjectURL(new Blob([
                        code
                    ])));
                } catch (e) {
                    // eslint-disable-next-line no-console
                    typeof console.warn === "function" && console.warn("\uD83C\uDF8A Could not load worker", e);
                    return null;
                }
                decorate(worker);
            }
            return worker;
        };
    }();
    var defaults = {
        particleCount: 50,
        angle: 90,
        spread: 45,
        startVelocity: 45,
        decay: 0.9,
        gravity: 1,
        drift: 0,
        ticks: 200,
        x: 0.5,
        y: 0.5,
        shapes: [
            "square",
            "circle"
        ],
        zIndex: 100,
        colors: [
            "#26ccff",
            "#a25afd",
            "#ff5e7e",
            "#88ff5a",
            "#fcff42",
            "#ffa62d",
            "#ff36ff"
        ],
        // probably should be true, but back-compat
        disableForReducedMotion: false,
        scalar: 1
    };
    function convert(val, transform) {
        return transform ? transform(val) : val;
    }
    function isOk(val) {
        return !(val === null || val === undefined);
    }
    function prop(options, name, transform) {
        return convert(options && isOk(options[name]) ? options[name] : defaults[name], transform);
    }
    function onlyPositiveInt(number) {
        return number < 0 ? 0 : Math.floor(number);
    }
    function randomInt(min, max) {
        // [min, max)
        return Math.floor(Math.random() * (max - min)) + min;
    }
    function toDecimal(str) {
        return parseInt(str, 16);
    }
    function colorsToRgb(colors) {
        return colors.map(hexToRgb);
    }
    function hexToRgb(str) {
        var val = String(str).replace(/[^0-9a-f]/gi, "");
        if (val.length < 6) val = val[0] + val[0] + val[1] + val[1] + val[2] + val[2];
        return {
            r: toDecimal(val.substring(0, 2)),
            g: toDecimal(val.substring(2, 4)),
            b: toDecimal(val.substring(4, 6))
        };
    }
    function getOrigin(options) {
        var origin = prop(options, "origin", Object);
        origin.x = prop(origin, "x", Number);
        origin.y = prop(origin, "y", Number);
        return origin;
    }
    function setCanvasWindowSize(canvas) {
        canvas.width = document.documentElement.clientWidth;
        canvas.height = document.documentElement.clientHeight;
    }
    function setCanvasRectSize(canvas) {
        var rect = canvas.getBoundingClientRect();
        canvas.width = rect.width;
        canvas.height = rect.height;
    }
    function getCanvas(zIndex) {
        var canvas = document.createElement("canvas");
        canvas.style.position = "fixed";
        canvas.style.top = "0px";
        canvas.style.left = "0px";
        canvas.style.pointerEvents = "none";
        canvas.style.zIndex = zIndex;
        return canvas;
    }
    function ellipse(context, x, y, radiusX, radiusY, rotation, startAngle, endAngle, antiClockwise) {
        context.save();
        context.translate(x, y);
        context.rotate(rotation);
        context.scale(radiusX, radiusY);
        context.arc(0, 0, 1, startAngle, endAngle, antiClockwise);
        context.restore();
    }
    function randomPhysics(opts) {
        var radAngle = opts.angle * (Math.PI / 180);
        var radSpread = opts.spread * (Math.PI / 180);
        return {
            x: opts.x,
            y: opts.y,
            wobble: Math.random() * 10,
            wobbleSpeed: Math.min(0.11, Math.random() * 0.1 + 0.05),
            velocity: opts.startVelocity * 0.5 + Math.random() * opts.startVelocity,
            angle2D: -radAngle + (0.5 * radSpread - Math.random() * radSpread),
            tiltAngle: (Math.random() * 0.5 + 0.25) * Math.PI,
            color: opts.color,
            shape: opts.shape,
            tick: 0,
            totalTicks: opts.ticks,
            decay: opts.decay,
            drift: opts.drift,
            random: Math.random() + 2,
            tiltSin: 0,
            tiltCos: 0,
            wobbleX: 0,
            wobbleY: 0,
            gravity: opts.gravity * 3,
            ovalScalar: 0.6,
            scalar: opts.scalar,
            flat: opts.flat
        };
    }
    function updateFetti(context, fetti) {
        fetti.x += Math.cos(fetti.angle2D) * fetti.velocity + fetti.drift;
        fetti.y += Math.sin(fetti.angle2D) * fetti.velocity + fetti.gravity;
        fetti.velocity *= fetti.decay;
        if (fetti.flat) {
            fetti.wobble = 0;
            fetti.wobbleX = fetti.x + 10 * fetti.scalar;
            fetti.wobbleY = fetti.y + 10 * fetti.scalar;
            fetti.tiltSin = 0;
            fetti.tiltCos = 0;
            fetti.random = 1;
        } else {
            fetti.wobble += fetti.wobbleSpeed;
            fetti.wobbleX = fetti.x + 10 * fetti.scalar * Math.cos(fetti.wobble);
            fetti.wobbleY = fetti.y + 10 * fetti.scalar * Math.sin(fetti.wobble);
            fetti.tiltAngle += 0.1;
            fetti.tiltSin = Math.sin(fetti.tiltAngle);
            fetti.tiltCos = Math.cos(fetti.tiltAngle);
            fetti.random = Math.random() + 2;
        }
        var progress = fetti.tick++ / fetti.totalTicks;
        var x1 = fetti.x + fetti.random * fetti.tiltCos;
        var y1 = fetti.y + fetti.random * fetti.tiltSin;
        var x2 = fetti.wobbleX + fetti.random * fetti.tiltCos;
        var y2 = fetti.wobbleY + fetti.random * fetti.tiltSin;
        context.fillStyle = "rgba(" + fetti.color.r + ", " + fetti.color.g + ", " + fetti.color.b + ", " + (1 - progress) + ")";
        context.beginPath();
        if (canUsePaths && fetti.shape.type === "path" && typeof fetti.shape.path === "string" && Array.isArray(fetti.shape.matrix)) context.fill(transformPath2D(fetti.shape.path, fetti.shape.matrix, fetti.x, fetti.y, Math.abs(x2 - x1) * 0.1, Math.abs(y2 - y1) * 0.1, Math.PI / 10 * fetti.wobble));
        else if (fetti.shape.type === "bitmap") {
            var rotation = Math.PI / 10 * fetti.wobble;
            var scaleX = Math.abs(x2 - x1) * 0.1;
            var scaleY = Math.abs(y2 - y1) * 0.1;
            var width = fetti.shape.bitmap.width * fetti.scalar;
            var height = fetti.shape.bitmap.height * fetti.scalar;
            var matrix = new DOMMatrix([
                Math.cos(rotation) * scaleX,
                Math.sin(rotation) * scaleX,
                -Math.sin(rotation) * scaleY,
                Math.cos(rotation) * scaleY,
                fetti.x,
                fetti.y
            ]);
            // apply the transform matrix from the confetti shape
            matrix.multiplySelf(new DOMMatrix(fetti.shape.matrix));
            var pattern = context.createPattern(bitmapMapper.transform(fetti.shape.bitmap), "no-repeat");
            pattern.setTransform(matrix);
            context.globalAlpha = 1 - progress;
            context.fillStyle = pattern;
            context.fillRect(fetti.x - width / 2, fetti.y - height / 2, width, height);
            context.globalAlpha = 1;
        } else if (fetti.shape === "circle") context.ellipse ? context.ellipse(fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI) : ellipse(context, fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI);
        else if (fetti.shape === "star") {
            var rot = Math.PI / 2 * 3;
            var innerRadius = 4 * fetti.scalar;
            var outerRadius = 8 * fetti.scalar;
            var x = fetti.x;
            var y = fetti.y;
            var spikes = 5;
            var step = Math.PI / spikes;
            while(spikes--){
                x = fetti.x + Math.cos(rot) * outerRadius;
                y = fetti.y + Math.sin(rot) * outerRadius;
                context.lineTo(x, y);
                rot += step;
                x = fetti.x + Math.cos(rot) * innerRadius;
                y = fetti.y + Math.sin(rot) * innerRadius;
                context.lineTo(x, y);
                rot += step;
            }
        } else {
            context.moveTo(Math.floor(fetti.x), Math.floor(fetti.y));
            context.lineTo(Math.floor(fetti.wobbleX), Math.floor(y1));
            context.lineTo(Math.floor(x2), Math.floor(y2));
            context.lineTo(Math.floor(x1), Math.floor(fetti.wobbleY));
        }
        context.closePath();
        context.fill();
        return fetti.tick < fetti.totalTicks;
    }
    function animate(canvas, fettis, resizer, size, done) {
        var animatingFettis = fettis.slice();
        var context = canvas.getContext("2d");
        var animationFrame;
        var destroy;
        var prom = promise(function(resolve) {
            function onDone() {
                animationFrame = destroy = null;
                context.clearRect(0, 0, size.width, size.height);
                bitmapMapper.clear();
                done();
                resolve();
            }
            function update() {
                if (isWorker && !(size.width === workerSize.width && size.height === workerSize.height)) {
                    size.width = canvas.width = workerSize.width;
                    size.height = canvas.height = workerSize.height;
                }
                if (!size.width && !size.height) {
                    resizer(canvas);
                    size.width = canvas.width;
                    size.height = canvas.height;
                }
                context.clearRect(0, 0, size.width, size.height);
                animatingFettis = animatingFettis.filter(function(fetti) {
                    return updateFetti(context, fetti);
                });
                if (animatingFettis.length) animationFrame = raf.frame(update);
                else onDone();
            }
            animationFrame = raf.frame(update);
            destroy = onDone;
        });
        return {
            addFettis: function(fettis) {
                animatingFettis = animatingFettis.concat(fettis);
                return prom;
            },
            canvas: canvas,
            promise: prom,
            reset: function() {
                if (animationFrame) raf.cancel(animationFrame);
                if (destroy) destroy();
            }
        };
    }
    function confettiCannon(canvas, globalOpts) {
        var isLibCanvas = !canvas;
        var allowResize = !!prop(globalOpts || {}, "resize");
        var hasResizeEventRegistered = false;
        var globalDisableForReducedMotion = prop(globalOpts, "disableForReducedMotion", Boolean);
        var shouldUseWorker = canUseWorker && !!prop(globalOpts || {}, "useWorker");
        var worker = shouldUseWorker ? getWorker() : null;
        var resizer = isLibCanvas ? setCanvasWindowSize : setCanvasRectSize;
        var initialized = canvas && worker ? !!canvas.__confetti_initialized : false;
        var preferLessMotion = typeof matchMedia === "function" && matchMedia("(prefers-reduced-motion)").matches;
        var animationObj;
        function fireLocal(options, size, done) {
            var particleCount = prop(options, "particleCount", onlyPositiveInt);
            var angle = prop(options, "angle", Number);
            var spread = prop(options, "spread", Number);
            var startVelocity = prop(options, "startVelocity", Number);
            var decay = prop(options, "decay", Number);
            var gravity = prop(options, "gravity", Number);
            var drift = prop(options, "drift", Number);
            var colors = prop(options, "colors", colorsToRgb);
            var ticks = prop(options, "ticks", Number);
            var shapes = prop(options, "shapes");
            var scalar = prop(options, "scalar");
            var flat = !!prop(options, "flat");
            var origin = getOrigin(options);
            var temp = particleCount;
            var fettis = [];
            var startX = canvas.width * origin.x;
            var startY = canvas.height * origin.y;
            while(temp--)fettis.push(randomPhysics({
                x: startX,
                y: startY,
                angle: angle,
                spread: spread,
                startVelocity: startVelocity,
                color: colors[temp % colors.length],
                shape: shapes[randomInt(0, shapes.length)],
                ticks: ticks,
                decay: decay,
                gravity: gravity,
                drift: drift,
                scalar: scalar,
                flat: flat
            }));
            // if we have a previous canvas already animating,
            // add to it
            if (animationObj) return animationObj.addFettis(fettis);
            animationObj = animate(canvas, fettis, resizer, size, done);
            return animationObj.promise;
        }
        function fire(options) {
            var disableForReducedMotion = globalDisableForReducedMotion || prop(options, "disableForReducedMotion", Boolean);
            var zIndex = prop(options, "zIndex", Number);
            if (disableForReducedMotion && preferLessMotion) return promise(function(resolve) {
                resolve();
            });
            if (isLibCanvas && animationObj) // use existing canvas from in-progress animation
            canvas = animationObj.canvas;
            else if (isLibCanvas && !canvas) {
                // create and initialize a new canvas
                canvas = getCanvas(zIndex);
                document.body.appendChild(canvas);
            }
            if (allowResize && !initialized) // initialize the size of a user-supplied canvas
            resizer(canvas);
            var size = {
                width: canvas.width,
                height: canvas.height
            };
            if (worker && !initialized) worker.init(canvas);
            initialized = true;
            if (worker) canvas.__confetti_initialized = true;
            function onResize() {
                if (worker) {
                    // TODO this really shouldn't be immediate, because it is expensive
                    var obj = {
                        getBoundingClientRect: function() {
                            if (!isLibCanvas) return canvas.getBoundingClientRect();
                        }
                    };
                    resizer(obj);
                    worker.postMessage({
                        resize: {
                            width: obj.width,
                            height: obj.height
                        }
                    });
                    return;
                }
                // don't actually query the size here, since this
                // can execute frequently and rapidly
                size.width = size.height = null;
            }
            function done() {
                animationObj = null;
                if (allowResize) {
                    hasResizeEventRegistered = false;
                    global.removeEventListener("resize", onResize);
                }
                if (isLibCanvas && canvas) {
                    document.body.removeChild(canvas);
                    canvas = null;
                    initialized = false;
                }
            }
            if (allowResize && !hasResizeEventRegistered) {
                hasResizeEventRegistered = true;
                global.addEventListener("resize", onResize, false);
            }
            if (worker) return worker.fire(options, size, done);
            return fireLocal(options, size, done);
        }
        fire.reset = function() {
            if (worker) worker.reset();
            if (animationObj) animationObj.reset();
        };
        return fire;
    }
    // Make default export lazy to defer worker creation until called.
    var defaultFire;
    function getDefaultFire() {
        if (!defaultFire) defaultFire = confettiCannon(null, {
            useWorker: true,
            resize: true
        });
        return defaultFire;
    }
    function transformPath2D(pathString, pathMatrix, x, y, scaleX, scaleY, rotation) {
        var path2d = new Path2D(pathString);
        var t1 = new Path2D();
        t1.addPath(path2d, new DOMMatrix(pathMatrix));
        var t2 = new Path2D();
        // see https://developer.mozilla.org/en-US/docs/Web/API/DOMMatrix/DOMMatrix
        t2.addPath(t1, new DOMMatrix([
            Math.cos(rotation) * scaleX,
            Math.sin(rotation) * scaleX,
            -Math.sin(rotation) * scaleY,
            Math.cos(rotation) * scaleY,
            x,
            y
        ]));
        return t2;
    }
    function shapeFromPath(pathData) {
        if (!canUsePaths) throw new Error("path confetti are not supported in this browser");
        var path, matrix;
        if (typeof pathData === "string") path = pathData;
        else {
            path = pathData.path;
            matrix = pathData.matrix;
        }
        var path2d = new Path2D(path);
        var tempCanvas = document.createElement("canvas");
        var tempCtx = tempCanvas.getContext("2d");
        if (!matrix) {
            // attempt to figure out the width of the path, up to 1000x1000
            var maxSize = 1000;
            var minX = maxSize;
            var minY = maxSize;
            var maxX = 0;
            var maxY = 0;
            var width, height;
            // do some line skipping... this is faster than checking
            // every pixel and will be mostly still correct
            for(var x = 0; x < maxSize; x += 2){
                for(var y = 0; y < maxSize; y += 2)if (tempCtx.isPointInPath(path2d, x, y, "nonzero")) {
                    minX = Math.min(minX, x);
                    minY = Math.min(minY, y);
                    maxX = Math.max(maxX, x);
                    maxY = Math.max(maxY, y);
                }
            }
            width = maxX - minX;
            height = maxY - minY;
            var maxDesiredSize = 10;
            var scale = Math.min(maxDesiredSize / width, maxDesiredSize / height);
            matrix = [
                scale,
                0,
                0,
                scale,
                -Math.round(width / 2 + minX) * scale,
                -Math.round(height / 2 + minY) * scale
            ];
        }
        return {
            type: "path",
            path: path,
            matrix: matrix
        };
    }
    function shapeFromText(textData) {
        var text, scalar = 1, color = "#000000", // see https://nolanlawson.com/2022/04/08/the-struggle-of-using-native-emoji-on-the-web/
        fontFamily = '"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", "Twemoji Mozilla", "system emoji", sans-serif';
        if (typeof textData === "string") text = textData;
        else {
            text = textData.text;
            scalar = "scalar" in textData ? textData.scalar : scalar;
            fontFamily = "fontFamily" in textData ? textData.fontFamily : fontFamily;
            color = "color" in textData ? textData.color : color;
        }
        // all other confetti are 10 pixels,
        // so this pixel size is the de-facto 100% scale confetti
        var fontSize = 10 * scalar;
        var font = "" + fontSize + "px " + fontFamily;
        var canvas = new OffscreenCanvas(fontSize, fontSize);
        var ctx = canvas.getContext("2d");
        ctx.font = font;
        var size = ctx.measureText(text);
        var width = Math.ceil(size.actualBoundingBoxRight + size.actualBoundingBoxLeft);
        var height = Math.ceil(size.actualBoundingBoxAscent + size.actualBoundingBoxDescent);
        var padding = 2;
        var x = size.actualBoundingBoxLeft + padding;
        var y = size.actualBoundingBoxAscent + padding;
        width += padding + padding;
        height += padding + padding;
        canvas = new OffscreenCanvas(width, height);
        ctx = canvas.getContext("2d");
        ctx.font = font;
        ctx.fillStyle = color;
        ctx.fillText(text, x, y);
        var scale = 1 / scalar;
        return {
            type: "bitmap",
            // TODO these probably need to be transfered for workers
            bitmap: canvas.transferToImageBitmap(),
            matrix: [
                scale,
                0,
                0,
                scale,
                -width * scale / 2,
                -height * scale / 2
            ]
        };
    }
    module.exports = function() {
        return getDefaultFire().apply(this, arguments);
    };
    module.exports.reset = function() {
        getDefaultFire().reset();
    };
    module.exports.create = confettiCannon;
    module.exports.shapeFromPath = shapeFromPath;
    module.exports.shapeFromText = shapeFromText;
})(function() {
    if (typeof window !== "undefined") return window;
    if (typeof self !== "undefined") return self;
    return this || {};
}(), $947b03da4811c942$var$module, false);
var // end source content
$947b03da4811c942$export$2e2bcd8739ae039 = $947b03da4811c942$var$module.exports;
var $947b03da4811c942$export$185802fd694ee1f5 = $947b03da4811c942$var$module.exports.create;

});




parcelRegister("edg5W", function(module, exports) {

$parcel$export(module.exports, "useSession", () => $1db449f60d76da39$export$ad0a340bf97d63d5);

var $ba8s2 = parcelRequire("ba8s2");

var $bCeTl = parcelRequire("bCeTl");

var $2gHT7 = parcelRequire("2gHT7");

var $43CNa = parcelRequire("43CNa");

var $bdmoM = parcelRequire("bdmoM");

var $acw62 = parcelRequire("acw62");
parcelRequire("gCemA");
var $yrzTx = parcelRequire("yrzTx");
const $1db449f60d76da39$export$ad0a340bf97d63d5 = ({ enabled: enabled = true } = {})=>{
    const auth0Session = (0, $bCeTl.useAuth0)();
    const token = (0, $43CNa.useToken)();
    const identity = (0, $ba8s2.useQuery)({
        ...(0, $2gHT7.getIdentitySessionQuery)(token.data),
        enabled: enabled && !!token.data,
        staleTime: (0, $bdmoM.SESSION_STALE_TIME),
        gcTime: (0, $bdmoM.SESSION_GC_TIME)
    });
    const auth0Loading = !auth0Session.isAuthenticated && auth0Session.isLoading;
    const tokenLoading = !token.data && token.isLoading;
    const identityLoading = !identity.data && identity.isLoading;
    const identityError = !identity.data && identity.isError;
    const auth0Error = !auth0Session.user && !!auth0Session.error;
    const tokenError = !token.data && token.isError;
    const isHumError = auth0Session.isAuthenticated && !!token.data && identityError;
    (0, $acw62.useEffect)(()=>{
        if (isHumError) (0, $yrzTx.log).error("Auth0 session is authenticated but identity failed", {
            auth0Id: auth0Session?.user?.sub,
            email: auth0Session?.user?.email,
            name: auth0Session?.user?.name,
            identityError: identity.error
        });
    }, [
        isHumError
    ]);
    return {
        isLoading: auth0Loading || auth0Session.isAuthenticated && (tokenLoading || identityLoading),
        isAuthenticated: auth0Session.isAuthenticated && !!identity.data,
        isError: auth0Error || tokenError || identityError,
        isHumError: isHumError,
        auth0: auth0Session?.user || null,
        token: token,
        user: identity.data
    };
};

});
parcelRegister("bCeTl", function(module, exports) {

$parcel$export(module.exports, "Auth0Provider", () => $874ecb7cc9a437a2$export$6aefaad9cc4faf3c);
$parcel$export(module.exports, "useAuth0", () => $874ecb7cc9a437a2$export$f2b63d3ca66bb884);

var $acw62 = parcelRequire("acw62");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $874ecb7cc9a437a2$var$extendStatics = function(d, b) {
    $874ecb7cc9a437a2$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $874ecb7cc9a437a2$var$extendStatics(d, b);
};
function $874ecb7cc9a437a2$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $874ecb7cc9a437a2$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $874ecb7cc9a437a2$var$__assign = function() {
    $874ecb7cc9a437a2$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $874ecb7cc9a437a2$var$__assign.apply(this, arguments);
};
function $874ecb7cc9a437a2$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $874ecb7cc9a437a2$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $874ecb7cc9a437a2$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
typeof SuppressedError === "function" && SuppressedError;
function $874ecb7cc9a437a2$var$e(e, t) {
    var i = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (i[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;
        for(o = Object.getOwnPropertySymbols(e); n < o.length; n++)t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (i[o[n]] = e[o[n]]);
    }
    return i;
}
"function" == typeof SuppressedError && SuppressedError;
var $874ecb7cc9a437a2$var$t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $874ecb7cc9a437a2$var$i(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function $874ecb7cc9a437a2$var$o(e, t) {
    return e(t = {
        exports: {}
    }, t.exports), t.exports;
}
var $874ecb7cc9a437a2$var$n = $874ecb7cc9a437a2$var$o(function(e, t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = function() {
        function e() {
            var e = this;
            this.locked = new Map, this.addToLocked = function(t, i) {
                var o = e.locked.get(t);
                void 0 === o ? void 0 === i ? e.locked.set(t, []) : e.locked.set(t, [
                    i
                ]) : void 0 !== i && (o.unshift(i), e.locked.set(t, o));
            }, this.isLocked = function(t) {
                return e.locked.has(t);
            }, this.lock = function(t) {
                return new Promise(function(i, o) {
                    e.isLocked(t) ? e.addToLocked(t, i) : (e.addToLocked(t), i());
                });
            }, this.unlock = function(t) {
                var i = e.locked.get(t);
                if (void 0 !== i && 0 !== i.length) {
                    var o = i.pop();
                    e.locked.set(t, i), void 0 !== o && setTimeout(o, 0);
                } else e.locked.delete(t);
            };
        }
        return e.getInstance = function() {
            return void 0 === e.instance && (e.instance = new e), e.instance;
        }, e;
    }();
    t.default = function() {
        return i.getInstance();
    };
});
$874ecb7cc9a437a2$var$i($874ecb7cc9a437a2$var$n);
var $874ecb7cc9a437a2$var$a = $874ecb7cc9a437a2$var$i($874ecb7cc9a437a2$var$o(function(e, i) {
    var o = $874ecb7cc9a437a2$var$t && $874ecb7cc9a437a2$var$t.__awaiter || function(e, t, i, o) {
        return new (i || (i = Promise))(function(n, a) {
            function r(e) {
                try {
                    c(o.next(e));
                } catch (e) {
                    a(e);
                }
            }
            function s(e) {
                try {
                    c(o.throw(e));
                } catch (e) {
                    a(e);
                }
            }
            function c(e) {
                e.done ? n(e.value) : new i(function(t) {
                    t(e.value);
                }).then(r, s);
            }
            c((o = o.apply(e, t || [])).next());
        });
    }, a = $874ecb7cc9a437a2$var$t && $874ecb7cc9a437a2$var$t.__generator || function(e, t) {
        var i, o, n, a, r = {
            label: 0,
            sent: function() {
                if (1 & n[0]) throw n[1];
                return n[1];
            },
            trys: [],
            ops: []
        };
        return a = {
            next: s(0),
            throw: s(1),
            return: s(2)
        }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
            return this;
        }), a;
        function s(a) {
            return function(s) {
                return function(a) {
                    if (i) throw new TypeError("Generator is already executing.");
                    for(; r;)try {
                        if (i = 1, o && (n = 2 & a[0] ? o.return : a[0] ? o.throw || ((n = o.return) && n.call(o), 0) : o.next) && !(n = n.call(o, a[1])).done) return n;
                        switch(o = 0, n && (a = [
                            2 & a[0],
                            n.value
                        ]), a[0]){
                            case 0:
                            case 1:
                                n = a;
                                break;
                            case 4:
                                return r.label++, {
                                    value: a[1],
                                    done: !1
                                };
                            case 5:
                                r.label++, o = a[1], a = [
                                    0
                                ];
                                continue;
                            case 7:
                                a = r.ops.pop(), r.trys.pop();
                                continue;
                            default:
                                if (!(n = r.trys, (n = n.length > 0 && n[n.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                    r = 0;
                                    continue;
                                }
                                if (3 === a[0] && (!n || a[1] > n[0] && a[1] < n[3])) {
                                    r.label = a[1];
                                    break;
                                }
                                if (6 === a[0] && r.label < n[1]) {
                                    r.label = n[1], n = a;
                                    break;
                                }
                                if (n && r.label < n[2]) {
                                    r.label = n[2], r.ops.push(a);
                                    break;
                                }
                                n[2] && r.ops.pop(), r.trys.pop();
                                continue;
                        }
                        a = t.call(e, r);
                    } catch (e) {
                        a = [
                            6,
                            e
                        ], o = 0;
                    } finally{
                        i = n = 0;
                    }
                    if (5 & a[0]) throw a[1];
                    return {
                        value: a[0] ? a[1] : void 0,
                        done: !0
                    };
                }([
                    a,
                    s
                ]);
            };
        }
    }, r = $874ecb7cc9a437a2$var$t;
    Object.defineProperty(i, "__esModule", {
        value: !0
    });
    var s = "browser-tabs-lock-key", c = {
        key: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        getItem: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        clear: function() {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    return [
                        2,
                        window.localStorage.clear()
                    ];
                });
            });
        },
        removeItem: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        setItem: function(e, t) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        keySync: function(e) {
            return window.localStorage.key(e);
        },
        getItemSync: function(e) {
            return window.localStorage.getItem(e);
        },
        clearSync: function() {
            return window.localStorage.clear();
        },
        removeItemSync: function(e) {
            return window.localStorage.removeItem(e);
        },
        setItemSync: function(e, t) {
            return window.localStorage.setItem(e, t);
        }
    };
    function d(e) {
        return new Promise(function(t) {
            return setTimeout(t, e);
        });
    }
    function u(e) {
        for(var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", i = "", o = 0; o < e; o++)i += t[Math.floor(Math.random() * t.length)];
        return i;
    }
    var l = function() {
        function e(t) {
            this.acquiredIatSet = new Set, this.storageHandler = void 0, this.id = Date.now().toString() + u(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, void 0 === e.waiters && (e.waiters = []);
        }
        return e.prototype.acquireLock = function(t, i) {
            return void 0 === i && (i = 5e3), o(this, void 0, void 0, function() {
                var o, n, r, l, h, p, m;
                return a(this, function(a) {
                    switch(a.label){
                        case 0:
                            o = Date.now() + u(4), n = Date.now() + i, r = s + "-" + t, l = void 0 === this.storageHandler ? c : this.storageHandler, a.label = 1;
                        case 1:
                            return Date.now() < n ? [
                                4,
                                d(30)
                            ] : [
                                3,
                                8
                            ];
                        case 2:
                            return a.sent(), null !== l.getItemSync(r) ? [
                                3,
                                5
                            ] : (h = this.id + "-" + t + "-" + o, [
                                4,
                                d(Math.floor(25 * Math.random()))
                            ]);
                        case 3:
                            return a.sent(), l.setItemSync(r, JSON.stringify({
                                id: this.id,
                                iat: o,
                                timeoutKey: h,
                                timeAcquired: Date.now(),
                                timeRefreshed: Date.now()
                            })), [
                                4,
                                d(30)
                            ];
                        case 4:
                            return a.sent(), null !== (p = l.getItemSync(r)) && (m = JSON.parse(p)).id === this.id && m.iat === o ? (this.acquiredIatSet.add(o), this.refreshLockWhileAcquired(r, o), [
                                2,
                                !0
                            ]) : [
                                3,
                                7
                            ];
                        case 5:
                            return e.lockCorrector(void 0 === this.storageHandler ? c : this.storageHandler), [
                                4,
                                this.waitForSomethingToChange(n)
                            ];
                        case 6:
                            a.sent(), a.label = 7;
                        case 7:
                            return o = Date.now() + u(4), [
                                3,
                                1
                            ];
                        case 8:
                            return [
                                2,
                                !1
                            ];
                    }
                });
            });
        }, e.prototype.refreshLockWhileAcquired = function(e, t) {
            return o(this, void 0, void 0, function() {
                var i = this;
                return a(this, function(r) {
                    return setTimeout(function() {
                        return o(i, void 0, void 0, function() {
                            var i, o, r;
                            return a(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        return [
                                            4,
                                            $874ecb7cc9a437a2$var$n.default().lock(t)
                                        ];
                                    case 1:
                                        return a.sent(), this.acquiredIatSet.has(t) ? (i = void 0 === this.storageHandler ? c : this.storageHandler, null === (o = i.getItemSync(e)) ? ($874ecb7cc9a437a2$var$n.default().unlock(t), [
                                            2
                                        ]) : ((r = JSON.parse(o)).timeRefreshed = Date.now(), i.setItemSync(e, JSON.stringify(r)), $874ecb7cc9a437a2$var$n.default().unlock(t), this.refreshLockWhileAcquired(e, t), [
                                            2
                                        ])) : ($874ecb7cc9a437a2$var$n.default().unlock(t), [
                                            2
                                        ]);
                                }
                            });
                        });
                    }, 1e3), [
                        2
                    ];
                });
            });
        }, e.prototype.waitForSomethingToChange = function(t) {
            return o(this, void 0, void 0, function() {
                return a(this, function(i) {
                    switch(i.label){
                        case 0:
                            return [
                                4,
                                new Promise(function(i) {
                                    var o = !1, n = Date.now(), a = !1;
                                    function r() {
                                        if (a || (window.removeEventListener("storage", r), e.removeFromWaiting(r), clearTimeout(s), a = !0), !o) {
                                            o = !0;
                                            var t = 50 - (Date.now() - n);
                                            t > 0 ? setTimeout(i, t) : i(null);
                                        }
                                    }
                                    window.addEventListener("storage", r), e.addToWaiting(r);
                                    var s = setTimeout(r, Math.max(0, t - Date.now()));
                                })
                            ];
                        case 1:
                            return i.sent(), [
                                2
                            ];
                    }
                });
            });
        }, e.addToWaiting = function(t) {
            this.removeFromWaiting(t), void 0 !== e.waiters && e.waiters.push(t);
        }, e.removeFromWaiting = function(t) {
            void 0 !== e.waiters && (e.waiters = e.waiters.filter(function(e) {
                return e !== t;
            }));
        }, e.notifyWaiters = function() {
            void 0 !== e.waiters && e.waiters.slice().forEach(function(e) {
                return e();
            });
        }, e.prototype.releaseLock = function(e) {
            return o(this, void 0, void 0, function() {
                return a(this, function(t) {
                    switch(t.label){
                        case 0:
                            return [
                                4,
                                this.releaseLock__private__(e)
                            ];
                        case 1:
                            return [
                                2,
                                t.sent()
                            ];
                    }
                });
            });
        }, e.prototype.releaseLock__private__ = function(t) {
            return o(this, void 0, void 0, function() {
                var i, o, r, d;
                return a(this, function(a) {
                    switch(a.label){
                        case 0:
                            return i = void 0 === this.storageHandler ? c : this.storageHandler, o = s + "-" + t, null === (r = i.getItemSync(o)) ? [
                                2
                            ] : (d = JSON.parse(r)).id !== this.id ? [
                                3,
                                2
                            ] : [
                                4,
                                $874ecb7cc9a437a2$var$n.default().lock(d.iat)
                            ];
                        case 1:
                            a.sent(), this.acquiredIatSet.delete(d.iat), i.removeItemSync(o), $874ecb7cc9a437a2$var$n.default().unlock(d.iat), e.notifyWaiters(), a.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
        }, e.lockCorrector = function(t) {
            for(var i = Date.now() - 5e3, o = t, n = [], a = 0;;){
                var r = o.keySync(a);
                if (null === r) break;
                n.push(r), a++;
            }
            for(var c = !1, d = 0; d < n.length; d++){
                var u = n[d];
                if (u.includes(s)) {
                    var l = o.getItemSync(u);
                    if (null !== l) {
                        var h = JSON.parse(l);
                        (void 0 === h.timeRefreshed && h.timeAcquired < i || void 0 !== h.timeRefreshed && h.timeRefreshed < i) && (o.removeItemSync(u), c = !0);
                    }
                }
            }
            c && e.notifyWaiters();
        }, e.waiters = void 0, e;
    }();
    i.default = l;
}));
const $874ecb7cc9a437a2$var$r = {
    timeoutInSeconds: 60
}, $874ecb7cc9a437a2$var$s = {
    name: "auth0-spa-js",
    version: "2.1.3"
}, $874ecb7cc9a437a2$var$c = ()=>Date.now();
class $874ecb7cc9a437a2$export$7d465be8efa67280 extends Error {
    constructor(e, t){
        super(t), this.error = e, this.error_description = t, Object.setPrototypeOf(this, $874ecb7cc9a437a2$export$7d465be8efa67280.prototype);
    }
    static fromPayload({ error: e, error_description: t }) {
        return new $874ecb7cc9a437a2$export$7d465be8efa67280(e, t);
    }
}
class $874ecb7cc9a437a2$export$cf0c46b07324e9c5 extends $874ecb7cc9a437a2$export$7d465be8efa67280 {
    constructor(e, t, i, o = null){
        super(e, t), this.state = i, this.appState = o, Object.setPrototypeOf(this, $874ecb7cc9a437a2$export$cf0c46b07324e9c5.prototype);
    }
}
class $874ecb7cc9a437a2$export$66d311bf29d5c89c extends $874ecb7cc9a437a2$export$7d465be8efa67280 {
    constructor(){
        super("timeout", "Timeout"), Object.setPrototypeOf(this, $874ecb7cc9a437a2$export$66d311bf29d5c89c.prototype);
    }
}
class $874ecb7cc9a437a2$export$ebbb83fe03f719a4 extends $874ecb7cc9a437a2$export$66d311bf29d5c89c {
    constructor(e){
        super(), this.popup = e, Object.setPrototypeOf(this, $874ecb7cc9a437a2$export$ebbb83fe03f719a4.prototype);
    }
}
class $874ecb7cc9a437a2$export$f1f681f0fb26bb55 extends $874ecb7cc9a437a2$export$7d465be8efa67280 {
    constructor(e){
        super("cancelled", "Popup closed"), this.popup = e, Object.setPrototypeOf(this, $874ecb7cc9a437a2$export$f1f681f0fb26bb55.prototype);
    }
}
class $874ecb7cc9a437a2$export$c59494f4dae44ada extends $874ecb7cc9a437a2$export$7d465be8efa67280 {
    constructor(e, t, i){
        super(e, t), this.mfa_token = i, Object.setPrototypeOf(this, $874ecb7cc9a437a2$export$c59494f4dae44ada.prototype);
    }
}
class $874ecb7cc9a437a2$export$ac1d2a00f8e0a046 extends $874ecb7cc9a437a2$export$7d465be8efa67280 {
    constructor(e, t){
        super("missing_refresh_token", `Missing Refresh Token (audience: '${$874ecb7cc9a437a2$var$g(e, [
            "default"
        ])}', scope: '${$874ecb7cc9a437a2$var$g(t)}')`), this.audience = e, this.scope = t, Object.setPrototypeOf(this, $874ecb7cc9a437a2$export$ac1d2a00f8e0a046.prototype);
    }
}
function $874ecb7cc9a437a2$var$g(e, t = []) {
    return e && !t.includes(e) ? e : "";
}
const $874ecb7cc9a437a2$var$w = ()=>window.crypto, $874ecb7cc9a437a2$var$y = ()=>{
    const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
    let t = "";
    return Array.from($874ecb7cc9a437a2$var$w().getRandomValues(new Uint8Array(43))).forEach((i)=>t += e[i % e.length]), t;
}, $874ecb7cc9a437a2$var$k = (e)=>btoa(e), $874ecb7cc9a437a2$var$v = (t)=>{
    var { clientId: i } = t, o = $874ecb7cc9a437a2$var$e(t, [
        "clientId"
    ]);
    return new URLSearchParams(((e)=>Object.keys(e).filter((t)=>void 0 !== e[t]).reduce((t, i)=>Object.assign(Object.assign({}, t), {
                [i]: e[i]
            }), {}))(Object.assign({
        client_id: i
    }, o))).toString();
}, $874ecb7cc9a437a2$var$b = (e)=>((e)=>decodeURIComponent(atob(e).split("").map((e)=>"%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), $874ecb7cc9a437a2$var$_ = async (e, t)=>{
    const i = await fetch(e, t);
    return {
        ok: i.ok,
        json: await i.json()
    };
}, $874ecb7cc9a437a2$var$I = async (e, t, i)=>{
    const o = new AbortController;
    let n;
    return t.signal = o.signal, Promise.race([
        $874ecb7cc9a437a2$var$_(e, t),
        new Promise((e, t)=>{
            n = setTimeout(()=>{
                o.abort(), t(new Error("Timeout when executing 'fetch'"));
            }, i);
        })
    ]).finally(()=>{
        clearTimeout(n);
    });
}, $874ecb7cc9a437a2$var$S = async (e, t, i, o, n, a, r)=>{
    var s, c;
    return s = {
        auth: {
            audience: t,
            scope: i
        },
        timeout: n,
        fetchUrl: e,
        fetchOptions: o,
        useFormData: r
    }, c = a, new Promise(function(e, t) {
        const i = new MessageChannel;
        i.port1.onmessage = function(o) {
            o.data.error ? t(new Error(o.data.error)) : e(o.data), i.port1.close();
        }, c.postMessage(s, [
            i.port2
        ]);
    });
}, $874ecb7cc9a437a2$var$O = async (e, t, i, o, n, a, r = 1e4)=>n ? $874ecb7cc9a437a2$var$S(e, t, i, o, r, n, a) : $874ecb7cc9a437a2$var$I(e, o, r);
async function $874ecb7cc9a437a2$var$T(t, i) {
    var { baseUrl: o, timeout: n, audience: a, scope: r, auth0Client: c, useFormData: u } = t, l = $874ecb7cc9a437a2$var$e(t, [
        "baseUrl",
        "timeout",
        "audience",
        "scope",
        "auth0Client",
        "useFormData"
    ]);
    const h = u ? $874ecb7cc9a437a2$var$v(l) : JSON.stringify(l);
    return await async function(t, i, o, n, a, r, s) {
        let c, u = null;
        for(let e = 0; e < 3; e++)try {
            c = await $874ecb7cc9a437a2$var$O(t, o, n, a, r, s, i), u = null;
            break;
        } catch (e) {
            u = e;
        }
        if (u) throw u;
        const l = c.json, { error: h, error_description: p } = l, g = $874ecb7cc9a437a2$var$e(l, [
            "error",
            "error_description"
        ]), { ok: w } = c;
        if (!w) {
            const e = p || `HTTP error. Unable to fetch ${t}`;
            if ("mfa_required" === h) throw new $874ecb7cc9a437a2$export$c59494f4dae44ada(h, e, g.mfa_token);
            if ("missing_refresh_token" === h) throw new $874ecb7cc9a437a2$export$ac1d2a00f8e0a046(o, n);
            throw new $874ecb7cc9a437a2$export$7d465be8efa67280(h || "request_error", e);
        }
        return g;
    }(`${o}/oauth/token`, n, a || "default", r, {
        method: "POST",
        body: h,
        headers: {
            "Content-Type": u ? "application/x-www-form-urlencoded" : "application/json",
            "Auth0-Client": btoa(JSON.stringify(c || $874ecb7cc9a437a2$var$s))
        }
    }, i, u);
}
const $874ecb7cc9a437a2$var$j = (...e)=>{
    var t;
    return (t = e.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(t))).join(" ");
};
class $874ecb7cc9a437a2$var$C {
    constructor(e, t = "@@auth0spajs@@", i){
        this.prefix = t, this.suffix = i, this.clientId = e.clientId, this.scope = e.scope, this.audience = e.audience;
    }
    toKey() {
        return [
            this.prefix,
            this.clientId,
            this.audience,
            this.scope,
            this.suffix
        ].filter(Boolean).join("::");
    }
    static fromKey(e) {
        const [t, i, o, n] = e.split("::");
        return new $874ecb7cc9a437a2$var$C({
            clientId: i,
            scope: n,
            audience: o
        }, t);
    }
    static fromCacheEntry(e) {
        const { scope: t, audience: i, client_id: o } = e;
        return new $874ecb7cc9a437a2$var$C({
            scope: t,
            audience: i,
            clientId: o
        });
    }
}
class $874ecb7cc9a437a2$export$40ef2cb682e70737 {
    set(e, t) {
        localStorage.setItem(e, JSON.stringify(t));
    }
    get(e) {
        const t = window.localStorage.getItem(e);
        if (t) try {
            return JSON.parse(t);
        } catch (e) {
            return;
        }
    }
    remove(e) {
        localStorage.removeItem(e);
    }
    allKeys() {
        return Object.keys(window.localStorage).filter((e)=>e.startsWith("@@auth0spajs@@"));
    }
}
class $874ecb7cc9a437a2$export$467265324939f47f {
    constructor(){
        this.enclosedCache = function() {
            let e = {};
            return {
                set (t, i) {
                    e[t] = i;
                },
                get (t) {
                    const i = e[t];
                    if (i) return i;
                },
                remove (t) {
                    delete e[t];
                },
                allKeys: ()=>Object.keys(e)
            };
        }();
    }
}
class $874ecb7cc9a437a2$var$x {
    constructor(e, t, i){
        this.cache = e, this.keyManifest = t, this.nowProvider = i || $874ecb7cc9a437a2$var$c;
    }
    async setIdToken(e, t, i) {
        var o;
        const n = this.getIdTokenCacheKey(e);
        await this.cache.set(n, {
            id_token: t,
            decodedToken: i
        }), await (null === (o = this.keyManifest) || void 0 === o ? void 0 : o.add(n));
    }
    async getIdToken(e) {
        const t = await this.cache.get(this.getIdTokenCacheKey(e.clientId));
        if (!t && e.scope && e.audience) {
            const t = await this.get(e);
            if (!t) return;
            if (!t.id_token || !t.decodedToken) return;
            return {
                id_token: t.id_token,
                decodedToken: t.decodedToken
            };
        }
        if (t) return {
            id_token: t.id_token,
            decodedToken: t.decodedToken
        };
    }
    async get(e, t = 0) {
        var i;
        let o = await this.cache.get(e.toKey());
        if (!o) {
            const t = await this.getCacheKeys();
            if (!t) return;
            const i = this.matchExistingCacheKey(e, t);
            i && (o = await this.cache.get(i));
        }
        if (!o) return;
        const n = await this.nowProvider(), a = Math.floor(n / 1e3);
        return o.expiresAt - t < a ? o.body.refresh_token ? (o.body = {
            refresh_token: o.body.refresh_token
        }, await this.cache.set(e.toKey(), o), o.body) : (await this.cache.remove(e.toKey()), void await (null === (i = this.keyManifest) || void 0 === i ? void 0 : i.remove(e.toKey()))) : o.body;
    }
    async set(e) {
        var t;
        const i = new $874ecb7cc9a437a2$var$C({
            clientId: e.client_id,
            scope: e.scope,
            audience: e.audience
        }), o = await this.wrapCacheEntry(e);
        await this.cache.set(i.toKey(), o), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.add(i.toKey()));
    }
    async clear(e) {
        var t;
        const i = await this.getCacheKeys();
        i && (await i.filter((t)=>!e || t.includes(e)).reduce(async (e, t)=>{
            await e, await this.cache.remove(t);
        }, Promise.resolve()), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.clear()));
    }
    async wrapCacheEntry(e) {
        const t = await this.nowProvider();
        return {
            body: e,
            expiresAt: Math.floor(t / 1e3) + e.expires_in
        };
    }
    async getCacheKeys() {
        var e;
        return this.keyManifest ? null === (e = await this.keyManifest.get()) || void 0 === e ? void 0 : e.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
    }
    getIdTokenCacheKey(e) {
        return new $874ecb7cc9a437a2$var$C({
            clientId: e
        }, "@@auth0spajs@@", "@@user@@").toKey();
    }
    matchExistingCacheKey(e, t) {
        return t.filter((t)=>{
            var i;
            const o = $874ecb7cc9a437a2$var$C.fromKey(t), n = new Set(o.scope && o.scope.split(" ")), a = (null === (i = e.scope) || void 0 === i ? void 0 : i.split(" ")) || [], r = o.scope && a.reduce((e, t)=>e && n.has(t), !0);
            return "@@auth0spajs@@" === o.prefix && o.clientId === e.clientId && o.audience === e.audience && r;
        })[0];
    }
}
class $874ecb7cc9a437a2$var$Z {
    constructor(e, t, i){
        this.storage = e, this.clientId = t, this.cookieDomain = i, this.storageKey = `a0.spajs.txs.${this.clientId}`;
    }
    create(e) {
        this.storage.save(this.storageKey, e, {
            daysUntilExpire: 1,
            cookieDomain: this.cookieDomain
        });
    }
    get() {
        return this.storage.get(this.storageKey);
    }
    remove() {
        this.storage.remove(this.storageKey, {
            cookieDomain: this.cookieDomain
        });
    }
}
const $874ecb7cc9a437a2$var$K = (e)=>"number" == typeof e, $874ecb7cc9a437a2$var$W = [
    "iss",
    "aud",
    "exp",
    "nbf",
    "iat",
    "jti",
    "azp",
    "nonce",
    "auth_time",
    "at_hash",
    "c_hash",
    "acr",
    "amr",
    "sub_jwk",
    "cnf",
    "sip_from_tag",
    "sip_date",
    "sip_callid",
    "sip_cseq_num",
    "sip_via_branch",
    "orig",
    "dest",
    "mky",
    "events",
    "toe",
    "txn",
    "rph",
    "sid",
    "vot",
    "vtm"
], $874ecb7cc9a437a2$var$E = (e)=>{
    if (!e.id_token) throw new Error("ID token is required but missing");
    const t = ((e)=>{
        const t = e.split("."), [i, o, n] = t;
        if (3 !== t.length || !i || !o || !n) throw new Error("ID token could not be decoded");
        const a = JSON.parse($874ecb7cc9a437a2$var$b(o)), r = {
            __raw: e
        }, s = {};
        return Object.keys(a).forEach((e)=>{
            r[e] = a[e], $874ecb7cc9a437a2$var$W.includes(e) || (s[e] = a[e]);
        }), {
            encoded: {
                header: i,
                payload: o,
                signature: n
            },
            header: JSON.parse($874ecb7cc9a437a2$var$b(i)),
            claims: r,
            user: s
        };
    })(e.id_token);
    if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
    if (t.claims.iss !== e.iss) throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${e.iss}", found "${t.claims.iss}"`);
    if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
    if ("RS256" !== t.header.alg) throw new Error(`Signature algorithm of "${t.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);
    if (!t.claims.aud || "string" != typeof t.claims.aud && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e.aud)) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but was not one of "${t.claims.aud.join(", ")}"`);
        if (t.claims.aud.length > 1) {
            if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
            if (t.claims.azp !== e.aud) throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${e.aud}", found "${t.claims.azp}"`);
        }
    } else if (t.claims.aud !== e.aud) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but found "${t.claims.aud}"`);
    if (e.nonce) {
        if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
        if (t.claims.nonce !== e.nonce) throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${e.nonce}", found "${t.claims.nonce}"`);
    }
    if (e.max_age && !$874ecb7cc9a437a2$var$K(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
    if (null == t.claims.exp || !$874ecb7cc9a437a2$var$K(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
    if (!$874ecb7cc9a437a2$var$K(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
    const i = e.leeway || 60, o = new Date(e.now || Date.now()), n = new Date(0);
    if (n.setUTCSeconds(t.claims.exp + i), o > n) throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${o}) is after expiration time (${n})`);
    if (null != t.claims.nbf && $874ecb7cc9a437a2$var$K(t.claims.nbf)) {
        const e = new Date(0);
        if (e.setUTCSeconds(t.claims.nbf - i), o < e) throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${o}) is before ${e}`);
    }
    if (null != t.claims.auth_time && $874ecb7cc9a437a2$var$K(t.claims.auth_time)) {
        const n = new Date(0);
        if (n.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + i), o > n) throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${o}) is after last auth at ${n}`);
    }
    if (e.organization) {
        const i = e.organization.trim();
        if (i.startsWith("org_")) {
            const e = i;
            if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
            if (e !== t.claims.org_id) throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_id}"`);
        } else {
            const e = i.toLowerCase();
            if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
            if (e !== t.claims.org_name) throw new Error(`Organization Name (org_name) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_name}"`);
        }
    }
    return t;
};
var $874ecb7cc9a437a2$var$R = $874ecb7cc9a437a2$var$o(function(e, i) {
    var o = $874ecb7cc9a437a2$var$t && $874ecb7cc9a437a2$var$t.__assign || function() {
        return o = Object.assign || function(e) {
            for(var t, i = 1, o = arguments.length; i < o; i++)for(var n in t = arguments[i])Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            return e;
        }, o.apply(this, arguments);
    };
    function n(e, t) {
        if (!t) return "";
        var i = "; " + e;
        return !0 === t ? i : i + "=" + t;
    }
    function a(e, t, i) {
        return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(e) {
            if ("number" == typeof e.expires) {
                var t = new Date;
                t.setMilliseconds(t.getMilliseconds() + 864e5 * e.expires), e.expires = t;
            }
            return n("Expires", e.expires ? e.expires.toUTCString() : "") + n("Domain", e.domain) + n("Path", e.path) + n("Secure", e.secure) + n("SameSite", e.sameSite);
        }(i);
    }
    function r(e) {
        for(var t = {}, i = e ? e.split("; ") : [], o = /(%[\dA-F]{2})+/gi, n = 0; n < i.length; n++){
            var a = i[n].split("="), r = a.slice(1).join("=");
            '"' === r.charAt(0) && (r = r.slice(1, -1));
            try {
                t[a[0].replace(o, decodeURIComponent)] = r.replace(o, decodeURIComponent);
            } catch (e) {}
        }
        return t;
    }
    function s() {
        return r(document.cookie);
    }
    function c(e, t, i) {
        document.cookie = a(e, t, o({
            path: "/"
        }, i));
    }
    i.__esModule = !0, i.encode = a, i.parse = r, i.getAll = s, i.get = function(e) {
        return s()[e];
    }, i.set = c, i.remove = function(e, t) {
        c(e, "", o(o({}, t), {
            expires: -1
        }));
    };
});
$874ecb7cc9a437a2$var$i($874ecb7cc9a437a2$var$R), $874ecb7cc9a437a2$var$R.encode, $874ecb7cc9a437a2$var$R.parse, $874ecb7cc9a437a2$var$R.getAll;
var $874ecb7cc9a437a2$var$U = $874ecb7cc9a437a2$var$R.get, $874ecb7cc9a437a2$var$L = $874ecb7cc9a437a2$var$R.set, $874ecb7cc9a437a2$var$D = $874ecb7cc9a437a2$var$R.remove;
const $874ecb7cc9a437a2$var$X = {
    get (e) {
        const t = $874ecb7cc9a437a2$var$U(e);
        if (void 0 !== t) return JSON.parse(t);
    },
    save (e, t, i) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0,
            sameSite: "none"
        }), (null == i ? void 0 : i.daysUntilExpire) && (o.expires = i.daysUntilExpire), (null == i ? void 0 : i.cookieDomain) && (o.domain = i.cookieDomain), $874ecb7cc9a437a2$var$L(e, JSON.stringify(t), o);
    },
    remove (e, t) {
        let i = {};
        (null == t ? void 0 : t.cookieDomain) && (i.domain = t.cookieDomain), $874ecb7cc9a437a2$var$D(e, i);
    }
}, $874ecb7cc9a437a2$var$N = {
    get (e) {
        const t = $874ecb7cc9a437a2$var$X.get(e);
        return t || $874ecb7cc9a437a2$var$X.get(`_legacy_${e}`);
    },
    save (e, t, i) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0
        }), (null == i ? void 0 : i.daysUntilExpire) && (o.expires = i.daysUntilExpire), (null == i ? void 0 : i.cookieDomain) && (o.domain = i.cookieDomain), $874ecb7cc9a437a2$var$L(`_legacy_${e}`, JSON.stringify(t), o), $874ecb7cc9a437a2$var$X.save(e, t, i);
    },
    remove (e, t) {
        let i = {};
        (null == t ? void 0 : t.cookieDomain) && (i.domain = t.cookieDomain), $874ecb7cc9a437a2$var$D(e, i), $874ecb7cc9a437a2$var$X.remove(e, t), $874ecb7cc9a437a2$var$X.remove(`_legacy_${e}`, t);
    }
}, $874ecb7cc9a437a2$var$J = {
    get (e) {
        if ("undefined" == typeof sessionStorage) return;
        const t = sessionStorage.getItem(e);
        return null != t ? JSON.parse(t) : void 0;
    },
    save (e, t) {
        sessionStorage.setItem(e, JSON.stringify(t));
    },
    remove (e) {
        sessionStorage.removeItem(e);
    }
};
function $874ecb7cc9a437a2$var$F(e, t, i) {
    var o = void 0 === t ? null : t, n = function(e, t) {
        var i = atob(e);
        if (t) {
            for(var o = new Uint8Array(i.length), n = 0, a = i.length; n < a; ++n)o[n] = i.charCodeAt(n);
            return String.fromCharCode.apply(null, new Uint16Array(o.buffer));
        }
        return i;
    }(e, void 0 !== i && i), a = n.indexOf("\n", 10) + 1, r = n.substring(a) + (o ? "//# sourceMappingURL=" + o : ""), s = new Blob([
        r
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(s);
}
var $874ecb7cc9a437a2$var$H, $874ecb7cc9a437a2$var$Y, $874ecb7cc9a437a2$var$G, $874ecb7cc9a437a2$var$V, $874ecb7cc9a437a2$var$M = ($874ecb7cc9a437a2$var$H = "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", $874ecb7cc9a437a2$var$Y = null, $874ecb7cc9a437a2$var$G = !1, function(e) {
    return $874ecb7cc9a437a2$var$V = $874ecb7cc9a437a2$var$V || $874ecb7cc9a437a2$var$F($874ecb7cc9a437a2$var$H, $874ecb7cc9a437a2$var$Y, $874ecb7cc9a437a2$var$G), new Worker($874ecb7cc9a437a2$var$V, e);
});
const $874ecb7cc9a437a2$var$A = {};
class $874ecb7cc9a437a2$var$B {
    constructor(e, t){
        this.cache = e, this.clientId = t, this.manifestKey = this.createManifestKeyFrom(this.clientId);
    }
    async add(e) {
        var t;
        const i = new Set((null === (t = await this.cache.get(this.manifestKey)) || void 0 === t ? void 0 : t.keys) || []);
        i.add(e), await this.cache.set(this.manifestKey, {
            keys: [
                ...i
            ]
        });
    }
    async remove(e) {
        const t = await this.cache.get(this.manifestKey);
        if (t) {
            const i = new Set(t.keys);
            return i.delete(e), i.size > 0 ? await this.cache.set(this.manifestKey, {
                keys: [
                    ...i
                ]
            }) : await this.cache.remove(this.manifestKey);
        }
    }
    get() {
        return this.cache.get(this.manifestKey);
    }
    clear() {
        return this.cache.remove(this.manifestKey);
    }
    createManifestKeyFrom(e) {
        return `@@auth0spajs@@::${e}`;
    }
}
const $874ecb7cc9a437a2$var$$ = {
    memory: ()=>(new $874ecb7cc9a437a2$export$467265324939f47f).enclosedCache,
    localstorage: ()=>new $874ecb7cc9a437a2$export$40ef2cb682e70737
}, $874ecb7cc9a437a2$var$q = (e)=>$874ecb7cc9a437a2$var$$[e], $874ecb7cc9a437a2$var$Q = (t)=>{
    const { openUrl: i, onRedirect: o } = t, n = $874ecb7cc9a437a2$var$e(t, [
        "openUrl",
        "onRedirect"
    ]);
    return Object.assign(Object.assign({}, n), {
        openUrl: !1 === i || i ? i : o
    });
}, $874ecb7cc9a437a2$var$ee = new $874ecb7cc9a437a2$var$a;
class $874ecb7cc9a437a2$var$te {
    constructor(e){
        let t, i;
        if (this.userCache = (new $874ecb7cc9a437a2$export$467265324939f47f).enclosedCache, this.defaultOptions = {
            authorizationParams: {
                scope: "openid profile email"
            },
            useRefreshTokensFallback: !1,
            useFormData: !0
        }, this._releaseLockOnPageHide = async ()=>{
            await $874ecb7cc9a437a2$var$ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
        }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), e), {
            authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), e.authorizationParams)
        }), "undefined" != typeof window && (()=>{
            if (!$874ecb7cc9a437a2$var$w()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
            if (void 0 === $874ecb7cc9a437a2$var$w().subtle) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
        })(), e.cache && e.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e.cache) i = e.cache;
        else {
            if (t = e.cacheLocation || "memory", !$874ecb7cc9a437a2$var$q(t)) throw new Error(`Invalid cache location "${t}"`);
            i = $874ecb7cc9a437a2$var$q(t)();
        }
        this.httpTimeoutMs = e.httpTimeoutInSeconds ? 1e3 * e.httpTimeoutInSeconds : 1e4, this.cookieStorage = !1 === e.legacySameSiteCookie ? $874ecb7cc9a437a2$var$X : $874ecb7cc9a437a2$var$N, this.orgHintCookieName = `auth0.${this.options.clientId}.organization_hint`, this.isAuthenticatedCookieName = ((e)=>`auth0.${e}.is.authenticated`)(this.options.clientId), this.sessionCheckExpiryDays = e.sessionCheckExpiryDays || 1;
        const o = e.useCookiesForTransactions ? this.cookieStorage : $874ecb7cc9a437a2$var$J;
        var n;
        this.scope = $874ecb7cc9a437a2$var$j("openid", this.options.authorizationParams.scope, this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new $874ecb7cc9a437a2$var$Z(o, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || $874ecb7cc9a437a2$var$c, this.cacheManager = new $874ecb7cc9a437a2$var$x(i, i.allKeys ? void 0 : new $874ecb7cc9a437a2$var$B(i, this.options.clientId), this.nowProvider), this.domainUrl = (n = this.options.domain, /^https?:\/\//.test(n) ? n : `https://${n}`), this.tokenIssuer = ((e, t)=>e ? e.startsWith("https://") ? e : `https://${e}/` : `${t}/`)(this.options.issuer, this.domainUrl), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && "memory" === t && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new $874ecb7cc9a437a2$var$M);
    }
    _url(e) {
        const t = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || $874ecb7cc9a437a2$var$s)));
        return `${this.domainUrl}${e}&auth0Client=${t}`;
    }
    _authorizeUrl(e) {
        return this._url(`/authorize?${$874ecb7cc9a437a2$var$v(e)}`);
    }
    async _verifyIdToken(e, t, i) {
        const o = await this.nowProvider();
        var n;
        return $874ecb7cc9a437a2$var$E({
            iss: this.tokenIssuer,
            aud: this.options.clientId,
            id_token: e,
            nonce: t,
            organization: i,
            leeway: this.options.leeway,
            max_age: (n = this.options.authorizationParams.max_age, "string" != typeof n ? n : parseInt(n, 10) || void 0),
            now: o
        });
    }
    _processOrgHint(e) {
        e ? this.cookieStorage.save(this.orgHintCookieName, e, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }) : this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        });
    }
    async _prepareAuthorizeUrl(e, t, i) {
        const o = $874ecb7cc9a437a2$var$k($874ecb7cc9a437a2$var$y()), n = $874ecb7cc9a437a2$var$k($874ecb7cc9a437a2$var$y()), a = $874ecb7cc9a437a2$var$y(), r = ((e)=>{
            const t = new Uint8Array(e);
            return ((e)=>{
                const t = {
                    "+": "-",
                    "/": "_",
                    "=": ""
                };
                return e.replace(/[+/=]/g, (e)=>t[e]);
            })(window.btoa(String.fromCharCode(...Array.from(t))));
        })(await (async (e)=>{
            const t = $874ecb7cc9a437a2$var$w().subtle.digest({
                name: "SHA-256"
            }, (new TextEncoder).encode(e));
            return await t;
        })(a)), s = ((e, t, i, o, n, a, r, s)=>Object.assign(Object.assign(Object.assign({
                client_id: e.clientId
            }, e.authorizationParams), i), {
                scope: $874ecb7cc9a437a2$var$j(t, i.scope),
                response_type: "code",
                response_mode: s || "query",
                state: o,
                nonce: n,
                redirect_uri: r || e.authorizationParams.redirect_uri,
                code_challenge: a,
                code_challenge_method: "S256"
            }))(this.options, this.scope, e, o, n, r, e.redirect_uri || this.options.authorizationParams.redirect_uri || i, null == t ? void 0 : t.response_mode), c = this._authorizeUrl(s);
        return {
            nonce: n,
            code_verifier: a,
            scope: s.scope,
            audience: s.audience || "default",
            redirect_uri: s.redirect_uri,
            state: o,
            url: c
        };
    }
    async loginWithPopup(e, t) {
        var i;
        if (e = e || {}, !(t = t || {}).popup && (t.popup = ((e)=>{
            const t = window.screenX + (window.innerWidth - 400) / 2, i = window.screenY + (window.innerHeight - 600) / 2;
            return window.open(e, "auth0:authorize:popup", `left=${t},top=${i},width=400,height=600,resizable,scrollbars=yes,status=1`);
        })(""), !t.popup)) throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
        const o = await this._prepareAuthorizeUrl(e.authorizationParams || {}, {
            response_mode: "web_message"
        }, window.location.origin);
        t.popup.location.href = o.url;
        const n = await ((e)=>new Promise((t, i)=>{
                let o;
                const n = setInterval(()=>{
                    e.popup && e.popup.closed && (clearInterval(n), clearTimeout(a), window.removeEventListener("message", o, !1), i(new $874ecb7cc9a437a2$export$f1f681f0fb26bb55(e.popup)));
                }, 1e3), a = setTimeout(()=>{
                    clearInterval(n), i(new $874ecb7cc9a437a2$export$ebbb83fe03f719a4(e.popup)), window.removeEventListener("message", o, !1);
                }, 1e3 * (e.timeoutInSeconds || 60));
                o = function(r) {
                    if (r.data && "authorization_response" === r.data.type) {
                        if (clearTimeout(a), clearInterval(n), window.removeEventListener("message", o, !1), e.popup.close(), r.data.response.error) return i($874ecb7cc9a437a2$export$7d465be8efa67280.fromPayload(r.data.response));
                        t(r.data.response);
                    }
                }, window.addEventListener("message", o);
            }))(Object.assign(Object.assign({}, t), {
            timeoutInSeconds: t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60
        }));
        if (o.state !== n.state) throw new $874ecb7cc9a437a2$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const a = (null === (i = e.authorizationParams) || void 0 === i ? void 0 : i.organization) || this.options.authorizationParams.organization;
        await this._requestToken({
            audience: o.audience,
            scope: o.scope,
            code_verifier: o.code_verifier,
            grant_type: "authorization_code",
            code: n.code,
            redirect_uri: o.redirect_uri
        }, {
            nonceIn: o.nonce,
            organization: a
        });
    }
    async getUser() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.user;
    }
    async getIdTokenClaims() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.claims;
    }
    async loginWithRedirect(t = {}) {
        var i;
        const o = $874ecb7cc9a437a2$var$Q(t), { openUrl: n, fragment: a, appState: r } = o, s = $874ecb7cc9a437a2$var$e(o, [
            "openUrl",
            "fragment",
            "appState"
        ]), c = (null === (i = s.authorizationParams) || void 0 === i ? void 0 : i.organization) || this.options.authorizationParams.organization, d = await this._prepareAuthorizeUrl(s.authorizationParams || {}), { url: u } = d, l = $874ecb7cc9a437a2$var$e(d, [
            "url"
        ]);
        this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, l), {
            appState: r
        }), c && {
            organization: c
        }));
        const h = a ? `${u}#${a}` : u;
        n ? await n(h) : window.location.assign(h);
    }
    async handleRedirectCallback(e = window.location.href) {
        const t = e.split("?").slice(1);
        if (0 === t.length) throw new Error("There are no query params available for parsing.");
        const { state: i, code: o, error: n, error_description: a } = ((e)=>{
            e.indexOf("#") > -1 && (e = e.substring(0, e.indexOf("#")));
            const t = new URLSearchParams(e);
            return {
                state: t.get("state"),
                code: t.get("code") || void 0,
                error: t.get("error") || void 0,
                error_description: t.get("error_description") || void 0
            };
        })(t.join("")), r = this.transactionManager.get();
        if (!r) throw new $874ecb7cc9a437a2$export$7d465be8efa67280("missing_transaction", "Invalid state");
        if (this.transactionManager.remove(), n) throw new $874ecb7cc9a437a2$export$cf0c46b07324e9c5(n, a || n, i, r.appState);
        if (!r.code_verifier || r.state && r.state !== i) throw new $874ecb7cc9a437a2$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const s = r.organization, c = r.nonce, l = r.redirect_uri;
        return await this._requestToken(Object.assign({
            audience: r.audience,
            scope: r.scope,
            code_verifier: r.code_verifier,
            grant_type: "authorization_code",
            code: o
        }, l ? {
            redirect_uri: l
        } : {}), {
            nonceIn: c,
            organization: s
        }), {
            appState: r.appState
        };
    }
    async checkSession(e) {
        if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
            if (!this.cookieStorage.get("auth0.is.authenticated")) return;
            this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
            }), this.cookieStorage.remove("auth0.is.authenticated");
        }
        try {
            await this.getTokenSilently(e);
        } catch (e) {}
    }
    async getTokenSilently(e = {}) {
        var t;
        const i = Object.assign(Object.assign({
            cacheMode: "on"
        }, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $874ecb7cc9a437a2$var$j(this.scope, null === (t = e.authorizationParams) || void 0 === t ? void 0 : t.scope)
            })
        }), o = await ((e, t)=>{
            let i = $874ecb7cc9a437a2$var$A[t];
            return i || (i = e().finally(()=>{
                delete $874ecb7cc9a437a2$var$A[t], i = null;
            }), $874ecb7cc9a437a2$var$A[t] = i), i;
        })(()=>this._getTokenSilently(i), `${this.options.clientId}::${i.authorizationParams.audience}::${i.authorizationParams.scope}`);
        return e.detailedResponse ? o : null == o ? void 0 : o.access_token;
    }
    async _getTokenSilently(t) {
        const { cacheMode: i } = t, o = $874ecb7cc9a437a2$var$e(t, [
            "cacheMode"
        ]);
        if ("off" !== i) {
            const e = await this._getEntryFromCache({
                scope: o.authorizationParams.scope,
                audience: o.authorizationParams.audience || "default",
                clientId: this.options.clientId
            });
            if (e) return e;
        }
        if ("cache-only" !== i) {
            if (!await (async (e, t = 3)=>{
                for(let i = 0; i < t; i++)if (await e()) return !0;
                return !1;
            })(()=>$874ecb7cc9a437a2$var$ee.acquireLock("auth0.lock.getTokenSilently", 5e3), 10)) throw new $874ecb7cc9a437a2$export$66d311bf29d5c89c;
            try {
                if (window.addEventListener("pagehide", this._releaseLockOnPageHide), "off" !== i) {
                    const e = await this._getEntryFromCache({
                        scope: o.authorizationParams.scope,
                        audience: o.authorizationParams.audience || "default",
                        clientId: this.options.clientId
                    });
                    if (e) return e;
                }
                const e = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(o) : await this._getTokenFromIFrame(o), { id_token: t, access_token: n, oauthTokenScope: a, expires_in: r } = e;
                return Object.assign(Object.assign({
                    id_token: t,
                    access_token: n
                }, a ? {
                    scope: a
                } : null), {
                    expires_in: r
                });
            } finally{
                await $874ecb7cc9a437a2$var$ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
            }
        }
    }
    async getTokenWithPopup(e = {}, t = {}) {
        var i;
        const o = Object.assign(Object.assign({}, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $874ecb7cc9a437a2$var$j(this.scope, null === (i = e.authorizationParams) || void 0 === i ? void 0 : i.scope)
            })
        });
        t = Object.assign(Object.assign({}, $874ecb7cc9a437a2$var$r), t), await this.loginWithPopup(o, t);
        return (await this.cacheManager.get(new $874ecb7cc9a437a2$var$C({
            scope: o.authorizationParams.scope,
            audience: o.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }))).access_token;
    }
    async isAuthenticated() {
        return !!await this.getUser();
    }
    _buildLogoutUrl(t) {
        null !== t.clientId ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
        const i = t.logoutParams || {}, { federated: o } = i, n = $874ecb7cc9a437a2$var$e(i, [
            "federated"
        ]), a = o ? "&federated" : "";
        return this._url(`/v2/logout?${$874ecb7cc9a437a2$var$v(Object.assign({
            clientId: t.clientId
        }, n))}`) + a;
    }
    async logout(t = {}) {
        const i = $874ecb7cc9a437a2$var$Q(t), { openUrl: o } = i, n = $874ecb7cc9a437a2$var$e(i, [
            "openUrl"
        ]);
        null === t.clientId ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.cookieStorage.remove(this.isAuthenticatedCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.userCache.remove("@@user@@");
        const a = this._buildLogoutUrl(n);
        o ? await o(a) : !1 !== o && window.location.assign(a);
    }
    async _getTokenFromIFrame(e) {
        const t = Object.assign(Object.assign({}, e.authorizationParams), {
            prompt: "none"
        }), i = this.cookieStorage.get(this.orgHintCookieName);
        i && !t.organization && (t.organization = i);
        const { url: o, state: n, nonce: a, code_verifier: r, redirect_uri: s, scope: c, audience: u } = await this._prepareAuthorizeUrl(t, {
            response_mode: "web_message"
        }, window.location.origin);
        try {
            if (window.crossOriginIsolated) throw new $874ecb7cc9a437a2$export$7d465be8efa67280("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
            const i = e.timeoutInSeconds || this.options.authorizeTimeoutInSeconds, h = await ((e, t, i = 60)=>new Promise((o, n)=>{
                    const a = window.document.createElement("iframe");
                    a.setAttribute("width", "0"), a.setAttribute("height", "0"), a.style.display = "none";
                    const r = ()=>{
                        window.document.body.contains(a) && (window.document.body.removeChild(a), window.removeEventListener("message", s, !1));
                    };
                    let s;
                    const c = setTimeout(()=>{
                        n(new $874ecb7cc9a437a2$export$66d311bf29d5c89c), r();
                    }, 1e3 * i);
                    s = function(e) {
                        if (e.origin != t) return;
                        if (!e.data || "authorization_response" !== e.data.type) return;
                        const i = e.source;
                        i && i.close(), e.data.response.error ? n($874ecb7cc9a437a2$export$7d465be8efa67280.fromPayload(e.data.response)) : o(e.data.response), clearTimeout(c), window.removeEventListener("message", s, !1), setTimeout(r, 2e3);
                    }, window.addEventListener("message", s, !1), window.document.body.appendChild(a), a.setAttribute("src", e);
                }))(o, this.domainUrl, i);
            if (n !== h.state) throw new $874ecb7cc9a437a2$export$7d465be8efa67280("state_mismatch", "Invalid state");
            const p = await this._requestToken(Object.assign(Object.assign({}, e.authorizationParams), {
                code_verifier: r,
                code: h.code,
                grant_type: "authorization_code",
                redirect_uri: s,
                timeout: e.authorizationParams.timeout || this.httpTimeoutMs
            }), {
                nonceIn: a,
                organization: t.organization
            });
            return Object.assign(Object.assign({}, p), {
                scope: c,
                oauthTokenScope: p.scope,
                audience: u
            });
        } catch (e) {
            throw "login_required" === e.error && this.logout({
                openUrl: !1
            }), e;
        }
    }
    async _getTokenUsingRefreshToken(e) {
        const t = await this.cacheManager.get(new $874ecb7cc9a437a2$var$C({
            scope: e.authorizationParams.scope,
            audience: e.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }));
        if (!(t && t.refresh_token || this.worker)) {
            if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw new $874ecb7cc9a437a2$export$ac1d2a00f8e0a046(e.authorizationParams.audience || "default", e.authorizationParams.scope);
        }
        const i = e.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, o = "number" == typeof e.timeoutInSeconds ? 1e3 * e.timeoutInSeconds : null;
        try {
            const n = await this._requestToken(Object.assign(Object.assign(Object.assign({}, e.authorizationParams), {
                grant_type: "refresh_token",
                refresh_token: t && t.refresh_token,
                redirect_uri: i
            }), o && {
                timeout: o
            }));
            return Object.assign(Object.assign({}, n), {
                scope: e.authorizationParams.scope,
                oauthTokenScope: n.scope,
                audience: e.authorizationParams.audience || "default"
            });
        } catch (t) {
            if ((t.message.indexOf("Missing Refresh Token") > -1 || t.message && t.message.indexOf("invalid refresh token") > -1) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw t;
        }
    }
    async _saveEntryInCache(t) {
        const { id_token: i, decodedToken: o } = t, n = $874ecb7cc9a437a2$var$e(t, [
            "id_token",
            "decodedToken"
        ]);
        this.userCache.set("@@user@@", {
            id_token: i,
            decodedToken: o
        }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(n);
    }
    async _getIdTokenFromCache() {
        const e = this.options.authorizationParams.audience || "default", t = await this.cacheManager.getIdToken(new $874ecb7cc9a437a2$var$C({
            clientId: this.options.clientId,
            audience: e,
            scope: this.scope
        })), i = this.userCache.get("@@user@@");
        return t && t.id_token === (null == i ? void 0 : i.id_token) ? i : (this.userCache.set("@@user@@", t), t);
    }
    async _getEntryFromCache({ scope: e, audience: t, clientId: i }) {
        const o = await this.cacheManager.get(new $874ecb7cc9a437a2$var$C({
            scope: e,
            audience: t,
            clientId: i
        }), 60);
        if (o && o.access_token) {
            const { access_token: e, oauthTokenScope: t, expires_in: i } = o, n = await this._getIdTokenFromCache();
            return n && Object.assign(Object.assign({
                id_token: n.id_token,
                access_token: e
            }, t ? {
                scope: t
            } : null), {
                expires_in: i
            });
        }
    }
    async _requestToken(e, t) {
        const { nonceIn: i, organization: o } = t || {}, n = await $874ecb7cc9a437a2$var$T(Object.assign({
            baseUrl: this.domainUrl,
            client_id: this.options.clientId,
            auth0Client: this.options.auth0Client,
            useFormData: this.options.useFormData,
            timeout: this.httpTimeoutMs
        }, e), this.worker), a = await this._verifyIdToken(n.id_token, i, o);
        return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, n), {
            decodedToken: a,
            scope: e.scope,
            audience: e.audience || "default"
        }), n.scope ? {
            oauthTokenScope: n.scope
        } : null), {
            client_id: this.options.clientId
        })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }), this._processOrgHint(o || a.claims.org_id), Object.assign(Object.assign({}, n), {
            decodedToken: a
        });
    }
}
class $874ecb7cc9a437a2$export$1f44aaf2ec115b54 {
}
/**
 * The initial auth state.
 */ var $874ecb7cc9a437a2$var$initialAuthState = {
    isAuthenticated: false,
    isLoading: true
};
/**
 * @ignore
 */ var $874ecb7cc9a437a2$var$stub = function() {
    throw new Error("You forgot to wrap your component in <Auth0Provider>.");
};
/**
 * @ignore
 */ var $874ecb7cc9a437a2$export$1b5d8f0c33515521 = $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, $874ecb7cc9a437a2$var$initialAuthState), {
    buildAuthorizeUrl: $874ecb7cc9a437a2$var$stub,
    buildLogoutUrl: $874ecb7cc9a437a2$var$stub,
    getAccessTokenSilently: $874ecb7cc9a437a2$var$stub,
    getAccessTokenWithPopup: $874ecb7cc9a437a2$var$stub,
    getIdTokenClaims: $874ecb7cc9a437a2$var$stub,
    loginWithRedirect: $874ecb7cc9a437a2$var$stub,
    loginWithPopup: $874ecb7cc9a437a2$var$stub,
    logout: $874ecb7cc9a437a2$var$stub,
    handleRedirectCallback: $874ecb7cc9a437a2$var$stub
});
/**
 * The Auth0 Context
 */ var $874ecb7cc9a437a2$export$419e9d660c2a6030 = (0, $acw62.createContext)($874ecb7cc9a437a2$export$1b5d8f0c33515521);
/**
 * An OAuth2 error will come from the authorization server and will have at least an `error` property which will
 * be the error code. And possibly an `error_description` property
 *
 * See: https://openid.net/specs/openid-connect-core-1_0.html#rfc.section.3.1.2.6
 */ var $874ecb7cc9a437a2$export$bdc0f363b754b88f = /** @class */ function(_super) {
    $874ecb7cc9a437a2$var$__extends(OAuthError, _super);
    function OAuthError(error, error_description) {
        var _this = _super.call(this, error_description || error) || this;
        _this.error = error;
        _this.error_description = error_description;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, OAuthError.prototype);
        return _this;
    }
    return OAuthError;
}(Error);
var $874ecb7cc9a437a2$var$CODE_RE = /[?&]code=[^&]+/;
var $874ecb7cc9a437a2$var$STATE_RE = /[?&]state=[^&]+/;
var $874ecb7cc9a437a2$var$ERROR_RE = /[?&]error=[^&]+/;
var $874ecb7cc9a437a2$var$hasAuthParams = function(searchParams) {
    if (searchParams === void 0) searchParams = window.location.search;
    return ($874ecb7cc9a437a2$var$CODE_RE.test(searchParams) || $874ecb7cc9a437a2$var$ERROR_RE.test(searchParams)) && $874ecb7cc9a437a2$var$STATE_RE.test(searchParams);
};
var $874ecb7cc9a437a2$var$normalizeErrorFn = function(fallbackMessage) {
    return function(error) {
        if (error instanceof Error) return error;
        // try to check errors of the following form: {error: string; error_description?: string}
        if (error !== null && typeof error === "object" && "error" in error && typeof error.error === "string") {
            if ("error_description" in error && typeof error.error_description === "string") return new $874ecb7cc9a437a2$export$bdc0f363b754b88f(error.error, error.error_description);
            return new $874ecb7cc9a437a2$export$bdc0f363b754b88f(error.error);
        }
        return new Error(fallbackMessage);
    };
};
var $874ecb7cc9a437a2$var$loginError = $874ecb7cc9a437a2$var$normalizeErrorFn("Login failed");
var $874ecb7cc9a437a2$var$tokenError = $874ecb7cc9a437a2$var$normalizeErrorFn("Get access token failed");
/**
 * @ignore
 * Helper function to map the v1 `redirectUri` option to the v2 `authorizationParams.redirect_uri`
 * and log a warning.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $874ecb7cc9a437a2$var$deprecateRedirectUri = function(options) {
    var _a;
    if (options === null || options === void 0 ? void 0 : options.redirectUri) {
        console.warn("Using `redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `redirectUri` will be no longer supported in a future version");
        options.authorizationParams = options.authorizationParams || {};
        options.authorizationParams.redirect_uri = options.redirectUri;
        delete options.redirectUri;
    }
    if ((_a = options === null || options === void 0 ? void 0 : options.authorizationParams) === null || _a === void 0 ? void 0 : _a.redirectUri) {
        console.warn("Using `authorizationParams.redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `authorizationParams.redirectUri` will be removed in a future version");
        options.authorizationParams.redirect_uri = options.authorizationParams.redirectUri;
        delete options.authorizationParams.redirectUri;
    }
};
/**
 * Handles how that state changes in the `useAuth0` hook.
 */ var $874ecb7cc9a437a2$var$reducer = function(state, action) {
    switch(action.type){
        case "LOGIN_POPUP_STARTED":
            return $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, state), {
                isLoading: true
            });
        case "LOGIN_POPUP_COMPLETE":
        case "INITIALISED":
            return $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user,
                isLoading: false,
                error: undefined
            });
        case "HANDLE_REDIRECT_COMPLETE":
        case "GET_ACCESS_TOKEN_COMPLETE":
            if (state.user === action.user) return state;
            return $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user
            });
        case "LOGOUT":
            return $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, state), {
                isAuthenticated: false,
                user: undefined
            });
        case "ERROR":
            return $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, state), {
                isLoading: false,
                error: action.error
            });
    }
};
/**
 * @ignore
 */ var $874ecb7cc9a437a2$var$toAuth0ClientOptions = function(opts) {
    $874ecb7cc9a437a2$var$deprecateRedirectUri(opts);
    return $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, opts), {
        auth0Client: {
            name: "auth0-react",
            version: "2.2.4"
        }
    });
};
/**
 * @ignore
 */ var $874ecb7cc9a437a2$var$defaultOnRedirectCallback = function(appState) {
    window.history.replaceState({}, document.title, (appState === null || appState === void 0 ? void 0 : appState.returnTo) || window.location.pathname);
};
/**
 * ```jsx
 * <Auth0Provider
 *   domain={domain}
 *   clientId={clientId}
 *   authorizationParams={{ redirect_uri: window.location.origin }}}>
 *   <MyApp />
 * </Auth0Provider>
 * ```
 *
 * Provides the Auth0Context to its child components.
 */ var $874ecb7cc9a437a2$export$6aefaad9cc4faf3c = function(opts) {
    var children = opts.children, skipRedirectCallback = opts.skipRedirectCallback, _a = opts.onRedirectCallback, onRedirectCallback = _a === void 0 ? $874ecb7cc9a437a2$var$defaultOnRedirectCallback : _a, _b = opts.context, context = _b === void 0 ? $874ecb7cc9a437a2$export$419e9d660c2a6030 : _b, clientOpts = $874ecb7cc9a437a2$var$__rest(opts, [
        "children",
        "skipRedirectCallback",
        "onRedirectCallback",
        "context"
    ]);
    var client = (0, $acw62.useState)(function() {
        return new $874ecb7cc9a437a2$var$te($874ecb7cc9a437a2$var$toAuth0ClientOptions(clientOpts));
    })[0];
    var _c = (0, $acw62.useReducer)($874ecb7cc9a437a2$var$reducer, $874ecb7cc9a437a2$var$initialAuthState), state = _c[0], dispatch = _c[1];
    var didInitialise = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(function() {
        if (didInitialise.current) return;
        didInitialise.current = true;
        (function() {
            return $874ecb7cc9a437a2$var$__awaiter(void 0, void 0, void 0, function() {
                var user, appState, error_1;
                return $874ecb7cc9a437a2$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                7,
                                ,
                                8
                            ]);
                            user = void 0;
                            if (!($874ecb7cc9a437a2$var$hasAuthParams() && !skipRedirectCallback)) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                client.handleRedirectCallback()
                            ];
                        case 1:
                            appState = _a.sent().appState;
                            return [
                                4 /*yield*/ ,
                                client.getUser()
                            ];
                        case 2:
                            user = _a.sent();
                            onRedirectCallback(appState, user);
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                client.checkSession()
                            ];
                        case 4:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                client.getUser()
                            ];
                        case 5:
                            user = _a.sent();
                            _a.label = 6;
                        case 6:
                            dispatch({
                                type: "INITIALISED",
                                user: user
                            });
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            error_1 = _a.sent();
                            dispatch({
                                type: "ERROR",
                                error: $874ecb7cc9a437a2$var$loginError(error_1)
                            });
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        })();
    }, [
        client,
        onRedirectCallback,
        skipRedirectCallback
    ]);
    var loginWithRedirect = (0, $acw62.useCallback)(function(opts) {
        $874ecb7cc9a437a2$var$deprecateRedirectUri(opts);
        return client.loginWithRedirect(opts);
    }, [
        client
    ]);
    var loginWithPopup = (0, $acw62.useCallback)(function(options, config) {
        return $874ecb7cc9a437a2$var$__awaiter(void 0, void 0, void 0, function() {
            var error_2, user;
            return $874ecb7cc9a437a2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dispatch({
                            type: "LOGIN_POPUP_STARTED"
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.loginWithPopup(options, config)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_2 = _a.sent();
                        dispatch({
                            type: "ERROR",
                            error: $874ecb7cc9a437a2$var$loginError(error_2)
                        });
                        return [
                            2 /*return*/ 
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 5:
                        user = _a.sent();
                        dispatch({
                            type: "LOGIN_POPUP_COMPLETE",
                            user: user
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var logout = (0, $acw62.useCallback)(function(opts) {
        if (opts === void 0) opts = {};
        return $874ecb7cc9a437a2$var$__awaiter(void 0, void 0, void 0, function() {
            return $874ecb7cc9a437a2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            client.logout(opts)
                        ];
                    case 1:
                        _a.sent();
                        if (opts.openUrl || opts.openUrl === false) dispatch({
                            type: "LOGOUT"
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenSilently = (0, $acw62.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(opts) {
        return $874ecb7cc9a437a2$var$__awaiter(void 0, void 0, void 0, function() {
            var token, error_3, _a;
            var _b;
            return $874ecb7cc9a437a2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenSilently(opts)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_3 = _c.sent();
                        throw $874ecb7cc9a437a2$var$tokenError(error_3);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: "GET_ACCESS_TOKEN_COMPLETE"
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenWithPopup = (0, $acw62.useCallback)(function(opts, config) {
        return $874ecb7cc9a437a2$var$__awaiter(void 0, void 0, void 0, function() {
            var token, error_4, _a;
            var _b;
            return $874ecb7cc9a437a2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenWithPopup(opts, config)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_4 = _c.sent();
                        throw $874ecb7cc9a437a2$var$tokenError(error_4);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: "GET_ACCESS_TOKEN_COMPLETE"
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getIdTokenClaims = (0, $acw62.useCallback)(function() {
        return client.getIdTokenClaims();
    }, [
        client
    ]);
    var handleRedirectCallback = (0, $acw62.useCallback)(function(url) {
        return $874ecb7cc9a437a2$var$__awaiter(void 0, void 0, void 0, function() {
            var error_5, _a;
            var _b;
            return $874ecb7cc9a437a2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.handleRedirectCallback(url)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                    case 2:
                        error_5 = _c.sent();
                        throw $874ecb7cc9a437a2$var$tokenError(error_5);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: "HANDLE_REDIRECT_COMPLETE"
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var contextValue = (0, $acw62.useMemo)(function() {
        return $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, state), {
            getAccessTokenSilently: getAccessTokenSilently,
            getAccessTokenWithPopup: getAccessTokenWithPopup,
            getIdTokenClaims: getIdTokenClaims,
            loginWithRedirect: loginWithRedirect,
            loginWithPopup: loginWithPopup,
            logout: logout,
            handleRedirectCallback: handleRedirectCallback
        });
    }, [
        state,
        getAccessTokenSilently,
        getAccessTokenWithPopup,
        getIdTokenClaims,
        loginWithRedirect,
        loginWithPopup,
        logout,
        handleRedirectCallback
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(context.Provider, {
        value: contextValue
    }, children);
};
/**
 * ```js
 * const {
 *   // Auth state:
 *   error,
 *   isAuthenticated,
 *   isLoading,
 *   user,
 *   // Auth methods:
 *   getAccessTokenSilently,
 *   getAccessTokenWithPopup,
 *   getIdTokenClaims,
 *   loginWithRedirect,
 *   loginWithPopup,
 *   logout,
 * } = useAuth0<TUser>();
 * ```
 *
 * Use the `useAuth0` hook in your components to access the auth state and methods.
 *
 * TUser is an optional type param to provide a type to the `user` field.
 */ var $874ecb7cc9a437a2$export$f2b63d3ca66bb884 = function(context) {
    if (context === void 0) context = $874ecb7cc9a437a2$export$419e9d660c2a6030;
    return (0, $acw62.useContext)(context);
};
/**
 * ```jsx
 * class MyComponent extends Component {
 *   render() {
 *     // Access the auth context from the `auth0` prop
 *     const { user } = this.props.auth0;
 *     return <div>Hello {user.name}!</div>
 *   }
 * }
 * // Wrap your class component in withAuth0
 * export default withAuth0(MyComponent);
 * ```
 *
 * Wrap your class components in this Higher Order Component to give them access to the Auth0Context.
 *
 * Providing a context as the second argument allows you to configure the Auth0Provider the Auth0Context
 * should come from f you have multiple within your application.
 */ var $874ecb7cc9a437a2$export$bf0b363fae22b33f = function(Component, context) {
    if (context === void 0) context = $874ecb7cc9a437a2$export$419e9d660c2a6030;
    return function WithAuth(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(context.Consumer, null, function(auth) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, $874ecb7cc9a437a2$var$__assign({}, props, {
                auth0: auth
            }));
        });
    };
};
/**
 * @ignore
 */ var $874ecb7cc9a437a2$var$defaultOnRedirecting = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
};
/**
* @ignore
*/ var $874ecb7cc9a437a2$var$defaultOnBeforeAuthentication = function() {
    return $874ecb7cc9a437a2$var$__awaiter(void 0, void 0, void 0, function() {
        return $874ecb7cc9a437a2$var$__generator(this, function(_a) {
            return [
                2 /*return*/ 
            ];
        });
    });
};
/**
 * @ignore
 */ var $874ecb7cc9a437a2$var$defaultReturnTo = function() {
    return "".concat(window.location.pathname).concat(window.location.search);
};
/**
 * ```js
 * const MyProtectedComponent = withAuthenticationRequired(MyComponent);
 * ```
 *
 * When you wrap your components in this Higher Order Component and an anonymous user visits your component
 * they will be redirected to the login page; after login they will be returned to the page they were redirected from.
 */ var $874ecb7cc9a437a2$export$2cfd0b285ff12c70 = function(Component, options) {
    if (options === void 0) options = {};
    return function WithAuthenticationRequired(props) {
        var _this = this;
        var _a = options.returnTo, returnTo = _a === void 0 ? $874ecb7cc9a437a2$var$defaultReturnTo : _a, _b = options.onRedirecting, onRedirecting = _b === void 0 ? $874ecb7cc9a437a2$var$defaultOnRedirecting : _b, _c = options.onBeforeAuthentication, onBeforeAuthentication = _c === void 0 ? $874ecb7cc9a437a2$var$defaultOnBeforeAuthentication : _c, loginOptions = options.loginOptions, _d = options.context, context = _d === void 0 ? $874ecb7cc9a437a2$export$419e9d660c2a6030 : _d;
        var _e = $874ecb7cc9a437a2$export$f2b63d3ca66bb884(context), isAuthenticated = _e.isAuthenticated, isLoading = _e.isLoading, loginWithRedirect = _e.loginWithRedirect;
        (0, $acw62.useEffect)(function() {
            if (isLoading || isAuthenticated) return;
            var opts = $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, loginOptions), {
                appState: $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, loginOptions && loginOptions.appState), {
                    returnTo: typeof returnTo === "function" ? returnTo() : returnTo
                })
            });
            (function() {
                return $874ecb7cc9a437a2$var$__awaiter(_this, void 0, void 0, function() {
                    return $874ecb7cc9a437a2$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    onBeforeAuthentication()
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    loginWithRedirect(opts)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
        }, [
            isLoading,
            isAuthenticated,
            loginWithRedirect,
            onBeforeAuthentication,
            loginOptions,
            returnTo
        ]);
        return isAuthenticated ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, $874ecb7cc9a437a2$var$__assign({}, props)) : onRedirecting();
    };
};

});

parcelRegister("2gHT7", function(module, exports) {

$parcel$export(module.exports, "getAccessToken", () => $4b77424ee1e81867$export$84773cc9bf7dbe87);
$parcel$export(module.exports, "getIdentitySessionQuery", () => $4b77424ee1e81867$export$5d131d6d434199e4);

var $8LEhm = parcelRequire("8LEhm");
parcelRequire("gjVi8");
var $2mq6B = parcelRequire("2mq6B");
parcelRequire("gCemA");
var $yrzTx = parcelRequire("yrzTx");
function $4b77424ee1e81867$export$84773cc9bf7dbe87(auth0Session) {
    return {
        queryKey: [
            "auth0/getAccessTokenSilently"
        ],
        queryFn: async ()=>{
            return await auth0Session.getAccessTokenSilently();
        }
    };
}
function $4b77424ee1e81867$export$5d131d6d434199e4(token) {
    return {
        queryKey: [
            "/session"
        ],
        queryFn: async ()=>{
            if (!token) throw new Error("No token");
            const api = await (0, $2mq6B.createApiClient)({
                token: token
            });
            try {
                const res = await api.get(`/identity/session`);
                if (!res.embedded?.user) return null;
                const { user: user } = res.embedded;
                return {
                    ...user,
                    isAdmin: user.userRole === (0, $8LEhm.UserRole).ADMIN,
                    isFund: user.userRole === (0, $8LEhm.UserRole).FUND,
                    isCompany: user.userRole === (0, $8LEhm.UserRole).COMPANY
                };
            } catch (e) {
                (0, $yrzTx.log).error("Error in getIdentitySessionQuery:", {
                    error: e
                });
                throw e;
            }
        }
    };
}

});
parcelRegister("8LEhm", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $9cd8c387eb08da7b$export$eb3485a690c2f0b8);
var $9cd8c387eb08da7b$export$eb3485a690c2f0b8;
(function(UserRole) {
    UserRole["ADMIN"] = "hum_admin";
    UserRole["COMPANY"] = "company_user";
    UserRole["COMPANY_ADMIN"] = "company_admin";
    UserRole["FUND"] = "fund_user";
    UserRole["FUND_ADMIN"] = "fund_admin";
})($9cd8c387eb08da7b$export$eb3485a690c2f0b8 || ($9cd8c387eb08da7b$export$eb3485a690c2f0b8 = {}));
var $9cd8c387eb08da7b$export$a82073022ded66e8;
(function(UserStatus) {
    UserStatus["INVITED"] = "invited";
    UserStatus["ACTIVE"] = "active";
    UserStatus["DISABLED"] = "disabled";
})($9cd8c387eb08da7b$export$a82073022ded66e8 || ($9cd8c387eb08da7b$export$a82073022ded66e8 = {}));

});


parcelRegister("43CNa", function(module, exports) {

$parcel$export(module.exports, "useToken", () => $d0be0a01887df6c5$export$31dcd79391e423fe);

var $bCeTl = parcelRequire("bCeTl");

var $2gHT7 = parcelRequire("2gHT7");

var $ba8s2 = parcelRequire("ba8s2");

var $bdmoM = parcelRequire("bdmoM");
function $d0be0a01887df6c5$export$31dcd79391e423fe() {
    const auth0Session = (0, $bCeTl.useAuth0)();
    const token = (0, $ba8s2.useQuery)({
        ...(0, $2gHT7.getAccessToken)(auth0Session),
        enabled: auth0Session.isAuthenticated && !!auth0Session.getAccessTokenSilently,
        refetchOnWindowFocus: true,
        staleTime: (0, $bdmoM.SESSION_STALE_TIME),
        gcTime: (0, $bdmoM.SESSION_GC_TIME)
    });
    // useActivityRefresh(async () => {
    //     await token.refetch();
    // });
    return token;
}

});
parcelRegister("bdmoM", function(module, exports) {

$parcel$export(module.exports, "SESSION_STALE_TIME", () => $d956d0c3528f982e$export$2ae5e02e51965865);
$parcel$export(module.exports, "SESSION_GC_TIME", () => $d956d0c3528f982e$export$4492461f29b223cd);
const $d956d0c3528f982e$export$2ae5e02e51965865 = 1740000;
const $d956d0c3528f982e$export$4492461f29b223cd = 43200000;

});




parcelRegister("3qMBE", function(module, exports) {

$parcel$export(module.exports, "asPage", () => $cb6a75ea03e385de$export$fd1badd6bfe627ce);

var $acw62 = parcelRequire("acw62");

var $7JXNE = parcelRequire("7JXNE");
function $cb6a75ea03e385de$export$fd1badd6bfe627ce(Page, config = {}) {
    return /*#__PURE__*/ (0, $acw62.memo)(function PageWithHOCs(props) {
        return (0, $7JXNE.withNavigation)(Page, config)({
            ...props,
            "data-testid": config.testId
        });
    });
}

});

parcelRegister("chdhE", function(module, exports) {
function $f55c8516e87e9701$export$632c201c2104e582(link) {
    console.log(link, "to" in link);
    return "to" in link;
}

});

parcelRegister("ltgJt", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $aphAM = parcelRequire("aphAM");
function $6316b9cd41df8058$export$35d5b245a0a6a4c1({ path: path, element: element, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Routes), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: path,
                element: element
            }),
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                    to: path
                })
            })
        ]
    });
}

});

parcelRegister("fuEBT", function(module, exports) {

$parcel$export(module.exports, "V1RedirectWithPath", () => $34efb1acf0b3619a$export$24a3e640a15321ce);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5R0Xk");
var $5Ttm9 = parcelRequire("5Ttm9");
parcelRequire("2bFYF");
var $fp4OM = parcelRequire("fp4OM");

var $acw62 = parcelRequire("acw62");
const $34efb1acf0b3619a$export$2e4407a7cff19423 = ({ to: to = "/" })=>{
    (0, $acw62.useEffect)(()=>{
        window.location.assign(`${"https://icm.humcapital.com/legacy"}${to}`);
    }, [
        to
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
        fullScreen: true
    });
};
const $34efb1acf0b3619a$export$24a3e640a15321ce = ()=>{
    const router = (0, $fp4OM.useRouter)();
    (0, $acw62.useEffect)(()=>{
        window.location.assign(`${"https://icm.humcapital.com/legacy"}${router.pathname}${window.location.search}`);
    }, [
        router.pathname
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
        fullScreen: true
    });
};

});


parcelRegister("4sYx8", function(module, exports) {

$parcel$export(module.exports, "mergeableAtom", () => $6550f6bb3dc1c936$export$b2ae22260dd1487a);

var $r2uF6 = parcelRequire("r2uF6");

var $f1q41 = parcelRequire("f1q41");
function $6550f6bb3dc1c936$export$8c5b449c4df2432f(key, initialValue = null) {
    const atomBase = (0, $r2uF6.atom)(localStorage.getItem(key) ?? initialValue);
    return (0, $r2uF6.atom)((get)=>get(atomBase), (get, set, newStr)=>{
        set(atomBase, newStr);
        localStorage.setItem(key, newStr);
    });
}
function $6550f6bb3dc1c936$export$b2ae22260dd1487a(baseAtom, parseFn) {
    return (0, $r2uF6.atom)((get)=>get(baseAtom), (get, set, update)=>{
        let nextUpdate = update;
        if (parseFn) nextUpdate = parseFn(update);
        set(baseAtom, (0, $f1q41.merge)({}, get(baseAtom), nextUpdate));
    });
}
function $6550f6bb3dc1c936$export$1f4c78b4ecf413a3(object = {}, keys) {
    return keys.every((key)=>{
        const value = (0, $f1q41.get)(object, key);
        return value !== undefined && value !== null && value !== "";
    });
}

});

parcelRegister("dUDTx", function(module, exports) {

$parcel$export(module.exports, "getLastNQuarters", () => $65e03d34de630e5d$export$789a1735add087cd);
$parcel$export(module.exports, "getLastNMonths", () => $65e03d34de630e5d$export$c22f498f9430bc01);
$parcel$export(module.exports, "getToday", () => $65e03d34de630e5d$export$883228a582a7567d);
const $65e03d34de630e5d$export$789a1735add087cd = (n)=>{
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentQuarter = Math.floor(currentDate.getMonth() / 3) + 1;
    const quarters = [];
    let year = currentYear;
    let quarter = currentQuarter;
    for(let i = 0; i < n; i++){
        quarters.unshift([
            year.toString(),
            `Q${quarter}`
        ]);
        quarter--;
        if (quarter === 0) {
            quarter = 4;
            year--;
        }
    }
    return quarters;
};
const $65e03d34de630e5d$var$monthAbbreviations = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $65e03d34de630e5d$export$c22f498f9430bc01 = (n)=>{
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    let month = currentDate.getMonth() - 1;
    let year = currentYear;
    if (month === -1) {
        month = 11;
        year--;
    }
    const months = [];
    for(let i = 0; i < n; i++){
        months.unshift([
            year.toString(),
            $65e03d34de630e5d$var$monthAbbreviations[month]
        ]);
        month--;
        if (month === -1) {
            month = 11;
            year--;
        }
    }
    return months;
};
const $65e03d34de630e5d$var$formatDate = (date)=>{
    const options = {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true
    };
    return date.toLocaleString("en-US", options);
};
const $65e03d34de630e5d$export$e7b72760378c0d3b = ()=>{
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    return $65e03d34de630e5d$var$formatDate(yesterday);
};
const $65e03d34de630e5d$export$883228a582a7567d = ()=>{
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return $65e03d34de630e5d$var$formatDate(today);
};
const $65e03d34de630e5d$var$currentDate = new Date();
const $65e03d34de630e5d$var$monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "September",
    "October",
    "November",
    "December"
];
const $65e03d34de630e5d$export$4bf68489d4ce7543 = ()=>$65e03d34de630e5d$var$monthNames[$65e03d34de630e5d$var$currentDate.getMonth()];

});



parcelRegister("5V56o", function(module, exports) {

$parcel$export(module.exports, "httpClient", () => $656053e44e556fd2$export$64d1f38a5d384966);
/**
 * HTTP client factory.
 */ parcelRequire("fmRoT");
var $7we3r = parcelRequire("7we3r");
const $656053e44e556fd2$var$create = (0, $7we3r.default).create.bind((0, $7we3r.default));
const $656053e44e556fd2$export$64d1f38a5d384966 = (0, $7we3r.default);
/**
 * Override axios.create method to extend instances.
 */ $656053e44e556fd2$export$64d1f38a5d384966.create = (config)=>{
    const instance = $656053e44e556fd2$var$create(config);
    /**
     * Extend axios instance with capability of creating derived instances.
     */ instance.create = function(instanceConfig) {
        const newInstance = $656053e44e556fd2$export$64d1f38a5d384966.create();
        newInstance.defaults = {
            ...newInstance.defaults,
            ...instanceConfig
        };
        // copy over current interceptors
        for (const hook of [
            "request",
            "response"
        ])this.interceptors[hook].forEach(({ fulfilled: fulfilled, rejected: rejected })=>{
            newInstance.interceptors[hook].use(fulfilled, rejected);
        });
        return newInstance;
    };
    return instance;
};

});
parcelRegister("fmRoT", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("7we3r")).default);

var $7we3r = parcelRequire("7we3r");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $7we3r.default);

});
parcelRegister("7we3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $57966c7e0affc4cb$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $blSvA = parcelRequire("blSvA");

var $8cmY2 = parcelRequire("8cmY2");

var $dIGMp = parcelRequire("dIGMp");

var $lAKPy = parcelRequire("lAKPy");

var $7L4QX = parcelRequire("7L4QX");

var $35BUy = parcelRequire("35BUy");

var $jOwpo = parcelRequire("jOwpo");

var $6HVMZ = parcelRequire("6HVMZ");

var $JEeti = parcelRequire("JEeti");

var $dxy9O = parcelRequire("dxy9O");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");

var $lnWCo = parcelRequire("lnWCo");
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $ewFRw.default)(defaultConfig);
    const instance = (0, $jJbMR.default)((0, $ewFRw.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $gKvUL.default).extend(instance, (0, $ewFRw.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $gKvUL.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $lk5EI.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $blSvA.default));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $ewFRw.default);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $dIGMp.default);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $lAKPy.default);
$57966c7e0affc4cb$var$axios.isCancel = (0, $7L4QX.default);
$57966c7e0affc4cb$var$axios.VERSION = (0, $35BUy.VERSION);
$57966c7e0affc4cb$var$axios.toFormData = (0, $jOwpo.default);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $6HVMZ.default);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $JEeti.default);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $dxy9O.default);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $lk5EI.default);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $bxxyx.default);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $8cmY2.default)((0, $gKvUL.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $jZ6wW.default).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $lnWCo.default);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c319b2c832c2914a$export$2e2bcd8739ae039);

var $jJbMR = parcelRequire("jJbMR");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== "object") return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $jJbMR.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest("HTMLFormElement");
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest("RegExp");
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $c319b2c832c2914a$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $c319b2c832c2914a$var$DIGIT = "0123456789";
const $c319b2c832c2914a$var$ALPHABET = {
    DIGIT: $c319b2c832c2914a$var$DIGIT,
    ALPHA: $c319b2c832c2914a$var$ALPHA,
    ALPHA_DIGIT: $c319b2c832c2914a$var$ALPHA + $c319b2c832c2914a$var$ALPHA.toUpperCase() + $c319b2c832c2914a$var$DIGIT
};
const $c319b2c832c2914a$var$generateString = (size = 16, alphabet = $c319b2c832c2914a$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest("AsyncFunction");
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    ALPHABET: $c319b2c832c2914a$var$ALPHABET,
    generateString: $c319b2c832c2914a$var$generateString,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable
};

});
parcelRegister("jJbMR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5cb5cefd6507f7e$export$2e2bcd8739ae039);
"use strict";
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("ewFRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93486d2307f31c3$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $7GD7a = parcelRequire("7GD7a");

var $bv3QM = parcelRequire("bv3QM");

var $bxxyx = parcelRequire("bxxyx");
"use strict";
const $a93486d2307f31c3$var$validators = (0, $bv3QM.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $83RYu.default)(),
            response: new (0, $83RYu.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $lk5EI.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $bv3QM.default).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $gKvUL.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $bv3QM.default).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $gKvUL.default).merge(headers.common, headers[config.method]);
        headers && (0, $gKvUL.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $bxxyx.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $dlZEJ.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $dlZEJ.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $lk5EI.default)(this.defaults, config);
        const fullPath = (0, $7GD7a.default)(config.baseURL, config.url);
        return (0, $cbIsf.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $gKvUL.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $lk5EI.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $gKvUL.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $lk5EI.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df8fedf1c1e4428$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $l9LQd = parcelRequire("l9LQd");
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $gKvUL.default).isURLSearchParams(params) ? params.toString() : new (0, $l9LQd.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

});
parcelRegister("l9LQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f66f8c7b4f247caf$export$2e2bcd8739ae039);

var $jOwpo = parcelRequire("jOwpo");
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $jOwpo.default)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;

});
parcelRegister("jOwpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6cbd383b18c9625$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $5vpyF = parcelRequire("5vpyF");

var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $gKvUL.default).isPlainObject(thing) || (0, $gKvUL.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $gKvUL.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $gKvUL.default).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $gKvUL.default).toFlatObject((0, $gKvUL.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $5vpyF.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $gKvUL.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $gKvUL.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $gKvUL.default).isSpecCompliantForm(formData);
    if (!(0, $gKvUL.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $gKvUL.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $gKvUL.default).isBlob(value)) throw new (0, $6HVMZ.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, $gKvUL.default).isArrayBuffer(value) || (0, $gKvUL.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $gKvUL.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $gKvUL.default).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $gKvUL.default).isFileList(value) || (0, $gKvUL.default).endsWith(key, "[]")) && (arr = (0, $gKvUL.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $gKvUL.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $gKvUL.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $gKvUL.default).forEach(value, function each(el, key) {
            const result = !((0, $gKvUL.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $gKvUL.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;

});
parcelRegister("6HVMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2395edb77acf3a$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $gKvUL.default).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $gKvUL.default).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $gKvUL.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;

});

parcelRegister("5vpyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4023ac50ad132196$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("83RYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de878cd737ef277$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
"use strict";
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $gKvUL.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8d10189805ccc0$export$2e2bcd8739ae039);

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $blSvA = parcelRequire("blSvA");

var $dIGMp = parcelRequire("dIGMp");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $dIGMp.default)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $bxxyx.default).from(config.headers);
    // Transform request data
    config.data = (0, $7YJ0v.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $jZ6wW.default).getAdapter(config.adapter || (0, $blSvA.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $7YJ0v.default).call(config, config.transformResponse, response);
        response.headers = (0, $bxxyx.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7L4QX.default)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $7YJ0v.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $bxxyx.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("7YJ0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf10c777cce5f4f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $blSvA = parcelRequire("blSvA");

var $bxxyx = parcelRequire("bxxyx");
"use strict";
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $blSvA.default);
    const context = response || config;
    const headers = (0, $bxxyx.default).from(context.headers);
    let data = context.data;
    (0, $gKvUL.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("blSvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $843bf0209bc94df8$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $6YCMk = parcelRequire("6YCMk");

var $jOwpo = parcelRequire("jOwpo");

var $lcuqa = parcelRequire("lcuqa");

var $g65xr = parcelRequire("g65xr");

var $8cmY2 = parcelRequire("8cmY2");
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $gKvUL.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $gKvUL.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $6YCMk.default),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $gKvUL.default).isObject(data);
            if (isObjectPayload && (0, $gKvUL.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $gKvUL.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $8cmY2.default)(data)) : data;
            if ((0, $gKvUL.default).isArrayBuffer(data) || (0, $gKvUL.default).isBuffer(data) || (0, $gKvUL.default).isStream(data) || (0, $gKvUL.default).isFile(data) || (0, $gKvUL.default).isBlob(data)) return data;
            if ((0, $gKvUL.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $gKvUL.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $lcuqa.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $gKvUL.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $jOwpo.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $gKvUL.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $6HVMZ.default).from(e, (0, $6HVMZ.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $g65xr.default).classes.FormData,
        Blob: (0, $g65xr.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $gKvUL.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;

});
parcelRegister("6YCMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $51466d41a76e5b4b$export$2e2bcd8739ae039);
"use strict";
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("lcuqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f250f62cadb740$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jOwpo = parcelRequire("jOwpo");

var $g65xr = parcelRequire("g65xr");
"use strict";
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $jOwpo.default)(data, new (0, $g65xr.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $g65xr.default).isNode && (0, $gKvUL.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("g65xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb8180acb278e187$export$2e2bcd8739ae039);

var $44xkq = parcelRequire("44xkq");

var $7pJXT = parcelRequire("7pJXT");
var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$7pJXT,
    ...(0, $44xkq.default)
};

});
parcelRegister("44xkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f71637df772b183$export$2e2bcd8739ae039);

var $9ww2p = parcelRequire("9ww2p");

var $bzEBu = parcelRequire("bzEBu");

var $7HTwA = parcelRequire("7HTwA");
var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9ww2p.default,
        FormData: $bzEBu.default,
        Blob: $7HTwA.default
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

});
parcelRegister("9ww2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eeff4490c995137$export$2e2bcd8739ae039);

var $l9LQd = parcelRequire("l9LQd");
"use strict";
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $l9LQd.default);

});

parcelRegister("bzEBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d275a264afb13f$export$2e2bcd8739ae039);
"use strict";
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;

});

parcelRegister("7HTwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c79e94740631e4$export$2e2bcd8739ae039);
"use strict";
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;

});


parcelRegister("7pJXT", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = ((product)=>{
    return $565e85ead8bde60a$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();

});



parcelRegister("8cmY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8142930b3b943f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $gKvUL.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $gKvUL.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $gKvUL.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $gKvUL.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $gKvUL.default).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $gKvUL.default).isFormData(formData) && (0, $gKvUL.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $gKvUL.default).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;

});


parcelRegister("bxxyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $866cce54f6bdfb0c$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $lDriZ = parcelRequire("lDriZ");
"use strict";
const $866cce54f6bdfb0c$var$$internals = Symbol("internals");
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $gKvUL.default).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $gKvUL.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $gKvUL.default).isString(value)) return;
    if ((0, $gKvUL.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $gKvUL.default).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $gKvUL.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $gKvUL.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $gKvUL.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $gKvUL.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $gKvUL.default).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $lDriZ.default)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $gKvUL.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $gKvUL.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $gKvUL.default).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $gKvUL.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            const key = (0, $gKvUL.default).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $gKvUL.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $gKvUL.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $gKvUL.default).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $gKvUL.default).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;

});
parcelRegister("lDriZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc026bbf9ee156f1$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $gKvUL.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

});



parcelRegister("7L4QX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a60afef8b0dd173$export$2e2bcd8739ae039);
"use strict";
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("dIGMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd0919e266b4fda$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");

var $gKvUL = parcelRequire("gKvUL");
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $6HVMZ.default).call(this, message == null ? "canceled" : message, (0, $6HVMZ.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $gKvUL.default).inherits($9fd0919e266b4fda$var$CanceledError, (0, $6HVMZ.default), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;

});

parcelRegister("jZ6wW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c8c7960873e9ee$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $5vpyF = parcelRequire("5vpyF");

var $at5cb = parcelRequire("at5cb");

var $6HVMZ = parcelRequire("6HVMZ");
const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $5vpyF.default),
    xhr: (0, $at5cb.default)
};
(0, $gKvUL.default).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $gKvUL.default).isFunction(adapter) || adapter === null || adapter === false;
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $gKvUL.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $6HVMZ.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($e8c8c7960873e9ee$var$renderReason).join("\n") : " " + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $6HVMZ.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};

});
parcelRegister("at5cb", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f0a48d5eb7919b$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $8JRzs = parcelRequire("8JRzs");

var $cbIsf = parcelRequire("cbIsf");

var $7GD7a = parcelRequire("7GD7a");

var $889er = parcelRequire("889er");

var $6YCMk = parcelRequire("6YCMk");

var $6HVMZ = parcelRequire("6HVMZ");

var $dIGMp = parcelRequire("dIGMp");

var $32jg5 = parcelRequire("32jg5");

var $g65xr = parcelRequire("g65xr");

var $bxxyx = parcelRequire("bxxyx");

var $6paAk = parcelRequire("6paAk");
"use strict";
function $79f0a48d5eb7919b$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $6paAk.default)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $bxxyx.default).from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $gKvUL.default).isFormData(requestData)) {
            if ((0, $g65xr.default).hasStandardBrowserEnv || (0, $g65xr.default).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $7GD7a.default)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $cbIsf.default)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $bxxyx.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $kk0E9.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $6HVMZ.default)("Request aborted", (0, $6HVMZ.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $6HVMZ.default)("Network Error", (0, $6HVMZ.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $6YCMk.default);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $6HVMZ.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $6HVMZ.default).ETIMEDOUT : (0, $6HVMZ.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $g65xr.default).hasStandardBrowserEnv) {
            withXSRFToken && (0, $gKvUL.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, $889er.default)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, $8JRzs.default).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $gKvUL.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $gKvUL.default).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $79f0a48d5eb7919b$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $79f0a48d5eb7919b$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $dIGMp.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $32jg5.default)(fullPath);
        if (protocol && (0, $g65xr.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $6HVMZ.default)("Unsupported protocol " + protocol + ":", (0, $6HVMZ.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb62d5372993dcf$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
"use strict";
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $6HVMZ.default)("Request failed with status code " + response.status, [
        (0, $6HVMZ.default).ERR_BAD_REQUEST,
        (0, $6HVMZ.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("8JRzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $65cc14c0704b5541$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $g65xr = parcelRequire("g65xr");
var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $gKvUL.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $gKvUL.default).isString(path) && cookie.push("path=" + path);
        (0, $gKvUL.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("7GD7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $598acbfafd2c63c5$export$2e2bcd8739ae039);

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
"use strict";
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $ckHwb.default)(requestedURL)) return (0, $fE4ul.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("ckHwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa91c1a59edb5d9$export$2e2bcd8739ae039);
"use strict";
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("fE4ul", function(module, exports) {

$parcel$export(module.exports, "default", () => $b63e12c1e0b9e0be$export$2e2bcd8739ae039);
"use strict";
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

});


parcelRegister("889er", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb63b558e1fb85a$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $g65xr = parcelRequire("g65xr");
"use strict";
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $gKvUL.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("32jg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $23607f53e4fda918$export$2e2bcd8739ae039);
"use strict";
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

});

parcelRegister("6paAk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a9d49cd0e6b8acc$export$2e2bcd8739ae039);
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;

});




parcelRegister("lk5EI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f85fda54cd977b19$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $bxxyx = parcelRequire("bxxyx");
"use strict";
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $bxxyx.default) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $gKvUL.default).isPlainObject(target) && (0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge({}, source);
        else if ((0, $gKvUL.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), true)
    };
    (0, $gKvUL.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $gKvUL.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});

parcelRegister("bv3QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f59389941e7907$export$2e2bcd8739ae039);

var $35BUy = parcelRequire("35BUy");

var $6HVMZ = parcelRequire("6HVMZ");
"use strict";
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $35BUy.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $6HVMZ.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $6HVMZ.default).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $6HVMZ.default)("options must be an object", (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $6HVMZ.default)("option " + opt + " must be " + result, (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $6HVMZ.default)("Unknown option " + opt, (0, $6HVMZ.default).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});
parcelRegister("35BUy", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $23ff3f1a5c7912d5$export$a4ad2735b021c132);
const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.6.8";

});



parcelRegister("lAKPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb81495929d8a282$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $dIGMp.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {

$parcel$export(module.exports, "default", () => $089369673aa7c1c3$export$2e2bcd8739ae039);
"use strict";
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("dxy9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db8da59db12cd94$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
"use strict";
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $gKvUL.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("lnWCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f919374d785e9fb8$export$2e2bcd8739ae039);
const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;

});




parcelRegister("7zRAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6187557c9046a49$export$2e2bcd8739ae039);
const $e6187557c9046a49$var$stripSensitiveData = (data, sensitiveFields)=>{
    if (!data || typeof data !== "object") return data;
    if (Array.isArray(data)) return data.map((item)=>$e6187557c9046a49$var$stripSensitiveData(item, sensitiveFields));
    const stripped = {
        ...data
    };
    for (const [key, value] of Object.entries(stripped)){
        if (sensitiveFields.some((field)=>key.toLowerCase() === field.toLowerCase())) delete stripped[key];
        else if (typeof value === "object" && value !== null) stripped[key] = $e6187557c9046a49$var$stripSensitiveData(value, sensitiveFields);
    }
    return stripped;
};
var $e6187557c9046a49$export$2e2bcd8739ae039 = $e6187557c9046a49$var$stripSensitiveData;

});



parcelRegister("4gN4F", function(module, exports) {

$parcel$export(module.exports, "getCacheKey", () => $9a0f78e24fe694d7$export$611736262b635f8d);
parcelRequire("gjVi8");
var $2mq6B = parcelRequire("2mq6B");
class $9a0f78e24fe694d7$var$MockAbort extends Error {
}
const $9a0f78e24fe694d7$var$nullObject = new Proxy({}, {
    get: (_, prop)=>{
        if (prop === "then") return ()=>{
            throw new $9a0f78e24fe694d7$var$MockAbort();
        };
        return $9a0f78e24fe694d7$var$nullObject;
    },
    apply: ()=>$9a0f78e24fe694d7$var$nullObject
});
function $9a0f78e24fe694d7$export$611736262b635f8d(queryFn, context, scope) {
    const key = scope ? [
        scope
    ] : [];
    const urlCapture = (url)=>{
        if (url) key.push(url);
        return $9a0f78e24fe694d7$var$nullObject;
    };
    const apiCapture = {
        ...(0, $2mq6B.createApiClient)(),
        get: urlCapture,
        post: urlCapture,
        put: urlCapture,
        delete: urlCapture,
        patch: urlCapture,
        isMock: true
    };
    const safeContext = {
        ...context,
        api: apiCapture
    };
    try {
        queryFn(safeContext)?.catch?.(()=>{});
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return key.length > 0 ? key : [
        "no-cache-key"
    ];
}

});

parcelRegister("gBHSi", function(module, exports) {

$parcel$export(module.exports, "createMutation", () => $005ee84160754e85$export$38a96a0d77fbb690);
function $005ee84160754e85$export$38a96a0d77fbb690(mutationFn, options = {}) {
    return {
        ...{
            ...options,
            waitForSession: options.waitForSession === undefined ? true : options.waitForSession
        },
        mutationFn: mutationFn
    };
}

});

parcelRegister("eX6Sv", function(module, exports) {

$parcel$export(module.exports, "queryClient", () => $1737f126bf51b013$export$7c07b633a151f9c5);

var $gNGGN = parcelRequire("gNGGN");
var $ldknz = parcelRequire("ldknz");
parcelRequire("18L7n");
var $3oOMC = parcelRequire("3oOMC");
const $1737f126bf51b013$export$c5e2bf3fcac7b35e = new (0, $gNGGN.QueryCache)({
    onError: (data, q)=>{
        const options = q.options;
        if (options.toastsEnabled && options.errorToast) {
            const { errorToast: errorToast } = options;
            (0, $3oOMC.toast).error(errorToast.message, errorToast.options);
        }
    },
    onSuccess: (data, q)=>{
        const options = q.options;
        if (options.toastsEnabled && options.successToast) {
            const { successToast: successToast } = options;
            (0, $3oOMC.toast).success(successToast.message, successToast.options);
        }
    }
});
const $1737f126bf51b013$export$7c07b633a151f9c5 = new (0, $ldknz.QueryClient)({
    queryCache: $1737f126bf51b013$export$c5e2bf3fcac7b35e
});

});
parcelRegister("gNGGN", function(module, exports) {

$parcel$export(module.exports, "QueryCache", () => $c3b25629722ddda6$export$5dde0cd941da8468);

var $4sZyw = parcelRequire("4sZyw");

var $0GZvz = parcelRequire("0GZvz");

var $dxPKP = parcelRequire("dxPKP");

var $aqN4U = parcelRequire("aqN4U");

var $64BU0 = parcelRequire("64BU0");
var $c3b25629722ddda6$var$_queries;
var $c3b25629722ddda6$export$5dde0cd941da8468 = class extends (0, $64BU0.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $4sZyw.__privateAdd)(this, $c3b25629722ddda6$var$_queries, void 0);
        (0, $4sZyw.__privateSet)(this, $c3b25629722ddda6$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $0GZvz.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $dxPKP.Query)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $4sZyw.__privateGet)(this, $c3b25629722ddda6$var$_queries).has(query.queryHash)) {
            (0, $4sZyw.__privateGet)(this, $c3b25629722ddda6$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $4sZyw.__privateGet)(this, $c3b25629722ddda6$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $4sZyw.__privateGet)(this, $c3b25629722ddda6$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $aqN4U.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $4sZyw.__privateGet)(this, $c3b25629722ddda6$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $4sZyw.__privateGet)(this, $c3b25629722ddda6$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $0GZvz.matchQuery)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $0GZvz.matchQuery)(filters, query)) : queries;
    }
    notify(event) {
        (0, $aqN4U.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $aqN4U.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $aqN4U.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$c3b25629722ddda6$var$_queries = new WeakMap();

});

parcelRegister("ldknz", function(module, exports) {

$parcel$export(module.exports, "QueryClient", () => $f71a9ec256bb1e8c$export$405d0624ed55a03f);

var $4sZyw = parcelRequire("4sZyw");

var $0GZvz = parcelRequire("0GZvz");

var $gNGGN = parcelRequire("gNGGN");

var $lxIrq = parcelRequire("lxIrq");

var $2uOjt = parcelRequire("2uOjt");

var $cSAic = parcelRequire("cSAic");

var $aqN4U = parcelRequire("aqN4U");

var $5YK1w = parcelRequire("5YK1w");
var $f71a9ec256bb1e8c$var$_queryCache, $f71a9ec256bb1e8c$var$_mutationCache, $f71a9ec256bb1e8c$var$_defaultOptions, $f71a9ec256bb1e8c$var$_queryDefaults, $f71a9ec256bb1e8c$var$_mutationDefaults, $f71a9ec256bb1e8c$var$_mountCount, $f71a9ec256bb1e8c$var$_unsubscribeFocus, $f71a9ec256bb1e8c$var$_unsubscribeOnline;
var $f71a9ec256bb1e8c$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $4sZyw.__privateAdd)(this, $f71a9ec256bb1e8c$var$_queryCache, void 0);
        (0, $4sZyw.__privateAdd)(this, $f71a9ec256bb1e8c$var$_mutationCache, void 0);
        (0, $4sZyw.__privateAdd)(this, $f71a9ec256bb1e8c$var$_defaultOptions, void 0);
        (0, $4sZyw.__privateAdd)(this, $f71a9ec256bb1e8c$var$_queryDefaults, void 0);
        (0, $4sZyw.__privateAdd)(this, $f71a9ec256bb1e8c$var$_mutationDefaults, void 0);
        (0, $4sZyw.__privateAdd)(this, $f71a9ec256bb1e8c$var$_mountCount, void 0);
        (0, $4sZyw.__privateAdd)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus, void 0);
        (0, $4sZyw.__privateAdd)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline, void 0);
        (0, $4sZyw.__privateSet)(this, $f71a9ec256bb1e8c$var$_queryCache, config.queryCache || new (0, $gNGGN.QueryCache)());
        (0, $4sZyw.__privateSet)(this, $f71a9ec256bb1e8c$var$_mutationCache, config.mutationCache || new (0, $lxIrq.MutationCache)());
        (0, $4sZyw.__privateSet)(this, $f71a9ec256bb1e8c$var$_defaultOptions, config.defaultOptions || {});
        (0, $4sZyw.__privateSet)(this, $f71a9ec256bb1e8c$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $4sZyw.__privateSet)(this, $f71a9ec256bb1e8c$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $4sZyw.__privateSet)(this, $f71a9ec256bb1e8c$var$_mountCount, 0);
    }
    mount() {
        (0, $4sZyw.__privateWrapper)(this, $f71a9ec256bb1e8c$var$_mountCount)._++;
        if ((0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_mountCount) !== 1) return;
        (0, $4sZyw.__privateSet)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus, (0, $2uOjt.focusManager).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache).onFocus();
            }
        }));
        (0, $4sZyw.__privateSet)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline, (0, $cSAic.onlineManager).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $4sZyw.__privateWrapper)(this, $f71a9ec256bb1e8c$var$_mountCount)._--;
        if ((0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_mountCount) !== 0) return;
        (_a = (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $4sZyw.__privateSet)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus, void 0);
        (_b = (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $4sZyw.__privateSet)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const cachedData = this.getQueryData(options.queryKey);
        if (cachedData === void 0) return this.fetchQuery(options);
        else {
            const defaultedOptions = this.defaultQueryOptions(options);
            const query = (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache).build(this, defaultedOptions);
            if (options.revalidateIfStale && query.isStaleByTime(defaultedOptions.staleTime)) this.prefetchQuery(defaultedOptions);
            return Promise.resolve(cachedData);
        }
    }
    getQueriesData(filters) {
        return (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $0GZvz.functionalUpdate)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $aqN4U.notifyManager).batch(()=>(0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache);
        (0, $aqN4U.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache);
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $aqN4U.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters = {}, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $aqN4U.notifyManager).batch(()=>(0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $0GZvz.noop)).catch((0, $0GZvz.noop));
    }
    invalidateQueries(filters = {}, options = {}) {
        return (0, $aqN4U.notifyManager).batch(()=>{
            (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: filters.refetchType ?? filters.type ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters = {}, options) {
        const fetchOptions = {
            ...options,
            cancelRefetch: (options == null ? void 0 : options.cancelRefetch) ?? true
        };
        const promises = (0, $aqN4U.notifyManager).batch(()=>(0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $0GZvz.noop));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $0GZvz.noop));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $0GZvz.noop)).catch((0, $0GZvz.noop));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $5YK1w.infiniteQueryBehavior)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $0GZvz.noop)).catch((0, $0GZvz.noop));
    }
    resumePausedMutations() {
        if ((0, $cSAic.onlineManager).isOnline()) return (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache);
    }
    getMutationCache() {
        return (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $4sZyw.__privateSet)(this, $f71a9ec256bb1e8c$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryDefaults).set((0, $0GZvz.hashKey)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $0GZvz.partialMatchKey)(queryKey, queryDefault.queryKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_mutationDefaults).set((0, $0GZvz.hashKey)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_mutationDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $0GZvz.partialMatchKey)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $0GZvz.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.enabled !== true && defaultedOptions.queryFn === (0, $0GZvz.skipToken)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_queryCache).clear();
        (0, $4sZyw.__privateGet)(this, $f71a9ec256bb1e8c$var$_mutationCache).clear();
    }
};
$f71a9ec256bb1e8c$var$_queryCache = new WeakMap();
$f71a9ec256bb1e8c$var$_mutationCache = new WeakMap();
$f71a9ec256bb1e8c$var$_defaultOptions = new WeakMap();
$f71a9ec256bb1e8c$var$_queryDefaults = new WeakMap();
$f71a9ec256bb1e8c$var$_mutationDefaults = new WeakMap();
$f71a9ec256bb1e8c$var$_mountCount = new WeakMap();
$f71a9ec256bb1e8c$var$_unsubscribeFocus = new WeakMap();
$f71a9ec256bb1e8c$var$_unsubscribeOnline = new WeakMap();

});
parcelRegister("lxIrq", function(module, exports) {

$parcel$export(module.exports, "MutationCache", () => $faef27284cfa645e$export$1fcfd9a244434844);

var $4sZyw = parcelRequire("4sZyw");

var $aqN4U = parcelRequire("aqN4U");

var $cXt7v = parcelRequire("cXt7v");

var $0GZvz = parcelRequire("0GZvz");

var $64BU0 = parcelRequire("64BU0");
var $faef27284cfa645e$var$_mutations, $faef27284cfa645e$var$_mutationId, $faef27284cfa645e$var$_resuming;
var $faef27284cfa645e$export$1fcfd9a244434844 = class extends (0, $64BU0.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $4sZyw.__privateAdd)(this, $faef27284cfa645e$var$_mutations, void 0);
        (0, $4sZyw.__privateAdd)(this, $faef27284cfa645e$var$_mutationId, void 0);
        (0, $4sZyw.__privateAdd)(this, $faef27284cfa645e$var$_resuming, void 0);
        (0, $4sZyw.__privateSet)(this, $faef27284cfa645e$var$_mutations, []);
        (0, $4sZyw.__privateSet)(this, $faef27284cfa645e$var$_mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, $cXt7v.Mutation)({
            mutationCache: this,
            mutationId: ++(0, $4sZyw.__privateWrapper)(this, $faef27284cfa645e$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $4sZyw.__privateGet)(this, $faef27284cfa645e$var$_mutations).push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        (0, $4sZyw.__privateSet)(this, $faef27284cfa645e$var$_mutations, (0, $4sZyw.__privateGet)(this, $faef27284cfa645e$var$_mutations).filter((x)=>x !== mutation));
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $aqN4U.notifyManager).batch(()=>{
            (0, $4sZyw.__privateGet)(this, $faef27284cfa645e$var$_mutations).forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return (0, $4sZyw.__privateGet)(this, $faef27284cfa645e$var$_mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return (0, $4sZyw.__privateGet)(this, $faef27284cfa645e$var$_mutations).find((mutation)=>(0, $0GZvz.matchMutation)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return (0, $4sZyw.__privateGet)(this, $faef27284cfa645e$var$_mutations).filter((mutation)=>(0, $0GZvz.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $aqN4U.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        (0, $4sZyw.__privateSet)(this, $faef27284cfa645e$var$_resuming, ((0, $4sZyw.__privateGet)(this, $faef27284cfa645e$var$_resuming) ?? Promise.resolve()).then(()=>{
            const pausedMutations = (0, $4sZyw.__privateGet)(this, $faef27284cfa645e$var$_mutations).filter((x)=>x.state.isPaused);
            return (0, $aqN4U.notifyManager).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $0GZvz.noop))), Promise.resolve()));
        }).then(()=>{
            (0, $4sZyw.__privateSet)(this, $faef27284cfa645e$var$_resuming, void 0);
        }));
        return (0, $4sZyw.__privateGet)(this, $faef27284cfa645e$var$_resuming);
    }
};
$faef27284cfa645e$var$_mutations = new WeakMap();
$faef27284cfa645e$var$_mutationId = new WeakMap();
$faef27284cfa645e$var$_resuming = new WeakMap();

});
parcelRegister("cXt7v", function(module, exports) {

$parcel$export(module.exports, "Mutation", () => $96f19558542b246f$export$17b8b19c814bcf56);
$parcel$export(module.exports, "getDefaultState", () => $96f19558542b246f$export$a1659b54bac3252a);

var $4sZyw = parcelRequire("4sZyw");

var $aqN4U = parcelRequire("aqN4U");

var $2sIyz = parcelRequire("2sIyz");

var $jmYZW = parcelRequire("jmYZW");
var $96f19558542b246f$var$_observers, $96f19558542b246f$var$_defaultOptions, $96f19558542b246f$var$_mutationCache, $96f19558542b246f$var$_retryer, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn;
var $96f19558542b246f$export$17b8b19c814bcf56 = class extends (0, $2sIyz.Removable) {
    constructor(config){
        super();
        (0, $4sZyw.__privateAdd)(this, $96f19558542b246f$var$_dispatch);
        (0, $4sZyw.__privateAdd)(this, $96f19558542b246f$var$_observers, void 0);
        (0, $4sZyw.__privateAdd)(this, $96f19558542b246f$var$_defaultOptions, void 0);
        (0, $4sZyw.__privateAdd)(this, $96f19558542b246f$var$_mutationCache, void 0);
        (0, $4sZyw.__privateAdd)(this, $96f19558542b246f$var$_retryer, void 0);
        this.mutationId = config.mutationId;
        (0, $4sZyw.__privateSet)(this, $96f19558542b246f$var$_defaultOptions, config.defaultOptions);
        (0, $4sZyw.__privateSet)(this, $96f19558542b246f$var$_mutationCache, config.mutationCache);
        (0, $4sZyw.__privateSet)(this, $96f19558542b246f$var$_observers, []);
        this.state = config.state || $96f19558542b246f$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...(0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_observers).includes(observer)) {
            (0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $4sZyw.__privateSet)(this, $96f19558542b246f$var$_observers, (0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        const executeMutation = ()=>{
            (0, $4sZyw.__privateSet)(this, $96f19558542b246f$var$_retryer, (0, $jmYZW.createRetryer)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                    return this.options.mutationFn(variables);
                },
                onFail: (failureCount, error)=>{
                    (0, $4sZyw.__privateMethod)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    (0, $4sZyw.__privateMethod)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    (0, $4sZyw.__privateMethod)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                        type: "continue"
                    });
                },
                retry: this.options.retry ?? 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            }));
            return (0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_retryer).promise;
        };
        const restored = this.state.status === "pending";
        try {
            if (!restored) {
                (0, $4sZyw.__privateMethod)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables
                });
                await ((_b = (_a = (0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $4sZyw.__privateMethod)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables
                });
            }
            const data = await executeMutation();
            await ((_f = (_e = (0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $4sZyw.__privateMethod)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $4sZyw.__privateMethod)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        }
    }
};
$96f19558542b246f$var$_observers = new WeakMap();
$96f19558542b246f$var$_defaultOptions = new WeakMap();
$96f19558542b246f$var$_mutationCache = new WeakMap();
$96f19558542b246f$var$_retryer = new WeakMap();
$96f19558542b246f$var$_dispatch = new WeakSet();
$96f19558542b246f$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: !(0, $jmYZW.canFetch)(this.options.networkMode),
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $aqN4U.notifyManager).batch(()=>{
        (0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $4sZyw.__privateGet)(this, $96f19558542b246f$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $96f19558542b246f$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}

});


parcelRegister("5YK1w", function(module, exports) {

$parcel$export(module.exports, "infiniteQueryBehavior", () => $45a641ae9a292711$export$84470d1367601e8d);


var $0GZvz = parcelRequire("0GZvz");
function $45a641ae9a292711$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const fetchFn = async ()=>{
                var _a, _b, _c, _d, _e;
                const options = context.options;
                const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
                const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
                const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
                const empty = {
                    pages: [],
                    pageParams: []
                };
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = context.options.queryFn && context.options.queryFn !== (0, $0GZvz.skipToken) ? context.options.queryFn : ()=>{
                    return Promise.reject(new Error(`Missing queryFn: '${context.options.queryHash}'`));
                };
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $0GZvz.addToStart) : (0, $0GZvz.addToEnd);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                let result;
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $45a641ae9a292711$var$getPreviousPageParam : $45a641ae9a292711$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    result = await fetchPage(empty, oldPageParams[0] ?? options.initialPageParam);
                    const remainingPages = pages ?? oldPages.length;
                    for(let i = 1; i < remainingPages; i++){
                        const param = $45a641ae9a292711$var$getNextPageParam(options, result);
                        result = await fetchPage(result, param);
                    }
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a, _b;
                return (_b = (_a = context.options).persister) == null ? void 0 : _b.call(_a, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $45a641ae9a292711$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams);
}
function $45a641ae9a292711$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams);
}
function $45a641ae9a292711$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $45a641ae9a292711$var$getNextPageParam(options, data) != null;
}
function $45a641ae9a292711$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $45a641ae9a292711$var$getPreviousPageParam(options, data) != null;
}

});



parcelRegister("hkj2Z", function(module, exports) {

$parcel$export(module.exports, "updateQueriesDataByPattern", () => $146f49224298a02d$export$3eb4c021ac123681);
function $146f49224298a02d$export$57091ef56c7e615f(queryClient, matcher) {
    const queries = queryClient.getQueryCache().getAll();
    const matchingKeys = [];
    for (const query of queries){
        const queryKey = query.queryKey;
        const queryKeyString = JSON.stringify(queryKey);
        let matches = false;
        if (matcher.contains && queryKeyString.includes(matcher.contains)) matches = true;
        if (matcher.regex && matcher.regex.test(queryKeyString)) matches = true;
        if (matcher.startsWith) {
            const firstKey = queryKey[0];
            if (typeof firstKey === "string" && firstKey.startsWith(matcher.startsWith)) matches = true;
        }
        if (matcher.endsWith) {
            const lastKey = queryKey[queryKey.length - 1];
            if (typeof lastKey === "string" && lastKey.endsWith(matcher.endsWith)) matches = true;
        }
        if (matcher.predicate && matcher.predicate(queryKey)) matches = true;
        if (matches) matchingKeys.push(queryKey);
    }
    return matchingKeys;
}
function $146f49224298a02d$export$3eb4c021ac123681(queryClient, matcher, updater) {
    const matchingKeys = $146f49224298a02d$export$57091ef56c7e615f(queryClient, matcher);
    matchingKeys.forEach((queryKey)=>{
        queryClient.setQueryData(queryKey, updater);
    });
}

});


parcelRegister("kL9vD", function(module, exports) {
$parcel$export(module.exports, "useSession", () => (parcelRequire("edg5W")).useSession);
parcelRequire("edg5W");

});

parcelRegister("er80J", function(module, exports) {

$parcel$export(module.exports, "useApiClient", () => $3c510eacb915639d$export$bd7ff15b2f060ea4);
parcelRequire("i5Lss");
var $2mq6B = parcelRequire("2mq6B");
parcelRequire("kL9vD");
var $edg5W = parcelRequire("edg5W");
function $3c510eacb915639d$export$bd7ff15b2f060ea4(baseURLOverride) {
    const session = (0, $edg5W.useSession)();
    return (0, $2mq6B.createApiClient)({
        baseURL: baseURLOverride,
        token: session.token.data || undefined
    });
}

});


parcelRegister("ioTAq", function(module, exports) {

$parcel$export(module.exports, "useApiPolling", () => $fdab3303cac80712$export$ef983126c1190ee7);

var $acw62 = parcelRequire("acw62");

var $7Y7Q4 = parcelRequire("7Y7Q4");
const $fdab3303cac80712$var$defaultRefetchInterval = 2000;
function $fdab3303cac80712$export$ef983126c1190ee7(query, hookOptions) {
    const [params, setParams] = (0, $acw62.useState)(undefined);
    const refetchInterval = hookOptions?.refetchInterval || $fdab3303cac80712$var$defaultRefetchInterval;
    const [isPolling, setPolling] = (0, $acw62.useState)(false);
    const res = (0, $7Y7Q4.useApiQuery)(query, {
        ...hookOptions,
        refetchInterval: isPolling ? refetchInterval : undefined,
        enabled: isPolling,
        toastsEnabled: false,
        params: params
    });
    (0, $acw62.useEffect)(()=>{
        if (res.data && hookOptions?.onPollSuccess) hookOptions?.onPollSuccess(res.data);
    }, [
        res.data
    ]);
    return {
        ...res,
        isPolling: isPolling,
        startPolling: (0, $acw62.useCallback)((paramsIn)=>{
            setParams(paramsIn);
            setPolling(true);
        }, [
            setParams,
            setPolling
        ]),
        stopPolling: ()=>setPolling(false)
    };
}

});


parcelRegister("8y7qB", function(module, exports) {
$parcel$export(module.exports, "useApiMutation", () => (parcelRequire("4CoXh")).useApiMutation);
parcelRequire("4CoXh");

});
parcelRegister("4CoXh", function(module, exports) {

$parcel$export(module.exports, "useApiMutation", () => $d4633297e3cd59d5$export$c4f1f1673f4fb16f);

var $5CC1K = parcelRequire("5CC1K");
var $f19YE = parcelRequire("f19YE");

var $edg5W = parcelRequire("edg5W");

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");
parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");
parcelRequire("18L7n");
var $3oOMC = parcelRequire("3oOMC");

var $cxTd9 = parcelRequire("cxTd9");

var $er80J = parcelRequire("er80J");
function $d4633297e3cd59d5$export$c4f1f1673f4fb16f(mutation, hookOptions = {}) {
    const options = {
        toastsEnabled: true,
        ...(0, $f1q41.omit)(mutation, "mutationFn"),
        ...hookOptions
    };
    const [mutationQueue, setMutationQueue] = (0, $acw62.useState)([]);
    const queryClient = (0, $f19YE.useQueryClient)();
    const session = (0, $edg5W.useSession)({
        enabled: options.waitForSession
    });
    const router = (0, $fp4OM.useRouter)();
    const api = (0, $er80J.useApiClient)();
    const appContext = {
        api: api,
        session: session,
        params: options.params,
        queryClient: queryClient,
        router: router
    };
    const mutationFn = (variables)=>mutation.mutationFn({
            ...appContext,
            payload: variables
        });
    const result = (0, $5CC1K.useMutation)({
        mutationFn: mutationFn,
        ...options,
        onError: (...args)=>{
            const { errorToast: errorToast, toastsEnabled: toastsEnabled } = options;
            if (toastsEnabled && errorToast) (0, $3oOMC.toast).error(errorToast.message, errorToast.options);
            if (options.onError) options.onError(...args);
        },
        onSuccess: (...args)=>{
            const invalidationList = options.invalidates || [];
            (0, $cxTd9.invalidateQueries)(invalidationList, appContext);
            const { successToast: successToast, toastsEnabled: toastsEnabled } = options;
            if (toastsEnabled && successToast) (0, $3oOMC.toast).success(successToast.message, successToast.options);
            if (options.onSuccess) options.onSuccess(...args);
        },
        onSettled: options.onSettled
    });
    (0, $acw62.useEffect)(()=>{
        if (mutationQueue.length > 0 && (!options.waitForSession || session.user)) {
            result.mutate(mutationQueue[0]);
            setMutationQueue(mutationQueue.slice(1));
        }
    }, [
        session
    ]);
    return {
        ...result,
        session: session,
        params: options.params,
        router: router,
        queryClient: queryClient,
        mutateAsync: (0, $acw62.useCallback)(async (variables = {})=>{
            if (!options.waitForSession || session.user) return await result.mutateAsync(variables);
            else setMutationQueue([
                ...mutationQueue,
                variables
            ]);
        }, [
            mutationQueue,
            session
        ]),
        mutate: (0, $acw62.useCallback)((variables = {})=>{
            if (!options.waitForSession || session.user) result.mutate(variables);
            else setMutationQueue([
                ...mutationQueue,
                variables
            ]);
        }, [
            mutationQueue,
            session
        ])
    };
}

});
parcelRegister("5CC1K", function(module, exports) {

$parcel$export(module.exports, "useMutation", () => $417dffbfea982a4c$export$609860bf8b0084c);

var $acw62 = parcelRequire("acw62");

var $cgbnY = parcelRequire("cgbnY");
var $aqN4U = parcelRequire("aqN4U");

var $f19YE = parcelRequire("f19YE");

var $e7sZD = parcelRequire("e7sZD");
"use client";
function $417dffbfea982a4c$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $f19YE.useQueryClient)(queryClient);
    const [observer] = $acw62.useState(()=>new (0, $cgbnY.MutationObserver)(client, options));
    $acw62.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>observer.subscribe((0, $aqN4U.notifyManager).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $acw62.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $e7sZD.noop));
    }, [
        observer
    ]);
    if (result.error && (0, $e7sZD.shouldThrowError)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}

});
parcelRegister("cgbnY", function(module, exports) {

$parcel$export(module.exports, "MutationObserver", () => $8ecfcf98cb47c0ad$export$d3c1860ee66f291a);

var $4sZyw = parcelRequire("4sZyw");

var $cXt7v = parcelRequire("cXt7v");

var $aqN4U = parcelRequire("aqN4U");

var $64BU0 = parcelRequire("64BU0");

var $0GZvz = parcelRequire("0GZvz");
var $8ecfcf98cb47c0ad$var$_client, $8ecfcf98cb47c0ad$var$_currentResult, $8ecfcf98cb47c0ad$var$_currentMutation, $8ecfcf98cb47c0ad$var$_mutateOptions, $8ecfcf98cb47c0ad$var$_updateResult, $8ecfcf98cb47c0ad$var$updateResult_fn, $8ecfcf98cb47c0ad$var$_notify, $8ecfcf98cb47c0ad$var$notify_fn;
var $8ecfcf98cb47c0ad$export$d3c1860ee66f291a = class extends (0, $64BU0.Subscribable) {
    constructor(client, options){
        super();
        (0, $4sZyw.__privateAdd)(this, $8ecfcf98cb47c0ad$var$_updateResult);
        (0, $4sZyw.__privateAdd)(this, $8ecfcf98cb47c0ad$var$_notify);
        (0, $4sZyw.__privateAdd)(this, $8ecfcf98cb47c0ad$var$_client, void 0);
        (0, $4sZyw.__privateAdd)(this, $8ecfcf98cb47c0ad$var$_currentResult, void 0);
        (0, $4sZyw.__privateAdd)(this, $8ecfcf98cb47c0ad$var$_currentMutation, void 0);
        (0, $4sZyw.__privateAdd)(this, $8ecfcf98cb47c0ad$var$_mutateOptions, void 0);
        (0, $4sZyw.__privateSet)(this, $8ecfcf98cb47c0ad$var$_client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $4sZyw.__privateMethod)(this, $8ecfcf98cb47c0ad$var$_updateResult, $8ecfcf98cb47c0ad$var$updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_client).defaultMutationOptions(options);
        if (!(0, $0GZvz.shallowEqualObjects)(this.options, prevOptions)) (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_currentMutation),
            observer: this
        });
        if ((prevOptions == null ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $0GZvz.hashKey)(prevOptions.mutationKey) !== (0, $0GZvz.hashKey)(this.options.mutationKey)) this.reset();
        else if (((_a = (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null ? void 0 : _a.state.status) === "pending") (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_currentMutation).setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, $4sZyw.__privateMethod)(this, $8ecfcf98cb47c0ad$var$_updateResult, $8ecfcf98cb47c0ad$var$updateResult_fn).call(this);
        (0, $4sZyw.__privateMethod)(this, $8ecfcf98cb47c0ad$var$_notify, $8ecfcf98cb47c0ad$var$notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_currentResult);
    }
    reset() {
        var _a;
        (_a = (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $4sZyw.__privateSet)(this, $8ecfcf98cb47c0ad$var$_currentMutation, void 0);
        (0, $4sZyw.__privateMethod)(this, $8ecfcf98cb47c0ad$var$_updateResult, $8ecfcf98cb47c0ad$var$updateResult_fn).call(this);
        (0, $4sZyw.__privateMethod)(this, $8ecfcf98cb47c0ad$var$_notify, $8ecfcf98cb47c0ad$var$notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, $4sZyw.__privateSet)(this, $8ecfcf98cb47c0ad$var$_mutateOptions, options);
        (_a = (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $4sZyw.__privateSet)(this, $8ecfcf98cb47c0ad$var$_currentMutation, (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_client).getMutationCache().build((0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_client), this.options));
        (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_currentMutation).addObserver(this);
        return (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_currentMutation).execute(variables);
    }
};
$8ecfcf98cb47c0ad$var$_client = new WeakMap();
$8ecfcf98cb47c0ad$var$_currentResult = new WeakMap();
$8ecfcf98cb47c0ad$var$_currentMutation = new WeakMap();
$8ecfcf98cb47c0ad$var$_mutateOptions = new WeakMap();
$8ecfcf98cb47c0ad$var$_updateResult = new WeakSet();
$8ecfcf98cb47c0ad$var$updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null ? void 0 : _a.state) ?? (0, $cXt7v.getDefaultState)();
    (0, $4sZyw.__privateSet)(this, $8ecfcf98cb47c0ad$var$_currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
$8ecfcf98cb47c0ad$var$_notify = new WeakSet();
$8ecfcf98cb47c0ad$var$notify_fn = function(action) {
    (0, $aqN4U.notifyManager).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_mutateOptions) && this.hasListeners()) {
            const variables = (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_currentResult).variables;
            const context = (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_currentResult).context;
            if ((action == null ? void 0 : action.type) === "success") {
                (_b = (_a = (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onSuccess) == null || _b.call(_a, action.data, variables, context);
                (_d = (_c = (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, variables, context);
            } else if ((action == null ? void 0 : action.type) === "error") {
                (_f = (_e = (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onError) == null || _f.call(_e, action.error, variables, context);
                (_h = (_g = (0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, variables, context);
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $4sZyw.__privateGet)(this, $8ecfcf98cb47c0ad$var$_currentResult));
        });
    });
};

});


parcelRegister("cxTd9", function(module, exports) {

$parcel$export(module.exports, "invalidateQueries", () => $a8c27bd62c66c112$export$ab66a22929fe54a7);
parcelRequire("i5Lss");
var $4gN4F = parcelRequire("4gN4F");
function $a8c27bd62c66c112$export$ab66a22929fe54a7(invalidationList, appContext) {
    const { queryClient: queryClient } = appContext;
    for (const invalidation of invalidationList){
        if (typeof invalidation === "function") queryClient.invalidateQueries({
            predicate: invalidation
        });
        else if (typeof invalidation === "string") queryClient.invalidateQueries({
            predicate: (query)=>{
                let invalidate = false;
                query.queryKey.forEach((key)=>{
                    if (typeof key === "string" && key.includes(invalidation)) invalidate = true;
                });
                return invalidate;
            },
            exact: false
        });
        else {
            const query = invalidation;
            const queryKey = (0, $4gN4F.getCacheKey)(query.queryFn, appContext, query.scope);
            if (queryKey) queryClient.invalidateQueries({
                queryKey: queryKey,
                exact: true
            });
        }
    }
}

});



parcelRegister("74MPp", function(module, exports) {
parcelRequire("er80J");

});



parcelRegister("h33ag", function(module, exports) {

$parcel$export(module.exports, "LoginPage", () => (parcelRequire("au8D6")).default);
$parcel$export(module.exports, "SignupPage", () => (parcelRequire("7vE2c")).default);
$parcel$export(module.exports, "LogoutPage", () => (parcelRequire("bBFEN")).default);
$parcel$export(module.exports, "CompanyProfilePage", () => (parcelRequire("gXZ39")).default);
$parcel$export(module.exports, "LoginErrorPage", () => (parcelRequire("gMxRY")).default);
$parcel$export(module.exports, "PostSignupPage", () => (parcelRequire("1bRue")).default);
$parcel$export(module.exports, "SignupCompletePage", () => (parcelRequire("7EKKo")).default);
$parcel$export(module.exports, "EmailVerificationPage", () => (parcelRequire("8vLZR")).default);
$parcel$export(module.exports, "ResetPasswordPage", () => (parcelRequire("GnB8W")).default);

var $au8D6 = parcelRequire("au8D6");

var $7vE2c = parcelRequire("7vE2c");

var $bBFEN = parcelRequire("bBFEN");

var $gXZ39 = parcelRequire("gXZ39");

var $gMxRY = parcelRequire("gMxRY");

var $1bRue = parcelRequire("1bRue");

var $7EKKo = parcelRequire("7EKKo");

var $8vLZR = parcelRequire("8vLZR");

var $GnB8W = parcelRequire("GnB8W");

});
parcelRegister("au8D6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0d189693116a522$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("18L7n");
var $5Ttm9 = parcelRequire("5Ttm9");
parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");

var $bCeTl = parcelRequire("bCeTl");

var $acw62 = parcelRequire("acw62");
function $a0d189693116a522$var$LoginPage() {
    const { loginWithRedirect: loginWithRedirect, user: user } = (0, $bCeTl.useAuth0)();
    const router = (0, $fp4OM.useRouter)();
    const returnTo = router.search.returnTo;
    (0, $acw62.useEffect)(()=>{
        if (!user) {
            if (returnTo) localStorage.setItem("returnTo", returnTo);
            loginWithRedirect({
                authorizationParams: {
                    redirect_uri: "https://icm.humcapital.com"
                }
            });
        }
    }, [
        user,
        loginWithRedirect
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
                fullScreen: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "sr-only",
                children: "Login Page"
            })
        ]
    });
}
var $a0d189693116a522$export$2e2bcd8739ae039 = $a0d189693116a522$var$LoginPage;

});

parcelRegister("7vE2c", function(module, exports) {

$parcel$export(module.exports, "default", () => $0344b7e6c3fdf409$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8LEhm = parcelRequire("8LEhm");

var $YHMTU = parcelRequire("YHMTU");
parcelRequire("18L7n");
var $5Ttm9 = parcelRequire("5Ttm9");
parcelRequire("gCemA");
var $3qMBE = parcelRequire("3qMBE");

var $bCeTl = parcelRequire("bCeTl");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");
function $0344b7e6c3fdf409$var$SignupPage() {
    const { loginWithRedirect: loginWithRedirect } = (0, $bCeTl.useAuth0)();
    const [isRedirectingTo, setIsRedirecting] = (0, $acw62.useState)(null);
    // TODO: If you are authenticated this page should redirect.
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $YHMTU.Onboarding).Layout, {
        centered: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w-full md:w-[400px]",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $YHMTU.Onboarding).Header, {
                    title: "What is your reason for signing up with Hum, today?"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w-full md:w-[400px]",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: (0, $9QePP.default)("flex flex-col", "items-center justify-center gap-6"),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            className: "secondary xl w-full",
                            disabled: !!isRedirectingTo,
                            onClick: ()=>{
                                setIsRedirecting("company");
                                loginWithRedirect({
                                    authorizationParams: {
                                        redirect_uri: "https://icm.humcapital.com" + `/post-signup/${(0, $8LEhm.UserRole).COMPANY}`,
                                        screen_hint: "signup"
                                    }
                                });
                            },
                            children: [
                                "I\u2019m looking to fundraise",
                                isRedirectingTo === "company" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            className: "secondary xl w-full",
                            disabled: !!isRedirectingTo,
                            onClick: ()=>{
                                setIsRedirecting("fund");
                                loginWithRedirect({
                                    authorizationParams: {
                                        redirect_uri: "https://icm.humcapital.com" + `/post-signup/${(0, $8LEhm.UserRole).FUND}`,
                                        screen_hint: "signup"
                                    }
                                });
                            },
                            children: [
                                "I\u2019m looking to invest",
                                isRedirectingTo === "fund" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {})
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var $0344b7e6c3fdf409$export$2e2bcd8739ae039 = (0, $3qMBE.asPage)($0344b7e6c3fdf409$var$SignupPage);

});
parcelRegister("YHMTU", function(module, exports) {

$parcel$export(module.exports, "Onboarding", () => $343c17f7a1ce2dcb$export$70238cd3868b67c9);

var $fm4Dh = parcelRequire("fm4Dh");

var $a8FiN = parcelRequire("a8FiN");

var $bUwH3 = parcelRequire("bUwH3");

var $caQGX = parcelRequire("caQGX");

var $kIdd2 = parcelRequire("kIdd2");

var $8a2R9 = parcelRequire("8a2R9");

var $lLqdn = parcelRequire("lLqdn");
const $343c17f7a1ce2dcb$export$70238cd3868b67c9 = {
    Layout: $fm4Dh.Layout,
    Step: $bUwH3.Step,
    Steps: $a8FiN.Steps,
    Header: $caQGX.Header,
    Video: $kIdd2.Video,
    TextBlock: $8a2R9.TextBlock,
    MobileSteps: $lLqdn.MobileSteps,
    MobileStep: $lLqdn.MobileStep
};

});
parcelRegister("fm4Dh", function(module, exports) {

$parcel$export(module.exports, "Layout", () => $71231ca0cb2e45e6$export$c84671f46d6a1ca);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $2hw4u = parcelRequire("2hw4u");
var $fRJCp = parcelRequire("fRJCp");
const $71231ca0cb2e45e6$export$c84671f46d6a1ca = ({ children: children, centered: centered })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2hw4u.AnimatePresence), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).main, {
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            exit: {
                opacity: 0
            },
            className: (0, $9QePP.default)("flex h-screen flex-col items-center lg:flex-row", "gap-5 lg:gap-[100px] xl:gap-[120px]", !centered && "px-10 pt-20 lg:px-[100px] xl:px-[180px] 2xl:px-[300px]", !centered && "first:flex first:w-full first:flex-col first:gap-3", !centered && "lg:first:w-[400px]", !centered && "last:w-full lg:last:max-w-[500px]", centered && "justify-center px-10 lg:px-0"),
            children: children
        })
    });
};

});

parcelRegister("a8FiN", function(module, exports) {

$parcel$export(module.exports, "Steps", () => $c0713cc886f6d287$export$fb587a27d5a722e7);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
const $c0713cc886f6d287$export$fb587a27d5a722e7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("border-y border-slate-700", "flex-col", "items-start justify-start", "divide-y divide-slate-700", "hidden lg:flex"),
        children: children
    });
};

});

parcelRegister("bUwH3", function(module, exports) {

$parcel$export(module.exports, "Step", () => $d383421e21e1e2d9$export$fd55ce593607084a);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("18L7n");
var $hUCih = parcelRequire("hUCih");

var $9QePP = parcelRequire("9QePP");
const $d383421e21e1e2d9$export$fd55ce593607084a = ({ active: active = false, completed: completed = false, text: text })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex w-full gap-8 py-7",
        children: [
            active && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).MapPin, {}),
            completed && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).Check, {}),
            !active && !completed && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).StepInProgress, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: (0, $9QePP.default)("heading-m", {
                    subdued: !active
                }),
                children: text
            })
        ]
    });
};

});

parcelRegister("caQGX", function(module, exports) {

$parcel$export(module.exports, "Header", () => $374ed48262427301$export$8b251419efc915eb);

var $ayMG0 = parcelRequire("ayMG0");
const $374ed48262427301$export$8b251419efc915eb = ({ title: title, description: description })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "display-s lg:display-l mb-4 lg:mb-6",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "body-l lg:mb-6",
                children: description
            })
        ]
    });
};

});

parcelRegister("kIdd2", function(module, exports) {

$parcel$export(module.exports, "Video", () => $eee634a7d096a4ec$export$ae01dedf5c052bb);

var $ayMG0 = parcelRequire("ayMG0");

var $5HdXb = parcelRequire("5HdXb");

var $7LrgD = parcelRequire("7LrgD");

var $9QePP = parcelRequire("9QePP");
const $eee634a7d096a4ec$export$ae01dedf5c052bb = ({ isNotPlaying: isNotPlaying, onPlay: onPlay, videoId: videoId })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("w-full", "h-full", "mb-8", "relative inline-block overflow-hidden rounded"),
        children: [
            isNotPlaying && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                role: "button",
                onClick: onPlay,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        width: "100%",
                        src: "https://humcapital.com/wp-content/uploads/2023/01/Investor-Video-thumbnail.png",
                        className: (0, $9QePP.default)("no-lazy", "rounded", "overflow-hidden", "peer transition-transform duration-200 hover:scale-125"),
                        alt: "investor video",
                        decoding: "async",
                        srcSet: "https://humcapital.com/wp-content/uploads/2023/01/Investor-Video-thumbnail.png 880w, https://humcapital.com/wp-content/uploads/2023/01/Investor-Video-thumbnail-300x169.png 300w, https://humcapital.com/wp-content/uploads/2023/01/Investor-Video-thumbnail-600x338.png 600w, https://humcapital.com/wp-content/uploads/2023/01/Investor-Video-thumbnail-768x432.png 768w, https://humcapital.com/wp-content/uploads/2023/01/Investor-Video-thumbnail-400x225.png 400w, https://humcapital.com/wp-content/uploads/2023/01/Investor-Video-thumbnail-110x62.png 110w",
                        sizes: "(max-width: 880px) 100vw, 880px"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5HdXb.default), {
                        height: 88,
                        className: (0, $9QePP.default)("-translate-x-1/2 -translate-y-1/2", "absolute left-1/2 top-1/2 z-10 fill-slate-500 hover:fill-slate-600")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7LrgD.default), {
                video: videoId,
                width: "500",
                showTitle: false,
                showPortrait: false,
                paused: isNotPlaying,
                responsive: true,
                className: (0, $9QePP.default)("rounded", {
                    hidden: isNotPlaying
                })
            })
        ]
    });
};

});

parcelRegister("8a2R9", function(module, exports) {

$parcel$export(module.exports, "TextBlock", () => $a667e608e3dff366$export$2db84c782bfb16e2);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
const $a667e608e3dff366$export$2db84c782bfb16e2 = ({ title: title, description: description, className: className })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: (0, $9QePP.default)("mb-4 text-pretty", className),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "heading-m mb-1",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "body-s",
                children: description
            })
        ]
    });
};

});

parcelRegister("lLqdn", function(module, exports) {

$parcel$export(module.exports, "MobileStep", () => $6db4e8a24f5aa937$export$7767e8950b82228);
$parcel$export(module.exports, "MobileSteps", () => $6db4e8a24f5aa937$export$d307cdbe35e3302a);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
const $6db4e8a24f5aa937$export$7767e8950b82228 = ({ active: active })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)(active ? "w-3/5 bg-brand-50" : "w-1/5 bg-slate-600", "rounded py-1 transition-all ease-in-out")
    });
};
const $6db4e8a24f5aa937$export$d307cdbe35e3302a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("mb-5 mt-3 w-full", "flex gap-4", "lg:hidden"),
        children: children
    });
};

});



parcelRegister("bBFEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $48271a1240557899$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("18L7n");
var $5Ttm9 = parcelRequire("5Ttm9");

var $bCeTl = parcelRequire("bCeTl");

var $8Nbse = parcelRequire("8Nbse");

var $bsaya = parcelRequire("bsaya");
function $48271a1240557899$var$LogoutRedirect() {
    const { logout: logout } = (0, $bCeTl.useAuth0)();
    (0, $acw62.useEffect)(()=>{
        logout();
        const taskId = localStorage.getItem((0, $bsaya.TASK_ID_KEY));
        localStorage.clear();
        // restore taskId if it exists
        if (taskId) localStorage.setItem((0, $bsaya.TASK_ID_KEY), taskId);
        sessionStorage.clear();
        (0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).remove("tRM7touMig");
        console.log("user logged out");
    }, [
        logout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
                fullScreen: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "sr-only",
                children: "Logout Page"
            })
        ]
    });
}
var $48271a1240557899$export$2e2bcd8739ae039 = $48271a1240557899$var$LogoutRedirect;

});
parcelRegister("8Nbse", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});

});

parcelRegister("bsaya", function(module, exports) {

$parcel$export(module.exports, "TASK_ID_KEY", () => $a84c21bcdb5cefbf$export$8bbf7da16f44aa3b);
$parcel$export(module.exports, "useCreditboxes", () => $a84c21bcdb5cefbf$export$109e62aa2d42518b);
parcelRequire("tL0U5");
var $4CoXh = parcelRequire("4CoXh");
var $ioTAq = parcelRequire("ioTAq");
parcelRequire("7TcSx");
var $27vLh = parcelRequire("27vLh");
var $9ohvd = parcelRequire("9ohvd");

var $dKUtl = parcelRequire("dKUtl");

var $acw62 = parcelRequire("acw62");

var $1zFjz = parcelRequire("1zFjz");
const $a84c21bcdb5cefbf$export$8bbf7da16f44aa3b = "creditbox_task_id";
const $a84c21bcdb5cefbf$var$saveTaskId = (taskId)=>{
    try {
        localStorage.setItem($a84c21bcdb5cefbf$export$8bbf7da16f44aa3b, taskId);
    } catch (error) {
        console.warn("Failed to save taskId to localStorage:", error);
    }
};
const $a84c21bcdb5cefbf$var$getStoredTaskId = ()=>{
    try {
        return localStorage.getItem($a84c21bcdb5cefbf$export$8bbf7da16f44aa3b);
    } catch (error) {
        console.warn("Failed to read taskId from localStorage:", error);
        return null;
    }
};
const $a84c21bcdb5cefbf$var$clearStoredTaskId = ()=>{
    try {
        localStorage.removeItem($a84c21bcdb5cefbf$export$8bbf7da16f44aa3b);
    } catch (error) {
        console.warn("Failed to clear taskId from localStorage:", error);
    }
};
const $a84c21bcdb5cefbf$export$109e62aa2d42518b = ()=>{
    const [displayMessage, setDisplayMessage] = (0, $acw62.useState)("");
    const [isResumedTask, setIsResumedTask] = (0, $acw62.useState)(false);
    const [successState, setSuccessState] = (0, $acw62.useState)(false);
    const [failureState, setFailureState] = (0, $acw62.useState)(false);
    const { data: task, isPolling: isPolling, startPolling: startPolling, stopPolling: stopPolling, isError: isTaskError } = (0, $ioTAq.useApiPolling)((0, $9ohvd.getTaskStatus), {
        onPollSuccess (data) {
            if (data?.meta?.displayMsg) setDisplayMessage(data.meta.displayMsg);
            if (data?.meta?.presignedS3Url) (0, $1zFjz.downloadFile)(data.meta.presignedS3Url);
            if (data?.state === (0, $dKUtl.CreditBoxStatus).Failure) {
                setFailureState(true);
                setSuccessState(false);
                stopPolling();
                $a84c21bcdb5cefbf$var$clearStoredTaskId();
                setIsResumedTask(false);
            }
            if (data?.state === (0, $dKUtl.CreditBoxStatus).Success) {
                setSuccessState(true);
                setFailureState(false);
                stopPolling();
                $a84c21bcdb5cefbf$var$clearStoredTaskId();
                setIsResumedTask(false);
            }
        }
    });
    const resumeStoredTask = (0, $acw62.useCallback)(()=>{
        const storedTaskId = $a84c21bcdb5cefbf$var$getStoredTaskId();
        if (storedTaskId && !isPolling) {
            setSuccessState(false);
            setFailureState(false);
            startPolling({
                taskId: storedTaskId
            });
            setIsResumedTask(true);
            return true;
        }
        return false;
    }, [
        startPolling,
        isPolling
    ]);
    const { mutate: generateCreditBoxes, isError: isGenerateCreditBoxesError } = (0, $4CoXh.useApiMutation)((0, $27vLh.createCreditBoxFromSfdc), {
        onSuccess (data) {
            if (data.taskId) {
                setSuccessState(false);
                setFailureState(false);
                startPolling(data);
                $a84c21bcdb5cefbf$var$saveTaskId(data.taskId);
            }
        }
    });
    const { mutate: updateOpportunities, isError: isUpdateOpportunitiesError } = (0, $4CoXh.useApiMutation)((0, $27vLh.updateOpportunitiesFromSfdc), {
        onSuccess (data) {
            if (data.taskId) {
                setSuccessState(false);
                setFailureState(false);
                startPolling(data);
                $a84c21bcdb5cefbf$var$saveTaskId(data.taskId);
            }
        }
    });
    const { mutate: runCreditBox, isError: isRunCreditBoxError } = (0, $4CoXh.useApiMutation)((0, $27vLh.runCreditBoxes), {
        onSuccess (data) {
            if (data.taskId) {
                setSuccessState(false);
                setFailureState(false);
                startPolling(data);
                $a84c21bcdb5cefbf$var$saveTaskId(data.taskId);
            }
        }
    });
    const { mutate: getCreditBoxesResults, isError: isGetCreditBoxesResultsSpreadsheetError } = (0, $4CoXh.useApiMutation)((0, $27vLh.getCreditBoxesResultsTask), {
        onSuccess (data) {
            if (data.taskId) {
                setSuccessState(false);
                setFailureState(false);
                startPolling(data);
                $a84c21bcdb5cefbf$var$saveTaskId(data.taskId);
            }
        }
    });
    const isError = isTaskError || isGenerateCreditBoxesError || isUpdateOpportunitiesError || isRunCreditBoxError || isGetCreditBoxesResultsSpreadsheetError || failureState;
    const isSuccess = successState;
    const stopTask = (0, $acw62.useCallback)(()=>{
        stopPolling();
        $a84c21bcdb5cefbf$var$clearStoredTaskId();
        setIsResumedTask(false);
        setSuccessState(false);
        setFailureState(false);
    }, [
        stopPolling
    ]);
    return {
        task: task,
        isPolling: isPolling,
        startGenerateCreditBoxes: ()=>generateCreditBoxes(),
        startUpdateOpportunities: ()=>updateOpportunities(),
        startRunCreditBox: (payload)=>runCreditBox(payload),
        startGetCreditBoxesResultsTask: (payload)=>getCreditBoxesResults(payload),
        stopPolling: stopTask,
        resumeStoredTask: resumeStoredTask,
        isError: isError,
        isSuccess: isSuccess,
        displayMessage: displayMessage,
        isResumedTask: isResumedTask
    };
};

});
parcelRegister("7TcSx", function(module, exports) {
$parcel$export(module.exports, "CreditBoxSearchType", () => (parcelRequire("dKUtl")).CreditBoxSearchType);
$parcel$export(module.exports, "createCreditBoxFromSfdc", () => (parcelRequire("27vLh")).createCreditBoxFromSfdc);
$parcel$export(module.exports, "getCreditBoxesResultsTask", () => (parcelRequire("27vLh")).getCreditBoxesResultsTask);
$parcel$export(module.exports, "runCreditBoxes", () => (parcelRequire("27vLh")).runCreditBoxes);
$parcel$export(module.exports, "updateOpportunitiesFromSfdc", () => (parcelRequire("27vLh")).updateOpportunitiesFromSfdc);
$parcel$export(module.exports, "getOpportunityFieldInfo", () => (parcelRequire("9ohvd")).getOpportunityFieldInfo);
$parcel$export(module.exports, "getTaskStatus", () => (parcelRequire("9ohvd")).getTaskStatus);
$parcel$export(module.exports, "useCreditboxes", () => (parcelRequire("bsaya")).useCreditboxes);
parcelRequire("dKUtl");
parcelRequire("27vLh");
parcelRequire("9ohvd");
parcelRequire("bsaya");

});
parcelRegister("27vLh", function(module, exports) {

$parcel$export(module.exports, "getCreditBoxesResultsTask", () => $3b6b210301ee6fe6$export$57957fd5d9df810);
$parcel$export(module.exports, "createCreditBoxFromSfdc", () => $3b6b210301ee6fe6$export$27262408202627b1);
$parcel$export(module.exports, "updateOpportunitiesFromSfdc", () => $3b6b210301ee6fe6$export$a6497c69fdd59046);
$parcel$export(module.exports, "runCreditBoxes", () => $3b6b210301ee6fe6$export$10c8cec934947273);
parcelRequire("i5Lss");
var $gBHSi = parcelRequire("gBHSi");
parcelRequire("gCemA");
var $9O2q1 = parcelRequire("9O2q1");
const $3b6b210301ee6fe6$export$f3d1525ea2690700 = (0, $gBHSi.createMutation)(({ api: api, payload: payload })=>{
    const queryBuilder = new (0, $9O2q1.QueryStringBuilder)();
    const paramMapping = {
        creditBoxId: "credit_box_id",
        opportunityName: "opportunity_name",
        icmId: "icm_id",
        icmUuid: "icm_uuid",
        sfdcOpportunityId: "sfdc_opportunity_id",
        score: "score"
    };
    Object.entries(paramMapping).forEach(([payloadKey, queryParamName])=>{
        const value = payload?.[payloadKey];
        if (value) queryBuilder.in(queryParamName, Array.isArray(value) ? value : [
            value
        ]);
    });
    const queryString = queryBuilder.build();
    return api.get(`/deal-flow/v1/credit_boxes/results/spreadsheet?${queryString}`);
}, {
    errorToast: {
        message: "Unable to generate credit boxes results."
    }
});
const $3b6b210301ee6fe6$export$57957fd5d9df810 = (0, $gBHSi.createMutation)(({ api: api, payload: payload })=>{
    return api.post(`/deal-flow/v2/credit_boxes/results/spreadsheet`, payload);
});
const $3b6b210301ee6fe6$export$27262408202627b1 = (0, $gBHSi.createMutation)(({ api: api })=>{
    return api.post("/deal-flow/v1/credit_boxes/generate_from_sfdc");
}, {
    invalidates: [
        "/credit_boxes/investor_map"
    ]
});
const $3b6b210301ee6fe6$export$a6497c69fdd59046 = (0, $gBHSi.createMutation)(({ api: api })=>{
    return api.post("/deal-flow/v1/opportunities/update_from_sfdc");
}, {
    invalidates: [
        "/credit_boxes/opportunity_map"
    ]
});
const $3b6b210301ee6fe6$export$10c8cec934947273 = (0, $gBHSi.createMutation)(({ api: api, payload: payload })=>{
    return api.post("/deal-flow/v1/credit_boxes/run", {
        creditBoxUuids: payload?.creditBoxUuids || [],
        icmCompanies: payload?.icmCompanies || [],
        sfdcOpportunities: payload?.sfdcOpportunities || [],
        prospectiveValues: payload?.prospectiveValues || [],
        testCreditBox: payload?.testCreditBox || {}
    });
});

});

parcelRegister("9ohvd", function(module, exports) {

$parcel$export(module.exports, "getCreditBoxInvestorMap", () => $9370b0cf5af96559$export$c08401e9984dd839);
$parcel$export(module.exports, "getCreditBoxOpportunityMap", () => $9370b0cf5af96559$export$f65268fcc503bd0c);
$parcel$export(module.exports, "getOpportunityFieldInfo", () => $9370b0cf5af96559$export$4d025ec26ef3273d);
$parcel$export(module.exports, "getTaskStatus", () => $9370b0cf5af96559$export$9813dd697f9dfeee);
$parcel$export(module.exports, "getInvestmentCriteria", () => $9370b0cf5af96559$export$713705659b05c06);
$parcel$export(module.exports, "getFunds", () => $9370b0cf5af96559$export$4c645135bc52394e);
parcelRequire("i5Lss");
var $kkxkw = parcelRequire("kkxkw");

var $dKUtl = parcelRequire("dKUtl");

var $9O2q1 = parcelRequire("9O2q1");

var $bxdbx = parcelRequire("bxdbx");
const $9370b0cf5af96559$export$c08401e9984dd839 = (0, $kkxkw.createQuery)(({ api: api, params: params })=>{
    const queryString = new (0, $9O2q1.QueryStringBuilder)().add("size", params?.size || (0, $dKUtl.PAGE_SIZE)).add("page", params?.page || 1).build();
    return api.get(`/deal-flow/v1/credit_boxes/investor_map?${queryString}`);
});
const $9370b0cf5af96559$export$f65268fcc503bd0c = (0, $kkxkw.createQuery)(({ api: api, params: params })=>{
    const queryString = new (0, $9O2q1.QueryStringBuilder)().add("size", params?.size || (0, $dKUtl.PAGE_SIZE)).add("page", params?.page || 1).build();
    return api.get(`/deal-flow/v1/credit_boxes/opportunity_map?${queryString}`).then((res)=>{
        const uniqueStatuses = [
            ...new Set(res.items.filter((opp)=>opp.status && opp.status !== "").map((opp)=>opp.status))
        ];
        return {
            ...res,
            statuses: uniqueStatuses
        };
    });
});
const $9370b0cf5af96559$export$4d025ec26ef3273d = (0, $kkxkw.createQuery)(({ api: api })=>{
    return api.get("/deal-flow/v1/credit_boxes/opportunity_field_info").then((res)=>{
        return res.items;
    });
});
const $9370b0cf5af96559$export$9813dd697f9dfeee = (0, $kkxkw.createQuery)(({ api: api, params: params })=>{
    return api.get(`/deal-flow/v1/task_status/${params?.taskId}`).then((res)=>{
        return {
            ...res,
            meta: (0, $bxdbx.camelCased)(JSON.parse(res.meta))
        };
    });
});
const $9370b0cf5af96559$export$713705659b05c06 = (0, $kkxkw.createQuery)(({ api: api, params: params })=>{
    const opportunityId = (params?.sfdcOpportunityId ?? "").slice(0, 15);
    const queryBuilder = new (0, $9O2q1.QueryStringBuilder)().add("sfdc_opportunity_id", `eq."${opportunityId}"`);
    if (params?.creditBoxIds && params.creditBoxIds.length > 0) {
        const creditBoxIds = params.creditBoxIds.map((id)=>`"${id}"`).join(",");
        queryBuilder.add("credit_box_id", `in.(${creditBoxIds})`);
    }
    const queryString = queryBuilder.build();
    return api.get(`/deal-flow/v1/credit_boxes/results/details?${queryString}`);
});
const $9370b0cf5af96559$export$4c645135bc52394e = (0, $kkxkw.createQuery)(({ api: api })=>{
    return api.get(`/deal-flow/v1/credit_boxes?fund_id=eq."${(0, $dKUtl.HUM_FUND_ID)}"`).then((res)=>{
        return res.items;
    });
});

});


parcelRegister("1zFjz", function(module, exports) {

$parcel$export(module.exports, "downloadFile", () => $c39db382d82d4ced$export$bb3b75778e3e272);
function $c39db382d82d4ced$export$bb3b75778e3e272(url) {
    const link = document.createElement("a");
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

});



parcelRegister("gXZ39", function(module, exports) {

$parcel$export(module.exports, "default", () => $daff03ebb14be235$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("18L7n");
var $arjdk = parcelRequire("arjdk");
var $5Ttm9 = parcelRequire("5Ttm9");
parcelRequire("tL0U5");
var $7Y7Q4 = parcelRequire("7Y7Q4");
parcelRequire("jLMBL");
var $3qMBE = parcelRequire("3qMBE");
parcelRequire("5F6eO");
var $iKH9u = parcelRequire("iKH9u");

var $fvg8F = parcelRequire("fvg8F");
function $daff03ebb14be235$var$PublicProfile() {
    const { data: profile, isLoading: isLoading } = (0, $7Y7Q4.useApiQuery)((0, $iKH9u.getPublicProfile), {
        waitForSession: false
    });
    if (!profile && isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
        fullScreen: true
    });
    if (profile) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fvg8F.Profile).Content, {
        ...profile,
        isPrivate: false
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $arjdk.InlineNotification), {
        type: (0, $arjdk.NotificationType).WARNING,
        className: "translate-y-12",
        children: "There was an error fetching your data. Try refreshing the page or contacting support."
    });
}
var $daff03ebb14be235$export$2e2bcd8739ae039 = (0, $3qMBE.asPage)($daff03ebb14be235$var$PublicProfile, {
    testId: "public:profile-page",
    title: "Want to learn more? Log in or sign up to learn more about this opportunity",
    variant: "public"
});

});
parcelRegister("5F6eO", function(module, exports) {
$parcel$export(module.exports, "startProfileDownload", () => (parcelRequire("9poYF")).startProfileDownload);
$parcel$export(module.exports, "updateCompanyProfile", () => (parcelRequire("9poYF")).updateCompanyProfile);
$parcel$export(module.exports, "getPrivateProfile", () => (parcelRequire("iKH9u")).getPrivateProfile);
$parcel$export(module.exports, "getProfileDownloadStatus", () => (parcelRequire("iKH9u")).getProfileDownloadStatus);
$parcel$export(module.exports, "getPublicProfile", () => (parcelRequire("iKH9u")).getPublicProfile);
$parcel$export(module.exports, "useProfileDownloads", () => (parcelRequire("7QL9H")).useProfileDownloads);
$parcel$export(module.exports, "HighlightsIcons", () => (parcelRequire("lFiRI")).HighlightsIcons);
parcelRequire("9poYF");
parcelRequire("iKH9u");
parcelRequire("7QL9H");
parcelRequire("hHpQI");
parcelRequire("lFiRI");

});
parcelRegister("9poYF", function(module, exports) {

$parcel$export(module.exports, "updateCompanyProfile", () => $79569f2cf4f0b76b$export$56ae61deb9ec459);
$parcel$export(module.exports, "startProfileDownload", () => $79569f2cf4f0b76b$export$f93a3dac65a5f4bb);
parcelRequire("tL0U5");
var $gBHSi = parcelRequire("gBHSi");

var $iKH9u = parcelRequire("iKH9u");
parcelRequire("gCemA");
var $fjko4 = parcelRequire("fjko4");
const $79569f2cf4f0b76b$export$56ae61deb9ec459 = (0, $gBHSi.createMutation)(({ api: api, payload: payload, router: router })=>api.put(`/backend/v1/companies/${router.params.companyId}/teaser_profile`, {
        hero: {
            ...payload.hero,
            callouts: payload.hero?.callouts || []
        },
        financialHighlights: {
            title: payload.financialHighlights?.title,
            description: payload.financialHighlights?.description,
            lastUpdated: (0, $fjko4.isoDateFormat)(payload.financialHighlights?.month, payload.financialHighlights?.year),
            highlights: Object.values(payload.financialHighlights?.highlights || [])
        },
        showFilesSection: payload.downloads?.isVisible,
        filesSectionDescription: payload.downloads?.description
    }), {
    invalidates: [
        (0, $iKH9u.getPrivateProfile)
    ]
});
const $79569f2cf4f0b76b$export$f93a3dac65a5f4bb = (0, $gBHSi.createMutation)(({ api: api, payload: payload })=>api.post("/backend/v1/public_analytics_download_tasks", {
        token: payload.token
    }), {
    waitForSession: false
});

});
parcelRegister("iKH9u", function(module, exports) {

$parcel$export(module.exports, "getPublicProfile", () => $35b0ca84dc5bf13d$export$f5620da4d67300bb);
$parcel$export(module.exports, "getPrivateProfile", () => $35b0ca84dc5bf13d$export$563a1583f8c9ee49);
$parcel$export(module.exports, "getProfileDownloadStatus", () => $35b0ca84dc5bf13d$export$3d4fe2c5e70c0e48);
parcelRequire("i5Lss");
var $kkxkw = parcelRequire("kkxkw");
parcelRequire("gCemA");
var $fjko4 = parcelRequire("fjko4");

var $lFiRI = parcelRequire("lFiRI");
const $35b0ca84dc5bf13d$export$f5620da4d67300bb = (0, $kkxkw.createQuery)(({ api: api, router: router })=>api.get("/backend/v1/companies/public_teaser_profile", {
        headers: {
            Authorization: `Bearer ${router.params.token}`
        }
    }).then((res)=>{
        const month = res.financialHighlights.lastUpdated.split(" ")[0];
        const year = res.financialHighlights.lastUpdated.split(" ")[1];
        const isoLastUpdated = (0, $fjko4.isoDateFormat)(month, year);
        return {
            ...res,
            financialHighlights: {
                ...res.financialHighlights,
                month: month,
                year: year,
                lastUpdated: isoLastUpdated,
                highlights: res.financialHighlights.highlights.map((highlight)=>({
                        ...highlight,
                        title: (0, $lFiRI.HIGHLIGHT_LABELS)[highlight.title] ? (0, $lFiRI.HIGHLIGHT_LABELS)[highlight.title] : highlight.title
                    }))
            },
            downloads: {
                isVisible: res.showFilesSection,
                description: res.filesSectionDescription
            }
        };
    }));
const $35b0ca84dc5bf13d$export$563a1583f8c9ee49 = (0, $kkxkw.createQuery)(({ api: api, session: session, router: router, params: params })=>{
    const { user: user } = session;
    const isCompanyUser = user?.isCompany;
    const companyId = isCompanyUser ? user.organizationId : router.params.companyId ?? params.companyId;
    const apiVersion = isCompanyUser ? "v2" : "v1";
    const path = `/backend/${apiVersion}/companies/${companyId}/teaser_profile`;
    return api.get(path).then((res)=>{
        const month = res.financialHighlights.lastUpdated.split(" ")[0];
        const year = res.financialHighlights.lastUpdated.split(" ")[1];
        const isoLastUpdated = (0, $fjko4.isoDateFormat)(month, year);
        return {
            ...res,
            hero: {
                ...res.hero,
                privateDescription: res.hero.privateDescription || "",
                publicDescription: res.hero.publicDescription || ""
            },
            financialHighlights: {
                ...res.financialHighlights,
                description: res.financialHighlights.description || "",
                month: month,
                year: year,
                lastUpdated: isoLastUpdated,
                highlights: res.financialHighlights.highlights.map((highlight)=>({
                        ...highlight,
                        title: (0, $lFiRI.HIGHLIGHT_LABELS)[highlight.title] ? (0, $lFiRI.HIGHLIGHT_LABELS)[highlight.title] : highlight.title
                    }))
            },
            downloads: {
                isVisible: res.showFilesSection,
                description: res.filesSectionDescription || ""
            }
        };
    });
});
const $35b0ca84dc5bf13d$export$3d4fe2c5e70c0e48 = (0, $kkxkw.createQuery)(({ api: api, params: params })=>api.get(`/backend/v1/public_analytics_download_tasks/${params.taskId}`), {
    waitForSession: false
});

});
parcelRegister("lFiRI", function(module, exports) {

$parcel$export(module.exports, "HighlightsIcons", () => $bb33f75d313de107$export$f010ecfd1a295a48);
$parcel$export(module.exports, "HIGHLIGHT_LABELS", () => $bb33f75d313de107$export$9296adc4a28dce6a);
var $bb33f75d313de107$export$f010ecfd1a295a48;
(function(HighlightsIcons) {
    HighlightsIcons["BarChartUp"] = "BarChartUp";
    HighlightsIcons["LineChartUp"] = "LineChartUp";
    HighlightsIcons["Percent"] = "Percent";
    HighlightsIcons["Tag"] = "Tag";
    HighlightsIcons["CircleDollar"] = "CircleDollar";
    HighlightsIcons["DollarBill"] = "DollarBill";
})($bb33f75d313de107$export$f010ecfd1a295a48 || ($bb33f75d313de107$export$f010ecfd1a295a48 = {}));
const $bb33f75d313de107$export$9296adc4a28dce6a = {
    ltmRevenue: "LTM Revenue",
    lastMonthEBITDA: "Last Month EBITDA",
    yoyRevenueGrowth: "YoY Revenue Growth",
    ltmGrossMargin: "LTM Gross Margin",
    runRateRevenue: "Run Rate Revenue",
    qoqRevenueGrowth: "QoQ Revenue Growth",
    totalEquityRaised: "Total Equity Raised"
};

});



parcelRegister("7QL9H", function(module, exports) {

$parcel$export(module.exports, "useProfileDownloads", () => $6f0169627a413bf6$export$a192403aefb4ec7e);
parcelRequire("tL0U5");
var $4CoXh = parcelRequire("4CoXh");
var $ioTAq = parcelRequire("ioTAq");
parcelRequire("5F6eO");
var $iKH9u = parcelRequire("iKH9u");
var $9poYF = parcelRequire("9poYF");

var $cNbKI = parcelRequire("cNbKI");
parcelRequire("agk6G");
var $iIyrH = parcelRequire("iIyrH");
parcelRequire("a1Lcn");
var $2bkBK = parcelRequire("2bkBK");
const $6f0169627a413bf6$export$a192403aefb4ec7e = (token)=>{
    const { data: task, isPolling: isPolling, startPolling: startPolling, stopPolling: stopPolling, isError: isError } = (0, $ioTAq.useApiPolling)((0, $iKH9u.getProfileDownloadStatus), {
        onPollSuccess (data) {
            if (data?.state === (0, $iIyrH.BulkDownloadStatus).Failure) {
                stopPolling();
                (0, $cNbKI.datadogRum).addAction((0, $2bkBK.ddActions).profile.downloadChartbook.fail, {
                    company_token: token
                });
            }
            if (data?.fileUrl && data?.state === (0, $iIyrH.BulkDownloadStatus).Success) {
                stopPolling();
                (0, $cNbKI.datadogRum).addAction((0, $2bkBK.ddActions).profile.downloadChartbook.success, {
                    company_token: token
                });
                window.location.assign(data.fileUrl);
            }
        }
    });
    const { mutate: startDownload } = (0, $4CoXh.useApiMutation)((0, $9poYF.startProfileDownload), {
        onSuccess (data) {
            if (data.taskId) {
                startPolling(data);
                (0, $cNbKI.datadogRum).addAction((0, $2bkBK.ddActions).profile.downloadChartbook.start, {
                    company_token: token
                });
            }
        }
    });
    return {
        task: task,
        isPolling: isPolling,
        startDownload: ()=>startDownload({
                token: token
            }),
        stopDownload: stopPolling,
        isError: isError
    };
};

});
parcelRegister("agk6G", function(module, exports) {
$parcel$export(module.exports, "getCompany", () => (parcelRequire("kTlwO")).getCompany);
$parcel$export(module.exports, "getCompanyConnectors", () => (parcelRequire("kTlwO")).getCompanyConnectors);
$parcel$export(module.exports, "searchCompanies", () => (parcelRequire("kTlwO")).searchCompanies);
$parcel$export(module.exports, "ConnectorStatus", () => (parcelRequire("eRTY4")).ConnectorStatus);
$parcel$export(module.exports, "PlatformType", () => (parcelRequire("eRTY4")).PlatformType);
$parcel$export(module.exports, "BulkDownloadStatus", () => (parcelRequire("iIyrH")).BulkDownloadStatus);
$parcel$export(module.exports, "OnboardingStatus", () => (parcelRequire("iIyrH")).OnboardingStatus);
$parcel$export(module.exports, "CompanySearchModal", () => (parcelRequire("6OXDw")).CompanySearchModal);
$parcel$export(module.exports, "acceptCompanyAgreements", () => (parcelRequire("hovjT")).acceptCompanyAgreements);
$parcel$export(module.exports, "acceptCompanyMNDA", () => (parcelRequire("hovjT")).acceptCompanyMNDA);
$parcel$export(module.exports, "createCompany", () => (parcelRequire("hovjT")).createCompany);
$parcel$export(module.exports, "updateCompany", () => (parcelRequire("hovjT")).updateCompany);
parcelRequire("kTlwO");
parcelRequire("eRTY4");
parcelRequire("iIyrH");
parcelRequire("6OXDw");
parcelRequire("hovjT");

});
parcelRegister("kTlwO", function(module, exports) {

$parcel$export(module.exports, "getCompany", () => $6a044c1a1c1c0e4f$export$3fb7e631d185ccd8);
$parcel$export(module.exports, "searchCompanies", () => $6a044c1a1c1c0e4f$export$9776722762f4c5a8);
$parcel$export(module.exports, "getCompanyFiles", () => $6a044c1a1c1c0e4f$export$a99430eafbbd7291);
$parcel$export(module.exports, "getCompanyFile", () => $6a044c1a1c1c0e4f$export$247a54df1a3e7d50);
$parcel$export(module.exports, "getCompanyConnectors", () => $6a044c1a1c1c0e4f$export$c039f525fd187b9);
parcelRequire("i5Lss");
var $kkxkw = parcelRequire("kkxkw");
const $6a044c1a1c1c0e4f$export$3fb7e631d185ccd8 = (0, $kkxkw.createQuery)(({ api: api, router: router, params: params, session: session })=>{
    const companyId = params?.uuid || router.params.companyUUID || router.params.companyId || session.user?.organizationId;
    return api.get(`/backend/v2/companies/${companyId}`);
});
const $6a044c1a1c1c0e4f$export$9776722762f4c5a8 = (0, $kkxkw.createQuery)(({ api: api, params: params })=>{
    const page = params.page || 1;
    const pageSize = params.pageSize || 10;
    return api.get(`/backend/companies/search?order=updated_at&q=${params.query}&page=${page}&num_pages=1&page_size=${pageSize}&company_type=company`).then((res)=>({
            results: res.results,
            pagination: res.pagination
        }));
});
const $6a044c1a1c1c0e4f$export$a99430eafbbd7291 = (0, $kkxkw.createQuery)(({ api: api, params: params, router: router, session: session })=>{
    const companyId = params?.uuid || router.params.companyUUID || session.user?.organizationId;
    return api.get(`/backend/v2/companies/${companyId}/files`).then((res)=>res);
});
const $6a044c1a1c1c0e4f$export$247a54df1a3e7d50 = (0, $kkxkw.createQuery)(({ api: api, params: params, router: router, session: session })=>{
    const companyId = params?.uuid || router.params.companyUUID || session.user?.organizationId;
    return api.get(`/backend/v2/companies/${companyId}/files/${params.fileId}/download`).then((res)=>({
            ...res,
            download: res.downloadUrl
        }));
});
const $6a044c1a1c1c0e4f$export$c039f525fd187b9 = (0, $kkxkw.createQuery)(({ api: api, params: params, router: router, session: session })=>{
    const companyId = params?.uuid || router.params.companyUUID || session.user?.organizationId;
    return api.get(`/backend/v2/companies/${companyId}/connectors`, {
        params: params
    });
});

});

parcelRegister("eRTY4", function(module, exports) {

$parcel$export(module.exports, "ConnectorStatus", () => $169971195170c961$export$a33e207089c31960);
$parcel$export(module.exports, "PlatformType", () => $169971195170c961$export$46aeff19cbe52427);
var $169971195170c961$var$ConnectorSource;
(function(ConnectorSource) {
    ConnectorSource["Capital"] = "capital";
    ConnectorSource["Codat"] = "codat";
})($169971195170c961$var$ConnectorSource || ($169971195170c961$var$ConnectorSource = {}));
var $169971195170c961$var$ConnectorType;
(function(ConnectorType) {
    ConnectorType["Affirm"] = "affirm";
    ConnectorType["AgileCRM"] = "agilecrm";
    ConnectorType["AuthorizeNet"] = "authorizenet";
    ConnectorType["Billomat"] = "billomat";
    ConnectorType["BrainTree"] = "braintree";
    ConnectorType["CheckBook"] = "checkbook";
    ConnectorType["ClearBooks"] = "clearbooks";
    ConnectorType["CompanyHub"] = "companyhub";
    ConnectorType["Enigma"] = "enigma";
    ConnectorType["Exact"] = "exact";
    ConnectorType["FastBill"] = "fastbill";
    ConnectorType["Finch"] = "finch";
    ConnectorType["FreshBooks"] = "freshbooks";
    ConnectorType["GoogleAdSense"] = "google_adsense";
    ConnectorType["GoogleAnalytics"] = "google_analytics";
    ConnectorType["Holded"] = "holded";
    ConnectorType["Kizen"] = "kizen";
    ConnectorType["Klarna"] = "klarna";
    ConnectorType["LiftOff"] = "liftoff";
    ConnectorType["MailChimp"] = "mailchimp";
    ConnectorType["MicrosoftDynamics"] = "microsoft_dynamics";
    ConnectorType["MixPanel"] = "mixpanel";
    ConnectorType["Mx"] = "mx";
    ConnectorType["NetSuite"] = "netsuite";
    ConnectorType["Nimble"] = "nimble";
    ConnectorType["PayPal"] = "paypal";
    ConnectorType["PayWhirl"] = "paywhirl";
    ConnectorType["Plaid"] = "plaid";
    ConnectorType["QuickBooks"] = "quickbooks";
    ConnectorType["QuickBooksDesktop"] = "quickbooks_desktop";
    ConnectorType["QuickBooksSandbox"] = "quickbooks_sandbox";
    ConnectorType["Recurly"] = "recurly";
    ConnectorType["RevCent"] = "revcent";
    ConnectorType["Shopify"] = "shopify";
    ConnectorType["Square"] = "square";
    ConnectorType["StoreHippo"] = "storehippo";
    ConnectorType["Stripe"] = "stripe";
    ConnectorType["StripeTest"] = "stripe_test";
    ConnectorType["Swell"] = "swell";
    ConnectorType["Test"] = "test";
    ConnectorType["ThreeDCart"] = "threedcart";
    ConnectorType["UploadedFile"] = "uploaded_file";
    ConnectorType["WorldPay"] = "worldpay";
    ConnectorType["XCart"] = "xcart";
    ConnectorType["Xero"] = "xero";
    ConnectorType["Yodlee"] = "yodlee";
})($169971195170c961$var$ConnectorType || ($169971195170c961$var$ConnectorType = {}));
var $169971195170c961$var$ConnectorHealthStatus;
(function(ConnectorHealthStatus) {
    ConnectorHealthStatus["Pending"] = "pending";
    ConnectorHealthStatus["InitialPullInProgress"] = "initial_pull_in_progress";
    ConnectorHealthStatus["PullInProgress"] = "pull_in_progress";
    ConnectorHealthStatus["Critical"] = "critical";
    ConnectorHealthStatus["Recovering"] = "recovering";
    ConnectorHealthStatus["Healthy"] = "healthy";
    ConnectorHealthStatus["Stale"] = "stale";
})($169971195170c961$var$ConnectorHealthStatus || ($169971195170c961$var$ConnectorHealthStatus = {}));
var $169971195170c961$export$a33e207089c31960;
(function(ConnectorStatus) {
    ConnectorStatus["Active"] = "active";
    ConnectorStatus["Pending"] = "pending";
    ConnectorStatus["Disconnected"] = "disconnected";
    ConnectorStatus["Deauthorized"] = "deauthorized";
    ConnectorStatus["Authenticating"] = "authenticating";
})($169971195170c961$export$a33e207089c31960 || ($169971195170c961$export$a33e207089c31960 = {}));
var $169971195170c961$export$46aeff19cbe52427;
(function(PlatformType) {
    PlatformType["BANK"] = "bank";
    PlatformType["ACCOUTING"] = "accounting_system";
    PlatformType["PAYMENTS"] = "payment_processor";
})($169971195170c961$export$46aeff19cbe52427 || ($169971195170c961$export$46aeff19cbe52427 = {}));

});

parcelRegister("iIyrH", function(module, exports) {

$parcel$export(module.exports, "BulkDownloadStatus", () => $a9ef4730471cef3b$export$bcec647bfaad7305);
$parcel$export(module.exports, "BUSINESS_TYPES", () => $a9ef4730471cef3b$export$a2b7e44451145864);
$parcel$export(module.exports, "OnboardingStatus", () => $a9ef4730471cef3b$export$bcc3ec789deb1f8c);
$parcel$export(module.exports, "CompanyFileDocumentType", () => $a9ef4730471cef3b$export$26e35f369551e9f5);
var $a9ef4730471cef3b$export$97fd21cceb1e64f3;
(function(CompanyType) {
    CompanyType["Admin"] = "admin";
    CompanyType["Investor"] = "investor";
    CompanyType["SyndicationInvestor"] = "syndication_investor";
    CompanyType["Company"] = "company";
    CompanyType["BalanceSheetPartner"] = "balance_sheet_partner";
})($a9ef4730471cef3b$export$97fd21cceb1e64f3 || ($a9ef4730471cef3b$export$97fd21cceb1e64f3 = {}));
var $a9ef4730471cef3b$export$ccf8bf0415aabfdf;
(function(ActivationStatus) {
    ActivationStatus["ReadyForSyndication"] = "ready_for_syndication";
    ActivationStatus["NotReadyForSyndication"] = "not_ready_for_syndication";
})($a9ef4730471cef3b$export$ccf8bf0415aabfdf || ($a9ef4730471cef3b$export$ccf8bf0415aabfdf = {}));
var $a9ef4730471cef3b$export$f60fb7c78c4caf5e;
(function(CompanySegment) {
    CompanySegment["Mice"] = "mice";
    CompanySegment["Boar"] = "boar";
    CompanySegment["Whale"] = "whale";
})($a9ef4730471cef3b$export$f60fb7c78c4caf5e || ($a9ef4730471cef3b$export$f60fb7c78c4caf5e = {}));
var $a9ef4730471cef3b$export$782fcf195ce14bdf;
(function(CompanyContactStatus) {
    CompanyContactStatus["Active"] = "active";
    CompanyContactStatus["Invited"] = "invited";
    CompanyContactStatus["Disabled"] = "disabled";
})($a9ef4730471cef3b$export$782fcf195ce14bdf || ($a9ef4730471cef3b$export$782fcf195ce14bdf = {}));
var $a9ef4730471cef3b$export$a3acfd60e8d43cae;
(function(CompanyAnalyticsStatus) {
    CompanyAnalyticsStatus["pending"] = "pending";
    CompanyAnalyticsStatus["critical"] = "critical";
    CompanyAnalyticsStatus["needsLabeling"] = "needs_labeling";
    CompanyAnalyticsStatus["analyticsRegression"] = "regression";
    CompanyAnalyticsStatus["analyticsStale"] = "analytics_stale";
    CompanyAnalyticsStatus["dataStale"] = "data_stale";
    CompanyAnalyticsStatus["healthy"] = "healthy";
    CompanyAnalyticsStatus["recovering"] = "recovering";
    CompanyAnalyticsStatus["waitingForData"] = "waiting_for_data";
})($a9ef4730471cef3b$export$a3acfd60e8d43cae || ($a9ef4730471cef3b$export$a3acfd60e8d43cae = {}));
var $a9ef4730471cef3b$export$bcec647bfaad7305;
(function(BulkDownloadStatus) {
    BulkDownloadStatus["Fake"] = "FAKE";
    BulkDownloadStatus["Started"] = "STARTED";
    BulkDownloadStatus["Pending"] = "PENDING";
    BulkDownloadStatus["Progress"] = "PROGRESS";
    BulkDownloadStatus["Success"] = "SUCCESS";
    BulkDownloadStatus["Failure"] = "FAILURE";
    BulkDownloadStatus["Revoked"] = "REVOKED";
})($a9ef4730471cef3b$export$bcec647bfaad7305 || ($a9ef4730471cef3b$export$bcec647bfaad7305 = {}));
var $a9ef4730471cef3b$export$23014ea746dc1f96;
(function(BusinessType) {
    BusinessType["ConsumerProducts"] = "consumer_products";
    BusinessType["ConsumerFinance"] = "consumer_finance";
    BusinessType["App"] = "app";
    BusinessType["Retail"] = "retail";
    BusinessType["Services"] = "services";
    BusinessType["SaasPositiveChurn"] = "saas_positive_churn";
    BusinessType["SaasNegativeChurn"] = "saas_negative_churn";
    BusinessType["CommercialFinance"] = "commercial_finance";
    BusinessType["Subscriptions"] = "subscriptions";
    BusinessType["Other"] = "other";
    BusinessType["Manufacturer"] = "manufacturer";
    BusinessType["Media"] = "media";
    BusinessType["Marketplace"] = "marketplace";
    BusinessType["Gaming"] = "gaming";
    BusinessType["ECommerce"] = "e_commerce";
    BusinessType["Health"] = "health";
    BusinessType["HealthIT"] = "health_it";
})($a9ef4730471cef3b$export$23014ea746dc1f96 || ($a9ef4730471cef3b$export$23014ea746dc1f96 = {}));
const $a9ef4730471cef3b$export$a2b7e44451145864 = {
    ["consumer_products"]: "Consumer Product",
    ["consumer_finance"]: "Consumer Finance",
    ["app"]: "Mobile App",
    ["retail"]: "Retail or distribution",
    ["services"]: "Service",
    ["saas_positive_churn"]: "SaaS",
    ["commercial_finance"]: "Specialty finance or lending",
    ["subscriptions"]: "Subscription",
    ["other"]: "Other",
    ["manufacturer"]: "Manufacturer",
    ["media"]: "Media",
    ["marketplace"]: "Marketplace",
    ["gaming"]: "Gaming",
    ["e_commerce"]: "E-Commerce",
    ["health"]: "Health",
    ["health_it"]: "Health IT"
};
var $a9ef4730471cef3b$export$bcc3ec789deb1f8c;
(function(OnboardingStatus) {
    OnboardingStatus[OnboardingStatus["VERIFY_EMAIL"] = 0] = "VERIFY_EMAIL";
    OnboardingStatus[OnboardingStatus["BASIC_INFO"] = 1] = "BASIC_INFO";
    OnboardingStatus[OnboardingStatus["ABOUT_YOUR_BUSINESS"] = 2] = "ABOUT_YOUR_BUSINESS";
    OnboardingStatus[OnboardingStatus["UNSUPPORTED_COUNTRY"] = 3] = "UNSUPPORTED_COUNTRY";
    OnboardingStatus[OnboardingStatus["SHARE_YOUR_GOALS"] = 4] = "SHARE_YOUR_GOALS";
    OnboardingStatus[OnboardingStatus["FUNDRAISING_HISTORY"] = 5] = "FUNDRAISING_HISTORY";
    OnboardingStatus[OnboardingStatus["MNDA"] = 6] = "MNDA";
    OnboardingStatus[OnboardingStatus["DATAROOM"] = 7] = "DATAROOM";
    OnboardingStatus[OnboardingStatus["COMPLETE"] = 8] = "COMPLETE";
})($a9ef4730471cef3b$export$bcc3ec789deb1f8c || ($a9ef4730471cef3b$export$bcc3ec789deb1f8c = {}));
var $a9ef4730471cef3b$export$26e35f369551e9f5;
(function(CompanyFileDocumentType) {
    CompanyFileDocumentType["Other"] = "other";
    CompanyFileDocumentType["TermSheet"] = "term_sheet";
    CompanyFileDocumentType["Loan"] = "loan";
    CompanyFileDocumentType["IncomeStatement"] = "income_statement";
    CompanyFileDocumentType["BalanceSheet"] = "balance_sheet";
    CompanyFileDocumentType["CustomerTape"] = "customer_tape";
    CompanyFileDocumentType["CashFlowStatement"] = "cash_flow_statement";
    CompanyFileDocumentType["LogoCompany"] = "logo_company";
    CompanyFileDocumentType["CapTable"] = "cap_table";
    CompanyFileDocumentType["FinancialStatementMapping"] = "financial_statement_mapping";
    CompanyFileDocumentType["CapitalMachineModelOutput"] = "capital_machine_model_output";
    CompanyFileDocumentType["DocusignMnda"] = "docusign_mnda";
    CompanyFileDocumentType["CompanyMnda"] = "company_mnda";
    CompanyFileDocumentType["CleanedIncomeStatement"] = "cleaned_income_statement";
    CompanyFileDocumentType["CleanedBalanceSheet"] = "cleaned_balance_sheet";
    CompanyFileDocumentType["CleanedCustomerTransactions"] = "cleaned_customer_tape";
    CompanyFileDocumentType["FinancialSummary"] = "financial_summary";
    CompanyFileDocumentType["PorfolioMonitoringImportSource"] = "porfolio_monitoring_import_source";
    CompanyFileDocumentType["OutOfFeeProof"] = "out_of_fee_proof";
    CompanyFileDocumentType["SyndicationLegalAgreement"] = "syndication_legal_agreement";
    CompanyFileDocumentType["BusinessOverviewDeck"] = "business_overview_deck";
    CompanyFileDocumentType["FeeAgreement"] = "fee_tos_agreement";
    CompanyFileDocumentType["ChartbookInvestorAnalytics"] = "chartbook_investor_analytics";
})($a9ef4730471cef3b$export$26e35f369551e9f5 || ($a9ef4730471cef3b$export$26e35f369551e9f5 = {}));
var $a9ef4730471cef3b$export$c0d3d383dd22c384;
(function(FileStatus) {
    FileStatus["AwaitingUpload"] = "awaiting_upload";
    FileStatus["Success"] = "success";
    FileStatus["Failed"] = "failed";
    FileStatus["Pending"] = "pending";
    FileStatus["Processing"] = "processing";
})($a9ef4730471cef3b$export$c0d3d383dd22c384 || ($a9ef4730471cef3b$export$c0d3d383dd22c384 = {}));

});

parcelRegister("6OXDw", function(module, exports) {

$parcel$export(module.exports, "CompanySearchModal", () => $8609fa2eee4e0755$export$1a18084d025a3c11);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("tL0U5");
var $7Y7Q4 = parcelRequire("7Y7Q4");
parcelRequire("18L7n");
var $dtQ0k = parcelRequire("dtQ0k");
var $41p3a = parcelRequire("41p3a");
var $lkwlf = parcelRequire("lkwlf");
parcelRequire("agk6G");
var $kTlwO = parcelRequire("kTlwO");

var $acw62 = parcelRequire("acw62");
parcelRequire("gCemA");
var $3ubHA = parcelRequire("3ubHA");
const $8609fa2eee4e0755$export$1a18084d025a3c11 = ({ isOpen: isOpen, onCancel: onCancel, onSelect: onSelect })=>{
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const [selectedCompany, setSelectedCompany] = (0, $acw62.useState)(null);
    const { data: companies, isLoading: isLoading, isError: isError } = (0, $7Y7Q4.useApiQuery)((0, $kTlwO.searchCompanies), {
        params: {
            query: searchTerm
        }
    });
    const debouncedSearch = (0, $3ubHA.useDebounce)((newSearchTerm)=>{
        setSearchTerm(newSearchTerm);
    }, 500);
    const handleCancel = ()=>{
        setSelectedCompany(null);
        setSearchTerm("");
        onCancel();
    };
    const handleSelect = (companyId)=>{
        setSelectedCompany(null);
        onSelect(companyId);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dtQ0k.Modal), {
        isOpen: isOpen,
        className: "w-[702px]",
        withTransitions: true,
        testId: "modal:company-search",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-8",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lkwlf.Search).Header, {
                        title: "Create a New Deal",
                        description: "To select a company search, or scroll below...",
                        children: [
                            isError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkwlf.Search).Error, {}),
                            isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkwlf.Search).Loading, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkwlf.Search).Bar, {
                        placeholder: "Search",
                        searchHandler: (value)=>debouncedSearch(value),
                        useV2Background: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkwlf.Search).Results, {
                        className: "bg-secondary",
                        children: companies?.results.map((company)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkwlf.Search).RadioResult, {
                                id: company.id,
                                name: company.name,
                                onChange: ()=>setSelectedCompany(company.id)
                            }, company.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $41p3a.ModalFooter), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "secondary",
                        onClick: handleCancel,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        disabled: !selectedCompany,
                        onClick: ()=>handleSelect(selectedCompany),
                        children: "Next"
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("hovjT", function(module, exports) {

$parcel$export(module.exports, "createCompany", () => $956729a72ac587f4$export$f2d57252ac812dcc);
$parcel$export(module.exports, "acceptCompanyAgreements", () => $956729a72ac587f4$export$b61691a8f64fafd4);
$parcel$export(module.exports, "updateCompany", () => $956729a72ac587f4$export$50f0ed8944cb1d90);
$parcel$export(module.exports, "acceptCompanyMNDA", () => $956729a72ac587f4$export$d5293078e0c83250);
parcelRequire("tL0U5");
var $gBHSi = parcelRequire("gBHSi");
const $956729a72ac587f4$export$f2d57252ac812dcc = (0, $gBHSi.createMutation)(({ api: api, payload: payload })=>{
    return api.post(`/backend/v2/companies`, payload);
}, {
    mutationKey: [
        "createCompany"
    ],
    invalidates: [
        "/companies"
    ]
});
const $956729a72ac587f4$export$b61691a8f64fafd4 = (0, $gBHSi.createMutation)(({ api: api, payload: payload })=>{
    return api.post(`/backend/v2/companies/${payload.organizationId}/accept_agreements`, {});
}, {
    mutationKey: [
        "acceptCompanyAgreements"
    ],
    invalidates: [
        "/companies"
    ]
});
const $956729a72ac587f4$export$50f0ed8944cb1d90 = (0, $gBHSi.createMutation)(({ api: api, payload: payload, session: session })=>{
    return api.patch(`/backend/v2/companies/${session.user?.organizationId}`, payload);
}, {
    mutationKey: [
        "updateCompany"
    ],
    errorToast: {
        message: "Failed to update company"
    },
    invalidates: [
        "/companies"
    ]
});
const $956729a72ac587f4$export$d5293078e0c83250 = (0, $gBHSi.createMutation)(({ api: api, payload: payload, session: session })=>{
    return api.post(`/backend/v2/companies/${session.user?.organizationId}/onboarding/mnda`, {
        firstName: payload.firstName,
        lastName: payload.lastName,
        role: payload.position
    });
}, {
    mutationKey: [
        "acceptCompanyMNDA"
    ],
    errorToast: {
        message: "Failed to sign MNDA"
    },
    invalidates: [
        "/companies"
    ]
});

});



parcelRegister("hHpQI", function(module, exports) {

});


parcelRegister("fvg8F", function(module, exports) {

$parcel$export(module.exports, "Profile", () => $8b58a13d57f3244b$export$5120f2d0b8d4cab8);

var $cAQBO = parcelRequire("cAQBO");

var $1250S = parcelRequire("1250S");

var $9gPHX = parcelRequire("9gPHX");

var $56hIS = parcelRequire("56hIS");

var $7ekv1 = parcelRequire("7ekv1");

var $bLW1O = parcelRequire("bLW1O");

var $l48UL = parcelRequire("l48UL");

var $j9a2k = parcelRequire("j9a2k");

var $hLr2d = parcelRequire("hLr2d");

var $70FMy = parcelRequire("70FMy");

var $k12C0 = parcelRequire("k12C0");

var $ioVhG = parcelRequire("ioVhG");

var $cBGHr = parcelRequire("cBGHr");
const $8b58a13d57f3244b$export$5120f2d0b8d4cab8 = {
    Hero: $9gPHX.Hero,
    HeroForm: $56hIS.HeroForm,
    DownloadsForm: $j9a2k.DownloadsForm,
    Downloads: $hLr2d.Downloads,
    Dataroom: $cBGHr.Dataroom,
    FinancialHighlights: $cAQBO.FinancialHighlights,
    FinancialHighlightsForm: $l48UL.FinancialHighlightsForm,
    Footer: $1250S.Footer,
    Content: $70FMy.Content,
    OpportunityCTA: $7ekv1.OpportunityCTA,
    LinkCTA: $k12C0.LinkCTA,
    Controls: $bLW1O.Controls,
    PrivacyToggle: $ioVhG.PrivacyToggle
};

});
parcelRegister("cAQBO", function(module, exports) {

$parcel$export(module.exports, "FinancialHighlights", () => $b846d810f9864dd2$export$f9f5f42292f2fe4d);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5F6eO");
var $lFiRI = parcelRequire("lFiRI");
parcelRequire("18L7n");
var $hUCih = parcelRequire("hUCih");
var $7i7mP = parcelRequire("7i7mP");
var $eSDZU = parcelRequire("eSDZU");

var $9QePP = parcelRequire("9QePP");
const $b846d810f9864dd2$var$iconMappings = {
    [(0, $lFiRI.HighlightsIcons).BarChartUp]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).BarChartup, {}),
    [(0, $lFiRI.HighlightsIcons).LineChartUp]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).LineChartup, {}),
    [(0, $lFiRI.HighlightsIcons).Percent]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).Percent, {}),
    [(0, $lFiRI.HighlightsIcons).Tag]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).Tag, {}),
    [(0, $lFiRI.HighlightsIcons).CircleDollar]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).CircleDollar, {}),
    [(0, $lFiRI.HighlightsIcons).DollarBill]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).DollarBill, {})
};
const $b846d810f9864dd2$export$f9f5f42292f2fe4d = ({ title: title, description: description, month: month, year: year, highlights: highlights })=>{
    return Object.keys(highlights || []).length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7i7mP.Section), {
        title: title,
        secondaryBg: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "body-s -mt-6 mb-8",
                children: [
                    "Last updated: ",
                    month,
                    " ",
                    year
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "body-m mt-2",
                children: description
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("mt-10", "grid grid-cols-1", "gap-4", "md:grid-cols-3"),
                children: Object.values(highlights || []).map(({ icon: icon, title: title, value: value }, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $eSDZU.StatBox), {
                        icon: $b846d810f9864dd2$var$iconMappings[icon],
                        title: title,
                        value: value
                    }, `${title}-${index}`))
            })
        ]
    }) : null;
};

});

parcelRegister("1250S", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $e7e84cd5298ac45f$export$a06f1c675e846f6f);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("gCemA");
var $2bkBK = parcelRequire("2bkBK");
parcelRequire("18L7n");
var $7i7mP = parcelRequire("7i7mP");

var $9QePP = parcelRequire("9QePP");
const $e7e84cd5298ac45f$export$a06f1c675e846f6f = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7i7mP.Section), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "body-micro subdued",
                children: [
                    "Securities are offered through ICM Capital Markets, LLC, Member FINRA/SIPC. Find out more about us on",
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: "https://brokercheck.finra.org/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "ui-link text-bodyMicoSize",
                        "dd-action": (0, $2bkBK.ddActions).profile.footer.finra,
                        children: "FINRA's Brokercheck website."
                    }),
                    " ",
                    "The information summarized on this page represents the views of Hum Capital at this time; its views may change without notice. The information presented herein may not be accurate or complete. This information does not constitute an offer to sell or a solicitation to buy any securities. By clicking the Explore this opportunity button below, you acknowledge this disclaimer and agree to keep this information strictly confidential."
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("mt-10 pb-10", "flex items-center justify-center"),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: (0, $9QePP.default)("my-2", "text-center text-white", "body-s subdued"),
                            children: "Have a question?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "body-s subdued flex items-center gap-1 text-center",
                            children: [
                                "Check out our",
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: "https://info.humcapital.com/hum-help-center",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "ui-link",
                                    "dd-action": (0, $2bkBK.ddActions).profile.footer.help,
                                    children: "Help Center"
                                }),
                                " ",
                                "or",
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: "mailto:hum-an@humcapital.com",
                                    className: "ui-link",
                                    "dd-action": (0, $2bkBK.ddActions).profile.footer.contact,
                                    children: "Contact Hum"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("9gPHX", function(module, exports) {

$parcel$export(module.exports, "Hero", () => $c5a8ec55b3354e50$export$887967f05dc521ae);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("18L7n");
var $7i7mP = parcelRequire("7i7mP");
var $eSDZU = parcelRequire("eSDZU");

var $ijsy9 = parcelRequire("ijsy9");

var $9QePP = parcelRequire("9QePP");

var $i8Fxz = parcelRequire("i8Fxz");
const $c5a8ec55b3354e50$export$887967f05dc521ae = ({ publicHeadline: publicHeadline, publicDescription: publicDescription, privateHeadline: privateHeadline, privateDescription: privateDescription, disclaimer: disclaimer, callouts: callouts, isPrivate: isPrivate })=>{
    const description = isPrivate ? (0, $ijsy9.marked).parse(privateDescription || "") : (0, $ijsy9.marked).parse(publicDescription || "");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7i7mP.Section), {
        title: isPrivate ? privateHeadline : publicHeadline,
        className: "pb-0",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-8 lg:mt-8",
                children: [
                    description && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "profile-description",
                        dangerouslySetInnerHTML: {
                            __html: (0, $i8Fxz.sanitize)(description)
                        }
                    }),
                    disclaimer && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-micro subdued",
                        children: disclaimer
                    })
                ]
            }),
            callouts && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("my-10", "flex flex-col flex-wrap", "gap-5", "md:flex-row"),
                children: Object.values(callouts).map(({ title: title, value: value })=>value !== "" && title !== "" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eSDZU.StatBox), {
                        className: "px-0",
                        secondary: true,
                        title: title,
                        value: value,
                        truncate: false
                    }, title))
            })
        ]
    });
};

});
parcelRegister("ijsy9", function(module, exports) {
/**
 * marked v16.0.0 - a markdown parser
 * Copyright (c) 2011-2025, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(g, f) {
    module.exports = f();
})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : module.exports, function() {
    var exports = {};
    var __exports = exports;
    var module1 = {
        exports: exports
    };
    "use strict";
    var H = Object.defineProperty;
    var be = Object.getOwnPropertyDescriptor;
    var Te = Object.getOwnPropertyNames;
    var we = Object.prototype.hasOwnProperty;
    var ye = (l, e)=>{
        for(var t in e)H(l, t, {
            get: e[t],
            enumerable: !0
        });
    }, Re = (l, e, t, n)=>{
        if (e && typeof e == "object" || typeof e == "function") for (let s of Te(e))!we.call(l, s) && s !== t && H(l, s, {
            get: ()=>e[s],
            enumerable: !(n = be(e, s)) || n.enumerable
        });
        return l;
    };
    var Se = (l)=>Re(H({}, "__esModule", {
            value: !0
        }), l);
    var kt = {};
    ye(kt, {
        Hooks: ()=>L,
        Lexer: ()=>x,
        Marked: ()=>E,
        Parser: ()=>b,
        Renderer: ()=>$,
        TextRenderer: ()=>_,
        Tokenizer: ()=>S,
        defaults: ()=>w,
        getDefaults: ()=>z,
        lexer: ()=>ht,
        marked: ()=>k,
        options: ()=>it,
        parse: ()=>pt,
        parseInline: ()=>ct,
        parser: ()=>ut,
        setOptions: ()=>ot,
        use: ()=>lt,
        walkTokens: ()=>at
    });
    module1.exports = Se(kt);
    function z() {
        return {
            async: !1,
            breaks: !1,
            extensions: null,
            gfm: !0,
            hooks: null,
            pedantic: !1,
            renderer: null,
            silent: !1,
            tokenizer: null,
            walkTokens: null
        };
    }
    var w = z();
    function N(l) {
        w = l;
    }
    var I = {
        exec: ()=>null
    };
    function h(l, e = "") {
        let t = typeof l == "string" ? l : l.source, n = {
            replace: (s, i)=>{
                let r = typeof i == "string" ? i : i.source;
                return r = r.replace(m.caret, "$1"), t = t.replace(s, r), n;
            },
            getRegex: ()=>new RegExp(t, e)
        };
        return n;
    }
    var m = {
        codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
        outputLinkReplace: /\\([\[\]])/g,
        indentCodeCompensation: /^(\s+)(?:```)/,
        beginningSpace: /^\s+/,
        endingHash: /#$/,
        startingSpaceChar: /^ /,
        endingSpaceChar: / $/,
        nonSpaceChar: /[^ ]/,
        newLineCharGlobal: /\n/g,
        tabCharGlobal: /\t/g,
        multipleSpaceGlobal: /\s+/g,
        blankLine: /^[ \t]*$/,
        doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
        blockquoteStart: /^ {0,3}>/,
        blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
        blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
        listReplaceTabs: /^\t+/,
        listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
        listIsTask: /^\[[ xX]\] /,
        listReplaceTask: /^\[[ xX]\] +/,
        anyLine: /\n.*\n/,
        hrefBrackets: /^<(.*)>$/,
        tableDelimiter: /[:|]/,
        tableAlignChars: /^\||\| *$/g,
        tableRowBlankLine: /\n[ \t]*$/,
        tableAlignRight: /^ *-+: *$/,
        tableAlignCenter: /^ *:-+: *$/,
        tableAlignLeft: /^ *:-+ *$/,
        startATag: /^<a /i,
        endATag: /^<\/a>/i,
        startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
        endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
        startAngleBracket: /^</,
        endAngleBracket: />$/,
        pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
        unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
        escapeTest: /[&<>"']/,
        escapeReplace: /[&<>"']/g,
        escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
        escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
        unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
        caret: /(^|[^\[])\^/g,
        percentDecode: /%25/g,
        findPipe: /\|/g,
        splitPipe: / \|/,
        slashPipe: /\\\|/g,
        carriageReturn: /\r\n|\r/g,
        spaceLine: /^ +$/gm,
        notSpaceStart: /^\S*/,
        endingNewline: /\n$/,
        listItemRegex: (l)=>new RegExp(`^( {0,3}${l})((?:[	 ][^\\n]*)?(?:\\n|$))`),
        nextBulletRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
        hrRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
        fencesBeginRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}(?:\`\`\`|~~~)`),
        headingBeginRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}#`),
        htmlBeginRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}<(?:[a-z].*>|!--)`, "i")
    }, $e = /^(?:[ \t]*(?:\n|$))+/, _e = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, Le = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, O = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, ze = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, F = /(?:[*+-]|\d{1,9}[.)])/, ie = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, oe = h(ie).replace(/bull/g, F).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), Me = h(ie).replace(/bull/g, F).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), Q = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, Pe = /^[^\n]+/, U = /(?!\s*\])(?:\\.|[^\[\]\\])+/, Ae = h(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", U).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), Ee = h(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, F).getRegex(), v = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", K = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, Ce = h("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", K).replace("tag", v).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), le = h(Q).replace("hr", O).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", v).getRegex(), Ie = h(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", le).getRegex(), X = {
        blockquote: Ie,
        code: _e,
        def: Ae,
        fences: Le,
        heading: ze,
        hr: O,
        html: Ce,
        lheading: oe,
        list: Ee,
        newline: $e,
        paragraph: le,
        table: I,
        text: Pe
    }, re = h("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", O).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", v).getRegex(), Oe = {
        ...X,
        lheading: Me,
        table: re,
        paragraph: h(Q).replace("hr", O).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", re).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", v).getRegex()
    }, Be = {
        ...X,
        html: h(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", K).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: I,
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: h(Q).replace("hr", O).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", oe).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
    }, qe = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, ve = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, ae = /^( {2,}|\\)\n(?!\s*$)/, De = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, D = /[\p{P}\p{S}]/u, W = /[\s\p{P}\p{S}]/u, ce = /[^\s\p{P}\p{S}]/u, Ze = h(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, W).getRegex(), pe = /(?!~)[\p{P}\p{S}]/u, Ge = /(?!~)[\s\p{P}\p{S}]/u, He = /(?:[^\s\p{P}\p{S}]|~)/u, Ne = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g, ue = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/, je = h(ue, "u").replace(/punct/g, D).getRegex(), Fe = h(ue, "u").replace(/punct/g, pe).getRegex(), he = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", Qe = h(he, "gu").replace(/notPunctSpace/g, ce).replace(/punctSpace/g, W).replace(/punct/g, D).getRegex(), Ue = h(he, "gu").replace(/notPunctSpace/g, He).replace(/punctSpace/g, Ge).replace(/punct/g, pe).getRegex(), Ke = h("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, ce).replace(/punctSpace/g, W).replace(/punct/g, D).getRegex(), Xe = h(/\\(punct)/, "gu").replace(/punct/g, D).getRegex(), We = h(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), Je = h(K).replace("(?:-->|$)", "-->").getRegex(), Ve = h("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", Je).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), q = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, Ye = h(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]*(?:\n[ \t]*)?)(title))?\s*\)/).replace("label", q).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), ke = h(/^!?\[(label)\]\[(ref)\]/).replace("label", q).replace("ref", U).getRegex(), ge = h(/^!?\[(ref)\](?:\[\])?/).replace("ref", U).getRegex(), et = h("reflink|nolink(?!\\()", "g").replace("reflink", ke).replace("nolink", ge).getRegex(), J = {
        _backpedal: I,
        anyPunctuation: Xe,
        autolink: We,
        blockSkip: Ne,
        br: ae,
        code: ve,
        del: I,
        emStrongLDelim: je,
        emStrongRDelimAst: Qe,
        emStrongRDelimUnd: Ke,
        escape: qe,
        link: Ye,
        nolink: ge,
        punctuation: Ze,
        reflink: ke,
        reflinkSearch: et,
        tag: Ve,
        text: De,
        url: I
    }, tt = {
        ...J,
        link: h(/^!?\[(label)\]\((.*?)\)/).replace("label", q).getRegex(),
        reflink: h(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", q).getRegex()
    }, j = {
        ...J,
        emStrongRDelimAst: Ue,
        emStrongLDelim: Fe,
        url: h(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    }, nt = {
        ...j,
        br: h(ae).replace("{2,}", "*").getRegex(),
        text: h(j.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    }, B = {
        normal: X,
        gfm: Oe,
        pedantic: Be
    }, P = {
        normal: J,
        gfm: j,
        breaks: nt,
        pedantic: tt
    };
    var st = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    }, fe = (l)=>st[l];
    function R(l, e) {
        if (e) {
            if (m.escapeTest.test(l)) return l.replace(m.escapeReplace, fe);
        } else if (m.escapeTestNoEncode.test(l)) return l.replace(m.escapeReplaceNoEncode, fe);
        return l;
    }
    function V(l) {
        try {
            l = encodeURI(l).replace(m.percentDecode, "%");
        } catch  {
            return null;
        }
        return l;
    }
    function Y(l, e) {
        let t = l.replace(m.findPipe, (i, r, o)=>{
            let a = !1, c = r;
            for(; --c >= 0 && o[c] === "\\";)a = !a;
            return a ? "|" : " |";
        }), n = t.split(m.splitPipe), s = 0;
        if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), e) {
            if (n.length > e) n.splice(e);
            else for(; n.length < e;)n.push("");
        }
        for(; s < n.length; s++)n[s] = n[s].trim().replace(m.slashPipe, "|");
        return n;
    }
    function A(l, e, t) {
        let n = l.length;
        if (n === 0) return "";
        let s = 0;
        for(; s < n;){
            let i = l.charAt(n - s - 1);
            if (i === e && !t) s++;
            else if (i !== e && t) s++;
            else break;
        }
        return l.slice(0, n - s);
    }
    function de(l, e) {
        if (l.indexOf(e[1]) === -1) return -1;
        let t = 0;
        for(let n = 0; n < l.length; n++)if (l[n] === "\\") n++;
        else if (l[n] === e[0]) t++;
        else if (l[n] === e[1] && (t--, t < 0)) return n;
        return t > 0 ? -2 : -1;
    }
    function me(l, e, t, n, s) {
        let i = e.href, r = e.title || null, o = l[1].replace(s.other.outputLinkReplace, "$1");
        n.state.inLink = !0;
        let a = {
            type: l[0].charAt(0) === "!" ? "image" : "link",
            raw: t,
            href: i,
            title: r,
            text: o,
            tokens: n.inlineTokens(o)
        };
        return n.state.inLink = !1, a;
    }
    function rt(l, e, t) {
        let n = l.match(t.other.indentCodeCompensation);
        if (n === null) return e;
        let s = n[1];
        return e.split(`
`).map((i)=>{
            let r = i.match(t.other.beginningSpace);
            if (r === null) return i;
            let [o] = r;
            return o.length >= s.length ? i.slice(s.length) : i;
        }).join(`
`);
    }
    var S = class {
        options;
        rules;
        lexer;
        constructor(e){
            this.options = e || w;
        }
        space(e) {
            let t = this.rules.block.newline.exec(e);
            if (t && t[0].length > 0) return {
                type: "space",
                raw: t[0]
            };
        }
        code(e) {
            let t = this.rules.block.code.exec(e);
            if (t) {
                let n = t[0].replace(this.rules.other.codeRemoveIndent, "");
                return {
                    type: "code",
                    raw: t[0],
                    codeBlockStyle: "indented",
                    text: this.options.pedantic ? n : A(n, `
`)
                };
            }
        }
        fences(e) {
            let t = this.rules.block.fences.exec(e);
            if (t) {
                let n = t[0], s = rt(n, t[3] || "", this.rules);
                return {
                    type: "code",
                    raw: n,
                    lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
                    text: s
                };
            }
        }
        heading(e) {
            let t = this.rules.block.heading.exec(e);
            if (t) {
                let n = t[2].trim();
                if (this.rules.other.endingHash.test(n)) {
                    let s = A(n, "#");
                    (this.options.pedantic || !s || this.rules.other.endingSpaceChar.test(s)) && (n = s.trim());
                }
                return {
                    type: "heading",
                    raw: t[0],
                    depth: t[1].length,
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        hr(e) {
            let t = this.rules.block.hr.exec(e);
            if (t) return {
                type: "hr",
                raw: A(t[0], `
`)
            };
        }
        blockquote(e) {
            let t = this.rules.block.blockquote.exec(e);
            if (t) {
                let n = A(t[0], `
`).split(`
`), s = "", i = "", r = [];
                for(; n.length > 0;){
                    let o = !1, a = [], c;
                    for(c = 0; c < n.length; c++)if (this.rules.other.blockquoteStart.test(n[c])) a.push(n[c]), o = !0;
                    else if (!o) a.push(n[c]);
                    else break;
                    n = n.slice(c);
                    let p = a.join(`
`), u = p.replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, "");
                    s = s ? `${s}
${p}` : p, i = i ? `${i}
${u}` : u;
                    let d = this.lexer.state.top;
                    if (this.lexer.state.top = !0, this.lexer.blockTokens(u, r, !0), this.lexer.state.top = d, n.length === 0) break;
                    let g = r.at(-1);
                    if (g?.type === "code") break;
                    if (g?.type === "blockquote") {
                        let T = g, f = T.raw + `
` + n.join(`
`), y = this.blockquote(f);
                        r[r.length - 1] = y, s = s.substring(0, s.length - T.raw.length) + y.raw, i = i.substring(0, i.length - T.text.length) + y.text;
                        break;
                    } else if (g?.type === "list") {
                        let T = g, f = T.raw + `
` + n.join(`
`), y = this.list(f);
                        r[r.length - 1] = y, s = s.substring(0, s.length - g.raw.length) + y.raw, i = i.substring(0, i.length - T.raw.length) + y.raw, n = f.substring(r.at(-1).raw.length).split(`
`);
                        continue;
                    }
                }
                return {
                    type: "blockquote",
                    raw: s,
                    tokens: r,
                    text: i
                };
            }
        }
        list(e) {
            let t = this.rules.block.list.exec(e);
            if (t) {
                let n = t[1].trim(), s = n.length > 1, i = {
                    type: "list",
                    raw: "",
                    ordered: s,
                    start: s ? +n.slice(0, -1) : "",
                    loose: !1,
                    items: []
                };
                n = s ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = s ? n : "[*+-]");
                let r = this.rules.other.listItemRegex(n), o = !1;
                for(; e;){
                    let c = !1, p = "", u = "";
                    if (!(t = r.exec(e)) || this.rules.block.hr.test(e)) break;
                    p = t[0], e = e.substring(p.length);
                    let d = t[2].split(`
`, 1)[0].replace(this.rules.other.listReplaceTabs, (Z)=>" ".repeat(3 * Z.length)), g = e.split(`
`, 1)[0], T = !d.trim(), f = 0;
                    if (this.options.pedantic ? (f = 2, u = d.trimStart()) : T ? f = t[1].length + 1 : (f = t[2].search(this.rules.other.nonSpaceChar), f = f > 4 ? 1 : f, u = d.slice(f), f += t[1].length), T && this.rules.other.blankLine.test(g) && (p += g + `
`, e = e.substring(g.length + 1), c = !0), !c) {
                        let Z = this.rules.other.nextBulletRegex(f), te = this.rules.other.hrRegex(f), ne = this.rules.other.fencesBeginRegex(f), se = this.rules.other.headingBeginRegex(f), xe = this.rules.other.htmlBeginRegex(f);
                        for(; e;){
                            let G = e.split(`
`, 1)[0], C;
                            if (g = G, this.options.pedantic ? (g = g.replace(this.rules.other.listReplaceNesting, "  "), C = g) : C = g.replace(this.rules.other.tabCharGlobal, "    "), ne.test(g) || se.test(g) || xe.test(g) || Z.test(g) || te.test(g)) break;
                            if (C.search(this.rules.other.nonSpaceChar) >= f || !g.trim()) u += `
` + C.slice(f);
                            else {
                                if (T || d.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || ne.test(d) || se.test(d) || te.test(d)) break;
                                u += `
` + g;
                            }
                            !T && !g.trim() && (T = !0), p += G + `
`, e = e.substring(G.length + 1), d = C.slice(f);
                        }
                    }
                    i.loose || (o ? i.loose = !0 : this.rules.other.doubleBlankLine.test(p) && (o = !0));
                    let y = null, ee;
                    this.options.gfm && (y = this.rules.other.listIsTask.exec(u), y && (ee = y[0] !== "[ ] ", u = u.replace(this.rules.other.listReplaceTask, ""))), i.items.push({
                        type: "list_item",
                        raw: p,
                        task: !!y,
                        checked: ee,
                        loose: !1,
                        text: u,
                        tokens: []
                    }), i.raw += p;
                }
                let a = i.items.at(-1);
                if (a) a.raw = a.raw.trimEnd(), a.text = a.text.trimEnd();
                else return;
                i.raw = i.raw.trimEnd();
                for(let c = 0; c < i.items.length; c++)if (this.lexer.state.top = !1, i.items[c].tokens = this.lexer.blockTokens(i.items[c].text, []), !i.loose) {
                    let p = i.items[c].tokens.filter((d)=>d.type === "space"), u = p.length > 0 && p.some((d)=>this.rules.other.anyLine.test(d.raw));
                    i.loose = u;
                }
                if (i.loose) for(let c = 0; c < i.items.length; c++)i.items[c].loose = !0;
                return i;
            }
        }
        html(e) {
            let t = this.rules.block.html.exec(e);
            if (t) return {
                type: "html",
                block: !0,
                raw: t[0],
                pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
                text: t[0]
            };
        }
        def(e) {
            let t = this.rules.block.def.exec(e);
            if (t) {
                let n = t[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " "), s = t[2] ? t[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", i = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
                return {
                    type: "def",
                    tag: n,
                    raw: t[0],
                    href: s,
                    title: i
                };
            }
        }
        table(e) {
            let t = this.rules.block.table.exec(e);
            if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
            let n = Y(t[1]), s = t[2].replace(this.rules.other.tableAlignChars, "").split("|"), i = t[3]?.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, "").split(`
`) : [], r = {
                type: "table",
                raw: t[0],
                header: [],
                align: [],
                rows: []
            };
            if (n.length === s.length) {
                for (let o of s)this.rules.other.tableAlignRight.test(o) ? r.align.push("right") : this.rules.other.tableAlignCenter.test(o) ? r.align.push("center") : this.rules.other.tableAlignLeft.test(o) ? r.align.push("left") : r.align.push(null);
                for(let o = 0; o < n.length; o++)r.header.push({
                    text: n[o],
                    tokens: this.lexer.inline(n[o]),
                    header: !0,
                    align: r.align[o]
                });
                for (let o of i)r.rows.push(Y(o, r.header.length).map((a, c)=>({
                        text: a,
                        tokens: this.lexer.inline(a),
                        header: !1,
                        align: r.align[c]
                    })));
                return r;
            }
        }
        lheading(e) {
            let t = this.rules.block.lheading.exec(e);
            if (t) return {
                type: "heading",
                raw: t[0],
                depth: t[2].charAt(0) === "=" ? 1 : 2,
                text: t[1],
                tokens: this.lexer.inline(t[1])
            };
        }
        paragraph(e) {
            let t = this.rules.block.paragraph.exec(e);
            if (t) {
                let n = t[1].charAt(t[1].length - 1) === `
` ? t[1].slice(0, -1) : t[1];
                return {
                    type: "paragraph",
                    raw: t[0],
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        text(e) {
            let t = this.rules.block.text.exec(e);
            if (t) return {
                type: "text",
                raw: t[0],
                text: t[0],
                tokens: this.lexer.inline(t[0])
            };
        }
        escape(e) {
            let t = this.rules.inline.escape.exec(e);
            if (t) return {
                type: "escape",
                raw: t[0],
                text: t[1]
            };
        }
        tag(e) {
            let t = this.rules.inline.tag.exec(e);
            if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
                type: "html",
                raw: t[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: !1,
                text: t[0]
            };
        }
        link(e) {
            let t = this.rules.inline.link.exec(e);
            if (t) {
                let n = t[2].trim();
                if (!this.options.pedantic && this.rules.other.startAngleBracket.test(n)) {
                    if (!this.rules.other.endAngleBracket.test(n)) return;
                    let r = A(n.slice(0, -1), "\\");
                    if ((n.length - r.length) % 2 === 0) return;
                } else {
                    let r = de(t[2], "()");
                    if (r === -2) return;
                    if (r > -1) {
                        let a = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + r;
                        t[2] = t[2].substring(0, r), t[0] = t[0].substring(0, a).trim(), t[3] = "";
                    }
                }
                let s = t[2], i = "";
                if (this.options.pedantic) {
                    let r = this.rules.other.pedanticHrefTitle.exec(s);
                    r && (s = r[1], i = r[3]);
                } else i = t[3] ? t[3].slice(1, -1) : "";
                return s = s.trim(), this.rules.other.startAngleBracket.test(s) && (this.options.pedantic && !this.rules.other.endAngleBracket.test(n) ? s = s.slice(1) : s = s.slice(1, -1)), me(t, {
                    href: s && s.replace(this.rules.inline.anyPunctuation, "$1"),
                    title: i && i.replace(this.rules.inline.anyPunctuation, "$1")
                }, t[0], this.lexer, this.rules);
            }
        }
        reflink(e, t) {
            let n;
            if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
                let s = (n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, " "), i = t[s.toLowerCase()];
                if (!i) {
                    let r = n[0].charAt(0);
                    return {
                        type: "text",
                        raw: r,
                        text: r
                    };
                }
                return me(n, i, n[0], this.lexer, this.rules);
            }
        }
        emStrong(e, t, n = "") {
            let s = this.rules.inline.emStrongLDelim.exec(e);
            if (!s || s[3] && n.match(this.rules.other.unicodeAlphaNumeric)) return;
            if (!(s[1] || s[2] || "") || !n || this.rules.inline.punctuation.exec(n)) {
                let r = [
                    ...s[0]
                ].length - 1, o, a, c = r, p = 0, u = s[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                for(u.lastIndex = 0, t = t.slice(-1 * e.length + r); (s = u.exec(t)) != null;){
                    if (o = s[1] || s[2] || s[3] || s[4] || s[5] || s[6], !o) continue;
                    if (a = [
                        ...o
                    ].length, s[3] || s[4]) {
                        c += a;
                        continue;
                    } else if ((s[5] || s[6]) && r % 3 && !((r + a) % 3)) {
                        p += a;
                        continue;
                    }
                    if (c -= a, c > 0) continue;
                    a = Math.min(a, a + c + p);
                    let d = [
                        ...s[0]
                    ][0].length, g = e.slice(0, r + s.index + d + a);
                    if (Math.min(r, a) % 2) {
                        let f = g.slice(1, -1);
                        return {
                            type: "em",
                            raw: g,
                            text: f,
                            tokens: this.lexer.inlineTokens(f)
                        };
                    }
                    let T = g.slice(2, -2);
                    return {
                        type: "strong",
                        raw: g,
                        text: T,
                        tokens: this.lexer.inlineTokens(T)
                    };
                }
            }
        }
        codespan(e) {
            let t = this.rules.inline.code.exec(e);
            if (t) {
                let n = t[2].replace(this.rules.other.newLineCharGlobal, " "), s = this.rules.other.nonSpaceChar.test(n), i = this.rules.other.startingSpaceChar.test(n) && this.rules.other.endingSpaceChar.test(n);
                return s && i && (n = n.substring(1, n.length - 1)), {
                    type: "codespan",
                    raw: t[0],
                    text: n
                };
            }
        }
        br(e) {
            let t = this.rules.inline.br.exec(e);
            if (t) return {
                type: "br",
                raw: t[0]
            };
        }
        del(e) {
            let t = this.rules.inline.del.exec(e);
            if (t) return {
                type: "del",
                raw: t[0],
                text: t[2],
                tokens: this.lexer.inlineTokens(t[2])
            };
        }
        autolink(e) {
            let t = this.rules.inline.autolink.exec(e);
            if (t) {
                let n, s;
                return t[2] === "@" ? (n = t[1], s = "mailto:" + n) : (n = t[1], s = n), {
                    type: "link",
                    raw: t[0],
                    text: n,
                    href: s,
                    tokens: [
                        {
                            type: "text",
                            raw: n,
                            text: n
                        }
                    ]
                };
            }
        }
        url(e) {
            let t;
            if (t = this.rules.inline.url.exec(e)) {
                let n, s;
                if (t[2] === "@") n = t[0], s = "mailto:" + n;
                else {
                    let i;
                    do i = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
                    while (i !== t[0]);
                    n = t[0], t[1] === "www." ? s = "http://" + t[0] : s = t[0];
                }
                return {
                    type: "link",
                    raw: t[0],
                    text: n,
                    href: s,
                    tokens: [
                        {
                            type: "text",
                            raw: n,
                            text: n
                        }
                    ]
                };
            }
        }
        inlineText(e) {
            let t = this.rules.inline.text.exec(e);
            if (t) {
                let n = this.lexer.state.inRawBlock;
                return {
                    type: "text",
                    raw: t[0],
                    text: t[0],
                    escaped: n
                };
            }
        }
    };
    var x = class l {
        tokens;
        options;
        state;
        tokenizer;
        inlineQueue;
        constructor(e){
            this.tokens = [], this.tokens.links = Object.create(null), this.options = e || w, this.options.tokenizer = this.options.tokenizer || new S, this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
                inLink: !1,
                inRawBlock: !1,
                top: !0
            };
            let t = {
                other: m,
                block: B.normal,
                inline: P.normal
            };
            this.options.pedantic ? (t.block = B.pedantic, t.inline = P.pedantic) : this.options.gfm && (t.block = B.gfm, this.options.breaks ? t.inline = P.breaks : t.inline = P.gfm), this.tokenizer.rules = t;
        }
        static get rules() {
            return {
                block: B,
                inline: P
            };
        }
        static lex(e, t) {
            return new l(t).lex(e);
        }
        static lexInline(e, t) {
            return new l(t).inlineTokens(e);
        }
        lex(e) {
            e = e.replace(m.carriageReturn, `
`), this.blockTokens(e, this.tokens);
            for(let t = 0; t < this.inlineQueue.length; t++){
                let n = this.inlineQueue[t];
                this.inlineTokens(n.src, n.tokens);
            }
            return this.inlineQueue = [], this.tokens;
        }
        blockTokens(e, t = [], n = !1) {
            for(this.options.pedantic && (e = e.replace(m.tabCharGlobal, "    ").replace(m.spaceLine, "")); e;){
                let s;
                if (this.options.extensions?.block?.some((r)=>(s = r.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(s.raw.length), t.push(s), !0) : !1)) continue;
                if (s = this.tokenizer.space(e)) {
                    e = e.substring(s.raw.length);
                    let r = t.at(-1);
                    s.raw.length === 1 && r !== void 0 ? r.raw += `
` : t.push(s);
                    continue;
                }
                if (s = this.tokenizer.code(e)) {
                    e = e.substring(s.raw.length);
                    let r = t.at(-1);
                    r?.type === "paragraph" || r?.type === "text" ? (r.raw += `
` + s.raw, r.text += `
` + s.text, this.inlineQueue.at(-1).src = r.text) : t.push(s);
                    continue;
                }
                if (s = this.tokenizer.fences(e)) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                if (s = this.tokenizer.heading(e)) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                if (s = this.tokenizer.hr(e)) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                if (s = this.tokenizer.blockquote(e)) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                if (s = this.tokenizer.list(e)) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                if (s = this.tokenizer.html(e)) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                if (s = this.tokenizer.def(e)) {
                    e = e.substring(s.raw.length);
                    let r = t.at(-1);
                    r?.type === "paragraph" || r?.type === "text" ? (r.raw += `
` + s.raw, r.text += `
` + s.raw, this.inlineQueue.at(-1).src = r.text) : this.tokens.links[s.tag] || (this.tokens.links[s.tag] = {
                        href: s.href,
                        title: s.title
                    });
                    continue;
                }
                if (s = this.tokenizer.table(e)) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                if (s = this.tokenizer.lheading(e)) {
                    e = e.substring(s.raw.length), t.push(s);
                    continue;
                }
                let i = e;
                if (this.options.extensions?.startBlock) {
                    let r = 1 / 0, o = e.slice(1), a;
                    this.options.extensions.startBlock.forEach((c)=>{
                        a = c.call({
                            lexer: this
                        }, o), typeof a == "number" && a >= 0 && (r = Math.min(r, a));
                    }), r < 1 / 0 && r >= 0 && (i = e.substring(0, r + 1));
                }
                if (this.state.top && (s = this.tokenizer.paragraph(i))) {
                    let r = t.at(-1);
                    n && r?.type === "paragraph" ? (r.raw += `
` + s.raw, r.text += `
` + s.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = r.text) : t.push(s), n = i.length !== e.length, e = e.substring(s.raw.length);
                    continue;
                }
                if (s = this.tokenizer.text(e)) {
                    e = e.substring(s.raw.length);
                    let r = t.at(-1);
                    r?.type === "text" ? (r.raw += `
` + s.raw, r.text += `
` + s.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = r.text) : t.push(s);
                    continue;
                }
                if (e) {
                    let r = "Infinite loop on byte: " + e.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(r);
                        break;
                    } else throw new Error(r);
                }
            }
            return this.state.top = !0, t;
        }
        inline(e, t = []) {
            return this.inlineQueue.push({
                src: e,
                tokens: t
            }), t;
        }
        inlineTokens(e, t = []) {
            let n = e, s = null;
            if (this.tokens.links) {
                let o = Object.keys(this.tokens.links);
                if (o.length > 0) for(; (s = this.tokenizer.rules.inline.reflinkSearch.exec(n)) != null;)o.includes(s[0].slice(s[0].lastIndexOf("[") + 1, -1)) && (n = n.slice(0, s.index) + "[" + "a".repeat(s[0].length - 2) + "]" + n.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
            }
            for(; (s = this.tokenizer.rules.inline.anyPunctuation.exec(n)) != null;)n = n.slice(0, s.index) + "++" + n.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            for(; (s = this.tokenizer.rules.inline.blockSkip.exec(n)) != null;)n = n.slice(0, s.index) + "[" + "a".repeat(s[0].length - 2) + "]" + n.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            let i = !1, r = "";
            for(; e;){
                i || (r = ""), i = !1;
                let o;
                if (this.options.extensions?.inline?.some((c)=>(o = c.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(o.raw.length), t.push(o), !0) : !1)) continue;
                if (o = this.tokenizer.escape(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.tag(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.link(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.reflink(e, this.tokens.links)) {
                    e = e.substring(o.raw.length);
                    let c = t.at(-1);
                    o.type === "text" && c?.type === "text" ? (c.raw += o.raw, c.text += o.text) : t.push(o);
                    continue;
                }
                if (o = this.tokenizer.emStrong(e, n, r)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.codespan(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.br(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.del(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.autolink(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (!this.state.inLink && (o = this.tokenizer.url(e))) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                let a = e;
                if (this.options.extensions?.startInline) {
                    let c = 1 / 0, p = e.slice(1), u;
                    this.options.extensions.startInline.forEach((d)=>{
                        u = d.call({
                            lexer: this
                        }, p), typeof u == "number" && u >= 0 && (c = Math.min(c, u));
                    }), c < 1 / 0 && c >= 0 && (a = e.substring(0, c + 1));
                }
                if (o = this.tokenizer.inlineText(a)) {
                    e = e.substring(o.raw.length), o.raw.slice(-1) !== "_" && (r = o.raw.slice(-1)), i = !0;
                    let c = t.at(-1);
                    c?.type === "text" ? (c.raw += o.raw, c.text += o.text) : t.push(o);
                    continue;
                }
                if (e) {
                    let c = "Infinite loop on byte: " + e.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(c);
                        break;
                    } else throw new Error(c);
                }
            }
            return t;
        }
    };
    var $ = class {
        options;
        parser;
        constructor(e){
            this.options = e || w;
        }
        space(e) {
            return "";
        }
        code({ text: e, lang: t, escaped: n }) {
            let s = (t || "").match(m.notSpaceStart)?.[0], i = e.replace(m.endingNewline, "") + `
`;
            return s ? '<pre><code class="language-' + R(s) + '">' + (n ? i : R(i, !0)) + `</code></pre>
` : "<pre><code>" + (n ? i : R(i, !0)) + `</code></pre>
`;
        }
        blockquote({ tokens: e }) {
            return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
        }
        html({ text: e }) {
            return e;
        }
        heading({ tokens: e, depth: t }) {
            return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
        }
        hr(e) {
            return `<hr>
`;
        }
        list(e) {
            let t = e.ordered, n = e.start, s = "";
            for(let o = 0; o < e.items.length; o++){
                let a = e.items[o];
                s += this.listitem(a);
            }
            let i = t ? "ol" : "ul", r = t && n !== 1 ? ' start="' + n + '"' : "";
            return "<" + i + r + `>
` + s + "</" + i + `>
`;
        }
        listitem(e) {
            let t = "";
            if (e.task) {
                let n = this.checkbox({
                    checked: !!e.checked
                });
                e.loose ? e.tokens[0]?.type === "paragraph" ? (e.tokens[0].text = n + " " + e.tokens[0].text, e.tokens[0].tokens && e.tokens[0].tokens.length > 0 && e.tokens[0].tokens[0].type === "text" && (e.tokens[0].tokens[0].text = n + " " + R(e.tokens[0].tokens[0].text), e.tokens[0].tokens[0].escaped = !0)) : e.tokens.unshift({
                    type: "text",
                    raw: n + " ",
                    text: n + " ",
                    escaped: !0
                }) : t += n + " ";
            }
            return t += this.parser.parse(e.tokens, !!e.loose), `<li>${t}</li>
`;
        }
        checkbox({ checked: e }) {
            return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
        }
        paragraph({ tokens: e }) {
            return `<p>${this.parser.parseInline(e)}</p>
`;
        }
        table(e) {
            let t = "", n = "";
            for(let i = 0; i < e.header.length; i++)n += this.tablecell(e.header[i]);
            t += this.tablerow({
                text: n
            });
            let s = "";
            for(let i = 0; i < e.rows.length; i++){
                let r = e.rows[i];
                n = "";
                for(let o = 0; o < r.length; o++)n += this.tablecell(r[o]);
                s += this.tablerow({
                    text: n
                });
            }
            return s && (s = `<tbody>${s}</tbody>`), `<table>
<thead>
` + t + `</thead>
` + s + `</table>
`;
        }
        tablerow({ text: e }) {
            return `<tr>
${e}</tr>
`;
        }
        tablecell(e) {
            let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
            return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
        }
        strong({ tokens: e }) {
            return `<strong>${this.parser.parseInline(e)}</strong>`;
        }
        em({ tokens: e }) {
            return `<em>${this.parser.parseInline(e)}</em>`;
        }
        codespan({ text: e }) {
            return `<code>${R(e, !0)}</code>`;
        }
        br(e) {
            return "<br>";
        }
        del({ tokens: e }) {
            return `<del>${this.parser.parseInline(e)}</del>`;
        }
        link({ href: e, title: t, tokens: n }) {
            let s = this.parser.parseInline(n), i = V(e);
            if (i === null) return s;
            e = i;
            let r = '<a href="' + e + '"';
            return t && (r += ' title="' + R(t) + '"'), r += ">" + s + "</a>", r;
        }
        image({ href: e, title: t, text: n, tokens: s }) {
            s && (n = this.parser.parseInline(s, this.parser.textRenderer));
            let i = V(e);
            if (i === null) return R(n);
            e = i;
            let r = `<img src="${e}" alt="${n}"`;
            return t && (r += ` title="${R(t)}"`), r += ">", r;
        }
        text(e) {
            return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : R(e.text);
        }
    };
    var _ = class {
        strong({ text: e }) {
            return e;
        }
        em({ text: e }) {
            return e;
        }
        codespan({ text: e }) {
            return e;
        }
        del({ text: e }) {
            return e;
        }
        html({ text: e }) {
            return e;
        }
        text({ text: e }) {
            return e;
        }
        link({ text: e }) {
            return "" + e;
        }
        image({ text: e }) {
            return "" + e;
        }
        br() {
            return "";
        }
    };
    var b = class l {
        options;
        renderer;
        textRenderer;
        constructor(e){
            this.options = e || w, this.options.renderer = this.options.renderer || new $, this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new _;
        }
        static parse(e, t) {
            return new l(t).parse(e);
        }
        static parseInline(e, t) {
            return new l(t).parseInline(e);
        }
        parse(e, t = !0) {
            let n = "";
            for(let s = 0; s < e.length; s++){
                let i = e[s];
                if (this.options.extensions?.renderers?.[i.type]) {
                    let o = i, a = this.options.extensions.renderers[o.type].call({
                        parser: this
                    }, o);
                    if (a !== !1 || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "paragraph",
                        "text"
                    ].includes(o.type)) {
                        n += a || "";
                        continue;
                    }
                }
                let r = i;
                switch(r.type){
                    case "space":
                        n += this.renderer.space(r);
                        continue;
                    case "hr":
                        n += this.renderer.hr(r);
                        continue;
                    case "heading":
                        n += this.renderer.heading(r);
                        continue;
                    case "code":
                        n += this.renderer.code(r);
                        continue;
                    case "table":
                        n += this.renderer.table(r);
                        continue;
                    case "blockquote":
                        n += this.renderer.blockquote(r);
                        continue;
                    case "list":
                        n += this.renderer.list(r);
                        continue;
                    case "html":
                        n += this.renderer.html(r);
                        continue;
                    case "paragraph":
                        n += this.renderer.paragraph(r);
                        continue;
                    case "text":
                        {
                            let o = r, a = this.renderer.text(o);
                            for(; s + 1 < e.length && e[s + 1].type === "text";)o = e[++s], a += `
` + this.renderer.text(o);
                            t ? n += this.renderer.paragraph({
                                type: "paragraph",
                                raw: a,
                                text: a,
                                tokens: [
                                    {
                                        type: "text",
                                        raw: a,
                                        text: a,
                                        escaped: !0
                                    }
                                ]
                            }) : n += a;
                            continue;
                        }
                    default:
                        {
                            let o = 'Token with "' + r.type + '" type was not found.';
                            if (this.options.silent) return console.error(o), "";
                            throw new Error(o);
                        }
                }
            }
            return n;
        }
        parseInline(e, t = this.renderer) {
            let n = "";
            for(let s = 0; s < e.length; s++){
                let i = e[s];
                if (this.options.extensions?.renderers?.[i.type]) {
                    let o = this.options.extensions.renderers[i.type].call({
                        parser: this
                    }, i);
                    if (o !== !1 || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(i.type)) {
                        n += o || "";
                        continue;
                    }
                }
                let r = i;
                switch(r.type){
                    case "escape":
                        n += t.text(r);
                        break;
                    case "html":
                        n += t.html(r);
                        break;
                    case "link":
                        n += t.link(r);
                        break;
                    case "image":
                        n += t.image(r);
                        break;
                    case "strong":
                        n += t.strong(r);
                        break;
                    case "em":
                        n += t.em(r);
                        break;
                    case "codespan":
                        n += t.codespan(r);
                        break;
                    case "br":
                        n += t.br(r);
                        break;
                    case "del":
                        n += t.del(r);
                        break;
                    case "text":
                        n += t.text(r);
                        break;
                    default:
                        {
                            let o = 'Token with "' + r.type + '" type was not found.';
                            if (this.options.silent) return console.error(o), "";
                            throw new Error(o);
                        }
                }
            }
            return n;
        }
    };
    var L = class {
        options;
        block;
        constructor(e){
            this.options = e || w;
        }
        static passThroughHooks = new Set([
            "preprocess",
            "postprocess",
            "processAllTokens"
        ]);
        preprocess(e) {
            return e;
        }
        postprocess(e) {
            return e;
        }
        processAllTokens(e) {
            return e;
        }
        provideLexer() {
            return this.block ? x.lex : x.lexInline;
        }
        provideParser() {
            return this.block ? b.parse : b.parseInline;
        }
    };
    var E = class {
        defaults = z();
        options = this.setOptions;
        parse = this.parseMarkdown(!0);
        parseInline = this.parseMarkdown(!1);
        Parser = b;
        Renderer = $;
        TextRenderer = _;
        Lexer = x;
        Tokenizer = S;
        Hooks = L;
        constructor(...e){
            this.use(...e);
        }
        walkTokens(e, t) {
            let n = [];
            for (let s of e)switch(n = n.concat(t.call(this, s)), s.type){
                case "table":
                    {
                        let i = s;
                        for (let r of i.header)n = n.concat(this.walkTokens(r.tokens, t));
                        for (let r of i.rows)for (let o of r)n = n.concat(this.walkTokens(o.tokens, t));
                        break;
                    }
                case "list":
                    {
                        let i = s;
                        n = n.concat(this.walkTokens(i.items, t));
                        break;
                    }
                default:
                    {
                        let i = s;
                        this.defaults.extensions?.childTokens?.[i.type] ? this.defaults.extensions.childTokens[i.type].forEach((r)=>{
                            let o = i[r].flat(1 / 0);
                            n = n.concat(this.walkTokens(o, t));
                        }) : i.tokens && (n = n.concat(this.walkTokens(i.tokens, t)));
                    }
            }
            return n;
        }
        use(...e) {
            let t = this.defaults.extensions || {
                renderers: {},
                childTokens: {}
            };
            return e.forEach((n)=>{
                let s = {
                    ...n
                };
                if (s.async = this.defaults.async || s.async || !1, n.extensions && (n.extensions.forEach((i)=>{
                    if (!i.name) throw new Error("extension name required");
                    if ("renderer" in i) {
                        let r = t.renderers[i.name];
                        r ? t.renderers[i.name] = function(...o) {
                            let a = i.renderer.apply(this, o);
                            return a === !1 && (a = r.apply(this, o)), a;
                        } : t.renderers[i.name] = i.renderer;
                    }
                    if ("tokenizer" in i) {
                        if (!i.level || i.level !== "block" && i.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                        let r = t[i.level];
                        r ? r.unshift(i.tokenizer) : t[i.level] = [
                            i.tokenizer
                        ], i.start && (i.level === "block" ? t.startBlock ? t.startBlock.push(i.start) : t.startBlock = [
                            i.start
                        ] : i.level === "inline" && (t.startInline ? t.startInline.push(i.start) : t.startInline = [
                            i.start
                        ]));
                    }
                    "childTokens" in i && i.childTokens && (t.childTokens[i.name] = i.childTokens);
                }), s.extensions = t), n.renderer) {
                    let i = this.defaults.renderer || new $(this.defaults);
                    for(let r in n.renderer){
                        if (!(r in i)) throw new Error(`renderer '${r}' does not exist`);
                        if ([
                            "options",
                            "parser"
                        ].includes(r)) continue;
                        let o = r, a = n.renderer[o], c = i[o];
                        i[o] = (...p)=>{
                            let u = a.apply(i, p);
                            return u === !1 && (u = c.apply(i, p)), u || "";
                        };
                    }
                    s.renderer = i;
                }
                if (n.tokenizer) {
                    let i = this.defaults.tokenizer || new S(this.defaults);
                    for(let r in n.tokenizer){
                        if (!(r in i)) throw new Error(`tokenizer '${r}' does not exist`);
                        if ([
                            "options",
                            "rules",
                            "lexer"
                        ].includes(r)) continue;
                        let o = r, a = n.tokenizer[o], c = i[o];
                        i[o] = (...p)=>{
                            let u = a.apply(i, p);
                            return u === !1 && (u = c.apply(i, p)), u;
                        };
                    }
                    s.tokenizer = i;
                }
                if (n.hooks) {
                    let i = this.defaults.hooks || new L;
                    for(let r in n.hooks){
                        if (!(r in i)) throw new Error(`hook '${r}' does not exist`);
                        if ([
                            "options",
                            "block"
                        ].includes(r)) continue;
                        let o = r, a = n.hooks[o], c = i[o];
                        L.passThroughHooks.has(r) ? i[o] = (p)=>{
                            if (this.defaults.async) return Promise.resolve(a.call(i, p)).then((d)=>c.call(i, d));
                            let u = a.call(i, p);
                            return c.call(i, u);
                        } : i[o] = (...p)=>{
                            let u = a.apply(i, p);
                            return u === !1 && (u = c.apply(i, p)), u;
                        };
                    }
                    s.hooks = i;
                }
                if (n.walkTokens) {
                    let i = this.defaults.walkTokens, r = n.walkTokens;
                    s.walkTokens = function(o) {
                        let a = [];
                        return a.push(r.call(this, o)), i && (a = a.concat(i.call(this, o))), a;
                    };
                }
                this.defaults = {
                    ...this.defaults,
                    ...s
                };
            }), this;
        }
        setOptions(e) {
            return this.defaults = {
                ...this.defaults,
                ...e
            }, this;
        }
        lexer(e, t) {
            return x.lex(e, t ?? this.defaults);
        }
        parser(e, t) {
            return b.parse(e, t ?? this.defaults);
        }
        parseMarkdown(e) {
            return (n, s)=>{
                let i = {
                    ...s
                }, r = {
                    ...this.defaults,
                    ...i
                }, o = this.onError(!!r.silent, !!r.async);
                if (this.defaults.async === !0 && i.async === !1) return o(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
                if (typeof n > "u" || n === null) return o(new Error("marked(): input parameter is undefined or null"));
                if (typeof n != "string") return o(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
                r.hooks && (r.hooks.options = r, r.hooks.block = e);
                let a = r.hooks ? r.hooks.provideLexer() : e ? x.lex : x.lexInline, c = r.hooks ? r.hooks.provideParser() : e ? b.parse : b.parseInline;
                if (r.async) return Promise.resolve(r.hooks ? r.hooks.preprocess(n) : n).then((p)=>a(p, r)).then((p)=>r.hooks ? r.hooks.processAllTokens(p) : p).then((p)=>r.walkTokens ? Promise.all(this.walkTokens(p, r.walkTokens)).then(()=>p) : p).then((p)=>c(p, r)).then((p)=>r.hooks ? r.hooks.postprocess(p) : p).catch(o);
                try {
                    r.hooks && (n = r.hooks.preprocess(n));
                    let p = a(n, r);
                    r.hooks && (p = r.hooks.processAllTokens(p)), r.walkTokens && this.walkTokens(p, r.walkTokens);
                    let u = c(p, r);
                    return r.hooks && (u = r.hooks.postprocess(u)), u;
                } catch (p) {
                    return o(p);
                }
            };
        }
        onError(e, t) {
            return (n)=>{
                if (n.message += `
Please report this to https://github.com/markedjs/marked.`, e) {
                    let s = "<p>An error occurred:</p><pre>" + R(n.message + "", !0) + "</pre>";
                    return t ? Promise.resolve(s) : s;
                }
                if (t) return Promise.reject(n);
                throw n;
            };
        }
    };
    var M = new E;
    function k(l, e) {
        return M.parse(l, e);
    }
    k.options = k.setOptions = function(l) {
        return M.setOptions(l), k.defaults = M.defaults, N(k.defaults), k;
    };
    k.getDefaults = z;
    k.defaults = w;
    k.use = function(...l) {
        return M.use(...l), k.defaults = M.defaults, N(k.defaults), k;
    };
    k.walkTokens = function(l, e) {
        return M.walkTokens(l, e);
    };
    k.parseInline = M.parseInline;
    k.Parser = b;
    k.parser = b.parse;
    k.Renderer = $;
    k.TextRenderer = _;
    k.Lexer = x;
    k.lexer = x.lex;
    k.Tokenizer = S;
    k.Hooks = L;
    k.parse = k;
    var it = k.options, ot = k.setOptions, lt = k.use, at = k.walkTokens, ct = k.parseInline, pt = k, ut = b.parse, ht = x.lex;
    if (__exports != exports) module1.exports = exports;
    return module1.exports;
});

});

parcelRegister("i8Fxz", function(module, exports) {
/*! @license DOMPurify 3.1.0 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.1.0/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== "undefined" && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!construct) construct = function construct(Func, args) {
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param {Function} func - The function to be wrapped and called.
   * @returns {Function} A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param {Function} func - The constructor function to be wrapped and called.
   * @returns {Function} A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param {Object} set - The set to which elements will be added.
   * @param {Array} array - The array containing elements to be added to the set.
   * @param {Function} transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns {Object} The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === "string") {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param {Array} array - The array to be cleaned.
   * @returns {Array} The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param {Object} object - The object to be cloned.
   * @returns {Object} A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === "object" && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param {Object} object - The object to look up the getter function in its prototype chain.
   * @param {String} prop - The property name for which to find the getter function.
   * @returns {Function} The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === "function") return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "section",
        "select",
        "shadow",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]);
    // SVG
    const svg$1 = freeze([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]);
    const svgFilters = freeze([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feDropShadow",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feImage",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]);
    const mathMl$1 = freeze([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover",
        "mprescripts"
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]);
    const text = freeze([
        "#text"
    ]);
    const html = freeze([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "nonce",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "pattern",
        "placeholder",
        "playsinline",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "wrap",
        "xmlns",
        "slot"
    ]);
    const svg = freeze([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "targetx",
        "targety",
        "transform",
        "transform-origin",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]);
    const mathMl = freeze([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnsalign",
        "columnlines",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lspace",
        "lquote",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]);
    const xml = freeze([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        ERB_EXPR: ERB_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR,
        DATA_ATTR: DATA_ATTR,
        ARIA_ATTR: ARIA_ATTR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        DOCTYPE_NAME: DOCTYPE_NAME,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT
    });
    const getGlobal = function getGlobal() {
        return typeof window === "undefined" ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {HTMLScriptElement} purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return {TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = "data-tt-policy-suffix";
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = "dompurify" + (suffix ? "#" + suffix : "");
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn("TrustedTypes policy " + policyName + " could not be created.");
            return null;
        }
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = "3.1.0";
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, "cloneNode");
        const getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
        const getChildNodes = lookupGetter(ElementPrototype, "childNodes");
        const getParentNode = lookupGetter(ElementPrototype, "parentNode");
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === "function") {
            const template = document.createElement("template");
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = "";
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === "function" && typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "role",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]);
        const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            "application/xhtml+xml",
            "text/html"
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement("form");
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== "object") cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, "ALLOWED_TAGS") ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, "ALLOWED_ATTR") ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, "ALLOWED_NAMESPACES") ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, "ADD_URI_SAFE_ATTR") ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, "ADD_DATA_URI_TAGS") ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, "FORBID_CONTENTS") ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, "FORBID_TAGS") ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = objectHasOwnProperty(cfg, "FORBID_ATTR") ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = objectHasOwnProperty(cfg, "USE_PROFILES") ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                "html",
                "head",
                "body"
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    "tbody"
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML("");
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === "string") emptyHTML = trustedTypesPolicy.createHTML("");
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        const MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]);
        const HTML_INTEGRATION_POINTS = addToSet({}, [
            "foreignobject",
            "desc",
            "title",
            "annotation-xml"
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            "title",
            "style",
            "font",
            "a",
            "script"
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: "template"
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                node.remove();
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ const _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === "is" && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, "");
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, "template", null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param  {Node} root The root element or node to start traversing on.
     * @return {NodeIterator} The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== "string" || typeof elm.textContent !== "string" || typeof elm.removeChild !== "function" || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== "function" || typeof elm.setAttribute !== "function" || typeof elm.namespaceURI !== "string" || typeof elm.insertBefore !== "function" || typeof elm.hasChildNodes !== "function");
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param  {Node} object object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ const _isNode = function _isNode(object) {
            return typeof Node === "function" && object instanceof Node;
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ const _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHook("beforeSanitizeElements", currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook("uponSanitizeElement", currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i)parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, " ");
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeElements", currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ""))) ;
            else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ""))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param {string} tagName name of the tag of the node to sanitize
     * @returns {boolean} Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== "annotation-xml" && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHook("beforeSanitizeAttributes", currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            const hookEvent = {
                attrName: "",
                attrValue: "",
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                let value = name === "value" ? attrValue : stringTrim(attrValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook("uponSanitizeAttribute", currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, " ");
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name")) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function") {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case "TrustedHTML":
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case "TrustedScriptURL":
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeAttributes", currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHook("beforeSanitizeShadowDOM", fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook("uponSanitizeShadowNode", shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeShadowDOM", fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} cfg object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = "<!-->";
            /* Stringify, in case dirty is an object */ if (typeof dirty !== "string" && !_isNode(dirty)) {
                if (typeof dirty.toString === "function") {
                    dirty = dirty.toString();
                    if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
                } else throw typeErrorCreate("toString is not a function");
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === "string") IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument("<!---->");
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === "BODY") /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === "HTML") body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, " ");
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {String} tag Tag name of containing element.
     * @param  {String} attr Attribute name.
     * @param  {String} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== "function") return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});


parcelRegister("56hIS", function(module, exports) {

$parcel$export(module.exports, "HeroForm", () => $3952aae883cb0f72$export$1c56b42befcecd1e);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("18L7n");
var $bApKI = parcelRequire("bApKI");
var $9hanQ = parcelRequire("9hanQ");
var $faxRZ = parcelRequire("faxRZ");
var $7i7mP = parcelRequire("7i7mP");

var $ggKhH = parcelRequire("ggKhH");
var $cVodR = parcelRequire("cVodR");
parcelRequire("gCemA");
var $2bkBK = parcelRequire("2bkBK");

var $9QePP = parcelRequire("9QePP");
const $3952aae883cb0f72$export$1c56b42befcecd1e = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7i7mP.Section), {
        title: "About your company",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: (0, $9QePP.default)("-mt-4 pb-6", "border-default border-b", "body-s"),
                children: "Share information about this deal below. You may share identifying information in the red Private Teaser zone below. All other information outside of this zone must be anonymized as it will appear on the Public Teaser page."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "my-8",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                        className: "heading-l",
                        children: "Public Teaser"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-s",
                        children: "The information you share in the Public Teaser must be anonymized. You may share data like industry, location and revenue model, but cannot share identifying information like your company name or team members."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bApKI.Input), {
                parent: "hero",
                label: "Public Headline",
                name: "publicHeadline",
                placeholder: "E.g: Manufacturer of athleisure performance apparel."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $faxRZ.RichText), {
                parent: "hero",
                label: "Public Paragraph Description",
                name: "publicDescription",
                placeholder: "E.g: Manufacturer of athleisure performance apparel."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("my-8 p-4", "rounded border border-red-600"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                        className: "heading-l",
                        children: "Private Teaser"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-s mb-8",
                        children: "The text in this section will be privately shown to investors once they have logged in. You can name your company, team members and share any other identifying information. The headline and paragraph descriptions below are the only areas of this page where you may share identifying information."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bApKI.Input), {
                        parent: "hero",
                        label: "Private Headline",
                        name: "privateHeadline",
                        placeholder: "E.g: Nike athleisure performance apparel."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $faxRZ.RichText), {
                        parent: "hero",
                        label: "Private Paragraph Description",
                        name: "privateDescription",
                        placeholder: "E.g: Manufacturer of athleisure performance apparel."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9hanQ.MutableList), {
                name: "hero.callouts",
                children: ({ items: items, addItem: addItem })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: (0, $9QePP.default)("mt-8", "grid grid-cols-1", "gap-3", "md:grid-cols-3"),
                                children: items.map(({ parent: parent, remove: remove }, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        "data-testid": parent,
                                        className: "relative mt-4 p-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVodR.default), {
                                                "data-testid": `delete-callout-${index + 1}`,
                                                onClick: remove,
                                                width: 20,
                                                height: 20,
                                                className: "absolute right-0 top-5 cursor-pointer",
                                                "dd-action": (0, $2bkBK.ddActions).profile.hero.callout.delete
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bApKI.Input), {
                                                parent: parent,
                                                name: "title",
                                                placeholder: "Label, eg. LTM Revenue",
                                                label: `Key info ${index + 1}`
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bApKI.Input), {
                                                parent: parent,
                                                name: "value",
                                                placeholder: "Value, eg. $10M",
                                                label: `Key value ${index + 1}`
                                            })
                                        ]
                                    }, parent))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: addItem,
                                "dd-action": (0, $2bkBK.ddActions).profile.hero.callout.add,
                                className: "secondary mt-8 inline-flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ggKhH.default), {
                                        className: "mr-2 size-4"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-button",
                                        children: "Add key info item"
                                    })
                                ]
                            })
                        ]
                    })
            })
        ]
    });
};

});

parcelRegister("7ekv1", function(module, exports) {

$parcel$export(module.exports, "OpportunityCTA", () => $88289337448aae50$export$eefa6b7a41848b5a);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("18L7n");
var $hUCih = parcelRequire("hUCih");
var $5Ttm9 = parcelRequire("5Ttm9");
var $4SyUF = parcelRequire("4SyUF");
function $88289337448aae50$export$eefa6b7a41848b5a({ onNotInterested: onNotInterested, onExploreOpportunity: onExploreOpportunity, testId: testId, showSpinnerButton: showSpinnerButton, showReject: showReject = true, showAccept: showAccept = true }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4SyUF.StickyFooter), {
        testId: testId,
        children: [
            showReject && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: onNotInterested,
                className: "secondary lg sm:mr-4",
                children: "I'm not interested"
            }),
            showAccept && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                onClick: onExploreOpportunity,
                className: "lg mt-4 sm:ml-4 sm:mt-0",
                disabled: showSpinnerButton,
                children: [
                    showSpinnerButton ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
                        className: "mr-2 inline-block"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).Check, {
                        className: "mr-2 inline-block"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-s text-gray-0",
                        children: "I am interested in this company"
                    })
                ]
            })
        ]
    });
}

});

parcelRegister("bLW1O", function(module, exports) {

$parcel$export(module.exports, "hasHeroErrorAtom", () => $ddffa37c13d200c7$export$682c3015c2074160);
$parcel$export(module.exports, "hasFinancialErrorAtom", () => $ddffa37c13d200c7$export$6233fe8cbb9b76fa);
$parcel$export(module.exports, "heroErrorsAtom", () => $ddffa37c13d200c7$export$32e18ab9b60f637b);
$parcel$export(module.exports, "financialErrorsAtom", () => $ddffa37c13d200c7$export$6628a46aa64c911);
$parcel$export(module.exports, "Controls", () => $ddffa37c13d200c7$export$c7c44baae9d9f25f);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("18L7n");
var $hUCih = parcelRequire("hUCih");
var $7i7mP = parcelRequire("7i7mP");
var $5Ttm9 = parcelRequire("5Ttm9");

var $a6uVN = parcelRequire("a6uVN");

var $eVhSR = parcelRequire("eVhSR");
var $dp7y6 = parcelRequire("dp7y6");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $r2uF6 = parcelRequire("r2uF6");

var $ioVhG = parcelRequire("ioVhG");
parcelRequire("gCemA");
var $2bkBK = parcelRequire("2bkBK");
var $ddffa37c13d200c7$export$efffd94d358f9ed;
(function(ControlState) {
    ControlState["NotEditing"] = "NotEditing";
    ControlState["Editing"] = "Editing";
    ControlState["Preview"] = "Preview";
})($ddffa37c13d200c7$export$efffd94d358f9ed || ($ddffa37c13d200c7$export$efffd94d358f9ed = {}));
const $ddffa37c13d200c7$export$682c3015c2074160 = (0, $r2uF6.atom)(false);
const $ddffa37c13d200c7$export$6233fe8cbb9b76fa = (0, $r2uF6.atom)(false);
const $ddffa37c13d200c7$export$32e18ab9b60f637b = (0, $r2uF6.atom)([]);
const $ddffa37c13d200c7$export$6628a46aa64c911 = (0, $r2uF6.atom)([]);
const $ddffa37c13d200c7$export$c7c44baae9d9f25f = ({ isDirty: isDirty = false, controlState: controlState, onEdit: onEdit, onDiscard: onDiscard, onPreview: onPreview, onPublish: onPublish, onPrivate: onPrivate, sendingChanges: sendingChanges })=>{
    const [privateProfile, setPrivateProfile] = (0, $acw62.useState)(false);
    const [_controlState, setControlState] = (0, $acw62.useState)(controlState || "NotEditing");
    const [showDiscardModal, setShowDiscardModal] = (0, $acw62.useState)(false);
    const heroError = (0, $r2uF6.useAtomValue)($ddffa37c13d200c7$export$682c3015c2074160);
    const financialSectionError = (0, $r2uF6.useAtomValue)($ddffa37c13d200c7$export$6233fe8cbb9b76fa);
    const hasErrors = heroError || financialSectionError;
    const heroErrors = (0, $r2uF6.useAtomValue)($ddffa37c13d200c7$export$32e18ab9b60f637b);
    const financialErrors = (0, $r2uF6.useAtomValue)($ddffa37c13d200c7$export$6628a46aa64c911);
    if (_controlState === "NotEditing") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7i7mP.Section), {
        className: "pb-0",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex justify-between px-2 md:px-0",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ioVhG.PrivacyToggle), {
                    isPrivate: !!privateProfile,
                    onChange: ()=>{
                        setPrivateProfile(!privateProfile);
                        onPrivate && onPrivate();
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    onClick: ()=>{
                        setControlState("Editing");
                        onEdit && onEdit();
                    },
                    className: "secondary xl flex items-center",
                    "dd-action": (0, $2bkBK.ddActions).profile.edit.click,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).Pencil, {
                            className: "text-color mr-2"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-button",
                            children: "Edit Page"
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7i7mP.Section), {
        className: "pb-0",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("flex items-center", _controlState === "Preview" ? "justify-between" : "justify-end"),
                children: [
                    _controlState === "Preview" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ioVhG.PrivacyToggle), {
                        isPrivate: !!privateProfile,
                        onChange: ()=>{
                            setPrivateProfile(!privateProfile);
                            onPrivate && onPrivate();
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: (0, $9QePP.default)("px-2", "flex flex-wrap", "items-center justify-end", "md:px-0"),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                className: "secondary flex items-center",
                                onClick: ()=>{
                                    if (isDirty) setShowDiscardModal(true);
                                    else setControlState("NotEditing");
                                },
                                "dd-action": (0, $2bkBK.ddActions).profile.edit.discard.click,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dp7y6.default), {
                                        className: "text-color mr-2 size-4"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-button hidden md:block",
                                        children: "Discard"
                                    })
                                ]
                            }),
                            _controlState === "Editing" && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>{
                                    setControlState("Preview");
                                    onPreview && onPreview();
                                },
                                className: "ml-4",
                                disabled: hasErrors,
                                "dd-action": (0, $2bkBK.ddActions).profile.edit.preview.click,
                                children: "Preview Changes"
                            }),
                            _controlState === "Preview" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>{
                                            setControlState("Editing");
                                            onEdit && onEdit();
                                        },
                                        "dd-action": (0, $2bkBK.ddActions).profile.edit.preview.back,
                                        className: "secondary ml-4 flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).Pencil, {
                                                className: "mr-2"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-button hidden md:block",
                                                children: "Back to Editing"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>{
                                            setControlState("NotEditing");
                                            onPublish && onPublish();
                                        },
                                        className: "ml-4 inline-flex gap-2",
                                        "dd-action": (0, $2bkBK.ddActions).profile.edit.publish.click,
                                        children: [
                                            "Publish Changes",
                                            sendingChanges && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {})
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showDiscardModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6uVN.DiscardModal), {
                onDiscard: ()=>{
                    setShowDiscardModal(false);
                    setControlState("NotEditing");
                    onDiscard && onDiscard();
                },
                onCancel: ()=>{
                    setShowDiscardModal(false);
                }
            }),
            hasErrors && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("mt-4 p-4", "border border-red-500", "rounded-md"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eVhSR.default), {
                                className: "size-5 fill-red-500"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-l",
                                children: "There are problems in the form below:"
                            })
                        ]
                    }),
                    heroErrors.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt-2 flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "size-5"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "subdued subheading",
                                        children: "Hero Errors:"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                        className: "mb-3 list-disc pl-5",
                                        children: heroErrors.map((error, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "body-s",
                                                children: error
                                            }, idx))
                                    })
                                ]
                            })
                        ]
                    }),
                    financialErrors.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "size-5"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "subdued subheading",
                                        children: "Financial Errors:"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                        className: "mb-3 list-disc pl-5",
                                        children: financialErrors.map((error, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "body-s",
                                                children: error
                                            }, idx))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("a6uVN", function(module, exports) {

$parcel$export(module.exports, "DiscardModal", () => $bc7c74b9525681d6$export$5a1c1fd1fd0d9704);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("gCemA");
var $2bkBK = parcelRequire("2bkBK");
parcelRequire("18L7n");
var $dtQ0k = parcelRequire("dtQ0k");
var $41p3a = parcelRequire("41p3a");
const $bc7c74b9525681d6$export$5a1c1fd1fd0d9704 = ({ onDiscard: onDiscard, onCancel: onCancel })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dtQ0k.Modal), {
        isOpen: true,
        title: "Discard changes?",
        description: "Are you sure you want to discard your changes?",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $41p3a.ModalFooter), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "secondary",
                    onClick: onCancel,
                    "dd-action": (0, $2bkBK.ddActions).profile.edit.discard.cancel,
                    children: "Go back"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    onClick: onDiscard,
                    "dd-action": (0, $2bkBK.ddActions).profile.edit.discard.confirm,
                    children: "Discard"
                })
            ]
        })
    });
};

});

parcelRegister("dp7y6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c237743b2450caa$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $9c237743b2450caa$var$TrashIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z",
        clipRule: "evenodd"
    }));
}
const $9c237743b2450caa$var$ForwardRef = $acw62.forwardRef($9c237743b2450caa$var$TrashIcon);
var $9c237743b2450caa$export$2e2bcd8739ae039 = $9c237743b2450caa$var$ForwardRef;

});

parcelRegister("ioVhG", function(module, exports) {

$parcel$export(module.exports, "PrivacyToggle", () => $c272a9fa3294316e$export$ef175342b604dfd2);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("18L7n");
var $3djtJ = parcelRequire("3djtJ");
function $c272a9fa3294316e$export$ef175342b604dfd2({ onChange: onChange, isPrivate: isPrivate }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-button mr-2",
                children: "Public View"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3djtJ.Toggle), {
                checked: isPrivate,
                onChange: onChange,
                testId: "privacy-toggle"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-button ml-2",
                children: "Private View"
            })
        ]
    });
}

});


parcelRegister("l48UL", function(module, exports) {

$parcel$export(module.exports, "FinancialHighlightsForm", () => $72cb155dfd6a5ece$export$7dec1ab1d298189a);

var $ayMG0 = parcelRequire("ayMG0");

var $8MMW2 = parcelRequire("8MMW2");
var $7KX8i = parcelRequire("7KX8i");
parcelRequire("18L7n");
var $hUCih = parcelRequire("hUCih");
var $bApKI = parcelRequire("bApKI");
var $9hanQ = parcelRequire("9hanQ");
var $7i7mP = parcelRequire("7i7mP");
var $97C3K = parcelRequire("97C3K");
var $1sOsm = parcelRequire("1sOsm");
parcelRequire("gCemA");
var $2bkBK = parcelRequire("2bkBK");
parcelRequire("dRO48");
var $ktz3T = parcelRequire("ktz3T");
parcelRequire("5F6eO");
var $lFiRI = parcelRequire("lFiRI");

var $9QePP = parcelRequire("9QePP");
const $72cb155dfd6a5ece$export$7dec1ab1d298189a = ()=>{
    const monthsArray = (0, $ktz3T.MONTHS).map((month)=>({
            label: month,
            value: month
        }));
    const currentYear = new Date().getFullYear();
    const highlightsIcons = [
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).BarChartup, {
                className: "ml-10 size-7"
            }),
            value: (0, $lFiRI.HighlightsIcons).BarChartUp
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).LineChartup, {
                className: "ml-10 size-7"
            }),
            value: (0, $lFiRI.HighlightsIcons).LineChartUp
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).Percent, {
                className: "ml-10 size-7"
            }),
            value: (0, $lFiRI.HighlightsIcons).Percent
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).Tag, {
                className: "ml-10 size-7"
            }),
            value: (0, $lFiRI.HighlightsIcons).Tag
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).CircleDollar, {
                className: "ml-10 size-7"
            }),
            value: (0, $lFiRI.HighlightsIcons).CircleDollar
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).DollarBill, {
                className: "ml-10 size-7"
            }),
            value: (0, $lFiRI.HighlightsIcons).DollarBill
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7i7mP.Section), {
        title: "Financial data",
        secondaryBg: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "hum-container px-4 pb-20 pt-8",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bApKI.Input), {
                    parent: "financialHighlights",
                    label: "Name of this section",
                    name: "title",
                    placeholder: "E.g: Financial Highlights"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "my-8",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "body-micro subdued",
                            children: "Last updated date"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w-xl mt-2 flex gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97C3K.Select), {
                                    parent: "financialHighlights",
                                    label: "Month",
                                    name: "month",
                                    options: monthsArray
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97C3K.Select), {
                                    parent: "financialHighlights",
                                    label: "Year",
                                    name: "year",
                                    options: [
                                        ...Array(10)
                                    ].map((_, i)=>({
                                            label: (currentYear - i).toString(),
                                            value: (currentYear - i).toString()
                                        }))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1sOsm.TextArea), {
                    parent: "financialHighlights",
                    label: "Paragraph Description",
                    name: "description",
                    placeholder: "E.g: Manufacturer of athleisure performance apparel."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9hanQ.MutableList), {
                    name: "financialHighlights.highlights",
                    children: ({ items: items, addItem: addItem })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: (0, $9QePP.default)("mt-8", "grid grid-cols-1", "gap-3", "md:grid-cols-3"),
                                    children: items.map(({ parent: parent, remove: remove }, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            "data-testid": parent,
                                            className: "relative mt-4 p-4",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7KX8i.default), {
                                                    "data-testid": `delete-highlight-${index + 1}`,
                                                    onClick: remove,
                                                    width: 20,
                                                    height: 20,
                                                    className: "absolute right-0 top-5 cursor-pointer",
                                                    "dd-action": (0, $2bkBK.ddActions).profile.financialHighlights.item.delete
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bApKI.Input), {
                                                    parent: parent,
                                                    name: "title",
                                                    placeholder: "Label, eg. LTM Revenue",
                                                    label: `Financial Highlight ${index + 1}`
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bApKI.Input), {
                                                    parent: parent,
                                                    name: "value",
                                                    placeholder: "Value, eg. $10M",
                                                    label: `Value ${index + 1}`
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97C3K.Select), {
                                                    parent: parent,
                                                    name: "icon",
                                                    label: "Icon",
                                                    placeholder: "Select an icon",
                                                    options: highlightsIcons
                                                })
                                            ]
                                        }, parent))
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: addItem,
                                    className: "secondary inline-flex gap-2",
                                    "dd-action": (0, $2bkBK.ddActions).profile.financialHighlights.item.add,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8MMW2.default), {
                                            className: "mr-2 size-4"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-button",
                                            children: "Add financial highlight item"
                                        })
                                    ]
                                })
                            ]
                        })
                })
            ]
        })
    });
};

});
parcelRegister("8MMW2", function(module, exports) {

$parcel$export(module.exports, "default", () => $6658c3f0e02ad269$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $6658c3f0e02ad269$var$PlusIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"
    }));
}
const $6658c3f0e02ad269$var$ForwardRef = $acw62.forwardRef($6658c3f0e02ad269$var$PlusIcon);
var $6658c3f0e02ad269$export$2e2bcd8739ae039 = $6658c3f0e02ad269$var$ForwardRef;

});


parcelRegister("j9a2k", function(module, exports) {

$parcel$export(module.exports, "DownloadsForm", () => $7811da04de622ca6$export$91e3415d6cb3bfc6);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("18L7n");
var $bVwXM = parcelRequire("bVwXM");
var $29x30 = parcelRequire("29x30");
var $7i7mP = parcelRequire("7i7mP");
var $1sOsm = parcelRequire("1sOsm");
const $7811da04de622ca6$export$91e3415d6cb3bfc6 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7i7mP.Section), {
        title: "Downloads",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1sOsm.TextArea), {
                parent: "downloads",
                label: "Downloads Description",
                name: "description"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bVwXM.Card), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "ui-element subdued",
                    children: "Hum Standardized Data & Chartbook"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $29x30.Checkbox), {
                parent: "downloads",
                label: "Do not show any files/folders/chartbooks.",
                name: "isVisible"
            })
        ]
    });
};

});

parcelRegister("hLr2d", function(module, exports) {

$parcel$export(module.exports, "Downloads", () => $cf1d03d2f63bac67$export$b82462f306cd9e20);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $cNbKI = parcelRequire("cNbKI");
parcelRequire("18L7n");
var $bVwXM = parcelRequire("bVwXM");
var $hUCih = parcelRequire("hUCih");
var $7dcDb = parcelRequire("7dcDb");
var $7i7mP = parcelRequire("7i7mP");
parcelRequire("gCemA");
var $2bkBK = parcelRequire("2bkBK");
var $yrzTx = parcelRequire("yrzTx");
parcelRequire("5F6eO");
var $7QL9H = parcelRequire("7QL9H");
parcelRequire("agk6G");
var $iIyrH = parcelRequire("iIyrH");
const $cf1d03d2f63bac67$export$b82462f306cd9e20 = ({ isVisible: isVisible = false, description: description, publicToken: publicToken })=>{
    const { task: task, isPolling: isPolling, startDownload: startDownload, stopDownload: stopDownload, isError: isError } = (0, $7QL9H.useProfileDownloads)(publicToken);
    const isFailure = isError || task?.state === (0, $iIyrH.BulkDownloadStatus).Failure || task?.state === (0, $iIyrH.BulkDownloadStatus).Revoked;
    const isSuccess = task?.state === (0, $iIyrH.BulkDownloadStatus).Success;
    (0, $acw62.useEffect)(()=>{
        if (isFailure) {
            (0, $cNbKI.datadogRum).addAction((0, $2bkBK.ddActions).profile.downloadChartbook.fail, {
                company_token: publicToken
            });
            (0, $yrzTx.log).error("Failed to download chartbook", {
                company_token: publicToken
            });
        }
    }, [
        isFailure,
        publicToken
    ]);
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7i7mP.Section), {
        title: "Downloads",
        className: "py-10",
        children: [
            description && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "subdued body-m mb-4",
                children: description
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bVwXM.Card), {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).ExcelFile, {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "ui-element subdued",
                                children: "Hum Standardized Data & Chartbook"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).Download, {
                        "dd-action": (0, $2bkBK.ddActions).profile.downloadChartbook.click,
                        onClick: ()=>startDownload()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7dcDb.ProgressDownload), {
                onCancel: ()=>stopDownload(),
                isPolling: isPolling,
                isFailure: isFailure,
                isSuccess: isSuccess
            })
        ]
    });
};

});

parcelRegister("70FMy", function(module, exports) {

$parcel$export(module.exports, "Content", () => $224fb4d1ce1d864a$export$7c6e2c02157bb7d2);

var $ayMG0 = parcelRequire("ayMG0");

var $fvg8F = parcelRequire("fvg8F");
const $224fb4d1ce1d864a$export$7c6e2c02157bb7d2 = ({ hero: hero, financialHighlights: financialHighlights, downloads: downloads, isPrivate: isPrivate, publicToken: publicToken, dataroom: dataroom })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fvg8F.Profile).Hero, {
                ...hero,
                isPrivate: isPrivate
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fvg8F.Profile).FinancialHighlights, {
                ...financialHighlights
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fvg8F.Profile).Downloads, {
                ...downloads,
                publicToken: publicToken
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fvg8F.Profile).Dataroom, {
                ...dataroom
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fvg8F.Profile).Footer, {})
        ]
    });
};

});

parcelRegister("k12C0", function(module, exports) {

$parcel$export(module.exports, "LinkCTA", () => $a47995f7cc4ad8ea$export$dcf4eaf274e0e63a);

var $ayMG0 = parcelRequire("ayMG0");

var $cNbKI = parcelRequire("cNbKI");

var $9c2hg = parcelRequire("9c2hg");
parcelRequire("gCemA");
var $2bkBK = parcelRequire("2bkBK");
parcelRequire("18L7n");
var $4SyUF = parcelRequire("4SyUF");
var $3oOMC = parcelRequire("3oOMC");

var $9QePP = parcelRequire("9QePP");
function $a47995f7cc4ad8ea$export$dcf4eaf274e0e63a({ token: token, testId: testId }) {
    if (!token) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4SyUF.StickyFooter), {
        testId: testId,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
            onClick: ()=>{
                navigator.clipboard.writeText(`${window.location.origin}/public/${token}?utm_source=hum_admin&utm_medium=copy_link`);
                (0, $3oOMC.toast).success("Copied to clipboard");
                (0, $cNbKI.datadogRum).addAction((0, $2bkBK.ddActions).profile.share.public, {
                    token: token
                });
            },
            className: (0, $9QePP.default)("lg", "secondary flex items-center", "sm:mr-4"),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9c2hg.default), {
                    className: "mr-2 inline-block",
                    width: 20,
                    color: "white"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-button",
                    children: "Copy public link"
                })
            ]
        })
    });
}

});
parcelRegister("9c2hg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b170050ee98143c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $6b170050ee98143c$var$LinkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"
    }));
}
const $6b170050ee98143c$var$ForwardRef = $acw62.forwardRef($6b170050ee98143c$var$LinkIcon);
var $6b170050ee98143c$export$2e2bcd8739ae039 = $6b170050ee98143c$var$ForwardRef;

});


parcelRegister("cBGHr", function(module, exports) {

$parcel$export(module.exports, "Dataroom", () => $c43b258e97f62203$export$5f710a6161860090);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("18L7n");
var $hUCih = parcelRequire("hUCih");
var $7i7mP = parcelRequire("7i7mP");
parcelRequire("gCemA");
var $7gcOJ = parcelRequire("7gcOJ");
const $c43b258e97f62203$export$5f710a6161860090 = ({ link: link, deactivate: deactivate })=>{
    const flags = (0, $7gcOJ.useFlags)();
    const isDataroomEnabled = flags.enabled("enable-dataroom-link");
    if (!link || !isDataroomEnabled) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7i7mP.Section), {
        className: "py-10",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "subdued body-m mb-4",
                children: "Want to learn more? Accept this deal in ICM to view the complete dataroom."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "subdued body-m mb-4",
                children: "Please ensure you have a signed MNDA with Hum Capital to activate the dataroom."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                disabled: deactivate,
                onClick: ()=>window.open(link, "_blank"),
                className: "lg flex items-center gap-2",
                children: [
                    "View Dataroom",
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).ExternalLink, {
                        className: "size-8 fill-white"
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("gMxRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $43d8e1dcd4d8160d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $YHMTU = parcelRequire("YHMTU");
parcelRequire("gCemA");
var $3qMBE = parcelRequire("3qMBE");

var $2TuUj = parcelRequire("2TuUj");

var $lzNIT = parcelRequire("lzNIT");
function $43d8e1dcd4d8160d$var$LoginErrorPage() {
    const message = "We encountered a network error while trying to log you in. Please try again. If the problem persists, contact our support team for assistance.";
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $YHMTU.Onboarding).Layout, {
        centered: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex max-w-xl flex-col gap-10",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2TuUj.default), {
                    className: "mx-auto size-20"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-center",
                    children: "Sorry, something went wrong"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "body-l subdued text-center",
                    children: message
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center justify-center gap-8",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.NavLink), {
                            to: "/logout",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "md w-[118px]",
                                children: "Retry Login"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: "https://info.humcapital.com/hum-help-center/kb-tickets/new",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "Talk to our team"
                        })
                    ]
                })
            ]
        })
    });
}
var $43d8e1dcd4d8160d$export$2e2bcd8739ae039 = (0, $3qMBE.asPage)($43d8e1dcd4d8160d$var$LoginErrorPage);

});

parcelRegister("1bRue", function(module, exports) {

$parcel$export(module.exports, "default", () => $824534f4202b4540$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("tL0U5");
var $4CoXh = parcelRequire("4CoXh");

var $43CNa = parcelRequire("43CNa");

var $bxDk4 = parcelRequire("bxDk4");
parcelRequire("18L7n");
var $5Ttm9 = parcelRequire("5Ttm9");
parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");

var $bCeTl = parcelRequire("bCeTl");

var $f19YE = parcelRequire("f19YE");

var $acw62 = parcelRequire("acw62");
function $824534f4202b4540$var$PostSignupPage() {
    const router = (0, $fp4OM.useRouter)();
    const token = (0, $43CNa.useToken)();
    const auth0 = (0, $bCeTl.useAuth0)();
    const cache = (0, $f19YE.useQueryClient)();
    const { mutate: create, isPending: isPending, data: createdUser } = (0, $4CoXh.useApiMutation)((0, $bxDk4.createUser), {
        waitForSession: false,
        onSuccess: (data)=>{
            cache.setQueryData([
                "/session"
            ], data);
            router.navigate(`/signup-complete`);
        }
    });
    const { role: role } = router.params;
    (0, $acw62.useEffect)(()=>{
        if (auth0.user?.sub && auth0.user?.email && token.data && role) {
            if (!isPending && !createdUser) create({
                email: auth0.user.email,
                auth0Id: auth0.user.sub,
                token: token.data,
                role: Array.isArray(role) ? role[0] : role
            });
        }
    }, [
        role,
        auth0.user?.sub,
        auth0.user?.email,
        token.data,
        isPending
    ]);
    // TODO HUM-2879: if !intent open a modal or show component
    // to get the intent from user (fundraise or invest)
    // if (!intent || (!isLoading && !isAuthenticated))
    //     return <Navigate to="error?type=auth" />;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
        fullScreen: true
    });
}
var $824534f4202b4540$export$2e2bcd8739ae039 = $824534f4202b4540$var$PostSignupPage;

});
parcelRegister("bxDk4", function(module, exports) {

$parcel$export(module.exports, "createUser", () => $6257d74bf686cd5d$export$3493b8991d49f558);
$parcel$export(module.exports, "updateUser", () => $6257d74bf686cd5d$export$e3ac7a5d19605772);
$parcel$export(module.exports, "sendVerificationEmail", () => $6257d74bf686cd5d$export$a82c31235528dbb3);
$parcel$export(module.exports, "resendInvite", () => $6257d74bf686cd5d$export$865741ffcb301176);
$parcel$export(module.exports, "sendPasswordReset", () => $6257d74bf686cd5d$export$db579c517e4aeb29);
parcelRequire("i5Lss");
var $2mq6B = parcelRequire("2mq6B");
var $gBHSi = parcelRequire("gBHSi");
const $6257d74bf686cd5d$export$3493b8991d49f558 = (0, $gBHSi.createMutation)(async ({ payload: payload })=>{
    const { email: email, auth0Id: auth0Id, role: role, token: token } = payload;
    return await (0, $2mq6B.createApiClient)({
        token: token,
        convert: false
    }).post(`/identity/users`, {
        ["auth0_id"]: auth0Id,
        user_role: role,
        email: email
    });
}, {
    waitForSession: false,
    mutationKey: [
        "createUser"
    ]
});
const $6257d74bf686cd5d$export$e3ac7a5d19605772 = (0, $gBHSi.createMutation)(({ session: session, payload: payload })=>{
    return (0, $2mq6B.createApiClient)({
        baseURL: `${"https://api2.humcapital.com"}`,
        token: session.token.data || ""
    }).patch(`/identity/users/${session.user?.id}`, payload);
}, {
    errorToast: {
        message: "Failed to save details",
        options: {
            description: "Please try again or contact support."
        }
    },
    invalidates: [
        "/session",
        "/companies",
        "Company Onboarding"
    ]
});
const $6257d74bf686cd5d$export$a82c31235528dbb3 = (0, $gBHSi.createMutation)(({ session: session })=>{
    return (0, $2mq6B.createApiClient)({
        baseURL: `${"https://api2.humcapital.com"}`,
        token: session.token.data || ""
    }).post(`/identity/verify-email`, {});
}, {
    successToast: {
        message: "We've sent a verification email"
    },
    errorToast: {
        message: "Failed to send verification email"
    }
});
const $6257d74bf686cd5d$export$865741ffcb301176 = (0, $gBHSi.createMutation)(({ api: api, payload: payload })=>{
    return api.post(`/identity/reset-password-email`, {
        email: payload.email,
        isInvite: payload.isInvite
    });
}, {
    successToast: {
        message: "Invite resent"
    },
    errorToast: {
        message: "Failed to resend invite"
    }
});
const $6257d74bf686cd5d$export$db579c517e4aeb29 = (0, $gBHSi.createMutation)(({ payload: payload })=>{
    return (0, $2mq6B.createApiClient)({
        baseURL: `${"https://api2.humcapital.com"}`
    }).post(`/identity/reset-password-email`, {
        email: payload.email,
        isInvite: false
    });
}, {
    waitForSession: false,
    successToast: {
        message: "Reset password email sent"
    },
    errorToast: {
        message: "Failed to send reset password email"
    }
});

});


parcelRegister("7EKKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9b542d1a0950750$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("ct56T");
var $edg5W = parcelRequire("edg5W");
parcelRequire("18L7n");
var $5Ttm9 = parcelRequire("5Ttm9");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");
function $c9b542d1a0950750$var$SignupCompletePage() {
    const { user: user } = (0, $edg5W.useSession)();
    (0, $acw62.useEffect)(()=>{
        window.location.reload();
    }, []);
    if (user) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: "/"
    });
    // TODO: add timeout
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
        fullScreen: true
    });
}
var $c9b542d1a0950750$export$2e2bcd8739ae039 = $c9b542d1a0950750$var$SignupCompletePage;

});
parcelRegister("ct56T", function(module, exports) {
$parcel$export(module.exports, "useSession", () => (parcelRequire("edg5W")).useSession);
parcelRequire("kL9vD");
parcelRequire("2gHT7");

});


parcelRegister("8vLZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f08bc309bed60ef1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("tL0U5");
var $4CoXh = parcelRequire("4CoXh");
parcelRequire("hb9Mc");
var $bxDk4 = parcelRequire("bxDk4");

var $YHMTU = parcelRequire("YHMTU");
parcelRequire("18L7n");
var $ddmfx = parcelRequire("ddmfx");
var $5Ttm9 = parcelRequire("5Ttm9");

var $acw62 = parcelRequire("acw62");

var $1ii2J = parcelRequire("1ii2J");

var $6kDFU = parcelRequire("6kDFU");
parcelRequire("ct56T");
var $edg5W = parcelRequire("edg5W");
function $f08bc309bed60ef1$export$2e2bcd8739ae039() {
    const [emailSent, setEmailSent] = (0, $1ii2J.useAtom)((0, $6kDFU.emailSentAtom));
    const { mutate: verifyEmail, isPending: isPending } = (0, $4CoXh.useApiMutation)((0, $bxDk4.sendVerificationEmail));
    const session = (0, $edg5W.useSession)();
    const email = session.user?.email;
    (0, $acw62.useEffect)(()=>{
        if (!emailSent) {
            verifyEmail();
            setEmailSent(true);
        }
    }, [
        emailSent
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddmfx.Illustration).VerifyEmail, {
                className: "mx-auto mt-0 size-48"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $YHMTU.Onboarding).TextBlock, {
                title: "Verify your email",
                description: `We\u{2019}ve sent a verification email to ${email}. Click the
                    link inside to continue.`
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                className: "xl w-full",
                onClick: ()=>verifyEmail(),
                disabled: isPending,
                children: [
                    isPending ? "Sending" : "Resend Email",
                    isPending && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {})
                ]
            })
        ]
    });
}

});
parcelRegister("hb9Mc", function(module, exports) {
$parcel$export(module.exports, "trackUserIdentity", () => (parcelRequire("1jzUO")).trackUserIdentity);
$parcel$export(module.exports, "resendInvite", () => (parcelRequire("bxDk4")).resendInvite);
$parcel$export(module.exports, "sendPasswordReset", () => (parcelRequire("bxDk4")).sendPasswordReset);
$parcel$export(module.exports, "sendVerificationEmail", () => (parcelRequire("bxDk4")).sendVerificationEmail);
$parcel$export(module.exports, "updateUser", () => (parcelRequire("bxDk4")).updateUser);
parcelRequire("1jzUO");
parcelRequire("8LEhm");
parcelRequire("bxDk4");

});
parcelRegister("1jzUO", function(module, exports) {

$parcel$export(module.exports, "trackUserIdentity", () => $93d5684c9c34a7bf$export$6f28a463b205e46b);

var $cNbKI = parcelRequire("cNbKI");
function $93d5684c9c34a7bf$export$6f28a463b205e46b(company, user, flagsmith) {
    if (user) {
        if (!flagsmith.identity) flagsmith.identify(user.email, {
            id: user.id,
            email: user.email ?? "",
            isAdmin: !!user.isAdmin,
            isCompany: !!user.isCompany,
            isFund: !!user.isFund,
            firstName: user.firstName ?? "",
            lastName: user.lastName ?? ""
        });
        (0, $cNbKI.datadogRum).setUser({
            ...user,
            id: user.id.toString(),
            name: `${user.firstName} ${user.lastName}`,
            company: {
                id: company?.id.toString(),
                name: company?.name,
                uuid: company?.uuid
            }
        });
    }
}

});


parcelRegister("6kDFU", function(module, exports) {

$parcel$export(module.exports, "emailSentAtom", () => $e0f08f1682c0c160$export$c8e50ea8dd92811f);

var $65mEx = parcelRequire("65mEx");
function $e0f08f1682c0c160$var$atomWithLocalStorage(key, initialValue) {
    const getInitialValue = ()=>{
        const storedValue = localStorage.getItem(key);
        if (storedValue) try {
            return JSON.parse(storedValue);
        } catch (e) {
            console.warn(`Error parsing localStorage key "${key}":`, e);
            localStorage.removeItem(key);
        }
        return initialValue;
    };
    return (0, $65mEx.atomWithStorage)(key, getInitialValue());
}
const $e0f08f1682c0c160$export$c8e50ea8dd92811f = $e0f08f1682c0c160$var$atomWithLocalStorage("emailSent", false);

});
parcelRegister("65mEx", function(module, exports) {
"use strict";

var $j3Led = parcelRequire("j3Led");

var $aoea5 = parcelRequire("aoea5");
Object.keys($j3Led).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call(module.exports, k)) Object.defineProperty(module.exports, k, {
        enumerable: true,
        get: function() {
            return $j3Led[k];
        }
    });
});
Object.keys($aoea5).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call(module.exports, k)) Object.defineProperty(module.exports, k, {
        enumerable: true,
        get: function() {
            return $aoea5[k];
        }
    });
});

});
parcelRegister("j3Led", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $de02eeb5a74d53ba$export$4a991c87e640ef77, (v) => $de02eeb5a74d53ba$export$4a991c87e640ef77 = v);
$parcel$export(module.exports, "atomFamily", () => $de02eeb5a74d53ba$export$98dc87c59e005bfc, (v) => $de02eeb5a74d53ba$export$98dc87c59e005bfc = v);
$parcel$export(module.exports, "atomWithDefault", () => $de02eeb5a74d53ba$export$2d6fff7aed134d89, (v) => $de02eeb5a74d53ba$export$2d6fff7aed134d89 = v);
$parcel$export(module.exports, "atomWithLazy", () => $de02eeb5a74d53ba$export$fd6cc418c371333, (v) => $de02eeb5a74d53ba$export$fd6cc418c371333 = v);
$parcel$export(module.exports, "atomWithObservable", () => $de02eeb5a74d53ba$export$3b2a8474031f51b9, (v) => $de02eeb5a74d53ba$export$3b2a8474031f51b9 = v);
$parcel$export(module.exports, "atomWithReducer", () => $de02eeb5a74d53ba$export$17495099fe18a247, (v) => $de02eeb5a74d53ba$export$17495099fe18a247 = v);
$parcel$export(module.exports, "atomWithRefresh", () => $de02eeb5a74d53ba$export$3b2add07a6d4dc2e, (v) => $de02eeb5a74d53ba$export$3b2add07a6d4dc2e = v);
$parcel$export(module.exports, "atomWithReset", () => $de02eeb5a74d53ba$export$1f78fd6066f888bc, (v) => $de02eeb5a74d53ba$export$1f78fd6066f888bc = v);
$parcel$export(module.exports, "atomWithStorage", () => $de02eeb5a74d53ba$export$19a57601fe8d8f7b, (v) => $de02eeb5a74d53ba$export$19a57601fe8d8f7b = v);
$parcel$export(module.exports, "createJSONStorage", () => $de02eeb5a74d53ba$export$95a3b7b12ab518f9, (v) => $de02eeb5a74d53ba$export$95a3b7b12ab518f9 = v);
$parcel$export(module.exports, "freezeAtom", () => $de02eeb5a74d53ba$export$14251e990c96d1bb, (v) => $de02eeb5a74d53ba$export$14251e990c96d1bb = v);
$parcel$export(module.exports, "freezeAtomCreator", () => $de02eeb5a74d53ba$export$62f7c4fe911bb8cf, (v) => $de02eeb5a74d53ba$export$62f7c4fe911bb8cf = v);
$parcel$export(module.exports, "loadable", () => $de02eeb5a74d53ba$export$9bbab1a1471800d5, (v) => $de02eeb5a74d53ba$export$9bbab1a1471800d5 = v);
$parcel$export(module.exports, "selectAtom", () => $de02eeb5a74d53ba$export$36732b116f66dde9, (v) => $de02eeb5a74d53ba$export$36732b116f66dde9 = v);
$parcel$export(module.exports, "splitAtom", () => $de02eeb5a74d53ba$export$6fe7d67a9e4f1865, (v) => $de02eeb5a74d53ba$export$6fe7d67a9e4f1865 = v);
$parcel$export(module.exports, "unstable_withStorageValidator", () => $de02eeb5a74d53ba$export$f803079012337c0c, (v) => $de02eeb5a74d53ba$export$f803079012337c0c = v);
$parcel$export(module.exports, "unwrap", () => $de02eeb5a74d53ba$export$debb760848ca95a, (v) => $de02eeb5a74d53ba$export$debb760848ca95a = v);
var $de02eeb5a74d53ba$export$4a991c87e640ef77;
var $de02eeb5a74d53ba$export$98dc87c59e005bfc;
var $de02eeb5a74d53ba$export$2d6fff7aed134d89;
var $de02eeb5a74d53ba$export$fd6cc418c371333;
var $de02eeb5a74d53ba$export$3b2a8474031f51b9;
var $de02eeb5a74d53ba$export$17495099fe18a247;
var $de02eeb5a74d53ba$export$3b2add07a6d4dc2e;
var $de02eeb5a74d53ba$export$1f78fd6066f888bc;
var $de02eeb5a74d53ba$export$19a57601fe8d8f7b;
var $de02eeb5a74d53ba$export$95a3b7b12ab518f9;
var $de02eeb5a74d53ba$export$14251e990c96d1bb;
var $de02eeb5a74d53ba$export$62f7c4fe911bb8cf;
var $de02eeb5a74d53ba$export$9bbab1a1471800d5;
var $de02eeb5a74d53ba$export$36732b116f66dde9;
var $de02eeb5a74d53ba$export$6fe7d67a9e4f1865;
var $de02eeb5a74d53ba$export$f803079012337c0c;
var $de02eeb5a74d53ba$export$debb760848ca95a;
"use strict";

var $8dPdT = parcelRequire("8dPdT");
var $de02eeb5a74d53ba$var$RESET = Symbol("");
function $de02eeb5a74d53ba$var$atomWithReset(initialValue) {
    var anAtom = $8dPdT.atom(initialValue, function(get, set, update) {
        var nextValue = typeof update === "function" ? update(get(anAtom)) : update;
        set(anAtom, nextValue === $de02eeb5a74d53ba$var$RESET ? initialValue : nextValue);
    });
    return anAtom;
}
function $de02eeb5a74d53ba$var$atomWithReducer(initialValue, reducer) {
    return $8dPdT.atom(initialValue, function(get, set, action) {
        set(this, reducer(get(this), action));
    });
}
function $de02eeb5a74d53ba$var$_extends() {
    $de02eeb5a74d53ba$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $de02eeb5a74d53ba$var$_extends.apply(this, arguments);
}
function $de02eeb5a74d53ba$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $de02eeb5a74d53ba$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $de02eeb5a74d53ba$var$_arrayLikeToArray(o, minLen);
}
function $de02eeb5a74d53ba$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $de02eeb5a74d53ba$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $de02eeb5a74d53ba$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $de02eeb5a74d53ba$var$atomFamily(initializeAtom, areEqual) {
    var shouldRemove = null;
    var atoms = new Map();
    var createAtom = function createAtom(param) {
        var item;
        if (areEqual === undefined) item = atoms.get(param);
        else for(var _iterator = $de02eeb5a74d53ba$var$_createForOfIteratorHelperLoose(atoms), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            if (areEqual(key, param)) {
                item = value;
                break;
            }
        }
        if (item !== undefined) {
            if (shouldRemove != null && shouldRemove(item[1], param)) createAtom.remove(param);
            else return item[0];
        }
        var newAtom = initializeAtom(param);
        atoms.set(param, [
            newAtom,
            Date.now()
        ]);
        return newAtom;
    };
    createAtom.remove = function(param) {
        if (areEqual === undefined) atoms.delete(param);
        else for(var _iterator2 = $de02eeb5a74d53ba$var$_createForOfIteratorHelperLoose(atoms), _step2; !(_step2 = _iterator2()).done;){
            var _step2$value = _step2.value, key = _step2$value[0];
            if (areEqual(key, param)) {
                atoms.delete(key);
                break;
            }
        }
    };
    createAtom.setShouldRemove = function(fn) {
        shouldRemove = fn;
        if (!shouldRemove) return;
        for(var _iterator3 = $de02eeb5a74d53ba$var$_createForOfIteratorHelperLoose(atoms), _step3; !(_step3 = _iterator3()).done;){
            var _step3$value = _step3.value, key = _step3$value[0], value = _step3$value[1];
            if (shouldRemove(value[1], key)) atoms.delete(key);
        }
    };
    return createAtom;
}
var $de02eeb5a74d53ba$var$getCached$2 = function getCached(c, m, k) {
    return (m.has(k) ? m : m.set(k, c())).get(k);
};
var $de02eeb5a74d53ba$var$cache1$3 = new WeakMap();
var $de02eeb5a74d53ba$var$memo3 = function memo3(create, dep1, dep2, dep3) {
    var cache2 = $de02eeb5a74d53ba$var$getCached$2(function() {
        return new WeakMap();
    }, $de02eeb5a74d53ba$var$cache1$3, dep1);
    var cache3 = $de02eeb5a74d53ba$var$getCached$2(function() {
        return new WeakMap();
    }, cache2, dep2);
    return $de02eeb5a74d53ba$var$getCached$2(create, cache3, dep3);
};
function $de02eeb5a74d53ba$var$selectAtom(anAtom, selector, equalityFn) {
    if (equalityFn === void 0) equalityFn = Object.is;
    return $de02eeb5a74d53ba$var$memo3(function() {
        var EMPTY = Symbol();
        var selectValue = function selectValue(_ref) {
            var value = _ref[0], prevSlice = _ref[1];
            if (prevSlice === EMPTY) return selector(value);
            var slice = selector(value, prevSlice);
            return equalityFn(prevSlice, slice) ? prevSlice : slice;
        };
        var derivedAtom = $8dPdT.atom(function(get) {
            var prev = get(derivedAtom);
            var value = get(anAtom);
            return selectValue([
                value,
                prev
            ]);
        });
        derivedAtom.init = EMPTY;
        return derivedAtom;
    }, anAtom, selector, equalityFn);
}
var $de02eeb5a74d53ba$var$frozenAtoms = new WeakSet();
var $de02eeb5a74d53ba$var$deepFreeze = function deepFreeze(obj) {
    if (typeof obj !== "object" || obj === null) return;
    Object.freeze(obj);
    var propNames = Object.getOwnPropertyNames(obj);
    for(var _iterator = $de02eeb5a74d53ba$var$_createForOfIteratorHelperLoose(propNames), _step; !(_step = _iterator()).done;){
        var name = _step.value;
        var value = obj[name];
        deepFreeze(value);
    }
    return obj;
};
function $de02eeb5a74d53ba$var$freezeAtom(anAtom) {
    if ($de02eeb5a74d53ba$var$frozenAtoms.has(anAtom)) return anAtom;
    $de02eeb5a74d53ba$var$frozenAtoms.add(anAtom);
    var origRead = anAtom.read;
    anAtom.read = function(get, options) {
        return $de02eeb5a74d53ba$var$deepFreeze(origRead.call(this, get, options));
    };
    if ("write" in anAtom) {
        var origWrite = anAtom.write;
        anAtom.write = function(get, set) {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            return origWrite.call.apply(origWrite, [
                this,
                get,
                function() {
                    for(var _len2 = arguments.length, setArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)setArgs[_key2] = arguments[_key2];
                    if (setArgs[0] === anAtom) setArgs[1] = $de02eeb5a74d53ba$var$deepFreeze(setArgs[1]);
                    return set.apply(void 0, setArgs);
                }
            ].concat(args));
        };
    }
    return anAtom;
}
function $de02eeb5a74d53ba$var$freezeAtomCreator(createAtom) {
    return function() {
        return $de02eeb5a74d53ba$var$freezeAtom(createAtom.apply(void 0, arguments));
    };
}
var $de02eeb5a74d53ba$var$getCached$1 = function getCached(c, m, k) {
    return (m.has(k) ? m : m.set(k, c())).get(k);
};
var $de02eeb5a74d53ba$var$cache1$2 = new WeakMap();
var $de02eeb5a74d53ba$var$memo2$1 = function memo2(create, dep1, dep2) {
    var cache2 = $de02eeb5a74d53ba$var$getCached$1(function() {
        return new WeakMap();
    }, $de02eeb5a74d53ba$var$cache1$2, dep1);
    return $de02eeb5a74d53ba$var$getCached$1(create, cache2, dep2);
};
var $de02eeb5a74d53ba$var$cacheKeyForEmptyKeyExtractor = {};
var $de02eeb5a74d53ba$var$isWritable = function isWritable(atom) {
    return !!atom.write;
};
var $de02eeb5a74d53ba$var$isFunction = function isFunction(x) {
    return typeof x === "function";
};
function $de02eeb5a74d53ba$var$splitAtom(arrAtom, keyExtractor) {
    return $de02eeb5a74d53ba$var$memo2$1(function() {
        var mappingCache = new WeakMap();
        var getMapping = function getMapping(arr, prev) {
            var mapping = mappingCache.get(arr);
            if (mapping) return mapping;
            var prevMapping = prev && mappingCache.get(prev);
            var atomList = [];
            var keyList = [];
            arr.forEach(function(item, index) {
                var key = keyExtractor ? keyExtractor(item) : index;
                keyList[index] = key;
                var cachedAtom = prevMapping && prevMapping.atomList[prevMapping.keyList.indexOf(key)];
                if (cachedAtom) {
                    atomList[index] = cachedAtom;
                    return;
                }
                var read = function read(get) {
                    var prev = get(mappingAtom);
                    var currArr = get(arrAtom);
                    var mapping = getMapping(currArr, prev == null ? void 0 : prev.arr);
                    var index = mapping.keyList.indexOf(key);
                    if (index < 0 || index >= currArr.length) {
                        var prevItem = arr[getMapping(arr).keyList.indexOf(key)];
                        if (prevItem) return prevItem;
                        throw new Error("splitAtom: index out of bounds for read");
                    }
                    return currArr[index];
                };
                var write = function write(get, set, update) {
                    var prev = get(mappingAtom);
                    var arr = get(arrAtom);
                    var mapping = getMapping(arr, prev == null ? void 0 : prev.arr);
                    var index = mapping.keyList.indexOf(key);
                    if (index < 0 || index >= arr.length) throw new Error("splitAtom: index out of bounds for write");
                    var nextItem = $de02eeb5a74d53ba$var$isFunction(update) ? update(arr[index]) : update;
                    if (!Object.is(arr[index], nextItem)) set(arrAtom, [].concat(arr.slice(0, index), [
                        nextItem
                    ], arr.slice(index + 1)));
                };
                atomList[index] = $de02eeb5a74d53ba$var$isWritable(arrAtom) ? $8dPdT.atom(read, write) : $8dPdT.atom(read);
            });
            if (prevMapping && prevMapping.keyList.length === keyList.length && prevMapping.keyList.every(function(x, i) {
                return x === keyList[i];
            })) mapping = prevMapping;
            else mapping = {
                arr: arr,
                atomList: atomList,
                keyList: keyList
            };
            mappingCache.set(arr, mapping);
            return mapping;
        };
        var mappingAtom = $8dPdT.atom(function(get) {
            var prev = get(mappingAtom);
            var arr = get(arrAtom);
            var mapping = getMapping(arr, prev == null ? void 0 : prev.arr);
            return mapping;
        });
        mappingAtom.init = undefined;
        var splittedAtom = $de02eeb5a74d53ba$var$isWritable(arrAtom) ? $8dPdT.atom(function(get) {
            return get(mappingAtom).atomList;
        }, function(get, set, action) {
            switch(action.type){
                case "remove":
                    var index = get(splittedAtom).indexOf(action.atom);
                    if (index >= 0) {
                        var arr = get(arrAtom);
                        set(arrAtom, [].concat(arr.slice(0, index), arr.slice(index + 1)));
                    }
                    break;
                case "insert":
                    var _index = action.before ? get(splittedAtom).indexOf(action.before) : get(splittedAtom).length;
                    if (_index >= 0) {
                        var _arr = get(arrAtom);
                        set(arrAtom, [].concat(_arr.slice(0, _index), [
                            action.value
                        ], _arr.slice(_index)));
                    }
                    break;
                case "move":
                    var index1 = get(splittedAtom).indexOf(action.atom);
                    var index2 = action.before ? get(splittedAtom).indexOf(action.before) : get(splittedAtom).length;
                    if (index1 >= 0 && index2 >= 0) {
                        var _arr2 = get(arrAtom);
                        if (index1 < index2) set(arrAtom, [].concat(_arr2.slice(0, index1), _arr2.slice(index1 + 1, index2), [
                            _arr2[index1]
                        ], _arr2.slice(index2)));
                        else set(arrAtom, [].concat(_arr2.slice(0, index2), [
                            _arr2[index1]
                        ], _arr2.slice(index2, index1), _arr2.slice(index1 + 1)));
                    }
                    break;
            }
        }) : $8dPdT.atom(function(get) {
            return get(mappingAtom).atomList;
        });
        return splittedAtom;
    }, arrAtom, keyExtractor || $de02eeb5a74d53ba$var$cacheKeyForEmptyKeyExtractor);
}
function $de02eeb5a74d53ba$var$atomWithDefault(getDefault) {
    var EMPTY = Symbol();
    var overwrittenAtom = $8dPdT.atom(EMPTY);
    var anAtom = $8dPdT.atom(function(get, options) {
        var overwritten = get(overwrittenAtom);
        if (overwritten !== EMPTY) return overwritten;
        return getDefault(get, options);
    }, function(get, set, update) {
        if (update === $de02eeb5a74d53ba$var$RESET) set(overwrittenAtom, EMPTY);
        else if (typeof update === "function") {
            var prevValue = get(anAtom);
            set(overwrittenAtom, update(prevValue));
        } else set(overwrittenAtom, update);
    });
    return anAtom;
}
var $de02eeb5a74d53ba$var$isPromiseLike = function isPromiseLike(x) {
    return typeof (x == null ? void 0 : x.then) === "function";
};
function $de02eeb5a74d53ba$var$withStorageValidator(validator) {
    return function(unknownStorage) {
        var storage = $de02eeb5a74d53ba$var$_extends({}, unknownStorage, {
            getItem: function getItem(key, initialValue) {
                var validate = function validate(value) {
                    if (!validator(value)) return initialValue;
                    return value;
                };
                var value = unknownStorage.getItem(key, initialValue);
                if ($de02eeb5a74d53ba$var$isPromiseLike(value)) return value.then(validate);
                return validate(value);
            }
        });
        return storage;
    };
}
function $de02eeb5a74d53ba$var$createJSONStorage(getStringStorage, options) {
    if (getStringStorage === void 0) getStringStorage = function getStringStorage() {
        try {
            return window.localStorage;
        } catch (e) {
            return undefined;
        }
    };
    var lastStr;
    var lastValue;
    var storage = {
        getItem: function getItem(key, initialValue) {
            var _getStringStorage$get, _getStringStorage;
            var parse = function parse(str) {
                str = str || "";
                if (lastStr !== str) {
                    try {
                        lastValue = JSON.parse(str, options == null ? void 0 : options.reviver);
                    } catch (_unused) {
                        return initialValue;
                    }
                    lastStr = str;
                }
                return lastValue;
            };
            var str = (_getStringStorage$get = (_getStringStorage = getStringStorage()) == null ? void 0 : _getStringStorage.getItem(key)) != null ? _getStringStorage$get : null;
            if ($de02eeb5a74d53ba$var$isPromiseLike(str)) return str.then(parse);
            return parse(str);
        },
        setItem: function setItem(key, newValue) {
            var _getStringStorage2;
            return (_getStringStorage2 = getStringStorage()) == null ? void 0 : _getStringStorage2.setItem(key, JSON.stringify(newValue, options == null ? void 0 : options.replacer));
        },
        removeItem: function removeItem(key) {
            var _getStringStorage3;
            return (_getStringStorage3 = getStringStorage()) == null ? void 0 : _getStringStorage3.removeItem(key);
        }
    };
    if (typeof window !== "undefined" && typeof window.addEventListener === "function" && window.Storage) storage.subscribe = function(key, callback, initialValue) {
        if (!(getStringStorage() instanceof window.Storage)) return function() {};
        var storageEventCallback = function storageEventCallback(e) {
            if (e.storageArea === getStringStorage() && e.key === key) {
                var _newValue;
                try {
                    _newValue = JSON.parse(e.newValue || "");
                } catch (_unused2) {
                    _newValue = initialValue;
                }
                callback(_newValue);
            }
        };
        window.addEventListener("storage", storageEventCallback);
        return function() {
            window.removeEventListener("storage", storageEventCallback);
        };
    };
    return storage;
}
var $de02eeb5a74d53ba$var$defaultStorage = $de02eeb5a74d53ba$var$createJSONStorage();
function $de02eeb5a74d53ba$var$atomWithStorage(key, initialValue, storage, options) {
    if (storage === void 0) storage = $de02eeb5a74d53ba$var$defaultStorage;
    var getOnInit = options == null ? void 0 : options.getOnInit;
    var baseAtom = $8dPdT.atom(getOnInit ? storage.getItem(key, initialValue) : initialValue);
    baseAtom.onMount = function(setAtom) {
        setAtom(storage.getItem(key, initialValue));
        var unsub;
        if (storage.subscribe) unsub = storage.subscribe(key, setAtom, initialValue);
        return unsub;
    };
    var anAtom = $8dPdT.atom(function(get) {
        return get(baseAtom);
    }, function(get, set, update) {
        var nextValue = typeof update === "function" ? update(get(baseAtom)) : update;
        if (nextValue === $de02eeb5a74d53ba$var$RESET) {
            set(baseAtom, initialValue);
            return storage.removeItem(key);
        }
        if (nextValue instanceof Promise) return nextValue.then(function(resolvedValue) {
            set(baseAtom, resolvedValue);
            return storage.setItem(key, resolvedValue);
        });
        set(baseAtom, nextValue);
        return storage.setItem(key, nextValue);
    });
    return anAtom;
}
function $de02eeb5a74d53ba$var$atomWithObservable(getObservable, options) {
    var returnResultData = function returnResultData(result) {
        if ("e" in result) throw result.e;
        return result.d;
    };
    var observableResultAtom = $8dPdT.atom(function(get) {
        var _observable$Symbol$ob, _observable;
        var observable = getObservable(get);
        var itself = (_observable$Symbol$ob = (_observable = observable)[Symbol.observable]) == null ? void 0 : _observable$Symbol$ob.call(_observable);
        if (itself) observable = itself;
        var resolve;
        var makePending = function makePending() {
            return new Promise(function(r) {
                resolve = r;
            });
        };
        var initialResult = options && "initialValue" in options ? {
            d: typeof options.initialValue === "function" ? options.initialValue() : options.initialValue
        } : makePending();
        var setResult;
        var lastResult;
        var listener = function listener(result) {
            lastResult = result;
            resolve == null || resolve(result);
            setResult == null || setResult(result);
        };
        var subscription;
        var timer;
        var isNotMounted = function isNotMounted() {
            return !setResult;
        };
        var start = function start() {
            if (subscription) {
                clearTimeout(timer);
                subscription.unsubscribe();
            }
            subscription = observable.subscribe({
                next: function next(d) {
                    return listener({
                        d: d
                    });
                },
                error: function error(e) {
                    return listener({
                        e: e
                    });
                },
                complete: function complete() {}
            });
            if (isNotMounted() && options != null && options.unstable_timeout) timer = setTimeout(function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            }, options.unstable_timeout);
        };
        start();
        var resultAtom = $8dPdT.atom(lastResult || initialResult);
        resultAtom.onMount = function(update) {
            setResult = update;
            if (lastResult) update(lastResult);
            if (subscription) clearTimeout(timer);
            else start();
            return function() {
                setResult = undefined;
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        };
        return [
            resultAtom,
            observable,
            makePending,
            start,
            isNotMounted
        ];
    });
    var observableAtom = $8dPdT.atom(function(get) {
        var _get = get(observableResultAtom), resultAtom = _get[0];
        var result = get(resultAtom);
        if (result instanceof Promise) return result.then(returnResultData);
        return returnResultData(result);
    }, function(get, set, data) {
        var _get2 = get(observableResultAtom), resultAtom = _get2[0], observable = _get2[1], makePending = _get2[2], start = _get2[3], isNotMounted = _get2[4];
        if ("next" in observable) {
            if (isNotMounted()) {
                set(resultAtom, makePending());
                start();
            }
            observable.next(data);
        } else throw new Error("observable is not subject");
    });
    return observableAtom;
}
var $de02eeb5a74d53ba$var$cache1$1 = new WeakMap();
var $de02eeb5a74d53ba$var$memo1 = function memo1(create, dep1) {
    return ($de02eeb5a74d53ba$var$cache1$1.has(dep1) ? $de02eeb5a74d53ba$var$cache1$1 : $de02eeb5a74d53ba$var$cache1$1.set(dep1, create())).get(dep1);
};
var $de02eeb5a74d53ba$var$isPromise$1 = function isPromise(x) {
    return x instanceof Promise;
};
var $de02eeb5a74d53ba$var$LOADING = {
    state: "loading"
};
function $de02eeb5a74d53ba$var$loadable(anAtom) {
    return $de02eeb5a74d53ba$var$memo1(function() {
        var loadableCache = new WeakMap();
        var refreshAtom = $8dPdT.atom(0);
        var derivedAtom = $8dPdT.atom(function(get, _ref) {
            var setSelf = _ref.setSelf;
            get(refreshAtom);
            var value;
            try {
                value = get(anAtom);
            } catch (error) {
                return {
                    state: "hasError",
                    error: error
                };
            }
            if (!$de02eeb5a74d53ba$var$isPromise$1(value)) return {
                state: "hasData",
                data: value
            };
            var promise = value;
            var cached1 = loadableCache.get(promise);
            if (cached1) return cached1;
            if (promise.status === "fulfilled") loadableCache.set(promise, {
                state: "hasData",
                data: promise.value
            });
            else if (promise.status === "rejected") loadableCache.set(promise, {
                state: "hasError",
                error: promise.reason
            });
            else promise.then(function(data) {
                loadableCache.set(promise, {
                    state: "hasData",
                    data: data
                });
            }, function(error) {
                loadableCache.set(promise, {
                    state: "hasError",
                    error: error
                });
            }).finally(setSelf);
            var cached2 = loadableCache.get(promise);
            if (cached2) return cached2;
            loadableCache.set(promise, $de02eeb5a74d53ba$var$LOADING);
            return $de02eeb5a74d53ba$var$LOADING;
        }, function(_get, set) {
            set(refreshAtom, function(c) {
                return c + 1;
            });
        });
        return $8dPdT.atom(function(get) {
            return get(derivedAtom);
        });
    }, anAtom);
}
var $de02eeb5a74d53ba$var$getCached = function getCached(c, m, k) {
    return (m.has(k) ? m : m.set(k, c())).get(k);
};
var $de02eeb5a74d53ba$var$cache1 = new WeakMap();
var $de02eeb5a74d53ba$var$memo2 = function memo2(create, dep1, dep2) {
    var cache2 = $de02eeb5a74d53ba$var$getCached(function() {
        return new WeakMap();
    }, $de02eeb5a74d53ba$var$cache1, dep1);
    return $de02eeb5a74d53ba$var$getCached(create, cache2, dep2);
};
var $de02eeb5a74d53ba$var$isPromise = function isPromise(x) {
    return x instanceof Promise;
};
var $de02eeb5a74d53ba$var$defaultFallback = function defaultFallback() {
    return undefined;
};
function $de02eeb5a74d53ba$var$unwrap(anAtom, fallback) {
    if (fallback === void 0) fallback = $de02eeb5a74d53ba$var$defaultFallback;
    return $de02eeb5a74d53ba$var$memo2(function() {
        var promiseErrorCache = new WeakMap();
        var promiseResultCache = new WeakMap();
        var refreshAtom = $8dPdT.atom(0);
        var promiseAndValueAtom = $8dPdT.atom(function(get, _ref) {
            var setSelf = _ref.setSelf;
            get(refreshAtom);
            var prev = get(promiseAndValueAtom);
            var promise = get(anAtom);
            if (!$de02eeb5a74d53ba$var$isPromise(promise)) return {
                v: promise
            };
            if (promise !== (prev == null ? void 0 : prev.p)) {
                if (promise.status === "fulfilled") promiseResultCache.set(promise, promise.value);
                else if (promise.status === "rejected") promiseErrorCache.set(promise, promise.reason);
                else promise.then(function(v) {
                    return promiseResultCache.set(promise, v);
                }, function(e) {
                    return promiseErrorCache.set(promise, e);
                }).finally(setSelf);
            }
            if (promiseErrorCache.has(promise)) throw promiseErrorCache.get(promise);
            if (promiseResultCache.has(promise)) return {
                p: promise,
                v: promiseResultCache.get(promise)
            };
            if (prev && "v" in prev) return {
                p: promise,
                f: fallback(prev.v),
                v: prev.v
            };
            return {
                p: promise,
                f: fallback()
            };
        }, function(_get, set) {
            set(refreshAtom, function(c) {
                return c + 1;
            });
        });
        promiseAndValueAtom.init = undefined;
        return $8dPdT.atom(function(get) {
            var state = get(promiseAndValueAtom);
            if ("f" in state) return state.f;
            return state.v;
        }, function(_get, set) {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            return set.apply(void 0, [
                anAtom
            ].concat(args));
        });
    }, anAtom, fallback);
}
function $de02eeb5a74d53ba$var$atomWithRefresh(read, write) {
    var refreshAtom = $8dPdT.atom(0);
    return $8dPdT.atom(function(get, options) {
        get(refreshAtom);
        return read(get, options);
    }, function(get, set) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        if (args.length === 0) set(refreshAtom, function(c) {
            return c + 1;
        });
        else if (write) return write.apply(void 0, [
            get,
            set
        ].concat(args));
    });
}
function $de02eeb5a74d53ba$var$atomWithLazy(makeInitial) {
    var a = $8dPdT.atom(undefined);
    delete a.init;
    Object.defineProperty(a, "init", {
        get: function get() {
            return makeInitial();
        }
    });
    return a;
}
$de02eeb5a74d53ba$export$4a991c87e640ef77 = $de02eeb5a74d53ba$var$RESET;
$de02eeb5a74d53ba$export$98dc87c59e005bfc = $de02eeb5a74d53ba$var$atomFamily;
$de02eeb5a74d53ba$export$2d6fff7aed134d89 = $de02eeb5a74d53ba$var$atomWithDefault;
$de02eeb5a74d53ba$export$fd6cc418c371333 = $de02eeb5a74d53ba$var$atomWithLazy;
$de02eeb5a74d53ba$export$3b2a8474031f51b9 = $de02eeb5a74d53ba$var$atomWithObservable;
$de02eeb5a74d53ba$export$17495099fe18a247 = $de02eeb5a74d53ba$var$atomWithReducer;
$de02eeb5a74d53ba$export$3b2add07a6d4dc2e = $de02eeb5a74d53ba$var$atomWithRefresh;
$de02eeb5a74d53ba$export$1f78fd6066f888bc = $de02eeb5a74d53ba$var$atomWithReset;
$de02eeb5a74d53ba$export$19a57601fe8d8f7b = $de02eeb5a74d53ba$var$atomWithStorage;
$de02eeb5a74d53ba$export$95a3b7b12ab518f9 = $de02eeb5a74d53ba$var$createJSONStorage;
$de02eeb5a74d53ba$export$14251e990c96d1bb = $de02eeb5a74d53ba$var$freezeAtom;
$de02eeb5a74d53ba$export$62f7c4fe911bb8cf = $de02eeb5a74d53ba$var$freezeAtomCreator;
$de02eeb5a74d53ba$export$9bbab1a1471800d5 = $de02eeb5a74d53ba$var$loadable;
$de02eeb5a74d53ba$export$36732b116f66dde9 = $de02eeb5a74d53ba$var$selectAtom;
$de02eeb5a74d53ba$export$6fe7d67a9e4f1865 = $de02eeb5a74d53ba$var$splitAtom;
$de02eeb5a74d53ba$export$f803079012337c0c = $de02eeb5a74d53ba$var$withStorageValidator;
$de02eeb5a74d53ba$export$debb760848ca95a = $de02eeb5a74d53ba$var$unwrap;

});

parcelRegister("aoea5", function(module, exports) {

$parcel$export(module.exports, "useAtomCallback", () => $7907217eb0a09595$export$f562a3682ac84ee6, (v) => $7907217eb0a09595$export$f562a3682ac84ee6 = v);
$parcel$export(module.exports, "useHydrateAtoms", () => $7907217eb0a09595$export$5a6ea65993cf01b0, (v) => $7907217eb0a09595$export$5a6ea65993cf01b0 = v);
$parcel$export(module.exports, "useReducerAtom", () => $7907217eb0a09595$export$548a2b3f6cd62e2d, (v) => $7907217eb0a09595$export$548a2b3f6cd62e2d = v);
$parcel$export(module.exports, "useResetAtom", () => $7907217eb0a09595$export$7bcdee284706f2ec, (v) => $7907217eb0a09595$export$7bcdee284706f2ec = v);
var $7907217eb0a09595$export$f562a3682ac84ee6;
var $7907217eb0a09595$export$5a6ea65993cf01b0;
var $7907217eb0a09595$export$548a2b3f6cd62e2d;
var $7907217eb0a09595$export$7bcdee284706f2ec;
"use client";
"use strict";

var $acw62 = parcelRequire("acw62");

var $1ii2J = parcelRequire("1ii2J");

var $j3Led = parcelRequire("j3Led");

var $8dPdT = parcelRequire("8dPdT");
function $7907217eb0a09595$var$useResetAtom(anAtom, options) {
    var setAtom = $1ii2J.useSetAtom(anAtom, options);
    var resetAtom = $acw62.useCallback(function() {
        return setAtom($j3Led.RESET);
    }, [
        setAtom
    ]);
    return resetAtom;
}
function $7907217eb0a09595$var$useReducerAtom(anAtom, reducer, options) {
    var _useAtom = $1ii2J.useAtom(anAtom, options), state = _useAtom[0], setState = _useAtom[1];
    var dispatch = $acw62.useCallback(function(action) {
        setState(function(prev) {
            return reducer(prev, action);
        });
    }, [
        setState,
        reducer
    ]);
    return [
        state,
        dispatch
    ];
}
function $7907217eb0a09595$var$useAtomCallback(callback, options) {
    var anAtom = $acw62.useMemo(function() {
        return $8dPdT.atom(null, function(get, set) {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            return callback.apply(void 0, [
                get,
                set
            ].concat(args));
        });
    }, [
        callback
    ]);
    return $1ii2J.useSetAtom(anAtom, options);
}
function $7907217eb0a09595$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7907217eb0a09595$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7907217eb0a09595$var$_arrayLikeToArray(o, minLen);
}
function $7907217eb0a09595$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7907217eb0a09595$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $7907217eb0a09595$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $7907217eb0a09595$var$hydratedMap = new WeakMap();
function $7907217eb0a09595$var$useHydrateAtoms(values, options) {
    var store = $1ii2J.useStore(options);
    var hydratedSet = $7907217eb0a09595$var$getHydratedSet(store);
    for(var _iterator = $7907217eb0a09595$var$_createForOfIteratorHelperLoose(values), _step; !(_step = _iterator()).done;){
        var _step$value = _step.value, atom = _step$value[0], value = _step$value[1];
        if (!hydratedSet.has(atom) || options != null && options.dangerouslyForceHydrate) {
            hydratedSet.add(atom);
            store.set(atom, value);
        }
    }
}
var $7907217eb0a09595$var$getHydratedSet = function getHydratedSet(store) {
    var hydratedSet = $7907217eb0a09595$var$hydratedMap.get(store);
    if (!hydratedSet) {
        hydratedSet = new WeakSet();
        $7907217eb0a09595$var$hydratedMap.set(store, hydratedSet);
    }
    return hydratedSet;
};
$7907217eb0a09595$export$f562a3682ac84ee6 = $7907217eb0a09595$var$useAtomCallback;
$7907217eb0a09595$export$5a6ea65993cf01b0 = $7907217eb0a09595$var$useHydrateAtoms;
$7907217eb0a09595$export$548a2b3f6cd62e2d = $7907217eb0a09595$var$useReducerAtom;
$7907217eb0a09595$export$7bcdee284706f2ec = $7907217eb0a09595$var$useResetAtom;

});




parcelRegister("GnB8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef8438cc22ced441$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("tL0U5");
var $4CoXh = parcelRequire("4CoXh");
parcelRequire("hb9Mc");
var $bxDk4 = parcelRequire("bxDk4");
parcelRequire("18L7n");
var $hQ0nj = parcelRequire("hQ0nj");
var $bApKI = parcelRequire("bApKI");
var $fEJo6 = parcelRequire("fEJo6");
var $5Ttm9 = parcelRequire("5Ttm9");

var $9QePP = parcelRequire("9QePP");

var $hEJWZ = parcelRequire("hEJWZ");
const { Container: $ef8438cc22ced441$var$Container, Header: $ef8438cc22ced441$var$Header } = (0, $fEJo6.MultiStepForm);
function $ef8438cc22ced441$var$ResetPasswordPage() {
    const { mutate: resetPassword, isPending: isResettingPassword } = (0, $4CoXh.useApiMutation)((0, $bxDk4.sendPasswordReset));
    const handleSubmit = (data)=>{
        resetPassword({
            email: data.email
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ef8438cc22ced441$var$Container, {
        centered: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, $9QePP.default)("flex flex-col gap-8", "items-center justify-center", "md:flex-row", "h-screen"),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb-8 w-full md:mb-0 md:w-[450px]",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($ef8438cc22ced441$var$Header, {
                        title: "Reset Your Password",
                        description: "Enter the email address associated with your Hum Capital account, and we\u2019ll send you a link to reset your password."
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w-full md:w-[500px]",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($ef8438cc22ced441$var$ResetPasswordForm, {
                            onSubmit: handleSubmit,
                            isSubmitting: isResettingPassword
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mx-auto mt-4 w-full text-center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: "/login",
                                children: "Back to Hum Capital"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
const $ef8438cc22ced441$var$ResetPasswordForm = ({ onSubmit: onSubmit, isSubmitting: isSubmitting })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hQ0nj.Form), {
        id: "reset-password:form",
        schema: $ef8438cc22ced441$var$ResetPasswordForm.schema,
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bApKI.Input), {
                name: "email",
                label: "Email address",
                placeholder: "Enter your email",
                disabled: isSubmitting
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                type: "submit",
                className: "lg mt-6 w-full",
                disabled: isSubmitting,
                form: "reset-password:form",
                children: [
                    isSubmitting ? "Sending" : "Continue",
                    isSubmitting && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {})
                ]
            })
        ]
    });
};
$ef8438cc22ced441$var$ResetPasswordForm.schema = $hEJWZ.object({
    email: $hEJWZ.string().email("Please enter a valid email address").required()
});
var $ef8438cc22ced441$export$2e2bcd8739ae039 = $ef8438cc22ced441$var$ResetPasswordPage;

});


parcelRegister("feEs1", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("2xY7I")).default);
parcelRequire("jUSgZ");

var $2xY7I = parcelRequire("2xY7I");

});
parcelRegister("jUSgZ", function(module, exports) {

$parcel$export(module.exports, "HomePage", () => (parcelRequire("3fKr5")).default);

var $3fKr5 = parcelRequire("3fKr5");

});
parcelRegister("3fKr5", function(module, exports) {

$parcel$export(module.exports, "default", () => $3368c55d6fbaef18$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("18L7n");
var $TzpgG = parcelRequire("TzpgG");

var $9QePP = parcelRequire("9QePP");

var $bBEp3 = parcelRequire("bBEp3");

var $cUmUK = parcelRequire("cUmUK");

var $j6N0v = parcelRequire("j6N0v");

var $5u3uw = parcelRequire("5u3uw");

var $r2uF6 = parcelRequire("r2uF6");

var $jY502 = parcelRequire("jY502");

var $fRJCp = parcelRequire("fRJCp");

var $dNvz7 = parcelRequire("dNvz7");

var $dJVCx = parcelRequire("dJVCx");
function $3368c55d6fbaef18$var$HomePage() {
    const selectedTab = (0, $r2uF6.useAtomValue)((0, $jY502.tabNavAtom));
    const selectedSection = (0, $r2uF6.useAtomValue)((0, $jY502.selectedTabAtom));
    const isCondensed = (0, $r2uF6.useAtomValue)((0, $jY502.condensedChartsAtom));
    const currentSection = (0, $dJVCx.getSectionsForTab)(selectedTab).find((s)=>s.id === selectedSection);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $TzpgG.Dashboard), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bBEp3.SectionList), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: (0, $9QePP.default)("bg-default z-[1000]", "sticky top-0 pb-8"),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cUmUK.PageHeading), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j6N0v.TabNavigation), {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5u3uw.CondenseToggle), {})
                                ]
                            })
                        ]
                    }),
                    selectedTab === (0, $jY502.Tab).EXECUTIVE_SUMMARY && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                        layout: true,
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            y: 0,
                            opacity: 1
                        },
                        exit: {
                            opacity: 0
                        },
                        transition: {
                            duration: 0.3
                        },
                        className: (0, $9QePP.default)("grid gap-8 pb-8", isCondensed ? "grid-cols-2" : "grid-cols-1", "w-full"),
                        children: (()=>{
                            return currentSection ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNvz7.SectionContent), {
                                sectionConfig: currentSection,
                                tabKey: selectedTab
                            }) : null;
                        })()
                    }, "analytics-grid"),
                    selectedTab === (0, $jY502.Tab).PRE_MEMO && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                        layout: true,
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            y: 0,
                            opacity: 1
                        },
                        exit: {
                            opacity: 0
                        },
                        transition: {
                            duration: 0.3
                        },
                        className: (0, $9QePP.default)("grid gap-8 pb-8", isCondensed ? "grid-cols-2" : "grid-cols-1", "w-full"),
                        children: (()=>{
                            return currentSection ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNvz7.SectionContent), {
                                sectionConfig: currentSection,
                                tabKey: selectedTab
                            }) : null;
                        })()
                    }, "analytics-grid"),
                    selectedTab === (0, $jY502.Tab).FULL_MEMO && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                        layout: true,
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            y: 0,
                            opacity: 1
                        },
                        exit: {
                            opacity: 0
                        },
                        transition: {
                            duration: 0.3
                        },
                        className: (0, $9QePP.default)("grid gap-8 pb-8", isCondensed ? "grid-cols-2" : "grid-cols-1", "w-full"),
                        children: (()=>{
                            return currentSection ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dNvz7.SectionContent), {
                                sectionConfig: currentSection,
                                tabKey: selectedTab,
                                isCondensed: isCondensed
                            }) : null;
                        })()
                    }, "analytics-grid")
                ]
            })
        ]
    });
}
var $3368c55d6fbaef18$export$2e2bcd8739ae039 = $3368c55d6fbaef18$var$HomePage;

});
parcelRegister("bBEp3", function(module, exports) {

$parcel$export(module.exports, "SectionList", () => $4bf0f6090d371caf$export$6d1d899ad8590d82);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("18L7n");
var $TzpgG = parcelRequire("TzpgG");

var $2hw4u = parcelRequire("2hw4u");
var $fRJCp = parcelRequire("fRJCp");

var $r2uF6 = parcelRequire("r2uF6");

var $jY502 = parcelRequire("jY502");
parcelRequire("2bFYF");
var $fp4OM = parcelRequire("fp4OM");

var $dJVCx = parcelRequire("dJVCx");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");
function $4bf0f6090d371caf$export$6d1d899ad8590d82() {
    const [isOpen] = (0, $r2uF6.useAtom)((0, $TzpgG.dashboardDrawerAtom));
    const [selectedNavTab] = (0, $r2uF6.useAtom)((0, $jY502.tabNavAtom));
    const [selectedSection, setSelectedSection] = (0, $r2uF6.useAtom)((0, $jY502.selectedTabAtom));
    const router = (0, $fp4OM.useRouter)();
    const sections = (0, $dJVCx.getSectionsForTab)(selectedNavTab);
    (0, $acw62.useEffect)(()=>{
        const urlSection = router.search.section;
        if (sections.length > 0) {
            if (urlSection && sections.find((s)=>s.id === urlSection)) setSelectedSection(urlSection);
            else {
                const firstSection = sections[0].id;
                setSelectedSection(firstSection);
                router.updateSearch("section", firstSection);
            }
        }
    }, [
        sections,
        router.search.section,
        router,
        setSelectedSection
    ]);
    const handleSectionClick = (sectionId)=>{
        setSelectedSection(sectionId);
        router.updateSearch("section", sectionId);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: isOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2hw4u.AnimatePresence), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fRJCp.motion).div, {
                layout: true,
                initial: {
                    opacity: 0
                },
                animate: {
                    y: 0,
                    opacity: 1
                },
                exit: {
                    opacity: 0
                },
                transition: {
                    duration: 0.4
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "heading-m mb-6 mt-2 shrink-0",
                        children: selectedNavTab
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        className: (0, $9QePP.default)("flex flex-col", "max-h-[calc(100vh-200px)] gap-2 overflow-y-auto"),
                        children: sections.map((section)=>{
                            const isActive = selectedSection === section.id;
                            return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>!section.deactivated && handleSectionClick(section.id),
                                    className: (0, $9QePP.default)("body-s block w-full text-left", "fade-container cursor-pointer rounded-lg p-2 pl-3", isActive ? "bg-default text-primary font-medium" : "text-color hover:bg-default hover:text-color bg-transparent", section.deactivated && "text-gray-400 hover:bg-transparent hover:text-gray-400"),
                                    children: section.title
                                })
                            }, section.id);
                        })
                    })
                ]
            })
        })
    });
}

});
parcelRegister("jY502", function(module, exports) {

$parcel$export(module.exports, "Tab", () => $e2f23036d4901692$export$3e41faf802a29e71);
$parcel$export(module.exports, "tabNavAtom", () => $e2f23036d4901692$export$7e9f5b2e30a4d93d);
$parcel$export(module.exports, "condensedChartsAtom", () => $e2f23036d4901692$export$1e1f07b8da50f085);
$parcel$export(module.exports, "selectedTabAtom", () => $e2f23036d4901692$export$d59fa05ea03e661b);

var $r2uF6 = parcelRequire("r2uF6");
var $e2f23036d4901692$export$3e41faf802a29e71;
(function(Tab) {
    Tab["FULL_MEMO"] = "Full Memo";
    Tab["EXECUTIVE_SUMMARY"] = "Executive Summary";
    Tab["PRE_MEMO"] = "Pre-Memo";
})($e2f23036d4901692$export$3e41faf802a29e71 || ($e2f23036d4901692$export$3e41faf802a29e71 = {}));
const $e2f23036d4901692$export$7e9f5b2e30a4d93d = (0, $r2uF6.atom)("Full Memo");
const $e2f23036d4901692$export$1e1f07b8da50f085 = (0, $r2uF6.atom)(true);
const $e2f23036d4901692$export$d59fa05ea03e661b = (0, $r2uF6.atom)("introduction");

});

parcelRegister("dJVCx", function(module, exports) {

$parcel$export(module.exports, "getSectionsForTab", () => $a946327aec63eadf$export$e8a224d145fe5e16);

var $jY502 = parcelRequire("jY502");
const $a946327aec63eadf$export$b0fdb1e0bc5f0910 = {
    [(0, $jY502.Tab).EXECUTIVE_SUMMARY]: [],
    [(0, $jY502.Tab).PRE_MEMO]: [],
    [(0, $jY502.Tab).FULL_MEMO]: [
        {
            id: "introduction",
            title: "Gumps Overview",
            widgets: [
                {
                    id: "company-overview",
                    title: "Company Overview",
                    dataKey: "companyOverview",
                    defaultOpen: true
                },
                {
                    id: "risks",
                    title: "Risks",
                    dataKey: "risks",
                    defaultOpen: false
                },
                {
                    id: "products-services",
                    title: "Products & Services",
                    dataKey: "productsAndServices",
                    defaultOpen: false
                },
                {
                    id: "leadership",
                    title: "Leadership Team",
                    dataKey: "leadership",
                    defaultOpen: false
                },
                {
                    id: "funding-valuation",
                    title: "Funding & Valuation",
                    dataKey: "fundingAndValuation",
                    defaultOpen: false
                },
                {
                    id: "recent-developments",
                    title: "Recent Developments",
                    dataKey: "recentDevelopments",
                    defaultOpen: false
                },
                {
                    id: "online-presence",
                    title: "Online Presence",
                    dataKey: "onlinePresence",
                    defaultOpen: false
                },
                {
                    id: "cash_flow_progression",
                    title: "Cashflow Progression",
                    dataKey: "cashflowProgression",
                    defaultOpen: true,
                    isChart: true,
                    chartType: "CashFlowProgression"
                },
                {
                    id: "asset_progression",
                    title: "Asset Progression",
                    dataKey: "assetProgression",
                    defaultOpen: true,
                    isChart: true,
                    chartType: "AssetProgression"
                },
                {
                    id: "liquidity",
                    title: "Liquidity",
                    dataKey: "liquidity",
                    defaultOpen: true,
                    isChart: true,
                    chartType: "Liquidity"
                }
            ]
        },
        {
            id: "market-background",
            title: "Market Background",
            widgets: [
                {
                    id: "summary",
                    title: "Summary, risk and missing info",
                    dataKey: "summary",
                    defaultOpen: true
                },
                {
                    id: "porter-five-forces",
                    title: "Porter's Five Forces",
                    dataKey: "porterFiveForces",
                    defaultOpen: false
                },
                {
                    id: "hamilton-powers",
                    title: "Hamilton Powers",
                    dataKey: "hamiltonPowers",
                    defaultOpen: false
                },
                {
                    id: "top-competitors",
                    title: "Top Competitors",
                    dataKey: "topCompetitors",
                    defaultOpen: false
                },
                {
                    id: "market-customers",
                    title: "Market Customers",
                    dataKey: "marketCustomers",
                    defaultOpen: false
                },
                {
                    id: "market-niche",
                    title: "Market Niche",
                    dataKey: "marketNiche",
                    defaultOpen: false
                },
                {
                    id: "bull-market",
                    title: "Bull Market",
                    dataKey: "bullMarket",
                    defaultOpen: false
                },
                {
                    id: "bear-market",
                    title: "Bear Market",
                    dataKey: "bearMarket",
                    defaultOpen: false
                }
            ]
        },
        {
            id: "team-background",
            title: "MGMT Team Background",
            widgets: [
                {
                    id: "founders",
                    title: "Founders",
                    dataKey: "founders",
                    defaultOpen: true
                }
            ]
        },
        {
            id: "capital-deal-structure",
            title: "Capital & Deal Structure",
            widgets: [
                {
                    id: "debt_service_coverage",
                    title: "Debt Service Coverage",
                    dataKey: "debtServiceCoverage",
                    defaultOpen: true,
                    isChart: true,
                    chartType: "DebtServiceCoverage"
                },
                {
                    id: "debt_to_cashflows",
                    title: "Debt to Cashflows",
                    dataKey: "debtToCashflows",
                    defaultOpen: true,
                    isChart: true,
                    chartType: "DebtToCashflows"
                },
                {
                    id: "disbursements_and_repayments",
                    title: "Disbursements & Repayments",
                    dataKey: "disbursementsAndRepayments",
                    defaultOpen: true,
                    isChart: true,
                    chartType: "DisbursementsAndRepayments"
                },
                {
                    id: "senior_vs_other_debt",
                    title: "Debt Composition",
                    dataKey: "debtComposition",
                    defaultOpen: true,
                    isChart: true,
                    chartType: "DebtComposition"
                }
            ]
        },
        {
            id: "audit-results",
            title: "Audit Results",
            widgets: [],
            deactivated: true
        },
        {
            id: "operational-overview",
            title: "Operational Overview",
            widgets: [],
            deactivated: true
        },
        {
            id: "peer-analysis",
            title: "Peer Analysis",
            widgets: [],
            deactivated: true
        },
        {
            id: "unit-economics-analysis",
            title: "Unit Economics Analysis",
            widgets: [],
            deactivated: true
        },
        {
            id: "growth-analysis",
            title: "Growth Analysis",
            widgets: [],
            deactivated: true
        },
        {
            id: "products-services",
            title: "Products & Services",
            widgets: [],
            deactivated: true
        },
        {
            id: "assets-liabilities",
            title: "Assets & Liabilities",
            widgets: [],
            deactivated: true
        },
        {
            id: "regulatory-issues",
            title: "Regulatory & Legal Issues",
            widgets: [],
            deactivated: true
        },
        {
            id: "material-dependencies",
            title: "Material Dependencies",
            widgets: [],
            deactivated: true
        }
    ]
};
const $a946327aec63eadf$export$e8a224d145fe5e16 = (tab)=>{
    return $a946327aec63eadf$export$b0fdb1e0bc5f0910[tab] || [];
};

});


parcelRegister("cUmUK", function(module, exports) {

$parcel$export(module.exports, "PageHeading", () => $e814edbfbb43e86f$export$9716a88f5535df7c);

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $hhIsJ = parcelRequire("hhIsJ");
var $33ISo = parcelRequire("33ISo");
var $iIt79 = parcelRequire("iIt79");
var $cWbAg = parcelRequire("cWbAg");
var $ib9V1 = parcelRequire("ib9V1");
var $bRCUQ = parcelRequire("bRCUQ");
function $e814edbfbb43e86f$export$9716a88f5535df7c() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("pb-8"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-between",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "display-s mb-1",
                    children: "Gumps"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-wrap gap-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hhIsJ.default), {
                                className: "fill-subdued size-4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-s subdued",
                                children: "Last updated: 07/16/25"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $33ISo.default), {
                                className: "fill-subdued size-4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-s subdued",
                                children: "Luxury Retail"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iIt79.default), {
                                className: "fill-subdued size-4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-s subdued",
                                children: "$3M - $5.5M"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cWbAg.default), {
                                className: "fill-subdued size-4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-s subdued",
                                children: "gumps.com"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ib9V1.default), {
                                className: "fill-subdued size-4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-s subdued",
                                children: "CA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bRCUQ.default), {
                                className: "fill-subdued size-4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-s subdued",
                                children: "51-200"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("hhIsJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9568384986854ab$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $c9568384986854ab$var$ClockIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z",
        clipRule: "evenodd"
    }));
}
const $c9568384986854ab$var$ForwardRef = $acw62.forwardRef($c9568384986854ab$var$ClockIcon);
var $c9568384986854ab$export$2e2bcd8739ae039 = $c9568384986854ab$var$ForwardRef;

});

parcelRegister("33ISo", function(module, exports) {

$parcel$export(module.exports, "default", () => $23a47662fcf55748$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $23a47662fcf55748$var$CogIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M17.004 10.407c.138.435-.216.842-.672.842h-3.465a.75.75 0 0 1-.65-.375l-1.732-3c-.229-.396-.053-.907.393-1.004a5.252 5.252 0 0 1 6.126 3.537ZM8.12 8.464c.307-.338.838-.235 1.066.16l1.732 3a.75.75 0 0 1 0 .75l-1.732 3c-.229.397-.76.5-1.067.161A5.23 5.23 0 0 1 6.75 12a5.23 5.23 0 0 1 1.37-3.536ZM10.878 17.13c-.447-.098-.623-.608-.394-1.004l1.733-3.002a.75.75 0 0 1 .65-.375h3.465c.457 0 .81.407.672.842a5.252 5.252 0 0 1-6.126 3.539Z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M21 12.75a.75.75 0 1 0 0-1.5h-.783a8.22 8.22 0 0 0-.237-1.357l.734-.267a.75.75 0 1 0-.513-1.41l-.735.268a8.24 8.24 0 0 0-.689-1.192l.6-.503a.75.75 0 1 0-.964-1.149l-.6.504a8.3 8.3 0 0 0-1.054-.885l.391-.678a.75.75 0 1 0-1.299-.75l-.39.676a8.188 8.188 0 0 0-1.295-.47l.136-.77a.75.75 0 0 0-1.477-.26l-.136.77a8.36 8.36 0 0 0-1.377 0l-.136-.77a.75.75 0 1 0-1.477.26l.136.77c-.448.121-.88.28-1.294.47l-.39-.676a.75.75 0 0 0-1.3.75l.392.678a8.29 8.29 0 0 0-1.054.885l-.6-.504a.75.75 0 1 0-.965 1.149l.6.503a8.243 8.243 0 0 0-.689 1.192L3.8 8.216a.75.75 0 1 0-.513 1.41l.735.267a8.222 8.222 0 0 0-.238 1.356h-.783a.75.75 0 0 0 0 1.5h.783c.042.464.122.917.238 1.356l-.735.268a.75.75 0 0 0 .513 1.41l.735-.268c.197.417.428.816.69 1.191l-.6.504a.75.75 0 0 0 .963 1.15l.601-.505c.326.323.679.62 1.054.885l-.392.68a.75.75 0 0 0 1.3.75l.39-.679c.414.192.847.35 1.294.471l-.136.77a.75.75 0 0 0 1.477.261l.137-.772a8.332 8.332 0 0 0 1.376 0l.136.772a.75.75 0 1 0 1.477-.26l-.136-.771a8.19 8.19 0 0 0 1.294-.47l.391.677a.75.75 0 0 0 1.3-.75l-.393-.679a8.29 8.29 0 0 0 1.054-.885l.601.504a.75.75 0 0 0 .964-1.15l-.6-.503c.261-.375.492-.774.69-1.191l.735.267a.75.75 0 1 0 .512-1.41l-.734-.267c.115-.439.195-.892.237-1.356h.784Zm-2.657-3.06a6.744 6.744 0 0 0-1.19-2.053 6.784 6.784 0 0 0-1.82-1.51A6.705 6.705 0 0 0 12 5.25a6.8 6.8 0 0 0-1.225.11 6.7 6.7 0 0 0-2.15.793 6.784 6.784 0 0 0-2.952 3.489.76.76 0 0 1-.036.098A6.74 6.74 0 0 0 5.251 12a6.74 6.74 0 0 0 3.366 5.842l.009.005a6.704 6.704 0 0 0 2.18.798l.022.003a6.792 6.792 0 0 0 2.368-.004 6.704 6.704 0 0 0 2.205-.811 6.785 6.785 0 0 0 1.762-1.484l.009-.01.009-.01a6.743 6.743 0 0 0 1.18-2.066c.253-.707.39-1.469.39-2.263a6.74 6.74 0 0 0-.408-2.309Z",
        clipRule: "evenodd"
    }));
}
const $23a47662fcf55748$var$ForwardRef = $acw62.forwardRef($23a47662fcf55748$var$CogIcon);
var $23a47662fcf55748$export$2e2bcd8739ae039 = $23a47662fcf55748$var$ForwardRef;

});

parcelRegister("iIt79", function(module, exports) {

$parcel$export(module.exports, "default", () => $da02eb8cd7f41a9a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $da02eb8cd7f41a9a$var$CurrencyDollarIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M10.464 8.746c.227-.18.497-.311.786-.394v2.795a2.252 2.252 0 0 1-.786-.393c-.394-.313-.546-.681-.546-1.004 0-.323.152-.691.546-1.004ZM12.75 15.662v-2.824c.347.085.664.228.921.421.427.32.579.686.579.991 0 .305-.152.671-.579.991a2.534 2.534 0 0 1-.921.42Z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v.816a3.836 3.836 0 0 0-1.72.756c-.712.566-1.112 1.35-1.112 2.178 0 .829.4 1.612 1.113 2.178.502.4 1.102.647 1.719.756v2.978a2.536 2.536 0 0 1-.921-.421l-.879-.66a.75.75 0 0 0-.9 1.2l.879.66c.533.4 1.169.645 1.821.75V18a.75.75 0 0 0 1.5 0v-.81a4.124 4.124 0 0 0 1.821-.749c.745-.559 1.179-1.344 1.179-2.191 0-.847-.434-1.632-1.179-2.191a4.122 4.122 0 0 0-1.821-.75V8.354c.29.082.559.213.786.393l.415.33a.75.75 0 0 0 .933-1.175l-.415-.33a3.836 3.836 0 0 0-1.719-.755V6Z",
        clipRule: "evenodd"
    }));
}
const $da02eb8cd7f41a9a$var$ForwardRef = $acw62.forwardRef($da02eb8cd7f41a9a$var$CurrencyDollarIcon);
var $da02eb8cd7f41a9a$export$2e2bcd8739ae039 = $da02eb8cd7f41a9a$var$ForwardRef;

});

parcelRegister("cWbAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $96b3e3212bd7c9d9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $96b3e3212bd7c9d9$var$GlobeAltIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M21.721 12.752a9.711 9.711 0 0 0-.945-5.003 12.754 12.754 0 0 1-4.339 2.708 18.991 18.991 0 0 1-.214 4.772 17.165 17.165 0 0 0 5.498-2.477ZM14.634 15.55a17.324 17.324 0 0 0 .332-4.647c-.952.227-1.945.347-2.966.347-1.021 0-2.014-.12-2.966-.347a17.515 17.515 0 0 0 .332 4.647 17.385 17.385 0 0 0 5.268 0ZM9.772 17.119a18.963 18.963 0 0 0 4.456 0A17.182 17.182 0 0 1 12 21.724a17.18 17.18 0 0 1-2.228-4.605ZM7.777 15.23a18.87 18.87 0 0 1-.214-4.774 12.753 12.753 0 0 1-4.34-2.708 9.711 9.711 0 0 0-.944 5.004 17.165 17.165 0 0 0 5.498 2.477ZM21.356 14.752a9.765 9.765 0 0 1-7.478 6.817 18.64 18.64 0 0 0 1.988-4.718 18.627 18.627 0 0 0 5.49-2.098ZM2.644 14.752c1.682.971 3.53 1.688 5.49 2.099a18.64 18.64 0 0 0 1.988 4.718 9.765 9.765 0 0 1-7.478-6.816ZM13.878 2.43a9.755 9.755 0 0 1 6.116 3.986 11.267 11.267 0 0 1-3.746 2.504 18.63 18.63 0 0 0-2.37-6.49ZM12 2.276a17.152 17.152 0 0 1 2.805 7.121c-.897.23-1.837.353-2.805.353-.968 0-1.908-.122-2.805-.353A17.151 17.151 0 0 1 12 2.276ZM10.122 2.43a18.629 18.629 0 0 0-2.37 6.49 11.266 11.266 0 0 1-3.746-2.504 9.754 9.754 0 0 1 6.116-3.985Z"
    }));
}
const $96b3e3212bd7c9d9$var$ForwardRef = $acw62.forwardRef($96b3e3212bd7c9d9$var$GlobeAltIcon);
var $96b3e3212bd7c9d9$export$2e2bcd8739ae039 = $96b3e3212bd7c9d9$var$ForwardRef;

});

parcelRegister("ib9V1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3c0f2c0084fed92$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $d3c0f2c0084fed92$var$MapPinIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
        clipRule: "evenodd"
    }));
}
const $d3c0f2c0084fed92$var$ForwardRef = $acw62.forwardRef($d3c0f2c0084fed92$var$MapPinIcon);
var $d3c0f2c0084fed92$export$2e2bcd8739ae039 = $d3c0f2c0084fed92$var$ForwardRef;

});

parcelRegister("bRCUQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a32d4cfc6665099$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $8a32d4cfc6665099$var$UserIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z",
        clipRule: "evenodd"
    }));
}
const $8a32d4cfc6665099$var$ForwardRef = $acw62.forwardRef($8a32d4cfc6665099$var$UserIcon);
var $8a32d4cfc6665099$export$2e2bcd8739ae039 = $8a32d4cfc6665099$var$ForwardRef;

});


parcelRegister("j6N0v", function(module, exports) {

$parcel$export(module.exports, "TabNavigation", () => $d5707ca4cc0797d6$export$e5a23d189f4d5894);

var $ayMG0 = parcelRequire("ayMG0");

var $jY502 = parcelRequire("jY502");

var $dJVCx = parcelRequire("dJVCx");
parcelRequire("2bFYF");
var $fp4OM = parcelRequire("fp4OM");

var $9QePP = parcelRequire("9QePP");

var $fRJCp = parcelRequire("fRJCp");

var $r2uF6 = parcelRequire("r2uF6");
function $d5707ca4cc0797d6$export$e5a23d189f4d5894() {
    const [selectedTab, setSelectedTab] = (0, $r2uF6.useAtom)((0, $jY502.tabNavAtom));
    const [, setSelectedSection] = (0, $r2uF6.useAtom)((0, $jY502.selectedTabAtom));
    const router = (0, $fp4OM.useRouter)();
    const handleTabChange = (tab)=>{
        setSelectedTab(tab);
        const sectionsForTab = (0, $dJVCx.getSectionsForTab)(tab);
        const firstSection = sectionsForTab[0]?.id;
        if (firstSection) {
            setSelectedSection(firstSection);
            router.updateSearch("section", firstSection);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            className: "flex w-fit gap-[10px]",
            children: Object.values((0, $jY502.Tab)).map((tab)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                    onClick: ()=>{
                        if (tab === (0, $jY502.Tab).FULL_MEMO) handleTabChange(tab);
                    },
                    className: (0, $9QePP.default)("cursor-pointer"),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: (0, $9QePP.default)("body-s px-3 py-1.5", tab === selectedTab ? "text-color hover:text-color" : "cursor-default text-gray-400 hover:text-gray-400"),
                            children: tab
                        }),
                        tab === selectedTab ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                            className: "h-[3px] bg-brand-500 underline",
                            layoutId: "underline"
                        }) : null
                    ]
                }, tab))
        })
    });
}

});

parcelRegister("5u3uw", function(module, exports) {

$parcel$export(module.exports, "CondenseToggle", () => $990c786e702d2cc1$export$9fc76041adb41c74);

var $ayMG0 = parcelRequire("ayMG0");

var $jY502 = parcelRequire("jY502");

var $r2uF6 = parcelRequire("r2uF6");

var $9QePP = parcelRequire("9QePP");
function $990c786e702d2cc1$export$9fc76041adb41c74() {
    const [condensedCharts, setCondensedCharts] = (0, $r2uF6.useAtom)((0, $jY502.condensedChartsAtom));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex gap-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "group flex cursor-pointer gap-0.5",
                onClick: ()=>setCondensedCharts(true),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: (0, $9QePP.default)(condensedCharts ? "bg-white" : "bg-gray-500", "size-2.5 rounded-[1px] group-hover:bg-white")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: (0, $9QePP.default)(condensedCharts ? "bg-white" : "bg-gray-500", "size-2.5 rounded-[1px] group-hover:bg-white")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("flex flex-col", "group cursor-pointer gap-0.5"),
                onClick: ()=>setCondensedCharts(false),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: (0, $9QePP.default)(!condensedCharts ? "bg-white" : "bg-gray-500", "h-1 w-5 rounded-[1px] group-hover:bg-white")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: (0, $9QePP.default)(!condensedCharts ? "bg-white" : "bg-gray-500", "h-1 w-5 rounded-[1px] group-hover:bg-white")
                    })
                ]
            })
        ]
    });
}

});

parcelRegister("dNvz7", function(module, exports) {

$parcel$export(module.exports, "SectionContent", () => $52548a353ad2d099$export$51a9c37cab91cff6);

var $ayMG0 = parcelRequire("ayMG0");

var $cYKjA = parcelRequire("cYKjA");

var $95VSz = parcelRequire("95VSz");

var $4DcVl = parcelRequire("4DcVl");

var $1V5et = parcelRequire("1V5et");

var $bUG4S = parcelRequire("bUG4S");

var $8WQ3J = parcelRequire("8WQ3J");

var $h9RZb = parcelRequire("h9RZb");

var $2q4Dy = parcelRequire("2q4Dy");

var $gsVw8 = parcelRequire("gsVw8");

var $aQVzu = parcelRequire("aQVzu");

var $laIQq = parcelRequire("laIQq");

var $gNbCT = parcelRequire("gNbCT");

var $3Xj54 = parcelRequire("3Xj54");
const $52548a353ad2d099$var$chartComponents = {
    AssetProgression: $bUG4S.AssetProgression,
    BalanceOverTime: $8WQ3J.BalanceOverTime,
    CashFlowProgression: $h9RZb.CashFlowProgression,
    DebtComposition: $2q4Dy.DebtComposition,
    DebtServiceCoverage: $gsVw8.DebtServiceCoverage,
    DebtToAssets: $aQVzu.DebtToAssets,
    DebtToCashflows: $laIQq.DebtToCashflows,
    Liquidity: $gNbCT.Liquidity,
    DisbursementsAndRepayments: $3Xj54.DisbursementsAndRepayments
};
function $52548a353ad2d099$export$51a9c37cab91cff6({ sectionConfig: sectionConfig, tabKey: tabKey, isCondensed: isCondensed = false }) {
    const widgets = sectionConfig.widgets.filter((widget)=>{
        if (widget.isChart) return (0, $1V5et.chartData)[widget.dataKey] && widget.chartType;
        return (0, $4DcVl.memoData)[sectionConfig.id]?.[widget.dataKey];
    });
    const renderWidget = (widget)=>{
        if (widget.isChart) {
            const ChartComponent = $52548a353ad2d099$var$chartComponents[widget.chartType];
            if (!ChartComponent) {
                console.warn(`Chart type "${widget.chartType}" not found`);
                return null;
            }
            return /*#__PURE__*/ (0, $ayMG0.jsx)(ChartComponent, {
                data: (0, $1V5et.chartData)[widget.dataKey],
                isCondensed: isCondensed
            }, widget.id + tabKey);
        } else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cYKjA.Collapse), {
            title: widget.title,
            defaultOpen: widget.defaultOpen,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95VSz.MarkdownMemo), {
                content: (0, $4DcVl.memoData)[sectionConfig.id][widget.dataKey]
            })
        }, widget.id + tabKey);
    };
    const midPoint = Math.ceil(widgets.length / 2);
    const modifier = sectionConfig.id === "introduction" ? 2 : 0;
    const leftColumnWidgets = widgets.slice(0, midPoint + modifier);
    const rightColumnWidgets = widgets.slice(midPoint + modifier);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex flex-col gap-2",
                children: leftColumnWidgets.map(renderWidget)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex flex-col gap-2",
                children: rightColumnWidgets.map(renderWidget)
            })
        ]
    });
}

});
parcelRegister("cYKjA", function(module, exports) {

$parcel$export(module.exports, "Collapse", () => $689e10b01249ee39$export$78768a9af065a7b);

var $ayMG0 = parcelRequire("ayMG0");

var $dA5Dq = parcelRequire("dA5Dq");

var $9QePP = parcelRequire("9QePP");
function $689e10b01249ee39$export$78768a9af065a7b({ testId: testId, className: className, title: title, children: children, defaultOpen: defaultOpen = false }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("details", {
        className: (0, $9QePP.default)("bg-secondary group w-full self-start rounded-md p-5", className),
        "data-testid": testId,
        open: defaultOpen,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("summary", {
                className: "cursor-pointer list-none",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "heading-l",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dA5Dq.default), {
                            className: "size-5 transition-transform duration-200 group-open:rotate-180"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mt-6",
                children: children
            })
        ]
    });
}

});

parcelRegister("95VSz", function(module, exports) {

$parcel$export(module.exports, "MarkdownMemo", () => $98f7c318eefaf1a9$export$1eea0102c518f863);

var $ayMG0 = parcelRequire("ayMG0");

var $78q0O = parcelRequire("78q0O");

var $7KOXg = parcelRequire("7KOXg");

var $7t8wP = parcelRequire("7t8wP");

var $4V6JI = parcelRequire("4V6JI");

var $1RiDN = parcelRequire("1RiDN");

var $9QePP = parcelRequire("9QePP");
const $98f7c318eefaf1a9$var$transformNode = (node, children)=>{
    if (node.tagName === "HR") return /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
        className: "border-default my-4"
    });
    if (node.tagName === "H2") return /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
        className: "heading-m mb-2",
        children: children
    });
    if (node.tagName === "H3") return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "heading-s",
        children: children
    });
    if (node.tagName === "H4") return /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
        className: "subheading",
        children: children
    });
    if (node.tagName === "UL") return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        className: "my-4 list-outside list-disc space-y-1",
        children: children
    });
    if (node.tagName === "LI") return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: "body-s ml-4",
        children: children
    });
    if (node.tagName === "EM") return /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
        className: "text-gray-400",
        children: children
    });
    if (node.tagName === "P") {
        const links = Array.from(node.querySelectorAll("a"));
        if (links.length > 1) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: (0, $9QePP.default)("mb-4 mt-1", "flex flex-wrap", "subdued gap-3"),
            children: links.map((linkElement, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1RiDN.Link), {
                    href: linkElement.getAttribute("href") || "",
                    title: linkElement.textContent || ""
                }, index))
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "body-s subdued mb-4 mt-1",
            children: children
        });
    }
    if (node.tagName === "A") {
        const parentP = node.closest("p");
        const allLinksInP = parentP?.querySelectorAll("a") || [];
        if (allLinksInP.length > 1) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1RiDN.Link), {
            href: node.getAttribute("href") || "",
            title: node.textContent || ""
        });
    }
    return undefined;
};
const $98f7c318eefaf1a9$export$1eea0102c518f863 = ({ content: content })=>{
    if (!content) return null;
    const processedContent = (0, $78q0O.remark)().use((0, $7KOXg.default)).use((0, $7t8wP.default)).processSync(content);
    const htmlContent = processedContent.toString();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "prose",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4V6JI.Interweave), {
            content: htmlContent,
            tagName: "div",
            transform: $98f7c318eefaf1a9$var$transformNode
        })
    });
};

});
parcelRegister("78q0O", function(module, exports) {

$parcel$export(module.exports, "remark", () => $531d753db30aefcf$export$f1c7991a8b4e0146);

var $hBHqC = parcelRequire("hBHqC");

var $3F7xF = parcelRequire("3F7xF");

var $14VHO = parcelRequire("14VHO");
const $531d753db30aefcf$export$f1c7991a8b4e0146 = (0, $hBHqC.unified)().use((0, $3F7xF.default)).use((0, $14VHO.default)).freeze();

});
parcelRegister("14VHO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c92ed4fd89beb21$export$2e2bcd8739ae039);
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownOptions
 * @typedef {Omit<ToMarkdownOptions, 'extensions'>} Options
 */ 
var $938Pm = parcelRequire("938Pm");
function $0c92ed4fd89beb21$export$2e2bcd8739ae039(options) {
    /** @type {import('unified').CompilerFunction<Node, string>} */ const compiler = (tree)=>{
        // Assume options.
        const settings = /** @type {Options} */ this.data("settings");
        return (0, $938Pm.toMarkdown)(tree, Object.assign({}, settings, options, {
            // Note: this option is not in the readme.
            // The goal is for it to be set by plugins on `data` instead of being
            // passed by users.
            extensions: /** @type {ToMarkdownOptions['extensions']} */ this.data("toMarkdownExtensions") || []
        }));
    };
    Object.assign(this, {
        Compiler: compiler
    });
}

});
parcelRegister("938Pm", function(module, exports) {

$parcel$export(module.exports, "toMarkdown", () => $696b3dc8c9c8834f$export$49a1dda9e62e8ae6);
/**
 * @typedef {import('./types.js').Enter} Enter
 * @typedef {import('./types.js').Info} Info
 * @typedef {import('./types.js').Join} Join
 * @typedef {import('./types.js').FlowContent} FlowContent
 * @typedef {import('./types.js').Node} Node
 * @typedef {import('./types.js').Options} Options
 * @typedef {import('./types.js').Parent} Parent
 * @typedef {import('./types.js').PhrasingContent} PhrasingContent
 * @typedef {import('./types.js').SafeConfig} SafeConfig
 * @typedef {import('./types.js').State} State
 * @typedef {import('./types.js').TrackFields} TrackFields
 */ 
var $50w0t = parcelRequire("50w0t");

var $iUyir = parcelRequire("iUyir");

var $6sx2f = parcelRequire("6sx2f");

var $byOSP = parcelRequire("byOSP");

var $zvmfE = parcelRequire("zvmfE");

var $Xl6Y9 = parcelRequire("Xl6Y9");

var $8Rca2 = parcelRequire("8Rca2");

var $g5QCV = parcelRequire("g5QCV");

var $ebQRQ = parcelRequire("ebQRQ");

var $gsbWy = parcelRequire("gsbWy");

var $932TR = parcelRequire("932TR");
function $696b3dc8c9c8834f$export$49a1dda9e62e8ae6(tree, options = {}) {
    /** @type {State} */ const state = {
        enter: enter,
        indentLines: $ebQRQ.indentLines,
        associationId: (0, $Xl6Y9.association),
        containerPhrasing: $696b3dc8c9c8834f$var$containerPhrasingBound,
        containerFlow: $696b3dc8c9c8834f$var$containerFlowBound,
        createTracker: (0, $932TR.track),
        safe: $696b3dc8c9c8834f$var$safeBound,
        stack: [],
        unsafe: [],
        join: [],
        // @ts-expect-error: we’ll fill it next.
        handlers: {},
        options: {},
        indexStack: [],
        // @ts-expect-error: we’ll add `handle` later.
        handle: undefined
    };
    (0, $iUyir.configure)(state, {
        unsafe: $zvmfE.unsafe,
        join: $byOSP.join,
        handlers: $6sx2f.handle
    });
    (0, $iUyir.configure)(state, options);
    if (state.options.tightDefinitions) (0, $iUyir.configure)(state, {
        join: [
            $696b3dc8c9c8834f$var$joinDefinition
        ]
    });
    state.handle = (0, $50w0t.zwitch)("type", {
        invalid: $696b3dc8c9c8834f$var$invalid,
        unknown: $696b3dc8c9c8834f$var$unknown,
        handlers: state.handlers
    });
    let result = state.handle(tree, undefined, state, {
        before: "\n",
        after: "\n",
        now: {
            line: 1,
            column: 1
        },
        lineShift: 0
    });
    if (result && result.charCodeAt(result.length - 1) !== 10 && result.charCodeAt(result.length - 1) !== 13) result += "\n";
    return result;
    /** @type {Enter} */ function enter(name) {
        state.stack.push(name);
        return exit;
        function exit() {
            state.stack.pop();
        }
    }
}
/**
 * @param {unknown} value
 * @returns {never}
 */ function $696b3dc8c9c8834f$var$invalid(value) {
    throw new Error("Cannot handle value `" + value + "`, expected node");
}
/**
 * @param {unknown} node
 * @returns {never}
 */ function $696b3dc8c9c8834f$var$unknown(node) {
    // @ts-expect-error: fine.
    throw new Error("Cannot handle unknown node `" + node.type + "`");
}
/** @type {Join} */ function $696b3dc8c9c8834f$var$joinDefinition(left, right) {
    // No blank line between adjacent definitions.
    if (left.type === "definition" && left.type === right.type) return 0;
}
/**
 * Serialize the children of a parent that contains phrasing children.
 *
 * These children will be joined flush together.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {Parent & {children: Array<PhrasingContent>}} parent
 *   Parent of flow nodes.
 * @param {Info} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined together.
 */ function $696b3dc8c9c8834f$var$containerPhrasingBound(parent, info) {
    return (0, $8Rca2.containerPhrasing)(parent, this, info);
}
/**
 * Serialize the children of a parent that contains flow children.
 *
 * These children will typically be joined by blank lines.
 * What they are joined by exactly is defined by `Join` functions.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {Parent & {children: Array<FlowContent>}} parent
 *   Parent of flow nodes.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $696b3dc8c9c8834f$var$containerFlowBound(parent, info) {
    return (0, $g5QCV.containerFlow)(parent, this, info);
}
/**
 * Make a string safe for embedding in markdown constructs.
 *
 * In markdown, almost all punctuation characters can, in certain cases,
 * result in something.
 * Whether they do is highly subjective to where they happen and in what
 * they happen.
 *
 * To solve this, `mdast-util-to-markdown` tracks:
 *
 * * Characters before and after something;
 * * What “constructs” we are in.
 *
 * This information is then used by this function to escape or encode
 * special characters.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {string | null | undefined} value
 *   Raw value to make safe.
 * @param {SafeConfig} config
 *   Configuration.
 * @returns {string}
 *   Serialized markdown safe for embedding.
 */ function $696b3dc8c9c8834f$var$safeBound(value, config) {
    return (0, $gsbWy.safe)(this, value, config);
}

});
parcelRegister("50w0t", function(module, exports) {

$parcel$export(module.exports, "zwitch", () => $3a55c7b5e19fe99f$export$d6a12bfbbedf6185);
/**
 * @callback Handler
 *   Handle a value, with a certain ID field set to a certain value.
 *   The ID field is passed to `zwitch`, and it’s value is this function’s
 *   place on the `handlers` record.
 * @param {...any} parameters
 *   Arbitrary parameters passed to the zwitch.
 *   The first will be an object with a certain ID field set to a certain value.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback UnknownHandler
 *   Handle values that do have a certain ID field, but it’s set to a value
 *   that is not listed in the `handlers` record.
 * @param {unknown} value
 *   An object with a certain ID field set to an unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback InvalidHandler
 *   Handle values that do not have a certain ID field.
 * @param {unknown} value
 *   Any unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {void|null|undefined|never}
 *   This should crash or return nothing.
 */ /**
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @typedef Options
 *   Configuration (required).
 * @property {Invalid} [invalid]
 *   Handler to use for invalid values.
 * @property {Unknown} [unknown]
 *   Handler to use for unknown values.
 * @property {Handlers} [handlers]
 *   Handlers to use.
 */ const $3a55c7b5e19fe99f$var$own = {}.hasOwnProperty;
function $3a55c7b5e19fe99f$export$d6a12bfbbedf6185(key, options) {
    const settings = options || {};
    /**
   * Handle one value.
   *
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @this {unknown}
   *   Any context object.
   * @param {unknown} [value]
   *   Any value.
   * @param {...unknown} parameters
   *   Arbitrary parameters passed to the zwitch.
   * @property {Handler} invalid
   *   Handle for values that do not have a certain ID field.
   * @property {Handler} unknown
   *   Handle values that do have a certain ID field, but it’s set to a value
   *   that is not listed in the `handlers` record.
   * @property {Handlers} handlers
   *   Record of handlers.
   * @returns {unknown}
   *   Anything.
   */ function one(value, ...parameters) {
        /** @type {Handler|undefined} */ let fn = one.invalid;
        const handlers = one.handlers;
        if (value && $3a55c7b5e19fe99f$var$own.call(value, key)) {
            // @ts-expect-error Indexable.
            const id = String(value[key]);
            // @ts-expect-error Indexable.
            fn = $3a55c7b5e19fe99f$var$own.call(handlers, id) ? handlers[id] : one.unknown;
        }
        if (fn) return fn.call(this, value, ...parameters);
    }
    one.handlers = settings.handlers || {};
    one.invalid = settings.invalid;
    one.unknown = settings.unknown;
    // @ts-expect-error: matches!
    return one;
}

});

parcelRegister("iUyir", function(module, exports) {

$parcel$export(module.exports, "configure", () => $dc480f85bcbeedb4$export$8d21e34596265fa2);
/**
 * @typedef {import('./types.js').Options} Options
 * @typedef {import('./types.js').State} State
 */ /**
 * @param {State} base
 * @param {Options} extension
 * @returns {State}
 */ function $dc480f85bcbeedb4$export$8d21e34596265fa2(base, extension) {
    let index = -1;
    /** @type {keyof Options} */ let key;
    // First do subextensions.
    if (extension.extensions) while(++index < extension.extensions.length)$dc480f85bcbeedb4$export$8d21e34596265fa2(base, extension.extensions[index]);
    for(key in extension){
        if (key === "extensions") ;
        else if (key === "unsafe" || key === "join") /* c8 ignore next 2 */ // @ts-expect-error: hush.
        base[key] = [
            ...base[key] || [],
            ...extension[key] || []
        ];
        else if (key === "handlers") base[key] = Object.assign(base[key], extension[key] || {});
        else // @ts-expect-error: hush.
        base.options[key] = extension[key];
    }
    return base;
}

});

parcelRegister("6sx2f", function(module, exports) {

$parcel$export(module.exports, "handle", () => $4b3efbbc37f918e5$export$8f34ce051745d39e);

var $gwadA = parcelRequire("gwadA");

var $4Hatm = parcelRequire("4Hatm");

var $eBQhD = parcelRequire("eBQhD");

var $jpEdK = parcelRequire("jpEdK");

var $jqiqe = parcelRequire("jqiqe");

var $a3Ah6 = parcelRequire("a3Ah6");

var $7tcoR = parcelRequire("7tcoR");

var $lMKRC = parcelRequire("lMKRC");

var $8iMdP = parcelRequire("8iMdP");

var $btXGe = parcelRequire("btXGe");

var $fILQl = parcelRequire("fILQl");

var $8KRtB = parcelRequire("8KRtB");

var $4Qlxp = parcelRequire("4Qlxp");

var $kWqww = parcelRequire("kWqww");

var $jCD7m = parcelRequire("jCD7m");

var $batsz = parcelRequire("batsz");

var $58De2 = parcelRequire("58De2");

var $3wVYA = parcelRequire("3wVYA");

var $9GBP5 = parcelRequire("9GBP5");
const $4b3efbbc37f918e5$export$8f34ce051745d39e = {
    blockquote: $gwadA.blockquote,
    break: (0, $4Hatm.hardBreak),
    code: $eBQhD.code,
    definition: $jpEdK.definition,
    emphasis: $jqiqe.emphasis,
    hardBreak: $4Hatm.hardBreak,
    heading: $a3Ah6.heading,
    html: $7tcoR.html,
    image: $lMKRC.image,
    imageReference: $8iMdP.imageReference,
    inlineCode: $btXGe.inlineCode,
    link: $fILQl.link,
    linkReference: $8KRtB.linkReference,
    list: $4Qlxp.list,
    listItem: $kWqww.listItem,
    paragraph: $jCD7m.paragraph,
    root: $batsz.root,
    strong: $58De2.strong,
    text: $3wVYA.text,
    thematicBreak: $9GBP5.thematicBreak
};

});
parcelRegister("gwadA", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $c0678f9c0c80b786$export$67dc04e652a298ca);
/**
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Map} Map
 */ /**
 * @param {Blockquote} node
 * @param {Parent | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $c0678f9c0c80b786$export$67dc04e652a298ca(node, _, state, info) {
    const exit = state.enter("blockquote");
    const tracker = state.createTracker(info);
    tracker.move("> ");
    tracker.shift(2);
    const value = state.indentLines(state.containerFlow(node, tracker.current()), $c0678f9c0c80b786$var$map);
    exit();
    return value;
}
/** @type {Map} */ function $c0678f9c0c80b786$var$map(line, _, blank) {
    return ">" + (blank ? "" : " ") + line;
}

});

parcelRegister("4Hatm", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $36b34d312e6c92b1$export$371da9dd35aba193);
/**
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ 
var $dE4NC = parcelRequire("dE4NC");
function $36b34d312e6c92b1$export$371da9dd35aba193(_, _1, state, info) {
    let index = -1;
    while(++index < state.unsafe.length){
        // If we can’t put eols in this construct (setext headings, tables), use a
        // space instead.
        if (state.unsafe[index].character === "\n" && (0, $dE4NC.patternInScope)(state.stack, state.unsafe[index])) return /[ \t]/.test(info.before) ? "" : " ";
    }
    return "\\\n";
}

});

parcelRegister("eBQhD", function(module, exports) {

$parcel$export(module.exports, "code", () => $aa2d13ceac7e6a6d$export$6565f9f03506010b);
/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Map} Map
 */ 
var $kNjUl = parcelRequire("kNjUl");

var $bQmKn = parcelRequire("bQmKn");

var $8uk76 = parcelRequire("8uk76");
function $aa2d13ceac7e6a6d$export$6565f9f03506010b(node, _, state, info) {
    const marker = (0, $8uk76.checkFence)(state);
    const raw = node.value || "";
    const suffix = marker === "`" ? "GraveAccent" : "Tilde";
    if ((0, $bQmKn.formatCodeAsIndented)(node, state)) {
        const exit = state.enter("codeIndented");
        const value = state.indentLines(raw, $aa2d13ceac7e6a6d$var$map);
        exit();
        return value;
    }
    const tracker = state.createTracker(info);
    const sequence = marker.repeat(Math.max((0, $kNjUl.longestStreak)(raw, marker) + 1, 3));
    const exit = state.enter("codeFenced");
    let value = tracker.move(sequence);
    if (node.lang) {
        const subexit = state.enter(`codeFencedLang${suffix}`);
        value += tracker.move(state.safe(node.lang, {
            before: value,
            after: " ",
            encode: [
                "`"
            ],
            ...tracker.current()
        }));
        subexit();
    }
    if (node.lang && node.meta) {
        const subexit = state.enter(`codeFencedMeta${suffix}`);
        value += tracker.move(" ");
        value += tracker.move(state.safe(node.meta, {
            before: value,
            after: "\n",
            encode: [
                "`"
            ],
            ...tracker.current()
        }));
        subexit();
    }
    value += tracker.move("\n");
    if (raw) value += tracker.move(raw + "\n");
    value += tracker.move(sequence);
    exit();
    return value;
}
/** @type {Map} */ function $aa2d13ceac7e6a6d$var$map(line, _, blank) {
    return (blank ? "" : "    ") + line;
}

});
parcelRegister("kNjUl", function(module, exports) {

$parcel$export(module.exports, "longestStreak", () => $f237d37fd92ab36a$export$711675ff42d864f2);
/**
 * Get the count of the longest repeating streak of `substring` in `value`.
 *
 * @param {string} value
 *   Content to search in.
 * @param {string} substring
 *   Substring to look for, typically one character.
 * @returns {number}
 *   Count of most frequent adjacent `substring`s in `value`.
 */ function $f237d37fd92ab36a$export$711675ff42d864f2(value, substring) {
    const source = String(value);
    let index = source.indexOf(substring);
    let expected = index;
    let count = 0;
    let max = 0;
    if (typeof substring !== "string") throw new TypeError("Expected substring");
    while(index !== -1){
        if (index === expected) {
            if (++count > max) max = count;
        } else count = 1;
        expected = index + substring.length;
        index = source.indexOf(substring, expected);
    }
    return max;
}

});

parcelRegister("bQmKn", function(module, exports) {

$parcel$export(module.exports, "formatCodeAsIndented", () => $89f6321aa6b6c091$export$8c0df78a8cad9f4b);
/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {Code} node
 * @param {State} state
 * @returns {boolean}
 */ function $89f6321aa6b6c091$export$8c0df78a8cad9f4b(node, state) {
    return Boolean(!state.options.fences && node.value && // If there’s no info…
    !node.lang && // And there’s a non-whitespace character…
    /[^ \r\n]/.test(node.value) && // And the value doesn’t start or end in a blank…
    !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node.value));
}

});

parcelRegister("8uk76", function(module, exports) {

$parcel$export(module.exports, "checkFence", () => $62e0ba358259120b$export$7487ee7cbb2e2919);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['fence'], null | undefined>}
 */ function $62e0ba358259120b$export$7487ee7cbb2e2919(state) {
    const marker = state.options.fence || "`";
    if (marker !== "`" && marker !== "~") throw new Error("Cannot serialize code with `" + marker + "` for `options.fence`, expected `` ` `` or `~`");
    return marker;
}

});


parcelRegister("jpEdK", function(module, exports) {

$parcel$export(module.exports, "definition", () => $e21f8d193ec596db$export$69f215ed977cdb73);
/**
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ 
var $778uq = parcelRequire("778uq");
function $e21f8d193ec596db$export$69f215ed977cdb73(node, _, state, info) {
    const quote = (0, $778uq.checkQuote)(state);
    const suffix = quote === '"' ? "Quote" : "Apostrophe";
    const exit = state.enter("definition");
    let subexit = state.enter("label");
    const tracker = state.createTracker(info);
    let value = tracker.move("[");
    value += tracker.move(state.safe(state.associationId(node), {
        before: value,
        after: "]",
        ...tracker.current()
    }));
    value += tracker.move("]: ");
    subexit();
    if (// If there’s no url, or…
    !node.url || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter("destinationLiteral");
        value += tracker.move("<");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: ">",
            ...tracker.current()
        }));
        value += tracker.move(">");
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter("destinationRaw");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? " " : "\n",
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(" " + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    exit();
    return value;
}

});
parcelRegister("778uq", function(module, exports) {

$parcel$export(module.exports, "checkQuote", () => $52dfc5c1fffc2be0$export$7aeba63896b2719);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['quote'], null | undefined>}
 */ function $52dfc5c1fffc2be0$export$7aeba63896b2719(state) {
    const marker = state.options.quote || '"';
    if (marker !== '"' && marker !== "'") throw new Error("Cannot serialize title with `" + marker + "` for `options.quote`, expected `\"`, or `'`");
    return marker;
}

});


parcelRegister("jqiqe", function(module, exports) {

$parcel$export(module.exports, "emphasis", () => $e23ebc427ec3e508$export$bef81ba411953b51);
/**
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ 
var $e7VQI = parcelRequire("e7VQI");
$e23ebc427ec3e508$export$bef81ba411953b51.peek = $e23ebc427ec3e508$var$emphasisPeek;
function $e23ebc427ec3e508$export$bef81ba411953b51(node, _, state, info) {
    const marker = (0, $e7VQI.checkEmphasis)(state);
    const exit = state.enter("emphasis");
    const tracker = state.createTracker(info);
    let value = tracker.move(marker);
    value += tracker.move(state.containerPhrasing(node, {
        before: value,
        after: marker,
        ...tracker.current()
    }));
    value += tracker.move(marker);
    exit();
    return value;
}
/**
 * @param {Emphasis} _
 * @param {Parent | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $e23ebc427ec3e508$var$emphasisPeek(_, _1, state) {
    return state.options.emphasis || "*";
}

});
parcelRegister("e7VQI", function(module, exports) {

$parcel$export(module.exports, "checkEmphasis", () => $a48e97cdba185620$export$f967eb786dea04e7);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['emphasis'], null | undefined>}
 */ function $a48e97cdba185620$export$f967eb786dea04e7(state) {
    const marker = state.options.emphasis || "*";
    if (marker !== "*" && marker !== "_") throw new Error("Cannot serialize emphasis with `" + marker + "` for `options.emphasis`, expected `*`, or `_`");
    return marker;
}

});


parcelRegister("a3Ah6", function(module, exports) {

$parcel$export(module.exports, "heading", () => $752652a1e7e1e72d$export$46e4a324ac90507f);
/**
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ 
var $cgDcF = parcelRequire("cgDcF");
function $752652a1e7e1e72d$export$46e4a324ac90507f(node, _, state, info) {
    const rank = Math.max(Math.min(6, node.depth || 1), 1);
    const tracker = state.createTracker(info);
    if ((0, $cgDcF.formatHeadingAsSetext)(node, state)) {
        const exit = state.enter("headingSetext");
        const subexit = state.enter("phrasing");
        const value = state.containerPhrasing(node, {
            ...tracker.current(),
            before: "\n",
            after: "\n"
        });
        subexit();
        exit();
        return value + "\n" + (rank === 1 ? "=" : "-").repeat(// The whole size…
        value.length - // Minus the position of the character after the last EOL (or
        // 0 if there is none)…
        (Math.max(value.lastIndexOf("\r"), value.lastIndexOf("\n")) + 1));
    }
    const sequence = "#".repeat(rank);
    const exit = state.enter("headingAtx");
    const subexit = state.enter("phrasing");
    // Note: for proper tracking, we should reset the output positions when there
    // is no content returned, because then the space is not output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    tracker.move(sequence + " ");
    let value = state.containerPhrasing(node, {
        before: "# ",
        after: "\n",
        ...tracker.current()
    });
    if (/^[\t ]/.test(value)) // To do: what effect has the character reference on tracking?
    value = "&#x" + value.charCodeAt(0).toString(16).toUpperCase() + ";" + value.slice(1);
    value = value ? sequence + " " + value : sequence;
    if (state.options.closeAtx) value += " " + sequence;
    subexit();
    exit();
    return value;
}

});
parcelRegister("cgDcF", function(module, exports) {

$parcel$export(module.exports, "formatHeadingAsSetext", () => $8ee563a328ffcd6b$export$78863676235adfbc);
/**
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../types.js').State} State
 */ 
var $imX1f = parcelRequire("imX1f");
var $6qkIL = parcelRequire("6qkIL");

var $apdnY = parcelRequire("apdnY");
function $8ee563a328ffcd6b$export$78863676235adfbc(node, state) {
    let literalWithBreak = false;
    // Look for literals with a line break.
    // Note that this also
    (0, $6qkIL.visit)(node, (node)=>{
        if ("value" in node && /\r?\n|\r/.test(node.value) || node.type === "break") {
            literalWithBreak = true;
            return 0, $imX1f.EXIT;
        }
    });
    return Boolean((!node.depth || node.depth < 3) && (0, $apdnY.toString)(node) && (state.options.setext || literalWithBreak));
}

});


parcelRegister("7tcoR", function(module, exports) {

$parcel$export(module.exports, "html", () => $5704dc361a6f1cea$export$c0bb0b647f701bb5);
/**
 * @typedef {import('mdast').HTML} HTML
 */ $5704dc361a6f1cea$export$c0bb0b647f701bb5.peek = $5704dc361a6f1cea$var$htmlPeek;
function $5704dc361a6f1cea$export$c0bb0b647f701bb5(node) {
    return node.value || "";
}
/**
 * @returns {string}
 */ function $5704dc361a6f1cea$var$htmlPeek() {
    return "<";
}

});

parcelRegister("lMKRC", function(module, exports) {

$parcel$export(module.exports, "image", () => $fdc26edb5371af24$export$5c452ff88e35e47d);
/**
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ 
var $778uq = parcelRequire("778uq");
$fdc26edb5371af24$export$5c452ff88e35e47d.peek = $fdc26edb5371af24$var$imagePeek;
function $fdc26edb5371af24$export$5c452ff88e35e47d(node, _, state, info) {
    const quote = (0, $778uq.checkQuote)(state);
    const suffix = quote === '"' ? "Quote" : "Apostrophe";
    const exit = state.enter("image");
    let subexit = state.enter("label");
    const tracker = state.createTracker(info);
    let value = tracker.move("![");
    value += tracker.move(state.safe(node.alt, {
        before: value,
        after: "]",
        ...tracker.current()
    }));
    value += tracker.move("](");
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter("destinationLiteral");
        value += tracker.move("<");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: ">",
            ...tracker.current()
        }));
        value += tracker.move(">");
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter("destinationRaw");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? " " : ")",
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(" " + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(")");
    exit();
    return value;
}
/**
 * @returns {string}
 */ function $fdc26edb5371af24$var$imagePeek() {
    return "!";
}

});

parcelRegister("8iMdP", function(module, exports) {

$parcel$export(module.exports, "imageReference", () => $60b5691325120494$export$f281796f6bc3b8db);
/**
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ $60b5691325120494$export$f281796f6bc3b8db.peek = $60b5691325120494$var$imageReferencePeek;
function $60b5691325120494$export$f281796f6bc3b8db(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter("imageReference");
    let subexit = state.enter("label");
    const tracker = state.createTracker(info);
    let value = tracker.move("![");
    const alt = state.safe(node.alt, {
        before: value,
        after: "]",
        ...tracker.current()
    });
    value += tracker.move(alt + "][");
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter("reference");
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: "]",
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === "full" || !alt || alt !== reference) value += tracker.move(reference + "]");
    else if (type === "shortcut") // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move("]");
    return value;
}
/**
 * @returns {string}
 */ function $60b5691325120494$var$imageReferencePeek() {
    return "!";
}

});

parcelRegister("fILQl", function(module, exports) {

$parcel$export(module.exports, "link", () => $b72013bc11322cc8$export$9c30223ca0a664fb);
/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Exit} Exit
 */ 
var $778uq = parcelRequire("778uq");

var $hV9vz = parcelRequire("hV9vz");
$b72013bc11322cc8$export$9c30223ca0a664fb.peek = $b72013bc11322cc8$var$linkPeek;
function $b72013bc11322cc8$export$9c30223ca0a664fb(node, _, state, info) {
    const quote = (0, $778uq.checkQuote)(state);
    const suffix = quote === '"' ? "Quote" : "Apostrophe";
    const tracker = state.createTracker(info);
    /** @type {Exit} */ let exit;
    /** @type {Exit} */ let subexit;
    if ((0, $hV9vz.formatLinkAsAutolink)(node, state)) {
        // Hide the fact that we’re in phrasing, because escapes don’t work.
        const stack = state.stack;
        state.stack = [];
        exit = state.enter("autolink");
        let value = tracker.move("<");
        value += tracker.move(state.containerPhrasing(node, {
            before: value,
            after: ">",
            ...tracker.current()
        }));
        value += tracker.move(">");
        exit();
        state.stack = stack;
        return value;
    }
    exit = state.enter("link");
    subexit = state.enter("label");
    let value = tracker.move("[");
    value += tracker.move(state.containerPhrasing(node, {
        before: value,
        after: "](",
        ...tracker.current()
    }));
    value += tracker.move("](");
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter("destinationLiteral");
        value += tracker.move("<");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: ">",
            ...tracker.current()
        }));
        value += tracker.move(">");
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter("destinationRaw");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? " " : ")",
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(" " + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(")");
    exit();
    return value;
}
/**
 * @param {Link} node
 * @param {Parent | undefined} _
 * @param {State} state
 * @returns {string}
 */ function $b72013bc11322cc8$var$linkPeek(node, _, state) {
    return (0, $hV9vz.formatLinkAsAutolink)(node, state) ? "<" : "[";
}

});
parcelRegister("hV9vz", function(module, exports) {

$parcel$export(module.exports, "formatLinkAsAutolink", () => $d0bf22a50416bce1$export$74cae3045e3179ed);
/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../types.js').State} State
 */ 
var $apdnY = parcelRequire("apdnY");
function $d0bf22a50416bce1$export$74cae3045e3179ed(node, state) {
    const raw = (0, $apdnY.toString)(node);
    return Boolean(!state.options.resourceLink && // If there’s a url…
    node.url && // And there’s a no title…
    !node.title && // And the content of `node` is a single text node…
    node.children && node.children.length === 1 && node.children[0].type === "text" && // And if the url is the same as the content…
    (raw === node.url || "mailto:" + raw === node.url) && // And that starts w/ a protocol…
    /^[a-z][a-z+.-]+:/i.test(node.url) && // And that doesn’t contain ASCII control codes (character escapes and
    // references don’t work), space, or angle brackets…
    !/[\0- <>\u007F]/.test(node.url));
}

});


parcelRegister("8KRtB", function(module, exports) {

$parcel$export(module.exports, "linkReference", () => $65fc19ee892be9f2$export$e6c469b1b7b2bc6a);
/**
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ $65fc19ee892be9f2$export$e6c469b1b7b2bc6a.peek = $65fc19ee892be9f2$var$linkReferencePeek;
function $65fc19ee892be9f2$export$e6c469b1b7b2bc6a(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter("linkReference");
    let subexit = state.enter("label");
    const tracker = state.createTracker(info);
    let value = tracker.move("[");
    const text = state.containerPhrasing(node, {
        before: value,
        after: "]",
        ...tracker.current()
    });
    value += tracker.move(text + "][");
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter("reference");
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: "]",
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === "full" || !text || text !== reference) value += tracker.move(reference + "]");
    else if (type === "shortcut") // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move("]");
    return value;
}
/**
 * @returns {string}
 */ function $65fc19ee892be9f2$var$linkReferencePeek() {
    return "[";
}

});

parcelRegister("4Qlxp", function(module, exports) {

$parcel$export(module.exports, "list", () => $386cb9b4b77b594a$export$8837f4fc672e936d);
/**
 * @typedef {import('mdast').List} List
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ 
var $9OG6d = parcelRequire("9OG6d");

var $6Pslq = parcelRequire("6Pslq");

var $3RImN = parcelRequire("3RImN");

var $6zja0 = parcelRequire("6zja0");

var $11pUG = parcelRequire("11pUG");
function $386cb9b4b77b594a$export$8837f4fc672e936d(node, parent, state, info) {
    const exit = state.enter("list");
    const bulletCurrent = state.bulletCurrent;
    /** @type {string} */ let bullet = node.ordered ? (0, $3RImN.checkBulletOrdered)(state) : (0, $9OG6d.checkBullet)(state);
    /** @type {string} */ const bulletOther = node.ordered ? (0, $6zja0.checkBulletOrderedOther)(state) : (0, $6Pslq.checkBulletOther)(state);
    const bulletLastUsed = state.bulletLastUsed;
    let useDifferentMarker = false;
    if (parent && // Explicit `other` set.
    (node.ordered ? state.options.bulletOrderedOther : state.options.bulletOther) && bulletLastUsed && bullet === bulletLastUsed) useDifferentMarker = true;
    if (!node.ordered) {
        const firstListItem = node.children ? node.children[0] : undefined;
        // If there’s an empty first list item directly in two list items,
        // we have to use a different bullet:
        //
        // ```markdown
        // * - *
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if (// Bullet could be used as a thematic break marker:
        (bullet === "*" || bullet === "-") && // Empty first list item:
        firstListItem && (!firstListItem.children || !firstListItem.children[0]) && // Directly in two other list items:
        state.stack[state.stack.length - 1] === "list" && state.stack[state.stack.length - 2] === "listItem" && state.stack[state.stack.length - 3] === "list" && state.stack[state.stack.length - 4] === "listItem" && // That are each the first child.
        state.indexStack[state.indexStack.length - 1] === 0 && state.indexStack[state.indexStack.length - 2] === 0 && state.indexStack[state.indexStack.length - 3] === 0) useDifferentMarker = true;
        // If there’s a thematic break at the start of the first list item,
        // we have to use a different bullet:
        //
        // ```markdown
        // * ---
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if ((0, $11pUG.checkRule)(state) === bullet && firstListItem) {
            let index = -1;
            while(++index < node.children.length){
                const item = node.children[index];
                if (item && item.type === "listItem" && item.children && item.children[0] && item.children[0].type === "thematicBreak") {
                    useDifferentMarker = true;
                    break;
                }
            }
        }
    }
    if (useDifferentMarker) bullet = bulletOther;
    state.bulletCurrent = bullet;
    const value = state.containerFlow(node, info);
    state.bulletLastUsed = bullet;
    state.bulletCurrent = bulletCurrent;
    exit();
    return value;
}

});
parcelRegister("6Pslq", function(module, exports) {

$parcel$export(module.exports, "checkBulletOther", () => $4f8d7e254ebc884b$export$e6803bf0889262a1);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ 
var $9OG6d = parcelRequire("9OG6d");
function $4f8d7e254ebc884b$export$e6803bf0889262a1(state) {
    const bullet = (0, $9OG6d.checkBullet)(state);
    const bulletOther = state.options.bulletOther;
    if (!bulletOther) return bullet === "*" ? "-" : "*";
    if (bulletOther !== "*" && bulletOther !== "+" && bulletOther !== "-") throw new Error("Cannot serialize items with `" + bulletOther + "` for `options.bulletOther`, expected `*`, `+`, or `-`");
    if (bulletOther === bullet) throw new Error("Expected `bullet` (`" + bullet + "`) and `bulletOther` (`" + bulletOther + "`) to be different");
    return bulletOther;
}

});

parcelRegister("3RImN", function(module, exports) {

$parcel$export(module.exports, "checkBulletOrdered", () => $2d08bc9f40f37661$export$98d522b78eddc19b);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bulletOrdered'], null | undefined>}
 */ function $2d08bc9f40f37661$export$98d522b78eddc19b(state) {
    const marker = state.options.bulletOrdered || ".";
    if (marker !== "." && marker !== ")") throw new Error("Cannot serialize items with `" + marker + "` for `options.bulletOrdered`, expected `.` or `)`");
    return marker;
}

});

parcelRegister("6zja0", function(module, exports) {

$parcel$export(module.exports, "checkBulletOrderedOther", () => $4c84dfd30976b298$export$9b77c4f2ef3fadc8);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ 
var $3RImN = parcelRequire("3RImN");
function $4c84dfd30976b298$export$9b77c4f2ef3fadc8(state) {
    const bulletOrdered = (0, $3RImN.checkBulletOrdered)(state);
    const bulletOrderedOther = state.options.bulletOrderedOther;
    if (!bulletOrderedOther) return bulletOrdered === "." ? ")" : ".";
    if (bulletOrderedOther !== "." && bulletOrderedOther !== ")") throw new Error("Cannot serialize items with `" + bulletOrderedOther + "` for `options.bulletOrderedOther`, expected `*`, `+`, or `-`");
    if (bulletOrderedOther === bulletOrdered) throw new Error("Expected `bulletOrdered` (`" + bulletOrdered + "`) and `bulletOrderedOther` (`" + bulletOrderedOther + "`) to be different");
    return bulletOrderedOther;
}

});

parcelRegister("11pUG", function(module, exports) {

$parcel$export(module.exports, "checkRule", () => $0be9fc44a79713f1$export$d8d533ef24dba866);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['rule'], null | undefined>}
 */ function $0be9fc44a79713f1$export$d8d533ef24dba866(state) {
    const marker = state.options.rule || "*";
    if (marker !== "*" && marker !== "-" && marker !== "_") throw new Error("Cannot serialize rules with `" + marker + "` for `options.rule`, expected `*`, `-`, or `_`");
    return marker;
}

});


parcelRegister("jCD7m", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $e48fe8e5492c7db8$export$9c206ddddb32a9b);
/**
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ /**
 * @param {Paragraph} node
 * @param {Parent | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $e48fe8e5492c7db8$export$9c206ddddb32a9b(node, _, state, info) {
    const exit = state.enter("paragraph");
    const subexit = state.enter("phrasing");
    const value = state.containerPhrasing(node, info);
    subexit();
    exit();
    return value;
}

});

parcelRegister("batsz", function(module, exports) {

$parcel$export(module.exports, "root", () => $82177af85c5d9736$export$e8e78c978b129247);
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ 
var $gogKI = parcelRequire("gogKI");
function $82177af85c5d9736$export$e8e78c978b129247(node, _, state, info) {
    // Note: `html` nodes are ambiguous.
    const hasPhrasing = node.children.some((d)=>(0, $gogKI.phrasing)(d));
    const fn = hasPhrasing ? state.containerPhrasing : state.containerFlow;
    // @ts-expect-error: `root`s are supposed to have one type of content
    return fn.call(state, node, info);
}

});
parcelRegister("gogKI", function(module, exports) {

$parcel$export(module.exports, "phrasing", () => $beebe1ee86198626$export$444c9dec66a6f08c);
/**
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('unist-util-is').AssertPredicate<PhrasingContent>} AssertPredicatePhrasing
 */ 
var $cWBD6 = parcelRequire("cWBD6");
const $beebe1ee86198626$export$444c9dec66a6f08c = /** @type {AssertPredicatePhrasing} */ (0, $cWBD6.convert)([
    "break",
    "delete",
    "emphasis",
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    "link",
    "linkReference",
    "strong",
    "text"
]);

});


parcelRegister("58De2", function(module, exports) {

$parcel$export(module.exports, "strong", () => $3bdc2073aabcf9e2$export$59ae2c325a998f89);
/**
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ 
var $dGeA4 = parcelRequire("dGeA4");
$3bdc2073aabcf9e2$export$59ae2c325a998f89.peek = $3bdc2073aabcf9e2$var$strongPeek;
function $3bdc2073aabcf9e2$export$59ae2c325a998f89(node, _, state, info) {
    const marker = (0, $dGeA4.checkStrong)(state);
    const exit = state.enter("strong");
    const tracker = state.createTracker(info);
    let value = tracker.move(marker + marker);
    value += tracker.move(state.containerPhrasing(node, {
        before: value,
        after: marker,
        ...tracker.current()
    }));
    value += tracker.move(marker + marker);
    exit();
    return value;
}
/**
 * @param {Strong} _
 * @param {Parent | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $3bdc2073aabcf9e2$var$strongPeek(_, _1, state) {
    return state.options.strong || "*";
}

});
parcelRegister("dGeA4", function(module, exports) {

$parcel$export(module.exports, "checkStrong", () => $9f5a820f52b0d463$export$b7ce17905d66a6c3);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['strong'], null | undefined>}
 */ function $9f5a820f52b0d463$export$b7ce17905d66a6c3(state) {
    const marker = state.options.strong || "*";
    if (marker !== "*" && marker !== "_") throw new Error("Cannot serialize strong with `" + marker + "` for `options.strong`, expected `*`, or `_`");
    return marker;
}

});


parcelRegister("3wVYA", function(module, exports) {

$parcel$export(module.exports, "text", () => $29215519c9cf6e8e$export$6f093cfa640b7166);
/**
 * @typedef {import('mdast').Text} Text
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ /**
 * @param {Text} node
 * @param {Parent | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $29215519c9cf6e8e$export$6f093cfa640b7166(node, _, state, info) {
    return state.safe(node.value, info);
}

});

parcelRegister("9GBP5", function(module, exports) {

$parcel$export(module.exports, "thematicBreak", () => $70d560227691dc58$export$ba7b13e047416c03);
/**
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 */ 
var $haz8Y = parcelRequire("haz8Y");

var $11pUG = parcelRequire("11pUG");
function $70d560227691dc58$export$ba7b13e047416c03(_, _1, state) {
    const value = ((0, $11pUG.checkRule)(state) + (state.options.ruleSpaces ? " " : "")).repeat((0, $haz8Y.checkRuleRepetition)(state));
    return state.options.ruleSpaces ? value.slice(0, -1) : value;
}

});
parcelRegister("haz8Y", function(module, exports) {

$parcel$export(module.exports, "checkRuleRepetition", () => $c7fea1a8d1cfef86$export$72f02155834d89c4);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['ruleRepetition'], null | undefined>}
 */ function $c7fea1a8d1cfef86$export$72f02155834d89c4(state) {
    const repetition = state.options.ruleRepetition || 3;
    if (repetition < 3) throw new Error("Cannot serialize rules with repetition `" + repetition + "` for `options.ruleRepetition`, expected `3` or more");
    return repetition;
}

});



parcelRegister("byOSP", function(module, exports) {

$parcel$export(module.exports, "join", () => $86aa570f04acd473$export$f7e2c8231c57a8bd);
/**
 * @typedef {import('./types.js').Join} Join
 */ 
var $bQmKn = parcelRequire("bQmKn");

var $cgDcF = parcelRequire("cgDcF");
const $86aa570f04acd473$export$f7e2c8231c57a8bd = [
    $86aa570f04acd473$var$joinDefaults
];
/** @type {Join} */ function $86aa570f04acd473$var$joinDefaults(left, right, parent, state) {
    // Indented code after list or another indented code.
    if (right.type === "code" && (0, $bQmKn.formatCodeAsIndented)(right, state) && (left.type === "list" || left.type === right.type && (0, $bQmKn.formatCodeAsIndented)(left, state))) return false;
    // Two lists with the same marker.
    if (left.type === "list" && left.type === right.type && Boolean(left.ordered) === Boolean(right.ordered) && !(left.ordered ? state.options.bulletOrderedOther : state.options.bulletOther)) return false;
    // Join children of a list or an item.
    // In which case, `parent` has a `spread` field.
    if ("spread" in parent && typeof parent.spread === "boolean") {
        if (left.type === "paragraph" && // Two paragraphs.
        (left.type === right.type || right.type === "definition" || // Paragraph followed by a setext heading.
        right.type === "heading" && (0, $cgDcF.formatHeadingAsSetext)(right, state))) return;
        return parent.spread ? 1 : 0;
    }
}

});

parcelRegister("zvmfE", function(module, exports) {

$parcel$export(module.exports, "unsafe", () => $06ab980627fe6824$export$aa1c11b655786597);
/**
 * @typedef {import('./types.js').Unsafe} Unsafe
 * @typedef {import('./types.js').ConstructName} ConstructName
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain things like attention (emphasis, strong), images, or links.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * @type {Array<ConstructName>}
 */ const $06ab980627fe6824$var$fullPhrasingSpans = [
    "autolink",
    "destinationLiteral",
    "destinationRaw",
    "reference",
    "titleQuote",
    "titleApostrophe"
];
const $06ab980627fe6824$export$aa1c11b655786597 = [
    {
        character: "	",
        after: "[\\r\\n]",
        inConstruct: "phrasing"
    },
    {
        character: "	",
        before: "[\\r\\n]",
        inConstruct: "phrasing"
    },
    {
        character: "	",
        inConstruct: [
            "codeFencedLangGraveAccent",
            "codeFencedLangTilde"
        ]
    },
    {
        character: "\r",
        inConstruct: [
            "codeFencedLangGraveAccent",
            "codeFencedLangTilde",
            "codeFencedMetaGraveAccent",
            "codeFencedMetaTilde",
            "destinationLiteral",
            "headingAtx"
        ]
    },
    {
        character: "\n",
        inConstruct: [
            "codeFencedLangGraveAccent",
            "codeFencedLangTilde",
            "codeFencedMetaGraveAccent",
            "codeFencedMetaTilde",
            "destinationLiteral",
            "headingAtx"
        ]
    },
    {
        character: " ",
        after: "[\\r\\n]",
        inConstruct: "phrasing"
    },
    {
        character: " ",
        before: "[\\r\\n]",
        inConstruct: "phrasing"
    },
    {
        character: " ",
        inConstruct: [
            "codeFencedLangGraveAccent",
            "codeFencedLangTilde"
        ]
    },
    // An exclamation mark can start an image, if it is followed by a link or
    // a link reference.
    {
        character: "!",
        after: "\\[",
        inConstruct: "phrasing",
        notInConstruct: $06ab980627fe6824$var$fullPhrasingSpans
    },
    // A quote can break out of a title.
    {
        character: '"',
        inConstruct: "titleQuote"
    },
    // A number sign could start an ATX heading if it starts a line.
    {
        atBreak: true,
        character: "#"
    },
    {
        character: "#",
        inConstruct: "headingAtx",
        after: "(?:[\r\n]|$)"
    },
    // Dollar sign and percentage are not used in markdown.
    // An ampersand could start a character reference.
    {
        character: "&",
        after: "[#A-Za-z]",
        inConstruct: "phrasing"
    },
    // An apostrophe can break out of a title.
    {
        character: "'",
        inConstruct: "titleApostrophe"
    },
    // A left paren could break out of a destination raw.
    {
        character: "(",
        inConstruct: "destinationRaw"
    },
    // A left paren followed by `]` could make something into a link or image.
    {
        before: "\\]",
        character: "(",
        inConstruct: "phrasing",
        notInConstruct: $06ab980627fe6824$var$fullPhrasingSpans
    },
    // A right paren could start a list item or break out of a destination
    // raw.
    {
        atBreak: true,
        before: "\\d+",
        character: ")"
    },
    {
        character: ")",
        inConstruct: "destinationRaw"
    },
    // An asterisk can start thematic breaks, list items, emphasis, strong.
    {
        atBreak: true,
        character: "*",
        after: "(?:[ 	\r\n*])"
    },
    {
        character: "*",
        inConstruct: "phrasing",
        notInConstruct: $06ab980627fe6824$var$fullPhrasingSpans
    },
    // A plus sign could start a list item.
    {
        atBreak: true,
        character: "+",
        after: "(?:[ 	\r\n])"
    },
    // A dash can start thematic breaks, list items, and setext heading
    // underlines.
    {
        atBreak: true,
        character: "-",
        after: "(?:[ 	\r\n-])"
    },
    // A dot could start a list item.
    {
        atBreak: true,
        before: "\\d+",
        character: ".",
        after: "(?:[ 	\r\n]|$)"
    },
    // Slash, colon, and semicolon are not used in markdown for constructs.
    // A less than can start html (flow or text) or an autolink.
    // HTML could start with an exclamation mark (declaration, cdata, comment),
    // slash (closing tag), question mark (instruction), or a letter (tag).
    // An autolink also starts with a letter.
    // Finally, it could break out of a destination literal.
    {
        atBreak: true,
        character: "<",
        after: "[!/?A-Za-z]"
    },
    {
        character: "<",
        after: "[!/?A-Za-z]",
        inConstruct: "phrasing",
        notInConstruct: $06ab980627fe6824$var$fullPhrasingSpans
    },
    {
        character: "<",
        inConstruct: "destinationLiteral"
    },
    // An equals to can start setext heading underlines.
    {
        atBreak: true,
        character: "="
    },
    // A greater than can start block quotes and it can break out of a
    // destination literal.
    {
        atBreak: true,
        character: ">"
    },
    {
        character: ">",
        inConstruct: "destinationLiteral"
    },
    // Question mark and at sign are not used in markdown for constructs.
    // A left bracket can start definitions, references, labels,
    {
        atBreak: true,
        character: "["
    },
    {
        character: "[",
        inConstruct: "phrasing",
        notInConstruct: $06ab980627fe6824$var$fullPhrasingSpans
    },
    {
        character: "[",
        inConstruct: [
            "label",
            "reference"
        ]
    },
    // A backslash can start an escape (when followed by punctuation) or a
    // hard break (when followed by an eol).
    // Note: typical escapes are handled in `safe`!
    {
        character: "\\",
        after: "[\\r\\n]",
        inConstruct: "phrasing"
    },
    // A right bracket can exit labels.
    {
        character: "]",
        inConstruct: [
            "label",
            "reference"
        ]
    },
    // Caret is not used in markdown for constructs.
    // An underscore can start emphasis, strong, or a thematic break.
    {
        atBreak: true,
        character: "_"
    },
    {
        character: "_",
        inConstruct: "phrasing",
        notInConstruct: $06ab980627fe6824$var$fullPhrasingSpans
    },
    // A grave accent can start code (fenced or text), or it can break out of
    // a grave accent code fence.
    {
        atBreak: true,
        character: "`"
    },
    {
        character: "`",
        inConstruct: [
            "codeFencedLangGraveAccent",
            "codeFencedMetaGraveAccent"
        ]
    },
    {
        character: "`",
        inConstruct: "phrasing",
        notInConstruct: $06ab980627fe6824$var$fullPhrasingSpans
    },
    // Left brace, vertical bar, right brace are not used in markdown for
    // constructs.
    // A tilde can start code (fenced).
    {
        atBreak: true,
        character: "~"
    }
];

});




parcelRegister("7t8wP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5701db6aba377020$export$2e2bcd8739ae039);
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('hast-util-sanitize').Schema} Schema
 * @typedef {import('mdast-util-to-hast').Handlers} Handlers
 *
 * @typedef Options
 *   Configuration.
 * @property {boolean|Schema|null} [sanitize]
 *   How to sanitize the output.
 * @property {Handlers} [handlers={}]
 *   Object mapping mdast nodes to functions handling them.
 */ 
var $7HlUG = parcelRequire("7HlUG");

var $k4HBL = parcelRequire("k4HBL");

var $jLZ37 = parcelRequire("jLZ37");
function $5701db6aba377020$export$2e2bcd8739ae039(settings) {
    const options = {
        ...settings || {}
    };
    /** @type {boolean|undefined} */ let clean;
    if (typeof options.sanitize === "boolean") {
        clean = options.sanitize;
        options.sanitize = undefined;
    }
    if (typeof clean !== "boolean") clean = true;
    Object.assign(this, {
        Compiler: compiler
    });
    /**
   * @type {import('unified').CompilerFunction<Root, string>}
   */ function compiler(node, file) {
        const hast = (0, $jLZ37.toHast)(node, {
            allowDangerousHtml: !clean,
            handlers: options.handlers
        });
        // @ts-expect-error: assume root.
        const cleanHast = clean ? (0, $k4HBL.sanitize)(hast, options.sanitize) : hast;
        const result = (0, $7HlUG.toHtml)(// @ts-expect-error: assume root.
        cleanHast, Object.assign({}, options, {
            allowDangerousHtml: !clean
        }));
        if (file.extname) file.extname = ".html";
        // Add an eof eol.
        return node && node.type && node.type === "root" && result && /[^\r\n]/.test(result.charAt(result.length - 1)) ? result + "\n" : result;
    }
}

});
parcelRegister("7HlUG", function(module, exports) {

$parcel$export(module.exports, "toHtml", () => $59ad8c13d9107e7c$export$a10125c086a4df16);
/**
 * @typedef {import('./types.js').Node} Node
 * @typedef {import('./types.js').Parent} Parent
 * @typedef {import('./types.js').Content} Content
 * @typedef {import('./types.js').Options} Options
 * @typedef {import('./types.js').State} State
 */ 
var $9LDLu = parcelRequire("9LDLu");

var $eJvlo = parcelRequire("eJvlo");

var $4jffC = parcelRequire("4jffC");
function $59ad8c13d9107e7c$export$a10125c086a4df16(tree, options) {
    const options_ = options || {};
    const quote = options_.quote || '"';
    const alternative = quote === '"' ? "'" : '"';
    if (quote !== '"' && quote !== "'") throw new Error("Invalid quote `" + quote + "`, expected `'` or `\"`");
    /** @type {State} */ const state = {
        one: $59ad8c13d9107e7c$var$one,
        all: $59ad8c13d9107e7c$export$84bf76cd7afc7469,
        settings: {
            omitOptionalTags: options_.omitOptionalTags || false,
            allowParseErrors: options_.allowParseErrors || false,
            allowDangerousCharacters: options_.allowDangerousCharacters || false,
            quoteSmart: options_.quoteSmart || false,
            preferUnquoted: options_.preferUnquoted || false,
            tightAttributes: options_.tightAttributes || false,
            upperDoctype: options_.upperDoctype || false,
            tightDoctype: options_.tightDoctype || false,
            bogusComments: options_.bogusComments || false,
            tightCommaSeparatedLists: options_.tightCommaSeparatedLists || false,
            tightSelfClosing: options_.tightSelfClosing || false,
            collapseEmptyAttributes: options_.collapseEmptyAttributes || false,
            allowDangerousHtml: options_.allowDangerousHtml || false,
            voids: options_.voids || (0, $eJvlo.htmlVoidElements),
            characterReferences: options_.characterReferences || options_.entities || {},
            closeSelfClosing: options_.closeSelfClosing || false,
            closeEmptyElements: options_.closeEmptyElements || false
        },
        schema: options_.space === "svg" ? (0, $9LDLu.svg) : (0, $9LDLu.html),
        quote: quote,
        alternative: alternative
    };
    return state.one(Array.isArray(tree) ? {
        type: "root",
        children: tree
    } : tree, undefined, undefined);
}
/**
 * Serialize a node.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {Node} node
 *   Node to handle.
 * @param {number | undefined} index
 *   Index of `node` in `parent.
 * @param {Parent | undefined} parent
 *   Parent of `node`.
 * @returns {string}
 *   Serialized node.
 */ function $59ad8c13d9107e7c$var$one(node, index, parent) {
    return (0, $4jffC.handle)(node, index, parent, this);
}
function $59ad8c13d9107e7c$export$84bf76cd7afc7469(parent) {
    /** @type {Array<string>} */ const results = [];
    const children = parent && parent.children || [];
    let index = -1;
    while(++index < children.length)results[index] = this.one(children[index], index, parent);
    return results.join("");
}

});
parcelRegister("eJvlo", function(module, exports) {

$parcel$export(module.exports, "htmlVoidElements", () => $ab9d94f2edae641a$export$762508062d068de);
/**
 * List of HTML void tag names.
 *
 * @type {Array<string>}
 */ const $ab9d94f2edae641a$export$762508062d068de = [
    "area",
    "base",
    "basefont",
    "bgsound",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "image",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "menuitem",
    "meta",
    "nextid",
    "param",
    "source",
    "track",
    "wbr"
];

});

parcelRegister("4jffC", function(module, exports) {

$parcel$export(module.exports, "handle", () => $3234c449d92b02c9$export$8f34ce051745d39e);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Node} Node
 * @typedef {import('../types.js').Parent} Parent
 */ 
var $50w0t = parcelRequire("50w0t");

var $b28pB = parcelRequire("b28pB");

var $u29Qd = parcelRequire("u29Qd");

var $7G94o = parcelRequire("7G94o");

var $84Uwv = parcelRequire("84Uwv");

var $9zah4 = parcelRequire("9zah4");

var $bGuJP = parcelRequire("bGuJP");
const $3234c449d92b02c9$export$8f34ce051745d39e = (0, $50w0t.zwitch)("type", {
    invalid: $3234c449d92b02c9$var$invalid,
    unknown: $3234c449d92b02c9$var$unknown,
    handlers: {
        comment: $b28pB.comment,
        doctype: $u29Qd.doctype,
        element: $7G94o.element,
        raw: $84Uwv.raw,
        root: $9zah4.root,
        text: $bGuJP.text
    }
});
/**
 * Fail when a non-node is found in the tree.
 *
 * @param {unknown} node
 *   Unknown value.
 * @returns {never}
 *   Never.
 */ function $3234c449d92b02c9$var$invalid(node) {
    throw new Error("Expected node, not `" + node + "`");
}
/**
 * Fail when a node with an unknown type is found in the tree.
 *
 * @param {unknown} node
 *  Unknown node.
 * @returns {never}
 *   Never.
 */ function $3234c449d92b02c9$var$unknown(node) {
    // @ts-expect-error: `type` is defined.
    throw new Error("Cannot compile unknown node `" + node.type + "`");
}

});
parcelRegister("b28pB", function(module, exports) {

$parcel$export(module.exports, "comment", () => $808668093c235903$export$4a34f930e789283c);
/**
 * @typedef {import('../types.js').Comment} Comment
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 */ 
var $4wYiT = parcelRequire("4wYiT");
function $808668093c235903$export$4a34f930e789283c(node, _1, _2, state) {
    // See: <https://html.spec.whatwg.org/multipage/syntax.html#comments>
    return state.settings.bogusComments ? "<?" + (0, $4wYiT.stringifyEntities)(node.value, Object.assign({}, state.settings.characterReferences, {
        subset: [
            ">"
        ]
    })) + ">" : "<!--" + node.value.replace(/^>|^->|<!--|-->|--!>|<!-$/g, encode) + "-->";
    /**
   * @param {string} $0
   */ function encode($0) {
        return (0, $4wYiT.stringifyEntities)($0, Object.assign({}, state.settings.characterReferences, {
            subset: [
                "<",
                ">"
            ]
        }));
    }
}

});
parcelRegister("4wYiT", function(module, exports) {

$parcel$export(module.exports, "stringifyEntities", () => $34c8ed9f7f067530$export$aca9de459d63ca2e);
/**
 * @typedef {import('./core.js').CoreOptions & import('./util/format-smart.js').FormatSmartOptions} Options
 * @typedef {import('./core.js').CoreOptions} LightOptions
 */ 
var $8JDLV = parcelRequire("8JDLV");

var $fiIMO = parcelRequire("fiIMO");

var $eTbJm = parcelRequire("eTbJm");
function $34c8ed9f7f067530$export$aca9de459d63ca2e(value, options) {
    return (0, $8JDLV.core)(value, Object.assign({
        format: (0, $fiIMO.formatSmart)
    }, options));
}
function $34c8ed9f7f067530$export$a2577b9dadf100a3(value, options) {
    return (0, $8JDLV.core)(value, Object.assign({
        format: (0, $eTbJm.formatBasic)
    }, options));
}

});
parcelRegister("8JDLV", function(module, exports) {

$parcel$export(module.exports, "core", () => $65c16094d2969a64$export$b75f8c4f8f3fbd14);
/**
 * @typedef CoreOptions
 * @property {ReadonlyArray<string>} [subset=[]]
 *   Whether to only escape the given subset of characters.
 * @property {boolean} [escapeOnly=false]
 *   Whether to only escape possibly dangerous characters.
 *   Those characters are `"`, `&`, `'`, `<`, `>`, and `` ` ``.
 *
 * @typedef FormatOptions
 * @property {(code: number, next: number, options: CoreWithFormatOptions) => string} format
 *   Format strategy.
 *
 * @typedef {CoreOptions & FormatOptions & import('./util/format-smart.js').FormatSmartOptions} CoreWithFormatOptions
 */ const $65c16094d2969a64$var$defaultSubsetRegex = /["&'<>`]/g;
const $65c16094d2969a64$var$surrogatePairsRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
const $65c16094d2969a64$var$controlCharactersRegex = // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
/[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
const $65c16094d2969a64$var$regexEscapeRegex = /[|\\{}()[\]^$+*?.]/g;
/** @type {WeakMap<ReadonlyArray<string>, RegExp>} */ const $65c16094d2969a64$var$subsetToRegexCache = new WeakMap();
function $65c16094d2969a64$export$b75f8c4f8f3fbd14(value, options) {
    value = value.replace(options.subset ? $65c16094d2969a64$var$charactersToExpressionCached(options.subset) : $65c16094d2969a64$var$defaultSubsetRegex, basic);
    if (options.subset || options.escapeOnly) return value;
    return value// Surrogate pairs.
    .replace($65c16094d2969a64$var$surrogatePairsRegex, surrogate)// BMP control characters (C0 except for LF, CR, SP; DEL; and some more
    // non-ASCII ones).
    .replace($65c16094d2969a64$var$controlCharactersRegex, basic);
    /**
   * @param {string} pair
   * @param {number} index
   * @param {string} all
   */ function surrogate(pair, index, all) {
        return options.format((pair.charCodeAt(0) - 0xd800) * 0x400 + pair.charCodeAt(1) - 0xdc00 + 0x10000, all.charCodeAt(index + 2), options);
    }
    /**
   * @param {string} character
   * @param {number} index
   * @param {string} all
   */ function basic(character, index, all) {
        return options.format(character.charCodeAt(0), all.charCodeAt(index + 1), options);
    }
}
/**
 * A wrapper function that caches the result of `charactersToExpression` with a WeakMap.
 * This can improve performance when tooling calls `charactersToExpression` repeatedly
 * with the same subset.
 *
 * @param {ReadonlyArray<string>} subset
 * @returns {RegExp}
 */ function $65c16094d2969a64$var$charactersToExpressionCached(subset) {
    let cached = $65c16094d2969a64$var$subsetToRegexCache.get(subset);
    if (!cached) {
        cached = $65c16094d2969a64$var$charactersToExpression(subset);
        $65c16094d2969a64$var$subsetToRegexCache.set(subset, cached);
    }
    return cached;
}
/**
 * @param {ReadonlyArray<string>} subset
 * @returns {RegExp}
 */ function $65c16094d2969a64$var$charactersToExpression(subset) {
    /** @type {Array<string>} */ const groups = [];
    let index = -1;
    while(++index < subset.length)groups.push(subset[index].replace($65c16094d2969a64$var$regexEscapeRegex, "\\$&"));
    return new RegExp("(?:" + groups.join("|") + ")", "g");
}

});

parcelRegister("fiIMO", function(module, exports) {

$parcel$export(module.exports, "formatSmart", () => $b23b470fdf6d3871$export$f53904683bee23d7);
/**
 * @typedef FormatSmartOptions
 * @property {boolean} [useNamedReferences=false]
 *   Prefer named character references (`&amp;`) where possible.
 * @property {boolean} [useShortestReferences=false]
 *   Prefer the shortest possible reference, if that results in less bytes.
 *   **Note**: `useNamedReferences` can be omitted when using `useShortestReferences`.
 * @property {boolean} [omitOptionalSemicolons=false]
 *   Whether to omit semicolons when possible.
 *   **Note**: This creates what HTML calls “parse errors” but is otherwise still valid HTML — don’t use this except when building a minifier.
 *   Omitting semicolons is possible for certain named and numeric references in some cases.
 * @property {boolean} [attribute=false]
 *   Create character references which don’t fail in attributes.
 *   **Note**: `attribute` only applies when operating dangerously with
 *   `omitOptionalSemicolons: true`.
 */ 
var $a7odI = parcelRequire("a7odI");

var $gZLYA = parcelRequire("gZLYA");

var $bFA8V = parcelRequire("bFA8V");
function $b23b470fdf6d3871$export$f53904683bee23d7(code, next, options) {
    let numeric = (0, $a7odI.toHexadecimal)(code, next, options.omitOptionalSemicolons);
    /** @type {string|undefined} */ let named;
    if (options.useNamedReferences || options.useShortestReferences) named = (0, $bFA8V.toNamed)(code, next, options.omitOptionalSemicolons, options.attribute);
    // Use the shortest numeric reference when requested.
    // A simple algorithm would use decimal for all code points under 100, as
    // those are shorter than hexadecimal:
    //
    // * `&#99;` vs `&#x63;` (decimal shorter)
    // * `&#100;` vs `&#x64;` (equal)
    //
    // However, because we take `next` into consideration when `omit` is used,
    // And it would be possible that decimals are shorter on bigger values as
    // well if `next` is hexadecimal but not decimal, we instead compare both.
    if ((options.useShortestReferences || !named) && options.useShortestReferences) {
        const decimal = (0, $gZLYA.toDecimal)(code, next, options.omitOptionalSemicolons);
        if (decimal.length < numeric.length) numeric = decimal;
    }
    return named && (!options.useShortestReferences || named.length < numeric.length) ? named : numeric;
}

});
parcelRegister("a7odI", function(module, exports) {

$parcel$export(module.exports, "toHexadecimal", () => $75dd587808a4aaab$export$ef12b12fd64fa3cc);
const $75dd587808a4aaab$var$hexadecimalRegex = /[\dA-Fa-f]/;
function $75dd587808a4aaab$export$ef12b12fd64fa3cc(code, next, omit) {
    const value = "&#x" + code.toString(16).toUpperCase();
    return omit && next && !$75dd587808a4aaab$var$hexadecimalRegex.test(String.fromCharCode(next)) ? value : value + ";";
}

});

parcelRegister("gZLYA", function(module, exports) {

$parcel$export(module.exports, "toDecimal", () => $c5f78eea402c0d26$export$63ad841d70774900);
const $c5f78eea402c0d26$var$decimalRegex = /\d/;
function $c5f78eea402c0d26$export$63ad841d70774900(code, next, omit) {
    const value = "&#" + String(code);
    return omit && next && !$c5f78eea402c0d26$var$decimalRegex.test(String.fromCharCode(next)) ? value : value + ";";
}

});

parcelRegister("bFA8V", function(module, exports) {

$parcel$export(module.exports, "toNamed", () => $87ef8f4c330daa20$export$b1e14dcd42472e57);

var $g8aJg = parcelRequire("g8aJg");

var $68JrW = parcelRequire("68JrW");

var $kaQWb = parcelRequire("kaQWb");
const $87ef8f4c330daa20$var$own = {}.hasOwnProperty;
/**
 * `characterEntitiesHtml4` but inverted.
 *
 * @type {Record<string, string>}
 */ const $87ef8f4c330daa20$var$characters = {};
/** @type {string} */ let $87ef8f4c330daa20$var$key;
for($87ef8f4c330daa20$var$key in 0, $68JrW.characterEntitiesHtml4)if ($87ef8f4c330daa20$var$own.call((0, $68JrW.characterEntitiesHtml4), $87ef8f4c330daa20$var$key)) $87ef8f4c330daa20$var$characters[(0, $68JrW.characterEntitiesHtml4)[$87ef8f4c330daa20$var$key]] = $87ef8f4c330daa20$var$key;
const $87ef8f4c330daa20$var$notAlphanumericRegex = /[^\dA-Za-z]/;
function $87ef8f4c330daa20$export$b1e14dcd42472e57(code, next, omit, attribute) {
    const character = String.fromCharCode(code);
    if ($87ef8f4c330daa20$var$own.call($87ef8f4c330daa20$var$characters, character)) {
        const name = $87ef8f4c330daa20$var$characters[character];
        const value = "&" + name;
        if (omit && (0, $g8aJg.characterEntitiesLegacy).includes(name) && !(0, $kaQWb.dangerous).includes(name) && (!attribute || next && next !== 61 /* `=` */  && $87ef8f4c330daa20$var$notAlphanumericRegex.test(String.fromCharCode(next)))) return value;
        return value + ";";
    }
    return "";
}

});
parcelRegister("g8aJg", function(module, exports) {

$parcel$export(module.exports, "characterEntitiesLegacy", () => $bbe5b7456579297f$export$9545335bdecb4b8c);
/**
 * List of legacy HTML named character references that don’t need a trailing semicolon.
 *
 * @type {Array<string>}
 */ const $bbe5b7456579297f$export$9545335bdecb4b8c = [
    "AElig",
    "AMP",
    "Aacute",
    "Acirc",
    "Agrave",
    "Aring",
    "Atilde",
    "Auml",
    "COPY",
    "Ccedil",
    "ETH",
    "Eacute",
    "Ecirc",
    "Egrave",
    "Euml",
    "GT",
    "Iacute",
    "Icirc",
    "Igrave",
    "Iuml",
    "LT",
    "Ntilde",
    "Oacute",
    "Ocirc",
    "Ograve",
    "Oslash",
    "Otilde",
    "Ouml",
    "QUOT",
    "REG",
    "THORN",
    "Uacute",
    "Ucirc",
    "Ugrave",
    "Uuml",
    "Yacute",
    "aacute",
    "acirc",
    "acute",
    "aelig",
    "agrave",
    "amp",
    "aring",
    "atilde",
    "auml",
    "brvbar",
    "ccedil",
    "cedil",
    "cent",
    "copy",
    "curren",
    "deg",
    "divide",
    "eacute",
    "ecirc",
    "egrave",
    "eth",
    "euml",
    "frac12",
    "frac14",
    "frac34",
    "gt",
    "iacute",
    "icirc",
    "iexcl",
    "igrave",
    "iquest",
    "iuml",
    "laquo",
    "lt",
    "macr",
    "micro",
    "middot",
    "nbsp",
    "not",
    "ntilde",
    "oacute",
    "ocirc",
    "ograve",
    "ordf",
    "ordm",
    "oslash",
    "otilde",
    "ouml",
    "para",
    "plusmn",
    "pound",
    "quot",
    "raquo",
    "reg",
    "sect",
    "shy",
    "sup1",
    "sup2",
    "sup3",
    "szlig",
    "thorn",
    "times",
    "uacute",
    "ucirc",
    "ugrave",
    "uml",
    "uuml",
    "yacute",
    "yen",
    "yuml"
];

});

parcelRegister("68JrW", function(module, exports) {

$parcel$export(module.exports, "characterEntitiesHtml4", () => $4786becb152d1d93$export$40952e41c47e8e55);
/**
 * Map of named character references from HTML 4.
 *
 * @type {Record<string, string>}
 */ const $4786becb152d1d93$export$40952e41c47e8e55 = {
    nbsp: "\xa0",
    iexcl: "\xa1",
    cent: "\xa2",
    pound: "\xa3",
    curren: "\xa4",
    yen: "\xa5",
    brvbar: "\xa6",
    sect: "\xa7",
    uml: "\xa8",
    copy: "\xa9",
    ordf: "\xaa",
    laquo: "\xab",
    not: "\xac",
    shy: "\xad",
    reg: "\xae",
    macr: "\xaf",
    deg: "\xb0",
    plusmn: "\xb1",
    sup2: "\xb2",
    sup3: "\xb3",
    acute: "\xb4",
    micro: "\xb5",
    para: "\xb6",
    middot: "\xb7",
    cedil: "\xb8",
    sup1: "\xb9",
    ordm: "\xba",
    raquo: "\xbb",
    frac14: "\xbc",
    frac12: "\xbd",
    frac34: "\xbe",
    iquest: "\xbf",
    Agrave: "\xc0",
    Aacute: "\xc1",
    Acirc: "\xc2",
    Atilde: "\xc3",
    Auml: "\xc4",
    Aring: "\xc5",
    AElig: "\xc6",
    Ccedil: "\xc7",
    Egrave: "\xc8",
    Eacute: "\xc9",
    Ecirc: "\xca",
    Euml: "\xcb",
    Igrave: "\xcc",
    Iacute: "\xcd",
    Icirc: "\xce",
    Iuml: "\xcf",
    ETH: "\xd0",
    Ntilde: "\xd1",
    Ograve: "\xd2",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Otilde: "\xd5",
    Ouml: "\xd6",
    times: "\xd7",
    Oslash: "\xd8",
    Ugrave: "\xd9",
    Uacute: "\xda",
    Ucirc: "\xdb",
    Uuml: "\xdc",
    Yacute: "\xdd",
    THORN: "\xde",
    szlig: "\xdf",
    agrave: "\xe0",
    aacute: "\xe1",
    acirc: "\xe2",
    atilde: "\xe3",
    auml: "\xe4",
    aring: "\xe5",
    aelig: "\xe6",
    ccedil: "\xe7",
    egrave: "\xe8",
    eacute: "\xe9",
    ecirc: "\xea",
    euml: "\xeb",
    igrave: "\xec",
    iacute: "\xed",
    icirc: "\xee",
    iuml: "\xef",
    eth: "\xf0",
    ntilde: "\xf1",
    ograve: "\xf2",
    oacute: "\xf3",
    ocirc: "\xf4",
    otilde: "\xf5",
    ouml: "\xf6",
    divide: "\xf7",
    oslash: "\xf8",
    ugrave: "\xf9",
    uacute: "\xfa",
    ucirc: "\xfb",
    uuml: "\xfc",
    yacute: "\xfd",
    thorn: "\xfe",
    yuml: "\xff",
    fnof: "\u0192",
    Alpha: "\u0391",
    Beta: "\u0392",
    Gamma: "\u0393",
    Delta: "\u0394",
    Epsilon: "\u0395",
    Zeta: "\u0396",
    Eta: "\u0397",
    Theta: "\u0398",
    Iota: "\u0399",
    Kappa: "\u039A",
    Lambda: "\u039B",
    Mu: "\u039C",
    Nu: "\u039D",
    Xi: "\u039E",
    Omicron: "\u039F",
    Pi: "\u03A0",
    Rho: "\u03A1",
    Sigma: "\u03A3",
    Tau: "\u03A4",
    Upsilon: "\u03A5",
    Phi: "\u03A6",
    Chi: "\u03A7",
    Psi: "\u03A8",
    Omega: "\u03A9",
    alpha: "\u03B1",
    beta: "\u03B2",
    gamma: "\u03B3",
    delta: "\u03B4",
    epsilon: "\u03B5",
    zeta: "\u03B6",
    eta: "\u03B7",
    theta: "\u03B8",
    iota: "\u03B9",
    kappa: "\u03BA",
    lambda: "\u03BB",
    mu: "\u03BC",
    nu: "\u03BD",
    xi: "\u03BE",
    omicron: "\u03BF",
    pi: "\u03C0",
    rho: "\u03C1",
    sigmaf: "\u03C2",
    sigma: "\u03C3",
    tau: "\u03C4",
    upsilon: "\u03C5",
    phi: "\u03C6",
    chi: "\u03C7",
    psi: "\u03C8",
    omega: "\u03C9",
    thetasym: "\u03D1",
    upsih: "\u03D2",
    piv: "\u03D6",
    bull: "\u2022",
    hellip: "\u2026",
    prime: "\u2032",
    Prime: "\u2033",
    oline: "\u203E",
    frasl: "\u2044",
    weierp: "\u2118",
    image: "\u2111",
    real: "\u211C",
    trade: "\u2122",
    alefsym: "\u2135",
    larr: "\u2190",
    uarr: "\u2191",
    rarr: "\u2192",
    darr: "\u2193",
    harr: "\u2194",
    crarr: "\u21B5",
    lArr: "\u21D0",
    uArr: "\u21D1",
    rArr: "\u21D2",
    dArr: "\u21D3",
    hArr: "\u21D4",
    forall: "\u2200",
    part: "\u2202",
    exist: "\u2203",
    empty: "\u2205",
    nabla: "\u2207",
    isin: "\u2208",
    notin: "\u2209",
    ni: "\u220B",
    prod: "\u220F",
    sum: "\u2211",
    minus: "\u2212",
    lowast: "\u2217",
    radic: "\u221A",
    prop: "\u221D",
    infin: "\u221E",
    ang: "\u2220",
    and: "\u2227",
    or: "\u2228",
    cap: "\u2229",
    cup: "\u222A",
    int: "\u222B",
    there4: "\u2234",
    sim: "\u223C",
    cong: "\u2245",
    asymp: "\u2248",
    ne: "\u2260",
    equiv: "\u2261",
    le: "\u2264",
    ge: "\u2265",
    sub: "\u2282",
    sup: "\u2283",
    nsub: "\u2284",
    sube: "\u2286",
    supe: "\u2287",
    oplus: "\u2295",
    otimes: "\u2297",
    perp: "\u22A5",
    sdot: "\u22C5",
    lceil: "\u2308",
    rceil: "\u2309",
    lfloor: "\u230A",
    rfloor: "\u230B",
    lang: "\u2329",
    rang: "\u232A",
    loz: "\u25CA",
    spades: "\u2660",
    clubs: "\u2663",
    hearts: "\u2665",
    diams: "\u2666",
    quot: '"',
    amp: "&",
    lt: "<",
    gt: ">",
    OElig: "\u0152",
    oelig: "\u0153",
    Scaron: "\u0160",
    scaron: "\u0161",
    Yuml: "\u0178",
    circ: "\u02C6",
    tilde: "\u02DC",
    ensp: "\u2002",
    emsp: "\u2003",
    thinsp: "\u2009",
    zwnj: "\u200C",
    zwj: "\u200D",
    lrm: "\u200E",
    rlm: "\u200F",
    ndash: "\u2013",
    mdash: "\u2014",
    lsquo: "\u2018",
    rsquo: "\u2019",
    sbquo: "\u201A",
    ldquo: "\u201C",
    rdquo: "\u201D",
    bdquo: "\u201E",
    dagger: "\u2020",
    Dagger: "\u2021",
    permil: "\u2030",
    lsaquo: "\u2039",
    rsaquo: "\u203A",
    euro: "\u20AC"
};

});

parcelRegister("kaQWb", function(module, exports) {

$parcel$export(module.exports, "dangerous", () => $eafdce1927fd4652$export$39b76096d2f1d598);
/**
 * List of legacy (that don’t need a trailing `;`) named references which could,
 * depending on what follows them, turn into a different meaning
 *
 * @type {Array<string>}
 */ const $eafdce1927fd4652$export$39b76096d2f1d598 = [
    "cent",
    "copy",
    "divide",
    "gt",
    "lt",
    "not",
    "para",
    "times"
];

});



parcelRegister("eTbJm", function(module, exports) {

$parcel$export(module.exports, "formatBasic", () => $ad6f4d389d64d4ee$export$83cfa611e0071208);
/**
 * The smallest way to encode a character.
 *
 * @param {number} code
 * @returns {string}
 */ function $ad6f4d389d64d4ee$export$83cfa611e0071208(code) {
    return "&#x" + code.toString(16).toUpperCase() + ";";
}

});



parcelRegister("u29Qd", function(module, exports) {

$parcel$export(module.exports, "doctype", () => $05a479efcf9acdac$export$3c172dfa1c27da99);
/**
 * @typedef {import('../types.js').DocType} DocType
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 */ /**
 * Serialize a doctype.
 *
 * @param {DocType} _1
 *   Node to handle.
 * @param {number | undefined} _2
 *   Index of `node` in `parent.
 * @param {Parent | undefined} _3
 *   Parent of `node`.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {string}
 *   Serialized node.
 */ function $05a479efcf9acdac$export$3c172dfa1c27da99(_1, _2, _3, state) {
    return "<!" + (state.settings.upperDoctype ? "DOCTYPE" : "doctype") + (state.settings.tightDoctype ? "" : " ") + "html>";
}

});

parcelRegister("7G94o", function(module, exports) {

$parcel$export(module.exports, "element", () => $59737dbcf91cb899$export$8454457683f90105);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').Element} Element
 * @typedef {import('../types.js').Properties} Properties
 * @typedef {import('../types.js').PropertyValue} PropertyValue
 */ 
var $i2eI2 = parcelRequire("i2eI2");

var $ath1E = parcelRequire("ath1E");

var $dLz4Z = parcelRequire("dLz4Z");
var $9LDLu = parcelRequire("9LDLu");

var $4T1Yz = parcelRequire("4T1Yz");

var $4wYiT = parcelRequire("4wYiT");

var $e3cGZ = parcelRequire("e3cGZ");

var $a0nIF = parcelRequire("a0nIF");
/**
 * Maps of subsets.
 *
 * Each value is a matrix of tuples.
 * The value at `0` causes parse errors, the value at `1` is valid.
 * Of both, the value at `0` is unsafe, and the value at `1` is safe.
 *
 * @type {Record<'name' | 'unquoted' | 'single' | 'double', Array<[Array<string>, Array<string>]>>}
 */ const $59737dbcf91cb899$var$constants = {
    // See: <https://html.spec.whatwg.org/#attribute-name-state>.
    name: [
        [
            "	\n\f\r &/=>".split(""),
            "	\n\f\r \"&'/=>`".split("")
        ],
        [
            "\0	\n\f\r \"&'/<=>".split(""),
            "\0	\n\f\r \"&'/<=>`".split("")
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(unquoted)-state>.
    unquoted: [
        [
            "	\n\f\r &>".split(""),
            "\0	\n\f\r \"&'<=>`".split("")
        ],
        [
            "\0	\n\f\r \"&'<=>`".split(""),
            "\0	\n\f\r \"&'<=>`".split("")
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state>.
    single: [
        [
            "&'".split(""),
            "\"&'`".split("")
        ],
        [
            "\0&'".split(""),
            "\0\"&'`".split("")
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state>.
    double: [
        [
            '"&'.split(""),
            "\"&'`".split("")
        ],
        [
            '\0"&'.split(""),
            "\0\"&'`".split("")
        ]
    ]
};
function $59737dbcf91cb899$export$8454457683f90105(node, index, parent, state) {
    const schema = state.schema;
    const omit = schema.space === "svg" ? false : state.settings.omitOptionalTags;
    let selfClosing = schema.space === "svg" ? state.settings.closeEmptyElements : state.settings.voids.includes(node.tagName.toLowerCase());
    /** @type {Array<string>} */ const parts = [];
    /** @type {string} */ let last;
    if (schema.space === "html" && node.tagName === "svg") state.schema = (0, $9LDLu.svg);
    const attrs = $59737dbcf91cb899$var$serializeAttributes(state, node.properties);
    const content = state.all(schema.space === "html" && node.tagName === "template" ? node.content : node);
    state.schema = schema;
    // If the node is categorised as void, but it has children, remove the
    // categorisation.
    // This enables for example `menuitem`s, which are void in W3C HTML but not
    // void in WHATWG HTML, to be stringified properly.
    if (content) selfClosing = false;
    if (attrs || !omit || !(0, $e3cGZ.opening)(node, index, parent)) {
        parts.push("<", node.tagName, attrs ? " " + attrs : "");
        if (selfClosing && (schema.space === "svg" || state.settings.closeSelfClosing)) {
            last = attrs.charAt(attrs.length - 1);
            if (!state.settings.tightSelfClosing || last === "/" || last && last !== '"' && last !== "'") parts.push(" ");
            parts.push("/");
        }
        parts.push(">");
    }
    parts.push(content);
    if (!selfClosing && (!omit || !(0, $a0nIF.closing)(node, index, parent))) parts.push("</" + node.tagName + ">");
    return parts.join("");
}
/**
 * @param {State} state
 * @param {Properties | null | undefined} props
 * @returns {string}
 */ function $59737dbcf91cb899$var$serializeAttributes(state, props) {
    /** @type {Array<string>} */ const values = [];
    let index = -1;
    /** @type {string} */ let key;
    if (props) {
        for(key in props)if (props[key] !== undefined && props[key] !== null) {
            const value = $59737dbcf91cb899$var$serializeAttribute(state, key, props[key]);
            if (value) values.push(value);
        }
    }
    while(++index < values.length){
        const last = state.settings.tightAttributes ? values[index].charAt(values[index].length - 1) : null;
        // In tight mode, don’t add a space after quoted attributes.
        if (index !== values.length - 1 && last !== '"' && last !== "'") values[index] += " ";
    }
    return values.join("");
}
/**
 * @param {State} state
 * @param {string} key
 * @param {PropertyValue} value
 * @returns {string}
 */ // eslint-disable-next-line complexity
function $59737dbcf91cb899$var$serializeAttribute(state, key, value) {
    const info = (0, $dLz4Z.find)(state.schema, key);
    const x = state.settings.allowParseErrors && state.schema.space === "html" ? 0 : 1;
    const y = state.settings.allowDangerousCharacters ? 0 : 1;
    let quote = state.quote;
    /** @type {string | undefined} */ let result;
    if (info.overloadedBoolean && (value === info.attribute || value === "")) value = true;
    else if (info.boolean || info.overloadedBoolean && typeof value !== "string") value = Boolean(value);
    if (value === undefined || value === null || value === false || typeof value === "number" && Number.isNaN(value)) return "";
    const name = (0, $4wYiT.stringifyEntities)(info.attribute, Object.assign({}, state.settings.characterReferences, {
        // Always encode without parse errors in non-HTML.
        subset: $59737dbcf91cb899$var$constants.name[x][y]
    }));
    // No value.
    // There is currently only one boolean property in SVG: `[download]` on
    // `<a>`.
    // This property does not seem to work in browsers (Firefox, Safari, Chrome),
    // so I can’t test if dropping the value works.
    // But I assume that it should:
    //
    // ```html
    // <!doctype html>
    // <svg viewBox="0 0 100 100">
    //   <a href=https://example.com download>
    //     <circle cx=50 cy=40 r=35 />
    //   </a>
    // </svg>
    // ```
    //
    // See: <https://github.com/wooorm/property-information/blob/main/lib/svg.js>
    if (value === true) return name;
    // `spaces` doesn’t accept a second argument, but it’s given here just to
    // keep the code cleaner.
    value = Array.isArray(value) ? (info.commaSeparated ? (0, $ath1E.stringify) : (0, $4T1Yz.stringify))(value, {
        padLeft: !state.settings.tightCommaSeparatedLists
    }) : String(value);
    if (state.settings.collapseEmptyAttributes && !value) return name;
    // Check unquoted value.
    if (state.settings.preferUnquoted) result = (0, $4wYiT.stringifyEntities)(value, Object.assign({}, state.settings.characterReferences, {
        subset: $59737dbcf91cb899$var$constants.unquoted[x][y],
        attribute: true
    }));
    // If we don’t want unquoted, or if `value` contains character references when
    // unquoted…
    if (result !== value) {
        // If the alternative is less common than `quote`, switch.
        if (state.settings.quoteSmart && (0, $i2eI2.ccount)(value, quote) > (0, $i2eI2.ccount)(value, state.alternative)) quote = state.alternative;
        result = quote + (0, $4wYiT.stringifyEntities)(value, Object.assign({}, state.settings.characterReferences, {
            // Always encode without parse errors in non-HTML.
            subset: (quote === "'" ? $59737dbcf91cb899$var$constants.single : $59737dbcf91cb899$var$constants.double)[x][y],
            attribute: true
        })) + quote;
    }
    // Don’t add a `=` for unquoted empties.
    return name + (result ? "=" + result : result);
}

});
parcelRegister("e3cGZ", function(module, exports) {

$parcel$export(module.exports, "opening", () => $a3ab30f7892ce4df$export$47fa9d71658d4a69);
/**
 * @typedef {import('../types.js').Element} Element
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').Content} Content
 */ 
var $fWRhB = parcelRequire("fWRhB");

var $gYCn4 = parcelRequire("gYCn4");

var $a0nIF = parcelRequire("a0nIF");

var $hBzP2 = parcelRequire("hBzP2");
const $a3ab30f7892ce4df$export$47fa9d71658d4a69 = (0, $hBzP2.omission)({
    html: $a3ab30f7892ce4df$var$html,
    head: $a3ab30f7892ce4df$var$head,
    body: $a3ab30f7892ce4df$var$body,
    colgroup: $a3ab30f7892ce4df$var$colgroup,
    tbody: $a3ab30f7892ce4df$var$tbody
});
/**
 * Whether to omit `<html>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $a3ab30f7892ce4df$var$html(node) {
    const head = (0, $gYCn4.siblingAfter)(node, -1);
    return !head || head.type !== "comment";
}
/**
 * Whether to omit `<head>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $a3ab30f7892ce4df$var$head(node) {
    const children = node.children;
    /** @type {Array<string>} */ const seen = [];
    let index = -1;
    while(++index < children.length){
        const child = children[index];
        if (child.type === "element" && (child.tagName === "title" || child.tagName === "base")) {
            if (seen.includes(child.tagName)) return false;
            seen.push(child.tagName);
        }
    }
    return children.length > 0;
}
/**
 * Whether to omit `<body>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $a3ab30f7892ce4df$var$body(node) {
    const head = (0, $gYCn4.siblingAfter)(node, -1, true);
    return !head || head.type !== "comment" && !(head.type === "text" && (0, $fWRhB.whitespace)(head.value.charAt(0))) && !(head.type === "element" && (head.tagName === "meta" || head.tagName === "link" || head.tagName === "script" || head.tagName === "style" || head.tagName === "template"));
}
/**
 * Whether to omit `<colgroup>`.
 * The spec describes some logic for the opening tag, but it’s easier to
 * implement in the closing tag, to the same effect, so we handle it there
 * instead.
 *
 * @param {Element} node
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $a3ab30f7892ce4df$var$colgroup(node, index, parent) {
    const previous = (0, $gYCn4.siblingBefore)(parent, index);
    const head = (0, $gYCn4.siblingAfter)(node, -1, true);
    // Previous colgroup was already omitted.
    if (parent && previous && previous.type === "element" && previous.tagName === "colgroup" && (0, $a0nIF.closing)(previous, parent.children.indexOf(previous), parent)) return false;
    return head && head.type === "element" && head.tagName === "col";
}
/**
 * Whether to omit `<tbody>`.
 *
 * @param {Element} node
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $a3ab30f7892ce4df$var$tbody(node, index, parent) {
    const previous = (0, $gYCn4.siblingBefore)(parent, index);
    const head = (0, $gYCn4.siblingAfter)(node, -1);
    // Previous table section was already omitted.
    if (parent && previous && previous.type === "element" && (previous.tagName === "thead" || previous.tagName === "tbody") && (0, $a0nIF.closing)(previous, parent.children.indexOf(previous), parent)) return false;
    return head && head.type === "element" && head.tagName === "tr";
}

});
parcelRegister("gYCn4", function(module, exports) {

$parcel$export(module.exports, "siblingAfter", () => $c5c003a931864e74$export$a0f7cf204d8f22ba);
$parcel$export(module.exports, "siblingBefore", () => $c5c003a931864e74$export$b103c35f55382246);
/**
 * @typedef {import('../../types.js').Parent} Parent
 * @typedef {import('../../types.js').Content} Content
 */ 
var $fWRhB = parcelRequire("fWRhB");
const $c5c003a931864e74$export$a0f7cf204d8f22ba = $c5c003a931864e74$var$siblings(1);
const $c5c003a931864e74$export$b103c35f55382246 = $c5c003a931864e74$var$siblings(-1);
/**
 * Factory to check siblings in a direction.
 *
 * @param {number} increment
 */ function $c5c003a931864e74$var$siblings(increment) {
    return sibling;
    /**
   * Find applicable siblings in a direction.
   *
   * @param {Parent | null | undefined} parent
   * @param {number | null | undefined} index
   * @param {boolean | null | undefined} [includeWhitespace=false]
   * @returns {Content}
   */ function sibling(parent, index, includeWhitespace) {
        const siblings = parent ? parent.children : [];
        let offset = (index || 0) + increment;
        let next = siblings && siblings[offset];
        if (!includeWhitespace) while(next && (0, $fWRhB.whitespace)(next)){
            offset += increment;
            next = siblings[offset];
        }
        return next;
    }
}

});

parcelRegister("a0nIF", function(module, exports) {

$parcel$export(module.exports, "closing", () => $748c4da9bff43cd4$export$4e69df80cd44263b);
/**
 * @typedef {import('../types.js').Element} Element
 * @typedef {import('../types.js').Parent} Parent
 */ 
var $fWRhB = parcelRequire("fWRhB");

var $gYCn4 = parcelRequire("gYCn4");

var $hBzP2 = parcelRequire("hBzP2");
const $748c4da9bff43cd4$export$4e69df80cd44263b = (0, $hBzP2.omission)({
    html: $748c4da9bff43cd4$var$html,
    head: $748c4da9bff43cd4$var$headOrColgroupOrCaption,
    body: $748c4da9bff43cd4$var$body,
    p: $748c4da9bff43cd4$var$p,
    li: $748c4da9bff43cd4$var$li,
    dt: $748c4da9bff43cd4$var$dt,
    dd: $748c4da9bff43cd4$var$dd,
    rt: $748c4da9bff43cd4$var$rubyElement,
    rp: $748c4da9bff43cd4$var$rubyElement,
    optgroup: $748c4da9bff43cd4$var$optgroup,
    option: $748c4da9bff43cd4$var$option,
    menuitem: $748c4da9bff43cd4$var$menuitem,
    colgroup: $748c4da9bff43cd4$var$headOrColgroupOrCaption,
    caption: $748c4da9bff43cd4$var$headOrColgroupOrCaption,
    thead: $748c4da9bff43cd4$var$thead,
    tbody: $748c4da9bff43cd4$var$tbody,
    tfoot: $748c4da9bff43cd4$var$tfoot,
    tr: $748c4da9bff43cd4$var$tr,
    td: $748c4da9bff43cd4$var$cells,
    th: $748c4da9bff43cd4$var$cells
});
/**
 * Macro for `</head>`, `</colgroup>`, and `</caption>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$headOrColgroupOrCaption(_, index, parent) {
    const next = (0, $gYCn4.siblingAfter)(parent, index, true);
    return !next || next.type !== "comment" && !(next.type === "text" && (0, $fWRhB.whitespace)(next.value.charAt(0)));
}
/**
 * Whether to omit `</html>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$html(_, index, parent) {
    const next = (0, $gYCn4.siblingAfter)(parent, index);
    return !next || next.type !== "comment";
}
/**
 * Whether to omit `</body>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$body(_, index, parent) {
    const next = (0, $gYCn4.siblingAfter)(parent, index);
    return !next || next.type !== "comment";
}
/**
 * Whether to omit `</p>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ // eslint-disable-next-line complexity
function $748c4da9bff43cd4$var$p(_, index, parent) {
    const next = (0, $gYCn4.siblingAfter)(parent, index);
    return next ? next.type === "element" && (next.tagName === "address" || next.tagName === "article" || next.tagName === "aside" || next.tagName === "blockquote" || next.tagName === "details" || next.tagName === "div" || next.tagName === "dl" || next.tagName === "fieldset" || next.tagName === "figcaption" || next.tagName === "figure" || next.tagName === "footer" || next.tagName === "form" || next.tagName === "h1" || next.tagName === "h2" || next.tagName === "h3" || next.tagName === "h4" || next.tagName === "h5" || next.tagName === "h6" || next.tagName === "header" || next.tagName === "hgroup" || next.tagName === "hr" || next.tagName === "main" || next.tagName === "menu" || next.tagName === "nav" || next.tagName === "ol" || next.tagName === "p" || next.tagName === "pre" || next.tagName === "section" || next.tagName === "table" || next.tagName === "ul") : !parent || // Confusing parent.
    !(parent.type === "element" && (parent.tagName === "a" || parent.tagName === "audio" || parent.tagName === "del" || parent.tagName === "ins" || parent.tagName === "map" || parent.tagName === "noscript" || parent.tagName === "video"));
}
/**
 * Whether to omit `</li>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$li(_, index, parent) {
    const next = (0, $gYCn4.siblingAfter)(parent, index);
    return !next || next.type === "element" && next.tagName === "li";
}
/**
 * Whether to omit `</dt>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$dt(_, index, parent) {
    const next = (0, $gYCn4.siblingAfter)(parent, index);
    return next && next.type === "element" && (next.tagName === "dt" || next.tagName === "dd");
}
/**
 * Whether to omit `</dd>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$dd(_, index, parent) {
    const next = (0, $gYCn4.siblingAfter)(parent, index);
    return !next || next.type === "element" && (next.tagName === "dt" || next.tagName === "dd");
}
/**
 * Whether to omit `</rt>` or `</rp>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$rubyElement(_, index, parent) {
    const next = (0, $gYCn4.siblingAfter)(parent, index);
    return !next || next.type === "element" && (next.tagName === "rp" || next.tagName === "rt");
}
/**
 * Whether to omit `</optgroup>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$optgroup(_, index, parent) {
    const next = (0, $gYCn4.siblingAfter)(parent, index);
    return !next || next.type === "element" && next.tagName === "optgroup";
}
/**
 * Whether to omit `</option>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$option(_, index, parent) {
    const next = (0, $gYCn4.siblingAfter)(parent, index);
    return !next || next.type === "element" && (next.tagName === "option" || next.tagName === "optgroup");
}
/**
 * Whether to omit `</menuitem>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$menuitem(_, index, parent) {
    const next = (0, $gYCn4.siblingAfter)(parent, index);
    return !next || next.type === "element" && (next.tagName === "menuitem" || next.tagName === "hr" || next.tagName === "menu");
}
/**
 * Whether to omit `</thead>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$thead(_, index, parent) {
    const next = (0, $gYCn4.siblingAfter)(parent, index);
    return next && next.type === "element" && (next.tagName === "tbody" || next.tagName === "tfoot");
}
/**
 * Whether to omit `</tbody>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$tbody(_, index, parent) {
    const next = (0, $gYCn4.siblingAfter)(parent, index);
    return !next || next.type === "element" && (next.tagName === "tbody" || next.tagName === "tfoot");
}
/**
 * Whether to omit `</tfoot>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$tfoot(_, index, parent) {
    return !(0, $gYCn4.siblingAfter)(parent, index);
}
/**
 * Whether to omit `</tr>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$tr(_, index, parent) {
    const next = (0, $gYCn4.siblingAfter)(parent, index);
    return !next || next.type === "element" && next.tagName === "tr";
}
/**
 * Whether to omit `</td>` or `</th>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parent | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$cells(_, index, parent) {
    const next = (0, $gYCn4.siblingAfter)(parent, index);
    return !next || next.type === "element" && (next.tagName === "td" || next.tagName === "th");
}

});
parcelRegister("hBzP2", function(module, exports) {

$parcel$export(module.exports, "omission", () => $cd11ade637dd7c40$export$67d072dabf9c1c63);
/**
 * @typedef {import('../types.js').OmitHandle} OmitHandle
 */ const $cd11ade637dd7c40$var$own = {}.hasOwnProperty;
function $cd11ade637dd7c40$export$67d072dabf9c1c63(handlers) {
    return omit;
    /**
   * Check if a given node can have a tag omitted.
   *
   * @type {OmitHandle}
   */ function omit(node, index, parent) {
        return $cd11ade637dd7c40$var$own.call(handlers, node.tagName) && handlers[node.tagName](node, index, parent);
    }
}

});




parcelRegister("84Uwv", function(module, exports) {

$parcel$export(module.exports, "raw", () => $5e1a8ad143cd4167$export$1776c186c69df29e);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').Raw} Raw
 */ 
var $bGuJP = parcelRequire("bGuJP");
function $5e1a8ad143cd4167$export$1776c186c69df29e(node, index, parent, state) {
    return state.settings.allowDangerousHtml ? node.value : (0, $bGuJP.text)(node, index, parent, state);
}

});
parcelRegister("bGuJP", function(module, exports) {

$parcel$export(module.exports, "text", () => $881b75e46443a8ac$export$6f093cfa640b7166);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').Raw} Raw
 * @typedef {import('../types.js').Text} Text
 */ 
var $4wYiT = parcelRequire("4wYiT");
function $881b75e46443a8ac$export$6f093cfa640b7166(node, _, parent, state) {
    // Check if content of `node` should be escaped.
    return parent && parent.type === "element" && (parent.tagName === "script" || parent.tagName === "style") ? node.value : (0, $4wYiT.stringifyEntities)(node.value, Object.assign({}, state.settings.characterReferences, {
        subset: [
            "<",
            "&"
        ]
    }));
}

});


parcelRegister("9zah4", function(module, exports) {

$parcel$export(module.exports, "root", () => $6f6f5a39bff6d564$export$e8e78c978b129247);
/**
 * @typedef {import('../types.js').Root} Root
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 */ /**
 * Serialize a root.
 *
 * @param {Root} node
 *   Node to handle.
 * @param {number | undefined} _1
 *   Index of `node` in `parent.
 * @param {Parent | undefined} _2
 *   Parent of `node`.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {string}
 *   Serialized node.
 */ function $6f6f5a39bff6d564$export$e8e78c978b129247(node, _1, _2, state) {
    return state.all(node);
}

});



parcelRegister("k4HBL", function(module, exports) {

$parcel$export(module.exports, "sanitize", () => $e9d6020433358870$export$83d2e9e3e4ee39ed);
/**
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Content} Content
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {Content | Root} Node
 *
 * @typedef {Properties[string]} PropertyValue
 *   Possible property values.
 * @typedef {string | number | boolean} PrimitivePropertyValue
 *   Possible primitive HTML attribute values.
 *
 * @typedef {Record<string, Array<string | [string, ...Array<PrimitivePropertyValue | RegExp>]>>} Attributes
 *  Map of tag names to allow lists for each property.
 * @typedef {Record<string, Array<PrimitivePropertyValue | RegExp>>} AttributeClean
 *   Normalized input.
 *
 * @typedef Schema
 *   Sanitization configuration.
 * @property {Attributes | undefined} [attributes]
 *   Map of tag names to allowed properties.
 *
 *   The special `'*'` key defines property names allowed on all elements.
 * @property {Record<string, Record<string, PropertyValue>> | undefined} [required]
 *   Map of tag names to required property names and their default property value.
 * @property {Array<string> | undefined} [tagNames]
 *   List of allowed tag names.
 * @property {Record<string, Array<string>> | undefined} [protocols]
 *   Map of protocols to allow in property values.
 * @property {Record<string, Array<string>> | undefined} [ancestors]
 *   Map of tag names to their required ancestor elements.
 * @property {Array<string> | undefined} [clobber]
 *   List of allowed property names which can clobber.
 * @property {string | undefined} [clobberPrefix]
 *   Prefix to use before potentially clobbering property names.
 * @property {Array<string> | undefined} [strip]
 *   Names of elements to strip from the tree.
 * @property {boolean | undefined} [allowComments]
 *   Whether to allow comments.
 * @property {boolean | undefined} [allowDoctypes]
 *   Whether to allow doctypes.
 *
 * @typedef {(schema: Schema, value: any, node: any, stack: Array<string>) => unknown} Handler
 * @typedef {Record<string, Handler>} NodeDefinition
 * @typedef {((schema: Schema, node: Node) => NodeDefinition | undefined)} NodeDefinitionGetter
 * @typedef {Record<string, NodeDefinition | NodeDefinitionGetter>} NodeSchema
 */ 
var $aBLsM = parcelRequire("aBLsM");
const $e9d6020433358870$var$own = {}.hasOwnProperty;
/** @type {NodeSchema} */ const $e9d6020433358870$var$nodeSchema = {
    root: {
        children: $e9d6020433358870$var$all
    },
    doctype: $e9d6020433358870$var$handleDoctype,
    comment: $e9d6020433358870$var$handleComment,
    element: {
        tagName: $e9d6020433358870$var$handleTagName,
        properties: $e9d6020433358870$var$handleProperties,
        children: $e9d6020433358870$var$all
    },
    text: {
        value: $e9d6020433358870$var$handleValue
    },
    "*": {
        data: $e9d6020433358870$var$allow,
        position: $e9d6020433358870$var$allow
    }
};
function $e9d6020433358870$export$83d2e9e3e4ee39ed(node, schema) {
    /** @type {Node} */ let ctx = {
        type: "root",
        children: []
    };
    if (node && typeof node === "object" && node.type) {
        const replace = $e9d6020433358870$var$one(Object.assign({}, (0, $aBLsM.defaultSchema), schema || {}), node, []);
        if (replace) {
            if (Array.isArray(replace)) {
                if (replace.length === 1) ctx = replace[0];
                else // @ts-expect-error Assume `root` is not a child.
                ctx.children = replace;
            } else ctx = replace;
        }
    }
    return ctx;
}
/**
 * Sanitize `node`.
 *
 * @param {Schema} schema
 * @param {Node} node
 * @param {Array<string>} stack
 * @returns {Node | Array<Node> | undefined}
 */ function $e9d6020433358870$var$one(schema, node, stack) {
    const type = node && node.type;
    /** @type {Node} */ // @ts-expect-error rest of props added later.
    const replacement = {
        type: node.type
    };
    /** @type {boolean | undefined} */ let replace;
    if ($e9d6020433358870$var$own.call($e9d6020433358870$var$nodeSchema, type)) {
        /** @type {NodeDefinition | NodeDefinitionGetter | undefined} */ let definition = $e9d6020433358870$var$nodeSchema[type];
        if (typeof definition === "function") definition = definition(schema, node);
        if (definition) {
            const allowed = Object.assign({}, definition, $e9d6020433358870$var$nodeSchema["*"]);
            /** @type {string} */ let key;
            replace = true;
            for(key in allowed)if ($e9d6020433358870$var$own.call(allowed, key)) {
                // @ts-expect-error: fine.
                // type-coverage:ignore-next-line
                const result = allowed[key](schema, node[key], node, stack);
                // eslint-disable-next-line max-depth
                if (result === false) {
                    replace = undefined;
                    // Set the non-safe value.
                    // @ts-expect-error: fine.
                    // type-coverage:ignore-next-line
                    replacement[key] = node[key];
                } else if (result !== undefined && result !== null) // @ts-expect-error: fine.
                // type-coverage:ignore-next-line
                replacement[key] = result;
            }
        }
    }
    if (replace) return replacement;
    return replacement.type === "element" && schema.strip && !schema.strip.includes(replacement.tagName) ? replacement.children : undefined;
}
/**
 * Sanitize `children`.
 *
 * @type {Handler}
 * @param {Array<Node>} children
 * @param {Node} node
 * @returns {Array<Node>}
 */ function $e9d6020433358870$var$all(schema, children, node, stack) {
    /** @type {Array<Node>} */ const results = [];
    if (Array.isArray(children)) {
        let index = -1;
        if (node.type === "element") stack.push(node.tagName);
        while(++index < children.length){
            const value = $e9d6020433358870$var$one(schema, children[index], stack);
            if (value) {
                if (Array.isArray(value)) results.push(...value);
                else results.push(value);
            }
        }
        if (node.type === "element") stack.pop();
    }
    return results;
}
/** @type {NodeDefinitionGetter} */ function $e9d6020433358870$var$handleDoctype(schema) {
    return schema.allowDoctypes ? {
        name: $e9d6020433358870$var$handleDoctypeName
    } : undefined;
}
/** @type {NodeDefinitionGetter} */ function $e9d6020433358870$var$handleComment(schema) {
    return schema.allowComments ? {
        value: $e9d6020433358870$var$handleCommentValue
    } : undefined;
}
/**
 * Sanitize `properties`.
 *
 * @type {Handler}
 * @param {Properties} properties
 * @param {Element} node
 * @returns {Properties}
 */ function $e9d6020433358870$var$handleProperties(schema, properties, node, stack) {
    const name = $e9d6020433358870$var$handleTagName(schema, node.tagName, node, stack);
    /* c8 ignore next */ const attrs = schema.attributes || {};
    /* c8 ignore next */ const reqs = schema.required || {};
    const props = properties || {};
    const allowed = Object.assign({}, $e9d6020433358870$var$toPropertyValueMap(attrs["*"]), $e9d6020433358870$var$toPropertyValueMap(name && $e9d6020433358870$var$own.call(attrs, name) ? attrs[name] : []));
    /** @type {Properties} */ const result = {};
    /** @type {string} */ let key;
    for(key in props)if ($e9d6020433358870$var$own.call(props, key)) {
        let value = props[key];
        /** @type {AttributeClean[string]} */ let definition;
        if ($e9d6020433358870$var$own.call(allowed, key)) definition = allowed[key];
        else if ($e9d6020433358870$var$data(key) && $e9d6020433358870$var$own.call(allowed, "data*")) definition = allowed["data*"];
        else continue;
        value = Array.isArray(value) ? $e9d6020433358870$var$handlePropertyValues(schema, value, key, definition) : $e9d6020433358870$var$handlePropertyValue(schema, value, key, definition);
        if (value !== undefined && value !== null) result[key] = value;
    }
    if (name && $e9d6020433358870$var$own.call(reqs, name)) {
        for(key in reqs[name])if (!$e9d6020433358870$var$own.call(result, key)) result[key] = reqs[name][key];
    }
    return result;
}
/**
 * Always return a valid HTML5 doctype.
 *
 * @type {Handler}
 * @returns {string}
 */ function $e9d6020433358870$var$handleDoctypeName() {
    return "html";
}
/**
 * Sanitize `tagName`.
 *
 * @param {Schema} schema
 * @param {string} tagName
 * @param {Node} _
 * @param {Array<string>} stack
 * @returns {string | false}
 */ function $e9d6020433358870$var$handleTagName(schema, tagName, _, stack) {
    const name = typeof tagName === "string" ? tagName : "";
    let index = -1;
    if (!name || name === "*" || schema.tagNames && !schema.tagNames.includes(name)) return false;
    // Some nodes can break out of their context if they don’t have a certain
    // ancestor.
    if (schema.ancestors && $e9d6020433358870$var$own.call(schema.ancestors, name)) {
        while(++index < schema.ancestors[name].length){
            if (stack.includes(schema.ancestors[name][index])) return name;
        }
        return false;
    }
    return name;
}
/**
 * See <https://html.spec.whatwg.org/multipage/parsing.html#serialising-html-fragments>
 *
 * @type {Handler}
 * @param {unknown} value
 * @returns {string}
 */ function $e9d6020433358870$var$handleCommentValue(_, value) {
    /** @type {string} */ const result = typeof value === "string" ? value : "";
    const index = result.indexOf("-->");
    return index < 0 ? result : result.slice(0, index);
}
/**
 * Sanitize `value`.
 *
 * @type {Handler}
 * @param {unknown} value
 * @returns {string}
 */ function $e9d6020433358870$var$handleValue(_, value) {
    return typeof value === "string" ? value : "";
}
/**
 * Allow `value`.
 *
 * @type {Handler}
 * @param {unknown} value
 */ function $e9d6020433358870$var$allow(_, value) {
    return value;
}
/**
 * Sanitize a property value which is a list.
 *
 * @param {Schema} schema
 * @param {Array<unknown>} values
 * @param {string} prop
 * @param {AttributeClean[string]} definition
 * @returns {Array<string | number>}
 */ function $e9d6020433358870$var$handlePropertyValues(schema, values, prop, definition) {
    let index = -1;
    /** @type {Array<string | number>} */ const result = [];
    while(++index < values.length){
        const value = $e9d6020433358870$var$handlePropertyValue(schema, values[index], prop, definition);
        if (value !== undefined && value !== null) // @ts-expect-error Assume no booleans were in arrays.
        result.push(value);
    }
    return result;
}
/**
 * Sanitize a property value.
 *
 * @param {Schema} schema
 * @param {unknown} value
 * @param {string} prop
 * @param {AttributeClean[string]} definition
 * @returns {PropertyValue}
 */ function $e9d6020433358870$var$handlePropertyValue(schema, value, prop, definition) {
    if ((typeof value === "boolean" || typeof value === "number" || typeof value === "string") && $e9d6020433358870$var$safeProtocol(schema, value, prop) && (definition.length === 0 || definition.some((allowed)=>allowed && typeof allowed === "object" && "flags" in allowed ? allowed.test(String(value)) : allowed === value))) return schema.clobberPrefix && schema.clobber && schema.clobber.includes(prop) ? schema.clobberPrefix + value : value;
}
/**
 * Check whether `value` is a safe URL.
 *
 * @param {Schema} schema
 * @param {unknown} value
 * @param {string} prop
 * @returns {boolean}
 */ function $e9d6020433358870$var$safeProtocol(schema, value, prop) {
    const url = String(value);
    const colon = url.indexOf(":");
    const questionMark = url.indexOf("?");
    const numberSign = url.indexOf("#");
    const slash = url.indexOf("/");
    const protocols = schema.protocols && $e9d6020433358870$var$own.call(schema.protocols, prop) ? schema.protocols[prop].concat() : [];
    let index = -1;
    if (protocols.length === 0 || colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign) return true;
    while(++index < protocols.length){
        if (colon === protocols[index].length && url.slice(0, protocols[index].length) === protocols[index]) return true;
    }
    return false;
}
/**
 * Create a map from a list of props or a list of properties and values.
 *
 * @param {Attributes[string]} values
 * @returns {AttributeClean}
 */ function $e9d6020433358870$var$toPropertyValueMap(values) {
    /** @type {AttributeClean} */ const result = {};
    let index = -1;
    while(++index < values.length){
        const value = values[index];
        if (Array.isArray(value)) result[value[0]] = value.slice(1);
        else result[value] = [];
    }
    return result;
}
/**
 * Check if `prop` is a data property.
 *
 * @param {string} prop
 * @returns {boolean}
 */ function $e9d6020433358870$var$data(prop) {
    return prop.length > 4 && prop.slice(0, 4).toLowerCase() === "data";
}

});
parcelRegister("aBLsM", function(module, exports) {

$parcel$export(module.exports, "defaultSchema", () => $7b922d4c1abbb949$export$1db618b7b2275ea1);
/** @type {import('./index.js').Schema} */ const $7b922d4c1abbb949$export$1db618b7b2275ea1 = {
    strip: [
        "script"
    ],
    clobberPrefix: "user-content-",
    clobber: [
        "name",
        "id"
    ],
    ancestors: {
        tbody: [
            "table"
        ],
        tfoot: [
            "table"
        ],
        thead: [
            "table"
        ],
        td: [
            "table"
        ],
        th: [
            "table"
        ],
        tr: [
            "table"
        ]
    },
    protocols: {
        href: [
            "http",
            "https",
            "mailto",
            "xmpp",
            "irc",
            "ircs"
        ],
        cite: [
            "http",
            "https"
        ],
        src: [
            "http",
            "https"
        ],
        longDesc: [
            "http",
            "https"
        ]
    },
    tagNames: [
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "br",
        "b",
        "i",
        "strong",
        "em",
        "a",
        "pre",
        "code",
        "img",
        "tt",
        "div",
        "ins",
        "del",
        "sup",
        "sub",
        "p",
        "ol",
        "ul",
        "table",
        "thead",
        "tbody",
        "tfoot",
        "blockquote",
        "dl",
        "dt",
        "dd",
        "kbd",
        "q",
        "samp",
        "var",
        "hr",
        "ruby",
        "rt",
        "rp",
        "li",
        "tr",
        "td",
        "th",
        "s",
        "strike",
        "summary",
        "details",
        "caption",
        "figure",
        "figcaption",
        "abbr",
        "bdo",
        "cite",
        "dfn",
        "mark",
        "small",
        "span",
        "time",
        "wbr",
        "input"
    ],
    attributes: {
        a: [
            "href"
        ],
        img: [
            "src",
            "longDesc"
        ],
        input: [
            [
                "type",
                "checkbox"
            ],
            [
                "disabled",
                true
            ]
        ],
        li: [
            [
                "className",
                "task-list-item"
            ]
        ],
        div: [
            "itemScope",
            "itemType"
        ],
        blockquote: [
            "cite"
        ],
        del: [
            "cite"
        ],
        ins: [
            "cite"
        ],
        q: [
            "cite"
        ],
        "*": [
            "abbr",
            "accept",
            "acceptCharset",
            "accessKey",
            "action",
            "align",
            "alt",
            "ariaDescribedBy",
            "ariaHidden",
            "ariaLabel",
            "ariaLabelledBy",
            "axis",
            "border",
            "cellPadding",
            "cellSpacing",
            "char",
            "charOff",
            "charSet",
            "checked",
            "clear",
            "cols",
            "colSpan",
            "color",
            "compact",
            "coords",
            "dateTime",
            "dir",
            "disabled",
            "encType",
            "htmlFor",
            "frame",
            "headers",
            "height",
            "hrefLang",
            "hSpace",
            "isMap",
            "id",
            "label",
            "lang",
            "maxLength",
            "media",
            "method",
            "multiple",
            "name",
            "noHref",
            "noShade",
            "noWrap",
            "open",
            "prompt",
            "readOnly",
            "rel",
            "rev",
            "rows",
            "rowSpan",
            "rules",
            "scope",
            "selected",
            "shape",
            "size",
            "span",
            "start",
            "summary",
            "tabIndex",
            "target",
            "title",
            "type",
            "useMap",
            "vAlign",
            "value",
            "vSpace",
            "width",
            "itemProp"
        ]
    },
    required: {
        input: {
            type: "checkbox",
            disabled: true
        }
    }
};

});


parcelRegister("jLZ37", function(module, exports) {

$parcel$export(module.exports, "toHast", () => $e651c33bf4085f1d$export$c0e4c5cf07538633);
/**
 * @typedef {import('mdast').Root|import('mdast').Parent['children'][number]} MdastNode
 * @typedef {import('hast').Root|import('hast').Parent['children'][number]} HastNode
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').ElementContent} Content
 * @typedef {import('unist-util-position').PositionLike} PositionLike
 *
 * @typedef EmbeddedHastFields
 * @property {string} [hName] Defines the tag name of an element
 * @property {Properties} [hProperties] Defines the properties of an element
 * @property {Array.<Content>} [hChildren] Defines the (hast) children of an element
 *
 * @typedef {Object.<string, unknown> & EmbeddedHastFields} Data unist data with embedded hast fields
 *
 * @typedef {MdastNode & {data?: Data}} NodeWithData unist node with embedded hast data
 *
 * @callback Handler
 * @param {H} h Handle context
 * @param {any} node mdast node to handle
 * @param {Parent|null} parent Parent of `node`
 * @returns {Content|Array.<Content>|null|undefined} hast node
 *
 * @callback HFunctionProps
 * @param {MdastNode|PositionLike|null|undefined} node mdast node or unist position
 * @param {string} tagName HTML tag name
 * @param {Properties} props Properties
 * @param {Array.<Content>?} [children] hast content
 * @returns {Element}
 *
 * @callback HFunctionNoProps
 * @param {MdastNode|PositionLike|null|undefined} node mdast node or unist position
 * @param {string} tagName HTML tag name
 * @param {Array.<Content>?} [children] hast content
 * @returns {Element}
 *
 * @typedef HFields
 * @property {boolean} dangerous Whether HTML is allowed
 * @property {(identifier: string) => Definition|null} definition Definition cache
 * @property {Object.<string, FootnoteDefinition>} footnoteById Footnote cache
 * @property {Array.<string>} footnoteOrder Order in which footnotes occur
 * @property {Handlers} handlers Applied handlers
 * @property {Handler} unknownHandler Handler for any none not in `passThrough` or otherwise handled
 * @property {(left: NodeWithData|PositionLike|null|undefined, right: Content) => Content} augment Like `h` but lower-level and usable on non-elements.
 * @property {Array.<string>} passThrough List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 * @property {boolean} [allowDangerousHtml=false] Whether to allow `html` nodes and inject them as `raw` HTML
 * @property {Handlers} [handlers] Object mapping mdast nodes to functions handling them
 * @property {Array.<string>} [passThrough] List of custom mdast node types to pass through (keep) in hast
 * @property {Handler} [unknownHandler] Handler for all unknown nodes.
 *
 * @typedef {Record.<string, Handler>} Handlers Map of node types to handlers
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} H Handle context
 */ 
var $e9fUE = parcelRequire("e9fUE");

var $6qkIL = parcelRequire("6qkIL");

var $iXENv = parcelRequire("iXENv");

var $3ZDbL = parcelRequire("3ZDbL");

var $jyH67 = parcelRequire("jyH67");

var $l0fG9 = parcelRequire("l0fG9");

var $5OlNN = parcelRequire("5OlNN");

var $2YRmg = parcelRequire("2YRmg");
const $e651c33bf4085f1d$var$own = {}.hasOwnProperty;
/**
 * Factory to transform.
 * @param {MdastNode} tree mdast node
 * @param {Options} [options] Configuration
 * @returns {H} `h` function
 */ function $e651c33bf4085f1d$var$factory(tree, options) {
    const settings = options || {};
    const dangerous = settings.allowDangerousHtml || false;
    /** @type {Object.<string, FootnoteDefinition>} */ const footnoteById = {};
    h.dangerous = dangerous;
    h.definition = (0, $jyH67.definitions)(tree);
    h.footnoteById = footnoteById;
    /** @type {Array.<string>} */ h.footnoteOrder = [];
    h.augment = augment;
    h.handlers = {
        ...(0, $2YRmg.handlers),
        ...settings.handlers
    };
    h.unknownHandler = settings.unknownHandler;
    h.passThrough = settings.passThrough;
    (0, $6qkIL.visit)(tree, "footnoteDefinition", (definition)=>{
        const id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$e651c33bf4085f1d$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    });
    // @ts-expect-error Hush, it’s fine!
    return h;
    /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   * @param {(NodeWithData|PositionLike)?} left
   * @param {Content} right
   * @returns {Content}
   */ function augment(left, right) {
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && "data" in left && left.data) {
            /** @type {Data} */ const data = left.data;
            if (data.hName) {
                if (right.type !== "element") right = {
                    type: "element",
                    tagName: "",
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === "element" && data.hProperties) right.properties = {
                ...right.properties,
                ...data.hProperties
            };
            if ("children" in right && right.children && data.hChildren) right.children = data.hChildren;
        }
        if (left) {
            const ctx = "type" in left ? left : {
                position: left
            };
            if (!(0, $3ZDbL.generated)(ctx)) right.position = {
                start: (0, $iXENv.pointStart)(ctx),
                end: (0, $iXENv.pointEnd)(ctx)
            };
        }
        return right;
    }
    /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */ function h(node, tagName, props, children) {
        if (Array.isArray(props)) {
            children = props;
            props = {};
        }
        // @ts-expect-error augmenting an element yields an element.
        return augment(node, {
            type: "element",
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
}
function $e651c33bf4085f1d$export$c0e4c5cf07538633(tree, options) {
    const h = $e651c33bf4085f1d$var$factory(tree, options);
    const node = (0, $l0fG9.one)(h, tree, null);
    const foot = (0, $5OlNN.footer)(h);
    if (foot) // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push((0, $e9fUE.u)("text", "\n"), foot);
    return Array.isArray(node) ? {
        type: "root",
        children: node
    } : node;
}

});
parcelRegister("e9fUE", function(module, exports) {

$parcel$export(module.exports, "u", () => $a4ce3fe2bd346243$export$3b14a55fb2447963);
/**
 * @typedef {import('unist').Node} Node
 */ /**
 * @typedef {Array<Node> | string} ChildrenOrValue
 *   List to use as `children` or value to use as `value`.
 *
 * @typedef {Record<string, unknown>} Props
 *   Other fields to add to the node.
 */ /**
 * Build a node.
 *
 * @param type
 *   Node type.
 * @param props
 *   Fields assigned to node.
 * @param value
 *   Children of node or value of `node` (cast to string).
 * @returns
 *   Built node.
 */ const $a4ce3fe2bd346243$export$3b14a55fb2447963 = /**
   * @type {(
   *   (<T extends string>(type: T) => {type: T}) &
   *   (<T extends string, P extends Props>(type: T, props: P) => {type: T} & P) &
   *   (<T extends string>(type: T, value: string) => {type: T, value: string}) &
   *   (<T extends string, P extends Props>(type: T, props: P, value: string) => {type: T, value: string} & P) &
   *   (<T extends string, C extends Array<Node>>(type: T, children: C) => {type: T, children: C}) &
   *   (<T extends string, P extends Props, C extends Array<Node>>(type: T, props: P, children: C) => {type: T, children: C} & P)
   * )}
   */ /**
     * @param {string} type
     * @param {Props | ChildrenOrValue | null | undefined} [props]
     * @param {ChildrenOrValue | null | undefined} [value]
     * @returns {Node}
     */ function(type, props, value) {
    /** @type {Node} */ const node = {
        type: String(type)
    };
    if ((value === undefined || value === null) && (typeof props === "string" || Array.isArray(props))) value = props;
    else Object.assign(node, props);
    if (Array.isArray(value)) // @ts-expect-error: create a parent.
    node.children = value;
    else if (value !== undefined && value !== null) // @ts-expect-error: create a literal.
    node.value = String(value);
    return node;
};

});

parcelRegister("iXENv", function(module, exports) {

$parcel$export(module.exports, "pointStart", () => $dcdd6239abffe99e$export$771bf3e4949bfbee);
$parcel$export(module.exports, "pointEnd", () => $dcdd6239abffe99e$export$da309cdce9dc2a25);
/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $dcdd6239abffe99e$export$771bf3e4949bfbee = $dcdd6239abffe99e$var$point("start");
const $dcdd6239abffe99e$export$da309cdce9dc2a25 = $dcdd6239abffe99e$var$point("end");
function $dcdd6239abffe99e$export$5880b8b5730aff45(node) {
    return {
        start: $dcdd6239abffe99e$export$771bf3e4949bfbee(node),
        end: $dcdd6239abffe99e$export$da309cdce9dc2a25(node)
    };
}
/**
 * Get the positional info of `node`.
 *
 * @param {'start' | 'end'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $dcdd6239abffe99e$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {NodeLike | Node | null | undefined} [node]
   * @returns {Point}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        // To do: next major: don’t return points when invalid.
        return {
            // @ts-expect-error: in practice, null is allowed.
            line: point.line || null,
            // @ts-expect-error: in practice, null is allowed.
            column: point.column || null,
            // @ts-expect-error: in practice, null is allowed.
            offset: point.offset > -1 ? point.offset : null
        };
    }
}

});

parcelRegister("l0fG9", function(module, exports) {

$parcel$export(module.exports, "all", () => $f4a5c290bddc7972$export$84bf76cd7afc7469);
$parcel$export(module.exports, "one", () => $f4a5c290bddc7972$export$80bf7733f1207381);
/**
 * @typedef {import('mdast').Root|import('mdast').Parent['children'][number]} MdastNode
 * @typedef {import('./index.js').H} H
 * @typedef {import('./index.js').Handler} Handler
 * @typedef {import('./index.js').Content} Content
 */ 
var $e9fUE = parcelRequire("e9fUE");
const $f4a5c290bddc7972$var$own = {}.hasOwnProperty;
/**
 * Transform an unknown node.
 * @type {Handler}
 * @param {MdastNode} node
 */ function $f4a5c290bddc7972$var$unknown(h, node) {
    const data = node.data || {};
    if ("value" in node && !($f4a5c290bddc7972$var$own.call(data, "hName") || $f4a5c290bddc7972$var$own.call(data, "hProperties") || $f4a5c290bddc7972$var$own.call(data, "hChildren"))) return h.augment(node, (0, $e9fUE.u)("text", node.value));
    return h(node, "div", $f4a5c290bddc7972$export$84bf76cd7afc7469(h, node));
}
function $f4a5c290bddc7972$export$80bf7733f1207381(h, node, parent) {
    const type = node && node.type;
    /** @type {Handler} */ let fn;
    // Fail on non-nodes.
    if (!type) throw new Error("Expected node, got `" + node + "`");
    if ($f4a5c290bddc7972$var$own.call(h.handlers, type)) fn = h.handlers[type];
    else if (h.passThrough && h.passThrough.includes(type)) fn = $f4a5c290bddc7972$var$returnNode;
    else fn = h.unknownHandler;
    return (typeof fn === "function" ? fn : $f4a5c290bddc7972$var$unknown)(h, node, parent);
}
/**
 * @type {Handler}
 * @param {MdastNode} node
 */ function $f4a5c290bddc7972$var$returnNode(h, node) {
    // @ts-expect-error: Pass through custom node.
    return "children" in node ? {
        ...node,
        children: $f4a5c290bddc7972$export$84bf76cd7afc7469(h, node)
    } : node;
}
function $f4a5c290bddc7972$export$84bf76cd7afc7469(h, parent) {
    /** @type {Array.<Content>} */ const values = [];
    if ("children" in parent) {
        const nodes = parent.children;
        let index = -1;
        while(++index < nodes.length){
            const result = $f4a5c290bddc7972$export$80bf7733f1207381(h, nodes[index], parent);
            if (result) {
                if (index && nodes[index - 1].type === "break") {
                    if (!Array.isArray(result) && result.type === "text") result.value = result.value.replace(/^\s+/, "");
                    if (!Array.isArray(result) && result.type === "element") {
                        const head = result.children[0];
                        if (head && head.type === "text") head.value = head.value.replace(/^\s+/, "");
                    }
                }
                if (Array.isArray(result)) values.push(...result);
                else values.push(result);
            }
        }
    }
    return values;
}

});

parcelRegister("5OlNN", function(module, exports) {

$parcel$export(module.exports, "footer", () => $43b288b5d784432f$export$adb608be33961c98);
/**
 * @typedef {import('mdast').BlockContent} BlockContent
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('./index.js').H} H
 */ 
var $cnGZN = parcelRequire("cnGZN");

var $9nVoC = parcelRequire("9nVoC");

var $8vlEq = parcelRequire("8vlEq");
function $43b288b5d784432f$export$adb608be33961c98(h) {
    const footnoteById = h.footnoteById;
    const footnoteOrder = h.footnoteOrder;
    let index = -1;
    /** @type {Array.<ListItem>} */ const listItems = [];
    while(++index < footnoteOrder.length){
        const def = footnoteById[footnoteOrder[index].toUpperCase()];
        if (!def) continue;
        const marker = String(index + 1);
        const content = [
            ...def.children
        ];
        /** @type {Link} */ const backReference = {
            type: "link",
            url: "#fnref" + marker,
            data: {
                hProperties: {
                    className: [
                        "footnote-back"
                    ],
                    role: "doc-backlink"
                }
            },
            children: [
                {
                    type: "text",
                    value: "\u21A9"
                }
            ]
        };
        const tail = content[content.length - 1];
        if (tail && tail.type === "paragraph") tail.children.push(backReference);
        else // @ts-expect-error Indeed, link directly added in block content.
        // Which we do because that way at least the handlers will be called
        // for the other HTML we’re generating (as markdown).
        content.push(backReference);
        listItems.push({
            type: "listItem",
            data: {
                hProperties: {
                    id: "fn" + marker,
                    role: "doc-endnote"
                }
            },
            children: content,
            position: def.position
        });
    }
    if (listItems.length === 0) return null;
    return h(null, "section", {
        className: [
            "footnotes"
        ],
        role: "doc-endnotes"
    }, (0, $8vlEq.wrap)([
        (0, $cnGZN.thematicBreak)(h),
        (0, $9nVoC.list)(h, {
            type: "list",
            ordered: true,
            children: listItems
        })
    ], true));
}

});
parcelRegister("cnGZN", function(module, exports) {

$parcel$export(module.exports, "thematicBreak", () => $02537fefb8a9d631$export$ba7b13e047416c03);
/**
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('hast').Element} Element
 * @typedef {import('../index.js').Handler} Handler
 */ /**
 * @type {Handler}
 * @param {ThematicBreak} [node]
 * @returns {Element}
 */ function $02537fefb8a9d631$export$ba7b13e047416c03(h, node) {
    return h(node, "hr");
}

});

parcelRegister("9nVoC", function(module, exports) {

$parcel$export(module.exports, "list", () => $6d52c8b65c22a0f3$export$8837f4fc672e936d);
/**
 * @typedef {import('mdast').List} List
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $8vlEq = parcelRequire("8vlEq");

var $l0fG9 = parcelRequire("l0fG9");
function $6d52c8b65c22a0f3$export$8837f4fc672e936d(h, node) {
    /** @type {Properties} */ const props = {};
    const name = node.ordered ? "ol" : "ul";
    const items = (0, $l0fG9.all)(h, node);
    let index = -1;
    if (typeof node.start === "number" && node.start !== 1) props.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < items.length){
        const item = items[index];
        if (item.type === "element" && item.tagName === "li" && item.properties && Array.isArray(item.properties.className) && item.properties.className.includes("task-list-item")) {
            props.className = [
                "contains-task-list"
            ];
            break;
        }
    }
    return h(node, name, props, (0, $8vlEq.wrap)(items, true));
}

});
parcelRegister("8vlEq", function(module, exports) {

$parcel$export(module.exports, "wrap", () => $6312036d85444421$export$4997ffc0176396a6);
/**
 * @typedef {import('./index.js').Content} Content
 */ 
var $e9fUE = parcelRequire("e9fUE");
function $6312036d85444421$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array.<Content>} */ const result = [];
    let index = -1;
    if (loose) result.push((0, $e9fUE.u)("text", "\n"));
    while(++index < nodes.length){
        if (index) result.push((0, $e9fUE.u)("text", "\n"));
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push((0, $e9fUE.u)("text", "\n"));
    return result;
}

});



parcelRegister("2YRmg", function(module, exports) {

$parcel$export(module.exports, "handlers", () => $22ba932f8fab6e62$export$455ce229eb3d2472);

var $19M7I = parcelRequire("19M7I");

var $8csaV = parcelRequire("8csaV");

var $dGTos = parcelRequire("dGTos");

var $6OXI0 = parcelRequire("6OXI0");

var $9L7N6 = parcelRequire("9L7N6");

var $hT1R6 = parcelRequire("hT1R6");

var $fmRjw = parcelRequire("fmRjw");

var $b2FpY = parcelRequire("b2FpY");

var $ebILQ = parcelRequire("ebILQ");

var $4xDW2 = parcelRequire("4xDW2");

var $ltxKP = parcelRequire("ltxKP");

var $dRX9X = parcelRequire("dRX9X");

var $8eXiN = parcelRequire("8eXiN");

var $d1oC8 = parcelRequire("d1oC8");

var $11GXx = parcelRequire("11GXx");

var $9nVoC = parcelRequire("9nVoC");

var $5hX5r = parcelRequire("5hX5r");

var $cxBlE = parcelRequire("cxBlE");

var $ad65M = parcelRequire("ad65M");

var $glYDL = parcelRequire("glYDL");

var $hdLPH = parcelRequire("hdLPH");

var $cnGZN = parcelRequire("cnGZN");
const $22ba932f8fab6e62$export$455ce229eb3d2472 = {
    blockquote: $19M7I.blockquote,
    break: (0, $8csaV.hardBreak),
    code: $dGTos.code,
    delete: (0, $6OXI0.strikethrough),
    emphasis: $9L7N6.emphasis,
    footnoteReference: $hT1R6.footnoteReference,
    footnote: $fmRjw.footnote,
    heading: $b2FpY.heading,
    html: $ebILQ.html,
    imageReference: $4xDW2.imageReference,
    image: $ltxKP.image,
    inlineCode: $dRX9X.inlineCode,
    linkReference: $8eXiN.linkReference,
    link: $d1oC8.link,
    listItem: $11GXx.listItem,
    list: $9nVoC.list,
    paragraph: $5hX5r.paragraph,
    root: $cxBlE.root,
    strong: $ad65M.strong,
    table: $glYDL.table,
    text: $hdLPH.text,
    thematicBreak: $cnGZN.thematicBreak,
    toml: $22ba932f8fab6e62$var$ignore,
    yaml: $22ba932f8fab6e62$var$ignore,
    definition: $22ba932f8fab6e62$var$ignore,
    footnoteDefinition: $22ba932f8fab6e62$var$ignore
};
// Return nothing for nodes that are ignored.
function $22ba932f8fab6e62$var$ignore() {
    return null;
}

});
parcelRegister("19M7I", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $0d7bf6069cd4a99d$export$67dc04e652a298ca);
/**
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $8vlEq = parcelRequire("8vlEq");

var $l0fG9 = parcelRequire("l0fG9");
function $0d7bf6069cd4a99d$export$67dc04e652a298ca(h, node) {
    return h(node, "blockquote", (0, $8vlEq.wrap)((0, $l0fG9.all)(h, node), true));
}

});

parcelRegister("8csaV", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $5f854cb469f7f6cd$export$371da9dd35aba193);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $e9fUE = parcelRequire("e9fUE");
function $5f854cb469f7f6cd$export$371da9dd35aba193(h, node) {
    return [
        h(node, "br"),
        (0, $e9fUE.u)("text", "\n")
    ];
}

});

parcelRegister("dGTos", function(module, exports) {

$parcel$export(module.exports, "code", () => $9f7a2a9a3e8cdc0a$export$6565f9f03506010b);
/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $e9fUE = parcelRequire("e9fUE");
function $9f7a2a9a3e8cdc0a$export$6565f9f03506010b(h, node) {
    const value = node.value ? node.value + "\n" : "";
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    const lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/);
    /** @type {Properties} */ const props = {};
    if (lang) props.className = [
        "language-" + lang
    ];
    const code = h(node, "code", props, [
        (0, $e9fUE.u)("text", value)
    ]);
    if (node.meta) code.data = {
        meta: node.meta
    };
    return h(node.position, "pre", [
        code
    ]);
}

});

parcelRegister("6OXI0", function(module, exports) {

$parcel$export(module.exports, "strikethrough", () => $4f75ba80b35d3487$export$19426ff118fe8be);
/**
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $l0fG9 = parcelRequire("l0fG9");
function $4f75ba80b35d3487$export$19426ff118fe8be(h, node) {
    return h(node, "del", (0, $l0fG9.all)(h, node));
}

});

parcelRegister("9L7N6", function(module, exports) {

$parcel$export(module.exports, "emphasis", () => $71ae8bf40e51fddd$export$bef81ba411953b51);
/**
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $l0fG9 = parcelRequire("l0fG9");
function $71ae8bf40e51fddd$export$bef81ba411953b51(h, node) {
    return h(node, "em", (0, $l0fG9.all)(h, node));
}

});

parcelRegister("hT1R6", function(module, exports) {

$parcel$export(module.exports, "footnoteReference", () => $d059032a2037e72d$export$7f87ee744075c1ba);
/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $e9fUE = parcelRequire("e9fUE");
function $d059032a2037e72d$export$7f87ee744075c1ba(h, node) {
    const footnoteOrder = h.footnoteOrder;
    const identifier = String(node.identifier);
    const index = footnoteOrder.indexOf(identifier);
    const marker = String(index === -1 ? footnoteOrder.push(identifier) : index + 1);
    return h(node, "a", {
        href: "#fn" + marker,
        className: [
            "footnote-ref"
        ],
        id: "fnref" + marker,
        role: "doc-noteref"
    }, [
        h(node.position, "sup", [
            (0, $e9fUE.u)("text", marker)
        ])
    ]);
}

});

parcelRegister("fmRjw", function(module, exports) {

$parcel$export(module.exports, "footnote", () => $b302441aef2a42d1$export$3b6a720baa2c20ec);
/**
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $hT1R6 = parcelRequire("hT1R6");
function $b302441aef2a42d1$export$3b6a720baa2c20ec(h, node) {
    const footnoteById = h.footnoteById;
    const footnoteOrder = h.footnoteOrder;
    let no = 1;
    while(no in footnoteById)no++;
    const identifier = String(no);
    // No need to check if `identifier` exists in `footnoteOrder`, it’s guaranteed
    // to not exist because we just generated it.
    footnoteOrder.push(identifier);
    footnoteById[identifier] = {
        type: "footnoteDefinition",
        identifier: identifier,
        children: [
            {
                type: "paragraph",
                children: node.children
            }
        ],
        position: node.position
    };
    return (0, $hT1R6.footnoteReference)(h, {
        type: "footnoteReference",
        identifier: identifier,
        position: node.position
    });
}

});

parcelRegister("b2FpY", function(module, exports) {

$parcel$export(module.exports, "heading", () => $80a0025fee2734a4$export$46e4a324ac90507f);
/**
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $l0fG9 = parcelRequire("l0fG9");
function $80a0025fee2734a4$export$46e4a324ac90507f(h, node) {
    return h(node, "h" + node.depth, (0, $l0fG9.all)(h, node));
}

});

parcelRegister("ebILQ", function(module, exports) {

$parcel$export(module.exports, "html", () => $a544d24f31a6d015$export$c0bb0b647f701bb5);
/**
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $e9fUE = parcelRequire("e9fUE");
function $a544d24f31a6d015$export$c0bb0b647f701bb5(h, node) {
    return h.dangerous ? h.augment(node, (0, $e9fUE.u)("raw", node.value)) : null;
}

});

parcelRegister("4xDW2", function(module, exports) {

$parcel$export(module.exports, "imageReference", () => $34e938c73615b97e$export$f281796f6bc3b8db);
/**
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $dMZD4 = parcelRequire("dMZD4");

var $5XWq3 = parcelRequire("5XWq3");
function $34e938c73615b97e$export$f281796f6bc3b8db(h, node) {
    const def = h.definition(node.identifier);
    if (!def) return (0, $5XWq3.revert)(h, node);
    /** @type {Properties} */ const props = {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dMZD4)))(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, "img", props);
}

});
parcelRegister("dMZD4", function(module, exports) {
"use strict";
var $a09f9057097f68d0$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $a09f9057097f68d0$var$getEncodeCache(exclude) {
    var i, ch, cache = $a09f9057097f68d0$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $a09f9057097f68d0$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push("%" + ("0" + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $a09f9057097f68d0$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = "";
    if (typeof exclude !== "string") {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $a09f9057097f68d0$var$encode.defaultChars;
    }
    if (typeof keepEscaped === "undefined") keepEscaped = true;
    cache = $a09f9057097f68d0$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += "%EF%BF%BD";
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$a09f9057097f68d0$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$a09f9057097f68d0$var$encode.componentChars = "-_.!~*'()";
module.exports = $a09f9057097f68d0$var$encode;

});

parcelRegister("5XWq3", function(module, exports) {

$parcel$export(module.exports, "revert", () => $457fc7453091eab4$export$3fdd26f3d9e7dc78);
/**
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('./index.js').Handler} Handler
 * @typedef {import('./index.js').Content} Content
 */ 
var $e9fUE = parcelRequire("e9fUE");

var $l0fG9 = parcelRequire("l0fG9");
function $457fc7453091eab4$export$3fdd26f3d9e7dc78(h, node) {
    const subtype = node.referenceType;
    let suffix = "]";
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return (0, $e9fUE.u)("text", "![" + node.alt + suffix);
    const contents = (0, $l0fG9.all)(h, node);
    const head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift((0, $e9fUE.u)("text", "["));
    const tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push((0, $e9fUE.u)("text", suffix));
    return contents;
}

});


parcelRegister("ltxKP", function(module, exports) {

$parcel$export(module.exports, "image", () => $fa267d4e016e1a94$export$5c452ff88e35e47d);
/**
 * @typedef {import('mdast').Image} Image
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $dMZD4 = parcelRequire("dMZD4");
function $fa267d4e016e1a94$export$5c452ff88e35e47d(h, node) {
    /** @type {Properties} */ const props = {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dMZD4)))(node.url),
        alt: node.alt
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, "img", props);
}

});

parcelRegister("dRX9X", function(module, exports) {

$parcel$export(module.exports, "inlineCode", () => $a18e1d7c380780d4$export$91b9bee19a0d8569);
/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $e9fUE = parcelRequire("e9fUE");
function $a18e1d7c380780d4$export$91b9bee19a0d8569(h, node) {
    return h(node, "code", [
        (0, $e9fUE.u)("text", node.value.replace(/\r?\n|\r/g, " "))
    ]);
}

});

parcelRegister("8eXiN", function(module, exports) {

$parcel$export(module.exports, "linkReference", () => $5ffda1b647f76013$export$e6c469b1b7b2bc6a);
/**
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $dMZD4 = parcelRequire("dMZD4");

var $5XWq3 = parcelRequire("5XWq3");

var $l0fG9 = parcelRequire("l0fG9");
function $5ffda1b647f76013$export$e6c469b1b7b2bc6a(h, node) {
    const def = h.definition(node.identifier);
    if (!def) return (0, $5XWq3.revert)(h, node);
    /** @type {Properties} */ const props = {
        href: (0, (/*@__PURE__*/$parcel$interopDefault($dMZD4)))(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, "a", props, (0, $l0fG9.all)(h, node));
}

});

parcelRegister("d1oC8", function(module, exports) {

$parcel$export(module.exports, "link", () => $97ae763275816d1f$export$9c30223ca0a664fb);
/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $dMZD4 = parcelRequire("dMZD4");

var $l0fG9 = parcelRequire("l0fG9");
function $97ae763275816d1f$export$9c30223ca0a664fb(h, node) {
    /** @type {Properties} */ const props = {
        href: (0, (/*@__PURE__*/$parcel$interopDefault($dMZD4)))(node.url)
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, "a", props, (0, $l0fG9.all)(h, node));
}

});

parcelRegister("11GXx", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $0bf735405dac3389$export$76c7e83ecc9cdf05);
/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').List} List
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('../index.js').Handler} Handler
 * @typedef {import('../index.js').Content} Content
 */ 
var $e9fUE = parcelRequire("e9fUE");

var $l0fG9 = parcelRequire("l0fG9");
function $0bf735405dac3389$export$76c7e83ecc9cdf05(h, node, parent) {
    const result = (0, $l0fG9.all)(h, node);
    const loose = parent ? $0bf735405dac3389$var$listLoose(parent) : $0bf735405dac3389$var$listItemLoose(node);
    /** @type {Properties} */ const props = {};
    /** @type {Array.<Content>} */ const wrapped = [];
    if (typeof node.checked === "boolean") {
        /** @type {Element} */ let paragraph;
        if (result[0] && result[0].type === "element" && result[0].tagName === "p") paragraph = result[0];
        else {
            paragraph = h(null, "p", []);
            result.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift((0, $e9fUE.u)("text", " "));
        paragraph.children.unshift(h(null, "input", {
            type: "checkbox",
            checked: node.checked,
            disabled: true
        }));
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        props.className = [
            "task-list-item"
        ];
    }
    let index = -1;
    while(++index < result.length){
        const child = result[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== "element" || child.tagName !== "p") wrapped.push((0, $e9fUE.u)("text", "\n"));
        if (child.type === "element" && child.tagName === "p" && !loose) wrapped.push(...child.children);
        else wrapped.push(child);
    }
    const tail = result[result.length - 1];
    // Add a final eol.
    if (tail && (loose || !("tagName" in tail) || tail.tagName !== "p")) wrapped.push((0, $e9fUE.u)("text", "\n"));
    return h(node, "li", props, wrapped);
}
/**
 * @param {List} node
 * @return {Boolean}
 */ function $0bf735405dac3389$var$listLoose(node) {
    let loose = node.spread;
    const children = node.children;
    let index = -1;
    while(!loose && ++index < children.length)loose = $0bf735405dac3389$var$listItemLoose(children[index]);
    return Boolean(loose);
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $0bf735405dac3389$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}

});

parcelRegister("5hX5r", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $3d9c5fb20df8334b$export$9c206ddddb32a9b);
/**
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $l0fG9 = parcelRequire("l0fG9");
function $3d9c5fb20df8334b$export$9c206ddddb32a9b(h, node) {
    return h(node, "p", (0, $l0fG9.all)(h, node));
}

});

parcelRegister("cxBlE", function(module, exports) {

$parcel$export(module.exports, "root", () => $921589a7f49d4b71$export$e8e78c978b129247);
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $e9fUE = parcelRequire("e9fUE");

var $l0fG9 = parcelRequire("l0fG9");

var $8vlEq = parcelRequire("8vlEq");
function $921589a7f49d4b71$export$e8e78c978b129247(h, node) {
    // @ts-expect-error `root`s are also fine.
    return h.augment(node, (0, $e9fUE.u)("root", (0, $8vlEq.wrap)((0, $l0fG9.all)(h, node))));
}

});

parcelRegister("ad65M", function(module, exports) {

$parcel$export(module.exports, "strong", () => $76efd80b61faffa2$export$59ae2c325a998f89);
/**
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $l0fG9 = parcelRequire("l0fG9");
function $76efd80b61faffa2$export$59ae2c325a998f89(h, node) {
    return h(node, "strong", (0, $l0fG9.all)(h, node));
}

});

parcelRegister("glYDL", function(module, exports) {

$parcel$export(module.exports, "table", () => $be7da570dd44e9e6$export$9852986a3ec5f6a0);
/**
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('hast').Element} Element
 * @typedef {import('../index.js').Handler} Handler
 * @typedef {import('../index.js').Content} Content
 */ 
var $iXENv = parcelRequire("iXENv");

var $8vlEq = parcelRequire("8vlEq");

var $l0fG9 = parcelRequire("l0fG9");
function $be7da570dd44e9e6$export$9852986a3ec5f6a0(h, node) {
    const rows = node.children;
    let index = -1;
    const align = node.align || [];
    /** @type {Array.<Element>} */ const result = [];
    while(++index < rows.length){
        const row = rows[index].children;
        const name = index === 0 ? "th" : "td";
        let pos = node.align ? align.length : row.length;
        /** @type {Array.<Content>} */ const out = [];
        while(pos--){
            const cell = row[pos];
            out[pos] = h(cell, name, {
                align: align[pos]
            }, cell ? (0, $l0fG9.all)(h, cell) : []);
        }
        result[index] = h(rows[index], "tr", (0, $8vlEq.wrap)(out, true));
    }
    return h(node, "table", (0, $8vlEq.wrap)([
        h(result[0].position, "thead", (0, $8vlEq.wrap)([
            result[0]
        ], true))
    ].concat(result[1] ? h({
        start: (0, $iXENv.pointStart)(result[1]),
        end: (0, $iXENv.pointEnd)(result[result.length - 1])
    }, "tbody", (0, $8vlEq.wrap)(result.slice(1), true)) : []), true));
}

});

parcelRegister("hdLPH", function(module, exports) {

$parcel$export(module.exports, "text", () => $c898c12a1a7a9791$export$6f093cfa640b7166);
/**
 * @typedef {import('mdast').Text} Text
 * @typedef {import('../index.js').Handler} Handler
 */ 
var $e9fUE = parcelRequire("e9fUE");
function $c898c12a1a7a9791$export$6f093cfa640b7166(h, node) {
    return h.augment(node, (0, $e9fUE.u)("text", String(node.value).replace(/[ \t]*(\r?\n|\r)[ \t]*/g, "$1")));
}

});




parcelRegister("4V6JI", function(module, exports) {

$parcel$export(module.exports, "Interweave", () => $3951b603af646a6c$export$61a91e0722c8b868);

var $13FrP = parcelRequire("13FrP");

var $acw62 = parcelRequire("acw62");

var $i53gE = parcelRequire("i53gE");
function $3951b603af646a6c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $3951b603af646a6c$var$INVALID_STYLES = /(url|image|image-set)\(/i;
class $3951b603af646a6c$var$StyleFilter extends (0, $13FrP.F) {
    attribute(name, value) {
        if (name === "style") Object.keys(value).forEach((key)=>{
            if (String(value[key]).match($3951b603af646a6c$var$INVALID_STYLES)) // eslint-disable-next-line no-param-reassign
            delete value[key];
        });
         // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return value;
    }
}
/* eslint-disable no-bitwise, no-cond-assign, complexity, @typescript-eslint/no-unsafe-return */ const $3951b603af646a6c$var$ELEMENT_NODE = 1;
const $3951b603af646a6c$var$TEXT_NODE = 3;
const $3951b603af646a6c$var$INVALID_ROOTS = /^<(!doctype|(html|head|body)(\s|>))/i;
const $3951b603af646a6c$var$ALLOWED_ATTRS = /^(aria-|data-|\w+:)/iu;
const $3951b603af646a6c$var$OPEN_TOKEN = /{{{(\w+)\/?}}}/;
function $3951b603af646a6c$var$createDocument() {
    // Maybe SSR? Just do nothing instead of crashing!
    if (typeof window === "undefined" || typeof document === "undefined") return undefined;
    return document.implementation.createHTMLDocument("Interweave");
}
class $3951b603af646a6c$export$7acfa6ed01010e37 {
    constructor(markup, props = {}, matchers = [], filters = []){
        var _props$allowList;
        $3951b603af646a6c$var$_defineProperty(this, "allowed", void 0);
        $3951b603af646a6c$var$_defineProperty(this, "banned", void 0);
        $3951b603af646a6c$var$_defineProperty(this, "blocked", void 0);
        $3951b603af646a6c$var$_defineProperty(this, "container", void 0);
        $3951b603af646a6c$var$_defineProperty(this, "content", []);
        $3951b603af646a6c$var$_defineProperty(this, "props", void 0);
        $3951b603af646a6c$var$_defineProperty(this, "matchers", void 0);
        $3951b603af646a6c$var$_defineProperty(this, "filters", void 0);
        $3951b603af646a6c$var$_defineProperty(this, "keyIndex", void 0);
        this.props = props;
        this.matchers = matchers;
        this.filters = [
            ...filters,
            new $3951b603af646a6c$var$StyleFilter()
        ];
        this.keyIndex = -1;
        this.container = this.createContainer(markup || "");
        this.allowed = new Set((_props$allowList = props.allowList) !== null && _props$allowList !== void 0 ? _props$allowList : (0, $13FrP.A));
        this.banned = new Set((0, $13FrP.B));
        this.blocked = new Set(props.blockList);
    }
    /**
   * Loop through and apply all registered attribute filters.
   */ applyAttributeFilters(name, value) {
        return this.filters.reduce((nextValue, filter)=>nextValue !== null && typeof filter.attribute === "function" ? filter.attribute(name, nextValue) : nextValue, value);
    }
    /**
   * Loop through and apply all registered node filters.
   */ applyNodeFilters(name, node) {
        // Allow null to be returned
        return this.filters.reduce((nextNode, filter)=>nextNode !== null && typeof filter.node === "function" ? filter.node(name, nextNode) : nextNode, node);
    }
    /**
   * Loop through and apply all registered matchers to the string.
   * If a match is found, create a React element, and build a new array.
   * This array allows React to interpolate and render accordingly.
   */ applyMatchers(string, parentConfig) {
        const elements = {};
        const { props: props } = this;
        let matchedString = string;
        let elementIndex = 0;
        let parts = null;
        this.matchers.forEach((matcher)=>{
            const tagName = matcher.asTag().toLowerCase();
            const config = this.getTagConfig(tagName); // Skip matchers that have been disabled from props or are not supported
            if (props[matcher.inverseName] || !this.isTagAllowed(tagName)) return;
             // Skip matchers in which the child cannot be rendered
            if (!this.canRenderChild(parentConfig, config)) return;
             // Continuously trigger the matcher until no matches are found
            let tokenizedString = "";
            while(matchedString && (parts = matcher.match(matchedString))){
                const { index: index, length: length, match: match, valid: valid, void: isVoid, ...partProps } = parts;
                const tokenName = matcher.propName + String(elementIndex); // Piece together a new string with interpolated tokens
                if (index > 0) tokenizedString += matchedString.slice(0, index);
                if (valid) {
                    tokenizedString += isVoid ? `{{{${tokenName}/}}}` : `{{{${tokenName}}}}${match}{{{/${tokenName}}}}`;
                    this.keyIndex += 1;
                    elementIndex += 1;
                    elements[tokenName] = {
                        children: match,
                        matcher: matcher,
                        props: {
                            ...props,
                            ...partProps,
                            key: this.keyIndex
                        }
                    };
                } else tokenizedString += match;
                 // Reduce the string being matched against,
                // otherwise we end up in an infinite loop!
                if (matcher.greedy) {
                    matchedString = tokenizedString + matchedString.slice(index + length);
                    tokenizedString = "";
                } else // eslint-disable-next-line unicorn/explicit-length-check
                matchedString = matchedString.slice(index + (length || match.length));
            } // Update the matched string with the tokenized string,
            // so that the next matcher can apply to it.
            if (!matcher.greedy) matchedString = tokenizedString + matchedString;
        });
        if (elementIndex === 0) return string;
        return this.replaceTokens(matchedString, elements);
    }
    /**
   * Determine whether the child can be rendered within the parent.
   */ canRenderChild(parentConfig, childConfig) {
        if (!parentConfig.tagName || !childConfig.tagName) return false;
         // No children
        if (parentConfig.void) return false;
         // Valid children
        if (parentConfig.children.length > 0) return parentConfig.children.includes(childConfig.tagName);
        if (parentConfig.invalid.length > 0 && parentConfig.invalid.includes(childConfig.tagName)) return false;
         // Valid parent
        if (childConfig.parent.length > 0) return childConfig.parent.includes(parentConfig.tagName);
         // Self nesting
        if (!parentConfig.self && parentConfig.tagName === childConfig.tagName) return false;
         // Content category type
        return Boolean(parentConfig && parentConfig.content & childConfig.type);
    }
    /**
   * Convert line breaks in a string to HTML `<br/>` tags.
   * If the string contains HTML, we should not convert anything,
   * as line breaks should be handled by `<br/>`s in the markup itself.
   */ convertLineBreaks(markup) {
        const { noHtml: noHtml, disableLineBreaks: disableLineBreaks } = this.props;
        if (noHtml || disableLineBreaks || markup.match(/<((?:\/[ a-z]+)|(?:[ a-z]+\/))>/gi)) return markup;
         // Replace carriage returns
        let nextMarkup = markup.replace(/\r\n/g, "\n"); // Replace long line feeds
        nextMarkup = nextMarkup.replace(/\n{3,}/g, "\n\n\n"); // Replace line feeds with `<br/>`s
        nextMarkup = nextMarkup.replace(/\n/g, "<br/>");
        return nextMarkup;
    }
    /**
   * Create a detached HTML document that allows for easy HTML
   * parsing while not triggering scripts or loading external
   * resources.
   */ createContainer(markup) {
        var _this$props$container;
        const factory = typeof $parcel$global !== "undefined" && $parcel$global.INTERWEAVE_SSR_POLYFILL || $3951b603af646a6c$var$createDocument;
        const doc = factory();
        if (!doc) return undefined;
        const tag = (_this$props$container = this.props.containerTagName) !== null && _this$props$container !== void 0 ? _this$props$container : "body";
        const el = tag === "body" || tag === "fragment" ? doc.body : doc.createElement(tag);
        if (markup.match($3951b603af646a6c$var$INVALID_ROOTS)) ;
        else el.innerHTML = this.convertLineBreaks(this.props.escapeHtml ? (0, (/*@__PURE__*/$parcel$interopDefault($i53gE)))(markup) : markup);
        return el;
    }
    /**
   * Convert an elements attribute map to an object map.
   * Returns null if no attributes are defined.
   */ extractAttributes(node) {
        const { allowAttributes: allowAttributes } = this.props;
        const attributes = {};
        let count = 0;
        if (node.nodeType !== $3951b603af646a6c$var$ELEMENT_NODE || !node.attributes) return null;
         // @ts-expect-error Cant type iterator
        [
            ...node.attributes
        ].forEach((attr)=>{
            const { name: name, value: value } = attr;
            const newName = name.toLowerCase();
            const filter = (0, $13FrP.a)[newName] || (0, $13FrP.a)[name]; // Verify the node is safe from attacks
            if (!this.isSafe(node)) return;
             // Do not allow denied attributes, excluding ARIA attributes
            // Do not allow events or XSS injections
            if (!newName.match($3951b603af646a6c$var$ALLOWED_ATTRS) && (!allowAttributes && (!filter || filter === (0, $13FrP.b)) || newName.startsWith("on") || value.replace(/(\s|\0|&#x0([9AD]);)/, "").match(/(javascript|vbscript|livescript|xss):/i))) return;
             // Apply attribute filters
            let newValue = newName === "style" ? this.extractStyleAttribute(node) : value; // Cast to boolean
            if (filter === (0, $13FrP.d)) newValue = true; // Cast to number
            else if (filter === (0, $13FrP.e)) newValue = Number.parseFloat(String(newValue)); // Cast to string
            else if (filter !== (0, $13FrP.f)) newValue = String(newValue);
            attributes[(0, $13FrP.c)[newName] || newName] = this.applyAttributeFilters(newName, newValue);
            count += 1;
        });
        if (count === 0) return null;
        return attributes;
    }
    /**
   * Extract the style attribute as an object and remove values that allow for attack vectors.
   */ extractStyleAttribute(node) {
        const styles = {}; // eslint-disable-next-line unicorn/prefer-spread
        Array.from(node.style).forEach((key)=>{
            const value = node.style[key];
            if (typeof value === "string" || typeof value === "number") styles[key.replace(/-([a-z])/g, (match, letter)=>String(letter).toUpperCase())] = value;
        });
        return styles;
    }
    /**
   * Return configuration for a specific tag.
   */ getTagConfig(tagName) {
        const common = {
            children: [],
            content: 0,
            invalid: [],
            parent: [],
            self: true,
            tagName: "",
            type: 0,
            void: false
        }; // Only spread when a tag config exists,
        // otherwise we use the empty `tagName`
        // for parent config inheritance.
        if ((0, $13FrP.T)[tagName]) return {
            ...common,
            ...(0, $13FrP.T)[tagName],
            tagName: tagName
        };
        return common;
    }
    /**
   * Verify that a node is safe from XSS and injection attacks.
   */ isSafe(node) {
        // URLs should only support HTTP, email and phone numbers
        if (typeof HTMLAnchorElement !== "undefined" && node instanceof HTMLAnchorElement) {
            const href = node.getAttribute("href"); // Fragment protocols start with about:
            // So let's just allow them
            if (href !== null && href !== void 0 && href.startsWith("#")) return true;
            const protocol = node.protocol.toLowerCase();
            return protocol === ":" || protocol === "http:" || protocol === "https:" || protocol === "mailto:" || protocol === "tel:";
        }
        return true;
    }
    /**
   * Verify that an HTML tag is allowed to render.
   */ isTagAllowed(tagName) {
        if (this.banned.has(tagName) || this.blocked.has(tagName)) return false;
         // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        return this.props.allowElements || this.allowed.has(tagName);
    }
    /**
   * Parse the markup by injecting it into a detached document,
   * while looping over all child nodes and generating an
   * array to interpolate into JSX.
   */ parse() {
        if (!this.container) return [];
        return this.parseNode(this.container, this.getTagConfig(this.container.nodeName.toLowerCase()));
    }
    /**
   * Loop over the nodes children and generate a
   * list of text nodes and React elements.
   */ parseNode(parentNode, parentConfig) {
        const { noHtml: noHtml, noHtmlExceptMatchers: noHtmlExceptMatchers, allowElements: allowElements, transform: transform, transformOnlyAllowList: transformOnlyAllowList } = this.props;
        let content = [];
        let mergedText = ""; // @ts-expect-error Cant type iterator
        [
            ...parentNode.childNodes
        ].forEach((node)=>{
            // Create React elements from HTML elements
            if (node.nodeType === $3951b603af646a6c$var$ELEMENT_NODE) {
                const tagName = node.nodeName.toLowerCase();
                const config = this.getTagConfig(tagName); // Persist any previous text
                if (mergedText) {
                    content.push(mergedText);
                    mergedText = "";
                } // Apply node filters first
                const nextNode = this.applyNodeFilters(tagName, node);
                if (!nextNode) return;
                 // Apply transformation second
                let children;
                if (transform && !(transformOnlyAllowList && !this.isTagAllowed(tagName))) {
                    this.keyIndex += 1;
                    const key = this.keyIndex; // Must occur after key is set
                    children = this.parseNode(nextNode, config);
                    const transformed = transform(nextNode, children, config);
                    if (transformed === null) return;
                    if (typeof transformed !== "undefined") {
                        content.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(transformed, {
                            key: key
                        }));
                        return;
                    } // Reset as we're not using the transformation
                    this.keyIndex = key - 1;
                } // Never allow these tags (except via a transformer)
                if (this.banned.has(tagName)) return;
                 // Only render when the following criteria is met:
                //  - HTML has not been disabled
                //  - Tag is allowed
                //  - Child is valid within the parent
                if (!(noHtml || noHtmlExceptMatchers && tagName !== "br") && this.isTagAllowed(tagName) && (allowElements || this.canRenderChild(parentConfig, config))) {
                    var _children;
                    this.keyIndex += 1; // Build the props as it makes it easier to test
                    const attributes = this.extractAttributes(nextNode);
                    const elementProps = {
                        tagName: tagName
                    };
                    if (attributes) elementProps.attributes = attributes;
                    if (config.void) elementProps.selfClose = config.void;
                    content.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $13FrP.E), {
                        ...elementProps,
                        key: this.keyIndex
                    }, (_children = children) !== null && _children !== void 0 ? _children : this.parseNode(nextNode, config))); // Render the children of the current element only.
                // Important: If the current element is not allowed,
                // use the parent element for the next scope.
                } else content = [
                    ...content,
                    ...this.parseNode(nextNode, config.tagName ? config : parentConfig)
                ];
                 // Apply matchers if a text node
            } else if (node.nodeType === $3951b603af646a6c$var$TEXT_NODE) {
                const text = noHtml && !noHtmlExceptMatchers ? node.textContent : this.applyMatchers(node.textContent || "", parentConfig);
                if (Array.isArray(text)) content = [
                    ...content,
                    ...text
                ];
                else mergedText += text;
            }
        });
        if (mergedText) content.push(mergedText);
        return content;
    }
    /**
   * Deconstruct the string into an array, by replacing custom tokens with React elements,
   * so that React can render it correctly.
   */ replaceTokens(tokenizedString, elements) {
        if (!tokenizedString.includes("{{{")) return tokenizedString;
        const nodes = [];
        let text = tokenizedString;
        let open = null; // Find an open token tag
        while(open = text.match($3951b603af646a6c$var$OPEN_TOKEN)){
            const [match, tokenName] = open;
            const startIndex = open.index;
            const isVoid = match.includes("/");
            if (startIndex > 0) {
                nodes.push(text.slice(0, startIndex)); // Reduce text so that the closing tag will be found after the opening
                text = text.slice(startIndex);
            }
            const { children: children, matcher: matcher, props: elementProps } = elements[tokenName];
            let endIndex; // Use tag as-is if void
            if (isVoid) {
                endIndex = match.length;
                nodes.push(matcher.createElement(children, elementProps)); // Find the closing tag if not void
            } else {
                const close = text.match(new RegExp(`{{{/${tokenName}}}}`));
                endIndex = close.index + close[0].length;
                nodes.push(matcher.createElement(this.replaceTokens(text.slice(match.length, close.index), elements), elementProps));
            } // Reduce text for the next interation
            text = text.slice(endIndex);
        } // Extra the remaining text
        if (text.length > 0) nodes.push(text);
         // Reduce to a string if possible
        if (nodes.length === 0) return "";
        if (nodes.length === 1 && typeof nodes[0] === "string") return nodes[0];
        return nodes;
    }
}
/* eslint-disable react/jsx-fragments */ function $3951b603af646a6c$export$b925b7ba50a6200f(props) {
    var _ref;
    const { attributes: attributes, className: className, containerTagName: containerTagName, content: content, emptyContent: emptyContent, parsedContent: parsedContent, tagName: tagName, noWrap: baseNoWrap } = props;
    const tag = (_ref = containerTagName !== null && containerTagName !== void 0 ? containerTagName : tagName) !== null && _ref !== void 0 ? _ref : "span";
    const noWrap = tag === "fragment" ? true : baseNoWrap;
    let mainContent;
    if (parsedContent) mainContent = parsedContent;
    else {
        const markup = new $3951b603af646a6c$export$7acfa6ed01010e37(content !== null && content !== void 0 ? content : "", props).parse();
        if (markup.length > 0) mainContent = markup;
    }
    if (!mainContent) mainContent = emptyContent;
    if (noWrap) // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, mainContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $13FrP.E), {
        attributes: attributes,
        className: className,
        tagName: tag
    }, mainContent);
}
/* eslint-disable promise/prefer-await-to-callbacks */ function $3951b603af646a6c$export$61a91e0722c8b868(props) {
    const { attributes: attributes, className: className, content: content = "", disableFilters: disableFilters = false, disableMatchers: disableMatchers = false, emptyContent: emptyContent = null, filters: filters = [], matchers: matchers = [], onAfterParse: onAfterParse = null, onBeforeParse: onBeforeParse = null, tagName: tagName = "span", noWrap: noWrap = false, ...parserProps } = props;
    const allMatchers = disableMatchers ? [] : matchers;
    const allFilters = disableFilters ? [] : filters;
    const beforeCallbacks = onBeforeParse ? [
        onBeforeParse
    ] : [];
    const afterCallbacks = onAfterParse ? [
        onAfterParse
    ] : []; // Inherit callbacks from matchers
    allMatchers.forEach((matcher)=>{
        if (matcher.onBeforeParse) beforeCallbacks.push(matcher.onBeforeParse.bind(matcher));
        if (matcher.onAfterParse) afterCallbacks.push(matcher.onAfterParse.bind(matcher));
    }); // Trigger before callbacks
    const markup = beforeCallbacks.reduce((string, callback)=>{
        const nextString = callback(string, props);
        return nextString;
    }, content !== null && content !== void 0 ? content : ""); // Parse the markup
    const parser = new $3951b603af646a6c$export$7acfa6ed01010e37(markup, parserProps, allMatchers, allFilters); // Trigger after callbacks
    const nodes = afterCallbacks.reduce((parserNodes, callback)=>{
        const nextNodes = callback(parserNodes, props);
        return nextNodes;
    }, parser.parse());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3951b603af646a6c$export$b925b7ba50a6200f, {
        attributes: attributes,
        className: className // eslint-disable-next-line react/destructuring-assignment
        ,
        containerTagName: props.containerTagName,
        emptyContent: emptyContent,
        noWrap: noWrap,
        parsedContent: nodes.length === 0 ? undefined : nodes,
        tagName: tagName
    });
}

});
parcelRegister("13FrP", function(module, exports) {

$parcel$export(module.exports, "T", () => $0c5638ed7aec54f5$export$971d5caa766a69d7);
$parcel$export(module.exports, "B", () => $0c5638ed7aec54f5$export$ef35774e6d314e91);
$parcel$export(module.exports, "A", () => $0c5638ed7aec54f5$export$ebd11618f299a286);
$parcel$export(module.exports, "b", () => $0c5638ed7aec54f5$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "e", () => $0c5638ed7aec54f5$export$f1e1789686576879);
$parcel$export(module.exports, "d", () => $0c5638ed7aec54f5$export$4368d992c4eafac0);
$parcel$export(module.exports, "f", () => $0c5638ed7aec54f5$export$2d1720544b23b823);
$parcel$export(module.exports, "a", () => $0c5638ed7aec54f5$export$407448d2b89b1813);
$parcel$export(module.exports, "c", () => $0c5638ed7aec54f5$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $0c5638ed7aec54f5$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "F", () => $0c5638ed7aec54f5$export$d66501df72047452);

var $acw62 = parcelRequire("acw62");
function $0c5638ed7aec54f5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/* eslint-disable no-bitwise, no-magic-numbers, sort-keys */ // https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Content_categories
const $0c5638ed7aec54f5$export$39b482c5e57630a8 = 1;
const $0c5638ed7aec54f5$export$dda1d9f60106f0e9 = 2;
const $0c5638ed7aec54f5$export$23f2a1d2818174ef = 4;
const $0c5638ed7aec54f5$export$35e795649ee09318 = 8;
const $0c5638ed7aec54f5$export$342063e11d6c3cad = 16;
const $0c5638ed7aec54f5$export$882b5998b3b9117c = 32;
const $0c5638ed7aec54f5$export$953cecd6e717a553 = 64; // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
const $0c5638ed7aec54f5$var$tagConfigs = {
    a: {
        content: $0c5638ed7aec54f5$export$39b482c5e57630a8 | $0c5638ed7aec54f5$export$35e795649ee09318,
        self: false,
        type: $0c5638ed7aec54f5$export$39b482c5e57630a8 | $0c5638ed7aec54f5$export$35e795649ee09318 | $0c5638ed7aec54f5$export$882b5998b3b9117c | $0c5638ed7aec54f5$export$953cecd6e717a553
    },
    address: {
        invalid: [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "address",
            "article",
            "aside",
            "section",
            "div",
            "header",
            "footer"
        ],
        self: false
    },
    audio: {
        children: [
            "track",
            "source"
        ]
    },
    br: {
        type: $0c5638ed7aec54f5$export$39b482c5e57630a8 | $0c5638ed7aec54f5$export$35e795649ee09318,
        void: true
    },
    body: {
        content: $0c5638ed7aec54f5$export$39b482c5e57630a8 | $0c5638ed7aec54f5$export$dda1d9f60106f0e9 | $0c5638ed7aec54f5$export$23f2a1d2818174ef | $0c5638ed7aec54f5$export$35e795649ee09318 | $0c5638ed7aec54f5$export$342063e11d6c3cad | $0c5638ed7aec54f5$export$882b5998b3b9117c | $0c5638ed7aec54f5$export$953cecd6e717a553
    },
    button: {
        content: $0c5638ed7aec54f5$export$35e795649ee09318,
        type: $0c5638ed7aec54f5$export$39b482c5e57630a8 | $0c5638ed7aec54f5$export$35e795649ee09318 | $0c5638ed7aec54f5$export$882b5998b3b9117c | $0c5638ed7aec54f5$export$953cecd6e717a553
    },
    caption: {
        content: $0c5638ed7aec54f5$export$39b482c5e57630a8,
        parent: [
            "table"
        ]
    },
    col: {
        parent: [
            "colgroup"
        ],
        void: true
    },
    colgroup: {
        children: [
            "col"
        ],
        parent: [
            "table"
        ]
    },
    details: {
        children: [
            "summary"
        ],
        type: $0c5638ed7aec54f5$export$39b482c5e57630a8 | $0c5638ed7aec54f5$export$882b5998b3b9117c | $0c5638ed7aec54f5$export$953cecd6e717a553
    },
    dd: {
        content: $0c5638ed7aec54f5$export$39b482c5e57630a8,
        parent: [
            "dl"
        ]
    },
    dl: {
        children: [
            "dt",
            "dd"
        ],
        type: $0c5638ed7aec54f5$export$39b482c5e57630a8
    },
    dt: {
        content: $0c5638ed7aec54f5$export$39b482c5e57630a8,
        invalid: [
            "footer",
            "header"
        ],
        parent: [
            "dl"
        ]
    },
    figcaption: {
        content: $0c5638ed7aec54f5$export$39b482c5e57630a8,
        parent: [
            "figure"
        ]
    },
    footer: {
        invalid: [
            "footer",
            "header"
        ]
    },
    header: {
        invalid: [
            "footer",
            "header"
        ]
    },
    hr: {
        type: $0c5638ed7aec54f5$export$39b482c5e57630a8,
        void: true
    },
    img: {
        void: true
    },
    li: {
        content: $0c5638ed7aec54f5$export$39b482c5e57630a8,
        parent: [
            "ul",
            "ol",
            "menu"
        ]
    },
    main: {
        self: false
    },
    ol: {
        children: [
            "li"
        ],
        type: $0c5638ed7aec54f5$export$39b482c5e57630a8
    },
    picture: {
        children: [
            "source",
            "img"
        ],
        type: $0c5638ed7aec54f5$export$39b482c5e57630a8 | $0c5638ed7aec54f5$export$35e795649ee09318 | $0c5638ed7aec54f5$export$342063e11d6c3cad
    },
    rb: {
        parent: [
            "ruby",
            "rtc"
        ]
    },
    rp: {
        parent: [
            "ruby",
            "rtc"
        ]
    },
    rt: {
        content: $0c5638ed7aec54f5$export$35e795649ee09318,
        parent: [
            "ruby",
            "rtc"
        ]
    },
    rtc: {
        content: $0c5638ed7aec54f5$export$35e795649ee09318,
        parent: [
            "ruby"
        ]
    },
    ruby: {
        children: [
            "rb",
            "rp",
            "rt",
            "rtc"
        ]
    },
    source: {
        parent: [
            "audio",
            "video",
            "picture"
        ],
        void: true
    },
    summary: {
        content: $0c5638ed7aec54f5$export$35e795649ee09318,
        parent: [
            "details"
        ]
    },
    table: {
        children: [
            "caption",
            "colgroup",
            "thead",
            "tbody",
            "tfoot",
            "tr"
        ],
        type: $0c5638ed7aec54f5$export$39b482c5e57630a8
    },
    tbody: {
        parent: [
            "table"
        ],
        children: [
            "tr"
        ]
    },
    td: {
        content: $0c5638ed7aec54f5$export$39b482c5e57630a8,
        parent: [
            "tr"
        ]
    },
    tfoot: {
        parent: [
            "table"
        ],
        children: [
            "tr"
        ]
    },
    th: {
        content: $0c5638ed7aec54f5$export$39b482c5e57630a8,
        parent: [
            "tr"
        ]
    },
    thead: {
        parent: [
            "table"
        ],
        children: [
            "tr"
        ]
    },
    tr: {
        parent: [
            "table",
            "tbody",
            "thead",
            "tfoot"
        ],
        children: [
            "th",
            "td"
        ]
    },
    track: {
        parent: [
            "audio",
            "video"
        ],
        void: true
    },
    ul: {
        children: [
            "li"
        ],
        type: $0c5638ed7aec54f5$export$39b482c5e57630a8
    },
    video: {
        children: [
            "track",
            "source"
        ]
    },
    wbr: {
        type: $0c5638ed7aec54f5$export$39b482c5e57630a8 | $0c5638ed7aec54f5$export$35e795649ee09318,
        void: true
    }
};
function $0c5638ed7aec54f5$var$createConfigBuilder(config) {
    return (tagName)=>{
        $0c5638ed7aec54f5$var$tagConfigs[tagName] = {
            ...config,
            ...$0c5638ed7aec54f5$var$tagConfigs[tagName]
        };
    };
}
[
    "address",
    "main",
    "div",
    "figure",
    "p",
    "pre"
].forEach($0c5638ed7aec54f5$var$createConfigBuilder({
    content: $0c5638ed7aec54f5$export$39b482c5e57630a8,
    type: $0c5638ed7aec54f5$export$39b482c5e57630a8 | $0c5638ed7aec54f5$export$953cecd6e717a553
}));
[
    "abbr",
    "b",
    "bdi",
    "bdo",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "ruby",
    "samp",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var"
].forEach($0c5638ed7aec54f5$var$createConfigBuilder({
    content: $0c5638ed7aec54f5$export$35e795649ee09318,
    type: $0c5638ed7aec54f5$export$39b482c5e57630a8 | $0c5638ed7aec54f5$export$35e795649ee09318 | $0c5638ed7aec54f5$export$953cecd6e717a553
}));
[
    "p",
    "pre"
].forEach($0c5638ed7aec54f5$var$createConfigBuilder({
    content: $0c5638ed7aec54f5$export$35e795649ee09318,
    type: $0c5638ed7aec54f5$export$39b482c5e57630a8 | $0c5638ed7aec54f5$export$953cecd6e717a553
}));
[
    "s",
    "small",
    "span",
    "del",
    "ins"
].forEach($0c5638ed7aec54f5$var$createConfigBuilder({
    content: $0c5638ed7aec54f5$export$35e795649ee09318,
    type: $0c5638ed7aec54f5$export$39b482c5e57630a8 | $0c5638ed7aec54f5$export$35e795649ee09318
}));
[
    "article",
    "aside",
    "footer",
    "header",
    "nav",
    "section",
    "blockquote"
].forEach($0c5638ed7aec54f5$var$createConfigBuilder({
    content: $0c5638ed7aec54f5$export$39b482c5e57630a8,
    type: $0c5638ed7aec54f5$export$39b482c5e57630a8 | $0c5638ed7aec54f5$export$dda1d9f60106f0e9 | $0c5638ed7aec54f5$export$953cecd6e717a553
}));
[
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
].forEach($0c5638ed7aec54f5$var$createConfigBuilder({
    content: $0c5638ed7aec54f5$export$35e795649ee09318,
    type: $0c5638ed7aec54f5$export$39b482c5e57630a8 | $0c5638ed7aec54f5$export$23f2a1d2818174ef | $0c5638ed7aec54f5$export$953cecd6e717a553
}));
[
    "audio",
    "canvas",
    "iframe",
    "img",
    "video"
].forEach($0c5638ed7aec54f5$var$createConfigBuilder({
    type: $0c5638ed7aec54f5$export$39b482c5e57630a8 | $0c5638ed7aec54f5$export$35e795649ee09318 | $0c5638ed7aec54f5$export$342063e11d6c3cad | $0c5638ed7aec54f5$export$953cecd6e717a553
})); // Disable this map from being modified
const $0c5638ed7aec54f5$export$971d5caa766a69d7 = Object.freeze($0c5638ed7aec54f5$var$tagConfigs); // Tags that should never be allowed, even if the allow list is disabled
const $0c5638ed7aec54f5$export$ef35774e6d314e91 = [
    "applet",
    "base",
    "body",
    "command",
    "embed",
    "frame",
    "frameset",
    "head",
    "html",
    "link",
    "meta",
    "noscript",
    "object",
    "script",
    "style",
    "title"
];
const $0c5638ed7aec54f5$export$ebd11618f299a286 = Object.keys($0c5638ed7aec54f5$export$971d5caa766a69d7).filter((tag)=>tag !== "canvas" && tag !== "iframe"); // Filters apply to HTML attributes
const $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5 = 1;
const $0c5638ed7aec54f5$export$8b22cf2602fb60ce = 2;
const $0c5638ed7aec54f5$export$f1e1789686576879 = 3;
const $0c5638ed7aec54f5$export$4368d992c4eafac0 = 4;
const $0c5638ed7aec54f5$export$2d1720544b23b823 = 5; // Attributes not listed here will be denied
// https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes
const $0c5638ed7aec54f5$export$407448d2b89b1813 = Object.freeze({
    alt: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    cite: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    class: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    colspan: $0c5638ed7aec54f5$export$f1e1789686576879,
    controls: $0c5638ed7aec54f5$export$4368d992c4eafac0,
    datetime: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    default: $0c5638ed7aec54f5$export$4368d992c4eafac0,
    disabled: $0c5638ed7aec54f5$export$4368d992c4eafac0,
    dir: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    height: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    href: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    id: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    kind: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    label: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    lang: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    loading: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    loop: $0c5638ed7aec54f5$export$4368d992c4eafac0,
    media: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    muted: $0c5638ed7aec54f5$export$4368d992c4eafac0,
    poster: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    rel: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    role: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    rowspan: $0c5638ed7aec54f5$export$f1e1789686576879,
    scope: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    sizes: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    span: $0c5638ed7aec54f5$export$f1e1789686576879,
    start: $0c5638ed7aec54f5$export$f1e1789686576879,
    style: $0c5638ed7aec54f5$export$2d1720544b23b823,
    src: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    srclang: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    srcset: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    tabindex: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    target: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    title: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    type: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5,
    width: $0c5638ed7aec54f5$export$7ccc53e8f1e7dfc5
}); // Attributes to camel case for React props
const $0c5638ed7aec54f5$export$db3b6bfb95261072 = Object.freeze({
    class: "className",
    colspan: "colSpan",
    datetime: "dateTime",
    rowspan: "rowSpan",
    srclang: "srcLang",
    srcset: "srcSet",
    tabindex: "tabIndex"
});
function $0c5638ed7aec54f5$export$71511d61b312f219() {
    $0c5638ed7aec54f5$export$71511d61b312f219 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0c5638ed7aec54f5$export$71511d61b312f219.apply(this, arguments);
}
function $0c5638ed7aec54f5$export$a9c23c6ac3fc3eca({ attributes: attributes = {}, className: className, children: children = null, selfClose: selfClose = false, tagName: tagName }) {
    const Tag = tagName;
    return selfClose ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, $0c5638ed7aec54f5$export$71511d61b312f219({
        className: className
    }, attributes)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, $0c5638ed7aec54f5$export$71511d61b312f219({
        className: className
    }, attributes), children);
}
class $0c5638ed7aec54f5$export$d66501df72047452 {
    /**
   * Filter and clean an HTML attribute value.
   */ attribute(name, value) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return value;
    }
    /**
   * Filter and clean an HTML node.
   */ node(name, node) {
        return node;
    }
}
/**
 * Trigger the actual pattern match and package the matched
 * response through a callback.
 */ function $0c5638ed7aec54f5$export$ae1af26003f05816(string, pattern, process, isVoid = false) {
    const matches = string.match(pattern instanceof RegExp ? pattern : new RegExp(pattern, "i"));
    if (!matches) return null;
    return {
        match: matches[0],
        void: isVoid,
        ...process(matches),
        index: matches.index,
        length: matches[0].length,
        valid: true
    };
}
class $0c5638ed7aec54f5$export$3a1a48c8f6ef640e {
    constructor(name, options, factory){
        $0c5638ed7aec54f5$var$_defineProperty(this, "greedy", false);
        $0c5638ed7aec54f5$var$_defineProperty(this, "options", void 0);
        $0c5638ed7aec54f5$var$_defineProperty(this, "propName", void 0);
        $0c5638ed7aec54f5$var$_defineProperty(this, "inverseName", void 0);
        $0c5638ed7aec54f5$var$_defineProperty(this, "factory", void 0);
        this.options = {
            ...options
        };
        this.propName = name;
        this.inverseName = `no${name.charAt(0).toUpperCase() + name.slice(1)}`;
        this.factory = factory !== null && factory !== void 0 ? factory : null;
    }
    /**
   * Attempts to create a React element using a custom user provided factory,
   * or the default matcher factory.
   */ createElement(children, props) {
        const element = this.factory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(this.factory, props, children) : this.replaceWith(children, props);
        return element;
    }
    /**
   * Trigger the actual pattern match and package the matched
   * response through a callback.
   */ doMatch(string, pattern, callback, isVoid = false) {
        return $0c5638ed7aec54f5$export$ae1af26003f05816(string, pattern, callback, isVoid);
    }
    /**
   * Callback triggered before parsing.
   */ onBeforeParse(content, props) {
        return content;
    }
    /**
   * Callback triggered after parsing.
   */ onAfterParse(content, props) {
        return content;
    }
}

});

parcelRegister("i53gE", function(module, exports) {
/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */ "use strict";
/**
 * Module variables.
 * @private
 */ var $d29b3a82057e0bd5$var$matchHtmlRegExp = /["'&<>]/;
/**
 * Module exports.
 * @public
 */ module.exports = $d29b3a82057e0bd5$var$escapeHtml;
/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */ function $d29b3a82057e0bd5$var$escapeHtml(string) {
    var str = "" + string;
    var match = $d29b3a82057e0bd5$var$matchHtmlRegExp.exec(str);
    if (!match) return str;
    var escape;
    var html = "";
    var index = 0;
    var lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escape = "&quot;";
                break;
            case 38:
                escape = "&amp;";
                break;
            case 39:
                escape = "&#39;";
                break;
            case 60:
                escape = "&lt;";
                break;
            case 62:
                escape = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.substring(lastIndex, index);
        lastIndex = index + 1;
        html += escape;
    }
    return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}

});


parcelRegister("1RiDN", function(module, exports) {

$parcel$export(module.exports, "Link", () => $bfbe844eba70a67b$export$a6c7ac8248d6e38a);

var $ayMG0 = parcelRequire("ayMG0");

var $04Y2Q = parcelRequire("04Y2Q");
const $bfbe844eba70a67b$export$a6c7ac8248d6e38a = ({ href: href, title: title })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        href: href,
        role: "button",
        className: "link-memo my-1",
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: "inline-flex items-center gap-2",
            children: [
                title && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "body-s",
                    children: title
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04Y2Q.default), {
                    className: "size-4"
                })
            ]
        })
    });
};

});
parcelRegister("04Y2Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $00eef37d19371422$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $00eef37d19371422$var$LinkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M19.902 4.098a3.75 3.75 0 0 0-5.304 0l-4.5 4.5a3.75 3.75 0 0 0 1.035 6.037.75.75 0 0 1-.646 1.353 5.25 5.25 0 0 1-1.449-8.45l4.5-4.5a5.25 5.25 0 1 1 7.424 7.424l-1.757 1.757a.75.75 0 1 1-1.06-1.06l1.757-1.757a3.75 3.75 0 0 0 0-5.304Zm-7.389 4.267a.75.75 0 0 1 1-.353 5.25 5.25 0 0 1 1.449 8.45l-4.5 4.5a5.25 5.25 0 1 1-7.424-7.424l1.757-1.757a.75.75 0 1 1 1.06 1.06l-1.757 1.757a3.75 3.75 0 1 0 5.304 5.304l4.5-4.5a3.75 3.75 0 0 0-1.035-6.037.75.75 0 0 1-.354-1Z",
        clipRule: "evenodd"
    }));
}
const $00eef37d19371422$var$ForwardRef = $acw62.forwardRef($00eef37d19371422$var$LinkIcon);
var $00eef37d19371422$export$2e2bcd8739ae039 = $00eef37d19371422$var$ForwardRef;

});



parcelRegister("4DcVl", function(module, exports) {

$parcel$export(module.exports, "memoData", () => $35f4d45ac54ace9a$export$92ec97b645e783e4);
const $35f4d45ac54ace9a$export$92ec97b645e783e4 = {
    introduction: {
        companyOverview: `
**Name:** Gump\u{2019}s

**About the company:** A luxury American home furnishings and d\xe9cor retailer known for elegant home d\xe9cor, fine jewelry, tabletop, collectibles, and curated gifts. Founded in 1861 in San Francisco, it maintains a storied legacy and iconic status in Union Square.

**Founded:** 1861

**Headquarters (HQ):** 250 Post Street (formerly 135 Post Street), San Francisco, CA 94108, United States.

**Industry:** Specialty / Luxury Retail \u{2013} focus on home furnishings, jewelry, tabletop, and gifts.

**Company size:** 51\u{2013}200 employees (LinkedIn); Dun & Bradstreet estimates 100\u{2013}250; PitchBook lists 119 employees.

[Gumps](https://gumps.com)
[LinkedIn](https://www.linkedin.com/company/gump%27s)

`,
        risks: `### Key Risks to Credit Investors

**Liquidity Risk:**

  - Thin liquidity coverage outside of peak periods exposes you to default risk if a single sales season is weak, or an unforeseen disruption occurs.
  - The company may be forced to tap credit lines, delay payments, or roll over obligations during weak months.

**Working Capital Intensity:**

  - Significant capital tied up in inventory, which limits convertible liquidity.
  - Receivables turnover and actual inventory liquidity would need further due diligence.

**High Leverage on Current Basis:**

  - Short-term liabilities exceed current assets; if credit lines are pulled back or supplier terms tighten, near-term solvency threatened.

**Operational Dependence on Seasonality:**

  - Failure to 'make the year' in Q4 means insufficient cash flow to sustain until next peak.

**Volatile EBITDA Margins:**

  - Several months with negative EBITDA despite reasonable top-line; suggests limited cost flexibility or high fixed cost base.`,
        productsAndServices: `### Summary

Gump\u{2019}s presents a refined merchandise strategy combining legacy luxury (crystal, jewelry, antiques) with modern, exclusive in\u{2011}house d\xe9cor \u{2014} creating a multi\u{2011}price\u{2011}tier product lineup. This caters to a discerning clientele seeking heritage quality, craftsmanship, and one\u{2011}of\u{2011}a\u{2011}kind finds.


### Product & Service Categories

Gump\u{2019}s offers a curated, luxury assortment spanning multiple departments tailored to refined tastes:

#### Fine Jewelry

- Includes Gump\u{2019}s Signature line: pearls, jade, colored\u{2011}gem necklaces, earrings, bracelets.
- Featured luxury designers: Melissa Joy Manning, Barbara Heinrich, Georg Jensen, Am\xe1li, Doves, Adel Chefridi, Loquet London, estate (vintage/one\u{2011}of\u{2011}a\u{2011}kind) pieces.

#### Home D\xe9cor

**Subcategories:**

- **Home Accents:** vases, candleholders, diffusers, trays, faux florals.
- **Furniture:** accent tables, chairs, garden stools, lamps.
- **Collectibles:** porcelain/Limoges boxes, crystal figurines (Baccarat, Lalique), plush toys (Steiff), Herend/Simon Pearce pieces.

#### Tabletop & Bar

- Stemware, tumblers, mugs, barware, serveware, flatware, table linens.

#### Gifts & Stationery

- Premium gift items: leather\u{2011}bound books, puzzles, stationery, scarves, chocolates, tea, games.

#### Exclusive Gump\u{2019}s Collections

- Unique in\u{2011}house designs \u{2014} e.g., lamps, trays, pillows, Limoges, puzzles, cable\u{2011}car motifs.

#### Estate Jewelry

- Antique and vintage pieces from Edwardian to Art Deco eras; one\u{2011}of\u{2011}a\u{2011}kind high\u{2011}value items.



### Pricing Overview

- **Lower\u{2011}end items (gifts, stationery):** ~$24\u{2013}$100
- **Mid\u{2011}range d\xe9cor & accessories:** $100\u{2013}$600 (trays, pillows, small furniture)
- **Fine jewelry & designer goods:** $500\u{2013}$5,000+
- **High\u{2011}end jewelry / estate pieces:** luxury\u{2011}level prices \u{2014} $10,000 up to $50,000+



### Product Descriptions

- **Luxury materials:** pearls, jade, diamonds, sterling and precious metals, crystal, porcelain, fine linens.
- **Distinctive design:** heirloom\u{2011}quality, artisanal, whimsical or elegant decorative pieces, and regionally inspired motifs (e.g., San Francisco cable\u{2011}cars).
- **Curated collections:** seasonally updated lines \u{2014} Summer, Spring, Holidays, featuring softer color palettes and themed items.



### Vendors & Brand Partnerships

#### Internal Gump\u{2019}s Brand
- Exclusive homewares and furniture labeled *\u{201C}Vendor: Gump\u{2019}s\u{201D}* (e.g., lamps, chairs, trays).

#### Prestige External Brands
- **Crystal & porcelain:** Baccarat, Lalique, Herend, Simon Pearce, Steiff plush.
- **Designer tabletop & bar:** Ichendorf, Kim Seybert, Lisa Corti, Bordallo Pinheiro, Mario Luca Giusti.
- **Jewelry designers:** Georg Jensen, Melissa Joy Manning, Barbara Heinrich, Am\xe1li, Adel Chefridi, Doves, Loquet London.
- **Estate jewelry:** sourced via purchase or consignment: antique, rare one\u{2011}of\u{2011}a\u{2011}kind vendors.
- **Seasonal exclusives:** special collections with partner artists (e.g., Rory Dobner, Dubost knives, Mottahedeh).


### Vendor Locations

- Most brands are global: Europe\u{2011}based crystal and porcelain makers (France, Hungary, Czech Republic, Germany).
- U.S.-based luxury designers: Georg Jensen (Denmark/US), Melissa Joy Manning (USA).
- Estate pieces from diversified sources: acquired via auctions/dealers worldwide.
- Gump\u{2019}s internal manufacturing/design likely San Francisco\u{2011}based, regionally themed.

*Note: Product listings do not specify vendor origin per item, except general brand provenance.*



### Additional Insights

- **Seasonal catalogs:** visually curated lookbooks (Spring, Summer, Holidays) showcasing set edits.
- **Final/clearance sale policy:** Summer sale items are final sale; seasonal.
- **In\u{2011}stock & fast\u{2011}ship products:** beauty/lifestyle items like Agraria diffusers and ElizabethW sachets.

`,
        leadership: `
### Family Leadership

John (CEO/Chair), Diane (Investor/Board), Anne (EVP \u{2013} Marketing & Digital), Christopher, Jack (board/executive roles).

### Senior Management

President (Jed Pogran) and VP of Marketing & E-commerce (Jessica Mitchell).

### Investor Group

John & Diane Chachas, previously involved since 2007; assumed full ownership post-bankruptcy in 2019.


### Founders

**Solomon Gump and Gustav Gump**
Founded Gump\u{2019}s in 1861 as a mirror and frame shop in San Francisco; the business evolved into a luxury home\u{2011}goods and decorative arts retailer.


### Ownership & Board

**John G. Chachas (born 1964) \u{2013} Chair and CEO**
- Acquired Gump\u{2019}s following its 2018 bankruptcy, in part with his wife Diane.
- Background: Harvard MBA, former MD at First Boston, Credit Suisse, and Lazard; later founder of Methuselah Advisors and Methuselah Capital Partners.
- Political involvement: Ran for U.S. Senate (Nevada) in 2010; board member of American College of Greece and Turning Point USA.

**Diane Chachas \u{2013} Investor and Board Member**
- Invested alongside John and family.

**Anne Chachas \u{2013} Executive Vice President**
- Oversees social media, marketing, and digital strategy.
- Leads revival initiatives; under her leadership Gump\u{2019}s launched catalogs and e\u{2011}commerce in 2019.

**Christopher Chachas and Jack Chachas \u{2013} Family Board Members**
- Co-owners alongside Anne.


### Key Executives (Non-Family)

- **Jed Pogran \u{2013} President**

- **Jessica Mitchell \u{2013} VP of Marketing & E-commerce**


### Other Notables

There\u{2019}s no public evidence of non-family C-Suite such as CFO, COO, or independent board members. Leadership appears centered around the Chachas family and their immediate executive team.
`,
        fundingAndValuation: `
### Current Valuation

No publicly disclosed post-money valuation found. PitchBook and CompWorth report "N/A" for current valuation.

### Total Funding to Date

Approximately **$15 million** raised over time.


### Number of Rounds

PitchBook lists **7 financing rounds**, though details (dates, amounts) are not publicly disclosed.

### Types of Rounds

Likely includes traditional equity rounds (seed, Series A, etc.), but specifics (which rounds were equity vs. debt) are not available in public datasets.

### Debt Financing

No information found on any debt-specific rounds.

### Investors

Stone Canyon Venture Partners, Walden

_Additional investor names and details are not publicly disclosed._

### Board Members (Related to Funding)

No data found linking specific board members to individual funding rounds.

Current board is family-centered (**Chachas family**) with no external investor representatives disclosed.

`,
        recentDevelopments: `### Open Letter Highlighting Downtown San Francisco Challenges

In August 2023, owner and CEO **John Chachas** took out full-page ads in the *San Francisco Chronicle*, addressing Governor Newsom, Mayor Breed, and the Board of Supervisors. He warned that deteriorating street conditions \u{2014} homeless encampments, drug use, vandalism \u{2014} could force Gump\u{2019}s historic Union Square flagship to close or relocate after its 166th holiday season.

---

### Coverage by Major News Outlets

Prominent outlets including **CBS News MoneyWatch**, *Cellenti*, *Chain Store Age*, and *SFGATE* echoed Chachas\u{2019}s concerns, noting Gump\u{2019}s experience reflects broader downtown retail struggles \u{2014} low foot traffic, safety issues, and the exit of other big retailers like Nordstrom and Whole Foods.

---

### Seasonal Catalog Launches & Digital Engagement

In 2024\u{2013}2025, Gump\u{2019}s released new seasonal catalogs (*Spring*, *Summer 2025*) and revamped its digital lookbook offerings, signaling investment in e-commerce and branding despite physical retail pressures.

---

### Contextual Summary

These developments underscore Gump\u{2019}s dual focus: preserving its iconic flagship store while pivoting toward digital and catalog-driven channels amid San Francisco\u{2019}s downtown challenges.

Chachas\u{2019}s public statements reflect both concern for the brand\u{2019}s heritage and a willingness to reposition if local conditions don\u{2019}t improve.

The digital catalog expansion demonstrates efforts to grow alternative revenue streams and maintain customer engagement.

---

### Launch of Summer 2025 Catalog & Expedited Offers

Gump\u{2019}s launched its **Summer 2025 catalog**, showcasing new arrivals such as:
- Victorian half-pearl stick pin ($971)
- Luxury gemstone necklaces (e.g., blue sapphire bezel-set at $7,282)
- Designer tabletop items like Florence melamine dinner plates and water goblets

The catalog features promotions valid through **July 13, 2025**, with selected items flagged as final-sale and in-stock for quick delivery.

---

### Spring Catalog Drop 2: Premium Jewelry Highlights

In the **Spring 2025 catalog (Drop 2)**, Gump\u{2019}s introduced high-end jewelry pieces including:
- Pav\xe9 diamond floral earrings (1.14 ctw, 14k gold, $3,750)
- Premium double-braided leather accessories exclusive to Gump\u{2019}s

---

### In-Store Events Featuring Esteemed Designers

Gump\u{2019}s updated its **2025 events calendar** for the Union Square flagship, including in-store showcases of collections from celebrated designers and brands such as:
- Baccarat
- Herend
- Steiff
- Olivia Riegel

These public-facing events are part of the retailer\u{2019}s strategy to increase foot traffic and brand engagement.
`,
        onlinePresence: `

Gump\u{2019}s maintains an active and polished digital presence across key platforms, focusing on design inspiration, catalog promotion, and in-store experience:

- **Instagram** (@gumpssf) features high-quality images of seasonal collections, bridal/event showcases (e.g., *\u{201C}Wedding Chic\u{201D}*), and designer collaborations \u{2014} though current engagement data isn't publicly listed (around **6.9% average engagement**, estimated via Influence.co).
- **Facebook** (Gump\u{2019}s San Francisco) is used to highlight new catalogs, trunk shows, holiday events, and store-exclusive promotions. Event posts \u{2014} such as trunk shows featuring designers \u{2014} date back within the past two years.
- **Pinterest** (Gump\u{2019}s account) repurposes Instagram\u{2019}s bridal and home d\xe9cor themes, showcasing past events like *\u{201C}Wedding Chic 2016\u{201D}*.

Influencer metrics via Influence.co suggest solid audience engagement (average ~**6.9%**), and a per-post rate of around **$115** for working with the brand.

Overall, Gump\u{2019}s leverages social channels to reinforce its luxury image, showcase seasonal merchandise, and drive both e-commerce and in-store visits through curated visual storytelling.


[Instagram](https://www.instagram.com/gumpssf/)
[Facebook](https://www.facebook.com/gumps)
[Pinterest](https://www.pinterest.com/gumps)
[LinkedIn](https://www.linkedin.com/company/gump%27s/)
`
    },
    "market-background": {
        summary: `

### Gaps in Information
- No precise market share data for Gump\u{2019}s in estate jewelry, collectibles, or luxury d\xe9cor.
- Lack of detailed customer segmentation (age, LTV, repeat rates).
- No competitor financials or digital marketing performance metrics publicly available.
- No disclosed strategy on digital innovation or expansion plans.

### Risks Identified
- Economic volatility could reduce demand for discretionary luxury goods.
- Aging customer base risks long-term brand relevance.
- Digital luxury marketplaces may bypass Gump\u{2019}s, threatening exclusivity and margins.
- San Francisco retail environment (urban decline, safety issues) could force location closure or relocation.
- Limited operational scale increases supply chain and vendor risk.

### Actions Required
- Commission formal market research for niche market sizing and share analysis.
- Conduct customer segmentation study to identify new target demographics.
- Benchmark digital and e-commerce metrics against competitors.
- Hold strategic discussions with Gump\u{2019}s leadership for insight into growth plans.
- Explore alternative flagship or pop-up locations outside San Francisco.
- Monitor competitor innovation in DTC luxury and online marketplaces.
`,
        porterFiveForces: `### Competitive Rivalry
Gump\u{2019}s operates in the high-end luxury retail market for home d\xe9cor, jewelry, and gifts. This segment is highly competitive, with rivals like **RH (Restoration Hardware)**, **Williams-Sonoma**, and **Serena & Lily** offering broader retail footprints and strong e-commerce capabilities.
Additionally, online-first luxury retailers and designer brand direct-to-consumer models (e.g., **Gucci Home**, **Tiffany & Co.**) intensify competition.
However, Gump\u{2019}s differentiates through heritage branding, exclusivity, and curated product selection.

### Threat of New Entrants
The threat of new entrants is **moderate to low**. Luxury retail has high barriers to entry due to brand equity, customer loyalty, and the capital required to source exclusive products and establish trust in the premium segment.
However, the rise of digital marketplaces and niche online boutiques does lower the entry threshold for new competitors in online channels.

### Bargaining Power of Buyers
Buyer power is **moderate**. Gump\u{2019}s caters to affluent customers who are price-insensitive for exclusive or heritage items but have ample alternatives through luxury department stores, direct designer purchases, and global e-commerce platforms.
Shoppers can compare prices and access substitutes easily online, which raises expectations for service and exclusivity.

### Bargaining Power of Suppliers
Supplier power is **high**. Gump\u{2019}s relies on partnerships with luxury brands (e.g., **Baccarat**, **Herend**, **Lalique**) and independent designers, many of whom maintain strict distribution agreements and price controls.
Additionally, sourcing estate jewelry and collectibles introduces constraints due to rarity and supply scarcity, limiting Gump\u{2019}s negotiating leverage.

### Threat of Substitutes
The threat of substitutes is **significant**. Luxury home goods and jewelry compete not only with similar products from other retailers but also with broader lifestyle spending\u{2014}such as travel, tech, and experiential purchases.
Customers may shift spending away from luxury goods during economic downturns or favor direct-to-brand options that bypass intermediaries like Gump\u{2019}s.`,
        hamiltonPowers: `### Network Effects

Gump\u{2019}s does not significantly benefit from network effects. Its business model is transactional and product-based, without a platform or community-driven ecosystem that grows stronger with user participation.


### Scale Economies

Gump\u{2019}s operates at a boutique scale with limited locations and a niche customer base. Unlike large chains such as **RH** or **Williams-Sonoma**
`,
        topCompetitors: `

## 1. Serena & Lily

**Products & Services:**
Coastal-inspired furniture, bedding, home accessories, outdoor furniture, lighting, tabletop, rugs.

**Pricing:**
- Table linens: ~$35\u{2013}$170 (bed sheets, pillows)
- Rattan chair: $200 (sale), $400 MSRP
- Resin lounger with cushions: high hundreds to low thousands

**Description:**
Design-driven, artisanal coastal aesthetic; emphasis on relaxed luxury and craftsmanship.

**Vendor Info / Locations:**
Products designed in-house; shipped from US; international shipping with limitations.

**Other Info:**
- Frequent sales (up to 53%)
- Trade program offering 25% discounts and additional perks


## 2. Horchow (Neiman Marcus)

**Products & Services:**
Luxury furniture, d\xe9cor, tabletop, gourmet accessories, seasonal holiday d\xe9cor and gifts.

**Pricing:**
- Home d\xe9cor: $70\u{2013}$3,800 (chairs, rugs, lamps)
- Tabletop & serveware: $35\u{2013}$170+

**Description:**
Curated offerings featuring high-end designers (e.g., MacKenzie-Childs, Ginori 1735, Jonathan Adler), with frequent seasonal sales (25\u{2013}30% off).

**Vendor Info / Locations:**
Partnerships with global luxury brands; selection includes European and US makers.

**Other Info:**
- Sales categories include \u{201C}Everyday Values,\u{201D} \u{201C}Limited Time Sales,\u{201D} and holiday-themed merchandise


## 3. RH (Restoration Hardware)

**Products & Services:**
Upscale furniture (indoor/outdoor), lighting, textiles, rugs, d\xe9cor, baby/teen collections, trade and interior design services.

**Pricing:**
- Sofas: ~$2,395 (Cloud sofa) to $7,000+
- Membership-driven discounts: 25% off full-price, 20% off sale items; membership fee ~$200/year

**Description:**
Gallery-style showrooms with white-glove delivery and design services; product line includes upscale furnishings and high-touch retail experience.

**Vendor Info / Locations:**
Private label and curated design-forward products; operates 84 galleries + outlets in North America.

**Other Info:**
- Membership program offers lifetime guarantees on select products
- Interior design services bundled

`,
        marketCustomers: `

### Demographic Overview
- Located primarily in the San Francisco Bay Area, but also nationwide through e-commerce.
- Targeting affluent consumers, including homebuyers, collectors, and gift-givers, often aged 35 and older with high disposable incomes.
- Appeals to luxury shoppers interested in heritage brands, fine jewelry, home d\xe9cor, and estate-quality items (e.g., jade, pearls, crystal).

### Market Size
- A niche, upscale segment of the luxury home and lifestyle market \u{2014} significant but much smaller than mass-market furniture and d\xe9cor sectors.
- With estimated annual revenue between **$5M\u{2013}$25M** and approximately **86 employees**, Gump\u{2019}s actively serves both local and national high-end consumer markets.

### Business Model
- Operates primarily in a **Business-to-Consumer (B2C)** model via its physical flagship store and e-commerce site.
- Also maintains a strong catalog-driven channel, blending traditional and digital retail outreach.

### Customer Behavior
- Appeals to heritage-oriented purchases, impulse collectibles, and occasion-driven buying (e.g., weddings, anniversaries, corporate gifting).
- Likely overlaps with customers of luxury retailers and artisanal designer brands.
`,
        marketNiche: `

## 1. Fine Jewelry

### Niche Size:
U.S. jewelry market \u{2248} **$76\u{2013}77 billion (2024)**, projected to reach \u{2248} **$111\u{2013}115 billion by 2033** (CAGR ~3\u{2013}4% annually).

### Description:
Includes Gump's own designs, luxury designer pieces, and estate/vintage jewelry. High-ticket items crafted for affluent consumers.


## 2. Estate/Antique Jewelry

### Niche Size:
Global estate jewelry sales \u{2248} **$5.5 billion**, with notable North American activity.

### Description:
One-of-a-kind vintage pieces, acquired via auctions and dealers. Distinct in scarcity and exclusivity.


## 3. Luxury Home D\xe9cor

### Niche Size (U.S.):
Premium home d\xe9cor segment within the broader **$215 billion (2025)** U.S. market, growing at ~4\u{2013}9% annual CAGR.

**Global luxury d\xe9cor:**
\u{2248} **$144 billion (2024)**, forecast to reach **$216 billion by 2034 (CAGR ~5%)**.

### Description:
High-end decorative objects, furniture, and exclusive collections targeted at the upscale home market.


## 4. Collectibles & Gifting

### Niche Overlap:
Part of luxury d\xe9cor and collectibles; aligns with vintage/heritage objects, designer gifts, and lifestyle goods.

### Size Insight:
Boutique and collector-focused segment; specific market size not isolated in available reports.


### Niche with Greatest Gump\u{2019}s Market Power

Gump\u{2019}s strongest domain is **Estate/Antique Jewelry**, a niche characterized by rarity, scarcity, and unique provenance \u{2014} where exclusive sourcing and heritage branding provide meaningful differentiation.

This gives Gump\u{2019}s greater competitive advantage compared to the broader luxury d\xe9cor or mainstream fine jewelry markets.
`,
        bullMarket: `### The Market Will Grow and Become More Profitable Because:

- **Luxury Consumer Resilience:**
 The global affluent consumer base continues to grow, with ultra-high-net-worth individuals increasing in both the U.S. and globally. Luxury spending tends to remain stable or rebound quickly after downturns, especially for tangible assets like jewelry and collectibles.

- **Experience-Driven Purchases:**
 High-end home d\xe9cor and personalized luxury items are increasingly viewed as lifestyle investments, not just discretionary spending. As consumers prioritize unique, heritage, and artisan-crafted products, premium home goods and estate jewelry see rising demand.

- **Shift to Omni-Channel Luxury:**
 The premium retail sector is adapting to combine in-person boutique experiences with upscale digital engagement. This allows traditional brands like Gump\u{2019}s to scale beyond their local base via online catalogs, e-commerce, and national shipping without diluting brand equity.

- **Collectibles & Estate Value Retention:**
 Fine estate jewelry and luxury collectibles often appreciate or retain value, attracting both connoisseurs and investors. This creates a niche where scarcity and legacy drive pricing power, independent of typical retail commoditization trends.

---

### The Company Will Take Share Because:

- **Heritage & Brand Differentiation:**
 Gump\u{2019}s is uniquely positioned with over 160 years of brand equity, allowing it to stand apart from mass-market luxury retailers and new entrants. Its history creates trust in high-value categories like estate jewelry.

- **Curated & Exclusive Offering:**
 Unlike competitors focused on volume (e.g., RH, Williams-Sonoma), Gump\u{2019}s leans into exclusivity through one-of-a-kind estate pieces and proprietary in-house collections, reducing direct comparability and pricing pressure.

- **Niche Customer Loyalty:**
 Gump\u{2019}s serves a loyal, high-net-worth customer base accustomed to tradition-driven purchases, luxury gifting, and heritage retail experiences. This niche, though smaller, is less price-sensitive and more relationship-driven, which reduces churn.

- **Digital Growth Potential:**
 With renewed focus on online catalogs, e-commerce expansion, and targeted outreach, Gump\u{2019}s has the opportunity to capture geographically dispersed luxury buyers without investing heavily in physical store expansion.
`,
        bearMarket: `### The Market Will Shrink and Become Less Profitable Because:

- **Shifts in Consumer Spending:**
 Younger generations are shifting luxury spending from goods to experiences (e.g., travel, wellness, dining). As millennial and Gen Z consumers accumulate wealth, they may prefer experiential luxury over home d\xe9cor or collectible goods, reducing long-term demand.

- **Macroeconomic Headwinds:**
 Luxury discretionary spending is vulnerable to economic slowdowns, rising interest rates, and inflation. Economic instability could suppress demand for non-essential, high-ticket items like estate jewelry and luxury collectibles.

- **Retail Real Estate Decline:**
 Physical luxury retail, especially in urban centers like San Francisco, faces risks from crime, homelessness, and declining foot traffic. The cost of maintaining flagship stores in challenged downtown areas may outweigh the returns.

- **Digital Disruption:**
 E-commerce giants and DTC luxury brands are eroding traditional luxury retail margins. Platforms like *1stDibs*, *Farfetch*, and *The RealReal* are digitizing the collectible and estate markets, making it easier for consumers to bypass traditional retailers.

---

### The Company Will Lose Share Because:

- **Limited Scale and Infrastructure:**
 Gump\u{2019}s remains a boutique operation without the economies of scale, digital infrastructure, or global logistics capabilities of larger competitors like RH or Williams-Sonoma. This makes scaling or price competition difficult.

- **Aging Customer Base:**
 Gump\u{2019}s core demographic (older, affluent buyers) may age out without sufficient replacement from younger consumers who lack brand familiarity or prefer modern, design-forward brands like Serena & Lily.

- **Lack of Innovation:**
 Gump\u{2019}s product strategy is tradition-focused, which may alienate design-savvy, trend-driven luxury buyers seeking contemporary or customizable offerings.

- **Concentration Risk:**
 Heavy dependence on a single flagship location in Union Square leaves Gump\u{2019}s vulnerable to regional risks \u{2014} including civic issues, real estate costs, and declining downtown retail viability.
`
    },
    "team-background": {
        founders: `### Solomon and Gustav Gump

Founded Gump\u{2019}s in **1861**, establishing the heritage luxury brand.

---

### John G. Chachas (CEO & Chair)

- **Education:**
 B.A. from Columbia; MBA from Harvard Business School.

- **Career:**
 Former senior banker at First Boston, Credit Suisse, Merrill Lynch, and Lazard.
 Advised major media transactions including Disney and Hearst.

- **Role at Gump\u{2019}s:**
 Acquired Gump\u{2019}s post-bankruptcy (Chapter 11, 2018) and led its relaunch in 2019.

---

### Diane Chachas (Investor/Board Member)

- Invested alongside John during the acquisition.
- No public bio available.

---

### Anne Chachas (EVP, Marketing & Digital)

- Oversees digital strategy, catalogs, and marketing post-relaunch.

---

### Jed Pogran (President) and Jessica Mitchell (VP, Marketing & Ecommerce)

- Jed listed on CB Insights.
- Jessica appears in org chart.
- Public persona details are limited.

---

### Board & Investors

- **Chachas Family:**
 Owner-investors include John, Diane, Anne, Christopher, and Jack Chachas.

- **External Investors:**
 Associated with John\u{2019}s prior deals via Methuselah Capital; no independent board members tied to financial backers.

---

### Talent Scarcity & Unique Strengths

- **High-Caliber Leadership:**
 John\u{2019}s elite finance background (Harvard, HBS, major M&A roles) brings strategic rigor and fundraising capability.

- **Digital Marketing Acumen:**
 Anne and Jessica are steering the company\u{2019}s pivot to e-commerce and digital cataloging \u{2014} a critical growth area.

- **Gaps:**
 No extraordinary board-level talent (e.g., marquee executives from major tech or retail brands) identified.

---

### Due Diligence & Background Checks

- No criminal records or public fraud convictions tied to John or Anne Chachas.
- **Investor Malpractice Alert:**
 A Gregory John Chachas Jr. (likely a relative) had FINRA disclosures for customer disputes and employment terminations; not linked to John G. Chachas.
- No public bankruptcy, regulatory infractions, or legal actions against core leadership or Gump\u{2019}s post-acquisition.

---

### Key Observations

- Gump\u{2019}s leadership centers on family ownership with significant finance and digital marketing talent.
- While lacking high-profile independent board members or marquee hires, John Chachas provides institutional strategy and capital access.
- No material legal or regulatory issues compromise leadership credibility.

*If desired, I can help identify potential board additions or recruitments to bolster governance and domain expertise.*
`
    },
    "audit-results": {},
    "operational-overview": {},
    "peer-analysis": {},
    "unit-economics-analysis": {},
    "growth-analysis": {},
    "products-services": {},
    "assets-liabilities": {},
    "regulatory-issues": {},
    "material-dependencies": {}
};

});

parcelRegister("1V5et", function(module, exports) {

$parcel$export(module.exports, "chartData", () => $312dc782f7c06d20$export$fa75311891f179ce);

var $9v8DH = parcelRequire("9v8DH");

var $8Kb80 = parcelRequire("8Kb80");

var $aBi1T = parcelRequire("aBi1T");

var $mvA3V = parcelRequire("mvA3V");

var $3EPNx = parcelRequire("3EPNx");

var $9dw5x = parcelRequire("9dw5x");

var $5HpO1 = parcelRequire("5HpO1");

var $2EGuI = parcelRequire("2EGuI");

var $lF3df = parcelRequire("lF3df");

var $gem4U = parcelRequire("gem4U");
const $312dc782f7c06d20$export$fa75311891f179ce = {
    assetProgression: (0, $9v8DH.default),
    balanceOverTime: (0, $8Kb80.default),
    cashflowProgression: (0, $aBi1T.default),
    debtComposition: (0, $mvA3V.default),
    debtServiceCoverage: (0, $3EPNx.default),
    debtToAssets: (0, $9dw5x.default),
    debtToCashflows: (0, $5HpO1.default),
    disbursementsAndRepayments: (0, $2EGuI.default),
    liquidity: (0, $lF3df.default),
    financial: (0, $gem4U.default)
};
var $312dc782f7c06d20$export$2e2bcd8739ae039 = $312dc782f7c06d20$export$fa75311891f179ce;

});
parcelRegister("9v8DH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eadb5e200dec927$export$2e2bcd8739ae039);
const $6eadb5e200dec927$var$assetProgressionData = [
    {
        month: [
            "2021",
            "Aug"
        ],
        totalAssets: 4593872.24,
        liquidAssets: 3441645.23,
        totalReceivables: -15772.19,
        totalNoncurrentAssets: 864365.1,
        noncurrentAssetsPropertyPlantAndEquipment: -11235.62,
        cash: 836829.02,
        totalInventory: 2620588.4,
        currentAssets: 3729507.14
    },
    {
        month: [
            "2021",
            "Sep"
        ],
        totalAssets: 5019494.7,
        liquidAssets: 3868935.52,
        totalReceivables: -7198.36,
        totalNoncurrentAssets: 862572.87,
        noncurrentAssetsPropertyPlantAndEquipment: -16378.62,
        cash: 383270.55,
        totalInventory: 3492863.33,
        currentAssets: 4156921.83
    },
    {
        month: [
            "2021",
            "Oct"
        ],
        totalAssets: 5984192.71,
        liquidAssets: 4798523.89,
        totalReceivables: 17708.46,
        totalNoncurrentAssets: 857141.59,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 801144.55,
        totalInventory: 3979670.88,
        currentAssets: 5127051.12
    },
    {
        month: [
            "2021",
            "Nov"
        ],
        totalAssets: 6764845.33,
        liquidAssets: 5548845.97,
        totalReceivables: 391321.88,
        totalNoncurrentAssets: 857174.19,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 1453189.69,
        totalInventory: 3704334.4,
        currentAssets: 5907671.14
    },
    {
        month: [
            "2021",
            "Dec"
        ],
        totalAssets: 6269656.43,
        liquidAssets: 5035201.15,
        totalReceivables: 383.81,
        totalNoncurrentAssets: 859623.69,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 2093477.41,
        totalInventory: 2941339.93,
        currentAssets: 5410032.74
    },
    {
        month: [
            "2022",
            "Jan"
        ],
        totalAssets: 5176376.59,
        liquidAssets: 3932703.98,
        totalReceivables: -21047.49,
        totalNoncurrentAssets: 859623.69,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 965303.76,
        totalInventory: 2988447.71,
        currentAssets: 4316752.9
    },
    {
        month: [
            "2022",
            "Feb"
        ],
        totalAssets: 5733235.75,
        liquidAssets: 4479273.21,
        totalReceivables: 1991.57,
        totalNoncurrentAssets: 859623.69,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 1371971.53,
        totalInventory: 3105310.11,
        currentAssets: 4873612.06
    },
    {
        month: [
            "2022",
            "Mar"
        ],
        totalAssets: 4958143.1,
        liquidAssets: 3704489.59,
        totalReceivables: -3479.56,
        totalNoncurrentAssets: 859623.69,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 349492.07,
        totalInventory: 3358477.08,
        currentAssets: 4098519.41
    },
    {
        month: [
            "2022",
            "Apr"
        ],
        totalAssets: 5211921.08,
        liquidAssets: 3957060.37,
        totalReceivables: -30924.48,
        totalNoncurrentAssets: 859623.69,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 421236.79,
        totalInventory: 3566748.06,
        currentAssets: 4352297.39
    },
    {
        month: [
            "2022",
            "May"
        ],
        totalAssets: 4871050.91,
        liquidAssets: 3610983.37,
        totalReceivables: -34097.64,
        totalNoncurrentAssets: 859644.58,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 119722.82,
        totalInventory: 3525358.19,
        currentAssets: 4011406.33
    },
    {
        month: [
            "2022",
            "Jun"
        ],
        totalAssets: 5476439.08,
        liquidAssets: 4212280.18,
        totalReceivables: -20.16,
        totalNoncurrentAssets: 861545.94,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 412926.4,
        totalInventory: 3799373.94,
        currentAssets: 4614893.14
    },
    {
        month: [
            "2022",
            "Jul"
        ],
        totalAssets: 5731036.17,
        liquidAssets: 4465389.57,
        totalReceivables: 8117.27,
        totalNoncurrentAssets: 861545.94,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 496691.42,
        totalInventory: 3960580.88,
        currentAssets: 4869490.23
    },
    {
        month: [
            "2022",
            "Aug"
        ],
        totalAssets: 5970116.05,
        liquidAssets: 4654583.25,
        totalReceivables: 46032.86,
        totalNoncurrentAssets: 861556.83,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 299495.54,
        totalInventory: 4309054.85,
        currentAssets: 5108559.22
    },
    {
        month: [
            "2022",
            "Sep"
        ],
        totalAssets: 6244422.68,
        liquidAssets: 4903765.67,
        totalReceivables: 46130.14,
        totalNoncurrentAssets: 861556.83,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 144536.11,
        totalInventory: 4713099.42,
        currentAssets: 5382865.85
    },
    {
        month: [
            "2022",
            "Oct"
        ],
        totalAssets: 6669938.68,
        liquidAssets: 5317295.03,
        totalReceivables: 82938.78,
        totalNoncurrentAssets: 861556.83,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 511916.49,
        totalInventory: 4722439.76,
        currentAssets: 5808381.85
    },
    {
        month: [
            "2022",
            "Nov"
        ],
        totalAssets: 7232194.8,
        liquidAssets: 5845771.54,
        totalReceivables: 230226.18,
        totalNoncurrentAssets: 861556.83,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 1500152.8,
        totalInventory: 4115392.56,
        currentAssets: 6370637.97
    },
    {
        month: [
            "2022",
            "Dec"
        ],
        totalAssets: 5657649.77,
        liquidAssets: 4270844.01,
        totalReceivables: 37037.3,
        totalNoncurrentAssets: 861556.83,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 776161.2,
        totalInventory: 3457645.51,
        currentAssets: 4796092.94
    },
    {
        month: [
            "2023",
            "Jan"
        ],
        totalAssets: 5964614.99,
        liquidAssets: 4560549.23,
        totalReceivables: -116872.35,
        totalNoncurrentAssets: 861556.83,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 1496772.12,
        totalInventory: 3180649.46,
        currentAssets: 5103058.16
    },
    {
        month: [
            "2023",
            "Feb"
        ],
        totalAssets: 4503351.53,
        liquidAssets: 3085608.38,
        totalReceivables: -177711.94,
        totalNoncurrentAssets: 863099.82,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 35759.9,
        totalInventory: 3227560.42,
        currentAssets: 3640251.71
    },
    {
        month: [
            "2023",
            "Mar"
        ],
        totalAssets: 4722787.64,
        liquidAssets: 3291250.89,
        totalReceivables: -212246.1,
        totalNoncurrentAssets: 863099.82,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 330112.56,
        totalInventory: 3173384.43,
        currentAssets: 3859687.82
    },
    {
        month: [
            "2023",
            "Apr"
        ],
        totalAssets: 5360519.6,
        liquidAssets: 3916742.85,
        totalReceivables: -229700.88,
        totalNoncurrentAssets: 863099.82,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 834658.4,
        totalInventory: 3311785.33,
        currentAssets: 4497419.78
    },
    {
        month: [
            "2023",
            "May"
        ],
        totalAssets: 5657914.67,
        liquidAssets: 4240122.86,
        totalReceivables: -252452.88,
        totalNoncurrentAssets: 863099.82,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 1189551.45,
        totalInventory: 3303024.29,
        currentAssets: 4794814.85
    },
    {
        month: [
            "2023",
            "Jun"
        ],
        totalAssets: 5541079.01,
        liquidAssets: 4149607.61,
        totalReceivables: -218572.91,
        totalNoncurrentAssets: 863142.81,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 853773.23,
        totalInventory: 3514407.29,
        currentAssets: 4677936.2
    },
    {
        month: [
            "2023",
            "Jul"
        ],
        totalAssets: 5385721.35,
        liquidAssets: 4019486.96,
        totalReceivables: -214352.97,
        totalNoncurrentAssets: 863185.8,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 565946.54,
        totalInventory: 3667893.39,
        currentAssets: 4522535.55
    },
    {
        month: [
            "2023",
            "Aug"
        ],
        totalAssets: 6113524.21,
        liquidAssets: 4755751.32,
        totalReceivables: -178551.69,
        totalNoncurrentAssets: 863185.8,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 1051243.87,
        totalInventory: 3883059.14,
        currentAssets: 5250338.41
    },
    {
        month: [
            "2023",
            "Sep"
        ],
        totalAssets: 5840188.49,
        liquidAssets: 4509263.18,
        totalReceivables: -106412.01,
        totalNoncurrentAssets: 864214.76,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 229324.62,
        totalInventory: 4386350.57,
        currentAssets: 4975973.73
    },
    {
        month: [
            "2023",
            "Oct"
        ],
        totalAssets: 7186925.49,
        liquidAssets: 5742972.67,
        totalReceivables: -22437.69,
        totalNoncurrentAssets: 864214.76,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 1177695.44,
        totalInventory: 4587714.92,
        currentAssets: 6322710.73
    },
    {
        month: [
            "2023",
            "Nov"
        ],
        totalAssets: 8288649.98,
        liquidAssets: 6648302.65,
        totalReceivables: 46486.05,
        totalNoncurrentAssets: 864214.76,
        noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
        cash: 2753910.17,
        totalInventory: 3847906.43,
        currentAssets: 7424435.22
    },
    {
        month: [
            "2023",
            "Dec"
        ],
        totalAssets: 7346455.69,
        liquidAssets: 5871865.99,
        totalReceivables: -5104.31,
        totalNoncurrentAssets: 680131.17,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 2623131.82,
        totalInventory: 3253838.48,
        currentAssets: 6666324.52
    },
    {
        month: [
            "2024",
            "Jan"
        ],
        totalAssets: 6973382.95,
        liquidAssets: 5506855.3,
        totalReceivables: 45544.36,
        totalNoncurrentAssets: 680131.17,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 2138036.21,
        totalInventory: 3323274.73,
        currentAssets: 6293251.78
    },
    {
        month: [
            "2024",
            "Feb"
        ],
        totalAssets: 6520360.97,
        liquidAssets: 5063132.98,
        totalReceivables: 100410.21,
        totalNoncurrentAssets: 680131.17,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 1564853.85,
        totalInventory: 3397868.92,
        currentAssets: 5840229.8
    },
    {
        month: [
            "2024",
            "Mar"
        ],
        totalAssets: 6301637.87,
        liquidAssets: 4855452.5,
        totalReceivables: 195106.49,
        totalNoncurrentAssets: 681904.92,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 1221752.51,
        totalInventory: 3438593.5,
        currentAssets: 5619732.95
    },
    {
        month: [
            "2024",
            "Apr"
        ],
        totalAssets: 5607513.1,
        liquidAssets: 4172322.51,
        totalReceivables: 236388.06,
        totalNoncurrentAssets: 681904.92,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 419327.05,
        totalInventory: 3516607.4,
        currentAssets: 4925608.18
    },
    {
        month: [
            "2024",
            "May"
        ],
        totalAssets: 6953444.48,
        liquidAssets: 5525829.13,
        totalReceivables: 326851.84,
        totalNoncurrentAssets: 681904.92,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 1758261.13,
        totalInventory: 3440716.16,
        currentAssets: 6271539.56
    },
    {
        month: [
            "2024",
            "Jun"
        ],
        totalAssets: 6670771.66,
        liquidAssets: 5284191.3,
        totalReceivables: 379993.44,
        totalNoncurrentAssets: 681947.91,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 1325360.54,
        totalInventory: 3578837.32,
        currentAssets: 5988823.75
    },
    {
        month: [
            "2024",
            "Jul"
        ],
        totalAssets: 6010165.65,
        liquidAssets: 4645681.19,
        totalReceivables: 403246.04,
        totalNoncurrentAssets: 681990.9,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 456598.43,
        totalInventory: 3785836.72,
        currentAssets: 5328174.75
    },
    {
        month: [
            "2024",
            "Aug"
        ],
        totalAssets: 6251917.74,
        liquidAssets: 4908545.89,
        totalReceivables: 402107.21,
        totalNoncurrentAssets: 681990.9,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 515308.36,
        totalInventory: 3991130.32,
        currentAssets: 5569926.84
    },
    {
        month: [
            "2024",
            "Sep"
        ],
        totalAssets: 6589615.64,
        liquidAssets: 5201638.28,
        totalReceivables: 378082.02,
        totalNoncurrentAssets: 681990.9,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 474504.22,
        totalInventory: 4349052.04,
        currentAssets: 5907624.74
    },
    {
        month: [
            "2024",
            "Oct"
        ],
        totalAssets: 6945624.8,
        liquidAssets: 5571499.41,
        totalReceivables: 137268.71,
        totalNoncurrentAssets: 681990.9,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 980222.92,
        totalInventory: 4454007.78,
        currentAssets: 6263633.9
    },
    {
        month: [
            "2024",
            "Nov"
        ],
        totalAssets: 7523522.73,
        liquidAssets: 6117144.64,
        totalReceivables: 321084.39,
        totalNoncurrentAssets: 681990.9,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 1696292.61,
        totalInventory: 4099767.64,
        currentAssets: 6841531.83
    },
    {
        month: [
            "2024",
            "Dec"
        ],
        totalAssets: 7666761.97,
        liquidAssets: 6119622.88,
        totalReceivables: 326447.81,
        totalNoncurrentAssets: 807024.92,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 2574967.8,
        totalInventory: 3218207.27,
        currentAssets: 6859737.05
    },
    {
        month: [
            "2025",
            "Jan"
        ],
        totalAssets: 6813294.62,
        liquidAssets: 5250426.58,
        totalReceivables: 358863.31,
        totalNoncurrentAssets: 807024.92,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 1584024.86,
        totalInventory: 3307538.41,
        currentAssets: 6006269.7
    },
    {
        month: [
            "2025",
            "Feb"
        ],
        totalAssets: 6941891.69,
        liquidAssets: 5368252.96,
        totalReceivables: 374293.99,
        totalNoncurrentAssets: 808524.92,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 1647578.58,
        totalInventory: 3346380.39,
        currentAssets: 6133366.77
    },
    {
        month: [
            "2025",
            "Mar"
        ],
        totalAssets: 7909797.03,
        liquidAssets: 6341865.64,
        totalReceivables: 419974.55,
        totalNoncurrentAssets: 808524.92,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 2455371.49,
        totalInventory: 3466519.6,
        currentAssets: 7101272.11
    },
    {
        month: [
            "2025",
            "Apr"
        ],
        totalAssets: 7236867.53,
        liquidAssets: 5665791.26,
        totalReceivables: 422894.39,
        totalNoncurrentAssets: 810985.24,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 1704202.32,
        totalInventory: 3538694.55,
        currentAssets: 6425882.29
    },
    {
        month: [
            "2025",
            "May"
        ],
        totalAssets: 7252907.99,
        liquidAssets: 5697728.36,
        totalReceivables: 419720.24,
        totalNoncurrentAssets: 810985.24,
        noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
        cash: 1753981.91,
        totalInventory: 3524026.21,
        currentAssets: 6441922.75
    },
    {
        month: [
            "2025",
            "Jun"
        ],
        totalAssets: 7465486.35,
        liquidAssets: 5878520.82,
        totalReceivables: 453174.84,
        totalNoncurrentAssets: 811005.24,
        noncurrentAssetsPropertyPlantAndEquipment: -78093.52,
        cash: 1661007.56,
        totalInventory: 3764338.42,
        currentAssets: 6654481.11
    },
    {
        month: [
            "2025",
            "Jul"
        ],
        totalAssets: 7492212.09,
        liquidAssets: 5902546.56,
        totalReceivables: 450587.99,
        totalNoncurrentAssets: 811005.24,
        noncurrentAssetsPropertyPlantAndEquipment: -78093.52,
        cash: 1684309.07,
        totalInventory: 3767649.5,
        currentAssets: 6681206.85
    }
];
var $6eadb5e200dec927$export$2e2bcd8739ae039 = $6eadb5e200dec927$var$assetProgressionData;

});

parcelRegister("8Kb80", function(module, exports) {

$parcel$export(module.exports, "default", () => $65db4070064af177$export$2e2bcd8739ae039);
const $65db4070064af177$var$balanceOverTimeData = [
    {
        month: [
            "2023",
            "Apr"
        ],
        balanceAvgInPeriod: 375000.0,
        interestAndFees: 0.0,
        debtBalanceBop: 0.0,
        capitalAtRiskEop: 750000.0,
        debtBalanceEop: 750000.0,
        amortization: 0.0,
        disbursement: -750000,
        capitalAtRiskAvgInPeriod: 375000.0,
        interestAndFeesCash: 0.0,
        capitalAtRiskBop: 0.0,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2023",
            "May"
        ],
        balanceAvgInPeriod: 1125000.0,
        interestAndFees: 9375.0,
        debtBalanceBop: 750000.0,
        capitalAtRiskEop: 1490625.0,
        debtBalanceEop: 1500000.0,
        amortization: 0.0,
        disbursement: -750000,
        capitalAtRiskAvgInPeriod: 1120312.5,
        interestAndFeesCash: 9375.0,
        capitalAtRiskBop: 750000.0,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2023",
            "Jun"
        ],
        balanceAvgInPeriod: 1500000.0,
        interestAndFees: 18750.0,
        debtBalanceBop: 1500000.0,
        capitalAtRiskEop: 1471875.0,
        debtBalanceEop: 1500000.0,
        amortization: 0.0,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 1481250.0,
        interestAndFeesCash: 18750.0,
        capitalAtRiskBop: 1490625.0,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2023",
            "Jul"
        ],
        balanceAvgInPeriod: 1500000.0,
        interestAndFees: 18750.0,
        debtBalanceBop: 1500000.0,
        capitalAtRiskEop: 1453125.0,
        debtBalanceEop: 1500000.0,
        amortization: 0.0,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 1462500.0,
        interestAndFeesCash: 18750.0,
        capitalAtRiskBop: 1471875.0,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2023",
            "Aug"
        ],
        balanceAvgInPeriod: 1482839.79,
        interestAndFees: 26096.24,
        debtBalanceBop: 1500000.0,
        capitalAtRiskEop: 1392708.33,
        debtBalanceEop: 1465679.57,
        amortization: 34320.43,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 1422916.67,
        interestAndFeesCash: 26096.24,
        capitalAtRiskBop: 1453125.0,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2023",
            "Sep"
        ],
        balanceAvgInPeriod: 1430976.56,
        interestAndFees: 32677.31,
        debtBalanceBop: 1465679.57,
        capitalAtRiskEop: 1290624.99,
        debtBalanceEop: 1396273.54,
        amortization: 69406.03,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 1341666.66,
        interestAndFeesCash: 32677.31,
        capitalAtRiskBop: 1392708.33,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2023",
            "Oct"
        ],
        balanceAvgInPeriod: 1360796.82,
        interestAndFees: 31129.9,
        debtBalanceBop: 1396273.54,
        capitalAtRiskEop: 1188541.65,
        debtBalanceEop: 1325320.1,
        amortization: 70953.44,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 1239583.32,
        interestAndFeesCash: 31129.9,
        capitalAtRiskBop: 1290624.99,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2023",
            "Nov"
        ],
        balanceAvgInPeriod: 1289052.43,
        interestAndFees: 29547.99,
        debtBalanceBop: 1325320.1,
        capitalAtRiskEop: 1086458.31,
        debtBalanceEop: 1252784.75,
        amortization: 72535.35,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 1137499.98,
        interestAndFeesCash: 29547.99,
        capitalAtRiskBop: 1188541.65,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2023",
            "Dec"
        ],
        balanceAvgInPeriod: 1215708.49,
        interestAndFees: 27930.82,
        debtBalanceBop: 1252784.75,
        capitalAtRiskEop: 984374.97,
        debtBalanceEop: 1178632.23,
        amortization: 74152.52,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 1035416.64,
        interestAndFeesCash: 27930.82,
        capitalAtRiskBop: 1086458.31,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2024",
            "Jan"
        ],
        balanceAvgInPeriod: 1140729.35,
        interestAndFees: 26277.59,
        debtBalanceBop: 1178632.23,
        capitalAtRiskEop: 882291.63,
        debtBalanceEop: 1102826.48,
        amortization: 75805.75,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 933333.3,
        interestAndFeesCash: 26277.59,
        capitalAtRiskBop: 984374.97,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2024",
            "Feb"
        ],
        balanceAvgInPeriod: 1064078.56,
        interestAndFees: 24587.5,
        debtBalanceBop: 1102826.48,
        capitalAtRiskEop: 780208.29,
        debtBalanceEop: 1025330.64,
        amortization: 77495.84,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 831249.96,
        interestAndFeesCash: 24587.5,
        capitalAtRiskBop: 882291.63,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2024",
            "Mar"
        ],
        balanceAvgInPeriod: 985718.83,
        interestAndFees: 22859.73,
        debtBalanceBop: 1025330.64,
        capitalAtRiskEop: 678124.95,
        debtBalanceEop: 946107.03,
        amortization: 79223.61,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 729166.62,
        interestAndFeesCash: 22859.73,
        capitalAtRiskBop: 780208.29,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2024",
            "Apr"
        ],
        balanceAvgInPeriod: 905612.08,
        interestAndFees: 21093.44,
        debtBalanceBop: 946107.03,
        capitalAtRiskEop: 576041.61,
        debtBalanceEop: 865117.13,
        amortization: 80989.9,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 627083.28,
        interestAndFeesCash: 21093.44,
        capitalAtRiskBop: 678124.95,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2024",
            "May"
        ],
        balanceAvgInPeriod: 775198.94,
        interestAndFees: 47246.96,
        debtBalanceBop: 865117.13,
        capitalAtRiskEop: 348958.27,
        debtBalanceEop: 685280.75,
        amortization: 179836.38,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 462499.94,
        interestAndFeesCash: 47246.96,
        capitalAtRiskBop: 576041.61,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2024",
            "Jun"
        ],
        balanceAvgInPeriod: 647279.1,
        interestAndFees: 10455.05,
        debtBalanceBop: 685280.75,
        capitalAtRiskEop: 262499.93,
        debtBalanceEop: 609277.46,
        amortization: 76003.29,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 305729.1,
        interestAndFeesCash: 10455.05,
        capitalAtRiskBop: 348958.27,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2024",
            "Jul"
        ],
        balanceAvgInPeriod: 570809.25,
        interestAndFees: 9521.92,
        debtBalanceBop: 609277.46,
        capitalAtRiskEop: 176041.59,
        debtBalanceEop: 532341.04,
        amortization: 76936.42,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 219270.76,
        interestAndFeesCash: 9521.92,
        capitalAtRiskBop: 262499.93,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2024",
            "Aug"
        ],
        balanceAvgInPeriod: 493395.85,
        interestAndFees: 8567.97,
        debtBalanceBop: 532341.04,
        capitalAtRiskEop: 89583.25,
        debtBalanceEop: 454450.67,
        amortization: 77890.37,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 132812.42,
        interestAndFeesCash: 8567.97,
        capitalAtRiskBop: 176041.59,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2024",
            "Sep"
        ],
        balanceAvgInPeriod: 415017.88,
        interestAndFees: 7592.76,
        debtBalanceBop: 454450.67,
        capitalAtRiskEop: 3124.91,
        debtBalanceEop: 375585.09,
        amortization: 78865.58,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 46354.08,
        interestAndFeesCash: 7592.76,
        capitalAtRiskBop: 89583.25,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2024",
            "Oct"
        ],
        balanceAvgInPeriod: 335653.82,
        interestAndFees: 6595.81,
        debtBalanceBop: 375585.09,
        capitalAtRiskEop: -83333.43,
        debtBalanceEop: 295722.56,
        amortization: 79862.53,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: -40104.26,
        interestAndFeesCash: 6595.81,
        capitalAtRiskBop: 3124.91,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2024",
            "Nov"
        ],
        balanceAvgInPeriod: 255281.7,
        interestAndFees: 5576.63,
        debtBalanceBop: 295722.56,
        capitalAtRiskEop: -169791.77,
        debtBalanceEop: 214840.85,
        amortization: 80881.71,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: -126562.6,
        interestAndFeesCash: 5576.63,
        capitalAtRiskBop: -83333.43,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2024",
            "Dec"
        ],
        balanceAvgInPeriod: 173879.04,
        interestAndFees: 4534.73,
        debtBalanceBop: 214840.85,
        capitalAtRiskEop: -256250.11,
        debtBalanceEop: 132917.24,
        amortization: 81923.61,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: -213020.94,
        interestAndFeesCash: 4534.73,
        capitalAtRiskBop: -169791.77,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2025",
            "Jan"
        ],
        balanceAvgInPeriod: 91422.87,
        interestAndFees: 3469.6,
        debtBalanceBop: 132917.24,
        capitalAtRiskEop: -342708.45,
        debtBalanceEop: 49928.5,
        amortization: 82988.74,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: -299479.28,
        interestAndFeesCash: 3469.6,
        capitalAtRiskBop: -256250.11,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2025",
            "Feb"
        ],
        balanceAvgInPeriod: 24964.24,
        interestAndFees: 1113.16,
        debtBalanceBop: 49928.5,
        capitalAtRiskEop: -393750.12,
        debtBalanceEop: -0.01,
        amortization: 49928.51,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: -368229.28,
        interestAndFeesCash: 1113.16,
        capitalAtRiskBop: -342708.45,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2025",
            "Mar"
        ],
        balanceAvgInPeriod: 849999.99,
        interestAndFees: 10625.0,
        debtBalanceBop: 849999.99,
        capitalAtRiskEop: 445624.88,
        debtBalanceEop: 849999.99,
        amortization: 0.0,
        disbursement: -850000,
        capitalAtRiskAvgInPeriod: 450937.38,
        interestAndFeesCash: 10625.0,
        capitalAtRiskBop: 456249.88,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2025",
            "Apr"
        ],
        balanceAvgInPeriod: 849999.99,
        interestAndFees: 10625.0,
        debtBalanceBop: 849999.99,
        capitalAtRiskEop: 434999.88,
        debtBalanceEop: 849999.99,
        amortization: 0.0,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 440312.38,
        interestAndFeesCash: 10625.0,
        capitalAtRiskBop: 445624.88,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2025",
            "May"
        ],
        balanceAvgInPeriod: 849999.99,
        interestAndFees: 10625.0,
        debtBalanceBop: 849999.99,
        capitalAtRiskEop: 424374.88,
        debtBalanceEop: 849999.99,
        amortization: 0.0,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 429687.38,
        interestAndFeesCash: 10625.0,
        capitalAtRiskBop: 434999.88,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2025",
            "Jun"
        ],
        balanceAvgInPeriod: 1680551.74,
        interestAndFees: 29575.73,
        debtBalanceBop: 1699999.99,
        capitalAtRiskEop: 1205902.66,
        debtBalanceEop: 1661103.5,
        amortization: 38896.49,
        disbursement: -850000,
        capitalAtRiskAvgInPeriod: 1240138.77,
        interestAndFeesCash: 29575.73,
        capitalAtRiskBop: 1274374.88,
        interestAndFeesAccrued: 0.0
    },
    {
        month: [
            "2025",
            "Jul"
        ],
        balanceAvgInPeriod: 1641221.66,
        interestAndFees: 28708.54,
        debtBalanceBop: 1661103.5,
        capitalAtRiskEop: 1137430.44,
        debtBalanceEop: 1621339.82,
        amortization: 39763.68,
        disbursement: 0.0,
        capitalAtRiskAvgInPeriod: 1171666.55,
        interestAndFeesCash: 28708.54,
        capitalAtRiskBop: 1205902.66,
        interestAndFeesAccrued: 0.0
    }
];
var $65db4070064af177$export$2e2bcd8739ae039 = $65db4070064af177$var$balanceOverTimeData;

});

parcelRegister("aBi1T", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7b585c39653a76$export$2e2bcd8739ae039);
const $7b7b585c39653a76$var$cashflowProgressionData = [
    {
        month: [
            "2021",
            "Aug"
        ],
        totalRevenue: 1056302.74,
        preMarketingEbitda: 605038.99,
        netIncome: -273191.15,
        grossMargin: 605038.99,
        changeInCash: null,
        ebitda: -261682.45
    },
    {
        month: [
            "2021",
            "Sep"
        ],
        totalRevenue: 829310.85,
        preMarketingEbitda: 415743.79,
        netIncome: -785783.29,
        grossMargin: 415743.79,
        changeInCash: -453558.47,
        ebitda: -710855.77
    },
    {
        month: [
            "2021",
            "Oct"
        ],
        totalRevenue: 2061491.35,
        preMarketingEbitda: 1222946.13,
        netIncome: 19219.22,
        grossMargin: 1222946.13,
        changeInCash: 417874.0,
        ebitda: 29210.15
    },
    {
        month: [
            "2021",
            "Nov"
        ],
        totalRevenue: 3116471.59,
        preMarketingEbitda: 1849843.97,
        netIncome: 183403.63,
        grossMargin: 1849843.97,
        changeInCash: 652045.14,
        ebitda: 223837.94
    },
    {
        month: [
            "2021",
            "Dec"
        ],
        totalRevenue: 3247412.49,
        preMarketingEbitda: 1838581.56,
        netIncome: -136687.84,
        grossMargin: 1838581.56,
        changeInCash: 640287.72,
        ebitda: -133300.42
    },
    {
        month: [
            "2022",
            "Jan"
        ],
        totalRevenue: 1225423.81,
        preMarketingEbitda: 541221.17,
        netIncome: -497343.3,
        grossMargin: 541221.17,
        changeInCash: -1128173.65,
        ebitda: -496804.59
    },
    {
        month: [
            "2022",
            "Feb"
        ],
        totalRevenue: 1488528.38,
        preMarketingEbitda: 882590.77,
        netIncome: -373991.93,
        grossMargin: 882590.77,
        changeInCash: 406667.77,
        ebitda: -334126.64
    },
    {
        month: [
            "2022",
            "Mar"
        ],
        totalRevenue: 1370241.74,
        preMarketingEbitda: 758729.43,
        netIncome: -228664.15,
        grossMargin: 758729.43,
        changeInCash: -1022479.46,
        ebitda: -227476.2
    },
    {
        month: [
            "2022",
            "Apr"
        ],
        totalRevenue: 997813.92,
        preMarketingEbitda: 504036.65,
        netIncome: -475392.37,
        grossMargin: 504036.65,
        changeInCash: 71744.72,
        ebitda: -474566.67
    },
    {
        month: [
            "2022",
            "May"
        ],
        totalRevenue: 1276291.23,
        preMarketingEbitda: 751475.78,
        netIncome: -279666.88,
        grossMargin: 751475.78,
        changeInCash: -301513.97,
        ebitda: -283093.72
    },
    {
        month: [
            "2022",
            "Jun"
        ],
        totalRevenue: 1147775.8,
        preMarketingEbitda: 620542.55,
        netIncome: -329005.7,
        grossMargin: 620542.55,
        changeInCash: 293203.58,
        ebitda: -328131.99
    },
    {
        month: [
            "2022",
            "Jul"
        ],
        totalRevenue: 968255.47,
        preMarketingEbitda: 490408.33,
        netIncome: -426311.31,
        grossMargin: 490408.33,
        changeInCash: 83765.02,
        ebitda: -426064.94
    },
    {
        month: [
            "2022",
            "Aug"
        ],
        totalRevenue: 1460722.01,
        preMarketingEbitda: 733338.54,
        netIncome: -237128.85,
        grossMargin: 733338.54,
        changeInCash: -197195.88,
        ebitda: -231432.52
    },
    {
        month: [
            "2022",
            "Sep"
        ],
        totalRevenue: 903691.02,
        preMarketingEbitda: 434959.17,
        netIncome: -918755.5,
        grossMargin: 434959.17,
        changeInCash: -154959.43,
        ebitda: -908612.45
    },
    {
        month: [
            "2022",
            "Oct"
        ],
        totalRevenue: 2572904.85,
        preMarketingEbitda: 1607418.18,
        netIncome: -65070.41,
        grossMargin: 1607418.18,
        changeInCash: 367380.38,
        ebitda: -41330.69
    },
    {
        month: [
            "2022",
            "Nov"
        ],
        totalRevenue: 4061811.53,
        preMarketingEbitda: 2545935.17,
        netIncome: 985749.74,
        grossMargin: 2545935.17,
        changeInCash: 988236.31,
        ebitda: 996662.53
    },
    {
        month: [
            "2022",
            "Dec"
        ],
        totalRevenue: 3473715.02,
        preMarketingEbitda: 1971616.57,
        netIncome: 681418.64,
        grossMargin: 1971616.57,
        changeInCash: -723991.6,
        ebitda: 915443.82
    },
    {
        month: [
            "2023",
            "Jan"
        ],
        totalRevenue: 1457363.91,
        preMarketingEbitda: 720973.17,
        netIncome: -411500.42,
        grossMargin: 720973.17,
        changeInCash: 720610.92,
        ebitda: -408923.78
    },
    {
        month: [
            "2023",
            "Feb"
        ],
        totalRevenue: 651704.91,
        preMarketingEbitda: 362867.12,
        netIncome: -441732.46,
        grossMargin: 362867.12,
        changeInCash: -1461012.22,
        ebitda: -437982.85
    },
    {
        month: [
            "2023",
            "Mar"
        ],
        totalRevenue: 1064881.14,
        preMarketingEbitda: 620772.96,
        netIncome: -271961.64,
        grossMargin: 620772.96,
        changeInCash: 294352.66,
        ebitda: -268249.95
    },
    {
        month: [
            "2023",
            "Apr"
        ],
        totalRevenue: 644017.64,
        preMarketingEbitda: 362507.38,
        netIncome: -365535.63,
        grossMargin: 362507.38,
        changeInCash: 504545.84,
        ebitda: -362322.35
    },
    {
        month: [
            "2023",
            "May"
        ],
        totalRevenue: 970982.72,
        preMarketingEbitda: 567370.78,
        netIncome: -142220.96,
        grossMargin: 567370.78,
        changeInCash: 354893.05,
        ebitda: -138217.53
    },
    {
        month: [
            "2023",
            "Jun"
        ],
        totalRevenue: 669718.47,
        preMarketingEbitda: 356721.22,
        netIncome: -114420.61,
        grossMargin: 356721.22,
        changeInCash: -335778.22,
        ebitda: -110445.3
    },
    {
        month: [
            "2023",
            "Jul"
        ],
        totalRevenue: 744590.0,
        preMarketingEbitda: 364889.98,
        netIncome: -266180.87,
        grossMargin: 364889.98,
        changeInCash: -287826.69,
        ebitda: -261339.09
    },
    {
        month: [
            "2023",
            "Aug"
        ],
        totalRevenue: 1461633.43,
        preMarketingEbitda: 860538.95,
        netIncome: 411625.34,
        grossMargin: 860538.95,
        changeInCash: 485297.33,
        ebitda: 478974.27
    },
    {
        month: [
            "2023",
            "Sep"
        ],
        totalRevenue: 1148165.85,
        preMarketingEbitda: 647090.12,
        netIncome: -334490.93,
        grossMargin: 647090.12,
        changeInCash: -821919.25,
        ebitda: -330344.04
    },
    {
        month: [
            "2023",
            "Oct"
        ],
        totalRevenue: 2708776.66,
        preMarketingEbitda: 1758525.62,
        netIncome: 167077.65,
        grossMargin: 1758525.62,
        changeInCash: 948370.82,
        ebitda: 214908.24
    },
    {
        month: [
            "2023",
            "Nov"
        ],
        totalRevenue: 4042095.01,
        preMarketingEbitda: 2573849.95,
        netIncome: 1042431.01,
        grossMargin: 2573849.95,
        changeInCash: 1576214.73,
        ebitda: 1047403.41
    },
    {
        month: [
            "2023",
            "Dec"
        ],
        totalRevenue: 3560257.66,
        preMarketingEbitda: 2127809.68,
        netIncome: 590468.22,
        grossMargin: 2127809.68,
        changeInCash: -130778.35,
        ebitda: 1142678.98
    },
    {
        month: [
            "2024",
            "Jan"
        ],
        totalRevenue: 1357548.17,
        preMarketingEbitda: 704527.9,
        netIncome: -290893.13,
        grossMargin: 704527.9,
        changeInCash: -485095.61,
        ebitda: -288098.75
    },
    {
        month: [
            "2024",
            "Feb"
        ],
        totalRevenue: 1412332.92,
        preMarketingEbitda: 852442.72,
        netIncome: -110915.23,
        grossMargin: 852442.72,
        changeInCash: -573182.36,
        ebitda: -27314.47
    },
    {
        month: [
            "2024",
            "Mar"
        ],
        totalRevenue: 1109826.56,
        preMarketingEbitda: 666606.51,
        netIncome: -135135.46,
        grossMargin: 666606.51,
        changeInCash: -343101.34,
        ebitda: -130093.38
    },
    {
        month: [
            "2024",
            "Apr"
        ],
        totalRevenue: 854810.07,
        preMarketingEbitda: 491998.35,
        netIncome: -231830.41,
        grossMargin: 491998.35,
        changeInCash: -802425.46,
        ebitda: -227585.66
    },
    {
        month: [
            "2024",
            "May"
        ],
        totalRevenue: 1304298.49,
        preMarketingEbitda: 739394.2,
        netIncome: 41031.37,
        grossMargin: 739394.2,
        changeInCash: 1338934.08,
        ebitda: 128549.29
    },
    {
        month: [
            "2024",
            "Jun"
        ],
        totalRevenue: 778806.57,
        preMarketingEbitda: 423225.13,
        netIncome: -159555.36,
        grossMargin: 423225.13,
        changeInCash: -432900.59,
        ebitda: -145428.41
    },
    {
        month: [
            "2024",
            "Jul"
        ],
        totalRevenue: 819763.32,
        preMarketingEbitda: 391749.68,
        netIncome: -532894.18,
        grossMargin: 391749.68,
        changeInCash: -868762.11,
        ebitda: -528576.95
    },
    {
        month: [
            "2024",
            "Aug"
        ],
        totalRevenue: 1212828.82,
        preMarketingEbitda: 715214.82,
        netIncome: 15554.2,
        grossMargin: 715214.82,
        changeInCash: 58709.93,
        ebitda: 22798.87
    },
    {
        month: [
            "2024",
            "Sep"
        ],
        totalRevenue: 1310645.84,
        preMarketingEbitda: 735601.58,
        netIncome: -483634.18,
        grossMargin: 735601.58,
        changeInCash: -40804.14,
        ebitda: -302181.54
    },
    {
        month: [
            "2024",
            "Oct"
        ],
        totalRevenue: 1992038.87,
        preMarketingEbitda: 1254771.22,
        netIncome: -163893.01,
        grossMargin: 1254771.22,
        changeInCash: 505718.7,
        ebitda: -166876.94
    },
    {
        month: [
            "2024",
            "Nov"
        ],
        totalRevenue: 3168315.18,
        preMarketingEbitda: 1989808.77,
        netIncome: 823853.55,
        grossMargin: 1989808.77,
        changeInCash: 716069.69,
        ebitda: 904849.13
    },
    {
        month: [
            "2024",
            "Dec"
        ],
        totalRevenue: 4392768.15,
        preMarketingEbitda: 2620464.6,
        netIncome: 110135.69,
        grossMargin: 2620464.6,
        changeInCash: 878675.19,
        ebitda: 689865.96
    },
    {
        month: [
            "2025",
            "Jan"
        ],
        totalRevenue: 1200761.65,
        preMarketingEbitda: 616446.92,
        netIncome: -543147.23,
        grossMargin: 616446.92,
        changeInCash: -990942.94,
        ebitda: -542199.64
    },
    {
        month: [
            "2025",
            "Feb"
        ],
        totalRevenue: 1364382.34,
        preMarketingEbitda: 807910.29,
        netIncome: -49217.81,
        grossMargin: 807910.29,
        changeInCash: 63553.72,
        ebitda: -44694.79
    },
    {
        month: [
            "2025",
            "Mar"
        ],
        totalRevenue: 1520812.98,
        preMarketingEbitda: 953225.48,
        netIncome: 105697.53,
        grossMargin: 953225.48,
        changeInCash: 807792.91,
        ebitda: 112243.9
    },
    {
        month: [
            "2025",
            "Apr"
        ],
        totalRevenue: 725728.68,
        preMarketingEbitda: 384629.32,
        netIncome: -419946.7,
        grossMargin: 384629.32,
        changeInCash: -751169.17,
        ebitda: -415232.58
    },
    {
        month: [
            "2025",
            "May"
        ],
        totalRevenue: 1109996.95,
        preMarketingEbitda: 668277.06,
        netIncome: -112206.39,
        grossMargin: 668277.06,
        changeInCash: 49779.59,
        ebitda: -108584.43
    },
    {
        month: [
            "2025",
            "Jun"
        ],
        totalRevenue: 765991.16,
        preMarketingEbitda: 437507.34,
        netIncome: 375209.2,
        grossMargin: 437507.34,
        changeInCash: -92974.35,
        ebitda: 381408.26
    },
    {
        month: [
            "2025",
            "Jul"
        ],
        totalRevenue: 37494.53,
        preMarketingEbitda: 23722.46,
        netIncome: 21769.13,
        grossMargin: 23722.46,
        changeInCash: 23301.51,
        ebitda: 21769.13
    }
];
var $7b7b585c39653a76$export$2e2bcd8739ae039 = $7b7b585c39653a76$var$cashflowProgressionData;

});

parcelRegister("mvA3V", function(module, exports) {

$parcel$export(module.exports, "default", () => $043a8d72bf320e13$export$2e2bcd8739ae039);
const $043a8d72bf320e13$var$debtCompositionData = [
    {
        month: [
            "2021",
            "Aug"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 1857.44,
        debtBalanceEop: null,
        totalDebt: 5934705.0,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2021",
            "Sep"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 65731.0,
        debtBalanceEop: null,
        totalDebt: 6490470.32,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2021",
            "Oct"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 776.0,
        debtBalanceEop: null,
        totalDebt: 6357936.11,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2021",
            "Nov"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 40401.63,
        debtBalanceEop: null,
        totalDebt: 6156903.37,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2021",
            "Dec"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 690.04,
        debtBalanceEop: null,
        totalDebt: 5960235.29,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2022",
            "Jan"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 846.24,
        debtBalanceEop: null,
        totalDebt: 5934705.0,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2022",
            "Feb"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 39923.44,
        debtBalanceEop: null,
        totalDebt: 6760812.11,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2022",
            "Mar"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 1031.0,
        debtBalanceEop: null,
        totalDebt: 6611734.23,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2022",
            "Apr"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 731.0,
        debtBalanceEop: null,
        totalDebt: 7521041.84,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2022",
            "May"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: -3243.71,
        debtBalanceEop: null,
        totalDebt: 7380070.88,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2022",
            "Jun"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 523.0,
        debtBalanceEop: null,
        totalDebt: 8193762.49,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2022",
            "Jul"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 1565.33,
        debtBalanceEop: null,
        totalDebt: 8901556.23,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2022",
            "Aug"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 2838.51,
        debtBalanceEop: null,
        totalDebt: 8642556.11,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2022",
            "Sep"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 9397.38,
        debtBalanceEop: null,
        totalDebt: 9036263.37,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2022",
            "Oct"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 23156.44,
        debtBalanceEop: null,
        totalDebt: 8938266.3,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2022",
            "Nov"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 3362.64,
        debtBalanceEop: null,
        totalDebt: 8401465.87,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2022",
            "Dec"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 174066.19,
        debtBalanceEop: null,
        totalDebt: 7419475.0,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2023",
            "Jan"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 2837.01,
        debtBalanceEop: null,
        totalDebt: 8350488.2,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2023",
            "Feb"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 2760.31,
        debtBalanceEop: null,
        totalDebt: 8186478.09,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2023",
            "Mar"
        ],
        interestAndFees: null,
        debtServiceReconcilitationDiffP: null,
        interestExpense: 3230.14,
        debtBalanceEop: null,
        totalDebt: 8532644.87,
        debtTotalReconciliationDiffP: null
    },
    {
        month: [
            "2023",
            "Apr"
        ],
        interestAndFees: 0.0,
        debtServiceReconcilitationDiffP: 1.0,
        interestExpense: 3185.9,
        debtBalanceEop: 750000.0,
        totalDebt: 9144386.24,
        debtTotalReconciliationDiffP: 0.92
    },
    {
        month: [
            "2023",
            "May"
        ],
        interestAndFees: 9375.0,
        debtServiceReconcilitationDiffP: -1.64,
        interestExpense: 3549.75,
        debtBalanceEop: 1500000.0,
        totalDebt: 9692323.5,
        debtTotalReconciliationDiffP: 0.85
    },
    {
        month: [
            "2023",
            "Jun"
        ],
        interestAndFees: 18750.0,
        debtServiceReconcilitationDiffP: -4.29,
        interestExpense: 3545.98,
        debtBalanceEop: 1500000.0,
        totalDebt: 9943909.91,
        debtTotalReconciliationDiffP: 0.85
    },
    {
        month: [
            "2023",
            "Jul"
        ],
        interestAndFees: 18750.0,
        debtServiceReconcilitationDiffP: -4.21,
        interestExpense: 3601.23,
        debtBalanceEop: 1500000.0,
        totalDebt: 9865314.61,
        debtTotalReconciliationDiffP: 0.85
    },
    {
        month: [
            "2023",
            "Aug"
        ],
        interestAndFees: 26096.24,
        debtServiceReconcilitationDiffP: 0.61,
        interestExpense: 66779.46,
        debtBalanceEop: 1465679.57,
        totalDebt: 9640737.11,
        debtTotalReconciliationDiffP: 0.85
    },
    {
        month: [
            "2023",
            "Sep"
        ],
        interestAndFees: 32677.31,
        debtServiceReconcilitationDiffP: -9.18,
        interestExpense: 3210.5,
        debtBalanceEop: 1396273.54,
        totalDebt: 9443092.5,
        debtTotalReconciliationDiffP: 0.85
    },
    {
        month: [
            "2023",
            "Oct"
        ],
        interestAndFees: 31129.9,
        debtServiceReconcilitationDiffP: 0.31,
        interestExpense: 45358.29,
        debtBalanceEop: 1325320.1,
        totalDebt: 9539217.66,
        debtTotalReconciliationDiffP: 0.86
    },
    {
        month: [
            "2023",
            "Nov"
        ],
        interestAndFees: 29547.99,
        debtServiceReconcilitationDiffP: -16.92,
        interestExpense: 1648.92,
        debtBalanceEop: 1252784.75,
        totalDebt: 9141559.4,
        debtTotalReconciliationDiffP: 0.86
    },
    {
        month: [
            "2023",
            "Dec"
        ],
        interestAndFees: 27930.82,
        debtServiceReconcilitationDiffP: 0.94,
        interestExpense: 468814.25,
        debtBalanceEop: 1178632.23,
        totalDebt: 9410963.79,
        debtTotalReconciliationDiffP: 0.87
    },
    {
        month: [
            "2024",
            "Jan"
        ],
        interestAndFees: 26277.59,
        debtServiceReconcilitationDiffP: -19.06,
        interestExpense: 1310.01,
        debtBalanceEop: 1102826.48,
        totalDebt: 9410232.79,
        debtTotalReconciliationDiffP: 0.88
    },
    {
        month: [
            "2024",
            "Feb"
        ],
        interestAndFees: 24587.5,
        debtServiceReconcilitationDiffP: 0.69,
        interestExpense: 80485.11,
        debtBalanceEop: 1025330.64,
        totalDebt: 9205335.13,
        debtTotalReconciliationDiffP: 0.89
    },
    {
        month: [
            "2024",
            "Mar"
        ],
        interestAndFees: 22859.73,
        debtServiceReconcilitationDiffP: -18.55,
        interestExpense: 1169.03,
        debtBalanceEop: 946107.03,
        totalDebt: 9102520.8,
        debtTotalReconciliationDiffP: 0.9
    },
    {
        month: [
            "2024",
            "Apr"
        ],
        interestAndFees: 21093.44,
        debtServiceReconcilitationDiffP: -16.03,
        interestExpense: 1238.81,
        debtBalanceEop: 865117.13,
        totalDebt: 8999706.47,
        debtTotalReconciliationDiffP: 0.9
    },
    {
        month: [
            "2024",
            "May"
        ],
        interestAndFees: 47246.96,
        debtServiceReconcilitationDiffP: 0.42,
        interestExpense: 81073.4,
        debtBalanceEop: 685280.75,
        totalDebt: 10414365.17,
        debtTotalReconciliationDiffP: 0.93
    },
    {
        month: [
            "2024",
            "Jun"
        ],
        interestAndFees: 10455.05,
        debtServiceReconcilitationDiffP: -0.02,
        interestExpense: 10220.65,
        debtBalanceEop: 609277.46,
        totalDebt: 10238265.5,
        debtTotalReconciliationDiffP: 0.94
    },
    {
        month: [
            "2024",
            "Jul"
        ],
        interestAndFees: 9521.92,
        debtServiceReconcilitationDiffP: -7.38,
        interestExpense: 1135.89,
        debtBalanceEop: 532341.04,
        totalDebt: 10038781.02,
        debtTotalReconciliationDiffP: 0.95
    },
    {
        month: [
            "2024",
            "Aug"
        ],
        interestAndFees: 8567.97,
        debtServiceReconcilitationDiffP: -7.08,
        interestExpense: 1059.81,
        debtBalanceEop: 454450.67,
        totalDebt: 9770639.62,
        debtTotalReconciliationDiffP: 0.95
    },
    {
        month: [
            "2024",
            "Sep"
        ],
        interestAndFees: 7592.76,
        debtServiceReconcilitationDiffP: 0.96,
        interestExpense: 178670.64,
        debtBalanceEop: 375585.09,
        totalDebt: 9504984.04,
        debtTotalReconciliationDiffP: 0.96
    },
    {
        month: [
            "2024",
            "Oct"
        ],
        interestAndFees: 6595.81,
        debtServiceReconcilitationDiffP: -6.13,
        interestExpense: 925.0,
        debtBalanceEop: 295722.56,
        totalDebt: 9112023.28,
        debtTotalReconciliationDiffP: 0.97
    },
    {
        month: [
            "2024",
            "Nov"
        ],
        interestAndFees: 5576.63,
        debtServiceReconcilitationDiffP: 0.93,
        interestExpense: 76858.23,
        debtBalanceEop: 214840.85,
        totalDebt: 9344280.79,
        debtTotalReconciliationDiffP: 0.98
    },
    {
        month: [
            "2024",
            "Dec"
        ],
        interestAndFees: 4534.73,
        debtServiceReconcilitationDiffP: 0.99,
        interestExpense: 584236.92,
        debtBalanceEop: 132917.24,
        totalDebt: 9294593.28,
        debtTotalReconciliationDiffP: 0.99
    },
    {
        month: [
            "2025",
            "Jan"
        ],
        interestAndFees: 3469.6,
        debtServiceReconcilitationDiffP: -2.96,
        interestExpense: 876.22,
        debtBalanceEop: 49928.5,
        totalDebt: 9207403.95,
        debtTotalReconciliationDiffP: 0.99
    },
    {
        month: [
            "2025",
            "Feb"
        ],
        interestAndFees: 1113.16,
        debtServiceReconcilitationDiffP: -0.29,
        interestExpense: 864.76,
        debtBalanceEop: -0.01,
        totalDebt: 9083544.83,
        debtTotalReconciliationDiffP: 1.0
    },
    {
        month: [
            "2025",
            "Mar"
        ],
        interestAndFees: 10625.0,
        debtServiceReconcilitationDiffP: -12.73,
        interestExpense: 773.75,
        debtBalanceEop: 849999.99,
        totalDebt: 9922188.83,
        debtTotalReconciliationDiffP: 0.91
    },
    {
        month: [
            "2025",
            "Apr"
        ],
        interestAndFees: 10625.0,
        debtServiceReconcilitationDiffP: -11.7,
        interestExpense: 836.9,
        debtBalanceEop: 849999.99,
        totalDebt: 9910832.83,
        debtTotalReconciliationDiffP: 0.91
    },
    {
        month: [
            "2025",
            "May"
        ],
        interestAndFees: 10625.0,
        debtServiceReconcilitationDiffP: -12.4,
        interestExpense: 792.94,
        debtBalanceEop: 849999.99,
        totalDebt: 9830157.41,
        debtTotalReconciliationDiffP: 0.91
    },
    {
        month: [
            "2025",
            "Jun"
        ],
        interestAndFees: 29575.73,
        debtServiceReconcilitationDiffP: -35.76,
        interestExpense: 804.66,
        debtBalanceEop: 1661103.5,
        totalDebt: 9830157.41,
        debtTotalReconciliationDiffP: 0.83
    },
    {
        month: [
            "2025",
            "Jul"
        ],
        interestAndFees: 28708.54,
        debtServiceReconcilitationDiffP: -Infinity,
        interestExpense: 0.0,
        debtBalanceEop: 1621339.82,
        totalDebt: 9830157.41,
        debtTotalReconciliationDiffP: 0.84
    }
];
var $043a8d72bf320e13$export$2e2bcd8739ae039 = $043a8d72bf320e13$var$debtCompositionData;

});

parcelRegister("3EPNx", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a9d498d93e50c6a$export$2e2bcd8739ae039);
const $2a9d498d93e50c6a$var$debtServiceCoverageData = [
    {
        month: [
            "2021",
            "Aug"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 1857.44,
        cash: 836829.02,
        ebitda: -261682.45,
        debtServiceCoverageRatio: -140.88,
        runway: 3.06
    },
    {
        month: [
            "2021",
            "Sep"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 65731.0,
        cash: 383270.55,
        ebitda: -710855.77,
        debtServiceCoverageRatio: -10.81,
        runway: 0.49
    },
    {
        month: [
            "2021",
            "Oct"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 776.0,
        cash: 801144.55,
        ebitda: 29210.15,
        debtServiceCoverageRatio: 37.64,
        runway: Infinity
    },
    {
        month: [
            "2021",
            "Nov"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 40401.63,
        cash: 1453189.69,
        ebitda: 223837.94,
        debtServiceCoverageRatio: 5.54,
        runway: Infinity
    },
    {
        month: [
            "2021",
            "Dec"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 690.04,
        cash: 2093477.41,
        ebitda: -133300.42,
        debtServiceCoverageRatio: -193.18,
        runway: 15.32
    },
    {
        month: [
            "2022",
            "Jan"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 846.24,
        cash: 965303.76,
        ebitda: -496804.59,
        debtServiceCoverageRatio: -587.07,
        runway: 1.94
    },
    {
        month: [
            "2022",
            "Feb"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 39923.44,
        cash: 1371971.53,
        ebitda: -334126.64,
        debtServiceCoverageRatio: -8.37,
        runway: 3.67
    },
    {
        month: [
            "2022",
            "Mar"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 1031.0,
        cash: 349492.07,
        ebitda: -227476.2,
        debtServiceCoverageRatio: -220.64,
        runway: 1.53
    },
    {
        month: [
            "2022",
            "Apr"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 731.0,
        cash: 421236.79,
        ebitda: -474566.67,
        debtServiceCoverageRatio: -649.2,
        runway: 0.89
    },
    {
        month: [
            "2022",
            "May"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: -3243.71,
        cash: 119722.82,
        ebitda: -283093.72,
        debtServiceCoverageRatio: 87.27,
        runway: 0.43
    },
    {
        month: [
            "2022",
            "Jun"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 523.0,
        cash: 412926.4,
        ebitda: -328131.99,
        debtServiceCoverageRatio: -627.4,
        runway: 1.26
    },
    {
        month: [
            "2022",
            "Jul"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 1565.33,
        cash: 496691.42,
        ebitda: -426064.94,
        debtServiceCoverageRatio: -272.19,
        runway: 1.17
    },
    {
        month: [
            "2022",
            "Aug"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 2838.51,
        cash: 299495.54,
        ebitda: -231432.52,
        debtServiceCoverageRatio: -81.53,
        runway: 1.26
    },
    {
        month: [
            "2022",
            "Sep"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 9397.38,
        cash: 144536.11,
        ebitda: -908612.45,
        debtServiceCoverageRatio: -96.69,
        runway: 0.16
    },
    {
        month: [
            "2022",
            "Oct"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 23156.44,
        cash: 511916.49,
        ebitda: -41330.69,
        debtServiceCoverageRatio: -1.78,
        runway: 7.87
    },
    {
        month: [
            "2022",
            "Nov"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 3362.64,
        cash: 1500152.8,
        ebitda: 996662.53,
        debtServiceCoverageRatio: 296.39,
        runway: Infinity
    },
    {
        month: [
            "2022",
            "Dec"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 174066.19,
        cash: 776161.2,
        ebitda: 915443.82,
        debtServiceCoverageRatio: 5.26,
        runway: Infinity
    },
    {
        month: [
            "2023",
            "Jan"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 2837.01,
        cash: 1496772.12,
        ebitda: -408923.78,
        debtServiceCoverageRatio: -144.14,
        runway: 3.64
    },
    {
        month: [
            "2023",
            "Feb"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 2760.31,
        cash: 35759.9,
        ebitda: -437982.85,
        debtServiceCoverageRatio: -158.67,
        runway: 0.08
    },
    {
        month: [
            "2023",
            "Mar"
        ],
        interestAndFees: null,
        debtServiceCoverageRatioFromRemittanceReport: null,
        interestExpense: 3230.14,
        cash: 330112.56,
        ebitda: -268249.95,
        debtServiceCoverageRatio: -83.05,
        runway: 1.21
    },
    {
        month: [
            "2023",
            "Apr"
        ],
        interestAndFees: 0.0,
        debtServiceCoverageRatioFromRemittanceReport: -Infinity,
        interestExpense: 3185.9,
        cash: 834658.4,
        ebitda: -362322.35,
        debtServiceCoverageRatio: -113.73,
        runway: 2.28
    },
    {
        month: [
            "2023",
            "May"
        ],
        interestAndFees: 9375.0,
        debtServiceCoverageRatioFromRemittanceReport: -14.74,
        interestExpense: 3549.75,
        cash: 1189551.45,
        ebitda: -138217.53,
        debtServiceCoverageRatio: -38.94,
        runway: 8.36
    },
    {
        month: [
            "2023",
            "Jun"
        ],
        interestAndFees: 18750.0,
        debtServiceCoverageRatioFromRemittanceReport: -5.89,
        interestExpense: 3545.98,
        cash: 853773.23,
        ebitda: -110445.3,
        debtServiceCoverageRatio: -31.15,
        runway: 7.46
    },
    {
        month: [
            "2023",
            "Jul"
        ],
        interestAndFees: 18750.0,
        debtServiceCoverageRatioFromRemittanceReport: -13.94,
        interestExpense: 3601.23,
        cash: 565946.54,
        ebitda: -261339.09,
        debtServiceCoverageRatio: -72.57,
        runway: 2.13
    },
    {
        month: [
            "2023",
            "Aug"
        ],
        interestAndFees: 26096.24,
        debtServiceCoverageRatioFromRemittanceReport: 18.35,
        interestExpense: 66779.46,
        cash: 1051243.87,
        ebitda: 478974.27,
        debtServiceCoverageRatio: 7.17,
        runway: Infinity
    },
    {
        month: [
            "2023",
            "Sep"
        ],
        interestAndFees: 32677.31,
        debtServiceCoverageRatioFromRemittanceReport: -10.11,
        interestExpense: 3210.5,
        cash: 229324.62,
        ebitda: -330344.04,
        debtServiceCoverageRatio: -102.89,
        runway: 0.69
    },
    {
        month: [
            "2023",
            "Oct"
        ],
        interestAndFees: 31129.9,
        debtServiceCoverageRatioFromRemittanceReport: 6.9,
        interestExpense: 45358.29,
        cash: 1177695.44,
        ebitda: 214908.24,
        debtServiceCoverageRatio: 4.74,
        runway: Infinity
    },
    {
        month: [
            "2023",
            "Nov"
        ],
        interestAndFees: 29547.99,
        debtServiceCoverageRatioFromRemittanceReport: 35.45,
        interestExpense: 1648.92,
        cash: 2753910.17,
        ebitda: 1047403.41,
        debtServiceCoverageRatio: 635.21,
        runway: Infinity
    },
    {
        month: [
            "2023",
            "Dec"
        ],
        interestAndFees: 27930.82,
        debtServiceCoverageRatioFromRemittanceReport: 40.91,
        interestExpense: 468814.25,
        cash: 2623131.82,
        ebitda: 1142678.98,
        debtServiceCoverageRatio: 2.44,
        runway: Infinity
    },
    {
        month: [
            "2024",
            "Jan"
        ],
        interestAndFees: 26277.59,
        debtServiceCoverageRatioFromRemittanceReport: -10.96,
        interestExpense: 1310.01,
        cash: 2138036.21,
        ebitda: -288098.75,
        debtServiceCoverageRatio: -219.92,
        runway: 7.35
    },
    {
        month: [
            "2024",
            "Feb"
        ],
        interestAndFees: 24587.5,
        debtServiceCoverageRatioFromRemittanceReport: -1.11,
        interestExpense: 80485.11,
        cash: 1564853.85,
        ebitda: -27314.47,
        debtServiceCoverageRatio: -0.34,
        runway: 14.11
    },
    {
        month: [
            "2024",
            "Mar"
        ],
        interestAndFees: 22859.73,
        debtServiceCoverageRatioFromRemittanceReport: -5.69,
        interestExpense: 1169.03,
        cash: 1221752.51,
        ebitda: -130093.38,
        debtServiceCoverageRatio: -111.28,
        runway: 9.04
    },
    {
        month: [
            "2024",
            "Apr"
        ],
        interestAndFees: 21093.44,
        debtServiceCoverageRatioFromRemittanceReport: -10.79,
        interestExpense: 1238.81,
        cash: 419327.05,
        ebitda: -227585.66,
        debtServiceCoverageRatio: -183.71,
        runway: 1.81
    },
    {
        month: [
            "2024",
            "May"
        ],
        interestAndFees: 47246.96,
        debtServiceCoverageRatioFromRemittanceReport: 2.72,
        interestExpense: 81073.4,
        cash: 1758261.13,
        ebitda: 128549.29,
        debtServiceCoverageRatio: 1.59,
        runway: Infinity
    },
    {
        month: [
            "2024",
            "Jun"
        ],
        interestAndFees: 10455.05,
        debtServiceCoverageRatioFromRemittanceReport: -13.91,
        interestExpense: 10220.65,
        cash: 1325360.54,
        ebitda: -145428.41,
        debtServiceCoverageRatio: -14.23,
        runway: 8.31
    },
    {
        month: [
            "2024",
            "Jul"
        ],
        interestAndFees: 9521.92,
        debtServiceCoverageRatioFromRemittanceReport: -55.51,
        interestExpense: 1135.89,
        cash: 456598.43,
        ebitda: -528576.95,
        debtServiceCoverageRatio: -465.34,
        runway: 0.86
    },
    {
        month: [
            "2024",
            "Aug"
        ],
        interestAndFees: 8567.97,
        debtServiceCoverageRatioFromRemittanceReport: 2.66,
        interestExpense: 1059.81,
        cash: 515308.36,
        ebitda: 22798.87,
        debtServiceCoverageRatio: 21.51,
        runway: Infinity
    },
    {
        month: [
            "2024",
            "Sep"
        ],
        interestAndFees: 7592.76,
        debtServiceCoverageRatioFromRemittanceReport: -39.8,
        interestExpense: 178670.64,
        cash: 474504.22,
        ebitda: -302181.54,
        debtServiceCoverageRatio: -1.69,
        runway: 0.98
    },
    {
        month: [
            "2024",
            "Oct"
        ],
        interestAndFees: 6595.81,
        debtServiceCoverageRatioFromRemittanceReport: -25.3,
        interestExpense: 925.0,
        cash: 980222.92,
        ebitda: -166876.94,
        debtServiceCoverageRatio: -180.41,
        runway: 5.98
    },
    {
        month: [
            "2024",
            "Nov"
        ],
        interestAndFees: 5576.63,
        debtServiceCoverageRatioFromRemittanceReport: 162.26,
        interestExpense: 76858.23,
        cash: 1696292.61,
        ebitda: 904849.13,
        debtServiceCoverageRatio: 11.77,
        runway: Infinity
    },
    {
        month: [
            "2024",
            "Dec"
        ],
        interestAndFees: 4534.73,
        debtServiceCoverageRatioFromRemittanceReport: 152.13,
        interestExpense: 584236.92,
        cash: 2574967.8,
        ebitda: 689865.96,
        debtServiceCoverageRatio: 1.18,
        runway: Infinity
    },
    {
        month: [
            "2025",
            "Jan"
        ],
        interestAndFees: 3469.6,
        debtServiceCoverageRatioFromRemittanceReport: -156.27,
        interestExpense: 876.22,
        cash: 1584024.86,
        ebitda: -542199.64,
        debtServiceCoverageRatio: -618.79,
        runway: 2.92
    },
    {
        month: [
            "2025",
            "Feb"
        ],
        interestAndFees: 1113.16,
        debtServiceCoverageRatioFromRemittanceReport: -40.15,
        interestExpense: 864.76,
        cash: 1647578.58,
        ebitda: -44694.79,
        debtServiceCoverageRatio: -51.68,
        runway: 33.48
    },
    {
        month: [
            "2025",
            "Mar"
        ],
        interestAndFees: 10625.0,
        debtServiceCoverageRatioFromRemittanceReport: 10.56,
        interestExpense: 773.75,
        cash: 2455371.49,
        ebitda: 112243.9,
        debtServiceCoverageRatio: 145.06,
        runway: Infinity
    },
    {
        month: [
            "2025",
            "Apr"
        ],
        interestAndFees: 10625.0,
        debtServiceCoverageRatioFromRemittanceReport: -39.08,
        interestExpense: 836.9,
        cash: 1704202.32,
        ebitda: -415232.58,
        debtServiceCoverageRatio: -496.16,
        runway: 4.06
    },
    {
        month: [
            "2025",
            "May"
        ],
        interestAndFees: 10625.0,
        debtServiceCoverageRatioFromRemittanceReport: -10.22,
        interestExpense: 792.94,
        cash: 1753981.91,
        ebitda: -108584.43,
        debtServiceCoverageRatio: -136.94,
        runway: 15.63
    },
    {
        month: [
            "2025",
            "Jun"
        ],
        interestAndFees: 29575.73,
        debtServiceCoverageRatioFromRemittanceReport: 12.9,
        interestExpense: 804.66,
        cash: 1661007.56,
        ebitda: 381408.26,
        debtServiceCoverageRatio: 474.0,
        runway: Infinity
    },
    {
        month: [
            "2025",
            "Jul"
        ],
        interestAndFees: 28708.54,
        debtServiceCoverageRatioFromRemittanceReport: 0.76,
        interestExpense: 0.0,
        cash: 1684309.07,
        ebitda: 21769.13,
        debtServiceCoverageRatio: Infinity,
        runway: Infinity
    }
];
var $2a9d498d93e50c6a$export$2e2bcd8739ae039 = $2a9d498d93e50c6a$var$debtServiceCoverageData;

});

parcelRegister("9dw5x", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b5e38044f2e3e01$export$2e2bcd8739ae039);
const $6b5e38044f2e3e01$var$debtToAssetsData = [
    {
        month: [
            "2021",
            "Aug"
        ],
        totalAssets: 4593872.24,
        grossDebtToLiquidAssets: 1.72,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.29,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 3441645.23,
        cash: 836829.02,
        totalDebt: 5934705.0
    },
    {
        month: [
            "2021",
            "Sep"
        ],
        totalAssets: 5019494.7,
        grossDebtToLiquidAssets: 1.68,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.29,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 3868935.52,
        cash: 383270.55,
        totalDebt: 6490470.32
    },
    {
        month: [
            "2021",
            "Oct"
        ],
        totalAssets: 5984192.71,
        grossDebtToLiquidAssets: 1.32,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.06,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 4798523.89,
        cash: 801144.55,
        totalDebt: 6357936.11
    },
    {
        month: [
            "2021",
            "Nov"
        ],
        totalAssets: 6764845.33,
        grossDebtToLiquidAssets: 1.11,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 0.91,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 5548845.97,
        cash: 1453189.69,
        totalDebt: 6156903.37
    },
    {
        month: [
            "2021",
            "Dec"
        ],
        totalAssets: 6269656.43,
        grossDebtToLiquidAssets: 1.18,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 0.95,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 5035201.15,
        cash: 2093477.41,
        totalDebt: 5960235.29
    },
    {
        month: [
            "2022",
            "Jan"
        ],
        totalAssets: 5176376.59,
        grossDebtToLiquidAssets: 1.51,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.15,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 3932703.98,
        cash: 965303.76,
        totalDebt: 5934705.0
    },
    {
        month: [
            "2022",
            "Feb"
        ],
        totalAssets: 5733235.75,
        grossDebtToLiquidAssets: 1.51,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.18,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 4479273.21,
        cash: 1371971.53,
        totalDebt: 6760812.11
    },
    {
        month: [
            "2022",
            "Mar"
        ],
        totalAssets: 4958143.1,
        grossDebtToLiquidAssets: 1.78,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.33,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 3704489.59,
        cash: 349492.07,
        totalDebt: 6611734.23
    },
    {
        month: [
            "2022",
            "Apr"
        ],
        totalAssets: 5211921.08,
        grossDebtToLiquidAssets: 1.9,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.44,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 3957060.37,
        cash: 421236.79,
        totalDebt: 7521041.84
    },
    {
        month: [
            "2022",
            "May"
        ],
        totalAssets: 4871050.91,
        grossDebtToLiquidAssets: 2.04,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.52,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 3610983.37,
        cash: 119722.82,
        totalDebt: 7380070.88
    },
    {
        month: [
            "2022",
            "Jun"
        ],
        totalAssets: 5476439.08,
        grossDebtToLiquidAssets: 1.95,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.5,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 4212280.18,
        cash: 412926.4,
        totalDebt: 8193762.49
    },
    {
        month: [
            "2022",
            "Jul"
        ],
        totalAssets: 5731036.17,
        grossDebtToLiquidAssets: 1.99,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.55,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 4465389.57,
        cash: 496691.42,
        totalDebt: 8901556.23
    },
    {
        month: [
            "2022",
            "Aug"
        ],
        totalAssets: 5970116.05,
        grossDebtToLiquidAssets: 1.86,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.45,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 4654583.25,
        cash: 299495.54,
        totalDebt: 8642556.11
    },
    {
        month: [
            "2022",
            "Sep"
        ],
        totalAssets: 6244422.68,
        grossDebtToLiquidAssets: 1.84,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.45,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 4903765.67,
        cash: 144536.11,
        totalDebt: 9036263.37
    },
    {
        month: [
            "2022",
            "Oct"
        ],
        totalAssets: 6669938.68,
        grossDebtToLiquidAssets: 1.68,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.34,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 5317295.03,
        cash: 511916.49,
        totalDebt: 8938266.3
    },
    {
        month: [
            "2022",
            "Nov"
        ],
        totalAssets: 7232194.8,
        grossDebtToLiquidAssets: 1.44,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.16,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 5845771.54,
        cash: 1500152.8,
        totalDebt: 8401465.87
    },
    {
        month: [
            "2022",
            "Dec"
        ],
        totalAssets: 5657649.77,
        grossDebtToLiquidAssets: 1.74,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.31,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 4270844.01,
        cash: 776161.2,
        totalDebt: 7419475.0
    },
    {
        month: [
            "2023",
            "Jan"
        ],
        totalAssets: 5964614.99,
        grossDebtToLiquidAssets: 1.83,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.4,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 4560549.23,
        cash: 1496772.12,
        totalDebt: 8350488.2
    },
    {
        month: [
            "2023",
            "Feb"
        ],
        totalAssets: 4503351.53,
        grossDebtToLiquidAssets: 2.65,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.82,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 3085608.38,
        cash: 35759.9,
        totalDebt: 8186478.09
    },
    {
        month: [
            "2023",
            "Mar"
        ],
        totalAssets: 4722787.64,
        grossDebtToLiquidAssets: 2.59,
        debtToTotalAssetsFromRemittanceReport: null,
        grossDebtToAssets: 1.81,
        debtToLiquidAssetsFromRemittanceReport: null,
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        liquidAssets: 3291250.89,
        cash: 330112.56,
        totalDebt: 8532644.87
    },
    {
        month: [
            "2023",
            "Apr"
        ],
        totalAssets: 5360519.6,
        grossDebtToLiquidAssets: 2.33,
        debtToTotalAssetsFromRemittanceReport: 0.07,
        grossDebtToAssets: 1.71,
        debtToLiquidAssetsFromRemittanceReport: -0.12,
        balanceAvgInPeriod: 375000.0,
        debtBalanceEop: 750000.0,
        liquidAssets: 3916742.85,
        cash: 834658.4,
        totalDebt: 9144386.24
    },
    {
        month: [
            "2023",
            "May"
        ],
        totalAssets: 5657914.67,
        grossDebtToLiquidAssets: 2.29,
        debtToTotalAssetsFromRemittanceReport: 0.2,
        grossDebtToAssets: 1.71,
        debtToLiquidAssetsFromRemittanceReport: -0.02,
        balanceAvgInPeriod: 1125000.0,
        debtBalanceEop: 1500000.0,
        liquidAssets: 4240122.86,
        cash: 1189551.45,
        totalDebt: 9692323.5
    },
    {
        month: [
            "2023",
            "Jun"
        ],
        totalAssets: 5541079.01,
        grossDebtToLiquidAssets: 2.4,
        debtToTotalAssetsFromRemittanceReport: 0.27,
        grossDebtToAssets: 1.79,
        debtToLiquidAssetsFromRemittanceReport: 0.16,
        balanceAvgInPeriod: 1500000.0,
        debtBalanceEop: 1500000.0,
        liquidAssets: 4149607.61,
        cash: 853773.23,
        totalDebt: 9943909.91
    },
    {
        month: [
            "2023",
            "Jul"
        ],
        totalAssets: 5385721.35,
        grossDebtToLiquidAssets: 2.45,
        debtToTotalAssetsFromRemittanceReport: 0.28,
        grossDebtToAssets: 1.83,
        debtToLiquidAssetsFromRemittanceReport: 0.23,
        balanceAvgInPeriod: 1500000.0,
        debtBalanceEop: 1500000.0,
        liquidAssets: 4019486.96,
        cash: 565946.54,
        totalDebt: 9865314.61
    },
    {
        month: [
            "2023",
            "Aug"
        ],
        totalAssets: 6113524.21,
        grossDebtToLiquidAssets: 2.03,
        debtToTotalAssetsFromRemittanceReport: 0.24,
        grossDebtToAssets: 1.58,
        debtToLiquidAssetsFromRemittanceReport: 0.09,
        balanceAvgInPeriod: 1482839.79,
        debtBalanceEop: 1465679.57,
        liquidAssets: 4755751.32,
        cash: 1051243.87,
        totalDebt: 9640737.11
    },
    {
        month: [
            "2023",
            "Sep"
        ],
        totalAssets: 5840188.49,
        grossDebtToLiquidAssets: 2.09,
        debtToTotalAssetsFromRemittanceReport: 0.25,
        grossDebtToAssets: 1.62,
        debtToLiquidAssetsFromRemittanceReport: 0.27,
        balanceAvgInPeriod: 1430976.56,
        debtBalanceEop: 1396273.54,
        liquidAssets: 4509263.18,
        cash: 229324.62,
        totalDebt: 9443092.5
    },
    {
        month: [
            "2023",
            "Oct"
        ],
        totalAssets: 7186925.49,
        grossDebtToLiquidAssets: 1.66,
        debtToTotalAssetsFromRemittanceReport: 0.19,
        grossDebtToAssets: 1.33,
        debtToLiquidAssetsFromRemittanceReport: 0.03,
        balanceAvgInPeriod: 1360796.82,
        debtBalanceEop: 1325320.1,
        liquidAssets: 5742972.67,
        cash: 1177695.44,
        totalDebt: 9539217.66
    },
    {
        month: [
            "2023",
            "Nov"
        ],
        totalAssets: 8288649.98,
        grossDebtToLiquidAssets: 1.38,
        debtToTotalAssetsFromRemittanceReport: 0.16,
        grossDebtToAssets: 1.1,
        debtToLiquidAssetsFromRemittanceReport: -0.22,
        balanceAvgInPeriod: 1289052.43,
        debtBalanceEop: 1252784.75,
        liquidAssets: 6648302.65,
        cash: 2753910.17,
        totalDebt: 9141559.4
    },
    {
        month: [
            "2023",
            "Dec"
        ],
        totalAssets: 7346455.69,
        grossDebtToLiquidAssets: 1.6,
        debtToTotalAssetsFromRemittanceReport: 0.17,
        grossDebtToAssets: 1.28,
        debtToLiquidAssetsFromRemittanceReport: -0.24,
        balanceAvgInPeriod: 1215708.49,
        debtBalanceEop: 1178632.23,
        liquidAssets: 5871865.99,
        cash: 2623131.82,
        totalDebt: 9410963.79
    },
    {
        month: [
            "2024",
            "Jan"
        ],
        totalAssets: 6973382.95,
        grossDebtToLiquidAssets: 1.71,
        debtToTotalAssetsFromRemittanceReport: 0.16,
        grossDebtToAssets: 1.35,
        debtToLiquidAssetsFromRemittanceReport: -0.18,
        balanceAvgInPeriod: 1140729.35,
        debtBalanceEop: 1102826.48,
        liquidAssets: 5506855.3,
        cash: 2138036.21,
        totalDebt: 9410232.79
    },
    {
        month: [
            "2024",
            "Feb"
        ],
        totalAssets: 6520360.97,
        grossDebtToLiquidAssets: 1.82,
        debtToTotalAssetsFromRemittanceReport: 0.16,
        grossDebtToAssets: 1.41,
        debtToLiquidAssetsFromRemittanceReport: -0.1,
        balanceAvgInPeriod: 1064078.56,
        debtBalanceEop: 1025330.64,
        liquidAssets: 5063132.98,
        cash: 1564853.85,
        totalDebt: 9205335.13
    },
    {
        month: [
            "2024",
            "Mar"
        ],
        totalAssets: 6301637.87,
        grossDebtToLiquidAssets: 1.87,
        debtToTotalAssetsFromRemittanceReport: 0.16,
        grossDebtToAssets: 1.44,
        debtToLiquidAssetsFromRemittanceReport: -0.05,
        balanceAvgInPeriod: 985718.83,
        debtBalanceEop: 946107.03,
        liquidAssets: 4855452.5,
        cash: 1221752.51,
        totalDebt: 9102520.8
    },
    {
        month: [
            "2024",
            "Apr"
        ],
        totalAssets: 5607513.1,
        grossDebtToLiquidAssets: 2.16,
        debtToTotalAssetsFromRemittanceReport: 0.16,
        grossDebtToAssets: 1.6,
        debtToLiquidAssetsFromRemittanceReport: 0.12,
        balanceAvgInPeriod: 905612.08,
        debtBalanceEop: 865117.13,
        liquidAssets: 4172322.51,
        cash: 419327.05,
        totalDebt: 8999706.47
    },
    {
        month: [
            "2024",
            "May"
        ],
        totalAssets: 6953444.48,
        grossDebtToLiquidAssets: 1.88,
        debtToTotalAssetsFromRemittanceReport: 0.11,
        grossDebtToAssets: 1.5,
        debtToLiquidAssetsFromRemittanceReport: -0.18,
        balanceAvgInPeriod: 775198.94,
        debtBalanceEop: 685280.75,
        liquidAssets: 5525829.13,
        cash: 1758261.13,
        totalDebt: 10414365.17
    },
    {
        month: [
            "2024",
            "Jun"
        ],
        totalAssets: 6670771.66,
        grossDebtToLiquidAssets: 1.94,
        debtToTotalAssetsFromRemittanceReport: 0.1,
        grossDebtToAssets: 1.53,
        debtToLiquidAssetsFromRemittanceReport: -0.13,
        balanceAvgInPeriod: 647279.1,
        debtBalanceEop: 609277.46,
        liquidAssets: 5284191.3,
        cash: 1325360.54,
        totalDebt: 10238265.5
    },
    {
        month: [
            "2024",
            "Jul"
        ],
        totalAssets: 6010165.65,
        grossDebtToLiquidAssets: 2.16,
        debtToTotalAssetsFromRemittanceReport: 0.09,
        grossDebtToAssets: 1.67,
        debtToLiquidAssetsFromRemittanceReport: 0.02,
        balanceAvgInPeriod: 570809.25,
        debtBalanceEop: 532341.04,
        liquidAssets: 4645681.19,
        cash: 456598.43,
        totalDebt: 10038781.02
    },
    {
        month: [
            "2024",
            "Aug"
        ],
        totalAssets: 6251917.74,
        grossDebtToLiquidAssets: 1.99,
        debtToTotalAssetsFromRemittanceReport: 0.08,
        grossDebtToAssets: 1.56,
        debtToLiquidAssetsFromRemittanceReport: -0,
        balanceAvgInPeriod: 493395.85,
        debtBalanceEop: 454450.67,
        liquidAssets: 4908545.89,
        cash: 515308.36,
        totalDebt: 9770639.62
    },
    {
        month: [
            "2024",
            "Sep"
        ],
        totalAssets: 6589615.64,
        grossDebtToLiquidAssets: 1.83,
        debtToTotalAssetsFromRemittanceReport: 0.06,
        grossDebtToAssets: 1.44,
        debtToLiquidAssetsFromRemittanceReport: -0.01,
        balanceAvgInPeriod: 415017.88,
        debtBalanceEop: 375585.09,
        liquidAssets: 5201638.28,
        cash: 474504.22,
        totalDebt: 9504984.04
    },
    {
        month: [
            "2024",
            "Oct"
        ],
        totalAssets: 6945624.8,
        grossDebtToLiquidAssets: 1.64,
        debtToTotalAssetsFromRemittanceReport: 0.05,
        grossDebtToAssets: 1.31,
        debtToLiquidAssetsFromRemittanceReport: -0.12,
        balanceAvgInPeriod: 335653.82,
        debtBalanceEop: 295722.56,
        liquidAssets: 5571499.41,
        cash: 980222.92,
        totalDebt: 9112023.28
    },
    {
        month: [
            "2024",
            "Nov"
        ],
        totalAssets: 7523522.73,
        grossDebtToLiquidAssets: 1.53,
        debtToTotalAssetsFromRemittanceReport: 0.03,
        grossDebtToAssets: 1.24,
        debtToLiquidAssetsFromRemittanceReport: -0.24,
        balanceAvgInPeriod: 255281.7,
        debtBalanceEop: 214840.85,
        liquidAssets: 6117144.64,
        cash: 1696292.61,
        totalDebt: 9344280.79
    },
    {
        month: [
            "2024",
            "Dec"
        ],
        totalAssets: 7666761.97,
        grossDebtToLiquidAssets: 1.52,
        debtToTotalAssetsFromRemittanceReport: 0.02,
        grossDebtToAssets: 1.21,
        debtToLiquidAssetsFromRemittanceReport: -0.39,
        balanceAvgInPeriod: 173879.04,
        debtBalanceEop: 132917.24,
        liquidAssets: 6119622.88,
        cash: 2574967.8,
        totalDebt: 9294593.28
    },
    {
        month: [
            "2025",
            "Jan"
        ],
        totalAssets: 6813294.62,
        grossDebtToLiquidAssets: 1.75,
        debtToTotalAssetsFromRemittanceReport: 0.01,
        grossDebtToAssets: 1.35,
        debtToLiquidAssetsFromRemittanceReport: -0.28,
        balanceAvgInPeriod: 91422.87,
        debtBalanceEop: 49928.5,
        liquidAssets: 5250426.58,
        cash: 1584024.86,
        totalDebt: 9207403.95
    },
    {
        month: [
            "2025",
            "Feb"
        ],
        totalAssets: 6941891.69,
        grossDebtToLiquidAssets: 1.69,
        debtToTotalAssetsFromRemittanceReport: 0.0,
        grossDebtToAssets: 1.31,
        debtToLiquidAssetsFromRemittanceReport: -0.3,
        balanceAvgInPeriod: 24964.24,
        debtBalanceEop: -0.01,
        liquidAssets: 5368252.96,
        cash: 1647578.58,
        totalDebt: 9083544.83
    },
    {
        month: [
            "2025",
            "Mar"
        ],
        totalAssets: 7909797.03,
        grossDebtToLiquidAssets: 1.56,
        debtToTotalAssetsFromRemittanceReport: 0.05,
        grossDebtToAssets: 1.25,
        debtToLiquidAssetsFromRemittanceReport: -0.32,
        balanceAvgInPeriod: 849999.99,
        debtBalanceEop: 849999.99,
        liquidAssets: 6341865.64,
        cash: 2455371.49,
        totalDebt: 9922188.83
    },
    {
        month: [
            "2025",
            "Apr"
        ],
        totalAssets: 7236867.53,
        grossDebtToLiquidAssets: 1.75,
        debtToTotalAssetsFromRemittanceReport: 0.12,
        grossDebtToAssets: 1.37,
        debtToLiquidAssetsFromRemittanceReport: -0.15,
        balanceAvgInPeriod: 849999.99,
        debtBalanceEop: 849999.99,
        liquidAssets: 5665791.26,
        cash: 1704202.32,
        totalDebt: 9910832.83
    },
    {
        month: [
            "2025",
            "May"
        ],
        totalAssets: 7252907.99,
        grossDebtToLiquidAssets: 1.73,
        debtToTotalAssetsFromRemittanceReport: 0.12,
        grossDebtToAssets: 1.36,
        debtToLiquidAssetsFromRemittanceReport: -0.16,
        balanceAvgInPeriod: 849999.99,
        debtBalanceEop: 849999.99,
        liquidAssets: 5697728.36,
        cash: 1753981.91,
        totalDebt: 9830157.41
    },
    {
        month: [
            "2025",
            "Jun"
        ],
        totalAssets: 7465486.35,
        grossDebtToLiquidAssets: 1.67,
        debtToTotalAssetsFromRemittanceReport: 0.17,
        grossDebtToAssets: 1.32,
        debtToLiquidAssetsFromRemittanceReport: -0.07,
        balanceAvgInPeriod: 1680551.74,
        debtBalanceEop: 1661103.5,
        liquidAssets: 5878520.82,
        cash: 1661007.56,
        totalDebt: 9830157.41
    },
    {
        month: [
            "2025",
            "Jul"
        ],
        totalAssets: 7492212.09,
        grossDebtToLiquidAssets: 1.67,
        debtToTotalAssetsFromRemittanceReport: 0.22,
        grossDebtToAssets: 1.31,
        debtToLiquidAssetsFromRemittanceReport: -0.01,
        balanceAvgInPeriod: 1641221.66,
        debtBalanceEop: 1621339.82,
        liquidAssets: 5902546.56,
        cash: 1684309.07,
        totalDebt: 9830157.41
    }
];
var $6b5e38044f2e3e01$export$2e2bcd8739ae039 = $6b5e38044f2e3e01$var$debtToAssetsData;

});

parcelRegister("5HpO1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4264fc66659d5df8$export$2e2bcd8739ae039);
const $4264fc66659d5df8$var$debtToCashflowsData = [
    {
        month: [
            "2021",
            "Aug"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 1056302.74,
        totalDebt: 5934705.0,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 605038.99,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 8.43,
        netDebtToEbitda: -19.48,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 836829.02,
        ebitda: -261682.45,
        netDebtToRevenue: 4.83
    },
    {
        month: [
            "2021",
            "Sep"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 829310.85,
        totalDebt: 6490470.32,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 415743.79,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 14.69,
        netDebtToEbitda: -8.59,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 383270.55,
        ebitda: -710855.77,
        netDebtToRevenue: 7.36
    },
    {
        month: [
            "2021",
            "Oct"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 2061491.35,
        totalDebt: 6357936.11,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 1222946.13,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 4.54,
        netDebtToEbitda: 190.23,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 801144.55,
        ebitda: 29210.15,
        netDebtToRevenue: 2.7
    },
    {
        month: [
            "2021",
            "Nov"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 3116471.59,
        totalDebt: 6156903.37,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 1849843.97,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 2.54,
        netDebtToEbitda: 21.01,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 1453189.69,
        ebitda: 223837.94,
        netDebtToRevenue: 1.51
    },
    {
        month: [
            "2021",
            "Dec"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 3247412.49,
        totalDebt: 5960235.29,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 1838581.56,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 2.1,
        netDebtToEbitda: -29.01,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 2093477.41,
        ebitda: -133300.42,
        netDebtToRevenue: 1.19
    },
    {
        month: [
            "2022",
            "Jan"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 1225423.81,
        totalDebt: 5934705.0,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 541221.17,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 9.18,
        netDebtToEbitda: -10,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 965303.76,
        ebitda: -496804.59,
        netDebtToRevenue: 4.06
    },
    {
        month: [
            "2022",
            "Feb"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 1488528.38,
        totalDebt: 6760812.11,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 882590.77,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 6.11,
        netDebtToEbitda: -16.13,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 1371971.53,
        ebitda: -334126.64,
        netDebtToRevenue: 3.62
    },
    {
        month: [
            "2022",
            "Mar"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 1370241.74,
        totalDebt: 6611734.23,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 758729.43,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 8.25,
        netDebtToEbitda: -27.53,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 349492.07,
        ebitda: -227476.2,
        netDebtToRevenue: 4.57
    },
    {
        month: [
            "2022",
            "Apr"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 997813.92,
        totalDebt: 7521041.84,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 504036.65,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 14.09,
        netDebtToEbitda: -14.96,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 421236.79,
        ebitda: -474566.67,
        netDebtToRevenue: 7.12
    },
    {
        month: [
            "2022",
            "May"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 1276291.23,
        totalDebt: 7380070.88,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 751475.78,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 9.66,
        netDebtToEbitda: -25.65,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 119722.82,
        ebitda: -283093.72,
        netDebtToRevenue: 5.69
    },
    {
        month: [
            "2022",
            "Jun"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 1147775.8,
        totalDebt: 8193762.49,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 620542.55,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 12.54,
        netDebtToEbitda: -23.71,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 412926.4,
        ebitda: -328131.99,
        netDebtToRevenue: 6.78
    },
    {
        month: [
            "2022",
            "Jul"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 968255.47,
        totalDebt: 8901556.23,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 490408.33,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 17.14,
        netDebtToEbitda: -19.73,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 496691.42,
        ebitda: -426064.94,
        netDebtToRevenue: 8.68
    },
    {
        month: [
            "2022",
            "Aug"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 1460722.01,
        totalDebt: 8642556.11,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 733338.54,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 11.38,
        netDebtToEbitda: -36.05,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 299495.54,
        ebitda: -231432.52,
        netDebtToRevenue: 5.71
    },
    {
        month: [
            "2022",
            "Sep"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 903691.02,
        totalDebt: 9036263.37,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 434959.17,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 20.44,
        netDebtToEbitda: -9.79,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 144536.11,
        ebitda: -908612.45,
        netDebtToRevenue: 9.84
    },
    {
        month: [
            "2022",
            "Oct"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 2572904.85,
        totalDebt: 8938266.3,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 1607418.18,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 5.24,
        netDebtToEbitda: -203.88,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 511916.49,
        ebitda: -41330.69,
        netDebtToRevenue: 3.28
    },
    {
        month: [
            "2022",
            "Nov"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 4061811.53,
        totalDebt: 8401465.87,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 2545935.17,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 2.71,
        netDebtToEbitda: 6.92,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 1500152.8,
        ebitda: 996662.53,
        netDebtToRevenue: 1.7
    },
    {
        month: [
            "2022",
            "Dec"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 3473715.02,
        totalDebt: 7419475.0,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 1971616.57,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 3.37,
        netDebtToEbitda: 7.26,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 776161.2,
        ebitda: 915443.82,
        netDebtToRevenue: 1.91
    },
    {
        month: [
            "2023",
            "Jan"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 1457363.91,
        totalDebt: 8350488.2,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 720973.17,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 9.51,
        netDebtToEbitda: -16.76,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 1496772.12,
        ebitda: -408923.78,
        netDebtToRevenue: 4.7
    },
    {
        month: [
            "2023",
            "Feb"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 651704.91,
        totalDebt: 8186478.09,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 362867.12,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 22.46,
        netDebtToEbitda: -18.61,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 35759.9,
        ebitda: -437982.85,
        netDebtToRevenue: 12.51
    },
    {
        month: [
            "2023",
            "Mar"
        ],
        balanceAvgInPeriod: null,
        debtBalanceEop: null,
        totalRevenue: 1064881.14,
        totalDebt: 8532644.87,
        netDebtToEbitdaFromRemittanceReport: null,
        preMarketingEbitda: 620772.96,
        netDebtFromRemittanceReport: null,
        netDebtToPreMarketingEbitda: 13.21,
        netDebtToEbitda: -30.58,
        netDebtToRevenueFromRemittanceReport: null,
        netDebtToPreMarketingEbitdaFromRemittanceReport: null,
        cash: 330112.56,
        ebitda: -268249.95,
        netDebtToRevenue: 7.7
    },
    {
        month: [
            "2023",
            "Apr"
        ],
        balanceAvgInPeriod: 375000.0,
        debtBalanceEop: 750000.0,
        totalRevenue: 644017.64,
        totalDebt: 9144386.24,
        netDebtToEbitdaFromRemittanceReport: 0.11,
        preMarketingEbitda: 362507.38,
        netDebtFromRemittanceReport: -459658.4,
        netDebtToPreMarketingEbitda: 22.92,
        netDebtToEbitda: -22.93,
        netDebtToRevenueFromRemittanceReport: -0.06,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.11,
        cash: 834658.4,
        ebitda: -362322.35,
        netDebtToRevenue: 12.9
    },
    {
        month: [
            "2023",
            "May"
        ],
        balanceAvgInPeriod: 1125000.0,
        debtBalanceEop: 1500000.0,
        totalRevenue: 970982.72,
        totalDebt: 9692323.5,
        netDebtToEbitdaFromRemittanceReport: 0.04,
        preMarketingEbitda: 567370.78,
        netDebtFromRemittanceReport: -64551.45,
        netDebtToPreMarketingEbitda: 14.99,
        netDebtToEbitda: -61.52,
        netDebtToRevenueFromRemittanceReport: -0.01,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.01,
        cash: 1189551.45,
        ebitda: -138217.53,
        netDebtToRevenue: 8.76
    },
    {
        month: [
            "2023",
            "Jun"
        ],
        balanceAvgInPeriod: 1500000.0,
        debtBalanceEop: 1500000.0,
        totalRevenue: 669718.47,
        totalDebt: 9943909.91,
        netDebtToEbitdaFromRemittanceReport: -0.49,
        preMarketingEbitda: 356721.22,
        netDebtFromRemittanceReport: 646226.77,
        netDebtToPreMarketingEbitda: 25.48,
        netDebtToEbitda: -82.3,
        netDebtToRevenueFromRemittanceReport: 0.08,
        netDebtToPreMarketingEbitdaFromRemittanceReport: 0.15,
        cash: 853773.23,
        ebitda: -110445.3,
        netDebtToRevenue: 13.57
    },
    {
        month: [
            "2023",
            "Jul"
        ],
        balanceAvgInPeriod: 1500000.0,
        debtBalanceEop: 1500000.0,
        totalRevenue: 744590.0,
        totalDebt: 9865314.61,
        netDebtToEbitdaFromRemittanceReport: -0.3,
        preMarketingEbitda: 364889.98,
        netDebtFromRemittanceReport: 934053.46,
        netDebtToPreMarketingEbitda: 25.49,
        netDebtToEbitda: -35.58,
        netDebtToRevenueFromRemittanceReport: 0.1,
        netDebtToPreMarketingEbitdaFromRemittanceReport: 0.21,
        cash: 565946.54,
        ebitda: -261339.09,
        netDebtToRevenue: 12.49
    },
    {
        month: [
            "2023",
            "Aug"
        ],
        balanceAvgInPeriod: 1482839.79,
        debtBalanceEop: 1465679.57,
        totalRevenue: 1461633.43,
        totalDebt: 9640737.11,
        netDebtToEbitdaFromRemittanceReport: 0.08,
        preMarketingEbitda: 860538.95,
        netDebtFromRemittanceReport: 431595.92,
        netDebtToPreMarketingEbitda: 9.98,
        netDebtToEbitda: 17.93,
        netDebtToRevenueFromRemittanceReport: 0.02,
        netDebtToPreMarketingEbitdaFromRemittanceReport: 0.04,
        cash: 1051243.87,
        ebitda: 478974.27,
        netDebtToRevenue: 5.88
    },
    {
        month: [
            "2023",
            "Sep"
        ],
        balanceAvgInPeriod: 1430976.56,
        debtBalanceEop: 1396273.54,
        totalRevenue: 1148165.85,
        totalDebt: 9443092.5,
        netDebtToEbitdaFromRemittanceReport: -0.3,
        preMarketingEbitda: 647090.12,
        netDebtFromRemittanceReport: 1201651.94,
        netDebtToPreMarketingEbitda: 14.24,
        netDebtToEbitda: -27.89,
        netDebtToRevenueFromRemittanceReport: 0.09,
        netDebtToPreMarketingEbitdaFromRemittanceReport: 0.15,
        cash: 229324.62,
        ebitda: -330344.04,
        netDebtToRevenue: 8.02
    },
    {
        month: [
            "2023",
            "Oct"
        ],
        balanceAvgInPeriod: 1360796.82,
        debtBalanceEop: 1325320.1,
        totalRevenue: 2708776.66,
        totalDebt: 9539217.66,
        netDebtToEbitdaFromRemittanceReport: 0.07,
        preMarketingEbitda: 1758525.62,
        netDebtFromRemittanceReport: 183101.38,
        netDebtToPreMarketingEbitda: 4.75,
        netDebtToEbitda: 38.91,
        netDebtToRevenueFromRemittanceReport: 0.01,
        netDebtToPreMarketingEbitdaFromRemittanceReport: 0.01,
        cash: 1177695.44,
        ebitda: 214908.24,
        netDebtToRevenue: 3.09
    },
    {
        month: [
            "2023",
            "Nov"
        ],
        balanceAvgInPeriod: 1289052.43,
        debtBalanceEop: 1252784.75,
        totalRevenue: 4042095.01,
        totalDebt: 9141559.4,
        netDebtToEbitdaFromRemittanceReport: -0.12,
        preMarketingEbitda: 2573849.95,
        netDebtFromRemittanceReport: -1464857.74,
        netDebtToPreMarketingEbitda: 2.48,
        netDebtToEbitda: 6.1,
        netDebtToRevenueFromRemittanceReport: -0.03,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.05,
        cash: 2753910.17,
        ebitda: 1047403.41,
        netDebtToRevenue: 1.58
    },
    {
        month: [
            "2023",
            "Dec"
        ],
        balanceAvgInPeriod: 1215708.49,
        debtBalanceEop: 1178632.23,
        totalRevenue: 3560257.66,
        totalDebt: 9410963.79,
        netDebtToEbitdaFromRemittanceReport: -0.1,
        preMarketingEbitda: 2127809.68,
        netDebtFromRemittanceReport: -1407423.33,
        netDebtToPreMarketingEbitda: 3.19,
        netDebtToEbitda: 5.94,
        netDebtToRevenueFromRemittanceReport: -0.03,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.06,
        cash: 2623131.82,
        ebitda: 1142678.98,
        netDebtToRevenue: 1.91
    },
    {
        month: [
            "2024",
            "Jan"
        ],
        balanceAvgInPeriod: 1140729.35,
        debtBalanceEop: 1102826.48,
        totalRevenue: 1357548.17,
        totalDebt: 9410232.79,
        netDebtToEbitdaFromRemittanceReport: 0.29,
        preMarketingEbitda: 704527.9,
        netDebtFromRemittanceReport: -997306.85,
        netDebtToPreMarketingEbitda: 10.32,
        netDebtToEbitda: -25.24,
        netDebtToRevenueFromRemittanceReport: -0.06,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.12,
        cash: 2138036.21,
        ebitda: -288098.75,
        netDebtToRevenue: 5.36
    },
    {
        month: [
            "2024",
            "Feb"
        ],
        balanceAvgInPeriod: 1064078.56,
        debtBalanceEop: 1025330.64,
        totalRevenue: 1412332.92,
        totalDebt: 9205335.13,
        netDebtToEbitdaFromRemittanceReport: 1.53,
        preMarketingEbitda: 852442.72,
        netDebtFromRemittanceReport: -500775.29,
        netDebtToPreMarketingEbitda: 8.96,
        netDebtToEbitda: -279.72,
        netDebtToRevenueFromRemittanceReport: -0.03,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.05,
        cash: 1564853.85,
        ebitda: -27314.47,
        netDebtToRevenue: 5.41
    },
    {
        month: [
            "2024",
            "Mar"
        ],
        balanceAvgInPeriod: 985718.83,
        debtBalanceEop: 946107.03,
        totalRevenue: 1109826.56,
        totalDebt: 9102520.8,
        netDebtToEbitdaFromRemittanceReport: 0.15,
        preMarketingEbitda: 666606.51,
        netDebtFromRemittanceReport: -236033.68,
        netDebtToPreMarketingEbitda: 11.82,
        netDebtToEbitda: -60.58,
        netDebtToRevenueFromRemittanceReport: -0.02,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.03,
        cash: 1221752.51,
        ebitda: -130093.38,
        netDebtToRevenue: 7.1
    },
    {
        month: [
            "2024",
            "Apr"
        ],
        balanceAvgInPeriod: 905612.08,
        debtBalanceEop: 865117.13,
        totalRevenue: 854810.07,
        totalDebt: 8999706.47,
        netDebtToEbitdaFromRemittanceReport: -0.18,
        preMarketingEbitda: 491998.35,
        netDebtFromRemittanceReport: 486285.03,
        netDebtToPreMarketingEbitda: 17.44,
        netDebtToEbitda: -37.7,
        netDebtToRevenueFromRemittanceReport: 0.05,
        netDebtToPreMarketingEbitdaFromRemittanceReport: 0.08,
        cash: 419327.05,
        ebitda: -227585.66,
        netDebtToRevenue: 10.04
    },
    {
        month: [
            "2024",
            "May"
        ],
        balanceAvgInPeriod: 775198.94,
        debtBalanceEop: 685280.75,
        totalRevenue: 1304298.49,
        totalDebt: 10414365.17,
        netDebtToEbitdaFromRemittanceReport: -0.64,
        preMarketingEbitda: 739394.2,
        netDebtFromRemittanceReport: -983062.19,
        netDebtToPreMarketingEbitda: 11.71,
        netDebtToEbitda: 67.34,
        netDebtToRevenueFromRemittanceReport: -0.06,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.11,
        cash: 1758261.13,
        ebitda: 128549.29,
        netDebtToRevenue: 6.64
    },
    {
        month: [
            "2024",
            "Jun"
        ],
        balanceAvgInPeriod: 647279.1,
        debtBalanceEop: 609277.46,
        totalRevenue: 778806.57,
        totalDebt: 10238265.5,
        netDebtToEbitdaFromRemittanceReport: 0.39,
        preMarketingEbitda: 423225.13,
        netDebtFromRemittanceReport: -678081.44,
        netDebtToPreMarketingEbitda: 21.06,
        netDebtToEbitda: -61.29,
        netDebtToRevenueFromRemittanceReport: -0.07,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.13,
        cash: 1325360.54,
        ebitda: -145428.41,
        netDebtToRevenue: 11.44
    },
    {
        month: [
            "2024",
            "Jul"
        ],
        balanceAvgInPeriod: 570809.25,
        debtBalanceEop: 532341.04,
        totalRevenue: 819763.32,
        totalDebt: 10038781.02,
        netDebtToEbitdaFromRemittanceReport: -0.02,
        preMarketingEbitda: 391749.68,
        netDebtFromRemittanceReport: 114210.82,
        netDebtToPreMarketingEbitda: 24.46,
        netDebtToEbitda: -18.13,
        netDebtToRevenueFromRemittanceReport: 0.01,
        netDebtToPreMarketingEbitdaFromRemittanceReport: 0.02,
        cash: 456598.43,
        ebitda: -528576.95,
        netDebtToRevenue: 11.69
    },
    {
        month: [
            "2024",
            "Aug"
        ],
        balanceAvgInPeriod: 493395.85,
        debtBalanceEop: 454450.67,
        totalRevenue: 1212828.82,
        totalDebt: 9770639.62,
        netDebtToEbitdaFromRemittanceReport: -0.08,
        preMarketingEbitda: 715214.82,
        netDebtFromRemittanceReport: -21912.51,
        netDebtToPreMarketingEbitda: 12.94,
        netDebtToEbitda: 405.96,
        netDebtToRevenueFromRemittanceReport: -0,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0,
        cash: 515308.36,
        ebitda: 22798.87,
        netDebtToRevenue: 7.63
    },
    {
        month: [
            "2024",
            "Sep"
        ],
        balanceAvgInPeriod: 415017.88,
        debtBalanceEop: 375585.09,
        totalRevenue: 1310645.84,
        totalDebt: 9504984.04,
        netDebtToEbitdaFromRemittanceReport: 0.02,
        preMarketingEbitda: 735601.58,
        netDebtFromRemittanceReport: -59486.34,
        netDebtToPreMarketingEbitda: 12.28,
        netDebtToEbitda: -29.88,
        netDebtToRevenueFromRemittanceReport: -0,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.01,
        cash: 474504.22,
        ebitda: -302181.54,
        netDebtToRevenue: 6.89
    },
    {
        month: [
            "2024",
            "Oct"
        ],
        balanceAvgInPeriod: 335653.82,
        debtBalanceEop: 295722.56,
        totalRevenue: 1992038.87,
        totalDebt: 9112023.28,
        netDebtToEbitdaFromRemittanceReport: 0.32,
        preMarketingEbitda: 1254771.22,
        netDebtFromRemittanceReport: -644569.1,
        netDebtToPreMarketingEbitda: 6.48,
        netDebtToEbitda: -48.73,
        netDebtToRevenueFromRemittanceReport: -0.03,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.04,
        cash: 980222.92,
        ebitda: -166876.94,
        netDebtToRevenue: 4.08
    },
    {
        month: [
            "2024",
            "Nov"
        ],
        balanceAvgInPeriod: 255281.7,
        debtBalanceEop: 214840.85,
        totalRevenue: 3168315.18,
        totalDebt: 9344280.79,
        netDebtToEbitdaFromRemittanceReport: -0.13,
        preMarketingEbitda: 1989808.77,
        netDebtFromRemittanceReport: -1441010.91,
        netDebtToPreMarketingEbitda: 3.84,
        netDebtToEbitda: 8.45,
        netDebtToRevenueFromRemittanceReport: -0.04,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.06,
        cash: 1696292.61,
        ebitda: 904849.13,
        netDebtToRevenue: 2.41
    },
    {
        month: [
            "2024",
            "Dec"
        ],
        balanceAvgInPeriod: 173879.04,
        debtBalanceEop: 132917.24,
        totalRevenue: 4392768.15,
        totalDebt: 9294593.28,
        netDebtToEbitdaFromRemittanceReport: -0.29,
        preMarketingEbitda: 2620464.6,
        netDebtFromRemittanceReport: -2401088.75,
        netDebtToPreMarketingEbitda: 2.56,
        netDebtToEbitda: 9.74,
        netDebtToRevenueFromRemittanceReport: -0.05,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.08,
        cash: 2574967.8,
        ebitda: 689865.96,
        netDebtToRevenue: 1.53
    },
    {
        month: [
            "2025",
            "Jan"
        ],
        balanceAvgInPeriod: 91422.87,
        debtBalanceEop: 49928.5,
        totalRevenue: 1200761.65,
        totalDebt: 9207403.95,
        netDebtToEbitdaFromRemittanceReport: 0.23,
        preMarketingEbitda: 616446.92,
        netDebtFromRemittanceReport: -1492601.99,
        netDebtToPreMarketingEbitda: 12.37,
        netDebtToEbitda: -14.06,
        netDebtToRevenueFromRemittanceReport: -0.1,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.2,
        cash: 1584024.86,
        ebitda: -542199.64,
        netDebtToRevenue: 6.35
    },
    {
        month: [
            "2025",
            "Feb"
        ],
        balanceAvgInPeriod: 24964.24,
        debtBalanceEop: -0.01,
        totalRevenue: 1364382.34,
        totalDebt: 9083544.83,
        netDebtToEbitdaFromRemittanceReport: 3.03,
        preMarketingEbitda: 807910.29,
        netDebtFromRemittanceReport: -1622614.34,
        netDebtToPreMarketingEbitda: 9.2,
        netDebtToEbitda: -166.37,
        netDebtToRevenueFromRemittanceReport: -0.1,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.17,
        cash: 1647578.58,
        ebitda: -44694.79,
        netDebtToRevenue: 5.45
    },
    {
        month: [
            "2025",
            "Mar"
        ],
        balanceAvgInPeriod: 849999.99,
        debtBalanceEop: 849999.99,
        totalRevenue: 1520812.98,
        totalDebt: 9922188.83,
        netDebtToEbitdaFromRemittanceReport: -1.51,
        preMarketingEbitda: 953225.48,
        netDebtFromRemittanceReport: -2030371.5,
        netDebtToPreMarketingEbitda: 7.83,
        netDebtToEbitda: 66.52,
        netDebtToRevenueFromRemittanceReport: -0.11,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.18,
        cash: 2455371.49,
        ebitda: 112243.9,
        netDebtToRevenue: 4.91
    },
    {
        month: [
            "2025",
            "Apr"
        ],
        balanceAvgInPeriod: 849999.99,
        debtBalanceEop: 849999.99,
        totalRevenue: 725728.68,
        totalDebt: 9910832.83,
        netDebtToEbitdaFromRemittanceReport: 0.17,
        preMarketingEbitda: 384629.32,
        netDebtFromRemittanceReport: -854202.33,
        netDebtToPreMarketingEbitda: 21.34,
        netDebtToEbitda: -19.76,
        netDebtToRevenueFromRemittanceReport: -0.1,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.19,
        cash: 1704202.32,
        ebitda: -415232.58,
        netDebtToRevenue: 11.31
    },
    {
        month: [
            "2025",
            "May"
        ],
        balanceAvgInPeriod: 849999.99,
        debtBalanceEop: 849999.99,
        totalRevenue: 1109996.95,
        totalDebt: 9830157.41,
        netDebtToEbitdaFromRemittanceReport: 0.69,
        preMarketingEbitda: 668277.06,
        netDebtFromRemittanceReport: -903981.92,
        netDebtToPreMarketingEbitda: 12.09,
        netDebtToEbitda: -74.38,
        netDebtToRevenueFromRemittanceReport: -0.07,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.11,
        cash: 1753981.91,
        ebitda: -108584.43,
        netDebtToRevenue: 7.28
    },
    {
        month: [
            "2025",
            "Jun"
        ],
        balanceAvgInPeriod: 1680551.74,
        debtBalanceEop: 1661103.5,
        totalRevenue: 765991.16,
        totalDebt: 9830157.41,
        netDebtToEbitdaFromRemittanceReport: -0.09,
        preMarketingEbitda: 437507.34,
        netDebtFromRemittanceReport: -405455.82,
        netDebtToPreMarketingEbitda: 18.67,
        netDebtToEbitda: 21.42,
        netDebtToRevenueFromRemittanceReport: -0.04,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.08,
        cash: 1661007.56,
        ebitda: 381408.26,
        netDebtToRevenue: 10.66
    },
    {
        month: [
            "2025",
            "Jul"
        ],
        balanceAvgInPeriod: 1641221.66,
        debtBalanceEop: 1621339.82,
        totalRevenue: 37494.53,
        totalDebt: 9830157.41,
        netDebtToEbitdaFromRemittanceReport: -0.16,
        preMarketingEbitda: 23722.46,
        netDebtFromRemittanceReport: -43087.41,
        netDebtToPreMarketingEbitda: 343.38,
        netDebtToEbitda: 374.19,
        netDebtToRevenueFromRemittanceReport: -0.1,
        netDebtToPreMarketingEbitdaFromRemittanceReport: -0.15,
        cash: 1684309.07,
        ebitda: 21769.13,
        netDebtToRevenue: 217.25
    }
];
var $4264fc66659d5df8$export$2e2bcd8739ae039 = $4264fc66659d5df8$var$debtToCashflowsData;

});

parcelRegister("2EGuI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ef047b4d75be9e6$export$2e2bcd8739ae039);
const $1ef047b4d75be9e6$var$disbursementsAndRepaymentsData = [
    {
        month: [
            "2023",
            "Apr"
        ],
        disbursement: -750000,
        interestAndFeesCash: 0.0,
        amortization: 0.0
    },
    {
        month: [
            "2023",
            "May"
        ],
        disbursement: -750000,
        interestAndFeesCash: 9375.0,
        amortization: 0.0
    },
    {
        month: [
            "2023",
            "Jun"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 18750.0,
        amortization: 0.0
    },
    {
        month: [
            "2023",
            "Jul"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 18750.0,
        amortization: 0.0
    },
    {
        month: [
            "2023",
            "Aug"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 26096.24,
        amortization: 34320.43
    },
    {
        month: [
            "2023",
            "Sep"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 32677.31,
        amortization: 69406.03
    },
    {
        month: [
            "2023",
            "Oct"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 31129.9,
        amortization: 70953.44
    },
    {
        month: [
            "2023",
            "Nov"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 29547.99,
        amortization: 72535.35
    },
    {
        month: [
            "2023",
            "Dec"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 27930.82,
        amortization: 74152.52
    },
    {
        month: [
            "2024",
            "Jan"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 26277.59,
        amortization: 75805.75
    },
    {
        month: [
            "2024",
            "Feb"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 24587.5,
        amortization: 77495.84
    },
    {
        month: [
            "2024",
            "Mar"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 22859.73,
        amortization: 79223.61
    },
    {
        month: [
            "2024",
            "Apr"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 21093.44,
        amortization: 80989.9
    },
    {
        month: [
            "2024",
            "May"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 47246.96,
        amortization: 179836.38
    },
    {
        month: [
            "2024",
            "Jun"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 10455.05,
        amortization: 76003.29
    },
    {
        month: [
            "2024",
            "Jul"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 9521.92,
        amortization: 76936.42
    },
    {
        month: [
            "2024",
            "Aug"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 8567.97,
        amortization: 77890.37
    },
    {
        month: [
            "2024",
            "Sep"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 7592.76,
        amortization: 78865.58
    },
    {
        month: [
            "2024",
            "Oct"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 6595.81,
        amortization: 79862.53
    },
    {
        month: [
            "2024",
            "Nov"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 5576.63,
        amortization: 80881.71
    },
    {
        month: [
            "2024",
            "Dec"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 4534.73,
        amortization: 81923.61
    },
    {
        month: [
            "2025",
            "Jan"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 3469.6,
        amortization: 82988.74
    },
    {
        month: [
            "2025",
            "Feb"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 1113.16,
        amortization: 49928.51
    },
    {
        month: [
            "2025",
            "Mar"
        ],
        disbursement: -850000,
        interestAndFeesCash: 10625.0,
        amortization: 0.0
    },
    {
        month: [
            "2025",
            "Apr"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 10625.0,
        amortization: 0.0
    },
    {
        month: [
            "2025",
            "May"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 10625.0,
        amortization: 0.0
    },
    {
        month: [
            "2025",
            "Jun"
        ],
        disbursement: -850000,
        interestAndFeesCash: 29575.73,
        amortization: 38896.49
    },
    {
        month: [
            "2025",
            "Jul"
        ],
        disbursement: 0.0,
        interestAndFeesCash: 28708.54,
        amortization: 39763.68
    }
];
var $1ef047b4d75be9e6$export$2e2bcd8739ae039 = $1ef047b4d75be9e6$var$disbursementsAndRepaymentsData;

});

parcelRegister("lF3df", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc4feb42de147708$export$2e2bcd8739ae039);
const $fc4feb42de147708$var$liquidityData = [
    {
        month: [
            "2021",
            "Aug"
        ],
        liquidAssets: 3441645.23,
        totalExpenses: 1329493.89,
        totalRevenue: 1056302.74,
        totalCurrentLiabilities: 6826698.13,
        currentAssetsNetInventory: 2620588.4,
        currentRatio: 0.55,
        quickRatio: 0.12,
        cashRatio: 0.12,
        cash: 836829.02,
        netIncome: -273191.15,
        ebitda: -261682.45,
        currentAssets: 3729507.14,
        runway: 3.06
    },
    {
        month: [
            "2021",
            "Sep"
        ],
        liquidAssets: 3868935.52,
        totalExpenses: 1615094.14,
        totalRevenue: 829310.85,
        totalCurrentLiabilities: 8039086.71,
        currentAssetsNetInventory: 3492863.33,
        currentRatio: 0.52,
        quickRatio: 0.05,
        cashRatio: 0.05,
        cash: 383270.55,
        netIncome: -785783.29,
        ebitda: -710855.77,
        currentAssets: 4156921.83,
        runway: 0.49
    },
    {
        month: [
            "2021",
            "Oct"
        ],
        liquidAssets: 4798523.89,
        totalExpenses: 2042272.13,
        totalRevenue: 2061491.35,
        totalCurrentLiabilities: 8970799.03,
        currentAssetsNetInventory: 3979670.88,
        currentRatio: 0.57,
        quickRatio: 0.09,
        cashRatio: 0.09,
        cash: 801144.55,
        netIncome: 19219.22,
        ebitda: 29210.15,
        currentAssets: 5127051.12,
        runway: Infinity
    },
    {
        month: [
            "2021",
            "Nov"
        ],
        liquidAssets: 5548845.97,
        totalExpenses: 2933067.96,
        totalRevenue: 3116471.59,
        totalCurrentLiabilities: 9575735.84,
        currentAssetsNetInventory: 3704334.4,
        currentRatio: 0.62,
        quickRatio: 0.19,
        cashRatio: 0.15,
        cash: 1453189.69,
        netIncome: 183403.63,
        ebitda: 223837.94,
        currentAssets: 5907671.14,
        runway: Infinity
    },
    {
        month: [
            "2021",
            "Dec"
        ],
        liquidAssets: 5035201.15,
        totalExpenses: 3384100.33,
        totalRevenue: 3247412.49,
        totalCurrentLiabilities: 9212443.52,
        currentAssetsNetInventory: 2941339.93,
        currentRatio: 0.59,
        quickRatio: 0.23,
        cashRatio: 0.23,
        cash: 2093477.41,
        netIncome: -136687.84,
        ebitda: -133300.42,
        currentAssets: 5410032.74,
        runway: 15.32
    },
    {
        month: [
            "2022",
            "Jan"
        ],
        liquidAssets: 3932703.98,
        totalExpenses: 1722767.11,
        totalRevenue: 1225423.81,
        totalCurrentLiabilities: 8588523.52,
        currentAssetsNetInventory: 2988447.71,
        currentRatio: 0.5,
        quickRatio: 0.11,
        cashRatio: 0.11,
        cash: 965303.76,
        netIncome: -497343.3,
        ebitda: -496804.59,
        currentAssets: 4316752.9,
        runway: 1.94
    },
    {
        month: [
            "2022",
            "Feb"
        ],
        liquidAssets: 4479273.21,
        totalExpenses: 1862520.31,
        totalRevenue: 1488528.38,
        totalCurrentLiabilities: 9517768.8,
        currentAssetsNetInventory: 3105310.11,
        currentRatio: 0.51,
        quickRatio: 0.14,
        cashRatio: 0.14,
        cash: 1371971.53,
        netIncome: -373991.93,
        ebitda: -334126.64,
        currentAssets: 4873612.06,
        runway: 3.67
    },
    {
        month: [
            "2022",
            "Mar"
        ],
        liquidAssets: 3704489.59,
        totalExpenses: 1598905.89,
        totalRevenue: 1370241.74,
        totalCurrentLiabilities: 8966187.77,
        currentAssetsNetInventory: 3358477.08,
        currentRatio: 0.46,
        quickRatio: 0.04,
        cashRatio: 0.04,
        cash: 349492.07,
        netIncome: -228664.15,
        ebitda: -227476.2,
        currentAssets: 4098519.41,
        runway: 1.53
    },
    {
        month: [
            "2022",
            "Apr"
        ],
        liquidAssets: 3957060.37,
        totalExpenses: 1473206.29,
        totalRevenue: 997813.92,
        totalCurrentLiabilities: 9689684.02,
        currentAssetsNetInventory: 3566748.06,
        currentRatio: 0.45,
        quickRatio: 0.04,
        cashRatio: 0.04,
        cash: 421236.79,
        netIncome: -475392.37,
        ebitda: -474566.67,
        currentAssets: 4352297.39,
        runway: 0.89
    },
    {
        month: [
            "2022",
            "May"
        ],
        liquidAssets: 3610983.37,
        totalExpenses: 1555958.11,
        totalRevenue: 1276291.23,
        totalCurrentLiabilities: 9622886.84,
        currentAssetsNetInventory: 3525358.19,
        currentRatio: 0.42,
        quickRatio: 0.01,
        cashRatio: 0.01,
        cash: 119722.82,
        netIncome: -279666.88,
        ebitda: -283093.72,
        currentAssets: 4011406.33,
        runway: 0.43
    },
    {
        month: [
            "2022",
            "Jun"
        ],
        liquidAssets: 4212280.18,
        totalExpenses: 1476781.5,
        totalRevenue: 1147775.8,
        totalCurrentLiabilities: 10548883.5,
        currentAssetsNetInventory: 3799373.94,
        currentRatio: 0.44,
        quickRatio: 0.04,
        cashRatio: 0.04,
        cash: 412926.4,
        netIncome: -329005.7,
        ebitda: -328131.99,
        currentAssets: 4614893.14,
        runway: 1.26
    },
    {
        month: [
            "2022",
            "Jul"
        ],
        liquidAssets: 4465389.57,
        totalExpenses: 1394566.78,
        totalRevenue: 968255.47,
        totalCurrentLiabilities: 11232364.5,
        currentAssetsNetInventory: 3960580.88,
        currentRatio: 0.43,
        quickRatio: 0.04,
        cashRatio: 0.04,
        cash: 496691.42,
        netIncome: -426311.31,
        ebitda: -426064.94,
        currentAssets: 4869490.23,
        runway: 1.17
    },
    {
        month: [
            "2022",
            "Aug"
        ],
        liquidAssets: 4654583.25,
        totalExpenses: 1697850.86,
        totalRevenue: 1460722.01,
        totalCurrentLiabilities: 11708685.42,
        currentAssetsNetInventory: 4309054.85,
        currentRatio: 0.44,
        quickRatio: 0.03,
        cashRatio: 0.03,
        cash: 299495.54,
        netIncome: -237128.85,
        ebitda: -231432.52,
        currentAssets: 5108559.22,
        runway: 1.26
    },
    {
        month: [
            "2022",
            "Sep"
        ],
        liquidAssets: 4903765.67,
        totalExpenses: 1822446.52,
        totalRevenue: 903691.02,
        totalCurrentLiabilities: 12892637.78,
        currentAssetsNetInventory: 4713099.42,
        currentRatio: 0.42,
        quickRatio: 0.01,
        cashRatio: 0.01,
        cash: 144536.11,
        netIncome: -918755.5,
        ebitda: -908612.45,
        currentAssets: 5382865.85,
        runway: 0.16
    },
    {
        month: [
            "2022",
            "Oct"
        ],
        liquidAssets: 5317295.03,
        totalExpenses: 2637975.26,
        totalRevenue: 2572904.85,
        totalCurrentLiabilities: 13362852.65,
        currentAssetsNetInventory: 4722439.76,
        currentRatio: 0.43,
        quickRatio: 0.04,
        cashRatio: 0.04,
        cash: 511916.49,
        netIncome: -65070.41,
        ebitda: -41330.69,
        currentAssets: 5808381.85,
        runway: 7.87
    },
    {
        month: [
            "2022",
            "Nov"
        ],
        liquidAssets: 5845771.54,
        totalExpenses: 3076061.79,
        totalRevenue: 4061811.53,
        totalCurrentLiabilities: 12942951.0,
        currentAssetsNetInventory: 4115392.56,
        currentRatio: 0.49,
        quickRatio: 0.13,
        cashRatio: 0.12,
        cash: 1500152.8,
        netIncome: 985749.74,
        ebitda: 996662.53,
        currentAssets: 6370637.97,
        runway: Infinity
    },
    {
        month: [
            "2022",
            "Dec"
        ],
        liquidAssets: 4270844.01,
        totalExpenses: 2792296.38,
        totalRevenue: 3473715.02,
        totalCurrentLiabilities: 10674817.54,
        currentAssetsNetInventory: 3457645.51,
        currentRatio: 0.45,
        quickRatio: 0.08,
        cashRatio: 0.07,
        cash: 776161.2,
        netIncome: 681418.64,
        ebitda: 915443.82,
        currentAssets: 4796092.94,
        runway: Infinity
    },
    {
        month: [
            "2023",
            "Jan"
        ],
        liquidAssets: 4560549.23,
        totalExpenses: 1868864.33,
        totalRevenue: 1457363.91,
        totalCurrentLiabilities: 11370077.59,
        currentAssetsNetInventory: 3180649.46,
        currentRatio: 0.45,
        quickRatio: 0.12,
        cashRatio: 0.13,
        cash: 1496772.12,
        netIncome: -411500.42,
        ebitda: -408923.78,
        currentAssets: 5103058.16,
        runway: 3.64
    },
    {
        month: [
            "2023",
            "Feb"
        ],
        liquidAssets: 3085608.38,
        totalExpenses: 1093437.37,
        totalRevenue: 651704.91,
        totalCurrentLiabilities: 10336212.12,
        currentAssetsNetInventory: 3227560.42,
        currentRatio: 0.35,
        quickRatio: -0.01,
        cashRatio: 0.0,
        cash: 35759.9,
        netIncome: -441732.46,
        ebitda: -437982.85,
        currentAssets: 3640251.71,
        runway: 0.08
    },
    {
        month: [
            "2023",
            "Mar"
        ],
        liquidAssets: 3291250.89,
        totalExpenses: 1336842.78,
        totalRevenue: 1064881.14,
        totalCurrentLiabilities: 10821890.24,
        currentAssetsNetInventory: 3173384.43,
        currentRatio: 0.36,
        quickRatio: 0.01,
        cashRatio: 0.03,
        cash: 330112.56,
        netIncome: -271961.64,
        ebitda: -268249.95,
        currentAssets: 3859687.82,
        runway: 1.21
    },
    {
        month: [
            "2023",
            "Apr"
        ],
        liquidAssets: 3916742.85,
        totalExpenses: 1009553.27,
        totalRevenue: 644017.64,
        totalCurrentLiabilities: 11111522.44,
        currentAssetsNetInventory: 3311785.33,
        currentRatio: 0.4,
        quickRatio: 0.05,
        cashRatio: 0.08,
        cash: 834658.4,
        netIncome: -365535.63,
        ebitda: -362322.35,
        currentAssets: 4497419.78,
        runway: 2.28
    },
    {
        month: [
            "2023",
            "May"
        ],
        liquidAssets: 4240122.86,
        totalExpenses: 1113203.68,
        totalRevenue: 970982.72,
        totalCurrentLiabilities: 10808866.42,
        currentAssetsNetInventory: 3303024.29,
        currentRatio: 0.44,
        quickRatio: 0.09,
        cashRatio: 0.11,
        cash: 1189551.45,
        netIncome: -142220.96,
        ebitda: -138217.53,
        currentAssets: 4794814.85,
        runway: 8.36
    },
    {
        month: [
            "2023",
            "Jun"
        ],
        liquidAssets: 4149607.61,
        totalExpenses: 784139.08,
        totalRevenue: 669718.47,
        totalCurrentLiabilities: 10807651.21,
        currentAssetsNetInventory: 3514407.29,
        currentRatio: 0.43,
        quickRatio: 0.06,
        cashRatio: 0.08,
        cash: 853773.23,
        netIncome: -114420.61,
        ebitda: -110445.3,
        currentAssets: 4677936.2,
        runway: 7.46
    },
    {
        month: [
            "2023",
            "Jul"
        ],
        liquidAssets: 4019486.96,
        totalExpenses: 1010770.87,
        totalRevenue: 744590.0,
        totalCurrentLiabilities: 10939675.52,
        currentAssetsNetInventory: 3667893.39,
        currentRatio: 0.41,
        quickRatio: 0.03,
        cashRatio: 0.05,
        cash: 565946.54,
        netIncome: -266180.87,
        ebitda: -261339.09,
        currentAssets: 4522535.55,
        runway: 2.13
    },
    {
        month: [
            "2023",
            "Aug"
        ],
        liquidAssets: 4755751.32,
        totalExpenses: 1050008.09,
        totalRevenue: 1461633.43,
        totalCurrentLiabilities: 11272654.77,
        currentAssetsNetInventory: 3883059.14,
        currentRatio: 0.47,
        quickRatio: 0.08,
        cashRatio: 0.09,
        cash: 1051243.87,
        netIncome: 411625.34,
        ebitda: 478974.27,
        currentAssets: 5250338.41,
        runway: Infinity
    },
    {
        month: [
            "2023",
            "Sep"
        ],
        liquidAssets: 4509263.18,
        totalExpenses: 1482656.78,
        totalRevenue: 1148165.85,
        totalCurrentLiabilities: 11430156.34,
        currentAssetsNetInventory: 4386350.57,
        currentRatio: 0.44,
        quickRatio: 0.01,
        cashRatio: 0.02,
        cash: 229324.62,
        netIncome: -334490.93,
        ebitda: -330344.04,
        currentAssets: 4975973.73,
        runway: 0.69
    },
    {
        month: [
            "2023",
            "Oct"
        ],
        liquidAssets: 5742972.67,
        totalExpenses: 2541699.01,
        totalRevenue: 2708776.66,
        totalCurrentLiabilities: 12683379.05,
        currentAssetsNetInventory: 4587714.92,
        currentRatio: 0.5,
        quickRatio: 0.09,
        cashRatio: 0.09,
        cash: 1177695.44,
        netIncome: 167077.65,
        ebitda: 214908.24,
        currentAssets: 6322710.73,
        runway: Infinity
    },
    {
        month: [
            "2023",
            "Nov"
        ],
        liquidAssets: 6648302.65,
        totalExpenses: 2999664.0,
        totalRevenue: 4042095.01,
        totalCurrentLiabilities: 12947188.76,
        currentAssetsNetInventory: 3847906.43,
        currentRatio: 0.57,
        quickRatio: 0.22,
        cashRatio: 0.21,
        cash: 2753910.17,
        netIncome: 1042431.01,
        ebitda: 1047403.41,
        currentAssets: 7424435.22,
        runway: Infinity
    },
    {
        month: [
            "2023",
            "Dec"
        ],
        liquidAssets: 5871865.99,
        totalExpenses: 2969789.44,
        totalRevenue: 3560257.66,
        totalCurrentLiabilities: 11928462.12,
        currentAssetsNetInventory: 3253838.48,
        currentRatio: 0.56,
        quickRatio: 0.22,
        cashRatio: 0.22,
        cash: 2623131.82,
        netIncome: 590468.22,
        ebitda: 1142678.98,
        currentAssets: 6666324.52,
        runway: Infinity
    },
    {
        month: [
            "2024",
            "Jan"
        ],
        liquidAssets: 5506855.3,
        totalExpenses: 1648441.3,
        totalRevenue: 1357548.17,
        totalCurrentLiabilities: 11822160.92,
        currentAssetsNetInventory: 3323274.73,
        currentRatio: 0.53,
        quickRatio: 0.18,
        cashRatio: 0.18,
        cash: 2138036.21,
        netIncome: -290893.13,
        ebitda: -288098.75,
        currentAssets: 6293251.78,
        runway: 7.35
    },
    {
        month: [
            "2024",
            "Feb"
        ],
        liquidAssets: 5063132.98,
        totalExpenses: 1523248.15,
        totalRevenue: 1412332.92,
        totalCurrentLiabilities: 11674723.31,
        currentAssetsNetInventory: 3397868.92,
        currentRatio: 0.5,
        quickRatio: 0.14,
        cashRatio: 0.13,
        cash: 1564853.85,
        netIncome: -110915.23,
        ebitda: -27314.47,
        currentAssets: 5840229.8,
        runway: 14.11
    },
    {
        month: [
            "2024",
            "Mar"
        ],
        liquidAssets: 4855452.5,
        totalExpenses: 1244962.02,
        totalRevenue: 1109826.56,
        totalCurrentLiabilities: 11689739.0,
        currentAssetsNetInventory: 3438593.5,
        currentRatio: 0.48,
        quickRatio: 0.12,
        cashRatio: 0.1,
        cash: 1221752.51,
        netIncome: -135135.46,
        ebitda: -130093.38,
        currentAssets: 5619732.95,
        runway: 9.04
    },
    {
        month: [
            "2024",
            "Apr"
        ],
        liquidAssets: 4172322.51,
        totalExpenses: 1086640.48,
        totalRevenue: 854810.07,
        totalCurrentLiabilities: 11326781.3,
        currentAssetsNetInventory: 3516607.4,
        currentRatio: 0.43,
        quickRatio: 0.06,
        cashRatio: 0.04,
        cash: 419327.05,
        netIncome: -231830.41,
        ebitda: -227585.66,
        currentAssets: 4925608.18,
        runway: 1.81
    },
    {
        month: [
            "2024",
            "May"
        ],
        liquidAssets: 5525829.13,
        totalExpenses: 1263267.12,
        totalRevenue: 1304298.49,
        totalCurrentLiabilities: 12859840.22,
        currentAssetsNetInventory: 3440716.16,
        currentRatio: 0.49,
        quickRatio: 0.16,
        cashRatio: 0.14,
        cash: 1758261.13,
        netIncome: 41031.37,
        ebitda: 128549.29,
        currentAssets: 6271539.56,
        runway: Infinity
    },
    {
        month: [
            "2024",
            "Jun"
        ],
        liquidAssets: 5284191.3,
        totalExpenses: 938361.93,
        totalRevenue: 778806.57,
        totalCurrentLiabilities: 12807078.09,
        currentAssetsNetInventory: 3578837.32,
        currentRatio: 0.47,
        quickRatio: 0.13,
        cashRatio: 0.1,
        cash: 1325360.54,
        netIncome: -159555.36,
        ebitda: -145428.41,
        currentAssets: 5988823.75,
        runway: 8.31
    },
    {
        month: [
            "2024",
            "Jul"
        ],
        liquidAssets: 4645681.19,
        totalExpenses: 1352657.5,
        totalRevenue: 819763.32,
        totalCurrentLiabilities: 12774513.23,
        currentAssetsNetInventory: 3785836.72,
        currentRatio: 0.42,
        quickRatio: 0.07,
        cashRatio: 0.04,
        cash: 456598.43,
        netIncome: -532894.18,
        ebitda: -528576.95,
        currentAssets: 5328174.75,
        runway: 0.86
    },
    {
        month: [
            "2024",
            "Aug"
        ],
        liquidAssets: 4908545.89,
        totalExpenses: 1197274.62,
        totalRevenue: 1212828.82,
        totalCurrentLiabilities: 13092680.65,
        currentAssetsNetInventory: 3991130.32,
        currentRatio: 0.43,
        quickRatio: 0.07,
        cashRatio: 0.04,
        cash: 515308.36,
        netIncome: 15554.2,
        ebitda: 22798.87,
        currentAssets: 5569926.84,
        runway: Infinity
    },
    {
        month: [
            "2024",
            "Sep"
        ],
        liquidAssets: 5201638.28,
        totalExpenses: 1794280.02,
        totalRevenue: 1310645.84,
        totalCurrentLiabilities: 14000076.96,
        currentAssetsNetInventory: 4349052.04,
        currentRatio: 0.42,
        quickRatio: 0.06,
        cashRatio: 0.03,
        cash: 474504.22,
        netIncome: -483634.18,
        ebitda: -302181.54,
        currentAssets: 5907624.74,
        runway: 0.98
    },
    {
        month: [
            "2024",
            "Oct"
        ],
        liquidAssets: 5571499.41,
        totalExpenses: 2155931.88,
        totalRevenue: 1992038.87,
        totalCurrentLiabilities: 14588841.52,
        currentAssetsNetInventory: 4454007.78,
        currentRatio: 0.43,
        quickRatio: 0.08,
        cashRatio: 0.07,
        cash: 980222.92,
        netIncome: -163893.01,
        ebitda: -166876.94,
        currentAssets: 6263633.9,
        runway: 5.98
    },
    {
        month: [
            "2024",
            "Nov"
        ],
        liquidAssets: 6117144.64,
        totalExpenses: 2344461.63,
        totalRevenue: 3168315.18,
        totalCurrentLiabilities: 14438556.79,
        currentAssetsNetInventory: 4099767.64,
        currentRatio: 0.47,
        quickRatio: 0.14,
        cashRatio: 0.12,
        cash: 1696292.61,
        netIncome: 823853.55,
        ebitda: 904849.13,
        currentAssets: 6841531.83,
        runway: Infinity
    },
    {
        month: [
            "2024",
            "Dec"
        ],
        liquidAssets: 6119622.88,
        totalExpenses: 4282632.46,
        totalRevenue: 4392768.15,
        totalCurrentLiabilities: 12905116.99,
        currentAssetsNetInventory: 3218207.27,
        currentRatio: 0.53,
        quickRatio: 0.22,
        cashRatio: 0.2,
        cash: 2574967.8,
        netIncome: 110135.69,
        ebitda: 689865.96,
        currentAssets: 6859737.05,
        runway: Infinity
    },
    {
        month: [
            "2025",
            "Jan"
        ],
        liquidAssets: 5250426.58,
        totalExpenses: 1743908.88,
        totalRevenue: 1200761.65,
        totalCurrentLiabilities: 12665526.42,
        currentAssetsNetInventory: 3307538.41,
        currentRatio: 0.47,
        quickRatio: 0.15,
        cashRatio: 0.13,
        cash: 1584024.86,
        netIncome: -543147.23,
        ebitda: -542199.64,
        currentAssets: 6006269.7,
        runway: 2.92
    },
    {
        month: [
            "2025",
            "Feb"
        ],
        liquidAssets: 5368252.96,
        totalExpenses: 1413600.15,
        totalRevenue: 1364382.34,
        totalCurrentLiabilities: 12923636.07,
        currentAssetsNetInventory: 3346380.39,
        currentRatio: 0.47,
        quickRatio: 0.16,
        cashRatio: 0.13,
        cash: 1647578.58,
        netIncome: -49217.81,
        ebitda: -44694.79,
        currentAssets: 6133366.77,
        runway: 33.48
    },
    {
        month: [
            "2025",
            "Mar"
        ],
        liquidAssets: 6341865.64,
        totalExpenses: 1415115.45,
        totalRevenue: 1520812.98,
        totalCurrentLiabilities: 12943247.56,
        currentAssetsNetInventory: 3466519.6,
        currentRatio: 0.55,
        quickRatio: 0.22,
        cashRatio: 0.19,
        cash: 2455371.49,
        netIncome: 105697.53,
        ebitda: 112243.9,
        currentAssets: 7101272.11,
        runway: Infinity
    },
    {
        month: [
            "2025",
            "Apr"
        ],
        liquidAssets: 5665791.26,
        totalExpenses: 1145675.38,
        totalRevenue: 725728.68,
        totalCurrentLiabilities: 12697365.79,
        currentAssetsNetInventory: 3538694.55,
        currentRatio: 0.51,
        quickRatio: 0.17,
        cashRatio: 0.13,
        cash: 1704202.32,
        netIncome: -419946.7,
        ebitda: -415232.58,
        currentAssets: 6425882.29,
        runway: 4.06
    },
    {
        month: [
            "2025",
            "May"
        ],
        liquidAssets: 5697728.36,
        totalExpenses: 1222203.34,
        totalRevenue: 1109996.95,
        totalCurrentLiabilities: 12899788.23,
        currentAssetsNetInventory: 3524026.21,
        currentRatio: 0.5,
        quickRatio: 0.17,
        cashRatio: 0.14,
        cash: 1753981.91,
        netIncome: -112206.39,
        ebitda: -108584.43,
        currentAssets: 6441922.75,
        runway: 15.63
    },
    {
        month: [
            "2025",
            "Jun"
        ],
        liquidAssets: 5878520.82,
        totalExpenses: 390781.96,
        totalRevenue: 765991.16,
        totalCurrentLiabilities: 12726899.82,
        currentAssetsNetInventory: 3764338.42,
        currentRatio: 0.52,
        quickRatio: 0.17,
        cashRatio: 0.13,
        cash: 1661007.56,
        netIncome: 375209.2,
        ebitda: 381408.26,
        currentAssets: 6654481.11,
        runway: Infinity
    },
    {
        month: [
            "2025",
            "Jul"
        ],
        liquidAssets: 5902546.56,
        totalExpenses: 15725.4,
        totalRevenue: 37494.53,
        totalCurrentLiabilities: 12731874.32,
        currentAssetsNetInventory: 3767649.5,
        currentRatio: 0.52,
        quickRatio: 0.17,
        cashRatio: 0.13,
        cash: 1684309.07,
        netIncome: 21769.13,
        ebitda: 21769.13,
        currentAssets: 6681206.85,
        runway: Infinity
    }
];
var $fc4feb42de147708$export$2e2bcd8739ae039 = $fc4feb42de147708$var$liquidityData;

});

parcelRegister("gem4U", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd0f146e339e89ed$export$2e2bcd8739ae039);
const $bd0f146e339e89ed$var$financialData = [
    {
        month: [
            "2022",
            "Jan"
        ],
        totalRevenue: 375344.25,
        projectedRevenue: 400000,
        grossMargin: 0.55220745,
        projectedGrossMargin: null,
        salesAndMarketing: 437506.09,
        projectedSalesAndMarketing: null,
        totalExpenses: 608790.65,
        projectedTotalExpenses: null,
        preMarketingEbitda: 207267.89,
        projectedPreMarketingEbitda: null,
        ebitda: -230238.2,
        projectedEbitda: null
    },
    {
        month: [
            "2022",
            "Feb"
        ],
        totalRevenue: 350652.6,
        projectedRevenue: 400000,
        grossMargin: 0.4469737,
        projectedGrossMargin: null,
        salesAndMarketing: 328297.86,
        projectedSalesAndMarketing: null,
        totalExpenses: 523089.77,
        projectedTotalExpenses: null,
        preMarketingEbitda: 156732.49,
        projectedPreMarketingEbitda: null,
        ebitda: -171565.37,
        projectedEbitda: null
    },
    {
        month: [
            "2022",
            "Mar"
        ],
        totalRevenue: 399967.95,
        projectedRevenue: 400000,
        grossMargin: 0.43483912,
        projectedGrossMargin: null,
        salesAndMarketing: 513041.16,
        projectedSalesAndMarketing: null,
        totalExpenses: 740448.03,
        projectedTotalExpenses: null,
        preMarketingEbitda: 173921.71,
        projectedPreMarketingEbitda: null,
        ebitda: -339119.45,
        projectedEbitda: null
    },
    {
        month: [
            "2022",
            "Apr"
        ],
        totalRevenue: 421113.8,
        projectedRevenue: 400000,
        grossMargin: 0.59451996,
        projectedGrossMargin: null,
        salesAndMarketing: 514452.25,
        projectedSalesAndMarketing: null,
        totalExpenses: 688510.83,
        projectedTotalExpenses: null,
        preMarketingEbitda: 250360.56,
        projectedPreMarketingEbitda: null,
        ebitda: -264091.69,
        projectedEbitda: null
    },
    {
        month: [
            "2022",
            "May"
        ],
        totalRevenue: 437060.66,
        projectedRevenue: 400000,
        grossMargin: 0.55973972,
        projectedGrossMargin: null,
        salesAndMarketing: 343500.96,
        projectedSalesAndMarketing: null,
        totalExpenses: 541608.38,
        projectedTotalExpenses: null,
        preMarketingEbitda: 244640.21,
        projectedPreMarketingEbitda: null,
        ebitda: -98860.75,
        projectedEbitda: null
    },
    {
        month: [
            "2022",
            "Jun"
        ],
        totalRevenue: 461146.41,
        projectedRevenue: 400000,
        grossMargin: 0.50295463,
        projectedGrossMargin: null,
        salesAndMarketing: 320623.21,
        projectedSalesAndMarketing: null,
        totalExpenses: 556096.08,
        projectedTotalExpenses: null,
        preMarketingEbitda: 231935.72,
        projectedPreMarketingEbitda: null,
        ebitda: -88687.49,
        projectedEbitda: null
    },
    {
        month: [
            "2022",
            "Jul"
        ],
        totalRevenue: 502910.95,
        projectedRevenue: 400000,
        grossMargin: 0.67257247,
        projectedGrossMargin: null,
        salesAndMarketing: 353983.7,
        projectedSalesAndMarketing: null,
        totalExpenses: 523841.96,
        projectedTotalExpenses: null,
        preMarketingEbitda: 338244.06,
        projectedPreMarketingEbitda: null,
        ebitda: -15739.64,
        projectedEbitda: null
    },
    {
        month: [
            "2022",
            "Aug"
        ],
        totalRevenue: 538945.3,
        projectedRevenue: 400000,
        grossMargin: 0.62932416,
        projectedGrossMargin: null,
        salesAndMarketing: 380675.42,
        projectedSalesAndMarketing: null,
        totalExpenses: 583853.99,
        projectedTotalExpenses: null,
        preMarketingEbitda: 339171.3,
        projectedPreMarketingEbitda: null,
        ebitda: -41504.12,
        projectedEbitda: null
    },
    {
        month: [
            "2022",
            "Sep"
        ],
        totalRevenue: 574821.13,
        projectedRevenue: 400000,
        grossMargin: 0.63520292,
        projectedGrossMargin: null,
        salesAndMarketing: 502714.43,
        projectedSalesAndMarketing: null,
        totalExpenses: 715312.54,
        projectedTotalExpenses: null,
        preMarketingEbitda: 365128.06,
        projectedPreMarketingEbitda: null,
        ebitda: -137586.37,
        projectedEbitda: null
    },
    {
        month: [
            "2022",
            "Oct"
        ],
        totalRevenue: 597897.49,
        projectedRevenue: 400000,
        grossMargin: 0.70457086,
        projectedGrossMargin: null,
        salesAndMarketing: 615347.78,
        projectedSalesAndMarketing: null,
        totalExpenses: 794833.25,
        projectedTotalExpenses: null,
        preMarketingEbitda: 421261.15,
        projectedPreMarketingEbitda: null,
        ebitda: -194086.63,
        projectedEbitda: null
    },
    {
        month: [
            "2022",
            "Nov"
        ],
        totalRevenue: 708884.88,
        projectedRevenue: 400000,
        grossMargin: 0.65385095,
        projectedGrossMargin: null,
        salesAndMarketing: 1144586,
        projectedSalesAndMarketing: null,
        totalExpenses: 1395357.17,
        projectedTotalExpenses: null,
        preMarketingEbitda: 463505.05,
        projectedPreMarketingEbitda: null,
        ebitda: -681080.95,
        projectedEbitda: null
    },
    {
        month: [
            "2022",
            "Dec"
        ],
        totalRevenue: 924244.24,
        projectedRevenue: 400000,
        grossMargin: 0.66328409,
        projectedGrossMargin: null,
        salesAndMarketing: 1183243.33,
        projectedSalesAndMarketing: null,
        totalExpenses: 1509829.98,
        projectedTotalExpenses: null,
        preMarketingEbitda: 613036.5,
        projectedPreMarketingEbitda: null,
        ebitda: -570206.83,
        projectedEbitda: null
    },
    {
        month: [
            "2023",
            "Jan"
        ],
        totalRevenue: 1061512.82,
        projectedRevenue: 887072.83333333,
        grossMargin: 0.63563632,
        projectedGrossMargin: 0.53300697,
        salesAndMarketing: 1440906.04,
        projectedSalesAndMarketing: 334856.5,
        totalExpenses: 1853242.89,
        projectedTotalExpenses: 493303.41666667,
        preMarketingEbitda: 674736.1,
        projectedPreMarketingEbitda: 314369.16666667,
        ebitda: -766169.94,
        projectedEbitda: -20487.33333333
    },
    {
        month: [
            "2023",
            "Feb"
        ],
        totalRevenue: 1068403.37,
        projectedRevenue: 887072.83333333,
        grossMargin: 0.66954098,
        projectedGrossMargin: 0.53300697,
        salesAndMarketing: 1067391.9,
        projectedSalesAndMarketing: 334856.5,
        totalExpenses: 1443016.31,
        projectedTotalExpenses: 493303.41666667,
        preMarketingEbitda: 715339.84,
        projectedPreMarketingEbitda: 314369.16666667,
        ebitda: -352052.06,
        projectedEbitda: -20487.33333333
    },
    {
        month: [
            "2023",
            "Mar"
        ],
        totalRevenue: 1250730.54,
        projectedRevenue: 887072.83333333,
        grossMargin: 0.65224188,
        projectedGrossMargin: 0.53300697,
        salesAndMarketing: 1333007.62,
        projectedSalesAndMarketing: 334856.5,
        totalExpenses: 1798374.49,
        projectedTotalExpenses: 493303.41666667,
        preMarketingEbitda: 815778.84,
        projectedPreMarketingEbitda: 314369.16666667,
        ebitda: -517228.78,
        projectedEbitda: -20487.33333333
    },
    {
        month: [
            "2023",
            "Apr"
        ],
        totalRevenue: 1382031.3,
        projectedRevenue: 887072.83333333,
        grossMargin: 0.70554431,
        projectedGrossMargin: 0.53300697,
        salesAndMarketing: 1569917.2,
        projectedSalesAndMarketing: 334856.5,
        totalExpenses: 2021277.23,
        projectedTotalExpenses: 493303.41666667,
        preMarketingEbitda: 975084.32,
        projectedPreMarketingEbitda: 314369.16666667,
        ebitda: -594832.88,
        projectedEbitda: -20487.33333333
    },
    {
        month: [
            "2023",
            "May"
        ],
        totalRevenue: 1541681.3,
        projectedRevenue: 887072.83333333,
        grossMargin: 0.67808519,
        projectedGrossMargin: 0.53300697,
        salesAndMarketing: 1788465.9,
        projectedSalesAndMarketing: 334856.5,
        totalExpenses: 2333868.91,
        projectedTotalExpenses: 493303.41666667,
        preMarketingEbitda: 1045391.25,
        projectedPreMarketingEbitda: 314369.16666667,
        ebitda: -743074.65,
        projectedEbitda: -20487.33333333
    },
    {
        month: [
            "2023",
            "Jun"
        ],
        totalRevenue: 1686330.23,
        projectedRevenue: 887072.83333333,
        grossMargin: 0.6251876,
        projectedGrossMargin: 0.53300697,
        salesAndMarketing: 1893239.35,
        projectedSalesAndMarketing: 334856.5,
        totalExpenses: 2582948.14,
        projectedTotalExpenses: 493303.41666667,
        preMarketingEbitda: 1054272.75,
        projectedPreMarketingEbitda: 314369.16666667,
        ebitda: -838966.6,
        projectedEbitda: -20487.33333333
    },
    {
        month: [
            "2023",
            "Jul"
        ],
        totalRevenue: 1891553.18,
        projectedRevenue: 887072.83333333,
        grossMargin: 0.64172278,
        projectedGrossMargin: 0.53300697,
        salesAndMarketing: 2462901.28,
        projectedSalesAndMarketing: 334856.5,
        totalExpenses: 3200750.17,
        projectedTotalExpenses: 493303.41666667,
        preMarketingEbitda: 1213852.77,
        projectedPreMarketingEbitda: 314369.16666667,
        ebitda: -1249048.51,
        projectedEbitda: -20487.33333333
    },
    {
        month: [
            "2023",
            "Aug"
        ],
        totalRevenue: 2040789.71,
        projectedRevenue: 887072.83333333,
        grossMargin: 0.66925402,
        projectedGrossMargin: 0.53300697,
        salesAndMarketing: 1528609.85,
        projectedSalesAndMarketing: 334856.5,
        totalExpenses: 2274219.07,
        projectedTotalExpenses: 493303.41666667,
        preMarketingEbitda: 1365806.72,
        projectedPreMarketingEbitda: 314369.16666667,
        ebitda: -162803.13,
        projectedEbitda: -20487.33333333
    },
    {
        month: [
            "2023",
            "Sep"
        ],
        totalRevenue: 2085807.31,
        projectedRevenue: 887072.83333333,
        grossMargin: 0.60058566,
        projectedGrossMargin: 0.53300697,
        salesAndMarketing: 1380236.28,
        projectedSalesAndMarketing: 334856.5,
        totalExpenses: 2286798.7,
        projectedTotalExpenses: 493303.41666667,
        preMarketingEbitda: 1252705.96,
        projectedPreMarketingEbitda: 314369.16666667,
        ebitda: -127530.32,
        projectedEbitda: -20487.33333333
    },
    {
        month: [
            "2023",
            "Oct"
        ],
        totalRevenue: 2113073.16,
        projectedRevenue: 887072.83333333,
        grossMargin: 0.6768269,
        projectedGrossMargin: 0.53300697,
        salesAndMarketing: 1607467.11,
        projectedSalesAndMarketing: 334856.5,
        totalExpenses: 2356879.78,
        projectedTotalExpenses: 493303.41666667,
        preMarketingEbitda: 1430184.75,
        projectedPreMarketingEbitda: 314369.16666667,
        ebitda: -177282.36,
        projectedEbitda: -20487.33333333
    },
    {
        month: [
            "2023",
            "Nov"
        ],
        totalRevenue: 2189861.1,
        projectedRevenue: 887072.83333333,
        grossMargin: 0.6794273,
        projectedGrossMargin: 0.53300697,
        salesAndMarketing: 1479244.75,
        projectedSalesAndMarketing: 334856.5,
        totalExpenses: 2260832.2,
        projectedTotalExpenses: 493303.41666667,
        preMarketingEbitda: 1487851.42,
        projectedPreMarketingEbitda: 314369.16666667,
        ebitda: 8606.67,
        projectedEbitda: -20487.33333333
    },
    {
        month: [
            "2023",
            "Dec"
        ],
        totalRevenue: 2298311.42,
        projectedRevenue: 887072.83333333,
        grossMargin: 0.73440144,
        projectedGrossMargin: 0.53300697,
        salesAndMarketing: 1484214.76,
        projectedSalesAndMarketing: 334856.5,
        totalExpenses: 2170069.1,
        projectedTotalExpenses: 493303.41666667,
        preMarketingEbitda: 1687883.22,
        projectedPreMarketingEbitda: 314369.16666667,
        ebitda: 203668.46,
        projectedEbitda: -20487.33333333
    },
    {
        month: [
            "2024",
            "Jan"
        ],
        totalRevenue: 2343039.86,
        projectedRevenue: 907702.75,
        grossMargin: 0.65828641,
        projectedGrossMargin: 0.5141473,
        salesAndMarketing: 1549884.1,
        projectedSalesAndMarketing: 258488.5,
        totalExpenses: 2425607.79,
        projectedTotalExpenses: 343488.5,
        preMarketingEbitda: 1542391.29,
        projectedPreMarketingEbitda: 381692.91666667,
        ebitda: -7492.81,
        projectedEbitda: 123204.41666667
    },
    {
        month: [
            "2024",
            "Feb"
        ],
        totalRevenue: 2235042.49,
        projectedRevenue: 907702.75,
        grossMargin: 0.67673411,
        projectedGrossMargin: 0.5141473,
        salesAndMarketing: 1490790.93,
        projectedSalesAndMarketing: 258488.5,
        totalExpenses: 2287768.44,
        projectedTotalExpenses: 343488.5,
        preMarketingEbitda: 1512529.49,
        projectedPreMarketingEbitda: 381692.91666667,
        ebitda: 21738.56,
        projectedEbitda: 123204.41666667
    },
    {
        month: [
            "2024",
            "Mar"
        ],
        totalRevenue: 2482952.72,
        projectedRevenue: 907702.75,
        grossMargin: 0.69051134,
        projectedGrossMargin: 0.5141473,
        salesAndMarketing: 1552007.28,
        projectedSalesAndMarketing: 258488.5,
        totalExpenses: 2390187.66,
        projectedTotalExpenses: 343488.5,
        preMarketingEbitda: 1714507.02,
        projectedPreMarketingEbitda: 381692.91666667,
        ebitda: 162499.74,
        projectedEbitda: 123204.41666667
    },
    {
        month: [
            "2024",
            "Apr"
        ],
        totalRevenue: 2469301.14,
        projectedRevenue: 907702.75,
        grossMargin: 0.67733012,
        projectedGrossMargin: 0.5141473,
        salesAndMarketing: 1485401.4,
        projectedSalesAndMarketing: 258488.5,
        totalExpenses: 2356892.16,
        projectedTotalExpenses: 343488.5,
        preMarketingEbitda: 1672532.03,
        projectedPreMarketingEbitda: 381692.91666667,
        ebitda: 187130.63,
        projectedEbitda: 123204.41666667
    },
    {
        month: [
            "2024",
            "May"
        ],
        totalRevenue: 2604888.38,
        projectedRevenue: 907702.75,
        grossMargin: 0.71845533,
        projectedGrossMargin: 0.5141473,
        salesAndMarketing: 1875098.9,
        projectedSalesAndMarketing: 258488.5,
        totalExpenses: 2681086.85,
        projectedTotalExpenses: 343488.5,
        preMarketingEbitda: 1871495.95,
        projectedPreMarketingEbitda: 381692.91666667,
        ebitda: -3602.95,
        projectedEbitda: 123204.41666667
    },
    {
        month: [
            "2024",
            "Jun"
        ],
        totalRevenue: 2589515.82,
        projectedRevenue: 907702.75,
        grossMargin: 0.71422139,
        projectedGrossMargin: 0.5141473,
        salesAndMarketing: 2247251.19,
        projectedSalesAndMarketing: 258488.5,
        totalExpenses: 3061993.68,
        projectedTotalExpenses: 343488.5,
        preMarketingEbitda: 1849487.59,
        projectedPreMarketingEbitda: 381692.91666667,
        ebitda: -397763.6,
        projectedEbitda: 123204.41666667
    },
    {
        month: [
            "2024",
            "Jul"
        ],
        totalRevenue: 2705124.13,
        projectedRevenue: 907702.75,
        grossMargin: 0.70986552,
        projectedGrossMargin: 0.5141473,
        salesAndMarketing: 1896465.81,
        projectedSalesAndMarketing: 258488.5,
        totalExpenses: 2754557.53,
        projectedTotalExpenses: 343488.5,
        preMarketingEbitda: 1920274.35,
        projectedPreMarketingEbitda: 381692.91666667,
        ebitda: 23808.54,
        projectedEbitda: 123204.41666667
    },
    {
        month: [
            "2024",
            "Aug"
        ],
        totalRevenue: 2748178.11,
        projectedRevenue: 907702.75,
        grossMargin: 0.70338765,
        projectedGrossMargin: 0.5141473,
        salesAndMarketing: 1880995.49,
        projectedSalesAndMarketing: 258488.5,
        totalExpenses: 2771612.8,
        projectedTotalExpenses: 343488.5,
        preMarketingEbitda: 1933034.54,
        projectedPreMarketingEbitda: 381692.91666667,
        ebitda: 52039.05,
        projectedEbitda: 123204.41666667
    },
    {
        month: [
            "2024",
            "Sep"
        ],
        totalRevenue: 2745465.68,
        projectedRevenue: 907702.75,
        grossMargin: 0.70935781,
        projectedGrossMargin: 0.5141473,
        salesAndMarketing: 1642239.58,
        projectedSalesAndMarketing: 258488.5,
        totalExpenses: 2552559.64,
        projectedTotalExpenses: 343488.5,
        preMarketingEbitda: 1947517.53,
        projectedPreMarketingEbitda: 381692.91666667,
        ebitda: 305277.95,
        projectedEbitda: 123204.41666667
    },
    {
        month: [
            "2024",
            "Oct"
        ],
        totalRevenue: 2881951.94,
        projectedRevenue: 907702.75,
        grossMargin: 0.72657481,
        projectedGrossMargin: 0.5141473,
        salesAndMarketing: 2058106.16,
        projectedSalesAndMarketing: 258488.5,
        totalExpenses: 2930104.41,
        projectedTotalExpenses: 343488.5,
        preMarketingEbitda: 2093953.69,
        projectedPreMarketingEbitda: 381692.91666667,
        ebitda: 35847.53,
        projectedEbitda: 123204.41666667
    },
    {
        month: [
            "2024",
            "Nov"
        ],
        totalRevenue: 1710754.94,
        projectedRevenue: 907702.75,
        grossMargin: 0.92829727,
        projectedGrossMargin: 0.5141473,
        salesAndMarketing: 231211.68,
        projectedSalesAndMarketing: 258488.5,
        totalExpenses: 353877.48,
        projectedTotalExpenses: 343488.5,
        preMarketingEbitda: 1588089.14,
        projectedPreMarketingEbitda: 381692.91666667,
        ebitda: 1356877.46,
        projectedEbitda: 123204.41666667
    },
    {
        month: [
            "2024",
            "Dec"
        ],
        totalRevenue: null,
        projectedRevenue: 907702.75,
        grossMargin: null,
        projectedGrossMargin: 0.5141473,
        salesAndMarketing: null,
        projectedSalesAndMarketing: 258488.5,
        totalExpenses: null,
        projectedTotalExpenses: 343488.5,
        preMarketingEbitda: null,
        projectedPreMarketingEbitda: 381692.91666667,
        ebitda: null,
        projectedEbitda: 123204.41666667
    }
];
var $bd0f146e339e89ed$export$2e2bcd8739ae039 = $bd0f146e339e89ed$var$financialData;

});


parcelRegister("bUG4S", function(module, exports) {

$parcel$export(module.exports, "AssetProgression", () => $ce968dc5172afa13$export$57eef73da31e7704);

var $ayMG0 = parcelRequire("ayMG0");

var $Bq2gZ = parcelRequire("Bq2gZ");

var $cLcpc = parcelRequire("cLcpc");

var $jAiH0 = parcelRequire("jAiH0");

var $5CWLf = parcelRequire("5CWLf");

var $dfZUs = parcelRequire("dfZUs");
function $ce968dc5172afa13$export$57eef73da31e7704({ isCondensed: isCondensed, data: data }) {
    const { selectedPeriod: selectedPeriod, periodFilterProps: periodFilterProps } = (0, $dfZUs.usePeriodFilter)("monthly");
    const aggregatedData = (0, $5CWLf.aggregateChartData)(data || [], selectedPeriod.value, "assetProgression");
    const filteredData = (0, $jAiH0.filterNullValuesFromChartData)(aggregatedData);
    if (filteredData.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Bq2gZ.Chart), {
        title: "Asset Progression",
        description: "The company maintains strong liquidity and asset quality, with liquid assets consistently comprising a significant and growing portion of total assets. However, periods of negative or volatile swings in receivables and inventory point to potential operational inefficiencies or risks that warrant further investigation.",
        isCondensed: isCondensed,
        periodFilter: periodFilterProps,
        options: {
            data: filteredData,
            tooltip: {
                mode: "single"
            },
            series: [
                {
                    type: "line",
                    xKey: "month",
                    yKey: "totalAssets",
                    yName: "Total Assets",
                    marker: {
                        enabled: false
                    },
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            return {
                                heading: `${month}`,
                                title: "Total Assets (Financial Statements)",
                                data: [
                                    {
                                        label: "Total Assets (Financial Statements)",
                                        value: (0, $jAiH0.formatCurrency)(datum.totalAssets)
                                    },
                                    {
                                        label: "Current Assets (Financial Statements)",
                                        value: (0, $jAiH0.formatCurrency)(datum.currentAssets)
                                    },
                                    {
                                        label: "Total Non-Current Assets (Financial Statements)",
                                        value: (0, $jAiH0.formatCurrency)(datum.totalNoncurrentAssets)
                                    }
                                ]
                            };
                        }
                    }
                },
                {
                    type: "line",
                    xKey: "month",
                    yKey: "liquidAssets",
                    yName: "Liquid Assets",
                    marker: {
                        enabled: false
                    },
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            return {
                                heading: `${month}`,
                                title: "Liquid Assets (Financial Statements)",
                                data: [
                                    {
                                        label: "Liquid Assets (Financial Statements)",
                                        value: (0, $jAiH0.formatCurrency)(datum.liquidAssets)
                                    },
                                    {
                                        label: "Cash (Financial Statements)",
                                        value: (0, $jAiH0.formatCurrency)(datum.cash)
                                    },
                                    {
                                        label: "Total Receivables (Financial Statements)",
                                        value: (0, $jAiH0.formatCurrency)(datum.totalReceivables)
                                    },
                                    {
                                        label: "Total Inventory (Financial Statements)",
                                        value: (0, $jAiH0.formatCurrency)(datum.totalInventory)
                                    },
                                    {
                                        label: "Fixed Assets (Financial Statements)",
                                        value: (0, $jAiH0.formatCurrency)(datum.noncurrentAssetsPropertyPlantAndEquipment)
                                    }
                                ]
                            };
                        }
                    }
                }
            ],
            axes: [
                (0, $cLcpc.GroupedCategoryAxis).doubleDepth,
                {
                    ...(0, $cLcpc.MoneyAxis),
                    keys: [
                        "totalAssets",
                        "liquidAssets"
                    ]
                }
            ]
        }
    });
}

});
parcelRegister("Bq2gZ", function(module, exports) {

$parcel$export(module.exports, "Chart", () => $597f5d483b2a9e62$export$acaa6426d77a227e);

var $ayMG0 = parcelRequire("ayMG0");

var $6mtXm = parcelRequire("6mtXm");

var $56bIJ = parcelRequire("56bIJ");

var $1cW8h = parcelRequire("1cW8h");

var $f1q41 = parcelRequire("f1q41");

var $aD9oO = parcelRequire("aD9oO");
const $597f5d483b2a9e62$export$acaa6426d77a227e = ({ options: options, title: title, description: description, isCondensed: isCondensed = false, isSnapshot: isSnapshot = false, titleLink: titleLink, periodFilter: periodFilter, dateRangeFilter: dateRangeFilter, ...rest })=>{
    const series = (0, $1cW8h.default)(options.series);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aD9oO.ChartContainer), {
        title: title,
        description: description,
        isCondensed: isCondensed,
        isSnapshot: isSnapshot,
        titleLink: titleLink,
        periodFilter: periodFilter,
        dateRangeFilter: dateRangeFilter,
        children: ({ height: height })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6mtXm.AgCharts), {
                options: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({
                    theme: $56bIJ.theme,
                    padding: {
                        top: 12,
                        right: 4,
                        bottom: 12,
                        left: 4
                    },
                    legend: {
                        enabled: series && series.length > 1,
                        toggleSeries: true,
                        preventHidingAll: true,
                        position: "bottom"
                    },
                    zoom: {
                        enabled: true,
                        enableSelecting: true,
                        enableScrolling: false,
                        enableDoubleClickToReset: true,
                        axes: "xy",
                        panKey: "shift"
                    },
                    tooltip: {
                        mode: "shared",
                        showArrow: true
                    },
                    height: height,
                    annotations: {
                        enabled: true,
                        toolbar: {
                            enabled: false
                        }
                    }
                }, {
                    ...options,
                    series: series
                }),
                ...rest
            })
    });
};

});
parcelRegister("6mtXm", function(module, exports) {

$parcel$export(module.exports, "AgCharts", () => $00b1916ee31d5b6d$export$e93fe4969a168dc7);
// packages/ag-charts-react/src/index.ts

var $acw62 = parcelRequire("acw62");

var $iTJTu = parcelRequire("iTJTu");
function $00b1916ee31d5b6d$var$getOptions(options, containerRef) {
    return {
        ...options,
        container: containerRef.current
    };
}
function $00b1916ee31d5b6d$var$ChartWithConstructor(ctor, displayName) {
    const Component = (0, $acw62.forwardRef)(function AgChartsReact(props, ref) {
        const { options: options, style: style, className: className } = props;
        const containerRef = (0, $acw62.useRef)(null);
        const chartRef = (0, $acw62.useRef)();
        (0, $acw62.useLayoutEffect)(()=>{
            const chart = ctor($00b1916ee31d5b6d$var$getOptions(options, containerRef));
            chartRef.current = chart;
            return ()=>{
                chart.destroy();
            };
        }, []);
        const unsafeIsInitialMount = chartRef.current === void 0;
        (0, $acw62.useEffect)(()=>{
            if (!unsafeIsInitialMount) chartRef.current?.update($00b1916ee31d5b6d$var$getOptions(options, containerRef)).catch((e)=>console.error(e));
        }, [
            options
        ]);
        (0, $acw62.useImperativeHandle)(ref, ()=>chartRef.current, []);
        return (0, $acw62.useMemo)(()=>{
            return (0, $acw62.createElement)("div", {
                ref: containerRef,
                style: style,
                className: className
            });
        }, [
            style,
            className
        ]);
    });
    Component.displayName = displayName;
    return Component;
}
var $00b1916ee31d5b6d$export$e93fe4969a168dc7 = /* @__PURE__ */ $00b1916ee31d5b6d$var$ChartWithConstructor((options)=>(0, $iTJTu.AgCharts).create(options), "AgCharts");
var $00b1916ee31d5b6d$export$c0209ea23400f4e4 = /* @__PURE__ */ $00b1916ee31d5b6d$var$ChartWithConstructor((options)=>(0, $iTJTu.AgCharts).createFinancialChart(options), "AgFinancialCharts");
var $00b1916ee31d5b6d$export$ff2d3c6b7fa2bb63 = /* @__PURE__ */ $00b1916ee31d5b6d$var$ChartWithConstructor((options)=>(0, $iTJTu.AgCharts).createGauge(options), "AgGauge");

});
parcelRegister("iTJTu", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $d77b025aa58d633c$export$a4ad2735b021c132);
$parcel$export(module.exports, "setupCommunityModules", () => $d77b025aa58d633c$export$2f274d5ba325cdcd);
$parcel$export(module.exports, "AgErrorBarSupportedSeriesTypes", () => $d77b025aa58d633c$export$8d1e42e0e779ee56);
$parcel$export(module.exports, "AgCharts", () => $d77b025aa58d633c$export$e93fe4969a168dc7);
$parcel$export(module.exports, "_Scene", () => $d77b025aa58d633c$export$f88ced8f90c5ae15);
$parcel$export(module.exports, "_Theme", () => $d77b025aa58d633c$export$d23fb0bb3c916391);
$parcel$export(module.exports, "_Util", () => $d77b025aa58d633c$export$48e12db5e55fd3a3);
$parcel$export(module.exports, "_ModuleSupport", () => $d77b025aa58d633c$export$d0f5d10b4c7de308);
$parcel$export(module.exports, "_Widget", () => $d77b025aa58d633c$export$eef9cbc113745b73);

var $idDdm = parcelRequire("idDdm");
var $d77b025aa58d633c$var$__defProp = Object.defineProperty;
var $d77b025aa58d633c$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $d77b025aa58d633c$var$__export = (target, all)=>{
    for(var name in all)$d77b025aa58d633c$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $d77b025aa58d633c$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $d77b025aa58d633c$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $d77b025aa58d633c$var$__defProp(target, key, result);
    return result;
};
// packages/ag-charts-community/src/module/module.ts
var $d77b025aa58d633c$var$BaseModuleInstance = class {
    constructor(){
        this.destroyFns = [];
    }
    destroy() {
        for (const destroyFn of this.destroyFns)destroyFn();
    }
};
var $d77b025aa58d633c$var$ModuleRegistry = class {
    constructor(){
        this.modules = [];
        this.dependencies = /* @__PURE__ */ new Map();
        this.modulesByOptionKey = /* @__PURE__ */ new Map();
    }
    register(...modules) {
        for (const module of modules){
            this.registerDependencies(module);
            const otherModule = this.modules.find((other)=>module.type === other.type && ("optionsKey" in module && "optionsKey" in other ? module.optionsKey === other.optionsKey : true) && module.identifier === other.identifier);
            if (otherModule) {
                if (module.packageType === "enterprise" && otherModule.packageType === "community") {
                    const index = this.modules.indexOf(otherModule);
                    this.modules.splice(index, 1, module);
                    if ("optionsKey" in module) this.modulesByOptionKey.set(module.optionsKey, module);
                }
            } else {
                this.modules.push(module);
                if ("optionsKey" in module) this.modulesByOptionKey.set(module.optionsKey, module);
            }
        }
    }
    hasEnterpriseModules() {
        return this.modules.some((m)=>m.packageType === "enterprise");
    }
    *byType(...types) {
        const yielded = /* @__PURE__ */ new Set();
        const modulesByType = this.modules.filter((module)=>types.includes(module.type));
        const calculateDependencies = (module)=>{
            const deps = this.dependencies.get(module);
            return deps?.flatMap(calculateDependencies).concat(deps) ?? [];
        };
        const unresolvable = [];
        for (const module of modulesByType){
            const uniqueKey = "optionsKey" in module ? module.optionsKey : module.contextKey;
            if (yielded.has(uniqueKey)) continue;
            for (const dependency of calculateDependencies(uniqueKey)){
                if (yielded.has(dependency)) continue;
                const dependencyModule = this.modulesByOptionKey.get(dependency);
                if (!dependencyModule) {
                    unresolvable.push(dependency);
                    continue;
                }
                if (!types.includes(dependencyModule.type)) continue;
                yield dependencyModule;
                yielded.add(dependency);
            }
            yield module;
            yielded.add(uniqueKey);
        }
        if (unresolvable.length > 0) throw new Error(`Could not resolve module dependencies: ${unresolvable}`);
    }
    registerDependencies(module) {
        if (module.dependencies == null || module.dependencies.length === 0) return;
        const uniqueKey = "optionsKey" in module ? module.optionsKey : module.contextKey;
        this.dependencies.set(uniqueKey, module.dependencies);
    }
};
var $d77b025aa58d633c$var$moduleRegistry = new $d77b025aa58d633c$var$ModuleRegistry();
// packages/ag-charts-community/src/util/bboxinterface.ts
var $d77b025aa58d633c$var$BBoxValues = {
    containsPoint: $d77b025aa58d633c$var$containsPoint,
    equals: $d77b025aa58d633c$var$equals,
    isEmpty: $d77b025aa58d633c$var$isEmpty,
    normalize: $d77b025aa58d633c$var$normalize
};
function $d77b025aa58d633c$var$containsPoint(bbox, x, y) {
    return x >= bbox.x && x <= bbox.x + bbox.width && y >= bbox.y && y <= bbox.y + bbox.height;
}
function $d77b025aa58d633c$var$equals(lhs, rhs) {
    return lhs.x === rhs.x && lhs.y === rhs.y && lhs.width === rhs.width && lhs.height === rhs.height;
}
function $d77b025aa58d633c$var$isEmpty(bbox) {
    return bbox == null || bbox.height === 0 || bbox.width === 0 || isNaN(bbox.height) || isNaN(bbox.width);
}
function $d77b025aa58d633c$var$normalize(bbox) {
    let { x: x, y: y, width: width2, height: height2 } = bbox;
    if ((width2 == null || width2 > 0) && (height2 == null || height2 > 0)) return bbox;
    if (x != null && width2 != null && width2 < 0) {
        width2 = -width2;
        x = x - width2;
    }
    if (y != null && height2 != null && height2 < 0) {
        height2 = -height2;
        y = y - height2;
    }
    return {
        x: x,
        y: y,
        width: width2,
        height: height2
    };
}
// packages/ag-charts-community/src/util/interpolating.ts
var $d77b025aa58d633c$var$interpolate = Symbol("interpolate");
var $d77b025aa58d633c$var$isInterpolating = (x)=>x[$d77b025aa58d633c$var$interpolate] != null;
// packages/ag-charts-community/src/util/nearest.ts
function $d77b025aa58d633c$var$nearestSquared(x, y, objects, maxDistanceSquared = Infinity) {
    const result = {
        nearest: void 0,
        distanceSquared: maxDistanceSquared
    };
    for (const obj of objects){
        const thisDistance = obj.distanceSquared(x, y);
        if (thisDistance === 0) return {
            nearest: obj,
            distanceSquared: 0
        };
        else if (thisDistance < result.distanceSquared) {
            result.nearest = obj;
            result.distanceSquared = thisDistance;
        }
    }
    return result;
}
function $d77b025aa58d633c$var$nearestSquaredInContainer(x, y, container, maxDistanceSquared = Infinity) {
    const { x: tx = x, y: ty = y } = container.transformPoint?.(x, y) ?? {};
    const result = {
        nearest: void 0,
        distanceSquared: maxDistanceSquared
    };
    for (const child of container.children){
        const { nearest: nearest, distanceSquared: distanceSquared2 } = child.nearestSquared(tx, ty, result.distanceSquared);
        if (distanceSquared2 === 0) return {
            nearest: nearest,
            distanceSquared: distanceSquared2
        };
        else if (distanceSquared2 < result.distanceSquared) {
            result.nearest = nearest;
            result.distanceSquared = distanceSquared2;
        }
    }
    return result;
}
// packages/ag-charts-community/src/scene/bbox.ts
var $d77b025aa58d633c$var$_BBox = class _BBox {
    constructor(x, y, width2, height2){
        this.x = x;
        this.y = y;
        this.width = width2;
        this.height = height2;
    }
    static fromDOMRect({ x: x, y: y, width: width2, height: height2 }) {
        return new _BBox(x, y, width2, height2);
    }
    static merge(boxes) {
        let left = Infinity;
        let top = Infinity;
        let right = -Infinity;
        let bottom = -Infinity;
        for (const box of boxes){
            if (box.x < left) left = box.x;
            if (box.y < top) top = box.y;
            if (box.x + box.width > right) right = box.x + box.width;
            if (box.y + box.height > bottom) bottom = box.y + box.height;
        }
        return new _BBox(left, top, right - left, bottom - top);
    }
    static nearestBox(x, y, boxes) {
        return $d77b025aa58d633c$var$nearestSquared(x, y, boxes);
    }
    toDOMRect() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height,
            top: this.y,
            left: this.x,
            right: this.x + this.width,
            bottom: this.y + this.height,
            toJSON () {
                return {};
            }
        };
    }
    clone() {
        const { x: x, y: y, width: width2, height: height2 } = this;
        return new _BBox(x, y, width2, height2);
    }
    equals(other) {
        return $d77b025aa58d633c$var$BBoxValues.equals(this, other);
    }
    containsPoint(x, y) {
        return $d77b025aa58d633c$var$BBoxValues.containsPoint(this, x, y);
    }
    intersection(other) {
        if (!this.collidesBBox(other)) return;
        const newX1 = (0, $idDdm.clamp)(other.x, this.x, other.x + other.width);
        const newY1 = (0, $idDdm.clamp)(other.y, this.y, other.y + other.height);
        const newX2 = (0, $idDdm.clamp)(other.x, this.x + this.width, other.x + other.width);
        const newY2 = (0, $idDdm.clamp)(other.y, this.y + this.height, other.y + other.height);
        return new _BBox(newX1, newY1, newX2 - newX1, newY2 - newY1);
    }
    collidesBBox(other) {
        return this.x < other.x + other.width && this.x + this.width > other.x && this.y < other.y + other.height && this.y + this.height > other.y;
    }
    computeCenter() {
        return {
            x: this.x + this.width / 2,
            y: this.y + this.height / 2
        };
    }
    isFinite() {
        return Number.isFinite(this.x) && Number.isFinite(this.y) && Number.isFinite(this.width) && Number.isFinite(this.height);
    }
    distanceSquared(x, y) {
        if (this.containsPoint(x, y)) return 0;
        const dx = x - (0, $idDdm.clamp)(this.x, x, this.x + this.width);
        const dy = y - (0, $idDdm.clamp)(this.y, y, this.y + this.height);
        return dx * dx + dy * dy;
    }
    shrink(amount, position) {
        if (typeof amount === "number") this.applyMargin(amount, position);
        else for (const key of Object.keys(amount)){
            const value = amount[key];
            if (typeof value === "number") this.applyMargin(value, key);
        }
        if (this.width < 0) this.width = 0;
        if (this.height < 0) this.height = 0;
        return this;
    }
    grow(amount, position) {
        if (typeof amount === "number") this.applyMargin(-amount, position);
        else for (const key of Object.keys(amount)){
            const value = amount[key];
            if (typeof value === "number") this.applyMargin(-value, key);
        }
        return this;
    }
    applyMargin(value, position) {
        switch(position){
            case "top":
                this.y += value;
            case "bottom":
                this.height -= value;
                break;
            case "left":
                this.x += value;
            case "right":
                this.width -= value;
                break;
            case "vertical":
                this.y += value;
                this.height -= value * 2;
                break;
            case "horizontal":
                this.x += value;
                this.width -= value * 2;
                break;
            case void 0:
                this.x += value;
                this.y += value;
                this.width -= value * 2;
                this.height -= value * 2;
                break;
        }
    }
    translate(x, y) {
        this.x += x;
        this.y += y;
        return this;
    }
    [$d77b025aa58d633c$var$interpolate](other, d) {
        return new _BBox(this.x * (1 - d) + other.x * d, this.y * (1 - d) + other.y * d, this.width * (1 - d) + other.width * d, this.height * (1 - d) + other.height * d);
    }
};
$d77b025aa58d633c$var$_BBox.zero = Object.freeze(new $d77b025aa58d633c$var$_BBox(0, 0, 0, 0));
$d77b025aa58d633c$var$_BBox.NaN = Object.freeze(new $d77b025aa58d633c$var$_BBox(NaN, NaN, NaN, NaN));
var $d77b025aa58d633c$var$BBox = $d77b025aa58d633c$var$_BBox;
var $d77b025aa58d633c$var$LONG_TIME_PERIOD_THRESHOLD = 2e3;
var $d77b025aa58d633c$var$timeOfLastLog = Date.now();
var $d77b025aa58d633c$var$logTimeGap = ()=>{
    const timeSinceLastLog = Date.now() - $d77b025aa58d633c$var$timeOfLastLog;
    if (timeSinceLastLog > $d77b025aa58d633c$var$LONG_TIME_PERIOD_THRESHOLD) {
        const prettyDuration = (Math.floor(timeSinceLastLog / 100) / 10).toFixed(1);
        (0, $idDdm.Logger).log(`**** ${prettyDuration}s since last log message ****`);
    }
    $d77b025aa58d633c$var$timeOfLastLog = Date.now();
};
var $d77b025aa58d633c$var$Debug = {
    create (...debugSelectors) {
        const resultFn = (...logContent)=>{
            if ($d77b025aa58d633c$var$Debug.check(...debugSelectors)) {
                if (typeof logContent[0] === "function") logContent = (0, $idDdm.toArray)(logContent[0]());
                $d77b025aa58d633c$var$logTimeGap();
                (0, $idDdm.Logger).log(...logContent);
            }
        };
        return Object.assign(resultFn, {
            check: ()=>$d77b025aa58d633c$var$Debug.check(...debugSelectors),
            group: (name, cb)=>{
                if ($d77b025aa58d633c$var$Debug.check(...debugSelectors)) return (0, $idDdm.Logger).logGroup(name, cb);
                return cb();
            }
        });
    },
    check (...debugSelectors) {
        if (debugSelectors.length === 0) debugSelectors.push(true);
        const chartDebug = (0, $idDdm.toArray)((0, $idDdm.getWindow)("agChartsDebug"));
        return chartDebug.some((selector)=>debugSelectors.includes(selector));
    },
    inDevelopmentMode (fn) {
        if ($d77b025aa58d633c$var$Debug.check("dev")) return fn();
    }
};
// packages/ag-charts-community/src/scene/canvas/canvasUtil.ts
function $d77b025aa58d633c$var$clearContext({ context: context, pixelRatio: pixelRatio, width: width2, height: height2 }) {
    context.save();
    context.resetTransform();
    context.clearRect(0, 0, Math.ceil(width2 * pixelRatio), Math.ceil(height2 * pixelRatio));
    context.restore();
}
function $d77b025aa58d633c$var$debugContext(ctx) {
    if ($d77b025aa58d633c$var$Debug.check("canvas")) {
        const save = ctx.save.bind(ctx);
        const restore = ctx.restore.bind(ctx);
        let depth = 0;
        Object.assign(ctx, {
            save () {
                save();
                depth++;
            },
            restore () {
                if (depth === 0) throw new Error("AG Charts - Unable to restore() past depth 0");
                restore();
                depth--;
            },
            verifyDepthZero () {
                if (depth !== 0) throw new Error(`AG Charts - Save/restore depth is non-zero: ${depth}`);
            }
        });
    }
}
// packages/ag-charts-community/src/scene/canvas/hdpiOffscreenCanvas.ts
function $d77b025aa58d633c$var$canvasDimensions(width2, height2, pixelRatio) {
    return [
        Math.floor(width2 * pixelRatio),
        Math.floor(height2 * pixelRatio)
    ];
}
var $d77b025aa58d633c$var$HdpiOffscreenCanvas = class {
    constructor(options){
        const { width: width2, height: height2, pixelRatio: pixelRatio, willReadFrequently: willReadFrequently = false } = options;
        this.width = width2;
        this.height = height2;
        this.pixelRatio = pixelRatio;
        const [canvasWidth, canvasHeight] = $d77b025aa58d633c$var$canvasDimensions(width2, height2, pixelRatio);
        this.canvas = new OffscreenCanvas(canvasWidth, canvasHeight);
        this.context = this.canvas.getContext("2d", {
            willReadFrequently: willReadFrequently
        });
        this.context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        $d77b025aa58d633c$var$debugContext(this.context);
    }
    drawImage(context, dx = 0, dy = 0) {
        return context.drawImage(this.canvas, dx, dy);
    }
    transferToImageBitmap() {
        return this.canvas.transferToImageBitmap();
    }
    resize(width2, height2, pixelRatio) {
        if (!(width2 > 0 && height2 > 0)) return;
        const { canvas: canvas, context: context } = this;
        if (width2 !== this.width || height2 !== this.height || pixelRatio !== this.pixelRatio) {
            const [canvasWidth, canvasHeight] = $d77b025aa58d633c$var$canvasDimensions(width2, height2, pixelRatio);
            canvas.width = canvasWidth;
            canvas.height = canvasHeight;
        }
        context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        this.width = width2;
        this.height = height2;
        this.pixelRatio = pixelRatio;
    }
    clear() {
        $d77b025aa58d633c$var$clearContext(this);
    }
    destroy() {
        this.canvas.width = 0;
        this.canvas.height = 0;
        this.context.clearRect(0, 0, 0, 0);
        this.canvas = null;
        this.context = null;
        Object.freeze(this);
    }
};
// packages/ag-charts-community/src/util/decorator.ts
var $d77b025aa58d633c$var$BREAK_TRANSFORM_CHAIN = Symbol("BREAK");
var $d77b025aa58d633c$var$CONFIG_KEY = "__decorator_config";
var $d77b025aa58d633c$var$ACCESSORS_KEY = "__decorator_accessors";
function $d77b025aa58d633c$var$addFakeTransformToInstanceProperty(target, propertyKeyOrSymbol) {
    $d77b025aa58d633c$var$initialiseConfig(target, propertyKeyOrSymbol).optional = true;
}
function $d77b025aa58d633c$var$initialiseConfig(target, propertyKeyOrSymbol) {
    if (Object.getOwnPropertyDescriptor(target, $d77b025aa58d633c$var$CONFIG_KEY) == null) Object.defineProperty(target, $d77b025aa58d633c$var$CONFIG_KEY, {
        value: {}
    });
    if (Object.getOwnPropertyDescriptor(target, $d77b025aa58d633c$var$ACCESSORS_KEY) == null) {
        const parentAccessors = Object.getPrototypeOf(target)?.[$d77b025aa58d633c$var$ACCESSORS_KEY];
        const accessors = parentAccessors?.slice() ?? [];
        Object.defineProperty(target, $d77b025aa58d633c$var$ACCESSORS_KEY, {
            value: accessors
        });
    }
    const config = target[$d77b025aa58d633c$var$CONFIG_KEY];
    const propertyKey = propertyKeyOrSymbol.toString();
    if (config[propertyKey] != null) return config[propertyKey];
    config[propertyKey] = {
        setters: [],
        getters: [],
        observers: []
    };
    const descriptor = Object.getOwnPropertyDescriptor(target, propertyKeyOrSymbol);
    let prevGet = descriptor?.get;
    let prevSet = descriptor?.set;
    if (prevGet == null || prevSet == null) {
        const accessors = target[$d77b025aa58d633c$var$ACCESSORS_KEY];
        let index = accessors.indexOf(propertyKeyOrSymbol);
        if (index === -1) index = accessors.push(propertyKeyOrSymbol) - 1;
        prevGet ?? (prevGet = function() {
            let accessorValues = this.__accessors;
            if (accessorValues == null) {
                accessorValues = accessors.slice().fill(void 0);
                Object.defineProperty(this, "__accessors", {
                    value: accessorValues
                });
            }
            return accessorValues[index];
        });
        prevSet ?? (prevSet = function(value) {
            let accessorValues = this.__accessors;
            if (accessorValues == null) {
                accessorValues = accessors.slice().fill(void 0);
                Object.defineProperty(this, "__accessors", {
                    value: accessorValues
                });
            }
            accessorValues[index] = value;
        });
    }
    const getter = function() {
        let value = prevGet.call(this);
        for (const transformFn of config[propertyKey].getters){
            value = transformFn(this, propertyKeyOrSymbol, value);
            if (value === $d77b025aa58d633c$var$BREAK_TRANSFORM_CHAIN) return;
        }
        return value;
    };
    const setter = function(value) {
        const { setters: setters, observers: observers } = config[propertyKey];
        let oldValue;
        if (setters.some((f)=>f.length > 2)) oldValue = prevGet.call(this);
        for (const transformFn of setters){
            value = transformFn(this, propertyKeyOrSymbol, value, oldValue);
            if (value === $d77b025aa58d633c$var$BREAK_TRANSFORM_CHAIN) return;
        }
        prevSet.call(this, value);
        for (const observerFn of observers)observerFn(this, value, oldValue);
    };
    Object.defineProperty(target, propertyKeyOrSymbol, {
        set: setter,
        get: getter,
        enumerable: true,
        configurable: false
    });
    return config[propertyKey];
}
function $d77b025aa58d633c$var$addTransformToInstanceProperty(setTransform, getTransform, configMetadata) {
    return (target, propertyKeyOrSymbol)=>{
        const config = $d77b025aa58d633c$var$initialiseConfig(target, propertyKeyOrSymbol);
        config.setters.push(setTransform);
        if (getTransform) config.getters.unshift(getTransform);
        if (configMetadata) Object.assign(config, configMetadata);
    };
}
function $d77b025aa58d633c$var$addObserverToInstanceProperty(setObserver) {
    return (target, propertyKeyOrSymbol)=>{
        $d77b025aa58d633c$var$initialiseConfig(target, propertyKeyOrSymbol).observers.push(setObserver);
    };
}
function $d77b025aa58d633c$var$isDecoratedObject(target) {
    return typeof target !== "undefined" && $d77b025aa58d633c$var$CONFIG_KEY in target;
}
function $d77b025aa58d633c$var$listDecoratedProperties(target) {
    const targets = /* @__PURE__ */ new Set();
    while($d77b025aa58d633c$var$isDecoratedObject(target)){
        targets.add(target?.[$d77b025aa58d633c$var$CONFIG_KEY]);
        target = Object.getPrototypeOf(target);
    }
    return Array.from(targets).flatMap((configMap)=>Object.keys(configMap));
}
function $d77b025aa58d633c$var$extractDecoratedProperties(target) {
    return $d77b025aa58d633c$var$listDecoratedProperties(target).reduce((result, key)=>{
        result[key] = target[key] ?? null;
        return result;
    }, {});
}
// packages/ag-charts-community/src/util/object.ts
function $d77b025aa58d633c$var$objectsEqual(a, b) {
    if (Array.isArray(a)) {
        if (!Array.isArray(b)) return false;
        if (a.length !== b.length) return false;
        return a.every((av, i)=>$d77b025aa58d633c$var$objectsEqual(av, b[i]));
    } else if ((0, $idDdm.isPlainObject)(a)) {
        if (!(0, $idDdm.isPlainObject)(b)) return false;
        return $d77b025aa58d633c$var$objectsEqualWith(a, b, $d77b025aa58d633c$var$objectsEqual);
    }
    return a === b;
}
function $d77b025aa58d633c$var$objectsEqualWith(a, b, cmp2) {
    if (Object.is(a, b)) return true;
    for (const key of Object.keys(b)){
        if (!(key in a)) return false;
    }
    for (const key of Object.keys(a)){
        if (!(key in b)) return false;
        if (!cmp2(a[key], b[key])) return false;
    }
    return true;
}
function $d77b025aa58d633c$var$mergeDefaults(...sources) {
    const target = {};
    for (const source of sources){
        if (!(0, $idDdm.isObject)(source)) continue;
        const keys = $d77b025aa58d633c$var$isDecoratedObject(source) ? $d77b025aa58d633c$var$listDecoratedProperties(source) : Object.keys(source);
        for (const key of keys)if ((0, $idDdm.isPlainObject)(target[key]) && (0, $idDdm.isPlainObject)(source[key])) target[key] = $d77b025aa58d633c$var$mergeDefaults(target[key], source[key]);
        else target[key] ?? (target[key] = source[key]);
    }
    return target;
}
function $d77b025aa58d633c$var$merge(...sources) {
    const target = {};
    for (const source of sources){
        if (!(0, $idDdm.isObject)(source)) continue;
        const keys = $d77b025aa58d633c$var$isDecoratedObject(source) ? $d77b025aa58d633c$var$listDecoratedProperties(source) : Object.keys(source);
        for (const key of keys){
            if ((0, $idDdm.isPlainObject)(target[key]) && (0, $idDdm.isPlainObject)(source[key])) target[key] = $d77b025aa58d633c$var$merge(target[key], source[key]);
            else if (!(key in target)) target[key] ?? (target[key] = source[key]);
        }
    }
    return target;
}
function $d77b025aa58d633c$var$mergeArrayDefaults(dataArray, ...itemDefaults) {
    if (itemDefaults && (0, $idDdm.isArray)(dataArray)) return dataArray.map((item)=>$d77b025aa58d633c$var$mergeDefaults(item, ...itemDefaults));
    return dataArray;
}
function $d77b025aa58d633c$var$mapValues(object4, mapper) {
    const result = {};
    for (const [key, value] of (0, $idDdm.entries)(object4))result[key] = mapper(value, key, object4);
    return result;
}
function $d77b025aa58d633c$var$without(object4, keys) {
    const clone2 = {
        ...object4
    };
    for (const key of keys)delete clone2[key];
    return clone2;
}
function $d77b025aa58d633c$var$getPath(object4, path) {
    const pathArray = (0, $idDdm.isArray)(path) ? path : path.split(".");
    return pathArray.reduce((value, pathKey)=>value[pathKey], object4);
}
var $d77b025aa58d633c$var$SKIP_JS_BUILTINS = /* @__PURE__ */ new Set([
    "__proto__",
    "constructor",
    "prototype"
]);
function $d77b025aa58d633c$var$setPath(object4, path, newValue) {
    const pathArray = (0, $idDdm.isArray)(path) ? path.slice() : path.split(".");
    const lastKey = pathArray.pop();
    if (pathArray.some((p)=>$d77b025aa58d633c$var$SKIP_JS_BUILTINS.has(p))) return;
    const lastObject = pathArray.reduce((value, pathKey)=>value[pathKey], object4);
    lastObject[lastKey] = newValue;
    return lastObject[lastKey];
}
function $d77b025aa58d633c$var$partialAssign(keysToCopy, target, source) {
    if (source === void 0) return target;
    for (const key of keysToCopy){
        const value = source[key];
        if (value !== void 0) target[key] = value;
    }
    return target;
}
function $d77b025aa58d633c$var$deepFreeze(obj) {
    if (obj == null || typeof obj !== "object" || !(0, $idDdm.isPlainObject)(obj)) return obj;
    Object.freeze(obj);
    Object.getOwnPropertyNames(obj).forEach((prop)=>{
        const value = obj[prop];
        if (value !== null && (typeof value === "object" || typeof value === "function") && !Object.isFrozen(value)) $d77b025aa58d633c$var$deepFreeze(value);
    });
    return obj;
}
function $d77b025aa58d633c$var$isObjectWithProperty(obj, key) {
    return (0, $idDdm.isPlainObject)(obj) && key in obj;
}
function $d77b025aa58d633c$var$isObjectWithStringProperty(obj, key) {
    return $d77b025aa58d633c$var$isObjectWithProperty(obj, key) && typeof obj[key] === "string";
}
var $d77b025aa58d633c$var$TRIPLE_EQ = (lhs, rhs)=>lhs === rhs;
function $d77b025aa58d633c$var$SceneChangeDetection(opts) {
    return function(target, key) {
        const privateKey = `__${key}`;
        if (target[key]) return;
        $d77b025aa58d633c$var$prepareGetSet(target, key, privateKey, opts);
    };
}
function $d77b025aa58d633c$var$SceneObjectChangeDetection(opts) {
    return $d77b025aa58d633c$var$SceneChangeDetection(opts);
}
function $d77b025aa58d633c$var$SceneArrayChangeDetection(opts) {
    const baseOpts = opts ?? {};
    baseOpts.equals = (0, $idDdm.arraysEqual);
    return $d77b025aa58d633c$var$SceneChangeDetection(opts);
}
function $d77b025aa58d633c$var$prepareGetSet(target, key, privateKey, opts) {
    const { changeCb: changeCb, convertor: convertor, checkDirtyOnAssignment: checkDirtyOnAssignment = false } = opts ?? {};
    const requiredOpts = {
        changeCb: changeCb,
        checkDirtyOnAssignment: checkDirtyOnAssignment,
        convertor: convertor
    };
    const setter = $d77b025aa58d633c$var$buildCheckDirtyChain(privateKey, $d77b025aa58d633c$var$buildChangeCallbackChain($d77b025aa58d633c$var$buildConvertorChain($d77b025aa58d633c$var$buildSetter(privateKey, requiredOpts), requiredOpts), requiredOpts), requiredOpts);
    const getter = function() {
        return this[privateKey];
    };
    Object.defineProperty(target, key, {
        set: setter,
        get: getter,
        enumerable: true,
        configurable: true
    });
}
function $d77b025aa58d633c$var$buildConvertorChain(setterFn, opts) {
    const { convertor: convertor } = opts;
    if (convertor) return function(value) {
        setterFn.call(this, convertor(value));
    };
    return setterFn;
}
var $d77b025aa58d633c$var$NO_CHANGE = Symbol("no-change");
function $d77b025aa58d633c$var$buildChangeCallbackChain(setterFn, opts) {
    const { changeCb: changeCb } = opts;
    if (changeCb) return function(value) {
        const change = setterFn.call(this, value);
        if (change !== $d77b025aa58d633c$var$NO_CHANGE) changeCb.call(this, this);
        return change;
    };
    return setterFn;
}
function $d77b025aa58d633c$var$buildCheckDirtyChain(privateKey, setterFn, opts) {
    const { checkDirtyOnAssignment: checkDirtyOnAssignment } = opts;
    if (checkDirtyOnAssignment) return function(value) {
        const change = setterFn.call(this, value);
        if (value?._dirty === true) this.markDirty(privateKey);
        return change;
    };
    return setterFn;
}
function $d77b025aa58d633c$var$buildSetter(privateKey, opts) {
    const { equals: equals2 = $d77b025aa58d633c$var$TRIPLE_EQ } = opts;
    return function(value) {
        const oldValue = this[privateKey];
        if (!equals2(value, oldValue)) {
            this[privateKey] = value;
            this.onChangeDetection(privateKey);
            return value;
        }
        return $d77b025aa58d633c$var$NO_CHANGE;
    };
}
// packages/ag-charts-community/src/scene/node.ts
var $d77b025aa58d633c$var$PointerEvents = /* @__PURE__ */ ((PointerEvents2)=>{
    PointerEvents2[PointerEvents2["All"] = 0] = "All";
    PointerEvents2[PointerEvents2["None"] = 1] = "None";
    return PointerEvents2;
})($d77b025aa58d633c$var$PointerEvents || {});
var $d77b025aa58d633c$var$_Node = class _Node {
    constructor(options){
        /** Unique number to allow creation order to be easily determined. */ this.serialNumber = _Node._nextSerialNumber++;
        this.childNodeCounts = {
            groups: 0,
            nonGroups: 0,
            thisComplexity: 0,
            complexity: 0
        };
        /** Unique node ID in the form `ClassName-NaturalNumber`. */ this.id = (0, $idDdm.createId)(this);
        this.pointerEvents = 0 /* All */ ;
        this.scene = void 0;
        this._dirty = true;
        this.dirtyZIndex = false;
        /**
     * To simplify the type system (especially in Selections) we don't have the `Parent` node
     * (one that has children). Instead, we mimic HTML DOM, where any node can have children.
     * But we still need to distinguish regular leaf nodes from container leafs somehow.
     */ this.isContainerNode = false;
        this.visible = true;
        this.zIndex = 0;
        this.name = options?.name;
        this.tag = options?.tag ?? NaN;
        this.zIndex = options?.zIndex ?? 0;
        if (options?.debugDirty ?? _Node._debugEnabled) this._debugDirtyProperties = /* @__PURE__ */ new Map([
            [
                "__first__",
                []
            ]
        ]);
    }
    static toSVG(node, width2, height2) {
        const svg = node?.toSVG();
        if (svg == null || !svg.elements.length && !svg.defs?.length) return;
        const root = (0, $idDdm.createSvgElement)("svg");
        root.setAttribute("width", String(width2));
        root.setAttribute("height", String(height2));
        root.setAttribute("viewBox", `0 0 ${width2} ${height2}`);
        if (svg.defs?.length) {
            const defs = (0, $idDdm.createSvgElement)("defs");
            defs.append(...svg.defs);
            root.append(defs);
        }
        root.append(...svg.elements);
        return root.outerHTML;
    }
    static *extractBBoxes(nodes, skipInvisible) {
        for (const n of nodes)if (!skipInvisible || n.visible && !n.transitionOut) {
            const bbox = n.getBBox();
            if (bbox) yield bbox;
        }
    }
    /**
   * Some arbitrary data bound to the node.
   */ get datum() {
        return this._datum;
    }
    set datum(datum) {
        if (this._datum !== datum) {
            this._previousDatum = this._datum;
            this._datum = datum;
        }
    }
    get previousDatum() {
        return this._previousDatum;
    }
    get layerManager() {
        return this.scene?.layersManager;
    }
    get imageLoader() {
        return this.scene?.imageLoader;
    }
    get dirty() {
        return this._dirty;
    }
    closestDatum() {
        for (const { datum: datum } of this.traverseUp(true)){
            if (datum != null) return datum;
        }
    }
    /** Perform any pre-rendering initialization. */ preRender(renderCtx, thisComplexity = 1) {
        this.childNodeCounts.groups = 0;
        this.childNodeCounts.nonGroups = 1;
        this.childNodeCounts.complexity = thisComplexity;
        this.childNodeCounts.thisComplexity = thisComplexity;
        for (const child of this.children()){
            const childCounts = child.preRender(renderCtx);
            this.childNodeCounts.groups += childCounts.groups;
            this.childNodeCounts.nonGroups += childCounts.nonGroups;
            this.childNodeCounts.complexity += childCounts.complexity;
        }
        return this.childNodeCounts;
    }
    render(renderCtx) {
        const { stats: stats } = renderCtx;
        this._dirty = false;
        this.debugDirtyProperties();
        if (renderCtx.debugNodeSearch) {
            const idOrName = this.name ?? this.id;
            if (renderCtx.debugNodeSearch.some((v)=>typeof v === "string" ? v === idOrName : v.test(idOrName))) renderCtx.debugNodes[this.name ?? this.id] = this;
        }
        if (stats) {
            stats.nodesRendered++;
            stats.opsPerformed += this.childNodeCounts.thisComplexity;
        }
    }
    setScene(scene) {
        this.scene = scene;
        this._debug = scene?.layersManager?.debug;
        for (const child of this.children())child.setScene(scene);
    }
    sortChildren(compareFn) {
        this.dirtyZIndex = false;
        if (!this.childNodes) return;
        const sortedChildren = [
            ...this.childNodes
        ].sort(compareFn);
        this.childNodes.clear();
        for (const child of sortedChildren)this.childNodes.add(child);
    }
    *traverseUp(includeSelf) {
        let node = this;
        if (includeSelf) yield node;
        while(node = node.parentNode)yield node;
    }
    *children() {
        if (!this.childNodes) return;
        for (const child of this.childNodes)yield child;
    }
    *descendants() {
        for (const child of this.children()){
            yield child;
            yield* child.descendants();
        }
    }
    /**
   * Checks if the node is a leaf (has no children).
   */ isLeaf() {
        return !this.childNodes?.size;
    }
    /**
   * Checks if the node is the root (has no parent).
   */ isRoot() {
        return !this.parentNode;
    }
    /**
   * Appends one or more new node instances to this parent.
   * If one needs to:
   * - move a child to the end of the list of children
   * - move a child from one parent to another (including parents in other scenes)
   * one should use the {@link insertBefore} method instead.
   * @param nodes A node or nodes to append.
   */ append(nodes) {
        this.childNodes ?? (this.childNodes = /* @__PURE__ */ new Set());
        for (const node of (0, $idDdm.toIterable)(nodes)){
            node.parentNode?.removeChild(node);
            this.childNodes.add(node);
            node.parentNode = this;
            node.setScene(this.scene);
        }
        this.invalidateCachedBBox();
        this.dirtyZIndex = true;
        this.markDirty();
    }
    appendChild(node) {
        this.append(node);
        return node;
    }
    removeChild(node) {
        if (!this.childNodes?.delete(node)) throw new Error(`AG Charts - internal error, unknown child node ${node.name ?? node.id} in $${this.name ?? this.id}`);
        delete node.parentNode;
        node.setScene();
        this.invalidateCachedBBox();
        this.dirtyZIndex = true;
        this.markDirty();
    }
    remove() {
        this.parentNode?.removeChild(this);
    }
    clear() {
        for (const child of this.children()){
            delete child.parentNode;
            child.setScene();
        }
        this.childNodes?.clear();
        this.invalidateCachedBBox();
    }
    destroy() {
        this.parentNode?.removeChild(this);
    }
    setProperties(styles, pickKeys) {
        if (pickKeys) for (const key of pickKeys)this[key] = styles[key];
        else Object.assign(this, styles);
        return this;
    }
    containsPoint(_x, _y) {
        return false;
    }
    /**
   * Hit testing method.
   * Recursively checks if the given point is inside this node or any of its children.
   * Returns the first matching node or `undefined`.
   * Nodes that render later (show on top) are hit tested first.
   */ pickNode(x, y) {
        if (!this.visible || this.pointerEvents === 1 /* None */  || !this.containsPoint(x, y)) return;
        if (this.childNodes != null && this.childNodes.size !== 0) {
            const children = [
                ...this.children()
            ];
            for(let i = children.length - 1; i >= 0; i--){
                const hit = children[i].pickNode(x, y);
                if (hit) return hit;
            }
        } else if (!this.isContainerNode) return this;
    }
    pickNodes(x, y, into = []) {
        if (!this.visible || this.pointerEvents === 1 /* None */  || !this.containsPoint(x, y)) return into;
        if (!this.isContainerNode) into.push(this);
        for (const child of this.children())child.pickNodes(x, y, into);
        return into;
    }
    invalidateCachedBBox() {
        if (this.cachedBBox != null) {
            this.cachedBBox = void 0;
            this.parentNode?.invalidateCachedBBox();
        }
    }
    getBBox() {
        if (this.cachedBBox == null) this.cachedBBox = Object.freeze(this.computeBBox());
        return this.cachedBBox;
    }
    computeBBox() {
        return;
    }
    onChangeDetection(property) {
        this.markDirty(property);
    }
    markDirty(property) {
        const { _dirty: _dirty } = this;
        if (property != null && this._debugDirtyProperties) this.markDebugProperties(property);
        const noParentCachedBBox = this.cachedBBox == null;
        if (noParentCachedBBox && _dirty) return;
        this.invalidateCachedBBox();
        this._dirty = true;
        if (this.parentNode) this.parentNode.markDirty();
    }
    markClean() {
        if (!this._dirty) return;
        this._dirty = false;
        this.debugDirtyProperties();
        for (const child of this.children())child.markClean();
    }
    markDebugProperties(property) {
        const sources = this._debugDirtyProperties?.get(property) ?? [];
        const caller = new Error().stack?.split("\n").filter((line)=>{
            return line !== "Error" && !line.includes(".markDebugProperties") && !line.includes(".markDirty") && !line.includes("Object.assign ") && !line.includes(`${this.constructor.name}.`);
        }) ?? "unknown";
        sources.push(caller[0].replace(" at ", "").trim());
        this._debugDirtyProperties?.set(property, sources);
    }
    debugDirtyProperties() {
        if (this._debugDirtyProperties == null) return;
        if (!this._debugDirtyProperties.has("__first__")) this._debugDirtyProperties.forEach((sources, property)=>{
            if (sources.length > 1) {
                console.groupCollapsed(`Property changed multiple times before render: ${this.constructor.name}.${property} (${sources.length}x)`);
                sources.forEach((source)=>console.log(source));
                console.groupEnd();
            }
        });
        this._debugDirtyProperties.clear();
    }
    onZIndexChange() {
        const { parentNode: parentNode } = this;
        if (parentNode) parentNode.dirtyZIndex = true;
    }
    toSVG() {
        return;
    }
};
$d77b025aa58d633c$var$_Node._nextSerialNumber = 0;
// eslint-disable-next-line sonarjs/public-static-readonly
$d77b025aa58d633c$var$_Node._debugEnabled = false;
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Node.prototype, "visible", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneObjectChangeDetection({
        equals: $d77b025aa58d633c$var$objectsEqual,
        changeCb: (target)=>target.onZIndexChange()
    })
], $d77b025aa58d633c$var$_Node.prototype, "zIndex", 2);
var $d77b025aa58d633c$var$Node2 = $d77b025aa58d633c$var$_Node;
// packages/ag-charts-community/src/util/angle.ts
var $d77b025aa58d633c$var$twoPi = Math.PI * 2;
var $d77b025aa58d633c$var$halfPi = Math.PI / 2;
function $d77b025aa58d633c$var$normalizeAngle360(radians) {
    radians %= $d77b025aa58d633c$var$twoPi;
    radians += $d77b025aa58d633c$var$twoPi;
    radians %= $d77b025aa58d633c$var$twoPi;
    return radians;
}
function $d77b025aa58d633c$var$normalizeAngle360Inclusive(radians) {
    radians %= $d77b025aa58d633c$var$twoPi;
    radians += $d77b025aa58d633c$var$twoPi;
    if (radians !== $d77b025aa58d633c$var$twoPi) radians %= $d77b025aa58d633c$var$twoPi;
    return radians;
}
function $d77b025aa58d633c$var$normalizeAngle180(radians) {
    radians %= $d77b025aa58d633c$var$twoPi;
    if (radians < -Math.PI) radians += $d77b025aa58d633c$var$twoPi;
    else if (radians >= Math.PI) radians -= $d77b025aa58d633c$var$twoPi;
    return radians;
}
function $d77b025aa58d633c$var$isBetweenAngles(targetAngle, startAngle, endAngle) {
    const t = $d77b025aa58d633c$var$normalizeAngle360(targetAngle);
    const a0 = $d77b025aa58d633c$var$normalizeAngle360(startAngle);
    const a1 = $d77b025aa58d633c$var$normalizeAngle360(endAngle);
    if (a0 < a1) return a0 <= t && t <= a1;
    else if (a0 > a1) return a0 <= t || t <= a1;
    else return true;
}
function $d77b025aa58d633c$var$toRadians(degrees) {
    return degrees / 180 * Math.PI;
}
function $d77b025aa58d633c$var$toDegrees(radians) {
    return radians / Math.PI * 180;
}
function $d77b025aa58d633c$var$angleBetween(angle0, angle1) {
    angle0 = $d77b025aa58d633c$var$normalizeAngle360(angle0);
    angle1 = $d77b025aa58d633c$var$normalizeAngle360(angle1);
    return angle1 - angle0 + (angle0 > angle1 ? $d77b025aa58d633c$var$twoPi : 0);
}
function $d77b025aa58d633c$var$getAngleRatioRadians(angle2) {
    const normalizedAngle = $d77b025aa58d633c$var$normalizeAngle360(angle2);
    if (normalizedAngle <= $d77b025aa58d633c$var$halfPi) return normalizedAngle / $d77b025aa58d633c$var$halfPi;
    else if (normalizedAngle <= Math.PI) return (Math.PI - normalizedAngle) / $d77b025aa58d633c$var$halfPi;
    else if (normalizedAngle <= 1.5 * Math.PI) return (normalizedAngle - Math.PI) / $d77b025aa58d633c$var$halfPi;
    else return ($d77b025aa58d633c$var$twoPi - normalizedAngle) / $d77b025aa58d633c$var$halfPi;
}
function $d77b025aa58d633c$var$angularPadding(hPadding, vPadding, angle2) {
    const angleRatio = $d77b025aa58d633c$var$getAngleRatioRadians(angle2);
    return hPadding * angleRatio + vPadding * Math.abs(1 - angleRatio);
}
function $d77b025aa58d633c$var$normalizeAngle360FromDegrees(degrees) {
    return degrees ? $d77b025aa58d633c$var$normalizeAngle360($d77b025aa58d633c$var$toRadians(degrees)) : 0;
}
var $d77b025aa58d633c$var$lerp = (x, y, t)=>x * (1 - t) + y * t;
var $d77b025aa58d633c$var$srgbToLinear = (value)=>{
    const sign = value < 0 ? -1 : 1;
    const abs = Math.abs(value);
    if (abs <= 0.04045) return value / 12.92;
    return sign * ((abs + 0.055) / 1.055) ** 2.4;
};
var $d77b025aa58d633c$var$srgbFromLinear = (value)=>{
    const sign = value < 0 ? -1 : 1;
    const abs = Math.abs(value);
    if (abs > 31308e-7) return sign * (1.055 * abs ** (1 / 2.4) - 0.055);
    return 12.92 * value;
};
var $d77b025aa58d633c$var$_Color = class _Color {
    /**
   * Every color component should be in the [0, 1] range.
   * Some easing functions (such as elastic easing) can overshoot the target value by some amount.
   * So, when animating colors, if the source or target color components are already near
   * or at the edge of the allowed [0, 1] range, it is possible for the intermediate color
   * component value to end up outside of that range mid-animation. For this reason the constructor
   * performs range checking/constraining.
   * @param r Red component.
   * @param g Green component.
   * @param b Blue component.
   * @param a Alpha (opacity) component.
   */ constructor(r, g, b, a = 1){
        this.r = (0, $idDdm.clamp)(0, r || 0, 1);
        this.g = (0, $idDdm.clamp)(0, g || 0, 1);
        this.b = (0, $idDdm.clamp)(0, b || 0, 1);
        this.a = (0, $idDdm.clamp)(0, a || 0, 1);
    }
    /**
   * A color string can be in one of the following formats to be valid:
   * - #rgb
   * - #rrggbb
   * - rgb(r, g, b)
   * - rgba(r, g, b, a)
   * - CSS color name such as 'white', 'orange', 'cyan', etc.
   */ static validColorString(str) {
        if (str.indexOf("#") >= 0) return !!_Color.parseHex(str);
        if (str.indexOf("rgb") >= 0) return !!_Color.stringToRgba(str);
        return _Color.nameToHex.has(str.toLowerCase());
    }
    /**
   * The given string can be in one of the following formats:
   * - #rgb
   * - #rrggbb
   * - rgb(r, g, b)
   * - rgba(r, g, b, a)
   * - CSS color name such as 'white', 'orange', 'cyan', etc.
   * @param str
   */ static fromString(str) {
        if (str.indexOf("#") >= 0) return _Color.fromHexString(str);
        const hex = _Color.nameToHex.get(str.toLowerCase());
        if (hex) return _Color.fromHexString(hex);
        if (str.indexOf("rgb") >= 0) return _Color.fromRgbaString(str);
        throw new Error(`Invalid color string: '${str}'`);
    }
    // See https://drafts.csswg.org/css-color/#hex-notation
    static parseHex(input) {
        input = input.replace(/ /g, "").slice(1);
        let parts;
        switch(input.length){
            case 6:
            case 8:
                parts = [];
                for(let i = 0; i < input.length; i += 2)parts.push(parseInt(`${input[i]}${input[i + 1]}`, 16));
                break;
            case 3:
            case 4:
                parts = input.split("").map((p)=>parseInt(p, 16)).map((p)=>p + p * 16);
                break;
        }
        if (parts?.length >= 3 && parts.every((p)=>p >= 0)) {
            if (parts.length === 3) parts.push(255);
            return parts;
        }
    }
    static fromHexString(str) {
        const values = _Color.parseHex(str);
        if (values) {
            const [r, g, b, a] = values;
            return new _Color(r / 255, g / 255, b / 255, a / 255);
        }
        throw new Error(`Malformed hexadecimal color string: '${str}'`);
    }
    static stringToRgba(str) {
        let po = -1;
        let pc = -1;
        for(let i = 0; i < str.length; i++){
            const c = str[i];
            if (po === -1 && c === "(") po = i;
            else if (c === ")") {
                pc = i;
                break;
            }
        }
        if (po === -1 || pc === -1) return;
        const contents = str.substring(po + 1, pc);
        const parts = contents.split(",");
        const rgba = [];
        for(let i = 0; i < parts.length; i++){
            const part = parts[i];
            let value = parseFloat(part);
            if (!Number.isFinite(value)) return;
            if (part.indexOf("%") >= 0) {
                value = (0, $idDdm.clamp)(0, value, 100);
                value /= 100;
            } else if (i === 3) value = (0, $idDdm.clamp)(0, value, 1);
            else {
                value = (0, $idDdm.clamp)(0, value, 255);
                value /= 255;
            }
            rgba.push(value);
        }
        return rgba;
    }
    static fromRgbaString(str) {
        const rgba = _Color.stringToRgba(str);
        if (rgba) {
            if (rgba.length === 3) return new _Color(rgba[0], rgba[1], rgba[2]);
            else if (rgba.length === 4) return new _Color(rgba[0], rgba[1], rgba[2], rgba[3]);
        }
        throw new Error(`Malformed rgb/rgba color string: '${str}'`);
    }
    static fromArray(arr) {
        if (arr.length === 4) return new _Color(arr[0], arr[1], arr[2], arr[3]);
        if (arr.length === 3) return new _Color(arr[0], arr[1], arr[2]);
        throw new Error("The given array should contain 3 or 4 color components (numbers).");
    }
    static fromHSB(h, s, b, alpha = 1) {
        const rgb = _Color.HSBtoRGB(h, s, b);
        return new _Color(rgb[0], rgb[1], rgb[2], alpha);
    }
    static fromHSL(h, s, l, alpha = 1) {
        const rgb = _Color.HSLtoRGB(h, s, l);
        return new _Color(rgb[0], rgb[1], rgb[2], alpha);
    }
    static fromOKLCH(l, c, h, alpha = 1) {
        const rgb = _Color.OKLCHtoRGB(l, c, h);
        return new _Color(rgb[0], rgb[1], rgb[2], alpha);
    }
    static padHex(str) {
        return str.length === 1 ? "0" + str : str;
    }
    toHexString() {
        let hex = "#" + _Color.padHex(Math.round(this.r * 255).toString(16)) + _Color.padHex(Math.round(this.g * 255).toString(16)) + _Color.padHex(Math.round(this.b * 255).toString(16));
        if (this.a < 1) hex += _Color.padHex(Math.round(this.a * 255).toString(16));
        return hex;
    }
    toRgbaString(fractionDigits = 3) {
        const components = [
            Math.round(this.r * 255),
            Math.round(this.g * 255),
            Math.round(this.b * 255)
        ];
        const k = Math.pow(10, fractionDigits);
        if (this.a !== 1) {
            components.push(Math.round(this.a * k) / k);
            return `rgba(${components.join(", ")})`;
        }
        return `rgb(${components.join(", ")})`;
    }
    toString() {
        if (this.a === 1) return this.toHexString();
        return this.toRgbaString();
    }
    toHSB() {
        return _Color.RGBtoHSB(this.r, this.g, this.b);
    }
    static RGBtoOKLCH(r, g, b) {
        const LSRGB0 = $d77b025aa58d633c$var$srgbToLinear(r);
        const LSRGB1 = $d77b025aa58d633c$var$srgbToLinear(g);
        const LSRGB2 = $d77b025aa58d633c$var$srgbToLinear(b);
        const LMS0 = Math.cbrt(0.4122214708 * LSRGB0 + 0.5363325363 * LSRGB1 + 0.0514459929 * LSRGB2);
        const LMS1 = Math.cbrt(0.2119034982 * LSRGB0 + 0.6806995451 * LSRGB1 + 0.1073969566 * LSRGB2);
        const LMS2 = Math.cbrt(0.0883024619 * LSRGB0 + 0.2817188376 * LSRGB1 + 0.6299787005 * LSRGB2);
        const OKLAB0 = 0.2104542553 * LMS0 + 0.793617785 * LMS1 - 0.0040720468 * LMS2;
        const OKLAB1 = 1.9779984951 * LMS0 - 2.428592205 * LMS1 + 0.4505937099 * LMS2;
        const OKLAB2 = 0.0259040371 * LMS0 + 0.7827717662 * LMS1 - 0.808675766 * LMS2;
        const hue = Math.atan2(OKLAB2, OKLAB1) * 180 / Math.PI;
        const OKLCH0 = OKLAB0;
        const OKLCH1 = Math.hypot(OKLAB1, OKLAB2);
        const OKLCH2 = hue >= 0 ? hue : hue + 360;
        return [
            OKLCH0,
            OKLCH1,
            OKLCH2
        ];
    }
    static OKLCHtoRGB(l, c, h) {
        const OKLAB0 = l;
        const OKLAB1 = c * Math.cos(h * Math.PI / 180);
        const OKLAB2 = c * Math.sin(h * Math.PI / 180);
        const LMS0 = (OKLAB0 + 0.3963377774 * OKLAB1 + 0.2158037573 * OKLAB2) ** 3;
        const LMS1 = (OKLAB0 - 0.1055613458 * OKLAB1 - 0.0638541728 * OKLAB2) ** 3;
        const LMS2 = (OKLAB0 - 0.0894841775 * OKLAB1 - 1.291485548 * OKLAB2) ** 3;
        const LSRGB0 = 4.0767416621 * LMS0 - 3.3077115913 * LMS1 + 0.2309699292 * LMS2;
        const LSRGB1 = -1.2684380046 * LMS0 + 2.6097574011 * LMS1 - 0.3413193965 * LMS2;
        const LSRGB2 = -0.0041960863 * LMS0 - 0.7034186147 * LMS1 + 1.707614701 * LMS2;
        const SRGB0 = $d77b025aa58d633c$var$srgbFromLinear(LSRGB0);
        const SRGB1 = $d77b025aa58d633c$var$srgbFromLinear(LSRGB1);
        const SRGB2 = $d77b025aa58d633c$var$srgbFromLinear(LSRGB2);
        return [
            SRGB0,
            SRGB1,
            SRGB2
        ];
    }
    static RGBtoHSL(r, g, b) {
        const min = Math.min(r, g, b);
        const max = Math.max(r, g, b);
        const l = (max + min) / 2;
        let h;
        let s;
        if (max === min) {
            h = 0;
            s = 0;
        } else {
            const delta3 = max - min;
            s = l > 0.5 ? delta3 / (2 - max - min) : delta3 / (max + min);
            if (max === r) h = (g - b) / delta3 + (g < b ? 6 : 0);
            else if (max === g) h = (b - r) / delta3 + 2;
            else h = (r - g) / delta3 + 4;
            h *= 60;
        }
        return [
            h,
            s,
            l
        ];
    }
    static HSLtoRGB(h, s, l) {
        h = (h % 360 + 360) % 360;
        if (s === 0) return [
            l,
            l,
            l
        ];
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        function hueToRgb(t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        const r = hueToRgb(h / 360 + 1 / 3);
        const g = hueToRgb(h / 360);
        const b = hueToRgb(h / 360 - 1 / 3);
        return [
            r,
            g,
            b
        ];
    }
    /**
   * Converts the given RGB triple to an array of HSB (HSV) components.
   */ static RGBtoHSB(r, g, b) {
        const min = Math.min(r, g, b);
        const max = Math.max(r, g, b);
        const S = max === 0 ? 0 : (max - min) / max;
        let H = 0;
        if (min !== max) {
            const delta3 = max - min;
            const rc = (max - r) / delta3;
            const gc = (max - g) / delta3;
            const bc = (max - b) / delta3;
            if (r === max) H = bc - gc;
            else if (g === max) H = 2 + rc - bc;
            else H = 4 + gc - rc;
            H /= 6;
            if (H < 0) H = H + 1;
        }
        return [
            H * 360,
            S,
            max
        ];
    }
    /**
   * Converts the given HSB (HSV) triple to an array of RGB components.
   */ static HSBtoRGB(H, S, B) {
        H = (H % 360 + 360) % 360 / 360;
        let r = 0;
        let g = 0;
        let b = 0;
        if (S === 0) r = g = b = B;
        else {
            const h = (H - Math.floor(H)) * 6;
            const f = h - Math.floor(h);
            const p = B * (1 - S);
            const q = B * (1 - S * f);
            const t = B * (1 - S * (1 - f));
            switch(h >> 0){
                case 0:
                    r = B;
                    g = t;
                    b = p;
                    break;
                case 1:
                    r = q;
                    g = B;
                    b = p;
                    break;
                case 2:
                    r = p;
                    g = B;
                    b = t;
                    break;
                case 3:
                    r = p;
                    g = q;
                    b = B;
                    break;
                case 4:
                    r = t;
                    g = p;
                    b = B;
                    break;
                case 5:
                    r = B;
                    g = p;
                    b = q;
                    break;
            }
        }
        return [
            r,
            g,
            b
        ];
    }
    static mix(c0, c1, t) {
        return new _Color($d77b025aa58d633c$var$lerp(c0.r, c1.r, t), $d77b025aa58d633c$var$lerp(c0.g, c1.g, t), $d77b025aa58d633c$var$lerp(c0.b, c1.b, t), $d77b025aa58d633c$var$lerp(c0.a, c1.a, t));
    }
    static lighten(c, t) {
        const oklch = _Color.RGBtoOKLCH(c.r, c.g, c.b);
        return _Color.fromOKLCH((0, $idDdm.clamp)(0, oklch[0] + t, 1), oklch[1], oklch[2]);
    }
    static darken(c, t) {
        const oklch = _Color.RGBtoOKLCH(c.r, c.g, c.b);
        return _Color.fromOKLCH((0, $idDdm.clamp)(0, oklch[0] - t, 1), oklch[1], oklch[2]);
    }
    static interpolate(colors, count) {
        const step = 1 / (colors.length - 1);
        const oklchColors = colors.map((c)=>_Color.RGBtoOKLCH(c.r, c.g, c.b));
        return Array.from({
            length: count
        }, (_, i)=>{
            const t = i / (count - 1);
            const index = colors.length <= 2 ? 0 : Math.min(Math.floor(t * (colors.length - 1)), colors.length - 2);
            const q = (t - index * step) / step;
            const c0 = oklchColors[index];
            const c1 = oklchColors[index + 1];
            return _Color.fromOKLCH($d77b025aa58d633c$var$lerp(c0[0], c1[0], q), $d77b025aa58d633c$var$lerp(c0[1], c1[1], q), $d77b025aa58d633c$var$lerp(c0[2], c1[2], q));
        });
    }
};
/**
 * CSS Color Module Level 4:
 * https://drafts.csswg.org/css-color/#named-colors
 */ $d77b025aa58d633c$var$_Color.nameToHex = /* @__PURE__ */ new Map([
    [
        "aliceblue",
        "#F0F8FF"
    ],
    [
        "antiquewhite",
        "#FAEBD7"
    ],
    [
        "aqua",
        "#00FFFF"
    ],
    [
        "aquamarine",
        "#7FFFD4"
    ],
    [
        "azure",
        "#F0FFFF"
    ],
    [
        "beige",
        "#F5F5DC"
    ],
    [
        "bisque",
        "#FFE4C4"
    ],
    [
        "black",
        "#000000"
    ],
    [
        "blanchedalmond",
        "#FFEBCD"
    ],
    [
        "blue",
        "#0000FF"
    ],
    [
        "blueviolet",
        "#8A2BE2"
    ],
    [
        "brown",
        "#A52A2A"
    ],
    [
        "burlywood",
        "#DEB887"
    ],
    [
        "cadetblue",
        "#5F9EA0"
    ],
    [
        "chartreuse",
        "#7FFF00"
    ],
    [
        "chocolate",
        "#D2691E"
    ],
    [
        "coral",
        "#FF7F50"
    ],
    [
        "cornflowerblue",
        "#6495ED"
    ],
    [
        "cornsilk",
        "#FFF8DC"
    ],
    [
        "crimson",
        "#DC143C"
    ],
    [
        "cyan",
        "#00FFFF"
    ],
    [
        "darkblue",
        "#00008B"
    ],
    [
        "darkcyan",
        "#008B8B"
    ],
    [
        "darkgoldenrod",
        "#B8860B"
    ],
    [
        "darkgray",
        "#A9A9A9"
    ],
    [
        "darkgreen",
        "#006400"
    ],
    [
        "darkgrey",
        "#A9A9A9"
    ],
    [
        "darkkhaki",
        "#BDB76B"
    ],
    [
        "darkmagenta",
        "#8B008B"
    ],
    [
        "darkolivegreen",
        "#556B2F"
    ],
    [
        "darkorange",
        "#FF8C00"
    ],
    [
        "darkorchid",
        "#9932CC"
    ],
    [
        "darkred",
        "#8B0000"
    ],
    [
        "darksalmon",
        "#E9967A"
    ],
    [
        "darkseagreen",
        "#8FBC8F"
    ],
    [
        "darkslateblue",
        "#483D8B"
    ],
    [
        "darkslategray",
        "#2F4F4F"
    ],
    [
        "darkslategrey",
        "#2F4F4F"
    ],
    [
        "darkturquoise",
        "#00CED1"
    ],
    [
        "darkviolet",
        "#9400D3"
    ],
    [
        "deeppink",
        "#FF1493"
    ],
    [
        "deepskyblue",
        "#00BFFF"
    ],
    [
        "dimgray",
        "#696969"
    ],
    [
        "dimgrey",
        "#696969"
    ],
    [
        "dodgerblue",
        "#1E90FF"
    ],
    [
        "firebrick",
        "#B22222"
    ],
    [
        "floralwhite",
        "#FFFAF0"
    ],
    [
        "forestgreen",
        "#228B22"
    ],
    [
        "fuchsia",
        "#FF00FF"
    ],
    [
        "gainsboro",
        "#DCDCDC"
    ],
    [
        "ghostwhite",
        "#F8F8FF"
    ],
    [
        "gold",
        "#FFD700"
    ],
    [
        "goldenrod",
        "#DAA520"
    ],
    [
        "gray",
        "#808080"
    ],
    [
        "green",
        "#008000"
    ],
    [
        "greenyellow",
        "#ADFF2F"
    ],
    [
        "grey",
        "#808080"
    ],
    [
        "honeydew",
        "#F0FFF0"
    ],
    [
        "hotpink",
        "#FF69B4"
    ],
    [
        "indianred",
        "#CD5C5C"
    ],
    [
        "indigo",
        "#4B0082"
    ],
    [
        "ivory",
        "#FFFFF0"
    ],
    [
        "khaki",
        "#F0E68C"
    ],
    [
        "lavender",
        "#E6E6FA"
    ],
    [
        "lavenderblush",
        "#FFF0F5"
    ],
    [
        "lawngreen",
        "#7CFC00"
    ],
    [
        "lemonchiffon",
        "#FFFACD"
    ],
    [
        "lightblue",
        "#ADD8E6"
    ],
    [
        "lightcoral",
        "#F08080"
    ],
    [
        "lightcyan",
        "#E0FFFF"
    ],
    [
        "lightgoldenrodyellow",
        "#FAFAD2"
    ],
    [
        "lightgray",
        "#D3D3D3"
    ],
    [
        "lightgreen",
        "#90EE90"
    ],
    [
        "lightgrey",
        "#D3D3D3"
    ],
    [
        "lightpink",
        "#FFB6C1"
    ],
    [
        "lightsalmon",
        "#FFA07A"
    ],
    [
        "lightseagreen",
        "#20B2AA"
    ],
    [
        "lightskyblue",
        "#87CEFA"
    ],
    [
        "lightslategray",
        "#778899"
    ],
    [
        "lightslategrey",
        "#778899"
    ],
    [
        "lightsteelblue",
        "#B0C4DE"
    ],
    [
        "lightyellow",
        "#FFFFE0"
    ],
    [
        "lime",
        "#00FF00"
    ],
    [
        "limegreen",
        "#32CD32"
    ],
    [
        "linen",
        "#FAF0E6"
    ],
    [
        "magenta",
        "#FF00FF"
    ],
    [
        "maroon",
        "#800000"
    ],
    [
        "mediumaquamarine",
        "#66CDAA"
    ],
    [
        "mediumblue",
        "#0000CD"
    ],
    [
        "mediumorchid",
        "#BA55D3"
    ],
    [
        "mediumpurple",
        "#9370DB"
    ],
    [
        "mediumseagreen",
        "#3CB371"
    ],
    [
        "mediumslateblue",
        "#7B68EE"
    ],
    [
        "mediumspringgreen",
        "#00FA9A"
    ],
    [
        "mediumturquoise",
        "#48D1CC"
    ],
    [
        "mediumvioletred",
        "#C71585"
    ],
    [
        "midnightblue",
        "#191970"
    ],
    [
        "mintcream",
        "#F5FFFA"
    ],
    [
        "mistyrose",
        "#FFE4E1"
    ],
    [
        "moccasin",
        "#FFE4B5"
    ],
    [
        "navajowhite",
        "#FFDEAD"
    ],
    [
        "navy",
        "#000080"
    ],
    [
        "oldlace",
        "#FDF5E6"
    ],
    [
        "olive",
        "#808000"
    ],
    [
        "olivedrab",
        "#6B8E23"
    ],
    [
        "orange",
        "#FFA500"
    ],
    [
        "orangered",
        "#FF4500"
    ],
    [
        "orchid",
        "#DA70D6"
    ],
    [
        "palegoldenrod",
        "#EEE8AA"
    ],
    [
        "palegreen",
        "#98FB98"
    ],
    [
        "paleturquoise",
        "#AFEEEE"
    ],
    [
        "palevioletred",
        "#DB7093"
    ],
    [
        "papayawhip",
        "#FFEFD5"
    ],
    [
        "peachpuff",
        "#FFDAB9"
    ],
    [
        "peru",
        "#CD853F"
    ],
    [
        "pink",
        "#FFC0CB"
    ],
    [
        "plum",
        "#DDA0DD"
    ],
    [
        "powderblue",
        "#B0E0E6"
    ],
    [
        "purple",
        "#800080"
    ],
    [
        "rebeccapurple",
        "#663399"
    ],
    [
        "red",
        "#FF0000"
    ],
    [
        "rosybrown",
        "#BC8F8F"
    ],
    [
        "royalblue",
        "#4169E1"
    ],
    [
        "saddlebrown",
        "#8B4513"
    ],
    [
        "salmon",
        "#FA8072"
    ],
    [
        "sandybrown",
        "#F4A460"
    ],
    [
        "seagreen",
        "#2E8B57"
    ],
    [
        "seashell",
        "#FFF5EE"
    ],
    [
        "sienna",
        "#A0522D"
    ],
    [
        "silver",
        "#C0C0C0"
    ],
    [
        "skyblue",
        "#87CEEB"
    ],
    [
        "slateblue",
        "#6A5ACD"
    ],
    [
        "slategray",
        "#708090"
    ],
    [
        "slategrey",
        "#708090"
    ],
    [
        "snow",
        "#FFFAFA"
    ],
    [
        "springgreen",
        "#00FF7F"
    ],
    [
        "steelblue",
        "#4682B4"
    ],
    [
        "tan",
        "#D2B48C"
    ],
    [
        "teal",
        "#008080"
    ],
    [
        "thistle",
        "#D8BFD8"
    ],
    [
        "tomato",
        "#FF6347"
    ],
    [
        "transparent",
        "#00000000"
    ],
    [
        "turquoise",
        "#40E0D0"
    ],
    [
        "violet",
        "#EE82EE"
    ],
    [
        "wheat",
        "#F5DEB3"
    ],
    [
        "white",
        "#FFFFFF"
    ],
    [
        "whitesmoke",
        "#F5F5F5"
    ],
    [
        "yellow",
        "#FFFF00"
    ],
    [
        "yellowgreen",
        "#9ACD32"
    ]
]);
var $d77b025aa58d633c$var$Color = $d77b025aa58d633c$var$_Color;
// packages/ag-charts-community/src/scale/abstractScale.ts
var $d77b025aa58d633c$var$AbstractScale = class {
    ticks(_ticks, _domain, _visibleRange) {
        return void 0;
    }
    niceDomain(_ticks, domain = this.domain) {
        return domain;
    }
    tickFormatter(_params) {
        return void 0;
    }
    datumFormatter(_params) {
        return void 0;
    }
    get bandwidth() {
        return void 0;
    }
    get step() {
        return void 0;
    }
    get inset() {
        return void 0;
    }
};
// packages/ag-charts-community/src/scale/invalidating.ts
var $d77b025aa58d633c$var$Invalidating = (target, propertyKey)=>{
    const mappedProperty = Symbol(String(propertyKey));
    target[mappedProperty] = void 0;
    Object.defineProperty(target, propertyKey, {
        get () {
            return this[mappedProperty];
        },
        set (newValue) {
            const oldValue = this[mappedProperty];
            if (oldValue !== newValue) {
                this[mappedProperty] = newValue;
                this.invalid = true;
            }
        },
        enumerable: true,
        configurable: false
    });
};
// packages/ag-charts-community/src/scale/colorScale.ts
var $d77b025aa58d633c$var$convertColorStringToOklcha = (v)=>{
    const color11 = $d77b025aa58d633c$var$Color.fromString(v);
    const [l, c, h] = $d77b025aa58d633c$var$Color.RGBtoOKLCH(color11.r, color11.g, color11.b);
    return {
        l: l,
        c: c,
        h: h,
        a: color11.a
    };
};
var $d77b025aa58d633c$var$delta = 1e-6;
var $d77b025aa58d633c$var$isAchromatic = (x)=>x.c < $d77b025aa58d633c$var$delta || x.l < $d77b025aa58d633c$var$delta || x.l > 1 - $d77b025aa58d633c$var$delta;
var $d77b025aa58d633c$var$interpolateOklch = (x, y, d)=>{
    d = (0, $idDdm.clamp)(0, d, 1);
    let h;
    if ($d77b025aa58d633c$var$isAchromatic(x)) h = y.h;
    else if ($d77b025aa58d633c$var$isAchromatic(y)) h = x.h;
    else {
        const xH = x.h;
        let yH = y.h;
        const deltaH = y.h - x.h;
        if (deltaH > 180) yH -= 360;
        else if (deltaH < -180) yH += 360;
        h = xH * (1 - d) + yH * d;
    }
    const c = x.c * (1 - d) + y.c * d;
    const l = x.l * (1 - d) + y.l * d;
    const a = x.a * (1 - d) + y.a * d;
    return $d77b025aa58d633c$var$Color.fromOKLCH(l, c, h, a);
};
var $d77b025aa58d633c$var$ColorScale = class extends $d77b025aa58d633c$var$AbstractScale {
    constructor(){
        super(...arguments);
        this.type = "color";
        this.invalid = true;
        this.domain = [
            0,
            1
        ];
        this.range = [
            "red",
            "blue"
        ];
        this.parsedRange = this.range.map($d77b025aa58d633c$var$convertColorStringToOklcha);
    }
    update() {
        const { domain: domain, range: range3 } = this;
        if (domain.length < 2) {
            (0, $idDdm.Logger).warnOnce("`colorDomain` should have at least 2 values.");
            if (domain.length === 0) domain.push(0, 1);
            else if (domain.length === 1) domain.push(domain[0] + 1);
        }
        for(let i = 1; i < domain.length; i++){
            const a = domain[i - 1];
            const b = domain[i];
            if (a >= b) {
                (0, $idDdm.Logger).warnOnce("`colorDomain` values should be supplied in ascending order.");
                domain.sort((a2, b2)=>a2 - b2);
                break;
            }
        }
        if (range3.length < domain.length) for(let i = range3.length; i < domain.length; i++)range3.push(range3.length > 0 ? range3[0] : "black");
        this.parsedRange = this.range.map($d77b025aa58d633c$var$convertColorStringToOklcha);
    }
    normalizeDomains(...domains) {
        return {
            domain: domains.flat(),
            animatable: true
        };
    }
    toDomain() {
        return;
    }
    convert(x) {
        this.refresh();
        const { domain: domain, range: range3, parsedRange: parsedRange } = this;
        const d0 = domain[0];
        const d1 = domain.at(-1);
        const r0 = range3[0];
        const r1 = range3[range3.length - 1];
        if (x <= d0) return r0;
        if (x >= d1) return r1;
        let index;
        let q;
        if (domain.length === 2) {
            const t = (x - d0) / (d1 - d0);
            const step = 1 / (range3.length - 1);
            index = range3.length <= 2 ? 0 : Math.min(Math.floor(t * (range3.length - 1)), range3.length - 2);
            q = (t - index * step) / step;
        } else {
            for(index = 0; index < domain.length - 2; index++){
                if (x < domain[index + 1]) break;
            }
            const a = domain[index];
            const b = domain[index + 1];
            q = (x - a) / (b - a);
        }
        const c0 = parsedRange[index];
        const c1 = parsedRange[index + 1];
        return $d77b025aa58d633c$var$interpolateOklch(c0, c1, q).toRgbaString();
    }
    invert() {
        return;
    }
    refresh() {
        if (!this.invalid) return;
        this.invalid = false;
        this.update();
        if (this.invalid) (0, $idDdm.Logger).warnOnce("Expected update to not invalidate scale");
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$ColorScale.prototype, "domain", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$ColorScale.prototype, "range", 2);
// packages/ag-charts-community/src/scene/gradient/gradient.ts
var $d77b025aa58d633c$var$Gradient = class {
    constructor(colorSpace, stops = [], bbox){
        this.colorSpace = colorSpace;
        this.stops = stops;
        this.bbox = bbox;
        this._cache = void 0;
    }
    createGradient(ctx, shapeBbox, params) {
        const bbox = this.bbox ?? shapeBbox;
        if (isNaN(bbox.x) || isNaN(bbox.y)) return;
        if (this._cache != null && this._cache.ctx === ctx && this._cache.bbox.equals(bbox)) return this._cache.gradient;
        const { stops: stops, colorSpace: colorSpace } = this;
        if (stops.length === 0) return;
        if (stops.length === 1) return stops[0].color;
        let gradient2 = this.createCanvasGradient(ctx, bbox, params);
        if (gradient2 == null) return;
        const isOkLch = colorSpace === "oklch";
        const step = 0.05;
        let c0 = stops[0];
        gradient2.addColorStop(c0.stop, c0.color);
        for(let i = 1; i < stops.length; i += 1){
            const c1 = stops[i];
            if (isOkLch) {
                const scale2 = new $d77b025aa58d633c$var$ColorScale();
                scale2.domain = [
                    c0.stop,
                    c1.stop
                ];
                scale2.range = [
                    c0.color,
                    c1.color
                ];
                for(let stop = c0.stop + step; stop < c1.stop; stop += step)gradient2.addColorStop(stop, scale2.convert(stop));
            }
            gradient2.addColorStop(c1.stop, c1.color);
            c0 = c1;
        }
        if ("createPattern" in gradient2) gradient2 = gradient2.createPattern();
        this._cache = {
            ctx: ctx,
            bbox: bbox,
            gradient: gradient2
        };
        return gradient2;
    }
    toSvg(shapeBbox) {
        const bbox = this.bbox ?? shapeBbox;
        const gradient2 = this.createSvgGradient(bbox);
        this.stops.forEach(({ stop: offset4, color: color11 })=>{
            const stop = (0, $idDdm.createSvgElement)("stop");
            stop.setAttribute("offset", `${offset4}`);
            stop.setAttribute("stop-color", `${color11}`);
            gradient2.appendChild(stop);
        });
        return gradient2;
    }
};
// packages/ag-charts-community/src/scene/gradient/conicGradient.ts
var $d77b025aa58d633c$var$ConicGradient = class extends $d77b025aa58d633c$var$Gradient {
    constructor(colorSpace, stops, angle2 = 0, bbox){
        super(colorSpace, stops, bbox);
        this.angle = angle2;
    }
    createCanvasGradient(ctx, bbox, params) {
        const angleOffset = -90;
        const { angle: angle2 } = this;
        const radians = $d77b025aa58d633c$var$normalizeAngle360FromDegrees(angle2 + angleOffset);
        const cx = params?.centerX ?? bbox.x + bbox.width * 0.5;
        const cy = params?.centerY ?? bbox.y + bbox.height * 0.5;
        return ctx.createConicGradient(radians, cx, cy);
    }
    createSvgGradient(_bbox) {
        return (0, $idDdm.createSvgElement)("linearGradient");
    }
};
var $d77b025aa58d633c$var$LinearGradient = class extends $d77b025aa58d633c$var$Gradient {
    constructor(colorSpace, stops, angle2 = 0, bbox){
        super(colorSpace, stops, bbox);
        this.angle = angle2;
    }
    getGradientPoints(bbox) {
        const angleOffset = 90;
        const { angle: angle2 } = this;
        const radians = $d77b025aa58d633c$var$normalizeAngle360FromDegrees(angle2 + angleOffset);
        const cos = Math.cos(radians);
        const sin = Math.sin(radians);
        const w = bbox.width;
        const h = bbox.height;
        const cx = bbox.x + w * 0.5;
        const cy = bbox.y + h * 0.5;
        const diagonal = Math.sqrt(h * h + w * w) / 2;
        const diagonalAngle = Math.atan2(h, w);
        let quarteredAngle;
        if (radians < Math.PI / 2) quarteredAngle = radians;
        else if (radians < Math.PI) quarteredAngle = Math.PI - radians;
        else if (radians < 1.5 * Math.PI) quarteredAngle = radians - Math.PI;
        else quarteredAngle = 2 * Math.PI - radians;
        const l = diagonal * Math.abs(Math.cos(quarteredAngle - diagonalAngle));
        return {
            x0: cx + cos * l,
            y0: cy + sin * l,
            x1: cx - cos * l,
            y1: cy - sin * l
        };
    }
    createCanvasGradient(ctx, bbox) {
        const { x0: x0, y0: y0, x1: x1, y1: y1 } = this.getGradientPoints(bbox);
        if (isNaN(x0) || isNaN(y0) || isNaN(x1) || isNaN(y1)) return void 0;
        return ctx.createLinearGradient(x0, y0, x1, y1);
    }
    createSvgGradient(bbox) {
        const { x0: x0, y0: y0, x1: x1, y1: y1 } = this.getGradientPoints(bbox);
        const gradient2 = (0, $idDdm.createSvgElement)("linearGradient");
        gradient2.setAttribute("x1", String(x0));
        gradient2.setAttribute("y1", String(y0));
        gradient2.setAttribute("x2", String(x1));
        gradient2.setAttribute("y2", String(y1));
        gradient2.setAttribute("gradientUnits", "userSpaceOnUse");
        return gradient2;
    }
};
var $d77b025aa58d633c$var$RadialGradient = class extends $d77b025aa58d633c$var$Gradient {
    constructor(colorSpace, stops, bbox){
        super(colorSpace, stops, bbox);
    }
    createCanvasGradient(ctx, bbox, params) {
        const cx = params?.centerX ?? bbox.x + bbox.width * 0.5;
        const cy = params?.centerY ?? bbox.y + bbox.height * 0.5;
        const innerRadius = params?.innerRadius ?? 0;
        const outerRadius = params?.outerRadius ?? Math.hypot(bbox.width * 0.5, bbox.height * 0.5) / Math.SQRT2;
        return ctx.createRadialGradient(cx, cy, innerRadius, cx, cy, outerRadius);
    }
    createSvgGradient(bbox) {
        const cx = bbox.x + bbox.width * 0.5;
        const cy = bbox.y + bbox.height * 0.5;
        const gradient2 = (0, $idDdm.createSvgElement)("radialGradient");
        gradient2.setAttribute("cx", String(cx));
        gradient2.setAttribute("cy", String(cy));
        gradient2.setAttribute("r", String(Math.hypot(bbox.width * 0.5, bbox.height * 0.5) / Math.SQRT2));
        gradient2.setAttribute("gradientUnits", "userSpaceOnUse");
        return gradient2;
    }
};
var $d77b025aa58d633c$var$Property = $d77b025aa58d633c$var$addFakeTransformToInstanceProperty;
var $d77b025aa58d633c$var$BaseProperties = class {
    handleUnknownProperties(_unknownKeys, _properties) {}
    set(properties) {
        const { className: className = this.constructor.name } = this.constructor;
        if (typeof properties !== "object") {
            (0, $idDdm.Logger).warn(`unable to set ${className} - expecting a properties object`);
            return this;
        }
        const keys = new Set(Object.keys(properties));
        for (const propertyKey of $d77b025aa58d633c$var$listDecoratedProperties(this))if (keys.has(propertyKey)) {
            const value = properties[propertyKey];
            const self = this;
            if ($d77b025aa58d633c$var$isProperties(self[propertyKey])) {
                if (self[propertyKey] instanceof $d77b025aa58d633c$var$PropertiesArray) {
                    const array6 = self[propertyKey].reset(value);
                    if (array6 != null) self[propertyKey] = array6;
                    else (0, $idDdm.Logger).warn(`unable to set [${propertyKey}] - expecting a properties array`);
                } else self[propertyKey].set(value);
            } else if ((0, $idDdm.isPlainObject)(value)) self[propertyKey] = $d77b025aa58d633c$var$merge(value, self[propertyKey] ?? {});
            else self[propertyKey] = value;
            keys.delete(propertyKey);
        }
        this.handleUnknownProperties(keys, properties);
        for (const unknownKey of keys)(0, $idDdm.Logger).warn(`unable to set [${unknownKey}] in ${className} - property is unknown`);
        return this;
    }
    toJson() {
        return $d77b025aa58d633c$var$listDecoratedProperties(this).reduce((object4, propertyKey)=>{
            const propertyValue = this[propertyKey];
            object4[propertyKey] = $d77b025aa58d633c$var$isProperties(propertyValue) ? propertyValue.toJson() : propertyValue;
            return object4;
        }, {});
    }
};
var $d77b025aa58d633c$var$PropertiesArray = class _PropertiesArray extends Array {
    constructor(itemFactory, ...properties){
        super(properties.length);
        const isConstructor = (value2)=>Boolean(value2?.prototype?.constructor?.name);
        const value = isConstructor(itemFactory) ? (params)=>new itemFactory().set(params) : itemFactory;
        Object.defineProperty(this, "itemFactory", {
            value: value,
            enumerable: false,
            configurable: false
        });
        this.set(properties);
    }
    set(properties) {
        if ((0, $idDdm.isArray)(properties)) {
            this.length = properties.length;
            for(let i = 0; i < properties.length; i++)this[i] = this.itemFactory(properties[i]);
        }
        return this;
    }
    reset(properties) {
        if (Array.isArray(properties)) return new _PropertiesArray(this.itemFactory, ...properties);
    }
    toJson() {
        return this.map((value)=>value?.toJson?.() ?? value);
    }
};
function $d77b025aa58d633c$var$isProperties(value) {
    return value instanceof $d77b025aa58d633c$var$BaseProperties || value instanceof $d77b025aa58d633c$var$PropertiesArray;
}
// packages/ag-charts-community/src/scene/gradient/stops.ts
var $d77b025aa58d633c$var$StopProperties = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.color = "black";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$StopProperties.prototype, "stop", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$StopProperties.prototype, "color", 2);
function $d77b025aa58d633c$var$stopsAreAscending(fills) {
    let currentStop;
    for (const fill of fills){
        if (fill?.stop == null) continue;
        if (currentStop != null && fill.stop < currentStop) return false;
        currentStop = fill.stop;
    }
    return true;
}
function $d77b025aa58d633c$var$discreteColorStops(colorStops) {
    return colorStops.flatMap((colorStop, i)=>{
        const { stop: stop } = colorStop;
        const nextColor = colorStops.at(i + 1)?.color;
        return nextColor != null ? [
            colorStop,
            {
                stop: stop,
                color: nextColor
            }
        ] : [
            colorStop
        ];
    });
}
function $d77b025aa58d633c$var$getDefaultColorStops(defaultColorStops, fillMode) {
    const stopOffset = fillMode === "discrete" ? 1 : 0;
    const colorStops = defaultColorStops.map((color11, index, { length: length2 })=>({
            stop: (index + stopOffset) / (length2 - 1 + stopOffset),
            color: color11
        }));
    return fillMode === "discrete" ? $d77b025aa58d633c$var$discreteColorStops(colorStops) : colorStops;
}
function $d77b025aa58d633c$var$getColorStops(baseFills, defaultColorStops, domain, fillMode = "continuous") {
    const fills = baseFills.map((fill)=>typeof fill === "string" ? {
            color: fill
        } : fill);
    if (fills.length === 0) return $d77b025aa58d633c$var$getDefaultColorStops(defaultColorStops, fillMode);
    else if (!$d77b025aa58d633c$var$stopsAreAscending(fills)) {
        (0, $idDdm.Logger).warnOnce(`[fills] must have the stops defined in ascending order`);
        return [];
    }
    const d0 = Math.min(...domain);
    const d1 = Math.max(...domain);
    const isDiscrete = fillMode === "discrete";
    const stops = new Float64Array(fills.length);
    let previousDefinedStopIndex = 0;
    let nextDefinedStopIndex = -1;
    for(let i = 0; i < fills.length; i += 1){
        const colorStop = fills[i];
        if (i >= nextDefinedStopIndex) {
            nextDefinedStopIndex = fills.length - 1;
            for(let j = i + 1; j < fills.length; j += 1)if (fills[j]?.stop != null) {
                nextDefinedStopIndex = j;
                break;
            }
        }
        let stop = colorStop?.stop;
        if (stop == null) {
            const stop0 = fills[previousDefinedStopIndex]?.stop;
            const stop1 = fills[nextDefinedStopIndex]?.stop;
            const value0 = stop0 ?? d0;
            const value1 = stop1 ?? d1;
            const stopOffset = isDiscrete && stop0 == null ? 1 : 0;
            stop = value0 + (value1 - value0) * (i - previousDefinedStopIndex + stopOffset) / (nextDefinedStopIndex - previousDefinedStopIndex + stopOffset);
        } else previousDefinedStopIndex = i;
        stops[i] = Math.max(0, Math.min(1, (stop - d0) / (d1 - d0)));
    }
    let lastDefinedColor = fills.find((c)=>c.color != null)?.color;
    let colorScale;
    const colorStops = fills.map((fill, i)=>{
        let color11 = fill?.color;
        const stop = stops[i];
        if (color11 != null) lastDefinedColor = color11;
        else if (lastDefinedColor != null) color11 = lastDefinedColor;
        else {
            if (colorScale == null) {
                colorScale = new $d77b025aa58d633c$var$ColorScale();
                colorScale.domain = [
                    0,
                    1
                ];
                colorScale.range = defaultColorStops;
            }
            color11 = colorScale.convert(stop);
        }
        return {
            stop: stop,
            color: color11
        };
    });
    return fillMode === "discrete" ? $d77b025aa58d633c$var$discreteColorStops(colorStops) : colorStops;
}
var $d77b025aa58d633c$var$Image2 = class {
    constructor(imageLoader, imageOptions){
        this.imageLoader = imageLoader;
        this._cache = void 0;
        this.url = imageOptions.url;
        this.backgroundFill = imageOptions.backgroundFill ?? "black";
        this.backgroundFillOpacity = imageOptions.backgroundFillOpacity ?? 1;
        this.repeat = imageOptions.repeat ?? "no-repeat";
        this.width = imageOptions.width;
        this.height = imageOptions.height;
        this.fit = imageOptions.fit ?? "stretch";
        this.rotation = imageOptions.rotation ?? 0;
    }
    createCanvasImage(ctx, image, width2, height2) {
        if (!image) return null;
        const [renderedWidth, renderedHeight] = this.getSize(image.width, image.height, width2, height2);
        if (renderedWidth < 1 || renderedHeight < 1) {
            (0, $idDdm.Logger).warnOnce("Image fill is too small to render, ignoring.");
            return null;
        }
        return ctx.createPattern(image, this.repeat);
    }
    getSize(imageWidth, imageHeight, width2, height2) {
        const { fit: fit } = this;
        let dw = imageWidth;
        let dh = imageHeight;
        let scale2 = 1;
        const shapeAspectRatio = width2 / height2;
        const imageAspectRatio = imageWidth / imageHeight;
        if (fit === "stretch" || imageWidth === 0 || imageHeight === 0) {
            dw = width2;
            dh = height2;
        } else if (fit === "contain") scale2 = imageAspectRatio > shapeAspectRatio ? width2 / imageWidth : height2 / imageHeight;
        else if (fit === "cover") scale2 = imageAspectRatio > shapeAspectRatio ? height2 / imageHeight : width2 / imageWidth;
        return [
            Math.max(1, dw * scale2),
            Math.max(1, dh * scale2)
        ];
    }
    setImageTransform(pattern, bbox) {
        if (typeof pattern === "string") return;
        const { url: url, rotation: rotation, width: width2, height: height2 } = this;
        const image = this.imageLoader?.loadImage(url);
        if (!image) return;
        const angle2 = $d77b025aa58d633c$var$normalizeAngle360FromDegrees(rotation);
        const cos = Math.cos(angle2);
        const sin = Math.sin(angle2);
        const [renderedWidth, renderedHeight] = this.getSize(image.width, image.height, width2 ?? bbox.width, height2 ?? bbox.height);
        const widthScale = renderedWidth / image.width;
        const heightScale = renderedHeight / image.height;
        const bboxCenterX = bbox.x + bbox.width / 2;
        const bboxCenterY = bbox.y + bbox.height / 2;
        const rotatedW = cos * renderedWidth - sin * renderedHeight;
        const rotatedH = sin * renderedWidth + cos * renderedHeight;
        const shapeCenterX = rotatedW / 2;
        const shapeCenterY = rotatedH / 2;
        pattern?.setTransform(new DOMMatrix([
            cos * widthScale,
            sin * heightScale,
            -sin * widthScale,
            cos * heightScale,
            bboxCenterX - shapeCenterX,
            bboxCenterY - shapeCenterY
        ]));
    }
    createPattern(ctx, shapeWidth, shapeHeight, node) {
        const width2 = this.width ?? shapeWidth;
        const height2 = this.height ?? shapeHeight;
        const cache = this._cache;
        if (cache != null && cache.ctx === ctx && cache.width === width2 && cache.height === height2) return cache.pattern;
        const image = this.imageLoader?.loadImage(this.url, node);
        const pattern = this.createCanvasImage(ctx, image, width2, height2);
        if (pattern == null) return this.backgroundFill;
        this._cache = {
            ctx: ctx,
            pattern: pattern,
            width: width2,
            height: height2
        };
        return pattern;
    }
    toSvg(bbox, pixelRatio) {
        const { url: url, rotation: rotation, backgroundFill: backgroundFill, backgroundFillOpacity: backgroundFillOpacity } = this;
        const { x: x, y: y, width: width2, height: height2 } = bbox;
        const pattern = (0, $idDdm.createSvgElement)("pattern");
        pattern.setAttribute("viewBox", `0 0 ${width2} ${height2}`);
        pattern.setAttribute("x", String(x));
        pattern.setAttribute("y", String(y));
        pattern.setAttribute("width", String(width2));
        pattern.setAttribute("height", String(height2));
        pattern.setAttribute("patternUnits", "userSpaceOnUse");
        const rect = (0, $idDdm.createSvgElement)("rect");
        rect.setAttribute("x", "0");
        rect.setAttribute("y", "0");
        rect.setAttribute("width", String(width2));
        rect.setAttribute("height", String(height2));
        rect.setAttribute("fill", backgroundFill);
        rect.setAttribute("fill-opacity", String(backgroundFillOpacity));
        pattern.appendChild(rect);
        const image = (0, $idDdm.createSvgElement)("image");
        image.setAttribute("href", url);
        image.setAttribute("x", "0");
        image.setAttribute("y", "0");
        image.setAttribute("width", String(width2));
        image.setAttribute("height", String(height2));
        image.setAttribute("preserveAspectRatio", "none");
        image.setAttribute("transform", `scale(${1 / pixelRatio}) rotate(${rotation}, ${width2 / 2}, ${height2 / 2})`);
        pattern.appendChild(image);
        return pattern;
    }
};
var $d77b025aa58d633c$var$commandEx = /^[\t\n\f\r ]*([achlmqstvz])[\t\n\f\r ]*/i;
var $d77b025aa58d633c$var$coordinateEx = /^[+-]?((\d*\.\d+)|(\d+\.)|(\d+))(e[+-]?\d+)?/i;
var $d77b025aa58d633c$var$commaEx = /[\t\n\f\r ]*,?[\t\n\f\r ]*/;
var $d77b025aa58d633c$var$flagEx = /^[01]/;
var $d77b025aa58d633c$var$pathParams = {
    z: [],
    h: [
        $d77b025aa58d633c$var$coordinateEx
    ],
    v: [
        $d77b025aa58d633c$var$coordinateEx
    ],
    m: [
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx
    ],
    l: [
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx
    ],
    t: [
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx
    ],
    s: [
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx
    ],
    q: [
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx
    ],
    c: [
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx
    ],
    a: [
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$flagEx,
        $d77b025aa58d633c$var$flagEx,
        $d77b025aa58d633c$var$coordinateEx,
        $d77b025aa58d633c$var$coordinateEx
    ]
};
function $d77b025aa58d633c$var$parseSvg(d) {
    if (!d) return;
    const segments = [];
    let i = 0;
    let currentCommand;
    while(i < d.length){
        const commandMatch = $d77b025aa58d633c$var$commandEx.exec(d.slice(i));
        let command;
        if (commandMatch == null) {
            if (!currentCommand) {
                (0, $idDdm.Logger).warnOnce(`Invalid SVG path, error at index ${i}: Missing command.`);
                return;
            }
            command = currentCommand;
        } else {
            command = commandMatch[1];
            i += commandMatch[0].length;
        }
        const segment = $d77b025aa58d633c$var$parseSegment(command, d, i);
        if (!segment) return;
        i = segment[0];
        currentCommand = command;
        segments.push(segment[1]);
    }
    return segments;
}
function $d77b025aa58d633c$var$parseSegment(command, d, index) {
    const params = $d77b025aa58d633c$var$pathParams[command.toLocaleLowerCase()];
    const pathSeg = {
        command: command,
        params: []
    };
    for (const regex of params){
        const segment = d.slice(index);
        const match = regex.exec(segment);
        if (match != null) {
            pathSeg.params.push(parseFloat(match[0]));
            index += match[0].length;
            const next = $d77b025aa58d633c$var$commaEx.exec(segment.slice(match[0].length));
            if (next != null) index += next[0].length;
        } else if (pathSeg.params.length === 1) return [
            index,
            pathSeg
        ];
        else {
            (0, $idDdm.Logger).warnOnce(`Invalid SVG path, error at index ${index}: No path segment parameters for command [${command}]`);
            return;
        }
    }
    return [
        index,
        pathSeg
    ];
}
// packages/ag-charts-community/src/util/distance.ts
function $d77b025aa58d633c$var$pointsDistanceSquared(x1, y1, x2, y2) {
    const dx = x1 - x2;
    const dy = y1 - y2;
    return dx * dx + dy * dy;
}
function $d77b025aa58d633c$var$lineDistanceSquared(x, y, x1, y1, x2, y2, best) {
    if (x1 === x2 && y1 === y2) return Math.min(best, $d77b025aa58d633c$var$pointsDistanceSquared(x, y, x1, y1));
    const dx = x2 - x1;
    const dy = y2 - y1;
    const t = Math.max(0, Math.min(1, ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy)));
    const ix = x1 + t * dx;
    const iy = y1 + t * dy;
    return Math.min(best, $d77b025aa58d633c$var$pointsDistanceSquared(x, y, ix, iy));
}
function $d77b025aa58d633c$var$arcDistanceSquared(x, y, cx, cy, radius, startAngle, endAngle, counterClockwise, best) {
    if (counterClockwise) [endAngle, startAngle] = [
        startAngle,
        endAngle
    ];
    const angle2 = Math.atan2(y - cy, x - cx);
    if (!$d77b025aa58d633c$var$isBetweenAngles(angle2, startAngle, endAngle)) {
        const startX = cx + Math.cos(startAngle) * radius;
        const startY = cy + Math.sin(startAngle) * radius;
        const endX = cx + Math.cos(startAngle) * radius;
        const endY = cy + Math.sin(startAngle) * radius;
        return Math.min(best, $d77b025aa58d633c$var$pointsDistanceSquared(x, y, startX, startY), $d77b025aa58d633c$var$pointsDistanceSquared(x, y, endX, endY));
    }
    const distToArc = radius - Math.sqrt($d77b025aa58d633c$var$pointsDistanceSquared(x, y, cx, cy));
    return Math.min(best, distToArc * distToArc);
}
// packages/ag-charts-community/src/scene/polyRoots.ts
function $d77b025aa58d633c$var$linearRoot(a, b) {
    const t = -b / a;
    return a !== 0 && t >= 0 && t <= 1 ? [
        t
    ] : [];
}
function $d77b025aa58d633c$var$quadraticRoots(a, b, c) {
    if (a === 0) return $d77b025aa58d633c$var$linearRoot(b, c);
    const D = b * b - 4 * a * c;
    const roots = [];
    if (D === 0) {
        const t = -b / (2 * a);
        if (t >= 0 && t <= 1) roots.push(t);
    } else if (D > 0) {
        const rD = Math.sqrt(D);
        const t1 = (-b - rD) / (2 * a);
        const t2 = (-b + rD) / (2 * a);
        if (t1 >= 0 && t1 <= 1) roots.push(t1);
        if (t2 >= 0 && t2 <= 1) roots.push(t2);
    }
    return roots;
}
function $d77b025aa58d633c$var$cubicRoots(a, b, c, d) {
    if (a === 0) return $d77b025aa58d633c$var$quadraticRoots(b, c, d);
    const A = b / a;
    const B = c / a;
    const C2 = d / a;
    const Q = (3 * B - A * A) / 9;
    const R = (9 * A * B - 27 * C2 - 2 * A * A * A) / 54;
    const D = Q * Q * Q + R * R;
    const third = 1 / 3;
    const roots = [];
    if (D >= 0) {
        const rD = Math.sqrt(D);
        const S = Math.sign(R + rD) * Math.pow(Math.abs(R + rD), third);
        const T = Math.sign(R - rD) * Math.pow(Math.abs(R - rD), third);
        const Im = Math.abs(Math.sqrt(3) * (S - T) / 2);
        const t = -third * A + (S + T);
        if (t >= 0 && t <= 1) roots.push(t);
        if (Im === 0) {
            const t2 = -third * A - (S + T) / 2;
            if (t2 >= 0 && t2 <= 1) roots.push(t2);
        }
    } else {
        const theta = Math.acos(R / Math.sqrt(-Q * Q * Q));
        const thirdA = third * A;
        const twoSqrtQ = 2 * Math.sqrt(-Q);
        const t1 = twoSqrtQ * Math.cos(third * theta) - thirdA;
        const t2 = twoSqrtQ * Math.cos(third * (theta + 2 * Math.PI)) - thirdA;
        const t3 = twoSqrtQ * Math.cos(third * (theta + 4 * Math.PI)) - thirdA;
        if (t1 >= 0 && t1 <= 1) roots.push(t1);
        if (t2 >= 0 && t2 <= 1) roots.push(t2);
        if (t3 >= 0 && t3 <= 1) roots.push(t3);
    }
    return roots;
}
// packages/ag-charts-community/src/scene/intersection.ts
function $d77b025aa58d633c$var$segmentIntersection(ax1, ay1, ax2, ay2, bx1, by1, bx2, by2) {
    const d = (ax2 - ax1) * (by2 - by1) - (ay2 - ay1) * (bx2 - bx1);
    if (d === 0) return 0;
    const ua = ((bx2 - bx1) * (ay1 - by1) - (ax1 - bx1) * (by2 - by1)) / d;
    const ub = ((ax2 - ax1) * (ay1 - by1) - (ay2 - ay1) * (ax1 - bx1)) / d;
    if (ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1) return 1;
    return 0;
}
function $d77b025aa58d633c$var$cubicSegmentIntersections(px1, py1, px2, py2, px3, py3, px4, py4, x1, y1, x2, y2) {
    let intersections = 0;
    const A = y1 - y2;
    const B = x2 - x1;
    const C2 = x1 * (y2 - y1) - y1 * (x2 - x1);
    const bx = $d77b025aa58d633c$var$bezierCoefficients(px1, px2, px3, px4);
    const by = $d77b025aa58d633c$var$bezierCoefficients(py1, py2, py3, py4);
    const a = A * bx[0] + B * by[0];
    const b = A * bx[1] + B * by[1];
    const c = A * bx[2] + B * by[2];
    const d = A * bx[3] + B * by[3] + C2;
    const roots = $d77b025aa58d633c$var$cubicRoots(a, b, c, d);
    for (const t of roots){
        const tt = t * t;
        const ttt = t * tt;
        const x = bx[0] * ttt + bx[1] * tt + bx[2] * t + bx[3];
        const y = by[0] * ttt + by[1] * tt + by[2] * t + by[3];
        let s;
        if (x1 === x2) s = (y - y1) / (y2 - y1);
        else s = (x - x1) / (x2 - x1);
        if (s >= 0 && s <= 1) intersections++;
    }
    return intersections;
}
function $d77b025aa58d633c$var$bezierCoefficients(P1, P2, P3, P4) {
    return [
        // Bézier expressed as matrix operations:
        -P1 + 3 * P2 - 3 * P3 + P4,
        //                 |-1  3 -3  1| |P1|
        3 * P1 - 6 * P2 + 3 * P3,
        //   [t^3 t^2 t 1] | 3 -6  3  0| |P2|
        -3 * P1 + 3 * P2,
        //                 |-3  3  0  0| |P3|
        P1
    ];
}
function $d77b025aa58d633c$var$arcIntersections(cx, cy, r, startAngle, endAngle, counterClockwise, x1, y1, x2, y2) {
    if (isNaN(cx) || isNaN(cy)) return 0;
    if (counterClockwise) [endAngle, startAngle] = [
        startAngle,
        endAngle
    ];
    const k = (y2 - y1) / (x2 - x1);
    const y0 = y1 - k * x1;
    const a = Math.pow(k, 2) + 1;
    const b = 2 * (k * (y0 - cy) - cx);
    const c = Math.pow(cx, 2) + Math.pow(y0 - cy, 2) - Math.pow(r, 2);
    const d = Math.pow(b, 2) - 4 * a * c;
    if (d < 0) return 0;
    const i1x = (-b + Math.sqrt(d)) / 2 / a;
    const i2x = (-b - Math.sqrt(d)) / 2 / a;
    let intersections = 0;
    [
        i1x,
        i2x
    ].forEach((x)=>{
        const isXInsideLine = x >= Math.min(x1, x2) && x <= Math.max(x1, x2);
        if (!isXInsideLine) return;
        const y = k * x + y0;
        const adjacent = x - cx;
        const opposite = y - cy;
        const angle2 = Math.atan2(opposite, adjacent);
        if ($d77b025aa58d633c$var$isBetweenAngles(angle2, startAngle, endAngle)) intersections++;
    });
    return intersections;
}
// packages/ag-charts-community/src/scene/util/bezier.ts
function $d77b025aa58d633c$var$evaluateBezier(p0, p1, p2, p3, t) {
    return (1 - t) ** 3 * p0 + 3 * (1 - t) ** 2 * t * p1 + 3 * (1 - t) * t ** 2 * p2 + t ** 3 * p3;
}
function $d77b025aa58d633c$var$solveBezier(p0, p1, p2, p3, value) {
    if (value <= Math.min(p0, p3)) return p0 < p3 ? 0 : 1;
    else if (value >= Math.max(p0, p3)) return p0 < p3 ? 1 : 0;
    let t0 = 0;
    let t1 = 1;
    let t = NaN;
    for(let i = 0; i < 12; i += 1){
        t = (t0 + t1) / 2;
        const curveValue = $d77b025aa58d633c$var$evaluateBezier(p0, p1, p2, p3, t);
        if (curveValue < value) t0 = t;
        else t1 = t;
    }
    return t;
}
function $d77b025aa58d633c$var$splitBezier(p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y, t) {
    const x01 = (1 - t) * p0x + t * p1x;
    const y01 = (1 - t) * p0y + t * p1y;
    const x12 = (1 - t) * p1x + t * p2x;
    const y12 = (1 - t) * p1y + t * p2y;
    const x23 = (1 - t) * p2x + t * p3x;
    const y23 = (1 - t) * p2y + t * p3y;
    const x012 = (1 - t) * x01 + t * x12;
    const y012 = (1 - t) * y01 + t * y12;
    const x123 = (1 - t) * x12 + t * x23;
    const y123 = (1 - t) * y12 + t * y23;
    const x0123 = (1 - t) * x012 + t * x123;
    const y0123 = (1 - t) * y012 + t * y123;
    return [
        [
            {
                x: p0x,
                y: p0y
            },
            {
                x: x01,
                y: y01
            },
            {
                x: x012,
                y: y012
            },
            {
                x: x0123,
                y: y0123
            }
        ],
        [
            {
                x: x0123,
                y: y0123
            },
            {
                x: x123,
                y: y123
            },
            {
                x: x23,
                y: y23
            },
            {
                x: p3x,
                y: p3y
            }
        ]
    ];
}
function $d77b025aa58d633c$var$calculateDerivativeExtrema(p0, p1, p2, p3) {
    const a = -p0 + 3 * p1 - 3 * p2 + p3;
    const b = 2 * (p0 - 2 * p1 + p2);
    const c = -p0 + p1;
    if (a === 0) {
        if (b !== 0) {
            const t = -c / b;
            if (t > 0 && t < 1) return [
                t
            ];
        }
        return [];
    }
    const discriminant = b * b - 4 * a * c;
    if (discriminant >= 0) {
        const sqrtDiscriminant = Math.sqrt(discriminant);
        const t1 = (-b + sqrtDiscriminant) / (2 * a);
        const t2 = (-b - sqrtDiscriminant) / (2 * a);
        return [
            t1,
            t2
        ].filter((t)=>t > 0 && t < 1);
    }
    return [];
}
function $d77b025aa58d633c$var$calculateDerivativeExtremaXY(sx, sy, cp1x, cp1y, cp2x, cp2y, x, y) {
    const tx = $d77b025aa58d633c$var$calculateDerivativeExtrema(sx, cp1x, cp2x, x);
    const ty = $d77b025aa58d633c$var$calculateDerivativeExtrema(sy, cp1y, cp2y, y);
    return [
        ...tx,
        ...ty
    ];
}
// packages/ag-charts-community/src/scene/extendedPath2D.ts
var $d77b025aa58d633c$var$ExtendedPath2D = class {
    constructor(){
        // The methods of this class will likely be called many times per animation frame,
        // and any allocation can trigger a GC cycle during animation, so we attempt
        // to minimize the number of allocations.
        this.path2d = new Path2D();
        this.previousCommands = [];
        this.previousParams = [];
        this.previousClosedPath = false;
        this.commands = [];
        this.params = [];
        this.openedPath = false;
        this.closedPath = false;
    }
    isEmpty() {
        return this.commands.length === 0;
    }
    isDirty() {
        return this.closedPath !== this.previousClosedPath || this.previousCommands.length !== this.commands.length || this.previousParams.length !== this.params.length || this.previousCommands.toString() !== this.commands.toString() || this.previousParams.toString() !== this.params.toString();
    }
    getPath2D() {
        return this.path2d;
    }
    moveTo(x, y) {
        this.openedPath = true;
        this.path2d.moveTo(x, y);
        this.commands.push(0 /* Move */ );
        this.params.push(x, y);
    }
    lineTo(x, y) {
        if (this.openedPath) {
            this.path2d.lineTo(x, y);
            this.commands.push(1 /* Line */ );
            this.params.push(x, y);
        } else this.moveTo(x, y);
    }
    rect(x, y, width2, height2) {
        this.moveTo(x, y);
        this.lineTo(x + width2, y);
        this.lineTo(x + width2, y + height2);
        this.lineTo(x, y + height2);
        this.closePath();
    }
    appendSvg(parts) {
        let sx = 0;
        let sy = 0;
        let cx;
        let cy;
        let cpx = 0;
        let cpy = 0;
        for (const { command: command, params: params } of parts){
            cx ?? (cx = params[0]);
            cy ?? (cy = params[1]);
            const relative = command === command.toLowerCase();
            const dx = relative ? cx : 0;
            const dy = relative ? cy : 0;
            switch(command.toLowerCase()){
                case "m":
                    this.moveTo(dx + params[0], dy + params[1]);
                    cx = dx + params[0];
                    cy = dy + params[1];
                    sx = cx;
                    sy = cy;
                    break;
                case "c":
                    this.cubicCurveTo(dx + params[0], dy + params[1], dx + params[2], dy + params[3], dx + params[4], dy + params[5]);
                    cpx = dx + params[2];
                    cpy = dy + params[3];
                    cx = dx + params[4];
                    cy = dy + params[5];
                    break;
                case "s":
                    this.cubicCurveTo(cx + cx - cpx, cy + cy - cpy, dx + params[0], dy + params[1], dx + params[2], dy + params[3]);
                    cpx = dx + params[0];
                    cpy = dy + params[1];
                    cx = dx + params[2];
                    cy = dy + params[3];
                    break;
                case "q":
                    this.cubicCurveTo((dx + 2 * params[0]) / 3, (dy + 2 * params[1]) / 3, (2 * params[0] + params[2]) / 3, (2 * params[1] + params[3]) / 3, params[2], params[3]);
                    cpx = params[0];
                    cpy = params[1];
                    cx = params[2];
                    cy = params[3];
                    break;
                case "t":
                    this.cubicCurveTo((cx + 2 * (cx + cx - cpx)) / 3, (cy + 2 * (cy + cy - cpy)) / 3, (2 * (cx + cx - cpx) + params[0]) / 3, (2 * (cy + cy - cpy) + params[1]) / 3, params[0], params[1]);
                    cpx = cx + cx - cpx;
                    cpy = cy + cy - cpy;
                    cx = params[0];
                    cy = params[1];
                    break;
                case "a":
                    this.ellipse(cx, cy, params[0], params[1], params[2] * Math.PI / 180, params[3], params[4], dx + params[5], dy + params[6]);
                    cx = dx + params[5];
                    cy = dy + params[6];
                    break;
                case "h":
                    this.lineTo(dx + params[0], cy);
                    cx = dx + params[0];
                    break;
                case "l":
                    this.lineTo(dx + params[0], dy + params[1]);
                    cx = dx + params[0];
                    cy = dy + params[1];
                    break;
                case "v":
                    this.lineTo(cx, dy + params[0]);
                    cy = dy + params[0];
                    break;
                case "z":
                    this.closePath();
                    cx = sx;
                    cy = sy;
                    break;
                default:
                    throw new Error(`Could not translate command '${command}' with '${params.join(" ")}'`);
            }
        }
    }
    ellipse(x1, y1, rx, ry, rotation, fA, fS, x2, y2) {
        rx = Math.abs(rx);
        ry = Math.abs(ry);
        const dx = (x1 - x2) / 2;
        const dy = (y1 - y2) / 2;
        const sin = Math.sin(rotation);
        const cos = Math.cos(rotation);
        const rotX = cos * dx + sin * dy;
        const rotY = -sin * dx + cos * dy;
        const normX = rotX / rx;
        const normY = rotY / ry;
        let scale2 = normX * normX + normY * normY;
        let cx = (x1 + x2) / 2;
        let cy = (y1 + y2) / 2;
        let cpx = 0;
        let cpy = 0;
        if (scale2 >= 1) {
            scale2 = Math.sqrt(scale2);
            rx *= scale2;
            ry *= scale2;
        } else {
            scale2 = Math.sqrt(1 / scale2 - 1);
            if (fA === fS) scale2 = -scale2;
            cpx = scale2 * rx * normY;
            cpy = -scale2 * ry * normX;
            cx += cos * cpx - sin * cpy;
            cy += sin * cpx + cos * cpy;
        }
        const sAngle = Math.atan2((rotY - cpy) / ry, (rotX - cpx) / rx);
        const deltaTheta = Math.atan2((-rotY - cpy) / ry, (-rotX - cpx) / rx) - sAngle;
        const eAngle = sAngle + deltaTheta;
        const counterClockwise = !!(1 - fS);
        this.ellipticalArc(cx, cy, rx, ry, rotation, sAngle, eAngle, counterClockwise);
    }
    ellipticalArc(cx, cy, rx, ry, rotation, sAngle, eAngle, counterClockwise) {
        if (counterClockwise) [sAngle, eAngle] = [
            eAngle,
            sAngle
        ];
        const params = [];
        const f90 = 0.5522847498307935;
        const sinS = Math.sin(sAngle);
        const cosS = Math.cos(sAngle);
        const sinR = Math.sin(rotation);
        const cosR = Math.cos(rotation);
        let xx = cosR * cosS * rx - sinR * sinS * ry;
        let yx = sinR * cosS * rx + cosR * sinS * ry;
        let xy = -cosR * sinS * rx - sinR * cosS * ry;
        let yy = -sinR * sinS * rx + cosR * cosS * ry;
        params.push(xx + cx, yx + cy);
        eAngle -= sAngle;
        eAngle = $d77b025aa58d633c$var$normalizeAngle360(eAngle);
        const rightAngle = Math.PI / 2;
        const fullRightAngles = Math.floor(eAngle / rightAngle);
        const remainderAngle = eAngle % rightAngle;
        for(let i = 0; i < fullRightAngles; i++){
            params.push(xx + xy * f90 + cx, yx + yy * f90 + cy, xx * f90 + xy + cx, yx * f90 + yy + cy, xy + cx, yy + cy);
            [xx, xy] = [
                xy,
                -xx
            ];
            [yx, yy] = [
                yy,
                -yx
            ];
        }
        if (remainderAngle > 0) {
            const sinRA = Math.sin(remainderAngle);
            const cosRA = Math.cos(remainderAngle);
            const factor = Math.tan(remainderAngle / 4) * (4 / 3);
            const cpx = cosRA + factor * sinRA;
            const cpy = sinRA - factor * cosRA;
            params.push(xx + xy * factor + cx, yx + yy * factor + cy, xx * cpx + xy * cpy + cx, yx * cpx + yy * cpy + cy, xx * cosRA + xy * sinRA + cx, yx * cosRA + yy * sinRA + cy);
        }
        if (counterClockwise) for(let i = 0, j = params.length - 2; i < j; i += 2, j -= 2){
            [params[i], params[j]] = [
                params[j],
                params[i]
            ];
            [params[i + 1], params[j + 1]] = [
                params[j + 1],
                params[i + 1]
            ];
        }
        for(let i = 2; i < params.length; i += 6){
            const [cx1, cy1, cx2, cy2, x, y] = params.slice(i, i + 6);
            this.cubicCurveTo(cx1, cy1, cx2, cy2, x, y);
        }
    }
    roundRect(x, y, width2, height2, radii) {
        radii = Math.min(radii, width2 / 2, height2 / 2);
        this.moveTo(x, y + radii);
        this.arc(x + radii, y + radii, radii, Math.PI, 1.5 * Math.PI);
        this.lineTo(x + radii, y);
        this.lineTo(x + width2 - radii, y);
        this.arc(x + width2 - radii, y + radii, radii, 1.5 * Math.PI, 2 * Math.PI);
        this.lineTo(x + width2, y + radii);
        this.lineTo(x + width2, y + height2 - radii);
        this.arc(x + width2 - radii, y + height2 - radii, radii, 0, Math.PI / 2);
        this.lineTo(x + width2 - radii, y + height2);
        this.lineTo(x + radii, y + height2);
        this.arc(x + +radii, y + height2 - radii, radii, Math.PI / 2, Math.PI);
        this.lineTo(x, y + height2 - radii);
        this.closePath();
    }
    arc(x, y, r, sAngle, eAngle, counterClockwise) {
        this.openedPath = true;
        this.path2d.arc(x, y, r, sAngle, eAngle, counterClockwise);
        this.commands.push(2 /* Arc */ );
        this.params.push(x, y, r, sAngle, eAngle, counterClockwise ? 1 : 0);
    }
    cubicCurveTo(cx1, cy1, cx2, cy2, x, y) {
        if (!this.openedPath) this.moveTo(cx1, cy1);
        this.path2d.bezierCurveTo(cx1, cy1, cx2, cy2, x, y);
        this.commands.push(3 /* Curve */ );
        this.params.push(cx1, cy1, cx2, cy2, x, y);
    }
    closePath() {
        if (this.openedPath) {
            this.path2d.closePath();
            this.commands.push(4 /* ClosePath */ );
            this.openedPath = false;
            this.closedPath = true;
        }
    }
    clear(trackChanges) {
        if (trackChanges) {
            this.previousCommands = this.commands;
            this.previousParams = this.params;
            this.previousClosedPath = this.closedPath;
        }
        this.path2d = new Path2D();
        this.openedPath = false;
        this.closedPath = false;
        this.commands = [];
        this.params = [];
    }
    isPointInPath(x, y) {
        const commands = this.commands;
        const params = this.params;
        const cn = commands.length;
        const ox = -10000;
        const oy = -10000;
        let sx = NaN;
        let sy = NaN;
        let px = 0;
        let py = 0;
        let intersectionCount = 0;
        for(let ci = 0, pi = 0; ci < cn; ci++)switch(commands[ci]){
            case 0 /* Move */ :
                intersectionCount += $d77b025aa58d633c$var$segmentIntersection(sx, sy, px, py, ox, oy, x, y);
                px = params[pi++];
                sx = px;
                py = params[pi++];
                sy = py;
                break;
            case 1 /* Line */ :
                intersectionCount += $d77b025aa58d633c$var$segmentIntersection(px, py, params[pi++], params[pi++], ox, oy, x, y);
                px = params[pi - 2];
                py = params[pi - 1];
                break;
            case 3 /* Curve */ :
                intersectionCount += $d77b025aa58d633c$var$cubicSegmentIntersections(px, py, params[pi++], params[pi++], params[pi++], params[pi++], params[pi++], params[pi++], ox, oy, x, y);
                px = params[pi - 2];
                py = params[pi - 1];
                break;
            case 2 /* Arc */ :
                {
                    const cx = params[pi++];
                    const cy = params[pi++];
                    const r = params[pi++];
                    const startAngle = params[pi++];
                    const endAngle = params[pi++];
                    const counterClockwise = Boolean(params[pi++]);
                    intersectionCount += $d77b025aa58d633c$var$arcIntersections(cx, cy, r, startAngle, endAngle, counterClockwise, ox, oy, x, y);
                    if (!isNaN(sx)) {
                        const startX = cx + Math.cos(startAngle) * r;
                        const startY = cy + Math.sin(startAngle) * r;
                        intersectionCount += $d77b025aa58d633c$var$segmentIntersection(px, py, startX, startY, ox, oy, x, y);
                    }
                    px = cx + Math.cos(endAngle) * r;
                    py = cy + Math.sin(endAngle) * r;
                    break;
                }
            case 4 /* ClosePath */ :
                intersectionCount += $d77b025aa58d633c$var$segmentIntersection(sx, sy, px, py, ox, oy, x, y);
                break;
        }
        return intersectionCount % 2 === 1;
    }
    distanceSquared(x, y) {
        let best = Infinity;
        const commands = this.commands;
        const params = this.params;
        const cn = commands.length;
        let sx = NaN;
        let sy = NaN;
        let px = 0;
        let py = 0;
        for(let ci = 0, pi = 0; ci < cn; ci++)switch(commands[ci]){
            case 0 /* Move */ :
                px = sx = params[pi++];
                py = sy = params[pi++];
                break;
            case 1 /* Line */ :
                {
                    const nx = params[pi++];
                    const ny = params[pi++];
                    best = $d77b025aa58d633c$var$lineDistanceSquared(x, y, px, py, nx, ny, best);
                    break;
                }
            case 3 /* Curve */ :
                (0, $idDdm.Logger).error("Command.Curve distanceSquare not implemented");
                break;
            case 2 /* Arc */ :
                {
                    const cx = params[pi++];
                    const cy = params[pi++];
                    const r = params[pi++];
                    const startAngle = params[pi++];
                    const endAngle = params[pi++];
                    const startX = cx + Math.cos(startAngle) * r;
                    const startY = cy + Math.sin(startAngle) * r;
                    const counterClockwise = Boolean(params[pi++]);
                    best = $d77b025aa58d633c$var$lineDistanceSquared(x, y, px, py, startX, startY, best);
                    best = $d77b025aa58d633c$var$arcDistanceSquared(x, y, cx, cy, r, startAngle, endAngle, counterClockwise, best);
                    px = cx + Math.cos(endAngle) * r;
                    py = cy + Math.sin(endAngle) * r;
                    break;
                }
            case 4 /* ClosePath */ :
                best = $d77b025aa58d633c$var$lineDistanceSquared(x, y, px, py, sx, sy, best);
                break;
        }
        return best;
    }
    // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/d
    toSVG(transform = (x, y)=>({
            x: x,
            y: y
        })) {
        const buffer = [];
        const { commands: commands, params: params } = this;
        const addCommand = (command, ...points)=>{
            buffer.push(command);
            for(let i = 0; i < points.length; i += 2){
                const { x: x, y: y } = transform(points[i], points[i + 1]);
                buffer.push(x, y);
            }
        };
        let pi = 0;
        for (const command of commands)switch(command){
            case 0 /* Move */ :
                addCommand("M", params[pi++], params[pi++]);
                break;
            case 1 /* Line */ :
                addCommand("L", params[pi++], params[pi++]);
                break;
            case 3 /* Curve */ :
                addCommand("C", params[pi++], params[pi++], params[pi++], params[pi++], params[pi++], params[pi++]);
                break;
            case 2 /* Arc */ :
                {
                    const cx = params[pi++];
                    const cy = params[pi++];
                    const r = params[pi++];
                    const A0 = params[pi++];
                    const A1 = params[pi++];
                    const ccw = params[pi++];
                    let sweep = ccw ? A0 - A1 : A1 - A0;
                    if (sweep < 0) sweep += Math.ceil(-sweep / (2 * Math.PI)) * 2 * Math.PI;
                    if (ccw) sweep = -sweep;
                    const arcSections = Math.max(Math.ceil(Math.abs(sweep) / (Math.PI / 2)), 1);
                    const step = sweep / arcSections;
                    const h = 4 / 3 * Math.tan(step / 4);
                    const move = buffer.length === 0 ? "M" : "L";
                    addCommand(move, cx + Math.cos(A0) * r, cy + Math.sin(A0) * r);
                    for(let i = 0; i < arcSections; i += 1){
                        const a0 = A0 + step * (i + 0);
                        const a1 = A0 + step * (i + 1);
                        const rSinStart = r * Math.sin(a0);
                        const rCosStart = r * Math.cos(a0);
                        const rSinEnd = r * Math.sin(a1);
                        const rCosEnd = r * Math.cos(a1);
                        addCommand("C", cx + rCosStart - h * rSinStart, cy + rSinStart + h * rCosStart, cx + rCosEnd + h * rSinEnd, cy + rSinEnd - h * rCosEnd, cx + rCosEnd, cy + rSinEnd);
                    }
                    break;
                }
            case 4 /* ClosePath */ :
                buffer.push("Z");
                break;
        }
        return buffer.join(" ");
    }
    computeBBox() {
        const { commands: commands, params: params } = this;
        let [top, left, right, bot] = [
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ];
        let [sx, sy] = [
            NaN,
            NaN
        ];
        let [mx, my] = [
            NaN,
            NaN
        ];
        const joinPoint = (x, y, updatestart)=>{
            top = Math.min(y, top);
            left = Math.min(x, left);
            right = Math.max(x, right);
            bot = Math.max(y, bot);
            if (updatestart) [sx, sy] = [
                x,
                y
            ];
        };
        const joinAngle = (cx, cy, r, angle2, updatestart)=>{
            const px = cx + r * Math.cos(angle2);
            const py = cy + r * Math.sin(angle2);
            joinPoint(px, py, updatestart);
        };
        let pi = 0;
        for (const command of commands)switch(command){
            case 0 /* Move */ :
                joinPoint(params[pi++], params[pi++], true);
                [mx, my] = [
                    sx,
                    sy
                ];
                break;
            case 1 /* Line */ :
                joinPoint(params[pi++], params[pi++], true);
                break;
            case 3 /* Curve */ :
                {
                    const cp1x = params[pi++];
                    const cp1y = params[pi++];
                    const cp2x = params[pi++];
                    const cp2y = params[pi++];
                    const x = params[pi++];
                    const y = params[pi++];
                    const ts = $d77b025aa58d633c$var$calculateDerivativeExtremaXY(sx, sy, cp1x, cp1y, cp2x, cp2y, x, y);
                    ts.forEach((t)=>{
                        const px = $d77b025aa58d633c$var$evaluateBezier(sx, cp1x, cp2x, x, t);
                        const py = $d77b025aa58d633c$var$evaluateBezier(sy, cp1y, cp2y, y, t);
                        joinPoint(px, py);
                    });
                    joinPoint(x, y, true);
                    break;
                }
            case 2 /* Arc */ :
                {
                    const cx = params[pi++];
                    const cy = params[pi++];
                    const r = params[pi++];
                    const a0 = $d77b025aa58d633c$var$normalizeAngle360(params[pi++]);
                    const a1 = $d77b025aa58d633c$var$normalizeAngle360(params[pi++]);
                    const ccw = params[pi++];
                    joinAngle(cx, cy, r, a0);
                    const criticalAngles = [
                        0,
                        Math.PI / 2,
                        Math.PI,
                        3 * Math.PI / 2
                    ];
                    const [r0, r1] = ccw ? [
                        a1,
                        a0
                    ] : [
                        a0,
                        a1
                    ];
                    for (const crit of criticalAngles)if (r0 < r1 && r0 <= crit && crit <= r1 || r0 > r1 && (r0 <= crit || crit <= r1)) joinAngle(cx, cy, r, crit);
                    joinAngle(cx, cy, r, a1, true);
                    break;
                }
            case 4 /* ClosePath */ :
                [sx, sy] = [
                    mx,
                    my
                ];
                break;
        }
        return new $d77b025aa58d633c$var$BBox(left, top, right - left, bot - top);
    }
};
// packages/ag-charts-community/src/scene/util/pixel.ts
function $d77b025aa58d633c$var$align(pixelRatio, start2, length2) {
    const alignedStart = Math.round(start2 * pixelRatio) / pixelRatio;
    if (length2 == null) return alignedStart;
    else if (length2 === 0) return 0;
    else if (length2 < 1) return Math.ceil(length2 * pixelRatio) / pixelRatio;
    return Math.round((length2 + start2) * pixelRatio) / pixelRatio - alignedStart;
}
function $d77b025aa58d633c$var$alignBefore(pixelRatio, start2) {
    return Math.floor(start2 * pixelRatio) / pixelRatio;
}
// packages/ag-charts-community/src/scene/pattern/patterns.ts
function $d77b025aa58d633c$var$drawPatternUnitPolygon(path, params, moves) {
    const { width: width2, height: height2, padding: padding, strokeWidth: strokeWidth } = params;
    const x0 = width2 / 2;
    const y0 = height2 / 2;
    const w = Math.max(1, width2 - padding - strokeWidth / 2);
    const h = Math.max(1, height2 - padding - strokeWidth / 2);
    let didMove = false;
    for (const [dx, dy] of moves){
        const x = x0 + (dx - 0.5) * w;
        const y = y0 + (dy - 0.5) * h;
        if (didMove) path.lineTo(x, y);
        else path.moveTo(x, y);
        didMove = true;
    }
    path.closePath();
}
var $d77b025aa58d633c$var$PATTERNS = {
    circles (path, { width: width2, strokeWidth: strokeWidth, padding: padding }) {
        const c = width2 / 2;
        const r = Math.max(1, c - padding - strokeWidth / 2);
        path.arc(c, c, r, 0, Math.PI * 2);
    },
    squares (path, { width: width2, height: height2, pixelRatio: pixelRatio, padding: padding, strokeWidth: strokeWidth }) {
        const offset4 = padding + strokeWidth / 2;
        path.moveTo($d77b025aa58d633c$var$align(pixelRatio, offset4), $d77b025aa58d633c$var$align(pixelRatio, offset4));
        path.lineTo($d77b025aa58d633c$var$align(pixelRatio, width2 - offset4), $d77b025aa58d633c$var$align(pixelRatio, offset4));
        path.lineTo($d77b025aa58d633c$var$align(pixelRatio, width2 - offset4), $d77b025aa58d633c$var$align(pixelRatio, height2 - offset4));
        path.lineTo($d77b025aa58d633c$var$align(pixelRatio, offset4), $d77b025aa58d633c$var$align(pixelRatio, height2 - offset4));
        path.closePath();
    },
    triangles (path, params) {
        $d77b025aa58d633c$var$drawPatternUnitPolygon(path, params, [
            [
                0.5,
                0
            ],
            [
                1,
                1
            ],
            [
                0,
                1
            ]
        ]);
    },
    diamonds (path, params) {
        $d77b025aa58d633c$var$drawPatternUnitPolygon(path, params, [
            [
                0.5,
                0
            ],
            [
                1,
                0.5
            ],
            [
                0.5,
                1
            ],
            [
                0,
                0.5
            ]
        ]);
    },
    stars (path, { width: width2, height: height2, padding: padding }) {
        const spikes = 5;
        const outerRadius = Math.max(1, (width2 - padding) / 2);
        const innerRadius = outerRadius / 2;
        const rotation = Math.PI / 2;
        for(let i = 0; i < spikes * 2; i++){
            const radius = i % 2 === 0 ? outerRadius : innerRadius;
            const angle2 = i * Math.PI / spikes - rotation;
            const xCoordinate = width2 / 2 + Math.cos(angle2) * radius;
            const yCoordinate = height2 / 2 + Math.sin(angle2) * radius;
            path.lineTo(xCoordinate, yCoordinate);
        }
        path.closePath();
    },
    hearts (path, { width: width2, height: height2, padding: padding }) {
        const r = Math.max(1, width2 / 4 - padding / 2);
        const x = width2 / 2;
        const y = height2 / 2 + r / 2;
        path.arc(x - r, y - r, r, $d77b025aa58d633c$var$toRadians(130), $d77b025aa58d633c$var$toRadians(330));
        path.arc(x + r, y - r, r, $d77b025aa58d633c$var$toRadians(220), $d77b025aa58d633c$var$toRadians(50));
        path.lineTo(x, y + r);
        path.closePath();
    },
    crosses (path, params) {
        $d77b025aa58d633c$var$drawPatternUnitPolygon(path, params, [
            [
                0.25,
                0
            ],
            [
                0.5,
                0.25
            ],
            [
                0.75,
                0
            ],
            [
                1,
                0.25
            ],
            [
                0.75,
                0.5
            ],
            [
                1,
                0.75
            ],
            [
                0.75,
                1
            ],
            [
                0.5,
                0.75
            ],
            [
                0.25,
                1
            ],
            [
                0,
                0.75
            ],
            [
                0.25,
                0.5
            ],
            [
                0,
                0.25
            ]
        ]);
    },
    "vertical-lines" (path, { width: width2, height: height2, pixelRatio: pixelRatio, strokeWidth: strokeWidth }) {
        const x = $d77b025aa58d633c$var$align(pixelRatio, width2 / 2) - strokeWidth % 2 / 2;
        path.moveTo(x, 0);
        path.lineTo(x, height2);
    },
    "horizontal-lines" (path, { width: width2, height: height2, pixelRatio: pixelRatio, strokeWidth: strokeWidth }) {
        const y = $d77b025aa58d633c$var$align(pixelRatio, height2 / 2) - strokeWidth % 2 / 2;
        path.moveTo(0, y);
        path.lineTo(width2, y);
    },
    "forward-slanted-lines" (path, { width: width2, height: height2, strokeWidth: strokeWidth }) {
        const angle2 = Math.atan2(height2, width2);
        const insetX = strokeWidth * Math.cos(angle2);
        const insetY = strokeWidth * Math.sin(angle2);
        path.moveTo(-insetX, insetY);
        path.lineTo(insetX, -insetY);
        path.moveTo(-insetX, height2 + insetY);
        path.lineTo(width2 + insetX, -insetY);
        path.moveTo(width2 - insetX, height2 + insetY);
        path.lineTo(width2 + insetX, height2 - insetY);
    },
    "backward-slanted-lines" (path, { width: width2, height: height2, strokeWidth: strokeWidth }) {
        const angle2 = Math.atan2(height2, width2);
        const insetX = strokeWidth * Math.cos(angle2);
        const insetY = strokeWidth * Math.sin(angle2);
        path.moveTo(width2 - insetX, -insetY);
        path.lineTo(width2 + insetX, insetY);
        path.moveTo(-insetX, -insetY);
        path.lineTo(width2 + insetX, height2 + insetY);
        path.moveTo(-insetX, height2 - insetY);
        path.lineTo(insetX, height2 + insetY);
    }
};
// packages/ag-charts-community/src/scene/pattern/pattern.ts
var $d77b025aa58d633c$var$Pattern = class {
    constructor(patternOptions){
        this._cache = void 0;
        this.width = Math.max(patternOptions?.width ?? 10, 1);
        this.height = Math.max(patternOptions?.height ?? 10, 1);
        this.fill = patternOptions.fill ?? "none";
        this.fillOpacity = patternOptions.fillOpacity ?? 1;
        this.backgroundFill = patternOptions.backgroundFill ?? "none";
        this.backgroundFillOpacity = patternOptions.backgroundFillOpacity ?? 1;
        this.stroke = patternOptions.stroke ?? "black";
        this.strokeOpacity = patternOptions.strokeOpacity ?? 1;
        this.strokeWidth = patternOptions.strokeWidth ?? 1;
        this.padding = patternOptions.padding ?? 1;
        this.pattern = patternOptions.pattern ?? "forward-slanted-lines";
        this.rotation = patternOptions.rotation ?? 0;
        this.scale = patternOptions.scale ?? 1;
        this.path = patternOptions.path;
    }
    getPath(pixelRatio) {
        const { pattern: pattern, width: width2, height: height2, padding: padding, strokeWidth: strokeWidth, path: svgPath } = this;
        const path = new $d77b025aa58d633c$var$ExtendedPath2D();
        const svgParts = $d77b025aa58d633c$var$parseSvg(svgPath);
        if (svgParts) path.appendSvg(svgParts);
        else $d77b025aa58d633c$var$PATTERNS[pattern](path, {
            width: width2,
            height: height2,
            pixelRatio: pixelRatio,
            strokeWidth: strokeWidth,
            padding: padding
        });
        return path;
    }
    renderStroke(path2d, ctx) {
        const { stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity } = this;
        if (!strokeWidth) return;
        ctx.strokeStyle = stroke2;
        ctx.lineWidth = strokeWidth;
        ctx.globalAlpha = strokeOpacity;
        ctx.stroke(path2d);
    }
    renderFill(path2d, ctx) {
        const { fill: fill, fillOpacity: fillOpacity } = this;
        if (fill === "none") return;
        ctx.fillStyle = fill;
        ctx.globalAlpha = fillOpacity;
        ctx.fill(path2d);
    }
    createCanvasPattern(ctx, pixelRatio) {
        const { width: width2, height: height2, scale: scale2, backgroundFill: backgroundFill, backgroundFillOpacity: backgroundFillOpacity } = this;
        if (width2 * scale2 < 1 || height2 * scale2 < 1) {
            (0, $idDdm.Logger).warnOnce("Pattern fill is too small to render, ignoring.");
            return null;
        }
        const offscreenPattern = new $d77b025aa58d633c$var$HdpiOffscreenCanvas({
            width: width2,
            height: height2,
            pixelRatio: pixelRatio * scale2
        });
        const offscreenPatternCtx = offscreenPattern.context;
        if (backgroundFill !== "none") {
            offscreenPatternCtx.fillStyle = backgroundFill;
            offscreenPatternCtx.globalAlpha = backgroundFillOpacity;
            offscreenPatternCtx.fillRect(0, 0, width2, height2);
        }
        const path2d = this.getPath(pixelRatio).getPath2D();
        this.renderFill(path2d, offscreenPatternCtx);
        this.renderStroke(path2d, offscreenPatternCtx);
        const pattern = ctx.createPattern(offscreenPattern.canvas, "repeat");
        this.setPatternTransform(pattern, pixelRatio);
        offscreenPattern.destroy();
        return pattern;
    }
    setPatternTransform(pattern, pixelRatio, tx = 0, ty = 0) {
        const angle2 = $d77b025aa58d633c$var$normalizeAngle360FromDegrees(this.rotation);
        const scale2 = 1 / pixelRatio;
        const cos = Math.cos(angle2) * scale2;
        const sin = Math.sin(angle2) * scale2;
        pattern?.setTransform(new DOMMatrix([
            cos,
            sin,
            -sin,
            cos,
            tx,
            ty
        ]));
    }
    createPattern(ctx, pixelRatio) {
        if (this._cache != null && this._cache.ctx === ctx && this._cache.pixelRatio === pixelRatio) return this._cache.pattern;
        const pattern = this.createCanvasPattern(ctx, pixelRatio);
        if (pattern == null) return;
        this._cache = {
            ctx: ctx,
            pattern: pattern,
            pixelRatio: pixelRatio
        };
        return pattern;
    }
    toSvg() {
        const { width: width2, height: height2, fill: fill, fillOpacity: fillOpacity, backgroundFill: backgroundFill, backgroundFillOpacity: backgroundFillOpacity, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, rotation: rotation, scale: scale2 } = this;
        const pattern = (0, $idDdm.createSvgElement)("pattern");
        pattern.setAttribute("viewBox", `0 0 ${width2} ${height2}`);
        pattern.setAttribute("width", String(width2));
        pattern.setAttribute("height", String(height2));
        pattern.setAttribute("patternUnits", "userSpaceOnUse");
        const rect = (0, $idDdm.createSvgElement)("rect");
        rect.setAttribute("x", "0");
        rect.setAttribute("y", "0");
        rect.setAttribute("width", String(width2));
        rect.setAttribute("height", String(height2));
        rect.setAttribute("fill", backgroundFill);
        rect.setAttribute("fill-opacity", String(backgroundFillOpacity));
        pattern.appendChild(rect);
        const path = (0, $idDdm.createSvgElement)("path");
        path.setAttribute("fill", fill);
        path.setAttribute("fill-opacity", String(fillOpacity));
        path.setAttribute("stroke-opacity", String(strokeOpacity));
        path.setAttribute("stroke", stroke2);
        path.setAttribute("stroke-width", String(strokeWidth));
        path.setAttribute("transform", `rotate(${rotation}) scale(${scale2})`);
        path.setAttribute("d", this.getPath(1).toSVG());
        pattern.appendChild(path);
        return pattern;
    }
};
function $d77b025aa58d633c$var$isGradientFill(fill) {
    return (0, $idDdm.isObject)(fill) && fill.type == "gradient";
}
function $d77b025aa58d633c$var$isStringFillArray(fills) {
    return (0, $idDdm.isArray)(fills) && fills.every((fill)=>typeof fill === "string");
}
function $d77b025aa58d633c$var$isPatternFill(fill) {
    return fill !== null && (0, $idDdm.isObject)(fill) && fill.type == "pattern";
}
function $d77b025aa58d633c$var$isImageFill(fill) {
    return fill !== null && (0, $idDdm.isObject)(fill) && fill.type == "image";
}
function $d77b025aa58d633c$var$isGradientOrPatternFill(fill) {
    return $d77b025aa58d633c$var$isGradientFill(fill) || $d77b025aa58d633c$var$isPatternFill(fill);
}
// packages/ag-charts-community/src/scene/shape/shape.ts
var $d77b025aa58d633c$var$_Shape = class _Shape extends $d77b025aa58d633c$var$Node2 {
    constructor(){
        super(...arguments);
        this.fillOpacity = 1;
        this.strokeOpacity = 1;
        this.fill = _Shape.defaultStyles.fill;
        this.stroke = _Shape.defaultStyles.stroke;
        this.strokeWidth = _Shape.defaultStyles.strokeWidth;
        this.lineDash = _Shape.defaultStyles.lineDash;
        this.lineDashOffset = _Shape.defaultStyles.lineDashOffset;
        this.lineCap = _Shape.defaultStyles.lineCap;
        this.lineJoin = _Shape.defaultStyles.lineJoin;
        this.miterLimit = void 0;
        this.opacity = _Shape.defaultStyles.opacity;
        this.fillShadow = _Shape.defaultStyles.fillShadow;
    }
    /**
   * Restores the default styles introduced by this subclass.
   */ restoreOwnStyles() {
        const { defaultStyles: defaultStyles } = this.constructor;
        Object.assign(this, defaultStyles);
    }
    getGradient(fill) {
        if ($d77b025aa58d633c$var$isGradientFill(fill)) return this.createGradient(fill);
    }
    createGradient(fill) {
        const { colorSpace: colorSpace = "rgb", gradient: gradient2 = "linear", colorStops: colorStops, rotation: rotation = 0, reverse: reverse = false } = fill;
        if (colorStops == null) return;
        let stops = $d77b025aa58d633c$var$getColorStops(colorStops, [
            "black"
        ], [
            0,
            1
        ]);
        if (reverse) stops = stops.map((s)=>({
                color: s.color,
                stop: 1 - s.stop
            })).reverse();
        switch(gradient2){
            case "linear":
                return new $d77b025aa58d633c$var$LinearGradient(colorSpace, stops, rotation);
            case "radial":
                return new $d77b025aa58d633c$var$RadialGradient(colorSpace, stops);
            case "conic":
                return new $d77b025aa58d633c$var$ConicGradient(colorSpace, stops, rotation);
        }
    }
    getPattern(fill) {
        if ($d77b025aa58d633c$var$isPatternFill(fill)) return this.createPattern(fill);
    }
    createPattern(fill) {
        return new $d77b025aa58d633c$var$Pattern(fill);
    }
    getImage(fill) {
        if ($d77b025aa58d633c$var$isImageFill(fill)) return this.createImage(fill);
    }
    createImage(fill) {
        return new $d77b025aa58d633c$var$Image2(this.imageLoader, fill);
    }
    onFillChange() {
        if (typeof this.fill === "object") {
            if ($d77b025aa58d633c$var$objectsEqual(this._cachedFill ?? {}, this.fill)) return;
        }
        this.fillGradient = this.getGradient(this.fill);
        this.fillPattern = this.getPattern(this.fill);
        this.fillImage = this.getImage(this.fill);
        this._cachedFill = this.fill;
    }
    onStrokeChange() {
        this.strokeGradient = this.getGradient(this.stroke);
    }
    /**
   * Returns a device-pixel aligned coordinate (or length if length is supplied).
   *
   * NOTE: Not suitable for strokes, since the stroke needs to be offset to the middle
   * of a device pixel.
   */ align(start2, length2) {
        return $d77b025aa58d633c$var$align(this.layerManager?.canvas?.pixelRatio ?? 1, start2, length2);
    }
    preRender(renderCtx, thisComplexity) {
        if (this.dirty) this.cachedDefaultGradientFillBBox = void 0;
        return super.preRender(renderCtx, thisComplexity);
    }
    fillStroke(ctx, path) {
        this.renderFill(ctx, path);
        this.renderStroke(ctx, path);
    }
    renderFill(ctx, path) {
        const { fill: fill, fillImage: fillImage } = this;
        if (fill && fill !== "none") {
            const { globalAlpha: globalAlpha } = ctx;
            if (fillImage) {
                ctx.globalAlpha = fillImage.backgroundFillOpacity;
                ctx.fillStyle = fillImage.backgroundFill;
                this.executeFill(ctx, path);
                ctx.globalAlpha = globalAlpha;
            }
            this.applyFillAndAlpha(ctx);
            this.applyShadow(ctx);
            this.executeFill(ctx, path);
            ctx.globalAlpha = globalAlpha;
        }
        ctx.shadowColor = "rgba(0, 0, 0, 0)";
    }
    executeFill(ctx, path) {
        if (path) ctx.fill(path);
        else ctx.fill();
    }
    applyFillAndAlpha(ctx) {
        const { fill: fill, fillGradient: fillGradient, fillPattern: fillPattern, fillImage: fillImage, fillOpacity: fillOpacity, opacity: opacity } = this;
        ctx.globalAlpha *= opacity * fillOpacity;
        if (fillGradient) {
            const { fillBBox: fillBBox = this.getDefaultGradientFillBBox() ?? this.getBBox(), fillParams: fillParams } = this;
            ctx.fillStyle = fillGradient.createGradient(ctx, fillBBox, fillParams) ?? "black";
        } else if (fillPattern) {
            const { x: x, y: y } = this.getBBox();
            const pixelRatio = this.layerManager?.canvas?.pixelRatio ?? 1;
            const pattern = fillPattern.createPattern(ctx, pixelRatio);
            fillPattern.setPatternTransform(pattern, pixelRatio, x, y);
            if (pattern) ctx.fillStyle = pattern;
            else {
                ctx.fillStyle = fillPattern.fill;
                ctx.globalAlpha *= fillPattern.fillOpacity;
            }
        } else if (fillImage) {
            const bbox = this.getBBox();
            const image = fillImage.createPattern(ctx, bbox.width, bbox.height, this);
            fillImage.setImageTransform(image, bbox);
            ctx.fillStyle = image ?? "transparent";
        } else ctx.fillStyle = typeof fill === "string" ? fill : "black";
    }
    applyStrokeAndAlpha(ctx) {
        const { stroke: stroke2, strokeOpacity: strokeOpacity, strokeGradient: strokeGradient, opacity: opacity } = this;
        ctx.strokeStyle = strokeGradient?.createGradient(ctx, this.getBBox()) ?? (typeof stroke2 === "string" ? stroke2 : void 0) ?? "black";
        ctx.globalAlpha *= opacity * strokeOpacity;
    }
    applyShadow(ctx) {
        const pixelRatio = this.layerManager?.canvas.pixelRatio ?? 1;
        const fillShadow = this.fillShadow;
        if (fillShadow?.enabled) {
            ctx.shadowColor = fillShadow.color;
            ctx.shadowOffsetX = fillShadow.xOffset * pixelRatio;
            ctx.shadowOffsetY = fillShadow.yOffset * pixelRatio;
            ctx.shadowBlur = fillShadow.blur * pixelRatio;
        }
    }
    renderStroke(ctx, path) {
        const { stroke: stroke2, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset, lineCap: lineCap, lineJoin: lineJoin, miterLimit: miterLimit } = this;
        if (stroke2 && strokeWidth) {
            const { globalAlpha: globalAlpha } = ctx;
            this.applyStrokeAndAlpha(ctx);
            ctx.lineWidth = strokeWidth;
            if (lineDash) ctx.setLineDash(lineDash);
            if (lineDashOffset) ctx.lineDashOffset = lineDashOffset;
            if (lineCap) ctx.lineCap = lineCap;
            if (lineJoin) ctx.lineJoin = lineJoin;
            if (miterLimit != null) ctx.miterLimit = miterLimit;
            this.executeStroke(ctx, path);
            ctx.globalAlpha = globalAlpha;
        }
    }
    executeStroke(ctx, path) {
        if (path) ctx.stroke(path);
        else ctx.stroke();
    }
    getDefaultGradientFillBBox() {
        if (this.cachedDefaultGradientFillBBox == null) this.cachedDefaultGradientFillBBox = Object.freeze(this.computeDefaultGradientFillBBox());
        return this.cachedDefaultGradientFillBBox;
    }
    computeDefaultGradientFillBBox() {
        return;
    }
    containsPoint(x, y) {
        return this.isPointInPath(x, y);
    }
    applySvgFillAttributes(element2, defs) {
        const { fill: fill, fillOpacity: fillOpacity } = this;
        if (typeof fill === "string") element2.setAttribute("fill", fill);
        else if ($d77b025aa58d633c$var$isGradientFill(fill) && this.fillGradient) {
            defs ?? (defs = []);
            const gradient2 = this.fillGradient.toSvg(this.fillBBox ?? this.getBBox());
            const id = (0, $idDdm.generateUUID)();
            gradient2.setAttribute("id", id);
            defs.push(gradient2);
            element2.setAttribute("fill", `url(#${id})`);
        } else if ($d77b025aa58d633c$var$isPatternFill(fill) && this.fillPattern) {
            defs ?? (defs = []);
            const pattern = this.fillPattern.toSvg();
            const id = (0, $idDdm.generateUUID)();
            pattern.setAttribute("id", id);
            defs.push(pattern);
            element2.setAttribute("fill", `url(#${id})`);
        } else if ($d77b025aa58d633c$var$isImageFill(fill) && this.fillImage) {
            defs ?? (defs = []);
            const pixelRatio = this.layerManager?.canvas?.pixelRatio ?? 1;
            const pattern = this.fillImage.toSvg(this.getBBox(), pixelRatio);
            const id = (0, $idDdm.generateUUID)();
            pattern.setAttribute("id", id);
            defs.push(pattern);
            element2.setAttribute("fill", `url(#${id})`);
        } else element2.setAttribute("fill", "none");
        element2.setAttribute("fill-opacity", String(fillOpacity));
        return defs;
    }
    applySvgStrokeAttributes(element2) {
        const { stroke: stroke2, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset } = this;
        if (stroke2 != null) {
            element2.setAttribute("stroke", typeof stroke2 === "string" ? stroke2 : "none");
            element2.setAttribute("stroke-opacity", String(strokeOpacity));
            element2.setAttribute("stroke-width", String(strokeWidth));
        }
        if (lineDash?.some((d)=>d !== 0) === true) {
            const svgLineDash = lineDash.length % 2 === 1 ? [
                ...lineDash,
                ...lineDash
            ] : lineDash;
            element2.setAttribute("stroke-dasharray", svgLineDash.join(" "));
            element2.setAttribute("stroke-dashoffset", String(lineDashOffset));
        }
    }
};
/**
 * Defaults for style properties. Note that properties that affect the position
 * and shape of the node are not considered style properties, for example:
 * `x`, `y`, `width`, `height`, `radius`, `rotation`, etc.
 * Can be used to reset to the original styling after some custom styling
 * has been applied (using the `restoreOwnStyles` method).
 * These static defaults are meant to be inherited by subclasses.
 */ $d77b025aa58d633c$var$_Shape.defaultStyles = {
    fill: "black",
    stroke: void 0,
    strokeWidth: 0,
    lineDash: void 0,
    lineDashOffset: 0,
    lineCap: void 0,
    lineJoin: void 0,
    opacity: 1,
    fillShadow: void 0
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Shape.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Shape.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneObjectChangeDetection({
        equals: $d77b025aa58d633c$var$objectsEqual,
        changeCb: (s)=>s.onFillChange()
    })
], $d77b025aa58d633c$var$_Shape.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneObjectChangeDetection({
        equals: $d77b025aa58d633c$var$objectsEqual,
        changeCb: (s)=>s.onStrokeChange()
    })
], $d77b025aa58d633c$var$_Shape.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Shape.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneArrayChangeDetection()
], $d77b025aa58d633c$var$_Shape.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Shape.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Shape.prototype, "lineCap", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Shape.prototype, "lineJoin", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Shape.prototype, "miterLimit", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        convertor: (v)=>(0, $idDdm.clamp)(0, v, 1)
    })
], $d77b025aa58d633c$var$_Shape.prototype, "opacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneObjectChangeDetection({
        equals: $d77b025aa58d633c$var$TRIPLE_EQ,
        checkDirtyOnAssignment: true
    })
], $d77b025aa58d633c$var$_Shape.prototype, "fillShadow", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneObjectChangeDetection({
        equals: $d77b025aa58d633c$var$BBoxValues.equals,
        changeCb: (s)=>s.onFillChange()
    })
], $d77b025aa58d633c$var$_Shape.prototype, "fillBBox", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneObjectChangeDetection({
        equals: $d77b025aa58d633c$var$objectsEqual,
        changeCb: (s)=>s.onFillChange()
    })
], $d77b025aa58d633c$var$_Shape.prototype, "fillParams", 2);
var $d77b025aa58d633c$var$Shape = $d77b025aa58d633c$var$_Shape;
var $d77b025aa58d633c$var$IDENTITY_MATRIX_ELEMENTS = [
    1,
    0,
    0,
    1,
    0,
    0
];
var $d77b025aa58d633c$var$Matrix = class _Matrix {
    get e() {
        return [
            ...this.elements
        ];
    }
    constructor(elements = $d77b025aa58d633c$var$IDENTITY_MATRIX_ELEMENTS){
        this.elements = [
            ...elements
        ];
    }
    setElements(elements) {
        const e = this.elements;
        e[0] = elements[0];
        e[1] = elements[1];
        e[2] = elements[2];
        e[3] = elements[3];
        e[4] = elements[4];
        e[5] = elements[5];
        return this;
    }
    get identity() {
        const e = this.elements;
        return (0, $idDdm.isNumberEqual)(e[0], 1) && (0, $idDdm.isNumberEqual)(e[1], 0) && (0, $idDdm.isNumberEqual)(e[2], 0) && (0, $idDdm.isNumberEqual)(e[3], 1) && (0, $idDdm.isNumberEqual)(e[4], 0) && (0, $idDdm.isNumberEqual)(e[5], 0);
    }
    /**
   * Performs the AxB matrix multiplication and saves the result
   * to `C`, if given, or to `A` otherwise.
   */ AxB(A, B, C2) {
        const a = A[0] * B[0] + A[2] * B[1], b = A[1] * B[0] + A[3] * B[1], c = A[0] * B[2] + A[2] * B[3], d = A[1] * B[2] + A[3] * B[3], e = A[0] * B[4] + A[2] * B[5] + A[4], f = A[1] * B[4] + A[3] * B[5] + A[5];
        C2 = C2 ?? A;
        C2[0] = a;
        C2[1] = b;
        C2[2] = c;
        C2[3] = d;
        C2[4] = e;
        C2[5] = f;
    }
    /**
   * The `other` matrix gets post-multiplied to the current matrix.
   * Returns the current matrix.
   * @param other
   */ multiplySelf(other) {
        this.AxB(this.elements, other.elements);
        return this;
    }
    /**
   * The `other` matrix gets post-multiplied to the current matrix.
   * Returns a new matrix.
   * @param other
   */ multiply(other) {
        const elements = new Array(6);
        if (other instanceof _Matrix) this.AxB(this.elements, other.elements, elements);
        else this.AxB(this.elements, [
            other.a,
            other.b,
            other.c,
            other.d,
            other.e,
            other.f
        ], elements);
        return new _Matrix(elements);
    }
    preMultiplySelf(other) {
        this.AxB(other.elements, this.elements, this.elements);
        return this;
    }
    /**
   * Returns the inverse of this matrix as a new matrix.
   */ inverse() {
        const el = this.elements;
        let a = el[0], b = el[1], c = el[2], d = el[3];
        const e = el[4], f = el[5];
        const rD = 1 / (a * d - b * c);
        a *= rD;
        b *= rD;
        c *= rD;
        d *= rD;
        return new _Matrix([
            d,
            -b,
            -c,
            a,
            c * f - d * e,
            b * e - a * f
        ]);
    }
    invertSelf() {
        const el = this.elements;
        let a = el[0], b = el[1], c = el[2], d = el[3];
        const e = el[4], f = el[5];
        const rD = 1 / (a * d - b * c);
        a *= rD;
        b *= rD;
        c *= rD;
        d *= rD;
        el[0] = d;
        el[1] = -b;
        el[2] = -c;
        el[3] = a;
        el[4] = c * f - d * e;
        el[5] = b * e - a * f;
        return this;
    }
    transformPoint(x, y) {
        const e = this.elements;
        return {
            x: x * e[0] + y * e[2] + e[4],
            y: x * e[1] + y * e[3] + e[5]
        };
    }
    transformBBox(bbox, target) {
        const el = this.elements;
        const xx = el[0];
        const xy = el[1];
        const yx = el[2];
        const yy = el[3];
        const h_w = bbox.width * 0.5;
        const h_h = bbox.height * 0.5;
        const cx = bbox.x + h_w;
        const cy = bbox.y + h_h;
        const w = Math.abs(h_w * xx) + Math.abs(h_h * yx);
        const h = Math.abs(h_w * xy) + Math.abs(h_h * yy);
        target ?? (target = new $d77b025aa58d633c$var$BBox(0, 0, 0, 0));
        target.x = cx * xx + cy * yx + el[4] - w;
        target.y = cx * xy + cy * yy + el[5] - h;
        target.width = w + w;
        target.height = h + h;
        return target;
    }
    toContext(ctx) {
        if (this.identity) return;
        const e = this.elements;
        ctx.transform(e[0], e[1], e[2], e[3], e[4], e[5]);
    }
    static updateTransformMatrix(matrix, scalingX, scalingY, rotation, translationX, translationY, opts) {
        const sx = scalingX;
        const sy = scalingY;
        let scx;
        let scy;
        if (sx === 1 && sy === 1) {
            scx = 0;
            scy = 0;
        } else {
            scx = opts?.scalingCenterX ?? 0;
            scy = opts?.scalingCenterY ?? 0;
        }
        const r = rotation;
        const cos = Math.cos(r);
        const sin = Math.sin(r);
        let rcx;
        let rcy;
        if (r === 0) {
            rcx = 0;
            rcy = 0;
        } else {
            rcx = opts?.rotationCenterX ?? 0;
            rcy = opts?.rotationCenterY ?? 0;
        }
        const tx = translationX;
        const ty = translationY;
        const tx4 = scx * (1 - sx) - rcx;
        const ty4 = scy * (1 - sy) - rcy;
        matrix.setElements([
            cos * sx,
            sin * sx,
            -sin * sy,
            cos * sy,
            cos * tx4 - sin * ty4 + rcx + tx,
            sin * tx4 + cos * ty4 + rcy + ty
        ]);
        return matrix;
    }
};
// packages/ag-charts-community/src/scene/transformable.ts
function $d77b025aa58d633c$var$isMatrixTransform(node) {
    return $d77b025aa58d633c$var$isMatrixTransformType(node.constructor);
}
var $d77b025aa58d633c$var$MATRIX_TRANSFORM_TYPE = Symbol("isMatrixTransform");
function $d77b025aa58d633c$var$isMatrixTransformType(cstr) {
    return cstr[$d77b025aa58d633c$var$MATRIX_TRANSFORM_TYPE] === true;
}
function $d77b025aa58d633c$var$MatrixTransform(Parent) {
    var _a, _b;
    const ParentNode = Parent;
    if ($d77b025aa58d633c$var$isMatrixTransformType(Parent)) return Parent;
    const TRANSFORM_MATRIX = Symbol("matrix_combined_transform");
    class MatrixTransformInternal extends ParentNode {
        constructor(){
            super(...arguments);
            this[_b] = new $d77b025aa58d633c$var$Matrix();
            this._dirtyTransform = true;
        }
        markDirtyTransform() {
            this._dirtyTransform = true;
            super.markDirty();
        }
        onChangeDetection(property) {
            super.onChangeDetection(property);
            this.markDirtyTransform();
        }
        updateMatrix(_matrix) {}
        computeTransformMatrix() {
            if (!this._dirtyTransform) return;
            this[TRANSFORM_MATRIX].setElements($d77b025aa58d633c$var$IDENTITY_MATRIX_ELEMENTS);
            this.updateMatrix(this[TRANSFORM_MATRIX]);
            this._dirtyTransform = false;
        }
        toParent(bbox) {
            this.computeTransformMatrix();
            if (this[TRANSFORM_MATRIX].identity) return bbox.clone();
            return this[TRANSFORM_MATRIX].transformBBox(bbox);
        }
        toParentPoint(x, y) {
            this.computeTransformMatrix();
            if (this[TRANSFORM_MATRIX].identity) return {
                x: x,
                y: y
            };
            return this[TRANSFORM_MATRIX].transformPoint(x, y);
        }
        fromParent(bbox) {
            this.computeTransformMatrix();
            if (this[TRANSFORM_MATRIX].identity) return bbox.clone();
            return this[TRANSFORM_MATRIX].inverse().transformBBox(bbox);
        }
        fromParentPoint(x, y) {
            this.computeTransformMatrix();
            if (this[TRANSFORM_MATRIX].identity) return {
                x: x,
                y: y
            };
            return this[TRANSFORM_MATRIX].inverse().transformPoint(x, y);
        }
        computeBBox() {
            const bbox = super.computeBBox();
            if (!bbox) return bbox;
            return this.toParent(bbox);
        }
        computeBBoxWithoutTransforms() {
            return super.computeBBox();
        }
        pickNode(x, y) {
            ({ x: x, y: y } = this.fromParentPoint(x, y));
            return super.pickNode(x, y);
        }
        pickNodes(x, y, into) {
            ({ x: x, y: y } = this.fromParentPoint(x, y));
            return super.pickNodes(x, y, into);
        }
        render(renderCtx) {
            this.computeTransformMatrix();
            const { ctx: ctx } = renderCtx;
            const matrix = this[TRANSFORM_MATRIX];
            let performRestore = false;
            if (!matrix.identity) {
                ctx.save();
                performRestore = true;
                matrix.toContext(ctx);
            }
            super.render(renderCtx);
            if (performRestore) ctx.restore();
        }
        toSVG() {
            this.computeTransformMatrix();
            const svg = super.toSVG();
            const matrix = this[TRANSFORM_MATRIX];
            if (matrix.identity || svg == null) return svg;
            const g = (0, $idDdm.createSvgElement)("g");
            g.append(...svg.elements);
            const [a, b, c, d, e, f] = matrix.e;
            g.setAttribute("transform", `matrix(${a} ${b} ${c} ${d} ${e} ${f})`);
            return {
                elements: [
                    g
                ],
                defs: svg.defs
            };
        }
    }
    _a = $d77b025aa58d633c$var$MATRIX_TRANSFORM_TYPE, _b = TRANSFORM_MATRIX;
    MatrixTransformInternal[_a] = true;
    return MatrixTransformInternal;
}
function $d77b025aa58d633c$var$Rotatable(Parent) {
    var _a;
    const ParentNode = Parent;
    const ROTATABLE_MATRIX = Symbol("matrix_rotation");
    class RotatableInternal extends $d77b025aa58d633c$var$MatrixTransform(ParentNode) {
        constructor(){
            super(...arguments);
            this[_a] = new $d77b025aa58d633c$var$Matrix();
            this.rotationCenterX = 0;
            this.rotationCenterY = 0;
            this.rotation = 0;
        }
        updateMatrix(matrix) {
            super.updateMatrix(matrix);
            const { rotation: rotation, rotationCenterX: rotationCenterX, rotationCenterY: rotationCenterY } = this;
            if (rotation === 0) return;
            $d77b025aa58d633c$var$Matrix.updateTransformMatrix(this[ROTATABLE_MATRIX], 1, 1, rotation, 0, 0, {
                rotationCenterX: rotationCenterX,
                rotationCenterY: rotationCenterY
            });
            matrix.multiplySelf(this[ROTATABLE_MATRIX]);
        }
    }
    _a = ROTATABLE_MATRIX;
    $d77b025aa58d633c$var$__decorateClass([
        $d77b025aa58d633c$var$SceneChangeDetection()
    ], RotatableInternal.prototype, "rotationCenterX", 2);
    $d77b025aa58d633c$var$__decorateClass([
        $d77b025aa58d633c$var$SceneChangeDetection()
    ], RotatableInternal.prototype, "rotationCenterY", 2);
    $d77b025aa58d633c$var$__decorateClass([
        $d77b025aa58d633c$var$SceneChangeDetection()
    ], RotatableInternal.prototype, "rotation", 2);
    return RotatableInternal;
}
function $d77b025aa58d633c$var$Scalable(Parent) {
    var _a;
    const ParentNode = Parent;
    const SCALABLE_MATRIX = Symbol("matrix_scale");
    class ScalableInternal extends $d77b025aa58d633c$var$MatrixTransform(ParentNode) {
        constructor(){
            super(...arguments);
            this[_a] = new $d77b025aa58d633c$var$Matrix();
            this.scalingX = 1;
            this.scalingY = 1;
            this.scalingCenterX = 0;
            this.scalingCenterY = 0;
        }
        updateMatrix(matrix) {
            super.updateMatrix(matrix);
            const { scalingX: scalingX, scalingY: scalingY, scalingCenterX: scalingCenterX, scalingCenterY: scalingCenterY } = this;
            if (scalingX === 1 && scalingY === 1) return;
            $d77b025aa58d633c$var$Matrix.updateTransformMatrix(this[SCALABLE_MATRIX], scalingX, scalingY, 0, 0, 0, {
                scalingCenterX: scalingCenterX,
                scalingCenterY: scalingCenterY
            });
            matrix.multiplySelf(this[SCALABLE_MATRIX]);
        }
    }
    _a = SCALABLE_MATRIX;
    $d77b025aa58d633c$var$__decorateClass([
        $d77b025aa58d633c$var$SceneChangeDetection()
    ], ScalableInternal.prototype, "scalingX", 2);
    $d77b025aa58d633c$var$__decorateClass([
        $d77b025aa58d633c$var$SceneChangeDetection()
    ], ScalableInternal.prototype, "scalingY", 2);
    $d77b025aa58d633c$var$__decorateClass([
        $d77b025aa58d633c$var$SceneChangeDetection()
    ], ScalableInternal.prototype, "scalingCenterX", 2);
    $d77b025aa58d633c$var$__decorateClass([
        $d77b025aa58d633c$var$SceneChangeDetection()
    ], ScalableInternal.prototype, "scalingCenterY", 2);
    return ScalableInternal;
}
function $d77b025aa58d633c$var$Translatable(Parent) {
    var _a;
    const ParentNode = Parent;
    const TRANSLATABLE_MATRIX = Symbol("matrix_translation");
    class TranslatableInternal extends $d77b025aa58d633c$var$MatrixTransform(ParentNode) {
        constructor(){
            super(...arguments);
            this[_a] = new $d77b025aa58d633c$var$Matrix();
            this.translationX = 0;
            this.translationY = 0;
        }
        updateMatrix(matrix) {
            super.updateMatrix(matrix);
            const { translationX: translationX, translationY: translationY } = this;
            if (translationX === 0 && translationY === 0) return;
            $d77b025aa58d633c$var$Matrix.updateTransformMatrix(this[TRANSLATABLE_MATRIX], 1, 1, 0, translationX, translationY);
            matrix.multiplySelf(this[TRANSLATABLE_MATRIX]);
        }
    }
    _a = TRANSLATABLE_MATRIX;
    $d77b025aa58d633c$var$__decorateClass([
        $d77b025aa58d633c$var$SceneChangeDetection()
    ], TranslatableInternal.prototype, "translationX", 2);
    $d77b025aa58d633c$var$__decorateClass([
        $d77b025aa58d633c$var$SceneChangeDetection()
    ], TranslatableInternal.prototype, "translationY", 2);
    return TranslatableInternal;
}
var $d77b025aa58d633c$var$Transformable = class {
    /**
   * Converts a BBox from canvas coordinate space into the coordinate space of the given Node.
   */ static fromCanvas(node, bbox) {
        const parents = [];
        for (const parent of node.traverseUp())if ($d77b025aa58d633c$var$isMatrixTransform(parent)) parents.unshift(parent);
        for (const parent of parents)bbox = parent.fromParent(bbox);
        if ($d77b025aa58d633c$var$isMatrixTransform(node)) bbox = node.fromParent(bbox);
        return bbox;
    }
    /**
   * Converts a Nodes BBox (or an arbitrary BBox if supplied) from local Node coordinate space
   * into the Canvas coordinate space.
   */ static toCanvas(node, bbox) {
        if (bbox == null) bbox = node.getBBox();
        else if ($d77b025aa58d633c$var$isMatrixTransform(node)) bbox = node.toParent(bbox);
        for (const parent of node.traverseUp())if ($d77b025aa58d633c$var$isMatrixTransform(parent)) bbox = parent.toParent(bbox);
        return bbox;
    }
    /**
   * Converts a point from canvas coordinate space into the coordinate space of the given Node.
   */ static fromCanvasPoint(node, x, y) {
        const parents = [];
        for (const parent of node.traverseUp())if ($d77b025aa58d633c$var$isMatrixTransform(parent)) parents.unshift(parent);
        for (const parent of parents)({ x: x, y: y } = parent.fromParentPoint(x, y));
        if ($d77b025aa58d633c$var$isMatrixTransform(node)) ({ x: x, y: y } = node.fromParentPoint(x, y));
        return {
            x: x,
            y: y
        };
    }
    /**
   * Converts a point from a Nodes local coordinate space into the Canvas coordinate space.
   */ static toCanvasPoint(node, x, y) {
        if ($d77b025aa58d633c$var$isMatrixTransform(node)) ({ x: x, y: y } = node.toParentPoint(x, y));
        for (const parent of node.traverseUp())if ($d77b025aa58d633c$var$isMatrixTransform(parent)) ({ x: x, y: y } = parent.toParentPoint(x, y));
        return {
            x: x,
            y: y
        };
    }
};
// packages/ag-charts-community/src/scene/zIndex.ts
var $d77b025aa58d633c$var$cmp = (a, b)=>Math.sign(a - b);
function $d77b025aa58d633c$var$compareZIndex(a, b) {
    if (typeof a === "number" && typeof b === "number") return $d77b025aa58d633c$var$cmp(a, b);
    const aArray = typeof a === "number" ? [
        a
    ] : a;
    const bArray = typeof b === "number" ? [
        b
    ] : b;
    const length2 = Math.min(aArray.length, bArray.length);
    for(let i = 0; i < length2; i += 1){
        const diff2 = $d77b025aa58d633c$var$cmp(aArray[i], bArray[i]);
        if (diff2 !== 0) return diff2;
    }
    return $d77b025aa58d633c$var$cmp(aArray.length, bArray.length);
}
// packages/ag-charts-community/src/scene/group.ts
var $d77b025aa58d633c$var$sharedOffscreenCanvas;
var $d77b025aa58d633c$var$_Group = class _Group extends $d77b025aa58d633c$var$Node2 {
    // optimizeForInfrequentRedraws: true
    constructor(opts){
        super(opts);
        this.opacity = 1;
        this.renderToOffscreenCanvas = false;
        this.optimizeForInfrequentRedraws = false;
        // Used when renderToOffscreenCanvas: true
        this.layer = void 0;
        // optimizeForInfrequentRedraws: false
        this.image = void 0;
        this._lastWidth = NaN;
        this._lastHeight = NaN;
        this._lastDevicePixelRatio = NaN;
        this.isContainerNode = true;
        this.renderToOffscreenCanvas = opts?.renderToOffscreenCanvas === true;
    }
    static is(value) {
        return value instanceof _Group;
    }
    static computeChildrenBBox(nodes, skipInvisible = true) {
        return $d77b025aa58d633c$var$BBox.merge($d77b025aa58d633c$var$Node2.extractBBoxes(nodes, skipInvisible));
    }
    static compareChildren(a, b) {
        return $d77b025aa58d633c$var$compareZIndex(a.zIndex, b.zIndex) || a.serialNumber - b.serialNumber;
    }
    // We consider a group to be boundless, thus any point belongs to it.
    containsPoint(_x, _y) {
        return true;
    }
    computeBBox() {
        return _Group.computeChildrenBBox(this.children());
    }
    computeSafeClippingBBox(pixelRatio) {
        const bbox = this.computeBBox();
        if (!bbox.isFinite()) return;
        let strokeWidth = 0;
        const strokeMiterAmount = 4;
        for (const child of this.descendants())if (child instanceof $d77b025aa58d633c$var$Shape) strokeWidth = Math.max(strokeWidth, child.strokeWidth);
        const padding = Math.max(// Account for anti-aliasing artefacts
        1, // Account for strokes (incl. miters) - this may not be the best place to include this
        strokeWidth / 2 * strokeMiterAmount);
        const { x: originX, y: originY } = $d77b025aa58d633c$var$Transformable.toCanvasPoint(this, 0, 0);
        const x = $d77b025aa58d633c$var$alignBefore(pixelRatio, originX + bbox.x - padding) - originX;
        const y = $d77b025aa58d633c$var$alignBefore(pixelRatio, originY + bbox.y - padding) - originY;
        const width2 = Math.ceil(bbox.x + bbox.width - x + padding);
        const height2 = Math.ceil(bbox.y + bbox.height - y + padding);
        return new $d77b025aa58d633c$var$BBox(x, y, width2, height2);
    }
    prepareSharedCanvas(width2, height2, pixelRatio) {
        if ($d77b025aa58d633c$var$sharedOffscreenCanvas == null || $d77b025aa58d633c$var$sharedOffscreenCanvas.pixelRatio !== pixelRatio) $d77b025aa58d633c$var$sharedOffscreenCanvas = new $d77b025aa58d633c$var$HdpiOffscreenCanvas({
            width: width2,
            height: height2,
            pixelRatio: pixelRatio
        });
        else $d77b025aa58d633c$var$sharedOffscreenCanvas.resize(width2, height2, pixelRatio);
        return $d77b025aa58d633c$var$sharedOffscreenCanvas;
    }
    isDirty(renderCtx) {
        const { width: width2, height: height2, devicePixelRatio: devicePixelRatio } = renderCtx;
        const { dirty: dirty, dirtyZIndex: dirtyZIndex, layer: layer } = this;
        const layerResized = layer != null && (this._lastWidth !== width2 || this._lastHeight !== height2);
        const pixelRatioChanged = this._lastDevicePixelRatio !== devicePixelRatio;
        this._lastWidth = width2;
        this._lastHeight = height2;
        this._lastDevicePixelRatio = devicePixelRatio;
        if (dirty || dirtyZIndex || layerResized || pixelRatioChanged) return true;
        for (const child of this.children()){
            if (child.dirty) return true;
        }
        return false;
    }
    preRender(renderCtx) {
        const counts = super.preRender(renderCtx, 0);
        counts.groups += 1;
        counts.nonGroups -= 1;
        if (this.renderToOffscreenCanvas && !this.optimizeForInfrequentRedraws && counts.nonGroups > 0 && this.getVisibility()) this.layer ?? (this.layer = this.layerManager?.addLayer({
            name: this.name
        }));
        else if (this.layer != null) {
            this.layerManager?.removeLayer(this.layer);
            this.layer = void 0;
        }
        return counts;
    }
    render(renderCtx) {
        const { layer: layer, renderToOffscreenCanvas: renderToOffscreenCanvas } = this;
        const childRenderCtx = {
            ...renderCtx
        };
        if (!renderToOffscreenCanvas) {
            this.renderInContext(childRenderCtx);
            super.render(childRenderCtx);
            return;
        }
        const { ctx: ctx, stats: stats, devicePixelRatio: pixelRatio } = renderCtx;
        let { image: image } = this;
        if (this.isDirty(renderCtx)) {
            image?.bitmap.close();
            image = void 0;
            const bbox = layer ? void 0 : this.computeSafeClippingBBox(pixelRatio);
            const renderOffscreen = (offscreenCanvas, ...transform)=>{
                const offscreenCtx = offscreenCanvas.context;
                childRenderCtx.ctx = offscreenCtx;
                offscreenCanvas.clear();
                offscreenCtx.save();
                offscreenCtx.setTransform(...transform);
                offscreenCtx.globalAlpha = 1;
                this.renderInContext(childRenderCtx);
                offscreenCtx.restore();
                offscreenCtx.verifyDepthZero?.();
            };
            if (layer) renderOffscreen(layer, ctx.getTransform());
            else if (bbox) {
                const { x: x, y: y, width: width2, height: height2 } = bbox;
                const canvas = this.prepareSharedCanvas(width2, height2, pixelRatio);
                renderOffscreen(canvas, pixelRatio, 0, 0, pixelRatio, -x * pixelRatio, -y * pixelRatio);
                image = {
                    bitmap: canvas.transferToImageBitmap(),
                    x: x,
                    y: y,
                    width: width2,
                    height: height2
                };
            } else if (this.dirtyZIndex) this.sortChildren(_Group.compareChildren);
            this.image = image;
            if (stats) stats.layersRendered++;
        } else {
            this.skipRender(childRenderCtx);
            if (stats) stats.layersSkipped++;
        }
        const { globalAlpha: globalAlpha } = ctx;
        ctx.globalAlpha = globalAlpha * this.opacity;
        if (layer) {
            ctx.save();
            ctx.resetTransform();
            layer.drawImage(ctx);
            ctx.restore();
        } else if (image) {
            const { bitmap: bitmap, x: x, y: y, width: width2, height: height2 } = image;
            ctx.drawImage(bitmap, 0, 0, width2 * pixelRatio, height2 * pixelRatio, x, y, width2, height2);
        }
        ctx.globalAlpha = globalAlpha;
        super.render(childRenderCtx);
    }
    skipRender(childRenderCtx) {
        const { stats: stats } = childRenderCtx;
        for (const child of this.children()){
            child.markClean();
            if (stats) {
                stats.nodesSkipped += this.childNodeCounts.groups + this.childNodeCounts.nonGroups;
                stats.opsSkipped += this.childNodeCounts.complexity;
            }
        }
    }
    applyClip(ctx, clipRect) {
        const { x: x, y: y, width: width2, height: height2 } = clipRect;
        ctx.beginPath();
        ctx.rect(x, y, width2, height2);
        ctx.clip();
    }
    renderInContext(childRenderCtx) {
        const { ctx: ctx, stats: stats } = childRenderCtx;
        if (this.dirtyZIndex) this.sortChildren(_Group.compareChildren);
        ctx.save();
        ctx.globalAlpha *= this.opacity;
        if (this.clipRect != null) {
            this.applyClip(ctx, this.clipRect);
            childRenderCtx.clipBBox = $d77b025aa58d633c$var$Transformable.toCanvas(this, this.clipRect);
        }
        for (const child of this.children()){
            if (!child.visible) {
                child.markClean();
                if (stats) {
                    stats.nodesSkipped += child.childNodeCounts.nonGroups + child.childNodeCounts.groups;
                    stats.opsSkipped += child.childNodeCounts.complexity;
                }
                continue;
            }
            ctx.save();
            child.render(childRenderCtx);
            ctx.restore();
        }
        ctx.restore();
    }
    /**
   * Transforms bbox given in the canvas coordinate space to bbox in this group's coordinate space and
   * sets this group's clipRect to the transformed bbox.
   * @param bbox clipRect bbox in the canvas coordinate space.
   */ setClipRect(bbox) {
        this.clipRect = bbox ? $d77b025aa58d633c$var$Transformable.fromCanvas(this, bbox) : void 0;
    }
    /**
   * Set the clip rect within the canvas coordinate space.
   * @param bbox clipRect bbox in the canvas coordinate space.
   */ setClipRectCanvasSpace(bbox) {
        this.clipRect = bbox;
    }
    setScene(scene) {
        if (this.layer) {
            this.scene?.layersManager.removeLayer(this.layer);
            this.layer = void 0;
        }
        super.setScene(scene);
    }
    getVisibility() {
        for (const node of this.traverseUp(true)){
            if (!node.visible) return false;
        }
        return true;
    }
    toSVG() {
        if (!this.visible) return;
        const defs = [];
        const elements = [];
        for (const child of this.children()){
            const svg = child.toSVG();
            if (svg != null) {
                elements.push(...svg.elements);
                if (svg.defs != null) defs.push(...svg.defs);
            }
        }
        return {
            elements: elements,
            defs: defs
        };
    }
};
$d77b025aa58d633c$var$_Group.className = "Group";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        convertor: (v)=>(0, $idDdm.clamp)(0, v, 1)
    })
], $d77b025aa58d633c$var$_Group.prototype, "opacity", 2);
var $d77b025aa58d633c$var$Group = $d77b025aa58d633c$var$_Group;
var $d77b025aa58d633c$var$ScalableGroup = class extends $d77b025aa58d633c$var$Scalable($d77b025aa58d633c$var$Group) {
};
var $d77b025aa58d633c$var$RotatableGroup = class extends $d77b025aa58d633c$var$Rotatable($d77b025aa58d633c$var$Group) {
};
var $d77b025aa58d633c$var$TranslatableGroup = class extends $d77b025aa58d633c$var$Translatable($d77b025aa58d633c$var$Group) {
};
var $d77b025aa58d633c$var$TransformableGroup = class extends $d77b025aa58d633c$var$Rotatable($d77b025aa58d633c$var$Translatable($d77b025aa58d633c$var$Group)) {
};
function $d77b025aa58d633c$var$setElementBBox(element2, bbox) {
    if (!element2) return;
    bbox = $d77b025aa58d633c$var$BBoxValues.normalize(bbox);
    if (bbox.width == null) element2.style.removeProperty("width");
    else element2.style.width = `${bbox.width}px`;
    if (bbox.height == null) element2.style.removeProperty("height");
    else element2.style.height = `${bbox.height}px`;
    if (bbox.x == null) element2.style.removeProperty("left");
    else element2.style.left = `${bbox.x}px`;
    if (bbox.y == null) element2.style.removeProperty("top");
    else element2.style.top = `${bbox.y}px`;
}
function $d77b025aa58d633c$var$getElementBBox(element2) {
    const width2 = parseFloat(element2.style.width) || element2.offsetWidth;
    const height2 = parseFloat(element2.style.height) || element2.offsetHeight;
    const x = parseFloat(element2.style.left) || element2.offsetLeft;
    const y = parseFloat(element2.style.top) || element2.offsetTop;
    return {
        x: x,
        y: y,
        width: width2,
        height: height2
    };
}
function $d77b025aa58d633c$var$focusCursorAtEnd(element2) {
    element2.focus({
        preventScroll: true
    });
    if (element2.lastChild?.textContent == null) return;
    const range3 = (0, $idDdm.getDocument)().createRange();
    range3.setStart(element2.lastChild, element2.lastChild.textContent.length);
    range3.setEnd(element2.lastChild, element2.lastChild.textContent.length);
    const selection = (0, $idDdm.getWindow)().getSelection();
    selection?.removeAllRanges();
    selection?.addRange(range3);
}
function $d77b025aa58d633c$var$isInputPending() {
    const navigator = (0, $idDdm.getWindow)("navigator");
    if ("scheduling" in navigator) {
        const scheduling = navigator.scheduling;
        if ("isInputPending" in scheduling) return scheduling.isInputPending({
            includeContinuous: true
        });
    }
    return false;
}
function $d77b025aa58d633c$var$getIconClassNames(icon) {
    return `ag-charts-icon ag-charts-icon-${icon}`;
}
var $d77b025aa58d633c$var$CLASS_INSTANCE_TYPE = "class-instance";
function $d77b025aa58d633c$var$jsonDiff(source, target, shallow) {
    if ((0, $idDdm.isArray)(target)) {
        if (!(0, $idDdm.isArray)(source) || source.length !== target.length || target.some((v, i)=>$d77b025aa58d633c$var$jsonDiff(source[i], v, shallow) != null)) return target;
    } else if ((0, $idDdm.isPlainObject)(target)) {
        if (!(0, $idDdm.isPlainObject)(source)) return target;
        const result = {};
        const allKeys = /* @__PURE__ */ new Set([
            ...Object.keys(source),
            ...Object.keys(target)
        ]);
        for (const key of allKeys){
            if (source[key] === target[key]) continue;
            else if (shallow?.has(key)) result[key] = target[key];
            else if (typeof source[key] === typeof target[key]) {
                const diff2 = $d77b025aa58d633c$var$jsonDiff(source[key], target[key], shallow);
                if (diff2 !== null) result[key] = diff2;
            } else result[key] = target[key];
        }
        return Object.keys(result).length ? result : null;
    } else if (source !== target) return target;
    return null;
}
function $d77b025aa58d633c$var$jsonPropertyCompare(source, target) {
    for (const key of Object.keys(source)){
        if (source[key] === target?.[key]) continue;
        return false;
    }
    return true;
}
function $d77b025aa58d633c$var$deepClone(source, opts) {
    if ((0, $idDdm.isArray)(source)) return $d77b025aa58d633c$var$cloneArray(source, opts);
    if ((0, $idDdm.isPlainObject)(source)) return $d77b025aa58d633c$var$clonePlainObject(source, opts);
    if (source instanceof Map) return new Map($d77b025aa58d633c$var$deepClone(Array.from(source)));
    return $d77b025aa58d633c$var$shallowClone(source);
}
function $d77b025aa58d633c$var$cloneArray(source, opts) {
    const result = [];
    const seen = opts?.seen;
    for (const item of source){
        if (typeof item === "object" && seen?.includes(item)) {
            (0, $idDdm.Logger).warn("cycle detected in array", item);
            continue;
        }
        seen?.push(item);
        result.push($d77b025aa58d633c$var$deepClone(item, opts));
        seen?.pop();
    }
    return result;
}
function $d77b025aa58d633c$var$clonePlainObject(source, opts) {
    const target = {};
    for (const key of Object.keys(source)){
        if (opts?.assign?.has(key)) target[key] = source[key];
        else if (opts?.shallow?.has(key)) target[key] = $d77b025aa58d633c$var$shallowClone(source[key]);
        else target[key] = $d77b025aa58d633c$var$deepClone(source[key], opts);
    }
    return target;
}
function $d77b025aa58d633c$var$shallowClone(source) {
    if ((0, $idDdm.isArray)(source)) return source.slice(0);
    if ((0, $idDdm.isPlainObject)(source)) return {
        ...source
    };
    if ((0, $idDdm.isDate)(source)) return new Date(source);
    if ((0, $idDdm.isRegExp)(source)) return new RegExp(source.source, source.flags);
    return source;
}
function $d77b025aa58d633c$var$jsonWalk(json, visit, skip, parallelJson, ctx, acc) {
    if ((0, $idDdm.isArray)(json)) {
        acc = visit(json, parallelJson, ctx, acc);
        let index = 0;
        for (const node of json){
            acc = $d77b025aa58d633c$var$jsonWalk(node, visit, skip, parallelJson?.[index], ctx, acc);
            index++;
        }
    } else if ((0, $idDdm.isPlainObject)(json)) {
        acc = visit(json, parallelJson, ctx, acc);
        for (const key of Object.keys(json)){
            if (skip?.has(key)) continue;
            const value = json[key];
            acc = $d77b025aa58d633c$var$jsonWalk(value, visit, skip, parallelJson?.[key], ctx, acc);
        }
    }
    return acc;
}
function $d77b025aa58d633c$var$jsonApply(target, source, params = {}) {
    const { path: path, matcherPath: matcherPath = path?.replace(/(\[[0-9+]+])/i, "[]"), skip: skip = [] } = params;
    if (target == null) throw new Error(`AG Charts - target is uninitialised: ${path ?? "<root>"}`);
    if (source == null) return target;
    if ($d77b025aa58d633c$var$isProperties(target)) return target.set(source);
    const targetAny = target;
    const targetType = $d77b025aa58d633c$var$classify(target);
    for (const property of Object.keys(source)){
        if ($d77b025aa58d633c$var$SKIP_JS_BUILTINS.has(property)) continue;
        const propertyMatcherPath = `${matcherPath ? matcherPath + "." : ""}${property}`;
        if (skip.includes(propertyMatcherPath)) continue;
        const newValue = source[property];
        const propertyPath = `${path ? path + "." : ""}${property}`;
        const targetClass = targetAny.constructor;
        const currentValue = targetAny[property];
        try {
            const currentValueType = $d77b025aa58d633c$var$classify(currentValue);
            const newValueType = $d77b025aa58d633c$var$classify(newValue);
            if (targetType === $d77b025aa58d633c$var$CLASS_INSTANCE_TYPE && !(property in target || property === "context")) {
                if (newValue === void 0) continue;
                (0, $idDdm.Logger).warn(`unable to set [${propertyPath}] in ${targetClass?.name} - property is unknown`);
                continue;
            }
            if (currentValueType != null && newValueType != null && newValueType !== currentValueType && (currentValueType !== $d77b025aa58d633c$var$CLASS_INSTANCE_TYPE || newValueType !== "object")) {
                (0, $idDdm.Logger).warn(`unable to set [${propertyPath}] in ${targetClass?.name} - can't apply type of [${newValueType}], allowed types are: [${currentValueType}]`);
                continue;
            }
            if ($d77b025aa58d633c$var$isProperties(currentValue)) targetAny[property].set(newValue);
            else if (newValueType === "object" && property !== "context") {
                if (currentValue == null) {
                    (0, $idDdm.Logger).warn(`unable to set [${propertyPath}] in ${targetClass?.name} - property is unknown`);
                    continue;
                }
                $d77b025aa58d633c$var$jsonApply(currentValue, newValue, {
                    ...params,
                    path: propertyPath,
                    matcherPath: propertyMatcherPath
                });
            } else targetAny[property] = newValue;
        } catch (error) {
            (0, $idDdm.Logger).warn(`unable to set [${propertyPath}] in [${targetClass?.name}]; nested error is: ${error.message}`);
        }
    }
    return target;
}
function $d77b025aa58d633c$var$classify(value) {
    if (value == null) return null;
    if ((0, $idDdm.isHtmlElement)(value) || (0, $idDdm.isDate)(value)) return "primitive";
    if ((0, $idDdm.isArray)(value)) return "array";
    if ((0, $idDdm.isObject)(value)) return (0, $idDdm.isPlainObject)(value) ? "object" : $d77b025aa58d633c$var$CLASS_INSTANCE_TYPE;
    if ((0, $idDdm.isFunction)(value)) return "function";
    return "primitive";
}
function $d77b025aa58d633c$var$jsonResolveOperations(source, params, skip, context) {
    return $d77b025aa58d633c$var$jsonResolveInner(source, params, context ?? source, {
        matches: /* @__PURE__ */ new Map()
    }, skip);
}
var $d77b025aa58d633c$var$operationResolvedUndefined = Symbol("operation-resolved-undefined");
function $d77b025aa58d633c$var$jsonResolveInner(json, params, source, meta, skip, path = [], modifiedPaths = {}) {
    if ((0, $idDdm.isArray)(json)) {
        $d77b025aa58d633c$var$jsonResolveVisitor(json, params, source, meta, path, modifiedPaths);
        let index = 0;
        for (const node of json){
            $d77b025aa58d633c$var$jsonResolveInner(node, params, source, meta, skip, [
                ...path,
                `${index}`
            ], modifiedPaths);
            index++;
        }
    } else if ((0, $idDdm.isPlainObject)(json)) {
        $d77b025aa58d633c$var$jsonResolveVisitor(json, params, source, meta, path, modifiedPaths);
        for (const key of Object.keys(json)){
            if (skip?.has(key)) continue;
            const node = json[key];
            if ($d77b025aa58d633c$var$getOperation(node)) json[key] = $d77b025aa58d633c$var$jsonResolveVisitorValue(node, params, source, meta, [
                ...path,
                key
            ], modifiedPaths);
            else $d77b025aa58d633c$var$jsonResolveInner(node, params, source, meta, skip, [
                ...path,
                key
            ], modifiedPaths);
        }
    }
    return modifiedPaths;
}
function $d77b025aa58d633c$var$jsonResolveVisitor(node, params, source, meta, path, modifiedPaths) {
    if ((0, $idDdm.isArray)(node)) for(let i = 0; i < node.length; i++){
        node[i] = $d77b025aa58d633c$var$jsonResolveVisitorValue(node[i], params, source, meta, [
            ...path,
            `${i}`
        ], modifiedPaths);
        if (node[i] === $d77b025aa58d633c$var$operationResolvedUndefined) node[i] = void 0;
    }
    else {
        let hasOperation = false;
        for (const name of Object.keys(node)){
            node[name] = $d77b025aa58d633c$var$jsonResolveVisitorValue(node[name], params, source, meta, [
                ...path,
                name
            ], modifiedPaths);
            hasOperation || (hasOperation = $d77b025aa58d633c$var$isKey(name, $d77b025aa58d633c$var$operations));
            if (node[name] === $d77b025aa58d633c$var$operationResolvedUndefined) delete node[name];
        }
        if (hasOperation && Object.keys(node).length > 1) {
            for (const key of Object.keys(node))if ($d77b025aa58d633c$var$isKey(key, $d77b025aa58d633c$var$operations)) delete node[key];
        }
    }
}
function $d77b025aa58d633c$var$jsonResolveVisitorValue(value, params, source, meta, path, modifiedPaths) {
    const operation = $d77b025aa58d633c$var$getOperation(value);
    if (!operation) return value;
    modifiedPaths[path.join(".")] = value;
    const resolved = $d77b025aa58d633c$var$resolveOperation(operation.operation, operation.values, params, source, path, meta);
    if (resolved === void 0) return $d77b025aa58d633c$var$operationResolvedUndefined;
    return resolved;
}
function $d77b025aa58d633c$var$getOperation(value) {
    if (!(0, $idDdm.isPlainObject)(value)) return;
    const [operation] = Object.keys(value);
    if (!$d77b025aa58d633c$var$isKey(operation, $d77b025aa58d633c$var$operations)) return;
    return {
        operation: operation,
        values: value[operation]
    };
}
function $d77b025aa58d633c$var$resolveOperation(operation, value, params, source, path, meta) {
    meta.referencedParams ?? (meta.referencedParams = /* @__PURE__ */ new Set());
    const resolveBranchFirst = [
        "$find" /* Find */ ,
        "$map" /* Map */ 
    ];
    if ((0, $idDdm.isArray)(value) && !resolveBranchFirst.includes(operation)) value = value.map((v)=>{
        const nestedOperation = $d77b025aa58d633c$var$getOperation(v);
        if (!nestedOperation) return v;
        return $d77b025aa58d633c$var$resolveOperation(nestedOperation.operation, nestedOperation.values, params, source, path, meta);
    });
    const fn = $d77b025aa58d633c$var$operations[operation];
    return fn(value, path, params, source, meta);
}
function $d77b025aa58d633c$var$isKey(key, obj) {
    return (0, $idDdm.isString)(key) && ((0, $idDdm.isObject)(obj) || (0, $idDdm.isArray)(obj)) && key in obj;
}
function $d77b025aa58d633c$var$isRatio(value) {
    return (0, $idDdm.isNumber)(value) && value >= 0 && value <= 1;
}
function $d77b025aa58d633c$var$isGradientFill2(fill) {
    return (0, $idDdm.isObject)(fill) && fill.type == "gradient";
}
function $d77b025aa58d633c$var$isPatternFill2(fill) {
    return fill !== null && (0, $idDdm.isObject)(fill) && fill.type == "pattern";
}
function $d77b025aa58d633c$var$isImageFill2(fill) {
    return fill !== null && (0, $idDdm.isObject)(fill) && fill.type == "image";
}
function $d77b025aa58d633c$var$resolvePath(root, path) {
    const relativePathParts = path.split("/");
    let resolvedPath = [
        ...root
    ];
    if (path.startsWith("/")) {
        resolvedPath = [];
        relativePathParts.shift();
    }
    let prevPartWasTwoDots = false;
    for (const part of relativePathParts){
        if (part === "..") {
            resolvedPath.pop();
            if (!prevPartWasTwoDots) resolvedPath.pop();
        } else if (part === ".") resolvedPath.pop();
        else if (part === "$index") {
            const index = root.findLast((v)=>!isNaN(Number(v)));
            if (index != null) resolvedPath.push(index);
        } else if (part === "$prevIndex") {
            const index = root.findLast((v)=>!isNaN(Number(v)));
            if (index != null) resolvedPath.push(`${Number(index) - 1}`);
        } else if (part.length !== 0) resolvedPath.push(part);
        prevPartWasTwoDots = part === "..";
    }
    return resolvedPath;
}
var $d77b025aa58d633c$var$locationOperations = {
    $ref: $d77b025aa58d633c$var$ref,
    $path: $d77b025aa58d633c$var$pathOperation,
    $palette: $d77b025aa58d633c$var$palette
};
var $d77b025aa58d633c$var$logicOperations = {
    $if: ([condition, thenValue, elseValue])=>condition ? thenValue : elseValue,
    $eq: ([a, b])=>a === b,
    $not: ([a])=>!a,
    $or: (values)=>(0, $idDdm.isArray)(values) && values.some(Boolean),
    $and: (values)=>(0, $idDdm.isArray)(values) && values.every(Boolean),
    $switch: ()=>{},
    $isOperation: $d77b025aa58d633c$var$isOperationOperator
};
var $d77b025aa58d633c$var$numericOperations = {
    $isEven: $d77b025aa58d633c$var$isEven,
    $mul: $d77b025aa58d633c$var$mul,
    $round: $d77b025aa58d633c$var$round
};
var $d77b025aa58d633c$var$transformOperations = {
    $map: $d77b025aa58d633c$var$map,
    $find: $d77b025aa58d633c$var$find,
    $merge: $d77b025aa58d633c$var$merge2,
    $omit: $d77b025aa58d633c$var$omit,
    $value: $d77b025aa58d633c$var$valueOperation
};
var $d77b025aa58d633c$var$fontOperations = {
    $rem: $d77b025aa58d633c$var$rem
};
var $d77b025aa58d633c$var$colorOperations = {
    $mix: $d77b025aa58d633c$var$mix,
    $foregroundBackgroundMix: $d77b025aa58d633c$var$foregroundBackgroundMix,
    $foregroundBackgroundAccentMix: $d77b025aa58d633c$var$foregroundBackgroundAccentMix,
    $interpolate: $d77b025aa58d633c$var$interpolate2,
    $isGradient: ([value])=>$d77b025aa58d633c$var$isGradientFill2(value),
    $isPattern: ([value])=>$d77b025aa58d633c$var$isPatternFill2(value),
    $isImage: ([value])=>$d77b025aa58d633c$var$isImageFill2(value)
};
var $d77b025aa58d633c$var$operations = {
    ...$d77b025aa58d633c$var$locationOperations,
    ...$d77b025aa58d633c$var$logicOperations,
    ...$d77b025aa58d633c$var$numericOperations,
    ...$d77b025aa58d633c$var$transformOperations,
    ...$d77b025aa58d633c$var$fontOperations,
    ...$d77b025aa58d633c$var$colorOperations
};
function $d77b025aa58d633c$var$ref(value, path, params, source, meta) {
    if (!$d77b025aa58d633c$var$isKey(value, params)) {
        (0, $idDdm.Logger).warnOnce(`\`$ref\` json operation failed on [${String(value)}] at [${path.join(".")}], expecting one of [${Object.keys(params).join(", ")}].`);
        return;
    }
    const operation = $d77b025aa58d633c$var$getOperation(params[value]);
    if (operation?.operation !== "$ref" /* Ref */ ) return params[value];
    if (meta.referencedParams?.has(operation.values)) {
        (0, $idDdm.Logger).warnOnce(`\`$ref\` json operation failed on [${String(value)}] at [${path.join(".")}], circular reference detected with [${[
            ...meta.referencedParams
        ].join(", ")}].`);
        return;
    }
    meta.referencedParams?.add(operation.values);
    return $d77b025aa58d633c$var$ref(operation.values, path, params, source, meta);
}
function $d77b025aa58d633c$var$palette(value, path, params, source) {
    if (!(0, $idDdm.isString)(value)) return;
    const p = params.__palette;
    const indexPaletteParams = [
        "fill",
        "fillFallback",
        "stroke",
        "gradient",
        "range2"
    ];
    if (indexPaletteParams.includes(value)) {
        const indexIndex = path.findLastIndex((v)=>!isNaN(Number(v)));
        let index = Number(path[indexIndex]);
        if (isNaN(index)) return;
        const seriesPath = path.slice(0, indexIndex);
        const ignoreIndexSeries = [
            "map-shape-background",
            "map-line-background"
        ];
        const ignoreIndexOffset = $d77b025aa58d633c$var$getPath(source, seriesPath).slice(0, index).filter((s)=>ignoreIndexSeries.includes(s.type)).length;
        index -= ignoreIndexOffset;
        switch(value){
            case "fill":
                return (0, $idDdm.circularSliceArray)(p.fills, 1, index)[0];
            case "fillFallback":
                return (0, $idDdm.circularSliceArray)(p.fillsFallback, 1, index)[0];
            case "stroke":
                return (0, $idDdm.circularSliceArray)(p.strokes, 1, index)[0];
            case "gradient":
                return (0, $idDdm.circularSliceArray)(p.sequentialColors, 1, index)[0];
            case "range2":
                return (0, $idDdm.circularSliceArray)(p.fills, 2, index);
        }
        return;
    }
    if (value === "gradients") return p.sequentialColors;
    return $d77b025aa58d633c$var$getPath(p, value);
}
function $d77b025aa58d633c$var$pathOperation(value, path, _params, source) {
    let hasDefaultValue = false;
    let defaultValue;
    let usingCustomBranch = false;
    let branch = source;
    if ((0, $idDdm.isArray)(value)) {
        hasDefaultValue = true;
        defaultValue = value[1];
        usingCustomBranch = value.length === 3;
        branch = usingCustomBranch ? value[2] : branch;
        value = value[0];
    } else if (!(0, $idDdm.isString)(value)) {
        (0, $idDdm.Logger).warnOnce(`\`$path\` json operation failed on [${String(value)}] at [${path.join(".")}], expecting a string.`);
        return;
    }
    const resolvedPath = $d77b025aa58d633c$var$resolvePath(usingCustomBranch ? [] : path, value);
    let resolvedValue = branch;
    for (const part of resolvedPath){
        if (!$d77b025aa58d633c$var$isKey(part, resolvedValue)) {
            if (!hasDefaultValue) {
                (0, $idDdm.Logger).warnOnce(`\`$path\` json operation failed on [${String(value)}] at [${path.join(".")}] resolved to [${resolvedPath.join(".")}], could not find path in object.`);
                return;
            } else return defaultValue;
        }
        resolvedValue = resolvedValue[part];
    }
    return Object.isFrozen(resolvedValue) ? $d77b025aa58d633c$var$deepClone(resolvedValue) : resolvedValue;
}
function $d77b025aa58d633c$var$isOperationOperator(value, path, _params, source) {
    const resolvedPath = (0, $idDdm.isString)(value) ? $d77b025aa58d633c$var$resolvePath(path, value) : path;
    const branch = resolvedPath.length === 0 ? source : $d77b025aa58d633c$var$getPath(source, resolvedPath);
    return $d77b025aa58d633c$var$getOperation(branch) != null;
}
function $d77b025aa58d633c$var$isEven([a], path) {
    if (typeof a === "number") return a % 2 === 0;
    (0, $idDdm.Logger).warnOnce(`\`$isEven\` json operation failed on [${String(a)}] at [${path.join(".")}], expecting a number.`);
}
function $d77b025aa58d633c$var$mul([a, b], path) {
    if (typeof a === "number" && typeof b === "number") return a * b;
    (0, $idDdm.Logger).warnOnce(`\`$mul\` json operation failed on [${String(a)}] and [${String(b)}] at [${path.join(".")}], expecting two numbers.`);
}
function $d77b025aa58d633c$var$round([a], path) {
    if (typeof a === "number") return Math.round(a);
    (0, $idDdm.Logger).warnOnce(`\`$round\` json operation failed on [${String(a)}] at [${path.join(".")}], expecting a number.`);
}
function $d77b025aa58d633c$var$map([mapOperation, mapValues3], path, params, source, meta) {
    const valuesOperation = $d77b025aa58d633c$var$getOperation(mapValues3);
    if (valuesOperation) mapValues3 = $d77b025aa58d633c$var$resolveOperation(valuesOperation.operation, valuesOperation.values, params, source, path, meta);
    if (!(0, $idDdm.isArray)(mapValues3)) return [];
    const mappedOperation = $d77b025aa58d633c$var$getOperation(mapOperation);
    if (!mappedOperation) return [];
    meta.matches.set(path.join("."), mapValues3);
    return mapValues3.map(()=>({
            [mappedOperation.operation]: mappedOperation.values
        }));
}
function $d77b025aa58d633c$var$find([findCondition, findValues], path, params, source, meta) {
    const valuesOperation = $d77b025aa58d633c$var$getOperation(findValues);
    if (valuesOperation) findValues = $d77b025aa58d633c$var$resolveOperation(valuesOperation.operation, valuesOperation.values, params, source, path, meta);
    if (!(0, $idDdm.isArray)(findValues)) return void 0;
    const conditionOperation = $d77b025aa58d633c$var$getOperation(findCondition);
    if (!conditionOperation) return findCondition ? findValues[0] : void 0;
    return findValues.find((value)=>$d77b025aa58d633c$var$resolveOperation(conditionOperation.operation, conditionOperation.values, params, value, [], meta));
}
function $d77b025aa58d633c$var$merge2(values) {
    if (!(0, $idDdm.isArray)(values)) return;
    for (const value of values){
        if (!(0, $idDdm.isPlainObject)(value)) return;
    }
    return $d77b025aa58d633c$var$mergeDefaults(...values);
}
function $d77b025aa58d633c$var$omit([keys, object4]) {
    if (!(0, $idDdm.isArray)(keys) || !(0, $idDdm.isPlainObject)(object4)) return;
    return $d77b025aa58d633c$var$without(object4, keys);
}
function $d77b025aa58d633c$var$valueOperation(value, path, _params, _source, meta) {
    if (value !== "$1" && value !== "$index") return value;
    const indexIndex = path.findLastIndex((v)=>!isNaN(Number(v)));
    if (indexIndex === -1) return value;
    const index = Number(path[indexIndex]);
    if (value === "$index") return index;
    const key = path.slice(0, indexIndex).join(".");
    return meta.matches.get(key)?.at(index);
}
function $d77b025aa58d633c$var$rem([a], path, params) {
    const fontSize = "fontSize";
    if ($d77b025aa58d633c$var$isKey(fontSize, params) && typeof params[fontSize] === "number" && typeof a === "number") return Math.round(a * params[fontSize]);
    (0, $idDdm.Logger).warnOnce(`\`$rem\` json operation failed on [${String(a)}] at [${path.join(".")}], expecting a number.`);
}
function $d77b025aa58d633c$var$mix([a, b, c], path) {
    const warningPrefix = `\`$mix\` json operation failed on [${String(a)}, ${String(b)}, ${String(c)}] at [${path.join(".")}], expecting`;
    const warningMessage = `${warningPrefix} two colors and a number between 0 and 1.`;
    if (typeof b !== "string" || !$d77b025aa58d633c$var$isRatio(c)) {
        (0, $idDdm.Logger).warnOnce(warningMessage);
        return;
    }
    if (typeof a === "string") try {
        return $d77b025aa58d633c$var$Color.mix($d77b025aa58d633c$var$Color.fromString(a), $d77b025aa58d633c$var$Color.fromString(b), c).toString();
    } catch  {
        (0, $idDdm.Logger).warnOnce(warningMessage);
        return;
    }
    if (!$d77b025aa58d633c$var$isGradientFill2(a)) {
        (0, $idDdm.Logger).warnOnce(warningMessage);
        return;
    }
    let colorStops = a.colorStops;
    try {
        colorStops = colorStops?.map((value)=>{
            let color11;
            if (typeof value.color === "string") color11 = $d77b025aa58d633c$var$Color.mix($d77b025aa58d633c$var$Color.fromString(value.color), $d77b025aa58d633c$var$Color.fromString(b), c).toString();
            return {
                ...value,
                color: color11
            };
        });
    } catch  {
        (0, $idDdm.Logger).warnOnce(`${warningPrefix} a gradient, a color and a number between 0 and 1.`);
        return;
    }
    return {
        ...a,
        colorStops: colorStops
    };
}
function $d77b025aa58d633c$var$foregroundBackgroundMix([background], path, params) {
    const foregroundColor = "foregroundColor";
    const backgroundColor = "backgroundColor";
    if ($d77b025aa58d633c$var$isKey(foregroundColor, params) && $d77b025aa58d633c$var$isKey(backgroundColor, params) && typeof params[foregroundColor] === "string" && typeof params[backgroundColor] === "string" && $d77b025aa58d633c$var$isRatio(background)) return $d77b025aa58d633c$var$Color.mix($d77b025aa58d633c$var$Color.fromString(params[foregroundColor]), $d77b025aa58d633c$var$Color.fromString(params[backgroundColor]), background).toString();
    (0, $idDdm.Logger).warnOnce(`\`$foregroundBackgroundMix\` json operation failed on [${String(background)}}}] at [${path.join(".")}], expecting a number between 0 and 1.`);
}
function $d77b025aa58d633c$var$foregroundBackgroundAccentMix([background, accent], path, params) {
    const foregroundColor = "foregroundColor";
    const backgroundColor = "backgroundColor";
    const accentColor = "accentColor";
    if ($d77b025aa58d633c$var$isKey(foregroundColor, params) && $d77b025aa58d633c$var$isKey(backgroundColor, params) && $d77b025aa58d633c$var$isKey(accentColor, params) && typeof params[foregroundColor] === "string" && typeof params[backgroundColor] === "string" && typeof params[accentColor] === "string" && $d77b025aa58d633c$var$isRatio(background) && $d77b025aa58d633c$var$isRatio(accent)) return $d77b025aa58d633c$var$Color.mix($d77b025aa58d633c$var$Color.mix($d77b025aa58d633c$var$Color.fromString(params[foregroundColor]), $d77b025aa58d633c$var$Color.fromString(params[backgroundColor]), background), $d77b025aa58d633c$var$Color.fromString(params[accentColor]), accent).toString();
    (0, $idDdm.Logger).warnOnce(`\`$foregroundBackgroundAccentMix\` json operation failed on [${String(background)}, ${String(accent)}}] at [${path.join(".")}], expecting two numbers between 0 and 1.`);
}
function $d77b025aa58d633c$var$interpolate2([colors, count]) {
    if (!(0, $idDdm.isArray)(colors) || !(0, $idDdm.isNumber)(count)) return;
    return $d77b025aa58d633c$var$Color.interpolate(colors.map((color11)=>$d77b025aa58d633c$var$Color.fromString(color11)), count).map((color11)=>color11.toString());
}
var $d77b025aa58d633c$var$Mutex = class {
    constructor(){
        this.available = true;
        this.acquireQueue = [];
    }
    acquire(cb) {
        return new Promise((resolve)=>{
            this.acquireQueue.push([
                cb,
                resolve
            ]);
            if (this.available) this.dispatchNext().catch((e)=>(0, $idDdm.Logger).errorOnce(e));
        });
    }
    async acquireImmediately(cb) {
        if (!this.available) return false;
        await this.acquire(cb);
        return true;
    }
    async waitForClearAcquireQueue() {
        return this.acquire(()=>Promise.resolve(void 0));
    }
    async dispatchNext() {
        this.available = false;
        let [next, done] = this.acquireQueue.shift() ?? [];
        while(next){
            try {
                await next();
                done?.();
            } catch (error) {
                (0, $idDdm.Logger).error("mutex callback error", error);
                done?.();
            }
            [next, done] = this.acquireQueue.shift() ?? [];
        }
        this.available = true;
    }
};
// packages/ag-charts-community/src/util/observable.ts
var $d77b025aa58d633c$var$Observable = class {
    constructor(){
        this.eventListeners = /* @__PURE__ */ new Map();
    }
    addEventListener(eventType, listener) {
        if (typeof listener !== "function") throw new Error("AG Charts - listener must be a Function");
        const eventTypeListeners = this.eventListeners.get(eventType);
        if (eventTypeListeners) eventTypeListeners.add(listener);
        else this.eventListeners.set(eventType, /* @__PURE__ */ new Set([
            listener
        ]));
    }
    removeEventListener(type, listener) {
        const listeners = this.eventListeners.get(type);
        if (listeners == null) return;
        listeners.delete(listener);
        if (listeners.size === 0) this.eventListeners.delete(type);
    }
    hasEventListener(type) {
        return this.eventListeners.has(type);
    }
    clearEventListeners() {
        this.eventListeners.clear();
    }
    fireEvent(event) {
        this.eventListeners.get(event.type)?.forEach((listener)=>listener(event));
    }
};
// packages/ag-charts-community/src/util/padding.ts
var $d77b025aa58d633c$var$Padding = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(top = 0, right = top, bottom = top, left = right){
        super();
        this.top = top;
        this.right = right;
        this.bottom = bottom;
        this.left = left;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Padding.prototype, "top", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Padding.prototype, "right", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Padding.prototype, "bottom", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Padding.prototype, "left", 2);
function $d77b025aa58d633c$var$ProxyProperty(proxyPath, configMetadata) {
    const pathArray = (0, $idDdm.isArray)(proxyPath) ? proxyPath : proxyPath.split(".");
    if (pathArray.length === 1) {
        const [property] = pathArray;
        return $d77b025aa58d633c$var$addTransformToInstanceProperty((target, _, value)=>target[property] = value, (target)=>target[property], configMetadata);
    }
    return $d77b025aa58d633c$var$addTransformToInstanceProperty((target, _, value)=>$d77b025aa58d633c$var$setPath(target, pathArray, value), (target)=>$d77b025aa58d633c$var$getPath(target, pathArray), configMetadata);
}
function $d77b025aa58d633c$var$ProxyOnWrite(proxyProperty) {
    return $d77b025aa58d633c$var$addTransformToInstanceProperty((target, _, value)=>target[proxyProperty] = value);
}
function $d77b025aa58d633c$var$ProxyPropertyOnWrite(childName, childProperty) {
    return $d77b025aa58d633c$var$addTransformToInstanceProperty((target, key, value)=>target[childName][childProperty ?? key] = value);
}
function $d77b025aa58d633c$var$ActionOnSet(opts) {
    const { newValue: newValueFn, oldValue: oldValueFn, changeValue: changeValueFn } = opts;
    return $d77b025aa58d633c$var$addTransformToInstanceProperty((target, _, newValue, oldValue)=>{
        if (newValue !== oldValue) {
            if (oldValue !== void 0) oldValueFn?.call(target, oldValue);
            if (newValue !== void 0) newValueFn?.call(target, newValue);
            changeValueFn?.call(target, newValue, oldValue);
        }
        return newValue;
    });
}
function $d77b025aa58d633c$var$ObserveChanges(observerFn) {
    return $d77b025aa58d633c$var$addObserverToInstanceProperty(observerFn);
}
function $d77b025aa58d633c$var$debouncedAnimationFrame(cb) {
    return $d77b025aa58d633c$var$buildScheduler((innerCb, _delayMs)=>(0, $idDdm.getWindow)().requestAnimationFrame(innerCb), cb);
}
function $d77b025aa58d633c$var$debouncedCallback(cb) {
    return $d77b025aa58d633c$var$buildScheduler((innerCb, delayMs = 0)=>{
        if (delayMs === 0) queueMicrotask(innerCb);
        else setTimeout(innerCb, delayMs);
    }, cb);
}
function $d77b025aa58d633c$var$buildScheduler(scheduleFn, cb) {
    let scheduleCount = 0;
    let promiseRunning = false;
    let awaitingPromise;
    let awaitingDone;
    const busy = ()=>{
        return promiseRunning;
    };
    const done = ()=>{
        promiseRunning = false;
        awaitingDone?.();
        awaitingDone = void 0;
        awaitingPromise = void 0;
        if (scheduleCount > 0) scheduleFn(scheduleCb);
    };
    const scheduleCb = ()=>{
        const count = scheduleCount;
        scheduleCount = 0;
        promiseRunning = true;
        const maybePromise = cb({
            count: count
        });
        if (!maybePromise) {
            done();
            return;
        }
        maybePromise.then(done, done);
    };
    return {
        schedule (delayMs) {
            if (scheduleCount === 0 && !busy()) scheduleFn(scheduleCb, delayMs);
            scheduleCount++;
        },
        async await () {
            if (!busy()) return;
            if (awaitingPromise == null) awaitingPromise = new Promise((resolve)=>{
                awaitingDone = resolve;
            });
            while(busy())await awaitingPromise;
        }
    };
}
// packages/ag-charts-community/src/widget/widgetEvents.ts
var $d77b025aa58d633c$var$WIDGET_HTML_EVENTS = [
    "blur",
    "change",
    "contextmenu",
    "focus",
    "keydown",
    "keyup",
    "click",
    "dblclick",
    "mouseenter",
    "mousemove",
    "mouseleave",
    "wheel",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel"
];
function $d77b025aa58d633c$var$allocMouseEvent(type, sourceEvent, current) {
    const { offsetX: offsetX, offsetY: offsetY, clientX: clientX, clientY: clientY } = sourceEvent;
    const { currentX: currentX, currentY: currentY } = $d77b025aa58d633c$var$WidgetEventUtil.calcCurrentXY(current, sourceEvent);
    return {
        type: type,
        offsetX: offsetX,
        offsetY: offsetY,
        clientX: clientX,
        clientY: clientY,
        currentX: currentX,
        currentY: currentY,
        sourceEvent: sourceEvent
    };
}
function $d77b025aa58d633c$var$allocTouchEvent(type, sourceEvent, _current) {
    return {
        type: type,
        sourceEvent: sourceEvent
    };
}
var $d77b025aa58d633c$var$WidgetAllocators = {
    blur: (sourceEvent)=>{
        return {
            type: "blur",
            sourceEvent: sourceEvent
        };
    },
    change: (sourceEvent)=>{
        return {
            type: "change",
            sourceEvent: sourceEvent
        };
    },
    contextmenu: (sourceEvent, current)=>{
        return $d77b025aa58d633c$var$allocMouseEvent("contextmenu", sourceEvent, current);
    },
    focus: (sourceEvent)=>{
        return {
            type: "focus",
            sourceEvent: sourceEvent
        };
    },
    keydown: (sourceEvent)=>{
        return {
            type: "keydown",
            sourceEvent: sourceEvent
        };
    },
    keyup: (sourceEvent)=>{
        return {
            type: "keyup",
            sourceEvent: sourceEvent
        };
    },
    click: (sourceEvent, current)=>{
        return $d77b025aa58d633c$var$allocMouseEvent("click", sourceEvent, current);
    },
    dblclick: (sourceEvent, current)=>{
        return $d77b025aa58d633c$var$allocMouseEvent("dblclick", sourceEvent, current);
    },
    mouseenter: (sourceEvent, current)=>{
        return $d77b025aa58d633c$var$allocMouseEvent("mouseenter", sourceEvent, current);
    },
    mousemove: (sourceEvent, current)=>{
        return $d77b025aa58d633c$var$allocMouseEvent("mousemove", sourceEvent, current);
    },
    mouseleave: (sourceEvent, current)=>{
        return $d77b025aa58d633c$var$allocMouseEvent("mouseleave", sourceEvent, current);
    },
    wheel: (sourceEvent)=>{
        const { offsetX: offsetX, offsetY: offsetY, clientX: clientX, clientY: clientY } = sourceEvent;
        const factor = sourceEvent.deltaMode === 0 ? 0.01 : 1;
        const deltaX = sourceEvent.deltaX * factor;
        const deltaY = sourceEvent.deltaY * factor;
        return {
            type: "wheel",
            offsetX: offsetX,
            offsetY: offsetY,
            clientX: clientX,
            clientY: clientY,
            deltaX: deltaX,
            deltaY: deltaY,
            sourceEvent: sourceEvent
        };
    },
    touchstart: (sourceEvent, current)=>{
        return $d77b025aa58d633c$var$allocTouchEvent("touchstart", sourceEvent, current);
    },
    touchmove: (sourceEvent, current)=>{
        return $d77b025aa58d633c$var$allocTouchEvent("touchmove", sourceEvent, current);
    },
    touchend: (sourceEvent, current)=>{
        return $d77b025aa58d633c$var$allocTouchEvent("touchend", sourceEvent, current);
    },
    touchcancel: (sourceEvent, current)=>{
        return $d77b025aa58d633c$var$allocTouchEvent("touchcancel", sourceEvent, current);
    }
};
var $d77b025aa58d633c$var$WidgetEventUtil = class {
    static alloc(type, sourceEvent, current) {
        return $d77b025aa58d633c$var$WidgetAllocators[type](sourceEvent, current);
    }
    static isHTMLEvent(type) {
        const htmlTypes = $d77b025aa58d633c$var$WIDGET_HTML_EVENTS;
        return htmlTypes.includes(type);
    }
    static calcCurrentXY(current, event) {
        const currentRect = current.getBoundingClientRect();
        return {
            currentX: event.clientX - currentRect.x,
            currentY: event.clientY - currentRect.y
        };
    }
};
var $d77b025aa58d633c$var$WidgetListenerHTML = class {
    constructor(){
        this.widgetListeners = {};
        this.sourceListeners = {};
    }
    initSourceHandler(type, handler) {
        this.sourceListeners ?? (this.sourceListeners = {});
        this.sourceListeners[type] = handler;
    }
    lazyGetWidgetListeners(type, target) {
        var _a;
        if (!(type in (this.sourceListeners ?? {}))) {
            const sourceHandler = (sourceEvent)=>{
                const widgetEvent = $d77b025aa58d633c$var$WidgetEventUtil.alloc(type, sourceEvent, target.getElement());
                for (const widgetListener of this.widgetListeners?.[type] ?? [])widgetListener(widgetEvent, target);
            };
            const opts = {};
            if (type.startsWith("touch")) opts.passive = false;
            this.initSourceHandler(type, sourceHandler);
            target.getElement().addEventListener(type, sourceHandler, opts);
        }
        this.widgetListeners ?? (this.widgetListeners = {});
        (_a = this.widgetListeners)[type] ?? (_a[type] = []);
        return this.widgetListeners[type];
    }
    add(type, target, handler) {
        const listeners = this.lazyGetWidgetListeners(type, target);
        listeners.push(handler);
    }
    remove(type, target, handler) {
        const listeners = this.lazyGetWidgetListeners(type, target);
        const index = listeners.indexOf(handler);
        if (index > -1) listeners.splice(index, 1);
    }
    destroy(target) {
        for (const [key, sourceHandler] of (0, $idDdm.entries)(this.sourceListeners ?? {}))target.getElement().removeEventListener(key, sourceHandler);
        this.widgetListeners = void 0;
        this.sourceListeners = void 0;
    }
};
var $d77b025aa58d633c$var$MouseDragger = class {
    constructor(glob, self, myCallbacks, downEvent){
        this.glob = glob;
        this.self = self;
        this.window = (0, $idDdm.getWindow)();
        this.mousegeneral = (generalEvent)=>{
            generalEvent.stopPropagation();
            generalEvent.stopImmediatePropagation();
        };
        this.mousemove = (moveEvent)=>{
            moveEvent.stopPropagation();
            moveEvent.stopImmediatePropagation();
            this.glob.globalMouseDragCallbacks?.mousemove(moveEvent);
        };
        this.mouseup = (upEvent)=>{
            if (upEvent.button === 0) {
                upEvent.stopPropagation();
                upEvent.stopImmediatePropagation();
                this.glob.globalMouseDragCallbacks?.mouseup(upEvent);
                this.destroy();
            }
        };
        const { window: window2, mousegeneral: mousegeneral, mousemove: mousemove, mouseup: mouseup } = this;
        window2.addEventListener("mousedown", mousegeneral, {
            capture: true
        });
        window2.addEventListener("mouseenter", mousegeneral, {
            capture: true
        });
        window2.addEventListener("mouseleave", mousegeneral, {
            capture: true
        });
        window2.addEventListener("mouseout", mousegeneral, {
            capture: true
        });
        window2.addEventListener("mouseover", mousegeneral, {
            capture: true
        });
        window2.addEventListener("mousemove", mousemove, {
            capture: true
        });
        window2.addEventListener("mouseup", mouseup, {
            capture: true
        });
        self.mouseDragger = this;
        glob.globalMouseDragCallbacks = myCallbacks;
        glob.globalMouseDragCallbacks.mousedown(downEvent);
    }
    destroy() {
        const { window: window2, mousegeneral: mousegeneral, mousemove: mousemove, mouseup: mouseup } = this;
        window2.removeEventListener("mousedown", mousegeneral, {
            capture: true
        });
        window2.removeEventListener("mouseenter", mousegeneral, {
            capture: true
        });
        window2.removeEventListener("mouseleave", mousegeneral, {
            capture: true
        });
        window2.removeEventListener("mouseout", mousegeneral, {
            capture: true
        });
        window2.removeEventListener("mouseover", mousegeneral, {
            capture: true
        });
        window2.removeEventListener("mousemove", mousemove, {
            capture: true
        });
        window2.removeEventListener("mouseup", mouseup, {
            capture: true
        });
        this.glob.globalMouseDragCallbacks = void 0;
        this.self.mouseDragger = void 0;
    }
};
function $d77b025aa58d633c$var$startMouseDrag(glob, self, myCallbacks, downEvent) {
    if (glob.globalMouseDragCallbacks != null) return void 0;
    return new $d77b025aa58d633c$var$MouseDragger(glob, self, myCallbacks, downEvent);
}
var $d77b025aa58d633c$var$LONG_TAP_DURATION_MS = 500;
var $d77b025aa58d633c$var$LONG_TAP_INTERRUPT_MIN_TOUCHMOVE_PXPX = 100;
function $d77b025aa58d633c$var$deltaClientSquared(a, b) {
    const dx = a.clientX - b.clientX;
    const dy = a.clientY - b.clientY;
    return dx * dx + dy * dy;
}
var $d77b025aa58d633c$var$gIsInLongTap = false;
var $d77b025aa58d633c$var$TouchDragger = class {
    constructor(glob, self, myCallbacks, initialTouch, target){
        this.glob = glob;
        this.self = self;
        this.initialTouch = initialTouch;
        this.target = target;
        this.longTapInterrupted = false;
        this.longtap = ()=>{
            const { target: target, initialTouch: initialTouch } = this;
            if (!this.longTapInterrupted) {
                target.dispatchEvent(new TouchEvent("touchcancel", {
                    touches: [
                        initialTouch
                    ],
                    bubbles: true
                }));
                $d77b025aa58d633c$var$gIsInLongTap = true;
                const longTapMove = (e)=>{
                    e.preventDefault();
                };
                const longTapEnd = (e)=>{
                    $d77b025aa58d633c$var$gIsInLongTap = false;
                    e.preventDefault();
                    target.removeEventListener("touchmove", longTapMove);
                    target.removeEventListener("touchend", longTapEnd);
                    target.removeEventListener("touchcancel", longTapEnd);
                };
                target.addEventListener("touchmove", longTapMove, {
                    passive: false
                });
                target.addEventListener("touchend", longTapEnd, {
                    passive: false
                });
                target.addEventListener("touchcancel", longTapEnd, {
                    passive: false
                });
                const { clientX: clientX, clientY: clientY } = initialTouch;
                const contextMenuEvent = new PointerEvent("contextmenu", {
                    bubbles: true,
                    cancelable: true,
                    view: (0, $idDdm.getWindow)(),
                    clientX: clientX,
                    clientY: clientY,
                    pointerType: "touch"
                });
                target.dispatchEvent(contextMenuEvent);
            }
        };
        this.touchmove = (moveEvent)=>{
            const { glob: glob, self: self, initialTouch: initialTouch } = this;
            const touch = this.findInitialFinger(moveEvent.targetTouches);
            if (touch != null) {
                this.longTapInterrupted = this.longTapInterrupted || $d77b025aa58d633c$var$deltaClientSquared(initialTouch, touch) > $d77b025aa58d633c$var$LONG_TAP_INTERRUPT_MIN_TOUCHMOVE_PXPX;
                if (self.dragTouchEnabled && touch != null) glob.globalTouchDragCallbacks?.touchmove(moveEvent, touch);
            }
        };
        this.touchend = (endEvent)=>{
            this.longTapInterrupted = true;
            const touch = this.findInitialFinger(endEvent.changedTouches, endEvent.touches);
            if (touch != null) this.glob.globalTouchDragCallbacks?.touchend(endEvent, touch);
            this.destroy();
        };
        this.longtapTimer = setTimeout(this.longtap, $d77b025aa58d633c$var$LONG_TAP_DURATION_MS);
        const { touchmove: touchmove, touchend: touchend } = this;
        target.addEventListener("touchmove", touchmove, {
            passive: false
        });
        target.addEventListener("touchstart", touchend, {
            passive: false
        });
        target.addEventListener("touchend", touchend, {
            passive: false
        });
        target.addEventListener("touchcancel", touchend, {
            passive: false
        });
        self.touchDragger = this;
        glob.globalTouchDragCallbacks = myCallbacks;
    }
    destroy() {
        const { longtapTimer: longtapTimer, touchmove: touchmove, touchend: touchend } = this;
        clearTimeout(longtapTimer);
        this.target.removeEventListener("touchstart", touchend);
        this.target.removeEventListener("touchmove", touchmove);
        this.target.removeEventListener("touchend", touchend);
        this.target.removeEventListener("touchcancel", touchend);
        this.glob.globalTouchDragCallbacks = void 0;
        this.self.touchDragger = void 0;
    }
    findInitialFinger(...touchLists) {
        const touches = touchLists.map((touchList)=>Array.from(touchList)).flat();
        return Array.from(touches).find((v)=>v.identifier === this.initialTouch.identifier);
    }
};
function $d77b025aa58d633c$var$startOneFingerTouch(glob, self, myCallbacks, initialTouch, target) {
    if (glob.globalTouchDragCallbacks != null || $d77b025aa58d633c$var$gIsInLongTap) return void 0;
    return new $d77b025aa58d633c$var$TouchDragger(glob, self, myCallbacks, initialTouch, target);
}
// packages/ag-charts-community/src/widget/widgetListenerInternal.ts
function $d77b025aa58d633c$var$makeMouseDrag(current, type, origin3, sourceEvent) {
    const { currentX: currentX, currentY: currentY } = $d77b025aa58d633c$var$WidgetEventUtil.calcCurrentXY(current.getElement(), sourceEvent);
    const originDeltaX = sourceEvent.pageX - origin3.pageX;
    const originDeltaY = sourceEvent.pageY - origin3.pageY;
    return {
        type: type,
        device: "mouse",
        offsetX: origin3.offsetX + originDeltaX,
        offsetY: origin3.offsetY + originDeltaY,
        clientX: sourceEvent.clientX,
        clientY: sourceEvent.clientY,
        currentX: currentX,
        currentY: currentY,
        originDeltaX: originDeltaX,
        originDeltaY: originDeltaY,
        sourceEvent: sourceEvent
    };
}
function $d77b025aa58d633c$var$getTouchOffsets(current, { pageX: pageX, pageY: pageY }) {
    const { x: x, y: y } = current.getElement().getBoundingClientRect();
    return {
        offsetX: pageX - x,
        offsetY: pageY - y
    };
}
function $d77b025aa58d633c$var$makeTouchDrag(current, type, origin3, sourceEvent, touch) {
    const { currentX: currentX, currentY: currentY } = $d77b025aa58d633c$var$WidgetEventUtil.calcCurrentXY(current.getElement(), touch);
    const originDeltaX = touch.pageX - origin3.pageX;
    const originDeltaY = touch.pageY - origin3.pageY;
    return {
        type: type,
        device: "touch",
        offsetX: origin3.offsetX + originDeltaX,
        offsetY: origin3.offsetY + originDeltaY,
        clientX: touch.clientX,
        clientY: touch.clientY,
        currentX: currentX,
        currentY: currentY,
        originDeltaX: originDeltaX,
        originDeltaY: originDeltaY,
        sourceEvent: sourceEvent
    };
}
var $d77b025aa58d633c$var$GlobalCallbacks = {};
var $d77b025aa58d633c$var$WidgetListenerInternal = class {
    constructor(dispatchCallback){
        this.dispatchCallback = dispatchCallback;
        this.dragTouchEnabled = true;
    }
    destroy() {
        this.dragTriggerRemover?.();
        this.dragTriggerRemover = void 0;
        this.listeners?.clear();
        this.mouseDragger?.destroy();
        this.touchDragger?.destroy();
    }
    getListenerSet(type) {
        this.listeners ?? (this.listeners = /* @__PURE__ */ new Map());
        let result = this.listeners.get(type);
        if (result === void 0) {
            result = /* @__PURE__ */ new Set();
            this.listeners.set(type, result);
        }
        return result;
    }
    add(type, target, handler) {
        this.getListenerSet(type).add(handler);
        switch(type){
            case "drag-start":
            case "drag-move":
            case "drag-end":
                this.registerDragTrigger(target);
                break;
        }
    }
    remove(type, _target, handler) {
        this.getListenerSet(type).delete(handler);
    }
    registerDragTrigger(target) {
        if (this.dragTriggerRemover == null) {
            const mouseTrigger = (event)=>this.triggerMouseDrag(target, event);
            const touchTrigger = (event)=>this.triggerTouchDrag(target, event);
            target.getElement().addEventListener("mousedown", mouseTrigger);
            target.getElement().addEventListener("touchstart", touchTrigger, {
                passive: false
            });
            this.dragTriggerRemover = ()=>{
                target.getElement().removeEventListener("mousedown", mouseTrigger);
                target.getElement().removeEventListener("touchstart", touchTrigger);
            };
        }
    }
    triggerMouseDrag(current, downEvent) {
        if (downEvent.button === 0) this.startMouseDrag(current, downEvent);
    }
    startMouseDrag(current, initialDownEvent) {
        const origin3 = {
            pageX: NaN,
            pageY: NaN,
            offsetX: NaN,
            offsetY: NaN
        };
        $d77b025aa58d633c$var$partialAssign([
            "pageX",
            "pageY",
            "offsetX",
            "offsetY"
        ], origin3, initialDownEvent);
        const dragCallbacks = {
            mousedown: (downEvent)=>{
                const dragStartEvent = $d77b025aa58d633c$var$makeMouseDrag(current, "drag-start", origin3, downEvent);
                this.dispatch("drag-start", current, dragStartEvent);
            },
            mousemove: (moveEvent)=>{
                const dragMoveEvent = $d77b025aa58d633c$var$makeMouseDrag(current, "drag-move", origin3, moveEvent);
                this.dispatch("drag-move", current, dragMoveEvent);
            },
            mouseup: (upEvent)=>{
                const dragEndEvent = $d77b025aa58d633c$var$makeMouseDrag(current, "drag-end", origin3, upEvent);
                this.dispatch("drag-end", current, dragEndEvent);
                this.endDrag(current, dragEndEvent);
            }
        };
        this.mouseDragger = $d77b025aa58d633c$var$startMouseDrag($d77b025aa58d633c$var$GlobalCallbacks, this, dragCallbacks, initialDownEvent);
    }
    endDrag(target, { sourceEvent: sourceEvent, clientX: clientX, clientY: clientY }) {
        const elem = target.getElement();
        const rect = elem.getBoundingClientRect();
        if (!$d77b025aa58d633c$var$BBoxValues.containsPoint(rect, clientX, clientY)) {
            elem.dispatchEvent(new MouseEvent("mouseleave", sourceEvent));
            sourceEvent.target?.dispatchEvent(new MouseEvent("mouseenter", sourceEvent));
        }
    }
    triggerTouchDrag(current, startEvent) {
        const touch = startEvent.targetTouches[0];
        if (startEvent.targetTouches.length === 1 && touch != null) this.startOneFingerTouch(current, startEvent, touch);
    }
    startOneFingerTouch(current, initialEvent, initialTouch) {
        const origin3 = {
            pageX: NaN,
            pageY: NaN,
            ...$d77b025aa58d633c$var$getTouchOffsets(current, initialTouch)
        };
        $d77b025aa58d633c$var$partialAssign([
            "pageX",
            "pageY"
        ], origin3, initialTouch);
        const dragCallbacks = {
            touchmove: (moveEvent, touch)=>{
                const dragMoveEvent = $d77b025aa58d633c$var$makeTouchDrag(current, "drag-move", origin3, moveEvent, touch);
                this.dispatch("drag-move", current, dragMoveEvent);
            },
            touchend: (cancelEvent, touch)=>{
                const dragMoveEvent = $d77b025aa58d633c$var$makeTouchDrag(current, "drag-end", origin3, cancelEvent, touch);
                this.dispatch("drag-end", current, dragMoveEvent);
            }
        };
        const target = current.getElement();
        this.touchDragger = $d77b025aa58d633c$var$startOneFingerTouch($d77b025aa58d633c$var$GlobalCallbacks, this, dragCallbacks, initialTouch, target);
        const dragStartEvent = $d77b025aa58d633c$var$makeTouchDrag(current, "drag-start", origin3, initialEvent, initialTouch);
        this.dispatch("drag-start", current, dragStartEvent);
    }
    dispatch(type, current, event) {
        for (const handler of this.getListenerSet(type))handler(event, current);
        this.dispatchCallback(type, event);
    }
};
// packages/ag-charts-community/src/widget/widget.ts
var $d77b025aa58d633c$var$WidgetBounds = class {
    constructor(elem){
        this.elem = elem;
    }
    setBounds(bounds) {
        $d77b025aa58d633c$var$setElementBBox(this.elemContainer ?? this.elem, bounds);
    }
    getBounds() {
        return $d77b025aa58d633c$var$getElementBBox(this.elemContainer ?? this.elem);
    }
    static setElementContainer(widget, elemContainer) {
        const currentBounds = widget.getBounds();
        $d77b025aa58d633c$var$setElementBBox(elemContainer, currentBounds);
        (0, $idDdm.setElementStyles)(widget.elem, {
            width: "100%",
            height: "100%"
        });
        widget.elem.remove();
        widget.elemContainer = elemContainer;
        widget.elemContainer.replaceChildren(widget.elem);
    }
};
var $d77b025aa58d633c$var$Widget = class extends $d77b025aa58d633c$var$WidgetBounds {
    constructor(elem){
        super(elem);
        this.elem = elem;
        this.index = NaN;
        this.children = [];
    }
    set id(elementId) {
        (0, $idDdm.setAttribute)(this.elem, "id", elementId);
    }
    get id() {
        return (0, $idDdm.getAttribute)(this.elem, "id");
    }
    getElement() {
        return this.elem;
    }
    getBoundingClientRect() {
        return this.elem.getBoundingClientRect();
    }
    get clientWidth() {
        return this.elem.clientWidth;
    }
    get clientHeight() {
        return this.elem.clientHeight;
    }
    destroy() {
        this.parent?.removeChild(this);
        this.children.forEach((child)=>{
            child.parent = void 0;
            child.destroy();
        });
        this.children.length = 0;
        this.destructor();
        this.remove();
        this.internalListener?.destroy();
        this.htmlListener?.destroy(this);
    }
    remove() {
        this.elem.remove();
        this.elemContainer?.remove();
    }
    setHidden(hidden) {
        (0, $idDdm.setElementStyle)(this.elem, "display", hidden ? "none" : void 0);
    }
    isHidden() {
        return (0, $idDdm.getWindow)()?.getComputedStyle?.(this.elem).display === "none";
    }
    setCursor(cursor) {
        (0, $idDdm.setElementStyle)(this.elem, "cursor", cursor);
    }
    setTextContent(textContent) {
        this.elem.textContent = textContent ?? null;
    }
    setAriaDescribedBy(ariaDescribedBy) {
        (0, $idDdm.setAttribute)(this.elem, "aria-describedby", ariaDescribedBy);
    }
    setAriaHidden(ariaHidden) {
        (0, $idDdm.setAttribute)(this.elem, "aria-hidden", ariaHidden);
    }
    setAriaLabel(ariaLabel) {
        (0, $idDdm.setAttribute)(this.elem, "aria-label", ariaLabel);
    }
    setAriaExpanded(ariaExpanded) {
        (0, $idDdm.setAttribute)(this.elem, "aria-expanded", ariaExpanded);
    }
    setAriaControls(ariaControls) {
        (0, $idDdm.setAttribute)(this.elem, "aria-controls", ariaControls);
    }
    setAriaHasPopup(ariaHasPopup) {
        (0, $idDdm.setAttribute)(this.elem, "aria-haspopup", ariaHasPopup);
    }
    setInnerHTML(html) {
        this.elem.innerHTML = html;
    }
    setPointerEvents(pointerEvents) {
        (0, $idDdm.setElementStyle)(this.elem, "pointer-events", pointerEvents);
    }
    isDisabled() {
        return (0, $idDdm.getAttribute)(this.elem, "aria-disabled", false);
    }
    hasPopup() {
        const ariaHasPopup = (0, $idDdm.getAttribute)(this.elem, "aria-haspopup");
        return ariaHasPopup !== void 0 && ariaHasPopup !== "false";
    }
    parseFloat(s) {
        return s === "" ? 0 : parseFloat(s);
    }
    cssLeft() {
        return this.parseFloat(this.elem.style.left);
    }
    cssTop() {
        return this.parseFloat(this.elem.style.top);
    }
    cssWidth() {
        return this.parseFloat(this.elem.style.width);
    }
    cssHeight() {
        return this.parseFloat(this.elem.style.height);
    }
    focus(opts) {
        this.elem.focus(opts);
    }
    setFocusOverride(focus) {
        (0, $idDdm.setAttribute)(this.elem, "data-focus-override", focus);
    }
    setPreventsDefault(preventDefault) {
        (0, $idDdm.setAttribute)(this.elem, "data-preventdefault", preventDefault);
    }
    setTabIndex(tabIndex) {
        (0, $idDdm.setAttribute)(this.elem, "tabindex", tabIndex);
    }
    addChild(child) {
        this.addChildToDOM(child, this.getBefore(child));
        this.children.push(child);
        child.index = this.children.length - 1;
        child.parent = this;
        this.onChildAdded(child);
    }
    removeChild(child) {
        const i = this.children.findIndex((value)=>value === child);
        this.children.splice(i, 1);
        this.removeChildFromDOM(child);
        this.onChildRemoved(child);
    }
    moveChild(child, domIndex) {
        if (child.domIndex === domIndex) return;
        child.domIndex = domIndex;
        this.removeChildFromDOM(child);
        this.addChildToDOM(child, this.getBefore(child));
    }
    addClass(...tokens) {
        this.elem.classList.add(...tokens);
    }
    removeClass(...tokens) {
        this.elem.classList.remove(...tokens);
    }
    toggleClass(token, force) {
        this.elem.classList.toggle(token, force);
    }
    appendOrInsert(child, before) {
        if (before) before.getElement().insertAdjacentElement("beforebegin", child);
        else this.elem.appendChild(child);
    }
    addChildToDOM(child, before) {
        this.appendOrInsert(child.getElement(), before);
    }
    removeChildFromDOM(child) {
        this.elem.removeChild(child.getElement());
    }
    onChildAdded(_child) {}
    onChildRemoved(_child) {}
    getBefore({ domIndex: domIndex }) {
        if (domIndex === void 0) return void 0;
        return this.children.filter((child)=>child.domIndex !== void 0 && child.domIndex > domIndex).reduce((prev, curr)=>!prev || curr.domIndex < prev.domIndex ? curr : prev, void 0);
    }
    addListener(type, listener) {
        if ($d77b025aa58d633c$var$WidgetEventUtil.isHTMLEvent(type)) {
            this.htmlListener ?? (this.htmlListener = new $d77b025aa58d633c$var$WidgetListenerHTML());
            this.htmlListener.add(type, this, listener);
        } else {
            this.internalListener ?? (this.internalListener = new $d77b025aa58d633c$var$WidgetListenerInternal(this.onDispatch.bind(this)));
            this.internalListener.add(type, this, listener);
        }
        return ()=>this.removeListener(type, listener);
    }
    removeListener(type, listener) {
        if ($d77b025aa58d633c$var$WidgetEventUtil.isHTMLEvent(type)) this.htmlListener?.remove(type, this, listener);
        else if (this.htmlListener != null) this.internalListener?.remove(type, this, listener);
    }
    setDragTouchEnabled(dragTouchEnabled) {
        this.internalListener ?? (this.internalListener = new $d77b025aa58d633c$var$WidgetListenerInternal(this.onDispatch.bind(this)));
        this.internalListener.dragTouchEnabled = dragTouchEnabled;
    }
    onDispatch(type, event) {
        if (!event.sourceEvent?.bubbles) return;
        let { parent: parent } = this;
        while(parent != null){
            const { internalListener: internalListener } = parent;
            if (internalListener != null) {
                const parentEvent = {
                    ...event,
                    ...$d77b025aa58d633c$var$WidgetEventUtil.calcCurrentXY(parent.getElement(), event)
                };
                internalListener.dispatch(type, parent, parentEvent);
            }
            parent = parent.parent;
        }
    }
    static addWindowEvent(_type, listener) {
        const pagehideHandler = (event)=>{
            if (event.persisted) return;
            listener();
        };
        (0, $idDdm.getWindow)().addEventListener("pagehide", pagehideHandler);
        return ()=>(0, $idDdm.getWindow)().removeEventListener("pagehide", pagehideHandler);
    }
};
// packages/ag-charts-community/src/util/canvas.util.ts
function $d77b025aa58d633c$var$createCanvasContext(width2 = 0, height2 = 0) {
    return new OffscreenCanvas(width2, height2).getContext("2d");
}
// packages/ag-charts-community/src/util/lruCache.ts
var $d77b025aa58d633c$var$LRUCache = class {
    constructor(maxCacheSize = 5){
        this.maxCacheSize = maxCacheSize;
        this.store = /* @__PURE__ */ new Map();
    }
    get(key) {
        if (!this.store.has(key)) return void 0;
        const hit = this.store.get(key);
        this.store.delete(key);
        this.store.set(key, hit);
        return hit;
    }
    has(key) {
        return this.store.has(key);
    }
    set(key, value) {
        this.store.set(key, value);
        if (this.store.size > this.maxCacheSize) {
            const iterator = this.store.keys();
            let evictCount = this.store.size - this.maxCacheSize;
            while(evictCount > 0){
                const evictKeyIterator = iterator.next();
                if (!evictKeyIterator.done) this.store.delete(evictKeyIterator.value);
                evictCount--;
            }
        }
        return value;
    }
    clear() {
        this.store.clear();
    }
};
// packages/ag-charts-community/src/util/textMeasurer.ts
var $d77b025aa58d633c$var$CachedTextMeasurerPool = class {
    // Measures the dimensions of the provided text, handling multiline if needed.
    static measureText(text, options) {
        const textMeasurer = this.getMeasurer(options);
        return textMeasurer.measureText(text);
    }
    static measureLines(text, options) {
        const textMeasurer = this.getMeasurer(options);
        return textMeasurer.measureLines(text);
    }
    // Gets a TextMeasurer instance, configuring text alignment and baseline if provided.
    static getMeasurer(options) {
        const font2 = typeof options.font === "string" ? options.font : $d77b025aa58d633c$var$TextUtils.toFontString(options.font);
        const key = `${font2}-${options.textAlign ?? "start"}-${options.textBaseline ?? "alphabetic"}`;
        return this.instanceMap.get(key) ?? this.createFontMeasurer(font2, options, key);
    }
    static clear() {
        this.instanceMap.clear();
    }
    // Creates or retrieves a TextMeasurer instance for a specific font.
    static createFontMeasurer(font2, options, key) {
        const ctx = $d77b025aa58d633c$var$createCanvasContext();
        ctx.font = font2;
        ctx.textAlign = options.textAlign ?? "start";
        ctx.textBaseline = options.textBaseline ?? "alphabetic";
        const measurer2 = new $d77b025aa58d633c$var$CachedTextMeasurer(ctx, options);
        this.instanceMap.set(key, measurer2);
        return measurer2;
    }
};
$d77b025aa58d633c$var$CachedTextMeasurerPool.instanceMap = new $d77b025aa58d633c$var$LRUCache(10);
var $d77b025aa58d633c$var$CachedTextMeasurer = class {
    constructor(ctx, options){
        this.ctx = ctx;
        // cached text measurements
        this.measureMap = new $d77b025aa58d633c$var$LRUCache(100);
        if (options.textAlign) ctx.textAlign = options.textAlign;
        if (options.textBaseline) ctx.textBaseline = options.textBaseline;
        ctx.font = typeof options.font === "string" ? options.font : $d77b025aa58d633c$var$TextUtils.toFontString(options.font);
        this.textMeasurer = new $d77b025aa58d633c$var$SimpleTextMeasurer((t)=>this.cachedCtxMeasureText(t), options.textBaseline ?? "alphabetic");
    }
    textWidth(text, estimate) {
        return this.textMeasurer.textWidth(text, estimate);
    }
    measureText(text) {
        return this.textMeasurer.measureText(text);
    }
    measureLines(text) {
        return this.textMeasurer.measureLines(text);
    }
    cachedCtxMeasureText(text) {
        if (!this.measureMap.has(text)) {
            const rawResult = this.ctx.measureText(text);
            this.measureMap.set(text, {
                actualBoundingBoxAscent: rawResult.actualBoundingBoxAscent,
                emHeightAscent: rawResult.emHeightAscent,
                emHeightDescent: rawResult.emHeightDescent,
                actualBoundingBoxDescent: rawResult.actualBoundingBoxDescent,
                actualBoundingBoxLeft: rawResult.actualBoundingBoxLeft,
                actualBoundingBoxRight: rawResult.actualBoundingBoxRight,
                alphabeticBaseline: rawResult.alphabeticBaseline,
                fontBoundingBoxAscent: rawResult.fontBoundingBoxAscent,
                fontBoundingBoxDescent: rawResult.fontBoundingBoxDescent,
                hangingBaseline: rawResult.hangingBaseline,
                ideographicBaseline: rawResult.ideographicBaseline,
                width: rawResult.width
            });
        }
        return this.measureMap.get(text);
    }
};
var $d77b025aa58d633c$var$TextUtils = class {
    static toFontString({ fontSize: fontSize = 10, fontStyle: fontStyle, fontWeight: fontWeight, fontFamily: fontFamily, lineHeight: lineHeight }) {
        let fontString = "";
        if (fontStyle) fontString += `${fontStyle} `;
        if (fontWeight) fontString += `${fontWeight} `;
        fontString += `${fontSize}px`;
        if (lineHeight) fontString += `/${lineHeight}px`;
        fontString += ` ${fontFamily}`;
        return fontString.trim();
    }
    static getLineHeight(fontSize) {
        return Math.ceil(fontSize * this.defaultLineHeight);
    }
    // Determines vertical offset modifier based on text baseline.
    static getVerticalModifier(textBaseline) {
        switch(textBaseline){
            case "hanging":
            case "top":
                return 0;
            case "middle":
                return 0.5;
            case "alphabetic":
            case "bottom":
            case "ideographic":
            default:
                return 1;
        }
    }
};
$d77b025aa58d633c$var$TextUtils.EllipsisChar = "\u2026";
// Representation for text clipping.
$d77b025aa58d633c$var$TextUtils.defaultLineHeight = 1.15;
// Normally between 1.1 and 1.2
$d77b025aa58d633c$var$TextUtils.lineSplitter = /\r?\n/g;
var $d77b025aa58d633c$var$SimpleTextMeasurer = class {
    constructor(measureTextFn, textBaseline = "alphabetic"){
        this.measureTextFn = measureTextFn;
        this.textBaseline = textBaseline;
        // local chars width cache per TextMeasurer
        this.charMap = /* @__PURE__ */ new Map();
    }
    // Measures metrics for a single line of text.
    getMetrics(text) {
        const m = this.measureTextFn(text);
        m.fontBoundingBoxAscent ?? (m.fontBoundingBoxAscent = m.emHeightAscent);
        m.fontBoundingBoxDescent ?? (m.fontBoundingBoxDescent = m.emHeightDescent);
        return {
            width: m.width,
            height: m.actualBoundingBoxAscent + m.actualBoundingBoxDescent,
            lineHeight: m.fontBoundingBoxAscent + m.fontBoundingBoxDescent,
            offsetTop: m.actualBoundingBoxAscent,
            offsetLeft: m.actualBoundingBoxLeft
        };
    }
    // Calculates aggregated metrics for multiline text.
    getMultilineMetrics(lines) {
        let width2 = 0;
        let height2 = 0;
        let offsetTop = 0;
        let offsetLeft = 0;
        let baselineDistance = 0;
        const verticalModifier = $d77b025aa58d633c$var$TextUtils.getVerticalModifier(this.textBaseline);
        const lineMetrics = [];
        let index = 0;
        const length2 = lines.length;
        for (const line of lines){
            const m = this.measureTextFn(line);
            m.fontBoundingBoxAscent ?? (m.fontBoundingBoxAscent = m.emHeightAscent);
            m.fontBoundingBoxDescent ?? (m.fontBoundingBoxDescent = m.emHeightDescent);
            if (width2 < m.width) width2 = m.width;
            if (offsetLeft < m.actualBoundingBoxLeft) offsetLeft = m.actualBoundingBoxLeft;
            if (index === 0) {
                height2 += m.actualBoundingBoxAscent;
                offsetTop += m.actualBoundingBoxAscent;
            } else baselineDistance += m.fontBoundingBoxAscent;
            if (index === length2 - 1) height2 += m.actualBoundingBoxDescent;
            else baselineDistance += m.fontBoundingBoxDescent;
            lineMetrics.push({
                text: line,
                width: m.width,
                height: m.actualBoundingBoxAscent + m.actualBoundingBoxDescent,
                lineHeight: m.fontBoundingBoxAscent + m.fontBoundingBoxDescent,
                offsetTop: m.actualBoundingBoxAscent,
                offsetLeft: m.actualBoundingBoxLeft
            });
            index++;
        }
        height2 += baselineDistance;
        offsetTop += baselineDistance * verticalModifier;
        return {
            width: width2,
            height: height2,
            offsetTop: offsetTop,
            offsetLeft: offsetLeft,
            lineMetrics: lineMetrics
        };
    }
    textWidth(text, estimate) {
        if (estimate) {
            let estimatedWidth = 0;
            for(let i = 0; i < text.length; i++)estimatedWidth += this.textWidth(text.charAt(i));
            return estimatedWidth;
        }
        if (text.length > 1) return this.measureTextFn(text).width;
        return this.charMap.get(text) ?? this.charWidth(text);
    }
    measureText(text) {
        return this.getMetrics(text);
    }
    // Measures the dimensions of the provided text, handling multiline if needed.
    measureLines(text) {
        const lines = typeof text === "string" ? text.split($d77b025aa58d633c$var$TextUtils.lineSplitter) : text;
        return this.getMultilineMetrics(lines);
    }
    charWidth(char) {
        const { width: width2 } = this.measureTextFn(char);
        this.charMap.set(char, width2);
        return width2;
    }
};
// packages/ag-charts-community/src/scene/shape/text.ts
var $d77b025aa58d633c$var$_Text = class _Text extends $d77b025aa58d633c$var$Shape {
    constructor(){
        super(...arguments);
        this.x = 0;
        this.y = 0;
        this.lines = [];
        this.text = void 0;
        this.fontSize = 10;
        this.fontFamily = "sans-serif";
        this.textAlign = _Text.defaultStyles.textAlign;
        this.textBaseline = _Text.defaultStyles.textBaseline;
    }
    onTextChange() {
        this.lines = this.text?.split("\n").map((s)=>s.trim()) ?? [];
    }
    static computeBBox(lines, x, y, opts) {
        const { offsetTop: offsetTop, offsetLeft: offsetLeft, width: width2, height: exactHeight } = $d77b025aa58d633c$var$CachedTextMeasurerPool.measureLines(lines, opts);
        const height2 = opts.lineHeight ? opts.lineHeight * lines.length : exactHeight;
        return new $d77b025aa58d633c$var$BBox(x - offsetLeft, y - offsetTop, width2, height2);
    }
    computeBBox() {
        const { x: x, y: y, lines: lines, textBaseline: textBaseline, textAlign: textAlign, lineHeight: lineHeight } = this;
        return _Text.computeBBox(lines, x, y, {
            font: this,
            textBaseline: textBaseline,
            textAlign: textAlign,
            lineHeight: lineHeight
        });
    }
    getTextMeasureBBox() {
        return this.computeBBox();
    }
    isPointInPath(x, y) {
        const bbox = this.getBBox();
        return bbox ? bbox.containsPoint(x, y) : false;
    }
    render(renderCtx) {
        const { ctx: ctx, stats: stats } = renderCtx;
        if (!this.lines.length || !this.layerManager) {
            if (stats) stats.nodesSkipped += 1;
            return super.render(renderCtx);
        }
        const { fill: fill, stroke: stroke2, strokeWidth: strokeWidth } = this;
        const { globalAlpha: globalAlpha } = ctx;
        const { pixelRatio: pixelRatio } = this.layerManager.canvas;
        if (!fill && !(stroke2 != null && strokeWidth > 0)) return super.render(renderCtx);
        const font2 = $d77b025aa58d633c$var$TextUtils.toFontString(this);
        if (ctx.font !== font2) ctx.font = font2;
        ctx.textAlign = this.textAlign;
        ctx.textBaseline = this.textBaseline;
        if (fill) {
            this.applyFillAndAlpha(ctx);
            const { fillShadow: fillShadow } = this;
            if (fillShadow?.enabled) {
                ctx.shadowColor = fillShadow.color;
                ctx.shadowOffsetX = fillShadow.xOffset * pixelRatio;
                ctx.shadowOffsetY = fillShadow.yOffset * pixelRatio;
                ctx.shadowBlur = fillShadow.blur * pixelRatio;
            }
            this.renderLines((line, x, y)=>ctx.fillText(line, x, y));
            ctx.globalAlpha = globalAlpha;
        }
        if (stroke2 && strokeWidth) {
            this.applyStrokeAndAlpha(ctx);
            ctx.lineWidth = strokeWidth;
            const { lineDash: lineDash, lineDashOffset: lineDashOffset, lineCap: lineCap, lineJoin: lineJoin } = this;
            if (lineDash) ctx.setLineDash([
                ...lineDash
            ]);
            if (lineDashOffset) ctx.lineDashOffset = lineDashOffset;
            if (lineCap) ctx.lineCap = lineCap;
            if (lineJoin) ctx.lineJoin = lineJoin;
            this.renderLines((line, x, y)=>ctx.strokeText(line, x, y));
            ctx.globalAlpha = globalAlpha;
        }
        super.render(renderCtx);
    }
    renderLines(renderCallback) {
        const { lines: lines, x: x, y: y } = this;
        const lineHeight = this.lineHeight ?? $d77b025aa58d633c$var$TextUtils.getLineHeight(this.fontSize);
        let offsetY = (lineHeight - lineHeight * lines.length) * $d77b025aa58d633c$var$TextUtils.getVerticalModifier(this.textBaseline);
        for (const line of lines){
            renderCallback(line, x, y + offsetY);
            offsetY += lineHeight;
        }
    }
    setFont(props) {
        this.fontFamily = props.fontFamily;
        this.fontSize = props.fontSize;
        this.fontStyle = props.fontStyle;
        this.fontWeight = props.fontWeight;
    }
    setAlign(props) {
        this.textAlign = props.textAlign;
        this.textBaseline = props.textBaseline;
    }
    toSVG() {
        if (!this.visible || !this.text) return;
        const element2 = (0, $idDdm.createSvgElement)("text");
        this.applySvgFillAttributes(element2);
        element2.setAttribute("font-family", this.fontFamily?.split(",")[0] ?? "");
        element2.setAttribute("font-size", String(this.fontSize));
        element2.setAttribute("font-style", this.fontStyle ?? "");
        element2.setAttribute("font-weight", String(this.fontWeight ?? ""));
        element2.setAttribute("text-anchor", {
            center: "middle",
            left: "start",
            right: "end",
            start: "start",
            end: "end"
        }[this.textAlign ?? "start"]);
        element2.setAttribute("alignment-baseline", {
            alphabetic: "alphabetic",
            top: "top",
            bottom: "bottom",
            hanging: "hanging",
            middle: "middle",
            ideographic: "ideographic"
        }[this.textBaseline ?? "alphabetic"]);
        element2.setAttribute("x", String(this.x));
        element2.setAttribute("y", String(this.y));
        element2.textContent = this.text ?? "";
        return {
            elements: [
                element2
            ]
        };
    }
};
$d77b025aa58d633c$var$_Text.className = "Text";
$d77b025aa58d633c$var$_Text.defaultStyles = {
    ...$d77b025aa58d633c$var$Shape.defaultStyles,
    textAlign: "start",
    fontStyle: void 0,
    fontWeight: void 0,
    fontSize: 10,
    fontFamily: "sans-serif",
    textBaseline: "alphabetic"
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Text.prototype, "x", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Text.prototype, "y", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        convertor: (value)=>(0, $idDdm.isDefined)(value) ? String(value) : value,
        changeCb: (o)=>o.onTextChange()
    })
], $d77b025aa58d633c$var$_Text.prototype, "text", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Text.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Text.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Text.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Text.prototype, "fontFamily", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Text.prototype, "textAlign", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Text.prototype, "textBaseline", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$_Text.prototype, "lineHeight", 2);
var $d77b025aa58d633c$var$Text = $d77b025aa58d633c$var$_Text;
var $d77b025aa58d633c$var$RotatableText = class extends $d77b025aa58d633c$var$Rotatable($d77b025aa58d633c$var$Text) {
};
var $d77b025aa58d633c$var$TransformableText = class extends $d77b025aa58d633c$var$Rotatable($d77b025aa58d633c$var$Translatable($d77b025aa58d633c$var$Text)) {
};
// packages/ag-charts-community/src/util/textWrapper.ts
var $d77b025aa58d633c$var$TextWrapper = class {
    static wrapText(text, options) {
        return this.wrapLines(text, options).join("\n");
    }
    static wrapLines(text, options) {
        const clippedResult = this.textWrap(text, options);
        if (options.overflow === "hide" && clippedResult.some((l)=>l.endsWith($d77b025aa58d633c$var$TextUtils.EllipsisChar))) return [];
        return clippedResult;
    }
    static appendEllipsis(text) {
        return text.replace(/[.,]{1,5}$/, "") + $d77b025aa58d633c$var$TextUtils.EllipsisChar;
    }
    static truncateLine(text, measurer2, maxWidth, ellipsisForce) {
        const ellipsisWidth = measurer2.textWidth($d77b025aa58d633c$var$TextUtils.EllipsisChar);
        let estimatedWidth = 0;
        let i = 0;
        for(; i < text.length; i++){
            const charWidth = measurer2.textWidth(text.charAt(i));
            if (estimatedWidth + charWidth > maxWidth) break;
            estimatedWidth += charWidth;
        }
        if (text.length === i && (!ellipsisForce || estimatedWidth + ellipsisWidth <= maxWidth)) return ellipsisForce ? text + $d77b025aa58d633c$var$TextUtils.EllipsisChar : text;
        text = text.slice(0, i).trimEnd();
        while(text.length && measurer2.textWidth(text) + ellipsisWidth > maxWidth)text = text.slice(0, -1).trimEnd();
        return text + $d77b025aa58d633c$var$TextUtils.EllipsisChar;
    }
    static textWrap(text, options) {
        const lines = text.split($d77b025aa58d633c$var$TextUtils.lineSplitter);
        const measurer2 = $d77b025aa58d633c$var$CachedTextMeasurerPool.getMeasurer(options);
        if (options.textWrap === "never") return lines.map((line)=>this.truncateLine(line.trimEnd(), measurer2, options.maxWidth));
        const result = [];
        const wrapHyphenate = options.textWrap === "hyphenate";
        const wrapOnSpace = options.textWrap == null || options.textWrap === "on-space";
        for (const untrimmedLine of lines){
            let line = untrimmedLine.trimEnd();
            if (line === "") {
                result.push(line);
                continue;
            }
            let i = 0;
            let estimatedWidth = 0;
            let lastSpaceIndex = 0;
            while(i < line.length){
                const char = line.charAt(i);
                estimatedWidth += measurer2.textWidth(char);
                if (char === " ") lastSpaceIndex = i;
                if (estimatedWidth > options.maxWidth) {
                    if (i === 0) break;
                    const actualWidth = measurer2.textWidth(line.slice(0, i + 1));
                    if (actualWidth <= options.maxWidth) {
                        estimatedWidth = actualWidth;
                        i++;
                        continue;
                    }
                    if (lastSpaceIndex) {
                        const nextWord = this.getWordAt(line, lastSpaceIndex + 1);
                        const textWidth = measurer2.textWidth(nextWord);
                        if (textWidth <= options.maxWidth) {
                            result.push(line.slice(0, lastSpaceIndex).trimEnd());
                            line = line.slice(lastSpaceIndex).trimStart();
                            i = 0;
                            estimatedWidth = 0;
                            lastSpaceIndex = 0;
                            continue;
                        } else if (wrapOnSpace && textWidth > options.maxWidth) result.push(line.slice(0, lastSpaceIndex).trimEnd(), this.truncateLine(line.slice(lastSpaceIndex).trimStart(), measurer2, options.maxWidth, true));
                    } else if (wrapOnSpace) result.push(this.truncateLine(line, measurer2, options.maxWidth, true));
                    if (wrapOnSpace) {
                        line = "";
                        break;
                    }
                    const postfix = wrapHyphenate ? "-" : "";
                    let newLine = line.slice(0, i).trim();
                    while(newLine.length && measurer2.textWidth(newLine + postfix) > options.maxWidth)newLine = newLine.slice(0, -1).trimEnd();
                    result.push(newLine + postfix);
                    if (!newLine.length) {
                        line = "";
                        break;
                    }
                    line = line.slice(newLine.length).trimStart();
                    i = -1;
                    estimatedWidth = 0;
                    lastSpaceIndex = 0;
                }
                i++;
            }
            if (line) result.push(line);
        }
        this.avoidOrphans(result, measurer2, options);
        return this.clipLines(result, measurer2, options);
    }
    static getWordAt(text, position) {
        const nextSpaceIndex = text.indexOf(" ", position);
        return nextSpaceIndex === -1 ? text.slice(position) : text.slice(position, nextSpaceIndex);
    }
    static clipLines(lines, measurer2, options) {
        if (!options.maxHeight) return lines;
        const { height: height2, lineMetrics: lineMetrics } = measurer2.measureLines(lines);
        if (height2 <= options.maxHeight) return lines;
        for(let i = 0, cumulativeHeight = 0; i < lineMetrics.length; i++){
            const { lineHeight: lineHeight } = lineMetrics[i];
            cumulativeHeight += lineHeight;
            if (cumulativeHeight > options.maxHeight) {
                if (options.overflow === "hide") return [];
                const clippedResults = lines.slice(0, i || 1);
                const lastLine = clippedResults.pop();
                return clippedResults.concat(this.truncateLine(lastLine, measurer2, options.maxWidth, true));
            }
        }
        return lines;
    }
    static avoidOrphans(lines, measurer2, options) {
        if (options.avoidOrphans === false || lines.length < 2) return;
        const { length: length2 } = lines;
        const lastLine = lines[length2 - 1];
        const beforeLast = lines[length2 - 2];
        if (beforeLast.length < lastLine.length) return;
        const lastSpaceIndex = beforeLast.lastIndexOf(" ");
        if (lastSpaceIndex === -1 || lastSpaceIndex === beforeLast.indexOf(" ") || lastLine.includes(" ")) return;
        const lastWord = beforeLast.slice(lastSpaceIndex + 1);
        if (measurer2.textWidth(lastLine + lastWord) <= options.maxWidth) {
            lines[length2 - 2] = beforeLast.slice(0, lastSpaceIndex);
            lines[length2 - 1] = lastWord + " " + lastLine;
        }
    }
};
// packages/ag-charts-community/src/chart/caption.ts
var $d77b025aa58d633c$var$Caption = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.id = (0, $idDdm.createId)(this);
        this.node = new $d77b025aa58d633c$var$RotatableText({
            zIndex: 1
        }).setProperties({
            textAlign: "center",
            pointerEvents: 1 /* None */ 
        });
        this.enabled = false;
        this.textAlign = "center";
        this.fontSize = 10;
        this.fontFamily = "sans-serif";
        this.wrapping = "always";
        this.padding = 0;
        this.layoutStyle = "block";
        this.truncated = false;
    }
    registerInteraction(moduleCtx, where) {
        return moduleCtx.layoutManager.addListener("layout:complete", ()=>this.updateA11yText(moduleCtx, where));
    }
    computeTextWrap(containerWidth, containerHeight) {
        const { text: text, padding: padding, wrapping: wrapping } = this;
        const maxWidth = Math.min(this.maxWidth ?? Infinity, containerWidth) - padding * 2;
        const maxHeight = this.maxHeight ?? containerHeight - padding * 2;
        if (!isFinite(maxWidth) && !isFinite(maxHeight)) {
            this.node.text = text;
            return;
        }
        const wrappedText = $d77b025aa58d633c$var$TextWrapper.wrapText(text ?? "", {
            maxWidth: maxWidth,
            maxHeight: maxHeight,
            font: this,
            textWrap: wrapping
        });
        this.node.text = wrappedText;
        this.truncated = wrappedText.includes($d77b025aa58d633c$var$TextUtils.EllipsisChar);
    }
    updateA11yText(moduleCtx, where) {
        const { proxyInteractionService: proxyInteractionService } = moduleCtx;
        if (this.enabled && this.text) {
            const bbox = $d77b025aa58d633c$var$Transformable.toCanvas(this.node);
            if (bbox) {
                const { id: domManagerId } = this;
                this.proxyText ?? (this.proxyText = proxyInteractionService.createProxyElement({
                    type: "text",
                    domManagerId: domManagerId,
                    where: where
                }));
                this.proxyText.textContent = this.text;
                this.proxyText.setBounds(bbox);
                this.proxyText.addListener("mousemove", (ev)=>this.handleMouseMove(moduleCtx, ev));
                this.proxyText.addListener("mouseleave", (ev)=>this.handleMouseLeave(moduleCtx, ev));
            }
        } else {
            this.proxyText?.destroy();
            this.proxyText = void 0;
        }
    }
    handleMouseMove(moduleCtx, event) {
        if (event != null && this.enabled && this.node.visible && this.truncated) {
            const { x: x, y: y } = $d77b025aa58d633c$var$Transformable.toCanvas(this.node);
            const canvasX = event.sourceEvent.offsetX + x;
            const canvasY = event.sourceEvent.offsetY + y;
            moduleCtx.tooltipManager.updateTooltip(this.id, {
                canvasX: canvasX,
                canvasY: canvasY,
                showArrow: false
            }, [
                {
                    type: "structured",
                    title: this.text
                }
            ]);
        }
    }
    handleMouseLeave(moduleCtx, _event) {
        moduleCtx.tooltipManager.removeTooltip(this.id);
    }
};
$d77b025aa58d633c$var$Caption.SMALL_PADDING = 10;
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node", "visible")
], $d77b025aa58d633c$var$Caption.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node")
], $d77b025aa58d633c$var$Caption.prototype, "text", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node")
], $d77b025aa58d633c$var$Caption.prototype, "textAlign", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node")
], $d77b025aa58d633c$var$Caption.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node")
], $d77b025aa58d633c$var$Caption.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node")
], $d77b025aa58d633c$var$Caption.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node")
], $d77b025aa58d633c$var$Caption.prototype, "fontFamily", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node", "fill")
], $d77b025aa58d633c$var$Caption.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Caption.prototype, "spacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Caption.prototype, "maxWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Caption.prototype, "maxHeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Caption.prototype, "wrapping", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Caption.prototype, "padding", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Caption.prototype, "layoutStyle", 2);
// packages/ag-charts-community/src/chart/chartAxisDirection.ts
var $d77b025aa58d633c$var$ChartAxisDirection = /* @__PURE__ */ ((ChartAxisDirection2)=>{
    ChartAxisDirection2["X"] = "x";
    ChartAxisDirection2["Y"] = "y";
    ChartAxisDirection2["Angle"] = "angle";
    ChartAxisDirection2["Radius"] = "radius";
    return ChartAxisDirection2;
})($d77b025aa58d633c$var$ChartAxisDirection || {});
function $d77b025aa58d633c$var$isChartAxisDirection(d) {
    switch(d){
        case "x":
        case "y":
        case "angle":
        case "radius":
            return true;
        default:
            return false;
    }
}
var $d77b025aa58d633c$var$LayoutElement = /* @__PURE__ */ ((LayoutElement2)=>{
    LayoutElement2[LayoutElement2["Caption"] = 0] = "Caption";
    LayoutElement2[LayoutElement2["Legend"] = 1] = "Legend";
    LayoutElement2[LayoutElement2["ToolbarLeft"] = 2] = "ToolbarLeft";
    LayoutElement2[LayoutElement2["ToolbarBottom"] = 3] = "ToolbarBottom";
    LayoutElement2[LayoutElement2["Navigator"] = 4] = "Navigator";
    LayoutElement2[LayoutElement2["Overlay"] = 5] = "Overlay";
    return LayoutElement2;
})($d77b025aa58d633c$var$LayoutElement || {});
var $d77b025aa58d633c$var$LayoutManager = class {
    constructor(){
        this.events = new (0, $idDdm.EventEmitter)();
        this.elements = /* @__PURE__ */ new Map();
    }
    addListener(eventName, listener) {
        return this.events.on(eventName, listener);
    }
    registerElement(element2, listener) {
        if (this.elements.has(element2)) this.elements.get(element2).add(listener);
        else this.elements.set(element2, /* @__PURE__ */ new Set([
            listener
        ]));
        return ()=>this.elements.get(element2)?.delete(listener);
    }
    createContext(width2, height2) {
        const context = new $d77b025aa58d633c$var$LayoutContext(width2, height2);
        for (const element2 of Object.values($d77b025aa58d633c$var$LayoutElement)){
            if (typeof element2 !== "number") continue;
            this.elements.get(element2)?.forEach((listener)=>listener(context));
        }
        return context;
    }
    emitLayoutComplete(context, options) {
        const eventType = "layout:complete";
        const { width: width2, height: height2 } = context;
        this.events.emit(eventType, {
            type: eventType,
            axes: options.axes ?? [],
            chart: {
                width: width2,
                height: height2
            },
            clipSeries: options.clipSeries ?? false,
            series: options.series
        });
    }
};
var $d77b025aa58d633c$var$LayoutContext = class {
    constructor(width2, height2){
        this.width = width2;
        this.height = height2;
        this.layoutBox = new $d77b025aa58d633c$var$BBox(0, 0, width2, height2);
    }
};
// packages/ag-charts-community/src/chart/chartCaptions.ts
var $d77b025aa58d633c$var$ChartCaptions = class {
    constructor(){
        this.title = new $d77b025aa58d633c$var$Caption();
        this.subtitle = new $d77b025aa58d633c$var$Caption();
        this.footnote = new $d77b025aa58d633c$var$Caption();
    }
    positionCaptions(ctx) {
        const { title: title, subtitle: subtitle, footnote: footnote } = this;
        const maxHeight = ctx.layoutBox.height / 10;
        if (title.enabled) {
            const { spacing: spacing } = title;
            this.positionCaption("top", title, ctx.layoutBox, maxHeight);
            this.shrinkLayoutByCaption("top", title, ctx.layoutBox, spacing);
        }
        if (subtitle.enabled) {
            this.positionCaption("top", subtitle, ctx.layoutBox, maxHeight);
            this.shrinkLayoutByCaption("top", subtitle, ctx.layoutBox, subtitle.spacing);
        }
        if (footnote.enabled) {
            this.positionCaption("bottom", footnote, ctx.layoutBox, maxHeight);
            this.shrinkLayoutByCaption("bottom", footnote, ctx.layoutBox, footnote.spacing);
        }
    }
    positionAbsoluteCaptions(ctx) {
        const { title: title, subtitle: subtitle, footnote: footnote } = this;
        const { rect: rect } = ctx.series;
        for (const caption of [
            title,
            subtitle,
            footnote
        ]){
            if (caption.layoutStyle !== "overlay") continue;
            if (caption.textAlign === "left") caption.node.x = rect.x + caption.padding;
            else if (caption.textAlign === "right") {
                const bbox = caption.node.getBBox();
                caption.node.x = rect.x + rect.width - bbox.width - caption.padding;
            }
        }
    }
    computeX(align2, layoutBox) {
        if (align2 === "left") return layoutBox.x;
        else if (align2 === "right") return layoutBox.x + layoutBox.width;
        return layoutBox.x + layoutBox.width / 2;
    }
    positionCaption(vAlign, caption, layoutBox, maxHeight) {
        const containerHeight = Math.max($d77b025aa58d633c$var$TextUtils.getLineHeight(caption.fontSize), maxHeight);
        caption.node.x = this.computeX(caption.textAlign, layoutBox) + caption.padding;
        caption.node.y = layoutBox.y + (vAlign === "top" ? 0 : layoutBox.height) + caption.padding;
        caption.node.textBaseline = vAlign;
        caption.computeTextWrap(layoutBox.width, containerHeight);
    }
    shrinkLayoutByCaption(vAlign, caption, layoutBox, spacing = 0) {
        if (caption.layoutStyle === "block") {
            const bbox = caption.node.getTextMeasureBBox();
            layoutBox.shrink(vAlign === "top" ? Math.ceil(bbox.y - layoutBox.y + bbox.height + spacing) : Math.ceil(layoutBox.y + layoutBox.height - bbox.y + spacing), vAlign);
        }
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ChartCaptions.prototype, "title", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ChartCaptions.prototype, "subtitle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ChartCaptions.prototype, "footnote", 2);
var $d77b025aa58d633c$var$chartTypes = [
    "candlestick",
    "hollow-candlestick",
    "ohlc",
    "line",
    "step-line",
    "hlc",
    "high-low"
];
var $d77b025aa58d633c$var$ChartTypeOriginator = class {
    constructor(chartService){
        this.chartService = chartService;
        this.mementoOriginatorKey = "chartType";
    }
    createMemento() {
        let chartType = this.chartService.publicApi?.getOptions()?.chartType;
        if (chartType == null) chartType = "candlestick";
        return chartType;
    }
    guardMemento(blob) {
        return blob == null || $d77b025aa58d633c$var$chartTypes.includes(blob);
    }
    restoreMemento(_version, _mementoVersion, memento) {
        if (memento == null) return;
        const options = {
            chartType: memento
        };
        this.chartService.publicApi?.updateDelta(options).catch((e)=>(0, $idDdm.Logger).error("error restoring state", e));
    }
};
// packages/ag-charts-community/src/util/destroy.ts
var $d77b025aa58d633c$var$DestroyFns = class {
    constructor(){
        this.destroyFns = [];
    }
    destroy() {
        this.destroyFns.forEach((fn)=>fn());
        this.destroyFns.length = 0;
    }
    setFns(destroyFns) {
        this.destroy();
        this.destroyFns = destroyFns;
    }
    push(...destroyFns) {
        this.destroyFns.push(...destroyFns);
    }
};
// packages/ag-charts-community/src/version.ts
var $d77b025aa58d633c$export$a4ad2735b021c132 = "11.3.2";
// packages/ag-charts-community/src/api/state/historyManager.ts
var $d77b025aa58d633c$var$NOT_FOUND = Symbol("previous-memento-not-found");
var $d77b025aa58d633c$var$HistoryManager = class {
    constructor(chartEventManager){
        this.history = [];
        this.historyIndex = -1;
        this.originators = /* @__PURE__ */ new Map();
        this.clearState = /* @__PURE__ */ new Map();
        this.maxHistoryLength = 100;
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "history");
        this.destroyFns = new $d77b025aa58d633c$var$DestroyFns();
        this.destroyFns.setFns([
            chartEventManager.addListener("series-undo", this.undo.bind(this)),
            chartEventManager.addListener("series-redo", this.redo.bind(this))
        ]);
    }
    destroy() {
        this.destroyFns.destroy();
    }
    addMementoOriginator(originator) {
        this.originators.set(originator.mementoOriginatorKey, originator);
        this.clearState.set(originator.mementoOriginatorKey, originator.createMemento());
        this.debugEvent("History add originator:", originator.mementoOriginatorKey);
    }
    clear() {
        this.debug(`History clear:`, Object.keys(this.originators));
        this.history = [];
        this.historyIndex = -1;
        for (const [mementoOriginatorKey, originator] of this.originators.entries())this.clearState.set(mementoOriginatorKey, originator.createMemento());
    }
    record(label, ...originators) {
        if (this.historyIndex < this.history.length - 1) this.history = this.history.slice(0, this.historyIndex + 1);
        if (this.history.length > this.maxHistoryLength) this.history = this.history.slice(-this.maxHistoryLength);
        const mementos = /* @__PURE__ */ new Map();
        for (const originator of originators){
            if (!this.originators.has(originator.mementoOriginatorKey)) throw new Error(`Originator [${originator.mementoOriginatorKey}] has not been added to the HistoryManager.`);
            mementos.set(originator.mementoOriginatorKey, originator.createMemento());
        }
        this.history.push({
            label: label,
            mementos: mementos
        });
        this.historyIndex = this.history.length - 1;
        this.debugEvent(`History record: [${label}]`);
    }
    undo() {
        const undoAction = this.history[this.historyIndex];
        if (!undoAction) return;
        for (const mementoOriginatorKey of undoAction.mementos.keys()){
            const previousMemento = this.findPreviousMemento(mementoOriginatorKey);
            if (previousMemento === $d77b025aa58d633c$var$NOT_FOUND) throw new Error(`Could not find previous memento for [${mementoOriginatorKey}].`);
            this.restoreMemento(mementoOriginatorKey, previousMemento);
        }
        this.historyIndex -= 1;
        this.debugEvent(`History undo: [${undoAction.label}]`);
    }
    redo() {
        const redoAction = this.history[this.historyIndex + 1];
        if (!redoAction) return;
        for (const [mementoOriginatorKey, memento] of redoAction.mementos.entries())this.restoreMemento(mementoOriginatorKey, memento);
        this.historyIndex += 1;
        this.debugEvent(`History redo: [${redoAction.label}]`);
    }
    findPreviousMemento(mementoOriginatorKey) {
        for(let i = this.historyIndex - 1; i >= 0; i--){
            if (this.history[i].mementos.has(mementoOriginatorKey)) return this.history[i].mementos.get(mementoOriginatorKey);
        }
        if (this.clearState.has(mementoOriginatorKey)) return this.clearState.get(mementoOriginatorKey);
        return $d77b025aa58d633c$var$NOT_FOUND;
    }
    restoreMemento(mementoOriginatorKey, memento) {
        this.originators.get(mementoOriginatorKey)?.restoreMemento($d77b025aa58d633c$export$a4ad2735b021c132, $d77b025aa58d633c$export$a4ad2735b021c132, memento);
    }
    debugEvent(...logContent) {
        this.debug(...logContent, this.history.map((action, index)=>index === this.historyIndex ? `** ${action.label} **` : action.label));
    }
};
var $d77b025aa58d633c$var$MementoCaretaker = class _MementoCaretaker {
    constructor(version){
        this.version = version.split("-")[0];
    }
    save(...originators) {
        const packet = {
            version: this.version
        };
        for (const originator of Object.values(originators))packet[originator.mementoOriginatorKey] = this.encode(originator, originator.createMemento());
        return packet;
    }
    restore(blob, ...originators) {
        if (typeof blob !== "object") {
            (0, $idDdm.Logger).warnOnce(`Could not restore data of type [${typeof blob}], expecting an object, ignoring.`);
            return;
        }
        if (blob == null) {
            (0, $idDdm.Logger).warnOnce(`Could not restore data of type [null], expecting an object, ignoring.`);
            return;
        }
        if (!("version" in blob) || typeof blob.version !== "string") {
            (0, $idDdm.Logger).warnOnce(`Could not restore data, missing [version] string in object, ignoring.`);
            return;
        }
        for (const originator of originators){
            const memento = this.decode(originator, blob[originator.mementoOriginatorKey]);
            const messages = [];
            if (!originator.guardMemento(memento, messages)) {
                const messagesString = messages.length > 0 ? `

${messages.join("\n\n")}

` : "";
                (0, $idDdm.Logger).warnOnce(`Could not restore [${originator.mementoOriginatorKey}] data, value was invalid, ignoring.${messagesString}`, memento);
                return;
            }
            originator.restoreMemento(this.version, blob.version, memento);
        }
    }
    /**
   * Encode a memento as a serializable object, encoding any non-serializble types.
   */ encode(originator, memento) {
        try {
            return JSON.parse(JSON.stringify(memento, _MementoCaretaker.encodeTypes));
        } catch (error) {
            throw new Error(`Failed to encode [${originator.mementoOriginatorKey}] value [${error}].`, {
                cause: error
            });
        }
    }
    /**
   * Decode an encoded memento, decoding any non-serializable types.
   */ decode(originator, encoded) {
        if (encoded == null) return encoded;
        try {
            return JSON.parse(JSON.stringify(encoded), _MementoCaretaker.decodeTypes);
        } catch (error) {
            throw new Error(`Failed to decode [${originator.mementoOriginatorKey}] value [${error}].`, {
                cause: error
            });
        }
    }
    static encodeTypes(key, value) {
        if ((0, $idDdm.isDate)(this[key])) return {
            __type: "date",
            value: this[key].toISOString()
        };
        return value;
    }
    static decodeTypes(key, value) {
        if ((0, $idDdm.isObject)(this[key]) && "__type" in this[key] && this[key].__type === "date") return new Date(this[key].value);
        return value;
    }
};
// packages/ag-charts-community/src/api/state/stateManager.ts
var $d77b025aa58d633c$var$StateManager = class {
    constructor(){
        this.caretaker = new $d77b025aa58d633c$var$MementoCaretaker($d77b025aa58d633c$export$a4ad2735b021c132);
        this.state = /* @__PURE__ */ new Map();
    }
    setState(originator, value) {
        if ($d77b025aa58d633c$var$objectsEqual(this.state.get(originator.mementoOriginatorKey), value)) return;
        this.setStateAndRestore(originator, value);
    }
    setStateAndRestore(originator, value) {
        this.state.set(originator.mementoOriginatorKey, value);
        this.restoreState(originator);
    }
    restoreState(originator) {
        const { caretaker: caretaker, state: state } = this;
        if (!state.has(originator.mementoOriginatorKey)) return;
        const value = state.get(originator.mementoOriginatorKey);
        caretaker.restore({
            version: caretaker.version,
            [originator.mementoOriginatorKey]: value
        }, originator);
    }
};
// packages/ag-charts-community/src/styles.css
var $d77b025aa58d633c$var$styles_default = '.ag-charts-wrapper,.ag-charts-wrapper:after,.ag-charts-wrapper:before,.ag-charts-wrapper *,.ag-charts-wrapper *:after,.ag-charts-wrapper *:before{box-sizing:border-box}.ag-charts-wrapper{--align-items: center;--justify-content: center;position:relative;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.ag-charts-wrapper--safe-horizontal{--justify-content: flex-start}.ag-charts-wrapper--safe-vertical{--align-items: flex-start}.ag-charts-tab-guard{width:0%;height:0%;position:absolute;pointer-events:none}.ag-charts-canvas-center{width:100%;height:100%;position:absolute;touch-action:auto;pointer-events:auto;display:flex;align-items:var(--align-items);justify-content:var(--justify-content)}.ag-charts-canvas-container,.ag-charts-canvas{position:relative;user-select:none;-webkit-user-select:none}.ag-charts-canvas-container>*,.ag-charts-canvas>*{pointer-events:none}.ag-charts-canvas canvas{display:block}.ag-charts-series-area{outline:none;pointer-events:auto;position:absolute}.ag-charts-swapchain{top:0;left:0;outline:none;opacity:0;pointer-events:none;position:absolute;width:100%;height:100%}.ag-charts-swapchain:focus-visible{opacity:1}.ag-charts-canvas-proxy,.ag-charts-canvas-overlay{inset:0;pointer-events:none;position:absolute;user-select:none;-webkit-user-select:none}.ag-charts-canvas-overlay>*{position:absolute;pointer-events:auto}.ag-charts-theme-default,.ag-charts-theme-default-dark{--ag-charts-accent-color: #2196f3;--ag-charts-background-color: #fff;--ag-charts-border-color: #dddddd;--ag-charts-foreground-color: #464646;--ag-charts-font-family: Verdana, sans-serif;--ag-charts-font-size: 12px;--ag-charts-font-weight: 400;--ag-charts-padding: 20px;--ag-charts-shadow-color: #00000080;--ag-charts-subtle-text-color: #8c8c8c;--ag-charts-text-color: #464646;--ag-charts-chrome-background-color: #fafafa;--ag-charts-chrome-font-family: Verdana, sans-serif;--ag-charts-chrome-font-size: 12px;--ag-charts-chrome-font-weight: 400;--ag-charts-chrome-subtle-text-color: #8c8c8c;--ag-charts-chrome-text-color: #181d1f;--ag-charts-input-background-color: #fff;--ag-charts-input-text-color: #464646;--ag-charts-crosshair-label-background-color: #fff;--ag-charts-crosshair-label-text-color: #464646;--ag-charts-spacing: 4px;--ag-charts-border-radius: 4px;--ag-charts-icon-size: 16px;--ag-charts-shadow: 0 2px 8px 0 color-mix(in srgb, black 8%, transparent);--ag-charts-focus-shadow: 0 0 0 3px var(--ag-charts-accent-color);--ag-charts-focus-color: color-mix(in srgb, var(--ag-charts-background-color), var(--ag-charts-accent-color) 12%);--ag-charts-input-border-color: var(--ag-charts-border-color);--ag-charts-input-border-radius: var(--ag-charts-border-radius);--ag-charts-input-focus-border-color: var(--ag-charts-accent-color);--ag-charts-input-focus-text-color: var(--ag-charts-accent-color);--ag-charts-input-disabled-background-color: color-mix( in srgb, var(--ag-charts-chrome-background-color), var(--ag-charts-foreground-color) 6% );--ag-charts-input-disabled-border-color: var(--ag-charts-border-color);--ag-charts-input-disabled-text-color: color-mix( in srgb, var(--ag-charts-chrome-background-color), var(--ag-charts-input-text-color) 50% );--ag-charts-input-placeholder-text-color: color-mix( in srgb, var(--ag-charts-input-background-color), var(--ag-charts-input-text-color) 60% );--ag-charts-button-background-color: var(--ag-charts-background-color);--ag-charts-button-border-color: var(--ag-charts-border-color);--ag-charts-button-border-radius: var(--ag-charts-border-radius);--ag-charts-button-text-color: var(--ag-charts-text-color);--ag-charts-button-focus-background-color: color-mix( in srgb, var(--ag-charts-button-background-color), var(--ag-charts-accent-color) 12% );--ag-charts-button-focus-border-color: var(--ag-charts-accent-color);--ag-charts-button-focus-text-color: var(--ag-charts-accent-color);--ag-charts-button-disabled-background-color: color-mix( in srgb, var(--ag-charts-chrome-background-color), var(--ag-charts-foreground-color) 6% );--ag-charts-button-disabled-border-color: var(--ag-charts-border-color);--ag-charts-button-disabled-text-color: color-mix( in srgb, var(--ag-charts-chrome-background-color), var(--ag-charts-chrome-text-color) 50% );--ag-charts-checkbox-background-color: color-mix( in srgb, var(--ag-charts-background-color), var(--ag-charts-foreground-color) 35% );--ag-charts-checkbox-checked-background-color: var(--ag-charts-accent-color);--ag-charts-chrome-font-size-small: var(--ag-charts-chrome-font-size);--ag-charts-chrome-font-size-medium: calc(var(--ag-charts-chrome-font-size) * (13 / 12));--ag-charts-chrome-font-size-large: calc(var(--ag-charts-chrome-font-size) * (14 / 12));--ag-charts-border: solid 1px var(--ag-charts-border-color);--ag-charts-focus-border: solid 1px var(--ag-charts-accent-color);--ag-charts-focus-border-shadow: 0 0 0 3px color-mix(in srgb, transparent, var(--ag-charts-accent-color) 20%);--ag-charts-layer-menu: 6;--ag-charts-layer-ui-overlay: 5;--ag-charts-layer-tooltip: 4;--ag-charts-layer-toolbar: 3;--ag-charts-layer-crosshair: 2;--ag-charts-layer-annotations: 1}.ag-charts-theme-default-dark{--ag-charts-shadow: 0 2px 12px 0 color-mix(in srgb, black 33.3%, transparent);--ag-charts-focus-color: color-mix(in srgb, var(--ag-charts-background-color), var(--ag-charts-accent-color) 22%)}.ag-chart-canvas-wrapper .ag-charts-theme-default{--ag-charts-border-radius: var(--ag-border-radius, 4px);--ag-charts-border: var(--ag-borders-critical, solid 1px) var(--ag-charts-border-color);--ag-charts-focus-shadow: var(--ag-focus-shadow, 0 0 0 3px var(--ag-charts-accent-color));--ag-charts-focus-border-shadow: var( --ag-focus-shadow, 0 0 0 3px color-mix(in srgb, transparent, var(--ag-charts-accent-color) 20%) )}.ag-charts-icon{display:block;width:20px;height:20px;speak:none;speak:never;mask:var(--icon) center / contain no-repeat;background-color:currentColor;transition:background-color .25s ease-in-out}.ag-charts-icon-align-center{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjMDAwIiBkPSJNNyAxMGg2djFIN3pNNCA3aDEydjFINHptMSA2aDEwdjFINXoiLz48L3N2Zz4=)}.ag-charts-icon-align-left{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjMDAwIiBkPSJNNCAxMGg2djFINHptMC0zaDEydjFINHptMCA2aDEwdjFINHoiLz48L3N2Zz4=)}.ag-charts-icon-align-right{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjMDAwIiBkPSJNMTAgMTBoNnYxaC02ek00IDdoMTJ2MUg0em0yIDZoMTB2MUg2eiIvPjwvc3ZnPg==)}.ag-charts-icon-arrow-drawing{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE1LjI5MyA0LjVIMTIuNXYtMUgxN3Y0aC0xVjUuMjA3bC05LjY0NiA5LjY0Ny0uNzA4LS43MDh6IiBmaWxsPSIjMDAwIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03IDE2YTIuNSAyLjUgMCAxIDEtNSAwIDIuNSAyLjUgMCAwIDEgNSAwbS0yLjUgMS41YTEuNSAxLjUgMCAxIDAgMC0zIDEuNSAxLjUgMCAwIDAgMCAzIiBmaWxsPSIjMDAwIi8+PC9zdmc+)}.ag-charts-icon-arrow-down-drawing{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02IDhMMS41IDhMMTAgMThMMTguNSA4TDE0IDhMMTQgM0w2IDNMNiA4Wk03IDRMNyA5SDMuNjYyNDRMMTAgMTYuNDU2TDE2LjMzNzYgOUwxMyA5TDEzIDRMNyA0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)}.ag-charts-icon-arrow-up-drawing{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCAxMkgxOC41TDEwIDJMMS41IDEySDZMNi4wMDAwMiAxN0gxNFYxMlpNMTMgMTZWMTFIMTYuMzM3NkwxMCAzLjU0NDA1TDMuNjYyNDQgMTFIN0w3LjAwMDAyIDE2SDEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)}.ag-charts-icon-callout-annotation{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMyA0LjVBMS41IDEuNSAwIDAgMSA0LjUgM2gxMUExLjUgMS41IDAgMCAxIDE3IDQuNXY4YTEuNSAxLjUgMCAwIDEtMS41IDEuNWgtNC41MTRhMjYgMjYgMCAwIDAtMi4wMTcgMS41NGwtLjMxNC4yNmMtLjU1LjQ1Ny0xLjExNS45MjYtMS43NiAxLjQtLjY2OS40OTEtMS41NjItLjAxMi0xLjU2Mi0uOFYxNEg0LjVBMS41IDEuNSAwIDAgMSAzIDEyLjV6TTQuNSA0YS41LjUgMCAwIDAtLjUuNXY4YS41LjUgMCAwIDAgLjUuNWgxLjgzM3YzLjM3MmEzNiAzNiAwIDAgMCAxLjY3OC0xLjMzOGwuMzItLjI2NWEyNiAyNiAwIDAgMSAyLjIyNS0xLjY4NWwuMTI2LS4wODRIMTUuNWEuNS41IDAgMCAwIC41LS41di04YS41LjUgMCAwIDAtLjUtLjV6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ag-charts-icon-candlestick-series{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzEzMTcyMiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNyAxdjNoMnYxMkg3djNINnYtM0g0VjRoMlYxek01IDVoM3YxMEg1ek0xMSAxNFY2aDJWMy4yNWgxVjZoMnY4aC0ydjIuNzVoLTFWMTR6bTEtN2gzdjZoLTN6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ag-charts-icon-close{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtNSA1IDEwIDEwTTUgMTUgMTUgNSIgc3Ryb2tlPSIjMDAwIi8+PC9zdmc+)}.ag-charts-icon-comment-annotation{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNy41MTMgMy45OTVhNi41IDYuNSAwIDAgMSA2LjA5OCAxMS40MWMtLjU4OC4zOTMtMS4yMTcuNTM2LTEuODI5LjU4NWExMyAxMyAwIDAgMS0xLjI3LjAxN0EyNyAyNyAwIDAgMCAxMCAxNkg0LjVhLjUuNSAwIDAgMS0uNS0uNVYxMHEwLS4yNDctLjAwNy0uNTEzYy0uMDA4LS40MTYtLjAxNi0uODU3LjAxNy0xLjI2OS4wNS0uNjEyLjE5Mi0xLjI0LjU4NS0xLjgzYTYuNSA2LjUgMCAwIDEgMi45MTgtMi4zOTNtMy41Ni42MWE1LjUgNS41IDAgMCAwLTUuNjQ2IDIuMzRjLS4yNjYuMzk3LS4zNzkuODQyLS40MiAxLjM1NC0uMDMuMzYtLjAyMi43MTgtLjAxNSAxLjEwOFE1IDkuNjg5IDUgMTB2NWg1cS4zMTEuMDAxLjU5My4wMDhjLjM5LjAwNy43NDcuMDE1IDEuMTA4LS4wMTUuNTEyLS4wNDEuOTU3LS4xNTQgMS4zNTUtLjQyYTUuNSA1LjUgMCAwIDAtMS45ODMtOS45NjciIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)}.ag-charts-icon-crosshair-add-line{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwMCIgZD0iTTEwIDUuNWEuNS41IDAgMCAxIC41LjV2My41aDMuODc1YS41LjUgMCAwIDEgMCAxSDEwLjV2NC4yNWEuNS41IDAgMSAxLTEgMFYxMC41SDUuNjI1YS41LjUgMCAxIDEgMC0xSDkuNVY2YS41LjUgMCAwIDEgLjUtLjUiLz48L3N2Zz4=)}.ag-charts-icon-date-range-drawing{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAyaDF2MTZIMnptMTUgMGgxdjE2aC0xeiIgZmlsbD0iIzE4MUQxRiIvPjxwYXRoIGQ9Ik0xMy4xNTcgMTFINXYtMWg3Ljc5M0wxMSA4LjIwN2wuNzA3LS43MDcgMy4xODIgMy4xODItMy4xODIgMy4xODItLjcwNy0uNzA3eiIgZmlsbD0iIzAwMCIvPjwvc3ZnPg==)}.ag-charts-icon-date-price-range-drawing{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAySDJ2MTZoMXptMy41MDcgNC44OUw4LjUgNC44OTVWMTBINXYxaDMuNXY3aDF2LTdoNS4wODhsLTEuOTU3IDEuOTU3LjcwNy43MDcgMy4xODItMy4xODJMMTMuMzM4IDcuM2wtLjcwNy43MDdMMTQuNjI0IDEwSDkuNVY0LjkzMmwxLjk1NyAxLjk1Ny43MDctLjcwN0w4Ljk4MiAzIDUuOCA2LjE4MnoiIGZpbGw9IiMxODFEMUYiLz48L3N2Zz4=)}.ag-charts-icon-delete{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzEzMTcyMiIgZD0iTTguNDk2IDguOTk2QS41LjUgMCAwIDEgOSA5LjQ5MnY0YS41LjUgMCAxIDEtMSAuMDA4di00YS41LjUgMCAwIDEgLjQ5Ni0uNTA0TTEyIDkuNWEuNS41IDAgMCAwLTEgMHY0YS41LjUgMCAwIDAgMSAweiIvPjxwYXRoIGZpbGw9IiMxMzE3MjIiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTYgNVYzLjVBMi41IDIuNSAwIDAgMSA4LjUgMWgzQTIuNSAyLjUgMCAwIDEgMTQgMy41VjVoMi44MzNhLjUuNSAwIDAgMSAwIDFIMTV2MTAuMjVjMCAuNDE1LS4wNjYuODYzLS4zIDEuMjIxLS4yNTcuMzk0LS42NzIuNjEyLTEuMi42MTJoLTdjLS41MjggMC0uOTQzLS4yMTgtMS4yLS42MTItLjIzNC0uMzU4LS4zLS44MDYtLjMtMS4yMjFWNkgzLjMzM2EuNS41IDAgMCAxIDAtMXptMS0xLjVBMS41IDEuNSAwIDAgMSA4LjUgMmgzQTEuNSAxLjUgMCAwIDEgMTMgMy41VjVIN3pNNiAxNi4yNVY2aDh2MTAuMjVjMCAuMzM1LS4wNTkuNTU0LS4xMzguNjc1LS4wNTUuMDg1LS4xNC4xNTgtLjM2Mi4xNThoLTdjLS4yMjIgMC0uMzA3LS4wNzMtLjM2Mi0uMTU4LS4wOC0uMTIxLS4xMzgtLjM0LS4xMzgtLjY3NSIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)}.ag-charts-icon-disjoint-channel,.ag-charts-icon-disjoint-channel-drawing{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzEzMTcyMiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTkuMDI4IDE3LjQ2YTIuMjUgMi4yNSAwIDAgMC00LjA5Mi0xLjg1bC05LjUxMS0yLjM3OGEyLjI1IDIuMjUgMCAxIDAtLjIyNS45NzRsOS40NzUgMi4zNjlhMi4yNTEgMi4yNTEgMCAwIDAgNC4zNTMuODg2bS0xLjY2Mi0xLjk2NWExLjI1IDEuMjUgMCAxIDEtLjg4NSAyLjMzOCAxLjI1IDEuMjUgMCAwIDEgLjg4NS0yLjMzOE00LjM0MyAxMy42NjlhMS4yNSAxLjI1IDAgMSAwLTIuMzM4LS44ODUgMS4yNSAxLjI1IDAgMCAwIDIuMzM4Ljg4NU0zLjk3IDguNzY5YTIuMjUgMi4yNSAwIDAgMCAxLjQ1NS0yLjExbDkuNTExLTIuMzc4YTIuMjUgMi4yNSAwIDEgMC0uMjYtLjk2NUw1LjIgNS42ODVhMi4yNSAyLjI1IDAgMSAwLTEuMjMgMy4wODRtLjM3My0yLjU0N2ExLjI1IDEuMjUgMCAxIDEtMi4zMzguODg1IDEuMjUgMS4yNSAwIDAgMSAyLjMzOC0uODg1bTEzLjc1LTMuNDM4YTEuMjUgMS4yNSAwIDEgMS0yLjMzOC44ODUgMS4yNSAxLjI1IDAgMCAxIDIuMzM4LS44ODUiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)}.ag-charts-icon-drag-handle{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSI1Ljc1IiBjeT0iNy43NSIgcj0iLjc1IiBmaWxsPSIjMDAwIiBmaWxsLW9wYWNpdHk9Ii41Ii8+PGNpcmNsZSBjeD0iOS43NSIgY3k9IjcuNzUiIHI9Ii43NSIgZmlsbD0iIzAwMCIgZmlsbC1vcGFjaXR5PSIuNSIvPjxjaXJjbGUgY3g9IjEzLjc1IiBjeT0iNy43NSIgcj0iLjc1IiBmaWxsPSIjMDAwIiBmaWxsLW9wYWNpdHk9Ii41Ii8+PGNpcmNsZSBjeD0iMTMuNzUiIGN5PSIxMS43NSIgcj0iLjc1IiBmaWxsPSIjMDAwIiBmaWxsLW9wYWNpdHk9Ii41Ii8+PGNpcmNsZSBjeD0iOS43NSIgY3k9IjExLjc1IiByPSIuNzUiIGZpbGw9IiMwMDAiIGZpbGwtb3BhY2l0eT0iLjUiLz48Y2lyY2xlIGN4PSI1Ljc1IiBjeT0iMTEuNzUiIHI9Ii43NSIgZmlsbD0iIzAwMCIgZmlsbC1vcGFjaXR5PSIuNSIvPjwvc3ZnPg==)}.ag-charts-icon-fibonacci-retracement-drawing{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjMDAwIiBkPSJNMiA1aDEydjFIMnoiLz48Y2lyY2xlIGN4PSIxNS43NSIgY3k9IjUuNSIgcj0iMS43NSIgc3Ryb2tlPSIjMDAwIi8+PGNpcmNsZSBjeD0iNC4yNSIgY3k9IjE0LjUiIHI9IjEuNzUiIHN0cm9rZT0iIzAwMCIvPjxwYXRoIGZpbGw9IiMwMDAiIGQ9Ik0xOCAxNUg2di0xaDEyem0wLTQuNUgydi0xaDE2eiIvPjwvc3ZnPg==)}.ag-charts-icon-fibonacci-retracement-trend-based-drawing{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjMDAwIiBkPSJtNC45OTYgMTIuNjc0IDMuMjkxLTUuNzQzLjg2OC40OTctMy4yOTEgNS43NDN6Ii8+PGNpcmNsZSBjeD0iOS43NSIgY3k9IjUuNSIgcj0iMS43NSIgc3Ryb2tlPSIjMDAwIi8+PGNpcmNsZSBjeD0iNC4zNTEiIGN5PSIxNC41IiByPSIxLjc1IiBzdHJva2U9IiMwMDAiLz48cGF0aCBmaWxsPSIjMDAwIiBkPSJNMTggNmgtN1Y1aDd6bTAgNC41aC03di0xaDd6bTAgNC41SDZ2LTFoMTJ6Ii8+PC9zdmc+)}.ag-charts-icon-fill-color{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJtOC4wNzEgNC4wNi0uOTI0LS45MjQuNzA3LS43MDcgNy4yODggNy4yODgtNC45NSA0Ljk1YTMuNSAzLjUgMCAwIDEtNC45NSAwbC0xLjQxNC0xLjQxNGEzLjUgMy41IDAgMCAxIDAtNC45NXptLjcwNy43MDhMNC41MzYgOS4wMWEyLjUgMi41IDAgMCAwIDAgMy41MzZMNS45NSAxMy45NmEyLjUgMi41IDAgMCAwIDMuNTM1IDBsNC4yNDMtNC4yNDN6bTYuOSA3LjIwMi0uMzQ1LjM2My0uMzQ0LS4zNjNhLjUuNSAwIDAgMSAuNjg4IDBtLS4zNDUgMS4wOGE4IDggMCAwIDAtLjI4LjMyMyA0LjMgNC4zIDAgMCAwLS40MDkuNTgyYy0uMTEzLjIwMS0uMTQ0LjMyNi0uMTQ0LjM3OGEuODMzLjgzMyAwIDAgMCAxLjY2NyAwYzAtLjA1Mi0uMDMxLS4xNzctLjE0NC0uMzc4YTQuMyA0LjMgMCAwIDAtLjQxLS41ODIgOCA4IDAgMCAwLS4yOC0uMzIybS0uMzQ0LTEuMDguMzQ0LjM2My4zNDQtLjM2My4wMDIuMDAyLjAwNC4wMDQuMDEzLjAxMmE2IDYgMCAwIDEgLjIwNi4yMDhjLjEzMS4xMzYuMzA4LjMyNy40ODUuNTQ1LjE3Ni4yMTUuMzYzLjQ2Ny41MDcuNzI0LjEzNy4yNDMuMjczLjU1My4yNzMuODY4YTEuODMzIDEuODMzIDAgMSAxLTMuNjY3IDBjMC0uMzE1LjEzNi0uNjI1LjI3My0uODY4LjE0NC0uMjU3LjMzLS41MDkuNTA3LS43MjRhOSA5IDAgMCAxIC42NDUtLjcwOGwuMDQ2LS4wNDUuMDEzLS4wMTIuMDA0LS4wMDR6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ag-charts-icon-hollow-candlestick-series{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzEzMTcyMiIgZmlsbC1vcGFjaXR5PSIuMTUiIGQ9Ik01IDVoM3YxMEg1eiIvPjxwYXRoIGZpbGw9IiMxMzE3MjIiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTcgMXYzaDJ2MTJIN3YzSDZ2LTNINFY0aDJWMXpNNSA1aDN2MTBINXptNyAyaDN2NmgtM3ptLTEgN1Y2aDJWMy4yNWgxVjZoMnY4aC0ydjIuNzVoLTFWMTR6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ag-charts-icon-horizontal-line,.ag-charts-icon-horizontal-line-drawing{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzEzMTcyMiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNLjUgOS41aDcuMzA2YTIuMjUgMi4yNSAwIDAgMSA0LjM4OCAwSDE5LjV2MWgtNy4zMDZhMi4yNSAyLjI1IDAgMCAxLTQuMzg4IDBILjV6bTkuNSAxLjc1YTEuMjUgMS4yNSAwIDEgMCAwLTIuNSAxLjI1IDEuMjUgMCAwIDAgMCAyLjUiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)}.ag-charts-icon-line-color{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTQuMjQyIDIuNzIyYy0uNjEyIDAtMS4yLjI0My0xLjYzMi42NzVsLTEuMzQzIDEuMzQ0YS41LjUgMCAwIDAtLjExMi4xMTJMNC4wNSAxMS45NTljLS4yMDcuMjA3LS4zNi40Ni0uNDQ2Ljc0di4wMDFsLS42OSAyLjc2N3YuMDAyYS44Mi44MiAwIDAgMCAxLjAyMiAxLjAyMWguMDAybDIuNjM0LS44MjJjLjI4LS4wODUuNTM0LS4yMzcuNzQtLjQ0M2w3LjEwNy03LjEwOGEuNS41IDAgMCAwIC4xMTItLjExMmwxLjM0My0xLjM0M2EyLjMwOCAyLjMwOCAwIDAgMC0xLjYzMi0zLjk0TTE0LjEyMiA3bDEuMDQ0LTEuMDQ1YTEuMzA4IDEuMzA4IDAgMSAwLTEuODQ5LTEuODVMMTIuMjcxIDUuMTV6bS0yLjU1OC0xLjE0Mi02LjgwNyA2LjgwOWEuOC44IDAgMCAwLS4xOTYuMzI1bC0uNzUgMi40NjggMi40Ny0uNzQ5YS44LjggMCAwIDAgLjMyNS0uMTk0bDYuODA4LTYuODF6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ag-charts-icon-line-series{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzEzMTcyMiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJtMTcuMzYyIDQuODczLTQuNTk0IDYuNjU0LTQuODUtMy4zMTctNC4yNTEgNi45NzctLjg1NC0uNTJMNy42MTIgNi43OWw0Ljg5OSAzLjM1IDQuMDI4LTUuODM2eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)}.ag-charts-icon-line-style-dashed{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjMDAwIiBkPSJNMiA5aDR2MUgyem0xMiAwaDR2MWgtNHpNOCA5aDR2MUg4eiIvPjwvc3ZnPg==)}.ag-charts-icon-line-style-dotted{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIyLjUiIGN5PSI5LjUiIHI9Ii41IiBmaWxsPSIjMDAwIi8+PGNpcmNsZSBjeD0iNC41IiBjeT0iOS41IiByPSIuNSIgZmlsbD0iIzAwMCIvPjxjaXJjbGUgY3g9IjYuNSIgY3k9IjkuNSIgcj0iLjUiIGZpbGw9IiMwMDAiLz48Y2lyY2xlIGN4PSI4LjUiIGN5PSI5LjUiIHI9Ii41IiBmaWxsPSIjMDAwIi8+PGNpcmNsZSBjeD0iMTAuNSIgY3k9IjkuNSIgcj0iLjUiIGZpbGw9IiMwMDAiLz48Y2lyY2xlIGN4PSIxMi41IiBjeT0iOS41IiByPSIuNSIgZmlsbD0iIzAwMCIvPjxjaXJjbGUgY3g9IjE0LjUiIGN5PSI5LjUiIHI9Ii41IiBmaWxsPSIjMDAwIi8+PGNpcmNsZSBjeD0iMTYuNSIgY3k9IjkuNSIgcj0iLjUiIGZpbGw9IiMwMDAiLz48L3N2Zz4=)}.ag-charts-icon-line-style-solid{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjMDAwIiBkPSJNMiA5aDE2djFIMnoiLz48L3N2Zz4=)}.ag-charts-icon-line-with-markers-series{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzEzMTcyMiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJtMTguMTk4IDQuODg4LTMuNTU2IDQuOTE4YTIuMjUgMi4yNSAwIDEgMS0zLjg2Ni43NWwtMS40MzItLjlhMi4yNCAyLjI0IDAgMCAxLTIuMDA5LjQzNWwtMy44MjggNi40MjgtLjg2LS41MTJMNi40NSA5LjYyM2EyLjI1IDIuMjUgMCAxIDEgMy41MS0uNzYxbDEuMzI5LjgzNWEyLjI0IDIuMjQgMCAwIDEgMi41NTctLjQ5N2wzLjU0Mi00Ljg5OHptLTQuOTYgNS4xNTNhMS4yNSAxLjI1IDAgMSAwLS42NCAyLjQxOSAxLjI1IDEuMjUgMCAwIDAgLjY0LTIuNDE5TTkuMSA4LjMyMXEuMDY2LS4xOTIuMDY3LS40MDRhMS4yNSAxLjI1IDAgMSAwLS4wNjcuNDA0IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ag-charts-icon-lock,.ag-charts-icon-locked{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTAuMjA3IDMuNzY0YTIuODk0IDIuODk0IDAgMCAwLTIuODk1IDIuODk0VjloNS43ODlWNi42NThhMi44OTQgMi44OTQgMCAwIDAtMi44OTUtMi44OTRNMTQuMSA5VjYuNjU4YTMuODk0IDMuODk0IDAgMSAwLTcuNzg5IDB2Mi4zNDlBMi41IDIuNSAwIDAgMCA0IDExLjV2M0EyLjUgMi41IDAgMCAwIDYuNSAxN2g4YTIuNSAyLjUgMCAwIDAgMi41LTIuNXYtM0EyLjUgMi41IDAgMCAwIDE0LjUgOXpNNi41IDEwQTEuNSAxLjUgMCAwIDAgNSAxMS41djNBMS41IDEuNSAwIDAgMCA2LjUgMTZoOGExLjUgMS41IDAgMCAwIDEuNS0xLjV2LTNhMS41IDEuNSAwIDAgMC0xLjUtMS41eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)}.ag-charts-icon-measurer-drawing{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0ibTQuNDYxIDEyLjcxIDEuNTMyLTEuNTMxIDEuNDE0IDEuNDE0LjcwNy0uNzA3TDYuNyAxMC40NzJsMS41MzItMS41MzMgMiAyIC43MDctLjcwNy0yLTIgNi4wMS02LjAxIDIuODMgMi44MjhMNS4wNSAxNy43NzggMi4yMjIgMTQuOTVsMS41MzItMS41MzIgMS40MTQgMS40MTQuNzA3LS43MDd6TS44MDggMTQuOTVsLjcwNy0uNzA3TDE0LjI0MyAxLjUxNWwuNzA3LS43MDcuNzA3LjcwNyAyLjgyOCAyLjgyOC43MDcuNzA3LS43MDcuNzA3TDUuNzU3IDE4LjQ4NWwtLjcwNy43MDctLjcwNy0uNzA3LTIuODI4LTIuODI4em0xMS4wNzgtNi44MzVMMTAuNDcgNi43bC43MDctLjcwNyAxLjQxNSAxLjQxNHptLjgyNC0zLjY1NCAxIDEgLjcwOC0uNzA3LTEtMXoiIGZpbGw9IiMxODFEMUYiLz48L3N2Zz4=)}.ag-charts-icon-note-annotation{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMyA0LjVBMS41IDEuNSAwIDAgMSA0LjUgM2gxMUExLjUgMS41IDAgMCAxIDE3IDQuNXY4YTEuNSAxLjUgMCAwIDEtMS41IDEuNWgtMy4yMWwtMS40NjkgMi41N2ExIDEgMCAwIDEtMS42ODIuMDg1TDcuMjQzIDE0SDQuNUExLjUgMS41IDAgMCAxIDMgMTIuNXpNNC41IDRhLjUuNSAwIDAgMC0uNS41djhhLjUuNSAwIDAgMCAuNS41aDMuMjU3bDIuMTk2IDMuMDc0TDExLjcxIDEzaDMuNzlhLjUuNSAwIDAgMCAuNS0uNXYtOGEuNS41IDAgMCAwLS41LS41eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNi41IDYuNUEuNS41IDAgMCAxIDcgNmg2YS41LjUgMCAwIDEgMCAxSDdhLjUuNSAwIDAgMS0uNS0uNU02LjUgOS41QS41LjUgMCAwIDEgNyA5aDZhLjUuNSAwIDAgMSAwIDFIN2EuNS41IDAgMCAxLS41LS41IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ag-charts-icon-ohlc-series{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzEzMTcyMiIgZD0iTTEzIDExaC0zdi0xaDNWM2gxdjJoNHYxaC00djExaC0xek02IDE3di0yaDN2LTFINlY0SDV2MUgydjFoM3YxMXoiLz48L3N2Zz4=)}.ag-charts-icon-pan-end{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwMCIgZD0ibTYuNjQ2IDEzLjgxMy0uMzUzLjM1NC43MDcuNzA3LjM1NC0uMzU0ek0xMS4xNjYgMTBsLjM1NC4zNTQuMzU0LS4zNTQtLjM1NC0uMzU0ek03LjM1NSA1LjQ4IDcgNS4xMjZsLS43MDcuNzA3LjM1My4zNTR6bTAgOS4wNCA0LjE2Ni00LjE2Ni0uNzA3LS43MDgtNC4xNjcgNC4xNjd6bTQuMTY2LTQuODc0TDcuMzU0IDUuNDhsLS43MDguNzA3IDQuMTY3IDQuMTY3ek0xMy4wODMgNXYxMGgxVjV6Ii8+PC9zdmc+)}.ag-charts-icon-pan-left{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTIuNzkgNS44MzMgOC42MjUgMTBsNC4xNjYgNC4xNjctLjcwNy43MDdMNy4yMSAxMGw0Ljg3My00Ljg3NHoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)}.ag-charts-icon-pan-right{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNy4yMSAxNC4xNjcgMTEuMzc2IDEwIDcuMjEgNS44MzNsLjcwNy0uNzA3TDEyLjc5IDEwbC00Ljg3MyA0Ljg3NHoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)}.ag-charts-icon-pan-start{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwMCIgZD0iTTYgNXYxMGgxVjV6TTkuNjI0IDEwbDQuMTY2LTQuMTY3LS43MDctLjcwN0w4LjIxIDEwbDQuODc0IDQuODc0LjcwNy0uNzA3eiIvPjwvc3ZnPg==)}.ag-charts-icon-parallel-channel,.ag-charts-icon-parallel-channel-drawing{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzEzMTcyMiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTcuNzIgNS4zMzFBMi4yNSAyLjI1IDAgMSAwIDE0LjcwNSAzLjZsLTkuNDkgNC41NjJhMi4yNSAyLjI1IDAgMSAwIC4yMDkgMS4wMWw5LjY2Mi00LjY0NmEyLjI1IDIuMjUgMCAwIDAgMi42MzQuODA1bS4zNzMtMi41NDdhMS4yNSAxLjI1IDAgMSAxLTIuMzM4Ljg4NSAxLjI1IDEuMjUgMCAwIDEgMi4zMzgtLjg4NU00LjM0MyA4LjY3YTEuMjUgMS4yNSAwIDEgMS0yLjMzOC44ODUgMS4yNSAxLjI1IDAgMCAxIDIuMzM4LS44ODVNNS4zMDcgMTYuNzI4YTIuMjUgMi4yNSAwIDEgMS0uNTI1LS44NThsOS45MjMtNC43N2EyLjI1IDIuMjUgMCAxIDEgLjM4MS45MjZ6bS0uOTY0LjI3NGExLjI1IDEuMjUgMCAxIDEtMi4zMzguODg1IDEuMjUgMS4yNSAwIDAgMSAyLjMzOC0uODg1bTEzLjAyMy01LjEwNmExLjI1IDEuMjUgMCAxIDAtLjg4NS0yLjMzOSAxLjI1IDEuMjUgMCAwIDAgLjg4NSAyLjMzOSIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)}.ag-charts-icon-position-bottom{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjMDAwIiBmaWxsLW9wYWNpdHk9Ii4yNSIgZD0iTTMgMTBoMTR2MUgzem0zLTNoOHYxSDZ6Ii8+PHBhdGggZmlsbD0iIzAwMCIgZD0iTTYgMTNoOHYxSDZ6Ii8+PC9zdmc+)}.ag-charts-icon-position-center{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjMDAwIiBkPSJNMyAxMGgxNHYxSDN6Ii8+PHBhdGggZmlsbD0iIzAwMCIgZmlsbC1vcGFjaXR5PSIuMjUiIGQ9Ik02IDdoOHYxSDZ6bTAgNmg4djFINnoiLz48L3N2Zz4=)}.ag-charts-icon-position-top{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjMDAwIiBmaWxsLW9wYWNpdHk9Ii4yNSIgZD0iTTMgMTBoMTR2MUgzeiIvPjxwYXRoIGZpbGw9IiMwMDAiIGQ9Ik02IDdoOHYxSDZ6Ii8+PHBhdGggZmlsbD0iIzAwMCIgZmlsbC1vcGFjaXR5PSIuMjUiIGQ9Ik02IDEzaDh2MUg2eiIvPjwvc3ZnPg==)}.ag-charts-icon-price-label-annotation{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNC41IDNBMS41IDEuNSAwIDAgMCAzIDQuNVYxM2ExLjUgMS41IDAgMCAwIDEuNSAxLjVoLjgzM3YuMDU3Yy4yNDItLjI5OS41OTctLjUwMyAxLS41NDhWMTMuNUg0LjVBLjUuNSAwIDAgMSA0IDEzVjQuNWEuNS41IDAgMCAxIC41LS41aDExYS41LjUgMCAwIDEgLjUuNXY4YS41LjUgMCAwIDEtLjUuNWgtNC44MThsLS4xMjYuMDg0YTI2IDI2IDAgMCAwLTIuMjI1IDEuNjg1bC0uMzIuMjY1LS4wNjguMDU2YTEuNSAxLjUgMCAwIDEtMi42MDkgMS4zNTRjLjAzMy43NjMuOTA1IDEuMjM4IDEuNTYuNzU2LjY0Ni0uNDc0IDEuMjEtLjk0MyAxLjc2MS0xLjRsLjMxMy0uMjZBMjYgMjYgMCAwIDEgMTAuOTg2IDE0SDE1LjVhMS41IDEuNSAwIDAgMCAxLjUtMS41di04QTEuNSAxLjUgMCAwIDAgMTUuNSAzeiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PHBhdGggZmlsbD0iIzEzMTcyMiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNOC43MTYgMTQuODE1YTIuMjUgMi4yNSAwIDEgMS00LjIxIDEuNTkzIDIuMjUgMi4yNSAwIDAgMSA0LjIxLTEuNTkzbS0xLjY2MiAxLjk2NmExLjI1IDEuMjUgMCAxIDAtLjg4NS0yLjMzOSAxLjI1IDEuMjUgMCAwIDAgLjg4NSAyLjMzOSIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)}.ag-charts-icon-price-range-drawing{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS4wNDYgMTVWNS44NzdoLjk0MlYxNXoiIGZpbGw9IiMxODFEMUYiLz48cGF0aCBkPSJNOS4wNDYgMTVWNS44NzdoLjk0MlYxNXoiIGZpbGw9IiMxODFEMUYiLz48cGF0aCBkPSJNOS41IDYuMjI4IDcuMTY3IDguMzc2IDYuNSA3Ljc2MiA5LjUgNWwzIDIuNzYyLS42NjcuNjE0eiIgZmlsbD0iIzAwMCIvPjxwYXRoIGQ9Ik0yIDE4di0xaDE2djF6TTIgM1YyaDE2djF6IiBmaWxsPSIjMTgxRDFGIi8+PC9zdmc+)}.ag-charts-icon-reset{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTIuMDQgNC40NDVhNS44MSA1LjgxIDAgMCAwLTcuMjU3IDIuNDUzLjUuNSAwIDAgMS0uODY1LS41MDJBNi44MSA2LjgxIDAgMSAxIDMgOS44MTNhLjUuNSAwIDAgMSAxIDAgNS44MSA1LjgxIDAgMSAwIDguMDQtNS4zNjgiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTQuMjg5IDMuMDAyYS41LjUgMCAwIDEgLjUuNXYyLjY1NWgyLjY1NWEuNS41IDAgMCAxIDAgMUg0LjI5YS41LjUgMCAwIDEtLjUtLjVWMy41MDJhLjUuNSAwIDAgMSAuNS0uNSIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)}.ag-charts-icon-settings{--icon: url(data:image/svg+xml;base64,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)}.ag-charts-icon-step-line-series{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzE4MUQxRiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNiA0aDV2OGgzVjhoNXYxaC00djRoLTVWNUg3djEwSDJ2LTFoNHoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)}.ag-charts-icon-text-annotation{--icon: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDRIMTZWN0gxNVY1SDEwLjVWMTVIMTRWMTZINlYxNUg5LjVWNUg1VjdINFY0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)}.ag-charts-icon-trend-line,.ag-charts-icon-trend-line-drawing{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzEzMTcyMiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNS4zMTQgMTAuOTM4YTIuMjUgMi4yNSAwIDEgMSAuMDEtMWg5LjM1MmEyLjI1IDIuMjUgMCAxIDEgLjAxIDF6bS0yLjE4OS43MjlhMS4yNSAxLjI1IDAgMSAwIDAtMi41IDEuMjUgMS4yNSAwIDAgMCAwIDIuNW0xMy43NSAwYTEuMjUgMS4yNSAwIDEgMCAwLTIuNSAxLjI1IDEuMjUgMCAwIDAgMCAyLjUiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)}.ag-charts-icon-unlock,.ag-charts-icon-unlocked{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTAuNjUxIDMuNWEyLjg5NCAyLjg5NCAwIDAgMC0yLjg5NCAyLjg5NFY5SDE0LjVhMi41IDIuNSAwIDAgMSAyLjUgMi41djNhMi41IDIuNSAwIDAgMS0yLjUgMi41aC04QTIuNSAyLjUgMCAwIDEgNCAxNC41di0zQTIuNSAyLjUgMCAwIDEgNi41IDloLjI1N1Y2LjM5NGEzLjg5NCAzLjg5NCAwIDEgMSA3Ljc4OSAwIC41LjUgMCAwIDEtMSAwQTIuODk0IDIuODk0IDAgMCAwIDEwLjY1IDMuNU02LjUgMTBBMS41IDEuNSAwIDAgMCA1IDExLjV2M0ExLjUgMS41IDAgMCAwIDYuNSAxNmg4YTEuNSAxLjUgMCAwIDAgMS41LTEuNXYtM2ExLjUgMS41IDAgMCAwLTEuNS0xLjV6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ag-charts-icon-vertical-line,.ag-charts-icon-vertical-line-drawing{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzEzMTcyMiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTAuNSA3LjgwNmEyLjI1IDIuMjUgMCAwIDEgMCA0LjM4OFYxOS41aC0xdi03LjMwNmEyLjI1IDIuMjUgMCAwIDEgMC00LjM4OFYuNWgxem0tLjUuOTQ0YTEuMjUgMS4yNSAwIDEgMSAwIDIuNSAxLjI1IDEuMjUgMCAwIDEgMC0yLjUiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)}.ag-charts-icon-zoom-in{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwMCIgZD0iTTEwIDUuNWEuNS41IDAgMCAxIC41LjV2My41aDMuODc1YS41LjUgMCAwIDEgMCAxSDEwLjV2NC4yNWEuNS41IDAgMSAxLTEgMFYxMC41SDUuNjI1YS41LjUgMCAxIDEgMC0xSDkuNVY2YS41LjUgMCAwIDEgLjUtLjUiLz48L3N2Zz4=)}.ag-charts-icon-zoom-out{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNS41IDEwYS41LjUgMCAwIDEgLjUtLjVoOGEuNS41IDAgMCAxIDAgMUg2YS41LjUgMCAwIDEtLjUtLjUiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)}.ag-charts-icon-high-low-series{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzEzMTcyMiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNyA0aDJ2MTJINFY0aDNNNSA1aDN2MTBINXpNMTEgMTRWNmg1djhoLTVtMS03aDN2NmgtM3oiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)}.ag-charts-icon-hlc-series{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzEzMTcyMiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJtMTguMTYzIDEuODM3LTUuMzM0IDExLjYyMUw2Ljk1NyA4LjEybC00LjE5OSA5LjYyMi0uOTE2LS40IDQuNzU2LTEwLjlMMTIuNDkgMTEuOCAxNy4yNTQgMS40MnoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGZpbGw9IiMwMDAiIGZpbGwtb3BhY2l0eT0iLjQiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTUuODI1IDIuNzA0LjU1IDEzLjc4NWwuOTAyLjQzIDQuNzI0LTkuOTE5IDYuMDM0IDUuMDI5IDMuMjU1LTguMTQtLjkyOC0uMzctMi43NDUgNi44NnptNy44NTIgMTQuNjM2IDUuNzgtMTMuMTM5LS45MTUtLjQwMi01LjIxOSAxMS44Ni02LjAwNS01LjUwNC0zLjI3OCA3LjY0OC45Mi4zOTQgMi43MjItNi4zNTJ6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ag-charts-icon-zoom-in-alt{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLXpvb20taW4iPjxjaXJjbGUgY3g9IjExIiBjeT0iMTEiIHI9IjgiLz48bGluZSB4MT0iMjEiIHgyPSIxNi42NSIgeTE9IjIxIiB5Mj0iMTYuNjUiLz48bGluZSB4MT0iMTEiIHgyPSIxMSIgeTE9IjgiIHkyPSIxNCIvPjxsaW5lIHgxPSI4IiB4Mj0iMTQiIHkxPSIxMSIgeTI9IjExIi8+PC9zdmc+)}.ag-charts-icon-zoom-out-alt{--icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLXpvb20tb3V0Ij48Y2lyY2xlIGN4PSIxMSIgY3k9IjExIiByPSI4Ii8+PGxpbmUgeDE9IjIxIiB4Mj0iMTYuNjUiIHkxPSIyMSIgeTI9IjE2LjY1Ii8+PGxpbmUgeDE9IjgiIHgyPSIxNCIgeTE9IjExIiB5Mj0iMTEiLz48L3N2Zz4=)}.ag-charts-input{--input-layer-active: 1;--input-layer-focus: 2;--input-padding: calc(var(--ag-charts-spacing) * 2);--input-padding-large: calc(var(--ag-charts-spacing) * 2.5);color:var(--ag-charts-input-text-color);font-family:var(--ag-charts-chrome-font-family);font-size:var(--ag-charts-chrome-font-size-large);transition-duration:.25s;transition-property:none;transition-timing-function:ease-out}.ag-charts-input:focus-visible{outline:var(--ag-charts-focus-border);box-shadow:var(--ag-charts-focus-border-shadow);z-index:var(--input-layer-focus)}.ag-charts-button{background:var(--ag-charts-button-background-color);border:1px solid var(--ag-charts-border-color);border-radius:var(--ag-charts-button-border-radius);color:var(--ag-charts-button-text-color);cursor:pointer;padding:var(--input-padding);transition-property:background,border-color}.ag-charts-button:hover{background:var(--ag-charts-focus-color)}.ag-charts-button:has(.ag-charts-icon){padding:2px}.ag-charts-checkbox{--checkbox-transition-duration: .1s;appearance:none;background:var(--ag-charts-checkbox-background-color);border-radius:calc(var(--ag-charts-border-radius) * 9);cursor:pointer;height:18px;margin:0;transition-duration:var(--checkbox-transition-duration);transition-property:margin;width:29px}.ag-charts-checkbox:before{display:block;background:var(--ag-charts-input-background-color);border-radius:calc(var(--ag-charts-border-radius) * 7);content:" ";height:14px;margin:2px;transition-duration:var(--checkbox-transition-duration);transition-property:margin;transition-timing-function:var(--ag-charts-input-transition-easing);width:14px}.ag-charts-checkbox:checked{background:var(--ag-charts-checkbox-checked-background-color)}.ag-charts-checkbox:checked:before{margin-left:13px}.ag-charts-select{background:var(--ag-charts-input-background-color);border:1px solid var(--ag-charts-input-border-color);border-radius:var(--ag-charts-input-border-radius);padding:3px 2px 4px;font-size:inherit}.ag-charts-textarea{--textarea-line-height: 1.38;background:var(--ag-charts-input-background-color);border:1px solid var(--ag-charts-border-color);border-radius:var(--ag-charts-input-border-radius);line-height:var(--textarea-line-height);font-family:var(--ag-charts-chrome-font-family);font-size:var(--ag-charts-chrome-font-size-large);padding:var(--input-padding-large) var(--input-padding)}.ag-charts-textarea::placeholder{color:var(--ag-charts-input-placeholder-text-color)}.ag-charts-proxy-container{pointer-events:none;position:absolute}.ag-charts-proxy-elem{-webkit-appearance:none;appearance:none;background:none;border:none;color:#0000;overflow:hidden;pointer-events:auto;position:absolute}.ag-charts-proxy-elem::-moz-range-thumb,.ag-charts-proxy-elem::-moz-range-track{opacity:0}.ag-charts-proxy-elem::-webkit-slider-runnable-track,.ag-charts-proxy-elem::-webkit-slider-thumb{opacity:0}.ag-charts-proxy-elem:focus-visible{outline:var(--ag-charts-focus-border);box-shadow:var(--ag-charts-focus-border-shadow)}.ag-charts-focus-indicator{position:absolute;display:block;pointer-events:none;user-select:none;-webkit-user-select:none;width:100%;height:100%}.ag-charts-focus-indicator>div{position:absolute;outline:solid 1px var(--ag-charts-chrome-background-color);box-shadow:var(--ag-charts-focus-shadow)}.ag-charts-focus-indicator>svg{width:100%;height:100%;fill:none;overflow:visible}.ag-charts-focus-svg-outer-path{stroke:var(--ag-charts-chrome-background-color);stroke-width:4px}.ag-charts-focus-svg-inner-path{stroke:var(--ag-charts-accent-color);stroke-width:2px}.ag-charts-overlay{color:#181d1f;pointer-events:none}.ag-charts-overlay.ag-charts-dark-overlay{color:#fff}.ag-charts-overlay--loading{color:#8c8c8c}.ag-charts-overlay__loading-background{background:#fff;pointer-events:none}.ag-charts-overlay.ag-charts-dark-overlay .ag-charts-overlay__loading-background{background:#192232}.ag-charts-tooltip{--tooltip-arrow-size: 8px;--tooltip-row-spacing: 8px;--tooltip-column-spacing: 16px;position:fixed;inset:unset;margin:0;padding:0;overflow:visible;top:var(--top, 0px);left:var(--left, 0px);width:max-content;max-width:100%;font-family:var(--ag-charts-chrome-font-family);font-size:var(--ag-charts-chrome-font-size);font-weight:var(--ag-charts-chrome-font-weight);color:var(--ag-charts-chrome-text-color);background:var(--ag-charts-chrome-background-color);border:var(--ag-charts-border);border-radius:var(--ag-charts-border-radius);box-shadow:var(--ag-charts-shadow)}.ag-charts-tooltip--compact .ag-charts-tooltip-content{--tooltip-row-spacing: 2px;--tooltip-column-spacing: 8px;padding:3px 6px}.ag-charts-tooltip--arrow-top:before,.ag-charts-tooltip--arrow-right:before,.ag-charts-tooltip--arrow-bottom:before,.ag-charts-tooltip--arrow-left:before{content:"";position:absolute;display:block;width:var(--tooltip-arrow-size);height:var(--tooltip-arrow-size);border:inherit;border-bottom-color:transparent;border-right-color:transparent;background:inherit;clip-path:polygon(0 0,100% 0,100% 1px,1px 100%,0 100%)}.ag-charts-tooltip--arrow-top:before{bottom:100%;left:50%;transform:translate(-50%) translateY(calc(var(--tooltip-arrow-size) * .5)) rotate(45deg)}.ag-charts-tooltip--arrow-bottom:before{top:100%;left:50%;transform:translate(-50%) translateY(calc(var(--tooltip-arrow-size) * -.5)) rotate(225deg)}.ag-charts-tooltip--arrow-left:before{right:100%;top:50%;transform:translateY(-50%) translate(calc(var(--tooltip-arrow-size) * .5)) rotate(315deg)}.ag-charts-tooltip--arrow-right:before{left:100%;top:50%;transform:translateY(-50%) translate(calc(var(--tooltip-arrow-size) * -.5)) rotate(135deg)}.ag-charts-tooltip--no-interaction{pointer-events:none;user-select:none;-webkit-user-select:none}.ag-charts-tooltip--wrap-always{overflow-wrap:break-word;word-break:break-word;hyphens:none}.ag-charts-tooltip--wrap-hyphenate{overflow-wrap:break-word;word-break:break-word;hyphens:auto}.ag-charts-tooltip--wrap-on-space{overflow-wrap:normal;word-break:normal}.ag-charts-tooltip--wrap-never{white-space:nowrap}.ag-charts-tooltip-heading,.ag-charts-tooltip-title,.ag-charts-tooltip-label,.ag-charts-tooltip-value{overflow:hidden;text-overflow:ellipsis}.ag-charts-tooltip-content{display:grid;grid:auto-flow minmax(1em,auto) / 1fr;padding:8px 12px;gap:var(--tooltip-row-spacing)}.ag-charts-tooltip-content:has(.ag-charts-tooltip-symbol){grid:auto-flow minmax(1em,auto) / auto 1fr}.ag-charts-tooltip-heading{grid-column:1 / -1}.ag-charts-tooltip-symbol{grid-column:1 / 2;place-self:center}.ag-charts-tooltip-symbol svg{display:block}.ag-charts-tooltip-title{grid-column:-2 / -1}.ag-charts-tooltip-row{grid-column:1 / -1;display:flex;gap:var(--tooltip-column-spacing);align-items:baseline;justify-content:space-between;overflow:hidden}.ag-charts-tooltip-row--inline{grid-column:-2 / -1}.ag-charts-tooltip-label{flex:1;min-width:0}.ag-charts-tooltip-value{min-width:0}.ag-charts-tooltip-footer{grid-column:1 / -1;color:var(--ag-charts-chrome-subtle-text-color);text-align:center}.ag-charts-popover{position:absolute;border:var(--ag-charts-border);border-radius:var(--ag-charts-border-radius);background:var(--ag-charts-chrome-background-color);color:var(--ag-charts-chrome-text-color);font-family:var(--ag-charts-chrome-font-family);font-size:var(--ag-charts-chrome-font-size);font-weight:var(--ag-charts-chrome-font-weight);box-shadow:var(--ag-charts-shadow);z-index:var(--ag-charts-layer-ui-overlay)}.ag-charts-menu{--item-padding: 6px 12px;--icon-color: var(--ag-charts-chrome-text-color);display:grid;grid:auto-flow auto / 1fr;column-gap:12px;font-size:var(--ag-charts-chrome-font-size)}.ag-charts-menu:has(.ag-charts-menu__icon,.ag-charts-menu__row--stroke-width-visible){grid:auto-flow auto / auto 1fr}.ag-charts-menu__row--stroke-width-visible:before{content:"";height:var(--strokeWidth);width:12px;background:var(--icon-color)}.ag-charts-menu__row--stroke-width-visible[aria-disabled=true]:before{filter:grayscale(1);opacity:.5}.ag-charts-menu__row{display:grid;grid-column:1 / -1;grid-template-columns:subgrid;align-items:center;padding:var(--item-padding)}.ag-charts-menu__row:not(.ag-charts-menu__row--active){cursor:pointer}.ag-charts-menu__row:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.ag-charts-menu__row:last-child{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.ag-charts-menu__row:focus{background:var(--ag-charts-focus-color)}.ag-charts-menu__row:focus-visible{outline:var(--ag-charts-focus-border);box-shadow:var(--ag-charts-focus-border-shadow);z-index:var(--ag-charts-layer-menu)}.ag-charts-menu__row--active{--icon-color: var(--ag-charts-accent-color);background:var(--ag-charts-focus-color);color:var(--ag-charts-accent-color)}.ag-charts-menu__label{grid-column:-1 / span 1}.ag-charts-toolbar{--toolbar-gap: calc(var(--ag-charts-spacing) * 2);--toolbar-size: 34px;--toolbar-button-padding: 6px;align-items:center;display:flex;flex-wrap:nowrap;position:absolute}.ag-charts-toolbar__button{align-items:center;background:var(--ag-charts-chrome-background-color);border:var(--ag-charts-border);color:var(--ag-charts-chrome-text-color);cursor:pointer;display:flex;font-family:var(--ag-charts-chrome-font-family);font-size:var(--ag-charts-chrome-font-size-medium);font-weight:var(--ag-charts-chrome-font-weight);justify-content:center;min-height:var(--toolbar-size);min-width:var(--toolbar-size);padding:var(--toolbar-button-padding);position:relative;transition:background-color .25s ease-in-out,border-color .25s ease-in-out,color .25s ease-in-out;white-space:nowrap}.ag-charts-toolbar__button:hover{background:var(--ag-charts-focus-color);z-index:1}.ag-charts-toolbar__button:focus-visible{outline:var(--ag-charts-focus-border);box-shadow:var(--ag-charts-focus-border-shadow);z-index:calc(var(--ag-charts-layer-ui-overlay) + 1)}.ag-charts-toolbar__button--active{background:var(--ag-charts-focus-color);border-color:var(--ag-charts-accent-color);color:var(--ag-charts-accent-color);z-index:2}.ag-charts-toolbar__button[aria-disabled=true]{background:var(--ag-charts-button-disabled-background-color);color:var(--ag-charts-button-disabled-text-color);cursor:default}.ag-charts-toolbar--horizontal{flex-direction:row;.ag-charts-toolbar__button{margin:0 0 0 -1px}.ag-charts-toolbar__button--first{border-bottom-left-radius:var(--ag-charts-border-radius);border-top-left-radius:var(--ag-charts-border-radius);margin:0}.ag-charts-toolbar__button--last{border-bottom-right-radius:var(--ag-charts-border-radius);border-top-right-radius:var(--ag-charts-border-radius)}}.ag-charts-toolbar--vertical{flex-direction:column;.ag-charts-toolbar__button{margin:-1px 0 0;max-width:100%}.ag-charts-toolbar__button--first{border-top-left-radius:var(--ag-charts-border-radius);border-top-right-radius:var(--ag-charts-border-radius);margin:0}.ag-charts-toolbar__button--last{border-bottom-left-radius:var(--ag-charts-border-radius);border-bottom-right-radius:var(--ag-charts-border-radius)}}.ag-charts-toolbar__icon+.ag-charts-toolbar__label{margin-left:var(--toolbar-gap)}.ag-charts-toolbar__icon,.ag-charts-toolbar__label{pointer-events:none}.ag-charts-floating-toolbar{border:none;display:flex;.ag-charts-toolbar{align-items:unset;position:unset}}.ag-charts-floating-toolbar__drag-handle{align-items:center;background:var(--ag-charts-chrome-background-color);border:var(--ag-charts-border);border-bottom-left-radius:var(--ag-charts-border-radius);border-top-left-radius:var(--ag-charts-border-radius);cursor:grab;display:flex;justify-content:center;min-width:24px;padding-left:0;padding-right:0}.ag-charts-floating-toolbar__drag-handle--dragging{cursor:grabbing}\n';
var $d77b025aa58d633c$var$Listeners = class {
    constructor(){
        this.registeredListeners = /* @__PURE__ */ new Map();
    }
    addListener(eventType, handler) {
        const record = {
            symbol: Symbol(eventType),
            handler: handler
        };
        if (this.registeredListeners.has(eventType)) this.registeredListeners.get(eventType).push(record);
        else this.registeredListeners.set(eventType, [
            record
        ]);
        return ()=>this.removeListener(record.symbol);
    }
    removeListener(eventSymbol) {
        for (const [type, listeners] of this.registeredListeners.entries()){
            const matchIndex = listeners.findIndex((listener)=>listener.symbol === eventSymbol);
            if (matchIndex >= 0) {
                listeners.splice(matchIndex, 1);
                if (listeners.length === 0) this.registeredListeners.delete(type);
                break;
            }
        }
    }
    dispatch(eventType, ...params) {
        for (const listener of this.getListenersByType(eventType))try {
            listener.handler(...params);
        } catch (e) {
            (0, $idDdm.Logger).errorOnce(e);
        }
    }
    getListenersByType(eventType) {
        return this.registeredListeners.get(eventType) ?? [];
    }
    destroy() {
        this.registeredListeners.clear();
    }
};
// packages/ag-charts-community/src/util/baseManager.ts
var $d77b025aa58d633c$var$BaseManager = class {
    constructor(){
        this.listeners = new $d77b025aa58d633c$var$Listeners();
        this.destroyFns = [];
        this.destroyed = false;
    }
    addListener(type, handler) {
        return this.listeners.addListener(type, handler);
    }
    destroy() {
        this.listeners.destroy();
        this.destroyFns.forEach((fn)=>fn());
        this.destroyed = true;
    }
};
var $d77b025aa58d633c$var$GuardedElement = class _GuardedElement {
    constructor(element2, topTabGuard, bottomTabGuard){
        this.element = element2;
        this.topTabGuard = topTabGuard;
        this.bottomTabGuard = bottomTabGuard;
        this.destroyFns = [];
        this.guardTabIndex = 0;
        this.hasFocus = false;
        this.initTabGuard(this.topTabGuard, (el)=>this.onTab(el, false));
        this.initTabGuard(this.bottomTabGuard, (el)=>this.onTab(el, true));
        this.element.addEventListener("focus", ()=>this.onFocus(), {
            capture: true
        });
        this.element.addEventListener("blur", (ev)=>this.onBlur(ev), {
            capture: true
        });
    }
    set tabIndex(index) {
        this.guardTabIndex = index;
        if (this.guardTabIndex === 0) this.setGuardIndices(void 0);
        else if (!this.hasFocus) this.setGuardIndices(this.guardTabIndex);
    }
    destroy() {
        for (const fn of this.destroyFns)fn();
        this.destroyFns.length = 0;
    }
    initTabGuard(guard, handler) {
        const handlerBinding = ()=>handler(guard);
        guard.addEventListener("focus", handlerBinding);
        this.destroyFns.push(()=>guard.removeEventListener("focus", handlerBinding));
    }
    setGuardIndices(index) {
        const tabindex = index;
        (0, $idDdm.setAttribute)(this.topTabGuard, "tabindex", tabindex);
        (0, $idDdm.setAttribute)(this.bottomTabGuard, "tabindex", tabindex);
    }
    onFocus() {
        this.hasFocus = true;
        if (this.guardTabIndex !== 0) this.setGuardIndices(0);
    }
    onBlur({ relatedTarget: relatedTarget }) {
        const { topTabGuard: top, bottomTabGuard: bot } = this;
        this.hasFocus = false;
        if (this.guardTabIndex !== 0 && relatedTarget !== top && relatedTarget !== bot) this.setGuardIndices(this.guardTabIndex);
    }
    onTab(guard, reverse) {
        if (this.guardTabIndex !== 0) {
            let focusTarget;
            if (guard.tabIndex === 0) {
                focusTarget = this.findExitTarget(!reverse);
                this.setGuardIndices(this.guardTabIndex);
            } else focusTarget = this.findEnterTarget(reverse);
            focusTarget?.focus();
        }
    }
    static queryFocusable(element2, selectors) {
        const myWindow = (0, $idDdm.getWindow)();
        return Array.from(element2.querySelectorAll(selectors)).filter((e)=>{
            if (e instanceof HTMLElement) {
                const style = myWindow.getComputedStyle(e);
                return style.display !== "none" && style.visibility !== "none";
            }
            return false;
        });
    }
    findEnterTarget(reverse) {
        const focusables = _GuardedElement.queryFocusable(this.element, '[tabindex="0"]');
        const index = reverse ? focusables.length - 1 : 0;
        return focusables[index];
    }
    findExitTarget(reverse) {
        const focusables = _GuardedElement.queryFocusable((0, $idDdm.getDocument)(), "[tabindex]").filter((e)=>e.tabIndex > 0).sort((a, b)=>a.tabIndex - b.tabIndex);
        const { before: before, after: after } = _GuardedElement.findBeforeAndAfter(focusables, this.guardTabIndex);
        return reverse ? before : after;
    }
    static findBeforeAndAfter(elements, targetTabIndex) {
        let left = 0;
        let right = elements.length - 1;
        let before = void 0;
        let after = void 0;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            const currentTabIndex = elements[mid].tabIndex;
            if (currentTabIndex === targetTabIndex) {
                before = elements[mid - 1] || void 0;
                after = elements[mid + 1] || void 0;
                break;
            } else if (currentTabIndex < targetTabIndex) {
                before = elements[mid];
                left = mid + 1;
            } else {
                after = elements[mid];
                right = mid - 1;
            }
        }
        return {
            before: before,
            after: after
        };
    }
};
function $d77b025aa58d633c$var$addRemovableEventListener(destroyFns, elem, type, listener, options) {
    elem.addEventListener(type, listener);
    const remover = ()=>elem.removeEventListener(type, listener, options);
    destroyFns.push(remover);
    return remover;
}
function $d77b025aa58d633c$var$addEscapeEventListener(destroyFns, elem, onEscape, keyCodes = [
    "Escape"
]) {
    $d77b025aa58d633c$var$addRemovableEventListener(destroyFns, elem, "keydown", (event)=>{
        if ($d77b025aa58d633c$var$matchesKey(event, ...keyCodes)) onEscape(event);
    });
}
function $d77b025aa58d633c$var$addMouseCloseListener(destroyFns, menu, hideCallback) {
    const self = $d77b025aa58d633c$var$addRemovableEventListener(destroyFns, window, "mousedown", (event)=>{
        if ([
            0,
            2
        ].includes(event.button) && !$d77b025aa58d633c$var$containsEvent(menu, event)) {
            hideCallback();
            self();
        }
    });
    return self;
}
function $d77b025aa58d633c$var$addTouchCloseListener(destroyFns, menu, hideCallback) {
    const self = $d77b025aa58d633c$var$addRemovableEventListener(destroyFns, window, "touchstart", (event)=>{
        const touches = Array.from(event.targetTouches);
        if (touches.some((touch)=>!$d77b025aa58d633c$var$containsEvent(menu, touch))) {
            hideCallback();
            self();
        }
    });
    return self;
}
function $d77b025aa58d633c$var$containsEvent(container, event) {
    return event.target instanceof Node && container.contains(event.target);
}
function $d77b025aa58d633c$var$addOverrideFocusVisibleEventListener(destroyFns, menu, buttons, overrideFocusVisible) {
    buttons.forEach((b)=>(0, $idDdm.setAttribute)(b, "data-focus-visible-override", overrideFocusVisible));
    const keydownTrueOverrider = ()=>{
        buttons.forEach((b)=>(0, $idDdm.setAttribute)(b, "data-focus-visible-override", true));
    };
    $d77b025aa58d633c$var$addRemovableEventListener(destroyFns, menu, "keydown", keydownTrueOverrider, {
        once: true
    });
}
function $d77b025aa58d633c$var$hasNoModifiers(event) {
    return !(event.shiftKey || event.altKey || event.ctrlKey || event.metaKey);
}
function $d77b025aa58d633c$var$matchesKey(event, ...keys) {
    return $d77b025aa58d633c$var$hasNoModifiers(event) && keys.some((key)=>event.key === key);
}
function $d77b025aa58d633c$var$linkTwoButtons(destroyFns, src, dst, key) {
    if (!dst) return;
    $d77b025aa58d633c$var$addRemovableEventListener(destroyFns, src, "keydown", (event)=>{
        if ($d77b025aa58d633c$var$matchesKey(event, key)) dst.focus();
    });
}
function $d77b025aa58d633c$var$linkThreeButtons(destroyFns, curr, next, nextKey, prev, prevKey) {
    $d77b025aa58d633c$var$linkTwoButtons(destroyFns, curr, prev, prevKey);
    $d77b025aa58d633c$var$linkTwoButtons(destroyFns, curr, next, nextKey);
    $d77b025aa58d633c$var$addRemovableEventListener(destroyFns, curr, "keydown", (event)=>{
        if ($d77b025aa58d633c$var$matchesKey(event, nextKey, prevKey)) event.preventDefault();
    });
}
var $d77b025aa58d633c$var$PREV_NEXT_KEYS = {
    horizontal: {
        nextKey: "ArrowRight",
        prevKey: "ArrowLeft"
    },
    vertical: {
        nextKey: "ArrowDown",
        prevKey: "ArrowUp"
    }
};
function $d77b025aa58d633c$var$initRovingTabIndex(opts) {
    const { orientation: orientation, buttons: buttons, wrapAround: wrapAround = false, onEscape: onEscape, onFocus: onFocus, onBlur: onBlur } = opts;
    const { nextKey: nextKey, prevKey: prevKey } = $d77b025aa58d633c$var$PREV_NEXT_KEYS[orientation];
    const setTabIndices = (event)=>{
        if (event.target && "tabIndex" in event.target) {
            buttons.forEach((b)=>b.tabIndex = -1);
            event.target.tabIndex = 0;
        }
    };
    const [c, m] = wrapAround ? [
        buttons.length,
        buttons.length
    ] : [
        0,
        Infinity
    ];
    const destroyFns = [];
    for(let i = 0; i < buttons.length; i++){
        const prev = buttons[(c + i - 1) % m];
        const curr = buttons[i];
        const next = buttons[(c + i + 1) % m];
        $d77b025aa58d633c$var$addRemovableEventListener(destroyFns, curr, "focus", setTabIndices);
        if (onFocus) $d77b025aa58d633c$var$addRemovableEventListener(destroyFns, curr, "focus", onFocus);
        if (onBlur) $d77b025aa58d633c$var$addRemovableEventListener(destroyFns, curr, "blur", onBlur);
        if (onEscape) $d77b025aa58d633c$var$addEscapeEventListener(destroyFns, curr, onEscape);
        $d77b025aa58d633c$var$linkThreeButtons(destroyFns, curr, next, nextKey, prev, prevKey);
        curr.tabIndex = i === 0 ? 0 : -1;
    }
    return destroyFns;
}
var $d77b025aa58d633c$var$MenuCloserImp = class {
    constructor(menu, lastFocus, closeCallback){
        this.lastFocus = lastFocus;
        this.closeCallback = closeCallback;
        this.destroyFns = [];
        this.destroyFns.push($d77b025aa58d633c$var$addMouseCloseListener(this.destroyFns, menu, ()=>this.close(true)));
        this.destroyFns.push($d77b025aa58d633c$var$addTouchCloseListener(this.destroyFns, menu, ()=>this.close(true)));
    }
    close(mousedown) {
        this.destroyFns.forEach((d)=>d());
        this.destroyFns.length = 0;
        this.closeCallback();
        this.finishClosing(mousedown);
    }
    finishClosing(mousedown) {
        this.destroyFns.forEach((d)=>d());
        this.destroyFns.length = 0;
        (0, $idDdm.setAttribute)(this.lastFocus, "aria-expanded", false);
        if (!mousedown) this.lastFocus?.focus({
            preventScroll: true
        });
        this.lastFocus = void 0;
    }
};
function $d77b025aa58d633c$var$initMenuKeyNav(opts) {
    const { sourceEvent: sourceEvent, orientation: orientation, menu: menu, buttons: buttons, closeCallback: closeCallback, overrideFocusVisible: overrideFocusVisible } = opts;
    const { nextKey: nextKey, prevKey: prevKey } = $d77b025aa58d633c$var$PREV_NEXT_KEYS[orientation];
    const lastFocus = $d77b025aa58d633c$var$getLastFocus(sourceEvent);
    (0, $idDdm.setAttribute)(lastFocus, "aria-expanded", true);
    const menuCloser = new $d77b025aa58d633c$var$MenuCloserImp(menu, lastFocus, closeCallback);
    const onEscape = ()=>menuCloser.close();
    const { destroyFns: destroyFns } = menuCloser;
    menu.role = "menu";
    menu.ariaOrientation = orientation;
    destroyFns.push(...$d77b025aa58d633c$var$initRovingTabIndex({
        orientation: orientation,
        buttons: buttons,
        onEscape: onEscape,
        wrapAround: true
    }));
    menu.tabIndex = -1;
    $d77b025aa58d633c$var$addEscapeEventListener(destroyFns, menu, onEscape);
    $d77b025aa58d633c$var$addRemovableEventListener(destroyFns, menu, "keydown", (ev)=>{
        if (ev.target === menu && (ev.key === nextKey || ev.key === prevKey)) {
            ev.preventDefault();
            buttons[0]?.focus();
        }
    });
    buttons[0]?.focus({
        preventScroll: true
    });
    if (overrideFocusVisible !== void 0) $d77b025aa58d633c$var$addOverrideFocusVisibleEventListener(destroyFns, menu, buttons, overrideFocusVisible);
    return menuCloser;
}
function $d77b025aa58d633c$var$makeAccessibleClickListener(element2, onclick) {
    return (event)=>{
        if (element2.ariaDisabled === "true") return event.preventDefault();
        onclick(event);
    };
}
function $d77b025aa58d633c$var$isButtonClickEvent(event) {
    if ("button" in event) return event.button === 0;
    return $d77b025aa58d633c$var$hasNoModifiers(event) && (event.code === "Space" || event.key === "Enter");
}
function $d77b025aa58d633c$var$getLastFocus(sourceEvent) {
    if (sourceEvent?.target instanceof HTMLElement && "tabindex" in sourceEvent.target.attributes) return sourceEvent.target;
    return void 0;
}
function $d77b025aa58d633c$var$stopPageScrolling(element2) {
    const handler = (event)=>{
        if (event.defaultPrevented) return;
        const shouldPrevent = (0, $idDdm.getAttribute)(event.target, "data-preventdefault", true);
        if (shouldPrevent && $d77b025aa58d633c$var$matchesKey(event, "ArrowRight", "ArrowLeft", "ArrowDown", "ArrowUp")) event.preventDefault();
    };
    element2.addEventListener("keydown", handler);
    return ()=>element2.removeEventListener("keydown", handler);
}
var $d77b025aa58d633c$var$PixelRatioObserver = class {
    constructor(callback8){
        this.callback = callback8;
        this.devicePixelRatio = (0, $idDdm.getWindow)("devicePixelRatio") ?? 1;
        this.devicePixelRatioMediaQuery = void 0;
        this.devicePixelRatioListener = (e)=>{
            if (e.matches) return;
            this.devicePixelRatio = (0, $idDdm.getWindow)("devicePixelRatio") ?? 1;
            this.unregisterDevicePixelRatioListener();
            this.registerDevicePixelRatioListener();
            this.callback(this.pixelRatio);
        };
    }
    get pixelRatio() {
        return this.devicePixelRatio;
    }
    observe() {
        this.registerDevicePixelRatioListener();
    }
    disconnect() {
        this.unregisterDevicePixelRatioListener();
    }
    unregisterDevicePixelRatioListener() {
        this.devicePixelRatioMediaQuery?.removeEventListener("change", this.devicePixelRatioListener);
        this.devicePixelRatioMediaQuery = void 0;
    }
    registerDevicePixelRatioListener() {
        const devicePixelRatioMediaQuery = (0, $idDdm.getWindow)("matchMedia")?.(`(resolution: ${this.pixelRatio}dppx)`);
        devicePixelRatioMediaQuery?.addEventListener("change", this.devicePixelRatioListener);
        this.devicePixelRatioMediaQuery = devicePixelRatioMediaQuery;
    }
};
// packages/ag-charts-community/src/util/sizeMonitor.ts
var $d77b025aa58d633c$var$SizeMonitor = class {
    constructor(){
        this.elements = /* @__PURE__ */ new Map();
        this.documentReady = false;
        this.queuedObserveRequests = [];
        this.onLoad = ()=>{
            this.documentReady = true;
            this.queuedObserveRequests.forEach(([el, cb])=>this.observe(el, cb));
            this.queuedObserveRequests = [];
            this.observeWindow();
        };
        if (typeof ResizeObserver !== "undefined") this.resizeObserver = new ResizeObserver((entries8)=>{
            for (const { target: target, contentRect: { width: width2, height: height2 } } of entries8){
                const entry = this.elements.get(target);
                this.checkSize(entry, target, width2, height2);
            }
        });
        let animationFrame;
        this.pixelRatioObserver = new $d77b025aa58d633c$var$PixelRatioObserver(()=>{
            clearTimeout(animationFrame);
            animationFrame = setTimeout(()=>this.checkPixelRatio(), 0);
        });
        this.documentReady = (0, $idDdm.getDocument)("readyState") === "complete";
        if (this.documentReady) this.observeWindow();
        else (0, $idDdm.getWindow)()?.addEventListener("load", this.onLoad);
    }
    destroy() {
        (0, $idDdm.getWindow)()?.removeEventListener("load", this.onLoad);
        this.resizeObserver?.disconnect();
        this.resizeObserver = void 0;
        this.pixelRatioObserver?.disconnect();
        this.pixelRatioObserver = void 0;
    }
    observeWindow() {
        this.pixelRatioObserver?.observe();
    }
    checkPixelRatio() {
        const pixelRatio = this.pixelRatioObserver?.pixelRatio ?? 1;
        for (const [element2, entry] of this.elements)if (entry.size != null && entry.size.pixelRatio !== pixelRatio) {
            const { width: width2, height: height2 } = entry.size;
            entry.size = {
                width: width2,
                height: height2,
                pixelRatio: pixelRatio
            };
            entry.cb(entry.size, element2);
        }
    }
    checkSize(entry, element2, width2, height2) {
        if (!entry) return;
        if (width2 !== entry.size?.width || height2 !== entry.size?.height) {
            const pixelRatio = this.pixelRatioObserver?.pixelRatio ?? 1;
            entry.size = {
                width: width2,
                height: height2,
                pixelRatio: pixelRatio
            };
            entry.cb(entry.size, element2);
        }
    }
    // Only a single callback is supported.
    observe(element2, cb) {
        if (!this.documentReady) {
            this.queuedObserveRequests.push([
                element2,
                cb
            ]);
            return;
        }
        if (this.elements.has(element2)) this.removeFromQueue(element2);
        else this.resizeObserver?.observe(element2);
        const entry = {
            cb: cb
        };
        this.elements.set(element2, entry);
    }
    unobserve(element2) {
        this.resizeObserver?.unobserve(element2);
        this.elements.delete(element2);
        this.removeFromQueue(element2);
        if (!this.elements.size) this.destroy();
    }
    removeFromQueue(element2) {
        this.queuedObserveRequests = this.queuedObserveRequests.filter(([el])=>el !== element2);
    }
};
// packages/ag-charts-community/src/util/stateTracker.ts
var $d77b025aa58d633c$var$StateTracker = class extends Map {
    constructor(defaultValue, defaultState){
        super();
        this.defaultValue = defaultValue;
        this.defaultState = defaultState;
    }
    set(key, value) {
        this.delete(key);
        if (typeof value !== "undefined") super.set(key, value);
        return this;
    }
    stateId() {
        return Array.from(this.keys()).pop() ?? this.defaultState;
    }
    stateValue() {
        return Array.from(this.values()).pop() ?? this.defaultValue;
    }
};
// packages/ag-charts-community/src/dom/domLayout.html
var $d77b025aa58d633c$var$domLayout_default = '<div role="presentation" class="ag-charts-wrapper ag-charts-styles" data-ag-charts><div role="presentation" class="ag-charts-canvas-center"><div role="presentation" class="ag-charts-canvas-container"><div role="presentation" class="ag-charts-canvas" aria-hidden="true"></div><div role="figure" class="ag-charts-canvas-proxy"><div role="presentation" class="ag-charts-series-area"></div></div><div role="presentation" class="ag-charts-canvas-overlay ag-charts-tooltip-container"></div></div></div></div>';
// packages/ag-charts-community/src/dom/domManager.ts
var $d77b025aa58d633c$var$DOM_ELEMENT_CLASSES = [
    "styles",
    "canvas",
    "canvas-center",
    "canvas-container",
    "canvas-overlay",
    "canvas-proxy",
    "series-area",
    "tooltip-container"
];
var $d77b025aa58d633c$var$MINIMAL_DOM_ELEMENT_ROLES = /* @__PURE__ */ new Set([
    "canvas-container",
    "canvas",
    "tooltip-container"
]);
var $d77b025aa58d633c$var$CONTAINER_MODIFIERS = {
    safeHorizontal: "ag-charts-wrapper--safe-horizontal",
    safeVertical: "ag-charts-wrapper--safe-vertical"
};
var $d77b025aa58d633c$var$domElementConfig = /* @__PURE__ */ new Map([
    [
        "styles",
        {
            childElementType: "style"
        }
    ],
    [
        "canvas",
        {
            childElementType: "canvas"
        }
    ],
    [
        "canvas-proxy",
        {
            childElementType: "div"
        }
    ],
    [
        "canvas-overlay",
        {
            childElementType: "div"
        }
    ],
    [
        "canvas-center",
        {
            childElementType: "div"
        }
    ],
    [
        "series-area",
        {
            childElementType: "div"
        }
    ],
    [
        "tooltip-container",
        {
            childElementType: "div"
        }
    ]
]);
function $d77b025aa58d633c$var$setupObserver(element2, cb) {
    if (typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver((observedEntries)=>{
        for (const entry of observedEntries)if (entry.target === element2) cb(entry.intersectionRatio);
    }, {
        root: element2
    });
    observer.observe(element2);
    return observer;
}
var $d77b025aa58d633c$var$NULL_DOMRECT = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    toJSON () {
        return $d77b025aa58d633c$var$NULL_DOMRECT;
    }
};
function $d77b025aa58d633c$var$createTabGuardElement(guardedElem, where) {
    const div = (0, $idDdm.createElement)("div");
    div.className = "ag-charts-tab-guard";
    guardedElem.insertAdjacentElement(where, div);
    return div;
}
var $d77b025aa58d633c$var$_DOMManager = class _DOMManager extends $d77b025aa58d633c$var$BaseManager {
    constructor(chart, initialContainer, styleContainer, mode = "normal"){
        super();
        this.chart = chart;
        this.styleContainer = styleContainer;
        this.mode = mode;
        this.anchorName = `--${(0, $idDdm.createId)(this)}`;
        this.styles = /* @__PURE__ */ new Map();
        this.pendingContainer = void 0;
        this.container = void 0;
        this.documentRoot = void 0;
        this.initiallyConnected = void 0;
        this.containerSize = void 0;
        this.sizeMonitor = new $d77b025aa58d633c$var$SizeMonitor();
        this.cursorState = new $d77b025aa58d633c$var$StateTracker("default");
        this.minWidth = 0;
        this.minHeight = 0;
        this.element = this.initDOM();
        this.rootElements = this.initRootElements();
        this.rootElements["canvas"].element.style.setProperty("anchor-name", this.anchorName);
        let hidden = false;
        this.observer = $d77b025aa58d633c$var$setupObserver(this.element, (intersectionRatio)=>{
            if (intersectionRatio === 0 && !hidden) this.listeners.dispatch("hidden", {
                type: "hidden"
            });
            hidden = intersectionRatio === 0;
        });
        this.setSizeOptions();
        this.updateContainerSize();
        this.addStyles("ag-charts-community", $d77b025aa58d633c$var$styles_default);
        this.setContainer(initialContainer);
        this.destroyFns.push($d77b025aa58d633c$var$stopPageScrolling(this.element));
        if (this.mode === "normal") {
            const guardedElement = this.rootElements["canvas-center"].element;
            if (guardedElement == null) throw new Error("Error initializing tab guards");
            const topGuard = $d77b025aa58d633c$var$createTabGuardElement(guardedElement, "beforebegin");
            const botGuard = $d77b025aa58d633c$var$createTabGuardElement(guardedElement, "afterend");
            this.tabGuards = new $d77b025aa58d633c$var$GuardedElement(guardedElement, topGuard, botGuard);
        }
    }
    initDOM() {
        if (this.mode === "normal") {
            const templateEl = (0, $idDdm.createElement)("div");
            templateEl.innerHTML = $d77b025aa58d633c$var$domLayout_default;
            return templateEl.firstChild;
        }
        const element2 = (0, $idDdm.createElement)("div");
        element2.role = "presentation";
        element2.dataset.agCharts = "";
        element2.classList.add("ag-charts-wrapper");
        const seriesArea = (0, $idDdm.createElement)("div");
        element2.appendChild(seriesArea);
        seriesArea.role = "presentation";
        seriesArea.classList.add("ag-charts-series-area");
        return element2;
    }
    initRootElements() {
        const { mode: mode, element: element2 } = this;
        const rootElements = {};
        for (const domElement of $d77b025aa58d633c$var$DOM_ELEMENT_CLASSES){
            const className = `ag-charts-${domElement}`;
            let el;
            if (mode === "normal") el = element2.classList.contains(className) ? element2 : element2.getElementsByClassName(className)[0];
            else if ($d77b025aa58d633c$var$MINIMAL_DOM_ELEMENT_ROLES.has(domElement)) el = element2;
            else el = element2.getElementsByClassName(className)[0] ?? (0, $idDdm.createElement)("div");
            if (el == null) throw new Error(`AG Charts - unable to find DOM element ${className}`);
            rootElements[domElement] = {
                element: el,
                children: /* @__PURE__ */ new Map(),
                listeners: []
            };
        }
        return rootElements;
    }
    destroy() {
        super.destroy();
        this.observer?.unobserve(this.element);
        if (this.container) this.sizeMonitor.unobserve(this.container);
        this.pendingContainer = void 0;
        Object.values(this.rootElements).forEach((el)=>{
            el.children.forEach((c)=>c.remove());
            el.element.remove();
        });
        this.element.remove();
    }
    postRenderUpdate() {
        if (this.mode === "minimal") return;
        if (this.pendingContainer == null || this.pendingContainer === this.container) return;
        if (_DOMManager.batchedUpdateContainer.length === 0) (0, $idDdm.getWindow)().setTimeout(this.applyBatchedUpdateContainer.bind(this), 0);
        _DOMManager.batchedUpdateContainer.push(this);
    }
    applyBatchedUpdateContainer() {
        for (const manager of _DOMManager.batchedUpdateContainer)if (!manager.destroyed) manager.updateContainer();
        _DOMManager.batchedUpdateContainer.splice(0);
    }
    setSizeOptions(minWidth = 300, minHeight = 300, optionsWidth, optionsHeight) {
        const { style: style } = this.element;
        style.width = `${optionsWidth ?? minWidth}px`;
        style.height = `${optionsHeight ?? minHeight}px`;
        this.minWidth = optionsWidth ?? minWidth;
        this.minHeight = optionsHeight ?? minHeight;
        this.updateContainerClassName();
    }
    updateContainerSize() {
        const { style: centerStyle } = this.rootElements["canvas-center"].element;
        centerStyle.visibility = this.containerSize == null ? "hidden" : "";
        if (this.containerSize) {
            centerStyle.width = `${this.containerSize.width ?? 0}px`;
            centerStyle.height = `${this.containerSize.height ?? 0}px`;
        } else {
            centerStyle.width = "";
            centerStyle.height = "";
        }
        this.updateContainerClassName();
    }
    setTabGuardIndex(tabIndex) {
        if (!this.tabGuards) return;
        this.tabGuards.tabIndex = tabIndex;
    }
    setContainer(newContainer) {
        if (newContainer === this.container) return;
        this.pendingContainer = newContainer;
        if (this.mode === "minimal" || this.container == null) this.updateContainer();
    }
    updateContainer() {
        const { pendingContainer: pendingContainer } = this;
        if (pendingContainer == null || pendingContainer === this.container) return;
        if (this.container) {
            this.container.removeChild(this.element);
            this.sizeMonitor.unobserve(this.container);
        }
        if (this.documentRoot != null) for (const id of this.rootElements["styles"].children.keys())this.removeChild("styles", id);
        this.container = pendingContainer;
        this.pendingContainer = void 0;
        this.documentRoot = this.getShadowDocumentRoot(pendingContainer);
        this.initiallyConnected = this.mode === "minimal" || pendingContainer.isConnected;
        for (const [id, styles] of this.styles)this.addStyles(id, styles);
        pendingContainer.appendChild(this.element);
        this.sizeMonitor.observe(pendingContainer, (size)=>{
            this.containerSize = size;
            this.updateContainerSize();
            this.listeners.dispatch("resize", {
                type: "resize"
            });
        });
        this.listeners.dispatch("container-changed", {
            type: "container-changed"
        });
    }
    setThemeClass(themeClassName) {
        const themeClassNamePrefix = "ag-charts-theme-";
        this.element.classList.forEach((className)=>{
            if (className.startsWith(themeClassNamePrefix) && className !== themeClassName) this.element.classList.remove(className);
        });
        this.element.classList.add(themeClassName);
    }
    setThemeParameters(params) {
        const keysMap = {
            accentColor: "accent-color",
            axisColor: "axis-color",
            backgroundColor: "background-color",
            borderColor: "border-color",
            foregroundColor: "foreground-color",
            fontFamily: "font-family",
            fontSize: "font-size",
            fontWeight: "font-weight",
            gridLineColor: "grid-line-color",
            padding: "padding",
            subtleTextColor: "subtle-text-color",
            textColor: "text-color",
            chromeBackgroundColor: "chrome-background-color",
            chromeFontFamily: "chrome-font-family",
            chromeFontSize: "chrome-font-size",
            chromeFontWeight: "chrome-font-weight",
            chromeSubtleTextColor: "chrome-subtle-text-color",
            chromeTextColor: "chrome-text-color",
            inputBackgroundColor: "input-background-color",
            inputTextColor: "input-text-color",
            crosshairLabelBackgroundColor: "crosshair-label-background-color",
            crosshairLabelTextColor: "crosshair-label-text-color"
        };
        const lengthKeys = [
            "fontSize",
            "chromeFontSize"
        ];
        for (const [key, value] of (0, $idDdm.entries)(params)){
            let formattedValue = `${value}`;
            if (lengthKeys.includes(key)) formattedValue = `${value}px`;
            this.element.style.setProperty(`--ag-charts-${keysMap[key]}`, formattedValue);
        }
    }
    updateCanvasLabel(ariaLabel) {
        (0, $idDdm.setAttribute)(this.rootElements["canvas-proxy"].element, "aria-label", ariaLabel);
    }
    getEventElement(defaultElem, eventType) {
        const events = [
            "focus",
            "blur",
            "keydown",
            "keyup"
        ];
        return events.includes(eventType) ? this.rootElements["series-area"].element : defaultElem;
    }
    addEventListener(type, listener, options) {
        this.getEventElement(this.element, type).addEventListener(type, listener, options);
    }
    removeEventListener(type, listener, options) {
        this.getEventElement(this.element, type).removeEventListener(type, listener, options);
    }
    /** Get the main chart area client bound rect. */ getBoundingClientRect() {
        return this.rootElements["canvas"].element.getBoundingClientRect();
    }
    /**
   * Get the client bounding rect for overlay elements that might float outside the bounds of the
   * main chart area.
   */ getOverlayClientRect() {
        const window2 = (0, $idDdm.getWindow)();
        const windowBBox = new $d77b025aa58d633c$var$BBox(0, 0, window2.innerWidth, window2.innerHeight);
        const containerBBox = this.getRawOverlayClientRect();
        return windowBBox.intersection(containerBBox)?.toDOMRect() ?? $d77b025aa58d633c$var$NULL_DOMRECT;
    }
    getRawOverlayClientRect() {
        let element2 = this.element;
        const fullScreenElement = this.element.getRootNode()?.fullscreenElement;
        while(element2 != null){
            let isContainer;
            if (fullScreenElement != null && element2 === fullScreenElement) isContainer = true;
            else {
                const styleMap = element2.computedStyleMap?.();
                const overflowY = styleMap?.get("overflow-y")?.toString();
                isContainer = overflowY === "auto" || overflowY === "scroll";
            }
            if (isContainer) return $d77b025aa58d633c$var$BBox.fromDOMRect(element2.getBoundingClientRect());
            element2 = element2.parentElement;
        }
        if (this.documentRoot != null) return $d77b025aa58d633c$var$BBox.fromDOMRect(this.documentRoot.getBoundingClientRect());
        const { innerWidth: innerWidth, innerHeight: innerHeight } = (0, $idDdm.getWindow)();
        return new $d77b025aa58d633c$var$BBox(0, 0, innerWidth, innerHeight);
    }
    getShadowDocumentRoot(current = this.container) {
        const docRoot = current?.ownerDocument?.body ?? (0, $idDdm.getDocument)("body");
        while(current != null){
            if (current === docRoot) return void 0;
            if (current.parentNode instanceof DocumentFragment) return current;
            current = current.parentNode;
        }
    }
    getParent(domElementClass) {
        return this.rootElements[domElementClass].element;
    }
    getChildBoundingClientRect(type) {
        const { children: children } = this.rootElements[type];
        const childRects = [];
        for (const child of children.values())childRects.push($d77b025aa58d633c$var$BBox.fromDOMRect(child.getBoundingClientRect()));
        return $d77b025aa58d633c$var$BBox.merge(childRects);
    }
    isManagedChildDOMElement(el, domElementClass, id) {
        const { children: children } = this.rootElements[domElementClass];
        const search = children?.get(id);
        return search != null && el.contains(search);
    }
    contains(element2, domElementClass) {
        if (domElementClass == null) return this.element.contains(element2);
        return this.rootElements[domElementClass].element.contains(element2);
    }
    addStyles(id, styles) {
        const dataAttribute = "data-ag-charts";
        this.styles.set(id, styles);
        if (this.container == null) return;
        const checkId = (el)=>{
            return el.getAttribute(dataAttribute) === id;
        };
        const addStyleElement = (el)=>{
            const metaElements = /* @__PURE__ */ new Set([
                "TITLE",
                "META"
            ]);
            let skippingMetaElements = true;
            let insertAfterEl;
            for (const child of el.children){
                if (skippingMetaElements && metaElements.has(child.tagName)) {
                    insertAfterEl = child;
                    continue;
                }
                skippingMetaElements = false;
                if (checkId(child)) return;
                if (child.hasAttribute(dataAttribute)) insertAfterEl = child;
            }
            const styleEl = (0, $idDdm.createElement)("style");
            if (this.chart.styleNonce != null) styleEl.nonce = this.chart.styleNonce;
            if (insertAfterEl == null) el.prepend(styleEl);
            else el.insertBefore(styleEl, insertAfterEl.nextSibling);
            return styleEl;
        };
        let styleElement;
        if (this.styleContainer) styleElement = addStyleElement(this.styleContainer);
        else if (this.initiallyConnected === false) styleElement = this.addChild("styles", id);
        else if (this.documentRoot == null && !_DOMManager.headStyles.has(id)) {
            styleElement = addStyleElement((0, $idDdm.getDocument)("head"));
            _DOMManager.headStyles.add(id);
        } else if (this.documentRoot != null) styleElement = this.addChild("styles", id);
        if (styleElement == null || checkId(styleElement)) return;
        styleElement.setAttribute(dataAttribute, id);
        styleElement.innerHTML = styles;
    }
    removeStyles(id) {
        this.removeChild("styles", id);
    }
    updateCursor(callerId, style) {
        this.cursorState.set(callerId, style);
        this.element.style.cursor = this.cursorState.stateValue();
    }
    getCursor() {
        return this.element.style.cursor;
    }
    addChild(domElementClass, id, child, insert) {
        const { element: element2, children: children, listeners: listeners } = this.rootElements[domElementClass];
        if (!children) throw new Error("AG Charts - unable to create DOM elements after destroy()");
        if (children.has(id)) return children.get(id);
        const { childElementType: childElementType = "div" } = $d77b025aa58d633c$var$domElementConfig.get(domElementClass) ?? {};
        if (child && child.tagName.toLowerCase() !== childElementType.toLowerCase()) throw new Error("AG Charts - mismatching DOM element type");
        const newChild = child ?? (0, $idDdm.createElement)(childElementType);
        for (const [type, fn, opts] of listeners)newChild.addEventListener(type, fn, opts);
        children.set(id, newChild);
        if (childElementType === "style" && this.chart.styleNonce != null) newChild.nonce = this.chart.styleNonce;
        if (insert) {
            const queryResult = element2.querySelector(insert.query);
            if (queryResult == null) throw new Error(`AG Charts - addChild query failed ${insert.query}`);
            queryResult.insertAdjacentElement(insert.where, newChild);
        } else element2?.appendChild(newChild);
        return newChild;
    }
    removeChild(domElementClass, id) {
        const { children: children } = this.rootElements[domElementClass];
        if (!children) return;
        children.get(id)?.remove();
        children.delete(id);
    }
    incrementDataCounter(name) {
        const { dataset: dataset } = this.element;
        dataset[name] ?? (dataset[name] = "0");
        dataset[name] = String(Number(dataset[name]) + 1);
    }
    setDataBoolean(name, value) {
        this.element.dataset[name] = String(value);
    }
    updateContainerClassName() {
        const { element: element2, containerSize: containerSize, minWidth: minWidth, minHeight: minHeight } = this;
        element2.classList.toggle($d77b025aa58d633c$var$CONTAINER_MODIFIERS.safeHorizontal, minWidth >= (containerSize?.width ?? Infinity));
        element2.classList.toggle($d77b025aa58d633c$var$CONTAINER_MODIFIERS.safeVertical, minHeight >= (containerSize?.height ?? Infinity));
    }
};
$d77b025aa58d633c$var$_DOMManager.batchedUpdateContainer = [];
$d77b025aa58d633c$var$_DOMManager.headStyles = /* @__PURE__ */ new Set();
var $d77b025aa58d633c$var$DOMManager = $d77b025aa58d633c$var$_DOMManager;
var $d77b025aa58d633c$var$BoundedTextWidget = class extends $d77b025aa58d633c$var$Widget {
    constructor(){
        super((0, $idDdm.createElement)("div"));
        this.textElement = (0, $idDdm.createSvgElement)("text");
        this.textElement.role = "presentation";
        this.svgElement = (0, $idDdm.createSvgElement)("svg");
        this.svgElement.appendChild(this.textElement);
        this.svgElement.style.width = "100%";
        this.svgElement.style.opacity = "0";
        this.svgElement.role = "presentation";
        this.elem.appendChild(this.svgElement);
        this.elem.role = "presentation";
    }
    set textContent(text) {
        this.textElement.textContent = text;
        const bboxCalculator = this.textElement;
        const bbox = bboxCalculator.getBBox?.();
        if (bbox) this.svgElement.setAttribute("viewBox", `${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}`);
    }
    get textContent() {
        return this.textElement.textContent;
    }
    destructor() {}
};
var $d77b025aa58d633c$var$AbstractButtonWidget = class extends $d77b025aa58d633c$var$Widget {
    constructor(element2, role){
        super(element2);
        (0, $idDdm.setAttribute)(this.elem, "role", role);
        this.setEnabled(true);
    }
    destructor() {}
    setEnabled(enabled) {
        (0, $idDdm.setAttribute)(this.elem, "aria-disabled", !enabled);
    }
    addListener(type, listener) {
        return super.addListener(type, (ev, current)=>{
            if ((type === "click" || type === "dblclick") && this.isDisabled()) return;
            listener(ev, current);
        });
    }
};
// packages/ag-charts-community/src/widget/buttonWidget.ts
var $d77b025aa58d633c$var$ButtonWidget = class extends $d77b025aa58d633c$var$AbstractButtonWidget {
    constructor(){
        super((0, $idDdm.createElement)("button"));
    }
};
var $d77b025aa58d633c$var$GroupWidget = class extends $d77b025aa58d633c$var$Widget {
    constructor(){
        super((0, $idDdm.createElement)("div"));
        (0, $idDdm.setAttribute)(this.elem, "role", "group");
    }
    destructor() {}
};
var $d77b025aa58d633c$var$RovingTabContainerWidget = class extends $d77b025aa58d633c$var$Widget {
    constructor(initialOrientation, role){
        super((0, $idDdm.createElement)("div"));
        this.focusedChildIndex = 0;
        this.onChildFocus = (_event, child)=>{
            const oldFocus = this.children[this.focusedChildIndex];
            this.focusedChildIndex = child.index;
            oldFocus?.setTabIndex(-1);
            child.setTabIndex(0);
        };
        this.onChildKeyDown = (event, child)=>{
            const rovingOrientation = this.orientation;
            const [primaryKeys, secondaryKeys] = rovingOrientation === "both" ? [
                $d77b025aa58d633c$var$PREV_NEXT_KEYS["horizontal"],
                $d77b025aa58d633c$var$PREV_NEXT_KEYS["vertical"]
            ] : [
                $d77b025aa58d633c$var$PREV_NEXT_KEYS[rovingOrientation],
                void 0
            ];
            let targetIndex = -1;
            if ($d77b025aa58d633c$var$hasNoModifiers(event.sourceEvent)) {
                const key = event.sourceEvent.key;
                if (key === primaryKeys.nextKey || key === secondaryKeys?.nextKey) targetIndex = child.index + 1;
                else if (key === primaryKeys.prevKey || key === secondaryKeys?.prevKey) targetIndex = child.index - 1;
            }
            this.children[targetIndex]?.focus();
        };
        (0, $idDdm.setAttribute)(this.elem, "role", role);
        this.orientation = initialOrientation;
    }
    get orientation() {
        return (0, $idDdm.getAttribute)(this.elem, "aria-orientation") ?? "both";
    }
    set orientation(orientation) {
        (0, $idDdm.setAttribute)(this.elem, "aria-orientation", orientation !== "both" ? orientation : void 0);
    }
    focus() {
        this.children[this.focusedChildIndex]?.focus();
    }
    clear() {
        this.focusedChildIndex = 0;
        for (const child of this.children){
            this.removeChildListeners(child);
            child.parent = void 0;
        }
        this.elem.textContent = "";
        this.children.length = 0;
    }
    addChildListeners(child) {
        child.addListener("focus", this.onChildFocus);
        child.addListener("keydown", this.onChildKeyDown);
    }
    removeChildListeners(child) {
        child.removeListener("focus", this.onChildFocus);
        child.removeListener("keydown", this.onChildKeyDown);
    }
    onChildAdded(child) {
        this.addChildListeners(child);
        child.setTabIndex(this.children.length === 1 ? 0 : -1);
    }
    onChildRemoved(removedChild) {
        this.removeChildListeners(removedChild);
        const { focusedChildIndex: focusedChildIndex, children: children } = this;
        const removedFocusedChild = focusedChildIndex === removedChild.index;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.index === focusedChildIndex) this.focusedChildIndex = i;
            child.index = i;
        }
        if (removedFocusedChild) {
            const newFocusChild = children[focusedChildIndex] ?? children[focusedChildIndex - 1];
            if (newFocusChild) {
                this.focusedChildIndex = newFocusChild.index;
                newFocusChild.setTabIndex(0);
            } else this.focusedChildIndex = 0;
        }
    }
};
// packages/ag-charts-community/src/widget/listWidget.ts
var $d77b025aa58d633c$var$ListWidget = class extends $d77b025aa58d633c$var$RovingTabContainerWidget {
    constructor(){
        super("both", "list");
        this.setHidden(true);
    }
    destructor() {
        this.children.forEach((c)=>c.getElement().parentElement.remove());
    }
    addChildToDOM(child, before) {
        const listItem = (0, $idDdm.createElement)("div");
        (0, $idDdm.setAttribute)(listItem, "role", "listitem");
        (0, $idDdm.setElementStyle)(listItem, "position", "absolute");
        $d77b025aa58d633c$var$Widget.setElementContainer(child, listItem);
        this.appendOrInsert(listItem, before);
        this.setHidden(false);
    }
    removeChildFromDOM(child) {
        child.getElement().parentElement.remove();
        this.setHidden(this.children.length === 0);
    }
    setHidden(hidden) {
        if (this.children.length === 0) hidden = true;
        super.setHidden(hidden);
    }
};
// packages/ag-charts-community/src/widget/nativeWidget.ts
var $d77b025aa58d633c$var$NativeWidget = class extends $d77b025aa58d633c$var$Widget {
    constructor(elem){
        super(elem);
    }
    destructor() {}
};
// packages/ag-charts-community/src/util/format.util.ts
var $d77b025aa58d633c$var$percentFormatter = new Intl.NumberFormat("en-US", {
    style: "percent"
});
function $d77b025aa58d633c$var$formatValue(value, maximumFractionDigits = 2) {
    if (typeof value === "number") return $d77b025aa58d633c$var$formatNumber(value, maximumFractionDigits);
    return typeof value === "string" ? value : String(value ?? "");
}
function $d77b025aa58d633c$var$formatPercent(value) {
    return $d77b025aa58d633c$var$percentFormatter.format(value);
}
var $d77b025aa58d633c$var$numberFormatters = /* @__PURE__ */ new Map().set(2, new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
    useGrouping: false
}));
function $d77b025aa58d633c$var$formatNumber(value, maximumFractionDigits) {
    let formatter = $d77b025aa58d633c$var$numberFormatters.get(maximumFractionDigits);
    if (!formatter) {
        formatter = new Intl.NumberFormat("en-US", {
            maximumFractionDigits: maximumFractionDigits,
            useGrouping: false
        });
        $d77b025aa58d633c$var$numberFormatters.set(maximumFractionDigits, formatter);
    }
    return formatter.format(value);
}
// packages/ag-charts-community/src/widget/sliderWidget.ts
var $d77b025aa58d633c$var$_SliderWidget = class _SliderWidget extends $d77b025aa58d633c$var$Widget {
    constructor(){
        super((0, $idDdm.createElement)("input"));
        this._step = _SliderWidget.STEP_ONE;
        this.orientation = "both";
    }
    get step() {
        return this._step;
    }
    set step(step) {
        this._step = step;
        this.getElement().step = step.attributeValue;
    }
    get keyboardStep() {
        return this._keyboardStep?.step ?? this._step;
    }
    set keyboardStep(step) {
        if (step === this._keyboardStep?.step) return;
        if (this._keyboardStep !== void 0) {
            this.removeListener("keydown", this._keyboardStep.onKeyDown);
            this.removeListener("keyup", this._keyboardStep.onKeyUp);
            this.removeListener("blur", this._keyboardStep.onBlur);
            this._keyboardStep = void 0;
        }
        if (step !== void 0) {
            const onKeyDown = ()=>this.getElement().step = step.attributeValue;
            const resetStep = ()=>this.getElement().step = this._step.attributeValue;
            this._keyboardStep = {
                step: step,
                onKeyDown: onKeyDown,
                onKeyUp: resetStep,
                onBlur: resetStep
            };
            this.addListener("keydown", this._keyboardStep.onKeyDown);
            this.addListener("keyup", this._keyboardStep.onKeyUp);
            this.addListener("blur", this._keyboardStep.onBlur);
        }
    }
    get orientation() {
        return (0, $idDdm.getAttribute)(this.elem, "aria-orientation") ?? "both";
    }
    set orientation(orientation) {
        (0, $idDdm.setAttribute)(this.elem, "aria-orientation", orientation !== "both" ? orientation : void 0);
        _SliderWidget.registerDefaultPreventers(this, orientation);
    }
    destructor() {}
    clampValueRatio(clampMin, clampMax) {
        const ratio11 = this.getValueRatio();
        const clampedRatio = (0, $idDdm.clamp)(clampMin, ratio11, clampMax);
        if (clampedRatio !== ratio11) this.setValueRatio(clampedRatio);
        return clampedRatio;
    }
    setValueRatio(ratio11, opts) {
        const { divider: divider } = this.step;
        const value = Math.round(ratio11 * 1e4) / divider;
        const { ariaValueText: ariaValueText = $d77b025aa58d633c$var$formatPercent(value / divider) } = opts ?? {};
        const elem = this.getElement();
        elem.value = `${value}`;
        elem.ariaValueText = ariaValueText;
    }
    getValueRatio() {
        return parseFloat(this.getElement().value) / this.step.divider;
    }
    static registerDefaultPreventers(target, orientation) {
        if (orientation === "both") target.removeListener("keydown", _SliderWidget.onKeyDown);
        else target.addListener("keydown", _SliderWidget.onKeyDown);
    }
    static onKeyDown(ev, current) {
        let ignoredKeys = [];
        const { orientation: orientation } = current;
        if (orientation === "horizontal") ignoredKeys = [
            "ArrowUp",
            "ArrowDown"
        ];
        else if (orientation === "vertical") ignoredKeys = [
            "ArrowLeft",
            "ArrowRight"
        ];
        if (ignoredKeys.includes(ev.sourceEvent.code)) ev.sourceEvent.preventDefault();
    }
};
$d77b025aa58d633c$var$_SliderWidget.STEP_ONE = {
    attributeValue: "1",
    divider: 1
};
$d77b025aa58d633c$var$_SliderWidget.STEP_HUNDRETH = {
    attributeValue: "0.01",
    divider: 100
};
var $d77b025aa58d633c$var$SliderWidget = $d77b025aa58d633c$var$_SliderWidget;
var $d77b025aa58d633c$var$SwitchWidget = class extends $d77b025aa58d633c$var$ButtonWidget {
    constructor(){
        super();
        (0, $idDdm.setAttribute)(this.elem, "role", "switch");
        this.setChecked(false);
    }
    setChecked(checked) {
        (0, $idDdm.setAttribute)(this.elem, "aria-checked", checked);
    }
};
// packages/ag-charts-community/src/widget/toolbarWidget.ts
var $d77b025aa58d633c$var$ToolbarWidget = class extends $d77b025aa58d633c$var$RovingTabContainerWidget {
    constructor(orientation = "horizontal"){
        super(orientation, "toolbar");
    }
    destructor() {}
};
// packages/ag-charts-community/src/dom/proxyInteractionService.ts
function $d77b025aa58d633c$var$checkType(type, meta) {
    return meta.params?.type === type;
}
function $d77b025aa58d633c$var$allocateResult(type) {
    if ("button" === type) return new $d77b025aa58d633c$var$ButtonWidget();
    else if ("slider" === type) return new $d77b025aa58d633c$var$SliderWidget();
    else if ("toolbar" === type) return new $d77b025aa58d633c$var$ToolbarWidget();
    else if ("group" === type) return new $d77b025aa58d633c$var$GroupWidget();
    else if ("list" === type) return new $d77b025aa58d633c$var$ListWidget();
    else if ("region" === type) return new $d77b025aa58d633c$var$NativeWidget((0, $idDdm.createElement)("div"));
    else if ("text" === type) return new $d77b025aa58d633c$var$BoundedTextWidget();
    else if ("listswitch" === type) return new $d77b025aa58d633c$var$SwitchWidget();
    else throw Error("AG Charts - error allocating meta");
}
function $d77b025aa58d633c$var$allocateMeta(params) {
    const meta = {
        params: params,
        result: void 0
    };
    meta.result = $d77b025aa58d633c$var$allocateResult(meta.params.type);
    return meta;
}
var $d77b025aa58d633c$var$ProxyInteractionService = class {
    constructor(localeManager, domManager){
        this.localeManager = localeManager;
        this.domManager = domManager;
        this.destroyFns = [];
    }
    destroy() {
        this.destroyFns.forEach((fn)=>fn());
    }
    addLocalisation(fn) {
        fn();
        this.destroyFns.push(this.localeManager.addListener("locale-changed", fn));
    }
    createProxyContainer(args) {
        const meta = $d77b025aa58d633c$var$allocateMeta(args);
        const { params: params, result: result } = meta;
        const div = result.getElement();
        this.domManager.addChild("canvas-proxy", params.domManagerId, div);
        div.classList.add(...params.classList, "ag-charts-proxy-container");
        div.role = params.type;
        if ("ariaOrientation" in params) div.ariaOrientation = params.ariaOrientation;
        if ($d77b025aa58d633c$var$checkType("toolbar", meta)) meta.result.orientation = meta.params.orientation;
        this.addLocalisation(()=>{
            div.ariaLabel = this.localeManager.t(params.ariaLabel.id, params.ariaLabel.params);
        });
        return result;
    }
    createProxyElement(args) {
        const meta = $d77b025aa58d633c$var$allocateMeta(args);
        if ($d77b025aa58d633c$var$checkType("button", meta)) {
            const { params: params, result: result } = meta;
            const button = result.getElement();
            this.initInteract(params, result);
            if (typeof params.textContent === "string") button.textContent = params.textContent;
            else {
                const { textContent: textContent } = params;
                this.addLocalisation(()=>{
                    button.textContent = this.localeManager.t(textContent.id, textContent.params);
                });
            }
            this.setParent(meta.params, meta.result);
        }
        if ($d77b025aa58d633c$var$checkType("slider", meta)) {
            const { params: params, result: result } = meta;
            const slider = result.getElement();
            this.initInteract(params, result);
            slider.type = "range";
            slider.role = "presentation";
            slider.style.margin = "0px";
            this.addLocalisation(()=>{
                slider.ariaLabel = this.localeManager.t(params.ariaLabel.id, params.ariaLabel.params);
            });
            this.setParent(meta.params, meta.result);
        }
        if ($d77b025aa58d633c$var$checkType("text", meta)) {
            const { params: params, result: result } = meta;
            this.initElement(params, result);
            this.setParent(meta.params, meta.result);
        }
        if ($d77b025aa58d633c$var$checkType("listswitch", meta)) {
            const { params: params, result: button } = meta;
            this.initInteract(params, button);
            button.setTextContent(params.textContent);
            button.setChecked(params.ariaChecked);
            button.setAriaDescribedBy(params.ariaDescribedBy);
            this.setParent(meta.params, meta.result);
        }
        if ($d77b025aa58d633c$var$checkType("region", meta)) {
            const { params: params, result: result } = meta;
            const region = result.getElement();
            this.initInteract(params, result);
            region.role = "region";
            this.setParent(meta.params, meta.result);
        }
        return meta.result;
    }
    initElement(params, widget) {
        const element2 = widget.getElement();
        (0, $idDdm.setElementStyle)(element2, "cursor", params.cursor);
        element2.classList.toggle("ag-charts-proxy-elem", true);
        return element2;
    }
    initInteract(params, widget) {
        const { tabIndex: tabIndex, domIndex: domIndex } = params;
        const element2 = this.initElement(params, widget);
        if (tabIndex !== void 0) element2.tabIndex = tabIndex;
        if (domIndex !== void 0) widget.domIndex = domIndex;
    }
    setParent(params, element2) {
        if ("parent" in params) params.parent?.addChild(element2);
        else {
            const insert = {
                where: params.where,
                query: ".ag-charts-series-area"
            };
            this.domManager.addChild("canvas-proxy", params.domManagerId, element2.getElement(), insert);
        }
    }
};
// packages/ag-charts-locale/src/en-US.ts
var $d77b025aa58d633c$export$d5744b21be81b3d2 = {
    // Screen reader announcement when focusing an item in the chart
    ariaAnnounceHoverDatum: "${datum}",
    // Screen reader announcement when focusing a chart
    ariaAnnounceChart: "chart, ${seriesCount}[number] series",
    // Screen reader announcement when focusing a hierarchy chart
    ariaAnnounceHierarchyChart: "hierarchy chart, ${caption}",
    // Screen reader announcement when focusing a gauge chart
    ariaAnnounceGaugeChart: "gauge chart, ${caption}",
    // Screen reader announcement when focusing an item in a treemap or sunburst chart
    ariaAnnounceHierarchyDatum: "level ${level}[number], ${count}[number] children, ${description}",
    // Screen reader announcement when focusing a link in a Sankey or chord chart
    ariaAnnounceFlowProportionLink: "link ${index} of ${count}, from ${from} to ${to}, ${sizeName} ${size}",
    // Screen reader announcement when focusing a node in a Sankey or chord chart
    ariaAnnounceFlowProportionNode: "node ${index} of ${count}, ${description}",
    // Screen reader description for legend items
    ariaDescriptionLegendItem: "Press Space or Enter to toggle visibility",
    // Screen reader for the '+' horizontal line button on the Y-axis
    ariaLabelAddHorizontalLine: "Add Horizontal Line",
    // Screen reader text for annotation-options toolbar
    ariaLabelAnnotationOptionsToolbar: "Annotation Options",
    // Screen reader text for annotation-settings dialog
    ariaLabelAnnotationSettingsDialog: "Annotation Settings",
    // Screen reader text for the color picker dialog
    ariaLabelColorPicker: "Color picker",
    // Screen reader text for the financial charts toolbar
    ariaLabelFinancialCharts: "Financial Charts",
    // Screen reader text for the legend toolbar
    ariaLabelLegend: "Legend",
    // Screen reader text for the legend pagination button
    ariaLabelLegendPagination: "Legend Pagination",
    // Screen reader text for the previous legend page button
    ariaLabelLegendPagePrevious: "Previous Legend Page",
    // Screen reader text for the next legend page button
    ariaLabelLegendPageNext: "Next Legend Page",
    // Screen reader text for the an item in the legend
    ariaLabelLegendItem: "${label}, Legend item ${index}[number] of ${count}[number]",
    // Screen reader text for the an unknown item in the legend
    ariaLabelLegendItemUnknown: "Unknown legend item",
    // Screen reader text for the navigator element
    ariaLabelNavigator: "Navigator",
    // Screen reader text for an accessibility control that changes the position of the navigator's range
    ariaLabelNavigatorRange: "Range",
    // Screen reader text for an accessibility control that changes the start of the navigator's range
    ariaLabelNavigatorMinimum: "Minimum",
    // Screen reader text for an accessibility control that changes the end of the navigator's range
    ariaLabelNavigatorMaximum: "Maximum",
    // Screen reader text for ranges toolbar
    ariaLabelRangesToolbar: "Ranges",
    // Screen reader text for the settings dialog tab-bar
    ariaLabelSettingsTabBar: "Settings",
    // Screen reader text for zoom toolbar
    ariaLabelZoomToolbar: "Zoom",
    // Screen reader text for the value of the navigator's range
    ariaValuePanRange: "${min}[percent0to2dp] to ${max}[percent0to2dp]",
    // Alt-text for the solid line dash style menu item icon
    iconAltTextLineStyleSolid: "Solid",
    // Alt-text for the long-dashed line dash style menu item icon
    iconAltTextLineStyleDashed: "Long-dashed",
    // Alt-text for the short-dashed line dash style menu item icon
    iconAltTextLineStyleDotted: "Short-dashed",
    // Alt-text for the 'position-top' icon
    iconAltTextPositionTop: "Top",
    // Alt-text for the 'position-center' icon
    iconAltTextPositionCenter: "Center",
    // Alt-text for the 'position-bottom' icon
    iconAltTextPositionBottom: "Bottom",
    // Alt-text for the 'position-left' icon
    iconAltTextAlignLeft: "Left",
    // Alt-text for the 'align-center' icon
    iconAltTextAlignCenter: "Center",
    // Alt-text for the 'position-right' icon
    iconAltTextAlignRight: "Right",
    // Alt-text for the 'close' icon
    iconAltTextClose: "Close",
    // Default text for the 'loading data' overlay
    overlayLoadingData: "Loading data...",
    // Default text for the 'no data' overlay
    overlayNoData: "No data to display",
    // Default text for the 'no visible series' overlay
    overlayNoVisibleSeries: "No visible series",
    // Default text for the 'unsupported browser' overlay
    overlayUnsupportedBrowser: "Incompatible browser version. Please upgrade your browser.",
    // Text for frequency label in Histogram Series tooltip
    seriesHistogramTooltipFrequency: "Frequency",
    // Text for sum label in Histogram Series tooltip
    seriesHistogramTooltipSum: "${yName} (sum)",
    // Text for sum label in Histogram Series tooltip
    seriesHistogramTooltipCount: "${yName} (count)",
    // Text for sum label in Histogram Series tooltip
    seriesHistogramTooltipMean: "${yName} (mean)",
    // Text for the series type toolbar's chart type button
    toolbarSeriesTypeDropdown: "Chart Type",
    // Text for the series type toolbar's OHLC chart type button
    toolbarSeriesTypeOHLC: "OHLC",
    // Text for the series type toolbar's HLC chart type button
    toolbarSeriesTypeHLC: "HLC",
    // Text for the series type toolbar's high low chart type button
    toolbarSeriesTypeHighLow: "High Low",
    // Text for the series type toolbar's candles chart type button
    toolbarSeriesTypeCandles: "Candles",
    // Text for the series type toolbar's hollow candles chart type button
    toolbarSeriesTypeHollowCandles: "Hollow Candles",
    // Text for the series type toolbar's line chart type button
    toolbarSeriesTypeLine: "Line",
    // Text for the series type toolbar's line with markers chart type button
    toolbarSeriesTypeLineWithMarkers: "Line with Markers",
    // Text for the series type toolbar's line with step line chart type button
    toolbarSeriesTypeStepLine: "Step Line",
    // Text for the annotation toolbar's trend line button
    toolbarAnnotationsTrendLine: "Trend Line",
    // Text for the annotation toolbar's Fibonacci Retracement button
    toolbarAnnotationsFibonacciRetracement: "Fib Retracement",
    // Text for the annotation toolbar's Fibonacci Retracement Trend Based button
    toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trend Based",
    // Text for the annotation toolbar's horizontal line button
    toolbarAnnotationsHorizontalLine: "Horizontal Line",
    // Text for the annotation toolbar's vertical line button
    toolbarAnnotationsVerticalLine: "Vertical Line",
    // Text for the annotation toolbar's parallel channel button
    toolbarAnnotationsParallelChannel: "Parallel Channel",
    // Text for the annotation toolbar's disjoint channel button
    toolbarAnnotationsDisjointChannel: "Disjoint Channel",
    // Text for the annotation toolbar's clear all button
    toolbarAnnotationsClearAll: "Clear All",
    // Text for the annotation toolbar's fill color picker annotation button
    toolbarAnnotationsFillColor: "Fill Color",
    // Text for the annotation toolbar's line color picker annotation button
    toolbarAnnotationsLineColor: "Line Color",
    // Text for the annotation toolbar's line style type button
    toolbarAnnotationsLineStyle: "Line Style",
    // Text for the annotation toolbar's line stroke width button
    toolbarAnnotationsLineStrokeWidth: "Line Stroke Width",
    // Text for the annotation toolbar's settings annotation button
    toolbarAnnotationsSettings: "Settings",
    // Text for the annotation toolbar's text color picker annotation button
    toolbarAnnotationsTextColor: "Text Color",
    // Text for the annotation toolbar's text size picker annotation button
    toolbarAnnotationsTextSize: "Text Size",
    // Text for the annotation toolbar's lock annotation button
    toolbarAnnotationsLock: "Lock",
    // Text for the annotation toolbar's unlock annotation button
    toolbarAnnotationsUnlock: "Unlock",
    // Text for the annotation toolbar's delete annotation button
    toolbarAnnotationsDelete: "Delete",
    // Text for the annotation toolbar's drag handle
    toolbarAnnotationsDragHandle: "Drag Toolbar",
    // Text for the annotation toolbar's line drawings menu button
    toolbarAnnotationsLineAnnotations: "Trend Lines",
    // Text for the annotation toolbar's Fibonacci drawings menu button
    toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
    // Text for the annotation toolbar's text annotations menu button
    toolbarAnnotationsTextAnnotations: "Text Annotations",
    // Text for the annotation toolbar's shapes menu button
    toolbarAnnotationsShapeAnnotations: "Arrows",
    // Text for the annotation toolbar's measurers menu button
    toolbarAnnotationsMeasurerAnnotations: "Measurers",
    // Text for the annotation toolbar's callout button
    toolbarAnnotationsCallout: "Callout",
    // Text for the annotation toolbar's comment button
    toolbarAnnotationsComment: "Comment",
    // Text for the annotation toolbar's note button
    toolbarAnnotationsNote: "Note",
    // Text for the annotation toolbar's text button
    toolbarAnnotationsText: "Text",
    // Text for the annotation toolbar's arrow button
    toolbarAnnotationsArrow: "Arrow",
    // Text for the annotation toolbar's arrow up button
    toolbarAnnotationsArrowUp: "Arrow Up",
    // Text for the annotation toolbar's arrow down button
    toolbarAnnotationsArrowDown: "Arrow Down",
    // Text for the annotation toolbar's date range button
    toolbarAnnotationsDateRange: "Date Range",
    // Text for the annotation toolbar's price range button
    toolbarAnnotationsPriceRange: "Price Range",
    // Text for the annotation toolbar's date and price range button
    toolbarAnnotationsDatePriceRange: "Date and Price",
    // Text for the annotation toolbar's quick date and price range button
    toolbarAnnotationsQuickDatePriceRange: "Measure",
    // Text for the range toolbar's 1 month button
    toolbarRange1Month: "1M",
    // Aria label for the range toolbar's 1 month button
    toolbarRange1MonthAria: "1 month",
    // Text for the range toolbar's 3 month button
    toolbarRange3Months: "3M",
    // Aria label for the range toolbar's 3 month button
    toolbarRange3MonthsAria: "3 months",
    // Text for the range toolbar's 6 month button
    toolbarRange6Months: "6M",
    // Aria label for the range toolbar's 6 month button
    toolbarRange6MonthsAria: "6 months",
    // Text for the range toolbar's year to date button
    toolbarRangeYearToDate: "YTD",
    // Aria label for the range toolbar's year to date month button
    toolbarRangeYearToDateAria: "Year to date",
    // Text for the range toolbar's 1 year button
    toolbarRange1Year: "1Y",
    // Aria label for the range toolbar's 1 year button
    toolbarRange1YearAria: "1 year",
    // Text for the range toolbar's full range button
    toolbarRangeAll: "All",
    // Aria label for the range toolbar's full range button
    toolbarRangeAllAria: "All",
    // Text for the zoom toolbar's zoom out button
    toolbarZoomZoomOut: "Zoom out",
    // Text for the zoom toolbar's zoom in button
    toolbarZoomZoomIn: "Zoom in",
    // Text for the zoom toolbar's pan left button
    toolbarZoomPanLeft: "Pan left",
    // Text for the zoom toolbar's pan right button
    toolbarZoomPanRight: "Pan right",
    // Text for the zoom toolbar's pan to the start button
    toolbarZoomPanStart: "Pan to the start",
    // Text for the zoom toolbar's pan to the end button
    toolbarZoomPanEnd: "Pan to the end",
    // Text for the zoom toolbar's pan reset button
    toolbarZoomReset: "Reset the zoom",
    // Text for the context menu's download button
    contextMenuDownload: "Download",
    // Text for the context menu's toggle series visibility button
    contextMenuToggleSeriesVisibility: "Toggle Visibility",
    // Text for the context menu's toggle other series visibility button
    contextMenuToggleOtherSeries: "Toggle Other Series",
    // Text for the context menu's zoom to point button
    contextMenuZoomToCursor: "Zoom to here",
    // Text for the context menu's pan to point button
    contextMenuPanToCursor: "Pan to here",
    // Text for the annotation dialog's header channel tab label
    dialogHeaderChannel: "Channel",
    // Text for the annotation dialog's header line tab label
    dialogHeaderLine: "Line",
    // Text for the annotation dialog's header fibonacci retracement line tab label
    dialogHeaderFibonacciRange: "Fib Retracement",
    // Text for the annotation dialog's header date range tab label
    dialogHeaderDateRange: "Date Range",
    // Text for the annotation dialog's header price range tab label
    dialogHeaderPriceRange: "Price Range",
    // Text for the annotation dialog's header date and price range tab label
    dialogHeaderDatePriceRange: "Date and Price",
    // Text for the annotation dialog's header text tab label
    dialogHeaderText: "Text",
    // Text for the annotation dialog's text alignment radio label
    dialogInputAlign: "Align",
    // Text for the annotation dialog's color picker label
    dialogInputColorPicker: "Color",
    // Text for the annotation dialog's color picker alt text
    dialogInputColorPickerAltText: "Text Color",
    // Text for the annotation dialog's fill color picker label
    dialogInputFillColorPicker: "Fill",
    // Text for the annotation dialog's fill color picker alt text
    dialogInputFillColorPickerAltText: "Fill Color",
    // Text for the annotation dialog's extend channel start checkbox
    dialogInputExtendChannelStart: "Extend channel start",
    // Text for the annotation dialog's extend channel end checkbox
    dialogInputExtendChannelEnd: "Extend channel end",
    // Text for the annotation dialog's extend line start checkbox
    dialogInputExtendLineStart: "Extend line start",
    // Text for the annotation dialog's extend line end checkbox
    dialogInputExtendLineEnd: "Extend line end",
    // Text for the annotation dialog's extend above checkbox
    dialogInputExtendAbove: "Extend above",
    // Text for the annotation dialog's extend below checkbox
    dialogInputExtendBelow: "Extend below",
    // Text for the annotation dialog's extend left checkbox
    dialogInputExtendLeft: "Extend left",
    // Text for the annotation dialog's extend right checkbox
    dialogInputExtendRight: "Extend right",
    // Text for the annotation dialog's reverse checkbox
    dialogInputReverse: "Reverse",
    // Text for the annotation dialog's show fill checkbox
    dialogInputShowFill: "Show Fill",
    // Text for the annotation dialog's font size select box label
    dialogInputFontSize: "Size",
    // Text for the annotation dialog's font size select box alt text
    dialogInputFontSizeAltText: "Font Size",
    // Text for the annotation dialog's line style radio label
    dialogInputLineStyle: "Dash",
    // Text for the annotation dialog's text position radio label
    dialogInputPosition: "Position",
    // Text for the annotation dialog's stroke width label
    dialogInputStrokeWidth: "Weight",
    // Text for the annotation dialog's stroke width label
    dialogInputStrokeWidthAltText: "Line Weight",
    // Text for the annotation dialog's Fibonacci bands label
    dialogInputFibonacciBands: "Bands",
    // Text for the annotation dialog's Fibonacci bands label
    dialogInputFibonacciBandsAltText: "Fibonacci Bands",
    // Text for text area input placeholders
    inputTextareaPlaceholder: "Add Text",
    // Text for the measurer statistics date range bars value
    measurerDateRangeBars: "${value}[number] bars",
    // Text for the measurer statistics price range value
    measurerPriceRangeValue: "${value}[number]",
    // Text for the measurer statistics price range percentage
    measurerPriceRangePercent: "${value}[percent]",
    // Text for the measurer statistics volume value
    measurerVolume: "Vol ${value}",
    // Status when multiple data are under the cursor, and the user can click to cycle through which one appears in the tooltip
    tooltipPaginationStatus: "${index}[number] of ${count}[number]"
};
var $d77b025aa58d633c$var$messageRegExp = /\$\{(\w+)}(?:\[(\w+)])?/gi;
var $d77b025aa58d633c$var$formatters = {
    number: new Intl.NumberFormat("en-US"),
    percent: new Intl.NumberFormat("en-US", {
        style: "percent",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }),
    percent0to2dp: new Intl.NumberFormat("en-US", {
        style: "percent",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }),
    date: new Intl.DateTimeFormat("en-US", {
        dateStyle: "full"
    }),
    time: new Intl.DateTimeFormat("en-US", {
        timeStyle: "full"
    }),
    datetime: new Intl.DateTimeFormat("en-US", {
        dateStyle: "full",
        timeStyle: "full"
    })
};
var $d77b025aa58d633c$var$defaultMessageFormatter = ({ defaultValue: defaultValue, variables: variables })=>{
    return defaultValue?.replaceAll($d77b025aa58d633c$var$messageRegExp, (_, match, format)=>{
        const value = variables[match];
        const formatter = format != null ? $d77b025aa58d633c$var$formatters[format] : null;
        if (format != null && formatter == null) (0, $idDdm.Logger).warnOnce(`Format style [${format}] is not supported`);
        if (formatter != null) return formatter.format(value);
        else if (typeof value === "number") return $d77b025aa58d633c$var$formatters.number.format(value);
        else if (value instanceof Date) return $d77b025aa58d633c$var$formatters.datetime.format(value);
        return String(value);
    });
};
// packages/ag-charts-community/src/locale/localeManager.ts
var $d77b025aa58d633c$var$LocaleManager = class extends $d77b025aa58d633c$var$Listeners {
    constructor(){
        super(...arguments);
        this.localeText = void 0;
        this.getLocaleText = void 0;
    }
    setLocaleText(localeText) {
        if (this.localeText !== localeText) {
            this.localeText = localeText;
            this.dispatch("locale-changed");
        }
    }
    setLocaleTextFormatter(getLocaleText) {
        this.getLocaleText = getLocaleText;
        if (this.getLocaleText !== getLocaleText) {
            this.getLocaleText = getLocaleText;
            this.dispatch("locale-changed");
        }
    }
    t(key, variables = {}) {
        const { localeText: localeText = $d77b025aa58d633c$export$d5744b21be81b3d2, getLocaleText: getLocaleText } = this;
        const defaultValue = localeText[key];
        return getLocaleText?.({
            key: key,
            defaultValue: defaultValue,
            variables: variables
        }) ?? $d77b025aa58d633c$var$defaultMessageFormatter({
            key: key,
            defaultValue: defaultValue,
            variables: variables
        }) ?? key;
    }
};
var $d77b025aa58d633c$var$HdpiCanvas = class {
    constructor(options){
        this.enabled = true;
        this.width = 600;
        this.height = 300;
        const { width: width2, height: height2, canvasElement: canvasElement, willReadFrequently: willReadFrequently = false } = options;
        this.pixelRatio = options.pixelRatio ?? (0, $idDdm.getWindow)("devicePixelRatio") ?? 1;
        this.element = canvasElement ?? (0, $idDdm.createElement)("canvas");
        this.element.style.display = "block";
        this.element.style.width = (width2 ?? this.width) + "px";
        this.element.style.height = (height2 ?? this.height) + "px";
        this.element.width = Math.round((width2 ?? this.width) * this.pixelRatio);
        this.element.height = Math.round((height2 ?? this.height) * this.pixelRatio);
        this.context = this.element.getContext("2d", {
            willReadFrequently: willReadFrequently
        });
        this.onEnabledChange();
        this.resize(width2 ?? 0, height2 ?? 0, this.pixelRatio);
        $d77b025aa58d633c$var$debugContext(this.context);
    }
    drawImage(context, dx = 0, dy = 0) {
        return context.drawImage(this.context.canvas, dx, dy);
    }
    toDataURL(type) {
        return this.element.toDataURL(type);
    }
    resize(width2, height2, pixelRatio) {
        if (!(width2 > 0 && height2 > 0)) return;
        const { element: element2, context: context } = this;
        element2.width = Math.round(width2 * pixelRatio);
        element2.height = Math.round(height2 * pixelRatio);
        context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        element2.style.width = width2 + "px";
        element2.style.height = height2 + "px";
        this.width = width2;
        this.height = height2;
        this.pixelRatio = pixelRatio;
    }
    clear() {
        $d77b025aa58d633c$var$clearContext(this);
    }
    destroy() {
        this.element.remove();
        this.element.width = 0;
        this.element.height = 0;
        this.context.clearRect(0, 0, 0, 0);
        Object.freeze(this);
    }
    reset() {
        this.context.resetTransform();
    }
    onEnabledChange() {
        if (this.element) this.element.style.display = this.enabled ? "" : "none";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target)=>target.onEnabledChange())
], $d77b025aa58d633c$var$HdpiCanvas.prototype, "enabled", 2);
var $d77b025aa58d633c$var$ImageLoader = class extends (0, $idDdm.EventEmitter) {
    constructor(){
        super(...arguments);
        this.cache = /* @__PURE__ */ new Map();
        this.imageLoadingCount = 0;
    }
    loadImage(uri, node) {
        const entry = this.cache.get(uri);
        if (entry?.image) return entry.image;
        else if (entry != null && node) {
            entry.nodes.add(node);
            return;
        }
        if (!node) return;
        const nextEntry = {
            image: void 0,
            nodes: /* @__PURE__ */ new Set([
                node
            ])
        };
        const image = new Image();
        this.imageLoadingCount++;
        image.onload = ()=>{
            nextEntry.image = image;
            nextEntry.nodes.forEach((n)=>n.markDirty());
            nextEntry.nodes.clear();
            this.imageLoadingCount--;
            this.emit("image-loaded", {
                uri: uri
            });
        };
        image.onerror = ()=>{
            this.imageLoadingCount--;
            nextEntry.nodes.clear();
            this.emit("image-error", {
                uri: uri
            });
        };
        image.src = uri;
        this.cache.set(uri, nextEntry);
        return nextEntry.image;
    }
    waitingToLoad() {
        return this.imageLoadingCount > 0;
    }
    destroy() {
        this.cache.forEach((entry)=>{
            entry.nodes.clear();
        });
        this.cache.clear();
    }
};
// packages/ag-charts-community/src/scene/layersManager.ts
var $d77b025aa58d633c$var$LayersManager = class {
    constructor(canvas){
        this.canvas = canvas;
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "scene");
        this.layersMap = /* @__PURE__ */ new Map();
        this.nextLayerId = 0;
    }
    get size() {
        return this.layersMap.size;
    }
    resize(width2, height2, pixelRatio) {
        this.canvas.resize(width2, height2, pixelRatio);
        this.layersMap.forEach(({ canvas: canvas })=>canvas.resize(width2, height2, pixelRatio));
    }
    addLayer(opts) {
        const { width: width2, height: height2, pixelRatio: pixelRatio } = this.canvas;
        const { name: name } = opts;
        const canvas = new $d77b025aa58d633c$var$HdpiOffscreenCanvas({
            width: width2,
            height: height2,
            pixelRatio: pixelRatio
        });
        this.layersMap.set(canvas, {
            id: this.nextLayerId++,
            name: name,
            canvas: canvas
        });
        this.debug("Scene.addLayer() - layers", this.layersMap);
        return canvas;
    }
    removeLayer(canvas) {
        if (this.layersMap.has(canvas)) {
            this.layersMap.delete(canvas);
            canvas.destroy();
            this.debug("Scene.removeLayer() -  layers", this.layersMap);
        }
    }
    clear() {
        for (const layer of this.layersMap.values())layer.canvas.destroy();
        this.layersMap.clear();
    }
};
function $d77b025aa58d633c$var$formatBytes(value) {
    for (const unit of [
        "B",
        "KB",
        "MB",
        "GB"
    ]){
        if (value < 1536) return `${value.toFixed(1)}${unit}`;
        value /= 1024;
    }
    return `${value.toFixed(1)}TB}`;
}
function $d77b025aa58d633c$var$memoryUsage() {
    if (!("memory" in performance)) return;
    const { totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize, jsHeapSizeLimit: jsHeapSizeLimit } = performance.memory;
    const result = [];
    for (const amount of [
        usedJSHeapSize,
        totalJSHeapSize,
        jsHeapSizeLimit
    ]){
        if (typeof amount !== "number") continue;
        result.push($d77b025aa58d633c$var$formatBytes(amount));
    }
    return `Heap ${result.join(" / ")}`;
}
function $d77b025aa58d633c$var$debugStats(layersManager, debugSplitTimes, ctx, renderCtxStats, extraDebugStats = {}, seriesRect = $d77b025aa58d633c$var$BBox.zero) {
    if (!$d77b025aa58d633c$var$Debug.check("scene:stats" /* SCENE_STATS */ , "scene:stats:verbose" /* SCENE_STATS_VERBOSE */ )) return;
    const { layersRendered: layersRendered = 0, layersSkipped: layersSkipped = 0, nodesRendered: nodesRendered = 0, nodesSkipped: nodesSkipped = 0, opsPerformed: opsPerformed = 0, opsSkipped: opsSkipped = 0 } = renderCtxStats ?? {};
    const end2 = performance.now();
    const { start: start2, ...durations } = debugSplitTimes;
    const splits = Object.entries(durations).map(([n, t])=>{
        return $d77b025aa58d633c$var$time(n, t);
    }).filter((v)=>v != null).join(" + ");
    const extras = Object.entries(extraDebugStats).map(([k, v])=>`${k}: ${JSON.stringify(v)}`).join(" ; ");
    const detailedStats = $d77b025aa58d633c$var$Debug.check("scene:stats:verbose" /* SCENE_STATS_VERBOSE */ );
    const memUsage = $d77b025aa58d633c$var$memoryUsage();
    const stats = [
        `${$d77b025aa58d633c$var$time("\u23F1\uFE0F", start2, end2)} (${splits})`,
        `${extras}`,
        `Layers: ${detailedStats ? $d77b025aa58d633c$var$pct(layersRendered, layersSkipped) : layersManager.size}`,
        detailedStats ? `Nodes: ${$d77b025aa58d633c$var$pct(nodesRendered, nodesSkipped)}` : null,
        detailedStats ? `Ops: ${$d77b025aa58d633c$var$pct(opsPerformed, opsSkipped)}` : null,
        detailedStats && memUsage ? memUsage : null
    ].filter((0, $idDdm.isString));
    const measurer2 = new $d77b025aa58d633c$var$SimpleTextMeasurer((t)=>ctx.measureText(t));
    const statsSize = new Map(stats.map((t)=>[
            t,
            measurer2.measureLines(t)
        ]));
    const width2 = Math.max(...Array.from(statsSize.values(), (s)=>s.width));
    const height2 = $d77b025aa58d633c$var$accumulate(statsSize.values(), (s)=>s.height);
    const x = 2 + seriesRect.x;
    ctx.save();
    ctx.fillStyle = "white";
    ctx.fillRect(x, 0, width2, height2);
    ctx.fillStyle = "black";
    let y = 0;
    for (const [stat, size] of statsSize.entries()){
        y += size.height;
        ctx.fillText(stat, x, y);
    }
    ctx.restore();
}
function $d77b025aa58d633c$var$prepareSceneNodeHighlight(ctx) {
    const config = (0, $idDdm.toArray)((0, $idDdm.getWindow)("agChartsSceneDebug"));
    const result = [];
    for (const name of config)if (name === "layout") result.push("seriesRoot", "legend", "root", /.*Axis-\d+-axis.*/);
    else result.push(name);
    ctx.debugNodeSearch = result;
}
function $d77b025aa58d633c$var$debugSceneNodeHighlight(ctx, debugNodes) {
    ctx.save();
    for (const [name, node] of Object.entries(debugNodes)){
        const bbox = $d77b025aa58d633c$var$Transformable.toCanvas(node);
        if (!bbox) {
            (0, $idDdm.Logger).log(`Scene.render() - no bbox for debugged node [${name}].`);
            continue;
        }
        ctx.globalAlpha = 0.8;
        ctx.strokeStyle = "red";
        ctx.lineWidth = 1;
        ctx.strokeRect(bbox.x, bbox.y, bbox.width, bbox.height);
        ctx.fillStyle = "red";
        ctx.strokeStyle = "white";
        ctx.font = "16px sans-serif";
        ctx.textBaseline = "top";
        ctx.textAlign = "left";
        ctx.lineWidth = 2;
        ctx.strokeText(name, bbox.x, bbox.y, bbox.width);
        ctx.fillText(name, bbox.x, bbox.y, bbox.width);
    }
    ctx.restore();
}
var $d77b025aa58d633c$var$skippedProperties = /* @__PURE__ */ new Set();
var $d77b025aa58d633c$var$allowedProperties = /* @__PURE__ */ new Set([
    "gradient",
    // '_datum',
    "zIndex",
    "clipRect",
    "cachedBBox",
    "childNodeCounts",
    "path",
    "__zIndex",
    "name",
    "__scalingCenterX",
    "__scalingCenterY",
    "__rotationCenterX",
    "__rotationCenterY",
    "_previousDatum",
    "__fill",
    "__lineDash",
    "borderPath",
    "borderClipPath",
    "_clipPath"
]);
function $d77b025aa58d633c$var$nodeProps(node) {
    const { ...allProps } = node;
    for (const prop of Object.keys(allProps)){
        if ($d77b025aa58d633c$var$allowedProperties.has(prop)) continue;
        if (typeof allProps[prop] === "number") continue;
        if (typeof allProps[prop] === "string") continue;
        if (typeof allProps[prop] === "boolean") continue;
        $d77b025aa58d633c$var$skippedProperties.add(prop);
        delete allProps[prop];
    }
    return allProps;
}
function $d77b025aa58d633c$var$buildTree(node, mode) {
    if (!$d77b025aa58d633c$var$Debug.check(true, "scene" /* SCENE */ )) return {};
    let order = 0;
    return {
        node: mode === "json" ? $d77b025aa58d633c$var$nodeProps(node) : node,
        name: node.name ?? node.id,
        dirty: node.dirty,
        ...Array.from(node.children(), (c)=>$d77b025aa58d633c$var$buildTree(c, mode)).reduce((result, childTree)=>{
            let { name: treeNodeName } = childTree;
            const { node: { visible: visible, opacity: opacity, zIndex: zIndex, translationX: translationX, translationY: translationY, rotation: rotation, scalingX: scalingX, scalingY: scalingY }, node: childNode } = childTree;
            if (!visible || opacity <= 0) treeNodeName = `(${treeNodeName})`;
            if ($d77b025aa58d633c$var$Group.is(childNode) && childNode.renderToOffscreenCanvas) treeNodeName = `*${treeNodeName}*`;
            const zIndexString = Array.isArray(zIndex) ? `(${zIndex.join(", ")})` : zIndex;
            const key = [
                `${(order++).toString().padStart(3, "0")}|`,
                `${treeNodeName ?? "<unknown>"}`,
                `z: ${zIndexString}`,
                translationX && `x: ${translationX}`,
                translationY && `y: ${translationY}`,
                rotation && `r: ${rotation}`,
                scalingX != null && scalingX !== 1 && `sx: ${scalingX}`,
                scalingY != null && scalingY !== 1 && `sy: ${scalingY}`
            ].filter((v)=>!!v).join(" ");
            let selectedKey = key;
            let index = 1;
            while(result[selectedKey] != null && index < 100)selectedKey = `${key} (${index++})`;
            result[selectedKey] = childTree;
            return result;
        }, {})
    };
}
function $d77b025aa58d633c$var$buildDirtyTree(node) {
    if (!node.dirty) return {
        dirtyTree: {},
        paths: []
    };
    const childrenDirtyTree = Array.from(node.children(), (c)=>$d77b025aa58d633c$var$buildDirtyTree(c)).filter((c)=>c.paths.length > 0);
    const name = $d77b025aa58d633c$var$Group.is(node) ? node.name ?? node.id : node.id;
    const paths = childrenDirtyTree.length ? childrenDirtyTree.flatMap((c)=>c.paths).map((p)=>`${name}.${p}`) : [
        name
    ];
    return {
        dirtyTree: {
            name: name,
            node: node,
            dirty: node.dirty,
            ...childrenDirtyTree.map((c)=>c.dirtyTree).filter((t)=>t.dirty != null).reduce((result, childTree)=>{
                result[childTree.name ?? "<unknown>"] = childTree;
                return result;
            }, {})
        },
        paths: paths
    };
}
function $d77b025aa58d633c$var$pct(rendered, skipped) {
    const total = rendered + skipped;
    return `${rendered} / ${total} (${Math.round(100 * rendered / total)}%)`;
}
function $d77b025aa58d633c$var$time(name, start2, end2) {
    const duration = end2 != null ? end2 - start2 : start2;
    return `${name}: ${Math.round(duration * 100) / 100}ms`;
}
function $d77b025aa58d633c$var$accumulate(iterator, mapper) {
    let sum2 = 0;
    for (const item of iterator)sum2 += mapper(item);
    return sum2;
}
// packages/ag-charts-community/src/scene/scene.ts
var $d77b025aa58d633c$var$Scene = class extends (0, $idDdm.EventEmitter) {
    constructor(canvasOptions){
        super();
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "scene" /* SCENE */ );
        this.id = (0, $idDdm.createId)(this);
        this.imageLoader = new $d77b025aa58d633c$var$ImageLoader();
        this.root = null;
        this.pendingSize = null;
        this.isDirty = false;
        this.destroyFns = [];
        this.updateDebugFlags();
        this.canvas = new $d77b025aa58d633c$var$HdpiCanvas(canvasOptions);
        this.layersManager = new $d77b025aa58d633c$var$LayersManager(this.canvas);
        this.destroyFns.push(this.imageLoader.on("image-loaded", ()=>{
            this.emit("scene-changed", {});
        }), this.imageLoader.on("image-error", ({ uri: uri })=>{
            (0, $idDdm.Logger).warnOnce(`Unable to load image ${uri}`);
        }));
    }
    waitingForUpdate() {
        return this.imageLoader?.waitingToLoad() ?? false;
    }
    get width() {
        return this.pendingSize?.[0] ?? this.canvas.width;
    }
    get height() {
        return this.pendingSize?.[1] ?? this.canvas.height;
    }
    get pixelRatio() {
        return this.pendingSize?.[2] ?? this.canvas.pixelRatio;
    }
    /** @deprecated v10.2.0 Only used by AG Grid Sparklines */ setContainer(value) {
        const { element: element2 } = this.canvas;
        element2.parentElement?.removeChild(element2);
        value.appendChild(element2);
        return this;
    }
    setRoot(node) {
        if (this.root === node) return this;
        this.isDirty = true;
        this.root?.setScene();
        this.root = node;
        if (node) {
            node.visible = true;
            node.setScene(this);
        }
        return this;
    }
    updateDebugFlags() {
        $d77b025aa58d633c$var$Debug.inDevelopmentMode(()=>$d77b025aa58d633c$var$Node2._debugEnabled = true);
    }
    clearCanvas() {
        this.canvas.clear();
    }
    attachNode(node) {
        this.appendChild(node);
        return ()=>this.removeChild(node);
    }
    appendChild(node) {
        this.root?.appendChild(node);
        return this;
    }
    removeChild(node) {
        this.root?.removeChild(node);
        return this;
    }
    download(fileName, fileFormat) {
        (0, $idDdm.downloadUrl)(this.canvas.toDataURL(fileFormat), fileName?.trim() ?? "image");
    }
    /** NOTE: Integrated Charts undocumented image download method. */ getDataURL(fileFormat) {
        return this.canvas.toDataURL(fileFormat);
    }
    resize(width2, height2, pixelRatio) {
        width2 = Math.round(width2);
        height2 = Math.round(height2);
        pixelRatio ?? (pixelRatio = this.pixelRatio);
        if (width2 > 0 && height2 > 0 && (width2 !== this.width || height2 !== this.height || pixelRatio !== this.pixelRatio)) {
            this.pendingSize = [
                width2,
                height2,
                pixelRatio
            ];
            this.isDirty = true;
            return true;
        }
        return false;
    }
    render(opts) {
        const { debugSplitTimes: debugSplitTimes = {
            start: performance.now()
        }, extraDebugStats: extraDebugStats, seriesRect: seriesRect } = opts ?? {};
        const { canvas: canvas, canvas: { context: ctx } = {}, root: root, pendingSize: pendingSize, width: width2, height: height2, pixelRatio: devicePixelRatio } = this;
        if (!ctx) return;
        const renderStartTime = performance.now();
        let resized = false;
        if (pendingSize) {
            resized = true;
            this.layersManager.resize(...pendingSize);
            this.pendingSize = null;
        }
        if (root && !root.visible) {
            this.isDirty = false;
            return;
        }
        if (root?.dirty === false && !this.isDirty) {
            if (this.debug.check()) this.debug("Scene.render() - no-op", {
                tree: $d77b025aa58d633c$var$buildTree(root, "console")
            });
            $d77b025aa58d633c$var$debugStats(this.layersManager, debugSplitTimes, ctx, void 0, extraDebugStats, seriesRect);
            return;
        }
        const renderCtx = {
            ctx: ctx,
            width: width2,
            height: height2,
            devicePixelRatio: devicePixelRatio,
            debugNodes: {}
        };
        if ($d77b025aa58d633c$var$Debug.check("scene:stats:verbose" /* SCENE_STATS_VERBOSE */ )) renderCtx.stats = {
            layersRendered: 0,
            layersSkipped: 0,
            nodesRendered: 0,
            nodesSkipped: 0,
            opsPerformed: 0,
            opsSkipped: 0
        };
        $d77b025aa58d633c$var$prepareSceneNodeHighlight(renderCtx);
        let canvasCleared = false;
        if (root?.dirty !== false || resized) {
            canvasCleared = true;
            canvas.clear();
        }
        if (root && $d77b025aa58d633c$var$Debug.check("scene:dirtyTree" /* SCENE_DIRTY_TREE */ )) {
            const { dirtyTree: dirtyTree, paths: paths } = $d77b025aa58d633c$var$buildDirtyTree(root);
            $d77b025aa58d633c$var$Debug.create("scene:dirtyTree" /* SCENE_DIRTY_TREE */ )("Scene.render() - dirtyTree", {
                dirtyTree: dirtyTree,
                paths: paths
            });
        }
        if (root && canvasCleared) {
            if (root.visible) root.preRender(renderCtx);
            if (this.debug.check()) {
                const tree = $d77b025aa58d633c$var$buildTree(root, "console");
                this.debug("Scene.render() - before", {
                    canvasCleared: canvasCleared,
                    tree: tree
                });
            }
            if (root.visible) try {
                ctx.save();
                root.render(renderCtx);
                ctx.restore();
            } catch (e) {
                this.canvas.reset();
                throw e;
            }
        }
        debugSplitTimes["\u270D\uFE0F"] = performance.now() - renderStartTime;
        ctx.verifyDepthZero?.();
        this.isDirty = false;
        $d77b025aa58d633c$var$debugStats(this.layersManager, debugSplitTimes, ctx, renderCtx.stats, extraDebugStats, seriesRect);
        $d77b025aa58d633c$var$debugSceneNodeHighlight(ctx, renderCtx.debugNodes);
        if (root && this.debug.check()) this.debug("Scene.render() - after", {
            tree: $d77b025aa58d633c$var$buildTree(root, "console"),
            canvasCleared: canvasCleared
        });
    }
    toSVG() {
        const { root: root, width: width2, height: height2 } = this;
        if (root == null) return;
        return $d77b025aa58d633c$var$Node2.toSVG(root, width2, height2);
    }
    /** Alternative to destroy() that preserves re-usable resources. */ strip() {
        const { context: context, pixelRatio: pixelRatio } = this.canvas;
        context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        this.layersManager.clear();
        this.setRoot(null);
        this.isDirty = false;
        this.clear();
    }
    destroy() {
        this.strip();
        this.canvas.destroy();
        this.imageLoader.destroy();
        this.destroyFns.forEach((fn)=>fn());
        Object.assign(this, {
            canvas: void 0
        });
    }
};
$d77b025aa58d633c$var$Scene.className = "Scene";
function $d77b025aa58d633c$var$needsContext(caller, _params) {
    return "context" in caller;
}
function $d77b025aa58d633c$var$maybeSetContext(caller, params) {
    if ($d77b025aa58d633c$var$needsContext(caller, params)) {
        if (params[0] != null && typeof params[0] === "object") {
            params[0].context = caller.context;
            return true;
        }
    }
    return false;
}
function $d77b025aa58d633c$var$callWithContext(caller1, caller2, fn, params) {
    if (!$d77b025aa58d633c$var$maybeSetContext(caller1, params)) {
        if (caller2) $d77b025aa58d633c$var$maybeSetContext(caller2, params);
    }
    return fn(...params);
}
var $d77b025aa58d633c$var$CallbackCache = class {
    constructor(){
        this.cache = /* @__PURE__ */ new WeakMap();
    }
    call(caller1, caller2, fn, ...params) {
        let serialisedParams;
        let paramCache = this.cache.get(fn);
        try {
            serialisedParams = JSON.stringify(params);
        } catch  {
            return this.invoke(caller1, caller2, fn, params, paramCache);
        }
        if (paramCache == null) {
            paramCache = /* @__PURE__ */ new Map();
            this.cache.set(fn, paramCache);
        }
        if (!paramCache.has(serialisedParams)) return this.invoke(caller1, caller2, fn, params, paramCache, serialisedParams);
        return paramCache.get(serialisedParams);
    }
    invoke(caller1, caller2, fn, params, paramCache, serialisedParams) {
        try {
            const result = $d77b025aa58d633c$var$callWithContext(caller1, caller2, fn, params);
            if (paramCache && serialisedParams != null) paramCache.set(serialisedParams, result);
            return result;
        } catch (e) {
            (0, $idDdm.Logger).warnOnce(`User callback errored, ignoring`, e);
            return;
        }
    }
    invalidateCache() {
        this.cache = /* @__PURE__ */ new WeakMap();
    }
};
var $d77b025aa58d633c$var$AnnotationManager = class extends $d77b025aa58d633c$var$BaseManager {
    constructor(annotationRoot, fireChartEvent){
        super();
        this.annotationRoot = annotationRoot;
        this.fireChartEvent = fireChartEvent;
        this.mementoOriginatorKey = "annotations";
        this.annotations = [];
    }
    createMemento() {
        return this.annotations;
    }
    guardMemento(blob) {
        return blob == null || (0, $idDdm.isArray)(blob);
    }
    restoreMemento(_version, _mementoVersion, memento) {
        this.annotations = this.cleanData(memento ?? []).map((annotation)=>{
            const annotationTheme = this.getAnnotationTypeStyles(annotation.type);
            return $d77b025aa58d633c$var$mergeDefaults(annotation, annotationTheme);
        });
        this.listeners.dispatch("restore-annotations", {
            type: "restore-annotations",
            annotations: this.annotations
        });
    }
    updateData(annotations) {
        this.annotations = this.cleanData(annotations ?? []);
    }
    fireChangedEvent() {
        this.fireChartEvent({
            type: "annotations",
            annotations: $d77b025aa58d633c$var$deepClone([
                ...this.annotations
            ])
        });
    }
    attachNode(node) {
        this.annotationRoot.append(node);
        return ()=>{
            this.annotationRoot?.removeChild(node);
            return this;
        };
    }
    setAnnotationStyles(styles) {
        this.styles = styles;
    }
    getAnnotationTypeStyles(type) {
        return this.styles?.[type];
    }
    cleanData(annotations) {
        for (const annotation of annotations)if ("textAlign" in annotation) delete annotation.textAlign;
        return annotations;
    }
};
// packages/ag-charts-community/src/chart/zIndexMap.ts
var $d77b025aa58d633c$var$ZIndexMap = /* @__PURE__ */ ((ZIndexMap2)=>{
    ZIndexMap2[ZIndexMap2["CHART_BACKGROUND"] = 0] = "CHART_BACKGROUND";
    ZIndexMap2[ZIndexMap2["AXIS_GRID"] = 1] = "AXIS_GRID";
    ZIndexMap2[ZIndexMap2["AXIS"] = 2] = "AXIS";
    ZIndexMap2[ZIndexMap2["ZOOM_SELECTION"] = 3] = "ZOOM_SELECTION";
    ZIndexMap2[ZIndexMap2["SERIES_CROSSLINE_RANGE"] = 4] = "SERIES_CROSSLINE_RANGE";
    ZIndexMap2[ZIndexMap2["SERIES_LAYER"] = 5] = "SERIES_LAYER";
    ZIndexMap2[ZIndexMap2["AXIS_FOREGROUND"] = 6] = "AXIS_FOREGROUND";
    ZIndexMap2[ZIndexMap2["SERIES_CROSSHAIR"] = 7] = "SERIES_CROSSHAIR";
    ZIndexMap2[ZIndexMap2["SERIES_CROSSLINE_LINE"] = 8] = "SERIES_CROSSLINE_LINE";
    ZIndexMap2[ZIndexMap2["SERIES_ANNOTATION"] = 9] = "SERIES_ANNOTATION";
    ZIndexMap2[ZIndexMap2["CHART_ANNOTATION"] = 10] = "CHART_ANNOTATION";
    ZIndexMap2[ZIndexMap2["CHART_ANNOTATION_FOCUSED"] = 11] = "CHART_ANNOTATION_FOCUSED";
    ZIndexMap2[ZIndexMap2["STATUS_BAR"] = 12] = "STATUS_BAR";
    ZIndexMap2[ZIndexMap2["SERIES_LABEL"] = 13] = "SERIES_LABEL";
    ZIndexMap2[ZIndexMap2["LEGEND"] = 14] = "LEGEND";
    ZIndexMap2[ZIndexMap2["NAVIGATOR"] = 15] = "NAVIGATOR";
    ZIndexMap2[ZIndexMap2["FOREGROUND"] = 16] = "FOREGROUND";
    return ZIndexMap2;
})($d77b025aa58d633c$var$ZIndexMap || {});
// packages/ag-charts-community/src/chart/axis/axisManager.ts
var $d77b025aa58d633c$var$AxisManager = class {
    constructor(sceneRoot){
        this.sceneRoot = sceneRoot;
        this.axes = /* @__PURE__ */ new Map();
        this.axisGridGroup = new $d77b025aa58d633c$var$Group({
            name: "Axes-Grids",
            zIndex: 1 /* AXIS_GRID */ 
        });
        this.axisGroup = new $d77b025aa58d633c$var$Group({
            name: "Axes",
            zIndex: 2 /* AXIS */ 
        });
        this.axisLabelGroup = new $d77b025aa58d633c$var$Group({
            name: "Axes-Labels",
            zIndex: 13 /* SERIES_LABEL */ 
        });
        this.axisCrosslineRangeGroup = new $d77b025aa58d633c$var$Group({
            name: "Axes-Crosslines-Range",
            zIndex: 4 /* SERIES_CROSSLINE_RANGE */ 
        });
        this.axisCrosslineLineGroup = new $d77b025aa58d633c$var$Group({
            name: "Axes-Crosslines-Line",
            zIndex: 8 /* SERIES_CROSSLINE_LINE */ 
        });
        this.axisCrosslineLabelGroup = new $d77b025aa58d633c$var$Group({
            name: "Axes-Crosslines-Label",
            zIndex: 13 /* SERIES_LABEL */ 
        });
        this.sceneRoot.appendChild(this.axisGroup);
        this.sceneRoot.appendChild(this.axisGridGroup);
        this.sceneRoot.appendChild(this.axisLabelGroup);
        this.sceneRoot.appendChild(this.axisCrosslineRangeGroup);
        this.sceneRoot.appendChild(this.axisCrosslineLineGroup);
        this.sceneRoot.appendChild(this.axisCrosslineLabelGroup);
    }
    updateAxes(oldAxes, newAxes) {
        const axisNodes = {
            axisNode: this.axisGroup,
            gridNode: this.axisGridGroup,
            labelNode: this.axisLabelGroup,
            crossLineRangeNode: this.axisCrosslineRangeGroup,
            crossLineLineNode: this.axisCrosslineLineGroup,
            crossLineLabelNode: this.axisCrosslineLabelGroup
        };
        for (const axis of oldAxes){
            if (newAxes.includes(axis)) continue;
            axis.detachAxis(axisNodes);
            axis.destroy();
        }
        for (const axis of newAxes){
            if (oldAxes?.includes(axis)) continue;
            axis.attachAxis(axisNodes);
        }
        this.axes.clear();
        for (const axis of newAxes){
            const ctx = axis.createAxisContext();
            if (this.axes.has(ctx.direction)) this.axes.get(ctx.direction)?.push(ctx);
            else this.axes.set(ctx.direction, [
                ctx
            ]);
        }
    }
    getAxisContext(direction) {
        return this.axes.get(direction) ?? [];
    }
    destroy() {
        this.axes.clear();
        this.sceneRoot.removeChild(this.axisGroup);
        this.sceneRoot.removeChild(this.axisGridGroup);
    }
};
// packages/ag-charts-community/src/chart/chartUpdateType.ts
var $d77b025aa58d633c$var$ChartUpdateType = /* @__PURE__ */ ((ChartUpdateType2)=>{
    ChartUpdateType2[ChartUpdateType2["FULL"] = 0] = "FULL";
    ChartUpdateType2[ChartUpdateType2["UPDATE_DATA"] = 1] = "UPDATE_DATA";
    ChartUpdateType2[ChartUpdateType2["PROCESS_DATA"] = 2] = "PROCESS_DATA";
    ChartUpdateType2[ChartUpdateType2["PROCESS_DOMAIN"] = 3] = "PROCESS_DOMAIN";
    ChartUpdateType2[ChartUpdateType2["PERFORM_LAYOUT"] = 4] = "PERFORM_LAYOUT";
    ChartUpdateType2[ChartUpdateType2["SERIES_UPDATE"] = 5] = "SERIES_UPDATE";
    ChartUpdateType2[ChartUpdateType2["PRE_SCENE_RENDER"] = 6] = "PRE_SCENE_RENDER";
    ChartUpdateType2[ChartUpdateType2["SCENE_RENDER"] = 7] = "SCENE_RENDER";
    ChartUpdateType2[ChartUpdateType2["NONE"] = 8] = "NONE";
    return ChartUpdateType2;
})($d77b025aa58d633c$var$ChartUpdateType || {});
var $d77b025aa58d633c$var$DataService = class extends $d77b025aa58d633c$var$Listeners {
    constructor(animationManager){
        super();
        this.animationManager = animationManager;
        this.dispatchOnlyLatest = true;
        this.dispatchThrottle = 0;
        this.requestThrottle = 300;
        this.isLoadingInitialData = false;
        this.isLoadingData = false;
        this.freshRequests = [];
        this.requestCounter = 0;
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "data-model", "data-source");
        this.throttledFetch = this.createThrottledFetch(this.requestThrottle);
        this.throttledDispatch = this.createThrottledDispatch(this.dispatchThrottle);
    }
    updateCallback(dataSourceCallback) {
        if (typeof dataSourceCallback !== "function") return;
        this.debug("DataService - updated data source callback");
        this.dataSourceCallback = dataSourceCallback;
        this.isLoadingInitialData = true;
        this.animationManager.skip();
        this.dispatch("data-source-change");
    }
    clearCallback() {
        this.dataSourceCallback = void 0;
    }
    load(params) {
        this.isLoadingData = true;
        this.throttledFetch(params);
    }
    isLazy() {
        return this.dataSourceCallback != null;
    }
    isLoading() {
        return this.isLazy() && (this.isLoadingInitialData || this.isLoadingData);
    }
    createThrottledFetch(requestThrottle) {
        return (0, $idDdm.throttle)((params)=>this.fetch(params).catch((e)=>(0, $idDdm.Logger).error("callback failed", e)), requestThrottle, {
            leading: false,
            trailing: true
        });
    }
    createThrottledDispatch(dispatchThrottle) {
        return (0, $idDdm.throttle)((id, data)=>{
            this.debug(`DataService - dispatching 'data-load' | ${id}`);
            this.dispatch("data-load", {
                type: "data-load",
                data: data
            });
        }, dispatchThrottle, {
            leading: true,
            trailing: true
        });
    }
    async fetch(params) {
        if (!this.dataSourceCallback) throw new Error("DataService - [dataSource.getData] callback not initialised");
        const start2 = performance.now();
        const id = this.requestCounter++;
        this.debug(`DataService - requesting | ${id}`);
        this.freshRequests.push(id);
        let response;
        try {
            response = await this.dataSourceCallback(params);
            this.debug(`DataService - response | ${performance.now() - start2}ms | ${id}`);
        } catch (error) {
            this.debug(`DataService - request failed | ${id}`);
            (0, $idDdm.Logger).errorOnce(`DataService - request failed | [${error}]`);
        }
        this.isLoadingInitialData = false;
        const requestIndex = this.freshRequests.findIndex((rid)=>rid === id);
        if (requestIndex === -1 || this.dispatchOnlyLatest && requestIndex !== this.freshRequests.length - 1) {
            this.debug(`DataService - discarding stale request | ${id}`);
            return;
        }
        this.freshRequests = this.freshRequests.slice(requestIndex + 1);
        if (this.freshRequests.length === 0) this.isLoadingData = false;
        if (Array.isArray(response)) this.throttledDispatch(id, response);
        else this.dispatch("data-error");
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        newValue (dispatchThrottle) {
            this.throttledDispatch = this.createThrottledDispatch(dispatchThrottle);
        }
    })
], $d77b025aa58d633c$var$DataService.prototype, "dispatchThrottle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        newValue (requestThrottle) {
            this.throttledFetch = this.createThrottledFetch(requestThrottle);
        }
    })
], $d77b025aa58d633c$var$DataService.prototype, "requestThrottle", 2);
// packages/ag-charts-community/src/chart/fonts/fontManager.ts
var $d77b025aa58d633c$var$FontManager = class {
    constructor(domManager, updateService){
        this.domManager = domManager;
        this.updateService = updateService;
        this.observers = [];
    }
    updateFonts(fonts) {
        if (!fonts || fonts.size === 0) return;
        this.loadFonts(fonts);
        fonts.forEach((font2)=>{
            this.observeFontStatus(font2);
        });
    }
    destroy() {
        for (const observer of this.observers)observer.disconnect();
        this.observers = [];
    }
    loadFonts(fonts) {
        const fontStrings = Array.from(fonts).map((font2)=>encodeURIComponent(font2));
        const fontStyle = ":wght@100;200;300;400;500;600;700;800;900";
        const joinString = `${fontStyle}&family=`;
        const css = `@import url('https://fonts.googleapis.com/css2?family=${fontStrings.join(joinString)}${fontStyle}&display=swap');
`;
        this.domManager.addStyles(`google-font-${fontStrings.join("-")}`, css);
    }
    observeFontStatus(font2) {
        const fontCheckElement = window.document.createElement("div");
        fontCheckElement.style.setProperty("position", "absolute");
        fontCheckElement.style.setProperty("top", "0");
        fontCheckElement.style.setProperty("margin", "0");
        fontCheckElement.style.setProperty("padding", "0");
        fontCheckElement.style.setProperty("overflow", "hidden");
        fontCheckElement.style.setProperty("visibility", "hidden");
        fontCheckElement.style.setProperty("width", "auto");
        fontCheckElement.style.setProperty("max-width", "none");
        fontCheckElement.style.setProperty("font-synthesis", "none");
        fontCheckElement.style.setProperty("font-family", font2);
        fontCheckElement.style.setProperty("font-size", "16px");
        fontCheckElement.style.setProperty("white-space", "nowrap");
        fontCheckElement.textContent = "UVWxyz";
        this.domManager.addChild("canvas-container", `font-check-${encodeURIComponent(font2)}`, fontCheckElement);
        const fontCheckObserver = new ResizeObserver((entries8)=>{
            const width2 = entries8?.at(0)?.contentBoxSize.at(0)?.inlineSize;
            if (width2 != null && width2 > 0) {
                $d77b025aa58d633c$var$CachedTextMeasurerPool.clear();
                this.updateService.update(4 /* PERFORM_LAYOUT */ );
            }
        });
        fontCheckObserver.observe(fontCheckElement);
        this.observers.push(fontCheckObserver);
    }
};
// packages/ag-charts-community/src/util/interpolate.ts
function $d77b025aa58d633c$var$interpolateNumber(a, b) {
    return (d)=>Number(a) * (1 - d) + Number(b) * d;
}
function $d77b025aa58d633c$var$interpolateColor(a, b) {
    if (typeof a === "string") try {
        a = $d77b025aa58d633c$var$Color.fromString(a);
    } catch  {
        a = $d77b025aa58d633c$var$Color.fromArray([
            0,
            0,
            0
        ]);
    }
    if (typeof b === "string") try {
        b = $d77b025aa58d633c$var$Color.fromString(b);
    } catch  {
        b = $d77b025aa58d633c$var$Color.fromArray([
            0,
            0,
            0
        ]);
    }
    return (d)=>$d77b025aa58d633c$var$Color.mix(a, b, d).toRgbaString();
}
// packages/ag-charts-community/src/motion/easing.ts
var $d77b025aa58d633c$var$easing_exports = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$var$easing_exports, {
    easeIn: ()=>$d77b025aa58d633c$var$easeIn,
    easeInOut: ()=>$d77b025aa58d633c$var$easeInOut,
    easeInOutQuad: ()=>$d77b025aa58d633c$var$easeInOutQuad,
    easeInQuad: ()=>$d77b025aa58d633c$var$easeInQuad,
    easeOut: ()=>$d77b025aa58d633c$var$easeOut,
    easeOutQuad: ()=>$d77b025aa58d633c$var$easeOutQuad,
    inverseEaseOut: ()=>$d77b025aa58d633c$var$inverseEaseOut,
    linear: ()=>$d77b025aa58d633c$var$linear
});
var $d77b025aa58d633c$var$linear = (n)=>n;
var $d77b025aa58d633c$var$easeIn = (n)=>1 - Math.cos(n * Math.PI / 2);
var $d77b025aa58d633c$var$easeOut = (n)=>Math.sin(n * Math.PI / 2);
var $d77b025aa58d633c$var$easeInOut = (n)=>-(Math.cos(n * Math.PI) - 1) / 2;
var $d77b025aa58d633c$var$easeInQuad = (n)=>n * n;
var $d77b025aa58d633c$var$easeOutQuad = (n)=>1 - (1 - n) ** 2;
var $d77b025aa58d633c$var$easeInOutQuad = (n)=>n < 0.5 ? 2 * n * n : 1 - (-2 * n + 2) ** 2 / 2;
var $d77b025aa58d633c$var$inverseEaseOut = (x)=>2 * Math.asin(x) / Math.PI;
// packages/ag-charts-community/src/motion/animation.ts
var $d77b025aa58d633c$var$QUICK_TRANSITION = 0.2;
var $d77b025aa58d633c$var$PHASE_ORDER = [
    "initial",
    "remove",
    "update",
    "add",
    "trailing",
    "end",
    "none"
];
var $d77b025aa58d633c$var$PHASE_METADATA = {
    initial: {
        animationDuration: 1,
        animationDelay: 0
    },
    add: {
        animationDuration: 0.25,
        animationDelay: 0.75
    },
    remove: {
        animationDuration: 0.25,
        animationDelay: 0
    },
    update: {
        animationDuration: 0.5,
        animationDelay: 0.25
    },
    trailing: {
        animationDuration: $d77b025aa58d633c$var$QUICK_TRANSITION,
        animationDelay: 1,
        skipIfNoEarlierAnimations: true
    },
    end: {
        animationDelay: 1 + $d77b025aa58d633c$var$QUICK_TRANSITION,
        animationDuration: 0,
        skipIfNoEarlierAnimations: true
    },
    none: {
        animationDuration: 0,
        animationDelay: 0
    }
};
var $d77b025aa58d633c$var$RepeatType = /* @__PURE__ */ ((RepeatType2)=>{
    RepeatType2["Loop"] = "loop";
    RepeatType2["Reverse"] = "reverse";
    return RepeatType2;
})($d77b025aa58d633c$var$RepeatType || {});
function $d77b025aa58d633c$var$isNodeArray(array6) {
    return array6.every((n)=>n instanceof $d77b025aa58d633c$var$Node2);
}
function $d77b025aa58d633c$var$deconstructSelectionsOrNodes(selectionsOrNodes) {
    return $d77b025aa58d633c$var$isNodeArray(selectionsOrNodes) ? {
        nodes: selectionsOrNodes,
        selections: []
    } : {
        nodes: [],
        selections: selectionsOrNodes
    };
}
function $d77b025aa58d633c$var$animationValuesEqual(a, b) {
    if (a === b) return true;
    else if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every((v, i)=>$d77b025aa58d633c$var$animationValuesEqual(v, b[i]));
    else if ($d77b025aa58d633c$var$isInterpolating(a) && $d77b025aa58d633c$var$isInterpolating(b)) return a.equals(b);
    else if ((0, $idDdm.isPlainObject)(a) && (0, $idDdm.isPlainObject)(b)) return $d77b025aa58d633c$var$objectsEqualWith(a, b, $d77b025aa58d633c$var$animationValuesEqual);
    return false;
}
var $d77b025aa58d633c$var$Animation = class {
    constructor(opts){
        this.isComplete = false;
        this.elapsed = 0;
        this.iteration = 0;
        this.isPlaying = false;
        this.isReverse = false;
        this.id = opts.id;
        this.groupId = opts.groupId;
        this.autoplay = opts.autoplay ?? true;
        this.ease = opts.ease ?? $d77b025aa58d633c$var$linear;
        this.phase = opts.phase;
        const durationProportion = opts.duration ?? $d77b025aa58d633c$var$PHASE_METADATA[this.phase].animationDuration;
        this.duration = durationProportion * opts.defaultDuration;
        this.delay = (opts.delay ?? 0) * opts.defaultDuration;
        this.onComplete = opts.onComplete;
        this.onPlay = opts.onPlay;
        this.onStop = opts.onStop;
        this.onUpdate = opts.onUpdate;
        this.interpolate = this.createInterpolator(opts.from, opts.to);
        this.from = opts.from;
        if (opts.skip === true) {
            this.onUpdate?.(opts.to, false, this);
            this.onStop?.(this);
            this.onComplete?.(this);
            this.isComplete = true;
        }
        if (opts.collapsable !== false) this.duration = this.checkCollapse(opts, this.duration);
    }
    checkCollapse(opts, calculatedDuration) {
        return $d77b025aa58d633c$var$animationValuesEqual(opts.from, opts.to) ? 0 : calculatedDuration;
    }
    play(initialUpdate = false) {
        if (this.isPlaying || this.isComplete) return;
        this.isPlaying = true;
        this.onPlay?.(this);
        if (!this.autoplay) return;
        this.autoplay = false;
        if (!initialUpdate) return;
        this.onUpdate?.(this.from, true, this);
    }
    stop() {
        this.isPlaying = false;
        if (!this.isComplete) {
            this.isComplete = true;
            this.onStop?.(this);
        }
    }
    update(time2) {
        if (this.isComplete) return time2;
        if (!this.isPlaying && this.autoplay) this.play(true);
        const previousElapsed = this.elapsed;
        this.elapsed += time2;
        if (this.delay > this.elapsed) return 0;
        const value = this.interpolate(this.isReverse ? 1 - this.delta : this.delta);
        this.onUpdate?.(value, false, this);
        const totalDuration = this.delay + this.duration;
        if (this.elapsed >= totalDuration) {
            this.stop();
            this.isComplete = true;
            this.onComplete?.(this);
            return time2 - (totalDuration - previousElapsed);
        }
        return 0;
    }
    get delta() {
        return this.ease((0, $idDdm.clamp)(0, (this.elapsed - this.delay) / this.duration, 1));
    }
    createInterpolator(from3, to) {
        if (typeof to !== "object" || $d77b025aa58d633c$var$isInterpolating(to)) return this.interpolateValue(from3, to);
        const interpolatorEntries = [];
        for (const key of Object.keys(to)){
            const interpolator = this.interpolateValue(from3[key], to[key]);
            if (interpolator != null) interpolatorEntries.push([
                key,
                interpolator
            ]);
        }
        return (d)=>{
            const result = {};
            for (const [key, interpolator] of interpolatorEntries)result[key] = interpolator(d);
            return result;
        };
    }
    interpolateValue(a, b) {
        if (a == null || b == null) return;
        else if ($d77b025aa58d633c$var$isInterpolating(a)) return (d)=>a[$d77b025aa58d633c$var$interpolate](b, d);
        try {
            switch(typeof a){
                case "number":
                    return $d77b025aa58d633c$var$interpolateNumber(a, b);
                case "string":
                    return $d77b025aa58d633c$var$interpolateColor(a, b);
                case "boolean":
                    if (a === b) return ()=>a;
                    break;
                case "object":
                    return ()=>a;
                default:
                    throw new Error(`Unable to interpolate values: ${a}, ${b}`);
            }
        } catch  {}
        throw new Error(`Unable to interpolate values: ${a}, ${b}`);
    }
};
var $d77b025aa58d633c$var$AnimationBatch = class {
    constructor(maxAnimationTime){
        this.maxAnimationTime = maxAnimationTime;
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "animation");
        this.controllers = /* @__PURE__ */ new Map();
        this.stoppedCbs = /* @__PURE__ */ new Set();
        this.currentPhase = 0;
        this.phases = new Map($d77b025aa58d633c$var$PHASE_ORDER.map((p)=>[
                p,
                []
            ]));
        this.skipAnimations = false;
        this.animationTimeConsumed = 0;
        /** Guard against premature animation execution. */ this.isReady = false;
    }
    get size() {
        return this.controllers.size;
    }
    get consumedTimeMs() {
        return this.animationTimeConsumed;
    }
    isActive() {
        return this.controllers.size > 0;
    }
    getActiveControllers() {
        return this.phases.get($d77b025aa58d633c$var$PHASE_ORDER[this.currentPhase]) ?? [];
    }
    checkOverlappingId(id) {
        if (id != null && this.controllers.has(id)) {
            this.controllers.get(id).stop();
            this.debug(`Skipping animation batch due to update of existing animation: ${id}`);
            this.skip();
        }
    }
    addAnimation(animation) {
        if (animation.isComplete) return;
        const animationPhaseIdx = $d77b025aa58d633c$var$PHASE_ORDER.indexOf(animation.phase);
        if (animationPhaseIdx < this.currentPhase) {
            this.debug(`Skipping animation due to being for an earlier phase`, animation.id);
            animation.stop();
            return;
        }
        this.controllers.set(animation.id, animation);
        this.phases.get(animation.phase)?.push(animation);
    }
    removeAnimation(animation) {
        this.controllers.delete(animation.id);
        const phase = this.phases.get(animation.phase);
        const index = phase?.indexOf(animation);
        if (index != null && index >= 0) phase?.splice(index, 1);
    }
    progress(deltaTime) {
        if (!this.isReady) return;
        let unusedTime = deltaTime === 0 ? 0.01 : deltaTime;
        const refresh = ()=>{
            const phase2 = $d77b025aa58d633c$var$PHASE_ORDER[this.currentPhase];
            return {
                phaseControllers: [
                    ...this.getActiveControllers()
                ],
                phase: phase2,
                phaseMeta: $d77b025aa58d633c$var$PHASE_METADATA[phase2]
            };
        };
        let { phase: phase, phaseControllers: phaseControllers, phaseMeta: phaseMeta } = refresh();
        const arePhasesComplete = ()=>$d77b025aa58d633c$var$PHASE_ORDER[this.currentPhase] == null;
        const progressPhase = ()=>{
            ({ phase: phase, phaseControllers: phaseControllers, phaseMeta: phaseMeta } = refresh());
            while(!arePhasesComplete() && phaseControllers.length === 0){
                this.currentPhase++;
                ({ phase: phase, phaseControllers: phaseControllers, phaseMeta: phaseMeta } = refresh());
                this.debug(`AnimationBatch - phase changing to ${phase}`, {
                    unusedTime: unusedTime
                }, phaseControllers);
            }
        };
        const total = this.controllers.size;
        this.debug(`AnimationBatch - ${deltaTime}ms; phase ${phase} with ${phaseControllers?.length} of ${total}`);
        do {
            const phaseDeltaTime = unusedTime;
            const skipPhase = phaseMeta.skipIfNoEarlierAnimations && this.animationTimeConsumed === 0;
            let completeCount = 0;
            for (const controller of phaseControllers){
                if (skipPhase) controller.stop();
                else unusedTime = Math.min(controller.update(phaseDeltaTime), unusedTime);
                if (controller.isComplete) {
                    completeCount++;
                    this.removeAnimation(controller);
                }
            }
            this.animationTimeConsumed += phaseDeltaTime - unusedTime;
            this.debug(`AnimationBatch - updated ${phaseControllers.length} controllers; ${completeCount} completed`);
            this.debug(`AnimationBatch - animationTimeConsumed: ${this.animationTimeConsumed}`);
            progressPhase();
        }while (unusedTime > 0 && !arePhasesComplete());
        if (this.animationTimeConsumed > this.maxAnimationTime) {
            this.debug(`Animation batch exceeded max animation time, skipping`, [
                ...this.controllers
            ]);
            this.stop();
        }
    }
    ready() {
        if (this.isReady) return;
        this.isReady = true;
        this.debug(`AnimationBatch - ready; skipped: ${this.skipAnimations}`, [
            ...this.controllers
        ]);
        let skipAll = true;
        for (const [, controller] of this.controllers)if (controller.duration > 0 && $d77b025aa58d633c$var$PHASE_METADATA[controller.phase].skipIfNoEarlierAnimations !== true) {
            skipAll = false;
            break;
        }
        if (!skipAll) {
            for (const [, controller] of this.controllers)if (controller.autoplay) controller.play(true);
        }
    }
    skip(skip = true) {
        if (this.skipAnimations === false && skip === true) {
            for (const controller of this.controllers.values())controller.stop();
            this.controllers.clear();
        }
        this.skipAnimations = skip;
    }
    play() {
        for (const controller of this.controllers.values())controller.play();
    }
    stop() {
        for (const controller of this.controllers.values())try {
            controller.stop();
            this.removeAnimation(controller);
        } catch (error) {
            (0, $idDdm.Logger).error("Error during animation stop", error);
        }
        this.dispatchStopped();
    }
    stopByAnimationId(id) {
        if (id != null && this.controllers.has(id)) {
            const controller = this.controllers.get(id);
            if (controller) {
                controller.stop();
                this.removeAnimation(controller);
            }
        }
    }
    stopByAnimationGroupId(id) {
        for (const controller of this.controllers.values())if (controller.groupId === id) this.stopByAnimationId(controller.id);
    }
    dispatchStopped() {
        this.stoppedCbs.forEach((cb)=>cb());
        this.stoppedCbs.clear();
    }
    isSkipped() {
        return this.skipAnimations;
    }
    getRemainingTime(restrictPhase) {
        if (!this.isActive()) return 0;
        let total = 0;
        for (const [phase, controllers] of this.phases){
            if (controllers.length === 0) continue;
            if (restrictPhase != null && restrictPhase !== phase) continue;
            total += Math.max(...controllers.map((c)=>c.isComplete ? 0 : c.delay + c.duration - (c.elapsed ?? 0)));
        }
        return total;
    }
    destroy() {
        this.stop();
        this.controllers.clear();
    }
};
// packages/ag-charts-community/src/chart/interaction/interactionManager.ts
var $d77b025aa58d633c$var$InteractionState = /* @__PURE__ */ ((InteractionState2)=>{
    InteractionState2[InteractionState2["Default"] = 32] = "Default";
    InteractionState2[InteractionState2["ZoomDrag"] = 16] = "ZoomDrag";
    InteractionState2[InteractionState2["Annotations"] = 8] = "Annotations";
    InteractionState2[InteractionState2["ContextMenu"] = 4] = "ContextMenu";
    InteractionState2[InteractionState2["Animation"] = 2] = "Animation";
    InteractionState2[InteractionState2["AnnotationsSelected"] = 1] = "AnnotationsSelected";
    InteractionState2[InteractionState2["Clickable"] = 41] = "Clickable";
    InteractionState2[InteractionState2["Focusable"] = 34] = "Focusable";
    InteractionState2[InteractionState2["Keyable"] = 43] = "Keyable";
    InteractionState2[InteractionState2["ContextMenuable"] = 36] = "ContextMenuable";
    InteractionState2[InteractionState2["AnnotationsMoveable"] = 9] = "AnnotationsMoveable";
    InteractionState2[InteractionState2["AnnotationsDraggable"] = 57] = "AnnotationsDraggable";
    InteractionState2[InteractionState2["ZoomDraggable"] = 50] = "ZoomDraggable";
    InteractionState2[InteractionState2["ZoomClickable"] = 34] = "ZoomClickable";
    InteractionState2[InteractionState2["ZoomWheelable"] = 59] = "ZoomWheelable";
    InteractionState2[InteractionState2["All"] = 63] = "All";
    return InteractionState2;
})($d77b025aa58d633c$var$InteractionState || {});
var $d77b025aa58d633c$var$InteractionManager = class {
    constructor(){
        this.stateQueue = 34 /* Animation */ ;
    }
    pushState(state) {
        this.stateQueue |= state;
    }
    popState(state) {
        this.stateQueue &= ~state;
    }
    isState(allowedStates) {
        return !!(this.stateQueue & -this.stateQueue & allowedStates);
    }
};
// packages/ag-charts-community/src/chart/interaction/animationManager.ts
function $d77b025aa58d633c$var$validAnimationDuration(testee) {
    if (testee == null) return true;
    return !isNaN(testee) && testee >= 0 && testee <= 2;
}
var $d77b025aa58d633c$var$AnimationManager = class {
    constructor(interactionManager, chartUpdateMutex){
        this.interactionManager = interactionManager;
        this.chartUpdateMutex = chartUpdateMutex;
        this.defaultDuration = 1e3;
        this.batch = new $d77b025aa58d633c$var$AnimationBatch(this.defaultDuration * 1.5);
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "animation");
        this.events = new (0, $idDdm.EventEmitter)();
        this.rafAvailable = typeof requestAnimationFrame !== "undefined";
        this.isPlaying = true;
        this.requestId = null;
        this.skipAnimations = true;
        this.currentAnonymousAnimationId = 0;
    }
    addListener(eventName, listener) {
        return this.events.on(eventName, listener);
    }
    /**
   * Create an animation to tween a value between the `from` and `to` properties. If an animation already exists
   * with the same `id`, immediately stop it.
   */ animate(opts) {
        const batch = this.batch;
        try {
            batch.checkOverlappingId(opts.id);
        } catch (error) {
            this.failsafeOnError(error);
            return;
        }
        let { id: id } = opts;
        if (id == null) {
            id = `__${this.currentAnonymousAnimationId}`;
            this.currentAnonymousAnimationId += 1;
        }
        const skip = this.isSkipped() || opts.phase === "none";
        if (skip) this.debug("AnimationManager - skipping animation");
        const { delay: delay, duration: duration } = opts;
        if (!$d77b025aa58d633c$var$validAnimationDuration(delay)) throw new Error(`Animation delay of ${delay} is unsupported (${id})`);
        if (!$d77b025aa58d633c$var$validAnimationDuration(duration)) throw new Error(`Animation duration of ${duration} is unsupported (${id})`);
        const animation = new $d77b025aa58d633c$var$Animation({
            ...opts,
            id: id,
            skip: skip,
            autoplay: this.isPlaying ? opts.autoplay : false,
            phase: opts.phase,
            defaultDuration: this.defaultDuration
        });
        if (this.forceTimeJump(animation, this.defaultDuration)) return;
        this.batch.addAnimation(animation);
        return animation;
    }
    play() {
        if (this.isPlaying) return;
        this.isPlaying = true;
        this.debug("AnimationManager.play()");
        try {
            this.batch.play();
        } catch (error) {
            this.failsafeOnError(error);
        }
        this.requestAnimation();
    }
    stop() {
        this.isPlaying = false;
        this.cancelAnimation();
        this.debug("AnimationManager.stop()");
        this.batch.stop();
    }
    stopByAnimationId(id) {
        try {
            this.batch.stopByAnimationId(id);
        } catch (error) {
            this.failsafeOnError(error);
        }
    }
    stopByAnimationGroupId(id) {
        try {
            this.batch.stopByAnimationGroupId(id);
        } catch (error) {
            this.failsafeOnError(error);
        }
    }
    reset() {
        if (this.isPlaying) {
            this.stop();
            this.play();
        } else this.stop();
    }
    skip(skip = true) {
        this.skipAnimations = skip;
    }
    isSkipped() {
        return !this.rafAvailable || this.skipAnimations || this.batch.isSkipped();
    }
    isActive() {
        return this.isPlaying && this.batch.isActive();
    }
    getRemainingTime(phase) {
        return this.batch.getRemainingTime(phase);
    }
    skipCurrentBatch() {
        if (this.debug.check()) this.debug(`AnimationManager - skipCurrentBatch()`, {
            stack: new Error().stack
        });
        this.batch.skip();
    }
    /** Mocking point for tests to guarantee that animation updates happen. */ isSkippingFrames() {
        return true;
    }
    /** Mocking point for tests to capture requestAnimationFrame callbacks. */ scheduleAnimationFrame(cb) {
        this.requestId = (0, $idDdm.getWindow)().requestAnimationFrame((t)=>{
            cb(t).catch((e)=>(0, $idDdm.Logger).error(e));
        });
    }
    /** Mocking point for tests to skip animations to a specific point in time. */ forceTimeJump(_animation, _defaultDuration) {
        return false;
    }
    requestAnimation() {
        if (!this.rafAvailable) return;
        if (!this.batch.isActive() || this.requestId !== null) return;
        let prevTime;
        const onAnimationFrame = async (time2)=>{
            const executeAnimationFrame = ()=>{
                const deltaTime = time2 - (prevTime ?? time2);
                prevTime = time2;
                this.debug("AnimationManager - onAnimationFrame()", {
                    controllersCount: this.batch.size,
                    deltaTime: deltaTime
                });
                this.interactionManager.pushState(2 /* Animation */ );
                try {
                    this.batch.progress(deltaTime);
                } catch (error) {
                    this.failsafeOnError(error);
                }
                this.events.emit("animation-frame", {
                    type: "animation-frame",
                    deltaMs: deltaTime
                });
            };
            if (this.isSkippingFrames()) await this.chartUpdateMutex.acquireImmediately(executeAnimationFrame);
            else await this.chartUpdateMutex.acquire(executeAnimationFrame);
            if (this.batch.isActive()) this.scheduleAnimationFrame(onAnimationFrame);
            else {
                this.batch.stop();
                this.events.emit("animation-stop", {
                    type: "animation-stop",
                    deltaMs: this.batch.consumedTimeMs
                });
            }
        };
        this.events.emit("animation-start", {
            type: "animation-start",
            deltaMs: 0
        });
        this.scheduleAnimationFrame(onAnimationFrame);
    }
    cancelAnimation() {
        if (this.requestId === null) return;
        cancelAnimationFrame(this.requestId);
        this.requestId = null;
        this.startBatch();
    }
    failsafeOnError(error, cancelAnimation = true) {
        (0, $idDdm.Logger).error("Error during animation, skipping animations", error);
        if (cancelAnimation) this.cancelAnimation();
    }
    startBatch(skipAnimations) {
        this.debug(`AnimationManager - startBatch() with skipAnimations=${skipAnimations}.`);
        this.reset();
        this.batch.destroy();
        this.batch = new $d77b025aa58d633c$var$AnimationBatch(this.defaultDuration * 1.5);
        if (skipAnimations === true) this.batch.skip();
    }
    endBatch() {
        if (this.batch.isActive()) {
            this.batch.ready();
            this.requestAnimation();
        } else {
            this.interactionManager.popState(2 /* Animation */ );
            if (this.batch.isSkipped()) this.batch.skip(false);
        }
    }
    onBatchStop(cb) {
        this.batch.stoppedCbs.add(cb);
    }
    destroy() {
        this.stop();
        this.events.clear();
    }
};
// packages/ag-charts-community/src/chart/interaction/chartEventManager.ts
var $d77b025aa58d633c$var$ChartEventManager = class extends $d77b025aa58d633c$var$BaseManager {
    seriesEvent(type) {
        this.listeners.dispatch(type, {
            type: type
        });
    }
    seriesKeyNavZoom(delta3, widgetEvent) {
        const event = {
            type: "series-keynav-zoom",
            delta: delta3,
            widgetEvent: widgetEvent
        };
        this.listeners.dispatch("series-keynav-zoom", event);
    }
    legendItemClick(legendType, series, itemId, enabled, legendItemName) {
        const event = {
            type: "legend-item-click",
            legendType: legendType,
            series: series,
            itemId: itemId,
            enabled: enabled,
            legendItemName: legendItemName
        };
        this.listeners.dispatch("legend-item-click", event);
    }
    legendItemDoubleClick(legendType, series, itemId, enabled, numVisibleItems, legendItemName) {
        const event = {
            type: "legend-item-double-click",
            legendType: legendType,
            series: series,
            itemId: itemId,
            enabled: enabled,
            legendItemName: legendItemName,
            numVisibleItems: numVisibleItems
        };
        this.listeners.dispatch("legend-item-double-click", event);
    }
};
// packages/ag-charts-community/src/chart/interaction/contextMenuTypes.ts
var $d77b025aa58d633c$var$ContextMenuBuiltinItems = class {
    constructor(){
        this.download = {
            type: "action",
            showOn: "always",
            label: "contextMenuDownload",
            enabled: true,
            action: void 0,
            items: void 0
        };
        this["zoom-to-cursor"] = {
            type: "action",
            showOn: "series-area",
            label: "contextMenuZoomToCursor",
            enabled: true,
            action: void 0,
            items: void 0
        };
        this["pan-to-cursor"] = {
            type: "action",
            showOn: "series-area",
            label: "contextMenuPanToCursor",
            enabled: true,
            action: void 0,
            items: void 0
        };
        this["toggle-series-visibility"] = {
            type: "action",
            showOn: "legend-item",
            label: "contextMenuToggleSeriesVisibility",
            enabled: true,
            action: void 0,
            items: void 0
        };
        this["toggle-other-series"] = {
            type: "action",
            showOn: "legend-item",
            label: "contextMenuToggleOtherSeries",
            enabled: true,
            action: void 0,
            items: void 0
        };
        this["separator"] = {
            type: "separator",
            showOn: "always",
            label: "separator",
            enabled: true,
            action: void 0,
            items: void 0
        };
    }
};
var $d77b025aa58d633c$var$ContextMenuBuiltinItemLists = class {
    constructor(){
        this.defaults = [
            "download",
            "zoom-to-cursor",
            "pan-to-cursor",
            "toggle-series-visibility",
            "toggle-other-series"
        ];
    }
};
var $d77b025aa58d633c$var$ContextMenuBuiltins = class {
    constructor(){
        this.items = new $d77b025aa58d633c$var$ContextMenuBuiltinItems();
        this.lists = new $d77b025aa58d633c$var$ContextMenuBuiltinItemLists();
    }
};
// packages/ag-charts-community/src/chart/interaction/contextMenuRegistry.ts
var $d77b025aa58d633c$var$ContextMenuRegistry = class extends $d77b025aa58d633c$var$BaseManager {
    constructor(){
        super();
        this.builtins = new $d77b025aa58d633c$var$ContextMenuBuiltins();
        this.hiddenActions = /* @__PURE__ */ new Set();
        this.setVisible("zoom-to-cursor", false);
        this.setVisible("pan-to-cursor", false);
    }
    static check(showOn, event) {
        return event.showOn == showOn;
    }
    static checkCallback(desiredShowOn, showOn, _callback) {
        return desiredShowOn === showOn;
    }
    dispatchContext(showOn, pointerEvent, context, position) {
        const { widgetEvent: widgetEvent } = pointerEvent;
        if (widgetEvent.sourceEvent.defaultPrevented) return;
        const x = position?.x ?? pointerEvent.canvasX;
        const y = position?.y ?? pointerEvent.canvasY;
        const event = {
            type: "context-setup",
            showOn: showOn,
            x: x,
            y: y,
            context: context,
            widgetEvent: widgetEvent
        };
        this.listeners.dispatch("context-setup", event);
        event.type = "context-complete";
        this.listeners.dispatch("context-complete", event);
    }
    isVisible(id) {
        return !this.hiddenActions.has(id);
    }
    setVisible(id, visible) {
        if (visible) this.hiddenActions.delete(id);
        else this.hiddenActions.add(id);
    }
};
// packages/ag-charts-community/src/chart/interaction/highlightManager.ts
var $d77b025aa58d633c$var$HighlightManager = class extends $d77b025aa58d633c$var$BaseManager {
    constructor(){
        super(...arguments);
        this.highlightStates = new $d77b025aa58d633c$var$StateTracker();
    }
    updateHighlight(callerId, highlightedDatum) {
        const { activeHighlight: previousHighlight } = this;
        this.highlightStates.set(callerId, highlightedDatum);
        this.activeHighlight = this.highlightStates.stateValue();
        if (!this.isEqual(this.activeHighlight, previousHighlight)) this.listeners.dispatch("highlight-change", {
            type: "highlight-change",
            currentHighlight: this.activeHighlight,
            previousHighlight: previousHighlight,
            callerId: callerId
        });
    }
    getActiveHighlight() {
        return this.activeHighlight;
    }
    isEqual(a, b) {
        return a === b || a != null && b != null && a?.series === b?.series && a?.itemId === b?.itemId && a?.datum === b?.datum;
    }
};
function $d77b025aa58d633c$var$datumBoundaryPoints(datum, domain) {
    if (datum == null || domain.length === 0) return [
        false,
        false
    ];
    const datumValue = datum.valueOf();
    const d0 = domain[0];
    const d1 = domain[domain.length - 1];
    if (typeof d0 === "string") return [
        datumValue === d0,
        datumValue === d1
    ];
    let min = d0.valueOf();
    let max = d1.valueOf();
    if (min > max) [min, max] = [
        max,
        min
    ];
    return [
        datumValue === min,
        datumValue === max
    ];
}
function $d77b025aa58d633c$var$datumStylerProperties(datum, xKey, yKey, xDomain, yDomain) {
    const { xValue: xValue, yValue: yValue } = datum;
    const [min, max] = $d77b025aa58d633c$var$datumBoundaryPoints(yValue, yDomain);
    const [first2, last] = $d77b025aa58d633c$var$datumBoundaryPoints(xValue, xDomain);
    return {
        xKey: xKey,
        yKey: yKey,
        xValue: xValue,
        yValue: yValue,
        first: first2,
        last: last,
        min: min,
        max: max
    };
}
function $d77b025aa58d633c$var$visibleRangeIndices(length2, [range0, range1], xRange) {
    const xMinIndex = (0, $idDdm.findMinIndex)(0, length2 - 1, (index)=>{
        const x1 = xRange(index)?.[1] ?? NaN;
        return !Number.isFinite(x1) || x1 > range0;
    }) ?? 0;
    let xMaxIndex = (0, $idDdm.findMaxIndex)(0, length2 - 1, (index)=>{
        const x0 = xRange(index)?.[0] ?? NaN;
        return !Number.isFinite(x0) || x0 < range1;
    }) ?? length2 - 1;
    xMaxIndex = Math.min(xMaxIndex + 1, length2);
    return [
        xMinIndex,
        xMaxIndex
    ];
}
function $d77b025aa58d633c$var$getDatumRefPoint(series, datum, movedBounds) {
    if (movedBounds) {
        const { x: x, y: y, width: width2, height: height2 } = movedBounds;
        return {
            canvasX: x + width2 / 2,
            canvasY: y + height2 / 2
        };
    }
    const refPoint = datum.yBar?.upperPoint ?? datum.midPoint ?? series.datumMidPoint?.(datum);
    if (refPoint) {
        const { x: x, y: y } = $d77b025aa58d633c$var$Transformable.toCanvasPoint(series.contentGroup, refPoint.x, refPoint.y);
        return {
            canvasX: Math.round(x),
            canvasY: Math.round(y)
        };
    }
}
function $d77b025aa58d633c$var$countExpandingSearch(min, max, start2, countUntil, iteratee) {
    let i = -1;
    let count = 0;
    let shift = 0;
    let reachedAnEnd = false;
    while(count < countUntil && i <= max - min){
        i += 1;
        const index = start2 + shift;
        if (!reachedAnEnd) shift *= -1;
        if (shift >= 0) shift += 1;
        if (reachedAnEnd && shift < 0) shift -= 1;
        if (index < min || index > max) {
            reachedAnEnd = true;
            continue;
        }
        if (iteratee(index)) count += 1;
    }
    return count;
}
// packages/ag-charts-community/src/chart/interaction/tooltipManager.ts
var $d77b025aa58d633c$var$TooltipManager = class {
    constructor(localeManager, domManager, tooltip){
        this.domManager = domManager;
        this.tooltip = tooltip;
        this.stateTracker = new $d77b025aa58d633c$var$StateTracker();
        this.suppressState = new $d77b025aa58d633c$var$StateTracker(false);
        this.appliedState = null;
        this.destroyFns = [];
        this.destroyFns.push(tooltip.setup(localeManager, domManager), domManager.addListener("hidden", ()=>this.tooltip.hide()));
    }
    destroy() {
        this.destroyFns.forEach((fn)=>fn());
    }
    updateTooltip(callerId, meta, content, pagination) {
        content ?? (content = this.stateTracker.get(callerId)?.content);
        this.stateTracker.set(callerId, {
            meta: meta,
            content: content,
            pagination: pagination
        });
        this.applyStates();
    }
    removeTooltip(callerId) {
        this.stateTracker.delete(callerId);
        this.applyStates();
    }
    suppressTooltip(callerId) {
        this.suppressState.set(callerId, true);
    }
    unsuppressTooltip(callerId) {
        this.suppressState.delete(callerId);
    }
    applyStates() {
        const id = this.stateTracker.stateId();
        const state = id ? this.stateTracker.get(id) : void 0;
        if (this.suppressState.stateValue() || state?.meta == null || state?.content == null) {
            this.appliedState = null;
            this.tooltip.hide();
            return;
        }
        const canvasRect = this.domManager.getBoundingClientRect();
        const boundingRect = this.tooltip.bounds === "extended" ? this.domManager.getOverlayClientRect() : canvasRect;
        if (this.appliedState?.content === state?.content) {
            const renderInstantly = this.tooltip.isVisible();
            this.tooltip.show(boundingRect, canvasRect, state?.meta, null, void 0, renderInstantly);
        } else this.tooltip.show(boundingRect, canvasRect, state?.meta, state?.content, state?.pagination);
        this.appliedState = state;
    }
    static makeTooltipMeta(event, series, datum, movedBounds) {
        const { canvasX: canvasX, canvasY: canvasY } = event;
        const tooltip = series.properties.tooltip;
        const { placement: placement, defaultPlacement: defaultPlacement, anchorTo: anchorTo, defaultAnchorTo: defaultAnchorTo, xOffset: xOffset, yOffset: yOffset } = tooltip.position;
        const refPoint = $d77b025aa58d633c$var$getDatumRefPoint(series, datum, movedBounds);
        const meta = {
            canvasX: canvasX,
            canvasY: canvasY,
            nodeCanvasX: refPoint?.canvasX ?? canvasX,
            nodeCanvasY: refPoint?.canvasY ?? canvasY,
            enableInteraction: tooltip.interaction?.enabled ?? false,
            showArrow: tooltip.showArrow,
            position: {
                placement: placement,
                defaultPlacement: defaultPlacement,
                anchorTo: anchorTo,
                defaultAnchorTo: defaultAnchorTo,
                xOffset: xOffset,
                yOffset: yOffset
            }
        };
        return meta;
    }
    isEnteringInteractiveTooltip(event) {
        const { tooltip: tooltip } = this;
        const relatedTarget = event.relatedTarget;
        return tooltip.interactive && tooltip.enabled && tooltip.isVisible() && tooltip.contains(relatedTarget);
    }
};
// packages/ag-charts-community/src/chart/interaction/dragInterpreter.ts
var $d77b025aa58d633c$var$DRAG_THRESHOLD_PX = 3;
var $d77b025aa58d633c$var$DOUBLE_TAP_TIMER_MS = 505;
var $d77b025aa58d633c$var$DOUBLE_TAP_THRESHOLD_PX = 30;
function $d77b025aa58d633c$var$makeSynthetic(device, type, event) {
    const { offsetX: offsetX, offsetY: offsetY, clientX: clientX, clientY: clientY, currentX: currentX, currentY: currentY, sourceEvent: sourceEvent } = event;
    return {
        type: type,
        device: device,
        offsetX: offsetX,
        offsetY: offsetY,
        clientX: clientX,
        clientY: clientY,
        currentX: currentX,
        currentY: currentY,
        sourceEvent: sourceEvent
    };
}
function $d77b025aa58d633c$var$checkDragDistance(dx, dy) {
    const distanceSquared2 = dx * dx + dy * dy;
    const thresholdSquared = $d77b025aa58d633c$var$DRAG_THRESHOLD_PX * $d77b025aa58d633c$var$DRAG_THRESHOLD_PX;
    return distanceSquared2 >= thresholdSquared;
}
function $d77b025aa58d633c$var$checkDoubleTapDistance(t1, t2) {
    const dx = t1.clientX - t2.clientX;
    const dy = t1.clientY - t2.clientY;
    const distanceSquared2 = dx * dx + dy * dy;
    const thresholdSquared = $d77b025aa58d633c$var$DOUBLE_TAP_THRESHOLD_PX * $d77b025aa58d633c$var$DOUBLE_TAP_THRESHOLD_PX;
    return distanceSquared2 < thresholdSquared;
}
var $d77b025aa58d633c$var$DragInterpreter = class {
    constructor(widget){
        this.destroyFns = [];
        this.listeners = new $d77b025aa58d633c$var$Listeners();
        this.isDragging = false;
        this.touch = {
            distanceTravelledX: 0,
            distanceTravelledY: 0,
            clientX: 0,
            clientY: 0
        };
        this.destroyFns.push(widget.addListener("touchstart", this.onTouchStart.bind(this)), widget.addListener("touchmove", this.onTouchMove.bind(this)), widget.addListener("touchend", this.onTouchEnd.bind(this)), widget.addListener("mousemove", this.onMouseMove.bind(this)), widget.addListener("dblclick", this.onDblClick.bind(this)), widget.addListener("drag-start", this.onDragStart.bind(this)), widget.addListener("drag-move", this.onDragMove.bind(this)), widget.addListener("drag-end", this.onDragEnd.bind(this)));
    }
    destroy() {
        this.destroyFns.forEach((fn)=>fn());
        this.listeners.destroy();
    }
    addListener(type, handler) {
        return this.listeners.addListener(type, handler);
    }
    dispatch(event) {
        this.listeners.dispatch(event.type, event);
    }
    onTouchStart(e) {
        const { clientX: clientX, clientY: clientY } = e.sourceEvent.targetTouches[0] ?? {
            clientX: Infinity,
            clientY: Infinity
        };
        this.touch.distanceTravelledX = 0;
        this.touch.distanceTravelledY = 0;
        this.touch.clientX = clientX;
        this.touch.clientY = clientY;
    }
    onTouchMove(e) {
        const { clientX: clientX, clientY: clientY } = e.sourceEvent.targetTouches[0] ?? {
            clientX: Infinity,
            clientY: Infinity
        };
        this.touch.distanceTravelledX += Math.abs(this.touch.clientX - clientX);
        this.touch.distanceTravelledY += Math.abs(this.touch.clientY - clientY);
        this.touch.clientX = clientX;
        this.touch.clientY = clientY;
    }
    onTouchEnd(event) {
        event.sourceEvent.preventDefault();
    }
    onMouseMove(event) {
        this.dispatch(event);
    }
    onDblClick(event) {
        this.dispatch({
            device: "mouse",
            ...event
        });
    }
    onDragStart(event) {
        this.dragStartEvent = event;
    }
    onDragMove(event) {
        if (this.dragStartEvent != null) {
            if ($d77b025aa58d633c$var$checkDragDistance(event.originDeltaX, event.originDeltaY)) {
                this.dispatch(this.dragStartEvent);
                this.dispatch({
                    ...this.dragStartEvent,
                    type: "drag-move"
                });
                this.dragStartEvent = void 0;
                this.isDragging = true;
            }
        }
        if (this.isDragging) this.dispatch(event);
    }
    onDragEnd(event) {
        if (this.isDragging) {
            this.dispatch(event);
            this.isDragging = false;
            return;
        }
        if (event.device === "mouse") {
            const click = $d77b025aa58d633c$var$makeSynthetic("mouse", "click", event);
            this.dispatch(click);
        } else if (event.sourceEvent.type === "touchend") {
            if ($d77b025aa58d633c$var$checkDragDistance(this.touch.distanceTravelledX, this.touch.distanceTravelledY)) return;
            const click = $d77b025aa58d633c$var$makeSynthetic("touch", "click", event);
            this.dispatch(click);
            const now = Date.now();
            if (this.lastClick !== void 0 && now - this.lastClick.time <= $d77b025aa58d633c$var$DOUBLE_TAP_TIMER_MS && $d77b025aa58d633c$var$checkDoubleTapDistance(this.lastClick, event)) {
                const dblClick = $d77b025aa58d633c$var$makeSynthetic(event.device, "dblclick", event);
                this.dispatch(dblClick);
                this.lastClick = void 0;
            } else this.lastClick = {
                time: now,
                clientX: event.clientX,
                clientY: event.clientY
            };
        }
    }
};
// packages/ag-charts-community/src/chart/interaction/widgetSet.ts
var $d77b025aa58d633c$var$DOMManagerWidget = class extends $d77b025aa58d633c$var$NativeWidget {
    constructor(elem){
        super(elem);
    }
    addChildToDOM() {}
    removeChildFromDOM() {}
};
var $d77b025aa58d633c$var$WidgetSet = class {
    constructor(domManager){
        this.seriesWidget = new $d77b025aa58d633c$var$DOMManagerWidget(domManager.getParent("series-area"));
        this.chartWidget = new $d77b025aa58d633c$var$DOMManagerWidget(domManager.getParent("canvas-proxy"));
        this.containerWidget = new $d77b025aa58d633c$var$DOMManagerWidget(domManager.getParent("canvas-container"));
        this.containerWidget.addChild(this.chartWidget);
        this.chartWidget.addChild(this.seriesWidget);
        this.seriesDragInterpreter = new $d77b025aa58d633c$var$DragInterpreter(this.seriesWidget);
    }
    destroy() {
        this.seriesDragInterpreter.destroy();
        this.seriesWidget.destroy();
        this.chartWidget.destroy();
        this.containerWidget.destroy();
    }
};
function $d77b025aa58d633c$var$clampArray(value, array6) {
    const [min, max] = $d77b025aa58d633c$var$findMinMax(array6);
    return (0, $idDdm.clamp)(min, value, max);
}
function $d77b025aa58d633c$var$findMinMax(array6) {
    if (array6.length === 0) return [];
    const result = [
        Infinity,
        -Infinity
    ];
    for (const val of array6){
        if (val < result[0]) result[0] = val;
        if (val > result[1]) result[1] = val;
    }
    return result;
}
function $d77b025aa58d633c$var$findRangeExtent(array6) {
    const [min, max] = $d77b025aa58d633c$var$findMinMax(array6);
    return max - min;
}
// packages/ag-charts-community/src/scale/continuousScale.ts
var $d77b025aa58d633c$var$_ContinuousScale = class _ContinuousScale extends $d77b025aa58d633c$var$AbstractScale {
    constructor(domain = [], range3 = []){
        super();
        this.domain = domain;
        this.range = range3;
        this.defaultClamp = false;
    }
    static is(value) {
        return value instanceof _ContinuousScale;
    }
    normalizeDomains(...domains) {
        return $d77b025aa58d633c$var$normalizeContinuousDomains(...domains);
    }
    transform(x) {
        return x;
    }
    transformInvert(x) {
        return x;
    }
    calcBandwidth(smallestInterval = 1, minWidth = 1) {
        const { domain: domain } = this;
        const rangeDistance = this.getPixelRange();
        if (domain.length === 0) return rangeDistance;
        const intervals = Math.abs(domain[1].valueOf() - domain[0].valueOf()) / smallestInterval + 1;
        let bands = intervals;
        if (minWidth !== 0) {
            const maxBands = Math.floor(rangeDistance);
            bands = Math.min(bands, maxBands);
        }
        return rangeDistance / Math.max(1, bands);
    }
    convert(value, options) {
        const { domain: domain } = this;
        if (!domain || domain.length < 2) return NaN;
        const clamp24 = options?.clamp ?? this.defaultClamp;
        const d0 = Number(this.transform(domain[0]));
        const d1 = Number(this.transform(domain[1]));
        const x = Number(this.transform(value));
        const { range: range3 } = this;
        const [r0, r1] = range3;
        if (clamp24) {
            const [start2, stop] = $d77b025aa58d633c$var$findMinMax([
                d0,
                d1
            ]);
            if (x < start2) return r0;
            else if (x > stop) return r1;
        }
        if (d0 === d1) return (r0 + r1) / 2;
        else if (x === d0) return r0;
        else if (x === d1) return r1;
        return r0 + (x - d0) / (d1 - d0) * (r1 - r0);
    }
    invert(x, _nearest) {
        const domain = this.domain.map((d2)=>this.transform(d2));
        const [d0, d1] = domain;
        const { range: range3 } = this;
        const [r0, r1] = range3;
        let d;
        if (r0 === r1) d = this.toDomain((Number(d0) + Number(d1)) / 2);
        else d = this.toDomain(Number(d0) + (x - r0) / (r1 - r0) * (Number(d1) - Number(d0)));
        return this.transformInvert(d);
    }
    getPixelRange() {
        const [a, b] = this.range;
        return Math.abs(b - a);
    }
};
$d77b025aa58d633c$var$_ContinuousScale.defaultTickCount = 5;
var $d77b025aa58d633c$var$ContinuousScale = $d77b025aa58d633c$var$_ContinuousScale;
function $d77b025aa58d633c$var$normalizeContinuousDomains(...domains) {
    let min;
    let minValue = Infinity;
    let max;
    let maxValue = -Infinity;
    for (const domain of domains)for (const d of domain){
        const value = d.valueOf();
        if (value < minValue) {
            minValue = value;
            min = d;
        }
        if (value > maxValue) {
            maxValue = value;
            max = d;
        }
    }
    if (min != null && max != null) {
        const domain = [
            min,
            max
        ];
        return {
            domain: domain,
            animatable: true
        };
    } else return {
        domain: [],
        animatable: false
    };
}
// packages/ag-charts-community/src/util/time/index.ts
var $d77b025aa58d633c$export$2da9be4cfdb689b1 = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$export$2da9be4cfdb689b1, {
    TimeInterval: ()=>$d77b025aa58d633c$var$TimeInterval,
    day: ()=>$d77b025aa58d633c$var$day,
    friday: ()=>$d77b025aa58d633c$var$friday,
    hour: ()=>$d77b025aa58d633c$var$hour,
    millisecond: ()=>$d77b025aa58d633c$var$millisecond,
    minute: ()=>$d77b025aa58d633c$var$minute,
    monday: ()=>$d77b025aa58d633c$var$monday,
    month: ()=>$d77b025aa58d633c$var$month,
    saturday: ()=>$d77b025aa58d633c$var$saturday,
    second: ()=>$d77b025aa58d633c$var$second,
    sunday: ()=>$d77b025aa58d633c$var$sunday,
    thursday: ()=>$d77b025aa58d633c$var$thursday,
    tuesday: ()=>$d77b025aa58d633c$var$tuesday,
    utcDay: ()=>$d77b025aa58d633c$var$utcDay,
    utcHour: ()=>$d77b025aa58d633c$var$utcHour,
    utcMinute: ()=>$d77b025aa58d633c$var$utcMinute,
    utcMonth: ()=>$d77b025aa58d633c$var$utcMonth,
    utcYear: ()=>$d77b025aa58d633c$var$utcYear,
    wednesday: ()=>$d77b025aa58d633c$var$wednesday,
    year: ()=>$d77b025aa58d633c$var$year
});
// packages/ag-charts-community/src/util/time/duration.ts
var $d77b025aa58d633c$var$durationSecond = 1e3;
var $d77b025aa58d633c$var$durationMinute = $d77b025aa58d633c$var$durationSecond * 60;
var $d77b025aa58d633c$var$durationHour = $d77b025aa58d633c$var$durationMinute * 60;
var $d77b025aa58d633c$var$durationDay = $d77b025aa58d633c$var$durationHour * 24;
var $d77b025aa58d633c$var$durationWeek = $d77b025aa58d633c$var$durationDay * 7;
var $d77b025aa58d633c$var$durationMonth = $d77b025aa58d633c$var$durationDay * 30;
var $d77b025aa58d633c$var$durationYear = $d77b025aa58d633c$var$durationDay * 365;
var $d77b025aa58d633c$var$TimeInterval = class _TimeInterval {
    constructor(unit, milliseconds, hierarchy, _encode, _decode, step = 1, _rangeCallback){
        this.unit = unit;
        this.milliseconds = milliseconds;
        this.hierarchy = hierarchy;
        this._encode = _encode;
        this._decode = _decode;
        this.step = step;
        this._rangeCallback = _rangeCallback;
    }
    static extent(start2, stop, visibleRange) {
        if (start2.getTime() > stop.getTime()) {
            [start2, stop] = [
                stop,
                start2
            ];
            if (visibleRange != null) visibleRange = [
                1 - visibleRange[1],
                1 - visibleRange[0]
            ];
        }
        if (visibleRange != null) {
            const delta3 = stop.getTime() - start2.getTime();
            const t0 = start2.getTime();
            start2 = new Date(t0 + visibleRange[0] * delta3);
            stop = new Date(t0 + visibleRange[1] * delta3);
        }
        return [
            start2,
            stop
        ];
    }
    getOffset(snapTo, step) {
        return Math.floor(this._encode(new Date(snapTo))) % step;
    }
    /**
   * Returns a new date representing the latest interval boundary date before or equal to date.
   * For example, `day.floor(date)` typically returns 12:00 AM local time on the given date.
   * @param date
   */ floor(date6) {
        const d = new Date(date6);
        const e = this._encode(d);
        return this._decode(e);
    }
    /**
   * Returns a new date representing the earliest interval boundary date after or equal to date.
   * @param date
   */ ceil(date6) {
        const d = new Date(Number(date6) - 1);
        const e = this._encode(d);
        return this._decode(e + 1);
    }
    rangeIndices(start2, stop, { extend: extend = false, visibleRange: visibleRange = [
        0,
        1
    ], limit: limit }) {
        [start2, stop] = _TimeInterval.extent(start2, stop, visibleRange);
        const e0 = this._encode(extend ? this.floor(start2) : this.ceil(start2));
        let e1 = this._encode(extend ? this.ceil(stop) : this.floor(stop));
        if (limit != null && e1 - e0 > limit) e1 = e0 + limit;
        return [
            e0,
            e1
        ];
    }
    /**
   * Returns an array of dates representing every interval boundary after or equal to start (inclusive) and before stop (exclusive).
   * @param start Range start.
   * @param stop Range end.
   * @param extend If specified, the requested range will be extended to the closest "nice" values.
   */ range(start2, stop, params = {}) {
        let rangeCallback;
        if (start2.getTime() > stop.getTime()) rangeCallback = this._rangeCallback?.(stop, start2);
        else rangeCallback = this._rangeCallback?.(start2, stop);
        const [e0, e1] = this.rangeIndices(start2, stop, params);
        const range3 = [];
        for(let e = e0; e <= e1; e++){
            const d = this._decode(e);
            range3.push(d);
        }
        rangeCallback?.();
        return range3;
    }
    previous(date6) {
        return this._decode(this._encode(this.ceil(date6)) - 1);
    }
    next(date6) {
        return this._decode(this._encode(this.floor(date6)) + 1);
    }
    rangeCount(start2, stop, params = {}) {
        const [e0, e1] = this.rangeIndices(start2, stop, params);
        return e1 - e0;
    }
    /**
   * Returns a filtered view of this interval representing every step'th date.
   * It can be a number of minutes, hours, days etc.
   * Must be a positive integer.
   * @param step
   */ every(step, options) {
        if (step === 1 && options?.snapTo != null) return this;
        const { unit: unit, milliseconds: milliseconds, hierarchy: hierarchy, step: baseStep } = this;
        let offset4 = 0;
        let rangeCallback;
        const unsafeStep = step;
        step = Math.max(1, Math.round(step));
        if (unsafeStep !== step) (0, $idDdm.Logger).warnOnce(`interval step of [${unsafeStep}] rounded to [${step}].`);
        const { snapTo: snapTo = "start" } = options ?? {};
        if (typeof snapTo === "string") {
            const initialOffset = offset4;
            rangeCallback = (start2, stop)=>{
                const s = snapTo === "start" ? start2 : stop;
                offset4 = this.getOffset(s, step);
                return ()=>offset4 = initialOffset;
            };
        } else if (typeof snapTo === "number") offset4 = this.getOffset(new Date(snapTo), step);
        else if (snapTo instanceof Date) offset4 = this.getOffset(snapTo, step);
        const encode13 = (date6)=>Math.floor((this._encode(date6) - offset4) / step);
        const decode13 = (encoded)=>this._decode(encoded * step + offset4);
        return new _TimeInterval(unit, milliseconds * step, hierarchy, encode13, decode13, baseStep * step, rangeCallback);
    }
};
// packages/ag-charts-community/src/util/time/year.ts
function $d77b025aa58d633c$var$encode(date6) {
    return date6.getFullYear();
}
function $d77b025aa58d633c$var$decode(encoded) {
    const d = /* @__PURE__ */ new Date();
    d.setFullYear(encoded);
    d.setMonth(0, 1);
    d.setHours(0, 0, 0, 0);
    return d;
}
var $d77b025aa58d633c$var$yearMs = (365 + 1 / 4 - 0.01 + 1 / 400) * 86400000;
var $d77b025aa58d633c$var$year = new $d77b025aa58d633c$var$TimeInterval("year", $d77b025aa58d633c$var$yearMs, void 0, $d77b025aa58d633c$var$encode, $d77b025aa58d633c$var$decode);
// packages/ag-charts-community/src/util/time/month.ts
function $d77b025aa58d633c$var$encode2(date6) {
    return date6.getFullYear() * 12 + date6.getMonth();
}
function $d77b025aa58d633c$var$decode2(encoded) {
    const y = Math.floor(encoded / 12);
    const month2 = encoded - y * 12;
    return new Date(y, month2, 1);
}
var $d77b025aa58d633c$var$month = new $d77b025aa58d633c$var$TimeInterval("month", $d77b025aa58d633c$var$year.milliseconds / 12, $d77b025aa58d633c$var$year, $d77b025aa58d633c$var$encode2, $d77b025aa58d633c$var$decode2);
// packages/ag-charts-community/src/util/time/day.ts
function $d77b025aa58d633c$var$encode3(date6) {
    const tzOffsetMs = date6.getTimezoneOffset() * $d77b025aa58d633c$var$durationMinute;
    return Math.floor((date6.getTime() - tzOffsetMs) / $d77b025aa58d633c$var$durationDay);
}
function $d77b025aa58d633c$var$decode3(encoded) {
    const d = new Date(1970, 0, 1);
    d.setDate(d.getDate() + encoded);
    return d;
}
var $d77b025aa58d633c$var$day = new $d77b025aa58d633c$var$TimeInterval("day", 86400000, $d77b025aa58d633c$var$month, $d77b025aa58d633c$var$encode3, $d77b025aa58d633c$var$decode3);
// packages/ag-charts-community/src/util/time/millisecond.ts
function $d77b025aa58d633c$var$encode4(date6) {
    return date6.getTime();
}
function $d77b025aa58d633c$var$decode4(encoded) {
    return new Date(encoded);
}
var $d77b025aa58d633c$var$millisecond = new $d77b025aa58d633c$var$TimeInterval("millisecond", 1, $d77b025aa58d633c$var$day, $d77b025aa58d633c$var$encode4, $d77b025aa58d633c$var$decode4);
// packages/ag-charts-community/src/util/time/second.ts
var $d77b025aa58d633c$var$offset = /* @__PURE__ */ new Date().getTimezoneOffset() * $d77b025aa58d633c$var$durationMinute;
function $d77b025aa58d633c$var$encode5(date6) {
    return Math.floor((date6.getTime() - $d77b025aa58d633c$var$offset) / $d77b025aa58d633c$var$durationSecond);
}
function $d77b025aa58d633c$var$decode5(encoded) {
    return new Date($d77b025aa58d633c$var$offset + encoded * $d77b025aa58d633c$var$durationSecond);
}
var $d77b025aa58d633c$var$second = new $d77b025aa58d633c$var$TimeInterval("second", 1e3, $d77b025aa58d633c$var$day, $d77b025aa58d633c$var$encode5, $d77b025aa58d633c$var$decode5);
// packages/ag-charts-community/src/util/time/minute.ts
var $d77b025aa58d633c$var$offset2 = /* @__PURE__ */ new Date().getTimezoneOffset() * $d77b025aa58d633c$var$durationMinute;
function $d77b025aa58d633c$var$encode6(date6) {
    return Math.floor((date6.getTime() - $d77b025aa58d633c$var$offset2) / $d77b025aa58d633c$var$durationMinute);
}
function $d77b025aa58d633c$var$decode6(encoded) {
    return new Date($d77b025aa58d633c$var$offset2 + encoded * $d77b025aa58d633c$var$durationMinute);
}
var $d77b025aa58d633c$var$minute = new $d77b025aa58d633c$var$TimeInterval("minute", 60000, $d77b025aa58d633c$var$day, $d77b025aa58d633c$var$encode6, $d77b025aa58d633c$var$decode6);
// packages/ag-charts-community/src/util/time/hour.ts
var $d77b025aa58d633c$var$offset3 = /* @__PURE__ */ new Date().getTimezoneOffset() * $d77b025aa58d633c$var$durationMinute;
function $d77b025aa58d633c$var$encode7(date6) {
    return Math.floor((date6.getTime() - $d77b025aa58d633c$var$offset3) / $d77b025aa58d633c$var$durationHour);
}
function $d77b025aa58d633c$var$decode7(encoded) {
    return new Date($d77b025aa58d633c$var$offset3 + encoded * $d77b025aa58d633c$var$durationHour);
}
var $d77b025aa58d633c$var$hour = new $d77b025aa58d633c$var$TimeInterval("hour", 3600000, $d77b025aa58d633c$var$day, $d77b025aa58d633c$var$encode7, $d77b025aa58d633c$var$decode7);
// packages/ag-charts-community/src/util/time/week.ts
function $d77b025aa58d633c$var$weekday(weekStart) {
    const thursday2 = 4;
    const dayShift = (7 + weekStart - thursday2) % 7;
    function encode13(date6) {
        const tzOffsetMs = date6.getTimezoneOffset() * $d77b025aa58d633c$var$durationMinute;
        return Math.floor((date6.getTime() - tzOffsetMs) / $d77b025aa58d633c$var$durationWeek - dayShift / 7);
    }
    function decode13(encoded) {
        const d = new Date(1970, 0, 1);
        d.setDate(d.getDate() + encoded * 7 + dayShift);
        return d;
    }
    return new $d77b025aa58d633c$var$TimeInterval("day", 604800000, $d77b025aa58d633c$var$month, encode13, decode13, 7);
}
var $d77b025aa58d633c$var$sunday = $d77b025aa58d633c$var$weekday(0);
var $d77b025aa58d633c$var$monday = $d77b025aa58d633c$var$weekday(1);
var $d77b025aa58d633c$var$tuesday = $d77b025aa58d633c$var$weekday(2);
var $d77b025aa58d633c$var$wednesday = $d77b025aa58d633c$var$weekday(3);
var $d77b025aa58d633c$var$thursday = $d77b025aa58d633c$var$weekday(4);
var $d77b025aa58d633c$var$friday = $d77b025aa58d633c$var$weekday(5);
var $d77b025aa58d633c$var$saturday = $d77b025aa58d633c$var$weekday(6);
// packages/ag-charts-community/src/util/time/utcYear.ts
function $d77b025aa58d633c$var$encode8(date6) {
    return date6.getUTCFullYear();
}
function $d77b025aa58d633c$var$decode8(encoded) {
    const d = /* @__PURE__ */ new Date();
    d.setUTCFullYear(encoded);
    d.setUTCMonth(0, 1);
    d.setUTCHours(0, 0, 0, 0);
    return d;
}
var $d77b025aa58d633c$var$utcYear = new $d77b025aa58d633c$var$TimeInterval("year", $d77b025aa58d633c$var$year.milliseconds, void 0, $d77b025aa58d633c$var$encode8, $d77b025aa58d633c$var$decode8);
// packages/ag-charts-community/src/util/time/utcMonth.ts
function $d77b025aa58d633c$var$encode9(date6) {
    return date6.getUTCFullYear() * 12 + date6.getUTCMonth();
}
function $d77b025aa58d633c$var$decode9(encoded) {
    const year2 = Math.floor(encoded / 12);
    const m = encoded - year2 * 12;
    return new Date(Date.UTC(year2, m, 1));
}
var $d77b025aa58d633c$var$utcMonth = new $d77b025aa58d633c$var$TimeInterval("month", $d77b025aa58d633c$var$month.milliseconds, $d77b025aa58d633c$var$utcYear, $d77b025aa58d633c$var$encode9, $d77b025aa58d633c$var$decode9);
// packages/ag-charts-community/src/util/time/utcDay.ts
function $d77b025aa58d633c$var$encode10(date6) {
    return Math.floor(date6.getTime() / $d77b025aa58d633c$var$durationDay);
}
function $d77b025aa58d633c$var$decode10(encoded) {
    const d = /* @__PURE__ */ new Date(0);
    d.setUTCDate(d.getUTCDate() + encoded);
    d.setUTCHours(0, 0, 0, 0);
    return d;
}
var $d77b025aa58d633c$var$utcDay = new $d77b025aa58d633c$var$TimeInterval("day", 86400000, $d77b025aa58d633c$var$utcMonth, $d77b025aa58d633c$var$encode10, $d77b025aa58d633c$var$decode10);
// packages/ag-charts-community/src/util/time/utcMinute.ts
function $d77b025aa58d633c$var$encode11(date6) {
    return Math.floor(date6.getTime() / $d77b025aa58d633c$var$durationMinute);
}
function $d77b025aa58d633c$var$decode11(encoded) {
    return new Date(encoded * $d77b025aa58d633c$var$durationMinute);
}
var $d77b025aa58d633c$var$utcMinute = new $d77b025aa58d633c$var$TimeInterval("minute", 60000, $d77b025aa58d633c$var$utcDay, $d77b025aa58d633c$var$encode11, $d77b025aa58d633c$var$decode11);
// packages/ag-charts-community/src/util/time/utcHour.ts
function $d77b025aa58d633c$var$encode12(date6) {
    return Math.floor(date6.getTime() / $d77b025aa58d633c$var$durationHour);
}
function $d77b025aa58d633c$var$decode12(encoded) {
    return new Date(encoded * $d77b025aa58d633c$var$durationHour);
}
var $d77b025aa58d633c$var$utcHour = new $d77b025aa58d633c$var$TimeInterval("hour", 3600000, $d77b025aa58d633c$var$utcDay, $d77b025aa58d633c$var$encode12, $d77b025aa58d633c$var$decode12);
// packages/ag-charts-community/src/util/timeFormat.ts
var $d77b025aa58d633c$var$CONSTANTS = {
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
};
function $d77b025aa58d633c$var$dayOfYear(date6, startOfYear = new Date(date6.getFullYear(), 0, 1)) {
    const startOffset = date6.getTimezoneOffset() - startOfYear.getTimezoneOffset();
    const timeDiff = date6.getTime() - startOfYear.getTime() + startOffset * 6e4;
    const timeOneDay = 36e5 * 24;
    return Math.floor(timeDiff / timeOneDay);
}
function $d77b025aa58d633c$var$weekOfYear(date6, startDay) {
    const startOfYear = new Date(date6.getFullYear(), 0, 1);
    const startOfYearDay = startOfYear.getDay();
    const firstWeekStartOffset = (startDay - startOfYearDay + 7) % 7;
    const startOffset = new Date(date6.getFullYear(), 0, firstWeekStartOffset + 1);
    if (startOffset <= date6) return Math.floor($d77b025aa58d633c$var$dayOfYear(date6, startOffset) / 7) + 1;
    return 0;
}
var $d77b025aa58d633c$var$SUNDAY = 0;
var $d77b025aa58d633c$var$MONDAY = 1;
var $d77b025aa58d633c$var$THURSDAY = 4;
function $d77b025aa58d633c$var$isoWeekOfYear(date6, year2 = date6.getFullYear()) {
    const firstOfYear = new Date(year2, 0, 1);
    const firstOfYearDay = firstOfYear.getDay();
    const firstThursdayOffset = ($d77b025aa58d633c$var$THURSDAY - firstOfYearDay + 7) % 7;
    const startOffset = new Date(year2, 0, firstThursdayOffset - ($d77b025aa58d633c$var$THURSDAY - $d77b025aa58d633c$var$MONDAY) + 1);
    if (startOffset <= date6) return Math.floor($d77b025aa58d633c$var$dayOfYear(date6, startOffset) / 7) + 1;
    return $d77b025aa58d633c$var$isoWeekOfYear(date6, year2 - 1);
}
function $d77b025aa58d633c$var$timezone(date6) {
    const offset4 = date6.getTimezoneOffset();
    const unsignedOffset = Math.abs(offset4);
    const sign = offset4 > 0 ? "-" : "+";
    return `${sign}${$d77b025aa58d633c$var$pad(Math.floor(unsignedOffset / 60), 2, "0")}${$d77b025aa58d633c$var$pad(Math.floor(unsignedOffset % 60), 2, "0")}`;
}
var $d77b025aa58d633c$var$FORMATTERS = {
    a: (d)=>$d77b025aa58d633c$var$CONSTANTS.shortDays[d.getDay()],
    A: (d)=>$d77b025aa58d633c$var$CONSTANTS.days[d.getDay()],
    b: (d)=>$d77b025aa58d633c$var$CONSTANTS.shortMonths[d.getMonth()],
    B: (d)=>$d77b025aa58d633c$var$CONSTANTS.months[d.getMonth()],
    c: "%x, %X",
    d: (d, p)=>$d77b025aa58d633c$var$pad(d.getDate(), 2, p ?? "0"),
    e: "%_d",
    f: (d, p)=>$d77b025aa58d633c$var$pad(d.getMilliseconds() * 1e3, 6, p ?? "0"),
    H: (d, p)=>$d77b025aa58d633c$var$pad(d.getHours(), 2, p ?? "0"),
    I: (d, p)=>{
        const hours = d.getHours() % 12;
        return hours === 0 ? "12" : $d77b025aa58d633c$var$pad(hours, 2, p ?? "0");
    },
    j: (d, p)=>$d77b025aa58d633c$var$pad($d77b025aa58d633c$var$dayOfYear(d) + 1, 3, p ?? "0"),
    m: (d, p)=>$d77b025aa58d633c$var$pad(d.getMonth() + 1, 2, p ?? "0"),
    M: (d, p)=>$d77b025aa58d633c$var$pad(d.getMinutes(), 2, p ?? "0"),
    L: (d, p)=>$d77b025aa58d633c$var$pad(d.getMilliseconds(), 3, p ?? "0"),
    p: (d)=>d.getHours() < 12 ? "AM" : "PM",
    Q: (d)=>String(d.getTime()),
    s: (d)=>String(Math.floor(d.getTime() / 1e3)),
    S: (d, p)=>$d77b025aa58d633c$var$pad(d.getSeconds(), 2, p ?? "0"),
    u: (d)=>{
        let day2 = d.getDay();
        if (day2 < 1) day2 += 7;
        return String(day2 % 7);
    },
    U: (d, p)=>$d77b025aa58d633c$var$pad($d77b025aa58d633c$var$weekOfYear(d, $d77b025aa58d633c$var$SUNDAY), 2, p ?? "0"),
    V: (d, p)=>$d77b025aa58d633c$var$pad($d77b025aa58d633c$var$isoWeekOfYear(d), 2, p ?? "0"),
    w: (d, p)=>$d77b025aa58d633c$var$pad(d.getDay(), 2, p ?? "0"),
    W: (d, p)=>$d77b025aa58d633c$var$pad($d77b025aa58d633c$var$weekOfYear(d, $d77b025aa58d633c$var$MONDAY), 2, p ?? "0"),
    x: "%-m/%-d/%Y",
    X: "%-I:%M:%S %p",
    y: (d, p)=>$d77b025aa58d633c$var$pad(d.getFullYear() % 100, 2, p ?? "0"),
    Y: (d, p)=>$d77b025aa58d633c$var$pad(d.getFullYear(), 4, p ?? "0"),
    Z: (d)=>$d77b025aa58d633c$var$timezone(d),
    "%": ()=>"%"
};
var $d77b025aa58d633c$var$PADS = {
    _: " ",
    "0": "0",
    "-": ""
};
function $d77b025aa58d633c$var$pad(value, size, padChar) {
    const output = String(Math.floor(value));
    if (output.length >= size) return output;
    return `${padChar.repeat(size - output.length)}${output}`;
}
function $d77b025aa58d633c$var$buildFormatter(formatString) {
    const formatParts = [];
    while(formatString.length > 0){
        let nextEscapeIdx = formatString.indexOf("%");
        if (nextEscapeIdx !== 0) {
            const literalPart = nextEscapeIdx > 0 ? formatString.substring(0, nextEscapeIdx) : formatString;
            formatParts.push(literalPart);
        }
        if (nextEscapeIdx < 0) break;
        const maybePadSpecifier = formatString[nextEscapeIdx + 1];
        const maybePad = $d77b025aa58d633c$var$PADS[maybePadSpecifier];
        if (maybePad != null) nextEscapeIdx++;
        const maybeFormatterSpecifier = formatString[nextEscapeIdx + 1];
        const maybeFormatter = $d77b025aa58d633c$var$FORMATTERS[maybeFormatterSpecifier];
        if (typeof maybeFormatter === "function") formatParts.push([
            maybeFormatter,
            maybePad
        ]);
        else if (typeof maybeFormatter === "string") {
            const formatter = $d77b025aa58d633c$var$buildFormatter(maybeFormatter);
            formatParts.push([
                formatter,
                maybePad
            ]);
        } else formatParts.push(`${maybePad ?? ""}${maybeFormatterSpecifier}`);
        formatString = formatString.substring(nextEscapeIdx + 2);
    }
    return (dateTime)=>{
        const dateTimeAsDate = typeof dateTime === "number" ? new Date(dateTime) : dateTime;
        return formatParts.map((c)=>typeof c === "string" ? c : c[0](dateTimeAsDate, c[1])).join("");
    };
}
// packages/ag-charts-community/src/util/timeFormatDefaults.ts
function $d77b025aa58d633c$var$dateToNumber(value) {
    return value instanceof Date ? value.getTime() : value;
}
function $d77b025aa58d633c$var$defaultTimeTickFormat(ticks, domain, formatOffset) {
    const formatString = $d77b025aa58d633c$var$calculateDefaultTimeTickFormat(ticks, domain, formatOffset);
    const formatter = $d77b025aa58d633c$var$buildFormatter(formatString);
    return (date6)=>formatter(date6);
}
function $d77b025aa58d633c$var$calculateDefaultTimeTickFormat(ticks, domain, formatOffset = 0) {
    let minInterval = Infinity;
    for(let i = 1; i < ticks.length; i++)minInterval = Math.min(minInterval, Math.abs(ticks[i].valueOf() - ticks[i - 1].valueOf()));
    const [d0, d1] = domain.length === 0 ? [
        0,
        0
    ] : $d77b025aa58d633c$var$findMinMax([
        domain[0].valueOf(),
        domain[domain.length - 1].valueOf()
    ]);
    const startYear = new Date(d0).getFullYear();
    const stopYear = new Date(d1).getFullYear();
    const yearChange = stopYear - startYear > 0;
    const timeFormat = isFinite(minInterval) ? $d77b025aa58d633c$var$getIntervalLowestGranularityFormat(minInterval, ticks) : $d77b025aa58d633c$var$getLowestGranularityFormat(ticks[0]);
    return $d77b025aa58d633c$var$formatStringBuilder(Math.max(timeFormat - formatOffset, 0), yearChange, ticks);
}
function $d77b025aa58d633c$var$getIntervalLowestGranularityFormat(value, ticks) {
    if (value < $d77b025aa58d633c$var$durationSecond) return 0 /* MILLISECOND */ ;
    else if (value < $d77b025aa58d633c$var$durationMinute) return 1 /* SECOND */ ;
    else if (value < $d77b025aa58d633c$var$durationHour) return 2 /* MINUTE */ ;
    else if (value < $d77b025aa58d633c$var$durationDay) return 3 /* HOUR */ ;
    else if (value < $d77b025aa58d633c$var$durationWeek) return 4 /* WEEK_DAY */ ;
    else if (value < $d77b025aa58d633c$var$durationDay * 28 || value < $d77b025aa58d633c$var$durationDay * 31 && $d77b025aa58d633c$var$hasDuplicateMonth(ticks)) return 5 /* SHORT_MONTH */ ;
    else if (value < $d77b025aa58d633c$var$durationYear) return 6 /* MONTH */ ;
    return 7 /* YEAR */ ;
}
function $d77b025aa58d633c$var$getLowestGranularityFormat(value) {
    if ($d77b025aa58d633c$var$second.floor(value) < value) return 0 /* MILLISECOND */ ;
    else if ($d77b025aa58d633c$var$minute.floor(value) < value) return 1 /* SECOND */ ;
    else if ($d77b025aa58d633c$var$hour.floor(value) < value) return 2 /* MINUTE */ ;
    else if ($d77b025aa58d633c$var$day.floor(value) < value) return 3 /* HOUR */ ;
    else if ($d77b025aa58d633c$var$month.floor(value) < value) {
        if ($d77b025aa58d633c$var$sunday.floor(value) < value) return 4 /* WEEK_DAY */ ;
        return 5 /* SHORT_MONTH */ ;
    } else if ($d77b025aa58d633c$var$year.floor(value) < value) return 6 /* MONTH */ ;
    return 7 /* YEAR */ ;
}
function $d77b025aa58d633c$var$hasDuplicateMonth(ticks) {
    let prevMonth = new Date(ticks[0]).getMonth();
    for(let i = 1; i < ticks.length; i++){
        const tickMonth = new Date(ticks[i]).getMonth();
        if (prevMonth === tickMonth) return true;
        prevMonth = tickMonth;
    }
    return false;
}
function $d77b025aa58d633c$var$formatStringBuilder(defaultTimeFormat, yearChange, ticks) {
    const firstTick = $d77b025aa58d633c$var$dateToNumber(ticks[0]);
    const lastTick = $d77b025aa58d633c$var$dateToNumber(ticks.at(-1));
    const extent2 = Math.abs(lastTick - firstTick);
    const activeYear = yearChange || defaultTimeFormat === 7 /* YEAR */ ;
    const activeDate = extent2 === 0;
    const parts = [
        [
            "hour",
            6 * $d77b025aa58d633c$var$durationHour,
            14 * $d77b025aa58d633c$var$durationDay,
            3 /* HOUR */ ,
            "%I %p"
        ],
        [
            "hour",
            $d77b025aa58d633c$var$durationMinute,
            6 * $d77b025aa58d633c$var$durationHour,
            3 /* HOUR */ ,
            "%I:%M"
        ],
        [
            "second",
            1e3,
            6 * $d77b025aa58d633c$var$durationHour,
            1 /* SECOND */ ,
            ":%S"
        ],
        [
            "ms",
            0,
            6 * $d77b025aa58d633c$var$durationHour,
            0 /* MILLISECOND */ ,
            ".%L"
        ],
        [
            "am/pm",
            $d77b025aa58d633c$var$durationMinute,
            6 * $d77b025aa58d633c$var$durationHour,
            3 /* HOUR */ ,
            "%p"
        ],
        " ",
        [
            "day",
            $d77b025aa58d633c$var$durationDay,
            $d77b025aa58d633c$var$durationWeek,
            4 /* WEEK_DAY */ ,
            "%a"
        ],
        [
            "month",
            activeDate ? 0 : $d77b025aa58d633c$var$durationWeek,
            52 * $d77b025aa58d633c$var$durationWeek,
            5 /* SHORT_MONTH */ ,
            "%b %d"
        ],
        [
            "month",
            5 * $d77b025aa58d633c$var$durationWeek,
            10 * $d77b025aa58d633c$var$durationYear,
            6 /* MONTH */ ,
            "%B"
        ],
        " ",
        [
            "year",
            activeYear ? 0 : $d77b025aa58d633c$var$durationYear,
            Infinity,
            7 /* YEAR */ ,
            "%Y"
        ]
    ];
    const formatParts = parts.filter((v)=>{
        if (typeof v === "string") return true;
        const [_, min, max, format] = v;
        return format >= defaultTimeFormat && min <= extent2 && extent2 < max;
    }).reduce((r, next)=>{
        if (typeof next === "string") r.result.push(next);
        else if (!r.used.has(next[0])) {
            r.result.push(next);
            r.used.add(next[0]);
        }
        return r;
    }, {
        result: [],
        used: /* @__PURE__ */ new Set()
    }).result;
    const firstFormat = formatParts.findIndex((v)=>typeof v !== "string");
    const lastFormat = formatParts.findLastIndex((v)=>typeof v !== "string");
    return formatParts.slice(firstFormat, lastFormat + 1).map((v)=>typeof v === "string" ? v : v[4]).join("").replaceAll(/\s+/g, " ").trim();
}
var $d77b025aa58d633c$var$_BandScale = class _BandScale extends $d77b025aa58d633c$var$AbstractScale {
    constructor(){
        super(...arguments);
        this.invalid = true;
        this.range = [
            0,
            1
        ];
        this.round = false;
        this._bandwidth = 1;
        this._step = 1;
        this._inset = 1;
        this._rawBandwidth = 1;
        /**
     * The ratio of the range that is reserved for space between bands.
     */ this._paddingInner = 0;
        /**
     * The ratio of the range that is reserved for space before the first
     * and after the last band.
     */ this._paddingOuter = 0;
    }
    static is(value) {
        return value instanceof _BandScale;
    }
    get bandwidth() {
        this.refresh();
        return this._bandwidth;
    }
    get step() {
        this.refresh();
        return this._step;
    }
    get inset() {
        this.refresh();
        return this._inset;
    }
    get rawBandwidth() {
        this.refresh();
        return this._rawBandwidth;
    }
    set padding(value) {
        value = (0, $idDdm.clamp)(0, value, 1);
        this._paddingInner = value;
        this._paddingOuter = value;
    }
    get padding() {
        return this._paddingInner;
    }
    set paddingInner(value) {
        this.invalid = true;
        this._paddingInner = (0, $idDdm.clamp)(0, value, 1);
    }
    get paddingInner() {
        return this._paddingInner;
    }
    set paddingOuter(value) {
        this.invalid = true;
        this._paddingOuter = (0, $idDdm.clamp)(0, value, 1);
    }
    get paddingOuter() {
        return this._paddingOuter;
    }
    refresh() {
        if (!this.invalid) return;
        this.invalid = false;
        this.update();
        if (this.invalid) (0, $idDdm.Logger).warnOnce("Expected update to not invalidate scale");
    }
    convert(d, _options) {
        this.refresh();
        const i = this.findIndex(d);
        if (i == null || i < 0 || i >= this.bands.length) return NaN;
        return this.ordinalRange(i);
    }
    invertNearestIndex(position) {
        this.refresh();
        const bandCount = this.bands.length;
        if (bandCount === 0) return -1;
        let low = 0;
        let high = bandCount - 1;
        let closestDistance = Infinity;
        let closestIndex = 0;
        while(low <= high){
            const mid = (high + low) / 2 | 0;
            const p = this.ordinalRange(mid);
            const distance2 = Math.abs(p - position);
            if (distance2 === 0) return mid;
            if (distance2 < closestDistance) {
                closestDistance = distance2;
                closestIndex = mid;
            }
            if (p < position) low = mid + 1;
            else high = mid - 1;
        }
        return closestIndex;
    }
    update() {
        const [r0, r1] = this.range;
        let { _paddingInner: paddingInner } = this;
        const { _paddingOuter: paddingOuter, round: round4, bands: bands } = this;
        const bandCount = bands.length;
        if (bandCount === 0) return;
        const rangeDistance = r1 - r0;
        let rawStep;
        if (bandCount === 1) {
            paddingInner = 0;
            rawStep = rangeDistance * (1 - paddingOuter * 2);
        } else rawStep = rangeDistance / Math.max(1, bandCount - paddingInner + paddingOuter * 2);
        const step = round4 ? Math.floor(rawStep) : rawStep;
        let inset = r0 + (rangeDistance - step * (bandCount - paddingInner)) / 2;
        let bandwidth = step * (1 - paddingInner);
        if (round4) {
            inset = Math.round(inset);
            bandwidth = Math.round(bandwidth);
        }
        this._step = step;
        this._inset = inset;
        this._bandwidth = bandwidth;
        this._rawBandwidth = rawStep * (1 - paddingInner);
    }
    ordinalRange(i) {
        const { _inset: inset, _step: step, range: range3 } = this;
        const min = Math.min(range3[0], range3[1]);
        const max = Math.max(range3[0], range3[1]);
        return (0, $idDdm.clamp)(min, inset + step * i, max);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_BandScale.prototype, "range", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_BandScale.prototype, "round", 2);
var $d77b025aa58d633c$var$BandScale = $d77b025aa58d633c$var$_BandScale;
// packages/ag-charts-community/src/scale/discreteTimeScale.ts
var $d77b025aa58d633c$var$DiscreteTimeScale = class _DiscreteTimeScale extends $d77b025aa58d633c$var$BandScale {
    static is(value) {
        return value instanceof _DiscreteTimeScale;
    }
    toDomain(value) {
        return new Date(value);
    }
    convert(d, options) {
        const { domain: domain, bands: bands } = this;
        if (domain.length <= 0) return NaN;
        const r0 = this.ordinalRange(0);
        const r1 = this.ordinalRange(bands.length - 1);
        const interpolate3 = options?.interpolate ?? false;
        const reversed = domain[0].valueOf() > domain[domain.length - 1].valueOf();
        if (!interpolate3) {
            const r = super.convert(d, options);
            return reversed ? r1 - (r - r0) : r;
        }
        if (bands.length === 0) return r0;
        const v = d.valueOf();
        let domainIndex;
        if (reversed) domainIndex = ((0, $idDdm.findMinIndex)(0, domain.length - 1, (i)=>domain[i].valueOf() <= v) ?? domain.length) - 1;
        else domainIndex = (0, $idDdm.findMaxIndex)(0, domain.length - 1, (i)=>domain[i].valueOf() <= v) ?? 0;
        domainIndex = Math.min(Math.max(domainIndex, 0), domain.length - 2);
        const v0 = domain[domainIndex].valueOf();
        const v1 = domain[domainIndex + 1].valueOf();
        const ratioWithinInterval = (v - v0) / (v1 - v0);
        const ratio11 = (domainIndex + ratioWithinInterval) / (domain.length - 1);
        return ratio11 * (r1 - r0) + r0;
    }
    invert(position, nearest = false) {
        this.refresh();
        const { domain: domain, bands: bands } = this;
        const reversed = domain[0].valueOf() > domain[domain.length - 1].valueOf();
        let index;
        if (nearest) index = this.invertNearestIndex(position - this.bandwidth / 2);
        else {
            const closestIndex = (0, $idDdm.findMinIndex)(0, bands.length - 1, (i)=>{
                const p = this.ordinalRange(i);
                return p >= position;
            });
            index = closestIndex ?? 0;
        }
        return bands[reversed ? bands.length - 1 - index : index];
    }
    /**
   * Returns a time format function suitable for displaying tick values.
   * @param specifier If the specifier string is provided, this method is equivalent to
   * the {@link TimeLocaleObject.format} method.
   * If no specifier is provided, this method returns the default time format function.
   */ tickFormatter({ domain: domain, ticks: ticks, specifier: specifier }, formatOffset) {
        return specifier != null ? $d77b025aa58d633c$var$buildFormatter(specifier) : $d77b025aa58d633c$var$defaultTimeTickFormat(ticks, domain, formatOffset);
    }
};
// packages/ag-charts-community/src/util/vector4.ts
var $d77b025aa58d633c$var$Vec4 = {
    bottomCenter: $d77b025aa58d633c$var$bottomCenter,
    center: $d77b025aa58d633c$var$center,
    clone: $d77b025aa58d633c$var$clone,
    collides: $d77b025aa58d633c$var$collides,
    end: $d77b025aa58d633c$var$end,
    from: $d77b025aa58d633c$var$from,
    height: $d77b025aa58d633c$var$height,
    round: $d77b025aa58d633c$var$round2,
    start: $d77b025aa58d633c$var$start,
    topCenter: $d77b025aa58d633c$var$topCenter,
    origin: $d77b025aa58d633c$var$origin,
    width: $d77b025aa58d633c$var$width
};
function $d77b025aa58d633c$var$start(a) {
    return {
        x: a.x1,
        y: a.y1
    };
}
function $d77b025aa58d633c$var$end(a) {
    return {
        x: a.x2,
        y: a.y2
    };
}
function $d77b025aa58d633c$var$topCenter(a) {
    return {
        x: (a.x1 + a.x2) / 2,
        y: Math.min(a.y1, a.y2)
    };
}
function $d77b025aa58d633c$var$center(a) {
    return {
        x: (a.x1 + a.x2) / 2,
        y: (a.y1 + a.y2) / 2
    };
}
function $d77b025aa58d633c$var$bottomCenter(a) {
    return {
        x: (a.x1 + a.x2) / 2,
        y: Math.max(a.y1, a.y2)
    };
}
function $d77b025aa58d633c$var$width(a) {
    return Math.abs(a.x2 - a.x1);
}
function $d77b025aa58d633c$var$height(a) {
    return Math.abs(a.y2 - a.y1);
}
function $d77b025aa58d633c$var$round2(a) {
    return {
        x1: Math.round(a.x1),
        y1: Math.round(a.y1),
        x2: Math.round(a.x2),
        y2: Math.round(a.y2)
    };
}
function $d77b025aa58d633c$var$clone(a) {
    return {
        x1: a.x1,
        y1: a.y1,
        x2: a.x2,
        y2: a.y2
    };
}
function $d77b025aa58d633c$var$collides(a, b) {
    const an = $d77b025aa58d633c$var$normalise(a);
    const bn = $d77b025aa58d633c$var$normalise(b);
    return an.x1 <= bn.x2 && an.x2 >= bn.x1 && an.y1 <= bn.y2 && an.y2 >= bn.y1;
}
function $d77b025aa58d633c$var$normalise(a) {
    return {
        x1: Math.min(a.x1, a.x2),
        x2: Math.max(a.x1, a.x2),
        y1: Math.min(a.y1, a.y2),
        y2: Math.max(a.y1, a.y2)
    };
}
function $d77b025aa58d633c$var$from(a, b, c, d) {
    if (typeof a === "number") return {
        x1: a,
        y1: b,
        x2: c,
        y2: d
    };
    if ("width" in a) return $d77b025aa58d633c$var$normalise({
        x1: a.x,
        y1: a.y,
        x2: a.x + a.width,
        y2: a.y + a.height
    });
    throw new Error(`Values can not be converted into a vector4: [${JSON.stringify(a)}] [${b}] [${c}] [${d}]`);
}
function $d77b025aa58d633c$var$origin() {
    return {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
    };
}
// packages/ag-charts-community/src/util/panToBBox.ts
function $d77b025aa58d633c$var$normalize2(screenMin, min, screenMax, max, target) {
    return min + (max - min) * ((target - screenMin) / (screenMax - screenMin));
}
function $d77b025aa58d633c$var$unnormalize(screenMin, min, screenMax, max, ratio11) {
    return screenMin + (ratio11 - min) * ((screenMax - screenMin) / (max - min));
}
function $d77b025aa58d633c$var$calcWorldAxis(viewportMin, viewportMax, ratio11) {
    return [
        $d77b025aa58d633c$var$unnormalize(viewportMin, ratio11.min, viewportMax, ratio11.max, 0),
        $d77b025aa58d633c$var$unnormalize(viewportMin, ratio11.min, viewportMax, ratio11.max, 1)
    ];
}
function $d77b025aa58d633c$var$calcWorldVec4(viewport, ratioX, ratioY) {
    const [x1, x2] = $d77b025aa58d633c$var$calcWorldAxis(viewport.x1, viewport.x2, ratioX);
    const [y1, y2] = $d77b025aa58d633c$var$calcWorldAxis(viewport.y1, viewport.y2, ratioY);
    return {
        x1: x1,
        x2: x2,
        y1: y1,
        y2: y2
    };
}
function $d77b025aa58d633c$var$panAxesUnnormalized(worldMin, worldMax, viewportMin, viewportMax, targetMin, targetMax) {
    if (viewportMin <= targetMin && targetMax <= viewportMax) return viewportMin;
    const minDiff = targetMin - viewportMin;
    const maxDiff = targetMax - viewportMax;
    const diff2 = Math.abs(minDiff) < Math.abs(maxDiff) ? minDiff : maxDiff;
    return (0, $idDdm.clamp)(worldMin, viewportMin + diff2, worldMax);
}
function $d77b025aa58d633c$var$calcPanToBBoxRatios(viewportBBox, ratios, targetBBox) {
    const { x: ratioX = {
        min: 0,
        max: 1
    }, y: ratioY = {
        min: 0,
        max: 1
    } } = ratios;
    const target = $d77b025aa58d633c$var$Vec4.from(targetBBox);
    const viewport = $d77b025aa58d633c$var$Vec4.from(viewportBBox);
    const world = $d77b025aa58d633c$var$calcWorldVec4(viewport, ratioX, ratioY);
    const x = $d77b025aa58d633c$var$panAxesUnnormalized(world.x1, world.x2, viewport.x1, viewport.x2, target.x1, target.x2);
    const y = $d77b025aa58d633c$var$panAxesUnnormalized(world.y1, world.y2, viewport.y1, viewport.y2, target.y1, target.y2);
    const result = {
        x: {
            min: $d77b025aa58d633c$var$normalize2(viewport.x1, ratioX.min, viewport.x2, ratioX.max, x),
            max: $d77b025aa58d633c$var$normalize2(viewport.x1, ratioX.min, viewport.x2, ratioX.max, x + viewportBBox.width)
        },
        y: {
            min: $d77b025aa58d633c$var$normalize2(viewport.y1, ratioY.min, viewport.y2, ratioY.max, y),
            max: $d77b025aa58d633c$var$normalize2(viewport.y1, ratioY.min, viewport.y2, ratioY.max, y + viewportBBox.height)
        }
    };
    const diffX = result.x.max - result.x.min;
    const diffY = result.y.max - result.y.min;
    result.x.min = (0, $idDdm.clamp)(0, result.x.min, 1 - diffX);
    result.x.max = result.x.min + diffX;
    result.y.min = (0, $idDdm.clamp)(0, result.y.min, 1 - diffY);
    result.y.max = result.y.min + diffY;
    return result;
}
// packages/ag-charts-community/src/chart/interaction/zoomManager.ts
var $d77b025aa58d633c$var$expectedMementoKeys = [
    "rangeX",
    "rangeY",
    "ratioX",
    "ratioY",
    "autoScaledAxes"
];
var $d77b025aa58d633c$var$ZoomManagerAutoScaleAxis = class {
    constructor(){
        this.enabled = false;
        this.padding = 0;
        this.manuallyAdjusted = false;
    }
};
var $d77b025aa58d633c$var$rangeValidator = (axis)=>(0, $idDdm.attachDescription)((value, { options: options })=>{
        if (!$d77b025aa58d633c$var$ContinuousScale.is(axis?.scale) && !$d77b025aa58d633c$var$DiscreteTimeScale.is(axis?.scale)) return true;
        if (value == null || options.end == null) return true;
        return value <= options.end;
    }, `to be less than end`);
var $d77b025aa58d633c$var$ZoomManager = class extends $d77b025aa58d633c$var$BaseManager {
    constructor(fireChartEvent, layoutManager){
        super();
        this.fireChartEvent = fireChartEvent;
        this.mementoOriginatorKey = "zoom";
        this.axisZoomManagers = /* @__PURE__ */ new Map();
        this.state = new $d77b025aa58d633c$var$StateTracker(void 0, "initial");
        this.axes = [];
        this.didLayoutAxes = false;
        this.autoScaleYAxis = new $d77b025aa58d633c$var$ZoomManagerAutoScaleAxis();
        this.lastRestoredState = void 0;
        this.independentAxes = false;
        this.navigatorModule = false;
        this.zoomModule = false;
        // The initial state memento can not be restored until the chart has performed its first layout. Instead save it as
        // pending and restore then delete it on the first layout.
        this.pendingMemento = void 0;
        this.destroyFns.push(layoutManager.addListener("layout:complete", ()=>{
            const { pendingMemento: pendingMemento } = this;
            const shouldPerformInitialLayout = !this.didLayoutAxes;
            this.didLayoutAxes = true;
            if (pendingMemento) this.restoreMemento(pendingMemento.version, pendingMemento.mementoVersion, pendingMemento.memento);
            else if (shouldPerformInitialLayout) this.autoScaleYZoom("zoom-manager");
        }));
    }
    createMemento() {
        return this.getMementoRanges();
    }
    guardMemento(blob, messages) {
        if (blob == null) return true;
        if (!(0, $idDdm.isObject)(blob)) return false;
        for (const key of Object.keys(blob)){
            if (!$d77b025aa58d633c$var$expectedMementoKeys.includes(key)) return false;
        }
        const primaryX = this.getPrimaryAxis("x" /* X */ );
        const primaryY = this.getPrimaryAxis("y" /* Y */ );
        const zoomMementoDefs = {
            rangeX: {
                start: (0, $idDdm.and)((0, $idDdm.or)((0, $idDdm.number), (0, $idDdm.date)), $d77b025aa58d633c$var$rangeValidator(primaryX)),
                end: (0, $idDdm.or)((0, $idDdm.number), (0, $idDdm.date))
            },
            rangeY: {
                start: (0, $idDdm.and)((0, $idDdm.or)((0, $idDdm.number), (0, $idDdm.date)), $d77b025aa58d633c$var$rangeValidator(primaryY)),
                end: (0, $idDdm.or)((0, $idDdm.number), (0, $idDdm.date))
            },
            ratioX: {
                start: (0, $idDdm.and)((0, $idDdm.ratio), (0, $idDdm.lessThan)("end")),
                end: (0, $idDdm.ratio)
            },
            ratioY: {
                start: (0, $idDdm.and)((0, $idDdm.ratio), (0, $idDdm.lessThan)("end")),
                end: (0, $idDdm.ratio)
            },
            autoScaledAxes: (0, $idDdm.arrayOf)((0, $idDdm.union)("y"))
        };
        const { invalid: invalid } = (0, $idDdm.validate)(blob, zoomMementoDefs);
        if (invalid.length > 0) {
            messages.push(...invalid.map(String));
            return false;
        }
        return true;
    }
    restoreMemento(version, mementoVersion, memento) {
        const { independentAxes: independentAxes } = this;
        if (!this.axes || !this.didLayoutAxes) {
            this.pendingMemento = {
                version: version,
                mementoVersion: mementoVersion,
                memento: memento
            };
            return;
        }
        this.pendingMemento = void 0;
        const zoom = this.getDefinedZoom();
        if (memento?.rangeX) zoom.x = this.rangeToRatio(memento.rangeX, "x" /* X */ ) ?? {
            min: 0,
            max: 1
        };
        else if (memento?.ratioX) zoom.x = {
            min: memento.ratioX.start ?? 0,
            max: memento.ratioX.end ?? 1
        };
        else zoom.x = {
            min: 0,
            max: 1
        };
        if (!this.navigatorModule || this.zoomModule) {
            let yAutoScale = memento?.autoScaledAxes?.includes("y");
            if (memento?.rangeY) {
                zoom.y = this.rangeToRatio(memento.rangeY, "y" /* Y */ ) ?? {
                    min: 0,
                    max: 1
                };
                yAutoScale ?? (yAutoScale = false);
            } else if (memento?.ratioY) {
                zoom.y = {
                    min: memento.ratioY.start ?? 0,
                    max: memento.ratioY.end ?? 1
                };
                yAutoScale ?? (yAutoScale = false);
            } else {
                zoom.y = {
                    min: 0,
                    max: 1
                };
                yAutoScale ?? (yAutoScale = true);
            }
            zoom.autoScaleYAxis = yAutoScale;
        }
        this.lastRestoredState = zoom;
        if (independentAxes !== true) {
            this.updateZoom("zoom-manager", zoom);
            return;
        }
        const primaryX = this.getPrimaryAxis("x" /* X */ );
        const primaryY = this.getPrimaryAxis("y" /* Y */ );
        for (const axis of [
            primaryX,
            primaryY
        ]){
            if (!axis) continue;
            this.updateAxisZoom("zoom-manager", axis.id, zoom[axis.direction]);
        }
    }
    updateAxes(axes) {
        this.axes = axes;
        const zoomManagers = new Map(axes.map((axis)=>[
                axis.id,
                this.axisZoomManagers.get(axis.id)
            ]));
        this.axisZoomManagers.clear();
        for (const axis of axes)this.axisZoomManagers.set(axis.id, zoomManagers.get(axis.id) ?? new $d77b025aa58d633c$var$AxisZoomManager(axis));
        if (this.state.size > 0 && axes.length > 0) this.updateZoom(this.state.stateId(), this.state.stateValue());
    }
    setIndependentAxes(independent = true) {
        this.independentAxes = independent;
    }
    setAutoScaleYAxis(enabled, padding) {
        this.autoScaleYAxis.enabled = enabled;
        this.autoScaleYAxis.padding = padding;
    }
    setNavigatorEnabled(enabled = true) {
        this.navigatorModule = enabled;
    }
    setZoomModuleEnabled(enabled = true) {
        this.zoomModule = enabled;
    }
    isNavigatorEnabled() {
        return this.navigatorModule;
    }
    isZoomEnabled() {
        return this.zoomModule;
    }
    updateZoom(callerId, newZoom) {
        if (newZoom?.x && (newZoom.x.min < 0 || newZoom.x.max > 1)) {
            (0, $idDdm.Logger).warnOnce(`Attempted to update x-axis zoom to an invalid ratio of [{ min: ${newZoom.x.min}, max: ${newZoom.x.max} }], expecting a ratio of 0 to 1, ignoring.`);
            newZoom.x = void 0;
        }
        if (newZoom?.y && (newZoom.y.min < 0 || newZoom.y.max > 1)) {
            (0, $idDdm.Logger).warnOnce(`Attempted to update y-axis zoom to an invalid ratio of [{ min: ${newZoom.y.min}, max: ${newZoom.y.max} }], expecting a ratio of 0 to 1, ignoring.`);
            newZoom.y = void 0;
        }
        if (this.axisZoomManagers.size === 0) {
            const stateId = this.state.stateId();
            if (stateId === "initial" || stateId === callerId) this.state.set(callerId, newZoom);
            return;
        }
        this.state.set(callerId, newZoom);
        const autoScaleYAxis = newZoom?.autoScaleYAxis;
        if (autoScaleYAxis != null) this.autoScaleYAxis.manuallyAdjusted = !autoScaleYAxis;
        this.axisZoomManagers.forEach((axis)=>{
            axis.updateZoom(callerId, newZoom?.[axis.getDirection()]);
        });
        this.applyChanges(callerId);
    }
    updateAxisZoom(callerId, axisId, newZoom) {
        this.axisZoomManagers.get(axisId)?.updateZoom(callerId, newZoom);
        this.applyChanges(callerId);
    }
    resetZoom(callerId) {
        this.autoScaleYAxis.manuallyAdjusted = false;
        const zoom = this.getRestoredZoom();
        this.updateZoom(callerId, {
            x: {
                min: zoom?.x?.min ?? 0,
                max: zoom?.x?.max ?? 1
            },
            y: {
                min: zoom?.y?.min ?? 0,
                max: zoom?.y?.max ?? 1
            },
            autoScaleYAxis: zoom?.autoScaleYAxis ?? true
        });
    }
    resetAxisZoom(callerId, axisId) {
        const axisZoomManager = this.axisZoomManagers.get(axisId);
        const direction = axisZoomManager?.getDirection();
        if (direction == null) return;
        const restoredZoom = this.getRestoredZoom();
        if (direction === "y" /* Y */ ) {
            const autoScaleYAxis = restoredZoom?.autoScaleYAxis ?? true;
            this.autoScaleYAxis.manuallyAdjusted = !autoScaleYAxis;
        }
        for (const axis of this.axes){
            if (axis.direction !== direction) continue;
            this.updateAxisZoom(callerId, axis.id, restoredZoom?.[direction] ?? {
                min: 0,
                max: 1
            });
        }
    }
    setAxisManuallyAdjusted(_callerId, axisId) {
        const direction = this.axisZoomManagers.get(axisId)?.getDirection();
        if (direction !== "y" /* Y */ ) return;
        this.autoScaleYAxis.manuallyAdjusted = true;
    }
    updatePrimaryAxisZoom(callerId, direction, newZoom) {
        const primaryAxis = this.getPrimaryAxis(direction);
        if (!primaryAxis) return;
        this.updateAxisZoom(callerId, primaryAxis.id, newZoom);
    }
    panToBBox(callerId, seriesRect, target) {
        if (!this.isZoomEnabled() && !this.isNavigatorEnabled()) return false;
        const zoom = this.getZoom();
        if (zoom === void 0 || !zoom.x && !zoom.y) return false;
        const panIsPossible = seriesRect.width > 0 && seriesRect.height > 0 && Math.abs(target.width) <= Math.abs(seriesRect.width) && Math.abs(target.height) <= Math.abs(seriesRect.height);
        if (!panIsPossible) {
            (0, $idDdm.Logger).warnOnce(`cannot pan to target BBox - chart too small?`);
            return false;
        }
        const newZoom = $d77b025aa58d633c$var$calcPanToBBoxRatios(seriesRect, zoom, target);
        if (this.independentAxes) {
            this.updatePrimaryAxisZoom(callerId, "x" /* X */ , newZoom.x);
            this.updatePrimaryAxisZoom(callerId, "y" /* Y */ , newZoom.y);
        } else this.updateZoom(callerId, newZoom);
        return true;
    }
    // Fire this event to signal to listeners that the view is changing through a zoom and/or pan change.
    fireZoomPanStartEvent(callerId) {
        this.listeners.dispatch("zoom-pan-start", {
            type: "zoom-pan-start",
            callerId: callerId
        });
    }
    extendToEnd(callerId, direction, extent2) {
        return this.extendWith(callerId, direction, (end2)=>Number(end2) - extent2);
    }
    extendWith(callerId, direction, fn) {
        const axis = this.getPrimaryAxis(direction);
        if (!axis) return;
        const extents = this.getDomainExtents(axis);
        if (!extents) return;
        const [, end2] = extents;
        const start2 = fn(end2);
        const ratio11 = this.rangeToRatio({
            start: start2,
            end: end2
        }, direction);
        if (!ratio11) return;
        this.updateZoom(callerId, {
            [direction]: ratio11
        });
    }
    updateWith(callerId, direction, fn) {
        const axis = this.getPrimaryAxis(direction);
        if (!axis) return;
        const extents = this.getDomainExtents(axis);
        if (!extents) return;
        let [start2, end2] = extents;
        [start2, end2] = fn(start2, end2);
        const ratio11 = this.rangeToRatio({
            start: start2,
            end: end2
        }, direction);
        if (!ratio11) return;
        this.updateZoom(callerId, {
            [direction]: ratio11
        });
    }
    getZoom() {
        let x;
        let y;
        this.axisZoomManagers.forEach((axis)=>{
            if (axis.getDirection() === "x" /* X */ ) x ?? (x = axis.getZoom());
            else if (axis.getDirection() === "y" /* Y */ ) y ?? (y = axis.getZoom());
        });
        if (x || y) return {
            x: x,
            y: y
        };
    }
    getAxisZoom(axisId) {
        return this.axisZoomManagers.get(axisId)?.getZoom() ?? {
            min: 0,
            max: 1
        };
    }
    getAxisZooms() {
        const axes = {};
        for (const [axisId, axis] of this.axisZoomManagers.entries())axes[axisId] = {
            direction: axis.getDirection(),
            zoom: axis.getZoom()
        };
        return axes;
    }
    getRestoredZoom() {
        return this.lastRestoredState;
    }
    getPrimaryAxisId(direction) {
        return this.getPrimaryAxis(direction)?.id;
    }
    isVisibleItemsCountAtLeast(zoom, minVisibleItems) {
        const xAxis = this.getPrimaryAxis("x" /* X */ );
        const yAxis = this.getPrimaryAxis("y" /* Y */ );
        const processedSeriesIds = /* @__PURE__ */ new Set();
        let visibleItemsCount = 0;
        const xVisibleRange = [
            zoom.x.min,
            zoom.x.max
        ];
        const yVisibleRange = [
            zoom.y.min,
            zoom.y.max
        ];
        for (const series of xAxis?.boundSeries ?? []){
            processedSeriesIds.add(series.id);
            const remainingItems = minVisibleItems - (visibleItemsCount ?? 0);
            const seriesVisibleItems = series.getVisibleItems(xVisibleRange, yVisibleRange, remainingItems);
            visibleItemsCount += seriesVisibleItems;
            if (visibleItemsCount >= minVisibleItems) return true;
        }
        for (const series of yAxis?.boundSeries ?? []){
            if (processedSeriesIds.has(series.id)) continue;
            const remainingItems = minVisibleItems - (visibleItemsCount ?? 0);
            const seriesVisibleItems = series.getVisibleItems(xVisibleRange, yVisibleRange, remainingItems);
            visibleItemsCount += seriesVisibleItems;
            if (visibleItemsCount >= minVisibleItems) return true;
        }
        return processedSeriesIds.size === 0;
    }
    getMementoRanges() {
        const zoom = this.getDefinedZoom();
        let autoScaledAxes;
        if (this.autoScaleYAxis.enabled) autoScaledAxes = this.autoScaleYAxis.manuallyAdjusted ? [] : [
            "y"
        ];
        const memento = {
            rangeX: this.getRangeDirection(zoom.x, "x" /* X */ ),
            rangeY: this.getRangeDirection(zoom.y, "y" /* Y */ ),
            ratioX: {
                start: zoom.x.min,
                end: zoom.x.max
            },
            ratioY: {
                start: zoom.y.min,
                end: zoom.y.max
            },
            autoScaledAxes: autoScaledAxes
        };
        return memento;
    }
    autoScaleYZoom(callerId, applyChanges = true) {
        if (!this.isZoomEnabled()) return;
        const { independentAxes: independentAxes, autoScaleYAxis: autoScaleYAxis } = this;
        const zoom = this.getZoom();
        if (zoom?.x == null || !autoScaleYAxis.enabled || autoScaleYAxis.manuallyAdjusted) return;
        const { padding: padding } = autoScaleYAxis;
        let zoomY;
        if (zoom.x?.min === 0 && zoom.x?.max === 1) zoomY = {
            min: 0,
            max: 1
        };
        else if (independentAxes) zoomY = this.primaryAxisZoom("y" /* Y */ , zoom.x, {
            padding: padding
        });
        else zoomY = this.combinedAxisZoom("y" /* Y */ , zoom.x, {
            padding: padding
        });
        if (zoomY == null) return;
        if (independentAxes) {
            const primaryAxis = this.getPrimaryAxis("y" /* Y */ );
            const primaryAxisManager = primaryAxis == null ? void 0 : this.axisZoomManagers.get(primaryAxis.id);
            primaryAxisManager?.updateZoom("zoom-manager", zoomY);
        } else {
            for (const axisZoomManager of this.axisZoomManagers.values())if (axisZoomManager.getDirection() === "y" /* Y */ ) axisZoomManager.updateZoom("zoom-manager", zoomY);
        }
        if (applyChanges) this.applyChanges(callerId);
    }
    applyChanges(callerId) {
        this.autoScaleYZoom(callerId, false);
        const changed = Array.from(this.axisZoomManagers.values(), (axis)=>axis.applyChanges()).includes(true);
        if (!changed) return;
        const axes = {};
        for (const [axisId, axis] of this.axisZoomManagers.entries())axes[axisId] = axis.getZoom();
        this.listeners.dispatch("zoom-change", {
            type: "zoom-change",
            ...this.getZoom(),
            axes: axes,
            callerId: callerId
        });
        this.fireChartEvent({
            type: "zoom",
            ...this.getMementoRanges()
        });
    }
    getRangeDirection(ratio11, direction) {
        const axis = this.getPrimaryAxis(direction);
        if (!axis || !$d77b025aa58d633c$var$ContinuousScale.is(axis.scale) && !$d77b025aa58d633c$var$DiscreteTimeScale.is(axis.scale)) return;
        const extents = this.getDomainPixelExtents(axis);
        if (!extents) return;
        const [d0, d1] = extents;
        let start2;
        let end2;
        if (d0 <= d1) {
            start2 = axis.scale.invert(0);
            end2 = axis.scale.invert(d0 + (d1 - d0) * ratio11.max);
        } else {
            start2 = axis.scale.invert(d0 - (d0 - d1) * ratio11.min);
            end2 = axis.scale.invert(0);
        }
        return {
            start: start2,
            end: end2
        };
    }
    rangeToRatio(range3, direction) {
        const axis = this.getPrimaryAxis(direction);
        if (!axis) return;
        const extents = this.getDomainPixelExtents(axis);
        if (!extents) return;
        const [d0, d1] = extents;
        let r0 = range3.start == null ? d0 : axis.scale.convert?.(range3.start);
        let r1 = range3.end == null ? d1 : axis.scale.convert?.(range3.end);
        if (!(0, $idDdm.isFiniteNumber)(r0) || !(0, $idDdm.isFiniteNumber)(r1)) return;
        const [dMin, dMax] = [
            Math.min(d0, d1),
            Math.max(d0, d1)
        ];
        if (r0 < dMin || r0 > dMax) {
            (0, $idDdm.Logger).warnOnce(`Invalid range start [${range3.start}], expecting a value between [${axis.scale.invert?.(d0)}] and [${axis.scale.invert?.(d1)}], ignoring.`);
            return;
        }
        if (r1 < dMin || r1 > dMax) {
            (0, $idDdm.Logger).warnOnce(`Invalid range end [${range3.end}], expecting a value between [${axis.scale.invert?.(d0)}] and [${axis.scale.invert?.(d1)}], ignoring.`);
            return;
        }
        r0 = Math.min(dMax, Math.max(dMin, r0));
        r1 = Math.min(dMax, Math.max(dMin, r1));
        const diff2 = d1 - d0;
        const min = Math.abs((r0 - d0) / diff2);
        const max = Math.abs((r1 - d0) / diff2);
        return {
            min: min,
            max: max
        };
    }
    getPrimaryAxis(direction) {
        return this.axes?.find((a)=>a.direction === direction);
    }
    getDomainExtents(axis) {
        const { domain: domain } = axis.scale;
        const d0 = domain.at(0);
        const d1 = domain.at(-1);
        if (d0 == null || d1 == null) return;
        return [
            d0,
            d1
        ];
    }
    getDomainPixelExtents(axis) {
        const { domain: domain } = axis.scale;
        const d0 = axis.scale.convert?.(domain.at(0));
        const d1 = axis.scale.convert?.(domain.at(-1));
        if (!(0, $idDdm.isFiniteNumber)(d0) || !(0, $idDdm.isFiniteNumber)(d1)) return;
        return [
            d0,
            d1
        ];
    }
    getDefinedZoom() {
        const zoom = this.getZoom();
        return {
            x: {
                min: zoom?.x?.min ?? 0,
                max: zoom?.x?.max ?? 1
            },
            y: {
                min: zoom?.y?.min ?? 0,
                max: zoom?.y?.max ?? 1
            }
        };
    }
    zoomBounds(xAxis, yAxis, zoom, padding) {
        const xScale = xAxis.scale;
        const xScaleRange = xScale.range;
        xScale.range = [
            0,
            1
        ];
        const yScale = yAxis.scale;
        const yScaleRange = yScale.range;
        yScale.range = [
            0,
            1
        ];
        let min = 1;
        let minPadding = false;
        let max = 0;
        let maxPadding = false;
        for (const series of yAxis.boundSeries){
            const { connectsToYAxis: connectsToYAxis } = series;
            const yValues = series.getRange("y" /* Y */ , [
                zoom.min,
                zoom.max
            ]);
            for (const yValue of yValues){
                const y = yScale.convert(yValue);
                if (!Number.isFinite(y)) continue;
                if (y < min) {
                    min = y;
                    minPadding = !connectsToYAxis || yValue < 0;
                }
                if (y > max) {
                    max = y;
                    maxPadding = !connectsToYAxis || yValue > 0;
                }
            }
        }
        if ((0, $idDdm.isFiniteNumber)(yAxis.min)) min = 0;
        if ((0, $idDdm.isFiniteNumber)(yAxis.max)) max = 1;
        xScale.range = xScaleRange;
        yScale.range = yScaleRange;
        if (min >= max) return;
        const totalPadding = (minPadding ? padding : 0) + (maxPadding ? padding : 0);
        const paddedDelta = Math.min((max - min) * (1 + totalPadding), 1);
        if (paddedDelta <= 0) return;
        if (minPadding && maxPadding) {
            const mid = (max + min) / 2;
            min = mid - paddedDelta / 2;
            max = mid + paddedDelta / 2;
        } else if (!minPadding && maxPadding) max = min + paddedDelta;
        else if (minPadding && !maxPadding) min = max - paddedDelta;
        if (min < 0) {
            max += -min;
            min = 0;
        } else if (max > 1) {
            min -= max - 1;
            max = 1;
        }
        return {
            min: min,
            max: max
        };
    }
    primaryAxisZoom(direction, zoom, { padding: padding = 0 } = {}) {
        const crossDirection = direction === "x" /* X */  ? "y" /* Y */  : "x" /* X */ ;
        const xAxis = this.getPrimaryAxis(crossDirection);
        const yAxis = this.getPrimaryAxis(direction);
        if (xAxis == null || yAxis == null) return;
        return this.zoomBounds(xAxis, yAxis, zoom, padding);
    }
    combinedAxisZoom(direction, zoom, { padding: padding = 0 } = {}) {
        const crossDirection = direction === "x" /* X */  ? "y" /* Y */  : "x" /* X */ ;
        const seriesXAxes = /* @__PURE__ */ new Map();
        for (const xAxis of this.axes){
            if (xAxis.direction !== crossDirection) continue;
            for (const series of xAxis.boundSeries)seriesXAxes.set(series, xAxis);
        }
        let min = 1;
        let max = 0;
        for (const yAxis of this.axes){
            if (yAxis.direction !== direction) continue;
            for (const series of yAxis.boundSeries){
                const xAxis = seriesXAxes.get(series);
                if (xAxis == null) continue;
                const bounds = this.zoomBounds(xAxis, yAxis, zoom, padding);
                if (bounds == null) return;
                min = Math.min(min, bounds.min);
                max = Math.max(max, bounds.max);
            }
        }
        const delta3 = 1e-6;
        if (min < delta3) min = 0;
        if (max > 1 - delta3) max = 1;
        if (min > max) return;
        return {
            min: min,
            max: max
        };
    }
};
var $d77b025aa58d633c$var$AxisZoomManager = class {
    constructor(axis){
        this.axis = axis;
        const [min = 0, max = 1] = axis.visibleRange;
        this.state = new $d77b025aa58d633c$var$StateTracker({
            min: min,
            max: max
        });
        this.currentZoom = this.state.stateValue();
    }
    getDirection() {
        return this.axis.direction;
    }
    updateZoom(callerId, newZoom) {
        this.state.set(callerId, newZoom);
    }
    getZoom() {
        return $d77b025aa58d633c$var$deepClone(this.state.stateValue());
    }
    hasChanges() {
        const currentZoom = this.currentZoom;
        const pendingZoom = this.state.stateValue();
        return currentZoom.min !== pendingZoom.min || currentZoom.max !== pendingZoom.max;
    }
    applyChanges() {
        const hasChanges = this.hasChanges();
        this.currentZoom = this.state.stateValue();
        return hasChanges;
    }
};
// packages/ag-charts-community/src/scene/util/labelPlacement.ts
function $d77b025aa58d633c$var$circleRectOverlap(c, unitCenter, x, y, w, h) {
    if (c.size === 0) return false;
    let cx = c.x;
    let cy = c.y;
    if (unitCenter != null) {
        cx -= (unitCenter.x - 0.5) * c.size;
        cy -= (unitCenter.y - 0.5) * c.size;
    }
    let edgeX = cx;
    if (cx < x) edgeX = x;
    else if (cx > x + w) edgeX = x + w;
    let edgeY = cy;
    if (cy < y) edgeY = y;
    else if (cy > y + h) edgeY = y + h;
    const dx = cx - edgeX;
    const dy = cy - edgeY;
    const d = Math.sqrt(dx * dx + dy * dy);
    return d <= c.size * 0.5;
}
function $d77b025aa58d633c$var$rectRectOverlap(r1, x2, y2, w2, h2) {
    const xOverlap = r1.x + r1.width > x2 && r1.x < x2 + w2;
    const yOverlap = r1.y + r1.height > y2 && r1.y < y2 + h2;
    return xOverlap && yOverlap;
}
function $d77b025aa58d633c$var$rectContainsRect(r1, r2x, r2y, r2w, r2h) {
    return r2x + r2w < r1.x + r1.width && r2x > r1.x && r2y > r1.y && r2y + r2h < r1.y + r1.height;
}
function $d77b025aa58d633c$var$isPointLabelDatum(x) {
    return x != null && typeof x.point === "object" && typeof x.label === "object";
}
var $d77b025aa58d633c$var$labelPlacements = {
    top: {
        x: 0,
        y: -1
    },
    bottom: {
        x: 0,
        y: 1
    },
    left: {
        x: -1,
        y: 0
    },
    right: {
        x: 1,
        y: 0
    },
    "top-left": {
        x: -1,
        y: -1
    },
    "top-right": {
        x: 1,
        y: -1
    },
    "bottom-left": {
        x: -1,
        y: 1
    },
    "bottom-right": {
        x: 1,
        y: 1
    }
};
function $d77b025aa58d633c$var$placeLabels(data, bounds, padding = 5) {
    const result = /* @__PURE__ */ new Map();
    const previousResults = [];
    const sortedDataClone = new Map([
        ...data.entries()
    ].map(([k, d])=>[
            k,
            d.toSorted((a, b)=>b.point.size - a.point.size)
        ]));
    const dataValues = [
        ...sortedDataClone.values()
    ].flat();
    for (const [seriesId, datums] of sortedDataClone.entries()){
        const labels = [];
        if (!datums[0]?.label) continue;
        for(let index = 0, ln = datums.length; index < ln; index++){
            const d = datums[index];
            const { point: point, label: label, anchor: anchor } = d;
            const { text: text, width: width2, height: height2 } = label;
            const r = point.size * 0.5;
            let dx = 0;
            let dy = 0;
            if (r > 0 && d.placement != null) {
                const placement = $d77b025aa58d633c$var$labelPlacements[d.placement];
                dx = (width2 * 0.5 + r + padding) * placement.x;
                dy = (height2 * 0.5 + r + padding) * placement.y;
            }
            const x = point.x - width2 * 0.5 + dx - ((anchor?.x ?? 0.5) - 0.5) * point.size;
            const y = point.y - height2 * 0.5 + dy - ((anchor?.y ?? 0.5) - 0.5) * point.size;
            const withinBounds = !bounds || $d77b025aa58d633c$var$rectContainsRect(bounds, x, y, width2, height2);
            if (!withinBounds) continue;
            const overlapPoints = dataValues.some((dataDatum)=>$d77b025aa58d633c$var$circleRectOverlap(dataDatum.point, dataDatum.anchor, x, y, width2, height2));
            if (overlapPoints) continue;
            const overlapLabels = previousResults.some((pr)=>$d77b025aa58d633c$var$rectRectOverlap(pr, x, y, width2, height2));
            if (overlapLabels) continue;
            const resultDatum = {
                index: index,
                text: text,
                x: x,
                y: y,
                width: width2,
                height: height2,
                datum: d
            };
            labels.push(resultDatum);
            previousResults.push(resultDatum);
        }
        result.set(seriesId, labels);
    }
    return result;
}
function $d77b025aa58d633c$var$axisLabelsOverlap(data, padding = 0) {
    const result = [];
    for(let index = 0; index < data.length; index++){
        const datum = data[index];
        const { point: { x: x, y: y }, label: { text: text } } = datum;
        let { width: width2, height: height2 } = datum.label;
        width2 += padding;
        height2 += padding;
        if (result.some((l)=>$d77b025aa58d633c$var$rectRectOverlap(l, x, y, width2, height2))) return true;
        result.push({
            index: index,
            text: text,
            x: x,
            y: y,
            width: width2,
            height: height2,
            datum: datum
        });
    }
    return false;
}
// packages/ag-charts-community/src/chart/layout/seriesLabelLayoutManager.ts
var $d77b025aa58d633c$var$SeriesLabelLayoutManager = class {
    constructor(){
        this.labelData = /* @__PURE__ */ new Map();
    }
    updateLabels(placedLabelSeries, padding, seriesRect = $d77b025aa58d633c$var$BBox.zero) {
        const bounds = {
            x: -padding.left,
            y: -padding.top,
            width: seriesRect.width + padding.left + padding.right,
            height: seriesRect.height + padding.top + padding.bottom
        };
        const expectedSeriesId = new Set(placedLabelSeries.map((s)=>s.id));
        for (const seriesId of this.labelData.keys())if (!expectedSeriesId.has(seriesId)) this.labelData.delete(seriesId);
        for (const series of placedLabelSeries){
            const labelData = series.getLabelData();
            if (labelData.every($d77b025aa58d633c$var$isPointLabelDatum)) this.labelData.set(series.id, labelData);
        }
        const placedLabels = $d77b025aa58d633c$var$placeLabels(this.labelData, bounds, 5);
        for (const series of placedLabelSeries)series.updatePlacedLabelData?.(placedLabels.get(series.id) ?? []);
    }
};
var $d77b025aa58d633c$var$LegendManager = class extends $d77b025aa58d633c$var$BaseManager {
    constructor(){
        super(...arguments);
        this.mementoOriginatorKey = "legend";
        this.legendDataMap = /* @__PURE__ */ new Map();
    }
    createMemento() {
        return this.getData().filter(({ hideInLegend: hideInLegend, isFixed: isFixed })=>!hideInLegend && !isFixed).map(({ enabled: enabled, seriesId: seriesId, itemId: itemId, legendItemName: legendItemName })=>({
                visible: enabled,
                seriesId: seriesId,
                itemId: itemId,
                legendItemName: legendItemName
            }));
    }
    guardMemento(blob) {
        return blob == null || (0, $idDdm.isArray)(blob);
    }
    restoreMemento(_version, _mementoVersion, memento) {
        memento?.forEach((datum)=>{
            const { seriesId: seriesId, data: data } = this.getRestoredData(datum) ?? {};
            if (!seriesId || !data) return;
            this.updateData(seriesId, data);
        });
        this.update();
    }
    getRestoredData(datum) {
        const { seriesId: seriesId, itemId: itemId, legendItemName: legendItemName, visible: visible } = datum;
        if (seriesId) {
            const legendData = this.legendDataMap.get(seriesId) ?? [];
            const data = legendData.map((d)=>{
                const match = d.seriesId === seriesId && (!itemId || d.itemId === itemId);
                if (match && d.isFixed) this.warnFixed(d.seriesId, d.itemId);
                return !d.isFixed && match ? {
                    ...d,
                    enabled: visible
                } : d;
            });
            return {
                seriesId: seriesId,
                data: data
            };
        }
        if (itemId == null && legendItemName == null) return;
        for (const legendDatum of this.getData()){
            if (itemId != null && legendDatum.itemId !== itemId || legendItemName != null && legendDatum.legendItemName !== legendItemName) continue;
            if (legendDatum.isFixed) {
                this.warnFixed(legendDatum.seriesId, itemId);
                return;
            }
            const seriesLegendData = (this.legendDataMap.get(legendDatum.seriesId) ?? []).map((d)=>d.itemId === itemId || d.legendItemName === legendItemName ? {
                    ...d,
                    enabled: visible
                } : d);
            return {
                seriesId: legendDatum.seriesId,
                data: seriesLegendData
            };
        }
    }
    warnFixed(seriesId, itemId) {
        (0, $idDdm.Logger).warnOnce(`The legend item with seriesId [${seriesId}] and itemId [${itemId}] is not configurable, this series item cannot be toggled through the legend.`);
    }
    update(data) {
        this.listeners.dispatch("legend-change", {
            type: "legend-change",
            legendData: data ?? this.getData()
        });
    }
    updateData(seriesId, data = []) {
        this.legendDataMap.set(seriesId, data);
    }
    clearData() {
        this.legendDataMap.clear();
    }
    toggleItem(enabled, seriesId, itemId, legendItemName) {
        if (legendItemName) {
            this.getData().forEach((datum)=>{
                const newData = (this.legendDataMap.get(datum.seriesId) ?? []).map((d)=>d.legendItemName === legendItemName ? {
                        ...d,
                        enabled: enabled
                    } : d);
                this.updateData(datum.seriesId, newData);
            });
            return;
        }
        const seriesLegendData = this.getData(seriesId);
        const singleLegendItem = seriesLegendData.length === 1;
        const data = seriesLegendData.map((datum)=>itemId == null && singleLegendItem || datum.itemId === itemId ? {
                ...datum,
                enabled: enabled
            } : datum);
        this.updateData(seriesId, data);
    }
    getData(seriesId) {
        if (seriesId) return this.legendDataMap.get(seriesId) ?? [];
        return [
            ...this.legendDataMap
        ].reduce((data, [_, legendData])=>data.concat(legendData), []);
    }
    getDatum({ seriesId: seriesId, itemId: itemId } = {}) {
        return this.getData(seriesId).find((datum)=>datum.itemId === itemId);
    }
    getSeriesEnabled(seriesId) {
        const data = this.getData(seriesId);
        if (data.length > 0) return data.some((d)=>d.enabled);
    }
    getItemEnabled({ seriesId: seriesId, itemId: itemId } = {}) {
        return this.getDatum({
            seriesId: seriesId,
            itemId: itemId
        })?.enabled ?? true;
    }
};
// packages/ag-charts-community/src/chart/series/seriesStateManager.ts
var $d77b025aa58d633c$var$SeriesStateManager = class {
    constructor(){
        this.groups = {};
    }
    registerSeries({ internalId: internalId, seriesGrouping: seriesGrouping, visible: visible, type: type }) {
        var _a;
        if (!seriesGrouping) return;
        (_a = this.groups)[type] ?? (_a[type] = {});
        this.groups[type][internalId] = {
            grouping: seriesGrouping,
            visible: visible
        };
    }
    updateSeries({ internalId: internalId, seriesGrouping: seriesGrouping, visible: visible, type: type }) {
        if (!seriesGrouping) return;
        const entry = this.groups[type]?.[internalId];
        if (entry) {
            entry.grouping = seriesGrouping;
            entry.visible = visible;
        }
    }
    deregisterSeries({ internalId: internalId, type: type }) {
        if (this.groups[type]) delete this.groups[type][internalId];
        if (this.groups[type] && Object.keys(this.groups[type]).length === 0) delete this.groups[type];
    }
    getVisiblePeerGroupIndex({ type: type, seriesGrouping: seriesGrouping, visible: visible }) {
        if (!seriesGrouping) return {
            visibleGroupCount: visible ? 1 : 0,
            visibleSameStackCount: visible ? 1 : 0,
            index: 0
        };
        const visibleGroupsSet = /* @__PURE__ */ new Set();
        const visibleSameStackSet = /* @__PURE__ */ new Set();
        for (const entry of Object.values(this.groups[type] ?? {})){
            if (!entry.visible) continue;
            visibleGroupsSet.add(entry.grouping.groupIndex);
            if (entry.grouping.groupIndex === seriesGrouping.groupIndex) visibleSameStackSet.add(entry.grouping.stackIndex);
        }
        const visibleGroups = Array.from(visibleGroupsSet);
        visibleGroups.sort((a, b)=>a - b);
        return {
            visibleGroupCount: visibleGroups.length,
            visibleSameStackCount: visibleSameStackSet.size,
            index: visibleGroups.indexOf(seriesGrouping.groupIndex)
        };
    }
};
var $d77b025aa58d633c$var$UpdateService = class {
    constructor(updateCallback){
        this.updateCallback = updateCallback;
        this.events = new (0, $idDdm.EventEmitter)();
    }
    addListener(eventName, listener) {
        return this.events.on(eventName, listener);
    }
    removeListener(eventName, listener) {
        return this.events.on(eventName, listener);
    }
    destroy() {
        this.events.clear();
    }
    update(type = 0 /* FULL */ , options) {
        this.updateCallback(type, options);
    }
    dispatchUpdateComplete(apiUpdate) {
        this.events.emit("update-complete", {
            type: "update-complete",
            apiUpdate: apiUpdate
        });
    }
    dispatchPreDomUpdate() {
        this.events.emit("pre-dom-update", {
            type: "pre-dom-update"
        });
    }
    dispatchPreSceneRender() {
        this.events.emit("pre-scene-render", {
            type: "pre-scene-render"
        });
    }
    dispatchProcessData({ series: series }) {
        this.events.emit("process-data", {
            type: "process-data",
            series: series
        });
    }
};
// packages/ag-charts-community/src/chart/chartContext.ts
var $d77b025aa58d633c$var$ChartContext = class {
    constructor(chart, vars){
        this.callbackCache = new $d77b025aa58d633c$var$CallbackCache();
        this.chartEventManager = new $d77b025aa58d633c$var$ChartEventManager();
        this.highlightManager = new $d77b025aa58d633c$var$HighlightManager();
        this.layoutManager = new $d77b025aa58d633c$var$LayoutManager();
        this.localeManager = new $d77b025aa58d633c$var$LocaleManager();
        this.seriesStateManager = new $d77b025aa58d633c$var$SeriesStateManager();
        this.stateManager = new $d77b025aa58d633c$var$StateManager();
        this.seriesLabelLayoutManager = new $d77b025aa58d633c$var$SeriesLabelLayoutManager();
        this.destroyFns = [];
        this.contextModules = [];
        const { scene: scene, root: root, syncManager: syncManager, container: container, fireEvent: fireEvent, updateCallback: updateCallback, updateMutex: updateMutex, styleContainer: styleContainer, chartType: chartType, domMode: domMode } = vars;
        this.chartService = chart;
        this.syncManager = syncManager;
        this.domManager = new $d77b025aa58d633c$var$DOMManager(this.chartService, container, styleContainer, domMode);
        this.widgets = new $d77b025aa58d633c$var$WidgetSet(this.domManager);
        const canvasElement = this.domManager.addChild("canvas", "scene-canvas", scene?.canvas.element);
        this.scene = scene ?? new $d77b025aa58d633c$var$Scene({
            canvasElement: canvasElement
        });
        this.scene.setRoot(root);
        this.destroyFns.push(this.scene.on("scene-changed", ()=>{
            this.updateService.update(7 /* SCENE_RENDER */ );
        }));
        this.axisManager = new $d77b025aa58d633c$var$AxisManager(root);
        this.legendManager = new $d77b025aa58d633c$var$LegendManager();
        this.annotationManager = new $d77b025aa58d633c$var$AnnotationManager(chart.annotationRoot, fireEvent);
        this.chartTypeOriginator = new $d77b025aa58d633c$var$ChartTypeOriginator(chart);
        this.interactionManager = new $d77b025aa58d633c$var$InteractionManager();
        this.contextMenuRegistry = new $d77b025aa58d633c$var$ContextMenuRegistry();
        this.updateService = new $d77b025aa58d633c$var$UpdateService(updateCallback);
        this.proxyInteractionService = new $d77b025aa58d633c$var$ProxyInteractionService(this.localeManager, this.domManager);
        this.fontManager = new $d77b025aa58d633c$var$FontManager(this.domManager, this.updateService);
        this.historyManager = new $d77b025aa58d633c$var$HistoryManager(this.chartEventManager);
        this.animationManager = new $d77b025aa58d633c$var$AnimationManager(this.interactionManager, updateMutex);
        this.dataService = new $d77b025aa58d633c$var$DataService(this.animationManager);
        this.tooltipManager = new $d77b025aa58d633c$var$TooltipManager(this.localeManager, this.domManager, chart.tooltip);
        this.zoomManager = new $d77b025aa58d633c$var$ZoomManager(fireEvent, this.layoutManager);
        for (const module of $d77b025aa58d633c$var$moduleRegistry.byType("context")){
            if (!module.chartTypes.includes(chartType)) continue;
            const moduleInstance = module.moduleFactory(this);
            this.contextModules.push(moduleInstance);
            this[module.contextKey] = moduleInstance;
        }
    }
    destroy() {
        this.animationManager.destroy();
        this.highlightManager.destroy();
        this.axisManager.destroy();
        this.callbackCache.invalidateCache();
        this.chartEventManager.destroy();
        this.domManager.destroy();
        this.fontManager.destroy();
        this.highlightManager.destroy();
        this.proxyInteractionService.destroy();
        this.syncManager.destroy();
        this.tooltipManager.destroy();
        this.zoomManager.destroy();
        this.widgets.destroy();
        this.contextModules.forEach((m)=>m.destroy());
        this.destroyFns.forEach((fn)=>fn());
    }
};
// packages/ag-charts-community/src/chart/chartHighlight.ts
var $d77b025aa58d633c$var$ChartHighlight = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.range = "tooltip";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ChartHighlight.prototype, "range", 2);
function $d77b025aa58d633c$var$setsEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const value of a){
        if (!b.has(value)) return false;
    }
    return true;
}
function $d77b025aa58d633c$var$idsMapEqual(a, b) {
    if (a == null || b == null) return a === b;
    if (a.size !== b.size) return false;
    for (const [key, aValue] of a){
        const bValue = b.get(key);
        if (bValue == null) return false;
        if (!$d77b025aa58d633c$var$setsEqual(aValue, bValue)) return false;
    }
    return true;
}
function $d77b025aa58d633c$var$propsEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i += 1){
        const { type: typeA, idsMap: idsMapA, scopes: scopesA, data: dataA, ...propA } = a[i];
        const { type: typeB, idsMap: idsMapB, scopes: scopesB, data: dataB, ...propB } = b[i];
        if (typeA !== typeB) return false;
        if (scopesA && scopesB && !(0, $idDdm.arraysEqual)(scopesA, scopesB)) return false;
        if (dataA && dataB && dataA !== dataB) return false;
        if (!$d77b025aa58d633c$var$objectsEqual(propA, propB) || !$d77b025aa58d633c$var$idsMapEqual(idsMapA, idsMapB)) return false;
    }
    return true;
}
function $d77b025aa58d633c$var$optsEqual(a, b) {
    const { props: propsA, ...restA } = a;
    const { props: propsB, ...restB } = b;
    return $d77b025aa58d633c$var$objectsEqual(restA, restB) && $d77b025aa58d633c$var$propsEqual(propsA, propsB);
}
function $d77b025aa58d633c$var$canReuseCachedData(cachedDataItem, data, ids, opts) {
    return data === cachedDataItem.data && (0, $idDdm.arraysEqual)(ids, cachedDataItem.ids) && $d77b025aa58d633c$var$optsEqual(opts, cachedDataItem.opts);
}
// packages/ag-charts-community/src/chart/data/dataDomain.ts
var $d77b025aa58d633c$var$DiscreteDomain = class _DiscreteDomain {
    constructor(){
        this.domain = /* @__PURE__ */ new Set();
    }
    static is(value) {
        return value instanceof _DiscreteDomain;
    }
    extend(val) {
        this.domain.add(val);
    }
    getDomain() {
        return Array.from(this.domain);
    }
};
var $d77b025aa58d633c$var$ContinuousDomain = class _ContinuousDomain {
    constructor(){
        this.domain = [
            Infinity,
            -Infinity
        ];
    }
    static is(value) {
        return value instanceof _ContinuousDomain;
    }
    static extendDomain(values, domain = [
        Infinity,
        -Infinity
    ]) {
        for (const value of values){
            if (typeof value !== "number") continue;
            if (domain[0] > value) domain[0] = value;
            if (domain[1] < value) domain[1] = value;
        }
        return domain;
    }
    extend(value) {
        if (this.domain[0] > value) this.domain[0] = value;
        if (this.domain[1] < value) this.domain[1] = value;
    }
    getDomain() {
        return [
            ...this.domain
        ];
    }
};
// packages/ag-charts-community/src/chart/data/rangeLookup.ts
var $d77b025aa58d633c$var$MIN = 0;
var $d77b025aa58d633c$var$MAX = 1;
var $d77b025aa58d633c$var$SPAN = 2;
var $d77b025aa58d633c$var$RangeLookup = class {
    constructor(allValues){
        const dataLength = allValues.reduce((acc, v)=>Math.max(acc, v.length), 0);
        const sizePower = 32 - Math.clz32(dataLength);
        let maxLevelSize = 1 << sizePower;
        if (dataLength === maxLevelSize / 2) maxLevelSize = maxLevelSize >>> 1;
        this.maxLevelSize = maxLevelSize;
        const buffer = new Float64Array((maxLevelSize * 2 - 1) * 2).fill(NaN);
        for (const values of allValues)for(let i = 0; i < values.length; i += 1){
            const value = Number(values[i]);
            const bufferIndex = maxLevelSize + i - 1;
            const bufferMinIndex = (bufferIndex * $d77b025aa58d633c$var$SPAN | 0) + $d77b025aa58d633c$var$MIN;
            const bufferMaxIndex = (bufferIndex * $d77b025aa58d633c$var$SPAN | 0) + $d77b025aa58d633c$var$MAX;
            const prevMinValue = buffer[bufferMinIndex];
            const prevMaxValue = buffer[bufferMaxIndex];
            if (!Number.isFinite(prevMinValue) || value < prevMinValue) buffer[bufferMinIndex] = value;
            if (!Number.isFinite(prevMaxValue) || value > prevMaxValue) buffer[bufferMaxIndex] = value;
        }
        for(let size = maxLevelSize / 2 | 0; size >= 1; size = size / 2 | 0){
            const start2 = size - 1 | 0;
            const end2 = start2 + size | 0;
            for(let i = 0; i < size; i += 1){
                const nodeIndex = start2 + i;
                const leftIndex = end2 + i * 2;
                const rightIndex = leftIndex + 1;
                const aMin = buffer[(leftIndex * $d77b025aa58d633c$var$SPAN | 0) + $d77b025aa58d633c$var$MIN];
                const bMin = buffer[(rightIndex * $d77b025aa58d633c$var$SPAN | 0) + $d77b025aa58d633c$var$MIN];
                buffer[(nodeIndex * $d77b025aa58d633c$var$SPAN | 0) + $d77b025aa58d633c$var$MIN] = !Number.isFinite(bMin) || aMin < bMin ? aMin : bMin;
                const aMax = buffer[(leftIndex * $d77b025aa58d633c$var$SPAN | 0) + $d77b025aa58d633c$var$MAX];
                const bMax = buffer[(rightIndex * $d77b025aa58d633c$var$SPAN | 0) + $d77b025aa58d633c$var$MAX];
                buffer[(nodeIndex * $d77b025aa58d633c$var$SPAN | 0) + $d77b025aa58d633c$var$MAX] = !Number.isFinite(bMax) || aMax > bMax ? aMax : bMax;
            }
        }
        this.buffer = buffer;
    }
    computeRangeInto(buffer, start2, end2, bufferIndex, currentStart, step, into) {
        const currentEnd = currentStart + step - 1;
        if (currentEnd < start2 || currentStart >= end2) return into;
        if (currentStart >= start2 && currentEnd < end2) {
            const min = buffer[(bufferIndex * $d77b025aa58d633c$var$SPAN | 0) + $d77b025aa58d633c$var$MIN];
            const max = buffer[(bufferIndex * $d77b025aa58d633c$var$SPAN | 0) + $d77b025aa58d633c$var$MAX];
            if (Number.isFinite(min)) into[0] = Math.min(into[0], min);
            if (Number.isFinite(max)) into[1] = Math.max(into[1], max);
        } else if (step > 1) {
            bufferIndex = bufferIndex * 2 | 0;
            step = step / 2 | 0;
            this.computeRangeInto(buffer, start2, end2, bufferIndex + 1 | 0, currentStart, step, into);
            this.computeRangeInto(buffer, start2, end2, bufferIndex + 2 | 0, currentStart + step, step, into);
        }
        return into;
    }
    rangeBetween(start2, end2) {
        if (start2 > end2) return [
            NaN,
            NaN
        ];
        const { maxLevelSize: maxLevelSize, buffer: buffer } = this;
        const range3 = [
            Infinity,
            -Infinity
        ];
        this.computeRangeInto(buffer, start2, end2, 0, 0, maxLevelSize, range3);
        return range3;
    }
    get range() {
        const { buffer: buffer } = this;
        return [
            buffer[$d77b025aa58d633c$var$MIN],
            buffer[$d77b025aa58d633c$var$MAX]
        ];
    }
};
// packages/ag-charts-community/src/chart/data/dataModel.ts
var $d77b025aa58d633c$var$DOMAIN_RANGES = Symbol("domain-ranges");
function $d77b025aa58d633c$var$toKeyString(keys) {
    return keys.map((key)=>(0, $idDdm.isObject)(key) ? JSON.stringify(key) : key).join("-");
}
function $d77b025aa58d633c$var$fixNumericExtent(extent2) {
    const numberExtent = extent2?.map(Number);
    return numberExtent?.every(Number.isFinite) ? numberExtent : [];
}
function $d77b025aa58d633c$var$getMissCount(scopeProvider, missMap) {
    return missMap?.get(scopeProvider.id) ?? 0;
}
function $d77b025aa58d633c$var$isScoped(obj) {
    return "scopes" in obj && Array.isArray(obj.scopes);
}
function $d77b025aa58d633c$var$createArray(length2, value) {
    const out = [];
    for(let i = 0; i < length2; i += 1)out[i] = value;
    return out;
}
function $d77b025aa58d633c$var$datumKeys(keys, columnScope, datumIndex) {
    const out = [];
    for (const k of keys){
        const key = k.get(columnScope)?.[datumIndex];
        if (key == null) return;
        out.push(key);
    }
    return out;
}
function $d77b025aa58d633c$var$getPathComponents(path) {
    const components = [];
    let matchIndex = 0;
    let matchGroup;
    const regExp = /((?:(?:^|\.)\s*\w+|\[\s*(?:'(?:[^']|(?<!\\)\\')*'|"(?:[^"]|(?<!\\)\\")*"|-?\d+)\s*\])\s*)/g;
    while(matchGroup = regExp.exec(path)){
        if (matchGroup.index !== matchIndex) return;
        matchIndex = matchGroup.index + matchGroup[0].length;
        const match = matchGroup[1].trim();
        if (match.startsWith(".")) components.push(match.slice(1).trim());
        else if (match.startsWith("[")) {
            const accessor = match.slice(1, -1).trim();
            if (accessor.startsWith(`'`)) components.push(accessor.slice(1, -1).replace(/(?<!\\)\\'/g, `'`));
            else if (accessor.startsWith(`"`)) components.push(accessor.slice(1, -1).replace(/(?<!\\)\\"/g, `"`));
            else components.push(accessor);
        } else components.push(match);
    }
    if (matchIndex !== path.length) return;
    return components;
}
function $d77b025aa58d633c$var$createPathAccessor(components) {
    return (datum)=>{
        let current = datum;
        for (const component of components)current = current[component];
        return current;
    };
}
var $d77b025aa58d633c$var$DataModel = class {
    constructor(opts, mode = "standalone", suppressFieldDotNotation = false){
        this.opts = opts;
        this.mode = mode;
        this.suppressFieldDotNotation = suppressFieldDotNotation;
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "data-model");
        this.scopeCache = /* @__PURE__ */ new Map();
        this.keys = [];
        this.values = [];
        this.aggregates = [];
        this.groupProcessors = [];
        this.propertyProcessors = [];
        this.reducers = [];
        this.processors = [];
        this.markScopeDatumInvalid = function(scopes, data, datumIndex, invalidData) {
            for (const scope of scopes){
                if (!invalidData.has(scope)) invalidData.set(scope, $d77b025aa58d633c$var$createArray(data.length, false));
                invalidData.get(scope)[datumIndex] = true;
            }
        };
        let keys = true;
        for (const next of opts.props){
            if (next.type === "key" && !keys) throw new Error("AG Charts - internal config error: keys must come before values.");
            if (next.type === "value" && keys) keys = false;
        }
        const verifyMatchGroupId = ({ matchGroupIds: matchGroupIds = [] })=>{
            for (const matchGroupId of matchGroupIds){
                if (this.values.every((def)=>def.groupId !== matchGroupId)) throw new Error(`AG Charts - internal config error: matchGroupIds properties must match defined groups (${matchGroupId}).`);
            }
        };
        const keyScopes = /* @__PURE__ */ new Set();
        const valueScopes = /* @__PURE__ */ new Set();
        for (const def of opts.props){
            const scopes = def.type === "key" ? keyScopes : valueScopes;
            if ($d77b025aa58d633c$var$isScoped(def)) def.scopes?.forEach((s)=>scopes.add(s));
            switch(def.type){
                case "key":
                    this.keys.push({
                        ...def,
                        index: this.keys.length,
                        missing: /* @__PURE__ */ new Map()
                    });
                    break;
                case "value":
                    if (def.property == null) throw new Error(`AG Charts - internal config error: no properties specified for value definitions: ${JSON.stringify(def)}`);
                    this.values.push({
                        ...def,
                        index: this.values.length,
                        missing: /* @__PURE__ */ new Map()
                    });
                    break;
                case "aggregate":
                    verifyMatchGroupId(def);
                    this.aggregates.push({
                        ...def,
                        index: this.aggregates.length
                    });
                    break;
                case "group-value-processor":
                    verifyMatchGroupId(def);
                    this.groupProcessors.push({
                        ...def,
                        index: this.groupProcessors.length
                    });
                    break;
                case "property-value-processor":
                    this.propertyProcessors.push({
                        ...def,
                        index: this.propertyProcessors.length
                    });
                    break;
                case "reducer":
                    this.reducers.push({
                        ...def,
                        index: this.reducers.length
                    });
                    break;
                case "processor":
                    this.processors.push({
                        ...def,
                        index: this.processors.length
                    });
                    break;
            }
        }
        if (!!this.opts.groupByKeys || this.opts.groupByFn != null) {
            const ungroupedScopes = new Set(valueScopes.values());
            keyScopes.forEach((s)=>ungroupedScopes.delete(s));
            if (ungroupedScopes.size > 0) throw new Error(`AG Charts - scopes missing key for grouping, illegal configuration: ${[
                ...ungroupedScopes.values()
            ]}`);
        }
    }
    resolveProcessedDataDefById(scope, searchId) {
        const def = this.scopeCache.get(scope.id)?.get(searchId);
        if (!def) throw new Error(`AG Charts - didn't find property definition for [${searchId}, ${scope.id}]`);
        return {
            index: def.index,
            def: def
        };
    }
    resolveProcessedDataIndexById(scope, searchId) {
        return this.resolveProcessedDataDefById(scope, searchId).index;
    }
    resolveKeysById(scope, searchId, processedData) {
        const index = this.resolveProcessedDataIndexById(scope, searchId);
        const keys = processedData.keys[index];
        if (keys == null) throw new Error(`AG Charts - didn't find keys for [${searchId}, ${scope.id}]`);
        return keys.get(scope.id);
    }
    hasColumnById(scope, searchId) {
        return this.scopeCache.get(scope.id)?.get(searchId) != null;
    }
    resolveColumnById(scope, searchId, processedData) {
        const index = this.resolveProcessedDataIndexById(scope, searchId);
        const column = processedData.columns?.[index];
        if (column == null) throw new Error(`AG Charts - didn't find column for [${searchId}, ${scope.id}]`);
        return column;
    }
    /**
   * Provides a convenience iterator to iterate over all of the extract datum values in a
   * specific DataGroup.
   *
   * @param scope to which datums should belong
   * @param group containing the datums
   * @param processedData containing the group
   */ *forEachDatum(scope, processedData, group) {
        const columnIndex = processedData.columnScopes.findIndex((s)=>s.has(scope.id));
        for (const datumIndex of group.datumIndices[columnIndex] ?? [])yield processedData.columns[columnIndex][datumIndex];
    }
    /**
   * Provides a convenience iterator to iterate over all of the extracted datum values in a
   * GroupedData.
   *
   * @param scope to which datums should belong
   * @param processedData to iterate through
   */ *forEachGroupDatum(scope, processedData) {
        const columnIndex = processedData.columnScopes.findIndex((s)=>s.has(scope.id));
        const output = {
            groupIndex: 0,
            columnIndex: columnIndex
        };
        const empty = [];
        for (const group of processedData.groups){
            output.group = group;
            let valueIndex = 0;
            for (const datumIndex of group.datumIndices[columnIndex] ?? empty){
                output.datumIndex = datumIndex;
                output.valueIndex = valueIndex++;
                yield output;
            }
            output.groupIndex++;
        }
    }
    /**
   * Provides a window-based convenience iterator to iterate over all of the extracted datum
   * values in a GroupedData, including the previous and next entries relative to each datum.
   *
   * @param scope to which datums should belong
   * @param processedData to iterate through
   */ *forEachGroupDatumTuple(scope, processedData) {
        const columnIndex = processedData.columnScopes.findIndex((s)=>s.has(scope.id));
        const output = {
            columnIndex: columnIndex,
            datumIndexes: [
                void 0,
                void 0,
                void 0
            ]
        };
        for (const next of this.forEachGroupDatum(scope, processedData)){
            output.group = output.nextGroup;
            output.groupIndex = output.nextGroupIndex;
            output.nextGroup = next.group;
            output.nextGroupIndex = next.groupIndex;
            output.datumIndexes[0] = output.datumIndexes[1];
            output.datumIndexes[1] = output.datumIndexes[2];
            output.datumIndexes[2] = next.datumIndex;
            if (output.group != null && output.datumIndexes[1] != null) yield output;
        }
        output.group = output.nextGroup;
        output.groupIndex = output.nextGroupIndex;
        output.nextGroup = void 0;
        output.nextGroupIndex = void 0;
        output.datumIndexes[0] = output.datumIndexes[1];
        output.datumIndexes[1] = output.datumIndexes[2];
        output.datumIndexes[2] = void 0;
        if (output.group != null && output.datumIndexes[1] != null) yield output;
    }
    getDomain(scope, searchId, type, processedData) {
        const domains = this.getDomainsByType(type ?? "value", processedData);
        return domains?.[this.resolveProcessedDataIndexById(scope, searchId)] ?? [];
    }
    getDomainBetweenRange(scope, searchIds, [i0, i1], processedData) {
        const columnIndices = searchIds.map((searchId)=>this.resolveProcessedDataIndexById(scope, searchId));
        const cacheKey = columnIndices.join(":");
        const domainRanges = processedData[$d77b025aa58d633c$var$DOMAIN_RANGES];
        let rangeLookup = domainRanges.get(cacheKey);
        if (rangeLookup == null) {
            const values = columnIndices.map((columnIndex)=>processedData.columns[columnIndex]);
            rangeLookup = new $d77b025aa58d633c$var$RangeLookup(values);
            domainRanges.set(cacheKey, rangeLookup);
        }
        return rangeLookup.rangeBetween(i0, i1);
    }
    getDomainsByType(type, processedData) {
        switch(type){
            case "key":
                return processedData.domain.keys;
            case "value":
                return processedData.domain.values;
            case "aggregate":
                return processedData.domain.aggValues;
            case "group-value-processor":
                return processedData.domain.groups;
            default:
                return null;
        }
    }
    processData(sources) {
        const { opts: { groupByKeys: groupByKeys, groupByFn: groupByFn }, aggregates: aggregates, groupProcessors: groupProcessors, reducers: reducers, processors: processors, propertyProcessors: propertyProcessors } = this;
        const start2 = performance.now();
        if (groupByKeys && this.keys.length === 0) return;
        let processedData = this.extractData(sources);
        if (groupByKeys) processedData = this.groupData(processedData);
        else if (groupByFn) processedData = this.groupData(processedData, groupByFn(processedData));
        if (groupProcessors.length > 0 && processedData.type === "grouped") this.postProcessGroups(processedData);
        if (aggregates.length > 0 && processedData.type === "ungrouped") this.aggregateUngroupedData(processedData);
        else if (aggregates.length > 0 && processedData.type === "grouped") this.aggregateGroupedData(processedData);
        if (propertyProcessors.length > 0) this.postProcessProperties(processedData);
        if (reducers.length > 0) this.reduceData(processedData);
        if (processors.length > 0) this.postProcessData(processedData);
        this.warnDataMissingProperties(sources);
        const end2 = performance.now();
        processedData.time = end2 - start2;
        if (this.debug.check()) $d77b025aa58d633c$var$logProcessedData(processedData);
        this.processScopeCache();
        return processedData;
    }
    warnDataMissingProperties(sources) {
        if (sources.size === 0) return;
        for (const def of (0, $idDdm.iterate)(this.keys, this.values))for (const [scope, missCount] of def.missing){
            if (missCount < (sources.get(scope)?.length ?? Infinity)) continue;
            const scopeHint = scope == null ? "" : ` for ${scope}`;
            (0, $idDdm.Logger).warnOnce(`the key '${def.property}' was not found in any data element${scopeHint}.`);
        }
    }
    processScopeCache() {
        this.scopeCache.clear();
        for (const def of (0, $idDdm.iterate)(this.keys, this.values, this.aggregates)){
            if (!def.idsMap) continue;
            for (const [scope, ids] of def.idsMap)for (const id of ids){
                if (!this.scopeCache.has(scope)) this.scopeCache.set(scope, /* @__PURE__ */ new Map([
                    [
                        id,
                        def
                    ]
                ]));
                else if (this.scopeCache.get(scope)?.has(id)) throw new Error("duplicate definition ids on the same scope are not allowed.");
                else this.scopeCache.get(scope).set(id, def);
            }
        }
    }
    valueGroupIdxLookup({ matchGroupIds: matchGroupIds }) {
        const result = [];
        for (const [index, def] of this.values.entries())if (!matchGroupIds || def.groupId && matchGroupIds.includes(def.groupId)) result.push(index);
        return result;
    }
    valueIdxLookup(scopes, prop) {
        const noScopesToMatch = scopes == null || scopes.length === 0;
        const propId = typeof prop === "string" ? prop : prop.id;
        const hasMatchingScopeId = (def)=>{
            if (def.idsMap) for (const [scope, ids] of def.idsMap){
                if (scopes?.includes(scope) && ids.has(propId)) return true;
            }
            return false;
        };
        const result = this.values.reduce((res, def, index)=>{
            const validDefScopes = def.scopes == null || noScopesToMatch && !def.scopes.length || def.scopes.some((s)=>scopes?.includes(s));
            if (validDefScopes && (def.property === propId || def.id === propId || hasMatchingScopeId(def))) res.push(index);
            return res;
        }, []);
        if (result.length === 0) throw new Error(`AG Charts - configuration error, unknown property ${JSON.stringify(prop)} in scope(s) ${JSON.stringify(scopes)}`);
        return result;
    }
    extractData(sources) {
        const { dataDomain: dataDomain, processValue: processValue, allScopesHaveSameDefs: allScopesHaveSameDefs } = this.initDataDomainProcessor();
        const { keys: keyDefs, values: valueDefs } = this;
        const { invalidData: invalidData, invalidKeys: invalidKeys, allKeyMappings: allKeyMappings } = this.extractKeys(keyDefs, sources, processValue);
        const { columns: columns, columnScopes: columnScopes, partialValidDataCount: partialValidDataCount, maxDataLength: maxDataLength } = this.extractValues(invalidData, valueDefs, sources, invalidKeys, processValue);
        const propertyDomain = (def)=>{
            const defDomain = dataDomain.get(def);
            const result = defDomain.getDomain();
            if ($d77b025aa58d633c$var$ContinuousDomain.is(defDomain) && result[0] > result[1]) return [];
            return result;
        };
        return {
            type: "ungrouped",
            input: {
                count: maxDataLength
            },
            scopes: new Set(sources.keys()),
            dataSources: sources,
            aggregation: void 0,
            keys: [
                ...allKeyMappings.values()
            ],
            columns: columns,
            columnScopes: columnScopes,
            invalidKeys: invalidKeys,
            invalidData: invalidData,
            domain: {
                keys: keyDefs.map(propertyDomain),
                values: valueDefs.map(propertyDomain)
            },
            defs: {
                allScopesHaveSameDefs: allScopesHaveSameDefs,
                keys: keyDefs,
                values: valueDefs
            },
            partialValidDataCount: partialValidDataCount,
            time: 0,
            [$d77b025aa58d633c$var$DOMAIN_RANGES]: /* @__PURE__ */ new Map()
        };
    }
    extractKeys(keyDefs, sources, processValue) {
        const invalidKeys = /* @__PURE__ */ new Map();
        const invalidData = /* @__PURE__ */ new Map();
        const allKeys = /* @__PURE__ */ new Map();
        let keyDefKeys;
        let scopeDataProcessed;
        const cloneScope = (source, target)=>{
            const sourceScope = scopeDataProcessed.get(source);
            keyDefKeys.set(target, keyDefKeys.get(sourceScope));
            if (invalidKeys.has(sourceScope)) {
                invalidKeys.set(target, invalidKeys.get(sourceScope));
                invalidData.set(target, invalidData.get(sourceScope));
            }
        };
        for (const keyDef of keyDefs){
            const { invalidValue: invalidValue, scopes: keyScopes } = keyDef;
            keyDefKeys = /* @__PURE__ */ new Map();
            scopeDataProcessed = /* @__PURE__ */ new Map();
            allKeys.set(keyDef, keyDefKeys);
            for (const scope of keyScopes ?? []){
                const data = sources.get(scope) ?? [];
                if (scopeDataProcessed.has(data)) {
                    cloneScope(data, scope);
                    continue;
                }
                const keys = [];
                keyDefKeys.set(scope, keys);
                scopeDataProcessed.set(data, scope);
                let invalidScopeKeys;
                let invalidScopeData;
                for(let datumIndex = 0; datumIndex < data.length; datumIndex++){
                    if (data[datumIndex] == null || typeof data[datumIndex] !== "object") continue;
                    const result = processValue(keyDef, data[datumIndex], datumIndex, scope);
                    if (result.valid) {
                        keys.push(result.value);
                        continue;
                    }
                    keys.push(invalidValue);
                    invalidScopeKeys ?? (invalidScopeKeys = $d77b025aa58d633c$var$createArray(data.length, false));
                    invalidScopeData ?? (invalidScopeData = $d77b025aa58d633c$var$createArray(data.length, false));
                    invalidScopeKeys[datumIndex] = true;
                    invalidScopeData[datumIndex] = true;
                }
                if (invalidScopeKeys && invalidScopeData) {
                    invalidKeys.set(scope, invalidScopeKeys);
                    invalidData.set(scope, invalidScopeData);
                }
            }
        }
        return {
            invalidData: invalidData,
            invalidKeys: invalidKeys,
            allKeyMappings: allKeys
        };
    }
    extractValues(invalidData, valueDefs, sources, invalidKeys, processValue) {
        let partialValidDataCount = 0;
        const columns = [];
        const allColumnScopes = [];
        let maxDataLength = 0;
        for (const def of valueDefs){
            const { invalidValue: invalidValue } = def;
            const valueSources = new Set(def.scopes.map((s)=>sources.get(s)));
            if (valueSources.size > 1) throw new Error(`AG Charts - more than one data source for: ${JSON.stringify(def)}`);
            const columnScopes = new Set(def.scopes);
            const columnScope = (0, $idDdm.first)(def.scopes);
            const columnSource = sources.get(columnScope);
            const column = new Array();
            for(let datumIndex = 0; datumIndex < columnSource.length; datumIndex++){
                if (columnSource[datumIndex] == null || typeof columnSource[datumIndex] !== "object") continue;
                const valueDatum = columnSource[datumIndex];
                const invalidKey = invalidKeys.get(columnScope)?.[datumIndex];
                const result = processValue(def, valueDatum, datumIndex, def.scopes);
                let value = result.value;
                if (invalidKey || !result.valid) this.markScopeDatumInvalid(def.scopes, columnSource, datumIndex, invalidData);
                if (invalidKey) value = invalidValue;
                else if (!result.valid) {
                    partialValidDataCount += 1;
                    value = invalidValue;
                }
                column[datumIndex] = value;
            }
            columns.push(column);
            allColumnScopes.push(columnScopes);
            maxDataLength = Math.max(maxDataLength, column.length);
        }
        return {
            columns: columns,
            columnScopes: allColumnScopes,
            partialValidDataCount: partialValidDataCount,
            maxDataLength: maxDataLength
        };
    }
    groupData(data, groupingFn) {
        var _a;
        const groups = /* @__PURE__ */ new Map();
        const { keys: dataKeys, columns: allColumns, columnScopes: columnScopes, invalidKeys: invalidKeys, invalidData: invalidData } = data;
        const allScopes = data.scopes;
        const processedColumnIndexes = /* @__PURE__ */ new Set();
        for (const scope of allScopes){
            const scopeColumnIndexes = allColumns.map((_, idx)=>idx).filter((idx)=>!processedColumnIndexes.has(idx) && columnScopes[idx].has(scope));
            if (scopeColumnIndexes.length === 0) continue;
            for (const idx of scopeColumnIndexes)processedColumnIndexes.add(idx);
            const siblingScopes = /* @__PURE__ */ new Set();
            for (const columnIdx of scopeColumnIndexes)for (const columnScope of columnScopes[columnIdx])siblingScopes.add(columnScope);
            const scopeKeys = dataKeys.map((k)=>k.get(scope)).filter((k)=>k != null);
            const firstColumn = allColumns[(0, $idDdm.first)(scopeColumnIndexes)];
            const scopeInvalidData = invalidData?.get(scope);
            const scopeInvalidKeys = invalidKeys?.get(scope);
            for(let datumIndex = 0; datumIndex < firstColumn.length; datumIndex++){
                if (scopeInvalidKeys?.[datumIndex] === true) continue;
                const keys = scopeKeys.map((k)=>k[datumIndex]);
                if (keys == null || keys.length === 0) throw new Error("AG Charts - no keys found for scope: " + scope);
                const group = groupingFn?.(keys) ?? keys;
                const groupStr = $d77b025aa58d633c$var$toKeyString(group);
                const outputGroup = groups.get(groupStr) ?? {
                    keys: group,
                    datumIndices: [],
                    validScopes: allScopes
                };
                if (!groups.has(groupStr)) groups.set(groupStr, outputGroup);
                if (scopeInvalidData?.[datumIndex] === true) {
                    if (outputGroup.validScopes === allScopes) outputGroup.validScopes = new Set(allScopes.values());
                    for (const invalidScope of siblingScopes)outputGroup.validScopes.delete(invalidScope);
                }
                for (const columnIdx of scopeColumnIndexes){
                    (_a = outputGroup.datumIndices)[columnIdx] ?? (_a[columnIdx] = []);
                    outputGroup.datumIndices[columnIdx].push(datumIndex);
                }
            }
        }
        const resultGroups = [];
        const resultData = [];
        for (const { keys: keys, datumIndices: datumIndices, validScopes: validScopes } of groups.values()){
            resultGroups.push(keys);
            resultData.push({
                datumIndices: datumIndices,
                keys: keys,
                aggregation: [],
                validScopes: validScopes
            });
        }
        return {
            ...data,
            type: "grouped",
            domain: {
                ...data.domain,
                groups: resultGroups
            },
            groups: resultData
        };
    }
    aggregateUngroupedData(processedData) {
        const domainAggValues = this.aggregates.map(()=>[
                Infinity,
                -Infinity
            ]);
        processedData.domain.aggValues = domainAggValues;
        const { keys: keys, columns: columns, dataSources: dataSources } = processedData;
        const onlyScope = (0, $idDdm.first)(dataSources.keys());
        const rawData = dataSources.get(onlyScope);
        processedData.aggregation = rawData?.map((_, datumIndex)=>{
            const aggregation = [];
            for (const [index, def] of this.aggregates.entries()){
                const indices = this.valueGroupIdxLookup(def);
                let groupAggValues = def.groupAggregateFunction?.() ?? [
                    Infinity,
                    -Infinity
                ];
                const valuesToAgg = indices.map((columnIndex)=>columns[columnIndex][datumIndex]);
                const k = $d77b025aa58d633c$var$datumKeys(keys, onlyScope, datumIndex);
                const valuesAgg = k != null ? def.aggregateFunction(valuesToAgg, k) : void 0;
                if (valuesAgg) groupAggValues = def.groupAggregateFunction?.(valuesAgg, groupAggValues) ?? $d77b025aa58d633c$var$ContinuousDomain.extendDomain(valuesAgg, groupAggValues);
                const finalValues = def.finalFunction?.(groupAggValues) ?? groupAggValues;
                aggregation[index] = finalValues;
                $d77b025aa58d633c$var$ContinuousDomain.extendDomain(finalValues, domainAggValues[index]);
            }
            return aggregation;
        });
    }
    aggregateGroupedData(processedData) {
        const domainAggValues = this.aggregates.map(()=>[
                Infinity,
                -Infinity
            ]);
        processedData.domain.aggValues = domainAggValues;
        const { columns: columns } = processedData;
        for (const [index, def] of this.aggregates.entries()){
            const indices = this.valueGroupIdxLookup(def);
            for (const group of processedData.groups){
                group.aggregation ?? (group.aggregation = []);
                const groupKeys = group.keys;
                let groupAggValues = def.groupAggregateFunction?.() ?? [
                    Infinity,
                    -Infinity
                ];
                const maxDatumIndex = Math.max(...indices.map((columnIndex)=>group.datumIndices[columnIndex]?.length ?? 0));
                for(let datumIndex = 0; datumIndex < maxDatumIndex; datumIndex++){
                    const valuesToAgg = indices.map((columnIndex)=>columns[columnIndex][group.datumIndices[columnIndex]?.[datumIndex]]);
                    const valuesAgg = def.aggregateFunction(valuesToAgg, groupKeys);
                    if (valuesAgg) groupAggValues = def.groupAggregateFunction?.(valuesAgg, groupAggValues) ?? $d77b025aa58d633c$var$ContinuousDomain.extendDomain(valuesAgg, groupAggValues);
                }
                const finalValues = def.finalFunction?.(groupAggValues) ?? groupAggValues;
                group.aggregation[index] = finalValues;
                $d77b025aa58d633c$var$ContinuousDomain.extendDomain(finalValues, domainAggValues[index]);
            }
        }
    }
    postProcessGroups(processedData) {
        const { groupProcessors: groupProcessors } = this;
        const { columnScopes: columnScopes, columns: columns, invalidData: invalidData } = processedData;
        for (const processor of groupProcessors){
            const valueIndexes = this.valueGroupIdxLookup(processor);
            const adjustFn = processor.adjust()();
            for (const dataGroup of processedData.groups)adjustFn(columns, valueIndexes, dataGroup);
            for (const valueIndex of valueIndexes){
                const valueDef = this.values[valueIndex];
                const isDiscrete = valueDef.valueType === "category";
                const column = columns[valueIndex];
                const columnScope = (0, $idDdm.first)(columnScopes[valueIndex]);
                const invalidDatums = invalidData?.get(columnScope);
                const domain = isDiscrete ? new $d77b025aa58d633c$var$DiscreteDomain() : new $d77b025aa58d633c$var$ContinuousDomain();
                for(let datumIndex = 0; datumIndex < column.length; datumIndex += 1){
                    if (invalidDatums?.[datumIndex] === true) continue;
                    domain.extend(column[datumIndex]);
                }
                processedData.domain.values[valueIndex] = domain.getDomain();
            }
        }
    }
    postProcessProperties(processedData) {
        for (const { adjust: adjust, property: property, scopes: scopes } of this.propertyProcessors)for (const idx of this.valueIdxLookup(scopes, property))adjust()(processedData, idx);
    }
    reduceData(processedData) {
        processedData.reduced ?? (processedData.reduced = {});
        const { dataSources: dataSources, keys: keys } = processedData;
        for (const def of this.reducers){
            const reducer = def.reducer();
            let accValue = def.initialValue;
            if (processedData.type === "grouped") for (const group of processedData.groups)accValue = reducer(accValue, group.keys);
            else {
                const onlyScope = (0, $idDdm.first)(dataSources.keys());
                const keyColumns = keys.map((k)=>k.get(onlyScope)).filter((k)=>k != null);
                const keysParam = keyColumns.map(()=>void 0);
                const rawData = dataSources.get(onlyScope);
                for(let datumIndex = 0; datumIndex < rawData.length; datumIndex += 1){
                    for(let keyIdx = 0; keyIdx < keysParam.length; keyIdx++)keysParam[keyIdx] = keyColumns[keyIdx]?.[datumIndex];
                    accValue = reducer(accValue, keysParam);
                }
            }
            processedData.reduced[def.property] = accValue;
        }
    }
    postProcessData(processedData) {
        processedData.reduced ?? (processedData.reduced = {});
        for (const def of this.processors)processedData.reduced[def.property] = def.calculate(processedData, processedData.reduced[def.property]);
    }
    initDataDomainProcessor() {
        const { keys: keyDefs, values: valueDefs } = this;
        const scopes = /* @__PURE__ */ new Set();
        for (const valueDef of valueDefs){
            if (!valueDef.scopes) continue;
            for (const scope of valueDef.scopes)scopes.add(scope);
        }
        const dataDomain = /* @__PURE__ */ new Map();
        const processorFns = /* @__PURE__ */ new Map();
        let allScopesHaveSameDefs = true;
        const initDataDomain = ()=>{
            for (const def of (0, $idDdm.iterate)(keyDefs, valueDefs))if (def.valueType === "category") dataDomain.set(def, new $d77b025aa58d633c$var$DiscreteDomain());
            else {
                dataDomain.set(def, new $d77b025aa58d633c$var$ContinuousDomain());
                allScopesHaveSameDefs && (allScopesHaveSameDefs = (def.scopes ?? []).length === scopes.size);
            }
        };
        initDataDomain();
        const accessors = this.buildAccessors((0, $idDdm.iterate)(keyDefs, valueDefs));
        const reusableResult = {
            value: void 0,
            missing: false,
            valid: false
        };
        const processValue = (def, datum, idx, valueScopes)=>{
            let valueInDatum;
            let value;
            if (accessors.has(def.property)) {
                try {
                    value = accessors.get(def.property)(datum);
                } catch  {}
                valueInDatum = value != null;
            } else {
                valueInDatum = def.property in datum;
                value = valueInDatum ? datum[def.property] : def.missingValue;
            }
            if (def.forceValue != null) {
                const valueNegative = valueInDatum && (0, $idDdm.isNegative)(value);
                value = valueNegative ? -1 * def.forceValue : def.forceValue;
                valueInDatum = true;
            }
            reusableResult.missing = !valueInDatum;
            const missingValueDef = "missingValue" in def;
            if (!valueInDatum && !missingValueDef) {
                if (typeof valueScopes === "string") {
                    const missCount = def.missing.get(valueScopes) ?? 0;
                    def.missing.set(valueScopes, missCount + 1);
                } else for (const scope of valueScopes){
                    const missCount = def.missing.get(scope) ?? 0;
                    def.missing.set(scope, missCount + 1);
                }
            }
            if (!dataDomain.has(def)) initDataDomain();
            if (valueInDatum && def.validation?.(value, datum, idx) === false) {
                reusableResult.valid = false;
                if ("invalidValue" in def) value = def.invalidValue;
                else {
                    if (this.mode !== "integrated") (0, $idDdm.Logger).warnOnce(`invalid value of type [${typeof value}] for [${def.scopes} / ${def.id}] ignored:`, `[${value}]`);
                    reusableResult.value = void 0;
                    return reusableResult;
                }
            } else reusableResult.valid = true;
            if (def.processor) {
                let processor = processorFns.get(def);
                if (processor == null) {
                    processor = def.processor();
                    processorFns.set(def, processor);
                }
                value = processor(value, idx);
            }
            dataDomain.get(def)?.extend(value);
            reusableResult.value = value;
            return reusableResult;
        };
        return {
            dataDomain: dataDomain,
            processValue: processValue,
            initDataDomain: initDataDomain,
            scopes: scopes,
            allScopesHaveSameDefs: allScopesHaveSameDefs
        };
    }
    buildAccessors(defs) {
        const result = /* @__PURE__ */ new Map();
        if (this.suppressFieldDotNotation) return result;
        for (const def of defs){
            const isPath = def.property.includes(".") || def.property.includes("[");
            if (!isPath) continue;
            const components = $d77b025aa58d633c$var$getPathComponents(def.property);
            if (components == null) {
                (0, $idDdm.Logger).warnOnce("Invalid property path [%s]", def.property);
                continue;
            }
            const accessor = $d77b025aa58d633c$var$createPathAccessor(components);
            result.set(def.property, accessor);
        }
        return result;
    }
};
function $d77b025aa58d633c$var$logProcessedData(processedData) {
    const logValues = (name, data)=>{
        if (data.length > 0) {
            (0, $idDdm.Logger).log(`DataModel.processData() - ${name}`);
            (0, $idDdm.Logger).table(data);
        }
    };
    (0, $idDdm.Logger).log("DataModel.processData() - processedData", processedData);
    logValues("Key Domains", processedData.domain.keys);
    logValues("Group Domains", processedData.domain.groups ?? []);
    logValues("Value Domains", processedData.domain.values);
    logValues("Aggregate Domains", processedData.domain.aggValues ?? []);
}
// packages/ag-charts-community/src/chart/data/dataController.ts
var $d77b025aa58d633c$var$_DataController = class _DataController {
    constructor(mode, suppressFieldDotNotation){
        this.mode = mode;
        this.suppressFieldDotNotation = suppressFieldDotNotation;
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "data-model");
        this.requested = [];
        this.status = "setup";
    }
    async request(id, data, opts) {
        if (this.status !== "setup") throw new Error(`AG Charts - data request after data setup phase.`);
        return new Promise((resolve, reject)=>{
            this.requested.push({
                id: id,
                opts: opts,
                data: data,
                resolve: resolve,
                reject: reject
            });
        });
    }
    execute(cachedData) {
        if (this.status !== "setup") throw new Error(`AG Charts - data request after data setup phase.`);
        this.status = "executed";
        this.debug("DataController.execute() - requested", this.requested);
        const valid = this.validateRequests(this.requested);
        this.debug("DataController.execute() - validated", valid);
        const merged = this.mergeRequested(valid);
        this.debug("DataController.execute() - merged", merged);
        if (this.debug.check()) (0, $idDdm.getWindow)().processedData = [];
        const nextCachedData = [];
        for (const { data: data, ids: ids, opts: opts, resolves: resolves, rejects: rejects } of merged){
            const reusableCache = cachedData?.find((cacheItem)=>$d77b025aa58d633c$var$canReuseCachedData(cacheItem, data, ids, opts));
            let dataModel;
            let processedData;
            if (reusableCache == null) try {
                dataModel = new $d77b025aa58d633c$var$DataModel(opts, this.mode, this.suppressFieldDotNotation);
                const sources = new Map(valid.map((v)=>[
                        v.id,
                        v.data
                    ]));
                processedData = dataModel.processData(sources);
            } catch (error) {
                rejects.forEach((cb)=>cb(error));
                continue;
            }
            else ({ dataModel: dataModel, processedData: processedData } = reusableCache);
            nextCachedData.push({
                opts: opts,
                data: data,
                ids: ids,
                dataModel: dataModel,
                processedData: processedData
            });
            if (this.debug.check()) (0, $idDdm.getWindow)("processedData").push(processedData);
            if (processedData?.partialValidDataCount === 0) resolves.forEach((resolve)=>resolve({
                    dataModel: dataModel,
                    processedData: processedData
                }));
            else if (processedData) this.splitResult(dataModel, processedData, ids, resolves);
            else rejects.forEach((cb)=>cb(new Error(`AG Charts - no processed data generated`)));
        }
        return nextCachedData;
    }
    validateRequests(requested) {
        const valid = [];
        for (const [index, request] of requested.entries())if (index > 0 && request.data.length !== requested[0].data.length && request.opts.groupByData === false && request.opts.groupByKeys === false) request.reject(new Error("all series[].data arrays must be of the same length and have matching keys."));
        else valid.push(request);
        return valid;
    }
    mergeRequested(requested) {
        const grouped = [];
        for (const request of requested){
            const match = grouped.find(_DataController.groupMatch(request));
            if (match) match.push(request);
            else grouped.push([
                request
            ]);
        }
        return grouped.map(_DataController.mergeRequests);
    }
    splitResult(dataModel, processedData, scopes, resolves) {
        for(let i = 0; i < scopes.length; i++){
            const resolve = resolves[i];
            resolve({
                dataModel: dataModel,
                processedData: processedData
            });
        }
    }
    static groupMatch({ data: data, opts: opts }) {
        function keys(props2) {
            return props2.filter((p)=>p.type === "key").map((p)=>p.property).join(";");
        }
        const { groupByData: groupByData, groupByKeys: groupByKeys = false, groupByFn: groupByFn, props: props } = opts;
        const propsKeys = keys(props);
        return ([group])=>(groupByData === false || group.data === data) && (group.opts.groupByKeys ?? false) === groupByKeys && group.opts.groupByFn === groupByFn && keys(group.opts.props) === propsKeys;
    }
    static mergeRequests(requests) {
        const crossScopeMergableTypes = /* @__PURE__ */ new Set([
            "key",
            "group-value-processor"
        ]);
        return requests.reduce((result, { id: id, data: data, resolve: resolve, reject: reject, opts: { props: props, ...opts } })=>{
            result.ids.push(id);
            result.rejects.push(reject);
            result.resolves.push(resolve);
            result.data ?? (result.data = data);
            result.opts ?? (result.opts = {
                ...opts,
                props: []
            });
            for (const prop of props){
                const clone2 = {
                    ...prop,
                    scopes: [
                        id
                    ],
                    data: data
                };
                _DataController.createIdsMap(id, clone2);
                const match = result.opts.props.find((existing)=>existing.type === clone2.type && (crossScopeMergableTypes.has(existing.type) || existing.data === clone2.data) && _DataController.deepEqual(existing, clone2));
                if (!match) {
                    result.opts.props.push(clone2);
                    continue;
                }
                match.scopes ?? (match.scopes = []);
                match.scopes.push(...clone2.scopes ?? []);
                if ((match.type === "key" || match.type === "value") && clone2.idsMap?.size) _DataController.mergeIdsMap(clone2.idsMap, match.idsMap);
            }
            return result;
        }, {
            ids: [],
            rejects: [],
            resolves: [],
            data: null,
            opts: null
        });
    }
    static mergeIdsMap(fromMap, toMap) {
        for (const [scope, ids] of fromMap){
            const toMapValue = toMap.get(scope);
            if (toMapValue == null) toMap.set(scope, new Set(ids));
            else for (const id of ids)toMapValue.add(id);
        }
    }
    static createIdsMap(scope, prop) {
        if (prop.id == null) return;
        prop.idsMap ?? (prop.idsMap = /* @__PURE__ */ new Map());
        if (prop.idsMap.has(scope)) prop.idsMap.get(scope).add(prop.id);
        else prop.idsMap.set(scope, /* @__PURE__ */ new Set([
            prop.id
        ]));
    }
    static deepEqual(a, b) {
        if (a === b) return true;
        if (a && b && typeof a == "object" && typeof b == "object") {
            if (a.constructor !== b.constructor) return false;
            let i, length2;
            if (Array.isArray(a)) {
                length2 = a.length;
                if (length2 !== b.length) return false;
                for(i = length2 - 1; i >= 0; i--){
                    if (!_DataController.deepEqual(a[i], b[i])) return false;
                }
                return true;
            }
            const keys = Object.keys(a);
            length2 = keys.length;
            if (length2 !== Object.keys(b).length) return false;
            for(i = length2 - 1; i >= 0; i--){
                const key = keys[i];
                if (!_DataController.skipKeys.has(key) && (!Object.hasOwn(b, key) || !_DataController.deepEqual(a[key], b[key]))) return false;
            }
            return true;
        }
        return false;
    }
};
// optimized version of deep equality for `mergeRequests` which can potentially loop over 1M times
$d77b025aa58d633c$var$_DataController.skipKeys = /* @__PURE__ */ new Set([
    "id",
    "idsMap",
    "type",
    "scopes",
    "data"
]);
var $d77b025aa58d633c$var$DataController = $d77b025aa58d633c$var$_DataController;
// packages/ag-charts-community/src/chart/factory/axisRegistry.ts
var $d77b025aa58d633c$var$AxisRegistry = class {
    constructor(){
        this.axesMap = /* @__PURE__ */ new Map();
        this.themeTemplates = /* @__PURE__ */ new Map();
    }
    register(axisType, module) {
        this.axesMap.set(axisType, module.moduleFactory);
        if (module.themeTemplate) this.setThemeTemplate(axisType, module.themeTemplate);
    }
    create(axisType, moduleContext) {
        const axisFactory = this.axesMap.get(axisType);
        if (axisFactory) return axisFactory(moduleContext);
        throw new Error(`AG Charts - unknown axis type: ${axisType}`);
    }
    has(axisType) {
        return this.axesMap.has(axisType);
    }
    keys() {
        return this.axesMap.keys();
    }
    setThemeTemplate(axisType, themeTemplate) {
        this.themeTemplates.set(axisType, themeTemplate);
        return this;
    }
    getThemeTemplate(axisType) {
        return this.themeTemplates.get(axisType);
    }
};
var $d77b025aa58d633c$var$axisRegistry = new $d77b025aa58d633c$var$AxisRegistry();
// packages/ag-charts-community/src/chart/factory/expectedEnterpriseModules.ts
var $d77b025aa58d633c$var$EXPECTED_ENTERPRISE_MODULES = [
    {
        type: "root",
        optionsKey: "animation",
        chartTypes: [
            "cartesian",
            "polar",
            "hierarchy",
            "topology",
            "flow-proportion",
            "standalone",
            "gauge"
        ]
    },
    {
        type: "root",
        optionsKey: "annotations",
        chartTypes: [
            "cartesian"
        ]
    },
    {
        type: "root",
        optionsKey: "background",
        chartTypes: [
            "cartesian",
            "polar",
            "hierarchy",
            "topology",
            "flow-proportion",
            "standalone",
            "gauge"
        ],
        optionsInnerKey: "image"
    },
    {
        type: "root",
        optionsKey: "foreground",
        chartTypes: [
            "cartesian",
            "polar",
            "hierarchy",
            "topology",
            "flow-proportion",
            "standalone",
            "gauge"
        ],
        optionsInnerKey: "image"
    },
    {
        type: "root",
        optionsKey: "chartToolbar",
        chartTypes: [
            "cartesian"
        ]
    },
    {
        type: "root",
        optionsKey: "contextMenu",
        chartTypes: [
            "cartesian",
            "polar",
            "hierarchy",
            "topology",
            "flow-proportion",
            "standalone",
            "gauge"
        ]
    },
    {
        type: "root",
        optionsKey: "statusBar",
        chartTypes: [
            "cartesian"
        ],
        identifier: "status-bar"
    },
    {
        type: "root",
        optionsKey: "dataSource",
        chartTypes: [
            "cartesian",
            "polar",
            "hierarchy",
            "topology",
            "flow-proportion",
            "standalone",
            "gauge"
        ]
    },
    {
        type: "root",
        optionsKey: "sync",
        chartTypes: [
            "cartesian"
        ]
    },
    {
        type: "root",
        optionsKey: "zoom",
        chartTypes: [
            "cartesian",
            "topology"
        ]
    },
    {
        type: "root",
        optionsKey: "ranges",
        chartTypes: [
            "cartesian"
        ]
    },
    {
        type: "legend",
        optionsKey: "gradientLegend",
        chartTypes: [
            "cartesian",
            "polar",
            "hierarchy",
            "topology",
            "flow-proportion",
            "standalone",
            "gauge"
        ],
        identifier: "gradient"
    },
    {
        type: "root",
        optionsKey: "navigator",
        chartTypes: [
            "cartesian"
        ]
    },
    {
        type: "axis",
        optionsKey: "axes[]",
        chartTypes: [
            "polar"
        ],
        identifier: "angle-category"
    },
    {
        type: "axis",
        optionsKey: "axes[]",
        chartTypes: [
            "polar"
        ],
        identifier: "angle-number"
    },
    {
        type: "axis",
        optionsKey: "axes[]",
        chartTypes: [
            "polar"
        ],
        identifier: "radius-category"
    },
    {
        type: "axis",
        optionsKey: "axes[]",
        chartTypes: [
            "polar"
        ],
        identifier: "radius-number"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "bar",
        community: true
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "line",
        community: true
    },
    {
        type: "axis",
        optionsKey: "axes[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "ordinal-time"
    },
    {
        type: "axis-option",
        optionsKey: "crosshair",
        chartTypes: [
            "cartesian"
        ]
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "box-plot"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "candlestick"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "cone-funnel"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "funnel"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "ohlc"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "heatmap"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "range-area"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "range-bar"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "waterfall"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "polar"
        ],
        identifier: "nightingale"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "polar"
        ],
        identifier: "radar-area"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "polar"
        ],
        identifier: "radar-line"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "polar"
        ],
        identifier: "radial-bar"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "polar"
        ],
        identifier: "radial-column"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "hierarchy"
        ],
        identifier: "sunburst"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "hierarchy"
        ],
        identifier: "treemap"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "topology"
        ],
        identifier: "map-shape"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "topology"
        ],
        identifier: "map-line"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "topology"
        ],
        identifier: "map-marker"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "topology"
        ],
        identifier: "map-shape-background"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "topology"
        ],
        identifier: "map-line-background"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "flow-proportion"
        ],
        identifier: "chord"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "flow-proportion"
        ],
        identifier: "sankey"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "standalone"
        ],
        identifier: "pyramid"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "gauge"
        ],
        identifier: "linear-gauge"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "gauge"
        ],
        identifier: "radial-gauge"
    },
    {
        type: "series-option",
        optionsKey: "errorBar",
        chartTypes: [
            "cartesian"
        ],
        identifier: "error-bars"
    },
    {
        type: "context",
        contextKey: "sharedToolbar",
        chartTypes: [
            "cartesian"
        ]
    }
];
function $d77b025aa58d633c$var$getEnterpriseSeriesChartTypes(type) {
    return $d77b025aa58d633c$var$EXPECTED_ENTERPRISE_MODULES.find((s)=>s.type === "series" && s.identifier === type)?.chartTypes;
}
function $d77b025aa58d633c$var$isEnterpriseCartesian(seriesType) {
    const type = $d77b025aa58d633c$var$getEnterpriseSeriesChartTypes(seriesType)?.find((v)=>v === "cartesian");
    return type === "cartesian";
}
function $d77b025aa58d633c$var$isEnterprisePolar(seriesType) {
    const type = $d77b025aa58d633c$var$getEnterpriseSeriesChartTypes(seriesType)?.find((v)=>v === "polar");
    return type === "polar";
}
function $d77b025aa58d633c$var$isEnterpriseHierarchy(seriesType) {
    const type = $d77b025aa58d633c$var$getEnterpriseSeriesChartTypes(seriesType)?.find((v)=>v === "hierarchy");
    return type === "hierarchy";
}
function $d77b025aa58d633c$var$isEnterpriseTopology(seriesType) {
    const type = $d77b025aa58d633c$var$getEnterpriseSeriesChartTypes(seriesType)?.find((v)=>v === "topology");
    return type === "topology";
}
function $d77b025aa58d633c$var$isEnterpriseFlowProportion(seriesType) {
    const type = $d77b025aa58d633c$var$getEnterpriseSeriesChartTypes(seriesType)?.find((v)=>v === "flow-proportion");
    return type === "flow-proportion";
}
function $d77b025aa58d633c$var$isEnterpriseStandalone(seriesType) {
    const type = $d77b025aa58d633c$var$getEnterpriseSeriesChartTypes(seriesType)?.find((v)=>v === "standalone");
    return type === "standalone";
}
function $d77b025aa58d633c$var$isEnterpriseGauge(seriesType) {
    const type = $d77b025aa58d633c$var$getEnterpriseSeriesChartTypes(seriesType)?.find((v)=>v === "gauge");
    return type === "gauge";
}
function $d77b025aa58d633c$var$isEnterpriseModule(module) {
    return module.packageType === "enterprise";
}
function $d77b025aa58d633c$var$verifyIfModuleExpected(module) {
    if (!$d77b025aa58d633c$var$isEnterpriseModule(module)) throw new Error("AG Charts - internal configuration error, only enterprise modules need verification.");
    const stub = $d77b025aa58d633c$var$EXPECTED_ENTERPRISE_MODULES.find((s)=>{
        return s.type === module.type && ("optionsKey" in s && "optionsKey" in module ? s.optionsKey === module.optionsKey : true) && ("contextKey" in s && "contextKey" in module ? s.contextKey === module.contextKey : true) && s.identifier === module.identifier && module.chartTypes.every((t)=>s.chartTypes.includes(t));
    });
    if (stub) {
        stub.useCount ?? (stub.useCount = 0);
        stub.useCount++;
    }
    return stub != null;
}
function $d77b025aa58d633c$var$getUnusedExpectedModules() {
    return $d77b025aa58d633c$var$EXPECTED_ENTERPRISE_MODULES.filter(({ useCount: useCount })=>useCount == null || useCount === 0);
}
// packages/ag-charts-community/src/chart/factory/legendRegistry.ts
var $d77b025aa58d633c$var$LegendRegistry = class {
    constructor(){
        this.legendMap = /* @__PURE__ */ new Map();
        this.themeTemplates = /* @__PURE__ */ new Map();
    }
    register(legendType, { optionsKey: optionsKey, moduleFactory: moduleFactory, themeTemplate: themeTemplate }) {
        this.legendMap.set(legendType, {
            optionsKey: optionsKey,
            moduleFactory: moduleFactory
        });
        this.themeTemplates.set(optionsKey, themeTemplate);
    }
    create(legendType, moduleContext) {
        const legendFactory = this.legendMap.get(legendType)?.moduleFactory;
        if (legendFactory) return legendFactory(moduleContext);
        throw new Error(`AG Charts - unknown legend type: ${legendType}`);
    }
    getThemeTemplates() {
        return Object.fromEntries(this.themeTemplates);
    }
    getKeys() {
        return Array.from(this.legendMap.entries()).reduce((result, [legendType, record])=>{
            result[legendType] = record.optionsKey;
            return result;
        }, {});
    }
};
var $d77b025aa58d633c$var$legendRegistry = new $d77b025aa58d633c$var$LegendRegistry();
// packages/ag-charts-community/src/chart/factory/chartTypes.ts
var $d77b025aa58d633c$var$ChartTypes = class extends Map {
    get(seriesType) {
        return super.get(seriesType) ?? "unknown";
    }
    isCartesian(seriesType) {
        return this.get(seriesType) === "cartesian";
    }
    isPolar(seriesType) {
        return this.get(seriesType) === "polar";
    }
    isHierarchy(seriesType) {
        return this.get(seriesType) === "hierarchy";
    }
    isTopology(seriesType) {
        return this.get(seriesType) === "topology";
    }
    isFlowProportion(seriesType) {
        return this.get(seriesType) === "flow-proportion";
    }
    isStandalone(seriesType) {
        return this.get(seriesType) === "standalone";
    }
    isGauge(seriesType) {
        return this.get(seriesType) === "gauge";
    }
    get seriesTypes() {
        return Array.from(this.keys());
    }
    get cartesianTypes() {
        return this.seriesTypes.filter((t)=>this.isCartesian(t));
    }
    get polarTypes() {
        return this.seriesTypes.filter((t)=>this.isPolar(t));
    }
    get hierarchyTypes() {
        return this.seriesTypes.filter((t)=>this.isHierarchy(t));
    }
    get topologyTypes() {
        return this.seriesTypes.filter((t)=>this.isTopology(t));
    }
    get flowProportionTypes() {
        return this.seriesTypes.filter((t)=>this.isFlowProportion(t));
    }
    get standaloneTypes() {
        return this.seriesTypes.filter((t)=>this.isStandalone(t));
    }
    get gaugeTypes() {
        return this.seriesTypes.filter((t)=>this.isGauge(t));
    }
};
var $d77b025aa58d633c$var$ChartDefaults = class extends Map {
    set(chartType, defaults) {
        return super.set(chartType, $d77b025aa58d633c$var$mergeDefaults(defaults, this.get(chartType)));
    }
};
var $d77b025aa58d633c$var$chartTypes2 = new $d77b025aa58d633c$var$ChartTypes();
var $d77b025aa58d633c$var$publicChartTypes = new $d77b025aa58d633c$var$ChartTypes();
var $d77b025aa58d633c$var$chartDefaults = new $d77b025aa58d633c$var$ChartDefaults();
// packages/ag-charts-community/src/chart/factory/seriesRegistry.ts
var $d77b025aa58d633c$var$SeriesRegistry = class {
    constructor(){
        this.seriesMap = /* @__PURE__ */ new Map();
        this.themeTemplates = /* @__PURE__ */ new Map();
    }
    register(seriesType, { chartTypes: [chartType], moduleFactory: moduleFactory, tooltipDefaults: tooltipDefaults, defaultAxes: defaultAxes, themeTemplate: themeTemplate, solo: solo, stackable: stackable, groupable: groupable, stackedByDefault: stackedByDefault, hidden: hidden }) {
        this.setThemeTemplate(seriesType, themeTemplate);
        this.seriesMap.set(seriesType, {
            moduleFactory: moduleFactory,
            tooltipDefaults: tooltipDefaults,
            defaultAxes: defaultAxes,
            solo: solo,
            stackable: stackable,
            groupable: groupable,
            stackedByDefault: stackedByDefault
        });
        $d77b025aa58d633c$var$chartTypes2.set(seriesType, chartType);
        if (!hidden) $d77b025aa58d633c$var$publicChartTypes.set(seriesType, chartType);
    }
    create(seriesType, moduleContext) {
        const seriesFactory = this.seriesMap.get(seriesType)?.moduleFactory;
        if (seriesFactory) return seriesFactory(moduleContext);
        throw new Error(`AG Charts - unknown series type: ${seriesType}`);
    }
    cloneDefaultAxes(seriesType) {
        const defaultAxes = this.seriesMap.get(seriesType)?.defaultAxes;
        if (defaultAxes == null) return null;
        return {
            axes: $d77b025aa58d633c$var$deepClone(defaultAxes)
        };
    }
    setThemeTemplate(seriesType, themeTemplate) {
        const currentTemplate = this.themeTemplates.get(seriesType);
        this.themeTemplates.set(seriesType, $d77b025aa58d633c$var$mergeDefaults(themeTemplate, currentTemplate));
    }
    getThemeTemplate(seriesType) {
        return this.themeTemplates.get(seriesType);
    }
    getTooltipDefauls(seriesType) {
        return this.seriesMap.get(seriesType)?.tooltipDefaults;
    }
    isSolo(seriesType) {
        return this.seriesMap.get(seriesType)?.solo ?? false;
    }
    isGroupable(seriesType) {
        return this.seriesMap.get(seriesType)?.groupable ?? false;
    }
    isStackable(seriesType) {
        return this.seriesMap.get(seriesType)?.stackable ?? false;
    }
    isStackedByDefault(seriesType) {
        return this.seriesMap.get(seriesType)?.stackedByDefault ?? false;
    }
};
var $d77b025aa58d633c$var$seriesRegistry = new $d77b025aa58d633c$var$SeriesRegistry();
// packages/ag-charts-community/src/chart/interaction/syncManager.ts
var $d77b025aa58d633c$var$_SyncManager = class _SyncManager extends $d77b025aa58d633c$var$BaseManager {
    constructor(chart){
        super();
        this.chart = chart;
    }
    subscribe(groupId = _SyncManager.DEFAULT_GROUP) {
        let syncGroup = this.get(groupId);
        if (!syncGroup) {
            syncGroup = {
                members: /* @__PURE__ */ new Set()
            };
            _SyncManager.chartsGroups.set(groupId, syncGroup);
        }
        syncGroup.members.add(this.chart);
        return this;
    }
    unsubscribe(groupId = _SyncManager.DEFAULT_GROUP) {
        const groupState = this.get(groupId);
        groupState?.members.delete(this.chart);
        delete groupState?.domains?.x?.sources?.[this.chart.id];
        delete groupState?.domains?.y?.sources?.[this.chart.id];
        return this;
    }
    getChart() {
        return this.chart;
    }
    getGroupState(groupId = _SyncManager.DEFAULT_GROUP) {
        return this.get(groupId);
    }
    getGroupMembers(groupId = _SyncManager.DEFAULT_GROUP) {
        const syncGroup = this.get(groupId);
        return syncGroup ? Array.from(syncGroup.members) : [];
    }
    getGroupSiblings(groupId = _SyncManager.DEFAULT_GROUP) {
        return this.getGroupMembers(groupId).filter((chart)=>chart !== this.chart);
    }
    getGroupSyncMode(groupId = _SyncManager.DEFAULT_GROUP) {
        if (this.getGroupMembers(groupId).some((c)=>c.series.length > 1)) return "multi-series";
        return "single-series";
    }
    get(groupId) {
        return _SyncManager.chartsGroups.get(groupId);
    }
};
$d77b025aa58d633c$var$_SyncManager.chartsGroups = /* @__PURE__ */ new Map();
$d77b025aa58d633c$var$_SyncManager.DEFAULT_GROUP = Symbol("sync-group-default");
var $d77b025aa58d633c$var$SyncManager = $d77b025aa58d633c$var$_SyncManager;
// packages/ag-charts-community/src/chart/keyboard.ts
var $d77b025aa58d633c$var$Keyboard = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.enabled = false;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Keyboard.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Keyboard.prototype, "tabIndex", 2);
// packages/ag-charts-community/src/motion/fromToMotion.ts
var $d77b025aa58d633c$var$fromToMotion_exports = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$var$fromToMotion_exports, {
    NODE_UPDATE_STATE_TO_PHASE_MAPPING: ()=>$d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING,
    fromToMotion: ()=>$d77b025aa58d633c$var$fromToMotion,
    staticFromToMotion: ()=>$d77b025aa58d633c$var$staticFromToMotion
});
var $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING = {
    added: "add",
    updated: "update",
    removed: "remove",
    unknown: "initial",
    "no-op": "none"
};
function $d77b025aa58d633c$var$fromToMotion(groupId, subId, animationManager, selectionsOrNodes, fns, getDatumId, diff2) {
    const { fromFn: fromFn, toFn: toFn, applyFn: applyFn = (node, props)=>node.setProperties(props) } = fns;
    const { nodes: nodes, selections: selections } = $d77b025aa58d633c$var$deconstructSelectionsOrNodes(selectionsOrNodes);
    const processNodes = (liveNodes, subNodes)=>{
        let prevFromProps;
        let liveNodeIndex = 0;
        let nodeIndex = 0;
        for (const node of subNodes){
            const isLive = liveNodes[liveNodeIndex] === node;
            const ctx = {
                last: nodeIndex >= subNodes.length - 1,
                lastLive: liveNodeIndex >= liveNodes.length - 1,
                prev: subNodes[nodeIndex - 1],
                prevFromProps: prevFromProps,
                prevLive: liveNodes[liveNodeIndex - 1],
                next: subNodes[nodeIndex + 1],
                nextLive: liveNodes[liveNodeIndex + (isLive ? 1 : 0)]
            };
            const animationId = `${groupId}_${subId}_${node.id}`;
            animationManager.stopByAnimationId(animationId);
            let status = "unknown";
            if (!isLive) status = "removed";
            else if (getDatumId && diff2) status = $d77b025aa58d633c$var$calculateStatus(node, node.datum, getDatumId, diff2);
            node.transitionOut = status === "removed";
            const { phase: phase, start: start2, finish: finish, delay: delay, duration: duration, ...from3 } = fromFn(node, node.datum, status, ctx);
            const { phase: toPhase, start: toStart, finish: toFinish, delay: toDelay, duration: toDuration, ...to } = toFn(node, node.datum, status, ctx);
            const collapsable = finish == null;
            animationManager.animate({
                id: animationId,
                groupId: groupId,
                phase: phase ?? toPhase ?? "update",
                duration: duration ?? toDuration,
                delay: delay ?? toDelay,
                from: from3,
                to: to,
                ease: $d77b025aa58d633c$var$easeOut,
                collapsable: collapsable,
                onPlay: ()=>{
                    const startProps = {
                        ...start2,
                        ...toStart,
                        ...from3
                    };
                    applyFn(node, startProps, "start");
                },
                onUpdate (props) {
                    applyFn(node, props, "update");
                },
                onStop: ()=>{
                    const endProps = {
                        ...start2,
                        ...toStart,
                        ...from3,
                        ...to,
                        ...finish,
                        ...toFinish
                    };
                    applyFn(node, endProps, "end");
                }
            });
            if (isLive) liveNodeIndex++;
            nodeIndex++;
            prevFromProps = from3;
        }
    };
    let selectionIndex = 0;
    for (const selection of selections){
        const selectionNodes = selection.nodes();
        const liveNodes = selectionNodes.filter((n)=>!selection.isGarbage(n));
        processNodes(liveNodes, selectionNodes);
        animationManager.animate({
            id: `${groupId}_${subId}_selection_${selectionIndex}`,
            groupId: groupId,
            phase: "end",
            from: 0,
            to: 1,
            ease: $d77b025aa58d633c$var$easeOut,
            onStop () {
                selection.cleanup();
            }
        });
        selectionIndex++;
    }
    processNodes(nodes, nodes);
}
function $d77b025aa58d633c$var$staticFromToMotion(groupId, subId, animationManager, selectionsOrNodes, from3, to, extraOpts) {
    const { nodes: nodes, selections: selections } = $d77b025aa58d633c$var$deconstructSelectionsOrNodes(selectionsOrNodes);
    const { start: start2, finish: finish, phase: phase } = extraOpts;
    animationManager.animate({
        id: `${groupId}_${subId}`,
        groupId: groupId,
        phase: phase ?? "update",
        from: from3,
        to: to,
        ease: $d77b025aa58d633c$var$easeOut,
        onPlay: ()=>{
            if (!start2) return;
            for (const node of nodes)node.setProperties(start2);
            for (const selection of selections)for (const node of selection.nodes())node.setProperties(start2);
        },
        onUpdate (props) {
            for (const node of nodes)node.setProperties(props);
            for (const selection of selections)for (const node of selection.nodes())node.setProperties(props);
        },
        onStop: ()=>{
            for (const node of nodes)node.setProperties({
                ...to,
                ...finish
            });
            for (const selection of selections){
                for (const node of selection.nodes())node.setProperties({
                    ...to,
                    ...finish
                });
                selection.cleanup();
            }
        }
    });
}
function $d77b025aa58d633c$var$calculateStatus(node, datum, getDatumId, diff2) {
    const id = getDatumId(node, datum);
    if (diff2.added.has(id)) return "added";
    if (diff2.removed.has(id)) return "removed";
    if (node.previousDatum == null && node.datum != null) return "added";
    if (node.previousDatum != null && node.datum == null) return "removed";
    return "updated";
}
// packages/ag-charts-community/src/motion/resetMotion.ts
var $d77b025aa58d633c$var$resetMotion_exports = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$var$resetMotion_exports, {
    resetMotion: ()=>$d77b025aa58d633c$var$resetMotion
});
function $d77b025aa58d633c$var$resetMotion(selectionsOrNodes, propsFn) {
    const { nodes: nodes, selections: selections } = $d77b025aa58d633c$var$deconstructSelectionsOrNodes(selectionsOrNodes);
    for (const selection of selections){
        for (const node of selection.nodes()){
            const from3 = propsFn(node, node.datum);
            node.setProperties(from3);
        }
        selection.cleanup();
    }
    for (const node of nodes){
        const from3 = propsFn(node, node.datum);
        node.setProperties(from3);
    }
}
// packages/ag-charts-community/src/scene/selection.ts
var $d77b025aa58d633c$var$Selection = class _Selection {
    constructor(parentNode, classOrFactory, autoCleanup = true){
        this.parentNode = parentNode;
        this.autoCleanup = autoCleanup;
        this.garbageBin = /* @__PURE__ */ new Set();
        this._nodesMap = /* @__PURE__ */ new Map();
        this._nodes = [];
        this.data = [];
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "scene", "scene:selections");
        this.nodeFactory = Object.prototype.isPrototypeOf.call($d77b025aa58d633c$var$Node2, classOrFactory) ? ()=>new classOrFactory() : classOrFactory;
    }
    static select(parent, classOrFactory, garbageCollection = true) {
        return new _Selection(parent, classOrFactory, garbageCollection);
    }
    static selectAll(parent, predicate) {
        const results = [];
        const traverse = (node)=>{
            if (predicate(node)) results.push(node);
            for (const child of node.children())traverse(child);
        };
        traverse(parent);
        return results;
    }
    static selectByClass(node, ...Classes) {
        return _Selection.selectAll(node, (n)=>Classes.some((C2)=>n instanceof C2));
    }
    static selectByTag(node, tag) {
        return _Selection.selectAll(node, (n)=>n.tag === tag);
    }
    createNode(datum, initializer, idx) {
        const node = this.nodeFactory(datum);
        node.datum = datum;
        initializer?.(node);
        if (idx == null) this._nodes.push(node);
        else this._nodes.splice(idx, 0, node);
        this.parentNode.appendChild(node);
        return node;
    }
    /**
   * Update the data in a selection. If an `getDatumId()` function is provided, maintain a list of ids related to
   * the nodes. Otherwise, take the more efficient route of simply creating and destroying nodes at the end
   * of the array.
   */ update(data, initializer, getDatumId) {
        if (this.garbageBin.size > 0) this.debug(`Selection - update() called with pending garbage`, data);
        if (getDatumId) {
            const dataMap = new Map(data.map((datum, idx)=>[
                    getDatumId(datum),
                    [
                        datum,
                        idx
                    ]
                ]));
            for (const [node, datumId] of this._nodesMap.entries())if (dataMap.has(datumId)) {
                const [newDatum] = dataMap.get(datumId);
                node.datum = newDatum;
                this.garbageBin.delete(node);
                dataMap.delete(datumId);
            } else this.garbageBin.add(node);
            for (const [datumId, [datum, idx]] of dataMap.entries())this._nodesMap.set(this.createNode(datum, initializer, idx), datumId);
        } else {
            const maxLength = Math.max(data.length, this.data.length);
            for(let i = 0; i < maxLength; i++){
                if (i >= data.length) this.garbageBin.add(this._nodes[i]);
                else if (i >= this._nodes.length) this.createNode(data[i], initializer);
                else {
                    this._nodes[i].datum = data[i];
                    this.garbageBin.delete(this._nodes[i]);
                }
            }
        }
        this.data = data.slice();
        if (this.autoCleanup) this.cleanup();
        return this;
    }
    cleanup() {
        if (this.garbageBin.size === 0) return this;
        this._nodes = this._nodes.filter((node)=>{
            if (this.garbageBin.has(node)) {
                this._nodesMap.delete(node);
                this.garbageBin.delete(node);
                node.destroy();
                return false;
            }
            return true;
        });
        return this;
    }
    clear() {
        this.update([]);
        return this;
    }
    isGarbage(node) {
        return this.garbageBin.has(node);
    }
    each(iterate3) {
        for (const entry of this._nodes.entries())iterate3(entry[1], entry[1].datum, entry[0]);
        return this;
    }
    *[Symbol.iterator]() {
        for(let index = 0; index < this._nodes.length; index++){
            const node = this._nodes[index];
            yield {
                node: node,
                datum: node.datum,
                index: index
            };
        }
    }
    select(predicate) {
        return _Selection.selectAll(this.parentNode, predicate);
    }
    selectByClass(Class) {
        return _Selection.selectByClass(this.parentNode, Class);
    }
    selectByTag(tag) {
        return _Selection.selectByTag(this.parentNode, tag);
    }
    nodes() {
        return this._nodes;
    }
    at(index) {
        return this._nodes.at(index);
    }
    get length() {
        return this._nodes.length;
    }
};
var $d77b025aa58d633c$var$Line = class extends $d77b025aa58d633c$var$Shape {
    constructor(opts = {}){
        super(opts);
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.restoreOwnStyles();
    }
    set x(value) {
        this.x1 = value;
        this.x2 = value;
    }
    set y(value) {
        this.y1 = value;
        this.y2 = value;
    }
    get midPoint() {
        return {
            x: (this.x1 + this.x2) / 2,
            y: (this.y1 + this.y2) / 2
        };
    }
    computeBBox() {
        return new $d77b025aa58d633c$var$BBox(Math.min(this.x1, this.x2), Math.min(this.y1, this.y2), Math.abs(this.x2 - this.x1), Math.abs(this.y2 - this.y1));
    }
    isPointInPath(x, y) {
        if (this.x1 === this.x2 || this.y1 === this.y2) return this.getBBox().clone().grow(this.strokeWidth / 2).containsPoint(x, y);
        return false;
    }
    distanceSquared(px, py) {
        const { x1: x1, y1: y1, x2: x2, y2: y2 } = this;
        return $d77b025aa58d633c$var$lineDistanceSquared(px, py, x1, y1, x2, y2, Infinity);
    }
    render(renderCtx) {
        const { ctx: ctx, devicePixelRatio: devicePixelRatio } = renderCtx;
        let { x1: x1, y1: y1, x2: x2, y2: y2 } = this;
        if (x1 === x2) {
            const { strokeWidth: strokeWidth } = this;
            const x = Math.round(x1 * devicePixelRatio) / devicePixelRatio + Math.trunc(strokeWidth * devicePixelRatio) % 2 / (devicePixelRatio * 2);
            x1 = x;
            x2 = x;
        } else if (y1 === y2) {
            const { strokeWidth: strokeWidth } = this;
            const y = Math.round(y1 * devicePixelRatio) / devicePixelRatio + Math.trunc(strokeWidth * devicePixelRatio) % 2 / (devicePixelRatio * 2);
            y1 = y;
            y2 = y;
        }
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        this.fillStroke(ctx);
        this.fillShadow?.markClean();
        super.render(renderCtx);
    }
    toSVG() {
        if (!this.visible) return;
        const element2 = (0, $idDdm.createSvgElement)("line");
        element2.setAttribute("x1", String(this.x1));
        element2.setAttribute("y1", String(this.y1));
        element2.setAttribute("x2", String(this.x2));
        element2.setAttribute("y2", String(this.y2));
        this.applySvgStrokeAttributes(element2);
        return {
            elements: [
                element2
            ]
        };
    }
};
$d77b025aa58d633c$var$Line.className = "Line";
$d77b025aa58d633c$var$Line.defaultStyles = {
    ...$d77b025aa58d633c$var$Shape.defaultStyles,
    fill: void 0,
    strokeWidth: 1
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Line.prototype, "x1", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Line.prototype, "y1", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Line.prototype, "x2", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Line.prototype, "y2", 2);
// packages/ag-charts-community/src/util/stateMachine.ts
var $d77b025aa58d633c$var$debugColor = "color: green";
var $d77b025aa58d633c$var$debugQuietColor = "color: grey";
function $d77b025aa58d633c$var$StateMachineProperty() {
    return $d77b025aa58d633c$var$addObserverToInstanceProperty(()=>{});
}
function $d77b025aa58d633c$var$applyProperties(parentState, childState) {
    const childProperties = $d77b025aa58d633c$var$listDecoratedProperties(childState);
    if (childProperties.length === 0) return;
    const properties = $d77b025aa58d633c$var$extractDecoratedProperties(parentState);
    for (const property of childProperties)if (property in properties) childState[property] = properties[property];
}
var $d77b025aa58d633c$var$AbstractStateMachine = class {
    transitionRoot(event, data) {
        if (this.parent) this.parent.transitionRoot(event, data);
        else this.transition(event, data);
    }
};
var $d77b025aa58d633c$var$_StateMachine = class _StateMachine extends $d77b025aa58d633c$var$AbstractStateMachine {
    constructor(defaultState, states, enterEach){
        super();
        this.defaultState = defaultState;
        this.states = states;
        this.enterEach = enterEach;
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "animation");
        this.state = defaultState;
        this.debug(`%c${this.constructor.name} | init -> ${defaultState}`, $d77b025aa58d633c$var$debugColor);
    }
    // TODO: handle events which do not require data without requiring `undefined` to be passed as as parameter, while
    // also still requiring data to be passed to those events which do require it.
    transition(event, data) {
        const shouldTransitionSelf = this.transitionChild(event, data);
        if (!shouldTransitionSelf || this.state === _StateMachine.child || this.state === _StateMachine.parent) return;
        const currentState = this.state;
        const currentStateConfig = this.states[this.state];
        let destination = currentStateConfig[event];
        const debugPrefix = `%c${this.constructor.name} | ${this.state} -> ${event} ->`;
        if (Array.isArray(destination)) destination = destination.find((transition)=>{
            if (!transition.guard) return true;
            const valid = transition.guard(data);
            if (!valid) this.debug(`${debugPrefix} (guarded)`, transition.target, $d77b025aa58d633c$var$debugQuietColor);
            return valid;
        });
        else if (typeof destination === "object" && !(destination instanceof _StateMachine) && destination.guard && !destination.guard(data)) {
            this.debug(`${debugPrefix} (guarded)`, destination.target, $d77b025aa58d633c$var$debugQuietColor);
            return;
        }
        if (!destination) {
            this.debug(`${debugPrefix} ${this.state}`, $d77b025aa58d633c$var$debugQuietColor);
            return;
        }
        const destinationState = this.getDestinationState(destination);
        const exitFn = destinationState === this.state ? void 0 : currentStateConfig.onExit;
        this.debug(`${debugPrefix} ${destinationState}`, $d77b025aa58d633c$var$debugColor);
        this.state = destinationState;
        if (typeof destination === "function") destination(data);
        else if (typeof destination === "object" && !(destination instanceof _StateMachine)) destination.action?.(data);
        exitFn?.();
        this.enterEach?.(currentState, destinationState);
        if (destinationState !== currentState && destinationState !== _StateMachine.child && destinationState !== _StateMachine.parent) this.states[destinationState].onEnter?.(currentState, data);
    }
    transitionAsync(event, data) {
        setTimeout(()=>{
            this.transition(event, data);
        }, 0);
    }
    is(value) {
        if (this.state === _StateMachine.child && this.childState) return this.childState.is(value);
        return this.state === value;
    }
    resetHierarchy() {
        this.debug(`%c${this.constructor.name} | ${this.state} -> [resetHierarchy] -> ${this.defaultState}`, "color: green");
        this.state = this.defaultState;
    }
    transitionChild(event, data) {
        if (this.state !== _StateMachine.child || !this.childState) return true;
        $d77b025aa58d633c$var$applyProperties(this, this.childState);
        this.childState.transition(event, data);
        if (!this.childState.is(_StateMachine.parent)) return true;
        this.debug(`%c${this.constructor.name} | ${this.state} -> ${event} -> ${this.defaultState}`, $d77b025aa58d633c$var$debugColor);
        this.state = this.defaultState;
        this.states[this.state].onEnter?.();
        this.childState.resetHierarchy();
        return false;
    }
    getDestinationState(destination) {
        let state = this.state;
        if (typeof destination === "string") state = destination;
        else if (destination instanceof _StateMachine) {
            this.childState = destination;
            this.childState.parent = this;
            state = _StateMachine.child;
        } else if (typeof destination === "object") {
            if (destination.target instanceof _StateMachine) {
                this.childState = destination.target;
                this.childState.parent = this;
                state = _StateMachine.child;
            } else if (destination.target != null) state = destination.target;
        }
        return state;
    }
};
$d77b025aa58d633c$var$_StateMachine.child = "__child";
$d77b025aa58d633c$var$_StateMachine.parent = "__parent";
var $d77b025aa58d633c$var$StateMachine = $d77b025aa58d633c$var$_StateMachine;
var $d77b025aa58d633c$var$ParallelStateMachine = class extends $d77b025aa58d633c$var$AbstractStateMachine {
    constructor(...stateMachines){
        super();
        this.stateMachines = stateMachines;
        for (const stateMachine of stateMachines)stateMachine.parent = this;
    }
    transition(event, data) {
        for (const stateMachine of this.stateMachines){
            $d77b025aa58d633c$var$applyProperties(this, stateMachine);
            stateMachine.transition(event, data);
        }
    }
    transitionAsync(event, data) {
        for (const stateMachine of this.stateMachines){
            $d77b025aa58d633c$var$applyProperties(this, stateMachine);
            stateMachine.transitionAsync(event, data);
        }
    }
};
var $d77b025aa58d633c$var$ModuleMap = class {
    constructor(){
        this.moduleMap = /* @__PURE__ */ new Map();
    }
    *modules() {
        for (const m of this.moduleMap.values())yield m.moduleInstance;
    }
    addModule(module, moduleFactory) {
        if (this.moduleMap.has(module.optionsKey)) throw new Error(`AG Charts - module already initialised: ${module.optionsKey}`);
        this.moduleMap.set(module.optionsKey, {
            module: module,
            moduleInstance: moduleFactory(module)
        });
    }
    removeModule(module) {
        const moduleKey = (0, $idDdm.isString)(module) ? module : module.optionsKey;
        this.moduleMap.get(moduleKey)?.moduleInstance.destroy();
        this.moduleMap.delete(moduleKey);
    }
    getModule(module) {
        return this.moduleMap.get((0, $idDdm.isString)(module) ? module : module.optionsKey)?.moduleInstance;
    }
    isEnabled(module) {
        return this.moduleMap.has((0, $idDdm.isString)(module) ? module : module.optionsKey);
    }
    mapModules(callback8) {
        return Array.from(this.moduleMap.values(), (m, i)=>callback8(m.moduleInstance, i));
    }
    destroy() {
        for (const moduleKey of this.moduleMap.keys())this.moduleMap.get(moduleKey)?.moduleInstance.destroy();
        this.moduleMap.clear();
    }
};
// packages/ag-charts-community/src/util/timeInterop.ts
function $d77b025aa58d633c$var$intervalInstance(interval) {
    return typeof interval === "string" ? $d77b025aa58d633c$export$2da9be4cfdb689b1[interval] : interval;
}
function $d77b025aa58d633c$var$intervalUnit(interval) {
    return $d77b025aa58d633c$var$intervalInstance(interval).unit;
}
function $d77b025aa58d633c$var$intervalStep(interval) {
    return $d77b025aa58d633c$var$intervalInstance(interval).step;
}
function $d77b025aa58d633c$var$intervalHierarchy(interval) {
    return $d77b025aa58d633c$var$intervalInstance(interval).hierarchy;
}
function $d77b025aa58d633c$var$intervalMilliseconds(interval) {
    return $d77b025aa58d633c$var$intervalInstance(interval).milliseconds;
}
function $d77b025aa58d633c$var$intervalRange(interval, start2, stop, options) {
    return $d77b025aa58d633c$var$intervalInstance(interval).range(start2, stop, options);
}
function $d77b025aa58d633c$var$intervalFloor(interval, date6) {
    return $d77b025aa58d633c$var$intervalInstance(interval).floor(date6);
}
// packages/ag-charts-community/src/scale/unitTimeScale.ts
var $d77b025aa58d633c$var$_UnitTimeScale = class _UnitTimeScale extends $d77b025aa58d633c$var$DiscreteTimeScale {
    constructor(){
        super(...arguments);
        this.type = "unit-time";
        this._domain = [];
        /* eslint-enable */ this._bands = void 0;
    }
    static is(value) {
        return value instanceof _UnitTimeScale;
    }
    set domain(domain) {
        if (domain === this._domain) return;
        this._domain = domain;
        this._bands = void 0;
    }
    get domain() {
        return this._domain;
    }
    get interval() {
        return this._interval;
    }
    set interval(interval) {
        if (this._interval === interval) return;
        this._interval = interval;
        this._bands = void 0;
    }
    get bands() {
        this._bands ?? (this._bands = this.calculateBands(this._domain, [
            0,
            1
        ]));
        return this._bands;
    }
    normalizeDomains(...domains) {
        return $d77b025aa58d633c$var$normalizeContinuousDomains(...domains);
    }
    convert(d, options) {
        const { domain: domain, interval: interval } = this;
        if (domain.length < 2) return NaN;
        if (interval != null) {
            const t = d.valueOf();
            const [start2, stop] = this.calculateBandRange(domain, interval);
            const d0 = Math.min(start2.valueOf(), stop.valueOf());
            const d1 = Math.max(start2.valueOf(), stop.valueOf());
            if (t < d0 || t >= d1 + $d77b025aa58d633c$var$intervalMilliseconds(interval)) return NaN;
        }
        return super.convert(d, options);
    }
    calculateBandRange(domain, interval) {
        const start2 = $d77b025aa58d633c$var$intervalFloor(interval, domain[0]);
        const stop = $d77b025aa58d633c$var$intervalFloor(interval, domain[1]);
        return [
            start2,
            stop
        ];
    }
    calculateBands(domain, visibleRange, extend = false) {
        if (domain === this.domain && visibleRange[0] === 0 && visibleRange[1] === 1 && !extend && this._bands != null) return this._bands;
        if (domain.length < 2) return [];
        const { interval: interval } = this;
        if (interval == null) return [];
        const [start2, stop] = this.calculateBandRange(domain, interval);
        return $d77b025aa58d633c$var$intervalRange(interval, start2, stop, {
            visibleRange: visibleRange,
            extend: extend
        });
    }
    ticks({ interval: interval }, domain = this.domain, visibleRange = [
        0,
        1
    ], extend = false) {
        if (domain.length < 2) return;
        const bands = this.calculateBands(domain, visibleRange, extend);
        const milliseconds = this.interval ? $d77b025aa58d633c$var$intervalMilliseconds(this.interval) : Infinity;
        if (interval == null) return {
            ticks: bands,
            count: void 0
        };
        const d0 = Math.min(domain[0].valueOf(), domain[1].valueOf());
        const d1 = Math.max(domain[0].valueOf(), domain[1].valueOf());
        const ticks = [];
        let intervalTicks;
        let intervalStartIndex;
        let intervalEndIndex;
        if (interval instanceof $d77b025aa58d633c$var$TimeInterval) {
            intervalTicks = interval.range(domain[0], domain[1], {
                extend: true,
                visibleRange: visibleRange
            });
            intervalStartIndex = 0;
            intervalEndIndex = intervalTicks.length - 1;
        } else {
            intervalTicks = bands;
            intervalStartIndex = (0, $idDdm.findMaxIndex)(0, bands.length - 1, (index)=>bands[index].valueOf() <= d0) ?? 0;
            intervalEndIndex = (0, $idDdm.findMaxIndex)(0, bands.length - 1, (index)=>bands[index].valueOf() <= d1) ?? bands.length - 1;
        }
        let lastIndex;
        for(let i = intervalStartIndex; i <= intervalEndIndex; i++){
            const intervalTickValue = intervalTicks[i].valueOf();
            const bandIndex = (0, $idDdm.findMaxIndex)(0, bands.length - 1, (index)=>bands[index].valueOf() <= intervalTickValue);
            const tick = bandIndex != null && bandIndex != lastIndex ? bands[bandIndex] : void 0;
            lastIndex = bandIndex;
            if (tick != null && intervalTickValue - tick.getTime() <= milliseconds) ticks.push(tick);
        }
        let bandStart;
        let bandEnd;
        if (this.interval) {
            const bandRange = this.calculateBandRange([
                new Date(d0),
                new Date(d1)
            ], this.interval);
            bandStart = bandRange[0].valueOf();
            bandEnd = bandRange[1].valueOf();
        } else {
            bandStart = d0;
            bandEnd = d1;
        }
        let firstTickIndex = (0, $idDdm.findMinIndex)(0, ticks.length - 1, (i)=>ticks[i].valueOf() >= bandStart) ?? 0;
        let lastTickIndex = (0, $idDdm.findMaxIndex)(0, ticks.length - 1, (i)=>ticks[i].valueOf() <= bandEnd) ?? ticks.length - 1;
        if (extend) {
            firstTickIndex = Math.max(firstTickIndex - 1, 0);
            lastTickIndex = Math.min(lastTickIndex + 1, ticks.length - 1);
        }
        return {
            ticks: ticks.slice(firstTickIndex, lastTickIndex + 1),
            count: ticks.length
        };
    }
    findIndex(value) {
        const { bands: bands } = this;
        const target = value.valueOf();
        return (0, $idDdm.findMaxIndex)(0, bands.length - 1, (index)=>bands[index].valueOf() <= target);
    }
    datumFormatter(params) {
        const formatter = this.tickFormatter(params, 1);
        return (date6)=>{
            const index = this.findIndex(date6);
            return index != null ? formatter(this.bands[index]) : formatter(date6);
        };
    }
};
$d77b025aa58d633c$var$_UnitTimeScale.defaultTickCount = 12;
var $d77b025aa58d633c$var$UnitTimeScale = $d77b025aa58d633c$var$_UnitTimeScale;
// packages/ag-charts-community/src/util/date.ts
function $d77b025aa58d633c$var$compareDates(a, b) {
    return a.valueOf() - b.valueOf();
}
function $d77b025aa58d633c$var$deduplicateSortedArray(values) {
    let v0 = NaN;
    const out = [];
    for (const v of values){
        const v1 = v.valueOf();
        if (v0 !== v1) out.push(v);
        v0 = v1;
    }
    return out;
}
function $d77b025aa58d633c$var$sortAndUniqueDates(values) {
    const sortedValues = values.slice().sort($d77b025aa58d633c$var$compareDates);
    return $d77b025aa58d633c$var$datesSortOrder(sortedValues) == null ? $d77b025aa58d633c$var$deduplicateSortedArray(sortedValues) : sortedValues;
}
function $d77b025aa58d633c$var$datesSortOrder(d) {
    if (d.length === 0) return 1;
    const sign = Number(d[d.length - 1]) > Number(d[0]) ? 1 : -1;
    let v0 = -Infinity * sign;
    for (const v of d){
        const v1 = v.valueOf();
        if (Math.sign(v1 - v0) !== sign) return;
        v0 = v1;
    }
    return sign;
}
var $d77b025aa58d633c$var$tInterval = (timeInterval, baseDuration, step)=>({
        duration: baseDuration * step,
        timeInterval: timeInterval,
        step: step
    });
var $d77b025aa58d633c$var$TickIntervals = [
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$second, $d77b025aa58d633c$var$durationSecond, 1),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$second, $d77b025aa58d633c$var$durationSecond, 5),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$second, $d77b025aa58d633c$var$durationSecond, 15),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$second, $d77b025aa58d633c$var$durationSecond, 30),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$minute, $d77b025aa58d633c$var$durationMinute, 1),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$minute, $d77b025aa58d633c$var$durationMinute, 5),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$minute, $d77b025aa58d633c$var$durationMinute, 15),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$minute, $d77b025aa58d633c$var$durationMinute, 30),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$hour, $d77b025aa58d633c$var$durationHour, 1),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$hour, $d77b025aa58d633c$var$durationHour, 3),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$hour, $d77b025aa58d633c$var$durationHour, 6),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$hour, $d77b025aa58d633c$var$durationHour, 12),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$day, $d77b025aa58d633c$var$durationDay, 1),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$day, $d77b025aa58d633c$var$durationDay, 2),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$sunday, $d77b025aa58d633c$var$durationWeek, 1),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$sunday, $d77b025aa58d633c$var$durationWeek, 2),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$sunday, $d77b025aa58d633c$var$durationWeek, 3),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$month, $d77b025aa58d633c$var$durationMonth, 1),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$month, $d77b025aa58d633c$var$durationMonth, 2),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$month, $d77b025aa58d633c$var$durationMonth, 3),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$month, $d77b025aa58d633c$var$durationMonth, 4),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$month, $d77b025aa58d633c$var$durationMonth, 6),
    $d77b025aa58d633c$var$tInterval($d77b025aa58d633c$var$year, $d77b025aa58d633c$var$durationYear, 1)
];
var $d77b025aa58d633c$var$TickMultipliers = [
    1,
    2,
    5,
    10
];
function $d77b025aa58d633c$var$isCloseToInteger(n, delta3) {
    return Math.abs(Math.round(n) - n) < delta3;
}
function $d77b025aa58d633c$var$countTicks(d0, d1, step) {
    const extent2 = Math.abs(d1 - d0);
    return extent2 >= step ? Math.abs(d1 - d0) / step + 1 : 1;
}
function $d77b025aa58d633c$var$createTicks(start2, stop, count, minCount, maxCount, visibleRange) {
    if (start2 === stop) return {
        ticks: [
            start2
        ],
        count: 1
    };
    if (count < 2) return {
        ticks: [
            start2,
            stop
        ],
        count: 2
    };
    const step = $d77b025aa58d633c$var$tickStep(start2, stop, count, minCount, maxCount);
    if (!Number.isFinite(step)) return {
        ticks: [],
        count: 0
    };
    let d0 = start2;
    let d1 = stop;
    if (!$d77b025aa58d633c$var$isCloseToInteger(d0 / step, 1e-12)) d0 = Math.ceil(d0 / step) * step;
    if (!$d77b025aa58d633c$var$isCloseToInteger(d1 / step, 1e-12)) d1 = Math.floor(d1 / step) * step;
    if (visibleRange != null) {
        const dr = d1 - d0;
        const vr = stop - start2;
        const vd0 = start2 + vr * visibleRange[0];
        const vd1 = start2 + vr * visibleRange[1];
        visibleRange = [
            (vd0 - d0) / dr,
            (vd1 - d0) / dr
        ];
    }
    const { ticks: ticks } = $d77b025aa58d633c$var$range(d0, d1, step, visibleRange);
    return {
        ticks: ticks,
        count: $d77b025aa58d633c$var$countTicks(start2, stop, step)
    };
}
var $d77b025aa58d633c$var$minPrimaryTickRatio = Math.floor(2 * $d77b025aa58d633c$var$sunday.milliseconds / $d77b025aa58d633c$var$month.milliseconds * 10) / 10;
function $d77b025aa58d633c$var$isPrimaryTickInterval({ timeInterval: timeInterval, step: step }) {
    const milliseconds = timeInterval.milliseconds * step;
    return milliseconds <= (timeInterval.hierarchy?.milliseconds ?? Infinity) * $d77b025aa58d633c$var$minPrimaryTickRatio;
}
function $d77b025aa58d633c$var$getTickTimeInterval(start2, stop, count, minCount, maxCount, { weekStart: weekStart, primaryOnly: primaryOnly = false, targetInterval: targetInterval }) {
    if (count <= 0) return;
    const target = targetInterval ?? Math.abs(stop - start2) / Math.max(count, 1);
    const i0 = $d77b025aa58d633c$var$TickIntervals.findLast((t)=>(!primaryOnly || $d77b025aa58d633c$var$isPrimaryTickInterval(t)) && target > t.duration);
    const i1 = $d77b025aa58d633c$var$TickIntervals.find((t)=>(!primaryOnly || $d77b025aa58d633c$var$isPrimaryTickInterval(t)) && target <= t.duration);
    if (i0 == null) {
        const step2 = Math.max($d77b025aa58d633c$var$tickStep(start2, stop, count, minCount, maxCount), 1);
        return $d77b025aa58d633c$var$millisecond.every(step2);
    } else if (i1 == null) {
        const step2 = targetInterval == null ? $d77b025aa58d633c$var$tickStep(start2 / $d77b025aa58d633c$var$durationYear, stop / $d77b025aa58d633c$var$durationYear, count, minCount, maxCount) : 1;
        return $d77b025aa58d633c$var$year.every(step2);
    }
    const { timeInterval: timeInterval, step: step } = target - i0.duration < i1.duration - target ? i0 : i1;
    if (timeInterval === $d77b025aa58d633c$var$sunday) return weekStart?.every(step) ?? $d77b025aa58d633c$var$day.every(7 * step);
    return timeInterval.every(step);
}
function $d77b025aa58d633c$var$tickStep(start2, end2, count, minCount = 0, maxCount = Infinity) {
    if (start2 === end2) return (0, $idDdm.clamp)(1, minCount, maxCount);
    else if (count < 1) return NaN;
    const extent2 = Math.abs(end2 - start2);
    const step = 10 ** Math.floor(Math.log10(extent2 / count));
    let m = NaN, minDiff = Infinity, isInBounds = false;
    for (const multiplier of $d77b025aa58d633c$var$TickMultipliers){
        const c = Math.ceil(extent2 / (multiplier * step));
        const validBounds = c >= minCount && c <= maxCount;
        if (isInBounds && !validBounds) continue;
        const diffCount = Math.abs(c - count);
        if (minDiff > diffCount || isInBounds !== validBounds) {
            isInBounds || (isInBounds = validBounds);
            minDiff = diffCount;
            m = multiplier;
        }
    }
    return m * step;
}
function $d77b025aa58d633c$var$decimalPlaces(decimal) {
    for(let i = decimal.length - 1; i >= 0; i -= 1){
        if (decimal[i] !== "0") return i + 1;
    }
    return 0;
}
function $d77b025aa58d633c$var$tickFormat(ticks, format) {
    const options = (0, $idDdm.parseNumberFormat)(format ?? ",f");
    if (options.precision == null || isNaN(options.precision)) {
        if (!options.type || "eEFgGnprs".includes(options.type)) options.precision = Math.max(...ticks.map((x)=>{
            if (!Number.isFinite(x)) return 0;
            const [integer, decimal] = x.toExponential((options.type ? 6 : 12) - 1).split(/[.e]/g);
            return (integer !== "1" && integer !== "-1" ? 1 : 0) + $d77b025aa58d633c$var$decimalPlaces(decimal) + 1;
        }));
        else if ("f%".includes(options.type)) options.precision = Math.max(...ticks.map((x)=>{
            if (!Number.isFinite(x) || x === 0) return 0;
            const l = Math.floor(Math.log10(Math.abs(x)));
            const digits = options.type ? 6 : 12;
            const decimal = x.toExponential(digits - 1).split(/[.e]/g)[1];
            const decimalLength = $d77b025aa58d633c$var$decimalPlaces(decimal);
            return Math.max(0, decimalLength - l);
        }));
    }
    const formatter = (0, $idDdm.createNumberFormatter)(options);
    return (n)=>formatter(Number(n));
}
function $d77b025aa58d633c$var$range(start2, end2, step, visibleRange) {
    if (!Number.isFinite(step) || step <= 0) return {
        ticks: [],
        count: 0
    };
    else if (start2 === end2) return {
        ticks: [
            start2
        ],
        count: 1
    };
    const f = 10 ** (0, $idDdm.countFractionDigits)(step);
    const d0 = Math.min(start2, end2);
    const d1 = Math.max(start2, end2);
    let vd0;
    let vd1;
    if (visibleRange != null && (visibleRange[0] !== 0 || visibleRange[1] !== 1)) {
        const rangeExtent = end2 - start2;
        const adjustedStart = start2 + rangeExtent * visibleRange[0];
        const adjustedEnd = end2 - rangeExtent * (1 - visibleRange[1]);
        vd0 = Math.min(adjustedStart, adjustedEnd);
        vd1 = Math.max(adjustedStart, adjustedEnd);
    } else {
        vd0 = d0;
        vd1 = d1;
    }
    vd0 = Math.floor(vd0 * f) / f;
    vd1 = Math.ceil(vd1 * f) / f;
    const ticks = [];
    for(let i = 0;; i += 1){
        const p = Math.round((d0 + step * i) * f) / f;
        if (p > d1) break;
        if (p >= vd0 && p <= vd1) ticks.push(p);
    }
    return {
        ticks: ticks,
        count: $d77b025aa58d633c$var$countTicks(d0, d1, step)
    };
}
function $d77b025aa58d633c$var$isDenseInterval(count, availableRange) {
    if (count >= availableRange) {
        (0, $idDdm.Logger).warnOnce(`the configured interval results in more than 1 item per pixel, ignoring. Supply a larger interval or omit this configuration`);
        return true;
    }
    return false;
}
function $d77b025aa58d633c$var$niceTicksDomain(start2, end2) {
    const extent2 = Math.abs(end2 - start2);
    const step = 10 ** Math.floor(Math.log10(extent2));
    let minError = Infinity, ticks = [
        start2,
        end2
    ];
    for (const multiplier of $d77b025aa58d633c$var$TickMultipliers){
        const m = multiplier * step;
        const d0 = Math.floor(start2 / m) * m;
        const d1 = Math.ceil(end2 / m) * m;
        const error = 1 - extent2 / Math.abs(d1 - d0);
        if (minError > error) {
            minError = error;
            ticks = [
                d0,
                d1
            ];
        }
    }
    return ticks;
}
function $d77b025aa58d633c$var$estimateTickCount(rangeExtent, zoomExtent, minSpacing, maxSpacing, defaultTickCount, defaultMinSpacing) {
    if (rangeExtent <= 0) return {
        minTickCount: 0,
        maxTickCount: 0,
        tickCount: 0
    };
    defaultMinSpacing = Math.max(defaultMinSpacing, rangeExtent / (defaultTickCount + 1));
    minSpacing ?? (minSpacing = defaultMinSpacing);
    maxSpacing ?? (maxSpacing = rangeExtent);
    if (minSpacing > maxSpacing) {
        if (minSpacing === defaultMinSpacing) minSpacing = maxSpacing;
        else maxSpacing = minSpacing;
    }
    const maxTickCount = Math.max(1, Math.floor(rangeExtent / (zoomExtent * minSpacing)));
    const minTickCount = Math.min(maxTickCount, Math.ceil(rangeExtent / (zoomExtent * maxSpacing)));
    const tickCount = (0, $idDdm.clamp)(minTickCount, Math.floor(defaultTickCount / zoomExtent), maxTickCount);
    return {
        minTickCount: minTickCount,
        maxTickCount: maxTickCount,
        tickCount: tickCount
    };
}
// packages/ag-charts-community/src/scale/timeScale.ts
var $d77b025aa58d633c$var$TimeScale = class _TimeScale extends $d77b025aa58d633c$var$ContinuousScale {
    constructor(){
        super([], [
            0,
            1
        ]);
        this.type = "time";
    }
    static is(value) {
        return value instanceof _TimeScale;
    }
    toDomain(d) {
        return new Date(d);
    }
    convert(value, options) {
        if (!(value instanceof Date)) value = new Date(value);
        return super.convert(value, options);
    }
    invert(value) {
        return new Date(super.invert(value));
    }
    niceDomain(ticks, domain = this.domain) {
        if (domain.length < 2) return [];
        let [d0, d1] = domain;
        const maxAttempts = 4;
        const availableRange = this.getPixelRange();
        for(let i = 0; i < maxAttempts; i++){
            const [n0, n1] = $d77b025aa58d633c$var$updateNiceDomainIteration(d0, d1, ticks, availableRange);
            if ($d77b025aa58d633c$var$dateToNumber(d0) === $d77b025aa58d633c$var$dateToNumber(n0) && $d77b025aa58d633c$var$dateToNumber(d1) === $d77b025aa58d633c$var$dateToNumber(n1)) break;
            d0 = n0;
            d1 = n1;
        }
        return [
            d0,
            d1
        ];
    }
    /**
   * Returns uniformly-spaced dates that represent the scale's domain.
   */ ticks(params, domain = this.domain, visibleRange = [
        0,
        1
    ], extend = false) {
        const { nice: nice, interval: interval, tickCount: tickCount = $d77b025aa58d633c$var$ContinuousScale.defaultTickCount, minTickCount: minTickCount, maxTickCount: maxTickCount } = params;
        if (domain.length < 2) return;
        const timestamps = domain.map($d77b025aa58d633c$var$dateToNumber);
        const start2 = timestamps[0];
        const stop = timestamps[timestamps.length - 1];
        if (interval != null) {
            const availableRange = this.getPixelRange();
            return {
                ticks: $d77b025aa58d633c$var$getDateTicksForInterval({
                    start: start2,
                    stop: stop,
                    interval: interval,
                    availableRange: availableRange,
                    visibleRange: visibleRange,
                    extend: extend
                }) ?? $d77b025aa58d633c$var$getDefaultDateTicks({
                    start: start2,
                    stop: stop,
                    tickCount: tickCount,
                    minTickCount: minTickCount,
                    maxTickCount: maxTickCount,
                    visibleRange: visibleRange,
                    extend: extend
                }),
                count: void 0
            };
        } else if (nice && tickCount === 2) return {
            ticks: domain,
            count: void 0
        };
        else if (nice && tickCount === 1) return {
            ticks: domain.slice(0, 1),
            count: void 0
        };
        return {
            ticks: $d77b025aa58d633c$var$getDefaultDateTicks({
                start: start2,
                stop: stop,
                tickCount: tickCount,
                minTickCount: minTickCount,
                maxTickCount: maxTickCount,
                visibleRange: visibleRange,
                extend: extend
            }),
            count: void 0
        };
    }
    _tickFormatter({ domain: domain, ticks: ticks, specifier: specifier }, formatOffset) {
        return specifier != null ? $d77b025aa58d633c$var$buildFormatter(specifier) : $d77b025aa58d633c$var$defaultTimeTickFormat(ticks, domain, formatOffset);
    }
    /**
   * Returns a time format function suitable for displaying tick values.
   *
   * @param ticks Optional array of tick values for custom formatting.
   * @param domain Optional array representing the [min, max] values of the time axis.
   * @param specifier Optional format specifier string for custom date formatting (e.g., `%Y`, `%m`, `%d`).
   * @param formatOffset Optional number for applying an offset to the format (e.g., timezone shifts).
   * @returns A function that formats a `Date` object into a string based on the provided specifier or default format.
   */ tickFormatter(params) {
        return this._tickFormatter(params);
    }
    datumFormatter(params) {
        return this._tickFormatter(params, 1);
    }
};
function $d77b025aa58d633c$var$getDefaultDateTicks({ start: start2, stop: stop, tickCount: tickCount, minTickCount: minTickCount, maxTickCount: maxTickCount, visibleRange: visibleRange, extend: extend }) {
    const t = $d77b025aa58d633c$var$getTickTimeInterval(start2, stop, tickCount, minTickCount, maxTickCount, {
        weekStart: $d77b025aa58d633c$var$sunday
    });
    return t ? t.range(new Date(start2), new Date(stop), {
        visibleRange: visibleRange,
        extend: extend
    }) : [];
}
function $d77b025aa58d633c$var$getDateTicksForInterval({ start: start2, stop: stop, interval: interval, availableRange: availableRange, visibleRange: visibleRange, extend: extend }) {
    if (!interval) return [];
    if (interval instanceof $d77b025aa58d633c$var$TimeInterval || typeof interval === "string") {
        const ticks2 = $d77b025aa58d633c$var$intervalRange(interval, new Date(start2), new Date(stop), {
            visibleRange: visibleRange,
            extend: extend
        });
        if ($d77b025aa58d633c$var$isDenseInterval(ticks2.length, availableRange)) return;
        return ticks2;
    }
    const absInterval = Math.abs(interval);
    if ($d77b025aa58d633c$var$isDenseInterval(Math.abs(stop - start2) / absInterval, availableRange)) return;
    const timeInterval = $d77b025aa58d633c$var$TickIntervals.findLast((tickInterval)=>absInterval % tickInterval.duration === 0);
    if (timeInterval) {
        const i = timeInterval.timeInterval.every(absInterval / (timeInterval.duration / timeInterval.step));
        return i.range(new Date(start2), new Date(stop), {
            visibleRange: visibleRange,
            extend: extend
        });
    }
    let date6 = new Date(Math.min(start2, stop));
    const stopDate = new Date(Math.max(start2, stop));
    const ticks = [];
    while(date6 <= stopDate){
        ticks.push(date6);
        date6 = new Date(date6);
        date6.setMilliseconds(date6.getMilliseconds() + absInterval);
    }
    return ticks;
}
function $d77b025aa58d633c$var$updateNiceDomainIteration(d0, d1, ticks, availableRange) {
    const { interval: interval } = ticks;
    const start2 = Math.min($d77b025aa58d633c$var$dateToNumber(d0), $d77b025aa58d633c$var$dateToNumber(d1));
    const stop = Math.max($d77b025aa58d633c$var$dateToNumber(d0), $d77b025aa58d633c$var$dateToNumber(d1));
    let i;
    if (interval instanceof $d77b025aa58d633c$var$TimeInterval) i = interval;
    else if (typeof interval === "string") i = interval;
    else {
        let tickCount;
        if (typeof interval === "number") {
            tickCount = (stop - start2) / Math.max(interval, 1);
            if ($d77b025aa58d633c$var$isDenseInterval(tickCount, availableRange)) tickCount = void 0;
        }
        tickCount ?? (tickCount = ticks.tickCount ?? $d77b025aa58d633c$var$ContinuousScale.defaultTickCount);
        i = $d77b025aa58d633c$var$getTickTimeInterval(start2, stop, tickCount, ticks.minTickCount, ticks.maxTickCount, {
            weekStart: $d77b025aa58d633c$var$sunday
        });
    }
    if (i == null) return [
        d0,
        d1
    ];
    const domain = $d77b025aa58d633c$var$intervalRange(i, new Date(start2), new Date(stop), {
        extend: true
    });
    if (domain == null || domain.length < 2) return [
        d0,
        d1
    ];
    const r0 = domain[0];
    const r1 = domain[domain.length - 1];
    return d0 <= d1 ? [
        r0,
        r1
    ] : [
        r1,
        r0
    ];
}
// packages/ag-charts-community/src/scale/ordinalTimeScale.ts
var $d77b025aa58d633c$var$OrdinalTimeScale = class _OrdinalTimeScale extends $d77b025aa58d633c$var$DiscreteTimeScale {
    constructor(){
        super(...arguments);
        this.type = "ordinal-time";
        this._domain = [];
        this.isReversed = false;
    }
    static is(value) {
        return value instanceof _OrdinalTimeScale;
    }
    set domain(domain) {
        if (domain === this._domain) return;
        this.invalid = true;
        this._domain = domain;
        this._bands = void 0;
        this.isReversed = domain.length > 0 && domain[0] > domain[domain.length - 1];
        this.sortedTimestamps = void 0;
        this.precomputedSteps = void 0;
    }
    get domain() {
        return this._domain;
    }
    get bands() {
        this._bands ?? (this._bands = this.isReversed ? this.domain.slice().reverse() : this.domain);
        return this._bands;
    }
    normalizeDomains(...domains) {
        const sortedDomains = domains.filter((domain)=>domain.length > 0);
        if (sortedDomains.length === 0) return {
            domain: [],
            animatable: false
        };
        else if (sortedDomains.length === 1) {
            let domain = sortedDomains[0];
            const sortOrder = $d77b025aa58d633c$var$datesSortOrder(domain);
            if (sortOrder === -1) domain = domain.slice().reverse();
            else if (sortOrder == null) domain = $d77b025aa58d633c$var$sortAndUniqueDates(domain.slice());
            return {
                domain: domain,
                animatable: true
            };
        }
        return {
            domain: $d77b025aa58d633c$var$sortAndUniqueDates(sortedDomains.flat()),
            animatable: true
        };
    }
    ticks({ interval: interval, maxTickCount: maxTickCount }, domain = this.domain, visibleRange = [
        0,
        1
    ], extend = false) {
        if (!domain.length) return;
        this.refresh();
        const { isReversed: isReversed } = this;
        if (interval == null) return {
            ticks: $d77b025aa58d633c$var$getDefaultTicks(domain, maxTickCount, isReversed, visibleRange, extend),
            count: void 0
        };
        const start2 = domain[0].valueOf();
        const stop = domain[domain.length - 1].valueOf();
        const [r0, r1] = this.range;
        const availableRange = Math.abs(r1 - r0);
        let ticks = $d77b025aa58d633c$var$getDateTicksForInterval({
            start: start2,
            stop: stop,
            interval: interval,
            availableRange: availableRange,
            visibleRange: visibleRange,
            extend: extend
        }) ?? $d77b025aa58d633c$var$getDefaultTicks(domain, maxTickCount, isReversed, visibleRange, extend);
        let lastIndex = -1;
        ticks = ticks.filter((tick)=>{
            const index = this.findInterval(tick.valueOf());
            const duplicated = index === lastIndex;
            lastIndex = index;
            return !duplicated;
        });
        return {
            ticks: ticks,
            count: void 0
        };
    }
    getSortedTimestamps() {
        let { sortedTimestamps: sortedTimestamps } = this;
        if (sortedTimestamps == null) {
            sortedTimestamps ?? (sortedTimestamps = this.bands.map($d77b025aa58d633c$var$dateToNumber));
            this.sortedTimestamps = sortedTimestamps;
        }
        return sortedTimestamps;
    }
    getPrecomputedSteps() {
        const { domain: domain } = this;
        let { precomputedSteps: precomputedSteps } = this;
        const computedStepCount = domain.length < 1e4 ? domain.length : Math.ceil(domain.length / 16);
        if (precomputedSteps != null || computedStepCount <= 1) return precomputedSteps;
        const sortedTimestamps = this.getSortedTimestamps();
        precomputedSteps = new Int32Array(computedStepCount);
        const d0 = sortedTimestamps[0];
        const d1 = sortedTimestamps[sortedTimestamps.length - 1];
        const dRange = d1 - d0;
        const low = 0;
        const high = sortedTimestamps.length - 1;
        for(let i = 0; i < precomputedSteps.length; i += 1)precomputedSteps[i] = this.findIntervalInRange(d0 + i / computedStepCount * dRange, low, high);
        this.precomputedSteps = precomputedSteps;
    }
    findIntervalInRange(target, low, high) {
        const sortedTimestamps = this.getSortedTimestamps();
        while(low <= high){
            const mid = (low + high) / 2 | 0;
            if (sortedTimestamps[mid] === target) return mid;
            else if (sortedTimestamps[mid] < target) low = mid + 1;
            else high = mid - 1;
        }
        return low;
    }
    findInterval(target) {
        const precomputedSteps = this.getPrecomputedSteps();
        let low;
        let high;
        if (precomputedSteps == null) {
            low = 0;
            high = this.domain.length - 1;
        } else {
            const sortedTimestamps = this.getSortedTimestamps();
            const d0 = sortedTimestamps[0];
            const d1 = sortedTimestamps[sortedTimestamps.length - 1];
            const i = Math.min((target - d0) / (d1 - d0) * precomputedSteps.length | 0, precomputedSteps.length - 1 | 0);
            low = precomputedSteps[i];
            high = i < precomputedSteps.length - 2 ? precomputedSteps[i + 1] : sortedTimestamps.length - 1;
        }
        return this.findIntervalInRange(target, low, high);
    }
    datumFormatter(params) {
        return this.tickFormatter(params);
    }
    findIndex(value) {
        const sortedTimestamps = this.getSortedTimestamps();
        const n = Number(value);
        if (n < sortedTimestamps[0]) return void 0;
        return this.findInterval(n);
    }
};
function $d77b025aa58d633c$var$getDefaultTicks(domain, maxTickCount, isReversed, visibleRange, extend) {
    const ticks = [];
    const tickEvery = Math.ceil(domain.length / maxTickCount);
    const tickOffset = Math.floor(tickEvery / 2);
    let startIndex = Math.floor(visibleRange[0] * domain.length);
    let endIndex = Math.ceil(visibleRange[1] * domain.length);
    if (extend) {
        if (startIndex > tickEvery) startIndex -= tickEvery;
        if (endIndex < domain.length - tickEvery) endIndex += tickEvery;
    }
    for(let index = startIndex; index < endIndex; index += 1){
        const tickIndex = isReversed ? domain.length - 1 - index : index;
        if (tickEvery <= 0 || (tickIndex + tickOffset) % tickEvery === 0) ticks.push(domain[index]);
    }
    return ticks;
}
// packages/ag-charts-community/src/scene/shape/range.ts
var $d77b025aa58d633c$var$Range = class extends $d77b025aa58d633c$var$Shape {
    constructor(opts = {}){
        super(opts);
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.startLine = false;
        this.endLine = false;
        this.horizontal = false;
        this.restoreOwnStyles();
    }
    computeBBox() {
        return new $d77b025aa58d633c$var$BBox(this.x1, this.y1, this.x2 - this.x1, this.y2 - this.y1);
    }
    isPointInPath(_x, _y) {
        return false;
    }
    render(renderCtx) {
        const { ctx: ctx } = renderCtx;
        let { x1: x1, y1: y1, x2: x2, y2: y2 } = this;
        x1 = this.align(x1);
        y1 = this.align(y1);
        x2 = this.align(x2);
        y2 = this.align(y2);
        const { fill: fill, horizontal: horizontal } = this;
        const { globalAlpha: globalAlpha } = ctx;
        if (fill != null) {
            this.applyFillAndAlpha(ctx);
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y1);
            ctx.lineTo(x2, y2);
            ctx.lineTo(x1, y2);
            ctx.closePath();
            ctx.fill();
            ctx.globalAlpha = globalAlpha;
        }
        const { stroke: stroke2, strokeWidth: strokeWidth, startLine: startLine, endLine: endLine } = this;
        const strokeActive = !!((startLine || endLine) && stroke2 && strokeWidth);
        if (strokeActive) {
            const { lineDash: lineDash, lineDashOffset: lineDashOffset, lineCap: lineCap, lineJoin: lineJoin } = this;
            this.applyStrokeAndAlpha(ctx);
            ctx.lineWidth = strokeWidth;
            if (lineDash) ctx.setLineDash([
                ...lineDash
            ]);
            if (lineDashOffset) ctx.lineDashOffset = lineDashOffset;
            if (lineCap) ctx.lineCap = lineCap;
            if (lineJoin) ctx.lineJoin = lineJoin;
            ctx.beginPath();
            if (startLine) {
                ctx.moveTo(x1, y1);
                if (horizontal) ctx.lineTo(x1, y2);
                else ctx.lineTo(x2, y1);
            }
            if (endLine) {
                ctx.moveTo(x2, y2);
                if (horizontal) ctx.lineTo(x2, y1);
                else ctx.lineTo(x1, y2);
            }
            ctx.stroke();
            ctx.globalAlpha = globalAlpha;
        }
        this.fillShadow?.markClean();
        super.render(renderCtx);
    }
};
$d77b025aa58d633c$var$Range.className = "Range";
$d77b025aa58d633c$var$Range.defaultStyles = {
    ...$d77b025aa58d633c$var$Shape.defaultStyles,
    strokeWidth: 1
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Range.prototype, "x1", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Range.prototype, "y1", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Range.prototype, "x2", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Range.prototype, "y2", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Range.prototype, "startLine", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Range.prototype, "endLine", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Range.prototype, "horizontal", 2);
function $d77b025aa58d633c$var$isStringObject(value) {
    return value != null && Object.hasOwn(value, "toString") && (0, $idDdm.isString)(value.toString());
}
function $d77b025aa58d633c$var$isNumberObject(value) {
    return value != null && Object.hasOwn(value, "valueOf") && (0, $idDdm.isFiniteNumber)(value.valueOf());
}
function $d77b025aa58d633c$var$isContinuous(value) {
    return (0, $idDdm.isFiniteNumber)(value) || (0, $idDdm.isValidDate)(value) || $d77b025aa58d633c$var$isNumberObject(value);
}
function $d77b025aa58d633c$var$checkDatum(value, isContinuousScale) {
    return value != null && (!isContinuousScale || $d77b025aa58d633c$var$isContinuous(value));
}
function $d77b025aa58d633c$var$transformIntegratedCategoryValue(value) {
    if ($d77b025aa58d633c$var$isStringObject(value) && Object.hasOwn(value, "id")) return value.id;
    return value;
}
// packages/ag-charts-community/src/chart/crossline/crossLine.ts
function $d77b025aa58d633c$var$getCrossLineValue(crossLine) {
    switch(crossLine.type){
        case "line":
            return crossLine.value;
        case "range":
            return crossLine.range;
    }
}
function $d77b025aa58d633c$var$validateCrossLineValue(value, scale2) {
    if (value == null) return false;
    const isContinuous2 = $d77b025aa58d633c$var$ContinuousScale.is(scale2) || $d77b025aa58d633c$var$DiscreteTimeScale.is(scale2);
    const validValue = (val)=>$d77b025aa58d633c$var$checkDatum(val, isContinuous2) && !isNaN(scale2.convert(val));
    if ((0, $idDdm.isArray)(value)) {
        const [start2, end2] = value;
        return validValue(start2) && validValue(end2);
    } else return validValue(value);
}
// packages/ag-charts-community/src/chart/crossline/cartesianCrossLine.ts
var $d77b025aa58d633c$var$horizontalLineAnchors = {
    top: {
        rangeH: 0,
        rangeV: -1,
        labelH: 0,
        labelV: 1
    },
    "inside-top": {
        rangeH: 0,
        rangeV: -1,
        labelH: 0,
        labelV: 1
    },
    "top-left": {
        rangeH: -1,
        rangeV: -1,
        labelH: -1,
        labelV: 1
    },
    "inside-top-left": {
        rangeH: -1,
        rangeV: -1,
        labelH: -1,
        labelV: 1
    },
    left: {
        rangeH: -1,
        rangeV: 0,
        labelH: 1,
        labelV: 0
    },
    "inside-left": {
        rangeH: -1,
        rangeV: 0,
        labelH: -1,
        labelV: 0
    },
    "bottom-left": {
        rangeH: -1,
        rangeV: 1,
        labelH: -1,
        labelV: -1
    },
    "inside-bottom-left": {
        rangeH: -1,
        rangeV: 1,
        labelH: -1,
        labelV: -1
    },
    bottom: {
        rangeH: 0,
        rangeV: 1,
        labelH: 0,
        labelV: -1
    },
    "inside-bottom": {
        rangeH: 0,
        rangeV: 1,
        labelH: 0,
        labelV: -1
    },
    "bottom-right": {
        rangeH: 1,
        rangeV: 1,
        labelH: 1,
        labelV: -1
    },
    "inside-bottom-right": {
        rangeH: 1,
        rangeV: 1,
        labelH: 1,
        labelV: -1
    },
    right: {
        rangeH: 1,
        rangeV: 0,
        labelH: -1,
        labelV: 0
    },
    "inside-right": {
        rangeH: 1,
        rangeV: 0,
        labelH: 1,
        labelV: 0
    },
    "top-right": {
        rangeH: 1,
        rangeV: -1,
        labelH: 1,
        labelV: 1
    },
    "inside-top-right": {
        rangeH: 1,
        rangeV: -1,
        labelH: 1,
        labelV: 1
    },
    inside: {
        rangeH: 0,
        rangeV: 0,
        labelH: 0,
        labelV: 0
    }
};
var $d77b025aa58d633c$var$verticalLineAnchors = {
    top: {
        rangeH: 0,
        rangeV: -1,
        labelH: 0,
        labelV: 1
    },
    "inside-top": {
        rangeH: 0,
        rangeV: -1,
        labelH: 0,
        labelV: -1
    },
    "top-left": {
        rangeH: -1,
        rangeV: -1,
        labelH: 1,
        labelV: -1
    },
    "inside-top-left": {
        rangeH: -1,
        rangeV: -1,
        labelH: 1,
        labelV: -1
    },
    left: {
        rangeH: -1,
        rangeV: 0,
        labelH: 1,
        labelV: 0
    },
    "inside-left": {
        rangeH: -1,
        rangeV: 0,
        labelH: 1,
        labelV: 0
    },
    "bottom-left": {
        rangeH: -1,
        rangeV: 1,
        labelH: 1,
        labelV: 1
    },
    "inside-bottom-left": {
        rangeH: -1,
        rangeV: 1,
        labelH: 1,
        labelV: 1
    },
    bottom: {
        rangeH: 0,
        rangeV: 1,
        labelH: 0,
        labelV: -1
    },
    "inside-bottom": {
        rangeH: 0,
        rangeV: 1,
        labelH: 0,
        labelV: 1
    },
    "bottom-right": {
        rangeH: 1,
        rangeV: 1,
        labelH: -1,
        labelV: 1
    },
    "inside-bottom-right": {
        rangeH: 1,
        rangeV: 1,
        labelH: -1,
        labelV: 1
    },
    right: {
        rangeH: 1,
        rangeV: 0,
        labelH: -1,
        labelV: 0
    },
    "inside-right": {
        rangeH: 1,
        rangeV: 0,
        labelH: -1,
        labelV: 0
    },
    "top-right": {
        rangeH: 1,
        rangeV: -1,
        labelH: -1,
        labelV: -1
    },
    "inside-top-right": {
        rangeH: -1,
        rangeV: -1,
        labelH: -1,
        labelV: -1
    },
    inside: {
        rangeH: 0,
        rangeV: 0,
        labelH: 0,
        labelV: 0
    }
};
var $d77b025aa58d633c$var$horizontalRangeAnchors = {
    top: {
        rangeH: 0,
        rangeV: -1,
        labelH: 0,
        labelV: 1
    },
    "inside-top": {
        rangeH: 0,
        rangeV: -1,
        labelH: 0,
        labelV: -1
    },
    "top-left": {
        rangeH: -1,
        rangeV: -1,
        labelH: -1,
        labelV: 1
    },
    "inside-top-left": {
        rangeH: -1,
        rangeV: -1,
        labelH: -1,
        labelV: -1
    },
    left: {
        rangeH: -1,
        rangeV: 0,
        labelH: 1,
        labelV: 0
    },
    "inside-left": {
        rangeH: -1,
        rangeV: 0,
        labelH: -1,
        labelV: 0
    },
    "bottom-left": {
        rangeH: -1,
        rangeV: 1,
        labelH: -1,
        labelV: -1
    },
    "inside-bottom-left": {
        rangeH: -1,
        rangeV: 1,
        labelH: -1,
        labelV: 1
    },
    bottom: {
        rangeH: 0,
        rangeV: 1,
        labelH: 0,
        labelV: -1
    },
    "inside-bottom": {
        rangeH: 0,
        rangeV: 1,
        labelH: 0,
        labelV: 1
    },
    "bottom-right": {
        rangeH: 1,
        rangeV: 1,
        labelH: 1,
        labelV: -1
    },
    "inside-bottom-right": {
        rangeH: 1,
        rangeV: 1,
        labelH: 1,
        labelV: 1
    },
    right: {
        rangeH: 1,
        rangeV: 0,
        labelH: -1,
        labelV: 0
    },
    "inside-right": {
        rangeH: 1,
        rangeV: 0,
        labelH: 1,
        labelV: 0
    },
    "top-right": {
        rangeH: 1,
        rangeV: -1,
        labelH: 1,
        labelV: 1
    },
    "inside-top-right": {
        rangeH: 1,
        rangeV: -1,
        labelH: 1,
        labelV: -1
    },
    inside: {
        rangeH: 0,
        rangeV: 0,
        labelH: 0,
        labelV: 0
    }
};
var $d77b025aa58d633c$var$verticalRangeAnchors = {
    top: {
        rangeH: 0,
        rangeV: -1,
        labelH: 0,
        labelV: 1
    },
    "inside-top": {
        rangeH: 0,
        rangeV: -1,
        labelH: 0,
        labelV: -1
    },
    "top-left": {
        rangeH: -1,
        rangeV: -1,
        labelH: 1,
        labelV: -1
    },
    "inside-top-left": {
        rangeH: -1,
        rangeV: -1,
        labelH: -1,
        labelV: -1
    },
    left: {
        rangeH: -1,
        rangeV: 0,
        labelH: 1,
        labelV: 0
    },
    "inside-left": {
        rangeH: -1,
        rangeV: 0,
        labelH: -1,
        labelV: 0
    },
    "bottom-left": {
        rangeH: -1,
        rangeV: 1,
        labelH: 1,
        labelV: 1
    },
    "inside-bottom-left": {
        rangeH: -1,
        rangeV: 1,
        labelH: -1,
        labelV: 1
    },
    bottom: {
        rangeH: 0,
        rangeV: 1,
        labelH: 0,
        labelV: -1
    },
    "inside-bottom": {
        rangeH: 0,
        rangeV: 1,
        labelH: 0,
        labelV: 1
    },
    "bottom-right": {
        rangeH: 1,
        rangeV: 1,
        labelH: -1,
        labelV: 1
    },
    "inside-bottom-right": {
        rangeH: 1,
        rangeV: 1,
        labelH: 1,
        labelV: 1
    },
    right: {
        rangeH: 1,
        rangeV: 0,
        labelH: -1,
        labelV: 0
    },
    "inside-right": {
        rangeH: 1,
        rangeV: 0,
        labelH: 1,
        labelV: 0
    },
    "top-right": {
        rangeH: 1,
        rangeV: -1,
        labelH: -1,
        labelV: -1
    },
    "inside-top-right": {
        rangeH: 1,
        rangeV: -1,
        labelH: 1,
        labelV: -1
    },
    inside: {
        rangeH: 0,
        rangeV: 0,
        labelH: 0,
        labelV: 0
    }
};
var $d77b025aa58d633c$var$CartesianCrossLineLabel = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.fontSize = 14;
        this.fontFamily = "Verdana, sans-serif";
        this.padding = 5;
        this.color = "rgba(87, 87, 87, 1)";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "text", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "fontFamily", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "padding", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "position", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "rotation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "parallel", 2);
var $d77b025aa58d633c$var$CartesianCrossLine = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super();
        this.id = (0, $idDdm.createId)(this);
        this.defaultColorRange = [];
        this.fill = "#c16068";
        this.label = new $d77b025aa58d633c$var$CartesianCrossLineLabel();
        this.scale = void 0;
        this.clippedRange = [
            -Infinity,
            Infinity
        ];
        this.gridLength = 0;
        this.position = "top";
        this.rangeGroup = new $d77b025aa58d633c$var$Group({
            name: this.id
        });
        this.lineGroup = new $d77b025aa58d633c$var$Group({
            name: this.id
        });
        this.labelGroup = new $d77b025aa58d633c$var$Group({
            name: this.id
        });
        this.crossLineRange = new $d77b025aa58d633c$var$Range();
        this.crossLineLabel = new $d77b025aa58d633c$var$TransformableText();
        this.data = void 0;
        this.startLine = false;
        this.endLine = false;
        this._isRange = void 0;
        this.lineGroup.append(this.crossLineRange);
        this.labelGroup.append(this.crossLineLabel);
        this.crossLineRange.pointerEvents = 1 /* None */ ;
    }
    get defaultLabelPosition() {
        return "top";
    }
    update(visible) {
        const { enabled: enabled, type: type, data: data, scale: scale2 } = this;
        if (!scale2 || !enabled || !visible || !$d77b025aa58d633c$var$validateCrossLineValue($d77b025aa58d633c$var$getCrossLineValue(this), scale2) || data == null) {
            this.rangeGroup.visible = false;
            this.lineGroup.visible = false;
            this.labelGroup.visible = false;
            return;
        }
        this.rangeGroup.visible = visible;
        this.lineGroup.visible = visible;
        this.labelGroup.visible = visible;
        this.updateNodes();
        const isRange = type === "range";
        if (isRange !== this._isRange) {
            if (isRange) this.rangeGroup.appendChild(this.crossLineRange);
            else this.lineGroup.appendChild(this.crossLineRange);
        }
        this._isRange = isRange;
    }
    calculateLayout(visible, reversedAxis) {
        this.data = void 0;
        if (!visible) return;
        const { type: type, range: range3, value: value, scale: scale2, clippedRange: clippedRange, strokeWidth: strokeWidth = 0 } = this;
        if (!scale2) return;
        const bandwidth = scale2.bandwidth ?? 0;
        const step = scale2.step ?? 0;
        const rangePadding = (reversedAxis ? -1 : 1) * (scale2 instanceof $d77b025aa58d633c$var$BandScale ? (step - bandwidth) / 2 : 0);
        let yStart;
        let yEnd;
        let clampedYStart;
        let clampedYEnd;
        if (type === "line") {
            const offset4 = bandwidth / 2;
            yStart = scale2.convert(value) + offset4;
            yEnd = NaN;
            clampedYStart = scale2.convert(value, {
                clamp: true
            }) + offset4;
            clampedYEnd = NaN;
        } else if (range3) {
            const [r0, r1] = range3;
            const ordinalTimeScalePadding = r0?.valueOf() === r1?.valueOf() && $d77b025aa58d633c$var$OrdinalTimeScale.is(scale2) ? bandwidth / 2 + rangePadding : 0;
            yStart = scale2.convert(r0) + ordinalTimeScalePadding;
            yEnd = scale2.convert(r1) + bandwidth;
            clampedYStart = scale2.convert(r0, {
                clamp: true
            }) + ordinalTimeScalePadding - rangePadding;
            clampedYEnd = scale2.convert(r1, {
                clamp: true
            }) + bandwidth + rangePadding;
        } else return;
        clampedYStart = $d77b025aa58d633c$var$clampArray(clampedYStart, clippedRange);
        clampedYEnd = $d77b025aa58d633c$var$clampArray(clampedYEnd, clippedRange);
        const validRange = (yStart === clampedYStart || yEnd === clampedYEnd || clampedYStart !== clampedYEnd) && Math.abs(clampedYEnd - clampedYStart) > 0;
        if (validRange && clampedYStart > clampedYEnd) {
            [clampedYStart, clampedYEnd] = [
                clampedYEnd,
                clampedYStart
            ];
            [yStart, yEnd] = [
                yEnd,
                yStart
            ];
        }
        if (yStart - rangePadding >= clampedYStart) yStart -= rangePadding;
        if (yEnd + rangePadding <= clampedYEnd) yEnd += rangePadding;
        this.startLine = strokeWidth > 0 && yStart >= clampedYStart && yStart <= clampedYStart + rangePadding;
        this.endLine = strokeWidth > 0 && yEnd >= clampedYEnd - bandwidth - rangePadding && yEnd <= clampedYEnd;
        if (type === "range" && !validRange && !this.startLine && !this.endLine) return;
        this.data = [
            clampedYStart,
            clampedYEnd
        ];
        if (this.label.enabled === false || !this.label.text) return;
    }
    updateNodes() {
        const { position: position, data: [r0, r1] = [
            0,
            0
        ], gridLength: gridLength } = this;
        const dr = Number.isFinite(r1) ? r1 - r0 : 0;
        let bounds;
        switch(position){
            case "top":
            case "bottom":
                bounds = new $d77b025aa58d633c$var$BBox(r0, position === "top" ? 0 : -gridLength, dr, gridLength);
                break;
            case "left":
            case "right":
                bounds = new $d77b025aa58d633c$var$BBox(position === "left" ? 0 : -gridLength, r0, gridLength, dr);
        }
        this.updateRangeNode(bounds);
        const { label: label } = this;
        if (label.enabled !== false && label.text) {
            this.updateLabel();
            this.positionLabel(bounds);
        }
    }
    updateRangeNode(bounds) {
        const { type: type, position: position, crossLineRange: crossLineRange, startLine: startLine, endLine: endLine, fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash } = this;
        crossLineRange.x1 = bounds.x;
        crossLineRange.x2 = bounds.x + bounds.width;
        crossLineRange.y1 = bounds.y;
        crossLineRange.y2 = bounds.y + bounds.height;
        crossLineRange.horizontal = position === "top" || position === "bottom";
        crossLineRange.startLine = startLine;
        crossLineRange.endLine = endLine;
        crossLineRange.fill = type === "range" ? fill : void 0;
        crossLineRange.fillOpacity = fillOpacity ?? 1;
        crossLineRange.stroke = stroke2;
        crossLineRange.strokeWidth = strokeWidth ?? 1;
        crossLineRange.strokeOpacity = strokeOpacity ?? 1;
        crossLineRange.lineDash = lineDash;
    }
    updateLabel() {
        const { crossLineLabel: crossLineLabel, label: label } = this;
        if (!label.text) return;
        crossLineLabel.fontStyle = label.fontStyle;
        crossLineLabel.fontWeight = label.fontWeight;
        crossLineLabel.fontSize = label.fontSize;
        crossLineLabel.fontFamily = label.fontFamily;
        crossLineLabel.fill = label.color;
        crossLineLabel.text = label.text;
    }
    get anchor() {
        const horizontal = this.position === "left" || this.position === "right";
        const range3 = this.type === "range";
        const { position: position = this.defaultLabelPosition } = this.label;
        if (range3) {
            const anchors = horizontal ? $d77b025aa58d633c$var$horizontalRangeAnchors : $d77b025aa58d633c$var$verticalRangeAnchors;
            return anchors[position];
        } else {
            const anchors = horizontal ? $d77b025aa58d633c$var$horizontalLineAnchors : $d77b025aa58d633c$var$verticalLineAnchors;
            return anchors[position];
        }
    }
    positionLabel(bounds) {
        const { crossLineLabel: crossLineLabel, label: label, anchor: anchor } = this;
        crossLineLabel.rotation = $d77b025aa58d633c$var$toRadians(label.rotation ?? 0);
        crossLineLabel.textBaseline = "middle";
        crossLineLabel.textAlign = "center";
        const bbox = crossLineLabel.getBBox();
        if (!bbox) return;
        const { width: width2, height: height2 } = bbox;
        const xOffset = label.padding + width2 / 2;
        const yOffset = label.padding + height2 / 2;
        const x = bounds.x + bounds.width * (anchor.rangeH + 1) / 2 - xOffset * anchor.labelH;
        const y = bounds.y + bounds.height * (anchor.rangeV + 1) / 2 - yOffset * anchor.labelV;
        crossLineLabel.x = x;
        crossLineLabel.y = y;
        crossLineLabel.rotationCenterX = x;
        crossLineLabel.rotationCenterY = y;
    }
    computeLabelSize() {
        const { label: label } = this;
        if (label.enabled === false || !label.text) return;
        const tempText = new $d77b025aa58d633c$var$TransformableText();
        tempText.fontFamily = label.fontFamily;
        tempText.fontSize = label.fontSize;
        tempText.fontStyle = label.fontStyle;
        tempText.fontWeight = label.fontWeight;
        tempText.text = label.text;
        tempText.rotation = $d77b025aa58d633c$var$toRadians(label.rotation ?? 0);
        tempText.textBaseline = "middle";
        tempText.textAlign = "center";
        const bbox = tempText.getBBox();
        if (!bbox) return;
        const { width: width2, height: height2 } = bbox;
        return {
            width: width2,
            height: height2
        };
    }
    calculatePadding(into) {
        const { label: label, anchor: anchor } = this;
        const size = this.computeLabelSize();
        if (!size) return;
        const { width: width2, height: height2 } = size;
        const xOffset = label.padding + width2;
        const yOffset = label.padding + height2;
        const horizontal = this.position === "left" || this.position === "right";
        if (horizontal) {
            if (anchor.rangeH === -1 && anchor.labelH === 1) into.left = Math.max(into.left ?? 0, xOffset);
            else if (anchor.rangeH === 1 && anchor.labelH === -1) into.right = Math.max(into.right ?? 0, xOffset);
        }
        if (!horizontal) {
            if (anchor.rangeV === -1 && anchor.labelV === 1) into.top = Math.max(into.top ?? 0, yOffset);
            else if (anchor.rangeV === 1 && anchor.labelV === -1) into.bottom = Math.max(into.bottom ?? 0, yOffset);
        }
    }
};
$d77b025aa58d633c$var$CartesianCrossLine.className = "CrossLine";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLine.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLine.prototype, "type", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLine.prototype, "range", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLine.prototype, "value", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLine.prototype, "defaultColorRange", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLine.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLine.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLine.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLine.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLine.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLine.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianCrossLine.prototype, "label", 2);
var $d77b025aa58d633c$var$Label = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.enabled = true;
    }
    getFont() {
        return $d77b025aa58d633c$var$TextUtils.toFontString(this);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Label.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Label.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Label.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Label.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Label.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Label.prototype, "fontFamily", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Label.prototype, "formatter", 2);
function $d77b025aa58d633c$var$calculateLabelRotation(rotation, parallel, regularFlipRotation = 0, parallelFlipRotation = 0) {
    const configuredRotation = $d77b025aa58d633c$var$normalizeAngle360FromDegrees(rotation);
    const parallelFlipFlag = !configuredRotation && parallelFlipRotation >= 0 && parallelFlipRotation <= Math.PI ? -1 : 1;
    const regularFlipFlag = !configuredRotation && regularFlipRotation >= 0 && regularFlipRotation <= Math.PI ? -1 : 1;
    let defaultRotation = 0;
    if (parallel) defaultRotation = parallelFlipFlag * Math.PI / 2;
    else if (regularFlipFlag === -1) defaultRotation = Math.PI;
    return {
        configuredRotation: configuredRotation,
        defaultRotation: defaultRotation,
        parallelFlipFlag: parallelFlipFlag,
        regularFlipFlag: regularFlipFlag
    };
}
function $d77b025aa58d633c$var$getLabelSpacing(minSpacing, rotated) {
    if (minSpacing != null) return minSpacing;
    return rotated ? 0 : 10;
}
function $d77b025aa58d633c$var$getTextBaseline(parallel, labelRotation, sideFlag, parallelFlipFlag, backwardsCompatibleTopBaseline) {
    if (parallel && !labelRotation) {
        const topBaseline = backwardsCompatibleTopBaseline ? "hanging" : "top";
        return sideFlag * parallelFlipFlag === -1 ? topBaseline : "bottom";
    }
    return "middle";
}
function $d77b025aa58d633c$var$getTextAlign(parallel, labelRotation, labelAutoRotation, sideFlag, regularFlipFlag) {
    const labelRotated = labelRotation > 0 && labelRotation <= Math.PI;
    const labelAutoRotated = labelAutoRotation > 0 && labelAutoRotation <= Math.PI;
    const alignFlag = labelRotated || labelAutoRotated ? -1 : 1;
    if (parallel) {
        if (labelRotation || labelAutoRotation) {
            if (sideFlag * alignFlag === -1) return "end";
        } else return "center";
    } else if (sideFlag * regularFlipFlag === -1) return "end";
    return "start";
}
function $d77b025aa58d633c$var$labelSpecifier(format, timeInterval) {
    if (format == null) return;
    if (typeof format === "string") return format;
    else if ((0, $idDdm.isPlainObject)(format) && timeInterval != null) return format[$d77b025aa58d633c$var$intervalUnit(timeInterval)];
}
function $d77b025aa58d633c$var$timeIntervalMaxLabelSize(scale2, label, primaryLabel, domain, ticks, timeInterval, textMeasurer) {
    const specifier = $d77b025aa58d633c$var$labelSpecifier(label.format, timeInterval) ?? (typeof label.format === "string" ? label.format : void 0);
    const formatParams = {
        domain: domain,
        ticks: ticks,
        fractionDigits: 0,
        specifier: specifier
    };
    const labelFormatter = scale2.tickFormatter(formatParams);
    const hierarchy = timeInterval ? $d77b025aa58d633c$var$intervalHierarchy(timeInterval) : void 0;
    const primarySpecifier = $d77b025aa58d633c$var$labelSpecifier(primaryLabel?.format, hierarchy);
    const primaryLabelFormatter = primarySpecifier ? scale2.tickFormatter({
        ...formatParams,
        specifier: primarySpecifier
    }) : labelFormatter;
    const d0 = new Date(domain[0]);
    const d1 = new Date(domain[domain.length - 1]);
    const hierarchyRange = hierarchy?.range(new Date(domain[0]), new Date(domain[domain.length - 1]), {
        extend: true
    });
    let maxWidth = 0;
    let maxHeight = 0;
    if (labelFormatter != null) {
        let l0;
        let l1;
        if (hierarchyRange != null && hierarchyRange.length > 1) {
            l0 = hierarchyRange[0];
            l1 = hierarchyRange[1];
        } else {
            l0 = d0;
            l1 = d1;
        }
        const labelRange = $d77b025aa58d633c$var$intervalRange(timeInterval, l0, l1, {
            limit: 50
        });
        for (const date6 of labelRange){
            const text = labelFormatter(date6);
            const { width: width2, height: height2 } = textMeasurer.measureLines(text);
            maxWidth = Math.max(maxWidth, width2);
            maxHeight = Math.max(maxHeight, height2);
        }
    }
    if (primaryLabelFormatter != null && hierarchyRange != null) for (const date6 of hierarchyRange){
        const text = primaryLabelFormatter(date6);
        const { width: width2, height: height2 } = textMeasurer.measureLines(text);
        maxWidth = Math.max(maxWidth, width2);
        maxHeight = Math.max(maxHeight, height2);
    }
    return {
        width: Math.ceil(maxWidth),
        height: Math.ceil(maxHeight)
    };
}
function $d77b025aa58d633c$var$createLabelData(tickData, labelX, labelMatrix, textMeasurer) {
    const labelData = [];
    for (const { tickLabel: text, translationY: translationY } of tickData){
        if (!text) continue;
        const { x: x, y: y } = labelMatrix.transformBBox(new $d77b025aa58d633c$var$BBox(labelX, translationY, 0, 0));
        const { width: width2, height: height2 } = textMeasurer.measureLines(text);
        labelData.push({
            point: {
                x: x,
                y: y
            },
            label: {
                text: text,
                width: width2,
                height: height2
            }
        });
    }
    return labelData;
}
function $d77b025aa58d633c$var$createFixedLabelData({ width: width2, height: height2, spacing: spacing }, labelX, labelMatrix) {
    const labelData = [];
    for (const translationY of [
        0,
        spacing
    ]){
        const { x: x, y: y } = labelMatrix.transformBBox(new $d77b025aa58d633c$var$BBox(labelX, translationY, 0, 0));
        labelData.push({
            point: {
                x: x,
                y: y
            },
            label: {
                text: void 0,
                width: width2,
                height: height2
            }
        });
    }
    return labelData;
}
// packages/ag-charts-community/src/chart/axis/axisGridLine.ts
var $d77b025aa58d633c$var$AxisGridLine = class {
    constructor(){
        this.enabled = true;
        this.width = 1;
        this.style = [
            {
                stroke: void 0,
                lineDash: []
            }
        ];
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisGridLine.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisGridLine.prototype, "width", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisGridLine.prototype, "style", 2);
// packages/ag-charts-community/src/chart/axis/axisInterval.ts
var $d77b025aa58d633c$var$AxisInterval = class extends $d77b025aa58d633c$var$BaseProperties {
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisInterval.prototype, "step", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisInterval.prototype, "values", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisInterval.prototype, "minSpacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisInterval.prototype, "maxSpacing", 2);
// packages/ag-charts-community/src/chart/axis/axisLabel.ts
var $d77b025aa58d633c$var$AxisLabel = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.enabled = true;
        this.spacing = 5;
        this.color = "#575757";
        this.avoidCollisions = true;
        this.mirrored = false;
        this.parallel = false;
    }
    /**
   * The side of the axis line to position the labels on.
   * -1 = left (default)
   * 1 = right
   */ getSideFlag() {
        return this.mirrored ? 1 : -1;
    }
    getFont() {
        return $d77b025aa58d633c$var$TextUtils.toFontString(this);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLabel.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLabel.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLabel.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLabel.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLabel.prototype, "fontFamily", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLabel.prototype, "spacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLabel.prototype, "minSpacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLabel.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLabel.prototype, "rotation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLabel.prototype, "avoidCollisions", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLabel.prototype, "mirrored", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLabel.prototype, "parallel", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLabel.prototype, "itemStyler", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLabel.prototype, "formatter", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLabel.prototype, "format", 2);
// packages/ag-charts-community/src/chart/axis/axisLine.ts
var $d77b025aa58d633c$var$AxisLine = class {
    constructor(){
        this.enabled = true;
        this.width = 1;
        this.stroke = void 0;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLine.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLine.prototype, "width", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisLine.prototype, "stroke", 2);
// packages/ag-charts-community/src/chart/axis/axisTick.ts
var $d77b025aa58d633c$var$AxisTick = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.enabled = true;
        this.width = 1;
        this.size = 6;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisTick.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisTick.prototype, "width", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisTick.prototype, "size", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisTick.prototype, "stroke", 2);
// packages/ag-charts-community/src/chart/axis/axisTitle.ts
var $d77b025aa58d633c$var$AxisTitle = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.caption = new $d77b025aa58d633c$var$Caption();
        this.enabled = false;
        this.spacing = $d77b025aa58d633c$var$Caption.SMALL_PADDING;
        this.fontSize = 10;
        this.fontFamily = "sans-serif";
        this.wrapping = "always";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisTitle.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisTitle.prototype, "text", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisTitle.prototype, "spacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisTitle.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisTitle.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisTitle.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisTitle.prototype, "fontFamily", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisTitle.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisTitle.prototype, "wrapping", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AxisTitle.prototype, "formatter", 2);
// packages/ag-charts-community/src/chart/axis/axisUtil.ts
var $d77b025aa58d633c$var$NiceMode = /* @__PURE__ */ ((NiceMode2)=>{
    NiceMode2[NiceMode2["TickAndDomain"] = 0] = "TickAndDomain";
    NiceMode2[NiceMode2["TicksOnly"] = 1] = "TicksOnly";
    NiceMode2[NiceMode2["Off"] = 2] = "Off";
    return NiceMode2;
})($d77b025aa58d633c$var$NiceMode || {});
function $d77b025aa58d633c$var$prepareAxisAnimationContext(axis) {
    const [requestedRangeMin, requestedRangeMax] = $d77b025aa58d633c$var$findMinMax(axis.range);
    const min = Math.floor(requestedRangeMin);
    const max = Math.ceil(requestedRangeMax);
    return {
        min: min,
        max: max,
        visible: min !== max
    };
}
var $d77b025aa58d633c$var$fullCircle = Math.PI * 2;
var $d77b025aa58d633c$var$halfCircle = $d77b025aa58d633c$var$fullCircle / 2;
function $d77b025aa58d633c$var$normaliseEndRotation(start2, end2) {
    const directDistance = Math.abs(end2 - start2);
    if (directDistance < $d77b025aa58d633c$var$halfCircle) return end2;
    else if (start2 > end2) return end2 + $d77b025aa58d633c$var$fullCircle;
    return end2 - $d77b025aa58d633c$var$fullCircle;
}
function $d77b025aa58d633c$var$prepareAxisAnimationFunctions(ctx) {
    const { min: min, max: max } = ctx;
    const outOfBounds = (y)=>{
        return y < min || y > max;
    };
    const tick = {
        fromFn (node, datum, status) {
            let { x1: x1, x2: x2, y1: y1, y2: y2 } = node;
            let opacity = node.opacity;
            if (status === "added" || outOfBounds(datum.offset)) {
                ({ x1: x1, x2: x2, y1: y1, y2: y2 } = datum);
                opacity = 0;
            }
            return {
                x1: x1,
                x2: x2,
                y1: y1,
                y2: y2,
                opacity: opacity,
                phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[status]
            };
        },
        toFn (_node, datum, status) {
            const { x1: x1, x2: x2, y1: y1, y2: y2 } = datum;
            let opacity = 1;
            if (status === "removed") opacity = 0;
            return {
                x1: x1,
                x2: x2,
                y1: y1,
                y2: y2,
                opacity: opacity
            };
        },
        applyFn (node, props) {
            node.setProperties(props);
            node.visible = !outOfBounds(node.y);
        }
    };
    const label = {
        fromFn (node, newDatum, status) {
            const datum = node.previousDatum ?? newDatum;
            let { x: x, y: y, rotationCenterX: rotationCenterX, rotationCenterY: rotationCenterY, rotation: rotation } = datum;
            let opacity = node.opacity;
            if (status === "removed" || outOfBounds(datum.y)) rotation = newDatum.rotation;
            else if (status === "added" || outOfBounds(node.datum.y)) {
                ({ x: x, y: y, rotationCenterX: rotationCenterX, rotationCenterY: rotationCenterY, rotation: rotation } = newDatum);
                opacity = 0;
            }
            return {
                x: x,
                y: y,
                rotationCenterX: rotationCenterX,
                rotationCenterY: rotationCenterY,
                rotation: rotation,
                opacity: opacity,
                phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[status]
            };
        },
        toFn (node, datum, status) {
            const { x: x, y: y, rotationCenterX: rotationCenterX, rotationCenterY: rotationCenterY } = datum;
            let rotation = 0;
            let opacity = 1;
            if (status === "added") rotation = datum.rotation;
            else if (status === "removed") {
                opacity = 0;
                rotation = datum.rotation;
            } else rotation = $d77b025aa58d633c$var$normaliseEndRotation(node.previousDatum?.rotation ?? datum.rotation, datum.rotation);
            return {
                x: x,
                y: y,
                rotationCenterX: rotationCenterX,
                rotationCenterY: rotationCenterY,
                rotation: rotation,
                opacity: opacity,
                finish: {
                    rotation: datum.rotation
                }
            };
        }
    };
    const line = {
        fromFn (node, datum) {
            const { x1: x1, x2: x2, y1: y1, y2: y2 } = node.previousDatum ?? datum;
            return {
                x1: x1,
                x2: x2,
                y1: y1,
                y2: y2,
                phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING["updated"]
            };
        },
        toFn (_node, datum) {
            const { x1: x1, x2: x2, y1: y1, y2: y2 } = datum;
            return {
                x1: x1,
                x2: x2,
                y1: y1,
                y2: y2
            };
        }
    };
    const group = {
        fromFn (node, _datum) {
            const { translationX: translationX, translationY: translationY } = node;
            return {
                translationX: translationX,
                translationY: translationY,
                phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING["updated"]
            };
        },
        toFn (_node, datum) {
            const { translationX: translationX, translationY: translationY } = datum;
            return {
                translationX: translationX,
                translationY: translationY
            };
        }
    };
    return {
        tick: tick,
        line: line,
        label: label,
        group: group
    };
}
function $d77b025aa58d633c$var$resetAxisGroupFn() {
    return (_node, datum)=>{
        return {
            translationX: datum.translationX,
            translationY: datum.translationY
        };
    };
}
function $d77b025aa58d633c$var$resetAxisLabelSelectionFn() {
    return (_node, datum)=>{
        return {
            x: datum.x,
            y: datum.y,
            rotationCenterX: datum.rotationCenterX,
            rotationCenterY: datum.rotationCenterY,
            rotation: datum.rotation
        };
    };
}
function $d77b025aa58d633c$var$resetAxisLineSelectionFn() {
    return (_node, datum)=>{
        const { x1: x1, x2: x2, y1: y1, y2: y2 } = datum;
        return {
            x1: x1,
            x2: x2,
            y1: y1,
            y2: y2
        };
    };
}
var $d77b025aa58d633c$var$hardCodedTimeFormats = {
    millisecond: "%Y %b %e %H:%M:%S.%L",
    second: "%Y %b %e %H:%M:%S",
    minute: "%Y %b %e %H:%M",
    hour: "%Y %b %e %H:%M",
    day: "%Y %b %e",
    month: "%Y %b",
    year: "%Y"
};
var $d77b025aa58d633c$var$FORMAT_ORDERS = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5,
    millisecond: 6
};
var $d77b025aa58d633c$var$MILLISECOND_FORMAT = /%[-_0]?L/;
var $d77b025aa58d633c$var$SECOND_FORMAT = /%[-_0]?S/;
var $d77b025aa58d633c$var$MINUTE_FORMAT = /%[-_0]?M/;
var $d77b025aa58d633c$var$HOUR_FORMAT = /%[-_0]?[HI]/;
var $d77b025aa58d633c$var$DAY_FORMAT = /^%[-_0]?[de]$/;
var $d77b025aa58d633c$var$MONTH_FORMAT = /^%[-_0]?[Bbm]$/;
var $d77b025aa58d633c$var$YEAR_FORMAT = /^%[-_0]?[Yy]$/;
function $d77b025aa58d633c$var$deriveTimeSpecifier(format, timeInterval) {
    if (!(0, $idDdm.isPlainObject)(format)) return format;
    const unit = $d77b025aa58d633c$var$intervalUnit(timeInterval);
    const { millisecond: millisecond2, second: second2, minute: minute2, hour: hour2, day: day2, month: month2, year: year2 } = format;
    const formatOrder = $d77b025aa58d633c$var$FORMAT_ORDERS[unit];
    const hardcodedTimeFormat = $d77b025aa58d633c$var$hardCodedTimeFormats[unit];
    if (formatOrder >= $d77b025aa58d633c$var$FORMAT_ORDERS.year && !$d77b025aa58d633c$var$YEAR_FORMAT.test(year2) || formatOrder >= $d77b025aa58d633c$var$FORMAT_ORDERS.month && !$d77b025aa58d633c$var$MONTH_FORMAT.test(month2) || formatOrder >= $d77b025aa58d633c$var$FORMAT_ORDERS.day && !$d77b025aa58d633c$var$DAY_FORMAT.test(day2)) return hardcodedTimeFormat;
    let specifier;
    switch(unit){
        case "year":
            return year2;
        case "month":
            return `${month2} ${year2}`;
        case "day":
            return `${month2} ${day2} ${year2}`;
        case "hour":
            specifier = hour2;
            break;
        case "minute":
            specifier = minute2;
            break;
        case "second":
            specifier = second2;
            break;
        case "millisecond":
            specifier = millisecond2;
            break;
        default:
            return hardcodedTimeFormat;
    }
    if (formatOrder >= $d77b025aa58d633c$var$FORMAT_ORDERS.hour && !$d77b025aa58d633c$var$HOUR_FORMAT.test(specifier) || formatOrder >= $d77b025aa58d633c$var$FORMAT_ORDERS.minute && !$d77b025aa58d633c$var$MINUTE_FORMAT.test(specifier) || formatOrder >= $d77b025aa58d633c$var$FORMAT_ORDERS.second && !$d77b025aa58d633c$var$SECOND_FORMAT.test(specifier) || formatOrder >= $d77b025aa58d633c$var$FORMAT_ORDERS.millisecond && !$d77b025aa58d633c$var$MILLISECOND_FORMAT.test(specifier)) return hardcodedTimeFormat;
    return `${specifier} ${month2} ${day2} ${year2}`;
}
// packages/ag-charts-community/src/chart/axis/axis.ts
var $d77b025aa58d633c$var$TranslatableLine = class extends $d77b025aa58d633c$var$Translatable($d77b025aa58d633c$var$Line) {
};
var $d77b025aa58d633c$var$AxisGroupZIndexMap = /* @__PURE__ */ ((AxisGroupZIndexMap2)=>{
    AxisGroupZIndexMap2[AxisGroupZIndexMap2["TickLines"] = 0] = "TickLines";
    AxisGroupZIndexMap2[AxisGroupZIndexMap2["AxisLine"] = 1] = "AxisLine";
    AxisGroupZIndexMap2[AxisGroupZIndexMap2["TickLabels"] = 2] = "TickLabels";
    return AxisGroupZIndexMap2;
})($d77b025aa58d633c$var$AxisGroupZIndexMap || {});
var $d77b025aa58d633c$var$_Axis = class _Axis {
    constructor(moduleCtx, scale2){
        this.moduleCtx = moduleCtx;
        this.scale = scale2;
        this.id = (0, $idDdm.createId)(this);
        this.nice = true;
        this.reverse = false;
        this.keys = [];
        this.interval = new $d77b025aa58d633c$var$AxisInterval();
        this.dataDomain = {
            domain: [],
            clipped: false
        };
        this.layoutConstraints = {
            stacked: true,
            align: "start",
            width: 100,
            unit: "percent"
        };
        this.boundSeries = [];
        this.includeInvisibleDomains = false;
        this.interactionEnabled = true;
        this.axisGroup = new $d77b025aa58d633c$var$Group({
            name: `${this.id}-axis`
        });
        // Order is important to apply the correct z-index.
        this.tickLineGroup = this.axisGroup.appendChild(new $d77b025aa58d633c$var$TransformableGroup({
            name: `${this.id}-Axis-tick-lines`,
            zIndex: 0 /* TickLines */ 
        }));
        this.tickLabelGroup = this.axisGroup.appendChild(new $d77b025aa58d633c$var$TransformableGroup({
            name: `${this.id}-Axis-tick-labels`,
            zIndex: 2 /* TickLabels */ 
        }));
        this.labelGroup = new $d77b025aa58d633c$var$Group({
            name: `${this.id}-Labels`,
            zIndex: 9 /* SERIES_ANNOTATION */ 
        });
        this.gridGroup = new $d77b025aa58d633c$var$TranslatableGroup({
            name: `${this.id}-Axis-grid`,
            zIndex: 1 /* AXIS_GRID */ 
        });
        this.gridLineGroup = this.gridGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-gridLines`
        }));
        this.crossLineRangeGroup = new $d77b025aa58d633c$var$TransformableGroup({
            name: `${this.id}-CrossLines-Range`,
            zIndex: 4 /* SERIES_CROSSLINE_RANGE */ 
        });
        this.crossLineLineGroup = new $d77b025aa58d633c$var$TransformableGroup({
            name: `${this.id}-CrossLines-Line`,
            zIndex: 8 /* SERIES_CROSSLINE_LINE */ 
        });
        this.crossLineLabelGroup = new $d77b025aa58d633c$var$TransformableGroup({
            name: `${this.id}-CrossLines-Label`,
            zIndex: 13 /* SERIES_LABEL */ 
        });
        this.tickLabelGroupSelection = $d77b025aa58d633c$var$Selection.select(this.tickLabelGroup, $d77b025aa58d633c$var$TransformableText, false);
        this._crossLines = [];
        this.line = new $d77b025aa58d633c$var$AxisLine();
        this.tick = new $d77b025aa58d633c$var$AxisTick();
        this.gridLine = new $d77b025aa58d633c$var$AxisGridLine();
        this.label = this.createLabel();
        this.defaultTickMinSpacing = _Axis.defaultTickMinSpacing;
        this.translation = {
            x: 0,
            y: 0
        };
        this.layout = {
            label: {
                fractionDigits: 0,
                spacing: this.label.spacing,
                format: this.label.format
            }
        };
        this.axisContext = void 0;
        this.labelFormatter = void 0;
        this.datumFormatter = void 0;
        this.scaleFormatterParams = void 0;
        this.destroyFns = [];
        this.range = [
            0,
            1
        ];
        this.visibleRange = [
            0,
            1
        ];
        this.title = new $d77b025aa58d633c$var$AxisTitle();
        this.gridLength = 0;
        /**
     * The distance between the grid ticks and the axis ticks.
     */ this.gridPadding = 0;
        /**
     * Is used to avoid collisions between axis labels and series.
     */ this.seriesAreaPadding = 0;
        this.animatable = true;
        this._cachedUnzoomedInputDomain = void 0;
        this._cachedUnzoomedRangeExtent = NaN;
        this._cachedUnzoomedTickCount = 0;
        this.moduleMap = new $d77b025aa58d633c$var$ModuleMap();
        this.range = this.scale.range.slice();
        this.crossLines.forEach((crossLine)=>this.initCrossLine(crossLine));
    }
    get type() {
        return this.constructor.type ?? "";
    }
    get labelNodes() {
        return this.tickLabelGroupSelection.nodes();
    }
    set crossLines(value) {
        const { CrossLineConstructor: CrossLineConstructor } = this.constructor;
        this._crossLines.forEach((crossLine)=>this.detachCrossLine(crossLine));
        this._crossLines = value.map((crossLine)=>{
            const instance = new CrossLineConstructor();
            instance.set(crossLine);
            return instance;
        });
        this._crossLines.forEach((crossLine)=>{
            this.attachCrossLine(crossLine);
            this.initCrossLine(crossLine);
        });
    }
    get crossLines() {
        return this._crossLines;
    }
    resetAnimation(_phase) {}
    attachCrossLine(crossLine) {
        this.crossLineRangeGroup.appendChild(crossLine.rangeGroup);
        this.crossLineLineGroup.appendChild(crossLine.lineGroup);
        this.crossLineLabelGroup.appendChild(crossLine.labelGroup);
    }
    detachCrossLine(crossLine) {
        this.crossLineRangeGroup.removeChild(crossLine.rangeGroup);
        this.crossLineLineGroup.removeChild(crossLine.lineGroup);
        this.crossLineLabelGroup.removeChild(crossLine.labelGroup);
    }
    destroy() {
        this.moduleMap.destroy();
        this.destroyFns.forEach((f)=>f());
    }
    updateScale() {
        const { range: rr, visibleRange: vr, scale: scale2 } = this;
        const span = (rr[1] - rr[0]) / (vr[1] - vr[0]);
        const shift = span * vr[0];
        const start2 = rr[0] - shift;
        scale2.range = [
            start2,
            start2 + span
        ];
        this.crossLines.forEach((crossLine)=>{
            crossLine.clippedRange = [
                rr[0],
                rr[1]
            ];
        });
    }
    setCrossLinesVisible(visible) {
        this.crossLineRangeGroup.visible = visible;
        this.crossLineLineGroup.visible = visible;
        this.crossLineLabelGroup.visible = visible;
    }
    attachAxis(groups) {
        groups.gridNode.appendChild(this.gridGroup);
        groups.axisNode.appendChild(this.axisGroup);
        groups.labelNode.appendChild(this.labelGroup);
        groups.crossLineRangeNode.appendChild(this.crossLineRangeGroup);
        groups.crossLineLineNode.appendChild(this.crossLineLineGroup);
        groups.crossLineLabelNode.appendChild(this.crossLineLabelGroup);
    }
    detachAxis(groups) {
        groups.gridNode.removeChild(this.gridGroup);
        groups.axisNode.removeChild(this.axisGroup);
        groups.labelNode.removeChild(this.labelGroup);
        groups.crossLineRangeNode.removeChild(this.crossLineRangeGroup);
        groups.crossLineLineNode.removeChild(this.crossLineLineGroup);
        groups.crossLineLabelNode.removeChild(this.crossLineLabelGroup);
    }
    attachLabel(axisLabelNode) {
        this.labelGroup.append(axisLabelNode);
    }
    /**
   * Checks if a point or an object is in range.
   * @param value A point (or object's starting point).
   * @param tolerance Expands the range on both ends by this amount.
   */ inRange(value, tolerance = 0) {
        const [min, max] = $d77b025aa58d633c$var$findMinMax(this.range);
        return value >= min - tolerance && value <= max + tolerance;
    }
    /**
   * Get a point's overflow on the range, expanded to include the non-visible range.
   * @param value Point
   * @returns Overflow
   */ getRangeOverflow(value) {
        const { range: rr, visibleRange: vr } = this;
        const size = (rr[1] - rr[0]) / (vr[1] - vr[0]);
        const [min, max] = $d77b025aa58d633c$var$findMinMax([
            rr[0] - size * vr[0],
            rr[0] - size * vr[0] + size
        ]);
        if (value < min) return value - min;
        if (value > max) return value - max;
        return 0;
    }
    defaultDatumFormatter(datum, fractionDigits) {
        return $d77b025aa58d633c$var$formatValue(datum, fractionDigits + 1);
    }
    defaultLabelFormatter(datum, fractionDigits) {
        return $d77b025aa58d633c$var$formatValue(datum, fractionDigits);
    }
    onGridLengthChange(value, prevValue) {
        if (prevValue ^ value) this.onGridVisibilityChange();
        this.crossLines.forEach((crossLine)=>this.initCrossLine(crossLine));
    }
    onGridVisibilityChange() {}
    createLabel() {
        return new $d77b025aa58d633c$var$AxisLabel();
    }
    /**
   * Creates/removes/updates the scene graph nodes that constitute the axis.
   */ update() {
        this.updatePosition();
        this.updateSelections();
        this.tickLineGroup.visible = this.tick.enabled;
        this.gridLineGroup.visible = this.gridLine.enabled;
        this.tickLabelGroup.visible = this.label.enabled;
        this.updateLabels();
        this.updateCrossLines();
    }
    getLabelStyles(params, additionalStyles, label = this.label) {
        const defaultStyle = {
            color: label.color,
            spacing: label.spacing,
            fontFamily: label.fontFamily,
            fontSize: label.fontSize,
            fontStyle: label.fontStyle,
            fontWeight: label.fontWeight
        };
        let stylerOutput;
        if (label.itemStyler) stylerOutput = this.callWithContext(label.itemStyler, {
            ...params,
            ...defaultStyle
        });
        const { color: fill, fontFamily: fontFamily, fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight, spacing: spacing } = $d77b025aa58d633c$var$mergeDefaults(stylerOutput, additionalStyles, defaultStyle);
        return {
            fill: fill,
            fontFamily: fontFamily,
            fontSize: fontSize,
            fontStyle: fontStyle,
            fontWeight: fontWeight,
            spacing: spacing
        };
    }
    getTickSize(tick = this.tick) {
        return tick.enabled ? tick.size : 0;
    }
    processData() {
        const { includeInvisibleDomains: includeInvisibleDomains, boundSeries: boundSeries, direction: direction } = this;
        const visibleSeries = includeInvisibleDomains ? boundSeries : boundSeries.filter((s)=>s.isEnabled());
        const domains = visibleSeries.map((series)=>series.getDomain(direction));
        this.setDomains(...domains);
    }
    setDomains(...domains) {
        let domain;
        let animatable;
        if (domains.length > 0) ({ domain: domain, animatable: animatable } = this.scale.normalizeDomains(...domains));
        else {
            domain = [];
            animatable = true;
        }
        this.dataDomain = this.normaliseDataDomain(domain);
        if (this.reverse) this.dataDomain.domain.reverse();
        this.animatable = animatable;
    }
    calculateLayout(initialPrimaryTickCount, chartPadding) {
        const { scale: scale2, label: label, visibleRange: visibleRange, nice: nice } = this;
        this.chartPadding = chartPadding;
        this.updateScale();
        const rangeExtent = $d77b025aa58d633c$var$findRangeExtent(this.range);
        const domain = this.dataDomain.domain;
        let tickLayoutDomain;
        let unzoomedTickCount;
        if (visibleRange[0] === 0 && visibleRange[1] === 1) {
            tickLayoutDomain = void 0;
            unzoomedTickCount = void 0;
        } else if (this._cachedUnzoomedInputDomain === domain && this._cachedUnzoomedRangeExtent === rangeExtent) {
            tickLayoutDomain = this.scale.domain;
            unzoomedTickCount = this._cachedUnzoomedTickCount;
        } else {
            const unzoomedTickLayout = this.calculateTickLayout(domain, nice ? 0 /* TickAndDomain */  : 2 /* Off */ , [
                0,
                1
            ]);
            tickLayoutDomain = unzoomedTickLayout.niceDomain;
            unzoomedTickCount = unzoomedTickLayout.rawTickCount ?? 0;
        }
        let niceMode;
        if (!nice) niceMode = 2 /* Off */ ;
        else if (tickLayoutDomain == null) niceMode = 0 /* TickAndDomain */ ;
        else niceMode = 1 /* TicksOnly */ ;
        const { niceDomain: niceDomain, ticks: ticks, rawTickCount: rawTickCount = 0, tickDomain: tickDomain, fractionDigits: fractionDigits, bbox: bbox } = this.calculateTickLayout(tickLayoutDomain ?? domain, niceMode, visibleRange, initialPrimaryTickCount);
        unzoomedTickCount ?? (unzoomedTickCount = rawTickCount);
        const primaryTickCount = rawTickCount !== 0 && unzoomedTickCount !== 0 ? {
            zoomed: rawTickCount,
            unzoomed: unzoomedTickCount
        } : void 0;
        const timeInterval = $d77b025aa58d633c$var$UnitTimeScale.is(scale2) ? scale2.interval : void 0;
        this.scale.domain = niceDomain;
        this._cachedUnzoomedInputDomain = domain;
        this._cachedUnzoomedRangeExtent = rangeExtent;
        this._cachedUnzoomedTickCount = unzoomedTickCount;
        const specifier = $d77b025aa58d633c$var$labelSpecifier(timeInterval == null ? label.format : $d77b025aa58d633c$var$deriveTimeSpecifier(label.format, timeInterval), timeInterval);
        this.labelFormatter = scale2.tickFormatter({
            domain: tickDomain,
            specifier: specifier,
            ticks: ticks,
            fractionDigits: fractionDigits
        }) ?? ((value)=>this.defaultLabelFormatter(value, fractionDigits));
        this.datumFormatter = scale2.datumFormatter({
            domain: tickDomain,
            specifier: specifier,
            ticks: ticks,
            fractionDigits: fractionDigits
        }) ?? ((value)=>this.defaultDatumFormatter(value, fractionDigits));
        this.scaleFormatterParams = {
            domain: tickDomain,
            ticks: ticks,
            fractionDigits: fractionDigits
        };
        this.layout.label = {
            fractionDigits: fractionDigits,
            spacing: this.label.spacing,
            format: this.label.format
        };
        this.layoutCrossLines();
        return {
            primaryTickCount: primaryTickCount,
            bbox: bbox
        };
    }
    updateCrossLines() {
        const anySeriesActive = this.isAnySeriesActive();
        this.crossLines.forEach((crossLine)=>{
            crossLine.update(anySeriesActive);
        });
    }
    updatePosition() {
        const { crossLineRangeGroup: crossLineRangeGroup, crossLineLineGroup: crossLineLineGroup, crossLineLabelGroup: crossLineLabelGroup, gridGroup: gridGroup, translation: translation } = this;
        const translationX = Math.floor(translation.x);
        const translationY = Math.floor(translation.y);
        gridGroup.setProperties({
            translationX: translationX,
            translationY: translationY
        });
        crossLineRangeGroup.setProperties({
            translationX: translationX,
            translationY: translationY
        });
        crossLineLineGroup.setProperties({
            translationX: translationX,
            translationY: translationY
        });
        crossLineLabelGroup.setProperties({
            translationX: translationX,
            translationY: translationY
        });
    }
    // For formatting (nice rounded) tick values.
    formatTick(value, index, domain, fractionDigits, timeInterval, defaultFormatter) {
        const { labelFormatter: labelFormatter, label: { formatter: formatter } } = this;
        let result;
        if (formatter) {
            const boundSeries = this.getFormatterBoundSeries();
            const unit = timeInterval ? $d77b025aa58d633c$var$intervalUnit(timeInterval) : void 0;
            const step = timeInterval ? $d77b025aa58d633c$var$intervalStep(timeInterval) : void 0;
            result = this.callWithContext(formatter, {
                value: value,
                index: index,
                domain: domain,
                fractionDigits: fractionDigits,
                unit: unit,
                step: step,
                boundSeries: boundSeries
            });
        } else if (defaultFormatter) result = defaultFormatter(value);
        else if (labelFormatter) result = labelFormatter(value);
        return String(result ?? value);
    }
    // For formatting arbitrary values between the ticks.
    formatDatum(value) {
        const { label: { formatter: formatter }, datumFormatter: valueFormatter = this.labelFormatter } = this;
        let result;
        if (formatter) {
            const { domain: domain } = this.scale;
            const boundSeries = this.getFormatterBoundSeries();
            result = this.callWithContext(formatter, {
                value: value,
                index: NaN,
                domain: domain,
                boundSeries: boundSeries
            });
        } else if (valueFormatter) result = this.callWithContext(valueFormatter, value);
        else if ((0, $idDdm.isArray)(value)) result = value.filter(Boolean).join(" - ");
        return String(result ?? value);
    }
    getScaleValueFormatter(format) {
        const { scaleFormatterParams: scaleFormatterParams } = this;
        let formatter;
        try {
            if (format != null && scaleFormatterParams != null) formatter = this.scale.tickFormatter({
                ...scaleFormatterParams,
                specifier: format
            });
        } catch  {
            (0, $idDdm.Logger).warnOnce(`the format string ${format} is invalid, ignoring.`);
        }
        formatter ?? (formatter = (value)=>this.formatDatum(value));
        return formatter;
    }
    getBBox() {
        return this.axisGroup.getBBox();
    }
    initCrossLine(crossLine) {
        crossLine.scale = this.scale;
        crossLine.gridLength = this.gridLength;
    }
    isAnySeriesActive() {
        return this.boundSeries.some((s)=>this.includeInvisibleDomains || s.isEnabled());
    }
    clipTickLines(x, y, width2, height2) {
        this.tickLineGroup.setClipRect(new $d77b025aa58d633c$var$BBox(x, y, width2, height2));
    }
    clipGrid(x, y, width2, height2) {
        this.gridGroup.setClipRect(new $d77b025aa58d633c$var$BBox(x, y, width2, height2));
    }
    getFormatterBoundSeries() {
        const { direction: direction } = this;
        const boundSeries = [];
        for (const series of this.boundSeries){
            const keys = series.getKeys(direction);
            const names = series.getNames(direction);
            for(let idx = 0; idx < keys.length; idx++)boundSeries.push({
                key: keys[idx],
                name: names[idx]
            });
        }
        return boundSeries;
    }
    getTitleFormatterParams(domain) {
        const { direction: direction } = this;
        const boundSeries = this.getFormatterBoundSeries();
        return {
            domain: domain,
            direction: direction,
            boundSeries: boundSeries,
            defaultValue: this.title?.text
        };
    }
    normaliseDataDomain(d) {
        return {
            domain: [
                ...d
            ],
            clipped: false
        };
    }
    getLayoutState() {
        return {
            id: this.id,
            rect: this.getBBox(),
            gridPadding: this.gridPadding,
            seriesAreaPadding: this.seriesAreaPadding,
            tickSize: this.getTickSize(),
            direction: this.direction,
            domain: this.dataDomain.domain,
            scale: this.scale,
            ...this.layout
        };
    }
    getModuleMap() {
        return this.moduleMap;
    }
    createModuleContext() {
        this.axisContext ?? (this.axisContext = this.createAxisContext());
        return {
            ...this.moduleCtx,
            parent: this.axisContext
        };
    }
    createAxisContext() {
        const { scale: scale2 } = this;
        return {
            axisId: this.id,
            scale: this.scale,
            direction: this.direction,
            continuous: $d77b025aa58d633c$var$ContinuousScale.is(scale2) || $d77b025aa58d633c$var$DiscreteTimeScale.is(scale2),
            getCanvasBounds: ()=>{
                return $d77b025aa58d633c$var$Transformable.toCanvas(this.axisGroup);
            },
            seriesKeyProperties: ()=>this.boundSeries.reduce((keys, series)=>{
                    const seriesKeys = series.getKeyProperties(this.direction);
                    seriesKeys.forEach((key)=>keys.add(key));
                    return keys;
                }, /* @__PURE__ */ new Set()),
            seriesIds: ()=>this.boundSeries.map((series)=>series.id),
            scaleValueFormatter: (specifier)=>this.getScaleValueFormatter(specifier),
            scaleInvert: (val)=>scale2.invert(val, true),
            scaleInvertNearest: (val)=>scale2.invert(val, true),
            attachLabel: (node)=>this.attachLabel(node),
            inRange: (value, tolerance)=>this.inRange(value, tolerance),
            getRangeOverflow: (value)=>this.getRangeOverflow(value)
        };
    }
    isReversed() {
        return this.reverse;
    }
    callWithContext(fn, ...params) {
        const { callbackCache: callbackCache, chartService: chartService } = this.moduleCtx;
        return callbackCache.call(this, chartService, fn, ...params);
    }
};
$d77b025aa58d633c$var$_Axis.defaultTickMinSpacing = 50;
$d77b025aa58d633c$var$_Axis.CrossLineConstructor = $d77b025aa58d633c$var$CartesianCrossLine;
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_Axis.prototype, "nice", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_Axis.prototype, "reverse", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_Axis.prototype, "keys", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_Axis.prototype, "interval", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_Axis.prototype, "title", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target, value, oldValue)=>target.onGridLengthChange(value, oldValue))
], $d77b025aa58d633c$var$_Axis.prototype, "gridLength", 2);
var $d77b025aa58d633c$var$Axis = $d77b025aa58d633c$var$_Axis;
function $d77b025aa58d633c$var$calculateNiceSecondaryAxis(scale2, domain, primaryTickCount, reverse, visibleRange) {
    let [d0, d1] = $d77b025aa58d633c$var$findMinMax(domain.map(Number));
    const unzoomedTickCount = Math.floor(primaryTickCount.unzoomed);
    if (unzoomedTickCount <= 1) {
        const [start3, stop2] = $d77b025aa58d633c$var$domainWithOddTickCount(d0, d1);
        const tickCount = 5 * Math.pow(2, -Math.ceil(Math.log2(visibleRange[1] - visibleRange[0])));
        const { ticks: ticks2 } = $d77b025aa58d633c$var$createTicks(start3, stop2, tickCount, void 0, void 0, visibleRange);
        const d2 = [
            scale2.toDomain(start3),
            scale2.toDomain(stop2)
        ];
        if (reverse) d2.reverse();
        return {
            domain: d2,
            ticks: ticks2
        };
    }
    if (d0 === d1) {
        const order = Math.floor(Math.log10(d0));
        const magnitude = Math.pow(10, order);
        const rangeOffsetStep = Math.min(magnitude, 1);
        const rangeOffset = unzoomedTickCount - 1;
        d0 -= rangeOffsetStep * Math.floor(rangeOffset / 2);
        d1 = d0 + rangeOffsetStep * rangeOffset;
    }
    let start2 = d0;
    let stop = d1;
    start2 = $d77b025aa58d633c$var$calculateNiceStart(start2, stop, unzoomedTickCount);
    const baseStep = $d77b025aa58d633c$var$getTickStep(start2, stop, unzoomedTickCount);
    const segments = unzoomedTickCount - 1;
    stop = start2 + segments * baseStep;
    const stepAlignedStart = Math.floor(start2 / baseStep) * baseStep;
    const stepAlignedStop = Math.floor(stop / baseStep) * baseStep;
    if (stepAlignedStart <= d0 && stepAlignedStop >= d1) {
        start2 = stepAlignedStart;
        stop = stepAlignedStop;
    }
    const d = [
        scale2.toDomain(start2),
        scale2.toDomain(stop)
    ];
    if (reverse) d.reverse();
    const step = baseStep * ((primaryTickCount.unzoomed - 1) / (primaryTickCount.zoomed - 1));
    const ticks = $d77b025aa58d633c$var$getTicks(start2, step, Math.floor(primaryTickCount.zoomed));
    return {
        domain: d,
        ticks: ticks
    };
}
function $d77b025aa58d633c$var$domainWithOddTickCount(d0, d1) {
    let start2 = d0;
    let stop = d1;
    let iterations = 0;
    do {
        [start2, stop] = $d77b025aa58d633c$var$niceTicksDomain(start2, stop);
        const { ticks: ticks } = $d77b025aa58d633c$var$createTicks(start2, stop, 5);
        if (ticks.length % 2 === 1) return [
            start2,
            stop
        ];
        start2 -= 1;
        stop += 1;
    }while (iterations++ < 10);
    return [
        d0,
        d1
    ];
}
function $d77b025aa58d633c$var$calculateNiceStart(a, b, count) {
    a = Math.floor(a);
    const rawStep = Math.abs(b - a) / (count - 1);
    const order = Math.floor(Math.log10(rawStep));
    const magnitude = Math.pow(10, order);
    return Math.floor(a / magnitude) * magnitude;
}
function $d77b025aa58d633c$var$getTicks(start2, step, count) {
    const fractionDigits = (0, $idDdm.countFractionDigits)(step);
    const f = Math.pow(10, fractionDigits);
    const ticks = [];
    for(let i = 0; i < count; i++){
        const tick = start2 + step * i;
        ticks.push(Math.round(tick * f) / f);
    }
    return ticks;
}
function $d77b025aa58d633c$var$getTickStep(start2, stop, count) {
    const segments = count - 1;
    const rawStep = (stop - start2) / segments;
    return $d77b025aa58d633c$var$calculateNextNiceStep(rawStep);
}
function $d77b025aa58d633c$var$calculateNextNiceStep(rawStep) {
    const order = Math.floor(Math.log10(rawStep));
    const magnitude = Math.pow(10, order);
    const step = rawStep / magnitude;
    if (step > 0 && step <= 1) return magnitude;
    if (step > 1 && step <= 2) return 2 * magnitude;
    if (step > 2 && step <= 5) return 5 * magnitude;
    if (step > 5 && step <= 10) return 10 * magnitude;
    return rawStep;
}
// packages/ag-charts-community/src/util/tempUtils.ts
function $d77b025aa58d633c$var$createIdsGenerator() {
    const idsCounter = /* @__PURE__ */ new Map();
    return (name)=>{
        const counter = idsCounter.get(name);
        if (counter) {
            idsCounter.set(name, counter + 1);
            return `${name}_${counter}`;
        }
        idsCounter.set(name, 1);
        return name;
    };
}
// packages/ag-charts-community/src/chart/axis/axisTickGenerator.ts
function $d77b025aa58d633c$var$ticksSpacing(ticks) {
    if (ticks.length < 2) return Infinity;
    let spacing = 0;
    let y0 = ticks[0].translationY;
    for(let i = 1; i < ticks.length; i++){
        const y1 = ticks[i].translationY;
        const delta3 = Math.abs(y1 - y0);
        spacing = Math.max(spacing, delta3);
        y0 = y1;
    }
    return spacing;
}
var $d77b025aa58d633c$var$AxisTickGenerator = class {
    constructor(axis){
        this.axis = axis;
    }
    estimateTickCount(visibleRange, minSpacing, maxSpacing) {
        const { scale: scale2, range: range3, defaultTickMinSpacing: defaultTickMinSpacing } = this.axis;
        const defaultTickCount = $d77b025aa58d633c$var$UnitTimeScale.is(scale2) ? $d77b025aa58d633c$var$UnitTimeScale.defaultTickCount : $d77b025aa58d633c$var$ContinuousScale.defaultTickCount;
        return $d77b025aa58d633c$var$estimateTickCount($d77b025aa58d633c$var$findRangeExtent(range3), $d77b025aa58d633c$var$findRangeExtent(visibleRange), minSpacing, maxSpacing, defaultTickCount, defaultTickMinSpacing);
    }
    filterTicks(ticks, tickCount) {
        const { minSpacing: minSpacing, maxSpacing: maxSpacing } = this.axis.interval;
        const tickSpacing = minSpacing != null || maxSpacing != null;
        const keepEvery = tickSpacing ? Math.ceil(ticks.length / tickCount) : 2;
        const offset4 = ticks.length % keepEvery ? -1 : 0;
        return ticks.filter((_, i)=>(i + offset4) % keepEvery === 0);
    }
    generateTicks({ domain: domain, primaryTickCount: primaryTickCount, visibleRange: visibleRange, niceMode: niceMode, parallelFlipRotation: parallelFlipRotation, regularFlipRotation: regularFlipRotation, labelX: labelX, sideFlag: sideFlag, removeOverflowLabels: removeOverflowLabels, removeOverflowThreshold: removeOverflowThreshold = 0 }) {
        const { scale: scale2, label: label, primaryLabel: primaryLabel, interval: { minSpacing: minSpacing, maxSpacing: maxSpacing } } = this.axis;
        const { parallel: parallel, fontFamily: fontFamily, fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight } = label;
        const secondaryAxis = primaryTickCount !== void 0;
        const { defaultRotation: defaultRotation, configuredRotation: configuredRotation, parallelFlipFlag: parallelFlipFlag, regularFlipFlag: regularFlipFlag } = $d77b025aa58d633c$var$calculateLabelRotation(label.rotation, parallel, regularFlipRotation, parallelFlipRotation);
        const { maxTickCount: maxTickCount } = this.estimateTickCount(visibleRange, minSpacing, maxSpacing);
        const continuous = $d77b025aa58d633c$var$ContinuousScale.is(scale2) || $d77b025aa58d633c$var$DiscreteTimeScale.is(scale2);
        const maxIterations = !continuous || isNaN(maxTickCount) ? 10 : maxTickCount;
        let textAlign = $d77b025aa58d633c$var$getTextAlign(parallel, configuredRotation, 0, sideFlag, regularFlipFlag);
        const textBaseline = $d77b025aa58d633c$var$getTextBaseline(parallel, configuredRotation, sideFlag, parallelFlipFlag, primaryLabel == null);
        const font2 = $d77b025aa58d633c$var$TextUtils.toFontString({
            fontFamily: fontFamily,
            fontSize: fontSize,
            fontStyle: fontStyle,
            fontWeight: fontWeight
        });
        const textMeasurer = $d77b025aa58d633c$var$CachedTextMeasurerPool.getMeasurer({
            font: font2
        });
        const textProps = {
            fontFamily: fontFamily,
            fontSize: fontSize,
            fontStyle: fontStyle,
            fontWeight: fontWeight,
            textBaseline: textBaseline,
            textAlign: textAlign
        };
        const checkLabelOverlap = label.enabled && label.avoidCollisions;
        const initialRotation = configuredRotation + defaultRotation;
        const labelMatrix = new $d77b025aa58d633c$var$Matrix();
        const updateLabelMatrix = (iterationRotation)=>{
            const labelRotation = initialRotation + iterationRotation;
            $d77b025aa58d633c$var$Matrix.updateTransformMatrix(labelMatrix, 1, 1, labelRotation, 0, 0);
        };
        const getLabelData = ({ ticks: ticks }, iterationRotation)=>{
            updateLabelMatrix(iterationRotation);
            return $d77b025aa58d633c$var$createLabelData(ticks, labelX, labelMatrix, textMeasurer);
        };
        const getTimeLabelData = (tickData2, iterationRotation)=>{
            const { niceDomain: niceDomain, ticks: ticks, rawTicks: rawTicks, timeInterval: timeInterval } = tickData2;
            if (timeInterval == null) return [];
            updateLabelMatrix(iterationRotation);
            const spacing = $d77b025aa58d633c$var$ticksSpacing(ticks);
            const { width: width2, height: height2 } = $d77b025aa58d633c$var$timeIntervalMaxLabelSize(scale2, label, primaryLabel, niceDomain ?? domain, rawTicks, timeInterval, textMeasurer);
            return $d77b025aa58d633c$var$createFixedLabelData({
                width: width2,
                height: height2,
                spacing: spacing
            }, labelX, labelMatrix);
        };
        const getLabelOverlap = (tickData2, iterationRotation)=>{
            if (!checkLabelOverlap) return false;
            const rotated = configuredRotation !== 0 || iterationRotation !== 0;
            const labelSpacing = $d77b025aa58d633c$var$getLabelSpacing(label.minSpacing, rotated);
            const overlap = $d77b025aa58d633c$var$axisLabelsOverlap(getTimeLabelData(tickData2, iterationRotation), labelSpacing) || $d77b025aa58d633c$var$axisLabelsOverlap(getLabelData(tickData2, iterationRotation), labelSpacing);
            return overlap;
        };
        let tickData = {
            tickDomain: [],
            ticks: [],
            rawTicks: [],
            rawTickCount: void 0,
            timeInterval: void 0,
            fractionDigits: 0,
            niceDomain: void 0
        };
        let index = 0;
        let autoRotation = 0;
        let labelOverlap = true;
        let terminate = false;
        while(!terminate && labelOverlap && index <= maxIterations){
            autoRotation = 0;
            for (const strategy of this.getTickStrategies({
                domain: domain,
                niceMode: niceMode,
                secondaryAxis: secondaryAxis,
                index: index
            }))({ tickData: tickData, index: index, autoRotation: autoRotation, terminate: terminate } = strategy({
                index: index,
                tickData: tickData,
                textProps: textProps,
                terminate: terminate,
                primaryTickCount: primaryTickCount,
                visibleRange: visibleRange,
                labelsOverlap () {
                    return getLabelOverlap(tickData, autoRotation);
                }
            }));
            labelOverlap = getLabelOverlap(tickData, autoRotation);
        }
        textAlign = $d77b025aa58d633c$var$getTextAlign(parallel, configuredRotation, autoRotation, sideFlag, regularFlipFlag);
        const rotation = configuredRotation + autoRotation;
        if (removeOverflowLabels && tickData.ticks.length > 2) {
            const labelData = getLabelData(tickData, autoRotation);
            const lastTick = tickData.ticks.at(-1);
            const lastLabel = labelData.at(-1);
            if (lastTick != null && lastLabel != null && lastTick.translationY + lastLabel.label.width / 2 > this.axis.range[1] + removeOverflowThreshold) {
                lastTick.tickLabel = void 0;
                const firstTick = tickData.ticks[0];
                if (firstTick.translationY === 0 && visibleRange[0] === 0 && visibleRange[1] === 1) firstTick.tickLabel = void 0;
            }
        }
        return {
            tickData: tickData,
            rotation: rotation,
            textBaseline: textBaseline,
            textAlign: textAlign
        };
    }
    getTickStrategies({ domain: domain, niceMode: niceMode, index: iteration, secondaryAxis: secondaryAxis }) {
        const { scale: scale2, label: label, interval: interval } = this.axis;
        const { minSpacing: minSpacing } = interval;
        const continuous = $d77b025aa58d633c$var$ContinuousScale.is(scale2) || $d77b025aa58d633c$var$DiscreteTimeScale.is(scale2);
        const avoidLabelCollisions = label.enabled && label.avoidCollisions;
        const filterTicks = !continuous && iteration !== 0 && avoidLabelCollisions;
        const autoRotate = label.autoRotate === true && label.rotation === void 0;
        const strategies = [];
        let tickGenerationType;
        if (interval.values) tickGenerationType = 3 /* VALUES */ ;
        else if (secondaryAxis) tickGenerationType = 1 /* CREATE_SECONDARY */ ;
        else if (filterTicks) tickGenerationType = 2 /* FILTER */ ;
        else tickGenerationType = 0 /* CREATE */ ;
        const tickGenerationStrategy = ({ index: index, tickData: tickData, primaryTickCount: primaryTickCount, visibleRange: visibleRange, terminate: terminate })=>this.createTickData(domain, niceMode, visibleRange, primaryTickCount, tickGenerationType, index, tickData, terminate);
        strategies.push(tickGenerationStrategy);
        if (!continuous && minSpacing != null) {
            const tickFilterStrategy = ({ index: index, tickData: tickData, primaryTickCount: primaryTickCount, visibleRange: visibleRange, terminate: terminate })=>this.createTickData(domain, niceMode, visibleRange, primaryTickCount, 2 /* FILTER */ , index, tickData, terminate);
            strategies.push(tickFilterStrategy);
        }
        if (avoidLabelCollisions && autoRotate) {
            const autoRotateStrategy = ({ index: index, tickData: tickData, labelsOverlap: labelsOverlap, terminate: terminate })=>({
                    index: index,
                    tickData: tickData,
                    autoRotation: labelsOverlap() ? $d77b025aa58d633c$var$normalizeAngle360FromDegrees(label.autoRotateAngle) : 0,
                    terminate: terminate
                });
            strategies.push(autoRotateStrategy);
        }
        return strategies;
    }
    ticksEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i += 1){
            if (a[i]?.valueOf() !== b[i]?.valueOf()) return false;
        }
        return true;
    }
    createTickData(domain, niceMode, visibleRange, primaryTickCount, tickGenerationType, index, tickData, terminate) {
        const { scale: scale2, interval: interval } = this.axis;
        const { step: step, values: values, minSpacing: minSpacing, maxSpacing: maxSpacing } = interval;
        const { maxTickCount: maxTickCount, minTickCount: minTickCount, tickCount: tickCount } = this.estimateTickCount(visibleRange, minSpacing, maxSpacing);
        const continuous = $d77b025aa58d633c$var$ContinuousScale.is(scale2) || $d77b025aa58d633c$var$DiscreteTimeScale.is(scale2);
        const maxIterations = !continuous || isNaN(maxTickCount) ? 10 : maxTickCount;
        const countTicks2 = (i)=>continuous ? Math.max(tickCount - i, minTickCount) : maxTickCount;
        const previousTicks = tickData.rawTicks;
        const regenerateTicks = step == null && values == null && countTicks2(index) > minTickCount && (continuous || tickGenerationType === 2 /* FILTER */ );
        const getTickParams = {
            domain: domain,
            niceMode: niceMode,
            visibleRange: visibleRange,
            primaryTickCount: primaryTickCount,
            tickGenerationType: tickGenerationType,
            previousTicks: previousTicks,
            minTickCount: minTickCount,
            maxTickCount: maxTickCount,
            tickCount: 0
        };
        getTickParams.tickCount = countTicks2(index);
        tickData = this.getTicks(getTickParams);
        if (regenerateTicks && this.ticksEqual(tickData.rawTicks, previousTicks)) {
            let lowerBound = index;
            let upperBound = maxIterations;
            while(lowerBound <= upperBound){
                index = (lowerBound + upperBound) / 2 | 0;
                getTickParams.tickCount = countTicks2(index);
                tickData = this.getTicks(getTickParams);
                if (this.ticksEqual(tickData.rawTicks, previousTicks)) lowerBound = index + 1;
                else upperBound = index - 1;
            }
        }
        index += 1;
        terminate || (terminate = step != null || values != null);
        return {
            tickData: tickData,
            index: index,
            autoRotation: 0,
            terminate: terminate
        };
    }
    getTimeIntervalTicks(visibleRange, tickParams, timeInterval) {
        const parentInterval = $d77b025aa58d633c$var$intervalHierarchy(timeInterval);
        if (parentInterval == null) return;
        const { scale: scale2, reverse: reverse } = this.axis;
        if (!$d77b025aa58d633c$var$TimeScale.is(scale2) && !$d77b025aa58d633c$var$DiscreteTimeScale.is(scale2)) return;
        if (reverse) visibleRange = [
            1 - visibleRange[1],
            1 - visibleRange[0]
        ];
        const dv0 = Math.min(scale2.domain[0].valueOf(), scale2.domain[scale2.domain.length - 1].valueOf());
        const dv1 = Math.max(scale2.domain[0].valueOf(), scale2.domain[scale2.domain.length - 1].valueOf());
        let [dp0, dp1] = $d77b025aa58d633c$var$TimeInterval.extent(new Date(dv0), new Date(dv1), visibleRange);
        dp0 = parentInterval.floor(dp0);
        if (dp0.valueOf() >= dv0) dp0 = parentInterval.previous(dp0);
        dp1 = parentInterval.ceil(dp1);
        if (dp1.valueOf() <= dv1) dp1 = parentInterval.next(dp1);
        const primaryTicks = parentInterval.range(dp0, dp1);
        const milliseconds = $d77b025aa58d633c$var$intervalMilliseconds(timeInterval);
        const interpolate3 = $d77b025aa58d633c$var$UnitTimeScale.is(scale2) && scale2.interval != null && $d77b025aa58d633c$var$intervalMilliseconds(scale2.interval) < milliseconds;
        let ticks;
        let primaryTicksIndices = /* @__PURE__ */ new Set();
        if ($d77b025aa58d633c$var$TimeScale.is(scale2) || $d77b025aa58d633c$var$UnitTimeScale.is(scale2)) {
            ticks = [];
            const intervalTickParams = {
                ...tickParams,
                interval: timeInterval
            };
            const timeScaleTicks = !$d77b025aa58d633c$var$UnitTimeScale.is(scale2) || interpolate3;
            for(let i = 0; i < primaryTicks.length - 1; i += 1){
                const p0 = primaryTicks[i];
                const p1 = primaryTicks[i + 1];
                const last = i === primaryTicks.length - 2;
                const dp = p1.valueOf() - p0.valueOf();
                const pVisibleRange = [
                    Math.max((dv0 - p0.valueOf()) / dp, 0),
                    Math.min((dv1 - p0.valueOf()) / dp, 1)
                ];
                const intervalTicks = timeScaleTicks ? this.timeScaleTicks(intervalTickParams, [
                    p0,
                    p1
                ], pVisibleRange, true) : scale2.ticks(intervalTickParams, [
                    p0,
                    p1
                ], pVisibleRange, true)?.ticks ?? [];
                (0, $idDdm.dropFirstWhile)(intervalTicks, (firstTick2)=>firstTick2.valueOf() < p0.valueOf());
                if (!last) (0, $idDdm.dropLastWhile)(intervalTicks, (lastTick)=>{
                    return timeScaleTicks ? lastTick.valueOf() + milliseconds > p1.valueOf() : lastTick.valueOf() >= p1.valueOf();
                });
                if (intervalTicks.length === 0) continue;
                const firstTick = intervalTicks[0];
                const firstTickDiff = $d77b025aa58d633c$var$compareDates(firstTick, p0);
                const firstPrimary = timeScaleTicks ? firstTickDiff === 0 : firstTickDiff <= milliseconds;
                if (firstPrimary) primaryTicksIndices.add(ticks.length);
                ticks.push(...intervalTicks);
            }
        } else if ($d77b025aa58d633c$var$OrdinalTimeScale.is(scale2)) {
            ticks = scale2.ticks(tickParams, void 0, visibleRange, true)?.ticks ?? [];
            let primaryTickIndex = 0;
            for(let i = 0; i < ticks.length; i++){
                const tick = ticks[i];
                let primary = false;
                while(primaryTickIndex < primaryTicks.length && $d77b025aa58d633c$var$compareDates(primaryTicks[primaryTickIndex], tick) <= 0){
                    primary = true;
                    primaryTickIndex++;
                }
                if (primary) primaryTicksIndices.add(i);
            }
        } else ticks = [];
        if (primaryTicksIndices.size === 0 || // If there's only one primary tick and it's the first tick, don't show primary ticks
        primaryTicksIndices.size === 1 && primaryTicksIndices.has(0)) primaryTicksIndices = void 0;
        return {
            ticks: ticks,
            tickCount: void 0,
            primaryTicksIndices: primaryTicksIndices,
            interpolate: interpolate3
        };
    }
    timeScaleTicks(params, domain, visibleRange, extend) {
        const { interval: interval } = params;
        if (interval == null) return domain;
        const d0 = domain[0].valueOf();
        const d1 = domain[1].valueOf();
        if (typeof interval !== "number") return $d77b025aa58d633c$var$intervalInstance(interval).every(1, {
            snapTo: domain[0]
        }).range(domain[0], domain[1], {
            visibleRange: visibleRange,
            extend: extend
        });
        const ticks = [];
        for(let intervalTickTime = d0; intervalTickTime <= d1; intervalTickTime += interval){
            const intervalTick = new Date(intervalTickTime);
            ticks.push(intervalTick);
        }
        return ticks;
    }
    getTicks({ domain: domain, niceMode: niceMode, visibleRange: visibleRange, tickGenerationType: tickGenerationType, previousTicks: previousTicks, tickCount: tickCount, minTickCount: minTickCount, maxTickCount: maxTickCount, primaryTickCount: primaryTickCount }) {
        const { axis: axis } = this;
        const { label: label, primaryLabel: primaryLabel, range: range3, scale: scale2, interval: interval } = axis;
        const idGenerator = $d77b025aa58d633c$var$createIdsGenerator();
        const domainParams = {
            nice: niceMode === 0 /* TickAndDomain */ ,
            interval: interval.step,
            tickCount: tickCount,
            minTickCount: minTickCount,
            maxTickCount: maxTickCount
        };
        const tickParams = {
            ...domainParams,
            nice: niceMode === 0 /* TickAndDomain */  || niceMode === 1 /* TicksOnly */ 
        };
        let secondaryAxisTicks;
        if (tickGenerationType === 1 /* CREATE_SECONDARY */  && primaryTickCount != null && $d77b025aa58d633c$var$ContinuousScale.is(scale2)) secondaryAxisTicks = $d77b025aa58d633c$var$calculateNiceSecondaryAxis(scale2, domain, primaryTickCount, axis.reverse, visibleRange);
        const niceDomain = niceMode === 0 /* TickAndDomain */  ? secondaryAxisTicks?.domain ?? scale2.niceDomain(domainParams, domain) : domain;
        let tickDomain = niceDomain;
        let rawTicks;
        let rawTickCount;
        let timeInterval;
        let primaryTicksIndices;
        let interpolate3 = false;
        const scaleDomain = scale2.domain;
        scale2.domain = niceDomain;
        switch(tickGenerationType){
            case 3 /* VALUES */ :
                tickDomain = interval.values;
                rawTicks = interval.values;
                rawTickCount = rawTicks.length;
                interpolate3 = $d77b025aa58d633c$var$UnitTimeScale.is(scale2);
                if ($d77b025aa58d633c$var$ContinuousScale.is(scale2)) {
                    const [d0, d1] = $d77b025aa58d633c$var$findMinMax(niceDomain.map(Number));
                    rawTicks = rawTicks.filter((value)=>Number(value) >= d0 && Number(value) <= d1).sort((a, b)=>Number(a) - Number(b));
                }
                break;
            case 1 /* CREATE_SECONDARY */ :
                if (secondaryAxisTicks) {
                    rawTicks = secondaryAxisTicks.ticks;
                    rawTickCount = secondaryAxisTicks.ticks.length;
                } else {
                    const tickGeneration = scale2.ticks(tickParams, niceDomain, visibleRange);
                    rawTicks = tickGeneration?.ticks ?? [];
                    rawTickCount = tickGeneration?.count;
                }
                break;
            case 2 /* FILTER */ :
                rawTicks = this.filterTicks(previousTicks, tickCount);
                rawTickCount = void 0;
                break;
            default:
                {
                    if (niceDomain.length > 0 && tickParams.interval == null && ($d77b025aa58d633c$var$UnitTimeScale.is(scale2) || primaryLabel != null && ($d77b025aa58d633c$var$TimeScale.is(scale2) || $d77b025aa58d633c$var$OrdinalTimeScale.is(scale2)))) {
                        const dates = niceDomain;
                        const start2 = Math.min(dates[0].valueOf(), dates[dates.length - 1].valueOf());
                        const end2 = Math.max(dates[0].valueOf(), dates[dates.length - 1].valueOf());
                        timeInterval = $d77b025aa58d633c$var$getTickTimeInterval(start2, end2, tickCount, minTickCount, maxTickCount, {
                            weekStart: primaryLabel == null ? $d77b025aa58d633c$var$sunday : void 0,
                            primaryOnly: $d77b025aa58d633c$var$UnitTimeScale.is(scale2)
                        });
                    }
                    const minTimeInterval = $d77b025aa58d633c$var$UnitTimeScale.is(scale2) ? scale2.interval : void 0;
                    if (minTimeInterval != null && timeInterval != null && $d77b025aa58d633c$var$intervalMilliseconds(minTimeInterval) > $d77b025aa58d633c$var$intervalMilliseconds(timeInterval)) timeInterval = minTimeInterval;
                    const intervalTicks = timeInterval ? this.getTimeIntervalTicks(visibleRange, tickParams, timeInterval) : void 0;
                    if (intervalTicks) ({ ticks: rawTicks, tickCount: rawTickCount, primaryTicksIndices: primaryTicksIndices, interpolate: interpolate3 } = intervalTicks);
                    else {
                        const intervalTickParams = $d77b025aa58d633c$var$UnitTimeScale.is(scale2) && timeInterval != null ? {
                            ...tickParams,
                            interval: tickParams.interval ?? timeInterval
                        } : tickParams;
                        const tickGeneration = scale2.ticks(intervalTickParams, niceDomain, visibleRange);
                        rawTicks = tickGeneration?.ticks ?? [];
                        rawTickCount = tickGeneration?.count;
                    }
                }
        }
        const fractionDigits = rawTicks.reduce((max, tick)=>Math.max(max, typeof tick === "number" ? (0, $idDdm.countFractionDigits)(tick) : 0), 0);
        const specifier = $d77b025aa58d633c$var$labelSpecifier(label.format, timeInterval) ?? (typeof label.format === "string" ? label.format : void 0);
        const formatParams = {
            domain: tickDomain,
            ticks: rawTicks,
            fractionDigits: fractionDigits,
            specifier: specifier
        };
        const labelFormatter = scale2.tickFormatter(formatParams);
        const primarySpecifier = $d77b025aa58d633c$var$labelSpecifier(primaryLabel?.format, timeInterval ? $d77b025aa58d633c$var$intervalHierarchy(timeInterval) : void 0);
        const primaryLabelFormatter = primarySpecifier ? scale2.tickFormatter({
            ...formatParams,
            specifier: primarySpecifier
        }) : labelFormatter;
        const halfBandwidth = (scale2.bandwidth ?? 0) / 2;
        const ticks = [];
        for(let i = 0; i < rawTicks.length; i++){
            const tick = rawTicks[i];
            const translationY = scale2.convert(tick, {
                interpolate: interpolate3
            }) + halfBandwidth;
            const primary = primaryTicksIndices?.has(i) ?? false;
            if (range3.length > 0 && !axis.inRange(translationY, 1e-3)) continue;
            const tickLabelFormatter = primary && primaryLabel?.enabled === true ? primaryLabelFormatter : labelFormatter;
            const tickLabel = label.enabled ? axis.formatTick(tick, i, niceDomain, fractionDigits, timeInterval, tickLabelFormatter) : "";
            ticks.push({
                tick: tick,
                tickId: idGenerator(tickLabel),
                tickLabel: tickLabel,
                translationY: Math.floor(translationY),
                primary: primary
            });
        }
        scale2.domain = scaleDomain;
        return {
            tickDomain: tickDomain,
            rawTicks: rawTicks,
            rawTickCount: rawTickCount,
            fractionDigits: fractionDigits,
            timeInterval: timeInterval,
            ticks: ticks,
            niceDomain: niceDomain
        };
    }
};
// packages/ag-charts-community/src/chart/axis/cartesianAxisLabel.ts
var $d77b025aa58d633c$var$CartesianAxisLabel = class extends $d77b025aa58d633c$var$AxisLabel {
    constructor(){
        super(...arguments);
        this.autoRotateAngle = 335;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianAxisLabel.prototype, "autoRotate", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianAxisLabel.prototype, "autoRotateAngle", 2);
// packages/ag-charts-community/src/chart/axis/cartesianAxis.ts
var $d77b025aa58d633c$var$_CartesianAxis = class _CartesianAxis extends $d77b025aa58d633c$var$Axis {
    constructor(moduleCtx, scale2){
        super(moduleCtx, scale2);
        this.headingLabelGroup = this.axisGroup.appendChild(new $d77b025aa58d633c$var$TranslatableGroup({
            name: `${this.id}-Axis-heading`
        }));
        this.lineNodeGroup = this.axisGroup.appendChild(new $d77b025aa58d633c$var$TranslatableGroup({
            name: `${this.id}-Axis-line`
        }));
        this.lineNode = this.lineNodeGroup.appendChild(new $d77b025aa58d633c$var$Line({
            // name: `${this.id}-Axis-line`,
            zIndex: 1 /* AxisLine */ 
        }));
        this.tickLineGroupSelection = $d77b025aa58d633c$var$Selection.select(this.tickLineGroup, $d77b025aa58d633c$var$Line, false);
        this.gridLineGroupSelection = $d77b025aa58d633c$var$Selection.select(this.gridLineGroup, $d77b025aa58d633c$var$Line, false);
        this.tempText = new $d77b025aa58d633c$var$TransformableText({
            debugDirty: false
        });
        this.tempCaption = new $d77b025aa58d633c$var$Caption();
        this.tickGenerator = new $d77b025aa58d633c$var$AxisTickGenerator(this);
        this.generatedTicks = void 0;
        this.animationManager = moduleCtx.animationManager;
        this.animationState = new $d77b025aa58d633c$var$StateMachine("empty", {
            empty: {
                update: {
                    target: "ready",
                    action: ()=>this.resetSelectionNodes()
                },
                reset: "empty"
            },
            ready: {
                update: (data)=>this.animateReadyUpdate(data),
                resize: ()=>this.resetSelectionNodes(),
                reset: "empty"
            }
        });
        this.headingLabelGroup.appendChild(this.title.caption.node);
        let previousSize = void 0;
        this.destroyFns.push(moduleCtx.layoutManager.addListener("layout:complete", (e)=>{
            const size = [
                e.chart.width,
                e.chart.height
            ];
            if (previousSize != null && !(0, $idDdm.arraysEqual)(size, previousSize)) this.animationState.transition("resize");
            previousSize = size;
        }), this.title.caption.registerInteraction(this.moduleCtx, "afterend"));
    }
    static is(value) {
        return value instanceof _CartesianAxis;
    }
    get primaryLabel() {
        return void 0;
    }
    get primaryTick() {
        return void 0;
    }
    get horizontal() {
        return this.position === "top" || this.position === "bottom";
    }
    onGridVisibilityChange() {
        this.gridLineGroupSelection.clear();
    }
    resetAnimation(phase) {
        if (phase === "initial") this.animationState.transition("reset");
    }
    get direction() {
        return this.position === "top" || this.position === "bottom" ? "x" /* X */  : "y" /* Y */ ;
    }
    createAxisContext() {
        return {
            ...super.createAxisContext(),
            position: this.position
        };
    }
    createLabel() {
        return new $d77b025aa58d633c$var$CartesianAxisLabel();
    }
    updateDirection() {
        switch(this.position){
            case "top":
                this.label.mirrored = true;
                this.label.parallel = true;
                break;
            case "right":
                this.label.mirrored = true;
                this.label.parallel = false;
                break;
            case "bottom":
                this.label.mirrored = false;
                this.label.parallel = true;
                break;
            case "left":
                this.label.mirrored = false;
                this.label.parallel = false;
                break;
        }
        if (this.axisContext) {
            this.axisContext.position = this.position;
            this.axisContext.direction = this.direction;
        }
    }
    calculateLayout(primaryTickCount, chartPadding) {
        this.updateDirection();
        return super.calculateLayout(primaryTickCount, chartPadding);
    }
    layoutCrossLines() {
        const anySeriesActive = this.isAnySeriesActive();
        this.crossLines.forEach((crossLine)=>{
            crossLine.calculateLayout?.(anySeriesActive, this.reverse);
        });
    }
    calculateTickLayout(domain, niceMode, visibleRange, initialPrimaryTickCount) {
        const sideFlag = this.label.getSideFlag();
        const rotation = this.horizontal ? -0.5 * Math.PI : 0;
        const parallelFlipRotation = $d77b025aa58d633c$var$normalizeAngle360(rotation);
        const regularFlipRotation = $d77b025aa58d633c$var$normalizeAngle360(rotation - Math.PI / 2);
        const labelX = sideFlag * (this.getTickSize() + this.label.spacing + this.seriesAreaPadding);
        if (niceMode === 2 /* Off */  && this.label.enabled === false && this.tick.enabled === false && this.gridLine.enabled === false) {
            const { bbox: bbox2, spacing: spacing2 } = this.tickBBox(domain, [], []);
            this.generatedTicks = {
                ticks: [],
                tickLines: [],
                gridLines: [],
                labels: [],
                spacing: spacing2
            };
            return {
                ticks: [],
                rawTickCount: 0,
                tickDomain: domain,
                niceDomain: domain,
                fractionDigits: 0,
                timeInterval: void 0,
                bbox: bbox2
            };
        }
        const removeOverflowLabels = this.horizontal && $d77b025aa58d633c$var$ContinuousScale.is(this.scale);
        const tickGenerationResult = this.tickGenerator.generateTicks({
            domain: domain,
            niceMode: niceMode,
            visibleRange: visibleRange,
            primaryTickCount: initialPrimaryTickCount,
            parallelFlipRotation: parallelFlipRotation,
            regularFlipRotation: regularFlipRotation,
            labelX: labelX,
            sideFlag: sideFlag,
            removeOverflowLabels: removeOverflowLabels,
            removeOverflowThreshold: this.chartPadding?.right
        });
        const { tickData: tickData } = tickGenerationResult;
        const { ticks: ticks, tickDomain: tickDomain, rawTicks: rawTicks, rawTickCount: rawTickCount, fractionDigits: fractionDigits, timeInterval: timeInterval, niceDomain: niceDomain = domain } = tickData;
        const labels = ticks.map((d)=>this.getTickLabelProps(d, tickGenerationResult));
        const { position: position, horizontal: horizontal, gridPadding: gridPadding, gridLength: gridLength } = this;
        const direction = position === "bottom" || position === "right" ? -1 : 1;
        const p1 = gridPadding;
        const p2 = direction * gridLength - gridPadding;
        const { gridLine: gridLine } = this;
        const gridLines = ticks.map(({ tickId: tickId, translationY: offset4 }, index)=>{
            const [x1, y1, x2, y2] = horizontal ? [
                offset4,
                p1,
                offset4,
                p2
            ] : [
                p1,
                offset4,
                p2,
                offset4
            ];
            const { style: style, width: strokeWidth } = gridLine;
            const { stroke: stroke2, lineDash: lineDash } = style[index % style.length] ?? {};
            return {
                tickId: tickId,
                offset: offset4,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                lineDash: lineDash
            };
        });
        const { tick: tick, primaryTick: primaryTick } = this;
        const tickLines = ticks.map(({ primary: primary, tickId: tickId, translationY: offset4 })=>{
            const datumTick = primary && primaryTick?.enabled ? primaryTick : tick;
            const h = -direction * this.getTickSize(datumTick);
            const [x1, y1, x2, y2] = horizontal ? [
                offset4,
                0,
                offset4,
                h
            ] : [
                0,
                offset4,
                h,
                offset4
            ];
            const { stroke: stroke2, width: strokeWidth } = datumTick;
            const lineDash = void 0;
            return {
                tickId: tickId,
                offset: offset4,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                lineDash: lineDash
            };
        });
        const { bbox: bbox, spacing: spacing } = this.tickBBox(tickDomain, ticks, labels);
        this.generatedTicks = {
            ticks: ticks,
            gridLines: gridLines,
            tickLines: tickLines,
            labels: labels,
            spacing: spacing
        };
        return {
            ticks: rawTicks,
            rawTickCount: rawTickCount,
            tickDomain: tickDomain,
            niceDomain: niceDomain,
            fractionDigits: fractionDigits,
            timeInterval: timeInterval,
            bbox: bbox
        };
    }
    update() {
        this.updateDirection();
        const previousTicksIds = Array.from(this.tickLabelGroupSelection.nodes(), (node)=>node.datum.tickId);
        super.update();
        this.tickLineGroup.visible = this.tick.enabled || (this.primaryTick?.enabled ?? false);
        this.tickLabelGroup.visible = this.label.enabled || (this.primaryTick?.enabled ?? false);
        const { generatedTicks: generatedTicks } = this;
        this.updateTitle(this.scale.domain, generatedTicks?.spacing ?? 0);
        if (!this.animatable) this.moduleCtx.animationManager.skipCurrentBatch();
        if (this.generatedTicks) {
            const { ticks: ticks } = this.generatedTicks;
            if (this.animationManager.isSkipped()) this.resetSelectionNodes();
            else {
                const tickIds = ticks.map((datum)=>datum.tickId);
                const diff2 = (0, $idDdm.diffArrays)(previousTicksIds, tickIds);
                this.animationState.transition("update", diff2);
            }
        }
        const { enabled: enabled, stroke: stroke2, width: width2 } = this.line;
        this.lineNode.setProperties({
            stroke: stroke2,
            strokeWidth: enabled ? width2 : 0
        });
        this.updateTickLines();
        this.updateGridLines();
    }
    getAxisTransform() {
        return {
            translationX: Math.floor(this.translation.x),
            translationY: Math.floor(this.translation.y)
        };
    }
    updatePosition() {
        super.updatePosition();
        const axisTransform = this.getAxisTransform();
        this.tickLineGroup.datum = axisTransform;
        this.tickLabelGroup.datum = axisTransform;
        this.lineNodeGroup.datum = axisTransform;
        this.headingLabelGroup.datum = axisTransform;
    }
    getAxisLineCoordinates() {
        const { horizontal: horizontal } = this;
        const [c1, c2] = $d77b025aa58d633c$var$findMinMax(this.range);
        return horizontal ? {
            x1: c1,
            x2: c2,
            y1: 0,
            y2: 0
        } : {
            x1: 0,
            x2: 0,
            y1: c1,
            y2: c2
        };
    }
    getTickLineBBox(datum) {
        const { position: position, primaryTick: primaryTick } = this;
        const tickSize = Math.max(this.getTickSize(), primaryTick?.enabled ? this.getTickSize(primaryTick) : 0);
        const { translationY: translationY } = datum;
        switch(position){
            case "top":
                return new $d77b025aa58d633c$var$BBox(translationY, -tickSize, translationY, tickSize);
            case "bottom":
                return new $d77b025aa58d633c$var$BBox(translationY, 0, translationY, tickSize);
            case "left":
                return new $d77b025aa58d633c$var$BBox(-tickSize, translationY, tickSize, translationY);
            case "right":
                return new $d77b025aa58d633c$var$BBox(0, translationY, tickSize, translationY);
        }
    }
    lineNodeBBox() {
        const { position: position, seriesAreaPadding: seriesAreaPadding } = this;
        const { y1: y1, y2: y2 } = this.getAxisLineCoordinates();
        const dy = y2 - y1;
        switch(position){
            case "top":
                return new $d77b025aa58d633c$var$BBox(y1, -seriesAreaPadding, dy, seriesAreaPadding);
            case "bottom":
                return new $d77b025aa58d633c$var$BBox(y1, 0, dy, seriesAreaPadding);
            case "left":
                return new $d77b025aa58d633c$var$BBox(-seriesAreaPadding, y1, seriesAreaPadding, dy);
            case "right":
                return new $d77b025aa58d633c$var$BBox(0, y1, seriesAreaPadding, dy);
        }
    }
    titleBBox(domain, spacing) {
        const { tempCaption: tempCaption } = this;
        tempCaption.node.setProperties(this.titleProps(tempCaption, domain, spacing));
        return tempCaption.node.getBBox();
    }
    tickBBox(domain, ticks, labels) {
        const { tick: tick, primaryTick: primaryTick, label: label, primaryLabel: primaryLabel, title: title, position: position, horizontal: horizontal, seriesAreaPadding: seriesAreaPadding } = this;
        const boxes = [];
        boxes.push(this.lineNodeBBox());
        if (tick.enabled || primaryTick?.enabled) for (const datum of ticks)boxes.push(this.getTickLineBBox(datum));
        const { tempText: tempText } = this;
        if (label.enabled) for (const datum of labels){
            if (!datum.visible) continue;
            tempText.setProperties(datum);
            const box = tempText.getBBox();
            if (box) boxes.push(box);
        }
        if (primaryLabel?.enabled && primaryLabel.format != null && position === "bottom") {
            const { fontSize: fontSize, format: format } = primaryLabel;
            const formats = (0, $idDdm.isPlainObject)(format) ? Object.values(format) : [
                format
            ];
            const maxLines = formats.reduce((m, f)=>Math.max(m, (0, $idDdm.countLines)(f)), 0);
            const labelOffset = this.getTickSize(primaryTick ?? tick) + primaryLabel.spacing + seriesAreaPadding;
            const inexactMeasurementPadding = 2;
            const height2 = maxLines * $d77b025aa58d633c$var$TextUtils.getLineHeight(fontSize) + inexactMeasurementPadding;
            boxes.push(new $d77b025aa58d633c$var$BBox(0, labelOffset, 1, height2));
        }
        let spacing = 0;
        if (title.enabled) {
            const combined = $d77b025aa58d633c$var$BBox.merge(boxes);
            spacing = horizontal ? combined.height : combined.width;
            boxes.push(this.titleBBox(domain, spacing));
        }
        const bbox = $d77b025aa58d633c$var$BBox.merge(boxes);
        return {
            bbox: bbox,
            spacing: spacing
        };
    }
    titleProps(caption, domain, spacing) {
        const { title: title } = this;
        if (!title.enabled) {
            caption.enabled = false;
            return {
                visible: false,
                text: "",
                textBaseline: "bottom",
                x: 0,
                y: 0,
                rotationCenterX: 0,
                rotationCenterY: 0,
                rotation: 0
            };
        }
        caption.enabled = true;
        caption.color = title.color;
        caption.fontFamily = title.fontFamily;
        caption.fontSize = title.fontSize;
        caption.fontStyle = title.fontStyle;
        caption.fontWeight = title.fontWeight;
        caption.wrapping = title.wrapping;
        const padding = (title.spacing ?? 0) + spacing;
        const { range: range3 } = this;
        const midOffset = (range3[0] + range3[1]) / 2;
        let x;
        let y;
        let rotation;
        let textBaseline;
        switch(this.position){
            case "top":
                x = midOffset;
                y = -padding;
                rotation = 0;
                textBaseline = "bottom";
                break;
            case "bottom":
                x = midOffset;
                y = padding;
                rotation = 0;
                textBaseline = "top";
                break;
            case "left":
                x = -padding;
                y = midOffset;
                rotation = -0.5 * Math.PI;
                textBaseline = "bottom";
                break;
            case "right":
                x = padding;
                y = midOffset;
                rotation = 0.5 * Math.PI;
                textBaseline = "bottom";
                break;
        }
        const { formatter: formatter = (p)=>p.defaultValue } = title;
        const text = this.callWithContext(formatter, this.getTitleFormatterParams(domain));
        caption.text = text;
        return {
            visible: true,
            text: text,
            textBaseline: textBaseline,
            x: x,
            y: y,
            rotationCenterX: x,
            rotationCenterY: y,
            rotation: rotation
        };
    }
    getTickLabelProps(datum, tickGenerationResult) {
        const { horizontal: horizontal, primaryLabel: primaryLabel, primaryTick: primaryTick, seriesAreaPadding: seriesAreaPadding, scale: scale2 } = this;
        const { tickId: tickId, tickLabel: text = "", translationY: translationY, primary: primary } = datum;
        const label = primary && primaryLabel?.enabled ? primaryLabel : this.label;
        const tick = primary && primaryTick?.enabled ? primaryTick : this.tick;
        const { rotation: rotation, textBaseline: textBaseline, textAlign: textAlign } = tickGenerationResult;
        const { range: range3 } = scale2;
        const sideFlag = this.label.getSideFlag();
        const labelOffset = sideFlag * (this.getTickSize(tick) + label.spacing + seriesAreaPadding);
        const visible = text !== "";
        const x = horizontal ? translationY : labelOffset;
        const y = horizontal ? -labelOffset : translationY;
        return {
            ...this.getLabelStyles({
                value: text
            }, void 0, label),
            tickId: tickId,
            rotation: rotation,
            text: text,
            textAlign: textAlign,
            textBaseline: textBaseline,
            visible: visible,
            x: x,
            y: y,
            rotationCenterX: x,
            rotationCenterY: y,
            range: range3
        };
    }
    updateSelections() {
        if (!this.generatedTicks) return;
        const lineData = this.getAxisLineCoordinates();
        const { tickLines: tickLines, gridLines: gridLines, labels: labels } = this.generatedTicks;
        const getDatumId = (datum)=>datum.tickId;
        this.lineNode.datum = lineData;
        this.gridLineGroupSelection.update(this.gridLine.enabled ? gridLines : [], void 0, getDatumId);
        this.tickLineGroupSelection.update(tickLines, void 0, getDatumId);
        this.tickLabelGroupSelection.update(labels, void 0, getDatumId);
    }
    updateGridLines() {
        this.gridLineGroupSelection.each((line, datum)=>{
            line.stroke = datum.stroke;
            line.strokeWidth = datum.strokeWidth;
            line.lineDash = datum.lineDash;
        });
    }
    updateTickLines() {
        this.tickLineGroupSelection.each((line, datum)=>{
            line.stroke = datum.stroke;
            line.strokeWidth = datum.strokeWidth;
            line.lineDash = datum.lineDash;
        });
    }
    updateTitle(domain, spacing) {
        const { caption: caption } = this.title;
        const titleProps = this.titleProps(caption, domain, spacing);
        caption.node.visible = titleProps.visible;
        caption.node.text = titleProps.text;
        caption.node.textBaseline = titleProps.textBaseline;
        caption.node.datum = titleProps;
    }
    updateLabels() {
        if (!this.label.enabled) return;
        this.tickLabelGroupSelection.each((node, datum)=>{
            node.fill = datum.fill;
            node.fontFamily = datum.fontFamily;
            node.fontSize = datum.fontSize;
            node.fontStyle = datum.fontStyle;
            node.fontWeight = datum.fontWeight;
            node.text = datum.text;
            node.textBaseline = datum.textBaseline;
            node.textAlign = datum.textAlign ?? "center";
        });
    }
    animateReadyUpdate(diff2) {
        const { animationManager: animationManager } = this.moduleCtx;
        const selectionCtx = $d77b025aa58d633c$var$prepareAxisAnimationContext(this);
        const fns = $d77b025aa58d633c$var$prepareAxisAnimationFunctions(selectionCtx);
        $d77b025aa58d633c$var$fromToMotion(this.id, "axis-group", animationManager, [
            this.lineNodeGroup,
            this.tickLabelGroup,
            this.tickLineGroup,
            this.headingLabelGroup
        ], fns.group);
        $d77b025aa58d633c$var$fromToMotion(this.id, "line", animationManager, [
            this.lineNode
        ], fns.line);
        $d77b025aa58d633c$var$fromToMotion(this.id, "line-paths", animationManager, [
            this.gridLineGroupSelection,
            this.tickLineGroupSelection
        ], fns.tick, (_, d)=>d.tickId, diff2);
        $d77b025aa58d633c$var$fromToMotion(this.id, "tick-labels", animationManager, [
            this.tickLabelGroupSelection
        ], fns.label, (_, d)=>d.tickId, diff2);
        $d77b025aa58d633c$var$fromToMotion(this.id, "title", animationManager, [
            this.title.caption.node
        ], fns.label, (_, d)=>d.tickId, diff2);
    }
    resetSelectionNodes() {
        $d77b025aa58d633c$var$resetMotion([
            this.lineNodeGroup,
            this.tickLabelGroup,
            this.tickLineGroup,
            this.headingLabelGroup
        ], $d77b025aa58d633c$var$resetAxisGroupFn());
        $d77b025aa58d633c$var$resetMotion([
            this.gridLineGroupSelection,
            this.tickLineGroupSelection
        ], $d77b025aa58d633c$var$resetAxisLineSelectionFn());
        $d77b025aa58d633c$var$resetMotion([
            this.tickLabelGroupSelection
        ], $d77b025aa58d633c$var$resetAxisLabelSelectionFn());
        $d77b025aa58d633c$var$resetMotion([
            this.title.caption.node
        ], $d77b025aa58d633c$var$resetAxisLabelSelectionFn());
        $d77b025aa58d633c$var$resetMotion([
            this.lineNode
        ], $d77b025aa58d633c$var$resetAxisLineSelectionFn());
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_CartesianAxis.prototype, "thickness", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_CartesianAxis.prototype, "position", 2);
var $d77b025aa58d633c$var$CartesianAxis = $d77b025aa58d633c$var$_CartesianAxis;
// packages/ag-charts-community/src/chart/mapping/prepareAxis.ts
var $d77b025aa58d633c$var$CartesianAxisPositions = [
    "top",
    "right",
    "bottom",
    "left"
];
function $d77b025aa58d633c$var$isAxisPosition(position) {
    return typeof position === "string" && $d77b025aa58d633c$var$CartesianAxisPositions.includes(position);
}
function $d77b025aa58d633c$var$guessInvalidPositions(axes) {
    const invalidAxes = [];
    const usedPositions = [];
    const guesses = [
        ...$d77b025aa58d633c$var$CartesianAxisPositions
    ];
    for (const axis of axes)if (axis instanceof $d77b025aa58d633c$var$CartesianAxis) {
        if ($d77b025aa58d633c$var$isAxisPosition(axis.position)) usedPositions.push(axis.position);
        else invalidAxes.push(axis);
    }
    for (const axis of invalidAxes){
        let nextGuess;
        do nextGuess = guesses.pop();
        while (nextGuess && usedPositions.includes(nextGuess));
        if (nextGuess == null) break;
        axis.position = nextGuess;
    }
}
// packages/ag-charts-community/src/chart/mapping/prepareSeries.ts
var $d77b025aa58d633c$var$MATCHING_KEYS = [
    "direction",
    "xKey",
    "yKey",
    "sizeKey",
    "angleKey",
    "radiusKey",
    "normalizedTo"
];
function $d77b025aa58d633c$var$matchSeriesOptions(series, optSeries, oldOptsSeries) {
    const generateKey = (type, i, opts)=>{
        const result = [
            type
        ];
        for (const key of $d77b025aa58d633c$var$MATCHING_KEYS)if (key in i && i[key] != null) result.push(`${key}=${i[key]}`);
        if (opts?.seriesGrouping) result.push(`seriesGrouping.groupId=${opts?.seriesGrouping.groupId}`);
        return result.join(";");
    };
    const seriesMap = /* @__PURE__ */ new Map();
    let idx = 0;
    for (const s of series){
        const key = generateKey(s.type, s.properties, oldOptsSeries?.[idx]);
        if (!seriesMap.has(key)) seriesMap.set(key, []);
        seriesMap.get(key)?.push([
            s,
            idx++
        ]);
    }
    const optsMap = /* @__PURE__ */ new Map();
    idx = 0;
    for (const o of optSeries){
        const key = generateKey(o.type, o, o);
        if (!optsMap.has(key)) optsMap.set(key, []);
        optsMap.get(key)?.push([
            o,
            idx++
        ]);
    }
    const overlap = [
        ...seriesMap.keys()
    ].some((k)=>optsMap.has(k));
    if (!overlap) return {
        status: "no-overlap",
        oldKeys: seriesMap.keys(),
        newKeys: optsMap.keys()
    };
    const changes = [];
    for (const [key, optsTuples] of optsMap.entries())for (const [opts, targetIdx] of optsTuples){
        const seriesArray = seriesMap.get(key);
        if (seriesArray == null || seriesArray.length < 1) {
            changes.push({
                opts: opts,
                targetIdx: targetIdx,
                idx: targetIdx,
                status: "add"
            });
            seriesMap.delete(key);
            continue;
        }
        const [outputSeries, currentIdx] = seriesArray.shift();
        const previousOpts = oldOptsSeries?.[currentIdx] ?? {};
        const diff2 = $d77b025aa58d633c$var$jsonDiff(previousOpts, opts ?? {});
        const { groupIndex: groupIndex, stackIndex: stackIndex } = diff2?.seriesGrouping ?? {};
        if (groupIndex != null || stackIndex != null) changes.push({
            opts: opts,
            series: outputSeries,
            diff: diff2,
            targetIdx: targetIdx,
            idx: currentIdx,
            status: "series-grouping"
        });
        else if (diff2) changes.push({
            opts: opts,
            series: outputSeries,
            diff: diff2,
            targetIdx: targetIdx,
            idx: currentIdx,
            status: "update"
        });
        else changes.push({
            opts: opts,
            series: outputSeries,
            targetIdx: targetIdx,
            idx: currentIdx,
            status: "no-op"
        });
        if (seriesArray.length === 0) seriesMap.delete(key);
    }
    for (const seriesArray of seriesMap.values())for (const [outputSeries, currentIdx] of seriesArray)changes.push({
        series: outputSeries,
        idx: currentIdx,
        targetIdx: -1,
        status: "remove"
    });
    return {
        status: "overlap",
        changes: changes
    };
}
// packages/ag-charts-community/src/chart/mapping/types.ts
function $d77b025aa58d633c$var$optionsType(input) {
    const { series: series } = input;
    return series?.[0]?.type ?? "line";
}
function $d77b025aa58d633c$var$isAgCartesianChartOptions(input) {
    const specifiedType = $d77b025aa58d633c$var$optionsType(input);
    return $d77b025aa58d633c$var$chartTypes2.isCartesian(specifiedType) || $d77b025aa58d633c$var$isEnterpriseCartesian(specifiedType);
}
function $d77b025aa58d633c$var$isAgPolarChartOptions(input) {
    const specifiedType = $d77b025aa58d633c$var$optionsType(input);
    return $d77b025aa58d633c$var$chartTypes2.isPolar(specifiedType) || $d77b025aa58d633c$var$isEnterprisePolar(specifiedType);
}
function $d77b025aa58d633c$var$isAgHierarchyChartOptions(input) {
    const specifiedType = $d77b025aa58d633c$var$optionsType(input);
    return $d77b025aa58d633c$var$chartTypes2.isHierarchy(specifiedType) || $d77b025aa58d633c$var$isEnterpriseHierarchy(specifiedType);
}
function $d77b025aa58d633c$var$isAgTopologyChartOptions(input) {
    const specifiedType = $d77b025aa58d633c$var$optionsType(input);
    return $d77b025aa58d633c$var$chartTypes2.isTopology(specifiedType) || $d77b025aa58d633c$var$isEnterpriseTopology(specifiedType);
}
function $d77b025aa58d633c$var$isAgFlowProportionChartOptions(input) {
    const specifiedType = $d77b025aa58d633c$var$optionsType(input);
    return $d77b025aa58d633c$var$chartTypes2.isFlowProportion(specifiedType) || $d77b025aa58d633c$var$isEnterpriseFlowProportion(specifiedType);
}
function $d77b025aa58d633c$var$isAgStandaloneChartOptions(input) {
    const specifiedType = $d77b025aa58d633c$var$optionsType(input);
    return $d77b025aa58d633c$var$chartTypes2.isStandalone(specifiedType) || $d77b025aa58d633c$var$isEnterpriseStandalone(specifiedType);
}
function $d77b025aa58d633c$var$isAgGaugeChartOptions(input) {
    const specifiedType = $d77b025aa58d633c$var$optionsType(input);
    return $d77b025aa58d633c$var$chartTypes2.isGauge(specifiedType) || $d77b025aa58d633c$var$isEnterpriseGauge(specifiedType);
}
function $d77b025aa58d633c$var$isAgPolarChartOptionsWithSeriesBasedLegend(input) {
    const specifiedType = $d77b025aa58d633c$var$optionsType(input);
    return $d77b025aa58d633c$var$isAgPolarChartOptions(input) && specifiedType !== "pie" && specifiedType !== "donut";
}
// packages/ag-charts-community/src/chart/modulesManager.ts
var $d77b025aa58d633c$var$ModulesManager = class extends $d77b025aa58d633c$var$ModuleMap {
    applyOptions(options) {
        for (const m of this.moduleMap.values())if (m.module.optionsKey in options && $d77b025aa58d633c$var$isProperties(m.moduleInstance)) m.moduleInstance.set(options[m.module.optionsKey]);
    }
    *legends() {
        for (const { module: module, moduleInstance: moduleInstance } of this.moduleMap.values()){
            if (module.type !== "legend") continue;
            yield {
                legendType: module.identifier,
                legend: moduleInstance
            };
        }
    }
};
var $d77b025aa58d633c$var$DEFAULT_OVERLAY_CLASS = "ag-charts-overlay";
var $d77b025aa58d633c$var$DEFAULT_OVERLAY_DARK_CLASS = "ag-charts-dark-overlay";
var $d77b025aa58d633c$var$Overlay = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(className, defaultMessageId){
        super();
        this.className = className;
        this.defaultMessageId = defaultMessageId;
        this.enabled = true;
    }
    getText(localeManager) {
        return localeManager.t(this.text ?? this.defaultMessageId);
    }
    getElement(animationManager, localeManager, rect) {
        this.content?.remove();
        this.focusBox = rect;
        if (this.renderer) {
            const htmlContent = this.renderer();
            if (htmlContent instanceof HTMLElement) this.content = htmlContent;
            else {
                const tempDiv = (0, $idDdm.createElement)("div");
                tempDiv.innerHTML = htmlContent;
                const { firstElementChild: firstElementChild } = tempDiv;
                if (firstElementChild instanceof HTMLElement && tempDiv.childElementCount === 1) this.content = firstElementChild;
                else this.content = tempDiv;
            }
        } else {
            const content = (0, $idDdm.createElement)("div", {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxSizing: "border-box",
                height: "100%",
                margin: "8px",
                fontFamily: "var(--ag-charts-font-family)",
                fontSize: "var(--ag-charts-font-size)",
                fontWeight: "var(--ag-charts-font-weight)"
            });
            content.innerText = this.getText(localeManager);
            this.content = content;
            animationManager?.animate({
                from: 0,
                to: 1,
                id: "overlay",
                phase: "add",
                groupId: "opacity",
                onUpdate (value) {
                    content.style.opacity = String(value);
                },
                onStop () {
                    content.style.opacity = "1";
                }
            });
        }
        return this.content;
    }
    removeElement(cleanup = ()=>this.content?.remove(), animationManager) {
        if (!this.content) return;
        if (animationManager) {
            const { content: content } = this;
            animationManager.animate({
                from: 1,
                to: 0,
                phase: "remove",
                id: "overlay",
                groupId: "opacity",
                onUpdate (value) {
                    content.style.opacity = String(value);
                },
                onStop () {
                    cleanup?.();
                }
            });
        } else cleanup?.();
        this.content = void 0;
        this.focusBox = void 0;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Overlay.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Overlay.prototype, "text", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Overlay.prototype, "renderer", 2);
// packages/ag-charts-community/src/chart/overlay/chartOverlays.ts
var $d77b025aa58d633c$var$ChartOverlays = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.darkTheme = false;
        this.loading = new $d77b025aa58d633c$var$Overlay("ag-charts-loading-overlay", "overlayLoadingData");
        this.noData = new $d77b025aa58d633c$var$Overlay("ag-charts-no-data-overlay", "overlayNoData");
        this.noVisibleSeries = new $d77b025aa58d633c$var$Overlay("ag-charts-no-visible-series", "overlayNoVisibleSeries");
        this.unsupportedBrowser = new $d77b025aa58d633c$var$Overlay("ag-charts-unsupported-browser", "overlayUnsupportedBrowser");
    }
    getFocusInfo(localeManager) {
        for (const overlay of [
            this.loading,
            this.noData,
            this.noVisibleSeries,
            this.unsupportedBrowser
        ]){
            if (overlay.focusBox !== void 0) return {
                text: overlay.getText(localeManager),
                rect: overlay.focusBox
            };
        }
        return void 0;
    }
    destroy() {
        this.loading.removeElement();
        this.noData.removeElement();
        this.noVisibleSeries.removeElement();
        this.unsupportedBrowser.removeElement();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ChartOverlays.prototype, "darkTheme", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ChartOverlays.prototype, "loading", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ChartOverlays.prototype, "noData", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ChartOverlays.prototype, "noVisibleSeries", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ChartOverlays.prototype, "unsupportedBrowser", 2);
function $d77b025aa58d633c$var$getLoadingSpinner(text, defaultDuration) {
    const { animationDuration: animationDuration } = $d77b025aa58d633c$var$PHASE_METADATA["add"];
    const duration = animationDuration * defaultDuration;
    const container = (0, $idDdm.createElement)("div", `${$d77b025aa58d633c$var$DEFAULT_OVERLAY_CLASS}--loading`, {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        height: "100%",
        boxSizing: "border-box",
        font: "13px Verdana, sans-serif",
        // FONT_SIZE.MEDIUM
        userSelect: "none",
        animation: `ag-charts-loading ${duration}ms linear 50ms both`
    });
    const matrix = (0, $idDdm.createElement)("span", {
        width: "45px",
        height: "40px",
        backgroundImage: [
            "linear-gradient(#0000 calc(1 * 100% / 6), #ccc 0 calc(3 * 100% / 6), #0000 0), ",
            "linear-gradient(#0000 calc(2 * 100% / 6), #ccc 0 calc(4 * 100% / 6), #0000 0), ",
            "linear-gradient(#0000 calc(3 * 100% / 6), #ccc 0 calc(5 * 100% / 6), #0000 0)"
        ].join(""),
        backgroundSize: "10px 400%",
        backgroundRepeat: "no-repeat",
        animation: "ag-charts-loading-matrix 1s infinite linear"
    });
    const label = (0, $idDdm.createElement)("p", {
        marginTop: "1em"
    });
    label.innerText = text;
    const background = (0, $idDdm.createElement)("div", `${$d77b025aa58d633c$var$DEFAULT_OVERLAY_CLASS}__loading-background`, {
        position: "absolute",
        inset: "0",
        opacity: "0.5",
        zIndex: "-1"
    });
    const animationStyles = (0, $idDdm.createElement)("style");
    animationStyles.innerText = [
        "@keyframes ag-charts-loading { from { opacity: 0 } to { opacity: 1 } }",
        "@keyframes ag-charts-loading-matrix {",
        "0% { background-position: 0% 0%, 50% 0%, 100% 0%; }",
        "100% { background-position: 0% 100%, 50% 100%, 100% 100%; }",
        "}"
    ].join(" ");
    container.replaceChildren(animationStyles, matrix, label, background);
    return container;
}
// packages/ag-charts-community/src/chart/series/seriesZIndexMap.ts
var $d77b025aa58d633c$var$SeriesZIndexMap = /* @__PURE__ */ ((SeriesZIndexMap2)=>{
    SeriesZIndexMap2[SeriesZIndexMap2["BACKGROUND"] = 0] = "BACKGROUND";
    SeriesZIndexMap2[SeriesZIndexMap2["ANY_CONTENT"] = 1] = "ANY_CONTENT";
    return SeriesZIndexMap2;
})($d77b025aa58d633c$var$SeriesZIndexMap || {});
var $d77b025aa58d633c$var$SeriesContentZIndexMap = /* @__PURE__ */ ((SeriesContentZIndexMap2)=>{
    SeriesContentZIndexMap2[SeriesContentZIndexMap2["FOREGROUND"] = 0] = "FOREGROUND";
    SeriesContentZIndexMap2[SeriesContentZIndexMap2["HIGHLIGHT"] = 1] = "HIGHLIGHT";
    SeriesContentZIndexMap2[SeriesContentZIndexMap2["LABEL"] = 2] = "LABEL";
    return SeriesContentZIndexMap2;
})($d77b025aa58d633c$var$SeriesContentZIndexMap || {});
// packages/ag-charts-community/src/chart/series/shapeUtil.ts
function $d77b025aa58d633c$var$getShapeFill(fill, defaultGradient, defaultPattern, defaultImage) {
    if ($d77b025aa58d633c$var$isGradientFill(fill)) return {
        type: "gradient",
        gradient: fill.gradient ?? defaultGradient.gradient,
        colorStops: fill.colorStops ?? defaultGradient.colorStops,
        bounds: fill.bounds ?? defaultGradient.bounds,
        rotation: fill.rotation ?? defaultGradient.rotation,
        reverse: fill.reverse ?? defaultGradient.reverse
    };
    if ($d77b025aa58d633c$var$isPatternFill(fill)) {
        const pattern = fill.pattern ?? defaultPattern.pattern;
        let strokeWidth = fill.strokeWidth;
        if (pattern === "backward-slanted-lines" || pattern === "forward-slanted-lines" || pattern === "horizontal-lines" || pattern === "vertical-lines") strokeWidth ?? (strokeWidth = defaultPattern.strokeWidth);
        else strokeWidth ?? (strokeWidth = 0);
        const width2 = fill.width ?? fill.height ?? defaultPattern.width;
        const height2 = fill.height ?? fill.width ?? defaultPattern.height;
        return {
            type: "pattern",
            pattern: pattern,
            width: width2,
            height: height2,
            path: fill.path,
            padding: fill.padding ?? defaultPattern.padding,
            fill: fill.fill ?? defaultPattern.fill,
            fillOpacity: fill.fillOpacity ?? defaultPattern.fillOpacity,
            backgroundFill: fill.backgroundFill ?? defaultPattern.backgroundFill,
            backgroundFillOpacity: fill.backgroundFillOpacity ?? defaultPattern.backgroundFillOpacity,
            stroke: fill.stroke ?? defaultPattern.stroke,
            strokeOpacity: fill.strokeOpacity ?? defaultPattern.strokeOpacity,
            strokeWidth: strokeWidth,
            rotation: fill.rotation ?? defaultPattern.rotation,
            scale: fill.scale ?? defaultPattern.scale
        };
    }
    if ($d77b025aa58d633c$var$isImageFill(fill)) return {
        type: "image",
        url: fill.url,
        width: fill.width,
        height: fill.height,
        backgroundFill: fill.backgroundFill ?? defaultImage.backgroundFill,
        backgroundFillOpacity: fill.backgroundFillOpacity ?? defaultImage.backgroundFillOpacity,
        rotation: fill.rotation ?? defaultImage.rotation,
        repeat: fill.repeat ?? defaultImage.repeat,
        fit: fill.fit ?? defaultImage.fit
    };
    return fill;
}
function $d77b025aa58d633c$var$getShapeStyle(style, defaultGradient, defaultPattern, defaultImage) {
    if (!$d77b025aa58d633c$var$isGradientFill(style?.fill) && !$d77b025aa58d633c$var$isPatternFill(style?.fill) && !$d77b025aa58d633c$var$isImageFill(style?.fill)) return style;
    return {
        ...style,
        fill: $d77b025aa58d633c$var$getShapeFill(style.fill, defaultGradient, defaultPattern, defaultImage)
    };
}
function $d77b025aa58d633c$var$applyShapeFillBBox(shape, fill, fillBBox, fillParams) {
    if (fillBBox == null || !$d77b025aa58d633c$var$isGradientFill(fill) || fill.bounds == null || fill.bounds === "item") shape.fillBBox = void 0;
    else shape.fillBBox = fillBBox[fill.bounds];
    shape.fillParams = fillParams;
}
function $d77b025aa58d633c$var$applyShapeStyle(shape, style, overrides, fillBBox, fillParams) {
    const fill = overrides?.fill ?? style.fill;
    shape.fill = fill;
    $d77b025aa58d633c$var$applyShapeFillBBox(shape, overrides?.fill ?? style.fill, fillBBox, fillParams);
    shape.fillOpacity = overrides?.fillOpacity ?? style.fillOpacity ?? 1;
    shape.stroke = overrides?.stroke ?? style.stroke;
    shape.strokeOpacity = overrides?.strokeOpacity ?? style.strokeOpacity ?? 1;
    shape.strokeWidth = overrides?.strokeWidth ?? style.strokeWidth ?? 0;
    shape.lineDash = overrides?.lineDash ?? style.lineDash;
    shape.lineDashOffset = overrides?.lineDashOffset ?? style.lineDashOffset ?? 0;
}
// packages/ag-charts-community/src/chart/series/series.ts
var $d77b025aa58d633c$var$SeriesNodePickMode = /* @__PURE__ */ ((SeriesNodePickMode2)=>{
    SeriesNodePickMode2[SeriesNodePickMode2["EXACT_SHAPE_MATCH"] = 0] = "EXACT_SHAPE_MATCH";
    SeriesNodePickMode2[SeriesNodePickMode2["NEAREST_NODE"] = 1] = "NEAREST_NODE";
    SeriesNodePickMode2[SeriesNodePickMode2["AXIS_ALIGNED"] = 2] = "AXIS_ALIGNED";
    return SeriesNodePickMode2;
})($d77b025aa58d633c$var$SeriesNodePickMode || {});
var $d77b025aa58d633c$var$CROSS_FILTER_MARKER_FILL_OPACITY_FACTOR = 0.25;
var $d77b025aa58d633c$var$CROSS_FILTER_MARKER_STROKE_OPACITY_FACTOR = 0.125;
var $d77b025aa58d633c$var$SeriesNodeEvent = class {
    constructor(type, event, nodeDatum, series){
        this.type = type;
        this.event = event;
        this.defaultPrevented = false;
        this.datum = nodeDatum.datum;
        this.seriesId = series.id;
    }
    preventDefault() {
        this.defaultPrevented = true;
    }
};
var $d77b025aa58d633c$var$SeriesGroupingChangedEvent = class {
    constructor(series, seriesGrouping, oldGrouping){
        this.series = series;
        this.seriesGrouping = seriesGrouping;
        this.oldGrouping = oldGrouping;
        this.type = "groupingChanged";
    }
};
var $d77b025aa58d633c$var$Series = class extends $d77b025aa58d633c$var$Observable {
    constructor(seriesOpts){
        super();
        this.destroyFns = [];
        this.usesPlacedLabels = false;
        this.seriesGrouping = void 0;
        this.NodeEvent = $d77b025aa58d633c$var$SeriesNodeEvent;
        this.internalId = (0, $idDdm.createId)(this);
        // The group node that contains the series rendering in its default (non-highlighted) state.
        this.contentGroup = new $d77b025aa58d633c$var$TranslatableGroup({
            name: `${this.internalId}-content`,
            zIndex: 1 /* ANY_CONTENT */ 
        });
        // The group node that contains all highlighted series items. This is a performance optimisation
        // for large-scale data-sets, where the only thing that routinely varies is the currently
        // highlighted node.
        this.highlightGroup = new $d77b025aa58d633c$var$TranslatableGroup({
            name: `${this.internalId}-highlight`,
            zIndex: 1 /* ANY_CONTENT */ 
        });
        // Error bars etc.
        this.annotationGroup = new $d77b025aa58d633c$var$TranslatableGroup({
            name: `${this.internalId}-annotation`
        });
        // Lazily initialised labelGroup for label presentation.
        this.labelGroup = new $d77b025aa58d633c$var$TranslatableGroup({
            name: `${this.internalId}-series-labels`
        });
        this.axes = {};
        this.directions = [
            "x" /* X */ ,
            "y" /* Y */ 
        ];
        // Flag to determine if we should recalculate node data.
        this.nodeDataRefresh = true;
        this.moduleMap = new $d77b025aa58d633c$var$ModuleMap();
        this.datumCallbackCache = /* @__PURE__ */ new Map();
        this.connectsToYAxis = false;
        this._declarationOrder = -1;
        this.seriesListeners = new $d77b025aa58d633c$var$Listeners();
        this._pickNodeCache = new $d77b025aa58d633c$var$LRUCache();
        const { moduleCtx: moduleCtx, pickModes: pickModes, directionKeys: directionKeys = {}, directionNames: directionNames = {}, canHaveAxes: canHaveAxes = false, usesPlacedLabels: usesPlacedLabels = false } = seriesOpts;
        this.ctx = moduleCtx;
        this.directionKeys = directionKeys;
        this.directionNames = directionNames;
        this.canHaveAxes = canHaveAxes;
        this.usesPlacedLabels = usesPlacedLabels;
        this.highlightGroup = new $d77b025aa58d633c$var$TranslatableGroup({
            name: `${this.internalId}-highlight`
        });
        this.highlightNode = this.highlightGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: "highlightNode",
            zIndex: 0
        }));
        this.highlightLabel = this.highlightGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: "highlightLabel",
            zIndex: 10
        }));
        this.pickModes = pickModes;
    }
    get pickModeAxis() {
        return "main";
    }
    get id() {
        return this.properties?.id ?? this.internalId;
    }
    get type() {
        return this.constructor.type ?? "";
    }
    get focusable() {
        return true;
    }
    get data() {
        return this._data ?? this._chartData;
    }
    set visible(newVisibility) {
        this.properties.visible = newVisibility;
        this.ctx.legendManager.toggleItem(newVisibility, this.id);
        this.ctx.legendManager.update();
        this.visibleMaybeChanged();
    }
    get visible() {
        return this.ctx.legendManager.getSeriesEnabled(this.id) ?? this.properties.visible;
    }
    get hasData() {
        return this.data != null && this.data.length > 0;
    }
    get tooltipEnabled() {
        return this.properties.tooltip?.enabled;
    }
    onDataChange() {
        this.nodeDataRefresh = true;
        this._pickNodeCache.clear();
    }
    setOptionsData(input) {
        this._data = input;
        this.onDataChange();
    }
    setChartData(input) {
        this._chartData = input;
        if (this.data === input) this.onDataChange();
    }
    onSeriesGroupingChange(prev, next) {
        const { internalId: internalId, type: type, visible: visible } = this;
        if (prev) this.ctx.seriesStateManager.deregisterSeries(this);
        if (next) this.ctx.seriesStateManager.registerSeries({
            internalId: internalId,
            type: type,
            visible: visible,
            seriesGrouping: next
        });
        this.fireEvent(new $d77b025aa58d633c$var$SeriesGroupingChangedEvent(this, next, prev));
    }
    getBandScalePadding() {
        return {
            inner: 1,
            outer: 0
        };
    }
    attachSeries(seriesContentNode, seriesNode, annotationNode) {
        seriesContentNode.appendChild(this.contentGroup);
        seriesNode.appendChild(this.highlightGroup);
        seriesNode.appendChild(this.labelGroup);
        annotationNode?.appendChild(this.annotationGroup);
    }
    detachSeries(seriesContentNode, seriesNode, annotationNode) {
        seriesContentNode?.removeChild(this.contentGroup);
        seriesNode.removeChild(this.highlightGroup);
        seriesNode.removeChild(this.labelGroup);
        annotationNode?.removeChild(this.annotationGroup);
    }
    setSeriesIndex(index) {
        if (index === this._declarationOrder) return false;
        this._declarationOrder = index;
        this.contentGroup.zIndex = [
            1 /* ANY_CONTENT */ ,
            index,
            0 /* FOREGROUND */ 
        ];
        this.highlightGroup.zIndex = [
            1 /* ANY_CONTENT */ ,
            index,
            1 /* HIGHLIGHT */ 
        ];
        this.labelGroup.zIndex = [
            1 /* ANY_CONTENT */ ,
            index,
            2 /* LABEL */ 
        ];
        this.annotationGroup.zIndex = index;
        return true;
    }
    renderToOffscreenCanvas() {
        return false;
    }
    addEventListener(type, listener) {
        return super.addEventListener(type, listener);
    }
    removeEventListener(type, listener) {
        return super.removeEventListener(type, listener);
    }
    hasEventListener(type) {
        return super.hasEventListener(type);
    }
    addListener(type, listener) {
        return this.seriesListeners.addListener(type, listener);
    }
    dispatch(type, event) {
        this.seriesListeners.dispatch(type, event);
    }
    addChartEventListeners() {
        return;
    }
    updatedDomains() {}
    destroy() {
        this.destroyFns.forEach((f)=>f());
        this.destroyFns = [];
        this.resetDatumCallbackCache();
        this.ctx.seriesStateManager.deregisterSeries(this);
    }
    getDirectionValues(direction, properties) {
        const resolvedDirection = this.resolveKeyDirection(direction);
        const keys = properties?.[resolvedDirection];
        const values = [];
        if (!keys) return values;
        const addValues = (...items)=>{
            for (const value of items){
                if (Array.isArray(value)) addValues(...value);
                else if (typeof value === "object") addValues(...Object.values(value));
                else values.push(value);
            }
        };
        addValues(...keys.map((key)=>this.properties[key]));
        return values;
    }
    getKeys(direction) {
        return this.getDirectionValues(direction, this.directionKeys);
    }
    getKeyProperties(direction) {
        return this.directionKeys[this.resolveKeyDirection(direction)] ?? [];
    }
    getNames(direction) {
        return this.getDirectionValues(direction, this.directionNames);
    }
    resolveKeyDirection(direction) {
        return direction;
    }
    // The union of the series domain ('community') and series-option domains ('enterprise').
    getDomain(direction) {
        const seriesDomain = this.getSeriesDomain(direction);
        const moduleDomains = this.moduleMap.mapModules((module)=>module.getDomain(direction)).flat();
        return moduleDomains.length !== 0 ? seriesDomain.concat(moduleDomains) : seriesDomain;
    }
    getRange(direction, visibleRange) {
        return this.getSeriesRange(direction, visibleRange);
    }
    getVisibleItems(_xVisibleRange, _yVisibleRange, _minVisibleItems) {
        return Infinity;
    }
    // Indicate that something external changed and we should recalculate nodeData.
    markNodeDataDirty() {
        this.nodeDataRefresh = true;
        this._pickNodeCache.clear();
        this.visibleMaybeChanged();
    }
    visibleMaybeChanged() {
        this.ctx.seriesStateManager.updateSeries(this);
    }
    getOpacity() {
        const defaultOpacity = 1;
        const { dimOpacity: dimOpacity = 1, enabled: enabled = true } = this.properties.highlightStyle.series;
        if (!enabled || dimOpacity === defaultOpacity) return defaultOpacity;
        switch(this.isItemIdHighlighted()){
            case 0 /* None */ :
            case 1 /* This */ :
                return defaultOpacity;
            case 2 /* Other */ :
            default:
                return dimOpacity;
        }
    }
    getStrokeWidth(defaultStrokeWidth) {
        const { strokeWidth: strokeWidth, enabled: enabled = true } = this.properties.highlightStyle.series;
        if (!enabled || strokeWidth === void 0) return defaultStrokeWidth;
        switch(this.isItemIdHighlighted()){
            case 1 /* This */ :
                return strokeWidth;
            case 0 /* None */ :
            case 2 /* Other */ :
                return defaultStrokeWidth;
        }
    }
    isItemIdHighlighted() {
        const series = this.ctx.highlightManager?.getActiveHighlight()?.series;
        if (series == null) return 0 /* None */ ;
        if (series !== this) return 2 /* Other */ ;
        return 1 /* This */ ;
    }
    getModuleTooltipParams() {
        return this.moduleMap.mapModules((module)=>module.getTooltipParams()).reduce((total, current)=>Object.assign(total, current), {});
    }
    pickNodes(point, intent, exactMatchOnly = false) {
        const { pickModes: pickModes, pickModeAxis: pickModeAxis, visible: visible, contentGroup: contentGroup } = this;
        if (!visible || !contentGroup.visible) return;
        if (intent === "highlight" && !this.properties.highlight.enabled) return;
        if (intent === "highlight-tooltip" && !this.properties.highlight.enabled) return;
        let maxDistance = Infinity;
        if (intent === "tooltip" || intent === "highlight-tooltip") {
            const { tooltip: tooltip } = this.properties;
            maxDistance = typeof tooltip.range === "number" ? tooltip.range : Infinity;
            exactMatchOnly || (exactMatchOnly = tooltip.range === "exact");
        } else if (intent === "event" || intent === "context-menu") {
            const { nodeClickRange: nodeClickRange } = this.properties;
            maxDistance = typeof nodeClickRange === "number" ? nodeClickRange : Infinity;
            exactMatchOnly || (exactMatchOnly = nodeClickRange === "exact");
        }
        const selectedPickModes = pickModes.filter((m)=>!exactMatchOnly || m === 0 /* EXACT_SHAPE_MATCH */ );
        const { x: x, y: y } = point;
        const key = JSON.stringify({
            x: x,
            y: y,
            maxDistance: maxDistance,
            selectedPickModes: selectedPickModes
        });
        if (this._pickNodeCache.has(key)) return this._pickNodeCache.get(key);
        for (const pickMode of selectedPickModes){
            let result;
            switch(pickMode){
                case 0 /* EXACT_SHAPE_MATCH */ :
                    {
                        const exact = this.pickNodesExactShape(point);
                        result = exact.length === 0 ? void 0 : {
                            datums: exact,
                            distance: 0
                        };
                        break;
                    }
                case 1 /* NEAREST_NODE */ :
                    {
                        const closest = this.pickNodeClosestDatum(point);
                        const exact = closest?.distance === 0 ? this.pickNodesExactShape(point) : void 0;
                        if (exact != null && exact.length !== 0) result = {
                            datums: exact,
                            distance: 0
                        };
                        else if (closest) result = {
                            datums: [
                                closest.datum
                            ],
                            distance: closest.distance
                        };
                        else result = void 0;
                        break;
                    }
                case 2 /* AXIS_ALIGNED */ :
                    {
                        const closest = pickModeAxis != null ? this.pickNodeMainAxisFirst(point, pickModeAxis === "main-category") : void 0;
                        result = closest != null ? {
                            datums: [
                                closest.datum
                            ],
                            distance: closest.distance
                        } : void 0;
                        break;
                    }
            }
            if (result && result.distance <= maxDistance) return this._pickNodeCache.set(key, {
                pickMode: pickMode,
                datums: result.datums,
                distance: result.distance
            });
        }
        return this._pickNodeCache.set(key, void 0);
    }
    pickNodesExactShape(point) {
        const datums = [];
        for (const node of this.contentGroup.pickNodes(point.x, point.y)){
            const datum = node.closestDatum();
            if (datum != null && datum.missing !== true) datums.push(datum);
        }
        return datums;
    }
    pickNodeClosestDatum(_point) {
        throw new Error("AG Charts - Series.pickNodeClosestDatum() not implemented");
    }
    pickNodeNearestDistantObject(point, items) {
        const match = $d77b025aa58d633c$var$nearestSquared(point.x, point.y, items);
        const datum = match.nearest?.closestDatum();
        if (datum != null && datum.missing !== true) return {
            datum: datum,
            distance: Math.sqrt(match.distanceSquared)
        };
    }
    pickNodeMainAxisFirst(_point, _requireCategoryAxis) {
        throw new Error("AG Charts - Series.pickNodeMainAxisFirst() not implemented");
    }
    getLabelData() {
        return [];
    }
    updatePlacedLabelData(_labels) {
        return;
    }
    fireNodeClickEvent(event, datum) {
        const clickEvent = new this.NodeEvent("seriesNodeClick", event, datum, this);
        this.fireEvent(clickEvent);
        return !clickEvent.defaultPrevented;
    }
    fireNodeDoubleClickEvent(event, datum) {
        const clickEvent = new this.NodeEvent("seriesNodeDoubleClick", event, datum, this);
        this.fireEvent(clickEvent);
        return !clickEvent.defaultPrevented;
    }
    createNodeContextMenuActionEvent(event, datum) {
        return new this.NodeEvent("nodeContextMenuAction", event, datum, this);
    }
    onLegendInitialState(legendType, initialState) {
        const { visible: visible = true, itemId: itemId, legendItemName: legendItemName } = initialState ?? {};
        this.toggleSeriesItem(visible, legendType, itemId, legendItemName);
    }
    onLegendItemClick(event) {
        const { enabled: enabled, itemId: itemId, series: series, legendType: legendType } = event;
        const legendItemName = "legendItemName" in this.properties ? this.properties.legendItemName : void 0;
        const legendItemKey = "legendItemKey" in this.properties ? this.properties.legendItemKey : void 0;
        const matchedLegendItemName = legendItemName != void 0 && legendItemName === event.legendItemName;
        if (series.id === this.id || matchedLegendItemName || legendItemKey != void 0) this.toggleSeriesItem(enabled, legendType, itemId, legendItemName, event);
    }
    onLegendItemDoubleClick(event) {
        const { enabled: enabled, itemId: itemId, series: series, numVisibleItems: numVisibleItems, legendType: legendType } = event;
        const legendItemName = "legendItemName" in this.properties ? this.properties.legendItemName : void 0;
        const legendItemKey = "legendItemKey" in this.properties ? this.properties.legendItemKey : void 0;
        const matchedLegendItemName = legendItemName != void 0 && legendItemName === event.legendItemName;
        if (series.id === this.id || matchedLegendItemName || legendItemKey != void 0) this.toggleSeriesItem(true, legendType, itemId, legendItemName, event);
        else if (enabled && numVisibleItems === 1) this.toggleSeriesItem(true, legendType, void 0, legendItemName);
        else this.toggleSeriesItem(false, legendType, void 0, legendItemName);
    }
    toggleSeriesItem(enabled, legendType, itemId, legendItemName, legendEvent) {
        const seriesId = this.id;
        if (enabled || legendType !== "category") this.visible = enabled;
        this.nodeDataRefresh = true;
        this._pickNodeCache.clear();
        const event = {
            type: "seriesVisibilityChange",
            seriesId: seriesId,
            itemId: itemId,
            legendItemName: legendEvent?.legendItemName ?? legendItemName,
            visible: enabled
        };
        this.fireEvent(event);
        this.ctx.legendManager.toggleItem(enabled, seriesId, itemId, legendItemName);
    }
    isEnabled() {
        return this.visible;
    }
    getModuleMap() {
        return this.moduleMap;
    }
    createModuleContext() {
        return {
            ...this.ctx,
            series: this
        };
    }
    getLabelText(label, params, defaultFormatter = $d77b025aa58d633c$var$formatValue) {
        if (label.formatter) return this.cachedCallWithContext(label.formatter, {
            seriesId: this.id,
            ...params
        }) ?? this.callWithContext(defaultFormatter, params.value);
        return this.callWithContext(defaultFormatter, params.value);
    }
    getMarkerStyle(marker, datum, params, highlighted = false, size = marker.size ?? 0, defaultStyle) {
        const { itemStyler: itemStyler, fillGradientDefaults: fillGradientDefaults2, fillPatternDefaults: fillPatternDefaults2, fillImageDefaults: fillImageDefaults2 } = marker;
        const defaultSize = {
            size: size
        };
        let markerStyle = $d77b025aa58d633c$var$getShapeStyle($d77b025aa58d633c$var$mergeDefaults(defaultSize, defaultStyle, marker.getStyle()), fillGradientDefaults2, fillPatternDefaults2, fillImageDefaults2);
        if (itemStyler && params) {
            const style = this.cachedCallWithContext(itemStyler, {
                seriesId: this.id,
                ...markerStyle,
                ...params,
                highlighted: highlighted,
                datum: datum
            });
            markerStyle = $d77b025aa58d633c$var$getShapeStyle($d77b025aa58d633c$var$mergeDefaults(style, markerStyle), fillGradientDefaults2, fillPatternDefaults2, fillImageDefaults2);
        }
        return markerStyle;
    }
    updateMarkerStyle(marker, markerNode, datum, point, params, highlighted, defaultStyle, fillBBox, { applyTranslation: applyTranslation = true, selected: selected = true } = {}) {
        const activeStyle = this.getMarkerStyle(marker, datum, params, highlighted, point?.size, defaultStyle);
        const { shape: shape, size: size } = activeStyle;
        const visible = this.visible && size > 0 && point && !isNaN(point.x) && !isNaN(point.y);
        $d77b025aa58d633c$var$applyShapeStyle(markerNode, activeStyle, void 0, fillBBox);
        if (applyTranslation) markerNode.setProperties({
            visible: visible,
            shape: shape,
            size: size,
            x: point?.x,
            y: point?.y,
            scalingCenterX: point?.x,
            scalingCenterY: point?.y
        });
        else markerNode.setProperties({
            visible: visible,
            shape: shape,
            size: size
        });
        if (!selected) {
            markerNode.fillOpacity *= $d77b025aa58d633c$var$CROSS_FILTER_MARKER_FILL_OPACITY_FACTOR;
            markerNode.strokeOpacity *= $d77b025aa58d633c$var$CROSS_FILTER_MARKER_STROKE_OPACITY_FACTOR;
        }
        if (typeof marker.shape === "function" && !markerNode.dirtyPath) {
            markerNode.path.clear(true);
            markerNode.updatePath();
            markerNode.checkPathDirty();
            const bb = markerNode.getBBox();
            if (point !== void 0 && bb.isFinite()) {
                const center2 = bb.computeCenter();
                const [dx, dy] = [
                    "x",
                    "y"
                ].map((key)=>(activeStyle.strokeWidth ?? 0) + Math.abs(center2[key] - point[key]));
                point.focusSize = Math.max(bb.width + dx, bb.height + dy);
            }
        }
    }
    get nodeDataDependencies() {
        return this._nodeDataDependencies ?? {
            seriesRectWidth: NaN,
            seriesRectHeight: NaN
        };
    }
    checkResize(newSeriesRect) {
        const { width: seriesRectWidth, height: seriesRectHeight } = newSeriesRect ?? {
            width: NaN,
            height: NaN
        };
        const newNodeDataDependencies = newSeriesRect ? {
            seriesRectWidth: seriesRectWidth,
            seriesRectHeight: seriesRectHeight
        } : void 0;
        const resize = $d77b025aa58d633c$var$jsonDiff(this.nodeDataDependencies, newNodeDataDependencies) != null;
        if (resize) {
            this._nodeDataDependencies = newNodeDataDependencies;
            this.markNodeDataDirty();
        }
        return resize;
    }
    pickFocus(_opts) {
        return void 0;
    }
    resetDatumCallbackCache() {
        this.datumCallbackCache.clear();
    }
    cachedDatumCallback(id, fn) {
        const { datumCallbackCache: datumCallbackCache } = this;
        const existing = datumCallbackCache.get(id);
        if (existing != null) return existing;
        try {
            const value = fn();
            datumCallbackCache.set(id, value);
            return value;
        } catch (error) {
            (0, $idDdm.Logger).error(String(error));
        }
    }
    cachedCallWithContext(fn, ...params) {
        return this.ctx.callbackCache.call(this.properties, this.ctx.chartService, fn, ...params);
    }
    callWithContext(fn, ...params) {
        return $d77b025aa58d633c$var$callWithContext(this.properties, this.ctx.chartService, fn, params);
    }
    formatTooltipWithContext(tooltip, content, params) {
        return tooltip.formatTooltip(this.properties, this.ctx.chartService, content, params);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        changeValue: function(newVal, oldVal) {
            this.onSeriesGroupingChange(oldVal, newVal);
        }
    })
], $d77b025aa58d633c$var$Series.prototype, "seriesGrouping", 2);
var $d77b025aa58d633c$var$Path = class extends $d77b025aa58d633c$var$Shape {
    constructor(){
        super(...arguments);
        /**
     * Declare a path to retain for later rendering and hit testing
     * using custom Path2D class. Think of it as a TypeScript version
     * of the native Path2D (with some differences) that works in all browsers.
     */ this.path = new $d77b025aa58d633c$var$ExtendedPath2D();
        this._clipX = NaN;
        this._clipY = NaN;
        this.clip = false;
        /**
     * The path only has to be updated when certain attributes change.
     * For example, if transform attributes (such as `translationX`)
     * are changed, we don't have to update the path. The `dirtyPath` flag
     * is how we keep track if the path has to be updated or not.
     */ this._dirtyPath = true;
        this.lastPixelRatio = NaN;
    }
    set clipX(value) {
        this._clipX = value;
        this.dirtyPath = true;
    }
    set clipY(value) {
        this._clipY = value;
        this.dirtyPath = true;
    }
    set dirtyPath(value) {
        if (this._dirtyPath !== value) {
            this._dirtyPath = value;
            if (value) this.markDirty("path");
        }
    }
    get dirtyPath() {
        return this._dirtyPath;
    }
    checkPathDirty() {
        if (this._dirtyPath) return;
        this.dirtyPath = this.path.isDirty() || (this.fillShadow?.isDirty() ?? false) || (this._clipPath?.isDirty() ?? false);
    }
    onChangeDetection(property) {
        if (!this._dirtyPath) {
            this._dirtyPath = true;
            super.onChangeDetection(property);
        }
    }
    computeBBox() {
        this.updatePathIfDirty();
        return this.path.computeBBox();
    }
    isPointInPath(x, y) {
        this.updatePathIfDirty();
        return this.path.closedPath && this.path.isPointInPath(x, y);
    }
    distanceSquared(x, y) {
        return this.distanceSquaredTransformedPoint(x, y);
    }
    svgPathData(transform) {
        this.updatePathIfDirty();
        return this.path.toSVG(transform);
    }
    distanceSquaredTransformedPoint(x, y) {
        this.updatePathIfDirty();
        if (this.path.closedPath && this.path.isPointInPath(x, y)) return 0;
        return this.path.distanceSquared(x, y);
    }
    isDirtyPath() {
        return false;
    }
    updatePath() {}
    updatePathIfDirty() {
        if (this.dirtyPath || this.isDirtyPath()) {
            this.updatePath();
            this.dirtyPath = false;
        }
    }
    preRender(renderCtx) {
        if (renderCtx.devicePixelRatio !== this.lastPixelRatio) this.dirtyPath = true;
        this.lastPixelRatio = renderCtx.devicePixelRatio;
        this.updatePathIfDirty();
        return super.preRender(renderCtx, this.path.commands.length);
    }
    render(renderCtx) {
        const { ctx: ctx } = renderCtx;
        if (this.clip && !isNaN(this._clipX) && !isNaN(this._clipY)) {
            ctx.save();
            const margin = this.strokeWidth / 2;
            this._clipPath ?? (this._clipPath = new $d77b025aa58d633c$var$ExtendedPath2D());
            this._clipPath.clear();
            this._clipPath.rect(-margin, -margin, this._clipX + margin, this._clipY + margin + margin);
            ctx.clip(this._clipPath?.getPath2D());
            if (this._clipX > 0 && this._clipY > 0) this.drawPath(ctx);
            ctx.restore();
        } else {
            this._clipPath = void 0;
            this.drawPath(ctx);
        }
        this.fillShadow?.markClean();
        super.render(renderCtx);
    }
    drawPath(ctx) {
        this.fillStroke(ctx, this.path.getPath2D());
    }
    toSVG() {
        if (!this.visible) return;
        const element2 = (0, $idDdm.createSvgElement)("path");
        element2.setAttribute("d", this.svgPathData());
        const defs = this.applySvgFillAttributes(element2, []);
        this.applySvgStrokeAttributes(element2);
        return {
            elements: [
                element2
            ],
            defs: defs
        };
    }
};
$d77b025aa58d633c$var$Path.className = "Path";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Path.prototype, "clip", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Path.prototype, "clipX", 1);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Path.prototype, "clipY", 1);
// packages/ag-charts-community/src/dom/focusIndicator.ts
var $d77b025aa58d633c$var$FocusIndicator = class {
    constructor(swapChain){
        this.swapChain = swapChain;
        this.hasBeenActivated = false;
        this.div = (0, $idDdm.createElement)("div");
        this.svg = (0, $idDdm.createSvgElement)("svg");
        this.outerPath = (0, $idDdm.createSvgElement)("path");
        this.innerPath = (0, $idDdm.createSvgElement)("path");
        this.svg.append(this.outerPath);
        this.svg.append(this.innerPath);
        this.outerPath.classList.add("ag-charts-focus-svg-outer-path");
        this.innerPath.classList.add("ag-charts-focus-svg-inner-path");
        this.element = (0, $idDdm.createElement)("div", "ag-charts-focus-indicator");
        this.element.ariaHidden = "true";
        this.element.append(this.svg);
        this.swapChain.addListener("swap", (parent)=>this.onSwap(parent));
    }
    clear() {}
    update(focus, rect, clip) {
        if (rect == null) return;
        if (focus instanceof $d77b025aa58d633c$var$Path) {
            const transform = (localX, localY)=>{
                let { x: x, y: y } = $d77b025aa58d633c$var$Transformable.toCanvasPoint(focus, localX, localY);
                x -= rect.x ?? 0;
                y -= rect.y ?? 0;
                return {
                    x: x,
                    y: y
                };
            };
            const d = focus.svgPathData(transform);
            this.outerPath.setAttribute("d", d);
            this.innerPath.setAttribute("d", d);
            this.show(this.svg);
        } else {
            let bbox;
            if (clip) {
                const x0 = Math.max(focus.x - rect.x, 0);
                const y0 = Math.max(focus.y - rect.y, 0);
                const x1 = Math.min(focus.x + focus.width - rect.x, rect.width);
                const y1 = Math.min(focus.y + focus.height - rect.y, rect.height);
                bbox = new $d77b025aa58d633c$var$BBox(x0, y0, x1 - x0, y1 - y0);
            } else bbox = new $d77b025aa58d633c$var$BBox(focus.x - rect.x, focus.y - rect.y, focus.width, focus.height);
            $d77b025aa58d633c$var$setElementBBox(this.div, bbox);
            this.show(this.div);
        }
    }
    onSwap(newParent) {
        if (newParent === this.element.parentElement) return;
        this.element.remove();
        newParent.appendChild(this.element);
        this.overrideFocusVisible(this.focusVisible);
    }
    show(child) {
        this.hasBeenActivated = true;
        this.element.innerHTML = "";
        this.element.append(child);
    }
    overrideFocusVisible(focusVisible) {
        this.focusVisible = focusVisible;
        const opacity = {
            true: "1",
            false: "0",
            undefined: ""
        };
        const parent = this.element.parentElement;
        parent?.style.setProperty("opacity", opacity[`${focusVisible}`]);
    }
    // Get the `:focus-visible` CSS state.
    isFocusVisible(force = false) {
        if (!force && !this.hasBeenActivated) return false;
        const parent = this.element.parentElement;
        return parent != null && (0, $idDdm.getWindow)().getComputedStyle(parent).opacity === "1";
    }
};
var $d77b025aa58d633c$var$FocusSwapChain = class {
    constructor(label1, label2, announcerRole){
        this.label1 = label1;
        this.label2 = label2;
        this.hasFocus = false;
        this.skipDispatch = false;
        this.listeners = {
            blur: [],
            focus: [],
            swap: []
        };
        this.onBlur = (e)=>{
            (0, $idDdm.setElementStyle)(e.target, "pointer-events", void 0);
            return !this.skipDispatch && this.dispatch("blur", e);
        };
        this.onFocus = (e)=>{
            (0, $idDdm.setElementStyle)(e.target, "pointer-events", "auto");
            return !this.skipDispatch && this.dispatch("focus", e);
        };
        (0, $idDdm.setAttribute)(this.label1, "id", (0, $idDdm.createElementId)());
        (0, $idDdm.setAttribute)(this.label2, "id", (0, $idDdm.createElementId)());
        (0, $idDdm.setElementStyle)(this.label1, "display", "none");
        (0, $idDdm.setElementStyle)(this.label2, "display", "none");
        this.activeAnnouncer = this.createAnnouncer(announcerRole);
        this.inactiveAnnouncer = this.createAnnouncer(announcerRole);
        (0, $idDdm.setAttribute)(this.activeAnnouncer, "tabindex", 0);
        this.label2.insertAdjacentElement("afterend", this.activeAnnouncer);
        this.label2.insertAdjacentElement("afterend", this.inactiveAnnouncer);
        this.swap("");
    }
    createAnnouncer(role) {
        const announcer = (0, $idDdm.createElement)("div");
        announcer.role = role;
        announcer.className = "ag-charts-swapchain";
        announcer.addEventListener("blur", this.onBlur);
        announcer.addEventListener("focus", this.onFocus);
        return announcer;
    }
    destroy() {
        for (const announcer of [
            this.activeAnnouncer,
            this.inactiveAnnouncer
        ]){
            announcer.removeEventListener("blur", this.onBlur);
            announcer.removeEventListener("focus", this.onFocus);
            announcer.remove();
        }
    }
    focus(opts) {
        this.focusOptions = opts;
        this.activeAnnouncer.focus(opts);
        this.focusOptions = void 0;
    }
    update(newLabel) {
        this.skipDispatch = true;
        this.swap(newLabel);
        if (this.hasFocus) this.activeAnnouncer.focus(this.focusOptions);
        this.skipDispatch = false;
    }
    addListener(type, handler) {
        this.listeners[type].push(handler);
        if (type === "swap") {
            const swapHandler = handler;
            swapHandler(this.activeAnnouncer);
        }
    }
    dispatch(type, param) {
        if (type === "focus") this.hasFocus = true;
        else if (type === "blur") this.hasFocus = false;
        this.listeners[type].forEach((fn)=>fn(param));
    }
    swap(newLabel) {
        const userTabIndex = this.activeAnnouncer.tabIndex;
        this.label2.textContent = newLabel;
        [this.inactiveAnnouncer, this.activeAnnouncer] = [
            this.activeAnnouncer,
            this.inactiveAnnouncer
        ];
        [this.label1, this.label2] = [
            this.label2,
            this.label1
        ];
        (0, $idDdm.setAttributes)(this.inactiveAnnouncer, {
            "aria-labelledby": this.label1.id,
            "aria-hidden": true,
            tabindex: void 0
        });
        (0, $idDdm.setAttributes)(this.activeAnnouncer, {
            "aria-labelledby": this.label1.id,
            "aria-hidden": false,
            tabindex: userTabIndex
        });
        this.dispatch("swap", this.activeAnnouncer);
    }
};
var $d77b025aa58d633c$var$KEY_BINDINGS = {
    arrowdown: {
        bindings: [
            {
                code: "ArrowDown"
            }
        ]
    },
    arrowleft: {
        bindings: [
            {
                code: "ArrowLeft"
            }
        ]
    },
    arrowright: {
        bindings: [
            {
                code: "ArrowRight"
            }
        ]
    },
    arrowup: {
        bindings: [
            {
                code: "ArrowUp"
            }
        ]
    },
    delete: {
        bindings: [
            {
                key: "Backspace"
            },
            {
                key: "Delete"
            }
        ],
        activatesFocusIndicator: false
    },
    redo: {
        bindings: [
            {
                key: "y",
                ctrlOrMeta: true
            },
            {
                key: "z",
                ctrlOrMeta: true,
                shift: true
            }
        ],
        activatesFocusIndicator: false
    },
    undo: {
        bindings: [
            {
                key: "z",
                ctrlOrMeta: true
            }
        ],
        activatesFocusIndicator: false
    },
    submit: {
        bindings: [
            {
                key: "Enter"
            },
            {
                code: "Enter"
            },
            {
                code: "Space"
            }
        ]
    },
    zoomin: {
        bindings: [
            {
                key: "+"
            },
            {
                code: "ZoomIn"
            },
            {
                code: "Add"
            }
        ],
        activatesFocusIndicator: false
    },
    zoomout: {
        bindings: [
            {
                key: "-"
            },
            {
                code: "ZoomOut"
            },
            {
                code: "Substract"
            }
        ],
        activatesFocusIndicator: false
    }
};
function $d77b025aa58d633c$var$matchesKeyBinding(e, bindings) {
    for (const kb of bindings)if ("code" in kb) {
        if (kb.code === e.code) return true;
    } else {
        const matches = kb.key === e.key && (kb.shift === void 0 || kb.shift === e.shiftKey) && (kb.ctrlOrMeta === void 0 || kb.ctrlOrMeta === e.ctrlKey || kb.ctrlOrMeta === e.metaKey);
        if (matches) return true;
    }
    return false;
}
function $d77b025aa58d633c$var$mapKeyboardEventToAction(event) {
    for (const [actionName, { activatesFocusIndicator: activatesFocusIndicator = true, bindings: bindings }] of (0, $idDdm.entries)($d77b025aa58d633c$var$KEY_BINDINGS)){
        if ($d77b025aa58d633c$var$matchesKeyBinding(event, bindings)) return {
            name: actionName,
            activatesFocusIndicator: activatesFocusIndicator
        };
    }
    return void 0;
}
// packages/ag-charts-community/src/chart/keyboardUtil.ts
function $d77b025aa58d633c$var$computeCenter(series, hoverRect, pick) {
    const refPoint = $d77b025aa58d633c$var$getDatumRefPoint(series, pick.datum, pick.movedBounds);
    if (refPoint != null) return {
        x: refPoint.canvasX,
        y: refPoint.canvasY
    };
    const bboxOrPath = pick.bounds;
    if (bboxOrPath == null) return;
    if (bboxOrPath instanceof $d77b025aa58d633c$var$BBox) {
        const { x: centerX, y: centerY } = bboxOrPath.computeCenter();
        return {
            x: hoverRect.x + centerX,
            y: hoverRect.y + centerY
        };
    }
    return $d77b025aa58d633c$var$Transformable.toCanvas(bboxOrPath).computeCenter();
}
function $d77b025aa58d633c$var$getPickedFocusBBox({ bounds: bounds }) {
    if (bounds instanceof $d77b025aa58d633c$var$BBox) return bounds;
    if (bounds != null) return $d77b025aa58d633c$var$Transformable.toCanvas(bounds);
    return $d77b025aa58d633c$var$BBox.NaN;
}
function $d77b025aa58d633c$var$makeKeyboardPointerEvent(series, hoverRect, pick) {
    const { x: canvasX, y: canvasY } = $d77b025aa58d633c$var$computeCenter(series, hoverRect, pick) ?? {};
    if (canvasX !== void 0 && canvasY !== void 0) return {
        type: "keyboard",
        canvasX: canvasX,
        canvasY: canvasY
    };
    return void 0;
}
function $d77b025aa58d633c$var$createDeprecationWarning() {
    return (key, message)=>{
        const msg = [
            `Property [${key}] is deprecated.`,
            message
        ].filter(Boolean).join(" ");
        (0, $idDdm.Logger).warnOnce(msg);
    };
}
function $d77b025aa58d633c$var$Deprecated(message, opts) {
    const warnDeprecated = $d77b025aa58d633c$var$createDeprecationWarning();
    const def = opts?.default;
    return $d77b025aa58d633c$var$addTransformToInstanceProperty((_, key, value)=>{
        if (value !== def) warnDeprecated(key.toString(), message);
        return value;
    });
}
function $d77b025aa58d633c$var$DeprecatedAndRenamedTo(newPropName, mapValue) {
    const warnDeprecated = $d77b025aa58d633c$var$createDeprecationWarning();
    return $d77b025aa58d633c$var$addTransformToInstanceProperty((target, key, value)=>{
        if (value !== target[newPropName]) {
            warnDeprecated(key.toString(), `Use [${newPropName}] instead.`);
            $d77b025aa58d633c$var$setPath(target, newPropName, mapValue ? mapValue(value) : value);
        }
        return $d77b025aa58d633c$var$BREAK_TRANSFORM_CHAIN;
    }, (target, key)=>{
        warnDeprecated(key.toString(), `Use [${newPropName}] instead.`);
        return $d77b025aa58d633c$var$getPath(target, newPropName);
    });
}
// packages/ag-charts-community/src/util/placement.ts
function $d77b025aa58d633c$var$calculatePlacement(naturalWidth, naturalHeight, container, bounds) {
    let { top: top, right: right, bottom: bottom, left: left, width: width2, height: height2 } = bounds;
    if (left != null) {
        if (width2 != null) right = container.width - left + width2;
        else if (right != null) width2 = container.width - left - right;
    } else if (right != null && width2 != null) left = container.width - right - width2;
    if (top != null) {
        if (height2 != null) bottom = container.height - top - height2;
        else if (bottom != null) height2 = container.height - bottom - top;
    } else if (bottom != null && height2 != null) top = container.height - bottom - height2;
    if (width2 == null) {
        if (height2 == null) {
            width2 = naturalWidth;
            height2 = naturalHeight;
        } else width2 = Math.ceil(naturalWidth * height2 / naturalHeight);
    } else if (height2 == null) height2 = Math.ceil(naturalHeight * width2 / naturalWidth);
    if (left == null) {
        if (right == null) left = Math.floor((container.width - width2) / 2);
        else left = container.width - right - width2;
    }
    if (top == null) {
        if (bottom == null) top = Math.floor((container.height - height2) / 2);
        else top = container.height - height2 - bottom;
    }
    return {
        x: left,
        y: top,
        width: width2,
        height: height2
    };
}
// packages/ag-charts-community/src/chart/tooltip/springAnimation.ts
var $d77b025aa58d633c$var$M = 0.1;
var $d77b025aa58d633c$var$K = 200;
var $d77b025aa58d633c$var$C = 12;
var $d77b025aa58d633c$var$DELTA = 0.5;
var $d77b025aa58d633c$var$SpringAnimation = class extends $d77b025aa58d633c$var$Listeners {
    constructor(){
        super(...arguments);
        this.x1 = NaN;
        this.y1 = NaN;
        this.x = NaN;
        this.y = NaN;
        this.vx = 0;
        this.vy = 0;
        this.t0 = NaN;
        this.animationFrameHandle = void 0;
    }
    reset() {
        this.x = NaN;
        this.y = NaN;
        if (this.animationFrameHandle != null) {
            cancelAnimationFrame(this.animationFrameHandle);
            this.animationFrameHandle = void 0;
        }
    }
    update(x, y) {
        if (Number.isNaN(this.x) || Number.isNaN(this.y)) {
            this.x = x;
            this.y = y;
            this.vx = 0;
            this.vy = 0;
            this.emitUpdate();
            if (this.animationFrameHandle != null) {
                cancelAnimationFrame(this.animationFrameHandle);
                this.animationFrameHandle = void 0;
            }
            return;
        }
        this.x1 = x;
        this.y1 = y;
        this.t0 = Date.now();
        if (this.animationFrameHandle == null) this.animationFrameHandle = requestAnimationFrame(this.onFrame.bind(this));
    }
    onFrame() {
        this.animationFrameHandle = void 0;
        const { x1: x1, y1: y1, t0: t0 } = this;
        const t1 = Date.now();
        const dt = t1 - t0;
        this.t0 = t1;
        const stepT = 1e-3;
        const iterations = Math.ceil(dt / (stepT * 1e3)) | 0;
        let { x: x, y: y, vx: vx, vy: vy } = this;
        for(let i = 0; i < iterations; i += 1){
            const dx = x - x1;
            const dy = y - y1;
            const ax = -($d77b025aa58d633c$var$K * dx + $d77b025aa58d633c$var$C * vx) / $d77b025aa58d633c$var$M;
            const ay = -($d77b025aa58d633c$var$K * dy + $d77b025aa58d633c$var$C * vy) / $d77b025aa58d633c$var$M;
            vx += ax * stepT;
            vy += ay * stepT;
            x += vx * stepT;
            y += vy * stepT;
        }
        if (Math.hypot(x - x1, y - y1) < $d77b025aa58d633c$var$DELTA) {
            this.x = this.x1;
            this.y = this.y1;
            this.vx = 0;
            this.vy = 0;
        } else {
            this.x = x;
            this.y = y;
            this.vx = vx;
            this.vy = vy;
            this.animationFrameHandle = requestAnimationFrame(this.onFrame.bind(this));
        }
        this.emitUpdate();
    }
    emitUpdate() {
        this.dispatch("update", {
            type: "update",
            x: this.x,
            y: this.y
        });
    }
};
var $d77b025aa58d633c$var$element = null;
function $d77b025aa58d633c$var$sanitizeHtml(text) {
    if (text === "") return "";
    $d77b025aa58d633c$var$element ?? ($d77b025aa58d633c$var$element = (0, $idDdm.createElement)("div"));
    $d77b025aa58d633c$var$element.textContent = String(text);
    return $d77b025aa58d633c$var$element.innerHTML.replace(/\n/g, "<br>");
}
// packages/ag-charts-community/src/chart/marker/shapes.ts
function $d77b025aa58d633c$var$drawMarkerUnitPolygon(params, moves) {
    const { path: path, size: size } = params;
    const { x: x0, y: y0 } = params;
    path.clear();
    let didMove = false;
    for (const [dx, dy] of moves){
        const x = x0 + (dx - 0.5) * size;
        const y = y0 + (dy - 0.5) * size;
        if (didMove) path.lineTo(x, y);
        else path.moveTo(x, y);
        didMove = true;
    }
    path.closePath();
}
var $d77b025aa58d633c$var$MARKER_SHAPES = {
    circle ({ path: path, x: x, y: y, size: size }) {
        const r = size / 2;
        path.arc(x, y, r, 0, Math.PI * 2);
        path.closePath();
    },
    cross (params) {
        $d77b025aa58d633c$var$drawMarkerUnitPolygon(params, [
            [
                0.25,
                0
            ],
            [
                0.5,
                0.25
            ],
            [
                0.75,
                0
            ],
            [
                1,
                0.25
            ],
            [
                0.75,
                0.5
            ],
            [
                1,
                0.75
            ],
            [
                0.75,
                1
            ],
            [
                0.5,
                0.75
            ],
            [
                0.25,
                1
            ],
            [
                0,
                0.75
            ],
            [
                0.25,
                0.5
            ],
            [
                0,
                0.25
            ]
        ]);
    },
    diamond (params) {
        $d77b025aa58d633c$var$drawMarkerUnitPolygon(params, [
            [
                0.5,
                0
            ],
            [
                1,
                0.5
            ],
            [
                0.5,
                1
            ],
            [
                0,
                0.5
            ]
        ]);
    },
    heart ({ path: path, x: x, y: y, size: size }) {
        const r = size / 4;
        y = y + r / 2;
        path.arc(x - r, y - r, r, $d77b025aa58d633c$var$toRadians(130), $d77b025aa58d633c$var$toRadians(330));
        path.arc(x + r, y - r, r, $d77b025aa58d633c$var$toRadians(220), $d77b025aa58d633c$var$toRadians(50));
        path.lineTo(x, y + r);
        path.closePath();
    },
    pin ({ path: path, x: x, y: y, size: s }) {
        const cx = 0.5;
        const cy = 0.5;
        path.moveTo(x + (0.15625 - cx) * s, y + (0.34375 - cy) * s);
        path.cubicCurveTo(x + (0.15625 - cx) * s, y + (0.151491 - cy) * s, x + (0.307741 - cx) * s, y + (0 - cy) * s, x + (0.5 - cx) * s, y + (0 - cy) * s);
        path.cubicCurveTo(x + (0.692259 - cx) * s, y + (0 - cy) * s, x + (0.84375 - cx) * s, y + (0.151491 - cy) * s, x + (0.84375 - cx) * s, y + (0.34375 - cy) * s);
        path.cubicCurveTo(x + (0.84375 - cx) * s, y + (0.493824 - cy) * s, x + (0.784625 - cx) * s, y + (0.600181 - cy) * s, x + (0.716461 - cx) * s, y + (0.695393 - cy) * s);
        path.cubicCurveTo(x + (0.699009 - cx) * s, y + (0.719769 - cy) * s, x + (0.681271 - cx) * s, y + (0.743104 - cy) * s, x + (0.663785 - cx) * s, y + (0.766105 - cy) * s);
        path.cubicCurveTo(x + (0.611893 - cx) * s, y + (0.834367 - cy) * s, x + (0.562228 - cx) * s, y + (0.899699 - cy) * s, x + (0.528896 - cx) * s, y + (0.980648 - cy) * s);
        path.cubicCurveTo(x + (0.524075 - cx) * s, y + (0.992358 - cy) * s, x + (0.512663 - cx) * s, y + (1 - cy) * s, x + (0.5 - cx) * s, y + (1 - cy) * s);
        path.cubicCurveTo(x + (0.487337 - cx) * s, y + (1 - cy) * s, x + (0.475925 - cx) * s, y + (0.992358 - cy) * s, x + (0.471104 - cx) * s, y + (0.980648 - cy) * s);
        path.cubicCurveTo(x + (0.487337 - cx) * s, y + (1 - cy) * s, x + (0.475925 - cx) * s, y + (0.992358 - cy) * s, x + (0.471104 - cx) * s, y + (0.980648 - cy) * s);
        path.cubicCurveTo(x + (0.437772 - cx) * s, y + (0.899699 - cy) * s, x + (0.388107 - cx) * s, y + (0.834367 - cy) * s, x + (0.336215 - cx) * s, y + (0.766105 - cy) * s);
        path.cubicCurveTo(x + (0.318729 - cx) * s, y + (0.743104 - cy) * s, x + (0.300991 - cx) * s, y + (0.719769 - cy) * s, x + (0.283539 - cx) * s, y + (0.695393 - cy) * s);
        path.cubicCurveTo(x + (0.215375 - cx) * s, y + (0.600181 - cy) * s, x + (0.15625 - cx) * s, y + (0.493824 - cy) * s, x + (0.15625 - cx) * s, y + (0.34375 - cy) * s);
        path.closePath();
    },
    plus (params) {
        $d77b025aa58d633c$var$drawMarkerUnitPolygon(params, [
            [
                1 / 3,
                0
            ],
            [
                2 / 3,
                0
            ],
            [
                2 / 3,
                1 / 3
            ],
            [
                1,
                1 / 3
            ],
            [
                1,
                2 / 3
            ],
            [
                2 / 3,
                2 / 3
            ],
            [
                2 / 3,
                1
            ],
            [
                1 / 3,
                1
            ],
            [
                1 / 3,
                2 / 3
            ],
            [
                0,
                2 / 3
            ],
            [
                0,
                1 / 3
            ],
            [
                1 / 3,
                1 / 3
            ]
        ]);
    },
    square ({ path: path, x: x, y: y, size: size, pixelRatio: pixelRatio }) {
        const hs = size / 2;
        path.moveTo($d77b025aa58d633c$var$align(pixelRatio, x - hs), $d77b025aa58d633c$var$align(pixelRatio, y - hs));
        path.lineTo($d77b025aa58d633c$var$align(pixelRatio, x + hs), $d77b025aa58d633c$var$align(pixelRatio, y - hs));
        path.lineTo($d77b025aa58d633c$var$align(pixelRatio, x + hs), $d77b025aa58d633c$var$align(pixelRatio, y + hs));
        path.lineTo($d77b025aa58d633c$var$align(pixelRatio, x - hs), $d77b025aa58d633c$var$align(pixelRatio, y + hs));
        path.closePath();
    },
    star ({ path: path, x: x, y: y, size: size }) {
        const spikes = 5;
        const outerRadius = size / 2;
        const innerRadius = outerRadius / 2;
        const rotation = Math.PI / 2;
        for(let i = 0; i < spikes * 2; i++){
            const radius = i % 2 === 0 ? outerRadius : innerRadius;
            const angle2 = i * Math.PI / spikes - rotation;
            const xCoordinate = x + Math.cos(angle2) * radius;
            const yCoordinate = y + Math.sin(angle2) * radius;
            path.lineTo(xCoordinate, yCoordinate);
        }
        path.closePath();
    },
    triangle (params) {
        $d77b025aa58d633c$var$drawMarkerUnitPolygon(params, [
            [
                0.5,
                0
            ],
            [
                1,
                0.87
            ],
            [
                0,
                0.87
            ]
        ]);
    }
};
// packages/ag-charts-community/src/chart/marker/marker.ts
var $d77b025aa58d633c$var$InternalMarker = class extends $d77b025aa58d633c$var$Path {
    constructor(){
        super(...arguments);
        this.shape = "square";
        this.x = 0;
        this.y = 0;
        this.size = 12;
    }
    updatePath() {
        const { path: path, shape: shape, x: x, y: y, size: size } = this;
        const pixelRatio = this.layerManager?.canvas?.pixelRatio ?? 1;
        const anchor = $d77b025aa58d633c$var$Marker.anchor(shape);
        const drawParams = {
            path: path,
            x: x - (anchor.x - 0.5) * size,
            y: y - (anchor.y - 0.5) * size,
            size: size,
            pixelRatio: pixelRatio
        };
        path.clear();
        if (typeof shape === "string") $d77b025aa58d633c$var$MARKER_SHAPES[shape](drawParams);
        else if (typeof shape === "function") shape(drawParams);
    }
    computeBBox() {
        const { x: x, y: y, size: size } = this;
        const anchor = $d77b025aa58d633c$var$Marker.anchor(this.shape);
        return new $d77b025aa58d633c$var$BBox(x - size * anchor.x, y - size * anchor.y, size, size);
    }
    executeFill(ctx, path) {
        if (!path) return;
        return super.executeFill(ctx, path);
    }
    executeStroke(ctx, path) {
        if (!path) return;
        return super.executeStroke(ctx, path);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneObjectChangeDetection({
        equals: $d77b025aa58d633c$var$TRIPLE_EQ
    })
], $d77b025aa58d633c$var$InternalMarker.prototype, "shape", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$InternalMarker.prototype, "x", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$InternalMarker.prototype, "y", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        convertor: Math.abs
    })
], $d77b025aa58d633c$var$InternalMarker.prototype, "size", 2);
var $d77b025aa58d633c$var$Marker = class extends $d77b025aa58d633c$var$Rotatable($d77b025aa58d633c$var$Scalable($d77b025aa58d633c$var$Translatable($d77b025aa58d633c$var$InternalMarker))) {
    static anchor(shape) {
        if (shape === "pin") return {
            x: 0.5,
            y: 1
        };
        else if (typeof shape === "function" && "anchor" in shape) return shape.anchor;
        return {
            x: 0.5,
            y: 0.5
        };
    }
    constructor(options){
        super(options);
        if (options?.shape != null) this.shape = options.shape;
    }
};
// packages/ag-charts-community/src/chart/legend/legendSymbol.ts
function $d77b025aa58d633c$var$legendSymbolSvg(symbol, size, lineSize = size * (5 / 3)) {
    const group = new $d77b025aa58d633c$var$Group();
    const markerStrokeWidth = Math.min(symbol.marker.strokeWidth ?? 1, 2);
    const lineStrokeWidth = Math.min(symbol.line?.strokeWidth ?? 0, 2);
    const width2 = Math.max(symbol.marker.enabled === false ? 0 : size, symbol.line == null ? 0 : lineSize);
    const height2 = Math.max(symbol.marker.enabled === false ? 0 : size, lineStrokeWidth);
    if (symbol.line != null) {
        const { stroke: stroke2, strokeOpacity: strokeOpacity, lineDash: lineDash } = symbol.line;
        const line = new $d77b025aa58d633c$var$Line();
        line.x1 = 0;
        line.y1 = height2 / 2;
        line.x2 = width2;
        line.y2 = height2 / 2;
        line.stroke = stroke2;
        line.strokeOpacity = strokeOpacity;
        line.strokeWidth = lineStrokeWidth;
        line.lineDash = lineDash;
        group.append(line);
    }
    if (symbol.marker.enabled !== false) {
        const { shape: shape, fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = symbol.marker;
        const marker = new $d77b025aa58d633c$var$Marker();
        marker.shape = shape ?? "square";
        marker.size = size;
        marker.fill = fill;
        marker.fillOpacity = fillOpacity ?? 1;
        marker.stroke = stroke2;
        marker.strokeOpacity = strokeOpacity ?? 1;
        marker.strokeWidth = markerStrokeWidth;
        marker.lineDash = lineDash;
        marker.lineDashOffset = lineDashOffset ?? 0;
        const anchor = $d77b025aa58d633c$var$Marker.anchor(shape);
        const x = width2 / 2 + (anchor.x - 0.5) * size;
        const y = height2 / 2 + (anchor.y - 0.5) * size;
        const scale2 = size / (size + markerStrokeWidth);
        marker.x = x;
        marker.y = y;
        marker.scalingCenterX = x;
        marker.scalingCenterY = y;
        marker.scalingX = scale2;
        marker.scalingY = scale2;
        group.append(marker);
    }
    return $d77b025aa58d633c$var$Group.toSVG(group, width2, height2);
}
// packages/ag-charts-community/src/chart/tooltip/tooltipContent.ts
var $d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS = "ag-charts-tooltip";
var $d77b025aa58d633c$var$DEFAULT_TOOLTIP_DARK_CLASS = "ag-charts-tooltip--dark";
function $d77b025aa58d633c$var$aggregateTooltipContent(content) {
    const out = [];
    const groupedContents = /* @__PURE__ */ new Map();
    for (const item of content)if (item.type === "structured") {
        const { heading: heading } = item;
        const insertionTarget = heading != null ? groupedContents.get(heading) : void 0;
        const groupedItem = {
            type: "structured",
            heading: heading,
            items: [
                item
            ]
        };
        if (insertionTarget == null) {
            groupedContents.set(heading, groupedItem);
            out.push(groupedItem);
        } else insertionTarget.items.push(item);
    } else out.push(item);
    return out;
}
function $d77b025aa58d633c$var$tooltipContentAriaLabel(ungroupedContent) {
    const content = $d77b025aa58d633c$var$aggregateTooltipContent(ungroupedContent);
    const ariaLabel = [];
    content.forEach((c)=>{
        if (c.type === "raw") return "";
        if (c.heading != null) ariaLabel.push(c.heading);
        c.items.forEach((i)=>{
            if (i.title != null) ariaLabel.push(i.title);
            i.data?.forEach((datum)=>{
                ariaLabel.push(datum.label ?? datum.fallbackLabel, datum.value);
            });
        });
    });
    return ariaLabel.join("; ");
}
function $d77b025aa58d633c$var$dataHtml(label, value, inline) {
    let rowHtml = "";
    if (label == null) rowHtml += `<span class="${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-label">${$d77b025aa58d633c$var$sanitizeHtml(value)}</span>`;
    else {
        rowHtml += `<span class="${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-label">${$d77b025aa58d633c$var$sanitizeHtml(label)}</span>`;
        rowHtml += " ";
        rowHtml += `<span class="${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-value">${$d77b025aa58d633c$var$sanitizeHtml(value)}</span>`;
    }
    const rowClassNames = [
        `${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-row`
    ];
    if (inline) rowClassNames.push(`${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-row--inline`);
    rowHtml = `<div class="${rowClassNames.join(" ")}">${rowHtml}</div>`;
    return rowHtml;
}
function $d77b025aa58d633c$var$tooltipRowContentHtml(content) {
    let html = "";
    if (content.data?.length && content.data.every((datum)=>datum.value == null || datum.value === "")) return html;
    const dataInline = content.title == null && content.data?.length === 1;
    const symbol = content.symbol == null ? void 0 : $d77b025aa58d633c$var$legendSymbolSvg(content.symbol, 12);
    if (symbol != null && (content.title != null || content.data?.length)) html += `<span class="${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-symbol">${symbol}</span>`;
    if (content.title != null) {
        html += `<span class="${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-title">${$d77b025aa58d633c$var$sanitizeHtml(content.title)}</span>`;
        html += " ";
    }
    content.data?.forEach((datum)=>{
        html += $d77b025aa58d633c$var$dataHtml(datum.label ?? datum.fallbackLabel, datum.value, dataInline);
        html += " ";
    });
    return html;
}
function $d77b025aa58d633c$var$tooltipPaginationContentHtml(localeManager, pagination) {
    if (localeManager == null || pagination.length === 1) return;
    const text = localeManager?.t("tooltipPaginationStatus", {
        index: pagination.index + 1,
        count: pagination.length
    });
    return `<div class="${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-footer">${text}</div>`;
}
function $d77b025aa58d633c$var$tooltipContentHtml(localeManager, content, mode, pagination) {
    const singleItem = content.items.length === 1 ? content.items[0] : void 0;
    let compact;
    let compactTitle;
    let compactFallbackLabel;
    switch(mode){
        case "compact":
            compact = true;
            compactTitle = singleItem?.title;
            break;
        case "single":
            compact = singleItem != null && (content.heading == null || singleItem.title == null) && singleItem.data?.length === 1 && singleItem.data[0].label == null && singleItem.data[0].value != null;
            compactFallbackLabel = content.heading ?? singleItem?.title;
            break;
        case "shared":
            compact = false;
    }
    let html = "";
    if (compact && singleItem != null) {
        if (compactTitle != null) html += $d77b025aa58d633c$var$dataHtml(void 0, compactTitle, false);
        singleItem.data?.forEach((datum)=>{
            html += $d77b025aa58d633c$var$dataHtml(datum.label ?? compactFallbackLabel, datum.value, false);
            html += " ";
        });
    } else {
        if (content.heading != null) {
            html += `<span class="${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-heading">${$d77b025aa58d633c$var$sanitizeHtml(content.heading)}</span>`;
            html += " ";
        }
        content.items.forEach((item)=>{
            html += $d77b025aa58d633c$var$tooltipRowContentHtml(item);
        });
    }
    if (html.length === 0) return;
    const paginationContent = mode !== "compact" && pagination != null ? $d77b025aa58d633c$var$tooltipPaginationContentHtml(localeManager, pagination) : void 0;
    if (paginationContent + null) html += paginationContent;
    html = `<div class="${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-content">${html.trimEnd()}</div>`;
    return html;
}
function $d77b025aa58d633c$var$tooltipPaginationHtml(localeManager, pagination) {
    const paginationContent = pagination == null ? void 0 : $d77b025aa58d633c$var$tooltipPaginationContentHtml(localeManager, pagination);
    if (paginationContent == null) return "";
    return `<div class="${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-content">${paginationContent}</div>`;
}
function $d77b025aa58d633c$var$tooltipHtml(localeManager, content, mode, pagination) {
    const aggregatedContent = $d77b025aa58d633c$var$aggregateTooltipContent(content);
    if (aggregatedContent.length === 0) return;
    if (aggregatedContent.length === 1 && aggregatedContent[0].type === "structured") return $d77b025aa58d633c$var$tooltipContentHtml(localeManager, aggregatedContent[0], mode, pagination);
    else {
        const htmlRows = aggregatedContent.map((c)=>{
            return c.type === "structured" ? $d77b025aa58d633c$var$tooltipContentHtml(localeManager, c, mode) : c.rawHtmlString;
        });
        if (pagination != null) htmlRows.push($d77b025aa58d633c$var$tooltipPaginationHtml(localeManager, pagination) ?? "");
        return htmlRows.join("");
    }
}
// packages/ag-charts-community/src/chart/tooltip/tooltip.ts
var $d77b025aa58d633c$var$horizontalAlignments = {
    left: -1,
    "top-left": -1,
    "bottom-left": -1,
    top: 0,
    center: 0,
    bottom: 0,
    right: 1,
    "top-right": 1,
    "bottom-right": 1
};
var $d77b025aa58d633c$var$verticalAlignments = {
    "top-left": -1,
    top: -1,
    "top-right": -1,
    left: 0,
    center: 0,
    right: 0,
    "bottom-left": 1,
    bottom: 1,
    "bottom-right": 1
};
var $d77b025aa58d633c$var$arrowPositions = {
    left: 3 /* Right */ ,
    "top-left": void 0,
    "bottom-left": void 0,
    top: 2 /* Bottom */ ,
    center: void 0,
    bottom: 1 /* Top */ ,
    right: 0 /* Left */ ,
    "top-right": void 0,
    "bottom-right": void 0
};
var $d77b025aa58d633c$var$directionChecks = {
    top: 2 /* Vertical */ ,
    bottom: 2 /* Vertical */ ,
    left: 1 /* Horizontal */ ,
    right: 1 /* Horizontal */ ,
    "top-right": 3 /* Both */ ,
    "top-left": 3 /* Both */ ,
    "bottom-right": 3 /* Both */ ,
    "bottom-left": 3 /* Both */ ,
    center: 0 /* None */ 
};
var $d77b025aa58d633c$var$TooltipPosition = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        /** The horizontal offset in pixels for the position of the tooltip. */ this.xOffset = 0;
        /** The vertical offset in pixels for the position of the tooltip. */ this.yOffset = 0;
    }
    get defaultAnchorTo() {
        const { type: type, _seriesOverrideType: _seriesOverrideType } = this;
        const defaultType = type ?? _seriesOverrideType ?? "pointer";
        if (defaultType === "node" || defaultType === "pointer") return defaultType;
        else return "chart";
    }
    get defaultPlacement() {
        const { type: type, _seriesOverrideType: _seriesOverrideType } = this;
        const defaultType = type ?? _seriesOverrideType ?? "pointer";
        if (defaultType === "node" || defaultType === "pointer") return "top";
        return defaultType;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$Deprecated("Use `anchorTo` and/or `placement` options instead.")
], $d77b025aa58d633c$var$TooltipPosition.prototype, "type", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$TooltipPosition.prototype, "_seriesOverrideType", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$TooltipPosition.prototype, "xOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$TooltipPosition.prototype, "yOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$TooltipPosition.prototype, "anchorTo", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$TooltipPosition.prototype, "placement", 2);
var $d77b025aa58d633c$var$Tooltip = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super();
        this.enabled = true;
        this.mode = "single";
        this.delay = 0;
        this.range = void 0;
        this.wrapping = "hyphenate";
        this.position = new $d77b025aa58d633c$var$TooltipPosition();
        this.pagination = false;
        this.darkTheme = false;
        this.bounds = "extended";
        this.destroyFns = [];
        this.springAnimation = new $d77b025aa58d633c$var$SpringAnimation();
        this.enableInteraction = false;
        this.wrapTypes = [
            "always",
            "hyphenate",
            "on-space",
            "never"
        ];
        this.sizeMonitor = new $d77b025aa58d633c$var$SizeMonitor();
        // Reading the element size is expensive, so cache the result
        this._elementSize = void 0;
        this._showTimeout = void 0;
        this.arrowPosition = void 0;
        this._visible = false;
        this.positionParams = void 0;
        this.localeManager = void 0;
        this.destroyFns.push(this.springAnimation.addListener("update", this.updateTooltipPosition.bind(this)));
    }
    get interactive() {
        return this.enableInteraction;
    }
    setup(localeManager, domManager) {
        if ("togglePopover" in (0, $idDdm.getWindow)().HTMLElement.prototype) {
            this.element = domManager.addChild("tooltip-container", $d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS);
            this.element.setAttribute("popover", "manual");
            this.element.className = $d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS;
            this.element.style.positionAnchor = domManager.anchorName;
            this.sizeMonitor.observe(this.element, (size)=>{
                this._elementSize = size;
                this.updateTooltipPosition();
            });
        }
        this.localeManager = localeManager;
        return ()=>{
            domManager.removeChild("tooltip-container", $d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS);
            this.destroyFns.forEach((f)=>f());
            if (this.element) this.sizeMonitor.unobserve(this.element);
        };
    }
    isVisible() {
        return this._visible;
    }
    contains(node) {
        return this.element?.contains(node) ?? false;
    }
    updateTooltipPosition() {
        const { element: element2, _elementSize: elementSize, positionParams: positionParams } = this;
        if (element2 == null || elementSize == null || positionParams == null) return;
        const { canvasRect: canvasRect, relativeRect: relativeRect, meta: meta } = positionParams;
        const { x: canvasX, y: canvasY } = this.springAnimation;
        let placements2 = meta.position?.placement ?? this.position.placement ?? meta.position?.defaultPlacement ?? this.position.defaultPlacement;
        if (!Array.isArray(placements2)) placements2 = [
            placements2
        ];
        const anchorTo = meta.position?.anchorTo ?? this.position.anchorTo ?? meta.position?.defaultAnchorTo ?? this.position.defaultAnchorTo;
        const xOffset = meta.position?.xOffset ?? 0;
        const yOffset = meta.position?.yOffset ?? 0;
        const minX = relativeRect.x;
        const minY = relativeRect.y;
        const maxX = relativeRect.width - elementSize.width - 1 + minX;
        const maxY = relativeRect.height - elementSize.height + minY;
        let i = 0;
        let placement;
        let position;
        let constrained = false;
        do {
            placement = placements2[i];
            i += 1;
            const tooltipBounds = this.getTooltipBounds({
                elementSize: elementSize,
                placement: placement,
                anchorTo: anchorTo,
                canvasX: canvasX,
                canvasY: canvasY,
                yOffset: yOffset,
                xOffset: xOffset,
                canvasRect: canvasRect
            });
            position = $d77b025aa58d633c$var$calculatePlacement(elementSize.width, elementSize.height, relativeRect, tooltipBounds);
            constrained = false;
            if ($d77b025aa58d633c$var$directionChecks[placement] & 1 /* Horizontal */ ) constrained || (constrained = position.x < minX || position.x > maxX);
            if ($d77b025aa58d633c$var$directionChecks[placement] & 2 /* Vertical */ ) constrained || (constrained = position.y < minY || position.y > maxY);
        }while (i < placements2.length && constrained);
        const left = (0, $idDdm.clamp)(minX, position.x, maxX);
        const top = (0, $idDdm.clamp)(minY, position.y, maxY);
        constrained || (constrained = left !== position.x || top !== position.y);
        const defaultShowArrow = anchorTo !== "chart" && !constrained && !xOffset && !yOffset;
        const showArrow = meta.showArrow ?? this.showArrow ?? defaultShowArrow;
        this.arrowPosition = showArrow ? $d77b025aa58d633c$var$arrowPositions[placement] : void 0;
        this.updateClassModifiers();
        element2.style.translate = `${left}px ${top}px`;
    }
    /**
   * Shows tooltip at the given event's coordinates.
   * If the `html` parameter is missing, moves the existing tooltip to the new position.
   */ show(boundingRect, canvasRect, meta, content, pagination, instantly = false) {
        const { element: element2 } = this;
        if (element2 != null && content != null && content.length !== 0) {
            const html = $d77b025aa58d633c$var$tooltipHtml(this.localeManager, content, this.mode, this.pagination ? pagination : void 0);
            if (html == null) {
                this.toggle(false);
                return;
            }
            element2.innerHTML = html;
        } else if (element2 == null || element2.innerHTML === "") {
            this.toggle(false);
            return;
        }
        const relativeRect = {
            x: boundingRect.x - canvasRect.x,
            y: boundingRect.y - canvasRect.y,
            width: boundingRect.width,
            height: boundingRect.height
        };
        this.positionParams = {
            canvasRect: canvasRect,
            relativeRect: relativeRect,
            meta: meta
        };
        const anchorTo = meta.position?.anchorTo ?? this.position.anchorTo ?? meta.position?.defaultAnchorTo ?? this.position.defaultAnchorTo;
        switch(anchorTo){
            case "node":
                this.springAnimation.update(meta.nodeCanvasX ?? meta.canvasX, meta.nodeCanvasY ?? meta.canvasY);
                break;
            case "pointer":
                this.springAnimation.update(meta.canvasX, meta.canvasY);
                break;
            case "chart":
                this.springAnimation.reset();
        }
        if (meta.enableInteraction) {
            this.enableInteraction = true;
            element2.style.pointerEvents = "auto";
            element2.removeAttribute("aria-hidden");
            element2.tabIndex = -1;
        } else {
            this.enableInteraction = false;
            element2.style.pointerEvents = "none";
            element2.setAttribute("aria-hidden", "true");
            element2.removeAttribute("tabindex");
        }
        element2.style.setProperty("--top", `${canvasRect.top}px`);
        element2.style.setProperty("--left", `${canvasRect.left}px`);
        this.updateClassModifiers();
        this.toggle(true, instantly);
    }
    hide() {
        this.toggle(false);
    }
    toggle(visible, instantly = false) {
        const { delay: delay } = this;
        if (visible && delay > 0 && !instantly) this._showTimeout ?? (this._showTimeout = setTimeout(()=>{
            this._showTimeout = void 0;
            this.toggleCallback(true);
        }, delay));
        else {
            clearTimeout(this._showTimeout);
            this._showTimeout = void 0;
            this.toggleCallback(visible);
        }
    }
    toggleCallback(visible) {
        if (!this.element?.isConnected) return;
        if (this._visible === visible) return;
        this._visible = visible;
        this.element.togglePopover(visible);
        if (visible) this.updateTooltipPosition();
        else this.springAnimation.reset();
    }
    updateClassModifiers() {
        if (!this.element?.isConnected) return;
        const { classList: classList } = this.element;
        const toggleClass = (name, include)=>classList.toggle(`${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}--${name}`, include);
        toggleClass("no-interaction", !this.enableInteraction);
        toggleClass("arrow-top", this.arrowPosition === 1 /* Top */ );
        toggleClass("arrow-right", this.arrowPosition === 3 /* Right */ );
        toggleClass("arrow-bottom", this.arrowPosition === 2 /* Bottom */ );
        toggleClass("arrow-left", this.arrowPosition === 0 /* Left */ );
        toggleClass("compact", this.mode === "compact");
        classList.toggle($d77b025aa58d633c$var$DEFAULT_TOOLTIP_DARK_CLASS, this.darkTheme);
        for (const wrapType of this.wrapTypes)classList.toggle(`${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}--wrap-${wrapType}`, wrapType === this.wrapping);
    }
    getTooltipBounds(opts) {
        const { elementSize: elementSize, anchorTo: anchorTo, placement: placement, canvasX: canvasX, canvasY: canvasY, yOffset: yOffset, xOffset: xOffset, canvasRect: canvasRect } = opts;
        const { width: tooltipWidth, height: tooltipHeight } = elementSize;
        const bounds = {
            width: tooltipWidth,
            height: tooltipHeight
        };
        if (anchorTo === "node" || anchorTo === "pointer") {
            const horizontalAlignment = $d77b025aa58d633c$var$horizontalAlignments[placement];
            const verticalAlignment = $d77b025aa58d633c$var$verticalAlignments[placement];
            bounds.top = canvasY + yOffset + tooltipHeight * (verticalAlignment - 1) / 2 + 8 * verticalAlignment;
            bounds.left = canvasX + xOffset + tooltipWidth * (horizontalAlignment - 1) / 2 + 8 * horizontalAlignment;
            return bounds;
        }
        switch(placement){
            case "top":
                bounds.top = yOffset;
                bounds.left = canvasRect.width / 2 - tooltipWidth / 2 + xOffset;
                return bounds;
            case "right":
                bounds.top = canvasRect.height / 2 - tooltipHeight / 2 + yOffset;
                bounds.left = canvasRect.width - tooltipWidth / 2 + xOffset;
                return bounds;
            case "left":
                bounds.top = canvasRect.height / 2 - tooltipHeight / 2 + yOffset;
                bounds.left = xOffset;
                return bounds;
            case "bottom":
                bounds.top = canvasRect.height - tooltipHeight + yOffset;
                bounds.left = canvasRect.width / 2 - tooltipWidth / 2 + xOffset;
                return bounds;
            case "top-left":
                bounds.top = yOffset;
                bounds.left = xOffset;
                return bounds;
            case "top-right":
                bounds.top = yOffset;
                bounds.left = canvasRect.width - tooltipWidth + xOffset;
                return bounds;
            case "bottom-right":
                bounds.top = canvasRect.height - tooltipHeight + yOffset;
                bounds.left = canvasRect.width - tooltipWidth + xOffset;
                return bounds;
            case "bottom-left":
                bounds.top = canvasRect.height - tooltipHeight + yOffset;
                bounds.left = xOffset;
                return bounds;
        }
        return bounds;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Tooltip.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Tooltip.prototype, "mode", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Tooltip.prototype, "showArrow", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Tooltip.prototype, "delay", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Tooltip.prototype, "range", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Tooltip.prototype, "wrapping", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Tooltip.prototype, "position", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Tooltip.prototype, "pagination", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Tooltip.prototype, "darkTheme", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Tooltip.prototype, "bounds", 2);
// packages/ag-charts-community/src/chart/series/seriesAreaManager.ts
function $d77b025aa58d633c$var$pickedNodesEqual(a, b) {
    return a.series === b.series && $d77b025aa58d633c$var$objectsEqual(a.datumIndex, b.datumIndex);
}
var $d77b025aa58d633c$var$PickedNodeState = class {
    constructor(){
        this.candidates = [];
    }
    get current() {
        return this.active;
    }
    reset() {
        this.candidates.length = 0;
        this.active = void 0;
    }
    update(nextCandidates, previousActive) {
        this.candidates = nextCandidates;
        let nextIndex = previousActive != null ? nextCandidates.findIndex((c)=>$d77b025aa58d633c$var$pickedNodesEqual(c, previousActive)) : -1;
        if (nextIndex === -1) nextIndex = 0;
        this.active = nextCandidates[nextIndex];
        return {
            current: this.active,
            index: nextIndex,
            length: nextCandidates.length
        };
    }
    next() {
        const { candidates: candidates, active: active } = this;
        const hoverIndex = active == null ? -1 : candidates.findIndex((c)=>$d77b025aa58d633c$var$pickedNodesEqual(c, active));
        if (hoverIndex === -1) return void 0;
        let nextIndex = hoverIndex + 1;
        if (nextIndex >= candidates.length) nextIndex = 0;
        this.active = candidates[nextIndex];
        return {
            current: this.active,
            index: nextIndex,
            length: this.candidates.length
        };
    }
};
var $d77b025aa58d633c$var$SeriesAreaManager = class extends $d77b025aa58d633c$var$BaseManager {
    constructor(chart){
        super();
        this.chart = chart;
        this.id = (0, $idDdm.createId)(this);
        this.series = [];
        this.highlight = {
            /** Last received event that still needs to be applied. */ pendingHoverEvent: void 0,
            /** Last applied event. */ appliedHoverEvent: void 0,
            /** Last applied event, which has been temporarily stashed during the main chart update cycle. */ stashedHoverEvent: void 0
        };
        this.tooltip = {
            lastHover: void 0
        };
        /**
     * A11y Requirements for Tooltip/Highlight (see AG-13051 for details):
     *
     *   -   When the series-area is blurred, always the mouse to update the tooltip/highlight.
     *
     *   -   When the series-area receives a `focus` event, use `:focus-visible` to guess the input device.
     *       (this is decided by the browser).
     *
     *   -   For keyboard users, `focus` and `keydown` events always updates & shows the tooltip/highlight on
     *       the currently (or newly) focused datum.
     *
     *   -   For keyboard users, `mousemove` events update the tooltip/highlight iff `pickNode` finds a match
     *       for the mouse event offsets.
     */ this.hoverDevice = "pointer";
        /**
     * This is the "second last" input event. It can be useful for keydown
     * events that for which don't to set the isFocusVisible state
     * (e.g. Backspace/Delete key on FC annotations, see AG-13041).
     *
     * Use with caution! The focus indicator must ALWAYS be visible for
     * keyboard-only users.
     */ this.previousInputDevice = "keyboard";
        this.focus = {
            sortedSeries: [],
            series: void 0,
            seriesIndex: 0,
            datumIndex: 0,
            datum: void 0
        };
        this.hoverScheduler = $d77b025aa58d633c$var$debouncedAnimationFrame(()=>{
            if (!this.tooltip.lastHover && !this.highlight.pendingHoverEvent) return;
            if (this.chart.getUpdateType() <= 5 /* SERIES_UPDATE */ ) {
                this.hoverScheduler.schedule();
                return;
            }
            if (this.highlight.pendingHoverEvent) this.handleHoverHighlight(false);
            if (this.tooltip.lastHover) this.handleHoverTooltip(this.tooltip.lastHover, false);
        });
        this.tooltipCandidates = new $d77b025aa58d633c$var$PickedNodeState();
        const label1 = chart.ctx.domManager.addChild("series-area", "series-area-aria-label1");
        const label2 = chart.ctx.domManager.addChild("series-area", "series-area-aria-label2");
        this.swapChain = new $d77b025aa58d633c$var$FocusSwapChain(label1, label2, "img");
        this.swapChain.addListener("blur", (event)=>this.onBlur(event));
        this.swapChain.addListener("focus", ()=>this.onFocus());
        if (chart.ctx.domManager.mode === "normal") {
            this.focusIndicator = new $d77b025aa58d633c$var$FocusIndicator(this.swapChain);
            this.focusIndicator.overrideFocusVisible(chart.mode === "integrated" ? false : void 0);
        }
        const { seriesDragInterpreter: seriesDragInterpreter, seriesWidget: seriesWidget, containerWidget: containerWidget } = chart.ctx.widgets;
        seriesWidget.setTabIndex(-1);
        this.destroyFns.push(()=>chart.ctx.domManager.removeChild("series-area", "series-area-aria-label1"), ()=>chart.ctx.domManager.removeChild("series-area", "series-area-aria-label2"), seriesWidget.addListener("focus", ()=>this.swapChain.focus()), seriesWidget.addListener("mousemove", (event)=>this.onHover(event)), seriesWidget.addListener("wheel", (event)=>this.onWheel(event)), seriesWidget.addListener("mouseleave", (event)=>this.onLeave(event)), seriesWidget.addListener("keydown", (event)=>this.onKeyDown(event)), seriesWidget.addListener("contextmenu", (event, current)=>this.onContextMenu(event, current)), seriesDragInterpreter.addListener("drag-move", (event)=>this.onDragMove(event)), seriesDragInterpreter.addListener("click", (event)=>this.onClick(event, seriesWidget)), seriesDragInterpreter.addListener("dblclick", (event)=>this.onClick(event, seriesWidget)), containerWidget.addListener("contextmenu", (event, current)=>this.onContextMenu(event, current)), containerWidget.addListener("click", (event, current)=>this.onClick(event, current)), containerWidget.addListener("dblclick", (event, current)=>this.onClick(event, current)), chart.ctx.animationManager.addListener("animation-start", ()=>this.clearAll()), chart.ctx.domManager.addListener("resize", ()=>this.clearAll()), chart.ctx.highlightManager.addListener("highlight-change", (event)=>this.changeHighlightDatum(event)), chart.ctx.layoutManager.addListener("layout:complete", (event)=>this.layoutComplete(event)), chart.ctx.updateService.addListener("pre-scene-render", ()=>this.preSceneRender()), chart.ctx.updateService.addListener("update-complete", ()=>this.updateComplete()), chart.ctx.zoomManager.addListener("zoom-change", ()=>this.clearAll()), chart.ctx.zoomManager.addListener("zoom-pan-start", ()=>this.clearAll()));
    }
    get bbox() {
        return (this.seriesRect ?? $d77b025aa58d633c$var$BBox.zero).clone();
    }
    isState(allowedStates) {
        return this.chart.ctx.interactionManager.isState(allowedStates);
    }
    isIgnoredTouch(event) {
        if (event.device !== "touch" || event.type === "click") return false;
        if (this.chart.ctx.chartService.touch.dragAction === "hover") return false;
        if (this.chart.ctx.chartService.touch.dragAction === "drag") {
            if (this.isState(9 /* AnnotationsMoveable */ )) return false;
        }
        return true;
    }
    dataChanged() {
        var _a;
        (_a = this.highlight).stashedHoverEvent ?? (_a.stashedHoverEvent = this.highlight.appliedHoverEvent);
        this.chart.ctx.tooltipManager.removeTooltip(this.id);
        this.focusIndicator?.clear();
        this.clearHighlight();
    }
    preSceneRender() {
        if (this.highlight.stashedHoverEvent != null) {
            this.highlight.pendingHoverEvent = this.highlight.stashedHoverEvent;
            this.highlight.stashedHoverEvent = void 0;
            this.handleHoverHighlight(true);
        }
        if (this.tooltip.lastHover != null) this.handleHoverTooltip(this.tooltip.lastHover, true);
    }
    updateComplete() {
        if (this.isState(34 /* Focusable */ ) && this.focusIndicator?.isFocusVisible()) this.handleSeriesFocus(0, 0, true);
    }
    update(type, opts) {
        this.chart.ctx.updateService.update(type, opts);
    }
    seriesChanged(series) {
        this.focus.sortedSeries = [
            ...series
        ].sort((a, b)=>{
            let fpA = a.properties.focusPriority ?? Infinity;
            let fpB = b.properties.focusPriority ?? Infinity;
            if (fpA === fpB) [fpA, fpB] = [
                a._declarationOrder,
                b._declarationOrder
            ];
            if (fpA < fpB) return -1;
            else if (fpA > fpB) return 1;
            return 0;
        });
        this.series = series;
    }
    layoutComplete(event) {
        this.seriesRect = event.series.rect;
        this.hoverRect = event.series.paddedRect;
        this.chart.ctx.widgets.seriesWidget.setBounds(event.series.paddedRect);
        if (this.chart.ctx.domManager.mode === "normal") this.chart.ctx.widgets.chartWidget.setBounds(event.chart);
    }
    onContextMenu(event, current) {
        const { sourceEvent: sourceEvent } = event;
        if (sourceEvent.currentTarget != current.getElement()) return;
        if (sourceEvent.target == this.chart.ctx.widgets.containerWidget.getElement()) {
            if (this.isState(36 /* ContextMenuable */ )) {
                const { currentX: canvasX2, currentY: canvasY2 } = event;
                this.chart.ctx.contextMenuRegistry.dispatchContext("always", {
                    widgetEvent: event,
                    canvasX: canvasX2,
                    canvasY: canvasY2
                }, void 0);
            }
            return;
        }
        let pickedNode;
        let position;
        if (this.focusIndicator?.isFocusVisible()) {
            pickedNode = this.chart.ctx.highlightManager.getActiveHighlight();
            if (pickedNode && this.seriesRect && pickedNode.midPoint) position = $d77b025aa58d633c$var$Transformable.toCanvasPoint(pickedNode.series.contentGroup, pickedNode.midPoint.x, pickedNode.midPoint.y);
        } else if (this.isState(36 /* ContextMenuable */ )) {
            const pick = this.pickNodes({
                x: event.currentX,
                y: event.currentY
            }, "context-menu");
            if (pick) {
                this.chart.ctx.highlightManager.updateHighlight(this.id);
                pickedNode = pick.matches[0].datum;
            }
        }
        const pickedSeries = pickedNode?.series;
        this.clearAll();
        const canvasX = event.currentX + current.cssLeft();
        const canvasY = event.currentY + current.cssTop();
        if (pickedSeries && pickedNode) this.chart.ctx.contextMenuRegistry.dispatchContext("series-node", {
            widgetEvent: event,
            canvasX: canvasX,
            canvasY: canvasY
        }, {
            pickedSeries: pickedSeries,
            pickedNode: pickedNode
        }, position);
        else this.chart.ctx.contextMenuRegistry.dispatchContext("series-area", {
            widgetEvent: event,
            canvasX: canvasX,
            canvasY: canvasY
        }, void 0, position);
    }
    onLeave(event) {
        if (!this.isState(41 /* Clickable */ )) return;
        const relatedTarget = event.sourceEvent.relatedTarget;
        if (relatedTarget?.className === "ag-charts-text-input__textarea") return;
        if (this.chart.ctx.tooltipManager.isEnteringInteractiveTooltip(event.sourceEvent)) return;
        this.chart.ctx.domManager.updateCursor(this.id);
        if (this.hoverDevice !== "keyboard") this.clearAll();
    }
    onWheel(_event) {
        if (!this.isState(41 /* Clickable */ )) return;
        this.focusIndicator?.overrideFocusVisible(false);
        this.previousInputDevice = "pointer";
    }
    onDragMove(event) {
        if (!this.isState(41 /* Clickable */ )) return;
        this.focusIndicator?.overrideFocusVisible(false);
        this.onHoverLikeEvent(event);
    }
    onHover(event) {
        if (!this.isState(41 /* Clickable */ )) return;
        this.onHoverLikeEvent(event);
    }
    onHoverLikeEvent(event) {
        if (this.isIgnoredTouch(event)) return;
        if (event.device === "touch" || $d77b025aa58d633c$var$excludesType(event, "drag-move")) this.tooltip.lastHover = event;
        if (event.device === "touch" && this.chart.ctx.chartService.touch.dragAction === "hover") event.sourceEvent.preventDefault();
        this.hoverDevice = "pointer";
        this.previousInputDevice = "pointer";
        this.highlight.pendingHoverEvent = event;
        this.hoverScheduler.schedule();
        if (this.isState(32 /* Default */ )) {
            const { currentX: x, currentY: y } = event;
            const matches = this.pickNodes({
                x: x,
                y: y
            }, "event")?.matches;
            const found = matches?.[0];
            if (found?.series.hasEventListener("seriesNodeClick") || found?.series.hasEventListener("seriesNodeDoubleClick") || matches != null && matches.length > 1 && this.chart.tooltip.pagination) this.chart.ctx.domManager.updateCursor(this.id, "pointer");
            else this.chart.ctx.domManager.updateCursor(this.id);
        }
    }
    onClick(event, current) {
        if (current === this.chart.ctx.widgets.seriesWidget && this.chart.ctx.animationManager.isActive()) this.chart.ctx.animationManager.skipCurrentBatch();
        if (event.device === "touch" && current === this.chart.ctx.widgets.seriesWidget) this.swapChain.focus({
            preventScroll: true
        });
        if (!this.isState(41 /* Clickable */ )) return;
        if (current === this.chart.ctx.widgets.seriesWidget) {
            if (!current.getElement().contains(event.sourceEvent.target)) return;
        } else if (event.sourceEvent.target != current.getElement()) return;
        this.focusIndicator?.overrideFocusVisible(false);
        this.onHoverLikeEvent(event);
        if (!this.isState(32 /* Default */ )) return;
        if (current == this.chart.ctx.widgets.seriesWidget && this.checkSeriesNodeClick(event)) {
            this.update(5 /* SERIES_UPDATE */ );
            event.sourceEvent.preventDefault();
            return;
        }
        const newEvent = {
            type: event.type === "click" ? "click" : "doubleClick",
            event: event.sourceEvent
        };
        this.chart.fireEvent(newEvent);
    }
    onFocus() {
        if (!this.isState(34 /* Focusable */ )) return;
        this.hoverDevice = this.focusIndicator?.isFocusVisible(true) ? "keyboard" : "pointer";
        this.handleFocus(0, 0);
    }
    onBlur(event) {
        if (!this.isState(34 /* Focusable */ )) return;
        this.hoverDevice = "pointer";
        if (!this.chart.ctx.tooltipManager.isEnteringInteractiveTooltip(event)) this.clearAll();
        this.focusIndicator?.overrideFocusVisible(void 0);
    }
    onKeyDown(widgetEvent) {
        if (!this.isState(43 /* Keyable */ )) return;
        const action = $d77b025aa58d633c$var$mapKeyboardEventToAction(widgetEvent.sourceEvent);
        if (action?.activatesFocusIndicator === false) this.focusIndicator?.overrideFocusVisible(this.previousInputDevice === "keyboard");
        switch(action?.name){
            case "redo":
                return this.chart.ctx.chartEventManager.seriesEvent("series-redo");
            case "undo":
                return this.chart.ctx.chartEventManager.seriesEvent("series-undo");
            case "zoomin":
                return this.chart.ctx.chartEventManager.seriesKeyNavZoom(1, widgetEvent);
            case "zoomout":
                return this.chart.ctx.chartEventManager.seriesKeyNavZoom(-1, widgetEvent);
            case "arrowup":
                return this.onArrow(-1, 0, widgetEvent);
            case "arrowdown":
                return this.onArrow(1, 0, widgetEvent);
            case "arrowleft":
                return this.onArrow(0, -1, widgetEvent);
            case "arrowright":
                return this.onArrow(0, 1, widgetEvent);
            case "submit":
                return this.onSubmit(widgetEvent);
        }
    }
    onArrow(seriesIndexDelta, datumIndexDelta, event) {
        if (!this.isState(34 /* Focusable */ )) return;
        this.hoverDevice = "keyboard";
        this.previousInputDevice = "keyboard";
        this.focusIndicator?.overrideFocusVisible(true);
        this.focus.seriesIndex += seriesIndexDelta;
        this.focus.datumIndex += datumIndexDelta;
        this.handleFocus(seriesIndexDelta, datumIndexDelta);
        event.sourceEvent.preventDefault();
        this.chart.ctx.chartEventManager.seriesEvent("series-focus-change");
    }
    onSubmit(event) {
        if (!this.isState(34 /* Focusable */ )) return;
        const { series: series, datum: datum } = this.focus;
        const sourceEvent = event.sourceEvent;
        if (series !== void 0 && datum !== void 0) series.fireNodeClickEvent(sourceEvent, datum);
        else this.chart.fireEvent({
            type: "click",
            event: sourceEvent
        });
        sourceEvent.preventDefault();
    }
    checkSeriesNodeClick(event) {
        var _a;
        const result = this.pickNodes({
            x: event.currentX,
            y: event.currentY
        }, "event");
        if (result == null || result.matches.length === 0) return;
        const paginationUpdate = this.chart.tooltip.pagination ? this.tooltipCandidates.update(result.matches, this.tooltipCandidates.current)?.current : void 0;
        const { series: series, datum: datum } = paginationUpdate ?? result.matches[0];
        const distance2 = paginationUpdate == null ? result.distance : 0;
        if (event.type === "click") {
            const defaultBehavior = series.fireNodeClickEvent(event.sourceEvent, datum);
            const nextTooltipCandidate = defaultBehavior && this.chart.tooltip.pagination ? this.tooltipCandidates.next() : void 0;
            if (nextTooltipCandidate != null) {
                event.sourceEvent.preventDefault();
                const { currentX: currentX, currentY: currentY } = event;
                const canvasX = currentX + (this.hoverRect?.x ?? 0);
                const canvasY = currentY + (this.hoverRect?.y ?? 0);
                (_a = this.highlight).pendingHoverEvent ?? (_a.pendingHoverEvent = this.highlight.appliedHoverEvent);
                this.handleHoverHighlight(false);
                this.showTooltip(nextTooltipCandidate.current, canvasX, canvasY, {
                    index: nextTooltipCandidate.index,
                    length: nextTooltipCandidate.length
                });
            }
            return true;
        }
        if (event.type === "dblclick") {
            event.preventZoomDblClick = distance2 === 0;
            series.fireNodeDoubleClickEvent(event.sourceEvent, datum);
            return true;
        }
        return false;
    }
    handleFocus(seriesIndexDelta, datumIndexDelta) {
        const overlayFocus = this.chart.overlays.getFocusInfo(this.chart.ctx.localeManager);
        if (overlayFocus == null) this.handleSeriesFocus(seriesIndexDelta, datumIndexDelta);
        else this.focusIndicator?.update(overlayFocus.rect, this.seriesRect, false);
    }
    handleSeriesFocus(otherIndexDelta, datumIndexDelta, refresh = false) {
        if (this.chart.chartType === "hierarchy" || this.chart.chartType === "gauge") {
            this.handleSoloSeriesFocus(otherIndexDelta, datumIndexDelta, refresh);
            return;
        }
        const { focus: focus } = this;
        const visibleSeries = focus.sortedSeries.filter((s)=>s.visible && s.focusable);
        if (visibleSeries.length === 0) return;
        const oldDatumIndex = focus.datumIndex - datumIndexDelta;
        const oldOtherIndex = focus.seriesIndex - otherIndexDelta;
        focus.seriesIndex = (0, $idDdm.clamp)(0, focus.seriesIndex, visibleSeries.length - 1);
        focus.series = visibleSeries[focus.seriesIndex];
        const datumIndex = this.focus.datumIndex;
        const otherIndex = this.focus.seriesIndex;
        this.updatePickedFocus(datumIndex, datumIndexDelta, oldDatumIndex, otherIndex, otherIndexDelta, oldOtherIndex, refresh);
    }
    handleSoloSeriesFocus(otherIndexDelta, datumIndexDelta, refresh) {
        this.focus.series = this.focus.sortedSeries[0];
        const datumIndex = this.focus.datumIndex;
        const otherIndex = this.focus.seriesIndex;
        const oldDatumIndex = this.focus.datumIndex - datumIndexDelta;
        const oldOtherIndex = this.focus.seriesIndex - otherIndexDelta;
        this.updatePickedFocus(datumIndex, datumIndexDelta, oldDatumIndex, otherIndex, otherIndexDelta, oldOtherIndex, refresh);
    }
    updatePickedFocus(datumIndex, datumIndexDelta, oldDatumIndex, otherIndex, otherIndexDelta, oldOtherIndex, refresh) {
        const { focus: focus, hoverRect: hoverRect, seriesRect: seriesRect } = this;
        if (focus.series === void 0 || hoverRect === void 0) return;
        const pick = focus?.series?.pickFocus({
            datumIndex: datumIndex,
            datumIndexDelta: datumIndexDelta,
            otherIndex: otherIndex,
            otherIndexDelta: otherIndexDelta,
            seriesRect: seriesRect
        });
        if (!pick) return;
        const { datum: datum } = pick;
        if (pick.otherIndex !== void 0) focus.seriesIndex = pick.otherIndex;
        focus.datumIndex = pick.datumIndex;
        focus.datum = datum;
        if (this.focusIndicator?.isFocusVisible()) this.chart.ctx.animationManager.reset();
        if (this.focusIndicator?.isFocusVisible()) {
            const focusBBox = $d77b025aa58d633c$var$getPickedFocusBBox(pick);
            const { x: x, y: y } = focusBBox.computeCenter();
            if (!hoverRect.containsPoint(x, y)) {
                const panSuccess = this.chart.ctx.zoomManager.panToBBox(this.id, hoverRect, focusBBox);
                if (panSuccess) return;
            }
            const { x1: x1, x2: x2, y1: y1, y2: y2 } = $d77b025aa58d633c$var$Vec4.from(focusBBox);
            const nw = hoverRect.containsPoint(x1, y1);
            const ne = hoverRect.containsPoint(x2, y1);
            const sw = hoverRect.containsPoint(x1, y2);
            const se = hoverRect.containsPoint(x2, y2);
            if (!(nw || ne || sw || se)) {
                const hoverBounds = $d77b025aa58d633c$var$Vec4.from(hoverRect);
                pick.movedBounds = focusBBox.clone();
                if (x1 < hoverBounds.x1 && x2 < hoverBounds.x1) {
                    pick.movedBounds.x = hoverBounds.x1 - 2;
                    pick.movedBounds.width = 4;
                } else if (x1 > hoverBounds.x2 && x2 > hoverBounds.x2) {
                    pick.movedBounds.x = hoverBounds.x2 - 2;
                    pick.movedBounds.width = 4;
                }
                if (y1 < hoverBounds.y1 && y2 < hoverBounds.y1) {
                    pick.movedBounds.y = hoverBounds.y1 - 2;
                    pick.movedBounds.height = 4;
                } else if (y1 > hoverBounds.y2 && y2 > hoverBounds.y2) {
                    pick.movedBounds.y = hoverBounds.y2 - 2;
                    pick.movedBounds.height = 4;
                }
            }
        }
        this.focusIndicator?.update(pick.movedBounds ?? pick.bounds, this.seriesRect, pick.clipFocusBox);
        const keyboardEvent = $d77b025aa58d633c$var$makeKeyboardPointerEvent(focus.series, hoverRect, pick);
        if (keyboardEvent !== void 0 && this.hoverDevice === "keyboard") {
            this.tooltip.lastHover = void 0;
            this.highlight.appliedHoverEvent = void 0;
            this.highlight.pendingHoverEvent = void 0;
            this.highlight.stashedHoverEvent = void 0;
            const tooltipContent = this.chart.getTooltipContent(focus.series, datum.datumIndex, datum);
            const meta = $d77b025aa58d633c$var$TooltipManager.makeTooltipMeta(keyboardEvent, focus.series, datum, pick.movedBounds);
            this.chart.ctx.highlightManager.updateHighlight(this.id, datum);
            const tooltipEnabled = focus.series.tooltipEnabled ?? this.chart.tooltip.enabled;
            if (tooltipEnabled) this.chart.ctx.tooltipManager.updateTooltip(this.id, meta, tooltipContent);
            else this.chart.ctx.tooltipManager.removeTooltip(this.id);
            if (!refresh) {
                const shouldAnnouncePick = datumIndexDelta === 0 && otherIndexDelta === 0 || oldDatumIndex !== pick.datumIndex || oldOtherIndex !== (pick.otherIndex ?? focus.seriesIndex);
                if (shouldAnnouncePick) this.swapChain.update(this.getDatumAriaText(datum, tooltipContent));
            }
        }
    }
    getDatumAriaText(datum, tooltipContent) {
        const description = tooltipContent == null ? "" : $d77b025aa58d633c$var$tooltipContentAriaLabel(tooltipContent);
        return this.chart.ctx.localeManager.t("ariaAnnounceHoverDatum", {
            datum: datum.series.getDatumAriaText?.(datum, description) ?? description
        });
    }
    clearHighlight() {
        this.highlight.pendingHoverEvent = void 0;
        this.highlight.appliedHoverEvent = void 0;
        this.chart.ctx.highlightManager.updateHighlight(this.id);
    }
    clearTooltip() {
        this.chart.ctx.tooltipManager.removeTooltip(this.id);
        this.tooltip.lastHover = void 0;
    }
    clearAll() {
        this.clearHighlight();
        this.clearTooltip();
        this.focusIndicator?.clear();
    }
    handleHoverHighlight(redisplay) {
        this.highlight.appliedHoverEvent = this.highlight.pendingHoverEvent;
        this.highlight.pendingHoverEvent = void 0;
        const event = this.highlight.appliedHoverEvent;
        if (!event || !this.isState(41 /* Clickable */ )) return;
        const { currentX: currentX, currentY: currentY } = event;
        const canvasX = event.currentX + (this.hoverRect?.x ?? 0);
        const canvasY = event.currentY + (this.hoverRect?.y ?? 0);
        if (redisplay ? this.chart.ctx.animationManager.isActive() : !this.hoverRect?.containsPoint(canvasX, canvasY)) {
            this.clearHighlight();
            return;
        }
        const { range: range3 } = this.chart.highlight;
        const intent = range3 === "tooltip" ? "highlight-tooltip" : "highlight";
        const pick = this.pickNodes({
            x: currentX,
            y: currentY
        }, intent);
        if (!pick || pick.matches.length === 0) {
            this.chart.ctx.highlightManager.updateHighlight(this.id);
            return;
        }
        const { current: tooltipPick } = this.tooltipCandidates;
        const tooltipMatch = tooltipPick == null ? void 0 : pick.matches.find((m)=>$d77b025aa58d633c$var$pickedNodesEqual(m, tooltipPick));
        const datum = tooltipMatch?.datum ?? pick.matches[0].datum;
        this.chart.ctx.highlightManager.updateHighlight(this.id, datum);
        this.hoverDevice = "pointer";
    }
    handleHoverTooltip(event, redisplay) {
        const { current: previousHover } = this.tooltipCandidates;
        this.tooltipCandidates.reset();
        if (!this.isState(41 /* Clickable */ )) return;
        const { currentX: currentX, currentY: currentY } = event;
        const canvasX = currentX + (this.hoverRect?.x ?? 0);
        const canvasY = currentY + (this.hoverRect?.y ?? 0);
        const targetElement = event.sourceEvent.target;
        if (redisplay ? this.chart.ctx.animationManager.isActive() : !this.hoverRect?.containsPoint(canvasX, canvasY)) {
            if (this.hoverDevice == "pointer") this.clearTooltip();
            return;
        }
        if (targetElement && this.chart.tooltip.interactive && this.chart.ctx.domManager.isManagedChildDOMElement(targetElement, "canvas-overlay", $d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS)) return;
        const pick = this.pickNodes({
            x: event.currentX,
            y: event.currentY
        }, "tooltip");
        if (!pick || pick.matches.length === 0) {
            if (this.hoverDevice == "pointer") this.clearTooltip();
            return;
        }
        this.hoverDevice = "pointer";
        if (pick.distance === 0) {
            const { current: current, index: index, length: length2 } = this.tooltipCandidates.update(pick.matches, this.chart.tooltip.pagination ? previousHover : void 0);
            this.showTooltip(current, canvasX, canvasY, {
                index: index,
                length: length2
            });
        } else this.showTooltip(pick.matches[0], canvasX, canvasY);
    }
    showTooltip({ series: series, datum: datum, datumIndex: datumIndex }, canvasX, canvasY, pagination) {
        const content = this.chart.getTooltipContent(series, datumIndex, datum);
        const tooltipEnabled = series.tooltipEnabled ?? this.chart.tooltip.enabled;
        const shouldUpdateTooltip = tooltipEnabled && content != null;
        if (shouldUpdateTooltip) {
            const meta = $d77b025aa58d633c$var$TooltipManager.makeTooltipMeta({
                type: "pointermove",
                canvasX: canvasX,
                canvasY: canvasY
            }, series, datum, void 0);
            this.chart.ctx.tooltipManager.updateTooltip(this.id, meta, content, pagination);
        } else this.chart.ctx.tooltipManager.removeTooltip(this.id);
    }
    changeHighlightDatum(event) {
        const seriesToUpdate = /* @__PURE__ */ new Set();
        const { series: newSeries, datum: newDatum } = event.currentHighlight ?? {};
        const { series: lastSeries, datum: lastDatum } = event.previousHighlight ?? {};
        if (lastSeries) seriesToUpdate.add(lastSeries);
        if (newSeries) seriesToUpdate.add(newSeries);
        if (lastSeries?.properties.cursor && lastDatum) this.chart.ctx.domManager.updateCursor(lastSeries.id);
        if (newSeries?.properties.cursor && newSeries?.properties.cursor !== "default" && newDatum) this.chart.ctx.domManager.updateCursor(newSeries.id, newSeries.properties.cursor);
        const updateAll = newSeries == null || lastSeries == null;
        if (updateAll) this.update(5 /* SERIES_UPDATE */ );
        else this.update(5 /* SERIES_UPDATE */ , {
            seriesToUpdate: seriesToUpdate
        });
    }
    pickNodes(point, intent, exactMatchOnly) {
        const reverseSeries = [
            ...this.series
        ].reverse();
        let result;
        for (const series of reverseSeries){
            if (!series.visible || !series.contentGroup.visible) continue;
            const pick = series.pickNodes(point, intent, exactMatchOnly);
            if (pick == null || pick.datums.length === 0) continue;
            const { datums: datums, distance: distance2 } = pick;
            if (pick.datums.length === 0) continue;
            if (distance2 === 0) {
                if (result?.distance !== 0) result = {
                    matches: [],
                    distance: 0
                };
                for (const datum of datums){
                    const { datumIndex: datumIndex } = datum;
                    result.matches.push({
                        series: series,
                        datum: datum,
                        datumIndex: datumIndex
                    });
                }
            } else if (result == null || result.distance > distance2) {
                const [datum] = datums;
                const { datumIndex: datumIndex } = datum;
                result = {
                    matches: [
                        {
                            series: series,
                            datum: datum,
                            datumIndex: datumIndex
                        }
                    ],
                    distance: distance2
                };
            }
        }
        return result;
    }
};
function $d77b025aa58d633c$var$excludesType(obj, excluded) {
    return obj.type !== excluded;
}
var $d77b025aa58d633c$var$SERIES_THRESHOLD_FOR_AGGRESSIVE_LAYER_REDUCTION = 30;
var $d77b025aa58d633c$var$SeriesLayerManager = class {
    constructor(seriesRoot){
        this.seriesRoot = seriesRoot;
        this.groups = /* @__PURE__ */ new Map();
        this.series = /* @__PURE__ */ new Map();
        this.expectedSeriesCount = 1;
        this.mode = "normal";
    }
    setSeriesCount(count) {
        this.expectedSeriesCount = count;
    }
    requestGroup(seriesConfig) {
        const { internalId: internalId, type: type, contentGroup: seriesContentGroup, seriesGrouping: seriesGrouping } = seriesConfig;
        const { groupIndex: groupIndex = internalId } = seriesGrouping ?? {};
        const seriesInfo = this.series.get(internalId);
        if (seriesInfo != null) throw new Error(`AG Charts - series already has an allocated layer: ${JSON.stringify(seriesInfo)}`);
        if (this.series.size === 0) this.mode = this.expectedSeriesCount >= $d77b025aa58d633c$var$SERIES_THRESHOLD_FOR_AGGRESSIVE_LAYER_REDUCTION ? "aggressive-grouping" : "normal";
        let group = this.groups.get(type);
        if (group == null) {
            group = /* @__PURE__ */ new Map();
            this.groups.set(type, group);
        }
        const lookupIndex = this.lookupIdx(groupIndex);
        let groupInfo = group.get(lookupIndex);
        if (groupInfo == null) {
            groupInfo = {
                type: type,
                id: lookupIndex,
                seriesIds: [],
                group: this.seriesRoot.appendChild(new $d77b025aa58d633c$var$Group({
                    name: `${seriesConfig.contentGroup.name ?? type}-managed-layer`,
                    zIndex: seriesConfig.contentGroup.zIndex,
                    // Set in updateLayerCompositing
                    renderToOffscreenCanvas: false
                }))
            };
            group.set(lookupIndex, groupInfo);
        }
        this.series.set(internalId, {
            layerState: groupInfo,
            seriesConfig: seriesConfig
        });
        groupInfo.seriesIds.push(internalId);
        groupInfo.group.appendChild(seriesContentGroup);
        return groupInfo.group;
    }
    changeGroup(seriesConfig) {
        const { internalId: internalId, seriesGrouping: seriesGrouping, type: type, contentGroup: contentGroup, oldGrouping: oldGrouping } = seriesConfig;
        const { groupIndex: groupIndex = internalId } = seriesGrouping ?? {};
        if (this.groups.get(type)?.get(groupIndex)?.seriesIds.includes(internalId)) return;
        if (this.series.has(internalId)) this.releaseGroup({
            internalId: internalId,
            seriesGrouping: oldGrouping,
            type: type,
            contentGroup: contentGroup
        });
        this.requestGroup(seriesConfig);
    }
    releaseGroup(seriesConfig) {
        const { internalId: internalId, contentGroup: contentGroup, type: type } = seriesConfig;
        if (!this.series.has(internalId)) throw new Error(`AG Charts - series doesn't have an allocated layer: ${internalId}`);
        const groupInfo = this.series.get(internalId)?.layerState;
        if (groupInfo) {
            groupInfo.seriesIds = groupInfo.seriesIds.filter((v)=>v !== internalId);
            groupInfo.group.removeChild(contentGroup);
        }
        if (groupInfo?.seriesIds.length === 0) {
            this.seriesRoot.removeChild(groupInfo.group);
            this.groups.get(groupInfo.type)?.delete(groupInfo.id);
            this.groups.get(type)?.delete(internalId);
        } else if (groupInfo != null && groupInfo.seriesIds.length > 0) groupInfo.group.zIndex = this.getLowestSeriesZIndex(groupInfo.seriesIds);
        this.series.delete(internalId);
    }
    updateLayerCompositing() {
        this.groups.forEach((groups)=>{
            groups.forEach((groupInfo)=>{
                const { group: group, seriesIds: seriesIds } = groupInfo;
                let renderToOffscreenCanvas;
                if (seriesIds.length === 0) renderToOffscreenCanvas = false;
                else if (seriesIds.length > 1) renderToOffscreenCanvas = true;
                else {
                    const series = this.series.get(seriesIds[0]);
                    renderToOffscreenCanvas = series?.seriesConfig.renderToOffscreenCanvas() === true;
                }
                group.renderToOffscreenCanvas = renderToOffscreenCanvas;
                group.zIndex = this.getLowestSeriesZIndex(seriesIds);
            });
        });
    }
    lookupIdx(groupIndex) {
        if (this.mode === "normal") return groupIndex;
        if (typeof groupIndex === "string") {
            groupIndex = Number(groupIndex.split("-").at(-1));
            if (!groupIndex) return 0;
        }
        return Math.floor((0, $idDdm.clamp)(0, groupIndex / this.expectedSeriesCount, 1) * $d77b025aa58d633c$var$SERIES_THRESHOLD_FOR_AGGRESSIVE_LAYER_REDUCTION);
    }
    destroy() {
        this.groups.forEach((groups)=>{
            groups.forEach((groupInfo)=>{
                this.seriesRoot.removeChild(groupInfo.group);
            });
        });
        this.groups.clear();
        this.series.clear();
    }
    getLowestSeriesZIndex(seriesIds) {
        const lowestSeriesZIndex = seriesIds.reduce((currentLowest, seriesId)=>{
            const series = this.series.get(seriesId);
            const zIndex = series?.seriesConfig.contentGroup.zIndex;
            if (currentLowest == null || zIndex == null) return zIndex;
            return $d77b025aa58d633c$var$compareZIndex(currentLowest, zIndex) <= 0 ? currentLowest : zIndex;
        }, void 0);
        return lowestSeriesZIndex ?? 1 /* ANY_CONTENT */ ;
    }
};
// packages/ag-charts-community/src/chart/touch.ts
var $d77b025aa58d633c$var$Touch = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.dragAction = "drag";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Touch.prototype, "dragAction", 2);
// packages/ag-charts-community/src/chart/update/dataWindowProcessor.ts
var $d77b025aa58d633c$var$DataWindowProcessor = class {
    constructor(chart, dataService, updateService, zoomManager, animationManager){
        this.chart = chart;
        this.dataService = dataService;
        this.updateService = updateService;
        this.zoomManager = zoomManager;
        this.animationManager = animationManager;
        this.dirtyZoom = false;
        this.dirtyDataSource = false;
        this.lastAxisZooms = /* @__PURE__ */ new Map();
        this.destroyFns = [];
        this.destroyFns.push(this.dataService.addListener("data-source-change", ()=>this.onDataSourceChange()), this.dataService.addListener("data-load", ()=>this.onDataLoad()), this.dataService.addListener("data-error", ()=>this.onDataError()), this.updateService.addListener("update-complete", (e)=>this.onUpdateComplete(e)), this.zoomManager.addListener("zoom-change", ()=>this.onZoomChange()));
    }
    destroy() {
        this.destroyFns.forEach((cb)=>cb());
    }
    onDataLoad() {
        this.animationManager.skip();
        this.updateService.update(1 /* UPDATE_DATA */ );
    }
    onDataError() {
        this.updateService.update(4 /* PERFORM_LAYOUT */ );
    }
    onDataSourceChange() {
        this.dirtyDataSource = true;
    }
    onUpdateComplete(event) {
        if (!event.apiUpdate && !this.dirtyZoom && !this.dirtyDataSource) return;
        this.updateWindow(event);
    }
    onZoomChange() {
        this.dirtyZoom = true;
    }
    updateWindow(event) {
        if (!this.dataService.isLazy()) return;
        const axis = this.getValidAxis();
        let window2;
        let shouldRefresh = true;
        if (axis) {
            const zoom = this.zoomManager.getAxisZoom(axis.id);
            window2 = this.getAxisWindow(axis, zoom);
            shouldRefresh = this.shouldRefresh(event, axis, zoom);
        }
        this.dirtyZoom = false;
        this.dirtyDataSource = false;
        if (!shouldRefresh) return;
        this.dataService.load({
            windowStart: window2?.min,
            windowEnd: window2?.max
        });
    }
    getValidAxis() {
        return this.chart.axes.find((axis)=>axis.type === "time");
    }
    shouldRefresh(event, axis, zoom) {
        if (event.apiUpdate) return true;
        if (this.dirtyDataSource) return true;
        if (!this.dirtyZoom) return false;
        const lastZoom = this.lastAxisZooms.get(axis.id);
        if (lastZoom && zoom.min === lastZoom.min && zoom.max === lastZoom.max) return false;
        this.lastAxisZooms.set(axis.id, zoom);
        return true;
    }
    getAxisWindow(axis, zoom) {
        const { domain: domain } = axis.scale;
        if (!zoom || domain.length === 0 || isNaN(Number(domain[0]))) return;
        const diff2 = Number(domain[1]) - Number(domain[0]);
        const min = new Date(Number(domain[0]) + diff2 * zoom.min);
        const max = new Date(Number(domain[0]) + diff2 * zoom.max);
        return {
            min: min,
            max: max
        };
    }
};
var $d77b025aa58d633c$var$isSafariRegexp = /^((?!chrome|android).)*safari/i;
var $d77b025aa58d633c$var$safariVersionRegexp = /Version\/(\d+(\.\d+)?)/;
var $d77b025aa58d633c$var$isChromeRegexp = /Chrome/;
var $d77b025aa58d633c$var$chromeVersionRegexp = /Chrome\/(\d+)/;
var $d77b025aa58d633c$var$isEdge = /Edg/;
var $d77b025aa58d633c$var$isOpera = /OPR/;
function $d77b025aa58d633c$var$isUnsupportedBrowser() {
    const { userAgent: userAgent } = (0, $idDdm.getWindow)("navigator");
    if ($d77b025aa58d633c$var$isSafariRegexp.test(userAgent)) {
        const versionExec = $d77b025aa58d633c$var$safariVersionRegexp.exec(userAgent);
        if (versionExec == null) return false;
        const version = parseFloat(versionExec[1]);
        const supported = Math.floor(version) > 16;
        if (!supported) (0, $idDdm.Logger).warnOnce(`Unsupported Safari version: ${version}; ${userAgent}`);
        return !supported;
    } else if ($d77b025aa58d633c$var$isChromeRegexp.test(userAgent) && !$d77b025aa58d633c$var$isEdge.test(userAgent) && !$d77b025aa58d633c$var$isOpera.test(userAgent)) {
        const versionExec = $d77b025aa58d633c$var$chromeVersionRegexp.exec(userAgent);
        if (versionExec == null) return false;
        const version = parseInt(versionExec[1], 10);
        const supported = version > 126;
        if (!supported) (0, $idDdm.Logger).warnOnce(`Unsupported Chrome version: ${version}; ${userAgent}`);
        return !supported;
    }
    return false;
}
// packages/ag-charts-community/src/chart/update/overlaysProcessor.ts
var $d77b025aa58d633c$var$visibleIgnoredSeries = /* @__PURE__ */ new Set([
    "map-shape-background",
    "map-line-background"
]);
var $d77b025aa58d633c$var$OverlaysProcessor = class {
    constructor(chartLike, overlays, dataService, layoutManager, localeManager, animationManager, domManager){
        this.chartLike = chartLike;
        this.overlays = overlays;
        this.dataService = dataService;
        this.layoutManager = layoutManager;
        this.localeManager = localeManager;
        this.animationManager = animationManager;
        this.domManager = domManager;
        this.destroyFns = [];
        this.overlayElem = this.domManager.addChild("canvas-overlay", "overlay");
        this.overlayElem.role = "status";
        this.overlayElem.ariaAtomic = "false";
        this.overlayElem.ariaLive = "polite";
        this.overlayElem.classList.toggle($d77b025aa58d633c$var$DEFAULT_OVERLAY_CLASS);
        this.destroyFns.push(this.layoutManager.addListener("layout:complete", (e)=>this.onLayoutComplete(e)));
    }
    destroy() {
        this.destroyFns.forEach((cb)=>cb());
        this.domManager.removeChild("canvas-overlay", "overlay");
    }
    onLayoutComplete({ series: { rect: rect } }) {
        const isLoading = this.dataService.isLoading();
        const hasData = this.chartLike.series.some((s)=>s.hasData);
        const anySeriesVisible = this.chartLike.series.some((s)=>s.visible && !$d77b025aa58d633c$var$visibleIgnoredSeries.has(s.type));
        if (this.overlays.darkTheme) this.overlayElem.classList.add($d77b025aa58d633c$var$DEFAULT_OVERLAY_DARK_CLASS);
        else this.overlayElem.classList.remove($d77b025aa58d633c$var$DEFAULT_OVERLAY_DARK_CLASS);
        this.overlayElem.style.left = `${rect.x}px`;
        this.overlayElem.style.top = `${rect.y}px`;
        this.overlayElem.style.width = `${rect.width}px`;
        this.overlayElem.style.height = `${rect.height}px`;
        const loadingShown = isLoading;
        const noDataShown = !isLoading && !hasData;
        const noVisibleSeriesShown = hasData && !anySeriesVisible;
        const unsupportedBrowser = this.overlays.unsupportedBrowser.enabled && $d77b025aa58d633c$var$isUnsupportedBrowser();
        if (loadingShown) this.showOverlay(this.overlays.loading, rect);
        else this.hideOverlay(this.overlays.loading);
        if (noDataShown) this.showOverlay(this.overlays.noData, rect);
        else this.hideOverlay(this.overlays.noData);
        if (noVisibleSeriesShown) this.showOverlay(this.overlays.noVisibleSeries, rect);
        else this.hideOverlay(this.overlays.noVisibleSeries);
        if (unsupportedBrowser) this.showOverlay(this.overlays.unsupportedBrowser, rect);
        else this.hideOverlay(this.overlays.unsupportedBrowser);
        const shown = loadingShown || noDataShown || noVisibleSeriesShown || unsupportedBrowser;
        (0, $idDdm.setAttribute)(this.overlayElem, "aria-hidden", !shown);
    }
    showOverlay(overlay, seriesRect) {
        if (!overlay.enabled) return;
        const element2 = overlay.getElement(this.animationManager, this.localeManager, seriesRect);
        this.overlayElem.appendChild(element2);
    }
    hideOverlay(overlay) {
        overlay.removeElement(()=>{
            this.overlayElem.innerText = "\xa0";
        }, this.animationManager);
    }
};
// packages/ag-charts-community/src/chart/chart.ts
var $d77b025aa58d633c$var$debug = $d77b025aa58d633c$var$Debug.create(true, "opts");
var $d77b025aa58d633c$var$SeriesArea = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.padding = new $d77b025aa58d633c$var$Padding(0);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesArea.prototype, "clip", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesArea.prototype, "padding", 2);
var $d77b025aa58d633c$var$_Chart = class _Chart extends $d77b025aa58d633c$var$Observable {
    constructor(options, resources){
        var _a;
        super();
        this.id = (0, $idDdm.createId)(this);
        this.seriesRoot = new $d77b025aa58d633c$var$TranslatableGroup({
            name: `${this.id}-series-root`,
            zIndex: 5 /* SERIES_LAYER */ 
        });
        this.annotationRoot = new $d77b025aa58d633c$var$TranslatableGroup({
            name: `${this.id}-annotation-root`,
            zIndex: 9 /* SERIES_ANNOTATION */ 
        });
        this.titleGroup = new $d77b025aa58d633c$var$Group({
            name: "titles",
            zIndex: 13 /* SERIES_LABEL */ 
        });
        this.debug = $d77b025aa58d633c$var$Debug.create();
        this.extraDebugStats = {};
        this.data = [];
        this._firstAutoSize = true;
        this._autoSizeNotify = new (0, $idDdm.AsyncAwaitQueue)();
        this.padding = new $d77b025aa58d633c$var$Padding(20);
        this.seriesArea = new $d77b025aa58d633c$var$SeriesArea();
        this.keyboard = new $d77b025aa58d633c$var$Keyboard();
        this.touch = new $d77b025aa58d633c$var$Touch();
        this.mode = "standalone";
        this.chartCaptions = new $d77b025aa58d633c$var$ChartCaptions();
        this.suppressFieldDotNotation = false;
        this.loadGoogleFonts = false;
        this.destroyed = false;
        this._destroyFns = [];
        this.chartAnimationPhase = "initial";
        this.modulesManager = new $d77b025aa58d633c$var$ModulesManager();
        this.processors = [];
        this.queuedUserOptions = [];
        this.queuedChartOptions = [];
        this.firstApply = true;
        this.syncStatus = "init";
        this.apiUpdate = false;
        this._pendingFactoryUpdatesCount = 0;
        this._performUpdateSkipAnimations = false;
        this._performUpdateNotify = new (0, $idDdm.AsyncAwaitQueue)();
        this.performUpdateType = 8 /* NONE */ ;
        this.runningUpdateType = 8 /* NONE */ ;
        this.updateShortcutCount = 0;
        this.seriesToUpdate = /* @__PURE__ */ new Set();
        this.updateMutex = new $d77b025aa58d633c$var$Mutex();
        this.updateRequestors = {};
        this.performUpdateTrigger = $d77b025aa58d633c$var$debouncedCallback(({ count: count })=>{
            if (this.destroyed) return;
            this.updateMutex.acquire(async ()=>{
                try {
                    await this.performUpdate(count);
                } catch (error) {
                    (0, $idDdm.Logger).error("update error", error);
                }
            }).catch((e)=>(0, $idDdm.Logger).errorOnce(e));
        });
        this._performUpdateSplits = {};
        this.axes = [];
        this.series = [];
        this._cachedData = void 0;
        this.onSeriesNodeClick = (event)=>{
            this.fireEvent(event);
        };
        this.onSeriesNodeDoubleClick = (event)=>{
            this.fireEvent(event);
        };
        this.onSeriesVisibilityChange = (event)=>{
            this.fireEvent(event);
        };
        this.seriesGroupingChanged = (event)=>{
            if (!(event instanceof $d77b025aa58d633c$var$SeriesGroupingChangedEvent)) return;
            const { series: series, seriesGrouping: seriesGrouping, oldGrouping: oldGrouping } = event;
            if (series.contentGroup.isRoot()) return;
            this.seriesLayerManager.changeGroup({
                internalId: series.internalId,
                type: series.type,
                contentGroup: series.contentGroup,
                renderToOffscreenCanvas: ()=>series.renderToOffscreenCanvas(),
                seriesGrouping: seriesGrouping,
                oldGrouping: oldGrouping
            });
        };
        this.chartOptions = options;
        const scene = resources?.scene;
        const container = resources?.container ?? options.processedOptions.container ?? void 0;
        const styleContainer = resources?.styleContainer ?? options.specialOverrides.styleContainer;
        if (scene) {
            this._firstAutoSize = false;
            this._lastAutoSize = [
                scene.width,
                scene.height,
                scene.pixelRatio
            ];
        }
        const root = new $d77b025aa58d633c$var$Group({
            name: "root"
        });
        root.visible = false;
        root.append(this.seriesRoot);
        root.append(this.annotationRoot);
        root.append(this.titleGroup);
        this.titleGroup.append(this.title.node);
        this.titleGroup.append(this.subtitle.node);
        this.titleGroup.append(this.footnote.node);
        this.tooltip = new $d77b025aa58d633c$var$Tooltip();
        this.seriesLayerManager = new $d77b025aa58d633c$var$SeriesLayerManager(this.seriesRoot);
        this.mode = options.userOptions.mode ?? this.mode;
        this.styleNonce = options.processedOptions.styleNonce;
        const ctx = this.ctx = new $d77b025aa58d633c$var$ChartContext(this, {
            chartType: this.getChartType(),
            scene: scene,
            root: root,
            container: container,
            styleContainer: styleContainer,
            domMode: options.optionMetadata.domMode,
            syncManager: new $d77b025aa58d633c$var$SyncManager(this),
            fireEvent: (event)=>this.fireEvent(event),
            updateCallback: (type, opts)=>this.update(type, opts),
            updateMutex: this.updateMutex
        });
        this._destroyFns.push(ctx.domManager.addListener("resize", ()=>this.parentResize(ctx.domManager.containerSize)));
        this.overlays = new $d77b025aa58d633c$var$ChartOverlays();
        (_a = this.overlays.loading).renderer ?? (_a.renderer = ()=>$d77b025aa58d633c$var$getLoadingSpinner(this.overlays.loading.getText(ctx.localeManager), ctx.animationManager.defaultDuration));
        this.processors = [
            new $d77b025aa58d633c$var$DataWindowProcessor(this, ctx.dataService, ctx.updateService, ctx.zoomManager, ctx.animationManager),
            new $d77b025aa58d633c$var$OverlaysProcessor(this, this.overlays, ctx.dataService, ctx.layoutManager, ctx.localeManager, ctx.animationManager, ctx.domManager)
        ];
        this.highlight = new $d77b025aa58d633c$var$ChartHighlight();
        this.container = container;
        const moduleContext = this.getModuleContext();
        ctx.domManager.setDataBoolean("animating", false);
        this.seriesAreaManager = new $d77b025aa58d633c$var$SeriesAreaManager(this.initSeriesAreaDependencies());
        this._destroyFns.push(ctx.layoutManager.registerElement(0 /* Caption */ , (e)=>{
            e.layoutBox.shrink(this.padding.toJson());
            this.chartCaptions.positionCaptions(e);
        }), ctx.layoutManager.addListener("layout:complete", (e)=>this.chartCaptions.positionAbsoluteCaptions(e)), ctx.dataService.addListener("data-load", (event)=>{
            this.data = event.data;
        }), this.title.registerInteraction(moduleContext, "beforebegin"), this.subtitle.registerInteraction(moduleContext, "beforebegin"), this.footnote.registerInteraction(moduleContext, "afterend"), $d77b025aa58d633c$var$Widget.addWindowEvent("page-left", ()=>this.destroy()), ctx.animationManager.addListener("animation-frame", ()=>{
            this.update(7 /* SCENE_RENDER */ );
        }), ctx.animationManager.addListener("animation-start", ()=>ctx.domManager.setDataBoolean("animating", true)), ctx.animationManager.addListener("animation-stop", ()=>ctx.domManager.setDataBoolean("animating", false)), ctx.zoomManager.addListener("zoom-change", ()=>{
            this.series.forEach((s)=>s.animationState?.transition("updateData"));
            const skipAnimations = this.chartAnimationPhase !== "initial";
            this.update(4 /* PERFORM_LAYOUT */ , {
                forceNodeDataRefresh: true,
                skipAnimations: skipAnimations
            });
        }));
        this.parentResize(ctx.domManager.containerSize);
    }
    static getInstance(element2) {
        return _Chart.chartsInstances.get(element2);
    }
    /** NOTE: This is exposed for use by Integrated charts only. */ get canvasElement() {
        return this.ctx.scene.canvas.element;
    }
    download(fileName, fileFormat) {
        this.ctx.scene.download(fileName, fileFormat);
    }
    getCanvasDataURL(fileFormat) {
        return this.ctx.scene.getDataURL(fileFormat);
    }
    toSVG() {
        return this.ctx.scene.toSVG();
    }
    get seriesAreaBoundingBox() {
        return this.seriesAreaManager.bbox;
    }
    getOptions() {
        return this.queuedUserOptions.at(-1) ?? this.chartOptions.userOptions;
    }
    getChartOptions() {
        return this.queuedChartOptions.at(-1) ?? this.chartOptions;
    }
    overrideFocusVisible(visible) {
        this.seriesAreaManager.focusIndicator?.overrideFocusVisible(visible);
    }
    initSeriesAreaDependencies() {
        const { ctx: ctx, tooltip: tooltip, highlight: highlight, overlays: overlays, seriesRoot: seriesRoot, mode: mode } = this;
        const chartType = this.getChartType();
        const fireEvent = this.fireEvent.bind(this);
        const getUpdateType = ()=>this.performUpdateType;
        const getTooltipContent = (series, datumIndex, removeThisDatum)=>this.getTooltipContent(series, datumIndex, removeThisDatum);
        return {
            fireEvent: fireEvent,
            getUpdateType: getUpdateType,
            getTooltipContent: getTooltipContent,
            chartType: chartType,
            ctx: ctx,
            tooltip: tooltip,
            highlight: highlight,
            overlays: overlays,
            seriesRoot: seriesRoot,
            mode: mode
        };
    }
    getModuleContext() {
        return this.ctx;
    }
    getTooltipContent(series, datumIndex, removeMeDatum) {
        const baseTooltipContent = series.properties.tooltip.enabled !== false ? series.getTooltipContent(datumIndex, removeMeDatum) : void 0;
        const tooltipContent = baseTooltipContent == null ? [] : [
            baseTooltipContent
        ];
        if (this.tooltip.mode !== "shared" || this.series.length === 1) return tooltipContent;
        const categoryValue = series.getCategoryValue(datumIndex);
        if (categoryValue == null) return tooltipContent;
        return this.series.flatMap((s)=>{
            if (s === series) return tooltipContent;
            if (!s.isEnabled() || s.properties.tooltip.enabled === false) return [];
            const seriesDatumIndex = s.datumIndexForCategoryValue(categoryValue);
            const seriesTooltipContent = seriesDatumIndex == null ? void 0 : s.getTooltipContent(seriesDatumIndex, void 0);
            return seriesTooltipContent == null ? [] : [
                seriesTooltipContent
            ];
        });
    }
    getCaptionText() {
        return [
            this.title,
            this.subtitle,
            this.footnote
        ].filter((caption)=>caption.enabled && caption.text).map((caption)=>caption.text).join(". ");
    }
    getAriaLabel() {
        return this.ctx.localeManager.t("ariaAnnounceChart", {
            seriesCount: this.series.length
        });
    }
    resetAnimations() {
        this.chartAnimationPhase = "initial";
        for (const series of this.series)series.resetAnimation(this.chartAnimationPhase);
        for (const axis of this.axes)axis.resetAnimation(this.chartAnimationPhase);
        this.animationRect = void 0;
        this.ctx.animationManager.reset();
    }
    skipAnimations() {
        this.ctx.animationManager.skipCurrentBatch();
        this._performUpdateSkipAnimations = true;
    }
    detachAndClear() {
        this.container = void 0;
        this.ctx.scene.clearCanvas();
    }
    destroy(opts) {
        if (this.destroyed) return;
        const keepTransferableResources = opts?.keepTransferableResources;
        let result;
        this.performUpdateType = 8 /* NONE */ ;
        this._destroyFns.forEach((fn)=>fn());
        this.processors.forEach((p)=>p.destroy());
        this.overlays.destroy();
        this.modulesManager.destroy();
        if (keepTransferableResources) {
            this.ctx.scene.strip();
            result = {
                container: this.container,
                scene: this.ctx.scene
            };
        } else {
            this.ctx.scene.destroy();
            this.container = void 0;
        }
        this.destroySeries(this.series);
        this.seriesLayerManager.destroy();
        this.axes.forEach((a)=>a.destroy());
        this.axes = [];
        this.animationRect = void 0;
        this.ctx.destroy();
        this.destroyed = true;
        Object.freeze(this);
        return result;
    }
    requestFactoryUpdate(cb) {
        if (this.destroyed) return;
        this._pendingFactoryUpdatesCount++;
        this.updateMutex.acquire(async ()=>{
            if (this.destroyed) return;
            try {
                await cb(this);
            } finally{
                if (!this.destroyed) this._pendingFactoryUpdatesCount--;
            }
        }).catch((e)=>(0, $idDdm.Logger).errorOnce(e));
    }
    clearCallbackCache() {
        this.ctx.callbackCache.invalidateCache();
        for (const series of this.series)series.resetDatumCallbackCache();
    }
    update(type = 0 /* FULL */ , opts) {
        if (this.destroyed) return;
        const { forceNodeDataRefresh: forceNodeDataRefresh = false, skipAnimations: skipAnimations, seriesToUpdate: seriesToUpdate = this.series, newAnimationBatch: newAnimationBatch, apiUpdate: apiUpdate = false } = opts ?? {};
        this.apiUpdate = apiUpdate;
        this.ctx.widgets.seriesWidget.setDragTouchEnabled(this.touch.dragAction !== "none");
        if (forceNodeDataRefresh) this.series.forEach((series)=>series.markNodeDataDirty());
        for (const series of seriesToUpdate)this.seriesToUpdate.add(series);
        if (skipAnimations) {
            this.ctx.animationManager.skipCurrentBatch();
            this._performUpdateSkipAnimations = true;
        }
        if (newAnimationBatch && this.ctx.animationManager.isActive()) this._performUpdateSkipAnimations = true;
        if (this.debug.check()) {
            let stack = new Error().stack ?? "<unknown>";
            stack = stack.replace(/\([^)]*/g, "");
            this.updateRequestors[stack] = type;
        }
        if (type < this.performUpdateType) {
            this.performUpdateType = type;
            this.ctx.domManager.setDataBoolean("updatePending", true);
            this.performUpdateTrigger.schedule(opts?.backOffMs);
        }
    }
    async performUpdate(count) {
        const { performUpdateType: performUpdateType, extraDebugStats: extraDebugStats, _performUpdateSplits: splits, ctx: ctx } = this;
        const seriesToUpdate = [
            ...this.seriesToUpdate
        ];
        this.clearCallbackCache();
        this.performUpdateType = 8 /* NONE */ ;
        this.seriesToUpdate.clear();
        this.runningUpdateType = performUpdateType;
        if (this.updateShortcutCount === 0 && performUpdateType < 7 /* SCENE_RENDER */ ) {
            ctx.animationManager.startBatch(this._performUpdateSkipAnimations);
            ctx.animationManager.onBatchStop(()=>this.chartAnimationPhase = "ready");
        }
        this.ctx.scene.updateDebugFlags();
        this.debug("Chart.performUpdate() - start", $d77b025aa58d633c$var$ChartUpdateType[performUpdateType]);
        let previousSplit = performance.now();
        splits.start ?? (splits.start = previousSplit);
        const updateSplits = (splitName)=>{
            splits[splitName] ?? (splits[splitName] = 0);
            splits[splitName] += performance.now() - previousSplit;
            previousSplit = performance.now();
        };
        switch(performUpdateType){
            case 0 /* FULL */ :
                if (this.checkUpdateShortcut(0 /* FULL */ )) break;
                this.ctx.updateService.dispatchPreDomUpdate();
                this.updateDOM();
            case 1 /* UPDATE_DATA */ :
                if (this.checkUpdateShortcut(1 /* UPDATE_DATA */ )) break;
                await this.updateData();
                updateSplits("\u2B07\uFE0F");
            case 2 /* PROCESS_DATA */ :
                if (this.checkUpdateShortcut(2 /* PROCESS_DATA */ )) break;
                await this.processData();
                this.seriesAreaManager.dataChanged();
                updateSplits("\uD83C\uDFED");
            case 3 /* PROCESS_DOMAIN */ :
                if (this.checkUpdateShortcut(3 /* PROCESS_DOMAIN */ )) break;
                await this.processDomains();
                updateSplits("\u26F0\uFE0F");
            case 4 /* PERFORM_LAYOUT */ :
                await this.checkFirstAutoSize();
                if (this.checkUpdateShortcut(4 /* PERFORM_LAYOUT */ )) break;
                await this.processLayout();
                updateSplits("\u2316");
            case 5 /* SERIES_UPDATE */ :
                if (this.checkUpdateShortcut(5 /* SERIES_UPDATE */ )) break;
                await this.updateSeries(seriesToUpdate);
                updateSplits("\uD83E\uDD14");
                this.updateAriaLabels();
                this.seriesLayerManager.updateLayerCompositing();
            case 6 /* PRE_SCENE_RENDER */ :
                if (this.checkUpdateShortcut(6 /* PRE_SCENE_RENDER */ )) break;
                ctx.updateService.dispatchPreSceneRender();
                updateSplits("\u2196");
            case 7 /* SCENE_RENDER */ :
                if (this.checkUpdateShortcut(7 /* SCENE_RENDER */ )) break;
                ctx.animationManager.endBatch();
                extraDebugStats["updateShortcutCount"] = this.updateShortcutCount;
                ctx.scene.render({
                    debugSplitTimes: splits,
                    extraDebugStats: extraDebugStats,
                    seriesRect: this.seriesRect
                });
                this.extraDebugStats = {};
                for (const key of Object.keys(splits))delete splits[key];
                this.ctx.domManager.incrementDataCounter("sceneRenders");
                this.ctx.domManager.postRenderUpdate();
            case 8 /* NONE */ :
                this.updateShortcutCount = 0;
                this.updateRequestors = {};
                this._performUpdateSkipAnimations = false;
                ctx.animationManager.endBatch();
        }
        if (!this.destroyed) {
            ctx.updateService.dispatchUpdateComplete(this.apiUpdate);
            this.apiUpdate = false;
            this.ctx.domManager.setDataBoolean("updatePending", false);
            this.runningUpdateType = 8 /* NONE */ ;
            this.syncStatus = "ready";
        }
        this._performUpdateNotify.notify();
        const end2 = performance.now();
        this.debug("Chart.performUpdate() - end", {
            chart: this,
            durationMs: Math.round((end2 - splits["start"]) * 100) / 100,
            count: count,
            performUpdateType: $d77b025aa58d633c$var$ChartUpdateType[performUpdateType]
        });
    }
    updateThemeClassName() {
        const themeClassNamePrefix = "ag-charts-theme-";
        const validThemeClassNames = [
            `${themeClassNamePrefix}default`,
            `${themeClassNamePrefix}default-dark`
        ];
        let themeClassName = validThemeClassNames[0];
        let isDark = false;
        let { theme: theme } = this.chartOptions.processedOptions;
        while(typeof theme !== "string" && theme != null)theme = theme.baseTheme;
        if (typeof theme === "string") {
            themeClassName = theme.replace("ag-", themeClassNamePrefix);
            isDark = theme.includes("-dark");
        }
        if (!validThemeClassNames.includes(themeClassName)) themeClassName = isDark ? validThemeClassNames[1] : validThemeClassNames[0];
        this.ctx.domManager.setThemeClass(themeClassName);
    }
    updateDOM() {
        this.updateThemeClassName();
        const { enabled: enabled, tabIndex: tabIndex } = this.keyboard;
        this.ctx.domManager.setTabGuardIndex(enabled ? tabIndex ?? 0 : -1);
        this.ctx.domManager.setThemeParameters(this.chartOptions.themeParameters);
    }
    updateAriaLabels() {
        this.ctx.domManager.updateCanvasLabel(this.getAriaLabel());
    }
    checkUpdateShortcut(checkUpdateType) {
        const maxShortcuts = 3;
        if (this.destroyed) return true;
        if (this.updateShortcutCount > maxShortcuts) {
            (0, $idDdm.Logger).warn(`exceeded the maximum number of simultaneous updates (${maxShortcuts + 1}), discarding changes and rendering`, this.updateRequestors);
            return false;
        }
        if (this.performUpdateType <= checkUpdateType) {
            this.updateShortcutCount++;
            return true;
        }
        return false;
    }
    async checkFirstAutoSize() {
        if (this.width != null && this.height != null) ;
        else if (!this._lastAutoSize) {
            const success = await this._autoSizeNotify.await(500);
            if (!success) this.debug("Chart.checkFirstAutoSize() - timeout for first size update.");
        }
    }
    onAxisChange(newValue, oldValue) {
        if (oldValue == null && newValue.length === 0) return;
        this.ctx.axisManager.updateAxes(oldValue ?? [], newValue);
    }
    onSeriesChange(newValue, oldValue) {
        const seriesToDestroy = oldValue?.filter((series)=>!newValue.includes(series)) ?? [];
        this.destroySeries(seriesToDestroy);
        this.seriesLayerManager?.setSeriesCount(newValue.length);
        for (const series of newValue){
            if (oldValue?.includes(series)) continue;
            const seriesContentNode = this.seriesLayerManager.requestGroup(series);
            series.attachSeries(seriesContentNode, this.seriesRoot, this.annotationRoot);
            const chart = this;
            series.chart = {
                get mode () {
                    return chart.mode;
                },
                get isMiniChart () {
                    return false;
                },
                get seriesRect () {
                    return chart.seriesRect;
                }
            };
            series.resetAnimation(this.chartAnimationPhase);
            this.addSeriesListeners(series);
            series.addChartEventListeners();
        }
        this.seriesAreaManager?.seriesChanged(newValue);
    }
    destroySeries(allSeries) {
        allSeries?.forEach((series)=>{
            series.removeEventListener("seriesNodeClick", this.onSeriesNodeClick);
            series.removeEventListener("seriesNodeDoubleClick", this.onSeriesNodeDoubleClick);
            series.removeEventListener("groupingChanged", this.seriesGroupingChanged);
            series.destroy();
            this.seriesLayerManager.releaseGroup(series);
            series.detachSeries(void 0, this.seriesRoot, this.annotationRoot);
            series.chart = void 0;
        });
    }
    addSeriesListeners(series) {
        if (this.hasEventListener("seriesNodeClick")) series.addEventListener("seriesNodeClick", this.onSeriesNodeClick);
        if (this.hasEventListener("seriesNodeDoubleClick")) series.addEventListener("seriesNodeDoubleClick", this.onSeriesNodeDoubleClick);
        if (this.hasEventListener("seriesVisibilityChange")) series.addEventListener("seriesVisibilityChange", this.onSeriesVisibilityChange);
        series.addEventListener("groupingChanged", this.seriesGroupingChanged);
    }
    assignSeriesToAxes() {
        for (const axis of this.axes)axis.boundSeries = this.series.filter((s)=>s.axes[axis.direction] === axis);
    }
    assignAxesToSeries() {
        const directionToAxesMap = (0, $idDdm.groupBy)(this.axes, (axis)=>axis.direction);
        for (const series of this.series)for (const direction of series.directions){
            const directionAxes = directionToAxesMap[direction];
            if (!directionAxes) {
                (0, $idDdm.Logger).warnOnce(`no available axis for direction [${direction}]; check series and axes configuration.`);
                return;
            }
            const seriesKeys = series.getKeys(direction);
            const newAxis = directionAxes.find((axis)=>!axis.keys.length || seriesKeys.some((key)=>axis.keys.includes(key)));
            if (!newAxis) {
                (0, $idDdm.Logger).warnOnce(`no matching axis for direction [${direction}] and keys [${seriesKeys}]; check series and axes configuration.`);
                return;
            }
            series.axes[direction] = newAxis;
        }
    }
    parentResize(size) {
        if (size == null || this.width != null && this.height != null) return;
        let { width: width2, height: height2 } = size;
        const { pixelRatio: pixelRatio } = size;
        width2 = Math.floor(width2);
        height2 = Math.floor(height2);
        if (width2 === 0 && height2 === 0) return;
        const [autoWidth = 0, autoHeight = 0, autoPixelRatio = 1] = this._lastAutoSize ?? [];
        if (autoWidth === width2 && autoHeight === height2 && autoPixelRatio === pixelRatio) return;
        this._lastAutoSize = [
            width2,
            height2,
            pixelRatio
        ];
        this.resize("SizeMonitor", {});
    }
    resize(source, opts) {
        const { scene: scene, animationManager: animationManager } = this.ctx;
        const { inWidth: inWidth, inHeight: inHeight, inMinWidth: inMinWidth, inMinHeight: inMinHeight, inOverrideDevicePixelRatio: inOverrideDevicePixelRatio } = opts;
        this.ctx.domManager.setSizeOptions(inMinWidth ?? this.minWidth, inMinHeight ?? this.minHeight, inWidth ?? this.width, inHeight ?? this.height);
        const width2 = inWidth ?? this.width ?? this._lastAutoSize?.[0];
        const height2 = inHeight ?? this.height ?? this._lastAutoSize?.[1];
        const pixelRatio = inOverrideDevicePixelRatio ?? this.overrideDevicePixelRatio ?? this._lastAutoSize?.[2];
        this.debug(`Chart.resize() from ${source}`, {
            width: width2,
            height: height2,
            pixelRatio: pixelRatio,
            stack: new Error().stack
        });
        if (width2 == null || height2 == null || !(0, $idDdm.isFiniteNumber)(width2) || !(0, $idDdm.isFiniteNumber)(height2)) return;
        if (scene.resize(width2, height2, pixelRatio)) {
            animationManager.reset();
            let skipAnimations = true;
            if ((this.width == null || this.height == null) && this._firstAutoSize) {
                skipAnimations = false;
                this._firstAutoSize = false;
            }
            this.update(4 /* PERFORM_LAYOUT */ , {
                forceNodeDataRefresh: true,
                skipAnimations: skipAnimations
            });
            this._autoSizeNotify.notify();
        }
    }
    async updateData() {
        this.series.forEach((s)=>s.setChartData(this.data));
        const modulePromises = this.modulesManager.mapModules((m)=>m.updateData?.(this.data));
        await Promise.all(modulePromises);
    }
    async processData() {
        if (this.series.some((s)=>s.canHaveAxes)) {
            this.assignAxesToSeries();
            this.assignSeriesToAxes();
        }
        const dataController = new $d77b025aa58d633c$var$DataController(this.mode, this.suppressFieldDotNotation);
        const seriesPromises = this.series.map((s)=>s.processData(dataController));
        const modulePromises = this.modulesManager.mapModules((m)=>m.processData?.(dataController));
        this._cachedData = dataController.execute(this._cachedData);
        await Promise.all([
            ...seriesPromises,
            ...modulePromises
        ]);
        this.updateLegends();
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    async processDomains() {
        for (const axis of this.axes)axis.processData();
        for (const series of this.series)series.updatedDomains();
    }
    updateLegends(initialStateLegend) {
        for (const { legend: legend, legendType: legendType } of this.modulesManager.legends())if (legendType === "category") this.setCategoryLegendData(initialStateLegend);
        else this.setLegendData(legendType, legend);
    }
    setCategoryLegendData(initialState) {
        var _a;
        const { ctx: { legendManager: legendManager, stateManager: stateManager } } = this;
        if (initialState) this.series.forEach((s)=>{
            const seriesState = initialState.find((init)=>init.seriesId === s.id);
            s.onLegendInitialState("category", seriesState);
        });
        const legendData = this.series.flatMap((s)=>{
            const seriesLegendData = s.getLegendData("category");
            legendManager.updateData(s.id, seriesLegendData);
            return seriesLegendData;
        });
        if (initialState) {
            stateManager.setStateAndRestore(legendManager, initialState);
            return;
        }
        if (this.mode !== "integrated") {
            const seriesMarkerFills = {};
            const seriesTypeMap = new Map(this.series.map((s)=>[
                    s.id,
                    s.type
                ]));
            for (const { seriesId: seriesId, symbol: { marker: marker }, label: label } of legendData.filter((d)=>!d.hideInLegend)){
                if (marker.fill == null) continue;
                const seriesType = seriesTypeMap.get(seriesId);
                const markerFill = seriesMarkerFills[seriesType] ?? (seriesMarkerFills[seriesType] = {});
                markerFill[_a = label.text] ?? (markerFill[_a] = marker.fill);
                if (markerFill[label.text] !== marker.fill) (0, $idDdm.Logger).warnOnce(`legend item '${label.text}' has multiple fill colors, this may cause unexpected behaviour.`);
            }
        }
        legendManager.update();
    }
    setLegendData(legendType, legend) {
        legend.data = this.series.filter((s)=>s.properties.showInLegend).flatMap((s)=>s.getLegendData(legendType));
    }
    async processLayout() {
        const oldRect = this.animationRect;
        const { width: width2, height: height2 } = this.ctx.scene;
        const ctx = this.ctx.layoutManager.createContext(width2, height2);
        await this.performLayout(ctx);
        if (oldRect && !this.animationRect?.equals(oldRect)) this.ctx.animationManager.skipCurrentBatch();
        this.debug("Chart.performUpdate() - seriesRect", this.seriesRect);
    }
    async updateSeries(seriesToUpdate) {
        const { seriesRect: seriesRect } = this;
        await Promise.all(seriesToUpdate.map((series)=>series.update({
                seriesRect: seriesRect
            })));
        this.ctx.seriesLabelLayoutManager.updateLabels(this.series.filter((s)=>s.visible && s.usesPlacedLabels), this.padding, this.seriesRect);
    }
    async waitForUpdate(timeoutMs = 1e4, failOnTimeout = false) {
        const start2 = performance.now();
        while(this._pendingFactoryUpdatesCount > 0 || this.performUpdateType !== 8 /* NONE */  || this.runningUpdateType !== 8 /* NONE */  || this.ctx.scene.waitingForUpdate()){
            if (this.destroyed) break;
            if (this._pendingFactoryUpdatesCount > 0) await this.updateMutex.waitForClearAcquireQueue();
            if (this.performUpdateType !== 8 /* NONE */  || this.runningUpdateType !== 8 /* NONE */ ) await this._performUpdateNotify.await();
            if (performance.now() - start2 > timeoutMs) {
                const message = `Chart.waitForUpdate() timeout of ${timeoutMs} reached - first chart update taking too long.`;
                if (failOnTimeout) throw new Error(message);
                else (0, $idDdm.Logger).warnOnce(message);
            }
            if ($d77b025aa58d633c$var$isInputPending()) await (0, $idDdm.pause)();
            if (this.ctx.scene.waitingForUpdate()) await (0, $idDdm.pause)(50);
        }
    }
    filterMiniChartSeries(series) {
        return series?.filter((s)=>s.showInMiniChart !== false);
    }
    applyOptions(newChartOptions) {
        const deltaOptions = this.firstApply ? newChartOptions.processedOptions : newChartOptions.diffOptions(this.chartOptions);
        if (deltaOptions == null || Object.keys(deltaOptions).length === 0) return;
        const oldOpts = this.firstApply ? {} : this.chartOptions.processedOptions;
        const newOpts = newChartOptions.processedOptions;
        $d77b025aa58d633c$var$debug("Chart.applyOptions() - applying delta", deltaOptions);
        const modulesChanged = this.applyModules(newOpts);
        const skip = [
            "type",
            "data",
            "series",
            "listeners",
            "preset",
            "theme",
            "legend.listeners",
            "navigator.miniChart.series",
            "navigator.miniChart.label",
            "locale.localeText",
            "axes",
            "topology",
            "nodes",
            "initialState",
            "styleContainer"
        ];
        if (deltaOptions.listeners) this.registerListeners(this, deltaOptions.listeners);
        $d77b025aa58d633c$var$jsonApply(this, deltaOptions, {
            skip: skip
        });
        let forceNodeDataRefresh = false;
        let seriesStatus = "no-op";
        if (deltaOptions.series != null) {
            seriesStatus = this.applySeries(this, deltaOptions.series, oldOpts?.series);
            forceNodeDataRefresh = true;
        }
        if (seriesStatus === "replaced") this.resetAnimations();
        if (this.applyAxes(this, newOpts, oldOpts, seriesStatus, [])) forceNodeDataRefresh = true;
        if (deltaOptions.data) this.data = deltaOptions.data;
        if (deltaOptions.legend?.listeners && this.modulesManager.isEnabled("legend")) Object.assign(this.legend.listeners, deltaOptions.legend.listeners);
        if (deltaOptions.locale?.localeText) this.modulesManager.getModule("locale").localeText = deltaOptions.locale?.localeText;
        this.chartOptions = newChartOptions;
        const navigatorModule = this.modulesManager.getModule("navigator");
        const zoomModule = this.modulesManager.getModule("zoom");
        if (!navigatorModule?.enabled && !zoomModule?.enabled) this.ctx.zoomManager.updateZoom("chart");
        const miniChart = navigatorModule?.miniChart;
        const miniChartSeries = newOpts.navigator?.miniChart?.series ?? newOpts.series;
        if (miniChart?.enabled === true && miniChartSeries != null) this.applyMiniChartOptions(miniChart, miniChartSeries, newOpts, oldOpts);
        else if (miniChart?.enabled === false) {
            miniChart.series = [];
            miniChart.axes = [];
        }
        this.ctx.annotationManager.setAnnotationStyles(newChartOptions.annotationThemes);
        forceNodeDataRefresh || (forceNodeDataRefresh = this.shouldForceNodeDataRefresh(deltaOptions, seriesStatus));
        const majorChange = forceNodeDataRefresh || modulesChanged;
        const updateType = majorChange ? 0 /* FULL */  : 4 /* PERFORM_LAYOUT */ ;
        this.maybeResetAnimations(seriesStatus);
        if (this.shouldClearLegendData(newOpts, oldOpts, seriesStatus)) this.ctx.legendManager.clearData();
        this.applyInitialState(newOpts);
        $d77b025aa58d633c$var$debug("Chart.applyOptions() - update type", $d77b025aa58d633c$var$ChartUpdateType[updateType], {
            seriesStatus: seriesStatus,
            forceNodeDataRefresh: forceNodeDataRefresh
        });
        this.update(updateType, {
            apiUpdate: true,
            forceNodeDataRefresh: forceNodeDataRefresh,
            newAnimationBatch: true
        });
        this.firstApply = false;
    }
    applyInitialState(options) {
        const { annotationManager: annotationManager, chartTypeOriginator: chartTypeOriginator, historyManager: historyManager, stateManager: stateManager, zoomManager: zoomManager } = this.ctx;
        const { initialState: initialState } = options;
        if ("annotations" in options && options.annotations?.enabled && initialState?.annotations != null) {
            const annotations = initialState.annotations.map((annotation)=>{
                const annotationTheme = annotationManager.getAnnotationTypeStyles(annotation.type);
                return $d77b025aa58d633c$var$mergeDefaults(annotation, annotationTheme);
            });
            stateManager.setState(annotationManager, annotations);
        }
        if (initialState?.chartType != null) stateManager.setState(chartTypeOriginator, initialState.chartType);
        if ((options.navigator?.enabled || options.zoom?.enabled) && initialState?.zoom != null) stateManager.setState(zoomManager, initialState.zoom);
        if (initialState?.legend != null) this.updateLegends(initialState.legend);
        if (initialState != null) historyManager.clear();
    }
    maybeResetAnimations(seriesStatus) {
        if (this.mode !== "standalone") return;
        switch(seriesStatus){
            case "series-grouping-change":
            case "replaced":
                this.resetAnimations();
                break;
            default:
        }
    }
    shouldForceNodeDataRefresh(deltaOptions, seriesStatus) {
        const seriesDataUpdate = !!deltaOptions.data || seriesStatus === "data-change" || seriesStatus === "replaced";
        const legendKeys = $d77b025aa58d633c$var$legendRegistry.getKeys();
        const optionsHaveLegend = Object.values(legendKeys).some((legendKey)=>deltaOptions[legendKey] != null);
        const otherRefreshUpdate = deltaOptions.title != null && deltaOptions.subtitle != null;
        return seriesDataUpdate || optionsHaveLegend || otherRefreshUpdate;
    }
    shouldClearLegendData(options, oldOpts, seriesStatus) {
        const seriesChanged = seriesStatus === "replaced" || seriesStatus === "series-grouping-change" || seriesStatus === "updated" && (options.series?.length !== oldOpts.series?.length || !options.series?.every((s, i)=>s.type === oldOpts.series?.[i].type));
        const legendRemoved = oldOpts.legend != null && options.legend == null;
        return seriesChanged || legendRemoved;
    }
    applyMiniChartOptions(miniChart, miniChartSeries, completeOptions, oldOpts) {
        const oldSeries = oldOpts?.navigator?.miniChart?.series ?? oldOpts?.series;
        const miniChartSeriesStatus = this.applySeries(miniChart, this.filterMiniChartSeries(miniChartSeries), this.filterMiniChartSeries(oldSeries));
        this.applyAxes(miniChart, completeOptions, oldOpts, miniChartSeriesStatus, [
            "axes[].tick",
            "axes[].thickness",
            "axes[].title",
            "axes[].crosshair",
            "axes[].gridLine",
            "axes[].label"
        ]);
        const series = miniChart.series;
        for (const s of series)s.properties.id = void 0;
        const axes = miniChart.axes;
        const horizontalAxis = axes.find((axis)=>axis.direction === "x" /* X */ );
        for (const axis of axes){
            axis.nice = false;
            axis.gridLine.enabled = false;
            axis.label.enabled = axis === horizontalAxis;
            axis.tick.enabled = false;
            axis.interactionEnabled = false;
        }
        if (horizontalAxis != null) {
            const miniChartOpts = completeOptions.navigator?.miniChart;
            const labelOptions = miniChartOpts?.label;
            const intervalOptions = miniChartOpts?.label?.interval;
            horizontalAxis.line.enabled = false;
            horizontalAxis.label.set($d77b025aa58d633c$var$without(labelOptions, [
                "interval",
                "rotation",
                "minSpacing",
                "autoRotate",
                "autoRotateAngle"
            ]));
            horizontalAxis.tick.set($d77b025aa58d633c$var$without(intervalOptions, [
                "enabled",
                "width",
                "size",
                "color",
                "interval",
                "step"
            ]));
            if (horizontalAxis.type === "grouped-category") {
                horizontalAxis.label.enabled = false;
                horizontalAxis.label.rotation = 0;
                const { depthOptions: depthOptions } = horizontalAxis;
                if (depthOptions.length === 0) depthOptions.set([
                    {
                        label: {
                            enabled: true
                        }
                    }
                ]);
                else for(let i = 1; i < depthOptions.length; i++)depthOptions[i].label.enabled = false;
            } else if (horizontalAxis.type === "time" || horizontalAxis.type === "unit-time" || horizontalAxis.type === "ordinal-time") horizontalAxis.parentLevel.enabled = false;
            const step = intervalOptions?.step;
            if (step != null) horizontalAxis.interval.step = step;
        }
    }
    applyModules(options) {
        const { type: chartType } = this.constructor;
        let modulesChanged = false;
        for (const module of $d77b025aa58d633c$var$moduleRegistry.byType("root", "legend")){
            const isConfigured = options[module.optionsKey] != null;
            const shouldBeEnabled = isConfigured && module.chartTypes.includes(chartType);
            if (shouldBeEnabled === this.modulesManager.isEnabled(module)) continue;
            if (shouldBeEnabled) {
                this.modulesManager.addModule(module, (m)=>m.moduleFactory(this.getModuleContext()));
                if (module.type === "legend") this.modulesManager.getModule(module)?.attachLegend(this.ctx.scene);
                this[module.optionsKey] = this.modulesManager.getModule(module);
            } else {
                this.modulesManager.removeModule(module);
                delete this[module.optionsKey];
            }
            modulesChanged = true;
        }
        return modulesChanged;
    }
    initSeriesDeclarationOrder(series) {
        for(let idx = 0; idx < series.length; idx++)series[idx].setSeriesIndex(idx);
    }
    applySeries(chart, optSeries, oldOptSeries) {
        if (!optSeries) return "no-change";
        const matchResult = $d77b025aa58d633c$var$matchSeriesOptions(chart.series, optSeries, oldOptSeries);
        if (matchResult.status === "no-overlap") {
            $d77b025aa58d633c$var$debug(`Chart.applySeries() - creating new series instances, status: ${matchResult.status}`, matchResult);
            const chartSeries = optSeries.map((opts)=>this.createSeries(opts));
            this.initSeriesDeclarationOrder(chartSeries);
            chart.series = chartSeries;
            return "replaced";
        }
        $d77b025aa58d633c$var$debug(`Chart.applySeries() - matchResult`, matchResult);
        const seriesInstances = [];
        let dataChanged = false;
        let groupingChanged = false;
        let isUpdated = false;
        const changes = matchResult.changes.toSorted((a, b)=>a.targetIdx - b.targetIdx);
        for (const change of changes){
            groupingChanged || (groupingChanged = change.status === "series-grouping");
            dataChanged || (dataChanged = change.diff?.data != null);
            isUpdated || (isUpdated = change.status !== "no-op");
            switch(change.status){
                case "add":
                    {
                        const newSeries = this.createSeries(change.opts);
                        seriesInstances.push(newSeries);
                        $d77b025aa58d633c$var$debug(`Chart.applySeries() - created new series`, newSeries);
                        break;
                    }
                case "remove":
                    $d77b025aa58d633c$var$debug(`Chart.applySeries() - removing series at previous idx ${change.idx}`, change.series);
                    break;
                case "no-op":
                    seriesInstances.push(change.series);
                    $d77b025aa58d633c$var$debug(`Chart.applySeries() - no change to series at previous idx ${change.idx}`, change.series);
                    break;
                case "series-grouping":
                case "update":
                default:
                    {
                        const { series: series, diff: diff2, idx: idx } = change;
                        $d77b025aa58d633c$var$debug(`Chart.applySeries() - applying series diff previous idx ${idx}`, diff2, series);
                        this.applySeriesValues(series, diff2);
                        series.markNodeDataDirty();
                        seriesInstances.push(series);
                    }
            }
        }
        this.initSeriesDeclarationOrder(seriesInstances);
        $d77b025aa58d633c$var$debug(`Chart.applySeries() - final series instances`, seriesInstances);
        chart.series = seriesInstances;
        if (groupingChanged) return "series-grouping-change";
        if (dataChanged) return "data-change";
        return isUpdated ? "updated" : "no-op";
    }
    applyAxes(chart, options, oldOpts, seriesStatus, skip = []) {
        if (!("axes" in options) || !options.axes) return false;
        skip = [
            "axes[].type",
            ...skip
        ];
        const axes = options.axes.map((axis)=>{
            if (axis.type === "time" && axis.unit != null) return {
                ...axis,
                type: "unit-time"
            };
            return axis;
        });
        const forceRecreate = seriesStatus === "replaced";
        const matchingTypes = !forceRecreate && chart.axes.length === axes.length && chart.axes.every((a, i)=>a.type === axes[i].type);
        if (matchingTypes && $d77b025aa58d633c$var$isAgCartesianChartOptions(oldOpts)) {
            chart.axes.forEach((axis, index)=>{
                const previousOpts = oldOpts.axes?.[index] ?? {};
                const axisDiff = $d77b025aa58d633c$var$jsonDiff(previousOpts, axes[index]);
                $d77b025aa58d633c$var$debug(`Chart.applyAxes() - applying axis diff idx ${index}`, axisDiff);
                const path = `axes[${index}]`;
                $d77b025aa58d633c$var$jsonApply(axis, axisDiff, {
                    path: path,
                    skip: skip
                });
            });
            return true;
        }
        $d77b025aa58d633c$var$debug(`Chart.applyAxes() - creating new axes instances; seriesStatus: ${seriesStatus}`);
        chart.axes = this.createAxis(axes, skip);
        return true;
    }
    createSeries(seriesOptions) {
        const seriesInstance = $d77b025aa58d633c$var$seriesRegistry.create(seriesOptions.type, this.getModuleContext());
        this.applySeriesOptionModules(seriesInstance, seriesOptions);
        this.applySeriesValues(seriesInstance, seriesOptions);
        return seriesInstance;
    }
    applySeriesOptionModules(series, options) {
        const moduleContext = series.createModuleContext();
        const moduleMap = series.getModuleMap();
        for (const module of $d77b025aa58d633c$var$moduleRegistry.byType("series-option"))if (module.optionsKey in options && module.seriesTypes.includes(series.type)) moduleMap.addModule(module, (m)=>m.moduleFactory(moduleContext));
    }
    applySeriesValues(target, options) {
        const moduleMap = target.getModuleMap();
        const { type: _, data: data, listeners: listeners, seriesGrouping: seriesGrouping, showInMiniChart: __, ...seriesOptions } = options;
        for (const moduleDef of $d77b025aa58d633c$var$EXPECTED_ENTERPRISE_MODULES){
            if (moduleDef.type !== "series-option") continue;
            if (moduleDef.optionsKey in seriesOptions) {
                const module = moduleMap.getModule(moduleDef.optionsKey);
                if (module) {
                    const moduleOptions = seriesOptions[moduleDef.optionsKey];
                    delete seriesOptions[moduleDef.optionsKey];
                    module.properties.set(moduleOptions);
                }
            }
        }
        if (seriesOptions.visible != null) target.visible = seriesOptions.visible;
        target.properties.set(seriesOptions);
        if ("data" in options) target.setOptionsData(data);
        if (listeners) this.registerListeners(target, listeners, {
            nodeClick: "seriesNodeClick",
            nodeDoubleClick: "seriesNodeDoubleClick"
        });
        if ("seriesGrouping" in options) {
            if (seriesGrouping == null) target.seriesGrouping = void 0;
            else target.seriesGrouping = {
                ...target.seriesGrouping,
                ...seriesGrouping
            };
        }
    }
    createAxis(options, skip) {
        const newAxes = [];
        const moduleContext = this.getModuleContext();
        for(let index = 0; index < options.length; index++){
            const axisOptions = options[index];
            const axis = $d77b025aa58d633c$var$axisRegistry.create(axisOptions.type, moduleContext);
            this.applyAxisModules(axis, axisOptions);
            $d77b025aa58d633c$var$jsonApply(axis, axisOptions, {
                path: `axes[${index}]`,
                skip: skip
            });
            newAxes.push(axis);
        }
        $d77b025aa58d633c$var$guessInvalidPositions(newAxes);
        return newAxes;
    }
    applyAxisModules(axis, options) {
        const moduleContext = axis.createModuleContext();
        const moduleMap = axis.getModuleMap();
        for (const module of $d77b025aa58d633c$var$moduleRegistry.byType("axis-option")){
            const shouldBeEnabled = options[module.optionsKey] != null;
            if (shouldBeEnabled === moduleMap.isEnabled(module)) continue;
            if (shouldBeEnabled) {
                moduleMap.addModule(module, (m)=>m.moduleFactory(moduleContext));
                axis[module.optionsKey] = moduleMap.getModule(module);
            } else {
                moduleMap.removeModule(module);
                delete axis[module.optionsKey];
            }
        }
    }
    registerListeners(source, listeners, mapping) {
        source.clearEventListeners();
        for (const [property, listener] of (0, $idDdm.entries)(listeners))if ((0, $idDdm.isFunction)(listener)) {
            const mappedEventName = mapping?.[property];
            if (mappedEventName == null) source.addEventListener(property, listener);
            else source.addEventListener(mappedEventName, (e)=>{
                if (e?.type === mappedEventName) {
                    const clone2 = new Proxy(e, {
                        get (target, p, receiver) {
                            return p === "type" ? property : Reflect.get(target, p, receiver);
                        }
                    });
                    listener(clone2);
                } else listener(e);
            });
        }
    }
};
$d77b025aa58d633c$var$_Chart.chartsInstances = /* @__PURE__ */ new WeakMap();
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        newValue (value) {
            if (this.destroyed) return;
            this.ctx.domManager.setContainer(value);
            $d77b025aa58d633c$var$_Chart.chartsInstances.set(value, this);
        },
        oldValue (value) {
            $d77b025aa58d633c$var$_Chart.chartsInstances.delete(value);
        }
    })
], $d77b025aa58d633c$var$_Chart.prototype, "container", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        newValue (value) {
            this.resize("width option", {
                inWidth: value
            });
        }
    })
], $d77b025aa58d633c$var$_Chart.prototype, "width", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        newValue (value) {
            this.resize("height option", {
                inHeight: value
            });
        }
    })
], $d77b025aa58d633c$var$_Chart.prototype, "height", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        newValue (value) {
            this.resize("minWidth option", {
                inMinWidth: value
            });
        }
    })
], $d77b025aa58d633c$var$_Chart.prototype, "minWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        newValue (value) {
            this.resize("minHeight option", {
                inMinHeight: value
            });
        }
    })
], $d77b025aa58d633c$var$_Chart.prototype, "minHeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        newValue (value) {
            this.resize("overrideDevicePixelRatio option", {
                inOverrideDevicePixelRatio: value
            });
        }
    })
], $d77b025aa58d633c$var$_Chart.prototype, "overrideDevicePixelRatio", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_Chart.prototype, "padding", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_Chart.prototype, "seriesArea", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_Chart.prototype, "keyboard", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_Chart.prototype, "touch", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_Chart.prototype, "mode", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_Chart.prototype, "styleNonce", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("chartCaptions.title")
], $d77b025aa58d633c$var$_Chart.prototype, "title", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("chartCaptions.subtitle")
], $d77b025aa58d633c$var$_Chart.prototype, "subtitle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("chartCaptions.footnote")
], $d77b025aa58d633c$var$_Chart.prototype, "footnote", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_Chart.prototype, "suppressFieldDotNotation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_Chart.prototype, "loadGoogleFonts", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        changeValue (newValue, oldValue) {
            this.onAxisChange(newValue, oldValue);
        }
    })
], $d77b025aa58d633c$var$_Chart.prototype, "axes", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        changeValue (newValue, oldValue) {
            this.onSeriesChange(newValue, oldValue);
        }
    })
], $d77b025aa58d633c$var$_Chart.prototype, "series", 2);
var $d77b025aa58d633c$var$Chart = $d77b025aa58d633c$var$_Chart;
// packages/ag-charts-community/src/chart/chartProxy.ts
var $d77b025aa58d633c$var$debug2 = $d77b025aa58d633c$var$Debug.create(true, "opts");
var $d77b025aa58d633c$var$DESTROYED_ERROR = "AG Charts - Chart was destroyed, cannot perform request.";
var $d77b025aa58d633c$var$_AgChartInstanceProxy = class _AgChartInstanceProxy {
    constructor(chart, factoryApi, licenseManager){
        this.factoryApi = factoryApi;
        this.licenseManager = licenseManager;
        this.chart = chart;
    }
    async update(options) {
        if (!this.chart) throw new Error($d77b025aa58d633c$var$DESTROYED_ERROR);
        return $d77b025aa58d633c$var$debug2.group("AgChartInstance.update()", async ()=>{
            this.factoryApi.update(options, this);
            await this.chart?.waitForUpdate();
        });
    }
    async updateDelta(deltaOptions) {
        if (!this.chart) throw new Error($d77b025aa58d633c$var$DESTROYED_ERROR);
        return $d77b025aa58d633c$var$debug2.group("AgChartInstance.updateDelta()", async ()=>{
            this.factoryApi.updateUserDelta(this, deltaOptions);
            await this.chart?.waitForUpdate();
        });
    }
    getOptions() {
        if (!this.chart) throw new Error($d77b025aa58d633c$var$DESTROYED_ERROR);
        const options = $d77b025aa58d633c$var$deepClone(this.chart.getOptions());
        for (const key of Object.keys(options))if (key.startsWith("_")) delete options[key];
        return options;
    }
    waitForUpdate() {
        if (!this.chart) throw new Error($d77b025aa58d633c$var$DESTROYED_ERROR);
        return this.chart.waitForUpdate();
    }
    async download(opts) {
        if (!this.chart) throw new Error($d77b025aa58d633c$var$DESTROYED_ERROR);
        const clone2 = await this.prepareResizedChart(this, this.chart, opts);
        try {
            clone2.chart?.download(opts?.fileName, opts?.fileFormat);
        } finally{
            clone2.destroy();
        }
    }
    async __toSVG(opts) {
        if (!this.chart) throw new Error($d77b025aa58d633c$var$DESTROYED_ERROR);
        const clone2 = await this.prepareResizedChart(this, this.chart, {
            width: 600,
            height: 300,
            ...opts
        });
        try {
            return clone2?.chart?.toSVG();
        } finally{
            clone2?.destroy();
        }
    }
    async getImageDataURL(opts) {
        if (!this.chart) throw new Error($d77b025aa58d633c$var$DESTROYED_ERROR);
        const clone2 = await this.prepareResizedChart(this, this.chart, opts);
        try {
            return clone2.chart.getCanvasDataURL(opts?.fileFormat);
        } finally{
            clone2.destroy();
        }
    }
    getState() {
        return this.factoryApi.caretaker.save(...this.getEnabledOriginators());
    }
    async setState(state) {
        const { chart: chart } = this;
        if (!chart) return;
        const originators = this.getEnabledOriginators();
        if (!originators.includes(chart.ctx.legendManager)) {
            await this.setStateOriginators(state, originators);
            return;
        }
        await this.setStateOriginators(state, originators.filter((originator)=>originator !== chart.ctx.zoomManager));
        await this.setStateOriginators(state, [
            chart.ctx.zoomManager
        ]);
    }
    resetAnimations() {
        this.chart?.resetAnimations();
    }
    skipAnimations() {
        this.chart?.skipAnimations();
    }
    destroy() {
        if (this.releaseChart) {
            this.releaseChart();
            this.releaseChart = void 0;
        } else if (this.chart) {
            this.chart.publicApi = void 0;
            this.chart.destroy();
        }
        this.chart = void 0;
    }
    async prepareResizedChart(proxy, chart, opts = {}) {
        const width2 = opts.width ?? chart.width ?? chart.ctx.scene.canvas.width;
        const height2 = opts.height ?? chart.height ?? chart.ctx.scene.canvas.height;
        const state = proxy.getState();
        const isEnterprise = $d77b025aa58d633c$var$moduleRegistry.hasEnterpriseModules();
        const processedOverrides = {
            ...chart.chartOptions.processedOverrides,
            container: document.createElement("div"),
            width: width2,
            height: height2
        };
        if (opts.width != null && opts.height != null) processedOverrides.overrideDevicePixelRatio = 1;
        const userOptions = chart.getOptions();
        if (isEnterprise) {
            processedOverrides.animation = {
                enabled: false
            };
            if (this.licenseManager?.isDisplayWatermark()) processedOverrides.foreground = {
                text: this.licenseManager.getWatermarkMessage(),
                image: {
                    url: `data:image/svg+xml;base64,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`,
                    width: 170,
                    height: 25,
                    right: 25,
                    bottom: 50,
                    opacity: 0.7
                }
            };
        }
        const specialOverrides = {
            ...chart.chartOptions.specialOverrides
        };
        const optionsMetadata = {
            ...chart.chartOptions.optionMetadata
        };
        const cloneProxy = this.factoryApi.create(userOptions, processedOverrides, specialOverrides, optionsMetadata);
        await cloneProxy.setState(state);
        cloneProxy.chart?.ctx.zoomManager.updateZoom("chartProxy", chart.ctx.zoomManager.getZoom());
        cloneProxy.chart?.ctx.legendManager.clearData();
        cloneProxy.chart?.ctx.legendManager.update(chart.ctx.legendManager.getData());
        chart.series.forEach((series, index)=>{
            cloneProxy.chart.series[index].visible = series.visible;
        });
        const legendPages = [];
        for (const legend of chart.modulesManager.legends())legendPages.push(legend.legend.pagination?.currentPage ?? 0);
        for (const legend of cloneProxy.chart.modulesManager.legends()){
            const page = legendPages.shift() ?? 0;
            if (!legend.legend.pagination) continue;
            legend.legend.pagination.setPage(page);
        }
        cloneProxy.chart?.update(0 /* FULL */ , {
            forceNodeDataRefresh: true
        });
        await cloneProxy.waitForUpdate();
        return cloneProxy;
    }
    getEnabledOriginators() {
        if (!this.chart) return [];
        const { chartOptions: { processedOptions: processedOptions, optionMetadata: optionMetadata }, ctx: { annotationManager: annotationManager, chartTypeOriginator: chartTypeOriginator, zoomManager: zoomManager, legendManager: legendManager } } = this.chart;
        const originators = [];
        if ("annotations" in processedOptions && processedOptions.annotations?.enabled) originators.push(annotationManager);
        const isFinancialChart = optionMetadata.presetType === "price-volume";
        if (isFinancialChart) originators.push(chartTypeOriginator);
        if (processedOptions.navigator?.enabled || processedOptions.zoom?.enabled) originators.push(zoomManager);
        if ("legend" in this.chart) originators.push(legendManager);
        return originators;
    }
    async setStateOriginators(state, originators) {
        this.factoryApi.caretaker.restore(state, ...originators);
        this.chart?.ctx.updateService.update(2 /* PROCESS_DATA */ , {
            forceNodeDataRefresh: true
        });
        await this.chart?.waitForUpdate();
    }
};
$d77b025aa58d633c$var$_AgChartInstanceProxy.chartInstances = /* @__PURE__ */ new WeakMap();
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        oldValue (chart) {
            if (!chart.destroyed) chart.publicApi = void 0;
            $d77b025aa58d633c$var$_AgChartInstanceProxy.chartInstances.delete(chart);
        },
        newValue (chart) {
            if (!chart) return;
            chart.publicApi = this;
            $d77b025aa58d633c$var$_AgChartInstanceProxy.chartInstances.set(chart, this);
        }
    })
], $d77b025aa58d633c$var$_AgChartInstanceProxy.prototype, "chart", 2);
var $d77b025aa58d633c$var$AgChartInstanceProxy = $d77b025aa58d633c$var$_AgChartInstanceProxy;
// packages/ag-charts-community/src/locale/locale.ts
var $d77b025aa58d633c$var$Locale = class extends $d77b025aa58d633c$var$BaseModuleInstance {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.localeText = void 0;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target)=>{
        target.ctx.localeManager.setLocaleText(target.localeText);
    }),
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Locale.prototype, "localeText", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target)=>{
        target.ctx.localeManager.setLocaleTextFormatter(target.getLocaleText);
    }),
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Locale.prototype, "getLocaleText", 2);
// packages/ag-charts-community/src/locale/localeModule.ts
var $d77b025aa58d633c$var$LocaleModule = {
    type: "root",
    optionsKey: "locale",
    packageType: "community",
    chartTypes: [
        "cartesian",
        "polar",
        "hierarchy",
        "topology",
        "flow-proportion",
        "standalone",
        "gauge"
    ],
    moduleFactory: (ctx)=>new $d77b025aa58d633c$var$Locale(ctx)
};
function $d77b025aa58d633c$var$filterVisibleTicks(ticks, reversed, visibleRange) {
    if (visibleRange == null || visibleRange[0] === 0 && visibleRange[1] === 1) return {
        ticks: ticks,
        count: ticks.length
    };
    const vt0 = (0, $idDdm.clamp)(0, Math.floor(visibleRange[0] * ticks.length), ticks.length);
    const vt1 = (0, $idDdm.clamp)(0, Math.ceil(visibleRange[1] * ticks.length), ticks.length);
    const t0 = reversed ? ticks.length - vt1 : vt0;
    const t1 = reversed ? ticks.length - vt0 : vt1;
    return {
        ticks: ticks.slice(t0, t1),
        count: ticks.length
    };
}
// packages/ag-charts-community/src/scale/categoryScale.ts
var $d77b025aa58d633c$var$CategoryScale = class _CategoryScale extends $d77b025aa58d633c$var$BandScale {
    constructor(){
        super(...arguments);
        this.type = "band";
        /**
     * Maps datum to its index in the {@link domain} array.
     * Used to check for duplicate data (not allowed).
     */ this.index = void 0;
        /**
     * Contains unique data only.
     */ this._domain = [];
    }
    static is(value) {
        return value instanceof _CategoryScale;
    }
    set domain(values) {
        if (this._domain === values) return;
        this.invalid = true;
        this._domain = values;
        this.index = void 0;
    }
    get domain() {
        return this._domain;
    }
    get bands() {
        return this._domain;
    }
    normalizeDomains(...domains) {
        let normalizedDomain = void 0;
        const seenDomains = /* @__PURE__ */ new Set();
        let animatable = true;
        for (const domain of domains){
            if (seenDomains.has(domain)) continue;
            seenDomains.add(domain);
            if (normalizedDomain == null) normalizedDomain = $d77b025aa58d633c$var$deduplicateCategories(domain);
            else {
                animatable && (animatable = $d77b025aa58d633c$var$domainOrderedToNormalizedDomain(domain, normalizedDomain));
                normalizedDomain = $d77b025aa58d633c$var$deduplicateCategories([
                    ...normalizedDomain,
                    ...domain
                ]);
            }
        }
        normalizedDomain ?? (normalizedDomain = []);
        return {
            domain: normalizedDomain,
            animatable: animatable
        };
    }
    toDomain(_value) {
        return void 0;
    }
    invert(position, nearest = false) {
        this.refresh();
        const offset4 = nearest ? this.bandwidth / 2 : 0;
        const index = this.invertNearestIndex(Math.max(0, position - offset4));
        const matches = nearest || position === this.ordinalRange(index);
        return matches ? this.domain[index] : void 0;
    }
    ticks(_params, domain = this.domain, visibleRange) {
        return $d77b025aa58d633c$var$filterVisibleTicks(domain, false, visibleRange);
    }
    findIndex(value) {
        let { index: index } = this;
        if (index == null) {
            const { domain: domain } = this;
            index = /* @__PURE__ */ new Map();
            for(let i = 0; i < domain.length; i++)index.set($d77b025aa58d633c$var$dateToNumber(domain[i]), i);
            this.index = index;
        }
        return index.get($d77b025aa58d633c$var$dateToNumber(value));
    }
};
function $d77b025aa58d633c$var$deduplicateCategories(d) {
    let domain;
    const uniqueValues = /* @__PURE__ */ new Set();
    for (const value of d){
        const key = $d77b025aa58d633c$var$dateToNumber(value);
        const lastSize = uniqueValues.size;
        uniqueValues.add(key);
        const isUniqueValue = uniqueValues.size !== lastSize;
        if (isUniqueValue) domain?.push(value);
        else domain ?? (domain = d.slice(0, uniqueValues.size));
    }
    return domain ?? d;
}
function $d77b025aa58d633c$var$domainOrderedToNormalizedDomain(domain, normalizedDomain) {
    let normalizedIndex = -1;
    for (const value of domain){
        const normalizedNextIndex = normalizedDomain.indexOf(value);
        if (normalizedNextIndex === -1) normalizedIndex = Infinity;
        else if (normalizedNextIndex <= normalizedIndex) return false;
        else normalizedIndex = normalizedNextIndex;
    }
    return true;
}
// packages/ag-charts-community/src/chart/axis/categoryAxis.ts
var $d77b025aa58d633c$var$_CategoryAxis = class _CategoryAxis extends $d77b025aa58d633c$var$CartesianAxis {
    constructor(moduleCtx, scale2 = new $d77b025aa58d633c$var$CategoryScale()){
        super(moduleCtx, scale2);
        this.groupPaddingInner = 0.1;
        this.includeInvisibleDomains = true;
        this.nice = false;
    }
    static is(value) {
        return value instanceof _CategoryAxis;
    }
    normaliseDataDomain(domain) {
        return {
            domain: domain,
            clipped: false
        };
    }
    updateScale() {
        super.updateScale();
        let { paddingInner: paddingInner, paddingOuter: paddingOuter } = this;
        if (!(0, $idDdm.isFiniteNumber)(paddingInner) || !(0, $idDdm.isFiniteNumber)(paddingOuter)) {
            const padding = this.reduceBandScalePadding();
            paddingInner ?? (paddingInner = padding.inner);
            paddingOuter ?? (paddingOuter = padding.outer);
        }
        this.scale.paddingInner = paddingInner ?? 0;
        this.scale.paddingOuter = paddingOuter ?? 0;
    }
    reduceBandScalePadding() {
        return this.boundSeries.reduce((result, series)=>{
            const padding = series.getBandScalePadding?.();
            if (padding) {
                if (result.inner > padding.inner) result.inner = padding.inner;
                if (result.outer < padding.outer) result.outer = padding.outer;
            }
            return result;
        }, {
            inner: Infinity,
            outer: -Infinity
        });
    }
};
$d77b025aa58d633c$var$_CategoryAxis.className = "CategoryAxis";
$d77b025aa58d633c$var$_CategoryAxis.type = "category";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_CategoryAxis.prototype, "groupPaddingInner", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_CategoryAxis.prototype, "paddingInner", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$_CategoryAxis.prototype, "paddingOuter", 2);
var $d77b025aa58d633c$var$CategoryAxis = $d77b025aa58d633c$var$_CategoryAxis;
// packages/ag-charts-community/src/scale/groupedCategoryScale.ts
var $d77b025aa58d633c$var$GroupedCategoryScale = class _GroupedCategoryScale extends $d77b025aa58d633c$var$CategoryScale {
    static is(value) {
        return value instanceof _GroupedCategoryScale;
    }
    normalizeDomains(...domains) {
        const { domain: domain } = super.normalizeDomains(...domains);
        return {
            domain: domain,
            animatable: false
        };
    }
    findIndex(value) {
        return super.findIndex(value) ?? this.getMatchIndex(value);
    }
    getMatchIndex(value) {
        const key = JSON.stringify(value);
        const match = this._domain.find((d)=>JSON.stringify(d) === key);
        if (match != null) return super.findIndex(match);
    }
};
// packages/ag-charts-community/src/util/extent.ts
function $d77b025aa58d633c$var$extent(values) {
    if (values.length === 0) return null;
    let min = Infinity;
    let max = -Infinity;
    for (const n of values){
        const v = n instanceof Date ? n.getTime() : n;
        if (typeof v !== "number") continue;
        if (v < min) min = v;
        if (v > max) max = v;
    }
    const result = [
        min,
        max
    ];
    return result.every(isFinite) ? result : null;
}
function $d77b025aa58d633c$var$normalisedExtentWithMetadata(d, min, max) {
    let clipped = false;
    if (d.length > 2) d = $d77b025aa58d633c$var$extent(d) ?? [
        NaN,
        NaN
    ];
    if (min != null) {
        clipped || (clipped = min > d[0]);
        d = [
            min,
            d[1]
        ];
    }
    if (max != null) {
        clipped || (clipped = max < d[1]);
        d = [
            d[0],
            max
        ];
    }
    if (d[0] > d[1]) d = [];
    return {
        extent: d,
        clipped: clipped
    };
}
// packages/ag-charts-community/src/util/memo.ts
var $d77b025aa58d633c$var$memorizedFns = /* @__PURE__ */ new WeakMap();
function $d77b025aa58d633c$var$memo(params, fnGenerator) {
    const serialisedParams = JSON.stringify(params, null, 0);
    if (!$d77b025aa58d633c$var$memorizedFns.has(fnGenerator)) $d77b025aa58d633c$var$memorizedFns.set(fnGenerator, /* @__PURE__ */ new Map());
    if (!$d77b025aa58d633c$var$memorizedFns.get(fnGenerator)?.has(serialisedParams)) $d77b025aa58d633c$var$memorizedFns.get(fnGenerator)?.set(serialisedParams, fnGenerator(params));
    return $d77b025aa58d633c$var$memorizedFns.get(fnGenerator)?.get(serialisedParams);
}
function $d77b025aa58d633c$var$simpleMemorize(fn, cacheCallback2) {
    const primitiveCache = /* @__PURE__ */ new Map();
    const paramsToKeys = (...params)=>{
        return params.map((v)=>{
            if (typeof v === "object") return v;
            if (typeof v === "symbol") return v;
            if (!primitiveCache.has(v)) primitiveCache.set(v, {
                v: v
            });
            return primitiveCache.get(v);
        });
    };
    const empty = {};
    const cache = /* @__PURE__ */ new WeakMap();
    return (...p)=>{
        const keys = p.length === 0 ? [
            empty
        ] : paramsToKeys(...p);
        let currentCache = cache;
        for (const key of keys.slice(0, -1)){
            if (!currentCache.has(key)) currentCache.set(key, /* @__PURE__ */ new WeakMap());
            currentCache = currentCache.get(key);
        }
        const finalKey = keys.at(-1);
        let cachedValue = currentCache.get(finalKey);
        if (cachedValue) cacheCallback2?.("hit", fn, p);
        else {
            cachedValue = fn(...p);
            currentCache.set(finalKey, cachedValue);
            cacheCallback2?.("miss", fn, p);
        }
        return cachedValue;
    };
}
function $d77b025aa58d633c$var$sumValues(values, accumulator = [
    0,
    0
]) {
    for (const value of values){
        if (typeof value !== "number") continue;
        if (value < 0) accumulator[0] += value;
        if (value > 0) accumulator[1] += value;
    }
    return accumulator;
}
function $d77b025aa58d633c$var$sum(id, matchGroupId) {
    const result = {
        id: id,
        matchGroupIds: [
            matchGroupId
        ],
        type: "aggregate",
        aggregateFunction: (values)=>$d77b025aa58d633c$var$sumValues(values)
    };
    return result;
}
function $d77b025aa58d633c$var$groupSum(id, matchGroupId) {
    return {
        id: id,
        type: "aggregate",
        matchGroupIds: matchGroupId ? [
            matchGroupId
        ] : void 0,
        aggregateFunction: (values)=>$d77b025aa58d633c$var$sumValues(values),
        groupAggregateFunction: (next, acc = [
            0,
            0
        ])=>{
            acc[0] += next?.[0] ?? 0;
            acc[1] += next?.[1] ?? 0;
            return acc;
        }
    };
}
function $d77b025aa58d633c$var$range2(id, matchGroupId) {
    const result = {
        id: id,
        matchGroupIds: [
            matchGroupId
        ],
        type: "aggregate",
        aggregateFunction: (values)=>$d77b025aa58d633c$var$ContinuousDomain.extendDomain(values)
    };
    return result;
}
function $d77b025aa58d633c$var$groupCount(id) {
    return {
        id: id,
        type: "aggregate",
        aggregateFunction: ()=>[
                0,
                1
            ],
        groupAggregateFunction: (next, acc = [
            0,
            0
        ])=>{
            acc[0] += next?.[0] ?? 0;
            acc[1] += next?.[1] ?? 0;
            return acc;
        }
    };
}
function $d77b025aa58d633c$var$groupAverage(id, matchGroupId) {
    const def = {
        id: id,
        matchGroupIds: matchGroupId ? [
            matchGroupId
        ] : void 0,
        type: "aggregate",
        aggregateFunction: (values)=>$d77b025aa58d633c$var$sumValues(values),
        groupAggregateFunction: (next, acc = [
            0,
            0,
            -1
        ])=>{
            acc[0] += next?.[0] ?? 0;
            acc[1] += next?.[1] ?? 0;
            acc[2]++;
            return acc;
        },
        finalFunction: (acc = [
            0,
            0,
            0
        ])=>{
            const result = acc[0] + acc[1];
            if (result >= 0) return [
                0,
                result / acc[2]
            ];
            return [
                result / acc[2],
                0
            ];
        }
    };
    return def;
}
function $d77b025aa58d633c$var$area(id, aggFn, matchGroupId) {
    const result = {
        id: id,
        matchGroupIds: matchGroupId ? [
            matchGroupId
        ] : void 0,
        type: "aggregate",
        aggregateFunction: (values, keyRange = [])=>{
            const keyWidth = keyRange[1] - keyRange[0];
            return aggFn.aggregateFunction(values).map((v)=>v / keyWidth);
        }
    };
    if (aggFn.groupAggregateFunction) result.groupAggregateFunction = aggFn.groupAggregateFunction;
    return result;
}
function $d77b025aa58d633c$var$accumulatedValue(onlyPositive) {
    return ()=>{
        let value = 0;
        return (datum)=>{
            if (!(0, $idDdm.isFiniteNumber)(datum)) return datum;
            value += onlyPositive ? Math.max(0, datum) : datum;
            return value;
        };
    };
}
function $d77b025aa58d633c$var$trailingAccumulatedValue() {
    return ()=>{
        let value = 0;
        return (datum)=>{
            if (!(0, $idDdm.isFiniteNumber)(datum)) return datum;
            const trailingValue = value;
            value += datum;
            return trailingValue;
        };
    };
}
// packages/ag-charts-community/src/chart/data/processors.ts
function $d77b025aa58d633c$var$basicContinuousCheckDatumValidation(value) {
    return value != null && $d77b025aa58d633c$var$isContinuous(value);
}
function $d77b025aa58d633c$var$basicDiscreteCheckDatumValidation(value) {
    return value != null;
}
function $d77b025aa58d633c$var$getValidationFn(scaleType) {
    switch(scaleType){
        case "number":
        case "log":
        case "ordinal-time":
        case "unit-time":
        case "time":
        case "color":
            return $d77b025aa58d633c$var$basicContinuousCheckDatumValidation;
        default:
            return $d77b025aa58d633c$var$basicDiscreteCheckDatumValidation;
    }
}
function $d77b025aa58d633c$var$getValueType(scaleType) {
    switch(scaleType){
        case "number":
        case "log":
        case "time":
        case "color":
            return "range";
        default:
            return "category";
    }
}
function $d77b025aa58d633c$var$keyProperty(propName, scaleType, opts = {}) {
    const result = {
        property: propName,
        type: "key",
        valueType: $d77b025aa58d633c$var$getValueType(scaleType),
        validation: $d77b025aa58d633c$var$getValidationFn(scaleType),
        ...opts
    };
    return result;
}
function $d77b025aa58d633c$var$valueProperty(propName, scaleType, opts = {}) {
    const result = {
        property: propName,
        type: "value",
        valueType: $d77b025aa58d633c$var$getValueType(scaleType),
        validation: $d77b025aa58d633c$var$getValidationFn(scaleType),
        ...opts
    };
    return result;
}
function $d77b025aa58d633c$var$rowCountProperty(propName, opts = {}) {
    const result = {
        property: propName,
        type: "value",
        valueType: "range",
        missingValue: 1,
        processor: ()=>()=>1,
        ...opts
    };
    return result;
}
var $d77b025aa58d633c$var$noopProcessor = function(v) {
    return v;
};
function $d77b025aa58d633c$var$processorChain(...chain) {
    const filteredChain = chain.filter((fn)=>fn != null);
    if (filteredChain.length === 0) return ()=>$d77b025aa58d633c$var$noopProcessor;
    if (filteredChain.length === 1) return filteredChain[0];
    return ()=>{
        const processorInstances = filteredChain.map((fn)=>fn());
        return (value, index)=>{
            return processorInstances.reduce((r, p)=>p(r, index), value);
        };
    };
}
function $d77b025aa58d633c$var$rangedValueProperty(propName, opts = {}) {
    const { min: min = -Infinity, max: max = Infinity, processor: processor, ...defOpts } = opts;
    return {
        type: "value",
        property: propName,
        valueType: "range",
        validation: $d77b025aa58d633c$var$basicContinuousCheckDatumValidation,
        processor: $d77b025aa58d633c$var$processorChain(processor, ()=>(datum)=>(0, $idDdm.isFiniteNumber)(datum) ? (0, $idDdm.clamp)(min, datum, max) : datum),
        ...defOpts
    };
}
function $d77b025aa58d633c$var$accumulativeValueProperty(propName, scaleType, opts = {}) {
    const { onlyPositive: onlyPositive, processor: processor, ...defOpts } = opts;
    const result = {
        ...$d77b025aa58d633c$var$valueProperty(propName, scaleType, defOpts),
        processor: $d77b025aa58d633c$var$processorChain(processor, $d77b025aa58d633c$var$accumulatedValue(onlyPositive))
    };
    return result;
}
function $d77b025aa58d633c$var$trailingAccumulatedValueProperty(propName, scaleType, opts = {}) {
    const result = {
        ...$d77b025aa58d633c$var$valueProperty(propName, scaleType, opts),
        processor: $d77b025aa58d633c$var$trailingAccumulatedValue()
    };
    return result;
}
function $d77b025aa58d633c$var$groupAccumulativeValueProperty(propName, mode, sum2, opts, scaleType) {
    return [
        $d77b025aa58d633c$var$valueProperty(propName, scaleType, opts),
        $d77b025aa58d633c$var$accumulateGroup(opts.groupId, mode, sum2, opts.separateNegative),
        ...opts.rangeId != null ? [
            $d77b025aa58d633c$var$range2(opts.rangeId, opts.groupId)
        ] : []
    ];
}
function $d77b025aa58d633c$var$groupStackValueProperty(propName, scaleType, opts) {
    return [
        $d77b025aa58d633c$var$valueProperty(propName, scaleType, opts),
        $d77b025aa58d633c$var$accumulateStack(opts.groupId)
    ];
}
var $d77b025aa58d633c$var$SMALLEST_KEY_INTERVAL = {
    type: "reducer",
    property: "smallestKeyInterval",
    initialValue: Infinity,
    reducer: ()=>{
        let prevX = NaN;
        return (smallestSoFar = Infinity, keys)=>{
            const nextX = typeof keys[0] === "number" ? keys[0] : Number(keys[0]);
            const interval = Math.abs(nextX - prevX);
            prevX = nextX;
            if (!isNaN(interval) && interval > 0 && interval < smallestSoFar) return interval;
            return smallestSoFar;
        };
    }
};
var $d77b025aa58d633c$var$LARGEST_KEY_INTERVAL = {
    type: "reducer",
    property: "largestKeyInterval",
    initialValue: -Infinity,
    reducer: ()=>{
        let prevX = NaN;
        return (largestSoFar = -Infinity, keys)=>{
            const nextX = typeof keys[0] === "number" ? keys[0] : Number(keys[0]);
            const interval = Math.abs(nextX - prevX);
            prevX = nextX;
            if (!isNaN(interval) && interval > 0 && interval > largestSoFar) return interval;
            return largestSoFar;
        };
    }
};
var $d77b025aa58d633c$var$SORT_DOMAIN_GROUPS = {
    type: "processor",
    property: "sortedGroupDomain",
    calculate: ({ domain: { groups: groups } })=>groups?.slice().sort((a, b)=>{
            for(let i = 0; i < a.length; i++){
                const result = a[i] - b[i];
                if (result !== 0) return result;
            }
            return 0;
        })
};
function $d77b025aa58d633c$var$normaliseFnBuilder({ normaliseTo: normaliseTo }) {
    const normalise2 = (val, extent2)=>{
        if (extent2 === 0) return null;
        const result = (val ?? 0) * normaliseTo / extent2;
        if (result >= 0) return Math.min(normaliseTo, result);
        return Math.max(-normaliseTo, result);
    };
    return ()=>()=>(columns, valueIndexes, dataGroup)=>{
                const extent2 = $d77b025aa58d633c$var$normaliseFindExtent(columns, valueIndexes, dataGroup);
                for (const valueIdx of valueIndexes)for (const datumIndex of dataGroup.datumIndices[valueIdx] ?? []){
                    const column = columns[valueIdx];
                    const value = column[datumIndex];
                    if (value == null) {
                        column[datumIndex] = void 0;
                        continue;
                    }
                    column[datumIndex] = typeof value === "number" ? normalise2(value, extent2) : value.map((v)=>normalise2(v, extent2));
                }
            };
}
function $d77b025aa58d633c$var$normaliseFindExtent(columns, valueIndexes, dataGroup) {
    const valuesExtent = [
        0,
        0
    ];
    for (const valueIdx of valueIndexes){
        const column = columns[valueIdx];
        for (const datumIndex of dataGroup.datumIndices[valueIdx] ?? []){
            const value = column[datumIndex];
            if (value == null) continue;
            const valueExtent = typeof value === "number" ? value : Math.max(...value.map((v)=>v ?? 0));
            const valIdx = valueExtent < 0 ? 0 : 1;
            if (valIdx === 0) valuesExtent[valIdx] = Math.min(valuesExtent[valIdx], valueExtent);
            else valuesExtent[valIdx] = Math.max(valuesExtent[valIdx], valueExtent);
        }
    }
    return Math.max(Math.abs(valuesExtent[0]), valuesExtent[1]);
}
function $d77b025aa58d633c$var$normaliseGroupTo(matchGroupIds, normaliseTo) {
    return {
        type: "group-value-processor",
        matchGroupIds: matchGroupIds,
        adjust: $d77b025aa58d633c$var$memo({
            normaliseTo: normaliseTo
        }, $d77b025aa58d633c$var$normaliseFnBuilder)
    };
}
function $d77b025aa58d633c$var$normalisePropertyFnBuilder({ normaliseTo: normaliseTo, zeroDomain: zeroDomain, rangeMin: rangeMin, rangeMax: rangeMax }) {
    const normaliseSpan = normaliseTo[1] - normaliseTo[0];
    const normalise2 = (val, start2, span)=>{
        const result = normaliseTo[0] + (val - start2) / span * normaliseSpan;
        if (span === 0) return zeroDomain;
        else if (result >= normaliseTo[1]) return normaliseTo[1];
        else if (result < normaliseTo[0]) return normaliseTo[0];
        return result;
    };
    return ()=>(pData, pIdx)=>{
            let [start2, end2] = pData.domain.values[pIdx];
            if (rangeMin != null) start2 = rangeMin;
            if (rangeMax != null) end2 = rangeMax;
            const span = end2 - start2;
            pData.domain.values[pIdx] = [
                normaliseTo[0],
                normaliseTo[1]
            ];
            const column = pData.columns[pIdx];
            for(let datumIndex = 0; datumIndex < column.length; datumIndex += 1)column[datumIndex] = normalise2(column[datumIndex], start2, span);
        };
}
function $d77b025aa58d633c$var$normalisePropertyTo(property, normaliseTo, zeroDomain, rangeMin, rangeMax) {
    return {
        type: "property-value-processor",
        property: property,
        adjust: $d77b025aa58d633c$var$memo({
            normaliseTo: normaliseTo,
            rangeMin: rangeMin,
            rangeMax: rangeMax,
            zeroDomain: zeroDomain
        }, $d77b025aa58d633c$var$normalisePropertyFnBuilder)
    };
}
var $d77b025aa58d633c$var$ANIMATION_VALIDATION_UNIQUE_KEYS = 1;
var $d77b025aa58d633c$var$ANIMATION_VALIDATION_ORDERED_KEYS = 2;
function $d77b025aa58d633c$var$animationValidationProcessKey(count, def, keyValues, column) {
    let validation = $d77b025aa58d633c$var$ANIMATION_VALIDATION_UNIQUE_KEYS | $d77b025aa58d633c$var$ANIMATION_VALIDATION_ORDERED_KEYS;
    if (def.valueType === "category") {
        if (keyValues.length < count) validation &= ~$d77b025aa58d633c$var$ANIMATION_VALIDATION_UNIQUE_KEYS;
        return validation;
    }
    let lastValue = column[0]?.valueOf();
    for(let d = 1; validation !== 0 && d < column.length; d++){
        const keyValue = column[d]?.valueOf();
        if (!Number.isFinite(keyValue) || lastValue > keyValue) validation &= ~$d77b025aa58d633c$var$ANIMATION_VALIDATION_ORDERED_KEYS;
        if (Number.isFinite(keyValue) && lastValue === keyValue) validation &= ~$d77b025aa58d633c$var$ANIMATION_VALIDATION_UNIQUE_KEYS;
        lastValue = keyValue;
    }
    return validation;
}
function $d77b025aa58d633c$var$animationValidation(valueKeyIds) {
    return {
        type: "processor",
        property: "animationValidation",
        calculate (result) {
            const { keys: keysDefs, values: valuesDef } = result.defs;
            const { input: { count: count }, domain: { keys: domainKeys, values: domainValues }, keys: keys, columns: columns } = result;
            let validation = $d77b025aa58d633c$var$ANIMATION_VALIDATION_UNIQUE_KEYS | $d77b025aa58d633c$var$ANIMATION_VALIDATION_ORDERED_KEYS;
            if (count !== 0) {
                for(let i = 0; validation !== 0 && i < keysDefs.length; i++)for (const scope of keysDefs[i].scopes)validation &= $d77b025aa58d633c$var$animationValidationProcessKey(count, keysDefs[i], domainKeys[i], keys[i].get(scope));
                for(let i = 0; validation !== 0 && i < valuesDef.length; i++){
                    const value = valuesDef[i];
                    if (!valueKeyIds?.includes(value.id)) continue;
                    validation &= $d77b025aa58d633c$var$animationValidationProcessKey(count, value, domainValues[i], columns[i]);
                }
            }
            return {
                uniqueKeys: (validation & $d77b025aa58d633c$var$ANIMATION_VALIDATION_UNIQUE_KEYS) !== 0,
                orderedKeys: (validation & $d77b025aa58d633c$var$ANIMATION_VALIDATION_ORDERED_KEYS) !== 0
            };
        }
    };
}
function $d77b025aa58d633c$var$buildGroupAccFn({ mode: mode, separateNegative: separateNegative }) {
    return ()=>()=>(columns, valueIndexes, dataGroup)=>{
                const acc = [
                    0,
                    0
                ];
                for (const valueIdx of valueIndexes)for (const datumIndex of dataGroup.datumIndices[valueIdx] ?? []){
                    const column = columns[valueIdx];
                    const currentVal = column[datumIndex];
                    const accIndex = (0, $idDdm.isNegative)(currentVal) && separateNegative ? 0 : 1;
                    if (!(0, $idDdm.isFiniteNumber)(currentVal)) continue;
                    if (mode === "normal") acc[accIndex] += currentVal;
                    column[datumIndex] = acc[accIndex];
                    if (mode === "trailing") acc[accIndex] += currentVal;
                }
            };
}
function $d77b025aa58d633c$var$buildGroupWindowAccFn({ mode: mode, sum: sum2 }) {
    return ()=>{
        const lastValues = [];
        let firstRow = true;
        return ()=>{
            return (columns, valueIndexes, dataGroup)=>{
                let acc = 0;
                for (const valueIdx of valueIndexes){
                    const column = columns[valueIdx];
                    for (const datumIndex of dataGroup.datumIndices[valueIdx] ?? []){
                        const currentVal = column[datumIndex];
                        const lastValue = firstRow && sum2 === "current" ? 0 : lastValues[valueIdx];
                        lastValues[valueIdx] = currentVal;
                        const sumValue = sum2 === "current" ? currentVal : lastValue;
                        if (!(0, $idDdm.isFiniteNumber)(currentVal) || !(0, $idDdm.isFiniteNumber)(lastValue)) {
                            column[datumIndex] = acc;
                            continue;
                        }
                        if (mode === "normal") acc += sumValue;
                        column[datumIndex] = acc;
                        if (mode === "trailing") acc += sumValue;
                    }
                }
                firstRow = false;
            };
        };
    };
}
function $d77b025aa58d633c$var$accumulateGroup(matchGroupId, mode, sum2, separateNegative = false) {
    let adjust;
    if (mode.startsWith("window")) {
        const modeParam = mode.endsWith("-trailing") ? "trailing" : "normal";
        adjust = $d77b025aa58d633c$var$memo({
            mode: modeParam,
            sum: sum2
        }, $d77b025aa58d633c$var$buildGroupWindowAccFn);
    } else adjust = $d77b025aa58d633c$var$memo({
        mode: mode,
        separateNegative: separateNegative
    }, $d77b025aa58d633c$var$buildGroupAccFn);
    return {
        type: "group-value-processor",
        matchGroupIds: [
            matchGroupId
        ],
        adjust: adjust
    };
}
function $d77b025aa58d633c$var$groupStackAccFn() {
    return ()=>(columns, valueIndexes, dataGroup)=>{
            const acc = new Float64Array(valueIndexes.length);
            let stackCount = 0;
            for (const valueIdx of valueIndexes){
                const column = columns[valueIdx];
                for (const datumIndex of dataGroup.datumIndices[valueIdx] ?? []){
                    const currentValue = column[datumIndex];
                    acc[stackCount] = Number.isFinite(currentValue) ? currentValue : NaN;
                    stackCount += 1;
                    column[datumIndex] = acc.subarray(0, stackCount);
                }
            }
        };
}
function $d77b025aa58d633c$var$accumulateStack(matchGroupId) {
    return {
        type: "group-value-processor",
        matchGroupIds: [
            matchGroupId
        ],
        adjust: $d77b025aa58d633c$var$groupStackAccFn
    };
}
function $d77b025aa58d633c$var$valueIdentifier(value) {
    return value.id ?? value.property;
}
function $d77b025aa58d633c$var$valueIndices(id, previousData, processedData) {
    const properties = /* @__PURE__ */ new Map();
    const previousValues = previousData.defs.values;
    for(let previousIndex = 0; previousIndex < previousValues.length; previousIndex += 1){
        const previousValue = previousValues[previousIndex];
        if (previousValue.scopes?.includes(id) === false) continue;
        const valueId = $d77b025aa58d633c$var$valueIdentifier(previousValue);
        if (properties.has(valueId)) return;
        properties.set(valueId, previousIndex);
    }
    const indices = [];
    const nextValues = processedData.defs.values;
    for(let nextIndex = 0; nextIndex < nextValues.length; nextIndex += 1){
        const nextValue = nextValues[nextIndex];
        if (nextValue.scopes?.includes(id) === false) continue;
        const valueId = $d77b025aa58d633c$var$valueIdentifier(nextValue);
        const previousIndex = properties.get(valueId);
        if (previousIndex == null) return;
        properties.delete(valueId);
        indices.push({
            previousIndex: previousIndex,
            nextIndex: nextIndex
        });
    }
    if (properties.size !== 0) return;
    return indices;
}
function $d77b025aa58d633c$var$columnsEqual(previousColumns, nextColumns, indices, previousDatumIndex, nextDatumIndex) {
    for (const { previousIndex: previousIndex, nextIndex: nextIndex } of indices){
        const previousColumn = previousColumns[previousIndex];
        const nextColumn = nextColumns[nextIndex];
        const previousValue = previousColumn[previousDatumIndex];
        const nextValue = nextColumn[nextDatumIndex];
        if (previousValue !== nextValue) return false;
    }
    return true;
}
function $d77b025aa58d633c$var$diff(id, previousData, updateMovedData = true) {
    return {
        type: "processor",
        property: "diff",
        calculate (processedData, previousValue) {
            const moved = /* @__PURE__ */ new Map();
            const added = /* @__PURE__ */ new Map();
            const updated = /* @__PURE__ */ new Map();
            const removed = /* @__PURE__ */ new Map();
            const previousKeys = previousData.keys;
            const keys = processedData.keys;
            const previousColumns = previousData.columns;
            const columns = processedData.columns;
            const indices = $d77b025aa58d633c$var$valueIndices(id, previousData, processedData);
            if (indices == null) return previousValue;
            const length2 = Math.max(previousData.input.count, processedData.input.count);
            for(let i = 0; i < length2; i++){
                const hasPreviousDatum = i < previousData.input.count;
                const hasDatum = i < processedData.input.count;
                const prevKeys = hasPreviousDatum ? $d77b025aa58d633c$var$datumKeys(previousKeys, id, i) : void 0;
                const prevId = prevKeys != null ? $d77b025aa58d633c$var$createDatumId(prevKeys) : "";
                const dKeys = hasDatum ? $d77b025aa58d633c$var$datumKeys(keys, id, i) : void 0;
                const datumId = dKeys != null ? $d77b025aa58d633c$var$createDatumId(dKeys) : "";
                if (hasDatum && hasPreviousDatum && prevId === datumId) {
                    if (!$d77b025aa58d633c$var$columnsEqual(previousColumns, columns, indices, i, i)) updated.set(datumId, i);
                    continue;
                }
                const removedIndex = removed.get(datumId);
                if (removedIndex != null) {
                    if (updateMovedData || !$d77b025aa58d633c$var$columnsEqual(previousColumns, columns, indices, removedIndex, i)) {
                        updated.set(datumId, i);
                        moved.set(datumId, i);
                    }
                    removed.delete(datumId);
                } else if (hasDatum) added.set(datumId, i);
                const addedIndex = added.get(prevId);
                if (addedIndex != null) {
                    if (updateMovedData || !$d77b025aa58d633c$var$columnsEqual(previousColumns, columns, indices, addedIndex, i)) {
                        updated.set(prevId, i);
                        moved.set(prevId, i);
                    }
                    added.delete(prevId);
                } else if (hasPreviousDatum) {
                    updated.delete(prevId);
                    removed.set(prevId, i);
                }
            }
            const changed = added.size > 0 || updated.size > 0 || removed.size > 0;
            const value = {
                changed: changed,
                added: new Set(added.keys()),
                updated: new Set(updated.keys()),
                removed: new Set(removed.keys()),
                moved: new Set(moved.keys())
            };
            return {
                ...previousValue,
                [id]: value
            };
        }
    };
}
function $d77b025aa58d633c$var$createDatumId(keys, ...extraKeys) {
    let result;
    if ((0, $idDdm.isArray)(keys)) result = keys.map((key)=>$d77b025aa58d633c$var$transformIntegratedCategoryValue(key)).join("___");
    else result = $d77b025aa58d633c$var$transformIntegratedCategoryValue(keys);
    const primitiveType = typeof result === "string" || typeof result === "number" || typeof result === "boolean" || result instanceof Date;
    if (primitiveType && extraKeys.length > 0) result += `___${extraKeys.join("___")}`;
    return result;
}
// packages/ag-charts-community/src/chart/axis/tree.ts
var $d77b025aa58d633c$var$Dimensions = class {
    constructor(){
        this.top = Infinity;
        this.right = -Infinity;
        this.bottom = -Infinity;
        this.left = Infinity;
    }
    update(x, y) {
        if (x > this.right) this.right = x;
        if (x < this.left) this.left = x;
        if (y > this.bottom) this.bottom = y;
        if (y < this.top) this.top = y;
    }
};
var $d77b025aa58d633c$var$TreeNode = class _TreeNode {
    constructor(label = "", parent, refId){
        this.label = label;
        this.parent = parent;
        this.refId = refId;
        this.position = 0;
        this.subtreeLeft = NaN;
        this.subtreeRight = NaN;
        this.children = [];
        this.leafCount = 0;
        this.prelim = 0;
        this.mod = 0;
        this.ancestor = this;
        this.change = 0;
        this.shift = 0;
        this.index = 0;
        // screen is meant to be recomputed from (layout) when the tree is resized (without performing another layout)
        this.screen = 0;
        this.depth = parent ? parent.depth + 1 : 0;
    }
    insertTick(tick, index) {
        let root = this;
        for(let i = 0; i < tick.length; i++){
            const pathPart = tick[i];
            const isNotLeaf = i !== tick.length - 1;
            const { children: children } = root;
            const existingNode = children.find((child)=>child.label === pathPart);
            if (existingNode && isNotLeaf) root = existingNode;
            else {
                const node = new _TreeNode(pathPart, root, index);
                node.index = children.length;
                children.push(node);
                if (isNotLeaf) root = node;
            }
        }
    }
    getLeftSibling() {
        return this.index > 0 ? this.parent?.children[this.index - 1] : void 0;
    }
    getLeftmostSibling() {
        return this.index > 0 ? this.parent?.children[0] : void 0;
    }
    // traverse the left contour of a subtree, return the successor of v on this contour
    nextLeft() {
        return this.children[0];
    }
    // traverse the right contour of a subtree, return the successor of v on this contour
    nextRight() {
        return this.children.at(-1);
    }
    getSiblings() {
        return this.parent?.children.filter((_, i)=>i !== this.index) ?? [];
    }
};
function $d77b025aa58d633c$var$ticksToTree(ticks) {
    const maxDepth = ticks.reduce((depth, tick)=>depth < tick.length ? tick.length : depth, 0);
    const root = new $d77b025aa58d633c$var$TreeNode();
    for(let i = 0; i < ticks.length; i++){
        const tick = ticks[i];
        while(tick.length < maxDepth)tick.push("");
        root.insertTick(tick, i);
    }
    return root;
}
function $d77b025aa58d633c$var$moveSubtree(wm, wp, shift) {
    const subtrees = wp.index - wm.index;
    const ratio11 = shift / subtrees;
    wp.change -= ratio11;
    wp.shift += shift;
    wm.change += ratio11;
    wp.prelim += shift;
    wp.mod += shift;
}
function $d77b025aa58d633c$var$ancestor(vim, v, defaultAncestor) {
    return v.getSiblings().indexOf(vim.ancestor) >= 0 ? vim.ancestor : defaultAncestor;
}
function $d77b025aa58d633c$var$executeShifts({ children: children }) {
    let shift = 0;
    let change = 0;
    for(let i = children.length - 1; i >= 0; i--){
        const w = children[i];
        w.prelim += shift;
        w.mod += shift;
        change += w.change;
        shift += w.shift + change;
    }
}
function $d77b025aa58d633c$var$apportion(v, defaultAncestor) {
    const w = v.getLeftSibling();
    if (w) {
        let vop = v;
        let vip = v;
        let vim = w;
        let vom = vip.getLeftmostSibling();
        let sip = vip.mod;
        let sop = vop.mod;
        let sim = vim.mod;
        let som = vom.mod;
        while(vim.nextRight() && vip.nextLeft()){
            vim = vim.nextRight();
            vip = vip.nextLeft();
            vom = vom.nextLeft();
            vop = vop.nextRight();
            vop.ancestor = v;
            const shift = vim.prelim + sim - (vip.prelim + sip) + 1;
            if (shift > 0) {
                $d77b025aa58d633c$var$moveSubtree($d77b025aa58d633c$var$ancestor(vim, v, defaultAncestor), v, shift);
                sip += shift;
                sop += shift;
            }
            sim += vim.mod;
            sip += vip.mod;
            som += vom.mod;
            sop += vop.mod;
        }
        if (vim.nextRight() && !vop.nextRight()) vop.mod += sim - sop;
        else {
            if (vip.nextLeft() && !vom.nextLeft()) vom.mod += sip - som;
            defaultAncestor = v;
        }
    }
    return defaultAncestor;
}
function $d77b025aa58d633c$var$firstWalk(node) {
    const { children: children } = node;
    if (children.length) {
        let [defaultAncestor] = children;
        for (const child of children){
            $d77b025aa58d633c$var$firstWalk(child);
            defaultAncestor = $d77b025aa58d633c$var$apportion(child, defaultAncestor);
        }
        $d77b025aa58d633c$var$executeShifts(node);
        const midpoint = (children[0].prelim + children.at(-1).prelim) / 2;
        const leftSibling = node.getLeftSibling();
        if (leftSibling) {
            node.prelim = leftSibling.prelim + 1;
            node.mod = node.prelim - midpoint;
        } else node.prelim = midpoint;
    } else {
        const leftSibling = node.getLeftSibling();
        node.prelim = leftSibling ? leftSibling.prelim + 1 : 0;
    }
}
function $d77b025aa58d633c$var$secondWalk(v, m, layout) {
    v.position = v.prelim + m;
    layout.insertNode(v);
    for (const w of v.children)$d77b025aa58d633c$var$secondWalk(w, m + v.mod, layout);
}
function $d77b025aa58d633c$var$thirdWalk(v) {
    const { children: children } = v;
    let leafCount = 0;
    for (const w of children){
        $d77b025aa58d633c$var$thirdWalk(w);
        if (w.children.length) leafCount += w.leafCount;
        else leafCount++;
    }
    v.leafCount = leafCount;
    if (children.length) {
        v.subtreeLeft = children[0].subtreeLeft;
        v.subtreeRight = children[children.length - 1].subtreeRight;
        v.position = (v.subtreeLeft + v.subtreeRight) / 2;
    } else {
        v.subtreeLeft = v.position;
        v.subtreeRight = v.position;
    }
}
function $d77b025aa58d633c$var$treeLayout(ticks) {
    const layout = new $d77b025aa58d633c$var$TreeLayout();
    const root = $d77b025aa58d633c$var$ticksToTree(ticks);
    $d77b025aa58d633c$var$firstWalk(root);
    $d77b025aa58d633c$var$secondWalk(root, -root.prelim, layout);
    $d77b025aa58d633c$var$thirdWalk(root);
    return layout;
}
var $d77b025aa58d633c$var$TreeLayout = class {
    constructor(){
        this.dimensions = new $d77b025aa58d633c$var$Dimensions();
        this.nodes = [];
        this.depth = 0;
    }
    insertNode(node) {
        if (this.depth < node.depth) this.depth = node.depth;
        this.dimensions.update(node.position, node.depth);
        this.nodes.push(node);
    }
    scaling(extent2, flip) {
        let scaling = 1;
        if (extent2 > 0) {
            const { left: left, right: right } = this.dimensions;
            if (right !== left) scaling = extent2 / (right - left);
        }
        if (flip) scaling *= -1;
        return scaling;
    }
};
// packages/ag-charts-community/src/chart/axis/groupedCategoryAxis.ts
var $d77b025aa58d633c$var$DepthLabelProperties = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.enabled = true;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DepthLabelProperties.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DepthLabelProperties.prototype, "avoidCollisions", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DepthLabelProperties.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DepthLabelProperties.prototype, "spacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DepthLabelProperties.prototype, "rotation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DepthLabelProperties.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DepthLabelProperties.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DepthLabelProperties.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DepthLabelProperties.prototype, "fontFamily", 2);
var $d77b025aa58d633c$var$DepthTickProperties = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.enabled = true;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DepthTickProperties.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DepthTickProperties.prototype, "width", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DepthTickProperties.prototype, "stroke", 2);
var $d77b025aa58d633c$var$DepthProperties = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.label = new $d77b025aa58d633c$var$DepthLabelProperties();
        this.tick = new $d77b025aa58d633c$var$DepthTickProperties();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DepthProperties.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DepthProperties.prototype, "tick", 2);
var $d77b025aa58d633c$var$GroupedCategoryAxis = class extends $d77b025aa58d633c$var$CategoryAxis {
    constructor(moduleCtx){
        super(moduleCtx, new $d77b025aa58d633c$var$GroupedCategoryScale());
        // Label scale (labels are positioned between ticks, tick count = label count + 1).
        // We don't call is `labelScale` for consistency with other axes.
        this.tickScale = new $d77b025aa58d633c$var$GroupedCategoryScale();
        this.depthOptions = new $d77b025aa58d633c$var$PropertiesArray($d77b025aa58d633c$var$DepthProperties);
        this.includeInvisibleDomains = true;
        this.tickScale.paddingInner = 1;
        this.tickScale.paddingOuter = 0;
    }
    resizeTickTree() {
        if (!this.tickTreeLayout) return;
        const { nodes: nodes } = this.tickTreeLayout;
        const { range: range3, step: step, inset: inset, bandwidth: bandwidth } = this.scale;
        const width2 = Math.abs(range3[1] - range3[0]) - step;
        const scaling = this.tickTreeLayout.scaling(width2, range3[0] > range3[1]);
        const shift = inset + bandwidth / 2;
        let offset4 = 0;
        for (const node of nodes){
            const screen = node.position * scaling;
            if (offset4 > screen) offset4 = screen;
            node.screen = screen + shift;
        }
        for (const node of nodes)node.screen -= offset4;
    }
    getDepthOptionsMap(maxDepth) {
        const optionsMap = [];
        const { depthOptions: depthOptions, label: label } = this;
        const defaultNonLeafRotation = this.horizontal ? 0 : -90;
        for(let i = 0; i < maxDepth; i++)optionsMap.push(depthOptions[i]?.label.enabled ?? label.enabled ? {
            enabled: true,
            spacing: depthOptions[i]?.label.spacing ?? label.spacing,
            rotation: depthOptions[i]?.label.rotation ?? (i ? defaultNonLeafRotation : label.rotation),
            // Default top-level label roration only applies to label leaves
            avoidCollisions: depthOptions[i]?.label.avoidCollisions ?? label.avoidCollisions
        } : {
            enabled: false,
            spacing: 0,
            rotation: 0,
            avoidCollisions: false
        });
        return optionsMap;
    }
    updateCategoryLabels() {
        if (!this.computedLayout) return;
        this.tickLabelGroupSelection.update(this.computedLayout.tickLabelLayout).each((node, datum)=>node.setProperties(datum));
    }
    updateAxisLine() {
        if (!this.computedLayout) return;
        this.lineNode.visible = this.line.enabled;
        this.lineNode.stroke = this.line.stroke;
        this.lineNode.strokeWidth = this.line.width;
    }
    computeLayout() {
        this.updateDirection();
        this.updateScale();
        this.resizeTickTree();
        if (!this.tickTreeLayout?.depth) return {
            bbox: $d77b025aa58d633c$var$BBox.zero,
            spacing: 0,
            separatorLayout: [],
            tickLabelLayout: []
        };
        const { step: step } = this.scale;
        const { title: title, label: label, range: range3, depthOptions: depthOptions, horizontal: horizontal } = this;
        const { depth: maxDepth, nodes: treeLabels } = this.tickTreeLayout;
        const keepEvery = Math.ceil(label.fontSize / step);
        const sideFlag = horizontal ? -label.getSideFlag() : label.getSideFlag();
        const tickLabelLayout = [];
        const labelBBoxes = /* @__PURE__ */ new Map();
        const tempText = new $d77b025aa58d633c$var$TransformableText();
        const optionsMap = this.getDepthOptionsMap(maxDepth);
        const labelSpacing = sideFlag * optionsMap[0].spacing;
        const setLabelProps = (datum, index)=>{
            const depth = maxDepth - datum.depth;
            if (!optionsMap[depth]?.enabled || index % keepEvery !== 0 || !(0, $idDdm.inRange)(datum.screen, range3)) return false;
            const text = this.formatTick(datum.label, index - 1, this.scale.domain);
            const labelStyles = this.getLabelStyles({
                value: text,
                depth: depth
            }, depthOptions[depth]?.label);
            tempText.setProperties({
                ...labelStyles,
                text: text,
                textAlign: "center",
                textBaseline: label.parallel ? "hanging" : "bottom",
                lineHeight: $d77b025aa58d633c$var$TextUtils.getLineHeight(labelStyles.fontSize),
                x: horizontal ? datum.screen : labelSpacing,
                y: horizontal ? labelSpacing : datum.screen,
                rotation: 0
            });
            return true;
        };
        const depthLabelMaxSize = {};
        treeLabels.forEach((datum, index)=>{
            const depth = maxDepth - datum.depth;
            const isVisible = setLabelProps(datum, index);
            if (!isVisible || !tempText.getBBox()) return;
            labelBBoxes.set(index, tempText.getBBox());
            tempText.rotation = $d77b025aa58d633c$var$normalizeAngle360FromDegrees(optionsMap[depth]?.rotation);
            const { width: width3, height: height2 } = tempText.getBBox();
            const labelSize = horizontal ? height2 : width3;
            depthLabelMaxSize[depth] ?? (depthLabelMaxSize[depth] = 0);
            if (depthLabelMaxSize[depth] < labelSize) depthLabelMaxSize[depth] = labelSize;
        });
        const idGenerator = $d77b025aa58d633c$var$createIdsGenerator();
        const separatorData = /* @__PURE__ */ new Map();
        const nestedPadding = (d)=>{
            if (d === 0) return 0;
            let v = depthLabelMaxSize[0];
            for(let i = 1; i <= d; i++){
                v += optionsMap[i].spacing;
                if (i !== d) v += depthLabelMaxSize[i];
            }
            return v;
        };
        treeLabels.forEach((datum, index)=>{
            if (index === 0) return;
            const visible = setLabelProps(datum, index);
            const isLeaf = !datum.children.length;
            const depth = maxDepth - datum.depth;
            if (datum.parent) {
                const separatorX = isLeaf ? datum.position : datum.position - (datum.leafCount - 1) / 2;
                if (!separatorData.has(separatorX)) {
                    const tickOptions = this.depthOptions[depth]?.tick;
                    let v = depthLabelMaxSize[0];
                    for(let i = 0; i <= depth; i++){
                        v += optionsMap[i].spacing;
                        if (i !== 0) v += depthLabelMaxSize[i];
                    }
                    separatorData.set(separatorX, {
                        tickSize: v,
                        tickStroke: tickOptions?.stroke,
                        tickWidth: tickOptions?.enabled !== false ? tickOptions?.width : 0
                    });
                }
            }
            if (!visible) return;
            const labelRotation = $d77b025aa58d633c$var$normalizeAngle360FromDegrees(optionsMap[depth].rotation);
            const { width: w, height: h } = labelBBoxes.get(index);
            const depthPadding = nestedPadding(depth);
            tempText.textAlign = "end";
            tempText.textBaseline = "middle";
            tempText.rotation = labelRotation;
            if (horizontal) {
                tempText.x += w / 2;
                tempText.y += (depthPadding + $d77b025aa58d633c$var$angularPadding(w / 2, h / 2, labelRotation)) * sideFlag;
                tempText.rotationCenterX = datum.screen;
                tempText.rotationCenterY = tempText.y;
            } else {
                tempText.x += depthPadding * sideFlag + $d77b025aa58d633c$var$angularPadding((optionsMap[depth].spacing * sideFlag + w) / 2, label.mirrored ? w : 0, labelRotation);
                tempText.rotationCenterX = tempText.x - w / 2;
                tempText.rotationCenterY = datum.screen;
            }
            if (optionsMap[depth].avoidCollisions) {
                const { width: width3, height: height2 } = tempText.getBBox();
                const labelSize = horizontal ? width3 : height2;
                const availableRange = isLeaf ? step : datum.leafCount * step;
                if (labelSize > availableRange) {
                    labelBBoxes.delete(index);
                    return;
                }
            }
            const { text: text = "" } = tempText;
            tickLabelLayout.push({
                text: text,
                visible: true,
                range: this.scale.range,
                tickId: idGenerator(text),
                fill: tempText.fill,
                fontFamily: tempText.fontFamily,
                fontSize: tempText.fontSize,
                fontStyle: tempText.fontStyle,
                fontWeight: tempText.fontWeight,
                rotation: tempText.rotation,
                rotationCenterX: tempText.rotationCenterX,
                rotationCenterY: tempText.rotationCenterY,
                textAlign: tempText.textAlign,
                textBaseline: tempText.textBaseline,
                x: tempText.x,
                y: tempText.y
            });
            labelBBoxes.set(index, $d77b025aa58d633c$var$Transformable.toCanvas(tempText));
        });
        const { enabled: enabled, stroke: stroke2, width: width2 } = this.line;
        this.lineNode.datum = horizontal ? {
            x1: range3[0],
            x2: range3[1],
            y1: 0,
            y2: 0
        } : {
            x1: 0,
            x2: 0,
            y1: range3[0],
            y2: range3[1]
        };
        this.lineNode.setProperties({
            stroke: stroke2,
            strokeWidth: enabled ? width2 : 0
        });
        const separatorLayout = [
            ...separatorData.values()
        ];
        separatorLayout.push(separatorLayout[0]);
        const bboxes = [
            this.lineNodeBBox(),
            $d77b025aa58d633c$var$BBox.merge(labelBBoxes.values()),
            new $d77b025aa58d633c$var$BBox(0, 0, separatorLayout[0].tickSize * sideFlag, 0)
        ];
        let spacing = 0;
        if (title.enabled) {
            const withoutTitle = $d77b025aa58d633c$var$BBox.merge(bboxes);
            spacing = horizontal ? withoutTitle.height : withoutTitle.width;
            bboxes.push(this.titleBBox(this.scale.domain, spacing));
        }
        const mergedBBox = $d77b025aa58d633c$var$BBox.merge(bboxes);
        return {
            bbox: mergedBBox,
            spacing: spacing,
            separatorLayout: separatorLayout,
            tickLabelLayout: tickLabelLayout
        };
    }
    /**
   * Creates/removes/updates the scene graph nodes that constitute the axis.
   * Supposed to be called _manually_ after changing _any_ of the axis properties.
   * This allows to bulk set axis properties before updating the nodes.
   * The node changes made by this method are rendered on the next animation frame.
   * We could schedule this method call automatically on the next animation frame
   * when any of the axis properties change (the way we do when properties of scene graph's
   * nodes change), but this will mean that we first wait for the next animation
   * frame to make changes to the nodes of the axis, then wait for another animation
   * frame to render those changes. It's nice to have everything update automatically,
   * but this extra level of async indirection will not just introduce an unwanted delay,
   * it will also make it harder to reason about the program.
   */ update() {
        if (!this.computedLayout) return;
        this.moduleCtx.animationManager.skipCurrentBatch();
        const { tickScale: tickScale, tick: tick, gridLine: gridLine, gridLength: gridLength } = this;
        const { separatorLayout: separatorLayout, spacing: spacing } = this.computedLayout;
        const { position: position, horizontal: horizontal, gridPadding: gridPadding } = this;
        const direction = position === "bottom" || position === "right" ? -1 : 1;
        const p1 = gridPadding;
        const p2 = direction * gridLength - gridPadding;
        const ticks = tickScale.ticks({
            nice: false,
            interval: void 0,
            tickCount: void 0,
            minTickCount: 0,
            maxTickCount: Infinity
        }).ticks.map((t, index)=>({
                tickId: $d77b025aa58d633c$var$createDatumId(t, index),
                offset: Math.round(tickScale.convert(t))
            }));
        this.gridLineGroupSelection.update(gridLine.enabled && gridLength ? ticks.map(({ tickId: tickId, offset: offset4 }, index)=>{
            const [x1, x2, y1, y2] = horizontal ? [
                offset4,
                offset4,
                p1,
                p2
            ] : [
                p1,
                p2,
                offset4,
                offset4
            ];
            const { style: style, width: strokeWidth } = gridLine;
            const { stroke: stroke2, lineDash: lineDash } = style[index % style.length] ?? {};
            return {
                tickId: tickId,
                offset: offset4,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                lineDash: lineDash
            };
        }) : []);
        this.tickLineGroupSelection.update(tick.enabled ? ticks.map(({ tickId: tickId, offset: offset4 }, index)=>{
            const { tickSize: tickSize = this.getTickSize(), tickStroke: stroke2 = tick.stroke, tickWidth: strokeWidth = tick.width } = separatorLayout[index] ?? {};
            const h = -direction * tickSize;
            const [x1, x2, y1, y2] = horizontal ? [
                offset4,
                offset4,
                0,
                h
            ] : [
                0,
                h,
                offset4,
                offset4
            ];
            const lineDash = void 0;
            return {
                tickId: tickId,
                offset: offset4,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                lineDash: lineDash
            };
        }) : []);
        this.updatePosition();
        this.updateCategoryLabels();
        this.updateAxisLine();
        this.updateGridLines();
        this.updateTickLines();
        this.updateTitle(this.scale.domain, spacing);
        this.resetSelectionNodes();
    }
    calculateLayout() {
        const { separatorLayout: separatorLayout, tickLabelLayout: tickLabelLayout, spacing: spacing, bbox: bbox } = this.computeLayout();
        this.computedLayout = {
            separatorLayout: separatorLayout,
            tickLabelLayout: tickLabelLayout,
            spacing: spacing
        };
        return {
            bbox: bbox,
            niceDomain: this.scale.domain
        };
    }
    /**
   * The length of the grid. The grid is only visible in case of a non-zero value.
   */ onGridVisibilityChange() {
        this.gridLineGroupSelection.clear();
        this.tickLabelGroupSelection.clear();
    }
    updateScale() {
        super.updateScale();
        this.tickScale.range = this.scale.range;
        this.scale.paddingOuter = this.scale.paddingInner / 2;
    }
    processData() {
        const { direction: direction } = this;
        const flatDomains = this.boundSeries.filter((s)=>s.visible).flatMap((series)=>series.getDomain(direction));
        this.dataDomain = {
            domain: $d77b025aa58d633c$var$extent(flatDomains) ?? this.filterDuplicateArrays(flatDomains),
            clipped: false
        };
        if (this.isReversed()) this.dataDomain.domain.reverse();
        const domain = this.dataDomain.domain.map((datum)=>// Handle integrated charts data when provided as an object
            (0, $idDdm.toArray)((0, $idDdm.isObject)(datum) && "value" in datum ? datum.value : datum));
        this.tickTreeLayout = $d77b025aa58d633c$var$treeLayout(domain);
        const orderedDomain = [];
        for (const node of this.tickTreeLayout.nodes){
            if (node.leafCount || node.refId == null) continue;
            orderedDomain.push(this.dataDomain.domain[node.refId]);
        }
        this.scale.domain = (0, $idDdm.sortBasedOnArray)(this.dataDomain.domain, orderedDomain);
        this.tickScale.domain = domain.concat([
            [
                ""
            ]
        ]);
    }
    filterDuplicateArrays(array6) {
        const seen = /* @__PURE__ */ new Set();
        return array6.filter((item)=>{
            const key = (0, $idDdm.isArray)(item) ? JSON.stringify(item) : item;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });
    }
};
$d77b025aa58d633c$var$GroupedCategoryAxis.className = "GroupedCategoryAxis";
$d77b025aa58d633c$var$GroupedCategoryAxis.type = "grouped-category";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$GroupedCategoryAxis.prototype, "depthOptions", 2);
var $d77b025aa58d633c$var$logFunctions = {
    2: (_base, x)=>Math.log2(x),
    [Math.E]: (_base, x)=>Math.log(x),
    10: (_base, x)=>Math.log10(x)
};
var $d77b025aa58d633c$var$DEFAULT_LOG = (base, x)=>Math.log(x) / Math.log(base);
function $d77b025aa58d633c$var$log(base, domain, x) {
    const start2 = Math.min(...domain);
    const fn = $d77b025aa58d633c$var$logFunctions[base] ?? $d77b025aa58d633c$var$DEFAULT_LOG;
    return start2 >= 0 ? fn(base, x) : -fn(base, -x);
}
var $d77b025aa58d633c$var$powFunctions = {
    [Math.E]: (_base, x)=>Math.exp(x),
    10: (_base, x)=>x >= 0 ? 10 ** x : 1 / 10 ** -x
};
var $d77b025aa58d633c$var$DEFAULT_POW = (base, x)=>base ** x;
function $d77b025aa58d633c$var$pow(base, domain, x) {
    const start2 = Math.min(...domain);
    const fn = $d77b025aa58d633c$var$powFunctions[base] ?? $d77b025aa58d633c$var$DEFAULT_POW;
    return start2 >= 0 ? fn(base, x) : -fn(base, -x);
}
var $d77b025aa58d633c$var$LogScale = class _LogScale extends $d77b025aa58d633c$var$ContinuousScale {
    constructor(d = [
        1,
        10
    ], r = [
        0,
        1
    ]){
        super(d, r);
        this.type = "log";
        // Handling <1 and crossing 0 cases is tricky, easiest solution is to default to clamping.
        this.defaultClamp = true;
        this.base = 10;
        this.log = (x)=>$d77b025aa58d633c$var$log(this.base, this.domain, x);
        this.pow = (x)=>$d77b025aa58d633c$var$pow(this.base, this.domain, x);
    }
    static is(value) {
        return value instanceof _LogScale;
    }
    toDomain(d) {
        return d;
    }
    transform(x) {
        const [min, max] = $d77b025aa58d633c$var$findMinMax(this.domain);
        if (min >= 0 !== max >= 0) return NaN;
        return min >= 0 ? Math.log(x) : -Math.log(-x);
    }
    transformInvert(x) {
        const [min, max] = $d77b025aa58d633c$var$findMinMax(this.domain);
        if (min >= 0 !== max >= 0) return NaN;
        return min >= 0 ? Math.exp(x) : -Math.exp(-x);
    }
    niceDomain(_ticks, domain = this.domain) {
        if (domain.length < 2) return [];
        const { base: base } = this;
        const [d0, d1] = domain;
        const roundStart = d0 > d1 ? Math.ceil : Math.floor;
        const roundStop = d0 > d1 ? Math.floor : Math.ceil;
        const n0 = $d77b025aa58d633c$var$pow(base, domain, roundStart($d77b025aa58d633c$var$log(base, domain, d0)));
        const n1 = $d77b025aa58d633c$var$pow(base, domain, roundStop($d77b025aa58d633c$var$log(base, domain, d1)));
        return [
            n0,
            n1
        ];
    }
    ticks({ interval: interval, tickCount: tickCount = $d77b025aa58d633c$var$ContinuousScale.defaultTickCount }, domain = this.domain, visibleRange) {
        if (!domain || domain.length < 2 || tickCount < 1) return;
        const base = this.base;
        const [d0, d1] = domain;
        const start2 = Math.min(d0, d1);
        const stop = Math.max(d0, d1);
        let p0 = this.log(start2);
        let p1 = this.log(stop);
        if (interval) {
            const inBounds = (tick)=>tick >= start2 && tick <= stop;
            const step = Math.min(Math.abs(interval), Math.abs(p1 - p0));
            const { ticks: rangeTicks, count: count } = $d77b025aa58d633c$var$range(p0, p1, step, visibleRange);
            const ticks2 = rangeTicks.map(this.pow).filter(inBounds);
            if (!$d77b025aa58d633c$var$isDenseInterval(ticks2.length, this.getPixelRange())) return {
                ticks: ticks2,
                count: count
            };
        }
        if (!(0, $idDdm.isInteger)(base) || p1 - p0 >= tickCount) {
            const step = Math.min(p1 - p0, tickCount);
            const { ticks: ticks2, count: count } = $d77b025aa58d633c$var$createTicks(p0, p1, step, void 0, void 0, visibleRange);
            return {
                ticks: ticks2.map(this.pow),
                count: count
            };
        }
        const ticks = [];
        const isPositive = start2 > 0;
        p0 = Math.floor(p0) - 1;
        p1 = Math.round(p1) + 1;
        const availableSpacing = $d77b025aa58d633c$var$findRangeExtent(this.range) / tickCount;
        let lastTickPosition = Infinity;
        for(let p = p0; p <= p1; p++){
            const nextMagnitudeTickPosition = this.convert(this.pow(p + 1));
            for(let k = 1; k < base; k++){
                const q = isPositive ? k : base - k + 1;
                const t = this.pow(p) * q;
                const tickPosition = this.convert(t);
                const prevSpacing = Math.abs(lastTickPosition - tickPosition);
                const nextSpacing = Math.abs(tickPosition - nextMagnitudeTickPosition);
                const fits = prevSpacing >= availableSpacing && nextSpacing >= availableSpacing;
                if (t >= start2 && t <= stop && (k === 1 || fits || ticks.length === 0)) {
                    ticks.push(t);
                    lastTickPosition = tickPosition;
                }
            }
        }
        return $d77b025aa58d633c$var$filterVisibleTicks(ticks, isPositive, visibleRange);
    }
    tickFormatter({ specifier: specifier }) {
        return specifier != null ? (0, $idDdm.createNumberFormatter)(specifier) : String;
    }
    datumFormatter(params) {
        return this.tickFormatter(params);
    }
};
// packages/ag-charts-community/src/scale/linearScale.ts
var $d77b025aa58d633c$var$LinearScale = class _LinearScale extends $d77b025aa58d633c$var$ContinuousScale {
    constructor(){
        super([
            0,
            1
        ], [
            0,
            1
        ]);
        this.type = "number";
    }
    static is(value) {
        return value instanceof _LinearScale;
    }
    static getTickStep(start2, stop, ticks) {
        const { interval: interval, tickCount: tickCount = $d77b025aa58d633c$var$ContinuousScale.defaultTickCount, minTickCount: minTickCount, maxTickCount: maxTickCount } = ticks;
        return interval ?? $d77b025aa58d633c$var$tickStep(start2, stop, tickCount, minTickCount, maxTickCount);
    }
    toDomain(d) {
        return d;
    }
    ticks({ interval: interval, tickCount: tickCount = $d77b025aa58d633c$var$ContinuousScale.defaultTickCount, minTickCount: minTickCount, maxTickCount: maxTickCount }, domain = this.domain, visibleRange) {
        if (!domain || domain.length < 2 || tickCount < 1 || !domain.every(isFinite)) return {
            ticks: [],
            count: 0
        };
        const [d0, d1] = domain;
        if (interval) {
            const step = Math.abs(interval);
            if (!$d77b025aa58d633c$var$isDenseInterval((d1 - d0) / step, this.getPixelRange())) return $d77b025aa58d633c$var$range(d0, d1, step, visibleRange);
        }
        return $d77b025aa58d633c$var$createTicks(d0, d1, tickCount, minTickCount, maxTickCount, visibleRange);
    }
    niceDomain(ticks, domain = this.domain) {
        if (domain.length < 2) return [];
        const { tickCount: tickCount = $d77b025aa58d633c$var$ContinuousScale.defaultTickCount } = ticks;
        let [start2, stop] = domain;
        if (tickCount === 1) [start2, stop] = $d77b025aa58d633c$var$niceTicksDomain(start2, stop);
        else if (tickCount > 1) {
            const roundStart = start2 > stop ? Math.ceil : Math.floor;
            const roundStop = start2 > stop ? Math.floor : Math.ceil;
            const maxAttempts = 4;
            for(let i = 0; i < maxAttempts; i++){
                const prev0 = start2;
                const prev1 = stop;
                const step = _LinearScale.getTickStep(start2, stop, ticks);
                const [d0, d1] = domain;
                start2 = roundStart(d0 / step) * step;
                stop = roundStop(d1 / step) * step;
                if (start2 === prev0 && stop === prev1) break;
            }
        }
        return [
            start2,
            stop
        ];
    }
    tickFormatter({ ticks: specifiedTicks, fractionDigits: fractionDigits, specifier: specifier }) {
        return specifier != null ? $d77b025aa58d633c$var$tickFormat(specifiedTicks, specifier) : (x)=>$d77b025aa58d633c$var$formatValue(x, fractionDigits);
    }
    datumFormatter({ ticks: specifiedTicks, fractionDigits: fractionDigits, specifier: specifier }) {
        return specifier != null ? $d77b025aa58d633c$var$tickFormat(specifiedTicks, specifier) : (x)=>$d77b025aa58d633c$var$formatValue(x, fractionDigits + 1);
    }
};
// packages/ag-charts-community/src/chart/axis/numberAxis.ts
var $d77b025aa58d633c$var$NumberAxis = class extends $d77b025aa58d633c$var$CartesianAxis {
    constructor(moduleCtx, scale2 = new $d77b025aa58d633c$var$LinearScale()){
        super(moduleCtx, scale2);
    }
    normaliseDataDomain(d) {
        const { min: min, max: max } = this;
        const { extent: extent2, clipped: clipped } = $d77b025aa58d633c$var$normalisedExtentWithMetadata(d, min, max);
        return {
            domain: extent2,
            clipped: clipped
        };
    }
};
$d77b025aa58d633c$var$NumberAxis.className = "NumberAxis";
$d77b025aa58d633c$var$NumberAxis.type = "number";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$NumberAxis.prototype, "min", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$NumberAxis.prototype, "max", 2);
// packages/ag-charts-community/src/chart/axis/logAxis.ts
var $d77b025aa58d633c$var$LogAxis = class extends $d77b025aa58d633c$var$NumberAxis {
    normaliseDataDomain(d) {
        const { min: min, max: max } = this;
        const { extent: extent2, clipped: clipped } = $d77b025aa58d633c$var$normalisedExtentWithMetadata(d, min, max);
        if (extent2[0] < 0 && extent2[1] > 0 || d[0] < 0 && d[1] > 0) {
            (0, $idDdm.Logger).warn(`The log axis domain crosses zero, the chart data cannot be rendered. See log axis documentation for more information.`);
            return {
                domain: [],
                clipped: clipped
            };
        } else if (extent2[0] === 0 || extent2[1] === 0 || d[0] === 0 || d[1] === 0) {
            (0, $idDdm.Logger).warn(`The log axis domain contains a value of 0, the chart data cannot be rendered. See log axis documentation for more information.`);
            return {
                domain: [],
                clipped: clipped
            };
        }
        return {
            domain: extent2,
            clipped: clipped
        };
    }
    set base(value) {
        this.scale.base = value;
    }
    get base() {
        return this.scale.base;
    }
    constructor(moduleCtx){
        super(moduleCtx, new $d77b025aa58d633c$var$LogScale());
    }
    defaultDatumFormatter(datum, _fractionDigits) {
        return String(datum);
    }
    defaultLabelFormatter(datum, _fractionDigits) {
        return String(datum);
    }
};
$d77b025aa58d633c$var$LogAxis.className = "LogAxis";
$d77b025aa58d633c$var$LogAxis.type = "log";
// packages/ag-charts-community/src/chart/axis/timeAxis.ts
var $d77b025aa58d633c$var$TimeAxisParentLevel = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.enabled = false;
        this.label = new $d77b025aa58d633c$var$AxisLabel();
        this.tick = new $d77b025aa58d633c$var$AxisTick();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$TimeAxisParentLevel.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$TimeAxisParentLevel.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$TimeAxisParentLevel.prototype, "tick", 2);
var $d77b025aa58d633c$var$TimeAxis = class extends $d77b025aa58d633c$var$CartesianAxis {
    constructor(moduleCtx){
        super(moduleCtx, new $d77b025aa58d633c$var$TimeScale());
        this.parentLevel = new $d77b025aa58d633c$var$TimeAxisParentLevel();
        this.min = void 0;
        this.max = void 0;
        this.groupPaddingInner = 0.1;
    }
    get primaryLabel() {
        return this.parentLevel.enabled ? this.parentLevel.label : void 0;
    }
    get primaryTick() {
        return this.parentLevel.enabled ? this.parentLevel.tick : void 0;
    }
    normaliseDataDomain(d) {
        return $d77b025aa58d633c$var$normaliseTimeDataDomain(d, this.min, this.max);
    }
};
$d77b025aa58d633c$var$TimeAxis.className = "TimeAxis";
$d77b025aa58d633c$var$TimeAxis.type = "time";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$TimeAxis.prototype, "parentLevel", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$TimeAxis.prototype, "min", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$TimeAxis.prototype, "max", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$TimeAxis.prototype, "groupPaddingInner", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$TimeAxis.prototype, "paddingInner", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$TimeAxis.prototype, "paddingOuter", 2);
function $d77b025aa58d633c$var$normaliseTimeDataDomain(d, min, max) {
    let clipped = false;
    if (typeof min === "number") min = new Date(min);
    if (typeof max === "number") max = new Date(max);
    if (d.length > 2) d = $d77b025aa58d633c$var$extent(d)?.map((x)=>new Date(x)) ?? [];
    if (min instanceof Date) {
        clipped || (clipped = min > d[0]);
        d = [
            min,
            d[1]
        ];
    }
    if (max instanceof Date) {
        clipped || (clipped = max < d[1]);
        d = [
            d[0],
            max
        ];
    }
    if (d[0] > d[1]) d = [];
    return {
        domain: d,
        clipped: clipped
    };
}
// packages/ag-charts-community/src/chart/axis/unitTimeAxis.ts
var $d77b025aa58d633c$var$UnitTimeAxis = class extends $d77b025aa58d633c$var$CategoryAxis {
    constructor(moduleCtx){
        super(moduleCtx, new $d77b025aa58d633c$var$UnitTimeScale());
        this.parentLevel = new $d77b025aa58d633c$var$TimeAxisParentLevel();
        this.min = void 0;
        this.max = void 0;
    }
    get primaryLabel() {
        return this.parentLevel.enabled ? this.parentLevel.label : void 0;
    }
    get primaryTick() {
        return this.parentLevel.enabled ? this.parentLevel.tick : void 0;
    }
    updateScale() {
        super.updateScale();
        this.scale.interval = this.unit;
    }
    normaliseDataDomain(domain) {
        return $d77b025aa58d633c$var$normaliseTimeDataDomain(domain, this.min, this.max);
    }
};
$d77b025aa58d633c$var$UnitTimeAxis.className = "UnitTimeAxis";
$d77b025aa58d633c$var$UnitTimeAxis.type = "unit-time";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$UnitTimeAxis.prototype, "parentLevel", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$UnitTimeAxis.prototype, "min", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$UnitTimeAxis.prototype, "max", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$UnitTimeAxis.prototype, "unit", 2);
// packages/ag-charts-community/src/scene/util/corner.ts
var $d77b025aa58d633c$var$drawCorner = (path, { x0: x0, y0: y0, x1: x1, y1: y1, cx: cx, cy: cy }, cornerRadius, move)=>{
    if (move) path.moveTo(x0, y0);
    if (x0 !== x1 || y0 !== y1) {
        const r0 = Math.atan2(y0 - cy, x0 - cx);
        const r1 = Math.atan2(y1 - cy, x1 - cx);
        path.arc(cx, cy, cornerRadius, r0, r1);
    } else path.lineTo(x0, y0);
};
// packages/ag-charts-community/src/scene/shape/rect.ts
var $d77b025aa58d633c$var$epsilon = 1e-6;
var $d77b025aa58d633c$var$cornerEdges = (leadingEdge, trailingEdge, leadingInset, trailingInset, cornerRadius)=>{
    let leadingClipped = false;
    let trailingClipped = false;
    let leading0 = trailingInset - Math.sqrt(Math.max(cornerRadius ** 2 - leadingInset ** 2, 0));
    let leading1 = 0;
    let trailing0 = 0;
    let trailing1 = leadingInset - Math.sqrt(Math.max(cornerRadius ** 2 - trailingInset ** 2, 0));
    if (leading0 > leadingEdge) {
        leadingClipped = true;
        leading0 = leadingEdge;
        leading1 = leadingInset - Math.sqrt(Math.max(cornerRadius ** 2 - (trailingInset - leadingEdge) ** 2));
    } else if (leading0 < $d77b025aa58d633c$var$epsilon) leading0 = 0;
    if (trailing1 > trailingEdge) {
        trailingClipped = true;
        trailing0 = trailingInset - Math.sqrt(Math.max(cornerRadius ** 2 - (leadingInset - trailingEdge) ** 2));
        trailing1 = trailingEdge;
    } else if (trailing1 < $d77b025aa58d633c$var$epsilon) trailing1 = 0;
    return {
        leading0: leading0,
        leading1: leading1,
        trailing0: trailing0,
        trailing1: trailing1,
        leadingClipped: leadingClipped,
        trailingClipped: trailingClipped
    };
};
var $d77b025aa58d633c$var$clippedRoundRect = (path, x, y, width2, height2, cornerRadii, clipBBox)=>{
    let { topLeft: topLeftCornerRadius, topRight: topRightCornerRadius, bottomRight: bottomRightCornerRadius, bottomLeft: bottomLeftCornerRadius } = cornerRadii;
    const maxVerticalCornerRadius = Math.max(topLeftCornerRadius + bottomLeftCornerRadius, topRightCornerRadius + bottomRightCornerRadius);
    const maxHorizontalCornerRadius = Math.max(topLeftCornerRadius + topRightCornerRadius, bottomLeftCornerRadius + bottomRightCornerRadius);
    if (maxVerticalCornerRadius <= 0 && maxHorizontalCornerRadius <= 0) {
        if (clipBBox == null) path.rect(x, y, width2, height2);
        else path.rect(clipBBox.x, clipBBox.y, clipBBox.width, clipBBox.height);
        return;
    } else if (clipBBox == null && topLeftCornerRadius === topRightCornerRadius && topLeftCornerRadius === bottomRightCornerRadius && topLeftCornerRadius === bottomLeftCornerRadius) {
        path.roundRect(x, y, width2, height2, topLeftCornerRadius);
        return;
    }
    if (width2 < 0) {
        x += width2;
        width2 = Math.abs(width2);
    }
    if (height2 < 0) {
        y += height2;
        height2 = Math.abs(height2);
    }
    if (width2 <= 0 || height2 <= 0) return;
    if (clipBBox == null) clipBBox = new $d77b025aa58d633c$var$BBox(x, y, width2, height2);
    else {
        const x0 = Math.max(x, clipBBox.x);
        const x1 = Math.min(x + width2, clipBBox.x + clipBBox.width);
        const y0 = Math.max(y, clipBBox.y);
        const y1 = Math.min(y + height2, clipBBox.y + clipBBox.height);
        clipBBox = new $d77b025aa58d633c$var$BBox(x0, y0, x1 - x0, y1 - y0);
    }
    const borderScale = Math.max(maxVerticalCornerRadius / height2, maxHorizontalCornerRadius / width2, 1);
    if (borderScale > 1) {
        topLeftCornerRadius /= borderScale;
        topRightCornerRadius /= borderScale;
        bottomRightCornerRadius /= borderScale;
        bottomLeftCornerRadius /= borderScale;
    }
    let drawTopLeftCorner = true;
    let drawTopRightCorner = true;
    let drawBottomRightCorner = true;
    let drawBottomLeftCorner = true;
    let topLeftCorner;
    let topRightCorner;
    let bottomRightCorner;
    let bottomLeftCorner;
    if (drawTopLeftCorner) {
        const nodes = $d77b025aa58d633c$var$cornerEdges(clipBBox.height, clipBBox.width, Math.max(x + topLeftCornerRadius - clipBBox.x, 0), Math.max(y + topLeftCornerRadius - clipBBox.y, 0), topLeftCornerRadius);
        if (nodes.leadingClipped) drawBottomLeftCorner = false;
        if (nodes.trailingClipped) drawTopRightCorner = false;
        const x0 = Math.max(clipBBox.x + nodes.leading1, clipBBox.x);
        const y0 = Math.max(clipBBox.y + nodes.leading0, clipBBox.y);
        const x1 = Math.max(clipBBox.x + nodes.trailing1, clipBBox.x);
        const y1 = Math.max(clipBBox.y + nodes.trailing0, clipBBox.y);
        const cx = x + topLeftCornerRadius;
        const cy = y + topLeftCornerRadius;
        topLeftCorner = {
            x0: x0,
            y0: y0,
            x1: x1,
            y1: y1,
            cx: cx,
            cy: cy
        };
    }
    if (drawTopRightCorner) {
        const nodes = $d77b025aa58d633c$var$cornerEdges(clipBBox.width, clipBBox.height, Math.max(y + topRightCornerRadius - clipBBox.y, 0), Math.max(clipBBox.x + clipBBox.width - (x + width2 - topRightCornerRadius), 0), topRightCornerRadius);
        if (nodes.leadingClipped) drawTopLeftCorner = false;
        if (nodes.trailingClipped) drawBottomRightCorner = false;
        const x0 = Math.min(clipBBox.x + clipBBox.width - nodes.leading0, clipBBox.x + clipBBox.width);
        const y0 = Math.max(clipBBox.y + nodes.leading1, clipBBox.y);
        const x1 = Math.min(clipBBox.x + clipBBox.width - nodes.trailing0, clipBBox.x + clipBBox.width);
        const y1 = Math.max(clipBBox.y + nodes.trailing1, clipBBox.y);
        const cx = x + width2 - topRightCornerRadius;
        const cy = y + topRightCornerRadius;
        topRightCorner = {
            x0: x0,
            y0: y0,
            x1: x1,
            y1: y1,
            cx: cx,
            cy: cy
        };
    }
    if (drawBottomRightCorner) {
        const nodes = $d77b025aa58d633c$var$cornerEdges(clipBBox.height, clipBBox.width, Math.max(clipBBox.x + clipBBox.width - (x + width2 - bottomRightCornerRadius), 0), Math.max(clipBBox.y + clipBBox.height - (y + height2 - bottomRightCornerRadius), 0), bottomRightCornerRadius);
        if (nodes.leadingClipped) drawTopRightCorner = false;
        if (nodes.trailingClipped) drawBottomLeftCorner = false;
        const x0 = Math.min(clipBBox.x + clipBBox.width - nodes.leading1, clipBBox.x + clipBBox.width);
        const y0 = Math.min(clipBBox.y + clipBBox.height - nodes.leading0, clipBBox.y + clipBBox.height);
        const x1 = Math.min(clipBBox.x + clipBBox.width - nodes.trailing1, clipBBox.x + clipBBox.width);
        const y1 = Math.min(clipBBox.y + clipBBox.height - nodes.trailing0, clipBBox.y + clipBBox.height);
        const cx = x + width2 - bottomRightCornerRadius;
        const cy = y + height2 - bottomRightCornerRadius;
        bottomRightCorner = {
            x0: x0,
            y0: y0,
            x1: x1,
            y1: y1,
            cx: cx,
            cy: cy
        };
    }
    if (drawBottomLeftCorner) {
        const nodes = $d77b025aa58d633c$var$cornerEdges(clipBBox.width, clipBBox.height, Math.max(clipBBox.y + clipBBox.height - (y + height2 - bottomLeftCornerRadius), 0), Math.max(x + bottomLeftCornerRadius - clipBBox.x, 0), bottomLeftCornerRadius);
        if (nodes.leadingClipped) drawBottomRightCorner = false;
        if (nodes.trailingClipped) drawTopLeftCorner = false;
        const x0 = Math.max(clipBBox.x + nodes.leading0, clipBBox.x);
        const y0 = Math.min(clipBBox.y + clipBBox.height - nodes.leading1, clipBBox.y + clipBBox.height);
        const x1 = Math.max(clipBBox.x + nodes.trailing0, clipBBox.x);
        const y1 = Math.min(clipBBox.y + clipBBox.height - nodes.trailing1, clipBBox.y + clipBBox.height);
        const cx = x + bottomLeftCornerRadius;
        const cy = y + height2 - bottomLeftCornerRadius;
        bottomLeftCorner = {
            x0: x0,
            y0: y0,
            x1: x1,
            y1: y1,
            cx: cx,
            cy: cy
        };
    }
    let didMove = false;
    if (drawTopLeftCorner && topLeftCorner != null) {
        $d77b025aa58d633c$var$drawCorner(path, topLeftCorner, topLeftCornerRadius, !didMove);
        didMove || (didMove = true);
    }
    if (drawTopRightCorner && topRightCorner != null) {
        $d77b025aa58d633c$var$drawCorner(path, topRightCorner, topRightCornerRadius, !didMove);
        didMove || (didMove = true);
    }
    if (drawBottomRightCorner && bottomRightCorner != null) {
        $d77b025aa58d633c$var$drawCorner(path, bottomRightCorner, bottomRightCornerRadius, !didMove);
        didMove || (didMove = true);
    }
    if (drawBottomLeftCorner && bottomLeftCorner != null) $d77b025aa58d633c$var$drawCorner(path, bottomLeftCorner, bottomLeftCornerRadius, !didMove);
    path.closePath();
};
var $d77b025aa58d633c$var$Rect = class extends $d77b025aa58d633c$var$Path {
    constructor(){
        super(...arguments);
        this.borderPath = new $d77b025aa58d633c$var$ExtendedPath2D();
        this.x = 0;
        this.y = 0;
        this.width = 10;
        this.height = 10;
        this.topLeftCornerRadius = 0;
        this.topRightCornerRadius = 0;
        this.bottomRightCornerRadius = 0;
        this.bottomLeftCornerRadius = 0;
        this.clipBBox = void 0;
        this.crisp = false;
        this.lastUpdatePathStrokeWidth = $d77b025aa58d633c$var$Shape.defaultStyles.strokeWidth;
        this.effectiveStrokeWidth = $d77b025aa58d633c$var$Shape.defaultStyles.strokeWidth;
        this.hittester = super.isPointInPath.bind(this);
        this.distanceCalculator = super.distanceSquaredTransformedPoint.bind(this);
        /**
     * When the rectangle's width or height is less than a pixel
     * and crisp mode is on, the rectangle will still fit into the pixel,
     * but will be less opaque to make an effect of holding less space.
     */ this.microPixelEffectOpacity = 1;
    }
    set cornerRadius(cornerRadius) {
        this.topLeftCornerRadius = cornerRadius;
        this.topRightCornerRadius = cornerRadius;
        this.bottomRightCornerRadius = cornerRadius;
        this.bottomLeftCornerRadius = cornerRadius;
    }
    isDirtyPath() {
        return this.lastUpdatePathStrokeWidth !== this.strokeWidth || Boolean(this.path.isDirty() || this.borderPath.isDirty());
    }
    updatePath() {
        const { path: path, borderPath: borderPath, crisp: crisp, topLeftCornerRadius: topLeft, topRightCornerRadius: topRight, bottomRightCornerRadius: bottomRight, bottomLeftCornerRadius: bottomLeft } = this;
        let { x: x, y: y, width: w, height: h, strokeWidth: strokeWidth, clipBBox: clipBBox } = this;
        const pixelRatio = this.layerManager?.canvas.pixelRatio ?? 1;
        const pixelSize = 1 / pixelRatio;
        let microPixelEffectOpacity = 1;
        path.clear(true);
        borderPath.clear(true);
        if (crisp) {
            if (w <= pixelSize) microPixelEffectOpacity *= w / pixelSize;
            if (h <= pixelSize) microPixelEffectOpacity *= h / pixelSize;
            w = this.align(x, w);
            h = this.align(y, h);
            x = this.align(x);
            y = this.align(y);
            clipBBox = clipBBox != null ? new $d77b025aa58d633c$var$BBox(this.align(clipBBox.x), this.align(clipBBox.y), this.align(clipBBox.x, clipBBox.width), this.align(clipBBox.y, clipBBox.height)) : void 0;
        }
        if (strokeWidth) {
            if (w < pixelSize) {
                const lx = x + pixelSize / 2;
                borderPath.moveTo(lx, y);
                borderPath.lineTo(lx, y + h);
                strokeWidth = pixelSize;
                this.borderClipPath = void 0;
            } else if (h < pixelSize) {
                const ly = y + pixelSize / 2;
                borderPath.moveTo(x, ly);
                borderPath.lineTo(x + w, ly);
                strokeWidth = pixelSize;
                this.borderClipPath = void 0;
            } else if (strokeWidth < w && strokeWidth < h) {
                const halfStrokeWidth = strokeWidth / 2;
                x += halfStrokeWidth;
                y += halfStrokeWidth;
                w -= strokeWidth;
                h -= strokeWidth;
                const adjustedClipBBox = clipBBox?.clone().shrink(halfStrokeWidth);
                const cornerRadii = {
                    topLeft: topLeft > 0 ? topLeft - strokeWidth : 0,
                    topRight: topRight > 0 ? topRight - strokeWidth : 0,
                    bottomRight: bottomRight > 0 ? bottomRight - strokeWidth : 0,
                    bottomLeft: bottomLeft > 0 ? bottomLeft - strokeWidth : 0
                };
                this.borderClipPath = void 0;
                if (w > 0 && h > 0 && (adjustedClipBBox == null || adjustedClipBBox?.width > 0 && adjustedClipBBox?.height > 0)) {
                    $d77b025aa58d633c$var$clippedRoundRect(path, x, y, w, h, cornerRadii, adjustedClipBBox);
                    $d77b025aa58d633c$var$clippedRoundRect(borderPath, x, y, w, h, cornerRadii, adjustedClipBBox);
                }
            } else {
                this.borderClipPath = this.borderClipPath ?? new $d77b025aa58d633c$var$ExtendedPath2D();
                this.borderClipPath.clear(true);
                this.borderClipPath.rect(x, y, w, h);
                borderPath.rect(x, y, w, h);
            }
        } else {
            const cornerRadii = {
                topLeft: topLeft,
                topRight: topRight,
                bottomRight: bottomRight,
                bottomLeft: bottomLeft
            };
            this.borderClipPath = void 0;
            $d77b025aa58d633c$var$clippedRoundRect(path, x, y, w, h, cornerRadii, clipBBox);
        }
        if ([
            topLeft,
            topRight,
            bottomRight,
            bottomLeft
        ].every((r)=>r === 0)) {
            const bbox = this.getBBox();
            this.hittester = bbox.containsPoint.bind(bbox);
            this.distanceSquared = (hitX, hitY)=>this.getBBox().distanceSquared(hitX, hitY);
        } else {
            this.hittester = super.isPointInPath;
            this.distanceCalculator = super.distanceSquaredTransformedPoint;
        }
        this.effectiveStrokeWidth = strokeWidth;
        this.lastUpdatePathStrokeWidth = strokeWidth;
        this.microPixelEffectOpacity = microPixelEffectOpacity;
    }
    computeBBox() {
        const { x: x, y: y, width: width2, height: height2, clipBBox: clipBBox } = this;
        return clipBBox?.clone() ?? new $d77b025aa58d633c$var$BBox(x, y, width2, height2);
    }
    isPointInPath(x, y) {
        return this.hittester(x, y);
    }
    get midPoint() {
        return {
            x: this.x + this.width / 2,
            y: this.y + this.height / 2
        };
    }
    distanceSquared(x, y) {
        return this.distanceCalculator(x, y);
    }
    applyFillAndAlpha(ctx) {
        super.applyFillAndAlpha(ctx);
        ctx.globalAlpha *= this.microPixelEffectOpacity;
    }
    applyStrokeAndAlpha(ctx) {
        super.applyStrokeAndAlpha(ctx);
        ctx.globalAlpha *= this.microPixelEffectOpacity;
    }
    renderStroke(ctx) {
        const { stroke: stroke2, effectiveStrokeWidth: effectiveStrokeWidth } = this;
        if (stroke2 && effectiveStrokeWidth) {
            const { globalAlpha: globalAlpha } = ctx;
            const { lineDash: lineDash, lineDashOffset: lineDashOffset, lineCap: lineCap, lineJoin: lineJoin, borderPath: borderPath, borderClipPath: borderClipPath } = this;
            if (borderClipPath) ctx.clip(borderClipPath.getPath2D());
            this.applyStrokeAndAlpha(ctx);
            ctx.lineWidth = effectiveStrokeWidth;
            if (lineDash) ctx.setLineDash(lineDash);
            if (lineDashOffset) ctx.lineDashOffset = lineDashOffset;
            if (lineCap) ctx.lineCap = lineCap;
            if (lineJoin) ctx.lineJoin = lineJoin;
            ctx.stroke(borderPath.getPath2D());
            ctx.globalAlpha = globalAlpha;
        }
    }
};
$d77b025aa58d633c$var$Rect.className = "Rect";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "x", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "y", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "width", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "height", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "topLeftCornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "topRightCornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "bottomRightCornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "bottomLeftCornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneObjectChangeDetection({
        equals: $d77b025aa58d633c$var$BBoxValues.equals
    })
], $d77b025aa58d633c$var$Rect.prototype, "clipBBox", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "crisp", 2);
// packages/ag-charts-community/src/chart/background/background.ts
var $d77b025aa58d633c$var$Background = class extends $d77b025aa58d633c$var$BaseModuleInstance {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.rectNode = new $d77b025aa58d633c$var$Rect();
        this.textNode = new $d77b025aa58d633c$var$Text();
        this.fill = "white";
        this.node = this.createNode();
        this.node.append([
            this.rectNode,
            this.textNode
        ]);
        this.visible = true;
        this.destroyFns.push(ctx.scene.attachNode(this.node), ctx.layoutManager.addListener("layout:complete", (e)=>this.onLayoutComplete(e)));
    }
    createNode() {
        return new $d77b025aa58d633c$var$Group({
            name: "background",
            zIndex: 0 /* CHART_BACKGROUND */ 
        });
    }
    onLayoutComplete(e) {
        const { width: width2, height: height2 } = e.chart;
        this.rectNode.width = width2;
        this.rectNode.height = height2;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node", "visible")
], $d77b025aa58d633c$var$Background.prototype, "visible", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("rectNode", "fill")
], $d77b025aa58d633c$var$Background.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Background.prototype, "image", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("textNode")
], $d77b025aa58d633c$var$Background.prototype, "text", 2);
// packages/ag-charts-community/src/chart/background/backgroundModule.ts
var $d77b025aa58d633c$var$BackgroundModule = {
    type: "root",
    optionsKey: "background",
    packageType: "community",
    chartTypes: [
        "cartesian",
        "polar",
        "hierarchy",
        "topology",
        "flow-proportion",
        "standalone",
        "gauge"
    ],
    moduleFactory: (ctx)=>new $d77b025aa58d633c$var$Background(ctx)
};
// packages/ag-charts-community/src/chart/gridLayout.ts
function $d77b025aa58d633c$var$gridLayout({ orientation: orientation, bboxes: bboxes, maxHeight: maxHeight, maxWidth: maxWidth, itemPaddingY: itemPaddingY = 0, itemPaddingX: itemPaddingX = 0, forceResult: forceResult = false }) {
    const horizontal = orientation === "horizontal";
    const primary = {
        max: horizontal ? maxWidth : maxHeight,
        fn: horizontal ? (b)=>b.width : (b)=>b.height,
        padding: horizontal ? itemPaddingX : itemPaddingY
    };
    const secondary = {
        max: horizontal ? maxHeight : maxWidth,
        fn: horizontal ? (b)=>b.height : (b)=>b.width,
        padding: horizontal ? itemPaddingY : itemPaddingX
    };
    let processedBBoxCount = 0;
    const rawPages = [];
    while(processedBBoxCount < bboxes.length){
        const unprocessedBBoxes = bboxes.slice(processedBBoxCount);
        const result = $d77b025aa58d633c$var$processBBoxes(unprocessedBBoxes, processedBBoxCount, primary, secondary, forceResult);
        if (!result) return;
        processedBBoxCount += result.processedBBoxCount;
        rawPages.push(result.pageIndices);
    }
    return $d77b025aa58d633c$var$buildPages(rawPages, orientation, bboxes, itemPaddingY, itemPaddingX);
}
function $d77b025aa58d633c$var$processBBoxes(bboxes, indexOffset, primary, secondary, forceResult) {
    const minGuess = 1;
    let startingGuess = $d77b025aa58d633c$var$estimateStartingGuess(bboxes, primary);
    if (startingGuess < minGuess) {
        if (!forceResult) return;
        startingGuess = minGuess;
    }
    let guess = startingGuess;
    while(guess >= minGuess){
        const pageIndices = $d77b025aa58d633c$var$calculatePage(bboxes, indexOffset, guess, primary, secondary, forceResult);
        if (pageIndices == null && guess <= minGuess) return;
        if (pageIndices == null) {
            guess--;
            continue;
        }
        if (typeof pageIndices === "number") {
            if (pageIndices <= minGuess) return;
            guess = pageIndices < guess && pageIndices > minGuess ? pageIndices : guess;
            guess--;
            continue;
        }
        const processedBBoxCount = pageIndices.length * pageIndices[0].length;
        return {
            processedBBoxCount: processedBBoxCount,
            pageIndices: pageIndices
        };
    }
}
function $d77b025aa58d633c$var$calculatePage(bboxes, indexOffset, primaryCount, primary, secondary, forceResult) {
    const result = [];
    let sumSecondary = 0;
    let currentMaxSecondary = 0;
    let currentPrimaryIndices = [];
    const maxPrimaryValues = [];
    for(let bboxIndex = 0; bboxIndex < bboxes.length; bboxIndex++){
        const primaryValueIdx = (bboxIndex + primaryCount) % primaryCount;
        if (primaryValueIdx === 0) {
            sumSecondary += currentMaxSecondary;
            currentMaxSecondary = 0;
            if (currentPrimaryIndices.length > 0) result.push(currentPrimaryIndices);
            currentPrimaryIndices = [];
        }
        const primaryValue = primary.fn(bboxes[bboxIndex]) + primary.padding;
        maxPrimaryValues[primaryValueIdx] = Math.max(maxPrimaryValues[primaryValueIdx] ?? 0, primaryValue);
        currentMaxSecondary = Math.max(currentMaxSecondary, secondary.fn(bboxes[bboxIndex]) + secondary.padding);
        const currentSecondaryDimension = sumSecondary + currentMaxSecondary;
        const returnResult = !forceResult || result.length > 0;
        if (currentSecondaryDimension > secondary.max && returnResult) {
            currentPrimaryIndices = [];
            break;
        }
        const sumPrimary = maxPrimaryValues.reduce((sum2, next)=>sum2 + next, 0);
        if (sumPrimary > primary.max && !forceResult) {
            if (maxPrimaryValues.length < primaryCount) return maxPrimaryValues.length;
            return;
        }
        currentPrimaryIndices.push(bboxIndex + indexOffset);
    }
    if (currentPrimaryIndices.length > 0) result.push(currentPrimaryIndices);
    return result.length > 0 ? result : void 0;
}
function $d77b025aa58d633c$var$buildPages(rawPages, orientation, bboxes, itemPaddingY, itemPaddingX) {
    let maxPageWidth = 0;
    let maxPageHeight = 0;
    const pages = rawPages.map((indices)=>{
        if (orientation === "horizontal") indices = $d77b025aa58d633c$var$transpose(indices);
        let endIndex = 0;
        const columns = indices.map((colIndices)=>{
            const colBBoxes = colIndices.map((bboxIndex)=>{
                endIndex = Math.max(bboxIndex, endIndex);
                return bboxes[bboxIndex];
            });
            let columnHeight = 0;
            let columnWidth = 0;
            colBBoxes.forEach((bbox)=>{
                columnHeight += bbox.height + itemPaddingY;
                columnWidth = Math.max(columnWidth, bbox.width + itemPaddingX);
            });
            return {
                indices: colIndices,
                bboxes: colBBoxes,
                columnHeight: Math.ceil(columnHeight),
                columnWidth: Math.ceil(columnWidth)
            };
        });
        let pageWidth = 0;
        let pageHeight = 0;
        columns.forEach((column)=>{
            pageWidth += column.columnWidth;
            pageHeight = Math.max(pageHeight, column.columnHeight);
        });
        maxPageWidth = Math.max(pageWidth, maxPageWidth);
        maxPageHeight = Math.max(pageHeight, maxPageHeight);
        return {
            columns: columns,
            startIndex: indices[0][0],
            endIndex: endIndex,
            pageWidth: pageWidth,
            pageHeight: pageHeight
        };
    });
    return {
        pages: pages,
        maxPageWidth: maxPageWidth,
        maxPageHeight: maxPageHeight
    };
}
function $d77b025aa58d633c$var$transpose(data) {
    const result = [];
    for (const _ of data[0])result.push([]);
    data.forEach((innerData, dataIdx)=>{
        innerData.forEach((item, itemIdx)=>{
            result[itemIdx][dataIdx] = item;
        });
    });
    return result;
}
function $d77b025aa58d633c$var$estimateStartingGuess(bboxes, primary) {
    const n = bboxes.length;
    let primarySum = 0;
    for(let bboxIndex = 0; bboxIndex < n; bboxIndex++){
        primarySum += primary.fn(bboxes[bboxIndex]) + primary.padding;
        if (primarySum > primary.max) {
            const ratio11 = n / bboxIndex;
            if (ratio11 < 2) return Math.ceil(n / 2);
            return bboxIndex;
        }
    }
    return n;
}
var $d77b025aa58d633c$var$PaginationLabel = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.color = "black";
        this.fontStyle = void 0;
        this.fontWeight = void 0;
        this.fontSize = 12;
        this.fontFamily = "Verdana, sans-serif";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PaginationLabel.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PaginationLabel.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PaginationLabel.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PaginationLabel.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PaginationLabel.prototype, "fontFamily", 2);
var $d77b025aa58d633c$var$PaginationMarkerStyle = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.size = 15;
        this.fill = void 0;
        this.fillOpacity = void 0;
        this.stroke = void 0;
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PaginationMarkerStyle.prototype, "size", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PaginationMarkerStyle.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PaginationMarkerStyle.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PaginationMarkerStyle.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PaginationMarkerStyle.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PaginationMarkerStyle.prototype, "strokeOpacity", 2);
var $d77b025aa58d633c$var$PaginationMarker = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(parent){
        super();
        this.parent = parent;
        this.shape = "triangle";
        this.size = 15;
        this.padding = 8;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        changeValue () {
            if (this.parent.marker === this) this.parent.onMarkerShapeChange();
        }
    })
], $d77b025aa58d633c$var$PaginationMarker.prototype, "shape", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PaginationMarker.prototype, "size", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PaginationMarker.prototype, "padding", 2);
var $d77b025aa58d633c$var$Pagination = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(chartUpdateCallback, pageUpdateCallback){
        super();
        this.chartUpdateCallback = chartUpdateCallback;
        this.pageUpdateCallback = pageUpdateCallback;
        this.id = (0, $idDdm.createId)(this);
        this.marker = new $d77b025aa58d633c$var$PaginationMarker(this);
        this.activeStyle = new $d77b025aa58d633c$var$PaginationMarkerStyle();
        this.inactiveStyle = new $d77b025aa58d633c$var$PaginationMarkerStyle();
        this.highlightStyle = new $d77b025aa58d633c$var$PaginationMarkerStyle();
        this.label = new $d77b025aa58d633c$var$PaginationLabel();
        this.group = new $d77b025aa58d633c$var$TranslatableGroup({
            name: "pagination"
        });
        this.labelNode = new $d77b025aa58d633c$var$Text();
        this.totalPages = 0;
        this.currentPage = 0;
        this.translationX = 0;
        this.translationY = 0;
        this.nextButtonDisabled = false;
        this.previousButtonDisabled = false;
        this._visible = true;
        this._enabled = true;
        this._orientation = "vertical";
        this.nextButton = new $d77b025aa58d633c$var$Marker();
        this.previousButton = new $d77b025aa58d633c$var$Marker();
        this.labelNode.setProperties({
            textBaseline: "middle",
            fontSize: 12,
            fontFamily: "Verdana, sans-serif",
            fill: "black",
            y: 1
        });
        this.group.append([
            this.nextButton,
            this.previousButton,
            this.labelNode
        ]);
        this.update();
        this.updateMarkers();
    }
    set visible(value) {
        this._visible = value;
        this.updateGroupVisibility();
    }
    get visible() {
        return this._visible;
    }
    set enabled(value) {
        this._enabled = value;
        this.updateGroupVisibility();
    }
    get enabled() {
        return this._enabled;
    }
    updateGroupVisibility() {
        this.group.visible = this.enabled && this.visible;
    }
    set orientation(value) {
        this._orientation = value;
        switch(value){
            case "horizontal":
                this.previousButton.rotation = -Math.PI / 2;
                this.nextButton.rotation = Math.PI / 2;
                break;
            case "vertical":
            default:
                this.previousButton.rotation = 0;
                this.nextButton.rotation = Math.PI;
        }
    }
    get orientation() {
        return this._orientation;
    }
    update() {
        this.updateLabel();
        this.updatePositions();
        this.enableOrDisableButtons();
    }
    updatePositions() {
        this.group.translationX = this.translationX;
        this.group.translationY = this.translationY;
        this.updateLabelPosition();
        this.updateNextButtonPosition();
    }
    updateLabelPosition() {
        const { size: markerSize, padding: markerPadding } = this.marker;
        this.nextButton.size = markerSize;
        this.previousButton.size = markerSize;
        this.labelNode.x = markerSize / 2 + markerPadding;
    }
    updateNextButtonPosition() {
        const labelBBox = this.labelNode.getBBox();
        this.nextButton.translationX = labelBBox.width + (this.marker.size / 2 + this.marker.padding) * 2;
    }
    updateLabel() {
        const { currentPage: currentPage, totalPages: pages, labelNode: labelNode, label: { color: color11, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily } } = this;
        labelNode.text = `${currentPage + 1} / ${pages}`;
        labelNode.fill = color11;
        labelNode.fontStyle = fontStyle;
        labelNode.fontWeight = fontWeight;
        labelNode.fontSize = fontSize;
        labelNode.fontFamily = fontFamily;
    }
    updateMarkers() {
        const { nextButton: nextButton, previousButton: previousButton, nextButtonDisabled: nextButtonDisabled, previousButtonDisabled: previousButtonDisabled, activeStyle: activeStyle, inactiveStyle: inactiveStyle, highlightStyle: highlightStyle, highlightActive: highlightActive } = this;
        const buttonStyle = (button, disabled)=>{
            if (disabled) return inactiveStyle;
            else if (button === highlightActive) return highlightStyle;
            return activeStyle;
        };
        this.updateMarker(nextButton, buttonStyle("next", nextButtonDisabled));
        this.updateMarker(previousButton, buttonStyle("previous", previousButtonDisabled));
    }
    updateMarker(marker, style) {
        const { shape: shape, size: size } = this.marker;
        marker.shape = shape;
        marker.size = size;
        marker.fill = style.fill;
        marker.fillOpacity = style.fillOpacity ?? 1;
        marker.stroke = style.stroke;
        marker.strokeWidth = style.strokeWidth;
        marker.strokeOpacity = style.strokeOpacity;
    }
    enableOrDisableButtons() {
        const { currentPage: currentPage, totalPages: totalPages } = this;
        const zeroPagesToDisplay = totalPages === 0;
        const onLastPage = currentPage === totalPages - 1;
        const onFirstPage = currentPage === 0;
        this.nextButtonDisabled = onLastPage || zeroPagesToDisplay;
        this.previousButtonDisabled = onFirstPage || zeroPagesToDisplay;
    }
    setPage(pageNumber) {
        pageNumber = (0, $idDdm.clamp)(0, pageNumber, Math.max(0, this.totalPages - 1));
        if (this.currentPage !== pageNumber) {
            this.currentPage = pageNumber;
            this.onPaginationChanged();
        }
    }
    getCursor(node) {
        return ({
            previous: this.previousButtonDisabled,
            next: this.nextButtonDisabled
        })[node] ? void 0 : "pointer";
    }
    onClick(event, node) {
        event.preventDefault();
        if (node === "next" && !this.nextButtonDisabled) {
            this.incrementPage();
            this.onPaginationChanged();
        } else if (node === "previous" && !this.previousButtonDisabled) {
            this.decrementPage();
            this.onPaginationChanged();
        }
    }
    onMouseHover(node) {
        this.highlightActive = node;
        this.updateMarkers();
        this.chartUpdateCallback(7 /* SCENE_RENDER */ );
    }
    onPaginationChanged() {
        this.pageUpdateCallback(this.currentPage);
    }
    incrementPage() {
        this.currentPage = Math.min(this.currentPage + 1, this.totalPages - 1);
    }
    decrementPage() {
        this.currentPage = Math.max(this.currentPage - 1, 0);
    }
    onMarkerShapeChange() {
        this.updatePositions();
        this.updateMarkers();
        this.chartUpdateCallback(7 /* SCENE_RENDER */ );
    }
    attachPagination(node) {
        node.append(this.group);
    }
    getBBox() {
        return this.group.getBBox();
    }
    computeCSSBounds() {
        const prev = $d77b025aa58d633c$var$Transformable.toCanvas(this.previousButton);
        const next = $d77b025aa58d633c$var$Transformable.toCanvas(this.nextButton);
        return {
            prev: prev,
            next: next
        };
    }
};
$d77b025aa58d633c$var$Pagination.className = "Pagination";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Pagination.prototype, "marker", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Pagination.prototype, "activeStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Pagination.prototype, "inactiveStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Pagination.prototype, "highlightStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Pagination.prototype, "label", 2);
var $d77b025aa58d633c$var$LegendDOMProxy = class {
    constructor(ctx, idPrefix){
        this.dirty = true;
        this.destroyFns = new $d77b025aa58d633c$var$DestroyFns();
        this.itemList = ctx.proxyInteractionService.createProxyContainer({
            type: "list",
            domManagerId: `${idPrefix}-toolbar`,
            classList: [
                "ag-charts-proxy-legend-toolbar"
            ],
            ariaLabel: {
                id: "ariaLabelLegend"
            }
        });
        this.paginationGroup = ctx.proxyInteractionService.createProxyContainer({
            type: "group",
            domManagerId: `${idPrefix}-pagination`,
            classList: [
                "ag-charts-proxy-legend-pagination"
            ],
            ariaLabel: {
                id: "ariaLabelLegendPagination"
            },
            ariaOrientation: "horizontal"
        });
        this.itemDescription = (0, $idDdm.createElement)("p");
        this.itemDescription.style.display = "none";
        this.itemDescription.id = (0, $idDdm.createElementId)();
        this.itemDescription.textContent = this.getItemAriaDescription(ctx.localeManager);
        this.itemList.getElement().append(this.itemDescription);
    }
    destroy() {
        this.destroyFns.destroy();
    }
    initLegendList(params) {
        if (!this.dirty) return;
        const { ctx: ctx, itemSelection: itemSelection, datumReader: datumReader, itemListener: itemListener } = params;
        const lm = ctx.localeManager;
        const count = itemSelection.length;
        itemSelection.each((markerLabel, datum, index)=>{
            markerLabel.proxyButton?.destroy();
            markerLabel.proxyButton = ctx.proxyInteractionService.createProxyElement({
                type: "listswitch",
                textContent: this.getItemAriaText(lm, datumReader.getItemLabel(datum), index, count),
                ariaChecked: !!markerLabel.datum.enabled,
                ariaDescribedBy: this.itemDescription.id,
                parent: this.itemList
            });
            const button = markerLabel.proxyButton;
            button.addListener("click", (ev)=>itemListener.onClick(ev.sourceEvent, markerLabel.datum, button));
            button.addListener("dblclick", (ev)=>itemListener.onDoubleClick(ev.sourceEvent, markerLabel.datum));
            button.addListener("mouseenter", (ev)=>itemListener.onHover(ev.sourceEvent, markerLabel));
            button.addListener("mouseleave", ()=>itemListener.onLeave());
            button.addListener("contextmenu", (ev)=>itemListener.onContextClick(ev, markerLabel));
            button.addListener("blur", ()=>itemListener.onLeave());
            button.addListener("focus", (ev)=>itemListener.onHover(ev.sourceEvent, markerLabel));
            button.addListener("drag-start", ()=>{});
        });
        this.dirty = false;
    }
    update(params) {
        if (params.visible) {
            this.initLegendList(params);
            this.updateItemProxyButtons(params);
            this.updatePaginationProxyButtons(params, true);
        }
        this.updateVisibility(params.visible);
    }
    updateVisibility(visible) {
        this.itemList.setHidden(!visible);
        this.paginationGroup.setHidden(!visible);
    }
    updateItemProxyButtons({ itemSelection: itemSelection, group: group, pagination: pagination, interactive: interactive }) {
        const groupBBox = $d77b025aa58d633c$var$Transformable.toCanvas(group);
        this.itemList.setBounds(groupBBox);
        const maxHeight = Math.max(...itemSelection.nodes().map((l)=>l.getBBox().height));
        itemSelection.each((l, _datum)=>{
            if (l.proxyButton) {
                const visible = l.pageIndex === pagination.currentPage;
                const { x: x, y: y, height: height2, width: width2 } = $d77b025aa58d633c$var$Transformable.toCanvas(l);
                const margin = (maxHeight - height2) / 2;
                const bbox = {
                    x: x - groupBBox.x,
                    y: y - margin - groupBBox.y,
                    height: maxHeight,
                    width: width2
                };
                const enabled = interactive && visible;
                l.proxyButton.setCursor("pointer");
                l.proxyButton.setEnabled(enabled);
                l.proxyButton.setPointerEvents(enabled ? void 0 : "none");
                l.proxyButton.setBounds(bbox);
            }
        });
    }
    updatePaginationProxyButtons(params, init) {
        const { pagination: pagination } = params;
        this.paginationGroup.setHidden(!pagination.visible);
        if (init && "ctx" in params) {
            const { ctx: ctx, oldPages: oldPages, newPages: newPages } = params;
            const oldNeedsButtons = (oldPages?.length ?? newPages.length) > 1;
            const newNeedsButtons = newPages.length > 1;
            if (oldNeedsButtons !== newNeedsButtons) {
                if (newNeedsButtons) {
                    this.prevButton = ctx.proxyInteractionService.createProxyElement({
                        type: "button",
                        textContent: {
                            id: "ariaLabelLegendPagePrevious"
                        },
                        tabIndex: 0,
                        parent: this.paginationGroup
                    });
                    this.prevButton.addListener("click", (ev)=>this.onPageButton(params, ev, "previous"));
                    this.prevButton.addListener("mouseenter", ()=>pagination.onMouseHover("previous"));
                    this.prevButton.addListener("mouseleave", ()=>pagination.onMouseHover(void 0));
                    this.nextButton ?? (this.nextButton = ctx.proxyInteractionService.createProxyElement({
                        type: "button",
                        textContent: {
                            id: "ariaLabelLegendPageNext"
                        },
                        tabIndex: 0,
                        parent: this.paginationGroup
                    }));
                    this.nextButton.addListener("click", (ev)=>this.onPageButton(params, ev, "next"));
                    this.nextButton.addListener("mouseenter", ()=>pagination.onMouseHover("next"));
                    this.nextButton.addListener("mouseleave", ()=>pagination.onMouseHover(void 0));
                } else {
                    this.nextButton?.destroy();
                    this.prevButton?.destroy();
                    this.nextButton = void 0;
                    this.prevButton = void 0;
                }
            }
        }
        const { prev: prev, next: next } = pagination.computeCSSBounds();
        this.prevButton?.setBounds(prev);
        this.nextButton?.setBounds(next);
        this.prevButton?.setEnabled(pagination.currentPage !== 0);
        this.nextButton?.setEnabled(pagination.currentPage !== pagination.totalPages - 1);
        this.nextButton?.setCursor(pagination.getCursor("next"));
        this.prevButton?.setCursor(pagination.getCursor("previous"));
    }
    onPageButton(params, ev, node) {
        params.pagination.onClick(ev.sourceEvent, node);
        this.updatePaginationProxyButtons(params, false);
    }
    onDataUpdate(oldData, newData) {
        this.dirty = oldData.length !== newData.length || oldData.some((_v, index, _a)=>{
            const [newValue, oldValue] = [
                newData[index],
                oldData[index]
            ];
            return newValue.id !== oldValue.id;
        });
    }
    onLocaleChanged(localeManager, itemSelection, datumReader) {
        const count = itemSelection.length;
        itemSelection.each(({ proxyButton: proxyButton }, datum, index)=>{
            const button = proxyButton?.getElement();
            if (button != null) {
                const label = datumReader.getItemLabel(datum);
                button.textContent = this.getItemAriaText(localeManager, label, index, count);
            }
        });
        this.itemDescription.textContent = this.getItemAriaDescription(localeManager);
    }
    onPageChange(params) {
        this.updateItemProxyButtons(params);
        this.updatePaginationProxyButtons(params, false);
    }
    getItemAriaText(localeManager, label, index, count) {
        if (index >= 0 && label) {
            index++;
            return localeManager.t("ariaLabelLegendItem", {
                label: label,
                index: index,
                count: count
            });
        }
        return localeManager.t("ariaLabelLegendItemUnknown");
    }
    getItemAriaDescription(localeManager) {
        return localeManager.t("ariaDescriptionLegendItem");
    }
};
// packages/ag-charts-community/src/chart/legend/legendEvent.ts
function $d77b025aa58d633c$var$makeLegendItemEvent(type, itemId, seriesId, event) {
    const result = {
        defaultPrevented: false,
        apiEvent: {
            type: type,
            itemId: itemId,
            seriesId: seriesId,
            event: event,
            preventDefault: ()=>result.defaultPrevented = true
        }
    };
    return result;
}
// packages/ag-charts-community/src/chart/legend/legendMarkerLabel.ts
var $d77b025aa58d633c$var$LegendMarkerLabel = class extends $d77b025aa58d633c$var$Translatable($d77b025aa58d633c$var$Group) {
    constructor(){
        super({
            name: "markerLabelGroup"
        });
        this.symbolsGroup = this.appendChild(new $d77b025aa58d633c$var$Group({
            name: "legend-markerLabel-symbols"
        }));
        this.label = this.appendChild(new $d77b025aa58d633c$var$Text());
        this.enabled = true;
        this.pageIndex = NaN;
        this.spacing = 0;
        this.length = 0;
        this.isCustomMarker = false;
        this.marker = this.symbolsGroup.appendChild(new $d77b025aa58d633c$var$Marker({
            zIndex: 1
        }));
        this.line = this.symbolsGroup.appendChild(new $d77b025aa58d633c$var$Line({
            zIndex: 0
        }));
        const { label: label, line: line, symbolsGroup: symbolsGroup } = this;
        line.visible = false;
        symbolsGroup.renderToOffscreenCanvas = true;
        symbolsGroup.optimizeForInfrequentRedraws = true;
        label.textBaseline = "middle";
        label.fontSize = 12;
        label.fontFamily = "Verdana, sans-serif";
        label.fill = "black";
        label.y = 1;
    }
    destroy() {
        super.destroy();
        this.proxyButton?.destroy();
    }
    setEnabled(enabled) {
        this.enabled = enabled;
        this.refreshVisibilities();
    }
    getTextMeasureBBox() {
        this.layout();
        return $d77b025aa58d633c$var$BBox.merge([
            this.symbolsGroup.getBBox(),
            this.label.getTextMeasureBBox()
        ]);
    }
    refreshVisibilities() {
        const opacity = this.enabled ? 1 : 0.5;
        this.label.opacity = opacity;
        this.opacity = opacity;
    }
    layout() {
        const { marker: marker, line: line, length: length2, isCustomMarker: isCustomMarker } = this;
        let centerTranslateX = 0;
        let centerTranslateY = 0;
        if (marker.visible) {
            const { size: size } = marker;
            const anchor = $d77b025aa58d633c$var$Marker.anchor(marker.shape);
            centerTranslateX = (anchor.x - 0.5) * size + length2 / 2;
            centerTranslateY = (anchor.y - 0.5) * size;
            if (isCustomMarker) {
                marker.x = 0;
                marker.y = 0;
                marker.translationX = centerTranslateX;
                marker.translationY = centerTranslateY;
            } else {
                marker.x = centerTranslateX;
                marker.y = centerTranslateY;
                marker.translationX = 0;
                marker.translationY = 0;
            }
        }
        if (line.visible) {
            line.x1 = 0;
            line.x2 = length2;
            line.y1 = 0;
            line.y2 = 0;
        }
    }
    preRender(renderCtx) {
        const out = super.preRender(renderCtx);
        this.layout();
        return out;
    }
    layoutLabel() {
        const { length: length2, spacing: spacing } = this;
        this.label.x = length2 + spacing;
    }
    computeBBox() {
        this.layout();
        return super.computeBBox();
    }
};
$d77b025aa58d633c$var$LegendMarkerLabel.className = "MarkerLabel";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("label")
], $d77b025aa58d633c$var$LegendMarkerLabel.prototype, "text", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("label")
], $d77b025aa58d633c$var$LegendMarkerLabel.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("label")
], $d77b025aa58d633c$var$LegendMarkerLabel.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("label")
], $d77b025aa58d633c$var$LegendMarkerLabel.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("label")
], $d77b025aa58d633c$var$LegendMarkerLabel.prototype, "fontFamily", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("label", "fill")
], $d77b025aa58d633c$var$LegendMarkerLabel.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target)=>target.layoutLabel())
], $d77b025aa58d633c$var$LegendMarkerLabel.prototype, "spacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target)=>target.layoutLabel())
], $d77b025aa58d633c$var$LegendMarkerLabel.prototype, "length", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$LegendMarkerLabel.prototype, "isCustomMarker", 2);
// packages/ag-charts-community/src/chart/legend/legend.ts
var $d77b025aa58d633c$var$LegendLabel = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.maxLength = void 0;
        this.color = "black";
        this.fontStyle = void 0;
        this.fontWeight = void 0;
        this.fontSize = 12;
        this.fontFamily = "Verdana, sans-serif";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendLabel.prototype, "maxLength", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendLabel.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendLabel.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendLabel.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendLabel.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendLabel.prototype, "fontFamily", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendLabel.prototype, "formatter", 2);
var $d77b025aa58d633c$var$LegendMarker = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.shape = void 0;
        this.size = 15;
        this.padding = 8;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendMarker.prototype, "shape", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendMarker.prototype, "size", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendMarker.prototype, "padding", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendMarker.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendMarker.prototype, "enabled", 2);
var $d77b025aa58d633c$var$LegendLine = class extends $d77b025aa58d633c$var$BaseProperties {
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendLine.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendLine.prototype, "length", 2);
var $d77b025aa58d633c$var$LegendItem = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.paddingX = 16;
        this.paddingY = 8;
        this.showSeriesStroke = false;
        this.marker = new $d77b025aa58d633c$var$LegendMarker();
        this.label = new $d77b025aa58d633c$var$LegendLabel();
        this.line = new $d77b025aa58d633c$var$LegendLine();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendItem.prototype, "maxWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendItem.prototype, "paddingX", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendItem.prototype, "paddingY", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendItem.prototype, "showSeriesStroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendItem.prototype, "marker", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendItem.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendItem.prototype, "line", 2);
var $d77b025aa58d633c$var$LegendListeners = class extends $d77b025aa58d633c$var$BaseProperties {
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendListeners.prototype, "legendItemClick", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LegendListeners.prototype, "legendItemDoubleClick", 2);
var $d77b025aa58d633c$var$fillGradientDefaults = {
    type: "gradient",
    bounds: "item",
    gradient: "linear",
    colorStops: [
        {
            color: "black"
        }
    ],
    rotation: 0,
    reverse: false
};
var $d77b025aa58d633c$var$fillPatternDefaults = {
    type: "pattern",
    pattern: "forward-slanted-lines",
    width: 8,
    height: 8,
    padding: 1,
    fill: "black",
    fillOpacity: 1,
    backgroundFill: "white",
    backgroundFillOpacity: 1,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 0,
    rotation: 0,
    scale: 1
};
var $d77b025aa58d633c$var$fillImageDefaults = {
    type: "image",
    backgroundFill: "black",
    backgroundFillOpacity: 1,
    rotation: 0,
    repeat: "no-repeat",
    fit: "contain",
    width: 8,
    height: 8
};
var $d77b025aa58d633c$var$Legend = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.id = (0, $idDdm.createId)(this);
        this.group = new $d77b025aa58d633c$var$TranslatableGroup({
            name: "legend",
            zIndex: 14 /* LEGEND */ 
        });
        this.itemSelection = $d77b025aa58d633c$var$Selection.select(this.group, $d77b025aa58d633c$var$LegendMarkerLabel);
        this.oldSize = [
            0,
            0
        ];
        this.pages = [];
        this.maxPageSize = [
            0,
            0
        ];
        /** Item index to track on re-pagination, so current page updates appropriately. */ this.paginationTrackingIndex = 0;
        this.truncatedItems = /* @__PURE__ */ new Set();
        this._data = [];
        this.toggleSeries = true;
        this.item = new $d77b025aa58d633c$var$LegendItem();
        this.listeners = new $d77b025aa58d633c$var$LegendListeners();
        this.enabled = true;
        this.position = "bottom";
        this.spacing = 20;
        this.destroyFns = [];
        this.size = [
            0,
            0
        ];
        this._visible = true;
        this.pagination = new $d77b025aa58d633c$var$Pagination((type)=>ctx.updateService.update(type), (page)=>this.updatePageNumber(page));
        this.pagination.attachPagination(this.group);
        const { items: items } = ctx.contextMenuRegistry.builtins;
        items["toggle-series-visibility"].action = (params)=>this.contextToggleVisibility(params);
        items["toggle-other-series"].action = (params)=>this.contextToggleOtherSeries(params);
        this.destroyFns.push(ctx.legendManager.addListener("legend-change", this.onLegendDataChange.bind(this)));
        this.destroyFns.push(()=>delete items["toggle-series-visibility"].action, ()=>delete items["toggle-other-series"].action, ctx.layoutManager.registerElement(1 /* Legend */ , (e)=>this.positionLegend(e)), ctx.localeManager.addListener("locale-changed", ()=>this.onLocaleChanged()), ()=>this.group.remove());
        this.domProxy = new $d77b025aa58d633c$var$LegendDOMProxy(this.ctx, this.id);
        this.ctx.historyManager.addMementoOriginator(ctx.legendManager);
    }
    set data(value) {
        if ($d77b025aa58d633c$var$objectsEqual(value, this._data)) return;
        this.domProxy.onDataUpdate(this._data, value);
        this._data = value;
        this.updateGroupVisibility();
    }
    get data() {
        return this._data;
    }
    onLegendDataChange({ legendData: legendData = [] }) {
        if (!this.enabled) return;
        this.data = legendData.filter((datum)=>!datum.hideInLegend);
    }
    destroy() {
        this.ctx.domManager.removeChild("canvas-overlay", `${this.id}-toolbar`);
        this.ctx.domManager.removeChild("canvas-overlay", `${this.id}-pagination`);
        this.destroyFns.forEach((f)=>f());
        this.itemSelection.clear();
        this.domProxy.destroy();
    }
    getOrientation() {
        return this.orientation ?? "horizontal";
    }
    set visible(value) {
        this._visible = value;
        this.updateGroupVisibility();
    }
    get visible() {
        return this._visible;
    }
    updateGroupVisibility() {
        this.group.visible = this.enabled && this.visible && this.data.length > 0;
    }
    attachLegend(scene) {
        scene.appendChild(this.group);
    }
    getItemLabel(datum) {
        const { formatter: formatter } = this.item.label;
        if (formatter) {
            const seriesDatum = datum.datum;
            return this.cachedCallWithContext(formatter, {
                itemId: datum.itemId,
                value: datum.label.text,
                seriesId: datum.seriesId,
                ...seriesDatum && {
                    datum: seriesDatum
                }
            });
        }
        return datum.label.text;
    }
    /**
   * The method is given the desired size of the legend, which only serves as a hint.
   * The vertically oriented legend will take as much horizontal space as needed, but will
   * respect the height constraints, and the horizontal legend will take as much vertical
   * space as needed in an attempt not to exceed the given width.
   * After the layout is done, the {@link size} will contain the actual size of the legend.
   * If the actual size is not the same as the previous actual size, the legend will fire
   * the 'layoutChange' event to communicate that another layout is needed, and the above
   * process should be repeated.
   * @param width
   * @param height
   */ calcLayout(width2, height2) {
        const { paddingX: paddingX, paddingY: paddingY, label: label, maxWidth: maxWidth, label: { maxLength: maxLength = Infinity, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily } } = this.item;
        const data = [
            ...this.data
        ];
        if (this.reverseOrder) data.reverse();
        this.itemSelection.update(data);
        const bboxes = [];
        const font2 = $d77b025aa58d633c$var$TextUtils.toFontString(label);
        const itemMaxWidthPercentage = 0.8;
        const maxItemWidth = maxWidth ?? width2 * itemMaxWidthPercentage;
        const { markerWidth: markerWidth, anyLineEnabled: anyLineEnabled } = this.calculateMarkerWidth();
        this.itemSelection.each((markerLabel, datum)=>{
            markerLabel.fontStyle = fontStyle;
            markerLabel.fontWeight = fontWeight;
            markerLabel.fontSize = fontSize;
            markerLabel.fontFamily = fontFamily;
            const paddedSymbolWidth = this.updateMarkerLabel(markerLabel, datum, markerWidth, anyLineEnabled);
            const id = datum.itemId ?? datum.id;
            const labelText = this.getItemLabel(datum);
            const text = (labelText ?? "<unknown>").replace(/\r?\n/g, " ");
            markerLabel.text = this.truncate(text, maxLength, maxItemWidth, paddedSymbolWidth, font2, id);
            bboxes.push(markerLabel.getTextMeasureBBox());
        });
        width2 = Math.max(1, width2);
        height2 = Math.max(1, height2);
        if (!isFinite(width2)) return {};
        const size = this.size;
        const oldSize = this.oldSize;
        size[0] = width2;
        size[1] = height2;
        if (size[0] !== oldSize[0] || size[1] !== oldSize[1]) {
            oldSize[0] = size[0];
            oldSize[1] = size[1];
        }
        const { pages: pages, maxPageHeight: maxPageHeight, maxPageWidth: maxPageWidth } = this.updatePagination(bboxes, width2, height2);
        const oldPages = this.pages;
        this.pages = pages;
        this.maxPageSize = [
            maxPageWidth - paddingX,
            maxPageHeight - paddingY
        ];
        const pageNumber = this.pagination.currentPage;
        const page = this.pages[pageNumber];
        if (this.pages.length < 1 || !page) {
            this.visible = false;
            return {
                oldPages: oldPages
            };
        }
        this.visible = true;
        this.updatePositions(pageNumber);
        this.update();
        return {
            oldPages: oldPages
        };
    }
    isCustomMarker(markerEnabled, shape) {
        return markerEnabled && shape !== void 0 && typeof shape !== "string";
    }
    calcSymbolsEnabled(symbol) {
        const { showSeriesStroke: showSeriesStroke, marker: marker } = this.item;
        const markerEnabled = !!marker.enabled || !showSeriesStroke || (symbol.marker.enabled ?? true);
        const lineEnabled = !!(symbol.line && showSeriesStroke);
        const isCustomMarker = this.isCustomMarker(markerEnabled, symbol.marker.shape);
        return {
            markerEnabled: markerEnabled,
            lineEnabled: lineEnabled,
            isCustomMarker: isCustomMarker
        };
    }
    calcSymbolsLengths(symbol, markerEnabled, lineEnabled) {
        const { marker: marker, line: line } = this.item;
        let customMarkerSize;
        const { shape: shape } = symbol.marker;
        if (this.isCustomMarker(markerEnabled, shape)) {
            const tmpShape = new $d77b025aa58d633c$var$Marker();
            tmpShape.shape = shape;
            tmpShape.updatePath();
            const bbox = tmpShape.getBBox();
            customMarkerSize = Math.max(bbox.width, bbox.height);
        }
        const markerLength = markerEnabled ? marker.size : 0;
        const lineLength = lineEnabled ? line.length ?? 25 : 0;
        return {
            markerLength: markerLength,
            lineLength: lineLength,
            customMarkerSize: customMarkerSize
        };
    }
    calculateMarkerWidth() {
        let markerWidth = 0;
        let anyLineEnabled = false;
        this.itemSelection.each((_, datum)=>{
            const { symbol: symbol } = datum;
            const { lineEnabled: lineEnabled, markerEnabled: markerEnabled } = this.calcSymbolsEnabled(symbol);
            const { markerLength: markerLength, lineLength: lineLength, customMarkerSize: customMarkerSize = -Infinity } = this.calcSymbolsLengths(symbol, markerEnabled, lineEnabled);
            markerWidth = Math.max(markerWidth, lineLength, customMarkerSize, markerLength);
            anyLineEnabled || (anyLineEnabled = lineEnabled);
        });
        return {
            markerWidth: markerWidth,
            anyLineEnabled: anyLineEnabled
        };
    }
    updateMarkerLabel(markerLabel, datum, markerWidth, anyLineEnabled) {
        const { marker: itemMarker, paddingX: paddingX } = this.item;
        const { symbol: symbol } = datum;
        let paddedSymbolWidth = paddingX;
        const { markerEnabled: markerEnabled, isCustomMarker: isCustomMarker } = this.calcSymbolsEnabled(symbol);
        const spacing = itemMarker.padding;
        if (markerEnabled || anyLineEnabled) paddedSymbolWidth += spacing + markerWidth;
        const { marker: marker, line: line } = markerLabel;
        marker.visible = markerEnabled;
        if (marker.visible) {
            marker.shape = itemMarker.shape ?? symbol.marker.shape ?? "square";
            marker.size = itemMarker.size;
            $d77b025aa58d633c$var$applyShapeStyle(marker, this.getMarkerStyles(symbol));
        }
        line.visible = anyLineEnabled;
        if (line.visible) $d77b025aa58d633c$var$applyShapeStyle(line, this.getLineStyles(symbol));
        markerLabel.length = markerWidth;
        markerLabel.spacing = spacing;
        markerLabel.isCustomMarker = isCustomMarker;
        return paddedSymbolWidth;
    }
    truncate(text, maxCharLength, maxItemWidth, paddedMarkerWidth, font2, id) {
        let addEllipsis = false;
        if (text.length > maxCharLength) {
            text = text.substring(0, maxCharLength);
            addEllipsis = true;
        }
        const measurer2 = $d77b025aa58d633c$var$CachedTextMeasurerPool.getMeasurer({
            font: font2
        });
        const result = $d77b025aa58d633c$var$TextWrapper.truncateLine(text, measurer2, maxItemWidth - paddedMarkerWidth, addEllipsis);
        if (result.endsWith($d77b025aa58d633c$var$TextUtils.EllipsisChar)) this.truncatedItems.add(id);
        else this.truncatedItems.delete(id);
        return result;
    }
    updatePagination(bboxes, width2, height2) {
        const orientation = this.getOrientation();
        const trackingIndex = Math.min(this.paginationTrackingIndex, bboxes.length);
        this.pagination.orientation = orientation;
        this.pagination.translationX = 0;
        this.pagination.translationY = 0;
        const { pages: pages, maxPageHeight: maxPageHeight, maxPageWidth: maxPageWidth, paginationBBox: paginationBBox, paginationVertical: paginationVertical } = this.calculatePagination(bboxes, width2, height2);
        const newCurrentPage = pages.findIndex((p)=>p.endIndex >= trackingIndex);
        this.pagination.currentPage = (0, $idDdm.clamp)(0, newCurrentPage, pages.length - 1);
        const { paddingX: itemPaddingX, paddingY: itemPaddingY } = this.item;
        const paginationComponentPadding = 8;
        const legendItemsWidth = maxPageWidth - itemPaddingX;
        const legendItemsHeight = maxPageHeight - itemPaddingY;
        let paginationX = 0;
        let paginationY = -paginationBBox.y - this.item.marker.size / 2;
        if (paginationVertical) paginationY += legendItemsHeight + paginationComponentPadding;
        else {
            paginationX += -paginationBBox.x + legendItemsWidth + paginationComponentPadding;
            paginationY += (legendItemsHeight - paginationBBox.height) / 2;
        }
        this.pagination.translationX = paginationX;
        this.pagination.translationY = paginationY;
        this.pagination.update();
        this.pagination.updateMarkers();
        let pageIndex = 0;
        this.itemSelection.each((markerLabel, _, nodeIndex)=>{
            if (nodeIndex > (pages[pageIndex]?.endIndex ?? Infinity)) pageIndex++;
            markerLabel.pageIndex = pageIndex;
        });
        return {
            maxPageHeight: maxPageHeight,
            maxPageWidth: maxPageWidth,
            pages: pages
        };
    }
    calculatePagination(bboxes, width2, height2) {
        const { paddingX: itemPaddingX, paddingY: itemPaddingY } = this.item;
        const orientation = this.getOrientation();
        const paginationVertical = [
            "left",
            "right"
        ].includes(this.position);
        let paginationBBox = this.pagination.getBBox();
        let lastPassPaginationBBox = new $d77b025aa58d633c$var$BBox(0, 0, 0, 0);
        let pages = [];
        let maxPageWidth = 0;
        let maxPageHeight = 0;
        let count = 0;
        const stableOutput = (bbox)=>{
            return bbox.width === paginationBBox.width && bbox.height === paginationBBox.height;
        };
        const forceResult = this.maxWidth !== void 0 && this.maxHeight !== void 0;
        do {
            if (count++ > 10) {
                (0, $idDdm.Logger).warn("unable to find stable legend layout.");
                break;
            }
            paginationBBox = lastPassPaginationBBox;
            const maxWidth = width2 - (paginationVertical ? 0 : paginationBBox.width);
            const maxHeight = height2 - (paginationVertical ? paginationBBox.height : 0);
            const layout = $d77b025aa58d633c$var$gridLayout({
                orientation: orientation,
                bboxes: bboxes,
                maxHeight: maxHeight,
                maxWidth: maxWidth,
                itemPaddingY: itemPaddingY,
                itemPaddingX: itemPaddingX,
                forceResult: forceResult
            });
            pages = layout?.pages ?? [];
            maxPageWidth = layout?.maxPageWidth ?? 0;
            maxPageHeight = layout?.maxPageHeight ?? 0;
            const totalPages = pages.length;
            this.pagination.visible = totalPages > 1;
            this.pagination.totalPages = totalPages;
            this.pagination.update();
            this.pagination.updateMarkers();
            lastPassPaginationBBox = this.pagination.getBBox();
            if (!this.pagination.visible) break;
        }while (!stableOutput(lastPassPaginationBBox));
        return {
            maxPageWidth: maxPageWidth,
            maxPageHeight: maxPageHeight,
            pages: pages,
            paginationBBox: lastPassPaginationBBox,
            paginationVertical: paginationVertical
        };
    }
    updatePositions(pageNumber = 0) {
        const { item: { paddingY: paddingY }, itemSelection: itemSelection, pages: pages } = this;
        if (pages.length < 1 || !pages[pageNumber]) return;
        const { columns: columns, startIndex: visibleStart, endIndex: visibleEnd } = pages[pageNumber];
        let x = 0;
        let y = 0;
        const columnCount = columns.length;
        const rowCount = columns[0].indices.length;
        const horizontal = this.getOrientation() === "horizontal";
        const itemHeight = columns[0].bboxes[0].height + paddingY;
        const rowSumColumnWidths = [];
        itemSelection.each((markerLabel, _, i)=>{
            if (i < visibleStart || i > visibleEnd) {
                markerLabel.visible = false;
                return;
            }
            const pageIndex = i - visibleStart;
            let columnIndex;
            let rowIndex;
            if (horizontal) {
                columnIndex = pageIndex % columnCount;
                rowIndex = Math.floor(pageIndex / columnCount);
            } else {
                columnIndex = Math.floor(pageIndex / rowCount);
                rowIndex = pageIndex % rowCount;
            }
            markerLabel.visible = true;
            const column = columns[columnIndex];
            if (!column) return;
            y = Math.floor(itemHeight * rowIndex);
            x = Math.floor(rowSumColumnWidths[rowIndex] ?? 0);
            rowSumColumnWidths[rowIndex] = (rowSumColumnWidths[rowIndex] ?? 0) + column.columnWidth;
            markerLabel.translationX = x;
            markerLabel.translationY = y;
        });
    }
    updatePageNumber(pageNumber) {
        const { itemSelection: itemSelection, group: group, pagination: pagination, pages: pages, toggleSeries: interactive } = this;
        const { startIndex: startIndex, endIndex: endIndex } = pages[pageNumber];
        if (startIndex === 0) this.paginationTrackingIndex = 0;
        else if (pageNumber === pages.length - 1) this.paginationTrackingIndex = endIndex;
        else this.paginationTrackingIndex = Math.floor((startIndex + endIndex) / 2);
        this.pagination.update();
        this.pagination.updateMarkers();
        this.updatePositions(pageNumber);
        this.domProxy.onPageChange({
            itemSelection: itemSelection,
            group: group,
            pagination: pagination,
            interactive: interactive
        });
        this.ctx.updateService.update(7 /* SCENE_RENDER */ );
    }
    update() {
        const { label: { color: color11 } } = this.item;
        this.itemSelection.each((markerLabel, datum)=>{
            markerLabel.setEnabled(datum.enabled);
            markerLabel.color = color11;
        });
        this.updateContextMenu();
    }
    updateContextMenu() {
        this.ctx.contextMenuRegistry.setVisible("toggle-series-visibility", this.toggleSeries);
        this.ctx.contextMenuRegistry.setVisible("toggle-other-series", this.toggleSeries);
    }
    getLineStyles(datum) {
        const { stroke: stroke2, strokeOpacity: strokeOpacity = 1, strokeWidth: strokeWidth, lineDash: lineDash } = datum.line ?? {};
        const defaultLineStrokeWidth = Math.min(2, strokeWidth ?? 1);
        return {
            stroke: stroke2,
            strokeOpacity: strokeOpacity,
            strokeWidth: this.item.line.strokeWidth ?? defaultLineStrokeWidth,
            lineDash: lineDash
        };
    }
    getMarkerStyles({ marker: marker }) {
        const { fill: fill, stroke: stroke2, strokeOpacity: strokeOpacity = 1, fillOpacity: fillOpacity = 1, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset } = marker;
        const defaultLineStrokeWidth = Math.min(2, strokeWidth ?? 1);
        if ($d77b025aa58d633c$var$isPatternFill(fill)) {
            fill.width = 8;
            fill.height = 8;
            fill.padding = 1;
            fill.strokeWidth = Math.min(2, fill.strokeWidth ?? 2);
        }
        if ($d77b025aa58d633c$var$isImageFill(fill)) {
            fill.fit = "contain";
            fill.width = void 0;
            fill.height = void 0;
            fill.repeat = "no-repeat";
        }
        return $d77b025aa58d633c$var$getShapeStyle({
            fill: fill,
            stroke: stroke2,
            strokeOpacity: strokeOpacity,
            fillOpacity: fillOpacity,
            strokeWidth: this.item.marker.strokeWidth ?? defaultLineStrokeWidth,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset
        }, $d77b025aa58d633c$var$fillGradientDefaults, $d77b025aa58d633c$var$fillPatternDefaults, $d77b025aa58d633c$var$fillImageDefaults);
    }
    computePagedBBox() {
        const actualBBox = $d77b025aa58d633c$var$Group.computeChildrenBBox(this.group.children());
        if (this.pages.length > 1) {
            const [maxPageWidth, maxPageHeight] = this.maxPageSize;
            actualBBox.height = Math.max(maxPageHeight, actualBBox.height);
            actualBBox.width = Math.max(maxPageWidth, actualBBox.width);
        }
        return actualBBox;
    }
    findNode(params) {
        const { datum: datum, proxyButton: proxyButton } = this.itemSelection.select((ml)=>ml.datum?.itemId === params.itemId)[0] ?? {};
        if (datum === void 0 || proxyButton === void 0) throw new Error(`AG Charts - Missing required properties { datum: ${datum}, proxyButton: ${JSON.stringify(proxyButton)} }`);
        return {
            datum: datum,
            proxyButton: proxyButton
        };
    }
    contextToggleVisibility(params) {
        const { datum: datum, proxyButton: proxyButton } = this.findNode(params);
        this.doClick(params.event, datum, proxyButton);
    }
    contextToggleOtherSeries(params) {
        this.doDoubleClick(params.event, this.findNode(params).datum);
    }
    onContextClick(widgetEvent, node) {
        const { sourceEvent: sourceEvent } = widgetEvent;
        const legendItem = node.datum;
        if (this.preventHidingAll && this.contextMenuDatum?.enabled && this.getVisibleItemCount() <= 1) this.ctx.contextMenuRegistry.builtins.items["toggle-series-visibility"].enabled = false;
        else this.ctx.contextMenuRegistry.builtins.items["toggle-series-visibility"].enabled = true;
        const toggleOtherSeriesVisible = this.ctx.chartService.series.length > 1 && this.ctx.chartService.series[0]?.getLegendData("category")[0]?.hideToggleOtherSeries !== true;
        this.ctx.contextMenuRegistry.setVisible("toggle-other-series", toggleOtherSeriesVisible);
        const { offsetX: offsetX, offsetY: offsetY } = sourceEvent;
        const { x: canvasX, y: canvasY } = $d77b025aa58d633c$var$Transformable.toCanvasPoint(node, offsetX, offsetY);
        this.ctx.contextMenuRegistry.dispatchContext("legend-item", {
            widgetEvent: widgetEvent,
            canvasX: canvasX,
            canvasY: canvasY
        }, {
            legendItem: legendItem
        });
    }
    onClick(event, datum, proxyButton) {
        if (this.doClick(event, datum, proxyButton)) event.preventDefault();
    }
    getVisibleItemCount() {
        return this.ctx.chartService.series.flatMap((s)=>s.getLegendData("category")).filter((d)=>d.enabled).length;
    }
    doClick(event, datum, proxyButton) {
        const { listeners: { legendItemClick: legendItemClick }, ctx: { chartService: chartService, highlightManager: highlightManager }, preventHidingAll: preventHidingAll, toggleSeries: toggleSeries } = this;
        if (!datum) return false;
        const { legendType: legendType, seriesId: seriesId, itemId: itemId, enabled: enabled } = datum;
        const series = chartService.series.find((s)=>s.id === seriesId);
        if (!series) return false;
        let newEnabled = enabled;
        const clickEvent = $d77b025aa58d633c$var$makeLegendItemEvent("click", itemId, series.id, event);
        legendItemClick?.(clickEvent.apiEvent);
        if (clickEvent.defaultPrevented) return true;
        if (toggleSeries) {
            newEnabled = !enabled;
            if (preventHidingAll && !newEnabled) {
                const numVisibleItems = this.getVisibleItemCount();
                if (numVisibleItems < 2) newEnabled = true;
            }
            proxyButton.setChecked(newEnabled);
            this.ctx.chartEventManager.legendItemClick(legendType, series, itemId, newEnabled, datum.legendItemName);
        }
        if (newEnabled) highlightManager.updateHighlight(this.id, {
            series: series,
            itemId: itemId,
            datum: void 0,
            datumIndex: void 0
        });
        else highlightManager.updateHighlight(this.id);
        this.ctx.legendManager.update();
        this.ctx.updateService.update(2 /* PROCESS_DATA */ , {
            forceNodeDataRefresh: true,
            skipAnimations: datum.skipAnimations ?? false
        });
        return true;
    }
    onDoubleClick(event, datum) {
        if (this.doDoubleClick(event, datum)) event.preventDefault();
    }
    doDoubleClick(event, datum) {
        const { listeners: { legendItemDoubleClick: legendItemDoubleClick }, ctx: { chartService: chartService }, toggleSeries: toggleSeries } = this;
        if (!datum) return false;
        const { legendType: legendType, id: id, itemId: itemId, seriesId: seriesId } = datum;
        const series = chartService.series.find((s)=>s.id === id);
        if (!series) return false;
        const doubleClickEvent = $d77b025aa58d633c$var$makeLegendItemEvent("dblclick", itemId, series.id, event);
        legendItemDoubleClick?.(doubleClickEvent.apiEvent);
        if (doubleClickEvent.defaultPrevented) return true;
        if (toggleSeries) {
            const legendData = chartService.series.flatMap((s)=>s.getLegendData("category"));
            let numVisibleItems = 0;
            const visibleLegendItemNames = /* @__PURE__ */ new Set();
            for (const d of legendData){
                if (!d.enabled) continue;
                numVisibleItems += 1;
                if (d.legendItemName != null) visibleLegendItemNames.add(d.legendItemName);
            }
            if (visibleLegendItemNames.size > 0) numVisibleItems = visibleLegendItemNames.size;
            const clickedItem = legendData.find((d)=>d.itemId === itemId && d.seriesId === seriesId);
            this.ctx.chartEventManager.legendItemDoubleClick(legendType, series, itemId, clickedItem?.enabled ?? false, numVisibleItems, clickedItem?.legendItemName);
        }
        this.ctx.legendManager.update();
        this.ctx.updateService.update(2 /* PROCESS_DATA */ , {
            forceNodeDataRefresh: true
        });
        return true;
    }
    toTooltipMeta(event, node) {
        let point;
        if (event instanceof FocusEvent) point = $d77b025aa58d633c$var$Transformable.toCanvas(node).computeCenter();
        else {
            event.preventDefault();
            point = $d77b025aa58d633c$var$Transformable.toCanvasPoint(node, event.offsetX, event.offsetY);
        }
        return {
            canvasX: point.x,
            canvasY: point.y,
            showArrow: false
        };
    }
    onHover(event, node) {
        if (!this.enabled) throw new Error("AG Charts - onHover handler called on disabled legend");
        this.pagination.setPage(node.pageIndex);
        const datum = node.datum;
        const series = datum ? this.ctx.chartService.series.find((s)=>s.id === datum?.id) : void 0;
        if (datum && this.truncatedItems.has(datum.itemId ?? datum.id)) {
            const meta = this.toTooltipMeta(event, node);
            this.ctx.tooltipManager.updateTooltip(this.id, meta, [
                {
                    type: "structured",
                    title: this.getItemLabel(datum)
                }
            ]);
        } else this.ctx.tooltipManager.removeTooltip(this.id);
        if (datum?.enabled && series) this.updateHighlight({
            series: series,
            itemId: datum?.itemId,
            datum: void 0,
            datumIndex: void 0
        });
        else this.updateHighlight();
    }
    onLeave() {
        this.ctx.tooltipManager.removeTooltip(this.id);
        this.updateHighlight();
    }
    updateHighlight(datum) {
        if (this.ctx.interactionManager.isState(32 /* Default */ )) this.ctx.highlightManager.updateHighlight(this.id, datum);
        else if (this.ctx.interactionManager.isState(2 /* Animation */ )) {
            this.pendingHighlightDatum = datum;
            this.ctx.animationManager.onBatchStop(()=>{
                this.ctx.highlightManager.updateHighlight(this.id, this.pendingHighlightDatum);
            });
        }
    }
    onLocaleChanged() {
        this.domProxy.onLocaleChanged(this.ctx.localeManager, this.itemSelection, this);
    }
    positionLegend(ctx) {
        const oldPages = this.positionLegendScene(ctx);
        this.positionLegendDOM(oldPages);
    }
    positionLegendScene(ctx) {
        if (!this.enabled || !this.data.length) return;
        const { layoutBox: layoutBox } = ctx;
        const { x: x, y: y, width: width2, height: height2 } = layoutBox;
        const [legendWidth, legendHeight] = this.calculateLegendDimensions(layoutBox);
        const { oldPages: oldPages } = this.calcLayout(legendWidth, legendHeight);
        const legendBBox = this.computePagedBBox();
        const calculateTranslationPerpendicularDimension = ()=>{
            switch(this.position){
                case "top":
                case "left":
                    return 0;
                case "bottom":
                    return height2 - legendBBox.height;
                case "right":
                default:
                    return width2 - legendBBox.width;
            }
        };
        if (this.visible) {
            const legendPadding = this.spacing;
            let translationX;
            let translationY;
            switch(this.position){
                case "top":
                case "bottom":
                    translationX = (width2 - legendBBox.width) / 2;
                    translationY = calculateTranslationPerpendicularDimension();
                    layoutBox.shrink(legendBBox.height + legendPadding, this.position);
                    break;
                case "left":
                case "right":
                default:
                    translationX = calculateTranslationPerpendicularDimension();
                    translationY = (height2 - legendBBox.height) / 2;
                    layoutBox.shrink(legendBBox.width + legendPadding, this.position);
            }
            this.group.translationX = Math.floor(x + translationX - legendBBox.x);
            this.group.translationY = Math.floor(y + translationY - legendBBox.y);
        }
        return oldPages;
    }
    positionLegendDOM(oldPages) {
        const { ctx: ctx, itemSelection: itemSelection, pagination: pagination, pages: newPages, toggleSeries: toggleSeries, group: group, listeners: { legendItemClick: legendItemClick, legendItemDoubleClick: legendItemDoubleClick } } = this;
        const visible = this.visible && this.enabled;
        const interactive = toggleSeries || legendItemDoubleClick != null || legendItemClick != null;
        this.domProxy.update({
            visible: visible,
            interactive: interactive,
            ctx: ctx,
            itemSelection: itemSelection,
            group: group,
            pagination: pagination,
            oldPages: oldPages,
            newPages: newPages,
            datumReader: this,
            itemListener: this
        });
    }
    calculateLegendDimensions(shrinkRect) {
        const { width: width2, height: height2 } = shrinkRect;
        const aspectRatio = width2 / height2;
        const maxCoefficient = 0.5;
        const minHeightCoefficient = 0.2;
        const minWidthCoefficient = 0.25;
        let legendWidth, legendHeight;
        switch(this.position){
            case "top":
            case "bottom":
                {
                    const heightCoefficient = aspectRatio < 1 ? Math.min(maxCoefficient, minHeightCoefficient * (1 / aspectRatio)) : minHeightCoefficient;
                    legendWidth = this.maxWidth ? Math.min(this.maxWidth, width2) : width2;
                    legendHeight = this.maxHeight ? Math.min(this.maxHeight, height2) : Math.round(height2 * heightCoefficient);
                    break;
                }
            case "left":
            case "right":
            default:
                {
                    const widthCoefficient = aspectRatio > 1 ? Math.min(maxCoefficient, minWidthCoefficient * aspectRatio) : minWidthCoefficient;
                    legendWidth = this.maxWidth ? Math.min(this.maxWidth, width2) : Math.round(width2 * widthCoefficient);
                    legendHeight = this.maxHeight ? Math.min(this.maxHeight, height2) : height2;
                }
        }
        return [
            legendWidth,
            legendHeight
        ];
    }
    cachedCallWithContext(fn, ...params) {
        const { callbackCache: callbackCache, chartService: chartService } = this.ctx;
        return callbackCache.call(this, chartService, fn, ...params);
    }
};
$d77b025aa58d633c$var$Legend.className = "Legend";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Legend.prototype, "toggleSeries", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Legend.prototype, "pagination", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Legend.prototype, "item", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Legend.prototype, "listeners", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target, newValue, oldValue)=>{
        target.updateGroupVisibility();
        if (newValue === oldValue) return;
        const { ctx: { legendManager: legendManager, stateManager: stateManager } } = target;
        if (oldValue === false && newValue === true) stateManager.restoreState(legendManager);
    }),
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Legend.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Legend.prototype, "position", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Legend.prototype, "maxWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Legend.prototype, "maxHeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Legend.prototype, "reverseOrder", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Legend.prototype, "orientation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Legend.prototype, "preventHidingAll", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$Legend.prototype, "spacing", 2);
// packages/ag-charts-community/src/chart/legend/legendModule.ts
var $d77b025aa58d633c$var$CommunityLegendModule = {
    type: "legend",
    optionsKey: "legend",
    identifier: "category",
    chartTypes: [
        "cartesian",
        "polar",
        "hierarchy",
        "topology",
        "flow-proportion",
        "standalone",
        "gauge"
    ],
    moduleFactory: (ctx)=>new $d77b025aa58d633c$var$Legend(ctx),
    packageType: "community",
    removable: "standalone-only"
};
// packages/ag-charts-community/src/chart/themes/constants.ts
var $d77b025aa58d633c$var$constants_exports = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$var$constants_exports, {
    CARTESIAN_AXIS_TYPE: ()=>$d77b025aa58d633c$var$CARTESIAN_AXIS_TYPE,
    CARTESIAN_POSITION: ()=>$d77b025aa58d633c$var$CARTESIAN_POSITION,
    FONT_SIZE: ()=>$d77b025aa58d633c$var$FONT_SIZE,
    FONT_SIZE_RATIO: ()=>$d77b025aa58d633c$var$FONT_SIZE_RATIO,
    POLAR_AXIS_SHAPE: ()=>$d77b025aa58d633c$var$POLAR_AXIS_SHAPE,
    POLAR_AXIS_TYPE: ()=>$d77b025aa58d633c$var$POLAR_AXIS_TYPE
});
var $d77b025aa58d633c$var$FONT_SIZE = /* @__PURE__ */ ((FONT_SIZE2)=>{
    FONT_SIZE2[FONT_SIZE2["SMALLEST"] = 8] = "SMALLEST";
    FONT_SIZE2[FONT_SIZE2["SMALLER"] = 10] = "SMALLER";
    FONT_SIZE2[FONT_SIZE2["SMALL"] = 12] = "SMALL";
    FONT_SIZE2[FONT_SIZE2["MEDIUM"] = 13] = "MEDIUM";
    FONT_SIZE2[FONT_SIZE2["LARGE"] = 14] = "LARGE";
    FONT_SIZE2[FONT_SIZE2["LARGEST"] = 17] = "LARGEST";
    return FONT_SIZE2;
})($d77b025aa58d633c$var$FONT_SIZE || {});
var $d77b025aa58d633c$var$FONT_SIZE_RATIO = /* @__PURE__ */ ((FONT_SIZE_RATIO2)=>{
    FONT_SIZE_RATIO2[FONT_SIZE_RATIO2["SMALLEST"] = 0.6666666666666666] = "SMALLEST";
    FONT_SIZE_RATIO2[FONT_SIZE_RATIO2["SMALLER"] = 0.8333333333333334] = "SMALLER";
    FONT_SIZE_RATIO2[FONT_SIZE_RATIO2["SMALL"] = 1] = "SMALL";
    FONT_SIZE_RATIO2[FONT_SIZE_RATIO2["MEDIUM"] = 1.0833333333333333] = "MEDIUM";
    FONT_SIZE_RATIO2[FONT_SIZE_RATIO2["LARGE"] = 1.1666666666666667] = "LARGE";
    FONT_SIZE_RATIO2[FONT_SIZE_RATIO2["LARGEST"] = 1.4166666666666667] = "LARGEST";
    return FONT_SIZE_RATIO2;
})($d77b025aa58d633c$var$FONT_SIZE_RATIO || {});
var $d77b025aa58d633c$var$CARTESIAN_POSITION = /* @__PURE__ */ ((CARTESIAN_POSITION2)=>{
    CARTESIAN_POSITION2["TOP"] = "top";
    CARTESIAN_POSITION2["RIGHT"] = "right";
    CARTESIAN_POSITION2["BOTTOM"] = "bottom";
    CARTESIAN_POSITION2["LEFT"] = "left";
    return CARTESIAN_POSITION2;
})($d77b025aa58d633c$var$CARTESIAN_POSITION || {});
var $d77b025aa58d633c$var$CARTESIAN_AXIS_TYPE = /* @__PURE__ */ ((CARTESIAN_AXIS_TYPE2)=>{
    CARTESIAN_AXIS_TYPE2["CATEGORY"] = "category";
    CARTESIAN_AXIS_TYPE2["GROUPED_CATEGORY"] = "grouped-category";
    CARTESIAN_AXIS_TYPE2["ORDINAL_TIME"] = "ordinal-time";
    CARTESIAN_AXIS_TYPE2["UNIT_TIME"] = "unit-time";
    CARTESIAN_AXIS_TYPE2["NUMBER"] = "number";
    CARTESIAN_AXIS_TYPE2["TIME"] = "time";
    CARTESIAN_AXIS_TYPE2["LOG"] = "log";
    return CARTESIAN_AXIS_TYPE2;
})($d77b025aa58d633c$var$CARTESIAN_AXIS_TYPE || {});
var $d77b025aa58d633c$var$POLAR_AXIS_TYPE = /* @__PURE__ */ ((POLAR_AXIS_TYPE2)=>{
    POLAR_AXIS_TYPE2["ANGLE_CATEGORY"] = "angle-category";
    POLAR_AXIS_TYPE2["ANGLE_NUMBER"] = "angle-number";
    POLAR_AXIS_TYPE2["RADIUS_CATEGORY"] = "radius-category";
    POLAR_AXIS_TYPE2["RADIUS_NUMBER"] = "radius-number";
    return POLAR_AXIS_TYPE2;
})($d77b025aa58d633c$var$POLAR_AXIS_TYPE || {});
var $d77b025aa58d633c$var$POLAR_AXIS_SHAPE = /* @__PURE__ */ ((POLAR_AXIS_SHAPE2)=>{
    POLAR_AXIS_SHAPE2["CIRCLE"] = "circle";
    POLAR_AXIS_SHAPE2["POLYGON"] = "polygon";
    return POLAR_AXIS_SHAPE2;
})($d77b025aa58d633c$var$POLAR_AXIS_SHAPE || {});
// packages/ag-charts-community/src/chart/themes/symbols.ts
var $d77b025aa58d633c$var$symbols_exports = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$var$symbols_exports, {
    DEFAULT_ANNOTATION_HANDLE_FILL: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_HANDLE_FILL,
    DEFAULT_ANNOTATION_STATISTICS_COLOR: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_COLOR,
    DEFAULT_ANNOTATION_STATISTICS_DIVIDER_STROKE: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DIVIDER_STROKE,
    DEFAULT_ANNOTATION_STATISTICS_DOWN_FILL: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DOWN_FILL,
    DEFAULT_ANNOTATION_STATISTICS_DOWN_STROKE: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DOWN_STROKE,
    DEFAULT_ANNOTATION_STATISTICS_FILL: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_FILL,
    DEFAULT_ANNOTATION_STATISTICS_STROKE: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_STROKE,
    DEFAULT_CAPTION_ALIGNMENT: ()=>$d77b025aa58d633c$var$DEFAULT_CAPTION_ALIGNMENT,
    DEFAULT_CAPTION_LAYOUT_STYLE: ()=>$d77b025aa58d633c$var$DEFAULT_CAPTION_LAYOUT_STYLE,
    DEFAULT_FIBONACCI_STROKES: ()=>$d77b025aa58d633c$var$DEFAULT_FIBONACCI_STROKES,
    DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL: ()=>$d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL,
    DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR: ()=>$d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR,
    DEFAULT_GRIDLINE_ENABLED: ()=>$d77b025aa58d633c$var$DEFAULT_GRIDLINE_ENABLED,
    DEFAULT_POLAR_SERIES_STROKE: ()=>$d77b025aa58d633c$var$DEFAULT_POLAR_SERIES_STROKE,
    DEFAULT_SEPARATION_LINES_COLOUR: ()=>$d77b025aa58d633c$var$DEFAULT_SEPARATION_LINES_COLOUR,
    DEFAULT_SHADOW_COLOUR: ()=>$d77b025aa58d633c$var$DEFAULT_SHADOW_COLOUR,
    DEFAULT_SPARKLINE_CROSSHAIR_STROKE: ()=>$d77b025aa58d633c$var$DEFAULT_SPARKLINE_CROSSHAIR_STROKE,
    DEFAULT_TEXTBOX_COLOR: ()=>$d77b025aa58d633c$var$DEFAULT_TEXTBOX_COLOR,
    DEFAULT_TEXTBOX_FILL: ()=>$d77b025aa58d633c$var$DEFAULT_TEXTBOX_FILL,
    DEFAULT_TEXTBOX_STROKE: ()=>$d77b025aa58d633c$var$DEFAULT_TEXTBOX_STROKE,
    DEFAULT_TEXT_ANNOTATION_COLOR: ()=>$d77b025aa58d633c$var$DEFAULT_TEXT_ANNOTATION_COLOR,
    DEFAULT_TOOLBAR_POSITION: ()=>$d77b025aa58d633c$var$DEFAULT_TOOLBAR_POSITION,
    IS_DARK_THEME: ()=>$d77b025aa58d633c$var$IS_DARK_THEME,
    PALETTE_ALT_DOWN_FILL: ()=>$d77b025aa58d633c$var$PALETTE_ALT_DOWN_FILL,
    PALETTE_ALT_DOWN_STROKE: ()=>$d77b025aa58d633c$var$PALETTE_ALT_DOWN_STROKE,
    PALETTE_ALT_NEUTRAL_FILL: ()=>$d77b025aa58d633c$var$PALETTE_ALT_NEUTRAL_FILL,
    PALETTE_ALT_NEUTRAL_STROKE: ()=>$d77b025aa58d633c$var$PALETTE_ALT_NEUTRAL_STROKE,
    PALETTE_ALT_UP_FILL: ()=>$d77b025aa58d633c$var$PALETTE_ALT_UP_FILL,
    PALETTE_ALT_UP_STROKE: ()=>$d77b025aa58d633c$var$PALETTE_ALT_UP_STROKE,
    PALETTE_DOWN_FILL: ()=>$d77b025aa58d633c$var$PALETTE_DOWN_FILL,
    PALETTE_DOWN_STROKE: ()=>$d77b025aa58d633c$var$PALETTE_DOWN_STROKE,
    PALETTE_NEUTRAL_FILL: ()=>$d77b025aa58d633c$var$PALETTE_NEUTRAL_FILL,
    PALETTE_NEUTRAL_STROKE: ()=>$d77b025aa58d633c$var$PALETTE_NEUTRAL_STROKE,
    PALETTE_UP_FILL: ()=>$d77b025aa58d633c$var$PALETTE_UP_FILL,
    PALETTE_UP_STROKE: ()=>$d77b025aa58d633c$var$PALETTE_UP_STROKE
});
var $d77b025aa58d633c$var$IS_DARK_THEME = Symbol("is-dark-theme");
var $d77b025aa58d633c$var$DEFAULT_SEPARATION_LINES_COLOUR = Symbol("default-separation-lines-colour");
var $d77b025aa58d633c$var$DEFAULT_SHADOW_COLOUR = Symbol("default-shadow-colour");
var $d77b025aa58d633c$var$DEFAULT_CAPTION_LAYOUT_STYLE = Symbol("default-caption-layout-style");
var $d77b025aa58d633c$var$DEFAULT_CAPTION_ALIGNMENT = Symbol("default-caption-alignment");
var $d77b025aa58d633c$var$PALETTE_UP_STROKE = Symbol("palette-up-stroke");
var $d77b025aa58d633c$var$PALETTE_DOWN_STROKE = Symbol("palette-down-stroke");
var $d77b025aa58d633c$var$PALETTE_UP_FILL = Symbol("palette-up-fill");
var $d77b025aa58d633c$var$PALETTE_DOWN_FILL = Symbol("palette-down-fill");
var $d77b025aa58d633c$var$PALETTE_NEUTRAL_STROKE = Symbol("palette-neutral-stroke");
var $d77b025aa58d633c$var$PALETTE_NEUTRAL_FILL = Symbol("palette-neutral-fill");
var $d77b025aa58d633c$var$PALETTE_ALT_UP_STROKE = Symbol("palette-alt-up-stroke");
var $d77b025aa58d633c$var$PALETTE_ALT_DOWN_STROKE = Symbol("palette-alt-down-stroke");
var $d77b025aa58d633c$var$PALETTE_ALT_UP_FILL = Symbol("palette-alt-up-fill");
var $d77b025aa58d633c$var$PALETTE_ALT_DOWN_FILL = Symbol("palette-alt-down-fill");
var $d77b025aa58d633c$var$PALETTE_ALT_NEUTRAL_FILL = Symbol("palette-gray-fill");
var $d77b025aa58d633c$var$PALETTE_ALT_NEUTRAL_STROKE = Symbol("palette-gray-stroke");
var $d77b025aa58d633c$var$DEFAULT_POLAR_SERIES_STROKE = Symbol("default-polar-series-stroke");
var $d77b025aa58d633c$var$DEFAULT_SPARKLINE_CROSSHAIR_STROKE = Symbol("default-sparkline-crosshair-stroke");
var $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR = Symbol("default-financial-charts-annotation-stroke");
var $d77b025aa58d633c$var$DEFAULT_FIBONACCI_STROKES = Symbol("default-hierarchy-strokes");
var $d77b025aa58d633c$var$DEFAULT_TEXT_ANNOTATION_COLOR = Symbol("default-text-annotation-color");
var $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL = Symbol("default-financial-charts-annotation-background-fill");
var $d77b025aa58d633c$var$DEFAULT_ANNOTATION_HANDLE_FILL = Symbol("default-annotation-handle-fill");
var $d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_FILL = Symbol("default-annotation-statistics-fill");
var $d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_STROKE = Symbol("default-annotation-statistics-stroke");
var $d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_COLOR = Symbol("default-annotation-statistics-color");
var $d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DIVIDER_STROKE = Symbol("default-annotation-statistics-divider-stroke");
var $d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DOWN_FILL = Symbol("default-annotation-statistics-fill");
var $d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DOWN_STROKE = Symbol("default-annotation-statistics-stroke");
var $d77b025aa58d633c$var$DEFAULT_TEXTBOX_FILL = Symbol("default-textbox-fill");
var $d77b025aa58d633c$var$DEFAULT_TEXTBOX_STROKE = Symbol("default-textbox-stroke");
var $d77b025aa58d633c$var$DEFAULT_TEXTBOX_COLOR = Symbol("default-textbox-color");
var $d77b025aa58d633c$var$DEFAULT_TOOLBAR_POSITION = Symbol("default-toolbar-position");
var $d77b025aa58d633c$var$DEFAULT_GRIDLINE_ENABLED = Symbol("default-gridline-enabled");
// packages/ag-charts-community/src/chart/themes/util.ts
var $d77b025aa58d633c$var$DIRECTION_SWAP_AXES = [
    {
        type: "number" /* NUMBER */ ,
        position: {
            $if: [
                {
                    $eq: [
                        {
                            $path: [
                                "/direction",
                                void 0
                            ]
                        },
                        "horizontal"
                    ]
                },
                "bottom" /* BOTTOM */ ,
                "left" /* LEFT */ 
            ]
        }
    },
    {
        type: "category" /* CATEGORY */ ,
        position: {
            $if: [
                {
                    $eq: [
                        {
                            $path: [
                                "/direction",
                                void 0
                            ]
                        },
                        "horizontal"
                    ]
                },
                "left" /* LEFT */ ,
                "bottom" /* BOTTOM */ 
            ]
        }
    }
];
var $d77b025aa58d633c$var$SAFE_FILL_OPERATION = {
    $if: [
        {
            $or: [
                {
                    $isGradient: [
                        {
                            $palette: "fill"
                        }
                    ]
                },
                {
                    $isPattern: [
                        {
                            $palette: "fill"
                        }
                    ]
                },
                {
                    $isImage: [
                        {
                            $value: "$1"
                        }
                    ]
                }
            ]
        },
        {
            $palette: "fillFallback"
        },
        {
            $palette: "fill"
        }
    ]
};
var $d77b025aa58d633c$var$SAFE_FILLS_OPERATION = {
    $if: [
        {
            $or: [
                {
                    $isGradient: [
                        {
                            $palette: "fill"
                        }
                    ]
                },
                {
                    $isPattern: [
                        {
                            $palette: "fill"
                        }
                    ]
                },
                {
                    $isImage: [
                        {
                            $value: "$1"
                        }
                    ]
                }
            ]
        },
        {
            $palette: "fillsFallback"
        },
        {
            $palette: "fills"
        }
    ]
};
var $d77b025aa58d633c$var$SAFE_STROKE_FILL_OPERATION = {
    $if: [
        {
            $isGradient: [
                {
                    $palette: "fill"
                }
            ]
        },
        {
            $palette: "fillFallback"
        },
        {
            $if: [
                {
                    $isPattern: [
                        {
                            $palette: "fill"
                        }
                    ]
                },
                {
                    $path: [
                        "./stroke",
                        {
                            $palette: "fillFallback"
                        },
                        {
                            $palette: "fill"
                        }
                    ]
                },
                {
                    $palette: "fill"
                }
            ]
        }
    ]
};
var $d77b025aa58d633c$var$SAFE_RANGE2_OPERATION = {
    $if: [
        {
            $or: [
                {
                    $isGradient: [
                        {
                            $palette: "fill"
                        }
                    ]
                },
                {
                    $isPattern: [
                        {
                            $palette: "fill"
                        }
                    ]
                },
                {
                    $isImage: [
                        {
                            $value: "$1"
                        }
                    ]
                }
            ]
        },
        [
            {
                $palette: "fillFallback"
            },
            {
                $palette: "fillFallback"
            }
        ],
        {
            $palette: "range2"
        }
    ]
};
var $d77b025aa58d633c$var$FILL_PATTERN_DEFAULTS = {
    type: "pattern",
    pattern: "forward-slanted-lines",
    width: 10,
    height: 10,
    padding: 2,
    fill: {
        $if: [
            {
                $or: [
                    {
                        $isGradient: [
                            {
                                $palette: "fill"
                            }
                        ]
                    },
                    {
                        $isImage: [
                            {
                                $palette: "fill"
                            }
                        ]
                    }
                ]
            },
            {
                $palette: "fillFallback"
            },
            {
                $if: [
                    {
                        $isPattern: [
                            {
                                $palette: "fill"
                            }
                        ]
                    },
                    {
                        $path: [
                            "./fill",
                            {
                                $palette: "fillFallback"
                            },
                            {
                                $palette: "fill"
                            }
                        ]
                    },
                    {
                        $palette: "fill"
                    }
                ]
            }
        ]
    },
    fillOpacity: 1,
    stroke: $d77b025aa58d633c$var$SAFE_STROKE_FILL_OPERATION,
    strokeOpacity: 1,
    strokeWidth: 4,
    backgroundFill: "none",
    backgroundFillOpacity: 1,
    rotation: 0,
    scale: 1
};
var $d77b025aa58d633c$var$FILL_IMAGE_DEFAULTS = {
    type: "image",
    backgroundFill: {
        $palette: "fillFallback"
    },
    backgroundFillOpacity: 1,
    repeat: "no-repeat",
    fit: "contain",
    rotation: 0
};
function $d77b025aa58d633c$var$getSequentialColors(colors) {
    return $d77b025aa58d633c$var$mapValues(colors, (value)=>{
        const color11 = $d77b025aa58d633c$var$Color.fromString(value);
        return [
            $d77b025aa58d633c$var$Color.darken(color11, 0.15).toString(),
            value,
            $d77b025aa58d633c$var$Color.lighten(color11, 0.15).toString()
        ];
    });
}
// packages/ag-charts-community/src/motion/pathMotion.ts
function $d77b025aa58d633c$var$pathMotion(groupId, subId, animationManager, paths, fns) {
    const { addPhaseFn: addPhaseFn, updatePhaseFn: updatePhaseFn, removePhaseFn: removePhaseFn } = fns;
    const animate = (phase, path, updateFn)=>{
        animationManager.animate({
            id: `${groupId}_${subId}_${path.id}_${phase}`,
            groupId: groupId,
            from: 0,
            to: 1,
            ease: $d77b025aa58d633c$var$easeOut,
            collapsable: false,
            onUpdate (ratio11, preInit) {
                if (preInit && phase !== "removed") return;
                path.path.clear(true);
                updateFn(ratio11, path);
                path.checkPathDirty();
            },
            onStop () {
                if (phase !== "added") return;
                path.path.clear(true);
                updateFn(1, path);
                path.checkPathDirty();
            },
            phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[phase]
        });
    };
    for (const path of paths){
        if (!animationManager.isSkipped()) {
            animate("removed", path, removePhaseFn);
            animate("updated", path, updatePhaseFn);
        }
        animate("added", path, addPhaseFn);
    }
}
// packages/ag-charts-community/src/chart/series/seriesLabelUtil.ts
function $d77b025aa58d633c$var$seriesLabelFadeInAnimation({ id: id }, subId, animationManager, ...labelSelections) {
    for (const labelSelection of labelSelections)labelSelection.cleanup();
    $d77b025aa58d633c$var$staticFromToMotion(id, subId, animationManager, labelSelections, {
        opacity: 0
    }, {
        opacity: 1
    }, {
        phase: "trailing"
    });
}
function $d77b025aa58d633c$var$seriesLabelFadeOutAnimation({ id: id }, subId, animationManager, ...labelSelections) {
    $d77b025aa58d633c$var$staticFromToMotion(id, subId, animationManager, labelSelections, {
        opacity: 1
    }, {
        opacity: 0
    }, {
        phase: "remove"
    });
}
function $d77b025aa58d633c$var$resetLabelFn(_node) {
    return {
        opacity: 1
    };
}
// packages/ag-charts-community/src/scene/util/changeDetectableProperties.ts
var $d77b025aa58d633c$var$ChangeDetectableProperties = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this._dirty = true;
    }
    markDirty() {
        this._dirty = true;
    }
    markClean(_opts) {
        this._dirty = false;
    }
    isDirty() {
        return this._dirty;
    }
    onChangeDetection(_property) {
        this.markDirty();
    }
};
// packages/ag-charts-community/src/scene/dropShadow.ts
var $d77b025aa58d633c$var$DropShadow = class extends $d77b025aa58d633c$var$ChangeDetectableProperties {
    constructor(){
        super(...arguments);
        this.enabled = true;
        this.color = "rgba(0, 0, 0, 0.5)";
        this.xOffset = 0;
        this.yOffset = 0;
        this.blur = 5;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$DropShadow.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$DropShadow.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$DropShadow.prototype, "xOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$DropShadow.prototype, "yOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$DropShadow.prototype, "blur", 2);
// packages/ag-charts-community/src/chart/series/seriesProperties.ts
var $d77b025aa58d633c$var$SeriesItemHighlightStyle = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.fill = "rgba(255,255,255, 0.33)";
        this.stroke = `rgba(0, 0, 0, 0.4)`;
        this.strokeWidth = 2;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesItemHighlightStyle.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesItemHighlightStyle.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesItemHighlightStyle.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesItemHighlightStyle.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesItemHighlightStyle.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesItemHighlightStyle.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesItemHighlightStyle.prototype, "lineDashOffset", 2);
var $d77b025aa58d633c$var$SeriesHighlightStyle = class extends $d77b025aa58d633c$var$BaseProperties {
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesHighlightStyle.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesHighlightStyle.prototype, "dimOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesHighlightStyle.prototype, "enabled", 2);
var $d77b025aa58d633c$var$TextHighlightStyle = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.color = "black";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$TextHighlightStyle.prototype, "color", 2);
var $d77b025aa58d633c$var$HighlightProperties = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.enabled = true;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HighlightProperties.prototype, "enabled", 2);
var $d77b025aa58d633c$var$FillGradientDefaults = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.type = "gradient";
        this.colorStops = [];
        this.bounds = "item";
        this.gradient = "linear";
        this.rotation = 0;
        this.reverse = false;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillGradientDefaults.prototype, "type", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillGradientDefaults.prototype, "colorStops", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillGradientDefaults.prototype, "bounds", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillGradientDefaults.prototype, "gradient", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillGradientDefaults.prototype, "rotation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillGradientDefaults.prototype, "reverse", 2);
var $d77b025aa58d633c$var$FillPatternDefaults = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.type = "pattern";
        this.colorStops = [];
        this.bounds = "item";
        this.gradient = "linear";
        this.rotation = 0;
        this.scale = 1;
        this.reverse = false;
        this.pattern = "forward-slanted-lines";
        this.width = 26;
        this.height = 26;
        this.padding = 6;
        this.fill = "black";
        this.fillOpacity = 1;
        this.backgroundFill = "white";
        this.backgroundFillOpacity = 1;
        this.stroke = "black";
        this.strokeOpacity = 1;
        this.strokeWidth = 0;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "type", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "colorStops", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "bounds", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "gradient", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "rotation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "scale", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "reverse", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "path", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "pattern", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "width", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "height", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "padding", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "backgroundFill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "backgroundFillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillPatternDefaults.prototype, "strokeWidth", 2);
var $d77b025aa58d633c$var$FillImageDefaults = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.type = "image";
        this.url = "";
        this.rotation = 0;
        this.scale = 1;
        this.backgroundFill = "black";
        this.backgroundFillOpacity = 1;
        this.repeat = "no-repeat";
        this.fit = "contain";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillImageDefaults.prototype, "type", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillImageDefaults.prototype, "url", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillImageDefaults.prototype, "rotation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillImageDefaults.prototype, "scale", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillImageDefaults.prototype, "backgroundFill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillImageDefaults.prototype, "backgroundFillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillImageDefaults.prototype, "repeat", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$FillImageDefaults.prototype, "fit", 2);
var $d77b025aa58d633c$var$HighlightStyle = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.item = new $d77b025aa58d633c$var$SeriesItemHighlightStyle();
        this.series = new $d77b025aa58d633c$var$SeriesHighlightStyle();
        this.text = new $d77b025aa58d633c$var$TextHighlightStyle();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HighlightStyle.prototype, "item", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HighlightStyle.prototype, "series", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HighlightStyle.prototype, "text", 2);
var $d77b025aa58d633c$var$SeriesProperties = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.visible = true;
        this.focusPriority = Infinity;
        this.showInLegend = true;
        this.cursor = "default";
        this.nodeClickRange = "exact";
        this.highlight = new $d77b025aa58d633c$var$HighlightProperties();
        this.highlightStyle = new $d77b025aa58d633c$var$HighlightStyle();
    }
    handleUnknownProperties(unknownKeys, properties) {
        if ("context" in properties) {
            this.context = properties.context;
            unknownKeys.delete("context");
        }
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesProperties.prototype, "id", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesProperties.prototype, "visible", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesProperties.prototype, "focusPriority", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesProperties.prototype, "showInLegend", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesProperties.prototype, "cursor", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesProperties.prototype, "nodeClickRange", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesProperties.prototype, "highlight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesProperties.prototype, "highlightStyle", 2);
// packages/ag-charts-community/src/chart/series/seriesMarker.ts
var $d77b025aa58d633c$var$SeriesMarker = class extends $d77b025aa58d633c$var$ChangeDetectableProperties {
    constructor(){
        super(...arguments);
        this.enabled = true;
        this.shape = "circle";
        this.size = 6;
        this.fillGradientDefaults = new $d77b025aa58d633c$var$FillGradientDefaults();
        this.fillPatternDefaults = new $d77b025aa58d633c$var$FillPatternDefaults();
        this.fillImageDefaults = new $d77b025aa58d633c$var$FillImageDefaults();
        this.fillOpacity = 1;
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
    }
    getStyle() {
        const { size: size, shape: shape, fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = this;
        return {
            size: size,
            shape: shape,
            fill: fill,
            fillOpacity: fillOpacity,
            stroke: stroke2,
            strokeWidth: strokeWidth,
            strokeOpacity: strokeOpacity,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset
        };
    }
    getDiameter() {
        return this.size + this.strokeWidth;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$SeriesMarker.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$SceneObjectChangeDetection({
        equals: $d77b025aa58d633c$var$TRIPLE_EQ
    })
], $d77b025aa58d633c$var$SeriesMarker.prototype, "shape", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$SeriesMarker.prototype, "size", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$SceneObjectChangeDetection({
        equals: $d77b025aa58d633c$var$objectsEqual
    })
], $d77b025aa58d633c$var$SeriesMarker.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesMarker.prototype, "fillGradientDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesMarker.prototype, "fillPatternDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesMarker.prototype, "fillImageDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$SeriesMarker.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$SeriesMarker.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$SeriesMarker.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$SeriesMarker.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesMarker.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesMarker.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$SceneObjectChangeDetection({
        equals: $d77b025aa58d633c$var$TRIPLE_EQ
    })
], $d77b025aa58d633c$var$SeriesMarker.prototype, "itemStyler", 2);
// packages/ag-charts-community/src/chart/series/seriesTooltip.ts
var $d77b025aa58d633c$var$SeriesTooltipInteraction = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.enabled = false;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesTooltipInteraction.prototype, "enabled", 2);
var $d77b025aa58d633c$var$SeriesTooltip = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.interaction = new $d77b025aa58d633c$var$SeriesTooltipInteraction();
        this.position = new $d77b025aa58d633c$var$TooltipPosition();
        this.range = void 0;
        this.class = void 0;
    }
    formatTooltip(caller1, caller2, content, params) {
        const overrides = this.renderer == null ? void 0 : $d77b025aa58d633c$var$callWithContext(caller1, caller2, this.renderer, [
            params
        ]);
        if (typeof overrides === "string") return {
            type: "raw",
            rawHtmlString: overrides
        };
        if (overrides != null) return {
            type: "structured",
            ...content,
            ...overrides
        };
        return {
            type: "structured",
            ...content
        };
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesTooltip.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesTooltip.prototype, "showArrow", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesTooltip.prototype, "renderer", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesTooltip.prototype, "interaction", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesTooltip.prototype, "position", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesTooltip.prototype, "range", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$SeriesTooltip.prototype, "class", 2);
// packages/ag-charts-community/src/scene/util/quadtree.ts
var $d77b025aa58d633c$var$QuadtreeNearest = class {
    constructor(capacity, maxdepth, boundary){
        this.root = new $d77b025aa58d633c$var$QuadtreeNodeNearest(capacity, maxdepth, boundary);
    }
    clear(boundary) {
        this.root.clear(boundary);
    }
    addValue(hitTester, value) {
        const elem = {
            hitTester: hitTester,
            value: value,
            distanceSquared: (x, y)=>{
                return hitTester.distanceSquared(x, y);
            }
        };
        this.root.addElem(elem);
    }
    find(x, y) {
        const arg = {
            best: {
                nearest: void 0,
                distanceSquared: Infinity
            }
        };
        this.root.find(x, y, arg);
        return arg.best;
    }
};
var $d77b025aa58d633c$var$QuadtreeSubdivisions = class {
    constructor(nw, ne, sw, se){
        this.nw = nw;
        this.ne = ne;
        this.sw = sw;
        this.se = se;
    }
    addElem(elem) {
        this.nw.addElem(elem);
        this.ne.addElem(elem);
        this.sw.addElem(elem);
        this.se.addElem(elem);
    }
    find(x, y, arg) {
        this.nw.find(x, y, arg);
        this.ne.find(x, y, arg);
        this.sw.find(x, y, arg);
        this.se.find(x, y, arg);
    }
};
var $d77b025aa58d633c$var$QuadtreeNode = class {
    constructor(capacity, maxdepth, boundary){
        this.capacity = capacity;
        this.maxdepth = maxdepth;
        this.boundary = boundary ?? $d77b025aa58d633c$var$BBox.NaN;
        this.elems = [];
        this.subdivisions = void 0;
    }
    clear(boundary) {
        this.elems.length = 0;
        this.boundary = boundary;
        this.subdivisions = void 0;
    }
    addElem(e) {
        if (this.addCondition(e)) {
            if (this.subdivisions === void 0) {
                if (this.maxdepth === 0 || this.elems.length < this.capacity) this.elems.push(e);
                else this.subdivide(e);
            } else this.subdivisions.addElem(e);
        }
    }
    find(x, y, arg) {
        if (this.findCondition(x, y, arg)) {
            if (this.subdivisions === void 0) this.findAction(x, y, arg);
            else this.subdivisions.find(x, y, arg);
        }
    }
    subdivide(newElem) {
        this.subdivisions = this.makeSubdivisions();
        for (const e of this.elems)this.subdivisions.addElem(e);
        this.subdivisions.addElem(newElem);
        this.elems.length = 0;
    }
    makeSubdivisions() {
        const { x: x, y: y, width: width2, height: height2 } = this.boundary;
        const { capacity: capacity } = this;
        const depth = this.maxdepth - 1;
        const halfWidth = width2 / 2;
        const halfHeight = height2 / 2;
        const nwBoundary = new $d77b025aa58d633c$var$BBox(x, y, halfWidth, halfHeight);
        const neBoundary = new $d77b025aa58d633c$var$BBox(x + halfWidth, y, halfWidth, halfHeight);
        const swBoundary = new $d77b025aa58d633c$var$BBox(x, y + halfHeight, halfWidth, halfHeight);
        const seBoundary = new $d77b025aa58d633c$var$BBox(x + halfWidth, y + halfHeight, halfWidth, halfHeight);
        return new $d77b025aa58d633c$var$QuadtreeSubdivisions(this.child(capacity, depth, nwBoundary), this.child(capacity, depth, neBoundary), this.child(capacity, depth, swBoundary), this.child(capacity, depth, seBoundary));
    }
};
var $d77b025aa58d633c$var$QuadtreeNodeNearest = class _QuadtreeNodeNearest extends $d77b025aa58d633c$var$QuadtreeNode {
    addCondition(e) {
        const { x: x, y: y } = e.hitTester.midPoint;
        return this.boundary.containsPoint(x, y);
    }
    findCondition(x, y, arg) {
        const { best: best } = arg;
        return best.distanceSquared !== 0 && this.boundary.distanceSquared(x, y) < best.distanceSquared;
    }
    findAction(x, y, arg) {
        const other = $d77b025aa58d633c$var$nearestSquared(x, y, this.elems, arg.best.distanceSquared);
        if (other.nearest !== void 0 && other.distanceSquared < arg.best.distanceSquared) arg.best = other;
    }
    child(capacity, depth, boundary) {
        return new _QuadtreeNodeNearest(capacity, depth, boundary);
    }
};
var $d77b025aa58d633c$var$DataModelSeries = class extends $d77b025aa58d633c$var$Series {
    constructor({ clipFocusBox: clipFocusBox, categoryKey: categoryKey, ...seriesOpts }){
        super(seriesOpts);
        this.categoryKey = categoryKey;
        this.clipFocusBox = clipFocusBox ?? true;
    }
    getScaleInformation({ xScale: xScale, yScale: yScale }) {
        const isContinuousX = $d77b025aa58d633c$var$ContinuousScale.is(xScale);
        const isContinuousY = $d77b025aa58d633c$var$ContinuousScale.is(yScale);
        return {
            isContinuousX: isContinuousX,
            isContinuousY: isContinuousY,
            xScaleType: xScale?.type,
            yScaleType: yScale?.type
        };
    }
    getModulePropertyDefinitions() {
        const xScale = this.axes["x" /* X */ ]?.scale;
        const yScale = this.axes["y" /* Y */ ]?.scale;
        return this.moduleMap.mapModules((mod)=>mod.getPropertyDefinitions(this.getScaleInformation({
                xScale: xScale,
                yScale: yScale
            }))).flat();
    }
    // Request data, but with message dispatching to series-options (modules).
    async requestDataModel(dataController, data, opts) {
        opts.props.push(...this.getModulePropertyDefinitions());
        const { dataModel: dataModel, processedData: processedData } = await dataController.request(this.id, data ?? [], opts);
        this.dataModel = dataModel;
        this.processedData = processedData;
        this.dispatch("data-processed", {
            dataModel: dataModel,
            processedData: processedData
        });
        return {
            dataModel: dataModel,
            processedData: processedData
        };
    }
    isProcessedDataAnimatable() {
        const validationResults = this.processedData?.reduced?.animationValidation;
        if (!validationResults) return true;
        const { orderedKeys: orderedKeys, uniqueKeys: uniqueKeys } = validationResults;
        return orderedKeys && uniqueKeys;
    }
    checkProcessedDataAnimatable() {
        if (!this.isProcessedDataAnimatable()) this.ctx.animationManager.skipCurrentBatch();
    }
    pickFocus(opts) {
        const nodeData = this.getNodeData();
        if (nodeData === void 0 || nodeData.length === 0) return;
        const datumIndex = this.computeFocusDatumIndex(opts, nodeData);
        if (datumIndex === void 0) return;
        const { clipFocusBox: clipFocusBox } = this;
        const datum = nodeData[datumIndex];
        const derivedOpts = {
            ...opts,
            datumIndex: datumIndex
        };
        const bounds = this.computeFocusBounds(derivedOpts);
        if (bounds !== void 0) return {
            bounds: bounds,
            clipFocusBox: clipFocusBox,
            datum: datum,
            datumIndex: datumIndex
        };
    }
    isDatumEnabled(nodeData, datumIndex) {
        const { missing: missing = false, enabled: enabled = true, focusable: focusable = true } = nodeData[datumIndex];
        return !missing && enabled && focusable;
    }
    computeFocusDatumIndex(opts, nodeData) {
        const searchBackward = (datumIndex2, delta3)=>{
            while(datumIndex2 >= 0 && !this.isDatumEnabled(nodeData, datumIndex2))datumIndex2 += delta3;
            return datumIndex2 === -1 ? void 0 : datumIndex2;
        };
        const searchForward = (datumIndex2, delta3)=>{
            while(datumIndex2 < nodeData.length && !this.isDatumEnabled(nodeData, datumIndex2))datumIndex2 += delta3;
            return datumIndex2 === nodeData.length ? void 0 : datumIndex2;
        };
        let datumIndex;
        const clampedIndex = (0, $idDdm.clamp)(0, opts.datumIndex, nodeData.length - 1);
        if (opts.datumIndexDelta < 0) datumIndex = searchBackward(clampedIndex, opts.datumIndexDelta);
        else if (opts.datumIndexDelta > 0) datumIndex = searchForward(clampedIndex, opts.datumIndexDelta);
        else datumIndex = searchForward(clampedIndex, 1) ?? searchBackward(clampedIndex, -1);
        if (datumIndex === void 0) {
            if (opts.datumIndexDelta === 0) return;
            else return opts.datumIndex - opts.datumIndexDelta;
        } else return datumIndex;
    }
    // Workaround - it would be nice if this difference didn't exist
    keysOrValues(xKey) {
        const key = this.dataModel.resolveProcessedDataIndexById(this, xKey);
        return this.processedData?.keys[key]?.get(this.id) ?? this.processedData?.columns[key] ?? [];
    }
    getCategoryKey() {
        return this.categoryKey;
    }
    getCategoryValue(datumIndex) {
        const { processedData: processedData, dataModel: dataModel } = this;
        const categoryKey = this.getCategoryKey();
        if (!processedData || !dataModel || !categoryKey) return;
        const invalid = processedData.invalidData?.get(this.id)?.[datumIndex] ?? false;
        return invalid ? void 0 : this.keysOrValues(categoryKey)[datumIndex];
    }
    datumIndexForCategoryValue(categoryValue) {
        const { processedData: processedData, dataModel: dataModel } = this;
        const categoryKey = this.getCategoryKey();
        if (!processedData || !dataModel || !categoryKey) return;
        categoryValue = categoryValue.valueOf();
        const invalidValues = processedData.invalidData?.get(this.id);
        const xValues = this.keysOrValues(categoryKey);
        for(let datumIndex = 0; datumIndex < xValues.length; datumIndex += 1){
            if (invalidValues?.[datumIndex] === true) continue;
            const xValue = xValues[datumIndex]?.valueOf();
            if ($d77b025aa58d633c$var$objectsEqual(categoryValue, xValue)) return datumIndex;
        }
    }
};
// packages/ag-charts-community/src/chart/series/cartesian/cartesianSeries.ts
var $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_KEYS = {
    ["x" /* X */ ]: [
        "xKey"
    ],
    ["y" /* Y */ ]: [
        "yKey"
    ]
};
var $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_NAMES = {
    ["x" /* X */ ]: [
        "xName"
    ],
    ["y" /* Y */ ]: [
        "yName"
    ]
};
var $d77b025aa58d633c$var$CartesianSeriesNodeEvent = class extends $d77b025aa58d633c$var$SeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.xKey = series.properties.xKey;
        this.yKey = series.properties.yKey;
    }
};
var $d77b025aa58d633c$var$CartesianSeriesProperties = class extends $d77b025aa58d633c$var$SeriesProperties {
    constructor(){
        super(...arguments);
        this.pickOutsideVisibleMinorAxis = false;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianSeriesProperties.prototype, "legendItemName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$CartesianSeriesProperties.prototype, "pickOutsideVisibleMinorAxis", 2);
var $d77b025aa58d633c$var$RENDER_TO_OFFSCREEN_CANVAS_THRESHOLD = 100;
var $d77b025aa58d633c$var$CartesianSeries = class extends $d77b025aa58d633c$var$DataModelSeries {
    constructor({ pathsPerSeries: pathsPerSeries = [
        "path"
    ], hasMarkers: hasMarkers = false, hasHighlightedLabels: hasHighlightedLabels = false, pathsZIndexSubOrderOffset: pathsZIndexSubOrderOffset = [], datumSelectionGarbageCollection: datumSelectionGarbageCollection = true, markerSelectionGarbageCollection: markerSelectionGarbageCollection = true, animationAlwaysUpdateSelections: animationAlwaysUpdateSelections = false, animationResetFns: animationResetFns, directionKeys: directionKeys, directionNames: directionNames, ...otherOpts }){
        super({
            directionKeys: directionKeys,
            directionNames: directionNames,
            canHaveAxes: true,
            ...otherOpts
        });
        this.NodeEvent = $d77b025aa58d633c$var$CartesianSeriesNodeEvent;
        this.dataNodeGroup = this.contentGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-series-dataNodes`,
            zIndex: 0
        }));
        this.markerGroup = this.contentGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-series-markers`,
            zIndex: 1
        }));
        this.labelGroup = this.contentGroup.appendChild(new $d77b025aa58d633c$var$TranslatableGroup({
            name: `${this.id}-series-labels`
        }));
        this.labelSelection = $d77b025aa58d633c$var$Selection.select(this.labelGroup, $d77b025aa58d633c$var$Text);
        this.highlightSelection = $d77b025aa58d633c$var$Selection.select(this.highlightNode, ()=>this.opts.hasMarkers ? new $d77b025aa58d633c$var$Marker() : this.nodeFactory());
        this.highlightLabelSelection = $d77b025aa58d633c$var$Selection.select(this.highlightLabel, $d77b025aa58d633c$var$Text);
        this.annotationSelections = /* @__PURE__ */ new Set();
        this.debug = $d77b025aa58d633c$var$Debug.create();
        if (!directionKeys || !directionNames) throw new Error(`Unable to initialise series type ${this.type}`);
        this.opts = {
            pathsPerSeries: pathsPerSeries,
            hasMarkers: hasMarkers,
            hasHighlightedLabels: hasHighlightedLabels,
            pathsZIndexSubOrderOffset: pathsZIndexSubOrderOffset,
            directionKeys: directionKeys,
            directionNames: directionNames,
            animationResetFns: animationResetFns,
            animationAlwaysUpdateSelections: animationAlwaysUpdateSelections,
            datumSelectionGarbageCollection: datumSelectionGarbageCollection,
            markerSelectionGarbageCollection: markerSelectionGarbageCollection
        };
        this.paths = pathsPerSeries.map((path)=>{
            return new $d77b025aa58d633c$var$Path({
                name: `${this.id}-${path}`
            });
        });
        this.datumSelection = $d77b025aa58d633c$var$Selection.select(this.dataNodeGroup, ()=>this.nodeFactory(), datumSelectionGarbageCollection);
        this.markerSelection = $d77b025aa58d633c$var$Selection.select(this.markerGroup, $d77b025aa58d633c$var$Marker, markerSelectionGarbageCollection);
        this.animationState = new $d77b025aa58d633c$var$StateMachine("empty", {
            empty: {
                update: {
                    target: "ready",
                    action: (data)=>this.animateEmptyUpdateReady(data)
                },
                reset: "empty",
                skip: "ready",
                disable: "disabled"
            },
            ready: {
                updateData: "waiting",
                clear: "clearing",
                highlight: (data)=>this.animateReadyHighlight(data),
                highlightMarkers: (data)=>this.animateReadyHighlightMarkers(data),
                resize: (data)=>this.animateReadyResize(data),
                reset: "empty",
                skip: "ready",
                disable: "disabled"
            },
            waiting: {
                update: {
                    target: "ready",
                    action: (data)=>{
                        if (this.ctx.animationManager.isSkipped()) this.resetAllAnimation(data);
                        else this.animateWaitingUpdateReady(data);
                    }
                },
                reset: "empty",
                skip: "ready",
                disable: "disabled"
            },
            disabled: {
                update: (data)=>this.resetAllAnimation(data),
                reset: "empty"
            },
            clearing: {
                update: {
                    target: "empty",
                    action: (data)=>this.animateClearingUpdateEmpty(data)
                },
                reset: "empty",
                skip: "ready"
            }
        }, ()=>this.checkProcessedDataAnimatable());
    }
    get contextNodeData() {
        return this._contextNodeData;
    }
    getNodeData() {
        return this.contextNodeData?.nodeData;
    }
    attachSeries(seriesContentNode, seriesNode, annotationNode) {
        super.attachSeries(seriesContentNode, seriesNode, annotationNode);
        this.attachPaths(this.paths, seriesNode, annotationNode);
    }
    detachSeries(seriesContentNode, seriesNode, annotationNode) {
        super.detachSeries(seriesContentNode, seriesNode, annotationNode);
        this.detachPaths(this.paths, seriesNode, annotationNode);
    }
    updatedDomains() {
        this.animationState.transition("updateData");
    }
    attachPaths(paths, _seriesNode, _annotationNode) {
        for (const path of paths)this.contentGroup.appendChild(path);
    }
    detachPaths(paths, _seriesNode, _annotationNode) {
        for (const path of paths)this.contentGroup.removeChild(path);
    }
    renderToOffscreenCanvas() {
        const nodeData = this.getNodeData();
        return nodeData != null && nodeData.length > $d77b025aa58d633c$var$RENDER_TO_OFFSCREEN_CANVAS_THRESHOLD;
    }
    resetAnimation(phase) {
        if (phase === "initial") this.animationState.transition("reset");
        else if (phase === "ready") this.animationState.transition("skip");
        else if (phase === "disabled") this.animationState.transition("disable");
    }
    addChartEventListeners() {
        this.destroyFns.push(this.ctx.chartEventManager.addListener("legend-item-click", (event)=>this.onLegendItemClick(event)), this.ctx.chartEventManager.addListener("legend-item-double-click", (event)=>this.onLegendItemDoubleClick(event)));
    }
    destroy() {
        super.destroy();
        this._contextNodeData = void 0;
    }
    update({ seriesRect: seriesRect }) {
        const { visible: visible, _contextNodeData: previousContextData } = this;
        const series = this.ctx.highlightManager?.getActiveHighlight()?.series;
        const seriesHighlighted = series === this;
        const resize = this.checkResize(seriesRect);
        const highlightItems = this.updateHighlightSelection(seriesHighlighted);
        this.updateSelections(visible);
        this.updateNodes(highlightItems, seriesHighlighted, visible);
        const animationData = this.getAnimationData(seriesRect, previousContextData);
        if (!animationData) return;
        if (resize) this.animationState.transition("resize", animationData);
        this.animationState.transition("update", animationData);
    }
    updateSelections(anySeriesItemEnabled) {
        var _a;
        const animationSkipUpdate = !this.opts.animationAlwaysUpdateSelections && this.ctx.animationManager.isSkipped();
        if (!anySeriesItemEnabled && animationSkipUpdate) return;
        if (!this.nodeDataRefresh && !this.isPathOrSelectionDirty()) return;
        if (this.nodeDataRefresh) {
            this.nodeDataRefresh = false;
            this.debug(`CartesianSeries.updateSelections() - calling createNodeData() for`, this.id);
            this.markQuadtreeDirty();
            this._contextNodeData = this.createNodeData();
            const animationValid = this.isProcessedDataAnimatable();
            if (this._contextNodeData) (_a = this._contextNodeData).animationValid ?? (_a.animationValid = animationValid);
            const { dataModel: dataModel, processedData: processedData } = this;
            if (dataModel !== void 0 && processedData !== void 0) this.dispatch("data-update", {
                dataModel: dataModel,
                processedData: processedData
            });
        }
        this.updateSeriesSelections();
    }
    updateSeriesSelections(seriesHighlighted) {
        const { datumSelection: datumSelection, labelSelection: labelSelection, markerSelection: markerSelection, paths: paths } = this;
        const contextData = this._contextNodeData;
        if (!contextData) return;
        const { nodeData: nodeData, labelData: labelData, itemId: itemId } = contextData;
        this.updatePaths({
            seriesHighlighted: seriesHighlighted,
            itemId: itemId,
            contextData: contextData,
            paths: paths
        });
        this.datumSelection = this.updateDatumSelection({
            nodeData: nodeData,
            datumSelection: datumSelection
        });
        this.labelSelection = this.updateLabelSelection({
            labelData: labelData,
            labelSelection: labelSelection
        }) ?? labelSelection;
        if (this.opts.hasMarkers) this.markerSelection = this.updateMarkerSelection({
            nodeData: nodeData,
            markerSelection: markerSelection
        });
    }
    getShapeFillBBox() {
        const { axes: axes } = this;
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        const [axisX1, axisX2] = $d77b025aa58d633c$var$findMinMax(xAxis?.range ?? [
            0,
            1
        ]);
        const [axisY1, axisY2] = $d77b025aa58d633c$var$findMinMax(yAxis?.range ?? [
            0,
            1
        ]);
        const xSeriesDomain = this.getSeriesDomain("x" /* X */ );
        const xSeriesRange = [
            xAxis?.scale.convert(xSeriesDomain.at(0)),
            xAxis?.scale.convert(xSeriesDomain.at(-1))
        ];
        const ySeriesDomain = this.getSeriesDomain("y" /* Y */ );
        const ySeriesRange = [
            yAxis?.scale.convert(ySeriesDomain.at(0)),
            yAxis?.scale.convert(ySeriesDomain.at(-1))
        ];
        const [seriesX1, seriesX2] = $d77b025aa58d633c$var$findMinMax(xSeriesRange);
        const [seriesY1, seriesY2] = $d77b025aa58d633c$var$findMinMax(ySeriesRange);
        return {
            axis: new $d77b025aa58d633c$var$BBox(axisX1, axisY1, axisX2 - axisX1, axisY2 - axisY1),
            series: new $d77b025aa58d633c$var$BBox(seriesX1, seriesY1, seriesX2 - seriesX1, seriesY2 - seriesY1)
        };
    }
    updateNodes(highlightedItems, seriesHighlighted, anySeriesItemEnabled) {
        const { highlightSelection: highlightSelection, highlightLabelSelection: highlightLabelSelection, opts: { hasMarkers: hasMarkers, hasHighlightedLabels: hasHighlightedLabels } } = this;
        const animationEnabled = !this.ctx.animationManager.isSkipped();
        const visible = this.visible && this._contextNodeData != null && anySeriesItemEnabled;
        this.contentGroup.visible = animationEnabled || visible;
        this.highlightGroup.visible = (animationEnabled || visible) && seriesHighlighted;
        const opacity = this.getOpacity();
        if (hasMarkers) {
            this.updateMarkerNodes({
                markerSelection: highlightSelection,
                isHighlight: true
            });
            this.animationState.transition("highlightMarkers", highlightSelection);
        } else {
            this.updateDatumNodes({
                datumSelection: highlightSelection,
                isHighlight: true
            });
            this.animationState.transition("highlight", highlightSelection);
        }
        if (hasHighlightedLabels) this.updateLabelNodes({
            labelSelection: highlightLabelSelection
        });
        const { dataNodeGroup: dataNodeGroup, markerGroup: markerGroup, datumSelection: datumSelection, labelSelection: labelSelection, markerSelection: markerSelection, paths: paths, labelGroup: labelGroup } = this;
        const { itemId: itemId } = this.contextNodeData ?? {};
        dataNodeGroup.opacity = opacity;
        dataNodeGroup.visible = animationEnabled || visible;
        labelGroup.visible = visible;
        if (hasMarkers) {
            markerGroup.opacity = opacity;
            markerGroup.visible = visible;
        }
        if (labelGroup) labelGroup.opacity = opacity;
        this.updatePathNodes({
            seriesHighlighted: seriesHighlighted,
            itemId: itemId,
            paths: paths,
            opacity: opacity,
            visible: visible,
            animationEnabled: animationEnabled
        });
        if (!dataNodeGroup.visible) return;
        this.updateDatumNodes({
            datumSelection: datumSelection,
            highlightedItems: highlightedItems,
            isHighlight: false
        });
        if (!this.usesPlacedLabels) this.updateLabelNodes({
            labelSelection: labelSelection
        });
        if (hasMarkers) this.updateMarkerNodes({
            markerSelection: markerSelection,
            isHighlight: false
        });
    }
    getHighlightLabelData(labelData, highlightedItem) {
        const labelItems = labelData.filter((ld)=>ld.datum === highlightedItem.datum && ld.itemId === highlightedItem.itemId);
        return labelItems.length === 0 ? void 0 : labelItems;
    }
    getHighlightData(_nodeData, highlightedItem) {
        return highlightedItem ? [
            highlightedItem
        ] : void 0;
    }
    updateHighlightSelection(seriesHighlighted) {
        const { highlightSelection: highlightSelection, highlightLabelSelection: highlightLabelSelection, _contextNodeData: contextNodeData } = this;
        if (!contextNodeData) return;
        const highlightedDatum = this.ctx.highlightManager?.getActiveHighlight();
        const item = seriesHighlighted && highlightedDatum?.datum ? highlightedDatum : void 0;
        let labelItems;
        let highlightItems;
        if (item != null) {
            const labelsEnabled = this.isLabelEnabled();
            const { labelData: labelData, nodeData: nodeData } = contextNodeData;
            highlightItems = this.getHighlightData(nodeData, item);
            labelItems = labelsEnabled ? this.getHighlightLabelData(labelData, item) : void 0;
        }
        this.highlightSelection = this.updateHighlightSelectionItem({
            items: highlightItems,
            highlightSelection: highlightSelection
        });
        this.highlightLabelSelection = this.updateHighlightSelectionLabel({
            items: labelItems,
            highlightLabelSelection: highlightLabelSelection
        });
        return highlightItems;
    }
    markQuadtreeDirty() {
        this.quadtree = void 0;
    }
    *datumNodesIter() {
        for (const { node: node } of this.datumSelection){
            if (node.datum.missing === true) continue;
            yield node;
        }
    }
    getQuadTree() {
        if (this.quadtree === void 0) {
            const { width: width2, height: height2 } = this.ctx.scene.canvas;
            const canvasRect = new $d77b025aa58d633c$var$BBox(0, 0, width2, height2);
            this.quadtree = new $d77b025aa58d633c$var$QuadtreeNearest(100, 10, canvasRect);
            this.initQuadTree(this.quadtree);
        }
        return this.quadtree;
    }
    initQuadTree(_quadtree) {}
    pickNodesExactShape(point) {
        const result = super.pickNodesExactShape(point);
        if (result.length !== 0) return result;
        const { x: x, y: y } = point;
        const { opts: { hasMarkers: hasMarkers } } = this;
        const { dataNodeGroup: dataNodeGroup, markerGroup: markerGroup } = this;
        let matches = dataNodeGroup.pickNodes(x, y).filter((match)=>match.datum.missing !== true);
        if (matches.length === 0 && hasMarkers) matches = markerGroup?.pickNodes(x, y).filter((match)=>match.datum.missing !== true);
        if (matches.length !== 0) {
            const datums = matches.map((match)=>match.datum);
            return datums;
        }
        for (const mod of this.moduleMap.modules()){
            const { datum: datum } = mod.pickNodeExact(point) ?? {};
            if (datum == null) continue;
            if (datum?.missing === true) continue;
            return [
                datum
            ];
        }
        return [];
    }
    pickNodeClosestDatum(point) {
        const { x: x, y: y } = point;
        const { axes: axes, _contextNodeData: contextNodeData } = this;
        if (!contextNodeData) return;
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        const hitPoint = {
            x: x,
            y: y
        };
        let minDistance = Infinity;
        let closestDatum;
        for (const datum of contextNodeData.nodeData){
            const { point: { x: datumX = NaN, y: datumY = NaN } = {} } = datum;
            if (isNaN(datumX) || isNaN(datumY)) continue;
            const isInRange = xAxis?.inRange(datumX) && yAxis?.inRange(datumY);
            if (!isInRange) continue;
            const distance2 = Math.max((hitPoint.x - datumX) ** 2 + (hitPoint.y - datumY) ** 2, 0);
            if (distance2 < minDistance) {
                minDistance = distance2;
                closestDatum = datum;
            }
        }
        for (const mod of this.moduleMap.modules()){
            const modPick = mod.pickNodeNearest(point);
            if (modPick !== void 0 && modPick.distanceSquared < minDistance) {
                minDistance = modPick.distanceSquared;
                closestDatum = modPick.datum;
                break;
            }
        }
        if (closestDatum) {
            const distance2 = Math.max(Math.sqrt(minDistance) - (closestDatum.point?.size ?? 0) / 2, 0);
            return {
                datum: closestDatum,
                distance: distance2
            };
        }
    }
    pickNodeMainAxisFirst(point, requireCategoryAxis) {
        const { x: x, y: y } = point;
        const { axes: axes, _contextNodeData: contextNodeData } = this;
        const { pickOutsideVisibleMinorAxis: pickOutsideVisibleMinorAxis } = this.properties;
        if (!contextNodeData) return;
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        const directions2 = [
            xAxis,
            yAxis
        ].filter($d77b025aa58d633c$var$CategoryAxis.is).map((a)=>a.direction);
        if (requireCategoryAxis && directions2.length === 0) return;
        const [majorDirection = "x" /* X */ ] = directions2;
        const hitPointCoords = [
            x,
            y
        ];
        if (majorDirection !== "x" /* X */ ) hitPointCoords.reverse();
        const minDistance = [
            Infinity,
            Infinity
        ];
        let closestDatum;
        for (const datum of contextNodeData.nodeData){
            const { x: datumX = NaN, y: datumY = NaN } = datum.point ?? datum.midPoint ?? {};
            if (isNaN(datumX) || isNaN(datumY) || datum.missing === true) continue;
            const visible = [
                xAxis?.inRange(datumX),
                yAxis?.inRange(datumY)
            ];
            if (majorDirection !== "x" /* X */ ) visible.reverse();
            if (!visible[0] || !pickOutsideVisibleMinorAxis && !visible[1]) continue;
            const datumPoint = [
                datumX,
                datumY
            ];
            if (majorDirection !== "x" /* X */ ) datumPoint.reverse();
            let newMinDistance = true;
            for(let i = 0; i < datumPoint.length; i++){
                const dist = Math.abs(datumPoint[i] - hitPointCoords[i]);
                if (dist > minDistance[i]) {
                    newMinDistance = false;
                    break;
                } else if (dist < minDistance[i]) {
                    minDistance[i] = dist;
                    minDistance.fill(Infinity, i + 1, minDistance.length);
                }
            }
            if (newMinDistance) closestDatum = datum;
        }
        if (closestDatum) {
            let closestDistanceSquared = Math.max(minDistance[0] ** 2 + minDistance[1] ** 2 - (closestDatum.point?.size ?? 0), 0);
            for (const mod of this.moduleMap.modules()){
                const modPick = mod.pickNodeMainAxisFirst(point);
                if (modPick !== void 0 && modPick.distanceSquared < closestDistanceSquared) {
                    closestDatum = modPick.datum;
                    closestDistanceSquared = modPick.distanceSquared;
                    break;
                }
            }
            return {
                datum: closestDatum,
                distance: Math.sqrt(closestDistanceSquared)
            };
        }
    }
    isPathOrSelectionDirty() {
        return false;
    }
    shouldFlipXY() {
        return false;
    }
    visibleRange(axisKey, visibleRange, indices) {
        const xValues = this.keysOrValues(axisKey);
        const pixelSize = 0;
        return $d77b025aa58d633c$var$visibleRangeIndices(indices?.length ?? xValues.length, visibleRange, (topIndex)=>{
            const datumIndex = indices?.[topIndex] ?? topIndex;
            return this.xCoordinateRange(xValues[datumIndex], pixelSize, datumIndex);
        });
    }
    domainForVisibleRange(_direction, axisKeys, crossAxisKey, visibleRange, sorted, indices) {
        const { processedData: processedData, dataModel: dataModel } = this;
        const [r0, r1] = visibleRange;
        const crossAxisValues = this.keysOrValues(crossAxisKey);
        if (sorted) {
            const crossAxisRange = this.visibleRange(crossAxisKey, visibleRange, indices);
            return dataModel.getDomainBetweenRange(this, axisKeys, crossAxisRange, processedData);
        }
        const allAxisValues = axisKeys.map((axisKey)=>this.keysOrValues(axisKey));
        let axisMin = Infinity;
        let axisMax = -Infinity;
        crossAxisValues.forEach((crossAxisValue, i)=>{
            const [x0, x1] = this.xCoordinateRange(crossAxisValue, 0, i);
            if (x1 < r0 || x0 > r1) return;
            for(let j = 0; j < axisKeys.length; j++){
                const axisValue = allAxisValues[j][i];
                axisMin = Math.min(axisMin, axisValue);
                axisMax = Math.max(axisMax, axisValue);
            }
        });
        if (axisMin > axisMax) return [
            NaN,
            NaN
        ];
        return [
            axisMin,
            axisMax
        ];
    }
    domainForClippedRange(direction, axisKeys, crossAxisKey, sorted) {
        const { processedData: processedData, dataModel: dataModel, axes: axes } = this;
        const crossDirection = direction === "x" /* X */  ? "y" /* Y */  : "x" /* X */ ;
        const crossAxisRange = $d77b025aa58d633c$var$axisExtent(axes[crossDirection]);
        if (!crossAxisRange) return axisKeys.flatMap((axisKey)=>dataModel.getDomain(this, axisKey, "value", processedData));
        const crossAxisValues = this.keysOrValues(crossAxisKey);
        if (sorted) {
            const crossRange = $d77b025aa58d633c$var$clippedRangeIndices(crossAxisValues.length, crossAxisRange, (index)=>crossAxisValues[index]);
            return dataModel.getDomainBetweenRange(this, axisKeys, crossRange, processedData);
        }
        const allAxisValues = axisKeys.map((axisKey)=>this.keysOrValues(axisKey));
        const range0 = crossAxisRange[0].valueOf();
        const range1 = crossAxisRange[1].valueOf();
        const axisValues = [];
        crossAxisValues.forEach((crossAxisValue, i)=>{
            const c = crossAxisValue.valueOf();
            if (c < range0 || c > range1) return;
            const values = allAxisValues.map((v)=>v[i]);
            if (c >= range0) axisValues.push(...values);
            if (c <= range1) axisValues.push(...values);
        });
        return axisValues;
    }
    countVisibleItems(crossAxisKey, axisKeys, xVisibleRange, yVisibleRange, minVisibleItems) {
        const { dataModel: dataModel, processedData: processedData } = this;
        if (!dataModel || !processedData) return Infinity;
        const crossValues = this.keysOrValues(crossAxisKey);
        const allAxisValues = axisKeys.map((axisKey)=>dataModel.resolveColumnById(this, axisKey, processedData));
        const crossAxis = this.axes["x" /* X */ ];
        const axis = this.axes["y" /* Y */ ];
        const shouldFlipXY = this.shouldFlipXY();
        const crossRange = crossAxis.range;
        const range3 = axis.range;
        const convert = (d, r, v)=>{
            return d[0] + (v - r[0]) / (r[1] - r[0]) * (d[1] - d[0]);
        };
        const crossMin = convert(crossRange, crossAxis.visibleRange, xVisibleRange[0]);
        const crossMax = convert(crossRange, crossAxis.visibleRange, xVisibleRange[1]);
        const axisMin = convert(range3, axis.visibleRange, shouldFlipXY ? yVisibleRange[0] : yVisibleRange[1]);
        const axisMax = convert(range3, axis.visibleRange, shouldFlipXY ? yVisibleRange[1] : yVisibleRange[0]);
        const startIndex = Math.round((xVisibleRange[0] + (xVisibleRange[1] - xVisibleRange[0]) / 2) * crossValues.length);
        const pixelSize = 0;
        return $d77b025aa58d633c$var$countExpandingSearch(0, crossValues.length - 1, startIndex, minVisibleItems, (index)=>{
            let [x0, x1] = this.xCoordinateRange(crossValues[index], pixelSize, index);
            let [y0, y1] = this.yCoordinateRange(allAxisValues.map((axisValues)=>axisValues[index]), pixelSize, index);
            if (!(0, $idDdm.isFiniteNumber)(x0) || !(0, $idDdm.isFiniteNumber)(x1) || !(0, $idDdm.isFiniteNumber)(y0) || !(0, $idDdm.isFiniteNumber)(y1)) return false;
            if (shouldFlipXY) [x0, x1, y0, y1] = [
                y0,
                y1,
                x0,
                x1
            ];
            return x0 >= crossMin && x1 <= crossMax && y0 >= axisMin && y1 <= axisMax;
        });
    }
    updateHighlightSelectionItem(opts) {
        const { opts: { hasMarkers: hasMarkers } } = this;
        const { items: items, highlightSelection: highlightSelection } = opts;
        const nodeData = items ?? [];
        if (hasMarkers) {
            const markerSelection = highlightSelection;
            return this.updateMarkerSelection({
                nodeData: nodeData,
                markerSelection: markerSelection
            });
        } else return this.updateDatumSelection({
            nodeData: nodeData,
            datumSelection: highlightSelection
        });
    }
    updateHighlightSelectionLabel(opts) {
        return this.updateLabelSelection({
            labelData: opts.items ?? [],
            labelSelection: opts.highlightLabelSelection
        });
    }
    updateDatumSelection(opts) {
        return opts.datumSelection;
    }
    updateDatumNodes(_opts) {}
    updateMarkerSelection(opts) {
        return opts.markerSelection;
    }
    updateMarkerNodes(_opts) {}
    updatePaths(opts) {
        opts.paths.forEach((p)=>p.visible = false);
    }
    updatePathNodes(opts) {
        const { paths: paths, opacity: opacity, visible: visible } = opts;
        for (const path of paths){
            path.opacity = opacity;
            path.visible = visible;
        }
    }
    resetPathAnimation(data) {
        const { path: path } = this.opts?.animationResetFns ?? {};
        if (path) data.paths.forEach((paths)=>{
            $d77b025aa58d633c$var$resetMotion([
                paths
            ], path);
        });
    }
    resetDatumAnimation(data) {
        const { datum: datum } = this.opts?.animationResetFns ?? {};
        if (datum) $d77b025aa58d633c$var$resetMotion([
            data.datumSelection
        ], datum);
    }
    resetLabelAnimation(data) {
        const { label: label } = this.opts?.animationResetFns ?? {};
        if (label) $d77b025aa58d633c$var$resetMotion([
            data.labelSelection
        ], label);
    }
    resetMarkerAnimation(data) {
        const { marker: marker } = this.opts?.animationResetFns ?? {};
        if (marker && this.opts.hasMarkers) $d77b025aa58d633c$var$resetMotion([
            data.markerSelection
        ], marker);
    }
    resetAllAnimation(data) {
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
        this.resetPathAnimation(data);
        this.resetDatumAnimation(data);
        this.resetLabelAnimation(data);
        this.resetMarkerAnimation(data);
        if (data.contextData?.animationValid === false) this.ctx.animationManager.skipCurrentBatch();
    }
    animateEmptyUpdateReady(data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation(data);
    }
    animateWaitingUpdateReady(data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation(data);
    }
    animateReadyHighlight(data) {
        const { datum: datum } = this.opts?.animationResetFns ?? {};
        if (datum) $d77b025aa58d633c$var$resetMotion([
            data
        ], datum);
    }
    animateReadyHighlightMarkers(data) {
        const { marker: marker } = this.opts?.animationResetFns ?? {};
        if (marker) $d77b025aa58d633c$var$resetMotion([
            data
        ], marker);
    }
    animateReadyResize(data) {
        this.resetAllAnimation(data);
    }
    animateClearingUpdateEmpty(data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation(data);
    }
    getAnimationData(seriesRect, previousContextData) {
        const { _contextNodeData: contextData } = this;
        if (!contextData) return;
        const animationData = {
            datumSelection: this.datumSelection,
            markerSelection: this.markerSelection,
            labelSelection: this.labelSelection,
            annotationSelections: [
                ...this.annotationSelections
            ],
            contextData: contextData,
            previousContextData: previousContextData,
            paths: this.paths,
            seriesRect: seriesRect
        };
        return animationData;
    }
    updateLabelSelection(opts) {
        return opts.labelSelection;
    }
    getScaling(scale2) {
        if (scale2 instanceof $d77b025aa58d633c$var$LogScale) {
            const { range: range3, domain: domain } = scale2;
            return {
                type: "log",
                convert: (d)=>scale2.convert(d),
                domain: [
                    domain[0],
                    domain[1]
                ],
                range: [
                    range3[0],
                    range3[1]
                ]
            };
        } else if (scale2 instanceof $d77b025aa58d633c$var$ContinuousScale) {
            const { range: range3, domain: domain } = scale2;
            return {
                type: "continuous",
                domain: [
                    domain[0],
                    domain[1]
                ],
                range: [
                    range3[0],
                    range3[1]
                ]
            };
        } else if (scale2 instanceof $d77b025aa58d633c$var$BandScale) {
            const { domain: domain } = scale2;
            return {
                type: "category",
                domain: domain,
                inset: scale2.inset,
                step: scale2.step
            };
        }
    }
    calculateScaling() {
        const result = {};
        for (const direction of Object.values($d77b025aa58d633c$var$ChartAxisDirection)){
            const axis = this.axes[direction];
            if (!axis) continue;
            const scalingResult = this.getScaling(axis.scale);
            if (scalingResult != null) result[direction] = scalingResult;
        }
        return result;
    }
};
function $d77b025aa58d633c$var$axisExtent(axis) {
    let min;
    let max;
    if (axis instanceof $d77b025aa58d633c$var$NumberAxis || axis instanceof $d77b025aa58d633c$var$TimeAxis) ({ min: min, max: max } = axis);
    if (min == null && max == null) return;
    min ?? (min = -Infinity);
    max ?? (max = Infinity);
    return [
        min,
        max
    ];
}
function $d77b025aa58d633c$var$clippedRangeIndices(length2, range3, xValue) {
    const range0 = range3[0].valueOf();
    const range1 = range3[1].valueOf();
    const xMinIndex = (0, $idDdm.findMinIndex)(0, length2 - 1, (index)=>{
        const x = xValue(index)?.valueOf();
        return !Number.isFinite(x) || x >= range0;
    });
    let xMaxIndex = (0, $idDdm.findMaxIndex)(0, length2 - 1, (index)=>{
        const x = xValue(index)?.valueOf();
        return !Number.isFinite(x) || x <= range1;
    });
    if (xMinIndex == null || xMaxIndex == null) return [
        0,
        0
    ];
    xMaxIndex = Math.min(xMaxIndex + 1, length2);
    return [
        xMinIndex,
        xMaxIndex
    ];
}
// packages/ag-charts-community/src/chart/series/cartesian/interpolationProperties.ts
var $d77b025aa58d633c$var$InterpolationProperties = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.type = "linear";
        this.tension = 1;
        this.position = "end";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$InterpolationProperties.prototype, "type", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$InterpolationProperties.prototype, "tension", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$InterpolationProperties.prototype, "position", 2);
// packages/ag-charts-community/src/chart/series/cartesian/areaSeriesProperties.ts
var $d77b025aa58d633c$var$AreaSeriesProperties = class extends $d77b025aa58d633c$var$CartesianSeriesProperties {
    constructor(){
        super(...arguments);
        this.xName = void 0;
        this.fill = "#c16068";
        this.fillGradientDefaults = new $d77b025aa58d633c$var$FillGradientDefaults();
        this.fillPatternDefaults = new $d77b025aa58d633c$var$FillPatternDefaults();
        this.fillImageDefaults = new $d77b025aa58d633c$var$FillImageDefaults();
        this.fillOpacity = 1;
        this.stroke = "#874349";
        this.strokeWidth = 2;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.interpolation = new $d77b025aa58d633c$var$InterpolationProperties();
        this.shadow = new $d77b025aa58d633c$var$DropShadow();
        this.marker = new $d77b025aa58d633c$var$SeriesMarker();
        this.label = new $d77b025aa58d633c$var$Label();
        this.tooltip = new $d77b025aa58d633c$var$SeriesTooltip();
        this.connectMissingData = false;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "xKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "xName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "yKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "yName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "yFilterKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "normalizedTo", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "fillGradientDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "fillPatternDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "fillImageDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "interpolation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "shadow", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "marker", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "tooltip", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "connectMissingData", 2);
// packages/ag-charts-community/src/chart/series/cartesian/lineInterpolation.ts
function $d77b025aa58d633c$var$spanRange(span) {
    switch(span.type){
        case "linear":
        case "step":
            return [
                {
                    x: span.x0,
                    y: span.y0
                },
                {
                    x: span.x1,
                    y: span.y1
                }
            ];
        case "cubic":
            return [
                {
                    x: span.cp0x,
                    y: span.cp0y
                },
                {
                    x: span.cp3x,
                    y: span.cp3y
                }
            ];
    }
}
function $d77b025aa58d633c$var$spanRangeNormalized(span) {
    const range3 = $d77b025aa58d633c$var$spanRange(span);
    if (range3[0].x > range3[1].x) range3.reverse();
    return range3;
}
function $d77b025aa58d633c$var$collapseSpanToPoint(span, point) {
    const { x: x, y: y } = point;
    switch(span.type){
        case "linear":
            return {
                type: "linear",
                moveTo: span.moveTo,
                x0: x,
                y0: y,
                x1: x,
                y1: y
            };
        case "step":
            return {
                type: "step",
                moveTo: span.moveTo,
                x0: x,
                y0: y,
                x1: x,
                y1: y,
                stepX: x
            };
        case "cubic":
            return {
                type: "cubic",
                moveTo: span.moveTo,
                cp0x: x,
                cp0y: y,
                cp1x: x,
                cp1y: y,
                cp2x: x,
                cp2y: y,
                cp3x: x,
                cp3y: y
            };
    }
}
function $d77b025aa58d633c$var$rescaleSpan(span, nextStart, nextEnd) {
    const [prevStart, prevEnd] = $d77b025aa58d633c$var$spanRange(span);
    const widthScale = prevEnd.x !== prevStart.x ? (nextEnd.x - nextStart.x) / (prevEnd.x - prevStart.x) : 0;
    const heightScale = prevEnd.y !== prevStart.y ? (nextEnd.y - nextStart.y) / (prevEnd.y - prevStart.y) : 0;
    switch(span.type){
        case "linear":
            return {
                type: "linear",
                moveTo: span.moveTo,
                x0: nextStart.x,
                y0: nextStart.y,
                x1: nextEnd.x,
                y1: nextEnd.y
            };
        case "cubic":
            return {
                type: "cubic",
                moveTo: span.moveTo,
                cp0x: nextStart.x,
                cp0y: nextStart.y,
                cp1x: nextEnd.x - (span.cp2x - prevStart.x) * widthScale,
                cp1y: nextEnd.y - (span.cp2y - prevStart.y) * heightScale,
                cp2x: nextEnd.x - (span.cp1x - prevStart.x) * widthScale,
                cp2y: nextEnd.y - (span.cp1y - prevStart.y) * heightScale,
                cp3x: nextEnd.x,
                cp3y: nextEnd.y
            };
        case "step":
            return {
                type: "step",
                moveTo: span.moveTo,
                x0: nextStart.x,
                y0: nextStart.y,
                x1: nextEnd.x,
                y1: nextEnd.y,
                stepX: nextEnd.x - (span.stepX - prevStart.x) * widthScale
            };
    }
}
function $d77b025aa58d633c$var$clipSpanX(span, x0, x1) {
    const { moveTo: moveTo } = span;
    const [start2, end2] = $d77b025aa58d633c$var$spanRangeNormalized(span);
    const { x: spanX0, y: spanY0 } = start2;
    const { x: spanX1, y: spanY1 } = end2;
    if (x1 < spanX0) return $d77b025aa58d633c$var$rescaleSpan(span, start2, start2);
    else if (x0 > spanX1) return $d77b025aa58d633c$var$rescaleSpan(span, end2, end2);
    switch(span.type){
        case "linear":
            {
                const m = spanY0 === spanY1 ? void 0 : (spanY1 - spanY0) / (spanX1 - spanX0);
                const y0 = m == null ? spanY0 : m * (x0 - spanX0) + spanY0;
                const y1 = m == null ? spanY0 : m * (x1 - spanX0) + spanY0;
                return {
                    type: "linear",
                    moveTo: moveTo,
                    x0: x0,
                    y0: y0,
                    x1: x1,
                    y1: y1
                };
            }
        case "step":
            if (x1 <= span.stepX) {
                const y = span.y0;
                return {
                    type: "step",
                    moveTo: moveTo,
                    x0: x0,
                    y0: y,
                    x1: x1,
                    y1: y,
                    stepX: x1
                };
            } else if (x0 >= span.stepX) {
                const y = span.y1;
                return {
                    type: "step",
                    moveTo: moveTo,
                    x0: x0,
                    y0: y,
                    x1: x1,
                    y1: y,
                    stepX: x0
                };
            } else {
                const { y0: y0, y1: y1, stepX: stepX } = span;
                return {
                    type: "step",
                    moveTo: moveTo,
                    x0: x0,
                    y0: y0,
                    x1: x1,
                    y1: y1,
                    stepX: stepX
                };
            }
        case "cubic":
            {
                const t0 = $d77b025aa58d633c$var$solveBezier(span.cp0x, span.cp1x, span.cp2x, span.cp3x, x0);
                let [_unused, bezier] = $d77b025aa58d633c$var$splitBezier(span.cp0x, span.cp0y, span.cp1x, span.cp1y, span.cp2x, span.cp2y, span.cp3x, span.cp3y, t0);
                const t1 = $d77b025aa58d633c$var$solveBezier(bezier[0].x, bezier[1].x, bezier[2].x, bezier[3].x, x1);
                [bezier, _unused] = $d77b025aa58d633c$var$splitBezier(bezier[0].x, bezier[0].y, bezier[1].x, bezier[1].y, bezier[2].x, bezier[2].y, bezier[3].x, bezier[3].y, t1);
                return {
                    type: "cubic",
                    moveTo: moveTo,
                    cp0x: bezier[0].x,
                    cp0y: bezier[0].y,
                    cp1x: bezier[1].x,
                    cp1y: bezier[1].y,
                    cp2x: bezier[2].x,
                    cp2y: bezier[2].y,
                    cp3x: bezier[3].x,
                    cp3y: bezier[3].y
                };
            }
    }
}
function $d77b025aa58d633c$var$linearPoints(points) {
    const spans = [];
    let i = 0;
    let x0 = NaN;
    let y0 = NaN;
    for (const { x: x1, y: y1 } of points){
        if (i > 0) {
            const moveTo = i === 1;
            spans.push({
                type: "linear",
                moveTo: moveTo,
                x0: x0,
                y0: y0,
                x1: x1,
                y1: y1
            });
        }
        i += 1;
        x0 = x1;
        y0 = y1;
    }
    return spans;
}
var $d77b025aa58d633c$var$lineSteps = {
    start: 0,
    middle: 0.5,
    end: 1
};
function $d77b025aa58d633c$var$stepPoints(points, position) {
    const spans = [];
    let i = 0;
    let x0 = NaN;
    let y0 = NaN;
    const p0 = typeof position === "number" ? position : $d77b025aa58d633c$var$lineSteps[position];
    for (const { x: x1, y: y1 } of points){
        if (i > 0) {
            const moveTo = i === 1;
            const stepX = x0 + (x1 - x0) * p0;
            spans.push({
                type: "step",
                moveTo: moveTo,
                x0: x0,
                y0: y0,
                x1: x1,
                y1: y1,
                stepX: stepX
            });
        }
        i += 1;
        x0 = x1;
        y0 = y1;
    }
    return spans;
}
var $d77b025aa58d633c$var$flatnessRatio = 0.05;
function $d77b025aa58d633c$var$smoothPoints(iPoints, tension) {
    const points = Array.isArray(iPoints) ? iPoints : Array.from(iPoints);
    if (points.length <= 1) return [];
    const gradients = points.map((c, i)=>{
        const p = i === 0 ? c : points[i - 1];
        const n = i === points.length - 1 ? c : points[i + 1];
        const isTerminalPoint = i === 0 || i === points.length - 1;
        if (Math.sign(p.y - c.y) === Math.sign(n.y - c.y)) return 0;
        if (!isTerminalPoint) {
            const range3 = Math.abs(p.y - n.y);
            const prevRatio = Math.abs(c.y - p.y) / range3;
            const nextRatio = Math.abs(c.y - n.y) / range3;
            if (prevRatio <= $d77b025aa58d633c$var$flatnessRatio || 1 - prevRatio <= $d77b025aa58d633c$var$flatnessRatio || nextRatio <= $d77b025aa58d633c$var$flatnessRatio || 1 - nextRatio <= $d77b025aa58d633c$var$flatnessRatio) return 0;
        }
        return (n.y - p.y) / (n.x - p.x);
    });
    if (gradients[1] === 0) gradients[0] *= 2;
    if (gradients[gradients.length - 2] === 0) gradients[gradients.length - 1] *= 2;
    const spans = [];
    for(let i = 1; i < points.length; i += 1){
        const prev = points[i - 1];
        const prevM = gradients[i - 1];
        const cur = points[i];
        const curM = gradients[i];
        const dx = cur.x - prev.x;
        const dy = cur.y - prev.y;
        let dcp1x = dx * tension / 3;
        let dcp1y = dx * prevM * tension / 3;
        let dcp2x = dx * tension / 3;
        let dcp2y = dx * curM * tension / 3;
        if (curM === 0 && Math.abs(dcp1y) > Math.abs(dy)) {
            dcp1x *= Math.abs(dy / dcp1y);
            dcp1y = Math.sign(dcp1y) * Math.abs(dy);
        }
        if (prevM === 0 && Math.abs(dcp2y) > Math.abs(dy)) {
            dcp2x *= Math.abs(dy / dcp2y);
            dcp2y = Math.sign(dcp2y) * Math.abs(dy);
        }
        spans.push({
            type: "cubic",
            moveTo: i === 1,
            cp0x: prev.x,
            cp0y: prev.y,
            cp1x: prev.x + dcp1x,
            cp1y: prev.y + dcp1y,
            cp2x: cur.x - dcp2x,
            cp2y: cur.y - dcp2y,
            cp3x: cur.x,
            cp3y: cur.y
        });
    }
    return spans;
}
// packages/ag-charts-community/src/chart/series/cartesian/lineInterpolationPlotting.ts
function $d77b025aa58d633c$var$lerp2(a, b, ratio11) {
    return (b - a) * ratio11 + a;
}
function $d77b025aa58d633c$var$linearSupertype(span, stepX) {
    const { x0: x0, y0: y0, x1: x1, y1: y1 } = span;
    const m = (y1 - y0) / (x1 - x0);
    const stepY = m * (stepX - x0) + y0;
    return {
        leftCp1x: x0,
        leftCp1y: y0,
        leftCp2x: stepX,
        leftCp2y: stepY,
        stepX: stepX,
        stepY0: stepY,
        stepY1: stepY,
        rightCp1x: stepX,
        rightCp1y: stepY,
        rightCp2x: x1,
        rightCp2y: y1
    };
}
function $d77b025aa58d633c$var$bezierSupertype(span, stepX) {
    const { cp0x: cp0x, cp0y: cp0y, cp1x: cp1x, cp1y: cp1y, cp2x: cp2x, cp2y: cp2y, cp3x: cp3x, cp3y: cp3y } = span;
    const t = $d77b025aa58d633c$var$solveBezier(cp0x, cp1x, cp2x, cp3x, stepX);
    const [left, right] = $d77b025aa58d633c$var$splitBezier(cp0x, cp0y, cp1x, cp1y, cp2x, cp2y, cp3x, cp3y, t);
    const stepY = left[3].y;
    return {
        leftCp1x: left[1].x,
        leftCp1y: left[1].y,
        leftCp2x: left[2].x,
        leftCp2y: left[2].y,
        stepX: stepX,
        stepY0: stepY,
        stepY1: stepY,
        rightCp1x: right[1].x,
        rightCp1y: right[1].y,
        rightCp2x: right[2].x,
        rightCp2y: right[2].y
    };
}
function $d77b025aa58d633c$var$stepSupertype(span) {
    const { x0: x0, y0: y0, x1: x1, y1: y1, stepX: stepX } = span;
    return {
        leftCp1x: (x0 + stepX) / 2,
        leftCp1y: y0,
        leftCp2x: (x0 + stepX) / 2,
        leftCp2y: y0,
        stepX: stepX,
        stepY0: y0,
        stepY1: y1,
        rightCp1x: (stepX + x1) / 2,
        rightCp1y: y1,
        rightCp2x: (stepX + x1) / 2,
        rightCp2y: y1
    };
}
function $d77b025aa58d633c$var$spanSupertype(span, stepX) {
    if (span.type === "linear") return $d77b025aa58d633c$var$linearSupertype(span, stepX);
    else if (span.type === "cubic") return $d77b025aa58d633c$var$bezierSupertype(span, stepX);
    else return $d77b025aa58d633c$var$stepSupertype(span);
}
function $d77b025aa58d633c$var$plotStart(path, moveTo, x0, y0, x1, y1, reversed) {
    switch(moveTo){
        case 0 /* MoveTo */ :
            if (reversed) path.moveTo(x1, y1);
            else path.moveTo(x0, y0);
            break;
        case 1 /* LineTo */ :
            if (reversed) path.lineTo(x1, y1);
            else path.lineTo(x0, y0);
            break;
    }
}
function $d77b025aa58d633c$var$plotLinear(path, x0, y0, x1, y1, reversed) {
    if (reversed) path.lineTo(x0, y0);
    else path.lineTo(x1, y1);
}
function $d77b025aa58d633c$var$plotCubic(path, cp0x, cp0y, cp1x, cp1y, cp2x, cp2y, cp3x, cp3y, reversed) {
    if (reversed) path.cubicCurveTo(cp2x, cp2y, cp1x, cp1y, cp0x, cp0y);
    else path.cubicCurveTo(cp1x, cp1y, cp2x, cp2y, cp3x, cp3y);
}
function $d77b025aa58d633c$var$plotStep(path, x0, y0, x1, y1, stepX, reversed) {
    if (reversed) {
        path.lineTo(stepX, y1);
        path.lineTo(stepX, y0);
        path.lineTo(x0, y0);
    } else {
        path.lineTo(stepX, y0);
        path.lineTo(stepX, y1);
        path.lineTo(x1, y1);
    }
}
function $d77b025aa58d633c$var$plotSpan(path, span, moveTo, reversed) {
    const [start2, end2] = $d77b025aa58d633c$var$spanRange(span);
    $d77b025aa58d633c$var$plotStart(path, moveTo, start2.x, start2.y, end2.x, end2.y, reversed);
    switch(span.type){
        case "linear":
            $d77b025aa58d633c$var$plotLinear(path, span.x0, span.y0, span.x1, span.y1, reversed);
            break;
        case "cubic":
            $d77b025aa58d633c$var$plotCubic(path, span.cp0x, span.cp0y, span.cp1x, span.cp1y, span.cp2x, span.cp2y, span.cp3x, span.cp3y, reversed);
            break;
        case "step":
            $d77b025aa58d633c$var$plotStep(path, span.x0, span.y0, span.x1, span.y1, span.stepX, reversed);
            break;
    }
}
function $d77b025aa58d633c$var$interpolatedSpanRange(a, b, ratio11) {
    const [aStart, aEnd] = $d77b025aa58d633c$var$spanRange(a);
    const [bStart, bEnd] = $d77b025aa58d633c$var$spanRange(b);
    const x0 = $d77b025aa58d633c$var$lerp2(aStart.x, bStart.x, ratio11);
    const y0 = $d77b025aa58d633c$var$lerp2(aStart.y, bStart.y, ratio11);
    const x1 = $d77b025aa58d633c$var$lerp2(aEnd.x, bEnd.x, ratio11);
    const y1 = $d77b025aa58d633c$var$lerp2(aEnd.y, bEnd.y, ratio11);
    return [
        {
            x: x0,
            y: y0
        },
        {
            x: x1,
            y: y1
        }
    ];
}
function $d77b025aa58d633c$var$plotInterpolatedSpans(path, a, b, ratio11, moveTo, reversed) {
    const [{ x: x0, y: y0 }, { x: x1, y: y1 }] = $d77b025aa58d633c$var$interpolatedSpanRange(a, b, ratio11);
    $d77b025aa58d633c$var$plotStart(path, moveTo, x0, y0, x1, y1, reversed);
    if (a.type === "cubic" && b.type === "cubic") {
        const cp1x = $d77b025aa58d633c$var$lerp2(a.cp1x, b.cp1x, ratio11);
        const cp1y = $d77b025aa58d633c$var$lerp2(a.cp1y, b.cp1y, ratio11);
        const cp2x = $d77b025aa58d633c$var$lerp2(a.cp2x, b.cp2x, ratio11);
        const cp2y = $d77b025aa58d633c$var$lerp2(a.cp2y, b.cp2y, ratio11);
        $d77b025aa58d633c$var$plotCubic(path, x0, y0, cp1x, cp1y, cp2x, cp2y, x1, y1, reversed);
    } else if (a.type === "step" && b.type === "step") {
        const stepX = $d77b025aa58d633c$var$lerp2(a.stepX, b.stepX, ratio11);
        $d77b025aa58d633c$var$plotStep(path, x0, y0, x1, y1, stepX, reversed);
    } else if (a.type === "linear" && b.type === "linear") $d77b025aa58d633c$var$plotLinear(path, x0, y0, x1, y1, reversed);
    else {
        let defaultStepX;
        if (a.type === "step") defaultStepX = a.stepX;
        else if (b.type === "step") defaultStepX = b.stepX;
        else defaultStepX = (x0 + x1) / 2;
        const as = $d77b025aa58d633c$var$spanSupertype(a, defaultStepX);
        const bs = $d77b025aa58d633c$var$spanSupertype(b, defaultStepX);
        const leftCp1x = $d77b025aa58d633c$var$lerp2(as.leftCp1x, bs.leftCp1x, ratio11);
        const leftCp1y = $d77b025aa58d633c$var$lerp2(as.leftCp1y, bs.leftCp1y, ratio11);
        const leftCp2x = $d77b025aa58d633c$var$lerp2(as.leftCp2x, bs.leftCp2x, ratio11);
        const leftCp2y = $d77b025aa58d633c$var$lerp2(as.leftCp2y, bs.leftCp2y, ratio11);
        const stepX = $d77b025aa58d633c$var$lerp2(as.stepX, bs.stepX, ratio11);
        const stepY0 = $d77b025aa58d633c$var$lerp2(as.stepY0, bs.stepY0, ratio11);
        const stepY1 = $d77b025aa58d633c$var$lerp2(as.stepY1, bs.stepY1, ratio11);
        const rightCp1x = $d77b025aa58d633c$var$lerp2(as.rightCp1x, bs.rightCp1x, ratio11);
        const rightCp1y = $d77b025aa58d633c$var$lerp2(as.rightCp1y, bs.rightCp1y, ratio11);
        const rightCp2x = $d77b025aa58d633c$var$lerp2(as.rightCp2x, bs.rightCp2x, ratio11);
        const rightCp2y = $d77b025aa58d633c$var$lerp2(as.rightCp2y, bs.rightCp2y, ratio11);
        if (reversed) {
            path.cubicCurveTo(rightCp2x, rightCp2y, rightCp1x, rightCp1y, stepX, stepY1);
            path.lineTo(stepX, stepY0);
            path.cubicCurveTo(leftCp2x, leftCp2y, leftCp1x, leftCp1y, x0, y0);
        } else {
            path.cubicCurveTo(leftCp1x, leftCp1y, leftCp2x, leftCp2y, stepX, stepY0);
            path.lineTo(stepX, stepY1);
            path.cubicCurveTo(rightCp1x, rightCp1y, rightCp2x, rightCp2y, x1, y1);
        }
    }
}
// packages/ag-charts-community/src/chart/series/cartesian/lineInterpolationUtil.ts
var $d77b025aa58d633c$var$CollapseMode = /* @__PURE__ */ ((CollapseMode2)=>{
    CollapseMode2[CollapseMode2["Zero"] = 0] = "Zero";
    CollapseMode2[CollapseMode2["Split"] = 1] = "Split";
    return CollapseMode2;
})($d77b025aa58d633c$var$CollapseMode || {});
function $d77b025aa58d633c$var$integratedCategoryMatch(a, b) {
    if (a == null || b == null) return false;
    if (typeof a !== "object" || typeof b !== "object") return false;
    if ("id" in a && "id" in b) return a.id === b.id;
    return a.toString() === b.toString();
}
function $d77b025aa58d633c$var$scale(val, scaling) {
    if (!scaling) return NaN;
    if (val instanceof Date) val = val.getTime();
    if (scaling.type === "continuous" && typeof val === "number") {
        const domainRatio = (val - scaling.domain[0]) / (scaling.domain[1] - scaling.domain[0]);
        return domainRatio * (scaling.range[1] - scaling.range[0]) + scaling.range[0];
    }
    if (scaling.type === "log" && typeof val === "number") return scaling.convert(val);
    if (scaling.type !== "category") return NaN;
    let matchingIndex = scaling.domain.findIndex((d)=>d === val);
    if (matchingIndex === -1) matchingIndex = scaling.domain.findIndex((d)=>$d77b025aa58d633c$var$integratedCategoryMatch(val, d));
    if (matchingIndex >= 0) return scaling.inset + scaling.step * matchingIndex;
    return NaN;
}
function $d77b025aa58d633c$var$toAxisValue(value) {
    return $d77b025aa58d633c$var$transformIntegratedCategoryValue(value).valueOf();
}
function $d77b025aa58d633c$var$getAxisIndices({ data: data }, values) {
    return data.map((datum, datumIndex)=>({
            xValue0Index: values.indexOf($d77b025aa58d633c$var$toAxisValue(datum.xValue0)),
            xValue1Index: values.indexOf($d77b025aa58d633c$var$toAxisValue(datum.xValue1)),
            datumIndex: datumIndex
        }));
}
function $d77b025aa58d633c$var$validateCategorySorting(newData, oldData) {
    const oldScale = oldData.scales.x;
    const newScale = newData.scales.x;
    if (oldScale?.type !== "category" || newScale?.type !== "category") return true;
    let x0 = -Infinity;
    for (const oldValue of oldScale.domain){
        const x = $d77b025aa58d633c$var$scale(oldValue, newScale);
        if (!Number.isFinite(x)) continue;
        if (x < x0) return false;
        else x0 = x;
    }
    return true;
}
function $d77b025aa58d633c$var$validateAxisEntriesOrder(axisValues, data) {
    let x0 = -Infinity;
    for (const axisValue of axisValues){
        const x = $d77b025aa58d633c$var$scale(axisValue.value, data.scales.x);
        if (!Number.isFinite(x)) continue;
        if (x < x0) return false;
        else x0 = x;
    }
    return true;
}
function $d77b025aa58d633c$var$spanAxisContext(newData, oldData) {
    const allAxisEntries = /* @__PURE__ */ new Map();
    for (const { xValue0: xValue0, xValue1: xValue1 } of newData.data){
        const xValue0Value = $d77b025aa58d633c$var$toAxisValue(xValue0);
        const xValue1Value = $d77b025aa58d633c$var$toAxisValue(xValue1);
        allAxisEntries.set(xValue0Value, xValue0).set(xValue1Value, xValue1);
    }
    const newAxisEntries = Array.from(allAxisEntries, ([axisValue, value])=>({
            axisValue: axisValue,
            value: value
        }));
    newAxisEntries.sort((a, b)=>{
        return $d77b025aa58d633c$var$scale(a.value, newData.scales.x) - $d77b025aa58d633c$var$scale(b.value, newData.scales.x);
    });
    const exclusivelyOldAxisEntries = [];
    for (const { xValue0: xValue0, xValue1: xValue1 } of oldData.data){
        const xValue0Value = $d77b025aa58d633c$var$toAxisValue(xValue0);
        const xValue1Value = $d77b025aa58d633c$var$toAxisValue(xValue1);
        if (!allAxisEntries.has(xValue0Value)) {
            allAxisEntries.set(xValue0Value, xValue0);
            exclusivelyOldAxisEntries.push({
                axisValue: xValue0Value,
                value: xValue0
            });
        }
        if (!allAxisEntries.has(xValue1Value)) {
            allAxisEntries.set(xValue1Value, xValue1);
            exclusivelyOldAxisEntries.push({
                axisValue: xValue1Value,
                value: xValue1
            });
        }
    }
    exclusivelyOldAxisEntries.sort((a, b)=>{
        return $d77b025aa58d633c$var$scale(a.value, oldData.scales.x) - $d77b025aa58d633c$var$scale(b.value, oldData.scales.x);
    });
    const axisEntries = newAxisEntries;
    let insertionIndex = 0;
    for (const oldAxisEntries of exclusivelyOldAxisEntries){
        for(let i = axisEntries.length - 1; i > insertionIndex; i -= 1){
            const oldValueX = $d77b025aa58d633c$var$scale(oldAxisEntries.value, oldData.scales.x);
            const newValueX = $d77b025aa58d633c$var$scale(axisEntries[i].value, oldData.scales.x);
            if (oldValueX > newValueX) {
                insertionIndex = i + 1;
                break;
            }
        }
        axisEntries.splice(insertionIndex, 0, oldAxisEntries);
        insertionIndex += 1;
    }
    if (!$d77b025aa58d633c$var$validateAxisEntriesOrder(axisEntries, oldData)) return;
    const axisValues = axisEntries.map((axisEntry)=>axisEntry.axisValue);
    const oldDataAxisIndices = $d77b025aa58d633c$var$getAxisIndices(oldData, axisValues);
    const newDataAxisIndices = $d77b025aa58d633c$var$getAxisIndices(newData, axisValues);
    return {
        axisValues: axisValues,
        oldDataAxisIndices: oldDataAxisIndices,
        newDataAxisIndices: newDataAxisIndices
    };
}
function $d77b025aa58d633c$var$clipSpan(span, xValue0Index, xIndices) {
    if (xIndices.xValue1Index === xIndices.xValue0Index + 1) return span;
    const range3 = $d77b025aa58d633c$var$spanRange(span);
    const step = (range3[1].x - range3[0].x) / (xIndices.xValue1Index - xIndices.xValue0Index);
    const start2 = range3[0].x + (xValue0Index - xIndices.xValue0Index) * step;
    const end2 = start2 + step;
    return $d77b025aa58d633c$var$clipSpanX(span, start2, end2);
}
function $d77b025aa58d633c$var$axisZeroSpan(span, data) {
    const [r0, r1] = $d77b025aa58d633c$var$spanRange(span);
    const y0 = $d77b025aa58d633c$var$scale(0, data.scales.y);
    return $d77b025aa58d633c$var$rescaleSpan(span, {
        x: r0.x,
        y: y0
    }, {
        x: r1.x,
        y: y0
    });
}
function $d77b025aa58d633c$var$collapseSpanToMidpoint(span) {
    const [r0, r1] = $d77b025aa58d633c$var$spanRange(span);
    return $d77b025aa58d633c$var$collapseSpanToPoint(span, {
        x: (r0.x + r1.x) / 2,
        y: (r0.y + r1.y) / 2
    });
}
function $d77b025aa58d633c$var$collapseSpan(span, collapseMode, data, axisIndices, indices, range3) {
    let xValue;
    let yValue;
    if (indices.xValue0Index >= range3.xValue1Index) {
        const datumIndex = axisIndices.findLast((i)=>i.xValue1Index <= range3.xValue1Index)?.datumIndex;
        const datum = datumIndex != null ? data.data[datumIndex] : void 0;
        xValue = datum?.xValue1;
        yValue = datum?.yValue1;
    } else if (indices.xValue0Index <= range3.xValue0Index) {
        const datumIndex = axisIndices.find((i)=>i.xValue0Index >= range3.xValue0Index)?.datumIndex;
        const datum = datumIndex != null ? data.data[datumIndex] : void 0;
        xValue = datum?.xValue0;
        yValue = datum?.yValue0;
    }
    if (xValue == null || yValue == null) switch(collapseMode){
        case 0 /* Zero */ :
            return $d77b025aa58d633c$var$axisZeroSpan(span, data);
        case 1 /* Split */ :
            return $d77b025aa58d633c$var$collapseSpanToMidpoint(span);
    }
    const x = $d77b025aa58d633c$var$scale(xValue, data.scales.x);
    const y = $d77b025aa58d633c$var$scale(yValue, data.scales.y);
    const point = {
        x: x,
        y: y
    };
    return $d77b025aa58d633c$var$rescaleSpan(span, point, point);
}
function $d77b025aa58d633c$var$zeroDataSpan(spanDatum, zeroData) {
    if (zeroData == null) return;
    const newSpanXValue0 = $d77b025aa58d633c$var$toAxisValue(spanDatum.xValue0);
    const newSpanXValue1 = $d77b025aa58d633c$var$toAxisValue(spanDatum.xValue1);
    return zeroData.find((zeroSpanDatum)=>$d77b025aa58d633c$var$toAxisValue(zeroSpanDatum.xValue0) === newSpanXValue0 && $d77b025aa58d633c$var$toAxisValue(zeroSpanDatum.xValue1) === newSpanXValue1)?.span;
}
function $d77b025aa58d633c$var$addSpan(newData, collapseMode, newAxisIndices, newIndices, oldZeroData, range3, out) {
    const newSpanDatum = newData.data[newIndices.datumIndex];
    const newSpan = newSpanDatum.span;
    const zeroSpan = $d77b025aa58d633c$var$zeroDataSpan(newSpanDatum, oldZeroData);
    if (zeroSpan != null) {
        out.removed.push({
            from: zeroSpan,
            to: zeroSpan
        });
        out.moved.push({
            from: zeroSpan,
            to: newSpan
        });
        out.added.push({
            from: newSpan,
            to: newSpan
        });
    } else {
        const oldSpan = $d77b025aa58d633c$var$collapseSpan(newSpan, collapseMode, newData, newAxisIndices, newIndices, range3);
        out.added.push({
            from: oldSpan,
            to: newSpan
        });
    }
}
function $d77b025aa58d633c$var$removeSpan(oldData, collapseMode, oldAxisIndices, oldIndices, newZeroData, range3, out) {
    const oldSpanDatum = oldData.data[oldIndices.datumIndex];
    const oldSpan = oldSpanDatum.span;
    const zeroSpan = $d77b025aa58d633c$var$zeroDataSpan(oldSpanDatum, newZeroData);
    if (zeroSpan != null) {
        out.removed.push({
            from: oldSpan,
            to: oldSpan
        });
        out.moved.push({
            from: oldSpan,
            to: zeroSpan
        });
        out.added.push({
            from: zeroSpan,
            to: zeroSpan
        });
    } else {
        const newSpan = $d77b025aa58d633c$var$collapseSpan(oldSpan, collapseMode, oldData, oldAxisIndices, oldIndices, range3);
        out.removed.push({
            from: oldSpan,
            to: newSpan
        });
    }
}
function $d77b025aa58d633c$var$alignSpanToContainingSpan(span, axisValues, preData, postData, postSpanIndices) {
    const startXValue0 = axisValues[postSpanIndices.xValue0Index];
    const startDatum = preData.data.find((spanDatum)=>$d77b025aa58d633c$var$toAxisValue(spanDatum.xValue0) === startXValue0);
    const endXValue1 = axisValues[postSpanIndices.xValue1Index];
    const endDatum = preData.data.find((spanDatum)=>$d77b025aa58d633c$var$toAxisValue(spanDatum.xValue1) === endXValue1);
    if (startDatum == null || endDatum == null) return;
    const [{ x: x0 }, { x: x1 }] = $d77b025aa58d633c$var$spanRange(span);
    const startX = $d77b025aa58d633c$var$scale(startDatum.xValue0, preData.scales.x);
    const startY = $d77b025aa58d633c$var$scale(startDatum.yValue0, preData.scales.y);
    const endX = $d77b025aa58d633c$var$scale(endDatum.xValue1, preData.scales.x);
    const endY = $d77b025aa58d633c$var$scale(endDatum.yValue1, preData.scales.y);
    let altSpan = postData.data[postSpanIndices.datumIndex].span;
    altSpan = $d77b025aa58d633c$var$rescaleSpan(altSpan, {
        x: startX,
        y: startY
    }, {
        x: endX,
        y: endY
    });
    altSpan = $d77b025aa58d633c$var$clipSpanX(altSpan, x0, x1);
    return altSpan;
}
function $d77b025aa58d633c$var$appendSpanPhases(newData, oldData, collapseMode, axisValues, xValue0Index, newAxisIndices, oldAxisIndices, range3, out) {
    const xValue1Index = xValue0Index + 1;
    const oldIndices = oldAxisIndices.find((i)=>i.xValue0Index <= xValue0Index && i.xValue1Index >= xValue1Index);
    const newIndices = newAxisIndices.find((i)=>i.xValue0Index <= xValue0Index && i.xValue1Index >= xValue1Index);
    const oldZeroData = oldData.zeroData;
    const newZeroData = newData.zeroData;
    if (oldIndices == null && newIndices != null) {
        $d77b025aa58d633c$var$addSpan(newData, collapseMode, newAxisIndices, newIndices, oldZeroData, range3, out);
        return;
    } else if (oldIndices != null && newIndices == null) {
        $d77b025aa58d633c$var$removeSpan(oldData, collapseMode, oldAxisIndices, oldIndices, newZeroData, range3, out);
        return;
    } else if (oldIndices == null || newIndices == null) return;
    let ordering;
    if (oldIndices.xValue0Index === newIndices.xValue0Index && oldIndices.xValue1Index === newIndices.xValue1Index) ordering = 0;
    else if (oldIndices.xValue0Index <= newIndices.xValue0Index && oldIndices.xValue1Index >= newIndices.xValue1Index) ordering = -1;
    else if (oldIndices.xValue0Index >= newIndices.xValue0Index && oldIndices.xValue1Index <= newIndices.xValue1Index) ordering = 1;
    else ordering = 0;
    const oldSpanDatum = oldData.data[oldIndices.datumIndex];
    const clippedOldSpanOldScale = $d77b025aa58d633c$var$clipSpan(oldSpanDatum.span, xValue0Index, oldIndices);
    const newSpanDatum = newData.data[newIndices.datumIndex];
    const clippedNewSpanNewScale = $d77b025aa58d633c$var$clipSpan(newSpanDatum.span, xValue0Index, newIndices);
    if (ordering === 1) {
        const clippedPostRemoveOldSpanOldScale = $d77b025aa58d633c$var$alignSpanToContainingSpan(clippedOldSpanOldScale, axisValues, oldData, newData, newIndices);
        if (clippedPostRemoveOldSpanOldScale != null) {
            out.removed.push({
                from: clippedOldSpanOldScale,
                to: clippedPostRemoveOldSpanOldScale
            });
            out.moved.push({
                from: clippedPostRemoveOldSpanOldScale,
                to: clippedNewSpanNewScale
            });
            out.added.push({
                from: clippedNewSpanNewScale,
                to: clippedNewSpanNewScale
            });
        } else $d77b025aa58d633c$var$removeSpan(oldData, collapseMode, oldAxisIndices, oldIndices, newZeroData, range3, out);
    } else if (ordering === -1) {
        const clippedPreAddedNewSpanNewScale = $d77b025aa58d633c$var$alignSpanToContainingSpan(clippedNewSpanNewScale, axisValues, newData, oldData, oldIndices);
        if (clippedPreAddedNewSpanNewScale != null) {
            out.removed.push({
                from: clippedOldSpanOldScale,
                to: clippedOldSpanOldScale
            });
            out.moved.push({
                from: clippedOldSpanOldScale,
                to: clippedPreAddedNewSpanNewScale
            });
            out.added.push({
                from: clippedPreAddedNewSpanNewScale,
                to: clippedNewSpanNewScale
            });
        } else $d77b025aa58d633c$var$addSpan(newData, collapseMode, newAxisIndices, newIndices, oldZeroData, range3, out);
    } else {
        out.removed.push({
            from: clippedOldSpanOldScale,
            to: clippedOldSpanOldScale
        });
        out.moved.push({
            from: clippedOldSpanOldScale,
            to: clippedNewSpanNewScale
        });
        out.added.push({
            from: clippedNewSpanNewScale,
            to: clippedNewSpanNewScale
        });
    }
}
function $d77b025aa58d633c$var$phaseAnimation(axisContext, newData, oldData, collapseMode) {
    const out = {
        removed: [],
        moved: [],
        added: []
    };
    const { axisValues: axisValues, oldDataAxisIndices: oldDataAxisIndices, newDataAxisIndices: newDataAxisIndices } = axisContext;
    const range3 = {
        xValue0Index: Math.max(oldDataAxisIndices.at(0)?.xValue0Index ?? -Infinity, newDataAxisIndices.at(0)?.xValue0Index ?? -Infinity),
        xValue1Index: Math.min(oldDataAxisIndices.at(-1)?.xValue1Index ?? Infinity, newDataAxisIndices.at(-1)?.xValue1Index ?? Infinity)
    };
    for(let xValue0Index = 0; xValue0Index < axisValues.length - 1; xValue0Index += 1)$d77b025aa58d633c$var$appendSpanPhases(newData, oldData, collapseMode, axisValues, xValue0Index, newDataAxisIndices, oldDataAxisIndices, range3, out);
    return out;
}
function $d77b025aa58d633c$var$resetSpan(data, spanDatum, collapseMode) {
    const { span: span } = spanDatum;
    switch(collapseMode){
        case 0 /* Zero */ :
            return $d77b025aa58d633c$var$zeroDataSpan(spanDatum, data.zeroData) ?? $d77b025aa58d633c$var$axisZeroSpan(span, data);
        case 1 /* Split */ :
            return $d77b025aa58d633c$var$collapseSpanToMidpoint(span);
    }
}
function $d77b025aa58d633c$var$resetAnimation(newData, oldData, collapseMode) {
    const added = [];
    const removed = [];
    for (const oldSpanDatum of oldData.data){
        const oldSpan = oldSpanDatum.span;
        const collapsedSpan = $d77b025aa58d633c$var$resetSpan(oldData, oldSpanDatum, collapseMode);
        removed.push({
            from: oldSpan,
            to: collapsedSpan
        });
    }
    for (const newSpanDatum of newData.data){
        const newSpan = newSpanDatum.span;
        const collapsedSpan = $d77b025aa58d633c$var$resetSpan(newData, newSpanDatum, collapseMode);
        added.push({
            from: collapsedSpan,
            to: newSpan
        });
    }
    return {
        removed: removed,
        moved: [],
        added: added
    };
}
function $d77b025aa58d633c$var$pairUpSpans(newData, oldData, collapseMode) {
    if (!$d77b025aa58d633c$var$validateCategorySorting(newData, oldData)) return;
    const axisContext = $d77b025aa58d633c$var$spanAxisContext(newData, oldData);
    return axisContext == null ? $d77b025aa58d633c$var$resetAnimation(newData, oldData, collapseMode) : $d77b025aa58d633c$var$phaseAnimation(axisContext, newData, oldData, collapseMode);
}
function $d77b025aa58d633c$var$isContinuousScaling(scaling) {
    return scaling.type === "continuous" || scaling.type === "log";
}
function $d77b025aa58d633c$var$isCategoryScaling(scaling) {
    return scaling.type === "category";
}
function $d77b025aa58d633c$var$areScalingEqual(a, b) {
    if (a === void 0 || b === void 0) return a !== void 0 || b !== void 0;
    if ($d77b025aa58d633c$var$isContinuousScaling(a) && $d77b025aa58d633c$var$isContinuousScaling(b)) return a.type === b.type && (0, $idDdm.arraysEqual)(a.domain, b.domain) && (0, $idDdm.arraysEqual)(a.range, b.range);
    if ($d77b025aa58d633c$var$isCategoryScaling(a) && $d77b025aa58d633c$var$isCategoryScaling(b)) return a.inset === b.inset && a.step === b.step && (0, $idDdm.arraysEqual)(a.domain, b.domain);
    return false;
}
function $d77b025aa58d633c$var$isScaleValid(scale2) {
    if (scale2 == null) return false;
    if (scale2.type === "category") return scale2.domain.every((v)=>v != null);
    return scale2.domain.every((v)=>Number.isFinite(v) || v instanceof Date) && scale2.range.every((v)=>Number.isFinite(v));
}
// packages/ag-charts-community/src/chart/series/cartesian/lineUtil.ts
function $d77b025aa58d633c$var$interpolatePoints(points, interpolation) {
    let spans;
    const pointsIter = points.map((point)=>point.point);
    switch(interpolation.type){
        case "linear":
            spans = $d77b025aa58d633c$var$linearPoints(pointsIter);
            break;
        case "smooth":
            spans = $d77b025aa58d633c$var$smoothPoints(pointsIter, interpolation.tension);
            break;
        case "step":
            spans = $d77b025aa58d633c$var$stepPoints(pointsIter, interpolation.position);
            break;
    }
    return spans.map((span, i)=>({
            span: span,
            xValue0: points[i].xDatum,
            yValue0: points[i].yDatum,
            xValue1: points[i + 1].xDatum,
            yValue1: points[i + 1].yDatum
        }));
}
function $d77b025aa58d633c$var$pointsEq(a, b, delta3 = 1e-3) {
    return Math.abs(a.x - b.x) < delta3 && Math.abs(a.y - b.y) < delta3;
}
function $d77b025aa58d633c$var$plotLinePathStroke({ path: path }, spans) {
    let lastPoint;
    for (const { span: span } of spans){
        const [start2, end2] = $d77b025aa58d633c$var$spanRange(span);
        const join = lastPoint != null && $d77b025aa58d633c$var$pointsEq(lastPoint, start2) ? 1 /* LineTo */  : 0 /* MoveTo */ ;
        $d77b025aa58d633c$var$plotSpan(path, span, join, false);
        lastPoint = end2;
    }
}
function $d77b025aa58d633c$var$plotInterpolatedLinePathStroke(ratio11, path, spans) {
    let lastPoint;
    for (const span of spans){
        const [start2, end2] = $d77b025aa58d633c$var$interpolatedSpanRange(span.from, span.to, ratio11);
        const join = lastPoint != null && $d77b025aa58d633c$var$pointsEq(lastPoint, start2) ? 1 /* LineTo */  : 0 /* MoveTo */ ;
        $d77b025aa58d633c$var$plotInterpolatedSpans(path.path, span.from, span.to, ratio11, join, false);
        lastPoint = end2;
    }
}
function $d77b025aa58d633c$var$prepareLinePathStrokeAnimationFns(status, spans, visibleToggleMode) {
    const removePhaseFn = (ratio11, path)=>$d77b025aa58d633c$var$plotInterpolatedLinePathStroke(ratio11, path, spans.removed);
    const updatePhaseFn = (ratio11, path)=>$d77b025aa58d633c$var$plotInterpolatedLinePathStroke(ratio11, path, spans.moved);
    const addPhaseFn = (ratio11, path)=>$d77b025aa58d633c$var$plotInterpolatedLinePathStroke(ratio11, path, spans.added);
    const pathProperties = $d77b025aa58d633c$var$prepareLinePathPropertyAnimation(status, visibleToggleMode);
    return {
        status: status,
        path: {
            addPhaseFn: addPhaseFn,
            updatePhaseFn: updatePhaseFn,
            removePhaseFn: removePhaseFn
        },
        pathProperties: pathProperties
    };
}
function $d77b025aa58d633c$var$prepareLinePathPropertyAnimation(status, visibleToggleMode) {
    const phase = visibleToggleMode === "none" ? "updated" : status;
    const result = {
        fromFn: (_path)=>{
            let mixin;
            if (status === "removed") mixin = {
                finish: {
                    visible: false
                }
            };
            else if (status === "added") mixin = {
                start: {
                    visible: true
                }
            };
            else mixin = {};
            return {
                phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[phase],
                ...mixin
            };
        },
        toFn: (_path)=>{
            return {
                phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[phase]
            };
        }
    };
    if (visibleToggleMode === "fade") return {
        fromFn: (path)=>{
            const opacity = status === "added" ? 0 : path.opacity;
            return {
                opacity: opacity,
                ...result.fromFn(path)
            };
        },
        toFn: (path)=>{
            const opacity = status === "removed" ? 0 : 1;
            return {
                opacity: opacity,
                ...result.toFn(path)
            };
        }
    };
    return result;
}
function $d77b025aa58d633c$var$prepareLinePathAnimation(newData, oldData, diff2) {
    const isCategoryBased = newData.scales.x?.type === "category";
    const wasCategoryBased = oldData.scales.x?.type === "category";
    if (isCategoryBased !== wasCategoryBased || !$d77b025aa58d633c$var$isScaleValid(newData.scales.x) || !$d77b025aa58d633c$var$isScaleValid(oldData.scales.x)) return;
    if (newData.strokeData == null || oldData.strokeData == null) return;
    let status = "updated";
    if (oldData.visible && !newData.visible) status = "removed";
    else if (!oldData.visible && newData.visible) status = "added";
    const strokeSpans = $d77b025aa58d633c$var$pairUpSpans({
        scales: newData.scales,
        data: newData.strokeData.spans
    }, {
        scales: oldData.scales,
        data: oldData.strokeData.spans
    }, 1 /* Split */ );
    if (strokeSpans == null) return;
    const stroke2 = $d77b025aa58d633c$var$prepareLinePathStrokeAnimationFns(status, strokeSpans, "fade");
    const hasMotion = (diff2?.changed ?? true) || !$d77b025aa58d633c$var$areScalingEqual(newData.scales.x, oldData.scales.x) || !$d77b025aa58d633c$var$areScalingEqual(newData.scales.y, oldData.scales.y) || status !== "updated";
    return {
        status: status,
        stroke: stroke2,
        hasMotion: hasMotion
    };
}
// packages/ag-charts-community/src/chart/series/cartesian/areaUtil.ts
function $d77b025aa58d633c$var$plotAreaPathFill({ path: path }, { spans: spans, phantomSpans: phantomSpans }) {
    for(let i = 0; i < spans.length; i += 1){
        const { span: span } = spans[i];
        const phantomSpan = phantomSpans[i].span;
        $d77b025aa58d633c$var$plotSpan(path, span, 0 /* MoveTo */ , false);
        $d77b025aa58d633c$var$plotSpan(path, phantomSpan, 1 /* LineTo */ , true);
        path.closePath();
    }
}
function $d77b025aa58d633c$var$plotInterpolatedAreaSeriesFillSpans(ratio11, { path: path }, spans, fillPhantomSpans) {
    for(let i = 0; i < spans.length; i += 1){
        const span = spans[i];
        const reversedPhantomSpan = fillPhantomSpans[i];
        $d77b025aa58d633c$var$plotInterpolatedSpans(path, span.from, span.to, ratio11, 0 /* MoveTo */ , false);
        $d77b025aa58d633c$var$plotInterpolatedSpans(path, reversedPhantomSpan.from, reversedPhantomSpan.to, ratio11, 1 /* LineTo */ , true);
        path.closePath();
    }
}
function $d77b025aa58d633c$var$prepareAreaFillAnimationFns(status, spans, fillPhantomSpans, visibleToggleMode) {
    const removePhaseFn = (ratio11, path)=>$d77b025aa58d633c$var$plotInterpolatedAreaSeriesFillSpans(ratio11, path, spans.removed, fillPhantomSpans.removed);
    const updatePhaseFn = (ratio11, path)=>$d77b025aa58d633c$var$plotInterpolatedAreaSeriesFillSpans(ratio11, path, spans.moved, fillPhantomSpans.moved);
    const addPhaseFn = (ratio11, path)=>$d77b025aa58d633c$var$plotInterpolatedAreaSeriesFillSpans(ratio11, path, spans.added, fillPhantomSpans.added);
    const pathProperties = $d77b025aa58d633c$var$prepareLinePathPropertyAnimation(status, visibleToggleMode);
    return {
        status: status,
        path: {
            addPhaseFn: addPhaseFn,
            updatePhaseFn: updatePhaseFn,
            removePhaseFn: removePhaseFn
        },
        pathProperties: pathProperties
    };
}
function $d77b025aa58d633c$var$prepareAreaPathAnimation(newData, oldData) {
    const isCategoryBased = newData.scales.x?.type === "category";
    const wasCategoryBased = oldData.scales.x?.type === "category";
    if (isCategoryBased !== wasCategoryBased || !$d77b025aa58d633c$var$isScaleValid(newData.scales.x) || !$d77b025aa58d633c$var$isScaleValid(oldData.scales.x)) return;
    let status = "updated";
    if (oldData.visible && !newData.visible) status = "removed";
    else if (!oldData.visible && newData.visible) status = "added";
    const fillSpans = $d77b025aa58d633c$var$pairUpSpans({
        scales: newData.scales,
        data: newData.fillData.spans
    }, {
        scales: oldData.scales,
        data: oldData.fillData.spans
    }, 0 /* Zero */ );
    if (fillSpans == null) return;
    const fillPhantomSpans = $d77b025aa58d633c$var$pairUpSpans({
        scales: newData.scales,
        data: newData.fillData.phantomSpans
    }, {
        scales: oldData.scales,
        data: oldData.fillData.phantomSpans
    }, 0 /* Zero */ );
    if (fillPhantomSpans == null) return;
    const strokeSpans = $d77b025aa58d633c$var$pairUpSpans({
        scales: newData.scales,
        data: newData.strokeData.spans,
        zeroData: newData.fillData.phantomSpans
    }, {
        scales: oldData.scales,
        data: oldData.strokeData.spans,
        zeroData: oldData.fillData.phantomSpans
    }, 0 /* Zero */ );
    if (strokeSpans == null) return;
    const fadeMode = "none";
    const fill = $d77b025aa58d633c$var$prepareAreaFillAnimationFns(status, fillSpans, fillPhantomSpans, fadeMode);
    const stroke2 = $d77b025aa58d633c$var$prepareLinePathStrokeAnimationFns(status, strokeSpans, fadeMode);
    return {
        status: status,
        fill: fill,
        stroke: stroke2
    };
}
function $d77b025aa58d633c$var$markerFadeInAnimation({ id: id }, animationManager, status, ...markerSelections) {
    const params = {
        phase: status ? $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[status] : "trailing"
    };
    $d77b025aa58d633c$var$staticFromToMotion(id, "markers", animationManager, markerSelections, {
        opacity: 0
    }, {
        opacity: 1
    }, params);
    markerSelections.forEach((s)=>s.cleanup());
}
function $d77b025aa58d633c$var$markerScaleInAnimation({ id: id }, animationManager, ...markerSelections) {
    $d77b025aa58d633c$var$staticFromToMotion(id, "markers", animationManager, markerSelections, {
        scalingX: 0,
        scalingY: 0
    }, {
        scalingX: 1,
        scalingY: 1
    }, {
        phase: "initial"
    });
    markerSelections.forEach((s)=>s.cleanup());
}
function $d77b025aa58d633c$var$markerSwipeScaleInAnimation({ id: id, nodeDataDependencies: nodeDataDependencies }, animationManager, ...markerSelections) {
    const seriesWidth = nodeDataDependencies.seriesRectWidth;
    const fromFn = (_, datum)=>{
        const x = datum.midPoint?.x ?? seriesWidth;
        let delay = (0, $idDdm.clamp)(0, $d77b025aa58d633c$var$inverseEaseOut(x / seriesWidth), 1);
        if (isNaN(delay)) delay = 0;
        return {
            scalingX: 0,
            scalingY: 0,
            delay: delay,
            duration: $d77b025aa58d633c$var$QUICK_TRANSITION,
            phase: "initial"
        };
    };
    const toFn = ()=>{
        return {
            scalingX: 1,
            scalingY: 1
        };
    };
    $d77b025aa58d633c$var$fromToMotion(id, "markers", animationManager, markerSelections, {
        fromFn: fromFn,
        toFn: toFn
    });
}
function $d77b025aa58d633c$var$resetMarkerFn(_node) {
    return {
        opacity: 1,
        scalingX: 1,
        scalingY: 1
    };
}
function $d77b025aa58d633c$var$resetMarkerPositionFn(_node, datum) {
    return {
        x: datum.point?.x ?? NaN,
        y: datum.point?.y ?? NaN,
        scalingCenterX: datum.point?.x ?? NaN,
        scalingCenterY: datum.point?.y ?? NaN
    };
}
function $d77b025aa58d633c$var$computeMarkerFocusBounds(series, { datumIndex: datumIndex }) {
    const nodeData = series.getNodeData();
    if (nodeData === void 0) return void 0;
    const datum = nodeData[datumIndex];
    const { point: point } = datum ?? {};
    if (datum == null || point == null) return void 0;
    const size = 4 + (point.focusSize ?? series.getFormattedMarkerStyle(datum).size);
    const radius = size / 2;
    const x = datum.point.x - radius;
    const y = datum.point.y - radius;
    return $d77b025aa58d633c$var$Transformable.toCanvas(series.contentGroup, new $d77b025aa58d633c$var$BBox(x, y, size, size));
}
// packages/ag-charts-community/src/chart/series/cartesian/pathUtil.ts
function $d77b025aa58d633c$var$pathSwipeInAnimation({ id: id, visible: visible, nodeDataDependencies: nodeDataDependencies }, animationManager, ...paths) {
    const { seriesRectWidth: width2, seriesRectHeight: height2 } = nodeDataDependencies;
    $d77b025aa58d633c$var$staticFromToMotion(id, "path_properties", animationManager, paths, {
        clipX: 0
    }, {
        clipX: width2
    }, {
        phase: "initial",
        start: {
            clip: true,
            clipY: height2,
            visible: visible
        },
        finish: {
            clip: false,
            visible: visible
        }
    });
}
function $d77b025aa58d633c$var$pathFadeInAnimation({ id: id }, subId, animationManager, phase = "add", ...selection) {
    $d77b025aa58d633c$var$staticFromToMotion(id, subId, animationManager, selection, {
        opacity: 0
    }, {
        opacity: 1
    }, {
        phase: phase
    });
}
function $d77b025aa58d633c$var$buildResetPathFn(opts) {
    return (_node)=>({
            visible: opts.getVisible(),
            opacity: opts.getOpacity(),
            clipScalingX: 1,
            clip: false
        });
}
function $d77b025aa58d633c$var$updateClipPath({ nodeDataDependencies: nodeDataDependencies }, path) {
    const toFinite = (value)=>isFinite(value) ? value : 0;
    path.clipX = toFinite(nodeDataDependencies.seriesRectWidth);
    path.clipY = toFinite(nodeDataDependencies.seriesRectHeight);
}
// packages/ag-charts-community/src/chart/series/cartesian/areaSeries.ts
var $d77b025aa58d633c$var$CROSS_FILTER_AREA_FILL_OPACITY_FACTOR = 0.125;
var $d77b025aa58d633c$var$CROSS_FILTER_AREA_STROKE_OPACITY_FACTOR = 0.25;
var $d77b025aa58d633c$var$AreaSeries = class extends $d77b025aa58d633c$var$CartesianSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            directionKeys: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_KEYS,
            directionNames: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_NAMES,
            categoryKey: "xValue",
            pathsPerSeries: [
                "fill",
                "stroke"
            ],
            pathsZIndexSubOrderOffset: [
                0,
                1e3
            ],
            hasMarkers: true,
            markerSelectionGarbageCollection: false,
            pickModes: [
                2 /* AXIS_ALIGNED */ ,
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            animationResetFns: {
                path: $d77b025aa58d633c$var$buildResetPathFn({
                    getVisible: ()=>this.visible,
                    getOpacity: ()=>this.getOpacity()
                }),
                label: $d77b025aa58d633c$var$resetLabelFn,
                marker: (node, datum)=>({
                        ...$d77b025aa58d633c$var$resetMarkerFn(node),
                        ...$d77b025aa58d633c$var$resetMarkerPositionFn(node, datum)
                    })
            },
            clipFocusBox: false
        });
        this.properties = new $d77b025aa58d633c$var$AreaSeriesProperties();
        this.connectsToYAxis = true;
        this.backgroundGroup = new $d77b025aa58d633c$var$Group({
            name: `${this.id}-background`,
            zIndex: 0 /* BACKGROUND */ 
        });
        this._isStacked = void 0;
    }
    get pickModeAxis() {
        return "main";
    }
    renderToOffscreenCanvas() {
        return super.renderToOffscreenCanvas() || this.contextNodeData != null && (this.contextNodeData.fillData.spans.length > $d77b025aa58d633c$var$RENDER_TO_OFFSCREEN_CANVAS_THRESHOLD || this.contextNodeData.strokeData.spans.length > $d77b025aa58d633c$var$RENDER_TO_OFFSCREEN_CANVAS_THRESHOLD);
    }
    attachSeries(seriesContentNode, seriesNode, annotationNode) {
        super.attachSeries(seriesContentNode, seriesNode, annotationNode);
        seriesContentNode.appendChild(this.backgroundGroup);
    }
    detachSeries(seriesContentNode, seriesNode, annotationNode) {
        super.detachSeries(seriesContentNode, seriesNode, annotationNode);
        seriesContentNode?.removeChild(this.backgroundGroup);
    }
    attachPaths([fill, stroke2]) {
        this.backgroundGroup.appendChild(fill);
        this.contentGroup.appendChild(stroke2);
        stroke2.zIndex = -1;
    }
    detachPaths([fill, stroke2]) {
        this.backgroundGroup.removeChild(fill);
        this.contentGroup.removeChild(stroke2);
    }
    isStacked() {
        const stackCount = this.seriesGrouping?.stackCount ?? 1;
        return stackCount > 1;
    }
    setSeriesIndex(index) {
        const isStacked = this.isStacked();
        if (!super.setSeriesIndex(index) && this._isStacked === isStacked) return false;
        this._isStacked = isStacked;
        if (isStacked) {
            this.backgroundGroup.zIndex = [
                0 /* BACKGROUND */ ,
                index
            ];
            this.contentGroup.zIndex = [
                1 /* ANY_CONTENT */ ,
                index,
                0 /* FOREGROUND */ 
            ];
        } else {
            this.backgroundGroup.zIndex = [
                1 /* ANY_CONTENT */ ,
                index,
                0 /* FOREGROUND */ ,
                0
            ];
            this.contentGroup.zIndex = [
                1 /* ANY_CONTENT */ ,
                index,
                0 /* FOREGROUND */ ,
                1
            ];
        }
        return true;
    }
    async processData(dataController) {
        if (this.data == null) return;
        const { data: data, visible: visible, seriesGrouping: { groupIndex: groupIndex = this.id, stackCount: stackCount = 1 } = {} } = this;
        const { xKey: xKey, yKey: yKey, yFilterKey: yFilterKey, connectMissingData: connectMissingData, normalizedTo: normalizedTo } = this.properties;
        const animationEnabled = !this.ctx.animationManager.isSkipped();
        const xScale = this.axes["x" /* X */ ]?.scale;
        const yScale = this.axes["y" /* Y */ ]?.scale;
        const { xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
            xScale: xScale,
            yScale: yScale
        });
        const idMap = {
            value: `area-stack-${groupIndex}-yValue`,
            values: `area-stack-${groupIndex}-yValues`,
            stack: `area-stack-${groupIndex}-yValue-stack`,
            marker: `area-stack-${groupIndex}-yValues-marker`
        };
        const extraProps = [];
        if ((0, $idDdm.isDefined)(normalizedTo)) extraProps.push($d77b025aa58d633c$var$normaliseGroupTo(Object.values(idMap), normalizedTo));
        if (animationEnabled) extraProps.push($d77b025aa58d633c$var$animationValidation());
        const common = {
            invalidValue: null
        };
        if (((0, $idDdm.isDefined)(normalizedTo) || connectMissingData) && stackCount > 1) common.invalidValue = 0;
        if (!visible) common.forceValue = 0;
        await this.requestDataModel(dataController, data, {
            props: [
                $d77b025aa58d633c$var$keyProperty(xKey, xScaleType, {
                    id: "xValue"
                }),
                $d77b025aa58d633c$var$valueProperty(yKey, yScaleType, {
                    id: `yValueRaw`,
                    ...common
                }),
                ...yFilterKey != null ? [
                    $d77b025aa58d633c$var$valueProperty(yFilterKey, yScaleType, {
                        id: "yFilterRaw"
                    })
                ] : [],
                ...$d77b025aa58d633c$var$groupStackValueProperty(yKey, yScaleType, {
                    id: `yValueStack`,
                    ...common,
                    groupId: idMap.stack
                }),
                $d77b025aa58d633c$var$valueProperty(yKey, yScaleType, {
                    id: `yValue`,
                    ...common,
                    groupId: idMap.value
                }),
                ...$d77b025aa58d633c$var$groupAccumulativeValueProperty(yKey, "window", "current", {
                    id: `yValueEnd`,
                    ...common,
                    groupId: idMap.values
                }, yScaleType),
                ...$d77b025aa58d633c$var$groupAccumulativeValueProperty(yKey, "normal", "current", {
                    id: `yValueCumulative`,
                    ...common,
                    groupId: idMap.marker
                }, yScaleType),
                ...extraProps
            ],
            groupByKeys: true,
            groupByData: false
        });
        this.animationState.transition("updateData");
    }
    xCoordinateRange(xValue, pixelSize) {
        const { marker: marker } = this.properties;
        const x = this.axes["x" /* X */ ].scale.convert(xValue);
        const r = marker.enabled ? 0.5 * marker.size * pixelSize : 0;
        return [
            x - r,
            x + r
        ];
    }
    yCoordinateRange(yValues, pixelSize) {
        const { marker: marker } = this.properties;
        const y = this.axes["y" /* Y */ ].scale.convert(yValues[0]);
        const r = marker.enabled ? 0.5 * marker.size * pixelSize : 0;
        return [
            y - r,
            y + r
        ];
    }
    getSeriesDomain(direction) {
        const { processedData: processedData, dataModel: dataModel, axes: axes } = this;
        if (!processedData || !dataModel) return [];
        const yAxis = axes["y" /* Y */ ];
        if (direction === "x" /* X */ ) {
            const keyDef = dataModel.resolveProcessedDataDefById(this, `xValue`);
            const keys = dataModel.getDomain(this, `xValue`, "key", processedData);
            if (keyDef?.def.type === "key" && keyDef.def.valueType === "category") return keys;
            return $d77b025aa58d633c$var$fixNumericExtent($d77b025aa58d633c$var$extent(keys));
        }
        const yExtent = this.domainForClippedRange("y" /* Y */ , [
            "yValueCumulative"
        ], "xValue", true);
        if (yAxis instanceof $d77b025aa58d633c$var$LogAxis || yAxis instanceof $d77b025aa58d633c$var$TimeAxis) return $d77b025aa58d633c$var$fixNumericExtent(yExtent);
        else {
            const fixedYExtent = Number.isFinite(yExtent[1] - yExtent[0]) ? [
                yExtent[0] > 0 ? 0 : yExtent[0],
                yExtent[1] < 0 ? 0 : yExtent[1]
            ] : [];
            return $d77b025aa58d633c$var$fixNumericExtent(fixedYExtent);
        }
    }
    getSeriesRange(_direction, visibleRange) {
        const [y0, y1] = this.domainForVisibleRange("y" /* Y */ , [
            "yValueCumulative"
        ], "xValue", visibleRange, true);
        return [
            Math.min(y0, 0),
            Math.max(y1, 0)
        ];
    }
    getVisibleItems(xVisibleRange, yVisibleRange, minVisibleItems) {
        return this.countVisibleItems("xValue", [
            "yValueCumulative"
        ], xVisibleRange, yVisibleRange, minVisibleItems);
    }
    createNodeData() {
        const { axes: axes, data: data, processedData: processedData, dataModel: dataModel } = this;
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        if (!xAxis || !yAxis || !data || !dataModel || processedData?.type !== "grouped") return;
        const { yKey: yKey, xKey: xKey, yFilterKey: yFilterKey, marker: marker, label: label, fill: seriesFill, stroke: seriesStroke, connectMissingData: connectMissingData, interpolation: interpolation } = this.properties;
        const { scale: xScale } = xAxis;
        const { scale: yScale } = yAxis;
        const { isContinuousY: isContinuousY } = this.getScaleInformation({
            xScale: xScale,
            yScale: yScale
        });
        const xOffset = (xScale.bandwidth ?? 0) / 2;
        const xValues = dataModel.resolveKeysById(this, "xValue", processedData);
        const yEndValues = dataModel.resolveColumnById(this, `yValueEnd`, processedData);
        const yRawValues = dataModel.resolveColumnById(this, `yValueRaw`, processedData);
        const yCumulativeValues = dataModel.resolveColumnById(this, `yValueCumulative`, processedData);
        const yFilterValues = yFilterKey != null ? dataModel.resolveColumnById(this, "yFilterRaw", processedData) : void 0;
        const yStackValues = dataModel.resolveColumnById(this, "yValueStack", processedData);
        const createMarkerCoordinate = (xDatum, yEnd, rawYDatum)=>{
            let currY;
            if ((0, $idDdm.isDefined)(this.properties.normalizedTo) ? isContinuousY && $d77b025aa58d633c$var$isContinuous(rawYDatum) : !isNaN(rawYDatum)) currY = yEnd;
            return {
                x: xScale.convert(xDatum) + xOffset,
                y: yScale.convert(currY),
                size: marker.size
            };
        };
        const labelData = [];
        const markerData = [];
        const { visibleSameStackCount: visibleSameStackCount } = this.ctx.seriesStateManager.getVisiblePeerGroupIndex(this);
        let crossFiltering = false;
        const { dataSources: dataSources } = processedData;
        const rawData = dataSources.get(this.id) ?? [];
        for (const { datumIndex: datumIndex } of dataModel.forEachGroupDatum(this, processedData)){
            const xDatum = xValues[datumIndex];
            if (xDatum == null) return;
            const seriesDatum = rawData[datumIndex];
            const yDatum = yRawValues[datumIndex];
            const yValueCumulative = yCumulativeValues[datumIndex];
            const yValueEnd = yEndValues[datumIndex];
            const validPoint = Number.isFinite(yDatum);
            const point = createMarkerCoordinate(xDatum, +yValueCumulative, yDatum);
            const selected = yFilterValues != null ? yFilterValues[datumIndex] === yDatum : void 0;
            if (selected === false) crossFiltering = true;
            if (validPoint && marker) markerData.push({
                series: this,
                itemId: yKey,
                datum: seriesDatum,
                datumIndex: datumIndex,
                midPoint: {
                    x: point.x,
                    y: point.y
                },
                cumulativeValue: yValueEnd,
                yValue: yDatum,
                xValue: xDatum,
                yKey: yKey,
                xKey: xKey,
                point: point,
                fill: marker.fill ?? seriesFill,
                stroke: marker.stroke ?? seriesStroke,
                strokeWidth: marker.strokeWidth ?? this.getStrokeWidth(this.properties.strokeWidth),
                selected: selected
            });
            if (validPoint && label) {
                const labelText = this.getLabelText(label, {
                    value: yDatum,
                    datum: seriesDatum,
                    xKey: xKey,
                    yKey: yKey,
                    xName: this.properties.xName,
                    yName: this.properties.yName
                });
                labelData.push({
                    series: this,
                    itemId: yKey,
                    datum: seriesDatum,
                    datumIndex: datumIndex,
                    x: point.x,
                    y: point.y,
                    labelText: labelText
                });
            }
        }
        const spansForPoints = (points)=>{
            return points.flatMap((p)=>{
                return Array.isArray(p) ? $d77b025aa58d633c$var$interpolatePoints(p, interpolation) : new Array(p.skip).fill(null);
            });
        };
        const createPoint = (xDatum, yDatum)=>({
                point: {
                    x: xScale.convert(xDatum) + xOffset,
                    y: yScale.convert(yDatum)
                },
                xDatum: xDatum,
                yDatum: yDatum
            });
        const getSeriesSpans = (index)=>{
            const points = [];
            for (const { datumIndexes: [pIdx, datumIndex, nIndx] } of dataModel.forEachGroupDatumTuple(this, processedData)){
                const xDatum = xValues[datumIndex];
                const yValueStack = yStackValues[datumIndex];
                const yDatum = yValueStack[index];
                const yDatumIsFinite = Number.isFinite(yDatum);
                if (connectMissingData && !yDatumIsFinite) continue;
                const lastYValueStack = pIdx != null ? yStackValues[pIdx] : void 0;
                const nextYValueStack = nIndx != null ? yStackValues[nIndx] : void 0;
                let yValueEndBackwards = 0;
                let yValueEndForwards = 0;
                for(let j = 0; j <= index; j += 1){
                    const value = yValueStack[j];
                    if (Number.isFinite(value)) {
                        const lastWasFinite = lastYValueStack == null || Number.isFinite(lastYValueStack[j]);
                        const nextWasFinite = nextYValueStack == null || Number.isFinite(nextYValueStack[j]);
                        if (lastWasFinite) yValueEndBackwards += value;
                        if (nextWasFinite) yValueEndForwards += value;
                    }
                }
                const currentPoints = points[points.length - 1];
                if (!connectMissingData && (yValueEndBackwards !== yValueEndForwards || !yDatumIsFinite)) {
                    if (!yDatumIsFinite && Array.isArray(currentPoints) && currentPoints.length === 1) points[points.length - 1] = {
                        skip: 1
                    };
                    else {
                        const pointBackwards = createPoint(xDatum, yValueEndBackwards);
                        const pointForwards = createPoint(xDatum, yValueEndForwards);
                        if (Array.isArray(currentPoints)) currentPoints.push(pointBackwards);
                        else if (currentPoints != null) currentPoints.skip += 1;
                        points.push(yDatumIsFinite ? [
                            pointForwards
                        ] : {
                            skip: 0
                        });
                    }
                } else {
                    const yValue = connectMissingData ? yDatum : Math.max(yValueEndBackwards, yValueEndForwards);
                    const point = createPoint(xDatum, yValue);
                    if (Array.isArray(currentPoints)) currentPoints.push(point);
                    else if (currentPoints != null) {
                        currentPoints.skip += 1;
                        points.push([
                            point
                        ]);
                    } else points.push([
                        point
                    ]);
                }
            }
            return spansForPoints(points);
        };
        const stackIndex = this.seriesGrouping?.stackIndex ?? 0;
        const getAxisSpans = ()=>{
            const yValueZeroPoints = Array.from(dataModel.forEachGroupDatum(this, processedData), ({ datumIndex: datumIndex })=>{
                const xDatum = xValues[datumIndex];
                const yValueStack = yStackValues[datumIndex];
                const yDatum = yValueStack[stackIndex];
                if (connectMissingData && !Number.isFinite(yDatum)) return;
                return createPoint(xDatum, 0);
            }).filter((x)=>x != null);
            return $d77b025aa58d633c$var$interpolatePoints(yValueZeroPoints, interpolation);
        };
        const currentSeriesSpans = getSeriesSpans(stackIndex);
        const phantomSpans = currentSeriesSpans.map(()=>null);
        for(let j = stackIndex - 1; j >= -1; j -= 1){
            let spans;
            for(let i = 0; i < phantomSpans.length; i += 1){
                if (phantomSpans[i] != null) continue;
                spans ?? (spans = j !== -1 ? getSeriesSpans(j) : getAxisSpans());
                phantomSpans[i] = spans[i];
            }
        }
        const fillSpans = currentSeriesSpans.map((span, index)=>span ?? phantomSpans[index]);
        const strokeSpans = currentSeriesSpans.filter((span)=>span != null);
        const context = {
            itemId: yKey,
            fillData: {
                itemId: yKey,
                spans: fillSpans,
                phantomSpans: phantomSpans
            },
            strokeData: {
                itemId: yKey,
                spans: strokeSpans
            },
            labelData: labelData,
            nodeData: markerData,
            scales: this.calculateScaling(),
            visible: this.visible,
            stackVisible: visibleSameStackCount > 0,
            crossFiltering: crossFiltering
        };
        return context;
    }
    isPathOrSelectionDirty() {
        return this.properties.marker.isDirty();
    }
    updatePathNodes(opts) {
        const { opacity: opacity, visible: visible, animationEnabled: animationEnabled } = opts;
        const [fill, stroke2] = opts.paths;
        const crossFiltering = this.contextNodeData?.crossFiltering === true;
        const strokeWidth = this.getStrokeWidth(this.properties.strokeWidth);
        stroke2.setProperties({
            fill: void 0,
            lineCap: "round",
            lineJoin: "round",
            pointerEvents: 1 /* None */ ,
            stroke: this.properties.stroke,
            strokeWidth: strokeWidth,
            strokeOpacity: this.properties.strokeOpacity * (crossFiltering ? $d77b025aa58d633c$var$CROSS_FILTER_AREA_STROKE_OPACITY_FACTOR : 1),
            lineDash: this.properties.lineDash,
            lineDashOffset: this.properties.lineDashOffset,
            opacity: opacity,
            visible: visible || animationEnabled
        });
        const seriesFill = $d77b025aa58d633c$var$getShapeFill(this.properties.fill, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
        $d77b025aa58d633c$var$applyShapeStyle(fill, {
            fill: seriesFill,
            stroke: void 0,
            fillOpacity: this.properties.fillOpacity * (crossFiltering ? $d77b025aa58d633c$var$CROSS_FILTER_AREA_FILL_OPACITY_FACTOR : 1)
        }, void 0, this.getShapeFillBBox());
        fill.setProperties({
            lineJoin: "round",
            pointerEvents: 1 /* None */ ,
            fillShadow: this.properties.shadow,
            opacity: opacity,
            visible: visible || animationEnabled
        });
        $d77b025aa58d633c$var$updateClipPath(this, stroke2);
        $d77b025aa58d633c$var$updateClipPath(this, fill);
    }
    updatePaths(opts) {
        this.updateAreaPaths(opts.paths, opts.contextData);
    }
    updateAreaPaths(paths, contextData) {
        for (const path of paths)path.visible = contextData.visible;
        if (contextData.visible) {
            this.updateFillPath(paths, contextData);
            this.updateStrokePath(paths, contextData);
        } else for (const path of paths){
            path.path.clear();
            path.markDirty("AreaSeries");
        }
    }
    updateFillPath(paths, contextData) {
        const [fill] = paths;
        fill.path.clear();
        $d77b025aa58d633c$var$plotAreaPathFill(fill, contextData.fillData);
        fill.markDirty("AreaSeries");
    }
    updateStrokePath(paths, contextData) {
        const { spans: spans } = contextData.strokeData;
        const [, stroke2] = paths;
        stroke2.path.clear();
        $d77b025aa58d633c$var$plotLinePathStroke(stroke2, spans);
        stroke2.markDirty("AreaSeries");
    }
    updateMarkerSelection(opts) {
        const { nodeData: nodeData, markerSelection: markerSelection } = opts;
        const markersEnabled = this.properties.marker.enabled || this.contextNodeData?.crossFiltering === true;
        if (this.properties.marker.isDirty()) {
            markerSelection.clear();
            markerSelection.cleanup();
        }
        return markerSelection.update(markersEnabled ? nodeData : []);
    }
    updateMarkerNodes(opts) {
        const { markerSelection: markerSelection, isHighlight: highlighted } = opts;
        const { xKey: xKey, yKey: yKey, marker: marker, fill: fill, stroke: stroke2, strokeWidth: strokeWidth, fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, highlightStyle: highlightStyle } = this.properties;
        const xDomain = this.getSeriesDomain("x" /* X */ );
        const yDomain = this.getSeriesDomain("y" /* Y */ );
        const baseStyle = $d77b025aa58d633c$var$mergeDefaults(highlighted && highlightStyle.item, marker.getStyle(), {
            fill: fill,
            stroke: stroke2,
            strokeWidth: strokeWidth,
            fillOpacity: fillOpacity,
            strokeOpacity: strokeOpacity
        });
        const fillBBox = this.getShapeFillBBox();
        markerSelection.each((node, datum)=>{
            this.updateMarkerStyle(marker, node, datum.datum, datum.point, $d77b025aa58d633c$var$datumStylerProperties(datum, xKey, yKey, xDomain, yDomain), highlighted, baseStyle, fillBBox, {
                selected: datum.selected
            });
        });
        if (!highlighted) this.properties.marker.markClean();
    }
    updateLabelSelection(opts) {
        const { labelData: labelData, labelSelection: labelSelection } = opts;
        return labelSelection.update(labelData);
    }
    updateLabelNodes(opts) {
        const { labelSelection: labelSelection } = opts;
        const { enabled: labelEnabled, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily, color: color11 } = this.properties.label;
        labelSelection.each((text, datum)=>{
            const { x: x, y: y, labelText: labelText } = datum;
            if (labelText && labelEnabled && this.visible) {
                text.fontStyle = fontStyle;
                text.fontWeight = fontWeight;
                text.fontSize = fontSize;
                text.fontFamily = fontFamily;
                text.textAlign = "center";
                text.textBaseline = "bottom";
                text.text = labelText;
                text.x = x;
                text.y = y - 10;
                text.fill = color11;
                text.visible = true;
            } else text.visible = false;
        });
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, axes: axes, properties: properties } = this;
        const { xKey: xKey, xName: xName, yKey: yKey, yName: yName, tooltip: tooltip, marker: marker } = properties;
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        if (!dataModel || !processedData || !xAxis || !yAxis) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const xValue = dataModel.resolveKeysById(this, `xValue`, processedData)[datumIndex];
        const yValue = dataModel.resolveColumnById(this, `yValueRaw`, processedData)[datumIndex];
        const { xDomain: xDomain, yDomain: yDomain } = this.cachedDatumCallback("domain", ()=>({
                xDomain: this.getSeriesDomain("x" /* X */ ),
                yDomain: this.getSeriesDomain("y" /* Y */ )
            }));
        if (xValue == null) return;
        const style = marker.getStyle();
        const nodeDatum = {
            datum: datum,
            xValue: xValue,
            yValue: yValue
        };
        const activeStyle = this.getMarkerStyle(marker, datum, $d77b025aa58d633c$var$datumStylerProperties(nodeDatum, xKey, yKey, xDomain, yDomain), false, void 0, style);
        return this.formatTooltipWithContext(tooltip, {
            heading: xAxis.formatDatum(xValue),
            symbol: this.legendItemSymbol(),
            data: [
                {
                    label: yName,
                    fallbackLabel: yKey,
                    value: yAxis.formatDatum(yValue)
                }
            ]
        }, {
            seriesId: seriesId,
            datum: datum,
            title: yName,
            xKey: xKey,
            xName: xName,
            yKey: yKey,
            yName: yName,
            ...activeStyle,
            ...this.getModuleTooltipParams()
        });
    }
    legendItemSymbol() {
        const { fill: fill, stroke: stroke2, fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, marker: marker, fillGradientDefaults: fillGradientDefaults2, fillPatternDefaults: fillPatternDefaults2, fillImageDefaults: fillImageDefaults2 } = this.properties;
        const useAreaFill = !marker.enabled || marker.fill === void 0;
        const legendMarkerFill = useAreaFill ? $d77b025aa58d633c$var$getShapeFill(fill, fillGradientDefaults2, fillPatternDefaults2, fillImageDefaults2) : $d77b025aa58d633c$var$getShapeFill(marker.fill, marker.fillGradientDefaults, marker.fillPatternDefaults, marker.fillImageDefaults);
        const markerStyle = this.getMarkerStyle(marker, void 0, void 0, false, void 0, {
            fill: legendMarkerFill,
            fillOpacity: useAreaFill ? fillOpacity : marker.fillOpacity
        });
        return {
            marker: {
                ...markerStyle,
                enabled: marker.enabled || strokeWidth <= 0
            },
            line: {
                stroke: stroke2,
                strokeOpacity: strokeOpacity,
                strokeWidth: strokeWidth,
                lineDash: lineDash
            }
        };
    }
    getLegendData(legendType) {
        if (legendType !== "category") return [];
        const { id: seriesId, ctx: { legendManager: legendManager }, visible: visible } = this;
        const { yKey: itemId, yName: yName, legendItemName: legendItemName, showInLegend: showInLegend } = this.properties;
        return [
            {
                legendType: legendType,
                id: seriesId,
                itemId: itemId,
                seriesId: seriesId,
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: seriesId,
                    itemId: itemId
                }),
                label: {
                    text: legendItemName ?? yName ?? itemId
                },
                symbol: this.legendItemSymbol(),
                legendItemName: legendItemName,
                hideInLegend: !showInLegend
            }
        ];
    }
    animateEmptyUpdateReady(animationData) {
        const { markerSelection: markerSelection, labelSelection: labelSelection, contextData: contextData, paths: paths } = animationData;
        const { animationManager: animationManager } = this.ctx;
        this.updateAreaPaths(paths, contextData);
        $d77b025aa58d633c$var$pathSwipeInAnimation(this, animationManager, ...paths);
        $d77b025aa58d633c$var$resetMotion([
            markerSelection
        ], $d77b025aa58d633c$var$resetMarkerPositionFn);
        $d77b025aa58d633c$var$markerSwipeScaleInAnimation(this, animationManager, markerSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelection);
    }
    animateReadyResize(animationData) {
        const { contextData: contextData, paths: paths } = animationData;
        this.updateAreaPaths(paths, contextData);
        super.animateReadyResize(animationData);
    }
    animateWaitingUpdateReady(animationData) {
        const { animationManager: animationManager } = this.ctx;
        const { markerSelection: markerSelection, labelSelection: labelSelection, contextData: contextData, paths: paths, previousContextData: previousContextData } = animationData;
        const [fill, stroke2] = paths;
        if (fill == null && stroke2 == null) return;
        this.resetMarkerAnimation(animationData);
        this.resetLabelAnimation(animationData);
        const update = ()=>{
            this.resetPathAnimation(animationData);
            this.updateAreaPaths(paths, contextData);
        };
        const skip = ()=>{
            animationManager.skipCurrentBatch();
            update();
        };
        if (contextData == null || previousContextData == null) {
            update();
            $d77b025aa58d633c$var$markerFadeInAnimation(this, animationManager, "added", markerSelection);
            $d77b025aa58d633c$var$pathFadeInAnimation(this, "fill_path_properties", animationManager, "add", fill);
            $d77b025aa58d633c$var$pathFadeInAnimation(this, "stroke_path_properties", animationManager, "add", stroke2);
            $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelection);
            return;
        }
        if (contextData.crossFiltering !== previousContextData.crossFiltering) {
            skip();
            return;
        }
        const fns = $d77b025aa58d633c$var$prepareAreaPathAnimation(contextData, previousContextData);
        if (fns === void 0) {
            skip();
            return;
        } else if (fns.status === "no-op") return;
        $d77b025aa58d633c$var$markerFadeInAnimation(this, animationManager, void 0, markerSelection);
        $d77b025aa58d633c$var$fromToMotion(this.id, "fill_path_properties", animationManager, [
            fill
        ], fns.fill.pathProperties);
        $d77b025aa58d633c$var$pathMotion(this.id, "fill_path_update", animationManager, [
            fill
        ], fns.fill.path);
        $d77b025aa58d633c$var$fromToMotion(this.id, "stroke_path_properties", animationManager, [
            stroke2
        ], fns.stroke.pathProperties);
        $d77b025aa58d633c$var$pathMotion(this.id, "stroke_path_update", animationManager, [
            stroke2
        ], fns.stroke.path);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelection);
        this.ctx.animationManager.animate({
            id: this.id,
            groupId: "reset_after_animation",
            phase: "trailing",
            from: {},
            to: {},
            onComplete: ()=>this.updateAreaPaths(paths, contextData)
        });
    }
    isLabelEnabled() {
        return this.properties.label.enabled;
    }
    nodeFactory() {
        return new $d77b025aa58d633c$var$Group();
    }
    getFormattedMarkerStyle(datum) {
        const { xKey: xKey, yKey: yKey } = datum;
        const xDomain = this.getSeriesDomain("x" /* X */ );
        const yDomain = this.getSeriesDomain("y" /* Y */ );
        return this.getMarkerStyle(this.properties.marker, datum.datum, $d77b025aa58d633c$var$datumStylerProperties(datum, xKey, yKey, xDomain, yDomain), true);
    }
    computeFocusBounds(opts) {
        return $d77b025aa58d633c$var$computeMarkerFocusBounds(this, opts);
    }
};
$d77b025aa58d633c$var$AreaSeries.className = "AreaSeries";
$d77b025aa58d633c$var$AreaSeries.type = "area";
var $d77b025aa58d633c$var$timeIntervalUnit = (0, $idDdm.union)("millisecond", "second", "minute", "hour", "day", "month", "year");
var $d77b025aa58d633c$var$numberFormatValidator = (0, $idDdm.attachDescription)((0, $idDdm.isValidNumberFormat), "a valid number format string");
var $d77b025aa58d633c$var$commonCrossLineLabelOptionsDefs = {
    enabled: (0, $idDdm.boolean),
    text: (0, $idDdm.string),
    padding: (0, $idDdm.number),
    ...(0, $idDdm.fontOptionsDef)
};
var $d77b025aa58d633c$var$commonCrossLineOptionsDefs = (0, $idDdm.attachDescription)({
    enabled: (0, $idDdm.boolean),
    type: (0, $idDdm.required)((0, $idDdm.union)("line", "range")),
    range: (0, $idDdm.and)((0, $idDdm.attachDescription)((_, { options: options })=>options.type === "range", "crossLine type to be 'range'"), (0, $idDdm.arrayOf)((0, $idDdm.defined)), (0, $idDdm.arrayLength)(2, 2)),
    value: (0, $idDdm.and)((0, $idDdm.attachDescription)((_, { options: options })=>options.type === "line", "crossLine type to be 'line'"), (0, $idDdm.defined)),
    label: $d77b025aa58d633c$var$commonCrossLineLabelOptionsDefs,
    fill: (0, $idDdm.string),
    fillOpacity: (0, $idDdm.ratio),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
}, "cross-line options");
var $d77b025aa58d633c$var$cartesianCrossLineOptionsDefs = {
    ...$d77b025aa58d633c$var$commonCrossLineOptionsDefs,
    label: {
        ...$d77b025aa58d633c$var$commonCrossLineLabelOptionsDefs,
        position: (0, $idDdm.union)("top", "left", "right", "bottom", "top-left", "top-right", "bottom-left", "bottom-right", "inside", "inside-left", "inside-right", "inside-top", "inside-bottom", "inside-top-left", "inside-bottom-left", "inside-top-right", "inside-bottom-right"),
        rotation: (0, $idDdm.number)
    }
};
var $d77b025aa58d633c$var$commonAxisLabelOptionsDefs = {
    enabled: (0, $idDdm.boolean),
    rotation: (0, $idDdm.number),
    avoidCollisions: (0, $idDdm.boolean),
    minSpacing: (0, $idDdm.positiveNumber),
    spacing: (0, $idDdm.positiveNumber),
    formatter: (0, $idDdm.callback),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fontOptionsDef),
        spacing: (0, $idDdm.number)
    }),
    ...(0, $idDdm.fontOptionsDef)
};
var $d77b025aa58d633c$var$cartesianAxisLabelOptionsDefs = {
    autoRotate: (0, $idDdm.boolean),
    autoRotateAngle: (0, $idDdm.number),
    ...$d77b025aa58d633c$var$commonAxisLabelOptionsDefs
};
var $d77b025aa58d633c$var$cartesianNumericAxisLabel = {
    format: $d77b025aa58d633c$var$numberFormatValidator,
    ...$d77b025aa58d633c$var$cartesianAxisLabelOptionsDefs
};
var $d77b025aa58d633c$var$cartesianTimeAxisLabel = {
    format: (0, $idDdm.or)((0, $idDdm.string), (0, $idDdm.object)),
    ...$d77b025aa58d633c$var$cartesianAxisLabelOptionsDefs
};
var $d77b025aa58d633c$var$cartesianAxisTick = {
    enabled: (0, $idDdm.boolean),
    width: (0, $idDdm.positiveNumber),
    size: (0, $idDdm.positiveNumber),
    stroke: (0, $idDdm.color)
};
var $d77b025aa58d633c$var$cartesianTimeAxisParentLevel = {
    enabled: (0, $idDdm.boolean),
    label: $d77b025aa58d633c$var$cartesianTimeAxisLabel,
    tick: $d77b025aa58d633c$var$cartesianAxisTick
};
var $d77b025aa58d633c$var$commonAxisOptionsDefs = {
    reverse: (0, $idDdm.boolean),
    gridLine: {
        enabled: (0, $idDdm.boolean),
        width: (0, $idDdm.positiveNumber),
        style: (0, $idDdm.arrayOfDefs)({
            stroke: (0, $idDdm.or)((0, $idDdm.color), (0, $idDdm.themeOperator)),
            lineDash: (0, $idDdm.arrayOf)((0, $idDdm.positiveNumber))
        }, "a grid-line style object array")
    },
    interval: {
        values: (0, $idDdm.arrayOf)((0, $idDdm.defined)),
        minSpacing: (0, $idDdm.positiveNumber)
    },
    label: $d77b025aa58d633c$var$commonAxisLabelOptionsDefs,
    line: {
        enabled: (0, $idDdm.boolean),
        width: (0, $idDdm.positiveNumber),
        stroke: (0, $idDdm.color)
    },
    tick: $d77b025aa58d633c$var$cartesianAxisTick
};
$d77b025aa58d633c$var$commonAxisOptionsDefs.context = (0, $idDdm.undocumented)(()=>true);
$d77b025aa58d633c$var$commonAxisOptionsDefs.layoutConstraints = (0, $idDdm.undocumented)({
    stacked: (0, $idDdm.required)((0, $idDdm.boolean)),
    align: (0, $idDdm.required)((0, $idDdm.union)("start", "end")),
    unit: (0, $idDdm.required)((0, $idDdm.union)("percent", "px")),
    width: (0, $idDdm.required)((0, $idDdm.positiveNumber))
});
var $d77b025aa58d633c$var$cartesianAxisOptionsDefs = {
    ...$d77b025aa58d633c$var$commonAxisOptionsDefs,
    keys: (0, $idDdm.arrayOf)((0, $idDdm.string)),
    crossLines: (0, $idDdm.arrayOfDefs)($d77b025aa58d633c$var$cartesianCrossLineOptionsDefs, "a cross-line options array"),
    position: (0, $idDdm.union)("top", "right", "bottom", "left"),
    thickness: (0, $idDdm.positiveNumber),
    title: {
        enabled: (0, $idDdm.boolean),
        text: (0, $idDdm.string),
        spacing: (0, $idDdm.positiveNumber),
        formatter: (0, $idDdm.callback),
        ...(0, $idDdm.fontOptionsDef)
    }
};
$d77b025aa58d633c$var$cartesianAxisOptionsDefs.title._enabledFromTheme = (0, $idDdm.undocumented)((0, $idDdm.boolean));
function $d77b025aa58d633c$var$cartesianAxisCrosshairOptions(canFormat) {
    const crosshairLabel = {
        enabled: (0, $idDdm.boolean),
        xOffset: (0, $idDdm.number),
        yOffset: (0, $idDdm.number),
        renderer: (0, $idDdm.callbackOf)((0, $idDdm.or)((0, $idDdm.string), (0, $idDdm.optionsDefs)({
            text: (0, $idDdm.string),
            color: $idDdm.color,
            backgroundColor: (0, $idDdm.color),
            opacity: (0, $idDdm.ratio)
        }, "crosshair label renderer result object")))
    };
    if (canFormat) crosshairLabel.format = (0, $idDdm.string);
    return {
        enabled: (0, $idDdm.boolean),
        snap: (0, $idDdm.boolean),
        label: crosshairLabel,
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    };
}
function $d77b025aa58d633c$var$continuousAxisOptions(validDatum, supportTimeInterval) {
    return {
        min: (0, $idDdm.and)(validDatum, (0, $idDdm.lessThan)("max")),
        max: (0, $idDdm.and)(validDatum, (0, $idDdm.greaterThan)("min")),
        nice: (0, $idDdm.boolean),
        interval: {
            step: supportTimeInterval ? (0, $idDdm.or)((0, $idDdm.positiveNumberNonZero), $d77b025aa58d633c$var$timeIntervalUnit, (0, $idDdm.instanceOf)($d77b025aa58d633c$var$TimeInterval)) : (0, $idDdm.positiveNumberNonZero),
            values: (0, $idDdm.arrayOf)(validDatum),
            minSpacing: (0, $idDdm.and)((0, $idDdm.positiveNumber), (0, $idDdm.lessThan)("maxSpacing")),
            maxSpacing: (0, $idDdm.and)((0, $idDdm.positiveNumber), (0, $idDdm.greaterThan)("minSpacing"))
        }
    };
}
// packages/ag-charts-community/src/chart/commonOptionsDefs.ts
var $d77b025aa58d633c$var$shapeValidator = (0, $idDdm.or)((0, $idDdm.union)("circle", "cross", "diamond", "heart", "plus", "pin", "square", "star", "triangle"), (0, $idDdm.callback));
var $d77b025aa58d633c$var$textWrapValidator = (0, $idDdm.union)("never", "always", "hyphenate", "on-space");
var $d77b025aa58d633c$var$tooltipPlacementValidator = (0, $idDdm.union)("top", "right", "bottom", "left", "top-right", "bottom-right", "bottom-left", "top-left", "center");
var $d77b025aa58d633c$var$tooltipDeprecatedTypeValidator = (0, $idDdm.union)("pointer", "node", "top", "right", "bottom", "left", "top-left", "top-right", "bottom-left", "bottom-right");
var $d77b025aa58d633c$var$rangeValidator2 = (0, $idDdm.or)((0, $idDdm.positiveNumber), (0, $idDdm.union)("exact", "nearest"));
var $d77b025aa58d633c$var$zoomAnchorPoint = (0, $idDdm.union)("pointer", "start", "middle", "end");
var $d77b025aa58d633c$var$chartCaptionOptionsDefs = {
    enabled: (0, $idDdm.boolean),
    text: (0, $idDdm.string),
    textAlign: (0, $idDdm.union)("left", "center", "right"),
    wrapping: (0, $idDdm.union)("never", "always", "hyphenate", "on-space"),
    spacing: (0, $idDdm.positiveNumber),
    maxWidth: (0, $idDdm.positiveNumber),
    maxHeight: (0, $idDdm.positiveNumber),
    ...(0, $idDdm.fontOptionsDef)
};
$d77b025aa58d633c$var$chartCaptionOptionsDefs.padding = (0, $idDdm.undocumented)((0, $idDdm.positiveNumber));
var $d77b025aa58d633c$var$chartOverlayOptionsDefs = {
    enabled: (0, $idDdm.boolean),
    text: (0, $idDdm.string),
    renderer: (0, $idDdm.callbackOf)((0, $idDdm.or)((0, $idDdm.string), (0, $idDdm.htmlElement)))
};
var $d77b025aa58d633c$var$contextMenuItemLiterals = [
    "defaults",
    "download",
    "zoom-to-cursor",
    "pan-to-cursor",
    "toggle-series-visibility",
    "toggle-other-series",
    "separator"
];
var $d77b025aa58d633c$var$contextMenuItemObjectDef = {
    type: (0, $idDdm.union)("action", "separator"),
    showOn: (0, $idDdm.union)("always", "series-area", "series-node", "legend-item"),
    label: (0, $idDdm.required)((0, $idDdm.string)),
    enabled: (0, $idDdm.boolean),
    action: (0, $idDdm.callback),
    items: (value, context)=>$d77b025aa58d633c$var$contextMenuItemsArray(value, context)
};
$d77b025aa58d633c$var$contextMenuItemObjectDef.iconUrl = (0, $idDdm.undocumented)((0, $idDdm.string));
var $d77b025aa58d633c$var$contextMenuItemObjectValidator = (0, $idDdm.optionsDefs)($d77b025aa58d633c$var$contextMenuItemObjectDef);
var $d77b025aa58d633c$var$contextMenuItemValidator = (0, $idDdm.attachDescription)((value, context)=>{
    let result;
    if (typeof value === "string") {
        const allowedValues = $d77b025aa58d633c$var$contextMenuItemLiterals;
        if (allowedValues.includes(value)) result = true;
        else {
            result = {
                valid: false,
                invalid: [],
                cleared: null
            };
            result.invalid.push(new (0, $idDdm.ValidationError)((0, $idDdm.ErrorType).Invalid, `a context menu item string alias: ["${$d77b025aa58d633c$var$contextMenuItemLiterals.join('", "')}"]`, value, context.path));
        }
    } else result = $d77b025aa58d633c$var$contextMenuItemObjectValidator(value, context);
    return result;
}, `a context menu item object or string alias: [${$d77b025aa58d633c$var$contextMenuItemLiterals.join(", ")}]`);
var $d77b025aa58d633c$var$contextMenuItemsArray = (0, $idDdm.arrayOf)($d77b025aa58d633c$var$contextMenuItemValidator, "a menu items array", false);
var $d77b025aa58d633c$var$contextMenuActionsArray = (0, $idDdm.arrayOfDefs)({
    label: (0, $idDdm.required)((0, $idDdm.string)),
    action: (0, $idDdm.required)((0, $idDdm.callback))
}, "a context menu actions array");
var $d77b025aa58d633c$var$toolbarButtonOptionsDefs = {
    label: (0, $idDdm.string),
    ariaLabel: (0, $idDdm.string),
    tooltip: (0, $idDdm.string),
    icon: (0, $idDdm.union)("align-center", "align-left", "align-right", "arrow-drawing", "arrow-down-drawing", "arrow-up-drawing", "callout-annotation", "candlestick-series", "close", "comment-annotation", "date-range-drawing", "date-price-range-drawing", "delete", "disjoint-channel-drawing", "drag-handle", "fill-color", "line-style-solid", "line-style-dashed", "line-style-dotted", "high-low-series", "hlc-series", "hollow-candlestick-series", "horizontal-line-drawing", "line-color", "line-series", "line-with-markers-series", "locked", "measurer-drawing", "note-annotation", "ohlc-series", "pan-end", "pan-left", "pan-right", "pan-start", "parallel-channel-drawing", "position-bottom", "position-center", "position-top", "price-label-annotation", "price-range-drawing", "reset", "settings", "step-line-series", "text-annotation", "trend-line-drawing", "fibonacci-retracement-drawing", "fibonacci-retracement-trend-based-drawing", "unlocked", "vertical-line-drawing", "zoom-in", "zoom-out")
};
var $d77b025aa58d633c$var$commonChartOptionsDefs = {
    width: (0, $idDdm.positiveNumber),
    height: (0, $idDdm.positiveNumber),
    minWidth: (0, $idDdm.positiveNumber),
    minHeight: (0, $idDdm.positiveNumber),
    suppressFieldDotNotation: (0, $idDdm.boolean),
    title: $d77b025aa58d633c$var$chartCaptionOptionsDefs,
    subtitle: $d77b025aa58d633c$var$chartCaptionOptionsDefs,
    footnote: $d77b025aa58d633c$var$chartCaptionOptionsDefs,
    padding: {
        top: (0, $idDdm.positiveNumber),
        right: (0, $idDdm.positiveNumber),
        bottom: (0, $idDdm.positiveNumber),
        left: (0, $idDdm.positiveNumber)
    },
    seriesArea: {
        clip: (0, $idDdm.boolean),
        padding: {
            top: (0, $idDdm.positiveNumber),
            right: (0, $idDdm.positiveNumber),
            bottom: (0, $idDdm.positiveNumber),
            left: (0, $idDdm.positiveNumber)
        }
    },
    legend: {
        enabled: (0, $idDdm.boolean),
        position: (0, $idDdm.union)("top", "right", "bottom", "left"),
        orientation: (0, $idDdm.union)("horizontal", "vertical"),
        maxWidth: (0, $idDdm.positiveNumber),
        maxHeight: (0, $idDdm.positiveNumber),
        spacing: (0, $idDdm.positiveNumber),
        preventHidingAll: (0, $idDdm.boolean),
        reverseOrder: (0, $idDdm.boolean),
        toggleSeries: (0, $idDdm.boolean),
        item: {
            marker: {
                size: (0, $idDdm.positiveNumber),
                shape: $d77b025aa58d633c$var$shapeValidator,
                padding: (0, $idDdm.positiveNumber),
                strokeWidth: (0, $idDdm.positiveNumber)
            },
            line: {
                length: (0, $idDdm.positiveNumber),
                strokeWidth: (0, $idDdm.positiveNumber)
            },
            label: {
                maxLength: (0, $idDdm.positiveNumber),
                formatter: (0, $idDdm.callback),
                ...(0, $idDdm.fontOptionsDef)
            },
            maxWidth: (0, $idDdm.positiveNumber),
            paddingX: (0, $idDdm.positiveNumber),
            paddingY: (0, $idDdm.positiveNumber),
            showSeriesStroke: (0, $idDdm.boolean)
        },
        pagination: {
            marker: {
                size: (0, $idDdm.positiveNumber),
                shape: $d77b025aa58d633c$var$shapeValidator,
                padding: (0, $idDdm.positiveNumber)
            },
            activeStyle: {
                ...(0, $idDdm.fillOptionsDef),
                ...(0, $idDdm.strokeOptionsDef)
            },
            inactiveStyle: {
                ...(0, $idDdm.fillOptionsDef),
                ...(0, $idDdm.strokeOptionsDef)
            },
            highlightStyle: {
                ...(0, $idDdm.fillOptionsDef),
                ...(0, $idDdm.strokeOptionsDef)
            },
            label: (0, $idDdm.fontOptionsDef)
        },
        listeners: {
            legendItemClick: (0, $idDdm.callback),
            legendItemDoubleClick: (0, $idDdm.callback)
        }
    },
    gradientLegend: {
        enabled: (0, $idDdm.boolean),
        position: (0, $idDdm.union)("top", "right", "bottom", "left"),
        spacing: (0, $idDdm.positiveNumber),
        reverseOrder: (0, $idDdm.boolean),
        gradient: {
            preferredLength: (0, $idDdm.positiveNumber),
            thickness: (0, $idDdm.positiveNumber)
        },
        scale: {
            label: {
                ...(0, $idDdm.fontOptionsDef),
                format: $d77b025aa58d633c$var$numberFormatValidator,
                formatter: (0, $idDdm.callback)
            },
            padding: (0, $idDdm.positiveNumber),
            interval: {
                step: (0, $idDdm.number),
                values: (0, $idDdm.array),
                minSpacing: (0, $idDdm.and)((0, $idDdm.positiveNumber), (0, $idDdm.lessThan)("maxSpacing")),
                maxSpacing: (0, $idDdm.and)((0, $idDdm.positiveNumber), (0, $idDdm.greaterThan)("minSpacing"))
            }
        }
    },
    listeners: {
        seriesNodeClick: (0, $idDdm.callback),
        seriesNodeDoubleClick: (0, $idDdm.callback),
        seriesVisibilityChange: (0, $idDdm.callback),
        click: (0, $idDdm.callback),
        doubleClick: (0, $idDdm.callback),
        annotations: (0, $idDdm.callback),
        zoom: (0, $idDdm.callback)
    },
    loadGoogleFonts: (0, $idDdm.boolean),
    highlight: {
        range: (0, $idDdm.union)("tooltip", "node")
    },
    overlays: {
        loading: $d77b025aa58d633c$var$chartOverlayOptionsDefs,
        noData: $d77b025aa58d633c$var$chartOverlayOptionsDefs,
        noVisibleSeries: $d77b025aa58d633c$var$chartOverlayOptionsDefs,
        unsupportedBrowser: $d77b025aa58d633c$var$chartOverlayOptionsDefs
    },
    tooltip: {
        enabled: (0, $idDdm.boolean),
        showArrow: (0, $idDdm.boolean),
        pagination: (0, $idDdm.boolean),
        delay: (0, $idDdm.positiveNumber),
        range: $d77b025aa58d633c$var$rangeValidator2,
        wrapping: $d77b025aa58d633c$var$textWrapValidator,
        mode: (0, $idDdm.union)("single", "shared", "compact"),
        position: {
            type: $d77b025aa58d633c$var$tooltipDeprecatedTypeValidator,
            anchorTo: (0, $idDdm.union)("pointer", "node", "chart"),
            placement: (0, $idDdm.or)($d77b025aa58d633c$var$tooltipPlacementValidator, (0, $idDdm.arrayOf)($d77b025aa58d633c$var$tooltipPlacementValidator)),
            xOffset: (0, $idDdm.number),
            yOffset: (0, $idDdm.number)
        }
    },
    animation: {
        enabled: (0, $idDdm.boolean),
        duration: (0, $idDdm.positiveNumber)
    },
    contextMenu: {
        enabled: (0, $idDdm.boolean),
        items: $d77b025aa58d633c$var$contextMenuItemsArray,
        extraActions: $d77b025aa58d633c$var$contextMenuActionsArray,
        extraSeriesAreaActions: $d77b025aa58d633c$var$contextMenuActionsArray,
        extraNodeActions: $d77b025aa58d633c$var$contextMenuActionsArray,
        extraLegendItemActions: $d77b025aa58d633c$var$contextMenuActionsArray
    },
    dataSource: {
        getData: (0, $idDdm.callback)
    },
    keyboard: {
        enabled: (0, $idDdm.boolean),
        tabIndex: (0, $idDdm.number)
    },
    touch: {
        dragAction: (0, $idDdm.union)("none", "drag", "hover")
    },
    ranges: {
        enabled: (0, $idDdm.boolean),
        buttons: (0, $idDdm.arrayOfDefs)({
            ...$d77b025aa58d633c$var$toolbarButtonOptionsDefs,
            value: (0, $idDdm.or)((0, $idDdm.number), (0, $idDdm.and)((0, $idDdm.arrayOf)((0, $idDdm.or)((0, $idDdm.number), (0, $idDdm.date))), (0, $idDdm.arrayLength)(2, 2)), (0, $idDdm.callback))
        }, "range button options array")
    },
    // modules
    locale: {
        localeText: (0, $idDdm.object),
        getLocaleText: (0, $idDdm.callbackOf)((0, $idDdm.string))
    },
    background: {
        visible: (0, $idDdm.boolean),
        fill: (0, $idDdm.color),
        // enterprise
        image: {
            url: (0, $idDdm.required)((0, $idDdm.string)),
            top: (0, $idDdm.number),
            right: (0, $idDdm.number),
            bottom: (0, $idDdm.number),
            left: (0, $idDdm.number),
            width: (0, $idDdm.positiveNumber),
            height: (0, $idDdm.positiveNumber),
            opacity: (0, $idDdm.ratio)
        }
    },
    styleNonce: (0, $idDdm.string),
    sync: {
        enabled: (0, $idDdm.boolean),
        groupId: (0, $idDdm.string),
        axes: (0, $idDdm.union)("x", "y", "xy"),
        nodeInteraction: (0, $idDdm.boolean),
        zoom: (0, $idDdm.boolean)
    },
    zoom: {
        enabled: (0, $idDdm.boolean),
        enableAxisDragging: (0, $idDdm.boolean),
        enableDoubleClickToReset: (0, $idDdm.boolean),
        enablePanning: (0, $idDdm.boolean),
        enableScrolling: (0, $idDdm.boolean),
        enableSelecting: (0, $idDdm.boolean),
        enableTwoFingerZoom: (0, $idDdm.boolean),
        keepAspectRatio: (0, $idDdm.boolean),
        anchorPointX: $d77b025aa58d633c$var$zoomAnchorPoint,
        anchorPointY: $d77b025aa58d633c$var$zoomAnchorPoint,
        axes: (0, $idDdm.union)("x", "y", "xy"),
        deceleration: (0, $idDdm.or)((0, $idDdm.union)("off", "short", "long"), (0, $idDdm.ratio)),
        minVisibleItems: (0, $idDdm.positiveNumber),
        minVisibleItemsX: (0, $idDdm.positiveNumber),
        minVisibleItemsY: (0, $idDdm.positiveNumber),
        panKey: (0, $idDdm.union)("alt", "ctrl", "meta", "shift"),
        scrollingStep: (0, $idDdm.ratio),
        autoScaling: {
            enabled: (0, $idDdm.boolean),
            padding: (0, $idDdm.ratio)
        },
        buttons: {
            enabled: (0, $idDdm.boolean),
            buttons: (0, $idDdm.arrayOfDefs)({
                ...$d77b025aa58d633c$var$toolbarButtonOptionsDefs,
                value: (0, $idDdm.union)("reset", "zoom-in", "zoom-out", "pan-left", "pan-right", "pan-start", "pan-end"),
                section: (0, $idDdm.string)
            }, "zoom button options array"),
            visible: (0, $idDdm.union)("always", "zoomed", "hover")
        }
    }
};
$d77b025aa58d633c$var$commonChartOptionsDefs.dataSource.requestThrottle = (0, $idDdm.undocumented)((0, $idDdm.positiveNumber));
$d77b025aa58d633c$var$commonChartOptionsDefs.dataSource.updateThrottle = (0, $idDdm.undocumented)((0, $idDdm.positiveNumber));
$d77b025aa58d633c$var$commonChartOptionsDefs.dataSource.updateDuringInteraction = (0, $idDdm.undocumented)((0, $idDdm.boolean));
$d77b025aa58d633c$var$commonChartOptionsDefs.zoom.enableIndependentAxes = (0, $idDdm.undocumented)((0, $idDdm.boolean));
$d77b025aa58d633c$var$commonChartOptionsDefs.statusBar = (0, $idDdm.undocumented)((0, $idDdm.defined));
$d77b025aa58d633c$var$commonChartOptionsDefs.foreground = (0, $idDdm.undocumented)({
    visible: (0, $idDdm.boolean),
    text: (0, $idDdm.string),
    image: {
        url: (0, $idDdm.string),
        top: (0, $idDdm.number),
        right: (0, $idDdm.number),
        bottom: (0, $idDdm.number),
        left: (0, $idDdm.number),
        width: (0, $idDdm.positiveNumber),
        height: (0, $idDdm.positiveNumber),
        opacity: (0, $idDdm.ratio)
    },
    ...(0, $idDdm.fillOptionsDef)
});
$d77b025aa58d633c$var$commonChartOptionsDefs.context = (0, $idDdm.undocumented)(()=>true);
$d77b025aa58d633c$var$commonChartOptionsDefs.overrideDevicePixelRatio = (0, $idDdm.undocumented)((0, $idDdm.number));
$d77b025aa58d633c$var$commonChartOptionsDefs.sync.domainMode = (0, $idDdm.undocumented)((0, $idDdm.union)("direction", "position", "key"));
var $d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs = {
    cursor: (0, $idDdm.string),
    showInLegend: (0, $idDdm.boolean),
    nodeClickRange: $d77b025aa58d633c$var$rangeValidator2,
    listeners: {
        nodeClick: (0, $idDdm.callback),
        nodeDoubleClick: (0, $idDdm.callback)
    },
    highlightStyle: {
        item: {
            ...(0, $idDdm.fillOptionsDef),
            ...(0, $idDdm.strokeOptionsDef)
        },
        series: {
            enabled: (0, $idDdm.boolean),
            dimOpacity: (0, $idDdm.ratio),
            strokeWidth: (0, $idDdm.positiveNumber)
        }
    }
};
var $d77b025aa58d633c$var$commonSeriesOptionsDefs = {
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    id: (0, $idDdm.string),
    visible: (0, $idDdm.boolean),
    data: (0, $idDdm.array)
};
$d77b025aa58d633c$var$commonSeriesOptionsDefs.context = (0, $idDdm.undocumented)(()=>true);
$d77b025aa58d633c$var$commonSeriesOptionsDefs.seriesGrouping = (0, $idDdm.undocumented)((0, $idDdm.defined));
$d77b025aa58d633c$var$commonSeriesOptionsDefs.highlight = (0, $idDdm.undocumented)({
    enabled: (0, $idDdm.boolean)
});
var $d77b025aa58d633c$var$markerOptionsDefs = {
    enabled: (0, $idDdm.boolean),
    shape: $d77b025aa58d633c$var$shapeValidator,
    size: (0, $idDdm.positiveNumber),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef),
        shape: $d77b025aa58d633c$var$shapeValidator,
        size: (0, $idDdm.positiveNumber)
    }),
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$seriesLabelOptionsDefs = {
    enabled: (0, $idDdm.boolean),
    formatter: (0, $idDdm.callback),
    ...(0, $idDdm.fontOptionsDef)
};
var $d77b025aa58d633c$var$autoSizedLabelOptionsDefs = {
    ...$d77b025aa58d633c$var$seriesLabelOptionsDefs,
    lineHeight: (0, $idDdm.positiveNumber),
    minimumFontSize: (0, $idDdm.positiveNumber),
    wrapping: $d77b025aa58d633c$var$textWrapValidator,
    overflowStrategy: (0, $idDdm.union)("ellipsis", "hide")
};
var $d77b025aa58d633c$var$errorBarThemeableOptionsDefs = {
    visible: (0, $idDdm.boolean),
    cap: {
        visible: (0, $idDdm.boolean),
        length: (0, $idDdm.positiveNumber),
        lengthRatio: (0, $idDdm.ratio),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    },
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$errorBarOptionsDefs = {
    ...$d77b025aa58d633c$var$errorBarThemeableOptionsDefs,
    xLowerKey: (0, $idDdm.string),
    xUpperKey: (0, $idDdm.string),
    yLowerKey: (0, $idDdm.string),
    yUpperKey: (0, $idDdm.string),
    xLowerName: (0, $idDdm.string),
    xUpperName: (0, $idDdm.string),
    yLowerName: (0, $idDdm.string),
    yUpperName: (0, $idDdm.string),
    itemStyler: (0, $idDdm.callbackDefs)({
        visible: (0, $idDdm.boolean),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef),
        cap: {
            visible: (0, $idDdm.boolean),
            length: (0, $idDdm.positiveNumber),
            lengthRatio: (0, $idDdm.ratio),
            ...(0, $idDdm.strokeOptionsDef),
            ...(0, $idDdm.lineDashOptionsDef)
        }
    })
};
var $d77b025aa58d633c$var$tooltipOptionsDefs = {
    enabled: (0, $idDdm.boolean),
    showArrow: (0, $idDdm.boolean),
    range: $d77b025aa58d633c$var$rangeValidator2,
    renderer: (0, $idDdm.callbackOf)((0, $idDdm.or)((0, $idDdm.string), (0, $idDdm.optionsDefs)({
        heading: (0, $idDdm.string),
        title: (0, $idDdm.string),
        data: (0, $idDdm.arrayOfDefs)({
            label: (0, $idDdm.required)((0, $idDdm.string)),
            value: (0, $idDdm.required)((0, $idDdm.string))
        })
    }, "tooltip renderer result object"))),
    position: {
        type: $d77b025aa58d633c$var$tooltipDeprecatedTypeValidator,
        anchorTo: (0, $idDdm.union)("node", "pointer", "chart"),
        placement: (0, $idDdm.or)($d77b025aa58d633c$var$tooltipPlacementValidator, (0, $idDdm.arrayOf)($d77b025aa58d633c$var$tooltipPlacementValidator)),
        xOffset: (0, $idDdm.number),
        yOffset: (0, $idDdm.number)
    },
    interaction: {
        enabled: (0, $idDdm.boolean)
    }
};
$d77b025aa58d633c$var$tooltipOptionsDefs.position._seriesOverrideType = (0, $idDdm.undocumented)($d77b025aa58d633c$var$tooltipDeprecatedTypeValidator);
var $d77b025aa58d633c$var$shadowOptionsDefs = {
    enabled: (0, $idDdm.boolean),
    xOffset: (0, $idDdm.number),
    yOffset: (0, $idDdm.number),
    blur: (0, $idDdm.positiveNumber),
    color: (0, $idDdm.color)
};
var $d77b025aa58d633c$var$interpolationOptionsDefs = (0, $idDdm.typeUnion)({
    linear: {},
    smooth: {
        tension: (0, $idDdm.ratio)
    },
    step: {
        position: (0, $idDdm.union)("start", "middle", "end")
    }
}, "interpolation line options");
// packages/ag-charts-community/src/chart/series/cartesian/areaSeriesOptionsDef.ts
var $d77b025aa58d633c$var$areaSeriesThemeableOptionsDef = {
    showInMiniChart: (0, $idDdm.boolean),
    connectMissingData: (0, $idDdm.boolean),
    interpolation: $d77b025aa58d633c$var$interpolationOptionsDefs,
    label: $d77b025aa58d633c$var$seriesLabelOptionsDefs,
    marker: $d77b025aa58d633c$var$markerOptionsDefs,
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    shadow: $d77b025aa58d633c$var$shadowOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$areaSeriesOptionsDef = {
    ...$d77b025aa58d633c$var$areaSeriesThemeableOptionsDef,
    ...$d77b025aa58d633c$var$commonSeriesOptionsDefs,
    type: (0, $idDdm.required)((0, $idDdm.constant)("area")),
    xKey: (0, $idDdm.required)((0, $idDdm.string)),
    yKey: (0, $idDdm.required)((0, $idDdm.string)),
    xName: (0, $idDdm.string),
    yName: (0, $idDdm.string),
    stacked: (0, $idDdm.boolean),
    stackGroup: (0, $idDdm.string),
    normalizedTo: (0, $idDdm.number)
};
// packages/ag-charts-community/src/chart/series/cartesian/areaSeriesModule.ts
var $d77b025aa58d633c$var$AreaSeriesModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "community",
    chartTypes: [
        "cartesian"
    ],
    identifier: "area",
    moduleFactory: (ctx)=>new $d77b025aa58d633c$var$AreaSeries(ctx),
    stackable: true,
    tooltipDefaults: {
        range: "nearest"
    },
    defaultAxes: [
        {
            type: "number" /* NUMBER */ ,
            position: "left" /* LEFT */ 
        },
        {
            type: "category" /* CATEGORY */ ,
            position: "bottom" /* BOTTOM */ 
        }
    ],
    themeTemplate: {
        series: {
            nodeClickRange: "nearest",
            // @ts-expect-error deprecated type field fallback value
            tooltip: {
                position: {
                    _seriesOverrideType: "node"
                }
            },
            fill: {
                $palette: "fill"
            },
            fillGradientDefaults: {
                type: "gradient",
                gradient: "linear",
                bounds: "item",
                colorStops: {
                    $palette: "gradient"
                },
                rotation: 0,
                reverse: false
            },
            fillPatternDefaults: $d77b025aa58d633c$var$FILL_PATTERN_DEFAULTS,
            fillImageDefaults: $d77b025aa58d633c$var$FILL_IMAGE_DEFAULTS,
            stroke: {
                $palette: "stroke"
            },
            fillOpacity: 0.8,
            strokeOpacity: 1,
            strokeWidth: 0,
            lineDash: [
                0
            ],
            lineDashOffset: 0,
            shadow: {
                enabled: false,
                color: $d77b025aa58d633c$var$DEFAULT_SHADOW_COLOUR,
                xOffset: 3,
                yOffset: 3,
                blur: 5
            },
            interpolation: {
                type: "linear"
            },
            marker: {
                enabled: false,
                shape: "circle",
                size: 7,
                strokeWidth: 0,
                fill: {
                    $palette: "fill"
                },
                stroke: {
                    $palette: "stroke"
                },
                // @ts-expect-error undocumented option
                fillGradientDefaults: {
                    type: "gradient",
                    gradient: "radial",
                    bounds: "item",
                    colorStops: {
                        $palette: "gradient"
                    },
                    rotation: 0,
                    reverse: true
                },
                fillPatternDefaults: $d77b025aa58d633c$var$FILL_PATTERN_DEFAULTS
            },
            label: {
                enabled: false,
                fontSize: {
                    $ref: "fontSize"
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontWeight: {
                    $ref: "fontWeight"
                },
                color: {
                    $ref: "textColor"
                }
            }
        }
    }
};
var $d77b025aa58d633c$var$NewAreaSeriesModule = {
    type: "series",
    name: "area",
    chartType: "cartesian",
    options: $d77b025aa58d633c$var$areaSeriesOptionsDef,
    create: (ctx)=>new $d77b025aa58d633c$var$AreaSeries(ctx)
};
function $d77b025aa58d633c$var$addHitTestersToQuadtree(quadtree, hitTesters) {
    for (const node of hitTesters){
        const datum = node.datum;
        if (datum === void 0) (0, $idDdm.Logger).error("undefined datum");
        else quadtree.addValue(node, datum);
    }
}
function $d77b025aa58d633c$var$findQuadtreeMatch(series, point) {
    const { x: x, y: y } = point;
    const { nearest: nearest, distanceSquared: distanceSquared2 } = series.getQuadTree().find(x, y);
    if (nearest !== void 0) return {
        datum: nearest.value,
        distance: Math.sqrt(distanceSquared2)
    };
    return void 0;
}
// packages/ag-charts-community/src/chart/series/cartesian/abstractBarSeries.ts
var $d77b025aa58d633c$var$AbstractBarSeriesProperties = class extends $d77b025aa58d633c$var$CartesianSeriesProperties {
    constructor(){
        super(...arguments);
        this.direction = "vertical";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$AbstractBarSeriesProperties.prototype, "direction", 2);
var $d77b025aa58d633c$var$AbstractBarSeries = class extends $d77b025aa58d633c$var$CartesianSeries {
    constructor(){
        super(...arguments);
        /**
     * Used to get the position of bars within each group.
     */ this.groupScale = new $d77b025aa58d633c$var$CategoryScale();
        this.smallestDataInterval = void 0;
        this.largestDataInterval = void 0;
    }
    padBandExtent(keys, alignStart) {
        const ratio11 = typeof alignStart === "boolean" ? 1 : 0.5;
        const scalePadding = (0, $idDdm.isFiniteNumber)(this.smallestDataInterval) ? this.smallestDataInterval * ratio11 : 0;
        const keysExtent = $d77b025aa58d633c$var$extent(keys) ?? [
            NaN,
            NaN
        ];
        if (typeof alignStart === "boolean") keysExtent[alignStart ? 0 : 1] -= (alignStart ? 1 : -1) * scalePadding;
        else {
            keysExtent[0] -= scalePadding;
            keysExtent[1] += scalePadding;
        }
        return $d77b025aa58d633c$var$fixNumericExtent(keysExtent);
    }
    getBandScalePadding() {
        return {
            inner: 0.3,
            outer: 0.15
        };
    }
    shouldFlipXY() {
        return !this.isVertical();
    }
    isVertical() {
        return this.properties.direction === "vertical";
    }
    getBarDirection() {
        return this.shouldFlipXY() ? "x" /* X */  : "y" /* Y */ ;
    }
    getCategoryDirection() {
        return this.shouldFlipXY() ? "y" /* Y */  : "x" /* X */ ;
    }
    getValueAxis() {
        const direction = this.getBarDirection();
        return this.axes[direction];
    }
    getCategoryAxis() {
        const direction = this.getCategoryDirection();
        return this.axes[direction];
    }
    getBandwidth(xAxis, minWidth) {
        return $d77b025aa58d633c$var$ContinuousScale.is(xAxis.scale) ? xAxis.scale.calcBandwidth(this.smallestDataInterval, minWidth) : xAxis.scale.bandwidth;
    }
    xCoordinateRange(xValue) {
        const xAxis = this.axes[this.getCategoryDirection()];
        const xScale = xAxis.scale;
        const bandWidth = this.getBandwidth(xAxis, 0) ?? 0;
        const barOffset = $d77b025aa58d633c$var$ContinuousScale.is(xScale) ? bandWidth * -0.5 : 0;
        const x = xScale.convert(xValue) + barOffset;
        return [
            x,
            x + bandWidth
        ];
    }
    yCoordinateRange(yValues) {
        const yAxis = this.axes[this.getBarDirection()];
        const yScale = yAxis.scale;
        const ys = yValues.map((yValue)=>yScale.convert(yValue));
        if (ys.length === 1) {
            const y0 = yScale.convert(0);
            return [
                Math.min(ys[0], y0),
                Math.max(ys[0], y0)
            ];
        }
        return [
            Math.min(...ys),
            Math.max(...ys)
        ];
    }
    updateGroupScale(xAxis) {
        const domain = [];
        const { groupScale: groupScale } = this;
        const xBandWidth = this.getBandwidth(xAxis);
        const { index: groupIndex, visibleGroupCount: visibleGroupCount } = this.ctx.seriesStateManager.getVisiblePeerGroupIndex(this);
        for(let groupIdx = 0; groupIdx < visibleGroupCount; groupIdx++)domain.push(String(groupIdx));
        groupScale.domain = domain;
        groupScale.range = [
            0,
            xBandWidth ?? 0
        ];
        if (xAxis instanceof $d77b025aa58d633c$var$GroupedCategoryAxis) groupScale.paddingInner = xAxis.groupPaddingInner;
        else if (xAxis instanceof $d77b025aa58d633c$var$CategoryAxis) {
            groupScale.paddingInner = xAxis.groupPaddingInner;
            groupScale.round = groupScale.padding !== 0;
        } else groupScale.padding = 0;
        const barWidth = groupScale.bandwidth >= 1 ? // Pixel-rounded value for low-volume bar charts.
        groupScale.bandwidth : // Handle high-volume bar charts gracefully.
        groupScale.rawBandwidth;
        return {
            barWidth: barWidth,
            groupIndex: groupIndex
        };
    }
    resolveKeyDirection(direction) {
        if (this.getBarDirection() === "x" /* X */ ) {
            if (direction === "x" /* X */ ) return "y" /* Y */ ;
            return "x" /* X */ ;
        }
        return direction;
    }
    initQuadTree(quadtree) {
        $d77b025aa58d633c$var$addHitTestersToQuadtree(quadtree, this.datumNodesIter());
    }
    pickNodeClosestDatum(point) {
        return $d77b025aa58d633c$var$findQuadtreeMatch(this, point);
    }
};
// packages/ag-charts-community/src/chart/series/cartesian/barSeriesProperties.ts
var $d77b025aa58d633c$var$BarSeriesLabel = class extends $d77b025aa58d633c$var$Label {
    constructor(){
        super(...arguments);
        this.placement = "inside-center";
        this.padding = 0;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesLabel.prototype, "placement", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesLabel.prototype, "padding", 2);
var $d77b025aa58d633c$var$BarSeriesProperties = class extends $d77b025aa58d633c$var$AbstractBarSeriesProperties {
    constructor(){
        super(...arguments);
        this.fill = "#c16068";
        this.fillGradientDefaults = new $d77b025aa58d633c$var$FillGradientDefaults();
        this.fillPatternDefaults = new $d77b025aa58d633c$var$FillPatternDefaults();
        this.fillImageDefaults = new $d77b025aa58d633c$var$FillImageDefaults();
        this.fillOpacity = 1;
        this.stroke = "#874349";
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.cornerRadius = 0;
        this.crisp = void 0;
        this.shadow = new $d77b025aa58d633c$var$DropShadow();
        this.label = new $d77b025aa58d633c$var$BarSeriesLabel();
        this.tooltip = new $d77b025aa58d633c$var$SeriesTooltip();
        this.sparklineMode = false;
        this.fastDataProcessing = false;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "xKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "xName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "yKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "yName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "yFilterKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "stackGroup", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "normalizedTo", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "fillGradientDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "fillPatternDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "fillImageDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "cornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "crisp", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "itemStyler", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "shadow", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "tooltip", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "sparklineMode", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "fastDataProcessing", 2);
function $d77b025aa58d633c$var$checkCrisp(scale2, visibleRange, smallestDataInterval, largestDataInterval) {
    if (visibleRange != null) {
        const [visibleMin, visibleMax] = visibleRange;
        const isZoomed = visibleMin !== 0 || visibleMax !== 1;
        if (isZoomed) return false;
    }
    if ($d77b025aa58d633c$var$ContinuousScale.is(scale2)) {
        const spacing = scale2.calcBandwidth(largestDataInterval) - scale2.calcBandwidth(smallestDataInterval);
        if (spacing > 0 && spacing < 1) return false;
    }
    return true;
}
var $d77b025aa58d633c$var$isDatumNegative = (datum)=>{
    return (0, $idDdm.isNegative)(datum.yValue ?? 0);
};
function $d77b025aa58d633c$var$collapsedStartingBarPosition(isVertical, axes, mode) {
    const { startingX: startingX, startingY: startingY } = $d77b025aa58d633c$var$getStartingValues(isVertical, axes);
    const calculate = (datum, prevDatum)=>{
        let x = isVertical ? datum.x : startingX;
        let y = isVertical ? startingY : datum.y;
        let width2 = isVertical ? datum.width : 0;
        let height2 = isVertical ? 0 : datum.height;
        const { opacity: opacity = 1 } = datum;
        if (prevDatum && (isNaN(x) || isNaN(y))) {
            ({ x: x, y: y } = prevDatum);
            width2 = isVertical ? prevDatum.width : 0;
            height2 = isVertical ? 0 : prevDatum.height;
            if (isVertical && !$d77b025aa58d633c$var$isDatumNegative(prevDatum)) y += prevDatum.height;
            else if (!isVertical && $d77b025aa58d633c$var$isDatumNegative(prevDatum)) x += prevDatum.width;
        }
        let clipBBox;
        if (datum.clipBBox == null) clipBBox = void 0;
        else if ($d77b025aa58d633c$var$isDatumNegative(datum)) clipBBox = isVertical ? new $d77b025aa58d633c$var$BBox(x, y - height2, width2, height2) : new $d77b025aa58d633c$var$BBox(x - width2, y, width2, height2);
        else clipBBox = new $d77b025aa58d633c$var$BBox(x, y, width2, height2);
        return {
            x: x,
            y: y,
            width: width2,
            height: height2,
            clipBBox: clipBBox,
            opacity: opacity
        };
    };
    return {
        isVertical: isVertical,
        calculate: calculate,
        mode: mode
    };
}
function $d77b025aa58d633c$var$midpointStartingBarPosition(isVertical, mode) {
    return {
        isVertical: isVertical,
        calculate: (datum)=>{
            return {
                x: isVertical ? datum.x : datum.x + datum.width / 2,
                y: isVertical ? datum.y + datum.height / 2 : datum.y,
                width: isVertical ? datum.width : 0,
                height: isVertical ? 0 : datum.height,
                clipBBox: datum.clipBBox,
                opacity: datum.opacity ?? 1
            };
        },
        mode: mode
    };
}
function $d77b025aa58d633c$var$prepareBarAnimationFunctions(initPos) {
    const isRemoved = (datum)=>datum == null || isNaN(datum.x) || isNaN(datum.y);
    const fromFn = (rect, datum, status)=>{
        if (status === "updated" && isRemoved(datum)) status = "removed";
        else if (status === "updated" && isRemoved(rect.previousDatum)) status = "added";
        let source;
        if (status === "added" && rect.previousDatum == null && initPos.mode === "fade") source = {
            ...$d77b025aa58d633c$var$resetBarSelectionsFn(rect, datum),
            opacity: 0
        };
        else if (status === "unknown" || status === "added") source = initPos.calculate(datum, rect.previousDatum);
        else source = {
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            clipBBox: rect.clipBBox,
            opacity: rect.opacity ?? 1
        };
        const phase = $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[status];
        return {
            ...source,
            phase: phase
        };
    };
    const toFn = (rect, datum, status)=>{
        if (status === "removed" && rect.datum == null && initPos.mode === "fade") return {
            ...$d77b025aa58d633c$var$resetBarSelectionsFn(rect, datum),
            opacity: 0
        };
        else if (status === "removed" || isRemoved(datum)) return initPos.calculate(datum, rect.previousDatum);
        else return {
            x: datum.x,
            y: datum.y,
            width: datum.width,
            height: datum.height,
            clipBBox: datum.clipBBox,
            opacity: datum.opacity ?? 1
        };
    };
    const applyFn = (rect, datum, status)=>{
        rect.setProperties(datum);
        rect.crisp = status === "end" && (rect.datum?.crisp ?? false);
    };
    return {
        toFn: toFn,
        fromFn: fromFn,
        applyFn: applyFn
    };
}
function $d77b025aa58d633c$var$getStartingValues(isVertical, axes) {
    const axis = axes[isVertical ? "y" /* Y */  : "x" /* X */ ];
    let startingX = Infinity;
    let startingY = 0;
    if (!axis) return {
        startingX: startingX,
        startingY: startingY
    };
    if (isVertical) startingY = axis.scale.convert($d77b025aa58d633c$var$ContinuousScale.is(axis.scale) ? 0 : Math.max(...axis.range));
    else startingX = axis.scale.convert($d77b025aa58d633c$var$ContinuousScale.is(axis.scale) ? 0 : Math.min(...axis.range));
    return {
        startingX: startingX,
        startingY: startingY
    };
}
function $d77b025aa58d633c$var$resetBarSelectionsFn(rect, { x: x, y: y, width: width2, height: height2, clipBBox: clipBBox, opacity: opacity = 1 }) {
    return {
        x: x,
        y: y,
        width: width2,
        height: height2,
        clipBBox: clipBBox,
        opacity: opacity,
        crisp: rect.datum?.crisp ?? false
    };
}
function $d77b025aa58d633c$var$computeBarFocusBounds(series, datum) {
    if (datum === void 0) return void 0;
    const { x: x, y: y, width: width2, height: height2 } = datum;
    return $d77b025aa58d633c$var$Transformable.toCanvas(series.contentGroup, new $d77b025aa58d633c$var$BBox(x, y, width2, height2));
}
// packages/ag-charts-community/src/chart/series/cartesian/diffUtil.ts
function $d77b025aa58d633c$var$calculateDataDiff(seriesId, datumSelection, getDatumId, contextNodeData, previousContextNodeData, processedData) {
    let dataDiff = processedData?.reduced?.diff?.[seriesId];
    if (dataDiff?.changed) return dataDiff;
    const scalingChanged = $d77b025aa58d633c$var$hasScalingChanged(contextNodeData, previousContextNodeData);
    if (dataDiff == null && processedData?.reduced?.diff != null) {
        dataDiff = {
            changed: true,
            added: /* @__PURE__ */ new Set(),
            updated: /* @__PURE__ */ new Set(),
            removed: /* @__PURE__ */ new Set(),
            moved: /* @__PURE__ */ new Set()
        };
        if (scalingChanged) dataDiff.updated = new Set(Array.from(datumSelection, ({ datum: datum })=>getDatumId(datum)));
        else dataDiff.added = new Set(Array.from(datumSelection, ({ datum: datum })=>getDatumId(datum)));
    } else if (scalingChanged) dataDiff = {
        changed: true,
        added: /* @__PURE__ */ new Set(),
        updated: new Set(Array.from(datumSelection, ({ datum: datum })=>getDatumId(datum))),
        removed: /* @__PURE__ */ new Set(),
        moved: /* @__PURE__ */ new Set()
    };
    return dataDiff;
}
function $d77b025aa58d633c$var$isGroupScaleContext(ctx) {
    return typeof ctx === "object" && ctx !== null && "groupScale" in ctx;
}
function $d77b025aa58d633c$var$hasScalingChanged(contextNodeData, previousContextNodeData) {
    if (!previousContextNodeData) return false;
    const scales = contextNodeData.scales;
    const prevScales = previousContextNodeData.scales;
    if (!$d77b025aa58d633c$var$areScalingEqual(scales.x, prevScales.x)) return true;
    if (!$d77b025aa58d633c$var$areScalingEqual(scales.y, prevScales.y)) return true;
    if (!$d77b025aa58d633c$var$isGroupScaleContext(contextNodeData) || !$d77b025aa58d633c$var$isGroupScaleContext(previousContextNodeData)) return false;
    const groupScale = contextNodeData.groupScale;
    const prevGroupScale = previousContextNodeData.groupScale;
    return !$d77b025aa58d633c$var$areScalingEqual(groupScale, prevGroupScale);
}
// packages/ag-charts-community/src/chart/series/cartesian/labelUtil.ts
function $d77b025aa58d633c$var$updateLabelNode(textNode, label, labelDatum) {
    if (label.enabled && labelDatum) {
        const { x: x, y: y, text: text, textAlign: textAlign, textBaseline: textBaseline } = labelDatum;
        const { color: fill, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily } = label;
        textNode.setProperties({
            visible: true,
            x: x,
            y: y,
            text: text,
            fill: fill,
            fontStyle: fontStyle,
            fontWeight: fontWeight,
            fontSize: fontSize,
            fontFamily: fontFamily,
            textAlign: textAlign,
            textBaseline: textBaseline
        });
    } else textNode.visible = false;
}
var $d77b025aa58d633c$var$placements = {
    "inside-start": {
        inside: true,
        direction: -1,
        textAlignment: 1
    },
    "inside-end": {
        inside: true,
        direction: 1,
        textAlignment: -1
    },
    "outside-start": {
        inside: false,
        direction: -1,
        textAlignment: -1
    },
    "outside-end": {
        inside: false,
        direction: 1,
        textAlignment: 1
    }
};
function $d77b025aa58d633c$var$adjustLabelPlacement({ isUpward: isUpward, isVertical: isVertical, placement: placement, padding: padding = 0, rect: rect }) {
    let x = rect.x + rect.width / 2;
    let y = rect.y + rect.height / 2;
    let textAlign = "center";
    let textBaseline = "middle";
    if (placement !== "inside-center") {
        const barDirection = (isUpward ? 1 : -1) * (isVertical ? -1 : 1);
        const { direction: direction, textAlignment: textAlignment } = $d77b025aa58d633c$var$placements[placement];
        const displacementRatio = (direction + 1) * 0.5;
        if (isVertical) {
            const y0 = isUpward ? rect.y + rect.height : rect.y;
            const height2 = rect.height * barDirection;
            y = y0 + height2 * displacementRatio + padding * textAlignment * barDirection;
            textBaseline = textAlignment === barDirection ? "top" : "bottom";
        } else {
            const x0 = isUpward ? rect.x : rect.x + rect.width;
            const width2 = rect.width * barDirection;
            x = x0 + width2 * displacementRatio + padding * textAlignment * barDirection;
            textAlign = textAlignment === barDirection ? "left" : "right";
        }
    }
    return {
        x: x,
        y: y,
        textAlign: textAlign,
        textBaseline: textBaseline
    };
}
// packages/ag-charts-community/src/chart/series/cartesian/barSeries.ts
var $d77b025aa58d633c$var$X_MIN = 0;
var $d77b025aa58d633c$var$X_MAX = 1;
var $d77b025aa58d633c$var$Y_MIN = 2;
var $d77b025aa58d633c$var$Y_MAX = 3;
var $d77b025aa58d633c$var$SPAN2 = 4;
var $d77b025aa58d633c$var$BarSeries = class extends $d77b025aa58d633c$var$AbstractBarSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            directionKeys: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_KEYS,
            directionNames: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_NAMES,
            categoryKey: "xValue",
            pickModes: [
                2 /* AXIS_ALIGNED */ ,
                // Only used in sparklineMode
                1 /* NEAREST_NODE */ ,
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            pathsPerSeries: [],
            hasHighlightedLabels: true,
            datumSelectionGarbageCollection: false,
            animationAlwaysUpdateSelections: true,
            animationResetFns: {
                datum: $d77b025aa58d633c$var$resetBarSelectionsFn,
                label: $d77b025aa58d633c$var$resetLabelFn
            }
        });
        this.properties = new $d77b025aa58d633c$var$BarSeriesProperties();
        this.connectsToYAxis = true;
        this.dataAggregationFilters = void 0;
    }
    get pickModeAxis() {
        return this.properties.sparklineMode ? "main" : void 0;
    }
    crossFilteringEnabled() {
        return this.properties.yFilterKey != null && (this.seriesGrouping == null || this.seriesGrouping.stackIndex === 0);
    }
    async processData(dataController) {
        if (!this.data) return;
        const { xKey: xKey, yKey: yKey, yFilterKey: yFilterKey, normalizedTo: normalizedTo, fastDataProcessing: fastDataProcessing } = this.properties;
        const { seriesGrouping: { groupIndex: groupIndex = this.id } = {}, data: data } = this;
        const groupCount2 = this.seriesGrouping?.groupCount ?? 0;
        const stackCount = this.seriesGrouping?.stackCount ?? 0;
        const stacked = stackCount >= 1 || normalizedTo != null;
        const grouped = !fastDataProcessing || groupCount2 > 1 || stacked;
        const animationEnabled = !this.ctx.animationManager.isSkipped();
        const xScale = this.getCategoryAxis()?.scale;
        const yScale = this.getValueAxis()?.scale;
        const { isContinuousX: isContinuousX, xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
            xScale: xScale,
            yScale: yScale
        });
        const stackGroupName = `bar-stack-${groupIndex}-yValues`;
        const stackGroupTrailingName = `${stackGroupName}-trailing`;
        const visibleProps = this.visible ? {} : {
            forceValue: 0
        };
        const props = [
            $d77b025aa58d633c$var$keyProperty(xKey, xScaleType, {
                id: "xValue"
            }),
            $d77b025aa58d633c$var$valueProperty(yKey, yScaleType, {
                id: `yValue-raw`,
                invalidValue: null,
                ...visibleProps
            })
        ];
        if (this.crossFilteringEnabled()) props.push($d77b025aa58d633c$var$valueProperty(yFilterKey, yScaleType, {
            id: `yFilterValue`,
            invalidValue: null,
            ...visibleProps
        }));
        if (stacked) props.push(...$d77b025aa58d633c$var$groupAccumulativeValueProperty(yKey, "normal", "current", {
            id: `yValue-end`,
            rangeId: `yValue-range`,
            invalidValue: null,
            missingValue: 0,
            groupId: stackGroupName,
            separateNegative: true,
            ...visibleProps
        }, yScaleType), ...$d77b025aa58d633c$var$groupAccumulativeValueProperty(yKey, "trailing", "current", {
            id: `yValue-start`,
            invalidValue: null,
            missingValue: 0,
            groupId: stackGroupTrailingName,
            separateNegative: true,
            ...visibleProps
        }, yScaleType));
        if (isContinuousX) props.push($d77b025aa58d633c$var$SMALLEST_KEY_INTERVAL, $d77b025aa58d633c$var$LARGEST_KEY_INTERVAL);
        if ((0, $idDdm.isFiniteNumber)(normalizedTo)) props.push($d77b025aa58d633c$var$normaliseGroupTo([
            stackGroupName,
            stackGroupTrailingName
        ], Math.abs(normalizedTo)));
        if (animationEnabled && this.processedData) props.push($d77b025aa58d633c$var$diff(this.id, this.processedData));
        if (animationEnabled || !grouped) props.push($d77b025aa58d633c$var$animationValidation());
        const { dataModel: dataModel, processedData: processedData } = await this.requestDataModel(dataController, data, {
            props: props,
            groupByKeys: grouped,
            groupByData: !grouped
        });
        this.dataAggregationFilters = this.aggregateData(dataModel, processedData);
        this.smallestDataInterval = processedData.reduced?.smallestKeyInterval;
        this.largestDataInterval = processedData.reduced?.largestKeyInterval;
        this.animationState.transition("updateData");
    }
    getSeriesDomain(direction) {
        const { processedData: processedData, dataModel: dataModel } = this;
        if (dataModel == null || processedData == null) return [];
        if (direction === this.getCategoryDirection()) {
            const keyDef = dataModel.resolveProcessedDataDefById(this, `xValue`);
            const keys = dataModel.getDomain(this, `xValue`, "key", processedData);
            if (keyDef?.def.type === "key" && keyDef.def.valueType === "category") return keys;
            return this.padBandExtent(keys);
        }
        const yKey = this.dataModel?.hasColumnById(this, `yValue-end`) ? "yValue-end" : "yValue-raw";
        let yExtent = this.domainForClippedRange(direction, [
            yKey
        ], "xValue", true);
        const yFilterExtent = this.crossFilteringEnabled() ? dataModel.getDomain(this, `yFilterValue`, "value", processedData) : void 0;
        if (yFilterExtent != null) yExtent = [
            Math.min(yExtent[0], yFilterExtent[0]),
            Math.max(yExtent[1], yFilterExtent[1])
        ];
        if (this.getValueAxis() instanceof $d77b025aa58d633c$var$LogAxis) return $d77b025aa58d633c$var$fixNumericExtent(yExtent);
        else {
            const fixedYExtent = Number.isFinite(yExtent[1] - yExtent[0]) ? [
                Math.min(0, yExtent[0]),
                Math.max(0, yExtent[1])
            ] : [];
            return $d77b025aa58d633c$var$fixNumericExtent(fixedYExtent);
        }
    }
    getSeriesRange(_direction, visibleRange) {
        const yKey = this.dataModel?.hasColumnById(this, `yValue-end`) ? "yValue-end" : "yValue-raw";
        const [y0, y1] = this.domainForVisibleRange("y" /* Y */ , [
            yKey
        ], "xValue", visibleRange, true);
        return [
            Math.min(y0, 0),
            Math.max(y1, 0)
        ];
    }
    getVisibleItems(xVisibleRange, yVisibleRange, minVisibleItems) {
        const yKey = this.dataModel?.hasColumnById(this, `yValue-end`) ? "yValue-end" : "yValue-raw";
        return this.countVisibleItems("xValue", [
            yKey
        ], xVisibleRange, yVisibleRange, minVisibleItems);
    }
    aggregateData(_dataModel, _processedData) {
        return;
    }
    createNodeData() {
        const { dataModel: dataModel, processedData: processedData, groupScale: groupScale, dataAggregationFilters: dataAggregationFilters } = this;
        const xAxis = this.getCategoryAxis();
        const yAxis = this.getValueAxis();
        if (!dataModel || !processedData || !xAxis || !yAxis) return;
        const rawData = processedData.dataSources?.get(this.id);
        if (rawData == null) return;
        const xScale = xAxis.scale;
        const yScale = yAxis.scale;
        const { xKey: xKey, yKey: yKey, xName: xName, yName: yName, legendItemName: legendItemName, label: label } = this.properties;
        const yReversed = yAxis.isReversed();
        const { barWidth: barWidth, groupIndex: groupScaleIndex } = this.updateGroupScale(xAxis);
        const groupOffset = groupScale.convert(String(groupScaleIndex));
        const barOffset = $d77b025aa58d633c$var$ContinuousScale.is(xScale) ? barWidth * -0.5 : 0;
        const xValues = dataModel.resolveKeysById(this, `xValue`, processedData);
        const yRawValues = dataModel.resolveColumnById(this, `yValue-raw`, processedData);
        const yFilterValues = this.crossFilteringEnabled() ? dataModel.resolveColumnById(this, `yFilterValue`, processedData) : void 0;
        const animationEnabled = !this.ctx.animationManager.isSkipped();
        const xPosition = (index)=>xScale.convert(xValues[index]) + groupOffset + barOffset;
        const crisp = this.properties.crisp ?? $d77b025aa58d633c$var$checkCrisp(xAxis?.scale, xAxis?.visibleRange, this.smallestDataInterval, this.largestDataInterval);
        const bboxBottom = yScale.convert(0);
        const nodeDatum = ({ datum: datum, datumIndex: datumIndex, valueIndex: valueIndex, xValue: xValue, yValue: yValue, cumulativeValue: cumulativeValue, phantom: phantom, currY: currY, prevY: prevY, x: x, width: width2, isPositive: isPositive, yRange: yRange, labelText: labelText, opacity: opacity, crossScale: crossScale = 1 })=>{
            const isUpward = isPositive !== yReversed;
            const y = yScale.convert(currY);
            const bottomY = yScale.convert(prevY);
            const bboxHeight = yScale.convert(yRange);
            const barAlongX = this.getBarDirection() === "x" /* X */ ;
            const xOffset = width2 * 0.5 * (1 - crossScale);
            const rect = {
                x: barAlongX ? Math.min(y, bottomY) : x + xOffset,
                y: barAlongX ? x + xOffset : Math.min(y, bottomY),
                width: barAlongX ? Math.abs(bottomY - y) : width2 * crossScale,
                height: barAlongX ? width2 * crossScale : Math.abs(bottomY - y)
            };
            const clipBBox = new $d77b025aa58d633c$var$BBox(rect.x, rect.y, rect.width, rect.height);
            const barRect = {
                x: barAlongX ? Math.min(bboxBottom, bboxHeight) : x + xOffset,
                y: barAlongX ? x + xOffset : Math.min(bboxBottom, bboxHeight),
                width: barAlongX ? Math.abs(bboxBottom - bboxHeight) : width2 * crossScale,
                height: barAlongX ? width2 * crossScale : Math.abs(bboxBottom - bboxHeight)
            };
            const lengthRatioMultiplier = this.shouldFlipXY() ? rect.height : rect.width;
            return {
                series: this,
                itemId: phantom ? $d77b025aa58d633c$var$createDatumId(yKey, phantom) : yKey,
                datum: datum,
                datumIndex: datumIndex,
                valueIndex: valueIndex,
                cumulativeValue: cumulativeValue,
                phantom: phantom,
                xValue: xValue,
                yValue: yValue,
                yKey: yKey,
                xKey: xKey,
                capDefaults: {
                    lengthRatioMultiplier: lengthRatioMultiplier,
                    lengthMax: lengthRatioMultiplier
                },
                x: barRect.x,
                y: barRect.y,
                width: barRect.width,
                height: barRect.height,
                midPoint: {
                    x: rect.x + rect.width / 2,
                    y: rect.y + rect.height / 2
                },
                opacity: opacity,
                topLeftCornerRadius: barAlongX !== isUpward,
                topRightCornerRadius: isUpward,
                bottomRightCornerRadius: barAlongX === isUpward,
                bottomLeftCornerRadius: !isUpward,
                clipBBox: clipBBox,
                crisp: crisp,
                label: labelText != null ? {
                    text: labelText,
                    ...$d77b025aa58d633c$var$adjustLabelPlacement({
                        isUpward: isUpward,
                        isVertical: !barAlongX,
                        placement: label.placement,
                        padding: label.padding,
                        rect: rect
                    })
                } : void 0,
                missing: yValue == null,
                focusable: !phantom
            };
        };
        const phantomNodes = [];
        const nodes = [];
        const labels = [];
        const handleDatum = (datumIndex, valueIndex, x, width2, yStart, yEnd, yRange, opacity)=>{
            const xValue = xValues[datumIndex];
            if (xValue == null) return;
            const yRawValue = yRawValues[datumIndex];
            const yFilterValue = yFilterValues != null ? Number(yFilterValues[datumIndex]) : void 0;
            const isPositive = yRawValue >= 0 && !Object.is(yRawValue, -0);
            if (!Number.isFinite(yEnd)) return;
            if (yFilterValue != null && !Number.isFinite(yFilterValue)) return;
            const labelText = yRawValue != null ? this.getLabelText(this.properties.label, {
                datum: rawData[datumIndex],
                value: yFilterValue ?? yRawValue,
                xKey: xKey,
                yKey: yKey,
                xName: xName,
                yName: yName,
                legendItemName: legendItemName
            }) : void 0;
            const inset = yFilterValue != null && yFilterValue > yRawValue;
            const nodeData = nodeDatum({
                datum: rawData[datumIndex],
                datumIndex: datumIndex,
                valueIndex: valueIndex,
                xValue: xValue,
                yValue: yFilterValue ?? yRawValue,
                cumulativeValue: yFilterValue ?? yEnd,
                phantom: false,
                currY: yFilterValue != null ? yStart + yFilterValue : yEnd,
                prevY: yStart,
                x: x,
                width: width2,
                isPositive: isPositive,
                yRange: Math.max(yStart + (yFilterValue ?? -Infinity), yRange),
                labelText: labelText,
                opacity: opacity,
                crossScale: inset ? 0.6 : void 0
            });
            nodes.push(nodeData);
            labels.push(nodeData);
            if (yFilterValue != null) {
                const phantomNodeData = nodeDatum({
                    datum: rawData[datumIndex],
                    datumIndex: datumIndex,
                    valueIndex: valueIndex,
                    xValue: xValue,
                    yValue: yFilterValue,
                    cumulativeValue: yFilterValue,
                    phantom: true,
                    currY: yEnd,
                    prevY: yStart,
                    x: x,
                    width: width2,
                    isPositive: isPositive,
                    yRange: yRange,
                    labelText: void 0,
                    opacity: opacity,
                    crossScale: void 0
                });
                phantomNodes.push(phantomNodeData);
            }
        };
        const [r0, r1] = xScale.range;
        const range3 = r1 - r0;
        const dataAggregationFilter = dataAggregationFilters?.find((f)=>f.maxRange > range3);
        if (processedData.type === "grouped") {
            const width2 = barWidth;
            const stacked = dataModel.hasColumnById(this, `yValue-start`);
            const yStartValues = stacked ? dataModel.resolveColumnById(this, `yValue-start`, processedData) : void 0;
            const yEndValues = stacked ? dataModel.resolveColumnById(this, `yValue-end`, processedData) : void 0;
            const yRangeIndex = stacked ? dataModel.resolveProcessedDataIndexById(this, `yValue-range`) : -1;
            for (const { datumIndex: datumIndex, valueIndex: valueIndex, group: { aggregation: aggregation } } of dataModel.forEachGroupDatum(this, processedData)){
                const x = xPosition(datumIndex);
                const yRawValue = yRawValues[datumIndex];
                const isPositive = yRawValue >= 0 && !Object.is(yRawValue, -0);
                const yStart = stacked ? Number(yStartValues?.[datumIndex]) : 0;
                const yEnd = stacked ? Number(yEndValues?.[datumIndex]) : yRawValue;
                let yRange = yEnd;
                if (stacked) yRange = aggregation[yRangeIndex][isPositive ? 1 : 0];
                handleDatum(datumIndex, valueIndex, x, width2, yStart, yEnd, yRange, 1);
            }
        } else if (dataAggregationFilter == null) {
            const width2 = barWidth;
            let [start2, end2] = this.visibleRange("xValue", xAxis.range);
            if (processedData.input.count < 1e3) {
                start2 = 0;
                end2 = processedData.input.count;
            }
            for(let datumIndex = start2; datumIndex < end2; datumIndex += 1){
                const x = xPosition(datumIndex);
                const yEnd = Number(yRawValues[datumIndex]);
                handleDatum(datumIndex, 0, x, width2, 0, yEnd, yEnd, 1);
            }
        } else {
            const { indexData: indexData, indices: indices } = dataAggregationFilter;
            const [start2, end2] = this.visibleRange("xValue", xAxis.range, indices);
            for(let i = start2; i < end2; i += 1){
                const aggIndex = i * $d77b025aa58d633c$var$SPAN2;
                const xMinIndex = indexData[aggIndex + $d77b025aa58d633c$var$X_MIN];
                const xMaxIndex = indexData[aggIndex + $d77b025aa58d633c$var$X_MAX];
                const yMinIndex = indexData[aggIndex + $d77b025aa58d633c$var$Y_MIN];
                const yMaxIndex = indexData[aggIndex + $d77b025aa58d633c$var$Y_MAX];
                if (xMinIndex === -1) continue;
                const x = xPosition((xMinIndex + xMaxIndex) / 2 | 0);
                const width2 = Math.abs(xPosition(xMaxIndex) - xPosition(xMinIndex)) + barWidth;
                const yEndMax = xValues[yMaxIndex] != null ? Number(yRawValues[yMaxIndex]) : NaN;
                const yEndMin = xValues[yMinIndex] != null ? Number(yRawValues[yMinIndex]) : NaN;
                if (yEndMax > 0) {
                    const opacity = yEndMin >= 0 ? yEndMin / yEndMax : 1;
                    handleDatum(yMaxIndex, 0, x, width2, 0, yEndMax, yEndMax, opacity);
                }
                if (yEndMin < 0) {
                    const opacity = yEndMax <= 0 ? yEndMax / yEndMin : 1;
                    handleDatum(yMinIndex, 1, x, width2, 0, yEndMin, yEndMin, opacity);
                }
            }
        }
        return {
            itemId: yKey,
            nodeData: phantomNodes.length > 0 ? [
                ...phantomNodes,
                ...nodes
            ] : nodes,
            labelData: labels,
            scales: this.calculateScaling(),
            visible: this.visible || animationEnabled,
            groupScale: this.getScaling(this.groupScale)
        };
    }
    nodeFactory() {
        return new $d77b025aa58d633c$var$Rect();
    }
    getHighlightData(nodeData, highlightedItem) {
        const highlightItem = nodeData.find((nodeDatum)=>nodeDatum.datum === highlightedItem.datum && !nodeDatum.phantom);
        return highlightItem != null ? [
            highlightItem
        ] : void 0;
    }
    updateDatumSelection(opts) {
        return opts.datumSelection.update(opts.nodeData, void 0, (datum)=>this.getDatumId(datum));
    }
    getItemBaseStyle(highlighted) {
        const { properties: properties } = this;
        const { cornerRadius: cornerRadius, fillGradientDefaults: fillGradientDefaults2, fillPatternDefaults: fillPatternDefaults2, fillImageDefaults: fillImageDefaults2 } = properties;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return $d77b025aa58d633c$var$getShapeStyle({
            fill: highlightStyle?.fill ?? properties.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? properties.fillOpacity,
            stroke: highlightStyle?.stroke ?? properties.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(properties.strokeWidth),
            strokeOpacity: highlightStyle?.strokeOpacity ?? properties.strokeOpacity,
            lineDash: highlightStyle?.lineDash ?? properties.lineDash ?? [],
            lineDashOffset: highlightStyle?.lineDashOffset ?? properties.lineDashOffset,
            cornerRadius: cornerRadius
        }, fillGradientDefaults2, fillPatternDefaults2, fillImageDefaults2);
    }
    getItemStyleOverrides(datumId, datum, xValue, yValue, format, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const { xKey: xKey, yKey: yKey, itemStyler: itemStyler, fillGradientDefaults: fillGradientDefaults2, fillPatternDefaults: fillPatternDefaults2, fillImageDefaults: fillImageDefaults2 } = properties;
        if (itemStyler == null) return;
        const { xDomain: xDomain, yDomain: yDomain } = this.cachedDatumCallback("domain", ()=>({
                xDomain: this.getSeriesDomain("x" /* X */ ),
                yDomain: this.getSeriesDomain("y" /* Y */ )
            }));
        const overrides = this.cachedDatumCallback($d77b025aa58d633c$var$createDatumId(datumId, highlighted ? "highlight" : "node"), ()=>{
            return this.callWithContext(itemStyler, {
                seriesId: seriesId,
                ...$d77b025aa58d633c$var$datumStylerProperties(datum, xKey, yKey, xDomain, yDomain),
                datum: datum,
                xValue: xValue,
                yValue: yValue,
                highlighted: highlighted,
                ...format
            });
        });
        return $d77b025aa58d633c$var$getShapeStyle(overrides, fillGradientDefaults2, fillPatternDefaults2, fillImageDefaults2);
    }
    updateDatumNodes(opts) {
        const { shadow: shadow } = this.properties;
        const categoryAlongX = this.getCategoryDirection() === "x" /* X */ ;
        const style = this.getItemBaseStyle(opts.isHighlight);
        const fillBBox = this.getShapeFillBBox();
        opts.datumSelection.each((rect, datum)=>{
            const overrides = this.getItemStyleOverrides(String(datum.datumIndex), datum.datum, datum.xValue, datum.yValue, style, opts.isHighlight);
            rect.opacity = datum.opacity ?? 0;
            $d77b025aa58d633c$var$applyShapeStyle(rect, style, overrides, fillBBox);
            const cornerRadius = overrides?.cornerRadius ?? style.cornerRadius;
            rect.topLeftCornerRadius = datum.topLeftCornerRadius ? cornerRadius : 0;
            rect.topRightCornerRadius = datum.topRightCornerRadius ? cornerRadius : 0;
            rect.bottomRightCornerRadius = datum.bottomRightCornerRadius ? cornerRadius : 0;
            rect.bottomLeftCornerRadius = datum.bottomLeftCornerRadius ? cornerRadius : 0;
            rect.visible = categoryAlongX ? (datum.clipBBox?.width ?? datum.width) > 0 : (datum.clipBBox?.height ?? datum.height) > 0;
            rect.crisp = datum.crisp;
            rect.fillShadow = shadow;
        });
    }
    updateLabelSelection(opts) {
        const data = this.isLabelEnabled() ? opts.labelData : [];
        return opts.labelSelection.update(data, (text)=>{
            text.pointerEvents = 1 /* None */ ;
        });
    }
    updateLabelNodes(opts) {
        opts.labelSelection.each((textNode, datum)=>{
            $d77b025aa58d633c$var$updateLabelNode(textNode, this.properties.label, datum.label);
        });
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, properties: properties } = this;
        const { xKey: xKey, xName: xName, yKey: yKey, yName: yName, legendItemName: legendItemName, stackGroup: stackGroup, tooltip: tooltip } = properties;
        const xAxis = this.getCategoryAxis();
        const yAxis = this.getValueAxis();
        if (!dataModel || !processedData || !xAxis || !yAxis) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const xValue = dataModel.resolveKeysById(this, `xValue`, processedData)[datumIndex];
        const yValue = dataModel.resolveColumnById(this, `yValue-raw`, processedData)[datumIndex];
        if (xValue == null) return;
        const format = this.getItemBaseStyle(false);
        Object.assign(format, this.getItemStyleOverrides(String(datumIndex), datum, xValue, yValue, format, false));
        return this.formatTooltipWithContext(tooltip, {
            heading: xAxis.formatDatum(xValue),
            symbol: this.legendItemSymbol(),
            data: [
                {
                    label: yName,
                    fallbackLabel: yKey,
                    value: yAxis.formatDatum(yValue)
                }
            ]
        }, {
            seriesId: seriesId,
            datum: datum,
            title: yName,
            xKey: xKey,
            xName: xName,
            yKey: yKey,
            yName: yName,
            legendItemName: legendItemName,
            stackGroup: stackGroup,
            ...format,
            ...this.getModuleTooltipParams()
        });
    }
    legendItemSymbol() {
        const { fill: fill, stroke: stroke2, strokeWidth: strokeWidth, fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, fillGradientDefaults: fillGradientDefaults2, fillPatternDefaults: fillPatternDefaults2, fillImageDefaults: fillImageDefaults2 } = this.properties;
        return {
            marker: $d77b025aa58d633c$var$getShapeStyle({
                fill: fill ?? "rgba(0, 0, 0, 0)",
                stroke: stroke2 ?? "rgba(0, 0, 0, 0)",
                fillOpacity: fillOpacity,
                strokeOpacity: strokeOpacity,
                strokeWidth: strokeWidth,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset
            }, fillGradientDefaults2, fillPatternDefaults2, fillImageDefaults2)
        };
    }
    getLegendData(legendType) {
        const { showInLegend: showInLegend } = this.properties;
        if (legendType !== "category") return [];
        const { id: seriesId, ctx: { legendManager: legendManager }, visible: visible } = this;
        const { yKey: itemId, yName: yName, legendItemName: legendItemName } = this.properties;
        return [
            {
                legendType: "category",
                id: seriesId,
                itemId: itemId,
                seriesId: seriesId,
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: seriesId,
                    itemId: itemId
                }),
                label: {
                    text: legendItemName ?? yName ?? itemId
                },
                symbol: this.legendItemSymbol(),
                legendItemName: legendItemName,
                hideInLegend: !showInLegend
            }
        ];
    }
    animateEmptyUpdateReady({ datumSelection: datumSelection, labelSelection: labelSelection, annotationSelections: annotationSelections }) {
        const fns = $d77b025aa58d633c$var$prepareBarAnimationFunctions($d77b025aa58d633c$var$collapsedStartingBarPosition(this.isVertical(), this.axes, "normal"));
        $d77b025aa58d633c$var$fromToMotion(this.id, "nodes", this.ctx.animationManager, [
            datumSelection
        ], fns);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, labelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "annotations", this.ctx.animationManager, ...annotationSelections);
    }
    animateWaitingUpdateReady(data) {
        const { datumSelection: datumSelection, labelSelection: labelSelection, annotationSelections: annotationSelections, contextData: contextData, previousContextData: previousContextData } = data;
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
        const dataDiff = $d77b025aa58d633c$var$calculateDataDiff(this.id, datumSelection, this.getDatumId.bind(this), data.contextData, previousContextData, this.processedData);
        const mode = previousContextData == null ? "fade" : "normal";
        const fns = $d77b025aa58d633c$var$prepareBarAnimationFunctions($d77b025aa58d633c$var$collapsedStartingBarPosition(this.isVertical(), this.axes, mode));
        $d77b025aa58d633c$var$fromToMotion(this.id, "nodes", this.ctx.animationManager, [
            datumSelection
        ], fns, (_, datum)=>this.getDatumId(datum), dataDiff);
        if (dataDiff?.changed || !$d77b025aa58d633c$var$areScalingEqual(contextData.groupScale, previousContextData?.groupScale)) {
            $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, labelSelection);
            $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "annotations", this.ctx.animationManager, ...annotationSelections);
        }
    }
    getDatumId(datum) {
        return $d77b025aa58d633c$var$createDatumId(datum.xValue, datum.valueIndex, datum.phantom);
    }
    isLabelEnabled() {
        return this.properties.label.enabled;
    }
    computeFocusBounds({ datumIndex: datumIndex }) {
        const datumBox = this.contextNodeData?.nodeData[datumIndex].clipBBox;
        return $d77b025aa58d633c$var$computeBarFocusBounds(this, datumBox);
    }
};
$d77b025aa58d633c$var$BarSeries.className = "BarSeries";
$d77b025aa58d633c$var$BarSeries.type = "bar";
var $d77b025aa58d633c$var$barSeriesThemeableOptionsDef = {
    direction: (0, $idDdm.union)("horizontal", "vertical"),
    showInMiniChart: (0, $idDdm.boolean),
    cornerRadius: (0, $idDdm.positiveNumber),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef),
        cornerRadius: (0, $idDdm.positiveNumber)
    }),
    crisp: (0, $idDdm.boolean),
    label: {
        ...$d77b025aa58d633c$var$seriesLabelOptionsDefs,
        placement: (0, $idDdm.union)("inside-center", "inside-start", "inside-end", "outside-start", "outside-end"),
        padding: (0, $idDdm.positiveNumber)
    },
    errorBar: $d77b025aa58d633c$var$errorBarThemeableOptionsDefs,
    shadow: $d77b025aa58d633c$var$shadowOptionsDefs,
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
$d77b025aa58d633c$var$barSeriesThemeableOptionsDef.sparklineMode = (0, $idDdm.undocumented)((0, $idDdm.boolean));
var $d77b025aa58d633c$var$barSeriesOptionsDef = {
    ...$d77b025aa58d633c$var$barSeriesThemeableOptionsDef,
    ...$d77b025aa58d633c$var$commonSeriesOptionsDefs,
    type: (0, $idDdm.required)((0, $idDdm.constant)("bar")),
    xKey: (0, $idDdm.required)((0, $idDdm.string)),
    yKey: (0, $idDdm.required)((0, $idDdm.string)),
    xName: (0, $idDdm.string),
    yName: (0, $idDdm.string),
    direction: (0, $idDdm.union)("horizontal", "vertical"),
    grouped: (0, $idDdm.boolean),
    stacked: (0, $idDdm.boolean),
    stackGroup: (0, $idDdm.string),
    normalizedTo: (0, $idDdm.number),
    legendItemName: (0, $idDdm.string),
    errorBar: $d77b025aa58d633c$var$errorBarOptionsDefs
};
$d77b025aa58d633c$var$barSeriesOptionsDef.pickOutsideVisibleMinorAxis = (0, $idDdm.undocumented)((0, $idDdm.boolean));
$d77b025aa58d633c$var$barSeriesOptionsDef.fastDataProcessing = (0, $idDdm.undocumented)((0, $idDdm.boolean));
$d77b025aa58d633c$var$barSeriesOptionsDef.focusPriority = (0, $idDdm.undocumented)((0, $idDdm.number));
// packages/ag-charts-community/src/chart/series/cartesian/barSeriesModule.ts
var $d77b025aa58d633c$var$BarSeriesModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "community",
    chartTypes: [
        "cartesian"
    ],
    identifier: "bar",
    moduleFactory: (ctx)=>new $d77b025aa58d633c$var$BarSeries(ctx),
    stackable: true,
    groupable: true,
    tooltipDefaults: {
        range: "exact"
    },
    defaultAxes: $d77b025aa58d633c$var$DIRECTION_SWAP_AXES,
    themeTemplate: {
        series: {
            direction: "vertical",
            fill: {
                $palette: "fill"
            },
            stroke: {
                $palette: "stroke"
            },
            // @ts-expect-error undocumented option
            fillGradientDefaults: {
                type: "gradient",
                gradient: "linear",
                bounds: "item",
                colorStops: {
                    $palette: "gradient"
                },
                rotation: 0,
                reverse: false
            },
            fillPatternDefaults: $d77b025aa58d633c$var$FILL_PATTERN_DEFAULTS,
            fillImageDefaults: $d77b025aa58d633c$var$FILL_IMAGE_DEFAULTS,
            fillOpacity: 1,
            strokeWidth: 0,
            lineDash: [
                0
            ],
            lineDashOffset: 0,
            label: {
                enabled: false,
                fontWeight: {
                    $ref: "fontWeight"
                },
                fontSize: {
                    $ref: "fontSize"
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                color: {
                    $if: [
                        {
                            $or: [
                                {
                                    $eq: [
                                        {
                                            $path: "./placement"
                                        },
                                        "outside-start"
                                    ]
                                },
                                {
                                    $eq: [
                                        {
                                            $path: "./placement"
                                        },
                                        "outside-end"
                                    ]
                                }
                            ]
                        },
                        {
                            $ref: "textColor"
                        },
                        {
                            $ref: "backgroundColor"
                        }
                    ]
                },
                placement: "inside-center"
            },
            shadow: {
                enabled: false,
                color: $d77b025aa58d633c$var$DEFAULT_SHADOW_COLOUR,
                xOffset: 3,
                yOffset: 3,
                blur: 5
            },
            errorBar: {
                cap: {
                    lengthRatio: 0.3
                }
            }
        }
    }
};
var $d77b025aa58d633c$var$NewBarSeriesModule = {
    type: "series",
    name: "bar",
    chartType: "cartesian",
    options: $d77b025aa58d633c$var$barSeriesOptionsDef,
    create: (ctx)=>new $d77b025aa58d633c$var$BarSeries(ctx)
};
// packages/ag-charts-community/src/chart/series/cartesian/bubbleSeriesProperties.ts
var $d77b025aa58d633c$var$BubbleSeriesMarker = class extends $d77b025aa58d633c$var$SeriesMarker {
    constructor(){
        super(...arguments);
        this.maxSize = 30;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$BubbleSeriesMarker.prototype, "maxSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property,
    $d77b025aa58d633c$var$SceneArrayChangeDetection()
], $d77b025aa58d633c$var$BubbleSeriesMarker.prototype, "domain", 2);
var $d77b025aa58d633c$var$BubbleSeriesLabel = class extends $d77b025aa58d633c$var$Label {
    constructor(){
        super(...arguments);
        this.placement = "top";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BubbleSeriesLabel.prototype, "placement", 2);
var $d77b025aa58d633c$var$BubbleSeriesProperties = class extends $d77b025aa58d633c$var$CartesianSeriesProperties {
    constructor(){
        super(...arguments);
        this.label = new $d77b025aa58d633c$var$BubbleSeriesLabel();
        this.tooltip = new $d77b025aa58d633c$var$SeriesTooltip();
        // No validation. Not a part of the options contract.
        this.marker = new $d77b025aa58d633c$var$BubbleSeriesMarker();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "xKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "yKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "sizeKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "labelKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "xFilterKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "yFilterKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "sizeFilterKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "xName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "yName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "sizeName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "labelName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "title", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.shape")
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "shape", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.size")
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "size", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.maxSize")
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "maxSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.domain")
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "domain", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.fillGradientDefaults")
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "fillGradientDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.fillPatternDefaults")
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "fillPatternDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.fillImageDefaults")
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "fillImageDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.fill")
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.fillOpacity")
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.stroke")
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.strokeWidth")
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.strokeOpacity")
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.lineDash")
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.lineDashOffset")
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.itemStyler")
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "itemStyler", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-community/src/chart/series/cartesian/bubbleSeries.ts
var $d77b025aa58d633c$var$BubbleSeriesNodeEvent = class extends $d77b025aa58d633c$var$CartesianSeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.sizeKey = series.properties.sizeKey;
    }
};
var $d77b025aa58d633c$var$BubbleSeries = class extends $d77b025aa58d633c$var$CartesianSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            directionKeys: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_KEYS,
            directionNames: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_NAMES,
            categoryKey: void 0,
            pickModes: [
                2 /* AXIS_ALIGNED */ ,
                1 /* NEAREST_NODE */ ,
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            pathsPerSeries: [],
            hasMarkers: true,
            markerSelectionGarbageCollection: false,
            animationResetFns: {
                label: $d77b025aa58d633c$var$resetLabelFn,
                marker: $d77b025aa58d633c$var$resetMarkerFn
            },
            usesPlacedLabels: true,
            clipFocusBox: false
        });
        this.NodeEvent = $d77b025aa58d633c$var$BubbleSeriesNodeEvent;
        this.properties = new $d77b025aa58d633c$var$BubbleSeriesProperties();
        this.sizeScale = new $d77b025aa58d633c$var$LinearScale();
    }
    get pickModeAxis() {
        return "main-category";
    }
    async processData(dataController) {
        if (this.data == null || !this.visible) return;
        const xScale = this.axes["x" /* X */ ]?.scale;
        const yScale = this.axes["y" /* Y */ ]?.scale;
        const { xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
            xScale: xScale,
            yScale: yScale
        });
        const sizeScaleType = this.sizeScale.type;
        const { xKey: xKey, yKey: yKey, sizeKey: sizeKey, xFilterKey: xFilterKey, yFilterKey: yFilterKey, sizeFilterKey: sizeFilterKey, labelKey: labelKey, marker: marker } = this.properties;
        const { dataModel: dataModel, processedData: processedData } = await this.requestDataModel(dataController, this.data, {
            props: [
                $d77b025aa58d633c$var$valueProperty(xKey, xScaleType, {
                    id: `xValue`
                }),
                $d77b025aa58d633c$var$valueProperty(yKey, yScaleType, {
                    id: `yValue`
                }),
                ...xFilterKey != null ? [
                    $d77b025aa58d633c$var$valueProperty(xFilterKey, xScaleType, {
                        id: `xFilterValue`
                    })
                ] : [],
                ...yFilterKey != null ? [
                    $d77b025aa58d633c$var$valueProperty(yFilterKey, yScaleType, {
                        id: `yFilterValue`
                    })
                ] : [],
                ...sizeFilterKey != null ? [
                    $d77b025aa58d633c$var$valueProperty(sizeFilterKey, sizeScaleType, {
                        id: `sizeFilterValue`
                    })
                ] : [],
                $d77b025aa58d633c$var$valueProperty(sizeKey, sizeScaleType, {
                    id: `sizeValue`
                }),
                ...labelKey ? [
                    $d77b025aa58d633c$var$valueProperty(labelKey, "band", {
                        id: `labelValue`
                    })
                ] : []
            ]
        });
        const sizeKeyIdx = dataModel.resolveProcessedDataIndexById(this, `sizeValue`);
        const mutableMarkerDomain = marker.domain ? [
            marker.domain[0],
            marker.domain[1]
        ] : void 0;
        this.sizeScale.domain = mutableMarkerDomain ?? processedData.domain.values[sizeKeyIdx] ?? [];
        this.animationState.transition("updateData");
    }
    xCoordinateRange(xValue, pixelSize, index) {
        const { properties: properties, sizeScale: sizeScale } = this;
        const { size: size, sizeKey: sizeKey } = properties;
        const x = this.axes["x" /* X */ ].scale.convert(xValue);
        const sizeValues = sizeKey != null ? this.dataModel.resolveColumnById(this, `sizeValue`, this.processedData) : void 0;
        const sizeValue = sizeValues != null ? sizeScale.convert(sizeValues[index]) : size;
        const r = 0.5 * sizeValue * pixelSize;
        return [
            x - r,
            x + r
        ];
    }
    yCoordinateRange(yValues, pixelSize, index) {
        const { properties: properties, sizeScale: sizeScale } = this;
        const { size: size, sizeKey: sizeKey } = properties;
        const y = this.axes["y" /* Y */ ].scale.convert(yValues[0]);
        const sizeValues = sizeKey != null ? this.dataModel.resolveColumnById(this, `sizeValue`, this.processedData) : void 0;
        const sizeValue = sizeValues != null ? sizeScale.convert(sizeValues[index]) : size;
        const r = 0.5 * sizeValue * pixelSize;
        return [
            y - r,
            y + r
        ];
    }
    getSeriesDomain(direction) {
        const { dataModel: dataModel, processedData: processedData } = this;
        if (!processedData || !dataModel) return [];
        const dataValues = {
            ["x" /* X */ ]: "xValue",
            ["y" /* Y */ ]: "yValue"
        };
        const id = dataValues[direction];
        const dataDef = dataModel.resolveProcessedDataDefById(this, id);
        const domain = dataModel.getDomain(this, id, "value", processedData);
        if (dataDef?.def.type === "value" && dataDef?.def.valueType === "category") return domain;
        const crossDirection = direction === "x" /* X */  ? "y" /* Y */  : "x" /* X */ ;
        const crossId = dataValues[crossDirection];
        const ext = this.domainForClippedRange(direction, [
            id
        ], crossId, false);
        return $d77b025aa58d633c$var$fixNumericExtent($d77b025aa58d633c$var$extent(ext));
    }
    getSeriesRange(_direction, visibleRange) {
        return this.domainForVisibleRange("y" /* Y */ , [
            "yValue"
        ], "xValue", visibleRange, false);
    }
    getVisibleItems(xVisibleRange, yVisibleRange, minVisibleItems) {
        return this.countVisibleItems("xValue", [
            "yValue"
        ], xVisibleRange, yVisibleRange, minVisibleItems);
    }
    createNodeData() {
        const { axes: axes, dataModel: dataModel, processedData: processedData, sizeScale: sizeScale, visible: visible } = this;
        const { xKey: xKey, yKey: yKey, sizeKey: sizeKey, xFilterKey: xFilterKey, yFilterKey: yFilterKey, sizeFilterKey: sizeFilterKey, labelKey: labelKey, xName: xName, yName: yName, sizeName: sizeName, labelName: labelName, label: label, marker: marker } = this.properties;
        const { placement: placement } = label;
        const anchor = $d77b025aa58d633c$var$Marker.anchor(marker.shape);
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        if (!(dataModel && processedData && visible && xAxis && yAxis)) return;
        const xDataValues = dataModel.resolveColumnById(this, `xValue`, processedData);
        const yDataValues = dataModel.resolveColumnById(this, `yValue`, processedData);
        const sizeDataValues = sizeKey != null ? dataModel.resolveColumnById(this, `sizeValue`, processedData) : void 0;
        const labelDataValues = labelKey != null ? dataModel.resolveColumnById(this, `labelValue`, processedData) : void 0;
        const xFilterDataValues = xFilterKey != null ? dataModel.resolveColumnById(this, `xFilterValue`, processedData) : void 0;
        const yFilterDataValues = yFilterKey != null ? dataModel.resolveColumnById(this, `yFilterValue`, processedData) : void 0;
        const sizeFilterDataValues = sizeFilterKey != null ? dataModel.resolveColumnById(this, `sizeFilterValue`, processedData) : void 0;
        const xScale = xAxis.scale;
        const yScale = yAxis.scale;
        const xOffset = (xScale.bandwidth ?? 0) / 2;
        const yOffset = (yScale.bandwidth ?? 0) / 2;
        const nodeData = [];
        sizeScale.range = [
            marker.size,
            marker.maxSize
        ];
        const font2 = label.getFont();
        const textMeasurer = $d77b025aa58d633c$var$CachedTextMeasurerPool.getMeasurer({
            font: font2
        });
        processedData.dataSources.get(this.id)?.forEach((datum, datumIndex)=>{
            const xDatum = xDataValues[datumIndex];
            const yDatum = yDataValues[datumIndex];
            const sizeValue = sizeDataValues?.[datumIndex];
            const x = xScale.convert(xDatum) + xOffset;
            const y = yScale.convert(yDatum) + yOffset;
            let selected;
            if (xFilterDataValues != null && yFilterDataValues != null) {
                selected = xFilterDataValues[datumIndex] === xDatum && yFilterDataValues[datumIndex] === yDatum;
                if (sizeFilterDataValues != null) selected && (selected = sizeFilterDataValues[datumIndex] === sizeValue);
            }
            const labelText = this.getLabelText(label, {
                value: labelDataValues != null ? labelDataValues[datumIndex] : yDatum,
                datum: datum,
                xKey: xKey,
                yKey: yKey,
                sizeKey: sizeKey,
                labelKey: labelKey,
                xName: xName,
                yName: yName,
                sizeName: sizeName,
                labelName: labelName
            });
            const size = textMeasurer.measureText(String(labelText));
            const markerSize = sizeValue != null ? sizeScale.convert(sizeValue) : marker.size;
            nodeData.push({
                series: this,
                itemId: yKey,
                yKey: yKey,
                xKey: xKey,
                datum: datum,
                datumIndex: datumIndex,
                xValue: xDatum,
                yValue: yDatum,
                sizeValue: sizeValue,
                point: {
                    x: x,
                    y: y,
                    size: markerSize
                },
                midPoint: {
                    x: x,
                    y: y
                },
                label: {
                    text: labelText,
                    ...size
                },
                anchor: anchor,
                placement: placement,
                selected: selected
            });
        });
        return {
            itemId: yKey,
            nodeData: nodeData,
            labelData: nodeData,
            scales: this.calculateScaling(),
            visible: this.visible
        };
    }
    isPathOrSelectionDirty() {
        return this.properties.marker.isDirty();
    }
    getLabelData() {
        if (!this.isLabelEnabled()) return [];
        return this.contextNodeData?.labelData ?? [];
    }
    updateMarkerSelection(opts) {
        const { nodeData: nodeData, markerSelection: markerSelection } = opts;
        if (this.properties.marker.isDirty()) {
            markerSelection.clear();
            markerSelection.cleanup();
        }
        const data = this.properties.marker.enabled ? nodeData : [];
        return markerSelection.update(data, void 0, (datum)=>$d77b025aa58d633c$var$createDatumId([
                datum.xValue,
                datum.yValue,
                datum.sizeValue,
                datum.label.text
            ]));
    }
    updateMarkerNodes(opts) {
        const { markerSelection: markerSelection, isHighlight: highlighted } = opts;
        const { xKey: xKey, yKey: yKey, sizeKey: sizeKey, labelKey: labelKey, marker: marker } = this.properties;
        const baseStyle = $d77b025aa58d633c$var$mergeDefaults(highlighted && this.properties.highlightStyle.item, marker.getStyle());
        this.sizeScale.range = [
            marker.size,
            marker.maxSize
        ];
        const fillBBox = this.getShapeFillBBox();
        markerSelection.each((node, datum)=>{
            this.updateMarkerStyle(marker, node, datum.datum, datum.point, {
                xKey: xKey,
                yKey: yKey,
                sizeKey: sizeKey,
                labelKey: labelKey
            }, highlighted, baseStyle, fillBBox, {
                selected: datum.selected
            });
        });
        if (!highlighted) this.properties.marker.markClean();
    }
    updatePlacedLabelData(labelData) {
        this.labelSelection.update(labelData.map((v)=>({
                ...v.datum,
                point: {
                    x: v.x,
                    y: v.y,
                    size: v.datum.point.size
                }
            })), (text)=>{
            text.pointerEvents = 1 /* None */ ;
        });
        this.updateLabelNodes({
            labelSelection: this.labelSelection
        });
    }
    updateLabelNodes(opts) {
        const { label: label } = this.properties;
        opts.labelSelection.each((text, datum)=>{
            text.text = datum.label.text;
            text.fill = label.color;
            text.x = datum.point?.x ?? 0;
            text.y = datum.point?.y ?? 0;
            text.fontStyle = label.fontStyle;
            text.fontWeight = label.fontWeight;
            text.fontSize = label.fontSize;
            text.fontFamily = label.fontFamily;
            text.textAlign = "left";
            text.textBaseline = "top";
        });
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, axes: axes, properties: properties } = this;
        const { xKey: xKey, xName: xName, yKey: yKey, yName: yName, sizeKey: sizeKey, sizeName: sizeName, labelKey: labelKey, labelName: labelName, title: title, tooltip: tooltip, marker: marker } = properties;
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        if (!dataModel || !processedData || !xAxis || !yAxis) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const xValue = dataModel.resolveColumnById(this, `xValue`, processedData)[datumIndex];
        const yValue = dataModel.resolveColumnById(this, `yValue`, processedData)[datumIndex];
        const nodeDatum = this.contextNodeData?.nodeData[datumIndex];
        if (xValue == null || nodeDatum == null) return;
        const data = [
            {
                label: xName,
                fallbackLabel: xKey,
                value: xAxis.formatDatum(xValue)
            },
            {
                label: yName,
                fallbackLabel: yKey,
                value: yAxis.formatDatum(yValue)
            }
        ];
        if (sizeKey != null) {
            const sizeValue = dataModel.resolveColumnById(this, `sizeValue`, processedData)[datumIndex];
            data.push({
                label: sizeName,
                fallbackLabel: sizeKey,
                value: String(sizeValue)
            });
        }
        const style = marker.getStyle();
        const activeStyle = this.getMarkerStyle(marker, datum, {
            xKey: xKey,
            yKey: yKey,
            sizeKey: sizeKey,
            labelKey: labelKey,
            highlighted: true
        }, false, void 0, style);
        return this.formatTooltipWithContext(tooltip, {
            title: title,
            symbol: this.legendItemSymbol(),
            data: data
        }, {
            seriesId: seriesId,
            datum: datum,
            title: yKey,
            xKey: xKey,
            xName: xName,
            yKey: yKey,
            yName: yName,
            sizeKey: sizeKey,
            sizeName: sizeName,
            labelKey: labelKey,
            labelName: labelName,
            ...activeStyle,
            ...this.getModuleTooltipParams()
        });
    }
    legendItemSymbol() {
        const marker = this.getMarkerStyle(this.properties.marker);
        return {
            marker: marker
        };
    }
    getLegendData() {
        const { id: seriesId, ctx: { legendManager: legendManager }, visible: visible } = this;
        const { yKey: itemId, yName: yName, title: title } = this.properties;
        return [
            {
                legendType: "category",
                id: seriesId,
                itemId: itemId,
                seriesId: seriesId,
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: seriesId,
                    itemId: itemId
                }),
                label: {
                    text: title ?? yName ?? itemId
                },
                symbol: this.legendItemSymbol()
            }
        ];
    }
    animateEmptyUpdateReady({ markerSelection: markerSelection, labelSelection: labelSelection }) {
        $d77b025aa58d633c$var$markerScaleInAnimation(this, this.ctx.animationManager, markerSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, labelSelection);
    }
    isLabelEnabled() {
        return this.properties.label.enabled;
    }
    nodeFactory() {
        return new $d77b025aa58d633c$var$Group();
    }
    getFormattedMarkerStyle(datum) {
        const { xKey: xKey, yKey: yKey, sizeKey: sizeKey, labelKey: labelKey, marker: marker } = this.properties;
        return this.getMarkerStyle(marker, datum, {
            xKey: xKey,
            yKey: yKey,
            sizeKey: sizeKey,
            labelKey: labelKey
        }, false, datum.point.size);
    }
    computeFocusBounds(opts) {
        return $d77b025aa58d633c$var$computeMarkerFocusBounds(this, opts);
    }
};
$d77b025aa58d633c$var$BubbleSeries.className = "BubbleSeries";
$d77b025aa58d633c$var$BubbleSeries.type = "bubble";
var $d77b025aa58d633c$var$bubbleSeriesThemeableOptionsDef = {
    title: (0, $idDdm.string),
    domain: (0, $idDdm.arrayOf)((0, $idDdm.number)),
    maxSize: (0, $idDdm.positiveNumber),
    showInMiniChart: (0, $idDdm.boolean),
    label: {
        placement: (0, $idDdm.union)("top", "right", "bottom", "left"),
        ...$d77b025aa58d633c$var$seriesLabelOptionsDefs
    },
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$markerOptionsDefs, [
        "enabled"
    ])
};
var $d77b025aa58d633c$var$bubbleSeriesOptionsDef = {
    ...$d77b025aa58d633c$var$bubbleSeriesThemeableOptionsDef,
    ...$d77b025aa58d633c$var$commonSeriesOptionsDefs,
    type: (0, $idDdm.required)((0, $idDdm.constant)("bubble")),
    xKey: (0, $idDdm.required)((0, $idDdm.string)),
    yKey: (0, $idDdm.required)((0, $idDdm.string)),
    sizeKey: (0, $idDdm.required)((0, $idDdm.string)),
    labelKey: (0, $idDdm.string),
    xName: (0, $idDdm.string),
    yName: (0, $idDdm.string),
    sizeName: (0, $idDdm.string),
    labelName: (0, $idDdm.string)
};
// packages/ag-charts-community/src/chart/series/cartesian/bubbleSeriesModule.ts
var $d77b025aa58d633c$var$BubbleSeriesModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "community",
    chartTypes: [
        "cartesian"
    ],
    identifier: "bubble",
    moduleFactory: (ctx)=>new $d77b025aa58d633c$var$BubbleSeries(ctx),
    tooltipDefaults: {
        range: "nearest"
    },
    defaultAxes: [
        {
            type: "number" /* NUMBER */ ,
            position: "bottom" /* BOTTOM */ 
        },
        {
            type: "number" /* NUMBER */ ,
            position: "left" /* LEFT */ 
        }
    ],
    themeTemplate: {
        series: {
            shape: "circle",
            size: 7,
            maxSize: 30,
            fill: {
                $palette: "fill"
            },
            stroke: {
                $palette: "stroke"
            },
            // @ts-expect-error undocumented option
            fillGradientDefaults: {
                type: "gradient",
                gradient: "radial",
                bounds: "item",
                colorStops: {
                    $palette: "gradient"
                },
                rotation: 0,
                reverse: true
            },
            fillPatternDefaults: $d77b025aa58d633c$var$FILL_PATTERN_DEFAULTS,
            fillImageDefaults: $d77b025aa58d633c$var$FILL_IMAGE_DEFAULTS,
            fillOpacity: 0.8,
            tooltip: {
                position: {
                    _seriesOverrideType: "node"
                }
            },
            label: {
                enabled: false,
                fontSize: {
                    $ref: "fontSize"
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontWeight: {
                    $ref: "fontWeight"
                },
                color: {
                    $ref: "textColor"
                }
            }
        }
    }
};
var $d77b025aa58d633c$var$NewBubbleSeriesModule = {
    type: "series",
    name: "bubble",
    chartType: "cartesian",
    options: $d77b025aa58d633c$var$bubbleSeriesOptionsDef,
    create: (ctx)=>new $d77b025aa58d633c$var$BubbleSeries(ctx)
};
// packages/ag-charts-community/src/chart/series/cartesian/histogramSeriesProperties.ts
var $d77b025aa58d633c$var$HistogramSeriesProperties = class extends $d77b025aa58d633c$var$CartesianSeriesProperties {
    constructor(){
        super(...arguments);
        this.fillGradientDefaults = new $d77b025aa58d633c$var$FillGradientDefaults();
        this.fillPatternDefaults = new $d77b025aa58d633c$var$FillPatternDefaults();
        this.fillImageDefaults = new $d77b025aa58d633c$var$FillImageDefaults();
        this.fillOpacity = 1;
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.cornerRadius = 0;
        this.areaPlot = false;
        this.aggregation = "sum";
        this.shadow = new $d77b025aa58d633c$var$DropShadow();
        this.label = new $d77b025aa58d633c$var$Label();
        this.tooltip = new $d77b025aa58d633c$var$SeriesTooltip();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "xKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "yKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "xName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "yName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "fillGradientDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "fillPatternDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "fillImageDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "cornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "areaPlot", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "bins", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "aggregation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "binCount", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "shadow", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-community/src/chart/series/cartesian/histogramSeries.ts
var $d77b025aa58d633c$var$defaultBinCount = 10;
var $d77b025aa58d633c$var$HistogramSeries = class extends $d77b025aa58d633c$var$CartesianSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            directionKeys: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_KEYS,
            directionNames: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_NAMES,
            categoryKey: void 0,
            pickModes: [
                1 /* NEAREST_NODE */ ,
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            datumSelectionGarbageCollection: false,
            animationResetFns: {
                datum: $d77b025aa58d633c$var$resetBarSelectionsFn,
                label: $d77b025aa58d633c$var$resetLabelFn
            }
        });
        this.properties = new $d77b025aa58d633c$var$HistogramSeriesProperties();
        this.calculatedBins = [];
    }
    // During processData phase, used to unify different ways of the user specifying
    // the bins. Returns bins in format[[min1, max1], [min2, max2], ... ].
    deriveBins(xDomain) {
        const binStarts = $d77b025aa58d633c$var$createTicks(xDomain[0], xDomain[1], $d77b025aa58d633c$var$defaultBinCount).ticks;
        const binSize = $d77b025aa58d633c$var$tickStep(xDomain[0], xDomain[1], $d77b025aa58d633c$var$defaultBinCount);
        const [firstBinEnd] = binStarts;
        const expandStartToBin = (n)=>[
                n,
                n + binSize
            ];
        return [
            [
                firstBinEnd - binSize,
                firstBinEnd
            ],
            ...binStarts.map(expandStartToBin)
        ];
    }
    calculateNiceBins(domain, binCount) {
        const startGuess = Math.floor(domain[0]);
        const stop = domain[1];
        const segments = binCount || 1;
        const { start: start2, binSize: binSize } = this.calculateNiceStart(startGuess, stop, segments);
        return this.getBins(start2, stop, binSize, segments);
    }
    getBins(start2, stop, step, count) {
        const bins = [];
        const precision = this.calculatePrecision(step);
        for(let i = 0; i < count; i++){
            const a = Math.round((start2 + i * step) * precision) / precision;
            let b = Math.round((start2 + (i + 1) * step) * precision) / precision;
            if (i === count - 1) b = Math.max(b, stop);
            bins[i] = [
                a,
                b
            ];
        }
        return bins;
    }
    calculatePrecision(step) {
        let precision = 10;
        if (isFinite(step) && step > 0) while(step < 1){
            precision *= 10;
            step *= 10;
        }
        return precision;
    }
    calculateNiceStart(a, b, segments) {
        const binSize = Math.abs(b - a) / segments;
        const order = Math.floor(Math.log10(binSize));
        const magnitude = Math.pow(10, order);
        const start2 = Math.floor(a / magnitude) * magnitude;
        return {
            start: start2,
            binSize: binSize
        };
    }
    async processData(dataController) {
        if (!this.visible) {
            this.processedData = void 0;
            this.animationState.transition("updateData");
        }
        const { xKey: xKey, yKey: yKey, areaPlot: areaPlot, aggregation: aggregation } = this.properties;
        const xScale = this.axes["x" /* X */ ]?.scale;
        const yScale = this.axes["y" /* Y */ ]?.scale;
        const { xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
            yScale: yScale,
            xScale: xScale
        });
        const props = [
            $d77b025aa58d633c$var$keyProperty(xKey, xScaleType),
            $d77b025aa58d633c$var$SORT_DOMAIN_GROUPS
        ];
        if (yKey) {
            let aggProp = $d77b025aa58d633c$var$groupCount("groupAgg");
            if (aggregation === "count") ;
            else if (aggregation === "sum") aggProp = $d77b025aa58d633c$var$groupSum("groupAgg");
            else if (aggregation === "mean") aggProp = $d77b025aa58d633c$var$groupAverage("groupAgg");
            if (areaPlot) aggProp = $d77b025aa58d633c$var$area("groupAgg", aggProp);
            props.push($d77b025aa58d633c$var$valueProperty(yKey, yScaleType, {
                invalidValue: void 0
            }), aggProp);
        } else {
            props.push($d77b025aa58d633c$var$rowCountProperty("count"));
            let aggProp = $d77b025aa58d633c$var$groupCount("groupAgg");
            if (areaPlot) aggProp = $d77b025aa58d633c$var$area("groupAgg", aggProp);
            props.push(aggProp);
        }
        const groupByFn = (dataSet)=>{
            const xExtent = $d77b025aa58d633c$var$fixNumericExtent(dataSet.domain.keys[0]);
            if (xExtent.length === 0) {
                dataSet.domain.groups = [];
                return ()=>[];
            }
            const bins = (0, $idDdm.isNumber)(this.properties.binCount) ? this.calculateNiceBins(xExtent, this.properties.binCount) : this.properties.bins ?? this.deriveBins(xExtent);
            const binCount = bins.length;
            this.calculatedBins = [
                ...bins
            ];
            return (keys)=>{
                let xValue = keys[0];
                if ((0, $idDdm.isDate)(xValue)) xValue = xValue.getTime();
                if (!(0, $idDdm.isNumber)(xValue)) return [];
                for(let i = 0; i < binCount; i++){
                    const nextBin = bins[i];
                    if (xValue >= nextBin[0] && xValue < nextBin[1]) return nextBin;
                    if (i === binCount - 1 && xValue <= nextBin[1]) return nextBin;
                }
                return [];
            };
        };
        if (!this.ctx.animationManager.isSkipped() && this.processedData) props.push($d77b025aa58d633c$var$diff(this.id, this.processedData, false));
        await this.requestDataModel(dataController, this.data, {
            props: props,
            groupByFn: groupByFn
        });
        this.animationState.transition("updateData");
    }
    xCoordinateRange() {
        return [
            NaN,
            NaN
        ];
    }
    yCoordinateRange() {
        return [
            NaN,
            NaN
        ];
    }
    getSeriesDomain(direction) {
        const { processedData: processedData, dataModel: dataModel } = this;
        if (!processedData || !dataModel || !this.calculatedBins.length) return [];
        const yDomain = dataModel.getDomain(this, `groupAgg`, "aggregate", processedData);
        const xDomainMin = this.calculatedBins?.[0][0];
        const xDomainMax = this.calculatedBins?.[(this.calculatedBins?.length ?? 0) - 1][1];
        if (direction === "x" /* X */ ) return $d77b025aa58d633c$var$fixNumericExtent([
            xDomainMin,
            xDomainMax
        ]);
        return $d77b025aa58d633c$var$fixNumericExtent(yDomain);
    }
    getSeriesRange(_direction, [r0, r1]) {
        const { dataModel: dataModel, processedData: processedData } = this;
        if (!dataModel || processedData?.type !== "grouped") return [
            NaN,
            NaN
        ];
        const xScale = this.axes["x" /* X */ ].scale;
        const yMin = 0;
        let yMax = -Infinity;
        processedData.groups.forEach(({ keys: keys, aggregation: aggregation })=>{
            const [[negativeAgg, positiveAgg] = [
                0,
                0
            ]] = aggregation;
            const [xDomainMin, xDomainMax] = keys;
            const [x0, x1] = $d77b025aa58d633c$var$findMinMax([
                xScale.convert(xDomainMin),
                xScale.convert(xDomainMax)
            ]);
            if (x1 >= r0 && x0 <= r1) {
                const total = negativeAgg + positiveAgg;
                yMax = Math.max(yMax, total);
            }
        });
        if (yMin > yMax) return [
            NaN,
            NaN
        ];
        return [
            yMin,
            yMax
        ];
    }
    frequency(group) {
        return group.datumIndices.reduce((acc, datumIndices)=>acc + datumIndices.length, 0);
    }
    createNodeData() {
        const { id: seriesId, axes: axes, processedData: processedData, dataModel: dataModel } = this;
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        if (!xAxis || !yAxis || !dataModel) return;
        const { scale: xScale } = xAxis;
        const { scale: yScale } = yAxis;
        const { xKey: xKey, yKey: yKey, xName: xName, yName: yName } = this.properties;
        const labelFormatter = this.properties.label.formatter;
        const nodeData = [];
        const context = {
            itemId: this.properties.yKey ?? this.id,
            nodeData: nodeData,
            labelData: nodeData,
            scales: this.calculateScaling(),
            animationValid: true,
            visible: this.visible
        };
        if (!this.visible || processedData == null || processedData.type !== "grouped") return context;
        processedData.groups.forEach((group, groupIndex)=>{
            const { keys: keys, aggregation: aggregation } = group;
            const [[negativeAgg, positiveAgg] = [
                0,
                0
            ]] = aggregation;
            const frequency = this.frequency(group);
            const domain = keys;
            const [xDomainMin, xDomainMax] = domain;
            const datum = [
                ...dataModel.forEachDatum(this, processedData, group)
            ];
            const xMinPx = xScale.convert(xDomainMin);
            const xMaxPx = xScale.convert(xDomainMax);
            const total = negativeAgg + positiveAgg;
            const yZeroPx = yScale.convert(0);
            const yMaxPx = yScale.convert(total);
            const w = Math.abs(xMaxPx - xMinPx);
            const h = Math.abs(yMaxPx - yZeroPx);
            const x = Math.min(xMinPx, xMaxPx);
            const y = Math.min(yZeroPx, yMaxPx);
            let selectionDatumLabel = void 0;
            if (total !== 0) selectionDatumLabel = {
                x: x + w / 2,
                y: y + h / 2,
                text: this.cachedDatumCallback($d77b025aa58d633c$var$createDatumId(groupIndex, "label"), ()=>labelFormatter?.({
                        value: total,
                        datum: datum,
                        seriesId: seriesId,
                        xKey: xKey,
                        yKey: yKey,
                        xName: xName,
                        yName: yName
                    })) ?? yAxis.formatDatum(total)
            };
            const nodeMidPoint = {
                x: x + w / 2,
                y: y + h / 2
            };
            const yAxisReversed = yAxis.isReversed();
            nodeData.push({
                series: this,
                datumIndex: groupIndex,
                datum: datum,
                // required by SeriesNodeDatum, but might not make sense here
                // since each selection is an aggregation of multiple data.
                aggregatedValue: total,
                frequency: frequency,
                domain: domain,
                yKey: yKey,
                xKey: xKey,
                x: x,
                y: y,
                xValue: xMinPx,
                yValue: yMaxPx,
                width: w,
                height: h,
                midPoint: nodeMidPoint,
                topLeftCornerRadius: !yAxisReversed,
                topRightCornerRadius: !yAxisReversed,
                bottomRightCornerRadius: yAxisReversed,
                bottomLeftCornerRadius: yAxisReversed,
                label: selectionDatumLabel,
                crisp: true
            });
        });
        nodeData.sort((a, b)=>a.x - b.x);
        return context;
    }
    nodeFactory() {
        return new $d77b025aa58d633c$var$Rect();
    }
    updateDatumSelection(opts) {
        const { nodeData: nodeData, datumSelection: datumSelection } = opts;
        return datumSelection.update(nodeData, void 0, (datum)=>datum.domain.join("_"));
    }
    getItemBaseStyle(highlighted) {
        const { properties: properties } = this;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return $d77b025aa58d633c$var$getShapeStyle({
            fill: highlightStyle?.fill ?? properties.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? properties.fillOpacity,
            stroke: highlightStyle?.stroke ?? properties.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(properties.strokeWidth),
            strokeOpacity: highlightStyle?.strokeOpacity ?? properties.strokeOpacity,
            lineDash: highlightStyle?.lineDash ?? properties.lineDash,
            lineDashOffset: highlightStyle?.lineDashOffset ?? properties.lineDashOffset,
            cornerRadius: properties.cornerRadius
        }, properties.fillGradientDefaults, properties.fillPatternDefaults, properties.fillImageDefaults);
    }
    updateDatumNodes(opts) {
        const { isHighlight: isDatumHighlighted } = opts;
        const { shadow: shadow } = this.properties;
        const style = this.getItemBaseStyle(isDatumHighlighted);
        const fillBBox = this.getShapeFillBBox();
        opts.datumSelection.each((rect, datum)=>{
            const { cornerRadius: cornerRadius } = style;
            const { topLeftCornerRadius: topLeftCornerRadius, topRightCornerRadius: topRightCornerRadius, bottomRightCornerRadius: bottomRightCornerRadius, bottomLeftCornerRadius: bottomLeftCornerRadius } = datum;
            $d77b025aa58d633c$var$applyShapeStyle(rect, style, void 0, fillBBox);
            rect.topLeftCornerRadius = topLeftCornerRadius ? cornerRadius : 0;
            rect.topRightCornerRadius = topRightCornerRadius ? cornerRadius : 0;
            rect.bottomRightCornerRadius = bottomRightCornerRadius ? cornerRadius : 0;
            rect.bottomLeftCornerRadius = bottomLeftCornerRadius ? cornerRadius : 0;
            rect.crisp = datum.crisp;
            rect.fillShadow = shadow;
            rect.visible = datum.height > 0;
        });
    }
    updateLabelSelection(opts) {
        const { labelData: labelData, labelSelection: labelSelection } = opts;
        return labelSelection.update(labelData, (text)=>{
            text.pointerEvents = 1 /* None */ ;
            text.textAlign = "center";
            text.textBaseline = "middle";
        });
    }
    updateLabelNodes(opts) {
        const { fontStyle: fontStyle, fontWeight: fontWeight, fontFamily: fontFamily, fontSize: fontSize, color: color11 } = this.properties.label;
        const labelEnabled = this.isLabelEnabled();
        opts.labelSelection.each((text, datum)=>{
            if (labelEnabled && datum?.label) {
                text.text = datum.label.text;
                text.x = datum.label.x;
                text.y = datum.label.y;
                text.fontStyle = fontStyle;
                text.fontWeight = fontWeight;
                text.fontFamily = fontFamily;
                text.fontSize = fontSize;
                text.fill = color11;
                text.visible = true;
            } else text.visible = false;
        });
    }
    initQuadTree(quadtree) {
        const { value: childNode } = this.contentGroup.children().next();
        if (childNode) $d77b025aa58d633c$var$addHitTestersToQuadtree(quadtree, childNode.children());
    }
    pickNodeClosestDatum(point) {
        return $d77b025aa58d633c$var$findQuadtreeMatch(this, point);
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, axes: axes, properties: properties, ctx: { localeManager: localeManager } } = this;
        const { xKey: xKey, xName: xName, yKey: yKey, yName: yName, tooltip: tooltip } = properties;
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        if (!dataModel || processedData?.type !== "grouped" || !xAxis || !yAxis) return;
        const group = processedData.groups[datumIndex];
        const { aggregation: aggregation, keys: keys } = group;
        const [[negativeAgg, positiveAgg] = [
            0,
            0
        ]] = aggregation;
        const frequency = this.frequency(group);
        const domain = keys;
        const [rangeMin, rangeMax] = domain;
        const aggregatedValue = negativeAgg + positiveAgg;
        const datum = {
            data: [
                ...dataModel.forEachDatum(this, processedData, group)
            ],
            aggregatedValue: aggregatedValue,
            frequency: frequency,
            domain: domain
        };
        const data = [
            {
                label: xName,
                fallbackLabel: xKey,
                value: `${xAxis.formatDatum(rangeMin)} - ${xAxis.formatDatum(rangeMax)}`
            },
            {
                label: localeManager.t("seriesHistogramTooltipFrequency"),
                value: yAxis.formatDatum(frequency)
            }
        ];
        if (yKey != null) {
            let label;
            switch(properties.aggregation){
                case "sum":
                    label = localeManager.t("seriesHistogramTooltipSum", {
                        yName: yName ?? yKey
                    });
                    break;
                case "mean":
                    label = localeManager.t("seriesHistogramTooltipMean", {
                        yName: yName ?? yKey
                    });
                    break;
                case "count":
                    label = localeManager.t("seriesHistogramTooltipCount", {
                        yName: yName ?? yKey
                    });
                    break;
            }
            data.push({
                label: label,
                value: yAxis.formatDatum(aggregatedValue)
            });
        }
        return this.formatTooltipWithContext(tooltip, {
            symbol: this.legendItemSymbol(),
            data: data
        }, {
            seriesId: seriesId,
            datum: datum,
            title: yName,
            xKey: xKey,
            xName: xName,
            yKey: yKey,
            yName: yName,
            xRange: [
                rangeMin,
                rangeMax
            ],
            frequency: frequency,
            ...this.getItemBaseStyle(false)
        });
    }
    legendItemSymbol() {
        const { fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, fillGradientDefaults: fillGradientDefaults2, fillPatternDefaults: fillPatternDefaults2, fillImageDefaults: fillImageDefaults2 } = this.properties;
        return {
            marker: $d77b025aa58d633c$var$getShapeStyle({
                fill: fill ?? "rgba(0, 0, 0, 0)",
                stroke: stroke2 ?? "rgba(0, 0, 0, 0)",
                fillOpacity: fillOpacity,
                strokeOpacity: strokeOpacity,
                strokeWidth: strokeWidth,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset
            }, fillGradientDefaults2, fillPatternDefaults2, fillImageDefaults2)
        };
    }
    getLegendData(legendType) {
        if (legendType !== "category") return [];
        const { id: seriesId, ctx: { legendManager: legendManager }, visible: visible } = this;
        const { xKey: itemId, yName: yName, showInLegend: showInLegend } = this.properties;
        return [
            {
                legendType: "category",
                id: seriesId,
                itemId: itemId,
                seriesId: seriesId,
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: seriesId,
                    itemId: itemId
                }),
                label: {
                    text: yName ?? itemId ?? "Frequency"
                },
                symbol: this.legendItemSymbol(),
                hideInLegend: !showInLegend
            }
        ];
    }
    animateEmptyUpdateReady({ datumSelection: datumSelection, labelSelection: labelSelection }) {
        const fns = $d77b025aa58d633c$var$prepareBarAnimationFunctions($d77b025aa58d633c$var$collapsedStartingBarPosition(true, this.axes, "normal"));
        $d77b025aa58d633c$var$fromToMotion(this.id, "datums", this.ctx.animationManager, [
            datumSelection
        ], fns);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, labelSelection);
    }
    animateWaitingUpdateReady(data) {
        const fns = $d77b025aa58d633c$var$prepareBarAnimationFunctions($d77b025aa58d633c$var$collapsedStartingBarPosition(true, this.axes, "normal"));
        const dataDiff = $d77b025aa58d633c$var$calculateDataDiff(this.id, data.datumSelection, (datum)=>$d77b025aa58d633c$var$createDatumId(datum.domain), data.contextData, data.previousContextData, this.processedData);
        $d77b025aa58d633c$var$fromToMotion(this.id, "datums", this.ctx.animationManager, [
            data.datumSelection
        ], fns, (_, datum)=>$d77b025aa58d633c$var$createDatumId(datum.domain), dataDiff);
        if (dataDiff?.changed) $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, data.labelSelection);
    }
    isLabelEnabled() {
        return this.properties.label.enabled;
    }
    computeFocusBounds({ datumIndex: datumIndex }) {
        return $d77b025aa58d633c$var$computeBarFocusBounds(this, this.contextNodeData?.nodeData[datumIndex]);
    }
};
$d77b025aa58d633c$var$HistogramSeries.className = "HistogramSeries";
$d77b025aa58d633c$var$HistogramSeries.type = "histogram";
var $d77b025aa58d633c$var$histogramSeriesThemeableOptionsDef = {
    showInMiniChart: (0, $idDdm.boolean),
    cornerRadius: (0, $idDdm.positiveNumber),
    label: $d77b025aa58d633c$var$seriesLabelOptionsDefs,
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    shadow: $d77b025aa58d633c$var$shadowOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$histogramSeriesOptionsDef = {
    ...$d77b025aa58d633c$var$histogramSeriesThemeableOptionsDef,
    ...$d77b025aa58d633c$var$commonSeriesOptionsDefs,
    type: (0, $idDdm.required)((0, $idDdm.constant)("histogram")),
    xKey: (0, $idDdm.required)((0, $idDdm.string)),
    yKey: (0, $idDdm.string),
    xName: (0, $idDdm.string),
    yName: (0, $idDdm.string),
    areaPlot: (0, $idDdm.boolean),
    aggregation: (0, $idDdm.union)("count", "sum", "mean"),
    bins: (0, $idDdm.arrayOf)((0, $idDdm.arrayOf)((0, $idDdm.number))),
    binCount: (0, $idDdm.positiveNumber)
};
// packages/ag-charts-community/src/chart/series/cartesian/histogramSeriesModule.ts
var $d77b025aa58d633c$var$HistogramSeriesModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "community",
    chartTypes: [
        "cartesian"
    ],
    identifier: "histogram",
    moduleFactory: (ctx)=>new $d77b025aa58d633c$var$HistogramSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    defaultAxes: [
        {
            type: "number" /* NUMBER */ ,
            position: "bottom" /* BOTTOM */ 
        },
        {
            type: "number" /* NUMBER */ ,
            position: "left" /* LEFT */ 
        }
    ],
    themeTemplate: {
        series: {
            fill: {
                $palette: "fill"
            },
            stroke: {
                $palette: "stroke"
            },
            // @ts-expect-error undocumented option
            fillGradientDefaults: {
                type: "gradient",
                gradient: "linear",
                bounds: "item",
                colorStops: {
                    $palette: "gradient"
                },
                rotation: 0,
                reverse: false
            },
            fillPatternDefaults: $d77b025aa58d633c$var$FILL_PATTERN_DEFAULTS,
            fillImageDefaults: $d77b025aa58d633c$var$FILL_IMAGE_DEFAULTS,
            strokeWidth: 1,
            fillOpacity: 1,
            strokeOpacity: 1,
            lineDash: [
                0
            ],
            lineDashOffset: 0,
            label: {
                enabled: false,
                fontSize: {
                    $ref: "fontSize"
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontWeight: {
                    $ref: "fontWeight"
                },
                color: {
                    $ref: "backgroundColor"
                }
            },
            shadow: {
                enabled: false,
                color: $d77b025aa58d633c$var$DEFAULT_SHADOW_COLOUR,
                xOffset: 3,
                yOffset: 3,
                blur: 5
            }
        }
    }
};
var $d77b025aa58d633c$var$NewHistogramSeriesModule = {
    type: "series",
    name: "histogram",
    chartType: "cartesian",
    enterprise: true,
    options: $d77b025aa58d633c$var$histogramSeriesOptionsDef,
    create: (ctx)=>new $d77b025aa58d633c$var$HistogramSeries(ctx)
};
// packages/ag-charts-community/src/chart/series/cartesian/lineSeriesProperties.ts
var $d77b025aa58d633c$var$LineSeriesProperties = class extends $d77b025aa58d633c$var$CartesianSeriesProperties {
    constructor(){
        super(...arguments);
        this.stroke = "#874349";
        this.strokeWidth = 2;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.interpolation = new $d77b025aa58d633c$var$InterpolationProperties();
        this.marker = new $d77b025aa58d633c$var$SeriesMarker();
        this.label = new $d77b025aa58d633c$var$Label();
        this.tooltip = new $d77b025aa58d633c$var$SeriesTooltip();
        this.connectMissingData = false;
        this.sparklineMode = false;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "xKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "yKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "xName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "yName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "yFilterKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "stackGroup", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "normalizedTo", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "title", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "interpolation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "marker", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "tooltip", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "connectMissingData", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "sparklineMode", 2);
// packages/ag-charts-community/src/chart/series/cartesian/lineSeries.ts
var $d77b025aa58d633c$var$CROSS_FILTER_LINE_STROKE_OPACITY_FACTOR = 0.25;
var $d77b025aa58d633c$var$LineSeries = class extends $d77b025aa58d633c$var$CartesianSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            directionKeys: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_KEYS,
            directionNames: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_NAMES,
            categoryKey: "xValue",
            hasMarkers: true,
            pickModes: [
                2 /* AXIS_ALIGNED */ ,
                1 /* NEAREST_NODE */ ,
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            markerSelectionGarbageCollection: false,
            animationResetFns: {
                path: $d77b025aa58d633c$var$buildResetPathFn({
                    getVisible: ()=>this.visible,
                    getOpacity: ()=>this.getOpacity()
                }),
                label: $d77b025aa58d633c$var$resetLabelFn,
                marker: (node, datum)=>({
                        ...$d77b025aa58d633c$var$resetMarkerFn(node),
                        ...$d77b025aa58d633c$var$resetMarkerPositionFn(node, datum)
                    })
            },
            clipFocusBox: false
        });
        this.properties = new $d77b025aa58d633c$var$LineSeriesProperties();
        this.dataAggregationFilters = void 0;
    }
    get pickModeAxis() {
        return this.properties.sparklineMode ? "main" : "main-category";
    }
    async processData(dataController) {
        if (this.data == null) return;
        const { data: data, visible: visible, seriesGrouping: { groupIndex: groupIndex = this.id, stackCount: stackCount = 0 } = {} } = this;
        const { xKey: xKey, yKey: yKey, yFilterKey: yFilterKey, connectMissingData: connectMissingData, normalizedTo: normalizedTo } = this.properties;
        const animationEnabled = !this.ctx.animationManager.isSkipped();
        const xScale = this.axes["x" /* X */ ]?.scale;
        const yScale = this.axes["y" /* Y */ ]?.scale;
        const { isContinuousX: isContinuousX, xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
            xScale: xScale,
            yScale: yScale
        });
        const stacked = stackCount >= 1 || normalizedTo != null;
        const common = {
            invalidValue: null
        };
        if (connectMissingData && stacked) common.invalidValue = 0;
        if (stacked && !visible) common.forceValue = 0;
        const props = [];
        if (!isContinuousX || stacked) props.push($d77b025aa58d633c$var$keyProperty(xKey, xScaleType, {
            id: "xKey"
        }));
        props.push($d77b025aa58d633c$var$valueProperty(xKey, xScaleType, {
            id: "xValue"
        }), $d77b025aa58d633c$var$valueProperty(yKey, yScaleType, {
            id: `yValueRaw`,
            ...common,
            invalidValue: void 0
        }));
        if (yFilterKey != null) props.push($d77b025aa58d633c$var$valueProperty(yFilterKey, yScaleType, {
            id: "yFilterRaw"
        }));
        if (stacked) {
            const ids = [
                `line-stack-${groupIndex}-yValues`,
                `line-stack-${groupIndex}-yValues-trailing`,
                `line-stack-${groupIndex}-yValues-marker`
            ];
            props.push(...$d77b025aa58d633c$var$groupAccumulativeValueProperty(yKey, "window", "current", {
                id: `yValueEnd`,
                ...common,
                groupId: ids[0]
            }, yScaleType), ...$d77b025aa58d633c$var$groupAccumulativeValueProperty(yKey, "window-trailing", "current", {
                id: `yValueStart`,
                ...common,
                groupId: ids[1]
            }, yScaleType), ...$d77b025aa58d633c$var$groupAccumulativeValueProperty(yKey, "normal", "current", {
                id: `yValueCumulative`,
                ...common,
                groupId: ids[2]
            }, yScaleType));
            if ((0, $idDdm.isDefined)(normalizedTo)) props.push($d77b025aa58d633c$var$normaliseGroupTo([
                ids[0],
                ids[1],
                ids[2]
            ], normalizedTo));
        }
        if (animationEnabled) {
            props.push($d77b025aa58d633c$var$animationValidation(isContinuousX ? [
                "xValue"
            ] : void 0));
            if (this.processedData) props.push($d77b025aa58d633c$var$diff(this.id, this.processedData));
        }
        const { dataModel: dataModel, processedData: processedData } = await this.requestDataModel(dataController, data, {
            props: props,
            groupByKeys: stacked,
            groupByData: !stacked
        });
        this.dataAggregationFilters = this.aggregateData(dataModel, processedData);
        this.animationState.transition("updateData");
    }
    xCoordinateRange(xValue, pixelSize) {
        const { marker: marker } = this.properties;
        const x = this.axes["x" /* X */ ].scale.convert(xValue);
        const r = marker.enabled ? 0.5 * marker.size * pixelSize : 0;
        return [
            x - r,
            x + r
        ];
    }
    yCoordinateRange(yValues, pixelSize) {
        const { marker: marker } = this.properties;
        const y = this.axes["y" /* Y */ ].scale.convert(yValues[0]);
        const r = marker.enabled ? 0.5 * marker.size * pixelSize : 0;
        return [
            y - r,
            y + r
        ];
    }
    getSeriesDomain(direction) {
        const { dataModel: dataModel, processedData: processedData } = this;
        if (!dataModel || !processedData) return [];
        if (direction === "x" /* X */ ) {
            const xDef = dataModel.resolveProcessedDataDefById(this, `xValue`);
            const domain = dataModel.getDomain(this, `xValue`, "value", processedData);
            if (xDef?.def.type === "value" && xDef.def.valueType === "category") return domain;
            return $d77b025aa58d633c$var$fixNumericExtent($d77b025aa58d633c$var$extent(domain));
        }
        const yKey = this.dataModel?.hasColumnById(this, `yValueEnd`) ? "yValueEnd" : "yValueRaw";
        const yExtent = this.domainForClippedRange("y" /* Y */ , [
            yKey
        ], "xValue", true);
        return $d77b025aa58d633c$var$fixNumericExtent(yExtent);
    }
    getSeriesRange(_direction, visibleRange) {
        const yKey = this.dataModel?.hasColumnById(this, `yValueEnd`) ? "yValueEnd" : "yValueRaw";
        return this.domainForVisibleRange("y" /* Y */ , [
            yKey
        ], "xValue", visibleRange, true);
    }
    getVisibleItems(xVisibleRange, yVisibleRange, minVisibleItems) {
        const yKey = this.dataModel?.hasColumnById(this, `yValueEnd`) ? "yValueEnd" : "yValueRaw";
        return this.countVisibleItems("xValue", [
            yKey
        ], xVisibleRange, yVisibleRange, minVisibleItems);
    }
    aggregateData(_dataModel, _processedData) {
        return;
    }
    createNodeData() {
        const { dataModel: dataModel, processedData: processedData, axes: axes, dataAggregationFilters: dataAggregationFilters } = this;
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        if (!dataModel || !processedData || !xAxis || !yAxis) return;
        const { xKey: xKey, yKey: yKey, yFilterKey: yFilterKey, xName: xName, yName: yName, marker: marker, label: label, connectMissingData: connectMissingData, interpolation: interpolation, legendItemName: legendItemName } = this.properties;
        const stacked = this.dataModel?.hasColumnById(this, `yValueEnd`);
        const xScale = xAxis.scale;
        const yScale = yAxis.scale;
        const xOffset = (xScale.bandwidth ?? 0) / 2;
        const yOffset = (yScale.bandwidth ?? 0) / 2;
        const size = marker.enabled ? marker.size : 0;
        const rawData = processedData.dataSources.get(this.id) ?? [];
        const xValues = dataModel.resolveColumnById(this, `xValue`, processedData);
        const yValues = dataModel.resolveColumnById(this, `yValueRaw`, processedData);
        const yEndValues = stacked ? dataModel.resolveColumnById(this, `yValueEnd`, processedData) : void 0;
        const yCumulativeValues = stacked ? dataModel.resolveColumnById(this, `yValueCumulative`, processedData) : yValues;
        const selectionValues = yFilterKey != null ? dataModel.resolveColumnById(this, `yFilterRaw`, processedData) : void 0;
        const xPosition = (index)=>xScale.convert(xValues[index]) + xOffset;
        const yPosition = (index)=>yScale.convert(yCumulativeValues[index]) + yOffset;
        const capDefaults = {
            lengthRatioMultiplier: this.properties.marker.getDiameter(),
            lengthMax: Infinity
        };
        const nodeData = [];
        let spanPoints;
        const handleDatum = (datumIndex)=>{
            const datum = rawData[datumIndex];
            const xDatum = xValues[datumIndex];
            const yDatum = yValues[datumIndex];
            const yEndDatum = yEndValues?.[datumIndex];
            const selected = selectionValues?.[datumIndex];
            const x = xPosition(datumIndex);
            const y = yPosition(datumIndex);
            if (!Number.isFinite(x)) return;
            if (yDatum != null) {
                const labelText = label.enabled ? this.getLabelText(label, {
                    value: yDatum,
                    datum: datum,
                    xKey: xKey,
                    yKey: yKey,
                    xName: xName,
                    yName: yName,
                    legendItemName: legendItemName
                }) : void 0;
                nodeData.push({
                    series: this,
                    datum: datum,
                    datumIndex: datumIndex,
                    yKey: yKey,
                    xKey: xKey,
                    point: {
                        x: x,
                        y: y,
                        size: size
                    },
                    midPoint: {
                        x: x,
                        y: y
                    },
                    cumulativeValue: yEndDatum,
                    yValue: yDatum,
                    xValue: xDatum,
                    capDefaults: capDefaults,
                    labelText: labelText,
                    selected: selected
                });
            }
            if (spanPoints == null) return;
            const currentSpanPoints = spanPoints[spanPoints.length - 1];
            if (yDatum != null) {
                const spanPoint = {
                    point: {
                        x: x,
                        y: y
                    },
                    xDatum: xDatum,
                    yDatum: yDatum
                };
                if (Array.isArray(currentSpanPoints)) currentSpanPoints.push(spanPoint);
                else if (currentSpanPoints != null) {
                    currentSpanPoints.skip += 1;
                    spanPoints.push([
                        spanPoint
                    ]);
                } else spanPoints.push([
                    spanPoint
                ]);
            } else if (!connectMissingData) {
                if (Array.isArray(currentSpanPoints) || currentSpanPoints == null) spanPoints.push({
                    skip: 0
                });
                else currentSpanPoints.skip += 1;
            }
        };
        const [r0, r1] = xScale.range;
        const range3 = r1 - r0;
        const dataAggregationFilter = dataAggregationFilters?.find((f)=>f.maxRange > range3);
        const indices = dataAggregationFilter?.indices;
        let [start2, end2] = this.visibleRange("xValue", xAxis.range, indices);
        start2 = Math.max(start2 - 1, 0);
        end2 = Math.min(end2 + 1, indices?.length ?? xValues.length);
        if (processedData.input.count < 1e3) {
            start2 = 0;
            end2 = processedData.input.count;
        }
        if (indices == null) spanPoints = [];
        for(let i = start2; i < end2; i += 1)handleDatum(indices?.[i] ?? i);
        const strokeSpans = spanPoints?.flatMap((p)=>{
            return Array.isArray(p) ? $d77b025aa58d633c$var$interpolatePoints(p, interpolation) : [];
        });
        const strokeData = strokeSpans != null ? {
            itemId: yKey,
            spans: strokeSpans
        } : void 0;
        const crossFiltering = selectionValues?.some((selectionValue, index)=>selectionValue === yValues[index]) ?? false;
        return {
            itemId: yKey,
            nodeData: nodeData,
            labelData: nodeData,
            strokeData: strokeData,
            scales: this.calculateScaling(),
            visible: this.visible,
            crossFiltering: crossFiltering
        };
    }
    isPathOrSelectionDirty() {
        return this.properties.marker.isDirty();
    }
    updatePathNodes(opts) {
        const { paths: [lineNode], opacity: opacity, visible: visible, animationEnabled: animationEnabled } = opts;
        const crossFiltering = this.contextNodeData?.crossFiltering === true;
        lineNode.setProperties({
            fill: void 0,
            lineJoin: "round",
            pointerEvents: 1 /* None */ ,
            opacity: opacity,
            stroke: this.properties.stroke,
            strokeWidth: this.getStrokeWidth(this.properties.strokeWidth),
            strokeOpacity: this.properties.strokeOpacity * (crossFiltering ? $d77b025aa58d633c$var$CROSS_FILTER_LINE_STROKE_OPACITY_FACTOR : 1),
            lineDash: this.properties.lineDash,
            lineDashOffset: this.properties.lineDashOffset
        });
        if (!animationEnabled) lineNode.visible = visible;
        $d77b025aa58d633c$var$updateClipPath(this, lineNode);
    }
    getMarkerItemBaseStyle(highlighted) {
        const { properties: properties } = this;
        const { marker: marker } = properties;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return $d77b025aa58d633c$var$getShapeStyle({
            size: marker.size,
            shape: marker.shape,
            fill: highlightStyle?.fill ?? marker.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? marker.fillOpacity,
            stroke: highlightStyle?.stroke ?? marker.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? marker.strokeWidth,
            strokeOpacity: highlightStyle?.strokeOpacity ?? marker.strokeOpacity,
            lineDash: highlightStyle?.lineDash ?? marker.lineDash,
            lineDashOffset: highlightStyle?.lineDashOffset ?? marker.lineDashOffset
        }, marker.fillGradientDefaults, marker.fillPatternDefaults, marker.fillImageDefaults);
    }
    getMarkerItemStyleOverrides(datumId, datum, format, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const { xKey: xKey, yKey: yKey, marker: marker } = properties;
        const { itemStyler: itemStyler } = marker;
        if (itemStyler == null) return;
        return this.cachedDatumCallback($d77b025aa58d633c$var$createDatumId(datumId, highlighted ? "highlight" : "node"), ()=>{
            const xDomain = this.getSeriesDomain("x" /* X */ );
            const yDomain = this.getSeriesDomain("y" /* Y */ );
            return this.callWithContext(itemStyler, {
                seriesId: seriesId,
                ...$d77b025aa58d633c$var$datumStylerProperties(datum, xKey, yKey, xDomain, yDomain),
                datum: datum,
                highlighted: highlighted,
                ...format
            });
        });
    }
    updateMarkerSelection(opts) {
        let { nodeData: nodeData } = opts;
        const { markerSelection: markerSelection } = opts;
        const markersEnabled = this.properties.marker.enabled || this.contextNodeData?.crossFiltering === true;
        nodeData = markersEnabled ? nodeData : [];
        if (this.properties.marker.isDirty()) {
            markerSelection.clear();
            markerSelection.cleanup();
        }
        return markerSelection.update(nodeData, void 0, (datum)=>$d77b025aa58d633c$var$createDatumId(datum.xValue));
    }
    updateMarkerNodes(opts) {
        const { markerSelection: markerSelection, isHighlight: highlighted } = opts;
        const { xKey: xKey, yKey: yKey, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, marker: marker, highlightStyle: highlightStyle } = this.properties;
        const xDomain = this.getSeriesDomain("x" /* X */ );
        const yDomain = this.getSeriesDomain("y" /* Y */ );
        const baseStyle = $d77b025aa58d633c$var$mergeDefaults(highlighted && highlightStyle.item, marker.getStyle(), {
            stroke: stroke2,
            strokeWidth: strokeWidth,
            strokeOpacity: strokeOpacity
        });
        const applyTranslation = this.ctx.animationManager.isSkipped();
        const fillBBox = this.getShapeFillBBox();
        markerSelection.each((node, datum)=>{
            this.updateMarkerStyle(marker, node, datum.datum, datum.point, $d77b025aa58d633c$var$datumStylerProperties(datum, xKey, yKey, xDomain, yDomain), highlighted, baseStyle, fillBBox, {
                applyTranslation: applyTranslation,
                selected: datum.selected
            });
        });
        if (!highlighted) marker.markClean();
    }
    updateLabelSelection(opts) {
        return opts.labelSelection.update(this.isLabelEnabled() ? opts.labelData : []);
    }
    updateLabelNodes(opts) {
        const { enabled: enabled, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily, color: color11 } = this.properties.label;
        opts.labelSelection.each((text, datum)=>{
            if (enabled && datum?.labelText) {
                text.fontStyle = fontStyle;
                text.fontWeight = fontWeight;
                text.fontSize = fontSize;
                text.fontFamily = fontFamily;
                text.textAlign = "center";
                text.textBaseline = "bottom";
                text.text = datum.labelText;
                text.x = datum.point.x;
                text.y = datum.point.y - 10;
                text.fill = color11;
                text.visible = true;
            } else text.visible = false;
        });
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, axes: axes, properties: properties } = this;
        const { xKey: xKey, xName: xName, yKey: yKey, yName: yName, tooltip: tooltip } = properties;
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        if (!dataModel || !processedData || !xAxis || !yAxis) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const xValue = dataModel.resolveColumnById(this, `xValue`, processedData)[datumIndex];
        const yValue = dataModel.resolveColumnById(this, `yValueRaw`, processedData)[datumIndex];
        if (xValue == null) return;
        const format = this.getMarkerItemBaseStyle(false);
        Object.assign(format, this.getMarkerItemStyleOverrides(String(datumIndex), datum, format, false));
        return this.formatTooltipWithContext(tooltip, {
            heading: xAxis.formatDatum(xValue),
            symbol: this.legendItemSymbol(),
            data: [
                {
                    label: yName,
                    fallbackLabel: yKey,
                    value: yAxis.formatDatum(yValue)
                }
            ]
        }, {
            seriesId: seriesId,
            datum: datum,
            title: yName,
            xKey: xKey,
            xName: xName,
            yKey: yKey,
            yName: yName,
            ...format,
            ...this.getModuleTooltipParams()
        });
    }
    legendItemSymbol() {
        const color0 = "rgba(0, 0, 0, 0)";
        const { stroke: stroke2, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, marker: marker } = this.properties;
        const markerStyle = this.getMarkerStyle(marker, void 0, void 0, false, void 0, {
            fill: marker.fill ?? color0,
            stroke: marker.stroke ?? stroke2 ?? color0
        });
        return {
            marker: {
                ...markerStyle,
                enabled: marker.enabled
            },
            line: {
                stroke: stroke2 ?? color0,
                strokeOpacity: strokeOpacity,
                strokeWidth: strokeWidth,
                lineDash: lineDash
            }
        };
    }
    getLegendData(legendType) {
        if (legendType !== "category") return [];
        const { id: seriesId, ctx: { legendManager: legendManager }, visible: visible } = this;
        const { yKey: itemId, yName: yName, title: title, legendItemName: legendItemName, showInLegend: showInLegend } = this.properties;
        return [
            {
                legendType: "category",
                id: seriesId,
                itemId: itemId,
                legendItemName: legendItemName,
                seriesId: seriesId,
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: seriesId,
                    itemId: itemId
                }),
                label: {
                    text: legendItemName ?? title ?? yName ?? itemId
                },
                symbol: this.legendItemSymbol(),
                hideInLegend: !showInLegend
            }
        ];
    }
    updatePaths(opts) {
        this.updateLinePaths(opts.paths, opts.contextData);
    }
    plotNodeDataPoints(path, nodeData) {
        if (nodeData.length === 0) return;
        const initialPoint = nodeData[0].point;
        path.moveTo(initialPoint.x, initialPoint.y);
        for(let i = 1; i < nodeData.length; i += 1){
            const { x: x, y: y } = nodeData[i].point;
            path.lineTo(x, y);
        }
    }
    updateLinePaths(paths, contextData) {
        const spans = contextData.strokeData?.spans;
        const [lineNode] = paths;
        lineNode.path.clear();
        if (spans != null) $d77b025aa58d633c$var$plotLinePathStroke(lineNode, spans);
        else this.plotNodeDataPoints(lineNode.path, contextData.nodeData);
        lineNode.markDirty("LineSeries");
    }
    animateEmptyUpdateReady(animationData) {
        const { markerSelection: markerSelection, labelSelection: labelSelection, annotationSelections: annotationSelections, contextData: contextData, paths: paths } = animationData;
        const { animationManager: animationManager } = this.ctx;
        this.updateLinePaths(paths, contextData);
        $d77b025aa58d633c$var$pathSwipeInAnimation(this, animationManager, ...paths);
        $d77b025aa58d633c$var$resetMotion([
            markerSelection
        ], $d77b025aa58d633c$var$resetMarkerPositionFn);
        $d77b025aa58d633c$var$markerSwipeScaleInAnimation(this, animationManager, markerSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "annotations", animationManager, ...annotationSelections);
    }
    animateReadyResize(animationData) {
        const { contextData: contextData, paths: paths } = animationData;
        this.updateLinePaths(paths, contextData);
        super.animateReadyResize(animationData);
    }
    animateWaitingUpdateReady(animationData) {
        const { animationManager: animationManager } = this.ctx;
        const { markerSelection: markerSelections, labelSelection: labelSelections, annotationSelections: annotationSelections, contextData: contextData, paths: paths, previousContextData: previousContextData } = animationData;
        const [path] = paths;
        this.resetMarkerAnimation(animationData);
        this.resetLabelAnimation(animationData);
        const update = ()=>{
            this.resetPathAnimation(animationData);
            this.updateLinePaths(paths, contextData);
        };
        const skip = ()=>{
            animationManager.skipCurrentBatch();
            update();
        };
        if (contextData == null || previousContextData == null) {
            update();
            $d77b025aa58d633c$var$markerFadeInAnimation(this, animationManager, "added", markerSelections);
            $d77b025aa58d633c$var$pathFadeInAnimation(this, "path_properties", animationManager, "add", path);
            $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelections);
            $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "annotations", animationManager, ...annotationSelections);
            return;
        }
        if (contextData.crossFiltering !== previousContextData.crossFiltering) {
            skip();
            return;
        }
        const fns = $d77b025aa58d633c$var$prepareLinePathAnimation(contextData, previousContextData, this.processedData?.reduced?.diff?.[this.id]);
        if (fns === void 0) {
            skip();
            return;
        } else if (fns.status === "no-op") return;
        $d77b025aa58d633c$var$fromToMotion(this.id, "path_properties", animationManager, [
            path
        ], fns.stroke.pathProperties);
        if (fns.status === "added") this.updateLinePaths(paths, contextData);
        else if (fns.status === "removed") this.updateLinePaths(paths, previousContextData);
        else $d77b025aa58d633c$var$pathMotion(this.id, "path_update", animationManager, [
            path
        ], fns.stroke.path);
        if (fns.hasMotion) {
            $d77b025aa58d633c$var$markerFadeInAnimation(this, animationManager, void 0, markerSelections);
            $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelections);
            $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "annotations", animationManager, ...annotationSelections);
        }
    }
    isLabelEnabled() {
        return this.properties.label.enabled;
    }
    getBandScalePadding() {
        return {
            inner: 1,
            outer: 0.1
        };
    }
    nodeFactory() {
        return new $d77b025aa58d633c$var$Group();
    }
    getFormattedMarkerStyle(datum) {
        const { xKey: xKey, yKey: yKey } = this.properties;
        const xDomain = this.getSeriesDomain("x" /* X */ );
        const yDomain = this.getSeriesDomain("y" /* Y */ );
        return this.getMarkerStyle(this.properties.marker, datum.datum, $d77b025aa58d633c$var$datumStylerProperties(datum, xKey, yKey, xDomain, yDomain), true);
    }
    computeFocusBounds(opts) {
        return $d77b025aa58d633c$var$computeMarkerFocusBounds(this, opts);
    }
};
$d77b025aa58d633c$var$LineSeries.className = "LineSeries";
$d77b025aa58d633c$var$LineSeries.type = "line";
var $d77b025aa58d633c$var$lineSeriesThemeableOptionsDef = {
    title: (0, $idDdm.string),
    showInMiniChart: (0, $idDdm.boolean),
    connectMissingData: (0, $idDdm.boolean),
    interpolation: $d77b025aa58d633c$var$interpolationOptionsDefs,
    label: $d77b025aa58d633c$var$seriesLabelOptionsDefs,
    marker: $d77b025aa58d633c$var$markerOptionsDefs,
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    errorBar: $d77b025aa58d633c$var$errorBarThemeableOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
$d77b025aa58d633c$var$lineSeriesThemeableOptionsDef.sparklineMode = (0, $idDdm.undocumented)((0, $idDdm.boolean));
var $d77b025aa58d633c$var$lineSeriesOptionsDef = {
    ...$d77b025aa58d633c$var$lineSeriesThemeableOptionsDef,
    ...$d77b025aa58d633c$var$commonSeriesOptionsDefs,
    type: (0, $idDdm.constant)("line"),
    xKey: (0, $idDdm.required)((0, $idDdm.string)),
    yKey: (0, $idDdm.required)((0, $idDdm.string)),
    xName: (0, $idDdm.string),
    yName: (0, $idDdm.string),
    stacked: (0, $idDdm.boolean),
    stackGroup: (0, $idDdm.string),
    normalizedTo: (0, $idDdm.number),
    legendItemName: (0, $idDdm.string),
    errorBar: $d77b025aa58d633c$var$errorBarOptionsDefs
};
$d77b025aa58d633c$var$lineSeriesOptionsDef.pickOutsideVisibleMinorAxis = (0, $idDdm.undocumented)((0, $idDdm.boolean));
$d77b025aa58d633c$var$lineSeriesOptionsDef.focusPriority = (0, $idDdm.undocumented)((0, $idDdm.number));
// packages/ag-charts-community/src/chart/series/cartesian/lineSeriesModule.ts
var $d77b025aa58d633c$var$LineSeriesModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "community",
    chartTypes: [
        "cartesian"
    ],
    identifier: "line",
    moduleFactory: (ctx)=>new $d77b025aa58d633c$var$LineSeries(ctx),
    stackable: true,
    tooltipDefaults: {
        range: "nearest"
    },
    defaultAxes: [
        {
            type: "number" /* NUMBER */ ,
            position: "left" /* LEFT */ 
        },
        {
            type: "category" /* CATEGORY */ ,
            position: "bottom" /* BOTTOM */ 
        }
    ],
    themeTemplate: {
        series: {
            tooltip: {
                position: {
                    _seriesOverrideType: "node"
                }
            },
            stroke: $d77b025aa58d633c$var$SAFE_STROKE_FILL_OPERATION,
            strokeWidth: 2,
            strokeOpacity: 1,
            lineDash: [
                0
            ],
            lineDashOffset: 0,
            interpolation: {
                type: "linear"
            },
            marker: {
                shape: "circle",
                size: 7,
                strokeWidth: 0,
                fill: {
                    $palette: "fill"
                },
                stroke: {
                    $palette: "stroke"
                },
                // @ts-expect-error undocumented option
                fillGradientDefaults: {
                    type: "gradient",
                    gradient: "radial",
                    bounds: "item",
                    colorStops: {
                        $palette: "gradient"
                    },
                    rotation: 0,
                    reverse: true
                },
                fillPatternDefaults: $d77b025aa58d633c$var$FILL_PATTERN_DEFAULTS,
                fillImageDefaults: $d77b025aa58d633c$var$FILL_IMAGE_DEFAULTS
            },
            label: {
                enabled: false,
                fontSize: {
                    $ref: "fontSize"
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontWeight: {
                    $ref: "fontWeight"
                },
                color: {
                    $ref: "textColor"
                }
            },
            errorBar: {
                cap: {
                    lengthRatio: 1
                }
            }
        }
    }
};
var $d77b025aa58d633c$var$NewLineSeriesModule = {
    type: "series",
    name: "line",
    chartType: "cartesian",
    options: $d77b025aa58d633c$var$lineSeriesOptionsDef,
    create: (ctx)=>new $d77b025aa58d633c$var$LineSeries(ctx)
};
// packages/ag-charts-community/src/chart/series/cartesian/scatterSeriesProperties.ts
var $d77b025aa58d633c$var$ScatterSeriesLabel = class extends $d77b025aa58d633c$var$Label {
    constructor(){
        super(...arguments);
        this.placement = "top";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ScatterSeriesLabel.prototype, "placement", 2);
var $d77b025aa58d633c$var$ScatterSeriesProperties = class extends $d77b025aa58d633c$var$CartesianSeriesProperties {
    constructor(){
        super(...arguments);
        this.label = new $d77b025aa58d633c$var$ScatterSeriesLabel();
        this.tooltip = new $d77b025aa58d633c$var$SeriesTooltip();
        // No validation. Not a part of the options contract.
        this.marker = new $d77b025aa58d633c$var$SeriesMarker();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "xKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "yKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "labelKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "xFilterKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "yFilterKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "xName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "yName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "labelName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "title", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.shape")
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "shape", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.size")
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "size", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.fill")
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.fillGradientDefaults")
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "fillGradientDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.fillPatternDefaults")
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "fillPatternDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.fillImageDefaults")
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "fillImageDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.fillOpacity")
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.stroke")
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.strokeWidth")
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.strokeOpacity")
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.lineDash")
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.lineDashOffset")
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyProperty("marker.itemStyler")
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "itemStyler", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-community/src/chart/series/cartesian/scatterSeries.ts
var $d77b025aa58d633c$var$ScatterSeries = class extends $d77b025aa58d633c$var$CartesianSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            directionKeys: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_KEYS,
            directionNames: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_NAMES,
            categoryKey: void 0,
            pickModes: [
                2 /* AXIS_ALIGNED */ ,
                1 /* NEAREST_NODE */ ,
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            pathsPerSeries: [],
            hasMarkers: true,
            markerSelectionGarbageCollection: false,
            animationResetFns: {
                marker: $d77b025aa58d633c$var$resetMarkerFn,
                label: $d77b025aa58d633c$var$resetLabelFn
            },
            usesPlacedLabels: true,
            clipFocusBox: false
        });
        this.properties = new $d77b025aa58d633c$var$ScatterSeriesProperties();
    }
    get pickModeAxis() {
        return "main-category";
    }
    async processData(dataController) {
        if (this.data == null || !this.visible) return;
        const xScale = this.axes["x" /* X */ ]?.scale;
        const yScale = this.axes["y" /* Y */ ]?.scale;
        const { xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
            xScale: xScale,
            yScale: yScale
        });
        const { xKey: xKey, yKey: yKey, xFilterKey: xFilterKey, yFilterKey: yFilterKey, labelKey: labelKey } = this.properties;
        await this.requestDataModel(dataController, this.data, {
            props: [
                $d77b025aa58d633c$var$valueProperty(xKey, xScaleType, {
                    id: `xValue`
                }),
                $d77b025aa58d633c$var$valueProperty(yKey, yScaleType, {
                    id: `yValue`
                }),
                ...xFilterKey != null ? [
                    $d77b025aa58d633c$var$valueProperty(xFilterKey, xScaleType, {
                        id: "xFilterValue"
                    })
                ] : [],
                ...yFilterKey != null ? [
                    $d77b025aa58d633c$var$valueProperty(yFilterKey, yScaleType, {
                        id: "yFilterValue"
                    })
                ] : [],
                ...labelKey ? [
                    $d77b025aa58d633c$var$valueProperty(labelKey, "band", {
                        id: `labelValue`
                    })
                ] : []
            ]
        });
        this.animationState.transition("updateData");
    }
    xCoordinateRange(xValue, pixelSize) {
        const x = this.axes["x" /* X */ ].scale.convert(xValue);
        const r = 0.5 * this.properties.size * pixelSize;
        return [
            x - r,
            x + r
        ];
    }
    yCoordinateRange(yValues, pixelSize) {
        const y = this.axes["y" /* Y */ ].scale.convert(yValues[0]);
        const r = 0.5 * this.properties.size * pixelSize;
        return [
            y - r,
            y + r
        ];
    }
    getSeriesDomain(direction) {
        const { dataModel: dataModel, processedData: processedData } = this;
        if (!processedData || !dataModel) return [];
        const dataValues = {
            ["x" /* X */ ]: "xValue",
            ["y" /* Y */ ]: "yValue"
        };
        const id = dataValues[direction];
        const dataDef = dataModel.resolveProcessedDataDefById(this, id);
        const domain = dataModel.getDomain(this, id, "value", processedData);
        if (dataDef?.def.type === "value" && dataDef?.def.valueType === "category") return domain;
        const crossDirection = direction === "x" /* X */  ? "y" /* Y */  : "x" /* X */ ;
        const crossId = dataValues[crossDirection];
        const ext = this.domainForClippedRange(direction, [
            id
        ], crossId, false);
        return $d77b025aa58d633c$var$fixNumericExtent($d77b025aa58d633c$var$extent(ext));
    }
    getSeriesRange(_direction, visibleRange) {
        return this.domainForVisibleRange("y" /* Y */ , [
            "yValue"
        ], "xValue", visibleRange, false);
    }
    getVisibleItems(xVisibleRange, yVisibleRange, minVisibleItems) {
        return this.countVisibleItems("xValue", [
            "yValue"
        ], xVisibleRange, yVisibleRange, minVisibleItems);
    }
    createNodeData() {
        const { axes: axes, dataModel: dataModel, processedData: processedData, visible: visible } = this;
        const { xKey: xKey, yKey: yKey, xFilterKey: xFilterKey, yFilterKey: yFilterKey, labelKey: labelKey, xName: xName, yName: yName, labelName: labelName, marker: marker, label: label } = this.properties;
        const { placement: placement } = label;
        const anchor = $d77b025aa58d633c$var$Marker.anchor(marker.shape);
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        if (!(dataModel && processedData && visible && xAxis && yAxis)) return;
        const xDataValues = dataModel.resolveColumnById(this, `xValue`, processedData);
        const yDataValues = dataModel.resolveColumnById(this, `yValue`, processedData);
        const labelDataValues = labelKey != null ? dataModel.resolveColumnById(this, `labelValue`, processedData) : void 0;
        const xFilterDataValues = xFilterKey != null ? dataModel.resolveColumnById(this, `xFilterValue`, processedData) : void 0;
        const yFilterDataValues = yFilterKey != null ? dataModel.resolveColumnById(this, `yFilterValue`, processedData) : void 0;
        const xScale = xAxis.scale;
        const yScale = yAxis.scale;
        const xOffset = (xScale.bandwidth ?? 0) / 2;
        const yOffset = (yScale.bandwidth ?? 0) / 2;
        const nodeData = [];
        const font2 = label.getFont();
        const textMeasurer = $d77b025aa58d633c$var$CachedTextMeasurerPool.getMeasurer({
            font: font2
        });
        const rawData = processedData.dataSources.get(this.id) ?? [];
        rawData.forEach((datum, datumIndex)=>{
            const xDatum = xDataValues[datumIndex];
            const yDatum = yDataValues[datumIndex];
            const x = xScale.convert(xDatum) + xOffset;
            const y = yScale.convert(yDatum) + yOffset;
            const selected = xFilterDataValues != null && yFilterDataValues != null ? xFilterDataValues[datumIndex] === xDatum && yFilterDataValues[datumIndex] === yDatum : void 0;
            const labelText = this.getLabelText(label, {
                value: labelDataValues != null ? labelDataValues?.[datumIndex] : yDatum,
                datum: datum,
                xKey: xKey,
                yKey: yKey,
                labelKey: labelKey,
                xName: xName,
                yName: yName,
                labelName: labelName
            });
            const size = textMeasurer.measureText(labelText);
            nodeData.push({
                series: this,
                itemId: yKey,
                yKey: yKey,
                xKey: xKey,
                datum: datum,
                datumIndex: datumIndex,
                xValue: xDatum,
                yValue: yDatum,
                capDefaults: {
                    lengthRatioMultiplier: marker.getDiameter(),
                    lengthMax: Infinity
                },
                point: {
                    x: x,
                    y: y,
                    size: marker.size
                },
                midPoint: {
                    x: x,
                    y: y
                },
                label: {
                    text: labelText,
                    ...size
                },
                anchor: anchor,
                placement: placement,
                selected: selected
            });
        });
        return {
            itemId: yKey,
            nodeData: nodeData,
            labelData: nodeData,
            scales: this.calculateScaling(),
            visible: this.visible
        };
    }
    isPathOrSelectionDirty() {
        return this.properties.marker.isDirty();
    }
    getLabelData() {
        if (!this.isLabelEnabled()) return [];
        return this.contextNodeData?.labelData ?? [];
    }
    updateMarkerSelection(opts) {
        const { nodeData: nodeData, markerSelection: markerSelection } = opts;
        if (this.properties.marker.isDirty()) {
            markerSelection.clear();
            markerSelection.cleanup();
        }
        return markerSelection.update(this.properties.marker.enabled ? nodeData : []);
    }
    updateMarkerNodes(opts) {
        const { markerSelection: markerSelection, isHighlight: highlighted } = opts;
        const { xKey: xKey, yKey: yKey, labelKey: labelKey, marker: marker, highlightStyle: highlightStyle } = this.properties;
        const baseStyle = $d77b025aa58d633c$var$mergeDefaults(highlighted && highlightStyle.item, marker.getStyle());
        const fillBBox = this.getShapeFillBBox();
        markerSelection.each((node, datum)=>{
            this.updateMarkerStyle(marker, node, datum.datum, datum.point, {
                xKey: xKey,
                yKey: yKey,
                labelKey: labelKey
            }, highlighted, baseStyle, fillBBox, {
                selected: datum.selected
            });
        });
        if (!highlighted) marker.markClean();
    }
    updatePlacedLabelData(labelData) {
        this.labelSelection.update(labelData.map((v)=>({
                ...v.datum,
                point: {
                    x: v.x,
                    y: v.y,
                    size: v.datum.point.size
                }
            })), (text)=>{
            text.pointerEvents = 1 /* None */ ;
        });
        this.updateLabelNodes({
            labelSelection: this.labelSelection
        });
    }
    updateLabelNodes(opts) {
        const { label: label } = this.properties;
        opts.labelSelection.each((text, datum)=>{
            text.text = datum.label.text;
            text.fill = label.color;
            text.x = datum.point?.x ?? 0;
            text.y = datum.point?.y ?? 0;
            text.fontStyle = label.fontStyle;
            text.fontWeight = label.fontWeight;
            text.fontSize = label.fontSize;
            text.fontFamily = label.fontFamily;
            text.textAlign = "left";
            text.textBaseline = "top";
        });
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, axes: axes, properties: properties } = this;
        const { xKey: xKey, xName: xName, yKey: yKey, yName: yName, labelKey: labelKey, labelName: labelName, title: title, tooltip: tooltip, marker: marker } = properties;
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        if (!dataModel || !processedData || !xAxis || !yAxis) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const xValue = dataModel.resolveColumnById(this, `xValue`, processedData)[datumIndex];
        const yValue = dataModel.resolveColumnById(this, `yValue`, processedData)[datumIndex];
        const nodeDatum = this.contextNodeData?.nodeData[datumIndex];
        if (xValue == null || nodeDatum == null) return;
        const activeStyle = this.getMarkerStyle(marker, nodeDatum.datum, {
            xKey: xKey,
            yKey: yKey,
            labelKey: labelKey,
            highlighted: true
        });
        return this.formatTooltipWithContext(tooltip, {
            symbol: this.legendItemSymbol(),
            title: title,
            data: [
                {
                    label: xName,
                    fallbackLabel: xKey,
                    value: xAxis.formatDatum(xValue)
                },
                {
                    label: yName,
                    fallbackLabel: yKey,
                    value: yAxis.formatDatum(yValue)
                }
            ]
        }, {
            seriesId: seriesId,
            datum: datum,
            title: yName,
            xKey: xKey,
            xName: xName,
            yKey: yKey,
            yName: yName,
            labelKey: labelKey,
            labelName: labelName,
            ...activeStyle,
            ...this.getModuleTooltipParams()
        });
    }
    legendItemSymbol() {
        const marker = this.getMarkerStyle(this.properties.marker);
        return {
            marker: marker
        };
    }
    getLegendData(legendType) {
        if (legendType !== "category") return [];
        const { yKey: itemId, yName: yName, title: title, showInLegend: showInLegend } = this.properties;
        const { id: seriesId, ctx: { legendManager: legendManager }, visible: visible } = this;
        return [
            {
                legendType: "category",
                id: seriesId,
                itemId: itemId,
                seriesId: seriesId,
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: seriesId,
                    itemId: itemId
                }),
                label: {
                    text: title ?? yName ?? itemId
                },
                symbol: this.legendItemSymbol(),
                hideInLegend: !showInLegend
            }
        ];
    }
    animateEmptyUpdateReady(data) {
        const { markerSelection: markerSelection, labelSelection: labelSelection, annotationSelections: annotationSelections } = data;
        $d77b025aa58d633c$var$markerScaleInAnimation(this, this.ctx.animationManager, markerSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, labelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "annotations", this.ctx.animationManager, ...annotationSelections);
    }
    isLabelEnabled() {
        return this.properties.label.enabled;
    }
    nodeFactory() {
        return new $d77b025aa58d633c$var$Group();
    }
    getFormattedMarkerStyle(datum) {
        const { xKey: xKey, yKey: yKey, labelKey: labelKey } = this.properties;
        return this.getMarkerStyle(this.properties.marker, datum.datum, {
            xKey: xKey,
            yKey: yKey,
            labelKey: labelKey
        }, true);
    }
    computeFocusBounds(opts) {
        return $d77b025aa58d633c$var$computeMarkerFocusBounds(this, opts);
    }
};
$d77b025aa58d633c$var$ScatterSeries.className = "ScatterSeries";
$d77b025aa58d633c$var$ScatterSeries.type = "scatter";
var $d77b025aa58d633c$var$scatterSeriesThemeableOptionsDef = {
    title: (0, $idDdm.string),
    showInMiniChart: (0, $idDdm.boolean),
    label: {
        placement: (0, $idDdm.union)("top", "right", "bottom", "left"),
        ...$d77b025aa58d633c$var$seriesLabelOptionsDefs
    },
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    errorBar: $d77b025aa58d633c$var$errorBarThemeableOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$markerOptionsDefs, [
        "enabled"
    ])
};
var $d77b025aa58d633c$var$scatterSeriesOptionsDef = {
    ...$d77b025aa58d633c$var$scatterSeriesThemeableOptionsDef,
    ...$d77b025aa58d633c$var$commonSeriesOptionsDefs,
    type: (0, $idDdm.required)((0, $idDdm.constant)("scatter")),
    xKey: (0, $idDdm.required)((0, $idDdm.string)),
    yKey: (0, $idDdm.required)((0, $idDdm.string)),
    labelKey: (0, $idDdm.string),
    xName: (0, $idDdm.string),
    yName: (0, $idDdm.string),
    labelName: (0, $idDdm.string),
    errorBar: $d77b025aa58d633c$var$errorBarOptionsDefs
};
// packages/ag-charts-community/src/chart/series/cartesian/scatterSeriesModule.ts
var $d77b025aa58d633c$var$ScatterSeriesModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "community",
    chartTypes: [
        "cartesian"
    ],
    identifier: "scatter",
    moduleFactory: (ctx)=>new $d77b025aa58d633c$var$ScatterSeries(ctx),
    tooltipDefaults: {
        range: "nearest"
    },
    defaultAxes: [
        {
            type: "number" /* NUMBER */ ,
            position: "bottom" /* BOTTOM */ 
        },
        {
            type: "number" /* NUMBER */ ,
            position: "left" /* LEFT */ 
        }
    ],
    themeTemplate: {
        series: {
            shape: "circle",
            size: 7,
            fill: {
                $palette: "fill"
            },
            stroke: {
                $palette: "stroke"
            },
            // @ts-expect-error undocumented option
            fillGradientDefaults: {
                type: "gradient",
                gradient: "radial",
                bounds: "item",
                colorStops: {
                    $palette: "gradient"
                },
                rotation: 0,
                reverse: true
            },
            fillPatternDefaults: $d77b025aa58d633c$var$FILL_PATTERN_DEFAULTS,
            fillImageDefaults: $d77b025aa58d633c$var$FILL_IMAGE_DEFAULTS,
            fillOpacity: 0.8,
            tooltip: {
                position: {
                    _seriesOverrideType: "node"
                }
            },
            label: {
                enabled: false,
                fontSize: {
                    $ref: "fontSize"
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontWeight: {
                    $ref: "fontWeight"
                },
                color: {
                    $ref: "textColor"
                }
            },
            errorBar: {
                cap: {
                    lengthRatio: 1
                }
            }
        }
    }
};
var $d77b025aa58d633c$var$NewScatterSeriesModule = {
    type: "series",
    name: "scatter",
    chartType: "cartesian",
    options: $d77b025aa58d633c$var$scatterSeriesOptionsDef,
    create: (ctx)=>new $d77b025aa58d633c$var$ScatterSeries(ctx)
};
// packages/ag-charts-community/src/scene/sectorBox.ts
var $d77b025aa58d633c$var$SectorBox = class _SectorBox {
    constructor(startAngle, endAngle, innerRadius, outerRadius){
        this.startAngle = startAngle;
        this.endAngle = endAngle;
        this.innerRadius = innerRadius;
        this.outerRadius = outerRadius;
    }
    clone() {
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this;
        return new _SectorBox(startAngle, endAngle, innerRadius, outerRadius);
    }
    equals(other) {
        return this.startAngle === other.startAngle && this.endAngle === other.endAngle && this.innerRadius === other.innerRadius && this.outerRadius === other.outerRadius;
    }
    [$d77b025aa58d633c$var$interpolate](other, d) {
        return new _SectorBox(this.startAngle * (1 - d) + other.startAngle * d, this.endAngle * (1 - d) + other.endAngle * d, this.innerRadius * (1 - d) + other.innerRadius * d, this.outerRadius * (1 - d) + other.outerRadius * d);
    }
};
// packages/ag-charts-community/src/scene/util/sector.ts
function $d77b025aa58d633c$var$sectorBox({ startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius }) {
    let x0 = Infinity;
    let y0 = Infinity;
    let x1 = -Infinity;
    let y1 = -Infinity;
    const addPoint = (x, y)=>{
        x0 = Math.min(x, x0);
        y0 = Math.min(y, y0);
        x1 = Math.max(x, x1);
        y1 = Math.max(y, y1);
    };
    addPoint(innerRadius * Math.cos(startAngle), innerRadius * Math.sin(startAngle));
    addPoint(innerRadius * Math.cos(endAngle), innerRadius * Math.sin(endAngle));
    addPoint(outerRadius * Math.cos(startAngle), outerRadius * Math.sin(startAngle));
    addPoint(outerRadius * Math.cos(endAngle), outerRadius * Math.sin(endAngle));
    if ($d77b025aa58d633c$var$isBetweenAngles(0, startAngle, endAngle)) addPoint(outerRadius, 0);
    if ($d77b025aa58d633c$var$isBetweenAngles(Math.PI * 0.5, startAngle, endAngle)) addPoint(0, outerRadius);
    if ($d77b025aa58d633c$var$isBetweenAngles(Math.PI, startAngle, endAngle)) addPoint(-outerRadius, 0);
    if ($d77b025aa58d633c$var$isBetweenAngles(Math.PI * 1.5, startAngle, endAngle)) addPoint(0, -outerRadius);
    return new $d77b025aa58d633c$var$BBox(x0, y0, x1 - x0, y1 - y0);
}
function $d77b025aa58d633c$var$isPointInSector(x, y, sector) {
    const radius = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    const { innerRadius: innerRadius, outerRadius: outerRadius } = sector;
    if (sector.startAngle === sector.endAngle || radius < Math.min(innerRadius, outerRadius) || radius > Math.max(innerRadius, outerRadius)) return false;
    const startAngle = $d77b025aa58d633c$var$normalizeAngle180(sector.startAngle);
    const endAngle = $d77b025aa58d633c$var$normalizeAngle180(sector.endAngle);
    const angle2 = Math.atan2(y, x);
    return startAngle < endAngle ? angle2 <= endAngle && angle2 >= startAngle : angle2 <= endAngle && angle2 >= -Math.PI || angle2 >= startAngle && angle2 <= Math.PI;
}
function $d77b025aa58d633c$var$lineCollidesSector(line, sector) {
    const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = sector;
    const outerStart = {
        x: outerRadius * Math.cos(startAngle),
        y: outerRadius * Math.sin(startAngle)
    };
    const outerEnd = {
        x: outerRadius * Math.cos(endAngle),
        y: outerRadius * Math.sin(endAngle)
    };
    const innerStart = innerRadius === 0 ? {
        x: 0,
        y: 0
    } : {
        x: innerRadius * Math.cos(startAngle),
        y: innerRadius * Math.sin(startAngle)
    };
    const innerEnd = innerRadius === 0 ? {
        x: 0,
        y: 0
    } : {
        x: innerRadius * Math.cos(endAngle),
        y: innerRadius * Math.sin(endAngle)
    };
    return $d77b025aa58d633c$var$segmentIntersection(line.start.x, line.start.y, line.end.x, line.end.y, outerStart.x, outerStart.y, innerStart.x, innerStart.y) || $d77b025aa58d633c$var$segmentIntersection(line.start.x, line.start.y, line.end.x, line.end.y, outerEnd.x, outerEnd.y, innerEnd.x, innerEnd.y) || $d77b025aa58d633c$var$arcIntersections(0, 0, outerRadius, startAngle, endAngle, true, line.start.x, line.start.y, line.end.x, line.end.y);
}
function $d77b025aa58d633c$var$boxCollidesSector(box, sector) {
    const topLeft = {
        x: box.x,
        y: box.y
    };
    const topRight = {
        x: box.x + box.width,
        y: box.y
    };
    const bottomLeft = {
        x: box.x,
        y: box.y + box.height
    };
    const bottomRight = {
        x: box.x + box.width,
        y: box.y + box.height
    };
    return $d77b025aa58d633c$var$lineCollidesSector({
        start: topLeft,
        end: topRight
    }, sector) || $d77b025aa58d633c$var$lineCollidesSector({
        start: bottomLeft,
        end: bottomRight
    }, sector);
}
function $d77b025aa58d633c$var$radiiScalingFactor(r, sweep, a, b) {
    if (a === 0 && b === 0) return 0;
    const fs1 = Math.asin(Math.abs(1 * a) / (r + 1 * a)) + Math.asin(Math.abs(1 * b) / (r + 1 * b)) - sweep;
    if (fs1 < 0) return 1;
    let start2 = 0;
    let end2 = 1;
    for(let i = 0; i < 8; i += 1){
        const s = (start2 + end2) / 2;
        const fs = Math.asin(Math.abs(s * a) / (r + s * a)) + Math.asin(Math.abs(s * b) / (r + s * b)) - sweep;
        if (fs < 0) start2 = s;
        else end2 = s;
    }
    return start2;
}
var $d77b025aa58d633c$var$delta2 = 1e-6;
function $d77b025aa58d633c$var$clockwiseAngle(angle2, relativeToStartAngle) {
    if ($d77b025aa58d633c$var$angleBetween(angle2, relativeToStartAngle) < $d77b025aa58d633c$var$delta2) return relativeToStartAngle;
    else return $d77b025aa58d633c$var$normalizeAngle360(angle2 - relativeToStartAngle) + relativeToStartAngle;
}
function $d77b025aa58d633c$var$clockwiseAngles(startAngle, endAngle, relativeToStartAngle = 0) {
    const fullPie = Math.abs(endAngle - startAngle) >= 2 * Math.PI;
    const sweepAngle = fullPie ? 2 * Math.PI : $d77b025aa58d633c$var$normalizeAngle360(endAngle - startAngle);
    startAngle = $d77b025aa58d633c$var$clockwiseAngle(startAngle, relativeToStartAngle);
    endAngle = startAngle + sweepAngle;
    return {
        startAngle: startAngle,
        endAngle: endAngle
    };
}
function $d77b025aa58d633c$var$arcRadialLineIntersectionAngle(cx, cy, r, startAngle, endAngle, clipAngle) {
    const sinA = Math.sin(clipAngle);
    const cosA = Math.cos(clipAngle);
    const c = cx ** 2 + cy ** 2 - r ** 2;
    let p0x;
    let p0y;
    let p1x;
    let p1y;
    if (cosA > 0.5) {
        const tanA = sinA / cosA;
        const a = 1 + tanA ** 2;
        const b = -2 * (cx + cy * tanA);
        const d = b ** 2 - 4 * a * c;
        if (d < 0) return;
        const x0 = (-b + Math.sqrt(d)) / (2 * a);
        const x1 = (-b - Math.sqrt(d)) / (2 * a);
        p0x = x0;
        p0y = x0 * tanA;
        p1x = x1;
        p1y = x1 * tanA;
    } else {
        const cotA = cosA / sinA;
        const a = 1 + cotA ** 2;
        const b = -2 * (cy + cx * cotA);
        const d = b ** 2 - 4 * a * c;
        if (d < 0) return;
        const y0 = (-b + Math.sqrt(d)) / (2 * a);
        const y1 = (-b - Math.sqrt(d)) / (2 * a);
        p0x = y0 * cotA;
        p0y = y0;
        p1x = y1 * cotA;
        p1y = y1;
    }
    const normalisedX = cosA;
    const normalisedY = sinA;
    const p0DotNormalized = p0x * normalisedX + p0y * normalisedY;
    const p1DotNormalized = p1x * normalisedX + p1y * normalisedY;
    const a0 = p0DotNormalized > 0 ? $d77b025aa58d633c$var$clockwiseAngle(Math.atan2(p0y - cy, p0x - cx), startAngle) : NaN;
    const a1 = p1DotNormalized > 0 ? $d77b025aa58d633c$var$clockwiseAngle(Math.atan2(p1y - cy, p1x - cx), startAngle) : NaN;
    if (a0 >= startAngle && a0 <= endAngle) return a0;
    else if (a1 >= startAngle && a1 <= endAngle) return a1;
}
function $d77b025aa58d633c$var$arcCircleIntersectionAngle(cx, cy, r, startAngle, endAngle, circleR) {
    const d = Math.hypot(cx, cy);
    const d1 = (d ** 2 - r ** 2 + circleR ** 2) / (2 * d);
    const d2 = d - d1;
    const theta = Math.atan2(cy, cx);
    const deltaTheta = Math.acos(-d2 / r);
    const a0 = $d77b025aa58d633c$var$clockwiseAngle(theta + deltaTheta, startAngle);
    const a1 = $d77b025aa58d633c$var$clockwiseAngle(theta - deltaTheta, startAngle);
    if (a0 >= startAngle && a0 <= endAngle) return a0;
    else if (a1 >= startAngle && a1 <= endAngle) return a1;
}
// packages/ag-charts-community/src/scene/shape/sector.ts
var $d77b025aa58d633c$var$Arc = class {
    constructor(cx, cy, r, a0, a1){
        this.cx = cx;
        this.cy = cy;
        this.r = r;
        this.a0 = a0;
        this.a1 = a1;
        if (this.a0 >= this.a1) {
            this.a0 = NaN;
            this.a1 = NaN;
        }
    }
    isValid() {
        return Number.isFinite(this.a0) && Number.isFinite(this.a1);
    }
    pointAt(a) {
        return {
            x: this.cx + this.r * Math.cos(a),
            y: this.cy + this.r * Math.sin(a)
        };
    }
    clipStart(a) {
        if (a == null || !this.isValid() || a < this.a0) return;
        this.a0 = a;
        if (Number.isNaN(a) || this.a0 >= this.a1) {
            this.a0 = NaN;
            this.a1 = NaN;
        }
    }
    clipEnd(a) {
        if (a == null || !this.isValid() || a > this.a1) return;
        this.a1 = a;
        if (Number.isNaN(a) || this.a0 >= this.a1) {
            this.a0 = NaN;
            this.a1 = NaN;
        }
    }
};
var $d77b025aa58d633c$var$Sector = class extends $d77b025aa58d633c$var$Path {
    constructor(){
        super(...arguments);
        this.centerX = 0;
        this.centerY = 0;
        this.innerRadius = 10;
        this.outerRadius = 20;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clipSector = void 0;
        this.concentricEdgeInset = 0;
        this.radialEdgeInset = 0;
        this.startOuterCornerRadius = 0;
        this.endOuterCornerRadius = 0;
        this.startInnerCornerRadius = 0;
        this.endInnerCornerRadius = 0;
    }
    set inset(value) {
        this.concentricEdgeInset = value;
        this.radialEdgeInset = value;
    }
    set cornerRadius(value) {
        this.startOuterCornerRadius = value;
        this.endOuterCornerRadius = value;
        this.startInnerCornerRadius = value;
        this.endInnerCornerRadius = value;
    }
    computeBBox() {
        return $d77b025aa58d633c$var$sectorBox(this).translate(this.centerX, this.centerY);
    }
    normalizedRadii() {
        const { concentricEdgeInset: concentricEdgeInset } = this;
        let { innerRadius: innerRadius, outerRadius: outerRadius } = this;
        innerRadius = innerRadius > 0 ? innerRadius + concentricEdgeInset : 0;
        outerRadius = Math.max(outerRadius - concentricEdgeInset, 0);
        return {
            innerRadius: innerRadius,
            outerRadius: outerRadius
        };
    }
    normalizedClipSector() {
        const { clipSector: clipSector } = this;
        if (clipSector == null) return;
        const { startAngle: startAngle, endAngle: endAngle } = $d77b025aa58d633c$var$clockwiseAngles(this.startAngle, this.endAngle);
        const { innerRadius: innerRadius, outerRadius: outerRadius } = this.normalizedRadii();
        const clipAngles = $d77b025aa58d633c$var$clockwiseAngles(clipSector.startAngle, clipSector.endAngle, startAngle);
        return new $d77b025aa58d633c$var$SectorBox(Math.max(startAngle, clipAngles.startAngle), Math.min(endAngle, clipAngles.endAngle), Math.max(innerRadius, clipSector.innerRadius), Math.min(outerRadius, clipSector.outerRadius));
    }
    getAngleOffset(radius) {
        return radius > 0 ? this.radialEdgeInset / radius : 0;
    }
    arc(r, angleSweep, a0, a1, outerArc, innerArc, start2, inner) {
        if (r <= 0) return;
        const { startAngle: startAngle, endAngle: endAngle } = $d77b025aa58d633c$var$clockwiseAngles(this.startAngle, this.endAngle);
        const { innerRadius: innerRadius, outerRadius: outerRadius } = this.normalizedRadii();
        const clipSector = this.normalizedClipSector();
        if (inner && innerRadius <= 0) return;
        const angleOffset = inner ? this.getAngleOffset(innerRadius + r) : this.getAngleOffset(outerRadius - r);
        const angle2 = start2 ? startAngle + angleOffset + angleSweep : endAngle - angleOffset - angleSweep;
        const radius = inner ? innerRadius + r : outerRadius - r;
        const cx = radius * Math.cos(angle2);
        const cy = radius * Math.sin(angle2);
        if (clipSector != null) {
            const delta3 = 1e-6;
            if (!start2 && !(angle2 >= startAngle - delta3 && angle2 <= clipSector.endAngle - delta3)) return;
            if (start2 && !(angle2 >= clipSector.startAngle + delta3 && angle2 <= endAngle - delta3)) return;
            if (inner && radius < clipSector.innerRadius - delta3) return;
            if (!inner && radius > clipSector.outerRadius + delta3) return;
        }
        const arc = new $d77b025aa58d633c$var$Arc(cx, cy, r, a0, a1);
        if (clipSector != null) {
            if (inner) {
                arc.clipStart($d77b025aa58d633c$var$arcRadialLineIntersectionAngle(cx, cy, r, a0, a1, clipSector.endAngle));
                arc.clipEnd($d77b025aa58d633c$var$arcRadialLineIntersectionAngle(cx, cy, r, a0, a1, clipSector.startAngle));
            } else {
                arc.clipStart($d77b025aa58d633c$var$arcRadialLineIntersectionAngle(cx, cy, r, a0, a1, clipSector.startAngle));
                arc.clipEnd($d77b025aa58d633c$var$arcRadialLineIntersectionAngle(cx, cy, r, a0, a1, clipSector.endAngle));
            }
            let circleClipStart;
            let circleClipEnd;
            if (start2) {
                circleClipStart = $d77b025aa58d633c$var$arcCircleIntersectionAngle(cx, cy, r, a0, a1, clipSector.innerRadius);
                circleClipEnd = $d77b025aa58d633c$var$arcCircleIntersectionAngle(cx, cy, r, a0, a1, clipSector.outerRadius);
            } else {
                circleClipStart = $d77b025aa58d633c$var$arcCircleIntersectionAngle(cx, cy, r, a0, a1, clipSector.outerRadius);
                circleClipEnd = $d77b025aa58d633c$var$arcCircleIntersectionAngle(cx, cy, r, a0, a1, clipSector.innerRadius);
            }
            arc.clipStart(circleClipStart);
            arc.clipEnd(circleClipEnd);
            if (circleClipStart != null) {
                const { x: x2, y: y2 } = arc.pointAt(circleClipStart);
                const theta2 = $d77b025aa58d633c$var$clockwiseAngle(Math.atan2(y2, x2), startAngle);
                if (start2) innerArc?.clipStart(theta2);
                else outerArc.clipEnd(theta2);
            }
            if (circleClipEnd != null) {
                const { x: x2, y: y2 } = arc.pointAt(circleClipEnd);
                const theta2 = $d77b025aa58d633c$var$clockwiseAngle(Math.atan2(y2, x2), startAngle);
                if (start2) outerArc.clipStart(theta2);
                else innerArc?.clipEnd(theta2);
            }
        }
        if (clipSector != null) {
            const { x: x2, y: y2 } = arc.pointAt((arc.a0 + arc.a1) / 2);
            if (!$d77b025aa58d633c$var$isPointInSector(x2, y2, clipSector)) return;
        }
        const { x: x, y: y } = arc.pointAt(start2 === inner ? arc.a0 : arc.a1);
        const theta = $d77b025aa58d633c$var$clockwiseAngle(Math.atan2(y, x), startAngle);
        const radialArc = inner ? innerArc : outerArc;
        if (start2) radialArc?.clipStart(theta);
        else radialArc?.clipEnd(theta);
        return arc;
    }
    updatePath() {
        const delta3 = 1e-6;
        const { path: path, centerX: centerX, centerY: centerY, concentricEdgeInset: concentricEdgeInset, radialEdgeInset: radialEdgeInset } = this;
        let { startOuterCornerRadius: startOuterCornerRadius, endOuterCornerRadius: endOuterCornerRadius, startInnerCornerRadius: startInnerCornerRadius, endInnerCornerRadius: endInnerCornerRadius } = this;
        const { startAngle: startAngle, endAngle: endAngle } = $d77b025aa58d633c$var$clockwiseAngles(this.startAngle, this.endAngle);
        const { innerRadius: innerRadius, outerRadius: outerRadius } = this.normalizedRadii();
        const clipSector = this.normalizedClipSector();
        const sweepAngle = endAngle - startAngle;
        const fullPie = sweepAngle >= 2 * Math.PI - delta3;
        path.clear();
        if (innerRadius === 0 && outerRadius === 0 || innerRadius > outerRadius) return;
        else if ((clipSector?.startAngle ?? startAngle) === (clipSector?.endAngle ?? endAngle)) return;
        else if (fullPie && this.clipSector == null && startOuterCornerRadius === 0 && endOuterCornerRadius === 0 && startInnerCornerRadius === 0 && endInnerCornerRadius === 0) {
            path.moveTo(centerX + outerRadius * Math.cos(startAngle), centerY + outerRadius * Math.sin(startAngle));
            path.arc(centerX, centerY, outerRadius, startAngle, endAngle);
            if (innerRadius > concentricEdgeInset) {
                path.moveTo(centerX + innerRadius * Math.cos(endAngle), centerY + innerRadius * Math.sin(endAngle));
                path.arc(centerX, centerY, innerRadius, endAngle, startAngle, true);
            }
            path.closePath();
            return;
        } else if (this.clipSector == null && Math.abs(innerRadius - outerRadius) < 1e-6) {
            path.arc(centerX, centerY, outerRadius, startAngle, endAngle, false);
            path.arc(centerX, centerY, outerRadius, endAngle, startAngle, true);
            path.closePath();
            return;
        }
        const innerAngleOffset = this.getAngleOffset(innerRadius);
        const outerAngleOffset = this.getAngleOffset(outerRadius);
        const outerAngleExceeded = sweepAngle < 2 * outerAngleOffset;
        if (outerAngleExceeded) return;
        const hasInnerSweep = (clipSector?.innerRadius ?? innerRadius) > concentricEdgeInset;
        const innerAngleExceeded = innerRadius < concentricEdgeInset || sweepAngle < 2 * innerAngleOffset;
        const radialLength = outerRadius - innerRadius;
        const maxRadialLength = Math.max(startOuterCornerRadius, startInnerCornerRadius, endOuterCornerRadius, endInnerCornerRadius);
        const initialScalingFactor = maxRadialLength > 0 ? Math.min(radialLength / maxRadialLength, 1) : 1;
        startOuterCornerRadius *= initialScalingFactor;
        endOuterCornerRadius *= initialScalingFactor;
        startInnerCornerRadius *= initialScalingFactor;
        endInnerCornerRadius *= initialScalingFactor;
        const outerScalingFactor = $d77b025aa58d633c$var$radiiScalingFactor(outerRadius, sweepAngle - 2 * outerAngleOffset, -startOuterCornerRadius, -endOuterCornerRadius);
        startOuterCornerRadius *= outerScalingFactor;
        endOuterCornerRadius *= outerScalingFactor;
        if (!innerAngleExceeded && hasInnerSweep) {
            const innerScalingFactor = $d77b025aa58d633c$var$radiiScalingFactor(innerRadius, sweepAngle - 2 * innerAngleOffset, startInnerCornerRadius, endInnerCornerRadius);
            startInnerCornerRadius *= innerScalingFactor;
            endInnerCornerRadius *= innerScalingFactor;
        } else {
            startInnerCornerRadius = 0;
            endInnerCornerRadius = 0;
        }
        const maxCombinedRadialLength = Math.max(startOuterCornerRadius + startInnerCornerRadius, endOuterCornerRadius + endInnerCornerRadius);
        const edgesScalingFactor = maxCombinedRadialLength > 0 ? Math.min(radialLength / maxCombinedRadialLength, 1) : 1;
        startOuterCornerRadius *= edgesScalingFactor;
        endOuterCornerRadius *= edgesScalingFactor;
        startInnerCornerRadius *= edgesScalingFactor;
        endInnerCornerRadius *= edgesScalingFactor;
        let startOuterCornerRadiusAngleSweep = 0;
        let endOuterCornerRadiusAngleSweep = 0;
        const startOuterCornerRadiusSweep = startOuterCornerRadius / (outerRadius - startOuterCornerRadius);
        const endOuterCornerRadiusSweep = endOuterCornerRadius / (outerRadius - endOuterCornerRadius);
        if (startOuterCornerRadiusSweep >= 0 && startOuterCornerRadiusSweep < 1 - delta3) startOuterCornerRadiusAngleSweep = Math.asin(startOuterCornerRadiusSweep);
        else {
            startOuterCornerRadiusAngleSweep = sweepAngle / 2;
            const maxStartOuterCornerRadius = outerRadius / (1 / Math.sin(startOuterCornerRadiusAngleSweep) + 1);
            startOuterCornerRadius = Math.min(maxStartOuterCornerRadius, startOuterCornerRadius);
        }
        if (endOuterCornerRadiusSweep >= 0 && endOuterCornerRadiusSweep < 1 - delta3) endOuterCornerRadiusAngleSweep = Math.asin(endOuterCornerRadiusSweep);
        else {
            endOuterCornerRadiusAngleSweep = sweepAngle / 2;
            const maxEndOuterCornerRadius = outerRadius / (1 / Math.sin(endOuterCornerRadiusAngleSweep) + 1);
            endOuterCornerRadius = Math.min(maxEndOuterCornerRadius, endOuterCornerRadius);
        }
        const startInnerCornerRadiusAngleSweep = Math.asin(startInnerCornerRadius / (innerRadius + startInnerCornerRadius));
        const endInnerCornerRadiusAngleSweep = Math.asin(endInnerCornerRadius / (innerRadius + endInnerCornerRadius));
        const outerArcRadius = clipSector?.outerRadius ?? outerRadius;
        const outerArcRadiusOffset = this.getAngleOffset(outerArcRadius);
        const outerArc = new $d77b025aa58d633c$var$Arc(0, 0, outerArcRadius, startAngle + outerArcRadiusOffset, endAngle - outerArcRadiusOffset);
        const innerArcRadius = clipSector?.innerRadius ?? innerRadius;
        const innerArcRadiusOffset = this.getAngleOffset(innerArcRadius);
        const innerArc = hasInnerSweep ? new $d77b025aa58d633c$var$Arc(0, 0, innerArcRadius, startAngle + innerArcRadiusOffset, endAngle - innerArcRadiusOffset) : void 0;
        if (clipSector != null) {
            outerArc.clipStart(clipSector.startAngle);
            outerArc.clipEnd(clipSector.endAngle);
            innerArc?.clipStart(clipSector.startAngle);
            innerArc?.clipEnd(clipSector.endAngle);
        }
        const startOuterArc = this.arc(startOuterCornerRadius, startOuterCornerRadiusAngleSweep, startAngle - Math.PI * 0.5, startAngle + startOuterCornerRadiusAngleSweep, outerArc, innerArc, true, false);
        const endOuterArc = this.arc(endOuterCornerRadius, endOuterCornerRadiusAngleSweep, endAngle - endOuterCornerRadiusAngleSweep, endAngle + Math.PI * 0.5, outerArc, innerArc, false, false);
        const endInnerArc = this.arc(endInnerCornerRadius, endInnerCornerRadiusAngleSweep, endAngle + Math.PI * 0.5, endAngle + Math.PI - endInnerCornerRadiusAngleSweep, outerArc, innerArc, false, true);
        const startInnerArc = this.arc(startInnerCornerRadius, startInnerCornerRadiusAngleSweep, startAngle + Math.PI + startInnerCornerRadiusAngleSweep, startAngle + Math.PI * 1.5, outerArc, innerArc, true, true);
        if (innerAngleExceeded) {
            const x = sweepAngle < Math.PI * 0.5 ? radialEdgeInset * (1 + Math.cos(sweepAngle)) / Math.sin(sweepAngle) : NaN;
            let r;
            if (x > 0 && x < outerRadius) r = Math.max(Math.hypot(radialEdgeInset, x), innerRadius);
            else r = radialEdgeInset;
            r = Math.max(r, innerRadius);
            const midAngle = startAngle + sweepAngle * 0.5;
            path.moveTo(centerX + r * Math.cos(midAngle), centerY + r * Math.sin(midAngle));
        } else if (startInnerArc?.isValid() === true || innerArc?.isValid() === true) ;
        else {
            const midAngle = startAngle + sweepAngle / 2;
            const cx = innerRadius * Math.cos(midAngle);
            const cy = innerRadius * Math.sin(midAngle);
            path.moveTo(centerX + cx, centerY + cy);
        }
        if (startOuterArc?.isValid() === true) {
            const { cx: cx, cy: cy, r: r, a0: a0, a1: a1 } = startOuterArc;
            path.arc(centerX + cx, centerY + cy, r, a0, a1);
        }
        if (outerArc.isValid()) {
            const { r: r, a0: a0, a1: a1 } = outerArc;
            path.arc(centerX, centerY, r, a0, a1);
        }
        if (endOuterArc?.isValid() === true) {
            const { cx: cx, cy: cy, r: r, a0: a0, a1: a1 } = endOuterArc;
            path.arc(centerX + cx, centerY + cy, r, a0, a1);
        }
        if (!innerAngleExceeded) {
            if (endInnerArc?.isValid() === true) {
                const { cx: cx, cy: cy, r: r, a0: a0, a1: a1 } = endInnerArc;
                path.arc(centerX + cx, centerY + cy, r, a0, a1);
            }
            if (innerArc?.isValid() === true) {
                const { r: r, a0: a0, a1: a1 } = innerArc;
                path.arc(centerX, centerY, r, a1, a0, true);
            }
            if (startInnerArc?.isValid() === true) {
                const { cx: cx, cy: cy, r: r, a0: a0, a1: a1 } = startInnerArc;
                path.arc(centerX + cx, centerY + cy, r, a0, a1);
            }
        }
        path.closePath();
    }
    isPointInPath(x, y) {
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.clipSector ?? this;
        return $d77b025aa58d633c$var$isPointInSector(x - this.centerX, y - this.centerY, {
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: Math.min(innerRadius, outerRadius),
            outerRadius: Math.max(innerRadius, outerRadius)
        });
    }
};
$d77b025aa58d633c$var$Sector.className = "Sector";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "centerX", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "centerY", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "innerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "outerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "startAngle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "endAngle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneObjectChangeDetection({
        equals: (lhs, rhs)=>lhs.equals(rhs)
    })
], $d77b025aa58d633c$var$Sector.prototype, "clipSector", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "concentricEdgeInset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "radialEdgeInset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "startOuterCornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "endOuterCornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "startInnerCornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "endInnerCornerRadius", 2);
// packages/ag-charts-community/src/chart/themes/defaultColors.ts
var $d77b025aa58d633c$var$DEFAULT_FILLS = {
    BLUE: "#5090dc",
    ORANGE: "#ffa03a",
    GREEN: "#459d55",
    CYAN: "#34bfe1",
    YELLOW: "#e1cc00",
    VIOLET: "#9669cb",
    GRAY: "#b5b5b5",
    MAGENTA: "#bd5aa7",
    BROWN: "#8a6224",
    RED: "#ef5452"
};
var $d77b025aa58d633c$var$DEFAULT_STROKES = {
    BLUE: "#2b5c95",
    ORANGE: "#cc6f10",
    GREEN: "#1e652e",
    CYAN: "#18859e",
    YELLOW: "#a69400",
    VIOLET: "#603c88",
    GRAY: "#575757",
    MAGENTA: "#7d2f6d",
    BROWN: "#4f3508",
    RED: "#a82529"
};
// packages/ag-charts-community/src/chart/series/polar/donutSeriesProperties.ts
var $d77b025aa58d633c$var$DonutTitle = class extends $d77b025aa58d633c$var$Caption {
    constructor(){
        super(...arguments);
        this.showInLegend = false;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutTitle.prototype, "showInLegend", 2);
var $d77b025aa58d633c$var$DonutInnerLabel = class extends $d77b025aa58d633c$var$Label {
    constructor(){
        super(...arguments);
        this.spacing = 2;
    }
    set(properties, _reset) {
        return super.set(properties);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutInnerLabel.prototype, "text", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutInnerLabel.prototype, "spacing", 2);
var $d77b025aa58d633c$var$DonutInnerCircle = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.fill = "transparent";
        this.fillOpacity = 1;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutInnerCircle.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutInnerCircle.prototype, "fillOpacity", 2);
var $d77b025aa58d633c$var$DonutSeriesCalloutLabel = class extends $d77b025aa58d633c$var$Label {
    constructor(){
        super(...arguments);
        this.offset = 3;
        this.minAngle = 0;
        this.minSpacing = 4;
        this.maxCollisionOffset = 50;
        this.avoidCollisions = true;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesCalloutLabel.prototype, "offset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesCalloutLabel.prototype, "minAngle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesCalloutLabel.prototype, "minSpacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesCalloutLabel.prototype, "maxCollisionOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesCalloutLabel.prototype, "avoidCollisions", 2);
var $d77b025aa58d633c$var$DonutSeriesSectorLabel = class extends $d77b025aa58d633c$var$Label {
    constructor(){
        super(...arguments);
        this.positionOffset = 0;
        this.positionRatio = 0.5;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesSectorLabel.prototype, "positionOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesSectorLabel.prototype, "positionRatio", 2);
var $d77b025aa58d633c$var$DonutSeriesCalloutLine = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.length = 10;
        this.strokeWidth = 1;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesCalloutLine.prototype, "colors", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesCalloutLine.prototype, "length", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesCalloutLine.prototype, "strokeWidth", 2);
var $d77b025aa58d633c$var$DonutSeriesProperties = class extends $d77b025aa58d633c$var$SeriesProperties {
    constructor(){
        super(...arguments);
        this.defaultColorRange = [];
        this.defaultPatternFills = [];
        this.fills = Object.values($d77b025aa58d633c$var$DEFAULT_FILLS);
        this.strokes = Object.values($d77b025aa58d633c$var$DEFAULT_STROKES);
        this.fillOpacity = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.cornerRadius = 0;
        this.rotation = 0;
        this.outerRadiusOffset = 0;
        this.outerRadiusRatio = 1;
        this.strokeWidth = 1;
        this.sectorSpacing = 0;
        this.hideZeroValueSectorsInLegend = false;
        this.innerLabels = new $d77b025aa58d633c$var$PropertiesArray($d77b025aa58d633c$var$DonutInnerLabel);
        this.title = new $d77b025aa58d633c$var$DonutTitle();
        this.innerCircle = new $d77b025aa58d633c$var$DonutInnerCircle();
        this.shadow = new $d77b025aa58d633c$var$DropShadow();
        this.calloutLabel = new $d77b025aa58d633c$var$DonutSeriesCalloutLabel();
        this.sectorLabel = new $d77b025aa58d633c$var$DonutSeriesSectorLabel();
        this.calloutLine = new $d77b025aa58d633c$var$DonutSeriesCalloutLine();
        this.tooltip = new $d77b025aa58d633c$var$SeriesTooltip();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "angleKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "angleName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "angleFilterKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "radiusKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "radiusName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "radiusMin", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "radiusMax", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "calloutLabelKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "calloutLabelName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "sectorLabelKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "sectorLabelName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "legendItemKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "defaultColorRange", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "defaultPatternFills", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "fills", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "strokes", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "cornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "itemStyler", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "rotation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "outerRadiusOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "outerRadiusRatio", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "innerRadiusOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "innerRadiusRatio", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "sectorSpacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "hideZeroValueSectorsInLegend", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "innerLabels", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "title", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "innerCircle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "shadow", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "calloutLabel", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "sectorLabel", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "calloutLine", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-community/src/chart/series/polar/pieUtil.ts
function $d77b025aa58d633c$var$preparePieSeriesAnimationFunctions(initialLoad, rotationDegrees, scaleFn, oldScaleFn) {
    const scale2 = [
        scaleFn.convert(0),
        scaleFn.convert(1)
    ];
    const oldScale = [
        oldScaleFn.convert(0),
        oldScaleFn.convert(1)
    ];
    const rotation = Math.PI / -2 + $d77b025aa58d633c$var$toRadians(rotationDegrees);
    const phase = initialLoad ? "initial" : "update";
    const scaleToNewRadius = ({ radius: radius })=>{
        return {
            innerRadius: scale2[0],
            outerRadius: scale2[0] + (scale2[1] - scale2[0]) * radius
        };
    };
    const scaleToOldRadius = ({ radius: radius })=>{
        return {
            innerRadius: oldScale[0],
            outerRadius: oldScale[0] + (oldScale[1] - oldScale[0]) * radius
        };
    };
    const fromFn = (sect, datum, status, { prevFromProps: prevFromProps })=>{
        let { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = sect;
        let { fill: fill, stroke: stroke2 } = datum.sectorFormat;
        if (status === "updated" && sect.previousDatum == null) status = "added";
        if (status === "unknown" || status === "added" && !prevFromProps) {
            startAngle = rotation;
            endAngle = rotation;
            innerRadius = datum.innerRadius;
            outerRadius = datum.outerRadius;
        } else if (status === "added" && prevFromProps) {
            startAngle = prevFromProps.endAngle ?? rotation;
            endAngle = prevFromProps.endAngle ?? rotation;
            innerRadius = prevFromProps.innerRadius ?? datum.innerRadius;
            outerRadius = prevFromProps.outerRadius ?? datum.outerRadius;
        }
        if (status === "added" && !initialLoad) {
            const radii = scaleToOldRadius(datum);
            innerRadius = radii.innerRadius;
            outerRadius = radii.outerRadius;
        }
        if (status === "updated") {
            fill = sect.fill ?? fill;
            stroke2 = (typeof sect.stroke === "string" ? sect.stroke : void 0) ?? stroke2;
        }
        return {
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            fill: fill,
            stroke: stroke2,
            phase: phase
        };
    };
    const toFn = (_sect, datum, status, { prevLive: prevLive })=>{
        let { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = datum;
        const { stroke: stroke2, fill: fill } = datum.sectorFormat;
        if (status === "removed" && prevLive) {
            startAngle = prevLive.datum?.endAngle;
            endAngle = prevLive.datum?.endAngle;
        } else if (status === "removed" && !prevLive) {
            startAngle = rotation;
            endAngle = rotation;
        }
        if (status === "removed") {
            const radii = scaleToNewRadius(datum);
            innerRadius = radii.innerRadius;
            outerRadius = radii.outerRadius;
        }
        return {
            startAngle: startAngle,
            endAngle: endAngle,
            outerRadius: outerRadius,
            innerRadius: innerRadius,
            stroke: stroke2,
            fill: fill
        };
    };
    const innerCircleFromFn = (node, _)=>{
        return {
            size: node.previousDatum?.radius ?? node.size ?? 0,
            phase: phase
        };
    };
    const innerCircleToFn = (_, datum)=>{
        return {
            size: datum.radius ?? 0
        };
    };
    return {
        nodes: {
            toFn: toFn,
            fromFn: fromFn
        },
        innerCircle: {
            fromFn: innerCircleFromFn,
            toFn: innerCircleToFn
        }
    };
}
function $d77b025aa58d633c$var$resetPieSelectionsFn(_node, datum) {
    return {
        startAngle: datum.startAngle,
        endAngle: datum.endAngle,
        innerRadius: datum.innerRadius,
        outerRadius: datum.outerRadius,
        stroke: datum.sectorFormat.stroke
    };
}
function $d77b025aa58d633c$var$pickByMatchingAngle(series, point) {
    const dy = point.y - series.centerY;
    const dx = point.x - series.centerX;
    const angle2 = Math.atan2(dy, dx);
    const sectors = series.getItemNodes();
    for (const sector of sectors){
        if (sector.datum.missing === true) continue;
        if ($d77b025aa58d633c$var$isBetweenAngles(angle2, sector.startAngle, sector.endAngle)) {
            const radius = Math.sqrt(dx * dx + dy * dy);
            let distance2 = 0;
            if (radius < sector.innerRadius) distance2 = sector.innerRadius - radius;
            else if (radius > sector.outerRadius) distance2 = radius - sector.outerRadius;
            return {
                datum: sector.datum,
                distance: distance2
            };
        }
    }
    return void 0;
}
// packages/ag-charts-community/src/chart/series/polar/polarZIndexMap.ts
var $d77b025aa58d633c$var$PolarZIndexMap = /* @__PURE__ */ ((PolarZIndexMap2)=>{
    PolarZIndexMap2[PolarZIndexMap2["BACKGROUND"] = 0] = "BACKGROUND";
    PolarZIndexMap2[PolarZIndexMap2["FOREGROUND"] = 1] = "FOREGROUND";
    PolarZIndexMap2[PolarZIndexMap2["HIGHLIGHT"] = 2] = "HIGHLIGHT";
    PolarZIndexMap2[PolarZIndexMap2["LABEL"] = 3] = "LABEL";
    return PolarZIndexMap2;
})($d77b025aa58d633c$var$PolarZIndexMap || {});
// packages/ag-charts-community/src/chart/series/polar/polarSeries.ts
var $d77b025aa58d633c$var$PolarSeries = class extends $d77b025aa58d633c$var$DataModelSeries {
    constructor({ categoryKey: categoryKey, useLabelLayer: useLabelLayer = false, pickModes: pickModes = [
        1 /* NEAREST_NODE */ ,
        0 /* EXACT_SHAPE_MATCH */ 
    ], canHaveAxes: canHaveAxes = false, animationResetFns: animationResetFns, ...opts }){
        super({
            ...opts,
            categoryKey: categoryKey,
            useLabelLayer: useLabelLayer,
            pickModes: pickModes,
            directionKeys: {
                ["angle" /* Angle */ ]: [
                    "angleKey"
                ],
                ["radius" /* Radius */ ]: [
                    "radiusKey"
                ]
            },
            directionNames: {
                ["angle" /* Angle */ ]: [
                    "angleName"
                ],
                ["radius" /* Radius */ ]: [
                    "radiusName"
                ]
            },
            canHaveAxes: canHaveAxes
        });
        this.directions = [
            "angle" /* Angle */ ,
            "radius" /* Radius */ 
        ];
        this.itemGroup = this.contentGroup.appendChild(new $d77b025aa58d633c$var$Group());
        this.nodeData = [];
        this.itemSelection = $d77b025aa58d633c$var$Selection.select(this.itemGroup, ()=>this.nodeFactory(), false);
        this.labelSelection = $d77b025aa58d633c$var$Selection.select(this.labelGroup, ()=>this.labelFactory(), false);
        this.highlightSelection = $d77b025aa58d633c$var$Selection.select(this.highlightGroup, ()=>this.nodeFactory());
        this.highlightLabelSelection = $d77b025aa58d633c$var$Selection.select(this.highlightLabel, ()=>this.labelFactory());
        /**
     * The center of the polar series (for example, the center of a pie).
     * If the polar chart has multiple series, all of them will have their
     * center set to the same value as a result of the polar chart layout.
     * The center coordinates are not supposed to be set by the user.
     */ this.centerX = 0;
        this.centerY = 0;
        /**
     * The maximum radius the series can use.
     * This value is set automatically as a result of the polar chart layout
     * and is not supposed to be set by the user.
     */ this.radius = 0;
        this.animationResetFns = animationResetFns;
        this.animationState = new $d77b025aa58d633c$var$StateMachine("empty", {
            empty: {
                update: {
                    target: "ready",
                    action: (data)=>this.animateEmptyUpdateReady(data)
                },
                reset: "empty",
                skip: "ready"
            },
            ready: {
                updateData: "waiting",
                clear: "clearing",
                highlight: (data)=>this.animateReadyHighlight(data),
                highlightMarkers: (data)=>this.animateReadyHighlightMarkers(data),
                resize: (data)=>this.animateReadyResize(data),
                reset: "empty",
                skip: "ready"
            },
            waiting: {
                update: {
                    target: "ready",
                    action: (data)=>this.animateWaitingUpdateReady(data)
                },
                reset: "empty",
                skip: "ready"
            },
            clearing: {
                update: {
                    target: "empty",
                    action: (data)=>this.animateClearingUpdateEmpty(data)
                },
                reset: "empty",
                skip: "ready"
            }
        }, ()=>this.checkProcessedDataAnimatable());
    }
    getItemNodes() {
        return [
            ...this.itemGroup.children()
        ];
    }
    getNodeData() {
        return this.nodeData;
    }
    setSeriesIndex(index) {
        if (!super.setSeriesIndex(index)) return false;
        this.contentGroup.zIndex = [
            index,
            1 /* FOREGROUND */ 
        ];
        this.highlightGroup.zIndex = [
            index,
            2 /* HIGHLIGHT */ 
        ];
        this.labelGroup.zIndex = [
            index,
            3 /* LABEL */ 
        ];
        return true;
    }
    resetAnimation(phase) {
        if (phase === "initial") this.animationState.transition("reset");
        else if (phase === "ready") this.animationState.transition("skip");
    }
    labelFactory() {
        const text = new $d77b025aa58d633c$var$Text();
        text.pointerEvents = 1 /* None */ ;
        return text;
    }
    addChartEventListeners() {
        this.destroyFns.push(this.ctx.chartEventManager?.addListener("legend-item-click", (event)=>this.onLegendItemClick(event)), this.ctx.chartEventManager?.addListener("legend-item-double-click", (event)=>this.onLegendItemDoubleClick(event)));
    }
    getInnerRadius() {
        return 0;
    }
    computeLabelsBBox(_options, _seriesRect) {
        return null;
    }
    getShapeFillBBox() {
        const outerRadius = this.radius;
        return {
            series: new $d77b025aa58d633c$var$BBox(-outerRadius, -outerRadius, outerRadius * 2, outerRadius * 2),
            axis: new $d77b025aa58d633c$var$BBox(-outerRadius, -outerRadius, outerRadius * 2, outerRadius * 2)
        };
    }
    resetAllAnimation() {
        const { item: item, label: label } = this.animationResetFns ?? {};
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
        if (item) $d77b025aa58d633c$var$resetMotion([
            this.itemSelection,
            this.highlightSelection
        ], item);
        if (label) $d77b025aa58d633c$var$resetMotion([
            this.labelSelection,
            this.highlightLabelSelection
        ], label);
        this.itemSelection.cleanup();
        this.labelSelection.cleanup();
        this.highlightSelection.cleanup();
        this.highlightLabelSelection.cleanup();
    }
    animateEmptyUpdateReady(_data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation();
    }
    animateWaitingUpdateReady(_data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation();
    }
    animateReadyHighlight(_data) {
        const { item: item, label: label } = this.animationResetFns ?? {};
        if (item) $d77b025aa58d633c$var$resetMotion([
            this.highlightSelection
        ], item);
        if (label) $d77b025aa58d633c$var$resetMotion([
            this.highlightLabelSelection
        ], label);
    }
    animateReadyHighlightMarkers(_data) {}
    animateReadyResize(_data) {
        this.resetAllAnimation();
    }
    animateClearingUpdateEmpty(_data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation();
    }
    computeFocusBounds(opts) {
        const datum = this.getNodeData()?.[opts.datumIndex];
        if (datum !== void 0) return this.itemSelection.select((node)=>node instanceof $d77b025aa58d633c$var$Path && node.datum === datum)[0];
        return void 0;
    }
    getSeriesRange(_direction, _visibleRange) {
        return [
            NaN,
            NaN
        ];
    }
};
// packages/ag-charts-community/src/chart/series/polar/donutSeries.ts
var $d77b025aa58d633c$var$DonutSeriesNodeEvent = class extends $d77b025aa58d633c$var$SeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.angleKey = series.properties.angleKey;
        this.radiusKey = series.properties.radiusKey;
        this.calloutLabelKey = series.properties.calloutLabelKey;
        this.sectorLabelKey = series.properties.sectorLabelKey;
    }
};
var $d77b025aa58d633c$var$DonutSeries = class extends $d77b025aa58d633c$var$PolarSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            categoryKey: void 0,
            pickModes: [
                1 /* NEAREST_NODE */ ,
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            useLabelLayer: true,
            animationResetFns: {
                item: $d77b025aa58d633c$var$resetPieSelectionsFn,
                label: $d77b025aa58d633c$var$resetLabelFn
            }
        });
        this.properties = new $d77b025aa58d633c$var$DonutSeriesProperties();
        this.phantomNodeData = void 0;
        this.backgroundGroup = new $d77b025aa58d633c$var$TranslatableGroup({
            name: `${this.id}-background`,
            zIndex: 0 /* BACKGROUND */ 
        });
        this.noVisibleData = false;
        this.previousRadiusScale = new $d77b025aa58d633c$var$LinearScale();
        this.radiusScale = new $d77b025aa58d633c$var$LinearScale();
        this.phantomGroup = this.backgroundGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: "phantom"
        }));
        this.phantomSelection = $d77b025aa58d633c$var$Selection.select(this.phantomGroup, ()=>this.nodeFactory(), false);
        this.calloutLabelGroup = this.contentGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: "pieCalloutLabels"
        }));
        this.calloutLabelSelection = new $d77b025aa58d633c$var$Selection(this.calloutLabelGroup, $d77b025aa58d633c$var$Group);
        // AG-6193 If the sum of all datums is 0, then we'll draw 1 or 2 rings to represent the empty series.
        this.zerosumRingsGroup = this.backgroundGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-zerosumRings`
        }));
        this.zerosumOuterRing = this.zerosumRingsGroup.appendChild(new $d77b025aa58d633c$var$Marker({
            shape: "circle"
        }));
        this.zerosumInnerRing = this.zerosumRingsGroup.appendChild(new $d77b025aa58d633c$var$Marker({
            shape: "circle"
        }));
        this.innerLabelsGroup = this.contentGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: "innerLabels"
        }));
        this.innerCircleGroup = this.backgroundGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-innerCircle`
        }));
        this.innerLabelsSelection = $d77b025aa58d633c$var$Selection.select(this.innerLabelsGroup, $d77b025aa58d633c$var$Text);
        this.innerCircleSelection = $d77b025aa58d633c$var$Selection.select(this.innerCircleGroup, ()=>new $d77b025aa58d633c$var$Marker({
                shape: "circle"
            }));
        this.surroundingRadius = void 0;
        this.NodeEvent = $d77b025aa58d633c$var$DonutSeriesNodeEvent;
        this.angleScale = new $d77b025aa58d633c$var$LinearScale();
        this.angleScale.domain = [
            0,
            1
        ];
        this.angleScale.range = [
            -Math.PI,
            Math.PI
        ].map((angle2)=>angle2 + Math.PI / 2);
        this.phantomGroup.opacity = 0.2;
    }
    get calloutNodeData() {
        return this.phantomNodeData ?? this.nodeData;
    }
    attachSeries(seriesContentNode, seriesNode, annotationNode) {
        super.attachSeries(seriesContentNode, seriesNode, annotationNode);
        seriesContentNode?.appendChild(this.backgroundGroup);
    }
    detachSeries(seriesContentNode, seriesNode, annotationNode) {
        super.detachSeries(seriesContentNode, seriesNode, annotationNode);
        seriesContentNode?.removeChild(this.backgroundGroup);
    }
    setSeriesIndex(index) {
        if (!super.setSeriesIndex(index)) return false;
        this.backgroundGroup.zIndex = [
            0 /* BACKGROUND */ ,
            index
        ];
        return true;
    }
    nodeFactory() {
        return new $d77b025aa58d633c$var$Sector();
    }
    getSeriesDomain(direction) {
        if (direction === "angle" /* Angle */ ) return this.angleScale.domain;
        else return this.radiusScale.domain;
    }
    async processData(dataController) {
        if (this.data == null) return;
        const { visible: visible, id: seriesId, ctx: { legendManager: legendManager } } = this;
        const { angleKey: angleKey, angleFilterKey: angleFilterKey, radiusKey: radiusKey, calloutLabelKey: calloutLabelKey, sectorLabelKey: sectorLabelKey, legendItemKey: legendItemKey } = this.properties;
        const processor = ()=>(value, index)=>{
                if (visible && legendManager.getItemEnabled({
                    seriesId: seriesId,
                    itemId: index
                })) return value;
                return 0;
            };
        const animationEnabled = !this.ctx.animationManager.isSkipped();
        const extraKeyProps = [];
        const extraProps = [];
        if (legendItemKey) extraKeyProps.push($d77b025aa58d633c$var$keyProperty(legendItemKey, "band", {
            id: `legendItemKey`
        }));
        else if (calloutLabelKey) extraKeyProps.push($d77b025aa58d633c$var$keyProperty(calloutLabelKey, "band", {
            id: `calloutLabelKey`
        }));
        else if (sectorLabelKey) extraKeyProps.push($d77b025aa58d633c$var$keyProperty(sectorLabelKey, "band", {
            id: `sectorLabelKey`
        }));
        const radiusScaleType = this.radiusScale.type;
        const angleScaleType = this.angleScale.type;
        if (radiusKey) extraProps.push($d77b025aa58d633c$var$rangedValueProperty(radiusKey, {
            id: "radiusValue",
            min: this.properties.radiusMin ?? 0,
            max: this.properties.radiusMax,
            missingValue: this.properties.radiusMax ?? 1,
            processor: processor
        }), $d77b025aa58d633c$var$valueProperty(radiusKey, radiusScaleType, {
            id: `radiusRaw`,
            processor: processor
        }), // Raw value pass-through.
        $d77b025aa58d633c$var$normalisePropertyTo("radiusValue", [
            0,
            1
        ], 1, this.properties.radiusMin ?? 0, this.properties.radiusMax));
        if (calloutLabelKey) extraProps.push($d77b025aa58d633c$var$valueProperty(calloutLabelKey, "band", {
            id: `calloutLabelValue`
        }));
        if (sectorLabelKey) extraProps.push($d77b025aa58d633c$var$valueProperty(sectorLabelKey, "band", {
            id: `sectorLabelValue`
        }));
        if (legendItemKey) extraProps.push($d77b025aa58d633c$var$valueProperty(legendItemKey, "band", {
            id: `legendItemValue`
        }));
        if (angleFilterKey) extraProps.push($d77b025aa58d633c$var$accumulativeValueProperty(angleFilterKey, angleScaleType, {
            id: `angleFilterValue`,
            onlyPositive: true,
            invalidValue: 0,
            processor: processor
        }), $d77b025aa58d633c$var$valueProperty(angleFilterKey, angleScaleType, {
            id: `angleFilterRaw`
        }), $d77b025aa58d633c$var$normalisePropertyTo("angleFilterValue", [
            0,
            1
        ], 0, 0));
        if (animationEnabled && this.processedData && extraKeyProps.length > 0) extraProps.push($d77b025aa58d633c$var$diff(this.id, this.processedData));
        extraProps.push($d77b025aa58d633c$var$animationValidation());
        await this.requestDataModel(dataController, this.data, {
            props: [
                ...extraKeyProps,
                $d77b025aa58d633c$var$accumulativeValueProperty(angleKey, angleScaleType, {
                    id: `angleValue`,
                    onlyPositive: true,
                    invalidValue: 0,
                    processor: processor
                }),
                $d77b025aa58d633c$var$valueProperty(angleKey, angleScaleType, {
                    id: `angleRaw`
                }),
                // Raw value pass-through.
                $d77b025aa58d633c$var$normalisePropertyTo("angleValue", [
                    0,
                    1
                ], 0, 0),
                ...extraProps
            ]
        });
        for (const valueDef of this.processedData?.defs?.values ?? []){
            const { id: id, missing: missing, property: property } = valueDef;
            const missCount = $d77b025aa58d633c$var$getMissCount(this, missing);
            if (id !== "angleRaw" && missCount > 0) (0, $idDdm.Logger).warnOnce(`no value was found for the key '${String(property)}' on ${missCount} data element${missCount > 1 ? "s" : ""}`);
        }
        this.animationState.transition("updateData");
    }
    maybeRefreshNodeData() {
        if (!this.nodeDataRefresh) return;
        const { nodeData: nodeData = [], phantomNodeData: phantomNodeData } = this.createNodeData() ?? {};
        this.nodeData = nodeData;
        this.phantomNodeData = phantomNodeData;
        this.nodeDataRefresh = false;
    }
    getProcessedDataValues(dataModel, processedData) {
        const angleValues = dataModel.resolveColumnById(this, `angleValue`, processedData);
        const angleRawValues = dataModel.resolveColumnById(this, `angleRaw`, processedData);
        const angleFilterValues = this.properties.angleFilterKey != null ? dataModel.resolveColumnById(this, `angleFilterValue`, processedData) : void 0;
        const angleFilterRawValues = this.properties.angleFilterKey != null ? dataModel.resolveColumnById(this, `angleFilterRaw`, processedData) : void 0;
        const radiusValues = this.properties.radiusKey ? dataModel.resolveColumnById(this, `radiusValue`, processedData) : void 0;
        const radiusRawValues = this.properties.radiusKey ? dataModel.resolveColumnById(this, `radiusRaw`, processedData) : void 0;
        const calloutLabelValues = this.properties.calloutLabelKey ? dataModel.resolveColumnById(this, `calloutLabelValue`, processedData) : void 0;
        const sectorLabelValues = this.properties.sectorLabelKey ? dataModel.resolveColumnById(this, `sectorLabelValue`, processedData) : void 0;
        const legendItemValues = this.properties.legendItemKey ? dataModel.resolveColumnById(this, `legendItemValue`, processedData) : void 0;
        return {
            angleValues: angleValues,
            angleRawValues: angleRawValues,
            angleFilterValues: angleFilterValues,
            angleFilterRawValues: angleFilterRawValues,
            radiusValues: radiusValues,
            radiusRawValues: radiusRawValues,
            calloutLabelValues: calloutLabelValues,
            sectorLabelValues: sectorLabelValues,
            legendItemValues: legendItemValues
        };
    }
    createNodeData() {
        const { id: seriesId, processedData: processedData, dataModel: dataModel, angleScale: angleScale, ctx: { legendManager: legendManager }, visible: visible } = this;
        const { rotation: rotation, innerRadiusRatio: innerRadiusRatio } = this.properties;
        if (!dataModel || processedData?.type !== "ungrouped") return;
        const { angleValues: angleValues, angleRawValues: angleRawValues, angleFilterValues: angleFilterValues, angleFilterRawValues: angleFilterRawValues, radiusValues: radiusValues, radiusRawValues: radiusRawValues, calloutLabelValues: calloutLabelValues, sectorLabelValues: sectorLabelValues, legendItemValues: legendItemValues } = this.getProcessedDataValues(dataModel, processedData);
        const useFilterAngles = angleFilterRawValues?.some((filterRawValue, index)=>{
            return filterRawValue > angleRawValues[index];
        }) ?? false;
        let currentStart = 0;
        let sum2 = 0;
        const nodes = [];
        const phantomNodes = angleFilterRawValues != null ? [] : void 0;
        const rawData = processedData.dataSources.get(this.id) ?? [];
        const invalidData = processedData.invalidData?.get(this.id);
        rawData.forEach((datum, datumIndex)=>{
            if (invalidData?.[datumIndex] === true) return;
            const currentValue = useFilterAngles ? angleFilterValues[datumIndex] : angleValues[datumIndex];
            const crossFilterScale = angleFilterRawValues != null && !useFilterAngles ? Math.sqrt(angleFilterRawValues[datumIndex] / angleRawValues[datumIndex]) : 1;
            const startAngle = angleScale.convert(currentStart) + $d77b025aa58d633c$var$toRadians(rotation);
            currentStart = currentValue;
            sum2 += currentValue;
            const endAngle = angleScale.convert(currentStart) + $d77b025aa58d633c$var$toRadians(rotation);
            const span = Math.abs(endAngle - startAngle);
            const midAngle = startAngle + span / 2;
            const angleValue = angleRawValues[datumIndex];
            const radiusRaw = radiusValues?.[datumIndex] ?? 1;
            const radius = radiusRaw * crossFilterScale;
            const radiusValue = radiusRawValues?.[datumIndex];
            const legendItemValue = legendItemValues?.[datumIndex];
            const nodeLabels = this.getLabels(datum, midAngle, span, true, calloutLabelValues?.[datumIndex], sectorLabelValues?.[datumIndex], legendItemValue);
            const sectorFormat = this.getSectorFormat(datum, datumIndex, false);
            const node = {
                itemId: datumIndex,
                series: this,
                datum: datum,
                datumIndex: datumIndex,
                angleValue: angleValue,
                midAngle: midAngle,
                midCos: Math.cos(midAngle),
                midSin: Math.sin(midAngle),
                startAngle: startAngle,
                endAngle: endAngle,
                radius: radius,
                innerRadius: Math.max(this.radiusScale.convert(0), 0),
                outerRadius: Math.max(this.radiusScale.convert(radius), 0),
                sectorFormat: sectorFormat,
                radiusValue: radiusValue,
                legendItemValue: legendItemValue,
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: seriesId,
                    itemId: datumIndex
                }),
                focusable: true,
                ...nodeLabels
            };
            nodes.push(node);
            if (phantomNodes != null) phantomNodes.push({
                ...node,
                radius: 1,
                innerRadius: Math.max(this.radiusScale.convert(0), 0),
                outerRadius: Math.max(this.radiusScale.convert(1), 0),
                focusable: false
            });
        });
        this.zerosumOuterRing.visible = sum2 === 0;
        this.zerosumInnerRing.visible = sum2 === 0 && innerRadiusRatio != null && innerRadiusRatio !== 1 && innerRadiusRatio > 0;
        return {
            itemId: seriesId,
            nodeData: nodes,
            labelData: nodes,
            phantomNodeData: phantomNodes
        };
    }
    getLabels(datum, midAngle, span, skipDisabled, calloutLabelValue, sectorLabelValue, legendItemValue) {
        const { calloutLabel: calloutLabel, sectorLabel: sectorLabel, legendItemKey: legendItemKey } = this.properties;
        const calloutLabelKey = !skipDisabled || calloutLabel.enabled ? this.properties.calloutLabelKey : void 0;
        const sectorLabelKey = !skipDisabled || sectorLabel.enabled ? this.properties.sectorLabelKey : void 0;
        if (!calloutLabelKey && !sectorLabelKey && !legendItemKey) return {};
        const labelFormatterParams = {
            datum: datum,
            angleKey: this.properties.angleKey,
            angleName: this.properties.angleName,
            radiusKey: this.properties.radiusKey,
            radiusName: this.properties.radiusName,
            calloutLabelKey: this.properties.calloutLabelKey,
            calloutLabelName: this.properties.calloutLabelName,
            sectorLabelKey: this.properties.sectorLabelKey,
            sectorLabelName: this.properties.sectorLabelName,
            legendItemKey: this.properties.legendItemKey
        };
        const result = {};
        if (calloutLabelKey && span >= $d77b025aa58d633c$var$toRadians(calloutLabel.minAngle)) result.calloutLabel = {
            ...this.getTextAlignment(midAngle),
            text: this.getLabelText(calloutLabel, {
                ...labelFormatterParams,
                value: calloutLabelValue
            }),
            hidden: false,
            collisionTextAlign: void 0,
            collisionOffsetY: 0,
            box: void 0
        };
        if (sectorLabelKey) result.sectorLabel = {
            text: this.getLabelText(sectorLabel, {
                ...labelFormatterParams,
                value: sectorLabelValue
            })
        };
        if (legendItemKey != null && legendItemValue != null) result.legendItem = {
            key: legendItemKey,
            text: legendItemValue
        };
        return result;
    }
    getTextAlignment(midAngle) {
        const quadrantTextOpts = [
            {
                textAlign: "center",
                textBaseline: "bottom"
            },
            {
                textAlign: "left",
                textBaseline: "middle"
            },
            {
                textAlign: "center",
                textBaseline: "hanging"
            },
            {
                textAlign: "right",
                textBaseline: "middle"
            }
        ];
        const midAngle180 = $d77b025aa58d633c$var$normalizeAngle180(midAngle);
        const quadrantStart = -0.75 * Math.PI;
        const quadrantOffset = midAngle180 - quadrantStart;
        const quadrant = Math.floor(quadrantOffset / (Math.PI / 2));
        const quadrantIndex = (0, $idDdm.modulus)(quadrant, quadrantTextOpts.length);
        return quadrantTextOpts[quadrantIndex];
    }
    getNodeFill(fill, defaultColorRange, defaultPatternFill) {
        return $d77b025aa58d633c$var$getShapeFill(fill, {
            type: "gradient",
            bounds: "series",
            colorStops: defaultColorRange.map((color11)=>({
                    color: color11
                })),
            gradient: "radial",
            rotation: 0,
            reverse: true
        }, {
            type: "pattern",
            pattern: "forward-slanted-lines",
            fill: defaultPatternFill,
            fillOpacity: 1,
            backgroundFill: "none",
            backgroundFillOpacity: 1,
            stroke: defaultPatternFill,
            strokeOpacity: 1,
            strokeWidth: 4,
            rotation: 0
        }, {
            type: "image",
            backgroundFill: defaultPatternFill,
            backgroundFillOpacity: 1,
            fit: "contain",
            repeat: "no-repeat",
            rotation: 0
        });
    }
    getFillParams(fill, innerRadius, outerRadius) {
        if (!$d77b025aa58d633c$var$isGradientFill(fill) || fill.bounds === "item") return;
        return {
            centerX: 0,
            centerY: 0,
            innerRadius: innerRadius,
            outerRadius: outerRadius
        };
    }
    getSectorFormat(datum, datumIndex, highlighted) {
        const { angleKey: angleKey, radiusKey: radiusKey, calloutLabelKey: calloutLabelKey, sectorLabelKey: sectorLabelKey, legendItemKey: legendItemKey, fills: fills, strokes: strokes, defaultColorRange: defaultColorRange, defaultPatternFills: defaultPatternFills, itemStyler: itemStyler } = this.properties;
        const defaultStroke = strokes[datumIndex % strokes.length];
        const { fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, cornerRadius: cornerRadius } = $d77b025aa58d633c$var$mergeDefaults(highlighted && this.properties.highlightStyle.item, {
            fill: fills.length > 0 ? fills[datumIndex % fills.length] : void 0,
            stroke: defaultStroke,
            strokeWidth: this.getStrokeWidth(this.properties.strokeWidth),
            strokeOpacity: this.getOpacity()
        }, this.properties);
        const defaultColors = defaultColorRange[datumIndex % defaultColorRange.length];
        const defaultPatternFill = defaultPatternFills[datumIndex % defaultPatternFills.length];
        const sectorFill = fill ?? "black";
        let format;
        if (itemStyler) format = this.cachedDatumCallback(this.getDatumId(datumIndex) + (highlighted ? "-highlight" : "-hide"), ()=>this.callWithContext(itemStyler, {
                datum: datum,
                angleKey: angleKey,
                radiusKey: radiusKey,
                calloutLabelKey: calloutLabelKey,
                sectorLabelKey: sectorLabelKey,
                legendItemKey: legendItemKey,
                fill: this.getNodeFill(sectorFill, defaultColors, defaultPatternFill),
                fillOpacity: fillOpacity,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                strokeOpacity: strokeOpacity,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset,
                cornerRadius: cornerRadius,
                highlighted: highlighted,
                seriesId: this.id
            }));
        return {
            fill: this.getNodeFill(format?.fill ?? sectorFill, defaultColors, defaultPatternFill),
            fillOpacity: format?.fillOpacity ?? fillOpacity,
            stroke: format?.stroke ?? stroke2,
            strokeWidth: format?.strokeWidth ?? strokeWidth,
            strokeOpacity: format?.strokeOpacity ?? strokeOpacity,
            lineDash: format?.lineDash ?? lineDash,
            lineDashOffset: format?.lineDashOffset ?? lineDashOffset,
            cornerRadius: format?.cornerRadius ?? cornerRadius
        };
    }
    getInnerRadius() {
        const { radius: radius } = this;
        const { innerRadiusRatio: innerRadiusRatio = 1, innerRadiusOffset: innerRadiusOffset = 0 } = this.properties;
        const innerRadius = radius * innerRadiusRatio + innerRadiusOffset;
        if (innerRadius === radius || innerRadius < 0) return 0;
        return innerRadius;
    }
    getOuterRadius() {
        const { outerRadiusRatio: outerRadiusRatio, outerRadiusOffset: outerRadiusOffset } = this.properties;
        return Math.max(this.radius * outerRadiusRatio + outerRadiusOffset, 0);
    }
    updateRadiusScale(resize) {
        const newRange = [
            this.getInnerRadius(),
            this.getOuterRadius()
        ];
        this.radiusScale.range = newRange;
        if (resize) this.previousRadiusScale.range = newRange;
        const setRadii = (d)=>({
                ...d,
                innerRadius: Math.max(this.radiusScale.convert(0), 0),
                outerRadius: Math.max(this.radiusScale.convert(d.radius), 0)
            });
        this.nodeData = this.nodeData.map(setRadii);
        this.phantomNodeData = this.phantomNodeData?.map(setRadii);
    }
    getTitleTranslationY() {
        const outerRadius = Math.max(0, this.radiusScale.range[1]);
        if (outerRadius === 0) return NaN;
        const spacing = this.properties.title?.spacing ?? 0;
        const titleOffset = 2 + spacing;
        const dy = Math.max(0, -outerRadius);
        return -outerRadius - titleOffset - dy;
    }
    update({ seriesRect: seriesRect }) {
        const { title: title } = this.properties;
        const newNodeDataDependencies = {
            seriesRectWidth: seriesRect?.width,
            seriesRectHeight: seriesRect?.height
        };
        const resize = $d77b025aa58d633c$var$jsonDiff(this.nodeDataDependencies, newNodeDataDependencies) != null;
        if (resize) this._nodeDataDependencies = newNodeDataDependencies;
        this.maybeRefreshNodeData();
        this.updateTitleNodes();
        this.updateRadiusScale(resize);
        this.contentGroup.translationX = this.centerX;
        this.contentGroup.translationY = this.centerY;
        this.highlightGroup.translationX = this.centerX;
        this.highlightGroup.translationY = this.centerY;
        this.backgroundGroup.translationX = this.centerX;
        this.backgroundGroup.translationY = this.centerY;
        if (this.labelGroup) {
            this.labelGroup.translationX = this.centerX;
            this.labelGroup.translationY = this.centerY;
        }
        if (title) {
            const dy = this.getTitleTranslationY();
            title.node.y = isFinite(dy) ? dy : 0;
            const titleBox = title.node.getBBox();
            title.node.visible = title.enabled && isFinite(dy) && !this.bboxIntersectsSurroundingSeries(titleBox);
        }
        for (const circle of [
            this.zerosumInnerRing,
            this.zerosumOuterRing
        ]){
            circle.fillOpacity = 0;
            circle.stroke = this.properties.calloutLabel.color;
            circle.strokeWidth = 1;
            circle.strokeOpacity = 1;
        }
        this.updateNodeMidPoint();
        this.updateSelections();
        this.updateNodes(seriesRect);
    }
    updateTitleNodes() {
        const { oldTitle: oldTitle } = this;
        const { title: title } = this.properties;
        if (oldTitle !== title) {
            if (oldTitle) this.labelGroup?.removeChild(oldTitle.node);
            if (title) {
                title.node.textBaseline = "bottom";
                this.labelGroup?.appendChild(title.node);
            }
            this.oldTitle = title;
        }
    }
    updateNodeMidPoint() {
        const setMidPoint = (d)=>{
            const radius = d.innerRadius + (d.outerRadius - d.innerRadius) / 2;
            d.midPoint = {
                x: d.midCos * Math.max(0, radius),
                y: d.midSin * Math.max(0, radius)
            };
        };
        this.nodeData.forEach(setMidPoint);
        this.phantomNodeData?.forEach(setMidPoint);
    }
    updateSelections() {
        this.updateGroupSelection();
        this.updateInnerCircleSelection();
    }
    updateGroupSelection() {
        const { itemSelection: itemSelection, highlightSelection: highlightSelection, phantomSelection: phantomSelection, highlightLabelSelection: highlightLabelSelection, calloutLabelSelection: calloutLabelSelection, labelSelection: labelSelection, innerLabelsSelection: innerLabelsSelection } = this;
        const highlightedNodeData = this.nodeData.map((datum)=>({
                ...datum,
                // Allow mutable sectorFormat, so formatted sector styles can be updated and varied
                // between normal and highlighted cases.
                sectorFormat: {
                    ...datum.sectorFormat
                }
            }));
        const update = (selection, nodeData)=>{
            selection.update(nodeData, void 0, (datum)=>this.getDatumId(datum.datumIndex));
            if (this.ctx.animationManager.isSkipped()) selection.cleanup();
        };
        update(itemSelection, this.nodeData);
        update(highlightSelection, highlightedNodeData);
        update(phantomSelection, this.phantomNodeData ?? []);
        calloutLabelSelection.update(this.calloutNodeData, (group)=>{
            const line = new $d77b025aa58d633c$var$Line();
            line.tag = 0 /* Callout */ ;
            line.pointerEvents = 1 /* None */ ;
            group.appendChild(line);
            const text = new $d77b025aa58d633c$var$Text();
            text.tag = 1 /* Label */ ;
            text.pointerEvents = 1 /* None */ ;
            group.appendChild(text);
        });
        labelSelection.update(this.nodeData);
        highlightLabelSelection.update(highlightedNodeData);
        innerLabelsSelection.update(this.properties.innerLabels, (node)=>{
            node.pointerEvents = 1 /* None */ ;
        });
    }
    updateInnerCircleSelection() {
        const { innerCircle: innerCircle } = this.properties;
        let radius = 0;
        const innerRadius = this.getInnerRadius();
        if (innerRadius > 0) {
            const circleRadius = Math.min(innerRadius, this.getOuterRadius());
            const antiAliasingPadding = 1;
            radius = Math.ceil(circleRadius * 2 + antiAliasingPadding);
        }
        const datums = innerCircle ? [
            {
                radius: radius
            }
        ] : [];
        this.innerCircleSelection.update(datums);
    }
    updateNodes(seriesRect) {
        const highlightedDatum = this.ctx.highlightManager.getActiveHighlight();
        const { visible: visible } = this;
        this.backgroundGroup.visible = visible;
        this.contentGroup.visible = visible;
        this.highlightGroup.visible = visible && highlightedDatum?.series === this;
        this.highlightLabel.visible = visible && highlightedDatum?.series === this;
        this.labelGroup.visible = visible;
        this.contentGroup.opacity = this.getOpacity();
        this.innerCircleSelection.each((node, { radius: radius })=>{
            node.setProperties({
                fill: this.getNodeFill(this.properties.innerCircle?.fill, [
                    "black"
                ], "black"),
                opacity: this.properties.innerCircle?.fillOpacity,
                size: radius
            });
        });
        const innerRadius = this.radiusScale.range[0];
        const outerRadius = this.radiusScale.range[1];
        const fillBBox = this.getShapeFillBBox();
        const animationDisabled = this.ctx.animationManager.isSkipped();
        const updateSectorFn = (sector, datum, _index, isDatumHighlighted)=>{
            const format = this.getSectorFormat(datum.datum, datum.itemId, isDatumHighlighted);
            datum.sectorFormat.fill = format.fill;
            datum.sectorFormat.stroke = format.stroke;
            if (animationDisabled) {
                sector.startAngle = datum.startAngle;
                sector.endAngle = datum.endAngle;
                sector.innerRadius = datum.innerRadius;
                sector.outerRadius = datum.outerRadius;
            }
            if (isDatumHighlighted || animationDisabled) {
                sector.fill = format.fill;
                sector.stroke = format.stroke;
            }
            const fillParams = this.getFillParams(format.fill, innerRadius, outerRadius);
            $d77b025aa58d633c$var$applyShapeFillBBox(sector, format.fill, fillBBox, fillParams);
            sector.strokeWidth = format.strokeWidth;
            sector.fillOpacity = format.fillOpacity;
            sector.strokeOpacity = format.strokeOpacity;
            sector.lineDash = format.lineDash;
            sector.lineDashOffset = format.lineDashOffset;
            sector.cornerRadius = format.cornerRadius;
            sector.fillShadow = this.properties.shadow;
            const inset = Math.max((this.properties.sectorSpacing + (format.stroke != null ? format.strokeWidth : 0)) / 2, 0);
            sector.inset = inset;
            sector.lineJoin = this.properties.sectorSpacing >= 0 || inset > 0 ? "miter" : "round";
        };
        this.itemSelection.each((node, datum, index)=>updateSectorFn(node, datum, index, false));
        this.highlightSelection.each((node, datum, index)=>{
            updateSectorFn(node, datum, index, true);
            node.visible = datum.itemId === highlightedDatum?.itemId;
        });
        this.phantomSelection.each((node, datum, index)=>updateSectorFn(node, datum, index, false));
        this.updateCalloutLineNodes();
        this.updateCalloutLabelNodes(seriesRect);
        this.updateSectorLabelNodes();
        this.updateInnerLabelNodes();
        this.updateZerosumRings();
        this.animationState.transition("update");
    }
    updateCalloutLineNodes() {
        const { calloutLine: { length: calloutLength, strokeWidth: strokeWidth, colors: colors }, strokes: strokes } = this.properties;
        const calloutStrokeWidth = strokeWidth;
        const calloutColors = $d77b025aa58d633c$var$isStringFillArray(colors) ? colors ?? this.properties.strokes : strokes;
        const { offset: offset4 } = this.properties.calloutLabel;
        this.calloutLabelSelection.selectByTag(0 /* Callout */ ).forEach((line)=>{
            const datum = line.closestDatum();
            const { calloutLabel: label, outerRadius: outerRadius, datumIndex: datumIndex } = datum;
            if (label?.text && !label.hidden && outerRadius !== 0) {
                line.visible = true;
                line.strokeWidth = calloutStrokeWidth;
                line.stroke = calloutColors[datumIndex % calloutColors.length];
                line.fill = void 0;
                const x1 = datum.midCos * outerRadius;
                const y1 = datum.midSin * outerRadius;
                let x2 = datum.midCos * (outerRadius + calloutLength);
                let y2 = datum.midSin * (outerRadius + calloutLength);
                const isMoved = label.collisionTextAlign ?? label.collisionOffsetY !== 0;
                if (isMoved && label.box != null) {
                    const box = label.box;
                    let cx = x2;
                    let cy = y2;
                    if (x2 < box.x) cx = box.x;
                    else if (x2 > box.x + box.width) cx = box.x + box.width;
                    if (y2 < box.y) cy = box.y;
                    else if (y2 > box.y + box.height) cy = box.y + box.height;
                    const dx = cx - x2;
                    const dy = cy - y2;
                    const length2 = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                    const paddedLength = length2 - offset4;
                    if (paddedLength > 0) {
                        x2 = x2 + dx * paddedLength / length2;
                        y2 = y2 + dy * paddedLength / length2;
                    }
                }
                line.x1 = x1;
                line.y1 = y1;
                line.x2 = x2;
                line.y2 = y2;
            } else line.visible = false;
        });
    }
    getLabelOverflow(text, box, seriesRect) {
        const seriesLeft = -this.centerX;
        const seriesRight = seriesLeft + seriesRect.width;
        const seriesTop = -this.centerY;
        const seriesBottom = seriesTop + seriesRect.height;
        const errPx = 1;
        let visibleTextPart = 1;
        if (box.x + errPx < seriesLeft) visibleTextPart = (box.x + box.width - seriesLeft) / box.width;
        else if (box.x + box.width - errPx > seriesRight) visibleTextPart = (seriesRight - box.x) / box.width;
        const hasVerticalOverflow = box.y + errPx < seriesTop || box.y + box.height - errPx > seriesBottom;
        const textLength = visibleTextPart === 1 ? text.length : Math.floor(text.length * visibleTextPart) - 1;
        const hasSurroundingSeriesOverflow = this.bboxIntersectsSurroundingSeries(box);
        return {
            textLength: textLength,
            hasVerticalOverflow: hasVerticalOverflow,
            hasSurroundingSeriesOverflow: hasSurroundingSeriesOverflow
        };
    }
    bboxIntersectsSurroundingSeries(box) {
        const { surroundingRadius: surroundingRadius } = this;
        if (surroundingRadius == null) return false;
        const corners = [
            {
                x: box.x,
                y: box.y
            },
            {
                x: box.x + box.width,
                y: box.y
            },
            {
                x: box.x + box.width,
                y: box.y + box.height
            },
            {
                x: box.x,
                y: box.y + box.height
            }
        ];
        const sur2 = surroundingRadius ** 2;
        return corners.some((corner)=>corner.x ** 2 + corner.y ** 2 > sur2);
    }
    computeCalloutLabelCollisionOffsets() {
        const { radiusScale: radiusScale } = this;
        const { calloutLabel: calloutLabel, calloutLine: calloutLine } = this.properties;
        const { offset: offset4, minSpacing: minSpacing } = calloutLabel;
        const innerRadius = radiusScale.convert(0);
        const shouldSkip = (datum)=>{
            const label = datum.calloutLabel;
            return !label || datum.outerRadius === 0;
        };
        const fullData = this.calloutNodeData;
        const data = fullData.filter((t)=>!shouldSkip(t));
        data.forEach((datum)=>{
            const label = datum.calloutLabel;
            if (label == null) return;
            label.hidden = false;
            label.collisionTextAlign = void 0;
            label.collisionOffsetY = 0;
        });
        if (data.length <= 1) return;
        const leftLabels = data.filter((d)=>d.midCos < 0).sort((a, b)=>a.midSin - b.midSin);
        const rightLabels = data.filter((d)=>d.midCos >= 0).sort((a, b)=>a.midSin - b.midSin);
        const topLabels = data.filter((d)=>d.midSin < 0 && d.calloutLabel?.textAlign === "center").sort((a, b)=>a.midCos - b.midCos);
        const bottomLabels = data.filter((d)=>d.midSin >= 0 && d.calloutLabel?.textAlign === "center").sort((a, b)=>a.midCos - b.midCos);
        const getTextBBox = (datum)=>{
            const label = datum.calloutLabel;
            if (label == null) return $d77b025aa58d633c$var$BBox.zero.clone();
            const labelRadius = datum.outerRadius + calloutLine.length + offset4;
            const x = datum.midCos * labelRadius;
            const y = datum.midSin * labelRadius + label.collisionOffsetY;
            const textAlign = label.collisionTextAlign ?? label.textAlign;
            const textBaseline = label.textBaseline;
            return $d77b025aa58d633c$var$Text.computeBBox(label.text, x, y, {
                font: this.properties.calloutLabel,
                textAlign: textAlign,
                textBaseline: textBaseline
            });
        };
        const avoidNeighbourYCollision = (label, next, direction)=>{
            const box = getTextBBox(label).grow(minSpacing / 2);
            const other = getTextBBox(next).grow(minSpacing / 2);
            const collidesOrBehind = box.x < other.x + other.width && box.x + box.width > other.x && (direction === "to-top" ? box.y < other.y + other.height : box.y + box.height > other.y);
            if (collidesOrBehind) next.calloutLabel.collisionOffsetY = direction === "to-top" ? box.y - other.y - other.height : box.y + box.height - other.y;
        };
        const avoidYCollisions = (labels)=>{
            const midLabel = labels.slice().sort((a, b)=>Math.abs(a.midSin) - Math.abs(b.midSin))[0];
            const midIndex = labels.indexOf(midLabel);
            for(let i = midIndex - 1; i >= 0; i--){
                const prev = labels[i + 1];
                const next = labels[i];
                avoidNeighbourYCollision(prev, next, "to-top");
            }
            for(let i = midIndex + 1; i < labels.length; i++){
                const prev = labels[i - 1];
                const next = labels[i];
                avoidNeighbourYCollision(prev, next, "to-bottom");
            }
        };
        const avoidXCollisions = (labels)=>{
            const labelsCollideLabelsByY = data.some((datum)=>datum.calloutLabel.collisionOffsetY !== 0);
            const boxes = labels.map((label)=>getTextBBox(label));
            const paddedBoxes = boxes.map((box)=>box.clone().grow(minSpacing / 2));
            let labelsCollideLabelsByX = false;
            for(let i = 0; i < paddedBoxes.length && !labelsCollideLabelsByX; i++){
                const box = paddedBoxes[i];
                for(let j = i + 1; j < labels.length; j++){
                    const other = paddedBoxes[j];
                    if (box.collidesBBox(other)) {
                        labelsCollideLabelsByX = true;
                        break;
                    }
                }
            }
            const sectors = fullData.map((datum)=>{
                const { startAngle: startAngle, endAngle: endAngle, outerRadius: outerRadius } = datum;
                return {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius
                };
            });
            const labelsCollideSectors = boxes.some((box)=>{
                return sectors.some((sector)=>$d77b025aa58d633c$var$boxCollidesSector(box, sector));
            });
            if (!labelsCollideLabelsByX && !labelsCollideLabelsByY && !labelsCollideSectors) return;
            labels.filter((d)=>d.calloutLabel.textAlign === "center").forEach((d)=>{
                const label = d.calloutLabel;
                if (d.midCos < 0) label.collisionTextAlign = "right";
                else if (d.midCos > 0) label.collisionTextAlign = "left";
                else label.collisionTextAlign = "center";
            });
        };
        avoidYCollisions(leftLabels);
        avoidYCollisions(rightLabels);
        avoidXCollisions(topLabels);
        avoidXCollisions(bottomLabels);
    }
    updateCalloutLabelNodes(seriesRect) {
        const { radiusScale: radiusScale } = this;
        const { calloutLabel: calloutLabel, calloutLine: calloutLine } = this.properties;
        const calloutLength = calloutLine.length;
        const { offset: offset4, color: color11 } = calloutLabel;
        const tempTextNode = new $d77b025aa58d633c$var$Text();
        this.calloutLabelSelection.selectByTag(1 /* Label */ ).forEach((text)=>{
            const datum = text.closestDatum();
            const label = datum.calloutLabel;
            const radius = radiusScale.convert(datum.radius);
            const outerRadius = Math.max(0, radius);
            if (!label?.text || outerRadius === 0 || label.hidden) {
                text.visible = false;
                return;
            }
            const labelRadius = outerRadius + calloutLength + offset4;
            const x = datum.midCos * labelRadius;
            const y = datum.midSin * labelRadius + label.collisionOffsetY;
            const align2 = {
                textAlign: label.collisionTextAlign ?? label.textAlign,
                textBaseline: label.textBaseline
            };
            tempTextNode.text = label.text;
            tempTextNode.x = x;
            tempTextNode.y = y;
            tempTextNode.setFont(this.properties.calloutLabel);
            tempTextNode.setAlign(align2);
            const box = tempTextNode.getBBox();
            let displayText = label.text;
            let visible = true;
            if (calloutLabel.avoidCollisions) {
                const { textLength: textLength, hasVerticalOverflow: hasVerticalOverflow } = this.getLabelOverflow(label.text, box, seriesRect);
                displayText = label.text.length === textLength ? label.text : `${label.text.substring(0, textLength)}\u2026`;
                visible = !hasVerticalOverflow;
            }
            text.text = displayText;
            text.x = x;
            text.y = y;
            text.setFont(this.properties.calloutLabel);
            text.setAlign(align2);
            text.fill = color11;
            text.visible = visible;
        });
    }
    computeLabelsBBox(options, seriesRect) {
        const { calloutLabel: calloutLabel, calloutLine: calloutLine } = this.properties;
        const calloutLength = calloutLine.length;
        const { offset: offset4, maxCollisionOffset: maxCollisionOffset, minSpacing: minSpacing } = calloutLabel;
        if (!calloutLabel.avoidCollisions) return null;
        this.maybeRefreshNodeData();
        this.updateRadiusScale(false);
        this.computeCalloutLabelCollisionOffsets();
        const textBoxes = [];
        const text = new $d77b025aa58d633c$var$Text();
        let titleBox;
        const { title: title } = this.properties;
        if (title?.text && title.enabled) {
            const dy = this.getTitleTranslationY();
            if (isFinite(dy)) {
                text.text = title.text;
                text.x = 0;
                text.y = dy;
                text.setFont(title);
                text.setAlign({
                    textBaseline: "bottom",
                    textAlign: "center"
                });
                titleBox = text.getBBox();
                textBoxes.push(titleBox);
            }
        }
        this.calloutNodeData.forEach((datum)=>{
            const label = datum.calloutLabel;
            if (!label || datum.outerRadius === 0) return null;
            const labelRadius = datum.outerRadius + calloutLength + offset4;
            const x = datum.midCos * labelRadius;
            const y = datum.midSin * labelRadius + label.collisionOffsetY;
            text.text = label.text;
            text.x = x;
            text.y = y;
            text.setFont(this.properties.calloutLabel);
            text.setAlign({
                textAlign: label.collisionTextAlign ?? label.textAlign,
                textBaseline: label.textBaseline
            });
            const box = text.getBBox();
            label.box = box;
            if (Math.abs(label.collisionOffsetY) > maxCollisionOffset) {
                label.hidden = true;
                return;
            }
            if (titleBox) {
                const seriesTop = -this.centerY;
                const titleCleanArea = new $d77b025aa58d633c$var$BBox(titleBox.x - minSpacing, seriesTop, titleBox.width + 2 * minSpacing, titleBox.y + titleBox.height + minSpacing - seriesTop);
                if (box.collidesBBox(titleCleanArea)) {
                    label.hidden = true;
                    return;
                }
            }
            if (options.hideWhenNecessary) {
                const { textLength: textLength, hasVerticalOverflow: hasVerticalOverflow, hasSurroundingSeriesOverflow: hasSurroundingSeriesOverflow } = this.getLabelOverflow(label.text, box, seriesRect);
                const isTooShort = label.text.length > 2 && textLength < 2;
                if (hasVerticalOverflow || isTooShort || hasSurroundingSeriesOverflow) {
                    label.hidden = true;
                    return;
                }
            }
            label.hidden = false;
            textBoxes.push(box);
        });
        if (textBoxes.length === 0) return null;
        return $d77b025aa58d633c$var$BBox.merge(textBoxes);
    }
    updateSectorLabelNodes() {
        const { radiusScale: radiusScale } = this;
        const innerRadius = radiusScale.convert(0);
        const { fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight, fontFamily: fontFamily, positionOffset: positionOffset, positionRatio: positionRatio, color: color11 } = this.properties.sectorLabel;
        const updateSectorLabel = (text, datum)=>{
            const { sectorLabel: sectorLabel, outerRadius: outerRadius } = datum;
            let isTextVisible = false;
            if (sectorLabel && outerRadius !== 0) {
                const labelRadius = innerRadius * (1 - positionRatio) + outerRadius * positionRatio + positionOffset;
                text.fill = color11;
                text.fontStyle = fontStyle;
                text.fontWeight = fontWeight;
                text.fontSize = fontSize;
                text.fontFamily = fontFamily;
                text.text = sectorLabel.text;
                text.x = datum.midCos * labelRadius;
                text.y = datum.midSin * labelRadius;
                text.textAlign = "center";
                text.textBaseline = "middle";
                const bbox = text.getBBox();
                const corners = [
                    [
                        bbox.x,
                        bbox.y
                    ],
                    [
                        bbox.x + bbox.width,
                        bbox.y
                    ],
                    [
                        bbox.x + bbox.width,
                        bbox.y + bbox.height
                    ],
                    [
                        bbox.x,
                        bbox.y + bbox.height
                    ]
                ];
                const { startAngle: startAngle, endAngle: endAngle } = datum;
                const sectorBounds = {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius
                };
                if (corners.every(([x, y])=>$d77b025aa58d633c$var$isPointInSector(x, y, sectorBounds))) isTextVisible = true;
            }
            text.visible = isTextVisible;
        };
        this.labelSelection.each(updateSectorLabel);
        this.highlightLabelSelection.each(updateSectorLabel);
    }
    updateInnerLabelNodes() {
        const textBBoxes = [];
        const margins = [];
        this.innerLabelsSelection.each((text, datum)=>{
            const { fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily, color: color11 } = datum;
            text.fontStyle = fontStyle;
            text.fontWeight = fontWeight;
            text.fontSize = fontSize;
            text.fontFamily = fontFamily;
            text.text = datum.text;
            text.x = 0;
            text.y = 0;
            text.fill = color11;
            text.textAlign = "center";
            text.textBaseline = "alphabetic";
            textBBoxes.push(text.getBBox());
            margins.push(datum.spacing);
        });
        const getMarginTop = (index)=>index === 0 ? 0 : margins[index];
        const getMarginBottom = (index)=>index === margins.length - 1 ? 0 : margins[index];
        const totalHeight = textBBoxes.reduce((sum2, bbox, i)=>{
            return sum2 + bbox.height + getMarginTop(i) + getMarginBottom(i);
        }, 0);
        const totalWidth = Math.max(...textBBoxes.map((bbox)=>bbox.width));
        const innerRadius = this.getInnerRadius();
        const labelRadius = Math.sqrt(Math.pow(totalWidth / 2, 2) + Math.pow(totalHeight / 2, 2));
        const labelsVisible = labelRadius <= (innerRadius > 0 ? innerRadius : this.getOuterRadius());
        const textBottoms = [];
        for(let i = 0, prev = -totalHeight / 2; i < textBBoxes.length; i++){
            const bbox = textBBoxes[i];
            const bottom = bbox.height + prev + getMarginTop(i);
            textBottoms.push(bottom);
            prev = bottom + getMarginBottom(i);
        }
        this.innerLabelsSelection.each((text, _datum, index)=>{
            text.y = textBottoms[index];
            text.visible = labelsVisible;
        });
    }
    updateZerosumRings() {
        this.zerosumOuterRing.size = this.getOuterRadius() * 2;
        this.zerosumInnerRing.size = this.getInnerRadius() * 2;
    }
    pickNodeClosestDatum(point) {
        return $d77b025aa58d633c$var$pickByMatchingAngle(this, point);
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, properties: properties } = this;
        const { legendItemKey: legendItemKey, calloutLabelKey: calloutLabelKey, calloutLabelName: calloutLabelName, sectorLabelKey: sectorLabelKey, sectorLabelName: sectorLabelName, angleKey: angleKey, angleName: angleName, radiusKey: radiusKey, radiusName: radiusName, tooltip: tooltip } = properties;
        const title = this.properties.title.text;
        if (!dataModel || !processedData) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const { angleRawValues: angleRawValues, legendItemValues: legendItemValues, calloutLabelValues: calloutLabelValues, sectorLabelValues: sectorLabelValues } = this.getProcessedDataValues(dataModel, processedData);
        const angleRawValue = angleRawValues[datumIndex];
        const label = legendItemValues?.[datumIndex] ?? (calloutLabelKey === angleKey ? void 0 : calloutLabelValues?.[datumIndex]) ?? (sectorLabelKey === angleKey ? void 0 : sectorLabelValues?.[datumIndex]) ?? angleName;
        return this.formatTooltipWithContext(tooltip, {
            title: title,
            symbol: this.legendItemSymbol(datumIndex),
            data: [
                {
                    label: label,
                    fallbackLabel: angleKey,
                    value: $d77b025aa58d633c$var$formatValue(angleRawValue, 3)
                }
            ]
        }, {
            seriesId: seriesId,
            datum: datum,
            title: angleName,
            legendItemKey: legendItemKey,
            calloutLabelKey: calloutLabelKey,
            calloutLabelName: calloutLabelName,
            sectorLabelKey: sectorLabelKey,
            sectorLabelName: sectorLabelName,
            angleKey: angleKey,
            angleName: angleName,
            radiusKey: radiusKey,
            radiusName: radiusName,
            ...this.getSectorFormat(datum, datumIndex, false)
        });
    }
    legendItemSymbol(datumIndex) {
        const datum = this.processedData?.dataSources.get(this.id)?.[datumIndex];
        const sectorFormat = this.getSectorFormat(datum, datumIndex, false);
        const { fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset } = this.properties;
        let { fill: fill } = sectorFormat;
        const { stroke: stroke2 } = sectorFormat;
        if ($d77b025aa58d633c$var$isGradientFill(fill)) fill = {
            ...fill,
            gradient: "linear",
            rotation: 0,
            reverse: false
        };
        return {
            marker: {
                fill: fill,
                stroke: stroke2,
                fillOpacity: fillOpacity,
                strokeOpacity: strokeOpacity,
                strokeWidth: strokeWidth,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset
            }
        };
    }
    getLegendData(legendType) {
        const { visible: visible, processedData: processedData, dataModel: dataModel, id: seriesId, ctx: { legendManager: legendManager } } = this;
        if (!dataModel || !processedData || legendType !== "category") return [];
        const { angleKey: angleKey, calloutLabelKey: calloutLabelKey, sectorLabelKey: sectorLabelKey, legendItemKey: legendItemKey, showInLegend: showInLegend } = this.properties;
        if (!legendItemKey && (!calloutLabelKey || calloutLabelKey === angleKey) && (!sectorLabelKey || sectorLabelKey === angleKey)) return [];
        const { angleRawValues: angleRawValues, calloutLabelValues: calloutLabelValues, sectorLabelValues: sectorLabelValues, legendItemValues: legendItemValues } = this.getProcessedDataValues(dataModel, processedData);
        const titleText = this.properties.title?.showInLegend && this.properties.title.text;
        const legendData = [];
        const hideZeros = this.properties.hideZeroValueSectorsInLegend;
        const rawData = processedData.dataSources.get(this.id);
        const invalidData = processedData.invalidData?.get(this.id);
        for(let datumIndex = 0; datumIndex < processedData.input.count; datumIndex++){
            const datum = rawData?.[datumIndex];
            const angleRawValue = angleRawValues[datumIndex];
            if (invalidData?.[datumIndex] === true || hideZeros && angleRawValue === 0) continue;
            const labelParts = [];
            if (titleText) labelParts.push(titleText);
            const labels = this.getLabels(datum, 2 * Math.PI, 2 * Math.PI, false, calloutLabelValues?.[datumIndex], sectorLabelValues?.[datumIndex], legendItemValues?.[datumIndex]);
            if (legendItemKey && labels.legendItem !== void 0) labelParts.push(labels.legendItem.text);
            else if (calloutLabelKey && calloutLabelKey !== angleKey && labels.calloutLabel?.text !== void 0) labelParts.push(labels.calloutLabel?.text);
            else if (sectorLabelKey && sectorLabelKey !== angleKey && labels.sectorLabel?.text !== void 0) labelParts.push(labels.sectorLabel?.text);
            if (labelParts.length === 0) continue;
            legendData.push({
                legendType: "category",
                id: seriesId,
                datum: datum,
                itemId: datumIndex,
                seriesId: seriesId,
                hideToggleOtherSeries: true,
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: seriesId,
                    itemId: datumIndex
                }),
                label: {
                    text: labelParts.join(" - ")
                },
                symbol: this.legendItemSymbol(datumIndex),
                legendItemName: legendItemKey != null ? datum[legendItemKey] : void 0,
                hideInLegend: !showInLegend
            });
        }
        return legendData;
    }
    // Used for grid
    setLegendState(enabledItems) {
        const { id: seriesId, ctx: { legendManager: legendManager, updateService: updateService } } = this;
        enabledItems.forEach((enabled, itemId)=>legendManager.toggleItem(enabled, seriesId, itemId));
        legendManager.update();
        updateService.update(5 /* SERIES_UPDATE */ );
    }
    animateEmptyUpdateReady(_data) {
        const { animationManager: animationManager } = this.ctx;
        const fns = $d77b025aa58d633c$var$preparePieSeriesAnimationFunctions(true, this.properties.rotation, this.radiusScale, this.previousRadiusScale);
        $d77b025aa58d633c$var$fromToMotion(this.id, "nodes", animationManager, [
            this.itemSelection,
            this.highlightSelection,
            this.phantomSelection
        ], fns.nodes, (_, datum)=>this.getDatumId(datum.datumIndex));
        $d77b025aa58d633c$var$fromToMotion(this.id, `innerCircle`, animationManager, [
            this.innerCircleSelection
        ], fns.innerCircle);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "callout", animationManager, this.calloutLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "sector", animationManager, this.labelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "highlight", animationManager, this.highlightLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "inner", animationManager, this.innerLabelsSelection);
        this.previousRadiusScale.range = this.radiusScale.range;
    }
    animateWaitingUpdateReady() {
        const { itemSelection: itemSelection, highlightSelection: highlightSelection, phantomSelection: phantomSelection, processedData: processedData, radiusScale: radiusScale, previousRadiusScale: previousRadiusScale } = this;
        const { animationManager: animationManager } = this.ctx;
        const dataDiff = processedData?.reduced?.diff?.[this.id];
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
        const supportedDiff = (dataDiff?.moved.size ?? 0) === 0;
        const hasKeys = (processedData?.defs.keys.length ?? 0) > 0;
        const hasUniqueKeys = processedData?.reduced?.animationValidation?.uniqueKeys ?? true;
        if (!supportedDiff || !hasKeys || !hasUniqueKeys) this.ctx.animationManager.skipCurrentBatch();
        const noVisibleData = !this.nodeData.some((n)=>n.enabled);
        const fns = $d77b025aa58d633c$var$preparePieSeriesAnimationFunctions(false, this.properties.rotation, radiusScale, previousRadiusScale);
        $d77b025aa58d633c$var$fromToMotion(this.id, "nodes", animationManager, [
            itemSelection,
            highlightSelection,
            phantomSelection
        ], fns.nodes, (_, datum)=>this.getDatumId(datum.datumIndex), dataDiff);
        $d77b025aa58d633c$var$fromToMotion(this.id, `innerCircle`, animationManager, [
            this.innerCircleSelection
        ], fns.innerCircle);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "callout", this.ctx.animationManager, this.calloutLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "sector", this.ctx.animationManager, this.labelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "highlight", this.ctx.animationManager, this.highlightLabelSelection);
        if (this.noVisibleData !== noVisibleData) {
            this.noVisibleData = noVisibleData;
            $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "inner", this.ctx.animationManager, this.innerLabelsSelection);
        }
        this.previousRadiusScale.range = this.radiusScale.range;
    }
    animateClearingUpdateEmpty() {
        const { itemSelection: itemSelection, highlightSelection: highlightSelection, phantomSelection: phantomSelection, radiusScale: radiusScale, previousRadiusScale: previousRadiusScale } = this;
        const { animationManager: animationManager } = this.ctx;
        const fns = $d77b025aa58d633c$var$preparePieSeriesAnimationFunctions(false, this.properties.rotation, radiusScale, previousRadiusScale);
        $d77b025aa58d633c$var$fromToMotion(this.id, "nodes", animationManager, [
            itemSelection,
            highlightSelection,
            phantomSelection
        ], fns.nodes, (_, datum)=>this.getDatumId(datum.datumIndex));
        $d77b025aa58d633c$var$fromToMotion(this.id, `innerCircle`, animationManager, [
            this.innerCircleSelection
        ], fns.innerCircle);
        $d77b025aa58d633c$var$seriesLabelFadeOutAnimation(this, "callout", this.ctx.animationManager, this.calloutLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeOutAnimation(this, "sector", this.ctx.animationManager, this.labelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeOutAnimation(this, "highlight", this.ctx.animationManager, this.highlightLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeOutAnimation(this, "inner", this.ctx.animationManager, this.innerLabelsSelection);
        this.previousRadiusScale.range = this.radiusScale.range;
    }
    getDatumId(datumIndex) {
        return `${datumIndex}`;
    }
};
$d77b025aa58d633c$var$DonutSeries.className = "DonutSeries";
$d77b025aa58d633c$var$DonutSeries.type = "donut";
var $d77b025aa58d633c$var$pieSeriesThemeableOptionsDef = {
    radiusMin: (0, $idDdm.positiveNumber),
    radiusMax: (0, $idDdm.positiveNumber),
    rotation: (0, $idDdm.number),
    outerRadiusOffset: (0, $idDdm.number),
    outerRadiusRatio: (0, $idDdm.ratio),
    hideZeroValueSectorsInLegend: (0, $idDdm.boolean),
    sectorSpacing: (0, $idDdm.positiveNumber),
    cornerRadius: (0, $idDdm.positiveNumber),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef),
        cornerRadius: (0, $idDdm.positiveNumber)
    }),
    title: {
        enabled: (0, $idDdm.boolean),
        text: (0, $idDdm.string),
        showInLegend: (0, $idDdm.boolean),
        spacing: (0, $idDdm.positiveNumber),
        ...(0, $idDdm.fontOptionsDef)
    },
    calloutLabel: {
        enabled: (0, $idDdm.boolean),
        offset: (0, $idDdm.number),
        minAngle: (0, $idDdm.positiveNumber),
        avoidCollisions: (0, $idDdm.boolean),
        formatter: (0, $idDdm.callback),
        ...(0, $idDdm.fontOptionsDef)
    },
    sectorLabel: {
        enabled: (0, $idDdm.boolean),
        positionOffset: (0, $idDdm.number),
        positionRatio: (0, $idDdm.ratio),
        formatter: (0, $idDdm.callback),
        ...(0, $idDdm.fontOptionsDef)
    },
    calloutLine: {
        colors: (0, $idDdm.arrayOf)((0, $idDdm.color)),
        length: (0, $idDdm.positiveNumber),
        strokeWidth: (0, $idDdm.positiveNumber)
    },
    fills: (0, $idDdm.arrayOf)((0, $idDdm.colorUnion)),
    strokes: (0, $idDdm.arrayOf)((0, $idDdm.color)),
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    shadow: $d77b025aa58d633c$var$shadowOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.lineDashOptionsDef),
    ...$d77b025aa58d633c$var$without((0, $idDdm.fillOptionsDef), [
        "fill"
    ]),
    ...$d77b025aa58d633c$var$without((0, $idDdm.strokeOptionsDef), [
        "stroke"
    ])
};
var $d77b025aa58d633c$var$pieSeriesOptionsDef = {
    ...$d77b025aa58d633c$var$pieSeriesThemeableOptionsDef,
    ...$d77b025aa58d633c$var$commonSeriesOptionsDefs,
    type: (0, $idDdm.required)((0, $idDdm.constant)("pie")),
    angleKey: (0, $idDdm.required)((0, $idDdm.string)),
    radiusKey: (0, $idDdm.string),
    calloutLabelKey: (0, $idDdm.string),
    sectorLabelKey: (0, $idDdm.string),
    legendItemKey: (0, $idDdm.string),
    angleName: (0, $idDdm.string),
    radiusName: (0, $idDdm.string),
    calloutLabelName: (0, $idDdm.string),
    sectorLabelName: (0, $idDdm.string)
};
$d77b025aa58d633c$var$pieSeriesOptionsDef.defaultColorRange = (0, $idDdm.undocumented)((0, $idDdm.arrayOf)((0, $idDdm.arrayOf)((0, $idDdm.color))));
$d77b025aa58d633c$var$pieSeriesOptionsDef.defaultPatternFills = (0, $idDdm.undocumented)((0, $idDdm.arrayOf)((0, $idDdm.color)));
$d77b025aa58d633c$var$pieSeriesOptionsDef.title._enabledFromTheme = (0, $idDdm.undocumented)((0, $idDdm.boolean));
$d77b025aa58d633c$var$pieSeriesOptionsDef.calloutLabel._enabledFromTheme = (0, $idDdm.undocumented)((0, $idDdm.boolean));
$d77b025aa58d633c$var$pieSeriesOptionsDef.sectorLabel._enabledFromTheme = (0, $idDdm.undocumented)((0, $idDdm.boolean));
// packages/ag-charts-community/src/chart/series/polar/donutSeriesOptionsDef.ts
var $d77b025aa58d633c$var$donutSeriesThemeableOptionsDef = {
    ...$d77b025aa58d633c$var$pieSeriesThemeableOptionsDef,
    innerRadiusOffset: (0, $idDdm.number),
    innerRadiusRatio: (0, $idDdm.ratio),
    innerCircle: {
        fill: (0, $idDdm.string),
        fillOpacity: (0, $idDdm.ratio)
    },
    innerLabels: {
        spacing: (0, $idDdm.positiveNumber),
        ...(0, $idDdm.fontOptionsDef)
    }
};
var $d77b025aa58d633c$var$donutSeriesOptionsDef = {
    ...$d77b025aa58d633c$var$donutSeriesThemeableOptionsDef,
    ...$d77b025aa58d633c$var$pieSeriesOptionsDef,
    type: (0, $idDdm.required)((0, $idDdm.constant)("donut")),
    innerLabels: (0, $idDdm.arrayOfDefs)({
        text: (0, $idDdm.required)((0, $idDdm.string)),
        spacing: (0, $idDdm.positiveNumber),
        ...(0, $idDdm.fontOptionsDef)
    }, "inner label options array")
};
// packages/ag-charts-community/src/chart/series/polar/donutTheme.ts
var $d77b025aa58d633c$var$donutTheme = {
    series: {
        title: {
            enabled: true,
            fontWeight: {
                $ref: "fontWeight"
            },
            fontSize: {
                $rem: [
                    1.1666666666666667 /* LARGE */ 
                ]
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            color: {
                $ref: "subtleTextColor"
            },
            spacing: 5
        },
        calloutLabel: {
            enabled: true,
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            fontWeight: {
                $ref: "fontWeight"
            },
            color: {
                $ref: "textColor"
            },
            offset: 3,
            minAngle: 1e-3
        },
        sectorLabel: {
            enabled: true,
            fontWeight: {
                $ref: "fontWeight"
            },
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            color: {
                $ref: "backgroundColor"
            },
            positionOffset: 0,
            positionRatio: 0.5
        },
        calloutLine: {
            length: 10,
            strokeWidth: 2,
            colors: {
                $map: [
                    {
                        $if: [
                            {
                                $or: [
                                    {
                                        $isGradient: [
                                            {
                                                $value: "$1"
                                            }
                                        ]
                                    },
                                    {
                                        $isPattern: [
                                            {
                                                $value: "$1"
                                            }
                                        ]
                                    },
                                    {
                                        $isImage: [
                                            {
                                                $value: "$1"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                $path: [
                                    "../../strokes/$index",
                                    {
                                        $ref: "foregroundColor"
                                    }
                                ]
                            },
                            {
                                $value: "$1"
                            }
                        ]
                    },
                    {
                        $if: [
                            {
                                $eq: [
                                    {
                                        $path: "../strokeWidth"
                                    },
                                    0
                                ]
                            },
                            {
                                $path: "../fills"
                            },
                            {
                                $path: "../strokes"
                            }
                        ]
                    }
                ]
            }
        },
        fills: {
            $palette: "fills"
        },
        strokes: {
            $palette: "strokes"
        },
        // @ts-expect-error undocumented option
        defaultColorRange: {
            $palette: "gradients"
        },
        defaultPatternFills: $d77b025aa58d633c$var$SAFE_FILLS_OPERATION,
        fillOpacity: 1,
        strokeOpacity: 1,
        strokeWidth: 0,
        lineDash: [
            0
        ],
        lineDashOffset: 0,
        rotation: 0,
        sectorSpacing: 1,
        innerRadiusRatio: {
            $if: [
                {
                    $eq: [
                        {
                            $path: [
                                "./innerRadiusOffset",
                                void 0
                            ]
                        },
                        void 0
                    ]
                },
                0.7,
                void 0
            ]
        },
        shadow: {
            enabled: false,
            color: $d77b025aa58d633c$var$DEFAULT_SHADOW_COLOUR,
            xOffset: 3,
            yOffset: 3,
            blur: 5
        },
        innerLabels: {
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            fontWeight: {
                $ref: "fontWeight"
            },
            color: {
                $ref: "textColor"
            },
            spacing: 2
        }
    },
    legend: {
        enabled: true
    }
};
// packages/ag-charts-community/src/chart/series/polar/donutSeriesModule.ts
var $d77b025aa58d633c$var$DonutSeriesModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "community",
    chartTypes: [
        "polar"
    ],
    identifier: "donut",
    moduleFactory: (ctx)=>new $d77b025aa58d633c$var$DonutSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    themeTemplate: $d77b025aa58d633c$var$donutTheme
};
var $d77b025aa58d633c$var$NewDonutSeriesModule = {
    type: "series",
    name: "donut",
    chartType: "polar",
    options: $d77b025aa58d633c$var$donutSeriesOptionsDef,
    create: (ctx)=>new $d77b025aa58d633c$var$DonutSeries(ctx)
};
// packages/ag-charts-community/src/chart/series/polar/pieSeriesProperties.ts
var $d77b025aa58d633c$var$PieTitle = class extends $d77b025aa58d633c$var$Caption {
    constructor(){
        super(...arguments);
        this.showInLegend = false;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieTitle.prototype, "showInLegend", 2);
var $d77b025aa58d633c$var$PieSeriesCalloutLabel = class extends $d77b025aa58d633c$var$Label {
    constructor(){
        super(...arguments);
        this.offset = 3;
        this.minAngle = 0;
        this.minSpacing = 4;
        this.maxCollisionOffset = 50;
        this.avoidCollisions = true;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesCalloutLabel.prototype, "offset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesCalloutLabel.prototype, "minAngle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesCalloutLabel.prototype, "minSpacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesCalloutLabel.prototype, "maxCollisionOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesCalloutLabel.prototype, "avoidCollisions", 2);
var $d77b025aa58d633c$var$PieSeriesSectorLabel = class extends $d77b025aa58d633c$var$Label {
    constructor(){
        super(...arguments);
        this.positionOffset = 0;
        this.positionRatio = 0.5;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesSectorLabel.prototype, "positionOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesSectorLabel.prototype, "positionRatio", 2);
var $d77b025aa58d633c$var$PieSeriesCalloutLine = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.length = 10;
        this.strokeWidth = 1;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesCalloutLine.prototype, "colors", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesCalloutLine.prototype, "length", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesCalloutLine.prototype, "strokeWidth", 2);
var $d77b025aa58d633c$var$PieSeriesProperties = class extends $d77b025aa58d633c$var$SeriesProperties {
    constructor(){
        super(...arguments);
        this.defaultColorRange = [];
        this.defaultPatternFills = [];
        this.fills = Object.values($d77b025aa58d633c$var$DEFAULT_FILLS);
        this.strokes = Object.values($d77b025aa58d633c$var$DEFAULT_STROKES);
        this.fillOpacity = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.cornerRadius = 0;
        this.rotation = 0;
        this.outerRadiusOffset = 0;
        this.outerRadiusRatio = 1;
        this.strokeWidth = 1;
        this.sectorSpacing = 0;
        this.hideZeroValueSectorsInLegend = false;
        this.title = new $d77b025aa58d633c$var$PieTitle();
        this.shadow = new $d77b025aa58d633c$var$DropShadow();
        this.calloutLabel = new $d77b025aa58d633c$var$PieSeriesCalloutLabel();
        this.sectorLabel = new $d77b025aa58d633c$var$PieSeriesSectorLabel();
        this.calloutLine = new $d77b025aa58d633c$var$PieSeriesCalloutLine();
        this.tooltip = new $d77b025aa58d633c$var$SeriesTooltip();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "angleKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "angleName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "angleFilterKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "radiusKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "radiusName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "radiusMin", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "radiusMax", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "calloutLabelKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "calloutLabelName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "sectorLabelKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "sectorLabelName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "legendItemKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "defaultColorRange", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "defaultPatternFills", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "fills", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "strokes", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "cornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "itemStyler", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "rotation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "outerRadiusOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "outerRadiusRatio", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "sectorSpacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "hideZeroValueSectorsInLegend", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "title", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "shadow", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "calloutLabel", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "sectorLabel", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "calloutLine", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-community/src/chart/series/polar/pieSeries.ts
var $d77b025aa58d633c$var$PieSeriesNodeEvent = class extends $d77b025aa58d633c$var$SeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.angleKey = series.properties.angleKey;
        this.radiusKey = series.properties.radiusKey;
        this.calloutLabelKey = series.properties.calloutLabelKey;
        this.sectorLabelKey = series.properties.sectorLabelKey;
    }
};
var $d77b025aa58d633c$var$PieSeries = class extends $d77b025aa58d633c$var$PolarSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            categoryKey: void 0,
            pickModes: [
                1 /* NEAREST_NODE */ ,
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            useLabelLayer: true,
            animationResetFns: {
                item: $d77b025aa58d633c$var$resetPieSelectionsFn,
                label: $d77b025aa58d633c$var$resetLabelFn
            }
        });
        this.properties = new $d77b025aa58d633c$var$PieSeriesProperties();
        this.phantomNodeData = void 0;
        this.backgroundGroup = new $d77b025aa58d633c$var$TranslatableGroup({
            name: `${this.id}-background`,
            zIndex: 0 /* BACKGROUND */ 
        });
        this.previousRadiusScale = new $d77b025aa58d633c$var$LinearScale();
        this.radiusScale = new $d77b025aa58d633c$var$LinearScale();
        this.phantomGroup = this.backgroundGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: "phantom"
        }));
        this.phantomSelection = $d77b025aa58d633c$var$Selection.select(this.phantomGroup, ()=>this.nodeFactory(), false);
        this.calloutLabelGroup = this.contentGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: "pieCalloutLabels"
        }));
        this.calloutLabelSelection = new $d77b025aa58d633c$var$Selection(this.calloutLabelGroup, $d77b025aa58d633c$var$Group);
        // AG-6193 If the sum of all datums is 0, then we'll draw 1 or 2 rings to represent the empty series.
        this.zerosumRingsGroup = this.backgroundGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-zerosumRings`
        }));
        this.zerosumOuterRing = this.zerosumRingsGroup.appendChild(new $d77b025aa58d633c$var$Marker({
            shape: "circle"
        }));
        this.surroundingRadius = void 0;
        this.NodeEvent = $d77b025aa58d633c$var$PieSeriesNodeEvent;
        this.angleScale = new $d77b025aa58d633c$var$LinearScale();
        this.angleScale.domain = [
            0,
            1
        ];
        this.angleScale.range = [
            -Math.PI,
            Math.PI
        ].map((angle2)=>angle2 + Math.PI / 2);
        this.phantomGroup.opacity = 0.2;
    }
    get calloutNodeData() {
        return this.phantomNodeData ?? this.nodeData;
    }
    attachSeries(seriesContentNode, seriesNode, annotationNode) {
        super.attachSeries(seriesContentNode, seriesNode, annotationNode);
        seriesContentNode.appendChild(this.backgroundGroup);
    }
    detachSeries(seriesContentNode, seriesNode, annotationNode) {
        super.detachSeries(seriesContentNode, seriesNode, annotationNode);
        seriesContentNode?.removeChild(this.backgroundGroup);
    }
    setSeriesIndex(index) {
        if (!super.setSeriesIndex(index)) return false;
        this.backgroundGroup.zIndex = [
            0 /* BACKGROUND */ ,
            index
        ];
        return true;
    }
    nodeFactory() {
        const sector = new $d77b025aa58d633c$var$Sector();
        sector.miterLimit = 1e9;
        return sector;
    }
    getSeriesDomain(direction) {
        if (direction === "angle" /* Angle */ ) return this.angleScale.domain;
        else return this.radiusScale.domain;
    }
    async processData(dataController) {
        if (this.data == null) return;
        const { visible: visible, id: seriesId, ctx: { legendManager: legendManager } } = this;
        const { angleKey: angleKey, angleFilterKey: angleFilterKey, radiusKey: radiusKey, calloutLabelKey: calloutLabelKey, sectorLabelKey: sectorLabelKey, legendItemKey: legendItemKey } = this.properties;
        const processor = ()=>(value, index)=>{
                if (visible && legendManager.getItemEnabled({
                    seriesId: seriesId,
                    itemId: index
                })) return value;
                return 0;
            };
        const animationEnabled = !this.ctx.animationManager.isSkipped();
        const extraKeyProps = [];
        const extraProps = [];
        if (legendItemKey) extraKeyProps.push($d77b025aa58d633c$var$keyProperty(legendItemKey, "band", {
            id: `legendItemKey`
        }));
        else if (calloutLabelKey) extraKeyProps.push($d77b025aa58d633c$var$keyProperty(calloutLabelKey, "band", {
            id: `calloutLabelKey`
        }));
        else if (sectorLabelKey) extraKeyProps.push($d77b025aa58d633c$var$keyProperty(sectorLabelKey, "band", {
            id: `sectorLabelKey`
        }));
        const radiusScaleType = this.radiusScale.type;
        const angleScaleType = this.angleScale.type;
        if (radiusKey) extraProps.push($d77b025aa58d633c$var$rangedValueProperty(radiusKey, {
            id: "radiusValue",
            min: this.properties.radiusMin ?? 0,
            max: this.properties.radiusMax,
            missingValue: this.properties.radiusMax ?? 1,
            processor: processor
        }), $d77b025aa58d633c$var$valueProperty(radiusKey, radiusScaleType, {
            id: `radiusRaw`,
            processor: processor
        }), // Raw value pass-through.
        $d77b025aa58d633c$var$normalisePropertyTo("radiusValue", [
            0,
            1
        ], 1, this.properties.radiusMin ?? 0, this.properties.radiusMax));
        if (calloutLabelKey) extraProps.push($d77b025aa58d633c$var$valueProperty(calloutLabelKey, "band", {
            id: `calloutLabelValue`
        }));
        if (sectorLabelKey) extraProps.push($d77b025aa58d633c$var$valueProperty(sectorLabelKey, "band", {
            id: `sectorLabelValue`
        }));
        if (legendItemKey) extraProps.push($d77b025aa58d633c$var$valueProperty(legendItemKey, "band", {
            id: `legendItemValue`
        }));
        if (angleFilterKey) extraProps.push($d77b025aa58d633c$var$accumulativeValueProperty(angleFilterKey, angleScaleType, {
            id: `angleFilterValue`,
            onlyPositive: true,
            invalidValue: 0,
            processor: processor
        }), $d77b025aa58d633c$var$valueProperty(angleFilterKey, angleScaleType, {
            id: `angleFilterRaw`
        }), $d77b025aa58d633c$var$normalisePropertyTo("angleFilterValue", [
            0,
            1
        ], 0, 0));
        if (animationEnabled && this.processedData?.reduced?.animationValidation?.uniqueKeys && extraKeyProps.length > 0) extraProps.push($d77b025aa58d633c$var$diff(this.id, this.processedData));
        extraProps.push($d77b025aa58d633c$var$animationValidation());
        await this.requestDataModel(dataController, this.data, {
            props: [
                ...extraKeyProps,
                $d77b025aa58d633c$var$accumulativeValueProperty(angleKey, angleScaleType, {
                    id: `angleValue`,
                    onlyPositive: true,
                    invalidValue: 0,
                    processor: processor
                }),
                $d77b025aa58d633c$var$valueProperty(angleKey, angleScaleType, {
                    id: `angleRaw`
                }),
                // Raw value pass-through.
                $d77b025aa58d633c$var$normalisePropertyTo("angleValue", [
                    0,
                    1
                ], 0, 0),
                ...extraProps
            ]
        });
        for (const valueDef of this.processedData?.defs?.values ?? []){
            const { id: id, missing: missing, property: property } = valueDef;
            const missCount = $d77b025aa58d633c$var$getMissCount(this, missing);
            if (id !== "angleRaw" && missCount > 0) (0, $idDdm.Logger).warnOnce(`no value was found for the key '${String(property)}' on ${missCount} data element${missCount > 1 ? "s" : ""}`);
        }
        this.animationState.transition("updateData");
    }
    maybeRefreshNodeData() {
        if (!this.nodeDataRefresh) return;
        const { nodeData: nodeData = [], phantomNodeData: phantomNodeData } = this.createNodeData() ?? {};
        this.nodeData = nodeData;
        this.phantomNodeData = phantomNodeData;
        this.nodeDataRefresh = false;
    }
    getProcessedDataValues(dataModel, processedData) {
        const angleValues = dataModel.resolveColumnById(this, `angleValue`, processedData);
        const angleRawValues = dataModel.resolveColumnById(this, `angleRaw`, processedData);
        const angleFilterValues = this.properties.angleFilterKey != null ? dataModel.resolveColumnById(this, `angleFilterValue`, processedData) : void 0;
        const angleFilterRawValues = this.properties.angleFilterKey != null ? dataModel.resolveColumnById(this, `angleFilterRaw`, processedData) : void 0;
        const radiusValues = this.properties.radiusKey ? dataModel.resolveColumnById(this, `radiusValue`, processedData) : void 0;
        const radiusRawValues = this.properties.radiusKey ? dataModel.resolveColumnById(this, `radiusRaw`, processedData) : void 0;
        const calloutLabelValues = this.properties.calloutLabelKey ? dataModel.resolveColumnById(this, `calloutLabelValue`, processedData) : void 0;
        const sectorLabelValues = this.properties.sectorLabelKey ? dataModel.resolveColumnById(this, `sectorLabelValue`, processedData) : void 0;
        const legendItemValues = this.properties.legendItemKey ? dataModel.resolveColumnById(this, `legendItemValue`, processedData) : void 0;
        return {
            angleValues: angleValues,
            angleRawValues: angleRawValues,
            angleFilterValues: angleFilterValues,
            angleFilterRawValues: angleFilterRawValues,
            radiusValues: radiusValues,
            radiusRawValues: radiusRawValues,
            calloutLabelValues: calloutLabelValues,
            sectorLabelValues: sectorLabelValues,
            legendItemValues: legendItemValues
        };
    }
    createNodeData() {
        const { id: seriesId, processedData: processedData, dataModel: dataModel, angleScale: angleScale, ctx: { legendManager: legendManager }, visible: visible } = this;
        const { rotation: rotation } = this.properties;
        if (!dataModel || processedData?.type !== "ungrouped") return;
        const { angleValues: angleValues, angleRawValues: angleRawValues, angleFilterValues: angleFilterValues, angleFilterRawValues: angleFilterRawValues, radiusValues: radiusValues, radiusRawValues: radiusRawValues, calloutLabelValues: calloutLabelValues, sectorLabelValues: sectorLabelValues, legendItemValues: legendItemValues } = this.getProcessedDataValues(dataModel, processedData);
        const useFilterAngles = angleFilterRawValues?.some((filterRawValue, index)=>{
            return filterRawValue > angleRawValues[index];
        }) ?? false;
        let currentStart = 0;
        let sum2 = 0;
        const nodes = [];
        const phantomNodes = angleFilterRawValues != null ? [] : void 0;
        const rawData = processedData.dataSources.get(this.id) ?? [];
        const invalidData = processedData.invalidData?.get(this.id);
        rawData.forEach((datum, datumIndex)=>{
            if (invalidData?.[datumIndex] === true) return;
            const currentValue = useFilterAngles ? angleFilterValues[datumIndex] : angleValues[datumIndex];
            const crossFilterScale = angleFilterRawValues != null && !useFilterAngles ? Math.sqrt(angleFilterRawValues[datumIndex] / angleRawValues[datumIndex]) : 1;
            const startAngle = angleScale.convert(currentStart) + $d77b025aa58d633c$var$toRadians(rotation);
            currentStart = currentValue;
            sum2 += currentValue;
            const endAngle = angleScale.convert(currentStart) + $d77b025aa58d633c$var$toRadians(rotation);
            const span = Math.abs(endAngle - startAngle);
            const midAngle = startAngle + span / 2;
            const angleValue = angleRawValues[datumIndex];
            const radiusRaw = radiusValues?.[datumIndex] ?? 1;
            const radius = radiusRaw * crossFilterScale;
            const radiusValue = radiusRawValues?.[datumIndex];
            const legendItemValue = legendItemValues?.[datumIndex];
            const nodeLabels = this.getLabels(datum, midAngle, span, true, calloutLabelValues?.[datumIndex], sectorLabelValues?.[datumIndex], legendItemValue);
            const sectorFormat = this.getSectorFormat(datum, datumIndex, false);
            const node = {
                itemId: datumIndex,
                series: this,
                datum: datum,
                datumIndex: datumIndex,
                angleValue: angleValue,
                midAngle: midAngle,
                midCos: Math.cos(midAngle),
                midSin: Math.sin(midAngle),
                startAngle: startAngle,
                endAngle: endAngle,
                radius: radius,
                innerRadius: Math.max(this.radiusScale.convert(0), 0),
                outerRadius: Math.max(this.radiusScale.convert(radius), 0),
                sectorFormat: sectorFormat,
                radiusValue: radiusValue,
                legendItemValue: legendItemValue,
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: seriesId,
                    itemId: datumIndex
                }),
                ...nodeLabels
            };
            nodes.push(node);
            if (phantomNodes != null) phantomNodes.push({
                ...node,
                radius: 1,
                innerRadius: Math.max(this.radiusScale.convert(0), 0),
                outerRadius: Math.max(this.radiusScale.convert(1), 0)
            });
        });
        this.zerosumOuterRing.visible = sum2 === 0;
        return {
            itemId: seriesId,
            nodeData: nodes,
            labelData: nodes,
            phantomNodeData: phantomNodes
        };
    }
    getLabels(datum, midAngle, span, skipDisabled, calloutLabelValue, sectorLabelValue, legendItemValue) {
        const { calloutLabel: calloutLabel, sectorLabel: sectorLabel, legendItemKey: legendItemKey } = this.properties;
        const calloutLabelKey = !skipDisabled || calloutLabel.enabled ? this.properties.calloutLabelKey : void 0;
        const sectorLabelKey = !skipDisabled || sectorLabel.enabled ? this.properties.sectorLabelKey : void 0;
        if (!calloutLabelKey && !sectorLabelKey && !legendItemKey) return {};
        const labelFormatterParams = {
            datum: datum,
            angleKey: this.properties.angleKey,
            angleName: this.properties.angleName,
            radiusKey: this.properties.radiusKey,
            radiusName: this.properties.radiusName,
            calloutLabelKey: this.properties.calloutLabelKey,
            calloutLabelName: this.properties.calloutLabelName,
            sectorLabelKey: this.properties.sectorLabelKey,
            sectorLabelName: this.properties.sectorLabelName,
            legendItemKey: this.properties.legendItemKey
        };
        const result = {};
        if (calloutLabelKey && span >= $d77b025aa58d633c$var$toRadians(calloutLabel.minAngle)) result.calloutLabel = {
            ...this.getTextAlignment(midAngle),
            text: this.getLabelText(calloutLabel, {
                ...labelFormatterParams,
                value: calloutLabelValue
            }),
            hidden: false,
            collisionTextAlign: void 0,
            collisionOffsetY: 0,
            box: void 0
        };
        if (sectorLabelKey) result.sectorLabel = {
            text: this.getLabelText(sectorLabel, {
                ...labelFormatterParams,
                value: sectorLabelValue
            })
        };
        if (legendItemKey != null && legendItemValue != null) result.legendItem = {
            key: legendItemKey,
            text: legendItemValue
        };
        return result;
    }
    getTextAlignment(midAngle) {
        const quadrantTextOpts = [
            {
                textAlign: "center",
                textBaseline: "bottom"
            },
            {
                textAlign: "left",
                textBaseline: "middle"
            },
            {
                textAlign: "center",
                textBaseline: "hanging"
            },
            {
                textAlign: "right",
                textBaseline: "middle"
            }
        ];
        const midAngle180 = $d77b025aa58d633c$var$normalizeAngle180(midAngle);
        const quadrantStart = -0.75 * Math.PI;
        const quadrantOffset = midAngle180 - quadrantStart;
        const quadrant = Math.floor(quadrantOffset / (Math.PI / 2));
        const quadrantIndex = (0, $idDdm.modulus)(quadrant, quadrantTextOpts.length);
        return quadrantTextOpts[quadrantIndex];
    }
    getNodeFill(fill, defaultColorRange, defaultPatternFill) {
        return $d77b025aa58d633c$var$getShapeFill(fill, {
            type: "gradient",
            bounds: "series",
            colorStops: defaultColorRange.map((color11)=>({
                    color: color11
                })),
            gradient: "radial",
            rotation: 0,
            reverse: true
        }, {
            type: "pattern",
            pattern: "forward-slanted-lines",
            fill: defaultPatternFill,
            fillOpacity: 1,
            backgroundFill: "none",
            backgroundFillOpacity: 1,
            stroke: defaultPatternFill,
            strokeOpacity: 1,
            strokeWidth: 4,
            rotation: 0
        }, {
            type: "image",
            backgroundFill: defaultPatternFill,
            backgroundFillOpacity: 1,
            fit: "contain",
            repeat: "no-repeat",
            rotation: 0
        });
    }
    getFillParams(fill, innerRadius, outerRadius) {
        if (!$d77b025aa58d633c$var$isGradientFill(fill) || fill.bounds === "item") return;
        return {
            centerX: 0,
            centerY: 0,
            innerRadius: innerRadius,
            outerRadius: outerRadius
        };
    }
    getSectorFormat(datum, datumIndex, highlighted) {
        const { angleKey: angleKey, radiusKey: radiusKey, calloutLabelKey: calloutLabelKey, sectorLabelKey: sectorLabelKey, legendItemKey: legendItemKey, fills: fills, strokes: strokes, defaultColorRange: defaultColorRange, defaultPatternFills: defaultPatternFills, itemStyler: itemStyler } = this.properties;
        const defaultStroke = strokes[datumIndex % strokes.length];
        const { fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, cornerRadius: cornerRadius } = $d77b025aa58d633c$var$mergeDefaults(highlighted && this.properties.highlightStyle.item, {
            fill: fills.length > 0 ? fills[datumIndex % fills.length] : void 0,
            stroke: defaultStroke,
            strokeWidth: this.getStrokeWidth(this.properties.strokeWidth),
            strokeOpacity: this.getOpacity()
        }, this.properties);
        const defaultColors = defaultColorRange[datumIndex % defaultColorRange.length];
        const defaultPatternFill = defaultPatternFills[datumIndex % defaultPatternFills.length];
        const sectorFill = fill ?? "black";
        let format;
        if (itemStyler) format = this.cachedDatumCallback(this.getDatumId(datumIndex) + (highlighted ? "-highlight" : "-hide"), ()=>this.callWithContext(itemStyler, {
                datum: datum,
                angleKey: angleKey,
                radiusKey: radiusKey,
                calloutLabelKey: calloutLabelKey,
                sectorLabelKey: sectorLabelKey,
                legendItemKey: legendItemKey,
                fill: this.getNodeFill(sectorFill, defaultColors, defaultPatternFill),
                strokeOpacity: strokeOpacity,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                fillOpacity: fillOpacity,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset,
                cornerRadius: cornerRadius,
                highlighted: highlighted,
                seriesId: this.id
            }));
        return {
            fill: this.getNodeFill(format?.fill ?? sectorFill, defaultColors, defaultPatternFill),
            fillOpacity: format?.fillOpacity ?? fillOpacity,
            stroke: format?.stroke ?? stroke2,
            strokeWidth: format?.strokeWidth ?? strokeWidth,
            strokeOpacity: format?.strokeOpacity ?? strokeOpacity,
            lineDash: format?.lineDash ?? lineDash,
            lineDashOffset: format?.lineDashOffset ?? lineDashOffset,
            cornerRadius: format?.cornerRadius ?? cornerRadius
        };
    }
    getOuterRadius() {
        return Math.max(this.radius * this.properties.outerRadiusRatio + this.properties.outerRadiusOffset, 0);
    }
    updateRadiusScale(resize) {
        const newRange = [
            0,
            this.getOuterRadius()
        ];
        this.radiusScale.range = newRange;
        if (resize) this.previousRadiusScale.range = newRange;
        const setRadii = (d)=>({
                ...d,
                innerRadius: Math.max(this.radiusScale.convert(0), 0),
                outerRadius: Math.max(this.radiusScale.convert(d.radius), 0)
            });
        this.nodeData = this.nodeData.map(setRadii);
        this.phantomNodeData = this.phantomNodeData?.map(setRadii);
    }
    getTitleTranslationY() {
        const outerRadius = Math.max(0, this.radiusScale.range[1]);
        if (outerRadius === 0) return NaN;
        const spacing = this.properties.title?.spacing ?? 0;
        const titleOffset = 2 + spacing;
        const dy = Math.max(0, -outerRadius);
        return -outerRadius - titleOffset - dy;
    }
    update({ seriesRect: seriesRect }) {
        const { title: title } = this.properties;
        const newNodeDataDependencies = {
            seriesRectWidth: seriesRect?.width,
            seriesRectHeight: seriesRect?.height
        };
        const resize = $d77b025aa58d633c$var$jsonDiff(this.nodeDataDependencies, newNodeDataDependencies) != null;
        if (resize) this._nodeDataDependencies = newNodeDataDependencies;
        this.maybeRefreshNodeData();
        this.updateTitleNodes();
        this.updateRadiusScale(resize);
        this.contentGroup.translationX = this.centerX;
        this.contentGroup.translationY = this.centerY;
        this.highlightGroup.translationX = this.centerX;
        this.highlightGroup.translationY = this.centerY;
        this.backgroundGroup.translationX = this.centerX;
        this.backgroundGroup.translationY = this.centerY;
        if (this.labelGroup) {
            this.labelGroup.translationX = this.centerX;
            this.labelGroup.translationY = this.centerY;
        }
        if (title) {
            const dy = this.getTitleTranslationY();
            title.node.y = isFinite(dy) ? dy : 0;
            const titleBox = title.node.getBBox();
            title.node.visible = title.enabled && isFinite(dy) && !this.bboxIntersectsSurroundingSeries(titleBox);
        }
        this.zerosumOuterRing.fillOpacity = 0;
        this.zerosumOuterRing.stroke = this.properties.calloutLabel.color;
        this.zerosumOuterRing.strokeWidth = 1;
        this.zerosumOuterRing.strokeOpacity = 1;
        this.updateNodeMidPoint();
        this.updateSelections();
        this.updateNodes(seriesRect);
    }
    updateTitleNodes() {
        const { oldTitle: oldTitle } = this;
        const { title: title } = this.properties;
        if (oldTitle !== title) {
            if (oldTitle) this.labelGroup?.removeChild(oldTitle.node);
            if (title) {
                title.node.textBaseline = "bottom";
                this.labelGroup?.appendChild(title.node);
            }
            this.oldTitle = title;
        }
    }
    updateNodeMidPoint() {
        const setMidPoint = (d)=>{
            const radius = d.innerRadius + (d.outerRadius - d.innerRadius) / 2;
            d.midPoint = {
                x: d.midCos * Math.max(0, radius),
                y: d.midSin * Math.max(0, radius)
            };
        };
        this.nodeData.forEach(setMidPoint);
        this.phantomNodeData?.forEach(setMidPoint);
    }
    updateSelections() {
        const { itemSelection: itemSelection, highlightSelection: highlightSelection, phantomSelection: phantomSelection, highlightLabelSelection: highlightLabelSelection, calloutLabelSelection: calloutLabelSelection, labelSelection: labelSelection } = this;
        const highlightedNodeData = this.nodeData.map((datum)=>({
                ...datum,
                // Allow mutable sectorFormat, so formatted sector styles can be updated and varied
                // between normal and highlighted cases.
                sectorFormat: {
                    ...datum.sectorFormat
                }
            }));
        const update = (selection, nodeData)=>{
            selection.update(nodeData, void 0, (datum)=>this.getDatumId(datum.datumIndex));
            if (this.ctx.animationManager.isSkipped()) selection.cleanup();
        };
        update(itemSelection, this.nodeData);
        update(highlightSelection, highlightedNodeData);
        update(phantomSelection, this.phantomNodeData ?? []);
        calloutLabelSelection.update(this.calloutNodeData, (group)=>{
            const line = new $d77b025aa58d633c$var$Line();
            line.tag = 0 /* Callout */ ;
            line.pointerEvents = 1 /* None */ ;
            group.appendChild(line);
            const text = new $d77b025aa58d633c$var$Text();
            text.tag = 1 /* Label */ ;
            text.pointerEvents = 1 /* None */ ;
            group.appendChild(text);
        });
        labelSelection.update(this.nodeData);
        highlightLabelSelection.update(highlightedNodeData);
    }
    updateNodes(seriesRect) {
        const highlightedDatum = this.ctx.highlightManager.getActiveHighlight();
        const { visible: visible } = this;
        this.backgroundGroup.visible = visible;
        this.contentGroup.visible = visible;
        this.highlightGroup.visible = visible && highlightedDatum?.series === this;
        this.highlightLabel.visible = visible && highlightedDatum?.series === this;
        if (this.labelGroup) this.labelGroup.visible = visible;
        this.contentGroup.opacity = this.getOpacity();
        const innerRadius = this.radiusScale.range[0];
        const outerRadius = this.radiusScale.range[1];
        const fillBBox = this.getShapeFillBBox();
        const animationDisabled = this.ctx.animationManager.isSkipped();
        const updateSectorFn = (sector, datum, _index, isDatumHighlighted)=>{
            const format = this.getSectorFormat(datum.datum, datum.itemId, isDatumHighlighted);
            datum.sectorFormat.fill = format.fill;
            datum.sectorFormat.stroke = format.stroke;
            if (animationDisabled) {
                sector.startAngle = datum.startAngle;
                sector.endAngle = datum.endAngle;
                sector.innerRadius = datum.innerRadius;
                sector.outerRadius = datum.outerRadius;
            }
            if (isDatumHighlighted || animationDisabled) {
                sector.fill = format.fill;
                sector.stroke = format.stroke;
            }
            const fillParams = this.getFillParams(format.fill, innerRadius, outerRadius);
            $d77b025aa58d633c$var$applyShapeFillBBox(sector, format.fill, fillBBox, fillParams);
            sector.strokeWidth = format.strokeWidth;
            sector.fillOpacity = format.fillOpacity;
            sector.strokeOpacity = format.strokeOpacity;
            sector.lineDash = format.lineDash;
            sector.lineDashOffset = format.lineDashOffset;
            sector.cornerRadius = format.cornerRadius;
            sector.fillShadow = this.properties.shadow;
            const inset = Math.max((this.properties.sectorSpacing + (format.stroke != null ? format.strokeWidth : 0)) / 2, 0);
            sector.inset = inset;
            sector.lineJoin = this.properties.sectorSpacing >= 0 || inset > 0 ? "miter" : "round";
        };
        this.itemSelection.each((node, datum, index)=>updateSectorFn(node, datum, index, false));
        this.highlightSelection.each((node, datum, index)=>{
            updateSectorFn(node, datum, index, true);
            node.visible = datum.itemId === highlightedDatum?.itemId;
        });
        this.phantomSelection.each((node, datum, index)=>updateSectorFn(node, datum, index, false));
        this.updateCalloutLineNodes();
        this.updateCalloutLabelNodes(seriesRect);
        this.updateSectorLabelNodes();
        this.updateZerosumRings();
        this.animationState.transition("update");
    }
    updateCalloutLineNodes() {
        const { calloutLine: { length: calloutLength, strokeWidth: strokeWidth, colors: colors }, strokes: strokes } = this.properties;
        const calloutStrokeWidth = strokeWidth;
        const calloutColors = $d77b025aa58d633c$var$isStringFillArray(colors) ? colors : strokes;
        const { offset: offset4 } = this.properties.calloutLabel;
        this.calloutLabelSelection.selectByTag(0 /* Callout */ ).forEach((line)=>{
            const datum = line.closestDatum();
            const { calloutLabel: label, outerRadius: outerRadius, datumIndex: datumIndex } = datum;
            if (label?.text && !label.hidden && outerRadius !== 0) {
                line.visible = true;
                line.strokeWidth = calloutStrokeWidth;
                line.stroke = calloutColors[datumIndex % calloutColors.length];
                line.fill = void 0;
                const x1 = datum.midCos * outerRadius;
                const y1 = datum.midSin * outerRadius;
                let x2 = datum.midCos * (outerRadius + calloutLength);
                let y2 = datum.midSin * (outerRadius + calloutLength);
                const isMoved = label.collisionTextAlign ?? label.collisionOffsetY !== 0;
                if (isMoved && label.box != null) {
                    const box = label.box;
                    let cx = x2;
                    let cy = y2;
                    if (x2 < box.x) cx = box.x;
                    else if (x2 > box.x + box.width) cx = box.x + box.width;
                    if (y2 < box.y) cy = box.y;
                    else if (y2 > box.y + box.height) cy = box.y + box.height;
                    const dx = cx - x2;
                    const dy = cy - y2;
                    const length2 = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                    const paddedLength = length2 - offset4;
                    if (paddedLength > 0) {
                        x2 = x2 + dx * paddedLength / length2;
                        y2 = y2 + dy * paddedLength / length2;
                    }
                }
                line.x1 = x1;
                line.y1 = y1;
                line.x2 = x2;
                line.y2 = y2;
            } else line.visible = false;
        });
    }
    getLabelOverflow(text, box, seriesRect) {
        const seriesLeft = -this.centerX;
        const seriesRight = seriesLeft + seriesRect.width;
        const seriesTop = -this.centerY;
        const seriesBottom = seriesTop + seriesRect.height;
        const errPx = 1;
        let visibleTextPart = 1;
        if (box.x + errPx < seriesLeft) visibleTextPart = (box.x + box.width - seriesLeft) / box.width;
        else if (box.x + box.width - errPx > seriesRight) visibleTextPart = (seriesRight - box.x) / box.width;
        const hasVerticalOverflow = box.y + errPx < seriesTop || box.y + box.height - errPx > seriesBottom;
        const textLength = visibleTextPart === 1 ? text.length : Math.floor(text.length * visibleTextPart) - 1;
        const hasSurroundingSeriesOverflow = this.bboxIntersectsSurroundingSeries(box);
        return {
            textLength: textLength,
            hasVerticalOverflow: hasVerticalOverflow,
            hasSurroundingSeriesOverflow: hasSurroundingSeriesOverflow
        };
    }
    bboxIntersectsSurroundingSeries(box) {
        const { surroundingRadius: surroundingRadius } = this;
        if (surroundingRadius == null) return false;
        const corners = [
            {
                x: box.x,
                y: box.y
            },
            {
                x: box.x + box.width,
                y: box.y
            },
            {
                x: box.x + box.width,
                y: box.y + box.height
            },
            {
                x: box.x,
                y: box.y + box.height
            }
        ];
        const sur2 = surroundingRadius ** 2;
        return corners.some((corner)=>corner.x ** 2 + corner.y ** 2 > sur2);
    }
    computeCalloutLabelCollisionOffsets() {
        const { radiusScale: radiusScale } = this;
        const { calloutLabel: calloutLabel, calloutLine: calloutLine } = this.properties;
        const { offset: offset4, minSpacing: minSpacing } = calloutLabel;
        const innerRadius = radiusScale.convert(0);
        const shouldSkip = (datum)=>{
            const label = datum.calloutLabel;
            return !label || datum.outerRadius === 0;
        };
        const fullData = this.calloutNodeData;
        const data = fullData.filter((t)=>!shouldSkip(t));
        data.forEach((datum)=>{
            const label = datum.calloutLabel;
            if (label == null) return;
            label.hidden = false;
            label.collisionTextAlign = void 0;
            label.collisionOffsetY = 0;
        });
        if (data.length <= 1) return;
        const leftLabels = data.filter((d)=>d.midCos < 0).sort((a, b)=>a.midSin - b.midSin);
        const rightLabels = data.filter((d)=>d.midCos >= 0).sort((a, b)=>a.midSin - b.midSin);
        const topLabels = data.filter((d)=>d.midSin < 0 && d.calloutLabel?.textAlign === "center").sort((a, b)=>a.midCos - b.midCos);
        const bottomLabels = data.filter((d)=>d.midSin >= 0 && d.calloutLabel?.textAlign === "center").sort((a, b)=>a.midCos - b.midCos);
        const getTextBBox = (datum)=>{
            const label = datum.calloutLabel;
            if (label == null) return $d77b025aa58d633c$var$BBox.zero.clone();
            const labelRadius = datum.outerRadius + calloutLine.length + offset4;
            const x = datum.midCos * labelRadius;
            const y = datum.midSin * labelRadius + label.collisionOffsetY;
            const textAlign = label.collisionTextAlign ?? label.textAlign;
            const textBaseline = label.textBaseline;
            return $d77b025aa58d633c$var$Text.computeBBox(label.text, x, y, {
                font: this.properties.calloutLabel,
                textAlign: textAlign,
                textBaseline: textBaseline
            });
        };
        const avoidNeighbourYCollision = (label, next, direction)=>{
            const box = getTextBBox(label).grow(minSpacing / 2);
            const other = getTextBBox(next).grow(minSpacing / 2);
            const collidesOrBehind = box.x < other.x + other.width && box.x + box.width > other.x && (direction === "to-top" ? box.y < other.y + other.height : box.y + box.height > other.y);
            if (collidesOrBehind) next.calloutLabel.collisionOffsetY = direction === "to-top" ? box.y - other.y - other.height : box.y + box.height - other.y;
        };
        const avoidYCollisions = (labels)=>{
            const midLabel = labels.slice().sort((a, b)=>Math.abs(a.midSin) - Math.abs(b.midSin))[0];
            const midIndex = labels.indexOf(midLabel);
            for(let i = midIndex - 1; i >= 0; i--){
                const prev = labels[i + 1];
                const next = labels[i];
                avoidNeighbourYCollision(prev, next, "to-top");
            }
            for(let i = midIndex + 1; i < labels.length; i++){
                const prev = labels[i - 1];
                const next = labels[i];
                avoidNeighbourYCollision(prev, next, "to-bottom");
            }
        };
        const avoidXCollisions = (labels)=>{
            const labelsCollideLabelsByY = data.some((datum)=>datum.calloutLabel.collisionOffsetY !== 0);
            const boxes = labels.map((label)=>getTextBBox(label));
            const paddedBoxes = boxes.map((box)=>box.clone().grow(minSpacing / 2));
            let labelsCollideLabelsByX = false;
            for(let i = 0; i < paddedBoxes.length && !labelsCollideLabelsByX; i++){
                const box = paddedBoxes[i];
                for(let j = i + 1; j < labels.length; j++){
                    const other = paddedBoxes[j];
                    if (box.collidesBBox(other)) {
                        labelsCollideLabelsByX = true;
                        break;
                    }
                }
            }
            const sectors = fullData.map((datum)=>{
                const { startAngle: startAngle, endAngle: endAngle, outerRadius: outerRadius } = datum;
                return {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius
                };
            });
            const labelsCollideSectors = boxes.some((box)=>{
                return sectors.some((sector)=>$d77b025aa58d633c$var$boxCollidesSector(box, sector));
            });
            if (!labelsCollideLabelsByX && !labelsCollideLabelsByY && !labelsCollideSectors) return;
            labels.filter((d)=>d.calloutLabel.textAlign === "center").forEach((d)=>{
                const label = d.calloutLabel;
                if (d.midCos < 0) label.collisionTextAlign = "right";
                else if (d.midCos > 0) label.collisionTextAlign = "left";
                else label.collisionTextAlign = "center";
            });
        };
        avoidYCollisions(leftLabels);
        avoidYCollisions(rightLabels);
        avoidXCollisions(topLabels);
        avoidXCollisions(bottomLabels);
    }
    updateCalloutLabelNodes(seriesRect) {
        const { radiusScale: radiusScale } = this;
        const { calloutLabel: calloutLabel, calloutLine: calloutLine } = this.properties;
        const calloutLength = calloutLine.length;
        const { offset: offset4, color: color11 } = calloutLabel;
        const tempTextNode = new $d77b025aa58d633c$var$Text();
        this.calloutLabelSelection.selectByTag(1 /* Label */ ).forEach((text)=>{
            const datum = text.closestDatum();
            const label = datum.calloutLabel;
            const radius = radiusScale.convert(datum.radius);
            const outerRadius = Math.max(0, radius);
            if (!label?.text || outerRadius === 0 || label.hidden) {
                text.visible = false;
                return;
            }
            const labelRadius = outerRadius + calloutLength + offset4;
            const x = datum.midCos * labelRadius;
            const y = datum.midSin * labelRadius + label.collisionOffsetY;
            const align2 = {
                textAlign: label.collisionTextAlign ?? label.textAlign,
                textBaseline: label.textBaseline
            };
            tempTextNode.text = label.text;
            tempTextNode.x = x;
            tempTextNode.y = y;
            tempTextNode.setFont(this.properties.calloutLabel);
            tempTextNode.setAlign(align2);
            const box = tempTextNode.getBBox();
            let displayText = label.text;
            let visible = true;
            if (calloutLabel.avoidCollisions) {
                const { textLength: textLength, hasVerticalOverflow: hasVerticalOverflow } = this.getLabelOverflow(label.text, box, seriesRect);
                displayText = label.text.length === textLength ? label.text : `${label.text.substring(0, textLength)}\u2026`;
                visible = !hasVerticalOverflow;
            }
            text.text = displayText;
            text.x = x;
            text.y = y;
            text.setFont(this.properties.calloutLabel);
            text.setAlign(align2);
            text.fill = color11;
            text.visible = visible;
        });
    }
    computeLabelsBBox(options, seriesRect) {
        const { calloutLabel: calloutLabel, calloutLine: calloutLine } = this.properties;
        const calloutLength = calloutLine.length;
        const { offset: offset4, maxCollisionOffset: maxCollisionOffset, minSpacing: minSpacing } = calloutLabel;
        if (!calloutLabel.avoidCollisions) return null;
        this.maybeRefreshNodeData();
        this.updateRadiusScale(false);
        this.computeCalloutLabelCollisionOffsets();
        const textBoxes = [];
        const text = new $d77b025aa58d633c$var$Text();
        let titleBox;
        const { title: title } = this.properties;
        if (title?.text && title.enabled) {
            const dy = this.getTitleTranslationY();
            if (isFinite(dy)) {
                text.text = title.text;
                text.x = 0;
                text.y = dy;
                text.setFont(title);
                text.setAlign({
                    textBaseline: "bottom",
                    textAlign: "center"
                });
                titleBox = text.getBBox();
                textBoxes.push(titleBox);
            }
        }
        this.calloutNodeData.forEach((datum)=>{
            const label = datum.calloutLabel;
            if (!label || datum.outerRadius === 0) return null;
            const labelRadius = datum.outerRadius + calloutLength + offset4;
            const x = datum.midCos * labelRadius;
            const y = datum.midSin * labelRadius + label.collisionOffsetY;
            text.text = label.text;
            text.x = x;
            text.y = y;
            text.setFont(this.properties.calloutLabel);
            text.setAlign({
                textAlign: label.collisionTextAlign ?? label.textAlign,
                textBaseline: label.textBaseline
            });
            const box = text.getBBox();
            label.box = box;
            if (Math.abs(label.collisionOffsetY) > maxCollisionOffset) {
                label.hidden = true;
                return;
            }
            if (titleBox) {
                const seriesTop = -this.centerY;
                const titleCleanArea = new $d77b025aa58d633c$var$BBox(titleBox.x - minSpacing, seriesTop, titleBox.width + 2 * minSpacing, titleBox.y + titleBox.height + minSpacing - seriesTop);
                if (box.collidesBBox(titleCleanArea)) {
                    label.hidden = true;
                    return;
                }
            }
            if (options.hideWhenNecessary) {
                const { textLength: textLength, hasVerticalOverflow: hasVerticalOverflow, hasSurroundingSeriesOverflow: hasSurroundingSeriesOverflow } = this.getLabelOverflow(label.text, box, seriesRect);
                const isTooShort = label.text.length > 2 && textLength < 2;
                if (hasVerticalOverflow || isTooShort || hasSurroundingSeriesOverflow) {
                    label.hidden = true;
                    return;
                }
            }
            label.hidden = false;
            textBoxes.push(box);
        });
        if (textBoxes.length === 0) return null;
        return $d77b025aa58d633c$var$BBox.merge(textBoxes);
    }
    updateSectorLabelNodes() {
        const { radiusScale: radiusScale } = this;
        const innerRadius = radiusScale.convert(0);
        const { fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight, fontFamily: fontFamily, positionOffset: positionOffset, positionRatio: positionRatio, color: color11 } = this.properties.sectorLabel;
        const isDonut = innerRadius > 0;
        const singleVisibleSector = this.ctx.legendManager.getData(this.id)?.filter((d)=>d.enabled).length === 1;
        const updateSectorLabel = (text, datum)=>{
            const { sectorLabel: sectorLabel, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle } = datum;
            let isTextVisible = false;
            if (sectorLabel && outerRadius !== 0) {
                const labelRadius = innerRadius * (1 - positionRatio) + outerRadius * positionRatio + positionOffset;
                text.fill = color11;
                text.fontStyle = fontStyle;
                text.fontWeight = fontWeight;
                text.fontSize = fontSize;
                text.fontFamily = fontFamily;
                text.text = sectorLabel.text;
                const shouldPutTextInCenter = !isDonut && singleVisibleSector;
                if (shouldPutTextInCenter) {
                    text.x = 0;
                    text.y = 0;
                } else {
                    text.x = datum.midCos * labelRadius;
                    text.y = datum.midSin * labelRadius;
                }
                text.textAlign = "center";
                text.textBaseline = "middle";
                const bbox = text.getBBox();
                const corners = [
                    [
                        bbox.x,
                        bbox.y
                    ],
                    [
                        bbox.x + bbox.width,
                        bbox.y
                    ],
                    [
                        bbox.x + bbox.width,
                        bbox.y + bbox.height
                    ],
                    [
                        bbox.x,
                        bbox.y + bbox.height
                    ]
                ];
                const sectorBounds = {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius
                };
                if (corners.every(([x, y])=>$d77b025aa58d633c$var$isPointInSector(x, y, sectorBounds))) isTextVisible = true;
            }
            text.visible = isTextVisible;
        };
        this.labelSelection.each(updateSectorLabel);
        this.highlightLabelSelection.each(updateSectorLabel);
    }
    updateZerosumRings() {
        this.zerosumOuterRing.size = this.getOuterRadius() * 2;
    }
    pickNodeClosestDatum(point) {
        return $d77b025aa58d633c$var$pickByMatchingAngle(this, point);
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, properties: properties } = this;
        const { legendItemKey: legendItemKey, calloutLabelKey: calloutLabelKey, calloutLabelName: calloutLabelName, sectorLabelKey: sectorLabelKey, sectorLabelName: sectorLabelName, angleKey: angleKey, angleName: angleName, radiusKey: radiusKey, radiusName: radiusName, tooltip: tooltip } = properties;
        const title = this.properties.title.text;
        if (!dataModel || !processedData) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const { angleRawValues: angleRawValues, legendItemValues: legendItemValues, calloutLabelValues: calloutLabelValues, sectorLabelValues: sectorLabelValues } = this.getProcessedDataValues(dataModel, processedData);
        const angleRawValue = angleRawValues[datumIndex];
        const label = legendItemValues?.[datumIndex] ?? (calloutLabelKey === angleKey ? void 0 : calloutLabelValues?.[datumIndex]) ?? (sectorLabelKey === angleKey ? void 0 : sectorLabelValues?.[datumIndex]) ?? angleName;
        return this.formatTooltipWithContext(tooltip, {
            title: title,
            symbol: this.legendItemSymbol(datumIndex),
            data: [
                {
                    label: label,
                    fallbackLabel: angleKey,
                    value: $d77b025aa58d633c$var$formatValue(angleRawValue, 3)
                }
            ]
        }, {
            seriesId: seriesId,
            datum: datum,
            title: angleName,
            legendItemKey: legendItemKey,
            calloutLabelKey: calloutLabelKey,
            calloutLabelName: calloutLabelName,
            sectorLabelKey: sectorLabelKey,
            sectorLabelName: sectorLabelName,
            angleKey: angleKey,
            angleName: angleName,
            radiusKey: radiusKey,
            radiusName: radiusName,
            ...this.getSectorFormat(datum, datumIndex, false)
        });
    }
    legendItemSymbol(datumIndex) {
        const datum = this.processedData?.dataSources.get(this.id)?.[datumIndex];
        const sectorFormat = this.getSectorFormat(datum, datumIndex, false);
        const { fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset } = this.properties;
        let { fill: fill } = sectorFormat;
        const { stroke: stroke2 } = sectorFormat;
        if ($d77b025aa58d633c$var$isGradientFill(fill)) fill = {
            ...fill,
            gradient: "linear",
            rotation: 0,
            reverse: false
        };
        return {
            marker: {
                fill: fill,
                stroke: stroke2,
                fillOpacity: fillOpacity,
                strokeOpacity: strokeOpacity,
                strokeWidth: strokeWidth,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset
            }
        };
    }
    getLegendData(legendType) {
        const { id: seriesId, visible: visible, processedData: processedData, dataModel: dataModel, ctx: { legendManager: legendManager } } = this;
        if (!dataModel || !processedData || legendType !== "category") return [];
        const { angleKey: angleKey, calloutLabelKey: calloutLabelKey, sectorLabelKey: sectorLabelKey, legendItemKey: legendItemKey, showInLegend: showInLegend } = this.properties;
        if (!legendItemKey && (!calloutLabelKey || calloutLabelKey === angleKey) && (!sectorLabelKey || sectorLabelKey === angleKey)) return [];
        const { calloutLabelValues: calloutLabelValues, sectorLabelValues: sectorLabelValues, legendItemValues: legendItemValues, angleRawValues: angleRawValues } = this.getProcessedDataValues(dataModel, processedData);
        const titleText = this.properties.title?.showInLegend && this.properties.title.text;
        const legendData = [];
        const hideZeros = this.properties.hideZeroValueSectorsInLegend;
        const rawData = processedData.dataSources.get(this.id);
        const invalidData = processedData.invalidData?.get(this.id);
        for(let datumIndex = 0; datumIndex < processedData.input.count; datumIndex++){
            const datum = rawData?.[datumIndex];
            const angleRawValue = angleRawValues[datumIndex];
            if (invalidData?.[datumIndex] === true || hideZeros && angleRawValue === 0) continue;
            const labelParts = [];
            if (titleText) labelParts.push(titleText);
            const labels = this.getLabels(datum, 2 * Math.PI, 2 * Math.PI, false, calloutLabelValues?.[datumIndex], sectorLabelValues?.[datumIndex], legendItemValues?.[datumIndex]);
            if (legendItemKey && labels.legendItem !== void 0) labelParts.push(labels.legendItem.text);
            else if (calloutLabelKey && calloutLabelKey !== angleKey && labels.calloutLabel?.text !== void 0) labelParts.push(labels.calloutLabel?.text);
            else if (sectorLabelKey && sectorLabelKey !== angleKey && labels.sectorLabel?.text !== void 0) labelParts.push(labels.sectorLabel?.text);
            if (labelParts.length === 0) continue;
            legendData.push({
                legendType: "category",
                id: seriesId,
                datum: datum,
                itemId: datumIndex,
                seriesId: seriesId,
                hideToggleOtherSeries: true,
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: seriesId,
                    itemId: datumIndex
                }),
                label: {
                    text: labelParts.join(" - ")
                },
                symbol: this.legendItemSymbol(datumIndex),
                legendItemName: legendItemKey != null ? datum[legendItemKey] : void 0,
                hideInLegend: !showInLegend
            });
        }
        return legendData;
    }
    // Used for grid
    setLegendState(enabledItems) {
        const { id: seriesId, ctx: { legendManager: legendManager, updateService: updateService } } = this;
        enabledItems.forEach((enabled, itemId)=>legendManager.toggleItem(enabled, seriesId, itemId));
        legendManager.update();
        updateService.update(5 /* SERIES_UPDATE */ );
    }
    animateEmptyUpdateReady(_data) {
        const { animationManager: animationManager } = this.ctx;
        const fns = $d77b025aa58d633c$var$preparePieSeriesAnimationFunctions(true, this.properties.rotation, this.radiusScale, this.previousRadiusScale);
        $d77b025aa58d633c$var$fromToMotion(this.id, "nodes", animationManager, [
            this.itemSelection,
            this.highlightSelection,
            this.phantomSelection
        ], fns.nodes, (_, datum)=>this.getDatumId(datum.datumIndex));
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "callout", animationManager, this.calloutLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "sector", animationManager, this.labelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "highlight", animationManager, this.highlightLabelSelection);
        this.previousRadiusScale.range = this.radiusScale.range;
    }
    animateWaitingUpdateReady() {
        const { itemSelection: itemSelection, highlightSelection: highlightSelection, phantomSelection: phantomSelection, processedData: processedData, radiusScale: radiusScale, previousRadiusScale: previousRadiusScale } = this;
        const { animationManager: animationManager } = this.ctx;
        const dataDiff = processedData?.reduced?.diff?.[this.id];
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
        const supportedDiff = (dataDiff?.moved.size ?? 0) === 0;
        const hasKeys = (processedData?.defs.keys.length ?? 0) > 0;
        const hasUniqueKeys = processedData?.reduced?.animationValidation?.uniqueKeys ?? true;
        if (!supportedDiff || !hasKeys || !hasUniqueKeys) this.ctx.animationManager.skipCurrentBatch();
        const fns = $d77b025aa58d633c$var$preparePieSeriesAnimationFunctions(false, this.properties.rotation, radiusScale, previousRadiusScale);
        $d77b025aa58d633c$var$fromToMotion(this.id, "nodes", animationManager, [
            itemSelection,
            highlightSelection,
            phantomSelection
        ], fns.nodes, (_, datum)=>this.getDatumId(datum.datumIndex), dataDiff);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "callout", this.ctx.animationManager, this.calloutLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "sector", this.ctx.animationManager, this.labelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "highlight", this.ctx.animationManager, this.highlightLabelSelection);
        this.previousRadiusScale.range = this.radiusScale.range;
    }
    animateClearingUpdateEmpty() {
        const { itemSelection: itemSelection, highlightSelection: highlightSelection, phantomSelection: phantomSelection, radiusScale: radiusScale, previousRadiusScale: previousRadiusScale } = this;
        const { animationManager: animationManager } = this.ctx;
        const fns = $d77b025aa58d633c$var$preparePieSeriesAnimationFunctions(false, this.properties.rotation, radiusScale, previousRadiusScale);
        $d77b025aa58d633c$var$fromToMotion(this.id, "nodes", animationManager, [
            itemSelection,
            highlightSelection,
            phantomSelection
        ], fns.nodes, (_, datum)=>this.getDatumId(datum.datumIndex));
        $d77b025aa58d633c$var$seriesLabelFadeOutAnimation(this, "callout", this.ctx.animationManager, this.calloutLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeOutAnimation(this, "sector", this.ctx.animationManager, this.labelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeOutAnimation(this, "highlight", this.ctx.animationManager, this.highlightLabelSelection);
        this.previousRadiusScale.range = this.radiusScale.range;
    }
    getDatumId(datumIndex) {
        return `${datumIndex}`;
    }
};
$d77b025aa58d633c$var$PieSeries.className = "PieSeries";
$d77b025aa58d633c$var$PieSeries.type = "pie";
// packages/ag-charts-community/src/chart/series/polar/pieTheme.ts
var $d77b025aa58d633c$var$pieTheme = {
    series: {
        title: {
            enabled: true,
            fontWeight: {
                $ref: "fontWeight"
            },
            fontSize: {
                $rem: [
                    1.1666666666666667 /* LARGE */ 
                ]
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            color: {
                $ref: "subtleTextColor"
            },
            spacing: 5
        },
        calloutLabel: {
            enabled: true,
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            fontWeight: {
                $ref: "fontWeight"
            },
            color: {
                $ref: "textColor"
            },
            offset: 3,
            minAngle: 1e-3
        },
        sectorLabel: {
            enabled: true,
            fontWeight: {
                $ref: "fontWeight"
            },
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            color: {
                $ref: "backgroundColor"
            },
            positionOffset: 0,
            positionRatio: 0.5
        },
        calloutLine: {
            length: 10,
            strokeWidth: 2,
            colors: {
                $map: [
                    {
                        $if: [
                            {
                                $or: [
                                    {
                                        $isGradient: [
                                            {
                                                $value: "$1"
                                            }
                                        ]
                                    },
                                    {
                                        $isPattern: [
                                            {
                                                $value: "$1"
                                            }
                                        ]
                                    },
                                    {
                                        $isImage: [
                                            {
                                                $value: "$1"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                $path: [
                                    "../../strokes/$index",
                                    {
                                        $ref: "foregroundColor"
                                    }
                                ]
                            },
                            {
                                $value: "$1"
                            }
                        ]
                    },
                    {
                        $if: [
                            {
                                $eq: [
                                    {
                                        $path: "../strokeWidth"
                                    },
                                    0
                                ]
                            },
                            {
                                $path: "../fills"
                            },
                            {
                                $path: "../strokes"
                            }
                        ]
                    }
                ]
            }
        },
        fills: {
            $palette: "fills"
        },
        strokes: {
            $palette: "strokes"
        },
        // @ts-expect-error undocumented option
        defaultColorRange: {
            $palette: "gradients"
        },
        defaultPatternFills: $d77b025aa58d633c$var$SAFE_FILLS_OPERATION,
        fillOpacity: 1,
        strokeOpacity: 1,
        strokeWidth: 0,
        lineDash: [
            0
        ],
        lineDashOffset: 0,
        rotation: 0,
        sectorSpacing: 1,
        shadow: {
            enabled: false,
            color: $d77b025aa58d633c$var$DEFAULT_SHADOW_COLOUR,
            xOffset: 3,
            yOffset: 3,
            blur: 5
        }
    },
    legend: {
        enabled: true
    }
};
// packages/ag-charts-community/src/chart/series/polar/pieSeriesModule.ts
var $d77b025aa58d633c$var$PieSeriesModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "community",
    chartTypes: [
        "polar"
    ],
    identifier: "pie",
    moduleFactory: (ctx)=>new $d77b025aa58d633c$var$PieSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    themeTemplate: $d77b025aa58d633c$var$pieTheme
};
var $d77b025aa58d633c$var$NewPieSeriesModule = {
    type: "series",
    name: "pie",
    chartType: "polar",
    options: $d77b025aa58d633c$var$pieSeriesOptionsDef,
    create: (ctx)=>new $d77b025aa58d633c$var$PieSeries(ctx)
};
// packages/ag-charts-community/src/chart/factory/registerInbuiltModules.ts
function $d77b025aa58d633c$export$2f274d5ba325cdcd() {
    $d77b025aa58d633c$var$moduleRegistry.register($d77b025aa58d633c$var$BackgroundModule, $d77b025aa58d633c$var$CommunityLegendModule, $d77b025aa58d633c$var$LocaleModule, $d77b025aa58d633c$var$AreaSeriesModule, $d77b025aa58d633c$var$BarSeriesModule, $d77b025aa58d633c$var$BubbleSeriesModule, $d77b025aa58d633c$var$LineSeriesModule, $d77b025aa58d633c$var$ScatterSeriesModule, $d77b025aa58d633c$var$DonutSeriesModule, $d77b025aa58d633c$var$PieSeriesModule, $d77b025aa58d633c$var$HistogramSeriesModule);
    for (const AxisConstructor of [
        $d77b025aa58d633c$var$NumberAxis,
        $d77b025aa58d633c$var$CategoryAxis,
        $d77b025aa58d633c$var$TimeAxis,
        $d77b025aa58d633c$var$GroupedCategoryAxis,
        $d77b025aa58d633c$var$LogAxis,
        $d77b025aa58d633c$var$UnitTimeAxis
    ])$d77b025aa58d633c$var$axisRegistry.register(AxisConstructor.type, {
        moduleFactory: (ctx)=>new AxisConstructor(ctx)
    });
}
function $d77b025aa58d633c$var$setupModules() {
    for (const m of $d77b025aa58d633c$var$moduleRegistry.modules){
        if (m.packageType === "enterprise" && !$d77b025aa58d633c$var$verifyIfModuleExpected(m)) (0, $idDdm.Logger).errorOnce("Unexpected enterprise module registered: " + m.identifier);
        if (m.type === "root" && m.themeTemplate) for (const chartType of m.chartTypes)$d77b025aa58d633c$var$chartDefaults.set(chartType, m.themeTemplate);
        if (m.type === "series") {
            if (m.chartTypes.length > 1) throw new Error(`AG Charts - Module definition error: ${m.identifier}`);
            $d77b025aa58d633c$var$seriesRegistry.register(m.identifier, m);
        }
        if (m.type === "series-option" && m.themeTemplate) for (const seriesType of m.seriesTypes)$d77b025aa58d633c$var$seriesRegistry.setThemeTemplate(seriesType, m.themeTemplate);
        if (m.type === "axis-option" && m.themeTemplate) for (const axisType of m.axisTypes){
            const axisTypeTheme = $d77b025aa58d633c$var$axisRegistry.getThemeTemplate(axisType);
            const theme = $d77b025aa58d633c$var$mergeDefaults(m.themeTemplate, axisTypeTheme);
            $d77b025aa58d633c$var$axisRegistry.setThemeTemplate(axisType, theme);
        }
        if (m.type === "axis") $d77b025aa58d633c$var$axisRegistry.register(m.identifier, m);
        if (m.type === "legend") $d77b025aa58d633c$var$legendRegistry.register(m.identifier, m);
    }
    if ($d77b025aa58d633c$var$moduleRegistry.hasEnterpriseModules()) {
        const expectedButUnused = $d77b025aa58d633c$var$getUnusedExpectedModules();
        if (expectedButUnused.length > 0) (0, $idDdm.Logger).errorOnce("Enterprise modules expected but not registered: ", expectedButUnused);
    }
}
// packages/ag-charts-types/src/chart/errorBarOptions.ts
var $d77b025aa58d633c$export$8d1e42e0e779ee56 = [
    "bar",
    "line",
    "scatter"
];
// packages/ag-charts-types/src/chart/navigatorOptions.ts
var $d77b025aa58d633c$var$__MINI_CHART_SERIES_OPTIONS = void 0;
var $d77b025aa58d633c$var$__VERIFY_MINI_CHART_SERIES_OPTIONS = void 0;
$d77b025aa58d633c$var$__VERIFY_MINI_CHART_SERIES_OPTIONS = $d77b025aa58d633c$var$__MINI_CHART_SERIES_OPTIONS;
// packages/ag-charts-types/src/chart/themeOptions.ts
var $d77b025aa58d633c$var$__THEME_OVERRIDES = void 0;
var $d77b025aa58d633c$var$__VERIFY_THEME_OVERRIDES = void 0;
$d77b025aa58d633c$var$__VERIFY_THEME_OVERRIDES = $d77b025aa58d633c$var$__THEME_OVERRIDES;
// packages/ag-charts-types/src/chart/tooltipOptions.ts
var $d77b025aa58d633c$export$72d20be677f065cb = /* @__PURE__ */ ((AgTooltipAnchorToType2)=>{
    AgTooltipAnchorToType2["POINTER"] = "pointer";
    AgTooltipAnchorToType2["NODE"] = "node";
    AgTooltipAnchorToType2["CHART"] = "chart";
    return AgTooltipAnchorToType2;
})($d77b025aa58d633c$export$72d20be677f065cb || {});
var $d77b025aa58d633c$export$8febaa3e13abde89 = /* @__PURE__ */ ((AgTooltipPlacementType2)=>{
    AgTooltipPlacementType2["TOP"] = "top";
    AgTooltipPlacementType2["RIGHT"] = "right";
    AgTooltipPlacementType2["BOTTOM"] = "bottom";
    AgTooltipPlacementType2["LEFT"] = "left";
    AgTooltipPlacementType2["TOP_RIGHT"] = "top-right";
    AgTooltipPlacementType2["BOTTOM_RIGHT"] = "bottom-right";
    AgTooltipPlacementType2["BOTTOM_LEFT"] = "bottom-left";
    AgTooltipPlacementType2["TOP_LEFT"] = "top-left";
    AgTooltipPlacementType2["CENTER"] = "center";
    return AgTooltipPlacementType2;
})($d77b025aa58d633c$export$8febaa3e13abde89 || {});
var $d77b025aa58d633c$export$a277a8c996e5a5f6 = /* @__PURE__ */ ((AgTooltipPositionType2)=>{
    AgTooltipPositionType2["POINTER"] = "pointer";
    AgTooltipPositionType2["NODE"] = "node";
    AgTooltipPositionType2["TOP"] = "top";
    AgTooltipPositionType2["RIGHT"] = "right";
    AgTooltipPositionType2["BOTTOM"] = "bottom";
    AgTooltipPositionType2["LEFT"] = "left";
    AgTooltipPositionType2["TOP_LEFT"] = "top-left";
    AgTooltipPositionType2["TOP_RIGHT"] = "top-right";
    AgTooltipPositionType2["BOTTOM_RIGHT"] = "bottom-right";
    AgTooltipPositionType2["BOTTOM_LEFT"] = "bottom-left";
    return AgTooltipPositionType2;
})($d77b025aa58d633c$export$a277a8c996e5a5f6 || {});
// packages/ag-charts-types/src/presets/gauge/commonOptions.ts
var $d77b025aa58d633c$var$__THEMEABLE_OPTIONS = void 0;
var $d77b025aa58d633c$var$__VERIFY_THEMEABLE_OPTIONS = void 0;
$d77b025aa58d633c$var$__VERIFY_THEMEABLE_OPTIONS = $d77b025aa58d633c$var$__THEMEABLE_OPTIONS;
var $d77b025aa58d633c$var$__AXIS_LABEL_OPTIONS = void 0;
var $d77b025aa58d633c$var$__VERIFY_AXIS_LABEL_OPTIONS = void 0;
$d77b025aa58d633c$var$__VERIFY_AXIS_LABEL_OPTIONS = $d77b025aa58d633c$var$__AXIS_LABEL_OPTIONS;
// packages/ag-charts-community/src/api/preset/presetUtils.ts
var $d77b025aa58d633c$var$IGNORED_PROP = Symbol("IGNORED_PROP");
function $d77b025aa58d633c$var$pickProps(opts, values) {
    const out = {};
    for (const key of Object.keys(values)){
        const value = values[key];
        if (value !== $d77b025aa58d633c$var$IGNORED_PROP && Object.hasOwn(opts, key)) out[key] = value;
    }
    return out;
}
// packages/ag-charts-community/src/api/preset/gauge.ts
function $d77b025aa58d633c$var$tooltipOptions(opts) {
    const { enabled: enabled, mode: mode, showArrow: showArrow, range: range3, position: position, pagination: pagination, delay: delay, wrapping: wrapping, interaction: interaction, renderer: renderer, ...rest } = opts;
    const seriesTooltipOptions = $d77b025aa58d633c$var$pickProps(opts, {
        enabled: enabled,
        showArrow: showArrow,
        range: range3,
        position: position,
        interaction: interaction,
        renderer: renderer,
        ...rest
    });
    const chartTooltipOptions = $d77b025aa58d633c$var$pickProps(opts, {
        enabled: $d77b025aa58d633c$var$IGNORED_PROP,
        showArrow: $d77b025aa58d633c$var$IGNORED_PROP,
        range: $d77b025aa58d633c$var$IGNORED_PROP,
        position: $d77b025aa58d633c$var$IGNORED_PROP,
        mode: mode,
        pagination: pagination,
        delay: delay,
        wrapping: wrapping,
        ...rest
    });
    return {
        chartTooltipOptions: chartTooltipOptions,
        seriesTooltipOptions: seriesTooltipOptions
    };
}
function $d77b025aa58d633c$var$radialGaugeOptions(opts) {
    const { animation: animation, background: background, container: container, contextMenu: contextMenu, footnote: footnote, height: height2, listeners: listeners, locale: locale, minHeight: minHeight, minWidth: minWidth, overrideDevicePixelRatio: overrideDevicePixelRatio, padding: padding, subtitle: subtitle, theme: theme, title: title, width: width2, type: type, cursor: cursor, nodeClickRange: nodeClickRange, tooltip: tooltip = {}, value: value, scale: scale2 = {}, startAngle: startAngle, endAngle: endAngle, highlightStyle: highlightStyle, segmentation: segmentation, bar: bar, needle: needle, targets: targets, outerRadius: outerRadius, innerRadius: innerRadius, outerRadiusRatio: outerRadiusRatio, innerRadiusRatio: innerRadiusRatio, cornerRadius: cornerRadius, cornerMode: cornerMode, label: label, secondaryLabel: secondaryLabel, spacing: spacing, ...rest } = opts;
    const { chartTooltipOptions: chartTooltipOptions, seriesTooltipOptions: seriesTooltipOptions } = $d77b025aa58d633c$var$tooltipOptions(tooltip);
    const chartOpts = $d77b025aa58d633c$var$pickProps(opts, {
        animation: animation,
        background: background,
        container: container,
        contextMenu: contextMenu,
        footnote: footnote,
        height: height2,
        listeners: listeners,
        locale: locale,
        minHeight: minHeight,
        minWidth: minWidth,
        overrideDevicePixelRatio: overrideDevicePixelRatio,
        padding: padding,
        subtitle: subtitle,
        theme: theme,
        title: title,
        tooltip: chartTooltipOptions,
        width: width2
    });
    const seriesOpts = $d77b025aa58d633c$var$pickProps(opts, {
        needle: needle != null ? {
            enabled: true,
            ...needle
        } : $d77b025aa58d633c$var$IGNORED_PROP,
        startAngle: startAngle,
        endAngle: endAngle,
        scale: scale2,
        type: type,
        cursor: cursor,
        nodeClickRange: nodeClickRange,
        tooltip: seriesTooltipOptions,
        value: value,
        highlightStyle: highlightStyle,
        segmentation: segmentation,
        bar: bar,
        targets: targets,
        outerRadius: outerRadius,
        innerRadius: innerRadius,
        outerRadiusRatio: outerRadiusRatio,
        innerRadiusRatio: innerRadiusRatio,
        cornerRadius: cornerRadius,
        cornerMode: cornerMode,
        label: label,
        secondaryLabel: secondaryLabel,
        spacing: spacing,
        ...rest
    });
    if ("context" in opts) chartOpts["context"] = opts.context;
    return {
        ...chartOpts,
        series: [
            seriesOpts
        ]
    };
}
function $d77b025aa58d633c$var$linearGaugeOptions(opts) {
    const { animation: animation, background: background, container: container, contextMenu: contextMenu, footnote: footnote, height: height2, listeners: listeners, locale: locale, minHeight: minHeight, minWidth: minWidth, overrideDevicePixelRatio: overrideDevicePixelRatio, padding: padding, subtitle: subtitle, theme: theme, title: title, width: width2, type: type, cursor: cursor, nodeClickRange: nodeClickRange, tooltip: tooltip = {}, value: value, scale: scale2 = {}, direction: direction = "vertical", thickness: thickness, highlightStyle: highlightStyle, segmentation: segmentation, bar: bar, targets: targets, cornerRadius: cornerRadius, cornerMode: cornerMode, label: label, ...rest } = opts;
    const { chartTooltipOptions: chartTooltipOptions, seriesTooltipOptions: seriesTooltipOptions } = $d77b025aa58d633c$var$tooltipOptions(tooltip);
    const chartOpts = $d77b025aa58d633c$var$pickProps(opts, {
        animation: animation,
        background: background,
        container: container,
        contextMenu: contextMenu,
        footnote: footnote,
        height: height2,
        listeners: listeners,
        locale: locale,
        minHeight: minHeight,
        minWidth: minWidth,
        overrideDevicePixelRatio: overrideDevicePixelRatio,
        padding: padding,
        subtitle: subtitle,
        theme: theme,
        title: title,
        tooltip: chartTooltipOptions,
        width: width2
    });
    const seriesOpts = $d77b025aa58d633c$var$pickProps(opts, {
        scale: scale2,
        type: type,
        cursor: cursor,
        nodeClickRange: nodeClickRange,
        tooltip: seriesTooltipOptions,
        value: value,
        direction: direction,
        thickness: thickness,
        highlightStyle: highlightStyle,
        segmentation: segmentation,
        bar: bar,
        targets: targets,
        cornerRadius: cornerRadius,
        cornerMode: cornerMode,
        label: label,
        ...rest
    });
    if ("context" in opts) chartOpts["context"] = opts.context;
    return {
        ...chartOpts,
        series: [
            seriesOpts
        ]
    };
}
function $d77b025aa58d633c$var$applyThemeDefaults(opts, presetTheme) {
    if (presetTheme == null) return opts;
    const { targets: targetsTheme, ...gaugeTheme } = presetTheme;
    opts = $d77b025aa58d633c$var$mergeDefaults(opts, gaugeTheme);
    if (opts.targets != null && targetsTheme != null) opts.targets = $d77b025aa58d633c$var$mergeArrayDefaults(opts.targets, targetsTheme);
    return opts;
}
function $d77b025aa58d633c$var$gauge(opts, presetTheme) {
    if (opts.listeners) {
        const { nodeClick: nodeClick, nodeDoubleClick: nodeDoubleClick, ...listeners } = opts.listeners;
        opts = {
            ...opts,
            listeners: {
                seriesNodeClick: nodeClick,
                seriesNodeDoubleClick: nodeDoubleClick,
                ...listeners
            }
        };
    }
    switch(opts.type){
        case "radial-gauge":
            const radialGaugeOpts = $d77b025aa58d633c$var$applyThemeDefaults(opts, presetTheme);
            return $d77b025aa58d633c$var$radialGaugeOptions(radialGaugeOpts);
        case "linear-gauge":
            const linearGaugeOpts = $d77b025aa58d633c$var$applyThemeDefaults(opts, presetTheme);
            return $d77b025aa58d633c$var$linearGaugeOptions(linearGaugeOpts);
        default:
            return {};
    }
}
var $d77b025aa58d633c$var$fillsOptionsDef = {
    fills: (0, $idDdm.and)((0, $idDdm.arrayLength)(2), (0, $idDdm.arrayOf)((0, $idDdm.optionsDefs)({
        color: (0, $idDdm.color),
        stop: (0, $idDdm.number)
    }, "")), (0, $idDdm.colorStopsOrderValidator)),
    fillMode: (0, $idDdm.union)("continuous", "discrete")
};
var $d77b025aa58d633c$var$linearGaugeTargetOptionsDef = {
    value: (0, $idDdm.required)((0, $idDdm.number)),
    text: (0, $idDdm.string),
    shape: (0, $idDdm.or)((0, $idDdm.union)("circle", "cross", "diamond", "heart", "plus", "pin", "square", "star", "triangle", "line"), (0, $idDdm.callback)),
    placement: (0, $idDdm.union)("before", "after", "middle"),
    spacing: (0, $idDdm.positiveNumber),
    size: (0, $idDdm.positiveNumber),
    rotation: (0, $idDdm.number),
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$radialGaugeTargetOptionsDef = {
    value: (0, $idDdm.required)((0, $idDdm.number)),
    text: (0, $idDdm.string),
    shape: (0, $idDdm.or)((0, $idDdm.union)("circle", "cross", "diamond", "heart", "plus", "pin", "square", "star", "triangle", "line"), (0, $idDdm.callback)),
    placement: (0, $idDdm.union)("inside", "outside", "middle"),
    spacing: (0, $idDdm.positiveNumber),
    size: (0, $idDdm.positiveNumber),
    rotation: (0, $idDdm.number),
    label: {
        ...$d77b025aa58d633c$var$seriesLabelOptionsDefs,
        spacing: (0, $idDdm.positiveNumber)
    },
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$linearGaugeSeriesThemeableOptionsDef = {
    direction: (0, $idDdm.union)("horizontal", "vertical"),
    cornerMode: (0, $idDdm.union)("container", "item"),
    cornerRadius: (0, $idDdm.positiveNumber),
    thickness: (0, $idDdm.positiveNumber),
    segmentation: {
        enabled: (0, $idDdm.boolean),
        spacing: (0, $idDdm.positiveNumber),
        interval: {
            values: (0, $idDdm.arrayOf)((0, $idDdm.number)),
            step: (0, $idDdm.number),
            count: (0, $idDdm.number)
        }
    },
    bar: {
        enabled: (0, $idDdm.boolean),
        thickness: (0, $idDdm.positiveNumber),
        thicknessRatio: (0, $idDdm.ratio),
        ...$d77b025aa58d633c$var$fillsOptionsDef,
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    },
    label: {
        ...$d77b025aa58d633c$var$autoSizedLabelOptionsDefs,
        text: (0, $idDdm.string),
        spacing: (0, $idDdm.positiveNumber),
        avoidCollisions: (0, $idDdm.boolean),
        placement: (0, $idDdm.union)("inside-start", "outside-start", "inside-end", "outside-end", "inside-center", "bar-inside", "bar-inside-end", "bar-outside-end", "bar-end")
    },
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs, [
        "listeners"
    ])
};
var $d77b025aa58d633c$var$linearGaugeSeriesOptionsDef = {
    ...$d77b025aa58d633c$var$linearGaugeSeriesThemeableOptionsDef,
    ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$commonSeriesOptionsDefs, [
        "listeners"
    ]),
    type: (0, $idDdm.required)((0, $idDdm.constant)("linear-gauge")),
    value: (0, $idDdm.required)((0, $idDdm.number)),
    scale: {
        min: (0, $idDdm.and)((0, $idDdm.number), (0, $idDdm.lessThan)("max")),
        max: (0, $idDdm.and)((0, $idDdm.number), (0, $idDdm.greaterThan)("min")),
        label: {
            enabled: (0, $idDdm.boolean),
            formatter: (0, $idDdm.callback),
            rotation: (0, $idDdm.number),
            spacing: (0, $idDdm.positiveNumber),
            minSpacing: (0, $idDdm.positiveNumber),
            placement: (0, $idDdm.union)("before", "after"),
            avoidCollisions: (0, $idDdm.boolean),
            format: $d77b025aa58d633c$var$numberFormatValidator,
            ...(0, $idDdm.fontOptionsDef)
        },
        interval: {
            values: (0, $idDdm.arrayOf)((0, $idDdm.number)),
            step: (0, $idDdm.number)
        },
        ...$d77b025aa58d633c$var$fillsOptionsDef,
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    },
    targets: (0, $idDdm.arrayOfDefs)($d77b025aa58d633c$var$linearGaugeTargetOptionsDef, "target options array")
};
$d77b025aa58d633c$var$linearGaugeSeriesOptionsDef.margin = (0, $idDdm.undocumented)((0, $idDdm.number));
$d77b025aa58d633c$var$linearGaugeSeriesOptionsDef.defaultColorRange = (0, $idDdm.undocumented)((0, $idDdm.arrayOf)((0, $idDdm.color)));
$d77b025aa58d633c$var$linearGaugeSeriesOptionsDef.defaultTarget = (0, $idDdm.undocumented)({
    ...$d77b025aa58d633c$var$linearGaugeTargetOptionsDef,
    value: (0, $idDdm.number),
    label: {
        ...$d77b025aa58d633c$var$seriesLabelOptionsDefs,
        spacing: (0, $idDdm.number)
    }
});
$d77b025aa58d633c$var$linearGaugeSeriesOptionsDef.defaultScale = (0, $idDdm.undocumented)($d77b025aa58d633c$var$linearGaugeSeriesOptionsDef.scale);
$d77b025aa58d633c$var$linearGaugeSeriesOptionsDef.scale.defaultFill = (0, $idDdm.undocumented)((0, $idDdm.color));
var $d77b025aa58d633c$var$radialGaugeSeriesThemeableOptionsDef = {
    outerRadius: (0, $idDdm.positiveNumber),
    innerRadius: (0, $idDdm.positiveNumber),
    outerRadiusRatio: (0, $idDdm.ratio),
    innerRadiusRatio: (0, $idDdm.ratio),
    startAngle: (0, $idDdm.number),
    endAngle: (0, $idDdm.number),
    spacing: (0, $idDdm.positiveNumber),
    cornerMode: (0, $idDdm.union)("container", "item"),
    cornerRadius: (0, $idDdm.positiveNumber),
    scale: {
        min: (0, $idDdm.and)((0, $idDdm.number), (0, $idDdm.lessThan)("max")),
        max: (0, $idDdm.and)((0, $idDdm.number), (0, $idDdm.greaterThan)("min")),
        label: {
            enabled: (0, $idDdm.boolean),
            formatter: (0, $idDdm.callback),
            rotation: (0, $idDdm.number),
            spacing: (0, $idDdm.positiveNumber),
            minSpacing: (0, $idDdm.positiveNumber),
            avoidCollisions: (0, $idDdm.boolean),
            format: $d77b025aa58d633c$var$numberFormatValidator,
            ...(0, $idDdm.fontOptionsDef)
        },
        interval: {
            values: (0, $idDdm.arrayOf)((0, $idDdm.number)),
            step: (0, $idDdm.number)
        },
        ...$d77b025aa58d633c$var$fillsOptionsDef,
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    },
    segmentation: {
        enabled: (0, $idDdm.boolean),
        spacing: (0, $idDdm.positiveNumber),
        interval: {
            values: (0, $idDdm.arrayOf)((0, $idDdm.number)),
            step: (0, $idDdm.number),
            count: (0, $idDdm.number)
        }
    },
    bar: {
        enabled: (0, $idDdm.boolean),
        ...$d77b025aa58d633c$var$fillsOptionsDef,
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    },
    needle: {
        enabled: (0, $idDdm.boolean),
        spacing: (0, $idDdm.positiveNumber),
        radiusRatio: (0, $idDdm.ratio),
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    },
    label: {
        text: (0, $idDdm.string),
        spacing: (0, $idDdm.positiveNumber),
        ...$d77b025aa58d633c$var$autoSizedLabelOptionsDefs
    },
    secondaryLabel: {
        text: (0, $idDdm.string),
        ...$d77b025aa58d633c$var$autoSizedLabelOptionsDefs
    },
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs
};
var $d77b025aa58d633c$var$radialGaugeSeriesOptionsDef = {
    ...$d77b025aa58d633c$var$radialGaugeSeriesThemeableOptionsDef,
    ...$d77b025aa58d633c$var$commonSeriesOptionsDefs,
    type: (0, $idDdm.required)((0, $idDdm.constant)("radial-gauge")),
    value: (0, $idDdm.required)((0, $idDdm.number)),
    targets: (0, $idDdm.arrayOfDefs)($d77b025aa58d633c$var$radialGaugeTargetOptionsDef, "target options array")
};
$d77b025aa58d633c$var$radialGaugeSeriesOptionsDef.defaultColorRange = (0, $idDdm.undocumented)((0, $idDdm.arrayOf)((0, $idDdm.color)));
$d77b025aa58d633c$var$radialGaugeSeriesOptionsDef.defaultTarget = (0, $idDdm.undocumented)({
    ...$d77b025aa58d633c$var$radialGaugeTargetOptionsDef,
    value: (0, $idDdm.number),
    label: {
        ...$d77b025aa58d633c$var$seriesLabelOptionsDefs,
        spacing: (0, $idDdm.number)
    }
});
$d77b025aa58d633c$var$radialGaugeSeriesOptionsDef.scale.defaultFill = (0, $idDdm.undocumented)((0, $idDdm.color));
// packages/ag-charts-community/src/api/preset/priceVolumePresetTheme.ts
var $d77b025aa58d633c$var$stroke = {
    stroke: $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR
};
var $d77b025aa58d633c$var$handle = {
    fill: $d77b025aa58d633c$var$DEFAULT_ANNOTATION_HANDLE_FILL
};
var $d77b025aa58d633c$var$axisLabel = {
    color: "white",
    fill: $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR
};
var $d77b025aa58d633c$var$lineText = {
    color: $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR
};
var $d77b025aa58d633c$var$font = {
    color: $d77b025aa58d633c$var$DEFAULT_TEXT_ANNOTATION_COLOR,
    fontSize: {
        $rem: [
            1.1666666666666667 /* LARGE */ 
        ]
    },
    fontFamily: {
        $ref: "fontFamily"
    }
};
var $d77b025aa58d633c$var$measurerStatistics = {
    ...$d77b025aa58d633c$var$font,
    fontSize: {
        $ref: "fontSize"
    },
    color: $d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_COLOR,
    fill: $d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_FILL,
    stroke: $d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_STROKE,
    strokeWidth: 1,
    divider: {
        stroke: $d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DIVIDER_STROKE,
        strokeWidth: 1,
        strokeOpacity: 0.5
    }
};
var $d77b025aa58d633c$var$measurer = {
    ...$d77b025aa58d633c$var$stroke,
    background: {
        fill: $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL,
        fillOpacity: 0.2
    },
    handle: {
        ...$d77b025aa58d633c$var$handle
    },
    text: {
        ...$d77b025aa58d633c$var$lineText
    },
    statistics: {
        ...$d77b025aa58d633c$var$measurerStatistics
    }
};
var $d77b025aa58d633c$var$annotationsTheme = {
    // Lines
    line: {
        ...$d77b025aa58d633c$var$stroke,
        handle: {
            ...$d77b025aa58d633c$var$handle
        },
        text: {
            ...$d77b025aa58d633c$var$lineText
        }
    },
    "horizontal-line": {
        ...$d77b025aa58d633c$var$stroke,
        handle: {
            ...$d77b025aa58d633c$var$handle
        },
        axisLabel: {
            ...$d77b025aa58d633c$var$axisLabel
        },
        text: {
            ...$d77b025aa58d633c$var$lineText
        }
    },
    "vertical-line": {
        ...$d77b025aa58d633c$var$stroke,
        handle: {
            ...$d77b025aa58d633c$var$handle
        },
        axisLabel: {
            ...$d77b025aa58d633c$var$axisLabel
        },
        text: {
            ...$d77b025aa58d633c$var$lineText
        }
    },
    // Channels
    "disjoint-channel": {
        ...$d77b025aa58d633c$var$stroke,
        background: {
            fill: $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL,
            fillOpacity: 0.2
        },
        handle: {
            ...$d77b025aa58d633c$var$handle
        },
        text: {
            ...$d77b025aa58d633c$var$lineText
        }
    },
    "parallel-channel": {
        ...$d77b025aa58d633c$var$stroke,
        background: {
            fill: $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL,
            fillOpacity: 0.2
        },
        handle: {
            ...$d77b025aa58d633c$var$handle
        },
        text: {
            ...$d77b025aa58d633c$var$lineText
        }
    },
    // Fibonnaccis
    "fibonacci-retracement": {
        ...$d77b025aa58d633c$var$stroke,
        strokes: $d77b025aa58d633c$var$DEFAULT_FIBONACCI_STROKES,
        rangeStroke: $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR,
        handle: {
            ...$d77b025aa58d633c$var$handle
        },
        text: {
            ...$d77b025aa58d633c$var$lineText,
            position: "center"
        },
        label: {
            ...$d77b025aa58d633c$var$font,
            color: void 0,
            fontSize: {
                $round: [
                    {
                        $mul: [
                            {
                                $ref: "fontSize"
                            },
                            10 / 12
                        ]
                    }
                ]
            }
        }
    },
    "fibonacci-retracement-trend-based": {
        ...$d77b025aa58d633c$var$stroke,
        strokes: $d77b025aa58d633c$var$DEFAULT_FIBONACCI_STROKES,
        rangeStroke: $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR,
        handle: {
            ...$d77b025aa58d633c$var$handle
        },
        text: {
            ...$d77b025aa58d633c$var$lineText,
            position: "center"
        },
        label: {
            ...$d77b025aa58d633c$var$font,
            color: void 0,
            fontSize: {
                $round: [
                    {
                        $mul: [
                            {
                                $ref: "fontSize"
                            },
                            10 / 12
                        ]
                    }
                ]
            }
        }
    },
    // Texts
    callout: {
        ...$d77b025aa58d633c$var$stroke,
        ...$d77b025aa58d633c$var$font,
        color: {
            $ref: "textColor"
        },
        handle: {
            ...$d77b025aa58d633c$var$handle
        },
        fill: $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL,
        fillOpacity: 0.2
    },
    comment: {
        ...$d77b025aa58d633c$var$font,
        color: "white",
        fontWeight: 700,
        handle: {
            ...$d77b025aa58d633c$var$handle
        },
        fill: $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR
    },
    note: {
        ...$d77b025aa58d633c$var$font,
        color: $d77b025aa58d633c$var$DEFAULT_TEXTBOX_COLOR,
        fill: $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR,
        stroke: {
            $ref: "backgroundColor"
        },
        strokeWidth: 1,
        strokeOpacity: 1,
        handle: {
            ...$d77b025aa58d633c$var$handle
        },
        background: {
            fill: $d77b025aa58d633c$var$DEFAULT_TEXTBOX_FILL,
            stroke: $d77b025aa58d633c$var$DEFAULT_TEXTBOX_STROKE,
            strokeWidth: 1
        }
    },
    text: {
        ...$d77b025aa58d633c$var$font,
        handle: {
            ...$d77b025aa58d633c$var$handle
        }
    },
    // Shapes
    arrow: {
        ...$d77b025aa58d633c$var$stroke,
        handle: {
            ...$d77b025aa58d633c$var$handle
        },
        text: {
            ...$d77b025aa58d633c$var$lineText
        }
    },
    "arrow-up": {
        fill: {
            $palette: "up.fill"
        },
        handle: {
            ...$d77b025aa58d633c$var$handle,
            stroke: $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR
        }
    },
    "arrow-down": {
        fill: {
            $palette: "down.fill"
        },
        handle: {
            ...$d77b025aa58d633c$var$handle,
            stroke: $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR
        }
    },
    // Measurers
    "date-range": {
        ...$d77b025aa58d633c$var$measurer
    },
    "price-range": {
        ...$d77b025aa58d633c$var$measurer
    },
    "date-price-range": {
        ...$d77b025aa58d633c$var$measurer
    },
    "quick-date-price-range": {
        up: {
            ...$d77b025aa58d633c$var$stroke,
            fill: $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL,
            fillOpacity: 0.2,
            handle: {
                ...$d77b025aa58d633c$var$handle
            },
            statistics: {
                ...$d77b025aa58d633c$var$measurerStatistics,
                color: "#fff",
                fill: $d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL,
                strokeWidth: 0,
                divider: {
                    stroke: "#fff",
                    strokeWidth: 1,
                    strokeOpacity: 0.5
                }
            }
        },
        down: {
            ...$d77b025aa58d633c$var$stroke,
            stroke: $d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DOWN_STROKE,
            fill: $d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DOWN_FILL,
            fillOpacity: 0.2,
            handle: {
                ...$d77b025aa58d633c$var$handle,
                stroke: $d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DOWN_STROKE
            },
            statistics: {
                ...$d77b025aa58d633c$var$measurerStatistics,
                color: "#fff",
                fill: $d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DOWN_FILL,
                strokeWidth: 0,
                divider: {
                    stroke: "#fff",
                    strokeWidth: 1,
                    strokeOpacity: 0.5
                }
            }
        }
    },
    axesButtons: {
        enabled: true
    }
};
// packages/ag-charts-community/src/api/preset/priceVolumePreset.ts
var $d77b025aa58d633c$var$chartTypes3 = [
    "ohlc",
    "line",
    "step-line",
    "hlc",
    "high-low",
    "candlestick",
    "hollow-candlestick"
];
var $d77b025aa58d633c$var$toolbarButtons = [
    {
        icon: "trend-line-drawing",
        tooltip: "toolbarAnnotationsLineAnnotations",
        value: "line-menu"
    },
    {
        icon: "fibonacci-retracement-drawing",
        tooltip: "toolbarAnnotationsFibonacciAnnotations",
        value: "fibonacci-menu"
    },
    {
        icon: "text-annotation",
        tooltip: "toolbarAnnotationsTextAnnotations",
        value: "text-menu"
    },
    {
        icon: "arrow-drawing",
        tooltip: "toolbarAnnotationsShapeAnnotations",
        value: "shape-menu"
    },
    {
        icon: "measurer-drawing",
        tooltip: "toolbarAnnotationsMeasurerAnnotations",
        value: "measurer-menu"
    },
    {
        icon: "delete",
        tooltip: "toolbarAnnotationsClearAll",
        value: "clear"
    }
];
function $d77b025aa58d633c$var$priceVolume(opts, _presetTheme, getTheme) {
    const { dateKey: dateKey = "date", highKey: highKey = "high", openKey: openKey = "open", lowKey: lowKey = "low", closeKey: closeKey = "close", volumeKey: volumeKey = "volume", chartType: chartType = "candlestick", navigator: navigator = false, volume: volume = true, rangeButtons: rangeButtons = true, statusBar: statusBar = true, toolbar: toolbar = true, zoom: zoom = true, sync: sync = false, theme: theme, data: data, ...unusedOpts } = opts;
    const priceSeries = $d77b025aa58d633c$var$createPriceSeries(chartType, dateKey, highKey, lowKey, openKey, closeKey);
    const volumeSeries = $d77b025aa58d633c$var$createVolumeSeries(getTheme, openKey, closeKey, volume, volumeKey);
    const miniChart = volume ? {
        miniChart: {
            enabled: navigator,
            series: [
                {
                    type: "line",
                    xKey: dateKey,
                    yKey: volumeKey,
                    stroke: $d77b025aa58d633c$var$SAFE_STROKE_FILL_OPERATION,
                    marker: {
                        enabled: false
                    }
                }
            ]
        },
        height: 40,
        minHandle: {
            height: 46
        },
        maxHandle: {
            height: 46
        }
    } : null;
    const navigatorOpts = {
        navigator: {
            enabled: navigator,
            ...miniChart
        }
    };
    const annotationOpts = {
        annotations: {
            enabled: toolbar,
            optionsToolbar: {
                enabled: toolbar
            },
            // @ts-expect-error undocumented option
            snap: true,
            toolbar: {
                enabled: toolbar,
                buttons: $d77b025aa58d633c$var$toolbarButtons,
                padding: 0
            },
            data: data,
            xKey: dateKey,
            volumeKey: volume ? volumeKey : void 0
        }
    };
    const statusBarOpts = statusBar ? {
        statusBar: {
            enabled: true,
            data: data,
            highKey: highKey,
            openKey: openKey,
            lowKey: lowKey,
            closeKey: closeKey,
            volumeKey: volume ? volumeKey : void 0
        }
    } : null;
    const zoomOpts = {
        zoom: {
            enabled: zoom,
            autoScaling: {
                enabled: true
            },
            // @ts-expect-error undocumented option
            enableIndependentAxes: true
        }
    };
    const toolbarOpts = {
        ranges: {
            enabled: rangeButtons
        }
    };
    const syncGroup = sync ? {
        sync: {
            enabled: sync,
            nodeInteraction: true,
            zoom: true
        }
    } : null;
    const volumeAxis = volume ? [
        {
            type: "number",
            position: "left",
            keys: [
                volumeKey
            ],
            label: {
                enabled: false
            },
            crosshair: {
                enabled: false
            },
            gridLine: {
                enabled: false
            },
            nice: false,
            // @ts-expect-error undocumented option
            layoutConstraints: {
                stacked: false,
                width: 20,
                unit: "percent",
                align: "end"
            }
        }
    ] : [];
    return {
        theme: {
            baseTheme: typeof theme === "string" ? theme : "ag-financial",
            ...$d77b025aa58d633c$var$mergeDefaults(typeof theme === "object" ? theme : null, {
                overrides: {
                    common: {
                        title: {
                            padding: 4
                        },
                        padding: {
                            top: 6,
                            right: 8,
                            bottom: 5
                        },
                        chartToolbar: {
                            enabled: toolbar
                        },
                        annotations: {
                            ...$d77b025aa58d633c$var$annotationsTheme
                        },
                        axes: {
                            number: {
                                interval: {
                                    maxSpacing: 45
                                },
                                label: {
                                    format: ".2f"
                                }
                            }
                        }
                    },
                    bar: {
                        series: {
                            fillOpacity: 0.5
                        }
                    },
                    line: {
                        series: {
                            marker: {
                                enabled: false
                            },
                            ...$d77b025aa58d633c$var$inlineSwitch(chartType, {
                                hlc: {
                                    stroke: {
                                        $palette: "altNeutral.stroke"
                                    },
                                    strokeWidth: 2
                                },
                                line: {
                                    stroke: {
                                        $palette: "neutral.stroke"
                                    }
                                },
                                "step-line": {
                                    stroke: {
                                        $palette: "neutral.stroke"
                                    },
                                    interpolation: {
                                        type: "step"
                                    }
                                }
                            })
                        }
                    },
                    candlestick: {
                        series: {
                            ...$d77b025aa58d633c$var$inlineSwitch(chartType, {
                                "hollow-candlestick": {
                                    item: {
                                        up: {
                                            fill: "transparent"
                                        }
                                    }
                                }
                            })
                        }
                    },
                    "range-area": {
                        series: {
                            fillOpacity: 0.3,
                            strokeWidth: 2
                        }
                    }
                }
            })
        },
        animation: {
            enabled: false
        },
        legend: {
            enabled: false
        },
        series: [
            ...volumeSeries,
            ...priceSeries
        ],
        axes: [
            {
                type: "number",
                position: "right",
                keys: [
                    openKey,
                    closeKey,
                    highKey,
                    lowKey
                ],
                crosshair: {
                    enabled: true,
                    snap: false
                },
                // @ts-expect-error undocumented option
                layoutConstraints: {
                    stacked: false,
                    width: 100,
                    unit: "percent",
                    align: "start"
                }
            },
            ...volumeAxis,
            {
                type: "ordinal-time",
                position: "bottom",
                line: {
                    enabled: false
                },
                label: {
                    enabled: true
                },
                crosshair: {
                    enabled: true
                }
            }
        ],
        tooltip: {
            enabled: false
        },
        data: data,
        ...annotationOpts,
        ...navigatorOpts,
        ...statusBarOpts,
        ...zoomOpts,
        ...toolbarOpts,
        ...syncGroup,
        ...unusedOpts
    };
}
function $d77b025aa58d633c$var$createVolumeSeries(getTheme, openKey, closeKey, volume, volumeKey) {
    if (!volume) return [];
    return [
        {
            type: "bar",
            xKey: "date",
            yKey: volumeKey,
            tooltip: {
                enabled: false
            },
            itemStyler ({ datum: datum }) {
                const { up: up, down: down } = getTheme().palette;
                return {
                    fill: datum[openKey] < datum[closeKey] ? up?.fill : down?.fill
                };
            },
            // @ts-expect-error undocumented option
            focusPriority: 1,
            fastDataProcessing: true,
            highlight: {
                enabled: false
            }
        }
    ];
}
var $d77b025aa58d633c$var$RANGE_AREA_TYPE = "range-area";
function $d77b025aa58d633c$var$createPriceSeries(chartType, xKey, highKey, lowKey, openKey, closeKey) {
    const keys = {
        xKey: xKey,
        openKey: openKey,
        closeKey: closeKey,
        highKey: highKey,
        lowKey: lowKey
    };
    const singleKeys = {
        xKey: xKey,
        yKey: closeKey
    };
    const common = {
        pickOutsideVisibleMinorAxis: true
    };
    switch(chartType ?? "candlestick"){
        case "ohlc":
            return $d77b025aa58d633c$var$createPriceSeriesOHLC(common, keys);
        case "line":
        case "step-line":
            return $d77b025aa58d633c$var$createPriceSeriesLine(common, singleKeys);
        case "hlc":
            return $d77b025aa58d633c$var$createPriceSeriesHLC(common, singleKeys, keys);
        case "high-low":
            return $d77b025aa58d633c$var$createPriceSeriesHighLow(common, keys);
        case "candlestick":
        case "hollow-candlestick":
            return $d77b025aa58d633c$var$createPriceSeriesCandlestick(common, keys);
        default:
            (0, $idDdm.Logger).warnOnce(`unknown chart type: ${chartType}; expected one of: ${$d77b025aa58d633c$var$chartTypes3.join(", ")}`);
            return $d77b025aa58d633c$var$createPriceSeriesCandlestick(common, keys);
    }
}
function $d77b025aa58d633c$var$createPriceSeriesOHLC(common, keys) {
    return [
        {
            type: "ohlc",
            // @ts-expect-error undocumented option
            focusPriority: 0,
            ...common,
            ...keys
        }
    ];
}
function $d77b025aa58d633c$var$createPriceSeriesLine(common, singleKeys) {
    return [
        {
            type: "line",
            // @ts-expect-error undocumented option
            focusPriority: 0,
            ...common,
            ...singleKeys
        }
    ];
}
function $d77b025aa58d633c$var$createPriceSeriesHLC(common, singleKeys, { xKey: xKey, highKey: highKey, closeKey: closeKey, lowKey: lowKey }) {
    return [
        {
            type: $d77b025aa58d633c$var$RANGE_AREA_TYPE,
            // @ts-expect-error undocumented option
            focusPriority: 0,
            ...common,
            xKey: xKey,
            yHighKey: highKey,
            yLowKey: closeKey,
            fill: $d77b025aa58d633c$var$PALETTE_UP_FILL,
            stroke: $d77b025aa58d633c$var$PALETTE_UP_STROKE
        },
        {
            type: $d77b025aa58d633c$var$RANGE_AREA_TYPE,
            // @ts-expect-error undocumented option
            focusPriority: 0,
            ...common,
            xKey: xKey,
            yHighKey: closeKey,
            yLowKey: lowKey,
            fill: $d77b025aa58d633c$var$PALETTE_DOWN_FILL,
            stroke: $d77b025aa58d633c$var$PALETTE_DOWN_STROKE
        },
        {
            type: "line",
            ...common,
            ...singleKeys
        }
    ];
}
function $d77b025aa58d633c$var$createPriceSeriesHighLow(common, { xKey: xKey, highKey: highKey, lowKey: lowKey }) {
    return [
        {
            type: "range-bar",
            ...common,
            xKey: xKey,
            yHighKey: highKey,
            yLowKey: lowKey,
            fill: $d77b025aa58d633c$var$PALETTE_NEUTRAL_FILL,
            stroke: $d77b025aa58d633c$var$PALETTE_NEUTRAL_STROKE,
            tooltip: {
                range: "nearest"
            },
            // @ts-expect-error undocumented option
            focusPriority: 0,
            fastDataProcessing: true
        }
    ];
}
function $d77b025aa58d633c$var$createPriceSeriesCandlestick(common, keys) {
    return [
        {
            type: "candlestick",
            // @ts-expect-error undocumented option
            focusPriority: 0,
            ...common,
            ...keys
        }
    ];
}
function $d77b025aa58d633c$var$inlineSwitch(caseName, switchCases) {
    return switchCases[caseName] ?? switchCases.default;
}
// packages/ag-charts-community/src/api/preset/sparkline.ts
var $d77b025aa58d633c$var$commonAxisProperties = {
    title: {
        enabled: false
    },
    label: {
        enabled: false
    },
    line: {
        enabled: false
    },
    gridLine: {
        enabled: false
    },
    crosshair: {
        enabled: false,
        stroke: $d77b025aa58d633c$var$DEFAULT_SPARKLINE_CROSSHAIR_STROKE,
        lineDash: [
            0
        ],
        label: {
            enabled: false
        }
    }
};
var $d77b025aa58d633c$var$numericAxisProperties = {
    ...$d77b025aa58d633c$var$commonAxisProperties,
    nice: false
};
var $d77b025aa58d633c$var$chartTooltipDefaults = {
    mode: "compact",
    position: {
        anchorTo: "node",
        placement: [
            "right",
            "left"
        ]
    },
    showArrow: false
};
var $d77b025aa58d633c$var$barGridLineDefaults = {
    style: [
        {
            stroke: {
                $ref: "gridLineColor"
            }
        }
    ],
    width: 2
};
var $d77b025aa58d633c$var$barAxisDefaults = {
    number: {
        gridLine: $d77b025aa58d633c$var$barGridLineDefaults
    },
    time: {
        gridLine: $d77b025aa58d633c$var$barGridLineDefaults
    },
    category: {
        gridLine: $d77b025aa58d633c$var$barGridLineDefaults
    }
};
var $d77b025aa58d633c$var$SPARKLINE_THEME = {
    overrides: {
        common: {
            animation: {
                enabled: false
            },
            contextMenu: {
                enabled: false
            },
            keyboard: {
                enabled: false
            },
            background: {
                visible: false
            },
            navigator: {
                enabled: false
            },
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            axes: {
                number: {
                    ...$d77b025aa58d633c$var$numericAxisProperties,
                    interval: {
                        values: [
                            0
                        ]
                    }
                },
                log: {
                    ...$d77b025aa58d633c$var$numericAxisProperties
                },
                time: {
                    ...$d77b025aa58d633c$var$numericAxisProperties
                },
                category: {
                    ...$d77b025aa58d633c$var$commonAxisProperties
                }
            }
        },
        bar: {
            series: {
                crisp: false,
                label: {
                    placement: "inside-end",
                    padding: 4
                },
                // @ts-expect-error undocumented option
                sparklineMode: true
            },
            tooltip: {
                ...$d77b025aa58d633c$var$chartTooltipDefaults,
                position: {
                    ...$d77b025aa58d633c$var$chartTooltipDefaults.position,
                    anchorTo: "pointer"
                },
                range: "nearest"
            },
            axes: $d77b025aa58d633c$var$barAxisDefaults
        },
        line: {
            seriesArea: {
                padding: {
                    top: 2,
                    right: 2,
                    bottom: 2,
                    left: 2
                }
            },
            series: {
                // @ts-expect-error undocumented option
                sparklineMode: true,
                strokeWidth: 1,
                marker: {
                    enabled: false,
                    size: 3
                }
            },
            tooltip: $d77b025aa58d633c$var$chartTooltipDefaults
        },
        area: {
            seriesArea: {
                padding: {
                    top: 1,
                    right: 0,
                    bottom: 1,
                    left: 0
                }
            },
            series: {
                strokeWidth: 1,
                fillOpacity: 0.4
            },
            tooltip: $d77b025aa58d633c$var$chartTooltipDefaults
        }
    }
};
var $d77b025aa58d633c$var$setInitialBaseTheme = $d77b025aa58d633c$var$simpleMemorize($d77b025aa58d633c$var$createInitialBaseTheme);
function $d77b025aa58d633c$var$createInitialBaseTheme(baseTheme, initialBaseTheme) {
    if (typeof baseTheme === "string") return {
        ...initialBaseTheme,
        baseTheme: baseTheme
    };
    if (baseTheme != null) return {
        ...baseTheme,
        // @ts-expect-error internal implementation
        baseTheme: $d77b025aa58d633c$var$setInitialBaseTheme(baseTheme.baseTheme, initialBaseTheme)
    };
    return initialBaseTheme;
}
function $d77b025aa58d633c$var$sparklineDataPreset(data) {
    if (Array.isArray(data) && data.length !== 0) {
        const firstItem = data[0];
        if (typeof firstItem === "number") {
            const mappedData = data.map((y, x)=>({
                    x: x,
                    y: y
                }));
            return {
                data: mappedData,
                series: [
                    {
                        xKey: "x",
                        yKey: "y"
                    }
                ],
                datumKey: "y"
            };
        } else if (Array.isArray(firstItem)) {
            const mappedData = data.map((datum)=>({
                    x: datum[0],
                    y: datum[1],
                    datum: datum
                }));
            return {
                data: mappedData,
                series: [
                    {
                        xKey: "x",
                        yKey: "y"
                    }
                ],
                datumKey: "datum"
            };
        }
    }
    return {
        data: data
    };
}
function $d77b025aa58d633c$var$axisPreset(opts) {
    switch(opts?.type){
        case "number":
            {
                const { type: type, min: min, max: max, reverse: reverse2 } = opts;
                return $d77b025aa58d633c$var$pickProps(opts, {
                    type: type,
                    reverse: reverse2,
                    min: min,
                    max: max
                });
            }
        case "time":
            {
                const { type: type, min: min, max: max, reverse: reverse2 } = opts;
                return $d77b025aa58d633c$var$pickProps(opts, {
                    type: type,
                    reverse: reverse2,
                    min: min,
                    max: max
                });
            }
        case "category":
        default:
            const { paddingInner: paddingInner, paddingOuter: paddingOuter, reverse: reverse } = opts ?? {};
            return $d77b025aa58d633c$var$pickProps({
                ...opts,
                type: "category"
            }, {
                type: "category",
                reverse: reverse,
                paddingInner: paddingInner,
                paddingOuter: paddingOuter
            });
    }
}
function $d77b025aa58d633c$var$gridLinePreset(opts, defaultEnabled, sparkOpts) {
    const gridLineOpts = {};
    if (opts?.stroke != null) {
        gridLineOpts.style = [
            {
                stroke: opts?.stroke
            }
        ];
        gridLineOpts.enabled ?? (gridLineOpts.enabled = true);
    }
    if (opts?.strokeWidth != null) {
        gridLineOpts.width = opts?.strokeWidth;
        gridLineOpts.enabled ?? (gridLineOpts.enabled = true);
    }
    if (sparkOpts.type === "bar" && sparkOpts.direction !== "horizontal") gridLineOpts.enabled ?? (gridLineOpts.enabled = true);
    if (opts?.visible != null) gridLineOpts.enabled = opts.visible;
    gridLineOpts.enabled ?? (gridLineOpts.enabled = defaultEnabled);
    return gridLineOpts;
}
var $d77b025aa58d633c$var$tooltipRendererFn = $d77b025aa58d633c$var$simpleMemorize((context, tooltip, datumKey)=>{
    return (params)=>{
        const xValue = params.datum[params.xKey];
        const yValue = params.datum[params.yKey];
        const datum = datumKey != null ? params.datum[datumKey] : params.datum;
        const userContent = tooltip?.renderer?.({
            context: context,
            datum: datum,
            xValue: xValue,
            yValue: yValue
        });
        if (typeof userContent === "string") return userContent;
        const content = userContent?.content ?? yValue.toFixed(2);
        return userContent?.title ? {
            heading: void 0,
            title: void 0,
            data: [
                {
                    label: userContent.title,
                    value: content
                }
            ]
        } : {
            heading: void 0,
            title: content,
            data: []
        };
    };
});
function $d77b025aa58d633c$var$sparkline(opts) {
    const { background: background, container: container, height: height2, listeners: listeners, locale: locale, minHeight: minHeight, minWidth: minWidth, overrideDevicePixelRatio: overrideDevicePixelRatio, padding: padding, width: width2, theme: baseTheme, data: baseData, crosshair: crosshair, axis: axis, min: min, max: max, tooltip: tooltip, context: context, styleNonce: styleNonce, ...optsRest } = opts;
    const chartOpts = $d77b025aa58d633c$var$pickProps(opts, {
        background: background,
        container: container,
        height: height2,
        listeners: listeners,
        locale: locale,
        minHeight: minHeight,
        minWidth: minWidth,
        overrideDevicePixelRatio: overrideDevicePixelRatio,
        padding: padding,
        width: width2,
        styleNonce: styleNonce,
        tooltip: $d77b025aa58d633c$var$IGNORED_PROP,
        context: $d77b025aa58d633c$var$IGNORED_PROP,
        data: $d77b025aa58d633c$var$IGNORED_PROP,
        crosshair: $d77b025aa58d633c$var$IGNORED_PROP,
        axis: $d77b025aa58d633c$var$IGNORED_PROP,
        min: $d77b025aa58d633c$var$IGNORED_PROP,
        max: $d77b025aa58d633c$var$IGNORED_PROP,
        theme: $d77b025aa58d633c$var$IGNORED_PROP
    });
    const { data: data, series: [seriesOverrides] = [], datumKey: datumKey } = $d77b025aa58d633c$var$sparklineDataPreset(baseData);
    const seriesOptions = optsRest;
    if (seriesOverrides != null) Object.assign(seriesOptions, seriesOverrides);
    seriesOptions.tooltip = {
        ...tooltip,
        renderer: $d77b025aa58d633c$var$tooltipRendererFn(context, tooltip, datumKey)
    };
    chartOpts.theme = $d77b025aa58d633c$var$setInitialBaseTheme(baseTheme, $d77b025aa58d633c$var$SPARKLINE_THEME);
    chartOpts.data = data;
    chartOpts.series = [
        seriesOptions
    ];
    const swapAxes = seriesOptions.type !== "bar" || seriesOptions.direction !== "horizontal";
    const [xAxisPosition, yAxisPosition] = swapAxes ? [
        "bottom",
        "left"
    ] : [
        "left",
        "bottom"
    ];
    const xAxis = {
        ...$d77b025aa58d633c$var$axisPreset(axis),
        position: xAxisPosition,
        ...$d77b025aa58d633c$var$pickProps(opts, {
            crosshair: crosshair
        })
    };
    const yAxis = {
        type: "number",
        gridLine: $d77b025aa58d633c$var$gridLinePreset(axis, false, opts),
        position: yAxisPosition,
        ...$d77b025aa58d633c$var$pickProps(opts, {
            min: min,
            max: max
        })
    };
    chartOpts.axes = swapAxes ? [
        yAxis,
        xAxis
    ] : [
        xAxis,
        yAxis
    ];
    return chartOpts;
}
// packages/ag-charts-community/src/api/preset/presetModules.ts
var $d77b025aa58d633c$var$priceVolumeOptionsDef = {
    chartType: (0, $idDdm.union)("candlestick", "hollow-candlestick", "ohlc", "line", "step-line", "hlc", "high-low"),
    dateKey: (0, $idDdm.string),
    openKey: (0, $idDdm.string),
    highKey: (0, $idDdm.string),
    lowKey: (0, $idDdm.string),
    closeKey: (0, $idDdm.string),
    volumeKey: (0, $idDdm.string),
    navigator: (0, $idDdm.boolean),
    volume: (0, $idDdm.boolean),
    rangeButtons: (0, $idDdm.boolean),
    statusBar: (0, $idDdm.boolean),
    toolbar: (0, $idDdm.boolean),
    zoom: (0, $idDdm.boolean),
    sync: (0, $idDdm.boolean),
    // Valid pass-through options
    theme: (0, $idDdm.defined),
    container: (0, $idDdm.defined),
    width: (0, $idDdm.defined),
    height: (0, $idDdm.defined),
    minWidth: (0, $idDdm.defined),
    minHeight: (0, $idDdm.defined),
    listeners: (0, $idDdm.defined),
    initialState: (0, $idDdm.defined),
    title: (0, $idDdm.defined),
    data: (0, $idDdm.array)
};
var $d77b025aa58d633c$var$commonGaugeOptions = {
    // Valid pass-through options
    theme: (0, $idDdm.defined),
    container: (0, $idDdm.defined),
    animation: (0, $idDdm.defined),
    background: (0, $idDdm.defined),
    contextMenu: (0, $idDdm.defined),
    listeners: (0, $idDdm.defined),
    locale: (0, $idDdm.defined),
    width: (0, $idDdm.defined),
    height: (0, $idDdm.defined),
    minWidth: (0, $idDdm.defined),
    minHeight: (0, $idDdm.defined),
    title: (0, $idDdm.defined),
    subtitle: (0, $idDdm.defined),
    footnote: (0, $idDdm.defined),
    padding: (0, $idDdm.defined),
    tooltip: {
        ...$d77b025aa58d633c$var$tooltipOptionsDefs,
        ...$d77b025aa58d633c$var$commonChartOptionsDefs.tooltip
    }
};
$d77b025aa58d633c$var$commonGaugeOptions.overrideDevicePixelRatio = (0, $idDdm.undocumented)((0, $idDdm.positiveNumber));
var $d77b025aa58d633c$var$commonSparklineOmit = [
    "showInLegend",
    "showInMiniChart",
    "grouped",
    "stacked",
    "stackGroup",
    "tooltip",
    "listeners",
    "errorBar",
    "xKey",
    "yKey",
    "type"
];
var $d77b025aa58d633c$var$commonSparklineAxisOptionsDef = {
    visible: (0, $idDdm.boolean),
    reverse: (0, $idDdm.boolean),
    stroke: (0, $idDdm.color),
    strokeWidth: (0, $idDdm.positiveNumber)
};
var $d77b025aa58d633c$var$commonSparklineOptionsDef = {
    context: (0, $idDdm.defined),
    tooltip: (0, $idDdm.defined),
    theme: (0, $idDdm.defined),
    background: (0, $idDdm.defined),
    container: (0, $idDdm.defined),
    width: (0, $idDdm.defined),
    height: (0, $idDdm.defined),
    minWidth: (0, $idDdm.defined),
    minHeight: (0, $idDdm.defined),
    padding: (0, $idDdm.defined),
    listeners: (0, $idDdm.defined),
    locale: (0, $idDdm.defined),
    data: (0, $idDdm.defined),
    styleNonce: (0, $idDdm.string),
    axis: (0, $idDdm.typeUnion)({
        number: {
            ...$d77b025aa58d633c$var$commonSparklineAxisOptionsDef,
            min: (0, $idDdm.and)((0, $idDdm.number), (0, $idDdm.lessThan)("max")),
            max: (0, $idDdm.and)((0, $idDdm.number), (0, $idDdm.greaterThan)("min"))
        },
        category: {
            ...$d77b025aa58d633c$var$commonSparklineAxisOptionsDef,
            paddingInner: (0, $idDdm.ratio),
            paddingOuter: (0, $idDdm.ratio)
        },
        time: {
            ...$d77b025aa58d633c$var$commonSparklineAxisOptionsDef,
            min: (0, $idDdm.and)((0, $idDdm.or)((0, $idDdm.number), (0, $idDdm.date)), (0, $idDdm.lessThan)("max")),
            max: (0, $idDdm.and)((0, $idDdm.or)((0, $idDdm.number), (0, $idDdm.date)), (0, $idDdm.greaterThan)("min"))
        }
    }, "axis options", "category"),
    min: (0, $idDdm.and)((0, $idDdm.number), (0, $idDdm.lessThan)("max")),
    max: (0, $idDdm.and)((0, $idDdm.number), (0, $idDdm.greaterThan)("min")),
    crosshair: {
        enabled: (0, $idDdm.boolean),
        snap: (0, $idDdm.boolean),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    },
    xKey: (0, $idDdm.string),
    yKey: (0, $idDdm.string)
};
var $d77b025aa58d633c$var$PriceVolumePresetModule = {
    type: "preset",
    name: "price-volume",
    enterprise: true,
    options: $d77b025aa58d633c$var$priceVolumeOptionsDef,
    create: $d77b025aa58d633c$var$priceVolume
};
var $d77b025aa58d633c$var$GaugePresetModule = {
    type: "preset",
    name: "gauge-preset",
    enterprise: true,
    options: (0, $idDdm.typeUnion)({
        "linear-gauge": {
            ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$linearGaugeSeriesOptionsDef, [
                "type"
            ]),
            ...$d77b025aa58d633c$var$commonGaugeOptions
        },
        "radial-gauge": {
            ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$radialGaugeSeriesOptionsDef, [
                "type"
            ]),
            ...$d77b025aa58d633c$var$commonGaugeOptions
        }
    }, "gauge options"),
    create: $d77b025aa58d633c$var$gauge
};
var $d77b025aa58d633c$var$SparklinePresetModule = {
    type: "preset",
    name: "sparkline",
    options: (0, $idDdm.typeUnion)({
        area: {
            ...$d77b025aa58d633c$var$commonSparklineOptionsDef,
            ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$areaSeriesOptionsDef, $d77b025aa58d633c$var$commonSparklineOmit)
        },
        bar: {
            ...$d77b025aa58d633c$var$commonSparklineOptionsDef,
            ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$barSeriesOptionsDef, $d77b025aa58d633c$var$commonSparklineOmit)
        },
        line: {
            ...$d77b025aa58d633c$var$commonSparklineOptionsDef,
            ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$lineSeriesOptionsDef, $d77b025aa58d633c$var$commonSparklineOmit)
        }
    }, "sparkline options"),
    create: $d77b025aa58d633c$var$sparkline,
    processData: $d77b025aa58d633c$var$sparklineDataPreset
};
var $d77b025aa58d633c$var$directions = [
    "top",
    "right",
    "bottom",
    "left"
];
var $d77b025aa58d633c$var$_CartesianChart = class _CartesianChart extends $d77b025aa58d633c$var$Chart {
    constructor(options, resources){
        super(options, resources);
        // TODO should come from theme
        /** Integrated Charts feature state - not used in Standalone Charts. */ this.paired = true;
        this.lastUpdateClipRect = void 0;
        this.lastLayoutWidth = NaN;
        this.lastLayoutHeight = NaN;
    }
    onAxisChange(newValue, oldValue) {
        super.onAxisChange(newValue, oldValue);
        this.syncAxisChanges(newValue, oldValue);
        if (this.ctx != null) this.ctx.zoomManager.updateAxes(newValue);
    }
    destroySeries(series) {
        super.destroySeries(series);
        this.lastLayoutWidth = NaN;
        this.lastLayoutHeight = NaN;
    }
    getChartType() {
        return "cartesian";
    }
    setRootClipRects(clipRect) {
        const { seriesRoot: seriesRoot, annotationRoot: annotationRoot } = this;
        seriesRoot.setClipRect(clipRect);
        annotationRoot.setClipRect(clipRect);
    }
    async processData() {
        await super.processData();
        if (this.syncStatus === "init") this.syncStatus = "domains-calculated";
        this.ctx.updateService.dispatchProcessData({
            series: {
                shouldFlipXY: this.shouldFlipXY()
            }
        });
    }
    async processDomains() {
        await super.processDomains();
        for (const axis of this.axes){
            const syncedDomain = await this.getSyncedDomain(axis);
            if (syncedDomain != null) axis.setDomains(syncedDomain);
        }
    }
    performLayout(ctx) {
        const { seriesRoot: seriesRoot, annotationRoot: annotationRoot } = this;
        const { clipSeries: clipSeries, seriesRect: seriesRect, visible: visible } = this.updateAxes(ctx.layoutBox);
        this.seriesRoot.visible = visible;
        this.seriesRect = seriesRect;
        this.animationRect = ctx.layoutBox;
        const { x: x, y: y } = seriesRect;
        if (ctx.width !== this.lastLayoutWidth || ctx.height !== this.lastLayoutHeight) for (const group of [
            seriesRoot,
            annotationRoot
        ]){
            group.translationX = Math.floor(x);
            group.translationY = Math.floor(y);
        }
        else {
            const { translationX: translationX, translationY: translationY } = seriesRoot;
            $d77b025aa58d633c$var$staticFromToMotion(this.id, "seriesRect", this.ctx.animationManager, [
                seriesRoot,
                annotationRoot
            ], {
                translationX: translationX,
                translationY: translationY
            }, {
                translationX: Math.floor(x),
                translationY: Math.floor(y)
            }, {
                phase: "update"
            });
        }
        this.lastLayoutWidth = ctx.width;
        this.lastLayoutHeight = ctx.height;
        const seriesPaddedRect = seriesRect.clone().grow(this.seriesArea.padding);
        const clipRect = this.seriesArea.clip || clipSeries ? seriesPaddedRect : void 0;
        const { lastUpdateClipRect: lastUpdateClipRect } = this;
        this.lastUpdateClipRect = clipRect;
        if (this.ctx.animationManager.isActive() && lastUpdateClipRect != null) this.ctx.animationManager.animate({
            id: this.id,
            groupId: "clip-rect",
            phase: "update",
            from: lastUpdateClipRect,
            to: seriesPaddedRect,
            onUpdate: (interpolatedClipRect)=>this.setRootClipRects(interpolatedClipRect),
            onComplete: ()=>this.setRootClipRects(clipRect)
        });
        else this.setRootClipRects(clipRect);
        this.ctx.layoutManager.emitLayoutComplete(ctx, {
            axes: this.axes.map((axis)=>axis.getLayoutState()),
            series: {
                visible: visible,
                rect: seriesRect,
                paddedRect: seriesPaddedRect
            },
            clipSeries: clipSeries
        });
    }
    updateAxes(layoutBox) {
        const { clipSeries: clipSeries, seriesRect: seriesRect, overflows: overflows } = this.resolveAxesLayout(layoutBox);
        for (const axis of this.axes){
            axis.update();
            axis.setCrossLinesVisible(!overflows);
            this.clipAxis(axis, seriesRect, layoutBox);
        }
        return {
            clipSeries: clipSeries,
            seriesRect: seriesRect,
            visible: !overflows
        };
    }
    // Iteratively try to resolve axis widths - since X axis width affects Y axis range,
    // and vice-versa, we need to iteratively try and find a fit for the axes and their
    // ticks/labels.
    resolveAxesLayout(layoutBox) {
        let newState;
        let prevState;
        let iterations = 0;
        const maxIterations = 10;
        do {
            prevState = newState ?? this.getDefaultState();
            newState = this.updateAxesPass(new Map(prevState.axisAreaWidths), layoutBox.clone());
            if (iterations++ > maxIterations) {
                (0, $idDdm.Logger).warn("Max iterations reached. Unable to stabilize axes layout.");
                break;
            }
        }while (!this.isLayoutStable(newState, prevState));
        this.lastAreaWidths = newState.axisAreaWidths;
        return newState;
    }
    updateAxesPass(axisAreaWidths, axisAreaBound) {
        const axisWidths = /* @__PURE__ */ new Map();
        const primaryTickCounts = {};
        let overflows = false;
        let clipSeries = false;
        for (const dir of $d77b025aa58d633c$var$directions){
            const padding = this.seriesArea.padding[dir];
            const axis = this.axes.findLast((a)=>a.position === dir);
            if (axis) axis.seriesAreaPadding = padding;
            else axisAreaBound.shrink(padding, dir);
        }
        const totalWidth = (axisAreaWidths.get("left") ?? 0) + (axisAreaWidths.get("right") ?? 0);
        const totalHeight = (axisAreaWidths.get("top") ?? 0) + (axisAreaWidths.get("bottom") ?? 0);
        const crossLinePadding = this.buildCrossLinePadding(axisAreaWidths);
        const crossLineHPadding = crossLinePadding.left + crossLinePadding.right;
        const crossLineVPadding = crossLinePadding.top + crossLinePadding.bottom;
        if (axisAreaBound.width <= totalWidth + crossLineHPadding || axisAreaBound.height <= totalHeight + crossLineVPadding) overflows = true;
        else axisAreaBound.shrink(crossLinePadding);
        const seriesRect = axisAreaBound.clone().shrink(Object.fromEntries(axisAreaWidths));
        for (const axis of this.axes){
            const { position: position = "left", direction: direction } = axis;
            this.sizeAxis(axis, seriesRect, position);
            const isVertical = direction === "y" /* Y */ ;
            const { primaryTickCount: primaryTickCount, bbox: bbox } = axis.calculateLayout(axis.nice ? primaryTickCounts[direction] : void 0, this.padding);
            primaryTickCounts[direction] ?? (primaryTickCounts[direction] = primaryTickCount);
            clipSeries || (clipSeries = axis.dataDomain.clipped || axis.visibleRange[0] > 0 || axis.visibleRange[1] < 1);
            axisWidths.set(axis.id, Math.ceil(axis.thickness ?? (isVertical ? bbox?.width : bbox?.height) ?? 0));
        }
        const axisGroups = (0, $idDdm.groupBy)(this.axes, (axis)=>axis.position ?? "left");
        const { width: width2, height: height2, pixelRatio: pixelRatio } = this.ctx.scene;
        const newAxisAreaWidths = /* @__PURE__ */ new Map();
        const axisOffsets = /* @__PURE__ */ new Map();
        for (const [position, axes] of (0, $idDdm.entries)(axisGroups)){
            const isVertical = position === "left" || position === "right";
            let currentOffset = isVertical ? height2 % pixelRatio : width2 % pixelRatio;
            let totalAxisWidth = 0;
            for (const axis of axes ?? []){
                axisOffsets.set(axis.id, currentOffset);
                const axisThickness = axisWidths.get(axis.id) ?? 0;
                totalAxisWidth = Math.max(totalAxisWidth, currentOffset + axisThickness);
                if (axis.layoutConstraints.stacked) currentOffset += axisThickness + _CartesianChart.AxesPadding;
            }
            newAxisAreaWidths.set(position, Math.ceil(totalAxisWidth));
        }
        for (const [position, axes] of (0, $idDdm.entries)(axisGroups))this.positionAxes({
            axes: axes ?? [],
            position: position,
            axisWidths: axisWidths,
            axisOffsets: axisOffsets,
            axisAreaWidths: newAxisAreaWidths,
            axisBound: axisAreaBound,
            seriesRect: seriesRect
        });
        return {
            clipSeries: clipSeries,
            seriesRect: seriesRect,
            axisAreaWidths: newAxisAreaWidths,
            overflows: overflows
        };
    }
    buildCrossLinePadding(axisAreaSize) {
        const crossLinePadding = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
        this.axes.forEach((axis)=>{
            const { position: position, label: label } = axis;
            axis.crossLines?.forEach((crossLine)=>{
                var _a;
                if (crossLine instanceof $d77b025aa58d633c$var$CartesianCrossLine) {
                    crossLine.position = position ?? "top";
                    (_a = crossLine.label).parallel ?? (_a.parallel = label.parallel);
                }
                crossLine.calculatePadding?.(crossLinePadding);
            });
        });
        for (const [side, padding = 0] of (0, $idDdm.entries)(crossLinePadding))crossLinePadding[side] = Math.max(padding - (axisAreaSize.get(side) ?? 0), 0);
        return crossLinePadding;
    }
    clampToOutsideSeriesRect(seriesRect, value, dimension, direction) {
        const bound = dimension === "x" ? seriesRect.x : seriesRect.y;
        const size = dimension === "x" ? seriesRect.width : seriesRect.height;
        return direction === 1 ? Math.min(value, bound + size) : Math.max(value, bound);
    }
    async getSyncedDomain(axis) {
        const syncModule = this.modulesManager.getModule("sync");
        if (!syncModule?.enabled) return;
        return await syncModule.getSyncedDomain(axis);
    }
    syncAxisChanges(newValue, oldValue) {
        const syncModule = this.modulesManager.getModule("sync");
        if (!syncModule?.enabled) return;
        const removed = new Set(oldValue ?? []);
        for (const axis of newValue)removed.delete(axis);
        for (const removedAxis of removed)syncModule.removeAxis(removedAxis);
    }
    sizeAxis(axis, seriesRect, position) {
        const isCategory = axis instanceof $d77b025aa58d633c$var$CategoryAxis;
        const isLeftRight = position === "left" || position === "right";
        const { width: width2, height: height2 } = seriesRect;
        const maxEnd = isLeftRight ? height2 : width2;
        let start2 = 0;
        let end2 = maxEnd;
        let { min: min, max: max } = this.ctx.zoomManager.getAxisZoom(axis.id);
        const { width: axisWidth, unit: unit, align: align2 } = axis.layoutConstraints;
        if (unit === "px") end2 = start2 + axisWidth;
        else end2 = end2 * axisWidth / 100;
        if (align2 === "end") {
            start2 = maxEnd - (end2 - start2);
            end2 = maxEnd;
        }
        if (isLeftRight) {
            if (isCategory) [min, max] = [
                1 - max,
                1 - min
            ];
            else [start2, end2] = [
                end2,
                start2
            ];
        }
        axis.range = [
            start2,
            end2
        ];
        axis.visibleRange = [
            min,
            max
        ];
        axis.gridLength = isLeftRight ? width2 : height2;
    }
    positionAxes(opts) {
        const { axes: axes, axisBound: axisBound, axisWidths: axisWidths, axisOffsets: axisOffsets, axisAreaWidths: axisAreaWidths, seriesRect: seriesRect, position: position } = opts;
        const axisAreaWidth = axisAreaWidths.get(position) ?? 0;
        let mainDimension = "x";
        let minorDimension = "y";
        let direction = 1;
        if (position === "top" || position === "bottom") {
            mainDimension = "y";
            minorDimension = "x";
        }
        let axisBoundMainOffset = axisBound[mainDimension];
        if (position === "right" || position === "bottom") {
            direction = -1;
            axisBoundMainOffset += mainDimension === "x" ? axisBound.width : axisBound.height;
        }
        for (const axis of axes){
            const minorOffset = axisAreaWidths.get(minorDimension === "x" ? "left" : "top") ?? 0;
            const axisThickness = axisWidths.get(axis.id) ?? 0;
            const axisOffset = axisOffsets.get(axis.id) ?? 0;
            axis.gridPadding = axisAreaWidth - axisOffset - axisThickness;
            axis.translation[minorDimension] = axisBound[minorDimension] + minorOffset;
            axis.translation[mainDimension] = this.clampToOutsideSeriesRect(seriesRect, axisBoundMainOffset + direction * (axisOffset + axisThickness), mainDimension, direction);
        }
    }
    shouldFlipXY() {
        return this.series.every((series)=>series instanceof $d77b025aa58d633c$var$CartesianSeries && series.shouldFlipXY());
    }
    getDefaultState() {
        const axisAreaWidths = /* @__PURE__ */ new Map();
        if (this.lastAreaWidths) for (const { position: position = "left" } of this.axes){
            const areaWidth = this.lastAreaWidths.get(position);
            if (areaWidth != null) axisAreaWidths.set(position, areaWidth);
        }
        return {
            axisAreaWidths: axisAreaWidths,
            clipSeries: false,
            overflows: false
        };
    }
    isLayoutStable(newState, prevState) {
        if (prevState.overflows !== newState.overflows || prevState.clipSeries !== newState.clipSeries) return false;
        for (const key of newState.axisAreaWidths.keys()){
            if (!prevState.axisAreaWidths.has(key)) return false;
        }
        for (const [p, w] of prevState.axisAreaWidths.entries()){
            const otherW = newState.axisAreaWidths.get(p);
            if ((w != null || otherW != null) && w !== otherW) return false;
        }
        return true;
    }
    clipAxis(axis, seriesRect, layoutBBox) {
        const gridLinePadding = Math.ceil(axis.gridLine?.width ?? 0);
        const axisLinePadding = Math.ceil(axis.line?.width ?? 0);
        let { width: width2, height: height2 } = seriesRect;
        width2 += axis.direction === "x" /* X */  ? gridLinePadding : axisLinePadding;
        height2 += axis.direction === "y" /* Y */  ? gridLinePadding : axisLinePadding;
        axis.clipGrid(seriesRect.x, seriesRect.y, width2, height2);
        switch(axis.position){
            case "left":
            case "right":
                axis.clipTickLines(layoutBBox.x, seriesRect.y - gridLinePadding, layoutBBox.width + gridLinePadding, seriesRect.height + gridLinePadding * 2);
                break;
            case "top":
            case "bottom":
                axis.clipTickLines(seriesRect.x - gridLinePadding, layoutBBox.y, seriesRect.width + gridLinePadding * 2, layoutBBox.height + gridLinePadding);
                break;
        }
    }
};
$d77b025aa58d633c$var$_CartesianChart.className = "CartesianChart";
$d77b025aa58d633c$var$_CartesianChart.type = "cartesian";
$d77b025aa58d633c$var$_CartesianChart.AxesPadding = 15;
var $d77b025aa58d633c$var$CartesianChart = $d77b025aa58d633c$var$_CartesianChart;
var $d77b025aa58d633c$var$commonChartOptions = {
    mode: (0, $idDdm.undocumented)((0, $idDdm.union)("integrated", "standalone")),
    container: (0, $idDdm.htmlElement),
    theme: (0, $idDdm.defined),
    series: (0, $idDdm.array),
    annotations: (0, $idDdm.defined),
    navigator: (0, $idDdm.defined),
    initialState: {
        chartType: (0, $idDdm.string),
        annotations: (0, $idDdm.defined),
        legend: (0, $idDdm.arrayOfDefs)({
            visible: (0, $idDdm.boolean),
            seriesId: (0, $idDdm.string),
            itemId: (0, $idDdm.string),
            legendItemName: (0, $idDdm.string)
        }, "legend state array"),
        zoom: (0, $idDdm.defined)
    }
};
var $d77b025aa58d633c$var$cartesianChartOptionsDefs = {
    ...$d77b025aa58d633c$var$commonChartOptionsDefs,
    ...$d77b025aa58d633c$var$commonChartOptions,
    axes: (0, $idDdm.defined),
    data: (0, $idDdm.array)
};
var $d77b025aa58d633c$var$polarChartOptionsDefs = {
    ...$d77b025aa58d633c$var$commonChartOptionsDefs,
    ...$d77b025aa58d633c$var$commonChartOptions,
    axes: (0, $idDdm.defined),
    data: (0, $idDdm.array)
};
var $d77b025aa58d633c$var$topologyChartOptionsDefs = {
    ...$d77b025aa58d633c$var$commonChartOptionsDefs,
    ...$d77b025aa58d633c$var$commonChartOptions,
    data: (0, $idDdm.array),
    topology: (0, $idDdm.geoJson)
};
var $d77b025aa58d633c$var$standaloneChartOptionsDefs = {
    ...$d77b025aa58d633c$var$commonChartOptionsDefs,
    ...$d77b025aa58d633c$var$commonChartOptions,
    data: (0, $idDdm.array)
};
var $d77b025aa58d633c$var$hierarchyChartOptionsDefs = {
    ...$d77b025aa58d633c$var$commonChartOptionsDefs,
    ...$d77b025aa58d633c$var$commonChartOptions,
    data: (0, $idDdm.array)
};
var $d77b025aa58d633c$var$flowProportionChartOptionsDefs = {
    ...$d77b025aa58d633c$var$commonChartOptionsDefs,
    ...$d77b025aa58d633c$var$commonChartOptions,
    data: (0, $idDdm.array),
    nodes: (0, $idDdm.array)
};
var $d77b025aa58d633c$var$gaugeChartOptionsDefs = {
    ...$d77b025aa58d633c$var$commonChartOptionsDefs,
    ...$d77b025aa58d633c$var$commonChartOptions,
    data: (0, $idDdm.array)
};
// packages/ag-charts-community/src/chart/cartesianChartModule.ts
var $d77b025aa58d633c$var$histogramAxisTypes = /* @__PURE__ */ new Set([
    "number",
    "log",
    "time"
]);
var $d77b025aa58d633c$var$validHistogramAxis = (axis)=>(0, $idDdm.isObject)(axis) && !$d77b025aa58d633c$var$histogramAxisTypes.has(axis.type);
var $d77b025aa58d633c$var$CartesianChartModule = {
    type: "chart",
    name: "cartesian",
    options: $d77b025aa58d633c$var$cartesianChartOptionsDefs,
    detect: $d77b025aa58d633c$var$isAgCartesianChartOptions,
    create (options, resources) {
        return new $d77b025aa58d633c$var$CartesianChart(options, resources);
    },
    validate (options, optionsDefs6, path) {
        const additionalErrors = [];
        if (options?.series?.[0]?.type === "histogram") {
            if (options?.axes?.some($d77b025aa58d633c$var$validHistogramAxis)) {
                additionalErrors.push(new (0, $idDdm.ValidationError)("invalid", "only continuous axis types when histogram series is used", options.axes, path, "axes"));
                options = $d77b025aa58d633c$var$without(options, [
                    "axes"
                ]);
            }
        }
        const result = (0, $idDdm.validate)(options, optionsDefs6, path);
        result.invalid.push(...additionalErrors);
        return result;
    }
};
var $d77b025aa58d633c$var$placeholderCreate = ()=>{
    throw new Error("Enterprise module placeholder cannot be initialised");
};
var $d77b025aa58d633c$var$FlowProportionChartModule = {
    type: "chart",
    name: "flow-proportion",
    placeholder: true,
    options: {},
    detect: $d77b025aa58d633c$var$isAgFlowProportionChartOptions,
    create: $d77b025aa58d633c$var$placeholderCreate
};
var $d77b025aa58d633c$var$GaugeChartModule = {
    type: "chart",
    name: "gauge",
    placeholder: true,
    options: {},
    detect: $d77b025aa58d633c$var$isAgGaugeChartOptions,
    create: $d77b025aa58d633c$var$placeholderCreate
};
var $d77b025aa58d633c$var$HierarchyChartModule = {
    type: "chart",
    name: "hierarchy",
    placeholder: true,
    options: {},
    detect: $d77b025aa58d633c$var$isAgHierarchyChartOptions,
    create: $d77b025aa58d633c$var$placeholderCreate
};
var $d77b025aa58d633c$var$StandaloneChartModule = {
    type: "chart",
    name: "standalone",
    placeholder: true,
    options: {},
    detect: $d77b025aa58d633c$var$isAgStandaloneChartOptions,
    create: $d77b025aa58d633c$var$placeholderCreate
};
var $d77b025aa58d633c$var$TopologyChartModule = {
    type: "chart",
    name: "topology",
    placeholder: true,
    options: {},
    detect: $d77b025aa58d633c$var$isAgTopologyChartOptions,
    create: $d77b025aa58d633c$var$placeholderCreate
};
// packages/ag-charts-community/src/chart/axis/polarAxis.ts
var $d77b025aa58d633c$var$PolarAxis = class extends $d77b025aa58d633c$var$Axis {
    constructor(){
        super(...arguments);
        this.shape = "polygon";
        this.innerRadiusRatio = 0;
        this.defaultTickMinSpacing = 20;
    }
    layoutCrossLines() {
        const sideFlag = this.label.getSideFlag();
        const anySeriesActive = this.isAnySeriesActive();
        const { rotation: rotation, parallelFlipRotation: parallelFlipRotation, regularFlipRotation: regularFlipRotation } = this.calculateRotations();
        this.crossLines.forEach((crossLine)=>{
            crossLine.sideFlag = -sideFlag;
            crossLine.direction = rotation === -Math.PI / 2 ? "angle" /* Angle */  : "radius" /* Radius */ ;
            crossLine.parallelFlipRotation = parallelFlipRotation;
            crossLine.regularFlipRotation = regularFlipRotation;
            crossLine.calculateLayout?.(anySeriesActive, this.reverse);
        });
    }
    updatePosition() {
        super.updatePosition();
        const translationX = Math.floor(this.translation.x);
        const translationY = Math.floor(this.translation.y);
        this.tickLineGroup.translationX = translationX;
        this.tickLineGroup.translationY = translationY;
        this.tickLabelGroup.translationX = translationX;
        this.tickLabelGroup.translationY = translationY;
        this.crossLineRangeGroup.translationX = translationX;
        this.crossLineRangeGroup.translationY = translationY;
        this.crossLineLineGroup.translationX = translationX;
        this.crossLineLineGroup.translationY = translationY;
        this.crossLineLabelGroup.translationX = translationX;
        this.crossLineLabelGroup.translationY = translationY;
        this.tickLabelGroupSelection.each($d77b025aa58d633c$var$resetAxisLabelSelectionFn());
    }
    computeLabelsBBox(_options, _seriesRect) {
        return null;
    }
    computeRange() {}
    getAxisLinePoints() {
        return void 0;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PolarAxis.prototype, "shape", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$PolarAxis.prototype, "innerRadiusRatio", 2);
// packages/ag-charts-community/src/chart/polarChart.ts
var $d77b025aa58d633c$var$PolarChart = class extends $d77b025aa58d633c$var$Chart {
    constructor(options, resources){
        super(options, resources);
        this.padding = new $d77b025aa58d633c$var$Padding(40);
        this.ctx.axisManager.axisGroup.zIndex = 6 /* AXIS_FOREGROUND */ ;
    }
    getChartType() {
        return "polar";
    }
    async performLayout(ctx) {
        const { layoutBox: layoutBox } = ctx;
        layoutBox.shrink(this.seriesArea.padding.toJson());
        const seriesRect = layoutBox.clone();
        this.seriesRect = seriesRect;
        this.animationRect = seriesRect;
        this.seriesRoot.translationX = seriesRect.x;
        this.seriesRoot.translationY = seriesRect.y;
        await this.computeCircle(seriesRect);
        this.axes.forEach((axis)=>axis.update());
        this.ctx.layoutManager.emitLayoutComplete(ctx, {
            series: {
                visible: true,
                rect: seriesRect,
                paddedRect: seriesRect
            }
        });
    }
    updateAxes(seriesBox, cx, cy, radius) {
        const angleAxis = this.axes.find((axis)=>axis.direction === "angle" /* Angle */ );
        const radiusAxis = this.axes.find((axis)=>axis.direction === "radius" /* Radius */ );
        if (!(angleAxis instanceof $d77b025aa58d633c$var$PolarAxis) || !(radiusAxis instanceof $d77b025aa58d633c$var$PolarAxis)) return;
        const angleScale = angleAxis.scale;
        const innerRadiusRatio = radiusAxis.innerRadiusRatio;
        angleAxis.innerRadiusRatio = innerRadiusRatio;
        angleAxis.computeRange();
        angleAxis.gridLength = radius;
        radiusAxis.gridAngles = angleScale.ticks({
            nice: angleAxis.nice,
            interval: void 0,
            tickCount: void 0,
            minTickCount: 0,
            maxTickCount: Infinity
        })?.ticks?.map((value)=>angleScale.convert(value));
        radiusAxis.gridRange = angleAxis.range;
        radiusAxis.range = [
            radius,
            radius * innerRadiusRatio
        ];
        [
            angleAxis,
            radiusAxis
        ].forEach((axis)=>{
            axis.translation.x = seriesBox.x + cx;
            axis.translation.y = seriesBox.y + cy;
            axis.calculateLayout();
        });
    }
    async computeCircle(seriesBox) {
        const polarSeries = this.series.filter($d77b025aa58d633c$var$isPolarSeries);
        const polarAxes = this.axes.filter($d77b025aa58d633c$var$isPolarAxis);
        const setSeriesCircle = (cx, cy, r)=>{
            this.updateAxes(seriesBox, cx, cy, r);
            polarSeries.forEach((series)=>{
                series.centerX = cx;
                series.centerY = cy;
                series.radius = r;
            });
            const pieSeries = polarSeries.filter((s)=>s.type === "donut" || s.type === "pie");
            if (pieSeries.length > 1) {
                const innerRadii = pieSeries.map((series)=>{
                    const innerRadius = series.getInnerRadius();
                    return {
                        series: series,
                        innerRadius: innerRadius
                    };
                }).sort((a, b)=>a.innerRadius - b.innerRadius);
                innerRadii.at(-1).series.surroundingRadius = void 0;
                for(let i = 0; i < innerRadii.length - 1; i++)innerRadii[i].series.surroundingRadius = innerRadii[i + 1].innerRadius;
            }
        };
        const centerX = seriesBox.width / 2;
        const centerY = seriesBox.height / 2;
        const initialRadius = Math.max(0, Math.min(seriesBox.width, seriesBox.height) / 2);
        let radius = initialRadius;
        setSeriesCircle(centerX, centerY, radius);
        const shake = async ({ hideWhenNecessary: hideWhenNecessary = false } = {})=>{
            const labelBoxes = [];
            for (const series of (0, $idDdm.iterate)(polarAxes, polarSeries)){
                const box = await series.computeLabelsBBox({
                    hideWhenNecessary: hideWhenNecessary
                }, seriesBox);
                if (box) labelBoxes.push(box);
            }
            if (labelBoxes.length === 0) {
                setSeriesCircle(centerX, centerY, initialRadius);
                return;
            }
            const labelBox = $d77b025aa58d633c$var$BBox.merge(labelBoxes);
            const refined = this.refineCircle(labelBox, radius, seriesBox);
            setSeriesCircle(refined.centerX, refined.centerY, refined.radius);
            radius = refined.radius;
        };
        await shake();
        await shake();
        await shake();
        await shake({
            hideWhenNecessary: true
        });
        await shake({
            hideWhenNecessary: true
        });
        for (const series of (0, $idDdm.iterate)(polarAxes, polarSeries))await series.computeLabelsBBox({
            hideWhenNecessary: true
        }, seriesBox);
        return {
            radius: radius,
            centerX: centerX,
            centerY: centerY
        };
    }
    refineCircle(labelsBox, radius, seriesBox) {
        const minCircleRatio = 0.5;
        const circleLeft = -radius;
        const circleTop = -radius;
        const circleRight = radius;
        const circleBottom = radius;
        let padLeft = Math.max(0, circleLeft - labelsBox.x);
        let padTop = Math.max(0, circleTop - labelsBox.y);
        let padRight = Math.max(0, labelsBox.x + labelsBox.width - circleRight);
        let padBottom = Math.max(0, labelsBox.y + labelsBox.height - circleBottom);
        padLeft = padRight = Math.max(padLeft, padRight);
        padTop = padBottom = Math.max(padTop, padBottom);
        const availCircleWidth = seriesBox.width - padLeft - padRight;
        const availCircleHeight = seriesBox.height - padTop - padBottom;
        let newRadius = Math.min(availCircleWidth, availCircleHeight) / 2;
        const minHorizontalRadius = minCircleRatio * seriesBox.width / 2;
        const minVerticalRadius = minCircleRatio * seriesBox.height / 2;
        const minRadius = Math.min(minHorizontalRadius, minVerticalRadius);
        if (newRadius < minRadius) {
            newRadius = minRadius;
            const horizontalPadding = padLeft + padRight;
            const verticalPadding = padTop + padBottom;
            if (2 * newRadius + verticalPadding > seriesBox.height) {
                const padHeight = seriesBox.height - 2 * newRadius;
                if (Math.min(padTop, padBottom) * 2 > padHeight) {
                    padTop = padHeight / 2;
                    padBottom = padHeight / 2;
                } else if (padTop > padBottom) padTop = padHeight - padBottom;
                else padBottom = padHeight - padTop;
            }
            if (2 * newRadius + horizontalPadding > seriesBox.width) {
                const padWidth = seriesBox.width - 2 * newRadius;
                if (Math.min(padLeft, padRight) * 2 > padWidth) {
                    padLeft = padWidth / 2;
                    padRight = padWidth / 2;
                } else if (padLeft > padRight) padLeft = padWidth - padRight;
                else padRight = padWidth - padLeft;
            }
        }
        const newWidth = padLeft + 2 * newRadius + padRight;
        const newHeight = padTop + 2 * newRadius + padBottom;
        return {
            centerX: (seriesBox.width - newWidth) / 2 + padLeft + newRadius,
            centerY: (seriesBox.height - newHeight) / 2 + padTop + newRadius,
            radius: newRadius
        };
    }
};
$d77b025aa58d633c$var$PolarChart.className = "PolarChart";
$d77b025aa58d633c$var$PolarChart.type = "polar";
function $d77b025aa58d633c$var$isPolarSeries(series) {
    return series instanceof $d77b025aa58d633c$var$PolarSeries;
}
function $d77b025aa58d633c$var$isPolarAxis(axis) {
    return axis instanceof $d77b025aa58d633c$var$PolarAxis;
}
// packages/ag-charts-community/src/chart/polarChartModule.ts
var $d77b025aa58d633c$var$PolarChartModule = {
    type: "chart",
    name: "polar",
    options: $d77b025aa58d633c$var$polarChartOptionsDefs,
    detect: $d77b025aa58d633c$var$isAgPolarChartOptions,
    create (options, resources) {
        return new $d77b025aa58d633c$var$PolarChart(options, resources);
    },
    validate (options, optionsDefs6, path) {
        const additionalErrors = [];
        const baseType = options?.series?.[0]?.type;
        if (baseType === "pie" || baseType === "donut") {
            if (options?.axes) {
                additionalErrors.push(new (0, $idDdm.UnknownError)([], options.axes, path, "axes"));
                options = $d77b025aa58d633c$var$without(options, [
                    "axes"
                ]);
            }
        }
        const result = (0, $idDdm.validate)(options, optionsDefs6, path);
        result.invalid.push(...additionalErrors);
        return result;
    }
};
var $d77b025aa58d633c$var$numberAxisOptionsDefs = {
    ...$d77b025aa58d633c$var$cartesianAxisOptionsDefs,
    ...$d77b025aa58d633c$var$continuousAxisOptions((0, $idDdm.number)),
    type: (0, $idDdm.required)((0, $idDdm.constant)("number")),
    label: $d77b025aa58d633c$var$cartesianNumericAxisLabel,
    crosshair: $d77b025aa58d633c$var$cartesianAxisCrosshairOptions(true)
};
var $d77b025aa58d633c$var$logAxisOptionsDefs = {
    ...$d77b025aa58d633c$var$cartesianAxisOptionsDefs,
    ...$d77b025aa58d633c$var$continuousAxisOptions((0, $idDdm.number)),
    type: (0, $idDdm.required)((0, $idDdm.constant)("log")),
    base: (0, $idDdm.and)((0, $idDdm.positiveNumberNonZero), (0, $idDdm.attachDescription)((value)=>value !== 1, "not equal to 1")),
    label: $d77b025aa58d633c$var$cartesianNumericAxisLabel,
    crosshair: $d77b025aa58d633c$var$cartesianAxisCrosshairOptions(true)
};
var $d77b025aa58d633c$var$timeAxisOptionsDefs = {
    ...$d77b025aa58d633c$var$cartesianAxisOptionsDefs,
    ...$d77b025aa58d633c$var$continuousAxisOptions((0, $idDdm.or)((0, $idDdm.number), (0, $idDdm.date)), true),
    type: (0, $idDdm.required)((0, $idDdm.constant)("time")),
    label: $d77b025aa58d633c$var$cartesianTimeAxisLabel,
    parentLevel: $d77b025aa58d633c$var$cartesianTimeAxisParentLevel,
    crosshair: $d77b025aa58d633c$var$cartesianAxisCrosshairOptions(true)
};
$d77b025aa58d633c$var$timeAxisOptionsDefs.paddingInner = (0, $idDdm.positiveNumber);
$d77b025aa58d633c$var$timeAxisOptionsDefs.paddingOuter = (0, $idDdm.positiveNumber);
$d77b025aa58d633c$var$timeAxisOptionsDefs.groupPaddingInner = (0, $idDdm.positiveNumber);
var $d77b025aa58d633c$var$categoryAxisOptionsDefs = {
    ...$d77b025aa58d633c$var$cartesianAxisOptionsDefs,
    type: (0, $idDdm.required)((0, $idDdm.constant)("category")),
    label: $d77b025aa58d633c$var$cartesianAxisLabelOptionsDefs,
    paddingInner: (0, $idDdm.ratio),
    paddingOuter: (0, $idDdm.ratio),
    groupPaddingInner: (0, $idDdm.ratio),
    crosshair: $d77b025aa58d633c$var$cartesianAxisCrosshairOptions()
};
var $d77b025aa58d633c$var$groupedCategoryAxisOptionsDefs = {
    ...$d77b025aa58d633c$var$cartesianAxisOptionsDefs,
    type: (0, $idDdm.required)((0, $idDdm.constant)("grouped-category")),
    label: $d77b025aa58d633c$var$cartesianAxisLabelOptionsDefs,
    crosshair: $d77b025aa58d633c$var$cartesianAxisCrosshairOptions(),
    paddingInner: (0, $idDdm.ratio),
    groupPaddingInner: (0, $idDdm.ratio),
    depthOptions: (0, $idDdm.arrayOfDefs)({
        label: {
            enabled: (0, $idDdm.boolean),
            avoidCollisions: (0, $idDdm.boolean),
            rotation: (0, $idDdm.number),
            spacing: (0, $idDdm.number),
            ...(0, $idDdm.fontOptionsDef)
        },
        tick: {
            enabled: (0, $idDdm.boolean),
            stroke: (0, $idDdm.color),
            width: (0, $idDdm.positiveNumber)
        }
    }, "depth options objects array")
};
var $d77b025aa58d633c$var$unitTimeAxisOptionsDefs = {
    ...$d77b025aa58d633c$var$cartesianAxisOptionsDefs,
    // @todo(AG-14472) - Remove nice
    // ...without(continuousAxisOptions(or(number, date), true), ['nice']),
    ...$d77b025aa58d633c$var$continuousAxisOptions((0, $idDdm.or)((0, $idDdm.number), (0, $idDdm.date)), true),
    type: (0, $idDdm.required)((0, $idDdm.constant)("unit-time")),
    unit: (0, $idDdm.or)((0, $idDdm.instanceOf)($d77b025aa58d633c$var$TimeInterval), $d77b025aa58d633c$var$timeIntervalUnit),
    label: $d77b025aa58d633c$var$cartesianTimeAxisLabel,
    parentLevel: $d77b025aa58d633c$var$cartesianTimeAxisParentLevel,
    paddingInner: (0, $idDdm.ratio),
    paddingOuter: (0, $idDdm.ratio),
    groupPaddingInner: (0, $idDdm.ratio),
    crosshair: $d77b025aa58d633c$var$cartesianAxisCrosshairOptions(true)
};
var $d77b025aa58d633c$var$mergeOptionsDefs = (a, b)=>{
    const out = {};
    for (const key of new Set([
        ...Object.keys(a),
        ...Object.keys(b)
    ])){
        const aDef = a[key];
        const bDef = b[key];
        if ((0, $idDdm.isPlainObject)(aDef) && (0, $idDdm.isPlainObject)(bDef)) out[key] = $d77b025aa58d633c$var$mergeOptionsDefs(aDef, bDef);
        else if (aDef != null && bDef != null && aDef !== bDef) out[key] = (0, $idDdm.or)(aDef, bDef);
        else out[key] = aDef ?? bDef;
    }
    return out;
};
var $d77b025aa58d633c$var$timeAxisOptionsCompatibilityDefs = $d77b025aa58d633c$var$mergeOptionsDefs($d77b025aa58d633c$var$timeAxisOptionsDefs, $d77b025aa58d633c$var$unitTimeAxisOptionsDefs);
var $d77b025aa58d633c$var$NumberAxisModule = {
    type: "axis",
    name: "number",
    chartType: "cartesian",
    options: $d77b025aa58d633c$var$numberAxisOptionsDefs,
    create: (ctx)=>new $d77b025aa58d633c$var$NumberAxis(ctx)
};
var $d77b025aa58d633c$var$LogAxisModule = {
    type: "axis",
    name: "log",
    chartType: "cartesian",
    options: $d77b025aa58d633c$var$logAxisOptionsDefs,
    create: (ctx)=>new $d77b025aa58d633c$var$LogAxis(ctx)
};
var $d77b025aa58d633c$var$TimeAxisModule = {
    type: "axis",
    name: "time",
    chartType: "cartesian",
    // @todo(AG-14472) - Replace with timeAxisOptionsDefs,
    options: $d77b025aa58d633c$var$timeAxisOptionsCompatibilityDefs,
    create: (ctx)=>new $d77b025aa58d633c$var$TimeAxis(ctx)
};
var $d77b025aa58d633c$var$CategoryAxisModule = {
    type: "axis",
    name: "category",
    chartType: "cartesian",
    options: $d77b025aa58d633c$var$categoryAxisOptionsDefs,
    create: (ctx)=>new $d77b025aa58d633c$var$CategoryAxis(ctx)
};
var $d77b025aa58d633c$var$GroupedCategoryAxisModule = {
    type: "axis",
    name: "grouped-category",
    chartType: "cartesian",
    options: $d77b025aa58d633c$var$groupedCategoryAxisOptionsDefs,
    create: (ctx)=>new $d77b025aa58d633c$var$GroupedCategoryAxis(ctx)
};
var $d77b025aa58d633c$var$UnitTimeAxisModule = {
    type: "axis",
    name: "unit-time",
    chartType: "cartesian",
    options: $d77b025aa58d633c$var$unitTimeAxisOptionsDefs,
    create: (ctx)=>new $d77b025aa58d633c$var$UnitTimeAxis(ctx)
};
var $d77b025aa58d633c$var$AllCartesianCommunityModules = [
    $d77b025aa58d633c$var$CartesianChartModule,
    $d77b025aa58d633c$var$NumberAxisModule,
    $d77b025aa58d633c$var$LogAxisModule,
    $d77b025aa58d633c$var$TimeAxisModule,
    $d77b025aa58d633c$var$CategoryAxisModule,
    $d77b025aa58d633c$var$GroupedCategoryAxisModule,
    $d77b025aa58d633c$var$UnitTimeAxisModule,
    $d77b025aa58d633c$var$NewAreaSeriesModule,
    $d77b025aa58d633c$var$NewBarSeriesModule,
    $d77b025aa58d633c$var$NewBubbleSeriesModule,
    $d77b025aa58d633c$var$NewHistogramSeriesModule,
    $d77b025aa58d633c$var$NewLineSeriesModule,
    $d77b025aa58d633c$var$NewScatterSeriesModule
];
var $d77b025aa58d633c$var$AllPolarCommunityModules = [
    $d77b025aa58d633c$var$PolarChartModule,
    $d77b025aa58d633c$var$NewDonutSeriesModule,
    $d77b025aa58d633c$var$NewPieSeriesModule
];
var $d77b025aa58d633c$var$AllCommunityModules = [
    ...$d77b025aa58d633c$var$AllCartesianCommunityModules,
    ...$d77b025aa58d633c$var$AllPolarCommunityModules,
    // Enterprise placeholders
    $d77b025aa58d633c$var$FlowProportionChartModule,
    $d77b025aa58d633c$var$GaugeChartModule,
    $d77b025aa58d633c$var$HierarchyChartModule,
    $d77b025aa58d633c$var$StandaloneChartModule,
    $d77b025aa58d633c$var$TopologyChartModule,
    // Presets
    $d77b025aa58d633c$var$PriceVolumePresetModule,
    $d77b025aa58d633c$var$GaugePresetModule,
    $d77b025aa58d633c$var$SparklinePresetModule
];
// packages/ag-charts-community/src/module/enterpriseModule.ts
var $d77b025aa58d633c$var$enterpriseModule = {
    isEnterprise: false
};
function $d77b025aa58d633c$var$removeUsedEnterpriseOptions(options, silent) {
    let usedOptions = [];
    const isGaugeChart = $d77b025aa58d633c$var$isAgGaugeChartOptions(options);
    const optsType = $d77b025aa58d633c$var$optionsType(options);
    const optionsChartType = optsType ? $d77b025aa58d633c$var$chartTypes2.get(optsType) : "unknown";
    for (const module of $d77b025aa58d633c$var$EXPECTED_ENTERPRISE_MODULES){
        if (optionsChartType !== "unknown" && !module.chartTypes.includes(optionsChartType)) continue;
        if (module.type === "root" || module.type === "legend") {
            const optionValue = options[module.optionsKey];
            if (optionValue == null) continue;
            if (!module.optionsInnerKey) {
                usedOptions.push(module.optionsKey);
                delete options[module.optionsKey];
            } else if (optionValue[module.optionsInnerKey]) {
                usedOptions.push(`${module.optionsKey}.${module.optionsInnerKey}`);
                delete optionValue[module.optionsInnerKey];
            }
        } else if (module.type === "axis") {
            if (!("axes" in options) || !(0, $idDdm.isArray)(options.axes) || !options.axes?.some((axis)=>axis.type === module.identifier)) continue;
            usedOptions.push(`axis[type=${module.identifier}]`);
            options.axes = options.axes.filter((axis)=>axis.type !== module.identifier);
        } else if (module.type === "axis-option") {
            if (!("axes" in options) || !(0, $idDdm.isArray)(options.axes) || !options.axes?.some((axis)=>axis[module.optionsKey])) continue;
            usedOptions.push(`axis.${module.optionsKey}`);
            options.axes.forEach((axis)=>{
                if (axis[module.optionsKey]) delete axis[module.optionsKey];
            });
        } else if (module.type === "series") {
            if (module.community) continue;
            if (!(0, $idDdm.isArray)(options.series) || !options.series?.some((series)=>series.type === module.identifier)) continue;
            usedOptions.push(`series[type=${module.identifier}]`);
            options.series = options.series.filter((series)=>series.type !== module.identifier);
        } else if (module.type === "series-option") {
            if (!(0, $idDdm.isArray)(options.series) || !options.series?.some((series)=>series[module.optionsKey])) continue;
            usedOptions.push(`series.${module.optionsKey}`);
            options.series.forEach((series)=>{
                if (series[module.optionsKey]) delete series[module.optionsKey];
            });
        }
    }
    if (usedOptions.length && !silent) {
        if (isGaugeChart) usedOptions = [
            "AgCharts.createGauge"
        ];
        let enterprisePackageName = "ag-charts-enterprise";
        let enterpriseReferenceUrl = "https://www.ag-grid.com/charts/javascript/installation/";
        if (options.mode === "integrated") {
            enterprisePackageName = "ag-grid-charts-enterprise' or 'ag-grid-enterprise/charts-enterprise";
            enterpriseReferenceUrl = "https://www.ag-grid.com/javascript-data-grid/integrated-charts-installation/";
        }
        (0, $idDdm.Logger).warnOnce([
            `unable to use these enterprise features as '${enterprisePackageName}' has not been loaded:`,
            "",
            ...usedOptions,
            "",
            `See: ${enterpriseReferenceUrl}`
        ].join("\n"));
    }
}
function $d77b025aa58d633c$var$removeUnusedEnterpriseOptions(options) {
    const integratedMode = "mode" in options && options.mode === "integrated";
    for (const module of $d77b025aa58d633c$var$moduleRegistry.byType("root", "legend")){
        const moduleOptions = options[module.optionsKey];
        const isPresentAndDisabled = moduleOptions != null && moduleOptions.enabled === false;
        const removable = !("removable" in module) || module.removable === true || module.removable === "standalone-only" && !integratedMode;
        if (isPresentAndDisabled && removable) delete options[module.optionsKey];
    }
}
// packages/ag-charts-community/src/module/coreModulesTypes.ts
function $d77b025aa58d633c$var$paletteType(partial) {
    if (partial?.up || partial?.down || partial?.neutral) return "user-full";
    else if (partial?.fills || partial?.strokes) return "user-indexed";
    return "inbuilt";
}
// packages/ag-charts-community/src/chart/themes/chartTheme.ts
var $d77b025aa58d633c$var$DEFAULT_BACKGROUND_FILL = "white";
var $d77b025aa58d633c$var$CHART_TYPE_CONFIG = {
    get cartesian () {
        return {
            seriesTypes: $d77b025aa58d633c$var$chartTypes2.cartesianTypes,
            commonOptions: [
                "zoom",
                "navigator"
            ]
        };
    },
    get polar () {
        return {
            seriesTypes: $d77b025aa58d633c$var$chartTypes2.polarTypes,
            commonOptions: []
        };
    },
    get hierarchy () {
        return {
            seriesTypes: $d77b025aa58d633c$var$chartTypes2.hierarchyTypes,
            commonOptions: []
        };
    },
    get topology () {
        return {
            seriesTypes: $d77b025aa58d633c$var$chartTypes2.topologyTypes,
            commonOptions: []
        };
    },
    get "flow-proportion" () {
        return {
            seriesTypes: $d77b025aa58d633c$var$chartTypes2.flowProportionTypes,
            commonOptions: []
        };
    },
    get standalone () {
        return {
            seriesTypes: $d77b025aa58d633c$var$chartTypes2.standaloneTypes,
            commonOptions: []
        };
    },
    get gauge () {
        return {
            seriesTypes: $d77b025aa58d633c$var$chartTypes2.gaugeTypes,
            commonOptions: []
        };
    }
};
var $d77b025aa58d633c$var$PRESET_OVERRIDES_TYPES = {
    "radial-gauge": true,
    "linear-gauge": true
};
function $d77b025aa58d633c$var$isPresetOverridesType(type) {
    return $d77b025aa58d633c$var$PRESET_OVERRIDES_TYPES[type] === true;
}
var $d77b025aa58d633c$var$modernTimeLabelFormat = {
    millisecond: "%H:%M:%S.L",
    second: "%H:%M:%S",
    minute: "%H:%M",
    hour: "%H:%M",
    day: "%e %B",
    month: "%B",
    year: "%Y"
};
var $d77b025aa58d633c$var$timeDivisionLabelFormat = {
    millisecond: "%H:%M:%S.%L",
    second: "%H:%M:%S",
    minute: "%H:%M",
    hour: "%H:%M",
    day: "%e",
    month: "%b",
    year: "%Y"
};
var $d77b025aa58d633c$var$CHART_TYPE_SPECIFIC_COMMON_OPTIONS = Object.values($d77b025aa58d633c$var$CHART_TYPE_CONFIG).reduce((r, { commonOptions: commonOptions })=>r.concat(commonOptions), []);
var $d77b025aa58d633c$var$_ChartTheme = class _ChartTheme {
    static getDefaultColors() {
        return {
            fills: $d77b025aa58d633c$var$DEFAULT_FILLS,
            fillsFallback: Object.values($d77b025aa58d633c$var$DEFAULT_FILLS),
            strokes: $d77b025aa58d633c$var$DEFAULT_STROKES,
            sequentialColors: $d77b025aa58d633c$var$getSequentialColors($d77b025aa58d633c$var$DEFAULT_FILLS),
            divergingColors: [
                $d77b025aa58d633c$var$DEFAULT_FILLS.ORANGE,
                $d77b025aa58d633c$var$DEFAULT_FILLS.YELLOW,
                $d77b025aa58d633c$var$DEFAULT_FILLS.GREEN
            ],
            hierarchyColors: [
                "#fff",
                "#e0e5ea",
                "#c1ccd5",
                "#a3b4c1",
                "#859cad"
            ],
            secondSequentialColors: $d77b025aa58d633c$var$Color.interpolate([
                $d77b025aa58d633c$var$Color.fromHexString($d77b025aa58d633c$var$DEFAULT_FILLS.BLUE),
                $d77b025aa58d633c$var$Color.fromHexString("#cbdef5")
            ], 8).map((color11)=>color11.toString()),
            secondDivergingColors: [
                $d77b025aa58d633c$var$DEFAULT_FILLS.GREEN,
                $d77b025aa58d633c$var$DEFAULT_FILLS.YELLOW,
                $d77b025aa58d633c$var$DEFAULT_FILLS.RED
            ],
            secondHierarchyColors: [
                "#fff",
                "#c5cbd1",
                "#a4b1bd",
                "#8498a9",
                "#648096"
            ],
            up: {
                fill: $d77b025aa58d633c$var$DEFAULT_FILLS.GREEN,
                stroke: $d77b025aa58d633c$var$DEFAULT_STROKES.GREEN
            },
            down: {
                fill: $d77b025aa58d633c$var$DEFAULT_FILLS.RED,
                stroke: $d77b025aa58d633c$var$DEFAULT_STROKES.RED
            },
            neutral: {
                fill: $d77b025aa58d633c$var$DEFAULT_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$DEFAULT_STROKES.GRAY
            },
            altUp: {
                fill: $d77b025aa58d633c$var$DEFAULT_FILLS.BLUE,
                stroke: $d77b025aa58d633c$var$DEFAULT_STROKES.BLUE
            },
            altDown: {
                fill: $d77b025aa58d633c$var$DEFAULT_FILLS.ORANGE,
                stroke: $d77b025aa58d633c$var$DEFAULT_STROKES.ORANGE
            },
            altNeutral: {
                fill: $d77b025aa58d633c$var$DEFAULT_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$DEFAULT_STROKES.GRAY
            }
        };
    }
    static getDefaultPublicParameters() {
        return {
            accentColor: "#2196f3",
            axisColor: {
                $foregroundBackgroundMix: [
                    0.675
                ]
            },
            backgroundColor: $d77b025aa58d633c$var$DEFAULT_BACKGROUND_FILL,
            borderColor: {
                $foregroundBackgroundMix: [
                    0.818
                ]
            },
            foregroundColor: "#464646",
            fontFamily: "Verdana, sans-serif",
            fontSize: 12 /* SMALL */ ,
            fontWeight: 400,
            gridLineColor: {
                $foregroundBackgroundAccentMix: [
                    0.93,
                    0.085
                ]
            },
            padding: 20,
            subtleTextColor: {
                $mix: [
                    {
                        $ref: "textColor"
                    },
                    {
                        $ref: "backgroundColor"
                    },
                    0.38
                ]
            },
            textColor: {
                $ref: "foregroundColor"
            },
            chromeBackgroundColor: {
                $foregroundBackgroundMix: [
                    0.975
                ]
            },
            chromeFontFamily: {
                $ref: "fontFamily"
            },
            chromeFontSize: {
                $ref: "fontSize"
            },
            chromeFontWeight: {
                $ref: "fontWeight"
            },
            chromeTextColor: "#181d1f",
            chromeSubtleTextColor: {
                $mix: [
                    {
                        $ref: "chromeTextColor"
                    },
                    {
                        $ref: "backgroundColor"
                    },
                    0.38
                ]
            },
            inputBackgroundColor: {
                $ref: "backgroundColor"
            },
            inputTextColor: {
                $ref: "textColor"
            },
            crosshairLabelBackgroundColor: {
                $ref: "foregroundColor"
            },
            crosshairLabelTextColor: {
                $ref: "backgroundColor"
            }
        };
    }
    static getAxisDefaults(overrideDefaults, { title: title, time: time2 }) {
        const timeLabelFormat = time2 === "modern" ? $d77b025aa58d633c$var$modernTimeLabelFormat : void 0;
        return $d77b025aa58d633c$var$mergeDefaults(overrideDefaults, title && {
            title: {
                enabled: false,
                text: "Axis Title",
                spacing: 25,
                fontWeight: {
                    $ref: "fontWeight"
                },
                fontSize: {
                    $rem: [
                        1.0833333333333333 /* MEDIUM */ 
                    ]
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                color: {
                    $ref: "textColor"
                }
            }
        }, time2 !== "off" && {
            label: {
                format: {
                    millisecond: {
                        $if: [
                            // @todo(AG-14472) - remove ../enabled fallback
                            {
                                $path: [
                                    "../../parentLevel/enabled",
                                    {
                                        $path: "../enabled"
                                    }
                                ]
                            },
                            $d77b025aa58d633c$var$timeDivisionLabelFormat.millisecond,
                            timeLabelFormat?.millisecond
                        ]
                    },
                    second: {
                        $if: [
                            // @todo(AG-14472) - remove ../enabled fallback
                            {
                                $path: [
                                    "../../parentLevel/enabled",
                                    {
                                        $path: "../enabled"
                                    }
                                ]
                            },
                            $d77b025aa58d633c$var$timeDivisionLabelFormat.second,
                            timeLabelFormat?.second
                        ]
                    },
                    minute: {
                        $if: [
                            // @todo(AG-14472) - remove ../enabled fallback
                            {
                                $path: [
                                    "../../parentLevel/enabled",
                                    {
                                        $path: "../enabled"
                                    }
                                ]
                            },
                            $d77b025aa58d633c$var$timeDivisionLabelFormat.minute,
                            timeLabelFormat?.minute
                        ]
                    },
                    hour: {
                        $if: [
                            // @todo(AG-14472) - remove ../enabled fallback
                            {
                                $path: [
                                    "../../parentLevel/enabled",
                                    {
                                        $path: "../enabled"
                                    }
                                ]
                            },
                            $d77b025aa58d633c$var$timeDivisionLabelFormat.hour,
                            timeLabelFormat?.hour
                        ]
                    },
                    day: {
                        $if: [
                            // @todo(AG-14472) - remove ../enabled fallback
                            {
                                $path: [
                                    "../../parentLevel/enabled",
                                    {
                                        $path: "../enabled"
                                    }
                                ]
                            },
                            $d77b025aa58d633c$var$timeDivisionLabelFormat.day,
                            timeLabelFormat?.day
                        ]
                    },
                    month: {
                        $if: [
                            // @todo(AG-14472) - remove ../enabled fallback
                            {
                                $path: [
                                    "../../parentLevel/enabled",
                                    {
                                        $path: "../enabled"
                                    }
                                ]
                            },
                            $d77b025aa58d633c$var$timeDivisionLabelFormat.month,
                            timeLabelFormat?.month
                        ]
                    },
                    year: {
                        $if: [
                            // @todo(AG-14472) - remove ../enabled fallback
                            {
                                $path: [
                                    "../../parentLevel/enabled",
                                    {
                                        $path: "../enabled"
                                    }
                                ]
                            },
                            $d77b025aa58d633c$var$timeDivisionLabelFormat.year,
                            timeLabelFormat?.year
                        ]
                    }
                }
            },
            parentLevel: {
                enabled: false,
                label: {
                    enabled: {
                        $path: "../../label/enabled"
                    },
                    fontSize: {
                        $path: "../../label/fontSize"
                    },
                    fontFamily: {
                        $path: "../../label/fontFamily"
                    },
                    fontWeight: "bold",
                    spacing: {
                        $path: "../../label/spacing"
                    },
                    color: {
                        $path: "../../label/color"
                    },
                    avoidCollisions: {
                        $path: "../../label/avoidCollisions"
                    },
                    format: {
                        millisecond: {
                            $path: [
                                "../../../label/format/millisecond",
                                $d77b025aa58d633c$var$timeDivisionLabelFormat.millisecond
                            ]
                        },
                        second: {
                            $path: [
                                "../../../label/format/second",
                                $d77b025aa58d633c$var$timeDivisionLabelFormat.second
                            ]
                        },
                        minute: {
                            $path: [
                                "../../../label/format/minute",
                                $d77b025aa58d633c$var$timeDivisionLabelFormat.minute
                            ]
                        },
                        hour: {
                            $path: [
                                "../../../label/format/hour",
                                $d77b025aa58d633c$var$timeDivisionLabelFormat.hour
                            ]
                        },
                        day: {
                            $path: [
                                "../../../label/format/day",
                                $d77b025aa58d633c$var$timeDivisionLabelFormat.day
                            ]
                        },
                        month: {
                            $path: [
                                "../../../label/format/month",
                                $d77b025aa58d633c$var$timeDivisionLabelFormat.month
                            ]
                        },
                        year: {
                            $path: [
                                "../../../label/format/year",
                                $d77b025aa58d633c$var$timeDivisionLabelFormat.year
                            ]
                        }
                    }
                },
                tick: {
                    enabled: {
                        $path: "../../tick/enabled"
                    },
                    size: {
                        $path: "../../tick/size"
                    },
                    width: {
                        $path: "../../tick/width"
                    },
                    stroke: {
                        $path: "../../tick/stroke"
                    }
                }
            }
        }, {
            label: {
                enabled: true,
                fontSize: {
                    $ref: "fontSize"
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontWeight: {
                    $ref: "fontWeight"
                },
                spacing: 11,
                color: {
                    $ref: "textColor"
                },
                avoidCollisions: true
            },
            line: {
                enabled: true,
                width: 1,
                stroke: {
                    $ref: "axisColor"
                }
            },
            tick: {
                enabled: false,
                size: 6,
                width: 1,
                stroke: {
                    $ref: "axisColor"
                }
            },
            gridLine: {
                enabled: true,
                style: [
                    {
                        stroke: {
                            $ref: "gridLineColor"
                        },
                        lineDash: []
                    }
                ]
            },
            crossLines: {
                enabled: true,
                fill: {
                    $ref: "foregroundColor"
                },
                stroke: {
                    $ref: "foregroundColor"
                },
                fillOpacity: 0.1,
                strokeWidth: 1,
                label: {
                    fontSize: {
                        $ref: "fontSize"
                    },
                    fontFamily: {
                        $ref: "fontFamily"
                    },
                    fontWeight: {
                        $ref: "fontWeight"
                    },
                    padding: 5,
                    color: {
                        $ref: "textColor"
                    }
                }
            }
        });
    }
    getChartDefaults() {
        return {
            minHeight: 300,
            minWidth: 300,
            background: {
                visible: true,
                fill: {
                    $ref: "backgroundColor"
                }
            },
            padding: {
                top: {
                    $ref: "padding"
                },
                right: {
                    $ref: "padding"
                },
                bottom: {
                    $ref: "padding"
                },
                left: {
                    $ref: "padding"
                }
            },
            seriesArea: {
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            },
            keyboard: {
                enabled: true
            },
            title: {
                enabled: false,
                text: "Title",
                spacing: {
                    $if: [
                        {
                            $path: "../subtitle/enabled"
                        },
                        10,
                        20
                    ]
                },
                fontWeight: {
                    $ref: "fontWeight"
                },
                fontSize: {
                    $rem: [
                        1.4166666666666667 /* LARGEST */ 
                    ]
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                color: {
                    $ref: "textColor"
                },
                wrapping: "hyphenate",
                layoutStyle: $d77b025aa58d633c$var$DEFAULT_CAPTION_LAYOUT_STYLE,
                textAlign: $d77b025aa58d633c$var$DEFAULT_CAPTION_ALIGNMENT
            },
            subtitle: {
                enabled: false,
                text: "Subtitle",
                spacing: 20,
                fontWeight: {
                    $ref: "fontWeight"
                },
                fontSize: {
                    $rem: [
                        1.0833333333333333 /* MEDIUM */ 
                    ]
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                color: {
                    $ref: "subtleTextColor"
                },
                wrapping: "hyphenate",
                layoutStyle: $d77b025aa58d633c$var$DEFAULT_CAPTION_LAYOUT_STYLE,
                textAlign: $d77b025aa58d633c$var$DEFAULT_CAPTION_ALIGNMENT
            },
            footnote: {
                enabled: false,
                text: "Footnote",
                spacing: 20,
                fontSize: {
                    $rem: [
                        1.0833333333333333 /* MEDIUM */ 
                    ]
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontWeight: {
                    $ref: "fontWeight"
                },
                color: {
                    $ref: "subtleTextColor"
                },
                wrapping: "hyphenate",
                layoutStyle: $d77b025aa58d633c$var$DEFAULT_CAPTION_LAYOUT_STYLE,
                textAlign: $d77b025aa58d633c$var$DEFAULT_CAPTION_ALIGNMENT
            },
            legend: {
                position: "bottom" /* BOTTOM */ ,
                orientation: {
                    $if: [
                        {
                            $or: [
                                {
                                    $eq: [
                                        {
                                            $path: "./position"
                                        },
                                        "left" /* LEFT */ 
                                    ]
                                },
                                {
                                    $eq: [
                                        {
                                            $path: "./position"
                                        },
                                        "right" /* RIGHT */ 
                                    ]
                                }
                            ]
                        },
                        "vertical",
                        "horizontal"
                    ]
                },
                spacing: 30,
                listeners: {},
                toggleSeries: true,
                item: {
                    paddingX: 16,
                    paddingY: 8,
                    marker: {
                        size: 15,
                        padding: 8
                    },
                    showSeriesStroke: true,
                    label: {
                        color: {
                            $ref: "textColor"
                        },
                        fontSize: {
                            $ref: "fontSize"
                        },
                        fontFamily: {
                            $ref: "fontFamily"
                        },
                        fontWeight: {
                            $ref: "fontWeight"
                        }
                    }
                },
                reverseOrder: false,
                pagination: {
                    marker: {
                        size: 12
                    },
                    activeStyle: {
                        fill: {
                            $ref: "foregroundColor"
                        }
                    },
                    inactiveStyle: {
                        fill: {
                            $ref: "subtleTextColor"
                        }
                    },
                    highlightStyle: {
                        fill: {
                            $ref: "foregroundColor"
                        }
                    },
                    label: {
                        color: {
                            $ref: "textColor"
                        }
                    }
                }
            },
            tooltip: {
                enabled: true,
                darkTheme: $d77b025aa58d633c$var$IS_DARK_THEME,
                delay: 0,
                pagination: false
            },
            overlays: {
                darkTheme: $d77b025aa58d633c$var$IS_DARK_THEME
            },
            listeners: {}
        };
    }
    constructor(options = {}){
        const { overrides: overrides, palette: palette2, params: params } = $d77b025aa58d633c$var$deepClone(options);
        const defaults = this.createChartConfigPerChartType(this.getDefaults());
        const presets = {};
        if (overrides) this.mergeOverrides(defaults, presets, overrides);
        const { fills: fills, strokes: strokes, sequentialColors: sequentialColors, ...otherColors } = this.getDefaultColors();
        this.palette = $d77b025aa58d633c$var$deepFreeze($d77b025aa58d633c$var$mergeDefaults(palette2, {
            fills: Object.values(fills),
            strokes: Object.values(strokes),
            sequentialColors: Object.values(sequentialColors),
            ...otherColors
        }));
        this.paletteType = $d77b025aa58d633c$var$paletteType(palette2);
        this.params = $d77b025aa58d633c$var$mergeDefaults(params, this.getPublicParameters());
        this.config = $d77b025aa58d633c$var$deepFreeze(this.templateTheme(defaults));
        this.presets = $d77b025aa58d633c$var$deepFreeze(presets);
    }
    mergeOverrides(defaults, presets, overrides) {
        for (const { seriesTypes: seriesTypes, commonOptions: commonOptions } of Object.values($d77b025aa58d633c$var$CHART_TYPE_CONFIG)){
            const cleanedCommon = {
                ...overrides.common
            };
            for (const commonKey of $d77b025aa58d633c$var$CHART_TYPE_SPECIFIC_COMMON_OPTIONS)if (!commonOptions.includes(commonKey)) delete cleanedCommon[commonKey];
            for (const s of seriesTypes){
                const seriesType = s;
                if (!$d77b025aa58d633c$var$isPresetOverridesType(seriesType)) defaults[seriesType] = $d77b025aa58d633c$var$mergeDefaults(cleanedCommon, defaults[seriesType]);
            }
        }
        $d77b025aa58d633c$var$chartTypes2.seriesTypes.forEach((s)=>{
            const seriesType = s;
            const seriesOverrides = overrides[seriesType];
            if ($d77b025aa58d633c$var$isPresetOverridesType(seriesType)) presets[seriesType] = seriesOverrides;
            else defaults[seriesType] = $d77b025aa58d633c$var$mergeDefaults(seriesOverrides, defaults[seriesType]);
        });
    }
    createChartConfigPerChartType(config) {
        for (const [nextType, { seriesTypes: seriesTypes }] of (0, $idDdm.entries)($d77b025aa58d633c$var$CHART_TYPE_CONFIG)){
            const typeDefaults = $d77b025aa58d633c$var$chartDefaults.get(nextType);
            for (const seriesType of seriesTypes)config[seriesType] ?? (config[seriesType] = $d77b025aa58d633c$var$deepClone(typeDefaults));
        }
        return config;
    }
    getDefaults() {
        const getOverridesByType = (chartType, seriesTypes)=>{
            const result = {};
            const chartTypeDefaults = {
                axes: {},
                ...$d77b025aa58d633c$var$legendRegistry.getThemeTemplates(),
                ...this.getChartDefaults(),
                ...$d77b025aa58d633c$var$chartDefaults.get(chartType)
            };
            for (const seriesType of seriesTypes){
                result[seriesType] = $d77b025aa58d633c$var$mergeDefaults($d77b025aa58d633c$var$seriesRegistry.getThemeTemplate(seriesType), result[seriesType] ?? $d77b025aa58d633c$var$deepClone(chartTypeDefaults));
                const { axes: axes } = result[seriesType];
                for (const axisType of $d77b025aa58d633c$var$axisRegistry.keys())axes[axisType] = $d77b025aa58d633c$var$mergeDefaults(axes[axisType], $d77b025aa58d633c$var$axisRegistry.getThemeTemplate(axisType), _ChartTheme.axisDefault[axisType]);
            }
            return result;
        };
        return $d77b025aa58d633c$var$mergeDefaults(getOverridesByType("cartesian", $d77b025aa58d633c$var$chartTypes2.cartesianTypes), getOverridesByType("polar", $d77b025aa58d633c$var$chartTypes2.polarTypes), getOverridesByType("hierarchy", $d77b025aa58d633c$var$chartTypes2.hierarchyTypes), getOverridesByType("topology", $d77b025aa58d633c$var$chartTypes2.topologyTypes), getOverridesByType("flow-proportion", $d77b025aa58d633c$var$chartTypes2.flowProportionTypes), getOverridesByType("standalone", $d77b025aa58d633c$var$chartTypes2.standaloneTypes), getOverridesByType("gauge", $d77b025aa58d633c$var$chartTypes2.gaugeTypes));
    }
    static applyTemplateTheme(node, _other, params) {
        if ((0, $idDdm.isArray)(node)) for(let i = 0; i < node.length; i++){
            const symbol = node[i];
            if (typeof symbol === "symbol" && params?.has(symbol)) node[i] = params.get(symbol);
        }
        else for (const name of Object.keys(node)){
            const value = node[name];
            if (typeof value === "symbol" && params?.has(value)) node[name] = params.get(value);
        }
    }
    templateTheme(themeTemplate, clone2 = true) {
        const themeInstance = clone2 ? $d77b025aa58d633c$var$deepClone(themeTemplate) : themeTemplate;
        const params = this.getTemplateParameters();
        $d77b025aa58d633c$var$jsonWalk(themeInstance, _ChartTheme.applyTemplateTheme, void 0, void 0, params);
        return themeInstance;
    }
    getDefaultColors() {
        return _ChartTheme.getDefaultColors();
    }
    getPublicParameters() {
        return _ChartTheme.getDefaultPublicParameters();
    }
    // Private parameters that are not exposed in the themes API.
    getTemplateParameters() {
        const params = /* @__PURE__ */ new Map();
        params.set($d77b025aa58d633c$var$IS_DARK_THEME, false);
        params.set($d77b025aa58d633c$var$DEFAULT_SEPARATION_LINES_COLOUR, "#d9d9d9");
        params.set($d77b025aa58d633c$var$DEFAULT_SHADOW_COLOUR, "#00000080");
        params.set($d77b025aa58d633c$var$DEFAULT_SPARKLINE_CROSSHAIR_STROKE, "#aaa");
        params.set($d77b025aa58d633c$var$DEFAULT_CAPTION_LAYOUT_STYLE, "block");
        params.set($d77b025aa58d633c$var$DEFAULT_CAPTION_ALIGNMENT, "center");
        params.set($d77b025aa58d633c$var$DEFAULT_FIBONACCI_STROKES, [
            "#797b86",
            "#e24c4a",
            "#f49d2d",
            "#65ab58",
            "#409682",
            "#4db9d2",
            "#5090dc",
            "#3068f9",
            "#e24c4a",
            "#913aac",
            "#d93e64"
        ]);
        params.set($d77b025aa58d633c$var$DEFAULT_POLAR_SERIES_STROKE, $d77b025aa58d633c$var$DEFAULT_BACKGROUND_FILL);
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR, $d77b025aa58d633c$var$DEFAULT_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$DEFAULT_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_TEXT_ANNOTATION_COLOR, $d77b025aa58d633c$var$DEFAULT_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_HANDLE_FILL, $d77b025aa58d633c$var$DEFAULT_BACKGROUND_FILL);
        params.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_FILL, "#fafafa");
        params.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_STROKE, "#ddd");
        params.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_COLOR, "#000");
        params.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DIVIDER_STROKE, "#181d1f");
        params.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DOWN_FILL, "#e35c5c");
        params.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DOWN_STROKE, "#e35c5c");
        params.set($d77b025aa58d633c$var$DEFAULT_TEXTBOX_FILL, "#fafafa");
        params.set($d77b025aa58d633c$var$DEFAULT_TEXTBOX_STROKE, "#ddd");
        params.set($d77b025aa58d633c$var$DEFAULT_TEXTBOX_COLOR, "#000");
        params.set($d77b025aa58d633c$var$DEFAULT_TOOLBAR_POSITION, "top");
        params.set($d77b025aa58d633c$var$DEFAULT_GRIDLINE_ENABLED, false);
        const defaultColors = this.getDefaultColors();
        params.set($d77b025aa58d633c$var$PALETTE_UP_STROKE, this.palette.up?.stroke ?? defaultColors.up.stroke);
        params.set($d77b025aa58d633c$var$PALETTE_UP_FILL, this.palette.up?.fill ?? defaultColors.up.fill);
        params.set($d77b025aa58d633c$var$PALETTE_DOWN_STROKE, this.palette.down?.stroke ?? defaultColors.down.stroke);
        params.set($d77b025aa58d633c$var$PALETTE_DOWN_FILL, this.palette.down?.fill ?? defaultColors.down.fill);
        params.set($d77b025aa58d633c$var$PALETTE_NEUTRAL_STROKE, this.palette.neutral?.stroke ?? defaultColors.neutral.stroke);
        params.set($d77b025aa58d633c$var$PALETTE_NEUTRAL_FILL, this.palette.neutral?.fill ?? defaultColors.neutral.fill);
        params.set($d77b025aa58d633c$var$PALETTE_ALT_UP_STROKE, this.palette.altUp?.stroke ?? defaultColors.up.stroke);
        params.set($d77b025aa58d633c$var$PALETTE_ALT_UP_FILL, this.palette.altUp?.fill ?? defaultColors.up.fill);
        params.set($d77b025aa58d633c$var$PALETTE_ALT_DOWN_STROKE, this.palette.altDown?.stroke ?? defaultColors.down.stroke);
        params.set($d77b025aa58d633c$var$PALETTE_ALT_DOWN_FILL, this.palette.altDown?.fill ?? defaultColors.down.fill);
        params.set($d77b025aa58d633c$var$PALETTE_ALT_NEUTRAL_FILL, this.palette.altNeutral?.fill ?? defaultColors.altNeutral.fill);
        params.set($d77b025aa58d633c$var$PALETTE_ALT_NEUTRAL_STROKE, this.palette.altNeutral?.stroke ?? defaultColors.altNeutral.stroke);
        return params;
    }
};
$d77b025aa58d633c$var$_ChartTheme.axisDefault = {
    ["number" /* NUMBER */ ]: $d77b025aa58d633c$var$_ChartTheme.getAxisDefaults({
        keys: [],
        line: {
            enabled: false
        },
        crosshair: {
            enabled: true
        }
    }, {
        title: true,
        time: "off"
    }),
    ["log" /* LOG */ ]: $d77b025aa58d633c$var$_ChartTheme.getAxisDefaults({
        keys: [],
        base: 10,
        line: {
            enabled: false
        },
        crosshair: {
            enabled: true
        }
    }, {
        title: true,
        time: "off"
    }),
    ["category" /* CATEGORY */ ]: $d77b025aa58d633c$var$_ChartTheme.getAxisDefaults({
        keys: [],
        groupPaddingInner: 0.1,
        label: {
            autoRotate: true
        },
        gridLine: {
            enabled: $d77b025aa58d633c$var$DEFAULT_GRIDLINE_ENABLED
        },
        crosshair: {
            enabled: false
        }
    }, {
        title: true,
        time: "off"
    }),
    ["grouped-category" /* GROUPED_CATEGORY */ ]: $d77b025aa58d633c$var$_ChartTheme.getAxisDefaults({
        keys: [],
        tick: {
            enabled: true,
            stroke: $d77b025aa58d633c$var$DEFAULT_SEPARATION_LINES_COLOUR
        },
        label: {
            spacing: 10,
            rotation: 270
        },
        paddingInner: 0.4,
        groupPaddingInner: 0.2,
        crosshair: {
            enabled: false
        }
    }, {
        title: true,
        time: "off"
    }),
    ["time" /* TIME */ ]: $d77b025aa58d633c$var$_ChartTheme.getAxisDefaults({
        keys: [],
        gridLine: {
            enabled: $d77b025aa58d633c$var$DEFAULT_GRIDLINE_ENABLED
        },
        crosshair: {
            enabled: true
        }
    }, {
        title: true,
        time: "legacy"
    }),
    ["ordinal-time" /* ORDINAL_TIME */ ]: $d77b025aa58d633c$var$_ChartTheme.getAxisDefaults({
        keys: [],
        groupPaddingInner: 0,
        label: {
            autoRotate: false
        },
        gridLine: {
            enabled: $d77b025aa58d633c$var$DEFAULT_GRIDLINE_ENABLED
        },
        crosshair: {
            enabled: true
        }
    }, {
        title: true,
        time: "legacy"
    }),
    ["unit-time" /* UNIT_TIME */ ]: $d77b025aa58d633c$var$_ChartTheme.getAxisDefaults({
        keys: [],
        groupPaddingInner: 0.1,
        label: {
            autoRotate: false
        },
        gridLine: {
            enabled: $d77b025aa58d633c$var$DEFAULT_GRIDLINE_ENABLED
        },
        crosshair: {
            enabled: true
        },
        parentLevel: {
            enabled: true
        }
    }, {
        title: true,
        time: "modern"
    }),
    ["angle-category" /* ANGLE_CATEGORY */ ]: $d77b025aa58d633c$var$_ChartTheme.getAxisDefaults({
        label: {
            spacing: 5
        },
        gridLine: {
            enabled: $d77b025aa58d633c$var$DEFAULT_GRIDLINE_ENABLED
        },
        shape: {
            $path: [
                "./shape",
                void 0,
                {
                    $find: [
                        {
                            $not: [
                                {
                                    $isOperation: "./shape"
                                }
                            ]
                        },
                        {
                            $path: ".."
                        }
                    ]
                }
            ]
        }
    }, {
        title: false,
        time: "off"
    }),
    ["angle-number" /* ANGLE_NUMBER */ ]: $d77b025aa58d633c$var$_ChartTheme.getAxisDefaults({
        label: {
            spacing: 5
        },
        gridLine: {
            enabled: $d77b025aa58d633c$var$DEFAULT_GRIDLINE_ENABLED
        }
    }, {
        title: false,
        time: "off"
    }),
    ["radius-category" /* RADIUS_CATEGORY */ ]: $d77b025aa58d633c$var$_ChartTheme.getAxisDefaults({
        positionAngle: 0,
        line: {
            enabled: false
        }
    }, {
        title: true,
        time: "off"
    }),
    ["radius-number" /* RADIUS_NUMBER */ ]: $d77b025aa58d633c$var$_ChartTheme.getAxisDefaults({
        positionAngle: 0,
        line: {
            enabled: false
        },
        shape: {
            $path: [
                "./shape",
                void 0,
                {
                    $find: [
                        {
                            $not: [
                                {
                                    $isOperation: "./shape"
                                }
                            ]
                        },
                        {
                            $path: ".."
                        }
                    ]
                }
            ]
        }
    }, {
        title: true,
        time: "off"
    })
};
var $d77b025aa58d633c$var$ChartTheme = $d77b025aa58d633c$var$_ChartTheme;
// packages/ag-charts-community/src/chart/themes/darkTheme.ts
var $d77b025aa58d633c$var$DEFAULT_DARK_BACKGROUND_FILL = "#192232";
var $d77b025aa58d633c$var$DEFAULT_DARK_FILLS = {
    BLUE: "#5090dc",
    ORANGE: "#ffa03a",
    GREEN: "#459d55",
    CYAN: "#34bfe1",
    YELLOW: "#e1cc00",
    VIOLET: "#9669cb",
    GRAY: "#b5b5b5",
    MAGENTA: "#bd5aa7",
    BROWN: "#8a6224",
    RED: "#ef5452"
};
var $d77b025aa58d633c$var$DEFAULT_DARK_STROKES = {
    BLUE: "#74a8e6",
    ORANGE: "#ffbe70",
    GREEN: "#6cb176",
    CYAN: "#75d4ef",
    YELLOW: "#f6e559",
    VIOLET: "#aa86d8",
    GRAY: "#a1a1a1",
    MAGENTA: "#ce7ab9",
    BROWN: "#997b52",
    RED: "#ff7872"
};
var $d77b025aa58d633c$var$DarkTheme = class extends $d77b025aa58d633c$var$ChartTheme {
    getDefaultColors() {
        return {
            fills: $d77b025aa58d633c$var$DEFAULT_DARK_FILLS,
            fillsFallback: Object.values($d77b025aa58d633c$var$DEFAULT_DARK_FILLS),
            strokes: $d77b025aa58d633c$var$DEFAULT_DARK_STROKES,
            sequentialColors: $d77b025aa58d633c$var$getSequentialColors($d77b025aa58d633c$var$DEFAULT_DARK_FILLS),
            divergingColors: [
                $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.ORANGE,
                $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.YELLOW,
                $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.GREEN
            ],
            hierarchyColors: [
                "#192834",
                "#253746",
                "#324859",
                "#3f596c",
                "#4d6a80"
            ],
            secondSequentialColors: [
                "#5090dc",
                "#4882c6",
                "#4073b0",
                "#38659a",
                "#305684",
                "#28486e",
                "#203a58",
                "#182b42"
            ],
            secondDivergingColors: [
                $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.GREEN,
                $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.YELLOW,
                $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.RED
            ],
            secondHierarchyColors: [
                "#192834",
                "#3b5164",
                "#496275",
                "#577287",
                "#668399"
            ],
            up: {
                fill: $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.GREEN,
                stroke: $d77b025aa58d633c$var$DEFAULT_DARK_STROKES.GREEN
            },
            down: {
                fill: $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.RED,
                stroke: $d77b025aa58d633c$var$DEFAULT_DARK_STROKES.RED
            },
            neutral: {
                fill: $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$DEFAULT_DARK_STROKES.GRAY
            },
            altUp: {
                fill: $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.BLUE,
                stroke: $d77b025aa58d633c$var$DEFAULT_DARK_STROKES.BLUE
            },
            altDown: {
                fill: $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.ORANGE,
                stroke: $d77b025aa58d633c$var$DEFAULT_DARK_STROKES.ORANGE
            },
            altNeutral: {
                fill: $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$DEFAULT_DARK_STROKES.GRAY
            }
        };
    }
    getPublicParameters() {
        return {
            ...super.getPublicParameters(),
            axisColor: {
                $foregroundBackgroundMix: [
                    0.263
                ]
            },
            backgroundColor: $d77b025aa58d633c$var$DEFAULT_DARK_BACKGROUND_FILL,
            borderColor: {
                $foregroundBackgroundMix: [
                    0.784
                ]
            },
            chromeBackgroundColor: {
                $foregroundBackgroundMix: [
                    0.93
                ]
            },
            foregroundColor: "#fff",
            gridLineColor: {
                $foregroundBackgroundAccentMix: [
                    0.743,
                    0.01
                ]
            },
            subtleTextColor: {
                $mix: [
                    {
                        $ref: "textColor"
                    },
                    {
                        $ref: "backgroundColor"
                    },
                    0.57
                ]
            },
            chromeTextColor: {
                $ref: "textColor"
            },
            crosshairLabelBackgroundColor: {
                $foregroundBackgroundAccentMix: [
                    0.35,
                    0.1
                ]
            }
        };
    }
    getTemplateParameters() {
        const params = super.getTemplateParameters();
        params.set($d77b025aa58d633c$var$IS_DARK_THEME, true);
        params.set($d77b025aa58d633c$var$DEFAULT_POLAR_SERIES_STROKE, $d77b025aa58d633c$var$DEFAULT_DARK_BACKGROUND_FILL);
        params.set($d77b025aa58d633c$var$DEFAULT_SEPARATION_LINES_COLOUR, "#7f8389");
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR, $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_TEXT_ANNOTATION_COLOR, "#fff");
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_HANDLE_FILL, $d77b025aa58d633c$var$DEFAULT_DARK_BACKGROUND_FILL);
        params.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_FILL, "#28313e");
        params.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_STROKE, "#4b525d");
        params.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_COLOR, "#fff");
        params.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DIVIDER_STROKE, "#fff");
        params.set($d77b025aa58d633c$var$DEFAULT_TEXTBOX_FILL, "#28313e");
        params.set($d77b025aa58d633c$var$DEFAULT_TEXTBOX_STROKE, "#4b525d");
        params.set($d77b025aa58d633c$var$DEFAULT_TEXTBOX_COLOR, "#fff");
        return params;
    }
    constructor(options){
        super(options);
    }
};
// packages/ag-charts-community/src/chart/themes/financialDark.ts
var $d77b025aa58d633c$var$FINANCIAL_DARK_FILLS = {
    GREEN: "#089981",
    RED: "#F23645",
    BLUE: "#5090dc",
    GRAY: "#A9A9A9"
};
var $d77b025aa58d633c$var$FINANCIAL_DARK_STROKES = {
    GREEN: "#089981",
    RED: "#F23645",
    BLUE: "#5090dc",
    GRAY: "#909090"
};
var $d77b025aa58d633c$var$FinancialDark = class extends $d77b025aa58d633c$var$DarkTheme {
    getDefaultColors() {
        return {
            ...super.getDefaultColors(),
            fills: {
                ...$d77b025aa58d633c$var$FINANCIAL_DARK_FILLS
            },
            fillsFallback: Object.values({
                ...$d77b025aa58d633c$var$FINANCIAL_DARK_FILLS
            }),
            strokes: {
                ...$d77b025aa58d633c$var$FINANCIAL_DARK_STROKES
            },
            sequentialColors: $d77b025aa58d633c$var$getSequentialColors($d77b025aa58d633c$var$FINANCIAL_DARK_FILLS),
            divergingColors: [
                $d77b025aa58d633c$var$FINANCIAL_DARK_FILLS.GREEN,
                $d77b025aa58d633c$var$FINANCIAL_DARK_FILLS.BLUE,
                $d77b025aa58d633c$var$FINANCIAL_DARK_FILLS.RED
            ],
            // hierarchyColors: [],
            secondSequentialColors: [
                "#5090dc",
                "#4882c6",
                "#4073b0",
                "#38659a",
                "#305684",
                "#28486e",
                "#203a58",
                "#182b42"
            ],
            // secondDivergingColors: [],
            // secondHierarchyColors: [],
            up: {
                fill: $d77b025aa58d633c$var$FINANCIAL_DARK_FILLS.GREEN,
                stroke: $d77b025aa58d633c$var$FINANCIAL_DARK_STROKES.GREEN
            },
            down: {
                fill: $d77b025aa58d633c$var$FINANCIAL_DARK_FILLS.RED,
                stroke: $d77b025aa58d633c$var$FINANCIAL_DARK_STROKES.RED
            },
            neutral: {
                fill: $d77b025aa58d633c$var$FINANCIAL_DARK_FILLS.BLUE,
                stroke: $d77b025aa58d633c$var$FINANCIAL_DARK_STROKES.BLUE
            },
            altUp: {
                fill: $d77b025aa58d633c$var$FINANCIAL_DARK_FILLS.GREEN,
                stroke: $d77b025aa58d633c$var$FINANCIAL_DARK_STROKES.GREEN
            },
            altDown: {
                fill: $d77b025aa58d633c$var$FINANCIAL_DARK_FILLS.RED,
                stroke: $d77b025aa58d633c$var$FINANCIAL_DARK_STROKES.RED
            },
            altNeutral: {
                fill: $d77b025aa58d633c$var$FINANCIAL_DARK_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$FINANCIAL_DARK_STROKES.GRAY
            }
        };
    }
    getPublicParameters() {
        return {
            ...super.getPublicParameters(),
            gridLineColor: {
                $foregroundBackgroundAccentMix: [
                    0.88,
                    0.01
                ]
            },
            padding: 0
        };
    }
    getTemplateParameters() {
        const params = super.getTemplateParameters();
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR, $d77b025aa58d633c$var$FINANCIAL_DARK_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$FINANCIAL_DARK_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_CAPTION_LAYOUT_STYLE, "overlay");
        params.set($d77b025aa58d633c$var$DEFAULT_CAPTION_ALIGNMENT, "left");
        params.set($d77b025aa58d633c$var$DEFAULT_TOOLBAR_POSITION, "bottom");
        params.set($d77b025aa58d633c$var$DEFAULT_GRIDLINE_ENABLED, true);
        return params;
    }
};
// packages/ag-charts-community/src/chart/themes/financialLight.ts
var $d77b025aa58d633c$var$FINANCIAL_LIGHT_FILLS = {
    GREEN: "#089981",
    RED: "#F23645",
    BLUE: "#5090dc",
    GRAY: "#A9A9A9"
};
var $d77b025aa58d633c$var$FINANCIAL_LIGHT_STROKES = {
    GREEN: "#089981",
    RED: "#F23645",
    BLUE: "#5090dc",
    GRAY: "#909090"
};
var $d77b025aa58d633c$var$FinancialLight = class extends $d77b025aa58d633c$var$ChartTheme {
    getDefaultColors() {
        return {
            ...super.getDefaultColors(),
            fills: {
                ...$d77b025aa58d633c$var$FINANCIAL_LIGHT_FILLS
            },
            fillsFallback: Object.values({
                ...$d77b025aa58d633c$var$FINANCIAL_LIGHT_FILLS
            }),
            strokes: {
                ...$d77b025aa58d633c$var$FINANCIAL_LIGHT_STROKES
            },
            sequentialColors: $d77b025aa58d633c$var$getSequentialColors($d77b025aa58d633c$var$FINANCIAL_LIGHT_FILLS),
            divergingColors: [
                $d77b025aa58d633c$var$FINANCIAL_LIGHT_FILLS.GREEN,
                $d77b025aa58d633c$var$FINANCIAL_LIGHT_FILLS.BLUE,
                $d77b025aa58d633c$var$FINANCIAL_LIGHT_FILLS.RED
            ],
            // hierarchyColors: [],
            // secondSequentialColors: [],
            // secondDivergingColors: [],
            // secondHierarchyColors: [],
            up: {
                fill: $d77b025aa58d633c$var$FINANCIAL_LIGHT_FILLS.GREEN,
                stroke: $d77b025aa58d633c$var$FINANCIAL_LIGHT_STROKES.GREEN
            },
            down: {
                fill: $d77b025aa58d633c$var$FINANCIAL_LIGHT_FILLS.RED,
                stroke: $d77b025aa58d633c$var$FINANCIAL_LIGHT_STROKES.RED
            },
            neutral: {
                fill: $d77b025aa58d633c$var$FINANCIAL_LIGHT_FILLS.BLUE,
                stroke: $d77b025aa58d633c$var$FINANCIAL_LIGHT_STROKES.BLUE
            },
            altUp: {
                fill: $d77b025aa58d633c$var$FINANCIAL_LIGHT_FILLS.GREEN,
                stroke: $d77b025aa58d633c$var$FINANCIAL_LIGHT_STROKES.GREEN
            },
            altDown: {
                fill: $d77b025aa58d633c$var$FINANCIAL_LIGHT_FILLS.RED,
                stroke: $d77b025aa58d633c$var$FINANCIAL_LIGHT_STROKES.RED
            },
            altNeutral: {
                fill: $d77b025aa58d633c$var$FINANCIAL_LIGHT_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$FINANCIAL_LIGHT_STROKES.GRAY
            }
        };
    }
    getPublicParameters() {
        return {
            ...super.getPublicParameters(),
            gridLineColor: {
                $foregroundBackgroundAccentMix: [
                    0.94,
                    0.01
                ]
            },
            padding: 0
        };
    }
    getTemplateParameters() {
        const params = super.getTemplateParameters();
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR, $d77b025aa58d633c$var$FINANCIAL_LIGHT_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$FINANCIAL_LIGHT_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_CAPTION_LAYOUT_STYLE, "overlay");
        params.set($d77b025aa58d633c$var$DEFAULT_CAPTION_ALIGNMENT, "left");
        params.set($d77b025aa58d633c$var$DEFAULT_TOOLBAR_POSITION, "bottom");
        params.set($d77b025aa58d633c$var$DEFAULT_GRIDLINE_ENABLED, true);
        return params;
    }
};
// packages/ag-charts-community/src/chart/themes/materialDark.ts
var $d77b025aa58d633c$var$MATERIAL_DARK_FILLS = {
    BLUE: "#2196F3",
    ORANGE: "#FF9800",
    GREEN: "#4CAF50",
    CYAN: "#00BCD4",
    YELLOW: "#FFEB3B",
    VIOLET: "#7E57C2",
    GRAY: "#9E9E9E",
    MAGENTA: "#F06292",
    BROWN: "#795548",
    RED: "#F44336"
};
var $d77b025aa58d633c$var$MATERIAL_DARK_STROKES = {
    BLUE: "#90CAF9",
    ORANGE: "#FFCC80",
    GREEN: "#A5D6A7",
    CYAN: "#80DEEA",
    YELLOW: "#FFF9C4",
    VIOLET: "#B39DDB",
    GRAY: "#E0E0E0",
    MAGENTA: "#F48FB1",
    BROWN: "#A1887F",
    RED: "#EF9A9A"
};
var $d77b025aa58d633c$var$MaterialDark = class extends $d77b025aa58d633c$var$DarkTheme {
    getDefaultColors() {
        return {
            ...super.getDefaultColors(),
            fills: $d77b025aa58d633c$var$MATERIAL_DARK_FILLS,
            fillsFallback: Object.values($d77b025aa58d633c$var$MATERIAL_DARK_FILLS),
            strokes: $d77b025aa58d633c$var$MATERIAL_DARK_STROKES,
            sequentialColors: $d77b025aa58d633c$var$getSequentialColors($d77b025aa58d633c$var$MATERIAL_DARK_FILLS),
            divergingColors: [
                $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.ORANGE,
                $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.YELLOW,
                $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.GREEN
            ],
            // hierarchyColors: [],
            secondSequentialColors: [
                "#2196f3",
                // 500
                "#208FEC",
                // (interpolated)
                "#1E88E5",
                // 600
                "#1C7FDC",
                // (interpolated)
                "#1976d2",
                // 700
                "#176EC9",
                // (interpolated)
                "#1565c0"
            ],
            secondDivergingColors: [
                $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.GREEN,
                $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.YELLOW,
                $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.RED
            ],
            // secondHierarchyColors: [],
            up: {
                fill: $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.GREEN,
                stroke: $d77b025aa58d633c$var$MATERIAL_DARK_STROKES.GREEN
            },
            down: {
                fill: $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.RED,
                stroke: $d77b025aa58d633c$var$MATERIAL_DARK_STROKES.RED
            },
            neutral: {
                fill: $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$MATERIAL_DARK_STROKES.GRAY
            },
            altUp: {
                fill: $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.BLUE,
                stroke: $d77b025aa58d633c$var$MATERIAL_DARK_STROKES.BLUE
            },
            altDown: {
                fill: $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.RED,
                stroke: $d77b025aa58d633c$var$MATERIAL_DARK_STROKES.RED
            },
            altNeutral: {
                fill: $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$MATERIAL_DARK_STROKES.GRAY
            }
        };
    }
    getTemplateParameters() {
        const params = super.getTemplateParameters();
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR, $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.BLUE);
        return params;
    }
};
// packages/ag-charts-community/src/chart/themes/materialLight.ts
var $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS = {
    BLUE: "#2196F3",
    ORANGE: "#FF9800",
    GREEN: "#4CAF50",
    CYAN: "#00BCD4",
    YELLOW: "#FFEB3B",
    VIOLET: "#7E57C2",
    GRAY: "#9E9E9E",
    MAGENTA: "#F06292",
    BROWN: "#795548",
    RED: "#F44336"
};
var $d77b025aa58d633c$var$MATERIAL_LIGHT_STROKES = {
    BLUE: "#1565C0",
    ORANGE: "#E65100",
    GREEN: "#2E7D32",
    CYAN: "#00838F",
    YELLOW: "#F9A825",
    VIOLET: "#4527A0",
    GRAY: "#616161",
    MAGENTA: "#C2185B",
    BROWN: "#4E342E",
    RED: "#B71C1C"
};
var $d77b025aa58d633c$var$MaterialLight = class extends $d77b025aa58d633c$var$ChartTheme {
    getDefaultColors() {
        return {
            ...super.getDefaultColors(),
            fills: $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS,
            fillsFallback: Object.values($d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS),
            strokes: $d77b025aa58d633c$var$MATERIAL_LIGHT_STROKES,
            sequentialColors: $d77b025aa58d633c$var$getSequentialColors($d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS),
            divergingColors: [
                $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.ORANGE,
                $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.YELLOW,
                $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.GREEN
            ],
            // hierarchyColors: [],
            secondSequentialColors: [
                "#2196f3",
                // 500
                "#329EF4",
                // (interpolated)
                "#42a5f5",
                // 400
                "#53ADF6",
                // (interpolated)
                "#64b5f6",
                // 300
                "#7AC0F8",
                // (interpolated)
                "#90caf9"
            ],
            secondDivergingColors: [
                $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.GREEN,
                $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.YELLOW,
                $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.RED
            ],
            // secondHierarchyColors: [],
            up: {
                fill: $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.GREEN,
                stroke: $d77b025aa58d633c$var$MATERIAL_LIGHT_STROKES.GREEN
            },
            down: {
                fill: $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.RED,
                stroke: $d77b025aa58d633c$var$MATERIAL_LIGHT_STROKES.RED
            },
            neutral: {
                fill: $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$MATERIAL_LIGHT_STROKES.GRAY
            },
            altUp: {
                fill: $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.BLUE,
                stroke: $d77b025aa58d633c$var$MATERIAL_LIGHT_STROKES.BLUE
            },
            altDown: {
                fill: $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.RED,
                stroke: $d77b025aa58d633c$var$MATERIAL_LIGHT_STROKES.RED
            },
            altNeutral: {
                fill: $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$MATERIAL_LIGHT_STROKES.GRAY
            }
        };
    }
    getTemplateParameters() {
        const params = super.getTemplateParameters();
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR, $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.BLUE);
        return params;
    }
};
// packages/ag-charts-community/src/chart/themes/polychromaDark.ts
var $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS = {
    BLUE: "#436ff4",
    PURPLE: "#9a7bff",
    MAGENTA: "#d165d2",
    PINK: "#f0598b",
    RED: "#f47348",
    ORANGE: "#f2a602",
    YELLOW: "#e9e201",
    GREEN: "#21b448",
    CYAN: "#00b9a2",
    MODERATE_BLUE: "#00aee4",
    GRAY: "#bbbbbb"
};
var $d77b025aa58d633c$var$POLYCHROMA_DARK_STROKES = {
    BLUE: "#6698ff",
    PURPLE: "#c0a3ff",
    MAGENTA: "#fc8dfc",
    PINK: "#ff82b1",
    RED: "#ff9b70",
    ORANGE: "#ffcf4e",
    YELLOW: "#ffff58",
    GREEN: "#58dd70",
    CYAN: "#51e2c9",
    MODERATE_BLUE: "#4fd7ff",
    GRAY: "#eeeeee"
};
var $d77b025aa58d633c$var$PolychromaDark = class extends $d77b025aa58d633c$var$DarkTheme {
    getDefaultColors() {
        return {
            fills: $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS,
            fillsFallback: Object.values($d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS),
            strokes: $d77b025aa58d633c$var$POLYCHROMA_DARK_STROKES,
            sequentialColors: $d77b025aa58d633c$var$getSequentialColors($d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS),
            divergingColors: [
                $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.BLUE,
                $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.RED
            ],
            hierarchyColors: [],
            secondSequentialColors: [
                $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.BLUE,
                $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.PURPLE,
                $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.MAGENTA,
                $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.PINK,
                $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.RED,
                $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.ORANGE,
                $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.YELLOW,
                $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.GREEN
            ],
            secondDivergingColors: [
                $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.BLUE,
                $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.RED
            ],
            secondHierarchyColors: [],
            up: {
                fill: $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.GREEN,
                stroke: $d77b025aa58d633c$var$POLYCHROMA_DARK_STROKES.GREEN
            },
            down: {
                fill: $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.RED,
                stroke: $d77b025aa58d633c$var$POLYCHROMA_DARK_STROKES.RED
            },
            neutral: {
                fill: $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$POLYCHROMA_DARK_STROKES.GRAY
            },
            altUp: {
                fill: $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.BLUE,
                stroke: $d77b025aa58d633c$var$POLYCHROMA_DARK_STROKES.BLUE
            },
            altDown: {
                fill: $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.RED,
                stroke: $d77b025aa58d633c$var$POLYCHROMA_DARK_STROKES.RED
            },
            altNeutral: {
                fill: $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$POLYCHROMA_DARK_STROKES.GRAY
            }
        };
    }
    getTemplateParameters() {
        const params = super.getTemplateParameters();
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR, $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.BLUE);
        return params;
    }
};
// packages/ag-charts-community/src/chart/themes/polychromaLight.ts
var $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS = {
    BLUE: "#436ff4",
    PURPLE: "#9a7bff",
    MAGENTA: "#d165d2",
    PINK: "#f0598b",
    RED: "#f47348",
    ORANGE: "#f2a602",
    YELLOW: "#e9e201",
    GREEN: "#21b448",
    CYAN: "#00b9a2",
    MODERATE_BLUE: "#00aee4",
    GRAY: "#bbbbbb"
};
var $d77b025aa58d633c$var$POLYCHROMA_LIGHT_STROKES = {
    BLUE: "#2346c9",
    PURPLE: "#7653d4",
    MAGENTA: "#a73da9",
    PINK: "#c32d66",
    RED: "#c84b1c",
    ORANGE: "#c87f00",
    YELLOW: "#c1b900",
    GREEN: "#008c1c",
    CYAN: "#00927c",
    MODERATE_BLUE: "#0087bb",
    GRAY: "#888888"
};
var $d77b025aa58d633c$var$PolychromaLight = class extends $d77b025aa58d633c$var$ChartTheme {
    getDefaultColors() {
        return {
            ...super.getDefaultColors(),
            fills: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS,
            fillsFallback: Object.values($d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS),
            strokes: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_STROKES,
            sequentialColors: $d77b025aa58d633c$var$getSequentialColors($d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS),
            divergingColors: [
                $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.BLUE,
                $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.RED
            ],
            hierarchyColors: [],
            secondSequentialColors: [
                $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.BLUE,
                $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.PURPLE,
                $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.MAGENTA,
                $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.PINK,
                $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.RED,
                $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.ORANGE,
                $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.YELLOW,
                $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.GREEN
            ],
            secondDivergingColors: [
                $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.BLUE,
                $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.RED
            ],
            secondHierarchyColors: [],
            up: {
                fill: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.GREEN,
                stroke: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_STROKES.GREEN
            },
            down: {
                fill: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.RED,
                stroke: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_STROKES.RED
            },
            neutral: {
                fill: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_STROKES.GRAY
            },
            altUp: {
                fill: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.BLUE,
                stroke: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_STROKES.BLUE
            },
            altDown: {
                fill: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.RED,
                stroke: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_STROKES.RED
            },
            altNeutral: {
                fill: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_STROKES.GRAY
            }
        };
    }
    getTemplateParameters() {
        const params = super.getTemplateParameters();
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR, $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.BLUE);
        return params;
    }
};
// packages/ag-charts-community/src/chart/themes/sheetsDark.ts
var $d77b025aa58d633c$var$SHEETS_DARK_FILLS = {
    BLUE: "#4472C4",
    ORANGE: "#ED7D31",
    GRAY: "#A5A5A5",
    YELLOW: "#FFC000",
    MODERATE_BLUE: "#5B9BD5",
    GREEN: "#70AD47",
    DARK_GRAY: "#7B7B7B",
    DARK_BLUE: "#264478",
    VERY_DARK_GRAY: "#636363",
    DARK_YELLOW: "#997300"
};
var $d77b025aa58d633c$var$SHEETS_DARK_STROKES = {
    BLUE: "#6899ee",
    ORANGE: "#ffa55d",
    GRAY: "#cdcdcd",
    YELLOW: "#ffea53",
    MODERATE_BLUE: "#82c3ff",
    GREEN: "#96d56f",
    DARK_GRAY: "#a1a1a1",
    DARK_BLUE: "#47689f",
    VERY_DARK_GRAY: "#878787",
    DARK_YELLOW: "#c0993d"
};
var $d77b025aa58d633c$var$SheetsDark = class extends $d77b025aa58d633c$var$DarkTheme {
    getDefaultColors() {
        return {
            ...super.getDefaultColors(),
            fills: {
                ...$d77b025aa58d633c$var$SHEETS_DARK_FILLS,
                RED: $d77b025aa58d633c$var$SHEETS_DARK_FILLS.ORANGE
            },
            fillsFallback: Object.values({
                ...$d77b025aa58d633c$var$SHEETS_DARK_FILLS,
                RED: $d77b025aa58d633c$var$SHEETS_DARK_FILLS.ORANGE
            }),
            strokes: {
                ...$d77b025aa58d633c$var$SHEETS_DARK_STROKES,
                RED: $d77b025aa58d633c$var$SHEETS_DARK_STROKES.ORANGE
            },
            sequentialColors: $d77b025aa58d633c$var$getSequentialColors({
                ...$d77b025aa58d633c$var$SHEETS_DARK_FILLS,
                RED: $d77b025aa58d633c$var$SHEETS_DARK_FILLS.ORANGE
            }),
            divergingColors: [
                $d77b025aa58d633c$var$SHEETS_DARK_FILLS.ORANGE,
                $d77b025aa58d633c$var$SHEETS_DARK_FILLS.YELLOW,
                $d77b025aa58d633c$var$SHEETS_DARK_FILLS.GREEN
            ],
            // hierarchyColors: [],
            secondSequentialColors: [
                "#5090dc",
                "#4882c6",
                "#4073b0",
                "#38659a",
                "#305684",
                "#28486e",
                "#203a58",
                "#182b42"
            ],
            secondDivergingColors: [
                $d77b025aa58d633c$var$SHEETS_DARK_FILLS.GREEN,
                $d77b025aa58d633c$var$SHEETS_DARK_FILLS.YELLOW,
                $d77b025aa58d633c$var$SHEETS_DARK_FILLS.ORANGE
            ],
            // secondHierarchyColors: [],
            up: {
                fill: $d77b025aa58d633c$var$SHEETS_DARK_FILLS.GREEN,
                stroke: $d77b025aa58d633c$var$SHEETS_DARK_STROKES.GREEN
            },
            down: {
                fill: $d77b025aa58d633c$var$SHEETS_DARK_FILLS.ORANGE,
                stroke: $d77b025aa58d633c$var$SHEETS_DARK_STROKES.ORANGE
            },
            neutral: {
                fill: $d77b025aa58d633c$var$SHEETS_DARK_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$SHEETS_DARK_STROKES.GRAY
            },
            altUp: {
                fill: $d77b025aa58d633c$var$SHEETS_DARK_FILLS.BLUE,
                stroke: $d77b025aa58d633c$var$SHEETS_DARK_STROKES.BLUE
            },
            altDown: {
                fill: $d77b025aa58d633c$var$SHEETS_DARK_FILLS.ORANGE,
                stroke: $d77b025aa58d633c$var$SHEETS_DARK_STROKES.ORANGE
            },
            altNeutral: {
                fill: $d77b025aa58d633c$var$SHEETS_DARK_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$SHEETS_DARK_STROKES.GRAY
            }
        };
    }
    getTemplateParameters() {
        const params = super.getTemplateParameters();
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR, $d77b025aa58d633c$var$SHEETS_DARK_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$SHEETS_DARK_FILLS.BLUE);
        return params;
    }
};
// packages/ag-charts-community/src/chart/themes/sheetsLight.ts
var $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS = {
    BLUE: "#5281d5",
    ORANGE: "#ff8d44",
    GRAY: "#b5b5b5",
    YELLOW: "#ffd02f",
    MODERATE_BLUE: "#6aabe6",
    GREEN: "#7fbd57",
    DARK_GRAY: "#8a8a8a",
    DARK_BLUE: "#335287",
    VERY_DARK_GRAY: "#717171",
    DARK_YELLOW: "#a98220"
};
var $d77b025aa58d633c$var$SHEETS_LIGHT_STROKES = {
    BLUE: "#214d9b",
    ORANGE: "#c25600",
    GRAY: "#7f7f7f",
    YELLOW: "#d59800",
    MODERATE_BLUE: "#3575ac",
    GREEN: "#4b861a",
    DARK_GRAY: "#575757",
    DARK_BLUE: "#062253",
    VERY_DARK_GRAY: "#414141",
    DARK_YELLOW: "#734f00"
};
var $d77b025aa58d633c$var$SheetsLight = class extends $d77b025aa58d633c$var$ChartTheme {
    getDefaultColors() {
        return {
            ...super.getDefaultColors(),
            fills: {
                ...$d77b025aa58d633c$var$SHEETS_LIGHT_FILLS,
                RED: $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.ORANGE
            },
            fillsFallback: Object.values({
                ...$d77b025aa58d633c$var$SHEETS_LIGHT_FILLS,
                RED: $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.ORANGE
            }),
            strokes: {
                ...$d77b025aa58d633c$var$SHEETS_LIGHT_STROKES,
                RED: $d77b025aa58d633c$var$SHEETS_LIGHT_STROKES.ORANGE
            },
            sequentialColors: $d77b025aa58d633c$var$getSequentialColors({
                ...$d77b025aa58d633c$var$SHEETS_LIGHT_FILLS,
                RED: $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.ORANGE
            }),
            divergingColors: [
                $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.ORANGE,
                $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.YELLOW,
                $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.GREEN
            ],
            // hierarchyColors: [],
            secondSequentialColors: [
                "#5090dc",
                "#629be0",
                "#73a6e3",
                "#85b1e7",
                "#96bcea",
                "#a8c8ee",
                "#b9d3f1",
                "#cbdef5"
            ],
            secondDivergingColors: [
                $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.GREEN,
                $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.YELLOW,
                $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.ORANGE
            ],
            secondHierarchyColors: [],
            up: {
                fill: $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.GREEN,
                stroke: $d77b025aa58d633c$var$SHEETS_LIGHT_STROKES.GREEN
            },
            down: {
                fill: $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.ORANGE,
                stroke: $d77b025aa58d633c$var$SHEETS_LIGHT_STROKES.ORANGE
            },
            neutral: {
                fill: $d77b025aa58d633c$var$SHEETS_LIGHT_STROKES.GRAY,
                stroke: $d77b025aa58d633c$var$SHEETS_LIGHT_STROKES.GRAY
            },
            altUp: {
                fill: $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.BLUE,
                stroke: $d77b025aa58d633c$var$SHEETS_LIGHT_STROKES.BLUE
            },
            altDown: {
                fill: $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.ORANGE,
                stroke: $d77b025aa58d633c$var$SHEETS_LIGHT_STROKES.ORANGE
            },
            altNeutral: {
                fill: $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$SHEETS_LIGHT_STROKES.GRAY
            }
        };
    }
    getTemplateParameters() {
        const params = super.getTemplateParameters();
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR, $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.BLUE);
        return params;
    }
};
var $d77b025aa58d633c$var$ordinalTimeAxisOptionsDefs = {
    ...$d77b025aa58d633c$var$cartesianAxisOptionsDefs,
    type: (0, $idDdm.required)((0, $idDdm.constant)("ordinal-time")),
    paddingInner: (0, $idDdm.ratio),
    paddingOuter: (0, $idDdm.ratio),
    groupPaddingInner: (0, $idDdm.ratio),
    label: $d77b025aa58d633c$var$cartesianTimeAxisLabel,
    parentLevel: $d77b025aa58d633c$var$cartesianTimeAxisParentLevel,
    interval: $d77b025aa58d633c$var$continuousAxisOptions((0, $idDdm.or)((0, $idDdm.number), (0, $idDdm.date)), true).interval,
    crosshair: $d77b025aa58d633c$var$cartesianAxisCrosshairOptions(true)
};
var $d77b025aa58d633c$var$angleNumberAxisOptionsDefs = {
    ...$d77b025aa58d633c$var$commonAxisOptionsDefs,
    ...$d77b025aa58d633c$var$continuousAxisOptions((0, $idDdm.number)),
    type: (0, $idDdm.required)((0, $idDdm.constant)("angle-number")),
    crossLines: (0, $idDdm.arrayOfDefs)($d77b025aa58d633c$var$commonCrossLineOptionsDefs),
    startAngle: (0, $idDdm.number),
    endAngle: (0, $idDdm.number),
    label: {
        ...$d77b025aa58d633c$var$commonAxisLabelOptionsDefs,
        orientation: (0, $idDdm.union)("fixed", "parallel", "perpendicular"),
        format: $d77b025aa58d633c$var$numberFormatValidator
    }
};
var $d77b025aa58d633c$var$invalidOptionsFromIntegratedCharts = {
    // @ts-expect-error integrated sets this from the formatting panel, but it isn't relevant.
    innerRadiusRatio: (0, $idDdm.ratio)
};
var $d77b025aa58d633c$var$angleCategoryAxisOptionsDefs = {
    ...$d77b025aa58d633c$var$commonAxisOptionsDefs,
    ...$d77b025aa58d633c$var$invalidOptionsFromIntegratedCharts,
    type: (0, $idDdm.required)((0, $idDdm.constant)("angle-category")),
    shape: (0, $idDdm.union)("polygon", "circle"),
    crossLines: (0, $idDdm.arrayOfDefs)($d77b025aa58d633c$var$commonCrossLineOptionsDefs),
    startAngle: (0, $idDdm.number),
    endAngle: (0, $idDdm.number),
    paddingInner: (0, $idDdm.ratio),
    groupPaddingInner: (0, $idDdm.ratio),
    label: {
        ...$d77b025aa58d633c$var$commonAxisLabelOptionsDefs,
        orientation: (0, $idDdm.union)("fixed", "parallel", "perpendicular")
    }
};
var $d77b025aa58d633c$var$radiusNumberAxisOptionsDefs = {
    ...$d77b025aa58d633c$var$commonAxisOptionsDefs,
    ...$d77b025aa58d633c$var$continuousAxisOptions((0, $idDdm.number)),
    type: (0, $idDdm.required)((0, $idDdm.constant)("radius-number")),
    shape: (0, $idDdm.union)("polygon", "circle"),
    positionAngle: (0, $idDdm.number),
    innerRadiusRatio: (0, $idDdm.ratio),
    crossLines: (0, $idDdm.arrayOfDefs)({
        ...$d77b025aa58d633c$var$commonCrossLineOptionsDefs,
        label: {
            ...$d77b025aa58d633c$var$commonCrossLineLabelOptionsDefs,
            positionAngle: (0, $idDdm.number)
        }
    }, "cross-line options"),
    title: {
        enabled: (0, $idDdm.boolean),
        text: (0, $idDdm.string),
        spacing: (0, $idDdm.positiveNumber),
        formatter: (0, $idDdm.callback),
        ...(0, $idDdm.fontOptionsDef)
    },
    label: {
        ...$d77b025aa58d633c$var$commonAxisLabelOptionsDefs,
        format: $d77b025aa58d633c$var$numberFormatValidator
    }
};
var $d77b025aa58d633c$var$radiusCategoryAxisOptionsDefs = {
    ...$d77b025aa58d633c$var$commonAxisOptionsDefs,
    type: (0, $idDdm.required)((0, $idDdm.constant)("radius-category")),
    positionAngle: (0, $idDdm.number),
    innerRadiusRatio: (0, $idDdm.ratio),
    paddingInner: (0, $idDdm.ratio),
    paddingOuter: (0, $idDdm.ratio),
    groupPaddingInner: (0, $idDdm.ratio),
    label: $d77b025aa58d633c$var$commonAxisLabelOptionsDefs,
    crossLines: (0, $idDdm.arrayOfDefs)({
        ...$d77b025aa58d633c$var$commonCrossLineOptionsDefs,
        label: {
            ...$d77b025aa58d633c$var$commonCrossLineLabelOptionsDefs,
            positionAngle: (0, $idDdm.number)
        }
    }, "cross-line options"),
    title: {
        enabled: (0, $idDdm.boolean),
        text: (0, $idDdm.string),
        spacing: (0, $idDdm.positiveNumber),
        formatter: (0, $idDdm.callback),
        ...(0, $idDdm.fontOptionsDef)
    }
};
var $d77b025aa58d633c$var$annotationLineOptionsDef = {
    lineStyle: (0, $idDdm.union)("solid", "dashed", "dotted"),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$annotationHandleStylesDefs = {
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$annotationTextStylesDef = {
    visible: (0, $idDdm.boolean),
    locked: (0, $idDdm.boolean),
    handle: $d77b025aa58d633c$var$annotationHandleStylesDefs,
    ...(0, $idDdm.fontOptionsDef)
};
var $d77b025aa58d633c$var$annotationLineTextDefs = {
    position: (0, $idDdm.union)("top", "center", "bottom"),
    alignment: (0, $idDdm.union)("left", "center", "right"),
    ...(0, $idDdm.fontOptionsDef)
};
var $d77b025aa58d633c$var$annotationChannelTextDefs = {
    position: (0, $idDdm.union)("top", "inside", "bottom"),
    alignment: (0, $idDdm.union)("left", "center", "right"),
    ...(0, $idDdm.fontOptionsDef)
};
var $d77b025aa58d633c$var$annotationAxisLabelOptionsDef = {
    enabled: (0, $idDdm.boolean),
    cornerRadius: (0, $idDdm.positiveNumber),
    formatter: (0, $idDdm.callback),
    ...(0, $idDdm.fontOptionsDef),
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$annotationChannelMiddleDefs = {
    visible: (0, $idDdm.boolean),
    ...$d77b025aa58d633c$var$annotationLineOptionsDef,
    ...(0, $idDdm.strokeOptionsDef)
};
var $d77b025aa58d633c$var$annotationMeasurerStatisticsOptionsDefs = {
    divider: (0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.fontOptionsDef)
};
var $d77b025aa58d633c$var$annotationQuickMeasurerDirectionStylesDefs = {
    handle: $d77b025aa58d633c$var$annotationHandleStylesDefs,
    statistics: $d77b025aa58d633c$var$annotationMeasurerStatisticsOptionsDefs,
    ...$d77b025aa58d633c$var$annotationLineOptionsDef,
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef)
};
var $d77b025aa58d633c$var$annotationLineStyleDefs = {
    visible: (0, $idDdm.boolean),
    locked: (0, $idDdm.boolean),
    extendStart: (0, $idDdm.boolean),
    extendEnd: (0, $idDdm.boolean),
    handle: $d77b025aa58d633c$var$annotationHandleStylesDefs,
    text: $d77b025aa58d633c$var$annotationLineTextDefs,
    ...$d77b025aa58d633c$var$annotationLineOptionsDef,
    ...(0, $idDdm.strokeOptionsDef)
};
var $d77b025aa58d633c$var$annotationCrossLineStyleDefs = {
    visible: (0, $idDdm.boolean),
    locked: (0, $idDdm.boolean),
    axisLabel: $d77b025aa58d633c$var$annotationAxisLabelOptionsDef,
    handle: $d77b025aa58d633c$var$annotationHandleStylesDefs,
    text: $d77b025aa58d633c$var$annotationLineTextDefs,
    ...$d77b025aa58d633c$var$annotationLineOptionsDef,
    ...(0, $idDdm.strokeOptionsDef)
};
var $d77b025aa58d633c$var$annotationChannelStyleDefs = {
    visible: (0, $idDdm.boolean),
    locked: (0, $idDdm.boolean),
    extendStart: (0, $idDdm.boolean),
    extendEnd: (0, $idDdm.boolean),
    handle: $d77b025aa58d633c$var$annotationHandleStylesDefs,
    text: $d77b025aa58d633c$var$annotationChannelTextDefs,
    background: (0, $idDdm.fillOptionsDef),
    ...$d77b025aa58d633c$var$annotationLineOptionsDef,
    ...(0, $idDdm.strokeOptionsDef)
};
var $d77b025aa58d633c$var$annotationDisjointChannelStyleDefs = {
    ...$d77b025aa58d633c$var$annotationChannelStyleDefs
};
var $d77b025aa58d633c$var$annotationParallelChannelStyleDefs = {
    ...$d77b025aa58d633c$var$annotationChannelStyleDefs,
    middle: $d77b025aa58d633c$var$annotationChannelMiddleDefs
};
var $d77b025aa58d633c$var$annotationFibonacciStylesDefs = {
    label: (0, $idDdm.fontOptionsDef),
    showFill: (0, $idDdm.boolean),
    isMultiColor: (0, $idDdm.boolean),
    strokes: (0, $idDdm.arrayOf)((0, $idDdm.color)),
    rangeStroke: (0, $idDdm.color),
    bands: (0, $idDdm.union)(4, 6, 10),
    ...$d77b025aa58d633c$var$annotationLineStyleDefs
};
var $d77b025aa58d633c$var$annotationCalloutStylesDefs = {
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...$d77b025aa58d633c$var$annotationTextStylesDef
};
var $d77b025aa58d633c$var$annotationCommentStylesDefs = {
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...$d77b025aa58d633c$var$annotationTextStylesDef
};
var $d77b025aa58d633c$var$annotationNoteStylesDefs = {
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...$d77b025aa58d633c$var$annotationTextStylesDef,
    background: {
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef)
    }
};
var $d77b025aa58d633c$var$annotationShapeStylesDefs = {
    visible: (0, $idDdm.boolean),
    locked: (0, $idDdm.boolean),
    handle: $d77b025aa58d633c$var$annotationHandleStylesDefs,
    ...(0, $idDdm.fillOptionsDef)
};
var $d77b025aa58d633c$var$annotationMeasurerStylesDefs = {
    visible: (0, $idDdm.boolean),
    locked: (0, $idDdm.boolean),
    extendStart: (0, $idDdm.boolean),
    extendEnd: (0, $idDdm.boolean),
    handle: $d77b025aa58d633c$var$annotationHandleStylesDefs,
    text: $d77b025aa58d633c$var$annotationLineTextDefs,
    background: (0, $idDdm.fillOptionsDef),
    statistics: $d77b025aa58d633c$var$annotationMeasurerStatisticsOptionsDefs,
    ...$d77b025aa58d633c$var$annotationLineOptionsDef,
    ...(0, $idDdm.strokeOptionsDef)
};
var $d77b025aa58d633c$var$annotationQuickMeasurerStylesDefs = {
    visible: (0, $idDdm.boolean),
    up: $d77b025aa58d633c$var$annotationQuickMeasurerDirectionStylesDefs,
    down: $d77b025aa58d633c$var$annotationQuickMeasurerDirectionStylesDefs
};
var $d77b025aa58d633c$var$annotationOptionsDef = {
    enabled: (0, $idDdm.boolean),
    axesButtons: {
        enabled: (0, $idDdm.boolean),
        axes: (0, $idDdm.union)("x", "y", "xy")
    },
    toolbar: {
        enabled: (0, $idDdm.boolean),
        padding: (0, $idDdm.positiveNumber),
        buttons: (0, $idDdm.arrayOfDefs)({
            ...$d77b025aa58d633c$var$toolbarButtonOptionsDefs,
            value: (0, $idDdm.union)("line-menu", "fibonacci-menu", "text-menu", "shape-menu", "measurer-menu", "line", "horizontal-line", "vertical-line", "parallel-channel", "disjoint-channel", "fibonacci-retracement", "fibonacci-retracement-trend-based", "text", "comment", "callout", "note", "clear")
        }, "annotation toolbar buttons array")
    },
    optionsToolbar: {
        enabled: (0, $idDdm.boolean),
        buttons: (0, $idDdm.arrayOf)((0, $idDdm.or)((0, $idDdm.optionsDefs)({
            ...$d77b025aa58d633c$var$toolbarButtonOptionsDefs,
            value: (0, $idDdm.required)((0, $idDdm.union)("line-stroke-width", "line-style-type", "line-color", "fill-color", "text-color", "text-size", "delete", "settings"))
        }), (0, $idDdm.optionsDefs)({
            ...$d77b025aa58d633c$var$toolbarButtonOptionsDefs,
            value: (0, $idDdm.required)((0, $idDdm.union)("lock")),
            checkedOverrides: $d77b025aa58d633c$var$toolbarButtonOptionsDefs
        })))
    }
};
$d77b025aa58d633c$var$annotationOptionsDef.data = (0, $idDdm.undocumented)((0, $idDdm.array));
$d77b025aa58d633c$var$annotationOptionsDef.xKey = (0, $idDdm.undocumented)((0, $idDdm.string));
$d77b025aa58d633c$var$annotationOptionsDef.volumeKey = (0, $idDdm.undocumented)((0, $idDdm.string));
$d77b025aa58d633c$var$annotationOptionsDef.snap = (0, $idDdm.undocumented)((0, $idDdm.boolean));
var $d77b025aa58d633c$var$boxPlotSeriesThemeableOptionsDef = {
    direction: (0, $idDdm.union)("horizontal", "vertical"),
    showInMiniChart: (0, $idDdm.boolean),
    cornerRadius: (0, $idDdm.positiveNumber),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef),
        cornerRadius: (0, $idDdm.positiveNumber),
        whisker: {
            ...(0, $idDdm.strokeOptionsDef),
            ...(0, $idDdm.lineDashOptionsDef)
        },
        cap: {
            lengthRatio: (0, $idDdm.ratio)
        }
    }),
    whisker: {
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    },
    cap: {
        lengthRatio: (0, $idDdm.ratio)
    },
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$candlestickSeriesItemOptionsDef = {
    cornerRadius: (0, $idDdm.positiveNumber),
    wick: {
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    },
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$candlestickSeriesThemeableOptionsDef = {
    item: {
        up: $d77b025aa58d633c$var$candlestickSeriesItemOptionsDef,
        down: $d77b025aa58d633c$var$candlestickSeriesItemOptionsDef
    },
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef),
        cornerRadius: (0, $idDdm.positiveNumber),
        wick: {
            ...(0, $idDdm.strokeOptionsDef),
            ...(0, $idDdm.lineDashOptionsDef)
        }
    }),
    showInMiniChart: (0, $idDdm.boolean),
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs
};
var $d77b025aa58d633c$var$chordSeriesThemeableOptionsDef = {
    fills: (0, $idDdm.arrayOf)((0, $idDdm.colorUnion)),
    strokes: (0, $idDdm.arrayOf)((0, $idDdm.color)),
    label: {
        spacing: (0, $idDdm.positiveNumber),
        maxWidth: (0, $idDdm.positiveNumber),
        ...$d77b025aa58d633c$var$seriesLabelOptionsDefs
    },
    link: {
        tension: (0, $idDdm.ratio),
        itemStyler: (0, $idDdm.callbackDefs)({
            ...(0, $idDdm.fillOptionsDef),
            ...(0, $idDdm.strokeOptionsDef),
            ...(0, $idDdm.lineDashOptionsDef),
            tension: (0, $idDdm.ratio)
        }),
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    },
    node: {
        width: (0, $idDdm.positiveNumber),
        spacing: (0, $idDdm.positiveNumber),
        itemStyler: (0, $idDdm.callbackDefs)({
            ...(0, $idDdm.fillOptionsDef),
            ...(0, $idDdm.strokeOptionsDef),
            ...(0, $idDdm.lineDashOptionsDef)
        }),
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    },
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs
};
var $d77b025aa58d633c$var$coneFunnelSeriesThemeableOptionsDef = {
    direction: (0, $idDdm.union)("horizontal", "vertical"),
    fills: (0, $idDdm.arrayOf)((0, $idDdm.colorUnion)),
    strokes: (0, $idDdm.arrayOf)((0, $idDdm.color)),
    showInMiniChart: (0, $idDdm.boolean),
    label: {
        spacing: (0, $idDdm.positiveNumber),
        placement: (0, $idDdm.union)("before", "middle", "after"),
        ...$d77b025aa58d633c$var$seriesLabelOptionsDefs
    },
    stageLabel: {
        rotation: (0, $idDdm.number),
        spacing: (0, $idDdm.positiveNumber),
        minSpacing: (0, $idDdm.positiveNumber),
        placement: (0, $idDdm.union)("before", "after"),
        avoidCollisions: (0, $idDdm.boolean),
        itemStyler: (0, $idDdm.callbackDefs)({
            ...(0, $idDdm.fontOptionsDef),
            spacing: (0, $idDdm.number)
        }),
        format: (0, $idDdm.string),
        ...$d77b025aa58d633c$var$seriesLabelOptionsDefs
    },
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...$d77b025aa58d633c$var$without((0, $idDdm.fillOptionsDef), [
        "fill"
    ]),
    ...$d77b025aa58d633c$var$without((0, $idDdm.strokeOptionsDef), [
        "stroke"
    ]),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$funnelSeriesThemeableOptionsDef = {
    direction: (0, $idDdm.union)("horizontal", "vertical"),
    fills: (0, $idDdm.arrayOf)((0, $idDdm.colorUnion)),
    strokes: (0, $idDdm.arrayOf)((0, $idDdm.color)),
    showInMiniChart: (0, $idDdm.boolean),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    }),
    spacingRatio: (0, $idDdm.ratio),
    crisp: (0, $idDdm.boolean),
    dropOff: {
        enabled: (0, $idDdm.boolean),
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    },
    stageLabel: {
        rotation: (0, $idDdm.number),
        spacing: (0, $idDdm.positiveNumber),
        minSpacing: (0, $idDdm.positiveNumber),
        placement: (0, $idDdm.union)("before", "after"),
        avoidCollisions: (0, $idDdm.boolean),
        itemStyler: (0, $idDdm.callbackDefs)({
            ...(0, $idDdm.fontOptionsDef),
            spacing: (0, $idDdm.number)
        }),
        format: (0, $idDdm.string),
        ...$d77b025aa58d633c$var$seriesLabelOptionsDefs
    },
    label: $d77b025aa58d633c$var$seriesLabelOptionsDefs,
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    shadow: $d77b025aa58d633c$var$shadowOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...$d77b025aa58d633c$var$without((0, $idDdm.fillOptionsDef), [
        "fill"
    ]),
    ...$d77b025aa58d633c$var$without((0, $idDdm.strokeOptionsDef), [
        "stroke"
    ]),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$heatmapSeriesThemeableOptionsDef = {
    title: (0, $idDdm.string),
    textAlign: (0, $idDdm.union)("left", "center", "right"),
    verticalAlign: (0, $idDdm.union)("top", "middle", "bottom"),
    itemPadding: (0, $idDdm.positiveNumber),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef)
    }),
    showInMiniChart: (0, $idDdm.boolean),
    label: $d77b025aa58d633c$var$autoSizedLabelOptionsDefs,
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.strokeOptionsDef)
};
var $d77b025aa58d633c$var$ohlcSeriesThemeableOptionsDef = {
    showInMiniChart: (0, $idDdm.boolean),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    }),
    item: {
        up: {
            ...(0, $idDdm.strokeOptionsDef),
            ...(0, $idDdm.lineDashOptionsDef)
        },
        down: {
            ...(0, $idDdm.strokeOptionsDef),
            ...(0, $idDdm.lineDashOptionsDef)
        }
    },
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs
};
var $d77b025aa58d633c$var$mapLineSeriesThemeableOptionsDef = {
    maxStrokeWidth: (0, $idDdm.positiveNumber),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    }),
    sizeDomain: (0, $idDdm.arrayOf)((0, $idDdm.positiveNumber)),
    label: $d77b025aa58d633c$var$seriesLabelOptionsDefs,
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef),
    highlightStyle: {
        ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs.highlightStyle,
        ...(0, $idDdm.strokeOptionsDef)
    }
};
var $d77b025aa58d633c$var$mapLineBackgroundSeriesThemeableOptionsDef = {
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$mapMarkerSeriesThemeableOptionsDef = {
    colorRange: (0, $idDdm.arrayOf)((0, $idDdm.color)),
    maxSize: (0, $idDdm.positiveNumber),
    sizeDomain: (0, $idDdm.arrayOf)((0, $idDdm.positiveNumber)),
    label: {
        placement: (0, $idDdm.union)("top", "bottom", "left", "right"),
        ...$d77b025aa58d633c$var$seriesLabelOptionsDefs
    },
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$markerOptionsDefs, [
        "enabled"
    ]),
    highlightStyle: {
        ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs.highlightStyle,
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef)
    }
};
var $d77b025aa58d633c$var$mapShapeSeriesThemeableOptionsDef = {
    colorRange: (0, $idDdm.arrayOf)((0, $idDdm.color)),
    padding: (0, $idDdm.positiveNumber),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    }),
    label: $d77b025aa58d633c$var$autoSizedLabelOptionsDefs,
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef),
    highlightStyle: {
        ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs.highlightStyle,
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef)
    }
};
var $d77b025aa58d633c$var$mapShapeBackgroundSeriesThemeableOptionsDef = {
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$nightingaleSeriesThemeableOptionsDef = {
    cornerRadius: (0, $idDdm.positiveNumber),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef),
        cornerRadius: (0, $idDdm.positiveNumber)
    }),
    label: $d77b025aa58d633c$var$seriesLabelOptionsDefs,
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$pyramidSeriesThemeableOptionsDef = {
    direction: (0, $idDdm.union)("horizontal", "vertical"),
    aspectRatio: (0, $idDdm.positiveNumber),
    spacing: (0, $idDdm.positiveNumber),
    reverse: (0, $idDdm.boolean),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    }),
    fills: (0, $idDdm.arrayOf)((0, $idDdm.colorUnion)),
    strokes: (0, $idDdm.arrayOf)((0, $idDdm.color)),
    label: $d77b025aa58d633c$var$seriesLabelOptionsDefs,
    stageLabel: {
        spacing: (0, $idDdm.positiveNumber),
        placement: (0, $idDdm.union)("before", "after"),
        ...$d77b025aa58d633c$var$seriesLabelOptionsDefs
    },
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    shadow: $d77b025aa58d633c$var$shadowOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...$d77b025aa58d633c$var$without((0, $idDdm.fillOptionsDef), [
        "fill"
    ]),
    ...$d77b025aa58d633c$var$without((0, $idDdm.strokeOptionsDef), [
        "stroke"
    ]),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$radarAreaSeriesThemeableOptionsDef = {
    connectMissingData: (0, $idDdm.boolean),
    marker: $d77b025aa58d633c$var$markerOptionsDefs,
    label: $d77b025aa58d633c$var$seriesLabelOptionsDefs,
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$radarLineSeriesThemeableOptionsDef = {
    connectMissingData: (0, $idDdm.boolean),
    marker: $d77b025aa58d633c$var$markerOptionsDefs,
    label: $d77b025aa58d633c$var$seriesLabelOptionsDefs,
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$radialBarSeriesThemeableOptionsDef = {
    cornerRadius: (0, $idDdm.positiveNumber),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef),
        cornerRadius: (0, $idDdm.positiveNumber)
    }),
    label: $d77b025aa58d633c$var$seriesLabelOptionsDefs,
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$radialColumnSeriesThemeableOptionsDef = {
    cornerRadius: (0, $idDdm.positiveNumber),
    columnWidthRatio: (0, $idDdm.ratio),
    maxColumnWidthRatio: (0, $idDdm.ratio),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef),
        cornerRadius: (0, $idDdm.positiveNumber)
    }),
    label: $d77b025aa58d633c$var$seriesLabelOptionsDefs,
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$rangeAreaSeriesThemeableOptionsDef = {
    showInMiniChart: (0, $idDdm.boolean),
    connectMissingData: (0, $idDdm.boolean),
    interpolation: $d77b025aa58d633c$var$interpolationOptionsDefs,
    label: {
        ...$d77b025aa58d633c$var$seriesLabelOptionsDefs,
        padding: (0, $idDdm.positiveNumber),
        placement: (0, $idDdm.union)("inside", "outside")
    },
    marker: $d77b025aa58d633c$var$markerOptionsDefs,
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    shadow: $d77b025aa58d633c$var$shadowOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$rangeBarSeriesThemeableOptionsDef = {
    direction: (0, $idDdm.union)("horizontal", "vertical"),
    showInMiniChart: (0, $idDdm.boolean),
    cornerRadius: (0, $idDdm.positiveNumber),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef),
        cornerRadius: (0, $idDdm.positiveNumber)
    }),
    label: {
        ...$d77b025aa58d633c$var$seriesLabelOptionsDefs,
        padding: (0, $idDdm.positiveNumber),
        placement: (0, $idDdm.union)("inside", "outside")
    },
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    shadow: $d77b025aa58d633c$var$shadowOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$sankeySeriesThemeableOptionsDef = {
    fills: (0, $idDdm.arrayOf)((0, $idDdm.colorUnion)),
    strokes: (0, $idDdm.arrayOf)((0, $idDdm.color)),
    label: {
        ...$d77b025aa58d633c$var$seriesLabelOptionsDefs,
        spacing: (0, $idDdm.positiveNumber)
    },
    link: {
        itemStyler: (0, $idDdm.callbackDefs)({
            ...(0, $idDdm.fillOptionsDef),
            ...(0, $idDdm.strokeOptionsDef),
            ...(0, $idDdm.lineDashOptionsDef)
        }),
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    },
    node: {
        width: (0, $idDdm.positiveNumber),
        spacing: (0, $idDdm.positiveNumber),
        alignment: (0, $idDdm.union)("left", "center", "right", "justify"),
        itemStyler: (0, $idDdm.callbackDefs)({
            ...(0, $idDdm.fillOptionsDef),
            ...(0, $idDdm.strokeOptionsDef),
            ...(0, $idDdm.lineDashOptionsDef)
        }),
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    },
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs
};
var $d77b025aa58d633c$var$sunburstSeriesThemeableOptionsDef = {
    fills: (0, $idDdm.arrayOf)((0, $idDdm.colorUnion)),
    strokes: (0, $idDdm.arrayOf)((0, $idDdm.color)),
    colorRange: (0, $idDdm.arrayOf)((0, $idDdm.color)),
    sectorSpacing: (0, $idDdm.positiveNumber),
    cornerRadius: (0, $idDdm.positiveNumber),
    padding: (0, $idDdm.positiveNumber),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef)
    }),
    label: {
        spacing: (0, $idDdm.positiveNumber),
        ...$d77b025aa58d633c$var$autoSizedLabelOptionsDefs
    },
    secondaryLabel: $d77b025aa58d633c$var$autoSizedLabelOptionsDefs,
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    ...$d77b025aa58d633c$var$without((0, $idDdm.fillOptionsDef), [
        "fill"
    ]),
    ...$d77b025aa58d633c$var$without((0, $idDdm.strokeOptionsDef), [
        "stroke"
    ]),
    highlightStyle: {
        label: {
            color: (0, $idDdm.color)
        },
        secondaryLabel: {
            color: (0, $idDdm.color)
        },
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef)
    }
};
var $d77b025aa58d633c$var$treemapSeriesThemeableOptionsDef = {
    fills: (0, $idDdm.arrayOf)((0, $idDdm.colorUnion)),
    strokes: (0, $idDdm.arrayOf)((0, $idDdm.color)),
    colorRange: (0, $idDdm.arrayOf)((0, $idDdm.color)),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef)
    }),
    group: {
        gap: (0, $idDdm.positiveNumber),
        padding: (0, $idDdm.positiveNumber),
        cornerRadius: (0, $idDdm.positiveNumber),
        textAlign: (0, $idDdm.union)("left", "center", "right"),
        interactive: (0, $idDdm.boolean),
        label: {
            ...$d77b025aa58d633c$var$seriesLabelOptionsDefs,
            spacing: (0, $idDdm.positiveNumber)
        },
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef)
    },
    tile: {
        gap: (0, $idDdm.positiveNumber),
        padding: (0, $idDdm.positiveNumber),
        cornerRadius: (0, $idDdm.positiveNumber),
        textAlign: (0, $idDdm.union)("left", "center", "right"),
        verticalAlign: (0, $idDdm.union)("top", "middle", "bottom"),
        label: {
            ...$d77b025aa58d633c$var$seriesLabelOptionsDefs,
            spacing: (0, $idDdm.positiveNumber),
            lineHeight: (0, $idDdm.positiveNumber),
            minimumFontSize: (0, $idDdm.positiveNumber),
            wrapping: (0, $idDdm.union)("never", "always", "hyphenate", "on-space"),
            overflowStrategy: (0, $idDdm.union)("ellipsis", "hide")
        },
        secondaryLabel: {
            ...$d77b025aa58d633c$var$seriesLabelOptionsDefs,
            lineHeight: (0, $idDdm.positiveNumber),
            minimumFontSize: (0, $idDdm.positiveNumber),
            wrapping: (0, $idDdm.union)("never", "always", "hyphenate", "on-space"),
            overflowStrategy: (0, $idDdm.union)("ellipsis", "hide")
        },
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef)
    },
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    highlightStyle: {
        group: {
            label: {
                color: (0, $idDdm.color)
            },
            ...(0, $idDdm.fillOptionsDef),
            ...(0, $idDdm.strokeOptionsDef)
        },
        tile: {
            label: {
                color: (0, $idDdm.color)
            },
            secondaryLabel: {
                color: (0, $idDdm.color)
            },
            ...(0, $idDdm.fillOptionsDef),
            ...(0, $idDdm.strokeOptionsDef)
        }
    }
};
var $d77b025aa58d633c$var$waterfallSeriesItemOptionsDef = {
    name: (0, $idDdm.string),
    cornerRadius: (0, $idDdm.positiveNumber),
    itemStyler: (0, $idDdm.callbackDefs)({
        ...(0, $idDdm.fillOptionsDef),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef),
        cornerRadius: (0, $idDdm.positiveNumber)
    }),
    label: {
        ...$d77b025aa58d633c$var$seriesLabelOptionsDefs,
        padding: (0, $idDdm.positiveNumber),
        placement: (0, $idDdm.union)("inside-start", "inside-center", "inside-end", "outside-start", "outside-end")
    },
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    shadow: $d77b025aa58d633c$var$shadowOptionsDefs,
    ...(0, $idDdm.fillOptionsDef),
    ...(0, $idDdm.strokeOptionsDef),
    ...(0, $idDdm.lineDashOptionsDef)
};
var $d77b025aa58d633c$var$waterfallSeriesThemeableOptionsDef = {
    direction: (0, $idDdm.union)("horizontal", "vertical"),
    showInMiniChart: (0, $idDdm.boolean),
    item: {
        positive: $d77b025aa58d633c$var$waterfallSeriesItemOptionsDef,
        negative: $d77b025aa58d633c$var$waterfallSeriesItemOptionsDef,
        total: $d77b025aa58d633c$var$waterfallSeriesItemOptionsDef
    },
    line: {
        enabled: (0, $idDdm.boolean),
        ...(0, $idDdm.strokeOptionsDef),
        ...(0, $idDdm.lineDashOptionsDef)
    },
    tooltip: $d77b025aa58d633c$var$tooltipOptionsDefs,
    ...$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs
};
// packages/ag-charts-community/src/chart/themes/themeOptionsDef.ts
var $d77b025aa58d633c$var$serializableDate = (0, $idDdm.optionsDefs)({
    __type: (0, $idDdm.required)((0, $idDdm.constant)("date")),
    value: (0, $idDdm.or)((0, $idDdm.string), (0, $idDdm.number))
}, "a serializable date object");
var $d77b025aa58d633c$var$navigatorHandleOptionsDef = {
    width: (0, $idDdm.positiveNumber),
    height: (0, $idDdm.positiveNumber),
    grip: (0, $idDdm.boolean),
    fill: (0, $idDdm.color),
    stroke: (0, $idDdm.color),
    strokeWidth: (0, $idDdm.positiveNumber),
    cornerRadius: (0, $idDdm.positiveNumber)
};
var $d77b025aa58d633c$var$navigatorOptionsDef = {
    enabled: (0, $idDdm.boolean),
    height: (0, $idDdm.positiveNumber),
    spacing: (0, $idDdm.positiveNumber),
    cornerRadius: (0, $idDdm.number),
    mask: {
        fill: (0, $idDdm.color),
        fillOpacity: (0, $idDdm.ratio),
        stroke: (0, $idDdm.color),
        strokeWidth: (0, $idDdm.positiveNumber)
    },
    minHandle: $d77b025aa58d633c$var$navigatorHandleOptionsDef,
    maxHandle: $d77b025aa58d633c$var$navigatorHandleOptionsDef,
    miniChart: {
        enabled: (0, $idDdm.boolean),
        padding: {
            top: (0, $idDdm.positiveNumber),
            bottom: (0, $idDdm.positiveNumber)
        },
        label: {
            enabled: (0, $idDdm.boolean),
            avoidCollisions: (0, $idDdm.boolean),
            spacing: (0, $idDdm.positiveNumber),
            format: $d77b025aa58d633c$var$numberFormatValidator,
            formatter: (0, $idDdm.callback),
            interval: {
                minSpacing: (0, $idDdm.positiveNumber),
                maxSpacing: (0, $idDdm.positiveNumber),
                values: (0, $idDdm.array),
                step: (0, $idDdm.number)
            },
            ...(0, $idDdm.fontOptionsDef)
        },
        series: (0, $idDdm.defined)
    }
};
var $d77b025aa58d633c$var$cartesianAxesThemeDef = {
    number: {
        ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$numberAxisOptionsDefs, [
            "type",
            "crossLines"
        ]),
        top: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$numberAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        right: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$numberAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        bottom: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$numberAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        left: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$numberAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        crossLines: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$cartesianCrossLineOptionsDefs, [
            "type"
        ])
    },
    log: {
        ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$logAxisOptionsDefs, [
            "type",
            "crossLines"
        ]),
        top: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$logAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        right: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$logAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        bottom: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$logAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        left: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$logAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        crossLines: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$cartesianCrossLineOptionsDefs, [
            "type"
        ])
    },
    category: {
        ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$categoryAxisOptionsDefs, [
            "type",
            "crossLines"
        ]),
        top: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$categoryAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        right: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$categoryAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        bottom: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$categoryAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        left: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$categoryAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        crossLines: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$cartesianCrossLineOptionsDefs, [
            "type"
        ])
    },
    time: {
        ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$timeAxisOptionsDefs, [
            "type",
            "crossLines"
        ]),
        top: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$timeAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        right: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$timeAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        bottom: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$timeAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        left: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$timeAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        crossLines: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$cartesianCrossLineOptionsDefs, [
            "type"
        ])
    },
    "grouped-category": {
        ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$groupedCategoryAxisOptionsDefs, [
            "type"
        ]),
        top: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$groupedCategoryAxisOptionsDefs, [
            "type",
            "position"
        ]),
        right: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$groupedCategoryAxisOptionsDefs, [
            "type",
            "position"
        ]),
        bottom: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$groupedCategoryAxisOptionsDefs, [
            "type",
            "position"
        ]),
        left: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$groupedCategoryAxisOptionsDefs, [
            "type",
            "position"
        ]),
        crossLines: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$cartesianCrossLineOptionsDefs, [
            "type"
        ])
    },
    "unit-time": {
        ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$unitTimeAxisOptionsDefs, [
            "type",
            "crossLines"
        ]),
        top: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$unitTimeAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        right: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$unitTimeAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        bottom: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$unitTimeAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        left: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$unitTimeAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        crossLines: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$cartesianCrossLineOptionsDefs, [
            "type"
        ])
    },
    "ordinal-time": {
        ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$ordinalTimeAxisOptionsDefs, [
            "type",
            "crossLines"
        ]),
        top: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$ordinalTimeAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        right: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$ordinalTimeAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        bottom: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$ordinalTimeAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        left: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$ordinalTimeAxisOptionsDefs, [
            "type",
            "crossLines",
            "position"
        ]),
        crossLines: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$cartesianCrossLineOptionsDefs, [
            "type"
        ])
    }
};
var $d77b025aa58d633c$var$polarAxesThemeDef = {
    "angle-category": {
        ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$angleCategoryAxisOptionsDefs, [
            "type",
            "crossLines"
        ]),
        crossLines: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$commonCrossLineOptionsDefs, [
            "type"
        ])
    },
    "angle-number": {
        ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$angleNumberAxisOptionsDefs, [
            "type",
            "crossLines"
        ]),
        crossLines: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$commonCrossLineOptionsDefs, [
            "type"
        ])
    },
    "radius-category": {
        ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$radiusCategoryAxisOptionsDefs, [
            "type",
            "crossLines"
        ]),
        crossLines: {
            ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$commonCrossLineOptionsDefs, [
                "type"
            ]),
            label: {
                ...$d77b025aa58d633c$var$commonCrossLineLabelOptionsDefs,
                positionAngle: (0, $idDdm.number)
            }
        }
    },
    "radius-number": {
        ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$radiusNumberAxisOptionsDefs, [
            "type",
            "crossLines"
        ]),
        crossLines: {
            ...$d77b025aa58d633c$var$without($d77b025aa58d633c$var$commonCrossLineOptionsDefs, [
                "type"
            ]),
            label: {
                ...$d77b025aa58d633c$var$commonCrossLineLabelOptionsDefs,
                positionAngle: (0, $idDdm.number)
            }
        }
    }
};
var $d77b025aa58d633c$var$undocumentedSeriesOptionsDef = {
    visible: (0, $idDdm.boolean)
};
var $d77b025aa58d633c$var$themeOverridesOptionsDef = {
    common: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        axes: {
            ...$d77b025aa58d633c$var$cartesianAxesThemeDef,
            ...$d77b025aa58d633c$var$polarAxesThemeDef
        },
        annotations: {
            ...$d77b025aa58d633c$var$annotationOptionsDef,
            line: $d77b025aa58d633c$var$annotationLineStyleDefs,
            "horizontal-line": $d77b025aa58d633c$var$annotationCrossLineStyleDefs,
            "vertical-line": $d77b025aa58d633c$var$annotationCrossLineStyleDefs,
            "disjoint-channel": $d77b025aa58d633c$var$annotationDisjointChannelStyleDefs,
            "parallel-channel": $d77b025aa58d633c$var$annotationParallelChannelStyleDefs,
            "fibonacci-retracement": $d77b025aa58d633c$var$annotationFibonacciStylesDefs,
            "fibonacci-retracement-trend-based": $d77b025aa58d633c$var$annotationFibonacciStylesDefs,
            callout: $d77b025aa58d633c$var$annotationCalloutStylesDefs,
            comment: $d77b025aa58d633c$var$annotationCommentStylesDefs,
            note: $d77b025aa58d633c$var$annotationNoteStylesDefs,
            text: $d77b025aa58d633c$var$annotationTextStylesDef,
            arrow: $d77b025aa58d633c$var$annotationLineStyleDefs,
            "arrow-up": $d77b025aa58d633c$var$annotationShapeStylesDefs,
            "arrow-down": $d77b025aa58d633c$var$annotationShapeStylesDefs,
            "date-range": $d77b025aa58d633c$var$annotationMeasurerStylesDefs,
            "price-range": $d77b025aa58d633c$var$annotationMeasurerStylesDefs,
            "date-price-range": $d77b025aa58d633c$var$annotationMeasurerStylesDefs,
            "quick-date-price-range": $d77b025aa58d633c$var$annotationQuickMeasurerStylesDefs
        },
        chartToolbar: {
            enabled: (0, $idDdm.boolean)
        },
        initialState: {
            legend: (0, $idDdm.arrayOfDefs)({
                visible: (0, $idDdm.boolean),
                seriesId: (0, $idDdm.string),
                itemId: (0, $idDdm.string),
                legendItemName: (0, $idDdm.string)
            }, "legend state array"),
            zoom: {
                rangeX: {
                    start: (0, $idDdm.or)((0, $idDdm.number), $d77b025aa58d633c$var$serializableDate),
                    end: (0, $idDdm.or)((0, $idDdm.number), $d77b025aa58d633c$var$serializableDate)
                },
                rangeY: {
                    start: (0, $idDdm.or)((0, $idDdm.number), $d77b025aa58d633c$var$serializableDate),
                    end: (0, $idDdm.or)((0, $idDdm.number), $d77b025aa58d633c$var$serializableDate)
                },
                ratioX: {
                    start: (0, $idDdm.ratio),
                    end: (0, $idDdm.ratio)
                },
                ratioY: {
                    start: (0, $idDdm.ratio),
                    end: (0, $idDdm.ratio)
                },
                autoScaledAxes: (0, $idDdm.arrayOf)((0, $idDdm.constant)("y"))
            }
        }
    },
    line: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$cartesianAxesThemeDef,
        series: $d77b025aa58d633c$var$lineSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    scatter: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$cartesianAxesThemeDef,
        series: $d77b025aa58d633c$var$scatterSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    bubble: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$cartesianAxesThemeDef,
        series: $d77b025aa58d633c$var$bubbleSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    area: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$cartesianAxesThemeDef,
        series: $d77b025aa58d633c$var$areaSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    bar: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$cartesianAxesThemeDef,
        series: $d77b025aa58d633c$var$barSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    "box-plot": {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$cartesianAxesThemeDef,
        series: $d77b025aa58d633c$var$boxPlotSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    candlestick: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$cartesianAxesThemeDef,
        series: $d77b025aa58d633c$var$candlestickSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    "cone-funnel": {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$cartesianAxesThemeDef,
        series: $d77b025aa58d633c$var$coneFunnelSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    funnel: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$cartesianAxesThemeDef,
        series: $d77b025aa58d633c$var$funnelSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    ohlc: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$cartesianAxesThemeDef,
        series: $d77b025aa58d633c$var$ohlcSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    histogram: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$cartesianAxesThemeDef, [
            "category",
            "grouped-category",
            "ordinal-time",
            "unit-time"
        ]),
        series: $d77b025aa58d633c$var$histogramSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    heatmap: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$cartesianAxesThemeDef,
        series: $d77b025aa58d633c$var$heatmapSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    waterfall: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$cartesianAxesThemeDef,
        series: $d77b025aa58d633c$var$waterfallSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    "range-bar": {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$cartesianAxesThemeDef,
        series: $d77b025aa58d633c$var$rangeBarSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    "range-area": {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$cartesianAxesThemeDef,
        series: $d77b025aa58d633c$var$rangeAreaSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    donut: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        series: $d77b025aa58d633c$var$donutSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    pie: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        series: $d77b025aa58d633c$var$pieSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    "radar-line": {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$polarAxesThemeDef,
        series: $d77b025aa58d633c$var$radarLineSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    "radar-area": {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$polarAxesThemeDef,
        series: $d77b025aa58d633c$var$radarAreaSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    "radial-bar": {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$polarAxesThemeDef,
        series: $d77b025aa58d633c$var$radialBarSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    "radial-column": {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$polarAxesThemeDef,
        series: $d77b025aa58d633c$var$radialColumnSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    nightingale: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        axes: $d77b025aa58d633c$var$polarAxesThemeDef,
        series: $d77b025aa58d633c$var$nightingaleSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    sunburst: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        series: $d77b025aa58d633c$var$sunburstSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    treemap: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        series: $d77b025aa58d633c$var$treemapSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    "map-shape": {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        series: $d77b025aa58d633c$var$mapShapeSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    "map-line": {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        series: $d77b025aa58d633c$var$mapLineSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    "map-marker": {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        series: $d77b025aa58d633c$var$mapMarkerSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    "map-shape-background": {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        series: $d77b025aa58d633c$var$mapShapeBackgroundSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    "map-line-background": {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        series: $d77b025aa58d633c$var$mapLineBackgroundSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    sankey: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        series: $d77b025aa58d633c$var$sankeySeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    chord: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        series: $d77b025aa58d633c$var$chordSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    pyramid: {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        series: $d77b025aa58d633c$var$pyramidSeriesThemeableOptionsDef,
        navigator: $d77b025aa58d633c$var$navigatorOptionsDef,
        ...$d77b025aa58d633c$var$undocumentedSeriesOptionsDef
    },
    "radial-gauge": {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        ...$d77b025aa58d633c$var$radialGaugeSeriesThemeableOptionsDef,
        targets: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$radialGaugeTargetOptionsDef, [
            "value"
        ]),
        tooltip: {
            ...$d77b025aa58d633c$var$radialGaugeSeriesThemeableOptionsDef.tooltip,
            ...$d77b025aa58d633c$var$commonChartOptionsDefs.tooltip
        }
    },
    "linear-gauge": {
        ...$d77b025aa58d633c$var$commonChartOptionsDefs,
        ...$d77b025aa58d633c$var$linearGaugeSeriesThemeableOptionsDef,
        targets: $d77b025aa58d633c$var$without($d77b025aa58d633c$var$linearGaugeTargetOptionsDef, [
            "value"
        ]),
        tooltip: {
            ...$d77b025aa58d633c$var$linearGaugeSeriesThemeableOptionsDef.tooltip,
            ...$d77b025aa58d633c$var$commonChartOptionsDefs.tooltip
        }
    }
};
function $d77b025aa58d633c$var$mapValues2(object4, mapper) {
    const result = {};
    for (const key of Reflect.ownKeys(object4))result[key] = mapper(object4[key], key, object4);
    return result;
}
var $d77b025aa58d633c$var$themeOverridesOptionsWithOperatorsDef = $d77b025aa58d633c$var$mapValues2($d77b025aa58d633c$var$themeOverridesOptionsDef, function themeOperatorMapper(value, key) {
    if ((0, $idDdm.isSymbol)(key)) return value;
    if ((0, $idDdm.isFunction)(value)) return (0, $idDdm.or)(value, (0, $idDdm.themeOperator), (0, $idDdm.isSymbol));
    else if ((0, $idDdm.isObject)(value)) return (0, $idDdm.or)((0, $idDdm.optionsDefs)((0, $idDdm.unionSymbol) in value ? $d77b025aa58d633c$var$mapValues2(value, (val)=>(0, $idDdm.isObject)(val) ? $d77b025aa58d633c$var$mapValues2(val, themeOperatorMapper) : val) : $d77b025aa58d633c$var$mapValues2(value, themeOperatorMapper)), (0, $idDdm.themeOperator), (0, $idDdm.isSymbol));
    throw new Error(`Invalid theme override value: ${String(value)}`);
});
// packages/ag-charts-community/src/chart/themes/vividDark.ts
var $d77b025aa58d633c$var$VIVID_DARK_FILLS = {
    BLUE: "#0083ff",
    ORANGE: "#ff6600",
    GREEN: "#00af00",
    CYAN: "#00ccff",
    YELLOW: "#f7c700",
    VIOLET: "#ac26ff",
    GRAY: "#a7a7b7",
    MAGENTA: "#e800c5",
    BROWN: "#b54300",
    RED: "#ff0000"
};
var $d77b025aa58d633c$var$VIVID_DARK_STROKES = {
    BLUE: "#67b7ff",
    ORANGE: "#ffc24d",
    GREEN: "#5cc86f",
    CYAN: "#54ebff",
    VIOLET: "#fff653",
    YELLOW: "#c18aff",
    GRAY: "#aeaeae",
    MAGENTA: "#f078d4",
    BROWN: "#ba8438",
    RED: "#ff726e"
};
var $d77b025aa58d633c$var$VividDark = class extends $d77b025aa58d633c$var$DarkTheme {
    getDefaultColors() {
        return {
            fills: $d77b025aa58d633c$var$VIVID_DARK_FILLS,
            fillsFallback: Object.values($d77b025aa58d633c$var$VIVID_DARK_FILLS),
            strokes: $d77b025aa58d633c$var$VIVID_DARK_STROKES,
            sequentialColors: $d77b025aa58d633c$var$getSequentialColors($d77b025aa58d633c$var$VIVID_DARK_FILLS),
            divergingColors: [
                $d77b025aa58d633c$var$VIVID_DARK_FILLS.ORANGE,
                $d77b025aa58d633c$var$VIVID_DARK_FILLS.YELLOW,
                $d77b025aa58d633c$var$VIVID_DARK_FILLS.GREEN
            ],
            hierarchyColors: [],
            secondSequentialColors: [
                "#0083ff",
                "#0076e6",
                "#0069cc",
                "#005cb3",
                "#004f99",
                "#004280",
                "#003466",
                "#00274c"
            ],
            secondDivergingColors: [
                $d77b025aa58d633c$var$VIVID_DARK_FILLS.GREEN,
                $d77b025aa58d633c$var$VIVID_DARK_FILLS.YELLOW,
                $d77b025aa58d633c$var$VIVID_DARK_FILLS.RED
            ],
            secondHierarchyColors: [],
            up: {
                fill: $d77b025aa58d633c$var$VIVID_DARK_FILLS.GREEN,
                stroke: $d77b025aa58d633c$var$VIVID_DARK_STROKES.GREEN
            },
            down: {
                fill: $d77b025aa58d633c$var$VIVID_DARK_FILLS.RED,
                stroke: $d77b025aa58d633c$var$VIVID_DARK_STROKES.RED
            },
            neutral: {
                fill: $d77b025aa58d633c$var$VIVID_DARK_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$VIVID_DARK_STROKES.GRAY
            },
            altUp: {
                fill: $d77b025aa58d633c$var$VIVID_DARK_FILLS.BLUE,
                stroke: $d77b025aa58d633c$var$VIVID_DARK_STROKES.BLUE
            },
            altDown: {
                fill: $d77b025aa58d633c$var$VIVID_DARK_FILLS.ORANGE,
                stroke: $d77b025aa58d633c$var$VIVID_DARK_STROKES.ORANGE
            },
            altNeutral: {
                fill: $d77b025aa58d633c$var$VIVID_DARK_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$VIVID_DARK_STROKES.GRAY
            }
        };
    }
    getTemplateParameters() {
        const params = super.getTemplateParameters();
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR, $d77b025aa58d633c$var$VIVID_DARK_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$VIVID_DARK_FILLS.BLUE);
        return params;
    }
};
// packages/ag-charts-community/src/chart/themes/vividLight.ts
var $d77b025aa58d633c$var$VIVID_FILLS = {
    BLUE: "#0083ff",
    ORANGE: "#ff6600",
    GREEN: "#00af00",
    CYAN: "#00ccff",
    YELLOW: "#f7c700",
    VIOLET: "#ac26ff",
    GRAY: "#a7a7b7",
    MAGENTA: "#e800c5",
    BROWN: "#b54300",
    RED: "#ff0000"
};
var $d77b025aa58d633c$var$VIVID_STROKES = {
    BLUE: "#0f68c0",
    ORANGE: "#d47100",
    GREEN: "#007922",
    CYAN: "#009ac2",
    VIOLET: "#bca400",
    YELLOW: "#753cac",
    GRAY: "#646464",
    MAGENTA: "#9b2685",
    BROWN: "#6c3b00",
    RED: "#cb0021"
};
var $d77b025aa58d633c$var$VividLight = class extends $d77b025aa58d633c$var$ChartTheme {
    getDefaultColors() {
        return {
            ...super.getDefaultColors(),
            fills: $d77b025aa58d633c$var$VIVID_FILLS,
            fillsFallback: Object.values($d77b025aa58d633c$var$VIVID_FILLS),
            strokes: $d77b025aa58d633c$var$VIVID_STROKES,
            sequentialColors: $d77b025aa58d633c$var$getSequentialColors($d77b025aa58d633c$var$VIVID_FILLS),
            divergingColors: [
                $d77b025aa58d633c$var$VIVID_FILLS.ORANGE,
                $d77b025aa58d633c$var$VIVID_FILLS.YELLOW,
                $d77b025aa58d633c$var$VIVID_FILLS.GREEN
            ],
            hierarchyColors: [],
            secondSequentialColors: [
                "#0083ff",
                "#1a8fff",
                "#339cff",
                "#4da8ff",
                "#66b5ff",
                "#80c1ff",
                "#99cdff",
                "#b3daff"
            ],
            secondDivergingColors: [
                $d77b025aa58d633c$var$VIVID_FILLS.GREEN,
                $d77b025aa58d633c$var$VIVID_FILLS.YELLOW,
                $d77b025aa58d633c$var$VIVID_FILLS.RED
            ],
            secondHierarchyColors: [],
            up: {
                fill: $d77b025aa58d633c$var$VIVID_FILLS.GREEN,
                stroke: $d77b025aa58d633c$var$VIVID_STROKES.GREEN
            },
            down: {
                fill: $d77b025aa58d633c$var$VIVID_FILLS.RED,
                stroke: $d77b025aa58d633c$var$VIVID_STROKES.RED
            },
            neutral: {
                fill: $d77b025aa58d633c$var$VIVID_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$VIVID_STROKES.GRAY
            },
            altUp: {
                fill: $d77b025aa58d633c$var$VIVID_FILLS.BLUE,
                stroke: $d77b025aa58d633c$var$VIVID_STROKES.BLUE
            },
            altDown: {
                fill: $d77b025aa58d633c$var$VIVID_FILLS.ORANGE,
                stroke: $d77b025aa58d633c$var$VIVID_STROKES.ORANGE
            },
            altNeutral: {
                fill: $d77b025aa58d633c$var$VIVID_FILLS.GRAY,
                stroke: $d77b025aa58d633c$var$VIVID_STROKES.GRAY
            }
        };
    }
    getTemplateParameters() {
        const params = super.getTemplateParameters();
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR, $d77b025aa58d633c$var$VIVID_FILLS.BLUE);
        params.set($d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$VIVID_FILLS.BLUE);
        return params;
    }
};
// packages/ag-charts-community/src/chart/mapping/themes.ts
var $d77b025aa58d633c$var$lightTheme = $d77b025aa58d633c$var$simpleMemorize(()=>new $d77b025aa58d633c$var$ChartTheme());
var $d77b025aa58d633c$var$themeCacheDebug = $d77b025aa58d633c$var$Debug.create(true, "perf");
var $d77b025aa58d633c$var$cacheCallback = (status, fn, keys)=>{
    $d77b025aa58d633c$var$themeCacheDebug(`[CACHE] ChartTheme`, status, fn.name, keys);
};
var $d77b025aa58d633c$var$themes = {
    // darkThemes,
    "ag-default-dark": $d77b025aa58d633c$var$simpleMemorize(()=>new $d77b025aa58d633c$var$DarkTheme()),
    "ag-sheets-dark": $d77b025aa58d633c$var$simpleMemorize(()=>new $d77b025aa58d633c$var$SheetsDark(), $d77b025aa58d633c$var$cacheCallback),
    "ag-polychroma-dark": $d77b025aa58d633c$var$simpleMemorize(()=>new $d77b025aa58d633c$var$PolychromaDark(), $d77b025aa58d633c$var$cacheCallback),
    "ag-vivid-dark": $d77b025aa58d633c$var$simpleMemorize(()=>new $d77b025aa58d633c$var$VividDark(), $d77b025aa58d633c$var$cacheCallback),
    "ag-material-dark": $d77b025aa58d633c$var$simpleMemorize(()=>new $d77b025aa58d633c$var$MaterialDark(), $d77b025aa58d633c$var$cacheCallback),
    "ag-financial-dark": $d77b025aa58d633c$var$simpleMemorize(()=>new $d77b025aa58d633c$var$FinancialDark(), $d77b025aa58d633c$var$cacheCallback),
    // lightThemes,
    "ag-default": $d77b025aa58d633c$var$lightTheme,
    "ag-sheets": $d77b025aa58d633c$var$simpleMemorize(()=>new $d77b025aa58d633c$var$SheetsLight(), $d77b025aa58d633c$var$cacheCallback),
    "ag-polychroma": $d77b025aa58d633c$var$simpleMemorize(()=>new $d77b025aa58d633c$var$PolychromaLight(), $d77b025aa58d633c$var$cacheCallback),
    "ag-vivid": $d77b025aa58d633c$var$simpleMemorize(()=>new $d77b025aa58d633c$var$VividLight(), $d77b025aa58d633c$var$cacheCallback),
    "ag-material": $d77b025aa58d633c$var$simpleMemorize(()=>new $d77b025aa58d633c$var$MaterialLight(), $d77b025aa58d633c$var$cacheCallback),
    "ag-financial": $d77b025aa58d633c$var$simpleMemorize(()=>new $d77b025aa58d633c$var$FinancialLight(), $d77b025aa58d633c$var$cacheCallback)
};
var $d77b025aa58d633c$var$getChartTheme = $d77b025aa58d633c$var$simpleMemorize($d77b025aa58d633c$var$createChartTheme, $d77b025aa58d633c$var$cacheCallback);
function $d77b025aa58d633c$var$createChartTheme(value) {
    if (value instanceof $d77b025aa58d633c$var$ChartTheme) return value;
    else if (!$d77b025aa58d633c$var$validateStructure(value)) return $d77b025aa58d633c$var$lightTheme();
    if (value == null || typeof value === "string") {
        const stockTheme = $d77b025aa58d633c$var$themes[value ?? "ag-default"];
        if (stockTheme) return stockTheme();
        throw new Error(`Cannot find theme \`${value}\`.`);
    }
    const { cleared: cleared, invalid: invalid } = (0, $idDdm.validate)($d77b025aa58d633c$var$reduceThemeOptions(value), $d77b025aa58d633c$var$themeOptionsDef, "theme");
    for (const error of invalid)(0, $idDdm.Logger).warnOnce(String(error));
    const baseTheme = cleared?.baseTheme ? $d77b025aa58d633c$var$getChartTheme(cleared.baseTheme) : $d77b025aa58d633c$var$lightTheme();
    return cleared ? new baseTheme.constructor(cleared) : baseTheme;
}
function $d77b025aa58d633c$var$reduceThemeOptions(options) {
    if (!(0, $idDdm.isObject)(options) || !(0, $idDdm.isObject)(options.baseTheme)) return options;
    let maybeNested = options;
    let palette2;
    let params;
    const overrides = [];
    while(typeof maybeNested === "object"){
        palette2 ?? (palette2 = maybeNested.palette);
        params ?? (params = maybeNested.params);
        if (maybeNested.overrides) overrides.push(maybeNested.overrides);
        maybeNested = maybeNested.baseTheme;
    }
    return {
        baseTheme: maybeNested,
        overrides: $d77b025aa58d633c$var$mergeDefaults(...overrides),
        params: params,
        palette: palette2
    };
}
var $d77b025aa58d633c$var$themeOptionsDef = {
    baseTheme: (0, $idDdm.or)((0, $idDdm.string), (0, $idDdm.object)),
    overrides: $d77b025aa58d633c$var$themeOverridesOptionsWithOperatorsDef,
    params: {
        accentColor: (0, $idDdm.color),
        axisColor: (0, $idDdm.color),
        backgroundColor: (0, $idDdm.color),
        borderColor: (0, $idDdm.color),
        foregroundColor: (0, $idDdm.color),
        fontFamily: (0, $idDdm.fontFamilyFull),
        fontSize: (0, $idDdm.number),
        fontWeight: (0, $idDdm.or)((0, $idDdm.string), (0, $idDdm.number)),
        gridLineColor: (0, $idDdm.color),
        padding: (0, $idDdm.number),
        subtleTextColor: (0, $idDdm.color),
        textColor: (0, $idDdm.color),
        chromeBackgroundColor: (0, $idDdm.color),
        chromeFontFamily: (0, $idDdm.fontFamilyFull),
        chromeFontSize: (0, $idDdm.number),
        chromeFontWeight: (0, $idDdm.or)((0, $idDdm.string), (0, $idDdm.number)),
        chromeSubtleTextColor: (0, $idDdm.color),
        chromeTextColor: (0, $idDdm.color),
        inputBackgroundColor: (0, $idDdm.color),
        inputTextColor: (0, $idDdm.color),
        crosshairLabelBackgroundColor: (0, $idDdm.color),
        crosshairLabelTextColor: (0, $idDdm.color)
    },
    palette: {
        fills: (0, $idDdm.arrayOf)((0, $idDdm.colorUnion)),
        strokes: (0, $idDdm.arrayOf)((0, $idDdm.color)),
        up: {
            fill: (0, $idDdm.or)((0, $idDdm.color), (0, $idDdm.gradientStrict)),
            stroke: (0, $idDdm.color)
        },
        down: {
            fill: (0, $idDdm.or)((0, $idDdm.color), (0, $idDdm.gradientStrict)),
            stroke: (0, $idDdm.color)
        },
        neutral: {
            fill: (0, $idDdm.or)((0, $idDdm.color), (0, $idDdm.gradientStrict)),
            stroke: (0, $idDdm.color)
        }
    }
};
var $d77b025aa58d633c$var$themeNameValidator = (0, $idDdm.union)("ag-default", "ag-default-dark", "ag-sheets", "ag-sheets-dark", "ag-polychroma", "ag-polychroma-dark", "ag-vivid", "ag-vivid-dark", "ag-material", "ag-material-dark", "ag-financial", "ag-financial-dark");
function $d77b025aa58d633c$var$validateStructure(value) {
    const { invalid: invalid } = (0, $idDdm.validate)({
        theme: value
    }, {
        theme: (0, $idDdm.or)($d77b025aa58d633c$var$themeNameValidator, (0, $idDdm.object))
    });
    for (const error of invalid)(0, $idDdm.Logger).warnOnce(String(error));
    return invalid.length === 0;
}
// packages/ag-charts-community/src/module/optionsModule.ts
var $d77b025aa58d633c$var$stringFormat = (value)=>`'${value}'`;
var $d77b025aa58d633c$var$_ChartOptions = class _ChartOptions {
    constructor(currentUserOptions, newUserOptions, processedOverrides, specialOverrides, metadata, deltaOptions, stripSymbols = false){
        this.themeParameters = {};
        this.optionMetadata = metadata ?? {};
        this.processedOverrides = processedOverrides ?? {};
        let baseChartOptions = null;
        if (currentUserOptions instanceof _ChartOptions) {
            baseChartOptions = currentUserOptions;
            this.specialOverrides = baseChartOptions.specialOverrides;
            if (deltaOptions === void 0) deltaOptions = $d77b025aa58d633c$var$jsonDiff(baseChartOptions.userOptions, newUserOptions, _ChartOptions.JSON_DIFF_OPTS);
            this.userOptions = $d77b025aa58d633c$var$deepClone($d77b025aa58d633c$var$merge(deltaOptions, baseChartOptions.userOptions), {
                ..._ChartOptions.OPTIONS_CLONE_OPTS,
                seen: []
            });
        } else {
            this.userOptions = $d77b025aa58d633c$var$deepClone(currentUserOptions ?? newUserOptions, {
                ..._ChartOptions.OPTIONS_CLONE_OPTS,
                seen: []
            });
            this.specialOverrides = this.specialOverridesDefaults({
                ...specialOverrides
            });
        }
        if (stripSymbols) this.removeLeftoverSymbols(this.userOptions);
        let activeTheme, processedOptions, defaultAxes, fastDelta, themeParameters, annotationThemes, googleFonts;
        if (!stripSymbols && deltaOptions !== void 0 && _ChartOptions.isFastPathDelta(deltaOptions) && baseChartOptions != null) {
            ({ activeTheme: activeTheme, processedOptions: processedOptions, defaultAxes: defaultAxes, fastDelta: fastDelta } = this.fastSetup(deltaOptions, baseChartOptions));
            themeParameters = baseChartOptions.themeParameters;
            annotationThemes = baseChartOptions.annotationThemes;
        } else {
            _ChartOptions.perfDebug(`ChartOptions.slowSetup()`);
            ({ activeTheme: activeTheme, processedOptions: processedOptions, defaultAxes: defaultAxes, themeParameters: themeParameters, annotationThemes: annotationThemes, googleFonts: googleFonts } = this.slowSetup(processedOverrides, deltaOptions, stripSymbols));
        }
        this.activeTheme = activeTheme;
        this.processedOptions = processedOptions;
        this.defaultAxes = defaultAxes;
        this.fastDelta = fastDelta ?? void 0;
        this.themeParameters = themeParameters;
        this.annotationThemes = annotationThemes;
        this.googleFonts = googleFonts;
        $d77b025aa58d633c$var$Debug.inDevelopmentMode(()=>$d77b025aa58d633c$var$deepFreeze(this));
    }
    static isFastPathDelta(deltaOptions) {
        for (const key of Object.keys(deltaOptions ?? {}))if (!this.FAST_PATH_OPTIONS.has(key)) {
            _ChartOptions.perfDebug("ChartOptions.isFastPathDelta() - slow path required due to presence of: ", key);
            return false;
        }
        _ChartOptions.perfDebug(`ChartOptions.isFastPathDelta() - fast path possible.`);
        return true;
    }
    fastSetup(deltaOptions, baseChartOptions) {
        const { activeTheme: activeTheme, defaultAxes: defaultAxes, processedOptions: baseOptions } = baseChartOptions;
        const { presetType: presetType } = this.optionMetadata;
        if (presetType != null && deltaOptions?.data != null) {
            const presetDef = (0, $idDdm.ModuleRegistry).getPresetModule(presetType);
            if (presetDef?.processData) {
                const { series: series, data: data } = presetDef.processData(deltaOptions.data);
                deltaOptions = $d77b025aa58d633c$var$mergeDefaults({
                    series: series,
                    data: data
                }, deltaOptions);
            }
        }
        this.fastSeriesSetup(deltaOptions, baseOptions);
        const processedOptions = $d77b025aa58d633c$var$mergeDefaults(deltaOptions, baseOptions);
        _ChartOptions.debug("ChartOptions.fastSetup() - processed options", processedOptions);
        return {
            activeTheme: activeTheme,
            defaultAxes: defaultAxes,
            processedOptions: processedOptions,
            fastDelta: deltaOptions
        };
    }
    fastSeriesSetup(deltaOptions, baseOptions) {
        if (!deltaOptions?.series) return;
        if (deltaOptions.series?.every((s, i)=>$d77b025aa58d633c$var$jsonPropertyCompare(s, baseOptions.series?.[i] ?? {}))) delete deltaOptions["series"];
        else deltaOptions.series = deltaOptions.series.map((s, i)=>{
            return $d77b025aa58d633c$var$merge(s, baseOptions.series?.[i] ?? {});
        });
    }
    slowSetup(processedOverrides, deltaOptions, stripSymbols = false) {
        let options = $d77b025aa58d633c$var$deepClone(this.userOptions, _ChartOptions.OPTIONS_CLONE_OPTS);
        if (deltaOptions) {
            options = $d77b025aa58d633c$var$mergeDefaults(deltaOptions, options);
            if (stripSymbols) this.removeLeftoverSymbols(options);
        }
        const { presetType: presetType } = this.optionMetadata;
        if (presetType != null) {
            const presetDef = (0, $idDdm.ModuleRegistry).getPresetModule(presetType);
            if (presetDef) {
                const { validate: validatePreset = (0, $idDdm.validate) } = presetDef;
                const presetParams = options;
                const presetSubType = options.type;
                const presetTheme = presetSubType != null ? $d77b025aa58d633c$var$getChartTheme(options.theme).presets[presetSubType] : void 0;
                const { cleared: cleared, invalid: invalid } = validatePreset(presetParams, presetDef.options, "");
                invalid.forEach((error)=>(0, $idDdm.Logger).warn(error));
                if ((0, $idDdm.hasRequiredInPath)(invalid, "")) options = {};
                else {
                    _ChartOptions.debug(">>> AgCharts.createOrUpdate() - applying preset", cleared);
                    options = presetDef.create(cleared, presetTheme, ()=>this.activeTheme);
                }
            }
        }
        this.soloSeriesIntegrity(options);
        if (!$d77b025aa58d633c$var$enterpriseModule.isEnterprise) $d77b025aa58d633c$var$removeUsedEnterpriseOptions(options);
        const activeTheme = $d77b025aa58d633c$var$getChartTheme(options.theme);
        if (presetType != null) activeTheme.templateTheme(options, false);
        this.validateSeriesOptions(options);
        this.chartDef = (0, $idDdm.ModuleRegistry).detectChartDefinition(options);
        if (!this.chartDef.placeholder) {
            const { validate: validateChart = (0, $idDdm.validate) } = this.chartDef;
            const { cleared: cleared, invalid: invalid } = validateChart(options, this.chartDef.options, "");
            invalid.forEach((error)=>(0, $idDdm.Logger).warn(error));
            options = cleared;
        }
        this.validateAxesOptions(options);
        this.removeDisabledOptions(options);
        const seriesType = this.optionsType(options);
        const { annotations: annotations = {}, axes: axesThemes = {}, series: seriesTheme, ...themeDefaults } = this.getSeriesThemeConfig(seriesType, activeTheme);
        const [annotationsOptions, annotationsThemes] = this.splitAnnotationsOptions(annotations);
        const annotationThemes = $d77b025aa58d633c$var$deepClone(annotationsThemes);
        const defaultAxes = this.getDefaultAxes(options, seriesTheme);
        let processedOptions = $d77b025aa58d633c$var$mergeDefaults(processedOverrides, options, annotationsOptions, themeDefaults, defaultAxes);
        this.processAxesOptions(processedOptions, axesThemes);
        this.processSeriesOptions(processedOptions, activeTheme);
        processedOptions = $d77b025aa58d633c$var$deepClone(processedOptions, _ChartOptions.OPTIONS_CLONE_OPTS);
        if (($d77b025aa58d633c$var$isAgCartesianChartOptions(processedOptions) || $d77b025aa58d633c$var$isAgStandaloneChartOptions(processedOptions) || $d77b025aa58d633c$var$isAgPolarChartOptionsWithSeriesBasedLegend(processedOptions)) && processedOptions.legend?.enabled == null) {
            processedOptions.legend ?? (processedOptions.legend = {});
            processedOptions.legend.enabled = processedOptions.series.length > 1;
        }
        this.enableConfiguredOptions(processedOptions, options);
        let googleFonts = this.processFonts(processedOptions);
        const themeParameters = activeTheme.params;
        googleFonts = this.processFonts(themeParameters, googleFonts);
        themeParameters.__palette = $d77b025aa58d633c$var$deepClone(activeTheme.palette);
        themeParameters.__palette.type = (0, $idDdm.isObject)(options.theme) ? $d77b025aa58d633c$var$paletteType(options.theme?.palette) : "inbuilt";
        this.resolveThemeOperations(themeParameters, themeParameters);
        this.resolveThemeOperations(themeParameters, processedOptions);
        this.resolveThemeOperations(themeParameters, annotationThemes);
        activeTheme.templateTheme(processedOptions, false);
        $d77b025aa58d633c$var$removeUnusedEnterpriseOptions(processedOptions);
        if (!$d77b025aa58d633c$var$enterpriseModule.isEnterprise) $d77b025aa58d633c$var$removeUsedEnterpriseOptions(processedOptions, true);
        this.validateSeriesOptions(processedOptions);
        this.validateAxesOptions(processedOptions);
        this.validatePluginOptions(processedOptions);
        this.processMiniChartSeriesOptions(processedOptions);
        if (!processedOptions.loadGoogleFonts) googleFonts.clear();
        _ChartOptions.debug(()=>[
                "ChartOptions.slowSetup() - processed options",
                $d77b025aa58d633c$var$deepClone(processedOptions)
            ]);
        return {
            activeTheme: activeTheme,
            processedOptions: processedOptions,
            defaultAxes: defaultAxes,
            themeParameters: themeParameters,
            annotationThemes: annotationThemes,
            googleFonts: googleFonts
        };
    }
    validatePluginOptions(options) {
        for (const pluginDef of (0, $idDdm.ModuleRegistry).listModulesByType((0, $idDdm.ModuleType).Plugin)){
            const pluginKey = pluginDef.name;
            if (pluginKey in options && (!pluginDef.chartType || pluginDef.chartType === this.chartDef?.name)) {
                const { cleared: cleared, invalid: invalid } = (0, $idDdm.validate)(options[pluginKey], pluginDef.options, pluginDef.name);
                invalid.forEach((error)=>(0, $idDdm.Logger).warn(error));
                options[pluginKey] = cleared;
            }
        }
    }
    validateSeriesOptions(options) {
        const chartType = this.chartDef?.name;
        const validatedSeriesOptions = [];
        const seriesCount = options.series?.length ?? 0;
        let validSeriesTypes;
        for(let index = 0; index < seriesCount; index++){
            const keyPath = `series[${index}]`;
            const seriesOptions = options.series[index];
            const seriesDef = (0, $idDdm.ModuleRegistry).getSeriesModule(seriesOptions.type ?? "line");
            if (seriesDef == null) {
                validSeriesTypes ?? (validSeriesTypes = (0, $idDdm.joinFormatted)(Array.from((0, $idDdm.ModuleRegistry).listModulesByType((0, $idDdm.ModuleType).Series)).filter((def)=>!chartType || def.chartType === chartType).map((def)=>def.name), "or", $d77b025aa58d633c$var$stringFormat));
                (0, $idDdm.Logger).warn(`Unknown type \`${seriesOptions.type}\` at \`${keyPath}.type\`; expecting ${validSeriesTypes}, ignoring.`);
                continue;
            } else if (chartType && seriesDef.chartType !== chartType) {
                (0, $idDdm.Logger).warn(`Series type \`${seriesDef.name}\` at \`${keyPath}.type\` is not supported by chart type \`${chartType}\`, ignoring.`);
                continue;
            }
            const { validate: validateSeries = (0, $idDdm.validate) } = seriesDef;
            const { cleared: cleared, invalid: invalid } = validateSeries(seriesOptions, seriesDef.options, keyPath);
            invalid.forEach((error)=>(0, $idDdm.Logger).warn(error));
            if (!(0, $idDdm.hasRequiredInPath)(invalid, keyPath)) validatedSeriesOptions.push(cleared);
        }
        options.series = validatedSeriesOptions;
    }
    validateAxesOptions(options) {
        if (!("axes" in options) || !options.axes) return;
        const chartType = this.chartDef?.name;
        const validatedAxesOptions = [];
        const axesCount = options.axes.length ?? 0;
        let validAxesTypes;
        for(let index = 0; index < axesCount; index++){
            const keyPath = `axes[${index}]`;
            let axisOptions = options.axes[index];
            if (axisOptions.type === "time" && axisOptions.unit != null) axisOptions = {
                ...axisOptions,
                type: "unit-time"
            };
            const axisDef = (0, $idDdm.ModuleRegistry).getAxisModule(axisOptions.type);
            if (axisDef == null) {
                validAxesTypes ?? (validAxesTypes = (0, $idDdm.joinFormatted)(Array.from((0, $idDdm.ModuleRegistry).listModulesByType((0, $idDdm.ModuleType).Axis)).filter((def)=>def.chartType === chartType).map((def)=>def.name), "or", $d77b025aa58d633c$var$stringFormat));
                (0, $idDdm.Logger).warn(`Unknown type \`${axisOptions.type}\` at  \`${keyPath}.type\`; expecting one of ${validAxesTypes}, ignoring all axes options.`);
                delete options.axes;
                break;
            } else if (axisDef.chartType !== chartType) {
                (0, $idDdm.Logger).warn(`Axis type \`${axisDef.name}\` at  \`${keyPath}.type\` is not supported by chart type \`${chartType}\`, ignoring.`);
                break;
            }
            const { validate: validateAxis = (0, $idDdm.validate) } = axisDef;
            const { cleared: cleared, invalid: invalid } = validateAxis(axisOptions, axisDef.options, keyPath);
            invalid.forEach((error)=>(0, $idDdm.Logger).warn(error));
            if (!(0, $idDdm.hasRequiredInPath)(invalid, keyPath)) validatedAxesOptions.push(cleared);
        }
        options.axes = validatedAxesOptions;
    }
    diffOptions(other) {
        if (this === other) return {};
        if (other == null) return this.processedOptions;
        return this.fastDelta ?? $d77b025aa58d633c$var$jsonDiff(other.processedOptions, this.processedOptions, _ChartOptions.JSON_DIFF_OPTS);
    }
    getSeriesThemeConfig(seriesType, activeTheme) {
        return activeTheme?.config[seriesType] ?? {};
    }
    getDefaultAxes(options, seriesTheme) {
        const optionsType2 = this.optionsType(options);
        const firstSeriesOptions = options.series?.find((series)=>(series.type ?? "line") === optionsType2) ?? {};
        const axes = $d77b025aa58d633c$var$seriesRegistry.cloneDefaultAxes(optionsType2);
        $d77b025aa58d633c$var$jsonResolveOperations(axes, {}, void 0, $d77b025aa58d633c$var$mergeDefaults(firstSeriesOptions, seriesTheme));
        return axes;
    }
    optionsType(options) {
        return options.series?.[0]?.type ?? "line";
    }
    splitAnnotationsOptions(annotations) {
        const { axesButtons: axesButtons = null, enabled: enabled = null, optionsToolbar: optionsToolbar = null, toolbar: toolbar = null, ...annotationsThemes } = annotations;
        if (axesButtons == null && enabled == null && optionsToolbar == null && toolbar == null) return [
            {},
            annotationsThemes
        ];
        return [
            {
                annotations: {
                    axesButtons: axesButtons,
                    enabled: enabled,
                    optionsToolbar: optionsToolbar,
                    toolbar: toolbar
                }
            },
            annotationsThemes
        ];
    }
    processAxesOptions(options, axesThemes) {
        if (!("axes" in options)) return;
        options.axes = options.axes?.map((axis)=>{
            const { crossLines: crossLinesTheme, ...axisTheme } = $d77b025aa58d633c$var$mergeDefaults(axesThemes[axis.type]?.[axis.position], axesThemes[axis.type]);
            if (axis.crossLines) axis.crossLines = $d77b025aa58d633c$var$mergeArrayDefaults(axis.crossLines, crossLinesTheme);
            const gridLineStyle = axisTheme.gridLine?.style;
            if (axis.gridLine?.style && gridLineStyle?.length) axis.gridLine.style = axis.gridLine.style.map((style, index)=>style.stroke != null || style.lineDash != null ? $d77b025aa58d633c$var$mergeDefaults(style, gridLineStyle.at(index % gridLineStyle.length)) : style);
            const { top: _1, right: _2, bottom: _3, left: _4, ...axisOptions } = $d77b025aa58d633c$var$mergeDefaults(axis, axisTheme);
            return axisOptions;
        });
    }
    processSeriesOptions(options, activeTheme) {
        const defaultTooltipPosition = this.getTooltipPositionDefaults(options);
        const processedSeries = options.series?.map((series)=>{
            series.type ?? (series.type = "line");
            const { innerLabels: innerLabelsTheme, ...seriesTheme } = this.getSeriesThemeConfig(series.type, activeTheme).series ?? {};
            const seriesDef = (0, $idDdm.ModuleRegistry).getSeriesModule(series.type);
            const tooltipDefined = Boolean(seriesDef?.options.tooltip);
            const visibleDefined = Boolean(seriesDef?.options.visible);
            const defaultTooltipRange = tooltipDefined && this.getTooltipRangeDefaults(options, series.type);
            const seriesOptions = $d77b025aa58d633c$var$mergeDefaults(this.getSeriesGroupingOptions(series), series, tooltipDefined && defaultTooltipPosition, defaultTooltipRange, seriesTheme, visibleDefined && {
                visible: true
            });
            if (seriesOptions.innerLabels) seriesOptions.innerLabels = $d77b025aa58d633c$var$mergeArrayDefaults(seriesOptions.innerLabels, innerLabelsTheme);
            return seriesOptions;
        });
        options.series = this.setSeriesGroupingOptions(processedSeries ?? []);
    }
    processMiniChartSeriesOptions(options) {
        let miniChartSeries = options.navigator?.miniChart?.series;
        if (miniChartSeries == null) return;
        miniChartSeries = miniChartSeries.map((series)=>{
            series.type ?? (series.type = "line");
            return series;
        });
        options.navigator.miniChart.series = this.setSeriesGroupingOptions(miniChartSeries);
    }
    resolveThemeOperations(params, options) {
        const modifiedPaths = $d77b025aa58d633c$var$jsonResolveOperations(options, params, /* @__PURE__ */ new Set([
            "palette",
            "data",
            "theme"
        ]));
        _ChartOptions.debug("ChartOptions.resolveTheme()", modifiedPaths);
    }
    getSeriesGroupingOptions(series) {
        const groupable = $d77b025aa58d633c$var$seriesRegistry.isGroupable(series.type);
        const stackable = $d77b025aa58d633c$var$seriesRegistry.isStackable(series.type);
        const stackedByDefault = $d77b025aa58d633c$var$seriesRegistry.isStackedByDefault(series.type);
        if (series.grouped && !groupable) (0, $idDdm.Logger).warnOnce(`unsupported grouping of series type "${series.type}".`);
        if ((series.stacked || series.stackGroup) && !stackable) (0, $idDdm.Logger).warnOnce(`unsupported stacking of series type "${series.type}".`);
        let { grouped: grouped, stacked: stacked } = series;
        stacked ?? (stacked = (stackedByDefault || series.stackGroup != null) && !(groupable && grouped));
        grouped ?? (grouped = true);
        return {
            stacked: stackable && stacked,
            grouped: groupable && grouped && !(stackable && stacked)
        };
    }
    setSeriesGroupingOptions(allSeries) {
        const seriesGroups = this.getSeriesGrouping(allSeries);
        _ChartOptions.debug("ChartOptions.setSeriesGroupingOptions() - series grouping: ", seriesGroups);
        const groupIdx = {};
        const groupCount2 = seriesGroups.reduce((countMap, seriesGroup)=>{
            var _a;
            if (seriesGroup.groupType === "default" /* DEFAULT */ ) return countMap;
            countMap[_a = seriesGroup.seriesType] ?? (countMap[_a] = 0);
            countMap[seriesGroup.seriesType] += seriesGroup.groupType === "stack" /* STACK */  ? 1 : seriesGroup.series.length;
            return countMap;
        }, {});
        return seriesGroups.flatMap((seriesGroup)=>{
            var _a;
            groupIdx[_a = seriesGroup.seriesType] ?? (groupIdx[_a] = 0);
            switch(seriesGroup.groupType){
                case "stack" /* STACK */ :
                    {
                        const groupIndex = groupIdx[seriesGroup.seriesType]++;
                        return seriesGroup.series.map((series, stackIndex)=>Object.assign(series, {
                                seriesGrouping: {
                                    groupId: seriesGroup.groupId,
                                    groupIndex: groupIndex,
                                    groupCount: groupCount2[seriesGroup.seriesType],
                                    stackIndex: stackIndex,
                                    stackCount: seriesGroup.series.length
                                }
                            }));
                    }
                case "group" /* GROUP */ :
                    return seriesGroup.series.map((series)=>Object.assign(series, {
                            seriesGrouping: {
                                groupId: seriesGroup.groupId,
                                groupIndex: groupIdx[seriesGroup.seriesType]++,
                                groupCount: groupCount2[seriesGroup.seriesType],
                                stackIndex: 0,
                                stackCount: 0
                            }
                        }));
            }
            return seriesGroup.series;
        }).map(({ stacked: _, grouped: __, ...seriesOptions })=>seriesOptions);
    }
    getSeriesGroupId(series) {
        return [
            series.type,
            series.xKey,
            series.stacked ? series.stackGroup ?? "stacked" : "grouped"
        ].filter(Boolean).join("-");
    }
    getSeriesGrouping(allSeries) {
        const groupMap = /* @__PURE__ */ new Map();
        return allSeries.reduce((result, series)=>{
            const seriesType = series.type;
            if (!series.stacked && !series.grouped) result.push({
                groupType: "default" /* DEFAULT */ ,
                seriesType: seriesType,
                series: [
                    series
                ],
                groupId: "__default__"
            });
            else {
                const groupId = this.getSeriesGroupId(series);
                if (!groupMap.has(groupId)) {
                    const groupType = series.stacked ? "stack" /* STACK */  : "group" /* GROUP */ ;
                    const record = {
                        groupType: groupType,
                        seriesType: seriesType,
                        series: [],
                        groupId: groupId
                    };
                    groupMap.set(groupId, record);
                    result.push(record);
                }
                groupMap.get(groupId).series.push(series);
            }
            return result;
        }, []);
    }
    getTooltipPositionDefaults(options) {
        const position = options.tooltip?.position;
        if (!(0, $idDdm.isPlainObject)(position)) return;
        const { type: type, anchorTo: anchorTo, placement: placement, xOffset: xOffset, yOffset: yOffset } = position;
        const result = {};
        if ((0, $idDdm.isString)(type) && (0, $idDdm.isEnumValue)($d77b025aa58d633c$export$a277a8c996e5a5f6, type)) result.type = type;
        if ((0, $idDdm.isString)(anchorTo) && (0, $idDdm.isEnumValue)($d77b025aa58d633c$export$72d20be677f065cb, anchorTo)) result.anchorTo = anchorTo;
        if ((0, $idDdm.isString)(placement) && (0, $idDdm.isEnumValue)($d77b025aa58d633c$export$8febaa3e13abde89, placement)) result.placement = placement;
        if ((0, $idDdm.isFiniteNumber)(xOffset)) result.xOffset = xOffset;
        if ((0, $idDdm.isFiniteNumber)(yOffset)) result.yOffset = yOffset;
        return {
            tooltip: {
                position: result
            }
        };
    }
    // AG-11591 Support for new series-specific & legacy chart-global 'tooltip.range' options
    //
    // The `chart.series[].tooltip.range` option is a bit different for legacy reason. This use to be
    // global option (`chart.tooltip.range`) that could override the theme. But now, the tooltip range
    // option is series-specific.
    //
    // To preserve backward compatibility, the `chart.tooltip.range` theme default has been changed from
    // 'nearest' to undefined.
    getTooltipRangeDefaults(options, seriesType) {
        return {
            tooltip: {
                range: options.tooltip?.range ?? $d77b025aa58d633c$var$seriesRegistry.getTooltipDefauls(seriesType)?.range
            }
        };
    }
    soloSeriesIntegrity(options) {
        if (!(0, $idDdm.isArray)(options.series)) return;
        const allSeries = options.series;
        if (allSeries && allSeries.length > 1 && allSeries.some((series)=>$d77b025aa58d633c$var$seriesRegistry.isSolo(series.type))) {
            const mainSeriesType = this.optionsType(options);
            if ($d77b025aa58d633c$var$seriesRegistry.isSolo(mainSeriesType)) {
                (0, $idDdm.Logger).warn(`series[0] of type '${mainSeriesType}' is incompatible with other series types. Only processing series[0]`);
                options.series = allSeries.slice(0, 1);
            } else {
                const { solo: solo, nonSolo: nonSolo } = (0, $idDdm.groupBy)(allSeries, (s)=>$d77b025aa58d633c$var$seriesRegistry.isSolo(s.type) ? "solo" : "nonSolo");
                const rejects = (0, $idDdm.unique)(solo.map((s)=>s.type)).join(", ");
                (0, $idDdm.Logger).warn(`Unable to mix these series types with the lead series type: ${rejects}`);
                options.series = nonSolo;
            }
        }
    }
    static enableConfiguredJsonOptions(visitingUserOpts, visitingMergedOpts) {
        if (typeof visitingMergedOpts === "object" && "enabled" in visitingMergedOpts && !visitingMergedOpts._enabledFromTheme && visitingUserOpts.enabled == null) visitingMergedOpts.enabled = true;
    }
    static cleanupEnabledFromThemeJsonOptions(visitingMergedOpts) {
        if (visitingMergedOpts._enabledFromTheme != null) delete visitingMergedOpts._enabledFromTheme;
    }
    enableConfiguredOptions(options, userOptions) {
        $d77b025aa58d633c$var$jsonWalk(userOptions, _ChartOptions.enableConfiguredJsonOptions, /* @__PURE__ */ new Set([
            "data",
            "theme"
        ]), options);
        $d77b025aa58d633c$var$jsonWalk(options, _ChartOptions.cleanupEnabledFromThemeJsonOptions, /* @__PURE__ */ new Set([
            "data",
            "theme"
        ]));
    }
    static processFontOptions(node, _, __, googleFonts = /* @__PURE__ */ new Set()) {
        if (typeof node === "object" && "fontFamily" in node) {
            if (Array.isArray(node.fontFamily)) {
                const fontFamily = [];
                for (const font2 of node.fontFamily)if (typeof font2 === "object" && "googleFont" in font2) {
                    fontFamily.push(font2.googleFont);
                    googleFonts?.add(font2.googleFont);
                } else fontFamily.push(font2);
                node.fontFamily = fontFamily.join(", ");
            } else if (typeof node.fontFamily === "object" && "googleFont" in node.fontFamily) {
                node.fontFamily = node.fontFamily.googleFont;
                googleFonts?.add(node.fontFamily);
            }
        }
        return googleFonts;
    }
    processFonts(options, googleFonts = /* @__PURE__ */ new Set()) {
        return $d77b025aa58d633c$var$jsonWalk(options, _ChartOptions.processFontOptions, /* @__PURE__ */ new Set([
            "data",
            "theme"
        ]), void 0, void 0, googleFonts);
    }
    static removeDisabledOptionJson(optionsNode) {
        if ("enabled" in optionsNode && optionsNode.enabled === false) Object.keys(optionsNode).forEach((key)=>{
            if (key === "enabled") return;
            delete optionsNode[key];
        });
    }
    removeDisabledOptions(options) {
        $d77b025aa58d633c$var$jsonWalk(options, _ChartOptions.removeDisabledOptionJson, /* @__PURE__ */ new Set([
            "data",
            "theme",
            "contextMenu"
        ]));
    }
    static removeLeftoverSymbolsJson(optionsNode) {
        if (!optionsNode || !(0, $idDdm.isObject)(optionsNode)) return;
        for (const key of Object.keys(optionsNode)){
            const value = optionsNode[key];
            if ((0, $idDdm.isSymbol)(value)) delete optionsNode[key];
        }
    }
    removeLeftoverSymbols(options) {
        $d77b025aa58d633c$var$jsonWalk(options, _ChartOptions.removeLeftoverSymbolsJson, /* @__PURE__ */ new Set([
            "data"
        ]));
    }
    specialOverridesDefaults(options) {
        if (options.window == null) options.window = (0, $idDdm.getWindow)();
        else (0, $idDdm.setWindow)(options.window);
        if (options.document == null) options.document = (0, $idDdm.getDocument)();
        else (0, $idDdm.setDocument)(options.document);
        if (options.window == null) throw new Error("AG Charts - unable to resolve global window");
        if (options.document == null) throw new Error("AG Charts - unable to resolve global document");
        return options;
    }
};
$d77b025aa58d633c$var$_ChartOptions.OPTIONS_CLONE_OPTS = {
    shallow: /* @__PURE__ */ new Set([
        "data",
        "container"
    ]),
    assign: /* @__PURE__ */ new Set([
        "context",
        "theme"
    ])
};
$d77b025aa58d633c$var$_ChartOptions.JSON_DIFF_OPTS = /* @__PURE__ */ new Set([
    "data"
]);
$d77b025aa58d633c$var$_ChartOptions.perfDebug = $d77b025aa58d633c$var$Debug.create(true, "perf");
$d77b025aa58d633c$var$_ChartOptions.FAST_PATH_OPTIONS = /* @__PURE__ */ new Set([
    "data",
    "width",
    "height",
    "container"
]);
$d77b025aa58d633c$var$_ChartOptions.debug = $d77b025aa58d633c$var$Debug.create(true, "opts");
var $d77b025aa58d633c$var$ChartOptions = $d77b025aa58d633c$var$_ChartOptions;
// packages/ag-charts-community/src/util/pool.ts
var $d77b025aa58d633c$var$CLEANUP_TIMEOUT_MS = 1e3;
var $d77b025aa58d633c$var$_Pool = class _Pool {
    constructor(name, buildItem, releaseItem, destroyItem, maxPoolSize, cleanupTimeMs = $d77b025aa58d633c$var$CLEANUP_TIMEOUT_MS){
        this.name = name;
        this.buildItem = buildItem;
        this.releaseItem = releaseItem;
        this.destroyItem = destroyItem;
        this.maxPoolSize = maxPoolSize;
        this.cleanupTimeMs = cleanupTimeMs;
        this.freePool = [];
        this.busyPool = /* @__PURE__ */ new Set();
    }
    static getPool(name, buildItem, releaseItem, destroyItem, maxPoolSize) {
        if (!this.pools.has(name)) this.pools.set(name, new _Pool(name, buildItem, releaseItem, destroyItem, maxPoolSize));
        return this.pools.get(name);
    }
    isFull() {
        return this.freePool.length + this.busyPool.size >= this.maxPoolSize;
    }
    hasFree() {
        return this.freePool.length > 0;
    }
    obtain(params) {
        if (!this.hasFree() && this.isFull()) throw new Error("AG Charts - pool exhausted");
        let nextFree = this.freePool.pop();
        if (nextFree == null) {
            nextFree = this.buildItem(params);
            _Pool.debug(()=>[
                    `Pool[name=${this.name}]: Created instance (${this.freePool.length} / ${this.busyPool.size + 1} / ${this.maxPoolSize})`,
                    nextFree
                ]);
        } else _Pool.debug(()=>[
                `Pool[name=${this.name}]: Re-used instance (${this.freePool.length} / ${this.busyPool.size + 1} / ${this.maxPoolSize})`,
                nextFree
            ]);
        this.busyPool.add(nextFree);
        return {
            item: nextFree,
            release: ()=>this.release(nextFree)
        };
    }
    obtainFree() {
        const nextFree = this.freePool.pop();
        if (nextFree == null) throw new Error("AG Charts - pool has no free instances");
        _Pool.debug(()=>[
                `Pool[name=${this.name}]: Re-used instance (${this.freePool.length} / ${this.busyPool.size + 1} / ${this.maxPoolSize})`,
                nextFree
            ]);
        this.busyPool.add(nextFree);
        return {
            item: nextFree,
            release: ()=>this.release(nextFree)
        };
    }
    release(item) {
        if (!this.busyPool.has(item)) throw new Error("AG Charts - cannot free item from pool which is not tracked as busy.");
        _Pool.debug(()=>[
                `Pool[name=${this.name}]: Releasing instance (${this.freePool.length} / ${this.busyPool.size} / ${this.maxPoolSize})`,
                item
            ]);
        this.releaseItem(item);
        this.busyPool.delete(item);
        this.freePool.push(item);
        _Pool.debug(()=>[
                `Pool[name=${this.name}]: Returned instance to free pool (${this.freePool.length} / ${this.busyPool.size} / ${this.maxPoolSize})`,
                item
            ]);
        const now = Date.now();
        const earliestClean = now + this.cleanupTimeMs * 0.5;
        if (this.cleanPoolTimer && (this.cleanPoolDue ?? Infinity) < earliestClean) {
            clearTimeout(this.cleanPoolTimer);
            this.cleanPoolTimer = void 0;
        }
        if (!this.cleanPoolTimer) {
            this.cleanPoolDue = now + this.cleanupTimeMs;
            this.cleanPoolTimer = setTimeout(this.cleanPool.bind(this), this.cleanupTimeMs);
        }
    }
    cleanPool() {
        const itemsToFree = this.freePool.splice(0);
        for (const item of itemsToFree)this.destroyItem(item);
        _Pool.debug(()=>[
                `Pool[name=${this.name}]: Cleaned pool of ${itemsToFree.length} items (${this.freePool.length} / ${this.busyPool.size} / ${this.maxPoolSize})`
            ]);
    }
    destroy() {
        this.cleanPool();
        for (const item of this.busyPool.values())this.destroyItem(item);
        this.busyPool.clear();
    }
};
$d77b025aa58d633c$var$_Pool.pools = /* @__PURE__ */ new Map();
$d77b025aa58d633c$var$_Pool.debug = $d77b025aa58d633c$var$Debug.create(true, "pool");
var $d77b025aa58d633c$var$Pool = $d77b025aa58d633c$var$_Pool;
// packages/ag-charts-community/src/api/agCharts.ts
(0, $idDdm.ModuleRegistry).registerMany($d77b025aa58d633c$var$AllCommunityModules);
var $d77b025aa58d633c$var$debug3 = $d77b025aa58d633c$var$Debug.create(true, "opts");
var $d77b025aa58d633c$export$e93fe4969a168dc7 = class {
    static licenseCheck(options) {
        if (this.licenseChecked) return;
        this.licenseManager = $d77b025aa58d633c$var$enterpriseModule.licenseManager?.(options);
        this.licenseManager?.validateLicense();
        this.licenseChecked = true;
    }
    static getLicenseDetails(licenseKey) {
        return $d77b025aa58d633c$var$enterpriseModule.licenseManager?.({}).getLicenseDetails(licenseKey);
    }
    /**
   * Returns the `AgChartInstance` for a DOM node, if there is one.
   */ static getInstance(element2) {
        return $d77b025aa58d633c$var$AgChartsInternal.getInstance(element2);
    }
    /**
   * Create a new `AgChartInstance` based upon the given configuration options.
   */ static create(userOptions, optionsMetadata) {
        return $d77b025aa58d633c$var$debug3.group("AgCharts.create()", ()=>{
            userOptions = $d77b025aa58d633c$var$Debug.inDevelopmentMode(()=>$d77b025aa58d633c$var$deepFreeze($d77b025aa58d633c$var$deepClone(userOptions))) ?? userOptions;
            this.licenseCheck(userOptions);
            const chart = $d77b025aa58d633c$var$AgChartsInternal.createOrUpdate({
                userOptions: userOptions,
                licenseManager: this.licenseManager,
                optionsMetadata: optionsMetadata
            });
            if (this.licenseManager?.isDisplayWatermark() && this.licenseManager) $d77b025aa58d633c$var$enterpriseModule.injectWatermark?.(chart.chart.ctx.domManager, this.licenseManager.getWatermarkMessage());
            return chart;
        });
    }
    static createFinancialChart(options) {
        return $d77b025aa58d633c$var$debug3.group("AgCharts.createFinancialChart()", ()=>{
            return this.create(options, {
                presetType: "price-volume"
            });
        });
    }
    static createGauge(options) {
        return $d77b025aa58d633c$var$debug3.group("AgCharts.createGauge()", ()=>{
            return this.create(options, {
                presetType: "gauge-preset"
            });
        });
    }
    static __createSparkline(options) {
        return $d77b025aa58d633c$var$debug3.group("AgCharts.__createSparkline()", ()=>{
            const { pool: pool, ...normalOptions } = options;
            return this.create(normalOptions, {
                presetType: "sparkline",
                pool: pool ?? true,
                domMode: "minimal"
            });
        });
    }
};
$d77b025aa58d633c$export$e93fe4969a168dc7.licenseChecked = false;
var $d77b025aa58d633c$var$_AgChartsInternal = class _AgChartsInternal {
    static getInstance(element2) {
        const chart = $d77b025aa58d633c$var$Chart.getInstance(element2);
        return chart ? $d77b025aa58d633c$var$AgChartInstanceProxy.chartInstances.get(chart) : void 0;
    }
    static initialiseModules() {
        if (_AgChartsInternal.initialised) return;
        $d77b025aa58d633c$export$2f274d5ba325cdcd();
        $d77b025aa58d633c$var$setupModules();
        _AgChartsInternal.initialised = true;
    }
    static createOrUpdate(opts) {
        let { proxy: proxy } = opts;
        const { userOptions: userOptions, licenseManager: licenseManager, processedOverrides: processedOverrides = proxy?.chart?.chartOptions.processedOverrides ?? {}, specialOverrides: specialOverrides = proxy?.chart?.chartOptions.specialOverrides ?? {}, optionsMetadata: optionsMetadata = proxy?.chart?.chartOptions.optionMetadata ?? {}, deltaOptions: deltaOptions, stripSymbols: stripSymbols = false } = opts;
        const styles = $d77b025aa58d633c$var$enterpriseModule.styles != null ? [
            [
                "ag-charts-enterprise",
                $d77b025aa58d633c$var$enterpriseModule.styles
            ]
        ] : [];
        const { presetType: presetType } = optionsMetadata;
        _AgChartsInternal.initialiseModules();
        $d77b025aa58d633c$var$debug3(()=>[
                ">>> AgCharts.createOrUpdate() user options",
                $d77b025aa58d633c$var$deepClone(userOptions)
            ]);
        let mutableOptions = userOptions;
        if ($d77b025aa58d633c$export$e93fe4969a168dc7.optionsMutationFn && mutableOptions) {
            mutableOptions = $d77b025aa58d633c$export$e93fe4969a168dc7.optionsMutationFn($d77b025aa58d633c$var$deepClone(mutableOptions), presetType);
            $d77b025aa58d633c$var$debug3(()=>[
                    ">>> AgCharts.createOrUpdate() MUTATED user options",
                    $d77b025aa58d633c$var$deepClone(mutableOptions)
                ]);
        }
        const pool = this.getPool(optionsMetadata);
        let create = false;
        let poolResult;
        let chart = proxy?.chart;
        if (chart == null && pool?.hasFree()) {
            poolResult = pool.obtainFree();
            chart = poolResult.item;
        }
        const { document: document2, window: userWindow, styleContainer: styleContainer, ...options } = mutableOptions ?? {};
        const baseOptions = chart?.getChartOptions();
        const chartOptions = new $d77b025aa58d633c$var$ChartOptions(baseOptions, options, processedOverrides, {
            ...specialOverrides,
            document: document2,
            window: userWindow,
            styleContainer: styleContainer
        }, optionsMetadata, deltaOptions, stripSymbols);
        if (chart == null || (0, $idDdm.ModuleRegistry).detectChartDefinition(chartOptions.processedOptions) !== (0, $idDdm.ModuleRegistry).detectChartDefinition(chart.chartOptions.processedOptions)) {
            poolResult?.release();
            poolResult = this.getPool(chartOptions.optionMetadata)?.obtain(chartOptions);
            if (poolResult) chart = poolResult.item;
            else {
                create = true;
                chart = _AgChartsInternal.createChartInstance(chartOptions, chart);
            }
        }
        styles.forEach(([id, css])=>{
            chart.ctx.domManager.addStyles(id, css);
        });
        chart.ctx.fontManager.updateFonts(chartOptions.googleFonts);
        if (proxy == null) {
            proxy = new $d77b025aa58d633c$var$AgChartInstanceProxy(chart, _AgChartsInternal.callbackApi, licenseManager);
            proxy.releaseChart = poolResult?.release;
        } else if (poolResult || create) {
            proxy.releaseChart?.();
            proxy.chart = chart;
            proxy.releaseChart = poolResult?.release;
        }
        if ($d77b025aa58d633c$var$debug3.check() && typeof window !== "undefined") {
            window.agChartInstances ?? (window.agChartInstances = {});
            window.agChartInstances[chart.id] = chart;
        }
        chart.queuedUserOptions.push(chartOptions.userOptions);
        chart.queuedChartOptions.push(chartOptions);
        chart.requestFactoryUpdate((chartRef)=>{
            $d77b025aa58d633c$var$debug3.group(">>>> Chart.applyOptions()", ()=>{
                chartRef.applyOptions(chartOptions);
                const queueIdx = chartRef.queuedUserOptions.indexOf(chartOptions.userOptions) + 1;
                chartRef.queuedUserOptions.splice(0, queueIdx);
                chartRef.queuedChartOptions.splice(0, queueIdx);
            });
        });
        return proxy;
    }
    static markRemovedProperties(node, _, modified = false) {
        if (typeof node !== "object") return modified;
        for (const key of Object.keys(node)){
            const value = node[key];
            if (typeof value === "undefined") {
                Object.assign(node, {
                    [key]: Symbol("UNSET")
                });
                modified || (modified = true);
            }
        }
        return modified;
    }
    static updateUserDelta(proxy, deltaOptions) {
        deltaOptions = $d77b025aa58d633c$var$deepClone(deltaOptions, $d77b025aa58d633c$var$ChartOptions.OPTIONS_CLONE_OPTS);
        const stripSymbols = $d77b025aa58d633c$var$jsonWalk(deltaOptions, _AgChartsInternal.markRemovedProperties, /* @__PURE__ */ new Set([
            "data"
        ]), void 0, void 0, false);
        $d77b025aa58d633c$var$debug3(()=>[
                ">>> AgCharts.updateUserDelta() user delta",
                $d77b025aa58d633c$var$deepClone(deltaOptions)
            ]);
        _AgChartsInternal.createOrUpdate({
            proxy: proxy,
            deltaOptions: deltaOptions,
            stripSymbols: stripSymbols
        });
    }
    static createChartInstance(options, oldChart) {
        const transferableResource = oldChart?.destroy({
            keepTransferableResources: true
        });
        const chartDef = (0, $idDdm.ModuleRegistry).detectChartDefinition(options.processedOptions);
        return chartDef.create(options, transferableResource);
    }
    static getPool(optionMetadata) {
        if (optionMetadata.pool !== true) return;
        return $d77b025aa58d633c$var$Pool.getPool(optionMetadata.presetType ?? "default", this.createChartInstance, this.detachAndClear, this.destroy, Infinity);
    }
};
$d77b025aa58d633c$var$_AgChartsInternal.caretaker = new $d77b025aa58d633c$var$MementoCaretaker($d77b025aa58d633c$export$a4ad2735b021c132);
$d77b025aa58d633c$var$_AgChartsInternal.initialised = false;
$d77b025aa58d633c$var$_AgChartsInternal.callbackApi = {
    caretaker: $d77b025aa58d633c$var$_AgChartsInternal.caretaker,
    create (userOptions, processedOverrides, specialOverrides, optionsMetadata) {
        return $d77b025aa58d633c$var$_AgChartsInternal.createOrUpdate({
            userOptions: userOptions,
            processedOverrides: processedOverrides,
            specialOverrides: specialOverrides,
            optionsMetadata: optionsMetadata
        });
    },
    update (opts, chart) {
        return $d77b025aa58d633c$var$_AgChartsInternal.createOrUpdate({
            userOptions: opts,
            proxy: chart
        });
    },
    updateUserDelta (chart, deltaOptions) {
        return $d77b025aa58d633c$var$_AgChartsInternal.updateUserDelta(chart, deltaOptions);
    }
};
$d77b025aa58d633c$var$_AgChartsInternal.detachAndClear = (chart)=>chart.detachAndClear();
$d77b025aa58d633c$var$_AgChartsInternal.destroy = (chart)=>chart.destroy();
var $d77b025aa58d633c$var$AgChartsInternal = $d77b025aa58d633c$var$_AgChartsInternal;
// packages/ag-charts-community/src/integrated-charts-scene.ts
var $d77b025aa58d633c$export$f88ced8f90c5ae15 = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$export$f88ced8f90c5ae15, {
    Arc: ()=>$d77b025aa58d633c$var$Arc2,
    BBox: ()=>$d77b025aa58d633c$var$BBox,
    Caption: ()=>$d77b025aa58d633c$var$Caption,
    CategoryScale: ()=>$d77b025aa58d633c$var$CategoryScale,
    Group: ()=>$d77b025aa58d633c$var$Group,
    Line: ()=>$d77b025aa58d633c$var$Line,
    LinearScale: ()=>$d77b025aa58d633c$var$LinearScale,
    Marker: ()=>$d77b025aa58d633c$var$Marker,
    Path: ()=>$d77b025aa58d633c$var$Path,
    RadialColumnShape: ()=>$d77b025aa58d633c$var$RadialColumnShape,
    Rect: ()=>$d77b025aa58d633c$var$Rect,
    Scene: ()=>$d77b025aa58d633c$var$Scene,
    Sector: ()=>$d77b025aa58d633c$var$Sector,
    Shape: ()=>$d77b025aa58d633c$var$Shape,
    TranslatableGroup: ()=>$d77b025aa58d633c$var$TranslatableGroup,
    getRadialColumnWidth: ()=>$d77b025aa58d633c$var$getRadialColumnWidth,
    toRadians: ()=>$d77b025aa58d633c$var$toRadians
});
var $d77b025aa58d633c$var$Arc2 = class extends $d77b025aa58d633c$var$Path {
    constructor(){
        super();
        this.centerX = 0;
        this.centerY = 0;
        this.radius = 10;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.counterClockwise = false;
        this.type = 0 /* Open */ ;
        this.restoreOwnStyles();
    }
    get fullPie() {
        return (0, $idDdm.isNumberEqual)($d77b025aa58d633c$var$normalizeAngle360(this.startAngle), $d77b025aa58d633c$var$normalizeAngle360(this.endAngle));
    }
    updatePath() {
        const path = this.path;
        path.clear();
        path.arc(this.centerX, this.centerY, this.radius, this.startAngle, this.endAngle, this.counterClockwise);
        if (this.type === 1 /* Chord */ ) path.closePath();
        else if (this.type === 2 /* Round */  && !this.fullPie) {
            path.lineTo(this.centerX, this.centerY);
            path.closePath();
        }
    }
    computeBBox() {
        return new $d77b025aa58d633c$var$BBox(this.centerX - this.radius, this.centerY - this.radius, this.radius * 2, this.radius * 2);
    }
    isPointInPath(x, y) {
        const bbox = this.getBBox();
        return this.type !== 0 /* Open */  && bbox.containsPoint(x, y) && this.path.isPointInPath(x, y);
    }
};
$d77b025aa58d633c$var$Arc2.className = "Arc";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Arc2.prototype, "centerX", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Arc2.prototype, "centerY", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Arc2.prototype, "radius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Arc2.prototype, "startAngle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Arc2.prototype, "endAngle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Arc2.prototype, "counterClockwise", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Arc2.prototype, "type", 2);
function $d77b025aa58d633c$var$rotatePoint(x, y, rotation) {
    const radius = Math.sqrt(x ** 2 + y ** 2);
    const angle2 = Math.atan2(y, x);
    const rotated = angle2 + rotation;
    return {
        x: Math.cos(rotated) * radius,
        y: Math.sin(rotated) * radius
    };
}
var $d77b025aa58d633c$var$RadialColumnShape = class extends $d77b025aa58d633c$var$Path {
    constructor(){
        super(...arguments);
        this.isBeveled = true;
        this.columnWidth = 0;
        this.startAngle = 0;
        this.endAngle = 0;
        this.outerRadius = 0;
        this.innerRadius = 0;
        this.axisInnerRadius = 0;
        this.axisOuterRadius = 0;
        this.isRadiusAxisReversed = false;
    }
    set cornerRadius(_value) {}
    computeBBox() {
        const { innerRadius: innerRadius, outerRadius: outerRadius, columnWidth: columnWidth } = this;
        const rotation = this.getRotation();
        const left = -columnWidth / 2;
        const right = columnWidth / 2;
        const top = -outerRadius;
        const bottom = -innerRadius;
        let x0 = Infinity;
        let y0 = Infinity;
        let x1 = -Infinity;
        let y1 = -Infinity;
        for(let i = 0; i < 4; i += 1){
            const { x: x, y: y } = $d77b025aa58d633c$var$rotatePoint(i % 2 === 0 ? left : right, i < 2 ? top : bottom, rotation);
            x0 = Math.min(x, x0);
            y0 = Math.min(y, y0);
            x1 = Math.max(x, x1);
            y1 = Math.max(y, y1);
        }
        return new $d77b025aa58d633c$var$BBox(x0, y0, x1 - x0, y1 - y0);
    }
    getRotation() {
        const { startAngle: startAngle, endAngle: endAngle } = this;
        const midAngle = $d77b025aa58d633c$var$angleBetween(startAngle, endAngle);
        return $d77b025aa58d633c$var$normalizeAngle360(startAngle + midAngle / 2 + Math.PI / 2);
    }
    updatePath() {
        const { isBeveled: isBeveled } = this;
        if (isBeveled) this.updateBeveledPath();
        else this.updateRectangularPath();
        this.checkPathDirty();
    }
    updateRectangularPath() {
        const { columnWidth: columnWidth, innerRadius: innerRadius, outerRadius: outerRadius, path: path } = this;
        const left = -columnWidth / 2;
        const right = columnWidth / 2;
        const top = -outerRadius;
        const bottom = -innerRadius;
        const rotation = this.getRotation();
        const points = [
            [
                left,
                bottom
            ],
            [
                left,
                top
            ],
            [
                right,
                top
            ],
            [
                right,
                bottom
            ]
        ].map(([x, y])=>$d77b025aa58d633c$var$rotatePoint(x, y, rotation));
        path.clear(true);
        path.moveTo(points[0].x, points[0].y);
        path.lineTo(points[1].x, points[1].y);
        path.lineTo(points[2].x, points[2].y);
        path.lineTo(points[3].x, points[3].y);
        path.closePath();
    }
    updateBeveledPath() {
        const { columnWidth: columnWidth, path: path, outerRadius: outerRadius, innerRadius: innerRadius, axisInnerRadius: axisInnerRadius, axisOuterRadius: axisOuterRadius, isRadiusAxisReversed: isRadiusAxisReversed } = this;
        const isStackBottom = (0, $idDdm.isNumberEqual)(innerRadius, axisInnerRadius);
        const sideRotation = Math.asin(columnWidth / 2 / innerRadius);
        const pointRotation = this.getRotation();
        const rotate2 = (x, y)=>$d77b025aa58d633c$var$rotatePoint(x, y, pointRotation);
        const getTriangleHypotenuse = (leg, otherLeg)=>Math.sqrt(leg ** 2 + otherLeg ** 2);
        const getTriangleLeg = (hypotenuse, otherLeg)=>{
            if (otherLeg > hypotenuse) return 0;
            return Math.sqrt(hypotenuse ** 2 - otherLeg ** 2);
        };
        const compare = (value, otherValue, lessThan6)=>lessThan6 ? value < otherValue : value > otherValue;
        const shouldConnectBottomCircle = isStackBottom && !isNaN(sideRotation) && sideRotation < Math.PI / 6;
        let left = -columnWidth / 2;
        let right = columnWidth / 2;
        const top = -outerRadius;
        const bottom = -innerRadius * (shouldConnectBottomCircle ? Math.cos(sideRotation) : 1);
        const hasBottomIntersection = compare(axisOuterRadius, getTriangleHypotenuse(innerRadius, columnWidth / 2), !isRadiusAxisReversed);
        if (hasBottomIntersection) {
            const bottomIntersectionX = getTriangleLeg(axisOuterRadius, innerRadius);
            left = -bottomIntersectionX;
            right = bottomIntersectionX;
        }
        path.clear(true);
        const bottomLeftPt = rotate2(left, bottom);
        path.moveTo(bottomLeftPt.x, bottomLeftPt.y);
        const isEmpty2 = (0, $idDdm.isNumberEqual)(innerRadius, outerRadius);
        const hasSideIntersection = compare(axisOuterRadius, getTriangleHypotenuse(outerRadius, columnWidth / 2), !isRadiusAxisReversed);
        if (isEmpty2 && shouldConnectBottomCircle) path.arc(0, 0, innerRadius, $d77b025aa58d633c$var$normalizeAngle360(-sideRotation - Math.PI / 2) + pointRotation, $d77b025aa58d633c$var$normalizeAngle360(sideRotation - Math.PI / 2) + pointRotation, false);
        else if (hasSideIntersection) {
            const sideIntersectionY = -getTriangleLeg(axisOuterRadius, columnWidth / 2);
            const topIntersectionX = getTriangleLeg(axisOuterRadius, outerRadius);
            if (!hasBottomIntersection) {
                const topLeftPt = rotate2(left, sideIntersectionY);
                path.lineTo(topLeftPt.x, topLeftPt.y);
            }
            path.arc(0, 0, axisOuterRadius, Math.atan2(sideIntersectionY, left) + pointRotation, Math.atan2(top, -topIntersectionX) + pointRotation, false);
            if (!(0, $idDdm.isNumberEqual)(topIntersectionX, 0)) {
                const topRightBevelPt = rotate2(topIntersectionX, top);
                path.lineTo(topRightBevelPt.x, topRightBevelPt.y);
            }
            path.arc(0, 0, axisOuterRadius, Math.atan2(top, topIntersectionX) + pointRotation, Math.atan2(sideIntersectionY, right) + pointRotation, false);
        } else {
            const topLeftPt = rotate2(left, top);
            const topRightPt = rotate2(right, top);
            path.lineTo(topLeftPt.x, topLeftPt.y);
            path.lineTo(topRightPt.x, topRightPt.y);
        }
        const bottomRightPt = rotate2(right, bottom);
        path.lineTo(bottomRightPt.x, bottomRightPt.y);
        if (shouldConnectBottomCircle) path.arc(0, 0, innerRadius, $d77b025aa58d633c$var$normalizeAngle360(sideRotation - Math.PI / 2) + pointRotation, $d77b025aa58d633c$var$normalizeAngle360(-sideRotation - Math.PI / 2) + pointRotation, true);
        else {
            const rotatedBottomLeftPt = rotate2(left, bottom);
            path.lineTo(rotatedBottomLeftPt.x, rotatedBottomLeftPt.y);
        }
        path.closePath();
    }
};
$d77b025aa58d633c$var$RadialColumnShape.className = "RadialColumnShape";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "isBeveled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "columnWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "startAngle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "endAngle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "outerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "innerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "axisInnerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "axisOuterRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "isRadiusAxisReversed", 2);
function $d77b025aa58d633c$var$getRadialColumnWidth(startAngle, endAngle, axisOuterRadius, columnWidthRatio, maxColumnWidthRatio) {
    const rotation = $d77b025aa58d633c$var$angleBetween(startAngle, endAngle);
    const pad2 = rotation * (1 - columnWidthRatio) / 2;
    startAngle += pad2;
    endAngle -= pad2;
    if (rotation < 1e-3) return 2 * axisOuterRadius * maxColumnWidthRatio;
    if (rotation >= 2 * Math.PI) {
        const midAngle = startAngle + rotation / 2;
        startAngle = midAngle - Math.PI;
        endAngle = midAngle + Math.PI;
    }
    const startX = axisOuterRadius * Math.cos(startAngle);
    const startY = axisOuterRadius * Math.sin(startAngle);
    const endX = axisOuterRadius * Math.cos(endAngle);
    const endY = axisOuterRadius * Math.sin(endAngle);
    const colWidth = Math.floor(Math.sqrt((startX - endX) ** 2 + (startY - endY) ** 2));
    const maxWidth = 2 * axisOuterRadius * maxColumnWidthRatio;
    return Math.max(1, Math.min(maxWidth, colWidth));
}
// packages/ag-charts-community/src/integrated-charts-theme.ts
var $d77b025aa58d633c$export$d23fb0bb3c916391 = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$export$d23fb0bb3c916391, {
    ChartTheme: ()=>$d77b025aa58d633c$var$ChartTheme,
    DEFAULT_ANNOTATION_HANDLE_FILL: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_HANDLE_FILL,
    DEFAULT_ANNOTATION_STATISTICS_COLOR: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_COLOR,
    DEFAULT_ANNOTATION_STATISTICS_DIVIDER_STROKE: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DIVIDER_STROKE,
    DEFAULT_ANNOTATION_STATISTICS_DOWN_FILL: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DOWN_FILL,
    DEFAULT_ANNOTATION_STATISTICS_DOWN_STROKE: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_DOWN_STROKE,
    DEFAULT_ANNOTATION_STATISTICS_FILL: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_FILL,
    DEFAULT_ANNOTATION_STATISTICS_STROKE: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_STATISTICS_STROKE,
    DEFAULT_CAPTION_ALIGNMENT: ()=>$d77b025aa58d633c$var$DEFAULT_CAPTION_ALIGNMENT,
    DEFAULT_CAPTION_LAYOUT_STYLE: ()=>$d77b025aa58d633c$var$DEFAULT_CAPTION_LAYOUT_STYLE,
    DEFAULT_FIBONACCI_STROKES: ()=>$d77b025aa58d633c$var$DEFAULT_FIBONACCI_STROKES,
    DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL: ()=>$d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL,
    DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR: ()=>$d77b025aa58d633c$var$DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR,
    DEFAULT_GRIDLINE_ENABLED: ()=>$d77b025aa58d633c$var$DEFAULT_GRIDLINE_ENABLED,
    DEFAULT_POLAR_SERIES_STROKE: ()=>$d77b025aa58d633c$var$DEFAULT_POLAR_SERIES_STROKE,
    DEFAULT_SEPARATION_LINES_COLOUR: ()=>$d77b025aa58d633c$var$DEFAULT_SEPARATION_LINES_COLOUR,
    DEFAULT_SHADOW_COLOUR: ()=>$d77b025aa58d633c$var$DEFAULT_SHADOW_COLOUR,
    DEFAULT_SPARKLINE_CROSSHAIR_STROKE: ()=>$d77b025aa58d633c$var$DEFAULT_SPARKLINE_CROSSHAIR_STROKE,
    DEFAULT_TEXTBOX_COLOR: ()=>$d77b025aa58d633c$var$DEFAULT_TEXTBOX_COLOR,
    DEFAULT_TEXTBOX_FILL: ()=>$d77b025aa58d633c$var$DEFAULT_TEXTBOX_FILL,
    DEFAULT_TEXTBOX_STROKE: ()=>$d77b025aa58d633c$var$DEFAULT_TEXTBOX_STROKE,
    DEFAULT_TEXT_ANNOTATION_COLOR: ()=>$d77b025aa58d633c$var$DEFAULT_TEXT_ANNOTATION_COLOR,
    DEFAULT_TOOLBAR_POSITION: ()=>$d77b025aa58d633c$var$DEFAULT_TOOLBAR_POSITION,
    IS_DARK_THEME: ()=>$d77b025aa58d633c$var$IS_DARK_THEME,
    PALETTE_ALT_DOWN_FILL: ()=>$d77b025aa58d633c$var$PALETTE_ALT_DOWN_FILL,
    PALETTE_ALT_DOWN_STROKE: ()=>$d77b025aa58d633c$var$PALETTE_ALT_DOWN_STROKE,
    PALETTE_ALT_NEUTRAL_FILL: ()=>$d77b025aa58d633c$var$PALETTE_ALT_NEUTRAL_FILL,
    PALETTE_ALT_NEUTRAL_STROKE: ()=>$d77b025aa58d633c$var$PALETTE_ALT_NEUTRAL_STROKE,
    PALETTE_ALT_UP_FILL: ()=>$d77b025aa58d633c$var$PALETTE_ALT_UP_FILL,
    PALETTE_ALT_UP_STROKE: ()=>$d77b025aa58d633c$var$PALETTE_ALT_UP_STROKE,
    PALETTE_DOWN_FILL: ()=>$d77b025aa58d633c$var$PALETTE_DOWN_FILL,
    PALETTE_DOWN_STROKE: ()=>$d77b025aa58d633c$var$PALETTE_DOWN_STROKE,
    PALETTE_NEUTRAL_FILL: ()=>$d77b025aa58d633c$var$PALETTE_NEUTRAL_FILL,
    PALETTE_NEUTRAL_STROKE: ()=>$d77b025aa58d633c$var$PALETTE_NEUTRAL_STROKE,
    PALETTE_UP_FILL: ()=>$d77b025aa58d633c$var$PALETTE_UP_FILL,
    PALETTE_UP_STROKE: ()=>$d77b025aa58d633c$var$PALETTE_UP_STROKE,
    getChartTheme: ()=>$d77b025aa58d633c$var$getChartTheme,
    resolveOperation: ()=>$d77b025aa58d633c$var$resolveOperation2,
    themeNames: ()=>$d77b025aa58d633c$var$themeNames,
    themeSymbols: ()=>$d77b025aa58d633c$var$symbols_exports,
    themes: ()=>$d77b025aa58d633c$var$themes
});
var $d77b025aa58d633c$var$themeNames = Object.keys($d77b025aa58d633c$var$themes);
function $d77b025aa58d633c$var$resolveOperation2(operation) {
    const params = $d77b025aa58d633c$var$ChartTheme.getDefaultPublicParameters();
    params.__palette = $d77b025aa58d633c$var$ChartTheme.getDefaultColors();
    const source = {
        operation: operation
    };
    $d77b025aa58d633c$var$jsonResolveOperations(source, params);
    return source.operation;
}
// packages/ag-charts-community/src/integrated-charts-util.ts
var $d77b025aa58d633c$export$48e12db5e55fd3a3 = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$export$48e12db5e55fd3a3, {
    Color: ()=>$d77b025aa58d633c$var$Color,
    interpolateColor: ()=>$d77b025aa58d633c$var$interpolateColor
});
// packages/ag-charts-community/src/module-support.ts
var $d77b025aa58d633c$export$d0f5d10b4c7de308 = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$export$d0f5d10b4c7de308, {
    AbstractBarSeries: ()=>$d77b025aa58d633c$var$AbstractBarSeries,
    AbstractBarSeriesProperties: ()=>$d77b025aa58d633c$var$AbstractBarSeriesProperties,
    ActionOnSet: ()=>$d77b025aa58d633c$var$ActionOnSet,
    AnchoredPopover: ()=>$d77b025aa58d633c$var$AnchoredPopover,
    Animation: ()=>$d77b025aa58d633c$var$Animation,
    AnimationManager: ()=>$d77b025aa58d633c$var$AnimationManager,
    Arc: ()=>$d77b025aa58d633c$var$Arc2,
    Axis: ()=>$d77b025aa58d633c$var$Axis,
    AxisGroupZIndexMap: ()=>$d77b025aa58d633c$var$AxisGroupZIndexMap,
    AxisInterval: ()=>$d77b025aa58d633c$var$AxisInterval,
    AxisLabel: ()=>$d77b025aa58d633c$var$AxisLabel,
    AxisTick: ()=>$d77b025aa58d633c$var$AxisTick,
    AxisTickGenerator: ()=>$d77b025aa58d633c$var$AxisTickGenerator,
    AxisTicks: ()=>$d77b025aa58d633c$var$AxisTicks,
    BBox: ()=>$d77b025aa58d633c$var$BBox,
    BBoxValues: ()=>$d77b025aa58d633c$var$BBoxValues,
    Background: ()=>$d77b025aa58d633c$var$Background,
    BackgroundModule: ()=>$d77b025aa58d633c$var$BackgroundModule,
    BandScale: ()=>$d77b025aa58d633c$var$BandScale,
    BarSeries: ()=>$d77b025aa58d633c$var$BarSeries,
    BarSeriesModule: ()=>$d77b025aa58d633c$var$BarSeriesModule,
    BaseModuleInstance: ()=>$d77b025aa58d633c$var$BaseModuleInstance,
    BaseProperties: ()=>$d77b025aa58d633c$var$BaseProperties,
    BaseToolbar: ()=>$d77b025aa58d633c$var$BaseToolbar,
    ButtonWidget: ()=>$d77b025aa58d633c$var$ButtonWidget,
    CachedTextMeasurer: ()=>$d77b025aa58d633c$var$CachedTextMeasurer,
    CachedTextMeasurerPool: ()=>$d77b025aa58d633c$var$CachedTextMeasurerPool,
    CallbackCache: ()=>$d77b025aa58d633c$var$CallbackCache,
    Caption: ()=>$d77b025aa58d633c$var$Caption,
    CartesianAxis: ()=>$d77b025aa58d633c$var$CartesianAxis,
    CartesianSeries: ()=>$d77b025aa58d633c$var$CartesianSeries,
    CartesianSeriesNodeEvent: ()=>$d77b025aa58d633c$var$CartesianSeriesNodeEvent,
    CartesianSeriesProperties: ()=>$d77b025aa58d633c$var$CartesianSeriesProperties,
    CategoryAxis: ()=>$d77b025aa58d633c$var$CategoryAxis,
    CategoryScale: ()=>$d77b025aa58d633c$var$CategoryScale,
    ChangeDetectableProperties: ()=>$d77b025aa58d633c$var$ChangeDetectableProperties,
    Chart: ()=>$d77b025aa58d633c$var$Chart,
    ChartAxisDirection: ()=>$d77b025aa58d633c$var$ChartAxisDirection,
    ChartEventManager: ()=>$d77b025aa58d633c$var$ChartEventManager,
    ChartOptions: ()=>$d77b025aa58d633c$var$ChartOptions,
    ChartUpdateType: ()=>$d77b025aa58d633c$var$ChartUpdateType,
    CollapseMode: ()=>$d77b025aa58d633c$var$CollapseMode,
    Color: ()=>$d77b025aa58d633c$var$Color,
    ColorScale: ()=>$d77b025aa58d633c$var$ColorScale,
    ConicGradient: ()=>$d77b025aa58d633c$var$ConicGradient,
    ContextMenuBuiltins: ()=>$d77b025aa58d633c$var$ContextMenuBuiltins,
    ContextMenuRegistry: ()=>$d77b025aa58d633c$var$ContextMenuRegistry,
    ContinuousScale: ()=>$d77b025aa58d633c$var$ContinuousScale,
    DEFAULT_CARTESIAN_DIRECTION_KEYS: ()=>$d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_KEYS,
    DEFAULT_CARTESIAN_DIRECTION_NAMES: ()=>$d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_NAMES,
    DEFAULT_TOOLTIP_CLASS: ()=>$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS,
    DEFAULT_TOOLTIP_DARK_CLASS: ()=>$d77b025aa58d633c$var$DEFAULT_TOOLTIP_DARK_CLASS,
    DIRECTION_SWAP_AXES: ()=>$d77b025aa58d633c$var$DIRECTION_SWAP_AXES,
    DOMManager: ()=>$d77b025aa58d633c$var$DOMManager,
    DataController: ()=>$d77b025aa58d633c$var$DataController,
    DataModel: ()=>$d77b025aa58d633c$var$DataModel,
    DataModelSeries: ()=>$d77b025aa58d633c$var$DataModelSeries,
    DataService: ()=>$d77b025aa58d633c$var$DataService,
    Debug: ()=>$d77b025aa58d633c$var$Debug,
    Deprecated: ()=>$d77b025aa58d633c$var$Deprecated,
    DeprecatedAndRenamedTo: ()=>$d77b025aa58d633c$var$DeprecatedAndRenamedTo,
    DiscreteTimeScale: ()=>$d77b025aa58d633c$var$DiscreteTimeScale,
    DragInterpreter: ()=>$d77b025aa58d633c$var$DragInterpreter,
    DraggablePopover: ()=>$d77b025aa58d633c$var$DraggablePopover,
    DropShadow: ()=>$d77b025aa58d633c$var$DropShadow,
    ExtendedPath2D: ()=>$d77b025aa58d633c$var$ExtendedPath2D,
    FILL_IMAGE_DEFAULTS: ()=>$d77b025aa58d633c$var$FILL_IMAGE_DEFAULTS,
    FILL_PATTERN_DEFAULTS: ()=>$d77b025aa58d633c$var$FILL_PATTERN_DEFAULTS,
    FONT_SIZE_RATIO: ()=>$d77b025aa58d633c$var$FONT_SIZE_RATIO,
    FillGradientDefaults: ()=>$d77b025aa58d633c$var$FillGradientDefaults,
    FillImageDefaults: ()=>$d77b025aa58d633c$var$FillImageDefaults,
    FillPatternDefaults: ()=>$d77b025aa58d633c$var$FillPatternDefaults,
    FloatingToolbar: ()=>$d77b025aa58d633c$var$FloatingToolbar,
    Gradient: ()=>$d77b025aa58d633c$var$Gradient,
    Group: ()=>$d77b025aa58d633c$var$Group,
    GroupedCategoryAxis: ()=>$d77b025aa58d633c$var$GroupedCategoryAxis,
    HdpiCanvas: ()=>$d77b025aa58d633c$var$HdpiCanvas,
    HierarchyNode: ()=>$d77b025aa58d633c$var$HierarchyNode,
    HierarchySeries: ()=>$d77b025aa58d633c$var$HierarchySeries,
    HierarchySeriesProperties: ()=>$d77b025aa58d633c$var$HierarchySeriesProperties,
    HighlightManager: ()=>$d77b025aa58d633c$var$HighlightManager,
    HighlightProperties: ()=>$d77b025aa58d633c$var$HighlightProperties,
    HighlightStyle: ()=>$d77b025aa58d633c$var$HighlightStyle,
    Image: ()=>$d77b025aa58d633c$var$Image3,
    InteractionManager: ()=>$d77b025aa58d633c$var$InteractionManager,
    InteractionState: ()=>$d77b025aa58d633c$var$InteractionState,
    InterpolationProperties: ()=>$d77b025aa58d633c$var$InterpolationProperties,
    Invalidating: ()=>$d77b025aa58d633c$var$Invalidating,
    LARGEST_KEY_INTERVAL: ()=>$d77b025aa58d633c$var$LARGEST_KEY_INTERVAL,
    Label: ()=>$d77b025aa58d633c$var$Label,
    LayoutElement: ()=>$d77b025aa58d633c$var$LayoutElement,
    LayoutManager: ()=>$d77b025aa58d633c$var$LayoutManager,
    LegendMarkerLabel: ()=>$d77b025aa58d633c$var$LegendMarkerLabel,
    Line: ()=>$d77b025aa58d633c$var$Line,
    LineSeries: ()=>$d77b025aa58d633c$var$LineSeries,
    LineSeriesModule: ()=>$d77b025aa58d633c$var$LineSeriesModule,
    LinearGradient: ()=>$d77b025aa58d633c$var$LinearGradient,
    LinearScale: ()=>$d77b025aa58d633c$var$LinearScale,
    Listeners: ()=>$d77b025aa58d633c$var$Listeners,
    LogScale: ()=>$d77b025aa58d633c$var$LogScale,
    LonLatBBox: ()=>$d77b025aa58d633c$var$LonLatBBox,
    Marker: ()=>$d77b025aa58d633c$var$Marker,
    Menu: ()=>$d77b025aa58d633c$var$Menu,
    MenuItemWidget: ()=>$d77b025aa58d633c$var$MenuItemWidget,
    MenuWidget: ()=>$d77b025aa58d633c$var$MenuWidget,
    MercatorScale: ()=>$d77b025aa58d633c$var$MercatorScale,
    ModuleRegistry: ()=>(0, $idDdm.ModuleRegistry),
    Motion: ()=>$d77b025aa58d633c$var$easing_exports,
    NODE_UPDATE_STATE_TO_PHASE_MAPPING: ()=>$d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING,
    NativeWidget: ()=>$d77b025aa58d633c$var$NativeWidget,
    NewAreaSeriesModule: ()=>$d77b025aa58d633c$var$NewAreaSeriesModule,
    NewBarSeriesModule: ()=>$d77b025aa58d633c$var$NewBarSeriesModule,
    NewBubbleSeriesModule: ()=>$d77b025aa58d633c$var$NewBubbleSeriesModule,
    NewHistogramSeriesModule: ()=>$d77b025aa58d633c$var$NewHistogramSeriesModule,
    NewLineSeriesModule: ()=>$d77b025aa58d633c$var$NewLineSeriesModule,
    NewScatterSeriesModule: ()=>$d77b025aa58d633c$var$NewScatterSeriesModule,
    NiceMode: ()=>$d77b025aa58d633c$var$NiceMode,
    Node: ()=>$d77b025aa58d633c$var$Node2,
    NumberAxis: ()=>$d77b025aa58d633c$var$NumberAxis,
    ObserveChanges: ()=>$d77b025aa58d633c$var$ObserveChanges,
    OrdinalTimeScale: ()=>$d77b025aa58d633c$var$OrdinalTimeScale,
    PHASE_METADATA: ()=>$d77b025aa58d633c$var$PHASE_METADATA,
    PHASE_ORDER: ()=>$d77b025aa58d633c$var$PHASE_ORDER,
    PREV_NEXT_KEYS: ()=>$d77b025aa58d633c$var$PREV_NEXT_KEYS,
    Padding: ()=>$d77b025aa58d633c$var$Padding,
    ParallelStateMachine: ()=>$d77b025aa58d633c$var$ParallelStateMachine,
    Path: ()=>$d77b025aa58d633c$var$Path,
    PointerEvents: ()=>$d77b025aa58d633c$var$PointerEvents,
    PolarAxis: ()=>$d77b025aa58d633c$var$PolarAxis,
    PolarSeries: ()=>$d77b025aa58d633c$var$PolarSeries,
    PolarZIndexMap: ()=>$d77b025aa58d633c$var$PolarZIndexMap,
    Popover: ()=>$d77b025aa58d633c$var$Popover,
    PropertiesArray: ()=>$d77b025aa58d633c$var$PropertiesArray,
    Property: ()=>$d77b025aa58d633c$var$Property,
    ProxyInteractionService: ()=>$d77b025aa58d633c$var$ProxyInteractionService,
    ProxyOnWrite: ()=>$d77b025aa58d633c$var$ProxyOnWrite,
    ProxyProperty: ()=>$d77b025aa58d633c$var$ProxyProperty,
    ProxyPropertyOnWrite: ()=>$d77b025aa58d633c$var$ProxyPropertyOnWrite,
    QUICK_TRANSITION: ()=>$d77b025aa58d633c$var$QUICK_TRANSITION,
    RENDER_TO_OFFSCREEN_CANVAS_THRESHOLD: ()=>$d77b025aa58d633c$var$RENDER_TO_OFFSCREEN_CANVAS_THRESHOLD,
    RadialColumnShape: ()=>$d77b025aa58d633c$var$RadialColumnShape,
    Range: ()=>$d77b025aa58d633c$var$Range,
    Rect: ()=>$d77b025aa58d633c$var$Rect,
    RepeatType: ()=>$d77b025aa58d633c$var$RepeatType,
    Rotatable: ()=>$d77b025aa58d633c$var$Rotatable,
    RotatableGroup: ()=>$d77b025aa58d633c$var$RotatableGroup,
    RotatableText: ()=>$d77b025aa58d633c$var$RotatableText,
    SAFE_FILLS_OPERATION: ()=>$d77b025aa58d633c$var$SAFE_FILLS_OPERATION,
    SAFE_FILL_OPERATION: ()=>$d77b025aa58d633c$var$SAFE_FILL_OPERATION,
    SAFE_RANGE2_OPERATION: ()=>$d77b025aa58d633c$var$SAFE_RANGE2_OPERATION,
    SAFE_STROKE_FILL_OPERATION: ()=>$d77b025aa58d633c$var$SAFE_STROKE_FILL_OPERATION,
    SKIP_JS_BUILTINS: ()=>$d77b025aa58d633c$var$SKIP_JS_BUILTINS,
    SMALLEST_KEY_INTERVAL: ()=>$d77b025aa58d633c$var$SMALLEST_KEY_INTERVAL,
    SORT_DOMAIN_GROUPS: ()=>$d77b025aa58d633c$var$SORT_DOMAIN_GROUPS,
    Scalable: ()=>$d77b025aa58d633c$var$Scalable,
    ScalableGroup: ()=>$d77b025aa58d633c$var$ScalableGroup,
    Scene: ()=>$d77b025aa58d633c$var$Scene,
    SceneArrayChangeDetection: ()=>$d77b025aa58d633c$var$SceneArrayChangeDetection,
    SceneChangeDetection: ()=>$d77b025aa58d633c$var$SceneChangeDetection,
    SceneObjectChangeDetection: ()=>$d77b025aa58d633c$var$SceneObjectChangeDetection,
    Sector: ()=>$d77b025aa58d633c$var$Sector,
    SectorBox: ()=>$d77b025aa58d633c$var$SectorBox,
    Selection: ()=>$d77b025aa58d633c$var$Selection,
    Series: ()=>$d77b025aa58d633c$var$Series,
    SeriesContentZIndexMap: ()=>$d77b025aa58d633c$var$SeriesContentZIndexMap,
    SeriesGroupingChangedEvent: ()=>$d77b025aa58d633c$var$SeriesGroupingChangedEvent,
    SeriesItemHighlightStyle: ()=>$d77b025aa58d633c$var$SeriesItemHighlightStyle,
    SeriesMarker: ()=>$d77b025aa58d633c$var$SeriesMarker,
    SeriesNodeEvent: ()=>$d77b025aa58d633c$var$SeriesNodeEvent,
    SeriesNodePickMode: ()=>$d77b025aa58d633c$var$SeriesNodePickMode,
    SeriesProperties: ()=>$d77b025aa58d633c$var$SeriesProperties,
    SeriesTooltip: ()=>$d77b025aa58d633c$var$SeriesTooltip,
    SeriesZIndexMap: ()=>$d77b025aa58d633c$var$SeriesZIndexMap,
    Shape: ()=>$d77b025aa58d633c$var$Shape,
    SimpleTextMeasurer: ()=>$d77b025aa58d633c$var$SimpleTextMeasurer,
    SliderWidget: ()=>$d77b025aa58d633c$var$SliderWidget,
    StateMachine: ()=>$d77b025aa58d633c$var$StateMachine,
    StateMachineProperty: ()=>$d77b025aa58d633c$var$StateMachineProperty,
    StopProperties: ()=>$d77b025aa58d633c$var$StopProperties,
    SvgPath: ()=>$d77b025aa58d633c$var$SvgPath,
    TRIPLE_EQ: ()=>$d77b025aa58d633c$var$TRIPLE_EQ,
    Text: ()=>$d77b025aa58d633c$var$Text,
    TextUtils: ()=>$d77b025aa58d633c$var$TextUtils,
    TextWrapper: ()=>$d77b025aa58d633c$var$TextWrapper,
    ThemeConstants: ()=>$d77b025aa58d633c$var$constants_exports,
    ThemeSymbols: ()=>$d77b025aa58d633c$var$symbols_exports,
    TimeAxisParentLevel: ()=>$d77b025aa58d633c$var$TimeAxisParentLevel,
    TimeScale: ()=>$d77b025aa58d633c$var$TimeScale,
    Toolbar: ()=>$d77b025aa58d633c$var$Toolbar,
    ToolbarButtonProperties: ()=>$d77b025aa58d633c$var$ToolbarButtonProperties,
    ToolbarButtonWidget: ()=>$d77b025aa58d633c$var$ToolbarButtonWidget,
    ToolbarWidget: ()=>$d77b025aa58d633c$var$ToolbarWidget,
    Tooltip: ()=>$d77b025aa58d633c$var$Tooltip,
    TooltipManager: ()=>$d77b025aa58d633c$var$TooltipManager,
    TooltipPosition: ()=>$d77b025aa58d633c$var$TooltipPosition,
    Transformable: ()=>$d77b025aa58d633c$var$Transformable,
    TransformableGroup: ()=>$d77b025aa58d633c$var$TransformableGroup,
    TransformableText: ()=>$d77b025aa58d633c$var$TransformableText,
    Translatable: ()=>$d77b025aa58d633c$var$Translatable,
    TranslatableGroup: ()=>$d77b025aa58d633c$var$TranslatableGroup,
    TranslatableLine: ()=>$d77b025aa58d633c$var$TranslatableLine,
    UnitTimeScale: ()=>$d77b025aa58d633c$var$UnitTimeScale,
    UpdateService: ()=>$d77b025aa58d633c$var$UpdateService,
    Vec2: ()=>$d77b025aa58d633c$var$Vec2,
    Vec4: ()=>$d77b025aa58d633c$var$Vec4,
    WIDGET_HTML_EVENTS: ()=>$d77b025aa58d633c$var$WIDGET_HTML_EVENTS,
    Widget: ()=>$d77b025aa58d633c$var$Widget,
    WidgetEventUtil: ()=>$d77b025aa58d633c$var$WidgetEventUtil,
    ZIndexMap: ()=>$d77b025aa58d633c$var$ZIndexMap,
    ZoomManager: ()=>$d77b025aa58d633c$var$ZoomManager,
    accumulateGroup: ()=>$d77b025aa58d633c$var$accumulateGroup,
    accumulateStack: ()=>$d77b025aa58d633c$var$accumulateStack,
    accumulatedValue: ()=>$d77b025aa58d633c$var$accumulatedValue,
    accumulativeValueProperty: ()=>$d77b025aa58d633c$var$accumulativeValueProperty,
    addEscapeEventListener: ()=>$d77b025aa58d633c$var$addEscapeEventListener,
    addHitTestersToQuadtree: ()=>$d77b025aa58d633c$var$addHitTestersToQuadtree,
    addMouseCloseListener: ()=>$d77b025aa58d633c$var$addMouseCloseListener,
    addOverrideFocusVisibleEventListener: ()=>$d77b025aa58d633c$var$addOverrideFocusVisibleEventListener,
    addTouchCloseListener: ()=>$d77b025aa58d633c$var$addTouchCloseListener,
    adjustLabelPlacement: ()=>$d77b025aa58d633c$var$adjustLabelPlacement,
    angleBetween: ()=>$d77b025aa58d633c$var$angleBetween,
    angleCategoryAxisOptionsDefs: ()=>$d77b025aa58d633c$var$angleCategoryAxisOptionsDefs,
    angleNumberAxisOptionsDefs: ()=>$d77b025aa58d633c$var$angleNumberAxisOptionsDefs,
    angularPadding: ()=>$d77b025aa58d633c$var$angularPadding,
    animationValidation: ()=>$d77b025aa58d633c$var$animationValidation,
    annotationCalloutStylesDefs: ()=>$d77b025aa58d633c$var$annotationCalloutStylesDefs,
    annotationChannelStyleDefs: ()=>$d77b025aa58d633c$var$annotationChannelStyleDefs,
    annotationChannelTextDefs: ()=>$d77b025aa58d633c$var$annotationChannelTextDefs,
    annotationCommentStylesDefs: ()=>$d77b025aa58d633c$var$annotationCommentStylesDefs,
    annotationCrossLineStyleDefs: ()=>$d77b025aa58d633c$var$annotationCrossLineStyleDefs,
    annotationDisjointChannelStyleDefs: ()=>$d77b025aa58d633c$var$annotationDisjointChannelStyleDefs,
    annotationFibonacciStylesDefs: ()=>$d77b025aa58d633c$var$annotationFibonacciStylesDefs,
    annotationLineStyleDefs: ()=>$d77b025aa58d633c$var$annotationLineStyleDefs,
    annotationLineTextDefs: ()=>$d77b025aa58d633c$var$annotationLineTextDefs,
    annotationMeasurerStylesDefs: ()=>$d77b025aa58d633c$var$annotationMeasurerStylesDefs,
    annotationNoteStylesDefs: ()=>$d77b025aa58d633c$var$annotationNoteStylesDefs,
    annotationOptionsDef: ()=>$d77b025aa58d633c$var$annotationOptionsDef,
    annotationParallelChannelStyleDefs: ()=>$d77b025aa58d633c$var$annotationParallelChannelStyleDefs,
    annotationQuickMeasurerStylesDefs: ()=>$d77b025aa58d633c$var$annotationQuickMeasurerStylesDefs,
    annotationShapeStylesDefs: ()=>$d77b025aa58d633c$var$annotationShapeStylesDefs,
    annotationTextStylesDef: ()=>$d77b025aa58d633c$var$annotationTextStylesDef,
    applyShapeFillBBox: ()=>$d77b025aa58d633c$var$applyShapeFillBBox,
    applyShapeStyle: ()=>$d77b025aa58d633c$var$applyShapeStyle,
    areScalingEqual: ()=>$d77b025aa58d633c$var$areScalingEqual,
    area: ()=>$d77b025aa58d633c$var$area,
    autoSizedLabelOptionsDefs: ()=>$d77b025aa58d633c$var$autoSizedLabelOptionsDefs,
    boxPlotSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$boxPlotSeriesThemeableOptionsDef,
    buildFormatter: ()=>$d77b025aa58d633c$var$buildFormatter,
    buildResetPathFn: ()=>$d77b025aa58d633c$var$buildResetPathFn,
    calculateDataDiff: ()=>$d77b025aa58d633c$var$calculateDataDiff,
    calculateDefaultTimeTickFormat: ()=>$d77b025aa58d633c$var$calculateDefaultTimeTickFormat,
    calculateDerivativeExtrema: ()=>$d77b025aa58d633c$var$calculateDerivativeExtrema,
    calculateDerivativeExtremaXY: ()=>$d77b025aa58d633c$var$calculateDerivativeExtremaXY,
    calculateLabelTranslation: ()=>$d77b025aa58d633c$var$calculateLabelTranslation,
    calculatePlacement: ()=>$d77b025aa58d633c$var$calculatePlacement,
    callWithContext: ()=>$d77b025aa58d633c$var$callWithContext,
    candlestickSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$candlestickSeriesThemeableOptionsDef,
    cartesianAxisCrosshairOptions: ()=>$d77b025aa58d633c$var$cartesianAxisCrosshairOptions,
    cartesianAxisLabelOptionsDefs: ()=>$d77b025aa58d633c$var$cartesianAxisLabelOptionsDefs,
    cartesianAxisOptionsDefs: ()=>$d77b025aa58d633c$var$cartesianAxisOptionsDefs,
    cartesianChartOptionsDefs: ()=>$d77b025aa58d633c$var$cartesianChartOptionsDefs,
    cartesianCrossLineOptionsDefs: ()=>$d77b025aa58d633c$var$cartesianCrossLineOptionsDefs,
    cartesianNumericAxisLabel: ()=>$d77b025aa58d633c$var$cartesianNumericAxisLabel,
    cartesianTimeAxisLabel: ()=>$d77b025aa58d633c$var$cartesianTimeAxisLabel,
    cartesianTimeAxisParentLevel: ()=>$d77b025aa58d633c$var$cartesianTimeAxisParentLevel,
    checkCrisp: ()=>$d77b025aa58d633c$var$checkCrisp,
    chordSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$chordSeriesThemeableOptionsDef,
    clampArray: ()=>$d77b025aa58d633c$var$clampArray,
    clippedRoundRect: ()=>$d77b025aa58d633c$var$clippedRoundRect,
    collapsedStartingBarPosition: ()=>$d77b025aa58d633c$var$collapsedStartingBarPosition,
    commonAxisLabelOptionsDefs: ()=>$d77b025aa58d633c$var$commonAxisLabelOptionsDefs,
    commonAxisOptionsDefs: ()=>$d77b025aa58d633c$var$commonAxisOptionsDefs,
    commonChartOptionsDefs: ()=>$d77b025aa58d633c$var$commonChartOptionsDefs,
    commonCrossLineLabelOptionsDefs: ()=>$d77b025aa58d633c$var$commonCrossLineLabelOptionsDefs,
    commonCrossLineOptionsDefs: ()=>$d77b025aa58d633c$var$commonCrossLineOptionsDefs,
    commonSeriesOptionsDefs: ()=>$d77b025aa58d633c$var$commonSeriesOptionsDefs,
    commonSeriesThemeableOptionsDefs: ()=>$d77b025aa58d633c$var$commonSeriesThemeableOptionsDefs,
    compareDates: ()=>$d77b025aa58d633c$var$compareDates,
    computeBarFocusBounds: ()=>$d77b025aa58d633c$var$computeBarFocusBounds,
    computeMarkerFocusBounds: ()=>$d77b025aa58d633c$var$computeMarkerFocusBounds,
    coneFunnelSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$coneFunnelSeriesThemeableOptionsDef,
    continuousAxisOptions: ()=>$d77b025aa58d633c$var$continuousAxisOptions,
    countExpandingSearch: ()=>$d77b025aa58d633c$var$countExpandingSearch,
    createButton: ()=>$d77b025aa58d633c$var$createButton,
    createCheckbox: ()=>$d77b025aa58d633c$var$createCheckbox,
    createDatumId: ()=>$d77b025aa58d633c$var$createDatumId,
    createDeprecationWarning: ()=>$d77b025aa58d633c$var$createDeprecationWarning,
    createIcon: ()=>$d77b025aa58d633c$var$createIcon,
    createSelect: ()=>$d77b025aa58d633c$var$createSelect,
    createTextArea: ()=>$d77b025aa58d633c$var$createTextArea,
    dateToNumber: ()=>$d77b025aa58d633c$var$dateToNumber,
    datesSortOrder: ()=>$d77b025aa58d633c$var$datesSortOrder,
    datumKeys: ()=>$d77b025aa58d633c$var$datumKeys,
    datumStylerProperties: ()=>$d77b025aa58d633c$var$datumStylerProperties,
    deconstructSelectionsOrNodes: ()=>$d77b025aa58d633c$var$deconstructSelectionsOrNodes,
    deepClone: ()=>$d77b025aa58d633c$var$deepClone,
    deepFreeze: ()=>$d77b025aa58d633c$var$deepFreeze,
    defaultTimeTickFormat: ()=>$d77b025aa58d633c$var$defaultTimeTickFormat,
    diff: ()=>$d77b025aa58d633c$var$diff,
    drawCorner: ()=>$d77b025aa58d633c$var$drawCorner,
    drawMarkerUnitPolygon: ()=>$d77b025aa58d633c$var$drawMarkerUnitPolygon,
    easing: ()=>$d77b025aa58d633c$var$easing_exports,
    enterpriseModule: ()=>$d77b025aa58d633c$var$enterpriseModule,
    errorBarOptionsDefs: ()=>$d77b025aa58d633c$var$errorBarOptionsDefs,
    errorBarThemeableOptionsDefs: ()=>$d77b025aa58d633c$var$errorBarThemeableOptionsDefs,
    evaluateBezier: ()=>$d77b025aa58d633c$var$evaluateBezier,
    extent: ()=>$d77b025aa58d633c$var$extent,
    extractDecoratedProperties: ()=>$d77b025aa58d633c$var$extractDecoratedProperties,
    fillsOptionsDef: ()=>$d77b025aa58d633c$var$fillsOptionsDef,
    findMinMax: ()=>$d77b025aa58d633c$var$findMinMax,
    findQuadtreeMatch: ()=>$d77b025aa58d633c$var$findQuadtreeMatch,
    findRangeExtent: ()=>$d77b025aa58d633c$var$findRangeExtent,
    fixNumericExtent: ()=>$d77b025aa58d633c$var$fixNumericExtent,
    flowProportionChartOptionsDefs: ()=>$d77b025aa58d633c$var$flowProportionChartOptionsDefs,
    focusCursorAtEnd: ()=>$d77b025aa58d633c$var$focusCursorAtEnd,
    formatNumber: ()=>$d77b025aa58d633c$var$formatNumber,
    formatPercent: ()=>$d77b025aa58d633c$var$formatPercent,
    formatValue: ()=>$d77b025aa58d633c$var$formatValue,
    fromToMotion: ()=>$d77b025aa58d633c$var$fromToMotion,
    funnelSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$funnelSeriesThemeableOptionsDef,
    gaugeChartOptionsDefs: ()=>$d77b025aa58d633c$var$gaugeChartOptionsDefs,
    getAngleRatioRadians: ()=>$d77b025aa58d633c$var$getAngleRatioRadians,
    getColorStops: ()=>$d77b025aa58d633c$var$getColorStops,
    getCrossLineValue: ()=>$d77b025aa58d633c$var$getCrossLineValue,
    getDateTicksForInterval: ()=>$d77b025aa58d633c$var$getDateTicksForInterval,
    getDatumRefPoint: ()=>$d77b025aa58d633c$var$getDatumRefPoint,
    getElementBBox: ()=>$d77b025aa58d633c$var$getElementBBox,
    getIconClassNames: ()=>$d77b025aa58d633c$var$getIconClassNames,
    getLastFocus: ()=>$d77b025aa58d633c$var$getLastFocus,
    getMissCount: ()=>$d77b025aa58d633c$var$getMissCount,
    getPath: ()=>$d77b025aa58d633c$var$getPath,
    getPathComponents: ()=>$d77b025aa58d633c$var$getPathComponents,
    getRadialColumnWidth: ()=>$d77b025aa58d633c$var$getRadialColumnWidth,
    getSequentialColors: ()=>$d77b025aa58d633c$var$getSequentialColors,
    getShapeFill: ()=>$d77b025aa58d633c$var$getShapeFill,
    getShapeStyle: ()=>$d77b025aa58d633c$var$getShapeStyle,
    groupAccumulativeValueProperty: ()=>$d77b025aa58d633c$var$groupAccumulativeValueProperty,
    groupAverage: ()=>$d77b025aa58d633c$var$groupAverage,
    groupCount: ()=>$d77b025aa58d633c$var$groupCount,
    groupStackValueProperty: ()=>$d77b025aa58d633c$var$groupStackValueProperty,
    groupSum: ()=>$d77b025aa58d633c$var$groupSum,
    hasNoModifiers: ()=>$d77b025aa58d633c$var$hasNoModifiers,
    heatmapSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$heatmapSeriesThemeableOptionsDef,
    hierarchyChartOptionsDefs: ()=>$d77b025aa58d633c$var$hierarchyChartOptionsDefs,
    initMenuKeyNav: ()=>$d77b025aa58d633c$var$initMenuKeyNav,
    initRovingTabIndex: ()=>$d77b025aa58d633c$var$initRovingTabIndex,
    interpolatePoints: ()=>$d77b025aa58d633c$var$interpolatePoints,
    interpolationOptionsDefs: ()=>$d77b025aa58d633c$var$interpolationOptionsDefs,
    isAgFlowProportionChartOptions: ()=>$d77b025aa58d633c$var$isAgFlowProportionChartOptions,
    isAgGaugeChartOptions: ()=>$d77b025aa58d633c$var$isAgGaugeChartOptions,
    isAgHierarchyChartOptions: ()=>$d77b025aa58d633c$var$isAgHierarchyChartOptions,
    isAgStandaloneChartOptions: ()=>$d77b025aa58d633c$var$isAgStandaloneChartOptions,
    isAgTopologyChartOptions: ()=>$d77b025aa58d633c$var$isAgTopologyChartOptions,
    isBetweenAngles: ()=>$d77b025aa58d633c$var$isBetweenAngles,
    isButtonClickEvent: ()=>$d77b025aa58d633c$var$isButtonClickEvent,
    isChartAxisDirection: ()=>$d77b025aa58d633c$var$isChartAxisDirection,
    isContinuous: ()=>$d77b025aa58d633c$var$isContinuous,
    isDecoratedObject: ()=>$d77b025aa58d633c$var$isDecoratedObject,
    isDenseInterval: ()=>$d77b025aa58d633c$var$isDenseInterval,
    isGradientFill: ()=>$d77b025aa58d633c$var$isGradientFill,
    isGradientOrPatternFill: ()=>$d77b025aa58d633c$var$isGradientOrPatternFill,
    isImageFill: ()=>$d77b025aa58d633c$var$isImageFill,
    isInputPending: ()=>$d77b025aa58d633c$var$isInputPending,
    isObjectWithProperty: ()=>$d77b025aa58d633c$var$isObjectWithProperty,
    isObjectWithStringProperty: ()=>$d77b025aa58d633c$var$isObjectWithStringProperty,
    isPatternFill: ()=>$d77b025aa58d633c$var$isPatternFill,
    isProperties: ()=>$d77b025aa58d633c$var$isProperties,
    isScaleValid: ()=>$d77b025aa58d633c$var$isScaleValid,
    jsonApply: ()=>$d77b025aa58d633c$var$jsonApply,
    jsonDiff: ()=>$d77b025aa58d633c$var$jsonDiff,
    jsonPropertyCompare: ()=>$d77b025aa58d633c$var$jsonPropertyCompare,
    jsonResolveOperations: ()=>$d77b025aa58d633c$var$jsonResolveOperations,
    jsonWalk: ()=>$d77b025aa58d633c$var$jsonWalk,
    keyProperty: ()=>$d77b025aa58d633c$var$keyProperty,
    legendSymbolSvg: ()=>$d77b025aa58d633c$var$legendSymbolSvg,
    lineDistanceSquared: ()=>$d77b025aa58d633c$var$lineDistanceSquared,
    linearGaugeSeriesOptionsDef: ()=>$d77b025aa58d633c$var$linearGaugeSeriesOptionsDef,
    linearGaugeSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$linearGaugeSeriesThemeableOptionsDef,
    linearGaugeTargetOptionsDef: ()=>$d77b025aa58d633c$var$linearGaugeTargetOptionsDef,
    listDecoratedProperties: ()=>$d77b025aa58d633c$var$listDecoratedProperties,
    makeAccessibleClickListener: ()=>$d77b025aa58d633c$var$makeAccessibleClickListener,
    mapLineBackgroundSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$mapLineBackgroundSeriesThemeableOptionsDef,
    mapLineSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$mapLineSeriesThemeableOptionsDef,
    mapMarkerSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$mapMarkerSeriesThemeableOptionsDef,
    mapShapeBackgroundSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$mapShapeBackgroundSeriesThemeableOptionsDef,
    mapShapeSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$mapShapeSeriesThemeableOptionsDef,
    mapValues: ()=>$d77b025aa58d633c$var$mapValues,
    markerFadeInAnimation: ()=>$d77b025aa58d633c$var$markerFadeInAnimation,
    markerOptionsDefs: ()=>$d77b025aa58d633c$var$markerOptionsDefs,
    markerScaleInAnimation: ()=>$d77b025aa58d633c$var$markerScaleInAnimation,
    markerSwipeScaleInAnimation: ()=>$d77b025aa58d633c$var$markerSwipeScaleInAnimation,
    merge: ()=>$d77b025aa58d633c$var$merge,
    mergeArrayDefaults: ()=>$d77b025aa58d633c$var$mergeArrayDefaults,
    mergeDefaults: ()=>$d77b025aa58d633c$var$mergeDefaults,
    midpointStartingBarPosition: ()=>$d77b025aa58d633c$var$midpointStartingBarPosition,
    moduleRegistry: ()=>$d77b025aa58d633c$var$moduleRegistry,
    motion: ()=>$d77b025aa58d633c$var$motion,
    nearestSquared: ()=>$d77b025aa58d633c$var$nearestSquared,
    nearestSquaredInContainer: ()=>$d77b025aa58d633c$var$nearestSquaredInContainer,
    nightingaleSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$nightingaleSeriesThemeableOptionsDef,
    normaliseGroupTo: ()=>$d77b025aa58d633c$var$normaliseGroupTo,
    normalisePropertyTo: ()=>$d77b025aa58d633c$var$normalisePropertyTo,
    normalisedExtentWithMetadata: ()=>$d77b025aa58d633c$var$normalisedExtentWithMetadata,
    normalizeAngle180: ()=>$d77b025aa58d633c$var$normalizeAngle180,
    normalizeAngle360: ()=>$d77b025aa58d633c$var$normalizeAngle360,
    normalizeAngle360FromDegrees: ()=>$d77b025aa58d633c$var$normalizeAngle360FromDegrees,
    normalizeAngle360Inclusive: ()=>$d77b025aa58d633c$var$normalizeAngle360Inclusive,
    normalizeContinuousDomains: ()=>$d77b025aa58d633c$var$normalizeContinuousDomains,
    numberFormatValidator: ()=>$d77b025aa58d633c$var$numberFormatValidator,
    objectsEqual: ()=>$d77b025aa58d633c$var$objectsEqual,
    objectsEqualWith: ()=>$d77b025aa58d633c$var$objectsEqualWith,
    ohlcSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$ohlcSeriesThemeableOptionsDef,
    ordinalTimeAxisOptionsDefs: ()=>$d77b025aa58d633c$var$ordinalTimeAxisOptionsDefs,
    pairUpSpans: ()=>$d77b025aa58d633c$var$pairUpSpans,
    partialAssign: ()=>$d77b025aa58d633c$var$partialAssign,
    pathFadeInAnimation: ()=>$d77b025aa58d633c$var$pathFadeInAnimation,
    pathMotion: ()=>$d77b025aa58d633c$var$pathMotion,
    pathSwipeInAnimation: ()=>$d77b025aa58d633c$var$pathSwipeInAnimation,
    pickByMatchingAngle: ()=>$d77b025aa58d633c$var$pickByMatchingAngle,
    plotAreaPathFill: ()=>$d77b025aa58d633c$var$plotAreaPathFill,
    plotInterpolatedAreaSeriesFillSpans: ()=>$d77b025aa58d633c$var$plotInterpolatedAreaSeriesFillSpans,
    plotInterpolatedLinePathStroke: ()=>$d77b025aa58d633c$var$plotInterpolatedLinePathStroke,
    plotLinePathStroke: ()=>$d77b025aa58d633c$var$plotLinePathStroke,
    polarChartOptionsDefs: ()=>$d77b025aa58d633c$var$polarChartOptionsDefs,
    prepareAreaFillAnimationFns: ()=>$d77b025aa58d633c$var$prepareAreaFillAnimationFns,
    prepareAreaPathAnimation: ()=>$d77b025aa58d633c$var$prepareAreaPathAnimation,
    prepareAxisAnimationContext: ()=>$d77b025aa58d633c$var$prepareAxisAnimationContext,
    prepareAxisAnimationFunctions: ()=>$d77b025aa58d633c$var$prepareAxisAnimationFunctions,
    prepareBarAnimationFunctions: ()=>$d77b025aa58d633c$var$prepareBarAnimationFunctions,
    prepareLinePathAnimation: ()=>$d77b025aa58d633c$var$prepareLinePathAnimation,
    prepareLinePathPropertyAnimation: ()=>$d77b025aa58d633c$var$prepareLinePathPropertyAnimation,
    prepareLinePathStrokeAnimationFns: ()=>$d77b025aa58d633c$var$prepareLinePathStrokeAnimationFns,
    preparePieSeriesAnimationFunctions: ()=>$d77b025aa58d633c$var$preparePieSeriesAnimationFunctions,
    pyramidSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$pyramidSeriesThemeableOptionsDef,
    radarAreaSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$radarAreaSeriesThemeableOptionsDef,
    radarLineSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$radarLineSeriesThemeableOptionsDef,
    radialBarSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$radialBarSeriesThemeableOptionsDef,
    radialColumnSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$radialColumnSeriesThemeableOptionsDef,
    radialGaugeSeriesOptionsDef: ()=>$d77b025aa58d633c$var$radialGaugeSeriesOptionsDef,
    radialGaugeSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$radialGaugeSeriesThemeableOptionsDef,
    radialGaugeTargetOptionsDef: ()=>$d77b025aa58d633c$var$radialGaugeTargetOptionsDef,
    radiusCategoryAxisOptionsDefs: ()=>$d77b025aa58d633c$var$radiusCategoryAxisOptionsDefs,
    radiusNumberAxisOptionsDefs: ()=>$d77b025aa58d633c$var$radiusNumberAxisOptionsDefs,
    range: ()=>$d77b025aa58d633c$var$range,
    rangeAreaSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$rangeAreaSeriesThemeableOptionsDef,
    rangeBarSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$rangeBarSeriesThemeableOptionsDef,
    rangeValidator: ()=>$d77b025aa58d633c$var$rangeValidator2,
    rangedValueProperty: ()=>$d77b025aa58d633c$var$rangedValueProperty,
    resetAxisGroupFn: ()=>$d77b025aa58d633c$var$resetAxisGroupFn,
    resetAxisLabelSelectionFn: ()=>$d77b025aa58d633c$var$resetAxisLabelSelectionFn,
    resetAxisLineSelectionFn: ()=>$d77b025aa58d633c$var$resetAxisLineSelectionFn,
    resetBarSelectionsFn: ()=>$d77b025aa58d633c$var$resetBarSelectionsFn,
    resetLabelFn: ()=>$d77b025aa58d633c$var$resetLabelFn,
    resetMarkerFn: ()=>$d77b025aa58d633c$var$resetMarkerFn,
    resetMarkerPositionFn: ()=>$d77b025aa58d633c$var$resetMarkerPositionFn,
    resetMotion: ()=>$d77b025aa58d633c$var$resetMotion,
    resetPieSelectionsFn: ()=>$d77b025aa58d633c$var$resetPieSelectionsFn,
    rowCountProperty: ()=>$d77b025aa58d633c$var$rowCountProperty,
    sankeySeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$sankeySeriesThemeableOptionsDef,
    scale: ()=>$d77b025aa58d633c$var$scale,
    sectorBox: ()=>$d77b025aa58d633c$var$sectorBox,
    seriesLabelFadeInAnimation: ()=>$d77b025aa58d633c$var$seriesLabelFadeInAnimation,
    seriesLabelFadeOutAnimation: ()=>$d77b025aa58d633c$var$seriesLabelFadeOutAnimation,
    seriesLabelOptionsDefs: ()=>$d77b025aa58d633c$var$seriesLabelOptionsDefs,
    setElementBBox: ()=>$d77b025aa58d633c$var$setElementBBox,
    setPath: ()=>$d77b025aa58d633c$var$setPath,
    shadowOptionsDefs: ()=>$d77b025aa58d633c$var$shadowOptionsDefs,
    shallowClone: ()=>$d77b025aa58d633c$var$shallowClone,
    solveBezier: ()=>$d77b025aa58d633c$var$solveBezier,
    sortAndUniqueDates: ()=>$d77b025aa58d633c$var$sortAndUniqueDates,
    splitBezier: ()=>$d77b025aa58d633c$var$splitBezier,
    standaloneChartOptionsDefs: ()=>$d77b025aa58d633c$var$standaloneChartOptionsDefs,
    staticFromToMotion: ()=>$d77b025aa58d633c$var$staticFromToMotion,
    stopPageScrolling: ()=>$d77b025aa58d633c$var$stopPageScrolling,
    sum: ()=>$d77b025aa58d633c$var$sum,
    sumValues: ()=>$d77b025aa58d633c$var$sumValues,
    sunburstSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$sunburstSeriesThemeableOptionsDef,
    timeIntervalUnit: ()=>$d77b025aa58d633c$var$timeIntervalUnit,
    toDegrees: ()=>$d77b025aa58d633c$var$toDegrees,
    toRadians: ()=>$d77b025aa58d633c$var$toRadians,
    toolbarButtonOptionsDefs: ()=>$d77b025aa58d633c$var$toolbarButtonOptionsDefs,
    tooltipContentAriaLabel: ()=>$d77b025aa58d633c$var$tooltipContentAriaLabel,
    tooltipHtml: ()=>$d77b025aa58d633c$var$tooltipHtml,
    tooltipOptionsDefs: ()=>$d77b025aa58d633c$var$tooltipOptionsDefs,
    topologyChartOptionsDefs: ()=>$d77b025aa58d633c$var$topologyChartOptionsDefs,
    trailingAccumulatedValue: ()=>$d77b025aa58d633c$var$trailingAccumulatedValue,
    trailingAccumulatedValueProperty: ()=>$d77b025aa58d633c$var$trailingAccumulatedValueProperty,
    treemapSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$treemapSeriesThemeableOptionsDef,
    updateClipPath: ()=>$d77b025aa58d633c$var$updateClipPath,
    updateLabelNode: ()=>$d77b025aa58d633c$var$updateLabelNode,
    validateCrossLineValue: ()=>$d77b025aa58d633c$var$validateCrossLineValue,
    valueProperty: ()=>$d77b025aa58d633c$var$valueProperty,
    visibleRangeIndices: ()=>$d77b025aa58d633c$var$visibleRangeIndices,
    waterfallSeriesThemeableOptionsDef: ()=>$d77b025aa58d633c$var$waterfallSeriesThemeableOptionsDef,
    without: ()=>$d77b025aa58d633c$var$without
});
var $d77b025aa58d633c$var$Vec2 = {
    add: $d77b025aa58d633c$var$add,
    angle: $d77b025aa58d633c$var$angle,
    apply: $d77b025aa58d633c$var$apply,
    equal: $d77b025aa58d633c$var$equal,
    distance: $d77b025aa58d633c$var$distance,
    distanceSquared: $d77b025aa58d633c$var$distanceSquared,
    from: $d77b025aa58d633c$var$from2,
    gradient: $d77b025aa58d633c$var$gradient,
    intercept: $d77b025aa58d633c$var$intercept,
    intersectAtX: $d77b025aa58d633c$var$intersectAtX,
    intersectAtY: $d77b025aa58d633c$var$intersectAtY,
    length: $d77b025aa58d633c$var$length,
    lengthSquared: $d77b025aa58d633c$var$lengthSquared,
    multiply: $d77b025aa58d633c$var$multiply,
    normalized: $d77b025aa58d633c$var$normalized,
    origin: $d77b025aa58d633c$var$origin2,
    required: $d77b025aa58d633c$var$required16,
    rotate: $d77b025aa58d633c$var$rotate,
    round: $d77b025aa58d633c$var$round3,
    sub: $d77b025aa58d633c$var$sub
};
function $d77b025aa58d633c$var$add(a, b) {
    if (typeof b === "number") return {
        x: a.x + b,
        y: a.y + b
    };
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
function $d77b025aa58d633c$var$sub(a, b) {
    if (typeof b === "number") return {
        x: a.x - b,
        y: a.y - b
    };
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $d77b025aa58d633c$var$multiply(a, b) {
    if (typeof b === "number") return {
        x: a.x * b,
        y: a.y * b
    };
    return {
        x: a.x * b.x,
        y: a.y * b.y
    };
}
function $d77b025aa58d633c$var$length(a) {
    return Math.sqrt(a.x * a.x + a.y * a.y);
}
function $d77b025aa58d633c$var$lengthSquared(a) {
    return a.x * a.x + a.y * a.y;
}
function $d77b025aa58d633c$var$distance(a, b) {
    const d = $d77b025aa58d633c$var$sub(a, b);
    return Math.sqrt(d.x * d.x + d.y * d.y);
}
function $d77b025aa58d633c$var$distanceSquared(a, b) {
    const d = $d77b025aa58d633c$var$sub(a, b);
    return d.x * d.x + d.y * d.y;
}
function $d77b025aa58d633c$var$normalized(a) {
    const l = $d77b025aa58d633c$var$length(a);
    return {
        x: a.x / l,
        y: a.y / l
    };
}
function $d77b025aa58d633c$var$angle(a, b) {
    if (b == null) return Math.atan2(a.y, a.x);
    return Math.atan2(a.y, a.x) - Math.atan2(b.y, b.x);
}
function $d77b025aa58d633c$var$rotate(a, theta, b = $d77b025aa58d633c$var$origin2()) {
    const l = $d77b025aa58d633c$var$length(a);
    return {
        x: b.x + l * Math.cos(theta),
        y: b.y + l * Math.sin(theta)
    };
}
function $d77b025aa58d633c$var$gradient(a, b, reflection) {
    const dx = b.x - a.x;
    const dy = reflection == null ? b.y - a.y : reflection - b.y - (reflection - a.y);
    return dy / dx;
}
function $d77b025aa58d633c$var$intercept(a, gradient2, reflection) {
    const y = reflection == null ? a.y : reflection - a.y;
    return y - gradient2 * a.x;
}
function $d77b025aa58d633c$var$intersectAtY(gradient2, coefficient, y = 0, reflection) {
    return {
        x: gradient2 === Infinity ? Infinity : (y - coefficient) / gradient2,
        y: reflection == null ? y : reflection - y
    };
}
function $d77b025aa58d633c$var$intersectAtX(gradient2, coefficient, x = 0, reflection) {
    const y = gradient2 === Infinity ? Infinity : gradient2 * x + coefficient;
    return {
        x: x,
        y: reflection == null ? y : reflection - y
    };
}
function $d77b025aa58d633c$var$round3(a, decimals = 2) {
    return {
        x: (0, $idDdm.roundTo)(a.x, decimals),
        y: (0, $idDdm.roundTo)(a.y, decimals)
    };
}
function $d77b025aa58d633c$var$equal(a, b) {
    return a.x === b.x && a.y === b.y;
}
function $d77b025aa58d633c$var$from2(a, b) {
    if (typeof a === "number") return {
        x: a,
        y: b
    };
    if ("currentX" in a) return {
        x: a.currentX,
        y: a.currentY
    };
    if ("offsetWidth" in a) return {
        x: a.offsetWidth,
        y: a.offsetHeight
    };
    if ("width" in a) return [
        {
            x: a.x,
            y: a.y
        },
        {
            x: a.x + a.width,
            y: a.y + a.height
        }
    ];
    if ("x1" in a) return [
        {
            x: a.x1,
            y: a.y1
        },
        {
            x: a.x2,
            y: a.y2
        }
    ];
    throw new Error(`Values can not be converted into a vector: [${JSON.stringify(a)}] [${b}]`);
}
function $d77b025aa58d633c$var$apply(a, b) {
    a.x = b.x;
    a.y = b.y;
    return a;
}
function $d77b025aa58d633c$var$required16(a) {
    return {
        x: a?.x ?? 0,
        y: a?.y ?? 0
    };
}
function $d77b025aa58d633c$var$origin2() {
    return {
        x: 0,
        y: 0
    };
}
var $d77b025aa58d633c$var$_HierarchyNode = class _HierarchyNode {
    constructor(series, datumIndex, datum, sizeValue, colorValue, sumSize, depth, parent, children){
        this.series = series;
        this.datumIndex = datumIndex;
        this.datum = datum;
        this.sizeValue = sizeValue;
        this.colorValue = colorValue;
        this.sumSize = sumSize;
        this.depth = depth;
        this.parent = parent;
        this.children = children;
        this.midPoint = {
            x: 0,
            y: 0
        };
    }
    get hasChildren() {
        return this.children.length > 0;
    }
    walk(callback8, order = _HierarchyNode.Walk.PreOrder) {
        if (order === _HierarchyNode.Walk.PreOrder) callback8(this);
        this.children.forEach((child)=>{
            child.walk(callback8, order);
        });
        if (order === _HierarchyNode.Walk.PostOrder) callback8(this);
    }
    *[Symbol.iterator]() {
        yield this;
        for (const child of this.children)yield* child;
    }
};
$d77b025aa58d633c$var$_HierarchyNode.Walk = {
    PreOrder: 0,
    PostOrder: 1
};
var $d77b025aa58d633c$var$HierarchyNode = $d77b025aa58d633c$var$_HierarchyNode;
var $d77b025aa58d633c$var$HierarchySeries = class extends $d77b025aa58d633c$var$Series {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            pickModes: [
                1 /* NEAREST_NODE */ ,
                0 /* EXACT_SHAPE_MATCH */ 
            ]
        });
        this.colorDomain = [
            0,
            0
        ];
        this.maxDepth = 0;
        this.colorScale = new $d77b025aa58d633c$var$ColorScale();
        this.animationState = new $d77b025aa58d633c$var$StateMachine("empty", {
            empty: {
                update: {
                    target: "ready",
                    action: (data)=>this.animateEmptyUpdateReady(data)
                },
                reset: "empty",
                skip: "ready"
            },
            ready: {
                updateData: "waiting",
                clear: "clearing",
                highlight: (data)=>this.animateReadyHighlight(data),
                resize: (data)=>this.animateReadyResize(data),
                reset: "empty",
                skip: "ready"
            },
            waiting: {
                update: {
                    target: "ready",
                    action: (data)=>this.animateWaitingUpdateReady(data)
                },
                reset: "empty",
                skip: "ready"
            },
            clearing: {
                update: {
                    target: "empty",
                    action: (data)=>this.animateClearingUpdateEmpty(data)
                },
                reset: "empty",
                skip: "ready"
            }
        }, ()=>this.checkProcessedDataAnimatable());
    }
    resetAnimation(phase) {
        if (phase === "initial") this.animationState.transition("reset");
        else if (phase === "ready") this.animationState.transition("skip");
    }
    processData() {
        const { NodeClass: NodeClass } = this;
        const { childrenKey: childrenKey, sizeKey: sizeKey, colorKey: colorKey, colorRange: colorRange } = this.properties;
        let maxDepth = 0;
        let minColor = Infinity;
        let maxColor = -Infinity;
        const createNode = (datum, indexPath, parent)=>{
            const depth = parent.depth != null ? parent.depth + 1 : 0;
            const children = childrenKey != null ? datum[childrenKey] : void 0;
            const isLeaf = children == null || children.length === 0;
            let sizeValue = sizeKey != null ? datum[sizeKey] : void 0;
            if (Number.isFinite(sizeValue)) sizeValue = Math.max(sizeValue, 0);
            else sizeValue = isLeaf ? 1 : 0;
            const sumSize = sizeValue;
            maxDepth = Math.max(maxDepth, depth);
            const colorValue = colorKey != null ? datum[colorKey] : void 0;
            if (typeof colorValue === "number") {
                minColor = Math.min(minColor, colorValue);
                maxColor = Math.max(maxColor, colorValue);
            }
            return appendChildren(new NodeClass(this, indexPath, datum, sizeValue, colorValue, sumSize, depth, parent, []), children);
        };
        const appendChildren = (node, data)=>{
            const { datumIndex: datumIndex } = node;
            data?.forEach((datum, childIndex)=>{
                const child = createNode(datum, datumIndex.concat(childIndex), node);
                node.children.push(child);
                node.sumSize += child.sumSize;
            });
            return node;
        };
        const rootNode = appendChildren(new NodeClass(this, [], void 0, 0, void 0, 0, void 0, void 0, []), this.data);
        const colorDomain = [
            minColor,
            maxColor
        ];
        this.colorScale.domain = minColor < maxColor ? [
            minColor,
            maxColor
        ] : [
            0,
            1
        ];
        this.colorScale.range = colorRange ?? [
            "black"
        ];
        this.colorScale.update();
        this.rootNode = rootNode;
        this.maxDepth = maxDepth;
        this.colorDomain = colorDomain;
    }
    update({ seriesRect: seriesRect }) {
        this.updateSelections();
        this.updateNodes();
        const animationData = this.getAnimationData();
        const resize = this.checkResize(seriesRect);
        if (resize) this.animationState.transition("resize", animationData);
        this.animationState.transition("update", animationData);
    }
    resetAllAnimation(_data) {
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
    }
    animateEmptyUpdateReady(data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation(data);
    }
    animateWaitingUpdateReady(data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation(data);
    }
    animateReadyHighlight(_data) {}
    animateReadyResize(data) {
        this.resetAllAnimation(data);
    }
    animateClearingUpdateEmpty(data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation(data);
    }
    getAnimationData() {
        return {};
    }
    isProcessedDataAnimatable() {
        return true;
    }
    checkProcessedDataAnimatable() {
        if (!this.isProcessedDataAnimatable()) this.ctx.animationManager.skipCurrentBatch();
    }
    getSeriesDomain() {
        return [
            NaN,
            NaN
        ];
    }
    getSeriesRange(_direction, _visibleRange) {
        return [
            NaN,
            NaN
        ];
    }
    getLegendData(legendType) {
        const { colorKey: colorKey, colorName: colorName, colorRange: colorRange } = this.properties;
        const { id: seriesId, ctx: { legendManager: legendManager }, visible: visible } = this;
        return legendType === "gradient" && colorKey != null && colorRange != null ? [
            {
                legendType: "gradient",
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: seriesId
                }),
                seriesId: seriesId,
                colorName: colorName,
                colorRange: colorRange,
                colorDomain: this.colorDomain
            }
        ] : [];
    }
    getDatumIdFromData(node) {
        return node.datumIndex.join(":");
    }
    getDatumId(node) {
        return this.getDatumIdFromData(node);
    }
    removeMeIndexPathForIndex(index) {
        return this.datumSelection.at(index + 1)?.datum.datumIndex ?? [];
    }
    removeMeIndexForIndexPath(indexPath) {
        for (const { index: index, datum: datum } of this.datumSelection){
            if ((0, $idDdm.arraysEqual)(datum.datumIndex, indexPath)) return index - 1;
        }
        return 0;
    }
    pickFocus(opts) {
        if (!this.rootNode?.children.length) return void 0;
        const index = (0, $idDdm.clamp)(0, opts.datumIndex - opts.datumIndexDelta, this.datumSelection.length - 1);
        const { datumIndexDelta: childDelta, otherIndexDelta: depthDelta } = opts;
        let path = this.removeMeIndexPathForIndex(index);
        const currentNode = path.reduce((n, childIndex)=>n.children[childIndex], this.rootNode);
        if (depthDelta > 0 && currentNode.hasChildren) path = [
            ...path,
            0
        ];
        else if (depthDelta < 0 && path.length > 1) path = path.slice(0, -1);
        else if (depthDelta === 0 && childDelta !== 0) {
            const maxIndex = currentNode.parent.children.length - 1;
            path = path.slice();
            path[path.length - 1] = (0, $idDdm.clamp)(0, path[path.length - 1] + childDelta, maxIndex);
        }
        const nextNode = path.reduce((n, childIndex)=>n.children[childIndex], this.rootNode);
        const bounds = this.computeFocusBounds(this.datumSelection.at(index + 1));
        if (bounds == null) return;
        return {
            datum: nextNode,
            datumIndex: this.removeMeIndexForIndexPath(path),
            otherIndex: nextNode.depth,
            bounds: bounds,
            clipFocusBox: true
        };
    }
    getDatumAriaText(datum, description) {
        if (!(datum instanceof this.NodeClass)) {
            (0, $idDdm.Logger).error(`datum is not HierarchyNode: ${JSON.stringify(datum)}`);
            return;
        }
        return this.ctx.localeManager.t("ariaAnnounceHierarchyDatum", {
            level: (datum.depth ?? -1) + 1,
            count: datum.children.length,
            description: description
        });
    }
    getCategoryValue(_datumIndex) {
        return;
    }
    datumIndexForCategoryValue(_categoryValue) {
        return;
    }
};
// packages/ag-charts-community/src/chart/series/hierarchy/hierarchySeriesProperties.ts
var $d77b025aa58d633c$var$HierarchySeriesProperties = class extends $d77b025aa58d633c$var$SeriesProperties {
    constructor(){
        super(...arguments);
        this.childrenKey = "children";
        this.fills = Object.values($d77b025aa58d633c$var$DEFAULT_FILLS);
        this.fillGradientDefaults = new $d77b025aa58d633c$var$FillGradientDefaults();
        this.fillPatternDefaults = new $d77b025aa58d633c$var$FillPatternDefaults();
        this.fillImageDefaults = new $d77b025aa58d633c$var$FillImageDefaults();
        this.strokes = Object.values($d77b025aa58d633c$var$DEFAULT_STROKES);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "childrenKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "sizeKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "colorKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "colorName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "fills", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "fillGradientDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "fillPatternDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "fillImageDefaults", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "strokes", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "colorRange", 2);
// packages/ag-charts-community/src/chart/series/topology/lonLatBbox.ts
var $d77b025aa58d633c$var$LonLatBBox = class {
    constructor(lon0, lat0, lon1, lat1){
        this.lon0 = lon0;
        this.lat0 = lat0;
        this.lon1 = lon1;
        this.lat1 = lat1;
    }
    merge(other) {
        this.lon0 = Math.min(this.lon0, other.lon0);
        this.lat0 = Math.min(this.lat0, other.lat0);
        this.lon1 = Math.max(this.lon1, other.lon1);
        this.lat1 = Math.max(this.lat1, other.lat1);
    }
};
// packages/ag-charts-community/src/chart/series/topology/mercatorScale.ts
var $d77b025aa58d633c$var$radsInDeg = Math.PI / 180;
var $d77b025aa58d633c$var$lonX = (lon)=>lon * $d77b025aa58d633c$var$radsInDeg;
var $d77b025aa58d633c$var$latY = (lat)=>-Math.log(Math.tan(Math.PI * 0.25 + lat * $d77b025aa58d633c$var$radsInDeg * 0.5));
var $d77b025aa58d633c$var$xLon = (x)=>x / $d77b025aa58d633c$var$radsInDeg;
var $d77b025aa58d633c$var$yLat = (y)=>(Math.atan(Math.exp(-y)) - Math.PI * 0.25) / ($d77b025aa58d633c$var$radsInDeg * 0.5);
var $d77b025aa58d633c$var$MercatorScale = class _MercatorScale extends $d77b025aa58d633c$var$AbstractScale {
    constructor(domain, range3){
        super();
        this.domain = domain;
        this.range = range3;
        this.type = "mercator";
        this.bounds = _MercatorScale.bounds(domain);
    }
    static bounds(domain) {
        const [[lon0, lat0], [lon1, lat1]] = domain;
        const x0 = $d77b025aa58d633c$var$lonX(lon0);
        const y0 = $d77b025aa58d633c$var$latY(lat0);
        const x1 = $d77b025aa58d633c$var$lonX(lon1);
        const y1 = $d77b025aa58d633c$var$latY(lat1);
        return new $d77b025aa58d633c$var$BBox(Math.min(x0, x1), Math.min(y0, y1), Math.abs(x1 - x0), Math.abs(y1 - y0));
    }
    static fixedScale() {
        return new _MercatorScale([
            [
                $d77b025aa58d633c$var$xLon(0),
                $d77b025aa58d633c$var$yLat(0)
            ],
            [
                $d77b025aa58d633c$var$xLon(1),
                $d77b025aa58d633c$var$yLat(1)
            ]
        ], [
            [
                0,
                0
            ],
            [
                1,
                1
            ]
        ]);
    }
    toDomain() {
        return;
    }
    normalizeDomains(...domains) {
        let x0 = -Infinity;
        let x1 = Infinity;
        let y0 = -Infinity;
        let y1 = Infinity;
        for (const domain of domains)for (const [x, y] of domain){
            x0 = Math.min(x, x0);
            x1 = Math.max(x, x1);
            y0 = Math.min(y, y0);
            y1 = Math.max(y, y1);
        }
        return {
            domain: [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ],
            animatable: true
        };
    }
    convert([lon, lat]) {
        const [[x0, y0], [x1, y1]] = this.range;
        const xScale = (x1 - x0) / this.bounds.width;
        const yScale = (y1 - y0) / this.bounds.height;
        return [
            ($d77b025aa58d633c$var$lonX(lon) - this.bounds.x) * xScale + x0,
            ($d77b025aa58d633c$var$latY(lat) - this.bounds.y) * yScale + y0
        ];
    }
    invert([x, y]) {
        const [[x0, y0], [x1, y1]] = this.range;
        const xScale = (x1 - x0) / this.bounds.width;
        const yScale = (y1 - y0) / this.bounds.height;
        return [
            $d77b025aa58d633c$var$xLon((x - x0) / xScale + this.bounds.x),
            $d77b025aa58d633c$var$yLat((y - y0) / yScale + this.bounds.y)
        ];
    }
};
var $d77b025aa58d633c$var$_AxisTicks = class _AxisTicks {
    constructor(){
        this.id = (0, $idDdm.createId)(this);
        this.axisGroup = new $d77b025aa58d633c$var$TranslatableGroup({
            name: `${this.id}-AxisTicks`,
            zIndex: 2 /* AXIS */ 
        });
        this.labelSelection = $d77b025aa58d633c$var$Selection.select(this.axisGroup, $d77b025aa58d633c$var$Text);
        this.interval = new $d77b025aa58d633c$var$AxisInterval();
        this.label = new $d77b025aa58d633c$var$AxisLabel();
        this.scale = new $d77b025aa58d633c$var$LinearScale();
        this.position = "bottom";
        this.translationX = 0;
        this.translationY = 0;
        this.padding = 0;
    }
    attachAxis(axisNode) {
        axisNode.appendChild(this.axisGroup);
    }
    calculateLayout() {
        const boxes = [];
        const tickData = this.generateTicks();
        const { translationX: translationX, translationY: translationY } = this;
        this.labelSelection.update(tickData.ticks.map((d)=>this.createLabelDatum(d)), void 0, (datum)=>datum.tickId);
        this.labelSelection.each((node, datum)=>{
            node.setProperties(datum);
            if (datum.visible) boxes.push(node.getBBox());
        });
        this.axisGroup.setProperties({
            translationX: translationX,
            translationY: translationY
        });
        return boxes.length > 0 ? $d77b025aa58d633c$var$BBox.merge(boxes) : void 0;
    }
    getLabelParams(datum) {
        const { padding: padding } = this;
        const { translate: translate } = datum;
        switch(this.position){
            case "top":
            case "bottom":
                return {
                    x: translate,
                    y: padding,
                    textAlign: "center",
                    textBaseline: "top"
                };
            case "left":
            case "right":
                return {
                    x: padding,
                    y: translate,
                    textAlign: "start",
                    textBaseline: "middle"
                };
        }
    }
    inRange(x, tolerance = 1e-3) {
        const [min, max] = $d77b025aa58d633c$var$findMinMax(this.scale.range);
        return x >= min - tolerance && x <= max + tolerance;
    }
    createLabelDatum(datum) {
        const { x: x, y: y, textBaseline: textBaseline, textAlign: textAlign } = this.getLabelParams(datum);
        return {
            visible: Boolean(datum.tickLabel),
            tickId: datum.tickId,
            fill: this.label.color,
            fontFamily: this.label.fontFamily,
            fontSize: this.label.fontSize,
            fontStyle: this.label.fontStyle,
            fontWeight: this.label.fontWeight,
            rotation: 0,
            rotationCenterX: 0,
            text: datum.tickLabel,
            textAlign: textAlign,
            textBaseline: textBaseline,
            x: x,
            y: y
        };
    }
    generateTicks() {
        const { minSpacing: minSpacing, maxSpacing: maxSpacing } = this.interval;
        const { maxTickCount: maxTickCount, minTickCount: minTickCount, tickCount: tickCount } = $d77b025aa58d633c$var$estimateTickCount($d77b025aa58d633c$var$findRangeExtent(this.scale.range), 1, minSpacing, maxSpacing, _AxisTicks.DefaultTickCount, _AxisTicks.DefaultMinSpacing);
        const tickData = this.getTicksData({
            nice: true,
            interval: this.interval.step,
            tickCount: tickCount,
            minTickCount: minTickCount,
            maxTickCount: maxTickCount
        });
        if (this.position === "bottom" || this.position === "top") {
            const measurer2 = $d77b025aa58d633c$var$CachedTextMeasurerPool.getMeasurer({
                font: this.label
            });
            const { domain: domain } = this.scale;
            const reversed = domain[0] > domain[1];
            const direction = reversed ? -1 : 1;
            let lastTickPosition = -Infinity * direction;
            tickData.ticks = tickData.ticks.filter((data)=>{
                if (Math.sign(data.translate - lastTickPosition) !== direction) return false;
                lastTickPosition = data.translate + measurer2.textWidth(data.tickLabel, true) * direction;
                return true;
            });
        }
        return tickData;
    }
    getTicksData(tickParams) {
        const ticks = [];
        const niceDomain = tickParams.nice ? this.scale.niceDomain(tickParams) : this.scale.domain;
        const rawTicks = this.scale.ticks(tickParams, niceDomain)?.ticks ?? [];
        const fractionDigits = rawTicks.reduce((max, tick)=>Math.max(max, (0, $idDdm.countFractionDigits)(tick)), 0);
        const boundSeries = [];
        const idGenerator = $d77b025aa58d633c$var$createIdsGenerator();
        const labelFormatter = typeof this.label.format === "string" ? this.scale.tickFormatter({
            domain: niceDomain,
            ticks: rawTicks,
            fractionDigits: fractionDigits,
            specifier: this.label.format
        }) : (x)=>$d77b025aa58d633c$var$formatValue(x, fractionDigits);
        for(let index = 0; index < rawTicks.length; index++){
            const tick = rawTicks[index];
            const translate = this.scale.convert(tick);
            if (!this.inRange(translate)) continue;
            const tickLabel = this.label.formatter?.({
                value: tick,
                index: index,
                domain: niceDomain,
                fractionDigits: fractionDigits,
                boundSeries: boundSeries
            }) ?? labelFormatter(tick);
            const tickId = idGenerator(tickLabel);
            ticks.push({
                tick: tick,
                tickId: tickId,
                tickLabel: tickLabel,
                translate: translate
            });
        }
        return {
            rawTicks: rawTicks,
            fractionDigits: fractionDigits,
            ticks: ticks
        };
    }
};
$d77b025aa58d633c$var$_AxisTicks.DefaultTickCount = 5;
$d77b025aa58d633c$var$_AxisTicks.DefaultMinSpacing = 10;
var $d77b025aa58d633c$var$AxisTicks = $d77b025aa58d633c$var$_AxisTicks;
// packages/ag-charts-community/src/chart/crossline/crossLineLabelPosition.ts
var $d77b025aa58d633c$var$horizontalCrosslineTranslationDirections = {
    top: {
        xTranslationDirection: 0,
        yTranslationDirection: -1
    },
    bottom: {
        xTranslationDirection: 0,
        yTranslationDirection: 1
    },
    left: {
        xTranslationDirection: -1,
        yTranslationDirection: 0
    },
    right: {
        xTranslationDirection: 1,
        yTranslationDirection: 0
    },
    "top-left": {
        xTranslationDirection: 1,
        yTranslationDirection: -1
    },
    "top-right": {
        xTranslationDirection: -1,
        yTranslationDirection: -1
    },
    "bottom-left": {
        xTranslationDirection: 1,
        yTranslationDirection: 1
    },
    "bottom-right": {
        xTranslationDirection: -1,
        yTranslationDirection: 1
    },
    inside: {
        xTranslationDirection: 0,
        yTranslationDirection: 0
    },
    "inside-left": {
        xTranslationDirection: 1,
        yTranslationDirection: 0
    },
    "inside-right": {
        xTranslationDirection: -1,
        yTranslationDirection: 0
    },
    "inside-top": {
        xTranslationDirection: 0,
        yTranslationDirection: 1
    },
    "inside-bottom": {
        xTranslationDirection: 0,
        yTranslationDirection: -1
    },
    "inside-top-left": {
        xTranslationDirection: 1,
        yTranslationDirection: 1
    },
    "inside-bottom-left": {
        xTranslationDirection: 1,
        yTranslationDirection: -1
    },
    "inside-top-right": {
        xTranslationDirection: -1,
        yTranslationDirection: 1
    },
    "inside-bottom-right": {
        xTranslationDirection: -1,
        yTranslationDirection: -1
    }
};
var $d77b025aa58d633c$var$verticalCrossLineTranslationDirections = {
    top: {
        xTranslationDirection: 1,
        yTranslationDirection: 0
    },
    bottom: {
        xTranslationDirection: -1,
        yTranslationDirection: 0
    },
    left: {
        xTranslationDirection: 0,
        yTranslationDirection: -1
    },
    right: {
        xTranslationDirection: 0,
        yTranslationDirection: 1
    },
    "top-left": {
        xTranslationDirection: -1,
        yTranslationDirection: -1
    },
    "top-right": {
        xTranslationDirection: -1,
        yTranslationDirection: 1
    },
    "bottom-left": {
        xTranslationDirection: 1,
        yTranslationDirection: -1
    },
    "bottom-right": {
        xTranslationDirection: 1,
        yTranslationDirection: 1
    },
    inside: {
        xTranslationDirection: 0,
        yTranslationDirection: 0
    },
    "inside-left": {
        xTranslationDirection: 0,
        yTranslationDirection: 1
    },
    "inside-right": {
        xTranslationDirection: 0,
        yTranslationDirection: -1
    },
    "inside-top": {
        xTranslationDirection: -1,
        yTranslationDirection: 0
    },
    "inside-bottom": {
        xTranslationDirection: 1,
        yTranslationDirection: 0
    },
    "inside-top-left": {
        xTranslationDirection: -1,
        yTranslationDirection: 1
    },
    "inside-bottom-left": {
        xTranslationDirection: 1,
        yTranslationDirection: 1
    },
    "inside-top-right": {
        xTranslationDirection: -1,
        yTranslationDirection: -1
    },
    "inside-bottom-right": {
        xTranslationDirection: 1,
        yTranslationDirection: -1
    }
};
function $d77b025aa58d633c$var$calculateLabelTranslation({ yDirection: yDirection, padding: padding = 0, position: position = "top", bbox: bbox }) {
    const crossLineTranslationDirections = yDirection ? $d77b025aa58d633c$var$horizontalCrosslineTranslationDirections : $d77b025aa58d633c$var$verticalCrossLineTranslationDirections;
    const { xTranslationDirection: xTranslationDirection, yTranslationDirection: yTranslationDirection } = crossLineTranslationDirections[position];
    const xTranslation = xTranslationDirection * (padding + bbox.width / 2);
    const yTranslation = yTranslationDirection * (padding + bbox.height / 2);
    return {
        xTranslation: xTranslation,
        yTranslation: yTranslation
    };
}
function $d77b025aa58d633c$var$createButton(options, attrs) {
    const button = (0, $idDdm.createElement)("button", $d77b025aa58d633c$var$getClassName("ag-charts-input ag-charts-button", attrs));
    if (options.label !== void 0) button.append(options.label);
    else {
        button.append($d77b025aa58d633c$var$createIcon(options.icon));
        button.ariaLabel = options.altText;
    }
    button.addEventListener("click", options.onPress);
    (0, $idDdm.setAttributes)(button, attrs);
    return button;
}
function $d77b025aa58d633c$var$createCheckbox(options, attrs) {
    const checkbox = (0, $idDdm.createElement)("input", $d77b025aa58d633c$var$getClassName("ag-charts-input ag-charts-checkbox", attrs));
    checkbox.type = "checkbox";
    checkbox.checked = options.checked;
    checkbox.addEventListener("change", (event)=>options.onChange(checkbox.checked, event));
    checkbox.addEventListener("keydown", (event)=>{
        if ($d77b025aa58d633c$var$isButtonClickEvent(event)) {
            event.preventDefault();
            checkbox.click();
        }
    });
    (0, $idDdm.setAttributes)(checkbox, attrs);
    return checkbox;
}
function $d77b025aa58d633c$var$createSelect(options, attrs) {
    const select = (0, $idDdm.createElement)("select", $d77b025aa58d633c$var$getClassName("ag-charts-input ag-charts-select", attrs));
    select.append(...options.options.map((option)=>{
        const optionEl = (0, $idDdm.createElement)("option");
        optionEl.value = option.value;
        optionEl.textContent = option.label;
        return optionEl;
    }));
    (0, $idDdm.setAttribute)(select, "data-preventdefault", false);
    select.value = options.value;
    select.addEventListener("change", (event)=>options.onChange(select.value, event));
    (0, $idDdm.setAttributes)(select, attrs);
    return select;
}
function $d77b025aa58d633c$var$createTextArea(options, attrs) {
    const textArea = (0, $idDdm.createElement)("textarea", $d77b025aa58d633c$var$getClassName("ag-charts-input ag-charts-textarea", attrs));
    textArea.value = options.value;
    textArea.addEventListener("input", (event)=>options.onChange(textArea.value, event));
    (0, $idDdm.setAttributes)(textArea, attrs);
    (0, $idDdm.setAttribute)(textArea, "data-preventdefault", false);
    return textArea;
}
function $d77b025aa58d633c$var$createIcon(icon) {
    const el = (0, $idDdm.createElement)("span", `ag-charts-icon ag-charts-icon-${icon}`);
    (0, $idDdm.setAttribute)(el, "aria-hidden", true);
    return el;
}
function $d77b025aa58d633c$var$getClassName(baseClass, attrs) {
    if (attrs == null) return baseClass;
    return `${baseClass} ${attrs.class}`;
}
// packages/ag-charts-community/src/scene/shape/svgPath.ts
var $d77b025aa58d633c$var$SvgPath = class extends $d77b025aa58d633c$var$Path {
    constructor(d = ""){
        super();
        this.x = 0;
        this.y = 0;
        this.commands = [];
        this._d = "";
        this.d = d;
    }
    get d() {
        return this._d;
    }
    set d(d) {
        if (d === this._d) return;
        this._d = d;
        this.commands.length = 0;
        for (const [_, command, paramsString] of d.matchAll(/([A-Z])([0-9. ]*)/g)){
            const params = paramsString.split(/\s+/g).map(Number);
            this.commands.push([
                command,
                params
            ]);
        }
        this.checkPathDirty();
    }
    updatePath() {
        const { path: path, x: x, y: y } = this;
        path.clear();
        let lastX = x;
        let lastY = y;
        for (const [command, params] of this.commands)switch(command){
            case "M":
                path.moveTo(x + params[0], y + params[1]);
                lastX = x + params[0];
                break;
            case "C":
                path.cubicCurveTo(x + params[0], y + params[1], x + params[2], y + params[3], x + params[4], y + params[5]);
                lastX = x + params[4];
                lastY = y + params[5];
                break;
            case "H":
                path.lineTo(x + params[0], lastY);
                lastX = y + params[0];
                break;
            case "L":
                path.lineTo(x + params[0], y + params[1]);
                lastX = x + params[0];
                lastY = y + params[1];
                break;
            case "V":
                path.lineTo(lastX, y + params[0]);
                lastY = y + params[0];
                break;
            case "Z":
                path.closePath();
                break;
            default:
                throw new Error(`Could not translate command '${command}' with '${params.join(" ")}'`);
        }
        path.closePath();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$SvgPath.prototype, "x", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$SvgPath.prototype, "y", 2);
// packages/ag-charts-community/src/scene/image.ts
var $d77b025aa58d633c$var$Image3 = class extends $d77b025aa58d633c$var$Node2 {
    constructor(sourceImage){
        super();
        this.sourceImage = sourceImage;
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
        this.opacity = 1;
    }
    render(renderCtx) {
        const { ctx: ctx } = renderCtx;
        const image = this.sourceImage;
        if (image) {
            ctx.globalAlpha = this.opacity;
            ctx.drawImage(image, 0, 0, image.width, image.height, this.x, this.y, this.width, this.height);
        }
        super.render(renderCtx);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Image3.prototype, "x", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Image3.prototype, "y", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Image3.prototype, "width", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Image3.prototype, "height", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection()
], $d77b025aa58d633c$var$Image3.prototype, "opacity", 2);
// packages/ag-charts-community/src/widget/exports.ts
var $d77b025aa58d633c$export$eef9cbc113745b73 = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$export$eef9cbc113745b73, {
    ButtonWidget: ()=>$d77b025aa58d633c$var$ButtonWidget,
    MenuItemWidget: ()=>$d77b025aa58d633c$var$MenuItemWidget,
    MenuWidget: ()=>$d77b025aa58d633c$var$MenuWidget,
    NativeWidget: ()=>$d77b025aa58d633c$var$NativeWidget,
    SliderWidget: ()=>$d77b025aa58d633c$var$SliderWidget,
    ToolbarWidget: ()=>$d77b025aa58d633c$var$ToolbarWidget,
    WIDGET_HTML_EVENTS: ()=>$d77b025aa58d633c$var$WIDGET_HTML_EVENTS,
    Widget: ()=>$d77b025aa58d633c$var$Widget,
    WidgetEventUtil: ()=>$d77b025aa58d633c$var$WidgetEventUtil
});
var $d77b025aa58d633c$var$MenuItemWidget = class extends $d77b025aa58d633c$var$AbstractButtonWidget {
    constructor(){
        super((0, $idDdm.createElement)("div"), "menuitem");
    }
};
// packages/ag-charts-community/src/widget/menuWidget.ts
var $d77b025aa58d633c$var$closeKeys = [
    "Escape",
    "ArrowLeft"
];
var $d77b025aa58d633c$var$MenuWidget = class _MenuWidget extends $d77b025aa58d633c$var$RovingTabContainerWidget {
    constructor(orientation = "vertical"){
        super(orientation, "menu");
        this.closeSubMenu = (ev)=>this.openSubMenu(ev, void 0);
    }
    destructor() {
        this.selfClose("2" /* DESTROY */ );
    }
    addSeparator() {
        const sep = (0, $idDdm.getDocument)().createElement("div");
        (0, $idDdm.setAttribute)(sep, "role", "separator");
        this.elem.appendChild(sep);
        return sep;
    }
    onChildAdded(child) {
        super.onChildAdded(child);
        if (!child.hasPopup()) child.addListener("mouseenter", this.closeSubMenu);
    }
    onChildRemoved(child) {
        super.onChildRemoved(child);
        if (!child.hasPopup()) child.removeListener("mouseenter", this.closeSubMenu);
    }
    addSubMenu() {
        const subMenuButton = new $d77b025aa58d633c$var$MenuItemWidget();
        const subMenuId = (0, $idDdm.createElementId)();
        const subMenu = new _MenuWidget(this.orientation);
        const accessibleOpener = (ev)=>{
            if (!subMenuButton.isDisabled()) this.openSubMenu(ev, subMenu);
        };
        const arrowRightOpener = (ev)=>{
            if ($d77b025aa58d633c$var$hasNoModifiers(ev.sourceEvent) && ev.sourceEvent.code === "ArrowRight") accessibleOpener(ev);
        };
        subMenuButton.setAriaHasPopup("menu");
        subMenuButton.setAriaExpanded(false);
        subMenuButton.setAriaControls(subMenuId);
        subMenuButton.addListener("click", accessibleOpener);
        subMenuButton.addListener("mouseenter", accessibleOpener);
        subMenuButton.addListener("keydown", arrowRightOpener);
        subMenu.addListener("close-widget", ()=>subMenuButton.setAriaExpanded(false));
        subMenu.addListener("open-widget", ()=>subMenuButton.setAriaExpanded(true));
        subMenu.id = subMenuId;
        this.addChild(subMenuButton);
        return {
            subMenuButton: subMenuButton,
            subMenu: subMenu
        };
    }
    openSubMenu(ev, subMenu) {
        const { openScope: openScope } = this;
        if (!openScope) return;
        openScope.openSubMenu?.selfClose("4" /* SIDLING_OPENED */ );
        subMenu?.open(ev);
        openScope.openSubMenu = subMenu;
    }
    open(event, opts) {
        const { overrideFocusVisible: overrideFocusVisible } = opts ?? {};
        if (this.openScope != null) return;
        this.openScope = {
            lastFocus: $d77b025aa58d633c$var$getLastFocus(event.sourceEvent),
            openSubMenu: void 0,
            abort: ()=>this.selfClose("1" /* ABORT */ ),
            close: ()=>this.selfClose("0" /* CLOSE */ ),
            removers: new $d77b025aa58d633c$var$DestroyFns()
        };
        const buttons = this.children.map((value)=>value.getElement());
        (0, $idDdm.setAttribute)(this.openScope.lastFocus, "aria-expanded", true);
        $d77b025aa58d633c$var$addMouseCloseListener(this.openScope.removers, this.elem, this.openScope.abort);
        $d77b025aa58d633c$var$addTouchCloseListener(this.openScope.removers, this.elem, this.openScope.abort);
        for (const child of this.children)$d77b025aa58d633c$var$addEscapeEventListener(this.openScope.removers, child.getElement(), this.openScope.close, $d77b025aa58d633c$var$closeKeys);
        if (overrideFocusVisible !== void 0) $d77b025aa58d633c$var$addOverrideFocusVisibleEventListener(this.openScope.removers, this.elem, buttons, overrideFocusVisible);
        this.internalListener?.dispatch("open-widget", this, {
            type: "open-widget"
        });
        this.children[0]?.focus({
            preventScroll: true
        });
    }
    selfClose(mode) {
        if (this.openScope === void 0) return;
        const { lastFocus: lastFocus, removers: removers, openSubMenu: openSubMenu } = this.openScope;
        this.openScope = void 0;
        openSubMenu?.selfClose("3" /* PARENT_CLOSED */ );
        (0, $idDdm.setAttribute)(lastFocus, "aria-expanded", false);
        if (mode === "0" /* CLOSE */ ) lastFocus?.focus({
            preventScroll: true
        });
        removers.destroy();
        this.internalListener?.dispatch("close-widget", this, {
            type: "close-widget"
        });
    }
    close() {
        this.selfClose("0" /* CLOSE */ );
    }
};
var $d77b025aa58d633c$var$canvasOverlay = "canvas-overlay";
var $d77b025aa58d633c$var$Popover = class extends $d77b025aa58d633c$var$BaseModuleInstance {
    constructor(ctx, id, options){
        super();
        this.ctx = ctx;
        this.hideFns = [];
        this.moduleId = `popover-${id}`;
        if (options?.detached) this.element = (0, $idDdm.createElement)("div");
        else this.element = ctx.domManager.addChild($d77b025aa58d633c$var$canvasOverlay, this.moduleId);
        this.element.setAttribute("role", "presentation");
        this.destroyFns.push(()=>ctx.domManager.removeChild($d77b025aa58d633c$var$canvasOverlay, this.moduleId));
    }
    attachTo(popover) {
        if (this.element.parentElement) return;
        popover.element.append(this.element);
    }
    hide(opts) {
        const { lastFocus: lastFocus = this.lastFocus } = opts ?? {};
        if (this.element.children.length === 0) return;
        this.hideFns.forEach((fn)=>fn());
        lastFocus?.focus();
        this.lastFocus = void 0;
    }
    removeChildren() {
        this.element.replaceChildren();
    }
    showWithChildren(children, options) {
        if (!this.element.parentElement) throw new Error("Can not show popover that has not been attached to a parent.");
        const popover = (0, $idDdm.createElement)("div", "ag-charts-popover");
        if (options.ariaLabel != null) popover.setAttribute("aria-label", options.ariaLabel);
        if (options.class != null) popover.classList.add(options.class);
        popover.replaceChildren(...children);
        this.element.replaceChildren(popover);
        this.hideFns.push(()=>this.removeChildren());
        if (options.onHide) this.hideFns.push(options.onHide);
        if (options.initialFocus && options.sourceEvent) {
            const lastFocus = $d77b025aa58d633c$var$getLastFocus(options.sourceEvent);
            if (lastFocus !== void 0) {
                this.lastFocus = lastFocus;
                this.initialFocus = options.initialFocus;
            }
        }
        return popover;
    }
    getPopoverElement() {
        return this.element.firstElementChild;
    }
    updatePosition(position) {
        const popover = this.getPopoverElement();
        if (!popover) return;
        popover.style.setProperty("right", "unset");
        popover.style.setProperty("bottom", "unset");
        if (position.x != null) popover.style.setProperty("left", `${Math.floor(position.x)}px`);
        if (position.y != null) popover.style.setProperty("top", `${Math.floor(position.y)}px`);
        this.initialFocus?.focus();
        this.initialFocus = void 0;
    }
};
// packages/ag-charts-community/src/components/popover/anchoredPopover.ts
var $d77b025aa58d633c$var$AnchoredPopover = class extends $d77b025aa58d633c$var$Popover {
    setAnchor(anchor, fallbackAnchor) {
        this.anchor = anchor;
        this.fallbackAnchor = fallbackAnchor;
        this.updatePosition(anchor);
        this.repositionWithinBounds();
    }
    showWithChildren(children, options) {
        const anchor = options.anchor ?? this.anchor;
        const fallbackAnchor = options.fallbackAnchor ?? this.fallbackAnchor;
        const popover = super.showWithChildren(children, options);
        if (anchor) this.setAnchor(anchor, fallbackAnchor);
        (0, $idDdm.getWindow)().requestAnimationFrame(()=>{
            this.repositionWithinBounds();
        });
        return popover;
    }
    repositionWithinBounds() {
        const { anchor: anchor, ctx: ctx, fallbackAnchor: fallbackAnchor } = this;
        const popover = this.getPopoverElement();
        if (!anchor || !popover) return;
        const canvasRect = ctx.domManager.getBoundingClientRect();
        const { offsetWidth: width2, offsetHeight: height2 } = popover;
        let x = (0, $idDdm.clamp)(0, anchor.x, canvasRect.width - width2);
        let y = (0, $idDdm.clamp)(0, anchor.y, canvasRect.height - height2);
        if (x !== anchor.x && fallbackAnchor?.x != null) x = (0, $idDdm.clamp)(0, fallbackAnchor.x - width2, canvasRect.width - width2);
        if (y !== anchor.y && fallbackAnchor?.y != null) y = (0, $idDdm.clamp)(0, fallbackAnchor.y - height2, canvasRect.height - height2);
        this.updatePosition({
            x: x,
            y: y
        });
    }
};
// packages/ag-charts-community/src/components/menu/menu.ts
var $d77b025aa58d633c$var$Menu = class extends $d77b025aa58d633c$var$AnchoredPopover {
    show(options) {
        const rows = options.items.map((item)=>this.createRow(options, item));
        const popover = this.showWithChildren(rows, options);
        popover.classList.add("ag-charts-menu");
        popover.setAttribute("role", "menu");
        this.menuCloser = $d77b025aa58d633c$var$initMenuKeyNav({
            orientation: "vertical",
            menu: popover,
            buttons: rows,
            sourceEvent: options.sourceEvent,
            closeCallback: ()=>this.hide()
        });
        this.hideFns.push(()=>{
            this.menuCloser?.finishClosing();
            this.menuCloser = void 0;
        });
    }
    createRow(options, item) {
        const { menuItemRole: menuItemRole = "menuitem" } = options;
        const active = item.value === options.value;
        const row = (0, $idDdm.createElement)("div", "ag-charts-menu__row");
        row.setAttribute("role", menuItemRole);
        if (menuItemRole === "menuitemradio") row.setAttribute("aria-checked", (options.value === item.value).toString());
        if (typeof item.value === "string") row.dataset.popoverId = item.value;
        row.classList.toggle(`ag-charts-menu__row--active`, active);
        if (item.icon != null) {
            const icon = (0, $idDdm.createElement)("span", `ag-charts-menu__icon ${$d77b025aa58d633c$var$getIconClassNames(item.icon)}`);
            row.appendChild(icon);
        }
        const strokeWidthVisible = item.strokeWidth != null;
        if (strokeWidthVisible) {
            row.classList.toggle(`ag-charts-menu__row--stroke-width-visible`, strokeWidthVisible);
            row.style.setProperty("--strokeWidth", strokeWidthVisible ? `${item.strokeWidth}px` : null);
        }
        if (item.label != null) {
            const label = (0, $idDdm.createElement)("span", "ag-charts-menu__label");
            label.textContent = this.ctx.localeManager.t(item.label);
            row.appendChild(label);
        }
        if ("altText" in item) row.ariaLabel = this.ctx.localeManager.t(item.altText);
        const select = ()=>{
            options.onPress?.(item);
        };
        const onclick = (e)=>{
            if ($d77b025aa58d633c$var$isButtonClickEvent(e)) {
                select();
                e.preventDefault();
                e.stopPropagation();
            }
        };
        row.addEventListener("keydown", onclick);
        row.addEventListener("click", onclick);
        row.addEventListener("mousemove", ()=>{
            row.focus({
                preventScroll: true
            });
        });
        return row;
    }
};
// packages/ag-charts-community/src/components/popover/draggablePopover.ts
var $d77b025aa58d633c$var$DraggablePopover = class extends $d77b025aa58d633c$var$Popover {
    constructor(){
        super(...arguments);
        this.dragged = false;
    }
    setDragHandle(dragHandle) {
        dragHandle.addListener("drag-start", (event)=>{
            dragHandle.addClass(this.dragHandleDraggingClass);
            this.onDragStart(event);
        });
        dragHandle.addListener("drag-move", this.onDragMove.bind(this));
        dragHandle.addListener("drag-end", ()=>{
            dragHandle.removeClass(this.dragHandleDraggingClass);
            this.onDragEnd.bind(this);
        });
    }
    onDragStart(event) {
        const popover = this.getPopoverElement();
        if (!popover) return;
        event.sourceEvent.preventDefault();
        this.dragged = true;
        this.dragStartState = {
            client: $d77b025aa58d633c$var$Vec2.from(event.clientX, event.clientY),
            position: $d77b025aa58d633c$var$Vec2.from(Number(popover.style.getPropertyValue("left").replace("px", "")), Number(popover.style.getPropertyValue("top").replace("px", "")))
        };
    }
    onDragMove(event) {
        const { dragStartState: dragStartState } = this;
        const popover = this.getPopoverElement();
        if (!dragStartState || !popover) return;
        const offset4 = $d77b025aa58d633c$var$Vec2.sub($d77b025aa58d633c$var$Vec2.from(event.clientX, event.clientY), dragStartState.client);
        const position = $d77b025aa58d633c$var$Vec2.add(dragStartState.position, offset4);
        const bounds = this.ctx.domManager.getBoundingClientRect();
        const partialPosition = {};
        if (position.x >= 0 && position.x + popover.offsetWidth <= bounds.width) partialPosition.x = position.x;
        if (position.y >= 0 && position.y + popover.offsetHeight <= bounds.height) partialPosition.y = position.y;
        this.updatePosition(partialPosition);
    }
    onDragEnd() {
        this.dragStartState = void 0;
    }
};
// packages/ag-charts-community/src/components/toolbar/toolbarButtonProperties.ts
var $d77b025aa58d633c$var$ToolbarButtonProperties = class extends $d77b025aa58d633c$var$BaseProperties {
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ToolbarButtonProperties.prototype, "icon", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ToolbarButtonProperties.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ToolbarButtonProperties.prototype, "ariaLabel", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Property
], $d77b025aa58d633c$var$ToolbarButtonProperties.prototype, "tooltip", 2);
var $d77b025aa58d633c$var$ToolbarButtonWidget = class extends $d77b025aa58d633c$var$ButtonWidget {
    constructor(localeManager){
        super();
        this.localeManager = localeManager;
    }
    update(options) {
        const { localeManager: localeManager } = this;
        if (options.tooltip) this.elem.title = localeManager.t(options.tooltip);
        let innerHTML = "";
        if (options.icon != null) innerHTML = `<span class="${$d77b025aa58d633c$var$getIconClassNames(options.icon)} ag-charts-toolbar__icon"></span>`;
        if (options.label != null) {
            const label = localeManager.t(options.label);
            innerHTML = `${innerHTML}<span class="ag-charts-toolbar__label">${label}</span>`;
        }
        this.elem.innerHTML = innerHTML;
    }
    setChecked(checked) {
        (0, $idDdm.setAttribute)(this.elem, "aria-checked", checked);
    }
};
// packages/ag-charts-community/src/components/toolbar/toolbar.ts
var $d77b025aa58d633c$var$BUTTON_ACTIVE_CLASS = "ag-charts-toolbar__button--active";
var $d77b025aa58d633c$var$BaseToolbar = class extends $d77b025aa58d633c$var$ToolbarWidget {
    constructor(localeManager, orientation = "horizontal"){
        super(orientation);
        this.localeManager = localeManager;
        this.horizontalSpacing = 10;
        this.verticalSpacing = 10;
        this.events = new $d77b025aa58d633c$var$Listeners();
        this.hasPrefix = false;
        this.buttonWidgets = [];
        this.addClass("ag-charts-toolbar");
        this.toggleClass("ag-charts-toolbar--horizontal", orientation === "horizontal");
        this.toggleClass("ag-charts-toolbar--vertical", orientation === "vertical");
    }
    addToolbarListener(eventType, handler) {
        return this.events.addListener(eventType, handler);
    }
    clearButtons() {
        for (const button of this.buttonWidgets)button.destroy();
        this.buttonWidgets.splice(0);
    }
    updateButtons(buttons) {
        const { buttonWidgets: buttonWidgets } = this;
        for (const [index, button] of buttons.entries()){
            const buttonWidget = this.buttonWidgets.at(index) ?? this.createButton(index, button);
            buttonWidget.update(button);
        }
        for(let index = buttons.length; index < buttonWidgets.length; index++){
            const button = this.buttonWidgets.at(index);
            button?.destroy();
        }
        this.buttonWidgets.splice(buttons.length);
        this.refreshButtonClasses();
    }
    updateButtonByIndex(index, button) {
        this.buttonWidgets.at(index)?.update(button);
    }
    clearActiveButton() {
        for (const button of this.buttonWidgets)button.toggleClass($d77b025aa58d633c$var$BUTTON_ACTIVE_CLASS, false);
    }
    toggleActiveButtonByIndex(index) {
        if (index === -1) return;
        for (const [buttonIndex, button] of this.buttonWidgets.entries())button.toggleClass($d77b025aa58d633c$var$BUTTON_ACTIVE_CLASS, index != null && index === buttonIndex);
    }
    toggleButtonEnabledByIndex(index, enabled) {
        if (index === -1) return;
        this.buttonWidgets.at(index)?.setEnabled(enabled);
    }
    toggleSwitchCheckedByIndex(index, checked) {
        if (index === -1) return;
        this.buttonWidgets.at(index)?.setChecked(checked);
    }
    getButtonBounds() {
        return this.buttonWidgets.map((buttonWidget)=>this.getButtonWidgetBounds(buttonWidget));
    }
    setButtonHiddenByIndex(index, hidden) {
        this.buttonWidgets.at(index)?.setHidden(hidden);
    }
    getButtonWidgetBounds(buttonWidget) {
        const parent = this.getBounds();
        const bounds = buttonWidget.getBounds();
        return new $d77b025aa58d633c$var$BBox(bounds.x + parent.x, bounds.y + parent.y, bounds.width, bounds.height);
    }
    refreshButtonClasses() {
        const { buttonWidgets: buttonWidgets, hasPrefix: hasPrefix } = this;
        let first2;
        let last;
        let section;
        for (const [index, buttonWidget] of buttonWidgets.entries()){
            first2 = !hasPrefix && index === 0 || section != buttonWidget.section;
            last = index === buttonWidgets.length - 1 || buttonWidget.section != buttonWidgets.at(index + 1)?.section;
            buttonWidget.toggleClass("ag-charts-toolbar__button--first", first2);
            buttonWidget.toggleClass("ag-charts-toolbar__button--last", last);
            buttonWidget.toggleClass("ag-charts-toolbar__button--gap", index > 0 && first2);
            section = buttonWidget.section;
        }
    }
    createButton(index, button) {
        const buttonWidget = this.createButtonWidget();
        buttonWidget.addClass("ag-charts-toolbar__button");
        buttonWidget.addListener("click", (event)=>{
            const buttonOptions = {
                index: index,
                ...button instanceof $d77b025aa58d633c$var$BaseProperties ? button.toJson() : button
            };
            const buttonBounds = this.getButtonWidgetBounds(buttonWidget);
            this.events.dispatch("button-pressed", {
                event: event,
                button: buttonOptions,
                buttonBounds: buttonBounds
            });
        });
        buttonWidget.addListener("focus", ()=>{
            this.events.dispatch("button-focused", {
                button: {
                    index: index
                }
            });
        });
        if (button.section) buttonWidget.section = button.section;
        this.buttonWidgets.push(buttonWidget);
        this.addChild(buttonWidget);
        return buttonWidget;
    }
};
var $d77b025aa58d633c$var$Toolbar = class extends $d77b025aa58d633c$var$BaseToolbar {
    createButtonWidget() {
        return new $d77b025aa58d633c$var$ToolbarButtonWidget(this.localeManager);
    }
};
var $d77b025aa58d633c$var$FloatingToolbarPopover = class extends $d77b025aa58d633c$var$DraggablePopover {
    constructor(ctx, id, onPopoverMoved){
        super(ctx, id);
        this.onPopoverMoved = onPopoverMoved;
        this.dragHandleDraggingClass = "ag-charts-floating-toolbar__drag-handle--dragging";
    }
    show(children, options = {}) {
        this.showWithChildren(children, {
            ...options,
            class: "ag-charts-floating-toolbar"
        });
    }
    hide() {
        this.dragged = false;
        super.hide();
    }
    getBounds() {
        const element2 = this.getPopoverElement();
        return new $d77b025aa58d633c$var$BBox(element2?.offsetLeft ?? 0, element2?.offsetTop ?? 0, element2?.offsetWidth ?? 0, element2?.offsetHeight ?? 0);
    }
    hasBeenDragged() {
        return this.dragged;
    }
    setAnchor(anchor, horizontalSpacing, verticalSpacing) {
        const element2 = this.getPopoverElement();
        if (!element2) return;
        const position = anchor.position ?? "above";
        const { offsetWidth: width2, offsetHeight: height2 } = element2;
        let top = anchor.y - height2 - verticalSpacing;
        let left = anchor.x - width2 / 2;
        if (position === "below") top = anchor.y + verticalSpacing;
        else if (position === "right") {
            top = anchor.y - height2 / 2;
            left = anchor.x + horizontalSpacing;
        } else if (position === "above-left") left = anchor.x;
        this.updatePosition({
            x: left,
            y: top
        });
    }
    ignorePointerEvents() {
        const element2 = this.getPopoverElement();
        if (element2) element2.style.pointerEvents = "none";
    }
    capturePointerEvents() {
        const element2 = this.getPopoverElement();
        if (element2) element2.style.pointerEvents = "unset";
    }
    updatePosition(position) {
        const bounds = this.getBounds();
        const canvasRect = this.ctx.domManager.getBoundingClientRect();
        position.x = Math.floor((0, $idDdm.clamp)(0, position.x, canvasRect.width - bounds.width));
        position.y = Math.floor((0, $idDdm.clamp)(0, position.y, canvasRect.height - bounds.height));
        super.updatePosition(position);
        this.onPopoverMoved();
    }
};
var $d77b025aa58d633c$var$FloatingToolbar = class extends $d77b025aa58d633c$var$BaseToolbar {
    constructor(ctx, id){
        super(ctx.localeManager);
        this.hasPrefix = true;
        this.popover = new $d77b025aa58d633c$var$FloatingToolbarPopover(ctx, id, this.onPopoverMoved.bind(this));
        this.dragHandle = new $d77b025aa58d633c$var$DragHandleWidget(ctx.localeManager.t("toolbarAnnotationsDragHandle"));
        this.popover.setDragHandle(this.dragHandle);
    }
    show(options = {}) {
        this.popover.show([
            this.dragHandle.getElement(),
            this.getElement()
        ], options);
    }
    hide() {
        this.popover.hide();
    }
    setAnchor(anchor) {
        this.popover.setAnchor(anchor, this.horizontalSpacing, this.verticalSpacing);
    }
    hasBeenDragged() {
        return this.popover.hasBeenDragged();
    }
    ignorePointerEvents() {
        this.popover.ignorePointerEvents();
    }
    capturePointerEvents() {
        this.popover.capturePointerEvents();
    }
    onPopoverMoved() {
        const popoverBounds = this.popover.getBounds();
        if (this.popoverBounds?.equals(popoverBounds)) return;
        this.popoverBounds = popoverBounds.clone();
        const buttonBounds = this.getButtonBounds();
        this.events.dispatch("toolbar-moved", {
            popoverBounds: popoverBounds,
            buttonBounds: buttonBounds
        });
    }
    getButtonWidgetBounds(buttonWidget) {
        const popoverBounds = this.popover.getBounds();
        const bounds = super.getButtonWidgetBounds(buttonWidget);
        const dragHandleBounds = this.dragHandle.getBounds();
        return new $d77b025aa58d633c$var$BBox(bounds.x + popoverBounds.x - dragHandleBounds.width, bounds.y + popoverBounds.y, bounds.width, bounds.height);
    }
};
var $d77b025aa58d633c$var$DragHandleWidget = class extends $d77b025aa58d633c$var$NativeWidget {
    constructor(title){
        super((0, $idDdm.createElement)("div", "ag-charts-floating-toolbar__drag-handle"));
        const icon = new $d77b025aa58d633c$var$NativeWidget((0, $idDdm.createElement)("span", `${$d77b025aa58d633c$var$getIconClassNames("drag-handle")} ag-charts-toolbar__icon`));
        icon.setAriaHidden(true);
        this.addChild(icon);
        this.elem.title = title;
    }
};
// packages/ag-charts-community/src/module-support.ts
var $d77b025aa58d633c$var$motion = {
    ...$d77b025aa58d633c$var$fromToMotion_exports,
    ...$d77b025aa58d633c$var$resetMotion_exports
};
// packages/ag-charts-community/src/main.ts
var $d77b025aa58d633c$export$c6d4909a4ed21cf2 = {
    VERSION: $d77b025aa58d633c$export$a4ad2735b021c132,
    _Scene: $d77b025aa58d633c$export$f88ced8f90c5ae15,
    _Theme: $d77b025aa58d633c$export$d23fb0bb3c916391,
    _Util: $d77b025aa58d633c$export$48e12db5e55fd3a3,
    create: $d77b025aa58d633c$export$e93fe4969a168dc7.create.bind($d77b025aa58d633c$export$e93fe4969a168dc7),
    createSparkline: $d77b025aa58d633c$export$e93fe4969a168dc7.__createSparkline.bind($d77b025aa58d633c$export$e93fe4969a168dc7),
    setup: $d77b025aa58d633c$export$2f274d5ba325cdcd,
    isEnterprise: false
};

});
parcelRegister("idDdm", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $5dc446195194829d$export$efa9a398d6368992);
$parcel$export(module.exports, "ModuleRegistry", () => $5dc446195194829d$export$dc053975cc7f6c11);
$parcel$export(module.exports, "ModuleType", () => $5dc446195194829d$export$6a8195ee8dd1cc03);
$parcel$export(module.exports, "EventEmitter", () => $5dc446195194829d$export$4fae95256245c8c0);
$parcel$export(module.exports, "getDocument", () => $5dc446195194829d$export$f65ca476c09acec0);
$parcel$export(module.exports, "getWindow", () => $5dc446195194829d$export$38b2d434cce3ea22);
$parcel$export(module.exports, "setDocument", () => $5dc446195194829d$export$65af85b1e66fbfaf);
$parcel$export(module.exports, "setWindow", () => $5dc446195194829d$export$b4ab31529663b75b);
$parcel$export(module.exports, "createElement", () => $5dc446195194829d$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "createSvgElement", () => $5dc446195194829d$export$2a5da685d2abe499);
$parcel$export(module.exports, "downloadUrl", () => $5dc446195194829d$export$8a96edb1c96563f4);
$parcel$export(module.exports, "isDefined", () => $5dc446195194829d$export$4e62c701997796c1);
$parcel$export(module.exports, "isArray", () => $5dc446195194829d$export$43bee75e5e14138e);
$parcel$export(module.exports, "isDate", () => $5dc446195194829d$export$871608497c498473);
$parcel$export(module.exports, "isValidDate", () => $5dc446195194829d$export$c03bb0116ee09d4b);
$parcel$export(module.exports, "isRegExp", () => $5dc446195194829d$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $5dc446195194829d$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isObject", () => $5dc446195194829d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPlainObject", () => $5dc446195194829d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isString", () => $5dc446195194829d$export$844ec244b1367d54);
$parcel$export(module.exports, "isNumber", () => $5dc446195194829d$export$7e4aa119212bc614);
$parcel$export(module.exports, "isFiniteNumber", () => $5dc446195194829d$export$cf6c09818bd7035a);
$parcel$export(module.exports, "isHtmlElement", () => $5dc446195194829d$export$211442cb55fb93);
$parcel$export(module.exports, "isEnumValue", () => $5dc446195194829d$export$26692eaabd7e05b);
$parcel$export(module.exports, "isSymbol", () => $5dc446195194829d$export$a244864fd9645c7f);
$parcel$export(module.exports, "isKeyOf", () => $5dc446195194829d$export$593c2aea212a54d2);
$parcel$export(module.exports, "debounce", () => $5dc446195194829d$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "throttle", () => $5dc446195194829d$export$de363e709c412c8a);
$parcel$export(module.exports, "joinFormatted", () => $5dc446195194829d$export$c32bc175729db37d);
$parcel$export(module.exports, "countLines", () => $5dc446195194829d$export$dcd94c44359f7fd4);
$parcel$export(module.exports, "unionSymbol", () => $5dc446195194829d$export$7fa97f9a075031f3);
$parcel$export(module.exports, "ErrorType", () => $5dc446195194829d$export$dba1278861bf0dc1);
$parcel$export(module.exports, "ValidationError", () => $5dc446195194829d$export$2191b9da168c6cf0);
$parcel$export(module.exports, "UnknownError", () => $5dc446195194829d$export$ff4405149dbd0c5c);
$parcel$export(module.exports, "validate", () => $5dc446195194829d$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "hasRequiredInPath", () => $5dc446195194829d$export$bd1887c4bfaf38c2);
$parcel$export(module.exports, "attachDescription", () => $5dc446195194829d$export$bba6692a526d78aa);
$parcel$export(module.exports, "required", () => $5dc446195194829d$export$a7a0278c004aac3f);
$parcel$export(module.exports, "optionsDefs", () => $5dc446195194829d$export$7a6abca6f5652443);
$parcel$export(module.exports, "undocumented", () => $5dc446195194829d$export$1b4eadfd4235d039);
$parcel$export(module.exports, "typeUnion", () => $5dc446195194829d$export$8e0e4e6aaf611182);
$parcel$export(module.exports, "and", () => $5dc446195194829d$export$21c0ac7fe1cef1b8);
$parcel$export(module.exports, "or", () => $5dc446195194829d$export$252bb8b3bbdf6749);
$parcel$export(module.exports, "array", () => $5dc446195194829d$export$2f23118c22fb2630);
$parcel$export(module.exports, "boolean", () => $5dc446195194829d$export$4a21f16c33752377);
$parcel$export(module.exports, "callback", () => $5dc446195194829d$export$eb872837e3137261);
$parcel$export(module.exports, "color", () => $5dc446195194829d$export$35e9368ef982300f);
$parcel$export(module.exports, "date", () => $5dc446195194829d$export$324d90190a8b822a);
$parcel$export(module.exports, "defined", () => $5dc446195194829d$export$43f40ad3fa1d5c97);
$parcel$export(module.exports, "number", () => $5dc446195194829d$export$98e628dec113755e);
$parcel$export(module.exports, "object", () => $5dc446195194829d$export$be5493f9613cbbe);
$parcel$export(module.exports, "string", () => $5dc446195194829d$export$22b082955e083ec3);
$parcel$export(module.exports, "htmlElement", () => $5dc446195194829d$export$e7b2b12b6108c43);
$parcel$export(module.exports, "arrayLength", () => $5dc446195194829d$export$a030413a47e709b);
$parcel$export(module.exports, "numberRange", () => $5dc446195194829d$export$ef3d98e343adfaa7);
$parcel$export(module.exports, "positiveNumber", () => $5dc446195194829d$export$4ea4739d3fef092b);
$parcel$export(module.exports, "positiveNumberNonZero", () => $5dc446195194829d$export$7a3de1ac8ff87618);
$parcel$export(module.exports, "ratio", () => $5dc446195194829d$export$85f17f73487c6e7d);
$parcel$export(module.exports, "lessThan", () => $5dc446195194829d$export$9b050841a3a1b328);
$parcel$export(module.exports, "greaterThan", () => $5dc446195194829d$export$f517ea36c68d4644);
$parcel$export(module.exports, "union", () => $5dc446195194829d$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "constant", () => $5dc446195194829d$export$c983f826f44ff86);
$parcel$export(module.exports, "instanceOf", () => $5dc446195194829d$export$ca03416d6c9e029e);
$parcel$export(module.exports, "arrayOf", () => $5dc446195194829d$export$e57ff0f701c44363);
$parcel$export(module.exports, "arrayOfDefs", () => $5dc446195194829d$export$fe1127d1c893468a);
$parcel$export(module.exports, "callbackOf", () => $5dc446195194829d$export$5ddbb04d06945c52);
$parcel$export(module.exports, "callbackDefs", () => $5dc446195194829d$export$6ff6dc42cac175be);
$parcel$export(module.exports, "themeOperator", () => $5dc446195194829d$export$5733cbdd20762933);
$parcel$export(module.exports, "colorStopsOrderValidator", () => $5dc446195194829d$export$2e447a4ee32725b5);
$parcel$export(module.exports, "gradientStrict", () => $5dc446195194829d$export$cbcc33c03ee9d202);
$parcel$export(module.exports, "strokeOptionsDef", () => $5dc446195194829d$export$e29d86c1f14e7d1b);
$parcel$export(module.exports, "fillGradientDefaults", () => $5dc446195194829d$export$e4300b1ae67dd683);
$parcel$export(module.exports, "fillPatternDefaults", () => $5dc446195194829d$export$9f82189363b38286);
$parcel$export(module.exports, "fillImageDefaults", () => $5dc446195194829d$export$34c5126f6b977ec7);
$parcel$export(module.exports, "colorUnion", () => $5dc446195194829d$export$14c5fb1a7b3fdd3e);
$parcel$export(module.exports, "fillOptionsDef", () => $5dc446195194829d$export$e5ca88d5ef7e3172);
$parcel$export(module.exports, "lineDashOptionsDef", () => $5dc446195194829d$export$59de7b59331cdd19);
$parcel$export(module.exports, "fontFamilyFull", () => $5dc446195194829d$export$4f72aa8b2be7d87c);
$parcel$export(module.exports, "fontOptionsDef", () => $5dc446195194829d$export$94bedaee6d52b277);
$parcel$export(module.exports, "toArray", () => $5dc446195194829d$export$45b10814cc054894);
$parcel$export(module.exports, "unique", () => $5dc446195194829d$export$7a5d5c156e7dc406);
$parcel$export(module.exports, "groupBy", () => $5dc446195194829d$export$3f063810d7bf01bd);
$parcel$export(module.exports, "arraysEqual", () => $5dc446195194829d$export$234180f8206db11b);
$parcel$export(module.exports, "circularSliceArray", () => $5dc446195194829d$export$4f04e632baba1950);
$parcel$export(module.exports, "sortBasedOnArray", () => $5dc446195194829d$export$2f90d41869a06080);
$parcel$export(module.exports, "dropFirstWhile", () => $5dc446195194829d$export$53419c3d64755fbd);
$parcel$export(module.exports, "dropLastWhile", () => $5dc446195194829d$export$39c8e39349afec19);
$parcel$export(module.exports, "AsyncAwaitQueue", () => $5dc446195194829d$export$44b16b51f8782693);
$parcel$export(module.exports, "pause", () => $5dc446195194829d$export$229c72e5fdee233b);
$parcel$export(module.exports, "iterate", () => $5dc446195194829d$export$c1a059043cc9c119);
$parcel$export(module.exports, "toIterable", () => $5dc446195194829d$export$22419d807aae1935);
$parcel$export(module.exports, "first", () => $5dc446195194829d$export$43128fadae87b74a);
$parcel$export(module.exports, "entries", () => $5dc446195194829d$export$3e9f948b41964866);
$parcel$export(module.exports, "setAttribute", () => $5dc446195194829d$export$9fec4d97f1922e0b);
$parcel$export(module.exports, "setAttributes", () => $5dc446195194829d$export$74da2cba014bdc09);
$parcel$export(module.exports, "getAttribute", () => $5dc446195194829d$export$735ee1799fd02602);
$parcel$export(module.exports, "setElementStyle", () => $5dc446195194829d$export$7dee023fd9f40ee);
$parcel$export(module.exports, "setElementStyles", () => $5dc446195194829d$export$d16b2ab591686b);
$parcel$export(module.exports, "findMaxIndex", () => $5dc446195194829d$export$d14a0c5b1661914b);
$parcel$export(module.exports, "findMinIndex", () => $5dc446195194829d$export$e6f0aa365af82aff);
$parcel$export(module.exports, "findMaxValue", () => $5dc446195194829d$export$1bedcaacb659a19e);
$parcel$export(module.exports, "diffArrays", () => $5dc446195194829d$export$f1c08b3bfc8443c4);
$parcel$export(module.exports, "clamp", () => $5dc446195194829d$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "inRange", () => $5dc446195194829d$export$ddf89a9c5af38f94);
$parcel$export(module.exports, "isNumberEqual", () => $5dc446195194829d$export$ffb638ef34bfe97b);
$parcel$export(module.exports, "isNegative", () => $5dc446195194829d$export$d0909a4f38b5c4d0);
$parcel$export(module.exports, "isInteger", () => $5dc446195194829d$export$a287f47fed4544b8);
$parcel$export(module.exports, "roundTo", () => $5dc446195194829d$export$7978a6ddf29f4374);
$parcel$export(module.exports, "modulus", () => $5dc446195194829d$export$2effa4df065fbace);
$parcel$export(module.exports, "countFractionDigits", () => $5dc446195194829d$export$88877a4c336dc8d8);
$parcel$export(module.exports, "geoJson", () => $5dc446195194829d$export$1c99306f6e0eb8a);
$parcel$export(module.exports, "createId", () => $5dc446195194829d$export$7149c6ffc9994c32);
$parcel$export(module.exports, "createElementId", () => $5dc446195194829d$export$e4789b5c419678e0);
$parcel$export(module.exports, "generateUUID", () => $5dc446195194829d$export$e73c8bd0f20705a);
$parcel$export(module.exports, "isValidNumberFormat", () => $5dc446195194829d$export$ee85cba4a41bdffc);
$parcel$export(module.exports, "parseNumberFormat", () => $5dc446195194829d$export$b4abf8bcc8b47ded);
$parcel$export(module.exports, "createNumberFormatter", () => $5dc446195194829d$export$f056b1f978c629b5);
var $5dc446195194829d$var$__defProp = Object.defineProperty;
var $5dc446195194829d$var$__export = (target, all)=>{
    for(var name in all)$5dc446195194829d$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// packages/ag-charts-core/src/globals/logger.ts
var $5dc446195194829d$export$efa9a398d6368992 = {};
$5dc446195194829d$var$__export($5dc446195194829d$export$efa9a398d6368992, {
    error: ()=>$5dc446195194829d$var$error,
    errorOnce: ()=>$5dc446195194829d$var$errorOnce,
    log: ()=>$5dc446195194829d$var$log,
    logGroup: ()=>$5dc446195194829d$var$logGroup,
    reset: ()=>$5dc446195194829d$var$reset,
    table: ()=>$5dc446195194829d$var$table,
    warn: ()=>$5dc446195194829d$var$warn,
    warnOnce: ()=>$5dc446195194829d$var$warnOnce
});
var $5dc446195194829d$var$doOnceCache = /* @__PURE__ */ new Set();
function $5dc446195194829d$var$log(...logContent) {
    console.log(...logContent);
}
function $5dc446195194829d$var$warn(message, ...logContent) {
    console.warn(`AG Charts - ${message}`, ...logContent);
}
function $5dc446195194829d$var$error(message, ...logContent) {
    if (typeof message === "object") console.error(`AG Charts error`, message, ...logContent);
    else console.error(`AG Charts - ${message}`, ...logContent);
}
function $5dc446195194829d$var$table(...logContent) {
    console.table(...logContent);
}
function $5dc446195194829d$var$guardOnce(messageOrError, prefix, cb) {
    let message;
    if (messageOrError instanceof Error) message = messageOrError.message;
    else if (typeof messageOrError === "string") message = messageOrError;
    else if (typeof messageOrError === "object") message = JSON.stringify(messageOrError);
    else message = String(messageOrError);
    const cacheKey = `${prefix}: ${message}`;
    if ($5dc446195194829d$var$doOnceCache.has(cacheKey)) return;
    cb(messageOrError);
    $5dc446195194829d$var$doOnceCache.add(cacheKey);
}
function $5dc446195194829d$var$warnOnce(messageOrError, ...logContent) {
    $5dc446195194829d$var$guardOnce(messageOrError, "Logger.warn", (message)=>$5dc446195194829d$var$warn(message, ...logContent));
}
function $5dc446195194829d$var$errorOnce(messageOrError, ...logContent) {
    $5dc446195194829d$var$guardOnce(messageOrError, "Logger.error", (message)=>$5dc446195194829d$var$error(message, ...logContent));
}
function $5dc446195194829d$var$reset() {
    $5dc446195194829d$var$doOnceCache.clear();
}
function $5dc446195194829d$var$logGroup(name, cb) {
    console.groupCollapsed(name);
    try {
        return cb();
    } finally{
        console.groupEnd();
    }
}
// packages/ag-charts-core/src/globals/moduleRegistry.ts
var $5dc446195194829d$export$dc053975cc7f6c11 = {};
$5dc446195194829d$var$__export($5dc446195194829d$export$dc053975cc7f6c11, {
    detectChartDefinition: ()=>$5dc446195194829d$var$detectChartDefinition,
    getAxisModule: ()=>$5dc446195194829d$var$getAxisModule,
    getPresetModule: ()=>$5dc446195194829d$var$getPresetModule,
    getSeriesModule: ()=>$5dc446195194829d$var$getSeriesModule,
    hasModule: ()=>$5dc446195194829d$var$hasModule,
    listModulesByType: ()=>$5dc446195194829d$var$listModulesByType,
    register: ()=>$5dc446195194829d$var$register,
    registerMany: ()=>$5dc446195194829d$var$registerMany,
    reset: ()=>$5dc446195194829d$var$reset2
});
// packages/ag-charts-core/src/interfaces/moduleDefinition.ts
var $5dc446195194829d$export$6a8195ee8dd1cc03 = /* @__PURE__ */ ((ModuleType2)=>{
    ModuleType2["Axis"] = "axis";
    ModuleType2["Chart"] = "chart";
    ModuleType2["Preset"] = "preset";
    ModuleType2["Plugin"] = "plugin";
    ModuleType2["Series"] = "series";
    return ModuleType2;
})($5dc446195194829d$export$6a8195ee8dd1cc03 || {});
// packages/ag-charts-core/src/globals/moduleRegistry.ts
var $5dc446195194829d$var$registeredModules = /* @__PURE__ */ new Map();
function $5dc446195194829d$var$register(definition) {
    const existingDefinition = $5dc446195194829d$var$registeredModules.get(definition.name);
    if (existingDefinition && (existingDefinition.enterprise || !definition.enterprise)) throw new Error(`AG Charts - Module '${definition.name}' already registered`);
    $5dc446195194829d$var$registeredModules.set(definition.name, definition);
}
function $5dc446195194829d$var$registerMany(definitions) {
    for (const definition of definitions)$5dc446195194829d$var$register(definition);
}
function $5dc446195194829d$var$reset2() {
    $5dc446195194829d$var$registeredModules.clear();
}
function $5dc446195194829d$var$hasModule(moduleName) {
    return $5dc446195194829d$var$registeredModules.has(moduleName);
}
function* $5dc446195194829d$var$listModulesByType(moduleType) {
    for (const definition of $5dc446195194829d$var$registeredModules.values())if ($5dc446195194829d$var$isModuleType(moduleType, definition)) yield definition;
}
function $5dc446195194829d$var$detectChartDefinition(options) {
    for (const definition of $5dc446195194829d$var$registeredModules.values()){
        if ($5dc446195194829d$var$isModuleType("chart" /* Chart */ , definition) && definition.detect(options)) return definition;
    }
    throw new Error(`AG Charts - Unknown chart type; Check options are correctly structured and series types are specified`);
}
function $5dc446195194829d$var$getAxisModule(moduleName) {
    const definition = $5dc446195194829d$var$registeredModules.get(moduleName);
    if ($5dc446195194829d$var$isModuleType("axis" /* Axis */ , definition)) return definition;
}
function $5dc446195194829d$var$getPresetModule(moduleName) {
    const definition = $5dc446195194829d$var$registeredModules.get(moduleName);
    if ($5dc446195194829d$var$isModuleType("preset" /* Preset */ , definition)) return definition;
}
function $5dc446195194829d$var$getSeriesModule(moduleName) {
    const definition = $5dc446195194829d$var$registeredModules.get(moduleName);
    if ($5dc446195194829d$var$isModuleType("series" /* Series */ , definition)) return definition;
}
function $5dc446195194829d$var$isModuleType(moduleType, definition) {
    return definition?.type === moduleType;
}
// packages/ag-charts-core/src/classes/eventEmitter.ts
var $5dc446195194829d$export$4fae95256245c8c0 = class {
    constructor(){
        this.events = /* @__PURE__ */ new Map();
    }
    /**
   * Registers an event listener.
   * @param eventName The event name to listen for.
   * @param listener The callback to be invoked on the event.
   * @returns A function to unregister the listener.
   */ on(eventName, listener) {
        if (!this.events.has(eventName)) this.events.set(eventName, /* @__PURE__ */ new Set());
        this.events.get(eventName)?.add(listener);
        return ()=>this.off(eventName, listener);
    }
    /**
   * Unregisters an event listener.
   * @param eventName The event name to stop listening for.
   * @param listener The callback to be removed.
   */ off(eventName, listener) {
        const eventListeners = this.events.get(eventName);
        if (eventListeners) {
            eventListeners.delete(listener);
            if (eventListeners.size === 0) this.events.delete(eventName);
        }
    }
    /**
   * Emits an event to all registered listeners.
   * @param eventName The name of the event to emit.
   * @param event The event payload.
   */ emit(eventName, event) {
        this.events.get(eventName)?.forEach((callback2)=>callback2(event));
    }
    /**
   * Clears all listeners for a specific event or all events if no event name is provided.
   * @param eventName (Optional) The name of the event to clear listeners for. If not provided, all listeners for all events are cleared.
   */ clear(eventName) {
        if (eventName) this.events.delete(eventName);
        else this.events.clear();
    }
};
// packages/ag-charts-core/src/utils/dom/globalsProxy.ts
var $5dc446195194829d$var$verifiedGlobals = {};
if (typeof window !== "undefined") $5dc446195194829d$var$verifiedGlobals.window = window;
else if (typeof $parcel$global !== "undefined") $5dc446195194829d$var$verifiedGlobals.window = $parcel$global.window;
if (typeof document !== "undefined") $5dc446195194829d$var$verifiedGlobals.document = document;
else if (typeof $parcel$global !== "undefined") $5dc446195194829d$var$verifiedGlobals.document = $parcel$global.document;
function $5dc446195194829d$export$f65ca476c09acec0(propertyName) {
    return propertyName ? $5dc446195194829d$var$verifiedGlobals.document?.[propertyName] : $5dc446195194829d$var$verifiedGlobals.document;
}
function $5dc446195194829d$export$38b2d434cce3ea22(propertyName) {
    return propertyName ? $5dc446195194829d$var$verifiedGlobals.window?.[propertyName] : $5dc446195194829d$var$verifiedGlobals.window;
}
function $5dc446195194829d$export$65af85b1e66fbfaf(document2) {
    $5dc446195194829d$var$verifiedGlobals.document = document2;
}
function $5dc446195194829d$export$b4ab31529663b75b(window2) {
    $5dc446195194829d$var$verifiedGlobals.window = window2;
}
// packages/ag-charts-core/src/utils/dom/domElements.ts
function $5dc446195194829d$export$c8a8987d4410bf2d(tagName, className, style) {
    const element = $5dc446195194829d$export$f65ca476c09acec0().createElement(tagName);
    if (typeof className === "object") {
        style = className;
        className = void 0;
    }
    if (className) for (const name of className.split(" "))element.classList.add(name);
    if (style) Object.assign(element.style, style);
    return element;
}
function $5dc446195194829d$export$2a5da685d2abe499(elementName) {
    return $5dc446195194829d$export$f65ca476c09acec0().createElementNS("http://www.w3.org/2000/svg", elementName);
}
// packages/ag-charts-core/src/utils/dom/domDownload.ts
function $5dc446195194829d$export$8a96edb1c96563f4(dataUrl, fileName) {
    const body = $5dc446195194829d$export$f65ca476c09acec0("body");
    const element = $5dc446195194829d$export$c8a8987d4410bf2d("a", {
        display: "none"
    });
    element.href = dataUrl;
    element.download = fileName;
    body.appendChild(element);
    element.click();
    setTimeout(()=>body.removeChild(element));
}
// packages/ag-charts-core/src/utils/dom/domUtils.ts
function $5dc446195194829d$export$6e865ea70d7724f(color2) {
    const OptionConstructor = $5dc446195194829d$export$38b2d434cce3ea22("Option");
    const { style: style } = new OptionConstructor();
    style.color = color2;
    return style.color || null;
}
// packages/ag-charts-core/src/utils/typeGuards.ts
function $5dc446195194829d$export$4e62c701997796c1(val) {
    return val != null;
}
function $5dc446195194829d$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $5dc446195194829d$export$f9ce7b637dfbe238(value) {
    return typeof value === "boolean";
}
function $5dc446195194829d$export$871608497c498473(value) {
    return value instanceof Date;
}
function $5dc446195194829d$export$c03bb0116ee09d4b(value) {
    return $5dc446195194829d$export$871608497c498473(value) && !isNaN(Number(value));
}
function $5dc446195194829d$export$49841c62b9eff15(value) {
    return value instanceof RegExp;
}
function $5dc446195194829d$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $5dc446195194829d$export$a6cdc56e425d0d0a(value) {
    return typeof value === "object" && value !== null && !$5dc446195194829d$export$43bee75e5e14138e(value);
}
function $5dc446195194829d$export$c10d0b04eaa80a43(value) {
    return $5dc446195194829d$export$43bee75e5e14138e(value) || $5dc446195194829d$export$53b83ca8eaab0383(value);
}
function $5dc446195194829d$export$53b83ca8eaab0383(value) {
    return typeof value === "object" && value !== null && value.constructor?.name === "Object";
}
function $5dc446195194829d$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
function $5dc446195194829d$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $5dc446195194829d$export$cf6c09818bd7035a(value) {
    return Number.isFinite(value);
}
function $5dc446195194829d$export$211442cb55fb93(value) {
    return typeof window !== "undefined" && value instanceof HTMLElement;
}
function $5dc446195194829d$export$c9313f80493900be(enumObject, enumKey) {
    return $5dc446195194829d$export$844ec244b1367d54(enumKey) && Object.keys(enumObject).includes(enumKey);
}
function $5dc446195194829d$export$26692eaabd7e05b(enumObject, enumValue) {
    return Object.values(enumObject).includes(enumValue);
}
function $5dc446195194829d$export$a244864fd9645c7f(value) {
    return typeof value === "symbol";
}
function $5dc446195194829d$export$e82f763eaa28f6fe(value) {
    return $5dc446195194829d$export$844ec244b1367d54(value) && (value === "none" || $5dc446195194829d$export$6e865ea70d7724f(value) != null);
}
function $5dc446195194829d$export$593c2aea212a54d2(value, container) {
    return value in container;
}
// packages/ag-charts-core/src/utils/functions.ts
function $5dc446195194829d$export$61fc7d43ac8f84b0(callback2, waitMs = 0, options) {
    const { leading: leading = false, trailing: trailing = true, maxWait: maxWait = Infinity } = options ?? {};
    let timerId;
    let startTime;
    if (maxWait < waitMs) throw new Error("Value of maxWait cannot be lower than waitMs.");
    function debounceCallback(...args) {
        if (leading && !startTime) {
            startTime = Date.now();
            timerId = setTimeout(()=>startTime = null, waitMs);
            callback2(...args);
            return;
        }
        let adjustedWaitMs = waitMs;
        if (maxWait !== Infinity && startTime) {
            const elapsedTime = Date.now() - startTime;
            if (waitMs > maxWait - elapsedTime) adjustedWaitMs = maxWait - elapsedTime;
        }
        clearTimeout(timerId);
        startTime ?? (startTime = Date.now());
        timerId = setTimeout(()=>{
            startTime = null;
            if (trailing) callback2(...args);
        }, adjustedWaitMs);
    }
    return Object.assign(debounceCallback, {
        cancel () {
            clearTimeout(timerId);
            startTime = null;
        }
    });
}
function $5dc446195194829d$export$de363e709c412c8a(callback2, waitMs, options) {
    const { leading: leading = true, trailing: trailing = true } = options ?? {};
    let timerId;
    let lastArgs;
    let shouldWait = false;
    function timeoutHandler() {
        if (trailing && lastArgs) {
            timerId = setTimeout(timeoutHandler, waitMs);
            callback2(...lastArgs);
        } else shouldWait = false;
        lastArgs = null;
    }
    function throttleCallback(...args) {
        if (shouldWait) lastArgs = args;
        else {
            shouldWait = true;
            timerId = setTimeout(timeoutHandler, waitMs);
            if (leading) callback2(...args);
            else lastArgs = args;
        }
    }
    return Object.assign(throttleCallback, {
        cancel () {
            clearTimeout(timerId);
            shouldWait = false;
            lastArgs = null;
        }
    });
}
function $5dc446195194829d$export$175e60bb96229ece(callback2, args, errorPath = "") {
    try {
        return callback2(...args);
    } catch (error2) {
        const postfix = errorPath ? ` \`${errorPath}\`` : "";
        $5dc446195194829d$var$warnOnce(`Uncaught exception in user callback${postfix}`, error2);
    }
}
// packages/ag-charts-core/src/utils/strings.ts
function $5dc446195194829d$export$c32bc175729db37d(values, conjunction = "and", format = String, maxItems = Infinity) {
    if (values.length === 0) return "";
    else if (values.length === 1) return format(values[0]);
    values = values.map(format);
    const lastValue = values.pop();
    if (values.length >= maxItems) {
        const remainingCount = values.length - (maxItems - 1);
        return `${values.slice(0, maxItems - 1).join(", ")}, and ${remainingCount} more ${conjunction} ${lastValue}`;
    }
    return `${values.join(", ")} ${conjunction} ${lastValue}`;
}
function $5dc446195194829d$export$a110e5bc79f44a84(value, maxLength = Infinity) {
    if (typeof value === "number") {
        if (isNaN(value)) return "NaN";
        else if (value === Infinity) return "Infinity";
        else if (value === -Infinity) return "-Infinity";
    }
    const strValue = JSON.stringify(value) ?? typeof value;
    if (strValue.length > maxLength) return `${strValue.slice(0, maxLength)}... (+${strValue.length - maxLength} characters)`;
    return strValue;
}
function $5dc446195194829d$export$dcd94c44359f7fd4(text) {
    let count = 1;
    for(let i = 0; i < text.length; i++)if (text.charCodeAt(i) === 10) count++;
    return count;
}
function $5dc446195194829d$export$5363a75c154d23a4(a, b) {
    if (a === b) return 0;
    const [shorter, longer] = a.length < b.length ? [
        a,
        b
    ] : [
        b,
        a
    ];
    const m = shorter.length;
    const n = longer.length;
    let prevRow = new Array(m + 1).fill(0).map((_, i)=>i);
    let currRow = new Array(m + 1);
    for(let i = 1; i <= n; i++){
        currRow[0] = i;
        for(let j = 1; j <= m; j++){
            const cost = longer[i - 1] === shorter[j - 1] ? 0 : 1;
            currRow[j] = Math.min(prevRow[j] + 1, // Deletion
            currRow[j - 1] + 1, // Insertion
            prevRow[j - 1] + cost);
        }
        [prevRow, currRow] = [
            currRow,
            prevRow
        ];
    }
    return prevRow[m];
}
// packages/ag-charts-core/src/utils/validation.ts
var $5dc446195194829d$var$descriptionSymbol = Symbol("description");
var $5dc446195194829d$var$requiredSymbol = Symbol("required");
var $5dc446195194829d$var$markedSymbol = Symbol("marked");
var $5dc446195194829d$var$undocumentedSymbol = Symbol("undocumented");
var $5dc446195194829d$export$7fa97f9a075031f3 = Symbol("union");
var $5dc446195194829d$var$similarOptionsMap = [
    [
        "placement",
        "position"
    ],
    [
        "padding",
        "spacing",
        "gap"
    ],
    [
        "color",
        "fill",
        "stroke"
    ],
    [
        "whisker",
        "wick"
    ],
    [
        "nodeClick",
        "seriesNodeClick"
    ],
    [
        "nodeDoubleClick",
        "seriesNodeDoubleClick"
    ],
    [
        "src",
        "url"
    ]
].reduce((map, words)=>{
    for (const word of words)map.set(word.toLowerCase(), new Set(words.filter((w)=>w !== word)));
    return map;
}, /* @__PURE__ */ new Map());
var $5dc446195194829d$export$dba1278861bf0dc1 = /* @__PURE__ */ ((ErrorType2)=>{
    ErrorType2["Invalid"] = "invalid";
    ErrorType2["Required"] = "required";
    ErrorType2["Unknown"] = "unknown";
    return ErrorType2;
})($5dc446195194829d$export$dba1278861bf0dc1 || {});
function $5dc446195194829d$var$extendPath(path, key) {
    if ($5dc446195194829d$export$cf6c09818bd7035a(key)) return `${path}[${key}]`;
    return path ? `${path}.${key}` : key;
}
var $5dc446195194829d$export$2191b9da168c6cf0 = class {
    constructor(type, description, value, path, key){
        this.type = type;
        this.description = description;
        this.value = value;
        this.path = path;
        this.key = key;
    }
    setUnionType(unionType, path) {
        if (this.path.startsWith(path)) {
            const suffix = this.path.slice(path.length);
            this.altPath = `${path}[type=${unionType}]${suffix}`;
        }
    }
    getPrefix() {
        const { altPath: path = this.path, key: key } = this;
        if (!path && !key) return "Value";
        return `Option \`${key ? $5dc446195194829d$var$extendPath(path, key) : path}\``;
    }
    toString() {
        const { description: description = "unknown", type: type, value: value } = this;
        if (type === "required" /* Required */  && value == null) return `${this.getPrefix()} is required and has not been provided; expecting ${description}, ignoring.`;
        return `${this.getPrefix()} cannot be set to \`${$5dc446195194829d$export$a110e5bc79f44a84(value, 50)}\`; expecting ${description}, ignoring.`;
    }
};
var $5dc446195194829d$export$ff4405149dbd0c5c = class extends $5dc446195194829d$export$2191b9da168c6cf0 {
    constructor(suggestions, value, path, key){
        super("unknown" /* Unknown */ , void 0, value, path, key);
        this.suggestions = suggestions;
        this.key = key;
    }
    getPrefix() {
        return `Unknown option \`${$5dc446195194829d$var$extendPath(this.path, this.key)}\``;
    }
    getPostfix() {
        const suggestions = $5dc446195194829d$export$c32bc175729db37d($5dc446195194829d$var$findSuggestions(this.key, this.suggestions), "or", (val)=>`\`${val}\``);
        return suggestions ? `; Did you mean ${suggestions}? Ignoring.` : ", ignoring.";
    }
    toString() {
        return `${this.getPrefix()}${this.getPostfix()}`;
    }
};
function $5dc446195194829d$export$a22775fa5e2eebd9(options, optionsDefs2, path = "") {
    if (!$5dc446195194829d$export$a6cdc56e425d0d0a(options)) return {
        cleared: null,
        invalid: [
            new $5dc446195194829d$export$2191b9da168c6cf0("required" /* Required */ , "an object", options, path)
        ]
    };
    const cleared = {};
    const invalid = [];
    const optionsKeys = new Set(Object.keys(options));
    const unusedKeys = [];
    if ($5dc446195194829d$export$7fa97f9a075031f3 in optionsDefs2) {
        const validTypes = Object.keys(optionsDefs2);
        const defaultType = optionsDefs2[$5dc446195194829d$export$7fa97f9a075031f3];
        if (options.type != null && validTypes.includes(options.type) || options.type == null && defaultType != null) {
            const { type: type = defaultType, ...rest } = options;
            const nestedResult = $5dc446195194829d$export$a22775fa5e2eebd9(rest, optionsDefs2[type], path);
            Object.assign(cleared, {
                type: type
            }, nestedResult.cleared);
            for (const error2 of nestedResult.invalid)error2.setUnionType(type, path);
            invalid.push(...nestedResult.invalid);
        } else {
            const keywords = $5dc446195194829d$export$c32bc175729db37d(validTypes, "or", (val)=>`'${val}'`);
            invalid.push(new $5dc446195194829d$export$2191b9da168c6cf0("required" /* Required */ , `a keyword such as ${keywords}`, options.type, path, "type"));
        }
        return {
            cleared: cleared,
            invalid: invalid
        };
    }
    for (const key of Object.keys(optionsDefs2)){
        const validatorOrDefs = optionsDefs2[key];
        const required2 = validatorOrDefs[$5dc446195194829d$var$requiredSymbol];
        const value = options[key];
        optionsKeys.delete(key);
        if (typeof value === "undefined") {
            if (!validatorOrDefs[$5dc446195194829d$var$undocumentedSymbol]) unusedKeys.push(key);
            if (!required2) continue;
        }
        const keyPath = $5dc446195194829d$var$extendPath(path, key);
        if ($5dc446195194829d$export$f6e2535fb5126e54(validatorOrDefs)) {
            const context = {
                options: options,
                path: keyPath
            };
            const validatorResult = validatorOrDefs(value, context);
            const objectResult = typeof validatorResult === "object";
            if (objectResult) {
                invalid.push(...validatorResult.invalid);
                if (validatorResult.valid) {
                    cleared[key] = validatorResult.cleared;
                    continue;
                } else if ($5dc446195194829d$export$bd1887c4bfaf38c2(validatorResult.invalid, keyPath)) continue;
            } else if (validatorResult) {
                cleared[key] = value;
                continue;
            }
            invalid.push(new $5dc446195194829d$export$2191b9da168c6cf0(required2 ? "required" /* Required */  : "invalid" /* Invalid */ , validatorOrDefs[$5dc446195194829d$var$descriptionSymbol], value, path, key));
        } else {
            const nestedResult = $5dc446195194829d$export$a22775fa5e2eebd9(value, validatorOrDefs, keyPath);
            if (nestedResult.cleared != null) cleared[key] = nestedResult.cleared;
            invalid.push(...nestedResult.invalid);
        }
    }
    for (const key of optionsKeys){
        const value = options[key];
        if (typeof value === "undefined") continue;
        invalid.push(new $5dc446195194829d$export$ff4405149dbd0c5c(unusedKeys, value, path, key));
    }
    return {
        cleared: cleared,
        invalid: invalid
    };
}
function $5dc446195194829d$var$findSuggestions(value, suggestions, maxDistance = 2) {
    const result = [];
    const lowerCaseValue = value.toLowerCase();
    const similarValues = $5dc446195194829d$var$similarOptionsMap.get(lowerCaseValue);
    for (const key of suggestions){
        const lowerCaseKey = key.toLowerCase();
        if (similarValues?.has(key) || lowerCaseKey.includes(lowerCaseValue) || $5dc446195194829d$export$5363a75c154d23a4(lowerCaseValue, lowerCaseKey) <= maxDistance) result.push(key);
    }
    return result;
}
function $5dc446195194829d$export$bba6692a526d78aa(validatorOrDefs, description) {
    return Object.assign($5dc446195194829d$export$f6e2535fb5126e54(validatorOrDefs) ? (value, context)=>validatorOrDefs(value, context) : {
        ...validatorOrDefs
    }, {
        [$5dc446195194829d$var$descriptionSymbol]: description
    });
}
function $5dc446195194829d$export$a7a0278c004aac3f(validatorOrDefs) {
    return Object.assign($5dc446195194829d$export$f6e2535fb5126e54(validatorOrDefs) ? (value, context)=>validatorOrDefs(value, context) : $5dc446195194829d$export$7a6abca6f5652443(validatorOrDefs), {
        [$5dc446195194829d$var$requiredSymbol]: true,
        [$5dc446195194829d$var$descriptionSymbol]: validatorOrDefs[$5dc446195194829d$var$descriptionSymbol]
    });
}
function $5dc446195194829d$export$1b4eadfd4235d039(validatorOrDefs) {
    return Object.assign($5dc446195194829d$export$f6e2535fb5126e54(validatorOrDefs) ? (value, context)=>validatorOrDefs(value, context) : $5dc446195194829d$export$7a6abca6f5652443(validatorOrDefs), {
        [$5dc446195194829d$var$undocumentedSymbol]: true,
        [$5dc446195194829d$var$descriptionSymbol]: validatorOrDefs[$5dc446195194829d$var$descriptionSymbol]
    });
}
var $5dc446195194829d$export$7a6abca6f5652443 = (defs, description = "an object")=>$5dc446195194829d$export$bba6692a526d78aa((value, context)=>{
        const result = $5dc446195194829d$export$a22775fa5e2eebd9(value, defs, context.path);
        const valid = !$5dc446195194829d$export$bd1887c4bfaf38c2(result.invalid, context.path);
        return {
            valid: valid,
            cleared: result.cleared,
            invalid: result.invalid
        };
    }, description);
var $5dc446195194829d$export$8e0e4e6aaf611182 = (defs, description, defaultType)=>({
        ...defs,
        [$5dc446195194829d$var$descriptionSymbol]: description,
        [$5dc446195194829d$export$7fa97f9a075031f3]: defaultType
    });
var $5dc446195194829d$export$21c0ac7fe1cef1b8 = (...validators)=>$5dc446195194829d$export$bba6692a526d78aa((value, context)=>{
        const invalid = [];
        for (const validator of validators){
            const result = validator(value, context);
            if (typeof result === "object") {
                invalid.push(...result.invalid);
                if (!result.valid) return {
                    valid: false,
                    cleared: value,
                    invalid: invalid
                };
                value = result.cleared;
            } else if (!result) return false;
        }
        return {
            valid: true,
            cleared: value,
            invalid: invalid
        };
    }, validators.map((v)=>v[$5dc446195194829d$var$descriptionSymbol]).filter(Boolean).join(" and "));
var $5dc446195194829d$export$252bb8b3bbdf6749 = (...validators)=>$5dc446195194829d$export$bba6692a526d78aa((value, context)=>{
        for (const validator of validators){
            const result = validator(value, context);
            if (typeof result === "object" ? result.valid : result) return result;
        }
        return false;
    }, validators.map((v)=>v[$5dc446195194829d$var$descriptionSymbol]).filter(Boolean).join(" or "));
var $5dc446195194829d$var$isComparable = (value)=>$5dc446195194829d$export$cf6c09818bd7035a(value) || $5dc446195194829d$export$c03bb0116ee09d4b(value);
var $5dc446195194829d$var$isValidDateValue = (value)=>$5dc446195194829d$export$871608497c498473(value) || ($5dc446195194829d$export$cf6c09818bd7035a(value) || $5dc446195194829d$export$844ec244b1367d54(value)) && $5dc446195194829d$export$c03bb0116ee09d4b(new Date(value));
var $5dc446195194829d$export$2f23118c22fb2630 = $5dc446195194829d$export$bba6692a526d78aa($5dc446195194829d$export$43bee75e5e14138e, "an array");
var $5dc446195194829d$export$4a21f16c33752377 = $5dc446195194829d$export$bba6692a526d78aa($5dc446195194829d$export$f9ce7b637dfbe238, "a boolean");
var $5dc446195194829d$export$eb872837e3137261 = $5dc446195194829d$export$bba6692a526d78aa($5dc446195194829d$export$f6e2535fb5126e54, "a function");
var $5dc446195194829d$export$35e9368ef982300f = $5dc446195194829d$export$bba6692a526d78aa($5dc446195194829d$export$e82f763eaa28f6fe, "a color string");
var $5dc446195194829d$export$324d90190a8b822a = $5dc446195194829d$export$bba6692a526d78aa($5dc446195194829d$var$isValidDateValue, "a date");
var $5dc446195194829d$export$43f40ad3fa1d5c97 = $5dc446195194829d$export$bba6692a526d78aa($5dc446195194829d$export$4e62c701997796c1, "a defined value");
var $5dc446195194829d$export$98e628dec113755e = $5dc446195194829d$export$bba6692a526d78aa($5dc446195194829d$export$cf6c09818bd7035a, "a number");
var $5dc446195194829d$export$be5493f9613cbbe = $5dc446195194829d$export$bba6692a526d78aa($5dc446195194829d$export$a6cdc56e425d0d0a, "an object");
var $5dc446195194829d$export$22b082955e083ec3 = $5dc446195194829d$export$bba6692a526d78aa($5dc446195194829d$export$844ec244b1367d54, "a string");
var $5dc446195194829d$export$e7b2b12b6108c43 = $5dc446195194829d$export$bba6692a526d78aa((value)=>typeof HTMLElement === "undefined" || value instanceof HTMLElement, "an html element");
var $5dc446195194829d$export$a030413a47e709b = (minLength, maxLength = Infinity)=>{
    let message;
    if (maxLength === Infinity) message = `an array of at least ${minLength} items`;
    else if (minLength === maxLength) message = `an array of exactly ${minLength} items`;
    else if (minLength === 0) message = `an array of no more than ${maxLength} items`;
    else message = `an array of at least ${minLength} and no more than ${maxLength} items`;
    return $5dc446195194829d$export$bba6692a526d78aa((value)=>$5dc446195194829d$export$43bee75e5e14138e(value) && value.length >= minLength && value.length <= maxLength, message);
};
var $5dc446195194829d$export$9536dc0a75b20bf9 = (minLength, maxLength = Infinity)=>{
    let message;
    if (maxLength === Infinity) message = `a string of at least ${minLength} characters`;
    else if (minLength === maxLength) message = `an string of exactly ${minLength} characters`;
    else if (minLength === 0) message = `an string of no more than ${maxLength} characters`;
    else message = `an string of at least ${minLength} and no more than ${maxLength} characters`;
    return $5dc446195194829d$export$bba6692a526d78aa((value)=>$5dc446195194829d$export$844ec244b1367d54(value) && value.length >= minLength && value.length <= maxLength, message);
};
var $5dc446195194829d$export$376940cb2452fc3a = (min, inclusive = true)=>$5dc446195194829d$export$bba6692a526d78aa((value)=>$5dc446195194829d$export$cf6c09818bd7035a(value) && (value > min || inclusive && value === min), `a number greater than ${inclusive ? "or equal to " : ""}${min}`);
var $5dc446195194829d$export$ef3d98e343adfaa7 = (min, max)=>$5dc446195194829d$export$bba6692a526d78aa((value)=>$5dc446195194829d$export$cf6c09818bd7035a(value) && value >= min && value <= max, `a number between ${min} and ${max} inclusive`);
var $5dc446195194829d$export$4ea4739d3fef092b = $5dc446195194829d$export$376940cb2452fc3a(0);
var $5dc446195194829d$export$7a3de1ac8ff87618 = $5dc446195194829d$export$376940cb2452fc3a(0, false);
var $5dc446195194829d$export$85f17f73487c6e7d = $5dc446195194829d$export$ef3d98e343adfaa7(0, 1);
var $5dc446195194829d$export$9b050841a3a1b328 = (otherField)=>$5dc446195194829d$export$bba6692a526d78aa((value, { options: options })=>!$5dc446195194829d$var$isComparable(value) || !$5dc446195194829d$var$isComparable(options[otherField]) || value < options[otherField], `the value to be less than \`${otherField}\``);
var $5dc446195194829d$export$f517ea36c68d4644 = (otherField)=>$5dc446195194829d$export$bba6692a526d78aa((value, { options: options })=>!$5dc446195194829d$var$isComparable(value) || !$5dc446195194829d$var$isComparable(options[otherField]) || value > options[otherField], `the value to be greater than \`${otherField}\``);
function $5dc446195194829d$export$971dd5b0dfd021b6(...allowed) {
    if ($5dc446195194829d$export$a6cdc56e425d0d0a(allowed[0])) allowed = Object.values(allowed[0]);
    const keywords = $5dc446195194829d$export$c32bc175729db37d(allowed, "or", (value)=>`'${value}'`);
    return $5dc446195194829d$export$bba6692a526d78aa((value)=>allowed.includes(value), `a keyword such as ${keywords}`);
}
var $5dc446195194829d$export$c983f826f44ff86 = (allowed)=>$5dc446195194829d$export$bba6692a526d78aa((value)=>allowed === value, `the value ${JSON.stringify(allowed)}`);
var $5dc446195194829d$export$ca03416d6c9e029e = (instanceType, description)=>$5dc446195194829d$export$bba6692a526d78aa((value)=>value instanceof instanceType, description ?? `an instance of ${instanceType.name}`);
var $5dc446195194829d$export$e57ff0f701c44363 = (validator, description, strict = true)=>$5dc446195194829d$export$bba6692a526d78aa((value, context)=>{
        if (!$5dc446195194829d$export$43bee75e5e14138e(value)) return false;
        let valid = strict;
        const cleared = [];
        const invalid = [];
        const setValid = (result)=>valid = strict ? valid && result : valid || result;
        if (value.length === 0) return {
            valid: true,
            cleared: cleared,
            invalid: invalid
        };
        for(let i = 0; i < value.length; i++){
            const options = value[i];
            const result = validator(options, {
                options: options,
                path: `${context.path}[${i}]`
            });
            if (typeof result === "object") {
                valid = setValid(result.valid);
                invalid.push(...result.invalid);
                if (result.cleared != null) cleared.push(result.cleared);
            } else {
                valid = setValid(result);
                if (result) cleared.push(options);
            }
        }
        return {
            valid: valid,
            cleared: valid || !strict ? cleared : null,
            invalid: invalid
        };
    }, description ?? `${validator[$5dc446195194829d$var$descriptionSymbol]} array`);
var $5dc446195194829d$export$fe1127d1c893468a = (defs, description = "an object array")=>$5dc446195194829d$export$bba6692a526d78aa((value, context)=>{
        if (!$5dc446195194829d$export$43bee75e5e14138e(value)) return false;
        const cleared = [];
        const invalid = [];
        for(let i = 0; i < value.length; i++){
            const indexPath = `${context.path}[${i}]`;
            const result = $5dc446195194829d$export$a22775fa5e2eebd9(value[i], defs, indexPath);
            if (!$5dc446195194829d$export$bd1887c4bfaf38c2(result.invalid, indexPath)) cleared.push(result.cleared);
            invalid.push(...result.invalid);
        }
        return {
            valid: true,
            cleared: cleared,
            invalid: invalid
        };
    }, description);
var $5dc446195194829d$export$5ddbb04d06945c52 = (validator, description)=>$5dc446195194829d$export$bba6692a526d78aa((value, context)=>{
        if (!$5dc446195194829d$export$f6e2535fb5126e54(value)) return false;
        if ($5dc446195194829d$var$markedSymbol in value) return true;
        const cbWithValidation = Object.assign((...args)=>{
            const result = $5dc446195194829d$export$175e60bb96229ece(value, args);
            if (result == null) return;
            const validatorResult = validator(result, {
                options: result,
                path: ""
            });
            if (typeof validatorResult === "object") {
                validatorResult.invalid.forEach($5dc446195194829d$var$callbackWarnInvalid(context, description ?? validator[$5dc446195194829d$var$descriptionSymbol]));
                if (validatorResult.valid) return validatorResult.cleared;
            } else if (validatorResult) return result;
            else $5dc446195194829d$var$warnOnce(`Callback \`${context.path}\` returned an invalid value \`${$5dc446195194829d$export$a110e5bc79f44a84(result, 50)}\`; expecting ${description ?? validator[$5dc446195194829d$var$descriptionSymbol]}, ignoring.`);
        }, {
            [$5dc446195194829d$var$markedSymbol]: true
        });
        return {
            valid: true,
            cleared: cbWithValidation,
            invalid: []
        };
    }, "a function");
var $5dc446195194829d$export$6ff6dc42cac175be = (defs, description = "an object")=>$5dc446195194829d$export$bba6692a526d78aa((value, context)=>{
        if (!$5dc446195194829d$export$f6e2535fb5126e54(value)) return false;
        if ($5dc446195194829d$var$markedSymbol in value) return true;
        const cbWithValidation = Object.assign((...args)=>{
            const result = $5dc446195194829d$export$175e60bb96229ece(value, args, context.path);
            if (result == null) return;
            const validatorResult = $5dc446195194829d$export$a22775fa5e2eebd9(result, defs);
            validatorResult.invalid.forEach($5dc446195194829d$var$callbackWarnInvalid(context, description));
            return validatorResult.cleared;
        }, {
            [$5dc446195194829d$var$markedSymbol]: true
        });
        return {
            valid: true,
            cleared: cbWithValidation,
            invalid: []
        };
    }, "a function");
function $5dc446195194829d$export$bd1887c4bfaf38c2(errors, rootPath) {
    return errors.some((error2)=>error2.type === "required" /* Required */  && error2.path === rootPath);
}
function $5dc446195194829d$var$callbackWarnInvalid(context, description) {
    return (error2)=>{
        if (error2 instanceof $5dc446195194829d$export$ff4405149dbd0c5c) return $5dc446195194829d$var$warnOnce(`Callback \`${context.path}\` returned an unknown property \`${$5dc446195194829d$var$extendPath(error2.path, error2.key)}\`${error2.getPostfix()}`);
        const errorValue = $5dc446195194829d$export$a110e5bc79f44a84(error2.value, 50);
        $5dc446195194829d$var$warnOnce(error2.key ? `Callback \`${context.path}\` returned an invalid property \`${$5dc446195194829d$var$extendPath(error2.path, error2.key)}\`: \`${errorValue}\`; expecting ${error2.description}, ignoring.` : `Callback \`${context.path}\` returned an invalid value \`${errorValue}\`; expecting ${description ?? error2.description}, ignoring.`);
    };
}
// packages/ag-charts-core/src/options/commonOptionsDefs.ts
var $5dc446195194829d$export$5733cbdd20762933 = (value)=>{
    if (!$5dc446195194829d$export$a6cdc56e425d0d0a(value)) return false;
    const keys = Object.keys(value);
    return keys.length === 1 && keys[0].startsWith("$");
};
var $5dc446195194829d$var$colorStop = $5dc446195194829d$export$7a6abca6f5652443({
    color: $5dc446195194829d$export$35e9368ef982300f,
    stop: $5dc446195194829d$export$85f17f73487c6e7d
}, "");
var $5dc446195194829d$export$2e447a4ee32725b5 = $5dc446195194829d$export$bba6692a526d78aa((value)=>{
    let lastStop = -Infinity;
    for (const item of value)if (item?.stop != null) {
        if (item.stop < lastStop) return false;
        lastStop = item.stop;
    }
    return true;
}, "color stops to be defined in ascending order");
var $5dc446195194829d$export$b2d2b9818f3d6f68 = $5dc446195194829d$export$21c0ac7fe1cef1b8($5dc446195194829d$export$a030413a47e709b(2), $5dc446195194829d$export$e57ff0f701c44363($5dc446195194829d$var$colorStop), $5dc446195194829d$export$2e447a4ee32725b5);
var $5dc446195194829d$var$gradientBounds = $5dc446195194829d$export$971dd5b0dfd021b6("axis", "item", "series");
var $5dc446195194829d$export$cbcc33c03ee9d202 = $5dc446195194829d$export$7a6abca6f5652443({
    type: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$c983f826f44ff86("gradient")),
    colorStops: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$b2d2b9818f3d6f68),
    rotation: $5dc446195194829d$export$98e628dec113755e,
    // @ts-expect-error undocumented options
    gradient: $5dc446195194829d$export$1b4eadfd4235d039($5dc446195194829d$export$971dd5b0dfd021b6("linear", "radial", "conic")),
    bounds: $5dc446195194829d$export$1b4eadfd4235d039($5dc446195194829d$var$gradientBounds),
    reverse: $5dc446195194829d$export$1b4eadfd4235d039($5dc446195194829d$export$4a21f16c33752377)
}, "a gradient object with color stops");
var $5dc446195194829d$export$e29d86c1f14e7d1b = {
    stroke: $5dc446195194829d$export$35e9368ef982300f,
    strokeWidth: $5dc446195194829d$export$4ea4739d3fef092b,
    strokeOpacity: $5dc446195194829d$export$85f17f73487c6e7d
};
var $5dc446195194829d$export$e4300b1ae67dd683 = $5dc446195194829d$export$7a6abca6f5652443({
    type: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$c983f826f44ff86("gradient")),
    gradient: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$971dd5b0dfd021b6("linear", "radial", "conic")),
    bounds: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$var$gradientBounds),
    colorStops: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$252bb8b3bbdf6749($5dc446195194829d$export$b2d2b9818f3d6f68, $5dc446195194829d$export$21c0ac7fe1cef1b8($5dc446195194829d$export$a030413a47e709b(2), $5dc446195194829d$export$e57ff0f701c44363($5dc446195194829d$export$35e9368ef982300f)))),
    rotation: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$98e628dec113755e),
    reverse: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$4a21f16c33752377)
});
var $5dc446195194829d$export$9f82189363b38286 = $5dc446195194829d$export$7a6abca6f5652443({
    type: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$c983f826f44ff86("pattern")),
    pattern: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$971dd5b0dfd021b6("vertical-lines", "horizontal-lines", "forward-slanted-lines", "backward-slanted-lines", "circles", "squares", "triangles", "diamonds", "stars", "hearts", "crosses")),
    path: $5dc446195194829d$export$9536dc0a75b20bf9(2),
    width: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$4ea4739d3fef092b),
    height: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$4ea4739d3fef092b),
    fill: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$35e9368ef982300f),
    fillOpacity: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$85f17f73487c6e7d),
    backgroundFill: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$35e9368ef982300f),
    backgroundFillOpacity: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$85f17f73487c6e7d),
    padding: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$4ea4739d3fef092b),
    rotation: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$98e628dec113755e),
    scale: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$4ea4739d3fef092b),
    stroke: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$35e9368ef982300f),
    strokeWidth: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$4ea4739d3fef092b),
    strokeOpacity: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$85f17f73487c6e7d)
});
var $5dc446195194829d$export$34c5126f6b977ec7 = $5dc446195194829d$export$7a6abca6f5652443({
    type: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$c983f826f44ff86("image")),
    url: $5dc446195194829d$export$22b082955e083ec3,
    width: $5dc446195194829d$export$4ea4739d3fef092b,
    height: $5dc446195194829d$export$4ea4739d3fef092b,
    rotation: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$98e628dec113755e),
    backgroundFill: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$35e9368ef982300f),
    backgroundFillOpacity: $5dc446195194829d$export$85f17f73487c6e7d,
    fit: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$971dd5b0dfd021b6("stretch", "contain", "cover")),
    repeat: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$971dd5b0dfd021b6("repeat", "repeat-x", "repeat-y", "no-repeat"))
});
var $5dc446195194829d$var$colorObject = $5dc446195194829d$export$8e0e4e6aaf611182({
    gradient: {
        colorStops: $5dc446195194829d$export$b2d2b9818f3d6f68,
        rotation: $5dc446195194829d$export$98e628dec113755e,
        // @ts-expect-error undocumented option
        gradient: $5dc446195194829d$export$1b4eadfd4235d039($5dc446195194829d$export$971dd5b0dfd021b6("linear", "radial", "conic")),
        bounds: $5dc446195194829d$export$1b4eadfd4235d039($5dc446195194829d$var$gradientBounds),
        reverse: $5dc446195194829d$export$1b4eadfd4235d039($5dc446195194829d$export$4a21f16c33752377)
    },
    pattern: {
        pattern: $5dc446195194829d$export$971dd5b0dfd021b6("vertical-lines", "horizontal-lines", "forward-slanted-lines", "backward-slanted-lines", "circles", "squares", "triangles", "diamonds", "stars", "hearts", "crosses"),
        path: $5dc446195194829d$export$9536dc0a75b20bf9(2),
        width: $5dc446195194829d$export$4ea4739d3fef092b,
        height: $5dc446195194829d$export$4ea4739d3fef092b,
        rotation: $5dc446195194829d$export$98e628dec113755e,
        scale: $5dc446195194829d$export$4ea4739d3fef092b,
        fill: $5dc446195194829d$export$35e9368ef982300f,
        fillOpacity: $5dc446195194829d$export$85f17f73487c6e7d,
        backgroundFill: $5dc446195194829d$export$35e9368ef982300f,
        backgroundFillOpacity: $5dc446195194829d$export$85f17f73487c6e7d,
        ...$5dc446195194829d$export$e29d86c1f14e7d1b,
        // @ts-expect-error undocumented option
        padding: $5dc446195194829d$export$1b4eadfd4235d039($5dc446195194829d$export$4ea4739d3fef092b)
    },
    image: {
        url: $5dc446195194829d$export$a7a0278c004aac3f($5dc446195194829d$export$22b082955e083ec3),
        backgroundFill: $5dc446195194829d$export$35e9368ef982300f,
        backgroundFillOpacity: $5dc446195194829d$export$85f17f73487c6e7d,
        width: $5dc446195194829d$export$4ea4739d3fef092b,
        height: $5dc446195194829d$export$4ea4739d3fef092b,
        fit: $5dc446195194829d$export$971dd5b0dfd021b6("stretch", "contain", "cover", "none"),
        repeat: $5dc446195194829d$export$971dd5b0dfd021b6("repeat", "repeat-x", "repeat-y", "no-repeat"),
        rotation: $5dc446195194829d$export$98e628dec113755e
    }
}, "a color object");
var $5dc446195194829d$export$14c5fb1a7b3fdd3e = $5dc446195194829d$export$252bb8b3bbdf6749($5dc446195194829d$export$35e9368ef982300f, $5dc446195194829d$export$7a6abca6f5652443($5dc446195194829d$var$colorObject, "a color object"));
var $5dc446195194829d$export$e5ca88d5ef7e3172 = {
    fill: $5dc446195194829d$export$14c5fb1a7b3fdd3e,
    fillOpacity: $5dc446195194829d$export$85f17f73487c6e7d
};
$5dc446195194829d$export$e5ca88d5ef7e3172.fillGradientDefaults = $5dc446195194829d$export$1b4eadfd4235d039($5dc446195194829d$export$e4300b1ae67dd683);
$5dc446195194829d$export$e5ca88d5ef7e3172.fillPatternDefaults = $5dc446195194829d$export$1b4eadfd4235d039($5dc446195194829d$export$9f82189363b38286);
$5dc446195194829d$export$e5ca88d5ef7e3172.fillImageDefaults = $5dc446195194829d$export$1b4eadfd4235d039($5dc446195194829d$export$34c5126f6b977ec7);
var $5dc446195194829d$export$59de7b59331cdd19 = {
    lineDash: $5dc446195194829d$export$e57ff0f701c44363($5dc446195194829d$export$4ea4739d3fef092b),
    lineDashOffset: $5dc446195194829d$export$98e628dec113755e
};
var $5dc446195194829d$export$641c4a34b864fb27 = $5dc446195194829d$export$7a6abca6f5652443({
    googleFont: $5dc446195194829d$export$22b082955e083ec3
}, "google font");
var $5dc446195194829d$export$4f72aa8b2be7d87c = $5dc446195194829d$export$252bb8b3bbdf6749($5dc446195194829d$export$22b082955e083ec3, $5dc446195194829d$export$5733cbdd20762933, $5dc446195194829d$export$641c4a34b864fb27, $5dc446195194829d$export$e57ff0f701c44363($5dc446195194829d$export$252bb8b3bbdf6749($5dc446195194829d$export$22b082955e083ec3, $5dc446195194829d$export$641c4a34b864fb27)));
var $5dc446195194829d$export$94bedaee6d52b277 = {
    color: $5dc446195194829d$export$35e9368ef982300f,
    fontFamily: $5dc446195194829d$export$4f72aa8b2be7d87c,
    fontSize: $5dc446195194829d$export$4ea4739d3fef092b,
    fontStyle: $5dc446195194829d$export$971dd5b0dfd021b6("normal", "italic", "oblique"),
    fontWeight: $5dc446195194829d$export$252bb8b3bbdf6749($5dc446195194829d$export$4ea4739d3fef092b, $5dc446195194829d$export$971dd5b0dfd021b6("normal", "bold", "bolder", "lighter"))
};
// packages/ag-charts-core/src/utils/arrays.ts
function $5dc446195194829d$export$45b10814cc054894(value) {
    if (typeof value === "undefined") return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $5dc446195194829d$export$7a5d5c156e7dc406(array2) {
    return Array.from(new Set(array2));
}
function $5dc446195194829d$export$3f063810d7bf01bd(array2, iteratee) {
    return array2.reduce((result, item)=>{
        const groupKey = iteratee(item);
        result[groupKey] ?? (result[groupKey] = []);
        result[groupKey].push(item);
        return result;
    }, {});
}
function $5dc446195194829d$export$234180f8206db11b(a, b) {
    if (a == null || b == null || a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (Array.isArray(a[i]) && Array.isArray(b[i])) {
            if (!$5dc446195194829d$export$234180f8206db11b(a[i], b[i])) return false;
        } else if (a[i] !== b[i]) return false;
    }
    return true;
}
function $5dc446195194829d$export$4f04e632baba1950(data, size, offset = 0) {
    if (data.length === 0) return [];
    const result = [];
    for(let i = 0; i < size; i++)result.push(data.at((i + offset) % data.length));
    return result;
}
function $5dc446195194829d$export$2f90d41869a06080(baseArray, orderArray) {
    const orderMap = /* @__PURE__ */ new Map();
    orderArray.forEach((item, index)=>{
        orderMap.set(item, index);
    });
    return baseArray.sort((a, b)=>{
        const indexA = orderMap.get(a) ?? Infinity;
        const indexB = orderMap.get(b) ?? Infinity;
        return indexA - indexB;
    });
}
function $5dc446195194829d$export$53419c3d64755fbd(array2, cond) {
    let i = 0;
    while(i < array2.length && cond(array2[i]))i += 1;
    const deleteCount = i;
    if (deleteCount !== 0) array2.splice(0, deleteCount);
}
function $5dc446195194829d$export$39c8e39349afec19(array2, cond) {
    let i = array2.length - 1;
    while(i >= 0 && cond(array2[i]))i -= 1;
    const deleteCount = array2.length - 1 - i;
    if (deleteCount !== 0) array2.splice(array2.length - deleteCount, deleteCount);
}
// packages/ag-charts-core/src/utils/async.ts
var $5dc446195194829d$export$44b16b51f8782693 = class {
    constructor(){
        this.queue = [];
    }
    /** Await another async process to call notify(). */ await(timeout = 50) {
        return new Promise((resolve)=>{
            const successFn = ()=>{
                clearTimeout(timeoutHandle);
                resolve(true);
            };
            const timeoutFn = ()=>{
                const queueIndex = this.queue.indexOf(successFn);
                if (queueIndex < 0) return;
                this.queue.splice(queueIndex, 1);
                resolve(false);
            };
            const timeoutHandle = setTimeout(timeoutFn, timeout);
            this.queue.push(successFn);
        });
    }
    /** Trigger any await()ing async processes to continue. */ notify() {
        this.queue.splice(0).forEach((cb)=>cb());
    }
};
function $5dc446195194829d$export$229c72e5fdee233b(delayMilliseconds = 0) {
    return new Promise((resolve)=>{
        setTimeout(resolve, delayMilliseconds);
    });
}
// packages/ag-charts-core/src/utils/iterators.ts
function* $5dc446195194829d$export$c1a059043cc9c119(...iterators) {
    for (const iterator of iterators)yield* iterator;
}
function $5dc446195194829d$export$22419d807aae1935(value) {
    return value != null && typeof value === "object" && Symbol.iterator in value ? value : [
        value
    ];
}
function $5dc446195194829d$export$43128fadae87b74a(iterable) {
    for (const value of iterable)return value;
    throw new Error("AG Charts - no first() value found");
}
function* $5dc446195194829d$export$3e9f948b41964866(obj) {
    const resultTuple = [
        void 0,
        void 0
    ];
    for (const key of Object.keys(obj)){
        resultTuple[0] = key;
        resultTuple[1] = obj[key];
        yield resultTuple;
    }
}
// packages/ag-charts-core/src/utils/attributeUtil.ts
function $5dc446195194829d$var$booleanParser(value) {
    return value === "true";
}
function $5dc446195194829d$var$numberParser(value) {
    return Number(value);
}
function $5dc446195194829d$var$stringParser(value) {
    return value;
}
var $5dc446195194829d$var$AttributeTypeParsers = {
    role: $5dc446195194829d$var$stringParser,
    "aria-checked": $5dc446195194829d$var$booleanParser,
    "aria-controls": $5dc446195194829d$var$stringParser,
    "aria-describedby": $5dc446195194829d$var$stringParser,
    "aria-disabled": $5dc446195194829d$var$booleanParser,
    "aria-expanded": $5dc446195194829d$var$booleanParser,
    "aria-haspopup": $5dc446195194829d$var$stringParser,
    "aria-hidden": $5dc446195194829d$var$booleanParser,
    "aria-label": $5dc446195194829d$var$stringParser,
    "aria-labelledby": $5dc446195194829d$var$stringParser,
    "aria-live": $5dc446195194829d$var$stringParser,
    "aria-orientation": $5dc446195194829d$var$stringParser,
    "aria-selected": $5dc446195194829d$var$booleanParser,
    "data-focus-override": $5dc446195194829d$var$booleanParser,
    "data-focus-visible-override": $5dc446195194829d$var$booleanParser,
    "data-preventdefault": $5dc446195194829d$var$booleanParser,
    class: $5dc446195194829d$var$stringParser,
    for: $5dc446195194829d$var$stringParser,
    id: $5dc446195194829d$var$stringParser,
    tabindex: $5dc446195194829d$var$numberParser,
    title: $5dc446195194829d$var$stringParser,
    placeholder: $5dc446195194829d$var$stringParser
};
function $5dc446195194829d$export$9fec4d97f1922e0b(e, qualifiedName, value) {
    if (value == null || value === "" || value === "") e?.removeAttribute(qualifiedName);
    else e?.setAttribute(qualifiedName, value.toString());
}
function $5dc446195194829d$export$74da2cba014bdc09(e, attrs) {
    if (attrs == null) return;
    for (const [key, value] of $5dc446195194829d$export$3e9f948b41964866(attrs)){
        if (key === "class") continue;
        $5dc446195194829d$export$9fec4d97f1922e0b(e, key, value);
    }
}
function $5dc446195194829d$export$735ee1799fd02602(e, qualifiedName, defaultValue) {
    if (!(e instanceof HTMLElement)) return void 0;
    const value = e.getAttribute(qualifiedName);
    if (value === null) return defaultValue;
    return $5dc446195194829d$var$AttributeTypeParsers[qualifiedName]?.(value) ?? void 0;
}
function $5dc446195194829d$export$7dee023fd9f40ee(e, property, value) {
    if (e == null) return;
    if (value == null) e.style.removeProperty(property);
    else e.style.setProperty(property, value.toString());
}
function $5dc446195194829d$export$d16b2ab591686b(e, styles) {
    for (const [key, value] of $5dc446195194829d$export$3e9f948b41964866(styles))$5dc446195194829d$export$7dee023fd9f40ee(e, key, value);
}
// packages/ag-charts-core/src/utils/binarySearch.ts
function $5dc446195194829d$export$d14a0c5b1661914b(min, max, iteratee) {
    if (min > max) return;
    let found;
    while(max >= min){
        const index = Math.floor((max + min) / 2);
        const value = iteratee(index);
        if (value) {
            found = index;
            min = index + 1;
        } else max = index - 1;
    }
    return found;
}
function $5dc446195194829d$export$e6f0aa365af82aff(min, max, iteratee) {
    if (min > max) return;
    let found;
    while(max >= min){
        const index = Math.floor((max + min) / 2);
        const value = iteratee(index);
        if (value) {
            found = index;
            max = index - 1;
        } else min = index + 1;
    }
    return found;
}
function $5dc446195194829d$export$1bedcaacb659a19e(min, max, iteratee) {
    if (min > max) return;
    let found;
    while(max >= min){
        const index = Math.floor((max + min) / 2);
        const value = iteratee(index);
        if (value == null) max = index - 1;
        else {
            found = value;
            min = index + 1;
        }
    }
    return found;
}
function $5dc446195194829d$export$e242cfa98ca8bb4e(min, max, iteratee) {
    if (min > max) return;
    let found;
    while(max >= min){
        const index = Math.floor((max + min) / 2);
        const value = iteratee(index);
        if (value == null) min = index + 1;
        else {
            found = value;
            max = index - 1;
        }
    }
    return found;
}
// packages/ag-charts-core/src/utils/diff.ts
function $5dc446195194829d$export$f1c08b3bfc8443c4(previous, current) {
    const size = Math.max(previous.length, current.length);
    const added = /* @__PURE__ */ new Set();
    const removed = /* @__PURE__ */ new Set();
    for(let i = 0; i < size; i++){
        const prev = previous[i];
        const curr = current[i];
        if (prev === curr) continue;
        if (removed.has(curr)) removed.delete(curr);
        else if (curr) added.add(curr);
        if (added.has(prev)) added.delete(prev);
        else if (prev) removed.add(prev);
    }
    return {
        changed: added.size > 0 || removed.size > 0,
        added: added,
        removed: removed
    };
}
// packages/ag-charts-core/src/utils/numbers.ts
function $5dc446195194829d$export$7d15b64cf5a3a4c4(min, value, max) {
    return Math.min(max, Math.max(min, value));
}
function $5dc446195194829d$export$ddf89a9c5af38f94(value, range, epsilon = 1e-10) {
    return value >= range[0] - epsilon && value <= range[1] + epsilon;
}
function $5dc446195194829d$export$ffb638ef34bfe97b(a, b, epsilon = 1e-10) {
    return a === b || Math.abs(a - b) < epsilon;
}
function $5dc446195194829d$export$d0909a4f38b5c4d0(value) {
    return Math.sign(value) === -1 || Object.is(value, -0);
}
function $5dc446195194829d$export$a287f47fed4544b8(value) {
    return value % 1 === 0;
}
function $5dc446195194829d$export$7978a6ddf29f4374(value, decimals = 2) {
    const base = 10 ** decimals;
    return Math.round(value * base) / base;
}
function $5dc446195194829d$export$2effa4df065fbace(n, m) {
    return Math.floor(n % m + (n < 0 ? Math.abs(m) : 0));
}
function $5dc446195194829d$export$88877a4c336dc8d8(value) {
    if (Math.floor(value) === value) return 0;
    let valueString = String(value);
    let exponent = 0;
    if (value < 1e-6 || value >= 1e21) {
        let exponentString;
        [valueString, exponentString] = valueString.split("e");
        if (exponentString != null) exponent = Number(exponentString);
    }
    const decimalPlaces = valueString.split(".")[1]?.length ?? 0;
    return Math.max(decimalPlaces - exponent, 0);
}
// packages/ag-charts-core/src/utils/geoJson.ts
function $5dc446195194829d$var$isValidCoordinate(value) {
    return Array.isArray(value) && value.length >= 2 && value.every($5dc446195194829d$export$cf6c09818bd7035a);
}
function $5dc446195194829d$var$isValidCoordinates(value) {
    return Array.isArray(value) && value.length >= 2 && value.every($5dc446195194829d$var$isValidCoordinate);
}
function $5dc446195194829d$var$hasSameStartEndPoint(c) {
    const start = c[0];
    const end = c[c.length - 1];
    return $5dc446195194829d$export$ffb638ef34bfe97b(start[0], end[0], 1e-3) && $5dc446195194829d$export$ffb638ef34bfe97b(start[1], end[1], 1e-3);
}
function $5dc446195194829d$var$isValidPolygon(value) {
    return Array.isArray(value) && value.every($5dc446195194829d$var$isValidCoordinates) && value.every($5dc446195194829d$var$hasSameStartEndPoint);
}
function $5dc446195194829d$var$isValidGeometry(value) {
    if (value === null) return true;
    if (!$5dc446195194829d$export$a6cdc56e425d0d0a(value) || value.type == null) return false;
    const { type: type, coordinates: coordinates } = value;
    switch(type){
        case "GeometryCollection":
            return Array.isArray(value.geometries) && value.geometries.every($5dc446195194829d$var$isValidGeometry);
        case "MultiPolygon":
            return Array.isArray(coordinates) && coordinates.every($5dc446195194829d$var$isValidPolygon);
        case "Polygon":
            return $5dc446195194829d$var$isValidPolygon(coordinates);
        case "MultiLineString":
            return Array.isArray(coordinates) && coordinates.every($5dc446195194829d$var$isValidCoordinates);
        case "LineString":
            return $5dc446195194829d$var$isValidCoordinates(coordinates);
        case "MultiPoint":
            return $5dc446195194829d$var$isValidCoordinates(coordinates);
        case "Point":
            return $5dc446195194829d$var$isValidCoordinate(coordinates);
        default:
            return false;
    }
}
function $5dc446195194829d$var$isValidFeature(value) {
    return $5dc446195194829d$export$a6cdc56e425d0d0a(value) && value.type === "Feature" && $5dc446195194829d$var$isValidGeometry(value.geometry);
}
function $5dc446195194829d$var$isValidFeatureCollection(value) {
    return $5dc446195194829d$export$a6cdc56e425d0d0a(value) && value.type === "FeatureCollection" && Array.isArray(value.features) && value.features.every($5dc446195194829d$var$isValidFeature);
}
var $5dc446195194829d$export$1c99306f6e0eb8a = $5dc446195194829d$export$bba6692a526d78aa($5dc446195194829d$var$isValidFeatureCollection, "a GeoJSON object");
// packages/ag-charts-core/src/utils/id.ts
var $5dc446195194829d$var$ID_MAP = /* @__PURE__ */ new Map();
var $5dc446195194829d$var$elementIDBrand = Symbol("ElementID");
var $5dc446195194829d$var$nextElementID = 1;
function $5dc446195194829d$export$4cc3052e36a312db() {
    $5dc446195194829d$var$ID_MAP.clear();
    $5dc446195194829d$var$nextElementID = 1;
}
function $5dc446195194829d$export$7149c6ffc9994c32(instance) {
    const constructor = instance.constructor;
    const className = Object.hasOwn(constructor, "className") ? constructor.className : constructor.name;
    if (!className) throw new Error(`The ${constructor} is missing the 'className' property.`);
    const nextId = ($5dc446195194829d$var$ID_MAP.get(className) ?? 0) + 1;
    $5dc446195194829d$var$ID_MAP.set(className, nextId);
    return `${className}-${nextId}`;
}
function $5dc446195194829d$export$e4789b5c419678e0() {
    return `ag-charts-${$5dc446195194829d$var$nextElementID++}`;
}
function $5dc446195194829d$export$e73c8bd0f20705a() {
    return crypto.randomUUID?.() ?? $5dc446195194829d$var$generateUUIDv4();
}
function $5dc446195194829d$var$generateUUIDv4() {
    const uuidArray = new Uint8Array(16);
    crypto.getRandomValues(uuidArray);
    uuidArray[6] = uuidArray[6] & 15 | 64;
    uuidArray[8] = uuidArray[8] & 63 | 128;
    let uuid = "";
    for(let i = 0; i < uuidArray.length; i++){
        if (i === 4 || i === 6 || i === 8 || i === 10) uuid += "-";
        uuid += uuidArray[i].toString(16).padStart(2, "0");
    }
    return uuid;
}
// packages/ag-charts-core/src/utils/numberFormat.ts
var $5dc446195194829d$var$formatRegEx = /^(?:(.)?([<>=^]))?([+\-( ])?([$€£¥₣₹#])?(0)?(\d+)?(,)?(?:\.(\d+))?(~)?([%a-z])?$/i;
var $5dc446195194829d$var$surroundedRegEx = /^((?:[^#]|#[^{])*)#{([^}]+)}(.*)$/;
function $5dc446195194829d$export$ee85cba4a41bdffc(value) {
    if (!$5dc446195194829d$export$844ec244b1367d54(value)) return false;
    const match = $5dc446195194829d$var$surroundedRegEx.exec(value);
    return $5dc446195194829d$var$formatRegEx.test(match ? match[2] : value);
}
function $5dc446195194829d$export$b4abf8bcc8b47ded(format) {
    let prefix;
    let suffix;
    const surrounded = $5dc446195194829d$var$surroundedRegEx.exec(format);
    if (surrounded) [, prefix, format, suffix] = surrounded;
    const match = $5dc446195194829d$var$formatRegEx.exec(format);
    if (!match) throw new Error(`The number formatter is invalid: ${format}`);
    const [, fill, align, sign, symbol, zero, width, comma, precision, trim, type] = match;
    return {
        fill: fill,
        align: align,
        sign: sign,
        symbol: symbol,
        zero: zero,
        width: parseInt(width),
        comma: comma,
        precision: parseInt(precision),
        trim: Boolean(trim),
        type: type,
        prefix: prefix,
        suffix: suffix
    };
}
function $5dc446195194829d$export$f056b1f978c629b5(format) {
    const options = typeof format === "string" ? $5dc446195194829d$export$b4abf8bcc8b47ded(format) : format;
    const { fill: fill, align: align, sign: sign = "-", symbol: symbol, zero: zero, width: width, comma: comma, type: type, prefix: prefix = "", suffix: suffix = "", precision: precision } = options;
    let { trim: trim } = options;
    const precisionIsNaN = precision == null || isNaN(precision);
    let formatBody;
    if (!type) {
        formatBody = $5dc446195194829d$var$decimalTypes["g"];
        trim = true;
    } else if (type in $5dc446195194829d$var$decimalTypes && type in $5dc446195194829d$var$integerTypes) formatBody = precisionIsNaN ? $5dc446195194829d$var$integerTypes[type] : $5dc446195194829d$var$decimalTypes[type];
    else if (type in $5dc446195194829d$var$decimalTypes) formatBody = $5dc446195194829d$var$decimalTypes[type];
    else if (type in $5dc446195194829d$var$integerTypes) formatBody = $5dc446195194829d$var$integerTypes[type];
    else throw new Error(`The number formatter type is invalid: ${type}`);
    let formatterPrecision;
    if (precisionIsNaN) formatterPrecision = type ? 6 : 12;
    else formatterPrecision = precision;
    return (n)=>{
        let result = formatBody(n, formatterPrecision);
        if (trim) result = $5dc446195194829d$var$removeTrailingZeros(result);
        if (comma) result = $5dc446195194829d$var$insertSeparator(result, comma);
        result = $5dc446195194829d$var$addSign(n, result, sign);
        if (symbol && symbol !== "#") result = `${symbol}${result}`;
        if (symbol === "#" && type === "x") result = `0x${result}`;
        if (type === "s") result = `${result}${$5dc446195194829d$var$getSIPrefix(n)}`;
        if (type === "%" || type === "p") result = `${result}%`;
        if (width != null && !isNaN(width)) result = $5dc446195194829d$var$addPadding(result, width, fill ?? zero, align);
        result = `${prefix}${result}${suffix}`;
        return result;
    };
}
var $5dc446195194829d$var$integerTypes = {
    b: (n)=>$5dc446195194829d$var$absFloor(n).toString(2),
    c: (n)=>String.fromCharCode(n),
    d: (n)=>Math.round(Math.abs(n)).toFixed(0),
    o: (n)=>$5dc446195194829d$var$absFloor(n).toString(8),
    x: (n)=>$5dc446195194829d$var$absFloor(n).toString(16),
    X: (n)=>$5dc446195194829d$var$integerTypes.x(n).toUpperCase(),
    n: (n)=>$5dc446195194829d$var$integerTypes.d(n),
    "%": (n)=>`${$5dc446195194829d$var$absFloor(n * 100).toFixed(0)}`
};
var $5dc446195194829d$var$decimalTypes = {
    e: (n, f)=>Math.abs(n).toExponential(f),
    E: (n, f)=>$5dc446195194829d$var$decimalTypes.e(n, f).toUpperCase(),
    f: (n, f)=>Math.abs(n).toFixed(f),
    F: (n, f)=>$5dc446195194829d$var$decimalTypes.f(n, f).toUpperCase(),
    g: (n, f)=>{
        if (n === 0) return "0";
        const a = Math.abs(n);
        const p = Math.floor(Math.log10(a));
        if (p >= -4 && p < f) return a.toFixed(f - 1 - p);
        return a.toExponential(f - 1);
    },
    G: (n, f)=>$5dc446195194829d$var$decimalTypes.g(n, f).toUpperCase(),
    n: (n, f)=>$5dc446195194829d$var$decimalTypes.g(n, f),
    p: (n, f)=>$5dc446195194829d$var$decimalTypes.r(n * 100, f),
    r: (n, f)=>{
        if (n === 0) return "0";
        const a = Math.abs(n);
        const p = Math.floor(Math.log10(a));
        const q = p - (f - 1);
        if (q <= 0) return a.toFixed(-q);
        const x = 10 ** q;
        return (Math.round(a / x) * x).toFixed();
    },
    s: (n, f)=>{
        const p = $5dc446195194829d$var$getSIPrefixPower(n);
        return $5dc446195194829d$var$decimalTypes.r(n / 10 ** p, f);
    },
    "%": (n, f)=>$5dc446195194829d$var$decimalTypes.f(n * 100, f)
};
var $5dc446195194829d$var$minSIPrefix = -24;
var $5dc446195194829d$var$maxSIPrefix = 24;
var $5dc446195194829d$var$siPrefixes = {
    [$5dc446195194829d$var$minSIPrefix]: "y",
    [-21]: "z",
    [-18]: "a",
    [-15]: "f",
    [-12]: "p",
    [-9]: "n",
    [-6]: "\xb5",
    [-3]: "m",
    [0]: "",
    [3]: "k",
    [6]: "M",
    [9]: "G",
    [12]: "T",
    [15]: "P",
    [18]: "E",
    [21]: "Z",
    [$5dc446195194829d$var$maxSIPrefix]: "Y"
};
var $5dc446195194829d$var$minusSign = "\u2212";
function $5dc446195194829d$var$absFloor(n) {
    return Math.floor(Math.abs(n));
}
function $5dc446195194829d$var$removeTrailingZeros(numString) {
    return numString.replace(/\.0+$/, "").replace(/(\.[1-9])0+$/, "$1");
}
function $5dc446195194829d$var$insertSeparator(numString, separator) {
    let dotIndex = numString.indexOf(".");
    if (dotIndex < 0) dotIndex = numString.length;
    const integerChars = numString.substring(0, dotIndex).split("");
    const fractionalPart = numString.substring(dotIndex);
    for(let i = integerChars.length - 3; i > 0; i -= 3)integerChars.splice(i, 0, separator);
    return `${integerChars.join("")}${fractionalPart}`;
}
function $5dc446195194829d$var$getSIPrefix(n) {
    return $5dc446195194829d$var$siPrefixes[$5dc446195194829d$var$getSIPrefixPower(n)];
}
function $5dc446195194829d$var$getSIPrefixPower(n) {
    return $5dc446195194829d$export$7d15b64cf5a3a4c4($5dc446195194829d$var$minSIPrefix, n ? Math.floor(Math.log10(Math.abs(n)) / 3) * 3 : 0, $5dc446195194829d$var$maxSIPrefix);
}
function $5dc446195194829d$var$addSign(num, numString, signType = "") {
    if (signType === "(") return num >= 0 ? numString : `(${numString})`;
    const plusSign = signType === "+" ? "+" : "";
    return `${num >= 0 ? plusSign : $5dc446195194829d$var$minusSign}${numString}`;
}
function $5dc446195194829d$var$addPadding(numString, width, fill = " ", align = ">") {
    let result = numString;
    if (align === ">" || !align) result = result.padStart(width, fill);
    else if (align === "<") result = result.padEnd(width, fill);
    else if (align === "^") {
        const padWidth = Math.max(0, width - result.length);
        const padLeft = Math.ceil(padWidth / 2);
        const padRight = Math.floor(padWidth / 2);
        result = result.padStart(padLeft + result.length, fill);
        result = result.padEnd(padRight + result.length, fill);
    }
    return result;
}

});



parcelRegister("56bIJ", function(module, exports) {

$parcel$export(module.exports, "theme", () => $c9147b3feae1fc05$export$bca14c5b3b88a9c9);
const $c9147b3feae1fc05$export$bca14c5b3b88a9c9 = {
    params: {
        foregroundColor: "#1e293b",
        backgroundColor: "#0F172A",
        accentColor: "#fff",
        chromeBackgroundColor: "#0F172A",
        chromeTextColor: "#FCFDFE",
        fontFamily: "Inter, serif",
        fontSize: 12,
        textColor: "#FCFDFE"
    }
};

});

parcelRegister("1cW8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fa25f82c0ffee0d$export$2e2bcd8739ae039);

var $f1q41 = parcelRequire("f1q41");

var $2mJUK = parcelRequire("2mJUK");
const $9fa25f82c0ffee0d$var$colors = Object.values((0, (/*@__PURE__*/$parcel$interopDefault($2mJUK))).theme.extend.colors.chart);
const $9fa25f82c0ffee0d$var$hydrateSeriesStyles = (series)=>{
    if (!series) return;
    return series.map((s, i)=>{
        if (s.type === "line") {
            const { default: color } = $9fa25f82c0ffee0d$var$colors[i === 0 ? 1 : i + 1];
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({
                stroke: color || "#000",
                marker: {
                    fill: color || "#000",
                    size: 9
                },
                cursor: "pointer"
            }, s);
        }
        if (s.type === "bar") {
            const { default: color, negative: negative, highlighted: highlighted } = $9fa25f82c0ffee0d$var$colors[i];
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({
                fill: color || "#000",
                cornerRadius: 6,
                cursor: "pointer",
                shadow: {
                    enabled: false
                },
                stroke: color || "#000",
                strokeWidth: 1.5,
                strokeOpacity: 0,
                itemStyler: (params)=>{
                    let fill = color;
                    if (params.yValue < 0) fill = negative;
                    if (params.highlighted) fill = highlighted;
                    return {
                        fill: fill
                    };
                }
            }, s);
        }
        return s;
    });
};
var $9fa25f82c0ffee0d$export$2e2bcd8739ae039 = $9fa25f82c0ffee0d$var$hydrateSeriesStyles;

});

parcelRegister("aD9oO", function(module, exports) {

$parcel$export(module.exports, "ChartContainer", () => $5fe0df1b4cdc733a$export$57a8e701bcb0acd5);

var $ayMG0 = parcelRequire("ayMG0");

var $bKDPc = parcelRequire("bKDPc");

var $9QePP = parcelRequire("9QePP");

var $iDSqy = parcelRequire("iDSqy");

var $jqf3H = parcelRequire("jqf3H");

var $2MSWI = parcelRequire("2MSWI");
function $5fe0df1b4cdc733a$export$57a8e701bcb0acd5({ title: title, children: children, description: description, isCondensed: isCondensed = true, isSnapshot: isSnapshot = false, titleLink: titleLink, periodFilter: periodFilter, dateRangeFilter: dateRangeFilter }) {
    const { parentRef: containerRef, width: containerWidth, height: containerHeight } = (0, $bKDPc.default)({
        debounceTime: 15
    });
    const { parentRef: headerRef, height: headerHeight } = (0, $bKDPc.default)({
        ignoreDimensions: [
            "width"
        ]
    });
    const containerPadding = 32;
    const width = containerWidth - 16;
    const height = containerHeight - headerHeight - containerPadding;
    const defaultPeriodOptions = [
        {
            label: "Monthly",
            value: "monthly"
        },
        {
            label: "Quarterly",
            value: "quarterly"
        },
        {
            label: "Yearly",
            value: "yearly"
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.clsx)("border-default flex flex-col rounded border", isCondensed ? "h-[680px]" : "h-[760px]"),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, $9QePP.clsx)("bg-secondary", "flex h-full flex-col text-clip rounded p-6"),
            ref: containerRef,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "header mb-4",
                    ref: headerRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: (0, $9QePP.clsx)("", "items-start justify-between"),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: (0, $9QePP.clsx)("mb-4", titleLink ? "flex w-full items-baseline justify-between gap-2" : ""),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        className: "heading-m",
                                        children: title
                                    }),
                                    titleLink?.href && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                        onClick: titleLink.onClick,
                                        href: titleLink.href,
                                        className: (0, $9QePP.clsx)("group flex items-center gap-1"),
                                        children: [
                                            titleLink.label,
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iDSqy.default), {
                                                width: 16,
                                                height: 16
                                            })
                                        ]
                                    }),
                                    titleLink?.onClick && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: titleLink.onClick,
                                        className: (0, $9QePP.clsx)("flex items-center gap-1", "faux-link"),
                                        children: [
                                            titleLink.label,
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iDSqy.default), {
                                                width: 16,
                                                height: 16
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isSnapshot && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-s subdued",
                                children: description
                            }),
                            (periodFilter || dateRangeFilter) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mt-4 space-y-4",
                                children: [
                                    periodFilter && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "flex items-center justify-end",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "w-48",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jqf3H.RawSelect), {
                                                name: "period-filter",
                                                label: "",
                                                options: periodFilter.options || defaultPeriodOptions,
                                                selected: periodFilter.selectedPeriod,
                                                onChange: periodFilter.onPeriodChange,
                                                testId: "chart-period-filter"
                                            })
                                        })
                                    }),
                                    dateRangeFilter && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: (0, $9QePP.clsx)("w-full", "flex items-center justify-end gap-2"),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: (0, $9QePP.clsx)("flex gap-2", isCondensed ? "w-full" : "w-1/3"),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "flex-1",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2MSWI.YearMonthSelect), {
                                                            value: dateRangeFilter.dateRange.startDate,
                                                            onChange: (value)=>dateRangeFilter.onDateRangeChange({
                                                                    ...dateRangeFilter.dateRange,
                                                                    startDate: value
                                                                }),
                                                            label: "",
                                                            availableDates: dateRangeFilter.availableDates,
                                                            placeholder: "Start date"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "flex-1",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2MSWI.YearMonthSelect), {
                                                            value: dateRangeFilter.dateRange.endDate,
                                                            onChange: (value)=>dateRangeFilter.onDateRangeChange({
                                                                    ...dateRangeFilter.dateRange,
                                                                    endDate: value
                                                                }),
                                                            label: "",
                                                            availableDates: dateRangeFilter.availableDates,
                                                            placeholder: "End date"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "w-20",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: ()=>dateRangeFilter.onDateRangeChange({
                                                            startDate: "",
                                                            endDate: ""
                                                        }),
                                                    className: "secondary w-full",
                                                    children: "Clear"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "h-full pt-0",
                    children: children({
                        width: width,
                        height: height
                    })
                })
            ]
        })
    });
}

});
parcelRegister("bKDPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $88e2e1f4a27951a6$export$2e2bcd8739ae039);

var $iI6LB = parcelRequire("iI6LB");

var $acw62 = parcelRequire("acw62");
function $88e2e1f4a27951a6$var$_extends() {
    $88e2e1f4a27951a6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $88e2e1f4a27951a6$var$_extends.apply(this, arguments);
}
var $88e2e1f4a27951a6$var$defaultIgnoreDimensions = [];
var $88e2e1f4a27951a6$var$defaultInitialSize = {
    width: 0,
    height: 0,
    top: 0,
    left: 0
};
function $88e2e1f4a27951a6$export$2e2bcd8739ae039(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$initialSize = _ref.initialSize, initialSize = _ref$initialSize === void 0 ? $88e2e1f4a27951a6$var$defaultInitialSize : _ref$initialSize, _ref$debounceTime = _ref.debounceTime, debounceTime = _ref$debounceTime === void 0 ? 300 : _ref$debounceTime, _ref$ignoreDimensions = _ref.ignoreDimensions, ignoreDimensions = _ref$ignoreDimensions === void 0 ? $88e2e1f4a27951a6$var$defaultIgnoreDimensions : _ref$ignoreDimensions, _ref$enableDebounceLe = _ref.enableDebounceLeadingCall, enableDebounceLeadingCall = _ref$enableDebounceLe === void 0 ? true : _ref$enableDebounceLe, resizeObserverPolyfill = _ref.resizeObserverPolyfill;
    var parentRef = (0, $acw62.useRef)(null);
    var animationFrameID = (0, $acw62.useRef)(0);
    var _useState = (0, $acw62.useState)($88e2e1f4a27951a6$var$_extends({}, $88e2e1f4a27951a6$var$defaultInitialSize, initialSize)), state = _useState[0], setState = _useState[1];
    var resize = (0, $acw62.useMemo)(function() {
        var normalized = Array.isArray(ignoreDimensions) ? ignoreDimensions : [
            ignoreDimensions
        ];
        return (0, (/*@__PURE__*/$parcel$interopDefault($iI6LB)))(function(incoming) {
            setState(function(existing) {
                var stateKeys = Object.keys(existing);
                var keysWithChanges = stateKeys.filter(function(key) {
                    return existing[key] !== incoming[key];
                });
                var shouldBail = keysWithChanges.every(function(key) {
                    return normalized.includes(key);
                });
                return shouldBail ? existing : incoming;
            });
        }, debounceTime, {
            leading: enableDebounceLeadingCall
        });
    }, [
        debounceTime,
        enableDebounceLeadingCall,
        ignoreDimensions
    ]);
    (0, $acw62.useEffect)(function() {
        var LocalResizeObserver = resizeObserverPolyfill || window.ResizeObserver;
        var observer = new LocalResizeObserver(function(entries) {
            entries.forEach(function(entry) {
                var _entry$contentRect;
                var _ref2 = (_entry$contentRect = entry == null ? void 0 : entry.contentRect) != null ? _entry$contentRect : {}, left = _ref2.left, top = _ref2.top, width = _ref2.width, height = _ref2.height;
                animationFrameID.current = window.requestAnimationFrame(function() {
                    resize({
                        width: width,
                        height: height,
                        top: top,
                        left: left
                    });
                });
            });
        });
        if (parentRef.current) observer.observe(parentRef.current);
        return function() {
            window.cancelAnimationFrame(animationFrameID.current);
            observer.disconnect();
            resize.cancel();
        };
    }, [
        resize,
        resizeObserverPolyfill
    ]);
    return $88e2e1f4a27951a6$var$_extends({
        parentRef: parentRef,
        resize: resize
    }, state);
}

});
parcelRegister("iI6LB", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");

var $9nn6T = parcelRequire("9nn6T");

var $iV4PZ = parcelRequire("iV4PZ");
/** Error message constants. */ var $d9f195cb3938646c$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d9f195cb3938646c$var$nativeMax = Math.max, $d9f195cb3938646c$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $d9f195cb3938646c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($d9f195cb3938646c$var$FUNC_ERROR_TEXT);
    wait = $iV4PZ(wait) || 0;
    if ($lsJ54(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $d9f195cb3938646c$var$nativeMax($iV4PZ(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $d9f195cb3938646c$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $9nn6T();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($9nn6T());
    }
    function debounced() {
        var time = $9nn6T(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $d9f195cb3938646c$var$debounce;

});
parcelRegister("9nn6T", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6d38303b9c8735ba$var$now = function() {
    return $23YZo.Date.now();
};
module.exports = $6d38303b9c8735ba$var$now;

});

parcelRegister("iV4PZ", function(module, exports) {

var $s0iWz = parcelRequire("s0iWz");

var $lsJ54 = parcelRequire("lsJ54");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $dc614d828223dea6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $dc614d828223dea6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $dc614d828223dea6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $dc614d828223dea6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $dc614d828223dea6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $dc614d828223dea6$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($9dr3u(value)) return $dc614d828223dea6$var$NAN;
    if ($lsJ54(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $lsJ54(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $s0iWz(value);
    var isBinary = $dc614d828223dea6$var$reIsBinary.test(value);
    return isBinary || $dc614d828223dea6$var$reIsOctal.test(value) ? $dc614d828223dea6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $dc614d828223dea6$var$reIsBadHex.test(value) ? $dc614d828223dea6$var$NAN : +value;
}
module.exports = $dc614d828223dea6$var$toNumber;

});
parcelRegister("s0iWz", function(module, exports) {

var $kzo8D = parcelRequire("kzo8D");
/** Used to match leading whitespace. */ var $0542da1d887b1c4d$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0542da1d887b1c4d$var$baseTrim(string) {
    return string ? string.slice(0, $kzo8D(string) + 1).replace($0542da1d887b1c4d$var$reTrimStart, "") : string;
}
module.exports = $0542da1d887b1c4d$var$baseTrim;

});
parcelRegister("kzo8D", function(module, exports) {
/** Used to match a single whitespace character. */ var $ef99cce288c7323e$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ef99cce288c7323e$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ef99cce288c7323e$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $ef99cce288c7323e$var$trimmedEndIndex;

});





parcelRegister("iDSqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d92616a074e1fd15$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $d92616a074e1fd15$var$ArrowTopRightOnSquareIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
    }));
}
const $d92616a074e1fd15$var$ForwardRef = $acw62.forwardRef($d92616a074e1fd15$var$ArrowTopRightOnSquareIcon);
var $d92616a074e1fd15$export$2e2bcd8739ae039 = $d92616a074e1fd15$var$ForwardRef;

});

parcelRegister("2MSWI", function(module, exports) {

$parcel$export(module.exports, "YearMonthSelect", () => $93411af5ea1d8417$export$c82af6b67515e8);

var $ayMG0 = parcelRequire("ayMG0");

var $jqf3H = parcelRequire("jqf3H");
function $93411af5ea1d8417$export$c82af6b67515e8({ value: value, onChange: onChange, label: label, availableDates: availableDates, placeholder: placeholder = "Select date" }) {
    const dateOptions = availableDates.map((date)=>{
        const [year, month] = date.split("-");
        const monthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];
        const monthName = monthNames[parseInt(month) - 1];
        return {
            label: `${monthName} ${year}`,
            value: date
        };
    });
    const selectedOption = dateOptions.find((opt)=>opt.value === value) || null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jqf3H.RawSelect), {
        name: `${label.toLowerCase()}-date`,
        label: label,
        options: dateOptions,
        selected: selectedOption,
        onChange: (option)=>{
            if (!Array.isArray(option) && option) onChange(option.value);
            else onChange("");
        },
        testId: `${label.toLowerCase()}-date-filter`,
        placeholder: placeholder
    });
}

});



parcelRegister("cLcpc", function(module, exports) {

$parcel$export(module.exports, "MoneyAxis", () => $fee91ea8bdedbb3a$export$b0cf11320e065241);
$parcel$export(module.exports, "GroupedCategoryAxis", () => $fee91ea8bdedbb3a$export$a99dab74fcc8dab8);
parcelRequire("iuVpE");
var $7op73 = parcelRequire("7op73");
const $fee91ea8bdedbb3a$export$b0cf11320e065241 = {
    type: "number",
    position: "right",
    label: {
        formatter: (params)=>"$" + (0, $7op73.abbreviate)(`${params.value}`)
    },
    crosshair: {
        enabled: false
    }
};
const $fee91ea8bdedbb3a$export$cf5f66fcb730f396 = {
    type: "number",
    position: "left",
    label: {
        formatter: (params)=>`${(params.value * 100).toFixed(0)}%`
    },
    crosshair: {
        enabled: false
    }
};
const $fee91ea8bdedbb3a$var$groupedBase = {
    type: "grouped-category",
    position: "bottom",
    line: {
        width: 1,
        stroke: "#6B7280"
    },
    gridLine: {
        enabled: false
    },
    paddingInner: 0.3,
    label: {
        rotation: 0,
        avoidCollisions: true
    }
};
const $fee91ea8bdedbb3a$export$a99dab74fcc8dab8 = {
    singleDepth: {
        ...$fee91ea8bdedbb3a$var$groupedBase,
        depthOptions: [
            {
                tick: {
                    stroke: "#6B7280",
                    width: 1
                },
                label: {
                    fontSize: 11,
                    avoidCollisions: true
                }
            }
        ]
    },
    doubleDepth: {
        ...$fee91ea8bdedbb3a$var$groupedBase,
        depthOptions: [
            {
                tick: {
                    stroke: "#6B7280",
                    width: 1
                },
                label: {
                    fontSize: 11,
                    avoidCollisions: true,
                    spacing: 8,
                    rotation: -90
                }
            },
            {
                tick: {
                    stroke: "#6B7280",
                    width: 1
                },
                label: {
                    fontSize: 11,
                    spacing: 12,
                    avoidCollisions: true
                }
            }
        ]
    }
};

});

parcelRegister("jAiH0", function(module, exports) {

$parcel$export(module.exports, "filterNullValuesFromChartData", () => $4c154175df9e5487$export$e05e2f5eb1224502);
$parcel$export(module.exports, "formatCurrency", () => $4c154175df9e5487$export$3dc27271f5d5c629);
$parcel$export(module.exports, "formatTooltipData", () => $4c154175df9e5487$export$bce9dc1075b67650);
function $4c154175df9e5487$export$e05e2f5eb1224502(data) {
    return data.map((item)=>{
        const filteredItem = {
            ...item
        };
        Object.keys(filteredItem).forEach((key)=>{
            if (filteredItem[key] === null) delete filteredItem[key];
        });
        return filteredItem;
    });
}
function $4c154175df9e5487$export$3dc27271f5d5c629(value) {
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    return formatter.format(value);
}
function $4c154175df9e5487$export$bce9dc1075b67650(items) {
    return items.filter((item)=>item.value != null && item.value !== "$NaN").map((item)=>({
            label: item.label,
            value: item.value
        }));
}

});

parcelRegister("5CWLf", function(module, exports) {

$parcel$export(module.exports, "aggregateChartData", () => $2ccfa7e1a637375a$export$582d6670466b71a4);
const $2ccfa7e1a637375a$var$MONTH_MAP = {
    Jan: 1,
    Feb: 2,
    Mar: 3,
    Apr: 4,
    May: 5,
    Jun: 6,
    Jul: 7,
    Aug: 8,
    Sep: 9,
    Oct: 10,
    Nov: 11,
    Dec: 12
};
function $2ccfa7e1a637375a$var$getQuarter(month) {
    return Math.ceil(month / 3);
}
function $2ccfa7e1a637375a$var$getQuarterLabel(quarter) {
    return `Q${quarter}`;
}
function $2ccfa7e1a637375a$var$aggregateValues(values, strategy) {
    const validValues = values.filter((v)=>v !== null);
    if (validValues.length === 0) return null;
    switch(strategy){
        case "sum":
            return validValues.reduce((sum, val)=>sum + val, 0);
        case "average":
            return validValues.reduce((sum, val)=>sum + val, 0) / validValues.length;
        case "last":
            return validValues[validValues.length - 1];
        case "first":
            return validValues[0];
        default:
            return validValues.reduce((sum, val)=>sum + val, 0);
    }
}
function $2ccfa7e1a637375a$export$7fe7b621f22a8175(data, period, aggregationConfig) {
    if (period === "monthly") return data;
    const grouped = data.reduce((acc, item)=>{
        const [year, monthName] = item.month;
        const monthNum = $2ccfa7e1a637375a$var$MONTH_MAP[monthName];
        let periodKey;
        let periodLabel;
        if (period === "quarterly") {
            const quarter = $2ccfa7e1a637375a$var$getQuarter(monthNum);
            periodKey = `${year}-Q${quarter}`;
            periodLabel = [
                year,
                $2ccfa7e1a637375a$var$getQuarterLabel(quarter)
            ];
        } else {
            periodKey = year;
            periodLabel = [
                year,
                ""
            ];
        }
        if (!acc[periodKey]) acc[periodKey] = {
            items: [],
            periodLabel: periodLabel
        };
        acc[periodKey].items.push(item);
        return acc;
    }, {});
    return Object.values(grouped).map(({ items: items, periodLabel: periodLabel })=>{
        const aggregated = {
            month: periodLabel
        };
        Object.entries(aggregationConfig).forEach(([fieldName, strategy])=>{
            const values = items.map((item)=>item[fieldName]);
            aggregated[fieldName] = $2ccfa7e1a637375a$var$aggregateValues(values, strategy);
        });
        const firstItem = items[0];
        Object.keys(firstItem).forEach((key)=>{
            if (key !== "month" && !aggregationConfig[key]) aggregated[key] = items[items.length - 1][key];
        });
        return aggregated;
    }).sort((a, b)=>{
        const yearA = parseInt(a.month[0]);
        const yearB = parseInt(b.month[0]);
        if (yearA !== yearB) return yearA - yearB;
        if (period === "quarterly") {
            const quarterA = parseInt(a.month[1].replace("Q", ""));
            const quarterB = parseInt(b.month[1].replace("Q", ""));
            return quarterA - quarterB;
        }
        return 0;
    });
}
const $2ccfa7e1a637375a$export$3fbf8ea390a4e5a4 = {
    cashflowProgression: {
        totalRevenue: "sum",
        preMarketingEbitda: "sum",
        netIncome: "sum",
        grossMargin: "sum",
        changeInCash: "sum",
        ebitda: "sum"
    },
    financialData: {
        totalRevenue: "sum",
        projectedRevenue: "sum",
        grossMargin: "average",
        projectedGrossMargin: "average",
        salesAndMarketing: "sum",
        projectedSalesAndMarketing: "sum",
        totalExpenses: "sum",
        projectedTotalExpenses: "sum",
        preMarketingEbitda: "sum",
        projectedPreMarketingEbitda: "sum",
        ebitda: "sum",
        projectedEbitda: "sum"
    },
    debtComposition: {
        interestAndFees: "sum",
        debtServiceReconcilitationDiffP: "sum",
        interestExpense: "sum",
        debtBalanceEop: "last",
        totalDebt: "last",
        debtTotalReconciliationDiffP: "sum"
    },
    assetProgression: {
        totalAssets: "last",
        liquidAssets: "last",
        totalReceivables: "last",
        totalNoncurrentAssets: "last",
        noncurrentAssetsPropertyPlantAndEquipment: "last",
        cash: "last",
        totalInventory: "last",
        currentAssets: "last"
    },
    balanceOverTime: {
        balanceAvgInPeriod: "average",
        interestAndFees: "sum",
        debtBalanceBop: "first",
        capitalAtRiskEop: "last",
        debtBalanceEop: "last",
        amortization: "sum",
        disbursement: "sum",
        capitalAtRiskAvgInPeriod: "average",
        interestAndFeesCash: "sum",
        capitalAtRiskBop: "first",
        interestAndFeesAccrued: "sum"
    },
    liquidity: {
        liquidAssets: "last",
        totalExpenses: "sum",
        totalRevenue: "sum",
        totalCurrentLiabilities: "last",
        currentAssetsNetInventory: "last",
        currentRatio: "last",
        quickRatio: "last",
        cashRatio: "last",
        cash: "last",
        netIncome: "sum",
        ebitda: "sum",
        currentAssets: "last",
        runway: "last"
    }
};
function $2ccfa7e1a637375a$export$582d6670466b71a4(data, period, chartType) {
    return $2ccfa7e1a637375a$export$7fe7b621f22a8175(data, period, $2ccfa7e1a637375a$export$3fbf8ea390a4e5a4[chartType]);
}

});

parcelRegister("dfZUs", function(module, exports) {

$parcel$export(module.exports, "usePeriodFilter", () => $de9534b7c8635884$export$c4542ae6166f2df3);

var $acw62 = parcelRequire("acw62");
function $de9534b7c8635884$export$c4542ae6166f2df3(defaultPeriod = "monthly") {
    const periodOptions = [
        {
            label: "Monthly",
            value: "monthly"
        },
        {
            label: "Quarterly",
            value: "quarterly"
        },
        {
            label: "Yearly",
            value: "yearly"
        }
    ];
    const defaultOption = periodOptions.find((option)=>option.value === defaultPeriod) || periodOptions[0];
    const [selectedPeriod, setSelectedPeriod] = (0, $acw62.useState)(defaultOption);
    const handlePeriodChange = (option)=>{
        if (Array.isArray(option)) setSelectedPeriod(option[0]);
        else setSelectedPeriod(option);
    };
    return {
        selectedPeriod: selectedPeriod,
        periodOptions: periodOptions,
        handlePeriodChange: handlePeriodChange,
        periodFilterProps: {
            selectedPeriod: selectedPeriod,
            onPeriodChange: handlePeriodChange,
            options: periodOptions
        }
    };
}

});


parcelRegister("8WQ3J", function(module, exports) {

$parcel$export(module.exports, "BalanceOverTime", () => $edbe07ca0c922f41$export$d62933ac4c5e4053);

var $ayMG0 = parcelRequire("ayMG0");

var $Bq2gZ = parcelRequire("Bq2gZ");

var $cLcpc = parcelRequire("cLcpc");

var $jAiH0 = parcelRequire("jAiH0");
function $edbe07ca0c922f41$export$d62933ac4c5e4053({ isCondensed: isCondensed, data: data }) {
    const filteredData = (0, $jAiH0.filterNullValuesFromChartData)(data || []);
    if (filteredData.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Bq2gZ.Chart), {
        title: "Balance Over Time",
        description: "Shows balance vs. at-risk capital over time for a credit.",
        isCondensed: isCondensed,
        options: {
            data: filteredData,
            tooltip: {
                mode: "single"
            },
            series: [
                {
                    type: "bar",
                    xKey: "month",
                    yKey: "balanceAvgInPeriod",
                    yName: "Avg. Loan Balance (Remittance Report)",
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            return {
                                heading: `${month}`,
                                title: "Average Loan Balance",
                                data: (0, $jAiH0.formatTooltipData)([
                                    {
                                        label: "Debt Balance BOP",
                                        value: (0, $jAiH0.formatCurrency)(datum.debtBalanceBop)
                                    },
                                    {
                                        label: "Disbursement",
                                        value: (0, $jAiH0.formatCurrency)(datum.disbursement)
                                    },
                                    {
                                        label: "Amortization",
                                        value: (0, $jAiH0.formatCurrency)(datum.amortization)
                                    },
                                    {
                                        label: "Interest & Fees",
                                        value: (0, $jAiH0.formatCurrency)(datum.interestAndFees)
                                    },
                                    {
                                        label: "Interest & Fees Accrued",
                                        value: (0, $jAiH0.formatCurrency)(datum.interestAndFeesAccrued)
                                    },
                                    {
                                        label: "Debt Balance EOP",
                                        value: (0, $jAiH0.formatCurrency)(datum.debtBalanceEop)
                                    }
                                ])
                            };
                        }
                    }
                },
                {
                    type: "bar",
                    xKey: "month",
                    yKey: "capitalAtRiskAvgInPeriod",
                    yName: "Average Loan Capital at Risk (Remittance Report)",
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            return {
                                heading: `${month}`,
                                title: "Capital at Risk",
                                data: (0, $jAiH0.formatTooltipData)([
                                    {
                                        label: "Capital at Risk BOP",
                                        value: (0, $jAiH0.formatCurrency)(datum.capitalAtRiskBop)
                                    },
                                    {
                                        label: "Disbursement",
                                        value: (0, $jAiH0.formatCurrency)(datum.disbursement)
                                    },
                                    {
                                        label: "Amortization",
                                        value: (0, $jAiH0.formatCurrency)(datum.amortization)
                                    },
                                    {
                                        label: "Interest & Fees Cash",
                                        value: (0, $jAiH0.formatCurrency)(datum.interestAndFeesCash)
                                    },
                                    {
                                        label: "Capital at Risk EOP",
                                        value: (0, $jAiH0.formatCurrency)(datum.capitalAtRiskEop)
                                    }
                                ])
                            };
                        }
                    }
                }
            ],
            axes: [
                (0, $cLcpc.GroupedCategoryAxis).doubleDepth,
                {
                    ...(0, $cLcpc.MoneyAxis),
                    keys: [
                        "balanceAvgInPeriod",
                        "capitalAtRiskAvgInPeriod"
                    ]
                }
            ]
        }
    });
}

});

parcelRegister("h9RZb", function(module, exports) {

$parcel$export(module.exports, "CashFlowProgression", () => $aaa4b1a1258c426a$export$542b09b16d63ee0d);

var $ayMG0 = parcelRequire("ayMG0");

var $Bq2gZ = parcelRequire("Bq2gZ");

var $cLcpc = parcelRequire("cLcpc");

var $jAiH0 = parcelRequire("jAiH0");

var $5CWLf = parcelRequire("5CWLf");

var $dfZUs = parcelRequire("dfZUs");

var $gfhg6 = parcelRequire("gfhg6");

var $8xtpf = parcelRequire("8xtpf");

var $dKaYu = parcelRequire("dKaYu");
function $aaa4b1a1258c426a$export$542b09b16d63ee0d({ isCondensed: isCondensed, data: data }) {
    const { selectedPeriod: selectedPeriod, periodFilterProps: periodFilterProps } = (0, $dfZUs.usePeriodFilter)("monthly");
    const { dateRange: dateRange, dateRangeFilterProps: dateRangeFilterProps } = (0, $gfhg6.useDateRangeFilter)();
    const availableDates = (0, $8xtpf.getAvailableDates)(data || []);
    const dateFilteredData = (0, $8xtpf.filterDataByDateRange)(data || [], dateRange);
    const aggregatedData = (0, $5CWLf.aggregateChartData)(dateFilteredData, selectedPeriod.value, "cashflowProgression");
    const filteredData = (0, $jAiH0.filterNullValuesFromChartData)(aggregatedData);
    if (filteredData.length === 0) return null;
    const axisConfig = (0, $dKaYu.getOptimalAxisConfig)(selectedPeriod.value);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Bq2gZ.Chart), {
        title: "Cash Flow Progression",
        description: "The company displays highly volatile cash flow with frequent and often substantial negative EBITDA and net income, indicating operational and financial instability that would increase credit risk for lenders.",
        isCondensed: isCondensed,
        periodFilter: periodFilterProps,
        dateRangeFilter: {
            ...dateRangeFilterProps,
            availableDates: availableDates
        },
        options: {
            data: filteredData,
            tooltip: {
                mode: "single"
            },
            series: [
                {
                    type: "line",
                    xKey: "month",
                    yKey: "totalRevenue",
                    yName: "Total Revenue",
                    marker: {
                        enabled: false
                    }
                },
                {
                    type: "line",
                    xKey: "month",
                    yKey: "preMarketingEbitda",
                    yName: "Pre-Marketing EBITDA",
                    marker: {
                        enabled: false
                    }
                },
                {
                    type: "line",
                    xKey: "month",
                    yKey: "netIncome",
                    yName: "Net Income",
                    marker: {
                        enabled: false
                    }
                },
                {
                    type: "line",
                    xKey: "month",
                    yKey: "grossMargin",
                    yName: "Gross Margin",
                    marker: {
                        enabled: false
                    }
                },
                {
                    type: "line",
                    xKey: "month",
                    yKey: "changeInCash",
                    yName: "Change in Cash",
                    marker: {
                        enabled: false
                    }
                },
                {
                    type: "line",
                    xKey: "month",
                    yKey: "ebitda",
                    yName: "EBITDA",
                    marker: {
                        enabled: false
                    }
                }
            ],
            axes: [
                axisConfig,
                {
                    ...(0, $cLcpc.MoneyAxis),
                    keys: [
                        "totalRevenue",
                        "preMarketingEbitda",
                        "netIncome",
                        "grossMargin",
                        "changeInCash",
                        "ebitda"
                    ],
                    crosshair: {
                        enabled: true
                    }
                }
            ]
        }
    });
}

});
parcelRegister("gfhg6", function(module, exports) {

$parcel$export(module.exports, "useDateRangeFilter", () => $465f9c985e25ded4$export$1799ff211e43f48e);

var $acw62 = parcelRequire("acw62");
function $465f9c985e25ded4$export$1799ff211e43f48e(defaultStart, defaultEnd) {
    const [dateRange, setDateRange] = (0, $acw62.useState)({
        startDate: defaultStart || "",
        endDate: defaultEnd || ""
    });
    const clearDateRange = ()=>{
        setDateRange({
            startDate: "",
            endDate: ""
        });
    };
    return {
        dateRange: dateRange,
        setDateRange: setDateRange,
        dateRangeFilterProps: {
            dateRange: dateRange,
            onDateRangeChange: setDateRange
        },
        clearDateRange: clearDateRange
    };
}

});

parcelRegister("8xtpf", function(module, exports) {

$parcel$export(module.exports, "filterDataByDateRange", () => $6c69f07a00c7bce4$export$f9771ba0ec640da1);
$parcel$export(module.exports, "getAvailableDates", () => $6c69f07a00c7bce4$export$8839a0b012658dc2);
function $6c69f07a00c7bce4$var$dataToDateString([year, month]) {
    const monthMap = {
        Jan: "01",
        Feb: "02",
        Mar: "03",
        Apr: "04",
        May: "05",
        Jun: "06",
        Jul: "07",
        Aug: "08",
        Sep: "09",
        Oct: "10",
        Nov: "11",
        Dec: "12"
    };
    return `${year}-${monthMap[month]}`;
}
function $6c69f07a00c7bce4$export$f9771ba0ec640da1(data, dateRange) {
    if (!dateRange.startDate || !dateRange.endDate) return data;
    return data.filter((item)=>{
        const itemDate = $6c69f07a00c7bce4$var$dataToDateString(item.month);
        return itemDate >= dateRange.startDate && itemDate <= dateRange.endDate;
    });
}
function $6c69f07a00c7bce4$export$8839a0b012658dc2(data) {
    return data.map((item)=>$6c69f07a00c7bce4$var$dataToDateString(item.month)).sort().filter((date, index, arr)=>arr.indexOf(date) === index);
}

});

parcelRegister("dKaYu", function(module, exports) {

$parcel$export(module.exports, "getOptimalAxisConfig", () => $c03aba46064c4a25$export$8345481806a6220);

var $cLcpc = parcelRequire("cLcpc");
function $c03aba46064c4a25$export$8345481806a6220(period) {
    if (period === "yearly") return (0, $cLcpc.GroupedCategoryAxis).singleDepth;
    return (0, $cLcpc.GroupedCategoryAxis).doubleDepth;
}

});


parcelRegister("2q4Dy", function(module, exports) {

$parcel$export(module.exports, "DebtComposition", () => $4fd29d65e9e26f4d$export$6098e2541389f5a2);

var $ayMG0 = parcelRequire("ayMG0");

var $Bq2gZ = parcelRequire("Bq2gZ");

var $cLcpc = parcelRequire("cLcpc");

var $jAiH0 = parcelRequire("jAiH0");
function $4fd29d65e9e26f4d$export$6098e2541389f5a2({ isCondensed: isCondensed, data: data }) {
    const filteredData = (0, $jAiH0.filterNullValuesFromChartData)(data || []);
    if (filteredData.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Bq2gZ.Chart), {
        title: "Debt Composition",
        description: "Total debt has consistently remained very high relative to operating performance, and rising debt-to-equity imbalances paired with reconciliation discrepancies and rapidly declining outstanding balances indicate potential reporting, accounting, or structural risk.",
        isCondensed: isCondensed,
        options: {
            data: filteredData,
            tooltip: {
                mode: "single"
            },
            series: [
                {
                    type: "line",
                    xKey: "month",
                    yKey: "debtTotalReconciliationDiffP",
                    yName: "Debt Total Reconciliation Diff %",
                    marker: {
                        enabled: false
                    },
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            const percentValue = datum.debtTotalReconciliationDiffP;
                            return {
                                heading: `${month}`,
                                title: "Debt Total Reconciliation Diff %",
                                data: (0, $jAiH0.formatTooltipData)([
                                    {
                                        label: "Debt Total Reconciliation Diff %",
                                        value: `${(percentValue * 100).toFixed(0)}%`
                                    },
                                    {
                                        label: "Total Debt",
                                        value: (0, $jAiH0.formatCurrency)(datum.totalDebt)
                                    },
                                    {
                                        label: "Debt Balance EOP",
                                        value: (0, $jAiH0.formatCurrency)(datum.debtBalanceEop)
                                    }
                                ])
                            };
                        }
                    }
                },
                {
                    type: "line",
                    xKey: "month",
                    yKey: "debtServiceReconcilitationDiffP",
                    yName: "Debt Service Reconciliation Diff %",
                    marker: {
                        enabled: false
                    },
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            const percentValue = datum.debtServiceReconcilitationDiffP;
                            return {
                                heading: `${month}`,
                                title: "Debt Service Reconciliation Diff %",
                                data: (0, $jAiH0.formatTooltipData)([
                                    {
                                        label: "Debt Service Reconciliation Diff %",
                                        value: `${(percentValue * 100).toFixed(0)}%`
                                    },
                                    {
                                        label: "Interest Expense",
                                        value: (0, $jAiH0.formatCurrency)(datum.interestExpense)
                                    },
                                    {
                                        label: "Interest and Fees",
                                        value: (0, $jAiH0.formatCurrency)(datum.interestAndFees)
                                    }
                                ])
                            };
                        }
                    }
                }
            ],
            axes: [
                (0, $cLcpc.GroupedCategoryAxis).doubleDepth,
                {
                    type: "number",
                    position: "right",
                    label: {
                        formatter: (params)=>{
                            return `${(params.value * 100).toFixed(0)}%`;
                        }
                    },
                    keys: [
                        "debtTotalReconciliationDiffP",
                        "debtServiceReconcilitationDiffP"
                    ]
                }
            ]
        }
    });
}

});

parcelRegister("gsVw8", function(module, exports) {

$parcel$export(module.exports, "DebtServiceCoverage", () => $c482095c4dac4bc6$export$5dd5cec293d0a8ee);

var $ayMG0 = parcelRequire("ayMG0");

var $Bq2gZ = parcelRequire("Bq2gZ");

var $cLcpc = parcelRequire("cLcpc");

var $jAiH0 = parcelRequire("jAiH0");
function $c482095c4dac4bc6$export$5dd5cec293d0a8ee({ isCondensed: isCondensed, data: data }) {
    const filteredData = (0, $jAiH0.filterNullValuesFromChartData)(data || []);
    if (filteredData.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Bq2gZ.Chart), {
        title: "Debt Service Coverage",
        description: "Highly volatile EBITDA, frequent negative and erratic debt service coverage ratios, and unpredictable runways indicate inconsistent operating performance and significant credit risk despite occasional strong months.",
        isCondensed: isCondensed,
        options: {
            data: filteredData,
            tooltip: {
                mode: "single"
            },
            series: [
                {
                    type: "line",
                    xKey: "month",
                    yKey: "debtServiceCoverageRatio",
                    yName: "Debt Service Coverage Ratio",
                    marker: {
                        enabled: false
                    },
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            const ratioValue = datum.debtServiceCoverageRatio;
                            return {
                                heading: `${month}`,
                                title: "Debt Service Coverage Ratio",
                                data: (0, $jAiH0.formatTooltipData)([
                                    {
                                        label: "Debt Service Coverage Ratio",
                                        value: ratioValue === Infinity ? "\u221Ex" : `${ratioValue.toFixed(1)}x`
                                    },
                                    {
                                        label: "EBITDA",
                                        value: (0, $jAiH0.formatCurrency)(datum.ebitda)
                                    },
                                    {
                                        label: "Interest Expense",
                                        value: (0, $jAiH0.formatCurrency)(datum.interestExpense)
                                    },
                                    {
                                        label: "Cash",
                                        value: (0, $jAiH0.formatCurrency)(datum.cash)
                                    },
                                    {
                                        label: "Runway",
                                        value: datum.runway === Infinity ? "\u221E months" : `${datum.runway.toFixed(1)} months`
                                    }
                                ])
                            };
                        }
                    }
                },
                {
                    type: "line",
                    xKey: "month",
                    yKey: "debtServiceCoverageRatioFromRemittanceReport",
                    yName: "Debt Service Coverage Ratio (Remittance Report)",
                    marker: {
                        enabled: false
                    },
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            const ratioValue = datum.debtServiceCoverageRatioFromRemittanceReport;
                            return {
                                heading: `${month}`,
                                title: "Debt Service Coverage Ratio (Remittance Report)",
                                data: (0, $jAiH0.formatTooltipData)([
                                    {
                                        label: "Debt Service Coverage Ratio (Remittance Report)",
                                        value: ratioValue === Infinity ? "\u221Ex" : ratioValue === -Infinity ? "-\u221Ex" : `${ratioValue.toFixed(1)}x`
                                    },
                                    {
                                        label: "EBITDA",
                                        value: (0, $jAiH0.formatCurrency)(datum.ebitda)
                                    },
                                    {
                                        label: "Interest and Fees",
                                        value: (0, $jAiH0.formatCurrency)(datum.interestAndFees)
                                    },
                                    {
                                        label: "Cash",
                                        value: (0, $jAiH0.formatCurrency)(datum.cash)
                                    },
                                    {
                                        label: "Runway",
                                        value: datum.runway === Infinity ? "\u221E months" : `${datum.runway.toFixed(1)} months`
                                    }
                                ])
                            };
                        }
                    }
                }
            ],
            axes: [
                (0, $cLcpc.GroupedCategoryAxis).doubleDepth,
                {
                    type: "number",
                    position: "right",
                    label: {
                        formatter: (params)=>{
                            if (params.value === Infinity) return "\u221Ex";
                            if (params.value === -Infinity) return "-\u221Ex";
                            return `${params.value.toFixed(1)}x`;
                        }
                    },
                    keys: [
                        "debtServiceCoverageRatio",
                        "debtServiceCoverageRatioFromRemittanceReport"
                    ]
                }
            ]
        }
    });
}

});

parcelRegister("aQVzu", function(module, exports) {

$parcel$export(module.exports, "DebtToAssets", () => $74d62eff4e930ae1$export$fbd92bb7dbbe27f7);

var $ayMG0 = parcelRequire("ayMG0");

var $Bq2gZ = parcelRequire("Bq2gZ");

var $cLcpc = parcelRequire("cLcpc");

var $jAiH0 = parcelRequire("jAiH0");
function $74d62eff4e930ae1$export$fbd92bb7dbbe27f7({ isCondensed: isCondensed, data: data }) {
    const transformedData = (data || []).map((item)=>({
            ...item,
            debtToTotalAssetsComputed: item.debtToTotalAssetsFromRemittanceReport != null ? item.debtToTotalAssetsFromRemittanceReport : item.grossDebtToAssets,
            debtToLiquidAssetsComputed: item.debtToLiquidAssetsFromRemittanceReport != null ? item.debtToLiquidAssetsFromRemittanceReport : item.grossDebtToLiquidAssets
        }));
    const filteredData = (0, $jAiH0.filterNullValuesFromChartData)(transformedData);
    if (filteredData.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Bq2gZ.Chart), {
        title: "Gross Debt to Assets",
        description: "Helps to evaluate whether a company's leverage is reasonable on a liquidation (assets) basis. Accomplishes this by showing debt to asset ratios including total assets, liquid assets and cash in a single chart with benchmarks. This chart is often used by portfolio managers overseeing a variety of asset-backed loan positions.",
        isCondensed: isCondensed,
        options: {
            data: filteredData,
            tooltip: {
                mode: "single"
            },
            series: [
                {
                    type: "line",
                    xKey: "month",
                    yKey: "debtToTotalAssetsComputed",
                    yName: "Debt to Total Assets",
                    marker: {
                        enabled: false
                    },
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            const ratioValue = datum.debtToTotalAssetsComputed;
                            return {
                                heading: `${month}`,
                                title: "Debt to Total Assets",
                                data: (0, $jAiH0.formatTooltipData)([
                                    {
                                        label: "Debt to Total Assets",
                                        value: `${ratioValue.toFixed(1)}x`
                                    },
                                    {
                                        label: "Debt Balance EOP",
                                        value: (0, $jAiH0.formatCurrency)(datum.debtBalanceEop)
                                    },
                                    {
                                        label: "Total Debt",
                                        value: (0, $jAiH0.formatCurrency)(datum.totalDebt)
                                    },
                                    {
                                        label: "Total Assets",
                                        value: (0, $jAiH0.formatCurrency)(datum.totalAssets)
                                    }
                                ])
                            };
                        }
                    }
                },
                {
                    type: "line",
                    xKey: "month",
                    yKey: "debtToLiquidAssetsComputed",
                    yName: "Debt to Liquid Assets",
                    marker: {
                        enabled: false
                    },
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            const ratioValue = datum.debtToLiquidAssetsComputed;
                            return {
                                heading: `${month}`,
                                title: "Debt to Liquid Assets",
                                data: (0, $jAiH0.formatTooltipData)([
                                    {
                                        label: "Debt to Liquid Assets",
                                        value: `${ratioValue.toFixed(1)}x`
                                    },
                                    {
                                        label: "Debt Balance EOP",
                                        value: (0, $jAiH0.formatCurrency)(datum.debtBalanceEop)
                                    },
                                    {
                                        label: "Total Debt",
                                        value: (0, $jAiH0.formatCurrency)(datum.totalDebt)
                                    },
                                    {
                                        label: "Liquid Assets",
                                        value: (0, $jAiH0.formatCurrency)(datum.liquidAssets)
                                    }
                                ])
                            };
                        }
                    }
                }
            ],
            axes: [
                (0, $cLcpc.GroupedCategoryAxis).doubleDepth,
                {
                    type: "number",
                    position: "right",
                    label: {
                        formatter: (params)=>{
                            return `${params.value.toFixed(1)}x`;
                        }
                    },
                    keys: [
                        "debtToTotalAssetsComputed",
                        "debtToLiquidAssetsComputed"
                    ]
                }
            ]
        }
    });
}

});

parcelRegister("laIQq", function(module, exports) {

$parcel$export(module.exports, "DebtToCashflows", () => $4b50aefde1124aef$export$fd2b781558f95325);

var $ayMG0 = parcelRequire("ayMG0");

var $Bq2gZ = parcelRequire("Bq2gZ");

var $cLcpc = parcelRequire("cLcpc");

var $jAiH0 = parcelRequire("jAiH0");
function $4b50aefde1124aef$export$fd2b781558f95325({ isCondensed: isCondensed, data: data }) {
    const transformedData = (data || []).map((item)=>({
            ...item,
            netDebtToEbitdaComputed: item.netDebtToEbitdaFromRemittanceReport != null ? item.netDebtToEbitdaFromRemittanceReport : item.netDebtToEbitda,
            netDebtToPreMarketingEbitdaComputed: item.netDebtToPreMarketingEbitdaFromRemittanceReport != null ? item.netDebtToPreMarketingEbitdaFromRemittanceReport : item.netDebtToPreMarketingEbitda,
            netDebtToRevenueComputed: item.netDebtToRevenueFromRemittanceReport != null ? item.netDebtToRevenueFromRemittanceReport : item.netDebtToRevenue
        }));
    const filteredData = (0, $jAiH0.filterNullValuesFromChartData)(transformedData);
    if (filteredData.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Bq2gZ.Chart), {
        title: "Debt to Cashflows",
        description: "Exceptionally high and volatile net debt to EBITDA and net debt to revenue ratios, combined with frequent negative EBITDA, indicate an unsustainable leverage profile and elevated credit risk.",
        isCondensed: isCondensed,
        options: {
            data: filteredData,
            tooltip: {
                mode: "single"
            },
            series: [
                {
                    type: "line",
                    xKey: "month",
                    yKey: "netDebtToEbitdaComputed",
                    yName: "Net Debt to EBITDA",
                    marker: {
                        enabled: false
                    },
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            const ratioValue = datum.netDebtToEbitdaComputed;
                            return {
                                heading: `${month}`,
                                title: "Net Debt to EBITDA",
                                data: (0, $jAiH0.formatTooltipData)([
                                    {
                                        label: "Net Debt to EBITDA",
                                        value: ratioValue === Infinity ? "\u221E" : ratioValue === -Infinity ? "-\u221E" : `${ratioValue.toFixed(1)}x`
                                    },
                                    {
                                        label: "Debt Balance EOP",
                                        value: (0, $jAiH0.formatCurrency)(datum.debtBalanceEop)
                                    },
                                    {
                                        label: "Total Debt",
                                        value: (0, $jAiH0.formatCurrency)(datum.totalDebt)
                                    },
                                    {
                                        label: "Cash",
                                        value: (0, $jAiH0.formatCurrency)(datum.cash)
                                    },
                                    {
                                        label: "EBITDA",
                                        value: (0, $jAiH0.formatCurrency)(datum.ebitda)
                                    }
                                ])
                            };
                        }
                    }
                },
                {
                    type: "line",
                    xKey: "month",
                    yKey: "netDebtToPreMarketingEbitdaComputed",
                    yName: "Net Debt to Pre-Marketing EBITDA",
                    marker: {
                        enabled: false
                    },
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            const ratioValue = datum.netDebtToPreMarketingEbitdaComputed;
                            return {
                                heading: `${month}`,
                                title: "Net Debt to Pre-Marketing EBITDA",
                                data: (0, $jAiH0.formatTooltipData)([
                                    {
                                        label: "Net Debt to Pre-Marketing EBITDA",
                                        value: ratioValue === Infinity ? "\u221E" : ratioValue === -Infinity ? "-\u221E" : `${ratioValue.toFixed(1)}x`
                                    },
                                    {
                                        label: "Debt Balance EOP",
                                        value: (0, $jAiH0.formatCurrency)(datum.debtBalanceEop)
                                    },
                                    {
                                        label: "Total Debt",
                                        value: (0, $jAiH0.formatCurrency)(datum.totalDebt)
                                    },
                                    {
                                        label: "Cash",
                                        value: (0, $jAiH0.formatCurrency)(datum.cash)
                                    },
                                    {
                                        label: "Pre-Marketing EBITDA",
                                        value: (0, $jAiH0.formatCurrency)(datum.preMarketingEbitda)
                                    }
                                ])
                            };
                        }
                    }
                },
                {
                    type: "line",
                    xKey: "month",
                    yKey: "netDebtToRevenueComputed",
                    yName: "Net Debt to Revenue",
                    marker: {
                        enabled: false
                    },
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            const ratioValue = datum.netDebtToRevenueComputed;
                            return {
                                heading: `${month}`,
                                title: "Net Debt to Revenue",
                                data: (0, $jAiH0.formatTooltipData)([
                                    {
                                        label: "Net Debt to Revenue",
                                        value: ratioValue === Infinity ? "\u221E" : ratioValue === -Infinity ? "-\u221E" : `${ratioValue.toFixed(1)}x`
                                    },
                                    {
                                        label: "Debt Balance EOP",
                                        value: (0, $jAiH0.formatCurrency)(datum.debtBalanceEop)
                                    },
                                    {
                                        label: "Total Debt",
                                        value: (0, $jAiH0.formatCurrency)(datum.totalDebt)
                                    },
                                    {
                                        label: "Cash",
                                        value: (0, $jAiH0.formatCurrency)(datum.cash)
                                    },
                                    {
                                        label: "Total Revenue",
                                        value: (0, $jAiH0.formatCurrency)(datum.totalRevenue)
                                    }
                                ])
                            };
                        }
                    }
                }
            ],
            axes: [
                (0, $cLcpc.GroupedCategoryAxis).doubleDepth,
                {
                    type: "number",
                    position: "right",
                    label: {
                        formatter: (params)=>{
                            if (params.value === Infinity) return "\u221E";
                            if (params.value === -Infinity) return "-\u221E";
                            return `${params.value.toFixed(1)}x`;
                        }
                    },
                    keys: [
                        "netDebtToEbitdaComputed",
                        "netDebtToPreMarketingEbitdaComputed",
                        "netDebtToRevenueComputed"
                    ]
                }
            ]
        }
    });
}

});

parcelRegister("gNbCT", function(module, exports) {

$parcel$export(module.exports, "Liquidity", () => $f718a2bad9677ca7$export$7394e3641033834d);

var $ayMG0 = parcelRequire("ayMG0");

var $Bq2gZ = parcelRequire("Bq2gZ");

var $cLcpc = parcelRequire("cLcpc");

var $jAiH0 = parcelRequire("jAiH0");

var $5CWLf = parcelRequire("5CWLf");

var $dfZUs = parcelRequire("dfZUs");
function $f718a2bad9677ca7$export$7394e3641033834d({ isCondensed: isCondensed, data: data }) {
    const { selectedPeriod: selectedPeriod, periodFilterProps: periodFilterProps } = (0, $dfZUs.usePeriodFilter)("monthly");
    const aggregatedData = (0, $5CWLf.aggregateChartData)(data || [], selectedPeriod.value, "liquidity");
    const filteredData = (0, $jAiH0.filterNullValuesFromChartData)(aggregatedData);
    if (filteredData.length === 0) return null;
    const getMaxValue = (data, keys)=>{
        let max = 0;
        data.forEach((item)=>{
            keys.forEach((key)=>{
                if (item[key] !== null && item[key] !== undefined && item[key] !== Infinity) max = Math.max(max, Math.abs(item[key]));
            });
        });
        return max;
    };
    const getDecimalPlaces = (maxValue)=>{
        if (maxValue >= 1) return 0;
        if (maxValue >= 0.1) return 1;
        if (maxValue >= 0.01) return 2;
        if (maxValue >= 0.001) return 3;
        if (maxValue >= 0.0001) return 4;
        return 5;
    };
    const yAxisKeys = [
        "runway",
        "quickRatio",
        "currentRatio",
        "cashRatio"
    ];
    const maxValue = getMaxValue(filteredData, yAxisKeys);
    const decimalPlaces = getDecimalPlaces(maxValue);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Bq2gZ.Chart), {
        title: "Liquidity",
        description: "Despite healthy liquid asset levels, persistent low current, quick, and cash ratios well below 1, frequent negative net income, and runway volatility indicate chronic liquidity stress and a high risk profile.",
        isCondensed: isCondensed,
        periodFilter: periodFilterProps,
        options: {
            data: filteredData,
            tooltip: {
                mode: "single"
            },
            series: [
                {
                    type: "line",
                    xKey: "month",
                    yKey: "runway",
                    yName: "Runway (Months)",
                    marker: {
                        enabled: false
                    },
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            const runwayValue = datum.runway === Infinity ? "\u221E" : datum.runway.toFixed(1);
                            return {
                                heading: `${month}`,
                                title: "Runway (Months)",
                                data: [
                                    {
                                        label: "Runway (Months)",
                                        value: `${runwayValue} months`
                                    },
                                    {
                                        label: "Liquid Assets",
                                        value: (0, $jAiH0.formatCurrency)(datum.liquidAssets)
                                    },
                                    {
                                        label: "Total Current Liabilities",
                                        value: (0, $jAiH0.formatCurrency)(datum.totalCurrentLiabilities)
                                    },
                                    {
                                        label: "Cash",
                                        value: (0, $jAiH0.formatCurrency)(datum.cash)
                                    },
                                    {
                                        label: "Total Revenue",
                                        value: (0, $jAiH0.formatCurrency)(datum.totalRevenue)
                                    },
                                    {
                                        label: "Total Expenses",
                                        value: (0, $jAiH0.formatCurrency)(datum.totalExpenses)
                                    },
                                    {
                                        label: "EBITDA",
                                        value: (0, $jAiH0.formatCurrency)(datum.ebitda)
                                    },
                                    {
                                        label: "Net Income",
                                        value: (0, $jAiH0.formatCurrency)(datum.netIncome)
                                    }
                                ]
                            };
                        }
                    }
                },
                {
                    type: "line",
                    xKey: "month",
                    yKey: "quickRatio",
                    yName: "Quick Ratio",
                    marker: {
                        enabled: false
                    },
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            return {
                                heading: `${month}`,
                                title: "Quick Ratio",
                                data: [
                                    {
                                        label: "Quick Ratio",
                                        value: `${datum.quickRatio.toFixed(2)}`
                                    },
                                    {
                                        label: "Current Assets",
                                        value: `$${datum.currentAssets.toLocaleString()}`
                                    },
                                    {
                                        label: "Current Assets Net Inventory",
                                        value: `$${datum.currentAssetsNetInventory.toLocaleString()}`
                                    },
                                    {
                                        label: "Total Current Liabilities",
                                        value: `$${datum.totalCurrentLiabilities.toLocaleString()}`
                                    }
                                ]
                            };
                        }
                    }
                },
                {
                    type: "line",
                    xKey: "month",
                    yKey: "currentRatio",
                    yName: "Current Ratio",
                    marker: {
                        enabled: false
                    },
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            return {
                                heading: `${month}`,
                                title: "Current Ratio",
                                data: [
                                    {
                                        label: "Current Ratio",
                                        value: `${datum.currentRatio.toFixed(2)}`
                                    },
                                    {
                                        label: "Current Assets",
                                        value: `$${datum.currentAssets.toLocaleString()}`
                                    },
                                    {
                                        label: "Total Current Liabilities",
                                        value: `$${datum.totalCurrentLiabilities.toLocaleString()}`
                                    }
                                ]
                            };
                        }
                    }
                },
                {
                    type: "line",
                    xKey: "month",
                    yKey: "cashRatio",
                    yName: "Cash Ratio",
                    marker: {
                        enabled: false
                    },
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            return {
                                heading: `${month}`,
                                title: "Cash Ratio",
                                data: [
                                    {
                                        label: "Cash Ratio",
                                        value: `${datum.cashRatio.toFixed(2)}`
                                    },
                                    {
                                        label: "Cash",
                                        value: `$${datum.cash.toLocaleString()}`
                                    },
                                    {
                                        label: "Total Current Liabilities",
                                        value: `$${datum.totalCurrentLiabilities.toLocaleString()}`
                                    }
                                ]
                            };
                        }
                    }
                }
            ],
            axes: [
                (0, $cLcpc.GroupedCategoryAxis).doubleDepth,
                {
                    type: "number",
                    position: "right",
                    min: 0,
                    label: {
                        formatter: (params)=>{
                            if (params.value === Infinity) return "\u221E";
                            if (params.value >= 1000) {
                                const kValue = params.value / 1000;
                                return `${kValue.toFixed(decimalPlaces)}K`;
                            }
                            return params.value.toFixed(decimalPlaces);
                        }
                    },
                    keys: yAxisKeys
                }
            ]
        }
    });
}

});

parcelRegister("3Xj54", function(module, exports) {

$parcel$export(module.exports, "DisbursementsAndRepayments", () => $16ed688d00e2d854$export$63cdac7ebb585bd5);

var $ayMG0 = parcelRequire("ayMG0");

var $Bq2gZ = parcelRequire("Bq2gZ");

var $cLcpc = parcelRequire("cLcpc");

var $jAiH0 = parcelRequire("jAiH0");
function $16ed688d00e2d854$export$63cdac7ebb585bd5({ isCondensed: isCondensed, data: data }) {
    const filteredData = (0, $jAiH0.filterNullValuesFromChartData)(data || []);
    if (filteredData.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Bq2gZ.Chart), {
        title: "Disbursements and Cash Repayments",
        description: "Following significant debt disbursements, the company has generally met recurring interest and amortization payments, but reliance on new large financings and irregular repayments reflect material refinancing and liquidity risk.",
        isCondensed: isCondensed,
        options: {
            data: filteredData,
            tooltip: {
                mode: "single"
            },
            series: [
                {
                    type: "bar",
                    xKey: "month",
                    yKey: "disbursement",
                    yName: "Disbursement (Remittance Report)",
                    stacked: true,
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            return {
                                heading: `${month}`,
                                title: "Disbursement (Remittance Report)",
                                data: (0, $jAiH0.formatTooltipData)([
                                    {
                                        label: "Disbursement",
                                        value: (0, $jAiH0.formatCurrency)(datum.disbursement)
                                    }
                                ])
                            };
                        }
                    }
                },
                {
                    type: "bar",
                    xKey: "month",
                    yKey: "amortization",
                    yName: "Amortization (Remittance Report)",
                    stacked: true,
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            return {
                                heading: `${month}`,
                                title: "Amortization",
                                data: (0, $jAiH0.formatTooltipData)([
                                    {
                                        label: "Amortization",
                                        value: (0, $jAiH0.formatCurrency)(datum.amortization)
                                    }
                                ])
                            };
                        }
                    }
                },
                {
                    type: "bar",
                    xKey: "month",
                    yKey: "interestAndFeesCash",
                    yName: "The Cash Portion of Interest and Fees (Remittance Report)",
                    stacked: true,
                    tooltip: {
                        renderer: (params)=>{
                            const datum = params.datum;
                            const month = `${datum.month[1]} ${datum.month[0]}`;
                            return {
                                heading: `${month}`,
                                title: "Interest and Fees Cash",
                                data: (0, $jAiH0.formatTooltipData)([
                                    {
                                        label: "Interest & Fees Cash",
                                        value: (0, $jAiH0.formatCurrency)(datum.interestAndFeesCash)
                                    }
                                ])
                            };
                        }
                    }
                }
            ],
            axes: [
                (0, $cLcpc.GroupedCategoryAxis).doubleDepth,
                {
                    ...(0, $cLcpc.MoneyAxis),
                    keys: [
                        "disbursement",
                        "amortization",
                        "interestAndFeesCash"
                    ]
                }
            ]
        }
    });
}

});




parcelRegister("2xY7I", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7d2173b98c4ba8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("jUSgZ");
var $3fKr5 = parcelRequire("3fKr5");

var $aphAM = parcelRequire("aphAM");
parcelRequire("18L7n");
var $4oMrS = parcelRequire("4oMrS");
parcelRequire("jLMBL");
var $7JXNE = parcelRequire("7JXNE");

var $cM7aN = parcelRequire("cM7aN");
(0, $cM7aN.LicenseManager).setLicenseKey("[TRIAL]_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-087313}_is_granted_for_evaluation_only___Use_in_production_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_purchasing_a_production_key_please_contact_info@ag-grid.com___You_are_granted_a_{Single_Application}_Developer_License_for_one_application_only___All_Front-End_JavaScript_developers_working_on_the_application_would_need_to_be_licensed___This_key_will_deactivate_on_{30 June 2025}____[v3]_[0102]_MTc1MTIzODAwMDAwMA==bab99475ed6430aef766ca806f8a0647");
function $2c7d2173b98c4ba8$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7JXNE.NavigationProvider), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Routes), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fKr5.default), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "*",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4oMrS.NotFoundPage), {})
                })
            ]
        })
    });
}

});
parcelRegister("cM7aN", function(module, exports) {

$parcel$export(module.exports, "LicenseManager", () => $2fb96651e8aa1522$export$91e2bbffdbb3852c);

var $iTJTu = parcelRequire("iTJTu");

var $idDdm = parcelRequire("idDdm");
var $2fb96651e8aa1522$var$__defProp = Object.defineProperty;
var $2fb96651e8aa1522$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $2fb96651e8aa1522$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $2fb96651e8aa1522$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $2fb96651e8aa1522$var$__defProp(target, key, result);
    return result;
};
// packages/ag-charts-enterprise/src/license/md5.ts
var $2fb96651e8aa1522$var$MD5 = class {
    constructor(){
        this.ieCompatibility = false;
    }
    init() {
        this.ieCompatibility = this.md5("hello") != "5d41402abc4b2a76b9719d911017c592";
    }
    md5cycle(x, k) {
        let a = x[0], b = x[1], c = x[2], d = x[3];
        a = this.ff(a, b, c, d, k[0], 7, -680876936);
        d = this.ff(d, a, b, c, k[1], 12, -389564586);
        c = this.ff(c, d, a, b, k[2], 17, 606105819);
        b = this.ff(b, c, d, a, k[3], 22, -1044525330);
        a = this.ff(a, b, c, d, k[4], 7, -176418897);
        d = this.ff(d, a, b, c, k[5], 12, 1200080426);
        c = this.ff(c, d, a, b, k[6], 17, -1473231341);
        b = this.ff(b, c, d, a, k[7], 22, -45705983);
        a = this.ff(a, b, c, d, k[8], 7, 1770035416);
        d = this.ff(d, a, b, c, k[9], 12, -1958414417);
        c = this.ff(c, d, a, b, k[10], 17, -42063);
        b = this.ff(b, c, d, a, k[11], 22, -1990404162);
        a = this.ff(a, b, c, d, k[12], 7, 1804603682);
        d = this.ff(d, a, b, c, k[13], 12, -40341101);
        c = this.ff(c, d, a, b, k[14], 17, -1502002290);
        b = this.ff(b, c, d, a, k[15], 22, 1236535329);
        a = this.gg(a, b, c, d, k[1], 5, -165796510);
        d = this.gg(d, a, b, c, k[6], 9, -1069501632);
        c = this.gg(c, d, a, b, k[11], 14, 643717713);
        b = this.gg(b, c, d, a, k[0], 20, -373897302);
        a = this.gg(a, b, c, d, k[5], 5, -701558691);
        d = this.gg(d, a, b, c, k[10], 9, 38016083);
        c = this.gg(c, d, a, b, k[15], 14, -660478335);
        b = this.gg(b, c, d, a, k[4], 20, -405537848);
        a = this.gg(a, b, c, d, k[9], 5, 568446438);
        d = this.gg(d, a, b, c, k[14], 9, -1019803690);
        c = this.gg(c, d, a, b, k[3], 14, -187363961);
        b = this.gg(b, c, d, a, k[8], 20, 1163531501);
        a = this.gg(a, b, c, d, k[13], 5, -1444681467);
        d = this.gg(d, a, b, c, k[2], 9, -51403784);
        c = this.gg(c, d, a, b, k[7], 14, 1735328473);
        b = this.gg(b, c, d, a, k[12], 20, -1926607734);
        a = this.hh(a, b, c, d, k[5], 4, -378558);
        d = this.hh(d, a, b, c, k[8], 11, -2022574463);
        c = this.hh(c, d, a, b, k[11], 16, 1839030562);
        b = this.hh(b, c, d, a, k[14], 23, -35309556);
        a = this.hh(a, b, c, d, k[1], 4, -1530992060);
        d = this.hh(d, a, b, c, k[4], 11, 1272893353);
        c = this.hh(c, d, a, b, k[7], 16, -155497632);
        b = this.hh(b, c, d, a, k[10], 23, -1094730640);
        a = this.hh(a, b, c, d, k[13], 4, 681279174);
        d = this.hh(d, a, b, c, k[0], 11, -358537222);
        c = this.hh(c, d, a, b, k[3], 16, -722521979);
        b = this.hh(b, c, d, a, k[6], 23, 76029189);
        a = this.hh(a, b, c, d, k[9], 4, -640364487);
        d = this.hh(d, a, b, c, k[12], 11, -421815835);
        c = this.hh(c, d, a, b, k[15], 16, 530742520);
        b = this.hh(b, c, d, a, k[2], 23, -995338651);
        a = this.ii(a, b, c, d, k[0], 6, -198630844);
        d = this.ii(d, a, b, c, k[7], 10, 1126891415);
        c = this.ii(c, d, a, b, k[14], 15, -1416354905);
        b = this.ii(b, c, d, a, k[5], 21, -57434055);
        a = this.ii(a, b, c, d, k[12], 6, 1700485571);
        d = this.ii(d, a, b, c, k[3], 10, -1894986606);
        c = this.ii(c, d, a, b, k[10], 15, -1051523);
        b = this.ii(b, c, d, a, k[1], 21, -2054922799);
        a = this.ii(a, b, c, d, k[8], 6, 1873313359);
        d = this.ii(d, a, b, c, k[15], 10, -30611744);
        c = this.ii(c, d, a, b, k[6], 15, -1560198380);
        b = this.ii(b, c, d, a, k[13], 21, 1309151649);
        a = this.ii(a, b, c, d, k[4], 6, -145523070);
        d = this.ii(d, a, b, c, k[11], 10, -1120210379);
        c = this.ii(c, d, a, b, k[2], 15, 718787259);
        b = this.ii(b, c, d, a, k[9], 21, -343485551);
        x[0] = this.add32(a, x[0]);
        x[1] = this.add32(b, x[1]);
        x[2] = this.add32(c, x[2]);
        x[3] = this.add32(d, x[3]);
    }
    cmn(q, a, b, x, s, t) {
        a = this.add32(this.add32(a, q), this.add32(x, t));
        return this.add32(a << s | a >>> 32 - s, b);
    }
    ff(a, b, c, d, x, s, t) {
        return this.cmn(b & c | ~b & d, a, b, x, s, t);
    }
    gg(a, b, c, d, x, s, t) {
        return this.cmn(b & d | c & ~d, a, b, x, s, t);
    }
    hh(a, b, c, d, x, s, t) {
        return this.cmn(b ^ c ^ d, a, b, x, s, t);
    }
    ii(a, b, c, d, x, s, t) {
        return this.cmn(c ^ (b | ~d), a, b, x, s, t);
    }
    md51(s) {
        const n = s.length;
        const state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        let i;
        for(i = 64; i <= s.length; i += 64)this.md5cycle(state, this.md5blk(s.substring(i - 64, i)));
        s = s.substring(i - 64);
        const tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < s.length; i++)tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
        tail[i >> 2] |= 128 << (i % 4 << 3);
        if (i > 55) {
            this.md5cycle(state, tail);
            for(i = 0; i < 16; i++)tail[i] = 0;
        }
        tail[14] = n * 8;
        this.md5cycle(state, tail);
        return state;
    }
    /* there needs to be support for Unicode here, * unless we pretend that we can redefine the MD-5
   * algorithm for multi-byte characters (perhaps by adding every four 16-bit characters and
   * shortening the sum to 32 bits). Otherwise I suthis.ggest performing MD-5 as if every character
   * was two bytes--e.g., 0040 0025 = @%--but then how will an ordinary MD-5 sum be matched?
   * There is no way to standardize text to something like UTF-8 before transformation; speed cost is
   * utterly prohibitive. The JavaScript standard itself needs to look at this: it should start
   * providing access to strings as preformed UTF-8 8-bit unsigned value arrays.
   */ md5blk(s) {
        const md5blks = [];
        for(let i = 0; i < 64; i += 4)md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
        return md5blks;
    }
    rhex(n) {
        const hex_chr = "0123456789abcdef".split("");
        let s = "", j = 0;
        for(; j < 4; j++)s += hex_chr[n >> j * 8 + 4 & 15] + hex_chr[n >> j * 8 & 15];
        return s;
    }
    hex(x) {
        for(let i = 0; i < x.length; i++)x[i] = this.rhex(x[i]);
        return x.join("");
    }
    md5(s) {
        return this.hex(this.md51(s));
    }
    add32(a, b) {
        return this.ieCompatibility ? this.add32Compat(a, b) : this.add32Std(a, b);
    }
    /* this function is much faster, so if possible we use it. Some IEs are the only ones I know of that
   need the idiotic second function, generated by an if clause.  */ add32Std(a, b) {
        return a + b & 4294967295;
    }
    add32Compat(x, y) {
        const lsw = (x & 65535) + (y & 65535), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 65535;
    }
};
// packages/ag-charts-enterprise/src/license/licenseManager.ts
function $2fb96651e8aa1522$var$missingOrEmpty(value) {
    return value == null || value.length === 0;
}
var $2fb96651e8aa1522$var$LICENSE_TYPES = {
    "01": "GRID",
    "02": "CHARTS",
    "0102": "BOTH"
};
var $2fb96651e8aa1522$var$LICENSING_HELP_URL = "https://www.ag-grid.com/charts/licensing/";
var $2fb96651e8aa1522$var$_LicenseManager = class _LicenseManager {
    constructor(document2){
        this.watermarkMessage = void 0;
        this.totalMessageLength = 124;
        this.document = document2;
        this.md5 = new $2fb96651e8aa1522$var$MD5();
        this.md5.init();
    }
    validateLicense() {
        const licenseDetails = this.getLicenseDetails(_LicenseManager.licenseKey, _LicenseManager.gridContext);
        const currentLicenseName = `AG ${licenseDetails.currentLicenseType === "BOTH" ? "Grid and " : ""}Charts Enterprise`;
        let suppliedLicenseName = "";
        if (licenseDetails.suppliedLicenseType === "BOTH") suppliedLicenseName = "AG Grid and AG Charts Enterprise";
        else if (licenseDetails.suppliedLicenseType === "GRID") suppliedLicenseName = "AG Grid Enterprise";
        else if (licenseDetails.suppliedLicenseType !== void 0) suppliedLicenseName = "AG Charts Enterprise";
        if (licenseDetails.missing) {
            if (!this.isWebsiteUrl() || this.isForceWatermark()) this.outputMissingLicenseKey(currentLicenseName);
        } else if (licenseDetails.expired) {
            const gridReleaseDate = _LicenseManager.getChartsReleaseDate();
            const formattedReleaseDate = _LicenseManager.formatDate(gridReleaseDate);
            this.outputExpiredKey(licenseDetails.expiry, formattedReleaseDate, suppliedLicenseName);
        } else if (!licenseDetails.valid) this.outputInvalidLicenseKey(!!licenseDetails.incorrectLicenseType, currentLicenseName, suppliedLicenseName);
        else if (licenseDetails.isTrial && licenseDetails.trialExpired) this.outputExpiredTrialKey(licenseDetails.expiry, currentLicenseName, suppliedLicenseName);
    }
    static extractExpiry(license) {
        const restrictionHashed = license.substring(license.lastIndexOf("_") + 1, license.length);
        return new Date(parseInt(_LicenseManager.decode(restrictionHashed), 10));
    }
    static extractLicenseComponents(licenseKey) {
        let cleanedLicenseKey = licenseKey.replace(/[\u200B-\u200D\uFEFF]/g, "");
        cleanedLicenseKey = cleanedLicenseKey.replace(/\r?\n|\r/g, "");
        if (licenseKey.length <= 32) return {
            md5: null,
            license: licenseKey,
            version: null,
            isTrial: null
        };
        const hashStart = cleanedLicenseKey.length - 32;
        const md5 = cleanedLicenseKey.substring(hashStart);
        const license = cleanedLicenseKey.substring(0, hashStart);
        const [version, isTrial, type] = _LicenseManager.extractBracketedInformation(cleanedLicenseKey);
        return {
            md5: md5,
            license: license,
            version: version,
            isTrial: isTrial,
            type: type
        };
    }
    getLicenseDetails(licenseKey, gridContext = false) {
        const currentLicenseType = "CHARTS";
        if ($2fb96651e8aa1522$var$missingOrEmpty(licenseKey)) return {
            licenseKey: licenseKey,
            valid: false,
            missing: true,
            currentLicenseType: currentLicenseType
        };
        const chartsReleaseDate = _LicenseManager.getChartsReleaseDate();
        const { md5: md5, license: license, version: version, isTrial: isTrial, type: type } = _LicenseManager.extractLicenseComponents(licenseKey);
        let valid = md5 === this.md5.md5(license) && licenseKey.indexOf("For_Trialing_ag-Grid_Only") === -1;
        let trialExpired = void 0;
        let expired = void 0;
        let expiry = null;
        let incorrectLicenseType = false;
        let suppliedLicenseType = void 0;
        function handleTrial() {
            const now = /* @__PURE__ */ new Date();
            trialExpired = expiry < now;
            expired = void 0;
        }
        if (valid) {
            expiry = _LicenseManager.extractExpiry(license);
            valid = !isNaN(expiry.getTime());
            if (valid) {
                expired = chartsReleaseDate > expiry;
                switch(version){
                    case "legacy":
                    case "2":
                        valid = false;
                        break;
                    case "3":
                        if ($2fb96651e8aa1522$var$missingOrEmpty(type)) valid = false;
                        else {
                            suppliedLicenseType = type;
                            if (type !== $2fb96651e8aa1522$var$LICENSE_TYPES["02"] && type !== $2fb96651e8aa1522$var$LICENSE_TYPES["0102"]) {
                                valid = false;
                                incorrectLicenseType = true;
                            } else if (isTrial) handleTrial();
                        }
                }
            }
        }
        if (!valid) return {
            licenseKey: licenseKey,
            valid: valid,
            incorrectLicenseType: incorrectLicenseType,
            currentLicenseType: currentLicenseType,
            suppliedLicenseType: suppliedLicenseType
        };
        return {
            licenseKey: licenseKey,
            valid: valid,
            expiry: _LicenseManager.formatDate(expiry),
            expired: expired,
            version: version,
            isTrial: isTrial,
            trialExpired: trialExpired,
            invalidLicenseTypeForCombo: gridContext ? suppliedLicenseType !== "BOTH" : void 0,
            incorrectLicenseType: incorrectLicenseType,
            currentLicenseType: currentLicenseType,
            suppliedLicenseType: suppliedLicenseType
        };
    }
    isDisplayWatermark() {
        return this.isForceWatermark() || !this.isLocalhost() && !this.isE2ETest() && !this.isWebsiteUrl() && !$2fb96651e8aa1522$var$missingOrEmpty(this.watermarkMessage);
    }
    getWatermarkMessage() {
        return this.watermarkMessage ?? "";
    }
    getHostname() {
        if (!this.document) return "localhost";
        const win = this.document.defaultView ?? window;
        if (!win) return "localhost";
        const loc = win.location;
        const { hostname: hostname = "" } = loc;
        return hostname;
    }
    isForceWatermark() {
        if (!this.document) return false;
        const win = this.document?.defaultView ?? typeof window != "undefined" ? window : void 0;
        if (!win) return false;
        const { pathname: pathname } = win.location;
        return pathname ? pathname.indexOf("forceWatermark") !== -1 : false;
    }
    isWebsiteUrl() {
        const hostname = this.getHostname();
        return /^((?:[\w-]+\.)?ag-grid\.com)$/.exec(hostname) !== null;
    }
    isLocalhost() {
        const hostname = this.getHostname();
        return /^(?:127\.0\.0\.1|localhost)$/.exec(hostname) !== null;
    }
    isE2ETest() {
        const hostname = this.getHostname();
        return /^(?:172\.17\.0\.1|host\.docker\.internal)$/.exec(hostname) !== null;
    }
    static formatDate(date) {
        const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();
        return day + " " + monthNames[monthIndex] + " " + year;
    }
    static getChartsReleaseDate() {
        return new Date(parseInt(_LicenseManager.decode(_LicenseManager.RELEASE_INFORMATION), 10));
    }
    static decode(input) {
        const keystr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        let t = "";
        let n, r, i;
        let s, o, u, a;
        let f = 0;
        const e = input.replace(/[^A-Za-z0-9+/=]/g, "");
        while(f < e.length){
            s = keystr.indexOf(e.charAt(f++));
            o = keystr.indexOf(e.charAt(f++));
            u = keystr.indexOf(e.charAt(f++));
            a = keystr.indexOf(e.charAt(f++));
            n = s << 2 | o >> 4;
            r = (o & 15) << 4 | u >> 2;
            i = (u & 3) << 6 | a;
            t = t + String.fromCharCode(n);
            if (u != 64) t = t + String.fromCharCode(r);
            if (a != 64) t = t + String.fromCharCode(i);
        }
        t = _LicenseManager.utf8_decode(t);
        return t;
    }
    static utf8_decode(input) {
        input = input.replace(/rn/g, "n");
        let t = "";
        for(let n = 0; n < input.length; n++){
            const r = input.charCodeAt(n);
            if (r < 128) t += String.fromCharCode(r);
            else if (r > 127 && r < 2048) {
                t += String.fromCharCode(r >> 6 | 192);
                t += String.fromCharCode(r & 63 | 128);
            } else {
                t += String.fromCharCode(r >> 12 | 224);
                t += String.fromCharCode(r >> 6 & 63 | 128);
                t += String.fromCharCode(r & 63 | 128);
            }
        }
        return t;
    }
    static setGridContext(gridContext = false) {
        _LicenseManager.gridContext = gridContext;
    }
    static setLicenseKey(licenseKey) {
        _LicenseManager.licenseKey = licenseKey;
    }
    static extractBracketedInformation(licenseKey) {
        if (!licenseKey.includes("[")) return [
            "legacy",
            false,
            void 0
        ];
        const matches = licenseKey.match(/\[(.*?)\]/g).map((match)=>match.replace("[", "").replace("]", ""));
        if (!matches || matches.length === 0) return [
            "legacy",
            false,
            void 0
        ];
        const isTrial = matches.filter((match)=>match === "TRIAL").length === 1;
        const rawVersion = matches.filter((match)=>match.startsWith("v"))[0];
        const version = rawVersion ? rawVersion.replace("v", "") : "legacy";
        const type = $2fb96651e8aa1522$var$LICENSE_TYPES[matches.filter((match)=>$2fb96651e8aa1522$var$LICENSE_TYPES[match])[0]];
        return [
            version,
            isTrial,
            type
        ];
    }
    centerPadAndOutput(input) {
        const paddingRequired = this.totalMessageLength - input.length;
        console.error(input.padStart(paddingRequired / 2 + input.length, "*").padEnd(this.totalMessageLength, "*"));
    }
    padAndOutput(input, padding = "*", terminateWithPadding = "") {
        console.error(input.padEnd(this.totalMessageLength - terminateWithPadding.length, padding) + terminateWithPadding);
    }
    outputInvalidLicenseKey(incorrectLicenseType, currentLicenseName, suppliedLicenseName) {
        if (!_LicenseManager.gridContext) {
            if (incorrectLicenseType) {
                this.centerPadAndOutput("");
                this.centerPadAndOutput(` ${currentLicenseName} License `);
                this.centerPadAndOutput(" Incompatible License Key ");
                this.padAndOutput(`* Your license key is for ${suppliedLicenseName} only and does not cover you for ${currentLicenseName}.`, " ", "*");
                this.padAndOutput(`* To troubleshoot your license key visit ${$2fb96651e8aa1522$var$LICENSING_HELP_URL}.`, " ", "*");
                this.centerPadAndOutput("");
                this.centerPadAndOutput("");
            } else {
                this.centerPadAndOutput("");
                this.centerPadAndOutput(` ${currentLicenseName} License `);
                this.centerPadAndOutput(" Invalid License Key ");
                this.padAndOutput(`* Your license key is not valid.`, " ", "*");
                this.padAndOutput(`* To troubleshoot your license key visit ${$2fb96651e8aa1522$var$LICENSING_HELP_URL}.`, " ", "*");
                this.centerPadAndOutput("");
                this.centerPadAndOutput("");
            }
        }
        this.watermarkMessage = "Invalid License";
    }
    outputExpiredTrialKey(formattedExpiryDate, currentLicenseName, suppliedLicenseName) {
        if (!_LicenseManager.gridContext) {
            this.centerPadAndOutput("");
            this.centerPadAndOutput(` ${currentLicenseName} License `);
            this.centerPadAndOutput(" Trial Period Expired. ");
            this.padAndOutput(`* Your trial only license for ${suppliedLicenseName} expired on ${formattedExpiryDate}.`, " ", "*");
            this.padAndOutput("* Please email info@ag-grid.com to purchase a license.", " ", "*");
            this.centerPadAndOutput("");
            this.centerPadAndOutput("");
        }
        this.watermarkMessage = "Trial Period Expired";
    }
    outputMissingLicenseKey(currentLicenseName) {
        if (!_LicenseManager.gridContext) {
            this.centerPadAndOutput("");
            this.centerPadAndOutput(` ${currentLicenseName} License `);
            this.centerPadAndOutput(" License Key Not Found ");
            this.padAndOutput(`* All ${currentLicenseName} features are unlocked for trial.`, " ", "*");
            this.padAndOutput("* If you want to hide the watermark please email info@ag-grid.com for a trial license key.", " ", "*");
            this.centerPadAndOutput("");
            this.centerPadAndOutput("");
        }
        this.watermarkMessage = "For Trial Use Only";
    }
    outputExpiredKey(formattedExpiryDate, formattedReleaseDate, currentLicenseName) {
        if (!_LicenseManager.gridContext) {
            this.centerPadAndOutput("");
            this.centerPadAndOutput(` ${currentLicenseName} License `);
            this.centerPadAndOutput(" Incompatible Software Version ");
            this.padAndOutput(`* Your license key works with versions of ${currentLicenseName} released before ${formattedExpiryDate}.`, " ", "*");
            this.padAndOutput(`* The version you are trying to use was released on ${formattedReleaseDate}.`, " ", "*");
            this.padAndOutput("* Please contact info@ag-grid.com to renew your license key.", " ", "*");
            this.centerPadAndOutput("");
            this.centerPadAndOutput("");
        }
        this.watermarkMessage = "License Expired";
    }
};
$2fb96651e8aa1522$var$_LicenseManager.RELEASE_INFORMATION = "MTc0OTAyMzU3MDQyNA==";
$2fb96651e8aa1522$var$_LicenseManager.gridContext = false;
var $2fb96651e8aa1522$var$LicenseManager = $2fb96651e8aa1522$var$_LicenseManager;
// packages/ag-charts-enterprise/src/utils/polar.ts
function $2fb96651e8aa1522$var$loopSymmetrically(items, step, iterator) {
    const loop = (start, end, loopStep, loopIterator)=>{
        let prev = items[0];
        for(let i = start; loopStep > 0 ? i <= end : i > end; i += loopStep){
            const curr = items[i];
            if (loopIterator(prev, curr)) return true;
            prev = curr;
        }
        return false;
    };
    const midIndex = Math.floor(items.length / 2);
    if (loop(step, midIndex, step, iterator)) return true;
    return loop(items.length - step, midIndex, -step, iterator);
}
var { AxisInterval: $2fb96651e8aa1522$var$AxisInterval, Property: $2fb96651e8aa1522$var$Property } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$AngleAxisInterval = class extends $2fb96651e8aa1522$var$AxisInterval {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property
], $2fb96651e8aa1522$var$AngleAxisInterval.prototype, "minSpacing", 2);
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection, Property: $2fb96651e8aa1522$var$Property2, Group: $2fb96651e8aa1522$var$Group } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$PolarCrossLineLabel = class extends $2fb96651e8aa1522$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.fontSize = 14;
        this.fontFamily = "Verdana, sans-serif";
        this.padding = 5;
        this.color = "rgba(87, 87, 87, 1)";
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLineLabel.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLineLabel.prototype, "text", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLineLabel.prototype, "fontStyle", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLineLabel.prototype, "fontWeight", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLineLabel.prototype, "fontSize", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLineLabel.prototype, "fontFamily", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLineLabel.prototype, "padding", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLineLabel.prototype, "color", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLineLabel.prototype, "parallel", 2);
var $2fb96651e8aa1522$var$PolarCrossLine = class extends $2fb96651e8aa1522$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.id = (0, $idDdm.createId)(this);
        this.defaultColorRange = [];
        this.shape = "polygon";
        this.label = new $2fb96651e8aa1522$var$PolarCrossLineLabel();
        this.scale = void 0;
        this.clippedRange = [
            -Infinity,
            Infinity
        ];
        this.gridLength = 0;
        this.sideFlag = -1;
        this.parallelFlipRotation = 0;
        this.regularFlipRotation = 0;
        this.direction = $2fb96651e8aa1522$var$ChartAxisDirection.Angle;
        this.axisInnerRadius = 0;
        this.axisOuterRadius = 0;
        this.lineGroup = new $2fb96651e8aa1522$var$Group({
            name: this.id
        });
        this.rangeGroup = new $2fb96651e8aa1522$var$Group({
            name: this.id
        });
        this.labelGroup = new $2fb96651e8aa1522$var$Group({
            name: this.id
        });
        this._isRange = void 0;
    }
    assignCrossLineGroup(isRange, crossLineRange) {
        if (isRange !== this._isRange) {
            if (isRange) this.rangeGroup.appendChild(crossLineRange);
            else this.lineGroup.appendChild(crossLineRange);
        }
        this._isRange = isRange;
    }
    setSectorNodeProps(node) {
        node.fill = this.fill;
        node.fillOpacity = this.fillOpacity ?? 1;
        node.stroke = this.stroke;
        node.strokeOpacity = this.strokeOpacity ?? 1;
        node.strokeWidth = this.strokeWidth ?? 1;
        node.lineDash = this.lineDash;
    }
    setLabelNodeProps(node, x, y, baseline, rotation) {
        const { label: label } = this;
        node.x = x;
        node.y = y;
        node.text = label.text;
        node.textAlign = "center";
        node.textBaseline = baseline;
        node.rotation = rotation;
        node.rotationCenterX = x;
        node.rotationCenterY = y;
        node.fill = label.color;
        node.fontFamily = label.fontFamily;
        node.fontSize = label.fontSize;
        node.fontStyle = label.fontStyle;
        node.visible = true;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLine.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLine.prototype, "type", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLine.prototype, "range", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLine.prototype, "value", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLine.prototype, "defaultColorRange", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLine.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLine.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLine.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLine.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLine.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLine.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLine.prototype, "shape", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property2
], $2fb96651e8aa1522$var$PolarCrossLine.prototype, "label", 2);
// packages/ag-charts-enterprise/src/axes/polar-crosslines/angleCrossLine.ts
var { ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection2, getCrossLineValue: $2fb96651e8aa1522$var$getCrossLineValue, validateCrossLineValue: $2fb96651e8aa1522$var$validateCrossLineValue, normalizeAngle360: $2fb96651e8aa1522$var$normalizeAngle360, Group: $2fb96651e8aa1522$var$Group2, Path: $2fb96651e8aa1522$var$Path, Sector: $2fb96651e8aa1522$var$Sector, RotatableText: $2fb96651e8aa1522$var$RotatableText, ContinuousScale: $2fb96651e8aa1522$var$ContinuousScale } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$AngleCrossLine = class extends $2fb96651e8aa1522$var$PolarCrossLine {
    constructor(){
        super();
        this.direction = $2fb96651e8aa1522$var$ChartAxisDirection2.Angle;
        this.polygonNode = new $2fb96651e8aa1522$var$Path();
        this.sectorNode = new $2fb96651e8aa1522$var$Sector();
        this.lineNode = new $2fb96651e8aa1522$var$Path();
        this.crossLineRange = new $2fb96651e8aa1522$var$Group2();
        this.labelNode = new $2fb96651e8aa1522$var$RotatableText();
        this.ticks = [];
        this.crossLineRange.append(this.polygonNode);
        this.crossLineRange.append(this.sectorNode);
        this.crossLineRange.append(this.lineNode);
        this.labelGroup.append(this.labelNode);
    }
    visibilityCheck() {
        if (!$2fb96651e8aa1522$var$ContinuousScale.is(this.scale)) return true;
        const [d0, d1] = this.scale.domain;
        const value = $2fb96651e8aa1522$var$getCrossLineValue(this);
        if ((0, $idDdm.isArray)(value)) {
            const [start, end] = value;
            return start >= d0 && start <= d1 && end >= start && end <= d1;
        } else return value >= d0 && value <= d1;
    }
    update(visible) {
        const { scale: scale } = this;
        if (!scale || !$2fb96651e8aa1522$var$validateCrossLineValue($2fb96651e8aa1522$var$getCrossLineValue(this), scale) || !this.visibilityCheck()) {
            this.rangeGroup.visible = false;
            this.lineGroup.visible = false;
            this.labelGroup.visible = false;
            return;
        }
        this.rangeGroup.visible = visible;
        this.lineGroup.visible = visible;
        this.labelGroup.visible = visible;
        this.updateLineNode(visible);
        this.updatePolygonNode(visible);
        this.updateSectorNode(visible);
        this.updateLabelNode(visible);
    }
    updateLineNode(visible) {
        const { scale: scale, type: type, value: value, lineNode: line } = this;
        if (!visible || type !== "line" || !scale) {
            line.visible = false;
            return;
        }
        const angle = scale.convert(value);
        if (isNaN(angle)) {
            line.visible = false;
            return;
        }
        const { axisInnerRadius: axisInnerRadius, axisOuterRadius: axisOuterRadius } = this;
        line.visible = true;
        line.stroke = this.stroke;
        line.strokeOpacity = this.strokeOpacity ?? 1;
        line.strokeWidth = this.strokeWidth ?? 1;
        line.fill = void 0;
        line.lineDash = this.lineDash;
        const x = axisOuterRadius * Math.cos(angle);
        const y = axisOuterRadius * Math.sin(angle);
        const x0 = axisInnerRadius * Math.cos(angle);
        const y0 = axisInnerRadius * Math.sin(angle);
        line.path.clear(true);
        line.path.moveTo(x0, y0);
        line.path.lineTo(x, y);
        this.assignCrossLineGroup(false, this.crossLineRange);
    }
    updatePolygonNode(visible) {
        const { polygonNode: polygon, range: range2, scale: scale, shape: shape, type: type, ticks: ticks } = this;
        if (!visible || type !== "range" || shape !== "polygon" || !scale || !range2) {
            polygon.visible = false;
            return;
        }
        const { axisInnerRadius: axisInnerRadius, axisOuterRadius: axisOuterRadius } = this;
        const startIndex = ticks.indexOf(range2[0]);
        const endIndex = ticks.indexOf(range2[1]);
        const stops = startIndex <= endIndex ? ticks.slice(startIndex, endIndex + 1) : ticks.slice(startIndex).concat(ticks.slice(0, endIndex + 1));
        const angles = stops.map((value)=>scale.convert(value));
        polygon.visible = true;
        this.setSectorNodeProps(polygon);
        const { path: path } = polygon;
        path.clear(true);
        angles.forEach((angle, index)=>{
            const x = axisOuterRadius * Math.cos(angle);
            const y = axisOuterRadius * Math.sin(angle);
            if (index === 0) path.moveTo(x, y);
            else path.lineTo(x, y);
        });
        if (axisInnerRadius === 0) path.lineTo(0, 0);
        else angles.slice().reverse().forEach((angle)=>{
            const x = axisInnerRadius * Math.cos(angle);
            const y = axisInnerRadius * Math.sin(angle);
            path.lineTo(x, y);
        });
        polygon.path.closePath();
        this.assignCrossLineGroup(true, this.crossLineRange);
    }
    updateSectorNode(visible) {
        const { sectorNode: sector, range: range2, scale: scale, shape: shape, type: type } = this;
        if (!visible || type !== "range" || shape !== "circle" || !scale || !range2) {
            sector.visible = false;
            return;
        }
        const { axisInnerRadius: axisInnerRadius, axisOuterRadius: axisOuterRadius } = this;
        const angles = range2.map((value)=>scale.convert(value));
        const step = scale.step ?? 0;
        const padding = scale instanceof (0, $iTJTu._ModuleSupport).BandScale ? step / 2 : 0;
        sector.visible = true;
        this.setSectorNodeProps(sector);
        sector.centerX = 0;
        sector.centerY = 0;
        sector.innerRadius = axisInnerRadius;
        sector.outerRadius = axisOuterRadius;
        sector.startAngle = angles[0] - padding;
        sector.endAngle = angles[1] + padding;
        this.assignCrossLineGroup(true, this.crossLineRange);
    }
    updateLabelNode(visible) {
        const { label: label, labelNode: node, range: range2, scale: scale, type: type, ticks: ticks } = this;
        if (!visible || label.enabled === false || !label.text || !scale || type === "range" && !range2) {
            node.visible = false;
            return;
        }
        node.visible = true;
        const { axisInnerRadius: axisInnerRadius, axisOuterRadius: axisOuterRadius } = this;
        let labelX;
        let labelY;
        let rotation;
        let textBaseline;
        if (type === "line") {
            const angle = $2fb96651e8aa1522$var$normalizeAngle360(scale.convert(this.value));
            const angle270 = 1.5 * Math.PI;
            const isRightSide = (0, $idDdm.isNumberEqual)(angle, angle270) || angle > angle270 || angle < Math.PI / 2;
            const midX = (axisInnerRadius + axisOuterRadius) / 2 * Math.cos(angle);
            const midY = (axisInnerRadius + axisOuterRadius) / 2 * Math.sin(angle);
            labelX = midX + label.padding * Math.cos(angle + Math.PI / 2);
            labelY = midY + label.padding * Math.sin(angle + Math.PI / 2);
            textBaseline = isRightSide ? "top" : "bottom";
            rotation = isRightSide ? angle : angle - Math.PI;
        } else {
            const [startAngle, endAngle] = range2.map((value)=>$2fb96651e8aa1522$var$normalizeAngle360(scale.convert(value)));
            let angle = (startAngle + endAngle) / 2;
            if (startAngle > endAngle) angle -= Math.PI;
            angle = $2fb96651e8aa1522$var$normalizeAngle360(angle);
            const isBottomSide = ((0, $idDdm.isNumberEqual)(angle, 0) || angle > 0) && angle < Math.PI;
            let distance;
            if (this.shape === "circle" || ticks.length < 3) distance = axisOuterRadius - label.padding;
            else distance = axisOuterRadius * Math.cos(Math.PI / ticks.length) - label.padding;
            labelX = distance * Math.cos(angle);
            labelY = distance * Math.sin(angle);
            textBaseline = isBottomSide ? "bottom" : "top";
            rotation = isBottomSide ? angle - Math.PI / 2 : angle + Math.PI / 2;
        }
        this.setLabelNodeProps(node, labelX, labelY, textBaseline, rotation);
    }
};
$2fb96651e8aa1522$var$AngleCrossLine.className = "AngleCrossLine";
// packages/ag-charts-enterprise/src/axes/angle/angleAxis.ts
var { ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection3, TextWrapper: $2fb96651e8aa1522$var$TextWrapper, TextUtils: $2fb96651e8aa1522$var$TextUtils, Property: $2fb96651e8aa1522$var$Property3, toRadians: $2fb96651e8aa1522$var$toRadians, normalizeAngle360: $2fb96651e8aa1522$var$normalizeAngle3602, normalizeAngle360Inclusive: $2fb96651e8aa1522$var$normalizeAngle360Inclusive, Path: $2fb96651e8aa1522$var$Path2, RotatableText: $2fb96651e8aa1522$var$RotatableText2, Transformable: $2fb96651e8aa1522$var$Transformable, BBox: $2fb96651e8aa1522$var$BBox, Selection: $2fb96651e8aa1522$var$Selection, Line: $2fb96651e8aa1522$var$Line } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$AngleAxisLabel = class extends (0, $iTJTu._ModuleSupport).AxisLabel {
    constructor(){
        super(...arguments);
        this.orientation = "fixed";
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property3
], $2fb96651e8aa1522$var$AngleAxisLabel.prototype, "orientation", 2);
var $2fb96651e8aa1522$var$AngleAxis = class extends (0, $iTJTu._ModuleSupport).PolarAxis {
    constructor(moduleCtx, scale){
        super(moduleCtx, scale);
        this.startAngle = 0;
        this.endAngle = void 0;
        this.tickLineGroupSelection = $2fb96651e8aa1522$var$Selection.select(this.tickLineGroup, $2fb96651e8aa1522$var$Line, false);
        this.gridLineGroupSelection = $2fb96651e8aa1522$var$Selection.select(this.gridLineGroup, $2fb96651e8aa1522$var$Line, false);
        this.labelData = [];
        this.tickData = [];
        this.radiusLineGroup = this.axisGroup.appendChild(new (0, $iTJTu._ModuleSupport).TransformableGroup());
        this.radiusLine = this.radiusLineGroup.appendChild(new $2fb96651e8aa1522$var$Path2());
        this.includeInvisibleDomains = true;
    }
    get direction() {
        return $2fb96651e8aa1522$var$ChartAxisDirection3.Angle;
    }
    createLabel() {
        return new $2fb96651e8aa1522$var$AngleAxisLabel();
    }
    calculateRotations() {
        const rotation = $2fb96651e8aa1522$var$toRadians(this.startAngle);
        const parallelFlipRotation = $2fb96651e8aa1522$var$normalizeAngle3602(rotation);
        const regularFlipRotation = $2fb96651e8aa1522$var$normalizeAngle3602(rotation - Math.PI / 2);
        return {
            rotation: rotation,
            parallelFlipRotation: parallelFlipRotation,
            regularFlipRotation: regularFlipRotation
        };
    }
    calculateTickLayout(domain) {
        const { nice: nice, scale: scale } = this;
        const ticksParams = {
            nice: nice,
            interval: void 0,
            tickCount: void 0,
            minTickCount: 0,
            maxTickCount: Infinity
        };
        const niceDomain = nice ? scale.niceDomain(ticksParams, domain) : domain;
        const tickData = this.generateAngleTicks(niceDomain);
        this.tickData = tickData;
        const ticks = tickData.map((t)=>t.value);
        const fractionDigits = ticks.reduce((f, t)=>Math.max(typeof t === "number" ? (0, $idDdm.countFractionDigits)(t) : 0, f), 0);
        return {
            niceDomain: niceDomain,
            tickDomain: niceDomain,
            ticks: ticks,
            rawTickCount: void 0,
            fractionDigits: fractionDigits,
            timeInterval: void 0,
            bbox: this.getBBox()
        };
    }
    update() {
        super.update();
        this.updateRadiusLine();
        this.updateGridLines();
        this.updateTickLines();
    }
    normalizedAngles() {
        const startAngle = $2fb96651e8aa1522$var$normalizeAngle3602(-Math.PI / 2 + $2fb96651e8aa1522$var$toRadians(this.startAngle));
        const sweep = this.endAngle != null ? $2fb96651e8aa1522$var$normalizeAngle360Inclusive($2fb96651e8aa1522$var$toRadians(this.endAngle) - $2fb96651e8aa1522$var$toRadians(this.startAngle)) : 2 * Math.PI;
        const endAngle = startAngle + sweep;
        return [
            startAngle,
            endAngle
        ];
    }
    computeRange() {
        this.range = this.normalizedAngles();
    }
    updateSelections() {
        const data = this.tickData;
        this.gridLineGroupSelection.update(this.gridLength && this.gridLine.enabled ? data : []);
        this.tickLineGroupSelection.update(this.tick.enabled ? data : []);
        this.tickLabelGroupSelection.update(this.label.enabled ? data : []);
        this.gridLineGroupSelection.cleanup();
        this.tickLineGroupSelection.cleanup();
        this.tickLabelGroupSelection.cleanup();
    }
    updatePosition() {
        super.updatePosition();
        const { translation: translation, radiusLineGroup: radiusLineGroup } = this;
        const translationX = Math.floor(translation.x);
        const translationY = Math.floor(translation.y);
        radiusLineGroup.translationX = translationX;
        radiusLineGroup.translationY = translationY;
    }
    updateRadiusLine() {
        const node = this.radiusLine;
        const { path: path } = node;
        path.clear(true);
        const { points: points, closePath: closePath } = this.getAxisLinePoints();
        points.forEach(({ x: x, y: y, moveTo: moveTo, arc: arc, radius: radius = 0, startAngle: startAngle = 0, endAngle: endAngle = 0 })=>{
            if (arc) path.arc(x, y, radius, startAngle, endAngle);
            else if (moveTo) path.moveTo(x, y);
            else path.lineTo(x, y);
        });
        if (closePath) path.closePath();
        node.visible = this.line.enabled;
        node.stroke = this.line.stroke;
        node.strokeWidth = this.line.width;
        node.fill = void 0;
    }
    getAxisLinePoints() {
        const { scale: scale, shape: shape, gridLength: radius } = this;
        const [startAngle, endAngle] = this.range;
        const isFullCircle = (0, $idDdm.isNumberEqual)(endAngle - startAngle, 2 * Math.PI);
        const points = [];
        if (shape === "circle") {
            if (isFullCircle) points.push({
                x: radius,
                y: 0,
                moveTo: true
            }, {
                x: 0,
                y: 0,
                radius: radius,
                startAngle: 0,
                endAngle: 2 * Math.PI,
                arc: true,
                moveTo: false
            });
            else points.push({
                x: radius * Math.cos(startAngle),
                y: radius * Math.sin(startAngle),
                moveTo: true
            }, {
                x: 0,
                y: 0,
                radius: radius,
                startAngle: $2fb96651e8aa1522$var$normalizeAngle3602(startAngle),
                endAngle: $2fb96651e8aa1522$var$normalizeAngle3602(endAngle),
                arc: true,
                moveTo: false
            });
        } else if (shape === "polygon") {
            const angles = scale.ticks({
                nice: this.nice,
                interval: void 0,
                tickCount: void 0,
                minTickCount: 0,
                maxTickCount: Infinity
            })?.ticks?.map((value)=>scale.convert(value));
            if (angles && angles.length > 2) angles.forEach((angle, i)=>{
                const x = radius * Math.cos(angle);
                const y = radius * Math.sin(angle);
                const moveTo = i === 0;
                points.push({
                    x: x,
                    y: y,
                    moveTo: moveTo
                });
            });
        }
        return {
            points: points,
            closePath: isFullCircle
        };
    }
    updateGridLines() {
        const { scale: scale, gridLength: radius, gridLine: { style: style, width: width }, innerRadiusRatio: innerRadiusRatio } = this;
        if (!(style && radius > 0)) return;
        const innerRadius = radius * innerRadiusRatio;
        const styleCount = style.length;
        this.gridLineGroupSelection.each((line, datum, index)=>{
            const { value: value } = datum;
            const { stroke: stroke2, lineDash: lineDash } = style[index % styleCount];
            const angle = scale.convert(value);
            line.x1 = innerRadius * Math.cos(angle);
            line.y1 = innerRadius * Math.sin(angle);
            line.x2 = radius * Math.cos(angle);
            line.y2 = radius * Math.sin(angle);
            line.stroke = stroke2;
            line.strokeWidth = width;
            line.lineDash = lineDash;
            line.fill = void 0;
        });
        this.gridLineGroupSelection.cleanup();
    }
    updateLabels() {
        const { label: label, tickLabelGroupSelection: tickLabelGroupSelection } = this;
        tickLabelGroupSelection.each((node, _, index)=>{
            const labelDatum = this.labelData[index];
            if (!labelDatum || labelDatum.hidden) {
                node.visible = false;
                return;
            }
            node.text = labelDatum.text;
            node.setFont(label);
            node.fill = label.color;
            node.x = labelDatum.x;
            node.y = labelDatum.y;
            node.textAlign = labelDatum.textAlign;
            node.textBaseline = labelDatum.textBaseline;
            node.visible = true;
            if (labelDatum.rotation) {
                node.rotation = labelDatum.rotation;
                node.rotationCenterX = labelDatum.x;
                node.rotationCenterY = labelDatum.y;
            } else node.rotation = 0;
        });
    }
    updateTickLines() {
        const { scale: scale, gridLength: radius, tick: tick, tickLineGroupSelection: tickLineGroupSelection } = this;
        tickLineGroupSelection.each((line, datum)=>{
            const { value: value } = datum;
            const angle = scale.convert(value);
            const cos = Math.cos(angle);
            const sin = Math.sin(angle);
            line.x1 = radius * cos;
            line.y1 = radius * sin;
            line.x2 = (radius + tick.size) * cos;
            line.y2 = (radius + tick.size) * sin;
            line.stroke = tick.stroke;
            line.strokeWidth = tick.width;
        });
    }
    createLabelNodeData(ticks, options, seriesRect) {
        const { label: label, gridLength: radius, scale: scale, tick: tick } = this;
        if (!label.enabled) return [];
        const tempText2 = new $2fb96651e8aa1522$var$RotatableText2();
        const seriesLeft = seriesRect.x - this.translation.x;
        const seriesRight = seriesRect.x + seriesRect.width - this.translation.x;
        const labelData = ticks.map((datum, index)=>{
            const { value: value } = datum;
            const distance = radius + label.spacing + tick.size;
            const angle = scale.convert(value);
            const cos = Math.cos(angle);
            const sin = Math.sin(angle);
            const x = distance * cos;
            const y = distance * sin;
            const { textAlign: textAlign, textBaseline: textBaseline } = this.getLabelAlign(angle);
            const isLastTickOverFirst = index === ticks.length - 1 && value !== ticks[0] && (0, $idDdm.isNumberEqual)($2fb96651e8aa1522$var$normalizeAngle3602(angle), $2fb96651e8aa1522$var$normalizeAngle3602(scale.convert(ticks[0])));
            const rotation = this.getLabelRotation(angle);
            let text2 = this.formatTick(value, index, scale.domain);
            tempText2.text = text2;
            tempText2.x = x;
            tempText2.y = y;
            tempText2.setFont(label);
            tempText2.textAlign = textAlign;
            tempText2.textBaseline = textBaseline;
            tempText2.rotation = rotation;
            if (rotation) {
                tempText2.rotationCenterX = x;
                tempText2.rotationCenterY = y;
            }
            let box = rotation ? $2fb96651e8aa1522$var$Transformable.toCanvas(tempText2) : tempText2.getBBox();
            if (box && options.hideWhenNecessary && !rotation) {
                const overflowLeft = seriesLeft - box.x;
                const overflowRight = box.x + box.width - seriesRight;
                const pixelError = 1;
                if (overflowLeft > pixelError || overflowRight > pixelError) {
                    const availWidth = box.width - Math.max(overflowLeft, overflowRight);
                    text2 = $2fb96651e8aa1522$var$TextWrapper.wrapText(text2, {
                        maxWidth: availWidth,
                        font: label,
                        textWrap: "never"
                    });
                    if (text2 === $2fb96651e8aa1522$var$TextUtils.EllipsisChar) text2 = "";
                    tempText2.text = text2;
                    box = tempText2.getBBox();
                }
            }
            return {
                text: text2,
                x: x,
                y: y,
                textAlign: textAlign,
                textBaseline: textBaseline,
                hidden: text2 === "" || datum.hidden || isLastTickOverFirst,
                rotation: rotation,
                box: box
            };
        });
        if (label.avoidCollisions) this.avoidLabelCollisions(labelData);
        return labelData;
    }
    computeLabelsBBox(options, seriesRect) {
        this.labelData = this.createLabelNodeData(this.tickData, options, seriesRect);
        const textBoxes = this.labelData.map(({ box: box })=>box).filter((box)=>box != null);
        if (!this.label.enabled || textBoxes.length === 0) return null;
        return $2fb96651e8aa1522$var$BBox.merge(textBoxes);
    }
    getLabelOrientation() {
        const { label: label } = this;
        return label instanceof $2fb96651e8aa1522$var$AngleAxisLabel ? label.orientation : "fixed";
    }
    getLabelRotation(tickAngle) {
        let rotation = $2fb96651e8aa1522$var$toRadians(this.label.rotation ?? 0);
        tickAngle = $2fb96651e8aa1522$var$normalizeAngle3602(tickAngle);
        const orientation = this.getLabelOrientation();
        if (orientation === "parallel") {
            rotation += tickAngle;
            if (tickAngle >= 0 && tickAngle < Math.PI) rotation -= Math.PI / 2;
            else rotation += Math.PI / 2;
        } else if (orientation === "perpendicular") {
            rotation += tickAngle;
            if (tickAngle >= Math.PI / 2 && tickAngle < 1.5 * Math.PI) rotation += Math.PI;
        }
        return rotation;
    }
    getLabelAlign(tickAngle) {
        const cos = Math.cos(tickAngle);
        const sin = Math.sin(tickAngle);
        let textAlign;
        let textBaseline;
        const orientation = this.getLabelOrientation();
        const isCos0 = (0, $idDdm.isNumberEqual)(cos, 0);
        const isSin0 = (0, $idDdm.isNumberEqual)(sin, 0);
        const isCos1 = (0, $idDdm.isNumberEqual)(cos, 1);
        const isSinMinus1 = (0, $idDdm.isNumberEqual)(sin, -1);
        const isCosPositive = cos > 0 && !isCos0;
        const isSinPositive = sin > 0 && !isSin0;
        if (orientation === "parallel") {
            textAlign = "center";
            textBaseline = isCos1 && isSin0 || isSinPositive ? "top" : "bottom";
        } else if (orientation === "perpendicular") {
            textAlign = isSinMinus1 || isCosPositive ? "left" : "right";
            textBaseline = "middle";
        } else {
            textAlign = "right";
            if (isCos0) textAlign = "center";
            else if (isCosPositive) textAlign = "left";
            textBaseline = "bottom";
            if (isSin0) textBaseline = "middle";
            else if (isSinPositive) textBaseline = "top";
        }
        return {
            textAlign: textAlign,
            textBaseline: textBaseline
        };
    }
    updateCrossLines() {
        const { shape: shape, gridLength: radius, innerRadiusRatio: innerRadiusRatio } = this;
        this.crossLines.forEach((crossLine)=>{
            if (crossLine instanceof $2fb96651e8aa1522$var$AngleCrossLine) {
                crossLine.ticks = this.tickData.map((t)=>t.value);
                crossLine.shape = shape;
                crossLine.axisOuterRadius = radius;
                crossLine.axisInnerRadius = radius * innerRadiusRatio;
            }
        });
        super.updateCrossLines();
    }
};
$2fb96651e8aa1522$var$AngleAxis.CrossLineConstructor = $2fb96651e8aa1522$var$AngleCrossLine;
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property3
], $2fb96651e8aa1522$var$AngleAxis.prototype, "startAngle", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property3
], $2fb96651e8aa1522$var$AngleAxis.prototype, "endAngle", 2);
// packages/ag-charts-enterprise/src/axes/angle-category/angleCategoryAxis.ts
var { Property: $2fb96651e8aa1522$var$Property4, CategoryScale: $2fb96651e8aa1522$var$CategoryScale } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$AngleCategoryAxis = class extends $2fb96651e8aa1522$var$AngleAxis {
    constructor(moduleCtx){
        super(moduleCtx, new $2fb96651e8aa1522$var$CategoryScale());
        this.groupPaddingInner = 0;
        this.paddingInner = 0;
        this.interval = new $2fb96651e8aa1522$var$AngleAxisInterval();
    }
    generateAngleTicks() {
        const { scale: scale, gridLength: radius } = this;
        const { values: values, minSpacing: minSpacing } = this.interval;
        const ticks = values ?? scale.ticks({
            nice: this.nice,
            interval: void 0,
            tickCount: void 0,
            minTickCount: 0,
            maxTickCount: Infinity
        })?.ticks ?? [];
        if (ticks.length < 2 || minSpacing == null) return ticks.map((value)=>{
            return {
                value: value,
                visible: true
            };
        });
        const startTick = ticks[0];
        const startAngle = scale.convert(startTick);
        const startX = radius * Math.cos(startAngle);
        const startY = radius * Math.sin(startAngle);
        for(let step = 1; step < ticks.length - 1; step++){
            const nextTick = ticks[step];
            const nextAngle = scale.convert(nextTick);
            if (nextAngle - startAngle > Math.PI) break;
            const nextX = radius * Math.cos(nextAngle);
            const nextY = radius * Math.sin(nextAngle);
            const spacing = Math.sqrt((nextX - startX) ** 2 + (nextY - startY) ** 2);
            if (spacing > minSpacing) {
                const visibleTicks = /* @__PURE__ */ new Set([
                    startTick
                ]);
                $2fb96651e8aa1522$var$loopSymmetrically(ticks, step, (_, next)=>{
                    visibleTicks.add(next);
                });
                return ticks.map((value)=>{
                    const visible = visibleTicks.has(value);
                    return {
                        value: value,
                        visible: visible
                    };
                });
            }
        }
        return [
            {
                value: startTick,
                visible: true
            }
        ];
    }
    avoidLabelCollisions(labelData) {
        const { minSpacing: minSpacing } = this.label;
        if (labelData.length < 3) return;
        const labelsCollide = (prev, next)=>{
            if (prev.hidden || next.hidden) return false;
            else if (minSpacing == null) return prev.box.collidesBBox(next.box);
            const prevBox = prev.box.clone().grow(minSpacing / 2);
            const nextBox = next.box.clone().grow(minSpacing / 2);
            return prevBox.collidesBBox(nextBox);
        };
        const firstLabel = labelData[0];
        const lastLabel = labelData.at(-1);
        const visibleLabels = /* @__PURE__ */ new Set([
            firstLabel
        ]);
        const lastLabelIsOverFirst = (0, $idDdm.isNumberEqual)(firstLabel.x, lastLabel.x) && (0, $idDdm.isNumberEqual)(firstLabel.y, lastLabel.y);
        const maxStep = Math.floor(labelData.length / 2);
        for(let step = 1; step <= maxStep; step++){
            const labels = lastLabelIsOverFirst ? labelData.slice(0, -1) : labelData;
            const collisionDetected = $2fb96651e8aa1522$var$loopSymmetrically(labels, step, labelsCollide);
            if (!collisionDetected) {
                $2fb96651e8aa1522$var$loopSymmetrically(labels, step, (_, next)=>{
                    visibleLabels.add(next);
                });
                break;
            }
        }
        labelData.forEach((datum)=>{
            if (!visibleLabels.has(datum)) {
                datum.hidden = true;
                datum.box = void 0;
            }
        });
    }
};
$2fb96651e8aa1522$var$AngleCategoryAxis.className = "AngleCategoryAxis";
$2fb96651e8aa1522$var$AngleCategoryAxis.type = "angle-category";
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property4
], $2fb96651e8aa1522$var$AngleCategoryAxis.prototype, "groupPaddingInner", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property4
], $2fb96651e8aa1522$var$AngleCategoryAxis.prototype, "paddingInner", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property4
], $2fb96651e8aa1522$var$AngleCategoryAxis.prototype, "interval", 2);
// packages/ag-charts-enterprise/src/axes/angle-category/angleCategoryAxisModule.ts
var $2fb96651e8aa1522$var$AngleCategoryAxisModule = {
    type: "axis",
    optionsKey: "axes[]",
    packageType: "enterprise",
    chartTypes: [
        "polar"
    ],
    identifier: "angle-category",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$AngleCategoryAxis(ctx)
};
var { range: $2fb96651e8aa1522$var$range, isDenseInterval: $2fb96651e8aa1522$var$isDenseInterval, LinearScale: $2fb96651e8aa1522$var$LinearScale } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$LinearAngleScale = class _LinearAngleScale extends $2fb96651e8aa1522$var$LinearScale {
    constructor(){
        super(...arguments);
        this.arcLength = 0;
    }
    static getNiceStepAndTickCount(ticks, domain) {
        const [start, stop] = domain;
        let step = $2fb96651e8aa1522$var$LinearScale.getTickStep(start, stop, ticks);
        const maxTickCount = isNaN(ticks.maxTickCount) ? Infinity : ticks.maxTickCount;
        const expectedTickCount = Math.abs(stop - start) / step;
        let niceTickCount = Math.pow(2, Math.ceil(Math.log(expectedTickCount) / Math.log(2)));
        if (niceTickCount > maxTickCount) {
            niceTickCount /= 2;
            step *= 2;
        }
        return {
            count: niceTickCount,
            step: step
        };
    }
    ticks(ticks, domain = this.domain) {
        const { arcLength: arcLength } = this;
        if (!domain || domain.length < 2 || domain.some((d)=>!isFinite(d)) || arcLength <= 0) return {
            ticks: [],
            count: 0
        };
        const { nice: nice, interval: interval } = ticks;
        const [d0, d1] = domain;
        if (interval) {
            const step2 = Math.abs(interval);
            const availableRange = this.getPixelRange();
            if (!$2fb96651e8aa1522$var$isDenseInterval((d1 - d0) / step2, availableRange)) return $2fb96651e8aa1522$var$range(d0, d1, step2);
        }
        let step;
        if (nice && this.hasNiceRange()) {
            const linearNiceDomain = super.niceDomain(ticks, domain);
            step = _LinearAngleScale.getNiceStepAndTickCount(ticks, linearNiceDomain).step;
        } else step = $2fb96651e8aa1522$var$LinearScale.getTickStep(d0, d1, ticks);
        return $2fb96651e8aa1522$var$range(d0, d1, step);
    }
    hasNiceRange() {
        const sortedRange = this.range.slice().sort((a, b)=>a - b);
        const niceRanges = [
            Math.PI,
            2 * Math.PI
        ];
        return niceRanges.some((r)=>(0, $idDdm.isNumberEqual)(r, sortedRange[1] - sortedRange[0]));
    }
    niceDomain(ticks, domain = this.domain) {
        const linearNiceDomain = super.niceDomain(ticks, domain);
        if (!this.hasNiceRange()) return linearNiceDomain;
        const reversed = linearNiceDomain[0] > linearNiceDomain[1];
        const start = reversed ? linearNiceDomain[1] : linearNiceDomain[0];
        const { step: step, count: count } = _LinearAngleScale.getNiceStepAndTickCount(ticks, linearNiceDomain);
        const s = 1 / step;
        const stop = step >= 1 ? Math.ceil(start / step + count) * step : Math.ceil((start + count * step) * s) / s;
        return reversed ? [
            stop,
            start
        ] : [
            start,
            stop
        ];
    }
    getPixelRange() {
        return this.arcLength;
    }
};
// packages/ag-charts-enterprise/src/axes/angle-number/angleNumberAxis.ts
var { Property: $2fb96651e8aa1522$var$Property5, angleBetween: $2fb96651e8aa1522$var$angleBetween, normalisedExtentWithMetadata: $2fb96651e8aa1522$var$normalisedExtentWithMetadata, findMinMax: $2fb96651e8aa1522$var$findMinMax } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$AngleNumberAxis = class extends $2fb96651e8aa1522$var$AngleAxis {
    constructor(moduleCtx){
        super(moduleCtx, new $2fb96651e8aa1522$var$LinearAngleScale());
        this.shape = "circle";
        this.interval = new $2fb96651e8aa1522$var$AngleAxisInterval();
    }
    normaliseDataDomain(d) {
        const { min: min, max: max } = this;
        const { extent: extent3, clipped: clipped } = $2fb96651e8aa1522$var$normalisedExtentWithMetadata(d, min, max);
        return {
            domain: extent3,
            clipped: clipped
        };
    }
    updateScale() {
        super.updateScale();
        this.scale.arcLength = this.getRangeArcLength();
    }
    getRangeArcLength() {
        const { range: requestedRange } = this;
        const min = Math.min(...requestedRange);
        const max = Math.max(...requestedRange);
        const rotation = $2fb96651e8aa1522$var$angleBetween(min, max) || 2 * Math.PI;
        const radius = this.gridLength;
        return rotation * radius;
    }
    generateAngleTicks(domain) {
        const { scale: scale, range: requestedRange, nice: nice } = this;
        const { values: values, step: step, minSpacing: minSpacing, maxSpacing: maxSpacing } = this.interval;
        let rawTicks;
        if (values == null) {
            const { arcLength: arcLength } = scale;
            const minTickCount = maxSpacing ? Math.floor(arcLength / maxSpacing) : 1;
            const maxTickCount = minSpacing ? Math.floor(arcLength / minSpacing) : Infinity;
            const preferredTickCount = Math.floor(4 / Math.PI * Math.abs(requestedRange[0] - requestedRange[1]));
            const tickCount = Math.max(minTickCount, Math.min(maxTickCount, preferredTickCount));
            const tickParams = {
                nice: nice,
                interval: step,
                tickCount: tickCount,
                minTickCount: minTickCount,
                maxTickCount: maxTickCount
            };
            rawTicks = scale.ticks(tickParams, domain)?.ticks ?? [];
        } else {
            const [d0, d1] = $2fb96651e8aa1522$var$findMinMax(domain.map(Number));
            rawTicks = values.filter((value)=>value >= d0 && value <= d1).sort((a, b)=>a - b);
        }
        return rawTicks.map((value)=>({
                value: value,
                visible: true
            }));
    }
    avoidLabelCollisions(labelData) {
        const { minSpacing: minSpacing } = this.label;
        const labelsCollide = (prev, next)=>{
            if (prev.hidden || next.hidden) return false;
            else if (minSpacing == null) return prev.box.collidesBBox(next.box);
            const prevBox = prev.box.clone().grow(minSpacing / 2);
            const nextBox = next.box.clone().grow(minSpacing / 2);
            return prevBox.collidesBBox(nextBox);
        };
        const firstLabel = labelData[0];
        const lastLabel = labelData.at(-1);
        if (firstLabel !== lastLabel && (0, $idDdm.isNumberEqual)(firstLabel.x, lastLabel.x) && (0, $idDdm.isNumberEqual)(firstLabel.y, lastLabel.y)) lastLabel.hidden = true;
        for(let step = 1; step < labelData.length; step *= 2){
            let collisionDetected = false;
            for(let i = step; i < labelData.length; i += step){
                const next = labelData[i];
                const prev = labelData[i - step];
                if (labelsCollide(prev, next)) {
                    collisionDetected = true;
                    break;
                }
            }
            if (!collisionDetected) {
                labelData.forEach((datum, i)=>{
                    if (i % step > 0) {
                        datum.hidden = true;
                        datum.box = void 0;
                    }
                });
                return;
            }
        }
        labelData.forEach((datum, i)=>{
            if (i > 0) {
                datum.hidden = true;
                datum.box = void 0;
            }
        });
    }
};
$2fb96651e8aa1522$var$AngleNumberAxis.className = "AngleNumberAxis";
$2fb96651e8aa1522$var$AngleNumberAxis.type = "angle-number";
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property5
], $2fb96651e8aa1522$var$AngleNumberAxis.prototype, "min", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property5
], $2fb96651e8aa1522$var$AngleNumberAxis.prototype, "max", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property5
], $2fb96651e8aa1522$var$AngleNumberAxis.prototype, "interval", 2);
// packages/ag-charts-enterprise/src/axes/angle-number/angleNumberAxisModule.ts
var $2fb96651e8aa1522$var$AngleNumberAxisModule = {
    type: "axis",
    optionsKey: "axes[]",
    packageType: "enterprise",
    chartTypes: [
        "polar"
    ],
    identifier: "angle-number",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$AngleNumberAxis(ctx)
};
var { OrdinalTimeScale: $2fb96651e8aa1522$var$OrdinalTimeScale, Property: $2fb96651e8aa1522$var$Property6, TimeAxisParentLevel: $2fb96651e8aa1522$var$TimeAxisParentLevel } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$OrdinalTimeAxis = class extends (0, $iTJTu._ModuleSupport).CategoryAxis {
    constructor(moduleCtx){
        super(moduleCtx, new $2fb96651e8aa1522$var$OrdinalTimeScale());
        this.parentLevel = new $2fb96651e8aa1522$var$TimeAxisParentLevel();
    }
    get primaryLabel() {
        return this.parentLevel.enabled ? this.parentLevel.label : void 0;
    }
    get primaryTick() {
        return this.parentLevel.enabled ? this.parentLevel.tick : void 0;
    }
};
$2fb96651e8aa1522$var$OrdinalTimeAxis.className = "OrdinalTimeAxis";
$2fb96651e8aa1522$var$OrdinalTimeAxis.type = "ordinal-time";
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property6
], $2fb96651e8aa1522$var$OrdinalTimeAxis.prototype, "parentLevel", 2);
// packages/ag-charts-enterprise/src/axes/ordinal/ordinalTimeAxisModule.ts
var $2fb96651e8aa1522$var$OrdinalTimeAxisModule = {
    type: "axis",
    optionsKey: "axes[]",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    identifier: "ordinal-time",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$OrdinalTimeAxis(ctx)
};
var { ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection4, Property: $2fb96651e8aa1522$var$Property7, getCrossLineValue: $2fb96651e8aa1522$var$getCrossLineValue2, validateCrossLineValue: $2fb96651e8aa1522$var$validateCrossLineValue2, normalizeAngle360FromDegrees: $2fb96651e8aa1522$var$normalizeAngle360FromDegrees, Group: $2fb96651e8aa1522$var$Group3, Path: $2fb96651e8aa1522$var$Path3, Sector: $2fb96651e8aa1522$var$Sector2, RotatableText: $2fb96651e8aa1522$var$RotatableText3 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadiusCrossLineLabel = class extends $2fb96651e8aa1522$var$PolarCrossLineLabel {
    constructor(){
        super(...arguments);
        this.positionAngle = void 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property7
], $2fb96651e8aa1522$var$RadiusCrossLineLabel.prototype, "positionAngle", 2);
var $2fb96651e8aa1522$var$RadiusCrossLine = class extends $2fb96651e8aa1522$var$PolarCrossLine {
    constructor(){
        super();
        this.direction = $2fb96651e8aa1522$var$ChartAxisDirection4.Radius;
        this.label = new $2fb96651e8aa1522$var$RadiusCrossLineLabel();
        this.polygonNode = new $2fb96651e8aa1522$var$Path3();
        this.sectorNode = new $2fb96651e8aa1522$var$Sector2();
        this.crossLineRange = new $2fb96651e8aa1522$var$Group3();
        this.labelNode = new $2fb96651e8aa1522$var$RotatableText3();
        this.outerRadius = 0;
        this.innerRadius = 0;
        this.crossLineRange.append(this.polygonNode);
        this.crossLineRange.append(this.sectorNode);
        this.labelGroup.append(this.labelNode);
    }
    update(visible) {
        const { scale: scale } = this;
        if (!scale || !$2fb96651e8aa1522$var$validateCrossLineValue2($2fb96651e8aa1522$var$getCrossLineValue2(this), scale)) {
            this.rangeGroup.visible = false;
            this.lineGroup.visible = false;
            this.labelGroup.visible = false;
            return;
        }
        this.updateRadii();
        const { innerRadius: innerRadius, outerRadius: outerRadius } = this;
        visible && (visible = innerRadius >= this.axisInnerRadius && outerRadius <= this.axisOuterRadius);
        this.rangeGroup.visible = visible;
        this.lineGroup.visible = visible;
        this.labelGroup.visible = visible;
        this.updatePolygonNode(visible);
        this.updateSectorNode(visible);
        this.updateLabelNode(visible);
        this.assignCrossLineGroup(this.type === "range", this.crossLineRange);
    }
    updateRadii() {
        const { range: range2, scale: scale, type: type, axisInnerRadius: axisInnerRadius, axisOuterRadius: axisOuterRadius } = this;
        if (!scale) return {
            innerRadius: 0,
            outerRadius: 0
        };
        const getRadius = (value)=>axisOuterRadius + axisInnerRadius - value;
        let outerRadius, innerRadius;
        if (type === "line") {
            outerRadius = getRadius(scale.convert(this.value));
            innerRadius = outerRadius;
        } else {
            const bandwidth = Math.abs(scale?.bandwidth ?? 0);
            const convertedRange = range2.map((r)=>scale.convert(r));
            outerRadius = getRadius(Math.max(...convertedRange));
            innerRadius = getRadius(Math.min(...convertedRange)) + bandwidth;
        }
        this.outerRadius = outerRadius;
        this.innerRadius = innerRadius;
    }
    drawPolygon(radius, angles, polygon) {
        angles.forEach((angle, index)=>{
            const x = radius * Math.cos(angle);
            const y = radius * Math.sin(angle);
            if (index === 0) polygon.path.moveTo(x, y);
            else polygon.path.lineTo(x, y);
        });
        polygon.path.closePath();
    }
    updatePolygonNode(visible) {
        const { gridAngles: gridAngles, polygonNode: polygon, scale: scale, shape: shape, type: type, innerRadius: innerRadius, outerRadius: outerRadius } = this;
        if (!visible || shape !== "polygon" || !scale || !gridAngles) {
            polygon.visible = false;
            return;
        }
        polygon.visible = true;
        const padding = this.getPadding();
        polygon.path.clear(true);
        this.drawPolygon(outerRadius - padding, gridAngles, polygon);
        const reversedAngles = gridAngles.slice().reverse();
        const innerPolygonRadius = type === "line" ? outerRadius - padding : innerRadius + padding;
        this.drawPolygon(innerPolygonRadius, reversedAngles, polygon);
        this.setSectorNodeProps(polygon);
    }
    updateSectorNode(visible) {
        const { axisInnerRadius: axisInnerRadius, axisOuterRadius: axisOuterRadius, scale: scale, sectorNode: sector, shape: shape, innerRadius: innerRadius, outerRadius: outerRadius } = this;
        if (!visible || shape !== "circle" || !scale) {
            sector.visible = false;
            return;
        }
        sector.visible = true;
        sector.startAngle = 0;
        sector.endAngle = 2 * Math.PI;
        const padding = this.getPadding();
        const r0 = (0, $idDdm.clamp)(axisInnerRadius, innerRadius + padding, axisOuterRadius);
        const r1 = (0, $idDdm.clamp)(axisInnerRadius, outerRadius - padding, axisOuterRadius);
        sector.innerRadius = Math.min(r0, r1);
        sector.outerRadius = Math.max(r0, r1);
        this.setSectorNodeProps(sector);
    }
    updateLabelNode(visible) {
        const { innerRadius: innerRadius, label: label, labelNode: node, scale: scale, shape: shape, type: type } = this;
        if (!visible || label.enabled === false || !label.text || !scale) {
            node.visible = false;
            return;
        }
        const angle = $2fb96651e8aa1522$var$normalizeAngle360FromDegrees((label.positionAngle ?? 0) - 90);
        const isBottomSide = ((0, $idDdm.isNumberEqual)(angle, 0) || angle > 0) && angle < Math.PI;
        const rotation = isBottomSide ? angle - Math.PI / 2 : angle + Math.PI / 2;
        let distance;
        const angles = this.gridAngles ?? [];
        if (type === "line") distance = innerRadius + label.padding;
        else if (shape === "circle" || angles.length < 3) distance = innerRadius - label.padding;
        else distance = innerRadius * Math.cos(Math.PI / angles.length) - label.padding;
        const labelX = distance * Math.cos(angle);
        const labelY = distance * Math.sin(angle);
        let textBaseline;
        if (type === "line") textBaseline = isBottomSide ? "top" : "bottom";
        else textBaseline = isBottomSide ? "bottom" : "top";
        this.setLabelNodeProps(node, labelX, labelY, textBaseline, rotation);
    }
    getPadding() {
        const { scale: scale } = this;
        if (!scale) return 0;
        const bandwidth = Math.abs(scale.bandwidth ?? 0);
        const step = Math.abs(scale.step ?? 0);
        return scale instanceof (0, $iTJTu._ModuleSupport).BandScale ? (step - bandwidth) / 2 : 0;
    }
};
$2fb96651e8aa1522$var$RadiusCrossLine.className = "RadiusCrossLine";
// packages/ag-charts-enterprise/src/axes/radius/radiusAxis.ts
var { ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection5, ZIndexMap: $2fb96651e8aa1522$var$ZIndexMap, Property: $2fb96651e8aa1522$var$Property8, normalizeAngle360: $2fb96651e8aa1522$var$normalizeAngle3603, toRadians: $2fb96651e8aa1522$var$toRadians2, Caption: $2fb96651e8aa1522$var$Caption, Group: $2fb96651e8aa1522$var$Group4, TransformableGroup: $2fb96651e8aa1522$var$TransformableGroup, Path: $2fb96651e8aa1522$var$Path4, Line: $2fb96651e8aa1522$var$Line2, Selection: $2fb96651e8aa1522$var$Selection2, AxisTickGenerator: $2fb96651e8aa1522$var$AxisTickGenerator, AxisGroupZIndexMap: $2fb96651e8aa1522$var$AxisGroupZIndexMap } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadiusAxisLabel = class extends (0, $iTJTu._ModuleSupport).AxisLabel {
    constructor(){
        super(...arguments);
        this.autoRotateAngle = 335;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property8
], $2fb96651e8aa1522$var$RadiusAxisLabel.prototype, "autoRotate", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property8
], $2fb96651e8aa1522$var$RadiusAxisLabel.prototype, "autoRotateAngle", 2);
var $2fb96651e8aa1522$var$RadiusAxis = class extends (0, $iTJTu._ModuleSupport).PolarAxis {
    constructor(moduleCtx, scale){
        super(moduleCtx, scale);
        this.positionAngle = 0;
        this.gridLineGroupSelection = $2fb96651e8aa1522$var$Selection2.select(this.gridLineGroup, $2fb96651e8aa1522$var$Line2, false);
        this.tickGenerator = new $2fb96651e8aa1522$var$AxisTickGenerator(this);
        this.generatedTicks = void 0;
        this.headingLabelGroup = this.axisGroup.appendChild(new $2fb96651e8aa1522$var$TransformableGroup({
            name: `${this.id}-Axis-heading`
        }));
        this.lineNodeGroup = this.axisGroup.appendChild(new $2fb96651e8aa1522$var$TransformableGroup({
            name: `${this.id}-Axis-line`
        }));
        this.lineNode = this.lineNodeGroup.appendChild(new $2fb96651e8aa1522$var$Line2({
            name: `${this.id}-Axis-line`,
            zIndex: $2fb96651e8aa1522$var$AxisGroupZIndexMap.AxisLine
        }));
        this.gridPathGroup = this.gridGroup.appendChild(new $2fb96651e8aa1522$var$Group4({
            name: `${this.id}-gridPaths`,
            zIndex: $2fb96651e8aa1522$var$ZIndexMap.AXIS_GRID
        }));
        this.gridPathSelection = $2fb96651e8aa1522$var$Selection2.select(this.gridPathGroup, $2fb96651e8aa1522$var$Path4);
        this.headingLabelGroup.appendChild(this.title.caption.node);
        this.destroyFns.push(this.title.caption.registerInteraction(this.moduleCtx, "afterend"));
    }
    get direction() {
        return $2fb96651e8aa1522$var$ChartAxisDirection5.Radius;
    }
    getAxisTransform() {
        const maxRadius = this.scale.range[0];
        const { translation: translation, positionAngle: positionAngle, innerRadiusRatio: innerRadiusRatio } = this;
        const innerRadius = maxRadius * innerRadiusRatio;
        const rotation = $2fb96651e8aa1522$var$toRadians2(positionAngle);
        return {
            translationX: translation.x,
            translationY: translation.y - maxRadius - innerRadius,
            rotation: rotation,
            rotationCenterX: 0,
            rotationCenterY: maxRadius + innerRadius
        };
    }
    update() {
        super.update();
        this.updateTitle();
        this.updateGridLines();
        const { enabled: enabled, stroke: stroke2, width: width } = this.line;
        this.lineNode.setProperties({
            stroke: stroke2,
            strokeWidth: enabled ? width : 0,
            x1: 0,
            y1: this.range[0],
            x2: 0,
            y2: this.range[1]
        });
    }
    updatePosition() {
        super.updatePosition();
        const axisTransform = this.getAxisTransform();
        this.tickLineGroup.setProperties(axisTransform);
        this.tickLabelGroup.setProperties(axisTransform);
        this.lineNodeGroup.setProperties(axisTransform);
        this.headingLabelGroup.setProperties(axisTransform);
    }
    calculateRotations() {
        const rotation = 0;
        const parallelFlipRotation = 0;
        const regularFlipRotation = -Math.PI / 2;
        return {
            rotation: rotation,
            parallelFlipRotation: parallelFlipRotation,
            regularFlipRotation: regularFlipRotation
        };
    }
    calculateTickLayout(domain, niceMode, _visibleRange) {
        const parallelFlipRotation = 0;
        const regularFlipRotation = -Math.PI / 2;
        const visibleRange = [
            0,
            1
        ];
        const sideFlag = this.label.getSideFlag();
        const labelX = sideFlag * (this.getTickSize() + this.label.spacing + this.seriesAreaPadding);
        const tickGenerationResult = this.tickGenerator.generateTicks({
            domain: domain,
            niceMode: niceMode,
            visibleRange: visibleRange,
            primaryTickCount: void 0,
            parallelFlipRotation: parallelFlipRotation,
            regularFlipRotation: regularFlipRotation,
            labelX: labelX,
            sideFlag: sideFlag,
            removeOverflowLabels: false
        });
        const { tickData: tickData } = tickGenerationResult;
        const { ticks: ticks, rawTicks: rawTicks, rawTickCount: rawTickCount, tickDomain: tickDomain, fractionDigits: fractionDigits, niceDomain: niceDomain = domain } = tickData;
        const labels = ticks.map((d)=>this.getTickLabelProps(d, tickGenerationResult));
        this.generatedTicks = {
            ticks: ticks,
            labels: labels
        };
        return {
            ticks: rawTicks,
            tickDomain: tickDomain,
            niceDomain: niceDomain,
            rawTickCount: rawTickCount,
            fractionDigits: fractionDigits,
            timeInterval: void 0
        };
    }
    updateSelections() {
        const { generatedTicks: generatedTicks } = this;
        if (!generatedTicks) return;
        const { ticks: ticks, labels: labels } = generatedTicks;
        this.gridLineGroupSelection.update(this.gridLength ? ticks : []);
        this.tickLabelGroupSelection.update(labels);
        this.gridPathSelection.update(this.gridLine.enabled ? this.prepareGridPathTickData(ticks) : []);
        this.gridLineGroupSelection.cleanup();
        this.tickLabelGroupSelection.cleanup();
        this.gridPathSelection.cleanup();
    }
    // TODO - abstract out
    updateLabels() {
        if (!this.label.enabled) return;
        const axisLabelPositionFn = (0, $iTJTu._ModuleSupport).resetAxisLabelSelectionFn();
        this.tickLabelGroupSelection.each((node, datum)=>{
            node.fill = datum.fill;
            node.fontFamily = datum.fontFamily;
            node.fontSize = datum.fontSize;
            node.fontStyle = datum.fontStyle;
            node.fontWeight = datum.fontWeight;
            node.text = datum.text;
            node.textBaseline = datum.textBaseline;
            node.textAlign = datum.textAlign ?? "center";
            node.setProperties(axisLabelPositionFn(node, datum));
        });
    }
    updateGridLines() {
        const { gridLine: { style: style, width: width }, shape: shape, generatedTicks: generatedTicks } = this;
        if (!style || !generatedTicks) return;
        const styleCount = style.length;
        const setStyle = (node, index)=>{
            const { stroke: stroke2, lineDash: lineDash } = style[index % styleCount];
            node.stroke = stroke2;
            node.strokeWidth = width;
            node.lineDash = lineDash;
            node.fill = void 0;
        };
        const [startAngle, endAngle] = this.gridRange ?? [
            0,
            2 * Math.PI
        ];
        const isFullCircle = (0, $idDdm.isNumberEqual)(endAngle - startAngle, 2 * Math.PI);
        const drawCircleShape = (node, value)=>{
            const { path: path } = node;
            path.clear(true);
            const radius = this.getTickRadius(value);
            if (isFullCircle) {
                path.moveTo(radius, 0);
                path.arc(0, 0, radius, 0, 2 * Math.PI);
            } else {
                path.moveTo(radius * Math.cos(startAngle), radius * Math.sin(startAngle));
                path.arc(0, 0, radius, $2fb96651e8aa1522$var$normalizeAngle3603(startAngle), $2fb96651e8aa1522$var$normalizeAngle3603(endAngle));
            }
            if (isFullCircle) path.closePath();
        };
        const drawPolygonShape = (node, value)=>{
            const { path: path } = node;
            const angles = this.gridAngles;
            path.clear(true);
            if (!angles || angles.length < 3) return;
            const radius = this.getTickRadius(value);
            angles.forEach((angle, idx)=>{
                const x = radius * Math.cos(angle);
                const y = radius * Math.sin(angle);
                if (idx === 0) path.moveTo(x, y);
                else path.lineTo(x, y);
                angles.forEach((innerAngle, innerIdx)=>{
                    const x2 = radius * Math.cos(innerAngle);
                    const y2 = radius * Math.sin(innerAngle);
                    if (innerIdx === 0) path.moveTo(x2, y2);
                    else path.lineTo(x2, y2);
                });
                path.closePath();
            });
            path.closePath();
        };
        const drawFn = shape === "circle" ? drawCircleShape : drawPolygonShape;
        this.gridPathSelection.each((node, value, index)=>{
            setStyle(node, index);
            drawFn(node, value);
        });
    }
    updateTitle() {
        const identityFormatter = (params)=>params.defaultValue;
        const { title: title, range: requestedRange } = this;
        const { formatter: formatter = identityFormatter } = this.title;
        title.caption.enabled = title.enabled;
        title.caption.fontFamily = title.fontFamily;
        title.caption.fontSize = title.fontSize;
        title.caption.fontStyle = title.fontStyle;
        title.caption.fontWeight = title.fontWeight;
        title.caption.color = title.color;
        title.caption.wrapping = title.wrapping;
        let titleVisible = false;
        const titleNode = title.caption.node;
        if (title.enabled) {
            titleVisible = true;
            titleNode.rotation = Math.PI / 2;
            titleNode.x = Math.floor((requestedRange[0] + requestedRange[1]) / 2);
            titleNode.y = -$2fb96651e8aa1522$var$Caption.SMALL_PADDING;
            titleNode.textAlign = "center";
            titleNode.textBaseline = "bottom";
            titleNode.text = this.callWithContext(formatter, this.getTitleFormatterParams(this.scale.domain));
        }
        titleNode.visible = titleVisible;
    }
    updateCrossLines() {
        this.crossLines.forEach((crossLine)=>{
            if (crossLine instanceof $2fb96651e8aa1522$var$RadiusCrossLine) {
                const { shape: shape, gridAngles: gridAngles, range: range2, innerRadiusRatio: innerRadiusRatio } = this;
                const radius = range2[0];
                crossLine.shape = shape;
                crossLine.gridAngles = gridAngles;
                crossLine.axisOuterRadius = radius;
                crossLine.axisInnerRadius = radius * innerRadiusRatio;
            }
        });
        super.updateCrossLines();
    }
    createLabel() {
        return new $2fb96651e8aa1522$var$RadiusAxisLabel();
    }
    // TODO - abstract out (shared with cartesian axis)
    getTickLabelProps(datum, tickGenerationResult) {
        const { label: label } = this;
        const { rotation: rotation, textBaseline: textBaseline, textAlign: textAlign } = tickGenerationResult;
        const range2 = this.scale.range;
        const text2 = datum.tickLabel ?? "";
        const sideFlag = label.getSideFlag();
        const labelX = sideFlag * (this.getTickSize() + label.spacing + this.seriesAreaPadding);
        const visible = text2 !== "" && text2 != null;
        const combinedRotation = rotation;
        return {
            ...this.getLabelStyles({
                value: datum.tickLabel
            }),
            tickId: datum.tickId,
            rotation: combinedRotation,
            text: text2,
            textAlign: textAlign,
            textBaseline: textBaseline,
            visible: visible,
            x: labelX,
            y: datum.translationY,
            rotationCenterX: labelX,
            rotationCenterY: datum.translationY,
            range: range2
        };
    }
};
$2fb96651e8aa1522$var$RadiusAxis.CrossLineConstructor = $2fb96651e8aa1522$var$RadiusCrossLine;
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property8
], $2fb96651e8aa1522$var$RadiusAxis.prototype, "positionAngle", 2);
// packages/ag-charts-enterprise/src/axes/radius-category/radiusCategoryAxis.ts
var { ProxyPropertyOnWrite: $2fb96651e8aa1522$var$ProxyPropertyOnWrite, Property: $2fb96651e8aa1522$var$Property9, CategoryScale: $2fb96651e8aa1522$var$CategoryScale2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadiusCategoryAxis = class extends $2fb96651e8aa1522$var$RadiusAxis {
    constructor(moduleCtx){
        super(moduleCtx, new $2fb96651e8aa1522$var$CategoryScale2());
        this.shape = "circle";
        this.groupPaddingInner = 0;
        this.paddingInner = 0;
        this.paddingOuter = 0;
    }
    normaliseDataDomain(domain) {
        return {
            domain: domain,
            clipped: false
        };
    }
    prepareGridPathTickData(data) {
        return data.slice().reverse();
    }
    getTickRadius(tickDatum) {
        const { scale: scale, innerRadiusRatio: innerRadiusRatio } = this;
        const maxRadius = scale.range[0];
        const minRadius = maxRadius * innerRadiusRatio;
        if ($2fb96651e8aa1522$var$CategoryScale2.is(scale)) {
            const ticks = scale.domain;
            const index = ticks.length - 1 - ticks.indexOf(tickDatum.tick);
            return index === 0 ? minRadius : scale.inset + scale.step * (index - 0.5) + scale.bandwidth / 2;
        } else {
            const tickRange = (maxRadius - minRadius) / scale.domain.length;
            return maxRadius - tickDatum.translationY + minRadius - tickRange / 2;
        }
    }
};
$2fb96651e8aa1522$var$RadiusCategoryAxis.className = "RadiusCategoryAxis";
$2fb96651e8aa1522$var$RadiusCategoryAxis.type = "radius-category";
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property9
], $2fb96651e8aa1522$var$RadiusCategoryAxis.prototype, "groupPaddingInner", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ProxyPropertyOnWrite("scale", "paddingInner"),
    $2fb96651e8aa1522$var$Property9
], $2fb96651e8aa1522$var$RadiusCategoryAxis.prototype, "paddingInner", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ProxyPropertyOnWrite("scale", "paddingOuter"),
    $2fb96651e8aa1522$var$Property9
], $2fb96651e8aa1522$var$RadiusCategoryAxis.prototype, "paddingOuter", 2);
// packages/ag-charts-enterprise/src/axes/radius-category/radiusCategoryAxisModule.ts
var $2fb96651e8aa1522$var$RadiusCategoryAxisModule = {
    type: "axis",
    optionsKey: "axes[]",
    packageType: "enterprise",
    chartTypes: [
        "polar"
    ],
    identifier: "radius-category",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$RadiusCategoryAxis(ctx)
};
var { Property: $2fb96651e8aa1522$var$Property10, normalisedExtentWithMetadata: $2fb96651e8aa1522$var$normalisedExtentWithMetadata2, LinearScale: $2fb96651e8aa1522$var$LinearScale2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadiusNumberAxis = class extends $2fb96651e8aa1522$var$RadiusAxis {
    constructor(moduleCtx){
        super(moduleCtx, new $2fb96651e8aa1522$var$LinearScale2());
        this.shape = "polygon";
    }
    prepareGridPathTickData(data) {
        const { scale: scale } = this;
        const domainTop = scale.domain[1];
        return data.filter(({ tick: tick })=>tick !== domainTop).sort((a, b)=>b.tick - a.tick);
    }
    getTickRadius(tickDatum) {
        const { scale: scale } = this;
        const maxRadius = scale.range[0];
        const minRadius = maxRadius * this.innerRadiusRatio;
        return maxRadius - tickDatum.translationY + minRadius;
    }
    normaliseDataDomain(d) {
        const { min: min, max: max } = this;
        const { extent: extent3, clipped: clipped } = $2fb96651e8aa1522$var$normalisedExtentWithMetadata2(d, min, max);
        return {
            domain: extent3,
            clipped: clipped
        };
    }
};
$2fb96651e8aa1522$var$RadiusNumberAxis.className = "RadiusNumberAxis";
$2fb96651e8aa1522$var$RadiusNumberAxis.type = "radius-number";
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property10
], $2fb96651e8aa1522$var$RadiusNumberAxis.prototype, "min", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property10
], $2fb96651e8aa1522$var$RadiusNumberAxis.prototype, "max", 2);
// packages/ag-charts-enterprise/src/axes/radius-number/radiusNumberAxisModule.ts
var $2fb96651e8aa1522$var$RadiusNumberAxisModule = {
    type: "axis",
    optionsKey: "axes[]",
    packageType: "enterprise",
    chartTypes: [
        "polar"
    ],
    identifier: "radius-number",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$RadiusNumberAxis(ctx)
};
var { ObserveChanges: $2fb96651e8aa1522$var$ObserveChanges, Property: $2fb96651e8aa1522$var$Property11 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$Animation = class extends (0, $iTJTu._ModuleSupport).BaseModuleInstance {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.enabled = true;
        ctx.animationManager.skip(false);
        this.destroyFns.push(()=>{
            ctx.animationManager.skip(true);
        });
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ObserveChanges((target, newValue)=>{
        target.ctx.animationManager.skip(!newValue);
    }),
    $2fb96651e8aa1522$var$Property11
], $2fb96651e8aa1522$var$Animation.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ObserveChanges((target, newValue)=>{
        target.ctx.animationManager.defaultDuration = newValue;
    }),
    $2fb96651e8aa1522$var$Property11
], $2fb96651e8aa1522$var$Animation.prototype, "duration", 2);
// packages/ag-charts-enterprise/src/features/animation/animationModule.ts
var $2fb96651e8aa1522$var$AnimationModule = {
    type: "root",
    optionsKey: "animation",
    packageType: "enterprise",
    chartTypes: [
        "cartesian",
        "polar",
        "hierarchy",
        "topology",
        "flow-proportion",
        "standalone",
        "gauge"
    ],
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$Animation(ctx),
    themeTemplate: {
        animation: {
            enabled: true
        }
    }
};
// packages/ag-charts-enterprise/src/features/text-input/textInputTemplate.html
var $2fb96651e8aa1522$var$textInputTemplate_default = '<div contenteditable="plaintext-only" class="ag-charts-text-input__textarea" tabindex="0"></div>';
// packages/ag-charts-enterprise/src/features/text-input/textInput.ts
var { focusCursorAtEnd: $2fb96651e8aa1522$var$focusCursorAtEnd } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$moduleId = "text-input";
var $2fb96651e8aa1522$var$canvasOverlay = "canvas-overlay";
var $2fb96651e8aa1522$var$TextInput = class extends (0, $iTJTu._ModuleSupport).BaseModuleInstance {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.layout = {
            getTextInputCoords: ()=>({
                    x: 0,
                    y: 0
                }),
            getTextPosition: ()=>"center",
            alignment: "center",
            textAlign: "center"
        };
        this.visible = false;
        this.element = ctx.domManager.addChild($2fb96651e8aa1522$var$canvasOverlay, $2fb96651e8aa1522$var$moduleId);
        this.element.classList.add("ag-charts-text-input");
        this.destroyFns.push(()=>ctx.domManager.removeChild($2fb96651e8aa1522$var$canvasOverlay, $2fb96651e8aa1522$var$moduleId));
    }
    setKeyDownHandler(handler) {
        this.element.addEventListener("keydown", handler);
        this.destroyFns.push(()=>this.element.removeEventListener("keydown", handler));
    }
    show(opts) {
        this.element.innerHTML = $2fb96651e8aa1522$var$textInputTemplate_default;
        const textArea = this.element.firstElementChild;
        (0, $idDdm.setAttribute)(textArea, "data-preventdefault", false);
        if (!textArea.isContentEditable) textArea.contentEditable = "true";
        textArea.setAttribute("placeholder", this.ctx.localeManager.t(opts.placeholderText ?? "inputTextareaPlaceholder"));
        if (opts.styles?.placeholderColor) textArea.style.setProperty("--placeholder-text-color", opts.styles?.placeholderColor);
        textArea.innerText = opts.text ?? "";
        textArea.style.color = opts.styles?.color ?? "inherit";
        textArea.style.fontFamily = opts.styles?.fontFamily ?? "inherit";
        textArea.style.fontSize = opts.styles?.fontSize ? `${opts.styles.fontSize}px` : "inherit";
        textArea.style.fontStyle = opts.styles?.fontStyle ?? "inherit";
        textArea.style.fontWeight = typeof opts.styles?.fontWeight === "number" ? `${opts.styles.fontWeight}` : opts.styles?.fontWeight ?? "inherit";
        $2fb96651e8aa1522$var$focusCursorAtEnd(textArea);
        textArea.addEventListener("input", ()=>{
            this.updatePosition();
            opts.onChange?.(this.getValue(), this.getBBox());
        });
        textArea.addEventListener("click", (event)=>{
            event.stopPropagation();
        });
        if (opts.layout) {
            this.layout = opts.layout;
            this.updatePosition();
        }
        opts.onChange?.(this.getValue(), this.getBBox());
        this.visible = true;
    }
    hide() {
        this.element.innerHTML = "";
        this.layout = {
            getTextInputCoords: ()=>({
                    x: 0,
                    y: 0
                }),
            getTextPosition: ()=>"center",
            alignment: "center",
            textAlign: "center"
        };
        this.visible = false;
    }
    isVisible() {
        return this.visible;
    }
    updateColor(color6) {
        if (!this.element.firstElementChild) return;
        this.element.firstElementChild.style.color = color6;
    }
    updateFontSize(fontSize) {
        if (!this.element.firstElementChild) return;
        this.element.firstElementChild.style.fontSize = `${fontSize}px`;
        this.updatePosition();
        return this.getBBox();
    }
    getValue() {
        if (!this.element.firstElementChild) return;
        return this.element.firstElementChild.innerText.trim();
    }
    updatePosition() {
        const { element: element } = this;
        const textArea = element.firstElementChild;
        if (!textArea) return;
        const sceneRect = this.ctx.domManager.getBoundingClientRect();
        const { width: width, getTextInputCoords: getTextInputCoords, getTextPosition: getTextPosition, alignment: alignment, textAlign: textAlign } = this.layout;
        element.style.setProperty("width", width ? `${width}px` : "unset");
        const textRect = textArea.getBoundingClientRect();
        const point = getTextInputCoords(textRect.height);
        let horizontalPosition = point.x;
        if (alignment === "center") horizontalPosition -= (width ?? textRect.width) / 2;
        else if (alignment === "right") horizontalPosition -= width ?? textRect.width;
        const position = getTextPosition();
        let verticalPosition = point.y;
        if (position === "center") verticalPosition -= textRect.height / 2;
        else if (position === "bottom") verticalPosition -= textRect.height;
        element.style.setProperty("top", `${verticalPosition}px`);
        element.style.setProperty("left", `${horizontalPosition}px`);
        element.style.setProperty("max-width", `${sceneRect.width - horizontalPosition}px`);
        element.style.setProperty("text-align", alignment);
        textArea.style.setProperty("text-align", textAlign);
    }
    getBBox() {
        const { left: left, top: top, width: width, height: height } = this.element.getBoundingClientRect();
        return new (0, $iTJTu._ModuleSupport).BBox(left, top, width, height);
    }
};
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties2, Property: $2fb96651e8aa1522$var$Property12 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$AxesButtons = class extends $2fb96651e8aa1522$var$BaseProperties2 {
    constructor(){
        super(...arguments);
        this.enabled = false;
        this.axes = "y";
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property12
], $2fb96651e8aa1522$var$AxesButtons.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property12
], $2fb96651e8aa1522$var$AxesButtons.prototype, "axes", 2);
// packages/ag-charts-enterprise/src/features/annotations/annotationTypes.ts
var $2fb96651e8aa1522$var$AnnotationType = /* @__PURE__ */ ((AnnotationType3)=>{
    AnnotationType3["Line"] = "line";
    AnnotationType3["HorizontalLine"] = "horizontal-line";
    AnnotationType3["VerticalLine"] = "vertical-line";
    AnnotationType3["DisjointChannel"] = "disjoint-channel";
    AnnotationType3["ParallelChannel"] = "parallel-channel";
    AnnotationType3["FibonacciRetracement"] = "fibonacci-retracement";
    AnnotationType3["FibonacciRetracementTrendBased"] = "fibonacci-retracement-trend-based";
    AnnotationType3["Callout"] = "callout";
    AnnotationType3["Comment"] = "comment";
    AnnotationType3["Note"] = "note";
    AnnotationType3["Text"] = "text";
    AnnotationType3["Arrow"] = "arrow";
    AnnotationType3["ArrowUp"] = "arrow-up";
    AnnotationType3["ArrowDown"] = "arrow-down";
    AnnotationType3["DateRange"] = "date-range";
    AnnotationType3["PriceRange"] = "price-range";
    AnnotationType3["DatePriceRange"] = "date-price-range";
    AnnotationType3["QuickDatePriceRange"] = "quick-date-price-range";
    return AnnotationType3;
})($2fb96651e8aa1522$var$AnnotationType || {});
var $2fb96651e8aa1522$var$ANNOTATION_TYPES = Object.values($2fb96651e8aa1522$var$AnnotationType);
function $2fb96651e8aa1522$var$stringToAnnotationType(value) {
    for (const t of $2fb96651e8aa1522$var$ANNOTATION_TYPES){
        if (t === value) return t;
    }
}
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties3, Property: $2fb96651e8aa1522$var$Property13 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$PointProperties = class extends $2fb96651e8aa1522$var$BaseProperties3 {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property13
], $2fb96651e8aa1522$var$PointProperties.prototype, "x", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property13
], $2fb96651e8aa1522$var$PointProperties.prototype, "y", 2);
var $2fb96651e8aa1522$var$ChannelAnnotationMiddleProperties = class extends $2fb96651e8aa1522$var$Stroke($2fb96651e8aa1522$var$LineStyle($2fb96651e8aa1522$var$Visible($2fb96651e8aa1522$var$BaseProperties3))) {
};
var $2fb96651e8aa1522$var$AxisLabelProperties = class extends $2fb96651e8aa1522$var$Stroke($2fb96651e8aa1522$var$LineStyle($2fb96651e8aa1522$var$Fill($2fb96651e8aa1522$var$Label($2fb96651e8aa1522$var$Font($2fb96651e8aa1522$var$BaseProperties3))))) {
    constructor(){
        super(...arguments);
        this.cornerRadius = 2;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property13
], $2fb96651e8aa1522$var$AxisLabelProperties.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property13
], $2fb96651e8aa1522$var$AxisLabelProperties.prototype, "cornerRadius", 2);
var $2fb96651e8aa1522$var$BackgroundProperties = class extends $2fb96651e8aa1522$var$Fill($2fb96651e8aa1522$var$BaseProperties3) {
};
var $2fb96651e8aa1522$var$HandleProperties = class extends $2fb96651e8aa1522$var$Stroke($2fb96651e8aa1522$var$LineStyle($2fb96651e8aa1522$var$Fill($2fb96651e8aa1522$var$BaseProperties3))) {
};
var $2fb96651e8aa1522$var$LineTextProperties = class extends $2fb96651e8aa1522$var$Font($2fb96651e8aa1522$var$BaseProperties3) {
    constructor(){
        super(...arguments);
        this.label = "";
        this.position = "top";
        this.alignment = "left";
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property13
], $2fb96651e8aa1522$var$LineTextProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property13
], $2fb96651e8aa1522$var$LineTextProperties.prototype, "position", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property13
], $2fb96651e8aa1522$var$LineTextProperties.prototype, "alignment", 2);
var $2fb96651e8aa1522$var$LabelTextProperties = class extends $2fb96651e8aa1522$var$Font($2fb96651e8aa1522$var$BaseProperties3) {
};
var $2fb96651e8aa1522$var$ChannelTextProperties = class extends $2fb96651e8aa1522$var$Font($2fb96651e8aa1522$var$BaseProperties3) {
    constructor(){
        super(...arguments);
        this.label = "";
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property13
], $2fb96651e8aa1522$var$ChannelTextProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property13
], $2fb96651e8aa1522$var$ChannelTextProperties.prototype, "position", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property13
], $2fb96651e8aa1522$var$ChannelTextProperties.prototype, "alignment", 2);
function $2fb96651e8aa1522$var$Annotation(Parent) {
    class AnnotationInternal extends $2fb96651e8aa1522$var$Lockable($2fb96651e8aa1522$var$Visible(Parent)) {
        constructor(){
            super(...arguments);
            // A uuid is required, over the usual incrementing index, as annotations can be restored from external databases
            this.id = (0, $idDdm.generateUUID)();
        }
    }
    return AnnotationInternal;
}
function $2fb96651e8aa1522$var$Line3(Parent) {
    class LineInternal extends Parent {
        constructor(){
            super(...arguments);
            this.start = new $2fb96651e8aa1522$var$PointProperties();
            this.end = new $2fb96651e8aa1522$var$PointProperties();
        }
    }
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], LineInternal.prototype, "start", 2);
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], LineInternal.prototype, "end", 2);
    return LineInternal;
}
function $2fb96651e8aa1522$var$Point(Parent) {
    class PointInternal extends Parent {
    }
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], PointInternal.prototype, "x", 2);
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], PointInternal.prototype, "y", 2);
    return PointInternal;
}
function $2fb96651e8aa1522$var$Value(Parent) {
    class ValueInternal extends Parent {
    }
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], ValueInternal.prototype, "value", 2);
    return ValueInternal;
}
function $2fb96651e8aa1522$var$Background(Parent) {
    class BackgroundInternal extends Parent {
        constructor(){
            super(...arguments);
            this.background = new $2fb96651e8aa1522$var$BackgroundProperties();
        }
    }
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], BackgroundInternal.prototype, "background", 2);
    return BackgroundInternal;
}
function $2fb96651e8aa1522$var$Handle(Parent) {
    class HandleInternal extends Parent {
        constructor(){
            super(...arguments);
            this.handle = new $2fb96651e8aa1522$var$HandleProperties();
        }
    }
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], HandleInternal.prototype, "handle", 2);
    return HandleInternal;
}
function $2fb96651e8aa1522$var$AxisLabel(Parent) {
    class AxisLabelInternal extends Parent {
        constructor(){
            super(...arguments);
            this.axisLabel = new $2fb96651e8aa1522$var$AxisLabelProperties();
        }
    }
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], AxisLabelInternal.prototype, "axisLabel", 2);
    return AxisLabelInternal;
}
function $2fb96651e8aa1522$var$Label(Parent) {
    class LabelInternal extends Parent {
        constructor(){
            super(...arguments);
            this.padding = void 0;
            this.textAlign = "center";
            this.formatter = void 0;
        }
    }
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], LabelInternal.prototype, "padding", 2);
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], LabelInternal.prototype, "textAlign", 2);
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], LabelInternal.prototype, "formatter", 2);
    return LabelInternal;
}
function $2fb96651e8aa1522$var$Cappable(Parent) {
    class CappableInternal extends Parent {
    }
    return CappableInternal;
}
function $2fb96651e8aa1522$var$Extendable(Parent) {
    class ExtendableInternal extends Parent {
    }
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], ExtendableInternal.prototype, "extendStart", 2);
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], ExtendableInternal.prototype, "extendEnd", 2);
    return ExtendableInternal;
}
function $2fb96651e8aa1522$var$Lockable(Parent) {
    class LockableInternal extends Parent {
    }
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], LockableInternal.prototype, "locked", 2);
    return LockableInternal;
}
function $2fb96651e8aa1522$var$Localisable(Parent) {
    class LocalisableInternal extends Parent {
        setLocaleManager(localeManager) {
            this.localeManager ?? (this.localeManager = localeManager);
        }
    }
    return LocalisableInternal;
}
function $2fb96651e8aa1522$var$Visible(Parent) {
    class VisibleInternal extends Parent {
    }
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], VisibleInternal.prototype, "visible", 2);
    return VisibleInternal;
}
function $2fb96651e8aa1522$var$Fill(Parent) {
    class FillInternal extends Parent {
    }
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], FillInternal.prototype, "fill", 2);
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], FillInternal.prototype, "fillOpacity", 2);
    return FillInternal;
}
function $2fb96651e8aa1522$var$Stroke(Parent) {
    class StrokeInternal extends Parent {
    }
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], StrokeInternal.prototype, "stroke", 2);
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], StrokeInternal.prototype, "strokeOpacity", 2);
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], StrokeInternal.prototype, "strokeWidth", 2);
    return StrokeInternal;
}
function $2fb96651e8aa1522$var$LineStyle(Parent) {
    class LineDashInternal extends Parent {
        constructor(){
            super(...arguments);
            this.lineCap = void 0;
            this.computedLineDash = void 0;
        }
    }
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], LineDashInternal.prototype, "lineDash", 2);
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], LineDashInternal.prototype, "lineDashOffset", 2);
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], LineDashInternal.prototype, "lineStyle", 2);
    return LineDashInternal;
}
function $2fb96651e8aa1522$var$Font(Parent) {
    class FontInternal extends Parent {
        constructor(){
            super(...arguments);
            this.fontSize = 12;
            this.fontFamily = "Verdana, sans-serif";
        }
    }
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], FontInternal.prototype, "fontStyle", 2);
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], FontInternal.prototype, "fontWeight", 2);
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], FontInternal.prototype, "fontSize", 2);
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], FontInternal.prototype, "fontFamily", 2);
    $2fb96651e8aa1522$var$__decorateClass([
        $2fb96651e8aa1522$var$Property13
    ], FontInternal.prototype, "color", 2);
    return FontInternal;
}
function $2fb96651e8aa1522$var$getGrouping(d) {
    if ((0, $idDdm.isNumber)(d) || (0, $idDdm.isString)(d) || (0, $idDdm.isDate)(d)) return {
        value: d,
        groupPercentage: 0
    };
    return d ?? {
        value: void 0,
        groupPercentage: 0
    };
}
function $2fb96651e8aa1522$var$getGroupingValue(d) {
    return $2fb96651e8aa1522$var$getGrouping(d)?.value;
}
// packages/ag-charts-enterprise/src/features/annotations/utils/values.ts
var { clampArray: $2fb96651e8aa1522$var$clampArray } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$convertLine(datum, context) {
    if (datum.start == null || datum.end == null) return;
    const start = $2fb96651e8aa1522$var$convertPoint(datum.start, context);
    const end = $2fb96651e8aa1522$var$convertPoint(datum.end, context);
    if (start == null || end == null) return;
    return {
        x1: start.x,
        y1: start.y,
        x2: end.x,
        y2: end.y
    };
}
function $2fb96651e8aa1522$var$convertPoint(point, context) {
    const x = $2fb96651e8aa1522$var$convert(point.x, context.xAxis);
    const y = $2fb96651e8aa1522$var$convert(point.y, context.yAxis);
    return {
        x: x,
        y: y
    };
}
function $2fb96651e8aa1522$var$convert(p, context) {
    if (p == null) return 0;
    const { value: value, groupPercentage: groupPercentage } = $2fb96651e8aa1522$var$getGrouping(p);
    const { scale: scale, snapToGroup: snapToGroup } = context;
    const width = scale.bandwidth === 0 ? scale.step ?? 0 : scale.bandwidth ?? 0;
    const offset = snapToGroup ? width / 2 : width * groupPercentage;
    return scale.convert(value) + offset;
}
function $2fb96651e8aa1522$var$invertCoords(coords, context) {
    const x = $2fb96651e8aa1522$var$invert(coords.x, context.xAxis);
    const y = $2fb96651e8aa1522$var$invert(coords.y, context.yAxis);
    return {
        x: x,
        y: y
    };
}
function $2fb96651e8aa1522$var$invert(n, context) {
    const { scale: scale } = context;
    if (context.continuous && scale.step == null) return context.scaleInvert(n);
    const value = context.scaleInvertNearest(n);
    const width = scale.bandwidth === 0 ? scale.step : scale.bandwidth ?? 0;
    const bandStart = scale.convert(value);
    const bandEnd = bandStart + width;
    const position = $2fb96651e8aa1522$var$clampArray(n, scale.range);
    const groupPercentage = bandStart === bandEnd ? 0 : (position - bandStart) / (bandEnd - bandStart);
    return {
        value: value,
        groupPercentage: groupPercentage
    };
}
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties4 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$StartEndProperties = class extends $2fb96651e8aa1522$var$Annotation($2fb96651e8aa1522$var$Line3($2fb96651e8aa1522$var$Handle($2fb96651e8aa1522$var$BaseProperties4))) {
    constructor(){
        super(...arguments);
        this.snapToAngle = 45;
    }
    getDefaultColor(_colorPickerType) {
        return void 0;
    }
    getDefaultOpacity(_colorPickerType) {
        return void 0;
    }
};
// packages/ag-charts-enterprise/src/features/annotations/properties/textualStartEndProperties.ts
var { Property: $2fb96651e8aa1522$var$Property14 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$TextualStartEndProperties = class extends $2fb96651e8aa1522$var$Localisable($2fb96651e8aa1522$var$Label($2fb96651e8aa1522$var$Font($2fb96651e8aa1522$var$StartEndProperties))) {
    constructor(){
        super(...arguments);
        this.text = "";
        this.position = "top";
        this.alignment = "left";
        this.placement = "inside";
        this.placeholderText = "inputTextareaPlaceholder";
    }
    getDefaultColor(_colorPickerType) {
        return this.color;
    }
    getDefaultOpacity(_colorPickerType) {
        return void 0;
    }
    getPlaceholderColor() {
        return void 0;
    }
    getPadding() {
        const { padding: padding = 0 } = this;
        return {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    getText() {
        const isPlaceholder = this.text.length == 0;
        let text2 = this.text;
        if (isPlaceholder) {
            text2 = this.placeholderText ?? "";
            if (this.localeManager) text2 = this.localeManager.t(text2);
        }
        return {
            text: text2,
            isPlaceholder: isPlaceholder
        };
    }
    getTextInputCoords(context, _height) {
        return $2fb96651e8aa1522$var$convertPoint(this.end, context);
    }
    getTextPosition() {
        return this.position;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property14
], $2fb96651e8aa1522$var$TextualStartEndProperties.prototype, "text", 2);
// packages/ag-charts-enterprise/src/features/annotations/callout/calloutProperties.ts
var { Property: $2fb96651e8aa1522$var$Property15, Color: $2fb96651e8aa1522$var$Color } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$DEFAULT_CALLOUT_PADDING = {
    top: 6,
    right: 12,
    bottom: 9,
    left: 12
};
var $2fb96651e8aa1522$var$CalloutProperties = class extends $2fb96651e8aa1522$var$Fill($2fb96651e8aa1522$var$Stroke($2fb96651e8aa1522$var$TextualStartEndProperties)) {
    constructor(){
        super(...arguments);
        this.type = "callout" /* Callout */ ;
        this.position = "bottom";
        this.alignment = "left";
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "callout" /* Callout */ ;
    }
    getDefaultColor(colorPickerType) {
        switch(colorPickerType){
            case `fill-color`:
                return this.fill;
            case `line-color`:
                return this.stroke;
            case `text-color`:
            default:
                return this.color;
        }
    }
    getDefaultOpacity(colorPickerType) {
        switch(colorPickerType){
            case `fill-color`:
                return this.fillOpacity;
            case `line-color`:
                return this.strokeOpacity;
            case `text-color`:
            default:
                return void 0;
        }
    }
    getPlaceholderColor() {
        const { r: r, g: g, b: b } = $2fb96651e8aa1522$var$Color.fromString(this.color ?? "#888888");
        return new $2fb96651e8aa1522$var$Color(r, g, b, 0.66).toString();
    }
    getPadding() {
        const { padding: padding } = this;
        if (padding == null) return {
            ...$2fb96651e8aa1522$var$DEFAULT_CALLOUT_PADDING
        };
        return {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    getTextInputCoords(context, height) {
        const coords = super.getTextInputCoords(context, height);
        const padding = this.getPadding();
        const paddingLeft = padding.left ?? 0;
        const paddingBottom = padding.bottom ?? 0;
        return {
            x: coords.x + paddingLeft,
            y: coords.y - paddingBottom
        };
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property15
], $2fb96651e8aa1522$var$CalloutProperties.prototype, "type", 2);
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties5, Property: $2fb96651e8aa1522$var$Property16 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$TextualPointProperties = class extends $2fb96651e8aa1522$var$Annotation($2fb96651e8aa1522$var$Point($2fb96651e8aa1522$var$Handle($2fb96651e8aa1522$var$Label($2fb96651e8aa1522$var$Font($2fb96651e8aa1522$var$BaseProperties5))))) {
    constructor(){
        super(...arguments);
        this.text = "";
        this.position = "top";
        this.alignment = "left";
        this.placement = "inside";
        this.placeholderText = "inputTextareaPlaceholder";
    }
    getDefaultColor(_colorPickerType) {
        return this.color;
    }
    getDefaultOpacity(_colorPickerType) {
        return void 0;
    }
    getPlaceholderColor() {
        return void 0;
    }
    getPadding() {
        const { padding: padding = 0 } = this;
        return {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    getText() {
        const isPlaceholder = this.text.length == 0;
        const text2 = !isPlaceholder ? this.text : this.placeholderText ?? "";
        return {
            text: text2,
            isPlaceholder: isPlaceholder
        };
    }
    getTextInputCoords(context, _height) {
        return $2fb96651e8aa1522$var$convertPoint(this, context);
    }
    getTextPosition() {
        return this.position;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property16
], $2fb96651e8aa1522$var$TextualPointProperties.prototype, "text", 2);
// packages/ag-charts-enterprise/src/features/annotations/comment/commentProperties.ts
var { Property: $2fb96651e8aa1522$var$Property17, Color: $2fb96651e8aa1522$var$Color2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$DEFAULT_COMMENT_PADDING = {
    top: 8,
    right: 14,
    bottom: 8,
    left: 14
};
var $2fb96651e8aa1522$var$CommentProperties = class extends $2fb96651e8aa1522$var$Fill($2fb96651e8aa1522$var$Stroke($2fb96651e8aa1522$var$TextualPointProperties)) {
    constructor(){
        super(...arguments);
        this.type = "comment" /* Comment */ ;
        this.position = "bottom";
        this.alignment = "left";
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "comment" /* Comment */ ;
    }
    getDefaultColor(colorPickerType) {
        switch(colorPickerType){
            case `fill-color`:
                return this.fill;
            case `line-color`:
                return this.stroke;
            case `text-color`:
            default:
                return this.color;
        }
    }
    getDefaultOpacity(colorPickerType) {
        switch(colorPickerType){
            case `fill-color`:
                return this.fillOpacity;
            case `line-color`:
                return this.strokeOpacity;
            case `text-color`:
            default:
                return void 0;
        }
    }
    getPlaceholderColor() {
        const { r: r, g: g, b: b } = $2fb96651e8aa1522$var$Color2.fromString(this.color ?? "#888888");
        return new $2fb96651e8aa1522$var$Color2(r, g, b, 0.66).toString();
    }
    getPadding() {
        const { padding: padding, fontSize: fontSize } = this;
        if (padding == null) return {
            top: Math.max(fontSize * 0.4, $2fb96651e8aa1522$var$DEFAULT_COMMENT_PADDING.top),
            bottom: Math.max(fontSize * 0.4, $2fb96651e8aa1522$var$DEFAULT_COMMENT_PADDING.bottom),
            left: Math.max(fontSize * 0.8, $2fb96651e8aa1522$var$DEFAULT_COMMENT_PADDING.left),
            right: Math.max(fontSize * 0.8, $2fb96651e8aa1522$var$DEFAULT_COMMENT_PADDING.right)
        };
        return {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    getTextInputCoords(context, height) {
        const coords = super.getTextInputCoords(context, height);
        const padding = this.getPadding();
        return {
            x: coords.x + padding.left,
            y: coords.y - padding.bottom
        };
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property17
], $2fb96651e8aa1522$var$CommentProperties.prototype, "type", 2);
var { Vec2: $2fb96651e8aa1522$var$Vec2 } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$getLineStyle(lineDash, lineStyle) {
    return lineDash ? "dashed" : lineStyle ?? "solid";
}
function $2fb96651e8aa1522$var$getComputedLineDash(strokeWidth, styleType) {
    switch(styleType){
        case "solid":
            return [];
        case "dashed":
            return [
                strokeWidth * 4,
                strokeWidth * 2
            ];
        case "dotted":
            return [
                0,
                strokeWidth * 2
            ];
    }
}
function $2fb96651e8aa1522$var$getLineDash(lineDash, computedLineDash, lineStyle, strokeWidth) {
    const styleType = $2fb96651e8aa1522$var$getLineStyle(lineDash, lineStyle);
    return computedLineDash ?? lineDash ?? $2fb96651e8aa1522$var$getComputedLineDash(strokeWidth ?? 1, styleType);
}
function $2fb96651e8aa1522$var$getLineCap(lineCap, lineDash, lineStyle) {
    const styleType = $2fb96651e8aa1522$var$getLineStyle(lineDash, lineStyle);
    return lineCap ?? styleType === "dotted" ? "round" : void 0;
}
function $2fb96651e8aa1522$var$boundsIntersections(coords, bounds) {
    const [p1, p2] = $2fb96651e8aa1522$var$Vec2.from(coords);
    const reflection = bounds.height;
    const gradient = $2fb96651e8aa1522$var$Vec2.gradient(p2, p1, reflection);
    const intercept = $2fb96651e8aa1522$var$Vec2.intercept(p2, gradient, reflection);
    const fallback = [
        {
            x: p1.x,
            y: reflection ?? 0
        },
        {
            x: p1.x,
            y: reflection == null ? bounds.height : reflection - bounds.height
        }
    ];
    if (gradient === Infinity) return fallback;
    let points = [
        $2fb96651e8aa1522$var$Vec2.intersectAtY(gradient, intercept, 0, reflection),
        $2fb96651e8aa1522$var$Vec2.intersectAtY(gradient, intercept, bounds.height, reflection),
        $2fb96651e8aa1522$var$Vec2.intersectAtX(gradient, intercept, 0, reflection),
        $2fb96651e8aa1522$var$Vec2.intersectAtX(gradient, intercept, bounds.width, reflection)
    ];
    points = points.filter((p)=>p.x >= bounds.x && p.x <= bounds.width && p.y >= bounds.y && p.y <= bounds.height).sort((a, b)=>{
        if (a.x === b.x) return 0;
        return a.x < b.x ? -1 : 1;
    });
    if (points.length !== 2) return fallback;
    return points;
}
// packages/ag-charts-enterprise/src/features/annotations/measurer/measurerProperties.ts
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties6, Property: $2fb96651e8aa1522$var$Property18 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$MeasurerStatisticsDivider = class extends $2fb96651e8aa1522$var$Stroke($2fb96651e8aa1522$var$BaseProperties6) {
};
var $2fb96651e8aa1522$var$MeasurerStatistics = class extends $2fb96651e8aa1522$var$Font($2fb96651e8aa1522$var$Fill($2fb96651e8aa1522$var$Stroke($2fb96651e8aa1522$var$BaseProperties6))) {
    constructor(){
        super(...arguments);
        this.divider = new $2fb96651e8aa1522$var$MeasurerStatisticsDivider();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property18
], $2fb96651e8aa1522$var$MeasurerStatistics.prototype, "divider", 2);
var $2fb96651e8aa1522$var$MeasurerDirectionProperties = class extends $2fb96651e8aa1522$var$Fill($2fb96651e8aa1522$var$Stroke($2fb96651e8aa1522$var$Handle($2fb96651e8aa1522$var$BaseProperties6))) {
    constructor(){
        super(...arguments);
        this.statistics = new $2fb96651e8aa1522$var$MeasurerStatistics();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property18
], $2fb96651e8aa1522$var$MeasurerDirectionProperties.prototype, "statistics", 2);
var $2fb96651e8aa1522$var$MeasurerTypeProperties = class extends $2fb96651e8aa1522$var$Localisable($2fb96651e8aa1522$var$Background($2fb96651e8aa1522$var$Stroke($2fb96651e8aa1522$var$LineStyle($2fb96651e8aa1522$var$StartEndProperties)))) {
    constructor(){
        super(...arguments);
        this.direction = "both";
        this.hasDateRange = false;
        this.hasPriceRange = false;
        this.statistics = new $2fb96651e8aa1522$var$MeasurerStatistics();
        this.getVolume = ()=>void 0;
        this.text = new $2fb96651e8aa1522$var$LineTextProperties();
    }
    getDefaultColor(colorPickerType) {
        switch(colorPickerType){
            case `fill-color`:
                return this.background.fill;
            case `line-color`:
                return this.stroke;
            case `text-color`:
                return this.text.color;
        }
    }
    getDefaultOpacity(colorPickerType) {
        switch(colorPickerType){
            case `fill-color`:
                return this.background.fillOpacity;
            case `line-color`:
                return this.strokeOpacity;
        }
    }
    getLineDash() {
        return $2fb96651e8aa1522$var$getLineDash(this.lineDash, this.computedLineDash, this.lineStyle, this.strokeWidth);
    }
    getLineCap() {
        return $2fb96651e8aa1522$var$getLineCap(this.lineCap, this.lineDash, this.lineStyle);
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property18
], $2fb96651e8aa1522$var$MeasurerTypeProperties.prototype, "statistics", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property18
], $2fb96651e8aa1522$var$MeasurerTypeProperties.prototype, "text", 2);
function $2fb96651e8aa1522$var$DateRange(Parent) {
    class DateRangeInternal extends Parent {
        constructor(){
            super(...arguments);
            this.hasDateRange = true;
        }
    }
    return DateRangeInternal;
}
function $2fb96651e8aa1522$var$PriceRange(Parent) {
    class PriceRangeInternal extends Parent {
        constructor(){
            super(...arguments);
            this.hasPriceRange = true;
        }
    }
    return PriceRangeInternal;
}
var $2fb96651e8aa1522$var$DateRangeProperties = class extends $2fb96651e8aa1522$var$DateRange($2fb96651e8aa1522$var$MeasurerTypeProperties) {
    constructor(){
        super(...arguments);
        this.type = "date-range" /* DateRange */ ;
        this.direction = "horizontal";
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "date-range" /* DateRange */ ;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property18
], $2fb96651e8aa1522$var$DateRangeProperties.prototype, "type", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property18
], $2fb96651e8aa1522$var$DateRangeProperties.prototype, "extendAbove", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property18
], $2fb96651e8aa1522$var$DateRangeProperties.prototype, "extendBelow", 2);
var $2fb96651e8aa1522$var$PriceRangeProperties = class extends $2fb96651e8aa1522$var$PriceRange($2fb96651e8aa1522$var$MeasurerTypeProperties) {
    constructor(){
        super(...arguments);
        this.type = "price-range" /* PriceRange */ ;
        this.direction = "vertical";
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "price-range" /* PriceRange */ ;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property18
], $2fb96651e8aa1522$var$PriceRangeProperties.prototype, "type", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property18
], $2fb96651e8aa1522$var$PriceRangeProperties.prototype, "extendLeft", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property18
], $2fb96651e8aa1522$var$PriceRangeProperties.prototype, "extendRight", 2);
var $2fb96651e8aa1522$var$DatePriceRangeProperties = class extends $2fb96651e8aa1522$var$DateRange($2fb96651e8aa1522$var$PriceRange($2fb96651e8aa1522$var$MeasurerTypeProperties)) {
    constructor(){
        super(...arguments);
        this.type = "date-price-range" /* DatePriceRange */ ;
        this.direction = "both";
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "date-price-range" /* DatePriceRange */ ;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property18
], $2fb96651e8aa1522$var$DatePriceRangeProperties.prototype, "type", 2);
var $2fb96651e8aa1522$var$QuickDatePriceRangeProperties = class extends $2fb96651e8aa1522$var$DateRange($2fb96651e8aa1522$var$PriceRange($2fb96651e8aa1522$var$MeasurerTypeProperties)) {
    constructor(){
        super(...arguments);
        this.type = "quick-date-price-range" /* QuickDatePriceRange */ ;
        this.up = new $2fb96651e8aa1522$var$MeasurerDirectionProperties();
        this.down = new $2fb96651e8aa1522$var$MeasurerDirectionProperties();
        this.direction = "both";
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "quick-date-price-range" /* QuickDatePriceRange */ ;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property18
], $2fb96651e8aa1522$var$QuickDatePriceRangeProperties.prototype, "type", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property18
], $2fb96651e8aa1522$var$QuickDatePriceRangeProperties.prototype, "up", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property18
], $2fb96651e8aa1522$var$QuickDatePriceRangeProperties.prototype, "down", 2);
var { TextWrapper: $2fb96651e8aa1522$var$TextWrapper2, CachedTextMeasurerPool: $2fb96651e8aa1522$var$CachedTextMeasurerPool, BBox: $2fb96651e8aa1522$var$BBox2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$ANNOTATION_TEXT_LINE_HEIGHT = 1.38;
function $2fb96651e8aa1522$var$getTextWrapOptions(options) {
    return {
        font: {
            fontFamily: options.fontFamily,
            fontSize: options.fontSize,
            fontStyle: options.fontStyle,
            fontWeight: options.fontWeight
        },
        textAlign: options.textAlign,
        textBaseline: options.position == "center" ? "middle" : options.position,
        lineHeight: $2fb96651e8aa1522$var$ANNOTATION_TEXT_LINE_HEIGHT,
        avoidOrphans: false,
        textWrap: "always"
    };
}
function $2fb96651e8aa1522$var$wrapText(options, text2, width) {
    return width ? $2fb96651e8aa1522$var$TextWrapper2.wrapText(text2, {
        ...$2fb96651e8aa1522$var$getTextWrapOptions(options),
        maxWidth: width
    }) : text2;
}
function $2fb96651e8aa1522$var$measureAnnotationText(options, text2) {
    const textOptions = $2fb96651e8aa1522$var$getTextWrapOptions(options);
    const { lineMetrics: lineMetrics, width: width } = $2fb96651e8aa1522$var$CachedTextMeasurerPool.measureLines(text2, textOptions);
    const height = lineMetrics.length * (options.fontSize ?? 14) * $2fb96651e8aa1522$var$ANNOTATION_TEXT_LINE_HEIGHT;
    return {
        width: width,
        height: height
    };
}
function $2fb96651e8aa1522$var$getBBox(options, text2, coords, bbox) {
    let width = bbox?.width ?? 0;
    let height = bbox?.height ?? 0;
    if (!bbox) {
        const wrappedText = options.width != null ? $2fb96651e8aa1522$var$wrapText(options, text2, options.width) : text2;
        ({ width: width, height: height } = $2fb96651e8aa1522$var$measureAnnotationText(options, wrappedText));
    }
    return new $2fb96651e8aa1522$var$BBox2(coords.x, coords.y, width, height);
}
function $2fb96651e8aa1522$var$updateTextNode(node, text2, isPlaceholder, config, { x: x, y: y }, textBaseline) {
    const { visible: visible = true, fontFamily: fontFamily, fontSize: fontSize = 14, fontStyle: fontStyle, fontWeight: fontWeight, textAlign: textAlign } = config;
    const lineHeight = fontSize * $2fb96651e8aa1522$var$ANNOTATION_TEXT_LINE_HEIGHT;
    textBaseline ?? (textBaseline = config.position == "center" ? "middle" : config.position);
    const fill = isPlaceholder ? config.getPlaceholderColor() : config.color;
    node.setProperties({
        x: x,
        y: y,
        visible: visible,
        text: text2,
        fill: fill,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontStyle: fontStyle,
        fontWeight: fontWeight,
        textAlign: textAlign,
        lineHeight: lineHeight,
        textBaseline: textBaseline
    });
}
// packages/ag-charts-enterprise/src/features/annotations/note/noteProperties.ts
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties7, Property: $2fb96651e8aa1522$var$Property19 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$DEFAULT_NOTE_PADDING = 10;
var $2fb96651e8aa1522$var$HANDLE_SIZE = 11;
var $2fb96651e8aa1522$var$ICON_HEIGHT = 20;
var $2fb96651e8aa1522$var$ICON_WIDTH = 22;
var $2fb96651e8aa1522$var$ICON_SPACING = 10;
var $2fb96651e8aa1522$var$LABEL_OFFSET = $2fb96651e8aa1522$var$ICON_HEIGHT + $2fb96651e8aa1522$var$ICON_SPACING;
var $2fb96651e8aa1522$var$TOOLBAR_OFFSET = 34;
var $2fb96651e8aa1522$var$NoteBackgroundProperties = class extends $2fb96651e8aa1522$var$Fill($2fb96651e8aa1522$var$Stroke($2fb96651e8aa1522$var$BaseProperties7)) {
};
var $2fb96651e8aa1522$var$NoteProperties = class extends $2fb96651e8aa1522$var$Fill($2fb96651e8aa1522$var$Stroke($2fb96651e8aa1522$var$TextualPointProperties)) {
    constructor(){
        super(...arguments);
        this.type = "note" /* Note */ ;
        this.background = new $2fb96651e8aa1522$var$NoteBackgroundProperties();
        this.position = "bottom";
        this.alignment = "center";
        this.width = 200;
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "note" /* Note */ ;
    }
    getDefaultColor(colorPickerType) {
        switch(colorPickerType){
            case `line-color`:
                return this.fill;
            case `text-color`:
                return this.color;
        }
    }
    getDefaultOpacity(colorPickerType) {
        switch(colorPickerType){
            case `line-color`:
                return this.fillOpacity;
            case `text-color`:
                return void 0;
        }
    }
    getPadding() {
        const padding = this.padding ?? $2fb96651e8aa1522$var$DEFAULT_NOTE_PADDING;
        return {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    getTextInputCoords(context, height) {
        const { width: width, text: text2 } = this;
        const textInputCoords = super.getTextInputCoords(context, height);
        const padding = this.getPadding().top;
        const bbox = $2fb96651e8aa1522$var$getBBox(this, text2, textInputCoords);
        bbox.x = (0, $idDdm.clamp)(width / 2, bbox.x, context.seriesRect.width - width / 2);
        const topY = bbox.y - $2fb96651e8aa1522$var$LABEL_OFFSET - padding * 2;
        const bottomY = bbox.y + $2fb96651e8aa1522$var$HANDLE_SIZE + padding * 2;
        const textHeight = Math.max(bbox.height, height);
        if (topY - textHeight - $2fb96651e8aa1522$var$TOOLBAR_OFFSET < 0) {
            bbox.y = bottomY;
            this.position = "top";
        } else {
            bbox.y = topY + padding;
            this.position = "bottom";
        }
        return {
            x: bbox.x,
            y: bbox.y
        };
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property19
], $2fb96651e8aa1522$var$NoteProperties.prototype, "type", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property19
], $2fb96651e8aa1522$var$NoteProperties.prototype, "background", 2);
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties8 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$PointProperties2 = class extends $2fb96651e8aa1522$var$Annotation($2fb96651e8aa1522$var$Point($2fb96651e8aa1522$var$Handle($2fb96651e8aa1522$var$BaseProperties8))) {
    getDefaultColor(_colorPickerType) {
        return void 0;
    }
    getDefaultOpacity(_colorPickerType) {
        return void 0;
    }
};
// packages/ag-charts-enterprise/src/features/annotations/properties/shapePointProperties.ts
var $2fb96651e8aa1522$var$ShapePointProperties = class _ShapePointProperties extends $2fb96651e8aa1522$var$Fill($2fb96651e8aa1522$var$PointProperties2) {
    constructor(){
        super(...arguments);
        this.size = 32;
    }
    static is(value) {
        return value instanceof _ShapePointProperties;
    }
    getDefaultColor(colorPickerType) {
        return colorPickerType === `fill-color` ? this.fill : void 0;
    }
    getDefaultOpacity(colorPickerType) {
        return colorPickerType === `fill-color` ? this.fillOpacity : void 0;
    }
};
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties9, Property: $2fb96651e8aa1522$var$Property20 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$HorizontalLineProperties = class extends $2fb96651e8aa1522$var$Annotation($2fb96651e8aa1522$var$Value($2fb96651e8aa1522$var$Handle($2fb96651e8aa1522$var$AxisLabel($2fb96651e8aa1522$var$Stroke($2fb96651e8aa1522$var$LineStyle($2fb96651e8aa1522$var$BaseProperties9)))))) {
    constructor(){
        super(...arguments);
        this.direction = "horizontal";
        this.type = "horizontal-line" /* HorizontalLine */ ;
        this.text = new $2fb96651e8aa1522$var$LineTextProperties();
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "horizontal-line" /* HorizontalLine */ ;
    }
    getDefaultColor() {
        return this.stroke;
    }
    getDefaultOpacity() {
        return this.strokeOpacity;
    }
    getLineDash() {
        return $2fb96651e8aa1522$var$getLineDash(this.lineDash, this.computedLineDash, this.lineStyle, this.strokeWidth);
    }
    getLineCap() {
        return $2fb96651e8aa1522$var$getLineCap(this.lineCap, this.lineDash, this.lineStyle);
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property20
], $2fb96651e8aa1522$var$HorizontalLineProperties.prototype, "type", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property20
], $2fb96651e8aa1522$var$HorizontalLineProperties.prototype, "text", 2);
var $2fb96651e8aa1522$var$VerticalLineProperties = class extends $2fb96651e8aa1522$var$Annotation($2fb96651e8aa1522$var$Value($2fb96651e8aa1522$var$Handle($2fb96651e8aa1522$var$AxisLabel($2fb96651e8aa1522$var$Stroke($2fb96651e8aa1522$var$LineStyle($2fb96651e8aa1522$var$BaseProperties9)))))) {
    constructor(){
        super(...arguments);
        this.direction = "vertical";
        this.type = "vertical-line" /* VerticalLine */ ;
        this.text = new $2fb96651e8aa1522$var$LineTextProperties();
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "vertical-line" /* VerticalLine */ ;
    }
    getDefaultColor() {
        return this.stroke;
    }
    getDefaultOpacity() {
        return this.strokeOpacity;
    }
    getLineDash() {
        return $2fb96651e8aa1522$var$getLineDash(this.lineDash, this.computedLineDash, this.lineStyle, this.strokeWidth);
    }
    getLineCap() {
        return $2fb96651e8aa1522$var$getLineCap(this.lineCap, this.lineDash, this.lineStyle);
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property20
], $2fb96651e8aa1522$var$VerticalLineProperties.prototype, "type", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property20
], $2fb96651e8aa1522$var$VerticalLineProperties.prototype, "text", 2);
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties10, Property: $2fb96651e8aa1522$var$Property21 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$DisjointChannelProperties = class extends $2fb96651e8aa1522$var$Annotation($2fb96651e8aa1522$var$Background($2fb96651e8aa1522$var$Line3($2fb96651e8aa1522$var$Handle($2fb96651e8aa1522$var$Extendable($2fb96651e8aa1522$var$Stroke($2fb96651e8aa1522$var$LineStyle($2fb96651e8aa1522$var$BaseProperties10))))))) {
    constructor(){
        super(...arguments);
        this.type = "disjoint-channel" /* DisjointChannel */ ;
        this.text = new $2fb96651e8aa1522$var$ChannelTextProperties();
        this.snapToAngle = 45;
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "disjoint-channel" /* DisjointChannel */ ;
    }
    get bottom() {
        const bottom = {
            start: {
                x: this.start.x,
                y: this.start.y
            },
            end: {
                x: this.end.x,
                y: this.end.y
            }
        };
        if (typeof bottom.start.y === "number" && typeof bottom.end.y === "number") {
            bottom.start.y -= this.startHeight;
            bottom.end.y -= this.endHeight;
        } else (0, $idDdm.Logger).warnOnce(`Annotation [${this.type}] can only be used with a numeric y-axis.`);
        return bottom;
    }
    getDefaultColor(colorPickerType) {
        switch(colorPickerType){
            case `fill-color`:
                return this.background.fill;
            case `line-color`:
                return this.stroke;
            case "text-color":
                return this.text.color;
        }
    }
    getDefaultOpacity(colorPickerType) {
        switch(colorPickerType){
            case `fill-color`:
                return this.background.fillOpacity;
            case `line-color`:
                return this.strokeOpacity;
        }
    }
    getLineDash() {
        return $2fb96651e8aa1522$var$getLineDash(this.lineDash, this.computedLineDash, this.lineStyle, this.strokeWidth);
    }
    getLineCap() {
        return $2fb96651e8aa1522$var$getLineCap(this.lineCap, this.lineDash, this.lineStyle);
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property21
], $2fb96651e8aa1522$var$DisjointChannelProperties.prototype, "type", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property21
], $2fb96651e8aa1522$var$DisjointChannelProperties.prototype, "startHeight", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property21
], $2fb96651e8aa1522$var$DisjointChannelProperties.prototype, "endHeight", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property21
], $2fb96651e8aa1522$var$DisjointChannelProperties.prototype, "text", 2);
var { Property: $2fb96651e8aa1522$var$Property22 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$LineTypeProperties = class extends $2fb96651e8aa1522$var$Localisable($2fb96651e8aa1522$var$Cappable($2fb96651e8aa1522$var$Extendable($2fb96651e8aa1522$var$Stroke($2fb96651e8aa1522$var$LineStyle($2fb96651e8aa1522$var$StartEndProperties))))) {
    constructor(){
        super(...arguments);
        this.text = new $2fb96651e8aa1522$var$LineTextProperties();
    }
    getDefaultColor(colorPickerType) {
        switch(colorPickerType){
            case "line-color":
                return this.stroke;
            case "text-color":
                return this.text.color;
        }
    }
    getDefaultOpacity() {
        return this.strokeOpacity;
    }
    getLineDash() {
        return $2fb96651e8aa1522$var$getLineDash(this.lineDash, this.computedLineDash, this.lineStyle, this.strokeWidth);
    }
    getLineCap() {
        return $2fb96651e8aa1522$var$getLineCap(this.lineCap, this.lineDash, this.lineStyle);
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property22
], $2fb96651e8aa1522$var$LineTypeProperties.prototype, "text", 2);
var $2fb96651e8aa1522$var$ArrowProperties = class extends $2fb96651e8aa1522$var$LineTypeProperties {
    constructor(){
        super(...arguments);
        this.type = "arrow" /* Arrow */ ;
        this.endCap = "arrow";
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "arrow" /* Arrow */ ;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property22
], $2fb96651e8aa1522$var$ArrowProperties.prototype, "type", 2);
var $2fb96651e8aa1522$var$LineProperties = class extends $2fb96651e8aa1522$var$LineTypeProperties {
    constructor(){
        super(...arguments);
        this.type = "line" /* Line */ ;
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "line" /* Line */ ;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property22
], $2fb96651e8aa1522$var$LineProperties.prototype, "type", 2);
// packages/ag-charts-enterprise/src/features/annotations/properties/fibonacciProperties.ts
var { Property: $2fb96651e8aa1522$var$Property23 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$FibonacciProperties = class extends $2fb96651e8aa1522$var$LineTypeProperties {
    constructor(){
        super(...arguments);
        this.label = new $2fb96651e8aa1522$var$LabelTextProperties();
        this.reverse = false;
        this.showFill = true;
        this.isMultiColor = true;
        this.strokes = [];
        this.bands = 10;
    }
    getDefaultColor(colorPickerType) {
        switch(colorPickerType){
            case "line-color":
                return this.rangeStroke ?? this.stroke;
            case "text-color":
                return this.text.color;
        }
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property23
], $2fb96651e8aa1522$var$FibonacciProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property23
], $2fb96651e8aa1522$var$FibonacciProperties.prototype, "reverse", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property23
], $2fb96651e8aa1522$var$FibonacciProperties.prototype, "showFill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property23
], $2fb96651e8aa1522$var$FibonacciProperties.prototype, "isMultiColor", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property23
], $2fb96651e8aa1522$var$FibonacciProperties.prototype, "strokes", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property23
], $2fb96651e8aa1522$var$FibonacciProperties.prototype, "rangeStroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property23
], $2fb96651e8aa1522$var$FibonacciProperties.prototype, "bands", 2);
// packages/ag-charts-enterprise/src/features/annotations/fibonacci-retracement-trend-based/fibonacciRetracementTrendBasedProperties.ts
var { Property: $2fb96651e8aa1522$var$Property24 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedProperties = class extends $2fb96651e8aa1522$var$FibonacciProperties {
    constructor(){
        super(...arguments);
        this.type = "fibonacci-retracement-trend-based" /* FibonacciRetracementTrendBased */ ;
        this.endRetracement = new $2fb96651e8aa1522$var$PointProperties();
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "fibonacci-retracement-trend-based" /* FibonacciRetracementTrendBased */ ;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property24
], $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedProperties.prototype, "type", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property24
], $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedProperties.prototype, "endRetracement", 2);
var { Property: $2fb96651e8aa1522$var$Property25 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$FibonacciRetracementProperties = class extends $2fb96651e8aa1522$var$FibonacciProperties {
    constructor(){
        super(...arguments);
        this.type = "fibonacci-retracement" /* FibonacciRetracement */ ;
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "fibonacci-retracement" /* FibonacciRetracement */ ;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property25
], $2fb96651e8aa1522$var$FibonacciRetracementProperties.prototype, "type", 2);
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties11, Property: $2fb96651e8aa1522$var$Property26 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$ParallelChannelProperties = class extends $2fb96651e8aa1522$var$Annotation($2fb96651e8aa1522$var$Background($2fb96651e8aa1522$var$Line3($2fb96651e8aa1522$var$Handle($2fb96651e8aa1522$var$Extendable($2fb96651e8aa1522$var$Stroke($2fb96651e8aa1522$var$LineStyle($2fb96651e8aa1522$var$BaseProperties11))))))) {
    constructor(){
        super(...arguments);
        this.type = "parallel-channel" /* ParallelChannel */ ;
        this.middle = new $2fb96651e8aa1522$var$ChannelAnnotationMiddleProperties();
        this.text = new $2fb96651e8aa1522$var$ChannelTextProperties();
        this.snapToAngle = 45;
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "parallel-channel" /* ParallelChannel */ ;
    }
    get bottom() {
        const bottom = {
            start: {
                x: this.start.x,
                y: this.start.y
            },
            end: {
                x: this.end.x,
                y: this.end.y
            }
        };
        if (typeof bottom.start.y === "number" && typeof bottom.end.y === "number") {
            bottom.start.y -= this.height;
            bottom.end.y -= this.height;
        } else (0, $idDdm.Logger).warnOnce(`Annotation [${this.type}] can only be used with a numeric y-axis.`);
        return bottom;
    }
    getDefaultColor(colorPickerType) {
        switch(colorPickerType){
            case `fill-color`:
                return this.background.fill;
            case `line-color`:
                return this.stroke;
            case "text-color":
                return this.text.color;
        }
    }
    getDefaultOpacity(colorPickerType) {
        switch(colorPickerType){
            case `fill-color`:
                return this.background.fillOpacity;
            case `line-color`:
                return this.strokeOpacity;
        }
    }
    getLineDash() {
        return $2fb96651e8aa1522$var$getLineDash(this.lineDash, this.computedLineDash, this.lineStyle, this.strokeWidth);
    }
    getLineCap() {
        return $2fb96651e8aa1522$var$getLineCap(this.lineCap, this.lineDash, this.lineStyle);
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property26
], $2fb96651e8aa1522$var$ParallelChannelProperties.prototype, "type", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property26
], $2fb96651e8aa1522$var$ParallelChannelProperties.prototype, "height", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property26
], $2fb96651e8aa1522$var$ParallelChannelProperties.prototype, "middle", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property26
], $2fb96651e8aa1522$var$ParallelChannelProperties.prototype, "text", 2);
var { Property: $2fb96651e8aa1522$var$Property27 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$TextProperties = class extends $2fb96651e8aa1522$var$TextualPointProperties {
    constructor(){
        super(...arguments);
        this.type = "text" /* Text */ ;
        this.position = "bottom";
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "text" /* Text */ ;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property27
], $2fb96651e8aa1522$var$TextProperties.prototype, "type", 2);
// packages/ag-charts-enterprise/src/features/annotations/utils/types.ts
function $2fb96651e8aa1522$var$isEphemeralType(datum) {
    return $2fb96651e8aa1522$var$QuickDatePriceRangeProperties.is(datum);
}
function $2fb96651e8aa1522$var$isLineType(datum) {
    return $2fb96651e8aa1522$var$LineProperties.is(datum) || $2fb96651e8aa1522$var$HorizontalLineProperties.is(datum) || $2fb96651e8aa1522$var$VerticalLineProperties.is(datum) || $2fb96651e8aa1522$var$ArrowProperties.is(datum) || $2fb96651e8aa1522$var$isFibonacciType(datum);
}
function $2fb96651e8aa1522$var$isChannelType(datum) {
    return $2fb96651e8aa1522$var$DisjointChannelProperties.is(datum) || $2fb96651e8aa1522$var$ParallelChannelProperties.is(datum);
}
function $2fb96651e8aa1522$var$isFibonacciType(datum) {
    return $2fb96651e8aa1522$var$FibonacciRetracementProperties.is(datum) || $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedProperties.is(datum);
}
function $2fb96651e8aa1522$var$isTextType(datum) {
    return $2fb96651e8aa1522$var$CalloutProperties.is(datum) || $2fb96651e8aa1522$var$CommentProperties.is(datum) || $2fb96651e8aa1522$var$NoteProperties.is(datum) || $2fb96651e8aa1522$var$TextProperties.is(datum);
}
function $2fb96651e8aa1522$var$isMeasurerType(datum) {
    return $2fb96651e8aa1522$var$DateRangeProperties.is(datum) || $2fb96651e8aa1522$var$PriceRangeProperties.is(datum) || $2fb96651e8aa1522$var$DatePriceRangeProperties.is(datum) || $2fb96651e8aa1522$var$QuickDatePriceRangeProperties.is(datum);
}
// packages/ag-charts-enterprise/src/features/annotations/utils/has.ts
function $2fb96651e8aa1522$var$hasFontSize(datum) {
    return $2fb96651e8aa1522$var$isTextType(datum) && !$2fb96651e8aa1522$var$NoteProperties.is(datum);
}
function $2fb96651e8aa1522$var$hasLineStyle(datum) {
    return $2fb96651e8aa1522$var$isLineType(datum) || $2fb96651e8aa1522$var$isChannelType(datum) || $2fb96651e8aa1522$var$isMeasurerType(datum) && !$2fb96651e8aa1522$var$QuickDatePriceRangeProperties.is(datum);
}
function $2fb96651e8aa1522$var$hasLineColor(datum) {
    return $2fb96651e8aa1522$var$isLineType(datum) || $2fb96651e8aa1522$var$isChannelType(datum) || $2fb96651e8aa1522$var$isMeasurerType(datum) || $2fb96651e8aa1522$var$CalloutProperties.is(datum) || $2fb96651e8aa1522$var$NoteProperties.is(datum);
}
function $2fb96651e8aa1522$var$hasIconColor(datum) {
    return $2fb96651e8aa1522$var$NoteProperties.is(datum);
}
function $2fb96651e8aa1522$var$hasFillColor(datum) {
    return $2fb96651e8aa1522$var$isChannelType(datum) || $2fb96651e8aa1522$var$isMeasurerType(datum) || $2fb96651e8aa1522$var$CalloutProperties.is(datum) || $2fb96651e8aa1522$var$CommentProperties.is(datum) || $2fb96651e8aa1522$var$ShapePointProperties.is(datum);
}
function $2fb96651e8aa1522$var$hasTextColor(datum) {
    return $2fb96651e8aa1522$var$isTextType(datum) && !$2fb96651e8aa1522$var$NoteProperties.is(datum);
}
function $2fb96651e8aa1522$var$hasLineText(datum) {
    return ($2fb96651e8aa1522$var$isLineType(datum) || $2fb96651e8aa1522$var$isChannelType(datum) || $2fb96651e8aa1522$var$isMeasurerType(datum)) && !$2fb96651e8aa1522$var$isEphemeralType(datum) && (0, $idDdm.isObject)(datum.text);
}
// packages/ag-charts-enterprise/src/features/annotations/utils/styles.ts
function $2fb96651e8aa1522$var$setFontSize(datum, fontSize) {
    if ("fontSize" in datum) datum.fontSize = fontSize;
    if ($2fb96651e8aa1522$var$hasLineText(datum)) datum.text.fontSize = fontSize;
}
function $2fb96651e8aa1522$var$setLineStyle(datum, style) {
    const strokeWidth = style?.strokeWidth ?? datum.strokeWidth ?? 1;
    const lineType = style?.type ?? datum.lineStyle;
    const lineStyle = lineType ?? $2fb96651e8aa1522$var$getLineStyle(datum.lineDash, lineType);
    const computedLineDash = $2fb96651e8aa1522$var$getComputedLineDash(strokeWidth, lineStyle);
    datum.strokeWidth = strokeWidth;
    datum.computedLineDash = computedLineDash;
    datum.lineStyle = lineStyle;
    datum.lineCap = lineStyle === "dotted" ? "round" : void 0;
}
function $2fb96651e8aa1522$var$setColor(datum, colorPickerType, colorOpacity, color6, opacity, isMultiColor) {
    switch(colorPickerType){
        case `fill-color`:
            if ("fill" in datum) datum.fill = color6;
            if ("fillOpacity" in datum) datum.fillOpacity = opacity;
            if ("background" in datum) {
                datum.background.fill = color6;
                datum.background.fillOpacity = opacity;
            }
            break;
        case `line-color`:
            if ("axisLabel" in datum) {
                datum.axisLabel.fill = color6;
                datum.axisLabel.fillOpacity = opacity;
                datum.axisLabel.stroke = color6;
                datum.axisLabel.strokeOpacity = opacity;
            }
            if ("fill" in datum && "fillOpacity" in datum && $2fb96651e8aa1522$var$hasIconColor(datum)) {
                datum.fill = color6;
                datum.fillOpacity = opacity;
            } else {
                if ("strokeOpacity" in datum) datum.strokeOpacity = opacity;
                if ("isMultiColor" in datum && "rangeStroke" in datum) {
                    datum.isMultiColor = isMultiColor;
                    datum.rangeStroke = color6;
                } else if ("stroke" in datum) datum.stroke = color6;
            }
            break;
        case `text-color`:
            if ("color" in datum) datum.color = colorOpacity;
            if ($2fb96651e8aa1522$var$hasLineText(datum)) datum.text.color = color6;
            break;
    }
}
// packages/ag-charts-enterprise/src/features/annotations/annotationDefaults.ts
var { deepClone: $2fb96651e8aa1522$var$deepClone } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$AnnotationDefaults = class {
    constructor(){
        this.mementoOriginatorKey = "annotation-defaults";
        this.colors = new Map(Object.values($2fb96651e8aa1522$var$AnnotationType).map((type)=>[
                type,
                /* @__PURE__ */ new Map([
                    [
                        "line-color",
                        void 0
                    ],
                    [
                        "fill-color",
                        void 0
                    ],
                    [
                        "text-color",
                        void 0
                    ]
                ])
            ]));
        this.fontSizes = /* @__PURE__ */ new Map([
            [
                "callout" /* Callout */ ,
                void 0
            ],
            [
                "comment" /* Comment */ ,
                void 0
            ],
            [
                "text" /* Text */ ,
                void 0
            ],
            [
                "arrow" /* Arrow */ ,
                void 0
            ],
            [
                "line" /* Line */ ,
                void 0
            ],
            [
                "disjoint-channel" /* DisjointChannel */ ,
                void 0
            ],
            [
                "parallel-channel" /* ParallelChannel */ ,
                void 0
            ],
            [
                "date-range" /* DateRange */ ,
                void 0
            ],
            [
                "price-range" /* PriceRange */ ,
                void 0
            ],
            [
                "date-price-range" /* DatePriceRange */ ,
                void 0
            ]
        ]);
        this.lineStyles = /* @__PURE__ */ new Map([
            [
                "line" /* Line */ ,
                void 0
            ],
            [
                "horizontal-line" /* HorizontalLine */ ,
                void 0
            ],
            [
                "vertical-line" /* VerticalLine */ ,
                void 0
            ],
            [
                "disjoint-channel" /* DisjointChannel */ ,
                void 0
            ],
            [
                "parallel-channel" /* ParallelChannel */ ,
                void 0
            ],
            [
                "arrow" /* Arrow */ ,
                void 0
            ],
            [
                "date-range" /* DateRange */ ,
                void 0
            ],
            [
                "price-range" /* PriceRange */ ,
                void 0
            ],
            [
                "date-price-range" /* DatePriceRange */ ,
                void 0
            ]
        ]);
        this.lineTextAlignments = /* @__PURE__ */ new Map([
            [
                "line" /* Line */ ,
                void 0
            ],
            [
                "horizontal-line" /* HorizontalLine */ ,
                void 0
            ],
            [
                "vertical-line" /* VerticalLine */ ,
                void 0
            ],
            [
                "disjoint-channel" /* DisjointChannel */ ,
                void 0
            ],
            [
                "parallel-channel" /* ParallelChannel */ ,
                void 0
            ],
            [
                "arrow" /* Arrow */ ,
                void 0
            ],
            [
                "date-range" /* DateRange */ ,
                void 0
            ],
            [
                "price-range" /* PriceRange */ ,
                void 0
            ],
            [
                "date-price-range" /* DatePriceRange */ ,
                void 0
            ]
        ]);
        this.lineTextPositions = /* @__PURE__ */ new Map([
            [
                "line" /* Line */ ,
                void 0
            ],
            [
                "horizontal-line" /* HorizontalLine */ ,
                void 0
            ],
            [
                "vertical-line" /* VerticalLine */ ,
                void 0
            ],
            [
                "disjoint-channel" /* DisjointChannel */ ,
                void 0
            ],
            [
                "parallel-channel" /* ParallelChannel */ ,
                void 0
            ],
            [
                "arrow" /* Arrow */ ,
                void 0
            ],
            [
                "date-range" /* DateRange */ ,
                void 0
            ],
            [
                "price-range" /* PriceRange */ ,
                void 0
            ],
            [
                "date-price-range" /* DatePriceRange */ ,
                void 0
            ]
        ]);
        this.fibonacciOptions = /* @__PURE__ */ new Map([
            [
                "fibonacci-retracement" /* FibonacciRetracement */ ,
                {
                    bands: void 0,
                    reverse: void 0,
                    showFill: void 0
                }
            ],
            [
                "fibonacci-retracement-trend-based" /* FibonacciRetracementTrendBased */ ,
                {
                    bands: void 0,
                    reverse: void 0,
                    showFill: void 0
                }
            ]
        ]);
    }
    createMemento() {
        return {
            colors: $2fb96651e8aa1522$var$deepClone(this.colors),
            fontSizes: $2fb96651e8aa1522$var$deepClone(this.fontSizes),
            lineStyles: $2fb96651e8aa1522$var$deepClone(this.lineStyles),
            lineTextAlignments: $2fb96651e8aa1522$var$deepClone(this.lineTextAlignments),
            lineTextPositions: $2fb96651e8aa1522$var$deepClone(this.lineTextPositions),
            fibonacciOptions: $2fb96651e8aa1522$var$deepClone(this.fibonacciOptions)
        };
    }
    guardMemento(_blob) {
        return true;
    }
    restoreMemento(_version, _mementoVersion, blob) {
        this.colors = $2fb96651e8aa1522$var$deepClone(blob.colors);
        this.fontSizes = $2fb96651e8aa1522$var$deepClone(blob.fontSizes);
        this.lineStyles = $2fb96651e8aa1522$var$deepClone(blob.lineStyles);
        this.lineTextAlignments = $2fb96651e8aa1522$var$deepClone(blob.lineTextAlignments);
        this.lineTextPositions = $2fb96651e8aa1522$var$deepClone(blob.lineTextPositions);
        this.fibonacciOptions = $2fb96651e8aa1522$var$deepClone(blob.fibonacciOptions);
    }
    setDefaultColor(type, colorType, colorOpacity, color6, opacity, isMultiColor) {
        this.colors.get(type)?.set(colorType, [
            colorOpacity,
            color6,
            opacity,
            isMultiColor
        ]);
    }
    setDefaultFontSize(type, fontSize) {
        this.fontSizes.set(type, fontSize);
    }
    setDefaultLineStyleType(type, lineStyleType) {
        const defaultStyle = this.lineStyles.get(type);
        if (defaultStyle) defaultStyle.type = lineStyleType;
        else this.lineStyles.set(type, {
            type: lineStyleType
        });
    }
    setDefaultLineStyleWidth(type, strokeWidth) {
        const defaultStyle = this.lineStyles.get(type);
        if (defaultStyle) defaultStyle.strokeWidth = strokeWidth;
        else this.lineStyles.set(type, {
            strokeWidth: strokeWidth
        });
    }
    setDefaultLineTextAlignment(type, alignment) {
        this.lineTextAlignments.set(type, alignment);
    }
    setDefaultLineTextPosition(type, position) {
        this.lineTextPositions.set(type, position);
    }
    setDefaultFibonacciOptions(type, key, value) {
        if (type != "fibonacci-retracement" /* FibonacciRetracement */  && type != "fibonacci-retracement-trend-based" /* FibonacciRetracementTrendBased */ ) return;
        const options = this.fibonacciOptions.get(type);
        options[key] = value;
        this.fibonacciOptions.set(type, options);
    }
    applyDefaults(datum) {
        for (const [annotationType, colors] of this.colors){
            if (datum.type !== annotationType) continue;
            for (const [colorPickerType, [colorOpacity, color6, opacity, isMultiColor] = []] of colors)if (colorOpacity && color6 && opacity != null && isMultiColor != null) $2fb96651e8aa1522$var$setColor(datum, colorPickerType, colorOpacity, color6, opacity, isMultiColor);
        }
        for (const [annotationType, size] of this.fontSizes){
            if (datum.type !== annotationType || size == null) continue;
            $2fb96651e8aa1522$var$setFontSize(datum, size);
        }
        for (const [annotationType, style] of this.lineStyles){
            if (datum.type !== annotationType || style == null) continue;
            $2fb96651e8aa1522$var$setLineStyle(datum, style);
        }
        for (const [annotationType, position] of this.lineTextPositions){
            if (datum.type !== annotationType || position == null) continue;
            datum.text.position = position;
        }
        for (const [annotationType, alignment] of this.lineTextAlignments){
            if (datum.type !== annotationType || alignment == null) continue;
            datum.text.alignment = alignment;
        }
        for (const [annotationType, options] of this.fibonacciOptions){
            if (datum.type !== annotationType || options == null) continue;
            Object.keys(options).forEach((option)=>{
                const value = options[option];
                if (value == null) return;
                datum.set({
                    [option]: value
                });
            });
        }
    }
};
// packages/ag-charts-enterprise/src/components/color-picker/colorPickerTemplate.html
var $2fb96651e8aa1522$var$colorPickerTemplate_default = '<div class="ag-charts-color-picker__palette" tabindex="0"></div><div class="ag-charts-color-picker__color-row"><button class="ag-charts-color-picker__multi-color-button" tabindex="0" type="button"></button> <input class="ag-charts-color-picker__hue-input" tabindex="0" type="range" min="0" max="360" value="0"></div><input class="ag-charts-color-picker__alpha-input" tabindex="0" type="range" min="0" max="1" value="1" step="0.01"> <label class="ag-charts-color-picker__color-field"><span class="ag-charts-color-picker__color-label">Color</span> <input class="ag-charts-color-picker__color-input" tabindex="0" value="#000"></label>';
// packages/ag-charts-enterprise/src/components/color-picker/colorPicker.ts
var { Color: $2fb96651e8aa1522$var$Color3 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$getHsva = (input)=>{
    try {
        const color6 = $2fb96651e8aa1522$var$Color3.fromString(input);
        const [h, s, v] = color6.toHSB();
        return [
            h,
            s,
            v,
            color6.a
        ];
    } catch  {
        return;
    }
};
var $2fb96651e8aa1522$var$ColorPicker = class extends (0, $iTJTu._ModuleSupport).AnchoredPopover {
    constructor(ctx, options){
        super(ctx, "color-picker", options);
        this.hasChanged = false;
        this.hideFns.push(()=>{
            if (this.hasChanged) this.onChangeHide?.();
        });
    }
    show(options) {
        this.hasChanged = false;
        this.onChangeHide = options.onChangeHide;
        const { element: element, initialFocus: initialFocus } = this.createColorPicker(options);
        const popover = this.showWithChildren([
            element
        ], {
            initialFocus: initialFocus,
            ...options
        });
        popover.classList.add("ag-charts-color-picker");
        popover.setAttribute("role", "dialog");
    }
    createColorPicker(opts) {
        let isMultiColor = opts.isMultiColor ?? false;
        let [h, s, v, a] = $2fb96651e8aa1522$var$getHsva(opts.color ?? "#f00") ?? [
            0,
            1,
            0.5,
            1
        ];
        a = opts.opacity ?? a;
        const colorPicker = (0, $idDdm.createElement)("div", "ag-charts-color-picker__content");
        colorPicker.innerHTML = $2fb96651e8aa1522$var$colorPickerTemplate_default;
        colorPicker.ariaLabel = this.ctx.localeManager.t("ariaLabelColorPicker");
        const paletteInput = colorPicker.querySelector(".ag-charts-color-picker__palette");
        const hueInput = colorPicker.querySelector(".ag-charts-color-picker__hue-input");
        const multiColorButton = colorPicker.querySelector(".ag-charts-color-picker__multi-color-button");
        const alphaInput = colorPicker.querySelector(".ag-charts-color-picker__alpha-input");
        const colorInput = colorPicker.querySelector(".ag-charts-color-picker__color-input");
        const colorInputLabel = colorPicker.querySelector(".ag-charts-color-picker__color-label");
        multiColorButton.classList.toggle("ag-charts-color-picker__multi-color-button--hidden", !opts.hasMultiColorOption);
        const update = (trackChange = true)=>{
            const color6 = $2fb96651e8aa1522$var$Color3.fromHSB(h, s, v, a);
            const colorString = color6.toHexString();
            colorPicker.style.setProperty("--h", `${h}`);
            colorPicker.style.setProperty("--s", `${s}`);
            colorPicker.style.setProperty("--v", `${v}`);
            colorPicker.style.setProperty("--a", `${a}`);
            colorPicker.style.setProperty("--color", colorString.slice(0, 7));
            colorPicker.style.setProperty("--color-a", colorString);
            hueInput.value = `${h}`;
            alphaInput.value = `${a}`;
            alphaInput.classList.toggle("ag-charts-color-picker__alpha-input--opaque", a === 1);
            multiColorButton.classList.toggle("ag-charts-color-picker__multi-color-button--active", isMultiColor);
            colorInputLabel.classList.toggle("ag-charts-color-picker__color-label--multi-color", isMultiColor);
            if (document.activeElement !== colorInput) colorInput.value = isMultiColor ? "Multi Colour" : colorString.toUpperCase();
            if (trackChange || opts.color == null) {
                const plainColor = $2fb96651e8aa1522$var$Color3.fromHSB(h, s, v, 1).toHexString();
                opts.onChange?.(colorString, plainColor, a, isMultiColor);
            }
            if (trackChange) this.hasChanged = true;
        };
        update(false);
        const preventDefault = (event)=>event.preventDefault();
        const stopPropagation = (event)=>event.stopPropagation();
        const beginPaletteInteraction = (e)=>{
            e.preventDefault();
            const currentTarget = e.currentTarget;
            currentTarget.focus();
            const rect = currentTarget.getBoundingClientRect();
            const pointerMove = ({ clientX: clientX, clientY: clientY })=>{
                isMultiColor = false;
                s = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1);
                v = 1 - Math.min(Math.max((clientY - rect.top) / rect.height, 0), 1);
                update();
            };
            const pointerUp = ()=>{
                window.removeEventListener("pointermove", pointerMove);
            };
            pointerMove(e);
            window.addEventListener("pointermove", pointerMove);
            window.addEventListener("pointerup", pointerUp, {
                once: true
            });
        };
        colorPicker.addEventListener("mousedown", stopPropagation);
        colorPicker.addEventListener("touchstart", stopPropagation);
        colorPicker.addEventListener("touchmove", stopPropagation);
        colorPicker.addEventListener("keydown", (e)=>{
            e.stopPropagation();
            switch(e.key){
                case "Enter":
                case "Escape":
                    this.hide();
                    break;
                default:
                    return;
            }
            e.preventDefault();
        });
        paletteInput.addEventListener("pointerdown", beginPaletteInteraction);
        paletteInput.addEventListener("touchstart", preventDefault, {
            passive: false
        });
        paletteInput.addEventListener("touchmove", preventDefault, {
            passive: false
        });
        paletteInput.addEventListener("keydown", (e)=>{
            if (e.key === "ArrowLeft") s = (0, $idDdm.clamp)(0, s - 0.01, 1);
            else if (e.key === "ArrowRight") s = (0, $idDdm.clamp)(0, s + 0.01, 1);
            else if (e.key === "ArrowUp") v = (0, $idDdm.clamp)(0, v + 0.01, 1);
            else if (e.key === "ArrowDown") v = (0, $idDdm.clamp)(0, v - 0.01, 1);
            else return;
            e.preventDefault();
            update();
        });
        multiColorButton.addEventListener("click", ()=>{
            isMultiColor = !isMultiColor;
            update();
        });
        hueInput.addEventListener("input", (e)=>{
            isMultiColor = false;
            h = e.currentTarget.valueAsNumber ?? 0;
            update();
        });
        alphaInput.addEventListener("input", (e)=>{
            isMultiColor = false;
            a = e.currentTarget.valueAsNumber ?? 0;
            update();
        });
        colorInput.addEventListener("input", (e)=>{
            isMultiColor = false;
            const hsva = $2fb96651e8aa1522$var$getHsva(e.currentTarget.value);
            if (hsva == null) return;
            [h, s, v, a] = hsva;
            update();
        });
        colorInput.addEventListener("blur", ()=>update());
        colorInput.addEventListener("keydown", (e)=>{
            if (e.key === "Enter") {
                e.currentTarget.blur();
                update();
            }
        });
        return {
            element: colorPicker,
            initialFocus: paletteInput
        };
    }
};
function $2fb96651e8aa1522$var$channelMenuItemVisible(scale) {
    return !(scale instanceof (0, $iTJTu._ModuleSupport).LogScale) && !(scale instanceof (0, $iTJTu._ModuleSupport).BandScale);
}
var $2fb96651e8aa1522$var$LINE_ANNOTATION_ITEMS = [
    {
        label: "toolbarAnnotationsTrendLine",
        icon: "trend-line-drawing",
        value: "line" /* Line */ 
    },
    {
        label: "toolbarAnnotationsHorizontalLine",
        icon: "horizontal-line-drawing",
        value: "horizontal-line" /* HorizontalLine */ 
    },
    {
        label: "toolbarAnnotationsVerticalLine",
        icon: "vertical-line-drawing",
        value: "vertical-line" /* VerticalLine */ 
    },
    {
        label: "toolbarAnnotationsParallelChannel",
        icon: "parallel-channel-drawing",
        value: "parallel-channel" /* ParallelChannel */ ,
        visible: $2fb96651e8aa1522$var$channelMenuItemVisible
    },
    {
        label: "toolbarAnnotationsDisjointChannel",
        icon: "disjoint-channel-drawing",
        value: "disjoint-channel" /* DisjointChannel */ ,
        visible: $2fb96651e8aa1522$var$channelMenuItemVisible
    }
];
var $2fb96651e8aa1522$var$FIBONACCI_ANNOTATION_ITEMS = [
    {
        label: "toolbarAnnotationsFibonacciRetracement",
        icon: "fibonacci-retracement-drawing",
        value: "fibonacci-retracement" /* FibonacciRetracement */ 
    },
    {
        label: "toolbarAnnotationsFibonacciRetracementTrendBased",
        icon: "fibonacci-retracement-trend-based-drawing",
        value: "fibonacci-retracement-trend-based" /* FibonacciRetracementTrendBased */ 
    }
];
var $2fb96651e8aa1522$var$FIBONACCI_RATIO_ITEMS = [
    {
        label: "Fibonacci - Extended",
        value: 10
    },
    {
        label: "Fibonacci - 6 Band",
        value: 6
    },
    {
        label: "Fibonacci - 4 Band",
        value: 4
    }
];
var $2fb96651e8aa1522$var$TEXT_ANNOTATION_ITEMS = [
    {
        label: "toolbarAnnotationsText",
        icon: "text-annotation",
        value: "text" /* Text */ 
    },
    {
        label: "toolbarAnnotationsComment",
        icon: "comment-annotation",
        value: "comment" /* Comment */ 
    },
    {
        label: "toolbarAnnotationsCallout",
        icon: "callout-annotation",
        value: "callout" /* Callout */ 
    },
    {
        label: "toolbarAnnotationsNote",
        icon: "note-annotation",
        value: "note" /* Note */ 
    }
];
var $2fb96651e8aa1522$var$SHAPE_ANNOTATION_ITEMS = [
    {
        label: "toolbarAnnotationsArrow",
        icon: "arrow-drawing",
        value: "arrow" /* Arrow */ 
    },
    {
        label: "toolbarAnnotationsArrowUp",
        icon: "arrow-up-drawing",
        value: "arrow-up" /* ArrowUp */ 
    },
    {
        label: "toolbarAnnotationsArrowDown",
        icon: "arrow-down-drawing",
        value: "arrow-down" /* ArrowDown */ 
    }
];
var $2fb96651e8aa1522$var$MEASURER_ANNOTATION_ITEMS = [
    {
        label: "toolbarAnnotationsQuickDatePriceRange",
        icon: "measurer-drawing",
        value: "quick-date-price-range" /* QuickDatePriceRange */ 
    },
    {
        label: "toolbarAnnotationsDateRange",
        icon: "date-range-drawing",
        value: "date-range" /* DateRange */ 
    },
    {
        label: "toolbarAnnotationsPriceRange",
        icon: "price-range-drawing",
        value: "price-range" /* PriceRange */ 
    },
    {
        label: "toolbarAnnotationsDatePriceRange",
        icon: "date-price-range-drawing",
        value: "date-price-range" /* DatePriceRange */ 
    }
];
var $2fb96651e8aa1522$var$LINE_STROKE_WIDTH_ITEMS = [
    {
        strokeWidth: 1,
        label: "1",
        value: 1
    },
    {
        strokeWidth: 2,
        label: "2",
        value: 2
    },
    {
        strokeWidth: 3,
        label: "3",
        value: 3
    },
    {
        strokeWidth: 4,
        label: "4",
        value: 4
    },
    {
        strokeWidth: 8,
        label: "8",
        value: 8
    }
];
var $2fb96651e8aa1522$var$LINE_STYLE_TYPE_ITEMS = [
    {
        icon: "line-style-solid",
        altText: "iconAltTextLineStyleSolid",
        value: "solid"
    },
    {
        icon: "line-style-dashed",
        altText: "iconAltTextLineStyleDashed",
        value: "dashed"
    },
    {
        icon: "line-style-dotted",
        altText: "iconAltTextLineStyleDotted",
        value: "dotted"
    }
];
var $2fb96651e8aa1522$var$TEXT_SIZE_ITEMS = [
    {
        label: "10",
        value: 10
    },
    {
        label: "12",
        value: 12
    },
    {
        label: "14",
        value: 14
    },
    {
        label: "16",
        value: 16
    },
    {
        label: "18",
        value: 18
    },
    {
        label: "22",
        value: 22
    },
    {
        label: "28",
        value: 28
    },
    {
        label: "36",
        value: 36
    },
    {
        label: "46",
        value: 46
    }
];
// packages/ag-charts-enterprise/src/features/annotations/annotationOptionsToolbar.ts
var { Color: $2fb96651e8aa1522$var$Color4, FloatingToolbar: $2fb96651e8aa1522$var$FloatingToolbar, Listeners: $2fb96651e8aa1522$var$Listeners, Menu: $2fb96651e8aa1522$var$Menu, PropertiesArray: $2fb96651e8aa1522$var$PropertiesArray, ToolbarButtonProperties: $2fb96651e8aa1522$var$ToolbarButtonProperties, ToolbarButtonWidget: $2fb96651e8aa1522$var$ToolbarButtonWidget, Property: $2fb96651e8aa1522$var$Property28 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$AnnotationOptionsButtonProperties = class extends $2fb96651e8aa1522$var$ToolbarButtonProperties {
    constructor(){
        super(...arguments);
        this.checkedOverrides = new $2fb96651e8aa1522$var$ToolbarButtonProperties();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property28
], $2fb96651e8aa1522$var$AnnotationOptionsButtonProperties.prototype, "value", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property28
], $2fb96651e8aa1522$var$AnnotationOptionsButtonProperties.prototype, "checkedOverrides", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property28
], $2fb96651e8aa1522$var$AnnotationOptionsButtonProperties.prototype, "color", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property28
], $2fb96651e8aa1522$var$AnnotationOptionsButtonProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property28
], $2fb96651e8aa1522$var$AnnotationOptionsButtonProperties.prototype, "isMultiColor", 2);
var $2fb96651e8aa1522$var$AnnotationOptionsButtonWidget = class extends $2fb96651e8aa1522$var$ToolbarButtonWidget {
    update(options) {
        super.update(options);
        if (options.value === "line-stroke-width" /* LineStrokeWidth */ ) this.updateLineStrokeWidth(options);
        if (options.value === "fill-color" /* FillColor */  || options.value === "line-color" /* LineColor */  || options.value === "text-color" /* TextColor */ ) this.updateFillColor(options);
    }
    updateFillColor(options) {
        const element = this.getElement();
        element.classList.add("ag-charts-annotations__color-picker-button");
        element.classList.toggle("ag-charts-annotations__color-picker-button--multi-color", options.isMultiColor);
        element.style.setProperty("--color", options.color ?? null);
    }
    updateLineStrokeWidth(options) {
        const element = this.getElement();
        element.classList.add("ag-charts-annotations__stroke-width-button");
        element.style.setProperty("--stroke-width", `${options.strokeWidth}px`);
    }
};
var $2fb96651e8aa1522$var$FloatingAnnotationOptionsToolbar = class extends $2fb96651e8aa1522$var$FloatingToolbar {
    createButtonWidget() {
        return new $2fb96651e8aa1522$var$AnnotationOptionsButtonWidget(this.localeManager);
    }
};
var $2fb96651e8aa1522$var$AnnotationOptionsToolbar = class extends (0, $iTJTu._ModuleSupport).BaseProperties {
    constructor(ctx, getActiveDatum){
        super();
        this.ctx = ctx;
        this.getActiveDatum = getActiveDatum;
        this.enabled = true;
        this.buttons = new $2fb96651e8aa1522$var$PropertiesArray($2fb96651e8aa1522$var$AnnotationOptionsButtonProperties);
        this.destroyFns = [];
        this.events = new $2fb96651e8aa1522$var$Listeners();
        this.visibleButtons = [];
        this.toolbar = new $2fb96651e8aa1522$var$FloatingAnnotationOptionsToolbar(this.ctx, "annotation-options");
        this.colorPicker = new $2fb96651e8aa1522$var$ColorPicker(this.ctx);
        this.textSizeMenu = new $2fb96651e8aa1522$var$Menu(this.ctx, "text-size");
        this.lineStyleTypeMenu = new $2fb96651e8aa1522$var$Menu(this.ctx, "annotations-line-style-type");
        this.lineStrokeWidthMenu = new $2fb96651e8aa1522$var$Menu(this.ctx, "annotations-line-stroke-width");
        this.destroyFns.push(this.toolbar.addToolbarListener("button-pressed", this.onButtonPress.bind(this)), this.toolbar.addToolbarListener("toolbar-moved", this.onToolbarMoved.bind(this)), ctx.widgets.seriesWidget.addListener("drag-start", this.onDragStart.bind(this)), ctx.widgets.seriesWidget.addListener("drag-end", this.onDragEnd.bind(this)), ()=>this.colorPicker.destroy());
    }
    onDragStart() {
        this.toolbar.ignorePointerEvents();
    }
    onDragEnd() {
        this.toolbar.capturePointerEvents();
    }
    destroy() {
        for (const destroyFn of this.destroyFns)destroyFn();
    }
    addListener(eventType, handler) {
        return this.events.addListener(eventType, handler);
    }
    show() {
        if (!this.enabled) return;
        this.toolbar.show();
    }
    hide() {
        this.toolbar.hide();
    }
    updateButtons(datum) {
        if (!this.enabled) return;
        const visible = {
            ["line-style-type" /* LineStyleType */ ]: $2fb96651e8aa1522$var$hasLineStyle(datum),
            ["line-stroke-width" /* LineStrokeWidth */ ]: $2fb96651e8aa1522$var$hasLineStyle(datum),
            ["line-color" /* LineColor */ ]: $2fb96651e8aa1522$var$hasLineColor(datum),
            ["text-color" /* TextColor */ ]: $2fb96651e8aa1522$var$hasTextColor(datum),
            ["fill-color" /* FillColor */ ]: $2fb96651e8aa1522$var$hasFillColor(datum),
            ["text-size" /* TextSize */ ]: $2fb96651e8aa1522$var$hasFontSize(datum),
            ["settings" /* Settings */ ]: $2fb96651e8aa1522$var$hasLineText(datum),
            ["lock" /* Lock */ ]: true,
            ["delete" /* Delete */ ]: true
        };
        this.visibleButtons = this.buttons.filter((button)=>visible[button.value]);
        this.toolbar.clearButtons();
        this.toolbar.updateButtons(this.visibleButtons);
        this.refreshButtons(datum);
    }
    setAnchorScene(scene) {
        if (this.toolbar.hasBeenDragged()) return;
        this.toolbar.setAnchor(scene.getAnchor());
    }
    hideOverlays() {
        this.toolbar.clearActiveButton();
        this.colorPicker.hide({
            lastFocus: null
        });
        this.textSizeMenu.hide();
        this.lineStyleTypeMenu.hide();
        this.lineStrokeWidthMenu.hide();
        this.dispatch("hid-overlays");
    }
    clearActiveButton() {
        this.toolbar.clearActiveButton();
    }
    updateColors(datum) {
        this.updateColorPickerColor("line-color" /* LineColor */ , datum.getDefaultColor("line-color" /* LineColor */ ), datum.getDefaultOpacity("line-color" /* LineColor */ ), "isMultiColor" in datum && datum?.isMultiColor);
        this.updateColorPickerColor("fill-color" /* FillColor */ , datum.getDefaultColor("fill-color" /* FillColor */ ), datum.getDefaultOpacity("fill-color" /* FillColor */ ), "isMultiColor" in datum && datum?.isMultiColor);
        this.updateColorPickerColor("text-color" /* TextColor */ , datum.getDefaultColor("text-color" /* TextColor */ ), datum.getDefaultOpacity("text-color" /* TextColor */ ), "isMultiColor" in datum && datum?.isMultiColor);
    }
    updateColorPickerColor(colorPickerType, color6, opacity, isMultiColor) {
        if (color6 != null && opacity != null) {
            const { r: r, g: g, b: b } = $2fb96651e8aa1522$var$Color4.fromString(color6);
            color6 = $2fb96651e8aa1522$var$Color4.fromArray([
                r,
                g,
                b,
                opacity
            ]).toHexString();
        }
        this.updateButtonByValue(colorPickerType, {
            color: color6,
            isMultiColor: isMultiColor
        });
    }
    updateFontSize(fontSize) {
        this.updateButtonByValue("text-size" /* TextSize */ , {
            label: fontSize != null ? String(fontSize) : void 0
        });
    }
    updateLineStyleType(item) {
        this.updateButtonByValue("line-style-type" /* LineStyleType */ , {
            icon: item.icon
        });
    }
    updateStrokeWidth(item) {
        this.updateButtonByValue("line-stroke-width" /* LineStrokeWidth */ , {
            label: item.label,
            strokeWidth: item.value
        });
    }
    dispatch(eventType, event) {
        this.events.dispatch(eventType, event);
    }
    onButtonPress({ event: event, button: button }) {
        const datum = this.getActiveDatum();
        if (!datum) return;
        this.hideOverlays();
        switch(button.value){
            case "line-style-type" /* LineStyleType */ :
                {
                    const lineStyle = $2fb96651e8aa1522$var$hasLineStyle(datum) ? $2fb96651e8aa1522$var$getLineStyle(datum.lineDash, datum.lineStyle) : void 0;
                    this.lineStyleTypeMenu.show({
                        items: $2fb96651e8aa1522$var$LINE_STYLE_TYPE_ITEMS,
                        ariaLabel: this.ctx.localeManager.t("toolbarAnnotationsLineStyle"),
                        value: lineStyle,
                        sourceEvent: event.sourceEvent,
                        onPress: (item)=>this.onLineStyleTypeMenuPress(item, datum),
                        class: "ag-charts-annotations__line-style-type-menu"
                    });
                    break;
                }
            case "line-stroke-width" /* LineStrokeWidth */ :
                {
                    const strokeWidth = $2fb96651e8aa1522$var$hasLineStyle(datum) ? datum.strokeWidth : void 0;
                    this.lineStrokeWidthMenu.show({
                        items: $2fb96651e8aa1522$var$LINE_STROKE_WIDTH_ITEMS,
                        ariaLabel: this.ctx.localeManager.t("toolbarAnnotationsLineStrokeWidth"),
                        value: strokeWidth,
                        sourceEvent: event.sourceEvent,
                        onPress: (item)=>this.onLineStrokeWidthMenuPress(item, datum),
                        class: "ag-charts-annotations__line-stroke-width-menu"
                    });
                    break;
                }
            case "line-color" /* LineColor */ :
            case "fill-color" /* FillColor */ :
            case "text-color" /* TextColor */ :
                this.toolbar.toggleActiveButtonByIndex(button.index);
                this.colorPicker.show({
                    color: datum?.getDefaultColor(button.value),
                    opacity: datum?.getDefaultOpacity(button.value),
                    sourceEvent: event.sourceEvent,
                    hasMultiColorOption: "isMultiColor" in datum,
                    isMultiColor: "isMultiColor" in datum && datum?.isMultiColor,
                    onChange: datum != null ? this.onColorPickerChange.bind(this, button.value, datum) : void 0,
                    onChangeHide: ((type)=>{
                        this.dispatch("saved-color", {
                            type: datum.type,
                            colorPickerType: button.value,
                            color: datum.getDefaultColor(type)
                        });
                    }).bind(this, button.value)
                });
                break;
            case "text-size" /* TextSize */ :
                {
                    const fontSize = $2fb96651e8aa1522$var$isTextType(datum) ? datum.fontSize : void 0;
                    this.textSizeMenu.show({
                        items: $2fb96651e8aa1522$var$TEXT_SIZE_ITEMS,
                        ariaLabel: this.ctx.localeManager.t("toolbarAnnotationsTextSize"),
                        value: fontSize,
                        sourceEvent: event.sourceEvent,
                        onPress: (item)=>this.onTextSizeMenuPress(item, datum),
                        class: "ag-charts-annotations__text-size-menu"
                    });
                    break;
                }
            case "delete" /* Delete */ :
                this.dispatch("pressed-delete");
                break;
            case "lock" /* Lock */ :
                datum.locked = !datum.locked;
                this.refreshButtons(datum);
                this.dispatch("pressed-lock");
                break;
            case "settings" /* Settings */ :
                this.toolbar.toggleActiveButtonByIndex(button.index);
                this.dispatch("pressed-settings", event);
                break;
        }
    }
    onToolbarMoved(event) {
        const { buttonBounds: buttonBounds, popoverBounds: popoverBounds } = event;
        const colorPickerAnchor = {
            x: popoverBounds.x,
            y: popoverBounds.y + popoverBounds.height + 4
        };
        const colorPickerFallbackAnchor = {
            y: popoverBounds.y - 4
        };
        this.colorPicker.setAnchor(colorPickerAnchor, colorPickerFallbackAnchor);
        for (const [index, bounds] of buttonBounds.entries()){
            const button = this.visibleButtons.at(index);
            if (!button) continue;
            const anchor = {
                x: bounds.x,
                y: bounds.y + bounds.height - 1
            };
            const fallbackAnchor = {
                y: bounds.y
            };
            switch(button.value){
                case "line-stroke-width" /* LineStrokeWidth */ :
                    this.lineStrokeWidthMenu.setAnchor(anchor, fallbackAnchor);
                    break;
                case "line-style-type" /* LineStyleType */ :
                    this.lineStyleTypeMenu.setAnchor(anchor, fallbackAnchor);
                    break;
                case "text-size" /* TextSize */ :
                    this.textSizeMenu.setAnchor(anchor, fallbackAnchor);
                    break;
            }
        }
    }
    onColorPickerChange(colorPickerType, datum, colorOpacity, color6, opacity, isMultiColor) {
        this.dispatch("updated-color", {
            type: datum.type,
            colorPickerType: colorPickerType,
            colorOpacity: colorOpacity,
            color: color6,
            opacity: opacity,
            isMultiColor: isMultiColor
        });
        this.updateColorPickerColor(colorPickerType, colorOpacity, opacity, isMultiColor);
    }
    onTextSizeMenuPress(item, datum) {
        if (!$2fb96651e8aa1522$var$hasFontSize(datum)) return;
        const fontSize = item.value;
        this.dispatch("updated-font-size", {
            type: datum.type,
            fontSize: fontSize
        });
        this.textSizeMenu.hide();
        this.updateFontSize(fontSize);
    }
    onLineStyleTypeMenuPress(item, datum) {
        if (!$2fb96651e8aa1522$var$hasLineStyle(datum)) return;
        const type = item.value;
        this.dispatch("updated-line-style", {
            type: datum.type,
            lineStyleType: type
        });
        this.lineStyleTypeMenu.hide();
        this.updateLineStyleType(item);
    }
    onLineStrokeWidthMenuPress(item, datum) {
        if (!$2fb96651e8aa1522$var$hasLineStyle(datum)) return;
        const strokeWidth = item.value;
        this.dispatch("updated-line-width", {
            type: datum.type,
            strokeWidth: strokeWidth
        });
        this.lineStrokeWidthMenu.hide();
        this.updateStrokeWidth(item);
    }
    refreshButtons(datum) {
        const locked = datum.locked ?? false;
        for (const [index, button] of this.visibleButtons.entries()){
            if (!button) continue;
            if (button.value === "lock" /* Lock */ ) {
                this.toolbar.toggleSwitchCheckedByIndex(index, locked);
                this.updateButtonByIndex(index, locked ? button.checkedOverrides.toJson() : button.toJson());
            } else this.toolbar.toggleButtonEnabledByIndex(index, !locked);
        }
        if ($2fb96651e8aa1522$var$hasFontSize(datum)) this.updateFontSize(datum.fontSize);
        this.updateColors(datum);
        this.updateLineStyles(datum);
    }
    updateLineStyles(datum) {
        if (!$2fb96651e8aa1522$var$hasLineStyle(datum)) return;
        const strokeWidth = datum.strokeWidth ?? 1;
        const lineStyleType = $2fb96651e8aa1522$var$getLineStyle(datum.lineDash, datum.lineStyle);
        this.updateStrokeWidth({
            strokeWidth: strokeWidth,
            value: strokeWidth,
            label: String(strokeWidth)
        });
        this.updateLineStyleType($2fb96651e8aa1522$var$LINE_STYLE_TYPE_ITEMS.find((item)=>item.value === lineStyleType) ?? $2fb96651e8aa1522$var$LINE_STYLE_TYPE_ITEMS[0]);
    }
    updateButtonByValue(value, change) {
        const index = this.visibleButtons.findIndex((button)=>button.value === value);
        if (index === -1) return;
        this.updateButtonByIndex(index, change);
    }
    updateButtonByIndex(index, change) {
        const button = this.visibleButtons.at(index);
        if (!button) return;
        this.toolbar.updateButtonByIndex(index, {
            ...button.toJson(),
            ...change,
            value: change.value ?? button.value
        });
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property28
], $2fb96651e8aa1522$var$AnnotationOptionsToolbar.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property28
], $2fb96651e8aa1522$var$AnnotationOptionsToolbar.prototype, "buttons", 2);
var { StateMachine: $2fb96651e8aa1522$var$StateMachine, StateMachineProperty: $2fb96651e8aa1522$var$StateMachineProperty, Vec2: $2fb96651e8aa1522$var$Vec22, Debug: $2fb96651e8aa1522$var$Debug } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$DragStateMachine = class extends $2fb96651e8aa1522$var$StateMachine {
    constructor(ctx){
        const actionKeyChange = ({ context: context })=>{
            this.node?.drag(this.datum, this.offset, context, this.snapping);
            ctx.update();
        };
        super("idle", {
            idle: {
                dragStart: {
                    target: "dragging",
                    action: ({ offset: offset, context: context })=>{
                        this.hasMoved = false;
                        this.dragStart = offset;
                        this.offset = offset;
                        this.node?.dragStart(this.datum, offset, context);
                    }
                }
            },
            dragging: {
                keyDown: actionKeyChange,
                keyUp: actionKeyChange,
                drag: ({ offset: offset, context: context })=>{
                    this.hasMoved = $2fb96651e8aa1522$var$Vec22.lengthSquared($2fb96651e8aa1522$var$Vec22.sub(offset, this.dragStart)) > 0;
                    this.offset = offset;
                    this.node?.drag(this.datum, offset, context, this.snapping);
                    ctx.update();
                },
                dragEnd: {
                    target: $2fb96651e8aa1522$var$StateMachine.parent,
                    action: ()=>{
                        this.node?.stopDragging();
                        if (this.hasMoved) ctx.recordAction("Move annotation");
                        ctx.update();
                    }
                }
            }
        });
        this.debug = $2fb96651e8aa1522$var$Debug.create(true, "annotations");
        this.hasMoved = false;
        this.snapping = false;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty()
], $2fb96651e8aa1522$var$DragStateMachine.prototype, "snapping", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty()
], $2fb96651e8aa1522$var$DragStateMachine.prototype, "datum", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty()
], $2fb96651e8aa1522$var$DragStateMachine.prototype, "node", 2);
var { Property: $2fb96651e8aa1522$var$Property29 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$ArrowDownProperties = class extends $2fb96651e8aa1522$var$ShapePointProperties {
    constructor(){
        super(...arguments);
        this.type = "arrow-down" /* ArrowDown */ ;
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "arrow-down" /* ArrowDown */ ;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property29
], $2fb96651e8aa1522$var$ArrowDownProperties.prototype, "type", 2);
var $2fb96651e8aa1522$var$_Handle = class _Handle extends (0, $iTJTu._ModuleSupport).Group {
    constructor(){
        super(...arguments);
        this.active = false;
        this.locked = false;
        this.visible = false;
        this.zIndex = 1;
    }
    drag(target) {
        const { handle: handle2, locked: locked } = this;
        if (locked) return {
            point: {
                x: handle2.x,
                y: handle2.y
            },
            offset: {
                x: 0,
                y: 0
            }
        };
        return {
            point: target,
            offset: {
                x: target.x - handle2.x,
                y: target.y - handle2.y
            }
        };
    }
    toggleActive(active) {
        this.active = active;
        if (!active) this.handle.strokeWidth = _Handle.INACTIVE_STROKE_WIDTH;
    }
    toggleHovered(hovered) {
        this.glow.visible = !this.locked && hovered;
        this.glow.dirtyPath = true;
    }
    toggleDragging(dragging) {
        if (this.locked) return;
        this.handle.visible = !dragging;
        this.glow.visible = this.glow.visible && !dragging;
        this.handle.dirtyPath = true;
        this.glow.dirtyPath = true;
    }
    toggleLocked(locked) {
        this.locked = locked;
    }
    getCursor() {
        return void 0;
    }
    containsPoint(x, y) {
        return this.handle.containsPoint(x, y);
    }
};
$2fb96651e8aa1522$var$_Handle.INACTIVE_STROKE_WIDTH = 2;
var $2fb96651e8aa1522$var$Handle2 = $2fb96651e8aa1522$var$_Handle;
var $2fb96651e8aa1522$var$_InvariantHandle = class _InvariantHandle extends $2fb96651e8aa1522$var$Handle2 {
    constructor(){
        super();
        this.handle = new (0, $iTJTu._ModuleSupport).Marker({
            shape: "circle"
        });
        this.glow = new (0, $iTJTu._ModuleSupport).Marker({
            shape: "circle"
        });
        this.append([
            this.handle
        ]);
        this.handle.size = _InvariantHandle.HANDLE_SIZE;
        this.handle.strokeWidth = $2fb96651e8aa1522$var$Handle2.INACTIVE_STROKE_WIDTH;
        this.handle.zIndex = 2;
    }
    update(styles) {
        this.handle.setProperties({
            ...styles,
            strokeWidth: $2fb96651e8aa1522$var$Handle2.INACTIVE_STROKE_WIDTH
        });
    }
    drag(target) {
        return {
            point: target,
            offset: {
                x: 0,
                y: 0
            }
        };
    }
};
$2fb96651e8aa1522$var$_InvariantHandle.HANDLE_SIZE = 7;
$2fb96651e8aa1522$var$_InvariantHandle.GLOW_SIZE = 9;
var $2fb96651e8aa1522$var$InvariantHandle = $2fb96651e8aa1522$var$_InvariantHandle;
var $2fb96651e8aa1522$var$_UnivariantHandle = class _UnivariantHandle extends $2fb96651e8aa1522$var$Handle2 {
    constructor(){
        super();
        this.handle = new (0, $iTJTu._ModuleSupport).Rect();
        this.glow = new (0, $iTJTu._ModuleSupport).Rect();
        this.gradient = "horizontal";
        this.append([
            this.glow,
            this.handle
        ]);
        this.handle.cornerRadius = _UnivariantHandle.CORNER_RADIUS;
        this.handle.width = _UnivariantHandle.HANDLE_SIZE;
        this.handle.height = _UnivariantHandle.HANDLE_SIZE;
        this.handle.strokeWidth = $2fb96651e8aa1522$var$Handle2.INACTIVE_STROKE_WIDTH;
        this.handle.zIndex = 2;
        this.glow.cornerRadius = _UnivariantHandle.CORNER_RADIUS;
        this.glow.width = _UnivariantHandle.GLOW_SIZE;
        this.glow.height = _UnivariantHandle.GLOW_SIZE;
        this.glow.strokeWidth = 0;
        this.glow.fillOpacity = 0.2;
        this.glow.zIndex = 1;
        this.glow.visible = false;
    }
    toggleLocked(locked) {
        super.toggleLocked(locked);
        if (locked) {
            const offset = (_UnivariantHandle.HANDLE_SIZE - $2fb96651e8aa1522$var$InvariantHandle.HANDLE_SIZE) / 2;
            this.handle.cornerRadius = 1;
            this.handle.fill = this.handle.stroke;
            this.handle.strokeWidth = 0;
            this.handle.x += offset;
            this.handle.y += offset;
            this.handle.width = $2fb96651e8aa1522$var$InvariantHandle.HANDLE_SIZE;
            this.handle.height = $2fb96651e8aa1522$var$InvariantHandle.HANDLE_SIZE;
            this.glow.width = $2fb96651e8aa1522$var$InvariantHandle.GLOW_SIZE;
            this.glow.height = $2fb96651e8aa1522$var$InvariantHandle.GLOW_SIZE;
        } else {
            this.handle.cornerRadius = _UnivariantHandle.CORNER_RADIUS;
            this.handle.width = _UnivariantHandle.HANDLE_SIZE;
            this.handle.height = _UnivariantHandle.HANDLE_SIZE;
            this.glow.width = _UnivariantHandle.GLOW_SIZE;
            this.glow.height = _UnivariantHandle.GLOW_SIZE;
            if (this.cachedStyles) this.handle.setProperties(this.cachedStyles);
        }
    }
    update(styles) {
        this.cachedStyles = {
            ...styles
        };
        if (!this.active) delete styles.strokeWidth;
        if (this.locked) {
            delete styles.fill;
            delete styles.strokeWidth;
            const offset = (_UnivariantHandle.HANDLE_SIZE - $2fb96651e8aa1522$var$InvariantHandle.HANDLE_SIZE) / 2;
            styles.x -= offset;
            styles.y -= offset;
            this.cachedStyles.x -= offset;
            this.cachedStyles.y -= offset;
        }
        this.handle.setProperties(styles);
        this.glow.setProperties({
            ...styles,
            x: (styles.x ?? this.glow.x) - 2,
            y: (styles.y ?? this.glow.y) - 2,
            strokeWidth: 0,
            fill: styles.stroke
        });
    }
    drag(target) {
        if (this.locked) return {
            point: target,
            offset: {
                x: 0,
                y: 0
            }
        };
        if (this.gradient === "vertical") return {
            point: {
                x: target.x,
                y: this.handle.y
            },
            offset: {
                x: target.x - this.handle.x,
                y: 0
            }
        };
        return {
            point: {
                x: this.handle.x,
                y: target.y
            },
            offset: {
                x: 0,
                y: target.y - this.handle.y
            }
        };
    }
    getCursor() {
        if (this.locked) return;
        return this.gradient === "vertical" ? "col-resize" : "row-resize";
    }
};
$2fb96651e8aa1522$var$_UnivariantHandle.HANDLE_SIZE = 12;
$2fb96651e8aa1522$var$_UnivariantHandle.GLOW_SIZE = 16;
$2fb96651e8aa1522$var$_UnivariantHandle.CORNER_RADIUS = 4;
var $2fb96651e8aa1522$var$UnivariantHandle = $2fb96651e8aa1522$var$_UnivariantHandle;
var $2fb96651e8aa1522$var$_DivariantHandle = class _DivariantHandle extends $2fb96651e8aa1522$var$Handle2 {
    constructor(){
        super();
        this.handle = new (0, $iTJTu._ModuleSupport).Marker({
            shape: "circle"
        });
        this.glow = new (0, $iTJTu._ModuleSupport).Marker({
            shape: "circle"
        });
        this.append([
            this.glow,
            this.handle
        ]);
        this.handle.size = _DivariantHandle.HANDLE_SIZE;
        this.handle.strokeWidth = $2fb96651e8aa1522$var$Handle2.INACTIVE_STROKE_WIDTH;
        this.handle.zIndex = 2;
        this.glow.size = _DivariantHandle.GLOW_SIZE;
        this.glow.strokeWidth = 0;
        this.glow.fillOpacity = 0.2;
        this.glow.zIndex = 1;
        this.glow.visible = false;
    }
    toggleLocked(locked) {
        super.toggleLocked(locked);
        if (locked) {
            this.handle.fill = this.handle.stroke;
            this.handle.strokeWidth = 0;
            this.handle.size = $2fb96651e8aa1522$var$InvariantHandle.HANDLE_SIZE;
            this.glow.size = $2fb96651e8aa1522$var$InvariantHandle.GLOW_SIZE;
        } else {
            this.handle.size = _DivariantHandle.HANDLE_SIZE;
            this.glow.size = _DivariantHandle.GLOW_SIZE;
            if (this.cachedStyles) this.handle.setProperties(this.cachedStyles);
        }
    }
    update(styles) {
        this.cachedStyles = {
            ...styles
        };
        if (!this.active) delete styles.strokeWidth;
        if (this.locked) {
            delete styles.fill;
            delete styles.strokeWidth;
        }
        this.handle.setProperties(styles);
        this.glow.setProperties({
            ...styles,
            strokeWidth: 0,
            fill: styles.stroke
        });
    }
    getCursor() {
        return "pointer";
    }
};
$2fb96651e8aa1522$var$_DivariantHandle.HANDLE_SIZE = 11;
$2fb96651e8aa1522$var$_DivariantHandle.GLOW_SIZE = 17;
var $2fb96651e8aa1522$var$DivariantHandle = $2fb96651e8aa1522$var$_DivariantHandle;
// packages/ag-charts-enterprise/src/features/annotations/scenes/annotationScene.ts
var { ZIndexMap: $2fb96651e8aa1522$var$ZIndexMap2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$AnnotationScene = class extends (0, $iTJTu._ModuleSupport).Group {
    constructor(){
        super(...arguments);
        this.name = "AnnotationScene";
        this.zIndex = $2fb96651e8aa1522$var$ZIndexMap2.CHART_ANNOTATION;
    }
    static isCheck(value, type) {
        return (0, $idDdm.isObject)(value) && Object.hasOwn(value, "type") && value.type === type;
    }
    toggleHovered(hovered) {
        this.toggleHandles(hovered);
    }
    *nonHandleChildren() {
        for (const child of this.children())if (!(child instanceof $2fb96651e8aa1522$var$Handle2)) yield child;
    }
    computeBBoxWithoutHandles() {
        return (0, $iTJTu._ModuleSupport).Transformable.toCanvas(this, (0, $iTJTu._ModuleSupport).Group.computeChildrenBBox(this.nonHandleChildren()));
    }
    updateNode(constructor, node, isConfigured) {
        if (!isConfigured && node) {
            this.removeChild(node);
            return;
        }
        if (isConfigured && node == null) {
            node = new constructor();
            this.appendChild(node);
        }
        return node;
    }
};
var { ContinuousScale: $2fb96651e8aa1522$var$ContinuousScale2, Vec2: $2fb96651e8aa1522$var$Vec23, toRadians: $2fb96651e8aa1522$var$toRadians3 } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$snapPoint(offset, context, snapping = false, origin, angleStep = 1) {
    if (!snapping) return $2fb96651e8aa1522$var$invertCoords(offset, context);
    const center = origin ? $2fb96651e8aa1522$var$convertPoint(origin, context) : $2fb96651e8aa1522$var$Vec23.origin();
    return $2fb96651e8aa1522$var$invertCoords($2fb96651e8aa1522$var$snapToAngle(offset, center, angleStep), context);
}
function $2fb96651e8aa1522$var$snapToAngle(vector, center, step) {
    const radial = $2fb96651e8aa1522$var$Vec23.sub(vector, center);
    const stepRadians = $2fb96651e8aa1522$var$toRadians3(step);
    const theta = Math.round($2fb96651e8aa1522$var$Vec23.angle(radial) / stepRadians) * stepRadians;
    return $2fb96651e8aa1522$var$Vec23.rotate(radial, theta, center);
}
function $2fb96651e8aa1522$var$getDragStartState(points, context) {
    const dragState = {};
    for (const [name, point] of (0, $idDdm.entries)(points))dragState[name] = $2fb96651e8aa1522$var$convertPoint(point, context);
    return dragState;
}
function $2fb96651e8aa1522$var$translate(vectors, translation, context, options = {
    overflowContinuous: 0,
    translateVectors: void 0,
    invertYVectors: void 0,
    snap: void 0
}) {
    const { xAxis: xAxis, yAxis: yAxis } = context;
    const vectorNames = Object.keys(vectors);
    const overflowsX = [];
    const overflowsY = [];
    const translateVectors = new Set(options.translateVectors ?? vectorNames);
    const invertYVectors = new Set(options.invertYVectors ?? []);
    const movingVectors = /* @__PURE__ */ new Set([
        ...translateVectors,
        ...invertYVectors
    ]);
    const invertYTranslation = $2fb96651e8aa1522$var$Vec23.multiply(translation, $2fb96651e8aa1522$var$Vec23.from(1, -1));
    for (const name of vectorNames){
        if (movingVectors.has(name)) {
            vectors[name] = $2fb96651e8aa1522$var$Vec23.add(vectors[name], invertYVectors.has(name) ? invertYTranslation : translation);
            if (options.snap) vectors[name] = $2fb96651e8aa1522$var$snapToAngle(vectors[name], options.snap.vectors[name], options.snap.angle);
        }
        overflowsX.push(xAxis.getRangeOverflow(vectors[name].x));
        overflowsY.push(yAxis.getRangeOverflow(vectors[name].y));
    }
    const sortNumbersAbs = (a, b)=>Math.abs(a) - Math.abs(b);
    const overflowDirection = (scale, directionTranslation, overflows)=>{
        if (options.overflowContinuous === 0 || !$2fb96651e8aa1522$var$ContinuousScale2.is(scale)) return overflows.toSorted(sortNumbersAbs).at(-1) ?? 0;
        if (vectorNames.length === movingVectors.size) return overflows.toSorted(sortNumbersAbs).at(-options.overflowContinuous - 1) ?? 0;
        if (overflows.filter((value)=>value !== 0).length <= options.overflowContinuous) return 0;
        const newTranslatedOverflows = overflows.filter((value, index)=>value !== 0 && Math.abs(value) <= Math.abs(directionTranslation) && movingVectors.has(vectorNames[index]));
        return newTranslatedOverflows.toSorted(sortNumbersAbs).at(-1) ?? 0;
    };
    const overflow = $2fb96651e8aa1522$var$Vec23.from(overflowDirection(xAxis.scale, translation.x, overflowsX), overflowDirection(yAxis.scale, translation.y, overflowsY));
    if (!$2fb96651e8aa1522$var$Vec23.equal(overflow, $2fb96651e8aa1522$var$Vec23.origin())) for (const name of vectorNames){
        if (!movingVectors.has(name)) continue;
        vectors[name] = $2fb96651e8aa1522$var$Vec23.round($2fb96651e8aa1522$var$Vec23.sub(vectors[name], overflow), 4);
    }
    const result = {};
    for (const name of vectorNames)result[name] = $2fb96651e8aa1522$var$invertCoords(vectors[name], context);
    return result;
}
// packages/ag-charts-enterprise/src/features/annotations/scenes/pointScene.ts
var { Vec2: $2fb96651e8aa1522$var$Vec24 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$PointScene = class extends $2fb96651e8aa1522$var$AnnotationScene {
    constructor(){
        super(...arguments);
        this.handle = new $2fb96651e8aa1522$var$DivariantHandle();
        this.anchor = {
            x: 0,
            y: 0,
            position: "above"
        };
    }
    update(datum, context) {
        const coords = $2fb96651e8aa1522$var$convertPoint(datum, context);
        this.updateHandle(datum, coords);
        this.anchor = this.updateAnchor(datum, coords, context);
    }
    dragStart(datum, target, context) {
        this.dragState = {
            offset: target,
            ...$2fb96651e8aa1522$var$getDragStartState({
                handle: datum
            }, context)
        };
    }
    drag(datum, target, context) {
        const { dragState: dragState } = this;
        if (datum.locked || !dragState) return;
        const { point: point } = $2fb96651e8aa1522$var$translate({
            point: dragState.handle
        }, $2fb96651e8aa1522$var$Vec24.sub(target, dragState.offset), context);
        datum.x = point.x;
        datum.y = point.y;
    }
    translate(datum, translation, context) {
        if (datum.locked) return;
        const { point: point } = $2fb96651e8aa1522$var$translate({
            point: $2fb96651e8aa1522$var$convertPoint(datum, context)
        }, translation, context);
        datum.x = point.x;
        datum.y = point.y;
    }
    toggleHandles(show) {
        this.handle.visible = Boolean(show);
        this.handle.toggleHovered(this.activeHandle === "handle");
    }
    toggleActive(active) {
        this.toggleHandles(active);
        this.handle.toggleActive(active);
    }
    stopDragging() {
        this.handle.toggleDragging(false);
    }
    copy(datum, copiedDatum, context) {
        const coords = $2fb96651e8aa1522$var$convertPoint(datum, context);
        const point = $2fb96651e8aa1522$var$invertCoords({
            x: coords.x - 30,
            y: coords.y - 30
        }, context);
        copiedDatum.x = point.x;
        copiedDatum.y = point.y;
        return copiedDatum;
    }
    getAnchor() {
        return this.anchor;
    }
    getCursor() {
        return "pointer";
    }
    containsPoint(x, y) {
        const { handle: handle2 } = this;
        this.activeHandle = void 0;
        if (handle2.containsPoint(x, y)) {
            this.activeHandle = "handle";
            return true;
        }
        return false;
    }
    getNodeAtCoords(x, y) {
        if (this.handle.containsPoint(x, y)) return "handle";
    }
    updateHandle(datum, point, bbox) {
        const { x: x, y: y } = this.getHandleCoords(datum, point, bbox);
        const styles = this.getHandleStyles(datum);
        this.handle.update({
            ...styles,
            x: x,
            y: y
        });
        this.handle.toggleLocked(datum.locked ?? false);
    }
    updateAnchor(datum, point, context) {
        const coords = this.getHandleCoords(datum, point);
        return {
            x: coords.x + context.seriesRect.x,
            y: coords.y + context.seriesRect.y,
            position: this.anchor.position
        };
    }
    getHandleCoords(_datum, point, _bbox) {
        return {
            x: point.x,
            y: point.y
        };
    }
    getHandleStyles(datum) {
        return {
            fill: datum.handle.fill,
            stroke: datum.handle.stroke,
            strokeOpacity: datum.handle.strokeOpacity,
            strokeWidth: datum.handle.strokeWidth
        };
    }
};
// packages/ag-charts-enterprise/src/features/annotations/scenes/shapePointScene.ts
var $2fb96651e8aa1522$var$ShapePointScene = class extends $2fb96651e8aa1522$var$PointScene {
    constructor(){
        super();
        this.append([
            this.handle
        ]);
    }
    update(datum, context) {
        super.update(datum, context);
        const coords = $2fb96651e8aa1522$var$convertPoint(datum, context);
        this.updateShape(datum, coords);
    }
    updateShape(datum, point) {
        this.updateShapeStyles(datum);
        this.updateShapePath(datum, point);
    }
    updateShapeStyles(datum) {
        const { shape: shape } = this;
        shape.fill = datum.fill;
        shape.fillOpacity = datum.fillOpacity ?? 1;
    }
    updateShapePath(datum, point) {
        const { shape: shape } = this;
        shape.x = point.x;
        shape.y = point.y;
        shape.size = datum.size;
    }
    containsPoint(x, y) {
        return super.containsPoint(x, y) || this.shape.containsPoint(x, y);
    }
    getNodeAtCoords(x, y) {
        if (this.shape.containsPoint(x, y)) return "shape";
        return super.getNodeAtCoords(x, y);
    }
};
// packages/ag-charts-enterprise/src/features/annotations/arrow-up/arrowUpScene.ts
var $2fb96651e8aa1522$var$arrowUpPoints = [
    [
        0.5,
        0
    ],
    [
        1,
        0.5
    ],
    [
        0.75,
        0.5
    ],
    [
        0.75,
        1
    ],
    [
        0.25,
        1
    ],
    [
        0.25,
        0.5
    ],
    [
        0,
        0.5
    ]
];
function $2fb96651e8aa1522$var$arrowUp(params) {
    (0, $iTJTu._ModuleSupport).drawMarkerUnitPolygon(params, $2fb96651e8aa1522$var$arrowUpPoints);
}
$2fb96651e8aa1522$var$arrowUp.anchor = {
    x: 0.5,
    y: 0
};
var $2fb96651e8aa1522$var$ArrowUpScene = class extends $2fb96651e8aa1522$var$ShapePointScene {
    constructor(){
        super();
        this.type = "arrow-up" /* ArrowUp */ ;
        this.shape = new (0, $iTJTu._ModuleSupport).Marker({
            shape: $2fb96651e8aa1522$var$arrowUp
        });
        this.append([
            this.shape
        ]);
    }
    static is(value) {
        return $2fb96651e8aa1522$var$AnnotationScene.isCheck(value, "arrow-up" /* ArrowUp */ );
    }
    getHandleCoords(datum, point) {
        const halfSize = $2fb96651e8aa1522$var$DivariantHandle.HANDLE_SIZE / 2;
        const handleCoords = super.getHandleCoords(datum, point);
        handleCoords.y -= halfSize;
        return handleCoords;
    }
};
// packages/ag-charts-enterprise/src/features/annotations/arrow-down/arrowDownScene.ts
var $2fb96651e8aa1522$var$arrowDownPoints = $2fb96651e8aa1522$var$arrowUpPoints.map(([x, y])=>[
        x,
        1 - y
    ]);
function $2fb96651e8aa1522$var$arrowDown(params) {
    (0, $iTJTu._ModuleSupport).drawMarkerUnitPolygon(params, $2fb96651e8aa1522$var$arrowDownPoints);
}
$2fb96651e8aa1522$var$arrowDown.anchor = {
    x: 0.5,
    y: 1
};
var $2fb96651e8aa1522$var$ArrowDownScene = class extends $2fb96651e8aa1522$var$ShapePointScene {
    constructor(){
        super();
        this.type = "arrow-down" /* ArrowDown */ ;
        this.shape = new (0, $iTJTu._ModuleSupport).Marker({
            shape: $2fb96651e8aa1522$var$arrowDown
        });
        this.append([
            this.shape
        ]);
    }
    static is(value) {
        return $2fb96651e8aa1522$var$AnnotationScene.isCheck(value, "arrow-down" /* ArrowDown */ );
    }
    updateAnchor(datum, point, context) {
        const anchor = super.updateAnchor(datum, point, context);
        anchor.y -= datum.size;
        return anchor;
    }
    getHandleCoords(datum, point) {
        const halfSize = $2fb96651e8aa1522$var$DivariantHandle.HANDLE_SIZE / 2;
        const handleCoords = super.getHandleCoords(datum, point);
        handleCoords.y += halfSize;
        return handleCoords;
    }
};
var { StateMachine: $2fb96651e8aa1522$var$StateMachine2, StateMachineProperty: $2fb96651e8aa1522$var$StateMachineProperty2, Debug: $2fb96651e8aa1522$var$Debug2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$PointStateMachine = class extends $2fb96651e8aa1522$var$StateMachine2 {
    constructor(ctx){
        const actionCreate = ({ point: point })=>{
            const datum = this.createDatum();
            datum.set({
                x: point.x,
                y: point.y
            });
            ctx.create(datum);
        };
        const actionFirstRender = ()=>{
            this.node?.toggleActive(true);
            ctx.showAnnotationOptions();
            ctx.update();
        };
        super("start", {
            start: {
                click: {
                    target: "waiting-first-render",
                    action: actionCreate
                },
                drag: {
                    target: "waiting-first-render",
                    action: actionCreate
                },
                cancel: $2fb96651e8aa1522$var$StateMachine2.parent,
                reset: $2fb96651e8aa1522$var$StateMachine2.parent
            },
            "waiting-first-render": {
                render: {
                    target: $2fb96651e8aa1522$var$StateMachine2.parent,
                    action: actionFirstRender
                }
            }
        });
        this.debug = $2fb96651e8aa1522$var$Debug2.create(true, "annotations");
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty2()
], $2fb96651e8aa1522$var$PointStateMachine.prototype, "node", 2);
// packages/ag-charts-enterprise/src/features/annotations/arrow-down/arrowDownState.ts
var $2fb96651e8aa1522$var$ArrowDownStateMachine = class extends $2fb96651e8aa1522$var$PointStateMachine {
    createDatum() {
        return new $2fb96651e8aa1522$var$ArrowDownProperties();
    }
};
// packages/ag-charts-enterprise/src/features/annotations/arrow-down/arrowDownConfig.ts
var $2fb96651e8aa1522$var$arrowDownConfig = {
    type: "arrow-down" /* ArrowDown */ ,
    datum: $2fb96651e8aa1522$var$ArrowDownProperties,
    scene: $2fb96651e8aa1522$var$ArrowDownScene,
    isDatum: $2fb96651e8aa1522$var$ArrowDownProperties.is,
    translate: (node, datum, translation, context)=>{
        if ($2fb96651e8aa1522$var$ArrowDownProperties.is(datum) && $2fb96651e8aa1522$var$ArrowDownScene.is(node)) node.translate(datum, translation, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$ArrowDownProperties.is(datum) && $2fb96651e8aa1522$var$ArrowDownProperties.is(copiedDatum) && $2fb96651e8aa1522$var$ArrowDownScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$ArrowDownProperties.is(datum) && $2fb96651e8aa1522$var$ArrowDownScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$ArrowDownStateMachine({
            ...ctx,
            create: createDatum("arrow-down" /* ArrowDown */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
var { Property: $2fb96651e8aa1522$var$Property30 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$ArrowUpProperties = class extends $2fb96651e8aa1522$var$ShapePointProperties {
    constructor(){
        super(...arguments);
        this.type = "arrow-up" /* ArrowUp */ ;
    }
    static is(value) {
        return (0, $idDdm.isObject)(value) && value.type === "arrow-up" /* ArrowUp */ ;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property30
], $2fb96651e8aa1522$var$ArrowUpProperties.prototype, "type", 2);
// packages/ag-charts-enterprise/src/features/annotations/arrow-up/arrowUpState.ts
var $2fb96651e8aa1522$var$ArrowUpStateMachine = class extends $2fb96651e8aa1522$var$PointStateMachine {
    createDatum() {
        return new $2fb96651e8aa1522$var$ArrowUpProperties();
    }
};
// packages/ag-charts-enterprise/src/features/annotations/arrow-up/arrowUpConfig.ts
var $2fb96651e8aa1522$var$arrowUpConfig = {
    type: "arrow-up" /* ArrowUp */ ,
    datum: $2fb96651e8aa1522$var$ArrowUpProperties,
    scene: $2fb96651e8aa1522$var$ArrowUpScene,
    isDatum: $2fb96651e8aa1522$var$ArrowUpProperties.is,
    translate: (node, datum, translation, context)=>{
        if ($2fb96651e8aa1522$var$ArrowUpProperties.is(datum) && $2fb96651e8aa1522$var$ArrowUpScene.is(node)) node.translate(datum, translation, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$ArrowUpProperties.is(datum) && $2fb96651e8aa1522$var$ArrowUpProperties.is(copiedDatum) && $2fb96651e8aa1522$var$ArrowUpScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$ArrowUpProperties.is(datum) && $2fb96651e8aa1522$var$ArrowUpScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$ArrowUpStateMachine({
            ...ctx,
            create: createDatum("arrow-up" /* ArrowUp */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
var { Vec2: $2fb96651e8aa1522$var$Vec25, Vec4: $2fb96651e8aa1522$var$Vec4 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$LinearScene = class extends $2fb96651e8aa1522$var$AnnotationScene {
    constructor(){
        super(...arguments);
        this.overflowContinuous = 0;
    }
    extendLine({ x1: x1, y1: y1, x2: x2, y2: y2 }, datum, context) {
        const linePoints = {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        };
        if (!datum.extendStart && !datum.extendEnd) return linePoints;
        const [left, right] = $2fb96651e8aa1522$var$boundsIntersections(linePoints, context.yAxis.bounds);
        const isFlippedX = linePoints.x2 < linePoints.x1;
        const isFlippedY = linePoints.y1 >= linePoints.y2;
        const isVertical = linePoints.x2 === linePoints.x1;
        if (datum.extendEnd) {
            if (isVertical) linePoints.y2 = isFlippedY ? right.y : left.y;
            else {
                linePoints.x2 = isFlippedX ? left.x : right.x;
                linePoints.y2 = isFlippedX ? left.y : right.y;
            }
        }
        if (datum.extendStart) {
            if (isVertical) linePoints.y1 = isFlippedY ? left.y : right.y;
            else {
                linePoints.x1 = isFlippedX ? right.x : left.x;
                linePoints.y1 = isFlippedX ? right.y : left.y;
            }
        }
        return linePoints;
    }
    dragStart(datum, target, context) {
        this.dragState = {
            offset: target,
            ...$2fb96651e8aa1522$var$getDragStartState({
                start: datum.start,
                end: datum.end
            }, context)
        };
    }
    drag(datum, target, context, snapping) {
        if (datum.locked) return;
        if (this.activeHandle) this.dragHandle(datum, target, context, snapping);
        else this.dragAll(datum, target, context);
    }
    dragAll(datum, target, context) {
        const { dragState: dragState } = this;
        if (!dragState) return;
        this.translatePoints(datum, dragState.start, dragState.end, $2fb96651e8aa1522$var$Vec25.sub(target, dragState.offset), context);
    }
    translate(datum, translation, context) {
        if (datum.locked) return;
        this.translatePoints(datum, $2fb96651e8aa1522$var$convertPoint(datum.start, context), $2fb96651e8aa1522$var$convertPoint(datum.end, context), translation, context);
    }
    copy(datum, copiedDatum, context) {
        const coords = $2fb96651e8aa1522$var$convertLine(datum, context);
        if (!coords) return;
        const bbox = this.computeBBoxWithoutHandles();
        const translation = {
            x: -bbox.width / 2,
            y: -bbox.height / 2
        };
        this.translatePoints(copiedDatum, $2fb96651e8aa1522$var$Vec4.start(coords), $2fb96651e8aa1522$var$Vec4.end(coords), translation, context);
        return copiedDatum;
    }
    translatePoints(datum, start, end, translation, context) {
        const vectors = this.getTranslatePointsVectors(start, end);
        const points = $2fb96651e8aa1522$var$translate(vectors, translation, context, {
            overflowContinuous: this.overflowContinuous
        });
        datum.start.x = points.start.x;
        datum.end.x = points.end.x;
        datum.start.y = points.start.y;
        datum.end.y = points.end.y;
    }
    getTranslatePointsVectors(start, end) {
        return {
            start: start,
            end: end
        };
    }
};
// packages/ag-charts-enterprise/src/features/annotations/scenes/startEndScene.ts
var { Vec2: $2fb96651e8aa1522$var$Vec26, Vec4: $2fb96651e8aa1522$var$Vec42 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$StartEndScene = class extends $2fb96651e8aa1522$var$LinearScene {
    constructor(){
        super(...arguments);
        this.start = new $2fb96651e8aa1522$var$DivariantHandle();
        this.end = new $2fb96651e8aa1522$var$DivariantHandle();
        this.anchor = {
            x: 0,
            y: 0,
            position: "above"
        };
    }
    update(datum, context) {
        const coords = $2fb96651e8aa1522$var$convertLine(datum, context);
        if (coords == null) return;
        this.updateHandles(datum, coords);
        this.updateAnchor(datum, coords, context);
    }
    toggleHandles(show) {
        if (typeof show === "boolean") {
            this.start.visible = show;
            this.end.visible = show;
        } else for (const [handle2, visible] of (0, $idDdm.entries)(show))this[handle2].visible = visible;
        this.start.toggleHovered(this.activeHandle === "start");
        this.end.toggleHovered(this.activeHandle === "end");
    }
    toggleActive(active) {
        this.toggleHandles(active);
        this.start.toggleActive(active);
        this.end.toggleActive(active);
    }
    dragHandle(datum, target, context, snapping) {
        const { activeHandle: activeHandle, dragState: dragState } = this;
        if (!activeHandle || !dragState) return;
        this[activeHandle].toggleDragging(true);
        const snapHandle = activeHandle === "start" ? "end" : "start";
        const snap = snapping ? {
            vectors: {
                [activeHandle]: $2fb96651e8aa1522$var$convertPoint(datum[snapHandle], context)
            },
            angle: datum.snapToAngle
        } : void 0;
        const { [activeHandle]: point } = $2fb96651e8aa1522$var$translate({
            [activeHandle]: dragState[activeHandle]
        }, $2fb96651e8aa1522$var$Vec26.sub(target, dragState.offset), context, {
            overflowContinuous: 0,
            snap: snap
        });
        datum[activeHandle].x = point.x;
        datum[activeHandle].y = point.y;
    }
    stopDragging() {
        this.start.toggleDragging(false);
        this.end.toggleDragging(false);
    }
    getAnchor() {
        return this.anchor;
    }
    getCursor() {
        return "pointer";
    }
    containsPoint(x, y) {
        const { start: start, end: end } = this;
        this.activeHandle = void 0;
        if (start.containsPoint(x, y)) {
            this.activeHandle = "start";
            return true;
        }
        if (end.containsPoint(x, y)) {
            this.activeHandle = "end";
            return true;
        }
        return false;
    }
    getNodeAtCoords(x, y) {
        if (this.start.containsPoint(x, y) || this.end.containsPoint(x, y)) return "handle";
    }
    updateHandles(datum, coords, bbox) {
        this.start.update({
            ...this.getHandleStyles(datum, "start"),
            ...this.getHandleCoords(datum, coords, "start")
        });
        this.end.update({
            ...this.getHandleStyles(datum, "end"),
            ...this.getHandleCoords(datum, coords, "end", bbox)
        });
        this.start.toggleLocked(datum.locked ?? false);
        this.end.toggleLocked(datum.locked ?? false);
    }
    updateAnchor(_datum, coords, context, _bbox) {
        this.anchor = {
            x: coords.x1 + context.seriesRect.x,
            y: coords.y1 + context.seriesRect.y,
            position: this.anchor.position
        };
    }
    getHandleCoords(_datum, coords, handle2, _bbox) {
        return handle2 === "start" ? $2fb96651e8aa1522$var$Vec42.start(coords) : $2fb96651e8aa1522$var$Vec42.end(coords);
    }
    getHandleStyles(datum, _handle) {
        return {
            fill: datum.handle.fill,
            stroke: datum.handle.stroke,
            strokeOpacity: datum.handle.strokeOpacity,
            strokeWidth: datum.handle.strokeWidth
        };
    }
};
// packages/ag-charts-enterprise/src/features/annotations/scenes/textualStartEndScene.ts
var { Vec4: $2fb96651e8aa1522$var$Vec43 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$TextualStartEndScene = class extends $2fb96651e8aa1522$var$StartEndScene {
    constructor(){
        super(...arguments);
        this.label = new (0, $iTJTu._ModuleSupport).Text({
            zIndex: 1
        });
        this.anchor = {
            x: 0,
            y: 0,
            position: "above-left"
        };
    }
    setTextInputBBox(bbox) {
        this.textInputBBox = bbox;
        this.markDirty("TextualStartEndScene");
    }
    update(datum, context) {
        const coords = $2fb96651e8aa1522$var$convertLine(datum, context);
        if (coords == null) return;
        const bbox = this.getTextBBox(datum, coords);
        this.updateLabel(datum, bbox, coords);
        this.updateHandles(datum, coords, bbox);
        this.updateShape(datum, bbox, coords);
        this.updateAnchor(datum, coords, context, bbox);
    }
    containsPoint(x, y) {
        return super.containsPoint(x, y) || this.label.containsPoint(x, y);
    }
    getNodeAtCoords(x, y) {
        if (this.label.containsPoint(x, y)) return "text";
        return super.getNodeAtCoords(x, y);
    }
    getTextBBox(datum, coords) {
        const { text: text2 } = datum.getText();
        return $2fb96651e8aa1522$var$getBBox(datum, text2, $2fb96651e8aa1522$var$Vec43.end(coords), this.textInputBBox);
    }
    updateLabel(datum, bbox, coords) {
        const { text: text2, isPlaceholder: isPlaceholder } = datum.getText();
        $2fb96651e8aa1522$var$updateTextNode(this.label, text2, isPlaceholder, datum, this.getLabelCoords(datum, bbox, coords));
    }
    updateShape(_datum, _textBBox, _coords) {}
    getLabelCoords(_datum, _bbox, coords) {
        return $2fb96651e8aa1522$var$Vec43.end(coords);
    }
    getHandleStyles(datum, handle2) {
        return {
            ...super.getHandleStyles(datum, handle2),
            stroke: datum.handle.stroke ?? datum.color
        };
    }
};
// packages/ag-charts-enterprise/src/features/annotations/callout/calloutScene.ts
var { drawCorner: $2fb96651e8aa1522$var$drawCorner, Path: $2fb96651e8aa1522$var$Path5 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$CalloutScene = class extends $2fb96651e8aa1522$var$TextualStartEndScene {
    constructor(){
        super();
        this.type = "callout" /* Callout */ ;
        this.shape = new $2fb96651e8aa1522$var$Path5();
        this.append([
            this.shape,
            this.label,
            this.start,
            this.end
        ]);
    }
    static is(value) {
        return $2fb96651e8aa1522$var$AnnotationScene.isCheck(value, "callout" /* Callout */ );
    }
    drag(datum, target, context, snapping) {
        if (datum.locked) return;
        if (this.activeHandle === "end") this.dragHandle(datum, target, context, snapping);
        else this.dragAll(datum, target, context);
    }
    getLabelCoords(datum, bbox, coords) {
        const padding = datum.getPadding();
        const { bodyBounds: bodyBounds = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        } } = this.getDimensions(datum, bbox, coords) ?? {};
        return {
            x: bodyBounds.x + padding.left,
            y: bodyBounds.y - padding.bottom
        };
    }
    getHandleStyles(datum, handle2) {
        return handle2 === "start" ? {
            fill: datum.handle.fill,
            stroke: datum.handle.stroke ?? datum.stroke,
            strokeOpacity: datum.handle.strokeOpacity,
            strokeWidth: datum.handle.strokeWidth
        } : {
            fill: void 0,
            strokeWidth: 0
        };
    }
    updateAnchor(datum, coords, context, bbox) {
        const { bodyBounds: bodyBounds } = this.getDimensions(datum, bbox, coords) ?? {};
        const bounds = bodyBounds ?? bbox;
        this.anchor = {
            x: bounds.x + context.seriesRect.x,
            y: bounds.y + context.seriesRect.y - bounds.height,
            position: this.anchor.position
        };
    }
    updateShape(datum, textBBox, coords) {
        const { shape: shape } = this;
        shape.fill = datum.fill;
        shape.fillOpacity = datum.fillOpacity ?? 1;
        shape.stroke = datum.stroke;
        shape.strokeWidth = datum.strokeWidth ?? 1;
        shape.strokeOpacity = datum.strokeOpacity ?? 1;
        const { tailPoint: tailPoint, bodyBounds: bodyBounds } = this.getDimensions(datum, textBBox, coords) ?? {};
        if (!tailPoint || !bodyBounds) return;
        this.updatePath(tailPoint, bodyBounds);
    }
    updatePath(tailPoint, bodyBounds) {
        const { x: tailX, y: tailY } = tailPoint;
        const { x: x, y: y, width: width, height: height } = bodyBounds;
        const top = y - height;
        const right = x + width;
        const placement = this.calculateCalloutPlacement({
            x: tailX,
            y: tailY
        }, bodyBounds);
        const cornerRadius = 8;
        const pathParams = [
            {
                coordinates: {
                    x0: x,
                    x1: x + cornerRadius,
                    y0: top + cornerRadius,
                    y1: top,
                    cx: placement === `topLeft` ? tailX : x + cornerRadius,
                    cy: placement === `topLeft` ? tailY : top + cornerRadius
                },
                type: placement === `topLeft` ? "calloutCorner" : "corner"
            },
            {
                coordinates: {
                    x0: x + cornerRadius,
                    x1: right - cornerRadius,
                    y0: top,
                    y1: top,
                    cx: tailX,
                    cy: tailY
                },
                type: placement === `top` ? "calloutSide" : "side"
            },
            {
                coordinates: {
                    x0: right - cornerRadius,
                    x1: right,
                    y0: top,
                    y1: top + cornerRadius,
                    cx: placement === `topRight` ? tailX : right - cornerRadius,
                    cy: placement === `topRight` ? tailY : top + cornerRadius
                },
                type: placement === `topRight` ? "calloutCorner" : "corner"
            },
            {
                coordinates: {
                    x0: right,
                    x1: right,
                    y0: top + cornerRadius,
                    y1: y - cornerRadius,
                    cx: tailX,
                    cy: tailY
                },
                type: placement === `right` ? "calloutSide" : "side"
            },
            {
                coordinates: {
                    x0: right,
                    x1: right - cornerRadius,
                    y0: y - cornerRadius,
                    y1: y,
                    cx: placement === `bottomRight` ? tailX : right - cornerRadius,
                    cy: placement === `bottomRight` ? tailY : y - cornerRadius
                },
                type: placement === `bottomRight` ? "calloutCorner" : "corner"
            },
            {
                coordinates: {
                    x0: right - cornerRadius,
                    x1: x + cornerRadius,
                    y0: y,
                    y1: y,
                    cx: tailX,
                    cy: tailY
                },
                type: placement === `bottom` ? "calloutSide" : "side"
            },
            {
                coordinates: {
                    x0: x + cornerRadius,
                    x1: x,
                    y0: y,
                    y1: y - cornerRadius,
                    cx: placement === `bottomLeft` ? tailX : x + cornerRadius,
                    cy: placement === `bottomLeft` ? tailY : y - cornerRadius
                },
                type: placement === `bottomLeft` ? "calloutCorner" : "corner"
            },
            {
                coordinates: {
                    x0: x,
                    x1: x,
                    y0: y - cornerRadius,
                    y1: top + cornerRadius,
                    cx: tailX,
                    cy: tailY
                },
                type: placement === `left` ? "calloutSide" : "side"
            }
        ];
        const { path: path } = this.shape;
        path.clear();
        path.moveTo(x, top + cornerRadius);
        pathParams.forEach(({ coordinates: coordinates, type: type })=>{
            this.drawPath(path, coordinates, cornerRadius, type);
        });
        path.closePath();
    }
    drawPath(path, { x0: x0, y0: y0, x1: x1, y1: y1, cx: cx, cy: cy }, cornerRadius, type) {
        const sideTailRadius = 6;
        switch(type){
            case "calloutCorner":
                path.lineTo(cx, cy);
                path.lineTo(x1, y1);
                break;
            case "corner":
                $2fb96651e8aa1522$var$drawCorner(path, {
                    x0: x0,
                    x1: x1,
                    y0: y0,
                    y1: y1,
                    cx: cx,
                    cy: cy
                }, cornerRadius, false);
                break;
            case "calloutSide":
                if (x0 !== x1) {
                    const direction = x0 > x1 ? -1 : 1;
                    const midX = Math.min(x0, x1) + Math.abs(x1 - x0) / 2;
                    path.lineTo(midX - sideTailRadius * direction, y0);
                    path.lineTo(cx, cy);
                    path.lineTo(midX + sideTailRadius * direction, y0);
                    path.lineTo(x1, y1);
                } else {
                    const direction = y0 > y1 ? -1 : 1;
                    const midY = Math.min(y0, y1) + Math.abs(y0 - y1) / 2;
                    path.lineTo(x0, midY - sideTailRadius * direction);
                    path.lineTo(cx, cy);
                    path.lineTo(x0, midY + sideTailRadius * direction);
                    path.lineTo(x1, y1);
                }
                break;
            case "side":
            default:
                path.lineTo(x1, y1);
                break;
        }
    }
    calculateCalloutPlacement(placement, bounds) {
        const right = bounds.x + bounds.width;
        const top = bounds.y - bounds.height;
        let xPlacement;
        let yPlacement;
        if (placement.x > right) xPlacement = "right";
        else if (placement.x < bounds.x) xPlacement = "left";
        if (placement.y > bounds.y) yPlacement = "bottom";
        else if (placement.y < top) yPlacement = "top";
        if (xPlacement && yPlacement) return `${yPlacement}${xPlacement[0].toUpperCase()}${xPlacement.substring(1)}`;
        else return yPlacement ?? xPlacement;
    }
    getDimensions(datum, textBBox, coords) {
        const { fontSize: fontSize } = datum;
        const padding = datum.getPadding();
        const horizontalPadding = padding.left + padding.right;
        const verticalPadding = padding.top + padding.bottom;
        const width = textBBox.width + horizontalPadding;
        const height = Math.max(textBBox.height + verticalPadding, fontSize + verticalPadding);
        return {
            tailPoint: {
                x: coords.x1,
                y: coords.y1
            },
            bodyBounds: {
                x: textBBox.x,
                y: textBBox.y,
                width: width,
                height: height
            }
        };
    }
    containsPoint(x, y) {
        const { start: start, end: end, shape: shape } = this;
        this.activeHandle = void 0;
        if (start.containsPoint(x, y)) {
            this.activeHandle = "start";
            return true;
        }
        const bodyContainsPoint = end.containsPoint(x, y) || shape.containsPoint(x, y);
        if (bodyContainsPoint) this.activeHandle = "end";
        return bodyContainsPoint;
    }
};
// packages/ag-charts-enterprise/src/features/annotations/states/textualStateUtils.ts
function $2fb96651e8aa1522$var$guardCancelAndExit({ key: key }) {
    return key === "Escape";
}
function $2fb96651e8aa1522$var$guardSaveAndExit({ key: key, shiftKey: shiftKey }) {
    return !shiftKey && key === "Enter";
}
// packages/ag-charts-enterprise/src/features/annotations/states/textualStartEndState.ts
var { StateMachine: $2fb96651e8aa1522$var$StateMachine3, StateMachineProperty: $2fb96651e8aa1522$var$StateMachineProperty3, Debug: $2fb96651e8aa1522$var$Debug3 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$TextualStartEndStateMachine = class extends $2fb96651e8aa1522$var$StateMachine3 {
    constructor(ctx){
        const actionCreate = ({ point: point })=>{
            const datum = this.createDatum();
            datum.set({
                start: point,
                end: point,
                visible: true
            });
            ctx.create(datum);
        };
        const actionFirstRender = ()=>{
            const { node: node } = this;
            node?.toggleActive(true);
            node?.toggleHandles({
                start: true
            });
        };
        const onStartEditing = ()=>{
            ctx.showTextInput();
            if (this.datum) this.datum.visible = false;
        };
        const onStopEditing = ()=>{
            ctx.hideTextInput();
            if (this.datum) this.datum.visible = true;
            ctx.deselect();
        };
        const actionUpdateTextInputBBox = (bbox)=>{
            this.node?.setTextInputBBox(bbox);
            ctx.update();
        };
        const onEndHover = ({ point: point })=>{
            const { datum: datum, node: node } = this;
            datum?.set({
                end: point
            });
            node?.toggleActive(true);
            node?.toggleHandles({
                end: false
            });
            ctx.update();
        };
        const onEndClick = ()=>{
            ctx.showAnnotationOptions();
            this.node?.toggleHandles({
                end: true
            });
        };
        const actionColor = ({ colorPickerType: colorPickerType, colorOpacity: colorOpacity, color: color6, opacity: opacity, isMultiColor: isMultiColor })=>{
            const { datum: datum } = this;
            if (!datum) return;
            if (colorPickerType === "text-color") ctx.updateTextInputColor(color6);
            $2fb96651e8aa1522$var$setColor(datum, colorPickerType, colorOpacity, color6, opacity, isMultiColor);
            ctx.update();
        };
        const actionFontSize = (fontSize)=>{
            const { datum: datum, node: node } = this;
            if (!datum || !node || !$2fb96651e8aa1522$var$isTextType(datum)) return;
            datum.fontSize = fontSize;
            ctx.updateTextInputFontSize(fontSize);
            ctx.update();
        };
        const actionCancel = ()=>{
            ctx.delete();
        };
        const actionSave = ({ textInputValue: textInputValue, bbox: bbox })=>{
            const { datum: datum } = this;
            if (bbox != null && textInputValue != null && textInputValue.length > 0) {
                if (!$2fb96651e8aa1522$var$isTextType(datum)) return;
                const wrappedText = $2fb96651e8aa1522$var$wrapText(datum, textInputValue, bbox.width);
                datum?.set({
                    text: wrappedText
                });
                ctx.update();
                ctx.recordAction(`Create ${datum?.type} annotation`);
            } else ctx.delete();
        };
        super("start", {
            start: {
                click: {
                    target: "waiting-first-render",
                    action: actionCreate
                },
                dragStart: {
                    target: "waiting-first-render",
                    action: actionCreate
                },
                cancel: $2fb96651e8aa1522$var$StateMachine3.parent,
                reset: $2fb96651e8aa1522$var$StateMachine3.parent
            },
            "waiting-first-render": {
                render: {
                    target: "end",
                    action: actionFirstRender
                }
            },
            end: {
                hover: onEndHover,
                drag: onEndHover,
                click: {
                    target: "edit",
                    action: onEndClick
                },
                dragEnd: {
                    target: "edit",
                    action: onEndClick
                },
                reset: {
                    target: $2fb96651e8aa1522$var$StateMachine3.parent,
                    action: actionCancel
                },
                cancel: {
                    target: $2fb96651e8aa1522$var$StateMachine3.parent,
                    action: actionCancel
                }
            },
            edit: {
                onEnter: onStartEditing,
                updateTextInputBBox: actionUpdateTextInputBBox,
                color: actionColor,
                fontSize: actionFontSize,
                textInput: [
                    {
                        guard: $2fb96651e8aa1522$var$guardCancelAndExit,
                        target: $2fb96651e8aa1522$var$StateMachine3.parent,
                        action: actionCancel
                    },
                    {
                        guard: $2fb96651e8aa1522$var$guardSaveAndExit,
                        target: $2fb96651e8aa1522$var$StateMachine3.parent,
                        action: actionSave
                    }
                ],
                click: {
                    target: $2fb96651e8aa1522$var$StateMachine3.parent,
                    action: actionSave
                },
                dragStart: {
                    target: $2fb96651e8aa1522$var$StateMachine3.parent,
                    action: actionSave
                },
                resize: {
                    target: $2fb96651e8aa1522$var$StateMachine3.parent,
                    action: actionSave
                },
                onExit: onStopEditing,
                cancel: {
                    target: $2fb96651e8aa1522$var$StateMachine3.parent,
                    action: actionCancel
                }
            }
        });
        this.debug = $2fb96651e8aa1522$var$Debug3.create(true, "annotations");
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty3()
], $2fb96651e8aa1522$var$TextualStartEndStateMachine.prototype, "datum", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty3()
], $2fb96651e8aa1522$var$TextualStartEndStateMachine.prototype, "node", 2);
// packages/ag-charts-enterprise/src/features/annotations/callout/calloutState.ts
var $2fb96651e8aa1522$var$CalloutStateMachine = class extends $2fb96651e8aa1522$var$TextualStartEndStateMachine {
    createDatum() {
        return new $2fb96651e8aa1522$var$CalloutProperties();
    }
};
// packages/ag-charts-enterprise/src/features/annotations/callout/calloutConfig.ts
var $2fb96651e8aa1522$var$calloutConfig = {
    type: "callout" /* Callout */ ,
    datum: $2fb96651e8aa1522$var$CalloutProperties,
    scene: $2fb96651e8aa1522$var$CalloutScene,
    isDatum: $2fb96651e8aa1522$var$CalloutProperties.is,
    translate: (node, datum, transition, context)=>{
        if ($2fb96651e8aa1522$var$CalloutProperties.is(datum) && $2fb96651e8aa1522$var$CalloutScene.is(node)) return node.translate(datum, transition, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$CalloutProperties.is(datum) && $2fb96651e8aa1522$var$CalloutProperties.is(copiedDatum) && $2fb96651e8aa1522$var$CalloutScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$CalloutProperties.is(datum) && $2fb96651e8aa1522$var$CalloutScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$CalloutStateMachine({
            ...ctx,
            create: createDatum("callout" /* Callout */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
var $2fb96651e8aa1522$var$TextualPointScene = class extends $2fb96651e8aa1522$var$PointScene {
    constructor(){
        super(...arguments);
        this.label = new (0, $iTJTu._ModuleSupport).Text({
            zIndex: 1
        });
        this.anchor = {
            x: 0,
            y: 0,
            position: "above-left"
        };
    }
    setTextInputBBox(bbox) {
        this.textInputBBox = bbox;
        this.markDirty("TextualPointScene");
    }
    update(datum, context) {
        const coords = $2fb96651e8aa1522$var$convertPoint(datum, context);
        const bbox = this.getTextBBox(datum, coords, context);
        this.updateLabel(datum, bbox);
        this.updateHandle(datum, coords, bbox);
        this.updateShape(datum, bbox);
        this.anchor = this.updateAnchor(datum, bbox, context);
    }
    copy(datum, copiedDatum, context) {
        const coords = $2fb96651e8aa1522$var$convertPoint(datum, context);
        const bbox = this.getTextBBox(datum, coords, context);
        const padding = datum.getPadding();
        const horizontalPadding = padding.left + padding.right;
        const verticalPadding = padding.top + padding.bottom;
        const xOffset = (bbox.width + horizontalPadding) / 2;
        const yOffset = bbox.height + verticalPadding;
        const point = $2fb96651e8aa1522$var$invertCoords({
            x: coords.x - xOffset,
            y: coords.y - yOffset
        }, context);
        copiedDatum.x = point.x;
        copiedDatum.y = point.y;
        return copiedDatum;
    }
    containsPoint(x, y) {
        const { label: label } = this;
        return super.containsPoint(x, y) || label.visible && label.containsPoint(x, y);
    }
    getNodeAtCoords(x, y) {
        if (this.label.visible && this.label.containsPoint(x, y)) return "text";
        return super.getNodeAtCoords(x, y);
    }
    getTextBBox(datum, coords, _context) {
        const { text: text2 } = datum.getText();
        return $2fb96651e8aa1522$var$getBBox(datum, text2, {
            x: coords.x,
            y: coords.y
        }, this.textInputBBox);
    }
    updateLabel(datum, bbox) {
        const { text: text2, isPlaceholder: isPlaceholder } = datum.getText();
        $2fb96651e8aa1522$var$updateTextNode(this.label, text2, isPlaceholder, datum, this.getLabelCoords(datum, bbox), this.getTextBaseline(datum));
    }
    updateShape(_datum, _bbox) {}
    updateAnchor(_datum, bbox, context) {
        return {
            x: bbox.x + context.seriesRect.x,
            y: bbox.y + context.seriesRect.y - bbox.height,
            position: this.anchor.position
        };
    }
    getLabelCoords(_datum, bbox) {
        return bbox;
    }
    getTextBaseline(datum) {
        return datum.position == "center" ? "middle" : datum.position;
    }
    getHandleCoords(_datum, _coords, bbox) {
        return bbox;
    }
    getHandleStyles(datum) {
        const styles = super.getHandleStyles(datum);
        styles.stroke = datum.handle.stroke ?? datum.color;
        return styles;
    }
};
// packages/ag-charts-enterprise/src/features/annotations/comment/commentScene.ts
var { drawCorner: $2fb96651e8aa1522$var$drawCorner2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$CommentScene = class extends $2fb96651e8aa1522$var$TextualPointScene {
    constructor(){
        super();
        this.type = "comment" /* Comment */ ;
        this.shape = new (0, $iTJTu._ModuleSupport).Path();
        this.append([
            this.shape,
            this.label,
            this.handle
        ]);
    }
    static is(value) {
        return $2fb96651e8aa1522$var$AnnotationScene.isCheck(value, "comment" /* Comment */ );
    }
    updateShape(datum, bbox) {
        const { shape: shape } = this;
        shape.fill = datum.fill;
        shape.fillOpacity = datum.fillOpacity ?? 1;
        shape.stroke = datum.stroke ?? "transparent";
        shape.strokeWidth = datum.strokeWidth ?? 1;
        shape.strokeOpacity = datum.strokeOpacity ?? 1;
        this.updatePath(datum, bbox);
    }
    getLabelCoords(datum, point) {
        const padding = datum.getPadding();
        return {
            x: point.x + padding.left,
            y: point.y - padding.bottom
        };
    }
    getHandleStyles(datum) {
        return {
            fill: datum.handle.fill,
            stroke: datum.handle.stroke ?? datum.stroke ?? datum.fill,
            strokeOpacity: datum.handle.strokeOpacity,
            strokeWidth: datum.handle.strokeWidth
        };
    }
    updateAnchor(datum, bbox, context) {
        const anchor = super.updateAnchor(datum, bbox, context);
        const padding = datum.getPadding();
        anchor.y -= padding.bottom + padding.top;
        return anchor;
    }
    updatePath(datum, bbox) {
        const padding = datum.getPadding();
        const { x: x, y: y } = bbox;
        let { width: width, height: height } = bbox;
        const { fontSize: fontSize } = datum;
        const horizontalPadding = padding.left + padding.right;
        const verticalPadding = padding.top + padding.bottom;
        width = width + horizontalPadding;
        height = Math.max(height + verticalPadding, fontSize + verticalPadding);
        const top = y - height;
        const right = x + width;
        const cornerRadius = (fontSize * $2fb96651e8aa1522$var$ANNOTATION_TEXT_LINE_HEIGHT + verticalPadding) / 2;
        const { path: path } = this.shape;
        path.clear();
        path.moveTo(x, y);
        path.lineTo(x, top + cornerRadius);
        $2fb96651e8aa1522$var$drawCorner2(path, {
            x0: x,
            x1: x + cornerRadius,
            y0: top + cornerRadius,
            y1: top,
            cx: x + cornerRadius,
            cy: top + cornerRadius
        }, cornerRadius, false);
        path.lineTo(right - cornerRadius, top);
        $2fb96651e8aa1522$var$drawCorner2(path, {
            x0: right - cornerRadius,
            x1: right,
            y0: top,
            y1: top + cornerRadius,
            cx: right - cornerRadius,
            cy: top + cornerRadius
        }, cornerRadius, false);
        path.lineTo(right, y - cornerRadius);
        $2fb96651e8aa1522$var$drawCorner2(path, {
            x0: right,
            x1: right - cornerRadius,
            y0: y - cornerRadius,
            y1: y,
            cx: right - cornerRadius,
            cy: y - cornerRadius
        }, cornerRadius, false);
        path.closePath();
    }
    containsPoint(x, y) {
        return super.containsPoint(x, y) || this.shape.containsPoint(x, y);
    }
};
var { StateMachine: $2fb96651e8aa1522$var$StateMachine4, StateMachineProperty: $2fb96651e8aa1522$var$StateMachineProperty4, Debug: $2fb96651e8aa1522$var$Debug4 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$TextualPointStateMachine = class extends $2fb96651e8aa1522$var$StateMachine4 {
    constructor(ctx){
        const actionCreate = ({ point: point })=>{
            const datum = this.createDatum();
            datum.set({
                x: point.x,
                y: point.y
            });
            ctx.create(datum);
        };
        const actionFirstRender = ()=>{
            this.node?.toggleActive(true);
            ctx.showAnnotationOptions();
            ctx.update();
        };
        const onStartEditing = ()=>{
            ctx.showTextInput();
            if (this.datum) this.datum.visible = false;
        };
        const onStopEditing = ()=>{
            ctx.hideTextInput();
            if (this.datum) this.datum.visible = true;
            ctx.deselect();
        };
        const actionUpdateTextInputBBox = (bbox)=>{
            this.node?.setTextInputBBox(bbox);
            ctx.update();
        };
        const actionColor = ({ colorPickerType: colorPickerType, colorOpacity: colorOpacity, color: color6, opacity: opacity, isMultiColor: isMultiColor })=>{
            if (!this.datum) return;
            if (colorPickerType === "text-color") ctx.updateTextInputColor(color6);
            $2fb96651e8aa1522$var$setColor(this.datum, colorPickerType, colorOpacity, color6, opacity, isMultiColor);
            ctx.update();
        };
        const actionFontSize = (fontSize)=>{
            const { datum: datum, node: node } = this;
            if (!datum || !node || !$2fb96651e8aa1522$var$isTextType(datum)) return;
            datum.fontSize = fontSize;
            ctx.updateTextInputFontSize(fontSize);
            ctx.update();
        };
        const actionCancel = ()=>{
            ctx.delete();
        };
        const actionSave = ({ textInputValue: textInputValue, bbox: bbox })=>{
            if (bbox != null && textInputValue != null && textInputValue.length > 0) {
                const { datum: datum } = this;
                if (!$2fb96651e8aa1522$var$isTextType(datum)) return;
                const wrappedText = $2fb96651e8aa1522$var$wrapText(datum, textInputValue, bbox.width);
                datum?.set({
                    text: wrappedText
                });
                ctx.update();
                ctx.recordAction(`Create ${datum?.type} annotation`);
            } else ctx.delete();
        };
        super("start", {
            start: {
                click: {
                    target: "waiting-first-render",
                    action: actionCreate
                },
                dragStart: {
                    target: "waiting-first-render",
                    action: actionCreate
                },
                cancel: $2fb96651e8aa1522$var$StateMachine4.parent,
                reset: $2fb96651e8aa1522$var$StateMachine4.parent
            },
            "waiting-first-render": {
                render: {
                    target: "edit",
                    action: actionFirstRender
                }
            },
            edit: {
                onEnter: onStartEditing,
                updateTextInputBBox: actionUpdateTextInputBBox,
                color: actionColor,
                fontSize: actionFontSize,
                textInput: [
                    {
                        guard: $2fb96651e8aa1522$var$guardCancelAndExit,
                        target: $2fb96651e8aa1522$var$StateMachine4.parent,
                        action: actionCancel
                    },
                    {
                        guard: $2fb96651e8aa1522$var$guardSaveAndExit,
                        target: $2fb96651e8aa1522$var$StateMachine4.parent,
                        action: actionSave
                    }
                ],
                click: {
                    target: $2fb96651e8aa1522$var$StateMachine4.parent,
                    action: actionSave
                },
                dragStart: {
                    target: $2fb96651e8aa1522$var$StateMachine4.parent,
                    action: actionSave
                },
                resize: {
                    target: $2fb96651e8aa1522$var$StateMachine4.parent,
                    action: actionSave
                },
                onExit: onStopEditing,
                cancel: {
                    target: $2fb96651e8aa1522$var$StateMachine4.parent,
                    action: actionCancel
                }
            }
        });
        this.debug = $2fb96651e8aa1522$var$Debug4.create(true, "annotations");
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty4()
], $2fb96651e8aa1522$var$TextualPointStateMachine.prototype, "datum", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty4()
], $2fb96651e8aa1522$var$TextualPointStateMachine.prototype, "node", 2);
// packages/ag-charts-enterprise/src/features/annotations/comment/commentState.ts
var $2fb96651e8aa1522$var$CommentStateMachine = class extends $2fb96651e8aa1522$var$TextualPointStateMachine {
    createDatum() {
        return new $2fb96651e8aa1522$var$CommentProperties();
    }
};
// packages/ag-charts-enterprise/src/features/annotations/comment/commentConfig.ts
var $2fb96651e8aa1522$var$commentConfig = {
    type: "comment" /* Comment */ ,
    datum: $2fb96651e8aa1522$var$CommentProperties,
    scene: $2fb96651e8aa1522$var$CommentScene,
    isDatum: $2fb96651e8aa1522$var$CommentProperties.is,
    translate: (node, datum, translation, context)=>{
        if ($2fb96651e8aa1522$var$CommentProperties.is(datum) && $2fb96651e8aa1522$var$CommentScene.is(node)) node.translate(datum, translation, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$CommentProperties.is(datum) && $2fb96651e8aa1522$var$CommentProperties.is(copiedDatum) && $2fb96651e8aa1522$var$CommentScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$CommentProperties.is(datum) && $2fb96651e8aa1522$var$CommentScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$CommentStateMachine({
            ...ctx,
            create: createDatum("comment" /* Comment */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
var { calculateLabelTranslation: $2fb96651e8aa1522$var$calculateLabelTranslation, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection6 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$AxisLabelScene = class extends (0, $iTJTu._ModuleSupport).Group {
    constructor(){
        super({
            name: "AnnotationAxisLabelGroup"
        });
        this.label = new (0, $iTJTu._ModuleSupport).Text({
            zIndex: 1
        });
        this.rect = new (0, $iTJTu._ModuleSupport).Rect();
        const { label: label } = this;
        label.fontSize = 12;
        label.fontFamily = "Verdana, sans-serif";
        label.fill = "black";
        label.textBaseline = "middle";
        label.textAlign = "center";
        this.append([
            this.rect,
            this.label
        ]);
    }
    update(opts) {
        this.updateLabel(opts);
        this.updateRect(opts);
        this.updatePosition(opts);
    }
    updateLabel({ value: value, styles: styles, context: context }) {
        const { fontWeight: fontWeight, fontSize: fontSize, fontStyle: fontStyle, fontFamily: fontFamily, textAlign: textAlign, color: color6 = "white", formatter: formatter } = styles;
        const text2 = formatter ? formatter({
            value: value
        }) : context.scaleValueFormatter()(value);
        this.label.setProperties({
            fontWeight: fontWeight,
            fontSize: fontSize,
            fontStyle: fontStyle,
            fontFamily: fontFamily,
            textAlign: textAlign,
            fill: color6,
            text: text2
        });
    }
    updateRect({ styles: styles }) {
        const { rect: rect } = this;
        const { cornerRadius: cornerRadius, fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeOpacity: strokeOpacity } = styles;
        rect.setProperties({
            cornerRadius: cornerRadius,
            fill: fill,
            fillOpacity: fillOpacity,
            stroke: stroke2,
            strokeOpacity: strokeOpacity
        });
    }
    updatePosition({ x: x, y: y, context: context, styles: { padding: padding } }) {
        const { label: label, rect: rect } = this;
        const labelBBox = label.getBBox()?.clone();
        const horizontalPadding = padding ?? 8;
        const verticalPadding = padding ?? 5;
        labelBBox.grow(horizontalPadding, "horizontal");
        labelBBox.grow(verticalPadding, "vertical");
        const shift = context.direction === $2fb96651e8aa1522$var$ChartAxisDirection6.X ? Math.round(verticalPadding / 2) : horizontalPadding;
        const { xTranslation: xTranslation, yTranslation: yTranslation } = $2fb96651e8aa1522$var$calculateLabelTranslation({
            yDirection: true,
            padding: context.labelPadding - shift,
            position: context.position ?? "left",
            bbox: labelBBox
        });
        const translationX = x + xTranslation;
        const translationY = y + yTranslation;
        label.x = translationX;
        label.y = translationY;
        rect.y = translationY - Math.round(labelBBox.height / 2);
        rect.x = translationX - Math.round(labelBBox.width / 2);
        rect.height = labelBBox.height;
        rect.width = labelBBox.width;
    }
};
$2fb96651e8aa1522$var$AxisLabelScene.className = "AxisLabel";
var { Vec2: $2fb96651e8aa1522$var$Vec27 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$CollidableLine = class extends (0, $iTJTu._ModuleSupport).Line {
    constructor(){
        super(...arguments);
        this.growCollisionBox = 9;
        this.clipMask = /* @__PURE__ */ new Map();
    }
    setProperties(styles, pickKeys) {
        super.setProperties(styles, pickKeys);
        this.updateCollisionBBox();
        return this;
    }
    updateCollisionBBox() {
        const { growCollisionBox: growCollisionBox, strokeWidth: strokeWidth, x1: x1, y1: y1, x2: x2, y2: y2 } = this;
        let height = strokeWidth + growCollisionBox;
        if (height % 2 === 0) height += 1;
        const topLeft = $2fb96651e8aa1522$var$Vec27.from(x1, y1 - Math.floor(height / 2));
        const bottomRight = $2fb96651e8aa1522$var$Vec27.from(x2, y2);
        const width = $2fb96651e8aa1522$var$Vec27.distance(topLeft, bottomRight);
        this.collisionBBox = new (0, $iTJTu._ModuleSupport).BBox(topLeft.x, topLeft.y, width, height);
    }
    isPointInPath(pointX, pointY) {
        const { collisionBBox: collisionBBox, x1: x1, y1: y1, x2: x2, y2: y2 } = this;
        if (!collisionBBox) return false;
        const v1 = $2fb96651e8aa1522$var$Vec27.from(x1, y1);
        const v2 = $2fb96651e8aa1522$var$Vec27.from(x2, y2);
        const point = $2fb96651e8aa1522$var$Vec27.sub($2fb96651e8aa1522$var$Vec27.from(pointX, pointY), v1);
        const end = $2fb96651e8aa1522$var$Vec27.sub(v2, v1);
        const rotated = $2fb96651e8aa1522$var$Vec27.rotate(point, $2fb96651e8aa1522$var$Vec27.angle(point, end), v1);
        return collisionBBox.containsPoint(rotated.x, rotated.y) ?? false;
    }
    render(renderCtx) {
        this.applyClipMask(renderCtx.ctx);
        super.render(renderCtx);
        this.closeClipMask(renderCtx.ctx);
    }
    setClipMask(id, mask) {
        const cm = this.clipMask.get(id);
        if ((0, $iTJTu._ModuleSupport).jsonDiff(cm, mask) != null) this.markDirty("CollidableLine");
        if (!mask) this.clipMask.delete(id);
        else this.clipMask.set(id, mask);
    }
    /**
   * Apply a clipping mask to the shape, this must be called before the shape calls `ctx.beginPath()`.
   */ applyClipMask(ctx) {
        const { clipMask: clipMask } = this;
        if (clipMask.size === 0) return;
        this.clipMask.forEach((mask)=>{
            const { x: x, y: y, radius: radius } = mask;
            ctx.save();
            ctx.beginPath();
            ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
            ctx.ellipse(x, y, radius, radius, 0, Math.PI * 2, 0, true);
            ctx.clip();
        });
    }
    closeClipMask(ctx) {
        if (this.clipMask.size === 0) return;
        ctx.restore();
    }
};
var $2fb96651e8aa1522$var$CollidableText = class extends (0, $iTJTu._ModuleSupport).TransformableText {
    constructor(){
        super(...arguments);
        this.growCollisionBox = {
            top: 4,
            right: 4,
            bottom: 4,
            left: 4
        };
    }
    isPointInPath(pointX, pointY) {
        const localPoint = this.fromParentPoint(pointX, pointY);
        const uBBox = this.computeBBoxWithoutTransforms();
        if (!uBBox) return false;
        return uBBox.grow(this.growCollisionBox).containsPoint(localPoint.x, localPoint.y);
    }
};
var { Vec2: $2fb96651e8aa1522$var$Vec28 } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$updateLineText(id, line, coords, textProperties, textNode, text2, lineWidth) {
    if (!text2 || !textNode || !textProperties) {
        line.setClipMask(id);
        return;
    }
    const { alignment: alignment, position: position } = textProperties;
    const numbers = $2fb96651e8aa1522$var$getNumbers(coords, textProperties.fontSize, lineWidth);
    const { point: point, textBaseline: textBaseline } = $2fb96651e8aa1522$var$positionAndAlignment(numbers, position, alignment);
    $2fb96651e8aa1522$var$setProperties(textNode, text2, textProperties, point, numbers.angle, textBaseline);
    const { x: x, y: y, width: width, height: height } = textNode.getBBox();
    const diameter = $2fb96651e8aa1522$var$Vec28.length($2fb96651e8aa1522$var$Vec28.from(width, height));
    const clipMask = {
        x: x + width / 2,
        y: y + height / 2,
        radius: diameter / 2 + $2fb96651e8aa1522$var$Vec28.length(numbers.offset)
    };
    if (position === "center") line.setClipMask(id, clipMask);
    else line.setClipMask(id);
    return {
        clipMask: clipMask,
        numbers: numbers
    };
}
function $2fb96651e8aa1522$var$updateChannelText(offsetInsideTextLabel, top, bottom, textProperties, lineWidth, textNode, text2) {
    if (!text2 || !textNode) return;
    const { alignment: alignment, position: position } = textProperties;
    const [actualTop, actualBottom] = top.y1 <= bottom.y1 ? [
        top,
        bottom
    ] : [
        bottom,
        top
    ];
    let relativeLine = actualTop;
    if (position === "bottom") relativeLine = actualBottom;
    else if (position === "inside") relativeLine = {
        x1: (actualTop.x1 + actualBottom.x1) / 2,
        y1: (actualTop.y1 + actualBottom.y1) / 2,
        x2: (actualTop.x2 + actualBottom.x2) / 2,
        y2: (actualTop.y2 + actualBottom.y2) / 2
    };
    const numbers = $2fb96651e8aa1522$var$getNumbers(relativeLine, textProperties.fontSize, lineWidth);
    const { point: point, textBaseline: textBaseline } = $2fb96651e8aa1522$var$positionAndAlignment(numbers, position === "inside" ? "center" : position, alignment, offsetInsideTextLabel);
    $2fb96651e8aa1522$var$setProperties(textNode, text2, textProperties, point, numbers.angle, textBaseline);
}
function $2fb96651e8aa1522$var$getNumbers(coords, fontSize, strokeWidth) {
    let [left, right] = $2fb96651e8aa1522$var$Vec28.from(coords);
    if (left.x > right.x) [left, right] = [
        right,
        left
    ];
    const normal = $2fb96651e8aa1522$var$Vec28.normalized($2fb96651e8aa1522$var$Vec28.sub(right, left));
    const angle = $2fb96651e8aa1522$var$Vec28.angle(normal);
    const inset = $2fb96651e8aa1522$var$Vec28.multiply(normal, $2fb96651e8aa1522$var$DivariantHandle.HANDLE_SIZE / 2 + (fontSize ?? 14) / 2);
    const offset = $2fb96651e8aa1522$var$Vec28.multiply(normal, (strokeWidth ?? 2) / 2 + (fontSize ?? 14) / 3);
    return {
        left: left,
        right: right,
        normal: normal,
        angle: angle,
        inset: inset,
        offset: offset
    };
}
function $2fb96651e8aa1522$var$positionAndAlignment({ left: left, right: right, normal: normal, angle: angle, inset: inset, offset: offset }, position, alignment, offsetInsideTextLabel) {
    let point;
    if (alignment === "right") point = $2fb96651e8aa1522$var$Vec28.sub(right, inset);
    else if (alignment === "center") point = $2fb96651e8aa1522$var$Vec28.add(left, $2fb96651e8aa1522$var$Vec28.multiply(normal, $2fb96651e8aa1522$var$Vec28.distance(left, right) / 2));
    else point = $2fb96651e8aa1522$var$Vec28.add(left, inset);
    let textBaseline = "bottom";
    if (position === "bottom") {
        point = $2fb96651e8aa1522$var$Vec28.rotate(offset, angle + Math.PI / 2, point);
        textBaseline = "top";
    } else if (position === "center" && !offsetInsideTextLabel) textBaseline = "middle";
    else point = $2fb96651e8aa1522$var$Vec28.rotate(offset, angle - Math.PI / 2, point);
    return {
        point: point,
        textBaseline: textBaseline
    };
}
function $2fb96651e8aa1522$var$setProperties(scene, text2, textProperties, point, angle, textBaseline) {
    scene.setProperties({
        text: text2,
        x: point.x,
        y: point.y,
        rotation: angle,
        rotationCenterX: point.x,
        rotationCenterY: point.y,
        fill: textProperties.color,
        fontFamily: textProperties.fontFamily,
        fontSize: textProperties.fontSize,
        fontStyle: textProperties.fontStyle,
        fontWeight: textProperties.fontWeight,
        textAlign: textProperties.alignment,
        textBaseline: textBaseline
    });
}
// packages/ag-charts-enterprise/src/features/annotations/cross-line/crossLineScene.ts
var { ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection7, Vec2: $2fb96651e8aa1522$var$Vec29, Vec4: $2fb96651e8aa1522$var$Vec44 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$CrossLineScene = class extends $2fb96651e8aa1522$var$AnnotationScene {
    constructor(){
        super();
        this.type = "cross-line";
        this.line = new $2fb96651e8aa1522$var$CollidableLine();
        this.middle = new $2fb96651e8aa1522$var$UnivariantHandle();
        this.isHorizontal = false;
        this.append([
            this.line,
            this.middle
        ]);
    }
    static is(value) {
        return $2fb96651e8aa1522$var$AnnotationScene.isCheck(value, "cross-line");
    }
    update(datum, context) {
        const { seriesRect: seriesRect } = context;
        this.seriesRect = seriesRect;
        this.isHorizontal = $2fb96651e8aa1522$var$HorizontalLineProperties.is(datum);
        const axisContext = this.isHorizontal ? context.yAxis : context.xAxis;
        const coords = this.convertCrossLine(datum, axisContext);
        if (coords == null) {
            this.visible = false;
            return;
        }
        this.visible = datum.visible ?? true;
        if (!this.visible) return;
        this.updateLine(datum, coords);
        this.updateHandle(datum, coords);
        this.updateText(datum, coords);
        this.updateAxisLabel(datum, axisContext, coords);
    }
    updateLine(datum, coords) {
        const { line: line } = this;
        const { lineDashOffset: lineDashOffset, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity } = datum;
        const { x1: x1, y1: y1, x2: x2, y2: y2 } = coords;
        line.setProperties({
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            lineCap: datum.getLineCap(),
            lineDash: datum.getLineDash(),
            lineDashOffset: lineDashOffset,
            stroke: stroke2,
            strokeWidth: strokeWidth,
            strokeOpacity: strokeOpacity,
            fillOpacity: 0
        });
    }
    updateHandle(datum, coords) {
        const { middle: middle } = this;
        const { locked: locked, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity } = datum;
        const handleStyles = {
            fill: datum.handle.fill,
            stroke: datum.handle.stroke ?? stroke2,
            strokeOpacity: datum.handle.strokeOpacity ?? strokeOpacity,
            strokeWidth: datum.handle.strokeWidth ?? strokeWidth
        };
        const handlePosition = $2fb96651e8aa1522$var$Vec29.sub($2fb96651e8aa1522$var$Vec44.center(coords), $2fb96651e8aa1522$var$Vec29.from(middle.handle.width / 2, middle.handle.height / 2));
        middle.gradient = this.isHorizontal ? "horizontal" : "vertical";
        middle.update({
            ...handleStyles,
            ...handlePosition
        });
        middle.toggleLocked(locked ?? false);
    }
    updateText(datum, coords) {
        this.text = this.updateNode($2fb96651e8aa1522$var$CollidableText, this.text, !!datum.text.label);
        $2fb96651e8aa1522$var$updateLineText(this.line.id, this.line, coords, datum.text, this.text, datum.text.label, datum.strokeWidth);
    }
    createAxisLabel(context) {
        const axisLabel2 = new $2fb96651e8aa1522$var$AxisLabelScene();
        context.attachLabel(axisLabel2);
        return axisLabel2;
    }
    updateAxisLabel(datum, axisContext, coords) {
        if (!this.axisLabel) this.axisLabel = this.createAxisLabel(axisContext);
        const { axisLabel: axisLabel2, seriesRect: seriesRect } = this;
        const { direction: direction, position: position } = axisContext;
        if (datum.axisLabel.enabled) {
            axisLabel2.visible = this.visible;
            const labelCorner = position === "left" || position === "top" ? $2fb96651e8aa1522$var$Vec44.start(coords) : $2fb96651e8aa1522$var$Vec44.end(coords);
            const labelPosition = direction === $2fb96651e8aa1522$var$ChartAxisDirection7.X ? labelCorner.x : labelCorner.y;
            if (!axisContext.inRange(labelPosition)) {
                axisLabel2.visible = false;
                return;
            }
            const value = $2fb96651e8aa1522$var$getGroupingValue(datum.value);
            axisLabel2.update({
                ...$2fb96651e8aa1522$var$Vec29.add(labelCorner, $2fb96651e8aa1522$var$Vec29.required(seriesRect)),
                value: value,
                styles: datum.axisLabel,
                context: axisContext
            });
        } else axisLabel2.visible = false;
    }
    setAxisLabelOpacity(opacity) {
        if (!this.axisLabel) return;
        this.axisLabel.opacity = opacity;
    }
    setAxisLabelVisible(visible) {
        if (!this.axisLabel) return;
        this.axisLabel.visible = visible;
    }
    toggleHandles(show) {
        this.middle.visible = show;
        this.middle.toggleHovered(this.activeHandle === "middle");
    }
    destroy() {
        super.destroy();
        this.axisLabel?.destroy();
    }
    toggleActive(active) {
        this.toggleHandles(active);
        this.middle.toggleActive(active);
    }
    dragStart(datum, target, context) {
        const middle = $2fb96651e8aa1522$var$HorizontalLineProperties.is(datum) ? {
            x: target.x,
            y: $2fb96651e8aa1522$var$convert(datum.value, context.yAxis)
        } : {
            x: $2fb96651e8aa1522$var$convert(datum.value, context.xAxis),
            y: target.y
        };
        this.dragState = {
            offset: target,
            middle: middle
        };
    }
    drag(datum, target, context) {
        const { activeHandle: activeHandle, dragState: dragState } = this;
        if (datum.locked || !dragState) return;
        if (activeHandle) this[activeHandle].toggleDragging(true);
        this.translatePoint(datum, dragState.middle, $2fb96651e8aa1522$var$Vec29.sub(target, dragState.offset), context);
    }
    translate(datum, translation, context) {
        if (datum.locked) return;
        const vector = $2fb96651e8aa1522$var$HorizontalLineProperties.is(datum) ? $2fb96651e8aa1522$var$Vec29.from(0, $2fb96651e8aa1522$var$convert(datum.value, context.yAxis)) : $2fb96651e8aa1522$var$Vec29.from($2fb96651e8aa1522$var$convert(datum.value, context.xAxis), 0);
        this.translatePoint(datum, vector, translation, context);
    }
    translatePoint(datum, value, translation, context) {
        const isHorizontal = $2fb96651e8aa1522$var$HorizontalLineProperties.is(datum);
        if (isHorizontal) translation.x = 0;
        else translation.y = 0;
        const { point: point } = $2fb96651e8aa1522$var$translate({
            point: value
        }, translation, context);
        datum.value = isHorizontal ? point.y : point.x;
    }
    stopDragging() {
        this.middle.toggleDragging(false);
    }
    copy(datum, copiedDatum, context) {
        const isHorizontal = $2fb96651e8aa1522$var$HorizontalLineProperties.is(datum);
        const axisContext = this.isHorizontal ? context.yAxis : context.xAxis;
        const coords = this.convertCrossLine(datum, axisContext);
        if (!coords) return;
        const yOffset = isHorizontal ? -30 : 0;
        const xOffset = isHorizontal ? 0 : -30;
        const point = $2fb96651e8aa1522$var$invertCoords({
            x: coords.x1 + xOffset,
            y: coords.y1 + yOffset
        }, context);
        copiedDatum.set({
            value: isHorizontal ? point.y : point.x
        });
        return copiedDatum;
    }
    getCursor() {
        if (this.activeHandle == null) return "pointer";
        return this[this.activeHandle].getCursor();
    }
    containsPoint(x, y) {
        const { middle: middle, line: line, text: text2 } = this;
        this.activeHandle = void 0;
        if (middle.containsPoint(x, y)) {
            this.activeHandle = "middle";
            return true;
        }
        return line.isPointInPath(x, y) || Boolean(text2?.containsPoint(x, y));
    }
    getNodeAtCoords(x, y) {
        if (this.text?.containsPoint(x, y)) return "text";
        if (this.line.isPointInPath(x, y)) return "line";
        if (this.middle.containsPoint(x, y)) return "handle";
    }
    getAnchor() {
        const bbox = this.computeBBoxWithoutHandles();
        if (this.isHorizontal) return {
            x: bbox.x + bbox.width / 2,
            y: bbox.y
        };
        return {
            x: bbox.x + bbox.width,
            y: bbox.y + bbox.height / 2,
            position: "right"
        };
    }
    convertCrossLine(datum, context) {
        if (datum.value == null) return;
        let x1 = 0;
        let y1 = 0;
        let x2, y2;
        const { bounds: bounds } = context;
        const scaledValue = $2fb96651e8aa1522$var$convert(datum.value, context);
        if ($2fb96651e8aa1522$var$HorizontalLineProperties.is(datum)) {
            x2 = bounds.width;
            y1 = scaledValue;
            y2 = scaledValue;
        } else {
            x1 = scaledValue;
            x2 = scaledValue;
            y2 = bounds.height;
        }
        return {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        };
    }
};
var { StateMachine: $2fb96651e8aa1522$var$StateMachine5, StateMachineProperty: $2fb96651e8aa1522$var$StateMachineProperty5, Debug: $2fb96651e8aa1522$var$Debug5 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$CrossLineStateMachine = class extends $2fb96651e8aa1522$var$StateMachine5 {
    constructor(direction, ctx){
        const onClick = ({ point: point })=>{
            const isHorizontal = direction === "horizontal";
            const datum = isHorizontal ? new $2fb96651e8aa1522$var$HorizontalLineProperties() : new $2fb96651e8aa1522$var$VerticalLineProperties();
            datum.set({
                value: isHorizontal ? point.y : point.x
            });
            ctx.create(datum);
            ctx.recordAction(`Create ${isHorizontal ? "horizontal-line" /* HorizontalLine */  : "vertical-line" /* VerticalLine */ } annotation`);
        };
        const actionFirstRender = ()=>{
            this.node?.toggleActive(true);
            ctx.showAnnotationOptions();
            ctx.update();
        };
        super("start", {
            start: {
                click: {
                    target: "waiting-first-render",
                    action: onClick
                },
                drag: {
                    target: "waiting-first-render",
                    action: onClick
                },
                reset: $2fb96651e8aa1522$var$StateMachine5.parent,
                cancel: $2fb96651e8aa1522$var$StateMachine5.parent
            },
            "waiting-first-render": {
                render: {
                    target: $2fb96651e8aa1522$var$StateMachine5.parent,
                    action: actionFirstRender
                }
            }
        });
        this.debug = $2fb96651e8aa1522$var$Debug5.create(true, "annotations");
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty5()
], $2fb96651e8aa1522$var$CrossLineStateMachine.prototype, "node", 2);
// packages/ag-charts-enterprise/src/features/annotations/cross-line/crossLineConfig.ts
var $2fb96651e8aa1522$var$horizontalLineConfig = {
    type: "horizontal-line" /* HorizontalLine */ ,
    datum: $2fb96651e8aa1522$var$HorizontalLineProperties,
    scene: $2fb96651e8aa1522$var$CrossLineScene,
    isDatum: $2fb96651e8aa1522$var$HorizontalLineProperties.is,
    translate: (node, datum, translation, context)=>{
        if ($2fb96651e8aa1522$var$HorizontalLineProperties.is(datum) && $2fb96651e8aa1522$var$CrossLineScene.is(node)) node.translate(datum, translation, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$HorizontalLineProperties.is(datum) && $2fb96651e8aa1522$var$HorizontalLineProperties.is(copiedDatum) && $2fb96651e8aa1522$var$CrossLineScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$HorizontalLineProperties.is(datum) && $2fb96651e8aa1522$var$CrossLineScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$CrossLineStateMachine("horizontal", {
            ...ctx,
            create: createDatum("horizontal-line" /* HorizontalLine */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
var $2fb96651e8aa1522$var$verticalLineConfig = {
    type: "vertical-line" /* VerticalLine */ ,
    datum: $2fb96651e8aa1522$var$VerticalLineProperties,
    scene: $2fb96651e8aa1522$var$CrossLineScene,
    isDatum: $2fb96651e8aa1522$var$VerticalLineProperties.is,
    translate: (node, datum, translation, context)=>{
        if ($2fb96651e8aa1522$var$VerticalLineProperties.is(datum) && $2fb96651e8aa1522$var$CrossLineScene.is(node)) node.translate(datum, translation, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$VerticalLineProperties.is(datum) && $2fb96651e8aa1522$var$VerticalLineProperties.is(copiedDatum) && $2fb96651e8aa1522$var$CrossLineScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$VerticalLineProperties.is(datum) && $2fb96651e8aa1522$var$CrossLineScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$CrossLineStateMachine("vertical", {
            ...ctx,
            create: createDatum("vertical-line" /* VerticalLine */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
var { Vec4: $2fb96651e8aa1522$var$Vec45 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$WithBackgroundScene = class {
    static updateBackground(datum, top, bottom, context) {
        const { background: background } = this;
        const { seriesRect: seriesRect } = context;
        background.path.clear(true);
        const bounds = $2fb96651e8aa1522$var$Vec45.from(0, 0, seriesRect.width, seriesRect.height);
        const points = this.getBackgroundPoints(datum, top, bottom, bounds);
        for(let i = 0; i < points.length; i++){
            const point = points[i];
            if (i === 0) background.path.moveTo(point.x, point.y);
            else background.path.lineTo(point.x, point.y);
        }
        background.path.closePath();
        background.checkPathDirty();
        const backgroundStyles = this.getBackgroundStyles?.(datum) ?? datum.background;
        background.setProperties({
            fill: backgroundStyles.fill,
            fillOpacity: backgroundStyles.fillOpacity
        });
    }
};
// packages/ag-charts-enterprise/src/features/annotations/scenes/channelScene.ts
var $2fb96651e8aa1522$var$ChannelScene = class extends $2fb96651e8aa1522$var$LinearScene {
    constructor(){
        super(...arguments);
        this.handles = {};
        this.overflowContinuous = 2;
        this.topLine = new $2fb96651e8aa1522$var$CollidableLine();
        this.bottomLine = new $2fb96651e8aa1522$var$CollidableLine();
        this.background = new (0, $iTJTu._ModuleSupport).Path({
            zIndex: -1
        });
        this.anchor = {
            x: 0,
            y: 0
        };
        this.updateBackground = $2fb96651e8aa1522$var$WithBackgroundScene.updateBackground.bind(this);
    }
    update(datum, context) {
        const { locked: locked, visible: visible } = datum;
        const top = $2fb96651e8aa1522$var$convertLine(datum, context);
        const bottom = $2fb96651e8aa1522$var$convertLine(datum.bottom, context);
        if (top == null || bottom == null) {
            this.visible = false;
            return;
        } else this.visible = visible ?? true;
        const topLine = this.extendLine(top, datum, context);
        const bottomLine = this.extendLine(bottom, datum, context);
        this.updateLines(datum, topLine, bottomLine, context, top, bottom);
        this.updateHandles(datum, top, bottom);
        this.updateText(datum, top, bottom);
        this.updateBackground(datum, topLine, bottomLine, context);
        this.updateAnchor(top, bottom);
        for (const handle2 of Object.values(this.handles))handle2.toggleLocked(locked ?? false);
    }
    toggleHandles(show) {
        const { handles: handles } = this;
        if (typeof show === "boolean") {
            for (const [handle2, node] of Object.entries(handles)){
                node.visible = show;
                node.toggleHovered(this.activeHandle === handle2);
            }
            return;
        }
        for (const [handle2, visible] of Object.entries(show)){
            const node = handles[handle2];
            node.visible = visible ?? true;
            node.toggleHovered(this.activeHandle === handle2);
        }
    }
    toggleActive(active) {
        this.toggleHandles(active);
        for (const node of Object.values(this.handles))node.toggleActive(active);
    }
    stopDragging() {
        const { activeHandle: activeHandle, handles: handles } = this;
        if (activeHandle == null) return;
        handles[activeHandle].toggleDragging(false);
    }
    getAnchor() {
        return this.anchor;
    }
    getCursor() {
        if (this.activeHandle == null) return "pointer";
        return this.handles[this.activeHandle].getCursor();
    }
    containsPoint(x, y) {
        const { handles: handles, topLine: topLine, bottomLine: bottomLine, text: text2 } = this;
        this.activeHandle = void 0;
        for (const [handle2, child] of Object.entries(handles))if (child.containsPoint(x, y)) {
            this.activeHandle = handle2;
            return true;
        }
        return topLine.containsPoint(x, y) || bottomLine.containsPoint(x, y) || Boolean(text2?.containsPoint(x, y));
    }
    getNodeAtCoords(x, y) {
        if (this.text?.containsPoint(x, y)) return "text";
        if (this.topLine.containsPoint(x, y) || this.bottomLine.containsPoint(x, y)) return "line";
        for (const [_, child] of Object.entries(this.handles)){
            if (child.containsPoint(x, y)) return "handle";
        }
    }
    updateAnchor(top, bottom) {
        const { x: x, y: y } = (0, $iTJTu._ModuleSupport).Transformable.toCanvasPoint(this.topLine, (top.x1 + top.x2) / 2, Math.min(top.y1, top.y2, bottom.y1, bottom.y2));
        this.anchor.x = x;
        this.anchor.y = y;
    }
};
// packages/ag-charts-enterprise/src/features/annotations/disjoint-channel/disjointChannelScene.ts
var { Vec2: $2fb96651e8aa1522$var$Vec210, Vec4: $2fb96651e8aa1522$var$Vec46 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$DisjointChannelScene = class extends $2fb96651e8aa1522$var$ChannelScene {
    constructor(){
        super();
        this.type = "disjoint-channel";
        this.handles = {
            topLeft: new $2fb96651e8aa1522$var$DivariantHandle(),
            topRight: new $2fb96651e8aa1522$var$DivariantHandle(),
            bottomLeft: new $2fb96651e8aa1522$var$DivariantHandle(),
            bottomRight: new $2fb96651e8aa1522$var$UnivariantHandle()
        };
        this.append([
            this.background,
            this.topLine,
            this.bottomLine,
            ...Object.values(this.handles)
        ]);
    }
    static is(value) {
        return $2fb96651e8aa1522$var$AnnotationScene.isCheck(value, "disjoint-channel");
    }
    dragHandle(datum, target, context, snapping) {
        const { activeHandle: activeHandle, handles: handles } = this;
        if (activeHandle == null) return;
        const { offset: offset } = handles[activeHandle].drag(target);
        handles[activeHandle].toggleDragging(true);
        if (activeHandle === "bottomRight") offset.x = 0;
        let translateVectors = [];
        let invertYVectors = [];
        let allowSnapping = snapping;
        switch(activeHandle){
            case "topLeft":
                translateVectors = [
                    "topLeft"
                ];
                invertYVectors = [
                    "bottomLeft"
                ];
                break;
            case "bottomLeft":
                translateVectors = [
                    "bottomLeft"
                ];
                invertYVectors = [
                    "topLeft"
                ];
                break;
            case "topRight":
                translateVectors = [
                    "topRight"
                ];
                invertYVectors = [
                    "bottomRight"
                ];
                break;
            case "bottomRight":
                translateVectors = [
                    "bottomLeft",
                    "bottomRight"
                ];
                allowSnapping = false;
                break;
        }
        const top = $2fb96651e8aa1522$var$convertLine(datum, context);
        const bottom = $2fb96651e8aa1522$var$convertLine(datum.bottom, context);
        if (!top || !bottom) return;
        const vectors = {
            topLeft: $2fb96651e8aa1522$var$Vec46.start(top),
            topRight: $2fb96651e8aa1522$var$Vec46.end(top),
            bottomLeft: $2fb96651e8aa1522$var$Vec46.start(bottom),
            bottomRight: $2fb96651e8aa1522$var$Vec46.end(bottom)
        };
        const snap = {
            vectors: {
                topLeft: vectors.topRight,
                bottomLeft: vectors.bottomRight,
                topRight: vectors.topLeft,
                bottomRight: vectors.bottomLeft
            },
            angle: datum.snapToAngle
        };
        const points = $2fb96651e8aa1522$var$translate(vectors, offset, context, {
            overflowContinuous: this.overflowContinuous,
            translateVectors: translateVectors,
            invertYVectors: invertYVectors,
            snap: allowSnapping ? snap : void 0
        });
        datum.start.x = points.topLeft.x;
        datum.start.y = points.topLeft.y;
        datum.end.x = points.topRight.x;
        datum.end.y = points.topRight.y;
        datum.startHeight = points.topLeft.y - points.bottomLeft.y;
        datum.endHeight = points.topRight.y - points.bottomRight.y;
    }
    getTranslatePointsVectors(start, end) {
        const { bottomLeft: bottomLeft, bottomRight: bottomRight, topLeft: topLeft, topRight: topRight } = this.handles;
        const startHeight = bottomLeft.getBBox().y - topLeft.getBBox().y;
        const endHeight = bottomRight.getBBox().y - topRight.getBBox().y;
        const bottomStart = $2fb96651e8aa1522$var$Vec210.add(start, $2fb96651e8aa1522$var$Vec210.from(0, startHeight));
        const bottomEnd = $2fb96651e8aa1522$var$Vec210.add(end, $2fb96651e8aa1522$var$Vec210.from(0, endHeight));
        return {
            start: start,
            end: end,
            bottomStart: bottomStart,
            bottomEnd: bottomEnd
        };
    }
    updateLines(datum, top, bottom) {
        const { topLine: topLine, bottomLine: bottomLine } = this;
        const { lineDashOffset: lineDashOffset, stroke: stroke2, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth } = datum;
        const lineStyles = {
            lineCap: datum.getLineCap(),
            lineDash: datum.getLineDash(),
            lineDashOffset: lineDashOffset,
            stroke: stroke2,
            strokeOpacity: strokeOpacity,
            strokeWidth: strokeWidth
        };
        topLine.setProperties({
            ...top,
            ...lineStyles
        });
        bottomLine.setProperties({
            ...bottom,
            ...lineStyles
        });
    }
    updateHandles(datum, top, bottom) {
        const { handles: { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } } = this;
        const handleStyles = {
            fill: datum.handle.fill,
            stroke: datum.handle.stroke ?? datum.stroke,
            strokeOpacity: datum.handle.strokeOpacity ?? datum.strokeOpacity,
            strokeWidth: datum.handle.strokeWidth ?? datum.strokeWidth
        };
        topLeft.update({
            ...handleStyles,
            ...$2fb96651e8aa1522$var$Vec46.start(top)
        });
        topRight.update({
            ...handleStyles,
            ...$2fb96651e8aa1522$var$Vec46.end(top)
        });
        bottomLeft.update({
            ...handleStyles,
            ...$2fb96651e8aa1522$var$Vec46.start(bottom)
        });
        bottomRight.update({
            ...handleStyles,
            ...$2fb96651e8aa1522$var$Vec210.sub($2fb96651e8aa1522$var$Vec46.end(bottom), $2fb96651e8aa1522$var$Vec210.from(bottomRight.handle.width / 2, bottomRight.handle.height / 2))
        });
    }
    updateText(datum, top, bottom) {
        this.text = this.updateNode($2fb96651e8aa1522$var$CollidableText, this.text, !!datum.text.label);
        $2fb96651e8aa1522$var$updateChannelText(false, top, bottom, datum.text, datum.strokeWidth, this.text, datum.text.label);
    }
    getBackgroundPoints(datum, top, bottom, bounds) {
        const isFlippedX = top.x1 > top.x2;
        const isFlippedY = top.y1 > top.y2;
        const topY = isFlippedY ? bounds.y2 : bounds.y1;
        const bottomY = isFlippedY ? bounds.y1 : bounds.y2;
        const points = $2fb96651e8aa1522$var$Vec210.from(top);
        if (datum.extendEnd && top.y2 === bottomY) points.push($2fb96651e8aa1522$var$Vec210.from(isFlippedX ? bounds.x1 : bounds.x2, isFlippedY ? bounds.y1 : bounds.y2));
        if (datum.extendEnd && bottom.y2 === topY) points.push($2fb96651e8aa1522$var$Vec210.from(isFlippedX ? bounds.x1 : bounds.x2, isFlippedY ? bounds.y2 : bounds.y1));
        points.push(...$2fb96651e8aa1522$var$Vec210.from(bottom).reverse());
        if (datum.extendStart && bottom.y1 === bottomY) points.push($2fb96651e8aa1522$var$Vec210.from(isFlippedX ? bounds.x2 : bounds.x1, isFlippedY ? bounds.y1 : bounds.y2));
        if (datum.extendStart && top.y1 === topY) points.push($2fb96651e8aa1522$var$Vec210.from(isFlippedX ? bounds.x2 : bounds.x1, isFlippedY ? bounds.y2 : bounds.y1));
        return points;
    }
};
var { StateMachine: $2fb96651e8aa1522$var$StateMachine6, StateMachineProperty: $2fb96651e8aa1522$var$StateMachineProperty6, Debug: $2fb96651e8aa1522$var$Debug6 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$DisjointChannelStateMachine = class extends $2fb96651e8aa1522$var$StateMachine6 {
    constructor(ctx){
        const actionCreate = ({ point: point })=>{
            const datum = new $2fb96651e8aa1522$var$DisjointChannelProperties();
            datum.set({
                start: point,
                end: point,
                startHeight: 0,
                endHeight: 0
            });
            ctx.create(datum);
        };
        const actionFirstRender = ()=>{
            const { node: node } = this;
            node?.toggleActive(true);
            node?.toggleHandles({
                topLeft: true,
                topRight: false,
                bottomLeft: false,
                bottomRight: false
            });
        };
        const actionEndUpdate = ({ offset: offset, context: context })=>{
            const { datum: datum, snapping: snapping } = this;
            if (!datum) return;
            datum.set({
                end: $2fb96651e8aa1522$var$snapPoint(offset, context, snapping, datum.start, datum.snapToAngle)
            });
            ctx.update();
        };
        const actionEndFinish = ()=>{
            this.node?.toggleHandles({
                topRight: true
            });
            ctx.update();
        };
        const actionHeightUpdate = ({ point: point })=>{
            const { datum: datum, node: node } = this;
            const endY = $2fb96651e8aa1522$var$getGroupingValue(datum?.end.y);
            const startY = $2fb96651e8aa1522$var$getGroupingValue(datum?.start.y);
            const { y: pointY } = point;
            if (datum == null || !(0, $idDdm.isNumber)(startY) || !(0, $idDdm.isNumber)(endY) || !(0, $idDdm.isNumber)(pointY)) return;
            const endHeight = endY - (pointY ?? 0);
            const startHeight = (startY - endY) * 2 + endHeight;
            const bottomStart = {
                x: datum?.start.x,
                y: startY - startHeight
            };
            const bottomEnd = {
                x: datum?.end.x,
                y: point.y
            };
            node?.toggleHandles({
                bottomLeft: true,
                bottomRight: true
            });
            if (!ctx.validatePoint(bottomStart, {
                overflowContinuous: true
            }) || !ctx.validatePoint(bottomEnd, {
                overflowContinuous: true
            })) return;
            datum.set({
                startHeight: startHeight,
                endHeight: endHeight
            });
            ctx.update();
        };
        const actionHeightFinish = ({ point: point })=>{
            const { datum: datum, node: node } = this;
            const endY = $2fb96651e8aa1522$var$getGroupingValue(datum?.end.y);
            const startY = $2fb96651e8aa1522$var$getGroupingValue(datum?.start.y);
            const { y: pointY } = point;
            if (datum == null || !(0, $idDdm.isNumber)(startY) || !(0, $idDdm.isNumber)(endY) || !(0, $idDdm.isNumber)(pointY)) return;
            const endHeight = endY - (pointY ?? 0);
            const startHeight = (startY - endY) * 2 + endHeight;
            const bottomStart = {
                x: datum.start.x,
                y: startY - endHeight
            };
            const bottomEnd = {
                x: datum.end.x,
                y: point.y
            };
            node?.toggleHandles(true);
            if (!ctx.validatePoint(bottomStart, {
                overflowContinuous: true
            }) || !ctx.validatePoint(bottomEnd, {
                overflowContinuous: true
            })) return;
            datum.set({
                startHeight: startHeight,
                endHeight: endHeight
            });
            ctx.recordAction(`Create ${"disjoint-channel" /* DisjointChannel */ } annotation`);
            ctx.showAnnotationOptions();
            ctx.update();
        };
        const actionCancel = ()=>ctx.delete();
        super("start", {
            start: {
                click: {
                    target: "waiting-first-render",
                    action: actionCreate
                },
                drag: {
                    target: "waiting-first-render",
                    action: actionCreate
                },
                reset: $2fb96651e8aa1522$var$StateMachine6.parent
            },
            "waiting-first-render": {
                render: {
                    target: "end",
                    action: actionFirstRender
                }
            },
            end: {
                hover: actionEndUpdate,
                drag: actionEndUpdate,
                click: {
                    target: "height",
                    action: actionEndFinish
                },
                dragEnd: {
                    target: "height",
                    action: actionEndFinish
                },
                reset: {
                    target: $2fb96651e8aa1522$var$StateMachine6.parent,
                    action: actionCancel
                },
                cancel: {
                    target: $2fb96651e8aa1522$var$StateMachine6.parent,
                    action: actionCancel
                }
            },
            height: {
                hover: actionHeightUpdate,
                click: {
                    target: $2fb96651e8aa1522$var$StateMachine6.parent,
                    action: actionHeightFinish
                },
                drag: {
                    target: $2fb96651e8aa1522$var$StateMachine6.parent,
                    action: actionHeightFinish
                },
                reset: {
                    target: $2fb96651e8aa1522$var$StateMachine6.parent,
                    action: actionCancel
                },
                cancel: {
                    target: $2fb96651e8aa1522$var$StateMachine6.parent,
                    action: actionCancel
                }
            }
        });
        this.debug = $2fb96651e8aa1522$var$Debug6.create(true, "annotations");
        this.snapping = false;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty6()
], $2fb96651e8aa1522$var$DisjointChannelStateMachine.prototype, "datum", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty6()
], $2fb96651e8aa1522$var$DisjointChannelStateMachine.prototype, "node", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty6()
], $2fb96651e8aa1522$var$DisjointChannelStateMachine.prototype, "snapping", 2);
// packages/ag-charts-enterprise/src/features/annotations/disjoint-channel/disjointChannelConfig.ts
var $2fb96651e8aa1522$var$disjointChannelConfig = {
    type: "disjoint-channel" /* DisjointChannel */ ,
    datum: $2fb96651e8aa1522$var$DisjointChannelProperties,
    scene: $2fb96651e8aa1522$var$DisjointChannelScene,
    isDatum: $2fb96651e8aa1522$var$DisjointChannelProperties.is,
    translate: (node, datum, transition, context)=>{
        if ($2fb96651e8aa1522$var$DisjointChannelProperties.is(datum) && $2fb96651e8aa1522$var$DisjointChannelScene.is(node)) node.translate(datum, transition, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$DisjointChannelProperties.is(datum) && $2fb96651e8aa1522$var$DisjointChannelProperties.is(copiedDatum) && $2fb96651e8aa1522$var$DisjointChannelScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$DisjointChannelProperties.is(datum) && $2fb96651e8aa1522$var$DisjointChannelScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$DisjointChannelStateMachine({
            ...ctx,
            create: createDatum("disjoint-channel" /* DisjointChannel */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
// packages/ag-charts-enterprise/src/features/annotations/utils/fibonacci.ts
var $2fb96651e8aa1522$var$FIBONACCI_RETRACEMENT_RATIOS = [
    0,
    23.6,
    38.2,
    50,
    61.8,
    78.6,
    100
];
var $2fb96651e8aa1522$var$FIBONACCI_EXTENSION_RATIOS = [
    161.8,
    261.8,
    361.8,
    423.6
];
var $2fb96651e8aa1522$var$FIBONACCI_RATIOS = [
    ...$2fb96651e8aa1522$var$FIBONACCI_RETRACEMENT_RATIOS,
    ...$2fb96651e8aa1522$var$FIBONACCI_EXTENSION_RATIOS
];
var $2fb96651e8aa1522$var$FIBONACCI_RATIOS_MAP = {
    10: $2fb96651e8aa1522$var$FIBONACCI_RATIOS,
    6: $2fb96651e8aa1522$var$FIBONACCI_RETRACEMENT_RATIOS,
    4: $2fb96651e8aa1522$var$FIBONACCI_RETRACEMENT_RATIOS.filter((r)=>r !== 78.6 && r !== 23.6)
};
var $2fb96651e8aa1522$var$FIBONACCI_RANGE_LABEL_PADDING = 10;
function $2fb96651e8aa1522$var$getFibonacciCoords(coords1, coords2) {
    const { x2: x2, y1: y1, y2: y2 } = coords1;
    const trendLineVerticalDistance = y1 - y2;
    if (coords2 == null) return {
        x1: x2,
        x2: x2,
        y1: y2 - trendLineVerticalDistance,
        y2: y2
    };
    return {
        x1: coords2.x1,
        x2: coords2.x2,
        y1: coords2.y2 - trendLineVerticalDistance,
        y2: coords2.y2
    };
}
function $2fb96651e8aa1522$var$createFibonacciRangesData({ x1: x1, y1: y1, x2: x2, y2: y2 }, context, reverse, yZero, bands = 10) {
    const verticalDistance = y1 - y2;
    const direction = reverse ? -1 : 1;
    let startY = yZero;
    const data = [];
    $2fb96651e8aa1522$var$FIBONACCI_RATIOS_MAP[bands].forEach((ratio3, index)=>{
        const endY = yZero + verticalDistance * (ratio3 / 100) * direction;
        const yDatumVal = context.yAxis.scaleInvert(endY);
        data.push({
            id: index,
            x1: x1,
            x2: x2,
            y1: startY,
            y2: endY,
            tag: ratio3 == 100 ? 0 /* OneLine */  : 1 /* HorizontalLine */ ,
            label: {
                x1: Math.min(x1, x2) - $2fb96651e8aa1522$var$FIBONACCI_RANGE_LABEL_PADDING,
                x2: x2,
                y1: endY,
                y2: endY,
                text: `${(ratio3 / 100).toFixed(3)} (${yDatumVal.toFixed(2)})`
            }
        });
        startY = endY;
    });
    return data;
}
// packages/ag-charts-enterprise/src/features/annotations/scenes/fibonacciScene.ts
var { Vec2: $2fb96651e8aa1522$var$Vec211, Vec4: $2fb96651e8aa1522$var$Vec47 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$FibonacciScene = class extends $2fb96651e8aa1522$var$AnnotationScene {
    constructor(){
        super();
        this.trendLine = new $2fb96651e8aa1522$var$CollidableLine();
        this.rangeFillsGroup = new (0, $iTJTu._ModuleSupport).Group({
            name: `${this.id}-range-fills`
        });
        this.rangeFillsGroupSelection = (0, $iTJTu._ModuleSupport).Selection.select(this.rangeFillsGroup, (0, $iTJTu._ModuleSupport).Range);
        this.rangeStrokesGroup = new (0, $iTJTu._ModuleSupport).Group({
            name: `${this.id}-range-strokes`
        });
        this.rangeStrokesGroupSelection = (0, $iTJTu._ModuleSupport).Selection.select(this.rangeStrokesGroup, $2fb96651e8aa1522$var$CollidableLine);
        this.labelsGroup = new (0, $iTJTu._ModuleSupport).Group({
            name: `${this.id}-ranges-labels`
        });
        this.labelsGroupSelection = (0, $iTJTu._ModuleSupport).Selection.select(this.labelsGroup, $2fb96651e8aa1522$var$CollidableText);
        this.anchor = {
            x: 0,
            y: 0,
            position: "above"
        };
        this.append([
            this.trendLine,
            this.rangeFillsGroup,
            this.rangeStrokesGroup,
            this.labelsGroup
        ]);
    }
    update(datum, context) {
        let coords = $2fb96651e8aa1522$var$convertLine(datum, context);
        if (coords == null) {
            this.visible = false;
            return;
        }
        coords = $2fb96651e8aa1522$var$Vec47.round(coords);
        this.visible = datum.visible ?? true;
        if (!this.visible) return;
        this.updateLine(datum, coords, this.trendLine);
        this.updateHandles(datum, coords);
        this.updateAnchor(datum, coords, context);
        const { reverse: reverse } = datum;
        const extendedCoords = this.extendLine(coords, datum, context);
        const yZero = reverse ? extendedCoords.y1 : extendedCoords.y2;
        const yOne = reverse ? extendedCoords.y2 : extendedCoords.y1;
        const data = $2fb96651e8aa1522$var$createFibonacciRangesData(extendedCoords, context, datum.reverse, yZero, datum.bands);
        this.updateRanges(datum, data, context);
        const oneLinePoints = {
            ...extendedCoords,
            y1: yOne,
            y2: yOne
        };
        this.updateText(datum, oneLinePoints);
    }
    extendLine({ x1: x1, y1: y1, x2: x2, y2: y2 }, datum, context) {
        const linePoints = {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        };
        if (!datum.extendStart && !datum.extendEnd) return linePoints;
        const { x: x, width: width } = context.xAxis.bounds;
        if (datum.extendEnd) linePoints[x1 > x2 ? "x1" : "x2"] = x + width;
        if (datum.extendStart) linePoints[x1 > x2 ? "x2" : "x1"] = x;
        return linePoints;
    }
    updateLine(datum, coords, line) {
        if (!coords || !line) return;
        const { lineDashOffset: lineDashOffset, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, stroke: stroke2 } = datum;
        line.setProperties({
            ...coords,
            lineCap: datum.getLineCap(),
            lineDash: [
                3,
                4
            ],
            lineDashOffset: lineDashOffset,
            strokeWidth: strokeWidth,
            strokeOpacity: strokeOpacity,
            fillOpacity: 0,
            stroke: stroke2
        });
    }
    updateRangeStrokes(datum) {
        const { lineDashOffset: lineDashOffset, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, strokes: strokes, rangeStroke: rangeStroke, isMultiColor: isMultiColor } = datum;
        this.rangeStrokesGroupSelection.each((line, { x1: x1, x2: x2, y2: y2, tag: tag }, index)=>{
            const y = y2;
            const color6 = isMultiColor ? strokes[index % strokes.length] : rangeStroke;
            line.setProperties({
                x1: x1,
                x2: x2,
                y1: y,
                y2: y,
                stroke: color6,
                strokeOpacity: strokeOpacity,
                strokeWidth: strokeWidth,
                lineCap: datum.getLineCap(),
                lineDash: datum.getLineDash(),
                lineDashOffset: lineDashOffset,
                tag: tag
            });
        });
    }
    updateRanges(datum, data, context) {
        const getDatumId = (d)=>d.id;
        this.rangeFillsGroupSelection.update(data, void 0, getDatumId);
        this.rangeStrokesGroupSelection.update(data, void 0, getDatumId);
        this.labelsGroupSelection.update(data, void 0, getDatumId);
        this.updateRangeFills(datum);
        this.updateRangeStrokes(datum);
        this.updateRangeLabels(datum, context);
    }
    updateRangeFills(datum) {
        const { lineDashOffset: lineDashOffset, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, strokes: colors, rangeStroke: rangeStroke, showFill: showFill, isMultiColor: isMultiColor } = datum;
        this.rangeFillsGroupSelection.each((range2, { x1: x1, x2: x2, y1: y1, y2: y2 }, index)=>{
            const color6 = isMultiColor ? colors[index % colors.length] : rangeStroke;
            if (!showFill) {
                range2.visible = false;
                return;
            }
            range2.setProperties({
                x1: x1,
                x2: x2,
                y1: y1,
                y2: y2,
                startLine: false,
                endLine: false,
                stroke: color6,
                strokeOpacity: strokeOpacity,
                fill: color6,
                fillOpacity: (strokeOpacity ?? 1) * 0.15,
                strokeWidth: strokeWidth,
                lineCap: datum.getLineCap(),
                lineDash: datum.getLineDash(),
                lineDashOffset: lineDashOffset,
                visible: true
            });
        });
    }
    updateRangeLabels(trendLineProperties, { xAxis: xAxis }) {
        const { rangeStrokesGroupSelection: rangeStrokesGroupSelection } = this;
        const { strokes: colors, strokeWidth: strokeWidth, rangeStroke: rangeStroke, isMultiColor: isMultiColor, label: { fontFamily: fontFamily, fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight, color: color6 } } = trendLineProperties;
        const labelProperties = {
            fontFamily: fontFamily,
            fontSize: fontSize,
            fontStyle: fontStyle,
            fontWeight: fontWeight
        };
        const withinBounds = this.checkWithinBounds(xAxis, labelProperties, this.labelsGroupSelection.at(0));
        this.labelsGroupSelection.each((textNode, datum, index)=>{
            const textColor = color6 ?? (isMultiColor ? colors[index % colors.length] : rangeStroke);
            const line = rangeStrokesGroupSelection.at(index);
            if (!line) return;
            const { text: text2, ...coords } = datum.label;
            if (withinBounds) {
                textNode.setProperties({
                    ...labelProperties,
                    text: text2,
                    x: coords.x1,
                    y: coords.y1,
                    textBaseline: "middle",
                    textAlign: "end",
                    fill: textColor
                });
                $2fb96651e8aa1522$var$updateLineText(textNode.id, line, coords);
            } else {
                const textProperties = {
                    ...labelProperties,
                    label: text2,
                    position: "center",
                    alignment: "left",
                    color: textColor
                };
                $2fb96651e8aa1522$var$updateLineText(textNode.id, line, coords, textProperties, textNode, text2, strokeWidth);
            }
        });
    }
    checkWithinBounds(xAxis, fontOptions, textNode) {
        if (!textNode) return false;
        const { text: text2, ...coords } = textNode.datum.label;
        textNode.setProperties({
            ...fontOptions,
            text: text2,
            x: coords.x1,
            y: coords.y1,
            textBaseline: "middle",
            textAlign: "end"
        });
        const { x: x } = textNode.getBBox();
        return x >= xAxis.bounds.x && x <= xAxis.bounds.x + xAxis.bounds.width;
    }
    updateText(datum, coords) {
        const oneLine = this.rangeStrokesGroupSelection.selectByTag(0 /* OneLine */ )[0];
        if (!oneLine) return;
        const { text: textProperties, strokeWidth: strokeWidth } = datum;
        this.text = this.updateNode($2fb96651e8aa1522$var$CollidableText, this.text, !!textProperties.label);
        $2fb96651e8aa1522$var$updateLineText(oneLine.id, oneLine, coords, textProperties, this.text, textProperties.label, strokeWidth);
    }
    updateAnchor(_datum, coords, _context, _bbox) {
        const point = $2fb96651e8aa1522$var$Vec47.topCenter(coords);
        $2fb96651e8aa1522$var$Vec211.apply(this.anchor, (0, $iTJTu._ModuleSupport).Transformable.toCanvasPoint(this.trendLine, point.x, point.y));
    }
    containsPoint(x, y) {
        const { trendLine: trendLine, rangeStrokesGroupSelection: rangeStrokesGroupSelection, text: text2 } = this;
        let isInStrokePath = false;
        rangeStrokesGroupSelection.each((line)=>isInStrokePath || (isInStrokePath = line.isPointInPath(x, y)));
        return isInStrokePath || trendLine.isPointInPath(x, y) || Boolean(text2?.containsPoint(x, y));
    }
    getNodeAtCoords(x, y) {
        if (this.text?.containsPoint(x, y)) return "text";
        if (this.trendLine.isPointInPath(x, y)) return "line";
    }
    getHandleStyles(datum) {
        return {
            fill: datum.handle.fill,
            stroke: datum.handle.stroke ?? datum.stroke,
            strokeOpacity: datum.handle.strokeOpacity ?? datum.strokeOpacity,
            strokeWidth: datum.handle.strokeWidth ?? datum.strokeWidth
        };
    }
    drag(datum, target, context, snapping) {
        if (datum.locked) return;
        if (this.activeHandle) this.dragHandle(datum, target, context, snapping);
        else this.dragAll(datum, target, context);
    }
    getAnchor() {
        return this.anchor;
    }
    getCursor() {
        return "pointer";
    }
};
var { ContinuousScale: $2fb96651e8aa1522$var$ContinuousScale3 } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$validateDatumPoint(context, point, options = {
    overflowContinuous: false
}, warningPrefix) {
    if (point.x == null || point.y == null) {
        if (warningPrefix) (0, $idDdm.Logger).warnOnce(`${warningPrefix}requires both an [x] and [y] property, ignoring.`);
        return false;
    }
    const { xAxis: xAxis, yAxis: yAxis } = context;
    const continuousX = options.overflowContinuous && $2fb96651e8aa1522$var$ContinuousScale3.is(xAxis.scale);
    const continuousY = options.overflowContinuous && $2fb96651e8aa1522$var$ContinuousScale3.is(yAxis.scale);
    const validX = continuousX || $2fb96651e8aa1522$var$validateDatumPointDirection(point.x, xAxis);
    const validY = continuousY || $2fb96651e8aa1522$var$validateDatumPointDirection(point.y, yAxis);
    if (validX && validY) return true;
    if (warningPrefix) {
        let text2 = "x & y domains";
        if (validX) text2 = "y domain";
        if (validY) text2 = "x domain";
        const xValue2 = $2fb96651e8aa1522$var$getGroupingValue(point.x);
        const yValue = $2fb96651e8aa1522$var$getGroupingValue(point.y);
        (0, $idDdm.Logger).warnOnce(`${warningPrefix}is outside the ${text2}, ignoring. - x: [${xValue2}], y: ${yValue}]`);
    }
    return false;
}
function $2fb96651e8aa1522$var$validateDatumPointDirection(d, context) {
    const { domain: domain } = context.scale;
    const value = $2fb96651e8aa1522$var$getGroupingValue(d);
    if (domain && value != null && context.continuous) return value >= domain[0] && value <= domain.at(-1);
    return true;
}
// packages/ag-charts-enterprise/src/features/annotations/fibonacci-retracement-trend-based/fibonacciRetracementTrendBasedScene.ts
var { Vec2: $2fb96651e8aa1522$var$Vec212, Vec4: $2fb96651e8aa1522$var$Vec48 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedScene = class extends $2fb96651e8aa1522$var$FibonacciScene {
    constructor(){
        super();
        this.type = "fibonacci-retracement-trend-based";
        this.endRetracementLine = new $2fb96651e8aa1522$var$CollidableLine();
        this.start = new $2fb96651e8aa1522$var$DivariantHandle();
        this.end = new $2fb96651e8aa1522$var$DivariantHandle();
        this.endRetracement = new $2fb96651e8aa1522$var$DivariantHandle();
        this.append([
            this.endRetracementLine,
            this.start,
            this.end,
            this.endRetracement
        ]);
    }
    static is(value) {
        return $2fb96651e8aa1522$var$AnnotationScene.isCheck(value, "fibonacci-retracement-trend-based");
    }
    update(datum, context) {
        let { coords1: coords1, coords2: coords2 } = this.getCoords(datum, context);
        if (coords1 == null || coords2 == null) {
            this.visible = false;
            return;
        }
        coords1 = $2fb96651e8aa1522$var$Vec48.round(coords1);
        coords2 = $2fb96651e8aa1522$var$Vec48.round(coords2);
        this.visible = datum.visible ?? true;
        if (!this.visible) return;
        if (datum.endRetracement.x == void 0 || datum.endRetracement.y == void 0) coords2 = void 0;
        this.updateLine(datum, coords1, this.trendLine);
        this.updateLine(datum, coords2, this.endRetracementLine);
        this.updateHandles(datum, coords1, coords2);
        this.updateAnchor(datum, coords2 ?? coords1, context);
        const { reverse: reverse, bands: bands } = datum;
        const coords = $2fb96651e8aa1522$var$getFibonacciCoords(coords1, coords2);
        const extendedCoords = this.extendLine(coords, datum, context);
        const yZero = extendedCoords.y2;
        const yOne = extendedCoords.y1;
        const data = !coords2 ? [] : $2fb96651e8aa1522$var$createFibonacciRangesData(extendedCoords, context, reverse, yZero, bands);
        this.updateRanges(datum, data, context);
        const oneLinePoints = {
            ...extendedCoords,
            y1: yOne,
            y2: yOne
        };
        this.updateText(datum, oneLinePoints);
    }
    containsPoint(x, y) {
        const { start: start, end: end, endRetracement: endRetracement, endRetracementLine: endRetracementLine } = this;
        this.activeHandle = void 0;
        if (start.containsPoint(x, y)) {
            this.activeHandle = "start";
            return true;
        }
        if (end.containsPoint(x, y)) {
            this.activeHandle = "end";
            return true;
        }
        if (endRetracement.containsPoint(x, y)) {
            this.activeHandle = "endRetracement";
            return true;
        }
        return endRetracementLine.isPointInPath(x, y) || super.containsPoint(x, y);
    }
    getNodeAtCoords(x, y) {
        if (this.start.containsPoint(x, y) || this.end.containsPoint(x, y) || this.endRetracement.containsPoint(x, y)) return "handle";
        if (this.endRetracementLine.isPointInPath(x, y)) return "line";
        return super.getNodeAtCoords(x, y);
    }
    dragStart(datum, target, context) {
        this.dragState = {
            offset: target,
            ...$2fb96651e8aa1522$var$getDragStartState({
                start: datum.start,
                end: datum.end,
                endRetracement: datum.endRetracement
            }, context)
        };
    }
    stopDragging() {
        this.start.toggleDragging(false);
        this.end.toggleDragging(false);
        this.endRetracement.toggleDragging(false);
    }
    dragAll(datum, target, context) {
        const { dragState: dragState } = this;
        if (!dragState) return;
        this.translatePoints({
            datum: datum,
            start: dragState.start,
            end: dragState.end,
            endRetracement: dragState.endRetracement,
            translation: $2fb96651e8aa1522$var$Vec212.sub(target, dragState.offset),
            context: context
        });
    }
    dragHandle(datum, target, context, snapping) {
        const { activeHandle: activeHandle, dragState: dragState } = this;
        if (!activeHandle || !dragState) return;
        this[activeHandle].toggleDragging(true);
        const point = snapping ? this.snapToAngle(datum, target, context) : $2fb96651e8aa1522$var$invertCoords(this[activeHandle].drag(target).point, context);
        if (!point || !$2fb96651e8aa1522$var$validateDatumPoint(context, point)) return;
        datum[activeHandle].x = point.x;
        datum[activeHandle].y = point.y;
    }
    snapToAngle(datum, coords, context) {
        const { activeHandle: activeHandle } = this;
        const handles = [
            "start",
            "end",
            "endRetracement"
        ];
        if (!activeHandle) return;
        const index = (handles.indexOf(activeHandle) + 1) % handles.length;
        const fixedHandle = handles[index];
        this[activeHandle].toggleDragging(true);
        const fixed = $2fb96651e8aa1522$var$convertPoint(datum[fixedHandle], context);
        return $2fb96651e8aa1522$var$invertCoords($2fb96651e8aa1522$var$snapToAngle(coords, fixed, datum.snapToAngle), context);
    }
    translatePoints({ datum: datum, start: start, end: end, endRetracement: endRetracement, translation: translation, context: context }) {
        const points = $2fb96651e8aa1522$var$translate({
            start: start,
            end: end,
            endRetracement: endRetracement
        }, translation, context, {
            overflowContinuous: 2
        });
        datum.start.x = points.start.x;
        datum.end.x = points.end.x;
        datum.endRetracement.x = points.endRetracement.x;
        datum.start.y = points.start.y;
        datum.end.y = points.end.y;
        datum.endRetracement.y = points.endRetracement.y;
    }
    translate(datum, translation, context) {
        this.translatePoints({
            datum: datum,
            start: $2fb96651e8aa1522$var$convertPoint(datum.start, context),
            end: $2fb96651e8aa1522$var$convertPoint(datum.end, context),
            endRetracement: $2fb96651e8aa1522$var$convertPoint(datum.endRetracement, context),
            translation: translation,
            context: context
        });
    }
    copy(datum, copiedDatum, context) {
        const { coords1: coords1, coords2: coords2 } = this.getCoords(datum, context);
        if (!coords1 || !coords2) return;
        const bbox = this.computeBBoxWithoutHandles();
        this.translatePoints({
            datum: copiedDatum,
            start: $2fb96651e8aa1522$var$Vec48.start(coords1),
            end: $2fb96651e8aa1522$var$Vec48.end(coords1),
            endRetracement: $2fb96651e8aa1522$var$Vec48.end(coords2),
            translation: {
                x: -bbox.width / 2,
                y: -bbox.height / 2
            },
            context: context
        });
        return copiedDatum;
    }
    getCoords(datum, context) {
        return {
            coords1: $2fb96651e8aa1522$var$convertLine(datum, context),
            coords2: $2fb96651e8aa1522$var$convertLine({
                start: datum.end,
                end: datum.endRetracement
            }, context)
        };
    }
    toggleHandles(show) {
        if (typeof show === "boolean") {
            this.start.visible = show;
            this.end.visible = show;
            this.endRetracement.visible = show;
        } else for (const [handle2, visible] of (0, $idDdm.entries)(show))this[handle2].visible = visible;
        this.start.toggleHovered(this.activeHandle === "start");
        this.end.toggleHovered(this.activeHandle === "end");
        this.endRetracement.toggleHovered(this.activeHandle === "endRetracement");
    }
    toggleActive(active) {
        this.toggleHandles(active);
        this.start.toggleActive(active);
        this.end.toggleActive(active);
        this.endRetracement.toggleActive(active);
    }
    updateHandles(datum, coords1, coords2, bbox) {
        this.start.update({
            ...this.getHandleStyles(datum),
            ...this.getHandleCoords(datum, coords1, "start")
        });
        this.end.update({
            ...this.getHandleStyles(datum),
            ...this.getHandleCoords(datum, coords1, "end", bbox)
        });
        if (coords2) this.endRetracement.update({
            ...this.getHandleStyles(datum),
            ...this.getHandleCoords(datum, coords2, "endRetracement", bbox)
        });
        this.start.toggleLocked(datum.locked ?? false);
        this.end.toggleLocked(datum.locked ?? false);
        this.endRetracement.toggleLocked(datum.locked ?? false);
    }
    getHandleCoords(_datum, coords, handle2, _bbox) {
        return handle2 === "start" ? $2fb96651e8aa1522$var$Vec48.start(coords) : $2fb96651e8aa1522$var$Vec48.end(coords);
    }
};
var { StateMachine: $2fb96651e8aa1522$var$StateMachine7, StateMachineProperty: $2fb96651e8aa1522$var$StateMachineProperty7, Debug: $2fb96651e8aa1522$var$Debug7 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedStateMachine = class extends $2fb96651e8aa1522$var$StateMachine7 {
    constructor(ctx){
        const actionCreate = ({ point: point })=>{
            const datum = this.createDatum();
            datum.set({
                start: point,
                end: point
            });
            ctx.create(datum);
        };
        const actionFirstRender = ()=>{
            const { node: node } = this;
            node?.toggleActive(true);
            node?.toggleHandles({
                start: true,
                end: false,
                endRetracement: false
            });
        };
        const actionEndUpdate = ({ offset: offset, context: context })=>{
            const { datum: datum, snapping: snapping } = this;
            if (!datum) return;
            datum.set({
                end: $2fb96651e8aa1522$var$snapPoint(offset, context, snapping, datum.start, datum.snapToAngle)
            });
            ctx.update();
        };
        const actionEndFinish = ()=>{
            const { datum: datum } = this;
            if (!datum) return;
            datum.endRetracement.x = datum.end.x;
            datum.endRetracement.y = datum.end.y;
            this.node?.toggleHandles({
                end: true
            });
            ctx.update();
        };
        const actionEndRetracementUpdate = ({ offset: offset, context: context })=>{
            const { datum: datum, snapping: snapping } = this;
            if (!datum) return;
            datum.set({
                endRetracement: $2fb96651e8aa1522$var$snapPoint(offset, context, snapping, datum.end, datum.snapToAngle)
            });
            ctx.update();
        };
        const actionEndRetracementFinish = ()=>{
            this.node?.toggleHandles({
                endRetracement: true
            });
            ctx.update();
        };
        const actionCancel = ()=>ctx.delete();
        const onExitEnd = ()=>{
            ctx.showAnnotationOptions();
            ctx.recordAction(`Create ${this.datum?.type} annotation`);
        };
        super("start", {
            start: {
                click: {
                    target: "waiting-first-render",
                    action: actionCreate
                },
                drag: {
                    target: "waiting-first-render",
                    action: actionCreate
                },
                reset: $2fb96651e8aa1522$var$StateMachine7.parent
            },
            "waiting-first-render": {
                render: {
                    target: "end",
                    action: actionFirstRender
                }
            },
            end: {
                hover: actionEndUpdate,
                click: {
                    target: "endRetracement",
                    action: actionEndFinish
                },
                drag: actionEndUpdate,
                dragEnd: {
                    target: "endRetracement",
                    action: actionEndFinish
                },
                reset: {
                    target: $2fb96651e8aa1522$var$StateMachine7.parent,
                    action: actionCancel
                },
                cancel: {
                    target: $2fb96651e8aa1522$var$StateMachine7.parent,
                    action: actionCancel
                },
                onExit: onExitEnd
            },
            endRetracement: {
                hover: actionEndRetracementUpdate,
                click: {
                    target: $2fb96651e8aa1522$var$StateMachine7.parent,
                    action: actionEndRetracementFinish
                },
                drag: {
                    target: $2fb96651e8aa1522$var$StateMachine7.parent,
                    action: actionEndRetracementFinish
                },
                reset: {
                    target: $2fb96651e8aa1522$var$StateMachine7.parent,
                    action: actionCancel
                },
                cancel: {
                    target: $2fb96651e8aa1522$var$StateMachine7.parent,
                    action: actionCancel
                }
            }
        });
        this.debug = $2fb96651e8aa1522$var$Debug7.create(true, "annotations");
        this.snapping = false;
    }
    createDatum() {
        return new $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedProperties();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty7()
], $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedStateMachine.prototype, "datum", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty7()
], $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedStateMachine.prototype, "node", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty7()
], $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedStateMachine.prototype, "snapping", 2);
// packages/ag-charts-enterprise/src/features/annotations/fibonacci-retracement-trend-based/fibonacciRetracementTrendBasedConfig.ts
var $2fb96651e8aa1522$var$fibonacciRetracementTrendBasedConfig = {
    type: "fibonacci-retracement-trend-based" /* FibonacciRetracementTrendBased */ ,
    datum: $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedProperties,
    scene: $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedScene,
    isDatum: $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedProperties.is,
    translate: (node, datum, transition, context)=>{
        if ($2fb96651e8aa1522$var$FibonacciRetracementTrendBasedProperties.is(datum) && $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedScene.is(node)) node.translate(datum, transition, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$FibonacciRetracementTrendBasedProperties.is(datum) && $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedProperties.is(copiedDatum) && $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$FibonacciRetracementTrendBasedProperties.is(datum) && $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$FibonacciRetracementTrendBasedStateMachine({
            ...ctx,
            create: createDatum("fibonacci-retracement-trend-based" /* FibonacciRetracementTrendBased */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
var { Vec2: $2fb96651e8aa1522$var$Vec213, Vec4: $2fb96651e8aa1522$var$Vec49 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$FibonacciRetracementScene = class extends $2fb96651e8aa1522$var$FibonacciScene {
    constructor(){
        super();
        this.type = "fibonacci-retracement";
        this.start = new $2fb96651e8aa1522$var$DivariantHandle();
        this.end = new $2fb96651e8aa1522$var$DivariantHandle();
        this.append([
            this.start,
            this.end
        ]);
    }
    static is(value) {
        return $2fb96651e8aa1522$var$AnnotationScene.isCheck(value, "fibonacci-retracement");
    }
    containsPoint(x, y) {
        const { start: start, end: end } = this;
        this.activeHandle = void 0;
        if (start.containsPoint(x, y)) {
            this.activeHandle = "start";
            return true;
        }
        if (end.containsPoint(x, y)) {
            this.activeHandle = "end";
            return true;
        }
        return super.containsPoint(x, y);
    }
    getNodeAtCoords(x, y) {
        if (this.start.containsPoint(x, y) || this.end.containsPoint(x, y)) return "handle";
        return super.getNodeAtCoords(x, y);
    }
    dragStart(datum, target, context) {
        this.dragState = {
            offset: target,
            ...$2fb96651e8aa1522$var$getDragStartState({
                start: datum.start,
                end: datum.end
            }, context)
        };
    }
    stopDragging() {
        this.start.toggleDragging(false);
        this.end.toggleDragging(false);
    }
    dragAll(datum, target, context) {
        const { dragState: dragState } = this;
        if (!dragState) return;
        this.translatePoints({
            datum: datum,
            start: dragState.start,
            end: dragState.end,
            translation: $2fb96651e8aa1522$var$Vec213.sub(target, dragState.offset),
            context: context
        });
    }
    dragHandle(datum, target, context, snapping) {
        const { activeHandle: activeHandle, dragState: dragState } = this;
        if (!activeHandle || !dragState) return;
        this[activeHandle].toggleDragging(true);
        const point = snapping ? this.snapToAngle(datum, target, context) : $2fb96651e8aa1522$var$invertCoords(this[activeHandle].drag(target).point, context);
        if (!point || !$2fb96651e8aa1522$var$validateDatumPoint(context, point)) return;
        datum[activeHandle].x = point.x;
        datum[activeHandle].y = point.y;
    }
    snapToAngle(datum, coords, context) {
        const { activeHandle: activeHandle } = this;
        const handles = [
            "start",
            "end"
        ];
        const fixedHandle = handles.find((handle2)=>handle2 !== activeHandle);
        if (!activeHandle || !fixedHandle) return;
        this[activeHandle].toggleDragging(true);
        const fixed = $2fb96651e8aa1522$var$convertPoint(datum[fixedHandle], context);
        return $2fb96651e8aa1522$var$invertCoords($2fb96651e8aa1522$var$snapToAngle(coords, fixed, datum.snapToAngle), context);
    }
    translatePoints({ datum: datum, start: start, end: end, translation: translation, context: context }) {
        const points = $2fb96651e8aa1522$var$translate({
            start: start,
            end: end
        }, translation, context, {
            overflowContinuous: 1
        });
        datum.start.x = points.start.x;
        datum.end.x = points.end.x;
        datum.start.y = points.start.y;
        datum.end.y = points.end.y;
    }
    translate(datum, translation, context) {
        this.translatePoints({
            datum: datum,
            start: $2fb96651e8aa1522$var$convertPoint(datum.start, context),
            end: $2fb96651e8aa1522$var$convertPoint(datum.end, context),
            translation: translation,
            context: context
        });
    }
    copy(datum, copiedDatum, context) {
        const coords = $2fb96651e8aa1522$var$convertLine(datum, context);
        if (!coords) return;
        const bbox = this.computeBBoxWithoutHandles();
        this.translatePoints({
            datum: copiedDatum,
            start: {
                x: coords.x1,
                y: coords.y1
            },
            end: {
                x: coords.x2,
                y: coords.y2
            },
            translation: {
                x: -bbox.width / 2,
                y: -bbox.height / 2
            },
            context: context
        });
        return copiedDatum;
    }
    toggleHandles(show) {
        if (typeof show === "boolean") {
            this.start.visible = show;
            this.end.visible = show;
        } else for (const [handle2, visible] of (0, $idDdm.entries)(show))this[handle2].visible = visible;
        this.start.toggleHovered(this.activeHandle === "start");
        this.end.toggleHovered(this.activeHandle === "end");
    }
    toggleActive(active) {
        this.toggleHandles(active);
        this.start.toggleActive(active);
        this.end.toggleActive(active);
    }
    updateHandles(datum, coords, _coords2, bbox) {
        this.start.update({
            ...this.getHandleStyles(datum),
            ...this.getHandleCoords(datum, coords, "start")
        });
        this.end.update({
            ...this.getHandleStyles(datum),
            ...this.getHandleCoords(datum, coords, "end", bbox)
        });
        this.start.toggleLocked(datum.locked ?? false);
        this.end.toggleLocked(datum.locked ?? false);
    }
    getHandleCoords(_datum, coords, handle2, _bbox) {
        return handle2 === "start" ? $2fb96651e8aa1522$var$Vec49.start(coords) : $2fb96651e8aa1522$var$Vec49.end(coords);
    }
};
var { StateMachine: $2fb96651e8aa1522$var$StateMachine8, StateMachineProperty: $2fb96651e8aa1522$var$StateMachineProperty8, Debug: $2fb96651e8aa1522$var$Debug8 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$LineTypeStateMachine = class extends $2fb96651e8aa1522$var$StateMachine8 {
    constructor(ctx){
        const actionCreate = ({ point: point })=>{
            const datum = this.createDatum();
            datum.set({
                start: point,
                end: point
            });
            ctx.create(datum);
        };
        const actionFirstRender = ()=>{
            const { node: node } = this;
            node?.toggleActive(true);
            node?.toggleHandles({
                start: true,
                end: false
            });
        };
        const actionEndUpdate = ({ offset: offset, context: context })=>{
            const { datum: datum, snapping: snapping } = this;
            if (!datum) return;
            datum.set({
                end: $2fb96651e8aa1522$var$snapPoint(offset, context, snapping, datum.start, datum.snapToAngle)
            });
            ctx.update();
        };
        const actionEndFinish = ()=>{
            this.node?.toggleHandles({
                end: true
            });
            ctx.update();
        };
        const actionCancel = ()=>ctx.delete();
        const onExitEnd = ()=>{
            ctx.showAnnotationOptions();
            ctx.recordAction(`Create ${this.datum?.type} annotation`);
        };
        super("start", {
            start: {
                click: {
                    target: "waiting-first-render",
                    action: actionCreate
                },
                drag: {
                    target: "waiting-first-render",
                    action: actionCreate
                },
                reset: $2fb96651e8aa1522$var$StateMachine8.parent
            },
            "waiting-first-render": {
                render: {
                    target: "end",
                    action: actionFirstRender
                }
            },
            end: {
                hover: actionEndUpdate,
                click: {
                    target: $2fb96651e8aa1522$var$StateMachine8.parent,
                    action: actionEndFinish
                },
                drag: actionEndUpdate,
                dragEnd: {
                    target: $2fb96651e8aa1522$var$StateMachine8.parent,
                    action: actionEndFinish
                },
                reset: {
                    target: $2fb96651e8aa1522$var$StateMachine8.parent,
                    action: actionCancel
                },
                cancel: {
                    target: $2fb96651e8aa1522$var$StateMachine8.parent,
                    action: actionCancel
                },
                onExit: onExitEnd
            }
        });
        this.debug = $2fb96651e8aa1522$var$Debug8.create(true, "annotations");
        this.snapping = false;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty8()
], $2fb96651e8aa1522$var$LineTypeStateMachine.prototype, "datum", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty8()
], $2fb96651e8aa1522$var$LineTypeStateMachine.prototype, "node", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty8()
], $2fb96651e8aa1522$var$LineTypeStateMachine.prototype, "snapping", 2);
var $2fb96651e8aa1522$var$ArrowStateMachine = class extends $2fb96651e8aa1522$var$LineTypeStateMachine {
    createDatum() {
        return new $2fb96651e8aa1522$var$ArrowProperties();
    }
};
var $2fb96651e8aa1522$var$LineStateMachine = class extends $2fb96651e8aa1522$var$LineTypeStateMachine {
    createDatum() {
        return new $2fb96651e8aa1522$var$LineProperties();
    }
};
// packages/ag-charts-enterprise/src/features/annotations/fibonacci-retracement/fibonacciRetracementState.ts
var $2fb96651e8aa1522$var$FibonacciRetracementStateMachine = class extends $2fb96651e8aa1522$var$LineTypeStateMachine {
    createDatum() {
        return new $2fb96651e8aa1522$var$FibonacciRetracementProperties();
    }
};
// packages/ag-charts-enterprise/src/features/annotations/fibonacci-retracement/fibonacciRetracementConfig.ts
var $2fb96651e8aa1522$var$fibonacciRetracementConfig = {
    type: "fibonacci-retracement" /* FibonacciRetracement */ ,
    datum: $2fb96651e8aa1522$var$FibonacciRetracementProperties,
    scene: $2fb96651e8aa1522$var$FibonacciRetracementScene,
    isDatum: $2fb96651e8aa1522$var$FibonacciRetracementProperties.is,
    translate: (node, datum, transition, context)=>{
        if ($2fb96651e8aa1522$var$FibonacciRetracementProperties.is(datum) && $2fb96651e8aa1522$var$FibonacciRetracementScene.is(node)) node.translate(datum, transition, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$FibonacciRetracementProperties.is(datum) && $2fb96651e8aa1522$var$FibonacciRetracementProperties.is(copiedDatum) && $2fb96651e8aa1522$var$FibonacciRetracementScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$FibonacciRetracementProperties.is(datum) && $2fb96651e8aa1522$var$FibonacciRetracementScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$FibonacciRetracementStateMachine({
            ...ctx,
            create: createDatum("fibonacci-retracement" /* FibonacciRetracement */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
var { Vec2: $2fb96651e8aa1522$var$Vec214 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$CapScene = class extends (0, $iTJTu._ModuleSupport).Group {
};
var $2fb96651e8aa1522$var$ArrowCapScene = class extends $2fb96651e8aa1522$var$CapScene {
    constructor(){
        super();
        this.type = "arrow";
        this.path = new (0, $iTJTu._ModuleSupport).Path();
        this.armLength = 6;
        this.append([
            this.path
        ]);
    }
    update(options) {
        const { path: path } = this;
        const { x: x, y: y, angle: angle, ...rest } = options;
        const origin = $2fb96651e8aa1522$var$Vec214.from(x, y);
        const offsetAngle = 3 * Math.PI / 4;
        const armLength = this.armLength + (options.strokeWidth ?? 0) * 2;
        const leftEnd = $2fb96651e8aa1522$var$Vec214.rotate($2fb96651e8aa1522$var$Vec214.from(0, armLength), angle + offsetAngle, origin);
        const rightEnd = $2fb96651e8aa1522$var$Vec214.rotate($2fb96651e8aa1522$var$Vec214.from(armLength, 0), angle - offsetAngle, origin);
        path.setProperties(rest);
        path.fillOpacity = 0;
        path.path.clear();
        path.path.moveTo(leftEnd.x, leftEnd.y);
        path.path.lineTo(origin.x, origin.y);
        path.path.lineTo(rightEnd.x, rightEnd.y);
    }
};
// packages/ag-charts-enterprise/src/features/annotations/line/lineScene.ts
var { Vec2: $2fb96651e8aa1522$var$Vec215, Vec4: $2fb96651e8aa1522$var$Vec410 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$LineScene = class extends $2fb96651e8aa1522$var$StartEndScene {
    constructor(){
        super();
        this.type = "line";
        this.line = new $2fb96651e8aa1522$var$CollidableLine();
        this.append([
            this.line,
            this.start,
            this.end
        ]);
    }
    static is(value) {
        return $2fb96651e8aa1522$var$AnnotationScene.isCheck(value, "line");
    }
    update(datum, context) {
        let coords = $2fb96651e8aa1522$var$convertLine(datum, context);
        if (coords == null) {
            this.visible = false;
            return;
        }
        coords = $2fb96651e8aa1522$var$Vec410.round(coords);
        this.visible = datum.visible ?? true;
        if (!this.visible) return;
        this.updateLine(datum, coords, context);
        this.updateHandles(datum, coords);
        this.updateText(datum, coords);
        this.updateCaps(datum, coords);
        this.updateAnchor(datum, coords, context);
    }
    updateLine(datum, coords, context) {
        const { line: line } = this;
        const { lineDashOffset: lineDashOffset, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity } = datum;
        const linePoints = this.extendLine(coords, datum, context);
        line.setProperties({
            ...linePoints,
            lineCap: datum.getLineCap(),
            lineDash: datum.getLineDash(),
            lineDashOffset: lineDashOffset,
            stroke: stroke2,
            strokeWidth: strokeWidth,
            strokeOpacity: strokeOpacity,
            fillOpacity: 0
        });
    }
    updateText(datum, coords) {
        this.text = this.updateNode($2fb96651e8aa1522$var$CollidableText, this.text, !!datum.text.label);
        $2fb96651e8aa1522$var$updateLineText(this.line.id, this.line, coords, datum.text, this.text, datum.text.label, datum.strokeWidth);
    }
    updateCaps(datum, coords) {
        if (!datum.startCap && this.startCap) {
            this.removeChild(this.startCap);
            this.startCap = void 0;
        }
        if (!datum.endCap && this.endCap) {
            this.removeChild(this.endCap);
            this.endCap = void 0;
        }
        if (!datum.startCap && !datum.endCap) return;
        const { stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity } = datum;
        const [start, end] = $2fb96651e8aa1522$var$Vec215.from(coords);
        const angle = $2fb96651e8aa1522$var$Vec215.angle($2fb96651e8aa1522$var$Vec215.sub(end, start));
        if (datum.startCap) {
            if (this.startCap && this.startCap.type !== datum.startCap) {
                this.removeChild(this.startCap);
                this.startCap = void 0;
            }
            if (this.startCap == null) {
                this.startCap = new $2fb96651e8aa1522$var$ArrowCapScene();
                this.append([
                    this.startCap
                ]);
            }
            this.startCap.update({
                x: start.x,
                y: start.y,
                angle: angle - Math.PI,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                strokeOpacity: strokeOpacity
            });
        }
        if (datum.endCap) {
            if (this.endCap && this.endCap.type !== datum.endCap) {
                this.removeChild(this.endCap);
                this.endCap = void 0;
            }
            if (this.endCap == null) {
                this.endCap = new $2fb96651e8aa1522$var$ArrowCapScene();
                this.append([
                    this.endCap
                ]);
            }
            this.endCap.update({
                x: end.x,
                y: end.y,
                angle: angle,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                strokeOpacity: strokeOpacity
            });
        }
    }
    updateAnchor(_datum, coords, _context, _bbox) {
        const point = $2fb96651e8aa1522$var$Vec410.topCenter(coords);
        $2fb96651e8aa1522$var$Vec215.apply(this.anchor, (0, $iTJTu._ModuleSupport).Transformable.toCanvasPoint(this.line, point.x, point.y));
    }
    containsPoint(x, y) {
        const { line: line, text: text2 } = this;
        return super.containsPoint(x, y) || line.isPointInPath(x, y) || Boolean(text2?.containsPoint(x, y));
    }
    getNodeAtCoords(x, y) {
        if (this.text?.containsPoint(x, y)) return "text";
        if (this.line.isPointInPath(x, y)) return "line";
        return super.getNodeAtCoords(x, y);
    }
    getHandleCoords(_datum, coords, handle2, _bbox) {
        const { startCap: startCap, endCap: endCap } = this;
        let [startPoint, endPoint] = $2fb96651e8aa1522$var$Vec215.from(coords);
        const angle = $2fb96651e8aa1522$var$Vec215.angle($2fb96651e8aa1522$var$Vec215.sub(endPoint, startPoint));
        if (startCap) startPoint = $2fb96651e8aa1522$var$Vec215.rotate($2fb96651e8aa1522$var$Vec215.from(0, -$2fb96651e8aa1522$var$DivariantHandle.HANDLE_SIZE / 2), angle, startPoint);
        if (endCap) endPoint = $2fb96651e8aa1522$var$Vec215.rotate($2fb96651e8aa1522$var$Vec215.from(0, $2fb96651e8aa1522$var$DivariantHandle.HANDLE_SIZE / 2), angle, endPoint);
        return handle2 === "start" ? startPoint : endPoint;
    }
    getHandleStyles(datum) {
        return {
            fill: datum.handle.fill,
            stroke: datum.handle.stroke ?? datum.stroke,
            strokeOpacity: datum.handle.strokeOpacity ?? datum.strokeOpacity,
            strokeWidth: datum.handle.strokeWidth ?? datum.strokeWidth
        };
    }
};
// packages/ag-charts-enterprise/src/features/annotations/line/lineConfig.ts
var $2fb96651e8aa1522$var$lineConfig = {
    type: "line" /* Line */ ,
    datum: $2fb96651e8aa1522$var$LineProperties,
    scene: $2fb96651e8aa1522$var$LineScene,
    isDatum: $2fb96651e8aa1522$var$LineProperties.is,
    translate: (node, datum, transition, context)=>{
        if ($2fb96651e8aa1522$var$LineProperties.is(datum) && $2fb96651e8aa1522$var$LineScene.is(node)) node.translate(datum, transition, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$LineProperties.is(datum) && $2fb96651e8aa1522$var$LineProperties.is(copiedDatum) && $2fb96651e8aa1522$var$LineScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$LineProperties.is(datum) && $2fb96651e8aa1522$var$LineScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$LineStateMachine({
            ...ctx,
            create: createDatum("line" /* Line */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
var $2fb96651e8aa1522$var$arrowConfig = {
    type: "arrow" /* Arrow */ ,
    datum: $2fb96651e8aa1522$var$ArrowProperties,
    scene: $2fb96651e8aa1522$var$LineScene,
    isDatum: $2fb96651e8aa1522$var$ArrowProperties.is,
    translate: (node, datum, transition, context)=>{
        if ($2fb96651e8aa1522$var$ArrowProperties.is(datum) && $2fb96651e8aa1522$var$LineScene.is(node)) node.translate(datum, transition, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$ArrowProperties.is(datum) && $2fb96651e8aa1522$var$ArrowProperties.is(copiedDatum) && $2fb96651e8aa1522$var$LineScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$ArrowProperties.is(datum) && $2fb96651e8aa1522$var$LineScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$ArrowStateMachine({
            ...ctx,
            create: createDatum("arrow" /* Arrow */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
function $2fb96651e8aa1522$var$layoutScenesRow(scenes, startX = 0, gap = 0) {
    let x = startX;
    for (const scene of scenes)if (Array.isArray(scene)) {
        for (const scene_ of scene)$2fb96651e8aa1522$var$layoutSetX(scene_, x);
        x += (0, $iTJTu._ModuleSupport).Group.computeChildrenBBox(scene).width + gap;
    } else {
        $2fb96651e8aa1522$var$layoutSetX(scene, x);
        x += scene.getBBox().width + gap;
    }
}
function $2fb96651e8aa1522$var$layoutScenesColumn(scenes, startY = 0, gap = 0) {
    let y = startY;
    for (const scene of scenes)if (Array.isArray(scene)) {
        for (const scene_ of scene)$2fb96651e8aa1522$var$layoutSetY(scene_, y);
        y += (0, $iTJTu._ModuleSupport).Group.computeChildrenBBox(scene).height + gap;
    } else {
        $2fb96651e8aa1522$var$layoutSetY(scene, y);
        y += scene.getBBox().height + gap;
    }
}
function $2fb96651e8aa1522$var$layoutSetX(scene, x) {
    if ("x1" in scene) {
        scene.x2 = x + (scene.x2 - scene.x1);
        scene.x1 = x;
    } else scene.x = x;
}
function $2fb96651e8aa1522$var$layoutSetY(scene, y) {
    if ("y1" in scene) {
        scene.y2 = y + (scene.y2 - scene.y1);
        scene.y1 = y;
    } else scene.y = y;
}
function $2fb96651e8aa1522$var$layoutAddX(scene, x) {
    if ("x1" in scene) {
        scene.x1 += x;
        scene.x2 += x;
    } else scene.x += x;
}
function $2fb96651e8aa1522$var$layoutAddY(scene, y) {
    if ("y1" in scene) {
        scene.y1 += y;
        scene.y2 += y;
    } else scene.y += y;
}
// packages/ag-charts-enterprise/src/features/annotations/measurer/measurerStatisticsScene.ts
var { Vec4: $2fb96651e8aa1522$var$Vec411 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$MeasurerStatisticsScene = class extends (0, $iTJTu._ModuleSupport).Group {
    constructor(){
        super();
        this.name = "MeasurerStatisticsScene";
        this.background = new (0, $iTJTu._ModuleSupport).Rect();
        this.dateRangeBarsText = new (0, $iTJTu._ModuleSupport).Text();
        this.dateRangeDivider = new (0, $iTJTu._ModuleSupport).Line();
        this.dateRangeValueText = new (0, $iTJTu._ModuleSupport).Text();
        this.priceRangeValueText = new (0, $iTJTu._ModuleSupport).Text();
        this.priceRangeDivider = new (0, $iTJTu._ModuleSupport).Line();
        this.priceRangePercentageText = new (0, $iTJTu._ModuleSupport).Text();
        this.volumeText = new (0, $iTJTu._ModuleSupport).Text();
        this.volumeFormatter = new Intl.NumberFormat("en-US", {
            notation: "compact",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        this.append([
            this.background,
            this.dateRangeBarsText,
            this.dateRangeDivider,
            this.dateRangeValueText,
            this.priceRangeValueText,
            this.priceRangeDivider,
            this.priceRangePercentageText,
            this.volumeText
        ]);
    }
    update(datum, stats, anchor, coords, context, verticalDirection, localeManager) {
        this.verticalDirection = verticalDirection;
        const scenes = this.updateStatistics(datum, stats, anchor, localeManager);
        const bbox = (0, $iTJTu._ModuleSupport).Group.computeChildrenBBox(scenes.flat());
        const padding = 10;
        bbox.grow(padding);
        this.updateBackground(datum, bbox, padding);
        this.reposition(scenes, padding, context);
        this.checkVisibility(datum, context, coords);
    }
    checkVisibility(datum, context, coords) {
        const bounds = $2fb96651e8aa1522$var$Vec411.from(new (0, $iTJTu._ModuleSupport).BBox(0, 0, context.seriesRect.width, context.seriesRect.height));
        if ($2fb96651e8aa1522$var$Vec411.collides(coords, bounds)) this.visible = datum.visible ?? true;
        else this.visible = false;
    }
    updateStatistics(datum, stats, anchor, localeManager) {
        const { dateRangeBarsText: dateRangeBarsText, dateRangeDivider: dateRangeDivider, dateRangeValueText: dateRangeValueText, priceRangeValueText: priceRangeValueText, priceRangeDivider: priceRangeDivider, priceRangePercentageText: priceRangePercentageText, volumeText: volumeText } = this;
        const horizontalGap = 8;
        const verticalGap = 6;
        const dividerLineHeight = datum.statistics.fontSize + 3;
        const dividerLineOffset = -2;
        const textStyles = this.getTextStyles(datum);
        const dividerLineStyles = {
            ...this.getDividerStyles(datum),
            x1: 0,
            y1: 0,
            x2: 0,
            y2: dividerLineHeight
        };
        const dateScenes = [
            dateRangeBarsText,
            dateRangeDivider,
            dateRangeValueText
        ];
        const priceScenes = [
            priceRangeValueText,
            priceRangeDivider,
            priceRangePercentageText
        ];
        const scenes = [];
        if (stats.priceRange) {
            priceRangeValueText.setProperties({
                ...textStyles,
                text: this.formatPriceRangeValue(stats.priceRange.value, localeManager)
            });
            priceRangeDivider.setProperties(dividerLineStyles);
            priceRangePercentageText.setProperties({
                ...textStyles,
                text: this.formatPriceRangePercentage(stats.priceRange.percentage, localeManager)
            });
            $2fb96651e8aa1522$var$layoutScenesRow(priceScenes, anchor.x, horizontalGap);
            scenes.push(priceScenes);
        }
        if (stats.dateRange) {
            dateRangeBarsText.setProperties({
                ...textStyles,
                text: this.formatDateRangeBars(stats.dateRange.bars, localeManager)
            });
            dateRangeDivider.setProperties(dividerLineStyles);
            dateRangeValueText.setProperties({
                ...textStyles,
                text: this.formatDateRangeValue(stats.dateRange.value)
            });
            $2fb96651e8aa1522$var$layoutScenesRow(dateScenes, anchor.x, horizontalGap);
            scenes.push(dateScenes);
        }
        if (stats.volume != null) {
            volumeText.setProperties({
                ...textStyles,
                x: anchor.x,
                text: this.formatVolume(stats.volume, localeManager),
                visible: true
            });
            scenes.push(volumeText);
        } else volumeText.visible = false;
        $2fb96651e8aa1522$var$layoutScenesColumn(scenes, anchor.y, verticalGap);
        priceRangeDivider.y1 += dividerLineOffset;
        priceRangeDivider.y2 += dividerLineOffset;
        dateRangeDivider.y1 += dividerLineOffset;
        dateRangeDivider.y2 += dividerLineOffset;
        return scenes;
    }
    updateBackground(datum, bbox, padding) {
        const styles = this.getBackgroundStyles(datum);
        this.background.setProperties({
            ...styles,
            ...bbox,
            x: bbox.x - bbox.width / 2 + padding,
            y: bbox.y
        });
    }
    reposition(scenes, padding, context) {
        const { width: width, height: height } = context.seriesRect;
        const background = $2fb96651e8aa1522$var$Vec411.from(this.background.getBBox());
        let offsetX = 0;
        if (background.x1 < 0) offsetX = -background.x1;
        if (background.x2 > width) offsetX = width - background.x2;
        const offsetY = Math.min(padding, height - background.y2);
        for (const scene of scenes)if (Array.isArray(scene)) {
            const rowWidth = (0, $iTJTu._ModuleSupport).Group.computeChildrenBBox(scene).width;
            for (const scene_ of scene){
                $2fb96651e8aa1522$var$layoutAddX(scene_, offsetX - rowWidth / 2);
                $2fb96651e8aa1522$var$layoutAddY(scene_, offsetY);
            }
        } else {
            $2fb96651e8aa1522$var$layoutAddX(scene, offsetX - scene.getBBox().width / 2);
            $2fb96651e8aa1522$var$layoutAddY(scene, offsetY);
        }
        this.background.x += offsetX;
        this.background.y += offsetY;
    }
    getTextStyles(datum) {
        return {
            fill: datum.statistics.color,
            fontFamily: datum.statistics.fontFamily,
            fontSize: datum.statistics.fontSize,
            fontStyle: datum.statistics.fontStyle,
            fontWeight: datum.statistics.fontWeight,
            textBaseline: "top"
        };
    }
    getDividerStyles(datum) {
        return {
            stroke: datum.statistics.divider.stroke,
            strokeOpacity: datum.statistics.divider.strokeOpacity,
            strokeWidth: datum.statistics.divider.strokeWidth
        };
    }
    getBackgroundStyles(datum) {
        return {
            fill: datum.statistics.fill,
            stroke: datum.statistics.stroke,
            strokeOpacity: datum.statistics.strokeOpacity,
            strokeWidth: datum.statistics.strokeWidth,
            cornerRadius: 4
        };
    }
    formatDateRangeBars(bars, localeManager) {
        return localeManager?.t("measurerDateRangeBars", {
            value: bars
        }) ?? `${bars}`;
    }
    formatDateRangeValue(time) {
        const range2 = [];
        const sign = time >= 0 ? "" : "-";
        time = Math.abs(time);
        const MINUTE = 60000;
        const HOUR = MINUTE * 60;
        const DAY2 = HOUR * 24;
        const minutes = Math.floor(time / MINUTE);
        const hours = Math.floor(time / HOUR);
        const days = Math.floor(time / DAY2);
        const remainderHours = hours % (DAY2 / HOUR);
        const remainderMinutes = minutes % (HOUR / MINUTE);
        if (days >= 1) range2.push(`${days}d`);
        if (hours >= 1 && (time < DAY2 || remainderHours !== 0)) range2.push(`${remainderHours}h`);
        if (time < HOUR || remainderMinutes !== 0) range2.push(`${remainderMinutes}m`);
        range2[0] = `${sign}${range2[0]}`;
        return range2.join(" ");
    }
    formatPriceRangeValue(value, localeManager) {
        return localeManager?.t("measurerPriceRangeValue", {
            value: Number(value.toFixed(2))
        }) ?? `${value}`;
    }
    formatPriceRangePercentage(percentage, localeManager) {
        return localeManager?.t("measurerPriceRangePercent", {
            value: percentage
        }) ?? `${percentage}`;
    }
    formatVolume(volume, localeManager) {
        const volumeString = isNaN(volume) ? "" : this.volumeFormatter.format(volume);
        return localeManager?.t("measurerVolume", {
            value: volumeString
        }) ?? volumeString;
    }
};
var $2fb96651e8aa1522$var$QuickMeasurerStatisticsScene = class extends $2fb96651e8aa1522$var$MeasurerStatisticsScene {
    getDirectionStyles(datum) {
        return this.verticalDirection === "down" ? datum.down.statistics : datum.up.statistics;
    }
    getTextStyles(datum) {
        const styles = this.getDirectionStyles(datum);
        return {
            ...super.getTextStyles(datum),
            fill: styles.color,
            fontFamily: styles.fontFamily,
            fontSize: styles.fontSize,
            fontStyle: styles.fontStyle,
            fontWeight: styles.fontWeight
        };
    }
    getDividerStyles(datum) {
        const styles = this.getDirectionStyles(datum);
        return {
            stroke: styles.divider.stroke,
            strokeOpacity: styles.divider.strokeOpacity,
            strokeWidth: styles.divider.strokeWidth
        };
    }
    getBackgroundStyles(datum) {
        const styles = this.getDirectionStyles(datum);
        return {
            ...super.getBackgroundStyles(datum),
            fill: styles.fill,
            stroke: styles.stroke,
            strokeOpacity: styles.strokeOpacity,
            strokeWidth: styles.strokeWidth
        };
    }
};
// packages/ag-charts-enterprise/src/features/annotations/measurer/measurerScene.ts
var { Vec2: $2fb96651e8aa1522$var$Vec216, Vec4: $2fb96651e8aa1522$var$Vec412 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$MeasurerScene = class extends $2fb96651e8aa1522$var$StartEndScene {
    constructor(){
        super();
        this.type = "measurer";
        this.horizontalLine = new $2fb96651e8aa1522$var$CollidableLine();
        this.verticalLine = new $2fb96651e8aa1522$var$CollidableLine();
        // These four bounding lines are named after the way they are drawn, e.g. the horizontalStartLine is a horizontal
        // line that is only shown when the measurer has the 'vertical' direction.
        this.horizontalStartLine = new $2fb96651e8aa1522$var$CollidableLine();
        this.horizontalEndLine = new $2fb96651e8aa1522$var$CollidableLine();
        this.verticalStartLine = new $2fb96651e8aa1522$var$CollidableLine();
        this.verticalEndLine = new $2fb96651e8aa1522$var$CollidableLine();
        this.horizontalEndCap = new $2fb96651e8aa1522$var$ArrowCapScene();
        this.verticalEndCap = new $2fb96651e8aa1522$var$ArrowCapScene();
        this.background = new (0, $iTJTu._ModuleSupport).Path({
            zIndex: -1
        });
        this.updateBackground = $2fb96651e8aa1522$var$WithBackgroundScene.updateBackground.bind(this);
        this.statistics = this.createStatisticsScene();
        this.statistics.zIndex = 1;
        this.append([
            this.background,
            this.verticalStartLine,
            this.verticalEndLine,
            this.horizontalStartLine,
            this.horizontalEndLine,
            this.horizontalLine,
            this.verticalLine,
            this.horizontalEndCap,
            this.verticalEndCap,
            this.start,
            this.end,
            this.statistics
        ]);
    }
    static is(value) {
        return $2fb96651e8aa1522$var$AnnotationScene.isCheck(value, "measurer");
    }
    createStatisticsScene() {
        return new $2fb96651e8aa1522$var$MeasurerStatisticsScene();
    }
    update(datum, context) {
        const coords = $2fb96651e8aa1522$var$convertLine(datum, context);
        if (coords == null) {
            this.visible = false;
            return;
        }
        this.visible = datum.visible ?? true;
        if (!this.visible) return;
        const extended = this.extendPerpendicular(coords, datum, context);
        const verticalStart = {
            ...extended,
            y2: extended.y1
        };
        const verticalEnd = {
            ...extended,
            y1: extended.y2
        };
        this.verticalDirection = coords.y1 < coords.y2 ? "down" : "up";
        this.updateVisibilities(datum);
        this.updateLines(datum, coords);
        this.updateHandles(datum, coords);
        this.updateText(datum, coords);
        this.updateCaps(datum, coords);
        this.updateBoundingLines(datum, extended);
        this.updateBackground(datum, verticalStart, verticalEnd, context);
        this.updateStatistics(datum, coords, context);
        this.updateAnchor(datum, coords, context);
    }
    extendPerpendicular(coords, datum, context) {
        const extended = {
            x1: Math.min(coords.x1, coords.x2),
            x2: Math.max(coords.x1, coords.x2),
            y1: Math.min(coords.y1, coords.y2),
            y2: Math.max(coords.y1, coords.y2)
        };
        const [start, end] = $2fb96651e8aa1522$var$Vec216.from(context.yAxis.bounds);
        if ($2fb96651e8aa1522$var$DateRangeProperties.is(datum)) {
            if (datum.extendAbove) extended.y1 = start.y;
            if (datum.extendBelow) extended.y2 = end.y;
        } else if ($2fb96651e8aa1522$var$PriceRangeProperties.is(datum)) {
            if (datum.extendLeft) extended.x1 = start.x;
            if (datum.extendRight) extended.x2 = end.x;
        }
        return extended;
    }
    updateVisibilities(datum) {
        const { horizontalStartLine: horizontalStartLine, horizontalEndLine: horizontalEndLine, horizontalEndCap: horizontalEndCap, verticalStartLine: verticalStartLine, verticalEndLine: verticalEndLine, verticalEndCap: verticalEndCap } = this;
        const { direction: direction } = datum;
        verticalStartLine.visible = direction !== "vertical";
        verticalEndLine.visible = direction !== "vertical";
        horizontalEndCap.visible = direction !== "vertical";
        horizontalStartLine.visible = direction !== "horizontal";
        horizontalEndLine.visible = direction !== "horizontal";
        verticalEndCap.visible = direction !== "horizontal";
    }
    updateLines(datum, coords) {
        const { horizontalLine: horizontalLine, verticalLine: verticalLine } = this;
        const { direction: direction } = datum;
        const { x1: x1, y1: y1, x2: x2, y2: y2 } = coords;
        const center = $2fb96651e8aa1522$var$Vec216.round($2fb96651e8aa1522$var$Vec412.center(coords), 0);
        const lineStyles = this.getLineStyles(datum);
        if (direction !== "vertical") horizontalLine.setProperties({
            ...lineStyles,
            x1: x1,
            x2: x2,
            y1: center.y,
            y2: center.y
        });
        if (direction !== "horizontal") verticalLine.setProperties({
            ...lineStyles,
            x1: center.x,
            x2: center.x,
            y1: y1,
            y2: y2
        });
    }
    updateText(datum, coords) {
        const { direction: direction } = datum;
        const center = $2fb96651e8aa1522$var$Vec216.round($2fb96651e8aa1522$var$Vec412.center(coords), 0);
        let line;
        const textCoords = {
            ...coords
        };
        if (direction === "vertical") {
            line = this.verticalLine;
            textCoords.x1 = center.x;
            textCoords.x2 = center.x;
        } else {
            line = this.horizontalLine;
            textCoords.y1 = center.y;
            textCoords.y2 = center.y;
        }
        this.text = this.updateNode($2fb96651e8aa1522$var$CollidableText, this.text, !!datum.text.label);
        const { id: id } = line;
        const clip = $2fb96651e8aa1522$var$updateLineText(id, line, textCoords, datum.text, this.text, datum.text.label, datum.strokeWidth);
        let verticalClipMask;
        if (direction === "both" && clip && this.text) {
            const textBBox = $2fb96651e8aa1522$var$Vec412.from(this.text.getBBox());
            const { offset: offset } = clip.numbers;
            const crossesVerticalLine = textBBox.x1 <= center.x + offset.x && textBBox.x2 >= center.x - offset.x;
            if (crossesVerticalLine) verticalClipMask = {
                x: center.x,
                y: clip.clipMask.y,
                radius: this.text.getBBox().height / 2 + $2fb96651e8aa1522$var$Vec216.length(offset)
            };
        }
        this.verticalLine.setClipMask(id, verticalClipMask);
    }
    updateCaps(datum, coords) {
        const { horizontalEndCap: horizontalEndCap, verticalEndCap: verticalEndCap } = this;
        const { direction: direction } = datum;
        const { x1: x1, y1: y1, x2: x2, y2: y2 } = coords;
        const center = $2fb96651e8aa1522$var$Vec216.round($2fb96651e8aa1522$var$Vec412.center(coords), 0);
        const { stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity } = this.getLineStyles(datum);
        const capStyles = {
            stroke: stroke2,
            strokeWidth: strokeWidth,
            strokeOpacity: strokeOpacity
        };
        if (direction !== "vertical") {
            const angle = x1 <= x2 ? 0 : Math.PI;
            let x = x2;
            if (direction === "horizontal") x += x1 <= x2 ? -2 : 2;
            horizontalEndCap.update({
                ...capStyles,
                x: x,
                y: center.y,
                angle: angle
            });
        }
        if (direction !== "horizontal") {
            const angle = y1 <= y2 ? Math.PI / 2 : Math.PI / -2;
            let y = y2;
            if (direction === "vertical") y += y1 <= y2 ? -2 : 2;
            verticalEndCap.update({
                ...capStyles,
                x: center.x,
                y: y,
                angle: angle
            });
        }
    }
    updateBoundingLines(datum, extendedCoords) {
        const { verticalStartLine: verticalStartLine, verticalEndLine: verticalEndLine, horizontalStartLine: horizontalStartLine, horizontalEndLine: horizontalEndLine } = this;
        const { direction: direction } = datum;
        const { x1: x1, y1: y1, x2: x2, y2: y2 } = extendedCoords;
        const lineStyles = this.getLineStyles(datum);
        if (direction === "horizontal") {
            verticalStartLine.setProperties({
                ...lineStyles,
                x1: x1,
                y1: y1,
                x2: x1,
                y2: y2
            });
            verticalEndLine.setProperties({
                ...lineStyles,
                x1: x2,
                y1: y1,
                x2: x2,
                y2: y2
            });
        }
        if (direction === "vertical") {
            horizontalStartLine.setProperties({
                ...lineStyles,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y1
            });
            horizontalEndLine.setProperties({
                ...lineStyles,
                x1: x1,
                y1: y2,
                x2: x2,
                y2: y2
            });
        }
    }
    updateStatistics(datum, coords, context) {
        const point = $2fb96651e8aa1522$var$Vec216.add($2fb96651e8aa1522$var$Vec412.bottomCenter(coords), $2fb96651e8aa1522$var$Vec216.from(0, 10));
        const statistics = {
            volume: this.getVolume(datum)
        };
        if (datum.hasPriceRange) statistics.priceRange = {
            percentage: this.getPriceRangePercentage(datum),
            value: this.getPriceRangeValue(datum)
        };
        if (datum.hasDateRange) statistics.dateRange = {
            bars: this.getDateRangeBars(coords, context),
            value: this.getDateRangeValue(datum)
        };
        this.statistics.update(datum, statistics, point, coords, context, this.verticalDirection, datum.localeManager);
    }
    updateAnchor(_datum, coords, _context, _bbox) {
        const point = $2fb96651e8aa1522$var$Vec412.topCenter(coords);
        $2fb96651e8aa1522$var$Vec216.apply(this.anchor, (0, $iTJTu._ModuleSupport).Transformable.toCanvasPoint(this.horizontalLine, point.x, point.y));
    }
    getBackgroundPoints(_datum, verticalStart, verticalEnd, _bounds) {
        const [startStart, startEnd] = $2fb96651e8aa1522$var$Vec216.from(verticalStart);
        const [endStart, endEnd] = $2fb96651e8aa1522$var$Vec216.from(verticalEnd);
        return [
            startStart,
            startEnd,
            endEnd,
            endStart
        ];
    }
    getLineStyles(datum) {
        const { lineDashOffset: lineDashOffset, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity } = datum;
        return {
            lineCap: datum.getLineCap(),
            lineDash: datum.getLineDash(),
            lineDashOffset: lineDashOffset,
            stroke: stroke2,
            strokeWidth: strokeWidth,
            strokeOpacity: strokeOpacity,
            fillOpacity: 0
        };
    }
    getBackgroundStyles(datum) {
        const { background: background } = datum;
        return {
            fill: background.fill,
            fillOpacity: background.fillOpacity
        };
    }
    getHandleStyles(datum) {
        return {
            fill: datum.handle.fill,
            stroke: datum.handle.stroke ?? datum.stroke,
            strokeOpacity: datum.handle.strokeOpacity ?? datum.strokeOpacity,
            strokeWidth: datum.handle.strokeWidth ?? datum.strokeWidth
        };
    }
    containsPoint(x, y) {
        const { horizontalLine: horizontalLine, text: text2, verticalLine: verticalLine, horizontalStartLine: horizontalStartLine, horizontalEndLine: horizontalEndLine, verticalStartLine: verticalStartLine, verticalEndLine: verticalEndLine } = this;
        return super.containsPoint(x, y) || horizontalLine.isPointInPath(x, y) || verticalLine.isPointInPath(x, y) || horizontalStartLine.visible && horizontalStartLine.isPointInPath(x, y) || horizontalEndLine.visible && horizontalEndLine.isPointInPath(x, y) || verticalStartLine.visible && verticalStartLine.isPointInPath(x, y) || verticalEndLine.visible && verticalEndLine.isPointInPath(x, y) || Boolean(text2?.containsPoint(x, y));
    }
    getNodeAtCoords(x, y) {
        if (this.text?.containsPoint(x, y)) return "text";
        if (this.start.containsPoint(x, y) || this.end.containsPoint(x, y)) return "handle";
        return "line";
    }
    getDateRangeBars(coords, context) {
        const { step: step } = context.xAxis.scale;
        const sign = coords.x1 <= coords.x2 ? 1 : -1;
        return step ? Math.round($2fb96651e8aa1522$var$Vec412.width(coords) / step) * sign : 0;
    }
    getDateRangeValue(datum) {
        const start = $2fb96651e8aa1522$var$getGroupingValue(datum.start.x);
        const end = $2fb96651e8aa1522$var$getGroupingValue(datum.end.x);
        if (!(0, $idDdm.isDate)(start) || !(0, $idDdm.isDate)(end)) throw new Error("Can not create a date range measurement of non-date x-axis.");
        return end.getTime() - start.getTime();
    }
    getPriceRangePercentage(datum) {
        if (datum.start.y == null || datum.end.y == null) throw new Error("Can not create a price range measurement of a non-numeric y-axis");
        const endY = $2fb96651e8aa1522$var$getGroupingValue(datum.end.y);
        const startY = $2fb96651e8aa1522$var$getGroupingValue(datum.start.y);
        if (!(0, $idDdm.isNumber)(endY) || !(0, $idDdm.isNumber)(startY)) throw new Error("Can not create a price range measurement of a non-numeric y-axis");
        return (endY - startY) / startY;
    }
    getPriceRangeValue(datum) {
        if (datum.start.y == null || datum.end.y == null) throw new Error("Can not create a price range measurement of a non-numeric y-axis");
        const endY = $2fb96651e8aa1522$var$getGroupingValue(datum.end.y);
        const startY = $2fb96651e8aa1522$var$getGroupingValue(datum.start.y);
        if (!(0, $idDdm.isNumber)(endY) || !(0, $idDdm.isNumber)(startY)) throw new Error("Can not create a price range measurement of a non-numeric y-axis");
        return endY - startY;
    }
    getVolume(datum) {
        return datum.getVolume(datum.start.x, datum.end.x);
    }
};
var $2fb96651e8aa1522$var$QuickMeasurerScene = class extends $2fb96651e8aa1522$var$MeasurerScene {
    constructor(){
        super(...arguments);
        this.type = "quick-measurer";
    }
    static is(value) {
        return $2fb96651e8aa1522$var$AnnotationScene.isCheck(value, "quick-measurer");
    }
    createStatisticsScene() {
        return new $2fb96651e8aa1522$var$QuickMeasurerStatisticsScene();
    }
    getDirectionStyles(datum) {
        return this.verticalDirection === "down" ? datum.down : datum.up;
    }
    getLineStyles(datum) {
        const styles = this.getDirectionStyles(datum);
        return {
            ...super.getLineStyles(datum),
            stroke: styles.stroke,
            strokeWidth: styles.strokeWidth,
            strokeOpacity: styles.strokeOpacity
        };
    }
    getBackgroundStyles(datum) {
        const styles = this.getDirectionStyles(datum);
        return {
            fill: styles.fill,
            fillOpacity: styles.fillOpacity
        };
    }
    getHandleStyles(datum) {
        const styles = this.getDirectionStyles(datum);
        return {
            fill: styles.handle.fill,
            stroke: styles.handle.stroke ?? styles.stroke,
            strokeOpacity: styles.handle.strokeOpacity ?? styles.strokeOpacity,
            strokeWidth: styles.handle.strokeWidth ?? styles.strokeWidth
        };
    }
};
var { StateMachine: $2fb96651e8aa1522$var$StateMachine9, StateMachineProperty: $2fb96651e8aa1522$var$StateMachineProperty9, Debug: $2fb96651e8aa1522$var$Debug9 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$MeasurerTypeStateMachine = class extends $2fb96651e8aa1522$var$StateMachine9 {
    constructor(ctx){
        const actionCreate = ({ point: point })=>{
            const datum = this.createDatum();
            datum.set({
                start: point,
                end: point
            });
            ctx.create(datum);
        };
        const actionEndUpdate = ({ point: point })=>{
            const { datum: datum, node: node } = this;
            datum?.set({
                end: point
            });
            node?.toggleActive(true);
            node?.toggleHandles({
                end: false
            });
            ctx.update();
        };
        const actionEndFinish = ()=>{
            this.node?.toggleHandles({
                end: true
            });
        };
        const actionCancel = ()=>ctx.delete();
        const onExitEnd = ()=>{
            ctx.showAnnotationOptions();
            if ($2fb96651e8aa1522$var$isEphemeralType(this.datum)) return;
            ctx.recordAction(`Create ${this.node?.type} annotation`);
        };
        super("start", {
            start: {
                reset: $2fb96651e8aa1522$var$StateMachine9.parent,
                click: {
                    target: "end",
                    action: actionCreate
                },
                drag: {
                    target: "end",
                    action: actionCreate
                }
            },
            end: {
                hover: actionEndUpdate,
                drag: actionEndUpdate,
                click: {
                    target: $2fb96651e8aa1522$var$StateMachine9.parent,
                    action: actionEndFinish
                },
                dragEnd: {
                    target: $2fb96651e8aa1522$var$StateMachine9.parent,
                    action: actionEndFinish
                },
                reset: {
                    target: $2fb96651e8aa1522$var$StateMachine9.parent,
                    action: actionCancel
                },
                cancel: {
                    target: $2fb96651e8aa1522$var$StateMachine9.parent,
                    action: actionCancel
                },
                onExit: onExitEnd
            }
        });
        this.debug = $2fb96651e8aa1522$var$Debug9.create(true, "annotations");
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty9()
], $2fb96651e8aa1522$var$MeasurerTypeStateMachine.prototype, "datum", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty9()
], $2fb96651e8aa1522$var$MeasurerTypeStateMachine.prototype, "node", 2);
var $2fb96651e8aa1522$var$DateRangeStateMachine = class extends $2fb96651e8aa1522$var$MeasurerTypeStateMachine {
    createDatum() {
        return new $2fb96651e8aa1522$var$DateRangeProperties();
    }
};
var $2fb96651e8aa1522$var$PriceRangeStateMachine = class extends $2fb96651e8aa1522$var$MeasurerTypeStateMachine {
    createDatum() {
        return new $2fb96651e8aa1522$var$PriceRangeProperties();
    }
};
var $2fb96651e8aa1522$var$DatePriceRangeStateMachine = class extends $2fb96651e8aa1522$var$MeasurerTypeStateMachine {
    createDatum() {
        return new $2fb96651e8aa1522$var$DatePriceRangeProperties();
    }
};
var $2fb96651e8aa1522$var$QuickDatePriceRangeStateMachine = class extends $2fb96651e8aa1522$var$MeasurerTypeStateMachine {
    createDatum() {
        return new $2fb96651e8aa1522$var$QuickDatePriceRangeProperties();
    }
};
// packages/ag-charts-enterprise/src/features/annotations/measurer/measurerConfig.ts
var $2fb96651e8aa1522$var$dateRangeConfig = {
    type: "date-range" /* DateRange */ ,
    datum: $2fb96651e8aa1522$var$DateRangeProperties,
    scene: $2fb96651e8aa1522$var$MeasurerScene,
    isDatum: $2fb96651e8aa1522$var$DateRangeProperties.is,
    translate: (node, datum, translation, context)=>{
        if ($2fb96651e8aa1522$var$DateRangeProperties.is(datum) && $2fb96651e8aa1522$var$MeasurerScene.is(node)) node.translate(datum, translation, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$DateRangeProperties.is(datum) && $2fb96651e8aa1522$var$DateRangeProperties.is(copiedDatum) && $2fb96651e8aa1522$var$MeasurerScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$DateRangeProperties.is(datum) && $2fb96651e8aa1522$var$MeasurerScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$DateRangeStateMachine({
            ...ctx,
            create: createDatum("date-range" /* DateRange */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
var $2fb96651e8aa1522$var$priceRangeConfig = {
    type: "price-range" /* PriceRange */ ,
    datum: $2fb96651e8aa1522$var$PriceRangeProperties,
    scene: $2fb96651e8aa1522$var$MeasurerScene,
    isDatum: $2fb96651e8aa1522$var$PriceRangeProperties.is,
    translate: (node, datum, translation, context)=>{
        if ($2fb96651e8aa1522$var$PriceRangeProperties.is(datum) && $2fb96651e8aa1522$var$MeasurerScene.is(node)) node.translate(datum, translation, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$PriceRangeProperties.is(datum) && $2fb96651e8aa1522$var$PriceRangeProperties.is(copiedDatum) && $2fb96651e8aa1522$var$MeasurerScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$PriceRangeProperties.is(datum) && $2fb96651e8aa1522$var$MeasurerScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$PriceRangeStateMachine({
            ...ctx,
            create: createDatum("date-range" /* DateRange */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
var $2fb96651e8aa1522$var$datePriceRangeConfig = {
    type: "date-price-range" /* DatePriceRange */ ,
    datum: $2fb96651e8aa1522$var$DatePriceRangeProperties,
    scene: $2fb96651e8aa1522$var$MeasurerScene,
    isDatum: $2fb96651e8aa1522$var$DatePriceRangeProperties.is,
    translate: (node, datum, translation, context)=>{
        if ($2fb96651e8aa1522$var$DatePriceRangeProperties.is(datum) && $2fb96651e8aa1522$var$MeasurerScene.is(node)) node.translate(datum, translation, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$DatePriceRangeProperties.is(datum) && $2fb96651e8aa1522$var$DatePriceRangeProperties.is(copiedDatum) && $2fb96651e8aa1522$var$MeasurerScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$DatePriceRangeProperties.is(datum) && $2fb96651e8aa1522$var$MeasurerScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$DatePriceRangeStateMachine({
            ...ctx,
            create: createDatum("date-range" /* DateRange */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
var $2fb96651e8aa1522$var$quickDatePriceRangeConfig = {
    type: "quick-date-price-range" /* QuickDatePriceRange */ ,
    datum: $2fb96651e8aa1522$var$QuickDatePriceRangeProperties,
    scene: $2fb96651e8aa1522$var$QuickMeasurerScene,
    isDatum: $2fb96651e8aa1522$var$QuickDatePriceRangeProperties.is,
    translate: (node, datum, translation, context)=>{
        if ($2fb96651e8aa1522$var$QuickDatePriceRangeProperties.is(datum) && $2fb96651e8aa1522$var$QuickMeasurerScene.is(node)) node.translate(datum, translation, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$QuickDatePriceRangeProperties.is(datum) && $2fb96651e8aa1522$var$QuickDatePriceRangeProperties.is(copiedDatum) && $2fb96651e8aa1522$var$QuickMeasurerScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$QuickDatePriceRangeProperties.is(datum) && $2fb96651e8aa1522$var$QuickMeasurerScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$QuickDatePriceRangeStateMachine({
            ...ctx,
            create: createDatum("quick-date-price-range" /* QuickDatePriceRange */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
var { ZIndexMap: $2fb96651e8aa1522$var$ZIndexMap3, TextWrapper: $2fb96651e8aa1522$var$TextWrapper3 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$NoteScene = class extends $2fb96651e8aa1522$var$TextualPointScene {
    constructor(){
        super();
        this.type = "note" /* Note */ ;
        this.shape = new (0, $iTJTu._ModuleSupport).Rect();
        this.iconBackground = new (0, $iTJTu._ModuleSupport).SvgPath("M22 1.83333C22 0.820811 21.1792 0 20.1667 0H1.83333C0.820811 0 0 0.82081 0 1.83333V13.9868C0 14.9994 0.820811 15.8202 1.83333 15.8202L5.88971 15.8202C6.44575 15.8202 6.97175 16.0725 7.31971 16.5062L9.57006 19.3112C10.304 20.2259 11.6962 20.2259 12.4301 19.3112L14.6804 16.5062C15.0284 16.0725 15.5544 15.8202 16.1104 15.8202L20.1667 15.8202C21.1792 15.8202 22 14.9994 22 13.9868V1.83333Z");
        this.iconLines = new (0, $iTJTu._ModuleSupport).SvgPath("M17.1114 5.75C17.1114 6.16421 16.7756 6.5 16.3614 6.5H5.63916C5.22495 6.5 4.88916 6.16421 4.88916 5.75V5.75C4.88916 5.33579 5.22495 5 5.63916 5H16.3614C16.7756 5 17.1114 5.33579 17.1114 5.75V5.75ZM17.1114 9.25C17.1114 9.66421 16.7756 10 16.3614 10H5.63916C5.22495 10 4.88916 9.66421 4.88916 9.25V9.25C4.88916 8.83579 5.22495 8.5 5.63916 8.5H16.3614C16.7756 8.5 17.1114 8.83579 17.1114 9.25V9.25Z");
        this.active = false;
        this.shape.visible = false;
        this.label.visible = false;
        this.iconBackground.fillShadow = new (0, $iTJTu._ModuleSupport).DropShadow();
        this.append([
            this.shape,
            this.label,
            this.iconBackground,
            this.iconLines,
            this.handle
        ]);
    }
    static is(value) {
        return $2fb96651e8aa1522$var$AnnotationScene.isCheck(value, "note" /* Note */ );
    }
    update(datum, context) {
        this.updateIcon(datum, context);
        super.update(datum, context);
    }
    getTextBBox(datum, coords, context) {
        const bbox = super.getTextBBox(datum, coords, context);
        bbox.x -= datum.width / 2;
        bbox.x = (0, $idDdm.clamp)(0, bbox.x, context.seriesRect.width - datum.width);
        const padding = datum.getPadding().top;
        const topY = bbox.y - $2fb96651e8aa1522$var$LABEL_OFFSET - padding * 2;
        const bottomY = bbox.y + $2fb96651e8aa1522$var$DivariantHandle.HANDLE_SIZE + padding * 2;
        if (topY - bbox.height - $2fb96651e8aa1522$var$TOOLBAR_OFFSET < 0) {
            bbox.y = bottomY;
            datum.position = "top";
        } else {
            bbox.y = topY + padding;
            datum.position = "bottom";
        }
        return bbox;
    }
    updateLabel(datum, bbox) {
        const labelVisibility = datum.visible === false ? false : this.label.visible;
        super.updateLabel(datum, bbox);
        this.label.visible = labelVisibility;
        this.label.text = $2fb96651e8aa1522$var$TextWrapper3.wrapText(datum.text, {
            font: {
                fontFamily: datum.fontFamily,
                fontSize: datum.fontSize,
                fontStyle: datum.fontStyle,
                fontWeight: datum.fontWeight
            },
            avoidOrphans: false,
            textAlign: datum.textAlign,
            textBaseline: "hanging",
            textWrap: "always",
            maxWidth: 200
        });
    }
    updateShape(datum, bbox) {
        const { shape: shape } = this;
        shape.fill = datum.background.fill;
        shape.fillOpacity = datum.background.fillOpacity ?? 1;
        shape.stroke = datum.background.stroke;
        shape.strokeOpacity = datum.background.strokeOpacity ?? 1;
        shape.strokeWidth = datum.background.strokeWidth ?? 1;
        shape.cornerRadius = 4;
        const padding = datum.getPadding().top;
        const isPositionTop = datum.position === "top";
        shape.x = bbox.x - padding;
        shape.width = datum.width + padding * 2;
        shape.height = bbox.height + padding * 2;
        shape.y = bbox.y + (isPositionTop ? 0 : -bbox.height) - padding;
    }
    updateIcon(datum, context) {
        const { active: active, iconBackground: iconBackground, iconLines: iconLines } = this;
        const { x: x, y: y } = $2fb96651e8aa1522$var$convertPoint(datum, context);
        iconBackground.x = x - $2fb96651e8aa1522$var$ICON_WIDTH / 2;
        iconBackground.y = y - $2fb96651e8aa1522$var$ICON_HEIGHT;
        iconLines.x = iconBackground.x;
        iconLines.y = iconBackground.y;
        iconBackground.fill = datum.fill;
        iconBackground.fillOpacity = datum.fillOpacity ?? 1;
        iconBackground.stroke = datum.stroke;
        iconBackground.strokeOpacity = datum.strokeOpacity ?? 1;
        iconBackground.strokeWidth = datum.strokeWidth ?? 1;
        iconLines.fill = datum.stroke;
        if (active) iconBackground.fillShadow.color = datum.fill ?? "rgba(0, 0, 0, 0.22)";
        else iconBackground.fillShadow.color = "rgba(0, 0, 0, 0.22)";
    }
    updateAnchor(datum, bbox, context) {
        const padding = datum.getPadding().top;
        const isPositionTop = datum.position === "top";
        const direction = isPositionTop ? 1 : -1;
        return {
            x: bbox.x + context.seriesRect.x + datum.width / 2,
            y: bbox.y + context.seriesRect.y + direction * (bbox.height + padding),
            position: isPositionTop ? "below" : "above"
        };
    }
    getLabelCoords(datum, bbox) {
        const isPositionTop = datum.position === "top";
        const padding = datum.getPadding().top + datum.fontSize * $2fb96651e8aa1522$var$ANNOTATION_TEXT_LINE_HEIGHT / 2;
        return {
            x: bbox.x,
            y: bbox.y + (isPositionTop ? padding / 2 : 0)
        };
    }
    getTextBaseline(datum) {
        return datum.position === "top" ? "middle" : datum.position;
    }
    getHandleCoords(_datum, coords, _bbox) {
        return {
            x: coords.x,
            y: coords.y + $2fb96651e8aa1522$var$DivariantHandle.HANDLE_SIZE / 2 + 4
        };
    }
    getHandleStyles(datum) {
        return {
            fill: datum.handle.fill,
            stroke: datum.handle.stroke ?? datum.fill,
            strokeOpacity: datum.handle.strokeOpacity,
            strokeWidth: datum.handle.strokeWidth
        };
    }
    toggleHovered(hovered) {
        super.toggleHovered(hovered);
        this.label.visible = hovered;
        this.shape.visible = hovered;
        this.zIndex = hovered ? $2fb96651e8aa1522$var$ZIndexMap3.CHART_ANNOTATION_FOCUSED : $2fb96651e8aa1522$var$ZIndexMap3.CHART_ANNOTATION;
    }
    toggleActive(active) {
        super.toggleActive(active);
        this.label.visible = active;
        this.shape.visible = active;
        this.active = active;
    }
    containsPoint(x, y) {
        if (this.shape.visible && this.shape.containsPoint(x, y)) return true;
        if (this.iconBackground.containsPoint(x, y)) return true;
        return super.containsPoint(x, y);
    }
};
// packages/ag-charts-enterprise/src/features/annotations/note/noteState.ts
var $2fb96651e8aa1522$var$NoteStateMachine = class extends $2fb96651e8aa1522$var$TextualPointStateMachine {
    createDatum() {
        return new $2fb96651e8aa1522$var$NoteProperties();
    }
};
// packages/ag-charts-enterprise/src/features/annotations/note/noteConfig.ts
var $2fb96651e8aa1522$var$noteConfig = {
    type: "note" /* Note */ ,
    datum: $2fb96651e8aa1522$var$NoteProperties,
    scene: $2fb96651e8aa1522$var$NoteScene,
    isDatum: $2fb96651e8aa1522$var$NoteProperties.is,
    translate: (node, datum, transition, context)=>{
        if ($2fb96651e8aa1522$var$NoteProperties.is(datum) && $2fb96651e8aa1522$var$NoteScene.is(node)) node.translate(datum, transition, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$NoteProperties.is(datum) && $2fb96651e8aa1522$var$NoteProperties.is(copiedDatum) && $2fb96651e8aa1522$var$NoteScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$NoteProperties.is(datum) && $2fb96651e8aa1522$var$NoteScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$NoteStateMachine({
            ...ctx,
            create: createDatum("note" /* Note */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
var { Vec2: $2fb96651e8aa1522$var$Vec217, Vec4: $2fb96651e8aa1522$var$Vec413 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$ParallelChannelScene = class extends $2fb96651e8aa1522$var$ChannelScene {
    constructor(){
        super();
        this.type = "parallel-channel";
        this.handles = {
            topLeft: new $2fb96651e8aa1522$var$DivariantHandle(),
            topMiddle: new $2fb96651e8aa1522$var$UnivariantHandle(),
            topRight: new $2fb96651e8aa1522$var$DivariantHandle(),
            bottomLeft: new $2fb96651e8aa1522$var$DivariantHandle(),
            bottomMiddle: new $2fb96651e8aa1522$var$UnivariantHandle(),
            bottomRight: new $2fb96651e8aa1522$var$DivariantHandle()
        };
        this.middleLine = new $2fb96651e8aa1522$var$CollidableLine();
        this.append([
            this.background,
            this.topLine,
            this.middleLine,
            this.bottomLine,
            ...Object.values(this.handles)
        ]);
    }
    static is(value) {
        return $2fb96651e8aa1522$var$AnnotationScene.isCheck(value, "parallel-channel");
    }
    dragHandle(datum, target, context, snapping) {
        const { activeHandle: activeHandle, handles: handles } = this;
        if (activeHandle == null) return;
        const { offset: offset } = handles[activeHandle].drag(target);
        handles[activeHandle].toggleDragging(true);
        if (activeHandle === "topMiddle" || activeHandle === "bottomMiddle") offset.x = 0;
        let translateVectors = [];
        let allowSnapping = snapping;
        switch(activeHandle){
            case "topLeft":
            case "bottomLeft":
                translateVectors = [
                    "topLeft",
                    "bottomLeft"
                ];
                break;
            case "topMiddle":
                translateVectors = [
                    "topLeft",
                    "topRight"
                ];
                offset.y -= $2fb96651e8aa1522$var$UnivariantHandle.HANDLE_SIZE / 2;
                allowSnapping = false;
                break;
            case "topRight":
            case "bottomRight":
                translateVectors = [
                    "topRight",
                    "bottomRight"
                ];
                break;
            case "bottomMiddle":
                translateVectors = [
                    "bottomLeft",
                    "bottomRight"
                ];
                offset.y -= $2fb96651e8aa1522$var$UnivariantHandle.HANDLE_SIZE / 2;
                allowSnapping = false;
                break;
        }
        const top = $2fb96651e8aa1522$var$convertLine(datum, context);
        const bottom = $2fb96651e8aa1522$var$convertLine(datum.bottom, context);
        if (!top || !bottom) return;
        const vectors = {
            topLeft: $2fb96651e8aa1522$var$Vec413.start(top),
            topRight: $2fb96651e8aa1522$var$Vec413.end(top),
            bottomLeft: $2fb96651e8aa1522$var$Vec413.start(bottom),
            bottomRight: $2fb96651e8aa1522$var$Vec413.end(bottom)
        };
        const snap = {
            vectors: {
                topLeft: vectors.topRight,
                bottomLeft: vectors.bottomRight,
                topRight: vectors.topLeft,
                bottomRight: vectors.bottomLeft
            },
            angle: datum.snapToAngle
        };
        const points = $2fb96651e8aa1522$var$translate(vectors, offset, context, {
            overflowContinuous: this.overflowContinuous,
            translateVectors: translateVectors,
            snap: allowSnapping ? snap : void 0
        });
        datum.start.x = points.topLeft.x;
        datum.start.y = points.topLeft.y;
        datum.end.x = points.topRight.x;
        datum.end.y = points.topRight.y;
        datum.height = points.topLeft.y - points.bottomLeft.y;
    }
    getTranslatePointsVectors(start, end) {
        const { bottomLeft: bottomLeft, topLeft: topLeft } = this.handles;
        const height = bottomLeft.getBBox().y - topLeft.getBBox().y;
        const bottomStart = $2fb96651e8aa1522$var$Vec217.add(start, $2fb96651e8aa1522$var$Vec217.from(0, height));
        const bottomEnd = $2fb96651e8aa1522$var$Vec217.add(end, $2fb96651e8aa1522$var$Vec217.from(0, height));
        return {
            start: start,
            end: end,
            bottomStart: bottomStart,
            bottomEnd: bottomEnd
        };
    }
    containsPoint(x, y) {
        return super.containsPoint(x, y) || this.middleLine.visible && this.middleLine.strokeWidth > 0 && this.middleLine.containsPoint(x, y);
    }
    getNodeAtCoords(x, y) {
        if (this.middleLine.visible && this.middleLine.strokeWidth > 0 && this.middleLine.containsPoint(x, y)) return "line";
        return super.getNodeAtCoords(x, y);
    }
    updateLines(datum, top, bottom, context, naturalTop, naturalBottom) {
        const { topLine: topLine, middleLine: middleLine, bottomLine: bottomLine } = this;
        const { lineDashOffset: lineDashOffset, stroke: stroke2, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth } = datum;
        const lineDash = datum.getLineDash();
        const lineStyles = {
            lineCap: datum.getLineCap(),
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            stroke: stroke2,
            strokeOpacity: strokeOpacity,
            strokeWidth: strokeWidth
        };
        topLine.setProperties({
            ...top,
            ...lineStyles
        });
        bottomLine.setProperties({
            ...bottom,
            ...lineStyles
        });
        const middlePoints = this.extendLine({
            x1: naturalTop.x1,
            y1: naturalBottom.y1 + (naturalTop.y1 - naturalBottom.y1) / 2,
            x2: naturalTop.x2,
            y2: naturalBottom.y2 + (naturalTop.y2 - naturalBottom.y2) / 2
        }, datum, context);
        middleLine.setProperties({
            ...middlePoints,
            lineDash: datum.middle.lineDash ?? lineDash,
            lineDashOffset: datum.middle.lineDashOffset ?? lineDashOffset,
            stroke: datum.middle.stroke ?? stroke2,
            strokeOpacity: datum.middle.strokeOpacity ?? strokeOpacity,
            strokeWidth: datum.middle.strokeWidth ?? strokeWidth,
            visible: datum.middle.visible ?? true
        });
    }
    updateHandles(datum, top, bottom) {
        const { handles: { topLeft: topLeft, topMiddle: topMiddle, topRight: topRight, bottomLeft: bottomLeft, bottomMiddle: bottomMiddle, bottomRight: bottomRight } } = this;
        const handleStyles = {
            fill: datum.handle.fill,
            stroke: datum.handle.stroke ?? datum.stroke,
            strokeOpacity: datum.handle.strokeOpacity ?? datum.strokeOpacity,
            strokeWidth: datum.handle.strokeWidth ?? datum.strokeWidth
        };
        topLeft.update({
            ...handleStyles,
            ...$2fb96651e8aa1522$var$Vec413.start(top)
        });
        topRight.update({
            ...handleStyles,
            ...$2fb96651e8aa1522$var$Vec413.end(top)
        });
        bottomLeft.update({
            ...handleStyles,
            ...$2fb96651e8aa1522$var$Vec413.start(bottom)
        });
        bottomRight.update({
            ...handleStyles,
            ...$2fb96651e8aa1522$var$Vec413.end(bottom)
        });
        topMiddle.update({
            ...handleStyles,
            ...$2fb96651e8aa1522$var$Vec217.sub($2fb96651e8aa1522$var$Vec413.center(top), $2fb96651e8aa1522$var$Vec217.from(topMiddle.handle.width / 2, topMiddle.handle.height / 2))
        });
        bottomMiddle.update({
            ...handleStyles,
            ...$2fb96651e8aa1522$var$Vec217.sub($2fb96651e8aa1522$var$Vec413.center(bottom), $2fb96651e8aa1522$var$Vec217.from(bottomMiddle.handle.width / 2, bottomMiddle.handle.height / 2))
        });
    }
    updateText(datum, top, bottom) {
        this.text = this.updateNode($2fb96651e8aa1522$var$CollidableText, this.text, !!datum.text.label);
        $2fb96651e8aa1522$var$updateChannelText(true, top, bottom, datum.text, datum.strokeWidth, this.text, datum.text.label);
    }
    getBackgroundPoints(datum, top, bottom, bounds) {
        const isFlippedX = top.x1 > top.x2;
        const isFlippedY = top.y1 > top.y2;
        const outOfBoundsStart = top.x1 !== bottom.x1 && top.y1 !== bottom.y1;
        const outOfBoundsEnd = top.x2 !== bottom.x2 && top.y2 !== bottom.y2;
        const points = $2fb96651e8aa1522$var$Vec217.from(top);
        if (datum.extendEnd && outOfBoundsEnd) points.push($2fb96651e8aa1522$var$Vec217.from(isFlippedX ? bounds.x1 : bounds.x2, isFlippedY ? bounds.y1 : bounds.y2));
        points.push(...$2fb96651e8aa1522$var$Vec217.from(bottom).reverse());
        if (datum.extendStart && outOfBoundsStart) points.push($2fb96651e8aa1522$var$Vec217.from(isFlippedX ? bounds.x2 : bounds.x1, isFlippedY ? bounds.y2 : bounds.y1));
        return points;
    }
};
var { StateMachine: $2fb96651e8aa1522$var$StateMachine10, StateMachineProperty: $2fb96651e8aa1522$var$StateMachineProperty10, Debug: $2fb96651e8aa1522$var$Debug10 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$ParallelChannelStateMachine = class extends $2fb96651e8aa1522$var$StateMachine10 {
    constructor(ctx){
        const actionCreate = ({ point: point })=>{
            const datum = new $2fb96651e8aa1522$var$ParallelChannelProperties();
            datum.set({
                start: point,
                end: point,
                height: 0
            });
            ctx.create(datum);
        };
        const actionFirstRender = ()=>{
            const { node: node } = this;
            node?.toggleActive(true);
            node?.toggleHandles({
                topLeft: true,
                topMiddle: false,
                topRight: false,
                bottomLeft: false,
                bottomMiddle: false,
                bottomRight: false
            });
        };
        const actionEndUpdate = ({ offset: offset, context: context })=>{
            const { datum: datum, snapping: snapping } = this;
            if (!datum) return;
            datum.set({
                end: $2fb96651e8aa1522$var$snapPoint(offset, context, snapping, datum.start, datum.snapToAngle)
            });
            ctx.update();
        };
        const actionEndFinish = ()=>{
            this.node?.toggleHandles({
                topRight: true
            });
            ctx.update();
        };
        const actionHeightUpdate = ({ point: point })=>{
            const { datum: datum, node: node } = this;
            const endY = $2fb96651e8aa1522$var$getGroupingValue(datum?.end.y);
            const startY = $2fb96651e8aa1522$var$getGroupingValue(datum?.start.y);
            const { y: pointY } = point;
            if (datum == null || !(0, $idDdm.isNumber)(startY) || !(0, $idDdm.isNumber)(endY) || !(0, $idDdm.isNumber)(pointY)) return;
            const height = endY - (pointY ?? 0);
            const bottomStartY = startY - height;
            node?.toggleHandles({
                bottomLeft: true,
                bottomRight: true
            });
            if (!ctx.validatePoint({
                x: datum.start.x,
                y: bottomStartY
            }, {
                overflowContinuous: true
            }) || !ctx.validatePoint({
                x: datum.end.x,
                y: point.y
            }, {
                overflowContinuous: true
            })) return;
            datum.set({
                height: height
            });
            ctx.update();
        };
        const actionHeightFinish = ({ point: point })=>{
            const { datum: datum, node: node } = this;
            const endY = $2fb96651e8aa1522$var$getGroupingValue(datum?.end.y);
            const startY = $2fb96651e8aa1522$var$getGroupingValue(datum?.start.y);
            const { y: pointY } = point;
            if (datum == null || !(0, $idDdm.isNumber)(startY) || !(0, $idDdm.isNumber)(endY) || !(0, $idDdm.isNumber)(pointY)) return;
            const height = endY - (pointY ?? 0);
            const bottomStartY = startY - height;
            node?.toggleHandles(true);
            if (!ctx.validatePoint({
                x: datum.start.x,
                y: bottomStartY
            }, {
                overflowContinuous: true
            }) || !ctx.validatePoint({
                x: datum.end.x,
                y: point.y
            }, {
                overflowContinuous: true
            })) return;
            datum.set({
                height: height
            });
            ctx.recordAction(`Create ${"parallel-channel" /* ParallelChannel */ } annotation`);
            ctx.showAnnotationOptions();
            ctx.update();
        };
        const actionCancel = ()=>ctx.delete();
        super("start", {
            start: {
                click: {
                    target: "waiting-first-render",
                    action: actionCreate
                },
                drag: {
                    target: "waiting-first-render",
                    action: actionCreate
                },
                reset: $2fb96651e8aa1522$var$StateMachine10.parent
            },
            "waiting-first-render": {
                render: {
                    target: "end",
                    action: actionFirstRender
                }
            },
            end: {
                hover: actionEndUpdate,
                drag: actionEndUpdate,
                click: {
                    target: "height",
                    action: actionEndFinish
                },
                dragEnd: {
                    target: "height",
                    action: actionEndFinish
                },
                reset: {
                    target: $2fb96651e8aa1522$var$StateMachine10.parent,
                    action: actionCancel
                },
                cancel: {
                    target: $2fb96651e8aa1522$var$StateMachine10.parent,
                    action: actionCancel
                }
            },
            height: {
                hover: actionHeightUpdate,
                click: {
                    target: $2fb96651e8aa1522$var$StateMachine10.parent,
                    action: actionHeightFinish
                },
                drag: {
                    target: $2fb96651e8aa1522$var$StateMachine10.parent,
                    action: actionHeightFinish
                },
                reset: {
                    target: $2fb96651e8aa1522$var$StateMachine10.parent,
                    action: actionCancel
                },
                cancel: {
                    target: $2fb96651e8aa1522$var$StateMachine10.parent,
                    action: actionCancel
                }
            }
        });
        this.debug = $2fb96651e8aa1522$var$Debug10.create(true, "annotations");
        this.snapping = false;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty10()
], $2fb96651e8aa1522$var$ParallelChannelStateMachine.prototype, "datum", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty10()
], $2fb96651e8aa1522$var$ParallelChannelStateMachine.prototype, "node", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty10()
], $2fb96651e8aa1522$var$ParallelChannelStateMachine.prototype, "snapping", 2);
// packages/ag-charts-enterprise/src/features/annotations/parallel-channel/parallelChannelConfig.ts
var $2fb96651e8aa1522$var$parallelChannelConfig = {
    type: "parallel-channel" /* ParallelChannel */ ,
    datum: $2fb96651e8aa1522$var$ParallelChannelProperties,
    scene: $2fb96651e8aa1522$var$ParallelChannelScene,
    isDatum: $2fb96651e8aa1522$var$ParallelChannelProperties.is,
    translate: (node, datum, transition, context)=>{
        if ($2fb96651e8aa1522$var$ParallelChannelProperties.is(datum) && $2fb96651e8aa1522$var$ParallelChannelScene.is(node)) node.translate(datum, transition, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$ParallelChannelProperties.is(datum) && $2fb96651e8aa1522$var$ParallelChannelProperties.is(copiedDatum) && $2fb96651e8aa1522$var$ParallelChannelScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$ParallelChannelProperties.is(datum) && $2fb96651e8aa1522$var$ParallelChannelScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$ParallelChannelStateMachine({
            ...ctx,
            create: createDatum("parallel-channel" /* ParallelChannel */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
// packages/ag-charts-enterprise/src/features/annotations/text/textScene.ts
var $2fb96651e8aa1522$var$TextScene = class extends $2fb96651e8aa1522$var$TextualPointScene {
    constructor(){
        super();
        this.type = "text" /* Text */ ;
        this.append([
            this.label,
            this.handle
        ]);
    }
    static is(value) {
        return $2fb96651e8aa1522$var$AnnotationScene.isCheck(value, "text" /* Text */ );
    }
    getHandleCoords(_datum, point) {
        const halfSize = $2fb96651e8aa1522$var$DivariantHandle.HANDLE_SIZE / 2;
        return {
            x: point.x + halfSize,
            y: point.y + 2 + halfSize
        };
    }
};
// packages/ag-charts-enterprise/src/features/annotations/text/textState.ts
var $2fb96651e8aa1522$var$TextStateMachine = class extends $2fb96651e8aa1522$var$TextualPointStateMachine {
    createDatum() {
        return new $2fb96651e8aa1522$var$TextProperties();
    }
};
// packages/ag-charts-enterprise/src/features/annotations/text/textConfig.ts
var $2fb96651e8aa1522$var$textConfig = {
    type: "text" /* Text */ ,
    datum: $2fb96651e8aa1522$var$TextProperties,
    scene: $2fb96651e8aa1522$var$TextScene,
    isDatum: $2fb96651e8aa1522$var$TextProperties.is,
    translate: (node, datum, transition, context)=>{
        if ($2fb96651e8aa1522$var$TextProperties.is(datum) && $2fb96651e8aa1522$var$TextScene.is(node)) node.translate(datum, transition, context);
    },
    copy: (node, datum, copiedDatum, context)=>{
        if ($2fb96651e8aa1522$var$TextProperties.is(datum) && $2fb96651e8aa1522$var$TextProperties.is(copiedDatum) && $2fb96651e8aa1522$var$TextScene.is(node)) return node.copy(datum, copiedDatum, context);
    },
    update: (node, datum, context)=>{
        if ($2fb96651e8aa1522$var$TextProperties.is(datum) && $2fb96651e8aa1522$var$TextScene.is(node)) node.update(datum, context);
    },
    createState: (ctx, { createDatum: createDatum })=>new $2fb96651e8aa1522$var$TextStateMachine({
            ...ctx,
            create: createDatum("text" /* Text */ )
        }),
    dragState: (ctx)=>new $2fb96651e8aa1522$var$DragStateMachine(ctx)
};
// packages/ag-charts-enterprise/src/features/annotations/annotationsConfig.ts
var $2fb96651e8aa1522$var$annotationConfigs = {
    // Lines
    [$2fb96651e8aa1522$var$lineConfig.type]: $2fb96651e8aa1522$var$lineConfig,
    [$2fb96651e8aa1522$var$horizontalLineConfig.type]: $2fb96651e8aa1522$var$horizontalLineConfig,
    [$2fb96651e8aa1522$var$verticalLineConfig.type]: $2fb96651e8aa1522$var$verticalLineConfig,
    // Channels
    [$2fb96651e8aa1522$var$parallelChannelConfig.type]: $2fb96651e8aa1522$var$parallelChannelConfig,
    [$2fb96651e8aa1522$var$disjointChannelConfig.type]: $2fb96651e8aa1522$var$disjointChannelConfig,
    // Fibonaccis
    [$2fb96651e8aa1522$var$fibonacciRetracementConfig.type]: $2fb96651e8aa1522$var$fibonacciRetracementConfig,
    [$2fb96651e8aa1522$var$fibonacciRetracementTrendBasedConfig.type]: $2fb96651e8aa1522$var$fibonacciRetracementTrendBasedConfig,
    // Texts
    [$2fb96651e8aa1522$var$calloutConfig.type]: $2fb96651e8aa1522$var$calloutConfig,
    [$2fb96651e8aa1522$var$commentConfig.type]: $2fb96651e8aa1522$var$commentConfig,
    [$2fb96651e8aa1522$var$noteConfig.type]: $2fb96651e8aa1522$var$noteConfig,
    [$2fb96651e8aa1522$var$textConfig.type]: $2fb96651e8aa1522$var$textConfig,
    // Shapes
    [$2fb96651e8aa1522$var$arrowConfig.type]: $2fb96651e8aa1522$var$arrowConfig,
    [$2fb96651e8aa1522$var$arrowUpConfig.type]: $2fb96651e8aa1522$var$arrowUpConfig,
    [$2fb96651e8aa1522$var$arrowDownConfig.type]: $2fb96651e8aa1522$var$arrowDownConfig,
    // Measurers
    [$2fb96651e8aa1522$var$dateRangeConfig.type]: $2fb96651e8aa1522$var$dateRangeConfig,
    [$2fb96651e8aa1522$var$priceRangeConfig.type]: $2fb96651e8aa1522$var$priceRangeConfig,
    [$2fb96651e8aa1522$var$datePriceRangeConfig.type]: $2fb96651e8aa1522$var$datePriceRangeConfig,
    [$2fb96651e8aa1522$var$quickDatePriceRangeConfig.type]: $2fb96651e8aa1522$var$quickDatePriceRangeConfig
};
function $2fb96651e8aa1522$var$getTypedDatum(datum) {
    for (const { isDatum: isDatum } of Object.values($2fb96651e8aa1522$var$annotationConfigs)){
        if (isDatum(datum)) return datum;
    }
}
var { ActionOnSet: $2fb96651e8aa1522$var$ActionOnSet, ParallelStateMachine: $2fb96651e8aa1522$var$ParallelStateMachine, StateMachine: $2fb96651e8aa1522$var$StateMachine11, StateMachineProperty: $2fb96651e8aa1522$var$StateMachineProperty11, Debug: $2fb96651e8aa1522$var$Debug11 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$AnnotationsStateMachine = class extends $2fb96651e8aa1522$var$ParallelStateMachine {
    constructor(ctx){
        super(new $2fb96651e8aa1522$var$SnappingStateMachine((snapping)=>{
            this.snapping = snapping;
        }), new $2fb96651e8aa1522$var$UpdateMachine(()=>{
            this.node = this.active == null ? void 0 : ctx.node(this.active);
        }), new $2fb96651e8aa1522$var$AnnotationsMainStateMachine(ctx, (index)=>{
            this.active = index;
            this.datum = this.active == null ? void 0 : ctx.datum(this.active);
            this.node = this.active == null ? void 0 : ctx.node(this.active);
        }));
        this.snapping = false;
    }
    // TODO: remove this leak
    getActive() {
        return this.active;
    }
    // TODO: remove this leak
    isActive(index) {
        return index === this.active;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty11()
], $2fb96651e8aa1522$var$AnnotationsStateMachine.prototype, "snapping", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty11()
], $2fb96651e8aa1522$var$AnnotationsStateMachine.prototype, "datum", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty11()
], $2fb96651e8aa1522$var$AnnotationsStateMachine.prototype, "node", 2);
var $2fb96651e8aa1522$var$SnappingStateMachine = class extends $2fb96651e8aa1522$var$StateMachine11 {
    constructor(setSnapping){
        super("idle" /* Idle */ , {
            ["idle" /* Idle */ ]: {
                hover: ({ shiftKey: shiftKey })=>setSnapping(shiftKey),
                keyDown: ({ shiftKey: shiftKey })=>setSnapping(shiftKey),
                keyUp: ({ shiftKey: shiftKey })=>setSnapping(shiftKey),
                click: ({ shiftKey: shiftKey })=>setSnapping(shiftKey),
                drag: ({ shiftKey: shiftKey })=>setSnapping(shiftKey)
            },
            ["dragging" /* Dragging */ ]: {},
            ["translating" /* Translating */ ]: {},
            ["text-input" /* TextInput */ ]: {}
        });
    }
};
var $2fb96651e8aa1522$var$UpdateMachine = class extends $2fb96651e8aa1522$var$StateMachine11 {
    constructor(update){
        super("idle" /* Idle */ , {
            ["idle" /* Idle */ ]: {
                onEnter: update,
                render: update
            },
            ["dragging" /* Dragging */ ]: {
                onEnter: update,
                render: update
            },
            ["translating" /* Translating */ ]: {
                onEnter: update,
                render: update
            },
            ["text-input" /* TextInput */ ]: {
                render: update
            }
        });
    }
};
var $2fb96651e8aa1522$var$AnnotationsMainStateMachine = class extends $2fb96651e8aa1522$var$StateMachine11 {
    constructor(ctx, setActive){
        const createDatum = (type)=>(datum)=>{
                ctx.create(type, datum);
                this.active = ctx.selectLast();
            };
        const deleteDatum = ()=>{
            if (this.active != null) ctx.delete(this.active);
            this.active = void 0;
            ctx.select();
        };
        const stateMachineHelpers = {
            createDatum: createDatum
        };
        const createStateMachineContext = {
            ...ctx,
            delete: deleteDatum,
            showTextInput: ()=>{
                if (this.active != null) ctx.showTextInput(this.active);
            },
            deselect: ()=>{
                const prevActive = this.active;
                this.active = void 0;
                this.hovered = void 0;
                ctx.select(this.active, prevActive);
            },
            showAnnotationOptions: ()=>{
                if (this.active != null) ctx.showAnnotationOptions(this.active);
            }
        };
        const createStateMachines = Object.fromEntries(Object.entries($2fb96651e8aa1522$var$annotationConfigs).map(([type, config])=>[
                type,
                config.createState(createStateMachineContext, stateMachineHelpers)
            ]));
        const dragStateMachines = Object.fromEntries(Object.entries($2fb96651e8aa1522$var$annotationConfigs).map(([type, config])=>[
                type,
                config.dragState(ctx, stateMachineHelpers)
            ]));
        const actionColor = ({ colorPickerType: colorPickerType, colorOpacity: colorOpacity, color: color6, opacity: opacity, isMultiColor: isMultiColor })=>{
            if (!this.datum) return;
            if (colorPickerType === "text-color") ctx.updateTextInputColor(color6);
            $2fb96651e8aa1522$var$setColor(this.datum, colorPickerType, colorOpacity, color6, opacity, isMultiColor);
            ctx.update();
        };
        const actionFontSize = (fontSize)=>{
            const { datum: datum, node: node } = this;
            if (!datum || !node) return;
            if ($2fb96651e8aa1522$var$isTextType(datum)) {
                datum.fontSize = fontSize;
                ctx.updateTextInputFontSize(fontSize);
            } else if ($2fb96651e8aa1522$var$hasLineText(datum)) datum.text.fontSize = fontSize;
            ctx.update();
        };
        const actionLineStyle = (lineStyle)=>{
            const { datum: datum, node: node } = this;
            if (!datum || !node || !$2fb96651e8aa1522$var$hasLineStyle(datum)) return;
            $2fb96651e8aa1522$var$setLineStyle(datum, lineStyle);
            ctx.update();
        };
        const actionUpdateTextInputBBox = (bbox)=>{
            const { node: node } = this;
            if (!node || !("setTextInputBBox" in node)) return;
            node.setTextInputBBox(bbox);
            ctx.update();
        };
        const actionSaveText = ({ textInputValue: textInputValue, bbox: bbox })=>{
            const { datum: datum } = this;
            if (bbox != null && textInputValue != null && textInputValue.length > 0) {
                if (!$2fb96651e8aa1522$var$isTextType(datum)) return;
                const wrappedText = $2fb96651e8aa1522$var$wrapText(datum, textInputValue, bbox.width);
                datum.set({
                    text: wrappedText
                });
                ctx.update();
                ctx.recordAction(`Change ${datum.type} annotation text`);
            } else {
                ctx.delete(this.active);
                ctx.recordAction(`Delete ${datum?.type} annotation`);
            }
        };
        const actionCancel = ()=>{
            ctx.updateTextInputBBox(void 0);
        };
        const guardActive = ()=>this.active != null;
        const guardCopied = ()=>this.copied != null;
        const guardActiveHasLineText = ()=>{
            const { active: active, datum: datum } = this;
            if (active == null) return false;
            if (!datum) return false;
            return $2fb96651e8aa1522$var$hasLineText(datum) && !datum.locked;
        };
        const guardActiveNotEphemeral = ()=>this.active != null && !$2fb96651e8aa1522$var$isEphemeralType(this.datum);
        const guardHovered = ()=>this.hovered != null;
        super("idle" /* Idle */ , {
            ["idle" /* Idle */ ]: {
                onEnter: ()=>{
                    ctx.select(this.active, this.active);
                    if (this.hoverCoords) this.hovered = ctx.hoverAtCoords(this.hoverCoords, this.active, this.hovered);
                },
                hover: ({ offset: offset })=>{
                    this.hovered = ctx.hoverAtCoords(offset, this.active, this.hovered);
                    this.hoverCoords = offset;
                },
                translate: {
                    guard: guardActive,
                    target: "translating" /* Translating */ ,
                    action: ({ translation: translation })=>{
                        ctx.startInteracting();
                        ctx.translate(this.active, translation);
                        ctx.update();
                    }
                },
                copy: {
                    guard: guardActiveNotEphemeral,
                    action: ()=>{
                        this.copied = ctx.copy(this.active);
                    }
                },
                cut: {
                    guard: guardActiveNotEphemeral,
                    action: ()=>{
                        this.copied = ctx.copy(this.active);
                        deleteDatum();
                    }
                },
                paste: {
                    guard: guardCopied,
                    action: ()=>{
                        ctx.paste(this.copied);
                    }
                },
                selectLast: ()=>{
                    const previousActive = this.active;
                    this.active = ctx.selectLast();
                    ctx.select(this.active, previousActive);
                },
                click: [
                    {
                        guard: ()=>{
                            const { active: active, hovered: hovered, datum: datum } = this;
                            if (active == null || hovered !== active) return false;
                            if (!datum) return false;
                            return $2fb96651e8aa1522$var$isTextType(datum) && !datum.locked;
                        },
                        target: "text-input" /* TextInput */ 
                    },
                    {
                        action: ()=>{
                            const prevActive = this.active;
                            this.active = this.hovered;
                            ctx.select(this.active, prevActive);
                        }
                    }
                ],
                dblclick: {
                    guard: guardActiveHasLineText,
                    action: ({ offset: offset })=>{
                        const nodeAtCoords = ctx.getNodeAtCoords(offset, this.active) === "text" ? "text" : "line";
                        ctx.showAnnotationSettings(this.active, void 0, nodeAtCoords);
                    }
                },
                dragStart: [
                    {
                        guard: guardHovered,
                        target: "dragging" /* Dragging */ ,
                        action: ()=>{
                            const prevActive = this.active;
                            this.active = this.hovered;
                            ctx.select(this.active, prevActive);
                            ctx.startInteracting();
                        }
                    },
                    {
                        action: ()=>{
                            const prevActive = this.active;
                            this.active = this.hovered;
                            ctx.select(this.active, prevActive);
                        }
                    }
                ],
                color: {
                    guard: guardActive,
                    action: actionColor
                },
                fontSize: {
                    guard: guardActive,
                    action: actionFontSize
                },
                lineProps: {
                    guard: guardActive,
                    action: (props)=>{
                        const datum = $2fb96651e8aa1522$var$getTypedDatum(this.datum);
                        datum?.set(props);
                        ctx.update();
                        ctx.recordAction(`Change ${datum?.type} ${Object.entries(props).map(([key, value])=>`${key} to ${value}`).join(", ")}`);
                    }
                },
                lineStyle: {
                    guard: guardActive,
                    action: actionLineStyle
                },
                lineText: {
                    guard: guardActive,
                    action: (props)=>{
                        const datum = $2fb96651e8aa1522$var$getTypedDatum(this.datum);
                        if (!$2fb96651e8aa1522$var$hasLineText(datum)) return;
                        if ($2fb96651e8aa1522$var$isChannelType(datum) && props.position === "center") props.position = "inside";
                        datum.text.set(props);
                        ctx.update();
                    }
                },
                updateTextInputBBox: {
                    guard: guardActive,
                    action: actionUpdateTextInputBBox
                },
                toolbarPressSettings: {
                    guard: guardActiveHasLineText,
                    action: (sourceEvent)=>{
                        ctx.showAnnotationSettings(this.active, sourceEvent);
                    }
                },
                reset: ()=>{
                    if (this.active != null) this.node?.toggleActive(false);
                    this.hovered = void 0;
                    this.active = void 0;
                    ctx.select(this.active, this.active);
                    ctx.resetToIdle();
                },
                delete: ()=>{
                    if (this.active == null) return;
                    ctx.delete(this.active);
                    if ($2fb96651e8aa1522$var$isEphemeralType(this.datum)) return;
                    ctx.recordAction(`Delete ${this.datum?.type} annotation`);
                },
                deleteAll: ()=>{
                    ctx.deleteAll();
                },
                ...createStateMachines
            },
            ["dragging" /* Dragging */ ]: {
                onEnter: (_, data)=>{
                    if (this.active == null) return;
                    const type = ctx.getAnnotationType(this.active);
                    if (!type) return;
                    this.transitionRoot(type);
                    this.transitionRoot("dragStart", data);
                },
                ...dragStateMachines
            },
            ["translating" /* Translating */ ]: {
                onEnter: ()=>{},
                translate: {
                    guard: guardActive,
                    target: "translating" /* Translating */ ,
                    action: ({ translation: translation })=>{
                        ctx.startInteracting();
                        ctx.translate(this.active, translation);
                        ctx.update();
                    }
                },
                translateEnd: {
                    guard: guardActive,
                    target: "idle" /* Idle */ 
                },
                onExit: ()=>{
                    ctx.stopInteracting();
                    ctx.update();
                    ctx.recordAction("Translate annotation");
                }
            },
            ["text-input" /* TextInput */ ]: {
                onEnter: ()=>{
                    if (this.active == null) return;
                    const datum = $2fb96651e8aa1522$var$getTypedDatum(this.datum);
                    if (!datum || !("getTextInputCoords" in datum)) return;
                    ctx.startInteracting();
                    ctx.showTextInput(this.active);
                    datum.visible = false;
                    ctx.update();
                },
                updateTextInputBBox: {
                    guard: guardActive,
                    action: actionUpdateTextInputBBox
                },
                resize: {
                    target: "idle" /* Idle */ ,
                    action: actionSaveText
                },
                click: {
                    target: "idle" /* Idle */ ,
                    action: actionSaveText
                },
                drag: {
                    target: "idle" /* Idle */ ,
                    action: actionSaveText
                },
                textInput: [
                    {
                        guard: $2fb96651e8aa1522$var$guardCancelAndExit,
                        target: "idle" /* Idle */ ,
                        action: actionCancel
                    },
                    {
                        guard: $2fb96651e8aa1522$var$guardSaveAndExit,
                        target: "idle" /* Idle */ ,
                        action: actionSaveText
                    }
                ],
                color: {
                    guard: guardActive,
                    action: actionColor
                },
                fontSize: {
                    guard: guardActive,
                    action: actionFontSize
                },
                cancel: {
                    target: "idle" /* Idle */ ,
                    action: actionCancel
                },
                onExit: ()=>{
                    ctx.stopInteracting();
                    ctx.hideTextInput();
                    const wasActive = this.active;
                    this.active = this.hovered = void 0;
                    ctx.select(this.active, wasActive);
                    if (wasActive == null) return;
                    const datum = ctx.datum(wasActive);
                    const node = ctx.node(wasActive);
                    if (!datum || !node) return;
                    datum.visible = true;
                }
            }
        });
        this.setActive = setActive;
        this.debug = $2fb96651e8aa1522$var$Debug11.create(true, "annotations");
        this.snapping = false;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ActionOnSet({
        changeValue (newValue) {
            this.setActive(newValue);
        }
    }),
    $2fb96651e8aa1522$var$StateMachineProperty11()
], $2fb96651e8aa1522$var$AnnotationsMainStateMachine.prototype, "active", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty11()
], $2fb96651e8aa1522$var$AnnotationsMainStateMachine.prototype, "hovered", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty11()
], $2fb96651e8aa1522$var$AnnotationsMainStateMachine.prototype, "hoverCoords", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty11()
], $2fb96651e8aa1522$var$AnnotationsMainStateMachine.prototype, "copied", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty11()
], $2fb96651e8aa1522$var$AnnotationsMainStateMachine.prototype, "snapping", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty11()
], $2fb96651e8aa1522$var$AnnotationsMainStateMachine.prototype, "datum", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$StateMachineProperty11()
], $2fb96651e8aa1522$var$AnnotationsMainStateMachine.prototype, "node", 2);
var { ActionOnSet: $2fb96651e8aa1522$var$ActionOnSet2, LayoutElement: $2fb96651e8aa1522$var$LayoutElement, Menu: $2fb96651e8aa1522$var$Menu2, PropertiesArray: $2fb96651e8aa1522$var$PropertiesArray2, ToolbarButtonProperties: $2fb96651e8aa1522$var$ToolbarButtonProperties2, Property: $2fb96651e8aa1522$var$Property31, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection8 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$AnnotationsToolbarButtonProperties = class extends $2fb96651e8aa1522$var$ToolbarButtonProperties2 {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property31
], $2fb96651e8aa1522$var$AnnotationsToolbarButtonProperties.prototype, "value", 2);
var $2fb96651e8aa1522$var$AnnotationsToolbar = class extends (0, $iTJTu._ModuleSupport).BaseProperties {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.enabled = true;
        this.padding = 20;
        this.buttons = new $2fb96651e8aa1522$var$PropertiesArray2($2fb96651e8aa1522$var$AnnotationsToolbarButtonProperties);
        this.events = new (0, $iTJTu._ModuleSupport).Listeners();
        this.annotationMenu = new $2fb96651e8aa1522$var$Menu2(this.ctx, "annotations");
        this.destroyFns = [];
        this.toolbar = ctx.sharedToolbar.getSharedToolbar("annotations");
        const onKeyDown = this.onKeyDown.bind(this);
        this.toolbar.addListener("keydown", onKeyDown);
        this.destroyFns.push(this.toolbar.addToolbarListener("button-pressed", this.onToolbarButtonPress.bind(this)), ctx.layoutManager.registerElement($2fb96651e8aa1522$var$LayoutElement.ToolbarLeft, this.onLayoutStart.bind(this)), ()=>{
            this.toolbar.removeListener("keydown", onKeyDown);
            this.toolbar.destroy();
        });
    }
    destroy() {
        for (const destroyFn of this.destroyFns)destroyFn();
    }
    addListener(eventType, handler) {
        return this.events.addListener(eventType, handler);
    }
    toggleVisibility(visible) {
        this.toolbar.setHidden(!visible);
    }
    toggleClearButtonEnabled(enabled) {
        const index = this.buttons.findIndex((button)=>button.value === "clear");
        this.toolbar.toggleButtonEnabledByIndex(index, enabled);
    }
    resetButtonIcons() {
        for (const [index, button] of this.buttons.entries())switch(button.value){
            case "line-menu":
                this.updateButtonByIndex(index, {
                    icon: "trend-line-drawing",
                    value: "line-menu"
                });
                break;
            case "fibonacci-menu":
                this.updateButtonByIndex(index, {
                    icon: "fibonacci-retracement-drawing",
                    value: "fibonacci-menu"
                });
                break;
            case "text-menu":
                this.updateButtonByIndex(index, {
                    icon: "text-annotation",
                    value: "text-menu"
                });
                break;
            case "shape-menu":
                this.updateButtonByIndex(index, {
                    icon: "arrow-drawing",
                    value: "shape-menu"
                });
                break;
            case "measurer-menu":
                this.updateButtonByIndex(index, {
                    icon: "measurer-drawing",
                    value: "measurer-menu"
                });
                break;
        }
    }
    hideOverlays() {
        this.annotationMenu.hide();
    }
    clearActiveButton() {
        this.toolbar.clearActiveButton();
    }
    dispatch(eventType, event) {
        this.events.dispatch(eventType, event);
    }
    onLayoutStart(event) {
        if (!this.enabled) return;
        this.toolbar.updateButtons(this.buttons);
        this.toolbar.layout(event.layoutBox, this.padding);
    }
    refreshButtonsEnabled(enabled) {
        for (const [index, button] of this.buttons.entries()){
            if (!button) continue;
            this.toolbar.toggleButtonEnabledByIndex(index, enabled);
        }
    }
    onToolbarButtonPress({ event: event, button: button, buttonBounds: buttonBounds }) {
        const axisScale = this.ctx.axisManager.getAxisContext($2fb96651e8aa1522$var$ChartAxisDirection8.Y)[0].scale;
        switch(button.value){
            case "clear":
                this.dispatch("pressed-clear");
                break;
            case "line-menu":
                this.onToolbarButtonPressShowMenu(event, buttonBounds, button.value, "toolbarAnnotationsLineAnnotations", $2fb96651e8aa1522$var$LINE_ANNOTATION_ITEMS.filter((item)=>item.visible ? item.visible(axisScale) : true));
                break;
            case "fibonacci-menu":
                this.onToolbarButtonPressShowMenu(event, buttonBounds, button.value, "toolbarAnnotationsFibonacciAnnotations", $2fb96651e8aa1522$var$FIBONACCI_ANNOTATION_ITEMS);
                break;
            case "text-menu":
                this.onToolbarButtonPressShowMenu(event, buttonBounds, button.value, "toolbarAnnotationsTextAnnotations", $2fb96651e8aa1522$var$TEXT_ANNOTATION_ITEMS);
                break;
            case "shape-menu":
                this.onToolbarButtonPressShowMenu(event, buttonBounds, button.value, "toolbarAnnotationsShapeAnnotations", $2fb96651e8aa1522$var$SHAPE_ANNOTATION_ITEMS);
                break;
            case "measurer-menu":
                this.onToolbarButtonPressShowMenu(event, buttonBounds, button.value, "toolbarAnnotationsMeasurerAnnotations", $2fb96651e8aa1522$var$MEASURER_ANNOTATION_ITEMS);
                break;
        }
    }
    onToolbarButtonPressShowMenu(event, buttonBounds, menu, ariaLabel, items) {
        this.dispatch("pressed-show-menu");
        const index = this.buttons.findIndex((button)=>button.value === menu);
        this.toolbar.toggleActiveButtonByIndex(index);
        this.annotationMenu.setAnchor({
            x: buttonBounds.x + buttonBounds.width + 6,
            y: buttonBounds.y
        });
        this.annotationMenu.show({
            items: items,
            ariaLabel: this.ctx.localeManager.t(ariaLabel),
            class: "ag-charts-annotations__toolbar-menu",
            sourceEvent: event.sourceEvent,
            onPress: this.onButtonPressMenuCreateAnnotation.bind(this, menu)
        });
    }
    onButtonPressMenuCreateAnnotation(menu, item) {
        const index = this.buttons.findIndex((button)=>button.value === menu);
        this.updateButtonByIndex(index, {
            icon: item.icon
        });
        this.dispatch("pressed-create-annotation", {
            annotation: item.value
        });
        this.annotationMenu.hide();
    }
    onKeyDown({ sourceEvent: sourceEvent }) {
        if (sourceEvent.key === "Escape") this.dispatch("cancel-create-annotation");
    }
    updateButtonByIndex(index, change) {
        const button = this.buttons.at(index);
        if (!button) return;
        button.set({
            ...button.toJson(),
            ...change,
            value: change.value ?? button.value
        });
        this.toolbar.updateButtonByIndex(index, {
            ...button.toJson()
        });
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property31,
    $2fb96651e8aa1522$var$ActionOnSet2({
        changeValue (enabled) {
            this.toolbar?.setHidden(!enabled);
        }
    })
], $2fb96651e8aa1522$var$AnnotationsToolbar.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property31
], $2fb96651e8aa1522$var$AnnotationsToolbar.prototype, "padding", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property31
], $2fb96651e8aa1522$var$AnnotationsToolbar.prototype, "buttons", 2);
var { BaseModuleInstance: $2fb96651e8aa1522$var$BaseModuleInstance, InteractionState: $2fb96651e8aa1522$var$InteractionState, Property: $2fb96651e8aa1522$var$Property32, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection9, getIconClassNames: $2fb96651e8aa1522$var$getIconClassNames } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$DEFAULT_ANNOTATION_AXIS_BUTTON_CLASS = `ag-charts-annotations__axis-button`;
var $2fb96651e8aa1522$var$AxisButton = class extends $2fb96651e8aa1522$var$BaseModuleInstance {
    constructor(ctx, axisCtx, onButtonClick, seriesRect){
        super();
        this.ctx = ctx;
        this.axisCtx = axisCtx;
        this.onButtonClick = onButtonClick;
        this.seriesRect = seriesRect;
        this.enabled = true;
        this.snap = false;
        this.padding = 0;
        this.button = this.setup();
        this.toggleVisibility(false);
        this.updateButtonElement();
        this.snap = Boolean(axisCtx.scale.bandwidth);
        ctx.domManager.addEventListener("focusin", ({ target: target })=>{
            const htmlTarget = target instanceof HTMLElement ? target : void 0;
            const isSeriesAreaChild = htmlTarget && ctx.domManager.contains(htmlTarget, "series-area");
            if (!isSeriesAreaChild && htmlTarget !== this.button.getElement()) this.hide();
        });
        this.destroyFns.push(ctx.widgets.seriesWidget.addListener("drag-move", (e)=>this.onMouseDrag(e)), ctx.widgets.seriesWidget.addListener("mousemove", (e)=>this.onMouseMove(e)), ctx.widgets.seriesWidget.addListener("mouseleave", ()=>this.onMouseLeave()), ctx.widgets.seriesDragInterpreter.addListener("click", (e)=>this.onClick(e)), ctx.chartEventManager.addListener("series-focus-change", ()=>this.onKeyPress()), ctx.zoomManager.addListener("zoom-pan-start", ()=>this.hide()), ctx.zoomManager.addListener("zoom-change", ()=>this.hide()), ()=>this.destroyElements(), ()=>this.button.destroy());
    }
    update(seriesRect, padding) {
        this.seriesRect = seriesRect;
        this.padding = padding;
    }
    setup() {
        const button = new (0, $iTJTu._Widget).ButtonWidget();
        button.addClass($2fb96651e8aa1522$var$DEFAULT_ANNOTATION_AXIS_BUTTON_CLASS);
        button.setTabIndex(-1);
        button.setAriaLabel(this.ctx.localeManager.t("ariaLabelAddHorizontalLine"));
        this.ctx.widgets.seriesWidget.getElement().appendChild(button.getElement());
        return button;
    }
    destroyElements() {
        this.ctx.domManager.removeChild("canvas-overlay", $2fb96651e8aa1522$var$DEFAULT_ANNOTATION_AXIS_BUTTON_CLASS);
    }
    onMouseMove(e) {
        if (this.ctx.interactionManager.isState($2fb96651e8aa1522$var$InteractionState.Clickable)) this.show(e);
    }
    onMouseDrag(e) {
        if (this.ctx.interactionManager.isState($2fb96651e8aa1522$var$InteractionState.AnnotationsMoveable)) this.show(e);
    }
    onMouseLeave() {
        if (this.ctx.interactionManager.isState($2fb96651e8aa1522$var$InteractionState.Clickable)) this.hide();
    }
    onClick(e) {
        if (this.ctx.interactionManager.isState($2fb96651e8aa1522$var$InteractionState.Clickable) && e.device === "touch") this.show(e);
    }
    show(event) {
        const { sourceEvent: sourceEvent, currentX: x, currentY: y } = event;
        if (!(this.enabled && this.ctx.widgets.seriesWidget.getElement().contains(sourceEvent.target))) {
            this.hide();
            return;
        }
        this.toggleVisibility(true);
        const buttonCoords = this.getButtonCoordinates({
            x: x,
            y: y
        });
        this.coords = {
            x: buttonCoords.x + this.button.clientWidth / 2,
            y: buttonCoords.y + this.button.clientHeight / 2
        };
        this.updatePosition(buttonCoords);
    }
    hide() {
        this.toggleVisibility(false);
    }
    onKeyPress() {
        if (this.snap && this.ctx.interactionManager.isState($2fb96651e8aa1522$var$InteractionState.Default)) return;
        this.hide();
    }
    getButtonCoordinates({ x: x, y: y }) {
        const { axisCtx: { direction: direction, position: position }, seriesRect: seriesRect, snap: snap, axisCtx: axisCtx, padding: padding } = this;
        const { clientWidth: buttonWidth, clientHeight: buttonHeight } = this.button;
        const [minY, maxY] = [
            0,
            seriesRect.height
        ];
        const [minX, maxX] = [
            0,
            seriesRect.width
        ];
        if (snap) {
            x = $2fb96651e8aa1522$var$convert($2fb96651e8aa1522$var$invert(x - seriesRect.x, axisCtx), axisCtx) + seriesRect.x;
            y = $2fb96651e8aa1522$var$convert($2fb96651e8aa1522$var$invert(y - seriesRect.y, axisCtx), axisCtx) + seriesRect.y;
        }
        if (direction === $2fb96651e8aa1522$var$ChartAxisDirection9.X) {
            const crosshairLabelPadding = 5;
            const offset = buttonHeight - Math.max(0, padding - crosshairLabelPadding);
            x = x - buttonWidth / 2;
            y = position === "top" ? minY - buttonHeight + offset : maxY - offset;
        } else {
            const crosshairLabelPadding = 9;
            const offset = buttonWidth - Math.max(0, padding - crosshairLabelPadding);
            x = position === "left" ? minX - buttonWidth + offset : maxX - offset;
            y = y - buttonHeight / 2;
        }
        return {
            x: x,
            y: y
        };
    }
    toggleVisibility(visible) {
        const { button: button } = this;
        if (button == null) return;
        const isVisible = this.enabled && visible;
        this.toggleClass("-hidden", !isVisible);
    }
    toggleClass(name, include) {
        this.button.toggleClass(`${$2fb96651e8aa1522$var$DEFAULT_ANNOTATION_AXIS_BUTTON_CLASS}-${name}`, include);
    }
    updatePosition({ x: x, y: y }) {
        this.button.getElement().style.transform = `translate(${Math.round(x)}px, ${Math.round(y)}px)`;
    }
    updateButtonElement() {
        const { button: button } = this;
        button.addListener("click", ()=>this.onButtonClick(this.coords));
        button.addListener("touchend", ()=>this.onButtonClick(this.coords));
        button.addListener("drag-start", ()=>{});
        button.setInnerHTML(`<span class="${$2fb96651e8aa1522$var$getIconClassNames("zoom-in")} ${$2fb96651e8aa1522$var$DEFAULT_ANNOTATION_AXIS_BUTTON_CLASS}-icon"></span>`);
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property32
], $2fb96651e8aa1522$var$AxisButton.prototype, "enabled", 2);
var { Color: $2fb96651e8aa1522$var$Color5, DraggablePopover: $2fb96651e8aa1522$var$DraggablePopover, NativeWidget: $2fb96651e8aa1522$var$NativeWidget, Vec2: $2fb96651e8aa1522$var$Vec218, createButton: $2fb96651e8aa1522$var$createButton, createCheckbox: $2fb96651e8aa1522$var$createCheckbox, createSelect: $2fb96651e8aa1522$var$createSelect, createTextArea: $2fb96651e8aa1522$var$createTextArea, initRovingTabIndex: $2fb96651e8aa1522$var$initRovingTabIndex, getIconClassNames: $2fb96651e8aa1522$var$getIconClassNames2, mapValues: $2fb96651e8aa1522$var$mapValues } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$_Dialog = class _Dialog extends $2fb96651e8aa1522$var$DraggablePopover {
    constructor(ctx, id){
        super(ctx, id);
        this.dragHandleDraggingClass = "ag-charts-dialog__drag-handle--dragging";
        this.colorPicker = new $2fb96651e8aa1522$var$ColorPicker(this.ctx, {
            detached: true
        });
        this.destroyFns.push(ctx.layoutManager.addListener("layout:complete", this.onLayoutComplete.bind(this)));
    }
    showWithChildren(children, options) {
        const popover = super.showWithChildren(children, options);
        popover.classList.add("ag-charts-dialog");
        popover.setAttribute("role", "dialog");
        popover.addEventListener("mousedown", (event)=>{
            if (event.target.classList?.contains("ag-charts-dialog__color-picker-button")) return;
            this.colorPicker.hide();
        });
        popover.addEventListener("keydown", this.onKeyDown.bind(this));
        (0, $idDdm.getWindow)().requestAnimationFrame(()=>this.reposition());
        this.colorPicker.attachTo(this);
        return popover;
    }
    updatePosition(position) {
        super.updatePosition(position);
        const { anchor: anchor, fallbackAnchor: fallbackAnchor } = this.getColorPickerAnchors() ?? {};
        if (!anchor) return;
        this.colorPicker.setAnchor(anchor, fallbackAnchor);
    }
    /**************
   * Containers *
   **************/ createTabs(tablistLabel, initial, tabs) {
        const element = (0, $idDdm.createElement)("div", "ag-charts-dialog__tabs");
        const tabButtonIds = $2fb96651e8aa1522$var$mapValues(tabs, ()=>(0, $idDdm.createElementId)());
        const tabPanelIds = $2fb96651e8aa1522$var$mapValues(tabs, ()=>(0, $idDdm.createElementId)());
        for (const [key, tab] of (0, $idDdm.entries)(tabs))(0, $idDdm.setAttributes)(tab.panel, {
            id: tabPanelIds[key],
            role: "tabpanel",
            "aria-labelledby": tabButtonIds[key]
        });
        const onPressTab = (active)=>{
            for (const [key, tab] of (0, $idDdm.entries)(tabs)){
                tab.panel.classList.toggle("ag-charts-dialog__tab-panel--active", key === active);
                tabButtons[key].classList.toggle("ag-charts-dialog__tab-button--active", key === active);
                (0, $idDdm.setAttribute)(tabButtons[key], "aria-selected", key === active);
                if (key === active) tab.onShow?.();
            }
        };
        const header = new $2fb96651e8aa1522$var$NativeWidget((0, $idDdm.createElement)("div", "ag-charts-dialog__header"));
        header.addListener("drag-start", (event)=>{
            const { sourceEvent: sourceEvent } = event;
            if (sourceEvent.target instanceof Element && sourceEvent.target.classList.contains("ag-charts-dialog__header")) this.onDragStart(event);
        });
        header.addListener("drag-move", (event)=>this.onDragMove(event));
        header.addListener("drag-end", ()=>this.onDragEnd());
        const dragHandle = new $2fb96651e8aa1522$var$DragHandleWidget();
        this.setDragHandle(dragHandle);
        const tabButtons = $2fb96651e8aa1522$var$mapValues(tabs, (tab, key)=>$2fb96651e8aa1522$var$createButton({
                label: this.ctx.localeManager.t(tab.label),
                onPress: ()=>onPressTab(key)
            }, {
                id: tabButtonIds[key],
                class: "ag-charts-dialog__tab-button",
                role: "tab",
                "aria-controls": tabPanelIds[key]
            }));
        const tabList = (0, $idDdm.createElement)("div", "ag-charts-dialog__tab-list");
        (0, $idDdm.setAttributes)(tabList, {
            role: "tablist",
            "aria-label": this.ctx.localeManager.t(tablistLabel)
        });
        tabList.append(...Object.values(tabButtons));
        const closeButton = this.createHeaderCloseButton();
        header.getElement().append(dragHandle.getElement(), tabList, closeButton);
        element.append(header.getElement(), ...Object.values(tabs).map((t)=>t.panel));
        onPressTab(initial);
        $2fb96651e8aa1522$var$initRovingTabIndex({
            orientation: "horizontal",
            buttons: Object.values(tabButtons)
        });
        return {
            tabs: element,
            initialFocus: tabButtons[initial]
        };
    }
    createTabPanel() {
        return (0, $idDdm.createElement)("div", "ag-charts-dialog__tab-panel");
    }
    /**********
   * Inputs *
   **********/ createInputGroupLine() {
        return (0, $idDdm.createElement)("div", "ag-charts-dialog__input-group-line");
    }
    createRadioGroup({ label: label, options: options, value: value, onChange: onChange }) {
        const group = this.createInputGroup(label);
        (0, $idDdm.setAttributes)(group, {
            role: "radiogroup",
            tabindex: -1,
            "aria-label": this.ctx.localeManager.t(label)
        });
        const activeClass = "ag-charts-dialog__button--active";
        const buttons2 = [];
        for (const button of options){
            const { icon: icon, altText: altTextKey } = button;
            const altText = this.ctx.localeManager.t(altTextKey);
            const buttonEl = $2fb96651e8aa1522$var$createButton({
                icon: icon,
                altText: altText,
                onPress: ()=>{
                    for (const b of Array.from(group.children)){
                        b.classList.remove(activeClass);
                        b.ariaChecked = "false";
                    }
                    buttonEl.classList.add(activeClass);
                    buttonEl.ariaChecked = "true";
                    onChange(button.value);
                }
            }, {
                "aria-checked": button.value === value,
                class: "ag-charts-dialog__button",
                role: "radio",
                title: altText
            });
            if (button.value === value) buttonEl.classList.add(activeClass);
            group.appendChild(buttonEl);
            buttons2.push(buttonEl);
        }
        $2fb96651e8aa1522$var$initRovingTabIndex({
            orientation: "horizontal",
            buttons: buttons2
        });
        return group;
    }
    createSelect({ altText: altText, label: label, options: options, value: value, onChange: onChange }) {
        const group = this.createInputGroup(label);
        const altTextT = this.ctx.localeManager.t(altText);
        const select = $2fb96651e8aa1522$var$createSelect({
            value: value,
            options: options,
            onChange: onChange
        }, {
            class: "ag-charts-dialog__select",
            "aria-label": altTextT,
            title: altTextT
        });
        group.append(select);
        return group;
    }
    createTextArea({ placeholder: placeholder, value: value, onChange: onChange }) {
        const placeholderT = placeholder ? this.ctx.localeManager.t(placeholder) : void 0;
        return $2fb96651e8aa1522$var$createTextArea({
            value: value,
            onChange: onChange
        }, {
            placeholder: placeholderT
        });
    }
    createCheckbox({ label: label, checked: checked, onChange: onChange }) {
        const id = (0, $idDdm.createElementId)();
        const group = this.createInputGroup(label, {
            for: id
        });
        const checkbox = $2fb96651e8aa1522$var$createCheckbox({
            checked: checked,
            onChange: onChange
        }, {
            class: "ag-charts-dialog__checkbox",
            role: "switch",
            id: id
        });
        group.append(checkbox);
        return group;
    }
    createColorPicker({ color: color6, opacity: opacity, label: label, altText: altText, onChange: onChange, onChangeHide: onChangeHide, isMultiColor: isMultiColor, hasMultiColorOption: hasMultiColorOption }) {
        const group = this.createInputGroup(label);
        const altTextT = this.ctx.localeManager.t(altText);
        const colorEl = $2fb96651e8aa1522$var$createButton({
            label: altTextT,
            onPress: (event)=>{
                const { anchor: anchor, fallbackAnchor: fallbackAnchor } = this.getColorPickerAnchors(colorEl) ?? {};
                this.colorPicker.show({
                    anchor: anchor,
                    fallbackAnchor: fallbackAnchor,
                    color: color6,
                    opacity: opacity,
                    isMultiColor: isMultiColor,
                    hasMultiColorOption: hasMultiColorOption,
                    sourceEvent: event,
                    onChange: (newColorOpacity, newColor, newOpacity, newIsMultiColor)=>{
                        colorEl.style.setProperty("--color", newColorOpacity);
                        colorEl.classList.toggle("ag-charts-dialog__color-picker-button--multi-color", newIsMultiColor);
                        onChange(newColorOpacity, newColor, newOpacity, newIsMultiColor);
                    },
                    onChangeHide: onChangeHide
                });
            }
        }, {
            "aria-label": altTextT,
            tabindex: 0,
            class: "ag-charts-dialog__color-picker-button",
            title: altTextT
        });
        if (isMultiColor) colorEl.classList.toggle("ag-charts-dialog__color-picker-button--multi-color");
        else if (color6) {
            const hex = $2fb96651e8aa1522$var$Color5.fromString(color6);
            const hexWithOpacity = new $2fb96651e8aa1522$var$Color5(hex.r, hex.g, hex.b, opacity);
            colorEl.style.setProperty("--color", hexWithOpacity.toHexString());
        }
        group.append(colorEl);
        this.hideFns.push(()=>{
            this.colorPicker.hide();
        });
        return group;
    }
    /***********
   * Private *
   ***********/ createHeaderCloseButton() {
        return $2fb96651e8aa1522$var$createButton({
            icon: "close",
            altText: this.ctx.localeManager.t("iconAltTextClose"),
            onPress: ()=>this.hide()
        }, {
            class: "ag-charts-dialog__close-button"
        });
    }
    createInputGroup(label, options) {
        const group = (0, $idDdm.createElement)("div", "ag-charts-dialog__input-group");
        const labelEl = (0, $idDdm.createElement)("label", "ag-charts-dialog__input-group-label");
        labelEl.innerText = this.ctx.localeManager.t(label);
        (0, $idDdm.setAttribute)(labelEl, "for", options?.for);
        group.appendChild(labelEl);
        return group;
    }
    onLayoutComplete(event) {
        this.seriesRect = event.series.paddedRect;
        this.reposition();
    }
    onKeyDown(event) {
        if (event.altKey || event.ctrlKey || event.metaKey || event.isComposing || event.key !== "Escape") return;
        this.hide();
    }
    reposition() {
        const { seriesRect: seriesRect, ctx: ctx } = this;
        const clientRect = ctx.domManager.getBoundingClientRect();
        const popover = this.getPopoverElement();
        if (!seriesRect || !popover) return;
        const outerOffset = $2fb96651e8aa1522$var$Vec218.from(0, seriesRect.y);
        const outerSize = $2fb96651e8aa1522$var$Vec218.from(clientRect.width, seriesRect.height);
        const popoverSize = $2fb96651e8aa1522$var$Vec218.from(popover);
        const halfWidth = $2fb96651e8aa1522$var$Vec218.from(0.5, 1);
        let position;
        if (seriesRect.width > 1e3) {
            const bottomCenter = $2fb96651e8aa1522$var$Vec218.sub($2fb96651e8aa1522$var$Vec218.add(outerOffset, $2fb96651e8aa1522$var$Vec218.multiply(outerSize, halfWidth)), $2fb96651e8aa1522$var$Vec218.multiply(popoverSize, halfWidth));
            position = $2fb96651e8aa1522$var$Vec218.sub(bottomCenter, $2fb96651e8aa1522$var$Vec218.from(0, _Dialog.offset));
        } else {
            const bottomRight = $2fb96651e8aa1522$var$Vec218.sub($2fb96651e8aa1522$var$Vec218.add(outerOffset, outerSize), popoverSize);
            position = $2fb96651e8aa1522$var$Vec218.sub(bottomRight, _Dialog.offset);
        }
        this.updatePosition(position);
    }
    getColorPickerAnchors(element) {
        if (element) this.colorPickerAnchorElement = element;
        if (!this.colorPickerAnchorElement) return;
        const rect = this.colorPickerAnchorElement.getBoundingClientRect();
        const canvasRect = this.ctx.domManager.getBoundingClientRect();
        const topLeft = $2fb96651e8aa1522$var$Vec218.sub($2fb96651e8aa1522$var$Vec218.from(rect.x, rect.y), $2fb96651e8aa1522$var$Vec218.from(canvasRect.left, canvasRect.top));
        const anchor = $2fb96651e8aa1522$var$Vec218.add(topLeft, $2fb96651e8aa1522$var$Vec218.from(0, rect.height + 5));
        const fallbackAnchor = $2fb96651e8aa1522$var$Vec218.sub(topLeft, $2fb96651e8aa1522$var$Vec218.from(0, 5));
        return {
            anchor: anchor,
            fallbackAnchor: fallbackAnchor
        };
    }
};
$2fb96651e8aa1522$var$_Dialog.offset = 60;
var $2fb96651e8aa1522$var$Dialog = $2fb96651e8aa1522$var$_Dialog;
var $2fb96651e8aa1522$var$DragHandleWidget = class extends $2fb96651e8aa1522$var$NativeWidget {
    constructor(){
        super((0, $idDdm.createElement)("div", "ag-charts-dialog__drag-handle"));
        const icon = new $2fb96651e8aa1522$var$NativeWidget((0, $idDdm.createElement)("span", $2fb96651e8aa1522$var$getIconClassNames2("drag-handle")));
        icon.setAriaHidden(true);
        this.addChild(icon);
    }
};
// packages/ag-charts-enterprise/src/features/annotations/settings-dialog/settingsDialog.ts
var { Listeners: $2fb96651e8aa1522$var$Listeners2, focusCursorAtEnd: $2fb96651e8aa1522$var$focusCursorAtEnd2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$AnnotationSettingsDialog = class extends $2fb96651e8aa1522$var$Dialog {
    constructor(ctx){
        super(ctx, "settings");
        this.events = new $2fb96651e8aa1522$var$Listeners2();
        this.hideFns.push(()=>this.events.dispatch("hidden"));
    }
    addListener(eventType, handler) {
        return this.events.addListener(eventType, handler);
    }
    show(datum, options) {
        const lineTab = this.createLinearLineTab(datum, options);
        const textTab = this.createLinearTextTab(datum, options);
        let lineLabel = "dialogHeaderLine";
        if ($2fb96651e8aa1522$var$isChannelType(datum)) lineLabel = "dialogHeaderChannel";
        else if ($2fb96651e8aa1522$var$isFibonacciType(datum)) lineLabel = "dialogHeaderFibonacciRange";
        else if (datum.type === "date-range" /* DateRange */ ) lineLabel = "dialogHeaderDateRange";
        else if (datum.type === "price-range" /* PriceRange */ ) lineLabel = "dialogHeaderPriceRange";
        else if (datum.type === "date-price-range" /* DatePriceRange */ ) lineLabel = "dialogHeaderDatePriceRange";
        const { tabs: tabs, initialFocus: initialFocus } = this.createTabs("ariaLabelSettingsTabBar", options.initialSelectedTab, {
            line: {
                label: lineLabel,
                panel: lineTab
            },
            text: {
                label: "dialogHeaderText",
                panel: textTab.panel,
                onShow: textTab.onShow
            }
        });
        options.initialFocus = initialFocus;
        const popover = this.showWithChildren([
            tabs
        ], options);
        popover.classList.add("ag-charts-dialog--annotation-settings");
    }
    createLinearLineTab(datum, options) {
        const panel = this.createTabPanel();
        const groupOne = this.createInputGroupLine();
        const groupTwo = this.createInputGroupLine();
        const hasMultiColorOption = "isMultiColor" in datum;
        const lineColorPicker = this.createColorPickerInput("line-color", datum.getDefaultColor("line-color"), datum.getDefaultOpacity("line-color"), hasMultiColorOption ? datum.isMultiColor : false, hasMultiColorOption, options.onChangeLineColor, options.onChangeHideLineColor);
        const strokeWidth = this.createStrokeWidthSelect(datum.strokeWidth ?? 2, options.onChangeLineStyleWidth);
        const lineStyle = this.createLineStyleRadioGroup(datum.lineStyle ?? "solid", options.onChangeLineStyleType);
        groupOne.append(lineColorPicker);
        if ("background" in datum) {
            const fillColorPicker = this.createColorPickerInput("fill-color", datum.getDefaultColor("fill-color"), datum.getDefaultOpacity("fill-color"), false, false, options.onChangeFillColor, options.onChangeHideFillColor);
            groupOne.append(fillColorPicker);
            groupTwo.append(strokeWidth);
        } else if ("showFill" in datum) {
            groupOne.append(this.createCheckbox({
                label: "dialogInputShowFill",
                checked: datum.showFill ?? true,
                onChange: (showFill)=>options.onChangeLine({
                        showFill: showFill
                    })
            }));
            groupTwo.append(strokeWidth);
        } else groupOne.append(strokeWidth);
        groupTwo.append(lineStyle);
        panel.append(groupOne, groupTwo);
        if ("bands" in datum) panel.append(this.createFibonacciRatioSelect(datum.bands ?? 10, (bands)=>options.onChangeLine({
                bands: bands
            })));
        if ("extendStart" in datum && "extendEnd" in datum) panel.append(this.createCheckbox({
            label: $2fb96651e8aa1522$var$isChannelType(datum) ? "dialogInputExtendChannelStart" : "dialogInputExtendLineStart",
            checked: datum.extendStart ?? false,
            onChange: (extendStart)=>options.onChangeLine({
                    extendStart: extendStart
                })
        }), this.createCheckbox({
            label: $2fb96651e8aa1522$var$isChannelType(datum) ? "dialogInputExtendChannelEnd" : "dialogInputExtendLineEnd",
            checked: datum.extendEnd ?? false,
            onChange: (extendEnd)=>options.onChangeLine({
                    extendEnd: extendEnd
                })
        }));
        if ("extendAbove" in datum && "extendBelow" in datum) panel.append(this.createCheckbox({
            label: "dialogInputExtendAbove",
            checked: datum.extendAbove ?? false,
            onChange: (extendAbove)=>options.onChangeLine({
                    extendAbove: extendAbove
                })
        }), this.createCheckbox({
            label: "dialogInputExtendBelow",
            checked: datum.extendBelow ?? false,
            onChange: (extendBelow)=>options.onChangeLine({
                    extendBelow: extendBelow
                })
        }));
        if ("extendLeft" in datum && "extendRight" in datum) panel.append(this.createCheckbox({
            label: "dialogInputExtendLeft",
            checked: datum.extendLeft ?? false,
            onChange: (extendLeft)=>options.onChangeLine({
                    extendLeft: extendLeft
                })
        }), this.createCheckbox({
            label: "dialogInputExtendRight",
            checked: datum.extendRight ?? false,
            onChange: (extendRight)=>options.onChangeLine({
                    extendRight: extendRight
                })
        }));
        if ("reverse" in datum && "showFill" in datum) panel.append(this.createCheckbox({
            label: "dialogInputReverse",
            checked: datum.reverse ?? false,
            onChange: (reverse)=>options.onChangeLine({
                    reverse: reverse
                })
        }));
        return panel;
    }
    createLinearTextTab(datum, options) {
        const panel = this.createTabPanel();
        const textArea = this.createTextArea({
            placeholder: "inputTextareaPlaceholder",
            value: datum.text.label,
            onChange: (value)=>options.onChangeText({
                    label: value
                })
        });
        const fontSize = this.createFontSizeSelect(datum.text.fontSize, options.onChangeTextFontSize);
        const colorPicker = this.createColorPickerInput("text-color", datum.text.color, 1, false, false, options.onChangeTextColor, options.onChangeHideTextColor);
        const textPosition = datum.text.position === "inside" ? "center" : datum.text.position;
        const position = this.createPositionRadioGroup(textPosition ?? "top", (value)=>options.onChangeText({
                position: value
            }));
        const alignment = this.createAlignmentRadioGroup(datum.text.alignment ?? "center", (value)=>options.onChangeText({
                alignment: value
            }));
        const inputGroupLine = this.createInputGroupLine();
        inputGroupLine.append(fontSize, colorPicker, position, alignment);
        panel.append(textArea, inputGroupLine);
        return {
            panel: panel,
            onShow: ()=>$2fb96651e8aa1522$var$focusCursorAtEnd2(textArea)
        };
    }
    createColorPickerInput(colorType, color6, opacity, isMultiColor, hasMultiColorOption, onChange, onChangeHide) {
        const label = colorType === "fill-color" ? "dialogInputFillColorPicker" : "dialogInputColorPicker";
        const altText = colorType === "fill-color" ? "dialogInputFillColorPickerAltText" : "dialogInputColorPickerAltText";
        return this.createColorPicker({
            label: label,
            altText: altText,
            color: color6,
            opacity: opacity,
            isMultiColor: isMultiColor,
            hasMultiColorOption: hasMultiColorOption,
            onChange: onChange,
            onChangeHide: onChangeHide
        });
    }
    createStrokeWidthSelect(strokeWidth, onChange) {
        return this.createSelect({
            label: "dialogInputStrokeWidth",
            altText: "dialogInputStrokeWidthAltText",
            options: $2fb96651e8aa1522$var$LINE_STROKE_WIDTH_ITEMS.map(({ label: label, value: value })=>({
                    label: label,
                    value: `${value}`
                })),
            value: String(strokeWidth),
            onChange: (value)=>onChange(Number(value))
        });
    }
    createFibonacciRatioSelect(bands, onChange) {
        return this.createSelect({
            label: "dialogInputFibonacciBands",
            altText: "dialogInputFibonacciBandsAltText",
            options: $2fb96651e8aa1522$var$FIBONACCI_RATIO_ITEMS.map(({ label: label, value: value })=>({
                    label: label,
                    value: `${value}`
                })),
            value: String(bands),
            onChange: (value)=>onChange(Number(value))
        });
    }
    createLineStyleRadioGroup(lineStyle, onChange) {
        return this.createRadioGroup({
            label: "dialogInputLineStyle",
            options: [
                {
                    icon: "line-style-solid",
                    altText: "iconAltTextLineStyleSolid",
                    value: "solid"
                },
                {
                    icon: "line-style-dashed",
                    altText: "iconAltTextLineStyleDashed",
                    value: "dashed"
                },
                {
                    icon: "line-style-dotted",
                    altText: "iconAltTextLineStyleDotted",
                    value: "dotted"
                }
            ],
            value: lineStyle,
            onChange: onChange
        });
    }
    createFontSizeSelect(fontSize, onChange) {
        return this.createSelect({
            label: "dialogInputFontSize",
            altText: "dialogInputFontSizeAltText",
            options: $2fb96651e8aa1522$var$TEXT_SIZE_ITEMS.map(({ label: label, value: value })=>({
                    label: label,
                    value: String(value)
                })),
            value: String(fontSize),
            onChange: (value)=>onChange(Number(value))
        });
    }
    createPositionRadioGroup(position, onChange) {
        return this.createRadioGroup({
            label: "dialogInputPosition",
            options: [
                {
                    icon: "position-top",
                    altText: "iconAltTextPositionTop",
                    value: "top"
                },
                {
                    icon: "position-center",
                    altText: "iconAltTextPositionCenter",
                    value: "center"
                },
                {
                    icon: "position-bottom",
                    altText: "iconAltTextPositionBottom",
                    value: "bottom"
                }
            ],
            value: position,
            onChange: onChange
        });
    }
    createAlignmentRadioGroup(alignment, onChange) {
        return this.createRadioGroup({
            label: "dialogInputAlign",
            options: [
                {
                    icon: "align-left",
                    altText: "iconAltTextAlignLeft",
                    value: "left"
                },
                {
                    icon: "align-center",
                    altText: "iconAltTextAlignCenter",
                    value: "center"
                },
                {
                    icon: "align-right",
                    altText: "iconAltTextAlignRight",
                    value: "right"
                }
            ],
            value: alignment,
            onChange: onChange
        });
    }
};
// packages/ag-charts-enterprise/src/features/annotations/utils/axis.ts
function $2fb96651e8aa1522$var$calculateAxisLabelPadding(axisLayout) {
    return axisLayout.gridPadding + axisLayout.seriesAreaPadding + axisLayout.tickSize + axisLayout.label.spacing;
}
// packages/ag-charts-enterprise/src/features/annotations/utils/update.ts
function $2fb96651e8aa1522$var$updateAnnotation(node, datum, context) {
    for (const { update: update } of Object.values($2fb96651e8aa1522$var$annotationConfigs))update(node, datum, context);
}
// packages/ag-charts-enterprise/src/features/annotations/annotations.ts
var { ChartUpdateType: $2fb96651e8aa1522$var$ChartUpdateType, InteractionState: $2fb96651e8aa1522$var$InteractionState2, ObserveChanges: $2fb96651e8aa1522$var$ObserveChanges2, PropertiesArray: $2fb96651e8aa1522$var$PropertiesArray3, Property: $2fb96651e8aa1522$var$Property33, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection10, Vec2: $2fb96651e8aa1522$var$Vec219, keyProperty: $2fb96651e8aa1522$var$keyProperty, valueProperty: $2fb96651e8aa1522$var$valueProperty, Selection: $2fb96651e8aa1522$var$Selection3, BBox: $2fb96651e8aa1522$var$BBox3 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$_Annotations = class _Annotations extends (0, $iTJTu._ModuleSupport).BaseModuleInstance {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.enabled = true;
        this.toolbar = new $2fb96651e8aa1522$var$AnnotationsToolbar(this.ctx);
        this.optionsToolbar = new $2fb96651e8aa1522$var$AnnotationOptionsToolbar(this.ctx, ()=>{
            const active = this.state.getActive();
            if (active == null) return;
            return $2fb96651e8aa1522$var$getTypedDatum(this.annotationData.at(active));
        });
        this.axesButtons = new $2fb96651e8aa1522$var$AxesButtons();
        this.snap = false;
        // Hidden options for use with measurer statistics
        this.data = void 0;
        this.xKey = void 0;
        this.volumeKey = void 0;
        this.annotationData = new $2fb96651e8aa1522$var$PropertiesArray3(_Annotations.createAnnotationDatum);
        this.defaults = new $2fb96651e8aa1522$var$AnnotationDefaults();
        this.container = new (0, $iTJTu._ModuleSupport).Group({
            name: "static-annotations"
        });
        this.annotations = new $2fb96651e8aa1522$var$Selection3(this.container, this.createAnnotationScene.bind(this));
        this.settingsDialog = new $2fb96651e8aa1522$var$AnnotationSettingsDialog(this.ctx);
        this.textInput = new $2fb96651e8aa1522$var$TextInput(this.ctx);
        this.postUpdateFns = [];
        this.state = this.setupStateMachine();
        this.setupListeners();
        this.setupDOM();
        this.ctx.historyManager.addMementoOriginator(ctx.annotationManager);
        this.ctx.historyManager.addMementoOriginator(this.defaults);
        this.textInput.setKeyDownHandler(this.onTextInput.bind(this));
    }
    setupStateMachine() {
        const { ctx: ctx } = this;
        return new $2fb96651e8aa1522$var$AnnotationsStateMachine({
            resetToIdle: ()=>{
                ctx.domManager.updateCursor("annotations");
                this.popAnnotationState($2fb96651e8aa1522$var$InteractionState2.Annotations);
                this.hideOverlays();
                this.optionsToolbar.hide();
                this.deleteEphemeralAnnotations();
                this.update();
            },
            hoverAtCoords: (coords, active, previousHovered)=>{
                let hovered;
                this.annotations.each((annotation, _, index)=>{
                    const contains = annotation.containsPoint(coords.x, coords.y);
                    if (contains) hovered ?? (hovered = index);
                    annotation.toggleHovered(contains || active === index);
                });
                if (hovered != null) ctx.tooltipManager.suppressTooltip("annotations");
                else if (!this.isAnnotationState()) ctx.tooltipManager.unsuppressTooltip("annotations");
                this.ctx.domManager.updateCursor("annotations", hovered == null ? void 0 : this.annotations.at(hovered)?.getCursor());
                if (hovered !== previousHovered) this.update();
                return hovered;
            },
            getNodeAtCoords: (coords, active)=>{
                const node = this.annotations.at(active);
                if (!node) return;
                return node.getNodeAtCoords(coords.x, coords.y);
            },
            translate: (index, translation)=>{
                const node = this.annotations.at(index);
                const datum = $2fb96651e8aa1522$var$getTypedDatum(this.annotationData.at(index));
                if (!node || !datum) return;
                return this.translateNode(node, datum, translation);
            },
            copy: (index)=>{
                const node = this.annotations.at(index);
                const datum = $2fb96651e8aa1522$var$getTypedDatum(this.annotationData.at(index));
                if (!node || !datum) return;
                return this.createAnnotationDatumCopy(node, datum);
            },
            paste: (datum)=>{
                this.createAnnotation(datum.type, datum, false);
                this.postUpdateFns.push(()=>{
                    this.state.transitionAsync("selectLast");
                    this.state.transitionAsync("copy");
                });
            },
            select: (index, previous)=>{
                const { annotations: annotations, optionsToolbar: optionsToolbar2, toolbar: toolbar2 } = this;
                this.hideOverlays();
                toolbar2.clearActiveButton();
                toolbar2.resetButtonIcons();
                const selectedNode = index != null ? annotations.at(index) : null;
                const previousNode = previous != null ? annotations.at(previous) : null;
                if (previousNode === selectedNode && selectedNode != null) return;
                previousNode?.toggleActive(false);
                optionsToolbar2.hide();
                if (selectedNode) {
                    this.pushAnnotationState($2fb96651e8aa1522$var$InteractionState2.AnnotationsSelected);
                    selectedNode.toggleActive(true);
                    optionsToolbar2.updateButtons(this.annotationData.at(index));
                    this.postUpdateFns.push(()=>{
                        optionsToolbar2.show();
                        optionsToolbar2.setAnchorScene(selectedNode);
                    });
                } else {
                    this.popAnnotationState($2fb96651e8aa1522$var$InteractionState2.AnnotationsSelected);
                    this.popAnnotationState($2fb96651e8aa1522$var$InteractionState2.Annotations);
                }
                this.deleteEphemeralAnnotations();
                this.update();
            },
            selectLast: ()=>{
                this.pushAnnotationState($2fb96651e8aa1522$var$InteractionState2.AnnotationsSelected);
                return this.annotationData.length - 1;
            },
            startInteracting: ()=>{
                this.pushAnnotationState($2fb96651e8aa1522$var$InteractionState2.Annotations);
            },
            stopInteracting: ()=>{
                this.popAnnotationState($2fb96651e8aa1522$var$InteractionState2.Annotations);
            },
            create: (type, datum)=>{
                this.createAnnotation(type, datum);
            },
            delete: (index)=>{
                this.annotationData.splice(index, 1);
            },
            deleteAll: ()=>{
                this.annotationData.splice(0, this.annotationData.length);
            },
            validatePoint: (point, options)=>{
                const context = this.getAnnotationContext();
                return context ? $2fb96651e8aa1522$var$validateDatumPoint(context, point, options) : true;
            },
            getAnnotationType: (index)=>{
                return $2fb96651e8aa1522$var$stringToAnnotationType(this.annotationData[index].type);
            },
            datum: (index)=>{
                return this.annotationData.at(index);
            },
            node: (index)=>{
                return this.annotations.at(index);
            },
            recordAction: (label)=>{
                this.recordActionAfterNextUpdate(label);
            },
            update: ()=>{
                this.postUpdateFns.push(()=>{
                    const active = this.state.getActive();
                    const node = active != null ? this.annotations.at(active) : null;
                    if (node == null) return;
                    this.optionsToolbar.setAnchorScene(node);
                });
                this.update();
            },
            showTextInput: (active)=>{
                const datum = $2fb96651e8aa1522$var$getTypedDatum(this.annotationData.at(active));
                const node = this.annotations.at(active);
                if (!node || !datum || !("getTextInputCoords" in datum) || !("getTextPosition" in datum)) return;
                const styles = {
                    color: datum.color,
                    fontFamily: datum.fontFamily,
                    fontSize: datum.fontSize,
                    fontStyle: datum.fontStyle,
                    fontWeight: datum.fontWeight,
                    placeholderColor: datum.getPlaceholderColor()
                };
                const context = this.getAnnotationContext();
                const getTextInputCoords = (height)=>$2fb96651e8aa1522$var$Vec219.add(datum.getTextInputCoords(context, height), $2fb96651e8aa1522$var$Vec219.required(this.seriesRect));
                const getTextPosition = ()=>datum.getTextPosition();
                this.textInput.show({
                    styles: styles,
                    layout: {
                        getTextInputCoords: getTextInputCoords,
                        getTextPosition: getTextPosition,
                        alignment: datum.alignment,
                        textAlign: datum.textAlign,
                        width: datum.width
                    },
                    text: datum.text,
                    placeholderText: datum.placeholderText,
                    onChange: (_text, bbox)=>{
                        this.state.transition("updateTextInputBBox", bbox);
                    }
                });
                this.ctx.domManager.updateCursor("annotations");
            },
            hideTextInput: ()=>{
                this.textInput.hide();
            },
            updateTextInputColor: (color6)=>{
                this.textInput.updateColor(color6);
            },
            updateTextInputFontSize: (fontSize)=>{
                const bbox = this.textInput.updateFontSize(fontSize);
                this.state.transition("updateTextInputBBox", bbox);
            },
            updateTextInputBBox: (bbox)=>{
                this.state.transition("updateTextInputBBox", bbox);
            },
            showAnnotationOptions: (active)=>{
                const node = this.annotations.at(active);
                if (!node || $2fb96651e8aa1522$var$isEphemeralType(this.annotationData.at(active))) return;
                this.optionsToolbar.updateButtons(this.annotationData.at(active));
                this.optionsToolbar.show();
                this.optionsToolbar.setAnchorScene(node);
            },
            showAnnotationSettings: (active, sourceEvent, initialTab = "line")=>{
                const datum = this.annotationData.at(active);
                if (!$2fb96651e8aa1522$var$isLineType(datum) && !$2fb96651e8aa1522$var$isChannelType(datum) && !$2fb96651e8aa1522$var$isMeasurerType(datum)) return;
                if ($2fb96651e8aa1522$var$isEphemeralType(datum)) return;
                const onChangeColor = (colorType)=>(colorOpacity, color6, opacity, isMultiColor)=>{
                        this.setColorAndDefault(datum.type, colorType, colorOpacity, color6, opacity, isMultiColor);
                        this.optionsToolbar.updateColorPickerColor(colorType, color6, opacity, isMultiColor);
                    };
                const onChangeHideColor = (colorType)=>()=>{
                        this.recordActionAfterNextUpdate(`Change ${datum.type} ${colorType} to ${datum.getDefaultColor(colorType)}`, [
                            "annotations",
                            "defaults"
                        ]);
                        this.update();
                    };
                const options = {
                    initialSelectedTab: initialTab,
                    ariaLabel: this.ctx.localeManager.t("ariaLabelAnnotationSettingsDialog"),
                    sourceEvent: sourceEvent,
                    onChangeLine: (props)=>{
                        this.state.transition("lineProps", props);
                        if (props.bands != null) this.defaults.setDefaultFibonacciOptions(datum.type, "bands", props.bands);
                        if (props.reverse != null) this.defaults.setDefaultFibonacciOptions(datum.type, "reverse", props.reverse);
                        if (props.showFill != null) this.defaults.setDefaultFibonacciOptions(datum.type, "showFill", props.showFill);
                    },
                    onChangeText: (props)=>{
                        this.state.transition("lineText", props);
                        if (props.alignment) this.defaults.setDefaultLineTextAlignment(datum.type, props.alignment);
                        if (props.position) this.defaults.setDefaultLineTextPosition(datum.type, props.position);
                        this.recordActionAfterNextUpdate(`Change ${datum.type} text ${Object.keys(props).map((key)=>`${key} to ${props[key]}`).join(", ")}`);
                    },
                    onChangeFillColor: onChangeColor("fill-color"),
                    onChangeHideFillColor: onChangeHideColor("fill-color"),
                    onChangeLineColor: onChangeColor("line-color"),
                    onChangeHideLineColor: onChangeHideColor("line-color"),
                    onChangeLineStyleType: (lineStyleType)=>{
                        this.setLineStyleTypeAndDefault(datum.type, lineStyleType);
                        this.optionsToolbar.updateLineStyleType($2fb96651e8aa1522$var$LINE_STYLE_TYPE_ITEMS.find((item)=>item.value === lineStyleType) ?? $2fb96651e8aa1522$var$LINE_STYLE_TYPE_ITEMS[0]);
                    },
                    onChangeLineStyleWidth: (strokeWidth)=>{
                        this.setLineStyleWidthAndDefault(datum.type, strokeWidth);
                        this.optionsToolbar.updateStrokeWidth({
                            strokeWidth: strokeWidth,
                            value: strokeWidth,
                            label: String(strokeWidth)
                        });
                    },
                    onChangeTextColor: onChangeColor("text-color"),
                    onChangeHideTextColor: onChangeHideColor("text-color"),
                    onChangeTextFontSize: (fontSize)=>{
                        this.setFontSizeAndDefault(datum.type, fontSize);
                    }
                };
                this.settingsDialog.show(datum, options);
            }
        });
    }
    setupListeners() {
        const { ctx: ctx, optionsToolbar: optionsToolbar2, settingsDialog: settingsDialog, toolbar: toolbar2 } = this;
        const { seriesWidget: seriesWidget, seriesDragInterpreter: seriesDragInterpreter, chartWidget: chartWidget } = ctx.widgets;
        this.destroyFns.push(// Interactions
        seriesDragInterpreter.addListener("click", this.hoverTouchPreHandler.bind(this)), seriesDragInterpreter.addListener("drag-start", this.hoverTouchPreHandler.bind(this)), seriesDragInterpreter.addListener("drag-move", this.dragMoveTouchPreHandler.bind(this)), seriesDragInterpreter.addListener("mousemove", this.onHover.bind(this)), seriesDragInterpreter.addListener("click", this.onClick.bind(this)), seriesDragInterpreter.addListener("dblclick", this.onDoubleClick.bind(this)), seriesDragInterpreter.addListener("drag-start", this.onDragStart.bind(this)), seriesDragInterpreter.addListener("drag-move", this.onDrag.bind(this)), seriesDragInterpreter.addListener("drag-end", this.onDragEnd.bind(this)), seriesWidget.addListener("keydown", this.onKeyDown.bind(this)), seriesWidget.addListener("keyup", this.onKeyUp.bind(this)), chartWidget.addListener("click", this.onCancel.bind(this)), // Services
        ctx.annotationManager.addListener("restore-annotations", this.onRestoreAnnotations.bind(this)), ctx.layoutManager.addListener("layout:complete", this.onLayoutComplete.bind(this)), ctx.updateService.addListener("pre-scene-render", this.onPreRender.bind(this)), ctx.zoomManager.addListener("zoom-change", ()=>this.onResize()), ctx.domManager.addListener("resize", ()=>this.onResize()), // Toolbar
        toolbar2.addListener("cancel-create-annotation", ()=>{
            this.cancel();
            this.reset();
            this.update();
        }), toolbar2.addListener("pressed-create-annotation", ({ annotation: annotation })=>{
            this.cancel();
            this.pushAnnotationState($2fb96651e8aa1522$var$InteractionState2.Annotations);
            this.state.transition(annotation);
            this.update();
        }), toolbar2.addListener("pressed-clear", ()=>{
            this.clear();
            this.recordActionAfterNextUpdate("Clear all");
        }), toolbar2.addListener("pressed-show-menu", ()=>{
            this.cancel();
            this.reset();
        }), toolbar2.addListener("pressed-unrelated", ()=>{
            this.reset();
        }), // Annotation Options Toolbar
        optionsToolbar2.addListener("pressed-delete", ()=>{
            this.cancel();
            this.delete();
            this.reset();
        }), optionsToolbar2.addListener("pressed-settings", ({ sourceEvent: sourceEvent })=>{
            this.state.transition("toolbarPressSettings", sourceEvent);
        }), optionsToolbar2.addListener("pressed-lock", ()=>{
            this.update();
        }), optionsToolbar2.addListener("hid-overlays", ()=>{
            this.settingsDialog.hide();
        }), optionsToolbar2.addListener("saved-color", ({ type: type, colorPickerType: colorPickerType, color: color6 })=>{
            this.recordActionAfterNextUpdate(`Change ${type} ${colorPickerType} to ${color6}`, [
                "annotations",
                "defaults"
            ]);
        }), optionsToolbar2.addListener("updated-color", ({ type: type, colorPickerType: colorPickerType, colorOpacity: colorOpacity, color: color6, opacity: opacity, isMultiColor: isMultiColor })=>{
            this.setColorAndDefault(type, colorPickerType, colorOpacity, color6, opacity, isMultiColor);
        }), optionsToolbar2.addListener("updated-font-size", ({ type: type, fontSize: fontSize })=>{
            this.setFontSizeAndDefault(type, fontSize);
        }), optionsToolbar2.addListener("updated-line-style", ({ type: type, lineStyleType: lineStyleType })=>{
            this.setLineStyleTypeAndDefault(type, lineStyleType);
        }), optionsToolbar2.addListener("updated-line-width", ({ type: type, strokeWidth: strokeWidth })=>{
            this.setLineStyleWidthAndDefault(type, strokeWidth);
        }), // Settings Dialog
        settingsDialog.addListener("hidden", ()=>{
            this.optionsToolbar.clearActiveButton();
        }));
    }
    setupDOM() {
        const { ctx: ctx, toolbar: toolbar2 } = this;
        this.destroyFns.push(// DOM
        ctx.annotationManager.attachNode(this.container), ()=>ctx.domManager.removeStyles($2fb96651e8aa1522$var$DEFAULT_ANNOTATION_AXIS_BUTTON_CLASS), ()=>toolbar2.destroy());
    }
    async processData(dataController) {
        if (!this.enabled || this.data == null || this.xKey == null || this.volumeKey == null) return;
        const props = [
            $2fb96651e8aa1522$var$keyProperty(this.xKey, void 0, {
                id: "date"
            }),
            $2fb96651e8aa1522$var$valueProperty(this.volumeKey, "number", {
                id: "volume"
            })
        ];
        const { dataModel: dataModel, processedData: processedData } = await dataController.request("annotations", this.data, {
            props: props
        });
        this.dataModel = dataModel;
        this.processedData = processedData;
    }
    /**
   * Create an annotation scene within the `this.annotations` scene selection. This method is automatically called by
   * the selection when a new scene is required.
   */ createAnnotationScene(datum) {
        if (datum.type in $2fb96651e8aa1522$var$annotationConfigs) return new $2fb96651e8aa1522$var$annotationConfigs[datum.type].scene();
        throw new Error(`AG Charts - Cannot create annotation scene of type [${datum.type}], expected one of [${Object.keys($2fb96651e8aa1522$var$annotationConfigs)}], ignoring.`);
    }
    /**
   * Create an annotation datum within the `this.annotationData` properties array. It is created as an instance
   * of `AnnotationProperties` from the given config for its type. This method is only called when annotations
   * are added from the initial state.
   */ static createAnnotationDatum(params) {
        if (params.type in $2fb96651e8aa1522$var$annotationConfigs) return new $2fb96651e8aa1522$var$annotationConfigs[params.type].datum().set(params);
        throw new Error(`AG Charts - Cannot create annotation datum of unknown type [${params.type}], expected one of [${Object.keys($2fb96651e8aa1522$var$annotationConfigs)}], ignoring.`);
    }
    /**
   * Append an annotation datum to `this.annotationData`, applying default styles. This method is called when a user
   * interacts with the chart to draw their own annotations.
   */ createAnnotation(type, datum, applyDefaults = true) {
        this.annotationData.push(datum);
        if (applyDefaults) {
            const styles = this.ctx.annotationManager.getAnnotationTypeStyles(type);
            if (styles) datum.set(styles);
            this.defaults.applyDefaults(datum);
        }
        this.injectDatumDependencies(datum);
        this.update();
    }
    injectDatumDependencies(datum) {
        if ("setLocaleManager" in datum) datum.setLocaleManager(this.ctx.localeManager);
        if ("getVolume" in datum) datum.getVolume = this.getDatumRangeVolume.bind(this);
    }
    getDatumRangeVolume(fromPoint, toPoint) {
        const { dataModel: dataModel, processedData: processedData } = this;
        let from = $2fb96651e8aa1522$var$getGroupingValue(fromPoint);
        let to = $2fb96651e8aa1522$var$getGroupingValue(toPoint);
        if (!(0, $idDdm.isValidDate)(from) || !(0, $idDdm.isValidDate)(to) || !dataModel || !processedData || this.volumeKey == null) return;
        if (from > to) [from, to] = [
            to,
            from
        ];
        const dateValues = dataModel.resolveKeysById({
            id: "annotations"
        }, "date", processedData);
        const volumeValues = dataModel.resolveColumnById({
            id: "annotations"
        }, "volume", processedData);
        let sum = 0;
        for(let datumIndex = 0; datumIndex < processedData.input.count; datumIndex++){
            const key = dateValues[datumIndex];
            if ((0, $idDdm.isValidDate)(key) && key >= from && key <= to) sum += volumeValues[datumIndex];
        }
        return sum;
    }
    translateNode(node, datum, translation) {
        const config = this.getAnnotationConfig(datum);
        const context = this.getAnnotationContext();
        if (!context) return;
        config.translate(node, datum, translation, context);
    }
    createAnnotationDatumCopy(node, datum) {
        const config = this.getAnnotationConfig(datum);
        const newDatum = new config.datum();
        newDatum.set(datum.toJson());
        const context = this.getAnnotationContext();
        if (!context) return;
        return config.copy(node, datum, newDatum, context);
    }
    getAnnotationConfig(datum) {
        if (datum.type in $2fb96651e8aa1522$var$annotationConfigs) return $2fb96651e8aa1522$var$annotationConfigs[datum.type];
        throw new Error(`AG Charts - Cannot get annotation config of unknown type [${datum.type}], expected one of [${Object.keys($2fb96651e8aa1522$var$annotationConfigs)}], ignoring.`);
    }
    onRestoreAnnotations(event) {
        if (!this.enabled) return;
        this.clear();
        this.annotationData.set(event.annotations);
        this.postUpdateFns.push(()=>{
            this.ctx.annotationManager.fireChangedEvent();
        });
        this.update();
    }
    onLayoutComplete(event) {
        const seriesRect = event.series.paddedRect;
        this.seriesRect = seriesRect;
        this.container.setClipRect(seriesRect);
        for (const axisLayout of event.axes ?? [])if (axisLayout.direction === (0, $iTJTu._ModuleSupport).ChartAxisDirection.X) this.xAxis = this.getAxis(axisLayout, seriesRect, this.xAxis?.button);
        else this.yAxis = this.getAxis(axisLayout, seriesRect, this.yAxis?.button);
        if (this.showAnnotations()) this.animateAnnotations({
            from: 0,
            to: 1,
            phase: "trailing"
        });
        else this.animateAnnotations({
            from: 1,
            to: 0,
            phase: "remove"
        });
    }
    showAnnotations() {
        if (!this.yAxis || !this.xAxis) return false;
        const hasData = this.ctx.chartService.series.some((s)=>s.hasData);
        const seriesIds = this.yAxis.context.seriesIds();
        const anyBoundSeriesVisible = seriesIds.some((id)=>{
            const series = this.ctx.chartService.series.find((s)=>s.id === id);
            return series?.visible;
        });
        return hasData && anyBoundSeriesVisible;
    }
    animateAnnotations({ from: from, to: to, phase: phase }) {
        const { annotations: annotations } = this;
        this.ctx.animationManager?.animate({
            from: from,
            to: to,
            id: "chart-annotations",
            phase: phase,
            groupId: "opacity",
            onUpdate (value) {
                annotations.each((node)=>{
                    node.opacity = value;
                    if ("setAxisLabelOpacity" in node) node.setAxisLabelOpacity(value);
                });
            },
            onStop () {
                annotations.each((node)=>{
                    node.opacity = to;
                    if ("setAxisLabelOpacity" in node) node.setAxisLabelOpacity(to);
                });
            }
        });
    }
    onPreRender() {
        this.updateAnnotations();
        this.state.transition("render");
    }
    getAxis(axisLayout, seriesRect, button) {
        const axisCtx = this.ctx.axisManager.getAxisContext(axisLayout.direction)[0];
        const { position: axisPosition = "bottom", direction: direction } = axisCtx;
        const padding = axisLayout.gridPadding + axisLayout.seriesAreaPadding;
        const bounds = new $2fb96651e8aa1522$var$BBox3(0, 0, seriesRect.width, seriesRect.height).grow(padding, axisPosition);
        const lineDirection = axisCtx.direction === $2fb96651e8aa1522$var$ChartAxisDirection10.X ? "vertical" : "horizontal";
        const { axesButtons: axesButtons, snap: snap } = this;
        const buttonEnabled = this.enabled && axesButtons.enabled && (axesButtons.axes === "xy" || axesButtons.axes === direction);
        if (buttonEnabled) {
            button ?? (button = new $2fb96651e8aa1522$var$AxisButton(this.ctx, {
                ...axisCtx,
                snapToGroup: snap
            }, (coords)=>this.onAxisButtonClick(coords, lineDirection), seriesRect));
            const axisLabelPadding = $2fb96651e8aa1522$var$calculateAxisLabelPadding(axisLayout);
            button.update(seriesRect, axisLabelPadding);
        } else {
            button?.destroy();
            button = void 0;
        }
        return {
            layout: axisLayout,
            context: axisCtx,
            bounds: bounds,
            button: button
        };
    }
    recordActionAfterNextUpdate(label, types = [
        "annotations"
    ]) {
        const { defaults: defaults, ctx: { annotationManager: annotationManager, historyManager: historyManager } } = this;
        const originators = types.map((type)=>type === "defaults" ? defaults : annotationManager);
        this.postUpdateFns.push(()=>{
            historyManager.record(label, ...originators);
            annotationManager.fireChangedEvent();
        });
    }
    setColorAndDefault(datumType, colorPickerType, colorOpacity, color6, opacity, isMultiColor) {
        this.state.transition("color", {
            colorPickerType: colorPickerType,
            colorOpacity: colorOpacity,
            color: color6,
            opacity: opacity,
            isMultiColor: isMultiColor
        });
        this.defaults.setDefaultColor(datumType, colorPickerType, colorOpacity, color6, opacity, isMultiColor);
    }
    setFontSizeAndDefault(datumType, fontSize) {
        this.state.transition("fontSize", fontSize);
        this.defaults.setDefaultFontSize(datumType, fontSize);
        this.recordActionAfterNextUpdate(`Change ${datumType} font size to ${fontSize}`, [
            "annotations",
            "defaults"
        ]);
    }
    setLineStyleTypeAndDefault(datumType, styleType) {
        this.state.transition("lineStyle", {
            type: styleType
        });
        this.defaults.setDefaultLineStyleType(datumType, styleType);
        this.recordActionAfterNextUpdate(`Change ${datumType} line style to ${styleType}`, [
            "annotations",
            "defaults"
        ]);
    }
    setLineStyleWidthAndDefault(datumType, strokeWidth) {
        this.state.transition("lineStyle", {
            strokeWidth: strokeWidth
        });
        this.defaults.setDefaultLineStyleWidth(datumType, strokeWidth);
        this.recordActionAfterNextUpdate(`Change ${datumType} stroke width to ${strokeWidth}`, [
            "annotations",
            "defaults"
        ]);
    }
    updateAnnotations() {
        const { annotationData: annotationData, annotations: annotations, seriesRect: seriesRect, ctx: { annotationManager: annotationManager } } = this;
        const context = this.getAnnotationContext();
        if (!seriesRect || !context) return;
        annotationManager.updateData(annotationData.toJson().filter((datum)=>!$2fb96651e8aa1522$var$isEphemeralType(datum)));
        const showAnnotations = this.showAnnotations();
        this.toolbar.refreshButtonsEnabled(showAnnotations);
        this.toolbar.toggleClearButtonEnabled(annotationData.length > 0 && showAnnotations);
        annotations.update(annotationData ?? [], void 0, (datum)=>datum.id).each((node, datum)=>{
            if (!showAnnotations) {
                node.visible = false;
                if ("setAxisLabelVisible" in node) node.setAxisLabelVisible(false);
                return;
            }
            if ("setAxisLabelVisible" in node) node.setAxisLabelVisible(true);
            this.injectDatumDependencies(datum);
            $2fb96651e8aa1522$var$updateAnnotation(node, datum, context);
        });
        this.postUpdateFns.forEach((fn)=>fn());
        this.postUpdateFns = [];
    }
    getAnnotationContext() {
        const { seriesRect: seriesRect, xAxis: xAxis, yAxis: yAxis, snap: snap } = this;
        if (!(seriesRect && xAxis && yAxis)) return;
        return {
            seriesRect: seriesRect,
            xAxis: {
                ...xAxis.context,
                bounds: xAxis.bounds,
                labelPadding: $2fb96651e8aa1522$var$calculateAxisLabelPadding(xAxis.layout),
                snapToGroup: snap
            },
            yAxis: {
                ...yAxis.context,
                bounds: yAxis.bounds,
                labelPadding: $2fb96651e8aa1522$var$calculateAxisLabelPadding(xAxis.layout),
                snapToGroup: snap
            }
        };
    }
    onHover(event) {
        const { state: state } = this;
        const context = this.getAnnotationContext();
        if (!context) return;
        const shiftKey = event.sourceEvent.shiftKey;
        const offset = $2fb96651e8aa1522$var$Vec219.from(event);
        const point = $2fb96651e8aa1522$var$invertCoords(offset, context);
        state.transition("hover", {
            offset: offset,
            point: point,
            shiftKey: shiftKey,
            context: context
        });
    }
    onClick(event) {
        const { state: state } = this;
        const context = this.getAnnotationContext();
        if (!context) return;
        const shiftKey = event.sourceEvent.shiftKey;
        const point = $2fb96651e8aa1522$var$invertCoords($2fb96651e8aa1522$var$Vec219.from(event), context);
        const textInputValue = this.textInput.getValue();
        const bbox = this.textInput.getBBox();
        state.transition("click", {
            point: point,
            shiftKey: shiftKey,
            textInputValue: textInputValue,
            bbox: bbox
        });
    }
    onDoubleClick(event) {
        const { state: state } = this;
        const context = this.getAnnotationContext();
        if (!context) return;
        const offset = $2fb96651e8aa1522$var$Vec219.from(event);
        state.transition("dblclick", {
            offset: offset
        });
    }
    onAxisButtonClick(coords, direction) {
        this.cancel();
        this.reset();
        const context = this.getAnnotationContext();
        if (!this.annotationData || !context) return;
        const { state: state } = this;
        this.pushAnnotationState($2fb96651e8aa1522$var$InteractionState2.Annotations);
        const isHorizontal = direction === "horizontal";
        state.transition(isHorizontal ? "horizontal-line" /* HorizontalLine */  : "vertical-line" /* VerticalLine */ );
        this.optionsToolbar.hide();
        if (!coords) return;
        const point = $2fb96651e8aa1522$var$invertCoords(coords, context);
        if (!$2fb96651e8aa1522$var$validateDatumPoint(context, point)) return;
        state.transition("click", {
            point: point,
            shiftKey: false
        });
        this.update();
    }
    onResize() {
        const textInputValue = this.textInput.getValue();
        const bbox = this.textInput.getBBox();
        this.state.transition("resize", {
            textInputValue: textInputValue,
            bbox: bbox
        });
    }
    hoverTouchPreHandler(event) {
        if (event.device === "touch") this.onHover(event);
    }
    dragMoveTouchPreHandler(event) {
        if (event.device === "touch" && this.ctx.interactionManager.isState($2fb96651e8aa1522$var$InteractionState2.AnnotationsSelected)) event.sourceEvent.preventDefault();
    }
    onDragStart(event) {
        if (!this.ctx.interactionManager.isState($2fb96651e8aa1522$var$InteractionState2.AnnotationsDraggable)) return;
        const context = this.getAnnotationContext();
        if (!context) return;
        const offset = $2fb96651e8aa1522$var$Vec219.from(event);
        const point = $2fb96651e8aa1522$var$invertCoords(offset, context);
        const textInputValue = this.textInput.getValue();
        const bbox = this.textInput.getBBox();
        this.state.transition("dragStart", {
            context: context,
            offset: offset,
            point: point,
            textInputValue: textInputValue,
            bbox: bbox
        });
    }
    onDrag(event) {
        if (!this.ctx.interactionManager.isState($2fb96651e8aa1522$var$InteractionState2.AnnotationsDraggable)) return;
        const context = this.getAnnotationContext();
        if (!context) return;
        const offset = $2fb96651e8aa1522$var$Vec219.from(event);
        const point = $2fb96651e8aa1522$var$invertCoords(offset, context);
        const shiftKey = event.sourceEvent.shiftKey;
        const textInputValue = this.textInput.getValue();
        const bbox = this.textInput.getBBox();
        this.state.transition("drag", {
            context: context,
            offset: offset,
            point: point,
            shiftKey: shiftKey,
            textInputValue: textInputValue,
            bbox: bbox
        });
    }
    onDragEnd() {
        this.state.transition("dragEnd");
    }
    onCancel(widgetEvent) {
        const { sourceEvent: sourceEvent } = widgetEvent ?? {};
        if (sourceEvent?.currentTarget !== sourceEvent?.target) return;
        this.cancel();
        this.reset();
    }
    onDelete() {
        if (this.textInput.isVisible()) return;
        this.cancel();
        this.delete();
        this.reset();
        this.update();
    }
    onTextInput(event) {
        const { state: state } = this;
        const context = this.getAnnotationContext();
        if (!context) return;
        const { key: key, shiftKey: shiftKey } = event;
        const textInputValue = this.textInput.getValue();
        const bbox = this.textInput.getBBox();
        state.transition("textInput", {
            key: key,
            shiftKey: shiftKey,
            textInputValue: textInputValue,
            bbox: bbox,
            context: context
        });
    }
    onKeyDown(event) {
        const { state: state } = this;
        const context = this.getAnnotationContext();
        if (!context) return;
        const { sourceEvent: sourceEvent } = event;
        const { shiftKey: shiftKey, ctrlKey: ctrlKey, metaKey: metaKey } = sourceEvent;
        const ctrlMeta = ctrlKey || metaKey;
        const ctrlShift = ctrlKey || shiftKey;
        state.transition("keyDown", {
            shiftKey: shiftKey,
            context: context
        });
        const translation = {
            x: 0,
            y: 0
        };
        const xStep = Math.max(context?.xAxis.scale.bandwidth ?? 0, ctrlShift ? 10 : 1);
        const yStep = Math.max(context?.yAxis.scale.bandwidth ?? 0, ctrlShift ? 10 : 1);
        switch(sourceEvent.key){
            case "ArrowDown":
                translation.y = yStep;
                break;
            case "ArrowUp":
                translation.y = -yStep;
                break;
            case "ArrowLeft":
                translation.x = -xStep;
                break;
            case "ArrowRight":
                translation.x = xStep;
                break;
            case "Escape":
                this.onCancel();
                return;
            case "Backspace":
            case "Delete":
                this.onDelete();
                return;
        }
        if (translation.x || translation.y) {
            state.transition("translate", {
                translation: translation
            });
            sourceEvent.stopPropagation();
            sourceEvent.preventDefault();
        }
        if (!ctrlMeta) return;
        switch(sourceEvent.key){
            case "c":
                state.transition("copy");
                return;
            case "x":
                state.transition("cut");
                this.recordActionAfterNextUpdate("Cut annotation");
                return;
            case "v":
                state.transition("paste");
                this.recordActionAfterNextUpdate("Paste annotation");
                return;
        }
    }
    onKeyUp(event) {
        const { shiftKey: shiftKey } = event.sourceEvent;
        const context = this.getAnnotationContext();
        if (!context) return;
        this.state.transition("keyUp", {
            shiftKey: shiftKey,
            context: context
        });
        this.state.transition("translateEnd");
    }
    clear() {
        this.cancel();
        this.deleteAll();
        this.reset();
    }
    reset() {
        this.state.transition("reset");
    }
    cancel() {
        this.state.transition("cancel");
    }
    delete() {
        this.state.transition("delete");
    }
    deleteAll() {
        this.state.transition("deleteAll");
    }
    deleteEphemeralAnnotations() {
        for (const [index, datum] of this.annotationData.entries())if ($2fb96651e8aa1522$var$isEphemeralType(datum)) this.annotationData.splice(index, 1);
    }
    hideOverlays() {
        this.settingsDialog.hide();
        this.toolbar.hideOverlays();
        this.optionsToolbar.hideOverlays();
    }
    pushAnnotationState(state) {
        this.ctx.interactionManager.pushState(state);
        this.ctx.tooltipManager.suppressTooltip("annotations");
    }
    popAnnotationState(state) {
        this.ctx.interactionManager.popState(state);
        this.ctx.tooltipManager.unsuppressTooltip("annotations");
    }
    isAnnotationState() {
        return this.ctx.interactionManager.isState($2fb96651e8aa1522$var$InteractionState2.Annotations) || this.ctx.interactionManager.isState($2fb96651e8aa1522$var$InteractionState2.AnnotationsSelected);
    }
    update(status = $2fb96651e8aa1522$var$ChartUpdateType.PRE_SCENE_RENDER) {
        this.ctx.updateService.update(status);
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ObserveChanges2((target, newValue, oldValue)=>{
        const { ctx: { annotationManager: annotationManager, stateManager: stateManager } } = target;
        if (newValue === oldValue) return;
        target.toolbar?.toggleVisibility(Boolean(newValue));
        if (oldValue === false && newValue === true) stateManager.restoreState(annotationManager);
        else if (newValue === false) target.clear();
    }),
    $2fb96651e8aa1522$var$Property33
], $2fb96651e8aa1522$var$_Annotations.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property33
], $2fb96651e8aa1522$var$_Annotations.prototype, "toolbar", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property33
], $2fb96651e8aa1522$var$_Annotations.prototype, "optionsToolbar", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property33
], $2fb96651e8aa1522$var$_Annotations.prototype, "axesButtons", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property33
], $2fb96651e8aa1522$var$_Annotations.prototype, "snap", 2);
var $2fb96651e8aa1522$var$Annotations = $2fb96651e8aa1522$var$_Annotations;
var { FONT_SIZE_RATIO: $2fb96651e8aa1522$var$FONT_SIZE_RATIO, ThemeSymbols: $2fb96651e8aa1522$var$ThemeSymbols } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$stroke = {
    stroke: {
        $ref: "foregroundColor"
    },
    strokeOpacity: 1,
    strokeWidth: 2
};
var $2fb96651e8aa1522$var$handle = {
    fill: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_ANNOTATION_HANDLE_FILL,
    strokeOpacity: 1,
    strokeWidth: 2
};
var $2fb96651e8aa1522$var$font = {
    color: {
        $ref: "backgroundColor"
    },
    fontSize: {
        $rem: [
            $2fb96651e8aa1522$var$FONT_SIZE_RATIO.LARGE
        ]
    },
    fontFamily: {
        $ref: "fontFamily"
    }
};
var $2fb96651e8aa1522$var$axisLabel = {
    ...$2fb96651e8aa1522$var$font,
    enabled: true,
    fill: {
        $ref: "foregroundColor"
    },
    fontSize: {
        $ref: "fontSize"
    }
};
var $2fb96651e8aa1522$var$text = {
    ...$2fb96651e8aa1522$var$font,
    textAlign: "left"
};
var $2fb96651e8aa1522$var$lineText = {
    ...$2fb96651e8aa1522$var$font,
    position: "top",
    alignment: "center",
    color: {
        $ref: "textColor"
    }
};
var $2fb96651e8aa1522$var$channelText = {
    ...$2fb96651e8aa1522$var$font,
    position: "top",
    alignment: "center",
    color: {
        $ref: "textColor"
    }
};
var $2fb96651e8aa1522$var$measurerStatistics = {
    ...$2fb96651e8aa1522$var$font,
    fontSize: {
        $ref: "fontSize"
    },
    color: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_ANNOTATION_STATISTICS_COLOR,
    fill: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_ANNOTATION_STATISTICS_FILL,
    stroke: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_ANNOTATION_STATISTICS_STROKE,
    strokeWidth: 1,
    divider: {
        stroke: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_ANNOTATION_STATISTICS_DIVIDER_STROKE,
        strokeWidth: 1,
        strokeOpacity: 0.5
    }
};
var $2fb96651e8aa1522$var$measurer = {
    ...$2fb96651e8aa1522$var$stroke,
    background: {
        fill: {
            $ref: "foregroundColor"
        },
        fillOpacity: 0.075
    },
    handle: {
        ...$2fb96651e8aa1522$var$handle
    },
    text: {
        ...$2fb96651e8aa1522$var$lineText
    },
    statistics: {
        ...$2fb96651e8aa1522$var$measurerStatistics
    }
};
var $2fb96651e8aa1522$var$toolbar = {
    buttons: [
        {
            icon: "text-annotation",
            tooltip: "toolbarAnnotationsTextAnnotations",
            value: "text-menu"
        },
        {
            icon: "trend-line-drawing",
            tooltip: "toolbarAnnotationsLineAnnotations",
            value: "line-menu"
        },
        {
            icon: "arrow-drawing",
            tooltip: "toolbarAnnotationsShapeAnnotations",
            value: "shape-menu"
        },
        {
            icon: "delete",
            tooltip: "toolbarAnnotationsClearAll",
            value: "clear"
        }
    ],
    // @ts-expect-error undocumented option
    padding: {
        $ref: "padding"
    }
};
var $2fb96651e8aa1522$var$optionsToolbar = {
    buttons: [
        {
            icon: "text-annotation",
            tooltip: "toolbarAnnotationsTextColor",
            value: "text-color"
        },
        {
            icon: "line-color",
            tooltip: "toolbarAnnotationsLineColor",
            value: "line-color"
        },
        {
            icon: "fill-color",
            tooltip: "toolbarAnnotationsFillColor",
            value: "fill-color"
        },
        {
            tooltip: "toolbarAnnotationsTextSize",
            value: "text-size"
        },
        {
            tooltip: "toolbarAnnotationsLineStrokeWidth",
            value: "line-stroke-width"
        },
        {
            icon: "line-style-solid",
            tooltip: "toolbarAnnotationsLineStyle",
            value: "line-style-type"
        },
        {
            icon: "settings",
            tooltip: "toolbarAnnotationsSettings",
            value: "settings"
        },
        {
            icon: "unlocked",
            tooltip: "toolbarAnnotationsLock",
            ariaLabel: "toolbarAnnotationsLock",
            checkedOverrides: {
                icon: "locked",
                tooltip: "toolbarAnnotationsUnlock"
            },
            value: "lock"
        },
        {
            icon: "delete",
            tooltip: "toolbarAnnotationsDelete",
            value: "delete"
        }
    ]
};
var $2fb96651e8aa1522$var$annotationsTheme = {
    enabled: false,
    // Lines
    line: {
        ...$2fb96651e8aa1522$var$stroke,
        handle: {
            ...$2fb96651e8aa1522$var$handle
        },
        text: {
            ...$2fb96651e8aa1522$var$lineText
        }
    },
    "horizontal-line": {
        ...$2fb96651e8aa1522$var$stroke,
        handle: {
            ...$2fb96651e8aa1522$var$handle
        },
        axisLabel: {
            ...$2fb96651e8aa1522$var$axisLabel
        },
        text: {
            ...$2fb96651e8aa1522$var$lineText
        }
    },
    "vertical-line": {
        ...$2fb96651e8aa1522$var$stroke,
        handle: {
            ...$2fb96651e8aa1522$var$handle
        },
        axisLabel: {
            ...$2fb96651e8aa1522$var$axisLabel
        },
        text: {
            ...$2fb96651e8aa1522$var$lineText
        }
    },
    // Channels
    "disjoint-channel": {
        ...$2fb96651e8aa1522$var$stroke,
        background: {
            fill: {
                $ref: "foregroundColor"
            },
            fillOpacity: 0.075
        },
        handle: {
            ...$2fb96651e8aa1522$var$handle
        },
        text: {
            ...$2fb96651e8aa1522$var$channelText
        }
    },
    "parallel-channel": {
        ...$2fb96651e8aa1522$var$stroke,
        middle: {
            lineDash: [
                6,
                5
            ],
            strokeWidth: 1
        },
        background: {
            fill: {
                $ref: "foregroundColor"
            },
            fillOpacity: 0.075
        },
        handle: {
            ...$2fb96651e8aa1522$var$handle
        },
        text: {
            ...$2fb96651e8aa1522$var$channelText
        }
    },
    // Fibonnaccis
    "fibonacci-retracement": {
        ...$2fb96651e8aa1522$var$stroke,
        strokes: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_FIBONACCI_STROKES,
        rangeStroke: {
            $ref: "foregroundColor"
        },
        handle: {
            ...$2fb96651e8aa1522$var$handle
        },
        text: {
            ...$2fb96651e8aa1522$var$lineText,
            position: "center"
        },
        label: {
            ...$2fb96651e8aa1522$var$font,
            color: void 0,
            fontSize: {
                $round: [
                    {
                        $mul: [
                            {
                                $ref: "fontSize"
                            },
                            10 / 12
                        ]
                    }
                ]
            }
        }
    },
    "fibonacci-retracement-trend-based": {
        ...$2fb96651e8aa1522$var$stroke,
        strokes: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_FIBONACCI_STROKES,
        rangeStroke: {
            $ref: "foregroundColor"
        },
        handle: {
            ...$2fb96651e8aa1522$var$handle
        },
        text: {
            ...$2fb96651e8aa1522$var$lineText,
            position: "center"
        },
        label: {
            ...$2fb96651e8aa1522$var$font,
            color: void 0,
            fontSize: {
                $round: [
                    {
                        $mul: [
                            {
                                $ref: "fontSize"
                            },
                            10 / 12
                        ]
                    }
                ]
            }
        }
    },
    // Texts
    callout: {
        ...$2fb96651e8aa1522$var$stroke,
        ...$2fb96651e8aa1522$var$text,
        color: {
            $ref: "textColor"
        },
        handle: {
            ...$2fb96651e8aa1522$var$handle
        },
        fill: {
            $ref: "foregroundColor"
        },
        fillOpacity: 0.075
    },
    comment: {
        ...$2fb96651e8aa1522$var$text,
        fontWeight: 700,
        handle: {
            ...$2fb96651e8aa1522$var$handle
        },
        fill: {
            $ref: "foregroundColor"
        }
    },
    note: {
        ...$2fb96651e8aa1522$var$text,
        color: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_TEXTBOX_COLOR,
        fill: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR,
        stroke: {
            $ref: "backgroundColor"
        },
        strokeWidth: 1,
        strokeOpacity: 1,
        handle: {
            ...$2fb96651e8aa1522$var$handle
        },
        background: {
            fill: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_TEXTBOX_FILL,
            stroke: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_TEXTBOX_STROKE,
            strokeWidth: 1
        }
    },
    text: {
        ...$2fb96651e8aa1522$var$text,
        color: {
            $ref: "textColor"
        },
        handle: {
            ...$2fb96651e8aa1522$var$handle
        }
    },
    // Shapes
    arrow: {
        ...$2fb96651e8aa1522$var$stroke,
        handle: {
            ...$2fb96651e8aa1522$var$handle
        },
        text: {
            ...$2fb96651e8aa1522$var$lineText
        }
    },
    "arrow-up": {
        fill: {
            $palette: "up.fill"
        },
        handle: {
            ...$2fb96651e8aa1522$var$handle,
            stroke: {
                $ref: "foregroundColor"
            }
        }
    },
    "arrow-down": {
        fill: {
            $palette: "down.fill"
        },
        handle: {
            ...$2fb96651e8aa1522$var$handle,
            stroke: {
                $ref: "foregroundColor"
            }
        }
    },
    // Measurers
    "date-range": {
        ...$2fb96651e8aa1522$var$measurer
    },
    "price-range": {
        ...$2fb96651e8aa1522$var$measurer
    },
    "date-price-range": {
        ...$2fb96651e8aa1522$var$measurer
    },
    "quick-date-price-range": {
        up: {
            ...$2fb96651e8aa1522$var$stroke,
            fill: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL,
            fillOpacity: 0.2,
            handle: {
                ...$2fb96651e8aa1522$var$handle
            },
            statistics: {
                ...$2fb96651e8aa1522$var$measurerStatistics,
                color: "#fff",
                fill: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL,
                strokeWidth: 0,
                divider: {
                    stroke: "#fff",
                    strokeWidth: 1,
                    strokeOpacity: 0.5
                }
            }
        },
        down: {
            ...$2fb96651e8aa1522$var$stroke,
            stroke: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_ANNOTATION_STATISTICS_DOWN_STROKE,
            fill: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_ANNOTATION_STATISTICS_DOWN_FILL,
            fillOpacity: 0.2,
            handle: {
                ...$2fb96651e8aa1522$var$handle,
                stroke: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_ANNOTATION_STATISTICS_DOWN_STROKE
            },
            statistics: {
                ...$2fb96651e8aa1522$var$measurerStatistics,
                color: "#fff",
                fill: $2fb96651e8aa1522$var$ThemeSymbols.DEFAULT_ANNOTATION_STATISTICS_DOWN_FILL,
                strokeWidth: 0,
                divider: {
                    stroke: "#fff",
                    strokeWidth: 1,
                    strokeOpacity: 0.5
                }
            }
        }
    },
    axesButtons: {},
    toolbar: // Toolbars
    $2fb96651e8aa1522$var$toolbar,
    optionsToolbar: $2fb96651e8aa1522$var$optionsToolbar
};
// packages/ag-charts-enterprise/src/features/annotations/annotationsModule.ts
var $2fb96651e8aa1522$var$AnnotationsModule = {
    type: "root",
    optionsKey: "annotations",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$Annotations(ctx),
    themeTemplate: {
        annotations: $2fb96651e8aa1522$var$annotationsTheme
    }
};
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties12, ObserveChanges: $2fb96651e8aa1522$var$ObserveChanges3, ProxyProperty: $2fb96651e8aa1522$var$ProxyProperty, Property: $2fb96651e8aa1522$var$Property34, calculatePlacement: $2fb96651e8aa1522$var$calculatePlacement } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$Image = class extends $2fb96651e8aa1522$var$BaseProperties12 {
    constructor(){
        super();
        this.opacity = 1;
        this.loadedSynchronously = true;
        this.containerWidth = 0;
        this.containerHeight = 0;
        this.onLoad = void 0;
        this.onImageLoad = ()=>{
            if (this.loadedSynchronously) return;
            this.node.visible = false;
            this.performLayout(this.containerWidth, this.containerHeight);
            this.onLoad?.();
        };
        this.imageElement = (0, $idDdm.createElement)("img");
        this.imageElement.onload = this.onImageLoad;
        this.node = new (0, $iTJTu._ModuleSupport).Image(this.imageElement);
    }
    get complete() {
        return this.imageElement.width > 0 && this.imageElement.height > 0;
    }
    performLayout(containerWidth, containerHeight) {
        this.containerWidth = containerWidth;
        this.containerHeight = containerHeight;
        const container = {
            width: containerWidth,
            height: containerHeight
        };
        const placement = $2fb96651e8aa1522$var$calculatePlacement(this.imageElement.width, this.imageElement.height, container, this);
        this.node.setProperties(this.complete ? {
            visible: true,
            opacity: this.opacity,
            ...placement
        } : {
            visible: false
        });
        return placement;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property34
], $2fb96651e8aa1522$var$Image.prototype, "top", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property34
], $2fb96651e8aa1522$var$Image.prototype, "right", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property34
], $2fb96651e8aa1522$var$Image.prototype, "bottom", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property34
], $2fb96651e8aa1522$var$Image.prototype, "left", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property34
], $2fb96651e8aa1522$var$Image.prototype, "width", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property34
], $2fb96651e8aa1522$var$Image.prototype, "height", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property34
], $2fb96651e8aa1522$var$Image.prototype, "opacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ProxyProperty("imageElement.src"),
    $2fb96651e8aa1522$var$ObserveChanges3((target)=>target.loadedSynchronously = target.complete)
], $2fb96651e8aa1522$var$Image.prototype, "url", 2);
// packages/ag-charts-enterprise/src/features/background/background.ts
var { ActionOnSet: $2fb96651e8aa1522$var$ActionOnSet3, Property: $2fb96651e8aa1522$var$Property35 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$Background2 = class extends (0, $iTJTu._ModuleSupport).Background {
    constructor(){
        super(...arguments);
        this.image = new $2fb96651e8aa1522$var$Image();
    }
    onLayoutComplete(event) {
        super.onLayoutComplete(event);
        if (this.image) {
            const { width: width, height: height } = event.chart;
            this.image.performLayout(width, height);
        }
    }
    onImageLoad() {
        this.ctx.updateService.update((0, $iTJTu._ModuleSupport).ChartUpdateType.SCENE_RENDER);
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property35,
    $2fb96651e8aa1522$var$ActionOnSet3({
        newValue (image) {
            this.node.appendChild(image.node);
            image.onLoad = ()=>this.onImageLoad();
        },
        oldValue (image) {
            this.node.removeChild(image.node);
            image.onLoad = void 0;
        }
    })
], $2fb96651e8aa1522$var$Background2.prototype, "image", 2);
// packages/ag-charts-enterprise/src/features/background/backgroundModule.ts
var $2fb96651e8aa1522$var$BackgroundModule = {
    type: "root",
    optionsKey: "background",
    packageType: "enterprise",
    chartTypes: [
        "cartesian",
        "polar",
        "hierarchy",
        "topology",
        "flow-proportion",
        "standalone",
        "gauge"
    ],
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$Background2(ctx)
};
var { ActionOnSet: $2fb96651e8aa1522$var$ActionOnSet4, LayoutElement: $2fb96651e8aa1522$var$LayoutElement2, Menu: $2fb96651e8aa1522$var$Menu3, Property: $2fb96651e8aa1522$var$Property36 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$menuItems = [
    {
        label: "toolbarSeriesTypeOHLC",
        icon: "ohlc-series",
        value: "ohlc"
    },
    {
        label: "toolbarSeriesTypeCandles",
        icon: "candlestick-series",
        value: "candlestick"
    },
    {
        label: "toolbarSeriesTypeHollowCandles",
        icon: "hollow-candlestick-series",
        value: "hollow-candlestick"
    },
    {
        label: "toolbarSeriesTypeLine",
        icon: "line-series",
        value: "line"
    },
    {
        label: "toolbarSeriesTypeStepLine",
        icon: "step-line-series",
        value: "step-line"
    },
    {
        label: "toolbarSeriesTypeHLC",
        icon: "hlc-series",
        value: "hlc"
    },
    {
        label: "toolbarSeriesTypeHighLow",
        icon: "high-low-series",
        value: "high-low"
    }
];
var $2fb96651e8aa1522$var$ChartToolbar = class extends (0, $iTJTu._ModuleSupport).BaseModuleInstance {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.enabled = false;
        this.menu = new $2fb96651e8aa1522$var$Menu3(this.ctx, "chart-toolbar");
        this.toolbar = ctx.sharedToolbar.getSharedToolbar("chartToolbar");
        this.destroyFns.push(this.toolbar.addToolbarListener("button-pressed", this.onButtonPressed.bind(this)), ctx.layoutManager.registerElement($2fb96651e8aa1522$var$LayoutElement2.ToolbarLeft, this.onLayoutStart.bind(this)), ()=>this.toolbar.destroy());
    }
    onLayoutStart(event) {
        if (!this.enabled) return;
        this.updateButton();
        this.toolbar.layout(event.layoutBox);
    }
    onButtonPressed({ event: event, buttonBounds: buttonBounds }) {
        this.menu.setAnchor({
            x: buttonBounds.x + buttonBounds.width + 6,
            y: buttonBounds.y
        });
        this.menu.show({
            items: $2fb96651e8aa1522$var$menuItems,
            menuItemRole: "menuitemradio",
            ariaLabel: this.ctx.localeManager.t("toolbarSeriesTypeDropdown"),
            class: "ag-charts-chart-toolbar__menu",
            value: this.getChartType(),
            sourceEvent: event.sourceEvent,
            onPress: (item)=>{
                this.setChartType(item.value);
                this.hidePopover();
            },
            onHide: ()=>{
                this.toolbar.clearActiveButton();
            }
        });
        this.toolbar.toggleActiveButtonByIndex(0);
    }
    updateButton() {
        const chartType = this.getChartType();
        const icon = $2fb96651e8aa1522$var$menuItems.find((item)=>item.value === chartType)?.icon;
        if (icon != null) this.toolbar.updateButtons([
            {
                icon: icon,
                tooltip: "toolbarSeriesTypeDropdown"
            }
        ]);
    }
    hidePopover() {
        this.toolbar.clearActiveButton();
        this.menu.hide();
    }
    setChartType(chartType) {
        const options = {
            chartType: chartType
        };
        this.ctx.chartService.publicApi?.updateDelta(options).catch((e)=>(0, $idDdm.Logger).error(e));
    }
    getChartType() {
        const chartType = this.ctx.chartService.publicApi?.getOptions()?.chartType;
        if (chartType == null || !$2fb96651e8aa1522$var$menuItems.some((item)=>item.value === chartType)) return "candlestick";
        return chartType;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property36,
    $2fb96651e8aa1522$var$ActionOnSet4({
        changeValue (enabled) {
            this.toolbar?.setHidden(!enabled);
        }
    })
], $2fb96651e8aa1522$var$ChartToolbar.prototype, "enabled", 2);
// packages/ag-charts-enterprise/src/features/chart-toolbar/chartToolbarModule.ts
var $2fb96651e8aa1522$var$ChartToolbarModule = {
    type: "root",
    optionsKey: "chartToolbar",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$ChartToolbar(ctx)
};
function $2fb96651e8aa1522$var$showsFor(showOn, showing) {
    if (showOn === "always") return true;
    if (showOn === "series-area") return showing === "series-area" || showing === "series-node";
    return showOn === showing;
}
function $2fb96651e8aa1522$var$appendItem(showing, item, result) {
    let mustShow = true;
    if (item.type === "separator") {
        const last = result.at(result.length - 1);
        mustShow = last !== void 0 && last.type !== "separator";
    }
    mustShow && (mustShow = $2fb96651e8aa1522$var$showsFor(item.showOn ?? "always", showing));
    if (mustShow) {
        const menuItem = new $2fb96651e8aa1522$var$ContextMenuItem(item);
        result.push(menuItem);
        return menuItem;
    }
}
function $2fb96651e8aa1522$var$appendBuiltinItem(showing, registry, keyword, result) {
    if (registry.isVisible(keyword)) $2fb96651e8aa1522$var$appendItem(showing, registry.builtins.items[keyword], result);
}
function $2fb96651e8aa1522$var$expandBuiltin(showing, registry, keyword, result) {
    const { builtins: builtins } = registry;
    if ((0, $idDdm.isKeyOf)(keyword, builtins.lists)) for (const childKeyword of builtins.lists[keyword])$2fb96651e8aa1522$var$appendBuiltinItem(showing, registry, childKeyword, result);
    else $2fb96651e8aa1522$var$appendBuiltinItem(showing, registry, keyword, result);
}
function $2fb96651e8aa1522$var$expandItems(showing, registry, items, result) {
    for (const item of items)if (typeof item === "string") $2fb96651e8aa1522$var$expandBuiltin(showing, registry, item, result);
    else {
        const menuItem = $2fb96651e8aa1522$var$appendItem(showing, item, result);
        if (item.items && menuItem && item.items.length > 0) $2fb96651e8aa1522$var$expandItems(showing, registry, item.items, menuItem.items);
    }
    if (result[result.length - 1]?.type === "separator") result.pop();
}
var $2fb96651e8aa1522$var$ContextMenuItem = class {
    constructor(options){
        this.type = "action";
        this.showOn = "always";
        this.label = "";
        this.iconUrl = void 0;
        this.enabled = true;
        this.items = [];
        this.action = void 0;
        if (options) this.setOptions(options);
        this.items = [];
    }
    setField(key, that, value) {
        that[key] = value;
    }
    setOptions(options) {
        let key;
        for(key in options)if (options[key] !== void 0) this.setField(key, this, options[key]);
    }
};
// packages/ag-charts-enterprise/src/features/context-menu/contextMenuStyles.ts
var $2fb96651e8aa1522$var$DEFAULT_CONTEXT_MENU_CLASS = "ag-charts-context-menu";
var $2fb96651e8aa1522$var$DEFAULT_CONTEXT_MENU_DARK_CLASS = "ag-charts-dark-context-menu";
// packages/ag-charts-enterprise/src/features/context-menu/contextMenu.ts
var { Deprecated: $2fb96651e8aa1522$var$Deprecated, Property: $2fb96651e8aa1522$var$Property37, ContextMenuRegistry: $2fb96651e8aa1522$var$ContextMenuRegistry } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$moduleId2 = "context-menu";
var $2fb96651e8aa1522$var$DEPRECATION_MESSAGE = "Use [items] instead";
var $2fb96651e8aa1522$var$ContextMenu = class extends (0, $iTJTu._ModuleSupport).BaseModuleInstance {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.enabled = true;
        this.darkTheme = false;
        this.items = [
            "defaults"
        ];
        // State
        this.pickedNode = void 0;
        this.showEvent = void 0;
        this.x = 0;
        this.y = 0;
        this.closingSubMenus = 0;
        this.menuWidget = new (0, $iTJTu._Widget).MenuWidget();
        const that = this;
        this.deprecationMap = {
            extraActions: {
                get items () {
                    return that.extraActions ?? [];
                },
                showOn: "always"
            },
            extraSeriesAreaActions: {
                get items () {
                    return that.extraSeriesAreaActions ?? [];
                },
                showOn: "series-area"
            },
            extraNodeActions: {
                get items () {
                    return that.extraNodeActions ?? [];
                },
                showOn: "series-node"
            },
            extraLegendItemActions: {
                get items () {
                    return that.extraLegendItemActions ?? [];
                },
                showOn: "legend-item"
            }
        };
        this.interactionManager = ctx.interactionManager;
        this.registry = ctx.contextMenuRegistry;
        this.element = ctx.domManager.addChild("canvas-overlay", $2fb96651e8aa1522$var$moduleId2);
        this.element.classList.add($2fb96651e8aa1522$var$DEFAULT_CONTEXT_MENU_CLASS);
        this.element.style.display = "none";
        this.element.addEventListener("contextmenu", (event)=>event.preventDefault());
        this.element.addEventListener("focusout", ({ relatedTarget: relatedTarget })=>{
            if (this.closingSubMenus > 0) return;
            if (relatedTarget == null || relatedTarget instanceof Node && !this.element.contains(relatedTarget)) this.hide();
        });
        this.destroyFns.push(()=>this.element.parentNode?.removeChild(this.element), ()=>this.menuWidget.destroy(), ctx.domManager.addListener("hidden", ()=>this.hide()), this.menuWidget.addListener("close-widget", ()=>this.onClose()));
        this.menuWidget.addClass(`${$2fb96651e8aa1522$var$DEFAULT_CONTEXT_MENU_CLASS}__menu`);
        if (typeof MutationObserver !== "undefined") {
            const observer = new MutationObserver(()=>{
                if (this.element.contains(this.menuWidget.getElement())) this.reposition();
            });
            observer.observe(this.element, {
                childList: true
            });
            this.mutationObserver = observer;
            this.destroyFns.push(()=>observer.disconnect());
        }
        this.ctx.contextMenuRegistry.builtins.items["download"].action = ()=>{
            const title = ctx.chartService.title;
            let fileName = "image";
            if (title?.enabled && title?.text !== void 0) fileName = title.text.replace(/\.+/, "");
            this.ctx.chartService.publicApi?.download({
                fileName: fileName
            }).catch((e)=>{
                (0, $idDdm.Logger).error("Unable to download chart", e);
            });
        };
        this.destroyFns.push(this.registry.addListener("context-complete", (e)=>this.onContext(e)));
    }
    createDeprecatedAdaptorItems() {
        const result = [];
        for (const deprecatedKey of Object.keys(this.deprecationMap)){
            const { items: items, showOn: showOn } = this.deprecationMap[deprecatedKey];
            result.push("separator");
            for (const { action: action, label: label } of items){
                const type = "action";
                const enabled = true;
                action;
                result.push({
                    type: type,
                    showOn: showOn,
                    enabled: enabled,
                    label: label,
                    action: action
                });
            }
        }
        return result;
    }
    expandItemsOptions(showing) {
        const result = [];
        const deprecatedItems = this.createDeprecatedAdaptorItems();
        $2fb96651e8aa1522$var$expandItems(showing, this.ctx.contextMenuRegistry, this.items, result);
        $2fb96651e8aa1522$var$expandItems(showing, this.ctx.contextMenuRegistry, deprecatedItems, result);
        return result;
    }
    onContext(event) {
        if (!this.enabled) return;
        event.widgetEvent.sourceEvent.preventDefault();
        this.showEvent = event.widgetEvent.sourceEvent;
        this.x = event.x;
        this.y = event.y;
        this.pickedNode = void 0;
        this.pickedLegendItem = void 0;
        if ($2fb96651e8aa1522$var$ContextMenuRegistry.check("series-node", event)) this.pickedNode = event.context.pickedNode;
        else if ($2fb96651e8aa1522$var$ContextMenuRegistry.check("legend-item", event)) this.pickedLegendItem = event.context.legendItem;
        const expandedItems = this.expandItemsOptions(event.showOn);
        if (expandedItems.length === 0) return;
        this.show(event.widgetEvent, expandedItems);
    }
    show(widgetEvent, expandedItems) {
        this.interactionManager.pushState((0, $iTJTu._ModuleSupport).InteractionState.ContextMenu);
        this.element.classList.toggle($2fb96651e8aa1522$var$DEFAULT_CONTEXT_MENU_DARK_CLASS, this.darkTheme);
        this.element.style.display = "block";
        const overrideFocusVisible = widgetEvent.sourceEvent.pointerType === "touch" ? false : void 0;
        if (overrideFocusVisible !== void 0) this.ctx.chartService.overrideFocusVisible(overrideFocusVisible);
        this.createMenu(expandedItems);
        this.element.appendChild(this.menuWidget.getElement());
        this.menuWidget.open(widgetEvent, {
            overrideFocusVisible: overrideFocusVisible
        });
    }
    hide() {
        this.menuWidget.close();
    }
    onClose() {
        this.interactionManager.popState((0, $iTJTu._ModuleSupport).InteractionState.ContextMenu);
        this.element.removeChild(this.menuWidget.getElement());
        this.element.style.display = "none";
    }
    onSubMenuOpen(button, menu) {
        const bounds = button.getBounds();
        button.setFocusOverride(true);
        button.getElement().insertAdjacentElement("afterend", menu.getElement());
        menu.getElement().style.position = "absolute";
        const canvasRect = this.ctx.domManager.getBoundingClientRect();
        const buttonClientRect = button.getBoundingClientRect();
        const remainingSpaceOnRight = canvasRect.right - buttonClientRect.right;
        const remainingSpaceOnLeft = buttonClientRect.left - canvasRect.left;
        const { offsetWidth: menuOffsetWidth, offsetHeight: menuOffsetHeight } = menu.getElement();
        let y = bounds.y;
        if (canvasRect.height > menuOffsetHeight) {
            const remainingSpaceOnBottom = canvasRect.bottom - buttonClientRect.top;
            if (remainingSpaceOnBottom < menuOffsetHeight) y -= menuOffsetHeight - remainingSpaceOnBottom;
        }
        if (remainingSpaceOnRight >= menuOffsetWidth) menu.setBounds({
            x: bounds.x + bounds.width,
            y: y
        });
        else {
            const x = bounds.x - menuOffsetWidth;
            const leftDelta = remainingSpaceOnLeft + x;
            if (leftDelta >= 0) menu.setBounds({
                x: x,
                y: y
            });
            else menu.setBounds({
                x: x - leftDelta,
                y: y
            });
        }
    }
    onSubMenuClose(button, menu) {
        button.setFocusOverride(void 0);
        this.closingSubMenus++;
        menu.remove();
        this.closingSubMenus--;
    }
    createMenu(expandedItems) {
        const { menuWidget: menuWidget } = this;
        menuWidget.clear();
        menuWidget.toggleClass($2fb96651e8aa1522$var$DEFAULT_CONTEXT_MENU_DARK_CLASS, this.darkTheme);
        menuWidget.setTabIndex(-1);
        this.createMenuItems(menuWidget, expandedItems);
    }
    createMenuItems(menuWidget, expandedItems) {
        for (const item of expandedItems)switch(item.type){
            case "separator":
                const sep = menuWidget.addSeparator();
                sep.classList.add(`${$2fb96651e8aa1522$var$DEFAULT_CONTEXT_MENU_CLASS}__divider`);
                sep.classList.toggle($2fb96651e8aa1522$var$DEFAULT_CONTEXT_MENU_DARK_CLASS, this.darkTheme);
                this.initTableCells(sep);
                break;
            case "action":
                if (item.items.length === 0) {
                    const btn = new (0, $iTJTu._Widget).MenuItemWidget();
                    this.initButtonElement(btn, item);
                    menuWidget.addChild(btn);
                } else {
                    const { subMenuButton: subMenuButton, subMenu: subMenu } = menuWidget.addSubMenu();
                    subMenu.addClass(`${$2fb96651e8aa1522$var$DEFAULT_CONTEXT_MENU_CLASS}__menu`);
                    subMenu.addListener("open-widget", ()=>this.onSubMenuOpen(subMenuButton, subMenu));
                    subMenu.addListener("close-widget", ()=>this.onSubMenuClose(subMenuButton, subMenu));
                    this.initButtonElement(subMenuButton, item);
                    this.createMenuItems(subMenu, item.items);
                }
                break;
            default:
                throw new Error("unhandled case");
        }
    }
    createButtonOnClick(showOn, callback2) {
        if ($2fb96651e8aa1522$var$ContextMenuRegistry.checkCallback("legend-item", showOn, callback2)) return (widgetEvent)=>{
            const event = widgetEvent.sourceEvent;
            if (this.pickedLegendItem) {
                const { seriesId: seriesId, itemId: itemId } = this.pickedLegendItem;
                callback2({
                    type: "contextmenu",
                    seriesId: seriesId,
                    itemId: itemId,
                    event: event
                });
                this.hide();
            } else (0, $idDdm.Logger).error("legend item not found");
        };
        else if ($2fb96651e8aa1522$var$ContextMenuRegistry.checkCallback("series-area", showOn, callback2)) return ()=>{
            callback2({
                type: "seriesContextMenuAction",
                event: this.showEvent
            });
            this.hide();
        };
        else if ($2fb96651e8aa1522$var$ContextMenuRegistry.checkCallback("series-node", showOn, callback2)) return ()=>{
            const { pickedNode: pickedNode, showEvent: showEvent } = this;
            const event = pickedNode?.series.createNodeContextMenuActionEvent(showEvent, pickedNode);
            if (event) callback2(event);
            else (0, $idDdm.Logger).error("series node not found");
            this.hide();
        };
        return ()=>{
            callback2({
                type: "contextMenuEvent",
                event: this.showEvent
            });
            this.hide();
        };
    }
    initTableCells(elem) {
        const cellIcon = (0, $idDdm.createElement)("div");
        const cellLabel = (0, $idDdm.createElement)("div");
        const cellArrow = (0, $idDdm.createElement)("div");
        cellIcon.classList.toggle("ag-charts-context-menu__icon", true);
        cellLabel.classList.toggle("ag-charts-context-menu__label", true);
        cellArrow.classList.toggle("ag-charts-context-menu__rightarrowhead", true);
        cellIcon.ariaHidden = "true";
        cellLabel.role = "presentation";
        cellArrow.ariaHidden = "true";
        elem.append(cellIcon, cellLabel, cellArrow);
        return {
            cellIcon: cellIcon,
            cellLabel: cellLabel,
            cellArrow: cellArrow
        };
    }
    initButtonElement(button, item) {
        button.addClass(`${$2fb96651e8aa1522$var$DEFAULT_CONTEXT_MENU_CLASS}__item`);
        button.toggleClass($2fb96651e8aa1522$var$DEFAULT_CONTEXT_MENU_DARK_CLASS, this.darkTheme);
        button.setEnabled(item.enabled);
        const label = this.ctx.localeManager.t(item.label);
        const cellPaddingClass = `${$2fb96651e8aa1522$var$DEFAULT_CONTEXT_MENU_CLASS}__cellpadding`;
        const { cellIcon: cellIcon, cellLabel: cellLabel, cellArrow: cellArrow } = this.initTableCells(button.getElement());
        cellLabel.textContent = label;
        cellLabel.classList.add(cellPaddingClass);
        if (item.iconUrl != null) {
            const img = (0, $idDdm.createElement)("img");
            img.src = item.iconUrl;
            cellIcon.append(img);
            cellIcon.classList.add(cellPaddingClass);
        }
        if (item.items.length > 0) {
            cellArrow.textContent = "\u276F";
            cellArrow.classList.add(cellPaddingClass);
        }
        const { showOn: showOn, action: action } = item;
        if (action != null) {
            const callback2 = this.createButtonOnClick(showOn, action);
            button.addListener("click", callback2);
            button.addListener("keydown", (keyEv)=>{
                if ((0, $iTJTu._ModuleSupport).isButtonClickEvent(keyEv.sourceEvent)) {
                    keyEv.sourceEvent.preventDefault();
                    callback2(keyEv);
                }
            });
        }
        button.addListener("mousemove", ()=>button.focus({
                preventScroll: true
            }));
    }
    reposition() {
        let { x: x, y: y } = this;
        this.element.style.top = "unset";
        this.element.style.bottom = "unset";
        const canvasRect = this.ctx.domManager.getBoundingClientRect();
        const { offsetWidth: width, offsetHeight: height } = this.element;
        x = (0, $idDdm.clamp)(0, x, canvasRect.width - width);
        y = (0, $idDdm.clamp)(0, y, canvasRect.height - height);
        this.element.style.left = `${x}px`;
        this.element.style.top = `calc(${y}px - 0.5em)`;
    }
    destroy() {
        super.destroy();
        this.mutationObserver?.disconnect();
        this.ctx.domManager.removeStyles($2fb96651e8aa1522$var$moduleId2);
        this.ctx.domManager.removeChild("canvas-overlay", $2fb96651e8aa1522$var$moduleId2);
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property37
], $2fb96651e8aa1522$var$ContextMenu.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property37
], $2fb96651e8aa1522$var$ContextMenu.prototype, "darkTheme", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property37
], $2fb96651e8aa1522$var$ContextMenu.prototype, "items", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Deprecated($2fb96651e8aa1522$var$DEPRECATION_MESSAGE)
], $2fb96651e8aa1522$var$ContextMenu.prototype, "extraActions", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Deprecated($2fb96651e8aa1522$var$DEPRECATION_MESSAGE)
], $2fb96651e8aa1522$var$ContextMenu.prototype, "extraNodeActions", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Deprecated($2fb96651e8aa1522$var$DEPRECATION_MESSAGE)
], $2fb96651e8aa1522$var$ContextMenu.prototype, "extraSeriesAreaActions", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Deprecated($2fb96651e8aa1522$var$DEPRECATION_MESSAGE)
], $2fb96651e8aa1522$var$ContextMenu.prototype, "extraLegendItemActions", 2);
// packages/ag-charts-enterprise/src/features/context-menu/contextMenuModule.ts
var $2fb96651e8aa1522$var$ContextMenuModule = {
    type: "root",
    packageType: "enterprise",
    chartTypes: [
        "cartesian",
        "polar",
        "hierarchy",
        "topology",
        "flow-proportion",
        "standalone",
        "gauge"
    ],
    optionsKey: "contextMenu",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$ContextMenu(ctx),
    themeTemplate: {
        contextMenu: {
            enabled: true,
            darkTheme: (0, $iTJTu._ModuleSupport).ThemeSymbols.IS_DARK_THEME
        }
    }
};
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties13, Property: $2fb96651e8aa1522$var$Property38 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$DEFAULT_LABEL_CLASS = "ag-charts-crosshair-label";
var $2fb96651e8aa1522$var$CrosshairLabelProperties = class extends (0, $iTJTu._ModuleSupport).ChangeDetectableProperties {
    constructor(){
        super(...arguments);
        this.enabled = true;
        this.xOffset = 0;
        this.yOffset = 0;
        this.format = void 0;
        this.renderer = void 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property38
], $2fb96651e8aa1522$var$CrosshairLabelProperties.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property38
], $2fb96651e8aa1522$var$CrosshairLabelProperties.prototype, "xOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property38
], $2fb96651e8aa1522$var$CrosshairLabelProperties.prototype, "yOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property38
], $2fb96651e8aa1522$var$CrosshairLabelProperties.prototype, "format", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property38
], $2fb96651e8aa1522$var$CrosshairLabelProperties.prototype, "renderer", 2);
var $2fb96651e8aa1522$var$CrosshairLabel = class extends $2fb96651e8aa1522$var$BaseProperties13 {
    constructor(domManager, key, axisId){
        super();
        this.domManager = domManager;
        this.id = (0, $idDdm.createId)(this);
        this.enabled = true;
        this.xOffset = 0;
        this.yOffset = 0;
        this.renderer = void 0;
        this.element = domManager.addChild("canvas-overlay", `crosshair-label-${this.id}`);
        this.element.classList.add($2fb96651e8aa1522$var$DEFAULT_LABEL_CLASS);
        (0, $idDdm.setAttribute)(this.element, "aria-hidden", true);
        this.element.setAttribute("data-key", key);
        this.element.setAttribute("data-axis-id", axisId);
    }
    show(meta) {
        const { element: element } = this;
        const left = meta.x + this.xOffset;
        const top = meta.y + this.yOffset;
        element.style.top = `${Math.round(top)}px`;
        element.style.left = `${Math.round(left)}px`;
        this.toggle(true);
    }
    setLabelHtml({ html: html, styles: styles }) {
        if (html !== void 0) this.element.innerHTML = html;
        if (styles !== void 0) Object.assign(this.element.style, styles);
    }
    getBBox() {
        const { element: element } = this;
        return new (0, $iTJTu._ModuleSupport).BBox(element.clientLeft, element.clientTop, element.clientWidth, element.clientHeight);
    }
    toggle(visible) {
        this.element.classList.toggle(`ag-charts-crosshair-label--hidden`, !visible);
    }
    destroy() {
        this.domManager.removeChild("canvas-overlay", `crosshair-label-${this.id}`);
    }
    toLabelHtml(input, defaults) {
        if (typeof input === "string") return {
            html: input,
            styles: {}
        };
        defaults = defaults ?? {};
        const { text: text2 = defaults.text ?? "", color: color6 = defaults.color, backgroundColor: backgroundColor = defaults.backgroundColor, opacity: opacity = defaults.opacity ?? 1 } = input;
        const styles = {
            opacity: opacity,
            "background-color": backgroundColor?.toLowerCase(),
            color: color6
        };
        return {
            html: `<div class="ag-charts-crosshair-label-content">
                    <span>${text2}</span>
                </div>`,
            styles: styles
        };
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property38
], $2fb96651e8aa1522$var$CrosshairLabel.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property38
], $2fb96651e8aa1522$var$CrosshairLabel.prototype, "xOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property38
], $2fb96651e8aa1522$var$CrosshairLabel.prototype, "yOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property38
], $2fb96651e8aa1522$var$CrosshairLabel.prototype, "format", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property38
], $2fb96651e8aa1522$var$CrosshairLabel.prototype, "renderer", 2);
// packages/ag-charts-enterprise/src/features/crosshair/crosshair.ts
var { Group: $2fb96651e8aa1522$var$Group5, TranslatableGroup: $2fb96651e8aa1522$var$TranslatableGroup, Line: $2fb96651e8aa1522$var$Line4, BBox: $2fb96651e8aa1522$var$BBox4, InteractionState: $2fb96651e8aa1522$var$InteractionState3, Property: $2fb96651e8aa1522$var$Property39, ZIndexMap: $2fb96651e8aa1522$var$ZIndexMap4, formatNumber: $2fb96651e8aa1522$var$formatNumber, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection11 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$Crosshair = class extends (0, $iTJTu._ModuleSupport).BaseModuleInstance {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.id = (0, $idDdm.createId)(this);
        this.enabled = false;
        this.stroke = "rgb(195, 195, 195)";
        this.lineDash = [
            6,
            3
        ];
        this.lineDashOffset = 0;
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.snap = true;
        this.label = new $2fb96651e8aa1522$var$CrosshairLabelProperties();
        this.seriesRect = new $2fb96651e8aa1522$var$BBox4(0, 0, 0, 0);
        this.bounds = new $2fb96651e8aa1522$var$BBox4(0, 0, 0, 0);
        this.crosshairGroup = new $2fb96651e8aa1522$var$TranslatableGroup({
            name: "crosshairs",
            zIndex: $2fb96651e8aa1522$var$ZIndexMap4.SERIES_CROSSHAIR
        });
        this.lineGroup = this.crosshairGroup.appendChild(new $2fb96651e8aa1522$var$Group5({
            name: `${this.id}-crosshair-lines`,
            zIndex: $2fb96651e8aa1522$var$ZIndexMap4.SERIES_CROSSHAIR
        }));
        this.lineGroupSelection = (0, $iTJTu._ModuleSupport).Selection.select(this.lineGroup, $2fb96651e8aa1522$var$Line4, false);
        this.activeHighlight = void 0;
        this.axisCtx = ctx.parent;
        this.labels = {};
        this.hideCrosshairs();
        ctx.domManager.addEventListener("focusin", ({ target: target })=>{
            const isSeriesAreaChild = target instanceof HTMLElement && ctx.domManager.contains(target, "series-area");
            if (this.crosshairGroup.visible && !isSeriesAreaChild) {
                this.hideCrosshairs();
                this.ctx.updateService.update((0, $iTJTu._ModuleSupport).ChartUpdateType.PERFORM_LAYOUT);
            }
        });
        this.destroyFns.push(ctx.scene.attachNode(this.crosshairGroup), ctx.widgets.seriesWidget.addListener("mousemove", (event)=>this.onMouseHoverLike(event)), ctx.widgets.seriesWidget.addListener("drag-move", (event)=>this.onMouseHoverLike(event)), ctx.widgets.seriesWidget.addListener("mouseleave", ()=>this.onMouseOut()), ctx.widgets.seriesDragInterpreter.addListener("click", (event)=>this.onClick(event)), ctx.chartEventManager.addListener("series-focus-change", ()=>this.onKeyPress()), ctx.zoomManager.addListener("zoom-pan-start", ()=>this.onMouseOut()), ctx.zoomManager.addListener("zoom-change", ()=>this.onMouseOut()), ctx.highlightManager.addListener("highlight-change", (event)=>this.onHighlightChange(event)), ctx.layoutManager.addListener("layout:complete", (event)=>this.layout(event)), ()=>Object.values(this.labels).forEach((label)=>label.destroy()));
    }
    layout({ series: { rect: rect, visible: visible }, axes: axes }) {
        if (!visible || !axes || !this.enabled) return;
        this.seriesRect = rect;
        const { position: axisPosition = "left", axisId: axisId } = this.axisCtx;
        const axisLayout = axes.find((a)=>a.id === axisId);
        if (!axisLayout) return;
        this.axisLayout = axisLayout;
        this.bounds = rect.clone().grow(axisLayout.gridPadding + axisLayout.seriesAreaPadding, axisPosition);
        const { crosshairGroup: crosshairGroup, bounds: bounds } = this;
        crosshairGroup.translationX = Math.round(bounds.x);
        crosshairGroup.translationY = Math.round(bounds.y);
        const crosshairKeys = [
            "pointer",
            ...this.axisCtx.seriesKeyProperties()
        ];
        this.updateSelections(crosshairKeys);
        this.updateLines();
        this.updateLabels(crosshairKeys);
    }
    updateSelections(data) {
        this.lineGroupSelection.update(data, (group)=>group.append(new $2fb96651e8aa1522$var$Line4()), (key)=>key);
    }
    updateLabels(keys) {
        const { labels: labels, ctx: ctx } = this;
        for (const key of keys){
            if (this.label.enabled) labels[key] ?? (labels[key] = new $2fb96651e8aa1522$var$CrosshairLabel(ctx.domManager, key, this.axisCtx.axisId));
            if (labels[key]) this.updateLabel(labels[key]);
        }
        this.labelFormatter = this.axisCtx.scaleValueFormatter(this.label.format);
    }
    updateLabel(label) {
        const { enabled: enabled, xOffset: xOffset, yOffset: yOffset, format: format, renderer: renderer } = this.label;
        label.enabled = enabled;
        label.xOffset = xOffset;
        label.yOffset = yOffset;
        label.format = format;
        label.renderer = renderer;
    }
    updateLines() {
        const { lineGroupSelection: lineGroupSelection, bounds: bounds, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, axisLayout: axisLayout } = this;
        if (!axisLayout) return;
        const isVertical = this.isVertical();
        lineGroupSelection.each((line)=>{
            line.stroke = stroke2;
            line.strokeWidth = strokeWidth;
            line.strokeOpacity = strokeOpacity;
            line.lineDash = lineDash;
            line.lineDashOffset = lineDashOffset;
            line.y1 = 0;
            line.y2 = isVertical ? bounds.height : 0;
            line.x1 = 0;
            line.x2 = isVertical ? 0 : bounds.width;
        });
    }
    isVertical() {
        return this.axisCtx.direction === $2fb96651e8aa1522$var$ChartAxisDirection11.X;
    }
    isHover(event) {
        return event.type === "mousemove" || event.type === "click" || event.device === "touch" && this.ctx.chartService.touch.dragAction === "hover";
    }
    formatValue(value) {
        const { labelFormatter: labelFormatter, axisLayout: axisLayout } = this;
        if (labelFormatter) {
            const result = this.cachedCallWithContext(labelFormatter, value);
            if (result != null) return result;
        }
        if (typeof value === "number") {
            const fractionDigits = (axisLayout?.label.fractionDigits ?? 0) + ((0, $idDdm.isInteger)(value) ? 0 : 1);
            return $2fb96651e8aa1522$var$formatNumber(value, fractionDigits);
        }
        return String(value ?? "");
    }
    onClick(event) {
        if (event.device === "touch") this.onMouseHoverLike(event);
    }
    onMouseHoverLike(event) {
        if (!this.enabled || this.snap) return;
        const requiredState = this.isHover(event) ? $2fb96651e8aa1522$var$InteractionState3.Clickable : $2fb96651e8aa1522$var$InteractionState3.AnnotationsMoveable;
        if (!this.ctx.interactionManager.isState(requiredState)) return;
        this.updatePositions(this.getData(event));
        this.crosshairGroup.visible = true;
        this.ctx.updateService.update((0, $iTJTu._ModuleSupport).ChartUpdateType.SCENE_RENDER);
    }
    onMouseOut() {
        if (!this.ctx.interactionManager.isState($2fb96651e8aa1522$var$InteractionState3.Clickable)) return;
        this.hideCrosshairs();
        this.ctx.updateService.update((0, $iTJTu._ModuleSupport).ChartUpdateType.SCENE_RENDER);
    }
    onKeyPress() {
        if (this.enabled && !this.snap && this.ctx.interactionManager.isState($2fb96651e8aa1522$var$InteractionState3.Default)) this.hideCrosshairs();
    }
    onHighlightChange(event) {
        if (!this.enabled) return;
        const { crosshairGroup: crosshairGroup, axisCtx: axisCtx } = this;
        const { datum: datum, series: series } = event.currentHighlight ?? {};
        const hasCrosshair = datum && (series?.axes.x?.id === axisCtx.axisId || series?.axes.y?.id === axisCtx.axisId);
        this.activeHighlight = hasCrosshair ? event.currentHighlight : void 0;
        if (!this.activeHighlight) this.hideCrosshairs();
        else if (this.snap) {
            const activeHighlightData = this.getActiveHighlightData(this.activeHighlight);
            this.updatePositions(activeHighlightData);
            crosshairGroup.visible = true;
        }
    }
    isInRange(value) {
        return this.axisCtx.inRange(value);
    }
    updatePositions(data) {
        const { seriesRect: seriesRect, lineGroupSelection: lineGroupSelection } = this;
        lineGroupSelection.each((line, key)=>{
            const lineData = data[key];
            if (!lineData) {
                line.visible = false;
                this.hideLabel(key);
                return;
            }
            line.visible = true;
            const { value: value, position: position } = lineData;
            let x = 0;
            let y = 0;
            if (this.isVertical()) {
                x = position;
                line.x = Math.round(x);
            } else {
                y = position;
                line.y = Math.round(y);
            }
            if (this.label.enabled) this.showLabel(x + seriesRect.x, y + seriesRect.y, value, key);
            else this.hideLabel(key);
        });
    }
    getData(event) {
        const { axisCtx: axisCtx } = this;
        const key = "pointer";
        const { datum: datum, xKey: xKey = "", yKey: yKey = "" } = this.activeHighlight ?? {};
        const { currentX: currentX, currentY: currentY } = event;
        const isVertical = this.isVertical();
        const position = isVertical ? currentX : currentY;
        let value = datum?.[isVertical ? xKey : yKey] ?? "";
        if (axisCtx.continuous) value = axisCtx.scaleInvert(position);
        return {
            [key]: {
                position: position,
                value: value
            }
        };
    }
    getActiveHighlightData(activeHighlight) {
        const { axisCtx: axisCtx } = this;
        const { datum: datum, series: series, xKey: xKey = "", aggregatedValue: aggregatedValue, cumulativeValue: cumulativeValue, midPoint: midPoint } = activeHighlight;
        const seriesKeyProperties = series.getKeyProperties(axisCtx.direction);
        const halfBandwidth = (axisCtx.scale.bandwidth ?? 0) / 2;
        const matchingAxisId = series.axes[axisCtx.direction]?.id === axisCtx.axisId;
        const isYKey = seriesKeyProperties.indexOf("yKey") > -1 && matchingAxisId;
        const isXKey = seriesKeyProperties.indexOf("xKey") > -1 && matchingAxisId;
        const datumValue = aggregatedValue ?? cumulativeValue;
        if (isYKey && datumValue !== void 0) {
            const position = axisCtx.scale.convert(datumValue) + halfBandwidth;
            const isInRange = this.isInRange(position);
            return isInRange ? {
                yKey: {
                    value: datumValue,
                    position: position
                }
            } : {};
        }
        if (isXKey) {
            const position = (this.isVertical() ? midPoint?.x : midPoint?.y) ?? 0;
            const value = axisCtx.continuous ? axisCtx.scaleInvert(position) : datum[xKey];
            return this.isInRange(position) ? {
                xKey: {
                    value: value,
                    position: position
                }
            } : {};
        }
        const activeHighlightData = {};
        seriesKeyProperties.forEach((key)=>{
            const keyValue = series.properties[key];
            const value = datum[keyValue];
            const position = axisCtx.scale.convert(value) + halfBandwidth;
            const isInRange = this.isInRange(position);
            if (isInRange) activeHighlightData[key] = {
                value: value,
                position: position
            };
        });
        return activeHighlightData;
    }
    getLabelHtml(value, label) {
        const fractionDigits = this.axisLayout?.label?.fractionDigits ?? 0;
        const defaults = {
            text: this.formatValue(value)
        };
        if (this.label.renderer) return label.toLabelHtml(this.label.renderer({
            value: value,
            fractionDigits: fractionDigits
        }), defaults);
        return label.toLabelHtml(defaults);
    }
    showLabel(x, y, value, key) {
        if (!this.axisLayout) return;
        const { bounds: bounds } = this;
        const label = this.labels[key];
        const html = this.getLabelHtml(value, label);
        label.setLabelHtml(html);
        const { width: width, height: height } = label.getBBox();
        const axisPosition = this.axisCtx.position;
        let padding = this.axisLayout.label.spacing + this.axisLayout.tickSize;
        if (this.axisCtx.direction === $2fb96651e8aa1522$var$ChartAxisDirection11.X) {
            padding -= 4;
            label.show({
                x: x - width / 2,
                y: axisPosition === "bottom" ? bounds.y + bounds.height + padding : bounds.y - height - padding
            });
        } else {
            padding -= 8;
            label.show({
                x: axisPosition === "right" ? bounds.x + bounds.width + padding : bounds.x - width - padding,
                y: y - height / 2
            });
        }
    }
    hideCrosshairs() {
        this.crosshairGroup.visible = false;
        for (const key of Object.keys(this.labels))this.hideLabel(key);
    }
    hideLabel(key) {
        this.labels[key]?.toggle(false);
    }
    cachedCallWithContext(fn, ...params) {
        const { callbackCache: callbackCache, chartService: chartService } = this.ctx;
        return callbackCache.call(this.axisCtx, chartService, fn, ...params);
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property39
], $2fb96651e8aa1522$var$Crosshair.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property39
], $2fb96651e8aa1522$var$Crosshair.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property39
], $2fb96651e8aa1522$var$Crosshair.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property39
], $2fb96651e8aa1522$var$Crosshair.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property39
], $2fb96651e8aa1522$var$Crosshair.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property39
], $2fb96651e8aa1522$var$Crosshair.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property39
], $2fb96651e8aa1522$var$Crosshair.prototype, "snap", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property39
], $2fb96651e8aa1522$var$Crosshair.prototype, "label", 2);
// packages/ag-charts-enterprise/src/features/crosshair/crosshairModule.ts
var $2fb96651e8aa1522$var$CrosshairModule = {
    type: "axis-option",
    optionsKey: "crosshair",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    axisTypes: [
        "category",
        "ordinal-time",
        "unit-time",
        "number",
        "log",
        "time"
    ],
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$Crosshair(ctx),
    themeTemplate: {
        crosshair: {
            snap: true,
            stroke: {
                $ref: "subtleTextColor"
            },
            strokeWidth: 1,
            strokeOpacity: 1,
            lineDash: [
                5,
                6
            ],
            lineDashOffset: 0,
            label: {
                enabled: true
            }
        }
    }
};
var { ActionOnSet: $2fb96651e8aa1522$var$ActionOnSet5, Property: $2fb96651e8aa1522$var$Property40 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$DataSource = class extends (0, $iTJTu._ModuleSupport).BaseModuleInstance {
    constructor(ctx){
        super();
        this.enabled = false;
        this.getData = ()=>Promise.resolve();
        this.dataService = ctx.dataService;
    }
    updateCallback(enabled, getData) {
        if (!this.dataService) return;
        if (enabled && getData != null) this.dataService.updateCallback(getData);
        else this.dataService.clearCallback();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ActionOnSet5({
        newValue (enabled) {
            this.updateCallback(enabled, this.getData);
        }
    }),
    $2fb96651e8aa1522$var$Property40
], $2fb96651e8aa1522$var$DataSource.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ActionOnSet5({
        newValue (getData) {
            this.updateCallback(this.enabled, getData);
        }
    }),
    $2fb96651e8aa1522$var$Property40
], $2fb96651e8aa1522$var$DataSource.prototype, "getData", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ActionOnSet5({
        newValue (requestThrottle) {
            this.dataService.requestThrottle = requestThrottle;
        }
    })
], $2fb96651e8aa1522$var$DataSource.prototype, "requestThrottle", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ActionOnSet5({
        newValue (updateThrottle) {
            this.dataService.dispatchThrottle = updateThrottle;
        }
    })
], $2fb96651e8aa1522$var$DataSource.prototype, "updateThrottle", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ActionOnSet5({
        newValue (updateDuringInteraction) {
            this.dataService.dispatchOnlyLatest = !updateDuringInteraction;
        }
    })
], $2fb96651e8aa1522$var$DataSource.prototype, "updateDuringInteraction", 2);
// packages/ag-charts-enterprise/src/features/data-source/dataSourceModule.ts
var $2fb96651e8aa1522$var$DataSourceModule = {
    type: "root",
    optionsKey: "dataSource",
    packageType: "enterprise",
    chartTypes: [
        "cartesian",
        "hierarchy",
        "polar",
        "topology",
        "flow-proportion",
        "standalone",
        "gauge"
    ],
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$DataSource(ctx),
    themeTemplate: {
        dataSource: {
            enabled: false
        }
    }
};
var { nearestSquaredInContainer: $2fb96651e8aa1522$var$nearestSquaredInContainer, partialAssign: $2fb96651e8aa1522$var$partialAssign, mergeDefaults: $2fb96651e8aa1522$var$mergeDefaults, BBox: $2fb96651e8aa1522$var$BBox5 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$HierarchicalBBox = class {
    constructor(components){
        this.components = components;
        this.union = $2fb96651e8aa1522$var$BBox5.merge(components);
    }
    containsPoint(x, y) {
        if (!this.union.containsPoint(x, y)) return false;
        for (const bbox of this.components){
            if (bbox.containsPoint(x, y)) return true;
        }
        return false;
    }
};
var $2fb96651e8aa1522$var$ErrorBarNode = class extends (0, $iTJTu._ModuleSupport).Group {
    constructor(){
        super();
        this.capLength = NaN;
        this._datum = void 0;
        this.whiskerPath = new (0, $iTJTu._ModuleSupport).Path();
        this.capsPath = new (0, $iTJTu._ModuleSupport).Path();
        this.bboxes = new $2fb96651e8aa1522$var$HierarchicalBBox([]);
        this.append([
            this.whiskerPath,
            this.capsPath
        ]);
    }
    get datum() {
        return this._datum;
    }
    set datum(datum) {
        this._datum = datum;
    }
    calculateCapLength(capsTheme, capDefaults) {
        const { lengthRatio: lengthRatio = 1, length: length } = capsTheme;
        const { lengthRatioMultiplier: lengthRatioMultiplier, lengthMax: lengthMax } = capDefaults;
        const desiredLength = length ?? lengthRatio * lengthRatioMultiplier;
        return Math.min(desiredLength, lengthMax);
    }
    getItemStylerParams(options, style, highlighted) {
        const { datum: datum } = this;
        if (datum == null || options.itemStyler == null) return;
        const { xLowerKey: xLowerKey, xUpperKey: xUpperKey, yLowerKey: yLowerKey, yUpperKey: yUpperKey } = options;
        return {
            ...style,
            datum: datum.datum,
            seriesId: datum.datum.seriesId,
            xKey: datum.xKey,
            yKey: datum.yKey,
            xLowerKey: xLowerKey,
            xUpperKey: xUpperKey,
            yLowerKey: yLowerKey,
            yUpperKey: yUpperKey,
            highlighted: highlighted
        };
    }
    formatStyles(style, options, caller, highlighted) {
        let { cap: capsStyle, ...whiskerStyle } = style;
        const params = this.getItemStylerParams(options, style, highlighted);
        if (params != null && options.itemStyler != null) {
            const result = caller.callWithContext(options.itemStyler, params);
            whiskerStyle = $2fb96651e8aa1522$var$mergeDefaults(result, whiskerStyle);
            capsStyle = $2fb96651e8aa1522$var$mergeDefaults(result?.cap, result, capsStyle);
        }
        return {
            whiskerStyle: whiskerStyle,
            capsStyle: capsStyle
        };
    }
    applyStyling(target, source) {
        $2fb96651e8aa1522$var$partialAssign([
            "visible",
            "stroke",
            "strokeWidth",
            "strokeOpacity",
            "lineDash",
            "lineDashOffset"
        ], target, source);
    }
    update(style, formatters, caller, highlighted) {
        if (this.datum === void 0) return;
        const { whiskerStyle: whiskerStyle, capsStyle: capsStyle } = this.formatStyles(style, formatters, caller, highlighted);
        const { xBar: xBar, yBar: yBar, capDefaults: capDefaults } = this.datum;
        const whisker = this.whiskerPath;
        this.applyStyling(whisker, whiskerStyle);
        whisker.path.clear(true);
        if (yBar !== void 0) {
            whisker.path.moveTo(yBar.lowerPoint.x, yBar.lowerPoint.y);
            whisker.path.lineTo(yBar.upperPoint.x, yBar.upperPoint.y);
        }
        if (xBar !== void 0) {
            whisker.path.moveTo(xBar.lowerPoint.x, xBar.lowerPoint.y);
            whisker.path.lineTo(xBar.upperPoint.x, xBar.upperPoint.y);
        }
        whisker.path.closePath();
        this.capLength = this.calculateCapLength(capsStyle ?? {}, capDefaults);
        const capOffset = this.capLength / 2;
        const caps = this.capsPath;
        this.applyStyling(caps, capsStyle);
        caps.path.clear(true);
        if (yBar !== void 0) {
            caps.path.moveTo(yBar.lowerPoint.x - capOffset, yBar.lowerPoint.y);
            caps.path.lineTo(yBar.lowerPoint.x + capOffset, yBar.lowerPoint.y);
            caps.path.moveTo(yBar.upperPoint.x - capOffset, yBar.upperPoint.y);
            caps.path.lineTo(yBar.upperPoint.x + capOffset, yBar.upperPoint.y);
        }
        if (xBar !== void 0) {
            caps.path.moveTo(xBar.lowerPoint.x, xBar.lowerPoint.y - capOffset);
            caps.path.lineTo(xBar.lowerPoint.x, xBar.lowerPoint.y + capOffset);
            caps.path.moveTo(xBar.upperPoint.x, xBar.upperPoint.y - capOffset);
            caps.path.lineTo(xBar.upperPoint.x, xBar.upperPoint.y + capOffset);
        }
        caps.path.closePath();
    }
    updateBBoxes() {
        const { capLength: capLength, whiskerPath: whisker, capsPath: caps } = this;
        const { yBar: yBar, xBar: xBar } = this.datum ?? {};
        const capOffset = capLength / 2;
        const components = [];
        if (yBar !== void 0) {
            const whiskerHeight = yBar.lowerPoint.y - yBar.upperPoint.y;
            components.push(new $2fb96651e8aa1522$var$BBox5(yBar.lowerPoint.x, yBar.upperPoint.y, whisker.strokeWidth, whiskerHeight), new $2fb96651e8aa1522$var$BBox5(yBar.lowerPoint.x - capOffset, yBar.lowerPoint.y, capLength, caps.strokeWidth), new $2fb96651e8aa1522$var$BBox5(yBar.upperPoint.x - capOffset, yBar.upperPoint.y, capLength, caps.strokeWidth));
        }
        if (xBar !== void 0) {
            const whiskerWidth = xBar.upperPoint.x - xBar.lowerPoint.x;
            components.push(new $2fb96651e8aa1522$var$BBox5(xBar.lowerPoint.x, xBar.upperPoint.y, whiskerWidth, whisker.strokeWidth), new $2fb96651e8aa1522$var$BBox5(xBar.lowerPoint.x, xBar.lowerPoint.y - capOffset, caps.strokeWidth, capLength), new $2fb96651e8aa1522$var$BBox5(xBar.upperPoint.x, xBar.upperPoint.y - capOffset, caps.strokeWidth, capLength));
        }
        this.bboxes.components = components;
        this.bboxes.union = $2fb96651e8aa1522$var$BBox5.merge(components);
    }
    containsPoint(x, y) {
        return this.bboxes.containsPoint(x, y);
    }
    pickNode(x, y) {
        return this.containsPoint(x, y) ? this : void 0;
    }
    nearestSquared(x, y, maxDistance) {
        const { bboxes: bboxes } = this;
        if (bboxes.union.distanceSquared(x, y) > maxDistance) return {
            nearest: void 0,
            distanceSquared: Infinity
        };
        const { distanceSquared: distanceSquared } = $2fb96651e8aa1522$var$BBox5.nearestBox(x, y, bboxes.components);
        return {
            nearest: this,
            distanceSquared: distanceSquared
        };
    }
};
var $2fb96651e8aa1522$var$ErrorBarGroup = class extends (0, $iTJTu._ModuleSupport).Group {
    nearestSquared(x, y) {
        const { nearest: nearest, distanceSquared: distanceSquared } = $2fb96651e8aa1522$var$nearestSquaredInContainer(x, y, {
            children: this.children()
        });
        if (nearest !== void 0 && !isNaN(distanceSquared)) return {
            datum: nearest.datum,
            distanceSquared: distanceSquared
        };
    }
};
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties14, Property: $2fb96651e8aa1522$var$Property41 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$ErrorBarCap = class extends $2fb96651e8aa1522$var$BaseProperties14 {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarCap.prototype, "visible", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarCap.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarCap.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarCap.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarCap.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarCap.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarCap.prototype, "length", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarCap.prototype, "lengthRatio", 2);
var $2fb96651e8aa1522$var$ErrorBarProperties = class extends $2fb96651e8aa1522$var$BaseProperties14 {
    constructor(){
        super(...arguments);
        this.visible = true;
        this.stroke = "black";
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.cap = new $2fb96651e8aa1522$var$ErrorBarCap();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarProperties.prototype, "yLowerKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarProperties.prototype, "yLowerName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarProperties.prototype, "yUpperKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarProperties.prototype, "yUpperName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarProperties.prototype, "xLowerKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarProperties.prototype, "xLowerName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarProperties.prototype, "xUpperKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarProperties.prototype, "xUpperName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarProperties.prototype, "visible", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarProperties.prototype, "itemStyler", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property41
], $2fb96651e8aa1522$var$ErrorBarProperties.prototype, "cap", 2);
// packages/ag-charts-enterprise/src/features/error-bar/errorBar.ts
var { fixNumericExtent: $2fb96651e8aa1522$var$fixNumericExtent, groupAccumulativeValueProperty: $2fb96651e8aa1522$var$groupAccumulativeValueProperty, mergeDefaults: $2fb96651e8aa1522$var$mergeDefaults2, valueProperty: $2fb96651e8aa1522$var$valueProperty2, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection12 } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$toErrorBoundCartesianSeries(ctx) {
    for (const supportedType of (0, $iTJTu.AgErrorBarSupportedSeriesTypes)){
        if (supportedType === ctx.series.type) return ctx.series;
    }
    throw new Error(`AG Charts - unsupported series type '${ctx.series.type}', error bars supported series types: ${(0, $iTJTu.AgErrorBarSupportedSeriesTypes).join(", ")}`);
}
var $2fb96651e8aa1522$var$ErrorBars = class _ErrorBars extends (0, $iTJTu._ModuleSupport).BaseModuleInstance {
    constructor(ctx){
        super();
        this.properties = new $2fb96651e8aa1522$var$ErrorBarProperties();
        const series = $2fb96651e8aa1522$var$toErrorBoundCartesianSeries(ctx);
        const { annotationGroup: annotationGroup, annotationSelections: annotationSelections } = series;
        this.cartesianSeries = series;
        this.groupNode = new $2fb96651e8aa1522$var$ErrorBarGroup({
            name: `${annotationGroup.id}-errorBars`
        });
        annotationGroup.appendChild(this.groupNode);
        this.selection = (0, $iTJTu._ModuleSupport).Selection.select(this.groupNode, ()=>this.errorBarFactory());
        annotationSelections.add(this.selection);
        series.addEventListener("seriesVisibilityChange", (e)=>this.onToggleSeriesItem(e));
        this.destroyFns.push(series.addListener("data-processed", (e)=>this.onDataProcessed(e)), series.addListener("data-update", (e)=>this.onDataUpdate(e)), ctx.highlightManager.addListener("highlight-change", (event)=>this.onHighlightChange(event)), ()=>annotationGroup.removeChild(this.groupNode), ()=>annotationSelections.delete(this.selection));
    }
    hasErrorBars() {
        const { xLowerKey: xLowerKey, xUpperKey: xUpperKey, yLowerKey: yLowerKey, yUpperKey: yUpperKey } = this.properties;
        return (0, $idDdm.isDefined)(xLowerKey) && (0, $idDdm.isDefined)(xUpperKey) || (0, $idDdm.isDefined)(yLowerKey) && (0, $idDdm.isDefined)(yUpperKey);
    }
    isStacked() {
        const stackCount = this.cartesianSeries.seriesGrouping?.stackCount;
        return stackCount == null ? false : stackCount > 0;
    }
    getUnstackPropertyDefinition(opts) {
        const props = [];
        const { xLowerKey: xLowerKey, xUpperKey: xUpperKey, yLowerKey: yLowerKey, yUpperKey: yUpperKey, xErrorsID: xErrorsID, yErrorsID: yErrorsID } = this.getMaybeFlippedKeys();
        const { xScaleType: xScaleType, yScaleType: yScaleType } = opts;
        if (yLowerKey != null && yUpperKey != null) props.push($2fb96651e8aa1522$var$valueProperty2(yLowerKey, yScaleType, {
            id: `${yErrorsID}-lower`
        }), $2fb96651e8aa1522$var$valueProperty2(yUpperKey, yScaleType, {
            id: `${yErrorsID}-upper`
        }));
        if (xLowerKey != null && xUpperKey != null) props.push($2fb96651e8aa1522$var$valueProperty2(xLowerKey, xScaleType, {
            id: `${xErrorsID}-lower`
        }), $2fb96651e8aa1522$var$valueProperty2(xUpperKey, xScaleType, {
            id: `${xErrorsID}-upper`
        }));
        return props;
    }
    getStackPropertyDefinition(opts) {
        const props = [];
        const { cartesianSeries: cartesianSeries } = this;
        const { xLowerKey: xLowerKey, xUpperKey: xUpperKey, yLowerKey: yLowerKey, yUpperKey: yUpperKey, xErrorsID: xErrorsID, yErrorsID: yErrorsID } = this.getMaybeFlippedKeys();
        const { xScaleType: xScaleType, yScaleType: yScaleType } = opts;
        const groupIndex = cartesianSeries.seriesGrouping?.groupIndex ?? cartesianSeries.id;
        const groupOpts = {
            invalidValue: null,
            missingValue: 0,
            separateNegative: true,
            ...cartesianSeries.visible ? {} : {
                forceValue: 0
            }
        };
        const makeErrorProperty = (key, id, type, scaleType)=>{
            return $2fb96651e8aa1522$var$groupAccumulativeValueProperty(key, "normal", "current", {
                id: `${id}-${type}`,
                groupId: `errorGroup-${groupIndex}-${type}`,
                ...groupOpts
            }, scaleType);
        };
        const pushErrorProperties = (lowerKey, upperKey, id, scaleType)=>{
            props.push(...makeErrorProperty(lowerKey, id, "lower", scaleType), ...makeErrorProperty(upperKey, id, "upper", scaleType));
        };
        if (yLowerKey != null && yUpperKey != null) pushErrorProperties(yLowerKey, yUpperKey, yErrorsID, yScaleType);
        if (xLowerKey != null && xUpperKey != null) pushErrorProperties(xLowerKey, xUpperKey, xErrorsID, xScaleType);
        return props;
    }
    getPropertyDefinitions(opts) {
        if (this.isStacked()) return this.getStackPropertyDefinition(opts);
        else return this.getUnstackPropertyDefinition(opts);
    }
    onDataProcessed(event) {
        this.dataModel = event.dataModel;
        this.processedData = event.processedData;
    }
    getDomain(direction) {
        const { xLowerKey: xLowerKey, xUpperKey: xUpperKey, xErrorsID: xErrorsID, yLowerKey: yLowerKey, yUpperKey: yUpperKey, yErrorsID: yErrorsID } = this.getMaybeFlippedKeys();
        const hasAxisErrors = direction === $2fb96651e8aa1522$var$ChartAxisDirection12.X ? (0, $idDdm.isDefined)(xLowerKey) && (0, $idDdm.isDefined)(xUpperKey) : (0, $idDdm.isDefined)(yLowerKey) && (0, $idDdm.isDefined)(yUpperKey);
        if (hasAxisErrors) {
            const { dataModel: dataModel, processedData: processedData, cartesianSeries: series } = this;
            if (dataModel != null && processedData != null) {
                const id = {
                    x: xErrorsID,
                    y: yErrorsID
                }[direction];
                const lowerDomain = dataModel.getDomain(series, `${id}-lower`, "value", processedData);
                const upperDomain = dataModel.getDomain(series, `${id}-upper`, "value", processedData);
                const domain = [
                    Math.min(...lowerDomain, ...upperDomain),
                    Math.max(...lowerDomain, ...upperDomain)
                ];
                return $2fb96651e8aa1522$var$fixNumericExtent(domain);
            }
        }
        return [];
    }
    onDataUpdate(event) {
        this.dataModel = event.dataModel;
        this.processedData = event.processedData;
        if ((0, $idDdm.isDefined)(event.dataModel) && (0, $idDdm.isDefined)(event.processedData)) {
            this.createNodeData();
            this.update();
        }
    }
    getNodeData() {
        return this.hasErrorBars() ? this.cartesianSeries.contextNodeData?.nodeData : void 0;
    }
    createNodeData() {
        const nodeData = this.getNodeData();
        const xScale = this.cartesianSeries.axes[$2fb96651e8aa1522$var$ChartAxisDirection12.X]?.scale;
        const yScale = this.cartesianSeries.axes[$2fb96651e8aa1522$var$ChartAxisDirection12.Y]?.scale;
        if (!xScale || !yScale || !nodeData) return;
        for(let i = 0; i < nodeData.length; i++){
            const { midPoint: midPoint, xLower: xLower, xUpper: xUpper, yLower: yLower, yUpper: yUpper } = this.getDatum(nodeData, i);
            if (midPoint != null) {
                let xBar, yBar;
                if ((0, $idDdm.isDefined)(xLower) && (0, $idDdm.isDefined)(xUpper)) xBar = {
                    lowerPoint: {
                        x: this.convert(xScale, xLower),
                        y: midPoint.y
                    },
                    upperPoint: {
                        x: this.convert(xScale, xUpper),
                        y: midPoint.y
                    }
                };
                if ((0, $idDdm.isDefined)(yLower) && (0, $idDdm.isDefined)(yUpper)) yBar = {
                    lowerPoint: {
                        x: midPoint.x,
                        y: this.convert(yScale, yLower)
                    },
                    upperPoint: {
                        x: midPoint.x,
                        y: this.convert(yScale, yUpper)
                    }
                };
                nodeData[i].xBar = xBar;
                nodeData[i].yBar = yBar;
            }
        }
    }
    getMaybeFlippedKeys() {
        let { xLowerKey: xLowerKey, xUpperKey: xUpperKey, yLowerKey: yLowerKey, yUpperKey: yUpperKey } = this.properties;
        let [xErrorsID, yErrorsID] = [
            "xValue-errors",
            "yValue-errors"
        ];
        if (this.cartesianSeries.shouldFlipXY()) {
            [xLowerKey, yLowerKey] = [
                yLowerKey,
                xLowerKey
            ];
            [xUpperKey, yUpperKey] = [
                yUpperKey,
                xUpperKey
            ];
            [xErrorsID, yErrorsID] = [
                yErrorsID,
                xErrorsID
            ];
        }
        return {
            xLowerKey: xLowerKey,
            xUpperKey: xUpperKey,
            xErrorsID: xErrorsID,
            yLowerKey: yLowerKey,
            yUpperKey: yUpperKey,
            yErrorsID: yErrorsID
        };
    }
    static getDatumKey(datum, key, offset) {
        if (key == null) return;
        const value = datum.datum[key];
        if (value == null) return;
        if (typeof value !== "number") {
            (0, $idDdm.Logger).warnOnce(`Found [${key}] error value of type ${typeof value}. Expected number type`);
            return;
        }
        return value + offset;
    }
    getDatum(nodeData, datumIndex) {
        const { xLowerKey: xLowerKey, xUpperKey: xUpperKey, yLowerKey: yLowerKey, yUpperKey: yUpperKey } = this.getMaybeFlippedKeys();
        const datum = nodeData[datumIndex];
        const d = datum.cumulativeValue == null || !this.isStacked() ? 0 : datum.cumulativeValue - datum.yValue;
        const [xOffset, yOffset] = this.cartesianSeries.shouldFlipXY() ? [
            d,
            0
        ] : [
            0,
            d
        ];
        return {
            midPoint: datum.midPoint,
            xLower: _ErrorBars.getDatumKey(datum, xLowerKey, xOffset),
            xUpper: _ErrorBars.getDatumKey(datum, xUpperKey, xOffset),
            yLower: _ErrorBars.getDatumKey(datum, yLowerKey, yOffset),
            yUpper: _ErrorBars.getDatumKey(datum, yUpperKey, yOffset)
        };
    }
    convert(scale, value) {
        const offset = (scale.bandwidth ?? 0) / 2;
        return scale.convert(value) + offset;
    }
    update() {
        const nodeData = this.getNodeData();
        if (nodeData != null) {
            this.selection.update(nodeData);
            this.selection.each((node, datum, i)=>this.updateNode(node, datum, i));
        }
    }
    updateNode(node, datum, _index) {
        node.datum = datum;
        node.update(this.getDefaultStyle(), this.properties, this.cartesianSeries, false);
        node.updateBBoxes();
    }
    pickNodeExact(point) {
        const { x: x, y: y } = point;
        const node = this.groupNode.pickNode(x, y);
        if (node != null) return {
            datum: node.datum,
            distanceSquared: 0
        };
    }
    pickNodeNearest(point) {
        return this.groupNode.nearestSquared(point.x, point.y);
    }
    pickNodeMainAxisFirst(point) {
        return this.groupNode.nearestSquared(point.x, point.y);
    }
    getTooltipParams() {
        const { xLowerKey: xLowerKey, xUpperKey: xUpperKey, yLowerKey: yLowerKey, yUpperKey: yUpperKey, xLowerName: xLowerName = xLowerKey, xUpperName: xUpperName = xUpperKey, yLowerName: yLowerName = yLowerKey, yUpperName: yUpperName = yUpperKey } = this.properties;
        return {
            xLowerKey: xLowerKey,
            xLowerName: xLowerName,
            xUpperKey: xUpperKey,
            xUpperName: xUpperName,
            yLowerKey: yLowerKey,
            yLowerName: yLowerName,
            yUpperKey: yUpperKey,
            yUpperName: yUpperName
        };
    }
    onToggleSeriesItem(event) {
        this.groupNode.visible = event.visible;
    }
    makeStyle(baseStyle) {
        return {
            visible: baseStyle.visible,
            lineDash: baseStyle.lineDash,
            lineDashOffset: baseStyle.lineDashOffset,
            stroke: baseStyle.stroke,
            strokeWidth: baseStyle.strokeWidth,
            strokeOpacity: baseStyle.strokeOpacity,
            cap: $2fb96651e8aa1522$var$mergeDefaults2(this.properties.cap, baseStyle)
        };
    }
    getDefaultStyle() {
        return this.makeStyle(this.getWhiskerProperties());
    }
    getHighlightStyle() {
        return this.makeStyle(this.getWhiskerProperties());
    }
    restyleHighlightChange(highlightChange, style, highlighted) {
        const nodeData = this.getNodeData();
        if (nodeData == null) return;
        for(let i = 0; i < nodeData.length; i++)if (highlightChange === nodeData[i]) {
            this.selection.at(i)?.update(style, this.properties, this.cartesianSeries, highlighted);
            break;
        }
    }
    onHighlightChange(event) {
        const { previousHighlight: previousHighlight, currentHighlight: currentHighlight } = event;
        if (currentHighlight?.series === this.cartesianSeries) this.restyleHighlightChange(currentHighlight, this.getHighlightStyle(), true);
        if (previousHighlight?.series === this.cartesianSeries) this.restyleHighlightChange(previousHighlight, this.getDefaultStyle(), false);
        this.groupNode.opacity = this.cartesianSeries.getOpacity();
    }
    errorBarFactory() {
        return new $2fb96651e8aa1522$var$ErrorBarNode();
    }
    getWhiskerProperties() {
        const { stroke: stroke2, strokeWidth: strokeWidth, visible: visible, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = this.properties;
        return {
            stroke: stroke2,
            strokeWidth: strokeWidth,
            visible: visible,
            strokeOpacity: strokeOpacity,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset
        };
    }
};
var $2fb96651e8aa1522$var$ERROR_BARS_THEME = {
    series: {
        errorBar: {
            visible: true,
            stroke: {
                $ref: "foregroundColor"
            },
            strokeWidth: 1,
            strokeOpacity: 1,
            cap: {
                length: void 0,
                lengthRatio: void 0
            }
        }
    }
};
// packages/ag-charts-enterprise/src/features/error-bar/errorBarModule.ts
var $2fb96651e8aa1522$var$ErrorBarsModule = {
    type: "series-option",
    identifier: "error-bars",
    optionsKey: "errorBar",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    seriesTypes: (0, $iTJTu.AgErrorBarSupportedSeriesTypes),
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$ErrorBars(ctx),
    themeTemplate: $2fb96651e8aa1522$var$ERROR_BARS_THEME
};
var { ZIndexMap: $2fb96651e8aa1522$var$ZIndexMap5, ActionOnSet: $2fb96651e8aa1522$var$ActionOnSet6, Property: $2fb96651e8aa1522$var$Property42, ProxyPropertyOnWrite: $2fb96651e8aa1522$var$ProxyPropertyOnWrite2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$Foreground = class extends (0, $iTJTu._ModuleSupport).Background {
    constructor(){
        super(...arguments);
        this.image = new $2fb96651e8aa1522$var$Image();
        this.fill = "transparent";
        this.fillOpacity = void 0;
    }
    createNode() {
        return new (0, $iTJTu._ModuleSupport).Group({
            name: "foreground",
            zIndex: $2fb96651e8aa1522$var$ZIndexMap5.FOREGROUND
        });
    }
    onLayoutComplete(event) {
        super.onLayoutComplete(event);
        const { width: width, height: height } = event.chart;
        let placement = {
            x: 0,
            y: 0,
            width: width,
            height: height
        };
        if (this.image) placement = this.image.performLayout(width, height);
        if (this.text) this.updateTextNode(placement);
    }
    onImageLoad() {
        this.ctx.updateService.update((0, $iTJTu._ModuleSupport).ChartUpdateType.SCENE_RENDER);
    }
    updateTextNode(placement) {
        const { textNode: textNode } = this;
        textNode.fontWeight = "bold";
        textNode.fontFamily = "Impact, sans-serif";
        textNode.fontSize = 19;
        textNode.opacity = 0.7;
        textNode.fill = "#9b9b9b";
        textNode.textBaseline = "top";
        const textBBox = this.textNode.getBBox();
        const textPadding = 10;
        textNode.x = placement.x + placement.width / 2 - textBBox.width / 2;
        textNode.y = placement.y + placement.height + textPadding;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property42,
    $2fb96651e8aa1522$var$ActionOnSet6({
        newValue (image) {
            this.node.appendChild(image.node);
            image.onLoad = ()=>this.onImageLoad();
        },
        oldValue (image) {
            this.node.removeChild(image.node);
            image.onLoad = void 0;
        }
    })
], $2fb96651e8aa1522$var$Foreground.prototype, "image", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property42,
    $2fb96651e8aa1522$var$ProxyPropertyOnWrite2("rectNode", "fill")
], $2fb96651e8aa1522$var$Foreground.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property42,
    $2fb96651e8aa1522$var$ProxyPropertyOnWrite2("rectNode", "fillOpacity")
], $2fb96651e8aa1522$var$Foreground.prototype, "fillOpacity", 2);
// packages/ag-charts-enterprise/src/features/foreground/foregroundModule.ts
var $2fb96651e8aa1522$var$ForegroundModule = {
    type: "root",
    optionsKey: "foreground",
    packageType: "enterprise",
    chartTypes: [
        "cartesian",
        "polar",
        "hierarchy",
        "topology",
        "flow-proportion",
        "standalone",
        "gauge"
    ],
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$Foreground(ctx)
};
var { TranslatableGroup: $2fb96651e8aa1522$var$TranslatableGroup2, SceneChangeDetection: $2fb96651e8aa1522$var$SceneChangeDetection } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$MiniChartGroup = class extends $2fb96651e8aa1522$var$TranslatableGroup2 {
    constructor(){
        super(...arguments);
        this.inset = 0;
        this.cornerRadius = 0;
    }
    applyClip(ctx, clipRect) {
        const { cornerRadius: cornerRadius, inset: inset } = this;
        const { x: x, y: y, width: width, height: height } = clipRect;
        ctx.beginPath();
        ctx.roundRect(x + inset, y + inset, width - 2 * inset, height - 2 * inset, cornerRadius);
        ctx.clip();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection()
], $2fb96651e8aa1522$var$MiniChartGroup.prototype, "inset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection()
], $2fb96651e8aa1522$var$MiniChartGroup.prototype, "cornerRadius", 2);
// packages/ag-charts-enterprise/src/features/navigator/miniChart.ts
var { Property: $2fb96651e8aa1522$var$Property43, ZIndexMap: $2fb96651e8aa1522$var$ZIndexMap6, ActionOnSet: $2fb96651e8aa1522$var$ActionOnSet7, CategoryAxis: $2fb96651e8aa1522$var$CategoryAxis, TextUtils: $2fb96651e8aa1522$var$TextUtils2, Padding: $2fb96651e8aa1522$var$Padding, Group: $2fb96651e8aa1522$var$Group6, BBox: $2fb96651e8aa1522$var$BBox6, ProxyProperty: $2fb96651e8aa1522$var$ProxyProperty2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$MiniChartPadding = class {
    constructor(){
        this.top = 0;
        this.bottom = 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property43
], $2fb96651e8aa1522$var$MiniChartPadding.prototype, "top", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property43
], $2fb96651e8aa1522$var$MiniChartPadding.prototype, "bottom", 2);
var $2fb96651e8aa1522$var$MiniChart = class extends (0, $iTJTu._ModuleSupport).BaseModuleInstance {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.enabled = false;
        this.padding = new $2fb96651e8aa1522$var$MiniChartPadding();
        this.root = new $2fb96651e8aa1522$var$Group6({
            name: "root"
        });
        this.seriesRoot = this.root.appendChild(new $2fb96651e8aa1522$var$MiniChartGroup({
            name: "Series-root",
            zIndex: $2fb96651e8aa1522$var$ZIndexMap6.SERIES_LAYER,
            renderToOffscreenCanvas: true
        }));
        this.axisGridGroup = this.root.appendChild(new $2fb96651e8aa1522$var$Group6({
            name: "Axes-Grids",
            zIndex: $2fb96651e8aa1522$var$ZIndexMap6.AXIS_GRID
        }));
        this.axisGroup = this.root.appendChild(new $2fb96651e8aa1522$var$Group6({
            name: "Axes-Grids",
            zIndex: $2fb96651e8aa1522$var$ZIndexMap6.AXIS_GRID
        }));
        this.axisLabelGroup = this.root.appendChild(new $2fb96651e8aa1522$var$Group6({
            name: "Axes-Labels",
            zIndex: $2fb96651e8aa1522$var$ZIndexMap6.SERIES_LABEL
        }));
        this.axisCrosslineRangeGroup = this.root.appendChild(new $2fb96651e8aa1522$var$Group6({
            name: "Axes-Crosslines-Range",
            zIndex: $2fb96651e8aa1522$var$ZIndexMap6.SERIES_CROSSLINE_RANGE
        }));
        this.axisCrosslineLineGroup = this.root.appendChild(new $2fb96651e8aa1522$var$Group6({
            name: "Axes-Crosslines-Line",
            zIndex: $2fb96651e8aa1522$var$ZIndexMap6.SERIES_CROSSLINE_LINE
        }));
        this.axisCrosslineLabelGroup = this.root.appendChild(new $2fb96651e8aa1522$var$Group6({
            name: "Axes-Crosslines-Label",
            zIndex: $2fb96651e8aa1522$var$ZIndexMap6.SERIES_LABEL
        }));
        this.data = [];
        this._destroyed = false;
        this.miniChartAnimationPhase = "initial";
        this.axes = [];
        this.series = [];
    }
    destroy() {
        if (this._destroyed) return;
        this.destroySeries(this.series);
        this.axes.forEach((a)=>a.destroy());
        this.axes = [];
        this._destroyed = true;
    }
    onSeriesChange(newValue, oldValue) {
        const seriesToDestroy = oldValue?.filter((series)=>!newValue.includes(series)) ?? [];
        this.destroySeries(seriesToDestroy);
        for (const series of newValue){
            if (oldValue?.includes(series)) continue;
            series.attachSeries(this.seriesRoot, this.seriesRoot, void 0);
            const chart = this;
            series.chart = {
                get mode () {
                    return "standalone";
                },
                get isMiniChart () {
                    return true;
                },
                get seriesRect () {
                    return chart.seriesRect;
                }
            };
            series.resetAnimation(this.miniChartAnimationPhase === "initial" ? "initial" : "disabled");
        }
    }
    destroySeries(allSeries) {
        allSeries?.forEach((series)=>{
            series.destroy();
            series.detachSeries(this.seriesRoot, this.seriesRoot, void 0);
            series.chart = void 0;
        });
    }
    assignSeriesToAxes() {
        this.axes.forEach((axis)=>{
            axis.boundSeries = this.series.filter((s)=>{
                const seriesAxis = s.axes[axis.direction];
                return seriesAxis === axis;
            });
        });
    }
    assignAxesToSeries() {
        const directionToAxesMap = {};
        this.axes.forEach((axis)=>{
            const direction = axis.direction;
            const directionAxes = directionToAxesMap[direction] ?? (directionToAxesMap[direction] = []);
            directionAxes.push(axis);
        });
        this.series.forEach((series)=>{
            series.directions.forEach((direction)=>{
                const directionAxes = directionToAxesMap[direction];
                if (!directionAxes) {
                    (0, $idDdm.Logger).warnOnce(`no available axis for direction [${direction}]; check series and axes configuration.`);
                    return;
                }
                const seriesKeys = series.getKeys(direction);
                const newAxis = this.findMatchingAxis(directionAxes, seriesKeys);
                if (!newAxis) {
                    (0, $idDdm.Logger).warnOnce(`no matching axis for direction [${direction}] and keys [${seriesKeys}]; check series and axes configuration.`);
                    return;
                }
                series.axes[direction] = newAxis;
            });
        });
    }
    findMatchingAxis(directionAxes, directionKeys) {
        for (const axis of directionAxes){
            if (!axis.keys.length) return axis;
            if (!directionKeys) continue;
            for (const directionKey of directionKeys){
                if (axis.keys.includes(directionKey)) return axis;
            }
        }
    }
    updateData(data) {
        this.series.forEach((s)=>s.setChartData(data));
        if (this.miniChartAnimationPhase === "initial") this.ctx.animationManager.onBatchStop(()=>{
            this.miniChartAnimationPhase = "ready";
            this.series.forEach((s)=>s.resetAnimation("disabled"));
        });
    }
    async processData(dataController) {
        if (this.series.some((s)=>s.canHaveAxes)) {
            this.assignAxesToSeries();
            this.assignSeriesToAxes();
        }
        await Promise.all(this.series.map((s)=>{
            s.resetDatumCallbackCache();
            return s.processData(dataController);
        }));
        for (const axis of this.axes)axis.processData();
    }
    computeAxisPadding() {
        const padding = new $2fb96651e8aa1522$var$Padding();
        if (!this.enabled) return padding;
        this.axes.forEach(({ position: position, thickness: thickness, line: line, label: label })=>{
            if (position == null) return;
            let size;
            if (thickness) size = thickness;
            else size = (line.enabled ? line.width : 0) + (label.enabled ? $2fb96651e8aa1522$var$TextUtils2.getLineHeight(label.fontSize ?? 0) + label.spacing : 0);
            padding[position] = Math.ceil(size);
        });
        return padding;
    }
    async layout(width, height) {
        const { padding: padding } = this;
        const animated = this.seriesRect != null;
        const seriesRect = new $2fb96651e8aa1522$var$BBox6(0, 0, width, height - (padding.top + padding.bottom));
        this.seriesRect = seriesRect;
        this.seriesRoot.translationY = padding.top;
        this.seriesRoot.setClipRectCanvasSpace(new $2fb96651e8aa1522$var$BBox6(0, -padding.top, width, height));
        this.axes.forEach((axis)=>{
            const { position: position = "left" } = axis;
            switch(position){
                case "top":
                case "bottom":
                    axis.range = [
                        0,
                        seriesRect.width
                    ];
                    axis.gridLength = seriesRect.height;
                    break;
                case "right":
                case "left":
                    {
                        const isCategoryAxis = axis instanceof $2fb96651e8aa1522$var$CategoryAxis;
                        axis.range = isCategoryAxis ? [
                            0,
                            seriesRect.height
                        ] : [
                            seriesRect.height,
                            0
                        ];
                        axis.gridLength = seriesRect.width;
                        break;
                    }
            }
            axis.gridPadding = 0;
            axis.translation.x = 0;
            axis.translation.y = 0;
            if (position === "right") axis.translation.x = width;
            else if (position === "bottom") axis.translation.y = height;
            if (!animated) axis.resetAnimation("initial");
            axis.calculateLayout();
            axis.update();
        });
        await Promise.all(this.series.map((series)=>series.update({
                seriesRect: seriesRect
            })));
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property43
], $2fb96651e8aa1522$var$MiniChart.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ProxyProperty2([
        "seriesRoot",
        "inset"
    ])
], $2fb96651e8aa1522$var$MiniChart.prototype, "inset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ProxyProperty2([
        "seriesRoot",
        "cornerRadius"
    ])
], $2fb96651e8aa1522$var$MiniChart.prototype, "cornerRadius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ActionOnSet7({
        changeValue (newValue, oldValue = []) {
            const axisNodes = {
                axisNode: this.axisGroup,
                gridNode: this.axisGridGroup,
                labelNode: this.axisLabelGroup,
                crossLineLineNode: this.axisCrosslineLineGroup,
                crossLineRangeNode: this.axisCrosslineRangeGroup,
                crossLineLabelNode: this.axisCrosslineLabelGroup
            };
            for (const axis of oldValue){
                if (newValue.includes(axis)) continue;
                axis.detachAxis(axisNodes);
                axis.destroy();
            }
            for (const axis of newValue){
                if (oldValue?.includes(axis)) continue;
                axis.attachAxis(axisNodes);
            }
        }
    })
], $2fb96651e8aa1522$var$MiniChart.prototype, "axes", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ActionOnSet7({
        changeValue (newValue, oldValue) {
            this.onSeriesChange(newValue, oldValue);
        }
    })
], $2fb96651e8aa1522$var$MiniChart.prototype, "series", 2);
var { SliderWidget: $2fb96651e8aa1522$var$SliderWidget } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$NavigatorDOMProxy = class {
    constructor(ctx, sliderHandlers){
        this.ctx = ctx;
        this.sliderHandlers = sliderHandlers;
        this._min = 0;
        this._max = 1;
        this.minRange = 1e-3;
        this.dragStartX = 0;
        this.ctx = ctx;
        this.toolbar = ctx.proxyInteractionService.createProxyContainer({
            type: "toolbar",
            domManagerId: `navigator-toolbar`,
            classList: [
                "ag-charts-proxy-navigator-toolbar"
            ],
            orientation: "vertical",
            ariaLabel: {
                id: "ariaLabelNavigator"
            }
        });
        this.sliders = [
            ctx.proxyInteractionService.createProxyElement({
                type: "slider",
                domIndex: 1,
                ariaLabel: {
                    id: "ariaLabelNavigatorMinimum"
                },
                parent: this.toolbar,
                cursor: "ew-resize"
            }),
            ctx.proxyInteractionService.createProxyElement({
                type: "slider",
                domIndex: -Infinity,
                ariaLabel: {
                    id: "ariaLabelNavigatorRange"
                },
                parent: this.toolbar,
                cursor: "grab"
            }),
            ctx.proxyInteractionService.createProxyElement({
                type: "slider",
                domIndex: 2,
                ariaLabel: {
                    id: "ariaLabelNavigatorMaximum"
                },
                parent: this.toolbar,
                cursor: "ew-resize"
            })
        ];
        for (const [index, key] of [
            "min",
            "pan",
            "max"
        ].entries()){
            const slider = this.sliders[index];
            slider.step = $2fb96651e8aa1522$var$SliderWidget.STEP_HUNDRETH;
            slider.keyboardStep = $2fb96651e8aa1522$var$SliderWidget.STEP_ONE;
            slider.orientation = "horizontal";
            slider.setPreventsDefault(false);
            slider.addListener("drag-start", (ev)=>this.onDragStart(index, ev, key));
            slider.addListener("drag-move", (ev)=>this.onDrag(slider, ev, key));
            slider.addListener("drag-end", ()=>this.updateSliderRatios());
            slider.addListener("contextmenu", (ev)=>this.onContextMenu(slider, ev));
        }
        this.sliders[0].addListener("change", ()=>this.onMinSliderChange());
        this.sliders[1].addListener("change", ()=>this.onPanSliderChange());
        this.sliders[2].addListener("change", ()=>this.onMaxSliderChange());
        this.updateSliderRatios();
        this.updateVisibility(false);
    }
    destroy() {
        this.toolbar.destroy();
    }
    updateVisibility(visible) {
        this.toolbar.setHidden(!visible);
    }
    updateZoom() {
        const { _min: min, _max: max } = this;
        if (min == null || max == null) return;
        return this.ctx.zoomManager.updateZoom("navigator", {
            x: {
                min: min,
                max: max
            }
        });
    }
    updateBounds(bounds) {
        this.toolbar.setBounds(bounds);
    }
    updateSliderBounds(sliderIndex, bounds) {
        this.sliders[sliderIndex].setBounds(bounds);
    }
    updateMinMax(min, max) {
        this._min = min;
        this._max = max;
        this.updateSliderRatios();
    }
    updateSliderRatios() {
        let { _min: min, _max: max } = this;
        min = Math.round(min * 100) / 100;
        max = Math.round(max * 100) / 100;
        const panAria = this.ctx.localeManager.t("ariaValuePanRange", {
            min: min,
            max: max
        });
        this.sliders[0].setValueRatio(min);
        this.sliders[1].setValueRatio(min, {
            ariaValueText: panAria
        });
        this.sliders[2].setValueRatio(max);
    }
    toCanvasOffsets(event) {
        return {
            offsetX: this.dragStartX + event.originDeltaX
        };
    }
    moveToFront(index) {
        if (index === 1) return;
        const frontSlider = this.sliders[index];
        const otherSlider = this.sliders[2 - index];
        this.toolbar.moveChild(otherSlider, frontSlider.domIndex - 1);
    }
    onDragStart(index, event, key) {
        const slider = this.sliders[index];
        const toolbarLeft = this.toolbar.cssLeft();
        const sliderLeft = slider.cssLeft();
        this.dragStartX = toolbarLeft + sliderLeft + event.offsetX;
        this.moveToFront(index);
        if (event.device === "touch") event.sourceEvent.preventDefault();
        this.sliderHandlers.onDragStart(key, this.toCanvasOffsets(event));
    }
    onDrag(_slider, event, key) {
        if (event.device === "touch") event.sourceEvent.preventDefault();
        this.sliderHandlers.onDrag(key, this.toCanvasOffsets(event));
    }
    onContextMenu(slider, widgetEvent) {
        const { offsetX: offsetX, offsetY: offsetY } = widgetEvent;
        const { x: toolbarX, y: toolbarY } = this.toolbar.getBounds();
        const { x: sliderX, y: sliderY } = slider.getBounds();
        const canvasX = offsetX + toolbarX + sliderX;
        const canvasY = offsetY + toolbarY + sliderY;
        this.ctx.contextMenuRegistry.dispatchContext("always", {
            widgetEvent: widgetEvent,
            canvasX: canvasX,
            canvasY: canvasY
        }, void 0);
    }
    onPanSliderChange() {
        const ratio3 = this.sliders[1].getValueRatio();
        const span = this._max - this._min;
        this._min = (0, $idDdm.clamp)(0, ratio3, 1 - span);
        this._max = this._min + span;
        this.updateZoom();
    }
    onMinSliderChange() {
        this._min = this.sliders[0].clampValueRatio(0, this._max - this.minRange);
        this.updateZoom();
    }
    onMaxSliderChange() {
        this._max = this.sliders[2].clampValueRatio(this._min + this.minRange, 1);
        this.updateZoom();
    }
};
var { Property: $2fb96651e8aa1522$var$Property44, SceneChangeDetection: $2fb96651e8aa1522$var$SceneChangeDetection2, BBox: $2fb96651e8aa1522$var$BBox7, ExtendedPath2D: $2fb96651e8aa1522$var$ExtendedPath2D } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RangeHandle = class extends (0, $iTJTu._ModuleSupport).Path {
    constructor(){
        super(...arguments);
        this.zIndex = 3;
        this.centerX = 0;
        this.centerY = 0;
        this.width = 8;
        this.height = 16;
        this.cornerRadius = 4;
        this.grip = true;
        this.gripPath = new $2fb96651e8aa1522$var$ExtendedPath2D();
    }
    setCenter(x, y) {
        this.dirtyPath = true;
        if (this.centerX !== x || this.centerY !== y) {
            this.centerX = x;
            this.centerY = y;
            this.markDirty("center");
        }
    }
    static align(minHandle, maxHandle, x, y, width, height, min, max, pixelAlign) {
        const minHandleX = minHandle.align(x + width * min) + pixelAlign;
        const maxHandleX = minHandleX + minHandle.align(x + width * min, width * (max - min)) - 2 * pixelAlign;
        const handleY = minHandle.align(y + height / 2);
        minHandle.setCenter(minHandleX, handleY);
        maxHandle.setCenter(maxHandleX, handleY);
    }
    computeBBox() {
        const { centerX: centerX, centerY: centerY, width: width, height: height } = this;
        const x = centerX - width / 2;
        const y = centerY - height / 2;
        return new $2fb96651e8aa1522$var$BBox7(x, y, width, height);
    }
    isPointInPath(x, y) {
        const bbox = this.getBBox();
        return bbox.containsPoint(x, y);
    }
    updatePath() {
        const { centerX: centerX, centerY: centerY, path: path, gripPath: gripPath, strokeWidth: strokeWidth, cornerRadius: cornerRadius, grip: grip } = this;
        const pixelAlign = strokeWidth / 2;
        const pixelRatio = this.layerManager?.canvas?.pixelRatio ?? 1;
        path.clear();
        gripPath.clear();
        const halfWidth = Math.floor(this.width / 2 * pixelRatio) / pixelRatio;
        const halfHeight = Math.floor(this.height / 2 * pixelRatio) / pixelRatio;
        path.roundRect(centerX - halfWidth + pixelAlign, centerY - halfHeight + pixelAlign, 2 * (halfWidth - pixelAlign), 2 * (halfHeight - pixelAlign), cornerRadius);
        const gripSpacing = 3;
        if (grip) {
            for(let x = -0.5; x <= 0.5; x += 1)for(let y = -1; y <= 1; y += 1){
                gripPath.arc(centerX + x * gripSpacing, centerY + y * gripSpacing, 1, 0, 2 * Math.PI);
                gripPath.closePath();
            }
        }
    }
    renderFill(ctx, path) {
        const { stroke: stroke2 } = this;
        super.renderFill(ctx, path);
        ctx.fillStyle = typeof stroke2 === "string" ? stroke2 : "black";
        ctx.fill(this.gripPath.getPath2D());
    }
};
$2fb96651e8aa1522$var$RangeHandle.className = "RangeHandle";
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property44,
    $2fb96651e8aa1522$var$SceneChangeDetection2()
], $2fb96651e8aa1522$var$RangeHandle.prototype, "width", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property44,
    $2fb96651e8aa1522$var$SceneChangeDetection2()
], $2fb96651e8aa1522$var$RangeHandle.prototype, "height", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property44,
    $2fb96651e8aa1522$var$SceneChangeDetection2()
], $2fb96651e8aa1522$var$RangeHandle.prototype, "cornerRadius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property44,
    $2fb96651e8aa1522$var$SceneChangeDetection2()
], $2fb96651e8aa1522$var$RangeHandle.prototype, "grip", 2);
var { Path: $2fb96651e8aa1522$var$Path6, BBox: $2fb96651e8aa1522$var$BBox8, ExtendedPath2D: $2fb96651e8aa1522$var$ExtendedPath2D2, clippedRoundRect: $2fb96651e8aa1522$var$clippedRoundRect, Property: $2fb96651e8aa1522$var$Property45, SceneChangeDetection: $2fb96651e8aa1522$var$SceneChangeDetection3 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RangeMask = class extends $2fb96651e8aa1522$var$Path6 {
    constructor(){
        super(...arguments);
        this.cornerRadius = 4;
        this.zIndex = 2;
        this.x = 0;
        this.y = 0;
        this.width = 200;
        this.height = 30;
        this.min = 0;
        this.max = 1;
        this.visiblePath = new $2fb96651e8aa1522$var$ExtendedPath2D2();
    }
    layout(x, y, width, height, min, max) {
        min = isNaN(min) ? this.min : min;
        max = isNaN(max) ? this.max : max;
        if (x !== this.x || y !== this.y || width !== this.width || this.height !== height || min !== this.min || max !== this.max) {
            this.x = x;
            this.y = y;
            this.width = width;
            this.height = height;
            this.min = min;
            this.max = max;
            this.dirtyPath = true;
            this.markDirty("RangeMask.layout");
        }
    }
    computeBBox() {
        const { x: x, y: y, width: width, height: height } = this;
        return new $2fb96651e8aa1522$var$BBox8(x, y, width, height);
    }
    computeVisibleRangeBBox() {
        const { x: x, y: y, width: width, height: height, min: min, max: max } = this;
        const minX = x + width * min;
        const maxX = x + width * max;
        return new $2fb96651e8aa1522$var$BBox8(minX, y, maxX - minX, height);
    }
    updatePath() {
        const { path: path, visiblePath: visiblePath, x: x, y: y, width: width, height: height, min: min, max: max, strokeWidth: strokeWidth, cornerRadius: cornerRadius } = this;
        const pixelAlign = strokeWidth / 2;
        path.clear();
        visiblePath.clear();
        const ax = this.align(x) + pixelAlign;
        const ay = this.align(y) + pixelAlign;
        const aw = this.align(x, width) - 2 * pixelAlign;
        const ah = this.align(y, height) - 2 * pixelAlign;
        const minX = this.align(x + width * min) + pixelAlign;
        const maxX = minX + this.align(x + width * min, width * (max - min)) - 2 * pixelAlign;
        const cornerRadiusParams = {
            topLeft: cornerRadius,
            topRight: cornerRadius,
            bottomRight: cornerRadius,
            bottomLeft: cornerRadius
        };
        $2fb96651e8aa1522$var$clippedRoundRect(path, ax, ay, aw, ah, cornerRadiusParams, new $2fb96651e8aa1522$var$BBox8(ax, ay, minX - ax, ah));
        $2fb96651e8aa1522$var$clippedRoundRect(path, ax, ay, aw, ah, cornerRadiusParams, new $2fb96651e8aa1522$var$BBox8(maxX, ay, aw + ax - maxX, ah));
        if (maxX - minX > 1) $2fb96651e8aa1522$var$clippedRoundRect(visiblePath, ax, ay, aw, ah, cornerRadiusParams, new $2fb96651e8aa1522$var$BBox8(minX, ay, maxX - minX, ah));
    }
    renderStroke(ctx, path) {
        super.renderStroke(ctx, path);
        super.renderStroke(ctx, this.visiblePath.getPath2D());
    }
};
$2fb96651e8aa1522$var$RangeMask.className = "RangeMask";
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property45,
    $2fb96651e8aa1522$var$SceneChangeDetection3()
], $2fb96651e8aa1522$var$RangeMask.prototype, "cornerRadius", 2);
var $2fb96651e8aa1522$var$RangeSelector = class extends (0, $iTJTu._ModuleSupport).Group {
    constructor(children){
        super({
            name: "rangeSelectorGroup",
            zIndex: (0, $iTJTu._ModuleSupport).ZIndexMap.NAVIGATOR
        });
        this.x = 0;
        this.y = 0;
        this.width = 200;
        this.height = 30;
        this.lOffset = 0;
        this.rOffset = 0;
        this.background = this.appendChild(new (0, $iTJTu._ModuleSupport).TranslatableGroup({
            name: "navigator-background",
            zIndex: 1
        }));
        this.append(children);
    }
    layout(x, y, width, height, lOffset, rOffset) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.lOffset = lOffset;
        this.rOffset = rOffset;
        this.background.translationX = x;
        this.background.translationY = y;
        this.markDirty("RangeSelector");
    }
    updateBackground(oldGroup, newGroup) {
        if (oldGroup != null) this.background.removeChild(oldGroup);
        if (newGroup != null) this.background.appendChild(newGroup);
        this.markDirty("RangeSelector");
    }
    computeBBox() {
        const { x: x, y: y, width: width, height: height, lOffset: lOffset, rOffset: rOffset } = this;
        return new (0, $iTJTu._ModuleSupport).BBox(x - lOffset, y, width + (lOffset + rOffset), height);
    }
};
// packages/ag-charts-enterprise/src/features/navigator/navigator.ts
var { BaseModuleInstance: $2fb96651e8aa1522$var$BaseModuleInstance2, ObserveChanges: $2fb96651e8aa1522$var$ObserveChanges4, Property: $2fb96651e8aa1522$var$Property46 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$Navigator = class extends $2fb96651e8aa1522$var$BaseModuleInstance2 {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.enabled = false;
        this.mask = new $2fb96651e8aa1522$var$RangeMask();
        this.minHandle = new $2fb96651e8aa1522$var$RangeHandle();
        this.maxHandle = new $2fb96651e8aa1522$var$RangeHandle();
        this.maskVisibleRange = {
            id: "navigator-mask-visible-range",
            getBBox: ()=>this.mask.computeVisibleRangeBBox(),
            toCanvasBBox: ()=>this.mask.computeVisibleRangeBBox(),
            fromCanvasPoint: (x, y)=>({
                    x: x,
                    y: y
                })
        };
        this.height = 30;
        this.cornerRadius = 0;
        this.spacing = 10;
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.rangeSelector = new $2fb96651e8aa1522$var$RangeSelector([
            this.mask,
            this.minHandle,
            this.maxHandle
        ]);
        this.destroyFns.push(ctx.scene.attachNode(this.rangeSelector), this.ctx.localeManager.addListener("locale-changed", ()=>this.updateZoom()), this.ctx.layoutManager.registerElement((0, $iTJTu._ModuleSupport).LayoutElement.Navigator, (e)=>this.onLayoutStart(e)), this.ctx.layoutManager.addListener("layout:complete", (e)=>this.onLayoutComplete(e)), ctx.zoomManager.addListener("zoom-change", (event)=>this.onZoomChange(event)));
        this.domProxy = new $2fb96651e8aa1522$var$NavigatorDOMProxy(ctx, this);
        this.updateGroupVisibility();
        this.miniChart = new $2fb96651e8aa1522$var$MiniChart(ctx);
    }
    updateBackground(oldGroup, newGroup) {
        this.rangeSelector?.updateBackground(oldGroup, newGroup);
    }
    updateGroupVisibility() {
        const { enabled: enabled } = this;
        if (this.rangeSelector == null || enabled === this.rangeSelector.visible) return;
        this.rangeSelector.visible = enabled;
        this.domProxy.updateVisibility(enabled);
        if (enabled) this.updateZoom();
        else this.ctx.zoomManager.updateZoom("navigator");
    }
    onLayoutStart(ctx) {
        if (this.enabled) {
            const { layoutBox: layoutBox } = ctx;
            const navigatorTotalHeight = this.height + this.spacing;
            layoutBox.shrink(navigatorTotalHeight, "bottom");
            this.y = layoutBox.y + layoutBox.height + this.spacing;
        } else this.y = 0;
        if (this.enabled && this.miniChart) {
            const { top: top, bottom: bottom } = this.miniChart.computeAxisPadding();
            ctx.layoutBox.shrink(top + bottom, "bottom");
            this.y -= bottom;
            this.miniChart.inset = this.mask.strokeWidth / 2;
            this.miniChart.cornerRadius = this.mask.cornerRadius;
        }
    }
    onLayoutComplete(opts) {
        const { x: x, width: width } = opts.series.rect;
        const { y: y, height: height } = this;
        this.domProxy.updateVisibility(this.enabled);
        if (this.enabled) {
            const { _min: min, _max: max } = this.domProxy;
            this.layoutNodes(x, y, width, height, min, max);
            this.domProxy.updateBounds({
                x: x,
                y: y,
                width: width,
                height: height
            });
        }
        this.x = x;
        this.width = width;
        this.miniChart?.layout(width, height).catch((e)=>(0, $idDdm.Logger).error(e));
    }
    canDrag() {
        return this.enabled && this.ctx.interactionManager.isState((0, $iTJTu._ModuleSupport).InteractionState.ZoomDraggable);
    }
    onDragStart(dragging, { offsetX: offsetX }) {
        if (!this.canDrag()) return;
        if (dragging === "pan") this.panStart = (offsetX - this.x) / this.width - this.domProxy._min;
        this.ctx.zoomManager.fireZoomPanStartEvent("navigator");
    }
    onDrag(dragging, { offsetX: offsetX }) {
        if (!this.canDrag()) return;
        const { panStart: panStart, x: x, width: width } = this;
        const { minRange: minRange } = this.domProxy;
        let { _min: min, _max: max } = this.domProxy;
        const ratio3 = (offsetX - x) / width;
        if (dragging === "min") min = (0, $idDdm.clamp)(0, ratio3, max - minRange);
        else if (dragging === "max") max = (0, $idDdm.clamp)(min + minRange, ratio3, 1);
        else if (dragging === "pan" && panStart != null) {
            const span = max - min;
            min = (0, $idDdm.clamp)(0, ratio3 - panStart, 1 - span);
            max = min + span;
        }
        this.domProxy._min = min;
        this.domProxy._max = max;
        this.updateZoom();
    }
    onZoomChange(event) {
        const { x: xZoom } = event;
        if (!xZoom) return;
        const { x: x, y: y, width: width, height: height } = this;
        const { min: min, max: max } = xZoom;
        this.domProxy.updateMinMax(min, max);
        this.layoutNodes(x, y, width, height, min, max);
    }
    layoutNodes(x, y, width, height, min, max) {
        const { rangeSelector: rangeSelector, mask: mask, minHandle: minHandle, maxHandle: maxHandle } = this;
        mask.layout(x, y, width, height, min, max);
        rangeSelector.layout(x, y, width, height, minHandle.width / 2, maxHandle.width / 2);
        $2fb96651e8aa1522$var$RangeHandle.align(minHandle, maxHandle, x, y, width, height, min, max, mask.strokeWidth / 2);
        if (min + (max - min) / 2 < 0.5) {
            minHandle.zIndex = 3;
            maxHandle.zIndex = 4;
        } else {
            minHandle.zIndex = 4;
            maxHandle.zIndex = 3;
        }
        [
            minHandle,
            this.maskVisibleRange,
            maxHandle
        ].forEach((node, index)=>{
            const bbox = node.getBBox();
            const tbox = {
                x: bbox.x - x,
                y: bbox.y - y,
                height: bbox.height,
                width: bbox.width
            };
            this.domProxy.updateSliderBounds(index, tbox);
        });
    }
    updateZoom() {
        if (!this.enabled) return;
        this.domProxy.updateZoom();
    }
    updateData(data) {
        return this.miniChart?.updateData(data);
    }
    async processData(dataController) {
        if (this.miniChart) return this.miniChart?.processData(dataController);
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ObserveChanges4((target, value, oldValue)=>{
        target.updateBackground(oldValue?.root, value?.root);
    })
], $2fb96651e8aa1522$var$Navigator.prototype, "miniChart", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property46,
    $2fb96651e8aa1522$var$ObserveChanges4((target, value)=>{
        target.ctx.zoomManager.setNavigatorEnabled(Boolean(value));
        target.updateGroupVisibility();
    })
], $2fb96651e8aa1522$var$Navigator.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property46
], $2fb96651e8aa1522$var$Navigator.prototype, "height", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property46,
    $2fb96651e8aa1522$var$ObserveChanges4((target, value)=>{
        target.mask.cornerRadius = value;
    })
], $2fb96651e8aa1522$var$Navigator.prototype, "cornerRadius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property46
], $2fb96651e8aa1522$var$Navigator.prototype, "spacing", 2);
var $2fb96651e8aa1522$var$NAVIGATOR_THEME = {
    enabled: false,
    // TODO: AG-10781 Breaking Change
    // height: { $if: [{ $path: './miniChart/enabled' }, 40, 18] },
    height: 18,
    cornerRadius: 4,
    mask: {
        fill: {
            $ref: "foregroundColor"
        },
        fillOpacity: 0.1,
        stroke: {
            $ref: "borderColor"
        },
        strokeWidth: 1
    },
    minHandle: {
        fill: {
            $ref: "backgroundColor"
        },
        stroke: {
            $ref: "borderColor"
        },
        strokeWidth: 1,
        width: 12,
        height: 24,
        cornerRadius: 4
    },
    maxHandle: {
        fill: {
            $ref: "backgroundColor"
        },
        stroke: {
            $ref: "borderColor"
        },
        strokeWidth: 1,
        width: 12,
        height: 24,
        cornerRadius: 4
    },
    miniChart: {
        enabled: false,
        label: {
            color: {
                $ref: "textColor"
            },
            fontSize: {
                $rem: [
                    (0, $iTJTu._ModuleSupport).FONT_SIZE_RATIO.SMALLER
                ]
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            fontWeight: {
                $ref: "fontWeight"
            },
            spacing: 5
        },
        padding: {
            top: 0,
            bottom: 0
        }
    }
};
// packages/ag-charts-enterprise/src/features/navigator/navigatorModule.ts
var $2fb96651e8aa1522$var$NavigatorModule = {
    type: "root",
    optionsKey: "navigator",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$Navigator(ctx),
    removable: false,
    // Toggling this module causes zoom state flakiness.
    themeTemplate: {
        navigator: $2fb96651e8aa1522$var$NAVIGATOR_THEME
    }
};
var { ToolbarButtonProperties: $2fb96651e8aa1522$var$ToolbarButtonProperties3, Property: $2fb96651e8aa1522$var$Property47 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RangesButtonProperties = class extends $2fb96651e8aa1522$var$ToolbarButtonProperties3 {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property47
], $2fb96651e8aa1522$var$RangesButtonProperties.prototype, "value", 2);
// packages/ag-charts-enterprise/src/features/ranges/ranges.ts
var { ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection13, LayoutElement: $2fb96651e8aa1522$var$LayoutElement3, PropertiesArray: $2fb96651e8aa1522$var$PropertiesArray4, Toolbar: $2fb96651e8aa1522$var$Toolbar, Property: $2fb96651e8aa1522$var$Property48 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$Ranges = class extends (0, $iTJTu._ModuleSupport).BaseModuleInstance {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.enabled = false;
        this.buttons = new $2fb96651e8aa1522$var$PropertiesArray4($2fb96651e8aa1522$var$RangesButtonProperties);
        this.verticalSpacing = 10;
        this.container = ctx.domManager.addChild("canvas-overlay", "range-buttons");
        this.container.role = "presentation";
        this.toolbar = new $2fb96651e8aa1522$var$Toolbar(this.ctx.localeManager);
        this.toolbar.addClass("ag-charts-range-buttons");
        this.container.append(this.toolbar.getElement());
        this.destroyFns.push(this.toolbar.addToolbarListener("button-pressed", this.onButtonPress.bind(this)), ctx.layoutManager.registerElement($2fb96651e8aa1522$var$LayoutElement3.ToolbarBottom, this.onLayoutStart.bind(this)), ctx.zoomManager.addListener("zoom-change", this.onZoomChanged.bind(this)), this.teardown.bind(this));
    }
    teardown() {
        this.container.removeChild(this.toolbar.getElement());
        this.toolbar.destroy();
    }
    onLayoutStart(event) {
        const { buttons: buttons2, ctx: ctx, enabled: enabled, toolbar: toolbar2, verticalSpacing: verticalSpacing } = this;
        const { layoutBox: layoutBox } = event;
        if (!enabled || !ctx.zoomManager.isZoomEnabled()) {
            toolbar2.setHidden(true);
            return;
        }
        toolbar2.setHidden(false);
        toolbar2.updateButtons(buttons2);
        const height = toolbar2.getBounds().height;
        toolbar2.setBounds({
            x: layoutBox.x,
            y: layoutBox.y + layoutBox.height - height,
            width: layoutBox.width,
            height: height
        });
        layoutBox.shrink({
            bottom: height + verticalSpacing
        });
    }
    onZoomChanged() {
        this.toolbar.clearActiveButton();
    }
    onButtonPress({ button: { index: index } }) {
        const { zoomManager: zoomManager } = this.ctx;
        const button = this.buttons.at(index);
        if (!button) return;
        const { value: value } = button;
        if (typeof value === "number") zoomManager.extendToEnd("zoom-buttons", $2fb96651e8aa1522$var$ChartAxisDirection13.X, value);
        else if (Array.isArray(value)) zoomManager.updateWith("zoom-buttons", $2fb96651e8aa1522$var$ChartAxisDirection13.X, ()=>value);
        else if (typeof value === "function") zoomManager.updateWith("zoom-buttons", $2fb96651e8aa1522$var$ChartAxisDirection13.X, value);
        this.toolbar.toggleActiveButtonByIndex(index);
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property48
], $2fb96651e8aa1522$var$Ranges.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property48
], $2fb96651e8aa1522$var$Ranges.prototype, "buttons", 2);
// packages/ag-charts-enterprise/src/features/ranges/rangesModule.ts
var $2fb96651e8aa1522$var$DAY = 86400000;
var $2fb96651e8aa1522$var$MONTH = $2fb96651e8aa1522$var$DAY * 30;
var $2fb96651e8aa1522$var$YEAR = $2fb96651e8aa1522$var$DAY * 365;
var $2fb96651e8aa1522$var$RangesModule = {
    type: "root",
    optionsKey: "ranges",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$Ranges(ctx),
    themeTemplate: {
        ranges: {
            enabled: false,
            buttons: [
                {
                    label: "toolbarRange1Month",
                    ariaLabel: "toolbarRange1MonthAria",
                    value: $2fb96651e8aa1522$var$MONTH
                },
                {
                    label: "toolbarRange3Months",
                    ariaLabel: "toolbarRange3MonthsAria",
                    value: 3 * $2fb96651e8aa1522$var$MONTH
                },
                {
                    label: "toolbarRange6Months",
                    ariaLabel: "toolbarRange6MonthsAria",
                    value: 6 * $2fb96651e8aa1522$var$MONTH
                },
                {
                    label: "toolbarRangeYearToDate",
                    ariaLabel: "toolbarRangeYearToDateAria",
                    value: (_start, end)=>[
                            /* @__PURE__ */ new Date(`${new Date(end).getFullYear()}-01-01`).getTime(),
                            end
                        ]
                },
                {
                    label: "toolbarRange1Year",
                    ariaLabel: "toolbarRange1YearAria",
                    value: $2fb96651e8aa1522$var$YEAR
                },
                {
                    label: "toolbarRangeAll",
                    ariaLabel: "toolbarRangeAllAria",
                    value: (start, end)=>[
                            start,
                            end
                        ]
                }
            ]
        }
    }
};
var $2fb96651e8aa1522$var$_SharedToolbar = class _SharedToolbar extends (0, $iTJTu._ModuleSupport).BaseModuleInstance {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.activeSections = /* @__PURE__ */ new Set();
        this.sectionButtons = {
            annotations: [],
            chartToolbar: []
        };
        this.container = this.ctx.domManager.addChild("canvas-overlay", "shared-toolbar");
        this.container.role = "presentation";
    }
    getSharedToolbar(section) {
        if (!this.sharedToolbar) this.createSharedToolbar();
        return this.toolbarWithSection(section);
    }
    createSharedToolbar() {
        this.sharedToolbar = new (0, $iTJTu._ModuleSupport).Toolbar(this.ctx.localeManager, "vertical");
        this.sharedToolbar.addClass("ag-charts-shared-toolbar");
        this.container.append(this.sharedToolbar.getElement());
        this.destroyFns.push(()=>{
            if (!this.sharedToolbar) return;
            this.container.removeChild(this.sharedToolbar.getElement());
            this.sharedToolbar.destroy();
            this.sharedToolbar = void 0;
        });
    }
    toolbarWithSection(section) {
        const sharedToolbar = this.sharedToolbar;
        const withSection = {
            layout: (layoutBox, padding)=>{
                if (this.firstLayoutSection != null && this.firstLayoutSection !== section && this.activeSections.has(this.firstLayoutSection)) return;
                this.firstLayoutSection = section;
                const width = sharedToolbar.getBounds().width;
                sharedToolbar.setBounds({
                    x: layoutBox.x,
                    y: layoutBox.y,
                    width: width
                });
                layoutBox.shrink({
                    left: width + sharedToolbar.horizontalSpacing + (padding ?? 0)
                });
            },
            addToolbarListener: (eventType, handler)=>{
                return sharedToolbar.addToolbarListener(eventType, (sharedEvent)=>{
                    const sectionIndex = this.getSectionIndex(section, sharedEvent.button.index);
                    if (sectionIndex < 0) return;
                    const event = {
                        ...sharedEvent,
                        button: this.sectionButtons[section][sectionIndex]
                    };
                    handler(event);
                });
            },
            updateButtons: (buttons2)=>{
                this.sectionButtons[section] = buttons2;
                const sharedButtons = _SharedToolbar.SECTION_ORDER.flatMap((order)=>this.sectionButtons[order]);
                sharedToolbar.updateButtons(sharedButtons);
            },
            updateButtonByIndex: (index, button)=>{
                sharedToolbar.updateButtonByIndex(this.getIndex(section, index), button);
            },
            toggleActiveButtonByIndex: (index)=>{
                sharedToolbar.toggleActiveButtonByIndex(this.getIndex(section, index));
            },
            toggleButtonEnabledByIndex: (index, enabled)=>{
                sharedToolbar.toggleButtonEnabledByIndex(this.getIndex(section, index), enabled);
            },
            setHidden: (hidden)=>{
                if (hidden) this.activeSections.delete(section);
                else this.activeSections.add(section);
                let sum = 0;
                for (const order of _SharedToolbar.SECTION_ORDER){
                    if (order !== section) {
                        sum += this.sectionButtons[order].length;
                        continue;
                    }
                    for (const index of this.sectionButtons[section].keys())sharedToolbar.setButtonHiddenByIndex(sum + index, hidden);
                }
            },
            destroy: ()=>{
                withSection.setHidden(true);
                if (this.activeSections.size === 0) this.destroy();
            },
            clearActiveButton: sharedToolbar.clearActiveButton.bind(sharedToolbar),
            addListener: sharedToolbar.addListener.bind(sharedToolbar),
            removeListener: sharedToolbar.removeListener.bind(sharedToolbar)
        };
        withSection.setHidden(false);
        return withSection;
    }
    getIndex(section, index) {
        let sum = 0;
        for (const order of _SharedToolbar.SECTION_ORDER){
            if (order === section) return sum + index;
            sum += this.sectionButtons[order].length;
        }
        return -1;
    }
    getSectionIndex(section, index) {
        let sum = 0;
        for (const order of _SharedToolbar.SECTION_ORDER){
            if (order === section) {
                if (index >= sum + this.sectionButtons[section].length) return -1;
                return index - sum;
            }
            sum += this.sectionButtons[order].length;
        }
        return -1;
    }
};
$2fb96651e8aa1522$var$_SharedToolbar.SECTION_ORDER = [
    "chartToolbar",
    "annotations"
];
var $2fb96651e8aa1522$var$SharedToolbar = $2fb96651e8aa1522$var$_SharedToolbar;
// packages/ag-charts-enterprise/src/features/shared-toolbar/sharedToolbarModule.ts
var $2fb96651e8aa1522$var$SharedToolbarModule = {
    type: "context",
    contextKey: "sharedToolbar",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$SharedToolbar(ctx)
};
var { CachedTextMeasurerPool: $2fb96651e8aa1522$var$CachedTextMeasurerPool2, ZIndexMap: $2fb96651e8aa1522$var$ZIndexMap7, LayoutElement: $2fb96651e8aa1522$var$LayoutElement4, Property: $2fb96651e8aa1522$var$Property49, BaseProperties: $2fb96651e8aa1522$var$BaseProperties15, valueProperty: $2fb96651e8aa1522$var$valueProperty3, TextUtils: $2fb96651e8aa1522$var$TextUtils3, Group: $2fb96651e8aa1522$var$Group7, Label: $2fb96651e8aa1522$var$Label2, Rect: $2fb96651e8aa1522$var$Rect, Text: $2fb96651e8aa1522$var$Text } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$chartConfigurations = {
    ohlc: 62 /* Volume */ ,
    candlestick: 62 /* Volume */ ,
    "hollow-candlestick": 62 /* Volume */ ,
    line: 96 /* Volume */ ,
    "step-line": 96 /* Volume */ ,
    hlc: 184 /* Volume */ ,
    "high-low": 800 /* Volume */ 
};
var $2fb96651e8aa1522$var$itemIdMap = {
    up: "positive",
    down: "negative"
};
var $2fb96651e8aa1522$var$neutralColorMap = {
    hlc: "altNeutral"
};
var $2fb96651e8aa1522$var$StatusBarBackground = class extends $2fb96651e8aa1522$var$BaseProperties15 {
    constructor(){
        super(...arguments);
        this.fill = "black";
        this.fillOpacity = 1;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property49
], $2fb96651e8aa1522$var$StatusBarBackground.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property49
], $2fb96651e8aa1522$var$StatusBarBackground.prototype, "fillOpacity", 2);
var $2fb96651e8aa1522$var$StatusBar = class extends (0, $iTJTu._ModuleSupport).BaseModuleInstance {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.enabled = false;
        this.openKey = void 0;
        this.highKey = void 0;
        this.lowKey = void 0;
        this.closeKey = void 0;
        this.volumeKey = void 0;
        this.title = new $2fb96651e8aa1522$var$Label2();
        this.positive = new $2fb96651e8aa1522$var$Label2();
        this.negative = new $2fb96651e8aa1522$var$Label2();
        this.neutral = new $2fb96651e8aa1522$var$Label2();
        this.altNeutral = new $2fb96651e8aa1522$var$Label2();
        this.background = new $2fb96651e8aa1522$var$StatusBarBackground();
        this.layoutStyle = "block";
        this.id = "status-bar";
        this.data = void 0;
        this.layer = new $2fb96651e8aa1522$var$Group7({
            name: "StatusBar",
            zIndex: $2fb96651e8aa1522$var$ZIndexMap7.STATUS_BAR
        });
        this.labelGroup = this.layer.appendChild(new (0, $iTJTu._ModuleSupport).TranslatableGroup());
        this.backgroundNode = this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Rect());
        this.labels = [
            {
                label: "O",
                configuration: 2 /* Open */ ,
                title: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                value: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                id: "openValue",
                key: "openKey",
                domain: void 0,
                formatter: new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            },
            {
                label: "H",
                configuration: 16 /* High */ ,
                title: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                value: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                id: "highValue",
                key: "highKey",
                domain: void 0,
                formatter: new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            },
            {
                label: "H",
                configuration: 256 /* NeutralHigh */ ,
                title: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                value: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                style: "neutral",
                id: "highValue",
                key: "highKey",
                domain: void 0,
                formatter: new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            },
            {
                label: "L",
                configuration: 8 /* Low */ ,
                title: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                value: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                id: "lowValue",
                key: "lowKey",
                domain: void 0,
                formatter: new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            },
            {
                label: "L",
                configuration: 512 /* NeutralLow */ ,
                title: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                value: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                style: "neutral",
                id: "lowValue",
                key: "lowKey",
                domain: void 0,
                formatter: new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            },
            {
                label: "C",
                configuration: 4 /* Close */ ,
                title: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                value: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                id: "closeValue",
                key: "closeKey",
                domain: void 0,
                formatter: new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            },
            {
                label: "C",
                configuration: 128 /* NeutralClose */ ,
                title: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                value: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                id: "closeValue",
                key: "closeKey",
                style: "neutral",
                domain: void 0,
                formatter: new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            },
            {
                label: "",
                configuration: 64 /* UnlabelledClose */ ,
                title: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                value: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                style: "neutral",
                id: "closeValue",
                key: "closeKey",
                domain: void 0,
                formatter: new Intl.NumberFormat("en-US", {
                    notation: "compact",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            },
            {
                label: "Vol",
                configuration: 32 /* Volume */ ,
                title: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                value: this.labelGroup.appendChild(new $2fb96651e8aa1522$var$Text()),
                id: "volumeValue",
                key: "volumeKey",
                domain: void 0,
                formatter: new Intl.NumberFormat("en-US", {
                    notation: "compact",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            }
        ];
        this.highlightManager = ctx.highlightManager;
        this.labelGroup.visible = false;
        this.destroyFns.push(ctx.scene.attachNode(this.layer), ctx.layoutManager.registerElement($2fb96651e8aa1522$var$LayoutElement4.Overlay, (e)=>this.startPerformLayout(e)), ctx.layoutManager.addListener("layout:complete", (e)=>this.onLayoutComplete(e)), ctx.highlightManager.addListener("highlight-change", ()=>this.updateHighlight()));
    }
    async processData(dataController) {
        if (!this.enabled || this.data == null) return;
        const props = [];
        for (const label of this.labels){
            const { id: id, key: key } = label;
            const datumKey = this[key];
            if (datumKey == null) label.domain = void 0;
            else props.push($2fb96651e8aa1522$var$valueProperty3(datumKey, "number", {
                id: id
            }));
        }
        if (props.length === 0) return;
        const { processedData: processedData, dataModel: dataModel } = await dataController.request(this.id, this.data, {
            props: props
        });
        for (const label of this.labels){
            const { id: id, key: key } = label;
            const datumKey = this[key];
            if (datumKey != null) label.domain = dataModel.getDomain(this, id, "value", processedData);
        }
    }
    startPerformLayout(opts) {
        this.labelGroup.translationX = 0;
        this.labelGroup.translationY = 0;
        if (!this.enabled) return;
        const { layoutBox: layoutBox } = opts;
        const innerSpacing = 4;
        const outerSpacing = 12;
        const spacingAbove = 0;
        const spacingBelow = 8;
        this.labelGroup.translationY = layoutBox.y + spacingAbove;
        const maxFontSize = Math.max(this.title.fontSize, this.positive.fontSize, this.negative.fontSize);
        const lineHeight = $2fb96651e8aa1522$var$TextUtils3.getLineHeight(maxFontSize);
        const labelConfigurations = $2fb96651e8aa1522$var$chartConfigurations[this.getChartType()] ?? 0;
        let left = 0;
        let offsetTop;
        let textVAlign = "alphabetic";
        if (this.layoutStyle === "block") {
            layoutBox.shrink(spacingAbove + lineHeight + spacingBelow, "top");
            offsetTop = maxFontSize + (lineHeight - maxFontSize) / 2;
        } else {
            const { title: title } = this.ctx.chartService;
            textVAlign = "top";
            offsetTop = spacingAbove + title.padding;
            if (title.enabled) {
                const titleBox = title.node.getBBox();
                left = titleBox.x + titleBox.width + outerSpacing;
            } else left = title.padding;
        }
        for (const { label: label, configuration: configuration, title: title, value: value, domain: domain, formatter: formatter } of this.labels){
            if (domain == null || (labelConfigurations & configuration) === 0) {
                title.visible = false;
                value.visible = false;
                continue;
            }
            const maxValueWidth = Math.max($2fb96651e8aa1522$var$CachedTextMeasurerPool2.measureText(formatter.format(domain[0]), {
                font: this.positive.getFont(),
                textBaseline: textVAlign,
                textAlign: "left"
            }).width, $2fb96651e8aa1522$var$CachedTextMeasurerPool2.measureText(formatter.format(domain[1]), {
                font: this.positive.getFont(),
                textBaseline: textVAlign,
                textAlign: "left"
            }).width, $2fb96651e8aa1522$var$CachedTextMeasurerPool2.measureText(formatter.format(domain[0]), {
                font: this.negative.getFont(),
                textBaseline: textVAlign,
                textAlign: "left"
            }).width, $2fb96651e8aa1522$var$CachedTextMeasurerPool2.measureText(formatter.format(domain[1]), {
                font: this.negative.getFont(),
                textBaseline: textVAlign,
                textAlign: "left"
            }).width);
            title.visible = true;
            value.visible = true;
            const titleMetrics = $2fb96651e8aa1522$var$CachedTextMeasurerPool2.measureText(label, {
                font: this.title.getFont(),
                textBaseline: textVAlign,
                textAlign: "left"
            });
            title.setFont(this.title);
            title.fill = this.title.color;
            title.text = label;
            title.textBaseline = textVAlign;
            title.y = offsetTop;
            title.x = left;
            left += titleMetrics.width + innerSpacing;
            value.textBaseline = textVAlign;
            value.y = offsetTop;
            value.x = left;
            left += maxValueWidth + outerSpacing;
        }
        this.backgroundNode.x = 0;
        this.backgroundNode.y = 0;
        this.backgroundNode.width = left - outerSpacing;
        this.backgroundNode.height = lineHeight + spacingAbove + spacingBelow;
        this.backgroundNode.fill = this.background.fill;
        this.backgroundNode.fillOpacity = this.background.fillOpacity;
    }
    onLayoutComplete(opts) {
        this.labelGroup.translationX = opts.series.rect.x;
        this.updateHighlight();
    }
    updateHighlight() {
        if (!this.enabled) return;
        const activeHighlight = this.highlightManager.getActiveHighlight();
        const datum = activeHighlight?.datum ?? this.data?.at(-1);
        if (datum == null) {
            this.labelGroup.visible = false;
            return;
        }
        this.labelGroup.visible = true;
        const itemId = activeHighlight?.itemId;
        let baseStyle = itemId != null ? $2fb96651e8aa1522$var$itemIdMap[itemId] : void 0;
        if (baseStyle == null && this.openKey != null && this.closeKey != null) {
            if (datum[this.openKey] < datum[this.closeKey]) baseStyle = "positive";
            else baseStyle = "negative";
        }
        for (const { domain: domain, value: value, key: key, formatter: formatter, style: style } of this.labels){
            if (domain == null) continue;
            let labelStyle = style ?? baseStyle ?? "neutral";
            if (labelStyle === "neutral") labelStyle = $2fb96651e8aa1522$var$neutralColorMap[this.getChartType()] ?? labelStyle;
            const datumKey = this[key];
            const datumValue = datumKey != null ? datum?.[datumKey] : void 0;
            value.setFont(this[labelStyle]);
            value.fill = this[labelStyle].color;
            value.text = typeof datumValue === "number" ? formatter.format(datumValue) : "";
        }
    }
    getChartType() {
        let chartType = this.ctx.chartService.publicApi?.getOptions()?.chartType;
        if (chartType == null || $2fb96651e8aa1522$var$chartConfigurations[chartType] == null) chartType = "candlestick";
        return chartType;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property49
], $2fb96651e8aa1522$var$StatusBar.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property49
], $2fb96651e8aa1522$var$StatusBar.prototype, "openKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property49
], $2fb96651e8aa1522$var$StatusBar.prototype, "highKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property49
], $2fb96651e8aa1522$var$StatusBar.prototype, "lowKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property49
], $2fb96651e8aa1522$var$StatusBar.prototype, "closeKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property49
], $2fb96651e8aa1522$var$StatusBar.prototype, "volumeKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property49
], $2fb96651e8aa1522$var$StatusBar.prototype, "title", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property49
], $2fb96651e8aa1522$var$StatusBar.prototype, "positive", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property49
], $2fb96651e8aa1522$var$StatusBar.prototype, "negative", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property49
], $2fb96651e8aa1522$var$StatusBar.prototype, "neutral", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property49
], $2fb96651e8aa1522$var$StatusBar.prototype, "altNeutral", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property49
], $2fb96651e8aa1522$var$StatusBar.prototype, "background", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property49
], $2fb96651e8aa1522$var$StatusBar.prototype, "layoutStyle", 2);
// packages/ag-charts-enterprise/src/features/status-bar/statusBarModule.ts
var $2fb96651e8aa1522$var$StatusBarModule = {
    type: "root",
    identifier: "status-bar",
    optionsKey: "statusBar",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$StatusBar(ctx),
    themeTemplate: {
        statusBar: {
            enabled: false,
            layoutStyle: (0, $iTJTu._ModuleSupport).ThemeSymbols.DEFAULT_CAPTION_LAYOUT_STYLE,
            title: {
                color: {
                    $ref: "textColor"
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontSize: {
                    $ref: "fontSize"
                },
                fontWeight: {
                    $ref: "fontWeight"
                }
            },
            positive: {
                color: {
                    $palette: "up.stroke"
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontSize: {
                    $ref: "fontSize"
                },
                fontWeight: {
                    $ref: "fontWeight"
                }
            },
            negative: {
                color: {
                    $palette: "down.stroke"
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontSize: {
                    $ref: "fontSize"
                },
                fontWeight: {
                    $ref: "fontWeight"
                }
            },
            neutral: {
                color: {
                    $palette: "neutral.stroke"
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontSize: {
                    $ref: "fontSize"
                },
                fontWeight: {
                    $ref: "fontWeight"
                }
            },
            background: {
                fill: {
                    $ref: "backgroundColor"
                },
                fillOpacity: 0.5
            },
            altNeutral: {
                color: "gray",
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontSize: {
                    $ref: "fontSize"
                },
                fontWeight: {
                    $ref: "fontWeight"
                }
            }
        }
    }
};
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties16, CartesianAxis: $2fb96651e8aa1522$var$CartesianAxis, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection14, ContinuousScale: $2fb96651e8aa1522$var$ContinuousScale4, ChartUpdateType: $2fb96651e8aa1522$var$ChartUpdateType2, ObserveChanges: $2fb96651e8aa1522$var$ObserveChanges5, TooltipManager: $2fb96651e8aa1522$var$TooltipManager, Property: $2fb96651e8aa1522$var$Property50, findMinMax: $2fb96651e8aa1522$var$findMinMax2, isObjectWithStringProperty: $2fb96651e8aa1522$var$isObjectWithStringProperty } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$debug = (0, $iTJTu._ModuleSupport).Debug.create("sync");
function $2fb96651e8aa1522$var$getDirectionKeys(series, primary, secondary) {
    const primaryKeys = series.getKeys(primary);
    const secondaryKeys = series.getKeys(secondary);
    if (series.shouldFlipXY?.()) return [
        secondaryKeys,
        primaryKeys
    ];
    return [
        primaryKeys,
        secondaryKeys
    ];
}
function $2fb96651e8aa1522$var$syncedDirections(axes = "x") {
    switch(axes){
        case "x":
            return [
                $2fb96651e8aa1522$var$ChartAxisDirection14.X
            ];
        case "y":
            return [
                $2fb96651e8aa1522$var$ChartAxisDirection14.Y
            ];
        case "xy":
            return [
                $2fb96651e8aa1522$var$ChartAxisDirection14.X,
                $2fb96651e8aa1522$var$ChartAxisDirection14.Y
            ];
    }
}
var $2fb96651e8aa1522$var$ChartSync = class extends $2fb96651e8aa1522$var$BaseProperties16 {
    constructor(moduleContext){
        super();
        this.moduleContext = moduleContext;
        this.enabled = false;
        this.axes = "x";
        this.nodeInteraction = true;
        this.zoom = true;
        this.domainMode = "key";
        this.domainSync = new (0, $idDdm.AsyncAwaitQueue)();
    }
    updateSiblings(groupId) {
        const { syncManager: syncManager } = this.moduleContext;
        for (const chart of syncManager.getGroupSiblings(groupId ?? this.groupId)){
            $2fb96651e8aa1522$var$debug("ChartSync.updateSiblings()", chart.id, chart);
            this.updateChart(chart);
        }
    }
    updateChart(chart, updateType = $2fb96651e8aa1522$var$ChartUpdateType2.PROCESS_DOMAIN) {
        $2fb96651e8aa1522$var$debug("ChartSync.updateChart()", chart.id, $2fb96651e8aa1522$var$ChartUpdateType2[updateType], chart);
        if (updateType === $2fb96651e8aa1522$var$ChartUpdateType2.PROCESS_DOMAIN) chart.ctx.updateService.update(updateType, {
            forceNodeDataRefresh: true
        });
        else chart.ctx.updateService.update(updateType);
    }
    enabledZoomSync() {
        const { syncManager: syncManager, zoomManager: zoomManager } = this.moduleContext;
        this.disableZoomSync?.();
        this.disableZoomSync = zoomManager.addListener("zoom-change", ()=>{
            for (const chart of syncManager.getGroupSiblings(this.groupId))if (chart.modulesManager.getModule("sync")?.zoom) chart.ctx.zoomManager.updateZoom("sync", this.mergeZoom(chart));
        });
    }
    enabledNodeInteractionSync() {
        const { highlightManager: highlightManager } = this.moduleContext;
        this.disableNodeInteractionSync?.();
        this.disableNodeInteractionSync = highlightManager.addListener("highlight-change", this.onHighlightChange.bind(this));
    }
    onHighlightChange(event) {
        const { syncManager: syncManager } = this.moduleContext;
        if (event.callerId.endsWith("-sync")) return;
        $2fb96651e8aa1522$var$debug("ChartSync.onHighlightChange()", event);
        const series = event.currentHighlight?.series;
        const [mainDirection] = $2fb96651e8aa1522$var$syncedDirections(this.axes);
        const secondaryDirection = mainDirection === $2fb96651e8aa1522$var$ChartAxisDirection14.X ? $2fb96651e8aa1522$var$ChartAxisDirection14.Y : $2fb96651e8aa1522$var$ChartAxisDirection14.X;
        const [primaryKeys, secondaryKeys] = series ? $2fb96651e8aa1522$var$getDirectionKeys(series, mainDirection, secondaryDirection) : [];
        let eventValue = primaryKeys?.[0] ? event.currentHighlight?.datum?.[primaryKeys[0]] : void 0;
        const valueIsDate = (0, $idDdm.isDate)(eventValue);
        if (valueIsDate) eventValue = eventValue.getTime();
        if (!event.currentHighlight?.datum) {
            for (const chart of syncManager.getGroupSiblings(this.groupId)){
                if (!chart.modulesManager.getModule("sync")?.nodeInteraction) continue;
                chart.ctx.highlightManager.updateHighlight(`${chart.id}-sync`);
                chart.ctx.tooltipManager.removeTooltip(`${chart.id}-sync`);
            }
            return;
        }
        const useSecondaryDirectionKey = syncManager.getGroupSyncMode(this.groupId) === "multi-series";
        this.findMatchingHighlightNodes(mainDirection, secondaryDirection, useSecondaryDirectionKey ? secondaryKeys : [], valueIsDate, eventValue, event);
    }
    findMatchingHighlightNodes(primaryDirection, secondaryDirection, secondaryKeys, valueIsDate, eventValue, event) {
        const { syncManager: syncManager } = this.moduleContext;
        $2fb96651e8aa1522$var$debug("ChartSync.findMatchingHighlightNodes()", {
            mainDirection: primaryDirection,
            secondaryKeys: secondaryKeys
        });
        for (const chart of syncManager.getGroupSiblings(this.groupId)){
            if (!chart.modulesManager.getModule("sync")?.nodeInteraction) continue;
            let dispatched = false;
            for (const axis of chart.axes){
                if (!$2fb96651e8aa1522$var$CartesianAxis.is(axis) || axis.direction !== primaryDirection) continue;
                const matchingNodes = chart.series.filter((s)=>{
                    if (!s.visible) return false;
                    if (secondaryKeys.length > 0) {
                        const [, seriesKeys] = $2fb96651e8aa1522$var$getDirectionKeys(s, primaryDirection, secondaryDirection);
                        return secondaryKeys.every((key)=>seriesKeys.includes(key));
                    }
                    return true;
                }).map(this.findMatchingNodes(axis, primaryDirection, valueIsDate, eventValue)).filter((0, $idDdm.isDefined));
                if (matchingNodes.length === 1 && matchingNodes[0]?.nodeDatum !== chart.ctx.highlightManager.getActiveHighlight()) {
                    this.dispatchHighlightUpdate(chart, matchingNodes[0].nodeDatum);
                    dispatched = true;
                    break;
                }
            }
            if (!dispatched) {
                $2fb96651e8aa1522$var$debug("ChartSync.findMatchingHighlightNodes() - no matching nodes", chart.id, event);
                this.dispatchHighlightUpdate(chart);
            }
        }
    }
    findMatchingNodes(axis, mainDirection, valueIsDate, eventValue) {
        return (series)=>{
            const seriesKeys = series.getKeys(axis.direction);
            if (axis.keys.length && !axis.keys.some((key)=>seriesKeys.includes(key))) return;
            const nodeData = series.contextNodeData?.nodeData ?? [];
            if (!nodeData?.length) return;
            const firstNode = nodeData[0];
            const mainDirectionKey = `${mainDirection}Key`;
            if (!$2fb96651e8aa1522$var$isObjectWithStringProperty(firstNode, mainDirectionKey)) return;
            const valueKey = firstNode[mainDirectionKey];
            const nodeDatum = nodeData.find((datum)=>{
                const nodeValue = datum.datum[valueKey];
                return valueIsDate ? nodeValue.getTime() === eventValue : nodeValue === eventValue;
            });
            return nodeDatum ? {
                series: series,
                nodeDatum: nodeDatum
            } : null;
        };
    }
    dispatchHighlightUpdate(chart, nodeDatum) {
        $2fb96651e8aa1522$var$debug("ChartSync.dispatchHighlightUpdate()", chart.id, nodeDatum);
        chart.ctx.highlightManager.updateHighlight(`${chart.id}-sync`, nodeDatum);
        const tooltipEnabled = nodeDatum?.series.tooltipEnabled ?? chart.tooltip.enabled;
        if (nodeDatum && tooltipEnabled) {
            const bbox = chart.seriesAreaBoundingBox;
            const canvasX = bbox.x + (nodeDatum.midPoint?.x ?? nodeDatum.point?.x ?? 0);
            const canvasY = bbox.y + (nodeDatum.midPoint?.y ?? nodeDatum.point?.y ?? 0);
            const tooltipMeta = $2fb96651e8aa1522$var$TooltipManager.makeTooltipMeta({
                type: "pointermove",
                canvasX: canvasX,
                canvasY: canvasY
            }, nodeDatum.series, nodeDatum, void 0);
            chart.ctx.tooltipManager.updateTooltip(`${chart.id}-sync`, tooltipMeta, chart.getTooltipContent(nodeDatum.series, nodeDatum.datumIndex, nodeDatum));
        } else chart.ctx.tooltipManager.removeTooltip(`${chart.id}-sync`);
        this.updateChart(chart, $2fb96651e8aa1522$var$ChartUpdateType2.SERIES_UPDATE);
    }
    async getSyncedDomain(axis) {
        if (!$2fb96651e8aa1522$var$CartesianAxis.is(axis) || this.axes !== "xy" && this.axes !== axis.direction) return;
        const { groupState: groupState, directionDomains: directionDomains, domainsByKey: domainsByKey, positionDomains: positionDomains } = this.updateDomainState(axis);
        this.validateAxis(axis, groupState);
        await this.waitForDomainsToBeReady();
        if (this.domainMode === "position") return this.calculateDerivedDomain(axis, positionDomains);
        if (this.domainMode === "direction" || axis.keys.length === 0) return this.calculateDerivedDomain(axis, directionDomains);
        return this.calculateKeyDerivedDomain(axis, domainsByKey);
    }
    updateDomainState(axis) {
        var _a, _b, _c, _d, _e;
        const { syncManager: syncManager } = this.moduleContext;
        const chartId = syncManager.getChart().id;
        const axisId = axis.id;
        const groupState = syncManager.getGroupState(this.groupId);
        if (!groupState) throw new Error("AG Charts - no GroupState for groupId: " + this.groupId);
        const domainsByDirection = groupState.domains ?? (groupState.domains = {});
        const directionDomains = domainsByDirection[_a = axis.direction] ?? (domainsByDirection[_a] = {
            derived: [],
            sources: {},
            dirty: true
        });
        const chartDirectionDomains = (_b = directionDomains.sources)[chartId] ?? (_b[chartId] = {});
        chartDirectionDomains[axisId] = axis.dataDomain.domain;
        directionDomains.dirty = true;
        const domainsByKey = groupState.domainsByKey ?? (groupState.domainsByKey = {});
        for (const key of axis.keys ?? []){
            const keyDomains = domainsByKey[key] ?? (domainsByKey[key] = {
                derived: [],
                sources: {},
                dirty: true
            });
            const chartKeyDomains = (_c = keyDomains.sources)[chartId] ?? (_c[chartId] = {});
            chartKeyDomains[axisId] = axis.dataDomain.domain;
            keyDomains.dirty = true;
        }
        const domainsByPosition = groupState.domainsByPosition ?? (groupState.domainsByPosition = {});
        const positionDomains = domainsByPosition[_d = axis.position] ?? (domainsByPosition[_d] = {
            derived: [],
            sources: {},
            dirty: true
        });
        const chartPositionDomains = (_e = positionDomains.sources)[chartId] ?? (_e[chartId] = {});
        chartPositionDomains[axisId] = axis.dataDomain.domain;
        positionDomains.dirty = true;
        return {
            groupState: groupState,
            directionDomains: directionDomains,
            domainsByKey: domainsByKey,
            positionDomains: positionDomains
        };
    }
    validateAxis(axis, groupState) {
        const multiSeries = this.moduleContext.syncManager.getGroupSyncMode(this.groupId) === "multi-series";
        if (!$2fb96651e8aa1522$var$syncedDirections(this.axes).includes(axis.direction)) return;
        if (multiSeries) this.validateMultiSeries(axis, groupState);
        else this.validateSingleSeries(axis, groupState);
    }
    validateMultiSeries(axis, groupState) {
        const { min: min, max: max, nice: nice, reverse: reverse } = axis;
        const matchingKeys = new Set(axis.boundSeries.flatMap((s)=>s.getKeys(axis.direction)));
        for (const member of groupState.members){
            const { axes: axes, modulesManager: modulesManager } = member;
            const memberSyncDirections = $2fb96651e8aa1522$var$syncedDirections(modulesManager.getModule("sync")?.axes);
            const keyMatchedAxes = axes.filter((a)=>memberSyncDirections.includes(a.direction)).filter((a)=>a.boundSeries.some((s)=>s.getKeys(a.direction).some((k)=>matchingKeys.has(k))));
            if (keyMatchedAxes.length === 0) continue;
            const [firstAxis] = keyMatchedAxes;
            if (firstAxis.min !== min || firstAxis.max !== max || firstAxis.nice !== nice || firstAxis.reverse !== reverse) {
                (0, $idDdm.Logger).warnOnce("To allow synchronization, ensure that all synchronized axes with matching keys have matching min, max, nice, and reverse properties.");
                this.enabled = false;
                return;
            }
        }
    }
    validateSingleSeries(axis, groupState) {
        const members = groupState.members;
        const [{ axes: syncAxes }] = members;
        const { direction: direction, min: min, max: max, nice: nice, reverse: reverse } = axis;
        for (const nextAxis of syncAxes){
            if (direction !== nextAxis.direction) continue;
            if (nice !== nextAxis.nice || reverse !== nextAxis.reverse || min !== nextAxis.min && ((0, $idDdm.isFiniteNumber)(min) || (0, $idDdm.isFiniteNumber)(nextAxis.min)) || max !== nextAxis.max && ((0, $idDdm.isFiniteNumber)(max) || (0, $idDdm.isFiniteNumber)(nextAxis.max))) {
                (0, $idDdm.Logger).warnOnce("To allow synchronization, ensure that all charts have matching min, max, nice, and reverse properties on the synchronized axes.");
                this.enabled = false;
                return;
            }
        }
    }
    calculateDerivedDomain(axis, directionDomains) {
        if (!directionDomains.dirty) return directionDomains.derived;
        const previousDerived = directionDomains.derived;
        directionDomains.derived = (0, $idDdm.unique)(Object.values(directionDomains.sources).map((d)=>Object.values(d)).flat(2));
        if ($2fb96651e8aa1522$var$ContinuousScale4.is(axis.scale)) directionDomains.derived = $2fb96651e8aa1522$var$findMinMax2(directionDomains.derived);
        directionDomains.dirty = false;
        if (!(0, $idDdm.arraysEqual)(previousDerived, directionDomains.derived)) {
            $2fb96651e8aa1522$var$debug(axis.id, "updated", axis.keys, {
                before: previousDerived,
                after: directionDomains.derived
            });
            this.updateSiblings();
        }
        return directionDomains.derived;
    }
    calculateKeyDerivedDomain(axis, domainsByKey) {
        let previousDerived = [];
        let newDerived = [];
        let updated = false;
        for (const key of axis.keys ?? []){
            const keyDomains = domainsByKey[key];
            const previousDerivedForKey = keyDomains.derived;
            previousDerived.push(...previousDerivedForKey);
            if (!keyDomains.dirty) {
                newDerived.push(...keyDomains.derived);
                continue;
            }
            keyDomains.derived = (0, $idDdm.unique)(Object.values(keyDomains.sources).map((d)=>Object.values(d)).flat(2));
            if ($2fb96651e8aa1522$var$ContinuousScale4.is(axis.scale)) keyDomains.derived = $2fb96651e8aa1522$var$findMinMax2(keyDomains.derived);
            newDerived.push(...keyDomains.derived);
            keyDomains.dirty = false;
            updated || (updated = !(0, $idDdm.arraysEqual)(previousDerivedForKey, keyDomains.derived));
        }
        if ($2fb96651e8aa1522$var$ContinuousScale4.is(axis.scale)) {
            previousDerived = $2fb96651e8aa1522$var$findMinMax2(previousDerived);
            newDerived = $2fb96651e8aa1522$var$findMinMax2(newDerived);
        }
        if (updated && !(0, $idDdm.arraysEqual)(previousDerived, newDerived)) {
            $2fb96651e8aa1522$var$debug(axis.id, "updated", axis.keys, {
                before: previousDerived,
                after: newDerived
            });
            this.updateSiblings();
        }
        return newDerived;
    }
    removeAxis(axis) {
        if (!$2fb96651e8aa1522$var$CartesianAxis.is(axis) || this.axes !== "xy" && this.axes !== axis.direction) return;
        const { syncManager: syncManager } = this.moduleContext;
        const syncGroup = syncManager.getGroupState(this.groupId);
        const chartId = syncManager.getChart().id;
        const axisId = axis.id;
        delete syncGroup?.domains?.[axis.direction]?.sources?.[chartId]?.[axisId];
        for (const key of axis.keys ?? [])delete syncGroup?.domainsByKey?.[key]?.sources?.[chartId]?.[axisId];
        delete syncGroup?.domainsByPosition?.[axis.position]?.sources?.[chartId]?.[axisId];
    }
    async waitForDomainsToBeReady() {
        const { syncManager: syncManager } = this.moduleContext;
        let count = 0;
        while(syncManager.getGroupMembers(this.groupId).some((c)=>c.syncStatus === "init")){
            $2fb96651e8aa1522$var$debug("ChartSync.waitForDomainsToBeReady() - waiting for all domains to be calculated", this.groupId);
            await this.domainSync.await();
            count++;
        }
        if (count > 0) $2fb96651e8aa1522$var$debug("ChartSync.waitForDomainsToBeReady() - waited for", count, "iterations");
        this.domainSync.notify();
    }
    mergeZoom(chart) {
        const { zoomManager: zoomManager } = this.moduleContext;
        if (this.axes === "xy") return zoomManager.getZoom();
        const combinedZoom = chart.ctx.zoomManager.getZoom() ?? {};
        combinedZoom[this.axes] = zoomManager.getZoom()?.[this.axes];
        return combinedZoom;
    }
    onEnabledChange() {
        const { syncManager: syncManager } = this.moduleContext;
        if (this.enabled) syncManager.subscribe(this.groupId);
        else syncManager.unsubscribe(this.groupId);
        this.updateSiblings();
        this.onNodeInteractionChange();
        this.onZoomChange();
    }
    onGroupIdChange(newValue, oldValue) {
        if (!this.enabled || newValue === oldValue) return;
        const { syncManager: syncManager } = this.moduleContext;
        syncManager.unsubscribe(oldValue);
        syncManager.subscribe(newValue);
        this.updateSiblings(oldValue);
        this.updateSiblings(newValue);
    }
    onAxesChange() {
        if (!this.enabled) return;
        const { syncManager: syncManager } = this.moduleContext;
        this.updateChart(syncManager.getChart());
    }
    onNodeInteractionChange() {
        if (this.enabled && this.nodeInteraction) this.enabledNodeInteractionSync();
        else this.disableNodeInteractionSync?.();
    }
    onZoomChange() {
        if (this.enabled && this.zoom) this.enabledZoomSync();
        else this.disableZoomSync?.();
    }
    destroy() {
        const { syncManager: syncManager } = this.moduleContext;
        syncManager.unsubscribe(this.groupId);
        this.updateSiblings();
        this.disableZoomSync?.();
    }
};
$2fb96651e8aa1522$var$ChartSync.className = "Sync";
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property50,
    $2fb96651e8aa1522$var$ObserveChanges5((target)=>target.onEnabledChange())
], $2fb96651e8aa1522$var$ChartSync.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property50,
    $2fb96651e8aa1522$var$ObserveChanges5((target, newValue, oldValue)=>target.onGroupIdChange(newValue, oldValue))
], $2fb96651e8aa1522$var$ChartSync.prototype, "groupId", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property50,
    $2fb96651e8aa1522$var$ObserveChanges5((target)=>target.onAxesChange())
], $2fb96651e8aa1522$var$ChartSync.prototype, "axes", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property50,
    $2fb96651e8aa1522$var$ObserveChanges5((target)=>target.onNodeInteractionChange())
], $2fb96651e8aa1522$var$ChartSync.prototype, "nodeInteraction", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property50,
    $2fb96651e8aa1522$var$ObserveChanges5((target)=>target.onZoomChange())
], $2fb96651e8aa1522$var$ChartSync.prototype, "zoom", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property50,
    $2fb96651e8aa1522$var$ObserveChanges5((target)=>target.onAxesChange())
], $2fb96651e8aa1522$var$ChartSync.prototype, "domainMode", 2);
// packages/ag-charts-enterprise/src/features/sync/syncModule.ts
var $2fb96651e8aa1522$var$SyncModule = {
    type: "root",
    optionsKey: "sync",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$ChartSync(ctx),
    themeTemplate: {
        sync: {
            enabled: false
        }
    }
};
var { Property: $2fb96651e8aa1522$var$Property51 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$VALID_COLOR = "#2196f3";
var $2fb96651e8aa1522$var$INVALID_COLOR = "#8a8a8a";
var $2fb96651e8aa1522$var$ZoomRect = class extends (0, $iTJTu._ModuleSupport).Rect {
    constructor(){
        super(...arguments);
        this.fill = $2fb96651e8aa1522$var$VALID_COLOR;
        this.fillOpacity = 0.2;
        this.zIndex = (0, $iTJTu._ModuleSupport).ZIndexMap.ZOOM_SELECTION;
    }
    updateValid() {
        this.fill = $2fb96651e8aa1522$var$VALID_COLOR;
    }
    updateInvalid() {
        this.fill = $2fb96651e8aa1522$var$INVALID_COLOR;
    }
};
$2fb96651e8aa1522$var$ZoomRect.className = "ZoomRect";
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property51
], $2fb96651e8aa1522$var$ZoomRect.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property51
], $2fb96651e8aa1522$var$ZoomRect.prototype, "fillOpacity", 2);
var $2fb96651e8aa1522$var$UNIT = {
    min: 0,
    max: 1
};
var $2fb96651e8aa1522$var$UNIT_SIZE = $2fb96651e8aa1522$var$UNIT.max - $2fb96651e8aa1522$var$UNIT.min;
var $2fb96651e8aa1522$var$DEFAULT_ANCHOR_POINT_X = "end";
var $2fb96651e8aa1522$var$DEFAULT_ANCHOR_POINT_Y = "middle";
var $2fb96651e8aa1522$var$constrain = (value, min = $2fb96651e8aa1522$var$UNIT.min, max = $2fb96651e8aa1522$var$UNIT.max)=>(0, $idDdm.clamp)(min, value, max);
function $2fb96651e8aa1522$var$unitZoomState() {
    return {
        x: {
            ...$2fb96651e8aa1522$var$UNIT
        },
        y: {
            ...$2fb96651e8aa1522$var$UNIT
        }
    };
}
function $2fb96651e8aa1522$var$dx(zoom) {
    return zoom.x.max - zoom.x.min;
}
function $2fb96651e8aa1522$var$dy(zoom) {
    return zoom.y.max - zoom.y.min;
}
function $2fb96651e8aa1522$var$isZoomRangeEqual(left, right, epsilon = 1e-10) {
    return (0, $idDdm.isNumberEqual)(left.min, right.min, epsilon) && (0, $idDdm.isNumberEqual)(left.max, right.max, epsilon);
}
function $2fb96651e8aa1522$var$isZoomEqual(left, right, epsilon) {
    return $2fb96651e8aa1522$var$isZoomRangeEqual(left.x, right.x, epsilon) && $2fb96651e8aa1522$var$isZoomRangeEqual(left.y, right.y, epsilon);
}
function $2fb96651e8aa1522$var$definedZoomState(zoom) {
    return {
        x: {
            min: zoom?.x?.min ?? $2fb96651e8aa1522$var$UNIT.min,
            max: zoom?.x?.max ?? $2fb96651e8aa1522$var$UNIT.max
        },
        y: {
            min: zoom?.y?.min ?? $2fb96651e8aa1522$var$UNIT.min,
            max: zoom?.y?.max ?? $2fb96651e8aa1522$var$UNIT.max
        }
    };
}
function $2fb96651e8aa1522$var$pointToRatio(bbox, x, y) {
    if (!bbox) return {
        x: 0,
        y: 0
    };
    const constrainedX = $2fb96651e8aa1522$var$constrain(x - bbox.x, 0, bbox.x + bbox.width);
    const constrainedY = $2fb96651e8aa1522$var$constrain(y - bbox.y, 0, bbox.y + bbox.height);
    const rx = 1 / bbox.width * constrainedX;
    const ry = 1 - 1 / bbox.height * constrainedY;
    return {
        x: $2fb96651e8aa1522$var$constrain(rx),
        y: $2fb96651e8aa1522$var$constrain(ry)
    };
}
function $2fb96651e8aa1522$var$translateZoom(zoom, x, y) {
    return {
        x: {
            min: zoom.x.min + x,
            max: zoom.x.max + x
        },
        y: {
            min: zoom.y.min + y,
            max: zoom.y.max + y
        }
    };
}
function $2fb96651e8aa1522$var$scaleZoom(zoom, sx, sy) {
    return {
        x: {
            min: zoom.x.min,
            max: zoom.x.min + $2fb96651e8aa1522$var$dx(zoom) * sx
        },
        y: {
            min: zoom.y.min,
            max: zoom.y.min + $2fb96651e8aa1522$var$dy(zoom) * sy
        }
    };
}
function $2fb96651e8aa1522$var$scaleZoomCenter(zoom, sx, sy) {
    const dx_ = $2fb96651e8aa1522$var$dx(zoom);
    const dy_ = $2fb96651e8aa1522$var$dy(zoom);
    const cx = zoom.x.min + dx_ / 2;
    const cy = zoom.y.min + dy_ / 2;
    return {
        x: {
            min: cx - dx_ * sx / 2,
            max: cx + dx_ * sx / 2
        },
        y: {
            min: cy - dy_ * sy / 2,
            max: cy + dy_ * sy / 2
        }
    };
}
function $2fb96651e8aa1522$var$scaleZoomAxisWithAnchor(newState, oldState, anchor, origin) {
    const { min: min, max: max } = oldState;
    const center = min + (max - min) / 2;
    const diff8 = newState.max - newState.min;
    switch(anchor){
        case "start":
            return {
                min: min,
                max: oldState.min + diff8
            };
        case "end":
            return {
                min: oldState.max - diff8,
                max: max
            };
        case "middle":
            return {
                min: center - diff8 / 2,
                max: center + diff8 / 2
            };
        case "pointer":
            return $2fb96651e8aa1522$var$scaleZoomAxisWithPoint(newState, oldState, origin ?? center);
        default:
            return {
                min: min,
                max: max
            };
    }
}
function $2fb96651e8aa1522$var$scaleZoomAxisWithPoint(newState, oldState, origin) {
    const newDelta = newState.max - newState.min;
    const oldDelta = oldState.max - oldState.min;
    const scaledOrigin = origin * (1 - (oldDelta - newDelta));
    const translation = origin - scaledOrigin;
    const min = newState.min + translation;
    const max = newState.max + translation;
    return {
        min: min,
        max: max
    };
}
function $2fb96651e8aa1522$var$multiplyZoom(zoom, nx, ny) {
    return {
        x: {
            min: zoom.x.min * nx,
            max: zoom.x.max * nx
        },
        y: {
            min: zoom.y.min * ny,
            max: zoom.y.max * ny
        }
    };
}
function $2fb96651e8aa1522$var$constrainZoom(zoom) {
    return {
        x: $2fb96651e8aa1522$var$constrainAxis(zoom.x),
        y: $2fb96651e8aa1522$var$constrainAxis(zoom.y)
    };
}
function $2fb96651e8aa1522$var$constrainAxis(axis) {
    const size = axis.max - axis.min;
    let min = axis.max > $2fb96651e8aa1522$var$UNIT.max ? $2fb96651e8aa1522$var$UNIT.max - size : axis.min;
    let max = axis.min < $2fb96651e8aa1522$var$UNIT.min ? size : axis.max;
    min = Math.max($2fb96651e8aa1522$var$UNIT.min, min);
    max = Math.min($2fb96651e8aa1522$var$UNIT.max, max);
    return {
        min: min,
        max: max
    };
}
// packages/ag-charts-enterprise/src/features/zoom/zoomAxisDragger.ts
var $2fb96651e8aa1522$var$ZoomAxisDragger = class {
    update(event, direction, anchor, bbox, zoom, axisZoom) {
        this.oldZoom ?? (this.oldZoom = $2fb96651e8aa1522$var$definedZoomState(direction === (0, $iTJTu._ModuleSupport).ChartAxisDirection.X ? {
            ...zoom,
            x: axisZoom
        } : {
            ...zoom,
            y: axisZoom
        }));
        this.updateCoords(event.currentX, event.currentY);
        return this.updateZoom(direction, anchor, bbox);
    }
    stop() {
        this.coords = void 0;
        this.oldZoom = void 0;
    }
    updateCoords(x, y) {
        if (this.coords) {
            this.coords.x2 = x;
            this.coords.y2 = y;
        } else this.coords = {
            x1: x,
            y1: y,
            x2: x,
            y2: y
        };
    }
    updateZoom(direction, anchor, bbox) {
        const { coords: coords, oldZoom: oldZoom } = this;
        let newZoom = $2fb96651e8aa1522$var$definedZoomState(oldZoom);
        if (!coords || !oldZoom) {
            if (direction === (0, $iTJTu._ModuleSupport).ChartAxisDirection.X) return newZoom.x;
            return newZoom.y;
        }
        const origin = $2fb96651e8aa1522$var$pointToRatio(bbox, coords.x1, coords.y1);
        const target = $2fb96651e8aa1522$var$pointToRatio(bbox, coords.x2, coords.y2);
        if (direction === (0, $iTJTu._ModuleSupport).ChartAxisDirection.X) {
            const scaleX = (target.x - origin.x) * $2fb96651e8aa1522$var$dx(oldZoom);
            newZoom.x.max += scaleX;
            newZoom.x = $2fb96651e8aa1522$var$scaleZoomAxisWithAnchor(newZoom.x, oldZoom.x, anchor, origin.x);
            newZoom = $2fb96651e8aa1522$var$constrainZoom(newZoom);
            return newZoom.x;
        }
        const scaleY = (target.y - origin.y) * $2fb96651e8aa1522$var$dy(oldZoom);
        newZoom.y.max -= scaleY;
        newZoom.y = $2fb96651e8aa1522$var$scaleZoomAxisWithAnchor(newZoom.y, oldZoom.y, anchor, origin.y);
        newZoom = $2fb96651e8aa1522$var$constrainZoom(newZoom);
        return newZoom.y;
    }
};
// packages/ag-charts-enterprise/src/features/zoom/zoomContextMenu.ts
var $2fb96651e8aa1522$var$ZoomContextMenu = class {
    constructor(contextMenuRegistry, zoomManager, getModuleProperties, getRect, updateZoom, isZoomValid){
        this.contextMenuRegistry = contextMenuRegistry;
        this.zoomManager = zoomManager;
        this.getModuleProperties = getModuleProperties;
        this.getRect = getRect;
        this.updateZoom = updateZoom;
        this.isZoomValid = isZoomValid;
    }
    registerActions(enabled) {
        const { contextMenuRegistry: contextMenuRegistry } = this;
        if (enabled) {
            contextMenuRegistry.setVisible("zoom-to-cursor", true);
            contextMenuRegistry.setVisible("pan-to-cursor", true);
        } else {
            contextMenuRegistry.setVisible("zoom-to-cursor", false);
            contextMenuRegistry.setVisible("pan-to-cursor", false);
            return;
        }
        contextMenuRegistry.builtins.items["zoom-to-cursor"].action = this.onZoomToHere.bind(this);
        contextMenuRegistry.builtins.items["pan-to-cursor"].action = this.onPanToHere.bind(this);
        const shouldEnableZoomToHere = (event)=>{
            const rect = this.getRect();
            if (!rect) return true;
            const origin = $2fb96651e8aa1522$var$pointToRatio(rect, event.x, event.y);
            return this.iterateFindNextZoomAtPoint(origin) != null;
        };
        const shouldEnablePanToHere = ()=>{
            return !$2fb96651e8aa1522$var$isZoomEqual($2fb96651e8aa1522$var$definedZoomState(this.zoomManager.getZoom()), $2fb96651e8aa1522$var$unitZoomState());
        };
        const removeListener = contextMenuRegistry.addListener("context-setup", (event)=>{
            contextMenuRegistry.builtins.items["zoom-to-cursor"].enabled = shouldEnableZoomToHere(event);
            contextMenuRegistry.builtins.items["pan-to-cursor"].enabled = shouldEnablePanToHere();
        });
        return ()=>{
            removeListener();
            contextMenuRegistry.setVisible("zoom-to-cursor", false);
            contextMenuRegistry.setVisible("pan-to-cursor", false);
        };
    }
    computeOrigin(event) {
        const rect = this.getRect();
        const { enabled: enabled } = this.getModuleProperties();
        if (!enabled || !rect || !event?.target || !(event instanceof MouseEvent)) return;
        const relativeRect = {
            x: 0,
            y: 0,
            width: rect.width,
            height: rect.height
        };
        return $2fb96651e8aa1522$var$pointToRatio(relativeRect, event.offsetX, event.offsetY);
    }
    onZoomToHere({ event: event }) {
        const origin = this.computeOrigin(event);
        if (!origin) return;
        const zoom = this.iterateFindNextZoomAtPoint(origin);
        if (zoom == null) return;
        this.updateZoom(zoom);
    }
    onPanToHere({ event: event }) {
        const origin = this.computeOrigin(event);
        if (!origin) return;
        const zoom = $2fb96651e8aa1522$var$definedZoomState(this.zoomManager.getZoom());
        const scaleX = $2fb96651e8aa1522$var$dx(zoom);
        const scaleY = $2fb96651e8aa1522$var$dy(zoom);
        const scaledOriginX = origin.x * scaleX;
        const scaledOriginY = origin.y * scaleY;
        const halfSize = $2fb96651e8aa1522$var$UNIT_SIZE / 2;
        let newZoom = {
            x: {
                min: origin.x - halfSize,
                max: origin.x + halfSize
            },
            y: {
                min: origin.y - halfSize,
                max: origin.y + halfSize
            }
        };
        newZoom = $2fb96651e8aa1522$var$scaleZoomCenter(newZoom, scaleX, scaleY);
        newZoom = $2fb96651e8aa1522$var$translateZoom(newZoom, zoom.x.min - origin.x + scaledOriginX, zoom.y.min - origin.y + scaledOriginY);
        this.updateZoom($2fb96651e8aa1522$var$constrainZoom(newZoom));
    }
    iterateFindNextZoomAtPoint(origin) {
        const { scrollingStep: scrollingStep } = this.getModuleProperties();
        for(let i = scrollingStep; i <= 1 - scrollingStep; i += scrollingStep){
            const zoom = this.getNextZoomAtPoint(origin, i);
            if (this.isZoomValid(zoom)) return zoom;
        }
    }
    getNextZoomAtPoint(origin, step) {
        const { isScalingX: isScalingX, isScalingY: isScalingY } = this.getModuleProperties();
        const zoom = $2fb96651e8aa1522$var$definedZoomState(this.zoomManager.getZoom());
        const scaledOriginX = origin.x * $2fb96651e8aa1522$var$dx(zoom);
        const scaledOriginY = origin.y * $2fb96651e8aa1522$var$dy(zoom);
        const halfSize = $2fb96651e8aa1522$var$UNIT_SIZE / 2;
        let newZoom = {
            x: {
                min: origin.x - halfSize,
                max: origin.x + halfSize
            },
            y: {
                min: origin.y - halfSize,
                max: origin.y + halfSize
            }
        };
        newZoom = $2fb96651e8aa1522$var$scaleZoomCenter(newZoom, isScalingX ? $2fb96651e8aa1522$var$dx(zoom) * step : $2fb96651e8aa1522$var$UNIT_SIZE, isScalingY ? $2fb96651e8aa1522$var$dy(zoom) * step : $2fb96651e8aa1522$var$UNIT_SIZE);
        newZoom = $2fb96651e8aa1522$var$translateZoom(newZoom, zoom.x.min - origin.x + scaledOriginX, zoom.y.min - origin.y + scaledOriginY);
        return $2fb96651e8aa1522$var$constrainZoom(newZoom);
    }
};
var { BBoxValues: $2fb96651e8aa1522$var$BBoxValues, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection15 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$ZoomDOMProxy = class {
    constructor(axesHandlers){
        this.axesHandlers = axesHandlers;
        this.axes = [];
    }
    destroy() {
        this.axes.forEach((a)=>a.div.destroy());
    }
    update(enableAxisDragging, ctx) {
        this.axes.forEach((ax)=>ax.div.setHidden(!enableAxisDragging));
        if (!enableAxisDragging) return;
        const { X: X, Y: Y } = (0, $iTJTu._ModuleSupport).ChartAxisDirection;
        const axesCtx = [
            ...ctx.axisManager.getAxisContext(X),
            ...ctx.axisManager.getAxisContext(Y)
        ];
        const { removed: removed, added: added } = this.diffAxisIds(axesCtx);
        if (removed.length > 0) this.axes = this.axes.filter((entry)=>{
            if (removed.includes(entry.axisId)) {
                entry.div.destroy();
                return false;
            }
            return true;
        });
        for (const newAxisCtx of added){
            const { axisId: axisId, direction: direction } = newAxisCtx;
            this.axes.push(this.initAxis(ctx, axisId, this.axesHandlers, direction));
        }
        for (const axis of this.axes){
            const axisCtx = axesCtx.find((ac)=>ac.axisId === axis.axisId);
            const bbox = axisCtx.getCanvasBounds();
            axis.div.setHidden($2fb96651e8aa1522$var$BBoxValues.isEmpty(bbox));
            if (bbox !== void 0) axis.div.setBounds(bbox);
        }
    }
    toggleAxisDraggingCursor(direction, enabled) {
        for (const axis of this.axes){
            if (axis.direction !== direction) continue;
            axis.div.setCursor(enabled ? this.getCursor(direction) : void 0);
        }
    }
    getCursor(direction) {
        return direction === $2fb96651e8aa1522$var$ChartAxisDirection15.X ? "ew-resize" : "ns-resize";
    }
    initAxis(ctx, axisId, handlers, direction) {
        const where = "afterend";
        const div = ctx.proxyInteractionService.createProxyElement({
            type: "region",
            domManagerId: axisId,
            where: where
        });
        div.setCursor(this.getCursor(direction));
        div.addListener("drag-start", (e)=>{
            if (e.device === "touch") e.sourceEvent.preventDefault();
            handlers.onDragStart(axisId, direction);
        });
        div.addListener("drag-move", (ev)=>handlers.onDrag(ev));
        div.addListener("drag-end", handlers.onDragEnd);
        div.addListener("dblclick", ()=>handlers.onDoubleClick(axisId, direction));
        return {
            axisId: axisId,
            div: div,
            direction: direction
        };
    }
    diffAxisIds(axesCtx) {
        const myIds = this.axes.map((entry)=>entry.axisId);
        const ctxIds = axesCtx.map((ctx)=>ctx.axisId);
        const removed = myIds.filter((id)=>!ctxIds.includes(id));
        const added = axesCtx.filter((ac)=>!myIds.includes(ac.axisId));
        return {
            removed: removed,
            added: added
        };
    }
};
var $2fb96651e8aa1522$var$maxZoomCoords = 16;
var $2fb96651e8aa1522$var$decelerationValues = {
    off: 1,
    short: 0.01,
    long: 2e-3
};
var $2fb96651e8aa1522$var$ZoomPanner = class {
    constructor(){
        this.deceleration = 1;
        this.zoomCoordsHistoryIndex = 0;
        this.coordsHistory = [];
    }
    get decelerationValue() {
        const { deceleration: deceleration } = this;
        return Math.max(typeof deceleration === "number" ? deceleration : $2fb96651e8aa1522$var$decelerationValues[deceleration] ?? 1, 1e-4);
    }
    addListener(_type, fn) {
        this.onUpdate = fn;
        return ()=>{
            this.onUpdate = void 0;
        };
    }
    stopInteractions() {
        if (this.inertiaHandle != null) {
            cancelAnimationFrame(this.inertiaHandle);
            this.inertiaHandle = void 0;
        }
    }
    update(event) {
        this.updateCoords(event.currentX, event.currentY);
        const { x1: x1 = 0, y1: y1 = 0, x2: x2 = 0, y2: y2 = 0 } = this.coords ?? {};
        this.onUpdate?.({
            type: "update",
            deltaX: x1 - x2,
            deltaY: y1 - y2
        });
    }
    start() {
        this.coordsMonitorTimeout = setInterval(this.recordCurrentZoomCoords.bind(this), 16);
    }
    stop() {
        const { coordsHistory: coordsHistory } = this;
        let deltaX = 0;
        let deltaY = 0;
        let deltaT = 0;
        if (coordsHistory.length > 0) {
            const arrayIndex = this.zoomCoordsHistoryIndex % $2fb96651e8aa1522$var$maxZoomCoords;
            let index1 = arrayIndex - 1;
            if (index1 < 0) index1 = coordsHistory.length - 1;
            let index0 = arrayIndex;
            if (index0 >= coordsHistory.length) index0 = 0;
            const coords1 = coordsHistory[index1];
            const coords0 = coordsHistory[index0];
            deltaX = coords1.x - coords0.x;
            deltaY = coords1.y - coords0.y;
            deltaT = coords1.t - coords0.t;
        }
        this.coords = void 0;
        clearInterval(this.coordsMonitorTimeout);
        this.coordsMonitorTimeout = void 0;
        this.zoomCoordsHistoryIndex = 0;
        this.coordsHistory.length = 0;
        if (deltaT > 0 && this.decelerationValue < 1) {
            const xVelocity = deltaX / deltaT;
            const yVelocity = deltaY / deltaT;
            const velocity = Math.hypot(xVelocity, yVelocity);
            const angle = Math.atan2(yVelocity, xVelocity);
            const t0 = performance.now();
            this.inertiaHandle = (0, $idDdm.getWindow)().requestAnimationFrame((t)=>{
                this.animateInertia(t, t, t0, velocity, angle);
            });
        }
    }
    recordCurrentZoomCoords() {
        const { coords: coords, coordsHistory: coordsHistory, zoomCoordsHistoryIndex: zoomCoordsHistoryIndex } = this;
        if (!coords) return;
        const { x2: x, y2: y } = coords;
        const t = Date.now();
        coordsHistory[zoomCoordsHistoryIndex % $2fb96651e8aa1522$var$maxZoomCoords] = {
            x: x,
            y: y,
            t: t
        };
        this.zoomCoordsHistoryIndex += 1;
    }
    animateInertia(t, prevT, t0, velocity, angle) {
        const friction = 1 - this.decelerationValue;
        const maxS = -velocity / Math.log(friction);
        const s0 = velocity * (friction ** (prevT - t0) - 1) / Math.log(friction);
        const s1 = velocity * (friction ** (t - t0) - 1) / Math.log(friction);
        this.onUpdate?.({
            type: "update",
            deltaX: -Math.cos(angle) * (s1 - s0),
            deltaY: -Math.sin(angle) * (s1 - s0)
        });
        if (s1 >= maxS - 1) return;
        this.inertiaHandle = requestAnimationFrame((nextT)=>{
            this.animateInertia(nextT, t, t0, velocity, angle);
        });
    }
    updateCoords(x, y) {
        if (this.coords) this.coords = {
            x1: this.coords.x2,
            y1: this.coords.y2,
            x2: x,
            y2: y
        };
        else this.coords = {
            x1: x,
            y1: y,
            x2: x,
            y2: y
        };
    }
    translateZooms(bbox, currentZooms, deltaX, deltaY) {
        const offset = $2fb96651e8aa1522$var$pointToRatio(bbox, bbox.x + Math.abs(deltaX), bbox.y + bbox.height - Math.abs(deltaY));
        const offsetX = Math.sign(deltaX) * offset.x;
        const offsetY = -Math.sign(deltaY) * offset.y;
        const newZooms = {};
        for (const [axisId, { direction: direction, zoom: currentZoom }] of (0, $idDdm.entries)(currentZooms)){
            if (currentZoom && currentZoom.min === $2fb96651e8aa1522$var$UNIT.min && currentZoom.max === $2fb96651e8aa1522$var$UNIT.max) continue;
            let zoom = $2fb96651e8aa1522$var$definedZoomState({
                [direction]: currentZoom
            });
            zoom = $2fb96651e8aa1522$var$constrainZoom($2fb96651e8aa1522$var$translateZoom(zoom, offsetX * $2fb96651e8aa1522$var$dx(zoom), offsetY * $2fb96651e8aa1522$var$dy(zoom)));
            newZooms[axisId] = {
                direction: direction,
                zoom: zoom[direction]
            };
        }
        return newZooms;
    }
};
var $2fb96651e8aa1522$var$DELTA_SCALE = 200;
var $2fb96651e8aa1522$var$ZoomScrollPanner = class {
    update(event, step, bbox, zooms) {
        const deltaX = event.deltaX * step * $2fb96651e8aa1522$var$DELTA_SCALE;
        return this.translateZooms(bbox, zooms, deltaX);
    }
    translateZooms(bbox, currentZooms, deltaX) {
        const newZooms = {};
        const offset = $2fb96651e8aa1522$var$pointToRatio(bbox, bbox.x + Math.abs(deltaX), 0);
        const offsetX = deltaX < 0 ? -offset.x : offset.x;
        for (const [axisId, { direction: direction, zoom: currentZoom }] of (0, $idDdm.entries)(currentZooms)){
            if (direction !== (0, $iTJTu._ModuleSupport).ChartAxisDirection.X) continue;
            let zoom = $2fb96651e8aa1522$var$definedZoomState({
                x: currentZoom
            });
            zoom = $2fb96651e8aa1522$var$constrainZoom($2fb96651e8aa1522$var$translateZoom(zoom, offsetX * $2fb96651e8aa1522$var$dx(zoom), 0));
            newZooms[axisId] = {
                direction: direction,
                zoom: zoom.x
            };
        }
        return newZooms;
    }
};
var $2fb96651e8aa1522$var$ZoomScroller = class {
    updateAxes(event, props, bbox, zooms) {
        const sourceEvent = event.sourceEvent;
        const newZooms = {};
        const { anchorPointX: anchorPointX, anchorPointY: anchorPointY, isScalingX: isScalingX, isScalingY: isScalingY, scrollingStep: scrollingStep } = props;
        const origin = $2fb96651e8aa1522$var$pointToRatio(bbox, sourceEvent.offsetX ?? sourceEvent.clientX, sourceEvent.offsetY ?? sourceEvent.clientY);
        for (const [axisId, { direction: direction, zoom: zoom }] of (0, $idDdm.entries)(zooms)){
            if (zoom == null) continue;
            let newZoom = {
                ...zoom
            };
            const delta3 = scrollingStep * event.deltaY * (zoom.max - zoom.min);
            if (direction === (0, $iTJTu._ModuleSupport).ChartAxisDirection.X && isScalingX) {
                newZoom.max += delta3;
                newZoom = $2fb96651e8aa1522$var$scaleZoomAxisWithAnchor(newZoom, zoom, anchorPointX, origin.x);
            } else if (direction === (0, $iTJTu._ModuleSupport).ChartAxisDirection.Y && isScalingY) {
                newZoom.max += delta3;
                newZoom = $2fb96651e8aa1522$var$scaleZoomAxisWithAnchor(newZoom, zoom, anchorPointY, origin.y);
            } else continue;
            newZooms[axisId] = {
                direction: direction,
                zoom: $2fb96651e8aa1522$var$constrainAxis(newZoom)
            };
        }
        return newZooms;
    }
    update(event, props, bbox, oldZoom) {
        const { anchorPointX: anchorPointX, anchorPointY: anchorPointY, isScalingX: isScalingX, isScalingY: isScalingY, scrollingStep: scrollingStep } = props;
        const canvasX = event.offsetX + bbox.x;
        const canvasY = event.offsetY + bbox.y;
        const origin = $2fb96651e8aa1522$var$pointToRatio(bbox, canvasX, canvasY);
        const dir = event.deltaY;
        let newZoom = $2fb96651e8aa1522$var$definedZoomState(oldZoom);
        newZoom.x.max += isScalingX ? scrollingStep * dir * $2fb96651e8aa1522$var$dx(oldZoom) : 0;
        newZoom.y.max += isScalingY ? scrollingStep * dir * $2fb96651e8aa1522$var$dy(oldZoom) : 0;
        if (isScalingX) newZoom.x = $2fb96651e8aa1522$var$scaleZoomAxisWithAnchor(newZoom.x, oldZoom.x, anchorPointX, origin.x);
        if (isScalingY) newZoom.y = $2fb96651e8aa1522$var$scaleZoomAxisWithAnchor(newZoom.y, oldZoom.y, anchorPointY, origin.y);
        newZoom = $2fb96651e8aa1522$var$constrainZoom(newZoom);
        return newZoom;
    }
    updateDelta(delta3, props, oldZoom) {
        const { anchorPointX: anchorPointX, anchorPointY: anchorPointY, isScalingX: isScalingX, isScalingY: isScalingY, scrollingStep: scrollingStep } = props;
        let newZoom = $2fb96651e8aa1522$var$definedZoomState(oldZoom);
        newZoom.x.max += isScalingX ? scrollingStep * -delta3 * $2fb96651e8aa1522$var$dx(oldZoom) : 0;
        newZoom.y.max += isScalingY ? scrollingStep * -delta3 * $2fb96651e8aa1522$var$dy(oldZoom) : 0;
        if (isScalingX) newZoom.x = $2fb96651e8aa1522$var$scaleZoomAxisWithAnchor(newZoom.x, oldZoom.x, anchorPointX);
        if (isScalingY) newZoom.y = $2fb96651e8aa1522$var$scaleZoomAxisWithAnchor(newZoom.y, oldZoom.y, anchorPointY);
        newZoom = $2fb96651e8aa1522$var$constrainZoom(newZoom);
        return newZoom;
    }
};
// packages/ag-charts-enterprise/src/features/zoom/zoomSelector.ts
var $2fb96651e8aa1522$var$ZoomSelector = class {
    constructor(rect, getZoom, isZoomValid){
        this.rect = rect;
        this.getZoom = getZoom;
        this.isZoomValid = isZoomValid;
        this.rect.visible = false;
    }
    update(event, props, bbox) {
        const canvasX = event.currentX + (bbox?.x ?? 0);
        const canvasY = event.currentY + (bbox?.y ?? 0);
        this.rect.visible = true;
        this.updateCoords(canvasX, canvasY, props, bbox);
        this.updateRect(bbox);
    }
    stop(innerBBox, bbox, currentZoom) {
        let zoom = $2fb96651e8aa1522$var$definedZoomState();
        if (!innerBBox || !bbox) return zoom;
        if (this.coords) zoom = this.createZoomFromCoords(bbox, currentZoom);
        const multiplyX = bbox.width / innerBBox.width;
        const multiplyY = bbox.height / innerBBox.height;
        zoom = $2fb96651e8aa1522$var$constrainZoom($2fb96651e8aa1522$var$multiplyZoom(zoom, multiplyX, multiplyY));
        this.reset();
        return zoom;
    }
    reset() {
        this.coords = void 0;
        this.rect.visible = false;
    }
    didUpdate() {
        return this.rect.visible && this.rect.width > 0 && this.rect.height > 0;
    }
    updateCoords(x, y, props, bbox) {
        if (!this.coords) {
            this.coords = {
                x1: x,
                y1: y,
                x2: x,
                y2: y
            };
            return;
        }
        const { coords: coords } = this;
        coords.x2 = x;
        coords.y2 = y;
        if (!bbox) return;
        const { isScalingX: isScalingX, isScalingY: isScalingY, keepAspectRatio: keepAspectRatio } = props;
        const normal = this.getNormalisedDimensions();
        if (keepAspectRatio && isScalingX && isScalingY) {
            const aspectRatio = bbox.width / bbox.height;
            if (coords.y2 < coords.y1) coords.y2 = Math.min(coords.y1 - normal.width / aspectRatio, coords.y1);
            else coords.y2 = Math.max(coords.y1 + normal.width / aspectRatio, coords.y1);
        }
        if (!isScalingX) {
            coords.x1 = bbox.x;
            coords.x2 = bbox.x + bbox.width;
        }
        if (!isScalingY) {
            coords.y1 = bbox.y;
            coords.y2 = bbox.y + bbox.height;
        }
    }
    updateRect(bbox) {
        if (!bbox) return;
        const { rect: rect } = this;
        const normal = this.getNormalisedDimensions();
        const { width: width, height: height } = normal;
        let { x: x, y: y } = normal;
        x = Math.max(x, bbox.x);
        x -= Math.max(0, x + width - (bbox.x + bbox.width));
        y = Math.max(y, bbox.y);
        y -= Math.max(0, y + height - (bbox.y + bbox.height));
        rect.x = x;
        rect.y = y;
        rect.width = width;
        rect.height = height;
        const zoom = this.createZoomFromCoords(bbox, this.getZoom());
        if (this.isZoomValid(zoom)) rect.updateValid();
        else rect.updateInvalid();
    }
    createZoomFromCoords(bbox, currentZoom) {
        const oldZoom = $2fb96651e8aa1522$var$definedZoomState(currentZoom);
        const normal = this.getNormalisedDimensions();
        const origin = $2fb96651e8aa1522$var$pointToRatio(bbox, normal.x, normal.y + normal.height);
        const xFactor = normal.width / bbox.width;
        const yFactor = normal.height / bbox.height;
        let newZoom = $2fb96651e8aa1522$var$scaleZoom(oldZoom, xFactor, yFactor);
        const translateX = origin.x * $2fb96651e8aa1522$var$dx(oldZoom);
        const translateY = origin.y * $2fb96651e8aa1522$var$dy(oldZoom);
        newZoom = $2fb96651e8aa1522$var$translateZoom(newZoom, translateX, translateY);
        newZoom = $2fb96651e8aa1522$var$constrainZoom(newZoom);
        return newZoom;
    }
    getNormalisedDimensions() {
        const { x1: x1 = 0, y1: y1 = 0, x2: x2 = 0, y2: y2 = 0 } = this.coords ?? {};
        const x = x1 <= x2 ? x1 : x2;
        const y = y1 <= y2 ? y1 : y2;
        const width = x1 <= x2 ? x2 - x1 : x1 - x2;
        const height = y1 <= y2 ? y2 - y1 : y1 - y2;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    }
};
var { ActionOnSet: $2fb96651e8aa1522$var$ActionOnSet8, BaseProperties: $2fb96651e8aa1522$var$BaseProperties17, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection16, NativeWidget: $2fb96651e8aa1522$var$NativeWidget2, PropertiesArray: $2fb96651e8aa1522$var$PropertiesArray5, Toolbar: $2fb96651e8aa1522$var$Toolbar2, ToolbarButtonProperties: $2fb96651e8aa1522$var$ToolbarButtonProperties4, Property: $2fb96651e8aa1522$var$Property52 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$ZoomButtonProperties = class extends $2fb96651e8aa1522$var$ToolbarButtonProperties4 {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property52
], $2fb96651e8aa1522$var$ZoomButtonProperties.prototype, "value", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property52
], $2fb96651e8aa1522$var$ZoomButtonProperties.prototype, "section", 2);
var $2fb96651e8aa1522$var$ZoomToolbar = class extends $2fb96651e8aa1522$var$BaseProperties17 {
    constructor(ctx, getModuleProperties, getResetZoom, updateZoom, updateAxisZoom, resetZoom, isZoomValid){
        super();
        this.ctx = ctx;
        this.getModuleProperties = getModuleProperties;
        this.getResetZoom = getResetZoom;
        this.updateZoom = updateZoom;
        this.updateAxisZoom = updateAxisZoom;
        this.resetZoom = resetZoom;
        this.isZoomValid = isZoomValid;
        this.enabled = false;
        this.buttons = new $2fb96651e8aa1522$var$PropertiesArray5($2fb96651e8aa1522$var$ZoomButtonProperties);
        this.visible = "hover";
        this.verticalSpacing = 10;
        this.detectionRange = 38;
        this.destroyFns = [];
        this.container = new $2fb96651e8aa1522$var$NativeWidget2((0, $idDdm.createElement)("div"));
        this.container.addClass("ag-charts-zoom-buttons");
        ctx.domManager.addChild("canvas-overlay", "zoom-buttons", this.container.getElement());
        this.toolbar = new $2fb96651e8aa1522$var$Toolbar2(ctx.localeManager);
        this.container.addChild(this.toolbar);
        this.toolbar.getElement().style.transform = `translateY(54px)`;
        this.toggleVisibility(this.visible === "always");
        this.destroyFns.push(this.toolbar.addToolbarListener("button-pressed", this.onButtonPress.bind(this)), this.toolbar.addToolbarListener("button-focused", this.onButtonFocus.bind(this)), ctx.widgets.containerWidget.addListener("mousemove", this.onHover.bind(this)), ctx.widgets.containerWidget.addListener("mouseleave", this.onLeave.bind(this)), ctx.layoutManager.addListener("layout:complete", this.onLayoutComplete.bind(this)), this.teardown.bind(this));
    }
    destroy() {
        for (const fn of this.destroyFns)fn();
    }
    toggleVisibleZoomed(isMaxZoom) {
        if (this.visible !== "zoomed") return;
        this.toggleVisibility(!isMaxZoom);
    }
    teardown() {
        this.ctx.domManager.removeChild("canvas-overlay", "zoom-buttons");
        this.container.destroy();
    }
    onLayoutComplete(event) {
        const { buttons: buttons2, container: container } = this;
        const { rect: rect } = event.series;
        this.toolbar.updateButtons(buttons2);
        this.toggleButtons();
        const height = container.getBounds().height;
        container.setBounds({
            y: rect.y + rect.height - height
        });
    }
    onHover(event) {
        if (!this.enabled || this.visible !== "hover" || this.toolbar.isHidden()) return;
        const { container: container, detectionRange: detectionRange, ctx: { scene: scene } } = this;
        const { currentY: currentY, sourceEvent: { target: target } } = event;
        const element = container.getElement();
        const detectionY = element.offsetTop - detectionRange;
        const visible = currentY > detectionY && currentY < scene.canvas.element.offsetHeight || target === element;
        this.toggleVisibility(visible);
    }
    onLeave() {
        if (this.visible !== "hover") return;
        this.toggleVisibility(false);
    }
    toggleVisibility(visible, immediate = false) {
        const { container: container, toolbar: toolbar2, verticalSpacing: verticalSpacing } = this;
        toolbar2.toggleClass("ag-charts-zoom-buttons__toolbar--hidden", !visible);
        const element = toolbar2.getElement();
        element.style.transitionDuration = immediate ? "0s" : "";
        element.style.transform = visible ? "translateY(0)" : `translateY(${container.getBounds().height + verticalSpacing}px)`;
    }
    toggleButtons() {
        const zoom = $2fb96651e8aa1522$var$definedZoomState(this.ctx.zoomManager.getZoom());
        if (this.previousZoom && $2fb96651e8aa1522$var$isZoomEqual(this.previousZoom, zoom)) return;
        this.previousZoom = zoom;
        for (const [index, button] of this.buttons.entries()){
            let enabled = true;
            switch(button?.value){
                case "pan-start":
                    enabled = zoom.x.min > $2fb96651e8aa1522$var$UNIT.min;
                    break;
                case "pan-end":
                    enabled = zoom.x.max < $2fb96651e8aa1522$var$UNIT.max;
                    break;
                case "pan-left":
                    enabled = zoom.x.min > $2fb96651e8aa1522$var$UNIT.min;
                    break;
                case "pan-right":
                    enabled = zoom.x.max < $2fb96651e8aa1522$var$UNIT.max;
                    break;
                case "zoom-out":
                    enabled = !$2fb96651e8aa1522$var$isZoomEqual(zoom, $2fb96651e8aa1522$var$unitZoomState());
                    break;
                case "zoom-in":
                    enabled = this.isZoomValid(this.getNextZoomStateUnified("zoom-in", zoom, this.getModuleProperties()));
                    break;
                case "reset":
                    enabled = !$2fb96651e8aa1522$var$isZoomEqual(zoom, this.getResetZoom());
                    break;
            }
            this.toolbar.toggleButtonEnabledByIndex(index, enabled);
        }
    }
    onButtonPress({ button: button }) {
        if (!this.enabled || this.toolbar.isHidden()) return;
        const props = this.getModuleProperties();
        if (props.independentAxes && button.value !== "reset") {
            const axisZooms = this.ctx.zoomManager.getAxisZooms();
            for (const [axisId, { direction: direction, zoom: zoom }] of (0, $idDdm.entries)(axisZooms)){
                if (zoom == null) continue;
                this.onButtonPressAxis(button, props, axisId, direction, zoom);
            }
        } else this.onButtonPressUnified(button, props);
    }
    onButtonFocus(_event) {
        this.toggleVisibility(true, true);
    }
    onButtonPressAxis(event, props, axisId, direction, zoom) {
        const { isScalingX: isScalingX, isScalingY: isScalingY, scrollingStep: scrollingStep } = props;
        let newZoom = {
            ...zoom
        };
        const delta3 = zoom.max - zoom.min;
        switch(event.value){
            case "pan-start":
                newZoom.max = delta3;
                newZoom.min = 0;
                break;
            case "pan-end":
                newZoom.min = newZoom.max - delta3;
                newZoom.max = $2fb96651e8aa1522$var$UNIT.max;
                break;
            case "pan-left":
                newZoom.min -= delta3 * scrollingStep;
                newZoom.max -= delta3 * scrollingStep;
                break;
            case "pan-right":
                newZoom.min += delta3 * scrollingStep;
                newZoom.max += delta3 * scrollingStep;
                break;
            case "zoom-in":
            case "zoom-out":
                {
                    const isDirectionX = direction === $2fb96651e8aa1522$var$ChartAxisDirection16.X;
                    const isScalingDirection = isDirectionX && isScalingX || !isDirectionX && isScalingY;
                    let scale = event.value === "zoom-in" ? 1 - scrollingStep : 1 + scrollingStep;
                    if (!isScalingDirection) scale = 1;
                    const placement = isDirectionX ? this.getAnchorPointX(props) : this.getAnchorPointY(props);
                    newZoom.max = newZoom.min + (newZoom.max - newZoom.min) * scale;
                    newZoom = $2fb96651e8aa1522$var$scaleZoomAxisWithAnchor(newZoom, zoom, placement);
                    break;
                }
        }
        this.updateAxisZoom(axisId, direction, $2fb96651e8aa1522$var$constrainAxis(newZoom));
    }
    onButtonPressUnified(event, props) {
        const { scrollingStep: scrollingStep } = props;
        const oldZoom = $2fb96651e8aa1522$var$definedZoomState(this.ctx.zoomManager.getZoom());
        let zoom = $2fb96651e8aa1522$var$definedZoomState(oldZoom);
        switch(event.value){
            case "reset":
                this.resetZoom();
                return;
            case "pan-start":
                zoom.x.max = $2fb96651e8aa1522$var$dx(zoom);
                zoom.x.min = 0;
                break;
            case "pan-end":
                zoom.x.min = $2fb96651e8aa1522$var$UNIT.max - $2fb96651e8aa1522$var$dx(zoom);
                zoom.x.max = $2fb96651e8aa1522$var$UNIT.max;
                break;
            case "pan-left":
                zoom = $2fb96651e8aa1522$var$translateZoom(zoom, -$2fb96651e8aa1522$var$dx(zoom) * scrollingStep, 0);
                break;
            case "pan-right":
                zoom = $2fb96651e8aa1522$var$translateZoom(zoom, $2fb96651e8aa1522$var$dx(zoom) * scrollingStep, 0);
                break;
            case "zoom-in":
            case "zoom-out":
                zoom = this.getNextZoomStateUnified(event.value, oldZoom, props);
                break;
        }
        this.updateZoom($2fb96651e8aa1522$var$constrainZoom(zoom));
    }
    getNextZoomStateUnified(button, oldZoom, props) {
        const { isScalingX: isScalingX, isScalingY: isScalingY, scrollingStep: scrollingStep } = props;
        const scale = button === "zoom-in" ? 1 - scrollingStep : 1 + scrollingStep;
        const zoom = $2fb96651e8aa1522$var$scaleZoom(oldZoom, isScalingX ? scale : 1, isScalingY ? scale : 1);
        zoom.x = $2fb96651e8aa1522$var$scaleZoomAxisWithAnchor(zoom.x, oldZoom.x, this.getAnchorPointX(props));
        zoom.y = $2fb96651e8aa1522$var$scaleZoomAxisWithAnchor(zoom.y, oldZoom.y, this.getAnchorPointY(props));
        return zoom;
    }
    getAnchorPointX(props) {
        const anchorPointX = this.anchorPointX ?? props.anchorPointX;
        return anchorPointX === "pointer" ? $2fb96651e8aa1522$var$DEFAULT_ANCHOR_POINT_X : anchorPointX;
    }
    getAnchorPointY(props) {
        const anchorPointY = this.anchorPointY ?? props.anchorPointY;
        return anchorPointY === "pointer" ? $2fb96651e8aa1522$var$DEFAULT_ANCHOR_POINT_Y : anchorPointY;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property52,
    $2fb96651e8aa1522$var$ActionOnSet8({
        changeValue (enabled) {
            this.toolbar?.setHidden(!enabled);
        }
    })
], $2fb96651e8aa1522$var$ZoomToolbar.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property52
], $2fb96651e8aa1522$var$ZoomToolbar.prototype, "buttons", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property52,
    $2fb96651e8aa1522$var$ActionOnSet8({
        changeValue (visible, oldValue) {
            if (oldValue == null) return;
            this.toggleVisibility(visible === "always");
        }
    })
], $2fb96651e8aa1522$var$ZoomToolbar.prototype, "visible", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property52
], $2fb96651e8aa1522$var$ZoomToolbar.prototype, "anchorPointX", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property52
], $2fb96651e8aa1522$var$ZoomToolbar.prototype, "anchorPointY", 2);
var $2fb96651e8aa1522$var$N = 1e6;
function $2fb96651e8aa1522$var$clientToNormal({ min: min, max: max }, a, Rx, Rw) {
    if (Rw === 0) return 0;
    return $2fb96651e8aa1522$var$N * ((a - Rx) / Rw * (max - min) + min);
}
function $2fb96651e8aa1522$var$solveTwoUnknowns(x1, x2, a1, a2, Rx, Rw) {
    [x1, x2] = [
        Math.min(x1, x2),
        Math.max(x1, x2)
    ];
    [a1, a2] = [
        Math.min(a1, a2),
        Math.max(a1, a2)
    ];
    const t1 = $2fb96651e8aa1522$var$N * (a1 - Rx) / Rw;
    const t2 = $2fb96651e8aa1522$var$N * (a2 - Rx) / Rw;
    const c = (a1 - Rx) / (a2 - Rx);
    const min = (x1 - c * x2) / ($2fb96651e8aa1522$var$N - t1 + c * (t2 - $2fb96651e8aa1522$var$N));
    const max = (x2 + (t2 - $2fb96651e8aa1522$var$N) * min) / t2;
    return {
        min: min,
        max: max
    };
}
function $2fb96651e8aa1522$var$isRangeOverlapping(centerA, radiusA, centerB, radiusB) {
    if (radiusA === 0) radiusA = 30;
    if (radiusB === 0) radiusB = 30;
    const minA = centerA - radiusA;
    const maxA = centerA + radiusA;
    const minB = centerB - radiusB;
    const maxB = centerB + radiusB;
    return !(maxA < minB || maxB < minA);
}
var $2fb96651e8aa1522$var$ZoomTwoFingers = class {
    constructor(){
        this.touchStart = {
            origins: [
                {
                    identifier: 0,
                    normalX: NaN,
                    normalY: NaN
                },
                {
                    identifier: 0,
                    normalX: NaN,
                    normalY: NaN
                }
            ]
        };
        this.initialZoom = {
            x: {
                min: 0,
                max: 1
            },
            y: {
                min: 0,
                max: 1
            }
        };
        this.previous = {
            a1: NaN,
            a2: NaN,
            b1: NaN,
            b2: NaN
        };
    }
    start(event, target, zoom) {
        if (event.sourceEvent.targetTouches.length !== 2) return false;
        event.sourceEvent.preventDefault();
        const targetTouches = Array.from(event.sourceEvent.targetTouches);
        const { x: Rx, y: Ry, width: Rw, height: Rh } = target.getBoundingClientRect();
        this.initialZoom.x.min = zoom.x?.min ?? 0;
        this.initialZoom.x.max = zoom.x?.max ?? 1;
        this.initialZoom.y.min = zoom.y?.min ?? 0;
        this.initialZoom.y.max = zoom.y?.max ?? 1;
        this.touchStart.origins.forEach((t)=>t.identifier = 0);
        this.previous.a1 = NaN;
        this.previous.a2 = NaN;
        this.previous.b1 = NaN;
        this.previous.b2 = NaN;
        for (const i of [
            0,
            1
        ]){
            const a = targetTouches[i].clientX;
            const b = Ry + Rh - targetTouches[i].clientY;
            this.touchStart.origins[i].identifier = targetTouches[i].identifier;
            this.touchStart.origins[i].normalX = $2fb96651e8aa1522$var$clientToNormal(this.initialZoom.x, a, Rx, Rw);
            this.touchStart.origins[i].normalY = $2fb96651e8aa1522$var$clientToNormal(this.initialZoom.y, b, Ry, Rh);
        }
        const [tA, tB] = targetTouches;
        const [oA, oB] = this.touchStart.origins;
        const xOverlap = $2fb96651e8aa1522$var$isRangeOverlapping(tA.clientX, tA.radiusX, tB.clientX, tB.radiusX);
        const yOverlap = $2fb96651e8aa1522$var$isRangeOverlapping(tA.clientY, tA.radiusY, tB.clientY, tB.radiusY);
        if (yOverlap) oA.normalY = oB.normalY = (oA.normalY + oB.normalY) / 2;
        if (xOverlap) oA.normalX = oB.normalX = (oA.normalX + oB.normalX) / 2;
        return true;
    }
    update(event, target) {
        event.sourceEvent.preventDefault();
        const targetTouches = Array.from(event.sourceEvent.targetTouches);
        const { x: Rx, y: Ry, width: Rw, height: Rh } = target.getBoundingClientRect();
        const { origins: origins } = this.touchStart;
        const touches = [
            0,
            1
        ].map((i)=>targetTouches.find((t)=>t.identifier === origins[i].identifier));
        const x1 = origins[0].normalX;
        const x2 = origins[1].normalX;
        const a1 = touches[0].clientX;
        const a2 = touches[1].clientX;
        const y1 = origins[0].normalY;
        const y2 = origins[1].normalY;
        const b1 = Ry + Rh - touches[0].clientY;
        const b2 = Ry + Rh - touches[1].clientY;
        return this.twitchTolerantZoomPan4(x1, x2, a1, a2, y1, y2, b1, b2, Rx, Ry, Rw, Rh);
    }
    end(event) {
        const identifiers = Array.from(event.sourceEvent.targetTouches).map((t)=>t.identifier);
        return !identifiers.includes(this.touchStart.origins[0].identifier) || !identifiers.includes(this.touchStart.origins[1].identifier);
    }
    // Small touch deltas on an axis, which can defined as one fingers moving ±1 pixel and the other not moving, can
    // cause the canvas to flicker between two zoompan views.
    //
    // For example, consider two fingers moving upwards slowly on the Y-axis with the following events (Y=0 is the top
    // of the screen):
    //
    //   [0]:  { finger1: { clientY: 101 }, finger2: { clientY: 201 } }
    //   [1]:  { finger1: { clientY: 101 }, finger2: { clientY: 200 } }
    //   [2]:  { finger1: { clientY: 100 }, finger2: { clientY: 200 } }
    //
    // The following transitions cause these changes to the zoompan respectively.
    //
    //   [0] => [1] : yMin decreases, yMax increases
    //   [1] => [2] : yMin increases, yMax decreases
    //
    // At highly-zoomed views, this sudden shift in yMin/yMax in the [1] => [2] transition is very noticeable. When many
    // of these kind of a transitions occur, the chart flickers between pan states instead of smoothly panning. Note
    // however that, if we didn't receive event [1], our transition would like this:
    //
    //   [0] => [2] : yMin increases, yMax increases
    //
    // ... which is a smooth panning transition. Therefore to prevent flickering, we skip event [1].
    twitchTolerantZoomPan4(x1, x2, a1, a2, y1, y2, b1, b2, Rx, Ry, Rw, Rh) {
        const { initialZoom: initialZoom, previous: previous } = this;
        const x = $2fb96651e8aa1522$var$twitchTolerantZoomPan2(x1, x2, a1, a2, previous, "a1", "a2", Rx, Rw, initialZoom.x);
        const y = $2fb96651e8aa1522$var$twitchTolerantZoomPan2(y1, y2, b1, b2, previous, "b1", "b2", Ry, Rh, initialZoom.y);
        return {
            x: x,
            y: y
        };
    }
};
function $2fb96651e8aa1522$var$twitchTolerantZoomPan2(x1, x2, a1, a2, previous, previousKey1, previousKey2, Rx, Rw, initialZoom) {
    if (x1 != x2) {
        const a1prev = previous[previousKey1];
        const a2prev = previous[previousKey2];
        const dx2 = Math.abs(a1 - a1prev) + Math.abs(a2 - a2prev);
        if (dx2 <= 1) {
            a1 = a1prev;
            a2 = a2prev;
        } else {
            previous[previousKey1] = a1;
            previous[previousKey2] = a2;
        }
        return $2fb96651e8aa1522$var$solveTwoUnknowns(x1, x2, a1, a2, Rx, Rw);
    } else {
        const xn1 = $2fb96651e8aa1522$var$clientToNormal(initialZoom, a1, Rx, Rw);
        const xn2 = $2fb96651e8aa1522$var$clientToNormal(initialZoom, a2, Rx, Rw);
        const xavg = (xn1 + xn2) / 2;
        const dzoom = (x1 - xavg) / $2fb96651e8aa1522$var$N;
        return {
            min: initialZoom.min + dzoom,
            max: initialZoom.max + dzoom
        };
    }
}
// packages/ag-charts-enterprise/src/features/zoom/zoom.ts
var { ActionOnSet: $2fb96651e8aa1522$var$ActionOnSet9, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection17, ChartUpdateType: $2fb96651e8aa1522$var$ChartUpdateType3, Deprecated: $2fb96651e8aa1522$var$Deprecated2, Property: $2fb96651e8aa1522$var$Property53, InteractionState: $2fb96651e8aa1522$var$InteractionState4, ProxyProperty: $2fb96651e8aa1522$var$ProxyProperty3 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$round = (value)=>(0, $idDdm.roundTo)(value, 10);
var $2fb96651e8aa1522$var$CURSOR_ID = "zoom-cursor";
var $2fb96651e8aa1522$var$TOOLTIP_ID = "zoom-tooltip";
var $2fb96651e8aa1522$var$ZoomAutoScaling = class extends (0, $iTJTu._ModuleSupport).BaseProperties {
    constructor(onChange){
        super();
        this.onChange = onChange;
        this.enabled = false;
        this.padding = 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53,
    $2fb96651e8aa1522$var$ActionOnSet9({
        changeValue (enabled) {
            this.onChange({
                enabled: enabled,
                padding: this.padding
            });
        }
    })
], $2fb96651e8aa1522$var$ZoomAutoScaling.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53,
    $2fb96651e8aa1522$var$ActionOnSet9({
        changeValue (padding) {
            this.onChange({
                enabled: this.enabled,
                padding: padding
            });
        }
    })
], $2fb96651e8aa1522$var$ZoomAutoScaling.prototype, "padding", 2);
var $2fb96651e8aa1522$var$Zoom = class extends (0, $iTJTu._ModuleSupport).BaseModuleInstance {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.enabled = false;
        this.enableAxisDragging = true;
        this.enableDoubleClickToReset = true;
        this.enablePanning = true;
        this.enableScrolling = true;
        this.enableSelecting = false;
        this.enableTwoFingerZoom = true;
        this.panKey = "alt";
        this.axes = "x";
        this.scrollingStep = $2fb96651e8aa1522$var$UNIT_SIZE / 10;
        this.keepAspectRatio = false;
        this.minVisibleItems = 2;
        this.anchorPointX = $2fb96651e8aa1522$var$DEFAULT_ANCHOR_POINT_X;
        this.anchorPointY = $2fb96651e8aa1522$var$DEFAULT_ANCHOR_POINT_Y;
        this.autoScaling = new $2fb96651e8aa1522$var$ZoomAutoScaling((newValue)=>{
            this.ctx.zoomManager.setAutoScaleYAxis(newValue.enabled, newValue.padding);
        });
        this.buttons = new $2fb96651e8aa1522$var$ZoomToolbar(this.ctx, this.getModuleProperties.bind(this), this.getResetZoom.bind(this), this.updateZoom.bind(this), this.updateAxisZoom.bind(this), this.resetZoom.bind(this), this.isZoomValid.bind(this));
        // Zoom methods
        this.axisDragger = new $2fb96651e8aa1522$var$ZoomAxisDragger();
        this.panner = new $2fb96651e8aa1522$var$ZoomPanner();
        this.scroller = new $2fb96651e8aa1522$var$ZoomScroller();
        this.scrollPanner = new $2fb96651e8aa1522$var$ZoomScrollPanner();
        this.twoFingers = new $2fb96651e8aa1522$var$ZoomTwoFingers();
        this.deceleration = "short";
        // State
        this.dragState = 0 /* None */ ;
        this.isState = (state)=>this.ctx.interactionManager.isState(state);
        this.destroyContextMenuActions = void 0;
        this.isFirstWheelEvent = true;
        this.debouncedWheelReset = (0, $idDdm.debounce)(()=>{
            this.isFirstWheelEvent = true;
        }, 100);
        const selectionRect = new $2fb96651e8aa1522$var$ZoomRect();
        this.selector = new $2fb96651e8aa1522$var$ZoomSelector(selectionRect, this.getZoom.bind(this), this.isZoomValid.bind(this));
        this.contextMenu = new $2fb96651e8aa1522$var$ZoomContextMenu(ctx.contextMenuRegistry, ctx.zoomManager, this.getModuleProperties.bind(this), ()=>this.paddedRect, this.updateZoom.bind(this), this.isZoomValid.bind(this));
        this.domProxy = new $2fb96651e8aa1522$var$ZoomDOMProxy({
            onDragStart: (id, dir)=>this.onAxisDragStart(id, dir),
            onDrag: (ev)=>{
                this.onDragMove({
                    ...ev,
                    currentX: ev.offsetX,
                    currentY: ev.offsetY
                });
            },
            onDragEnd: ()=>this.onDragEnd(),
            onDoubleClick: (id, direction)=>{
                this.hoveredAxis = {
                    id: id,
                    direction: direction
                };
                this.onDoubleClick();
                this.hoveredAxis = void 0;
            }
        });
        this.destroyFns.push(ctx.scene.attachNode(selectionRect), ctx.chartEventManager.addListener("series-keynav-zoom", (event)=>this.onNavZoom(event)), ctx.widgets.seriesDragInterpreter.addListener("dblclick", (event)=>this.onDoubleClick(event)), ctx.widgets.seriesDragInterpreter.addListener("drag-move", (event)=>this.onDragMove(event)), ctx.widgets.seriesDragInterpreter.addListener("drag-start", (event)=>this.onDragStart(event)), ctx.widgets.seriesDragInterpreter.addListener("drag-end", ()=>this.onDragEnd()), ctx.widgets.seriesWidget.addListener("wheel", (event)=>this.onWheel(event)), ctx.widgets.seriesWidget.addListener("touchstart", (event, current)=>this.onTouchStart(event, current)), ctx.widgets.seriesWidget.addListener("touchmove", (event, current)=>this.onTouchMove(event, current)), ctx.widgets.seriesWidget.addListener("touchend", (event)=>this.onTouchEnd(event)), ctx.widgets.seriesWidget.addListener("touchcancel", (event)=>this.onTouchEnd(event)), ctx.updateService.addListener("process-data", (event)=>this.onProcessData(event)), ctx.layoutManager.addListener("layout:complete", (event)=>this.onLayoutComplete(event)), ctx.zoomManager.addListener("zoom-change", (event)=>this.onZoomChange(event)), ctx.zoomManager.addListener("zoom-pan-start", (event)=>this.onZoomPanStart(event)), this.panner.addListener("update", (event)=>this.onPanUpdate(event)), ()=>this.teardown());
    }
    teardown() {
        this.ctx.zoomManager.setZoomModuleEnabled(false);
        this.buttons.destroy();
        this.destroyContextMenuActions?.();
    }
    onEnabledChange(enabled) {
        this.ctx.zoomManager.setZoomModuleEnabled(enabled);
        if (this.contextMenu) {
            this.destroyContextMenuActions?.();
            this.destroyContextMenuActions = this.contextMenu.registerActions(enabled);
        }
    }
    isIgnoredTouch(event) {
        if (event?.device !== "touch") return false;
        if (this.ctx.chartService.touch.dragAction !== "drag") return true;
        if (this.enableSelecting) return false;
        if (!this.enablePanning) return true;
        const { x: x, y: y } = this.getZoom();
        return x.min === 0 && x.max === 1 && y.min === 0 && y.max === 1;
    }
    onDoubleClick(event) {
        const { enabled: enabled, enableDoubleClickToReset: enableDoubleClickToReset, hoveredAxis: hoveredAxis, ctx: { zoomManager: zoomManager } } = this;
        if (!enabled || !enableDoubleClickToReset || !this.isState($2fb96651e8aa1522$var$InteractionState4.ZoomClickable)) return;
        if (hoveredAxis) zoomManager.resetAxisZoom("zoom", hoveredAxis.id);
        else if (!event?.preventZoomDblClick) this.resetZoom();
    }
    onDragStart(event) {
        const { enabled: enabled, enableAxisDragging: enableAxisDragging, enablePanning: enablePanning, enableSelecting: enableSelecting, hoveredAxis: hoveredAxis, ctx: { domManager: domManager, zoomManager: zoomManager } } = this;
        if (!enabled) return;
        if (!this.hoveredAxis) {
            if (!this.isState($2fb96651e8aa1522$var$InteractionState4.ZoomDraggable) || this.dragState !== 0 /* None */  || this.isIgnoredTouch(event)) return;
        }
        this.panner.stopInteractions();
        let newDragState = 0 /* None */ ;
        if (enableAxisDragging && hoveredAxis) newDragState = 1 /* Axis */ ;
        else if (event != null) {
            const panKeyPressed = this.isPanningKeyPressed(event.sourceEvent);
            if (enablePanning && (!enableSelecting || panKeyPressed)) {
                domManager.updateCursor($2fb96651e8aa1522$var$CURSOR_ID, "grabbing");
                newDragState = 2 /* Pan */ ;
                this.panner.start();
            } else if (enableSelecting && !panKeyPressed) newDragState = 3 /* Select */ ;
        }
        if ((this.dragState = newDragState) !== 0 /* None */ ) zoomManager.fireZoomPanStartEvent("zoom");
    }
    onDragMove(event) {
        const { anchorPointX: anchorPointX, anchorPointY: anchorPointY, axisDragger: axisDragger, dragState: dragState, enabled: enabled, paddedRect: paddedRect, panner: panner, selector: selector, seriesRect: seriesRect, shouldFlipXY: shouldFlipXY, hoveredAxis: hoveredAxis, ctx: { interactionManager: interactionManager, tooltipManager: tooltipManager, updateService: updateService, zoomManager: zoomManager } } = this;
        if (!enabled || !paddedRect || !seriesRect) return;
        if (!hoveredAxis) {
            if (!this.isState($2fb96651e8aa1522$var$InteractionState4.ZoomDraggable) || this.isIgnoredTouch(event)) return;
        }
        interactionManager.pushState((0, $iTJTu._ModuleSupport).InteractionState.ZoomDrag);
        if (event.device === "touch") event.sourceEvent.preventDefault();
        const zoom = this.getZoom();
        switch(dragState){
            case 1 /* Axis */ :
                {
                    if (!hoveredAxis) break;
                    const { id: axisId, direction: direction } = hoveredAxis;
                    let anchor = direction === $2fb96651e8aa1522$var$ChartAxisDirection17.X ? anchorPointX : anchorPointY;
                    if (shouldFlipXY) anchor = direction === $2fb96651e8aa1522$var$ChartAxisDirection17.X ? anchorPointY : anchorPointX;
                    const axisZoom = zoomManager.getAxisZoom(axisId);
                    const newZoom = axisDragger.update(event, direction, anchor, seriesRect, zoom, axisZoom);
                    zoomManager.setAxisManuallyAdjusted("zoom", axisId);
                    this.updateAxisZoom(axisId, direction, newZoom);
                    break;
                }
            case 2 /* Pan */ :
                panner.update(event);
                break;
            case 3 /* Select */ :
                selector.update(event, this.getModuleProperties(), paddedRect);
                break;
            case 0 /* None */ :
                return;
        }
        tooltipManager.updateTooltip($2fb96651e8aa1522$var$TOOLTIP_ID);
        updateService.update($2fb96651e8aa1522$var$ChartUpdateType3.PERFORM_LAYOUT, {
            skipAnimations: true
        });
    }
    onDragEnd() {
        const { axisDragger: axisDragger, dragState: dragState, enabled: enabled, panner: panner, selector: selector, ctx: { domManager: domManager, interactionManager: interactionManager, tooltipManager: tooltipManager } } = this;
        interactionManager.popState((0, $iTJTu._ModuleSupport).InteractionState.ZoomDrag);
        if (!enabled || dragState === 0 /* None */ ) return;
        switch(dragState){
            case 1 /* Axis */ :
                this.hoveredAxis = void 0;
                axisDragger.stop();
                break;
            case 2 /* Pan */ :
                panner.stop();
                break;
            case 3 /* Select */ :
                {
                    if (!selector.didUpdate()) break;
                    const zoom = this.getZoom();
                    const newZoom = selector.stop(this.seriesRect, this.paddedRect, zoom);
                    this.updateZoom(newZoom);
                    break;
                }
        }
        this.dragState = 0 /* None */ ;
        domManager.updateCursor($2fb96651e8aa1522$var$CURSOR_ID);
        tooltipManager.removeTooltip($2fb96651e8aa1522$var$TOOLTIP_ID);
    }
    onNavZoom(event) {
        const { enabled: enabled, enableScrolling: enableScrolling, scroller: scroller } = this;
        const isDefaultState = this.ctx.interactionManager.isState((0, $iTJTu._ModuleSupport).InteractionState.Default);
        if (!isDefaultState || !enabled || !enableScrolling) return;
        event.widgetEvent.sourceEvent.preventDefault();
        this.updateZoom(scroller.updateDelta(event.delta, this.getModuleProperties(), this.getZoom()));
    }
    onWheel(event) {
        const { enabled: enabled, enablePanning: enablePanning, enableScrolling: enableScrolling, paddedRect: paddedRect } = this;
        if (!enabled || !enableScrolling || !paddedRect || !this.isState($2fb96651e8aa1522$var$InteractionState4.ZoomWheelable)) return;
        const { deltaX: deltaX, deltaY: deltaY } = event.sourceEvent;
        const isHorizontalScrolling = deltaX != null && deltaY != null && Math.abs(deltaX) > Math.abs(deltaY);
        if (enablePanning && isHorizontalScrolling) this.onWheelPanning(event);
        else this.onWheelScrolling(event);
    }
    onWheelPanning(event) {
        const { scrollingStep: scrollingStep, scrollPanner: scrollPanner, seriesRect: seriesRect, ctx: { zoomManager: zoomManager } } = this;
        if (!seriesRect) return;
        event.sourceEvent.preventDefault();
        const newZooms = scrollPanner.update(event, scrollingStep, seriesRect, zoomManager.getAxisZooms());
        for (const [axisId, { direction: direction, zoom: zoom }] of (0, $idDdm.entries)(newZooms))this.updateAxisZoom(axisId, direction, zoom);
    }
    onWheelScrolling(event) {
        const { enableAxisDragging: enableAxisDragging, enableIndependentAxes: enableIndependentAxes, hoveredAxis: hoveredAxis, scroller: scroller, seriesRect: seriesRect, ctx: { zoomManager: zoomManager } } = this;
        if (!seriesRect) return;
        const zoom = this.getZoom();
        let isZoomCapped = event.deltaY > 0 && this.isMaxZoom(zoom);
        const isAxisScrolling = enableAxisDragging && hoveredAxis != null;
        let isScalingX = this.isScalingX();
        let isScalingY = this.isScalingY();
        if (isAxisScrolling) {
            isScalingX = hoveredAxis.direction === (0, $iTJTu._ModuleSupport).ChartAxisDirection.X;
            isScalingY = !isScalingX;
        }
        const props = this.getModuleProperties({
            isScalingX: isScalingX,
            isScalingY: isScalingY
        });
        let updated = true;
        if (enableIndependentAxes === true) {
            const newZooms = scroller.updateAxes(event, props, seriesRect, zoomManager.getAxisZooms());
            for (const [axisId, { direction: direction, zoom: axisZoom }] of (0, $idDdm.entries)(newZooms)){
                if (isAxisScrolling && hoveredAxis.id !== axisId) continue;
                updated && (updated = this.updateAxisZoom(axisId, direction, axisZoom));
            }
        } else {
            const newZoom = scroller.update(event, props, seriesRect, this.getZoom());
            updated = this.updateUnifiedZoom(newZoom);
        }
        isZoomCapped || (isZoomCapped = event.deltaY < 0 && !updated);
        if (!this.isFirstWheelEvent || !isZoomCapped) event.sourceEvent.preventDefault();
        this.isFirstWheelEvent = false;
        this.debouncedWheelReset();
    }
    onAxisDragStart(id, direction) {
        this.hoveredAxis = {
            id: id,
            direction: direction
        };
        this.onDragStart(void 0);
    }
    onTouchStart(event, current) {
        if (!this.enableTwoFingerZoom || this.dragState !== 0 /* None */ ) return;
        if (this.twoFingers.start(event, current, this.getZoom())) this.dragState = 4 /* TwoFingers */ ;
    }
    onTouchMove(event, current) {
        if (!this.enableTwoFingerZoom || this.dragState !== 4 /* TwoFingers */ ) return;
        const newZoom = this.twoFingers.update(event, current);
        this.updateZoom($2fb96651e8aa1522$var$constrainZoom(newZoom));
    }
    onTouchEnd(event) {
        if (!this.enableTwoFingerZoom || this.dragState !== 4 /* TwoFingers */ ) return;
        event.sourceEvent.preventDefault();
        if (this.twoFingers.end(event)) this.dragState = 0 /* None */ ;
    }
    onProcessData(event) {
        this.shouldFlipXY = event.series.shouldFlipXY;
    }
    onLayoutComplete(event) {
        this.domProxy.update(this.enableAxisDragging, this.ctx);
        if (!this.enabled) return;
        this.seriesRect = event.series.rect;
        this.paddedRect = event.series.paddedRect;
        if (this.enableAxisDragging) this.toggleAxisDraggingCursors();
    }
    onZoomChange(event) {
        if (event.callerId !== "zoom") this.panner.stopInteractions();
        const zoom = this.getZoom();
        this.buttons.toggleVisibleZoomed(this.isMaxZoom(zoom));
    }
    onZoomPanStart(event) {
        if (event.callerId === "zoom") this.panner.stopInteractions();
    }
    onPanUpdate(event) {
        const { panner: panner, seriesRect: seriesRect, ctx: { tooltipManager: tooltipManager, zoomManager: zoomManager } } = this;
        if (!seriesRect) return;
        const newZooms = panner.translateZooms(seriesRect, zoomManager.getAxisZooms(), event.deltaX, event.deltaY);
        for (const [axisId, { direction: direction, zoom: zoom }] of (0, $idDdm.entries)(newZooms))this.updateAxisZoom(axisId, direction, zoom);
        tooltipManager.updateTooltip($2fb96651e8aa1522$var$TOOLTIP_ID);
    }
    isPanningKeyPressed(event) {
        switch(this.panKey){
            case "alt":
                return event.altKey;
            case "ctrl":
                return event.ctrlKey;
            case "shift":
                return event.shiftKey;
            case "meta":
                return event.metaKey;
        }
    }
    isScalingX() {
        if (this.axes === "xy") return true;
        return this.shouldFlipXY ? this.axes === "y" : this.axes === "x";
    }
    isScalingY() {
        if (this.axes === "xy") return true;
        return this.shouldFlipXY ? this.axes === "x" : this.axes === "y";
    }
    getAnchorPointX() {
        return this.shouldFlipXY ? this.anchorPointY : this.anchorPointX;
    }
    getAnchorPointY() {
        return this.shouldFlipXY ? this.anchorPointX : this.anchorPointY;
    }
    isMaxZoom(zoom) {
        return $2fb96651e8aa1522$var$isZoomEqual(zoom, $2fb96651e8aa1522$var$unitZoomState());
    }
    isZoomValid(newZoom) {
        const { minVisibleItems: minVisibleItems, minVisibleItemsX: minVisibleItemsX, minVisibleItemsY: minVisibleItemsY, ctx: { zoomManager: zoomManager } } = this;
        if (minVisibleItems === 0) return true;
        const zoom = this.getZoom();
        const zoomedInX = $2fb96651e8aa1522$var$round($2fb96651e8aa1522$var$dx(newZoom)) < $2fb96651e8aa1522$var$round($2fb96651e8aa1522$var$dx(zoom));
        const zoomedInY = $2fb96651e8aa1522$var$round($2fb96651e8aa1522$var$dy(newZoom)) < $2fb96651e8aa1522$var$round($2fb96651e8aa1522$var$dy(zoom));
        if (!zoomedInX && !zoomedInY) return true;
        if (minVisibleItemsX != null && zoomedInX) return zoomManager.isVisibleItemsCountAtLeast(newZoom, minVisibleItemsX);
        if (minVisibleItemsY != null && zoomedInY) return zoomManager.isVisibleItemsCountAtLeast(newZoom, minVisibleItemsY);
        return zoomManager.isVisibleItemsCountAtLeast(newZoom, minVisibleItems);
    }
    isAxisZoomValid(direction, axisZoom) {
        const { minVisibleItems: minVisibleItems, minVisibleItemsX: minVisibleItemsX, minVisibleItemsY: minVisibleItemsY, ctx: { zoomManager: zoomManager } } = this;
        const zoom = this.getZoom();
        const deltaAxis = axisZoom.max - axisZoom.min;
        const deltaOld = zoom[direction].max - zoom[direction].min;
        const newZoom = {
            ...zoom,
            [direction]: axisZoom
        };
        const minVisibleDir = direction === $2fb96651e8aa1522$var$ChartAxisDirection17.X ? minVisibleItemsX : minVisibleItemsY;
        return deltaAxis >= deltaOld || zoomManager.isVisibleItemsCountAtLeast(newZoom, minVisibleDir ?? minVisibleItems);
    }
    resetZoom() {
        this.ctx.zoomManager.resetZoom("zoom");
    }
    updateZoom(zoom) {
        if (this.enableIndependentAxes) this.updatePrimaryAxisZooms(zoom);
        else this.updateUnifiedZoom(zoom);
    }
    updateUnifiedZoom(zoom) {
        if (!this.isZoomValid(zoom)) {
            this.ctx.updateService.update($2fb96651e8aa1522$var$ChartUpdateType3.SCENE_RENDER, {
                skipAnimations: true
            });
            return false;
        }
        this.ctx.zoomManager.updateZoom("zoom", zoom);
        return true;
    }
    updatePrimaryAxisZooms(zoom) {
        this.updatePrimaryAxisZoom(zoom, $2fb96651e8aa1522$var$ChartAxisDirection17.X);
        this.updatePrimaryAxisZoom(zoom, $2fb96651e8aa1522$var$ChartAxisDirection17.Y);
    }
    updatePrimaryAxisZoom(zoom, direction) {
        const axisId = this.ctx.zoomManager.getPrimaryAxisId(direction);
        if (axisId == null) return;
        this.updateAxisZoom(axisId, direction, zoom[direction]);
    }
    updateAxisZoom(axisId, direction, axisZoom) {
        const { enableIndependentAxes: enableIndependentAxes, ctx: { zoomManager: zoomManager } } = this;
        if (!axisZoom) return false;
        const zoom = this.getZoom();
        if (enableIndependentAxes !== true) {
            zoom[direction] = axisZoom;
            return this.updateUnifiedZoom(zoom);
        }
        if (!this.isAxisZoomValid(direction, axisZoom)) return false;
        zoomManager.updateAxisZoom("zoom", axisId, axisZoom);
        return true;
    }
    toggleAxisDraggingCursors() {
        const { anchorPointX: anchorPointX, anchorPointY: anchorPointY, domProxy: domProxy } = this;
        const zoom = this.getZoom();
        let showCursorX = $2fb96651e8aa1522$var$dx(zoom) !== $2fb96651e8aa1522$var$UNIT_SIZE;
        let showCursorY = $2fb96651e8aa1522$var$dy(zoom) !== $2fb96651e8aa1522$var$UNIT_SIZE;
        if (!showCursorX) {
            const checkZoomX = $2fb96651e8aa1522$var$scaleZoom(zoom, 0.999, 1);
            checkZoomX.x = $2fb96651e8aa1522$var$scaleZoomAxisWithAnchor(checkZoomX.x, zoom.x, anchorPointX);
            showCursorX = this.isZoomValid(checkZoomX);
        }
        if (!showCursorY) {
            const checkZoomY = $2fb96651e8aa1522$var$scaleZoom(zoom, 1, 0.999);
            checkZoomY.y = $2fb96651e8aa1522$var$scaleZoomAxisWithAnchor(checkZoomY.y, zoom.y, anchorPointY);
            showCursorY = this.isZoomValid(checkZoomY);
        }
        domProxy.toggleAxisDraggingCursor($2fb96651e8aa1522$var$ChartAxisDirection17.X, showCursorX);
        domProxy.toggleAxisDraggingCursor($2fb96651e8aa1522$var$ChartAxisDirection17.Y, showCursorY);
    }
    getZoom() {
        return $2fb96651e8aa1522$var$definedZoomState(this.ctx.zoomManager.getZoom());
    }
    getResetZoom() {
        return $2fb96651e8aa1522$var$definedZoomState(this.ctx.zoomManager.getRestoredZoom());
    }
    getModuleProperties(overrides) {
        return {
            anchorPointX: overrides?.anchorPointX ?? this.getAnchorPointX(),
            anchorPointY: overrides?.anchorPointY ?? this.getAnchorPointY(),
            enabled: overrides?.enabled ?? this.enabled,
            independentAxes: overrides?.independentAxes ?? this.enableIndependentAxes === true,
            isScalingX: overrides?.isScalingX ?? this.isScalingX(),
            isScalingY: overrides?.isScalingY ?? this.isScalingY(),
            keepAspectRatio: overrides?.keepAspectRatio ?? this.keepAspectRatio,
            scrollingStep: overrides?.scrollingStep ?? this.scrollingStep
        };
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ActionOnSet9({
        newValue (enabled) {
            this.onEnabledChange(enabled);
        }
    }),
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "enableAxisDragging", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "enableDoubleClickToReset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ActionOnSet9({
        changeValue (newValue) {
            this.ctx.zoomManager.setIndependentAxes(Boolean(newValue));
        }
    }),
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "enableIndependentAxes", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "enablePanning", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "enableScrolling", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "enableSelecting", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "enableTwoFingerZoom", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "panKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "axes", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "scrollingStep", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "keepAspectRatio", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "minVisibleItems", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Deprecated2("Use [minVisibleItems] instead."),
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "minVisibleItemsX", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Deprecated2("Use [minVisibleItems] instead."),
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "minVisibleItemsY", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "anchorPointX", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "anchorPointY", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "autoScaling", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "buttons", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ProxyProperty3("panner.deceleration"),
    $2fb96651e8aa1522$var$Property53
], $2fb96651e8aa1522$var$Zoom.prototype, "deceleration", 2);
// packages/ag-charts-enterprise/src/features/zoom/zoomModule.ts
var $2fb96651e8aa1522$var$buttons = {
    enabled: true,
    visible: "hover",
    buttons: [
        {
            icon: "zoom-out",
            tooltip: "toolbarZoomZoomOut",
            value: "zoom-out",
            section: "scale"
        },
        {
            icon: "zoom-in",
            tooltip: "toolbarZoomZoomIn",
            value: "zoom-in",
            section: "scale"
        },
        {
            icon: "pan-left",
            tooltip: "toolbarZoomPanLeft",
            value: "pan-left",
            section: "pan"
        },
        {
            icon: "pan-right",
            tooltip: "toolbarZoomPanRight",
            value: "pan-right",
            section: "pan"
        },
        {
            icon: "reset",
            tooltip: "toolbarZoomReset",
            value: "reset",
            section: "reset"
        }
    ]
};
var $2fb96651e8aa1522$var$ZoomModule = {
    type: "root",
    optionsKey: "zoom",
    packageType: "enterprise",
    chartTypes: [
        "cartesian",
        "topology"
    ],
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$Zoom(ctx),
    themeTemplate: {
        zoom: {
            anchorPointX: "end",
            anchorPointY: "middle",
            axes: "x",
            buttons: $2fb96651e8aa1522$var$buttons,
            enabled: false,
            enableAxisDragging: true,
            enableDoubleClickToReset: true,
            enablePanning: true,
            enableScrolling: true,
            enableSelecting: false,
            enableTwoFingerZoom: true,
            deceleration: "short",
            minVisibleItems: 2,
            panKey: "alt",
            scrollingStep: 0.1,
            autoScaling: {
                enabled: false,
                padding: 0.05
            }
        }
    }
};
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties18, AxisTicks: $2fb96651e8aa1522$var$AxisTicks, ZIndexMap: $2fb96651e8aa1522$var$ZIndexMap8, ProxyProperty: $2fb96651e8aa1522$var$ProxyProperty4, Property: $2fb96651e8aa1522$var$Property54, LayoutElement: $2fb96651e8aa1522$var$LayoutElement5, Group: $2fb96651e8aa1522$var$Group8, Rect: $2fb96651e8aa1522$var$Rect2, Marker: $2fb96651e8aa1522$var$Marker, TranslatableGroup: $2fb96651e8aa1522$var$TranslatableGroup3, BBox: $2fb96651e8aa1522$var$BBox9 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$GradientBar = class extends $2fb96651e8aa1522$var$BaseProperties18 {
    constructor(){
        super(...arguments);
        this.thickness = 16;
        this.preferredLength = 100;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property54
], $2fb96651e8aa1522$var$GradientBar.prototype, "thickness", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property54
], $2fb96651e8aa1522$var$GradientBar.prototype, "preferredLength", 2);
var $2fb96651e8aa1522$var$GradientLegendScale = class {
    constructor(axisTicks){
        this.axisTicks = axisTicks;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ProxyProperty4("axisTicks.label")
], $2fb96651e8aa1522$var$GradientLegendScale.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ProxyProperty4("axisTicks.interval")
], $2fb96651e8aa1522$var$GradientLegendScale.prototype, "interval", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$ProxyProperty4("axisTicks.padding")
], $2fb96651e8aa1522$var$GradientLegendScale.prototype, "padding", 2);
var $2fb96651e8aa1522$var$GradientLegend = class {
    constructor(ctx){
        this.ctx = ctx;
        this.id = (0, $idDdm.createId)(this);
        this.legendGroup = new $2fb96651e8aa1522$var$TranslatableGroup3({
            name: "legend",
            zIndex: $2fb96651e8aa1522$var$ZIndexMap8.LEGEND
        });
        this.gradientRect = new $2fb96651e8aa1522$var$Rect2();
        this.arrow = new $2fb96651e8aa1522$var$Marker({
            shape: "triangle"
        });
        this.ticksGroup = new $2fb96651e8aa1522$var$Group8({
            name: "legend-axis-group"
        });
        this.destroyFns = [];
        this.enabled = false;
        this.position = "bottom";
        this.reverseOrder = false;
        this.gradient = new $2fb96651e8aa1522$var$GradientBar();
        this.spacing = 20;
        this.data = [];
        this.highlightManager = ctx.highlightManager;
        this.axisTicks = new $2fb96651e8aa1522$var$AxisTicks();
        this.axisTicks.attachAxis(this.ticksGroup);
        this.scale = new $2fb96651e8aa1522$var$GradientLegendScale(this.axisTicks);
        this.legendGroup.append([
            this.gradientRect,
            this.arrow,
            this.ticksGroup
        ]);
        this.destroyFns.push(ctx.highlightManager.addListener("highlight-change", ()=>this.onChartHoverChange()), ctx.layoutManager.registerElement($2fb96651e8aa1522$var$LayoutElement5.Legend, (e)=>this.onStartLayout(e)), ()=>this.legendGroup.remove());
    }
    isVertical() {
        return this.position === "right" || this.position === "left";
    }
    destroy() {
        this.destroyFns.forEach((f)=>f());
    }
    attachLegend(scene) {
        scene.appendChild(this.legendGroup);
    }
    onStartLayout(ctx) {
        const [data] = this.data;
        if (!this.enabled || !data?.enabled || data.legendType !== "gradient") {
            this.legendGroup.visible = false;
            return;
        }
        const { colorRange: colorRange } = this.normalizeColorArrays(data);
        this.updateGradientRect(ctx.layoutBox, colorRange);
        const axisBBox = this.updateAxis(data) ?? new $2fb96651e8aa1522$var$BBox9(0, 0, 0, 0);
        const { left: left, top: top } = this.getMeasurements(ctx.layoutBox, axisBBox);
        this.updateArrow();
        this.legendGroup.visible = true;
        this.legendGroup.translationX = left;
        this.legendGroup.translationY = top;
    }
    normalizeColorArrays(data) {
        let colorDomain = data.colorDomain.slice();
        const colorRange = data.colorRange.slice();
        if (colorDomain.length === colorRange.length) return {
            colorDomain: colorDomain,
            colorRange: colorRange
        };
        if (colorDomain.length > colorRange.length) colorRange.splice(colorDomain.length);
        const [d0, d1] = colorDomain;
        const count = colorRange.length;
        colorDomain = colorRange.map((_, i)=>{
            if (i === 0) return d0;
            else if (i === count - 1) return d1;
            return d0 + (d1 - d0) * i / (count - 1);
        });
        return {
            colorDomain: colorDomain,
            colorRange: colorRange
        };
    }
    updateGradientRect(shrinkRect, colorRange) {
        const { gradientRect: gradientRect } = this;
        const { preferredLength: preferredLength, thickness: thickness } = this.gradient;
        let angle;
        if (this.isVertical()) {
            angle = 0;
            gradientRect.width = thickness;
            gradientRect.height = Math.min(shrinkRect.height, preferredLength);
        } else {
            angle = 90;
            gradientRect.width = Math.min(shrinkRect.width, preferredLength);
            gradientRect.height = thickness;
        }
        gradientRect.fill = {
            type: "gradient",
            gradient: "linear",
            colorSpace: "oklch",
            colorStops: colorRange.map((color6, i)=>({
                    stop: i / (colorRange.length - 1),
                    color: color6
                })),
            rotation: angle
        };
    }
    updateAxis(data) {
        const { axisTicks: axisTicks } = this;
        const vertical = this.isVertical();
        const positiveAxis = this.reverseOrder !== vertical;
        axisTicks.position = this.position;
        axisTicks.translationX = vertical ? this.gradient.thickness : 0;
        axisTicks.translationY = vertical ? 0 : this.gradient.thickness;
        axisTicks.scale.domain = positiveAxis ? data.colorDomain.slice().reverse() : data.colorDomain;
        axisTicks.scale.range = vertical ? [
            0,
            this.gradientRect.height
        ] : [
            0,
            this.gradientRect.width
        ];
        return axisTicks.calculateLayout();
    }
    updateArrow() {
        const highlighted = this.highlightManager.getActiveHighlight();
        const { arrow: arrow } = this;
        if (highlighted?.colorValue == null) {
            arrow.visible = false;
            return;
        }
        const { scale: scale, label: label } = this.axisTicks;
        const size = label.fontSize ?? 0;
        const t = scale.convert(highlighted.colorValue);
        let { x: x, y: y } = this.gradientRect;
        let rotation = Math.PI;
        if (this.isVertical()) {
            x -= size / 2;
            y += t;
            rotation /= 2;
        } else {
            x += t;
            y -= size / 2;
        }
        arrow.visible = true;
        arrow.fill = label.color;
        arrow.rotation = rotation;
        arrow.size = size;
        arrow.translationX = x;
        arrow.translationY = y;
    }
    getMeasurements(shrinkRect, axisBox) {
        let { x: left, y: top } = shrinkRect;
        let { width: width, height: height } = this.gradientRect;
        if (this.isVertical()) width += axisBox.width + 5;
        else height += axisBox.height + 5;
        switch(this.position){
            case "left":
                top += shrinkRect.height / 2 - height / 2;
                shrinkRect.shrink(width + this.spacing, "left");
                break;
            case "right":
                left += shrinkRect.width - width;
                top += shrinkRect.height / 2 - height / 2;
                shrinkRect.shrink(width + this.spacing, "right");
                break;
            case "top":
                left += shrinkRect.width / 2 - width / 2;
                shrinkRect.shrink(height + this.spacing, "top");
                break;
            case "bottom":
                left += shrinkRect.width / 2 - width / 2;
                top += shrinkRect.height - height;
                shrinkRect.shrink(height + this.spacing, "bottom");
        }
        return {
            top: top,
            left: left
        };
    }
    onChartHoverChange() {
        if (!this.enabled) return;
        this.updateArrow();
    }
};
$2fb96651e8aa1522$var$GradientLegend.className = "GradientLegend";
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property54
], $2fb96651e8aa1522$var$GradientLegend.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property54
], $2fb96651e8aa1522$var$GradientLegend.prototype, "position", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property54
], $2fb96651e8aa1522$var$GradientLegend.prototype, "reverseOrder", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property54
], $2fb96651e8aa1522$var$GradientLegend.prototype, "gradient", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property54
], $2fb96651e8aa1522$var$GradientLegend.prototype, "spacing", 2);
// packages/ag-charts-enterprise/src/gradient-legend/gradientLegendModule.ts
var $2fb96651e8aa1522$var$GradientLegendModule = {
    type: "legend",
    optionsKey: "gradientLegend",
    packageType: "enterprise",
    chartTypes: [
        "cartesian",
        "polar",
        "hierarchy",
        "topology",
        "flow-proportion",
        "standalone",
        "gauge"
    ],
    identifier: "gradient",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$GradientLegend(ctx),
    themeTemplate: {
        enabled: false,
        position: "bottom",
        spacing: 20,
        scale: {
            padding: 13,
            label: {
                color: {
                    $ref: "textColor"
                },
                fontSize: {
                    $ref: "fontSize"
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontWeight: {
                    $ref: "fontWeight"
                }
            },
            interval: {
                minSpacing: 15
            }
        },
        gradient: {
            preferredLength: 100,
            thickness: 16
        },
        reverseOrder: false
    },
    removable: "standalone-only"
};
function $2fb96651e8aa1522$var$injectWatermark(domManager, text2) {
    const element = domManager.addChild("canvas-overlay", "watermark");
    const textElement = (0, $idDdm.createElement)("span");
    textElement.innerText = text2;
    element.addEventListener("animationend", ()=>{
        domManager.removeChild("canvas-overlay", "watermark");
        domManager.removeStyles("watermark");
    });
    element.classList.add("ag-watermark");
    element.appendChild(textElement);
}
var { ordinalTimeAxisOptionsDefs: $2fb96651e8aa1522$var$ordinalTimeAxisOptionsDefs, angleNumberAxisOptionsDefs: $2fb96651e8aa1522$var$angleNumberAxisOptionsDefs, angleCategoryAxisOptionsDefs: $2fb96651e8aa1522$var$angleCategoryAxisOptionsDefs, radiusNumberAxisOptionsDefs: $2fb96651e8aa1522$var$radiusNumberAxisOptionsDefs, radiusCategoryAxisOptionsDefs: $2fb96651e8aa1522$var$radiusCategoryAxisOptionsDefs } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$OrdinalTimeAxisModule2 = {
    type: "axis",
    name: "ordinal-time",
    chartType: "cartesian",
    enterprise: true,
    options: $2fb96651e8aa1522$var$ordinalTimeAxisOptionsDefs,
    create: (ctx)=>new $2fb96651e8aa1522$var$OrdinalTimeAxis(ctx)
};
var $2fb96651e8aa1522$var$AngleNumberAxisModule2 = {
    type: "axis",
    name: "angle-number",
    chartType: "polar",
    enterprise: true,
    options: $2fb96651e8aa1522$var$angleNumberAxisOptionsDefs,
    create: (ctx)=>new $2fb96651e8aa1522$var$AngleNumberAxis(ctx)
};
var $2fb96651e8aa1522$var$AngleCategoryAxisModule2 = {
    type: "axis",
    name: "angle-category",
    chartType: "polar",
    enterprise: true,
    options: $2fb96651e8aa1522$var$angleCategoryAxisOptionsDefs,
    create: (ctx)=>new $2fb96651e8aa1522$var$AngleCategoryAxis(ctx)
};
var $2fb96651e8aa1522$var$RadiusNumberAxisModule2 = {
    type: "axis",
    name: "radius-number",
    chartType: "polar",
    enterprise: true,
    options: $2fb96651e8aa1522$var$radiusNumberAxisOptionsDefs,
    create: (ctx)=>new $2fb96651e8aa1522$var$RadiusNumberAxis(ctx)
};
var $2fb96651e8aa1522$var$RadiusCategoryAxisModule2 = {
    type: "axis",
    name: "radius-category",
    chartType: "polar",
    enterprise: true,
    options: $2fb96651e8aa1522$var$radiusCategoryAxisOptionsDefs,
    create: (ctx)=>new $2fb96651e8aa1522$var$RadiusCategoryAxis(ctx)
};
var { Chart: $2fb96651e8aa1522$var$Chart, Property: $2fb96651e8aa1522$var$Property55 } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$isFlowProportion(series) {
    return series.type === "sankey" || series.type === "chord";
}
var $2fb96651e8aa1522$var$FlowProportionChart = class extends $2fb96651e8aa1522$var$Chart {
    getChartType() {
        return "flow-proportion";
    }
    async updateData() {
        await super.updateData();
        const options = this.getOptions();
        if (this.nodes !== options.nodes) this.nodes = options.nodes;
        const { nodes: nodes } = this;
        this.series.forEach((series)=>{
            if ($2fb96651e8aa1522$var$isFlowProportion(series)) series.setChartNodes(nodes);
        });
    }
    performLayout(ctx) {
        const { seriesRoot: seriesRoot, annotationRoot: annotationRoot } = this;
        const { layoutBox: layoutBox } = ctx;
        layoutBox.shrink(this.seriesArea.padding.toJson());
        const seriesRect = layoutBox.clone();
        this.seriesRect = seriesRect;
        this.animationRect = seriesRect;
        seriesRoot.visible = this.series.some((s)=>s.visible);
        for (const group of [
            seriesRoot,
            annotationRoot
        ]){
            group.translationX = Math.floor(seriesRect.x);
            group.translationY = Math.floor(seriesRect.y);
        }
        this.ctx.layoutManager.emitLayoutComplete(ctx, {
            series: {
                visible: seriesRoot.visible,
                rect: seriesRect,
                paddedRect: seriesRect
            }
        });
    }
};
$2fb96651e8aa1522$var$FlowProportionChart.className = "FlowProportionChart";
$2fb96651e8aa1522$var$FlowProportionChart.type = "flow-proportion";
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property55
], $2fb96651e8aa1522$var$FlowProportionChart.prototype, "nodes", 2);
// packages/ag-charts-enterprise/src/charts/flowProportionChartModule.ts
var { isAgFlowProportionChartOptions: $2fb96651e8aa1522$var$isAgFlowProportionChartOptions, flowProportionChartOptionsDefs: $2fb96651e8aa1522$var$flowProportionChartOptionsDefs } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$FlowProportionChartModule = {
    type: "chart",
    name: "flow-proportion",
    enterprise: true,
    options: $2fb96651e8aa1522$var$flowProportionChartOptionsDefs,
    detect: $2fb96651e8aa1522$var$isAgFlowProportionChartOptions,
    create (options, resources) {
        return new $2fb96651e8aa1522$var$FlowProportionChart(options, resources);
    }
};
var { Chart: $2fb96651e8aa1522$var$Chart2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$GaugeChart = class extends $2fb96651e8aa1522$var$Chart2 {
    getChartType() {
        return "gauge";
    }
    performLayout(ctx) {
        const { seriesRoot: seriesRoot, annotationRoot: annotationRoot, series: series, seriesArea: seriesArea } = this;
        const { layoutBox: layoutBox } = ctx;
        const seriesRect = layoutBox.clone();
        layoutBox.shrink(seriesArea.padding.toJson());
        this.seriesRect = seriesRect.clone().translate(seriesRect.x - layoutBox.x, seriesRect.y - layoutBox.y);
        this.animationRect = layoutBox;
        seriesRoot.visible = series.some((s)=>s.visible);
        for (const group of [
            seriesRoot,
            annotationRoot
        ]){
            group.translationX = Math.floor(layoutBox.x);
            group.translationY = Math.floor(layoutBox.y);
        }
        this.ctx.layoutManager.emitLayoutComplete(ctx, {
            series: {
                visible: seriesRoot.visible,
                rect: seriesRect,
                paddedRect: layoutBox
            }
        });
    }
    getAriaLabel() {
        const captions = [];
        const chartCaption = this.getCaptionText();
        if (chartCaption.length !== 0) captions.push(chartCaption);
        for (const series of this.series)captions.push(series.getCaptionText());
        const caption = captions.join(". ");
        return this.ctx.localeManager.t("ariaAnnounceGaugeChart", {
            caption: caption
        });
    }
};
$2fb96651e8aa1522$var$GaugeChart.className = "GaugeChart";
$2fb96651e8aa1522$var$GaugeChart.type = "gauge";
// packages/ag-charts-enterprise/src/charts/gaugeChartModule.ts
var { isAgGaugeChartOptions: $2fb96651e8aa1522$var$isAgGaugeChartOptions, gaugeChartOptionsDefs: $2fb96651e8aa1522$var$gaugeChartOptionsDefs } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$GaugeChartModule = {
    type: "chart",
    name: "gauge",
    enterprise: true,
    options: $2fb96651e8aa1522$var$gaugeChartOptionsDefs,
    detect: $2fb96651e8aa1522$var$isAgGaugeChartOptions,
    create (options, resources) {
        return new $2fb96651e8aa1522$var$GaugeChart(options, resources);
    }
};
var { Chart: $2fb96651e8aa1522$var$Chart3 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$HierarchyChart = class extends $2fb96651e8aa1522$var$Chart3 {
    getChartType() {
        return "hierarchy";
    }
    performLayout(ctx) {
        const { seriesRoot: seriesRoot, annotationRoot: annotationRoot } = this;
        const { layoutBox: layoutBox } = ctx;
        layoutBox.shrink(this.seriesArea.padding.toJson());
        const seriesRect = layoutBox.clone();
        this.seriesRect = seriesRect;
        this.animationRect = seriesRect;
        for (const group of [
            seriesRoot,
            annotationRoot
        ]){
            group.translationX = Math.floor(seriesRect.x);
            group.translationY = Math.floor(seriesRect.y);
        }
        seriesRoot.visible = this.series[0].visible;
        seriesRoot.setClipRect(seriesRect.clone());
        this.ctx.layoutManager.emitLayoutComplete(ctx, {
            series: {
                visible: true,
                rect: seriesRect,
                paddedRect: seriesRect
            }
        });
    }
    getAriaLabel() {
        const caption = this.getCaptionText();
        return this.ctx.localeManager.t("ariaAnnounceHierarchyChart", {
            caption: caption
        });
    }
};
$2fb96651e8aa1522$var$HierarchyChart.className = "HierarchyChart";
$2fb96651e8aa1522$var$HierarchyChart.type = "hierarchy";
// packages/ag-charts-enterprise/src/charts/hierarchyChartModule.ts
var { isAgHierarchyChartOptions: $2fb96651e8aa1522$var$isAgHierarchyChartOptions, hierarchyChartOptionsDefs: $2fb96651e8aa1522$var$hierarchyChartOptionsDefs } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$HierarchyChartModule = {
    type: "chart",
    name: "hierarchy",
    enterprise: true,
    options: $2fb96651e8aa1522$var$hierarchyChartOptionsDefs,
    detect: $2fb96651e8aa1522$var$isAgHierarchyChartOptions,
    create (options, resources) {
        return new $2fb96651e8aa1522$var$HierarchyChart(options, resources);
    }
};
var { Chart: $2fb96651e8aa1522$var$Chart4 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$StandaloneChart = class extends $2fb96651e8aa1522$var$Chart4 {
    getChartType() {
        return "standalone";
    }
    performLayout(ctx) {
        const { seriesRoot: seriesRoot, annotationRoot: annotationRoot } = this;
        const { layoutBox: layoutBox } = ctx;
        layoutBox.shrink(this.seriesArea.padding.toJson());
        const seriesRect = layoutBox.clone();
        this.seriesRect = seriesRect;
        this.animationRect = seriesRect;
        for (const group of [
            seriesRoot,
            annotationRoot
        ]){
            group.translationX = Math.floor(layoutBox.x);
            group.translationY = Math.floor(layoutBox.y);
        }
        seriesRoot.visible = this.series[0].visible;
        this.ctx.layoutManager.emitLayoutComplete(ctx, {
            series: {
                visible: true,
                rect: seriesRect,
                paddedRect: layoutBox
            }
        });
    }
    getAriaLabel() {
        const caption = this.getCaptionText();
        return this.ctx.localeManager.t("ariaAnnounceHierarchyChart", {
            caption: caption
        });
    }
};
$2fb96651e8aa1522$var$StandaloneChart.className = "StandaloneChart";
$2fb96651e8aa1522$var$StandaloneChart.type = "standalone";
// packages/ag-charts-enterprise/src/charts/standaloneChartModule.ts
var { isAgStandaloneChartOptions: $2fb96651e8aa1522$var$isAgStandaloneChartOptions, standaloneChartOptionsDefs: $2fb96651e8aa1522$var$standaloneChartOptionsDefs } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$StandaloneChartModule = {
    type: "chart",
    name: "standalone",
    enterprise: true,
    options: $2fb96651e8aa1522$var$standaloneChartOptionsDefs,
    detect: $2fb96651e8aa1522$var$isAgStandaloneChartOptions,
    create (options, resources) {
        return new $2fb96651e8aa1522$var$StandaloneChart(options, resources);
    }
};
var { Chart: $2fb96651e8aa1522$var$Chart5, MercatorScale: $2fb96651e8aa1522$var$MercatorScale, NumberAxis: $2fb96651e8aa1522$var$NumberAxis, Property: $2fb96651e8aa1522$var$Property56 } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$isTopologySeries(series) {
    return series.type === "map-shape" || series.type === "map-line" || series.type === "map-marker" || series.type === "map-shape-background" || series.type === "map-line-background";
}
var $2fb96651e8aa1522$var$TopologyChart = class extends $2fb96651e8aa1522$var$Chart5 {
    constructor(options, resources){
        super(options, resources);
        this.xAxis = new $2fb96651e8aa1522$var$NumberAxis(this.getModuleContext());
        this.xAxis.position = "bottom";
        this.yAxis = new $2fb96651e8aa1522$var$NumberAxis(this.getModuleContext());
        this.yAxis.position = "left";
        this.ctx.zoomManager.updateAxes([
            this.xAxis,
            this.yAxis
        ]);
    }
    getChartType() {
        return "topology";
    }
    async updateData() {
        await super.updateData();
        const options = this.getOptions();
        if (this.topology !== options.topology) this.topology = options.topology;
        const { topology: topology } = this;
        this.series.forEach((series)=>{
            if ($2fb96651e8aa1522$var$isTopologySeries(series)) series.setChartTopology(topology);
        });
    }
    performLayout(ctx) {
        const { seriesRoot: seriesRoot, annotationRoot: annotationRoot } = this;
        const { layoutBox: layoutBox } = ctx;
        layoutBox.shrink(this.seriesArea.padding.toJson());
        const seriesRect = layoutBox.clone();
        this.seriesRect = seriesRect;
        this.animationRect = seriesRect;
        const mapSeries = this.series.filter($2fb96651e8aa1522$var$isTopologySeries);
        const combinedBbox = mapSeries.reduce((combined, series)=>{
            if (!series.visible) return combined;
            const bbox = series.topologyBounds;
            if (bbox == null) return combined;
            if (combined == null) return bbox;
            combined.merge(bbox);
            return combined;
        }, void 0);
        let scale;
        if (combinedBbox != null) {
            const { lon0: lon0, lat0: lat0, lon1: lon1, lat1: lat1 } = combinedBbox;
            const domain = [
                [
                    lon0,
                    lat0
                ],
                [
                    lon1,
                    lat1
                ]
            ];
            const bounds = $2fb96651e8aa1522$var$MercatorScale.bounds(domain);
            const { width: width, height: height } = seriesRect;
            const viewBoxScale = Math.min(width / bounds.width, height / bounds.height);
            const viewBoxWidth = bounds.width * viewBoxScale;
            const viewBoxHeight = bounds.height * viewBoxScale;
            const viewBoxOriginX = (width - viewBoxWidth) / 2;
            const viewBoxOriginY = (height - viewBoxHeight) / 2;
            const x0 = viewBoxOriginX;
            const y0 = viewBoxOriginY;
            const x1 = viewBoxOriginX + viewBoxWidth;
            const y1 = viewBoxOriginY + viewBoxHeight;
            const xZoom = this.ctx.zoomManager.getAxisZoom(this.xAxis.id);
            const yZoom = this.ctx.zoomManager.getAxisZoom(this.yAxis.id);
            const xSpan = (x1 - x0) / (xZoom.max - xZoom.min);
            const xStart = x0 - xSpan * xZoom.min;
            const ySpan = (y1 - y0) / (1 - yZoom.min - (1 - yZoom.max));
            const yStart = y0 - ySpan * (1 - yZoom.max);
            scale = new $2fb96651e8aa1522$var$MercatorScale(domain, [
                [
                    xStart,
                    yStart
                ],
                [
                    xStart + xSpan,
                    yStart + ySpan
                ]
            ]);
        }
        mapSeries.forEach((series)=>{
            series.scale = scale;
        });
        const seriesVisible = this.series.some((s)=>s.visible);
        seriesRoot.visible = seriesVisible;
        for (const group of [
            seriesRoot,
            annotationRoot
        ]){
            group.translationX = Math.floor(seriesRect.x);
            group.translationY = Math.floor(seriesRect.y);
            group.setClipRect(seriesRect.clone());
        }
        this.ctx.layoutManager.emitLayoutComplete(ctx, {
            series: {
                visible: seriesVisible,
                rect: seriesRect,
                paddedRect: seriesRect
            }
        });
    }
};
$2fb96651e8aa1522$var$TopologyChart.className = "TopologyChart";
$2fb96651e8aa1522$var$TopologyChart.type = "topology";
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property56
], $2fb96651e8aa1522$var$TopologyChart.prototype, "topology", 2);
// packages/ag-charts-enterprise/src/charts/topologyChartModule.ts
var { isAgTopologyChartOptions: $2fb96651e8aa1522$var$isAgTopologyChartOptions, topologyChartOptionsDefs: $2fb96651e8aa1522$var$topologyChartOptionsDefs } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$TopologyChartModule = {
    type: "chart",
    name: "topology",
    enterprise: true,
    options: $2fb96651e8aa1522$var$topologyChartOptionsDefs,
    detect: $2fb96651e8aa1522$var$isAgTopologyChartOptions,
    create (options, resources) {
        return new $2fb96651e8aa1522$var$TopologyChart(options, resources);
    }
};
var { annotationCalloutStylesDefs: $2fb96651e8aa1522$var$annotationCalloutStylesDefs, annotationNoteStylesDefs: $2fb96651e8aa1522$var$annotationNoteStylesDefs, annotationTextStylesDef: $2fb96651e8aa1522$var$annotationTextStylesDef, annotationCommentStylesDefs: $2fb96651e8aa1522$var$annotationCommentStylesDefs, annotationMeasurerStylesDefs: $2fb96651e8aa1522$var$annotationMeasurerStylesDefs, annotationShapeStylesDefs: $2fb96651e8aa1522$var$annotationShapeStylesDefs, annotationChannelTextDefs: $2fb96651e8aa1522$var$annotationChannelTextDefs, annotationCrossLineStyleDefs: $2fb96651e8aa1522$var$annotationCrossLineStyleDefs, annotationFibonacciStylesDefs: $2fb96651e8aa1522$var$annotationFibonacciStylesDefs, annotationLineStyleDefs: $2fb96651e8aa1522$var$annotationLineStyleDefs, annotationLineTextDefs: $2fb96651e8aa1522$var$annotationLineTextDefs, annotationDisjointChannelStyleDefs: $2fb96651e8aa1522$var$annotationDisjointChannelStyleDefs, annotationParallelChannelStyleDefs: $2fb96651e8aa1522$var$annotationParallelChannelStyleDefs } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$serializableDate = (0, $idDdm.optionsDefs)({
    __type: (0, $idDdm.required)((0, $idDdm.constant)("date")),
    value: (0, $idDdm.or)((0, $idDdm.string), (0, $idDdm.number))
}, "a serializable date object");
var $2fb96651e8aa1522$var$xValue = (0, $idDdm.or)((0, $idDdm.string), (0, $idDdm.number), $2fb96651e8aa1522$var$serializableDate);
var $2fb96651e8aa1522$var$annotationValue = (0, $idDdm.or)($2fb96651e8aa1522$var$xValue, (0, $idDdm.optionsDefs)({
    value: $2fb96651e8aa1522$var$xValue,
    groupPercentage: (0, $idDdm.numberRange)(-1, 1)
}));
var $2fb96651e8aa1522$var$channelAnnotationTextOptionsDef = {
    ...$2fb96651e8aa1522$var$annotationChannelTextDefs,
    label: (0, $idDdm.string)
};
var $2fb96651e8aa1522$var$lineAnnotationTextOptionsDef = {
    ...$2fb96651e8aa1522$var$annotationLineTextDefs,
    label: (0, $idDdm.string)
};
var $2fb96651e8aa1522$var$annotationPointOptionsDef = {
    x: $2fb96651e8aa1522$var$annotationValue,
    y: (0, $idDdm.number)
};
var $2fb96651e8aa1522$var$annotationInitialStateOptionsDef = (0, $idDdm.typeUnion)({
    line: {
        ...$2fb96651e8aa1522$var$annotationLineStyleDefs,
        start: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        end: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        text: $2fb96651e8aa1522$var$lineAnnotationTextOptionsDef
    },
    "horizontal-line": {
        ...$2fb96651e8aa1522$var$annotationCrossLineStyleDefs,
        value: $2fb96651e8aa1522$var$annotationValue,
        text: $2fb96651e8aa1522$var$lineAnnotationTextOptionsDef
    },
    "vertical-line": {
        ...$2fb96651e8aa1522$var$annotationCrossLineStyleDefs,
        value: $2fb96651e8aa1522$var$annotationValue,
        text: $2fb96651e8aa1522$var$lineAnnotationTextOptionsDef
    },
    "disjoint-channel": {
        ...$2fb96651e8aa1522$var$annotationDisjointChannelStyleDefs,
        startHeight: (0, $idDdm.positiveNumber),
        endHeight: (0, $idDdm.positiveNumber),
        start: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        end: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        text: $2fb96651e8aa1522$var$channelAnnotationTextOptionsDef
    },
    "parallel-channel": {
        ...$2fb96651e8aa1522$var$annotationParallelChannelStyleDefs,
        height: (0, $idDdm.positiveNumber),
        start: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        end: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        text: $2fb96651e8aa1522$var$channelAnnotationTextOptionsDef
    },
    "fibonacci-retracement": {
        ...$2fb96651e8aa1522$var$annotationFibonacciStylesDefs,
        start: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        end: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        text: $2fb96651e8aa1522$var$lineAnnotationTextOptionsDef,
        reverse: (0, $idDdm.boolean)
    },
    "fibonacci-retracement-trend-based": {
        ...$2fb96651e8aa1522$var$annotationFibonacciStylesDefs,
        start: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        end: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        endRetracement: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        text: $2fb96651e8aa1522$var$lineAnnotationTextOptionsDef,
        reverse: (0, $idDdm.boolean)
    },
    callout: {
        ...$2fb96651e8aa1522$var$annotationCalloutStylesDefs,
        start: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        end: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        text: (0, $idDdm.string)
    },
    comment: {
        ...$2fb96651e8aa1522$var$annotationCommentStylesDefs,
        ...$2fb96651e8aa1522$var$annotationPointOptionsDef,
        text: (0, $idDdm.string)
    },
    note: {
        ...$2fb96651e8aa1522$var$annotationNoteStylesDefs,
        ...$2fb96651e8aa1522$var$annotationPointOptionsDef,
        text: (0, $idDdm.string)
    },
    text: {
        ...$2fb96651e8aa1522$var$annotationTextStylesDef,
        ...$2fb96651e8aa1522$var$annotationPointOptionsDef,
        text: (0, $idDdm.string)
    },
    arrow: {
        ...$2fb96651e8aa1522$var$annotationLineStyleDefs,
        text: $2fb96651e8aa1522$var$lineAnnotationTextOptionsDef,
        start: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        end: $2fb96651e8aa1522$var$annotationPointOptionsDef
    },
    "arrow-up": {
        ...$2fb96651e8aa1522$var$annotationShapeStylesDefs,
        ...$2fb96651e8aa1522$var$annotationPointOptionsDef
    },
    "arrow-down": {
        ...$2fb96651e8aa1522$var$annotationShapeStylesDefs,
        ...$2fb96651e8aa1522$var$annotationPointOptionsDef
    },
    "date-range": {
        ...$2fb96651e8aa1522$var$annotationMeasurerStylesDefs,
        extendAbove: (0, $idDdm.boolean),
        extendBelow: (0, $idDdm.boolean),
        text: $2fb96651e8aa1522$var$lineAnnotationTextOptionsDef,
        start: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        end: $2fb96651e8aa1522$var$annotationPointOptionsDef
    },
    "price-range": {
        ...$2fb96651e8aa1522$var$annotationMeasurerStylesDefs,
        extendLeft: (0, $idDdm.boolean),
        extendRight: (0, $idDdm.boolean),
        text: $2fb96651e8aa1522$var$lineAnnotationTextOptionsDef,
        start: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        end: $2fb96651e8aa1522$var$annotationPointOptionsDef
    },
    "date-price-range": {
        ...$2fb96651e8aa1522$var$annotationMeasurerStylesDefs,
        text: $2fb96651e8aa1522$var$lineAnnotationTextOptionsDef,
        start: $2fb96651e8aa1522$var$annotationPointOptionsDef,
        end: $2fb96651e8aa1522$var$annotationPointOptionsDef
    }
}, "an annotation initial state object");
var $2fb96651e8aa1522$var$initialStateOptionsDef = {
    chartType: (0, $idDdm.union)("candlestick", "hollow-candlestick", "ohlc", "line", "step-line", "hlc", "high-low"),
    annotations: (0, $idDdm.arrayOfDefs)($2fb96651e8aa1522$var$annotationInitialStateOptionsDef),
    legend: (0, $idDdm.arrayOfDefs)({
        visible: (0, $idDdm.boolean),
        seriesId: (0, $idDdm.string),
        itemId: (0, $idDdm.string),
        legendItemName: (0, $idDdm.string)
    }, "legend state array"),
    zoom: {
        rangeX: {
            start: (0, $idDdm.or)((0, $idDdm.number), $2fb96651e8aa1522$var$serializableDate),
            end: (0, $idDdm.or)((0, $idDdm.number), $2fb96651e8aa1522$var$serializableDate)
        },
        rangeY: {
            start: (0, $idDdm.or)((0, $idDdm.number), $2fb96651e8aa1522$var$serializableDate),
            end: (0, $idDdm.or)((0, $idDdm.number), $2fb96651e8aa1522$var$serializableDate)
        },
        ratioX: {
            start: (0, $idDdm.ratio),
            end: (0, $idDdm.ratio)
        },
        ratioY: {
            start: (0, $idDdm.ratio),
            end: (0, $idDdm.ratio)
        },
        autoScaledAxes: (0, $idDdm.arrayOf)((0, $idDdm.constant)("y"))
    }
};
// packages/ag-charts-enterprise/src/series/box-plot/blotPlotUtil.ts
function $2fb96651e8aa1522$var$prepareBoxPlotFromTo(isVertical) {
    const from = isVertical ? {
        scalingX: 1,
        scalingY: 0
    } : {
        scalingX: 0,
        scalingY: 1
    };
    const to = {
        scalingX: 1,
        scalingY: 1
    };
    return {
        from: from,
        to: to
    };
}
function $2fb96651e8aa1522$var$resetBoxPlotSelectionsScalingCenterFn(isVertical) {
    return (_node, datum)=>{
        if (isVertical) return {
            scalingCenterY: datum.scaledValues.medianValue
        };
        return {
            scalingCenterX: datum.scaledValues.medianValue
        };
    };
}
var { ScalableGroup: $2fb96651e8aa1522$var$ScalableGroup, Rect: $2fb96651e8aa1522$var$Rect3, Line: $2fb96651e8aa1522$var$Line5, BBox: $2fb96651e8aa1522$var$BBox10, Selection: $2fb96651e8aa1522$var$Selection4, applyShapeFillBBox: $2fb96651e8aa1522$var$applyShapeFillBBox } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$BoxPlotGroup = class extends $2fb96651e8aa1522$var$ScalableGroup {
    constructor(){
        super();
        this.append([
            new $2fb96651e8aa1522$var$Rect3({
                tag: 0 /* Box */ 
            }),
            new $2fb96651e8aa1522$var$Rect3({
                tag: 2 /* Outline */ 
            }),
            new $2fb96651e8aa1522$var$Rect3({
                tag: 1 /* Median */ 
            }),
            new $2fb96651e8aa1522$var$Line5({
                tag: 3 /* Whisker */ 
            }),
            new $2fb96651e8aa1522$var$Line5({
                tag: 3 /* Whisker */ 
            }),
            new $2fb96651e8aa1522$var$Line5({
                tag: 4 /* Cap */ 
            }),
            new $2fb96651e8aa1522$var$Line5({
                tag: 4 /* Cap */ 
            })
        ]);
    }
    updateDatumStyles(datum, activeStyles, isVertical, isReversedValueAxis, fillBBox) {
        const { bandwidth: bandwidth, scaledValues: { xValue: axisValue, medianValue: medianValue } } = datum;
        let { minValue: minValue, q1Value: q1Value, q3Value: q3Value, maxValue: maxValue } = datum.scaledValues;
        if (isVertical && !isReversedValueAxis || !isVertical && isReversedValueAxis) [maxValue, q3Value, q1Value, minValue] = [
            minValue,
            q1Value,
            q3Value,
            maxValue
        ];
        const position = (x, y, width, height)=>isVertical ? {
                y: x,
                x: y,
                width: height,
                height: width
            } : {
                x: x,
                y: y,
                width: width,
                height: height
            };
        const hPosition = (x1, x2, y)=>isVertical ? {
                y1: x1,
                y2: x2,
                x: y
            } : {
                x1: x1,
                x2: x2,
                y: y
            };
        const vPosition = (x, y1, y2)=>isVertical ? {
                x1: y1,
                x2: y2,
                y: x
            } : {
                x: x,
                y1: y1,
                y2: y2
            };
        const bbox = (x, y, width, height)=>{
            ({ x: x, y: y, width: width, height: height } = position(x, y, width, height));
            return new $2fb96651e8aa1522$var$BBox10(x, y, width, height);
        };
        const { fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, cornerRadius: cornerRadius, cap: cap, whisker: whiskerStyles } = activeStyles;
        const selection = $2fb96651e8aa1522$var$Selection4.select(this, $2fb96651e8aa1522$var$Rect3);
        const [box] = selection.selectByTag(0 /* Box */ );
        const [outline] = selection.selectByTag(2 /* Outline */ );
        const [median] = selection.selectByTag(1 /* Median */ );
        const whiskers = selection.selectByTag(3 /* Whisker */ );
        const caps = selection.selectByTag(4 /* Cap */ );
        if (whiskerStyles.strokeWidth > bandwidth) whiskerStyles.strokeWidth = bandwidth;
        const boxesPosition = position(q1Value, axisValue, q3Value - q1Value, bandwidth);
        outline.setProperties(boxesPosition);
        box.setProperties(boxesPosition);
        box.setProperties({
            cornerRadius: cornerRadius
        });
        const medianStart = Math.max(Math.round(medianValue - strokeWidth / 2), q1Value + strokeWidth);
        const medianEnd = Math.min(Math.round(medianValue + strokeWidth / 2), q3Value - strokeWidth);
        median.setProperties(boxesPosition);
        median.setProperties({
            visible: medianStart < medianEnd,
            cornerRadius: cornerRadius,
            clipBBox: bbox(medianStart, axisValue + strokeWidth, medianEnd - medianStart, Math.max(0, bandwidth - strokeWidth * 2))
        });
        const capStart = Math.floor(axisValue + bandwidth * (1 - cap.lengthRatio) / 2);
        const capEnd = Math.ceil(axisValue + bandwidth * (1 + cap.lengthRatio) / 2);
        caps[0].setProperties(vPosition(minValue, capStart, capEnd));
        caps[1].setProperties(vPosition(maxValue, capStart, capEnd));
        whiskers[0].setProperties(hPosition(Math.round(minValue + whiskerStyles.strokeWidth / 2), q1Value, Math.floor(axisValue + bandwidth / 2)));
        whiskers[1].setProperties(hPosition(q3Value, Math.round(maxValue - whiskerStyles.strokeWidth / 2), Math.floor(axisValue + bandwidth / 2)));
        $2fb96651e8aa1522$var$applyShapeFillBBox(box, fill, fillBBox);
        box.setProperties({
            fill: fill,
            fillOpacity: fillOpacity,
            strokeWidth: strokeWidth * 2,
            strokeOpacity: 0
        });
        median.setProperties({
            fill: stroke2,
            fillOpacity: strokeOpacity,
            strokeWidth: 0
        });
        for (const element of [
            ...whiskers,
            ...caps
        ])element.setProperties(whiskerStyles);
        outline.setProperties({
            stroke: stroke2,
            strokeWidth: strokeWidth,
            strokeOpacity: strokeOpacity,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            cornerRadius: cornerRadius,
            fillOpacity: 0
        });
    }
    distanceSquared(x, y) {
        const nodes = $2fb96651e8aa1522$var$Selection4.selectByClass(this, $2fb96651e8aa1522$var$Rect3, $2fb96651e8aa1522$var$Line5);
        return (0, $iTJTu._ModuleSupport).nearestSquared(x, y, nodes).distanceSquared;
    }
    get midPoint() {
        const datum = this.datum;
        if (datum.midPoint === void 0) {
            (0, $idDdm.Logger).error("BoxPlotGroup.datum.midPoint is undefined");
            return {
                x: NaN,
                y: NaN
            };
        }
        return datum.midPoint;
    }
};
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties19, FillGradientDefaults: $2fb96651e8aa1522$var$FillGradientDefaults, FillPatternDefaults: $2fb96651e8aa1522$var$FillPatternDefaults, FillImageDefaults: $2fb96651e8aa1522$var$FillImageDefaults, AbstractBarSeriesProperties: $2fb96651e8aa1522$var$AbstractBarSeriesProperties, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip, Property: $2fb96651e8aa1522$var$Property57, mergeDefaults: $2fb96651e8aa1522$var$mergeDefaults3 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$BoxPlotSeriesCap = class extends $2fb96651e8aa1522$var$BaseProperties19 {
    constructor(){
        super(...arguments);
        this.lengthRatio = 0.5;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesCap.prototype, "lengthRatio", 2);
var $2fb96651e8aa1522$var$BoxPlotSeriesWhisker = class extends $2fb96651e8aa1522$var$BaseProperties19 {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesWhisker.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesWhisker.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesWhisker.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesWhisker.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesWhisker.prototype, "lineDashOffset", 2);
var $2fb96651e8aa1522$var$BoxPlotSeriesProperties = class extends $2fb96651e8aa1522$var$AbstractBarSeriesProperties {
    constructor(){
        super(...arguments);
        this.fill = "#c16068";
        this.fillGradientDefaults = new $2fb96651e8aa1522$var$FillGradientDefaults();
        this.fillPatternDefaults = new $2fb96651e8aa1522$var$FillPatternDefaults();
        this.fillImageDefaults = new $2fb96651e8aa1522$var$FillImageDefaults();
        this.fillOpacity = 1;
        this.stroke = "#333";
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.cornerRadius = 0;
        this.cap = new $2fb96651e8aa1522$var$BoxPlotSeriesCap();
        this.whisker = new $2fb96651e8aa1522$var$BoxPlotSeriesWhisker();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip();
    }
    toJson() {
        const { stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = this;
        const properties = super.toJson();
        properties.whisker = $2fb96651e8aa1522$var$mergeDefaults3(properties.whisker, {
            stroke: stroke2,
            strokeWidth: strokeWidth,
            strokeOpacity: strokeOpacity,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset
        });
        return properties;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "xKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "minKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "q1Key", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "medianKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "q3Key", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "maxKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "xName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "yName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "minName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "q1Name", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "medianName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "q3Name", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "maxName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "fillGradientDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "fillPatternDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "fillImageDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "cornerRadius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "itemStyler", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "cap", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "whisker", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property57
], $2fb96651e8aa1522$var$BoxPlotSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-enterprise/src/series/box-plot/boxPlotSeries.ts
var { extractDecoratedProperties: $2fb96651e8aa1522$var$extractDecoratedProperties, fixNumericExtent: $2fb96651e8aa1522$var$fixNumericExtent2, keyProperty: $2fb96651e8aa1522$var$keyProperty2, mergeDefaults: $2fb96651e8aa1522$var$mergeDefaults4, SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode, SMALLEST_KEY_INTERVAL: $2fb96651e8aa1522$var$SMALLEST_KEY_INTERVAL, valueProperty: $2fb96651e8aa1522$var$valueProperty4, diff: $2fb96651e8aa1522$var$diff, animationValidation: $2fb96651e8aa1522$var$animationValidation, computeBarFocusBounds: $2fb96651e8aa1522$var$computeBarFocusBounds, createDatumId: $2fb96651e8aa1522$var$createDatumId, ContinuousScale: $2fb96651e8aa1522$var$ContinuousScale5, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection18, motion: $2fb96651e8aa1522$var$motion, isGradientFill: $2fb96651e8aa1522$var$isGradientFill, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$BoxPlotSeriesNodeEvent = class extends (0, $iTJTu._ModuleSupport).SeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.xKey = series.properties.xKey;
        this.minKey = series.properties.minKey;
        this.q1Key = series.properties.q1Key;
        this.medianKey = series.properties.medianKey;
        this.q3Key = series.properties.q3Key;
        this.maxKey = series.properties.maxKey;
    }
};
var $2fb96651e8aa1522$var$BoxPlotSeries = class extends (0, $iTJTu._ModuleSupport).AbstractBarSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode.NEAREST_NODE,
                $2fb96651e8aa1522$var$SeriesNodePickMode.EXACT_SHAPE_MATCH
            ],
            directionKeys: {
                x: [
                    "xKey"
                ],
                y: [
                    "medianKey",
                    "q1Key",
                    "q3Key",
                    "minKey",
                    "maxKey"
                ]
            },
            directionNames: {
                x: [
                    "xName"
                ],
                y: [
                    "medianName",
                    "q1Name",
                    "q3Name",
                    "minName",
                    "maxName"
                ]
            },
            categoryKey: "xValue",
            pathsPerSeries: [],
            hasHighlightedLabels: true
        });
        this.properties = new $2fb96651e8aa1522$var$BoxPlotSeriesProperties();
        this.NodeEvent = $2fb96651e8aa1522$var$BoxPlotSeriesNodeEvent;
    }
    async processData(dataController) {
        if (!this.visible) return;
        const { xKey: xKey, minKey: minKey, q1Key: q1Key, medianKey: medianKey, q3Key: q3Key, maxKey: maxKey } = this.properties;
        const animationEnabled = !this.ctx.animationManager.isSkipped();
        const xScale = this.getCategoryAxis()?.scale;
        const yScale = this.getValueAxis()?.scale;
        const { isContinuousX: isContinuousX, xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
            xScale: xScale,
            yScale: yScale
        });
        const extraProps = [];
        if (animationEnabled && this.processedData) extraProps.push($2fb96651e8aa1522$var$diff(this.id, this.processedData));
        if (animationEnabled) extraProps.push($2fb96651e8aa1522$var$animationValidation());
        const { processedData: processedData } = await this.requestDataModel(dataController, this.data, {
            props: [
                $2fb96651e8aa1522$var$keyProperty2(xKey, xScaleType, {
                    id: `xValue`
                }),
                $2fb96651e8aa1522$var$valueProperty4(minKey, yScaleType, {
                    id: `minValue`
                }),
                $2fb96651e8aa1522$var$valueProperty4(q1Key, yScaleType, {
                    id: `q1Value`
                }),
                $2fb96651e8aa1522$var$valueProperty4(medianKey, yScaleType, {
                    id: `medianValue`
                }),
                $2fb96651e8aa1522$var$valueProperty4(q3Key, yScaleType, {
                    id: `q3Value`
                }),
                $2fb96651e8aa1522$var$valueProperty4(maxKey, yScaleType, {
                    id: `maxValue`
                }),
                ...isContinuousX ? [
                    $2fb96651e8aa1522$var$SMALLEST_KEY_INTERVAL
                ] : [],
                ...extraProps
            ]
        });
        this.smallestDataInterval = processedData.reduced?.smallestKeyInterval;
        this.animationState.transition("updateData");
    }
    getSeriesDomain(direction) {
        const { processedData: processedData, dataModel: dataModel } = this;
        if (!(processedData && dataModel)) return [];
        if (direction !== this.getBarDirection()) {
            const { index: index, def: def } = dataModel.resolveProcessedDataDefById(this, `xValue`);
            const keys = processedData.domain.keys[index];
            if (def.type === "key" && def.valueType === "category") return keys;
            return this.padBandExtent(keys);
        }
        const yExtent = this.domainForClippedRange(direction, [
            "minValue",
            "maxValue"
        ], "xValue", true);
        return $2fb96651e8aa1522$var$fixNumericExtent2(yExtent);
    }
    getSeriesRange(_direction, visibleRange) {
        return this.domainForVisibleRange($2fb96651e8aa1522$var$ChartAxisDirection18.Y, [
            "maxValue",
            "minValue"
        ], "xValue", visibleRange, true);
    }
    createNodeData() {
        const { visible: visible, dataModel: dataModel, processedData: processedData } = this;
        const xAxis = this.getCategoryAxis();
        const yAxis = this.getValueAxis();
        if (!(dataModel && processedData && xAxis && yAxis)) return;
        const { xKey: xKey, fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, cap: cap, whisker: whisker } = this.properties;
        const nodeData = [];
        const xValues = dataModel.resolveKeysById(this, "xValue", processedData);
        const minValues = dataModel.resolveColumnById(this, "minValue", processedData);
        const q1Values = dataModel.resolveColumnById(this, "q1Value", processedData);
        const medianValues = dataModel.resolveColumnById(this, "medianValue", processedData);
        const q3Values = dataModel.resolveColumnById(this, "q3Value", processedData);
        const maxValues = dataModel.resolveColumnById(this, "maxValue", processedData);
        const { barWidth: barWidth, groupIndex: groupIndex } = this.updateGroupScale(xAxis);
        const barOffset = $2fb96651e8aa1522$var$ContinuousScale5.is(xAxis.scale) ? barWidth * -0.5 : 0;
        const { groupScale: groupScale } = this;
        const isVertical = this.isVertical();
        const context = {
            itemId: xKey,
            nodeData: nodeData,
            labelData: [],
            scales: this.calculateScaling(),
            groupScale: this.getScaling(this.groupScale),
            visible: this.visible
        };
        if (!visible) return context;
        const rawData = processedData.dataSources.get(this.id) ?? [];
        rawData.forEach((datum, datumIndex)=>{
            const xValue2 = xValues[datumIndex];
            if (xValue2 == null) return;
            const minValue = minValues[datumIndex];
            const q1Value = q1Values[datumIndex];
            const medianValue = medianValues[datumIndex];
            const q3Value = q3Values[datumIndex];
            const maxValue = maxValues[datumIndex];
            if ([
                minValue,
                q1Value,
                medianValue,
                q3Value,
                maxValue
            ].some((value)=>typeof value !== "number") || minValue > q1Value || q1Value > medianValue || medianValue > q3Value || q3Value > maxValue) return;
            const scaledValues = {
                xValue: Math.round(xAxis.scale.convert(xValue2)),
                minValue: Math.round(yAxis.scale.convert(minValue)),
                q1Value: Math.round(yAxis.scale.convert(q1Value)),
                medianValue: Math.round(yAxis.scale.convert(medianValue)),
                q3Value: Math.round(yAxis.scale.convert(q3Value)),
                maxValue: Math.round(yAxis.scale.convert(maxValue))
            };
            scaledValues.xValue += Math.round(groupScale.convert(String(groupIndex))) + barOffset;
            const bandwidth = Math.round(barWidth);
            const height = Math.abs(scaledValues.q3Value - scaledValues.q1Value);
            const midX = scaledValues.xValue + bandwidth / 2;
            const midY = Math.min(scaledValues.q3Value, scaledValues.q1Value) + height / 2;
            const midPoint = {
                x: isVertical ? midX : midY,
                y: isVertical ? midY : midX
            };
            let focusRect;
            if (isVertical) focusRect = {
                x: midPoint.x - bandwidth / 2,
                y: scaledValues.minValue,
                width: bandwidth,
                height: scaledValues.maxValue - scaledValues.minValue
            };
            else focusRect = {
                x: scaledValues.minValue,
                y: midPoint.y - bandwidth / 2,
                width: scaledValues.maxValue - scaledValues.minValue,
                height: bandwidth
            };
            nodeData.push({
                series: this,
                itemId: xValue2,
                datum: datum,
                datumIndex: datumIndex,
                xKey: xKey,
                bandwidth: bandwidth,
                scaledValues: scaledValues,
                cap: cap,
                whisker: whisker,
                fill: fill,
                fillOpacity: fillOpacity,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                strokeOpacity: strokeOpacity,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset,
                midPoint: midPoint,
                focusRect: focusRect
            });
        });
        return context;
    }
    legendItemSymbol() {
        const { fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, fillGradientDefaults: fillGradientDefaults4, fillPatternDefaults: fillPatternDefaults4, fillImageDefaults: fillImageDefaults4 } = this.properties;
        return {
            marker: $2fb96651e8aa1522$var$getShapeStyle({
                fill: fill,
                fillOpacity: fillOpacity,
                stroke: stroke2,
                strokeOpacity: strokeOpacity,
                strokeWidth: strokeWidth,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset
            }, fillGradientDefaults4, fillPatternDefaults4, fillImageDefaults4)
        };
    }
    getLegendData(legendType) {
        const { id: seriesId, ctx: { legendManager: legendManager }, visible: visible } = this;
        const { xKey: xKey, yName: yName, showInLegend: showInLegend, legendItemName: legendItemName } = this.properties;
        if (!xKey || legendType !== "category") return [];
        return [
            {
                legendType: "category",
                id: seriesId,
                itemId: seriesId,
                seriesId: seriesId,
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: seriesId,
                    itemId: seriesId
                }),
                label: {
                    text: legendItemName ?? yName ?? seriesId
                },
                symbol: this.legendItemSymbol(),
                legendItemName: legendItemName,
                hideInLegend: !showInLegend
            }
        ];
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, properties: properties } = this;
        const { xKey: xKey, xName: xName, yName: yName, medianKey: medianKey, medianName: medianName, q1Key: q1Key, q1Name: q1Name, q3Key: q3Key, q3Name: q3Name, minKey: minKey, minName: minName, maxKey: maxKey, maxName: maxName, legendItemName: legendItemName, tooltip: tooltip } = properties;
        const xAxis = this.getCategoryAxis();
        const yAxis = this.getValueAxis();
        if (!dataModel || !processedData || !xAxis || !yAxis) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const xValue2 = dataModel.resolveKeysById(this, `xValue`, processedData)[datumIndex];
        const minValue = dataModel.resolveColumnById(this, `minValue`, processedData)[datumIndex];
        const q1Value = dataModel.resolveColumnById(this, `q1Value`, processedData)[datumIndex];
        const medianValue = dataModel.resolveColumnById(this, `medianValue`, processedData)[datumIndex];
        const q3Value = dataModel.resolveColumnById(this, `q3Value`, processedData)[datumIndex];
        const maxValue = dataModel.resolveColumnById(this, `maxValue`, processedData)[datumIndex];
        if (xValue2 == null) return;
        const format = this.getItemBaseStyle(false);
        Object.assign(format, this.getItemStyleOverrides(String(datumIndex), datum, format, false));
        return this.formatTooltipWithContext(tooltip, {
            heading: xAxis.formatDatum(xValue2),
            title: legendItemName ?? yName,
            symbol: this.legendItemSymbol(),
            data: [
                {
                    label: minName,
                    fallbackLabel: minKey,
                    value: yAxis.formatDatum(minValue)
                },
                {
                    label: q1Name,
                    fallbackLabel: q1Key,
                    value: yAxis.formatDatum(q1Value)
                },
                {
                    label: medianName,
                    fallbackLabel: medianKey,
                    value: yAxis.formatDatum(medianValue)
                },
                {
                    label: q3Name,
                    fallbackLabel: q3Key,
                    value: yAxis.formatDatum(q3Value)
                },
                {
                    label: maxName,
                    fallbackLabel: maxKey,
                    value: yAxis.formatDatum(maxValue)
                }
            ]
        }, {
            seriesId: seriesId,
            datum: datum,
            title: yName,
            xKey: xKey,
            xName: xName,
            yName: yName,
            medianKey: medianKey,
            medianName: medianName,
            q1Key: q1Key,
            q1Name: q1Name,
            q3Key: q3Key,
            q3Name: q3Name,
            minKey: minKey,
            minName: minName,
            maxKey: maxKey,
            maxName: maxName,
            ...format
        });
    }
    animateEmptyUpdateReady({ datumSelection: datumSelection }) {
        const isVertical = this.isVertical();
        const { from: from, to: to } = $2fb96651e8aa1522$var$prepareBoxPlotFromTo(isVertical);
        $2fb96651e8aa1522$var$motion.resetMotion([
            datumSelection
        ], $2fb96651e8aa1522$var$resetBoxPlotSelectionsScalingCenterFn(isVertical));
        $2fb96651e8aa1522$var$motion.staticFromToMotion(this.id, "datums", this.ctx.animationManager, [
            datumSelection
        ], from, to, {
            phase: "initial"
        });
    }
    isLabelEnabled() {
        return false;
    }
    updateDatumSelection(opts) {
        const data = opts.nodeData ?? [];
        return opts.datumSelection.update(data);
    }
    getItemBaseStyle(highlighted) {
        const { properties: properties } = this;
        const { cornerRadius: cornerRadius, cap: cap, whisker: whisker, fillGradientDefaults: fillGradientDefaults4, fillPatternDefaults: fillPatternDefaults4, fillImageDefaults: fillImageDefaults4 } = properties;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        const strokeWidth = this.getStrokeWidth(properties.strokeWidth);
        return $2fb96651e8aa1522$var$getShapeStyle({
            fill: highlightStyle?.fill ?? properties.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? properties.fillOpacity,
            stroke: highlightStyle?.stroke ?? properties.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? strokeWidth,
            strokeOpacity: highlightStyle?.strokeOpacity ?? properties.strokeOpacity,
            lineDash: highlightStyle?.lineDash ?? properties.lineDash ?? [],
            lineDashOffset: highlightStyle?.lineDashOffset ?? properties.lineDashOffset,
            cornerRadius: cornerRadius,
            cap: cap,
            whisker: whisker
        }, fillGradientDefaults4, fillPatternDefaults4, fillImageDefaults4);
    }
    getItemStyleOverrides(datumId, datum, format, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const { xKey: xKey, minKey: minKey, q1Key: q1Key, medianKey: medianKey, q3Key: q3Key, maxKey: maxKey, fillGradientDefaults: fillGradientDefaults4, fillPatternDefaults: fillPatternDefaults4, fillImageDefaults: fillImageDefaults4, itemStyler: itemStyler } = properties;
        if (itemStyler == null) return;
        const overrides = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId(datumId, highlighted ? "highlight" : "node"), ()=>{
            return this.callWithContext(itemStyler, {
                seriesId: seriesId,
                datum: datum,
                xKey: xKey,
                minKey: minKey,
                q1Key: q1Key,
                medianKey: medianKey,
                q3Key: q3Key,
                maxKey: maxKey,
                highlighted: highlighted,
                ...format
            });
        });
        return $2fb96651e8aa1522$var$getShapeStyle(overrides, fillGradientDefaults4, fillPatternDefaults4, fillImageDefaults4);
    }
    updateDatumNodes({ datumSelection: datumSelection, isHighlight: highlighted }) {
        const isVertical = this.isVertical();
        const isReversedValueAxis = this.getValueAxis()?.isReversed();
        const { highlightStyle: highlightStyle } = this.properties;
        datumSelection.each((boxPlotGroup, nodeDatum)=>{
            let activeStyles = this.getFormattedStyles(nodeDatum, highlighted ? "highlight" : "node");
            if (highlighted) activeStyles = $2fb96651e8aa1522$var$mergeDefaults4(highlightStyle.item, activeStyles);
            const { stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = activeStyles;
            activeStyles.whisker = $2fb96651e8aa1522$var$mergeDefaults4(activeStyles.whisker, {
                stroke: stroke2,
                strokeWidth: strokeWidth,
                strokeOpacity: strokeOpacity,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset
            });
            const fillBBox = this.getShapeFillBBox();
            boxPlotGroup.updateDatumStyles(nodeDatum, activeStyles, isVertical, isReversedValueAxis, fillBBox);
        });
    }
    updateLabelNodes() {}
    updateLabelSelection(opts) {
        const { labelData: labelData, labelSelection: labelSelection } = opts;
        return labelSelection.update(labelData);
    }
    nodeFactory() {
        return new $2fb96651e8aa1522$var$BoxPlotGroup();
    }
    getFormattedStyles(nodeDatum, scope) {
        const { id: seriesId, properties: properties } = this;
        const { xKey: xKey, minKey: minKey, q1Key: q1Key, medianKey: medianKey, q3Key: q3Key, maxKey: maxKey, itemStyler: itemStyler, cornerRadius: cornerRadius, fillGradientDefaults: fillGradientDefaults4, fillPatternDefaults: fillPatternDefaults4, fillImageDefaults: fillImageDefaults4 } = properties;
        const { datum: datum, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, cap: cap, whisker: whisker } = nodeDatum;
        let fill;
        let fillOpacity = 1;
        if ($2fb96651e8aa1522$var$isGradientFill(nodeDatum.fill)) fill = nodeDatum.fill;
        else {
            fill = nodeDatum.fill;
            fillOpacity = properties.fillOpacity;
        }
        let styles = $2fb96651e8aa1522$var$getShapeStyle({
            fill: fill,
            fillOpacity: fillOpacity,
            stroke: stroke2,
            strokeWidth: strokeWidth,
            strokeOpacity: strokeOpacity,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            cornerRadius: cornerRadius,
            cap: $2fb96651e8aa1522$var$extractDecoratedProperties(cap),
            whisker: $2fb96651e8aa1522$var$extractDecoratedProperties(whisker)
        }, fillGradientDefaults4, fillPatternDefaults4, fillImageDefaults4);
        if (itemStyler) {
            const formatStyles = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId(datum.index, scope), ()=>this.callWithContext(itemStyler, {
                    datum: datum,
                    seriesId: seriesId,
                    highlighted: scope === "highlight",
                    ...styles,
                    xKey: xKey,
                    minKey: minKey,
                    q1Key: q1Key,
                    medianKey: medianKey,
                    q3Key: q3Key,
                    maxKey: maxKey
                }));
            if (formatStyles) styles = $2fb96651e8aa1522$var$getShapeStyle($2fb96651e8aa1522$var$mergeDefaults4(formatStyles, styles), fillGradientDefaults4, fillPatternDefaults4, fillImageDefaults4);
        }
        return styles;
    }
    computeFocusBounds({ datumIndex: datumIndex }) {
        return $2fb96651e8aa1522$var$computeBarFocusBounds(this, this.contextNodeData?.nodeData[datumIndex].focusRect);
    }
};
$2fb96651e8aa1522$var$BoxPlotSeries.className = "BoxPlotSeries";
$2fb96651e8aa1522$var$BoxPlotSeries.type = "box-plot";
var { boxPlotSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$boxPlotSeriesThemeableOptionsDef, commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$boxPlotSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$boxPlotSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs,
    type: (0, $idDdm.required)((0, $idDdm.constant)("box-plot")),
    xKey: (0, $idDdm.required)((0, $idDdm.string)),
    minKey: (0, $idDdm.required)((0, $idDdm.string)),
    q1Key: (0, $idDdm.required)((0, $idDdm.string)),
    medianKey: (0, $idDdm.required)((0, $idDdm.string)),
    q3Key: (0, $idDdm.required)((0, $idDdm.string)),
    maxKey: (0, $idDdm.required)((0, $idDdm.string)),
    xName: (0, $idDdm.string),
    yName: (0, $idDdm.string),
    minName: (0, $idDdm.string),
    q1Name: (0, $idDdm.string),
    medianName: (0, $idDdm.string),
    q3Name: (0, $idDdm.string),
    maxName: (0, $idDdm.string),
    grouped: (0, $idDdm.boolean),
    legendItemName: (0, $idDdm.string)
};
var { CARTESIAN_AXIS_TYPE: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE } = (0, $iTJTu._ModuleSupport).ThemeConstants;
var $2fb96651e8aa1522$var$BOX_PLOT_SERIES_THEME = {
    series: {
        direction: "vertical",
        fill: {
            $if: [
                {
                    $or: [
                        {
                            $isGradient: [
                                {
                                    $palette: "fill"
                                }
                            ]
                        },
                        {
                            $isPattern: [
                                {
                                    $palette: "fill"
                                }
                            ]
                        },
                        {
                            $isImage: [
                                {
                                    $palette: "fill"
                                }
                            ]
                        }
                    ]
                },
                {
                    $palette: "fill"
                },
                {
                    $mix: [
                        (0, $iTJTu._ModuleSupport).SAFE_FILL_OPERATION,
                        {
                            $ref: "backgroundColor"
                        },
                        0.7
                    ]
                }
            ]
        },
        stroke: {
            $palette: "stroke"
        },
        // @ts-expect-error undocumented option
        fillGradientDefaults: {
            type: "gradient",
            gradient: "linear",
            bounds: "item",
            colorStops: {
                $palette: "gradient"
            },
            rotation: 0,
            reverse: false
        },
        fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
        fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
        strokeWidth: 2
    },
    axes: {
        [$2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE.NUMBER]: {
            crosshair: {
                snap: false
            }
        },
        [$2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE.CATEGORY]: {
            groupPaddingInner: 0.2,
            crosshair: {
                enabled: false,
                snap: false
            }
        }
    }
};
// packages/ag-charts-enterprise/src/series/box-plot/boxPlotModule.ts
var $2fb96651e8aa1522$var$BoxPlotModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    identifier: "box-plot",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$BoxPlotSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    defaultAxes: (0, $iTJTu._ModuleSupport).DIRECTION_SWAP_AXES,
    themeTemplate: $2fb96651e8aa1522$var$BOX_PLOT_SERIES_THEME,
    groupable: true
};
var $2fb96651e8aa1522$var$BoxPlotSeriesModule = {
    type: "series",
    name: "box-plot",
    chartType: "cartesian",
    enterprise: true,
    options: $2fb96651e8aa1522$var$boxPlotSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$BoxPlotSeries(ctx)
};
var { findMinMax: $2fb96651e8aa1522$var$findMinMax3 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$X_MIN = 0;
var $2fb96651e8aa1522$var$X_MAX = 1;
var $2fb96651e8aa1522$var$Y_MIN = 2;
var $2fb96651e8aa1522$var$Y_MAX = 3;
var $2fb96651e8aa1522$var$SPAN = 4;
function $2fb96651e8aa1522$var$maxRangeFittingPoints(data, precision = 1) {
    let power = Math.ceil(Math.log2(data.length / precision)) - 1;
    power = Math.min(Math.max(power, 0), 16);
    return 2 ** power | 0;
}
function $2fb96651e8aa1522$var$aggregationDomain(domain) {
    return $2fb96651e8aa1522$var$findMinMax3(domain.map((x)=>Number(x)));
}
function $2fb96651e8aa1522$var$xRatioForDatumIndex(xValue2, d0, d1) {
    return (xValue2.valueOf() - d0) / (d1 - d0);
}
function $2fb96651e8aa1522$var$aggregationIndexForXRatio(xRatio, maxRange) {
    return Math.min(Math.floor(xRatio * maxRange), maxRange - 1) * $2fb96651e8aa1522$var$SPAN | 0;
}
function $2fb96651e8aa1522$var$createAggregationIndices(xValues, yMaxValues, yMinValues, d0, d1, maxRange) {
    const indexData = new Int32Array(maxRange * $2fb96651e8aa1522$var$SPAN).fill(-1);
    const valueData = new Float64Array(maxRange * $2fb96651e8aa1522$var$SPAN).fill(NaN);
    for(let datumIndex = 0; datumIndex < xValues.length; datumIndex += 1){
        const xValue2 = xValues[datumIndex];
        const yMaxValue = yMaxValues[datumIndex];
        const yMinValue = yMinValues[datumIndex];
        if (xValue2 == null || yMaxValue == null || yMinValue == null) continue;
        const xRatio = $2fb96651e8aa1522$var$xRatioForDatumIndex(xValue2, d0, d1);
        const yMax = yMaxValue.valueOf();
        const yMin = yMinValue.valueOf();
        const aggIndex = $2fb96651e8aa1522$var$aggregationIndexForXRatio(xRatio, maxRange);
        const unset = indexData[aggIndex + $2fb96651e8aa1522$var$X_MIN] === -1;
        if (unset || xRatio < valueData[aggIndex + $2fb96651e8aa1522$var$X_MIN]) {
            indexData[aggIndex + $2fb96651e8aa1522$var$X_MIN] = datumIndex;
            valueData[aggIndex + $2fb96651e8aa1522$var$X_MIN] = xRatio;
        }
        if (unset || xRatio > valueData[aggIndex + $2fb96651e8aa1522$var$X_MAX]) {
            indexData[aggIndex + $2fb96651e8aa1522$var$X_MAX] = datumIndex;
            valueData[aggIndex + $2fb96651e8aa1522$var$X_MAX] = xRatio;
        }
        if (unset || yMin < valueData[aggIndex + $2fb96651e8aa1522$var$Y_MIN]) {
            indexData[aggIndex + $2fb96651e8aa1522$var$Y_MIN] = datumIndex;
            valueData[aggIndex + $2fb96651e8aa1522$var$Y_MIN] = yMin;
        }
        if (unset || yMax > valueData[aggIndex + $2fb96651e8aa1522$var$Y_MAX]) {
            indexData[aggIndex + $2fb96651e8aa1522$var$Y_MAX] = datumIndex;
            valueData[aggIndex + $2fb96651e8aa1522$var$Y_MAX] = yMax;
        }
    }
    return {
        indexData: indexData,
        valueData: valueData
    };
}
function $2fb96651e8aa1522$var$compactAggregationIndices(indexData, valueData, maxRange, { inPlace: inPlace = false } = {}) {
    const nextMaxRange = maxRange / 2 | 0;
    const nextIndexData = !inPlace ? new Int32Array(nextMaxRange * $2fb96651e8aa1522$var$SPAN) : indexData;
    const nextValueData = !inPlace ? new Float64Array(nextMaxRange * $2fb96651e8aa1522$var$SPAN) : valueData;
    for(let i = 0; i < nextMaxRange; i += 1){
        const aggIndex = i * $2fb96651e8aa1522$var$SPAN | 0;
        const index0 = aggIndex * 2 | 0;
        const index1 = index0 + $2fb96651e8aa1522$var$SPAN | 0;
        const index1Unset = indexData[index1 + $2fb96651e8aa1522$var$X_MIN] === -1;
        const xMinAggIndex = index1Unset || valueData[index0 + $2fb96651e8aa1522$var$X_MIN] < valueData[index1 + $2fb96651e8aa1522$var$X_MIN] ? index0 : index1;
        nextIndexData[aggIndex + $2fb96651e8aa1522$var$X_MIN] = indexData[xMinAggIndex + $2fb96651e8aa1522$var$X_MIN];
        nextValueData[aggIndex + $2fb96651e8aa1522$var$X_MIN] = valueData[xMinAggIndex + $2fb96651e8aa1522$var$X_MIN];
        const xMaxAggIndex = index1Unset || valueData[index0 + $2fb96651e8aa1522$var$X_MAX] > valueData[index1 + $2fb96651e8aa1522$var$X_MAX] ? index0 : index1;
        nextIndexData[aggIndex + $2fb96651e8aa1522$var$X_MAX] = indexData[xMaxAggIndex + $2fb96651e8aa1522$var$X_MAX];
        nextValueData[aggIndex + $2fb96651e8aa1522$var$X_MAX] = valueData[xMaxAggIndex + $2fb96651e8aa1522$var$X_MAX];
        const yMinAggIndex = index1Unset || valueData[index0 + $2fb96651e8aa1522$var$Y_MIN] < valueData[index1 + $2fb96651e8aa1522$var$Y_MIN] ? index0 : index1;
        nextIndexData[aggIndex + $2fb96651e8aa1522$var$Y_MIN] = indexData[yMinAggIndex + $2fb96651e8aa1522$var$Y_MIN];
        nextValueData[aggIndex + $2fb96651e8aa1522$var$Y_MIN] = valueData[yMinAggIndex + $2fb96651e8aa1522$var$Y_MIN];
        const yMaxAggIndex = index1Unset || valueData[index0 + $2fb96651e8aa1522$var$Y_MAX] > valueData[index1 + $2fb96651e8aa1522$var$Y_MAX] ? index0 : index1;
        nextIndexData[aggIndex + $2fb96651e8aa1522$var$Y_MAX] = indexData[yMaxAggIndex + $2fb96651e8aa1522$var$Y_MAX];
        nextValueData[aggIndex + $2fb96651e8aa1522$var$Y_MAX] = valueData[yMaxAggIndex + $2fb96651e8aa1522$var$Y_MAX];
    }
    return {
        maxRange: nextMaxRange,
        indexData: nextIndexData,
        valueData: nextValueData
    };
}
// packages/ag-charts-enterprise/src/series/ohlc/ohlcAggregation.ts
var $2fb96651e8aa1522$var$AGGREGATION_THRESHOLD = 1e3;
var $2fb96651e8aa1522$var$OPEN = $2fb96651e8aa1522$var$X_MIN;
var $2fb96651e8aa1522$var$HIGH = $2fb96651e8aa1522$var$Y_MAX;
var $2fb96651e8aa1522$var$LOW = $2fb96651e8aa1522$var$Y_MIN;
var $2fb96651e8aa1522$var$CLOSE = $2fb96651e8aa1522$var$X_MAX;
function $2fb96651e8aa1522$var$aggregateOhlcData(xValues, highValues, lowValues, domain) {
    if (xValues.length < $2fb96651e8aa1522$var$AGGREGATION_THRESHOLD) return;
    const [d0, d1] = $2fb96651e8aa1522$var$aggregationDomain(domain);
    let maxRange = $2fb96651e8aa1522$var$maxRangeFittingPoints(xValues);
    let { indexData: indexData, valueData: valueData } = $2fb96651e8aa1522$var$createAggregationIndices(xValues, highValues, lowValues, d0, d1, maxRange);
    const filters = [
        {
            maxRange: maxRange,
            indexData: indexData
        }
    ];
    while(maxRange > 64){
        ({ indexData: indexData, valueData: valueData, maxRange: maxRange } = $2fb96651e8aa1522$var$compactAggregationIndices(indexData, valueData, maxRange));
        filters.push({
            maxRange: maxRange,
            indexData: indexData
        });
    }
    filters.reverse();
    return filters;
}
// packages/ag-charts-enterprise/src/series/ohlc/ohlcSeriesBase.ts
var { fixNumericExtent: $2fb96651e8aa1522$var$fixNumericExtent3, keyProperty: $2fb96651e8aa1522$var$keyProperty3, createDatumId: $2fb96651e8aa1522$var$createDatumId2, SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode2, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection19, SMALLEST_KEY_INTERVAL: $2fb96651e8aa1522$var$SMALLEST_KEY_INTERVAL2, valueProperty: $2fb96651e8aa1522$var$valueProperty5, diff: $2fb96651e8aa1522$var$diff2, animationValidation: $2fb96651e8aa1522$var$animationValidation2, computeBarFocusBounds: $2fb96651e8aa1522$var$computeBarFocusBounds2, visibleRangeIndices: $2fb96651e8aa1522$var$visibleRangeIndices, ContinuousScale: $2fb96651e8aa1522$var$ContinuousScale6, DiscreteTimeScale: $2fb96651e8aa1522$var$DiscreteTimeScale, BandScale: $2fb96651e8aa1522$var$BandScale, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$OhlcSeriesNodeEvent = class extends (0, $iTJTu._ModuleSupport).SeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.xKey = series.properties.xKey;
        this.openKey = series.properties.openKey;
        this.closeKey = series.properties.closeKey;
        this.highKey = series.properties.highKey;
        this.lowKey = series.properties.lowKey;
    }
};
var $2fb96651e8aa1522$var$OhlcSeriesBase = class extends (0, $iTJTu._ModuleSupport).AbstractBarSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode2.AXIS_ALIGNED,
                $2fb96651e8aa1522$var$SeriesNodePickMode2.EXACT_SHAPE_MATCH
            ],
            directionKeys: {
                x: [
                    "xKey"
                ],
                y: [
                    "lowKey",
                    "highKey",
                    "openKey",
                    "closeKey"
                ]
            },
            directionNames: {
                x: [
                    "xName"
                ],
                y: [
                    "lowName",
                    "highName",
                    "openName",
                    "closeName"
                ]
            },
            categoryKey: "xValue",
            pathsPerSeries: []
        });
        this.NodeEvent = $2fb96651e8aa1522$var$OhlcSeriesNodeEvent;
        this.dataAggregationFilters = void 0;
    }
    async processData(dataController) {
        if (!this.visible) return;
        const { xKey: xKey, openKey: openKey, closeKey: closeKey, highKey: highKey, lowKey: lowKey } = this.properties;
        const animationEnabled = !this.ctx.animationManager.isSkipped();
        const xScale = this.getCategoryAxis()?.scale;
        const yScale = this.getValueAxis()?.scale;
        const { isContinuousX: isContinuousX, xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
            xScale: xScale,
            yScale: yScale
        });
        const extraProps = [];
        if (animationEnabled) {
            if (this.processedData) extraProps.push($2fb96651e8aa1522$var$diff2(this.id, this.processedData));
            extraProps.push($2fb96651e8aa1522$var$animationValidation2());
        }
        if (openKey) extraProps.push($2fb96651e8aa1522$var$valueProperty5(openKey, yScaleType, {
            id: `openValue`,
            invalidValue: void 0,
            missingValue: void 0
        }));
        const { dataModel: dataModel, processedData: processedData } = await this.requestDataModel(dataController, this.data, {
            props: [
                $2fb96651e8aa1522$var$keyProperty3(xKey, xScaleType, {
                    id: `xValue`
                }),
                $2fb96651e8aa1522$var$valueProperty5(closeKey, yScaleType, {
                    id: `closeValue`
                }),
                $2fb96651e8aa1522$var$valueProperty5(highKey, yScaleType, {
                    id: `highValue`
                }),
                $2fb96651e8aa1522$var$valueProperty5(lowKey, yScaleType, {
                    id: `lowValue`
                }),
                ...isContinuousX ? [
                    $2fb96651e8aa1522$var$SMALLEST_KEY_INTERVAL2
                ] : [],
                ...extraProps
            ]
        });
        this.smallestDataInterval = processedData.reduced?.smallestKeyInterval;
        this.dataAggregationFilters = this.aggregateData(dataModel, processedData);
        this.animationState.transition("updateData");
    }
    aggregateData(dataModel, processedData) {
        const xAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection19.X];
        if (xAxis == null || !($2fb96651e8aa1522$var$ContinuousScale6.is(xAxis.scale) || $2fb96651e8aa1522$var$DiscreteTimeScale.is(xAxis.scale))) return;
        const xValues = dataModel.resolveKeysById(this, `xValue`, processedData);
        const highValues = dataModel.resolveColumnById(this, `highValue`, processedData);
        const lowValues = dataModel.resolveColumnById(this, `lowValue`, processedData);
        const { index: index } = dataModel.resolveProcessedDataDefById(this, `xValue`);
        const domain = processedData.domain.keys[index];
        return $2fb96651e8aa1522$var$aggregateOhlcData(xValues, highValues, lowValues, domain);
    }
    getSeriesDomain(direction) {
        const { processedData: processedData, dataModel: dataModel } = this;
        if (!(processedData && dataModel)) return [];
        if (direction !== this.getBarDirection()) {
            const { index: index, def: def } = dataModel.resolveProcessedDataDefById(this, `xValue`);
            const keys = processedData.domain.keys[index];
            if (def.type === "key" && def.valueType === "category") return keys;
            return this.padBandExtent(keys);
        }
        const yExtent = this.domainForClippedRange(direction, [
            "highValue",
            "lowValue"
        ], "xValue", true);
        return $2fb96651e8aa1522$var$fixNumericExtent3(yExtent);
    }
    getSeriesRange(_direction, visibleRange) {
        return this.domainForVisibleRange($2fb96651e8aa1522$var$ChartAxisDirection19.Y, [
            "highValue",
            "lowValue"
        ], "xValue", visibleRange, true);
    }
    getVisibleItems(xVisibleRange, yVisibleRange, minVisibleItems) {
        return this.countVisibleItems("xValue", [
            "highValue",
            "lowValue"
        ], xVisibleRange, yVisibleRange, minVisibleItems);
    }
    createNodeData() {
        const { visible: visible, dataModel: dataModel, processedData: processedData } = this;
        const xAxis = this.getCategoryAxis();
        const yAxis = this.getValueAxis();
        if (!(dataModel && processedData && xAxis && yAxis)) return;
        const nodeData = [];
        const { xKey: xKey, highKey: highKey, lowKey: lowKey } = this.properties;
        const rawData = processedData.dataSources.get(this.id) ?? [];
        const xValues = dataModel.resolveKeysById(this, "xValue", processedData);
        const openValues = dataModel.resolveColumnById(this, "openValue", processedData);
        const closeValues = dataModel.resolveColumnById(this, "closeValue", processedData);
        const highValues = dataModel.resolveColumnById(this, "highValue", processedData);
        const lowValues = dataModel.resolveColumnById(this, "lowValue", processedData);
        const { groupScale: groupScale } = this;
        const { barWidth: barWidth, groupIndex: groupIndex } = this.updateGroupScale(xAxis);
        const groupOffset = groupScale.convert(String(groupIndex));
        const effectiveBarWidth = barWidth >= 1 ? barWidth : groupScale.rawBandwidth;
        const applyWidthOffset = $2fb96651e8aa1522$var$BandScale.is(xAxis.scale);
        const context = {
            itemId: xKey,
            nodeData: nodeData,
            labelData: [],
            scales: this.calculateScaling(),
            groupScale: this.getScaling(this.groupScale),
            visible: this.visible
        };
        if (!visible) return context;
        const handleDatum = (datumIndex, xValue2, openValue, closeValue, highValue, lowValue, width, crisp)=>{
            const datum = rawData[datumIndex];
            const xOffset = applyWidthOffset ? width / 2 : 0;
            const centerX = xAxis.scale.convert(xValue2) + groupOffset + xOffset;
            const yOpen = yAxis.scale.convert(openValue);
            const yClose = yAxis.scale.convert(closeValue);
            const yHigh = yAxis.scale.convert(highValue);
            const yLow = yAxis.scale.convert(lowValue);
            const isRising = closeValue > openValue;
            const itemId = isRising ? "up" : "down";
            const y = Math.min(yHigh, yLow);
            const height = Math.max(yHigh, yLow) - y;
            const midPoint = {
                x: centerX,
                y: y + height / 2
            };
            nodeData.push({
                series: this,
                itemId: itemId,
                datum: datum,
                datumIndex: datumIndex,
                xKey: xKey,
                xValue: xValue2,
                openValue: openValue,
                closeValue: closeValue,
                highValue: highValue,
                lowValue: lowValue,
                midPoint: midPoint,
                aggregatedValue: closeValue,
                isRising: isRising,
                centerX: centerX,
                width: width,
                y: y,
                height: height,
                yOpen: yOpen,
                yClose: yClose,
                crisp: crisp
            });
        };
        const { dataAggregationFilters: dataAggregationFilters } = this;
        const xScale = xAxis.scale;
        const [r0, r1] = xScale.range;
        const range2 = r1 - r0;
        const xPosition = (index)=>xScale.convert(xValues[index]) + groupOffset;
        const dataAggregationFilter = dataAggregationFilters?.find((f)=>f.maxRange > range2);
        if (dataAggregationFilter == null) {
            let [start, end] = $2fb96651e8aa1522$var$visibleRangeIndices(rawData.length, xAxis.range, (index)=>{
                const x = xPosition(index);
                return [
                    x,
                    x + effectiveBarWidth
                ];
            });
            if (processedData.input.count < 1e3) {
                start = 0;
                end = processedData.input.count;
            }
            for(let datumIndex = start; datumIndex < end; datumIndex += 1){
                const xValue2 = xValues[datumIndex];
                if (xValue2 == null) continue;
                const openValue = openValues[datumIndex];
                const closeValue = closeValues[datumIndex];
                const highValue = highValues[datumIndex];
                const lowValue = lowValues[datumIndex];
                const validLowValue = lowValue != null && lowValue <= openValue && lowValue <= closeValue;
                const validHighValue = highValue != null && highValue >= openValue && highValue >= closeValue;
                if (!validLowValue) {
                    (0, $idDdm.Logger).warnOnce(`invalid low value for key [${lowKey}] in data element, low value cannot be higher than datum open or close values`);
                    continue;
                }
                if (!validHighValue) {
                    (0, $idDdm.Logger).warnOnce(`invalid high value for key [${highKey}] in data element, high value cannot be lower than datum open or close values.`);
                    continue;
                }
                handleDatum(datumIndex, xValue2, openValue, closeValue, highValue, lowValue, effectiveBarWidth, true);
            }
        } else {
            const { maxRange: maxRange, indexData: indexData } = dataAggregationFilter;
            const [start, end] = $2fb96651e8aa1522$var$visibleRangeIndices(maxRange, xAxis.range, (index)=>{
                const aggIndex = index * $2fb96651e8aa1522$var$SPAN;
                const openIndex = indexData[aggIndex + $2fb96651e8aa1522$var$OPEN];
                const closeIndex = indexData[aggIndex + $2fb96651e8aa1522$var$CLOSE];
                if (openIndex === -1) return;
                return [
                    xPosition(openIndex),
                    xPosition(closeIndex) + effectiveBarWidth
                ];
            });
            for(let i = start; i < end; i += 1){
                const aggIndex = i * $2fb96651e8aa1522$var$SPAN;
                const openIndex = indexData[aggIndex + $2fb96651e8aa1522$var$OPEN];
                const closeIndex = indexData[aggIndex + $2fb96651e8aa1522$var$CLOSE];
                const highIndex = indexData[aggIndex + $2fb96651e8aa1522$var$HIGH];
                const lowIndex = indexData[aggIndex + $2fb96651e8aa1522$var$LOW];
                if (openIndex === -1) continue;
                const midDatumIndex = (openIndex + closeIndex) / 2 | 0;
                const xValue2 = xValues[midDatumIndex];
                if (xValue2 == null) continue;
                const openValue = openValues[openIndex];
                const closeValue = closeValues[closeIndex];
                const highValue = highValues[highIndex];
                const lowValue = lowValues[lowIndex];
                const width = Math.abs(xPosition(closeIndex) - xPosition(openIndex)) + effectiveBarWidth;
                handleDatum(midDatumIndex, xValue2, openValue, closeValue, highValue, lowValue, width, false);
            }
        }
        return context;
    }
    isVertical() {
        return true;
    }
    isLabelEnabled() {
        return false;
    }
    updateDatumSelection(opts) {
        const data = opts.nodeData ?? [];
        return opts.datumSelection.update(data);
    }
    updateLabelNodes(_opts) {}
    updateLabelSelection(opts) {
        const { labelData: labelData, labelSelection: labelSelection } = opts;
        return labelSelection.update(labelData);
    }
    getItemBaseStyle(itemId, highlighted) {
        const { properties: properties } = this;
        const item = properties.item[itemId];
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        const shapeStyle = {
            fill: highlightStyle?.fill ?? item.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? item.fillOpacity,
            stroke: highlightStyle?.stroke ?? item.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? item.strokeWidth,
            strokeOpacity: highlightStyle?.strokeOpacity ?? item.strokeOpacity,
            lineDash: highlightStyle?.lineDash ?? item.lineDash,
            lineDashOffset: highlightStyle?.lineDashOffset ?? item.lineDashOffset
        };
        return item.fillGradientDefaults && item.fillPatternDefaults && item.fillImageDefaults ? $2fb96651e8aa1522$var$getShapeStyle2(shapeStyle, item.fillGradientDefaults, item.fillPatternDefaults, item.fillImageDefaults) : shapeStyle;
    }
    getItemStyleOverrides(datumId, datum, itemId, format, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const item = properties.item[itemId];
        const { itemStyler: itemStyler } = properties;
        if (itemStyler == null) return;
        const { xKey: xKey, openKey: openKey, closeKey: closeKey, highKey: highKey, lowKey: lowKey } = properties;
        const overrides = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId2(datumId, highlighted ? "highlight" : "node"), ()=>{
            return this.callWithContext(itemStyler, {
                seriesId: seriesId,
                datum: datum,
                itemId: itemId,
                xKey: xKey,
                openKey: openKey,
                closeKey: closeKey,
                highKey: highKey,
                lowKey: lowKey,
                highlighted: highlighted,
                ...format
            });
        });
        return item.fillGradientDefaults && item.fillPatternDefaults && item.fillImageDefaults ? $2fb96651e8aa1522$var$getShapeStyle2(overrides, item.fillGradientDefaults, item.fillPatternDefaults, item.fillImageDefaults) : overrides;
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, properties: properties } = this;
        const { xKey: xKey, xName: xName, yName: yName, openKey: openKey, openName: openName, highKey: highKey, highName: highName, lowKey: lowKey, lowName: lowName, closeKey: closeKey, closeName: closeName, legendItemName: legendItemName, tooltip: tooltip } = properties;
        const xAxis = this.getCategoryAxis();
        const yAxis = this.getValueAxis();
        if (!dataModel || !processedData || !xAxis || !yAxis) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const xValue2 = dataModel.resolveKeysById(this, `xValue`, processedData)[datumIndex];
        const openValue = dataModel.resolveColumnById(this, `openValue`, processedData)[datumIndex];
        const highValue = dataModel.resolveColumnById(this, `highValue`, processedData)[datumIndex];
        const lowValue = dataModel.resolveColumnById(this, `lowValue`, processedData)[datumIndex];
        const closeValue = dataModel.resolveColumnById(this, `closeValue`, processedData)[datumIndex];
        if (xValue2 == null) return;
        const itemId = closeValue >= openValue ? "up" : "down";
        const item = this.properties.item[itemId];
        const format = this.getItemBaseStyle(itemId, false);
        Object.assign(format, this.getItemStyleOverrides(String(datumIndex), datum, itemId, format, false));
        let marker = {
            fill: item.fill ?? item.stroke,
            fillOpacity: item.fillOpacity ?? item.strokeOpacity ?? 1,
            stroke: item.stroke,
            strokeWidth: item.strokeWidth ?? 1,
            strokeOpacity: item.strokeOpacity ?? 1,
            lineDash: item.lineDash ?? [
                0
            ],
            lineDashOffset: item.lineDashOffset ?? 0
        };
        if (item.fillGradientDefaults && item.fillPatternDefaults && item.fillImageDefaults) marker = $2fb96651e8aa1522$var$getShapeStyle2(marker, item.fillGradientDefaults, item.fillPatternDefaults, item.fillImageDefaults);
        return this.formatTooltipWithContext(tooltip, {
            heading: xAxis.formatDatum(xValue2),
            title: legendItemName,
            symbol: {
                marker: marker
            },
            data: [
                {
                    label: openName,
                    fallbackLabel: openKey,
                    value: yAxis.formatDatum(openValue)
                },
                {
                    label: highName,
                    fallbackLabel: highKey,
                    value: yAxis.formatDatum(highValue)
                },
                {
                    label: lowName,
                    fallbackLabel: lowKey,
                    value: yAxis.formatDatum(lowValue)
                },
                {
                    label: closeName,
                    fallbackLabel: closeKey,
                    value: yAxis.formatDatum(closeValue)
                }
            ]
        }, {
            seriesId: seriesId,
            datum: datum,
            title: yName,
            itemId: itemId,
            xKey: xKey,
            xName: xName,
            yName: yName,
            openKey: openKey,
            openName: openName,
            highKey: highKey,
            highName: highName,
            lowKey: lowKey,
            lowName: lowName,
            closeKey: closeKey,
            closeName: closeName,
            ...format
        });
    }
    getDatumId(datum) {
        return $2fb96651e8aa1522$var$createDatumId2(datum.xValue);
    }
    computeFocusBounds(opts) {
        const nodeDatum = this.getNodeData()?.at(opts.datumIndex);
        if (nodeDatum == null) return;
        const { centerX: centerX, y: y, width: width, height: height } = nodeDatum;
        const datum = {
            x: centerX - width / 2,
            y: y,
            width: width,
            height: height
        };
        return $2fb96651e8aa1522$var$computeBarFocusBounds2(this, datum);
    }
};
var { Path: $2fb96651e8aa1522$var$Path7, SceneChangeDetection: $2fb96651e8aa1522$var$SceneChangeDetection4, BBox: $2fb96651e8aa1522$var$BBox11 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$OhlcBaseNode = class extends $2fb96651e8aa1522$var$Path7 {
    constructor(){
        super(...arguments);
        this.centerX = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
        this.yOpen = 0;
        this.yClose = 0;
        this.crisp = false;
        this.strokeAlignment = 0;
    }
    computeBBox() {
        const { centerX: centerX, y: y, width: width, height: height } = this;
        return new $2fb96651e8aa1522$var$BBox11(centerX - width / 2, y, width, height);
    }
    isPointInPath(x, y) {
        return this.getBBox().containsPoint(x, y);
    }
    distanceSquared(x, y) {
        return this.getBBox().distanceSquared(x, y);
    }
    get midPoint() {
        return {
            x: this.centerX,
            y: this.y + this.height / 2
        };
    }
    alignedCoordinates() {
        const { y: y, width: width, height: height, crisp: crisp, strokeAlignment: strokeAlignment } = this;
        let { centerX: centerX, yOpen: yOpen, yClose: yClose } = this;
        let x0 = centerX - width / 2;
        let x1 = centerX + width / 2;
        let y0 = y;
        let y1 = y + height;
        if (crisp && width > 1) {
            centerX = this.align(centerX);
            yOpen = this.align(yOpen);
            yClose = this.align(yClose);
            const halfWidth = this.align(width / 2);
            x0 = centerX - halfWidth;
            x1 = centerX + halfWidth;
            y0 = this.align(y);
            y1 = y0 + this.align(y0, height);
        }
        const centerY = (y0 + y1) / 2;
        centerX += strokeAlignment;
        x0 += strokeAlignment;
        x1 += strokeAlignment;
        y0 -= strokeAlignment;
        y1 += strokeAlignment;
        yOpen += yOpen < centerY ? strokeAlignment : -strokeAlignment;
        yClose += yClose < centerY ? strokeAlignment : -strokeAlignment;
        return {
            centerX: centerX,
            x0: x0,
            x1: x1,
            y0: y0,
            y1: y1,
            yOpen: yOpen,
            yClose: yClose
        };
    }
    executeStroke(ctx, path) {
        const { width: width, strokeWidth: strokeWidth } = this;
        if (width < strokeWidth) ctx.lineWidth = width;
        super.executeStroke(ctx, path);
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection4()
], $2fb96651e8aa1522$var$OhlcBaseNode.prototype, "centerX", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection4()
], $2fb96651e8aa1522$var$OhlcBaseNode.prototype, "y", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection4()
], $2fb96651e8aa1522$var$OhlcBaseNode.prototype, "width", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection4()
], $2fb96651e8aa1522$var$OhlcBaseNode.prototype, "height", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection4()
], $2fb96651e8aa1522$var$OhlcBaseNode.prototype, "yOpen", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection4()
], $2fb96651e8aa1522$var$OhlcBaseNode.prototype, "yClose", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection4()
], $2fb96651e8aa1522$var$OhlcBaseNode.prototype, "crisp", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection4()
], $2fb96651e8aa1522$var$OhlcBaseNode.prototype, "strokeAlignment", 2);
var $2fb96651e8aa1522$var$OhlcNode = class extends $2fb96651e8aa1522$var$OhlcBaseNode {
    updatePath() {
        const { path: path } = this;
        const { centerX: centerX, x0: x0, x1: x1, y0: y0, y1: y1, yOpen: yOpen, yClose: yClose } = this.alignedCoordinates();
        path.clear();
        path.moveTo(centerX, y0);
        path.lineTo(centerX, y1);
        if (Math.abs(x1 - x0) > 1) {
            path.moveTo(x0, yOpen);
            path.lineTo(centerX, yOpen);
            path.moveTo(centerX, yClose);
            path.lineTo(x1, yClose);
        }
    }
};
// packages/ag-charts-enterprise/src/series/candlestick/candlestickNode.ts
var { SceneArrayChangeDetection: $2fb96651e8aa1522$var$SceneArrayChangeDetection, SceneChangeDetection: $2fb96651e8aa1522$var$SceneChangeDetection5, ExtendedPath2D: $2fb96651e8aa1522$var$ExtendedPath2D3, BBox: $2fb96651e8aa1522$var$BBox12 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$CandlestickNode = class extends $2fb96651e8aa1522$var$OhlcBaseNode {
    constructor(){
        super(...arguments);
        this.wickPath = new $2fb96651e8aa1522$var$ExtendedPath2D3();
        this.wickStroke = void 0;
        this.wickStrokeWidth = void 0;
        this.wickStrokeOpacity = void 0;
    }
    computeDefaultGradientFillBBox() {
        const { width: width, centerX: centerX, yOpen: yOpen, yClose: yClose } = this;
        const boxTop = Math.min(yOpen, yClose);
        const boxBottom = Math.max(yOpen, yClose);
        const rectHeight = boxBottom - boxTop;
        const x0 = centerX - width / 2;
        const x1 = centerX + width / 2;
        return new $2fb96651e8aa1522$var$BBox12(x0, boxTop, x1 - x0, rectHeight);
    }
    updatePath() {
        const { path: path, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, wickStroke: wickStroke, wickStrokeWidth: wickStrokeWidth, wickStrokeOpacity: wickStrokeOpacity, wickLineDash: wickLineDash, wickLineDashOffset: wickLineDashOffset, strokeAlignment: strokeAlignment } = this;
        const { centerX: centerX, x0: x0, x1: x1, y0: y0, y1: y1, yOpen: yOpen, yClose: yClose } = this.alignedCoordinates();
        this.path.clear();
        this.wickPath.clear();
        const needsWickPath = wickStroke != null && wickStroke !== stroke2 || wickStrokeWidth != null && wickStrokeWidth !== strokeWidth || wickStrokeOpacity != null && wickStrokeOpacity !== strokeOpacity || wickLineDash != null && wickLineDash !== lineDash || wickLineDashOffset != null && wickLineDashOffset !== lineDashOffset;
        const wickPath = needsWickPath ? this.wickPath : path;
        if (Math.abs(x1 - x0) <= 3) {
            wickPath.moveTo(centerX, y0);
            wickPath.lineTo(centerX, y1);
            return;
        }
        const boxTop = Math.min(yOpen, yClose);
        const boxBottom = Math.max(yOpen, yClose);
        wickPath.moveTo(centerX, y0);
        wickPath.lineTo(centerX, boxTop + strokeWidth / 2);
        wickPath.moveTo(centerX, y1);
        wickPath.lineTo(centerX, boxBottom - strokeWidth / 2);
        const boxStrokeAdjustment = strokeAlignment + strokeWidth / 2;
        const rectHeight = boxBottom - boxTop - 2 * boxStrokeAdjustment;
        if (rectHeight > 0) path.rect(x0 + boxStrokeAdjustment, boxTop + boxStrokeAdjustment, x1 - x0 - 2 * boxStrokeAdjustment, rectHeight);
        else {
            const boxMid = (boxTop + boxBottom) / 2;
            path.moveTo(x0, boxMid);
            path.lineTo(x1, boxMid);
        }
    }
    drawPath(ctx) {
        super.drawPath(ctx);
        const { wickPath: wickPath } = this;
        if (wickPath.isEmpty()) return;
        const { stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, wickStroke: wickStroke = stroke2, wickStrokeWidth: wickStrokeWidth = strokeWidth, wickStrokeOpacity: wickStrokeOpacity = strokeOpacity, wickLineDash: wickLineDash = lineDash, wickLineDashOffset: wickLineDashOffset = lineDashOffset } = this;
        if (wickStrokeWidth === 0) return;
        ctx.globalAlpha *= wickStrokeOpacity;
        if (typeof wickStroke === "string") ctx.strokeStyle = wickStroke;
        ctx.lineWidth = wickStrokeWidth;
        if (wickLineDash != null) ctx.setLineDash([
            ...wickLineDash
        ]);
        ctx.lineDashOffset = wickLineDashOffset;
        ctx.stroke(wickPath.getPath2D());
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection5()
], $2fb96651e8aa1522$var$CandlestickNode.prototype, "wickStroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection5()
], $2fb96651e8aa1522$var$CandlestickNode.prototype, "wickStrokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection5()
], $2fb96651e8aa1522$var$CandlestickNode.prototype, "wickStrokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneArrayChangeDetection()
], $2fb96651e8aa1522$var$CandlestickNode.prototype, "wickLineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection5()
], $2fb96651e8aa1522$var$CandlestickNode.prototype, "wickLineDashOffset", 2);
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties20, Property: $2fb96651e8aa1522$var$Property58, AbstractBarSeriesProperties: $2fb96651e8aa1522$var$AbstractBarSeriesProperties2, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$OhlcSeriesItem = class extends $2fb96651e8aa1522$var$BaseProperties20 {
    constructor(){
        super(...arguments);
        this.stroke = "#333";
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesItem.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesItem.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesItem.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesItem.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesItem.prototype, "lineDashOffset", 2);
var $2fb96651e8aa1522$var$OhlcSeriesItems = class extends $2fb96651e8aa1522$var$BaseProperties20 {
    constructor(){
        super(...arguments);
        this.up = new $2fb96651e8aa1522$var$OhlcSeriesItem();
        this.down = new $2fb96651e8aa1522$var$OhlcSeriesItem();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesItems.prototype, "up", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesItems.prototype, "down", 2);
var $2fb96651e8aa1522$var$OhlcSeriesBaseProperties = class extends $2fb96651e8aa1522$var$AbstractBarSeriesProperties2 {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesBaseProperties.prototype, "xKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesBaseProperties.prototype, "openKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesBaseProperties.prototype, "closeKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesBaseProperties.prototype, "highKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesBaseProperties.prototype, "lowKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesBaseProperties.prototype, "xName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesBaseProperties.prototype, "yName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesBaseProperties.prototype, "openName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesBaseProperties.prototype, "closeName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesBaseProperties.prototype, "highName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesBaseProperties.prototype, "lowName", 2);
var $2fb96651e8aa1522$var$OhlcSeriesProperties = class extends $2fb96651e8aa1522$var$OhlcSeriesBaseProperties {
    constructor(){
        super(...arguments);
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip2();
        this.item = new $2fb96651e8aa1522$var$OhlcSeriesItems();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesProperties.prototype, "tooltip", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesProperties.prototype, "item", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property58
], $2fb96651e8aa1522$var$OhlcSeriesProperties.prototype, "itemStyler", 2);
// packages/ag-charts-enterprise/src/series/candlestick/candlestickSeriesProperties.ts
var { FillGradientDefaults: $2fb96651e8aa1522$var$FillGradientDefaults2, FillPatternDefaults: $2fb96651e8aa1522$var$FillPatternDefaults2, FillImageDefaults: $2fb96651e8aa1522$var$FillImageDefaults2, BaseProperties: $2fb96651e8aa1522$var$BaseProperties21, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip3, Property: $2fb96651e8aa1522$var$Property59 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$CandlestickSeriesWick = class extends $2fb96651e8aa1522$var$BaseProperties21 {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesWick.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesWick.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesWick.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesWick.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesWick.prototype, "lineDashOffset", 2);
var $2fb96651e8aa1522$var$CandlestickSeriesItem = class extends $2fb96651e8aa1522$var$BaseProperties21 {
    constructor(){
        super(...arguments);
        this.fill = "#c16068";
        this.fillGradientDefaults = new $2fb96651e8aa1522$var$FillGradientDefaults2();
        this.fillPatternDefaults = new $2fb96651e8aa1522$var$FillPatternDefaults2();
        this.fillImageDefaults = new $2fb96651e8aa1522$var$FillImageDefaults2();
        this.fillOpacity = 1;
        this.stroke = "#333";
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.cornerRadius = 0;
        this.wick = new $2fb96651e8aa1522$var$CandlestickSeriesWick();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesItem.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesItem.prototype, "fillGradientDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesItem.prototype, "fillPatternDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesItem.prototype, "fillImageDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesItem.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesItem.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesItem.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesItem.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesItem.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesItem.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesItem.prototype, "cornerRadius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesItem.prototype, "wick", 2);
var $2fb96651e8aa1522$var$CandlestickSeriesItems = class extends $2fb96651e8aa1522$var$BaseProperties21 {
    constructor(){
        super(...arguments);
        this.up = new $2fb96651e8aa1522$var$CandlestickSeriesItem();
        this.down = new $2fb96651e8aa1522$var$CandlestickSeriesItem();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesItems.prototype, "up", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesItems.prototype, "down", 2);
var $2fb96651e8aa1522$var$CandlestickSeriesProperties = class extends $2fb96651e8aa1522$var$OhlcSeriesBaseProperties {
    constructor(){
        super(...arguments);
        this.item = new $2fb96651e8aa1522$var$CandlestickSeriesItems();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip3();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesProperties.prototype, "item", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesProperties.prototype, "tooltip", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property59
], $2fb96651e8aa1522$var$CandlestickSeriesProperties.prototype, "itemStyler", 2);
// packages/ag-charts-enterprise/src/series/candlestick/candlestickSeries.ts
var { createDatumId: $2fb96651e8aa1522$var$createDatumId3, isGradientFill: $2fb96651e8aa1522$var$isGradientFill2, isPatternFill: $2fb96651e8aa1522$var$isPatternFill, isImageFill: $2fb96651e8aa1522$var$isImageFill, getShapeFill: $2fb96651e8aa1522$var$getShapeFill, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle3 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$CandlestickSeries = class extends $2fb96651e8aa1522$var$OhlcSeriesBase {
    constructor(){
        super(...arguments);
        this.properties = new $2fb96651e8aa1522$var$CandlestickSeriesProperties();
    }
    nodeFactory() {
        return new $2fb96651e8aa1522$var$CandlestickNode();
    }
    updateDatumNodes({ datumSelection: datumSelection, isHighlight: isHighlight }) {
        const { id: seriesId, properties: properties } = this;
        const { xKey: xKey, highKey: highKey, lowKey: lowKey, openKey: openKey, closeKey: closeKey, item: item, itemStyler: itemStyler } = properties;
        const { up: up, down: down } = item;
        const upStyle = $2fb96651e8aa1522$var$getShapeStyle3({
            fill: up.fill,
            fillOpacity: up.fillOpacity,
            stroke: up.stroke,
            strokeWidth: up.strokeWidth,
            strokeOpacity: up.strokeOpacity,
            lineDash: up.lineDash,
            lineDashOffset: up.lineDashOffset
        }, up.fillGradientDefaults, up.fillPatternDefaults, up.fillImageDefaults);
        const downStyle = $2fb96651e8aa1522$var$getShapeStyle3({
            fill: down.fill,
            fillOpacity: down.fillOpacity,
            stroke: down.stroke,
            strokeWidth: down.strokeWidth,
            strokeOpacity: down.strokeOpacity,
            lineDash: down.lineDash,
            lineDashOffset: down.lineDashOffset
        }, down.fillGradientDefaults, down.fillPatternDefaults, down.fillImageDefaults);
        const highlightStyle = isHighlight ? properties.highlightStyle.item : void 0;
        datumSelection.each((node, datum)=>{
            const { isRising: isRising, centerX: centerX, width: width, y: y, height: height, yOpen: yOpen, yClose: yClose, crisp: crisp } = datum;
            let style;
            if (itemStyler != null) {
                const { fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = isRising ? upStyle : downStyle;
                style = $2fb96651e8aa1522$var$getShapeStyle3(this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId3(this.getDatumId(datum), isHighlight ? "highlight" : "node"), ()=>this.callWithContext(itemStyler, {
                        seriesId: seriesId,
                        itemId: datum.itemId,
                        xKey: xKey,
                        highKey: highKey,
                        lowKey: lowKey,
                        openKey: openKey,
                        closeKey: closeKey,
                        datum: datum.datum,
                        fill: fill,
                        fillOpacity: fillOpacity,
                        strokeOpacity: strokeOpacity,
                        stroke: stroke2,
                        strokeWidth: strokeWidth,
                        lineDash: lineDash,
                        lineDashOffset: lineDashOffset,
                        highlighted: isHighlight
                    })), isRising ? up.fillGradientDefaults : down.fillGradientDefaults, isRising ? up.fillPatternDefaults : down.fillPatternDefaults, isRising ? up.fillImageDefaults : down.fillImageDefaults);
            }
            node.centerX = centerX;
            node.width = width;
            node.y = y;
            node.height = height;
            node.yOpen = yOpen;
            node.yClose = yClose;
            node.crisp = crisp;
            const risingStyle = isRising ? upStyle : downStyle;
            const risingWickStyle = isRising ? up.wick : down.wick;
            $2fb96651e8aa1522$var$applyShapeStyle(node, {
                fill: highlightStyle?.fill ?? style?.fill ?? risingStyle.fill,
                fillOpacity: highlightStyle?.fillOpacity ?? style?.fillOpacity ?? risingStyle.fillOpacity,
                stroke: highlightStyle?.stroke ?? style?.stroke ?? risingStyle.stroke,
                strokeWidth: highlightStyle?.strokeWidth ?? style?.strokeWidth ?? risingStyle.strokeWidth,
                strokeOpacity: highlightStyle?.strokeOpacity ?? style?.strokeOpacity ?? risingStyle.strokeOpacity,
                lineDash: highlightStyle?.lineDash ?? style?.lineDash ?? risingStyle.lineDash,
                lineDashOffset: highlightStyle?.lineDashOffset ?? style?.lineDashOffset ?? risingStyle.lineDashOffset
            }, void 0, this.getShapeFillBBox());
            const styleWick = style?.wick;
            node.wickStroke = highlightStyle?.stroke ?? styleWick?.stroke ?? risingWickStyle.stroke;
            node.wickStrokeWidth = highlightStyle?.strokeWidth ?? styleWick?.strokeWidth ?? risingWickStyle.strokeWidth;
            node.wickStrokeOpacity = highlightStyle?.strokeOpacity ?? styleWick?.strokeOpacity ?? risingWickStyle.strokeOpacity;
            node.wickLineDash = highlightStyle?.lineDash ?? styleWick?.lineDash ?? risingWickStyle.lineDash;
            node.wickLineDashOffset = highlightStyle?.lineDashOffset ?? styleWick?.lineDashOffset ?? risingWickStyle.lineDashOffset;
            node.strokeAlignment = (style?.strokeWidth ?? risingStyle.strokeWidth) / 2;
        });
    }
    legendItemSymbol() {
        const { up: up, down: down } = this.properties.item;
        const upFill = $2fb96651e8aa1522$var$getShapeFill(up.fill, up.fillGradientDefaults, up.fillPatternDefaults, up.fillImageDefaults);
        const upColorStops = $2fb96651e8aa1522$var$isGradientFill2(upFill) ? upFill.colorStops.map((c)=>typeof c === "string" ? c : {
                color: c.color,
                stop: c.stop != null ? c.stop * 0.5 : void 0
            }) : [
            {
                color: $2fb96651e8aa1522$var$isPatternFill(upFill) || $2fb96651e8aa1522$var$isImageFill(upFill) ? up.stroke : upFill,
                stop: 0
            },
            {
                color: $2fb96651e8aa1522$var$isPatternFill(upFill) || $2fb96651e8aa1522$var$isImageFill(upFill) ? up.stroke : upFill,
                stop: 0.5
            }
        ];
        const downFill = $2fb96651e8aa1522$var$getShapeFill(down.fill, down.fillGradientDefaults, down.fillPatternDefaults, down.fillImageDefaults);
        const downColorStops = $2fb96651e8aa1522$var$isGradientFill2(downFill) ? downFill.colorStops.map((c)=>typeof c === "string" ? c : {
                color: c.color,
                stop: c.stop != null ? c.stop * 0.5 : void 0
            }) : [
            {
                color: $2fb96651e8aa1522$var$isPatternFill(downFill) || $2fb96651e8aa1522$var$isImageFill(downFill) ? down.stroke : downFill,
                stop: 0.5
            }
        ];
        const fill = {
            type: "gradient",
            gradient: "linear",
            rotation: 90,
            colorStops: [
                ...upColorStops,
                ...downColorStops
            ],
            reverse: false
        };
        const stroke2 = {
            type: "gradient",
            gradient: "linear",
            rotation: 90,
            colorStops: [
                {
                    color: up.stroke,
                    stop: 0
                },
                {
                    color: up.stroke,
                    stop: 0.5
                },
                {
                    color: down.stroke,
                    stop: 0.5
                }
            ],
            reverse: false
        };
        return {
            marker: {
                fill: fill,
                fillOpacity: up.fillOpacity,
                stroke: stroke2,
                strokeWidth: up.strokeWidth ?? 1,
                strokeOpacity: up.strokeOpacity ?? 1,
                lineDash: up.lineDash,
                lineDashOffset: up.lineDashOffset
            }
        };
    }
    getLegendData(legendType) {
        const { id: id, data: data, visible: visible, ctx: { legendManager: legendManager } } = this;
        const { xKey: xKey, yName: yName, showInLegend: showInLegend, legendItemName: legendItemName } = this.properties;
        if (!data?.length || !xKey || legendType !== "category") return [];
        return [
            {
                legendType: "category",
                id: id,
                itemId: id,
                seriesId: id,
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: id,
                    itemId: id
                }),
                label: {
                    text: legendItemName ?? yName ?? id
                },
                symbol: this.legendItemSymbol(),
                legendItemName: legendItemName,
                hideInLegend: !showInLegend
            }
        ];
    }
};
$2fb96651e8aa1522$var$CandlestickSeries.className = "CandleStickSeries";
$2fb96651e8aa1522$var$CandlestickSeries.type = "candlestick";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs2, candlestickSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$candlestickSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$candlestickSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$candlestickSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs2,
    type: (0, $idDdm.required)((0, $idDdm.constant)("candlestick")),
    xKey: (0, $idDdm.required)((0, $idDdm.string)),
    openKey: (0, $idDdm.required)((0, $idDdm.string)),
    highKey: (0, $idDdm.required)((0, $idDdm.string)),
    lowKey: (0, $idDdm.required)((0, $idDdm.string)),
    closeKey: (0, $idDdm.required)((0, $idDdm.string)),
    xName: (0, $idDdm.string),
    yName: (0, $idDdm.string),
    openName: (0, $idDdm.string),
    highName: (0, $idDdm.string),
    lowName: (0, $idDdm.string),
    closeName: (0, $idDdm.string)
};
$2fb96651e8aa1522$var$candlestickSeriesOptionsDef.pickOutsideVisibleMinorAxis = (0, $idDdm.undocumented)((0, $idDdm.boolean));
$2fb96651e8aa1522$var$candlestickSeriesOptionsDef.focusPriority = (0, $idDdm.undocumented)((0, $idDdm.number));
var { CARTESIAN_AXIS_TYPE: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE2 } = (0, $iTJTu._ModuleSupport).ThemeConstants;
function $2fb96651e8aa1522$var$itemTheme(key) {
    return {
        fill: {
            $if: [
                {
                    $eq: [
                        {
                            $palette: "type"
                        },
                        "user-indexed"
                    ]
                },
                key === "up" ? "transparent" : {
                    $palette: "fill"
                },
                {
                    $palette: `${key}.fill`
                }
            ]
        },
        stroke: {
            $if: [
                {
                    $eq: [
                        {
                            $palette: "type"
                        },
                        "user-indexed"
                    ]
                },
                {
                    $palette: "stroke"
                },
                {
                    $palette: `${key}.stroke`
                }
            ]
        },
        // @ts-expect-error undocumented-option
        fillGradientDefaults: {
            type: "gradient",
            gradient: "linear",
            bounds: "item",
            colorStops: {
                $if: [
                    {
                        $or: [
                            {
                                $isGradient: [
                                    {
                                        $palette: `${key}.fill`
                                    }
                                ]
                            },
                            {
                                $isPattern: [
                                    {
                                        $palette: `${key}.fill`
                                    }
                                ]
                            },
                            {
                                $isImage: [
                                    {
                                        $palette: `${key}.fill`
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        $map: [
                            {
                                $path: [
                                    "./color",
                                    void 0,
                                    {
                                        $value: "$1"
                                    }
                                ]
                            },
                            {
                                $path: [
                                    "./colorStops",
                                    void 0,
                                    {
                                        $palette: `${key}.fill`
                                    }
                                ]
                            }
                        ]
                    },
                    [
                        {
                            $mix: [
                                {
                                    $palette: `${key}.fill`
                                },
                                "black",
                                0.15
                            ]
                        },
                        {
                            $mix: [
                                {
                                    $palette: `${key}.fill`
                                },
                                "white",
                                0.15
                            ]
                        }
                    ]
                ]
            },
            rotation: 0,
            reverse: false
        },
        fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
        fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS
    };
}
var $2fb96651e8aa1522$var$CANDLESTICK_SERIES_THEME = {
    series: {
        item: {
            up: $2fb96651e8aa1522$var$itemTheme("up"),
            down: $2fb96651e8aa1522$var$itemTheme("down")
        },
        highlightStyle: {
            item: {
                strokeWidth: 3
            }
        }
    },
    animation: {
        enabled: false
    },
    axes: {
        [$2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE2.NUMBER]: {
            crosshair: {
                snap: false
            }
        },
        [$2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE2.ORDINAL_TIME]: {
            groupPaddingInner: 0,
            crosshair: {
                enabled: true
            }
        }
    }
};
// packages/ag-charts-enterprise/src/series/candlestick/candlestickModule.ts
var { CARTESIAN_AXIS_TYPE: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE3, CARTESIAN_POSITION: $2fb96651e8aa1522$var$CARTESIAN_POSITION } = (0, $iTJTu._ModuleSupport).ThemeConstants;
var $2fb96651e8aa1522$var$CandlestickModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    identifier: "candlestick",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$CandlestickSeries(ctx),
    tooltipDefaults: {
        range: "nearest"
    },
    defaultAxes: [
        {
            type: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE3.NUMBER,
            position: $2fb96651e8aa1522$var$CARTESIAN_POSITION.LEFT
        },
        {
            type: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE3.ORDINAL_TIME,
            position: $2fb96651e8aa1522$var$CARTESIAN_POSITION.BOTTOM
        }
    ],
    themeTemplate: $2fb96651e8aa1522$var$CANDLESTICK_SERIES_THEME,
    groupable: false
};
var $2fb96651e8aa1522$var$CandlestickSeriesModule = {
    type: "series",
    name: "candlestick",
    chartType: "cartesian",
    enterprise: true,
    options: $2fb96651e8aa1522$var$candlestickSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$CandlestickSeries(ctx)
};
var { CachedTextMeasurerPool: $2fb96651e8aa1522$var$CachedTextMeasurerPool3, TextUtils: $2fb96651e8aa1522$var$TextUtils4, TextWrapper: $2fb96651e8aa1522$var$TextWrapper4 } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$generateLabelSecondaryLabelFontSizeCandidates(label, secondaryLabel) {
    const { fontSize: labelFontSize, minimumFontSize: labelMinimumFontSize = labelFontSize } = label;
    const { fontSize: secondaryLabelFontSize, minimumFontSize: secondaryLabelMinimumFontSize = secondaryLabelFontSize } = secondaryLabel;
    const labelTracks = labelFontSize - labelMinimumFontSize;
    const secondaryLabelTracks = secondaryLabelFontSize - secondaryLabelMinimumFontSize;
    let currentLabelFontSize = label.fontSize;
    let currentSecondaryLabelFontSize = secondaryLabel.fontSize;
    const out = [
        {
            labelFontSize: labelFontSize,
            secondaryLabelFontSize: secondaryLabelFontSize
        }
    ];
    while(currentLabelFontSize > labelMinimumFontSize || currentSecondaryLabelFontSize > secondaryLabelMinimumFontSize){
        const labelProgress = labelTracks > 0 ? (currentLabelFontSize - labelMinimumFontSize) / labelTracks : -1;
        const secondaryLabelProgress = secondaryLabelTracks > 0 ? (currentSecondaryLabelFontSize - secondaryLabelMinimumFontSize) / secondaryLabelTracks : -1;
        if (labelProgress > secondaryLabelProgress) currentLabelFontSize--;
        else currentSecondaryLabelFontSize--;
        out.push({
            labelFontSize: currentLabelFontSize,
            secondaryLabelFontSize: currentSecondaryLabelFontSize
        });
    }
    out.reverse();
    return out;
}
function $2fb96651e8aa1522$var$getLineHeight(labelProps, fontSize) {
    if (labelProps.lineHeight != null && labelProps.fontSize != null) return labelProps.lineHeight * fontSize / labelProps.fontSize;
    else return $2fb96651e8aa1522$var$TextUtils4.getLineHeight(fontSize);
}
function $2fb96651e8aa1522$var$formatStackedLabels(labelValue, labelProps, secondaryLabelValue, secondaryLabelProps, { padding: padding }, sizeFittingHeight) {
    const { spacing: spacing = 0 } = labelProps;
    const widthAdjust = 2 * padding;
    const heightAdjust = 2 * padding + spacing;
    const minimumHeight = (labelProps.minimumFontSize ?? labelProps.fontSize) + (secondaryLabelProps.minimumFontSize ?? secondaryLabelProps.fontSize);
    if (minimumHeight > sizeFittingHeight(minimumHeight + heightAdjust, false).height - heightAdjust) return;
    const fontSizeCandidates = $2fb96651e8aa1522$var$generateLabelSecondaryLabelFontSizeCandidates(labelProps, secondaryLabelProps);
    const labelTextSizeProps = {
        fontFamily: labelProps.fontFamily,
        fontSize: labelProps.fontSize,
        fontStyle: labelProps.fontStyle,
        fontWeight: labelProps.fontWeight
    };
    const secondaryLabelTextSizeProps = {
        fontFamily: secondaryLabelProps.fontFamily,
        fontSize: secondaryLabelProps.fontSize,
        fontStyle: secondaryLabelProps.fontStyle,
        fontWeight: secondaryLabelProps.fontWeight
    };
    let label;
    let secondaryLabel;
    return (0, $idDdm.findMaxValue)(0, fontSizeCandidates.length - 1, (index)=>{
        const { labelFontSize: labelFontSize, secondaryLabelFontSize: secondaryLabelFontSize } = fontSizeCandidates[index];
        const allowTruncation = index === 0;
        const labelLineHeight = $2fb96651e8aa1522$var$getLineHeight(labelProps, labelFontSize);
        const secondaryLabelLineHeight = $2fb96651e8aa1522$var$getLineHeight(secondaryLabelProps, secondaryLabelFontSize);
        const sizeFitting = sizeFittingHeight(labelLineHeight + secondaryLabelLineHeight + heightAdjust, allowTruncation);
        const availableWidth = sizeFitting.width - widthAdjust;
        const availableHeight = sizeFitting.height - heightAdjust;
        if (labelLineHeight + secondaryLabelLineHeight > availableHeight) return;
        if (label == null || label.fontSize !== labelFontSize) {
            labelTextSizeProps.fontSize = labelFontSize;
            label = $2fb96651e8aa1522$var$wrapLabel(labelProps, labelValue, availableWidth, availableHeight, labelTextSizeProps, labelProps.wrapping, allowTruncation ? labelProps.overflowStrategy : "hide");
        }
        if (label == null || label.width > availableWidth || label.height > availableHeight) return;
        if (secondaryLabel == null || secondaryLabel.fontSize !== secondaryLabelFontSize) {
            secondaryLabelTextSizeProps.fontSize = secondaryLabelFontSize;
            secondaryLabel = $2fb96651e8aa1522$var$wrapLabel(secondaryLabelProps, secondaryLabelValue, availableWidth, availableHeight, secondaryLabelTextSizeProps, secondaryLabelProps.wrapping, allowTruncation ? secondaryLabelProps.overflowStrategy : "hide");
        }
        if (secondaryLabel == null) return;
        const totalLabelHeight = label.height + secondaryLabel.height;
        if (secondaryLabel.width > availableWidth || totalLabelHeight > availableHeight) return;
        return {
            width: Math.max(label.width, secondaryLabel.width),
            height: totalLabelHeight + spacing,
            meta: sizeFitting.meta,
            label: label,
            secondaryLabel: secondaryLabel
        };
    });
}
function $2fb96651e8aa1522$var$formatSingleLabel(value, props, { padding: padding }, sizeFittingHeight) {
    const sizeAdjust = 2 * padding;
    const minimumFontSize = Math.min(props.minimumFontSize ?? props.fontSize, props.fontSize);
    const textSizeProps = {
        fontFamily: props.fontFamily,
        fontSize: props.fontSize,
        fontStyle: props.fontStyle,
        fontWeight: props.fontWeight
    };
    return (0, $idDdm.findMaxValue)(minimumFontSize, props.fontSize, (fontSize)=>{
        const lineHeight = $2fb96651e8aa1522$var$getLineHeight(props, fontSize);
        const allowTruncation = fontSize === minimumFontSize;
        const sizeFitting = sizeFittingHeight(lineHeight + sizeAdjust, allowTruncation);
        const availableWidth = sizeFitting.width - sizeAdjust;
        const availableHeight = sizeFitting.height - sizeAdjust;
        if (lineHeight > availableHeight) return;
        textSizeProps.fontSize = fontSize;
        const lines = $2fb96651e8aa1522$var$TextWrapper4.wrapLines(value, {
            maxWidth: availableWidth,
            maxHeight: availableHeight,
            font: textSizeProps,
            textWrap: props.wrapping,
            overflow: (allowTruncation ? props.overflowStrategy : void 0) ?? "hide"
        });
        if (!lines.length) return;
        const clippedLabel = $2fb96651e8aa1522$var$clipLines(lines, {
            lineHeight: lineHeight,
            font: textSizeProps,
            maxWidth: availableWidth,
            maxHeight: availableHeight
        });
        if (!clippedLabel) return;
        return [
            {
                fontSize: fontSize,
                lineHeight: lineHeight,
                ...clippedLabel
            },
            sizeFitting.meta
        ];
    });
}
function $2fb96651e8aa1522$var$hasInvalidFontSize(label) {
    return label?.minimumFontSize != null && label?.fontSize != null && label?.minimumFontSize > label?.fontSize;
}
function $2fb96651e8aa1522$var$formatLabels(baseLabelValue, labelProps, baseSecondaryLabelValue, secondaryLabelProps, layoutParams, sizeFittingHeight) {
    const labelValue = labelProps.enabled ? baseLabelValue : void 0;
    const secondaryLabelValue = secondaryLabelProps.enabled ? baseSecondaryLabelValue : void 0;
    if ($2fb96651e8aa1522$var$hasInvalidFontSize(labelProps) || $2fb96651e8aa1522$var$hasInvalidFontSize(secondaryLabelProps)) (0, $idDdm.Logger).warnOnce(`minimumFontSize should be set to a value less than or equal to the font size`);
    let value;
    if (labelValue != null && secondaryLabelValue != null) value = $2fb96651e8aa1522$var$formatStackedLabels(labelValue, labelProps, secondaryLabelValue, secondaryLabelProps, layoutParams, sizeFittingHeight);
    let labelMeta;
    if (value == null && labelValue != null) labelMeta = $2fb96651e8aa1522$var$formatSingleLabel(labelValue, labelProps, layoutParams, sizeFittingHeight);
    if (labelMeta != null) {
        const [label, meta] = labelMeta;
        value = {
            width: label.width,
            height: label.height,
            meta: meta,
            label: label,
            secondaryLabel: void 0
        };
    }
    let secondaryLabelMeta;
    if (value == null && labelValue == null && secondaryLabelValue != null) secondaryLabelMeta = $2fb96651e8aa1522$var$formatSingleLabel(secondaryLabelValue, secondaryLabelProps, layoutParams, sizeFittingHeight);
    if (secondaryLabelMeta != null) {
        const [secondaryLabel, meta] = secondaryLabelMeta;
        value = {
            width: secondaryLabel.width,
            height: secondaryLabel.height,
            meta: meta,
            label: void 0,
            secondaryLabel: secondaryLabel
        };
    }
    return value;
}
function $2fb96651e8aa1522$var$wrapLabel(props, text2, maxWidth, maxHeight, font2, textWrap, overflow) {
    const lines = $2fb96651e8aa1522$var$TextWrapper4.wrapLines(text2, {
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        font: font2,
        textWrap: textWrap,
        overflow: overflow
    });
    if (!lines.length) return;
    const lineHeight = $2fb96651e8aa1522$var$getLineHeight(props, font2.fontSize);
    const { width: width } = $2fb96651e8aa1522$var$CachedTextMeasurerPool3.measureLines(lines, {
        font: font2
    });
    return {
        width: width,
        lineHeight: lineHeight,
        text: lines.join("\n"),
        height: lines.length * lineHeight,
        fontSize: font2.fontSize
    };
}
function $2fb96651e8aa1522$var$clipLines(lines, { font: font2, lineHeight: lineHeight = $2fb96651e8aa1522$var$TextUtils4.defaultLineHeight, maxWidth: maxWidth, maxHeight: maxHeight = Infinity }) {
    let height = lineHeight * lines.length;
    while(height > maxHeight){
        if (lines.length === 1) return;
        lines.pop();
        lines[lines.length - 1] = $2fb96651e8aa1522$var$TextWrapper4.appendEllipsis(lines.at(-1));
        height = lineHeight * lines.length;
    }
    const metrics = $2fb96651e8aa1522$var$CachedTextMeasurerPool3.measureLines(lines, {
        font: font2
    });
    let text2, width;
    if (metrics.width > maxWidth) {
        const clippedLines = [];
        width = 0;
        for (const line of metrics.lineMetrics){
            if (line.width > maxWidth) {
                if (!clippedLines.length) return;
                break;
            }
            clippedLines.push(line.text);
            width = Math.max(width, line.width);
        }
        text2 = $2fb96651e8aa1522$var$TextWrapper4.appendEllipsis(clippedLines.join("\n"));
    } else {
        text2 = lines.join("\n");
        width = metrics.width;
    }
    return {
        text: text2,
        width: width,
        height: height
    };
}
var { Property: $2fb96651e8aa1522$var$Property60 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$BaseAutoSizedLabel = class extends (0, $iTJTu._ModuleSupport).Label {
    constructor(){
        super(...arguments);
        this.wrapping = "on-space";
        this.overflowStrategy = "ellipsis";
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property60
], $2fb96651e8aa1522$var$BaseAutoSizedLabel.prototype, "wrapping", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property60
], $2fb96651e8aa1522$var$BaseAutoSizedLabel.prototype, "overflowStrategy", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property60
], $2fb96651e8aa1522$var$BaseAutoSizedLabel.prototype, "lineHeight", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property60
], $2fb96651e8aa1522$var$BaseAutoSizedLabel.prototype, "minimumFontSize", 2);
var $2fb96651e8aa1522$var$AutoSizedLabel = class extends $2fb96651e8aa1522$var$BaseAutoSizedLabel {
    constructor(){
        super(...arguments);
        this.spacing = 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property60
], $2fb96651e8aa1522$var$AutoSizedLabel.prototype, "spacing", 2);
var $2fb96651e8aa1522$var$AutoSizedSecondaryLabel = class extends $2fb96651e8aa1522$var$BaseAutoSizedLabel {
};
// packages/ag-charts-enterprise/src/series/heatmap/heatmapSeriesProperties.ts
var { CartesianSeriesProperties: $2fb96651e8aa1522$var$CartesianSeriesProperties, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip4, Property: $2fb96651e8aa1522$var$Property61 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$HeatmapSeriesProperties = class extends $2fb96651e8aa1522$var$CartesianSeriesProperties {
    constructor(){
        super(...arguments);
        this.colorRange = [
            "black",
            "black"
        ];
        this.stroke = "black";
        this.strokeOpacity = 1;
        this.strokeWidth = 0;
        this.textAlign = "center";
        this.verticalAlign = "middle";
        this.itemPadding = 0;
        this.label = new $2fb96651e8aa1522$var$AutoSizedLabel();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip4();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "title", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "xKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "yKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "colorKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "xName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "yName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "colorName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "colorRange", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "textAlign", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "verticalAlign", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "itemPadding", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "itemStyler", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property61
], $2fb96651e8aa1522$var$HeatmapSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-enterprise/src/series/heatmap/heatmapSeries.ts
var { SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode3, computeBarFocusBounds: $2fb96651e8aa1522$var$computeBarFocusBounds3, getMissCount: $2fb96651e8aa1522$var$getMissCount, valueProperty: $2fb96651e8aa1522$var$valueProperty6, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection20, DEFAULT_CARTESIAN_DIRECTION_KEYS: $2fb96651e8aa1522$var$DEFAULT_CARTESIAN_DIRECTION_KEYS, DEFAULT_CARTESIAN_DIRECTION_NAMES: $2fb96651e8aa1522$var$DEFAULT_CARTESIAN_DIRECTION_NAMES, createDatumId: $2fb96651e8aa1522$var$createDatumId4, ColorScale: $2fb96651e8aa1522$var$ColorScale, Rect: $2fb96651e8aa1522$var$Rect4, PointerEvents: $2fb96651e8aa1522$var$PointerEvents, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$HeatmapSeriesNodeEvent = class extends (0, $iTJTu._ModuleSupport).CartesianSeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.colorKey = series.properties.colorKey;
    }
};
var $2fb96651e8aa1522$var$textAlignFactors = {
    left: -0.5,
    center: 0,
    right: -0.5
};
var $2fb96651e8aa1522$var$verticalAlignFactors = {
    top: -0.5,
    middle: 0,
    bottom: -0.5
};
var $2fb96651e8aa1522$var$HeatmapSeries = class extends (0, $iTJTu._ModuleSupport).CartesianSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            directionKeys: $2fb96651e8aa1522$var$DEFAULT_CARTESIAN_DIRECTION_KEYS,
            directionNames: $2fb96651e8aa1522$var$DEFAULT_CARTESIAN_DIRECTION_NAMES,
            categoryKey: void 0,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode3.NEAREST_NODE,
                $2fb96651e8aa1522$var$SeriesNodePickMode3.EXACT_SHAPE_MATCH
            ],
            pathsPerSeries: [],
            hasMarkers: false,
            hasHighlightedLabels: true
        });
        this.properties = new $2fb96651e8aa1522$var$HeatmapSeriesProperties();
        this.NodeEvent = $2fb96651e8aa1522$var$HeatmapSeriesNodeEvent;
        this.colorScale = new $2fb96651e8aa1522$var$ColorScale();
    }
    async processData(dataController) {
        const xAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection20.X];
        const yAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection20.Y];
        if (!xAxis || !yAxis || !this.data?.length) return;
        const { xKey: xKey, yKey: yKey, colorRange: colorRange, colorKey: colorKey } = this.properties;
        const xScale = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection20.X]?.scale;
        const yScale = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection20.Y]?.scale;
        const { xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
            xScale: xScale,
            yScale: yScale
        });
        const colorScaleType = this.colorScale.type;
        const { dataModel: dataModel, processedData: processedData } = await this.requestDataModel(dataController, this.data, {
            props: [
                $2fb96651e8aa1522$var$valueProperty6(xKey, xScaleType, {
                    id: "xValue"
                }),
                $2fb96651e8aa1522$var$valueProperty6(yKey, yScaleType, {
                    id: "yValue"
                }),
                ...colorKey ? [
                    $2fb96651e8aa1522$var$valueProperty6(colorKey, colorScaleType, {
                        id: "colorValue",
                        invalidValue: null
                    })
                ] : []
            ]
        });
        if (this.isColorScaleValid()) {
            const colorKeyIdx = dataModel.resolveProcessedDataIndexById(this, "colorValue");
            this.colorScale.domain = processedData.domain.values[colorKeyIdx];
            this.colorScale.range = colorRange;
            this.colorScale.update();
        }
    }
    isColorScaleValid() {
        const { colorKey: colorKey } = this.properties;
        if (!colorKey) return false;
        const { dataModel: dataModel, processedData: processedData } = this;
        if (!dataModel || !processedData) return false;
        const colorDataIdx = dataModel.resolveProcessedDataIndexById(this, "colorValue");
        const dataCount = processedData.input.count;
        const missCount = $2fb96651e8aa1522$var$getMissCount(this, processedData.defs.values[colorDataIdx].missing);
        const colorDataMissing = dataCount === 0 || dataCount === missCount;
        return !colorDataMissing;
    }
    xCoordinateRange(xValue2, pixelSize) {
        const xScale = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection20.X].scale;
        const xOffset = pixelSize * (xScale.bandwidth ?? 0) / 2;
        const x = xScale.convert(xValue2) + xOffset;
        const width = pixelSize * (xScale.bandwidth ?? 10);
        return [
            x,
            x + width
        ];
    }
    yCoordinateRange(yValues, pixelSize) {
        const yScale = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection20.Y].scale;
        const yOffset = pixelSize * (yScale.bandwidth ?? 0) / 2;
        const y = yScale.convert(yValues[0]) + yOffset;
        const height = pixelSize * (yScale.bandwidth ?? 10);
        return [
            y,
            y + height
        ];
    }
    getSeriesDomain(direction) {
        const { dataModel: dataModel, processedData: processedData } = this;
        if (!dataModel || !processedData) return [];
        if (direction === $2fb96651e8aa1522$var$ChartAxisDirection20.X) return dataModel.getDomain(this, `xValue`, "value", processedData);
        else return dataModel.getDomain(this, `yValue`, "value", processedData);
    }
    getSeriesRange(_direction, _visibleRange) {
        return [
            NaN,
            NaN
        ];
    }
    createNodeData() {
        const { data: data, visible: visible, axes: axes, dataModel: dataModel, processedData: processedData } = this;
        const xAxis = axes[$2fb96651e8aa1522$var$ChartAxisDirection20.X];
        const yAxis = axes[$2fb96651e8aa1522$var$ChartAxisDirection20.Y];
        if (!(data && dataModel && processedData && visible && xAxis && yAxis)) return;
        if (xAxis.type !== "category" || yAxis.type !== "category") {
            (0, $idDdm.Logger).warnOnce(`Heatmap series expected axes to have "category" type, but received "${xAxis.type}" and "${yAxis.type}" instead.`);
            return;
        }
        const { xKey: xKey, xName: xName, yKey: yKey, yName: yName, colorKey: colorKey, colorName: colorName, textAlign: textAlign, verticalAlign: verticalAlign, itemPadding: itemPadding, label: label } = this.properties;
        const xValues = dataModel.resolveColumnById(this, `xValue`, processedData);
        const yValues = dataModel.resolveColumnById(this, `yValue`, processedData);
        const colorValues = colorKey ? dataModel.resolveColumnById(this, `colorValue`, processedData) : void 0;
        const xScale = xAxis.scale;
        const yScale = yAxis.scale;
        const xOffset = (xScale.bandwidth ?? 0) / 2;
        const yOffset = (yScale.bandwidth ?? 0) / 2;
        const nodeData = [];
        const labelData = [];
        const width = xScale.bandwidth ?? 10;
        const height = yScale.bandwidth ?? 10;
        const textAlignFactor = (width - 2 * itemPadding) * $2fb96651e8aa1522$var$textAlignFactors[textAlign];
        const verticalAlignFactor = (height - 2 * itemPadding) * $2fb96651e8aa1522$var$verticalAlignFactors[verticalAlign];
        const sizeFittingHeight = ()=>({
                width: width,
                height: height,
                meta: null
            });
        const rawData = processedData.dataSources.get(this.id) ?? [];
        rawData.forEach((datum, datumIndex)=>{
            const xDatum = xValues[datumIndex];
            const yDatum = yValues[datumIndex];
            const x = xScale.convert(xDatum) + xOffset;
            const y = yScale.convert(yDatum) + yOffset;
            const colorValue = colorValues?.[datumIndex];
            const labelText = colorValue == null ? void 0 : this.getLabelText(label, {
                value: colorValue,
                datum: datum,
                colorKey: colorKey,
                colorName: colorName,
                xKey: xKey,
                yKey: yKey,
                xName: xName,
                yName: yName
            });
            const labels = $2fb96651e8aa1522$var$formatLabels(labelText, this.properties.label, void 0, this.properties.label, {
                padding: itemPadding
            }, sizeFittingHeight);
            const point = {
                x: x,
                y: y,
                size: 0
            };
            nodeData.push({
                series: this,
                itemId: yKey,
                datumIndex: datumIndex,
                yKey: yKey,
                xKey: xKey,
                xValue: xDatum,
                yValue: yDatum,
                colorValue: colorValue,
                datum: datum,
                point: point,
                width: width,
                height: height,
                midPoint: {
                    x: x,
                    y: y
                },
                missing: colorValues != null && colorValue == null
            });
            if (labels?.label != null) {
                const { text: text2, fontSize: fontSize, lineHeight: lineHeight, height: labelHeight } = labels.label;
                const { fontStyle: fontStyle, fontFamily: fontFamily, fontWeight: fontWeight, color: color6 } = this.properties.label;
                const lx = point.x + textAlignFactor * (width - 2 * itemPadding);
                const ly = point.y + verticalAlignFactor * (height - 2 * itemPadding) - (labels.height - labelHeight) * 0.5;
                labelData.push({
                    series: this,
                    itemId: yKey,
                    datum: datum,
                    datumIndex: datumIndex,
                    text: text2,
                    fontSize: fontSize,
                    lineHeight: lineHeight,
                    fontStyle: fontStyle,
                    fontFamily: fontFamily,
                    fontWeight: fontWeight,
                    color: color6,
                    textAlign: textAlign,
                    verticalAlign: verticalAlign,
                    x: lx,
                    y: ly
                });
            }
        });
        return {
            itemId: this.properties.yKey ?? this.id,
            nodeData: nodeData,
            labelData: labelData,
            scales: this.calculateScaling(),
            visible: this.visible
        };
    }
    nodeFactory() {
        return new $2fb96651e8aa1522$var$Rect4();
    }
    update(params) {
        this.ctx.animationManager.skipCurrentBatch();
        return super.update(params);
    }
    updateDatumSelection(opts) {
        const { nodeData: nodeData, datumSelection: datumSelection } = opts;
        const data = nodeData ?? [];
        return datumSelection.update(data);
    }
    getItemBaseStyle(highlighted) {
        const { properties: properties } = this;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return {
            fill: highlightStyle?.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? 1,
            stroke: highlightStyle?.stroke ?? properties.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(properties.strokeWidth),
            strokeOpacity: highlightStyle?.strokeOpacity ?? properties.strokeOpacity
        };
    }
    getItemStyleOverrides(datumId, datum, colorValue, format, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const { xKey: xKey, yKey: yKey, itemStyler: itemStyler } = properties;
        const fill = this.isColorScaleValid() && colorValue != null ? this.colorScale.convert(colorValue) : "transparent";
        let overrides = format.fill == null ? {
            fill: fill
        } : void 0;
        if (itemStyler != null) {
            overrides ?? (overrides = {});
            const itemStyle = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId4(datumId, highlighted ? "highlight" : "node"), ()=>{
                return this.callWithContext(itemStyler, {
                    seriesId: seriesId,
                    datum: datum,
                    xKey: xKey,
                    yKey: yKey,
                    highlighted: highlighted,
                    ...format,
                    fill: fill
                });
            });
            Object.assign(overrides, itemStyle);
        }
        return overrides;
    }
    updateDatumNodes(opts) {
        const { isHighlight: isDatumHighlighted } = opts;
        const xAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection20.X];
        const [visibleMin, visibleMax] = xAxis?.visibleRange ?? [];
        const isZoomed = visibleMin !== 0 || visibleMax !== 1;
        const crisp = !isZoomed;
        const style = this.getItemBaseStyle(isDatumHighlighted);
        opts.datumSelection.each((rect, nodeDatum)=>{
            const { datumIndex: datumIndex, colorValue: colorValue, datum: datum, point: point, width: width, height: height } = nodeDatum;
            const overrides = this.getItemStyleOverrides(String(datumIndex), datum, colorValue, style, isDatumHighlighted);
            rect.crisp = crisp;
            rect.x = Math.floor(point.x - width / 2);
            rect.y = Math.floor(point.y - height / 2);
            rect.width = Math.ceil(width);
            rect.height = Math.ceil(height);
            $2fb96651e8aa1522$var$applyShapeStyle2(rect, style, overrides);
        });
    }
    updateLabelSelection(opts) {
        const { labelData: labelData, labelSelection: labelSelection } = opts;
        const { enabled: enabled } = this.properties.label;
        const data = enabled ? labelData : [];
        return labelSelection.update(data);
    }
    updateLabelNodes(opts) {
        opts.labelSelection.each((text2, datum)=>{
            text2.text = datum.text;
            text2.fontSize = datum.fontSize;
            text2.lineHeight = datum.lineHeight;
            text2.fontStyle = datum.fontStyle;
            text2.fontFamily = datum.fontFamily;
            text2.fontWeight = datum.fontWeight;
            text2.fill = datum.color;
            text2.textAlign = datum.textAlign;
            text2.textBaseline = datum.verticalAlign;
            text2.x = datum.x;
            text2.y = datum.y;
            text2.pointerEvents = $2fb96651e8aa1522$var$PointerEvents.None;
        });
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, axes: axes, properties: properties, colorScale: colorScale } = this;
        const { xKey: xKey, xName: xName, yKey: yKey, yName: yName, colorKey: colorKey, colorName: colorName, colorRange: colorRange, title: title, legendItemName: legendItemName, tooltip: tooltip } = properties;
        const xAxis = axes[$2fb96651e8aa1522$var$ChartAxisDirection20.X];
        const yAxis = axes[$2fb96651e8aa1522$var$ChartAxisDirection20.Y];
        if (!dataModel || !processedData || !xAxis || !yAxis) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const xValue2 = dataModel.resolveColumnById(this, `xValue`, processedData)[datumIndex];
        const yValue = dataModel.resolveColumnById(this, `yValue`, processedData)[datumIndex];
        const colorValue = colorKey != null && this.isColorScaleValid() ? dataModel.resolveColumnById(this, `colorValue`, processedData)[datumIndex] : void 0;
        if (xValue2 == null) return;
        const data = [];
        let fill;
        if (colorValue == null) fill = colorRange[0];
        else {
            fill = colorScale.convert(colorValue);
            data.push({
                label: colorName,
                fallbackLabel: colorKey,
                value: String(colorValue)
            });
        }
        data.push({
            label: xName,
            fallbackLabel: xKey,
            value: xAxis.formatDatum(xValue2)
        }, {
            label: yName,
            fallbackLabel: yKey,
            value: yAxis.formatDatum(yValue)
        });
        const format = this.getItemBaseStyle(false);
        Object.assign(format, this.getItemStyleOverrides(String(datumIndex), datum, colorValue, format, false));
        if (format.fill != null) fill = format.fill;
        const symbol = fill != null ? {
            marker: {
                shape: "square",
                fill: fill,
                fillOpacity: 1,
                stroke: void 0,
                strokeWidth: 0,
                strokeOpacity: 1,
                lineDash: [
                    0
                ],
                lineDashOffset: 0
            }
        } : void 0;
        return this.formatTooltipWithContext(tooltip, {
            title: title ?? legendItemName,
            symbol: symbol,
            data: data
        }, {
            seriesId: seriesId,
            datum: datum,
            title: title,
            xKey: xKey,
            xName: xName,
            yKey: yKey,
            yName: yName,
            colorKey: colorKey,
            colorName: colorName,
            ...format
        });
    }
    getLegendData(legendType) {
        if (legendType !== "gradient" || !this.isColorScaleValid() || !this.dataModel) return [];
        return [
            {
                legendType: "gradient",
                enabled: this.visible,
                seriesId: this.id,
                colorName: this.properties.colorName,
                colorDomain: this.processedData.domain.values[this.dataModel.resolveProcessedDataIndexById(this, "colorValue")],
                colorRange: this.properties.colorRange
            }
        ];
    }
    isLabelEnabled() {
        return this.properties.label.enabled && Boolean(this.properties.colorKey);
    }
    getBandScalePadding() {
        return {
            inner: 0,
            outer: 0
        };
    }
    computeFocusBounds({ datumIndex: datumIndex }) {
        const datum = this.contextNodeData?.nodeData[datumIndex];
        if (datum === void 0) return void 0;
        const { width: width, height: height, midPoint: midPoint } = datum;
        const focusRect = {
            x: midPoint.x - width / 2,
            y: midPoint.y - height / 2,
            width: width,
            height: height
        };
        return $2fb96651e8aa1522$var$computeBarFocusBounds3(this, focusRect);
    }
};
$2fb96651e8aa1522$var$HeatmapSeries.className = "HeatmapSeries";
$2fb96651e8aa1522$var$HeatmapSeries.type = "heatmap";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs3, heatmapSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$heatmapSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$heatmapSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$heatmapSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs3,
    type: (0, $idDdm.required)((0, $idDdm.constant)("heatmap")),
    xKey: (0, $idDdm.required)((0, $idDdm.string)),
    yKey: (0, $idDdm.required)((0, $idDdm.string)),
    colorKey: (0, $idDdm.string),
    xName: (0, $idDdm.string),
    yName: (0, $idDdm.string),
    colorName: (0, $idDdm.string),
    colorRange: (0, $idDdm.arrayOf)((0, $idDdm.color))
};
var $2fb96651e8aa1522$var$HEATMAP_SERIES_THEME = {
    series: {
        stroke: {
            $if: [
                {
                    $eq: [
                        {
                            $palette: "type"
                        },
                        "inbuilt"
                    ]
                },
                {
                    $ref: "backgroundColor"
                },
                {
                    $path: [
                        "./0",
                        {
                            $palette: "stroke"
                        },
                        {
                            $palette: "strokes"
                        }
                    ]
                }
            ]
        },
        // @ts-expect-error undocumented option
        colorRange: {
            $if: [
                {
                    $eq: [
                        {
                            $palette: "type"
                        },
                        "inbuilt"
                    ]
                },
                {
                    $palette: "divergingColors"
                },
                (0, $iTJTu._ModuleSupport).SAFE_RANGE2_OPERATION
            ]
        },
        label: {
            enabled: false,
            color: {
                $ref: "textColor"
            },
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            fontWeight: {
                $ref: "fontWeight"
            },
            wrapping: "on-space",
            overflowStrategy: "ellipsis"
        },
        itemPadding: 3
    },
    gradientLegend: {
        enabled: true
    }
};
// packages/ag-charts-enterprise/src/series/heatmap/heatmapModule.ts
var { ThemeConstants: { CARTESIAN_AXIS_TYPE: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE4, CARTESIAN_POSITION: $2fb96651e8aa1522$var$CARTESIAN_POSITION2 } } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$HeatmapModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    identifier: "heatmap",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$HeatmapSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    defaultAxes: [
        {
            type: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE4.CATEGORY,
            position: $2fb96651e8aa1522$var$CARTESIAN_POSITION2.LEFT
        },
        {
            type: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE4.CATEGORY,
            position: $2fb96651e8aa1522$var$CARTESIAN_POSITION2.BOTTOM
        }
    ],
    themeTemplate: $2fb96651e8aa1522$var$HEATMAP_SERIES_THEME
};
var $2fb96651e8aa1522$var$HeatmapSeriesModule = {
    type: "series",
    name: "heatmap",
    chartType: "cartesian",
    enterprise: true,
    options: $2fb96651e8aa1522$var$heatmapSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$HeatmapSeries(ctx)
};
var { createDatumId: $2fb96651e8aa1522$var$createDatumId5 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$OhlcSeries = class extends $2fb96651e8aa1522$var$OhlcSeriesBase {
    constructor(){
        super(...arguments);
        this.properties = new $2fb96651e8aa1522$var$OhlcSeriesProperties();
    }
    nodeFactory() {
        return new $2fb96651e8aa1522$var$OhlcNode();
    }
    updateDatumNodes({ datumSelection: datumSelection, isHighlight: isHighlight }) {
        const { id: seriesId, properties: properties } = this;
        const { xKey: xKey, highKey: highKey, lowKey: lowKey, openKey: openKey, closeKey: closeKey, item: item, itemStyler: itemStyler } = properties;
        const { up: up, down: down } = item;
        const { stroke: upStroke, strokeWidth: upStrokeWidth, strokeOpacity: upStrokeOpacity, lineDash: upLineDash, lineDashOffset: upLineDashOffset } = up;
        const { stroke: downStroke, strokeWidth: downStrokeWidth, strokeOpacity: downStrokeOpacity, lineDash: downLineDash, lineDashOffset: downLineDashOffset } = down;
        const highlightStyle = isHighlight ? properties.highlightStyle.item : void 0;
        datumSelection.each((node, datum)=>{
            const { isRising: isRising, centerX: centerX, width: width, y: y, height: height, yOpen: yOpen, yClose: yClose, crisp: crisp } = datum;
            let style;
            if (itemStyler != null) {
                const { stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = isRising ? up : down;
                style = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId5(this.getDatumId(datum), isHighlight ? "highlight" : "node"), ()=>this.callWithContext(itemStyler, {
                        seriesId: seriesId,
                        itemId: datum.itemId,
                        xKey: xKey,
                        highKey: highKey,
                        lowKey: lowKey,
                        openKey: openKey,
                        closeKey: closeKey,
                        datum: datum.datum,
                        strokeOpacity: strokeOpacity,
                        stroke: stroke2,
                        strokeWidth: strokeWidth,
                        lineDash: lineDash,
                        lineDashOffset: lineDashOffset,
                        highlighted: isHighlight
                    }));
            }
            node.centerX = centerX;
            node.width = width;
            node.y = y;
            node.height = height;
            node.yOpen = yOpen;
            node.yClose = yClose;
            node.crisp = crisp;
            node.stroke = highlightStyle?.stroke ?? style?.stroke ?? (isRising ? upStroke : downStroke);
            node.strokeWidth = highlightStyle?.strokeWidth ?? style?.strokeWidth ?? (isRising ? upStrokeWidth : downStrokeWidth);
            node.strokeOpacity = highlightStyle?.strokeOpacity ?? style?.strokeOpacity ?? (isRising ? upStrokeOpacity : downStrokeOpacity);
            node.lineDash = highlightStyle?.lineDash ?? style?.lineDash ?? (isRising ? upLineDash : downLineDash);
            node.lineDashOffset = highlightStyle?.lineDashOffset ?? style?.lineDashOffset ?? (isRising ? upLineDashOffset : downLineDashOffset);
            node.strokeAlignment = (style?.strokeWidth ?? (isRising ? upStrokeWidth : downStrokeWidth)) / 2;
        });
    }
    getLegendData(legendType) {
        const { id: id, data: data, ctx: { legendManager: legendManager }, visible: visible } = this;
        const { xKey: xKey, yName: yName, item: { up: up, down: down }, showInLegend: showInLegend, legendItemName: legendItemName } = this.properties;
        if (!data?.length || !xKey || legendType !== "category") return [];
        const fill = {
            type: "gradient",
            gradient: "linear",
            colorSpace: "rgb",
            colorStops: [
                {
                    color: up.stroke,
                    stop: 0
                },
                {
                    color: up.stroke,
                    stop: 0.5
                },
                {
                    color: down.stroke,
                    stop: 0.5
                }
            ],
            rotation: 90
        };
        return [
            {
                legendType: "category",
                id: id,
                itemId: id,
                seriesId: id,
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: id,
                    itemId: id
                }),
                label: {
                    text: legendItemName ?? yName ?? id
                },
                symbol: {
                    marker: {
                        fill: fill,
                        fillOpacity: up.strokeOpacity,
                        stroke: void 0,
                        strokeWidth: 0,
                        strokeOpacity: 1,
                        lineDash: [
                            0
                        ],
                        lineDashOffset: 0
                    }
                },
                legendItemName: legendItemName,
                hideInLegend: !showInLegend
            }
        ];
    }
};
$2fb96651e8aa1522$var$OhlcSeries.className = "ohlc";
$2fb96651e8aa1522$var$OhlcSeries.type = "ohlc";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs4, ohlcSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$ohlcSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$ohlcSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$ohlcSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs4,
    type: (0, $idDdm.required)((0, $idDdm.constant)("ohlc")),
    xKey: (0, $idDdm.required)((0, $idDdm.string)),
    openKey: (0, $idDdm.required)((0, $idDdm.string)),
    highKey: (0, $idDdm.required)((0, $idDdm.string)),
    lowKey: (0, $idDdm.required)((0, $idDdm.string)),
    closeKey: (0, $idDdm.required)((0, $idDdm.string)),
    xName: (0, $idDdm.string),
    yName: (0, $idDdm.string),
    openName: (0, $idDdm.string),
    highName: (0, $idDdm.string),
    lowName: (0, $idDdm.string),
    closeName: (0, $idDdm.string)
};
$2fb96651e8aa1522$var$ohlcSeriesOptionsDef.pickOutsideVisibleMinorAxis = (0, $idDdm.undocumented)((0, $idDdm.boolean));
$2fb96651e8aa1522$var$ohlcSeriesOptionsDef.focusPriority = (0, $idDdm.undocumented)((0, $idDdm.number));
// packages/ag-charts-enterprise/src/series/ohlc/ohlcModule.ts
var { CARTESIAN_AXIS_TYPE: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE5, CARTESIAN_POSITION: $2fb96651e8aa1522$var$CARTESIAN_POSITION3 } = (0, $iTJTu._ModuleSupport).ThemeConstants;
var $2fb96651e8aa1522$var$OhlcModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    identifier: "ohlc",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$OhlcSeries(ctx),
    tooltipDefaults: {
        range: "nearest"
    },
    defaultAxes: [
        {
            type: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE5.NUMBER,
            position: $2fb96651e8aa1522$var$CARTESIAN_POSITION3.LEFT
        },
        {
            type: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE5.ORDINAL_TIME,
            position: $2fb96651e8aa1522$var$CARTESIAN_POSITION3.BOTTOM
        }
    ],
    themeTemplate: {
        animation: {
            enabled: false
        },
        series: {
            item: {
                up: {
                    stroke: {
                        $if: [
                            {
                                $eq: [
                                    {
                                        $palette: "type"
                                    },
                                    "user-indexed"
                                ]
                            },
                            {
                                $palette: "stroke"
                            },
                            {
                                $palette: "up.stroke"
                            }
                        ]
                    }
                },
                down: {
                    stroke: {
                        $if: [
                            {
                                $eq: [
                                    {
                                        $palette: "type"
                                    },
                                    "user-indexed"
                                ]
                            },
                            {
                                $palette: "stroke"
                            },
                            {
                                $palette: "down.stroke"
                            }
                        ]
                    }
                }
            }
        },
        axes: {
            [$2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE5.NUMBER]: {
                crosshair: {
                    snap: false
                }
            },
            [$2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE5.ORDINAL_TIME]: {
                groupPaddingInner: 0,
                crosshair: {
                    enabled: true
                }
            }
        }
    },
    groupable: false
};
var $2fb96651e8aa1522$var$OhlcSeriesModule = {
    type: "series",
    name: "ohlc",
    chartType: "cartesian",
    enterprise: true,
    options: $2fb96651e8aa1522$var$ohlcSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$OhlcSeries(ctx)
};
// packages/ag-charts-enterprise/src/series/range-area/rangeAreaAggregation.ts
var $2fb96651e8aa1522$var$AGGREGATION_THRESHOLD2 = 1e3;
function $2fb96651e8aa1522$var$aggregationContainsTopIndex(xValues, d0, d1, indexData, maxRange, datumIndex) {
    const xValue2 = xValues[datumIndex];
    if (xValue2 == null) return false;
    const xRatio = $2fb96651e8aa1522$var$xRatioForDatumIndex(xValue2, d0, d1);
    const aggIndex = $2fb96651e8aa1522$var$aggregationIndexForXRatio(xRatio, maxRange);
    return datumIndex === indexData[aggIndex + $2fb96651e8aa1522$var$Y_MAX];
}
function $2fb96651e8aa1522$var$aggregationContainsBottomIndex(xValues, d0, d1, indexData, maxRange, datumIndex) {
    const xValue2 = xValues[datumIndex];
    if (xValue2 == null) return false;
    const xRatio = $2fb96651e8aa1522$var$xRatioForDatumIndex(xValue2, d0, d1);
    const aggIndex = $2fb96651e8aa1522$var$aggregationIndexForXRatio(xRatio, maxRange);
    return datumIndex === indexData[aggIndex + $2fb96651e8aa1522$var$Y_MIN];
}
function $2fb96651e8aa1522$var$aggregateData(xValues, highValues, lowValues, domain) {
    if (xValues.length < $2fb96651e8aa1522$var$AGGREGATION_THRESHOLD2) return;
    const [d0, d1] = $2fb96651e8aa1522$var$aggregationDomain(domain);
    let maxRange = $2fb96651e8aa1522$var$maxRangeFittingPoints(xValues);
    const { indexData: indexData, valueData: valueData } = $2fb96651e8aa1522$var$createAggregationIndices(xValues, highValues, lowValues, d0, d1, maxRange);
    let topIndices = [];
    let bottomIndices = [];
    for(let datumIndex = 0; datumIndex < xValues.length; datumIndex += 1){
        if ($2fb96651e8aa1522$var$aggregationContainsTopIndex(xValues, d0, d1, indexData, maxRange, datumIndex)) topIndices.push(datumIndex);
        if ($2fb96651e8aa1522$var$aggregationContainsBottomIndex(xValues, d0, d1, indexData, maxRange, datumIndex)) bottomIndices.push(datumIndex);
    }
    const filters = [
        {
            maxRange: maxRange,
            topIndices: topIndices,
            bottomIndices: bottomIndices
        }
    ];
    while(maxRange > 64){
        ({ maxRange: maxRange } = $2fb96651e8aa1522$var$compactAggregationIndices(indexData, valueData, maxRange, {
            inPlace: true
        }));
        topIndices = topIndices.filter($2fb96651e8aa1522$var$aggregationContainsTopIndex.bind(null, xValues, d0, d1, indexData, maxRange));
        bottomIndices = bottomIndices.filter($2fb96651e8aa1522$var$aggregationContainsBottomIndex.bind(null, xValues, d0, d1, indexData, maxRange));
        filters.push({
            maxRange: maxRange,
            topIndices: topIndices,
            bottomIndices: bottomIndices
        });
    }
    filters.reverse();
    return filters;
}
var { CartesianSeriesProperties: $2fb96651e8aa1522$var$CartesianSeriesProperties2, FillGradientDefaults: $2fb96651e8aa1522$var$FillGradientDefaults3, FillPatternDefaults: $2fb96651e8aa1522$var$FillPatternDefaults3, FillImageDefaults: $2fb96651e8aa1522$var$FillImageDefaults3, InterpolationProperties: $2fb96651e8aa1522$var$InterpolationProperties, SeriesMarker: $2fb96651e8aa1522$var$SeriesMarker, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip5, Property: $2fb96651e8aa1522$var$Property62, DropShadow: $2fb96651e8aa1522$var$DropShadow, Label: $2fb96651e8aa1522$var$Label3 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RangeAreaSeriesLabel = class extends $2fb96651e8aa1522$var$Label3 {
    constructor(){
        super(...arguments);
        this.placement = "outside";
        this.padding = 6;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaSeriesLabel.prototype, "placement", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaSeriesLabel.prototype, "padding", 2);
var $2fb96651e8aa1522$var$RangeAreaProperties = class extends $2fb96651e8aa1522$var$CartesianSeriesProperties2 {
    constructor(){
        super(...arguments);
        this.fill = "#99CCFF";
        this.fillGradientDefaults = new $2fb96651e8aa1522$var$FillGradientDefaults3();
        this.fillPatternDefaults = new $2fb96651e8aa1522$var$FillPatternDefaults3();
        this.fillImageDefaults = new $2fb96651e8aa1522$var$FillImageDefaults3();
        this.fillOpacity = 1;
        this.stroke = "#99CCFF";
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.interpolation = new $2fb96651e8aa1522$var$InterpolationProperties();
        this.shadow = new $2fb96651e8aa1522$var$DropShadow().set({
            enabled: false
        });
        this.marker = new $2fb96651e8aa1522$var$SeriesMarker();
        this.label = new $2fb96651e8aa1522$var$RangeAreaSeriesLabel();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip5();
        this.connectMissingData = false;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "xKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "yLowKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "yHighKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "xName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "yName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "yLowName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "yHighName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "fillGradientDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "fillPatternDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "fillImageDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "interpolation", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "shadow", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "marker", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "tooltip", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property62
], $2fb96651e8aa1522$var$RangeAreaProperties.prototype, "connectMissingData", 2);
var { CollapseMode: $2fb96651e8aa1522$var$CollapseMode, isScaleValid: $2fb96651e8aa1522$var$isScaleValid, pairUpSpans: $2fb96651e8aa1522$var$pairUpSpans, prepareAreaFillAnimationFns: $2fb96651e8aa1522$var$prepareAreaFillAnimationFns, plotInterpolatedLinePathStroke: $2fb96651e8aa1522$var$plotInterpolatedLinePathStroke, prepareLinePathPropertyAnimation: $2fb96651e8aa1522$var$prepareLinePathPropertyAnimation, areScalingEqual: $2fb96651e8aa1522$var$areScalingEqual } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$prepareRangeAreaPathStrokeAnimationFns(status, highSpans, lowSpans, visibleToggleMode) {
    const removePhaseFn = (ratio3, path)=>{
        $2fb96651e8aa1522$var$plotInterpolatedLinePathStroke(ratio3, path, highSpans.removed);
        $2fb96651e8aa1522$var$plotInterpolatedLinePathStroke(ratio3, path, lowSpans.removed);
    };
    const updatePhaseFn = (ratio3, path)=>{
        $2fb96651e8aa1522$var$plotInterpolatedLinePathStroke(ratio3, path, highSpans.moved);
        $2fb96651e8aa1522$var$plotInterpolatedLinePathStroke(ratio3, path, lowSpans.moved);
    };
    const addPhaseFn = (ratio3, path)=>{
        $2fb96651e8aa1522$var$plotInterpolatedLinePathStroke(ratio3, path, highSpans.added);
        $2fb96651e8aa1522$var$plotInterpolatedLinePathStroke(ratio3, path, lowSpans.added);
    };
    const pathProperties = $2fb96651e8aa1522$var$prepareLinePathPropertyAnimation(status, visibleToggleMode);
    return {
        status: status,
        path: {
            addPhaseFn: addPhaseFn,
            updatePhaseFn: updatePhaseFn,
            removePhaseFn: removePhaseFn
        },
        pathProperties: pathProperties
    };
}
function $2fb96651e8aa1522$var$prepareRangeAreaPathAnimation(newData, oldData, diff8) {
    const isCategoryBased = newData.scales.x?.type === "category";
    const wasCategoryBased = oldData.scales.x?.type === "category";
    if (isCategoryBased !== wasCategoryBased || !$2fb96651e8aa1522$var$isScaleValid(newData.scales.x) || !$2fb96651e8aa1522$var$isScaleValid(oldData.scales.x)) return;
    let status = "updated";
    if (oldData.visible && !newData.visible) status = "removed";
    else if (!oldData.visible && newData.visible) status = "added";
    const fillSpans = $2fb96651e8aa1522$var$pairUpSpans({
        scales: newData.scales,
        data: newData.fillData.spans
    }, {
        scales: oldData.scales,
        data: oldData.fillData.spans
    }, $2fb96651e8aa1522$var$CollapseMode.Split);
    if (fillSpans == null) return;
    const fillPhantomSpans = $2fb96651e8aa1522$var$pairUpSpans({
        scales: newData.scales,
        data: newData.fillData.phantomSpans
    }, {
        scales: oldData.scales,
        data: oldData.fillData.phantomSpans
    }, $2fb96651e8aa1522$var$CollapseMode.Split);
    if (fillPhantomSpans == null) return;
    const highStrokeSpans = $2fb96651e8aa1522$var$pairUpSpans({
        scales: newData.scales,
        data: newData.highStrokeData.spans
    }, {
        scales: oldData.scales,
        data: oldData.highStrokeData.spans
    }, $2fb96651e8aa1522$var$CollapseMode.Split);
    if (highStrokeSpans == null) return;
    const lowStrokeSpans = $2fb96651e8aa1522$var$pairUpSpans({
        scales: newData.scales,
        data: newData.lowStrokeData.spans
    }, {
        scales: oldData.scales,
        data: oldData.lowStrokeData.spans
    }, $2fb96651e8aa1522$var$CollapseMode.Split);
    if (lowStrokeSpans == null) return;
    const fadeMode = "fade";
    const fill = $2fb96651e8aa1522$var$prepareAreaFillAnimationFns(status, fillSpans, fillPhantomSpans, fadeMode);
    const stroke2 = $2fb96651e8aa1522$var$prepareRangeAreaPathStrokeAnimationFns(status, highStrokeSpans, lowStrokeSpans, fadeMode);
    const hasMotion = (diff8?.changed ?? true) || !$2fb96651e8aa1522$var$areScalingEqual(newData.scales.x, oldData.scales.x) || !$2fb96651e8aa1522$var$areScalingEqual(newData.scales.y, oldData.scales.y) || status !== "updated";
    return {
        status: status,
        fill: fill,
        stroke: stroke2,
        hasMotion: hasMotion
    };
}
// packages/ag-charts-enterprise/src/series/range-area/rangeArea.ts
var { valueProperty: $2fb96651e8aa1522$var$valueProperty7, keyProperty: $2fb96651e8aa1522$var$keyProperty4, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection21, mergeDefaults: $2fb96651e8aa1522$var$mergeDefaults5, updateLabelNode: $2fb96651e8aa1522$var$updateLabelNode, fixNumericExtent: $2fb96651e8aa1522$var$fixNumericExtent4, buildResetPathFn: $2fb96651e8aa1522$var$buildResetPathFn, resetLabelFn: $2fb96651e8aa1522$var$resetLabelFn, resetMarkerFn: $2fb96651e8aa1522$var$resetMarkerFn, resetMarkerPositionFn: $2fb96651e8aa1522$var$resetMarkerPositionFn, pathSwipeInAnimation: $2fb96651e8aa1522$var$pathSwipeInAnimation, resetMotion: $2fb96651e8aa1522$var$resetMotion, markerSwipeScaleInAnimation: $2fb96651e8aa1522$var$markerSwipeScaleInAnimation, seriesLabelFadeInAnimation: $2fb96651e8aa1522$var$seriesLabelFadeInAnimation, animationValidation: $2fb96651e8aa1522$var$animationValidation3, diff: $2fb96651e8aa1522$var$diff3, updateClipPath: $2fb96651e8aa1522$var$updateClipPath, computeMarkerFocusBounds: $2fb96651e8aa1522$var$computeMarkerFocusBounds, plotAreaPathFill: $2fb96651e8aa1522$var$plotAreaPathFill, plotLinePathStroke: $2fb96651e8aa1522$var$plotLinePathStroke, interpolatePoints: $2fb96651e8aa1522$var$interpolatePoints, pathFadeInAnimation: $2fb96651e8aa1522$var$pathFadeInAnimation, markerFadeInAnimation: $2fb96651e8aa1522$var$markerFadeInAnimation, fromToMotion: $2fb96651e8aa1522$var$fromToMotion, pathMotion: $2fb96651e8aa1522$var$pathMotion, extent: $2fb96651e8aa1522$var$extent, createDatumId: $2fb96651e8aa1522$var$createDatumId6, applyShapeFillBBox: $2fb96651e8aa1522$var$applyShapeFillBBox2, PointerEvents: $2fb96651e8aa1522$var$PointerEvents2, Group: $2fb96651e8aa1522$var$Group9, BBox: $2fb96651e8aa1522$var$BBox13, ContinuousScale: $2fb96651e8aa1522$var$ContinuousScale7, DiscreteTimeScale: $2fb96651e8aa1522$var$DiscreteTimeScale2, findMinMax: $2fb96651e8aa1522$var$findMinMax4, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle4, getShapeFill: $2fb96651e8aa1522$var$getShapeFill2, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle3 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RangeAreaSeriesNodeEvent = class extends (0, $iTJTu._ModuleSupport).SeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.xKey = series.properties.xKey;
        this.yLowKey = series.properties.yLowKey;
        this.yHighKey = series.properties.yHighKey;
    }
};
var $2fb96651e8aa1522$var$RangeAreaSeries = class extends (0, $iTJTu._ModuleSupport).CartesianSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            hasMarkers: true,
            pathsPerSeries: [
                "fill",
                "stroke"
            ],
            pickModes: [
                (0, $iTJTu._ModuleSupport).SeriesNodePickMode.AXIS_ALIGNED
            ],
            directionKeys: {
                [$2fb96651e8aa1522$var$ChartAxisDirection21.X]: [
                    "xKey"
                ],
                [$2fb96651e8aa1522$var$ChartAxisDirection21.Y]: [
                    "yLowKey",
                    "yHighKey"
                ]
            },
            directionNames: {
                [$2fb96651e8aa1522$var$ChartAxisDirection21.X]: [
                    "xName"
                ],
                [$2fb96651e8aa1522$var$ChartAxisDirection21.Y]: [
                    "yLowName",
                    "yHighName",
                    "yName"
                ]
            },
            categoryKey: "xValue",
            animationResetFns: {
                path: $2fb96651e8aa1522$var$buildResetPathFn({
                    getVisible: ()=>this.visible,
                    getOpacity: ()=>this.getOpacity()
                }),
                label: $2fb96651e8aa1522$var$resetLabelFn,
                marker: (node, datum)=>({
                        ...$2fb96651e8aa1522$var$resetMarkerFn(node),
                        ...$2fb96651e8aa1522$var$resetMarkerPositionFn(node, datum)
                    })
            },
            clipFocusBox: false
        });
        this.properties = new $2fb96651e8aa1522$var$RangeAreaProperties();
        this.NodeEvent = $2fb96651e8aa1522$var$RangeAreaSeriesNodeEvent;
        this.dataAggregationFilters = void 0;
    }
    async processData(dataController) {
        const { xKey: xKey, yLowKey: yLowKey, yHighKey: yHighKey } = this.properties;
        const xScale = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection21.X]?.scale;
        const yScale = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection21.Y]?.scale;
        const { xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
            xScale: xScale,
            yScale: yScale
        });
        const extraProps = [];
        const animationEnabled = !this.ctx.animationManager.isSkipped();
        if (!this.ctx.animationManager.isSkipped() && this.processedData) extraProps.push($2fb96651e8aa1522$var$diff3(this.id, this.processedData));
        if (animationEnabled) extraProps.push($2fb96651e8aa1522$var$animationValidation3());
        const { dataModel: dataModel, processedData: processedData } = await this.requestDataModel(dataController, this.data, {
            props: [
                $2fb96651e8aa1522$var$keyProperty4(xKey, xScaleType, {
                    id: `xValue`
                }),
                $2fb96651e8aa1522$var$valueProperty7(yLowKey, yScaleType, {
                    id: `yLowValue`
                }),
                $2fb96651e8aa1522$var$valueProperty7(yHighKey, yScaleType, {
                    id: `yHighValue`
                }),
                ...extraProps
            ]
        });
        this.dataAggregationFilters = this.aggregateData(dataModel, processedData);
        this.animationState.transition("updateData");
    }
    aggregateData(dataModel, processedData) {
        const xAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection21.X];
        if (xAxis == null || !($2fb96651e8aa1522$var$ContinuousScale7.is(xAxis.scale) || $2fb96651e8aa1522$var$DiscreteTimeScale2.is(xAxis.scale))) return;
        const xValues = dataModel.resolveKeysById(this, `xValue`, processedData);
        const yHighValues = dataModel.resolveColumnById(this, `yHighValue`, processedData);
        const yLowValues = dataModel.resolveColumnById(this, `yLowValue`, processedData);
        const { index: index } = dataModel.resolveProcessedDataDefById(this, `xValue`);
        const domain = processedData.domain.keys[index];
        return $2fb96651e8aa1522$var$aggregateData(xValues, yHighValues, yLowValues, domain);
    }
    xCoordinateRange(xValue2) {
        const x = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection21.X].scale.convert(xValue2);
        return [
            x,
            x
        ];
    }
    yCoordinateRange(yValues) {
        const y = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection21.Y].scale.convert(yValues[0]);
        return [
            y,
            y
        ];
    }
    getSeriesDomain(direction) {
        const { processedData: processedData, dataModel: dataModel } = this;
        if (!(processedData && dataModel)) return [];
        const { domain: { keys: [keys] } } = processedData;
        if (direction === $2fb96651e8aa1522$var$ChartAxisDirection21.X) {
            const keyDef = dataModel.resolveProcessedDataDefById(this, `xValue`);
            if (keyDef?.def.type === "key" && keyDef.def.valueType === "category") return keys;
            return $2fb96651e8aa1522$var$fixNumericExtent4($2fb96651e8aa1522$var$extent(keys));
        } else {
            const yExtent = this.domainForClippedRange($2fb96651e8aa1522$var$ChartAxisDirection21.Y, [
                "yHighValue",
                "yLowValue"
            ], "xValue", true);
            const fixedYExtent = $2fb96651e8aa1522$var$findMinMax4(yExtent);
            return $2fb96651e8aa1522$var$fixNumericExtent4(fixedYExtent);
        }
    }
    getSeriesRange(_direction, visibleRange) {
        return this.domainForVisibleRange($2fb96651e8aa1522$var$ChartAxisDirection21.Y, [
            "yHighValue",
            "yLowValue"
        ], "xValue", visibleRange, true);
    }
    createNodeData() {
        const { data: data, dataModel: dataModel, processedData: processedData, axes: axes } = this;
        const xAxis = axes[$2fb96651e8aa1522$var$ChartAxisDirection21.X];
        const yAxis = axes[$2fb96651e8aa1522$var$ChartAxisDirection21.Y];
        if (!(data && xAxis && yAxis && dataModel && processedData)) return;
        const xScale = xAxis.scale;
        const yScale = yAxis.scale;
        const { xKey: xKey, yLowKey: yLowKey, yHighKey: yHighKey, connectMissingData: connectMissingData, marker: marker, interpolation: interpolation } = this.properties;
        const rawData = processedData.dataSources.get(this.id) ?? [];
        const xOffset = (xScale.bandwidth ?? 0) / 2;
        const xValues = dataModel.resolveKeysById(this, "xValue", processedData);
        const yHighValues = dataModel.resolveColumnById(this, "yHighValue", processedData);
        const yLowValues = dataModel.resolveColumnById(this, "yLowValue", processedData);
        const xPosition = (index)=>xScale.convert(xValues[index]) + xOffset;
        const labelData = [];
        const markerData = [];
        const spanPoints = [];
        const handleDatumPoint = (datumIndex, yHighValue, yLowValue)=>{
            const datum = rawData[datumIndex];
            const xValue2 = xValues[datumIndex];
            if (xValue2 == null) return;
            const currentSpanPoints = spanPoints[spanPoints.length - 1];
            if (Number.isFinite(yHighValue) && Number.isFinite(yLowValue)) {
                const appendMarker = (id, yValue, y)=>{
                    markerData.push({
                        index: datumIndex,
                        series: this,
                        itemId: id,
                        datum: datum,
                        datumIndex: datumIndex,
                        midPoint: {
                            x: x,
                            y: y
                        },
                        yHighValue: yHighValue,
                        yLowValue: yLowValue,
                        xValue: xValue2,
                        xKey: xKey,
                        yLowKey: yLowKey,
                        yHighKey: yHighKey,
                        point: {
                            x: x,
                            y: y,
                            size: size
                        },
                        enabled: true
                    });
                    const highLabelDatum = this.createLabelData({
                        datumIndex: datumIndex,
                        point: {
                            x: x,
                            y: y
                        },
                        value: yValue,
                        yLowValue: yLowValue,
                        yHighValue: yHighValue,
                        itemId: id,
                        inverted: inverted,
                        datum: datum,
                        series: this
                    });
                    labelData.push(highLabelDatum);
                };
                const inverted = yLowValue > yHighValue;
                const x = xPosition(datumIndex);
                const yHighCoordinate = yScale.convert(yHighValue);
                const yLowCoordinate = yScale.convert(yLowValue);
                const { size: size } = marker;
                appendMarker("high", yHighValue, yHighCoordinate);
                appendMarker("low", yLowValue, yLowCoordinate);
                const spanPoint = {
                    high: {
                        point: {
                            x: x,
                            y: yHighCoordinate
                        },
                        xDatum: xValue2,
                        yDatum: yHighValue
                    },
                    low: {
                        point: {
                            x: x,
                            y: yLowCoordinate
                        },
                        xDatum: xValue2,
                        yDatum: yLowValue
                    }
                };
                if (Array.isArray(currentSpanPoints)) currentSpanPoints.push(spanPoint);
                else if (currentSpanPoints != null) {
                    currentSpanPoints.skip += 1;
                    spanPoints.push([
                        spanPoint
                    ]);
                } else spanPoints.push([
                    spanPoint
                ]);
            } else if (!connectMissingData) {
                if (Array.isArray(currentSpanPoints) || currentSpanPoints == null) spanPoints.push({
                    skip: 0
                });
                else currentSpanPoints.skip += 1;
            }
        };
        const { dataAggregationFilters: dataAggregationFilters } = this;
        const [r0, r1] = xScale.range;
        const range2 = r1 - r0;
        const dataAggregationFilter = dataAggregationFilters?.find((f)=>f.maxRange > range2);
        const topIndices = dataAggregationFilter?.topIndices;
        const bottomIndices = dataAggregationFilter?.bottomIndices;
        let [start, end] = this.visibleRange("xValue", xAxis.range, topIndices);
        start = Math.max(start - 1, 0);
        end = Math.min(end + 1, topIndices?.length ?? xValues.length);
        if (processedData.input.count < 1e3) {
            start = 0;
            end = processedData.input.count;
        }
        for(let i = start; i < end; i += 1){
            const topDatumIndex = topIndices?.[i] ?? i;
            const bottomDatumIndex = bottomIndices?.[i] ?? i;
            handleDatumPoint(topDatumIndex, yHighValues[topDatumIndex], yLowValues[bottomDatumIndex]);
        }
        const highSpans = spanPoints.flatMap((p)=>{
            if (!Array.isArray(p)) return [];
            const highPoints = p.map((d)=>d.high);
            return $2fb96651e8aa1522$var$interpolatePoints(highPoints, interpolation);
        });
        const lowSpans = spanPoints.flatMap((p)=>{
            if (!Array.isArray(p)) return [];
            const lowPoints = p.map((d)=>d.low);
            return $2fb96651e8aa1522$var$interpolatePoints(lowPoints, interpolation);
        });
        const context = {
            itemId: `${yLowKey}-${yHighKey}`,
            labelData: labelData,
            nodeData: markerData,
            fillData: {
                itemId: "high",
                spans: highSpans,
                phantomSpans: lowSpans
            },
            highStrokeData: {
                itemId: "high",
                spans: highSpans
            },
            lowStrokeData: {
                itemId: "low",
                spans: lowSpans
            },
            scales: this.calculateScaling(),
            visible: this.visible
        };
        return context;
    }
    createLabelData({ datumIndex: datumIndex, point: point, value: value, itemId: itemId, inverted: inverted, datum: datum, series: series }) {
        const { xKey: xKey, yLowKey: yLowKey, yHighKey: yHighKey, xName: xName, yName: yName, yLowName: yLowName, yHighName: yHighName, label: label } = this.properties;
        const { placement: placement, padding: padding = 10 } = label;
        let actualItemId = itemId;
        if (inverted) actualItemId = itemId === "low" ? "high" : "low";
        const direction = placement === "outside" && actualItemId === "high" || placement === "inside" && actualItemId === "low" ? -1 : 1;
        return {
            x: point.x,
            y: point.y + padding * direction,
            series: series,
            itemId: itemId,
            datum: datum,
            datumIndex: datumIndex,
            text: this.getLabelText(label, {
                value: value,
                datum: datum,
                itemId: itemId,
                xKey: xKey,
                yLowKey: yLowKey,
                yHighKey: yHighKey,
                xName: xName,
                yLowName: yLowName,
                yHighName: yHighName,
                yName: yName
            }),
            textAlign: "center",
            textBaseline: direction === -1 ? "bottom" : "top"
        };
    }
    isPathOrSelectionDirty() {
        return this.properties.marker.isDirty();
    }
    updatePathNodes(opts) {
        const { opacity: opacity, visible: visible } = opts;
        const [fill, stroke2] = opts.paths;
        const strokeWidth = this.getStrokeWidth(this.properties.strokeWidth);
        stroke2.setProperties({
            fill: void 0,
            lineCap: "round",
            lineJoin: "round",
            pointerEvents: $2fb96651e8aa1522$var$PointerEvents2.None,
            stroke: this.properties.stroke,
            strokeWidth: strokeWidth,
            strokeOpacity: this.properties.strokeOpacity,
            lineDash: this.properties.lineDash,
            lineDashOffset: this.properties.lineDashOffset,
            opacity: opacity,
            visible: visible
        });
        const seriesFill = $2fb96651e8aa1522$var$getShapeFill2(this.properties.fill, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
        const fillBBox = this.getShapeFillBBox();
        $2fb96651e8aa1522$var$applyShapeFillBBox2(fill, seriesFill, fillBBox);
        $2fb96651e8aa1522$var$applyShapeStyle3(fill, {
            stroke: void 0,
            fill: seriesFill,
            fillOpacity: this.properties.fillOpacity,
            lineDash: this.properties.lineDash,
            lineDashOffset: this.properties.lineDashOffset,
            strokeOpacity: this.properties.strokeOpacity,
            strokeWidth: strokeWidth
        }, void 0, fillBBox);
        fill.setProperties({
            pointerEvents: $2fb96651e8aa1522$var$PointerEvents2.None,
            lineJoin: "round",
            fillShadow: this.properties.shadow,
            opacity: opacity,
            visible: visible
        });
        $2fb96651e8aa1522$var$updateClipPath(this, stroke2);
        $2fb96651e8aa1522$var$updateClipPath(this, fill);
    }
    updatePaths(opts) {
        this.updateAreaPaths(opts.paths, opts.contextData);
    }
    updateAreaPaths(paths, contextData) {
        for (const path of paths)path.visible = contextData.visible;
        if (contextData.visible) {
            this.updateFillPath(paths, contextData);
            this.updateStrokePath(paths, contextData);
        } else for (const path of paths){
            path.path.clear();
            path.markDirty("RangeArea");
        }
    }
    updateFillPath(paths, contextData) {
        const [fill] = paths;
        fill.path.clear();
        $2fb96651e8aa1522$var$plotAreaPathFill(fill, contextData.fillData);
        fill.markDirty("RangeArea");
    }
    updateStrokePath(paths, contextData) {
        const [, stroke2] = paths;
        stroke2.path.clear();
        $2fb96651e8aa1522$var$plotLinePathStroke(stroke2, contextData.highStrokeData.spans);
        $2fb96651e8aa1522$var$plotLinePathStroke(stroke2, contextData.lowStrokeData.spans);
        stroke2.markDirty("RangeArea");
    }
    updateMarkerSelection(opts) {
        const { nodeData: nodeData, markerSelection: markerSelection } = opts;
        if (this.properties.marker.isDirty()) {
            markerSelection.clear();
            markerSelection.cleanup();
        }
        return markerSelection.update(this.properties.marker.enabled ? nodeData : []);
    }
    getMarkerItemBaseStyle(highlighted) {
        const { properties: properties } = this;
        const { marker: marker } = properties;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return {
            shape: marker.shape,
            size: marker.size,
            fill: highlightStyle?.fill ?? marker.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? marker.fillOpacity,
            stroke: highlightStyle?.stroke ?? marker.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(marker.strokeWidth),
            strokeOpacity: highlightStyle?.strokeOpacity ?? marker.strokeOpacity,
            lineDash: highlightStyle?.lineDash ?? marker.lineDash,
            lineDashOffset: highlightStyle?.lineDashOffset ?? marker.lineDashOffset
        };
    }
    getMarkerItemStyleOverrides(datumId, datum, format, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const { xKey: xKey, yHighKey: yHighKey, yLowKey: yLowKey, marker: marker } = properties;
        const { itemStyler: itemStyler } = marker;
        if (itemStyler == null) return;
        return this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId6(datumId, highlighted ? "highlight" : "node"), ()=>{
            return this.callWithContext(itemStyler, {
                seriesId: seriesId,
                datum: datum,
                xKey: xKey,
                yHighKey: yHighKey,
                yLowKey: yLowKey,
                highlighted: highlighted,
                ...format
            });
        });
    }
    updateMarkerNodes(opts) {
        const { markerSelection: markerSelection, isHighlight: highlighted } = opts;
        const { xKey: xKey, yLowKey: yLowKey, yHighKey: yHighKey, marker: marker, fill: fill, stroke: stroke2, strokeWidth: strokeWidth, fillOpacity: fillOpacity, strokeOpacity: strokeOpacity } = this.properties;
        const baseStyle = $2fb96651e8aa1522$var$mergeDefaults5(highlighted && this.properties.highlightStyle.item, marker.getStyle(), {
            fill: fill,
            fillOpacity: fillOpacity,
            stroke: stroke2,
            strokeWidth: strokeWidth,
            strokeOpacity: strokeOpacity
        });
        const fillBBox = this.getShapeFillBBox();
        markerSelection.each((node, datum)=>{
            this.updateMarkerStyle(marker, node, datum.datum, datum.point, {
                xKey: xKey,
                yHighKey: yHighKey,
                yLowKey: yLowKey
            }, highlighted, baseStyle, fillBBox);
        });
        if (!highlighted) this.properties.marker.markClean();
    }
    updateLabelSelection(opts) {
        const { labelData: labelData, labelSelection: labelSelection } = opts;
        return labelSelection.update(labelData, (text2)=>{
            text2.pointerEvents = $2fb96651e8aa1522$var$PointerEvents2.None;
        });
    }
    updateLabelNodes(opts) {
        opts.labelSelection.each((textNode, datum)=>{
            $2fb96651e8aa1522$var$updateLabelNode(textNode, this.properties.label, datum);
        });
    }
    getHighlightLabelData(labelData, highlightedItem) {
        const labelItems = labelData.filter((ld)=>ld.datum === highlightedItem.datum);
        return labelItems.length > 0 ? labelItems : void 0;
    }
    getHighlightData(nodeData, highlightedItem) {
        const highlightItems = nodeData.filter((nodeDatum)=>nodeDatum.datum === highlightedItem.datum);
        return highlightItems.length > 0 ? highlightItems : void 0;
    }
    getTooltipContent(datumIndex, removeThisDatum) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, axes: axes, properties: properties } = this;
        const { xName: xName, yName: yName, yLowKey: yLowKey, yLowName: yLowName, xKey: xKey, yHighKey: yHighKey, yHighName: yHighName, tooltip: tooltip } = properties;
        const xAxis = axes[$2fb96651e8aa1522$var$ChartAxisDirection21.X];
        const yAxis = axes[$2fb96651e8aa1522$var$ChartAxisDirection21.Y];
        if (!dataModel || !processedData || !xAxis || !yAxis) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const xValue2 = dataModel.resolveKeysById(this, `xValue`, processedData)[datumIndex];
        const yHighValue = dataModel.resolveColumnById(this, `yHighValue`, processedData)[datumIndex];
        const yLowValue = dataModel.resolveColumnById(this, `yLowValue`, processedData)[datumIndex];
        if (xValue2 == null) return;
        const format = this.getMarkerItemBaseStyle(false);
        Object.assign(format, this.getMarkerItemStyleOverrides(String(datumIndex), datumIndex, format, false));
        const value = `${yAxis.formatDatum(yLowValue)} - ${yAxis.formatDatum(yHighValue)}`;
        return this.formatTooltipWithContext(tooltip, {
            heading: xAxis.formatDatum(xValue2),
            symbol: this.legendItemSymbol(),
            data: [
                {
                    label: yName,
                    fallbackLabel: `${yLowName ?? yLowKey} - ${yHighName ?? yHighKey}`,
                    value: value
                }
            ]
        }, {
            seriesId: seriesId,
            datum: datum,
            title: yName,
            itemId: removeThisDatum?.itemId ?? "unknown",
            xName: xName,
            yName: yName,
            yLowKey: yLowKey,
            yLowName: yLowName,
            xKey: xKey,
            yHighKey: yHighKey,
            yHighName: yHighName,
            ...format
        });
    }
    legendItemSymbol() {
        const { fill: fill, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, marker: marker } = this.properties;
        const markerStyle = $2fb96651e8aa1522$var$getShapeStyle4({
            shape: marker.shape,
            fill: marker.fill ?? fill,
            stroke: marker.stroke ?? stroke2,
            fillOpacity: marker.fillOpacity,
            strokeOpacity: marker.strokeOpacity,
            strokeWidth: marker.strokeWidth,
            lineDash: marker.lineDash,
            lineDashOffset: marker.lineDashOffset
        }, marker.fillGradientDefaults, marker.fillPatternDefaults, marker.fillImageDefaults);
        return {
            marker: markerStyle,
            line: {
                stroke: stroke2,
                strokeOpacity: strokeOpacity,
                strokeWidth: strokeWidth,
                lineDash: lineDash
            }
        };
    }
    getLegendData(legendType) {
        if (legendType !== "category") return [];
        const { id: seriesId, visible: visible } = this;
        const { yLowKey: yLowKey, yHighKey: yHighKey, yName: yName, yLowName: yLowName, yHighName: yHighName, showInLegend: showInLegend } = this.properties;
        const legendItemText = yName ?? `${yLowName ?? yLowKey} - ${yHighName ?? yHighKey}`;
        const itemId = `${yLowKey}-${yHighKey}`;
        return [
            {
                legendType: "category",
                id: seriesId,
                itemId: itemId,
                seriesId: seriesId,
                enabled: visible,
                label: {
                    text: `${legendItemText}`
                },
                symbol: this.legendItemSymbol(),
                hideInLegend: !showInLegend
            }
        ];
    }
    isLabelEnabled() {
        return this.properties.label.enabled;
    }
    onDataChange() {}
    nodeFactory() {
        return new $2fb96651e8aa1522$var$Group9();
    }
    animateEmptyUpdateReady(animationData) {
        const { markerSelection: markerSelection, labelSelection: labelSelection, contextData: contextData, paths: paths } = animationData;
        const { animationManager: animationManager } = this.ctx;
        this.updateAreaPaths(paths, contextData);
        $2fb96651e8aa1522$var$pathSwipeInAnimation(this, animationManager, ...paths);
        $2fb96651e8aa1522$var$resetMotion([
            markerSelection
        ], $2fb96651e8aa1522$var$resetMarkerPositionFn);
        $2fb96651e8aa1522$var$markerSwipeScaleInAnimation(this, animationManager, markerSelection);
        $2fb96651e8aa1522$var$seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelection);
    }
    animateReadyResize(animationData) {
        const { contextData: contextData, paths: paths } = animationData;
        this.updateAreaPaths(paths, contextData);
        super.animateReadyResize(animationData);
    }
    animateWaitingUpdateReady(animationData) {
        const { animationManager: animationManager } = this.ctx;
        const { markerSelection: markerSelection, labelSelection: labelSelection, contextData: contextData, paths: paths, previousContextData: previousContextData } = animationData;
        const [fill, stroke2] = paths;
        if (fill == null && stroke2 == null) return;
        this.resetMarkerAnimation(animationData);
        this.resetLabelAnimation(animationData);
        const update = ()=>{
            this.resetPathAnimation(animationData);
            this.updateAreaPaths(paths, contextData);
        };
        const skip = ()=>{
            animationManager.skipCurrentBatch();
            update();
        };
        if (contextData == null || previousContextData == null) {
            update();
            $2fb96651e8aa1522$var$markerFadeInAnimation(this, animationManager, "added", markerSelection);
            $2fb96651e8aa1522$var$pathFadeInAnimation(this, "fill_path_properties", animationManager, "add", fill);
            $2fb96651e8aa1522$var$pathFadeInAnimation(this, "stroke_path_properties", animationManager, "add", stroke2);
            $2fb96651e8aa1522$var$seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelection);
            return;
        }
        const fns = $2fb96651e8aa1522$var$prepareRangeAreaPathAnimation(contextData, previousContextData, this.processedData?.reduced?.diff?.[this.id]);
        if (fns === void 0) {
            skip();
            return;
        } else if (fns.status === "no-op") return;
        $2fb96651e8aa1522$var$fromToMotion(this.id, "fill_path_properties", animationManager, [
            fill
        ], fns.fill.pathProperties);
        $2fb96651e8aa1522$var$fromToMotion(this.id, "stroke_path_properties", animationManager, [
            stroke2
        ], fns.stroke.pathProperties);
        if (fns.status === "added") this.updateAreaPaths(paths, contextData);
        else if (fns.status === "removed") this.updateAreaPaths(paths, previousContextData);
        else {
            $2fb96651e8aa1522$var$pathMotion(this.id, "fill_path_update", animationManager, [
                fill
            ], fns.fill.path);
            $2fb96651e8aa1522$var$pathMotion(this.id, "stroke_path_update", animationManager, [
                stroke2
            ], fns.stroke.path);
        }
        if (fns.hasMotion) {
            $2fb96651e8aa1522$var$markerFadeInAnimation(this, animationManager, void 0, markerSelection);
            $2fb96651e8aa1522$var$seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelection);
        }
        this.ctx.animationManager.animate({
            id: this.id,
            groupId: "reset_after_animation",
            phase: "trailing",
            from: {},
            to: {},
            onComplete: ()=>this.updateAreaPaths(paths, contextData)
        });
    }
    getFormattedMarkerStyle(datum) {
        const { xKey: xKey, yLowKey: yLowKey, yHighKey: yHighKey } = this.properties;
        return this.getMarkerStyle(this.properties.marker, datum.datum, {
            xKey: xKey,
            yLowKey: yLowKey,
            yHighKey: yHighKey
        }, true);
    }
    computeFocusBounds(opts) {
        const hiBox = $2fb96651e8aa1522$var$computeMarkerFocusBounds(this, opts);
        const loBox = $2fb96651e8aa1522$var$computeMarkerFocusBounds(this, {
            ...opts,
            datumIndex: opts.datumIndex + 1
        });
        if (hiBox && loBox) return $2fb96651e8aa1522$var$BBox13.merge([
            hiBox,
            loBox
        ]);
        return void 0;
    }
    isDatumEnabled(nodeData, datumIndex) {
        return datumIndex % 2 === 0 && super.isDatumEnabled(nodeData, datumIndex);
    }
};
$2fb96651e8aa1522$var$RangeAreaSeries.className = "RangeAreaSeries";
$2fb96651e8aa1522$var$RangeAreaSeries.type = "range-area";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs5, rangeAreaSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$rangeAreaSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$rangeAreaSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$rangeAreaSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs5,
    type: (0, $idDdm.required)((0, $idDdm.constant)("range-area")),
    xKey: (0, $idDdm.required)((0, $idDdm.string)),
    yLowKey: (0, $idDdm.required)((0, $idDdm.string)),
    yHighKey: (0, $idDdm.required)((0, $idDdm.string)),
    xName: (0, $idDdm.string),
    yName: (0, $idDdm.string),
    yLowName: (0, $idDdm.string),
    yHighName: (0, $idDdm.string)
};
$2fb96651e8aa1522$var$rangeAreaSeriesOptionsDef.pickOutsideVisibleMinorAxis = (0, $idDdm.undocumented)((0, $idDdm.boolean));
$2fb96651e8aa1522$var$rangeAreaSeriesOptionsDef.focusPriority = (0, $idDdm.undocumented)((0, $idDdm.number));
var $2fb96651e8aa1522$var$RANGE_AREA_SERIES_THEME = {
    series: {
        fill: {
            $palette: "fill"
        },
        fillGradientDefaults: {
            type: "gradient",
            gradient: "linear",
            bounds: "item",
            colorStops: {
                $palette: "gradient"
            },
            rotation: 0,
            reverse: false
        },
        fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
        stroke: {
            $palette: "stroke"
        },
        fillOpacity: 0.7,
        nodeClickRange: "nearest",
        marker: {
            enabled: false,
            fill: {
                $palette: "fill"
            },
            stroke: {
                $palette: "stroke"
            },
            // @ts-expect-error undocumented option
            fillGradientDefaults: {
                type: "gradient",
                gradient: "radial",
                bounds: "item",
                colorStops: {
                    $palette: "gradient"
                },
                rotation: 0,
                reverse: true
            },
            fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
            fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
            size: 6,
            strokeWidth: 2
        },
        label: {
            enabled: false,
            placement: "outside",
            padding: 10,
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            fontWeight: {
                $ref: "fontWeight"
            },
            color: {
                $ref: "textColor"
            }
        },
        interpolation: {
            type: "linear"
        }
    },
    axes: {
        [(0, $iTJTu._ModuleSupport).ThemeConstants.CARTESIAN_AXIS_TYPE.NUMBER]: {
            crosshair: {
                enabled: true
            }
        }
    }
};
// packages/ag-charts-enterprise/src/series/range-area/rangeAreaModule.ts
var { ThemeConstants: { CARTESIAN_AXIS_TYPE: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE6, CARTESIAN_POSITION: $2fb96651e8aa1522$var$CARTESIAN_POSITION4 } } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RangeAreaModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    identifier: "range-area",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$RangeAreaSeries(ctx),
    tooltipDefaults: {
        range: "nearest"
    },
    defaultAxes: [
        {
            type: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE6.NUMBER,
            position: $2fb96651e8aa1522$var$CARTESIAN_POSITION4.LEFT
        },
        {
            type: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE6.CATEGORY,
            position: $2fb96651e8aa1522$var$CARTESIAN_POSITION4.BOTTOM
        }
    ],
    themeTemplate: $2fb96651e8aa1522$var$RANGE_AREA_SERIES_THEME
};
var $2fb96651e8aa1522$var$RangeAreaSeriesModule = {
    type: "series",
    name: "range-area",
    chartType: "cartesian",
    enterprise: true,
    options: $2fb96651e8aa1522$var$rangeAreaSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$RangeAreaSeries(ctx)
};
// packages/ag-charts-enterprise/src/series/range-bar/rangeBarAggregation.ts
var $2fb96651e8aa1522$var$AGGREGATION_THRESHOLD3 = 1e3;
var $2fb96651e8aa1522$var$PRECISION = 5;
function $2fb96651e8aa1522$var$aggregateRangeBarData(xValues, highValues, lowValues, domain) {
    if (xValues.length < $2fb96651e8aa1522$var$AGGREGATION_THRESHOLD3) return;
    const [d0, d1] = $2fb96651e8aa1522$var$aggregationDomain(domain);
    let maxRange = $2fb96651e8aa1522$var$maxRangeFittingPoints(xValues, $2fb96651e8aa1522$var$PRECISION);
    let { indexData: indexData, valueData: valueData } = $2fb96651e8aa1522$var$createAggregationIndices(xValues, highValues, lowValues, d0, d1, maxRange);
    const filters = [
        {
            maxRange: maxRange,
            indexData: indexData
        }
    ];
    while(maxRange > 64){
        ({ indexData: indexData, valueData: valueData, maxRange: maxRange } = $2fb96651e8aa1522$var$compactAggregationIndices(indexData, valueData, maxRange));
        filters.push({
            maxRange: maxRange,
            indexData: indexData
        });
    }
    filters.reverse();
    return filters;
}
var { AbstractBarSeriesProperties: $2fb96651e8aa1522$var$AbstractBarSeriesProperties3, FillGradientDefaults: $2fb96651e8aa1522$var$FillGradientDefaults4, FillPatternDefaults: $2fb96651e8aa1522$var$FillPatternDefaults4, FillImageDefaults: $2fb96651e8aa1522$var$FillImageDefaults4, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip6, Property: $2fb96651e8aa1522$var$Property63, DropShadow: $2fb96651e8aa1522$var$DropShadow2, Label: $2fb96651e8aa1522$var$Label4 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RangeBarSeriesLabel = class extends $2fb96651e8aa1522$var$Label4 {
    constructor(){
        super(...arguments);
        this.placement = "inside";
        this.padding = 6;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarSeriesLabel.prototype, "placement", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarSeriesLabel.prototype, "padding", 2);
var $2fb96651e8aa1522$var$RangeBarProperties = class extends $2fb96651e8aa1522$var$AbstractBarSeriesProperties3 {
    constructor(){
        super(...arguments);
        this.fill = "#99CCFF";
        this.fillGradientDefaults = new $2fb96651e8aa1522$var$FillGradientDefaults4();
        this.fillPatternDefaults = new $2fb96651e8aa1522$var$FillPatternDefaults4();
        this.fillImageDefaults = new $2fb96651e8aa1522$var$FillImageDefaults4();
        this.fillOpacity = 1;
        this.stroke = "#99CCFF";
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.cornerRadius = 0;
        this.shadow = new $2fb96651e8aa1522$var$DropShadow2().set({
            enabled: false
        });
        this.label = new $2fb96651e8aa1522$var$RangeBarSeriesLabel();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip6();
        this.fastDataProcessing = false;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "xKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "yLowKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "yHighKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "xName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "yName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "yLowName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "yHighName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "fillGradientDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "fillPatternDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "fillImageDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "cornerRadius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "itemStyler", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "shadow", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "tooltip", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property63
], $2fb96651e8aa1522$var$RangeBarProperties.prototype, "fastDataProcessing", 2);
// packages/ag-charts-enterprise/src/series/range-bar/rangeBarSeries.ts
var { SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode4, valueProperty: $2fb96651e8aa1522$var$valueProperty8, keyProperty: $2fb96651e8aa1522$var$keyProperty5, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection22, checkCrisp: $2fb96651e8aa1522$var$checkCrisp, updateLabelNode: $2fb96651e8aa1522$var$updateLabelNode2, SMALLEST_KEY_INTERVAL: $2fb96651e8aa1522$var$SMALLEST_KEY_INTERVAL3, LARGEST_KEY_INTERVAL: $2fb96651e8aa1522$var$LARGEST_KEY_INTERVAL, diff: $2fb96651e8aa1522$var$diff4, prepareBarAnimationFunctions: $2fb96651e8aa1522$var$prepareBarAnimationFunctions, midpointStartingBarPosition: $2fb96651e8aa1522$var$midpointStartingBarPosition, resetBarSelectionsFn: $2fb96651e8aa1522$var$resetBarSelectionsFn, fixNumericExtent: $2fb96651e8aa1522$var$fixNumericExtent5, seriesLabelFadeInAnimation: $2fb96651e8aa1522$var$seriesLabelFadeInAnimation2, resetLabelFn: $2fb96651e8aa1522$var$resetLabelFn2, animationValidation: $2fb96651e8aa1522$var$animationValidation4, computeBarFocusBounds: $2fb96651e8aa1522$var$computeBarFocusBounds4, visibleRangeIndices: $2fb96651e8aa1522$var$visibleRangeIndices2, createDatumId: $2fb96651e8aa1522$var$createDatumId7, ContinuousScale: $2fb96651e8aa1522$var$ContinuousScale8, DiscreteTimeScale: $2fb96651e8aa1522$var$DiscreteTimeScale3, Rect: $2fb96651e8aa1522$var$Rect5, PointerEvents: $2fb96651e8aa1522$var$PointerEvents3, motion: $2fb96651e8aa1522$var$motion2, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle4, findMinMax: $2fb96651e8aa1522$var$findMinMax5, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle5, areScalingEqual: $2fb96651e8aa1522$var$areScalingEqual2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RangeBarSeriesNodeEvent = class extends (0, $iTJTu._ModuleSupport).SeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.xKey = series.properties.xKey;
        this.yLowKey = series.properties.yLowKey;
        this.yHighKey = series.properties.yHighKey;
    }
};
var $2fb96651e8aa1522$var$RangeBarSeries = class extends (0, $iTJTu._ModuleSupport).AbstractBarSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode4.AXIS_ALIGNED,
                $2fb96651e8aa1522$var$SeriesNodePickMode4.EXACT_SHAPE_MATCH
            ],
            hasHighlightedLabels: true,
            directionKeys: {
                x: [
                    "xKey"
                ],
                y: [
                    "yLowKey",
                    "yHighKey"
                ]
            },
            directionNames: {
                x: [
                    "xName"
                ],
                y: [
                    "yLowName",
                    "yHighName",
                    "yName"
                ]
            },
            categoryKey: "xValue",
            datumSelectionGarbageCollection: false,
            animationResetFns: {
                datum: $2fb96651e8aa1522$var$resetBarSelectionsFn,
                label: $2fb96651e8aa1522$var$resetLabelFn2
            }
        });
        this.properties = new $2fb96651e8aa1522$var$RangeBarProperties();
        this.dataAggregationFilters = void 0;
        this.NodeEvent = $2fb96651e8aa1522$var$RangeBarSeriesNodeEvent;
    }
    async processData(dataController) {
        const { xKey: xKey, yLowKey: yLowKey, yHighKey: yHighKey, fastDataProcessing: fastDataProcessing } = this.properties;
        const grouped = !fastDataProcessing;
        const xScale = this.getCategoryAxis()?.scale;
        const yScale = this.getValueAxis()?.scale;
        const { isContinuousX: isContinuousX, xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
            xScale: xScale,
            yScale: yScale
        });
        const extraProps = [];
        if (!this.ctx.animationManager.isSkipped()) {
            if (this.processedData) extraProps.push($2fb96651e8aa1522$var$diff4(this.id, this.processedData));
            extraProps.push($2fb96651e8aa1522$var$animationValidation4());
        }
        const visibleProps = this.visible ? {} : {
            forceValue: 0
        };
        const { dataModel: dataModel, processedData: processedData } = await this.requestDataModel(dataController, this.data, {
            props: [
                $2fb96651e8aa1522$var$keyProperty5(xKey, xScaleType, {
                    id: "xValue"
                }),
                $2fb96651e8aa1522$var$valueProperty8(yLowKey, yScaleType, {
                    id: `yLowValue`,
                    invalidValue: null,
                    ...visibleProps
                }),
                $2fb96651e8aa1522$var$valueProperty8(yHighKey, yScaleType, {
                    id: `yHighValue`,
                    invalidValue: null,
                    ...visibleProps
                }),
                ...isContinuousX ? [
                    $2fb96651e8aa1522$var$SMALLEST_KEY_INTERVAL3,
                    $2fb96651e8aa1522$var$LARGEST_KEY_INTERVAL
                ] : [],
                ...extraProps
            ],
            groupByKeys: grouped
        });
        this.smallestDataInterval = processedData.reduced?.smallestKeyInterval;
        this.largestDataInterval = processedData.reduced?.largestKeyInterval;
        this.dataAggregationFilters = this.aggregateData(dataModel, processedData);
        this.animationState.transition("updateData");
    }
    aggregateData(dataModel, processedData) {
        if (processedData.type !== "grouped") return;
        const xAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection22.X];
        if (xAxis == null || !($2fb96651e8aa1522$var$ContinuousScale8.is(xAxis.scale) || $2fb96651e8aa1522$var$DiscreteTimeScale3.is(xAxis.scale))) return;
        const xValues = dataModel.resolveKeysById(this, `xValue`, processedData);
        const yHighValues = dataModel.resolveColumnById(this, `yHighValue`, processedData);
        const yLowValues = dataModel.resolveColumnById(this, `yLowValue`, processedData);
        const { index: index } = dataModel.resolveProcessedDataDefById(this, `xValue`);
        const domain = processedData.domain.keys[index];
        return $2fb96651e8aa1522$var$aggregateRangeBarData(xValues, yHighValues, yLowValues, domain);
    }
    getSeriesDomain(direction) {
        const { processedData: processedData, dataModel: dataModel } = this;
        if (!processedData || !dataModel) return [];
        const { keys: [keys] } = processedData.domain;
        if (direction === this.getCategoryDirection()) {
            const keyDef = dataModel.resolveProcessedDataDefById(this, `xValue`);
            if (keyDef?.def.type === "key" && keyDef?.def.valueType === "category") return keys;
            return this.padBandExtent(keys);
        } else {
            const yExtent = this.domainForClippedRange(direction, [
                "yHighValue",
                "yLowValue"
            ], "xValue", true);
            const fixedYExtent = $2fb96651e8aa1522$var$findMinMax5(yExtent);
            return $2fb96651e8aa1522$var$fixNumericExtent5(fixedYExtent);
        }
    }
    getSeriesRange(_direction, visibleRange) {
        return this.domainForVisibleRange($2fb96651e8aa1522$var$ChartAxisDirection22.Y, [
            "yHighValue",
            "yLowValue"
        ], "xValue", visibleRange, true);
    }
    createNodeData() {
        const { data: data, dataModel: dataModel, groupScale: groupScale, processedData: processedData, visible: visible } = this;
        const xAxis = this.getCategoryAxis();
        const yAxis = this.getValueAxis();
        if (!(data && xAxis && yAxis && dataModel && processedData?.dataSources)) return;
        const xScale = xAxis.scale;
        const yScale = yAxis.scale;
        const barAlongX = this.getBarDirection() === $2fb96651e8aa1522$var$ChartAxisDirection22.X;
        const { xKey: xKey, yLowKey: yLowKey, yHighKey: yHighKey, strokeWidth: strokeWidth } = this.properties;
        const itemId = `${yLowKey}-${yHighKey}`;
        const context = {
            itemId: itemId,
            nodeData: [],
            labelData: [],
            scales: this.calculateScaling(),
            groupScale: this.getScaling(this.groupScale),
            visible: this.visible
        };
        if (!visible) return context;
        const rawData = processedData.dataSources.get(this.id) ?? [];
        const xValues = dataModel.resolveKeysById(this, `xValue`, processedData);
        const yLowValues = dataModel.resolveColumnById(this, `yLowValue`, processedData);
        const yHighValues = dataModel.resolveColumnById(this, `yHighValue`, processedData);
        const { barWidth: effectiveBarWidth, groupIndex: groupIndex } = this.updateGroupScale(xAxis);
        const barOffset = $2fb96651e8aa1522$var$ContinuousScale8.is(xScale) ? effectiveBarWidth * -0.5 : 0;
        const groupOffset = groupScale.convert(String(groupIndex));
        const defaultCrisp = $2fb96651e8aa1522$var$checkCrisp(xAxis?.scale, xAxis?.visibleRange, this.smallestDataInterval, this.largestDataInterval);
        const xPosition = (datumIndex)=>Math.round(xScale.convert(xValues[datumIndex])) + groupOffset + barOffset;
        const handleDatum = (datumIndex, groupedDataIndex, x, width, yLow, yHigh, crisp)=>{
            const datum = rawData[datumIndex];
            const xDatum = xValues[datumIndex];
            if (xDatum == null) return;
            const rawLowValue = yLowValues[datumIndex];
            const rawHighValue = yHighValues[datumIndex];
            if (!Number.isFinite(rawLowValue?.valueOf()) || !Number.isFinite(rawHighValue?.valueOf())) return;
            const [yLowValue, yHighValue] = rawLowValue < rawHighValue ? [
                rawLowValue,
                rawHighValue
            ] : [
                rawHighValue,
                rawLowValue
            ];
            const y = Math.round(yScale.convert(yHigh));
            const bottomY = Math.round(yScale.convert(yLow));
            const height = Math.max(strokeWidth, Math.abs(bottomY - y));
            const rect = {
                x: barAlongX ? Math.min(y, bottomY) : x,
                y: barAlongX ? x : Math.min(y, bottomY),
                width: barAlongX ? height : width,
                height: barAlongX ? width : height
            };
            const nodeMidPoint = {
                x: rect.x + rect.width / 2,
                y: rect.y + rect.height / 2
            };
            const labelData = this.createLabelData({
                datumIndex: datumIndex,
                rect: rect,
                barAlongX: barAlongX,
                yLowValue: yLowValue,
                yHighValue: yHighValue,
                datum: datum,
                series: this
            });
            const nodeDatum = {
                index: groupedDataIndex,
                valueIndex: datumIndex,
                series: this,
                itemId: itemId,
                datum: datum,
                datumIndex: datumIndex,
                xValue: xDatum,
                yLowValue: rawLowValue,
                yHighValue: rawHighValue,
                yLowKey: yLowKey,
                yHighKey: yHighKey,
                xKey: xKey,
                x: rect.x,
                y: rect.y,
                width: rect.width,
                height: rect.height,
                midPoint: nodeMidPoint,
                crisp: crisp,
                labels: labelData
            };
            context.nodeData.push(nodeDatum);
            context.labelData.push(...labelData);
        };
        const { dataAggregationFilters: dataAggregationFilters } = this;
        const [r0, r1] = xScale.range;
        const range2 = r1 - r0;
        const dataAggregationFilter = dataAggregationFilters?.find((f)=>f.maxRange > range2);
        if (dataAggregationFilter != null) {
            const { maxRange: maxRange, indexData: indexData } = dataAggregationFilter;
            const [start, end] = $2fb96651e8aa1522$var$visibleRangeIndices2(maxRange, xAxis.range, (index)=>{
                const aggIndex = index * $2fb96651e8aa1522$var$SPAN;
                const xMinIndex = indexData[aggIndex + $2fb96651e8aa1522$var$X_MIN];
                const xMaxIndex = indexData[aggIndex + $2fb96651e8aa1522$var$X_MAX];
                if (xMinIndex === -1) return;
                const midDatumIndex = (xMinIndex + xMaxIndex) / 2 | 0;
                return [
                    xPosition(midDatumIndex),
                    xPosition(xMaxIndex) + effectiveBarWidth
                ];
            });
            for(let i = start; i < end; i += 1){
                const aggIndex = i * $2fb96651e8aa1522$var$SPAN;
                const xMinIndex = indexData[aggIndex + $2fb96651e8aa1522$var$X_MIN];
                const xMaxIndex = indexData[aggIndex + $2fb96651e8aa1522$var$X_MAX];
                const yMinIndex = indexData[aggIndex + $2fb96651e8aa1522$var$Y_MIN];
                const yMaxIndex = indexData[aggIndex + $2fb96651e8aa1522$var$Y_MAX];
                if (xMinIndex === -1) continue;
                const midDatumIndex = (xMinIndex + xMaxIndex) / 2 | 0;
                const xValue2 = xValues[midDatumIndex];
                if (xValue2 == null) continue;
                const x = xPosition(midDatumIndex);
                const width = Math.abs(xPosition(xMinIndex) - xPosition(xMaxIndex)) + effectiveBarWidth;
                const yLow = yLowValues[yMinIndex];
                const yHigh = yHighValues[yMaxIndex];
                handleDatum(midDatumIndex, 0, x, width, yLow, yHigh, false);
            }
        } else if (processedData.type === "ungrouped") {
            let [start, end] = $2fb96651e8aa1522$var$visibleRangeIndices2(rawData.length, xAxis.range, (index)=>{
                const x = xPosition(index);
                return [
                    x,
                    effectiveBarWidth
                ];
            });
            if (processedData.input.count < 1e3) {
                start = 0;
                end = processedData.input.count;
            }
            for(let datumIndex = start; datumIndex < end; datumIndex += 1){
                const x = xPosition(datumIndex);
                const width = effectiveBarWidth;
                const yLow = yLowValues[datumIndex];
                const yHigh = yHighValues[datumIndex];
                handleDatum(datumIndex, 0, x, width, yLow, yHigh, defaultCrisp);
            }
        } else for (const { datumIndex: datumIndex, groupIndex: groupDataIndex } of dataModel.forEachGroupDatum(this, processedData)){
            const x = xPosition(datumIndex);
            const width = effectiveBarWidth;
            const yLow = yLowValues[datumIndex];
            const yHigh = yHighValues[datumIndex];
            handleDatum(datumIndex, groupDataIndex, x, width, yLow, yHigh, defaultCrisp);
        }
        return context;
    }
    createLabelData({ datumIndex: datumIndex, rect: rect, barAlongX: barAlongX, yLowValue: yLowValue, yHighValue: yHighValue, datum: datum, series: series }) {
        const { xKey: xKey, yLowKey: yLowKey, yHighKey: yHighKey, xName: xName, yLowName: yLowName, yHighName: yHighName, yName: yName, label: label } = this.properties;
        const labelParams = {
            datum: datum,
            xKey: xKey,
            yLowKey: yLowKey,
            yHighKey: yHighKey,
            xName: xName,
            yLowName: yLowName,
            yHighName: yHighName,
            yName: yName
        };
        const { placement: placement, padding: padding } = label;
        const paddingDirection = placement === "outside" ? 1 : -1;
        const labelPadding = padding * paddingDirection;
        const yLowLabel = {
            datumIndex: datumIndex,
            x: rect.x + (barAlongX ? -labelPadding : rect.width / 2),
            y: rect.y + (barAlongX ? rect.height / 2 : rect.height + labelPadding),
            textAlign: barAlongX ? "left" : "center",
            textBaseline: barAlongX ? "middle" : "bottom",
            text: this.getLabelText(label, {
                itemId: "low",
                value: yLowValue,
                ...labelParams
            }),
            itemId: "low",
            datum: datum,
            series: series
        };
        const yHighLabel = {
            datumIndex: datumIndex,
            x: rect.x + (barAlongX ? rect.width + labelPadding : rect.width / 2),
            y: rect.y + (barAlongX ? rect.height / 2 : -labelPadding),
            textAlign: barAlongX ? "right" : "center",
            textBaseline: barAlongX ? "middle" : "top",
            text: this.getLabelText(label, {
                itemId: "high",
                value: yHighValue,
                ...labelParams
            }),
            itemId: "high",
            datum: datum,
            series: series
        };
        if (placement === "outside") {
            yLowLabel.textAlign = barAlongX ? "right" : "center";
            yLowLabel.textBaseline = barAlongX ? "middle" : "top";
            yHighLabel.textAlign = barAlongX ? "left" : "center";
            yHighLabel.textBaseline = barAlongX ? "middle" : "bottom";
        }
        return [
            yLowLabel,
            yHighLabel
        ];
    }
    nodeFactory() {
        return new $2fb96651e8aa1522$var$Rect5();
    }
    updateDatumSelection(opts) {
        const { nodeData: nodeData, datumSelection: datumSelection } = opts;
        const data = nodeData ?? [];
        return datumSelection.update(data, void 0, (datum)=>this.getDatumId(datum));
    }
    getItemBaseStyle(highlighted) {
        const { properties: properties } = this;
        const { cornerRadius: cornerRadius, fillGradientDefaults: fillGradientDefaults4, fillPatternDefaults: fillPatternDefaults4, fillImageDefaults: fillImageDefaults4 } = properties;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return $2fb96651e8aa1522$var$getShapeStyle5({
            fill: highlightStyle?.fill ?? properties.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? properties.fillOpacity,
            stroke: highlightStyle?.stroke ?? properties.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(properties.strokeWidth),
            strokeOpacity: highlightStyle?.strokeOpacity ?? properties.strokeOpacity,
            lineDash: highlightStyle?.lineDash ?? properties.lineDash ?? [],
            lineDashOffset: highlightStyle?.lineDashOffset ?? properties.lineDashOffset,
            cornerRadius: cornerRadius
        }, fillGradientDefaults4, fillPatternDefaults4, fillImageDefaults4);
    }
    getItemStyleOverrides(datumId, datum, format, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const { xKey: xKey, yHighKey: yHighKey, yLowKey: yLowKey, itemStyler: itemStyler, fillGradientDefaults: fillGradientDefaults4, fillPatternDefaults: fillPatternDefaults4, fillImageDefaults: fillImageDefaults4 } = properties;
        if (itemStyler == null) return;
        const overrides = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId7(datumId, highlighted ? "highlight" : "node"), ()=>{
            return this.callWithContext(itemStyler, {
                seriesId: seriesId,
                datum: datum,
                xKey: xKey,
                yHighKey: yHighKey,
                yLowKey: yLowKey,
                highlighted: highlighted,
                ...format
            });
        });
        return $2fb96651e8aa1522$var$getShapeStyle5(overrides, fillGradientDefaults4, fillPatternDefaults4, fillImageDefaults4);
    }
    updateDatumNodes(opts) {
        const { datumSelection: datumSelection, isHighlight: isHighlight } = opts;
        const categoryAlongX = this.getCategoryDirection() === $2fb96651e8aa1522$var$ChartAxisDirection22.X;
        const style = this.getItemBaseStyle(isHighlight);
        const fillBBox = this.getShapeFillBBox();
        datumSelection.each((rect, datum)=>{
            const overrides = this.getItemStyleOverrides(String(datum.datumIndex), datum.datum, style, isHighlight);
            $2fb96651e8aa1522$var$applyShapeStyle4(rect, style, overrides, fillBBox);
            rect.cornerRadius = overrides?.cornerRadius ?? style.cornerRadius;
            rect.visible = categoryAlongX ? datum.width > 0 : datum.height > 0;
            rect.crisp = datum.crisp;
        });
    }
    getHighlightLabelData(labelData, highlightedItem) {
        const labelItems = labelData.filter((ld)=>ld.datum === highlightedItem.datum);
        return labelItems.length > 0 ? labelItems : void 0;
    }
    updateLabelSelection(opts) {
        const labelData = this.properties.label.enabled ? opts.labelData : [];
        return opts.labelSelection.update(labelData, (text2)=>{
            text2.pointerEvents = $2fb96651e8aa1522$var$PointerEvents3.None;
        });
    }
    updateLabelNodes(opts) {
        opts.labelSelection.each((textNode, datum)=>{
            $2fb96651e8aa1522$var$updateLabelNode2(textNode, this.properties.label, datum);
        });
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, properties: properties } = this;
        const { xKey: xKey, xName: xName, yName: yName, yLowKey: yLowKey, yHighKey: yHighKey, yLowName: yLowName, yHighName: yHighName, tooltip: tooltip } = properties;
        const xAxis = this.getCategoryAxis();
        const yAxis = this.getValueAxis();
        if (!dataModel || !processedData || !xAxis || !yAxis) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const xValue2 = dataModel.resolveKeysById(this, `xValue`, processedData)[datumIndex];
        const yHighValue = dataModel.resolveColumnById(this, `yHighValue`, processedData)[datumIndex];
        const yLowValue = dataModel.resolveColumnById(this, `yLowValue`, processedData)[datumIndex];
        if (xValue2 == null) return;
        const format = this.getItemBaseStyle(false);
        Object.assign(format, this.getItemStyleOverrides(String(datumIndex), datum, format, false));
        const value = `${yAxis.formatDatum(yLowValue)} - ${yAxis.formatDatum(yHighValue)}`;
        return this.formatTooltipWithContext(tooltip, {
            heading: xAxis.formatDatum(xValue2),
            symbol: this.legendItemSymbol(),
            data: [
                {
                    label: yName,
                    fallbackLabel: `${yLowName ?? yLowKey} - ${yHighName ?? yHighKey}`,
                    value: value
                }
            ]
        }, {
            seriesId: seriesId,
            datum: datum,
            title: yName,
            xKey: xKey,
            xName: xName,
            yName: yName,
            yLowKey: yLowKey,
            yHighKey: yHighKey,
            yLowName: yLowName,
            yHighName: yHighName,
            ...format
        });
    }
    legendItemSymbol() {
        const { fill: fill, stroke: stroke2, strokeWidth: strokeWidth, fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, fillGradientDefaults: fillGradientDefaults4, fillPatternDefaults: fillPatternDefaults4, fillImageDefaults: fillImageDefaults4 } = this.properties;
        return {
            marker: $2fb96651e8aa1522$var$getShapeStyle5({
                fill: fill,
                stroke: stroke2,
                fillOpacity: fillOpacity,
                strokeOpacity: strokeOpacity,
                strokeWidth: strokeWidth,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset
            }, fillGradientDefaults4, fillPatternDefaults4, fillImageDefaults4)
        };
    }
    getLegendData(legendType) {
        if (legendType !== "category") return [];
        const { id: seriesId, visible: visible } = this;
        const { yName: yName, yLowName: yLowName, yHighName: yHighName, yLowKey: yLowKey, yHighKey: yHighKey, showInLegend: showInLegend } = this.properties;
        const legendItemText = yName ?? `${yLowName ?? yLowKey} - ${yHighName ?? yHighKey}`;
        const itemId = `${yLowKey}-${yHighKey}`;
        return [
            {
                legendType: "category",
                id: seriesId,
                itemId: itemId,
                seriesId: seriesId,
                enabled: visible,
                label: {
                    text: `${legendItemText}`
                },
                symbol: this.legendItemSymbol(),
                hideInLegend: !showInLegend
            }
        ];
    }
    animateEmptyUpdateReady({ datumSelection: datumSelection, labelSelection: labelSelection }) {
        const fns = $2fb96651e8aa1522$var$prepareBarAnimationFunctions($2fb96651e8aa1522$var$midpointStartingBarPosition(this.isVertical(), "normal"));
        $2fb96651e8aa1522$var$motion2.fromToMotion(this.id, "datums", this.ctx.animationManager, [
            datumSelection
        ], fns);
        $2fb96651e8aa1522$var$seriesLabelFadeInAnimation2(this, "labels", this.ctx.animationManager, labelSelection);
    }
    animateWaitingUpdateReady(data) {
        const { datumSelection: datumSelections, labelSelection: labelSelection, contextData: contextData, previousContextData: previousContextData } = data;
        const dataDiff = (0, $iTJTu._ModuleSupport).calculateDataDiff(this.id, datumSelections, this.getDatumId.bind(this), contextData, previousContextData, this.processedData);
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
        const mode = previousContextData == null ? "fade" : "normal";
        const fns = $2fb96651e8aa1522$var$prepareBarAnimationFunctions($2fb96651e8aa1522$var$midpointStartingBarPosition(this.isVertical(), mode));
        $2fb96651e8aa1522$var$motion2.fromToMotion(this.id, "datums", this.ctx.animationManager, [
            datumSelections
        ], fns, (_, datum)=>this.getDatumId(datum), dataDiff);
        if (dataDiff?.changed || !$2fb96651e8aa1522$var$areScalingEqual2(contextData.groupScale, previousContextData?.groupScale)) $2fb96651e8aa1522$var$seriesLabelFadeInAnimation2(this, "labels", this.ctx.animationManager, labelSelection);
    }
    getDatumId(datum) {
        return `${datum.xValue}-${datum.valueIndex}`;
    }
    isLabelEnabled() {
        return this.properties.label.enabled;
    }
    onDataChange() {}
    computeFocusBounds({ datumIndex: datumIndex }) {
        return $2fb96651e8aa1522$var$computeBarFocusBounds4(this, this.contextNodeData?.nodeData[datumIndex]);
    }
};
$2fb96651e8aa1522$var$RangeBarSeries.className = "RangeBarSeries";
$2fb96651e8aa1522$var$RangeBarSeries.type = "range-bar";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs6, rangeBarSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$rangeBarSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$rangeBarSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$rangeBarSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs6,
    type: (0, $idDdm.required)((0, $idDdm.constant)("range-bar")),
    xKey: (0, $idDdm.required)((0, $idDdm.string)),
    yLowKey: (0, $idDdm.required)((0, $idDdm.string)),
    yHighKey: (0, $idDdm.required)((0, $idDdm.string)),
    xName: (0, $idDdm.string),
    yName: (0, $idDdm.string),
    yLowName: (0, $idDdm.string),
    yHighName: (0, $idDdm.string)
};
$2fb96651e8aa1522$var$rangeBarSeriesOptionsDef.pickOutsideVisibleMinorAxis = (0, $idDdm.undocumented)((0, $idDdm.boolean));
$2fb96651e8aa1522$var$rangeBarSeriesOptionsDef.fastDataProcessing = (0, $idDdm.undocumented)((0, $idDdm.boolean));
$2fb96651e8aa1522$var$rangeBarSeriesOptionsDef.focusPriority = (0, $idDdm.undocumented)((0, $idDdm.number));
var $2fb96651e8aa1522$var$RANGE_BAR_SERIES_THEME = {
    series: {
        direction: "vertical",
        fill: {
            $palette: "fill"
        },
        stroke: {
            $palette: "stroke"
        },
        // @ts-expect-error undocumented option
        fillGradientDefaults: {
            type: "gradient",
            gradient: "linear",
            bounds: "item",
            colorStops: {
                $palette: "gradient"
            },
            rotation: 0,
            reverse: false
        },
        fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
        fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
        strokeWidth: 0,
        label: {
            enabled: false,
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            fontWeight: {
                $ref: "fontWeight"
            },
            color: {
                $ref: "backgroundColor"
            },
            placement: "inside"
        }
    },
    axes: {
        [(0, $iTJTu._ModuleSupport).ThemeConstants.CARTESIAN_AXIS_TYPE.NUMBER]: {
            crosshair: {
                enabled: true
            }
        }
    }
};
// packages/ag-charts-enterprise/src/series/range-bar/rangeBarModule.ts
var $2fb96651e8aa1522$var$RangeBarModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    identifier: "range-bar",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$RangeBarSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    defaultAxes: (0, $iTJTu._ModuleSupport).DIRECTION_SWAP_AXES,
    themeTemplate: $2fb96651e8aa1522$var$RANGE_BAR_SERIES_THEME,
    groupable: true
};
var $2fb96651e8aa1522$var$RangeBarSeriesModule = {
    type: "series",
    name: "range-bar",
    chartType: "cartesian",
    enterprise: true,
    options: $2fb96651e8aa1522$var$rangeBarSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$RangeBarSeries(ctx)
};
var { AbstractBarSeriesProperties: $2fb96651e8aa1522$var$AbstractBarSeriesProperties4, BaseProperties: $2fb96651e8aa1522$var$BaseProperties22, FillGradientDefaults: $2fb96651e8aa1522$var$FillGradientDefaults5, FillPatternDefaults: $2fb96651e8aa1522$var$FillPatternDefaults5, FillImageDefaults: $2fb96651e8aa1522$var$FillImageDefaults5, PropertiesArray: $2fb96651e8aa1522$var$PropertiesArray6, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip7, Property: $2fb96651e8aa1522$var$Property64, DropShadow: $2fb96651e8aa1522$var$DropShadow3, Label: $2fb96651e8aa1522$var$Label5 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$WaterfallSeriesTotal = class extends $2fb96651e8aa1522$var$BaseProperties22 {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesTotal.prototype, "totalType", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesTotal.prototype, "index", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesTotal.prototype, "axisLabel", 2);
var $2fb96651e8aa1522$var$WaterfallSeriesItemTooltip = class extends $2fb96651e8aa1522$var$BaseProperties22 {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItemTooltip.prototype, "renderer", 2);
var $2fb96651e8aa1522$var$WaterfallSeriesLabel = class extends $2fb96651e8aa1522$var$Label5 {
    constructor(){
        super(...arguments);
        this.placement = "outside-end";
        this.padding = 6;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesLabel.prototype, "placement", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesLabel.prototype, "padding", 2);
var $2fb96651e8aa1522$var$WaterfallSeriesItem = class extends $2fb96651e8aa1522$var$BaseProperties22 {
    constructor(){
        super(...arguments);
        this.fill = "#c16068";
        this.fillGradientDefaults = new $2fb96651e8aa1522$var$FillGradientDefaults5();
        this.fillPatternDefaults = new $2fb96651e8aa1522$var$FillPatternDefaults5();
        this.fillImageDefaults = new $2fb96651e8aa1522$var$FillImageDefaults5();
        this.stroke = "#c16068";
        this.fillOpacity = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.strokeWidth = 1;
        this.cornerRadius = 0;
        this.shadow = new $2fb96651e8aa1522$var$DropShadow3().set({
            enabled: false
        });
        this.label = new $2fb96651e8aa1522$var$WaterfallSeriesLabel();
        this.tooltip = new $2fb96651e8aa1522$var$WaterfallSeriesItemTooltip();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItem.prototype, "name", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItem.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItem.prototype, "fillGradientDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItem.prototype, "fillPatternDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItem.prototype, "fillImageDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItem.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItem.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItem.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItem.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItem.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItem.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItem.prototype, "cornerRadius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItem.prototype, "itemStyler", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItem.prototype, "shadow", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItem.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItem.prototype, "tooltip", 2);
var $2fb96651e8aa1522$var$WaterfallSeriesConnectorLine = class extends $2fb96651e8aa1522$var$BaseProperties22 {
    constructor(){
        super(...arguments);
        this.enabled = true;
        this.stroke = "black";
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.strokeWidth = 2;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesConnectorLine.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesConnectorLine.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesConnectorLine.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesConnectorLine.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesConnectorLine.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesConnectorLine.prototype, "strokeWidth", 2);
var $2fb96651e8aa1522$var$WaterfallSeriesItems = class extends $2fb96651e8aa1522$var$BaseProperties22 {
    constructor(){
        super(...arguments);
        this.positive = new $2fb96651e8aa1522$var$WaterfallSeriesItem();
        this.negative = new $2fb96651e8aa1522$var$WaterfallSeriesItem();
        this.total = new $2fb96651e8aa1522$var$WaterfallSeriesItem();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItems.prototype, "positive", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItems.prototype, "negative", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesItems.prototype, "total", 2);
var $2fb96651e8aa1522$var$WaterfallSeriesProperties = class extends $2fb96651e8aa1522$var$AbstractBarSeriesProperties4 {
    constructor(){
        super(...arguments);
        this.item = new $2fb96651e8aa1522$var$WaterfallSeriesItems();
        this.totals = new $2fb96651e8aa1522$var$PropertiesArray6($2fb96651e8aa1522$var$WaterfallSeriesTotal);
        this.line = new $2fb96651e8aa1522$var$WaterfallSeriesConnectorLine();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip7();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesProperties.prototype, "xKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesProperties.prototype, "yKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesProperties.prototype, "xName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesProperties.prototype, "yName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesProperties.prototype, "item", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesProperties.prototype, "totals", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesProperties.prototype, "line", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property64
], $2fb96651e8aa1522$var$WaterfallSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-enterprise/src/series/waterfall/waterfallSeries.ts
var { adjustLabelPlacement: $2fb96651e8aa1522$var$adjustLabelPlacement, SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode5, fixNumericExtent: $2fb96651e8aa1522$var$fixNumericExtent6, valueProperty: $2fb96651e8aa1522$var$valueProperty9, keyProperty: $2fb96651e8aa1522$var$keyProperty6, accumulativeValueProperty: $2fb96651e8aa1522$var$accumulativeValueProperty, trailingAccumulatedValueProperty: $2fb96651e8aa1522$var$trailingAccumulatedValueProperty, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection23, createDatumId: $2fb96651e8aa1522$var$createDatumId8, checkCrisp: $2fb96651e8aa1522$var$checkCrisp2, updateLabelNode: $2fb96651e8aa1522$var$updateLabelNode3, prepareBarAnimationFunctions: $2fb96651e8aa1522$var$prepareBarAnimationFunctions2, collapsedStartingBarPosition: $2fb96651e8aa1522$var$collapsedStartingBarPosition, resetBarSelectionsFn: $2fb96651e8aa1522$var$resetBarSelectionsFn2, seriesLabelFadeInAnimation: $2fb96651e8aa1522$var$seriesLabelFadeInAnimation3, resetLabelFn: $2fb96651e8aa1522$var$resetLabelFn3, animationValidation: $2fb96651e8aa1522$var$animationValidation5, DEFAULT_CARTESIAN_DIRECTION_KEYS: $2fb96651e8aa1522$var$DEFAULT_CARTESIAN_DIRECTION_KEYS2, DEFAULT_CARTESIAN_DIRECTION_NAMES: $2fb96651e8aa1522$var$DEFAULT_CARTESIAN_DIRECTION_NAMES2, computeBarFocusBounds: $2fb96651e8aa1522$var$computeBarFocusBounds5, isContinuous: $2fb96651e8aa1522$var$isContinuous, Rect: $2fb96651e8aa1522$var$Rect6, motion: $2fb96651e8aa1522$var$motion3, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle5, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle6 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$WaterfallSeries = class extends (0, $iTJTu._ModuleSupport).AbstractBarSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            directionKeys: $2fb96651e8aa1522$var$DEFAULT_CARTESIAN_DIRECTION_KEYS2,
            directionNames: $2fb96651e8aa1522$var$DEFAULT_CARTESIAN_DIRECTION_NAMES2,
            categoryKey: void 0,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode5.NEAREST_NODE,
                $2fb96651e8aa1522$var$SeriesNodePickMode5.EXACT_SHAPE_MATCH
            ],
            pathsPerSeries: [
                "connector"
            ],
            hasHighlightedLabels: true,
            pathsZIndexSubOrderOffset: [
                -1,
                -1
            ],
            animationResetFns: {
                datum: $2fb96651e8aa1522$var$resetBarSelectionsFn2,
                label: $2fb96651e8aa1522$var$resetLabelFn3
            }
        });
        this.properties = new $2fb96651e8aa1522$var$WaterfallSeriesProperties();
        this.seriesItemTypes = /* @__PURE__ */ new Set([
            "positive",
            "negative",
            "total"
        ]);
    }
    async processData(dataController) {
        const { xKey: xKey, yKey: yKey, totals: totals } = this.properties;
        const { data: data = [] } = this;
        if (!this.visible) return;
        const positiveNumber4 = (v)=>$2fb96651e8aa1522$var$isContinuous(v) && Number(v) >= 0;
        const negativeNumber = (v)=>$2fb96651e8aa1522$var$isContinuous(v) && Number(v) >= 0;
        const totalTypeValue = (v)=>v === "total" || v === "subtotal";
        const propertyDefinition = {
            missingValue: void 0,
            invalidValue: void 0
        };
        const dataWithTotals = [];
        const totalsMap = totals.reduce((result, total)=>{
            const totalsAtIndex = result.get(total.index);
            if (totalsAtIndex) totalsAtIndex.push(total);
            else result.set(total.index, [
                total
            ]);
            return result;
        }, /* @__PURE__ */ new Map());
        data.forEach((datum, i)=>{
            dataWithTotals.push(datum);
            totalsMap.get(i)?.forEach((total)=>dataWithTotals.push({
                    ...total.toJson(),
                    [xKey]: total.axisLabel
                }));
        });
        const extraProps = [];
        if (!this.ctx.animationManager.isSkipped()) extraProps.push($2fb96651e8aa1522$var$animationValidation5());
        const xScale = this.getCategoryAxis()?.scale;
        const yScale = this.getValueAxis()?.scale;
        const { isContinuousX: isContinuousX, xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
            xScale: xScale,
            yScale: yScale
        });
        const { processedData: processedData } = await this.requestDataModel(dataController, dataWithTotals, {
            props: [
                $2fb96651e8aa1522$var$keyProperty6(xKey, xScaleType, {
                    id: `xValue`
                }),
                $2fb96651e8aa1522$var$accumulativeValueProperty(yKey, yScaleType, {
                    ...propertyDefinition,
                    id: `yCurrent`
                }),
                $2fb96651e8aa1522$var$accumulativeValueProperty(yKey, yScaleType, {
                    ...propertyDefinition,
                    missingValue: 0,
                    id: `yCurrentTotal`
                }),
                $2fb96651e8aa1522$var$accumulativeValueProperty(yKey, yScaleType, {
                    ...propertyDefinition,
                    id: `yCurrentPositive`,
                    validation: positiveNumber4
                }),
                $2fb96651e8aa1522$var$accumulativeValueProperty(yKey, yScaleType, {
                    ...propertyDefinition,
                    id: `yCurrentNegative`,
                    validation: negativeNumber
                }),
                $2fb96651e8aa1522$var$trailingAccumulatedValueProperty(yKey, yScaleType, {
                    ...propertyDefinition,
                    id: `yPrevious`
                }),
                $2fb96651e8aa1522$var$valueProperty9(yKey, yScaleType, {
                    id: `yRaw`
                }),
                // Raw value pass-through.
                $2fb96651e8aa1522$var$valueProperty9("totalType", "band", {
                    id: `totalTypeValue`,
                    missingValue: void 0,
                    validation: totalTypeValue
                }),
                ...isContinuousX ? [
                    (0, $iTJTu._ModuleSupport).SMALLEST_KEY_INTERVAL,
                    (0, $iTJTu._ModuleSupport).LARGEST_KEY_INTERVAL
                ] : [],
                ...extraProps
            ]
        });
        this.smallestDataInterval = processedData.reduced?.smallestKeyInterval;
        this.largestDataInterval = processedData.reduced?.largestKeyInterval;
        this.updateSeriesItemTypes();
        this.animationState.transition("updateData");
    }
    getSeriesDomain(direction) {
        const { processedData: processedData, dataModel: dataModel } = this;
        if (!processedData || !dataModel) return [];
        const { keys: [keys], values: values } = processedData.domain;
        if (direction === this.getCategoryDirection()) {
            const keyDef = dataModel.resolveProcessedDataDefById(this, `xValue`);
            if (keyDef?.def.type === "key" && keyDef?.def.valueType === "category") return keys;
            const isDirectionY = direction === $2fb96651e8aa1522$var$ChartAxisDirection23.Y;
            const isReversed = this.getCategoryAxis().isReversed();
            return this.padBandExtent(keys, isReversed !== isDirectionY);
        } else {
            const yCurrIndex = dataModel.resolveProcessedDataIndexById(this, "yCurrent");
            const yExtent = values[yCurrIndex];
            const fixedYExtent = [
                Math.min(0, yExtent[0]),
                Math.max(0, yExtent[1])
            ];
            return $2fb96651e8aa1522$var$fixNumericExtent6(fixedYExtent);
        }
    }
    getSeriesRange(_direction, _visibleRange) {
        return [
            NaN,
            NaN
        ];
    }
    createNodeData() {
        const { data: data, dataModel: dataModel, processedData: processedData } = this;
        const categoryAxis = this.getCategoryAxis();
        const valueAxis = this.getValueAxis();
        if (!data || !categoryAxis || !valueAxis || !dataModel || !processedData) return;
        const { line: line } = this.properties;
        const xScale = categoryAxis.scale;
        const yScale = valueAxis.scale;
        const barAlongX = this.getBarDirection() === $2fb96651e8aa1522$var$ChartAxisDirection23.X;
        const barWidth = this.getBandwidth(categoryAxis) ?? 10;
        const categoryAxisReversed = categoryAxis.isReversed();
        const valueAxisReversed = valueAxis.isReversed();
        if (processedData.type !== "ungrouped") return;
        const context = {
            itemId: this.properties.yKey,
            nodeData: [],
            labelData: [],
            pointData: [],
            scales: this.calculateScaling(),
            groupScale: this.getScaling(this.groupScale),
            visible: this.visible
        };
        if (!this.visible) return context;
        const pointData = [];
        const xValues = dataModel.resolveKeysById(this, `xValue`, processedData);
        const yRawValues = dataModel.resolveColumnById(this, `yRaw`, processedData);
        const totalTypeValues = dataModel.resolveColumnById(this, `totalTypeValue`, processedData);
        const yCurrValues = dataModel.resolveColumnById(this, "yCurrent", processedData);
        const yPrevValues = dataModel.resolveColumnById(this, "yPrevious", processedData);
        const yCurrTotalValues = dataModel.resolveColumnById(this, "yCurrentTotal", processedData);
        const crisp = $2fb96651e8aa1522$var$checkCrisp2(categoryAxis?.scale, categoryAxis?.visibleRange, this.smallestDataInterval, this.largestDataInterval);
        function getValues(isTotal, isSubtotal, datumIndex) {
            if (isTotal || isSubtotal) return {
                cumulativeValue: yCurrTotalValues[datumIndex],
                trailingValue: isSubtotal ? trailingSubtotal : 0
            };
            return {
                cumulativeValue: yCurrValues[datumIndex],
                trailingValue: yPrevValues[datumIndex]
            };
        }
        function getValue(isTotal, isSubtotal, rawValue, cumulativeValue, trailingValue) {
            if (isTotal) return cumulativeValue;
            if (isSubtotal) return (cumulativeValue ?? 0) - (trailingValue ?? 0);
            return rawValue;
        }
        let trailingSubtotal = 0;
        const { xKey: xKey, yKey: yKey, xName: xName, yName: yName } = this.properties;
        const rawData = processedData.dataSources.get(this.id) ?? [];
        rawData.forEach((datum, datumIndex)=>{
            const datumType = totalTypeValues[datumIndex];
            const isSubtotal = this.isSubtotal(datumType);
            const isTotal = this.isTotal(datumType);
            const isTotalOrSubtotal = isTotal || isSubtotal;
            const xDatum = xValues[datumIndex];
            if (xDatum == null) return;
            const x = Math.round(xScale.convert(xDatum));
            const rawValue = yRawValues[datumIndex];
            const { cumulativeValue: cumulativeValue, trailingValue: trailingValue } = getValues(isTotal, isSubtotal, datumIndex);
            if (isTotalOrSubtotal) trailingSubtotal = cumulativeValue ?? 0;
            const currY = Math.round(yScale.convert(cumulativeValue));
            const trailY = Math.round(yScale.convert(trailingValue));
            const value = getValue(isTotal, isSubtotal, rawValue, cumulativeValue, trailingValue);
            const isPositive = (value ?? 0) >= 0;
            const seriesItemType = this.getSeriesItemType(isPositive, datumType);
            const { strokeWidth: strokeWidth, label: label } = this.getItemConfig(seriesItemType);
            const y = isPositive ? currY : trailY;
            const bottomY = isPositive ? trailY : currY;
            const barHeight = Math.max(strokeWidth, Math.abs(bottomY - y));
            const rect = {
                x: barAlongX ? Math.min(y, bottomY) : x,
                y: barAlongX ? x : Math.min(y, bottomY),
                width: barAlongX ? barHeight : barWidth,
                height: barAlongX ? barWidth : barHeight
            };
            const nodeMidPoint = {
                x: rect.x + rect.width / 2,
                y: rect.y + rect.height / 2
            };
            const pointY = isTotalOrSubtotal ? currY : trailY;
            const pixelAlignmentOffset = Math.floor(line.strokeWidth) % 2 / 2;
            const startY = categoryAxisReversed ? currY : pointY;
            const stopY = categoryAxisReversed ? pointY : currY;
            let startCoordinates;
            let stopCoordinates;
            if (barAlongX) {
                startCoordinates = {
                    x: startY + pixelAlignmentOffset,
                    y: rect.y
                };
                stopCoordinates = {
                    x: stopY + pixelAlignmentOffset,
                    y: rect.y + rect.height
                };
            } else {
                startCoordinates = {
                    x: rect.x,
                    y: startY + pixelAlignmentOffset
                };
                stopCoordinates = {
                    x: rect.x + rect.width,
                    y: stopY + pixelAlignmentOffset
                };
            }
            const pathPoint = {
                // lineTo
                x: categoryAxisReversed ? stopCoordinates.x : startCoordinates.x,
                y: categoryAxisReversed ? stopCoordinates.y : startCoordinates.y,
                // moveTo
                x2: categoryAxisReversed ? startCoordinates.x : stopCoordinates.x,
                y2: categoryAxisReversed ? startCoordinates.y : stopCoordinates.y,
                size: 0
            };
            pointData.push(pathPoint);
            const itemId = seriesItemType === "subtotal" ? "total" : seriesItemType;
            const labelText = this.getLabelText(label, {
                itemId: itemId,
                value: value,
                datum: datum,
                xKey: xKey,
                yKey: yKey,
                xName: xName,
                yName: yName
            });
            const nodeDatum = {
                index: datumIndex,
                series: this,
                itemId: seriesItemType,
                datum: datum,
                datumIndex: datumIndex,
                cumulativeValue: cumulativeValue ?? 0,
                xValue: xDatum,
                yValue: value,
                yKey: yKey,
                xKey: xKey,
                x: rect.x,
                y: rect.y,
                width: rect.width,
                height: rect.height,
                midPoint: nodeMidPoint,
                crisp: crisp,
                label: {
                    text: labelText,
                    ...$2fb96651e8aa1522$var$adjustLabelPlacement({
                        isUpward: (value ?? -1) >= 0 !== valueAxisReversed,
                        isVertical: !barAlongX,
                        placement: label.placement,
                        padding: label.padding,
                        rect: rect
                    })
                }
            };
            context.nodeData.push(nodeDatum);
            context.labelData.push(nodeDatum);
        });
        const connectorLinesEnabled = this.properties.line.enabled;
        if (yCurrValues != null && connectorLinesEnabled) context.pointData = pointData;
        return context;
    }
    updateSeriesItemTypes() {
        const { dataModel: dataModel, seriesItemTypes: seriesItemTypes, processedData: processedData } = this;
        if (!dataModel || !processedData) return;
        seriesItemTypes.clear();
        const yPositiveIndex = dataModel.resolveProcessedDataIndexById(this, "yCurrentPositive");
        const yNegativeIndex = dataModel.resolveProcessedDataIndexById(this, "yCurrentNegative");
        const totalTypeIndex = dataModel.resolveProcessedDataIndexById(this, `totalTypeValue`);
        const positiveDomain = processedData.domain.values[yPositiveIndex] ?? [];
        const negativeDomain = processedData.domain.values[yNegativeIndex] ?? [];
        if (positiveDomain.length > 0) seriesItemTypes.add("positive");
        if (negativeDomain.length > 0) seriesItemTypes.add("negative");
        const itemTypes = processedData?.domain.values[totalTypeIndex];
        if (!itemTypes) return;
        itemTypes.forEach((type)=>{
            if (type === "total" || type === "subtotal") seriesItemTypes.add("total");
        });
    }
    isSubtotal(datumType) {
        return datumType === "subtotal";
    }
    isTotal(datumType) {
        return datumType === "total";
    }
    nodeFactory() {
        return new $2fb96651e8aa1522$var$Rect6();
    }
    getSeriesItemType(isPositive, datumType) {
        return datumType ?? (isPositive ? "positive" : "negative");
    }
    getItemConfig(seriesItemType) {
        switch(seriesItemType){
            case "positive":
                return this.properties.item.positive;
            case "negative":
                return this.properties.item.negative;
            case "subtotal":
            case "total":
                return this.properties.item.total;
        }
    }
    updateDatumSelection(opts) {
        const { nodeData: nodeData, datumSelection: datumSelection } = opts;
        const data = nodeData ?? [];
        return datumSelection.update(data);
    }
    getItemStyle(datumId, datum, itemId, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const item = properties.item[itemId === "subtotal" ? "total" : itemId];
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        const { itemStyler: itemStyler, fillGradientDefaults: fillGradientDefaults4, fillPatternDefaults: fillPatternDefaults4, fillImageDefaults: fillImageDefaults4 } = item;
        const { xKey: xKey, yKey: yKey } = properties;
        const format = $2fb96651e8aa1522$var$getShapeStyle6({
            fill: highlightStyle?.fill ?? item.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? item.fillOpacity,
            stroke: highlightStyle?.stroke ?? item.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? item.strokeWidth,
            strokeOpacity: highlightStyle?.strokeOpacity ?? item.strokeOpacity,
            lineDash: highlightStyle?.lineDash ?? item.lineDash ?? [],
            lineDashOffset: highlightStyle?.lineDashOffset ?? item.lineDashOffset,
            cornerRadius: item.cornerRadius
        }, fillGradientDefaults4, fillPatternDefaults4, fillImageDefaults4);
        if (itemStyler != null) {
            let itemStyle = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId8(datumId, highlighted ? "highlight" : "node"), ()=>{
                return this.callWithContext(itemStyler, {
                    seriesId: seriesId,
                    itemId: itemId,
                    datum: datum,
                    xKey: xKey,
                    yKey: yKey,
                    highlighted: highlighted,
                    ...format
                });
            });
            itemStyle = $2fb96651e8aa1522$var$getShapeStyle6(itemStyle, fillGradientDefaults4, fillPatternDefaults4, fillImageDefaults4);
            Object.assign(format, itemStyle);
        }
        return format;
    }
    updateDatumNodes(opts) {
        const { datumSelection: datumSelection, isHighlight: isHighlight } = opts;
        const categoryAlongX = this.getCategoryDirection() === $2fb96651e8aa1522$var$ChartAxisDirection23.X;
        const fillBBox = this.getShapeFillBBox();
        datumSelection.each((rect, datum)=>{
            const seriesItemType = datum.itemId;
            const style = this.getItemStyle(String(datum.datumIndex), datum.datum, seriesItemType, isHighlight);
            $2fb96651e8aa1522$var$applyShapeStyle5(rect, style, void 0, fillBBox);
            rect.visible = categoryAlongX ? datum.width > 0 : datum.height > 0;
            rect.crisp = datum.crisp;
        });
    }
    updateLabelSelection(opts) {
        const { labelData: labelData, labelSelection: labelSelection } = opts;
        if (labelData.length === 0) return labelSelection.update([]);
        const data = labelData.filter((labelDatum)=>{
            const { label: label } = this.getItemConfig(labelDatum.itemId);
            return label.enabled;
        });
        return labelSelection.update(data);
    }
    updateLabelNodes(opts) {
        opts.labelSelection.each((textNode, datum)=>{
            $2fb96651e8aa1522$var$updateLabelNode3(textNode, this.getItemConfig(datum.itemId).label, datum.label);
        });
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, properties: properties } = this;
        const { xKey: xKey, xName: xName, yKey: yKey, yName: yName, tooltip: tooltip } = properties;
        const xAxis = this.getCategoryAxis();
        const yAxis = this.getValueAxis();
        if (!dataModel || !processedData || !xAxis || !yAxis) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const xValue2 = dataModel.resolveKeysById(this, `xValue`, processedData)[datumIndex];
        const yValue = dataModel.resolveColumnById(this, `yRaw`, processedData)[datumIndex];
        const yCurrTotalValues = dataModel.resolveColumnById(this, "yCurrentTotal", processedData);
        const totalTypeValues = dataModel.resolveColumnById(this, `totalTypeValue`, processedData);
        if (xValue2 == null) return;
        const datumType = totalTypeValues[datumIndex];
        const isPositive = (yValue ?? 0) >= 0;
        const seriesItemType = this.getSeriesItemType(isPositive, datumType);
        let total;
        if (this.isTotal(datumType)) total = yCurrTotalValues[datumIndex];
        else if (this.isSubtotal(datumType)) {
            total = yCurrTotalValues[datumIndex];
            for(let previousIndex = datumIndex - 1; previousIndex >= 0; previousIndex -= 1)if (this.isSubtotal(totalTypeValues[previousIndex])) {
                total = total - yCurrTotalValues[previousIndex];
                break;
            }
        } else total = yValue;
        const format = this.getItemStyle(String(datumIndex), datum, seriesItemType, false);
        return this.formatTooltipWithContext(tooltip, {
            heading: xAxis.formatDatum(xValue2),
            symbol: this.legendItemSymbol(seriesItemType),
            data: [
                {
                    label: yName,
                    fallbackLabel: yKey,
                    value: yAxis.formatDatum(total)
                }
            ]
        }, {
            seriesId: seriesId,
            datum: datum,
            title: yName,
            itemId: seriesItemType,
            xKey: xKey,
            xName: xName,
            yKey: yKey,
            yName: yName,
            ...format
        });
    }
    legendItemSymbol(item) {
        const { fill: fill, stroke: stroke2, fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset, fillGradientDefaults: fillGradientDefaults4, fillPatternDefaults: fillPatternDefaults4, fillImageDefaults: fillImageDefaults4 } = this.getItemConfig(item);
        return {
            marker: $2fb96651e8aa1522$var$getShapeStyle6({
                fill: fill,
                stroke: stroke2,
                fillOpacity: fillOpacity,
                strokeOpacity: strokeOpacity,
                strokeWidth: strokeWidth,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset
            }, fillGradientDefaults4, fillPatternDefaults4, fillImageDefaults4)
        };
    }
    getLegendData(legendType) {
        if (legendType !== "category") return [];
        const { id: id, seriesItemTypes: seriesItemTypes } = this;
        const legendData = [];
        const capitalise = (text2)=>text2.charAt(0).toUpperCase() + text2.substring(1);
        const { showInLegend: showInLegend } = this.properties;
        seriesItemTypes.forEach((item)=>{
            const { name: name } = this.getItemConfig(item);
            legendData.push({
                legendType: "category",
                id: id,
                itemId: item,
                seriesId: id,
                enabled: true,
                label: {
                    text: name ?? capitalise(item)
                },
                symbol: this.legendItemSymbol(item),
                hideInLegend: !showInLegend,
                isFixed: true
            });
        });
        return legendData;
    }
    toggleSeriesItem() {}
    animateEmptyUpdateReady(opts) {
        const { datumSelection: datumSelection, labelSelection: labelSelection, contextData: contextData } = opts;
        const fns = $2fb96651e8aa1522$var$prepareBarAnimationFunctions2($2fb96651e8aa1522$var$collapsedStartingBarPosition(this.isVertical(), this.axes, "normal"));
        $2fb96651e8aa1522$var$motion3.fromToMotion(this.id, "datums", this.ctx.animationManager, [
            datumSelection
        ], fns);
        $2fb96651e8aa1522$var$seriesLabelFadeInAnimation3(this, "labels", this.ctx.animationManager, labelSelection);
        const { pointData: pointData } = contextData;
        if (!pointData) return;
        if (this.isVertical()) this.animateConnectorLinesVertical(opts);
        else this.animateConnectorLinesHorizontal(opts);
    }
    animateConnectorLinesHorizontal(opts) {
        const { pointData: pointData = [] } = opts.contextData;
        const [lineNode] = opts.paths;
        const { path: linePath } = lineNode;
        this.updateLineNode(lineNode);
        const valueAxis = this.getValueAxis();
        const valueAxisReversed = valueAxis?.isReversed();
        const compare = valueAxisReversed ? (v, v2)=>v < v2 : (v, v2)=>v > v2;
        const startX = valueAxis?.scale.convert(0);
        const endX = pointData.reduce((end, point)=>{
            if (compare(point.x, end)) end = point.x;
            return end;
        }, valueAxisReversed ? Infinity : 0);
        const scale = (value, start1, end1, start2, end2)=>{
            return (value - start1) / (end1 - start1) * (end2 - start2) + start2;
        };
        this.ctx.animationManager.animate({
            id: `${this.id}_connectors`,
            groupId: this.id,
            phase: "initial",
            from: startX,
            to: endX,
            ease: (0, $iTJTu._ModuleSupport).Motion.easeOut,
            collapsable: false,
            onUpdate (pointX) {
                linePath.clear(true);
                pointData.forEach((point, index)=>{
                    const x = scale(pointX, startX, endX, startX, point.x);
                    const x2 = scale(pointX, startX, endX, startX, point.x2);
                    if (index !== 0) linePath.lineTo(x, point.y);
                    linePath.moveTo(x2, point.y2);
                });
                lineNode.checkPathDirty();
            },
            onStop: ()=>this.resetConnectorLinesPath(opts)
        });
    }
    animateConnectorLinesVertical(opts) {
        const { pointData: pointData = [] } = opts.contextData;
        const [lineNode] = opts.paths;
        const { path: linePath } = lineNode;
        this.updateLineNode(lineNode);
        const valueAxis = this.getValueAxis();
        const valueAxisReversed = valueAxis?.isReversed();
        const compare = valueAxisReversed ? (v, v2)=>v > v2 : (v, v2)=>v < v2;
        const startY = valueAxis?.scale.convert(0);
        const endY = pointData.reduce((end, point)=>{
            if (compare(point.y, end)) end = point.y;
            return end;
        }, valueAxisReversed ? 0 : Infinity);
        const scale = (value, start1, end1, start2, end2)=>{
            return (value - start1) / (end1 - start1) * (end2 - start2) + start2;
        };
        this.ctx.animationManager.animate({
            id: `${this.id}_connectors`,
            groupId: this.id,
            phase: "initial",
            from: startY,
            to: endY,
            ease: (0, $iTJTu._ModuleSupport).Motion.easeOut,
            collapsable: false,
            onUpdate (pointY) {
                linePath.clear(true);
                pointData.forEach((point, index)=>{
                    const y = scale(pointY, startY, endY, startY, point.y);
                    const y2 = scale(pointY, startY, endY, startY, point.y2);
                    if (index !== 0) linePath.lineTo(point.x, y);
                    linePath.moveTo(point.x2, y2);
                });
                lineNode.checkPathDirty();
            },
            onStop: ()=>this.resetConnectorLinesPath(opts)
        });
    }
    animateReadyResize(data) {
        super.animateReadyResize(data);
        this.resetConnectorLinesPath(data);
    }
    updatePaths(opts) {
        this.resetConnectorLinesPath({
            contextData: opts.contextData,
            paths: opts.paths
        });
    }
    resetConnectorLinesPath({ contextData: contextData, paths: paths }) {
        if (paths.length === 0) return;
        const [lineNode] = paths;
        this.updateLineNode(lineNode);
        const { path: linePath } = lineNode;
        linePath.clear(true);
        const { pointData: pointData } = contextData;
        if (!pointData) return;
        pointData.forEach((point, index)=>{
            if (index !== 0) linePath.lineTo(point.x, point.y);
            linePath.moveTo(point.x2, point.y2);
        });
        lineNode.checkPathDirty();
    }
    updateLineNode(lineNode) {
        const { stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = this.properties.line;
        lineNode.setProperties({
            fill: void 0,
            stroke: stroke2,
            strokeWidth: this.getStrokeWidth(strokeWidth),
            strokeOpacity: strokeOpacity,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            lineJoin: "round",
            pointerEvents: (0, $iTJTu._ModuleSupport).PointerEvents.None
        });
    }
    isLabelEnabled() {
        const { positive: positive, negative: negative, total: total } = this.properties.item;
        return positive.label.enabled || negative.label.enabled || total.label.enabled;
    }
    onDataChange() {}
    computeFocusBounds({ datumIndex: datumIndex }) {
        return $2fb96651e8aa1522$var$computeBarFocusBounds5(this, this.contextNodeData?.nodeData[datumIndex]);
    }
};
$2fb96651e8aa1522$var$WaterfallSeries.className = "WaterfallSeries";
$2fb96651e8aa1522$var$WaterfallSeries.type = "waterfall";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs7, waterfallSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$waterfallSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$waterfallSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$waterfallSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs7,
    type: (0, $idDdm.required)((0, $idDdm.constant)("waterfall")),
    xKey: (0, $idDdm.required)((0, $idDdm.string)),
    yKey: (0, $idDdm.required)((0, $idDdm.string)),
    xName: (0, $idDdm.string),
    yName: (0, $idDdm.string),
    totals: (0, $idDdm.arrayOfDefs)({
        totalType: (0, $idDdm.required)((0, $idDdm.union)("total", "subtotal")),
        index: (0, $idDdm.required)((0, $idDdm.positiveNumber)),
        axisLabel: (0, $idDdm.required)((0, $idDdm.string))
    }, "a total definition options array")
};
function $2fb96651e8aa1522$var$itemTheme2(key, index) {
    return {
        fill: {
            $if: [
                {
                    $eq: [
                        {
                            $palette: "type"
                        },
                        "user-indexed"
                    ]
                },
                {
                    $path: [
                        `./${index}`,
                        {
                            $palette: "fill"
                        },
                        {
                            $palette: "fills"
                        }
                    ]
                },
                {
                    $palette: `${key}.fill`
                }
            ]
        },
        // @ts-expect-error undocumented option
        fillGradientDefaults: {
            type: "gradient",
            gradient: "linear",
            bounds: "item",
            colorStops: {
                $if: [
                    {
                        $or: [
                            {
                                $isGradient: [
                                    {
                                        $palette: `${key}.fill`
                                    }
                                ]
                            },
                            {
                                $isPattern: [
                                    {
                                        $palette: `${key}.fill`
                                    }
                                ]
                            },
                            {
                                $isImage: [
                                    {
                                        $palette: `${key}.fill`
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        $map: [
                            {
                                $path: [
                                    "./color",
                                    void 0,
                                    {
                                        $value: "$1"
                                    }
                                ]
                            },
                            {
                                $path: [
                                    "./colorStops",
                                    void 0,
                                    {
                                        $palette: `${key}.fill`
                                    }
                                ]
                            }
                        ]
                    },
                    [
                        {
                            $mix: [
                                {
                                    $palette: `${key}.fill`
                                },
                                "black",
                                0.15
                            ]
                        },
                        {
                            $mix: [
                                {
                                    $palette: `${key}.fill`
                                },
                                "white",
                                0.15
                            ]
                        }
                    ]
                ]
            },
            rotation: 0,
            reverse: false
        },
        fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
        fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
        stroke: {
            $palette: `${key}.stroke`
        },
        strokeWidth: 0,
        label: {
            enabled: false,
            fontStyle: void 0,
            fontWeight: {
                $ref: "fontWeight"
            },
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            color: {
                $ref: "textColor"
            },
            formatter: void 0,
            placement: "outside-end"
        }
    };
}
var $2fb96651e8aa1522$var$WATERFALL_SERIES_THEME = {
    series: {
        item: {
            positive: $2fb96651e8aa1522$var$itemTheme2("altUp", 0),
            negative: $2fb96651e8aa1522$var$itemTheme2("altDown", 1),
            total: $2fb96651e8aa1522$var$itemTheme2("neutral", 2)
        },
        line: {
            stroke: {
                $palette: "neutral.stroke"
            },
            strokeOpacity: 1,
            lineDash: [
                0
            ],
            lineDashOffset: 0,
            strokeWidth: 2
        }
    },
    legend: {
        enabled: true,
        toggleSeries: false
    }
};
// packages/ag-charts-enterprise/src/series/waterfall/waterfallModule.ts
var $2fb96651e8aa1522$var$WaterfallModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    identifier: "waterfall",
    solo: true,
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$WaterfallSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    defaultAxes: (0, $iTJTu._ModuleSupport).DIRECTION_SWAP_AXES,
    themeTemplate: $2fb96651e8aa1522$var$WATERFALL_SERIES_THEME
};
var $2fb96651e8aa1522$var$WaterfallSeriesModule = {
    type: "series",
    name: "waterfall",
    chartType: "cartesian",
    enterprise: true,
    options: $2fb96651e8aa1522$var$waterfallSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$WaterfallSeries(ctx)
};
// packages/ag-charts-enterprise/src/features/navigator/navigatorOptionsDefs.ts
var { NewAreaSeriesModule: $2fb96651e8aa1522$var$NewAreaSeriesModule, NewBarSeriesModule: $2fb96651e8aa1522$var$NewBarSeriesModule, NewBubbleSeriesModule: $2fb96651e8aa1522$var$NewBubbleSeriesModule, NewHistogramSeriesModule: $2fb96651e8aa1522$var$NewHistogramSeriesModule, NewLineSeriesModule: $2fb96651e8aa1522$var$NewLineSeriesModule, NewScatterSeriesModule: $2fb96651e8aa1522$var$NewScatterSeriesModule, numberFormatValidator: $2fb96651e8aa1522$var$numberFormatValidator, without: $2fb96651e8aa1522$var$without } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$navigatorHandleOptionsDef = {
    width: (0, $idDdm.positiveNumber),
    height: (0, $idDdm.positiveNumber),
    grip: (0, $idDdm.boolean),
    fill: (0, $idDdm.color),
    stroke: (0, $idDdm.color),
    strokeWidth: (0, $idDdm.positiveNumber),
    cornerRadius: (0, $idDdm.positiveNumber)
};
var $2fb96651e8aa1522$var$commonIgnoredMiniChartProperties = [
    "cursor",
    "highlightStyle",
    "listeners",
    "nodeClickRange",
    "showInLegend",
    "showInMiniChart",
    "tooltip",
    "visible",
    "xName",
    "yName"
];
var $2fb96651e8aa1522$var$navigatorOptionsDef = {
    enabled: (0, $idDdm.boolean),
    height: (0, $idDdm.positiveNumber),
    spacing: (0, $idDdm.positiveNumber),
    cornerRadius: (0, $idDdm.number),
    mask: {
        fill: (0, $idDdm.color),
        fillOpacity: (0, $idDdm.ratio),
        stroke: (0, $idDdm.color),
        strokeWidth: (0, $idDdm.positiveNumber)
    },
    minHandle: $2fb96651e8aa1522$var$navigatorHandleOptionsDef,
    maxHandle: $2fb96651e8aa1522$var$navigatorHandleOptionsDef,
    miniChart: {
        enabled: (0, $idDdm.boolean),
        padding: {
            top: (0, $idDdm.positiveNumber),
            bottom: (0, $idDdm.positiveNumber)
        },
        label: {
            enabled: (0, $idDdm.boolean),
            avoidCollisions: (0, $idDdm.boolean),
            spacing: (0, $idDdm.positiveNumber),
            format: $2fb96651e8aa1522$var$numberFormatValidator,
            formatter: (0, $idDdm.callback),
            interval: {
                minSpacing: (0, $idDdm.positiveNumber),
                maxSpacing: (0, $idDdm.positiveNumber),
                values: (0, $idDdm.array),
                step: (0, $idDdm.number)
            },
            ...(0, $idDdm.fontOptionsDef)
        },
        series: (0, $idDdm.arrayOfDefs)((0, $idDdm.typeUnion)({
            area: $2fb96651e8aa1522$var$without($2fb96651e8aa1522$var$NewAreaSeriesModule.options, $2fb96651e8aa1522$var$commonIgnoredMiniChartProperties),
            bar: $2fb96651e8aa1522$var$without($2fb96651e8aa1522$var$NewBarSeriesModule.options, [
                ...$2fb96651e8aa1522$var$commonIgnoredMiniChartProperties,
                "errorBar",
                "label",
                "legendItemName",
                "direction"
            ]),
            "box-plot": $2fb96651e8aa1522$var$without($2fb96651e8aa1522$var$BoxPlotSeriesModule.options, [
                ...$2fb96651e8aa1522$var$commonIgnoredMiniChartProperties,
                "direction",
                "legendItemName",
                "minName",
                "q1Name",
                "medianName",
                "q3Name",
                "maxName"
            ]),
            bubble: $2fb96651e8aa1522$var$without($2fb96651e8aa1522$var$NewBubbleSeriesModule.options, [
                ...$2fb96651e8aa1522$var$commonIgnoredMiniChartProperties,
                "title",
                "label",
                "labelKey",
                "labelName",
                "sizeName"
            ]),
            candlestick: $2fb96651e8aa1522$var$without($2fb96651e8aa1522$var$CandlestickSeriesModule.options, $2fb96651e8aa1522$var$commonIgnoredMiniChartProperties),
            heatmap: $2fb96651e8aa1522$var$without($2fb96651e8aa1522$var$HeatmapSeriesModule.options, [
                ...$2fb96651e8aa1522$var$commonIgnoredMiniChartProperties,
                "title",
                "label",
                "colorName",
                "textAlign",
                "verticalAlign",
                "itemPadding",
                "colorRange"
            ]),
            histogram: $2fb96651e8aa1522$var$without($2fb96651e8aa1522$var$NewHistogramSeriesModule.options, [
                ...$2fb96651e8aa1522$var$commonIgnoredMiniChartProperties,
                "label"
            ]),
            line: $2fb96651e8aa1522$var$without($2fb96651e8aa1522$var$NewLineSeriesModule.options, [
                ...$2fb96651e8aa1522$var$commonIgnoredMiniChartProperties,
                "errorBar",
                "title",
                "label"
            ]),
            ohlc: $2fb96651e8aa1522$var$without($2fb96651e8aa1522$var$OhlcSeriesModule.options, $2fb96651e8aa1522$var$commonIgnoredMiniChartProperties),
            "range-area": $2fb96651e8aa1522$var$without($2fb96651e8aa1522$var$RangeAreaSeriesModule.options, [
                ...$2fb96651e8aa1522$var$commonIgnoredMiniChartProperties,
                "label",
                "yLowName",
                "yHighName"
            ]),
            "range-bar": $2fb96651e8aa1522$var$without($2fb96651e8aa1522$var$RangeBarSeriesModule.options, [
                ...$2fb96651e8aa1522$var$commonIgnoredMiniChartProperties,
                "direction",
                "label",
                "yLowName",
                "yHighName"
            ]),
            scatter: $2fb96651e8aa1522$var$without($2fb96651e8aa1522$var$NewScatterSeriesModule.options, [
                ...$2fb96651e8aa1522$var$commonIgnoredMiniChartProperties,
                "errorBar",
                "title",
                "label",
                "labelKey",
                "labelName"
            ]),
            waterfall: $2fb96651e8aa1522$var$without($2fb96651e8aa1522$var$WaterfallSeriesModule.options, [
                ...$2fb96651e8aa1522$var$commonIgnoredMiniChartProperties,
                "direction"
            ])
        }, "miniChart series options"))
    }
};
// packages/ag-charts-enterprise/src/features/sync/pluginModules.ts
var { annotationOptionsDef: $2fb96651e8aa1522$var$annotationOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$AnnotationsModule2 = {
    type: "plugin",
    name: "annotations",
    chartType: "cartesian",
    options: $2fb96651e8aa1522$var$annotationOptionsDef,
    create () {
        return null;
    }
};
var $2fb96651e8aa1522$var$NavigatorModule2 = {
    type: "plugin",
    name: "navigator",
    chartType: "cartesian",
    options: $2fb96651e8aa1522$var$navigatorOptionsDef,
    create () {
        return null;
    }
};
var $2fb96651e8aa1522$var$InitialStateModule = {
    type: "plugin",
    name: "initialState",
    options: $2fb96651e8aa1522$var$initialStateOptionsDef,
    create () {
        return null;
    }
};
function $2fb96651e8aa1522$var$computeNodeGraph(nodes, links, includeCircularReferences) {
    if (!includeCircularReferences) links = $2fb96651e8aa1522$var$removeCircularLinks(links);
    const nodeGraph = /* @__PURE__ */ new Map();
    for (const datum of nodes)nodeGraph.set(datum.id, {
        datum: datum,
        linksBefore: [],
        linksAfter: [],
        maxPathLengthBefore: -1,
        maxPathLengthAfter: -1
    });
    let maxPathLength = 0;
    nodeGraph.forEach((node, id)=>{
        maxPathLength = Math.max(maxPathLength, $2fb96651e8aa1522$var$computePathLength(nodeGraph, links, node, id, -1, []) + $2fb96651e8aa1522$var$computePathLength(nodeGraph, links, node, id, 1, []) + 1);
    });
    return {
        links: links,
        nodeGraph: nodeGraph,
        maxPathLength: maxPathLength
    };
}
function $2fb96651e8aa1522$var$findCircularLinks(links, link, into, stack) {
    const stackIndex = stack.indexOf(link);
    if (stackIndex !== -1) {
        for(let i = stackIndex; i < stack.length; i += 1)into.add(stack[i]);
        return;
    }
    stack.push(link);
    const { toNode: toNode } = link;
    for (const next of links)if (next.fromNode === toNode) $2fb96651e8aa1522$var$findCircularLinks(links, next, into, stack);
    stack.pop();
}
function $2fb96651e8aa1522$var$removeCircularLinks(links) {
    const circularLinks = /* @__PURE__ */ new Set();
    for (const link of links)$2fb96651e8aa1522$var$findCircularLinks(links, link, circularLinks, []);
    if (circularLinks.size !== 0) (0, $idDdm.Logger).warnOnce("Some links formed circular references. These will be removed from the output.");
    return circularLinks.size === 0 ? links : links.filter((link)=>!circularLinks.has(link));
}
function $2fb96651e8aa1522$var$computePathLength(nodeGraph, links, node, id, direction, stack) {
    if (stack.includes(id)) return Infinity;
    let maxPathLength = direction === -1 ? node.maxPathLengthBefore : node.maxPathLengthAfter;
    if (maxPathLength === -1) {
        maxPathLength = 0;
        const connectedLinks = direction === -1 ? node.linksBefore : node.linksAfter;
        for (const link of links){
            const { fromNode: fromNode, toNode: toNode } = link;
            const linkId = direction === -1 ? toNode.id : fromNode.id;
            const nextNodeId = direction === -1 ? fromNode.id : toNode.id;
            const nextNode = id === linkId ? nodeGraph.get(nextNodeId) : void 0;
            if (nextNode == null) continue;
            connectedLinks.push({
                node: nextNode,
                link: link
            });
            stack?.push(id);
            maxPathLength = Math.max(maxPathLength, $2fb96651e8aa1522$var$computePathLength(nodeGraph, links, nextNode, nextNodeId, direction, stack) + 1);
            stack?.pop();
        }
        if (direction === -1) node.maxPathLengthBefore = maxPathLength;
        else node.maxPathLengthAfter = maxPathLength;
    }
    return maxPathLength;
}
// packages/ag-charts-enterprise/src/series/flow-proportion/flowProportionSeries.ts
var { Series: $2fb96651e8aa1522$var$Series, DataController: $2fb96651e8aa1522$var$DataController, keyProperty: $2fb96651e8aa1522$var$keyProperty7, valueProperty: $2fb96651e8aa1522$var$valueProperty10, Selection: $2fb96651e8aa1522$var$Selection5, Group: $2fb96651e8aa1522$var$Group10, TransformableText: $2fb96651e8aa1522$var$TransformableText } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$FlowProportionSeriesNodeEvent = class extends (0, $iTJTu._ModuleSupport).SeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        const { datumIndex: datumIndex } = datum;
        const nodeDatum = series.contextNodeData?.nodeData.find((d)=>d.datumIndex.type === datumIndex.type && d.datumIndex.index === datumIndex.index);
        this.size = nodeDatum?.size;
        this.label = nodeDatum?.type === 1 /* Node */  ? nodeDatum?.label : void 0;
    }
};
var $2fb96651e8aa1522$var$FlowProportionSeries = class extends $2fb96651e8aa1522$var$Series {
    constructor(){
        super(...arguments);
        this.NodeEvent = $2fb96651e8aa1522$var$FlowProportionSeriesNodeEvent;
        this._chartNodes = void 0;
        this.nodeCount = 0;
        this.linkCount = 0;
        this.linksDataModel = void 0;
        this.linksProcessedData = void 0;
        this.nodesDataModel = void 0;
        this.nodesProcessedData = void 0;
        this.processedNodes = /* @__PURE__ */ new Map();
        this.linkGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group10({
            name: "linkGroup"
        }));
        this.nodeGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group10({
            name: "nodeGroup"
        }));
        this.focusLinkGroup = this.highlightNode.appendChild(new $2fb96651e8aa1522$var$Group10({
            name: "linkGroup"
        }));
        this.focusNodeGroup = this.highlightNode.appendChild(new $2fb96651e8aa1522$var$Group10({
            name: "nodeGroup"
        }));
        this.highlightLinkGroup = this.highlightNode.appendChild(new $2fb96651e8aa1522$var$Group10({
            name: "linkGroup"
        }));
        this.highlightNodeGroup = this.highlightNode.appendChild(new $2fb96651e8aa1522$var$Group10({
            name: "nodeGroup"
        }));
        this.labelSelection = $2fb96651e8aa1522$var$Selection5.select(this.labelGroup, $2fb96651e8aa1522$var$TransformableText);
        this.linkSelection = $2fb96651e8aa1522$var$Selection5.select(this.linkGroup, ()=>this.linkFactory());
        this.nodeSelection = $2fb96651e8aa1522$var$Selection5.select(this.nodeGroup, ()=>this.nodeFactory());
        this.focusLinkSelection = $2fb96651e8aa1522$var$Selection5.select(this.focusLinkGroup, ()=>this.linkFactory());
        this.focusNodeSelection = $2fb96651e8aa1522$var$Selection5.select(this.focusNodeGroup, ()=>this.nodeFactory());
        this.highlightLinkSelection = $2fb96651e8aa1522$var$Selection5.select(this.highlightLinkGroup, ()=>this.linkFactory());
        this.highlightNodeSelection = $2fb96651e8aa1522$var$Selection5.select(this.highlightNodeGroup, ()=>this.nodeFactory());
    }
    get nodes() {
        return this.properties.nodes ?? this._chartNodes;
    }
    setChartNodes(nodes) {
        this._chartNodes = nodes;
        if (this.nodes === nodes) this.nodeDataRefresh = true;
    }
    async processData(dataController) {
        const { data: data, nodes: nodes } = this;
        if (data == null) return;
        const { fromKey: fromKey, toKey: toKey, sizeKey: sizeKey, idKey: idKey, labelKey: labelKey } = this.properties;
        const nodesDataController = new $2fb96651e8aa1522$var$DataController("standalone", dataController.suppressFieldDotNotation);
        const nodesDataModelPromise = nodes != null ? nodesDataController.request(this.id, nodes, {
            props: [
                $2fb96651e8aa1522$var$keyProperty7(idKey, void 0, {
                    id: "idValue",
                    includeProperty: false
                }),
                ...labelKey != null ? [
                    $2fb96651e8aa1522$var$valueProperty10(labelKey, void 0, {
                        id: "labelValue",
                        includeProperty: false
                    })
                ] : []
            ],
            groupByKeys: true
        }) : null;
        const linksDataModelPromise = dataController.request(this.id, data, {
            props: [
                $2fb96651e8aa1522$var$valueProperty10(fromKey, void 0, {
                    id: "fromValue",
                    includeProperty: false
                }),
                $2fb96651e8aa1522$var$valueProperty10(toKey, void 0, {
                    id: "toValue",
                    includeProperty: false
                }),
                ...sizeKey != null ? [
                    $2fb96651e8aa1522$var$valueProperty10(sizeKey, void 0, {
                        id: "sizeValue",
                        includeProperty: false,
                        missingValue: 0
                    })
                ] : []
            ],
            groupByKeys: false
        });
        if (nodes != null) nodesDataController.execute();
        const [nodesDataModel, linksDataModel] = await Promise.all([
            nodesDataModelPromise,
            linksDataModelPromise
        ]);
        this.nodesDataModel = nodesDataModel?.dataModel;
        this.nodesProcessedData = nodesDataModel?.processedData;
        this.linksDataModel = linksDataModel?.dataModel;
        this.linksProcessedData = linksDataModel?.processedData;
        const processedNodes = /* @__PURE__ */ new Map();
        if (nodesDataModel == null) {
            const fromIdValues = linksDataModel.dataModel.resolveColumnById(this, "fromValue", linksDataModel.processedData);
            const toIdValues = linksDataModel.dataModel.resolveColumnById(this, "toValue", linksDataModel.processedData);
            const createImplicitNode = (id)=>{
                const datumIndex = processedNodes.size;
                const label = id;
                return {
                    series: this,
                    itemId: void 0,
                    datum: {},
                    // Must be a referential object for tooltips
                    datumIndex: {
                        type: 1 /* Node */ ,
                        index: datumIndex
                    },
                    type: 1 /* Node */ ,
                    index: datumIndex,
                    linksBefore: [],
                    linksAfter: [],
                    id: id,
                    size: 0,
                    label: label
                };
            };
            linksDataModel.processedData.dataSources.get(this.id)?.forEach((_datum, datumIndex)=>{
                const fromId = fromIdValues[datumIndex];
                const toId = toIdValues[datumIndex];
                if (fromId == null || toId == null) return;
                if (!processedNodes.has(fromId)) processedNodes.set(fromId, createImplicitNode(fromId));
                if (!processedNodes.has(toId)) processedNodes.set(toId, createImplicitNode(toId));
            });
        } else {
            const nodeIdValues = nodesDataModel.dataModel.resolveColumnById(this, "idValue", nodesDataModel.processedData);
            const labelValues = labelKey != null ? nodesDataModel.dataModel.resolveColumnById(this, "labelValue", nodesDataModel.processedData) : void 0;
            nodesDataModel.processedData.dataSources.get(this.id)?.forEach((datum, datumIndex)=>{
                const id = nodeIdValues[datumIndex];
                const label = labelValues?.[datumIndex];
                processedNodes.set(id, {
                    series: this,
                    itemId: void 0,
                    datum: datum,
                    datumIndex: {
                        type: 1 /* Node */ ,
                        index: datumIndex
                    },
                    type: 1 /* Node */ ,
                    index: datumIndex,
                    linksBefore: [],
                    linksAfter: [],
                    id: id,
                    size: 0,
                    label: label
                });
            });
        }
        this.processedNodes = processedNodes;
    }
    getNodeGraph(createNode, createLink, { includeCircularReferences: includeCircularReferences }) {
        const { linksDataModel: linksDataModel, linksProcessedData: linksProcessedData } = this;
        if (linksDataModel == null || linksProcessedData == null) {
            const { links: links2, nodeGraph: nodeGraph2, maxPathLength: maxPathLength2 } = $2fb96651e8aa1522$var$computeNodeGraph(/* @__PURE__ */ new Map().values(), [], includeCircularReferences);
            this.nodeCount = 0;
            this.linkCount = 0;
            return {
                nodeGraph: nodeGraph2,
                links: links2,
                maxPathLength: maxPathLength2
            };
        }
        const { sizeKey: sizeKey } = this.properties;
        const fromIdValues = linksDataModel.resolveColumnById(this, "fromValue", linksProcessedData);
        const toIdValues = linksDataModel.resolveColumnById(this, "toValue", linksProcessedData);
        const sizeValues = sizeKey != null ? linksDataModel.resolveColumnById(this, "sizeValue", linksProcessedData) : void 0;
        const nodesById = /* @__PURE__ */ new Map();
        this.processedNodes.forEach((datum)=>{
            const node = createNode(datum);
            nodesById.set(datum.id, node);
        });
        const baseLinks = [];
        linksProcessedData.dataSources.get(this.id)?.forEach((datum, datumIndex)=>{
            const fromId = fromIdValues[datumIndex];
            const toId = toIdValues[datumIndex];
            const size = sizeValues != null ? sizeValues[datumIndex] : 1;
            const fromNode = nodesById.get(fromId);
            const toNode = nodesById.get(toId);
            if (size <= 0 || fromNode == null || toNode == null) return;
            const link = createLink({
                series: this,
                itemId: void 0,
                datum: datum,
                datumIndex: {
                    type: 0 /* Link */ ,
                    index: datumIndex
                },
                type: 0 /* Link */ ,
                index: datumIndex,
                fromNode: fromNode,
                toNode: toNode,
                size: size
            });
            baseLinks.push(link);
        });
        const { links: links, nodeGraph: nodeGraph, maxPathLength: maxPathLength } = $2fb96651e8aa1522$var$computeNodeGraph(nodesById.values(), baseLinks, includeCircularReferences);
        nodeGraph.forEach((node)=>{
            node.datum.linksBefore = node.linksBefore.map((linkedNode)=>linkedNode.link);
            node.datum.linksAfter = node.linksAfter.map((linkedNode)=>linkedNode.link);
        });
        this.nodeCount = nodeGraph.size;
        this.linkCount = links.length;
        return {
            nodeGraph: nodeGraph,
            links: links,
            maxPathLength: maxPathLength
        };
    }
    updateSelections() {
        if (this.nodeDataRefresh) {
            this.contextNodeData = this.createNodeData();
            this.nodeDataRefresh = false;
        }
    }
    update(opts) {
        const { seriesRect: seriesRect } = opts;
        const newNodeDataDependencies = {
            seriesRectWidth: seriesRect?.width ?? 0,
            seriesRectHeight: seriesRect?.height ?? 0
        };
        if (this._nodeDataDependencies == null || this._nodeDataDependencies.seriesRectWidth !== newNodeDataDependencies.seriesRectWidth || this._nodeDataDependencies.seriesRectHeight !== newNodeDataDependencies.seriesRectHeight) this._nodeDataDependencies = newNodeDataDependencies;
        this.updateSelections();
        const nodeData = this.contextNodeData?.nodeData ?? [];
        const labelData = this.contextNodeData?.labelData ?? [];
        let highlightedDatum = this.ctx.highlightManager?.getActiveHighlight();
        if (highlightedDatum?.series === this && highlightedDatum.type == null) {
            const { itemId: itemId } = highlightedDatum;
            highlightedDatum = itemId != null ? nodeData.find((node)=>node.type === 1 /* Node */  && node.id === itemId) : void 0;
        } else if (highlightedDatum?.series !== this) highlightedDatum = void 0;
        this.contentGroup.visible = this.visible;
        this.contentGroup.opacity = highlightedDatum != null ? this.properties.highlightStyle.series.dimOpacity ?? 1 : 1;
        this.labelSelection = this.updateLabelSelection({
            labelData: labelData,
            labelSelection: this.labelSelection
        });
        this.updateLabelNodes({
            labelSelection: this.labelSelection
        });
        this.linkSelection = this.updateLinkSelection({
            nodeData: nodeData.filter((d)=>d.type === 0 /* Link */ ),
            datumSelection: this.linkSelection
        });
        this.updateLinkNodes({
            datumSelection: this.linkSelection,
            isHighlight: false
        });
        this.nodeSelection = this.updateNodeSelection({
            nodeData: nodeData.filter((d)=>d.type === 1 /* Node */ ),
            datumSelection: this.nodeSelection
        });
        this.updateNodeNodes({
            datumSelection: this.nodeSelection,
            isHighlight: false
        });
        let focusLinkSelection;
        let focusNodeSelection;
        let highlightLinkSelection;
        let highlightNodeSelection;
        if (highlightedDatum?.type === 1 /* Node */ ) {
            focusLinkSelection = nodeData.filter((node)=>{
                return node.type === 0 /* Link */  && (node.toNode === highlightedDatum || node.fromNode === highlightedDatum);
            });
            focusNodeSelection = focusLinkSelection.map((link)=>{
                return link.fromNode === highlightedDatum ? link.toNode : link.fromNode;
            });
            focusNodeSelection.push(highlightedDatum);
            highlightLinkSelection = [];
            highlightNodeSelection = [
                highlightedDatum
            ];
        } else if (highlightedDatum?.type === 0 /* Link */ ) {
            focusLinkSelection = [
                highlightedDatum
            ];
            focusNodeSelection = [
                highlightedDatum.fromNode,
                highlightedDatum.toNode
            ];
            highlightLinkSelection = [
                highlightedDatum
            ];
            highlightNodeSelection = [];
        } else {
            focusLinkSelection = [];
            focusNodeSelection = [];
            highlightLinkSelection = [];
            highlightNodeSelection = [];
        }
        this.focusLinkSelection = this.updateLinkSelection({
            nodeData: focusLinkSelection,
            datumSelection: this.focusLinkSelection
        });
        this.updateLinkNodes({
            datumSelection: this.focusLinkSelection,
            isHighlight: false
        });
        this.focusNodeSelection = this.updateNodeSelection({
            nodeData: focusNodeSelection,
            datumSelection: this.focusNodeSelection
        });
        this.updateNodeNodes({
            datumSelection: this.focusNodeSelection,
            isHighlight: false
        });
        this.highlightLinkSelection = this.updateLinkSelection({
            nodeData: highlightLinkSelection,
            datumSelection: this.highlightLinkSelection
        });
        this.updateLinkNodes({
            datumSelection: this.highlightLinkSelection,
            isHighlight: true
        });
        this.highlightNodeSelection = this.updateNodeSelection({
            nodeData: highlightNodeSelection,
            datumSelection: this.highlightNodeSelection
        });
        this.updateNodeNodes({
            datumSelection: this.highlightNodeSelection,
            isHighlight: true
        });
    }
    resetAnimation(_chartAnimationPhase) {}
    getSeriesDomain(_direction) {
        return [];
    }
    getSeriesRange(_direction, _visibleRange) {
        return [
            NaN,
            NaN
        ];
    }
    legendItemSymbol(_type, nodeIndex, format = {}) {
        const { fills: fills, strokes: strokes } = this.properties;
        const { fill: fill = fills[nodeIndex % fills.length], fillOpacity: fillOpacity = 1, stroke: stroke2 = strokes[nodeIndex % strokes.length], strokeWidth: strokeWidth = 0, strokeOpacity: strokeOpacity = 1, lineDash: lineDash = [
            0
        ], lineDashOffset: lineDashOffset = 0 } = format;
        return {
            marker: {
                fill: fill,
                fillOpacity: fillOpacity,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                strokeOpacity: strokeOpacity,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset
            }
        };
    }
    getLegendData(legendType) {
        if (legendType !== "category") return [];
        const { showInLegend: showInLegend } = this.properties;
        return Array.from(this.processedNodes.values(), ({ id: id, label: label }, nodeIndex)=>({
                legendType: "category",
                id: this.id,
                itemId: id,
                seriesId: this.id,
                enabled: true,
                label: {
                    text: label ?? id
                },
                symbol: this.legendItemSymbol(1 /* Node */ , nodeIndex),
                hideInLegend: !showInLegend,
                isFixed: true
            }));
    }
    pickNodeClosestDatum({ x: x, y: y }) {
        let minDistanceSquared = Infinity;
        let minDatum;
        this.linkSelection.each((node, datum)=>{
            const distanceSquared = node.containsPoint(x, y) ? 0 : Infinity;
            if (distanceSquared < minDistanceSquared) {
                minDistanceSquared = distanceSquared;
                minDatum = datum;
            }
        });
        this.nodeSelection.each((node, datum)=>{
            const distanceSquared = node.distanceSquared(x, y);
            if (distanceSquared < minDistanceSquared) {
                minDistanceSquared = distanceSquared;
                minDatum = datum;
            }
        });
        return minDatum != null ? {
            datum: minDatum,
            distance: Math.sqrt(minDistanceSquared)
        } : void 0;
    }
    getDatumAriaText(datum, description) {
        if (datum.type === 0 /* Link */ ) return this.ctx.localeManager.t("ariaAnnounceFlowProportionLink", {
            index: datum.index + 1,
            count: this.linkCount,
            from: datum.fromNode.id,
            to: datum.toNode.id,
            size: datum.size,
            sizeName: this.properties.sizeName ?? this.properties.sizeKey
        });
        else if (datum.type === 1 /* Node */ ) return this.ctx.localeManager.t("ariaAnnounceFlowProportionNode", {
            index: datum.index + 1,
            count: this.nodeCount,
            description: description
        });
    }
    pickFocus(opts) {
        const { datumIndexDelta: childDelta, otherIndexDelta: depthDelta } = opts;
        const currentNodeDatum = this.contextNodeData?.nodeData[opts.datumIndex - opts.datumIndexDelta];
        let nextNodeDatum = currentNodeDatum;
        if (depthDelta !== 0 || childDelta === 0) return;
        if (currentNodeDatum?.type === 0 /* Link */ ) {
            const allLinks = Array.from(this.linkSelection, (link)=>link.datum);
            const selfIndex = allLinks.indexOf(currentNodeDatum);
            const nextIndex = selfIndex + childDelta;
            if (nextIndex >= 0 && nextIndex < allLinks.length) nextNodeDatum = allLinks[nextIndex];
            else if (nextIndex > 0) nextNodeDatum = allLinks[allLinks.length - 1];
            else {
                const allNodes = Array.from(this.nodeSelection, (node)=>node.datum);
                nextNodeDatum = allNodes[allNodes.length - 1];
            }
        } else if (currentNodeDatum?.type === 1 /* Node */ ) {
            const allNodes = Array.from(this.nodeSelection, (node)=>node.datum);
            const selfIndex = allNodes.indexOf(currentNodeDatum);
            const nextIndex = selfIndex + childDelta;
            if (nextIndex >= 0 && nextIndex < allNodes.length) nextNodeDatum = allNodes[nextIndex];
            else if (nextIndex < 0) nextNodeDatum = allNodes[0];
            else {
                const allLinks = Array.from(this.linkSelection, (link)=>link.datum);
                nextNodeDatum = allLinks[0];
            }
        }
        if (nextNodeDatum == null) return;
        const nodeDatum = nextNodeDatum.type === 1 /* Node */  ? Array.from(this.nodeSelection).find((n)=>n.datum === nextNodeDatum) : Array.from(this.linkSelection).find((n)=>n.datum === nextNodeDatum);
        if (nodeDatum == null) return;
        const bounds = this.computeFocusBounds(nodeDatum.node);
        if (bounds == null) return;
        return {
            datum: nodeDatum.datum,
            datumIndex: this.contextNodeData?.nodeData.indexOf(nodeDatum.datum) ?? 0,
            otherIndex: 0,
            bounds: bounds,
            clipFocusBox: true
        };
    }
    getCategoryValue(_datumIndex) {
        return;
    }
    datumIndexForCategoryValue(_categoryValue) {
        return;
    }
};
var { Path: $2fb96651e8aa1522$var$Path8, SceneChangeDetection: $2fb96651e8aa1522$var$SceneChangeDetection6 } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$bezierControlPoints({ radius: radius, startAngle: startAngle, endAngle: endAngle, tension: tension }) {
    const cp0x = radius * Math.cos(startAngle);
    const cp0y = radius * Math.sin(startAngle);
    const cp3x = radius * Math.cos(endAngle);
    const cp3y = radius * Math.sin(endAngle);
    const cp1x = cp0x * tension;
    const cp1y = cp0y * tension;
    const cp2x = cp3x * tension;
    const cp2y = cp3y * tension;
    return {
        x: [
            cp0x,
            cp1x,
            cp2x,
            cp3x
        ],
        y: [
            cp0y,
            cp1y,
            cp2y,
            cp3y
        ]
    };
}
var $2fb96651e8aa1522$var$ChordLink = class extends $2fb96651e8aa1522$var$Path8 {
    constructor(){
        super(...arguments);
        this.centerX = 0;
        this.centerY = 0;
        this.radius = 0;
        this.startAngle1 = 0;
        this.endAngle1 = 0;
        this.startAngle2 = 0;
        this.endAngle2 = 0;
        this.tension = 1;
    }
    tensionedCurveTo(cp0x, cp0y, cp1x, cp1y, cp2x, cp2y, cp3x, cp3y) {
        const { path: path, tension: tension } = this;
        const scale = 1 - tension;
        path.cubicCurveTo((cp1x - cp0x) * scale + cp0x, (cp1y - cp0y) * scale + cp0y, (cp2x - cp3x) * scale + cp3x, (cp2y - cp3y) * scale + cp3y, cp3x, cp3y);
    }
    updatePath() {
        const { path: path, centerX: centerX, centerY: centerY, radius: radius } = this;
        let { startAngle1: startAngle1, endAngle1: endAngle1, startAngle2: startAngle2, endAngle2: endAngle2 } = this;
        if (startAngle1 > startAngle2) {
            [startAngle1, startAngle2] = [
                startAngle2,
                startAngle1
            ];
            [endAngle1, endAngle2] = [
                endAngle2,
                endAngle1
            ];
        }
        path.clear();
        const startX = centerX + radius * Math.cos(startAngle1);
        const startY = centerY + radius * Math.sin(startAngle1);
        path.moveTo(startX, startY);
        this.tensionedCurveTo(startX, startY, centerX, centerY, centerX, centerY, centerX + radius * Math.cos(endAngle2), centerY + radius * Math.sin(endAngle2));
        path.arc(centerX, centerY, radius, endAngle2, startAngle2, true);
        this.tensionedCurveTo(centerX + radius * Math.cos(startAngle2), centerY + radius * Math.sin(startAngle2), centerX, centerY, centerX, centerY, centerX + radius * Math.cos(endAngle1), centerY + radius * Math.sin(endAngle1));
        path.arc(centerX, centerY, radius, endAngle1, startAngle1, true);
        path.closePath();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection6()
], $2fb96651e8aa1522$var$ChordLink.prototype, "centerX", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection6()
], $2fb96651e8aa1522$var$ChordLink.prototype, "centerY", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection6()
], $2fb96651e8aa1522$var$ChordLink.prototype, "radius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection6()
], $2fb96651e8aa1522$var$ChordLink.prototype, "startAngle1", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection6()
], $2fb96651e8aa1522$var$ChordLink.prototype, "endAngle1", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection6()
], $2fb96651e8aa1522$var$ChordLink.prototype, "startAngle2", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection6()
], $2fb96651e8aa1522$var$ChordLink.prototype, "endAngle2", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection6()
], $2fb96651e8aa1522$var$ChordLink.prototype, "tension", 2);
var { FillGradientDefaults: $2fb96651e8aa1522$var$FillGradientDefaults6, FillPatternDefaults: $2fb96651e8aa1522$var$FillPatternDefaults6, FillImageDefaults: $2fb96651e8aa1522$var$FillImageDefaults6, BaseProperties: $2fb96651e8aa1522$var$BaseProperties23, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip8, SeriesProperties: $2fb96651e8aa1522$var$SeriesProperties, Property: $2fb96651e8aa1522$var$Property65, Label: $2fb96651e8aa1522$var$Label6 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$ChordSeriesLabelProperties = class extends $2fb96651e8aa1522$var$Label6 {
    constructor(){
        super(...arguments);
        this.spacing = 1;
        this.maxWidth = 1;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesLabelProperties.prototype, "spacing", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesLabelProperties.prototype, "maxWidth", 2);
var $2fb96651e8aa1522$var$ChordSeriesLinkProperties = class extends $2fb96651e8aa1522$var$BaseProperties23 {
    constructor(){
        super(...arguments);
        this.fill = void 0;
        this.fillOpacity = 1;
        this.stroke = void 0;
        this.strokeOpacity = 1;
        this.strokeWidth = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.tension = 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesLinkProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesLinkProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesLinkProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesLinkProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesLinkProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesLinkProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesLinkProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesLinkProperties.prototype, "tension", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesLinkProperties.prototype, "itemStyler", 2);
var $2fb96651e8aa1522$var$ChordSeriesNodeProperties = class extends $2fb96651e8aa1522$var$BaseProperties23 {
    constructor(){
        super(...arguments);
        this.spacing = 1;
        this.width = 1;
        this.fill = void 0;
        this.fillOpacity = 1;
        this.stroke = void 0;
        this.strokeOpacity = 1;
        this.strokeWidth = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesNodeProperties.prototype, "spacing", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesNodeProperties.prototype, "width", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesNodeProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesNodeProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesNodeProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesNodeProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesNodeProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesNodeProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesNodeProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesNodeProperties.prototype, "itemStyler", 2);
var $2fb96651e8aa1522$var$ChordSeriesProperties = class extends $2fb96651e8aa1522$var$SeriesProperties {
    constructor(){
        super(...arguments);
        this.idKey = "";
        this.idName = void 0;
        this.labelKey = void 0;
        this.labelName = void 0;
        this.sizeKey = void 0;
        this.sizeName = void 0;
        this.nodes = void 0;
        this.fillGradientDefaults = new $2fb96651e8aa1522$var$FillGradientDefaults6();
        this.fillPatternDefaults = new $2fb96651e8aa1522$var$FillPatternDefaults6();
        this.fillImageDefaults = new $2fb96651e8aa1522$var$FillImageDefaults6();
        this.fills = [];
        this.strokes = [];
        this.label = new $2fb96651e8aa1522$var$ChordSeriesLabelProperties();
        this.link = new $2fb96651e8aa1522$var$ChordSeriesLinkProperties();
        this.node = new $2fb96651e8aa1522$var$ChordSeriesNodeProperties();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip8();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "fromKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "toKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "idKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "idName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "labelKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "labelName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "sizeKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "sizeName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "nodes", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "fillGradientDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "fillPatternDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "fillImageDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "fills", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "strokes", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "link", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "node", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property65
], $2fb96651e8aa1522$var$ChordSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-enterprise/src/series/chord/chordSeries.ts
var { SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode6, CachedTextMeasurerPool: $2fb96651e8aa1522$var$CachedTextMeasurerPool4, TextWrapper: $2fb96651e8aa1522$var$TextWrapper5, TextUtils: $2fb96651e8aa1522$var$TextUtils5, createDatumId: $2fb96651e8aa1522$var$createDatumId9, angleBetween: $2fb96651e8aa1522$var$angleBetween2, normalizeAngle360: $2fb96651e8aa1522$var$normalizeAngle3604, isBetweenAngles: $2fb96651e8aa1522$var$isBetweenAngles, Sector: $2fb96651e8aa1522$var$Sector3, evaluateBezier: $2fb96651e8aa1522$var$evaluateBezier, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle6, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle7, BBox: $2fb96651e8aa1522$var$BBox14 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$nodeMidAngle = (node)=>node.startAngle + $2fb96651e8aa1522$var$angleBetween2(node.startAngle, node.endAngle) / 2;
var $2fb96651e8aa1522$var$ChordSeries = class extends $2fb96651e8aa1522$var$FlowProportionSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode6.NEAREST_NODE,
                $2fb96651e8aa1522$var$SeriesNodePickMode6.EXACT_SHAPE_MATCH
            ]
        });
        this.properties = new $2fb96651e8aa1522$var$ChordSeriesProperties();
    }
    isLabelEnabled() {
        return (this.properties.labelKey != null || this.nodes == null) && this.properties.label.enabled;
    }
    linkFactory() {
        return new $2fb96651e8aa1522$var$ChordLink();
    }
    nodeFactory() {
        return new $2fb96651e8aa1522$var$Sector3();
    }
    createNodeData() {
        const { id: seriesId, _nodeDataDependencies: { seriesRectWidth: seriesRectWidth, seriesRectHeight: seriesRectHeight } = {
            seriesRectWidth: 0,
            seriesRectHeight: 0
        } } = this;
        const { fromKey: fromKey, toKey: toKey, sizeKey: sizeKey, label: { spacing: labelSpacing, maxWidth: labelMaxWidth, fontSize: fontSize }, node: { width: nodeWidth, spacing: nodeSpacing } } = this.properties;
        const centerX = seriesRectWidth / 2;
        const centerY = seriesRectHeight / 2;
        let labelData = [];
        const { nodeGraph: nodeGraph, links: links } = this.getNodeGraph((node)=>({
                ...node,
                centerX: centerX,
                centerY: centerY,
                innerRadius: NaN,
                outerRadius: NaN,
                startAngle: NaN,
                endAngle: NaN
            }), (link)=>({
                ...link,
                centerX: centerX,
                centerY: centerY,
                radius: NaN,
                startAngle1: NaN,
                endAngle1: NaN,
                startAngle2: NaN,
                endAngle2: NaN
            }), {
            includeCircularReferences: true
        });
        let totalSize = 0;
        nodeGraph.forEach(({ datum: node, linksBefore: linksBefore, linksAfter: linksAfter }, id)=>{
            const size = linksBefore.reduce((acc, { link: link })=>acc + link.size, 0) + linksAfter.reduce((acc, { link: link })=>acc + link.size, 0);
            if (size === 0) nodeGraph.delete(id);
            else {
                node.size = size;
                totalSize += node.size;
                const label = this.getLabelText(this.properties.label, {
                    datum: node.datum,
                    value: node.label,
                    fromKey: fromKey,
                    toKey: toKey,
                    sizeKey: sizeKey,
                    size: node.size
                });
                node.label = String(label);
            }
        });
        let labelInset = 0;
        if (this.isLabelEnabled()) {
            const canvasFont = this.properties.label.getFont();
            let maxMeasuredLabelWidth = 0;
            nodeGraph.forEach(({ datum: node })=>{
                const { id: id, label: label } = node;
                if (label == null) return;
                const text2 = $2fb96651e8aa1522$var$TextWrapper5.wrapText(label, {
                    maxWidth: labelMaxWidth,
                    font: this.properties.label,
                    textWrap: "never"
                });
                const { width: width } = $2fb96651e8aa1522$var$CachedTextMeasurerPool4.measureText(text2, {
                    font: canvasFont,
                    textAlign: "left",
                    textBaseline: "middle"
                });
                maxMeasuredLabelWidth = Math.max(width, maxMeasuredLabelWidth);
                labelData.push({
                    id: id,
                    text: text2,
                    centerX: centerX,
                    centerY: centerY,
                    angle: NaN,
                    radius: NaN
                });
            });
            labelInset = maxMeasuredLabelWidth + labelSpacing;
        }
        const nodeCount = nodeGraph.size;
        let radius = Math.min(seriesRectWidth, seriesRectHeight) / 2 - nodeWidth - labelInset;
        let spacingSweep = nodeSpacing / radius;
        if (labelInset !== 0 && (nodeCount * spacingSweep >= 1.5 * Math.PI || radius <= 0)) {
            labelData = [];
            radius = Math.min(seriesRectWidth, seriesRectHeight) / 2 - nodeWidth;
            spacingSweep = nodeSpacing / radius;
        }
        if (nodeCount * spacingSweep >= 2 * Math.PI || radius <= 0) {
            (0, $idDdm.Logger).warnOnce("There was insufficient space to display the Chord Series.");
            return;
        }
        const innerRadius = radius;
        const outerRadius = radius + nodeWidth;
        const sizeScale = Math.max((2 * Math.PI - nodeCount * spacingSweep) / totalSize, 0);
        let nodeAngle = 0;
        nodeGraph.forEach(({ datum: node })=>{
            node.innerRadius = innerRadius;
            node.outerRadius = outerRadius;
            node.startAngle = nodeAngle;
            node.endAngle = nodeAngle + node.size * sizeScale;
            nodeAngle = node.endAngle + spacingSweep;
            const midR = (node.innerRadius + node.outerRadius) / 2;
            const midAngle = $2fb96651e8aa1522$var$nodeMidAngle(node);
            node.midPoint = {
                x: node.centerX + midR * Math.cos(midAngle),
                y: node.centerY + midR * Math.sin(midAngle)
            };
        });
        const nodeData = [];
        nodeGraph.forEach(({ datum: node, linksBefore: linksBefore, linksAfter: linksAfter })=>{
            const midAngle = $2fb96651e8aa1522$var$nodeMidAngle(node);
            const combinedLinks = [
                ...linksBefore.map((l)=>({
                        link: l.link,
                        distance: $2fb96651e8aa1522$var$angleBetween2($2fb96651e8aa1522$var$nodeMidAngle(l.node.datum), midAngle),
                        after: false
                    })),
                ...linksAfter.map((l)=>({
                        link: l.link,
                        distance: $2fb96651e8aa1522$var$angleBetween2($2fb96651e8aa1522$var$nodeMidAngle(l.node.datum), midAngle),
                        after: true
                    }))
            ];
            let linkAngle = node.startAngle;
            combinedLinks.toSorted((a, b)=>a.distance - b.distance).forEach(({ link: link, after: after })=>{
                const linkSweep = link.size * sizeScale;
                if (after) {
                    link.startAngle1 = linkAngle;
                    link.endAngle1 = linkAngle + linkSweep;
                } else {
                    link.startAngle2 = linkAngle;
                    link.endAngle2 = linkAngle + linkSweep;
                }
                linkAngle += link.size * sizeScale;
            });
            nodeData.push(node);
        });
        const { tension: tension } = this.properties.link;
        links.forEach((link)=>{
            link.radius = radius;
            const outer = $2fb96651e8aa1522$var$bezierControlPoints({
                radius: radius,
                startAngle: link.startAngle1,
                endAngle: link.endAngle2,
                tension: tension
            });
            const inner = $2fb96651e8aa1522$var$bezierControlPoints({
                radius: radius,
                startAngle: link.startAngle2,
                endAngle: link.endAngle1,
                tension: tension
            });
            const outerX = $2fb96651e8aa1522$var$evaluateBezier(...outer.x, 0.5);
            const outerY = $2fb96651e8aa1522$var$evaluateBezier(...outer.y, 0.5);
            const innerX = $2fb96651e8aa1522$var$evaluateBezier(...inner.x, 0.5);
            const innerY = $2fb96651e8aa1522$var$evaluateBezier(...inner.y, 0.5);
            link.midPoint = {
                x: link.centerX + (outerX + innerX) / 2,
                y: link.centerY + (outerY + innerY) / 2
            };
            nodeData.push(link);
        });
        labelData.forEach((label)=>{
            const node = nodeGraph.get(label.id)?.datum;
            if (node == null) return;
            label.radius = outerRadius + labelSpacing;
            label.angle = $2fb96651e8aa1522$var$normalizeAngle3604(node.startAngle + $2fb96651e8aa1522$var$angleBetween2(node.startAngle, node.endAngle) / 2);
        });
        labelData.sort((a, b)=>a.angle - b.angle);
        let minAngle = Infinity;
        let maxAngle = -Infinity;
        labelData = labelData.filter((label)=>{
            const labelHeight = $2fb96651e8aa1522$var$TextUtils5.getLineHeight(fontSize);
            const da = Math.atan2(labelHeight / 2, label.radius);
            const a0 = label.angle - da;
            const a1 = label.angle + da;
            if ($2fb96651e8aa1522$var$isBetweenAngles(minAngle, a0, a1)) return false;
            if ($2fb96651e8aa1522$var$isBetweenAngles(maxAngle, a0, a1)) return false;
            minAngle = Math.min(a0, minAngle);
            maxAngle = Math.max(a1, maxAngle);
            return true;
        });
        return {
            itemId: seriesId,
            nodeData: nodeData,
            labelData: labelData
        };
    }
    updateLabelSelection(opts) {
        const labels = this.isLabelEnabled() ? opts.labelData : [];
        return opts.labelSelection.update(labels);
    }
    updateLabelNodes(opts) {
        const { labelSelection: labelSelection } = opts;
        const { color: fill, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily } = this.properties.label;
        labelSelection.each((label, { text: text2, centerX: centerX, centerY: centerY, radius: radius, angle: angle })=>{
            label.visible = true;
            label.translationX = centerX + radius * Math.cos(angle);
            label.translationY = centerY + radius * Math.sin(angle);
            label.text = text2;
            label.fill = fill;
            label.fontStyle = fontStyle;
            label.fontWeight = fontWeight;
            label.fontSize = fontSize;
            label.fontFamily = fontFamily;
            label.textBaseline = "middle";
            if (Math.cos(angle) >= 0) {
                label.textAlign = "left";
                label.rotation = angle;
            } else {
                label.textAlign = "right";
                label.rotation = angle - Math.PI;
            }
        });
    }
    updateNodeSelection(opts) {
        return opts.datumSelection.update(opts.nodeData, void 0, (datum)=>$2fb96651e8aa1522$var$createDatumId9([
                datum.type,
                datum.id
            ]));
    }
    getBaseNodeStyle(highlighted) {
        const { properties: properties } = this;
        const { fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = properties.node;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return $2fb96651e8aa1522$var$getShapeStyle7({
            fill: highlightStyle?.fill ?? fill,
            fillOpacity: highlightStyle?.fillOpacity ?? fillOpacity,
            stroke: highlightStyle?.stroke ?? stroke2,
            strokeOpacity: highlightStyle?.strokeOpacity ?? strokeOpacity,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(properties.node.strokeWidth),
            lineDash: highlightStyle?.lineDash ?? lineDash,
            lineDashOffset: highlightStyle?.lineDashOffset ?? lineDashOffset
        }, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
    }
    getNodeStyleOverrides(datumId, datum, datumIndex, size, label, format, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const { fills: fills, strokes: strokes } = properties;
        const { itemStyler: itemStyler } = properties.node;
        const fill = format.fill ?? fills[datumIndex % fills.length];
        const stroke2 = format.stroke ?? strokes[datumIndex % strokes.length];
        let overrides;
        if (!highlighted) {
            overrides ?? (overrides = {});
            overrides.fill = fill;
            overrides.stroke = stroke2;
        }
        if (itemStyler != null) {
            const itemStyle = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId9(datumId, "node", highlighted ? "highlight" : "node"), ()=>{
                const { fillOpacity: fillOpacity = 1, strokeOpacity: strokeOpacity = 1, strokeWidth: strokeWidth = 0, lineDash: lineDash = [], lineDashOffset: lineDashOffset = 0 } = format;
                return this.callWithContext(itemStyler, {
                    seriesId: seriesId,
                    datum: datum,
                    highlighted: highlighted,
                    label: label,
                    size: size,
                    fill: fill,
                    fillOpacity: fillOpacity,
                    stroke: stroke2,
                    strokeOpacity: strokeOpacity,
                    strokeWidth: strokeWidth,
                    lineDash: lineDash,
                    lineDashOffset: lineDashOffset
                });
            });
            overrides ?? (overrides = {});
            Object.assign(overrides, itemStyle);
        }
        return $2fb96651e8aa1522$var$getShapeStyle7(overrides, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
    }
    updateNodeNodes(opts) {
        const { datumSelection: datumSelection, isHighlight: isHighlight } = opts;
        const format = this.getBaseNodeStyle(isHighlight);
        const fillBBox = this.getShapeFillBBox();
        datumSelection.each((sector, datum)=>{
            const { datumIndex: datumIndex, size: size, label: label } = datum;
            const overrides = this.getNodeStyleOverrides(String(datumIndex.index), datum.datum, datumIndex.index, size, label, format, isHighlight);
            $2fb96651e8aa1522$var$applyShapeStyle6(sector, format, overrides, fillBBox);
            sector.centerX = datum.centerX;
            sector.centerY = datum.centerY;
            sector.innerRadius = datum.innerRadius;
            sector.outerRadius = datum.outerRadius;
            sector.startAngle = datum.startAngle;
            sector.endAngle = datum.endAngle;
            sector.inset = sector.strokeWidth / 2;
        });
    }
    updateLinkSelection(opts) {
        return opts.datumSelection.update(opts.nodeData, void 0, (datum)=>$2fb96651e8aa1522$var$createDatumId9([
                datum.type,
                datum.index,
                datum.fromNode.id,
                datum.toNode.id
            ]));
    }
    getBaseLinkStyle(highlighted) {
        const { properties: properties } = this;
        const { fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, tension: tension } = properties.link;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return $2fb96651e8aa1522$var$getShapeStyle7({
            fill: highlightStyle?.fill ?? fill,
            fillOpacity: highlightStyle?.fillOpacity ?? fillOpacity,
            stroke: highlightStyle?.stroke ?? stroke2,
            strokeOpacity: highlightStyle?.strokeOpacity ?? strokeOpacity,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(properties.link.strokeWidth),
            lineDash: highlightStyle?.lineDash ?? lineDash,
            lineDashOffset: highlightStyle?.lineDashOffset ?? lineDashOffset,
            tension: tension
        }, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
    }
    getLinkStyleOverrides(datumId, datum, fromNodeDatumIndex, format, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const { fills: fills, strokes: strokes } = properties;
        const { itemStyler: itemStyler } = properties.link;
        const fill = format.fill ?? fills[fromNodeDatumIndex % fills.length];
        const stroke2 = format.stroke ?? strokes[fromNodeDatumIndex % strokes.length];
        let overrides;
        if (!highlighted) {
            overrides ?? (overrides = {});
            overrides.fill = fill;
            overrides.stroke = stroke2;
        }
        if (itemStyler != null) {
            const itemStyle = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId9(datumId, "link", highlighted ? "highlight" : "node"), ()=>{
                const { fillOpacity: fillOpacity = 1, strokeOpacity: strokeOpacity = 1, strokeWidth: strokeWidth = 0, lineDash: lineDash = [], lineDashOffset: lineDashOffset = 0, tension: tension } = format;
                return this.callWithContext(itemStyler, {
                    seriesId: seriesId,
                    datum: datum,
                    highlighted: highlighted,
                    tension: tension,
                    fill: fill,
                    fillOpacity: fillOpacity,
                    stroke: stroke2,
                    strokeOpacity: strokeOpacity,
                    strokeWidth: strokeWidth,
                    lineDash: lineDash,
                    lineDashOffset: lineDashOffset
                });
            });
            overrides ?? (overrides = {});
            Object.assign(overrides, itemStyle);
        }
        return $2fb96651e8aa1522$var$getShapeStyle7(overrides, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
    }
    updateLinkNodes(opts) {
        const { datumSelection: datumSelection, isHighlight: isHighlight } = opts;
        const style = this.getBaseLinkStyle(isHighlight);
        const fillBBox = this.getShapeFillBBox();
        datumSelection.each((link, datum)=>{
            const { datumIndex: datumIndex } = datum;
            const fromNodeDatumIndex = datum.fromNode.datumIndex;
            const overrides = this.getLinkStyleOverrides(String(datumIndex.index), datum.datum, fromNodeDatumIndex.index, style, isHighlight);
            link.centerX = datum.centerX;
            link.centerY = datum.centerY;
            link.radius = datum.radius;
            link.startAngle1 = datum.startAngle1;
            link.endAngle1 = datum.endAngle1;
            link.startAngle2 = datum.startAngle2;
            link.endAngle2 = datum.endAngle2;
            $2fb96651e8aa1522$var$applyShapeStyle6(link, style, overrides, fillBBox);
            link.tension = overrides?.tension ?? style.tension;
        });
    }
    getShapeFillBBox() {
        const width = this._nodeDataDependencies?.seriesRectWidth ?? 0;
        const height = this._nodeDataDependencies?.seriesRectHeight ?? 0;
        const size = Math.min(width, height);
        const x = (width - size) / 2;
        const y = (height - size) / 2;
        const bbox = new $2fb96651e8aa1522$var$BBox14(x, y, width, height);
        return {
            series: bbox,
            axis: bbox
        };
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, linksProcessedData: linksProcessedData, nodesProcessedData: nodesProcessedData, properties: properties } = this;
        const { fromKey: fromKey, toKey: toKey, sizeKey: sizeKey, sizeName: sizeName, tooltip: tooltip } = properties;
        const seriesDatum = this.contextNodeData?.nodeData.find((d)=>d.datumIndex.type === datumIndex.type && d.datumIndex.index === datumIndex.index);
        if (seriesDatum == null) return;
        const nodeIndex = seriesDatum.type === 0 /* Link */  ? seriesDatum.fromNode.index : seriesDatum.index;
        const title = seriesDatum.type === 0 /* Link */  ? `${seriesDatum.fromNode.label} - ${seriesDatum.toNode.label}` : seriesDatum.label;
        const datum = datumIndex.type === 0 /* Link */  ? linksProcessedData?.dataSources.get(this.id)?.[datumIndex.index] : nodesProcessedData?.dataSources.get(this.id)?.[datumIndex.index];
        const size = seriesDatum.size;
        let format;
        if (seriesDatum.type === 0 /* Link */ ) {
            const fromNodeDatumIndex = seriesDatum.fromNode.datumIndex;
            const linkFormat = this.getBaseLinkStyle(false);
            Object.assign(linkFormat, this.getLinkStyleOverrides(String(datumIndex.index), datum, fromNodeDatumIndex.index, linkFormat, false));
            format = linkFormat;
        } else {
            const label = seriesDatum.label;
            const nodeFormat = this.getBaseNodeStyle(false);
            Object.assign(nodeFormat, this.getNodeStyleOverrides(String(datumIndex.index), datum, datumIndex.index, size, label, nodeFormat, false));
            format = nodeFormat;
        }
        return this.formatTooltipWithContext(tooltip, {
            title: title,
            symbol: this.legendItemSymbol(seriesDatum.type, nodeIndex, format),
            data: sizeKey != null ? [
                {
                    label: sizeName,
                    fallbackLabel: sizeKey,
                    value: String(size)
                }
            ] : []
        }, {
            seriesId: seriesId,
            datum: datum,
            title: title,
            fromKey: fromKey,
            toKey: toKey,
            sizeKey: sizeKey,
            sizeName: sizeName,
            size: size,
            ...format
        });
    }
    computeFocusBounds(node) {
        return node;
    }
};
$2fb96651e8aa1522$var$ChordSeries.className = "ChordSeries";
$2fb96651e8aa1522$var$ChordSeries.type = "chord";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs8, chordSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$chordSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$chordSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$chordSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs8,
    type: (0, $idDdm.required)((0, $idDdm.constant)("chord")),
    fromKey: (0, $idDdm.required)((0, $idDdm.string)),
    toKey: (0, $idDdm.required)((0, $idDdm.string)),
    sizeKey: (0, $idDdm.string),
    sizeName: (0, $idDdm.string)
};
$2fb96651e8aa1522$var$chordSeriesOptionsDef.fillGradientDefaults = (0, $idDdm.undocumented)((0, $idDdm.fillGradientDefaults));
$2fb96651e8aa1522$var$chordSeriesOptionsDef.fillPatternDefaults = (0, $idDdm.undocumented)((0, $idDdm.fillPatternDefaults));
$2fb96651e8aa1522$var$chordSeriesOptionsDef.fillImageDefaults = (0, $idDdm.undocumented)((0, $idDdm.fillImageDefaults));
// packages/ag-charts-enterprise/src/series/chord/chordModule.ts
var $2fb96651e8aa1522$var$ChordModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "flow-proportion"
    ],
    solo: true,
    identifier: "chord",
    tooltipDefaults: {
        range: "exact"
    },
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$ChordSeries(ctx),
    themeTemplate: {
        series: {
            fills: {
                $palette: "fills"
            },
            strokes: {
                $palette: "strokes"
            },
            // @ts-expect-error undocumented option
            fillGradientDefaults: {
                type: "gradient",
                gradient: "linear",
                bounds: "item",
                colorStops: {
                    $palette: "gradient"
                },
                rotation: 0,
                reverse: false
            },
            fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
            fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
            highlightStyle: {
                series: {
                    dimOpacity: 0.2
                }
            },
            label: {
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontSize: {
                    $ref: "fontSize"
                },
                fontWeight: {
                    $ref: "fontWeight"
                },
                color: {
                    $ref: "textColor"
                },
                spacing: 5,
                maxWidth: 100
            },
            node: {
                spacing: 8,
                width: 10,
                strokeWidth: 0
            },
            link: {
                fillOpacity: 0.5,
                strokeWidth: 0,
                tension: 0.4
            }
        },
        legend: {
            enabled: false,
            toggleSeries: false
        }
    }
};
var $2fb96651e8aa1522$var$ChordSeriesModule = {
    type: "series",
    name: "chord",
    chartType: "flow-proportion",
    enterprise: true,
    options: $2fb96651e8aa1522$var$chordSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$ChordSeries(ctx)
};
var { ThemeConstants: { CARTESIAN_AXIS_TYPE: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE7, CARTESIAN_POSITION: $2fb96651e8aa1522$var$CARTESIAN_POSITION5 }, ThemeSymbols: { DEFAULT_SHADOW_COLOUR: $2fb96651e8aa1522$var$DEFAULT_SHADOW_COLOUR } } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$FUNNEL_SERIES_AXES = {
    $if: [
        {
            $eq: [
                {
                    $path: [
                        "/direction",
                        void 0
                    ]
                },
                "horizontal"
            ]
        },
        [
            {
                type: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE7.NUMBER,
                position: $2fb96651e8aa1522$var$CARTESIAN_POSITION5.LEFT
            },
            {
                type: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE7.CATEGORY,
                position: {
                    $if: [
                        {
                            $eq: [
                                {
                                    $path: [
                                        "/stageLabel/placement",
                                        void 0
                                    ]
                                },
                                "before"
                            ]
                        },
                        $2fb96651e8aa1522$var$CARTESIAN_POSITION5.TOP,
                        $2fb96651e8aa1522$var$CARTESIAN_POSITION5.BOTTOM
                    ]
                },
                label: {
                    $omit: [
                        [
                            "placement"
                        ],
                        {
                            $path: [
                                "/stageLabel",
                                void 0
                            ]
                        }
                    ]
                }
            }
        ],
        [
            {
                type: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE7.CATEGORY,
                position: {
                    $if: [
                        {
                            $eq: [
                                {
                                    $path: [
                                        "/stageLabel/placement",
                                        void 0
                                    ]
                                },
                                "after"
                            ]
                        },
                        $2fb96651e8aa1522$var$CARTESIAN_POSITION5.RIGHT,
                        $2fb96651e8aa1522$var$CARTESIAN_POSITION5.LEFT
                    ]
                },
                label: {
                    $omit: [
                        [
                            "placement"
                        ],
                        {
                            $path: [
                                "/stageLabel",
                                void 0
                            ]
                        }
                    ]
                }
            },
            {
                type: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE7.NUMBER,
                position: $2fb96651e8aa1522$var$CARTESIAN_POSITION5.BOTTOM
            }
        ]
    ]
};
var $2fb96651e8aa1522$var$FUNNEL_SERIES_THEME = {
    series: {
        direction: "vertical",
        strokeWidth: 0,
        spacingRatio: 0.25,
        fills: [
            {
                $palette: "fill"
            }
        ],
        strokes: [
            {
                $palette: "stroke"
            }
        ],
        // @ts-expect-error undocumented option
        fillGradientDefaults: {
            type: "gradient",
            gradient: "linear",
            bounds: "item",
            colorStops: {
                $palette: "gradient"
            },
            rotation: 0,
            reverse: false
        },
        fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
        fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
        label: {
            enabled: true,
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            fontWeight: {
                $ref: "fontWeight"
            },
            color: {
                $ref: "backgroundColor"
            }
        },
        dropOff: {
            enabled: true,
            fillOpacity: 0.2,
            strokeWidth: 0
        },
        shadow: {
            enabled: false,
            color: $2fb96651e8aa1522$var$DEFAULT_SHADOW_COLOUR,
            xOffset: 3,
            yOffset: 3,
            blur: 5
        }
    },
    axes: {
        [$2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE7.NUMBER]: {
            nice: false,
            gridLine: {
                enabled: false
            },
            crosshair: {
                enabled: false
            },
            label: {
                enabled: false,
                formatter (params) {
                    return Math.abs(params.value).toFixed(params.fractionDigits ?? 0);
                }
            }
        },
        [$2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE7.CATEGORY]: {
            line: {
                enabled: false
            }
        }
    }
};
var { lineDistanceSquared: $2fb96651e8aa1522$var$lineDistanceSquared, BBox: $2fb96651e8aa1522$var$BBox15, Path: $2fb96651e8aa1522$var$Path9, SceneChangeDetection: $2fb96651e8aa1522$var$SceneChangeDetection7 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$delta = 1e-6;
function $2fb96651e8aa1522$var$pointsEq([ax, ay], [bx, by]) {
    return Math.abs(ax - bx) <= $2fb96651e8aa1522$var$delta && Math.abs(ay - by) <= $2fb96651e8aa1522$var$delta;
}
var $2fb96651e8aa1522$var$FunnelConnector = class extends $2fb96651e8aa1522$var$Path9 {
    constructor(){
        super(...arguments);
        this.x0 = 0;
        this.y0 = 0;
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.x3 = 0;
        this.y3 = 0;
    }
    get midPoint() {
        const { x0: x0, y0: y0, x1: x1, y1: y1, x2: x2, y2: y2, x3: x3, y3: y3 } = this;
        return {
            x: (x0 + x1 + x2 + x3) / 4,
            y: (y0 + y1 + y2 + y3) / 4
        };
    }
    distanceSquared(x, y) {
        if (this.containsPoint(x, y)) return 0;
        const { x0: x0, y0: y0, x1: x1, y1: y1, x2: x2, y2: y2, x3: x3, y3: y3 } = this;
        return Math.min($2fb96651e8aa1522$var$lineDistanceSquared(x, y, x0, y0, x1, y1, Infinity), $2fb96651e8aa1522$var$lineDistanceSquared(x, y, x1, y1, x2, y2, Infinity), $2fb96651e8aa1522$var$lineDistanceSquared(x, y, x2, y2, x3, y3, Infinity), $2fb96651e8aa1522$var$lineDistanceSquared(x, y, x3, y3, x0, y0, Infinity));
    }
    computeBBox() {
        const { x0: x0, y0: y0, x1: x1, y1: y1, x2: x2, y2: y2, x3: x3, y3: y3 } = this;
        const x = Math.min(x0, x1, x2, x3);
        const width = Math.max(x0, x1, x2, x3) - x;
        const y = Math.min(y0, y1, y2, y3);
        const height = Math.max(y0, y1, y2, y3) - y;
        return new $2fb96651e8aa1522$var$BBox15(x, y, width, height);
    }
    updatePath() {
        const { path: path, x0: x0, y0: y0, x1: x1, y1: y1, x2: x2, y2: y2, x3: x3, y3: y3 } = this;
        const points = [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ],
            [
                x2,
                y2
            ],
            [
                x3,
                y3
            ]
        ];
        path.clear();
        let start;
        let current;
        points.forEach((p)=>{
            if (start != null && $2fb96651e8aa1522$var$pointsEq(start, p) || current != null && $2fb96651e8aa1522$var$pointsEq(current, p)) return;
            const [x, y] = p;
            if (start == null) path.moveTo(x, y);
            else path.lineTo(x, y);
            start ?? (start = p);
            current = p;
        });
        path.closePath();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection7()
], $2fb96651e8aa1522$var$FunnelConnector.prototype, "x0", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection7()
], $2fb96651e8aa1522$var$FunnelConnector.prototype, "y0", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection7()
], $2fb96651e8aa1522$var$FunnelConnector.prototype, "x1", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection7()
], $2fb96651e8aa1522$var$FunnelConnector.prototype, "y1", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection7()
], $2fb96651e8aa1522$var$FunnelConnector.prototype, "x2", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection7()
], $2fb96651e8aa1522$var$FunnelConnector.prototype, "y2", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection7()
], $2fb96651e8aa1522$var$FunnelConnector.prototype, "x3", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection7()
], $2fb96651e8aa1522$var$FunnelConnector.prototype, "y3", 2);
var { NODE_UPDATE_STATE_TO_PHASE_MAPPING: $2fb96651e8aa1522$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$connectorStartingPosition(datum, _prevDatum, isVertical, _mode) {
    const { x0: x0, y0: y0, x1: x1, y1: y1, x2: x2, y2: y2, x3: x3, y3: y3, opacity: opacity } = datum;
    if (isVertical) return {
        x0: (x0 + x3) / 2,
        y0: (y0 + y3) / 2,
        x1: (x1 + x2) / 2,
        y1: (y1 + y2) / 2,
        x2: (x1 + x2) / 2,
        y2: (y1 + y2) / 2,
        x3: (x0 + x3) / 2,
        y3: (y0 + y3) / 2,
        opacity: opacity
    };
    else return {
        x0: (x0 + x1) / 2,
        y0: (y0 + y1) / 2,
        x1: (x0 + x1) / 2,
        y1: (y0 + y1) / 2,
        x2: (x2 + x3) / 2,
        y2: (y2 + y3) / 2,
        x3: (x2 + x3) / 2,
        y3: (y2 + y3) / 2,
        opacity: opacity
    };
}
function $2fb96651e8aa1522$var$prepareConnectorAnimationFunctions(isVertical, mode) {
    const isRemoved = (datum)=>datum == null;
    const fromFn = (connector, datum, status)=>{
        if (status === "updated" && isRemoved(datum)) status = "removed";
        else if (status === "updated" && isRemoved(connector.previousDatum)) status = "added";
        let source;
        if (status === "added" && connector.previousDatum == null && mode === "fade") source = {
            ...$2fb96651e8aa1522$var$resetConnectorSelectionsFn(connector, datum),
            opacity: 0
        };
        else if (status === "unknown" || status === "added") source = $2fb96651e8aa1522$var$connectorStartingPosition(datum, connector.previousDatum, isVertical, mode);
        else source = {
            x0: connector.x0,
            y0: connector.y0,
            x1: connector.x1,
            y1: connector.y1,
            x2: connector.x2,
            y2: connector.y2,
            x3: connector.x3,
            y3: connector.y3,
            opacity: connector.opacity
        };
        const phase = $2fb96651e8aa1522$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[status];
        return {
            ...source,
            phase: phase
        };
    };
    const toFn = (connector, datum, status)=>{
        let source;
        if (status === "removed" && connector.datum == null && mode === "fade") source = {
            ...$2fb96651e8aa1522$var$resetConnectorSelectionsFn(connector, datum),
            opacity: 0
        };
        else if (status === "removed" || isRemoved(datum)) source = $2fb96651e8aa1522$var$connectorStartingPosition(datum, connector.previousDatum, isVertical, mode);
        else source = $2fb96651e8aa1522$var$resetConnectorSelectionsFn(connector, datum);
        return source;
    };
    return {
        fromFn: fromFn,
        toFn: toFn
    };
}
function $2fb96651e8aa1522$var$resetConnectorSelectionsFn(_node, datum) {
    const { x0: x0, y0: y0, x1: x1, y1: y1, x2: x2, y2: y2, x3: x3, y3: y3, opacity: opacity } = datum;
    return {
        x0: x0,
        y0: y0,
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        x3: x3,
        y3: y3,
        opacity: opacity
    };
}
// packages/ag-charts-enterprise/src/series/funnel/baseFunnelSeries.ts
var { SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode7, SeriesZIndexMap: $2fb96651e8aa1522$var$SeriesZIndexMap, valueProperty: $2fb96651e8aa1522$var$valueProperty11, keyProperty: $2fb96651e8aa1522$var$keyProperty8, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection24, updateLabelNode: $2fb96651e8aa1522$var$updateLabelNode4, SMALLEST_KEY_INTERVAL: $2fb96651e8aa1522$var$SMALLEST_KEY_INTERVAL4, LARGEST_KEY_INTERVAL: $2fb96651e8aa1522$var$LARGEST_KEY_INTERVAL2, diff: $2fb96651e8aa1522$var$diff5, fixNumericExtent: $2fb96651e8aa1522$var$fixNumericExtent7, seriesLabelFadeInAnimation: $2fb96651e8aa1522$var$seriesLabelFadeInAnimation4, resetMotion: $2fb96651e8aa1522$var$resetMotion2, resetLabelFn: $2fb96651e8aa1522$var$resetLabelFn4, animationValidation: $2fb96651e8aa1522$var$animationValidation6, computeBarFocusBounds: $2fb96651e8aa1522$var$computeBarFocusBounds6, ContinuousScale: $2fb96651e8aa1522$var$ContinuousScale9, Group: $2fb96651e8aa1522$var$Group11, Selection: $2fb96651e8aa1522$var$Selection6, PointerEvents: $2fb96651e8aa1522$var$PointerEvents4, motion: $2fb96651e8aa1522$var$motion4, checkCrisp: $2fb96651e8aa1522$var$checkCrisp3, createDatumId: $2fb96651e8aa1522$var$createDatumId10, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle7, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle8, getShapeFill: $2fb96651e8aa1522$var$getShapeFill3 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$FunnelSeriesNodeEvent = class extends (0, $iTJTu._ModuleSupport).SeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.xKey = series.properties.stageKey;
        this.yKey = series.properties.valueKey;
    }
};
var $2fb96651e8aa1522$var$BaseFunnelSeries = class extends (0, $iTJTu._ModuleSupport).AbstractBarSeries {
    constructor({ moduleCtx: moduleCtx, animationResetFns: animationResetFns }){
        super({
            moduleCtx: moduleCtx,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode7.AXIS_ALIGNED,
                $2fb96651e8aa1522$var$SeriesNodePickMode7.EXACT_SHAPE_MATCH
            ],
            hasHighlightedLabels: true,
            directionKeys: {
                x: [
                    "stageKey"
                ],
                y: [
                    "valueKey"
                ]
            },
            directionNames: {
                x: [],
                y: []
            },
            categoryKey: "xValue",
            datumSelectionGarbageCollection: false,
            animationResetFns: {
                datum: animationResetFns.datum,
                label: $2fb96651e8aa1522$var$resetLabelFn4
            }
        });
        // @ts-expect-error xKey/yKey renamed
        this.NodeEvent = $2fb96651e8aa1522$var$FunnelSeriesNodeEvent;
        this.connectorNodeGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group11({
            name: `${this.id}-series-connectorNodes`,
            zIndex: $2fb96651e8aa1522$var$SeriesZIndexMap.BACKGROUND
        }));
        this.connectorSelection = $2fb96651e8aa1522$var$Selection6.select(this.connectorNodeGroup, ()=>this.connectionFactory());
        this.connectorNodeGroup.pointerEvents = $2fb96651e8aa1522$var$PointerEvents4.None;
    }
    get pickModeAxis() {
        return "main-category";
    }
    setSeriesIndex(index) {
        if (!super.setSeriesIndex(index)) return false;
        this.connectorNodeGroup.zIndex = [
            $2fb96651e8aa1522$var$SeriesZIndexMap.BACKGROUND,
            index
        ];
        return true;
    }
    isVertical() {
        return !super.isVertical();
    }
    connectionFactory() {
        return new $2fb96651e8aa1522$var$FunnelConnector();
    }
    async processData(dataController) {
        const { stageKey: stageKey, valueKey: valueKey } = this.properties;
        const { visible: visible, id: seriesId } = this;
        const validation = (_value, _datum, index)=>visible && this.ctx.legendManager.getItemEnabled({
                seriesId: seriesId,
                itemId: index
            });
        const xScale = this.getCategoryAxis()?.scale;
        const yScale = this.getValueAxis()?.scale;
        const { isContinuousX: isContinuousX, xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
            xScale: xScale,
            yScale: yScale
        });
        const extraProps = [];
        if (!this.ctx.animationManager.isSkipped()) {
            if (this.processedData) extraProps.push($2fb96651e8aa1522$var$diff5(this.id, this.processedData));
            extraProps.push($2fb96651e8aa1522$var$animationValidation6());
        }
        const visibleProps = this.visible ? {} : {
            forceValue: 0
        };
        const { processedData: processedData } = await this.requestDataModel(dataController, this.data, {
            props: [
                $2fb96651e8aa1522$var$keyProperty8(stageKey, xScaleType, {
                    id: "xValue"
                }),
                $2fb96651e8aa1522$var$valueProperty11(valueKey, yScaleType, {
                    id: `yValue`,
                    ...visibleProps,
                    validation: validation,
                    invalidValue: 0
                }),
                ...isContinuousX ? [
                    $2fb96651e8aa1522$var$SMALLEST_KEY_INTERVAL4,
                    $2fb96651e8aa1522$var$LARGEST_KEY_INTERVAL2
                ] : [],
                ...extraProps
            ],
            groupByKeys: false
        });
        this.smallestDataInterval = processedData.reduced?.smallestKeyInterval;
        this.largestDataInterval = processedData.reduced?.largestKeyInterval;
        this.animationState.transition("updateData");
    }
    getSeriesDomain(direction) {
        const { processedData: processedData, dataModel: dataModel, id: seriesId, ctx: { legendManager: legendManager } } = this;
        if (!processedData || !dataModel) return [];
        const { keys: [keys] } = processedData.domain;
        if (direction === this.getCategoryDirection()) {
            const keyDef = dataModel.resolveProcessedDataDefById(this, `xValue`);
            if (keyDef?.def.type === "key" && keyDef?.def.valueType === "category") {
                if (!this.hasData) return [];
                return keys.filter((_key, index)=>legendManager.getItemEnabled({
                        seriesId: seriesId,
                        itemId: index
                    }));
            }
            return this.padBandExtent(keys);
        } else {
            const yExtent = this.domainForClippedRange(direction, [
                "yValue"
            ], "xValue", true);
            const maxExtent = Math.max(...yExtent);
            const fixedYExtent = [
                -maxExtent,
                maxExtent
            ];
            return $2fb96651e8aa1522$var$fixNumericExtent7(fixedYExtent);
        }
    }
    getSeriesRange(_direction, _visibleRange) {
        return [
            NaN,
            NaN
        ];
    }
    createNodeData() {
        const { hasData: hasData, data: data, dataModel: dataModel, groupScale: groupScale, processedData: processedData, id: seriesId, ctx: { legendManager: legendManager } } = this;
        const xAxis = this.getCategoryAxis();
        const yAxis = this.getValueAxis();
        if (!(hasData && data && xAxis && yAxis && dataModel && processedData?.type === "ungrouped")) return;
        const xScale = xAxis.scale;
        const yScale = yAxis.scale;
        const barAlongX = this.getBarDirection() === $2fb96651e8aa1522$var$ChartAxisDirection24.X;
        const { stageKey: stageKey, valueKey: valueKey } = this.properties;
        const { strokeWidth: strokeWidth } = this.barStyle();
        const itemId = `${valueKey}`;
        const context = {
            itemId: itemId,
            nodeData: [],
            labelData: [],
            connectorData: [],
            scales: this.calculateScaling(),
            groupScale: this.getScaling(this.groupScale),
            visible: this.visible
        };
        const isVisible = this.visible;
        if (!isVisible) return context;
        const xValues = dataModel.resolveKeysById(this, "xValue", processedData);
        const yValues = dataModel.resolveColumnById(this, `yValue`, processedData);
        const { barWidth: barWidth, groupIndex: groupIndex } = this.updateGroupScale(xAxis);
        const barOffset = $2fb96651e8aa1522$var$ContinuousScale9.is(xScale) ? barWidth * -0.5 : 0;
        const crisp = $2fb96651e8aa1522$var$checkCrisp3(xAxis?.scale, xAxis?.visibleRange, this.smallestDataInterval, this.largestDataInterval);
        let previousConnection;
        const rawData = processedData.dataSources.get(this.id) ?? [];
        rawData.forEach((datum, datumIndex)=>{
            const visible = isVisible && legendManager.getItemEnabled({
                seriesId: seriesId,
                itemId: datumIndex
            });
            const xDatum = xValues[datumIndex];
            if (xDatum == null) return;
            const x = Math.round(xScale.convert(xDatum)) + groupScale.convert(String(groupIndex)) + barOffset;
            const yDatum = yValues[datumIndex];
            const yNegative = Math.round(yScale.convert(-yDatum));
            const yPositive = Math.round(yScale.convert(yDatum));
            const barHeight = Math.max(strokeWidth, Math.abs(yPositive - yNegative));
            const rect = {
                x: barAlongX ? Math.min(yPositive, yNegative) : x,
                y: barAlongX ? x : Math.min(yPositive, yNegative),
                width: barAlongX ? barHeight : barWidth,
                height: barAlongX ? barWidth : barHeight
            };
            const nodeMidPoint = {
                x: rect.x + rect.width / 2,
                y: rect.y + rect.height / 2
            };
            const labelData = this.createLabelData({
                datumIndex: datumIndex,
                rect: rect,
                barAlongX: barAlongX,
                yDatum: yDatum,
                datum: datum,
                visible: visible
            });
            const nodeDatum = {
                index: datumIndex,
                series: this,
                itemId: itemId,
                datum: datum,
                datumIndex: datumIndex,
                xValue: xDatum,
                yValue: yDatum,
                xKey: stageKey,
                yKey: valueKey,
                x: rect.x,
                y: rect.y,
                width: rect.width,
                height: rect.height,
                midPoint: nodeMidPoint,
                strokeWidth: strokeWidth,
                crisp: crisp,
                label: labelData,
                visible: visible
            };
            context.nodeData.push(nodeDatum);
            if (labelData != null) context.labelData.push(labelData);
            if (previousConnection != null) {
                const prevRect = previousConnection.rect;
                const startNodeDatum = previousConnection.nodeDatum;
                const startDatumIndex = previousConnection.datumIndex;
                if (barAlongX) context.connectorData.push({
                    datum: startNodeDatum,
                    datumIndex: startDatumIndex,
                    x0: prevRect.x,
                    y0: prevRect.y + prevRect.height,
                    x1: prevRect.x + prevRect.width,
                    y1: prevRect.y + prevRect.height,
                    x2: rect.x + rect.width,
                    y2: rect.y,
                    x3: rect.x,
                    y3: rect.y,
                    opacity: 1
                });
                else context.connectorData.push({
                    datum: startNodeDatum,
                    datumIndex: startDatumIndex,
                    x0: prevRect.x + prevRect.width,
                    y0: prevRect.y,
                    x1: rect.x,
                    y1: rect.y,
                    x2: rect.x,
                    y2: rect.y + rect.height,
                    x3: prevRect.x + prevRect.width,
                    y3: prevRect.y + prevRect.height,
                    opacity: 1
                });
            }
            if (visible) previousConnection = {
                itemId: itemId,
                rect: rect,
                nodeDatum: nodeDatum,
                datumIndex: datumIndex
            };
        });
        return context;
    }
    updateNodes(highlightedItems, seriesHighlighted, anySeriesItemEnabled) {
        super.updateNodes(highlightedItems, seriesHighlighted, anySeriesItemEnabled);
        const { connectorSelection: connectorSelection } = this;
        const connectorData = this.contextNodeData?.connectorData ?? [];
        this.connectorSelection = this.updateConnectorSelection({
            connectorSelection: connectorSelection,
            connectorData: connectorData
        });
        this.updateConnectorNodes({
            connectorSelection: connectorSelection
        });
    }
    updateDatumSelection(opts) {
        const { nodeData: nodeData, datumSelection: datumSelection } = opts;
        const data = nodeData ?? [];
        return datumSelection.update(data, void 0, (datum)=>this.getDatumId(datum));
    }
    updateConnectorSelection(opts) {
        const { connectorData: connectorData, connectorSelection: connectorSelection } = opts;
        return connectorSelection.update(this.connectorEnabled() ? connectorData : [], void 0, (connector)=>this.getDatumId(connector.datum));
    }
    updateConnectorNodes(opts) {
        const { fills: fills, strokes: strokes, fillGradientDefaults: fillGradientDefaults4, fillPatternDefaults: fillPatternDefaults4, fillImageDefaults: fillImageDefaults4 } = this.properties;
        const { fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset } = this.connectorStyle();
        const fillBBox = this.getShapeFillBBox();
        opts.connectorSelection.each((connector, datum)=>{
            const { datumIndex: datumIndex } = datum;
            connector.setProperties($2fb96651e8aa1522$var$resetConnectorSelectionsFn(connector, datum));
            const connectorFill = $2fb96651e8aa1522$var$getShapeFill3(fill ?? fills[datumIndex % fills.length], fillGradientDefaults4, fillPatternDefaults4, fillImageDefaults4);
            $2fb96651e8aa1522$var$applyShapeStyle7(connector, {
                fill: connectorFill,
                stroke: stroke2 ?? strokes[datumIndex % strokes.length],
                fillOpacity: fillOpacity,
                strokeOpacity: strokeOpacity,
                strokeWidth: strokeWidth,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset
            }, void 0, fillBBox);
        });
    }
    getHighlightLabelData(labelData, highlightedItem) {
        const labelItems = labelData.filter((ld)=>ld.datum === highlightedItem.datum);
        return labelItems.length > 0 ? labelItems : void 0;
    }
    updateLabelSelection(opts) {
        const labelData = this.properties.label.enabled ? opts.labelData : [];
        return opts.labelSelection.update(labelData, (text2)=>{
            text2.pointerEvents = $2fb96651e8aa1522$var$PointerEvents4.None;
        });
    }
    updateLabelNodes(opts) {
        opts.labelSelection.each((textNode, datum)=>{
            $2fb96651e8aa1522$var$updateLabelNode4(textNode, this.properties.label, datum);
        });
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, properties: properties } = this;
        const { stageKey: stageKey, valueKey: valueKey, tooltip: tooltip } = properties;
        const xAxis = this.getCategoryAxis();
        const yAxis = this.getValueAxis();
        if (!dataModel || !processedData || !xAxis || !yAxis) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const xValue2 = dataModel.resolveKeysById(this, "xValue", processedData)[datumIndex];
        const yValue = dataModel.resolveColumnById(this, `yValue`, processedData)[datumIndex];
        if (xValue2 == null) return;
        return this.formatTooltipWithContext(tooltip, {
            symbol: this.legendItemSymbol(datumIndex),
            data: [
                {
                    label: xAxis.formatDatum(xValue2),
                    value: yAxis.formatDatum(yValue)
                }
            ]
        }, {
            seriesId: seriesId,
            datum: datum,
            title: stageKey,
            stageKey: stageKey,
            valueKey: valueKey,
            ...this.tooltipStyle(datum, datumIndex)
        });
    }
    resetAllAnimation(data) {
        super.resetAllAnimation(data);
        $2fb96651e8aa1522$var$resetMotion2([
            this.connectorSelection
        ], $2fb96651e8aa1522$var$resetConnectorSelectionsFn);
    }
    animateEmptyUpdateReady({ labelSelection: labelSelection }) {
        const { connectorSelection: connectorSelection } = this;
        const isVertical = this.isVertical();
        const mode = "normal";
        const connectorFns = $2fb96651e8aa1522$var$prepareConnectorAnimationFunctions(isVertical, mode);
        $2fb96651e8aa1522$var$motion4.fromToMotion(this.id, "connectors", this.ctx.animationManager, [
            connectorSelection
        ], connectorFns);
        $2fb96651e8aa1522$var$seriesLabelFadeInAnimation4(this, "labels", this.ctx.animationManager, labelSelection);
    }
    animateWaitingUpdateReady(data) {
        const { labelSelection: labelSelections } = data;
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
        $2fb96651e8aa1522$var$seriesLabelFadeInAnimation4(this, "labels", this.ctx.animationManager, labelSelections);
    }
    getDatumId(datum) {
        return $2fb96651e8aa1522$var$createDatumId10(datum.xValue);
    }
    isLabelEnabled() {
        return this.properties.label.enabled;
    }
    computeFocusBounds({ datumIndex: datumIndex }) {
        return $2fb96651e8aa1522$var$computeBarFocusBounds6(this, this.contextNodeData?.nodeData[datumIndex]);
    }
    legendItemSymbol(datumIndex) {
        const { strokeWidth: strokeWidth, fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, fillGradientDefaults: fillGradientDefaults4, fillPatternDefaults: fillPatternDefaults4, fillImageDefaults: fillImageDefaults4 } = this.barStyle();
        const { fills: fills, strokes: strokes } = this.properties;
        const fill = fills[datumIndex % fills.length] ?? "black";
        const stroke2 = strokes[datumIndex % strokes.length] ?? "black";
        return {
            marker: $2fb96651e8aa1522$var$getShapeStyle8({
                fill: fill,
                fillOpacity: fillOpacity,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                strokeOpacity: strokeOpacity,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset
            }, fillGradientDefaults4, fillPatternDefaults4, fillImageDefaults4)
        };
    }
    getLegendData(legendType) {
        const { id: seriesId, processedData: processedData, dataModel: dataModel, ctx: { legendManager: legendManager }, visible: visible } = this;
        if (!dataModel || !processedData || legendType !== "category") return [];
        const { showInLegend: showInLegend } = this.properties;
        const xValues = dataModel.resolveKeysById(this, "xValue", processedData);
        return (processedData.dataSources.get(this.id) ?? []).map((datum, datumIndex)=>{
            const stageValue = xValues[datumIndex];
            if (stageValue == null) return;
            return {
                legendType: "category",
                id: seriesId,
                datum: datum,
                itemId: datumIndex,
                seriesId: seriesId,
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: seriesId,
                    itemId: datumIndex
                }),
                label: {
                    text: String(stageValue)
                },
                symbol: this.legendItemSymbol(datumIndex),
                skipAnimations: true,
                hideInLegend: !showInLegend
            };
        }).filter((datum)=>datum != null);
    }
};
var { FillGradientDefaults: $2fb96651e8aa1522$var$FillGradientDefaults7, FillPatternDefaults: $2fb96651e8aa1522$var$FillPatternDefaults7, FillImageDefaults: $2fb96651e8aa1522$var$FillImageDefaults7, Label: $2fb96651e8aa1522$var$Label7, AbstractBarSeriesProperties: $2fb96651e8aa1522$var$AbstractBarSeriesProperties5, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip9, AxisLabel: $2fb96651e8aa1522$var$AxisLabel2, Property: $2fb96651e8aa1522$var$Property66 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$ConeFunnelSeriesLabel = class extends $2fb96651e8aa1522$var$Label7 {
    constructor(){
        super(...arguments);
        this.spacing = 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelSeriesLabel.prototype, "placement", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelSeriesLabel.prototype, "spacing", 2);
var $2fb96651e8aa1522$var$ConeFunnelSeriesStageLabel = class extends $2fb96651e8aa1522$var$AxisLabel2 {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelSeriesStageLabel.prototype, "placement", 2);
var $2fb96651e8aa1522$var$ConeFunnelProperties = class extends $2fb96651e8aa1522$var$AbstractBarSeriesProperties5 {
    constructor(){
        super(...arguments);
        this.fills = [];
        this.fillGradientDefaults = new $2fb96651e8aa1522$var$FillGradientDefaults7();
        this.fillPatternDefaults = new $2fb96651e8aa1522$var$FillPatternDefaults7();
        this.fillImageDefaults = new $2fb96651e8aa1522$var$FillImageDefaults7();
        this.fillOpacity = 1;
        this.strokes = [];
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.label = new $2fb96651e8aa1522$var$ConeFunnelSeriesLabel();
        this.stageLabel = new $2fb96651e8aa1522$var$ConeFunnelSeriesStageLabel();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip9();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelProperties.prototype, "stageKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelProperties.prototype, "valueKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelProperties.prototype, "fills", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelProperties.prototype, "fillGradientDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelProperties.prototype, "fillPatternDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelProperties.prototype, "fillImageDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelProperties.prototype, "strokes", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelProperties.prototype, "stageLabel", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property66
], $2fb96651e8aa1522$var$ConeFunnelProperties.prototype, "tooltip", 2);
// packages/ag-charts-enterprise/src/series/cone-funnel/coneFunnelUtil.ts
function $2fb96651e8aa1522$var$resetLineSelectionsFn(_node, { x: x, y: y, width: width, height: height, opacity: opacity }) {
    return {
        x1: x,
        y1: y,
        x2: x + width,
        y2: y + height,
        opacity: opacity
    };
}
// packages/ag-charts-enterprise/src/series/cone-funnel/coneFunnelSeries.ts
var { formatValue: $2fb96651e8aa1522$var$formatValue, Line: $2fb96651e8aa1522$var$Line6 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$ConeFunnelSeries = class extends $2fb96651e8aa1522$var$BaseFunnelSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            animationResetFns: {
                datum: $2fb96651e8aa1522$var$resetLineSelectionsFn
            }
        });
        this.properties = new $2fb96651e8aa1522$var$ConeFunnelProperties();
    }
    get hasData() {
        const { id: seriesId, ctx: { legendManager: legendManager } } = this;
        const visibleItems = this.data?.reduce((accum, _, datumIndex)=>accum + (legendManager.getItemEnabled({
                seriesId: seriesId,
                itemId: datumIndex
            }) ? 1 : 0), 0);
        return visibleItems != null && visibleItems > 1;
    }
    getBandScalePadding() {
        return {
            inner: 1,
            outer: 0
        };
    }
    connectorEnabled() {
        return true;
    }
    barStyle() {
        return {
            fillOpacity: 1,
            strokeOpacity: 1,
            strokeWidth: 0,
            lineDash: [],
            lineDashOffset: 0,
            fillGradientDefaults: this.properties.fillGradientDefaults,
            fillPatternDefaults: this.properties.fillPatternDefaults,
            fillImageDefaults: this.properties.fillImageDefaults
        };
    }
    connectorStyle() {
        const { fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset, fillGradientDefaults: fillGradientDefaults4, fillPatternDefaults: fillPatternDefaults4, fillImageDefaults: fillImageDefaults4 } = this.properties;
        return {
            fillOpacity: fillOpacity,
            strokeOpacity: strokeOpacity,
            strokeWidth: strokeWidth,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            fillGradientDefaults: fillGradientDefaults4,
            fillPatternDefaults: fillPatternDefaults4,
            fillImageDefaults: fillImageDefaults4
        };
    }
    nodeFactory() {
        return new $2fb96651e8aa1522$var$Line6();
    }
    createLabelData({ datumIndex: datumIndex, rect: rect, barAlongX: barAlongX, yDatum: yDatum, datum: datum, visible: visible }) {
        const { stageKey: stageKey, valueKey: valueKey, label: label } = this.properties;
        const { spacing: spacing, placement: placement } = label;
        let x;
        let y;
        let textAlign;
        let textBaseline;
        if (barAlongX) {
            x = rect.x + rect.width / 2;
            textAlign = "center";
            switch(placement){
                case "before":
                    y = rect.y - spacing;
                    textBaseline = "bottom";
                    break;
                case "after":
                    y = rect.y + rect.height + spacing;
                    textBaseline = "top";
                    break;
                default:
                    y = rect.y + rect.height / 2;
                    textBaseline = "middle";
            }
        } else {
            y = rect.y + rect.height / 2;
            textBaseline = "middle";
            switch(placement){
                case "before":
                    x = rect.x - spacing;
                    textAlign = "right";
                    break;
                case "after":
                    x = rect.x + rect.width + spacing;
                    textAlign = "left";
                    break;
                default:
                    x = rect.x + rect.width / 2;
                    textAlign = "center";
            }
        }
        return {
            x: x,
            y: y,
            textAlign: textAlign,
            textBaseline: textBaseline,
            text: this.getLabelText(label, {
                itemId: valueKey,
                value: yDatum,
                datum: datum,
                stageKey: stageKey,
                valueKey: valueKey
            }, (value)=>$2fb96651e8aa1522$var$formatValue(value, 0)),
            itemId: valueKey,
            datum: datum,
            datumIndex: datumIndex,
            series: this,
            visible: visible
        };
    }
    updateDatumNodes(opts) {
        const highlightStyle = opts.isHighlight ? this.properties.highlightStyle.item : void 0;
        opts.datumSelection.each((line, datum)=>{
            line.setProperties($2fb96651e8aa1522$var$resetLineSelectionsFn(line, datum));
            line.stroke = highlightStyle?.stroke;
            line.strokeWidth = highlightStyle?.strokeWidth ?? 0;
            line.strokeOpacity = highlightStyle?.strokeOpacity ?? 1;
            line.lineDash = highlightStyle?.lineDash;
            line.lineDashOffset = highlightStyle?.lineDashOffset ?? 0;
        });
    }
    tooltipStyle(_datum, datumIndex) {
        const { fills: fills, strokes: strokes } = this.properties;
        const fill = fills[datumIndex % fills.length] ?? "black";
        const stroke2 = strokes[datumIndex % strokes.length] ?? "black";
        const { fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset } = this.barStyle();
        return {
            fill: fill,
            fillOpacity: fillOpacity,
            stroke: stroke2,
            strokeOpacity: strokeOpacity,
            strokeWidth: strokeWidth,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset
        };
    }
};
$2fb96651e8aa1522$var$ConeFunnelSeries.className = "ConeFunnelSeries";
$2fb96651e8aa1522$var$ConeFunnelSeries.type = "cone-funnel";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs9, coneFunnelSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$coneFunnelSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$coneFunnelSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$coneFunnelSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs9,
    type: (0, $idDdm.required)((0, $idDdm.constant)("cone-funnel")),
    stageKey: (0, $idDdm.required)((0, $idDdm.string)),
    valueKey: (0, $idDdm.required)((0, $idDdm.string))
};
var { ThemeConstants: { CARTESIAN_AXIS_TYPE: $2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE8 } } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$CONE_FUNNEL_SERIES_THEME = {
    series: {
        direction: "vertical",
        fills: {
            $if: [
                {
                    $eq: [
                        {
                            $palette: "type"
                        },
                        "inbuilt"
                    ]
                },
                {
                    $palette: "secondSequentialColors"
                },
                (0, $iTJTu._ModuleSupport).SAFE_RANGE2_OPERATION
            ]
        },
        strokes: {
            $if: [
                {
                    $eq: [
                        {
                            $palette: "type"
                        },
                        "inbuilt"
                    ]
                },
                {
                    $palette: "secondSequentialColors"
                },
                (0, $iTJTu._ModuleSupport).SAFE_RANGE2_OPERATION
            ]
        },
        // @ts-expect-error undocumented option
        fillGradientDefaults: {
            type: "gradient",
            gradient: "linear",
            bounds: "item",
            colorStops: {
                $palette: "gradient"
            },
            rotation: 0,
            reverse: false
        },
        fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
        fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
        strokeWidth: 0,
        label: {
            enabled: true,
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            fontWeight: {
                $ref: "fontWeight"
            },
            color: {
                $ref: "textColor"
            },
            placement: "before",
            spacing: 4
        }
    },
    seriesArea: {
        padding: {
            top: 20,
            bottom: 20
        }
    },
    axes: {
        [$2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE8.NUMBER]: {
            nice: false,
            gridLine: {
                enabled: false
            },
            crosshair: {
                enabled: false
            },
            label: {
                enabled: false,
                formatter (params) {
                    return Math.abs(params.value).toFixed(params.fractionDigits ?? 0);
                }
            }
        },
        [$2fb96651e8aa1522$var$CARTESIAN_AXIS_TYPE8.CATEGORY]: {
            line: {
                enabled: false
            }
        }
    }
};
// packages/ag-charts-enterprise/src/series/cone-funnel/coneFunnelModule.ts
var $2fb96651e8aa1522$var$ConeFunnelModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    identifier: "cone-funnel",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$ConeFunnelSeries(ctx),
    solo: true,
    tooltipDefaults: {
        range: "nearest"
    },
    defaultAxes: $2fb96651e8aa1522$var$FUNNEL_SERIES_AXES,
    themeTemplate: $2fb96651e8aa1522$var$CONE_FUNNEL_SERIES_THEME
};
var $2fb96651e8aa1522$var$ConeFunnelSeriesModule = {
    type: "series",
    name: "cone-funnel",
    chartType: "cartesian",
    enterprise: true,
    options: $2fb96651e8aa1522$var$coneFunnelSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$ConeFunnelSeries(ctx)
};
var { FillGradientDefaults: $2fb96651e8aa1522$var$FillGradientDefaults8, FillPatternDefaults: $2fb96651e8aa1522$var$FillPatternDefaults8, FillImageDefaults: $2fb96651e8aa1522$var$FillImageDefaults8, Label: $2fb96651e8aa1522$var$Label8, DropShadow: $2fb96651e8aa1522$var$DropShadow4, AbstractBarSeriesProperties: $2fb96651e8aa1522$var$AbstractBarSeriesProperties6, BaseProperties: $2fb96651e8aa1522$var$BaseProperties24, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip10, AxisLabel: $2fb96651e8aa1522$var$AxisLabel3, Property: $2fb96651e8aa1522$var$Property67 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$FunnelSeriesLabel = class extends $2fb96651e8aa1522$var$Label8 {
};
var $2fb96651e8aa1522$var$FunnelSeriesStageLabel = class extends $2fb96651e8aa1522$var$AxisLabel3 {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelSeriesStageLabel.prototype, "placement", 2);
var $2fb96651e8aa1522$var$FunnelDropOff = class extends $2fb96651e8aa1522$var$BaseProperties24 {
    constructor(){
        super(...arguments);
        this.enabled = true;
        this.fill = void 0;
        this.fillOpacity = 1;
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelDropOff.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelDropOff.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelDropOff.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelDropOff.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelDropOff.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelDropOff.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelDropOff.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelDropOff.prototype, "lineDashOffset", 2);
var $2fb96651e8aa1522$var$FunnelProperties = class extends $2fb96651e8aa1522$var$AbstractBarSeriesProperties6 {
    constructor(){
        super(...arguments);
        this.fills = [];
        this.fillGradientDefaults = new $2fb96651e8aa1522$var$FillGradientDefaults8();
        this.fillPatternDefaults = new $2fb96651e8aa1522$var$FillPatternDefaults8();
        this.fillImageDefaults = new $2fb96651e8aa1522$var$FillImageDefaults8();
        this.fillOpacity = 1;
        this.strokes = [];
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.spacingRatio = 0;
        this.dropOff = new $2fb96651e8aa1522$var$FunnelDropOff();
        this.shadow = new $2fb96651e8aa1522$var$DropShadow4().set({
            enabled: false
        });
        this.label = new $2fb96651e8aa1522$var$FunnelSeriesLabel();
        this.stageLabel = new $2fb96651e8aa1522$var$FunnelSeriesStageLabel();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip10();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "stageKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "valueKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "fills", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "fillGradientDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "fillPatternDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "fillImageDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "strokes", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "spacingRatio", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "itemStyler", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "dropOff", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "shadow", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "stageLabel", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property67
], $2fb96651e8aa1522$var$FunnelProperties.prototype, "tooltip", 2);
// packages/ag-charts-enterprise/src/series/funnel/funnelSeries.ts
var { ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection25, resetBarSelectionsFn: $2fb96651e8aa1522$var$resetBarSelectionsFn3, prepareBarAnimationFunctions: $2fb96651e8aa1522$var$prepareBarAnimationFunctions3, midpointStartingBarPosition: $2fb96651e8aa1522$var$midpointStartingBarPosition2, createDatumId: $2fb96651e8aa1522$var$createDatumId11, formatValue: $2fb96651e8aa1522$var$formatValue2, Rect: $2fb96651e8aa1522$var$Rect7, motion: $2fb96651e8aa1522$var$motion5, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle8, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle9 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$FunnelSeries = class extends $2fb96651e8aa1522$var$BaseFunnelSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            animationResetFns: {
                datum: $2fb96651e8aa1522$var$resetBarSelectionsFn3
            }
        });
        this.properties = new $2fb96651e8aa1522$var$FunnelProperties();
    }
    getBandScalePadding() {
        return {
            inner: this.properties.spacingRatio,
            outer: 0
        };
    }
    connectorEnabled() {
        return this.properties.dropOff.enabled;
    }
    barStyle() {
        const { fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset, fillGradientDefaults: fillGradientDefaults4, fillPatternDefaults: fillPatternDefaults4, fillImageDefaults: fillImageDefaults4 } = this.properties;
        return {
            fillOpacity: fillOpacity,
            strokeOpacity: strokeOpacity,
            strokeWidth: strokeWidth,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            fillGradientDefaults: fillGradientDefaults4,
            fillPatternDefaults: fillPatternDefaults4,
            fillImageDefaults: fillImageDefaults4
        };
    }
    connectorStyle() {
        const { fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset } = this.properties.dropOff;
        return {
            fill: fill,
            fillOpacity: fillOpacity,
            stroke: stroke2,
            strokeOpacity: strokeOpacity,
            strokeWidth: strokeWidth,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            fillGradientDefaults: this.properties.fillGradientDefaults,
            fillPatternDefaults: this.properties.fillPatternDefaults,
            fillImageDefaults: this.properties.fillImageDefaults
        };
    }
    nodeFactory() {
        return new $2fb96651e8aa1522$var$Rect7();
    }
    createLabelData({ datumIndex: datumIndex, rect: rect, yDatum: yDatum, datum: datum, visible: visible }) {
        const { valueKey: valueKey, stageKey: stageKey, label: label } = this.properties;
        return {
            x: rect.x + rect.width / 2,
            y: rect.y + rect.height / 2,
            textAlign: "center",
            textBaseline: "middle",
            text: this.getLabelText(label, {
                itemId: stageKey,
                value: yDatum,
                datum: datum,
                valueKey: valueKey,
                stageKey: stageKey
            }, (value)=>$2fb96651e8aa1522$var$formatValue2(value, 0)),
            itemId: stageKey,
            datum: datum,
            datumIndex: datumIndex,
            series: this,
            visible: visible
        };
    }
    getItemBaseStyle(highlighted) {
        const { properties: properties } = this;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return $2fb96651e8aa1522$var$getShapeStyle9({
            fill: highlightStyle?.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? properties.fillOpacity,
            stroke: highlightStyle?.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(properties.strokeWidth),
            strokeOpacity: highlightStyle?.strokeOpacity ?? properties.strokeOpacity,
            lineDash: highlightStyle?.lineDash ?? properties.lineDash,
            lineDashOffset: highlightStyle?.lineDashOffset ?? properties.lineDashOffset
        }, properties.fillGradientDefaults, properties.fillPatternDefaults, properties.fillImageDefaults);
    }
    getItemStyleOverrides(datumId, datum, datumIndex, format, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const { stageKey: stageKey, valueKey: valueKey, fills: fills, strokes: strokes, itemStyler: itemStyler } = properties;
        const fill = format.fill ?? fills[datumIndex % fills.length] ?? "black";
        const stroke2 = format.stroke ?? strokes[datumIndex % strokes.length] ?? "black";
        const overrides = {};
        if (!highlighted) {
            overrides.fill = fill;
            overrides.stroke = stroke2;
        }
        if (itemStyler != null) {
            const itemStyle = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId11(datumId, highlighted ? "highlight" : "node"), ()=>{
                const { fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset } = format;
                return this.callWithContext(itemStyler, {
                    seriesId: seriesId,
                    datum: datum,
                    highlighted: highlighted,
                    stageKey: stageKey,
                    valueKey: valueKey,
                    fill: fill,
                    fillOpacity: fillOpacity,
                    stroke: stroke2,
                    strokeOpacity: strokeOpacity,
                    strokeWidth: strokeWidth,
                    lineDash: lineDash,
                    lineDashOffset: lineDashOffset
                });
            });
            Object.assign(overrides, itemStyle);
        }
        return $2fb96651e8aa1522$var$getShapeStyle9(overrides, properties.fillGradientDefaults, properties.fillPatternDefaults, properties.fillImageDefaults);
    }
    updateDatumNodes(opts) {
        const { shadow: shadow } = this.properties;
        const { datumSelection: datumSelection, isHighlight: isHighlight } = opts;
        const categoryAlongX = this.getCategoryDirection() === $2fb96651e8aa1522$var$ChartAxisDirection25.X;
        const style = this.getItemBaseStyle(isHighlight);
        const fillBBox = this.getShapeFillBBox();
        datumSelection.each((rect, datum)=>{
            const { datumIndex: datumIndex } = datum;
            const overrides = this.getItemStyleOverrides(String(datum.datumIndex), datum.datum, datumIndex, style, isHighlight);
            $2fb96651e8aa1522$var$applyShapeStyle8(rect, style, overrides, fillBBox);
            rect.visible = categoryAlongX ? datum.width > 0 : datum.height > 0;
            rect.crisp = datum.crisp;
            rect.fillShadow = shadow;
        });
    }
    tooltipStyle(datum, datumIndex) {
        const style = this.getItemBaseStyle(false);
        Object.assign(style, this.getItemStyleOverrides(String(datumIndex), datum, datumIndex, style, false));
        return style;
    }
    animateEmptyUpdateReady(params) {
        super.animateEmptyUpdateReady(params);
        const { datumSelection: datumSelection } = params;
        const isVertical = this.isVertical();
        const mode = "normal";
        const barFns = $2fb96651e8aa1522$var$prepareBarAnimationFunctions3($2fb96651e8aa1522$var$midpointStartingBarPosition2(isVertical, mode));
        $2fb96651e8aa1522$var$motion5.fromToMotion(this.id, "datums", this.ctx.animationManager, [
            datumSelection
        ], barFns);
    }
    animateWaitingUpdateReady(data) {
        super.animateWaitingUpdateReady(data);
        const { datumSelection: datumSelections } = data;
        const { processedData: processedData } = this;
        const dataDiff = processedData?.reduced?.diff?.[this.id];
        const fns = $2fb96651e8aa1522$var$prepareBarAnimationFunctions3($2fb96651e8aa1522$var$midpointStartingBarPosition2(this.isVertical(), "fade"));
        $2fb96651e8aa1522$var$motion5.fromToMotion(this.id, "datums", this.ctx.animationManager, [
            datumSelections
        ], fns, (_, datum)=>datum.xValue, dataDiff);
    }
};
$2fb96651e8aa1522$var$FunnelSeries.className = "FunnelSeries";
$2fb96651e8aa1522$var$FunnelSeries.type = "funnel";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs10, funnelSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$funnelSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$funnelSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$funnelSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs10,
    type: (0, $idDdm.required)((0, $idDdm.constant)("funnel")),
    stageKey: (0, $idDdm.required)((0, $idDdm.string)),
    valueKey: (0, $idDdm.required)((0, $idDdm.string))
};
// packages/ag-charts-enterprise/src/series/funnel/funnelModule.ts
var $2fb96651e8aa1522$var$FunnelModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    identifier: "funnel",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$FunnelSeries(ctx),
    solo: true,
    tooltipDefaults: {
        range: "exact"
    },
    defaultAxes: $2fb96651e8aa1522$var$FUNNEL_SERIES_AXES,
    themeTemplate: $2fb96651e8aa1522$var$FUNNEL_SERIES_THEME
};
var $2fb96651e8aa1522$var$FunnelSeriesModule = {
    type: "series",
    name: "funnel",
    chartType: "cartesian",
    enterprise: true,
    options: $2fb96651e8aa1522$var$funnelSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$FunnelSeries(ctx)
};
// packages/ag-charts-enterprise/src/series/gauge-util/datumUnion.ts
var $2fb96651e8aa1522$var$DatumUnion = class {
    *[Symbol.iterator]() {
        const { node: node, datum: datum } = this;
        if (node && datum) yield {
            node: node,
            datum: datum
        };
    }
    nodes() {
        return this.node ? [
            this.node
        ] : [];
    }
    update(datumSelection, group, ctor, nodeUpdater) {
        const nodes = datumSelection.nodes();
        if (nodes.length === 0) {
            this.node?.remove();
            this.node = void 0;
        } else {
            if (this.node === void 0) {
                this.node = new ctor();
                this.node.fillOpacity = 0;
                this.node.strokeOpacity = 0;
                group.appendChild(this.node);
            }
            const first = nodes[0];
            const last = nodes.toReversed().find((n)=>n.datum.datum.value > n.datum.datum.segmentStart) ?? nodes[nodes.length - 1];
            this.node.datum = this.datum = first.datum;
            nodeUpdater(this.node, first, last);
        }
    }
};
var $2fb96651e8aa1522$var$fadeInFns = {
    fromFn: ()=>({
            opacity: 0,
            phase: "initial"
        }),
    toFn: ()=>({
            opacity: 1
        })
};
function $2fb96651e8aa1522$var$formatLabel(value, scale) {
    if (value == null) return "";
    const { min: min, max: max } = scale;
    const minLog10 = min !== 0 ? Math.ceil(Math.log10(Math.abs(min))) : 0;
    const maxLog10 = max !== 0 ? Math.ceil(Math.log10(Math.abs(max))) : 0;
    const dp = Math.max(2 - Math.max(minLog10, maxLog10), 0);
    return value.toFixed(dp);
}
function $2fb96651e8aa1522$var$getLabelText(seriesId, ctx, datum, valueOverride) {
    if (datum.text != null) return datum.text;
    const value = valueOverride ?? datum.value;
    let labelFormat;
    if (datum?.formatter != null) labelFormat = $2fb96651e8aa1522$var$formatWithContext(ctx, datum.formatter, {
        seriesId: seriesId,
        datum: void 0,
        value: value
    });
    if (labelFormat != null) return String(labelFormat);
}
function $2fb96651e8aa1522$var$formatWithContext(ctx, formatter, params) {
    return (0, $iTJTu._ModuleSupport).callWithContext(ctx.chartService, void 0, formatter, [
        params
    ]);
}
function $2fb96651e8aa1522$var$lineMarker({ path: path, x: x, y: y, size: size }) {
    path.moveTo(x, y - size / 2);
    path.lineTo(x, y + size / 2);
}
function $2fb96651e8aa1522$var$pickGaugeNearestDatum(self, point) {
    const it = (0, $idDdm.iterate)(self.datumUnion.nodes(), self.targetSelection.nodes());
    return self.pickNodeNearestDistantObject(point, it);
}
function $2fb96651e8aa1522$var$pickGaugeFocus(self, opts) {
    const others = [
        {
            data: self.contextNodeData?.nodeData,
            selection: self.datumUnion
        },
        {
            data: self.contextNodeData?.targetData,
            selection: self.targetSelection
        }
    ].filter((v)=>v.data && v.data.length > 0);
    const otherIndex = (0, $idDdm.clamp)(0, opts.otherIndex + opts.otherIndexDelta, others.length - 1);
    if (others.length === 0) return;
    const { data: data, selection: selection } = others[otherIndex];
    if (data == null || data.length === 0) return;
    const datumIndex = (0, $idDdm.clamp)(0, opts.datumIndex, data.length - 1);
    const datum = data[datumIndex];
    for (const node of selection)if (node.datum === datum) {
        const bounds = node.node;
        return {
            bounds: bounds,
            clipFocusBox: true,
            datum: datum,
            datumIndex: datumIndex,
            otherIndex: otherIndex
        };
    }
}
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties25, Property: $2fb96651e8aa1522$var$Property68 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$GaugeSegmentationIntervalProperties = class extends $2fb96651e8aa1522$var$BaseProperties25 {
    getSegments(scale, maxTicks) {
        const { values: values, step: step, count: count } = this;
        const d0 = Math.min(...scale.domain);
        const d1 = Math.max(...scale.domain);
        let ticks;
        if (values != null) {
            const segments = values.filter((v)=>v > d0 && v < d1).sort((a, b)=>a - b);
            ticks = [
                d0,
                ...segments,
                d1
            ];
        } else if (step != null) {
            const segments = [];
            for(let i = d0; i < d1; i += step)segments.push(i);
            segments.push(d1);
            ticks = segments;
        } else if (count != null) {
            const segments = count + 1;
            ticks = Array.from({
                length: segments + 1
            }, (_, i)=>i / segments * (d1 - d0) + d0);
        } else {
            const segments = scale.ticks({
                nice: true,
                interval: void 0,
                tickCount: void 0,
                minTickCount: 0,
                maxTickCount: Infinity
            })?.ticks?.filter((v)=>v > d0 && v < d1);
            ticks = segments != null ? [
                d0,
                ...segments,
                d1
            ] : void 0;
        }
        if (ticks != null && ticks.length > maxTicks) {
            (0, $idDdm.Logger).warnOnce(`the configured segmentation results in more than 1 item per pixel, ignoring. Supply a segmentation configuration that results in larger segments or omit this configuration`);
            ticks = void 0;
        }
        ticks ?? (ticks = [
            d0,
            d1
        ]);
        return ticks;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property68
], $2fb96651e8aa1522$var$GaugeSegmentationIntervalProperties.prototype, "values", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property68
], $2fb96651e8aa1522$var$GaugeSegmentationIntervalProperties.prototype, "step", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property68
], $2fb96651e8aa1522$var$GaugeSegmentationIntervalProperties.prototype, "count", 2);
var $2fb96651e8aa1522$var$GaugeSegmentationProperties = class extends $2fb96651e8aa1522$var$BaseProperties25 {
    constructor(){
        super(...arguments);
        this.enabled = false;
        this.interval = new $2fb96651e8aa1522$var$GaugeSegmentationIntervalProperties();
        this.spacing = 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property68
], $2fb96651e8aa1522$var$GaugeSegmentationProperties.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property68
], $2fb96651e8aa1522$var$GaugeSegmentationProperties.prototype, "interval", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property68
], $2fb96651e8aa1522$var$GaugeSegmentationProperties.prototype, "spacing", 2);
// packages/ag-charts-enterprise/src/series/linear-gauge/linearGaugeSeriesProperties.ts
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties26, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip11, SeriesProperties: $2fb96651e8aa1522$var$SeriesProperties2, PropertiesArray: $2fb96651e8aa1522$var$PropertiesArray7, Property: $2fb96651e8aa1522$var$Property69, Label: $2fb96651e8aa1522$var$Label9, AxisLabel: $2fb96651e8aa1522$var$AxisLabel4 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$LinearGaugeDefaultTargetLabelProperties = class extends $2fb96651e8aa1522$var$Label9 {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeDefaultTargetLabelProperties.prototype, "spacing", 2);
var $2fb96651e8aa1522$var$LinearGaugeTargetProperties = class extends $2fb96651e8aa1522$var$BaseProperties26 {
    constructor(){
        super(...arguments);
        this.value = 0;
        this.label = new $2fb96651e8aa1522$var$LinearGaugeDefaultTargetLabelProperties();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeTargetProperties.prototype, "text", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeTargetProperties.prototype, "value", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeTargetProperties.prototype, "shape", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeTargetProperties.prototype, "placement", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeTargetProperties.prototype, "spacing", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeTargetProperties.prototype, "size", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeTargetProperties.prototype, "rotation", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeTargetProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeTargetProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeTargetProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeTargetProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeTargetProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeTargetProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeTargetProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeTargetProperties.prototype, "label", 2);
var $2fb96651e8aa1522$var$LinearGaugeBarProperties = class extends $2fb96651e8aa1522$var$BaseProperties26 {
    constructor(){
        super(...arguments);
        this.enabled = true;
        this.thicknessRatio = 1;
        this.fills = new $2fb96651e8aa1522$var$PropertiesArray7((0, $iTJTu._ModuleSupport).StopProperties);
        this.fillMode = "continuous";
        this.fillOpacity = 1;
        this.stroke = "black";
        this.strokeWidth = 0;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeBarProperties.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeBarProperties.prototype, "thickness", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeBarProperties.prototype, "thicknessRatio", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeBarProperties.prototype, "fills", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeBarProperties.prototype, "fillMode", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeBarProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeBarProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeBarProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeBarProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeBarProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeBarProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeBarProperties.prototype, "lineDashOffset", 2);
var $2fb96651e8aa1522$var$LinearGaugeScaleIntervalProperties = class extends $2fb96651e8aa1522$var$BaseProperties26 {
    constructor(){
        super(...arguments);
        this.values = void 0;
        this.step = void 0;
        this.minSpacing = 0;
        this.maxSpacing = 1e3;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleIntervalProperties.prototype, "values", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleIntervalProperties.prototype, "step", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleIntervalProperties.prototype, "minSpacing", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleIntervalProperties.prototype, "maxSpacing", 2);
var $2fb96651e8aa1522$var$LinearGaugeScaleLabelProperties = class extends $2fb96651e8aa1522$var$AxisLabel4 {
    constructor(){
        super(...arguments);
        this.placement = void 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleLabelProperties.prototype, "placement", 2);
var $2fb96651e8aa1522$var$LinearGaugeScaleProperties = class extends $2fb96651e8aa1522$var$BaseProperties26 {
    constructor(){
        super(...arguments);
        this.min = 0;
        this.max = 1;
        this.fills = new $2fb96651e8aa1522$var$PropertiesArray7((0, $iTJTu._ModuleSupport).StopProperties);
        this.fillMode = "continuous";
        this.fillOpacity = 1;
        this.stroke = "black";
        this.strokeWidth = 0;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.defaultFill = "black";
        this.interval = new $2fb96651e8aa1522$var$LinearGaugeScaleIntervalProperties();
        this.label = new $2fb96651e8aa1522$var$LinearGaugeScaleLabelProperties();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleProperties.prototype, "min", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleProperties.prototype, "max", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleProperties.prototype, "fills", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleProperties.prototype, "fillMode", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleProperties.prototype, "defaultFill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleProperties.prototype, "interval", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeScaleProperties.prototype, "label", 2);
var $2fb96651e8aa1522$var$LinearGaugeLabelProperties = class extends $2fb96651e8aa1522$var$AutoSizedLabel {
    constructor(){
        super(...arguments);
        this.placement = "inside-center";
        this.avoidCollisions = true;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeLabelProperties.prototype, "text", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeLabelProperties.prototype, "placement", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeLabelProperties.prototype, "avoidCollisions", 2);
var $2fb96651e8aa1522$var$LinearGaugeSeriesProperties = class extends $2fb96651e8aa1522$var$SeriesProperties2 {
    constructor(){
        super(...arguments);
        this.value = 0;
        this.segmentation = new $2fb96651e8aa1522$var$GaugeSegmentationProperties();
        this.defaultColorRange = [];
        this.targets = new $2fb96651e8aa1522$var$PropertiesArray7($2fb96651e8aa1522$var$LinearGaugeTargetProperties);
        this.defaultTarget = new $2fb96651e8aa1522$var$LinearGaugeTargetProperties();
        this.defaultScale = new $2fb96651e8aa1522$var$LinearGaugeScaleProperties();
        this.direction = "vertical";
        this.thickness = 1;
        this.cornerRadius = 0;
        this.cornerMode = "container";
        this.margin = 0;
        this.scale = new $2fb96651e8aa1522$var$LinearGaugeScaleProperties();
        this.bar = new $2fb96651e8aa1522$var$LinearGaugeBarProperties();
        this.label = new $2fb96651e8aa1522$var$LinearGaugeLabelProperties();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip11();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeSeriesProperties.prototype, "value", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeSeriesProperties.prototype, "segmentation", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeSeriesProperties.prototype, "defaultColorRange", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeSeriesProperties.prototype, "targets", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeSeriesProperties.prototype, "defaultTarget", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeSeriesProperties.prototype, "defaultScale", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeSeriesProperties.prototype, "direction", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeSeriesProperties.prototype, "thickness", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeSeriesProperties.prototype, "cornerRadius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeSeriesProperties.prototype, "cornerMode", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeSeriesProperties.prototype, "margin", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeSeriesProperties.prototype, "scale", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeSeriesProperties.prototype, "bar", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeSeriesProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property69
], $2fb96651e8aa1522$var$LinearGaugeSeriesProperties.prototype, "tooltip", 2);
var { CachedTextMeasurerPool: $2fb96651e8aa1522$var$CachedTextMeasurerPool5, BBox: $2fb96651e8aa1522$var$BBox16 } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$datumRect(datum) {
    const { x0: x0, y0: y0, x1: x1, y1: y1, horizontalInset: horizontalInset, verticalInset: verticalInset } = datum;
    const x = Math.min(x0, x1) + horizontalInset;
    const y = Math.min(y0, y1) + verticalInset;
    const width = Math.max(Math.abs(x1 - x0) - 2 * horizontalInset, 0);
    const height = Math.max(Math.abs(y1 - y0) - 2 * verticalInset, 0);
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
function $2fb96651e8aa1522$var$clipBBoxVisibility(datum, clipBBox) {
    if (clipBBox == null) return true;
    const rect = $2fb96651e8aa1522$var$datumRect(datum);
    const delta3 = 1e-6;
    const x0 = rect.x + delta3;
    const y0 = rect.y + delta3;
    const x1 = rect.x + rect.width - delta3;
    const y1 = rect.y + rect.height - delta3;
    const clipX0 = clipBBox.x;
    const clipX1 = clipBBox.x + clipBBox.width;
    const clipY0 = clipBBox.y;
    const clipY1 = clipBBox.y + clipBBox.height;
    return Math.max(x0, clipX0) <= Math.min(x1, clipX1) && Math.max(y0, clipY0) <= Math.min(y1, clipY1);
}
function $2fb96651e8aa1522$var$hasClipBBox(datum) {
    const { clipX0: clipX0, clipX1: clipX1, clipY0: clipY0, clipY1: clipY1 } = datum;
    return clipX0 != null && clipX1 != null || clipY0 != null && clipY1 != null;
}
function $2fb96651e8aa1522$var$computeClipBBox(datum) {
    if (!$2fb96651e8aa1522$var$hasClipBBox(datum)) return;
    const { x0: x0, y0: y0, x1: x1, y1: y1 } = datum;
    const { x: x, y: y, width: width, height: height } = $2fb96651e8aa1522$var$datumRect(datum);
    let { clipX0: clipX0, clipX1: clipX1, clipY0: clipY0, clipY1: clipY1 } = datum;
    if (clipX0 == null || clipX1 == null) {
        clipX0 = x0;
        clipX1 = x1;
    }
    if (clipY0 == null || clipY1 == null) {
        clipY0 = y0;
        clipY1 = y1;
    }
    const clipX = Math.min(clipX0, clipX1);
    const clipY = Math.min(clipY0, clipY1);
    const clipWidth = Math.abs(clipX1 - clipX0);
    const clipHeight = Math.abs(clipY1 - clipY0);
    clipX0 = Math.max(x, clipX);
    clipY0 = Math.max(y, clipY);
    clipX1 = Math.min(x + width, clipX + clipWidth);
    clipY1 = Math.min(y + height, clipY + clipHeight);
    return new $2fb96651e8aa1522$var$BBox16(Math.min(clipX0, clipX1), Math.min(clipY0, clipY1), Math.abs(clipX1 - clipX0), Math.abs(clipY1 - clipY0));
}
function $2fb96651e8aa1522$var$prepareLinearGaugeSeriesAnimationFunctions(initialLoad, horizontal) {
    const phase = initialLoad ? "initial" : "update";
    const node = {
        fromFn (sect, datum) {
            const previousDatum = sect.previousDatum;
            let { x0: x0, y0: y0, x1: x1, y1: y1, clipX0: clipX0, clipY0: clipY0, clipX1: clipX1, clipY1: clipY1 } = previousDatum ?? datum;
            const { horizontalInset: horizontalInset, verticalInset: verticalInset } = datum;
            const previousHadClipBBox = previousDatum != null && $2fb96651e8aa1522$var$hasClipBBox(previousDatum);
            const nextHasClipBBox = $2fb96651e8aa1522$var$hasClipBBox(datum);
            if (previousHadClipBBox && nextHasClipBBox) ;
            else if (!previousHadClipBBox && nextHasClipBBox) {
                ({ x0: x0, y0: y0, x1: x1, y1: y1, clipX0: clipX0, clipY0: clipY0, clipX1: clipX1, clipY1: clipY1 } = datum);
                if (initialLoad) {
                    if (horizontal) clipX1 = datum.clipX0;
                    else clipY1 = datum.clipY0;
                }
            } else if (previousHadClipBBox && !nextHasClipBBox) {
                ({ x0: x0, y0: y0, x1: x1, y1: y1 } = datum);
                clipX0 = void 0;
                clipY0 = void 0;
                clipX1 = void 0;
                clipY1 = void 0;
            } else if (initialLoad) {
                if (horizontal) x1 = x0;
                else y1 = y0;
            }
            return {
                x0: x0,
                y0: y0,
                x1: x1,
                y1: y1,
                clipX0: clipX0,
                clipY0: clipY0,
                clipX1: clipX1,
                clipY1: clipY1,
                horizontalInset: horizontalInset,
                verticalInset: verticalInset,
                phase: phase
            };
        },
        toFn (_sect, datum) {
            const { x0: x0, y0: y0, x1: x1, y1: y1, clipX0: clipX0, clipY0: clipY0, clipX1: clipX1, clipY1: clipY1, horizontalInset: horizontalInset, verticalInset: verticalInset } = datum;
            return {
                x0: x0,
                y0: y0,
                x1: x1,
                y1: y1,
                clipX0: clipX0,
                clipY0: clipY0,
                clipX1: clipX1,
                clipY1: clipY1,
                horizontalInset: horizontalInset,
                verticalInset: verticalInset
            };
        },
        applyFn (rect, params) {
            rect.setProperties($2fb96651e8aa1522$var$resetLinearGaugeSeriesResetRectFunction(rect, params));
        }
    };
    return {
        node: node
    };
}
function $2fb96651e8aa1522$var$resetLinearGaugeSeriesResetRectFunction(_node, datum) {
    const { x: x, y: y, width: width, height: height } = $2fb96651e8aa1522$var$datumRect(datum);
    const clipBBox = $2fb96651e8aa1522$var$computeClipBBox(datum);
    const visible = $2fb96651e8aa1522$var$clipBBoxVisibility(datum, clipBBox);
    return {
        x: x,
        y: y,
        width: width,
        height: height,
        clipBBox: clipBBox,
        visible: visible
    };
}
var $2fb96651e8aa1522$var$horizontalTextAligns = {
    ["Before" /* Before */ ]: "right",
    ["Center" /* Center */ ]: "center",
    ["After" /* After */ ]: "left"
};
var $2fb96651e8aa1522$var$verticalTextBaselines = {
    ["Before" /* Before */ ]: "top",
    ["Center" /* Center */ ]: "middle",
    ["After" /* After */ ]: "bottom"
};
var $2fb96651e8aa1522$var$horizontalAlignFactors = {
    ["Before" /* Before */ ]: -1,
    ["Center" /* Center */ ]: -0.5,
    ["After" /* After */ ]: 0
};
var $2fb96651e8aa1522$var$verticalAlignFactors2 = {
    ["Before" /* Before */ ]: 0,
    ["Center" /* Center */ ]: -0.5,
    ["After" /* After */ ]: -1
};
function $2fb96651e8aa1522$var$formatLinearGaugeLabels(series, ctx, selection, opts, bboxes, datumOverrides) {
    const { seriesRect: seriesRect, gaugeRect: gaugeRect, barRect: barRect } = bboxes;
    const { padding: padding, horizontal: horizontal } = opts;
    selection.each((label, labelDatum)=>{
        const labelText = $2fb96651e8aa1522$var$getLabelText(series.id, ctx, labelDatum, datumOverrides?.label);
        let boundingWidth;
        let boundingHeight;
        if (labelDatum.placement === "outside-start") {
            if (horizontal) {
                boundingWidth = gaugeRect.x;
                boundingHeight = seriesRect.height;
            } else {
                boundingWidth = seriesRect.width;
                boundingHeight = seriesRect.height - (gaugeRect.y + gaugeRect.height);
            }
        } else if (labelDatum.placement === "outside-end") {
            if (horizontal) {
                boundingWidth = seriesRect.width - (gaugeRect.x + gaugeRect.width);
                boundingHeight = seriesRect.height;
            } else {
                boundingWidth = seriesRect.width;
                boundingHeight = gaugeRect.y;
            }
        } else if (labelDatum.avoidCollisions) {
            boundingWidth = gaugeRect.width;
            boundingHeight = gaugeRect.height;
        }
        let layout;
        if (labelText == null) return;
        else if (boundingWidth != null && boundingHeight != null) {
            const sizeFittingHeight = ()=>({
                    width: boundingWidth,
                    height: boundingHeight,
                    meta: null
                });
            const labelMeta = $2fb96651e8aa1522$var$formatSingleLabel(labelText, labelDatum, {
                padding: padding
            }, sizeFittingHeight);
            layout = labelMeta?.[0];
        } else {
            const font2 = {
                fontSize: labelDatum.fontSize,
                fontStyle: labelDatum.fontStyle,
                fontWeight: labelDatum.fontWeight,
                fontFamily: labelDatum.fontFamily,
                lineHeight: labelDatum.lineHeight
            };
            const { width: width, height: height } = $2fb96651e8aa1522$var$CachedTextMeasurerPool5.measureText(labelText, {
                font: font2
            });
            layout = {
                text: labelText,
                fontSize: labelDatum.fontSize,
                lineHeight: $2fb96651e8aa1522$var$getLineHeight(labelDatum, labelDatum.fontSize),
                width: width,
                height: height
            };
        }
        if (layout == null) {
            label.visible = false;
            return;
        }
        const scale0 = horizontal ? gaugeRect.x : gaugeRect.y + gaugeRect.height;
        const scale1 = horizontal ? gaugeRect.x + gaugeRect.width : gaugeRect.y;
        const bar0 = horizontal ? barRect.x : barRect.y + barRect.height;
        const bar1 = horizontal ? barRect.x + barRect.width : barRect.y;
        const offset = labelDatum.spacing * (horizontal ? 1 : -1);
        let bounds0;
        let bounds1;
        let s;
        let align;
        switch(labelDatum.placement){
            case "outside-start":
                bounds0 = -Infinity;
                bounds1 = Infinity;
                s = scale0 - offset;
                align = "Before" /* Before */ ;
                break;
            case "outside-end":
                bounds0 = -Infinity;
                bounds1 = Infinity;
                s = scale1 + offset;
                align = "After" /* After */ ;
                break;
            case "inside-start":
                bounds0 = scale0;
                bounds1 = bar1;
                s = scale0 + offset;
                align = "After" /* After */ ;
                break;
            case "inside-end":
                bounds0 = bar1;
                bounds1 = scale1;
                s = scale1 - offset;
                align = "Before" /* Before */ ;
                break;
            case "inside-center":
                bounds0 = scale0;
                bounds1 = scale1;
                s = (scale0 + scale1) / 2;
                align = "Center" /* Center */ ;
                break;
            case "bar-inside":
                bounds0 = bar0;
                bounds1 = bar1;
                s = (bar0 + bar1) / 2;
                align = "Center" /* Center */ ;
                break;
            case "bar-inside-end":
                bounds0 = bar0;
                bounds1 = bar1;
                s = bar1 - offset;
                align = "Before" /* Before */ ;
                break;
            case "bar-outside-end":
                bounds0 = bar1;
                bounds1 = scale1;
                s = bar1 + offset;
                align = "After" /* After */ ;
                break;
            case "bar-end":
                bounds0 = -Infinity;
                bounds1 = Infinity;
                s = bar1;
                align = "Center" /* Center */ ;
                break;
        }
        const x = horizontal ? s : gaugeRect.x + gaugeRect.width / 2;
        const y = horizontal ? gaugeRect.y + gaugeRect.height / 2 : s;
        let s0;
        let s1;
        if (horizontal) {
            s0 = x + $2fb96651e8aa1522$var$horizontalAlignFactors[align] * layout.width;
            s1 = s0 + layout.width;
        } else {
            s0 = y + $2fb96651e8aa1522$var$verticalAlignFactors2[align] * layout.height;
            s1 = s0 + layout.height;
        }
        const inside = Math.min(s0, s1) >= Math.min(bounds0, bounds1) && Math.max(s0, s1) <= Math.max(bounds0, bounds1);
        if (labelDatum.avoidCollisions && !inside) {
            label.visible = false;
            return;
        }
        label.visible = true;
        label.text = layout.text;
        label.fontSize = layout.fontSize;
        label.lineHeight = layout.lineHeight;
        label.textAlign = horizontal ? $2fb96651e8aa1522$var$horizontalTextAligns[align] : "center";
        label.textBaseline = horizontal ? "middle" : $2fb96651e8aa1522$var$verticalTextBaselines[align];
        label.x = x;
        label.y = y;
    });
}
// packages/ag-charts-enterprise/src/series/linear-gauge/linearGaugeSeries.ts
var { fromToMotion: $2fb96651e8aa1522$var$fromToMotion2, resetMotion: $2fb96651e8aa1522$var$resetMotion3, SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode8, StateMachine: $2fb96651e8aa1522$var$StateMachine12, createDatumId: $2fb96651e8aa1522$var$createDatumId12, CachedTextMeasurerPool: $2fb96651e8aa1522$var$CachedTextMeasurerPool6, toRadians: $2fb96651e8aa1522$var$toRadians4, BBox: $2fb96651e8aa1522$var$BBox17, Group: $2fb96651e8aa1522$var$Group12, PointerEvents: $2fb96651e8aa1522$var$PointerEvents5, Selection: $2fb96651e8aa1522$var$Selection7, Rect: $2fb96651e8aa1522$var$Rect8, Text: $2fb96651e8aa1522$var$Text2, TransformableText: $2fb96651e8aa1522$var$TransformableText2, Marker: $2fb96651e8aa1522$var$Marker2, LinearScale: $2fb96651e8aa1522$var$LinearScale3, AxisTickGenerator: $2fb96651e8aa1522$var$AxisTickGenerator2, NiceMode: $2fb96651e8aa1522$var$NiceMode, easing: $2fb96651e8aa1522$var$easing, getColorStops: $2fb96651e8aa1522$var$getColorStops, findRangeExtent: $2fb96651e8aa1522$var$findRangeExtent } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$horizontalTargetPlacementRotation = {
    before: 180,
    middle: 0,
    after: 0
};
var $2fb96651e8aa1522$var$verticalTargetPlacementRotation = {
    before: 90,
    middle: 0,
    after: -90
};
var $2fb96651e8aa1522$var$LinearGaugeAxis = class {
    constructor(gauge, ctx){
        this.gauge = gauge;
        this.ctx = ctx;
    }
    get defaultTickMinSpacing() {
        return 0;
    }
    get range() {
        return this.gauge.range;
    }
    get reverse() {
        return false;
    }
    get scale() {
        return this.gauge.scale;
    }
    get label() {
        return this.gauge.properties.scale.label;
    }
    get interval() {
        return this.gauge.properties.scale.interval;
    }
    formatTick(value, index, domain, _fractionDigits, _timeInterval, defaultFormatter) {
        const { label: label } = this;
        return this.formatWithContext(value, index, domain) ?? (label.format != null ? defaultFormatter?.(value) : void 0) ?? this.gauge.formatLabel(value);
    }
    formatWithContext(value, index, domain) {
        let r = void 0;
        if (this.label.formatter) r = $2fb96651e8aa1522$var$formatWithContext(this.ctx, this.label.formatter, {
            value: value,
            index: index,
            domain: domain,
            boundSeries: void 0
        });
        return r;
    }
    inRange() {
        return true;
    }
};
var $2fb96651e8aa1522$var$LinearGaugeSeries = class extends (0, $iTJTu._ModuleSupport).Series {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            useLabelLayer: true,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode8.EXACT_SHAPE_MATCH,
                $2fb96651e8aa1522$var$SeriesNodePickMode8.NEAREST_NODE
            ]
        });
        this.properties = new $2fb96651e8aa1522$var$LinearGaugeSeriesProperties();
        this.seriesRect = $2fb96651e8aa1522$var$BBox17.NaN;
        this.gaugeRect = $2fb96651e8aa1522$var$BBox17.NaN;
        this.scale = new $2fb96651e8aa1522$var$LinearScale3();
        this.originX = 0;
        this.originY = 0;
        this.scaleGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group12({
            name: "scaleGroup"
        }));
        this.itemGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group12({
            name: "itemGroup"
        }));
        this.itemTargetGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group12({
            name: "itemTargetGroup"
        }));
        this.itemTargetLabelGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group12({
            name: "itemTargetLabelGroup"
        }));
        this.itemLabelGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group12({
            name: "itemLabelGroup"
        }));
        this.highlightTargetGroup = this.highlightGroup.appendChild(new $2fb96651e8aa1522$var$Group12({
            name: "itemTargetLabelGroup"
        }));
        this.tickGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group12({
            name: "tickGroup"
        }));
        this.scaleSelection = $2fb96651e8aa1522$var$Selection7.select(this.scaleGroup, ()=>this.nodeFactory());
        this.datumSelection = $2fb96651e8aa1522$var$Selection7.select(this.itemGroup, ()=>this.nodeFactory());
        this.targetSelection = $2fb96651e8aa1522$var$Selection7.select(this.itemTargetGroup, ()=>this.markerFactory());
        this.targetLabelSelection = $2fb96651e8aa1522$var$Selection7.select(this.itemTargetLabelGroup, $2fb96651e8aa1522$var$Text2);
        this.labelSelection = $2fb96651e8aa1522$var$Selection7.select(this.itemLabelGroup, $2fb96651e8aa1522$var$Text2);
        this.highlightTargetSelection = $2fb96651e8aa1522$var$Selection7.select(this.highlightTargetGroup, ()=>this.markerFactory());
        this.tickSelection = $2fb96651e8aa1522$var$Selection7.select(this.tickGroup, $2fb96651e8aa1522$var$TransformableText2);
        this.datumUnion = new $2fb96651e8aa1522$var$DatumUnion();
        this.axis = new $2fb96651e8aa1522$var$LinearGaugeAxis(this, moduleCtx);
        this.tickGenerator = new $2fb96651e8aa1522$var$AxisTickGenerator2(this.axis);
        this.animationState = new $2fb96651e8aa1522$var$StateMachine12("empty", {
            empty: {
                update: {
                    target: "ready",
                    action: ()=>this.animateEmptyUpdateReady()
                },
                reset: "empty",
                skip: "ready"
            },
            ready: {
                updateData: "waiting",
                clear: "clearing",
                resize: ()=>this.animateReadyResize(),
                reset: "empty",
                skip: "ready"
            },
            waiting: {
                update: {
                    target: "ready",
                    action: ()=>this.animateWaitingUpdateReady()
                },
                reset: "empty",
                skip: "ready"
            },
            clearing: {
                update: {
                    target: "empty"
                },
                reset: "empty",
                skip: "ready"
            }
        });
        this.scaleGroup.pointerEvents = $2fb96651e8aa1522$var$PointerEvents5.None;
        this.tickGroup.pointerEvents = $2fb96651e8aa1522$var$PointerEvents5.None;
    }
    get range() {
        return this.horizontal ? [
            0,
            this.gaugeRect.width
        ] : [
            0,
            this.gaugeRect.height
        ];
    }
    get horizontal() {
        return this.properties.direction === "horizontal";
    }
    get hasData() {
        return true;
    }
    nodeFactory() {
        const rect = new $2fb96651e8aa1522$var$Rect8();
        rect.crisp = true;
        return rect;
    }
    markerFactory() {
        return new $2fb96651e8aa1522$var$Marker2();
    }
    processData() {
        this.nodeDataRefresh = true;
        this.animationState.transition("updateData");
    }
    formatLabel(value) {
        return $2fb96651e8aa1522$var$formatLabel(value, this.properties.scale);
    }
    createLinearGradient(scale, fills, fillMode) {
        const { properties: properties, horizontal: horizontal } = this;
        const { defaultColorRange: defaultColorRange } = properties;
        const colorStops = $2fb96651e8aa1522$var$getColorStops(fills, defaultColorRange, scale.domain, fillMode);
        return {
            type: "gradient",
            gradient: "linear",
            colorSpace: "oklch",
            colorStops: colorStops,
            rotation: horizontal ? 90 : 0
        };
    }
    getShapeFillBBox() {
        const { properties: properties, originX: originX, originY: originY, horizontal: horizontal, scale: scale } = this;
        const { thickness: thickness } = properties;
        const length = $2fb96651e8aa1522$var$findRangeExtent(scale.range);
        return new $2fb96651e8aa1522$var$BBox17(originX, originY, horizontal ? length : thickness, horizontal ? thickness : length);
    }
    getTargets() {
        const { properties: properties } = this;
        const defaultTarget = properties.defaultTarget;
        return Array.from(properties.targets).map((target)=>{
            const { text: text2 = defaultTarget.text, value: value = defaultTarget.value ?? 0, shape: shape = defaultTarget.shape ?? "triangle", rotation: rotation = defaultTarget.rotation ?? 0, strokeWidth: strokeWidth = defaultTarget.strokeWidth ?? 0, placement: placement = defaultTarget.placement ?? "middle", spacing: spacing = defaultTarget.spacing ?? 0, size: size = defaultTarget.size ?? 0, fill: fill = defaultTarget.fill ?? "black", fillOpacity: fillOpacity = defaultTarget.fillOpacity ?? 1, stroke: stroke2 = defaultTarget.stroke ?? "black", strokeOpacity: strokeOpacity = defaultTarget.strokeOpacity ?? 1, lineDash: lineDash = defaultTarget.lineDash ?? [
                0
            ], lineDashOffset: lineDashOffset = defaultTarget.lineDashOffset ?? 0 } = target;
            const { enabled: labelEnabled = defaultTarget.label.enabled, color: labelColor = defaultTarget.label.color ?? "black", fontStyle: labelFontStyle = defaultTarget.label.fontStyle ?? "normal", fontWeight: labelFontWeight = defaultTarget.label.fontWeight ?? "normal", fontSize: labelFontSize = defaultTarget.label.fontSize, fontFamily: labelFontFamily = defaultTarget.label.fontFamily, spacing: labelSpacing = defaultTarget.label.spacing ?? 0 } = target.label;
            return {
                text: text2,
                value: value,
                shape: shape,
                placement: placement,
                spacing: spacing,
                size: size,
                rotation: rotation,
                fill: fill,
                fillOpacity: fillOpacity,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                strokeOpacity: strokeOpacity,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset,
                label: {
                    enabled: labelEnabled,
                    color: labelColor,
                    fontStyle: labelFontStyle,
                    fontWeight: labelFontWeight,
                    fontSize: labelFontSize,
                    fontFamily: labelFontFamily,
                    spacing: labelSpacing
                }
            };
        });
    }
    getTargetPoint(target) {
        const { properties: properties, originX: originX, originY: originY, horizontal: horizontal, scale: scale, gaugeRect: gaugeRect } = this;
        const { thickness: thickness } = properties;
        const { value: value, placement: placement, spacing: spacing, size: size } = target;
        const mainOffset = scale.convert(value);
        let crossOffset;
        switch(placement){
            case "before":
                crossOffset = -(spacing + size / 2);
                break;
            case "after":
                crossOffset = thickness + spacing + size / 2;
                break;
            default:
                crossOffset = thickness / 2;
                break;
        }
        return {
            x: originX + gaugeRect.x + (horizontal ? mainOffset : crossOffset),
            y: originY + gaugeRect.y + (horizontal ? crossOffset : mainOffset)
        };
    }
    getTargetLabel(target) {
        const { size: size, placement: placement, label: label } = target;
        const { spacing: spacing, color: fill, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily } = label;
        const lineHeight = void 0;
        const offset = size / 2 + spacing;
        let textAlign;
        let textBaseline;
        let offsetX = 0;
        let offsetY = 0;
        if (this.horizontal) {
            textAlign = "center";
            if (placement === "after") {
                textBaseline = "top";
                offsetY = offset;
            } else {
                textBaseline = "bottom";
                offsetY = -offset;
            }
        } else {
            textBaseline = "middle";
            if (placement === "before") {
                textAlign = "right";
                offsetX = -offset;
            } else {
                textAlign = "left";
                offsetX = offset;
            }
        }
        return {
            offsetX: offsetX,
            offsetY: offsetY,
            fill: fill,
            textAlign: textAlign,
            textBaseline: textBaseline,
            fontStyle: fontStyle,
            fontWeight: fontWeight,
            fontSize: fontSize,
            fontFamily: fontFamily,
            lineHeight: lineHeight
        };
    }
    labelDatum(label, value) {
        const { placement: placement, avoidCollisions: avoidCollisions, spacing: spacing, text: text2, color: fill, fontSize: fontSize, minimumFontSize: minimumFontSize, fontStyle: fontStyle, fontWeight: fontWeight, fontFamily: fontFamily, lineHeight: lineHeight, wrapping: wrapping, overflowStrategy: overflowStrategy, formatter: formatter = (params)=>this.formatLabel(params.value) } = label;
        return {
            placement: placement,
            avoidCollisions: avoidCollisions,
            spacing: spacing,
            text: text2,
            value: value,
            fill: fill,
            fontSize: fontSize,
            minimumFontSize: minimumFontSize,
            fontStyle: fontStyle,
            fontWeight: fontWeight,
            fontFamily: fontFamily,
            lineHeight: lineHeight,
            wrapping: wrapping,
            overflowStrategy: overflowStrategy,
            formatter: formatter
        };
    }
    verticalLabelInset() {
        const { properties: properties } = this;
        const { label: label } = properties;
        const lines = label.text?.split("\n");
        const labelSize = $2fb96651e8aa1522$var$getLineHeight(label, label.fontSize) * (lines?.length ?? 1);
        return label.spacing + labelSize;
    }
    horizontalLabelInset() {
        const { scale: scale, properties: properties } = this;
        const { scale: scaleProps, label: label } = properties;
        const lines = label.text?.split("\n");
        const font2 = label.getFont();
        const ticks = scaleProps.interval.values ?? scale.ticks({
            nice: false,
            interval: scaleProps.interval.step,
            minTickCount: 0,
            maxTickCount: 6,
            tickCount: 5
        })?.ticks ?? [];
        const linesOrTicks = lines ?? ticks?.map((tick)=>$2fb96651e8aa1522$var$getLabelText(this.id, this.ctx, this.labelDatum(label, tick)) ?? "");
        const labelSize = linesOrTicks.reduce((accum, text2)=>{
            const { width: width } = $2fb96651e8aa1522$var$CachedTextMeasurerPool6.measureText(text2, {
                font: font2
            });
            return Math.max(accum, width);
        }, 0);
        return label.spacing + labelSize;
    }
    createNodeData() {
        const { id: seriesId, properties: properties, horizontal: horizontal, scale: scale, seriesRect: seriesRect } = this;
        const { value: value, segmentation: segmentation, thickness: thickness, cornerRadius: cornerRadius, cornerMode: cornerMode, bar: bar, scale: scaleProps, label: label } = properties;
        scale.domain = [
            scaleProps.min,
            scaleProps.max
        ];
        scale.range = horizontal ? [
            0,
            seriesRect.width
        ] : [
            seriesRect.height,
            0
        ];
        let parallelFlipRotation;
        let sideFlag;
        if (horizontal) {
            sideFlag = 1;
            parallelFlipRotation = Math.PI / 2;
        } else if (scaleProps.label.placement === "before") {
            sideFlag = 1;
            parallelFlipRotation = 0;
        } else {
            sideFlag = -1;
            parallelFlipRotation = 0;
        }
        const regularFlipRotation = parallelFlipRotation - Math.PI / 2;
        let x0;
        let x1;
        let y0;
        let y1;
        if (horizontal) {
            x0 = 0;
            x1 = seriesRect.width;
            y0 = (seriesRect.height - thickness) / 2;
            y1 = y0 + thickness;
            if (label.placement === "outside-start") x0 += this.horizontalLabelInset();
            else if (label.placement === "outside-end") x1 -= this.horizontalLabelInset();
        } else {
            x0 = (seriesRect.width - thickness) / 2;
            x1 = x0 + thickness;
            y1 = 0;
            y0 = seriesRect.height;
            if (label.placement === "outside-start") y0 -= this.verticalLabelInset();
            else if (label.placement === "outside-end") y1 += this.verticalLabelInset();
        }
        this.gaugeRect = new $2fb96651e8aa1522$var$BBox17(Math.min(x0, x1), Math.min(y0, y1), Math.abs(x1 - x0), Math.abs(y1 - y0));
        const originX = 0;
        const originY = 0;
        scale.domain = [
            scaleProps.min,
            scaleProps.max
        ];
        scale.range = horizontal ? [
            x0,
            x1
        ] : [
            y0,
            y1
        ];
        const { ticks: tickData } = this.tickGenerator.generateTicks({
            domain: scale.domain,
            primaryTickCount: void 0,
            visibleRange: [
                0,
                1
            ],
            niceMode: $2fb96651e8aa1522$var$NiceMode.Off,
            labelX: 0,
            parallelFlipRotation: parallelFlipRotation,
            regularFlipRotation: regularFlipRotation,
            sideFlag: sideFlag,
            removeOverflowLabels: false
        }).tickData;
        const isReversed = false;
        const targets = this.getTargets();
        const nodeData = [];
        const targetData = [];
        const labelData = [];
        const scaleData = [];
        const [m0, m1] = scale.range;
        const mainAxisSize = Math.abs(m1 - m0);
        const containerX = horizontal ? scale.convert(value) : x1;
        const containerY = horizontal ? y1 : scale.convert(value);
        const inset = segmentation.enabled ? segmentation.spacing / 2 : 0;
        const horizontalInset = horizontal ? inset : 0;
        const verticalInset = horizontal ? 0 : inset;
        const barThickness = Math.min(bar.thickness ?? Math.round(bar.thicknessRatio * thickness), thickness);
        const barInset = -(thickness - barThickness) / 2;
        const barXInset = horizontal ? 0 : barInset;
        const barYInset = horizontal ? barInset : 0;
        const cornersOnAllItems = cornerMode === "item";
        const maxTicks = Math.ceil(mainAxisSize);
        let segments = segmentation.enabled ? segmentation.interval.getSegments(scale, maxTicks) : void 0;
        const barFill = bar.fill ?? this.createLinearGradient(scale, bar.fills, bar.fillMode);
        const scaleFill = scaleProps.fill ?? (bar.enabled && scaleProps.fills.length === 0 ? scaleProps.defaultFill : void 0) ?? this.createLinearGradient(scale, scaleProps.fills, scaleProps.fillMode);
        if (segments == null && cornersOnAllItems) {
            const segmentStart = Math.min(...scale.domain);
            const segmentEnd = Math.max(...scale.domain);
            const datum = {
                value: value,
                segmentStart: segmentStart,
                segmentEnd: segmentEnd
            };
            if (bar.enabled) {
                const barAppliedCornerRadius = Math.min(cornerRadius, barThickness / 2, mainAxisSize / 2);
                const barCornerInset = barAppliedCornerRadius * (isReversed ? -1 : 1);
                const barCornerXInset = horizontal ? barCornerInset : 0;
                const barCornerYInset = horizontal ? 0 : barCornerInset;
                nodeData.push({
                    series: this,
                    itemId: `value`,
                    datum: datum,
                    datumIndex: {
                        type: 0 /* Node */ 
                    },
                    type: 0 /* Node */ ,
                    x0: originX + x0 - barCornerXInset - barXInset,
                    y0: originY + y0 - barCornerYInset - barYInset,
                    x1: originX + containerX + barCornerXInset + barXInset,
                    y1: originY + containerY + barCornerYInset + barYInset,
                    clipX0: void 0,
                    clipY0: void 0,
                    clipX1: void 0,
                    clipY1: void 0,
                    topLeftCornerRadius: cornerRadius,
                    topRightCornerRadius: cornerRadius,
                    bottomRightCornerRadius: cornerRadius,
                    bottomLeftCornerRadius: cornerRadius,
                    fill: barFill,
                    horizontalInset: horizontalInset,
                    verticalInset: verticalInset
                });
            }
            const scaleAppliedCornerRadius = Math.min(cornerRadius, thickness / 2, mainAxisSize / 2);
            const scaleCornerInset = scaleAppliedCornerRadius * (isReversed ? -1 : 1);
            const scaleCornerXInset = horizontal ? scaleCornerInset : 0;
            const scaleCornerYInset = horizontal ? 0 : scaleCornerInset;
            scaleData.push({
                series: this,
                itemId: `scale`,
                datum: datum,
                datumIndex: {
                    type: 0 /* Node */ 
                },
                type: 0 /* Node */ ,
                x0: originX + x0 - scaleCornerXInset,
                y0: originY + y0 - scaleCornerYInset,
                x1: originX + x1 + scaleCornerXInset,
                y1: originY + y1 + scaleCornerYInset,
                clipX0: void 0,
                clipY0: void 0,
                clipX1: void 0,
                clipY1: void 0,
                topLeftCornerRadius: cornerRadius,
                topRightCornerRadius: cornerRadius,
                bottomRightCornerRadius: cornerRadius,
                bottomLeftCornerRadius: cornerRadius,
                fill: scaleFill,
                horizontalInset: horizontalInset,
                verticalInset: verticalInset
            });
        } else {
            segments ?? (segments = scale.domain);
            const clipX0 = originX + x0 - barXInset;
            const clipY0 = originY + y0 - barYInset;
            const clipX1 = originX + containerX + barXInset;
            const clipY1 = originY + containerY + barYInset;
            for(let i = 0; i < segments.length - 1; i += 1){
                const segmentStart = segments[i + 0];
                const segmentEnd = segments[i + 1];
                const datum = {
                    value: value,
                    segmentStart: segmentStart,
                    segmentEnd: segmentEnd
                };
                const isStart = i === 0;
                const isEnd = i === segments.length - 2;
                const itemStart = scale.convert(segmentStart);
                const itemEnd = scale.convert(segmentEnd);
                const startCornerRadius = cornersOnAllItems || isStart ? cornerRadius : 0;
                const endCornerRadius = cornersOnAllItems || isEnd ? cornerRadius : 0;
                const topLeftCornerRadius = horizontal ? startCornerRadius : endCornerRadius;
                const topRightCornerRadius = endCornerRadius;
                const bottomRightCornerRadius = horizontal ? endCornerRadius : startCornerRadius;
                const bottomLeftCornerRadius = startCornerRadius;
                if (bar.enabled) nodeData.push({
                    series: this,
                    itemId: `value-${i}`,
                    datum: datum,
                    datumIndex: {
                        type: 0 /* Node */ 
                    },
                    type: 0 /* Node */ ,
                    x0: originX + (horizontal ? itemStart : x0),
                    y0: originY + (horizontal ? y0 : itemStart),
                    x1: originX + (horizontal ? itemEnd : x1),
                    y1: originY + (horizontal ? y1 : itemEnd),
                    clipX0: clipX0,
                    clipY0: clipY0,
                    clipX1: clipX1,
                    clipY1: clipY1,
                    topLeftCornerRadius: topLeftCornerRadius,
                    topRightCornerRadius: topRightCornerRadius,
                    bottomRightCornerRadius: bottomRightCornerRadius,
                    bottomLeftCornerRadius: bottomLeftCornerRadius,
                    fill: barFill,
                    horizontalInset: horizontalInset,
                    verticalInset: verticalInset
                });
                scaleData.push({
                    series: this,
                    itemId: `scale-${i}`,
                    datum: datum,
                    datumIndex: {
                        type: 0 /* Node */ 
                    },
                    type: 0 /* Node */ ,
                    x0: originX + (horizontal ? itemStart : x0),
                    y0: originY + (horizontal ? y0 : itemStart),
                    x1: originX + (horizontal ? itemEnd : x1),
                    y1: originY + (horizontal ? y1 : itemEnd),
                    clipX0: void 0,
                    clipY0: void 0,
                    clipX1: void 0,
                    clipY1: void 0,
                    topLeftCornerRadius: topLeftCornerRadius,
                    topRightCornerRadius: topRightCornerRadius,
                    bottomRightCornerRadius: bottomRightCornerRadius,
                    bottomLeftCornerRadius: bottomLeftCornerRadius,
                    fill: scaleFill,
                    horizontalInset: horizontalInset,
                    verticalInset: verticalInset
                });
            }
        }
        if (label.enabled) labelData.push(this.labelDatum(label, value));
        const targetPlacementRotation2 = horizontal ? $2fb96651e8aa1522$var$horizontalTargetPlacementRotation : $2fb96651e8aa1522$var$verticalTargetPlacementRotation;
        for(let i = 0; i < targets.length; i += 1){
            const target = targets[i];
            const { value: targetValue, text: text2, shape: shape, size: size, fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = target;
            const targetPoint = this.getTargetPoint(target);
            const targetRotation = $2fb96651e8aa1522$var$toRadians4(target.rotation + targetPlacementRotation2[target.placement]);
            targetData.push({
                series: this,
                itemId: `target-${i}`,
                midPoint: targetPoint,
                datum: {
                    value: targetValue
                },
                datumIndex: {
                    type: 1 /* Target */ ,
                    index: i
                },
                type: 1 /* Target */ ,
                value: targetValue,
                text: text2,
                x: targetPoint.x,
                y: targetPoint.y,
                shape: shape,
                size: size,
                rotation: targetRotation,
                fill: fill,
                fillOpacity: fillOpacity,
                stroke: stroke2,
                strokeOpacity: strokeOpacity,
                strokeWidth: strokeWidth,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset,
                label: this.getTargetLabel(target)
            });
        }
        return {
            itemId: seriesId,
            nodeData: nodeData,
            tickData: tickData,
            targetData: targetData,
            labelData: labelData,
            scaleData: scaleData
        };
    }
    updateSelections(resize) {
        if (this.nodeDataRefresh || resize) {
            this.contextNodeData = this.createNodeData();
            this.nodeDataRefresh = false;
        }
    }
    highlightDatum(node) {
        if (node != null && node.series === this && node.type === 1 /* Target */ ) return node;
    }
    update({ seriesRect: seriesRect }) {
        const { datumSelection: datumSelection, labelSelection: labelSelection, targetSelection: targetSelection, targetLabelSelection: targetLabelSelection, scaleSelection: scaleSelection, highlightTargetSelection: highlightTargetSelection, tickSelection: tickSelection } = this;
        this.seriesRect = seriesRect ?? $2fb96651e8aa1522$var$BBox17.NaN;
        const resize = this.checkResize(seriesRect);
        this.updateSelections(resize);
        this.contentGroup.visible = this.visible;
        this.contentGroup.opacity = this.getOpacity();
        const nodeData = this.contextNodeData?.nodeData ?? [];
        const labelData = this.contextNodeData?.labelData ?? [];
        const targetData = this.contextNodeData?.targetData ?? [];
        const scaleData = this.contextNodeData?.scaleData ?? [];
        const tickData = this.contextNodeData?.tickData ?? [];
        const highlightTargetDatum = this.highlightDatum(this.ctx.highlightManager.getActiveHighlight());
        this.scaleSelection = this.updateScaleSelection({
            scaleData: scaleData,
            scaleSelection: scaleSelection
        });
        this.updateScaleNodes({
            scaleSelection: scaleSelection
        });
        this.targetSelection = this.updateTargetSelection({
            targetData: targetData,
            targetSelection: targetSelection
        });
        this.updateTargetNodes({
            targetSelection: targetSelection,
            isHighlight: false
        });
        this.targetLabelSelection = this.updateTargetLabelSelection({
            targetData: targetData,
            targetLabelSelection: targetLabelSelection
        });
        this.updateTargetLabelNodes({
            targetLabelSelection: targetLabelSelection
        });
        this.datumSelection = this.updateDatumSelection({
            nodeData: nodeData,
            datumSelection: datumSelection
        });
        this.updateDatumNodes({
            datumSelection: datumSelection
        });
        this.labelSelection = this.updateLabelSelection({
            labelData: labelData,
            labelSelection: labelSelection
        });
        this.updateLabelNodes({
            labelSelection: labelSelection
        });
        this.highlightTargetSelection = this.updateTargetSelection({
            targetData: highlightTargetDatum != null ? [
                highlightTargetDatum
            ] : [],
            targetSelection: highlightTargetSelection
        });
        this.updateTargetNodes({
            targetSelection: highlightTargetSelection,
            isHighlight: true
        });
        this.tickSelection = this.updateTickSelection({
            tickData: tickData,
            tickSelection: tickSelection
        });
        this.updateTickNodes({
            tickSelection: tickSelection
        });
        if (resize) this.animationState.transition("resize");
        this.animationState.transition("update");
    }
    updateDatumSelection(opts) {
        return opts.datumSelection.update(opts.nodeData, void 0, (datum)=>{
            return $2fb96651e8aa1522$var$createDatumId12(opts.nodeData.length, datum.itemId);
        });
    }
    updateDatumNodes(opts) {
        const { datumSelection: datumSelection } = opts;
        const { ctx: ctx, properties: properties } = this;
        const { bar: bar } = properties;
        const { fillOpacity: fillOpacity, stroke: stroke2, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = bar;
        const strokeWidth = this.getStrokeWidth(bar.strokeWidth);
        const animationDisabled = ctx.animationManager.isSkipped();
        const fillBBox = this.getShapeFillBBox();
        datumSelection.each((rect, datum)=>{
            const { topLeftCornerRadius: topLeftCornerRadius, topRightCornerRadius: topRightCornerRadius, bottomRightCornerRadius: bottomRightCornerRadius, bottomLeftCornerRadius: bottomLeftCornerRadius, fill: fill } = datum;
            rect.fill = fill;
            rect.fillBBox = fillBBox;
            rect.fillOpacity = fillOpacity;
            rect.stroke = stroke2;
            rect.strokeOpacity = strokeOpacity;
            rect.strokeWidth = strokeWidth;
            rect.lineDash = lineDash;
            rect.lineDashOffset = lineDashOffset;
            rect.topLeftCornerRadius = topLeftCornerRadius;
            rect.topRightCornerRadius = topRightCornerRadius;
            rect.bottomRightCornerRadius = bottomRightCornerRadius;
            rect.bottomLeftCornerRadius = bottomLeftCornerRadius;
            rect.pointerEvents = this.properties.bar.enabled ? (0, $iTJTu._ModuleSupport).PointerEvents.All : (0, $iTJTu._ModuleSupport).PointerEvents.None;
            if (animationDisabled || rect.previousDatum == null) rect.setProperties($2fb96651e8aa1522$var$resetLinearGaugeSeriesResetRectFunction(rect, datum));
        });
        this.datumUnion.update(datumSelection, this.itemGroup, (0, $iTJTu._ModuleSupport).Rect, (node, first, last)=>{
            node.pointerEvents = (0, $iTJTu._ModuleSupport).PointerEvents.None;
            node.clipBBox ?? (node.clipBBox = new $2fb96651e8aa1522$var$BBox17(NaN, NaN, NaN, NaN));
            node.x = first.x;
            node.y = first.y;
            node.clipBBox.x = first.clipBBox?.x ?? first.x;
            node.clipBBox.y = first.clipBBox?.y ?? first.y;
            if (this.horizontal) {
                node.height = node.clipBBox.height = last.height;
                node.width = last === first ? last.width : last.x + last.width;
                node.clipBBox.width = node.width - (last.width - (last.clipBBox?.width ?? last.width));
                node.topLeftCornerRadius = first.topLeftCornerRadius;
                node.bottomLeftCornerRadius = first.bottomLeftCornerRadius;
                node.topRightCornerRadius = last.topRightCornerRadius;
                node.bottomRightCornerRadius = last.bottomRightCornerRadius;
            } else {
                node.width = node.clipBBox.width = last.width;
                node.height = last === first ? last.height : last.x + last.height;
                node.clipBBox.height = node.height - (last.height - (last.clipBBox?.height ?? last.height));
                node.topLeftCornerRadius = first.topLeftCornerRadius;
                node.topRightCornerRadius = first.topRightCornerRadius;
                node.bottomLeftCornerRadius = last.bottomLeftCornerRadius;
                node.bottomRightCornerRadius = last.bottomRightCornerRadius;
            }
        });
    }
    updateScaleSelection(opts) {
        return opts.scaleSelection.update(opts.scaleData, void 0, (datum)=>{
            return $2fb96651e8aa1522$var$createDatumId12(opts.scaleData.length, datum.itemId);
        });
    }
    updateScaleNodes(opts) {
        const { scaleSelection: scaleSelection } = opts;
        const { scale: scale } = this.properties;
        const { fillOpacity: fillOpacity, stroke: stroke2, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset } = scale;
        const fillBBox = this.getShapeFillBBox();
        scaleSelection.each((rect, datum)=>{
            const { topLeftCornerRadius: topLeftCornerRadius, topRightCornerRadius: topRightCornerRadius, bottomRightCornerRadius: bottomRightCornerRadius, bottomLeftCornerRadius: bottomLeftCornerRadius, fill: fill } = datum;
            rect.fill = fill;
            rect.fillBBox = fillBBox;
            rect.fillOpacity = fillOpacity;
            rect.stroke = stroke2;
            rect.strokeOpacity = strokeOpacity;
            rect.strokeWidth = strokeWidth;
            rect.lineDash = lineDash;
            rect.lineDashOffset = lineDashOffset;
            rect.topLeftCornerRadius = topLeftCornerRadius;
            rect.topRightCornerRadius = topRightCornerRadius;
            rect.bottomRightCornerRadius = bottomRightCornerRadius;
            rect.bottomLeftCornerRadius = bottomLeftCornerRadius;
            rect.setProperties($2fb96651e8aa1522$var$resetLinearGaugeSeriesResetRectFunction(rect, datum));
        });
    }
    updateTargetSelection(opts) {
        return opts.targetSelection.update(opts.targetData, void 0, (target)=>target.itemId);
    }
    updateTargetNodes(opts) {
        const { targetSelection: targetSelection, isHighlight: isHighlight } = opts;
        const highlightStyle = isHighlight ? this.properties.highlightStyle.item : void 0;
        targetSelection.each((target, datum)=>{
            const { x: x, y: y, shape: shape, size: size, rotation: rotation, fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset } = datum;
            target.size = size;
            target.shape = shape === "line" ? $2fb96651e8aa1522$var$lineMarker : shape;
            target.fill = highlightStyle?.fill ?? fill;
            target.fillOpacity = highlightStyle?.fillOpacity ?? fillOpacity;
            target.stroke = highlightStyle?.stroke ?? stroke2;
            target.strokeOpacity = highlightStyle?.strokeOpacity ?? strokeOpacity;
            target.strokeWidth = highlightStyle?.strokeWidth ?? strokeWidth;
            target.lineDash = highlightStyle?.lineDash ?? lineDash;
            target.lineDashOffset = highlightStyle?.lineDashOffset ?? lineDashOffset;
            target.translationX = x;
            target.translationY = y;
            target.rotation = rotation;
        });
    }
    updateTargetLabelSelection(opts) {
        return opts.targetLabelSelection.update(opts.targetData);
    }
    updateTargetLabelNodes(opts) {
        const { targetLabelSelection: targetLabelSelection } = opts;
        targetLabelSelection.each((label, target)=>{
            const { x: x, y: y, text: text2 } = target;
            const { offsetX: offsetX, offsetY: offsetY, fill: fill, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily, textAlign: textAlign, textBaseline: textBaseline } = target.label;
            label.visible = true;
            label.x = x + offsetX;
            label.y = y + offsetY;
            label.text = text2;
            label.fill = fill;
            label.fontStyle = fontStyle;
            label.fontWeight = fontWeight;
            label.fontSize = fontSize;
            label.fontFamily = fontFamily;
            label.textAlign = textAlign;
            label.textBaseline = textBaseline;
        });
    }
    updateTickSelection(opts) {
        return opts.tickSelection.update(opts.tickData, void 0, (datum)=>datum.tickId);
    }
    updateTickNodes(opts) {
        const { gaugeRect: gaugeRect, properties: properties } = this;
        const defaultScale = properties.defaultScale;
        const { enabled: enabled, color: color6, fontFamily: fontFamily = defaultScale.label.fontFamily, fontSize: fontSize = defaultScale.label.fontSize, fontStyle: fontStyle, fontWeight: fontWeight = defaultScale.label.fontWeight, spacing: spacing } = properties.scale.label;
        let { placement: placement } = properties.scale.label;
        const rotation = $2fb96651e8aa1522$var$toRadians4(properties.scale.label.rotation ?? 0);
        let textAlign;
        let textBaseline;
        let textX;
        let textY;
        if (this.horizontal) {
            placement ?? (placement = "after");
            textAlign = "center";
            textBaseline = placement === "before" ? "bottom" : "top";
            textY = this.originY + gaugeRect.y + (placement === "before" ? -spacing : gaugeRect.height + spacing);
        } else {
            placement ?? (placement = "before");
            textAlign = placement === "before" ? "end" : "start";
            textBaseline = "middle";
            textX = this.originX + gaugeRect.x + (placement === "before" ? -spacing : gaugeRect.width + spacing);
        }
        opts.tickSelection.each((label, datum)=>{
            if (!enabled) {
                label.visible = false;
                return;
            }
            const x = textX ?? datum.translationY;
            const y = textY ?? datum.translationY;
            label.visible = true;
            label.text = datum.tickLabel;
            label.fill = color6;
            label.fontFamily = fontFamily;
            label.fontSize = fontSize;
            label.fontStyle = fontStyle;
            label.fontWeight = fontWeight;
            label.textBaseline = textBaseline;
            label.textAlign = textAlign;
            label.x = x;
            label.y = y;
            label.rotationCenterX = x;
            label.rotationCenterY = y;
            label.rotation = rotation;
        });
    }
    updateLabelSelection(opts) {
        return opts.labelSelection.update(opts.labelData, void 0, (_datum)=>"primary");
    }
    updateLabelNodes(opts) {
        const { labelSelection: labelSelection } = opts;
        const animationDisabled = this.ctx.animationManager.isSkipped();
        labelSelection.each((label, datum)=>{
            label.fill = datum.fill;
            label.fontStyle = datum.fontStyle;
            label.fontWeight = datum.fontWeight;
            label.fontFamily = datum.fontFamily;
        });
        if (animationDisabled || this.labelsHaveExplicitText()) this.formatLabelText();
    }
    labelsHaveExplicitText() {
        for (const { datum: datum } of this.labelSelection){
            if (datum.text == null) return false;
        }
        return true;
    }
    formatLabelText(datum) {
        const { labelSelection: labelSelection, horizontal: horizontal, scale: scale, seriesRect: seriesRect, gaugeRect: gaugeRect } = this;
        const { x: x, y: y, width: width, height: height } = gaugeRect;
        const value = datum?.label ?? this.properties.value;
        let barRect;
        if (horizontal) {
            const xValue2 = scale.convert(value);
            barRect = new $2fb96651e8aa1522$var$BBox17(x, y, xValue2 - x, height);
        } else {
            const yValue = scale.convert(value);
            barRect = new $2fb96651e8aa1522$var$BBox17(x, yValue, width, height - yValue);
        }
        const bboxes = {
            seriesRect: seriesRect,
            gaugeRect: gaugeRect,
            barRect: barRect
        };
        const { margin: padding } = this.properties;
        $2fb96651e8aa1522$var$formatLinearGaugeLabels(this, this.ctx, labelSelection, {
            padding: padding,
            horizontal: horizontal
        }, bboxes, datum);
    }
    resetAllAnimation() {
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
        $2fb96651e8aa1522$var$resetMotion3([
            this.datumSelection
        ], $2fb96651e8aa1522$var$resetLinearGaugeSeriesResetRectFunction);
        this.formatLabelText();
    }
    resetAnimation(phase) {
        if (phase === "initial") this.animationState.transition("reset");
        else if (phase === "ready") this.animationState.transition("skip");
    }
    animateLabelText(params = {}) {
        const { animationManager: animationManager } = this.ctx;
        let labelFrom = 0;
        let labelTo = 0;
        this.labelSelection.each((label, datum)=>{
            label.opacity = 1;
            labelFrom = label.previousDatum?.value ?? params.from ?? datum.value;
            labelTo = datum.value;
        });
        if (this.labelsHaveExplicitText()) ;
        else if (labelFrom === labelTo) this.formatLabelText({
            label: labelTo
        });
        else {
            const animationId = `${this.id}_labels`;
            animationManager.animate({
                id: animationId,
                groupId: "label",
                from: {
                    label: labelFrom
                },
                to: {
                    label: labelTo
                },
                phase: params.phase ?? "update",
                ease: $2fb96651e8aa1522$var$easing.easeOut,
                onUpdate: (datum)=>this.formatLabelText(datum)
            });
        }
    }
    animateEmptyUpdateReady() {
        const { animationManager: animationManager } = this.ctx;
        const { node: node } = $2fb96651e8aa1522$var$prepareLinearGaugeSeriesAnimationFunctions(true, this.horizontal);
        $2fb96651e8aa1522$var$fromToMotion2(this.id, "node", animationManager, [
            this.datumSelection
        ], node, (_sector, datum)=>datum.itemId);
        $2fb96651e8aa1522$var$fromToMotion2(this.id, "label", animationManager, [
            this.labelSelection
        ], $2fb96651e8aa1522$var$fadeInFns, ()=>"primary");
        this.animateLabelText({
            from: 0,
            phase: "initial"
        });
    }
    animateWaitingUpdateReady() {
        const { animationManager: animationManager } = this.ctx;
        const { node: node } = $2fb96651e8aa1522$var$prepareLinearGaugeSeriesAnimationFunctions(false, this.horizontal);
        $2fb96651e8aa1522$var$fromToMotion2(this.id, "node", animationManager, [
            this.datumSelection
        ], node, (_sector, datum)=>datum.itemId);
        this.animateLabelText();
    }
    animateReadyResize() {
        this.resetAllAnimation();
    }
    getSeriesDomain() {
        return [
            0,
            1
        ];
    }
    getSeriesRange(_direction, _visibleRange) {
        return [
            NaN,
            NaN
        ];
    }
    getLegendData() {
        return [];
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, properties: properties } = this;
        const { tooltip: tooltip } = properties;
        let value;
        let text2;
        if (datumIndex.type === 0 /* Node */ ) {
            value = properties.value;
            text2 = properties.label.text;
        } else ({ value: value, text: text2 } = properties.targets[datumIndex.index]);
        if (value == null) return;
        return this.formatTooltipWithContext(tooltip, {
            data: [
                {
                    label: text2,
                    fallbackLabel: "Value",
                    value: this.formatLabel(value)
                }
            ]
        }, {
            seriesId: seriesId,
            title: void 0,
            datum: void 0,
            value: value
        });
    }
    pickNodeClosestDatum(point) {
        return $2fb96651e8aa1522$var$pickGaugeNearestDatum(this, point);
    }
    pickFocus(opts) {
        return $2fb96651e8aa1522$var$pickGaugeFocus(this, opts);
    }
    getCaptionText() {
        return this.formatLabel(this.properties.value);
    }
    getCategoryValue(_datumIndex) {
        return;
    }
    datumIndexForCategoryValue(_categoryValue) {
        return;
    }
};
$2fb96651e8aa1522$var$LinearGaugeSeries.className = "LinearGaugeSeries";
$2fb96651e8aa1522$var$LinearGaugeSeries.type = "linear-gauge";
// packages/ag-charts-enterprise/src/series/linear-gauge/linearGaugeModule.ts
var $2fb96651e8aa1522$var$LinearGaugeModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "gauge"
    ],
    identifier: "linear-gauge",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$LinearGaugeSeries(ctx),
    tooltipDefaults: {
        range: 10
    },
    themeTemplate: {
        minWidth: 200,
        minHeight: 200,
        tooltip: {
            enabled: false
        },
        series: {
            thickness: 50,
            defaultColorRange: {
                $if: [
                    {
                        $eq: [
                            {
                                $palette: "type"
                            },
                            "inbuilt"
                        ]
                    },
                    {
                        $interpolate: [
                            {
                                $palette: "secondDivergingColors"
                            },
                            5
                        ]
                    },
                    (0, $iTJTu._ModuleSupport).SAFE_RANGE2_OPERATION
                ]
            },
            scale: {
                // @ts-expect-error undocumented option
                defaultFill: {
                    $path: [
                        "./1",
                        {
                            $palette: "fill"
                        },
                        {
                            $palette: "hierarchyColors"
                        }
                    ]
                },
                // TODO: mix backgroundColor and foregroundColor?
                stroke: {
                    $path: [
                        "./2",
                        (0, $iTJTu._ModuleSupport).SAFE_STROKE_FILL_OPERATION,
                        {
                            $palette: "hierarchyColors"
                        }
                    ]
                },
                // TODO: mix backgroundColor and foregroundColor?
                label: {
                    spacing: 11
                }
            },
            bar: {
                strokeWidth: 0
            },
            segmentation: {
                enabled: false,
                interval: {},
                spacing: 1
            },
            defaultTarget: {
                fill: {
                    $ref: "foregroundColor"
                },
                stroke: {
                    $ref: "foregroundColor"
                },
                size: 10,
                shape: "triangle",
                placement: "after",
                spacing: 5,
                label: {
                    enabled: true,
                    fontWeight: {
                        $ref: "fontWeight"
                    },
                    fontSize: {
                        $ref: "fontSize"
                    },
                    fontFamily: {
                        $ref: "fontFamily"
                    },
                    color: {
                        $ref: "textColor"
                    },
                    spacing: 5
                }
            },
            defaultScale: {
                label: {
                    fontWeight: {
                        $ref: "fontWeight"
                    },
                    fontSize: {
                        $ref: "fontSize"
                    },
                    fontFamily: {
                        $ref: "fontFamily"
                    },
                    color: {
                        $ref: "textColor"
                    }
                }
            },
            label: {
                enabled: false,
                placement: "inside-start",
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontWeight: {
                    $ref: "fontWeight"
                },
                fontSize: {
                    $rem: [
                        2
                    ]
                },
                minimumFontSize: 12,
                spacing: 18,
                color: {
                    $ref: "backgroundColor"
                }
            },
            margin: 4
        }
    }
};
var $2fb96651e8aa1522$var$LinearGaugeSeriesModule = {
    type: "series",
    name: "linear-gauge",
    chartType: "gauge",
    enterprise: true,
    options: (0, $iTJTu._ModuleSupport).linearGaugeSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$LinearGaugeSeries(ctx)
};
// packages/ag-charts-enterprise/src/series/map-util/mapThemeDefaults.ts
var $2fb96651e8aa1522$var$MAP_THEME_DEFAULTS = {
    zoom: {
        axes: "xy",
        anchorPointX: "pointer",
        anchorPointY: "pointer",
        buttons: {
            // @ts-expect-error undocumented options
            anchorPointX: "middle",
            anchorPointY: "middle"
        }
    },
    legend: {
        enabled: false
    },
    gradientLegend: {
        enabled: false
    }
};
// packages/ag-charts-enterprise/src/series/map-util/lineStringUtil.ts
var $2fb96651e8aa1522$var$delta2 = 1e-9;
function $2fb96651e8aa1522$var$lineSegmentDistanceToPointSquared(a, b, x, y) {
    const [ax, ay] = a;
    const [bx, by] = b;
    const abx = bx - ax;
    const aby = by - ay;
    const l = abx * abx + aby * aby;
    let x0;
    let y0;
    if (Math.abs(l) < $2fb96651e8aa1522$var$delta2) {
        x0 = ax;
        y0 = ay;
    } else {
        let t = ((x - ax) * abx + (y - ay) * aby) / l;
        t = Math.max(0, Math.min(1, t));
        x0 = ax + t * (bx - ax);
        y0 = ay + t * (by - ay);
    }
    const dx2 = x - x0;
    const dy2 = y - y0;
    return dx2 * dx2 + dy2 * dy2;
}
function $2fb96651e8aa1522$var$lineStringDistance(lineString, x, y) {
    let minDistanceSquared = Infinity;
    let p0 = lineString[lineString.length - 1];
    for (const p1 of lineString){
        minDistanceSquared = Math.min(minDistanceSquared, $2fb96651e8aa1522$var$lineSegmentDistanceToPointSquared(p0, p1, x, y));
        p0 = p1;
    }
    return Math.sqrt(minDistanceSquared);
}
function $2fb96651e8aa1522$var$lineStringLength(lineSegment) {
    let [x0, y0] = lineSegment[0];
    let totalDistance = 0;
    for(let i = 1; i < lineSegment.length; i += 1){
        const [x1, y1] = lineSegment[i];
        const distance = Math.hypot(x1 - x0, y1 - y0);
        totalDistance += distance;
        x0 = x1;
        y0 = y1;
    }
    return totalDistance;
}
function $2fb96651e8aa1522$var$lineStringCenter(lineSegment) {
    if (lineSegment.length === 0) return;
    const targetDistance = $2fb96651e8aa1522$var$lineStringLength(lineSegment) / 2;
    let [x0, y0] = lineSegment[0];
    let totalDistance = 0;
    for(let i = 1; i < lineSegment.length; i += 1){
        const [x1, y1] = lineSegment[i];
        const segmentDistance = Math.hypot(x1 - x0, y1 - y0);
        const nextDistance = totalDistance + segmentDistance;
        if (nextDistance > targetDistance) {
            const ratio3 = (targetDistance - totalDistance) / segmentDistance;
            const point = [
                x0 + (x1 - x0) * ratio3,
                y0 + (y1 - y0) * ratio3
            ];
            const angle = Math.atan2(y1 - y0, x1 - x0);
            return {
                point: point,
                angle: angle
            };
        }
        totalDistance = nextDistance;
        x0 = x1;
        y0 = y1;
    }
}
var { LonLatBBox: $2fb96651e8aa1522$var$LonLatBBox } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$extendBbox(into, lon0, lat0, lon1, lat1) {
    if (into == null) into = new $2fb96651e8aa1522$var$LonLatBBox(lon0, lat0, lon1, lat1);
    else {
        into.lon0 = Math.min(into.lon0, lon0);
        into.lat0 = Math.min(into.lat0, lat0);
        into.lon1 = Math.max(into.lon1, lon1);
        into.lat1 = Math.max(into.lat1, lat1);
    }
    return into;
}
// packages/ag-charts-enterprise/src/series/map-util/polygonUtil.ts
function $2fb96651e8aa1522$var$polygonBbox(polygon, into) {
    polygon.forEach((coordinates)=>{
        const [lon, lat] = coordinates;
        into = $2fb96651e8aa1522$var$extendBbox(into, lon, lat, lon, lat);
    });
    return into;
}
function $2fb96651e8aa1522$var$polygonCentroid(polygon) {
    if (polygon.length === 0) return;
    let x = 0;
    let y = 0;
    let k = 0;
    let [x0, y0] = polygon[polygon.length - 1];
    for (const [x1, y1] of polygon){
        const c = x0 * y1 - x1 * y0;
        k += c;
        x += (x0 + x1) * c;
        y += (y0 + y1) * c;
        x0 = x1;
        y0 = y1;
    }
    k *= 3;
    return [
        x / k,
        y / k
    ];
}
function $2fb96651e8aa1522$var$polygonDistance(polygons, x, y) {
    let inside = false;
    let minDistanceSquared = Infinity;
    for (const polygon of polygons){
        let p0 = polygon[polygon.length - 1];
        let [x0, y0] = p0;
        for (const p1 of polygon){
            const [x1, y1] = p1;
            if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
            minDistanceSquared = Math.min(minDistanceSquared, $2fb96651e8aa1522$var$lineSegmentDistanceToPointSquared(p0, p1, x, y));
            p0 = p1;
            x0 = x1;
            y0 = y1;
        }
    }
    return (inside ? -1 : 1) * Math.sqrt(minDistanceSquared);
}
// packages/ag-charts-enterprise/src/series/map-util/geoGeometry.ts
var { Path: $2fb96651e8aa1522$var$Path10, ExtendedPath2D: $2fb96651e8aa1522$var$ExtendedPath2D4, BBox: $2fb96651e8aa1522$var$BBox18, SceneChangeDetection: $2fb96651e8aa1522$var$SceneChangeDetection8, SceneObjectChangeDetection: $2fb96651e8aa1522$var$SceneObjectChangeDetection, objectsEqual: $2fb96651e8aa1522$var$objectsEqual } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$GeoGeometry = class extends $2fb96651e8aa1522$var$Path10 {
    constructor(){
        super(...arguments);
        this.projectedGeometry = void 0;
        this.renderMode = 3 /* All */ ;
        // Keep non-filled shapes separate so we don't fill them
        this.strokePath = new $2fb96651e8aa1522$var$ExtendedPath2D4();
    }
    computeBBox() {
        if (this.dirtyPath || this.isDirtyPath()) {
            this.updatePath();
            this.dirtyPath = false;
        }
        return this.bbox?.clone();
    }
    updatePath() {
        const { projectedGeometry: projectedGeometry } = this;
        this.strokePath.clear();
        this.path.clear();
        this.bbox = projectedGeometry != null ? this.drawGeometry(projectedGeometry, void 0) : void 0;
    }
    drawPath(ctx) {
        super.drawPath(ctx);
        this.renderStroke(ctx, this.strokePath.getPath2D());
    }
    containsPoint(x, y) {
        const { projectedGeometry: projectedGeometry } = this;
        if (projectedGeometry == null) return false;
        if (!this.getBBox().containsPoint(x, y)) return false;
        return this.geometryDistance(projectedGeometry, x, y) <= 0;
    }
    distanceSquared(x, y) {
        const { projectedGeometry: projectedGeometry } = this;
        if (projectedGeometry == null) return Infinity;
        const distance = this.geometryDistance(projectedGeometry, x, y);
        return distance > 0 ? distance * distance : 0;
    }
    geometryDistance(geometry, x, y) {
        const { renderMode: renderMode, strokeWidth: strokeWidth } = this;
        const drawPolygons = (renderMode & 1 /* Polygons */ ) !== 0;
        const drawLines = (renderMode & 2 /* Lines */ ) !== 0;
        const minStrokeDistance = Math.max(strokeWidth / 2, 1) + 1;
        switch(geometry.type){
            case "GeometryCollection":
                return geometry.geometries.reduce((minDistance, g)=>Math.min(minDistance, this.geometryDistance(g, x, y)), Infinity);
            case "MultiPolygon":
                return drawPolygons ? geometry.coordinates.reduce((minDistance, polygon)=>Math.min(minDistance, Math.max($2fb96651e8aa1522$var$polygonDistance(polygon, x, y), 0)), Infinity) : Infinity;
            case "Polygon":
                return drawPolygons ? Math.max($2fb96651e8aa1522$var$polygonDistance(geometry.coordinates, x, y), 0) : Infinity;
            case "MultiLineString":
                return drawLines ? geometry.coordinates.reduce((minDistance, lineString)=>{
                    return Math.min(minDistance, Math.max($2fb96651e8aa1522$var$lineStringDistance(lineString, x, y) - minStrokeDistance, 0));
                }, Infinity) : Infinity;
            case "LineString":
                return drawLines ? Math.max($2fb96651e8aa1522$var$lineStringDistance(geometry.coordinates, x, y) - minStrokeDistance, 0) : Infinity;
            case "MultiPoint":
            case "Point":
            default:
                return Infinity;
        }
    }
    drawGeometry(geometry, bbox) {
        const { renderMode: renderMode, path: path, strokePath: strokePath } = this;
        const drawPolygons = (renderMode & 1 /* Polygons */ ) !== 0;
        const drawLines = (renderMode & 2 /* Lines */ ) !== 0;
        switch(geometry.type){
            case "GeometryCollection":
                geometry.geometries.forEach((g)=>{
                    bbox = this.drawGeometry(g, bbox);
                });
                break;
            case "MultiPolygon":
                if (drawPolygons) geometry.coordinates.forEach((coordinates)=>{
                    bbox = this.drawPolygon(path, coordinates, bbox);
                });
                break;
            case "Polygon":
                if (drawPolygons) bbox = this.drawPolygon(path, geometry.coordinates, bbox);
                break;
            case "LineString":
                if (drawLines) bbox = this.drawLineString(strokePath, geometry.coordinates, bbox, false);
                break;
            case "MultiLineString":
                if (drawLines) geometry.coordinates.forEach((coordinates)=>{
                    bbox = this.drawLineString(strokePath, coordinates, bbox, false);
                });
                break;
            case "Point":
            case "MultiPoint":
                break;
        }
        return bbox;
    }
    drawPolygon(path, polygons, bbox) {
        if (polygons.length < 1) return bbox;
        bbox = this.drawLineString(path, polygons[0], bbox, true);
        for(let i = 1; i < polygons.length; i += 1){
            const enclave = polygons[i];
            this.drawLineString(path, enclave, void 0, true);
        }
        return bbox;
    }
    drawLineString(path, coordinates, bbox, isClosed) {
        if (coordinates.length < 2) return bbox;
        const end = isClosed ? coordinates.length - 1 : coordinates.length;
        for(let i = 0; i < end; i += 1){
            const [x, y] = coordinates[i];
            if (i === 0) path.moveTo(x, y);
            else path.lineTo(x, y);
            if (bbox == null) bbox = new $2fb96651e8aa1522$var$BBox18(x, y, 0, 0);
            else {
                const { x: x0, y: y0 } = bbox;
                const x1 = x0 + bbox.width;
                const y1 = y0 + bbox.height;
                bbox.x = Math.min(x0, x);
                bbox.y = Math.min(y0, y);
                bbox.width = Math.max(x1, x) - bbox.x;
                bbox.height = Math.max(y1, y) - bbox.y;
            }
        }
        if (isClosed) path.closePath();
        return bbox;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneObjectChangeDetection({
        equals: $2fb96651e8aa1522$var$objectsEqual
    })
], $2fb96651e8aa1522$var$GeoGeometry.prototype, "projectedGeometry", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection8()
], $2fb96651e8aa1522$var$GeoGeometry.prototype, "renderMode", 2);
// packages/ag-charts-enterprise/src/series/map-util/geometryUtil.ts
function $2fb96651e8aa1522$var$geometryBbox(geometry, into) {
    if (geometry.bbox != null) {
        const [lon0, lat0, lon1, lat1] = geometry.bbox;
        into = $2fb96651e8aa1522$var$extendBbox(into, lon0, lat0, lon1, lat1);
        return into;
    }
    switch(geometry.type){
        case "GeometryCollection":
            geometry.geometries.forEach((g)=>{
                into = $2fb96651e8aa1522$var$geometryBbox(g, into);
            });
            break;
        case "MultiPolygon":
            geometry.coordinates.forEach((c)=>{
                if (c.length > 0) into = $2fb96651e8aa1522$var$polygonBbox(c[0], into);
            });
            break;
        case "Polygon":
            if (geometry.coordinates.length > 0) into = $2fb96651e8aa1522$var$polygonBbox(geometry.coordinates[0], into);
            break;
        case "MultiLineString":
            geometry.coordinates.forEach((c)=>{
                into = $2fb96651e8aa1522$var$polygonBbox(c, into);
            });
            break;
        case "LineString":
            into = $2fb96651e8aa1522$var$polygonBbox(geometry.coordinates, into);
            break;
        case "MultiPoint":
            geometry.coordinates.forEach((p)=>{
                const [lon, lat] = p;
                into = $2fb96651e8aa1522$var$extendBbox(into, lon, lat, lon, lat);
            });
            break;
        case "Point":
            {
                const [lon, lat] = geometry.coordinates;
                into = $2fb96651e8aa1522$var$extendBbox(into, lon, lat, lon, lat);
                break;
            }
    }
    return into;
}
function $2fb96651e8aa1522$var$largestPolygon(geometry) {
    switch(geometry.type){
        case "GeometryCollection":
            {
                let maxArea;
                let maxPolygon;
                geometry.geometries.forEach((g)=>{
                    const polygon = $2fb96651e8aa1522$var$largestPolygon(g);
                    if (polygon == null) return;
                    const bbox = $2fb96651e8aa1522$var$polygonBbox(polygon[0], void 0);
                    if (bbox == null) return;
                    const area = Math.abs(bbox.lat1 - bbox.lat0) * Math.abs(bbox.lon1 - bbox.lon0);
                    if (maxArea == null || area > maxArea) {
                        maxArea = area;
                        maxPolygon = polygon;
                    }
                });
                return maxPolygon;
            }
        case "MultiPolygon":
            {
                let maxArea;
                let maxPolygon;
                geometry.coordinates.forEach((polygon)=>{
                    const bbox = $2fb96651e8aa1522$var$polygonBbox(polygon[0], void 0);
                    if (bbox == null) return;
                    const area = Math.abs(bbox.lat1 - bbox.lat0) * Math.abs(bbox.lon1 - bbox.lon0);
                    if (maxArea == null || area > maxArea) {
                        maxArea = area;
                        maxPolygon = polygon;
                    }
                });
                return maxPolygon;
            }
        case "Polygon":
            return geometry.coordinates;
        case "MultiLineString":
        case "LineString":
        case "MultiPoint":
        case "Point":
            return;
    }
}
function $2fb96651e8aa1522$var$largestLineString(geometry) {
    switch(geometry.type){
        case "GeometryCollection":
            {
                let maxLength;
                let maxLineString;
                geometry.geometries.forEach((g)=>{
                    const lineString = $2fb96651e8aa1522$var$largestLineString(g);
                    if (lineString == null) return;
                    const length = $2fb96651e8aa1522$var$lineStringLength(lineString);
                    if (length == null) return;
                    if (maxLength == null || length > maxLength) {
                        maxLength = length;
                        maxLineString = lineString;
                    }
                });
                return maxLineString;
            }
        case "MultiLineString":
            {
                let maxLength = 0;
                let maxLineString;
                geometry.coordinates.forEach((lineString)=>{
                    const length = $2fb96651e8aa1522$var$lineStringLength(lineString);
                    if (length > maxLength) {
                        maxLength = length;
                        maxLineString = lineString;
                    }
                });
                return maxLineString;
            }
        case "LineString":
            return geometry.coordinates;
        case "MultiPolygon":
        case "Polygon":
        case "MultiPoint":
        case "Point":
            return;
    }
}
function $2fb96651e8aa1522$var$containsType(geometry, type) {
    if (geometry == null) return false;
    switch(geometry.type){
        case "GeometryCollection":
            return geometry.geometries.some((g)=>$2fb96651e8aa1522$var$containsType(g, type));
        case "MultiPolygon":
        case "Polygon":
            return (type & 1 /* Polygon */ ) !== 0;
        case "MultiLineString":
        case "LineString":
            return (type & 2 /* LineString */ ) !== 0;
        case "MultiPoint":
        case "Point":
            return (type & 4 /* Point */ ) !== 0;
    }
}
function $2fb96651e8aa1522$var$projectGeometry(geometry, scale) {
    switch(geometry.type){
        case "GeometryCollection":
            return {
                type: "GeometryCollection",
                geometries: geometry.geometries.map((g)=>$2fb96651e8aa1522$var$projectGeometry(g, scale))
            };
        case "Polygon":
            return {
                type: "Polygon",
                coordinates: $2fb96651e8aa1522$var$projectPolygon(geometry.coordinates, scale)
            };
        case "MultiPolygon":
            return {
                type: "MultiPolygon",
                coordinates: $2fb96651e8aa1522$var$projectMultiPolygon(geometry.coordinates, scale)
            };
        case "MultiLineString":
            return {
                type: "MultiLineString",
                coordinates: $2fb96651e8aa1522$var$projectPolygon(geometry.coordinates, scale)
            };
        case "LineString":
            return {
                type: "LineString",
                coordinates: $2fb96651e8aa1522$var$projectLineString(geometry.coordinates, scale)
            };
        case "MultiPoint":
            return {
                type: "MultiPoint",
                coordinates: $2fb96651e8aa1522$var$projectLineString(geometry.coordinates, scale)
            };
        case "Point":
            return {
                type: "Point",
                coordinates: scale.convert(geometry.coordinates)
            };
    }
}
function $2fb96651e8aa1522$var$projectMultiPolygon(multiPolygon, scale) {
    return multiPolygon.map((polygon)=>$2fb96651e8aa1522$var$projectPolygon(polygon, scale));
}
function $2fb96651e8aa1522$var$projectPolygon(polygon, scale) {
    return polygon.map((lineString)=>$2fb96651e8aa1522$var$projectLineString(lineString, scale));
}
function $2fb96651e8aa1522$var$projectLineString(lineString, scale) {
    return lineString.map((lonLat)=>scale.convert(lonLat));
}
// packages/ag-charts-enterprise/src/series/map-util/mapUtil.ts
function $2fb96651e8aa1522$var$prepareMapMarkerAnimationFunctions() {
    const fromFn = (marker, _datum, status)=>{
        if (status === "removed") return {
            scalingX: 1,
            scalingY: 1
        };
        else if (marker.previousDatum == null) return {
            scalingX: 0,
            scalingY: 0
        };
        return {
            scalingX: marker.scalingX,
            scalingY: marker.scalingY
        };
    };
    const toFn = (_marker, _datum, status)=>{
        if (status === "removed") return {
            scalingX: 0,
            scalingY: 0
        };
        return {
            scalingX: 1,
            scalingY: 1
        };
    };
    return {
        fromFn: fromFn,
        toFn: toFn
    };
}
function $2fb96651e8aa1522$var$findFocusedGeoGeometry(series, opts) {
    const datum = series.contextNodeData?.nodeData[opts.datumIndex];
    if (datum === void 0) return void 0;
    for (const node of series.datumSelection.nodes()){
        if (node.datum === datum) return node;
    }
    return void 0;
}
var $2fb96651e8aa1522$var$TopologySeriesProperties = class extends (0, $iTJTu._ModuleSupport).SeriesProperties {
};
var $2fb96651e8aa1522$var$TopologySeries = class extends (0, $iTJTu._ModuleSupport).DataModelSeries {
    addChartEventListeners() {
        this.destroyFns.push(this.ctx.chartEventManager.addListener("legend-item-click", (event)=>{
            this.onLegendItemClick(event);
        }), this.ctx.chartEventManager.addListener("legend-item-double-click", (event)=>{
            this.onLegendItemDoubleClick(event);
        }));
    }
    getSeriesDomain() {
        return [
            NaN,
            NaN
        ];
    }
    getSeriesRange(_direction, _visibleRange) {
        return [
            NaN,
            NaN
        ];
    }
};
var { Property: $2fb96651e8aa1522$var$Property70, SeriesProperties: $2fb96651e8aa1522$var$SeriesProperties3, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip12, Label: $2fb96651e8aa1522$var$Label10 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$MapLineSeriesProperties = class extends $2fb96651e8aa1522$var$SeriesProperties3 {
    constructor(){
        super(...arguments);
        this.topology = void 0;
        this.idKey = "";
        this.topologyIdKey = "name";
        this.idName = void 0;
        this.labelKey = void 0;
        this.labelName = void 0;
        this.colorRange = void 0;
        this.maxStrokeWidth = void 0;
        this.stroke = "black";
        this.strokeOpacity = 1;
        this.strokeWidth = 0;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.label = new $2fb96651e8aa1522$var$Label10();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip12();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "topology", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "title", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "legendItemName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "idKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "topologyIdKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "idName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "labelKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "labelName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "sizeKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "sizeName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "colorKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "colorName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "sizeDomain", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "colorRange", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "maxStrokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "itemStyler", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property70
], $2fb96651e8aa1522$var$MapLineSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-enterprise/src/series/map-line/mapLineSeries.ts
var { getMissCount: $2fb96651e8aa1522$var$getMissCount2, createDatumId: $2fb96651e8aa1522$var$createDatumId13, SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode9, valueProperty: $2fb96651e8aa1522$var$valueProperty12, CachedTextMeasurerPool: $2fb96651e8aa1522$var$CachedTextMeasurerPool7, ColorScale: $2fb96651e8aa1522$var$ColorScale2, LinearScale: $2fb96651e8aa1522$var$LinearScale4, Selection: $2fb96651e8aa1522$var$Selection8, Text: $2fb96651e8aa1522$var$Text3, Transformable: $2fb96651e8aa1522$var$Transformable2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$MapLineSeries = class extends $2fb96651e8aa1522$var$TopologySeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            categoryKey: void 0,
            useLabelLayer: true,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode9.EXACT_SHAPE_MATCH,
                $2fb96651e8aa1522$var$SeriesNodePickMode9.NEAREST_NODE
            ],
            usesPlacedLabels: true
        });
        this.properties = new $2fb96651e8aa1522$var$MapLineSeriesProperties();
        this._chartTopology = void 0;
        this.colorScale = new $2fb96651e8aa1522$var$ColorScale2();
        this.sizeScale = new $2fb96651e8aa1522$var$LinearScale4();
        this.datumSelection = $2fb96651e8aa1522$var$Selection8.select(this.contentGroup, ()=>this.nodeFactory());
        this.labelSelection = $2fb96651e8aa1522$var$Selection8.select(this.labelGroup, $2fb96651e8aa1522$var$Text3);
        this.highlightDatumSelection = $2fb96651e8aa1522$var$Selection8.select(this.highlightNode, ()=>this.nodeFactory());
        this._previousDatumMidPoint = void 0;
    }
    getNodeData() {
        return this.contextNodeData?.nodeData;
    }
    get topology() {
        return this.properties.topology ?? this._chartTopology;
    }
    get hasData() {
        return super.hasData && this.topology != null;
    }
    renderToOffscreenCanvas() {
        return true;
    }
    setSeriesIndex(index) {
        if (!super.setSeriesIndex(index)) return false;
        this.contentGroup.zIndex = [
            1 /* ShapeLine */ ,
            index
        ];
        this.highlightGroup.zIndex = [
            2 /* ShapeLineHighlight */ ,
            index
        ];
        return true;
    }
    setChartTopology(topology) {
        this._chartTopology = topology;
        if (this.topology === topology) this.nodeDataRefresh = true;
    }
    isLabelEnabled() {
        return this.properties.labelKey != null && this.properties.label.enabled;
    }
    nodeFactory() {
        const geoGeometry = new $2fb96651e8aa1522$var$GeoGeometry();
        geoGeometry.renderMode = 2 /* Lines */ ;
        geoGeometry.lineJoin = "round";
        geoGeometry.lineCap = "round";
        return geoGeometry;
    }
    async processData(dataController) {
        if (this.data == null) return;
        const { data: data, topology: topology, sizeScale: sizeScale, colorScale: colorScale } = this;
        const { topologyIdKey: topologyIdKey, idKey: idKey, sizeKey: sizeKey, colorKey: colorKey, labelKey: labelKey, sizeDomain: sizeDomain, colorRange: colorRange } = this.properties;
        const featureById = /* @__PURE__ */ new Map();
        topology?.features.forEach((feature)=>{
            const property = feature.properties?.[topologyIdKey];
            if (property == null || !$2fb96651e8aa1522$var$containsType(feature.geometry, 2 /* LineString */ )) return;
            featureById.set(property, feature);
        });
        const sizeScaleType = this.sizeScale.type;
        const colorScaleType = this.colorScale.type;
        const mercatorScaleType = this.scale?.type;
        const { dataModel: dataModel, processedData: processedData } = await this.requestDataModel(dataController, data, {
            props: [
                $2fb96651e8aa1522$var$valueProperty12(idKey, mercatorScaleType, {
                    id: "idValue",
                    includeProperty: false
                }),
                $2fb96651e8aa1522$var$valueProperty12(idKey, mercatorScaleType, {
                    id: "featureValue",
                    includeProperty: false,
                    processor: ()=>(datum)=>featureById.get(datum)
                }),
                ...labelKey != null ? [
                    $2fb96651e8aa1522$var$valueProperty12(labelKey, "band", {
                        id: "labelValue"
                    })
                ] : [],
                ...sizeKey != null ? [
                    $2fb96651e8aa1522$var$valueProperty12(sizeKey, sizeScaleType, {
                        id: "sizeValue"
                    })
                ] : [],
                ...colorKey != null ? [
                    $2fb96651e8aa1522$var$valueProperty12(colorKey, colorScaleType, {
                        id: "colorValue"
                    })
                ] : []
            ]
        });
        const featureValues = dataModel.resolveColumnById(this, `featureValue`, processedData);
        this.topologyBounds = featureValues.reduce((current, feature)=>{
            const geometry = feature?.geometry;
            if (geometry == null) return current;
            return $2fb96651e8aa1522$var$geometryBbox(geometry, current);
        }, void 0);
        if (sizeKey != null) {
            const sizeIdx = dataModel.resolveProcessedDataIndexById(this, `sizeValue`);
            const processedSize = processedData.domain.values[sizeIdx] ?? [];
            sizeScale.domain = sizeDomain ?? processedSize;
        }
        if (colorRange != null && this.isColorScaleValid()) {
            const colorKeyIdx = dataModel.resolveProcessedDataIndexById(this, "colorValue");
            colorScale.domain = processedData.domain.values[colorKeyIdx];
            colorScale.range = colorRange;
            colorScale.update();
        }
        if (topology == null) (0, $idDdm.Logger).warnOnce(`no topology was provided for [MapLineSeries]; nothing will be rendered.`);
    }
    isColorScaleValid() {
        const { colorKey: colorKey } = this.properties;
        if (!colorKey) return false;
        const { dataModel: dataModel, processedData: processedData } = this;
        if (!dataModel || !processedData) return false;
        const colorIdx = dataModel.resolveProcessedDataIndexById(this, "colorValue");
        const dataCount = processedData.input.count;
        const missCount = $2fb96651e8aa1522$var$getMissCount2(this, processedData.defs.values[colorIdx].missing);
        const colorDataMissing = dataCount === 0 || dataCount === missCount;
        return !colorDataMissing;
    }
    getLabelDatum(datum, labelValue, projectedGeometry, font2) {
        if (labelValue == null || projectedGeometry == null) return;
        const lineString = $2fb96651e8aa1522$var$largestLineString(projectedGeometry);
        if (lineString == null) return;
        const { idKey: idKey, idName: idName, sizeKey: sizeKey, sizeName: sizeName, colorKey: colorKey, colorName: colorName, labelKey: labelKey, labelName: labelName, label: label } = this.properties;
        const labelText = this.getLabelText(label, {
            value: labelValue,
            datum: datum,
            idKey: idKey,
            idName: idName,
            sizeKey: sizeKey,
            sizeName: sizeName,
            colorKey: colorKey,
            colorName: colorName,
            labelKey: labelKey,
            labelName: labelName
        });
        if (labelText == null) return;
        const labelSize = $2fb96651e8aa1522$var$CachedTextMeasurerPool7.measureText(String(labelText), {
            font: font2
        });
        const labelCenter = $2fb96651e8aa1522$var$lineStringCenter(lineString);
        if (labelCenter == null) return;
        const [x, y] = labelCenter.point;
        const { width: width, height: height } = labelSize;
        return {
            point: {
                x: x,
                y: y,
                size: 0
            },
            label: {
                width: width,
                height: height,
                text: labelText
            },
            anchor: void 0,
            placement: void 0
        };
    }
    createNodeData() {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, sizeScale: sizeScale, properties: properties, scale: scale } = this;
        const { idKey: idKey, sizeKey: sizeKey, colorKey: colorKey, labelKey: labelKey, label: label } = properties;
        if (dataModel == null || processedData == null) return;
        const idValues = dataModel.resolveColumnById(this, `idValue`, processedData);
        const featureValues = dataModel.resolveColumnById(this, `featureValue`, processedData);
        const labelValues = labelKey != null ? dataModel.resolveColumnById(this, `labelValue`, processedData) : void 0;
        const sizeValues = sizeKey != null ? dataModel.resolveColumnById(this, `sizeValue`, processedData) : void 0;
        const colorValues = colorKey != null ? dataModel.resolveColumnById(this, `colorValue`, processedData) : void 0;
        const maxStrokeWidth = properties.maxStrokeWidth ?? properties.strokeWidth;
        sizeScale.range = [
            Math.min(properties.strokeWidth, maxStrokeWidth),
            maxStrokeWidth
        ];
        const font2 = label.getFont();
        const projectedGeometries = /* @__PURE__ */ new Map();
        processedData.dataSources.get(this.id)?.forEach((_datum, datumIndex)=>{
            const id = idValues[datumIndex];
            const geometry = featureValues[datumIndex]?.geometry ?? void 0;
            const projectedGeometry = geometry != null && scale != null ? $2fb96651e8aa1522$var$projectGeometry(geometry, scale) : void 0;
            if (id != null && projectedGeometry != null) projectedGeometries.set(id, projectedGeometry);
        });
        const nodeData = [];
        const labelData = [];
        const missingGeometries = [];
        const rawData = processedData.dataSources.get(this.id) ?? [];
        rawData.forEach((datum, datumIndex)=>{
            const idValue = idValues[datumIndex];
            const colorValue = colorValues?.[datumIndex];
            const sizeValue = sizeValues?.[datumIndex];
            const labelValue = labelValues?.[datumIndex];
            const projectedGeometry = projectedGeometries.get(idValue);
            if (projectedGeometry == null) missingGeometries.push(idValue);
            const labelDatum = this.getLabelDatum(datum, labelValue, projectedGeometry, font2);
            if (labelDatum != null) labelData.push(labelDatum);
            nodeData.push({
                series: this,
                itemId: idKey,
                datum: datum,
                datumIndex: datumIndex,
                idValue: idValue,
                labelValue: labelValue,
                colorValue: colorValue,
                sizeValue: sizeValue,
                projectedGeometry: projectedGeometry
            });
        });
        const missingGeometriesCap = 10;
        if (missingGeometries.length > missingGeometriesCap) {
            const excessItems = missingGeometries.length - missingGeometriesCap;
            missingGeometries.length = missingGeometriesCap;
            missingGeometries.push(`(+${excessItems} more)`);
        }
        if (missingGeometries.length > 0) (0, $idDdm.Logger).warnOnce(`some data items do not have matches in the provided topology`, missingGeometries);
        return {
            itemId: seriesId,
            nodeData: nodeData,
            labelData: labelData
        };
    }
    updateSelections() {
        if (this.nodeDataRefresh) {
            this.contextNodeData = this.createNodeData();
            this.nodeDataRefresh = false;
        }
    }
    update() {
        const { datumSelection: datumSelection, highlightDatumSelection: highlightDatumSelection } = this;
        this.updateSelections();
        this.contentGroup.visible = this.visible;
        this.contentGroup.opacity = this.getOpacity();
        let highlightedDatum = this.ctx.highlightManager?.getActiveHighlight();
        if (highlightedDatum != null && (highlightedDatum.series !== this || highlightedDatum.datum == null)) highlightedDatum = void 0;
        const nodeData = this.contextNodeData?.nodeData ?? [];
        this.datumSelection = this.updateDatumSelection({
            nodeData: nodeData,
            datumSelection: datumSelection
        });
        this.updateDatumNodes({
            datumSelection: datumSelection,
            isHighlight: false
        });
        this.highlightDatumSelection = this.updateDatumSelection({
            nodeData: highlightedDatum != null ? [
                highlightedDatum
            ] : [],
            datumSelection: highlightDatumSelection
        });
        this.updateDatumNodes({
            datumSelection: highlightDatumSelection,
            isHighlight: true
        });
    }
    updateDatumSelection(opts) {
        return opts.datumSelection.update(opts.nodeData, void 0, (datum)=>$2fb96651e8aa1522$var$createDatumId13(datum.idValue));
    }
    getItemBaseStyle(highlighted) {
        const { properties: properties } = this;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return {
            stroke: highlightStyle?.stroke ?? properties.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(properties.strokeWidth),
            strokeOpacity: highlightStyle?.strokeOpacity ?? properties.strokeOpacity,
            lineDash: highlightStyle?.lineDash ?? properties.lineDash,
            lineDashOffset: highlightStyle?.lineDashOffset ?? properties.lineDashOffset
        };
    }
    getItemStyleOverrides(datumId, datum, colorValue, sizeValue, format, highlighted) {
        const { id: seriesId, properties: properties, colorScale: colorScale, sizeScale: sizeScale } = this;
        const { colorRange: colorRange, itemStyler: itemStyler } = properties;
        let overrides;
        if (!highlighted && colorValue != null) {
            overrides ?? (overrides = {});
            overrides.stroke = this.isColorScaleValid() ? colorScale.convert(colorValue) : colorRange?.[0] ?? properties.stroke;
        }
        if (sizeValue != null) {
            overrides ?? (overrides = {});
            overrides.strokeWidth = sizeScale.convert(sizeValue, {
                clamp: true
            });
        }
        if (itemStyler != null) {
            const itemStyle = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId13(datumId, highlighted ? "highlight" : "node"), ()=>{
                return this.callWithContext(itemStyler, {
                    seriesId: seriesId,
                    datum: datum,
                    highlighted: highlighted,
                    ...format,
                    ...overrides
                });
            });
            overrides ?? (overrides = {});
            Object.assign(overrides, itemStyle);
        }
        return overrides;
    }
    updateDatumNodes(opts) {
        const { datumSelection: datumSelection, isHighlight: isHighlight } = opts;
        const format = this.getItemBaseStyle(isHighlight);
        datumSelection.each((geoGeometry, nodeDatum)=>{
            const { datum: datum, datumIndex: datumIndex, colorValue: colorValue, sizeValue: sizeValue, projectedGeometry: projectedGeometry } = nodeDatum;
            if (projectedGeometry == null) {
                geoGeometry.visible = false;
                geoGeometry.projectedGeometry = void 0;
                return;
            }
            const overrides = this.getItemStyleOverrides(String(datumIndex), datum, colorValue, sizeValue, format, isHighlight);
            geoGeometry.visible = true;
            geoGeometry.projectedGeometry = projectedGeometry;
            geoGeometry.stroke = overrides?.stroke ?? format.stroke;
            geoGeometry.strokeWidth = overrides?.strokeWidth ?? format.strokeWidth;
            geoGeometry.strokeOpacity = overrides?.strokeOpacity ?? format.strokeOpacity;
            geoGeometry.lineDash = overrides?.lineDash ?? format.lineDash;
            geoGeometry.lineDashOffset = overrides?.lineDashOffset ?? format.lineDashOffset;
        });
    }
    updatePlacedLabelData(labelData) {
        this.labelSelection = this.labelSelection.update(labelData, (text2)=>{
            text2.pointerEvents = (0, $iTJTu._ModuleSupport).PointerEvents.None;
        });
        this.updateLabelNodes({
            labelSelection: this.labelSelection
        });
    }
    updateLabelNodes(opts) {
        const { labelSelection: labelSelection } = opts;
        const { color: fill, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily } = this.properties.label;
        labelSelection.each((label, { x: x, y: y, width: width, height: height, text: text2 })=>{
            label.visible = true;
            label.x = x + width / 2;
            label.y = y + height / 2;
            label.text = text2;
            label.fill = fill;
            label.fontStyle = fontStyle;
            label.fontWeight = fontWeight;
            label.fontSize = fontSize;
            label.fontFamily = fontFamily;
            label.textAlign = "center";
            label.textBaseline = "middle";
        });
    }
    resetAnimation() {}
    getLabelData() {
        if (!this.isLabelEnabled()) return [];
        return this.contextNodeData?.labelData ?? [];
    }
    pickNodeClosestDatum({ x: x, y: y }) {
        let minDistanceSquared = Infinity;
        let minDatum;
        this.datumSelection.each((node, datum)=>{
            const distanceSquared = node.distanceSquared(x, y);
            if (distanceSquared < minDistanceSquared) {
                minDistanceSquared = distanceSquared;
                minDatum = datum;
            }
        });
        return minDatum != null ? {
            datum: minDatum,
            distance: Math.sqrt(minDistanceSquared)
        } : void 0;
    }
    datumMidPoint(datum) {
        const { _previousDatumMidPoint: _previousDatumMidPoint } = this;
        if (_previousDatumMidPoint?.datum === datum) return _previousDatumMidPoint.point;
        const projectedGeometry = datum.projectedGeometry;
        const lineString = projectedGeometry != null ? $2fb96651e8aa1522$var$largestLineString(projectedGeometry) : void 0;
        const center = lineString != null ? $2fb96651e8aa1522$var$lineStringCenter(lineString)?.point : void 0;
        const point = center != null ? {
            x: center[0],
            y: center[1]
        } : void 0;
        this._previousDatumMidPoint = {
            datum: datum,
            point: point
        };
        return point;
    }
    legendItemSymbol(datumIndex) {
        const { dataModel: dataModel, processedData: processedData, properties: properties } = this;
        const { strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash } = properties;
        let { stroke: stroke2 } = properties;
        if (datumIndex != null && this.isColorScaleValid()) {
            const colorValues = dataModel.resolveColumnById(this, "colorValue", processedData);
            const colorValue = colorValues[datumIndex];
            stroke2 = this.colorScale.convert(colorValue);
        }
        return {
            marker: {
                fill: void 0,
                fillOpacity: 0,
                stroke: void 0,
                strokeWidth: 0,
                strokeOpacity: 0,
                lineDash: [
                    0
                ],
                lineDashOffset: 0,
                enabled: false
            },
            line: {
                stroke: stroke2,
                strokeWidth: strokeWidth,
                strokeOpacity: strokeOpacity,
                lineDash: lineDash
            }
        };
    }
    getLegendData(legendType) {
        const { processedData: processedData, dataModel: dataModel } = this;
        if (processedData == null || dataModel == null) return [];
        const { id: seriesId, visible: visible } = this;
        const { title: title, legendItemName: legendItemName, idKey: idKey, idName: idName, colorKey: colorKey, colorName: colorName, colorRange: colorRange, showInLegend: showInLegend } = this.properties;
        if (legendType === "gradient" && colorKey != null && colorRange != null) {
            const colorDomain = processedData.domain.values[dataModel.resolveProcessedDataIndexById(this, "colorValue")];
            const legendDatum = {
                legendType: "gradient",
                enabled: visible,
                seriesId: seriesId,
                colorName: colorName,
                colorRange: colorRange,
                colorDomain: colorDomain
            };
            return [
                legendDatum
            ];
        } else if (legendType === "category") {
            const legendDatum = {
                legendType: "category",
                id: seriesId,
                itemId: seriesId,
                seriesId: seriesId,
                enabled: visible,
                label: {
                    text: legendItemName ?? title ?? idName ?? idKey
                },
                symbol: this.legendItemSymbol(),
                legendItemName: legendItemName,
                hideInLegend: !showInLegend
            };
            return [
                legendDatum
            ];
        } else return [];
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, properties: properties } = this;
        const { idKey: idKey, idName: idName, colorKey: colorKey, colorName: colorName, sizeKey: sizeKey, sizeName: sizeName, labelKey: labelKey, labelName: labelName, title: title, legendItemName: legendItemName, tooltip: tooltip } = properties;
        if (!dataModel || !processedData) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const idValues = dataModel.resolveColumnById(this, `idValue`, processedData);
        const data = [];
        const sizeValue = sizeKey != null ? dataModel.resolveColumnById(this, `sizeValue`, processedData)[datumIndex] : void 0;
        const colorValue = colorKey != null ? dataModel.resolveColumnById(this, `colorValue`, processedData)[datumIndex] : void 0;
        if (sizeKey != null) data.push({
            label: sizeName,
            fallbackLabel: sizeKey,
            value: String(sizeValue)
        });
        if (colorKey != null) data.push({
            label: colorName,
            fallbackLabel: colorKey,
            value: String(colorValue)
        });
        if (labelKey != null && labelKey !== idKey) {
            const labelValue = dataModel.resolveColumnById(this, `labelValue`, processedData)[datumIndex];
            data.push({
                label: labelName,
                fallbackLabel: labelKey,
                value: labelValue
            });
        }
        const format = this.getItemBaseStyle(false);
        Object.assign(format, this.getItemStyleOverrides(String(datumIndex), datumIndex, colorValue, sizeValue, format, false));
        return this.formatTooltipWithContext(tooltip, {
            heading: idValues[datumIndex],
            title: title ?? legendItemName,
            symbol: this.legendItemSymbol(datumIndex),
            data: data
        }, {
            seriesId: seriesId,
            datum: datum,
            title: title,
            idKey: idKey,
            idName: idName,
            colorKey: colorKey,
            colorName: colorName,
            sizeKey: sizeKey,
            sizeName: sizeName,
            labelKey: labelKey,
            labelName: labelName,
            ...format
        });
    }
    computeFocusBounds(opts) {
        const geometry = $2fb96651e8aa1522$var$findFocusedGeoGeometry(this, opts);
        return geometry ? $2fb96651e8aa1522$var$Transformable2.toCanvas(this.contentGroup, geometry.getBBox()) : void 0;
    }
};
$2fb96651e8aa1522$var$MapLineSeries.className = "MapLineSeries";
$2fb96651e8aa1522$var$MapLineSeries.type = "map-line";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs11, mapLineSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$mapLineSeriesThemeableOptionsDef, without: $2fb96651e8aa1522$var$without2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$mapLineSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$mapLineSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$without2($2fb96651e8aa1522$var$commonSeriesOptionsDefs11, [
        "highlightStyle"
    ]),
    type: (0, $idDdm.required)((0, $idDdm.constant)("map-line")),
    idKey: (0, $idDdm.required)((0, $idDdm.string)),
    sizeKey: (0, $idDdm.string),
    colorKey: (0, $idDdm.string),
    labelKey: (0, $idDdm.string),
    idName: (0, $idDdm.string),
    sizeName: (0, $idDdm.string),
    colorName: (0, $idDdm.string),
    labelName: (0, $idDdm.string),
    topology: (0, $idDdm.geoJson),
    topologyIdKey: (0, $idDdm.string),
    legendItemName: (0, $idDdm.string),
    title: (0, $idDdm.string)
};
$2fb96651e8aa1522$var$mapLineSeriesOptionsDef.colorRange = (0, $idDdm.undocumented)((0, $idDdm.and)((0, $idDdm.arrayOf)((0, $idDdm.color)), (0, $idDdm.arrayLength)(1)));
// packages/ag-charts-enterprise/src/series/map-line/mapLineModule.ts
var $2fb96651e8aa1522$var$MapLineModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "topology"
    ],
    identifier: "map-line",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$MapLineSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    themeTemplate: {
        ...$2fb96651e8aa1522$var$MAP_THEME_DEFAULTS,
        series: {
            stroke: (0, $iTJTu._ModuleSupport).SAFE_STROKE_FILL_OPERATION,
            // @ts-expect-error undocumented option
            colorRange: {
                $if: [
                    {
                        $eq: [
                            {
                                $palette: "type"
                            },
                            "inbuilt"
                        ]
                    },
                    {
                        $palette: "divergingColors"
                    },
                    (0, $iTJTu._ModuleSupport).SAFE_RANGE2_OPERATION
                ]
            },
            strokeWidth: 1,
            maxStrokeWidth: 3,
            lineDash: [
                0
            ],
            lineDashOffset: 0,
            label: {
                enabled: true,
                fontSize: {
                    $ref: "fontSize"
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontWeight: {
                    $ref: "fontWeight"
                },
                color: {
                    $ref: "textColor"
                }
            }
        },
        tooltip: {
            range: "exact"
        }
    }
};
var $2fb96651e8aa1522$var$MapLineSeriesModule = {
    type: "series",
    name: "map-line",
    chartType: "topology",
    enterprise: true,
    options: $2fb96651e8aa1522$var$mapLineSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$MapLineSeries(ctx)
};
var { Property: $2fb96651e8aa1522$var$Property71, SeriesProperties: $2fb96651e8aa1522$var$SeriesProperties4, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip13 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$MapLineBackgroundSeriesProperties = class extends $2fb96651e8aa1522$var$SeriesProperties4 {
    constructor(){
        super(...arguments);
        this.topology = void 0;
        this.stroke = "black";
        this.strokeOpacity = 1;
        this.strokeWidth = 0;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip13();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property71
], $2fb96651e8aa1522$var$MapLineBackgroundSeriesProperties.prototype, "topology", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property71
], $2fb96651e8aa1522$var$MapLineBackgroundSeriesProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property71
], $2fb96651e8aa1522$var$MapLineBackgroundSeriesProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property71
], $2fb96651e8aa1522$var$MapLineBackgroundSeriesProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property71
], $2fb96651e8aa1522$var$MapLineBackgroundSeriesProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property71
], $2fb96651e8aa1522$var$MapLineBackgroundSeriesProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property71
], $2fb96651e8aa1522$var$MapLineBackgroundSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-enterprise/src/series/map-line-background/mapLineBackgroundSeries.ts
var { createDatumId: $2fb96651e8aa1522$var$createDatumId14, SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode10, Group: $2fb96651e8aa1522$var$Group13, Selection: $2fb96651e8aa1522$var$Selection9, PointerEvents: $2fb96651e8aa1522$var$PointerEvents6 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$MapLineBackgroundSeries = class extends $2fb96651e8aa1522$var$TopologySeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            categoryKey: void 0,
            useLabelLayer: true,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode10.EXACT_SHAPE_MATCH
            ]
        });
        this.properties = new $2fb96651e8aa1522$var$MapLineBackgroundSeriesProperties();
        this._chartTopology = void 0;
        this.itemGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group13({
            name: "itemGroup"
        }));
        this.datumSelection = $2fb96651e8aa1522$var$Selection9.select(this.itemGroup, ()=>this.nodeFactory());
    }
    getNodeData() {
        return this.contextNodeData?.nodeData;
    }
    get topology() {
        return this.properties.topology ?? this._chartTopology;
    }
    get focusable() {
        return false;
    }
    setOptionsData() {}
    setChartData() {}
    get hasData() {
        return false;
    }
    renderToOffscreenCanvas() {
        return true;
    }
    setChartTopology(topology) {
        this._chartTopology = topology;
        if (this.topology === topology) this.nodeDataRefresh = true;
    }
    setSeriesIndex(index) {
        if (!super.setSeriesIndex(index)) return false;
        this.contentGroup.zIndex = [
            0 /* ShapeLineBackground */ ,
            index,
            0
        ];
        this.highlightGroup.zIndex = [
            0 /* ShapeLineBackground */ ,
            index,
            1
        ];
        return true;
    }
    nodeFactory() {
        const geoGeometry = new $2fb96651e8aa1522$var$GeoGeometry();
        geoGeometry.renderMode = 2 /* Lines */ ;
        geoGeometry.lineJoin = "round";
        geoGeometry.lineCap = "round";
        geoGeometry.pointerEvents = $2fb96651e8aa1522$var$PointerEvents6.None;
        return geoGeometry;
    }
    processData() {
        const { topology: topology } = this;
        this.topologyBounds = topology?.features.reduce((current, feature)=>{
            const geometry = feature.geometry;
            if (geometry == null) return current;
            return $2fb96651e8aa1522$var$geometryBbox(geometry, current);
        }, void 0);
        if (topology == null) (0, $idDdm.Logger).warnOnce(`no topology was provided for [MapShapeBackgroundSeries]; nothing will be rendered.`);
    }
    createNodeData() {
        const { id: seriesId, topology: topology, scale: scale } = this;
        if (topology == null) return;
        const nodeData = [];
        const labelData = [];
        topology.features.forEach((feature, index)=>{
            const { geometry: geometry } = feature;
            const projectedGeometry = geometry != null && scale != null ? $2fb96651e8aa1522$var$projectGeometry(geometry, scale) : void 0;
            if (projectedGeometry == null) return;
            nodeData.push({
                series: this,
                itemId: index,
                datum: feature,
                datumIndex: 0,
                index: index,
                projectedGeometry: projectedGeometry
            });
        });
        return {
            itemId: seriesId,
            nodeData: nodeData,
            labelData: labelData
        };
    }
    updateSelections() {
        if (this.nodeDataRefresh) {
            this.contextNodeData = this.createNodeData();
            this.nodeDataRefresh = false;
        }
    }
    update() {
        const { datumSelection: datumSelection } = this;
        this.updateSelections();
        this.contentGroup.visible = this.visible;
        const { nodeData: nodeData = [] } = this.contextNodeData ?? {};
        this.datumSelection = this.updateDatumSelection({
            nodeData: nodeData,
            datumSelection: datumSelection
        });
        this.updateDatumNodes({
            datumSelection: datumSelection
        });
    }
    updateDatumSelection(opts) {
        return opts.datumSelection.update(opts.nodeData, void 0, (datum)=>$2fb96651e8aa1522$var$createDatumId14(datum.index));
    }
    updateDatumNodes(opts) {
        const { properties: properties } = this;
        const { datumSelection: datumSelection } = opts;
        const { stroke: stroke2, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = properties;
        const strokeWidth = this.getStrokeWidth(properties.strokeWidth);
        datumSelection.each((geoGeometry, datum)=>{
            const { projectedGeometry: projectedGeometry } = datum;
            if (projectedGeometry == null) {
                geoGeometry.visible = false;
                geoGeometry.projectedGeometry = void 0;
                return;
            }
            geoGeometry.visible = true;
            geoGeometry.projectedGeometry = projectedGeometry;
            geoGeometry.stroke = stroke2;
            geoGeometry.strokeWidth = strokeWidth;
            geoGeometry.strokeOpacity = strokeOpacity;
            geoGeometry.lineDash = lineDash;
            geoGeometry.lineDashOffset = lineDashOffset;
        });
    }
    resetAnimation() {}
    getLegendData() {
        return [];
    }
    getTooltipContent(_seriesDatum) {
        return;
    }
    computeFocusBounds(_opts) {
        return void 0;
    }
};
$2fb96651e8aa1522$var$MapLineBackgroundSeries.className = "MapLineBackgroundSeries";
$2fb96651e8aa1522$var$MapLineBackgroundSeries.type = "map-line-background";
var { mapLineBackgroundSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$mapLineBackgroundSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$mapLineBackgroundSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$mapLineBackgroundSeriesThemeableOptionsDef,
    type: (0, $idDdm.required)((0, $idDdm.constant)("map-line-background")),
    topology: (0, $idDdm.geoJson)
};
// packages/ag-charts-enterprise/src/series/map-line-background/mapLineBackgroundModule.ts
var $2fb96651e8aa1522$var$MapLineBackgroundModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "topology"
    ],
    identifier: "map-line-background",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$MapLineBackgroundSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    themeTemplate: {
        ...$2fb96651e8aa1522$var$MAP_THEME_DEFAULTS,
        series: {
            stroke: {
                $path: [
                    "./1",
                    {
                        $palette: "stroke"
                    },
                    {
                        $palette: "secondHierarchyColors"
                    }
                ]
            },
            strokeWidth: 1,
            lineDash: [
                0
            ],
            lineDashOffset: 0
        }
    }
};
var $2fb96651e8aa1522$var$MapLineBackgroundSeriesModule = {
    type: "series",
    name: "map-line-background",
    chartType: "topology",
    enterprise: true,
    options: $2fb96651e8aa1522$var$mapLineBackgroundSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$MapLineBackgroundSeries(ctx)
};
// packages/ag-charts-enterprise/src/series/map-util/linkedList.ts
var $2fb96651e8aa1522$var$insertManySorted = (list, items, cmp)=>{
    let head = list;
    let current = head;
    for (const value of items)if (head == null || cmp(head.value, value) > 0) {
        head = {
            value: value,
            next: head
        };
        current = head;
    } else {
        current;
        while(current.next != null && cmp(current.next.value, value) <= 0)current = current.next;
        current.next = {
            value: value,
            next: current.next
        };
    }
    return head;
};
// packages/ag-charts-enterprise/src/series/map-util/polygonPointSearch.ts
function $2fb96651e8aa1522$var$polygonPointSearch(polygons, precision, valueFn) {
    const bbox = $2fb96651e8aa1522$var$polygonBbox(polygons[0], void 0);
    if (bbox == null) return;
    const boundingXCenter = (bbox.lon0 + bbox.lon1) / 2;
    const boundingYCenter = (bbox.lat0 + bbox.lat1) / 2;
    const boundingWidth = Math.abs(bbox.lon1 - bbox.lon0);
    const boundingHeight = Math.abs(bbox.lat1 - bbox.lat0);
    const centroid = $2fb96651e8aa1522$var$polygonCentroid(polygons[0]);
    const [cx, cy] = centroid;
    const centroidDistanceToPolygon = -$2fb96651e8aa1522$var$polygonDistance(polygons, cx, cy);
    let bestResult;
    const cellValue = (distanceToPolygon, distanceToCentroid)=>{
        const centroidDriftFactor = 0.5;
        const centroidDrift = Math.max(distanceToCentroid - centroidDistanceToPolygon, 0);
        return distanceToPolygon - centroidDriftFactor * centroidDrift;
    };
    const createLabelPlacement = (x2, y2, stride)=>{
        const { distance: distance2, maxDistance: maxDistance } = valueFn(polygons, x2, y2, stride);
        const distanceToCentroid = Math.hypot(cx - x2, cy - y2);
        const maxXTowardsCentroid = Math.min(Math.max(cx, x2 - stride / 2), x2 + stride / 2);
        const maxYTowardsCentroid = Math.min(Math.max(cy, y2 - stride / 2), y2 + stride / 2);
        const minDistanceToCentroid = Math.hypot(cx - maxXTowardsCentroid, cy - maxYTowardsCentroid);
        const value = cellValue(distance2, distanceToCentroid);
        const maxValue = cellValue(maxDistance, minDistanceToCentroid);
        return {
            distance: distance2,
            maxDistance: maxDistance,
            value: value,
            maxValue: maxValue,
            x: x2,
            y: y2,
            stride: stride
        };
    };
    const appendLabelPlacement = (into, x2, y2, stride)=>{
        const labelPlacement = createLabelPlacement(x2, y2, stride);
        if (labelPlacement.maxDistance >= 0) into.push(labelPlacement);
    };
    const initialStride = Math.min(boundingWidth, boundingHeight) / 2;
    let queue = {
        value: createLabelPlacement(boundingXCenter, boundingYCenter, initialStride),
        next: null
    };
    while(queue != null){
        const item = queue.value;
        const { distance: distance2, value: value, maxValue: maxValue, x: x2, y: y2, stride: stride } = item;
        queue = queue.next;
        if (distance2 > 0 && (bestResult == null || value > bestResult.value)) bestResult = item;
        if (bestResult != null && maxValue - bestResult.value <= precision) continue;
        const nextStride = stride / 2;
        const newLabelPlacements = [];
        appendLabelPlacement(newLabelPlacements, x2 - nextStride, y2 - nextStride, nextStride);
        appendLabelPlacement(newLabelPlacements, x2 + nextStride, y2 - nextStride, nextStride);
        appendLabelPlacement(newLabelPlacements, x2 - nextStride, y2 + nextStride, nextStride);
        appendLabelPlacement(newLabelPlacements, x2 + nextStride, y2 + nextStride, nextStride);
        newLabelPlacements.sort($2fb96651e8aa1522$var$labelPlacementCmp);
        queue = $2fb96651e8aa1522$var$insertManySorted(queue, newLabelPlacements, $2fb96651e8aa1522$var$labelPlacementCmp);
    }
    if (bestResult == null) return;
    const { distance: distance, x: x, y: y } = bestResult;
    return {
        x: x,
        y: y,
        distance: distance
    };
}
var $2fb96651e8aa1522$var$labelPlacementCmp = (a, b)=>b.maxValue - a.maxValue;
// packages/ag-charts-enterprise/src/series/map-util/markerUtil.ts
function $2fb96651e8aa1522$var$polygonMarkerCenter(polygons, precision) {
    const result = $2fb96651e8aa1522$var$polygonPointSearch(polygons, precision, (p, x2, y2, stride)=>{
        const distance = -$2fb96651e8aa1522$var$polygonDistance(p, x2, y2);
        const maxDistance = distance + stride * Math.SQRT2;
        return {
            distance: distance,
            maxDistance: maxDistance
        };
    });
    if (result == null) return;
    const { x: x, y: y } = result;
    return [
        x,
        y
    ];
}
function $2fb96651e8aa1522$var$markerPositions(geometry, precision) {
    let center;
    switch(geometry.type){
        case "GeometryCollection":
            return geometry.geometries.flatMap((g)=>$2fb96651e8aa1522$var$markerPositions(g, precision));
        case "MultiPoint":
            return geometry.coordinates;
        case "Point":
            return [
                geometry.coordinates
            ];
        case "MultiPolygon":
            {
                const polygon = $2fb96651e8aa1522$var$largestPolygon(geometry);
                center = polygon != null ? $2fb96651e8aa1522$var$polygonMarkerCenter(polygon, precision) : void 0;
                break;
            }
        case "Polygon":
            {
                const polygon = geometry.coordinates;
                center = polygon != null ? $2fb96651e8aa1522$var$polygonMarkerCenter(polygon, precision) : void 0;
                break;
            }
        case "MultiLineString":
            {
                const lineString = $2fb96651e8aa1522$var$largestLineString(geometry);
                center = lineString != null ? $2fb96651e8aa1522$var$lineStringCenter(lineString)?.point : void 0;
                break;
            }
        case "LineString":
            {
                const lineString = geometry.coordinates;
                center = $2fb96651e8aa1522$var$lineStringCenter(lineString)?.point;
                break;
            }
    }
    return center != null ? [
        center
    ] : [];
}
var { BBox: $2fb96651e8aa1522$var$BBox19 } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$getTopologyShapeFillBBox(scale) {
    if (!scale) return;
    const { range: range2 } = scale;
    const x = range2[0][0];
    const y = range2[0][1];
    const width = range2[1][0] - x;
    const height = range2[1][1] - y;
    const bbox = new $2fb96651e8aa1522$var$BBox19(x, y, width, height);
    return {
        series: bbox,
        axis: bbox
    };
}
var { FillGradientDefaults: $2fb96651e8aa1522$var$FillGradientDefaults9, FillPatternDefaults: $2fb96651e8aa1522$var$FillPatternDefaults9, FillImageDefaults: $2fb96651e8aa1522$var$FillImageDefaults9, Property: $2fb96651e8aa1522$var$Property72, SeriesProperties: $2fb96651e8aa1522$var$SeriesProperties5, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip14, Label: $2fb96651e8aa1522$var$Label11 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$MapMarkerSeriesLabel = class extends $2fb96651e8aa1522$var$Label11 {
    constructor(){
        super(...arguments);
        this.placement = "bottom";
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesLabel.prototype, "placement", 2);
var $2fb96651e8aa1522$var$MapMarkerSeriesProperties = class extends $2fb96651e8aa1522$var$SeriesProperties5 {
    constructor(){
        super(...arguments);
        this.topology = void 0;
        this.idKey = void 0;
        this.topologyIdKey = "name";
        this.idName = void 0;
        this.latitudeKey = void 0;
        this.latitudeName = void 0;
        this.longitudeKey = void 0;
        this.longitudeName = void 0;
        this.labelKey = void 0;
        this.labelName = void 0;
        this.colorRange = void 0;
        this.shape = "circle";
        this.size = 6;
        this.fill = "black";
        this.fillGradientDefaults = new $2fb96651e8aa1522$var$FillGradientDefaults9();
        this.fillPatternDefaults = new $2fb96651e8aa1522$var$FillPatternDefaults9();
        this.fillImageDefaults = new $2fb96651e8aa1522$var$FillImageDefaults9();
        this.fillOpacity = 1;
        this.stroke = "black";
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.label = new $2fb96651e8aa1522$var$MapMarkerSeriesLabel();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip14();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "topology", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "title", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "legendItemName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "idKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "topologyIdKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "idName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "latitudeKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "latitudeName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "longitudeKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "longitudeName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "labelKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "labelName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "sizeKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "sizeName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "colorKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "colorName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "colorRange", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "shape", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "size", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "maxSize", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "sizeDomain", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "fillGradientDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "fillPatternDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "fillImageDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "itemStyler", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property72
], $2fb96651e8aa1522$var$MapMarkerSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-enterprise/src/series/map-marker/mapMarkerSeries.ts
var { CachedTextMeasurerPool: $2fb96651e8aa1522$var$CachedTextMeasurerPool8, fromToMotion: $2fb96651e8aa1522$var$fromToMotion3, StateMachine: $2fb96651e8aa1522$var$StateMachine13, getMissCount: $2fb96651e8aa1522$var$getMissCount3, createDatumId: $2fb96651e8aa1522$var$createDatumId15, SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode11, valueProperty: $2fb96651e8aa1522$var$valueProperty13, computeMarkerFocusBounds: $2fb96651e8aa1522$var$computeMarkerFocusBounds2, ColorScale: $2fb96651e8aa1522$var$ColorScale3, LinearScale: $2fb96651e8aa1522$var$LinearScale5, Group: $2fb96651e8aa1522$var$Group14, Selection: $2fb96651e8aa1522$var$Selection10, Text: $2fb96651e8aa1522$var$Text4, Marker: $2fb96651e8aa1522$var$Marker3, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle9, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle10 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$MapMarkerSeries = class extends $2fb96651e8aa1522$var$TopologySeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            categoryKey: void 0,
            useLabelLayer: true,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode11.EXACT_SHAPE_MATCH,
                $2fb96651e8aa1522$var$SeriesNodePickMode11.NEAREST_NODE
            ],
            usesPlacedLabels: true
        });
        this.properties = new $2fb96651e8aa1522$var$MapMarkerSeriesProperties();
        this._chartTopology = void 0;
        this.colorScale = new $2fb96651e8aa1522$var$ColorScale3();
        this.sizeScale = new $2fb96651e8aa1522$var$LinearScale5();
        this.markerGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group14({
            name: "markerGroup"
        }));
        this.labelSelection = $2fb96651e8aa1522$var$Selection10.select(this.labelGroup, $2fb96651e8aa1522$var$Text4, false);
        this.markerSelection = $2fb96651e8aa1522$var$Selection10.select(this.markerGroup, $2fb96651e8aa1522$var$Marker3, false);
        this.highlightMarkerSelection = $2fb96651e8aa1522$var$Selection10.select(this.highlightNode, $2fb96651e8aa1522$var$Marker3);
        this.animationState = new $2fb96651e8aa1522$var$StateMachine13("empty", {
            empty: {
                update: {
                    target: "ready",
                    action: ()=>this.animateMarkers()
                },
                reset: "empty",
                skip: "ready"
            },
            ready: {
                updateData: "waiting",
                clear: "clearing",
                resize: ()=>this.resetAllAnimation(),
                reset: "empty",
                skip: "ready"
            },
            waiting: {
                update: {
                    target: "ready",
                    action: ()=>this.animateMarkers()
                },
                // chart.ts transitions to updateData on zoom change
                resize: {
                    target: "ready",
                    action: ()=>this.resetAllAnimation()
                },
                reset: "empty",
                skip: "ready"
            },
            clearing: {
                update: {
                    target: "empty",
                    action: ()=>this.resetAllAnimation()
                },
                reset: "empty",
                skip: "ready"
            }
        }, ()=>this.checkProcessedDataAnimatable());
    }
    getNodeData() {
        return this.contextNodeData?.nodeData;
    }
    get topology() {
        return this.properties.topology ?? this._chartTopology;
    }
    get hasData() {
        const hasLatLon = this.properties.latitudeKey != null && this.properties.longitudeKey != null;
        return super.hasData && (this.topology != null || hasLatLon);
    }
    renderToOffscreenCanvas() {
        return true;
    }
    setChartTopology(topology) {
        this._chartTopology = topology;
        if (this.topology === topology) this.nodeDataRefresh = true;
    }
    setSeriesIndex(index) {
        if (!super.setSeriesIndex(index)) return false;
        this.contentGroup.zIndex = [
            3 /* Marker */ ,
            index
        ];
        this.highlightGroup.zIndex = [
            4 /* MarkerHighlight */ ,
            index
        ];
        return true;
    }
    isLabelEnabled() {
        return this.properties.labelKey != null && this.properties.label.enabled;
    }
    async processData(dataController) {
        if (this.data == null) return;
        const { data: data, topology: topology, sizeScale: sizeScale, colorScale: colorScale } = this;
        const { topologyIdKey: topologyIdKey, idKey: idKey, latitudeKey: latitudeKey, longitudeKey: longitudeKey, sizeKey: sizeKey, colorKey: colorKey, labelKey: labelKey, sizeDomain: sizeDomain, colorRange: colorRange } = this.properties;
        const featureById = /* @__PURE__ */ new Map();
        topology?.features.forEach((feature)=>{
            const property = feature.properties?.[topologyIdKey];
            if (property == null) return;
            featureById.set(property, feature);
        });
        const sizeScaleType = this.sizeScale.type;
        const colorScaleType = this.colorScale.type;
        const mercatorScaleType = this.scale?.type;
        const hasLatLon = latitudeKey != null && longitudeKey != null;
        const { dataModel: dataModel, processedData: processedData } = await this.requestDataModel(dataController, data, {
            props: [
                ...idKey != null ? [
                    $2fb96651e8aa1522$var$valueProperty13(idKey, mercatorScaleType, {
                        id: "idValue",
                        includeProperty: false
                    }),
                    $2fb96651e8aa1522$var$valueProperty13(idKey, mercatorScaleType, {
                        id: "featureValue",
                        includeProperty: false,
                        processor: ()=>(datum)=>featureById.get(datum)
                    })
                ] : [],
                ...hasLatLon ? [
                    $2fb96651e8aa1522$var$valueProperty13(latitudeKey, mercatorScaleType, {
                        id: "latValue"
                    }),
                    $2fb96651e8aa1522$var$valueProperty13(longitudeKey, mercatorScaleType, {
                        id: "lonValue"
                    })
                ] : [],
                ...labelKey ? [
                    $2fb96651e8aa1522$var$valueProperty13(labelKey, "band", {
                        id: "labelValue"
                    })
                ] : [],
                ...sizeKey ? [
                    $2fb96651e8aa1522$var$valueProperty13(sizeKey, sizeScaleType, {
                        id: "sizeValue"
                    })
                ] : [],
                ...colorKey ? [
                    $2fb96651e8aa1522$var$valueProperty13(colorKey, colorScaleType, {
                        id: "colorValue"
                    })
                ] : []
            ]
        });
        const featureValues = idKey != null ? dataModel.resolveColumnById(this, `featureValue`, processedData) : void 0;
        const latValues = hasLatLon ? dataModel.resolveColumnById(this, `latValue`, processedData) : void 0;
        const lonValues = hasLatLon ? dataModel.resolveColumnById(this, `lonValue`, processedData) : void 0;
        this.topologyBounds = processedData.dataSources.get(this.id)?.reduce((current, _datum, datumIndex)=>{
            const feature = featureValues?.[datumIndex];
            const geometry = feature?.geometry;
            if (geometry != null) current = $2fb96651e8aa1522$var$geometryBbox(geometry, current);
            if (latValues != null && lonValues != null) {
                const lon = lonValues[datumIndex];
                const lat = latValues[datumIndex];
                current = $2fb96651e8aa1522$var$extendBbox(current, lon, lat, lon, lat);
            }
            return current;
        }, void 0);
        if (sizeKey != null) {
            const sizeIdx = dataModel.resolveProcessedDataIndexById(this, `sizeValue`);
            const processedSize = processedData.domain.values[sizeIdx] ?? [];
            sizeScale.domain = sizeDomain ?? processedSize;
        }
        if (colorRange != null && this.isColorScaleValid()) {
            const colorKeyIdx = dataModel.resolveProcessedDataIndexById(this, "colorValue");
            colorScale.domain = processedData.domain.values[colorKeyIdx];
            colorScale.range = colorRange;
            colorScale.update();
        }
        this.animationState.transition("updateData");
    }
    isColorScaleValid() {
        const { colorKey: colorKey } = this.properties;
        if (!colorKey) return false;
        const { dataModel: dataModel, processedData: processedData } = this;
        if (!dataModel || !processedData) return false;
        const colorIdx = dataModel.resolveProcessedDataIndexById(this, "colorValue");
        const dataCount = processedData.input.count;
        const missCount = $2fb96651e8aa1522$var$getMissCount3(this, processedData.defs.values[colorIdx].missing);
        const colorDataMissing = dataCount === 0 || dataCount === missCount;
        return !colorDataMissing;
    }
    getLabelDatum(datum, labelValue, x, y, size, font2) {
        if (labelValue == null) return;
        const { idKey: idKey, idName: idName, latitudeKey: latitudeKey, latitudeName: latitudeName, longitudeKey: longitudeKey, longitudeName: longitudeName, sizeKey: sizeKey, sizeName: sizeName, colorKey: colorKey, colorName: colorName, labelKey: labelKey, labelName: labelName, label: label, shape: shape } = this.properties;
        const { placement: placement } = label;
        const labelText = this.getLabelText(label, {
            value: labelValue,
            datum: datum,
            idKey: idKey,
            idName: idName,
            latitudeKey: latitudeKey,
            latitudeName: latitudeName,
            longitudeKey: longitudeKey,
            longitudeName: longitudeName,
            sizeKey: sizeKey,
            sizeName: sizeName,
            colorKey: colorKey,
            colorName: colorName,
            labelKey: labelKey,
            labelName: labelName
        });
        if (labelText == null) return;
        const { width: width, height: height } = $2fb96651e8aa1522$var$CachedTextMeasurerPool8.measureText(String(labelText), {
            font: font2
        });
        const anchor = $2fb96651e8aa1522$var$Marker3.anchor(shape);
        return {
            point: {
                x: x,
                y: y,
                size: size
            },
            label: {
                width: width,
                height: height,
                text: labelText
            },
            anchor: anchor,
            placement: placement
        };
    }
    createNodeData() {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, sizeScale: sizeScale, properties: properties, scale: scale } = this;
        const { idKey: idKey, latitudeKey: latitudeKey, longitudeKey: longitudeKey, sizeKey: sizeKey, colorKey: colorKey, labelKey: labelKey, label: label } = properties;
        if (dataModel == null || processedData == null || scale == null) return;
        const hasLatLon = latitudeKey != null && longitudeKey != null;
        const idValues = idKey != null ? dataModel.resolveColumnById(this, `idValue`, processedData) : void 0;
        const featureValues = idKey != null ? dataModel.resolveColumnById(this, `featureValue`, processedData) : void 0;
        const latValues = hasLatLon ? dataModel.resolveColumnById(this, `latValue`, processedData) : void 0;
        const lonValues = hasLatLon ? dataModel.resolveColumnById(this, `lonValue`, processedData) : void 0;
        const labelValues = labelKey != null ? dataModel.resolveColumnById(this, `labelValue`, processedData) : void 0;
        const sizeValues = sizeKey != null ? dataModel.resolveColumnById(this, `sizeValue`, processedData) : void 0;
        const colorValues = colorKey != null ? dataModel.resolveColumnById(this, `colorValue`, processedData) : void 0;
        const markerMaxSize = properties.maxSize ?? properties.size;
        sizeScale.range = [
            Math.min(properties.size, markerMaxSize),
            markerMaxSize
        ];
        const font2 = label.getFont();
        let projectedGeometries;
        if (idValues != null && featureValues != null) {
            projectedGeometries = /* @__PURE__ */ new Map();
            processedData.dataSources.get(this.id)?.forEach((_datum, datumIndex)=>{
                const id = idValues[datumIndex];
                const geometry = featureValues[datumIndex]?.geometry ?? void 0;
                const projectedGeometry = geometry != null && scale != null ? $2fb96651e8aa1522$var$projectGeometry(geometry, scale) : void 0;
                if (id != null && projectedGeometry != null) projectedGeometries.set(id, projectedGeometry);
            });
        }
        const nodeData = [];
        const labelData = [];
        const missingGeometries = [];
        const rawData = processedData.dataSources.get(this.id) ?? [];
        rawData.forEach((datum, datumIndex)=>{
            const idValue = idValues?.[datumIndex];
            const lonValue = lonValues?.[datumIndex];
            const latValue = latValues?.[datumIndex];
            const colorValue = colorValues?.[datumIndex];
            const sizeValue = sizeValues?.[datumIndex];
            const labelValue = labelValues?.[datumIndex];
            const size = sizeValue != null ? sizeScale.convert(sizeValue, {
                clamp: true
            }) : properties.size;
            const projectedGeometry = idValue != null ? projectedGeometries?.get(idValue) : void 0;
            if (idValue != null && $2fb96651e8aa1522$var$projectGeometry == null) missingGeometries.push(idValue);
            if (lonValue != null && latValue != null) {
                const [x, y] = scale.convert([
                    lonValue,
                    latValue
                ]);
                const labelDatum = this.getLabelDatum(datum, labelValue, x, y, size, font2);
                if (labelDatum) labelData.push(labelDatum);
                nodeData.push({
                    series: this,
                    itemId: latitudeKey,
                    datum: datum,
                    datumIndex: datumIndex,
                    index: -1,
                    idValue: idValue,
                    lonValue: lonValue,
                    latValue: latValue,
                    labelValue: labelValue,
                    sizeValue: sizeValue,
                    colorValue: colorValue,
                    point: {
                        x: x,
                        y: y,
                        size: size
                    },
                    midPoint: {
                        x: x,
                        y: y
                    }
                });
            } else if (projectedGeometry != null) $2fb96651e8aa1522$var$markerPositions(projectedGeometry, 1).forEach(([x, y], index)=>{
                const labelDatum = this.getLabelDatum(datum, labelValue, x, y, size, font2);
                if (labelDatum) labelData.push(labelDatum);
                nodeData.push({
                    series: this,
                    itemId: latitudeKey,
                    datum: datum,
                    datumIndex: datumIndex,
                    index: index,
                    idValue: idValue,
                    lonValue: lonValue,
                    latValue: latValue,
                    labelValue: labelValue,
                    sizeValue: sizeValue,
                    colorValue: colorValue,
                    point: {
                        x: x,
                        y: y,
                        size: size
                    },
                    midPoint: {
                        x: x,
                        y: y
                    }
                });
            });
        });
        const missingGeometriesCap = 10;
        if (missingGeometries.length > missingGeometriesCap) {
            const excessItems = missingGeometries.length - missingGeometriesCap;
            missingGeometries.length = missingGeometriesCap;
            missingGeometries.push(`(+${excessItems} more)`);
        }
        if (missingGeometries.length > 0) (0, $idDdm.Logger).warnOnce(`some data items do not have matches in the provided topology`, missingGeometries);
        return {
            itemId: seriesId,
            nodeData: nodeData,
            labelData: labelData
        };
    }
    updateSelections() {
        if (this.nodeDataRefresh) {
            this.contextNodeData = this.createNodeData();
            this.nodeDataRefresh = false;
        }
    }
    checkScaleChange() {
        if (this.previousScale === this.scale) return false;
        this.previousScale = this.scale;
        return true;
    }
    update({ seriesRect: seriesRect }) {
        const resize = this.checkResize(seriesRect);
        const scaleChange = this.checkScaleChange();
        const { markerSelection: markerSelection, highlightMarkerSelection: highlightMarkerSelection } = this;
        this.updateSelections();
        this.contentGroup.visible = this.visible;
        this.contentGroup.opacity = this.getOpacity();
        let highlightedDatum = this.ctx.highlightManager?.getActiveHighlight();
        if (highlightedDatum != null && (highlightedDatum.series !== this || highlightedDatum.datum == null)) highlightedDatum = void 0;
        const nodeData = this.contextNodeData?.nodeData ?? [];
        this.markerSelection = this.updateMarkerSelection({
            markerData: nodeData,
            markerSelection: markerSelection
        });
        this.updateMarkerNodes({
            markerSelection: markerSelection,
            isHighlight: false,
            highlightedDatum: highlightedDatum
        });
        this.highlightMarkerSelection = this.updateMarkerSelection({
            markerData: highlightedDatum != null ? [
                highlightedDatum
            ] : [],
            markerSelection: highlightMarkerSelection
        });
        this.updateMarkerNodes({
            markerSelection: highlightMarkerSelection,
            isHighlight: true,
            highlightedDatum: highlightedDatum
        });
        if (scaleChange || resize) this.animationState.transition("resize");
        this.animationState.transition("update");
    }
    updatePlacedLabelData(labelData) {
        this.labelSelection = this.labelSelection.update(labelData, (text2)=>{
            text2.pointerEvents = (0, $iTJTu._ModuleSupport).PointerEvents.None;
        });
        this.updateLabelNodes({
            labelSelection: this.labelSelection
        });
    }
    updateLabelNodes(opts) {
        const { labelSelection: labelSelection } = opts;
        const { color: fill, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily } = this.properties.label;
        labelSelection.each((label, { x: x, y: y, width: width, height: height, text: text2 })=>{
            label.visible = true;
            label.x = x + width / 2;
            label.y = y + height / 2;
            label.text = text2;
            label.fill = fill;
            label.fontStyle = fontStyle;
            label.fontWeight = fontWeight;
            label.fontSize = fontSize;
            label.fontFamily = fontFamily;
            label.textAlign = "center";
            label.textBaseline = "middle";
        });
    }
    updateMarkerSelection(opts) {
        const { markerData: markerData, markerSelection: markerSelection } = opts;
        return markerSelection.update(markerData, void 0, (datum)=>$2fb96651e8aa1522$var$createDatumId15([
                datum.index,
                datum.idValue,
                datum.lonValue,
                datum.latValue
            ]));
    }
    getMarkerItemBaseStyle(highlighted) {
        const { properties: properties } = this;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return $2fb96651e8aa1522$var$getShapeStyle10({
            shape: properties.shape,
            size: properties.size,
            fill: highlightStyle?.fill ?? properties.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? properties.fillOpacity,
            stroke: highlightStyle?.stroke ?? properties.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(properties.strokeWidth),
            strokeOpacity: highlightStyle?.strokeOpacity ?? properties.strokeOpacity,
            lineDash: highlightStyle?.lineDash ?? properties.lineDash,
            lineDashOffset: highlightStyle?.lineDashOffset ?? properties.lineDashOffset
        }, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
    }
    getMarkerItemStyleOverrides(datumId, datum, colorValue, sizeValue, format, highlighted) {
        const { id: seriesId, properties: properties, colorScale: colorScale, sizeScale: sizeScale } = this;
        const { colorRange: colorRange, itemStyler: itemStyler } = properties;
        let overrides;
        overrides ?? (overrides = {});
        if (!highlighted && colorValue != null) overrides.fill = this.isColorScaleValid() ? colorScale.convert(colorValue) : colorRange?.[0] ?? properties.fill;
        if (sizeValue != null) overrides.size = sizeScale.convert(sizeValue, {
            clamp: true
        });
        if (itemStyler != null) {
            const itemStyle = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId15(datumId, highlighted ? "highlight" : "node"), ()=>{
                return this.callWithContext(itemStyler, {
                    seriesId: seriesId,
                    datum: datum,
                    highlighted: highlighted,
                    ...format,
                    ...overrides
                });
            });
            overrides ?? (overrides = {});
            Object.assign(overrides, itemStyle);
        }
        return overrides;
    }
    updateMarkerNodes(opts) {
        const { markerSelection: markerSelection, isHighlight: isHighlight, highlightedDatum: highlightedDatum } = opts;
        const style = this.getMarkerItemBaseStyle(isHighlight);
        const fillBBox = $2fb96651e8aa1522$var$getTopologyShapeFillBBox(this.scale);
        markerSelection.each((marker, markerDatum)=>{
            const { datumIndex: datumIndex, datum: datum, point: point, colorValue: colorValue, sizeValue: sizeValue } = markerDatum;
            const overrides = this.getMarkerItemStyleOverrides(String(datumIndex), datum, colorValue, sizeValue, style, isHighlight);
            marker.shape = overrides?.shape ?? style.shape;
            marker.size = overrides?.size ?? style.size;
            $2fb96651e8aa1522$var$applyShapeStyle9(marker, style, overrides, fillBBox);
            marker.x = point.x;
            marker.y = point.y;
            marker.scalingCenterX = point.x;
            marker.scalingCenterY = point.y;
            marker.zIndex = !isHighlight && highlightedDatum != null && datum === highlightedDatum.datum ? 1 : 0;
        });
    }
    isProcessedDataAnimatable() {
        return true;
    }
    resetAnimation(phase) {
        if (phase === "initial") this.animationState.transition("reset");
        else if (phase === "ready") this.animationState.transition("skip");
    }
    resetAllAnimation() {
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
        this.ctx.animationManager.skipCurrentBatch();
        this.labelSelection.cleanup();
        this.markerSelection.cleanup();
        this.highlightMarkerSelection.cleanup();
    }
    animateMarkers() {
        const { animationManager: animationManager } = this.ctx;
        const fns = $2fb96651e8aa1522$var$prepareMapMarkerAnimationFunctions();
        $2fb96651e8aa1522$var$fromToMotion3(this.id, "markers", animationManager, [
            this.markerSelection,
            this.highlightMarkerSelection
        ], fns);
    }
    getLabelData() {
        if (!this.isLabelEnabled()) return [];
        return this.contextNodeData?.labelData ?? [];
    }
    pickNodeClosestDatum(p) {
        const { x: x0, y: y0 } = p;
        let minDistanceSquared = Infinity;
        let minDatum;
        this.contextNodeData?.nodeData.forEach((datum)=>{
            const { x: x, y: y, size: size } = datum.point;
            const dx2 = Math.max(Math.abs(x - x0) - size, 0);
            const dy2 = Math.max(Math.abs(y - y0) - size, 0);
            const distanceSquared = dx2 * dx2 + dy2 * dy2;
            if (distanceSquared < minDistanceSquared) {
                minDistanceSquared = distanceSquared;
                minDatum = datum;
            }
        });
        return minDatum != null ? {
            datum: minDatum,
            distance: Math.sqrt(minDistanceSquared)
        } : void 0;
    }
    legendItemSymbol(datumIndex) {
        const { dataModel: dataModel, processedData: processedData, properties: properties } = this;
        const { shape: shape, fillOpacity: fillOpacity, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = properties;
        let { fill: fill } = properties;
        if (datumIndex != null && this.isColorScaleValid()) {
            const colorValues = dataModel.resolveColumnById(this, "colorValue", processedData);
            const colorValue = colorValues[datumIndex];
            fill = this.colorScale.convert(colorValue);
        }
        return {
            marker: $2fb96651e8aa1522$var$getShapeStyle10({
                shape: shape,
                fill: fill,
                fillOpacity: fillOpacity,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                strokeOpacity: strokeOpacity,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset
            }, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults)
        };
    }
    getLegendData(legendType) {
        const { processedData: processedData, dataModel: dataModel } = this;
        if (processedData == null || dataModel == null) return [];
        const { id: seriesId, visible: visible } = this;
        const { title: title, legendItemName: legendItemName, idName: idName, idKey: idKey, colorKey: colorKey, colorName: colorName, colorRange: colorRange, showInLegend: showInLegend } = this.properties;
        if (legendType === "gradient" && colorKey != null && colorRange != null) {
            const colorDomain = processedData.domain.values[dataModel.resolveProcessedDataIndexById(this, "colorValue")];
            const legendDatum = {
                legendType: "gradient",
                enabled: visible,
                seriesId: seriesId,
                colorName: colorName,
                colorRange: colorRange,
                colorDomain: colorDomain
            };
            return [
                legendDatum
            ];
        } else if (legendType === "category") {
            const legendDatum = {
                legendType: "category",
                id: seriesId,
                itemId: seriesId,
                seriesId: seriesId,
                enabled: visible,
                label: {
                    text: legendItemName ?? title ?? idName ?? idKey ?? seriesId
                },
                symbol: this.legendItemSymbol(),
                legendItemName: legendItemName,
                hideInLegend: !showInLegend
            };
            return [
                legendDatum
            ];
        } else return [];
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, properties: properties } = this;
        const { idKey: idKey, idName: idName, latitudeKey: latitudeKey, latitudeName: latitudeName, longitudeKey: longitudeKey, longitudeName: longitudeName, colorKey: colorKey, colorName: colorName, sizeKey: sizeKey, sizeName: sizeName, labelKey: labelKey, labelName: labelName, title: title, legendItemName: legendItemName, tooltip: tooltip } = properties;
        if (!dataModel || !processedData) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const sizeValue = sizeKey != null ? dataModel.resolveColumnById(this, `sizeValue`, processedData)[datumIndex] : void 0;
        const colorValue = colorKey != null ? dataModel.resolveColumnById(this, `colorValue`, processedData)[datumIndex] : void 0;
        const data = [];
        if (sizeValue != null) data.push({
            label: sizeName,
            fallbackLabel: sizeKey,
            value: String(sizeValue)
        });
        if (colorValue != null) data.push({
            label: colorName,
            fallbackLabel: colorKey,
            value: String(colorValue)
        });
        if (labelKey != null && labelKey !== idKey) {
            const labelValue = dataModel.resolveColumnById(this, `labelValue`, processedData)[datumIndex];
            data.push({
                label: labelName,
                fallbackLabel: labelKey,
                value: labelValue
            });
        }
        let heading;
        if (idKey != null) heading = dataModel.resolveColumnById(this, `idValue`, processedData)[datumIndex];
        else if (latitudeKey != null && longitudeKey != null) {
            const latValue = dataModel.resolveColumnById(this, `latValue`, processedData)[datumIndex];
            const lonValue = dataModel.resolveColumnById(this, `lonValue`, processedData)[datumIndex];
            heading = `${Math.abs(latValue).toFixed(4)}\xB0 ${latValue >= 0 ? "N" : "S"}, ${Math.abs(lonValue).toFixed(4)}\xB0 ${lonValue >= 0 ? "W" : "E"}`;
        }
        const format = this.getMarkerItemBaseStyle(false);
        Object.assign(format, this.getMarkerItemStyleOverrides(String(datumIndex), datumIndex, colorValue, sizeValue, format, false));
        return this.formatTooltipWithContext(tooltip, {
            heading: heading,
            title: title ?? legendItemName,
            symbol: this.legendItemSymbol(datumIndex),
            data: data
        }, {
            seriesId: seriesId,
            datum: datum,
            title: title,
            idKey: idKey,
            idName: idName,
            latitudeKey: latitudeKey,
            latitudeName: latitudeName,
            longitudeKey: longitudeKey,
            longitudeName: longitudeName,
            colorKey: colorKey,
            colorName: colorName,
            sizeKey: sizeKey,
            sizeName: sizeName,
            labelKey: labelKey,
            labelName: labelName,
            ...format
        });
    }
    getFormattedMarkerStyle(markerDatum) {
        const { datumIndex: datumIndex, colorValue: colorValue, sizeValue: sizeValue } = markerDatum;
        const format = this.getMarkerItemBaseStyle(false);
        Object.assign(format, this.getMarkerItemStyleOverrides(String(datumIndex), datumIndex, colorValue, sizeValue, format, false));
        return {
            size: format.size
        };
    }
    computeFocusBounds(opts) {
        return $2fb96651e8aa1522$var$computeMarkerFocusBounds2(this, opts);
    }
};
$2fb96651e8aa1522$var$MapMarkerSeries.className = "MapMarkerSeries";
$2fb96651e8aa1522$var$MapMarkerSeries.type = "map-marker";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs12, mapMarkerSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$mapMarkerSeriesThemeableOptionsDef, without: $2fb96651e8aa1522$var$without3 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$mapMarkerSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$mapMarkerSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$without3($2fb96651e8aa1522$var$commonSeriesOptionsDefs12, [
        "highlightStyle"
    ]),
    type: (0, $idDdm.required)((0, $idDdm.constant)("map-marker")),
    idKey: (0, $idDdm.string),
    latitudeKey: (0, $idDdm.string),
    longitudeKey: (0, $idDdm.string),
    sizeKey: (0, $idDdm.string),
    colorKey: (0, $idDdm.string),
    labelKey: (0, $idDdm.string),
    idName: (0, $idDdm.string),
    latitudeName: (0, $idDdm.string),
    longitudeName: (0, $idDdm.string),
    sizeName: (0, $idDdm.string),
    colorName: (0, $idDdm.string),
    labelName: (0, $idDdm.string),
    topology: (0, $idDdm.geoJson),
    topologyIdKey: (0, $idDdm.string),
    legendItemName: (0, $idDdm.string),
    title: (0, $idDdm.string)
};
// packages/ag-charts-enterprise/src/series/map-marker/mapMarkerModule.ts
var $2fb96651e8aa1522$var$MapMarkerModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "topology"
    ],
    identifier: "map-marker",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$MapMarkerSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    themeTemplate: {
        ...$2fb96651e8aa1522$var$MAP_THEME_DEFAULTS,
        series: {
            shape: "circle",
            maxSize: 30,
            fill: {
                $palette: "fill"
            },
            stroke: {
                $palette: "stroke"
            },
            colorRange: {
                $if: [
                    {
                        $eq: [
                            {
                                $palette: "type"
                            },
                            "inbuilt"
                        ]
                    },
                    {
                        $palette: "divergingColors"
                    },
                    (0, $iTJTu._ModuleSupport).SAFE_RANGE2_OPERATION
                ]
            },
            // @ts-expect-error undocumented option
            fillGradientDefaults: {
                type: "gradient",
                gradient: "radial",
                bounds: "item",
                colorStops: {
                    $palette: "gradient"
                },
                rotation: 0,
                reverse: true
            },
            fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
            fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
            fillOpacity: 0.5,
            label: {
                enabled: false,
                fontSize: {
                    $ref: "fontSize"
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontWeight: {
                    $ref: "fontWeight"
                },
                color: {
                    $ref: "textColor"
                }
            }
        },
        tooltip: {
            range: "exact"
        }
    }
};
var $2fb96651e8aa1522$var$MapMarkerSeriesModule = {
    type: "series",
    name: "map-marker",
    chartType: "topology",
    enterprise: true,
    options: $2fb96651e8aa1522$var$mapMarkerSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$MapMarkerSeries(ctx),
    validate (options, optionsDefs2, path) {
        const result = (0, $idDdm.validate)(options, optionsDefs2, path);
        const { cleared: cleared, invalid: invalid } = result;
        if (cleared?.idKey == null && (cleared?.latitudeKey == null || cleared?.longitudeKey == null)) {
            const extendPath = (key)=>path ? `${path}.${key}` : key;
            const message = `Either \`${extendPath("idKey")}\` or both \`${extendPath("latitudeKey")}\` and \`${extendPath("longitudeKey")}\` are required.`;
            invalid.push(new (0, $idDdm.ValidationError)("required", message, null, path));
        }
        return result;
    }
};
// packages/ag-charts-enterprise/src/series/map-util/polygonLabelUtil.ts
function $2fb96651e8aa1522$var$preferredLabelCenter(polygons, { aspectRatio: aspectRatio, precision: precision }) {
    const result = $2fb96651e8aa1522$var$polygonPointSearch(polygons, precision, (p, cx, cy, stride)=>{
        const width = $2fb96651e8aa1522$var$maxWidthOfRectConstrainedByCenterAndAspectRatioToPolygon(p, cx, cy, aspectRatio);
        const maxWidth2 = width + 2 * stride * aspectRatio;
        const distance2 = width * Math.SQRT2;
        const maxDistance = maxWidth2 * Math.SQRT2;
        return {
            distance: distance2,
            maxDistance: maxDistance
        };
    });
    if (result == null) return;
    const { x: x, y: y, distance: distance } = result;
    const maxWidth = distance / Math.SQRT2;
    return {
        x: x,
        y: y,
        maxWidth: maxWidth
    };
}
function $2fb96651e8aa1522$var$maxWidthOfRectConstrainedByCenterAndAspectRatioToLineSegment(a, b, cx, cy, aspectRatio) {
    const [ax, ay] = a;
    const [bx, by] = b;
    const positiveM = 1 / aspectRatio;
    const abx = bx - ax;
    const aby = by - ay;
    const [topPointX, topPointY] = ay <= by ? a : b;
    const [leftPointX, leftPointY] = ax <= bx ? a : b;
    const [bottomPointX, bottomPointY] = ay <= by ? b : a;
    const [rightPointX, rightPointY] = ax <= bx ? b : a;
    let maxWidth = Infinity;
    if (abx !== 0) {
        const abm = aby / abx;
        for(let i = 0; i <= 1; i += 1){
            const m = i === 0 ? positiveM : -positiveM;
            const x = (abm * ax - ay - m * cx + cy) / (abm - m);
            if (x >= leftPointX && x <= rightPointX) {
                const width = Math.abs(cx - x) * 2;
                maxWidth = Math.min(maxWidth, width);
            }
        }
    } else for(let i = 0; i <= 1; i += 1){
        const m = i === 0 ? positiveM : -positiveM;
        const y = m * (ax - cx) + cy;
        if (y >= topPointY && y <= bottomPointY) {
            const height = Math.abs(cy - y) * 2;
            const width = height * aspectRatio;
            maxWidth = Math.min(maxWidth, width);
        }
    }
    const positiveMRecip = aspectRatio;
    const centerToTopMRecip = Math.abs((topPointX - cx) / (topPointY - cy));
    const centerToBottomMRecip = Math.abs((bottomPointX - cx) / (bottomPointY - cy));
    if (bottomPointY < cy && centerToBottomMRecip < positiveMRecip) {
        const height = Math.abs(cy - bottomPointY) * 2;
        const width = height * aspectRatio;
        maxWidth = Math.min(maxWidth, width);
    } else if (topPointY > cy && centerToTopMRecip < positiveMRecip) {
        const height = Math.abs(cy - topPointY) * 2;
        const width = height * aspectRatio;
        maxWidth = Math.min(maxWidth, width);
    }
    const centerToLeftM = Math.abs((leftPointY - cy) / (leftPointX - cx));
    const centerToRightM = Math.abs((rightPointY - cy) / (rightPointX - cx));
    if (rightPointX < cx && centerToRightM < positiveM) {
        const width = Math.abs(cx - rightPointX) * 2;
        maxWidth = Math.min(maxWidth, width);
    } else if (leftPointX > cx && centerToLeftM < positiveM) {
        const width = Math.abs(cx - leftPointX) * 2;
        maxWidth = Math.min(maxWidth, width);
    }
    return maxWidth;
}
function $2fb96651e8aa1522$var$maxWidthOfRectConstrainedByCenterAndAspectRatioToPolygon(polygons, cx, cy, aspectRatio) {
    let inside = false;
    let minWidth = Infinity;
    for (const polygon of polygons){
        let p0 = polygon[polygon.length - 1];
        let [x0, y0] = p0;
        for (const p1 of polygon){
            const [x1, y1] = p1;
            if (y1 > cy !== y0 > cy && cx < (x0 - x1) * (cy - y1) / (y0 - y1) + x1) inside = !inside;
            const width = $2fb96651e8aa1522$var$maxWidthOfRectConstrainedByCenterAndAspectRatioToLineSegment(p0, p1, cx, cy, aspectRatio);
            minWidth = Math.min(minWidth, width);
            p0 = p1;
            x0 = x1;
            y0 = y1;
        }
    }
    return (inside ? 1 : -1) * minWidth;
}
function $2fb96651e8aa1522$var$applyX(into, cx, x) {
    if (x >= cx) into.maxX = Math.min(into.maxX, x - cx);
    if (x <= cx) into.minX = Math.max(into.minX, x - cx);
}
function $2fb96651e8aa1522$var$xExtentsOfRectConstrainedByCenterAndHeightToLineSegment(into, a, b, cx, cy, height) {
    const ry0 = cy - height / 2;
    const ry1 = cy + height / 2;
    const [ax, ay] = a;
    const [bx, by] = b;
    const abx = bx - ax;
    const aby = by - ay;
    const [leftPointX, leftPointY] = ax <= bx ? a : b;
    const [rightPointX, rightPointY] = ax <= bx ? b : a;
    if (abx !== 0) {
        const abm = aby / abx;
        for(let i = 0; i <= 1; i += 1){
            const y = i === 0 ? ry0 : ry1;
            const x = (y - ay) / abm + ax;
            if (x >= leftPointX && x <= rightPointX) $2fb96651e8aa1522$var$applyX(into, cx, x);
        }
    } else if (Math.max(ry0, Math.min(ay, by)) <= Math.min(ry1, Math.max(ay, by))) $2fb96651e8aa1522$var$applyX(into, cx, ax);
    if (rightPointX < cx && rightPointY >= ry0 && rightPointY <= ry1) $2fb96651e8aa1522$var$applyX(into, cx, rightPointX);
    else if (leftPointX > cx && leftPointY >= ry0 && leftPointY <= ry1) $2fb96651e8aa1522$var$applyX(into, cx, leftPointX);
    return into;
}
function $2fb96651e8aa1522$var$maxWidthInPolygonForRectOfHeight(polygons, cx, cy, height) {
    const result = {
        minX: -Infinity,
        maxX: Infinity
    };
    for (const polygon of polygons){
        let p0 = polygon[polygon.length - 1];
        for (const p1 of polygon){
            $2fb96651e8aa1522$var$xExtentsOfRectConstrainedByCenterAndHeightToLineSegment(result, p0, p1, cx, cy, height);
            p0 = p1;
        }
    }
    const { minX: minX, maxX: maxX } = result;
    if (Number.isFinite(minX) && Number.isFinite(maxX)) return {
        x: cx + (minX + maxX) / 2,
        width: maxX - minX
    };
    else return {
        x: cx,
        width: 0
    };
}
var { Property: $2fb96651e8aa1522$var$Property73, SeriesProperties: $2fb96651e8aa1522$var$SeriesProperties6, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip15, FillGradientDefaults: $2fb96651e8aa1522$var$FillGradientDefaults10, FillPatternDefaults: $2fb96651e8aa1522$var$FillPatternDefaults10, FillImageDefaults: $2fb96651e8aa1522$var$FillImageDefaults10 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$MapShapeSeriesProperties = class extends $2fb96651e8aa1522$var$SeriesProperties6 {
    constructor(){
        super(...arguments);
        this.topology = void 0;
        this.idKey = "";
        this.idName = void 0;
        this.topologyIdKey = "name";
        this.labelKey = void 0;
        this.labelName = void 0;
        this.colorRange = void 0;
        this.fill = "black";
        this.fillGradientDefaults = new $2fb96651e8aa1522$var$FillGradientDefaults10();
        this.fillPatternDefaults = new $2fb96651e8aa1522$var$FillPatternDefaults10();
        this.fillImageDefaults = new $2fb96651e8aa1522$var$FillImageDefaults10();
        this.fillOpacity = 1;
        this.stroke = "black";
        this.strokeOpacity = 1;
        this.strokeWidth = 0;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.padding = 0;
        this.label = new $2fb96651e8aa1522$var$AutoSizedSecondaryLabel();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip15();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "topology", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "title", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "legendItemName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "idKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "idName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "topologyIdKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "labelKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "labelName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "colorKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "colorName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "colorRange", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "fillGradientDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "fillPatternDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "fillImageDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "padding", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "itemStyler", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property73
], $2fb96651e8aa1522$var$MapShapeSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-enterprise/src/series/map-shape/mapShapeSeries.ts
var { getMissCount: $2fb96651e8aa1522$var$getMissCount4, createDatumId: $2fb96651e8aa1522$var$createDatumId16, SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode12, valueProperty: $2fb96651e8aa1522$var$valueProperty14, CachedTextMeasurerPool: $2fb96651e8aa1522$var$CachedTextMeasurerPool9, TextUtils: $2fb96651e8aa1522$var$TextUtils6, ColorScale: $2fb96651e8aa1522$var$ColorScale4, Group: $2fb96651e8aa1522$var$Group15, Selection: $2fb96651e8aa1522$var$Selection11, Text: $2fb96651e8aa1522$var$Text5, PointerEvents: $2fb96651e8aa1522$var$PointerEvents7, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle10, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle11 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$fixedScale = (0, $iTJTu._ModuleSupport).MercatorScale.fixedScale();
var $2fb96651e8aa1522$var$MapShapeSeries = class extends $2fb96651e8aa1522$var$TopologySeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            categoryKey: void 0,
            useLabelLayer: true,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode12.EXACT_SHAPE_MATCH,
                $2fb96651e8aa1522$var$SeriesNodePickMode12.NEAREST_NODE
            ]
        });
        this.properties = new $2fb96651e8aa1522$var$MapShapeSeriesProperties();
        this._chartTopology = void 0;
        this.colorScale = new $2fb96651e8aa1522$var$ColorScale4();
        this.itemGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group15({
            name: "itemGroup"
        }));
        this.itemLabelGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group15({
            name: "itemLabelGroup"
        }));
        this.datumSelection = $2fb96651e8aa1522$var$Selection11.select(this.itemGroup, ()=>this.nodeFactory());
        this.labelSelection = $2fb96651e8aa1522$var$Selection11.select(this.itemLabelGroup, $2fb96651e8aa1522$var$Text5);
        this.highlightDatumSelection = $2fb96651e8aa1522$var$Selection11.select(this.highlightNode, ()=>this.nodeFactory());
        this.previousLabelLayouts = void 0;
        this._previousDatumMidPoint = void 0;
        this.itemLabelGroup.pointerEvents = $2fb96651e8aa1522$var$PointerEvents7.None;
    }
    getNodeData() {
        return this.contextNodeData?.nodeData;
    }
    get topology() {
        return this.properties.topology ?? this._chartTopology;
    }
    get hasData() {
        return super.hasData && this.topology != null;
    }
    renderToOffscreenCanvas() {
        return true;
    }
    setChartTopology(topology) {
        this._chartTopology = topology;
        if (this.topology === topology) this.nodeDataRefresh = true;
    }
    setSeriesIndex(index) {
        if (!super.setSeriesIndex(index)) return false;
        this.contentGroup.zIndex = [
            1 /* ShapeLine */ ,
            index
        ];
        this.highlightGroup.zIndex = [
            2 /* ShapeLineHighlight */ ,
            index
        ];
        return true;
    }
    isLabelEnabled() {
        return this.properties.labelKey != null && this.properties.label.enabled;
    }
    nodeFactory() {
        const geoGeometry = new $2fb96651e8aa1522$var$GeoGeometry();
        geoGeometry.renderMode = 1 /* Polygons */ ;
        geoGeometry.lineJoin = "round";
        return geoGeometry;
    }
    async processData(dataController) {
        if (this.data == null) return;
        const { data: data, topology: topology, colorScale: colorScale } = this;
        const { topologyIdKey: topologyIdKey, idKey: idKey, colorKey: colorKey, labelKey: labelKey, colorRange: colorRange } = this.properties;
        const featureById = /* @__PURE__ */ new Map();
        topology?.features.forEach((feature)=>{
            const property = feature.properties?.[topologyIdKey];
            if (property == null || !$2fb96651e8aa1522$var$containsType(feature.geometry, 1 /* Polygon */ )) return;
            featureById.set(property, feature);
        });
        const colorScaleType = this.colorScale.type;
        const mercatorScaleType = this.scale?.type;
        const { dataModel: dataModel, processedData: processedData } = await this.requestDataModel(dataController, data, {
            props: [
                $2fb96651e8aa1522$var$valueProperty14(idKey, mercatorScaleType, {
                    id: "idValue",
                    includeProperty: false
                }),
                $2fb96651e8aa1522$var$valueProperty14(idKey, mercatorScaleType, {
                    id: "featureValue",
                    includeProperty: false,
                    processor: ()=>(datum)=>featureById.get(datum)
                }),
                ...labelKey ? [
                    $2fb96651e8aa1522$var$valueProperty14(labelKey, "band", {
                        id: "labelValue"
                    })
                ] : [],
                ...colorKey ? [
                    $2fb96651e8aa1522$var$valueProperty14(colorKey, colorScaleType, {
                        id: "colorValue"
                    })
                ] : []
            ]
        });
        const featureValues = dataModel.resolveColumnById(this, `featureValue`, processedData);
        this.topologyBounds = featureValues.reduce((current, feature)=>{
            const geometry = feature?.geometry;
            if (geometry == null) return current;
            return $2fb96651e8aa1522$var$geometryBbox(geometry, current);
        }, void 0);
        if (colorRange != null && this.isColorScaleValid()) {
            const colorKeyIdx = dataModel.resolveProcessedDataIndexById(this, "colorValue");
            colorScale.domain = processedData.domain.values[colorKeyIdx];
            colorScale.range = colorRange;
            colorScale.update();
        }
        if (topology == null) (0, $idDdm.Logger).warnOnce(`no topology was provided for [MapShapeSeries]; nothing will be rendered.`);
    }
    isColorScaleValid() {
        const { colorKey: colorKey } = this.properties;
        if (!colorKey) return false;
        const { dataModel: dataModel, processedData: processedData } = this;
        if (!dataModel || !processedData) return false;
        const colorIdx = dataModel.resolveProcessedDataIndexById(this, "colorValue");
        const dataCount = processedData.input.count;
        const missCount = $2fb96651e8aa1522$var$getMissCount4(this, processedData.defs.values[colorIdx].missing);
        const colorDataMissing = dataCount === 0 || dataCount === missCount;
        return !colorDataMissing;
    }
    getLabelLayout(datum, labelValue, font2, geometry, previousLabelLayout) {
        if (labelValue == null || geometry == null) return;
        const { idKey: idKey, idName: idName, colorKey: colorKey, colorName: colorName, labelKey: labelKey, labelName: labelName, padding: padding, label: label } = this.properties;
        const labelText = this.getLabelText(label, {
            value: labelValue,
            datum: datum,
            idKey: idKey,
            idName: idName,
            colorKey: colorKey,
            colorName: colorName,
            labelKey: labelKey,
            labelName: labelName
        });
        if (labelText == null) return;
        const baseSize = $2fb96651e8aa1522$var$CachedTextMeasurerPool9.measureText(String(labelText), {
            font: font2
        });
        const numLines = labelText.split("\n").length;
        const aspectRatio = (baseSize.width + 2 * padding) / (numLines * $2fb96651e8aa1522$var$TextUtils6.getLineHeight(label.fontSize) + 2 * padding);
        if (previousLabelLayout?.geometry === geometry && previousLabelLayout?.labelText === labelText && previousLabelLayout?.aspectRatio === aspectRatio) return previousLabelLayout;
        const fixedGeometry = $2fb96651e8aa1522$var$projectGeometry(geometry, $2fb96651e8aa1522$var$fixedScale);
        const fixedPolygon = $2fb96651e8aa1522$var$largestPolygon(fixedGeometry);
        if (fixedPolygon == null) return;
        const labelPlacement = $2fb96651e8aa1522$var$preferredLabelCenter(fixedPolygon, {
            aspectRatio: aspectRatio,
            precision: 1e-3
        });
        if (labelPlacement == null) return;
        const { x: x, y: y, maxWidth: maxWidth } = labelPlacement;
        return {
            geometry: geometry,
            labelText: labelText,
            aspectRatio: aspectRatio,
            x: x,
            y: y,
            maxWidth: maxWidth,
            fixedPolygon: fixedPolygon
        };
    }
    getLabelDatum(labelLayout, scaling) {
        const { scale: scale } = this;
        if (scale == null) return;
        const { padding: padding, label: label } = this.properties;
        const { labelText: labelText, aspectRatio: aspectRatio, x: untruncatedX, y: y, maxWidth: maxWidth, fixedPolygon: fixedPolygon } = labelLayout;
        const maxSizeWithoutTruncation = {
            width: Math.ceil(maxWidth * scaling),
            height: Math.ceil(maxWidth * scaling / aspectRatio),
            meta: untruncatedX
        };
        const labelFormatting = $2fb96651e8aa1522$var$formatSingleLabel(labelText, label, {
            padding: padding
        }, (height, allowTruncation)=>{
            if (!allowTruncation) return maxSizeWithoutTruncation;
            const result = $2fb96651e8aa1522$var$maxWidthInPolygonForRectOfHeight(fixedPolygon, untruncatedX, y, height / scaling);
            return {
                width: result.width * scaling,
                height: height,
                meta: result.x
            };
        });
        if (labelFormatting == null) return;
        const [{ text: text2, fontSize: fontSize, lineHeight: lineHeight, width: width }, formattingX] = labelFormatting;
        if (text2 === $2fb96651e8aa1522$var$TextUtils6.EllipsisChar) return;
        const x = width < maxSizeWithoutTruncation.width ? untruncatedX : formattingX;
        const position = this.scale.convert($2fb96651e8aa1522$var$fixedScale.invert([
            x,
            y
        ]));
        return {
            x: position[0],
            y: position[1],
            text: text2,
            fontSize: fontSize,
            lineHeight: lineHeight
        };
    }
    createNodeData() {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, properties: properties, scale: scale, previousLabelLayouts: previousLabelLayouts } = this;
        const { idKey: idKey, colorKey: colorKey, labelKey: labelKey, label: label } = properties;
        if (dataModel == null || processedData == null) return;
        const scaling = scale != null ? (scale.range[1][0] - scale.range[0][0]) / scale.bounds.width : NaN;
        const idValues = dataModel.resolveColumnById(this, `idValue`, processedData);
        const featureValues = dataModel.resolveColumnById(this, `featureValue`, processedData);
        const labelValues = labelKey != null ? dataModel.resolveColumnById(this, `labelValue`, processedData) : void 0;
        const colorValues = colorKey != null ? dataModel.resolveColumnById(this, `colorValue`, processedData) : void 0;
        const font2 = label.getFont();
        const labelLayouts = /* @__PURE__ */ new Map();
        this.previousLabelLayouts = labelLayouts;
        const nodeData = [];
        const labelData = [];
        const missingGeometries = [];
        const rawData = processedData.dataSources.get(this.id) ?? [];
        rawData.forEach((datum, datumIndex)=>{
            const idValue = idValues[datumIndex];
            const colorValue = colorValues?.[datumIndex];
            const labelValue = labelValues?.[datumIndex];
            const geometry = featureValues[datumIndex]?.geometry ?? void 0;
            if (geometry == null) missingGeometries.push(idValue);
            const labelLayout = this.getLabelLayout(datum, labelValue, font2, geometry, previousLabelLayouts?.get(idValue));
            if (labelLayout != null) labelLayouts.set(idValue, labelLayout);
            const labelDatum = labelLayout != null && scale != null ? this.getLabelDatum(labelLayout, scaling) : void 0;
            if (labelDatum != null) labelData.push(labelDatum);
            const projectedGeometry = geometry != null && scale != null ? $2fb96651e8aa1522$var$projectGeometry(geometry, scale) : void 0;
            nodeData.push({
                series: this,
                itemId: idKey,
                datum: datum,
                datumIndex: datumIndex,
                idValue: idValue,
                colorValue: colorValue,
                labelValue: labelValue,
                projectedGeometry: projectedGeometry
            });
        });
        const missingGeometriesCap = 10;
        if (missingGeometries.length > missingGeometriesCap) {
            const excessItems = missingGeometries.length - missingGeometriesCap;
            missingGeometries.length = missingGeometriesCap;
            missingGeometries.push(`(+${excessItems} more)`);
        }
        if (missingGeometries.length > 0) (0, $idDdm.Logger).warnOnce(`some data items do not have matches in the provided topology`, missingGeometries);
        return {
            itemId: seriesId,
            nodeData: nodeData,
            labelData: labelData
        };
    }
    updateSelections() {
        if (this.nodeDataRefresh) {
            this.contextNodeData = this.createNodeData();
            this.nodeDataRefresh = false;
        }
    }
    update() {
        const { datumSelection: datumSelection, labelSelection: labelSelection, highlightDatumSelection: highlightDatumSelection } = this;
        this.updateSelections();
        this.contentGroup.visible = this.visible;
        this.contentGroup.opacity = this.getOpacity();
        let highlightedDatum = this.ctx.highlightManager?.getActiveHighlight();
        if (highlightedDatum != null && (highlightedDatum.series !== this || highlightedDatum.datum == null)) highlightedDatum = void 0;
        const nodeData = this.contextNodeData?.nodeData ?? [];
        const labelData = this.contextNodeData?.labelData ?? [];
        this.datumSelection = this.updateDatumSelection({
            nodeData: nodeData,
            datumSelection: datumSelection
        });
        this.updateDatumNodes({
            datumSelection: datumSelection,
            isHighlight: false
        });
        this.labelSelection = this.updateLabelSelection({
            labelData: labelData,
            labelSelection: labelSelection
        });
        this.updateLabelNodes({
            labelSelection: labelSelection
        });
        this.highlightDatumSelection = this.updateDatumSelection({
            nodeData: highlightedDatum != null ? [
                highlightedDatum
            ] : [],
            datumSelection: highlightDatumSelection
        });
        this.updateDatumNodes({
            datumSelection: highlightDatumSelection,
            isHighlight: true
        });
    }
    updateDatumSelection(opts) {
        return opts.datumSelection.update(opts.nodeData, void 0, (datum)=>$2fb96651e8aa1522$var$createDatumId16(datum.idValue));
    }
    getItemBaseStyle(highlighted) {
        const { properties: properties } = this;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return $2fb96651e8aa1522$var$getShapeStyle11({
            fill: highlightStyle?.fill ?? properties.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? properties.fillOpacity,
            stroke: highlightStyle?.stroke ?? properties.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(properties.strokeWidth),
            strokeOpacity: highlightStyle?.strokeOpacity ?? properties.strokeOpacity,
            lineDash: highlightStyle?.lineDash ?? properties.lineDash,
            lineDashOffset: highlightStyle?.lineDashOffset ?? properties.lineDashOffset
        }, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
    }
    getItemStyleOverrides(datumId, datum, colorValue, format, highlighted) {
        const { id: seriesId, properties: properties, colorScale: colorScale } = this;
        const { colorRange: colorRange, itemStyler: itemStyler } = properties;
        let overrides;
        if (!highlighted && colorValue != null) {
            overrides ?? (overrides = {});
            overrides.fill = this.isColorScaleValid() ? colorScale.convert(colorValue) : colorRange?.[0] ?? properties.fill;
        }
        if (itemStyler != null) {
            const itemStyle = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId16(datumId, highlighted ? "highlight" : "node"), ()=>{
                return this.callWithContext(itemStyler, {
                    seriesId: seriesId,
                    datum: datum,
                    highlighted: highlighted,
                    ...format,
                    ...overrides
                });
            });
            overrides ?? (overrides = {});
            Object.assign(overrides, itemStyle);
        }
        return $2fb96651e8aa1522$var$getShapeStyle11(overrides, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
    }
    updateDatumNodes(opts) {
        const { datumSelection: datumSelection, isHighlight: isHighlight } = opts;
        const style = this.getItemBaseStyle(isHighlight);
        const fillBBox = $2fb96651e8aa1522$var$getTopologyShapeFillBBox(this.scale);
        datumSelection.each((geoGeometry, nodeDatum)=>{
            const { datum: datum, datumIndex: datumIndex, colorValue: colorValue, projectedGeometry: projectedGeometry } = nodeDatum;
            if (projectedGeometry == null) {
                geoGeometry.visible = false;
                geoGeometry.projectedGeometry = void 0;
                return;
            }
            const overrides = this.getItemStyleOverrides(String(datumIndex), datum, colorValue, style, isHighlight);
            geoGeometry.visible = true;
            geoGeometry.projectedGeometry = projectedGeometry;
            $2fb96651e8aa1522$var$applyShapeStyle10(geoGeometry, style, overrides, fillBBox);
        });
    }
    updateLabelSelection(opts) {
        const labels = this.isLabelEnabled() ? opts.labelData : [];
        return opts.labelSelection.update(labels);
    }
    updateLabelNodes(opts) {
        const { labelSelection: labelSelection } = opts;
        const { color: fill, fontStyle: fontStyle, fontWeight: fontWeight, fontFamily: fontFamily } = this.properties.label;
        labelSelection.each((label, { x: x, y: y, text: text2, fontSize: fontSize, lineHeight: lineHeight })=>{
            label.visible = true;
            label.x = x;
            label.y = y;
            label.text = text2;
            label.fill = fill;
            label.fontStyle = fontStyle;
            label.fontWeight = fontWeight;
            label.fontSize = fontSize;
            label.lineHeight = lineHeight;
            label.fontFamily = fontFamily;
            label.textAlign = "center";
            label.textBaseline = "middle";
        });
    }
    resetAnimation() {}
    pickNodeClosestDatum({ x: x, y: y }) {
        let minDistanceSquared = Infinity;
        let minDatum;
        this.datumSelection.each((node, datum)=>{
            const distanceSquared = node.distanceSquared(x, y);
            if (distanceSquared < minDistanceSquared) {
                minDistanceSquared = distanceSquared;
                minDatum = datum;
            }
        });
        return minDatum != null ? {
            datum: minDatum,
            distance: Math.sqrt(minDistanceSquared)
        } : void 0;
    }
    datumMidPoint(datum) {
        const { _previousDatumMidPoint: _previousDatumMidPoint } = this;
        if (_previousDatumMidPoint?.datum === datum) return _previousDatumMidPoint.point;
        const projectedGeometry = datum.projectedGeometry;
        const polygon = projectedGeometry != null ? $2fb96651e8aa1522$var$largestPolygon(projectedGeometry) : void 0;
        const center = polygon != null ? $2fb96651e8aa1522$var$polygonMarkerCenter(polygon, 2) : void 0;
        const point = center != null ? {
            x: center[0],
            y: center[1]
        } : void 0;
        this._previousDatumMidPoint = {
            datum: datum,
            point: point
        };
        return point;
    }
    legendItemSymbol(datumIndex) {
        const { dataModel: dataModel, processedData: processedData, properties: properties } = this;
        const { fillOpacity: fillOpacity, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = properties;
        let { fill: fill } = properties;
        if (datumIndex != null && this.isColorScaleValid()) {
            const colorValues = dataModel.resolveColumnById(this, "colorValue", processedData);
            const colorValue = colorValues[datumIndex];
            fill = this.colorScale.convert(colorValue);
        }
        return {
            marker: $2fb96651e8aa1522$var$getShapeStyle11({
                fill: fill,
                fillOpacity: fillOpacity,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                strokeOpacity: strokeOpacity,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset
            }, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults)
        };
    }
    getLegendData(legendType) {
        const { processedData: processedData, dataModel: dataModel } = this;
        if (processedData == null || dataModel == null) return [];
        const { id: seriesId, visible: visible } = this;
        const { title: title, legendItemName: legendItemName, idKey: idKey, idName: idName, colorKey: colorKey, colorName: colorName, colorRange: colorRange, showInLegend: showInLegend } = this.properties;
        if (legendType === "gradient" && colorKey != null && colorRange != null) {
            const colorDomain = processedData.domain.values[dataModel.resolveProcessedDataIndexById(this, "colorValue")];
            const legendDatum = {
                legendType: "gradient",
                enabled: visible,
                seriesId: seriesId,
                colorName: colorName,
                colorRange: colorRange,
                colorDomain: colorDomain
            };
            return [
                legendDatum
            ];
        } else if (legendType === "category") {
            const legendDatum = {
                legendType: "category",
                id: seriesId,
                itemId: seriesId,
                seriesId: seriesId,
                enabled: visible,
                label: {
                    text: legendItemName ?? title ?? idName ?? idKey
                },
                symbol: this.legendItemSymbol(),
                legendItemName: legendItemName,
                hideInLegend: !showInLegend
            };
            return [
                legendDatum
            ];
        } else return [];
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, properties: properties } = this;
        const { idKey: idKey, idName: idName, colorKey: colorKey, colorName: colorName, labelKey: labelKey, labelName: labelName, legendItemName: legendItemName, title: title, tooltip: tooltip } = properties;
        if (!dataModel || !processedData) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const idValue = dataModel.resolveColumnById(this, `idValue`, processedData)[datumIndex];
        const colorValue = colorKey != null ? dataModel.resolveColumnById(this, `colorValue`, processedData)[datumIndex] : void 0;
        const data = [];
        if (colorValue != null) data.push({
            label: colorName,
            fallbackLabel: colorKey,
            value: String(colorValue)
        });
        if (labelKey != null && labelKey !== idKey) {
            const labelValue = dataModel.resolveColumnById(this, `labelValue`, processedData)[datumIndex];
            data.push({
                label: labelName,
                fallbackLabel: labelKey,
                value: labelValue
            });
        }
        const format = this.getItemBaseStyle(false);
        Object.assign(format, this.getItemStyleOverrides(String(datumIndex), datumIndex, colorValue, format, false));
        return this.formatTooltipWithContext(tooltip, {
            heading: idValue,
            title: title ?? legendItemName,
            symbol: this.legendItemSymbol(datumIndex),
            data: data
        }, {
            seriesId: seriesId,
            datum: datum,
            title: title,
            idKey: idKey,
            idName: idName,
            colorKey: colorKey,
            colorName: colorName,
            labelKey: labelKey,
            labelName: labelName,
            ...format
        });
    }
    computeFocusBounds(opts) {
        return $2fb96651e8aa1522$var$findFocusedGeoGeometry(this, opts);
    }
};
$2fb96651e8aa1522$var$MapShapeSeries.className = "MapShapeSeries";
$2fb96651e8aa1522$var$MapShapeSeries.type = "map-shape";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs13, mapShapeSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$mapShapeSeriesThemeableOptionsDef, without: $2fb96651e8aa1522$var$without4 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$mapShapeSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$mapShapeSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$without4($2fb96651e8aa1522$var$commonSeriesOptionsDefs13, [
        "highlightStyle"
    ]),
    type: (0, $idDdm.required)((0, $idDdm.constant)("map-shape")),
    idKey: (0, $idDdm.required)((0, $idDdm.string)),
    colorKey: (0, $idDdm.string),
    labelKey: (0, $idDdm.string),
    idName: (0, $idDdm.string),
    colorName: (0, $idDdm.string),
    labelName: (0, $idDdm.string),
    topology: (0, $idDdm.geoJson),
    topologyIdKey: (0, $idDdm.string),
    legendItemName: (0, $idDdm.string),
    title: (0, $idDdm.string)
};
// packages/ag-charts-enterprise/src/series/map-shape/mapShapeModule.ts
var $2fb96651e8aa1522$var$MapShapeModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "topology"
    ],
    identifier: "map-shape",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$MapShapeSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    themeTemplate: {
        ...$2fb96651e8aa1522$var$MAP_THEME_DEFAULTS,
        series: {
            fill: {
                $palette: "fill"
            },
            stroke: {
                $ref: "backgroundColor"
            },
            colorRange: {
                $if: [
                    {
                        $eq: [
                            {
                                $palette: "type"
                            },
                            "inbuilt"
                        ]
                    },
                    {
                        $palette: "divergingColors"
                    },
                    (0, $iTJTu._ModuleSupport).SAFE_RANGE2_OPERATION
                ]
            },
            // @ts-expect-error undocumented option
            fillGradientDefaults: {
                type: "gradient",
                gradient: "linear",
                bounds: "item",
                colorStops: {
                    $palette: "gradient"
                },
                rotation: 0,
                reverse: false
            },
            fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
            fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
            fillOpacity: 1,
            strokeWidth: 1,
            lineDash: [
                0
            ],
            lineDashOffset: 0,
            padding: 2,
            label: {
                color: {
                    $ref: "backgroundColor"
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontSize: {
                    $ref: "fontSize"
                },
                fontWeight: "bold",
                overflowStrategy: "hide"
            }
        },
        tooltip: {
            range: "exact"
        }
    }
};
var $2fb96651e8aa1522$var$MapShapeSeriesModule = {
    type: "series",
    name: "map-shape",
    chartType: "topology",
    enterprise: true,
    options: $2fb96651e8aa1522$var$mapShapeSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$MapShapeSeries(ctx)
};
var { FillGradientDefaults: $2fb96651e8aa1522$var$FillGradientDefaults11, FillPatternDefaults: $2fb96651e8aa1522$var$FillPatternDefaults11, FillImageDefaults: $2fb96651e8aa1522$var$FillImageDefaults11, Property: $2fb96651e8aa1522$var$Property74, SeriesProperties: $2fb96651e8aa1522$var$SeriesProperties7, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip16 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$MapShapeBackgroundSeriesProperties = class extends $2fb96651e8aa1522$var$SeriesProperties7 {
    constructor(){
        super(...arguments);
        this.topology = void 0;
        this.fill = "black";
        this.fillGradientDefaults = new $2fb96651e8aa1522$var$FillGradientDefaults11();
        this.fillPatternDefaults = new $2fb96651e8aa1522$var$FillPatternDefaults11();
        this.fillImageDefaults = new $2fb96651e8aa1522$var$FillImageDefaults11();
        this.fillOpacity = 1;
        this.stroke = "black";
        this.strokeOpacity = 1;
        this.strokeWidth = 0;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip16();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property74
], $2fb96651e8aa1522$var$MapShapeBackgroundSeriesProperties.prototype, "topology", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property74
], $2fb96651e8aa1522$var$MapShapeBackgroundSeriesProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property74
], $2fb96651e8aa1522$var$MapShapeBackgroundSeriesProperties.prototype, "fillGradientDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property74
], $2fb96651e8aa1522$var$MapShapeBackgroundSeriesProperties.prototype, "fillPatternDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property74
], $2fb96651e8aa1522$var$MapShapeBackgroundSeriesProperties.prototype, "fillImageDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property74
], $2fb96651e8aa1522$var$MapShapeBackgroundSeriesProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property74
], $2fb96651e8aa1522$var$MapShapeBackgroundSeriesProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property74
], $2fb96651e8aa1522$var$MapShapeBackgroundSeriesProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property74
], $2fb96651e8aa1522$var$MapShapeBackgroundSeriesProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property74
], $2fb96651e8aa1522$var$MapShapeBackgroundSeriesProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property74
], $2fb96651e8aa1522$var$MapShapeBackgroundSeriesProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property74
], $2fb96651e8aa1522$var$MapShapeBackgroundSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-enterprise/src/series/map-shape-background/mapShapeBackgroundSeries.ts
var { createDatumId: $2fb96651e8aa1522$var$createDatumId17, SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode13, Selection: $2fb96651e8aa1522$var$Selection12, Group: $2fb96651e8aa1522$var$Group16, PointerEvents: $2fb96651e8aa1522$var$PointerEvents8, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle12 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$MapShapeBackgroundSeries = class extends $2fb96651e8aa1522$var$TopologySeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            categoryKey: void 0,
            useLabelLayer: true,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode13.EXACT_SHAPE_MATCH
            ]
        });
        this.properties = new $2fb96651e8aa1522$var$MapShapeBackgroundSeriesProperties();
        this._chartTopology = void 0;
        this.itemGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group16({
            name: "itemGroup"
        }));
        this.datumSelection = $2fb96651e8aa1522$var$Selection12.select(this.itemGroup, ()=>this.nodeFactory());
    }
    get topology() {
        return this.properties.topology ?? this._chartTopology;
    }
    get focusable() {
        return false;
    }
    setOptionsData() {}
    setChartData() {}
    getNodeData() {
        return;
    }
    get hasData() {
        return false;
    }
    renderToOffscreenCanvas() {
        return true;
    }
    setChartTopology(topology) {
        this._chartTopology = topology;
        if (this.topology === topology) this.nodeDataRefresh = true;
    }
    setSeriesIndex(index) {
        if (!super.setSeriesIndex(index)) return false;
        this.contentGroup.zIndex = [
            0 /* ShapeLineBackground */ ,
            index,
            0
        ];
        this.highlightGroup.zIndex = [
            0 /* ShapeLineBackground */ ,
            index,
            1
        ];
        return true;
    }
    nodeFactory() {
        const geoGeometry = new $2fb96651e8aa1522$var$GeoGeometry();
        geoGeometry.renderMode = 1 /* Polygons */ ;
        geoGeometry.lineJoin = "round";
        geoGeometry.pointerEvents = $2fb96651e8aa1522$var$PointerEvents8.None;
        return geoGeometry;
    }
    processData() {
        const { topology: topology } = this;
        this.topologyBounds = topology?.features.reduce((current, feature)=>{
            const geometry = feature.geometry;
            if (geometry == null) return current;
            return $2fb96651e8aa1522$var$geometryBbox(geometry, current);
        }, void 0);
        if (topology == null) (0, $idDdm.Logger).warnOnce(`no topology was provided for [MapShapeBackgroundSeries]; nothing will be rendered.`);
    }
    createNodeData() {
        const { id: seriesId, topology: topology, scale: scale } = this;
        if (topology == null) return;
        const nodeData = [];
        const labelData = [];
        topology.features.forEach((feature, index)=>{
            const { geometry: geometry } = feature;
            const projectedGeometry = geometry != null && scale != null ? $2fb96651e8aa1522$var$projectGeometry(geometry, scale) : void 0;
            if (projectedGeometry == null) return;
            nodeData.push({
                series: this,
                itemId: index,
                datum: feature,
                datumIndex: 0,
                index: index,
                projectedGeometry: projectedGeometry
            });
        });
        return {
            itemId: seriesId,
            nodeData: nodeData,
            labelData: labelData
        };
    }
    updateSelections() {
        if (this.nodeDataRefresh) {
            this.contextNodeData = this.createNodeData();
            this.nodeDataRefresh = false;
        }
    }
    update() {
        const { datumSelection: datumSelection } = this;
        this.updateSelections();
        this.contentGroup.visible = this.visible;
        const { nodeData: nodeData = [] } = this.contextNodeData ?? {};
        this.datumSelection = this.updateDatumSelection({
            nodeData: nodeData,
            datumSelection: datumSelection
        });
        this.updateDatumNodes({
            datumSelection: datumSelection
        });
    }
    updateDatumSelection(opts) {
        return opts.datumSelection.update(opts.nodeData, void 0, (datum)=>$2fb96651e8aa1522$var$createDatumId17(datum.index));
    }
    updateDatumNodes(opts) {
        const { properties: properties } = this;
        const { datumSelection: datumSelection } = opts;
        const { fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = properties;
        const strokeWidth = this.getStrokeWidth(properties.strokeWidth);
        datumSelection.each((geoGeometry, datum)=>{
            const { projectedGeometry: projectedGeometry } = datum;
            if (projectedGeometry == null) {
                geoGeometry.visible = false;
                geoGeometry.projectedGeometry = void 0;
                return;
            }
            geoGeometry.visible = true;
            geoGeometry.projectedGeometry = projectedGeometry;
            const styles = $2fb96651e8aa1522$var$getShapeStyle12({
                fill: fill,
                fillOpacity: fillOpacity,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                strokeOpacity: strokeOpacity,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset
            }, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
            geoGeometry.setProperties(styles);
        });
    }
    resetAnimation() {}
    getLegendData() {
        return [];
    }
    getTooltipContent(_seriesDatum) {
        return;
    }
    pickFocus() {
        return void 0;
    }
    computeFocusBounds(_opts) {
        return void 0;
    }
};
$2fb96651e8aa1522$var$MapShapeBackgroundSeries.className = "MapShapeBackgroundSeries";
$2fb96651e8aa1522$var$MapShapeBackgroundSeries.type = "map-shape-background";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs14, mapShapeBackgroundSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$mapShapeBackgroundSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$mapShapeBackgroundSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$mapShapeBackgroundSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs14,
    type: (0, $idDdm.required)((0, $idDdm.constant)("map-shape-background")),
    topology: (0, $idDdm.geoJson)
};
// packages/ag-charts-enterprise/src/series/map-shape-background/mapShapeBackgroundModule.ts
var $2fb96651e8aa1522$var$MapShapeBackgroundModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "topology"
    ],
    identifier: "map-shape-background",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$MapShapeBackgroundSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    themeTemplate: {
        ...$2fb96651e8aa1522$var$MAP_THEME_DEFAULTS,
        series: {
            fill: {
                $path: [
                    "./1",
                    {
                        $palette: "fill"
                    },
                    {
                        $palette: "hierarchyColors"
                    }
                ]
            },
            // TODO: mix backgroundColor and foregroundColor?
            stroke: {
                $ref: "backgroundColor"
            },
            strokeWidth: 1,
            // @ts-expect-error undocumented-option
            fillGradientDefaults: {
                type: "gradient",
                gradient: "linear",
                bounds: "item",
                colorStops: [
                    {
                        $mix: [
                            {
                                $path: [
                                    "./1",
                                    {
                                        $palette: "fill"
                                    },
                                    {
                                        $palette: "hierarchyColors"
                                    }
                                ]
                            },
                            "black",
                            0.15
                        ]
                    },
                    {
                        $mix: [
                            {
                                $path: [
                                    "./1",
                                    {
                                        $palette: "fill"
                                    },
                                    {
                                        $palette: "hierarchyColors"
                                    }
                                ]
                            },
                            "white",
                            0.15
                        ]
                    }
                ],
                rotation: 0,
                reverse: false
            },
            fillPatternDefaults: {
                ...(0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
                fill: {
                    $path: [
                        "./1",
                        {
                            $palette: "fill"
                        },
                        {
                            $palette: "hierarchyColors"
                        }
                    ]
                },
                stroke: {
                    $path: [
                        "./1",
                        {
                            $palette: "fill"
                        },
                        {
                            $palette: "hierarchyColors"
                        }
                    ]
                }
            },
            fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS
        }
    }
};
var $2fb96651e8aa1522$var$MapShapeBackgroundSeriesModule = {
    type: "series",
    name: "map-shape-background",
    chartType: "topology",
    enterprise: true,
    options: $2fb96651e8aa1522$var$mapShapeBackgroundSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$MapShapeBackgroundSeries(ctx)
};
var { ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection26, PolarAxis: $2fb96651e8aa1522$var$PolarAxis, diff: $2fb96651e8aa1522$var$diff6, fixNumericExtent: $2fb96651e8aa1522$var$fixNumericExtent8, groupAccumulativeValueProperty: $2fb96651e8aa1522$var$groupAccumulativeValueProperty2, keyProperty: $2fb96651e8aa1522$var$keyProperty9, normaliseGroupTo: $2fb96651e8aa1522$var$normaliseGroupTo, resetLabelFn: $2fb96651e8aa1522$var$resetLabelFn5, seriesLabelFadeInAnimation: $2fb96651e8aa1522$var$seriesLabelFadeInAnimation5, seriesLabelFadeOutAnimation: $2fb96651e8aa1522$var$seriesLabelFadeOutAnimation, valueProperty: $2fb96651e8aa1522$var$valueProperty15, animationValidation: $2fb96651e8aa1522$var$animationValidation7, createDatumId: $2fb96651e8aa1522$var$createDatumId18, SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode14, normalizeAngle360: $2fb96651e8aa1522$var$normalizeAngle3605, CategoryScale: $2fb96651e8aa1522$var$CategoryScale3, motion: $2fb96651e8aa1522$var$motion6, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle11, isGradientFill: $2fb96651e8aa1522$var$isGradientFill3, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle13 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadialColumnSeriesNodeEvent = class extends (0, $iTJTu._ModuleSupport).SeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.angleKey = series.properties.angleKey;
        this.radiusKey = series.properties.radiusKey;
    }
};
var $2fb96651e8aa1522$var$RadialColumnSeriesBase = class extends (0, $iTJTu._ModuleSupport).PolarSeries {
    constructor(moduleCtx, { animationResetFns: animationResetFns }){
        super({
            moduleCtx: moduleCtx,
            categoryKey: "angleValue",
            useLabelLayer: true,
            canHaveAxes: true,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode14.NEAREST_NODE,
                $2fb96651e8aa1522$var$SeriesNodePickMode14.EXACT_SHAPE_MATCH
            ],
            animationResetFns: {
                ...animationResetFns,
                label: $2fb96651e8aa1522$var$resetLabelFn5
            }
        });
        this.NodeEvent = $2fb96651e8aa1522$var$RadialColumnSeriesNodeEvent;
        this.groupScale = new $2fb96651e8aa1522$var$CategoryScale3();
        this.circleCache = {
            r: 0,
            cx: 0,
            cy: 0
        };
    }
    getSeriesDomain(direction) {
        const { dataModel: dataModel, processedData: processedData } = this;
        if (!processedData || !dataModel) return [];
        if (direction === $2fb96651e8aa1522$var$ChartAxisDirection26.Angle) return dataModel.getDomain(this, "angleValue", "key", processedData);
        else {
            const yExtent = dataModel.getDomain(this, "radiusValue-end", "value", processedData);
            const fixedYExtent = Number.isFinite(yExtent[1] - yExtent[0]) ? [
                yExtent[0] > 0 ? 0 : yExtent[0],
                yExtent[1] < 0 ? 0 : yExtent[1]
            ] : [];
            return $2fb96651e8aa1522$var$fixNumericExtent8(fixedYExtent);
        }
    }
    async processData(dataController) {
        const { angleKey: angleKey, radiusKey: radiusKey, normalizedTo: normalizedTo } = this.properties;
        const animationEnabled = !this.ctx.animationManager.isSkipped();
        const stackGroupId = this.getStackId();
        const stackGroupTrailingId = `${stackGroupId}-trailing`;
        const extraProps = [];
        if ((0, $idDdm.isDefined)(normalizedTo)) extraProps.push($2fb96651e8aa1522$var$normaliseGroupTo([
            stackGroupId,
            stackGroupTrailingId
        ], Math.abs(normalizedTo)));
        if (animationEnabled && this.processedData) extraProps.push($2fb96651e8aa1522$var$diff6(this.id, this.processedData));
        if (animationEnabled) extraProps.push($2fb96651e8aa1522$var$animationValidation7());
        const visibleProps = this.visible ? {} : {
            forceValue: 0
        };
        const radiusScaleType = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection26.Radius]?.scale.type;
        const angleScaleType = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection26.Angle]?.scale.type;
        await this.requestDataModel(dataController, this.data, {
            props: [
                $2fb96651e8aa1522$var$keyProperty9(angleKey, angleScaleType, {
                    id: "angleValue"
                }),
                $2fb96651e8aa1522$var$valueProperty15(radiusKey, radiusScaleType, {
                    id: "radiusValue-raw",
                    invalidValue: null,
                    ...visibleProps
                }),
                ...$2fb96651e8aa1522$var$groupAccumulativeValueProperty2(radiusKey, "normal", "current", {
                    id: `radiusValue-end`,
                    rangeId: `radiusValue-range`,
                    invalidValue: null,
                    groupId: stackGroupId,
                    separateNegative: true,
                    ...visibleProps
                }, radiusScaleType),
                ...$2fb96651e8aa1522$var$groupAccumulativeValueProperty2(radiusKey, "trailing", "current", {
                    id: `radiusValue-start`,
                    invalidValue: null,
                    groupId: stackGroupTrailingId,
                    separateNegative: true,
                    ...visibleProps
                }, radiusScaleType),
                ...extraProps
            ],
            groupByKeys: true,
            groupByData: false
        });
        this.animationState.transition("updateData");
    }
    didCircleChange() {
        const r = this.radius;
        const cx = this.centerX;
        const cy = this.centerY;
        const cache = this.circleCache;
        if (r !== cache.r || cx !== cache.cx || cy !== cache.cy) {
            this.circleCache = {
                r: r,
                cx: cx,
                cy: cy
            };
            return true;
        }
        return false;
    }
    isRadiusAxisReversed() {
        return this.axes[$2fb96651e8aa1522$var$ChartAxisDirection26.Radius]?.isReversed();
    }
    maybeRefreshNodeData() {
        const circleChanged = this.didCircleChange();
        if (!circleChanged && !this.nodeDataRefresh) return;
        const { nodeData: nodeData = [] } = this.createNodeData() ?? {};
        this.nodeData = nodeData;
        this.nodeDataRefresh = false;
    }
    getAxisInnerRadius() {
        const radiusAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection26.Radius];
        return radiusAxis instanceof $2fb96651e8aa1522$var$PolarAxis ? this.radius * radiusAxis.innerRadiusRatio : 0;
    }
    createNodeData() {
        const { processedData: processedData, dataModel: dataModel, groupScale: groupScale } = this;
        if (!dataModel || !processedData || processedData.type !== "grouped") return;
        const angleAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection26.Angle];
        const radiusAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection26.Radius];
        const angleScale = angleAxis?.scale;
        const radiusScale = radiusAxis?.scale;
        if (!angleScale || !radiusScale) return;
        const angleValues = dataModel.resolveKeysById(this, `angleValue`, processedData);
        const radiusStartValues = dataModel.resolveColumnById(this, `radiusValue-start`, processedData);
        const radiusEndValues = dataModel.resolveColumnById(this, `radiusValue-end`, processedData);
        const radiusRawValues = dataModel.resolveColumnById(this, `radiusValue-raw`, processedData);
        const radiusRangeIndex = dataModel.resolveProcessedDataIndexById(this, `radiusValue-range`);
        let groupPaddingInner = 0;
        let groupPaddingOuter = 0;
        if (angleAxis instanceof $2fb96651e8aa1522$var$AngleCategoryAxis) {
            groupPaddingInner = angleAxis.groupPaddingInner;
            groupPaddingOuter = angleAxis.paddingInner;
        }
        const groupAngleStep = angleScale.bandwidth ?? 0;
        const paddedGroupAngleStep = groupAngleStep * (1 - groupPaddingOuter);
        const { index: groupIndex, visibleGroupCount: visibleGroupCount } = this.ctx.seriesStateManager.getVisiblePeerGroupIndex(this);
        groupScale.domain = Array.from({
            length: visibleGroupCount
        }).map((_, i)=>String(i));
        groupScale.range = [
            -paddedGroupAngleStep / 2,
            paddedGroupAngleStep / 2
        ];
        groupScale.paddingInner = visibleGroupCount > 1 ? groupPaddingInner : 0;
        const radiusAxisReversed = this.isRadiusAxisReversed();
        const axisInnerRadius = radiusAxisReversed ? this.radius : this.getAxisInnerRadius();
        const axisOuterRadius = radiusAxisReversed ? this.getAxisInnerRadius() : this.radius;
        const axisTotalRadius = axisOuterRadius + axisInnerRadius;
        const { angleKey: angleKey, radiusKey: radiusKey, angleName: angleName, radiusName: radiusName, label: label } = this.properties;
        const getLabelNodeDatum = (datum, radiusDatum, x, y)=>{
            const labelText = this.getLabelText(label, {
                value: radiusDatum,
                datum: datum,
                angleKey: angleKey,
                radiusKey: radiusKey,
                angleName: angleName,
                radiusName: radiusName
            });
            if (labelText) return {
                x: x,
                y: y,
                text: labelText,
                textAlign: "center",
                textBaseline: "middle"
            };
        };
        const nodeData = [];
        const context = {
            itemId: radiusKey,
            nodeData: nodeData,
            labelData: nodeData
        };
        if (!this.visible) return context;
        const { dataSources: dataSources } = processedData;
        const rawData = dataSources.get(this.id) ?? [];
        for (const { datumIndex: datumIndex, group: group } of dataModel.forEachGroupDatum(this, processedData)){
            const datum = rawData[datumIndex];
            const angleDatum = angleValues[datumIndex];
            if (angleDatum == null) return;
            const radiusDatum = radiusRawValues[datumIndex];
            const isPositive = radiusDatum >= 0 && !Object.is(radiusDatum, -0);
            const innerRadiusDatum = radiusStartValues[datumIndex];
            const outerRadiusDatum = radiusEndValues[datumIndex];
            const radiusRange = group.aggregation[radiusRangeIndex][isPositive ? 1 : 0] ?? 0;
            const negative = isPositive === radiusAxisReversed;
            if (innerRadiusDatum === void 0 || outerRadiusDatum === void 0) return;
            let startAngle;
            let endAngle;
            if (rawData.length === 1) {
                startAngle = -0.5 * Math.PI;
                endAngle = 1.5 * Math.PI;
            } else {
                const groupAngle = angleScale.convert(angleDatum);
                startAngle = $2fb96651e8aa1522$var$normalizeAngle3605(groupAngle + groupScale.convert(String(groupIndex)));
                endAngle = $2fb96651e8aa1522$var$normalizeAngle3605(startAngle + groupScale.bandwidth);
            }
            const angle = startAngle + groupScale.bandwidth / 2;
            const innerRadius = axisTotalRadius - radiusScale.convert(innerRadiusDatum);
            const outerRadius = axisTotalRadius - radiusScale.convert(outerRadiusDatum);
            const midRadius = (innerRadius + outerRadius) / 2;
            const stackInnerRadius = axisTotalRadius - radiusScale.convert(0);
            const stackOuterRadius = axisTotalRadius - radiusScale.convert(radiusRange);
            const x = Math.cos(angle) * midRadius;
            const y = Math.sin(angle) * midRadius;
            const labelNodeDatum = this.properties.label.enabled ? getLabelNodeDatum(datum, radiusDatum, x, y) : void 0;
            const columnWidth = this.getColumnWidth(startAngle, endAngle);
            nodeData.push({
                series: this,
                datum: datum,
                datumIndex: datumIndex,
                point: {
                    x: x,
                    y: y,
                    size: 0
                },
                midPoint: {
                    x: x,
                    y: y
                },
                label: labelNodeDatum,
                angleValue: angleDatum,
                radiusValue: radiusDatum,
                negative: negative,
                innerRadius: innerRadius,
                outerRadius: outerRadius,
                stackInnerRadius: stackInnerRadius,
                stackOuterRadius: stackOuterRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                midAngle: angle,
                axisInnerRadius: axisInnerRadius,
                axisOuterRadius: axisOuterRadius,
                columnWidth: columnWidth,
                index: datumIndex
            });
        }
        return {
            itemId: radiusKey,
            nodeData: nodeData,
            labelData: nodeData
        };
    }
    getColumnWidth(_startAngle, _endAngle) {
        return NaN;
    }
    update({ seriesRect: seriesRect }) {
        const resize = this.checkResize(seriesRect);
        this.maybeRefreshNodeData();
        this.contentGroup.translationX = this.centerX;
        this.contentGroup.translationY = this.centerY;
        this.highlightGroup.translationX = this.centerX;
        this.highlightGroup.translationY = this.centerY;
        if (this.labelGroup) {
            this.labelGroup.translationX = this.centerX;
            this.labelGroup.translationY = this.centerY;
        }
        this.updateSectorSelection(this.itemSelection, false);
        this.updateSectorSelection(this.highlightSelection, true);
        this.updateLabels();
        if (resize) this.animationState.transition("resize");
        this.animationState.transition("update");
    }
    getItemBaseStyle(highlighted) {
        const { properties: properties } = this;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return $2fb96651e8aa1522$var$getShapeStyle13({
            fill: highlightStyle?.fill ?? properties.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? properties.fillOpacity,
            stroke: highlightStyle?.stroke ?? properties.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(properties.strokeWidth),
            strokeOpacity: highlightStyle?.strokeOpacity ?? properties.strokeOpacity,
            lineDash: highlightStyle?.lineDash ?? properties.lineDash,
            lineDashOffset: highlightStyle?.lineDashOffset ?? properties.lineDashOffset,
            cornerRadius: properties.cornerRadius
        }, properties.fillGradientDefaults, properties.fillPatternDefaults, properties.fillImageDefaults);
    }
    getItemStyleOverrides(datumId, datum, format, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const { angleKey: angleKey, radiusKey: radiusKey, itemStyler: itemStyler, fillGradientDefaults: fillGradientDefaults4, fillPatternDefaults: fillPatternDefaults4, fillImageDefaults: fillImageDefaults4 } = properties;
        if (itemStyler == null) return;
        const overrides = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId18(datumId, highlighted ? "highlight" : "node"), ()=>{
            return this.callWithContext(itemStyler, {
                seriesId: seriesId,
                datum: datum,
                highlighted: highlighted,
                angleKey: angleKey,
                radiusKey: radiusKey,
                ...format
            });
        });
        return $2fb96651e8aa1522$var$getShapeStyle13(overrides, fillGradientDefaults4, fillPatternDefaults4, fillImageDefaults4);
    }
    updateSectorSelection(selection, highlighted) {
        let selectionData = [];
        if (highlighted) {
            const activeHighlight = this.ctx.highlightManager?.getActiveHighlight();
            if (activeHighlight?.datum && activeHighlight.series === this) selectionData.push(activeHighlight);
        } else selectionData = this.nodeData;
        const radiusAxisReversed = this.isRadiusAxisReversed();
        const axisInnerRadius = radiusAxisReversed ? this.radius : this.getAxisInnerRadius();
        const axisOuterRadius = radiusAxisReversed ? this.getAxisInnerRadius() : this.radius;
        const fillBBox = this.getShapeFillBBox();
        const style = this.getItemBaseStyle(highlighted);
        selection.update(selectionData, void 0, (datum)=>this.getDatumId(datum)).each((node, nodeDatum)=>{
            const { datum: datum, datumIndex: datumIndex, midPoint: midPoint } = nodeDatum;
            const overrides = this.getItemStyleOverrides(String(datumIndex), datum, style, highlighted);
            const fill = overrides?.fill ?? style.fill;
            const itemBounds = $2fb96651e8aa1522$var$isGradientFill3(fill) && fill.bounds === "item";
            const fillParams = itemBounds ? {
                centerX: midPoint?.x ?? 0,
                centerY: midPoint?.y ?? 0
            } : {
                centerX: 0,
                centerY: 0,
                innerRadius: axisInnerRadius,
                outerRadius: axisOuterRadius
            };
            this.updateItemPath(node, nodeDatum, highlighted);
            $2fb96651e8aa1522$var$applyShapeStyle11(node, style, overrides, fillBBox, fillParams);
            node.cornerRadius = overrides?.cornerRadius ?? style.cornerRadius;
            node.lineJoin = "round";
        });
    }
    updateLabels() {
        const { label: label } = this.properties;
        this.labelSelection.update(this.nodeData).each((node, datum)=>{
            if (label.enabled && datum.label) {
                node.x = datum.label.x;
                node.y = datum.label.y;
                node.fill = label.color;
                node.fontFamily = label.fontFamily;
                node.fontSize = label.fontSize;
                node.fontStyle = label.fontStyle;
                node.fontWeight = label.fontWeight;
                node.text = datum.label.text;
                node.textAlign = datum.label.textAlign;
                node.textBaseline = datum.label.textBaseline;
                node.visible = true;
            } else node.visible = false;
        });
    }
    animateEmptyUpdateReady() {
        const { labelSelection: labelSelection } = this;
        const fns = this.getColumnTransitionFunctions();
        $2fb96651e8aa1522$var$motion6.fromToMotion(this.id, "datums", this.ctx.animationManager, [
            this.itemSelection
        ], fns);
        $2fb96651e8aa1522$var$seriesLabelFadeInAnimation5(this, "labels", this.ctx.animationManager, labelSelection);
    }
    animateClearingUpdateEmpty() {
        const { itemSelection: itemSelection } = this;
        const { animationManager: animationManager } = this.ctx;
        const fns = this.getColumnTransitionFunctions();
        $2fb96651e8aa1522$var$motion6.fromToMotion(this.id, "datums", animationManager, [
            itemSelection
        ], fns);
        $2fb96651e8aa1522$var$seriesLabelFadeOutAnimation(this, "labels", animationManager, this.labelSelection);
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, axes: axes, properties: properties } = this;
        const { angleKey: angleKey, angleName: angleName, radiusKey: radiusKey, radiusName: radiusName, tooltip: tooltip } = properties;
        const angleAxis = axes[$2fb96651e8aa1522$var$ChartAxisDirection26.Angle];
        const radiusAxis = axes[$2fb96651e8aa1522$var$ChartAxisDirection26.Radius];
        if (!dataModel || !processedData || !angleAxis || !radiusAxis) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const angleValue = dataModel.resolveKeysById(this, `angleValue`, processedData)[datumIndex];
        const radiusValue = dataModel.resolveColumnById(this, `radiusValue-raw`, processedData)[datumIndex];
        if (angleValue == null) return;
        const format = this.getItemBaseStyle(false);
        Object.assign(format, this.getItemStyleOverrides(String(datumIndex), datumIndex, format, false));
        return this.formatTooltipWithContext(tooltip, {
            heading: angleAxis.formatDatum(angleValue),
            symbol: this.legendItemSymbol(),
            data: [
                {
                    label: radiusName,
                    fallbackLabel: radiusKey,
                    value: radiusAxis.formatDatum(radiusValue)
                }
            ]
        }, {
            seriesId: seriesId,
            datum: datum,
            title: angleName,
            angleKey: angleKey,
            angleName: angleName,
            radiusKey: radiusKey,
            radiusName: radiusName,
            ...format
        });
    }
    pickNodeClosestDatum(point) {
        return this.pickNodeNearestDistantObject(point, this.itemSelection.nodes());
    }
    legendItemSymbol() {
        const { fill: fill, stroke: stroke2, fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset, fillGradientDefaults: fillGradientDefaults4, fillPatternDefaults: fillPatternDefaults4, fillImageDefaults: fillImageDefaults4 } = this.properties;
        const markerStyle = $2fb96651e8aa1522$var$getShapeStyle13({
            fill: fill ?? "rgba(0, 0, 0, 0)",
            stroke: stroke2 ?? "rgba(0, 0, 0, 0)",
            fillOpacity: fillOpacity,
            strokeOpacity: strokeOpacity,
            strokeWidth: strokeWidth,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset
        }, fillGradientDefaults4, fillPatternDefaults4, fillImageDefaults4);
        if ((0, $iTJTu._ModuleSupport).isGradientFill(markerStyle.fill)) markerStyle.fill = {
            ...markerStyle.fill,
            gradient: "linear",
            rotation: 0,
            reverse: false
        };
        return {
            marker: markerStyle
        };
    }
    getLegendData(legendType) {
        if (legendType !== "category") return [];
        const { id: seriesId, visible: visible } = this;
        const { radiusKey: radiusKey, radiusName: radiusName, showInLegend: showInLegend } = this.properties;
        return [
            {
                legendType: "category",
                id: seriesId,
                itemId: radiusKey,
                seriesId: seriesId,
                enabled: visible,
                label: {
                    text: radiusName ?? radiusKey
                },
                symbol: this.legendItemSymbol(),
                hideInLegend: !showInLegend
            }
        ];
    }
    getDatumId(datum) {
        return $2fb96651e8aa1522$var$createDatumId18(datum.angleValue);
    }
    computeLabelsBBox() {
        return null;
    }
};
var { SeriesProperties: $2fb96651e8aa1522$var$SeriesProperties8, FillGradientDefaults: $2fb96651e8aa1522$var$FillGradientDefaults12, FillPatternDefaults: $2fb96651e8aa1522$var$FillPatternDefaults12, FillImageDefaults: $2fb96651e8aa1522$var$FillImageDefaults12, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip17, Property: $2fb96651e8aa1522$var$Property75, Label: $2fb96651e8aa1522$var$Label12 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties = class extends $2fb96651e8aa1522$var$SeriesProperties8 {
    constructor(){
        super(...arguments);
        this.fill = "black";
        this.fillGradientDefaults = new $2fb96651e8aa1522$var$FillGradientDefaults12();
        this.fillPatternDefaults = new $2fb96651e8aa1522$var$FillPatternDefaults12();
        this.fillImageDefaults = new $2fb96651e8aa1522$var$FillImageDefaults12();
        this.fillOpacity = 1;
        this.stroke = "black";
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.cornerRadius = 0;
        this.rotation = 0;
        this.label = new $2fb96651e8aa1522$var$Label12();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip17();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "angleKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "angleName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "radiusKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "radiusName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "fillGradientDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "fillPatternDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "fillImageDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "cornerRadius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "itemStyler", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "rotation", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "stackGroup", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "normalizedTo", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property75
], $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties.prototype, "tooltip", 2);
var { motion: $2fb96651e8aa1522$var$motion7 } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$createAngleMotionCalculator() {
    const angles = {
        startAngle: /* @__PURE__ */ new Map(),
        endAngle: /* @__PURE__ */ new Map()
    };
    const angleKeys = [
        "startAngle",
        "endAngle"
    ];
    const calculate = (node, datum, status)=>{
        angleKeys.forEach((key)=>{
            const map = angles[key];
            let from2 = (status === "removed" || status === "updated" ? node : datum)[key];
            let to2 = (status === "removed" ? node : datum)[key];
            if (isNaN(to2)) to2 = node.previousDatum?.[key] ?? NaN;
            const diff8 = from2 - to2;
            if (Math.abs(diff8) > Math.PI) from2 -= Math.sign(diff8) * 2 * Math.PI;
            map.set(datum, {
                from: from2,
                to: to2
            });
        });
    };
    const getAngles = (datum, fromToKey)=>{
        return {
            startAngle: angles.startAngle.get(datum)[fromToKey],
            endAngle: angles.endAngle.get(datum)[fromToKey]
        };
    };
    const from = (datum)=>getAngles(datum, "from");
    const to = (datum)=>getAngles(datum, "to");
    return {
        calculate: calculate,
        from: from,
        to: to
    };
}
function $2fb96651e8aa1522$var$fixRadialColumnAnimationStatus(node, datum, status) {
    if (status === "updated") {
        if (node.previousDatum == null || isNaN(node.previousDatum.startAngle) || isNaN(node.previousDatum.endAngle)) return "added";
        if (isNaN(datum.startAngle) || isNaN(datum.endAngle)) return "removed";
    }
    if (status === "added" && node.previousDatum != null) return "updated";
    return status;
}
function $2fb96651e8aa1522$var$prepareRadialColumnAnimationFunctions(axisZeroRadius) {
    const angles = $2fb96651e8aa1522$var$createAngleMotionCalculator();
    const fromFn = (node, datum, status)=>{
        status = $2fb96651e8aa1522$var$fixRadialColumnAnimationStatus(node, datum, status);
        angles.calculate(node, datum, status);
        const { startAngle: startAngle, endAngle: endAngle } = angles.from(datum);
        let innerRadius;
        let outerRadius;
        let columnWidth;
        let axisInnerRadius;
        let axisOuterRadius;
        if (status === "removed" || status === "updated") {
            innerRadius = node.innerRadius;
            outerRadius = node.outerRadius;
            columnWidth = node.columnWidth;
            axisInnerRadius = node.axisInnerRadius;
            axisOuterRadius = node.axisOuterRadius;
        } else {
            innerRadius = axisZeroRadius;
            outerRadius = axisZeroRadius;
            columnWidth = datum.columnWidth;
            axisInnerRadius = datum.axisInnerRadius;
            axisOuterRadius = datum.axisOuterRadius;
        }
        const phase = $2fb96651e8aa1522$var$motion7.NODE_UPDATE_STATE_TO_PHASE_MAPPING[status];
        return {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            columnWidth: columnWidth,
            axisInnerRadius: axisInnerRadius,
            axisOuterRadius: axisOuterRadius,
            startAngle: startAngle,
            endAngle: endAngle,
            phase: phase
        };
    };
    const toFn = (node, datum, status)=>{
        const { startAngle: startAngle, endAngle: endAngle } = angles.to(datum);
        let innerRadius;
        let outerRadius;
        let columnWidth;
        let axisInnerRadius;
        let axisOuterRadius;
        if (status === "removed") {
            innerRadius = node.innerRadius;
            outerRadius = node.innerRadius;
            columnWidth = node.columnWidth;
            axisInnerRadius = node.axisInnerRadius;
            axisOuterRadius = node.axisOuterRadius;
        } else {
            innerRadius = isNaN(datum.innerRadius) ? axisZeroRadius : datum.innerRadius;
            outerRadius = isNaN(datum.outerRadius) ? axisZeroRadius : datum.outerRadius;
            columnWidth = isNaN(datum.columnWidth) ? node.columnWidth : datum.columnWidth;
            axisInnerRadius = datum.axisInnerRadius;
            axisOuterRadius = datum.axisOuterRadius;
        }
        return {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            columnWidth: columnWidth,
            axisInnerRadius: axisInnerRadius,
            axisOuterRadius: axisOuterRadius,
            startAngle: startAngle,
            endAngle: endAngle
        };
    };
    return {
        toFn: toFn,
        fromFn: fromFn
    };
}
function $2fb96651e8aa1522$var$resetRadialColumnSelectionFn(_node, { innerRadius: innerRadius, outerRadius: outerRadius, columnWidth: columnWidth, axisInnerRadius: axisInnerRadius, axisOuterRadius: axisOuterRadius, startAngle: startAngle, endAngle: endAngle }) {
    return {
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        columnWidth: columnWidth,
        axisInnerRadius: axisInnerRadius,
        axisOuterRadius: axisOuterRadius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}
// packages/ag-charts-enterprise/src/series/nightingale/nightingaleUtil.ts
var { SectorBox: $2fb96651e8aa1522$var$SectorBox, motion: $2fb96651e8aa1522$var$motion8 } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$getRadii(datum) {
    const { negative: negative, innerRadius: innerRadius, outerRadius: outerRadius, stackInnerRadius: stackInnerRadius, stackOuterRadius: stackOuterRadius } = datum;
    return {
        innerRadius: negative ? stackOuterRadius : stackInnerRadius,
        outerRadius: negative ? stackInnerRadius : stackOuterRadius,
        clipInnerRadius: negative ? outerRadius : innerRadius,
        clipOuterRadius: negative ? innerRadius : outerRadius
    };
}
function $2fb96651e8aa1522$var$prepareNightingaleAnimationFunctions(axisZeroRadius) {
    const angles = $2fb96651e8aa1522$var$createAngleMotionCalculator();
    const fromFn = (sect, datum, status)=>{
        status = $2fb96651e8aa1522$var$fixRadialColumnAnimationStatus(sect, datum, status);
        angles.calculate(sect, datum, status);
        const { startAngle: startAngle, endAngle: endAngle } = angles.from(datum);
        let innerRadius;
        let outerRadius;
        let clipSector;
        if (status === "removed" || status === "updated") {
            innerRadius = sect.innerRadius;
            outerRadius = sect.outerRadius;
            clipSector = sect.clipSector;
        } else {
            innerRadius = axisZeroRadius;
            outerRadius = axisZeroRadius;
        }
        clipSector ?? (clipSector = new $2fb96651e8aa1522$var$SectorBox(startAngle, endAngle, innerRadius, outerRadius));
        const phase = $2fb96651e8aa1522$var$motion8.NODE_UPDATE_STATE_TO_PHASE_MAPPING[status];
        return {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle,
            clipSector: clipSector,
            phase: phase
        };
    };
    const toFn = (_sect, datum, status)=>{
        const { startAngle: startAngle, endAngle: endAngle } = angles.to(datum);
        let innerRadius;
        let outerRadius;
        let clipSector;
        if (status === "removed") {
            innerRadius = axisZeroRadius;
            outerRadius = axisZeroRadius;
            clipSector = new $2fb96651e8aa1522$var$SectorBox(startAngle, endAngle, innerRadius, outerRadius);
        } else {
            let clipInnerRadius, clipOuterRadius;
            ({ innerRadius: innerRadius, outerRadius: outerRadius, clipInnerRadius: clipInnerRadius, clipOuterRadius: clipOuterRadius } = $2fb96651e8aa1522$var$getRadii(datum));
            if (isNaN(innerRadius)) innerRadius = axisZeroRadius;
            if (isNaN(outerRadius)) outerRadius = axisZeroRadius;
            if (isNaN(clipInnerRadius)) clipInnerRadius = axisZeroRadius;
            if (isNaN(clipOuterRadius)) clipOuterRadius = axisZeroRadius;
            clipSector = new $2fb96651e8aa1522$var$SectorBox(startAngle, endAngle, clipInnerRadius, clipOuterRadius);
        }
        return {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle,
            clipSector: clipSector
        };
    };
    return {
        toFn: toFn,
        fromFn: fromFn
    };
}
function $2fb96651e8aa1522$var$resetNightingaleSelectionFn(_sect, datum) {
    const { startAngle: startAngle, endAngle: endAngle } = datum;
    const { innerRadius: innerRadius, outerRadius: outerRadius, clipInnerRadius: clipInnerRadius, clipOuterRadius: clipOuterRadius } = $2fb96651e8aa1522$var$getRadii(datum);
    const clipSector = new $2fb96651e8aa1522$var$SectorBox(startAngle, endAngle, clipInnerRadius, clipOuterRadius);
    return {
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle,
        clipSector: clipSector
    };
}
// packages/ag-charts-enterprise/src/series/nightingale/nightingaleSeries.ts
var { Sector: $2fb96651e8aa1522$var$Sector4, SectorBox: $2fb96651e8aa1522$var$SectorBox2, PolarZIndexMap: $2fb96651e8aa1522$var$PolarZIndexMap } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$NightingaleSeries = class extends $2fb96651e8aa1522$var$RadialColumnSeriesBase {
    // TODO: Enable once the options contract has been revisited
    // @TempValidate
    // sectorSpacing = 1;
    constructor(moduleCtx){
        super(moduleCtx, {
            animationResetFns: {
                item: $2fb96651e8aa1522$var$resetNightingaleSelectionFn
            }
        });
        this.properties = new $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties();
    }
    setSeriesIndex(index) {
        if (!super.setSeriesIndex(index)) return false;
        this.contentGroup.zIndex = [
            0,
            $2fb96651e8aa1522$var$PolarZIndexMap.FOREGROUND,
            index
        ];
        this.highlightGroup.zIndex = [
            0,
            $2fb96651e8aa1522$var$PolarZIndexMap.HIGHLIGHT,
            index
        ];
        this.labelGroup.zIndex = [
            0,
            $2fb96651e8aa1522$var$PolarZIndexMap.LABEL,
            index
        ];
        return true;
    }
    getStackId() {
        const groupIndex = this.seriesGrouping?.groupIndex ?? this.id;
        return `nightingale-stack-${groupIndex}-yValues`;
    }
    nodeFactory() {
        return new $2fb96651e8aa1522$var$Sector4();
    }
    updateItemPath(node, datum, highlight) {
        const { negative: negative } = datum;
        node.centerX = 0;
        node.centerY = 0;
        node.startOuterCornerRadius = !negative ? this.properties.cornerRadius : 0;
        node.endOuterCornerRadius = !negative ? this.properties.cornerRadius : 0;
        node.startInnerCornerRadius = negative ? this.properties.cornerRadius : 0;
        node.endInnerCornerRadius = negative ? this.properties.cornerRadius : 0;
        if (highlight) {
            const { startAngle: startAngle, endAngle: endAngle } = datum;
            const { innerRadius: innerRadius, outerRadius: outerRadius, clipInnerRadius: clipInnerRadius, clipOuterRadius: clipOuterRadius } = $2fb96651e8aa1522$var$getRadii(datum);
            node.innerRadius = innerRadius;
            node.outerRadius = outerRadius;
            node.startAngle = startAngle;
            node.endAngle = endAngle;
            node.clipSector = new $2fb96651e8aa1522$var$SectorBox2(startAngle, endAngle, clipInnerRadius, clipOuterRadius);
        }
    }
    getColumnTransitionFunctions() {
        const axisZeroRadius = this.isRadiusAxisReversed() ? this.radius : this.getAxisInnerRadius();
        return $2fb96651e8aa1522$var$prepareNightingaleAnimationFunctions(axisZeroRadius);
    }
};
$2fb96651e8aa1522$var$NightingaleSeries.className = "NightingaleSeries";
$2fb96651e8aa1522$var$NightingaleSeries.type = "nightingale";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs15, nightingaleSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$nightingaleSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$nightingaleSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$nightingaleSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs15,
    type: (0, $idDdm.required)((0, $idDdm.constant)("nightingale")),
    angleKey: (0, $idDdm.required)((0, $idDdm.string)),
    radiusKey: (0, $idDdm.required)((0, $idDdm.string)),
    angleName: (0, $idDdm.string),
    radiusName: (0, $idDdm.string),
    grouped: (0, $idDdm.boolean),
    stacked: (0, $idDdm.boolean),
    stackGroup: (0, $idDdm.string),
    normalizedTo: (0, $idDdm.number)
};
var { ThemeConstants: { POLAR_AXIS_TYPE: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE, POLAR_AXIS_SHAPE: $2fb96651e8aa1522$var$POLAR_AXIS_SHAPE } } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$axisShape = {
    $path: [
        "./shape",
        $2fb96651e8aa1522$var$POLAR_AXIS_SHAPE.CIRCLE,
        {
            $find: [
                {
                    $not: [
                        {
                            $isOperation: "./shape"
                        }
                    ]
                },
                {
                    $path: ".."
                }
            ]
        }
    ]
};
var $2fb96651e8aa1522$var$NIGHTINGALE_SERIES_THEME = {
    series: {
        fill: {
            $palette: "fill"
        },
        stroke: {
            $if: [
                {
                    $eq: [
                        {
                            $palette: "type"
                        },
                        "inbuilt"
                    ]
                },
                {
                    $ref: "backgroundColor"
                },
                {
                    $palette: "stroke"
                }
            ]
        },
        // @ts-expect-error undocumented option
        fillGradientDefaults: {
            type: "gradient",
            gradient: "radial",
            bounds: "series",
            colorStops: {
                $palette: "gradient"
            },
            rotation: 0,
            reverse: false
        },
        fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
        fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
        strokeWidth: 1,
        label: {
            enabled: false,
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            fontWeight: {
                $ref: "fontWeight"
            },
            color: {
                $ref: "textColor"
            }
        }
    },
    axes: {
        [$2fb96651e8aa1522$var$POLAR_AXIS_TYPE.ANGLE_CATEGORY]: {
            shape: $2fb96651e8aa1522$var$axisShape,
            groupPaddingInner: 0,
            paddingInner: 0,
            label: {
                spacing: 10
            }
        },
        [$2fb96651e8aa1522$var$POLAR_AXIS_TYPE.RADIUS_NUMBER]: {
            shape: $2fb96651e8aa1522$var$axisShape
        }
    }
};
// packages/ag-charts-enterprise/src/series/nightingale/nightingaleModule.ts
var { ThemeConstants: { POLAR_AXIS_TYPE: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE2 } } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$NightingaleModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "polar"
    ],
    identifier: "nightingale",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$NightingaleSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    defaultAxes: [
        {
            type: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE2.ANGLE_CATEGORY
        },
        {
            type: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE2.RADIUS_NUMBER
        }
    ],
    themeTemplate: $2fb96651e8aa1522$var$NIGHTINGALE_SERIES_THEME,
    stackable: true,
    groupable: true,
    stackedByDefault: true
};
var $2fb96651e8aa1522$var$NightingaleSeriesModule = {
    type: "series",
    name: "nightingale",
    chartType: "polar",
    enterprise: true,
    options: $2fb96651e8aa1522$var$nightingaleSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$NightingaleSeries(ctx)
};
var { SeriesProperties: $2fb96651e8aa1522$var$SeriesProperties9, FillGradientDefaults: $2fb96651e8aa1522$var$FillGradientDefaults13, FillPatternDefaults: $2fb96651e8aa1522$var$FillPatternDefaults13, FillImageDefaults: $2fb96651e8aa1522$var$FillImageDefaults13, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip18, Property: $2fb96651e8aa1522$var$Property76, Label: $2fb96651e8aa1522$var$Label13, DropShadow: $2fb96651e8aa1522$var$DropShadow5 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$PyramidSeriesLabel = class extends $2fb96651e8aa1522$var$Label13 {
};
var $2fb96651e8aa1522$var$PyramidSeriesStageLabel = class extends $2fb96651e8aa1522$var$Label13 {
    constructor(){
        super(...arguments);
        this.spacing = 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidSeriesStageLabel.prototype, "spacing", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidSeriesStageLabel.prototype, "placement", 2);
var $2fb96651e8aa1522$var$PyramidProperties = class extends $2fb96651e8aa1522$var$SeriesProperties9 {
    constructor(){
        super(...arguments);
        this.fills = [];
        this.fillGradientDefaults = new $2fb96651e8aa1522$var$FillGradientDefaults13();
        this.fillPatternDefaults = new $2fb96651e8aa1522$var$FillPatternDefaults13();
        this.fillImageDefaults = new $2fb96651e8aa1522$var$FillImageDefaults13();
        this.fillOpacity = 1;
        this.strokes = [];
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.direction = "vertical";
        this.reverse = void 0;
        this.spacing = 0;
        this.aspectRatio = void 0;
        this.shadow = new $2fb96651e8aa1522$var$DropShadow5().set({
            enabled: false
        });
        this.label = new $2fb96651e8aa1522$var$PyramidSeriesLabel();
        this.stageLabel = new $2fb96651e8aa1522$var$PyramidSeriesStageLabel();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip18();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "stageKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "valueKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "fills", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "fillGradientDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "fillPatternDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "fillImageDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "strokes", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "direction", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "reverse", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "spacing", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "aspectRatio", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "itemStyler", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "shadow", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "stageLabel", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property76
], $2fb96651e8aa1522$var$PyramidProperties.prototype, "tooltip", 2);
// packages/ag-charts-enterprise/src/series/pyramid/pyramidUtil.ts
function $2fb96651e8aa1522$var$applyPyramidDatum(connector, { x: x, y: y, top: top, right: right, bottom: bottom, left: left }) {
    connector.x0 = x - top / 2;
    connector.x1 = x + top / 2;
    connector.x2 = x + bottom / 2;
    connector.x3 = x - bottom / 2;
    connector.y0 = y - left / 2;
    connector.y1 = y - right / 2;
    connector.y2 = y + right / 2;
    connector.y3 = y + left / 2;
}
function $2fb96651e8aa1522$var$preparePyramidAnimationFunctions(direction) {
    const fromFn = (_connector, datum)=>{
        const { x: x, y: y } = datum;
        let { top: top, right: right, bottom: bottom, left: left } = datum;
        if (direction === "vertical") {
            top = 0;
            bottom = 0;
        } else {
            left = 0;
            right = 0;
        }
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left
        };
    };
    const toFn = (_connector, datum)=>{
        const { x: x, y: y, top: top, right: right, bottom: bottom, left: left } = datum;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left
        };
    };
    const applyFn = $2fb96651e8aa1522$var$applyPyramidDatum;
    return {
        fromFn: fromFn,
        toFn: toFn,
        applyFn: applyFn
    };
}
// packages/ag-charts-enterprise/src/series/pyramid/pyramidSeries.ts
var { StateMachine: $2fb96651e8aa1522$var$StateMachine14, valueProperty: $2fb96651e8aa1522$var$valueProperty16, SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode15, CachedTextMeasurerPool: $2fb96651e8aa1522$var$CachedTextMeasurerPool10, TextUtils: $2fb96651e8aa1522$var$TextUtils7, createDatumId: $2fb96651e8aa1522$var$createDatumId19, BBox: $2fb96651e8aa1522$var$BBox20, Group: $2fb96651e8aa1522$var$Group17, Selection: $2fb96651e8aa1522$var$Selection13, Text: $2fb96651e8aa1522$var$Text6, PointerEvents: $2fb96651e8aa1522$var$PointerEvents9, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle12, fromToMotion: $2fb96651e8aa1522$var$fromToMotion4, seriesLabelFadeInAnimation: $2fb96651e8aa1522$var$seriesLabelFadeInAnimation6, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle14 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$PyramidSeries = class extends (0, $iTJTu._ModuleSupport).DataModelSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            categoryKey: void 0,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode15.EXACT_SHAPE_MATCH,
                $2fb96651e8aa1522$var$SeriesNodePickMode15.NEAREST_NODE
            ]
        });
        this.properties = new $2fb96651e8aa1522$var$PyramidProperties();
        this.itemGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group17({
            name: "itemGroup"
        }));
        this.itemLabelGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group17({
            name: "itemLabelGroup"
        }));
        this.stageLabelGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group17({
            name: "stageLabelGroup"
        }));
        this.datumSelection = $2fb96651e8aa1522$var$Selection13.select(this.itemGroup, ()=>this.nodeFactory());
        this.labelSelection = $2fb96651e8aa1522$var$Selection13.select(this.itemLabelGroup, $2fb96651e8aa1522$var$Text6);
        this.stageLabelSelection = $2fb96651e8aa1522$var$Selection13.select(this.stageLabelGroup, $2fb96651e8aa1522$var$Text6);
        this.highlightDatumSelection = $2fb96651e8aa1522$var$Selection13.select(this.highlightNode, ()=>this.nodeFactory());
        this.animationState = new $2fb96651e8aa1522$var$StateMachine14("empty", {
            empty: {
                update: {
                    target: "ready",
                    action: ()=>this.animateEmptyUpdateReady()
                },
                reset: "empty",
                skip: "ready"
            },
            ready: {
                clear: "empty",
                reset: "empty",
                skip: "ready"
            }
        }, ()=>this.checkProcessedDataAnimatable());
        this.itemLabelGroup.pointerEvents = $2fb96651e8aa1522$var$PointerEvents9.None;
        this.stageLabelGroup.pointerEvents = $2fb96651e8aa1522$var$PointerEvents9.None;
    }
    addChartEventListeners() {
        this.destroyFns.push(this.ctx.chartEventManager?.addListener("legend-item-click", (event)=>this.onLegendItemClick(event)));
    }
    nodeFactory() {
        return new $2fb96651e8aa1522$var$FunnelConnector();
    }
    getNodeData() {
        return this.contextNodeData?.nodeData;
    }
    resetAnimation(phase) {
        if (phase === "initial") this.animationState.transition("reset");
        else if (phase === "ready") this.animationState.transition("skip");
    }
    async processData(dataController) {
        if (this.data == null) return;
        const { id: seriesId, visible: visible, ctx: { legendManager: legendManager } } = this;
        const { stageKey: stageKey, valueKey: valueKey } = this.properties;
        const xScaleType = "band";
        const yScaleType = "number";
        const validation = (_value, _datum, index)=>visible && legendManager.getItemEnabled({
                seriesId: seriesId,
                itemId: index
            });
        const visibleProps = this.visible ? {} : {
            forceValue: 0
        };
        await this.requestDataModel(dataController, this.data, {
            props: [
                $2fb96651e8aa1522$var$valueProperty16(stageKey, xScaleType, {
                    id: "xValue"
                }),
                $2fb96651e8aa1522$var$valueProperty16(valueKey, yScaleType, {
                    id: `yValue`,
                    ...visibleProps,
                    validation: validation,
                    invalidValue: 0
                })
            ]
        });
    }
    createNodeData() {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, properties: properties, visible: visible, ctx: { legendManager: legendManager } } = this;
        const { stageKey: stageKey, valueKey: valueKey, direction: direction, reverse: reverse = direction === "horizontal", spacing: spacing, aspectRatio: aspectRatio, label: label, stageLabel: stageLabel } = properties;
        if (dataModel == null || processedData == null) return;
        const horizontal = direction === "horizontal";
        const xValues = dataModel.resolveColumnById(this, `xValue`, processedData);
        const yValues = dataModel.resolveColumnById(this, `yValue`, processedData);
        const textMeasurer = $2fb96651e8aa1522$var$CachedTextMeasurerPool10.getMeasurer({
            font: stageLabel.getFont()
        });
        let textAlign;
        let textBaseline;
        if (horizontal) {
            textAlign = "center";
            textBaseline = stageLabel.placement === "before" ? "bottom" : "top";
        } else {
            textAlign = stageLabel.placement === "after" ? "left" : "right";
            textBaseline = "middle";
        }
        const stageLabelData = stageLabel.enabled ? [] : void 0;
        let maxLabelWidth = 0;
        let maxLabelHeight = 0;
        let yTotal = 0;
        const rawData = processedData.dataSources.get(this.id) ?? [];
        rawData.forEach((datum, datumIndex)=>{
            const xValue2 = xValues[datumIndex];
            const yValue = yValues[datumIndex];
            const enabled = visible && legendManager.getItemEnabled({
                seriesId: seriesId,
                itemId: datumIndex
            });
            yTotal += yValue;
            if (stageLabelData == null) return;
            const text2 = this.getLabelText(this.properties.stageLabel, {
                datum: datum,
                value: xValue2,
                stageKey: stageKey,
                valueKey: valueKey
            });
            const { width: width } = textMeasurer.measureText(text2);
            const height = text2.split("\n").length * $2fb96651e8aa1522$var$TextUtils7.getLineHeight(label.fontSize);
            maxLabelWidth = Math.max(maxLabelWidth, width);
            maxLabelHeight = Math.max(maxLabelHeight, height);
            stageLabelData.push({
                x: NaN,
                y: NaN,
                text: text2,
                textAlign: textAlign,
                textBaseline: textBaseline,
                visible: enabled
            });
        });
        const seriesRectWidth = this._nodeDataDependencies?.seriesRectWidth ?? 0;
        const seriesRectHeight = this._nodeDataDependencies?.seriesRectHeight ?? 0;
        const totalSpacing = spacing * (processedData.input.count - 1);
        let bounds;
        if (horizontal) {
            const verticalInset = maxLabelHeight + stageLabel.spacing;
            bounds = new $2fb96651e8aa1522$var$BBox20(0, stageLabel.placement === "before" ? verticalInset : 0, seriesRectWidth, seriesRectHeight - verticalInset);
        } else {
            const horizontalInset = maxLabelWidth + stageLabel.spacing;
            bounds = new $2fb96651e8aa1522$var$BBox20(stageLabel.placement === "after" ? 0 : horizontalInset, 0, seriesRectWidth - horizontalInset, seriesRectHeight);
        }
        if (aspectRatio != null && aspectRatio !== 0) {
            const directionalAspectRatio = direction === "horizontal" ? 1 / aspectRatio : aspectRatio;
            const constrainedWidth = Math.min(bounds.width, bounds.height * directionalAspectRatio);
            const constrainedHeight = constrainedWidth / directionalAspectRatio;
            bounds = new $2fb96651e8aa1522$var$BBox20(bounds.x + (bounds.width - constrainedWidth) / 2, bounds.y + (bounds.height - constrainedHeight) / 2, constrainedWidth, constrainedHeight);
        }
        let labelX;
        let labelY;
        if (horizontal) labelY = stageLabel.placement === "before" ? bounds.y - stageLabel.spacing : bounds.y + bounds.height + stageLabel.spacing;
        else labelX = stageLabel.placement === "after" ? bounds.x + bounds.width + stageLabel.spacing : bounds.x - stageLabel.spacing;
        const availableWidth = bounds.width - (horizontal ? totalSpacing : 0);
        const availableHeight = bounds.height - (horizontal ? 0 : totalSpacing);
        if (availableWidth < 0 || availableHeight < 0) return;
        const nodeData = [];
        const labelData = [];
        let yStart = 0;
        rawData.forEach((datum, datumIndex)=>{
            const xValue2 = xValues[datumIndex];
            const yValue = yValues[datumIndex];
            const enabled = visible && legendManager.getItemEnabled({
                seriesId: seriesId,
                itemId: datumIndex
            });
            const yEnd = yStart + yValue;
            const yMidRatio = (yStart + yEnd) / (2 * yTotal);
            const yRangeRatio = (yEnd - yStart) / yTotal;
            const xOffset = horizontal ? availableWidth * yMidRatio + spacing * datumIndex : availableWidth * 0.5;
            const yOffset = horizontal ? availableHeight * 0.5 : availableHeight * yMidRatio + spacing * datumIndex;
            const x = bounds.x + xOffset;
            const y = bounds.y + yOffset;
            if (stageLabelData != null) {
                const stageLabelDatum = stageLabelData[datumIndex];
                stageLabelDatum.x = labelX ?? x;
                stageLabelDatum.y = labelY ?? y;
            }
            let top;
            let right;
            let bottom;
            let left;
            if (horizontal) {
                const barWidth = availableWidth * yRangeRatio;
                top = barWidth;
                bottom = barWidth;
                const y0 = (xOffset + barWidth / 2) * (availableHeight / bounds.width);
                const y1 = (xOffset - barWidth / 2) * (availableHeight / bounds.width);
                right = reverse ? bounds.height - y0 : y0;
                left = reverse ? bounds.height - y1 : y1;
            } else {
                const barHeight = availableHeight * yRangeRatio;
                right = barHeight;
                left = barHeight;
                const x0 = (yOffset - barHeight / 2) * (availableWidth / bounds.height);
                const x1 = (yOffset + barHeight / 2) * (availableWidth / bounds.height);
                top = reverse ? bounds.width - x0 : x0;
                bottom = reverse ? bounds.width - x1 : x1;
            }
            const text2 = this.getLabelText(label, {
                datum: datum,
                value: yValue,
                stageKey: stageKey,
                valueKey: valueKey
            });
            const labelDatum = {
                x: x,
                y: y,
                text: text2,
                textAlign: "center",
                textBaseline: "middle",
                visible: enabled
            };
            labelData.push(labelDatum);
            nodeData.push({
                series: this,
                itemId: valueKey,
                datum: datum,
                datumIndex: datumIndex,
                index: datumIndex,
                xValue: xValue2,
                yValue: yValue,
                x: x,
                y: y,
                top: top,
                right: right,
                bottom: bottom,
                left: left,
                label: labelDatum,
                enabled: enabled,
                midPoint: {
                    x: x,
                    y: y
                }
            });
            yStart = yEnd;
        });
        return {
            itemId: seriesId,
            nodeData: nodeData,
            labelData: labelData,
            stageLabelData: stageLabelData,
            bounds: bounds
        };
    }
    updateSelections() {
        if (this.nodeDataRefresh) {
            this.contextNodeData = this.createNodeData();
            this.nodeDataRefresh = false;
        }
    }
    update({ seriesRect: seriesRect }) {
        this.checkResize(seriesRect);
        const { datumSelection: datumSelection, labelSelection: labelSelection, stageLabelSelection: stageLabelSelection, highlightDatumSelection: highlightDatumSelection } = this;
        this.updateSelections();
        this.contentGroup.visible = this.visible;
        this.contentGroup.opacity = this.getOpacity();
        let highlightedDatum = this.ctx.highlightManager?.getActiveHighlight();
        if (highlightedDatum != null && (highlightedDatum.series !== this || highlightedDatum.datum == null)) highlightedDatum = void 0;
        const nodeData = this.contextNodeData?.nodeData ?? [];
        const labelData = this.contextNodeData?.labelData ?? [];
        const stageLabelData = this.contextNodeData?.stageLabelData ?? [];
        this.datumSelection = this.updateDatumSelection({
            nodeData: nodeData,
            datumSelection: datumSelection
        });
        this.updateDatumNodes({
            datumSelection: datumSelection,
            isHighlight: false
        });
        this.labelSelection = this.updateLabelSelection({
            labelData: labelData,
            labelSelection: labelSelection
        });
        this.updateLabelNodes({
            labelSelection: labelSelection,
            labelProperties: this.properties.label
        });
        this.stageLabelSelection = this.updateStageLabelSelection({
            stageLabelData: stageLabelData,
            stageLabelSelection: stageLabelSelection
        });
        this.updateLabelNodes({
            labelSelection: stageLabelSelection,
            labelProperties: this.properties.stageLabel
        });
        this.highlightDatumSelection = this.updateDatumSelection({
            nodeData: highlightedDatum != null ? [
                highlightedDatum
            ] : [],
            datumSelection: highlightDatumSelection
        });
        this.updateDatumNodes({
            datumSelection: highlightDatumSelection,
            isHighlight: true
        });
        this.animationState.transition("update");
    }
    updateDatumSelection(opts) {
        return opts.datumSelection.update(opts.nodeData);
    }
    getItemBaseStyle(highlighted) {
        const { properties: properties } = this;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return $2fb96651e8aa1522$var$getShapeStyle14({
            fill: highlightStyle?.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? properties.fillOpacity,
            stroke: highlightStyle?.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(properties.strokeWidth),
            strokeOpacity: highlightStyle?.strokeOpacity ?? properties.strokeOpacity,
            lineDash: highlightStyle?.lineDash ?? properties.lineDash,
            lineDashOffset: highlightStyle?.lineDashOffset ?? properties.lineDashOffset
        }, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
    }
    getItemStyleOverrides(datumId, datum, datumIndex, format, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const { fills: fills, strokes: strokes, stageKey: stageKey, valueKey: valueKey, itemStyler: itemStyler } = properties;
        const fill = format.fill ?? fills[datumIndex % fills.length];
        const stroke2 = format.stroke ?? strokes[datumIndex % strokes.length];
        const overrides = {};
        if (!highlighted) {
            overrides.fill = fill;
            overrides.stroke = stroke2;
        }
        if (itemStyler != null) {
            const itemStyle = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId19(datumId, highlighted ? "highlight" : "node"), ()=>{
                return this.callWithContext(itemStyler, {
                    seriesId: seriesId,
                    datum: datum,
                    stageKey: stageKey,
                    valueKey: valueKey,
                    highlighted: highlighted,
                    fill: fill,
                    stroke: stroke2,
                    ...format
                });
            });
            Object.assign(overrides, itemStyle);
        }
        return $2fb96651e8aa1522$var$getShapeStyle14(overrides, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
    }
    updateDatumNodes(opts) {
        const { datumSelection: datumSelection, isHighlight: isHighlight } = opts;
        const { properties: properties } = this;
        const { shadow: shadow } = properties;
        const style = this.getItemBaseStyle(isHighlight);
        const bounds = this.contextNodeData?.bounds;
        const fillBBox = bounds ? {
            series: bounds,
            axis: bounds
        } : void 0;
        datumSelection.each((connector, nodeDatum)=>{
            const { datumIndex: datumIndex, datum: datum } = nodeDatum;
            const overrides = this.getItemStyleOverrides(String(datumIndex), datum, datumIndex, style, isHighlight);
            $2fb96651e8aa1522$var$applyShapeStyle12(connector, style, overrides, fillBBox);
            $2fb96651e8aa1522$var$applyPyramidDatum(connector, nodeDatum);
            connector.fillShadow = shadow;
        });
    }
    updateLabelSelection(opts) {
        return opts.labelSelection.update(this.properties.label.enabled ? opts.labelData : []);
    }
    updateStageLabelSelection(opts) {
        return opts.stageLabelSelection.update(opts.stageLabelData);
    }
    updateLabelNodes(opts) {
        const { labelSelection: labelSelection, labelProperties: labelProperties } = opts;
        const { color: fill, fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight, fontFamily: fontFamily } = labelProperties;
        labelSelection.each((label, { visible: visible, x: x, y: y, text: text2, textAlign: textAlign, textBaseline: textBaseline })=>{
            label.visible = visible;
            label.x = x;
            label.y = y;
            label.text = text2;
            label.fill = fill;
            label.fontStyle = fontStyle;
            label.fontWeight = fontWeight;
            label.fontSize = fontSize;
            label.fontFamily = fontFamily;
            label.textAlign = textAlign;
            label.textBaseline = textBaseline;
        });
    }
    computeFocusBounds(opts) {
        const datum = this.getNodeData()?.[opts.datumIndex];
        if (datum === void 0) return;
        for (const node of this.datumSelection){
            if (node.datum === datum) return node.node;
        }
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, properties: properties } = this;
        const { stageKey: stageKey, valueKey: valueKey, tooltip: tooltip } = properties;
        if (!dataModel || !processedData) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const xValue2 = dataModel.resolveColumnById(this, "xValue", processedData)[datumIndex];
        const yValue = dataModel.resolveColumnById(this, `yValue`, processedData)[datumIndex];
        if (xValue2 == null) return;
        const value = this.getLabelText(this.properties.stageLabel, {
            datum: processedData.dataSources.get(this.id)?.[datumIndex],
            value: yValue,
            stageKey: stageKey,
            valueKey: valueKey
        });
        const format = this.getItemBaseStyle(false);
        Object.assign(format, this.getItemStyleOverrides(String(datumIndex), datumIndex, datumIndex, format, false));
        return this.formatTooltipWithContext(tooltip, {
            symbol: this.legendItemSymbol(datumIndex),
            data: [
                {
                    label: String(xValue2),
                    value: value
                }
            ]
        }, {
            seriesId: seriesId,
            datum: datum,
            title: void 0,
            stageKey: stageKey,
            valueKey: valueKey,
            ...format
        });
    }
    getSeriesDomain() {
        return [
            NaN,
            NaN
        ];
    }
    getSeriesRange(_direction, _visibleRange) {
        return [
            NaN,
            NaN
        ];
    }
    pickNodeClosestDatum({ x: x, y: y }) {
        let minDistanceSquared = Infinity;
        let minDatum;
        this.datumSelection.each((node, datum)=>{
            const distanceSquared = node.distanceSquared(x, y);
            if (distanceSquared < minDistanceSquared) {
                minDistanceSquared = distanceSquared;
                minDatum = datum;
            }
        });
        return minDatum != null ? {
            datum: minDatum,
            distance: Math.sqrt(minDistanceSquared)
        } : void 0;
    }
    legendItemSymbol(datumIndex) {
        const { fills: fills, strokes: strokes, strokeWidth: strokeWidth, fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = this.properties;
        const fill = fills[datumIndex % fills.length] ?? "black";
        const stroke2 = strokes[datumIndex % strokes.length] ?? "black";
        return {
            marker: $2fb96651e8aa1522$var$getShapeStyle14({
                fill: fill,
                fillOpacity: fillOpacity,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                strokeOpacity: strokeOpacity,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset
            }, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults)
        };
    }
    getLegendData(legendType) {
        const { processedData: processedData, dataModel: dataModel, id: seriesId, ctx: { legendManager: legendManager }, visible: visible } = this;
        if (!dataModel || !processedData || legendType !== "category") return [];
        const { showInLegend: showInLegend } = this.properties;
        const legendData = [];
        const stageValues = dataModel.resolveColumnById(this, `xValue`, processedData);
        const rawData = processedData.dataSources.get(this.id) ?? [];
        rawData.forEach((_datum, datumIndex)=>{
            const stageValue = stageValues[datumIndex];
            legendData.push({
                legendType: "category",
                id: seriesId,
                itemId: datumIndex,
                seriesId: seriesId,
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: seriesId,
                    itemId: datumIndex
                }),
                label: {
                    text: stageValue
                },
                symbol: this.legendItemSymbol(datumIndex),
                hideInLegend: !showInLegend
            });
        });
        return legendData;
    }
    animateReset() {
        this.ctx.animationManager.skipCurrentBatch();
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
    }
    animateEmptyUpdateReady() {
        const { datumSelection: datumSelection, labelSelection: labelSelection, properties: properties } = this;
        const fns = $2fb96651e8aa1522$var$preparePyramidAnimationFunctions(properties.direction);
        $2fb96651e8aa1522$var$fromToMotion4(this.id, "nodes", this.ctx.animationManager, [
            datumSelection
        ], fns);
        $2fb96651e8aa1522$var$seriesLabelFadeInAnimation6(this, "labels", this.ctx.animationManager, labelSelection);
    }
};
$2fb96651e8aa1522$var$PyramidSeries.className = "PyramidSeries";
$2fb96651e8aa1522$var$PyramidSeries.type = "pyramid";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs16, pyramidSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$pyramidSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$pyramidSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$pyramidSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs16,
    type: (0, $idDdm.required)((0, $idDdm.constant)("pyramid")),
    stageKey: (0, $idDdm.required)((0, $idDdm.string)),
    valueKey: (0, $idDdm.required)((0, $idDdm.string))
};
var { ThemeSymbols: { DEFAULT_SHADOW_COLOUR: $2fb96651e8aa1522$var$DEFAULT_SHADOW_COLOUR2 } } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$PYRAMID_SERIES_THEME = {
    series: {
        direction: "vertical",
        strokeWidth: 0,
        spacing: 2,
        fills: {
            $palette: "fills"
        },
        strokes: {
            $palette: "strokes"
        },
        // @ts-expect-error undocumented option
        fillGradientDefaults: {
            type: "gradient",
            gradient: "linear",
            bounds: "item",
            colorStops: {
                $palette: "gradient"
            },
            rotation: 0,
            reverse: false
        },
        fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
        fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
        label: {
            enabled: true,
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            fontWeight: {
                $ref: "fontWeight"
            },
            color: {
                $ref: "backgroundColor"
            }
        },
        stageLabel: {
            enabled: true,
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            fontWeight: {
                $ref: "fontWeight"
            },
            color: {
                $ref: "textColor"
            },
            spacing: 12
        },
        shadow: {
            enabled: false,
            color: $2fb96651e8aa1522$var$DEFAULT_SHADOW_COLOUR2,
            xOffset: 3,
            yOffset: 3,
            blur: 5
        }
    }
};
// packages/ag-charts-enterprise/src/series/pyramid/pyramidModule.ts
var $2fb96651e8aa1522$var$PyramidModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "standalone"
    ],
    identifier: "pyramid",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$PyramidSeries(ctx),
    solo: true,
    tooltipDefaults: {
        range: "exact"
    },
    themeTemplate: $2fb96651e8aa1522$var$PYRAMID_SERIES_THEME
};
var $2fb96651e8aa1522$var$PyramidSeriesModule = {
    type: "series",
    name: "pyramid",
    chartType: "standalone",
    enterprise: true,
    options: $2fb96651e8aa1522$var$pyramidSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$PyramidSeries(ctx)
};
var { ThemeConstants: { POLAR_AXIS_TYPE: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE3 } } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$BASE_RADAR_SERIES_THEME = {
    series: {
        stroke: {
            $palette: "stroke"
        },
        label: {
            enabled: false,
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            fontWeight: {
                $ref: "fontWeight"
            },
            color: {
                $ref: "textColor"
            }
        },
        marker: {
            enabled: true,
            fill: {
                $palette: "fill"
            },
            stroke: {
                $palette: "stroke"
            },
            // @ts-expect-error undocumented option
            fillGradientDefaults: {
                type: "gradient",
                gradient: "radial",
                bounds: "item",
                colorStops: {
                    $palette: "gradient"
                },
                rotation: 0,
                reverse: true
            },
            fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
            fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
            fillOpacity: 1,
            shape: "circle",
            size: 6,
            strokeOpacity: 1,
            strokeWidth: 0
        }
    },
    axes: {
        [$2fb96651e8aa1522$var$POLAR_AXIS_TYPE3.ANGLE_CATEGORY]: {
            label: {
                spacing: 10
            }
        }
    }
};
var $2fb96651e8aa1522$var$RADAR_LINE_SERIES_THEME = (0, $iTJTu._ModuleSupport).mergeDefaults({
    series: {
        stroke: (0, $iTJTu._ModuleSupport).SAFE_STROKE_FILL_OPERATION,
        strokeWidth: 2
    }
}, $2fb96651e8aa1522$var$BASE_RADAR_SERIES_THEME);
var $2fb96651e8aa1522$var$RADAR_AREA_SERIES_THEME = (0, $iTJTu._ModuleSupport).mergeDefaults({
    series: {
        fill: {
            $palette: "fill"
        },
        fillGradientDefaults: {
            type: "gradient",
            gradient: "linear",
            bounds: "item",
            colorStops: {
                $palette: "gradient"
            },
            rotation: 0,
            reverse: false
        },
        fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
        fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
        fillOpacity: 0.8,
        strokeWidth: 2,
        marker: {
            enabled: false,
            fillGradientDefaults: {
                type: "gradient",
                gradient: "radial",
                bounds: "item",
                colorStops: {
                    $palette: "gradient"
                },
                rotation: 0,
                reverse: true
            },
            fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
            fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS
        }
    }
}, $2fb96651e8aa1522$var$BASE_RADAR_SERIES_THEME);
var { Label: $2fb96651e8aa1522$var$Label14, SeriesMarker: $2fb96651e8aa1522$var$SeriesMarker2, SeriesProperties: $2fb96651e8aa1522$var$SeriesProperties10, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip19, Property: $2fb96651e8aa1522$var$Property77 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadarSeriesProperties = class extends $2fb96651e8aa1522$var$SeriesProperties10 {
    constructor(){
        super(...arguments);
        this.stroke = "black";
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.rotation = 0;
        this.marker = new $2fb96651e8aa1522$var$SeriesMarker2();
        this.label = new $2fb96651e8aa1522$var$Label14();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip19();
        this.connectMissingData = false;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property77
], $2fb96651e8aa1522$var$RadarSeriesProperties.prototype, "angleKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property77
], $2fb96651e8aa1522$var$RadarSeriesProperties.prototype, "radiusKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property77
], $2fb96651e8aa1522$var$RadarSeriesProperties.prototype, "angleName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property77
], $2fb96651e8aa1522$var$RadarSeriesProperties.prototype, "radiusName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property77
], $2fb96651e8aa1522$var$RadarSeriesProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property77
], $2fb96651e8aa1522$var$RadarSeriesProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property77
], $2fb96651e8aa1522$var$RadarSeriesProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property77
], $2fb96651e8aa1522$var$RadarSeriesProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property77
], $2fb96651e8aa1522$var$RadarSeriesProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property77
], $2fb96651e8aa1522$var$RadarSeriesProperties.prototype, "rotation", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property77
], $2fb96651e8aa1522$var$RadarSeriesProperties.prototype, "marker", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property77
], $2fb96651e8aa1522$var$RadarSeriesProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property77
], $2fb96651e8aa1522$var$RadarSeriesProperties.prototype, "tooltip", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property77
], $2fb96651e8aa1522$var$RadarSeriesProperties.prototype, "connectMissingData", 2);
// packages/ag-charts-enterprise/src/series/radar/radarSeries.ts
var { ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection27, PolarAxis: $2fb96651e8aa1522$var$PolarAxis2, SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode16, valueProperty: $2fb96651e8aa1522$var$valueProperty17, fixNumericExtent: $2fb96651e8aa1522$var$fixNumericExtent9, seriesLabelFadeInAnimation: $2fb96651e8aa1522$var$seriesLabelFadeInAnimation7, markerFadeInAnimation: $2fb96651e8aa1522$var$markerFadeInAnimation2, resetMarkerFn: $2fb96651e8aa1522$var$resetMarkerFn2, animationValidation: $2fb96651e8aa1522$var$animationValidation8, computeMarkerFocusBounds: $2fb96651e8aa1522$var$computeMarkerFocusBounds3, extent: $2fb96651e8aa1522$var$extent2, BBox: $2fb96651e8aa1522$var$BBox21, Group: $2fb96651e8aa1522$var$Group18, Path: $2fb96651e8aa1522$var$Path11, PointerEvents: $2fb96651e8aa1522$var$PointerEvents10, Selection: $2fb96651e8aa1522$var$Selection14, Text: $2fb96651e8aa1522$var$Text7, Marker: $2fb96651e8aa1522$var$Marker4, mergeDefaults: $2fb96651e8aa1522$var$mergeDefaults6, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle15 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadarSeriesNodeEvent = class extends (0, $iTJTu._ModuleSupport).SeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.angleKey = series.properties.angleKey;
        this.radiusKey = series.properties.radiusKey;
    }
};
var $2fb96651e8aa1522$var$RadarSeries = class extends (0, $iTJTu._ModuleSupport).PolarSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            categoryKey: "angleValue",
            useLabelLayer: true,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode16.NEAREST_NODE,
                $2fb96651e8aa1522$var$SeriesNodePickMode16.EXACT_SHAPE_MATCH
            ],
            canHaveAxes: true,
            animationResetFns: {
                item: $2fb96651e8aa1522$var$resetMarkerFn2
            },
            clipFocusBox: false
        });
        this.properties = new $2fb96651e8aa1522$var$RadarSeriesProperties();
        this.NodeEvent = $2fb96651e8aa1522$var$RadarSeriesNodeEvent;
        this.lineGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group18({
            name: "radar-line"
        }));
        this.lineSelection = $2fb96651e8aa1522$var$Selection14.select(this.lineGroup, $2fb96651e8aa1522$var$Path11);
        this.resetInvalidToZero = false;
        this.circleCache = {
            r: 0,
            cx: 0,
            cy: 0
        };
        this.lineGroup.zIndex = 0;
        this.itemGroup.zIndex = 1;
    }
    nodeFactory() {
        return new $2fb96651e8aa1522$var$Marker4();
    }
    getSeriesDomain(direction) {
        const { dataModel: dataModel, processedData: processedData } = this;
        if (!processedData || !dataModel) return [];
        if (direction === $2fb96651e8aa1522$var$ChartAxisDirection27.Angle) return dataModel.getDomain(this, `angleValue`, "value", processedData);
        else {
            const domain = dataModel.getDomain(this, `radiusValue`, "value", processedData);
            const ext = $2fb96651e8aa1522$var$extent2(domain.length === 0 ? domain : [
                0
            ].concat(domain));
            return $2fb96651e8aa1522$var$fixNumericExtent9(ext);
        }
    }
    async processData(dataController) {
        const { angleKey: angleKey, radiusKey: radiusKey } = this.properties;
        const extraProps = [];
        if (!this.ctx.animationManager.isSkipped()) extraProps.push($2fb96651e8aa1522$var$animationValidation8());
        const radiusScaleType = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection27.Radius]?.scale.type;
        const angleScaleType = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection27.Angle]?.scale.type;
        await this.requestDataModel(dataController, this.data, {
            props: [
                $2fb96651e8aa1522$var$valueProperty17(angleKey, angleScaleType, {
                    id: "angleValue"
                }),
                $2fb96651e8aa1522$var$valueProperty17(radiusKey, radiusScaleType, {
                    id: "radiusValue",
                    invalidValue: void 0
                }),
                ...extraProps
            ]
        });
        this.animationState.transition("updateData");
    }
    didCircleChange() {
        const r = this.radius;
        const cx = this.centerX;
        const cy = this.centerY;
        const cache = this.circleCache;
        if (!(r === cache.r && cx === cache.cx && cy === cache.cy)) {
            this.circleCache = {
                r: r,
                cx: cx,
                cy: cy
            };
            return true;
        }
        return false;
    }
    getAxisInnerRadius() {
        const radiusAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection27.Radius];
        return radiusAxis instanceof $2fb96651e8aa1522$var$PolarAxis2 ? this.radius * radiusAxis.innerRadiusRatio : 0;
    }
    maybeRefreshNodeData() {
        const didCircleChange = this.didCircleChange();
        if (!didCircleChange && !this.nodeDataRefresh) return;
        const { nodeData: nodeData = [] } = this.createNodeData() ?? {};
        this.nodeData = nodeData;
        this.nodeDataRefresh = false;
    }
    createNodeData() {
        const { processedData: processedData, dataModel: dataModel } = this;
        if (!processedData || !dataModel) return;
        const { angleKey: angleKey, radiusKey: radiusKey, angleName: angleName, radiusName: radiusName, marker: marker, label: label } = this.properties;
        const angleScale = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection27.Angle]?.scale;
        const radiusScale = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection27.Radius]?.scale;
        if (!angleScale || !radiusScale) return;
        const angleValues = dataModel.resolveColumnById(this, `angleValue`, processedData);
        const radiusValues = dataModel.resolveColumnById(this, `radiusValue`, processedData);
        const axisInnerRadius = this.getAxisInnerRadius();
        const rawData = processedData.dataSources.get(this.id) ?? [];
        const nodeData = rawData.map((datum, datumIndex)=>{
            const angleDatum = angleValues[datumIndex];
            const radiusDatum = radiusValues[datumIndex];
            const angle = angleScale.convert(angleDatum);
            const radius = this.radius + axisInnerRadius - radiusScale.convert(radiusDatum);
            const cos = Math.cos(angle);
            const sin = Math.sin(angle);
            const x = cos * radius;
            const y = sin * radius;
            let labelNodeDatum;
            if (label.enabled) {
                const labelText = this.getLabelText(label, {
                    value: radiusDatum,
                    datum: datum,
                    angleKey: angleKey,
                    radiusKey: radiusKey,
                    angleName: angleName,
                    radiusName: radiusName
                });
                if (labelText) {
                    let textAlign = "right";
                    if ((0, $idDdm.isNumberEqual)(cos, 0)) textAlign = "center";
                    else if (cos > 0) textAlign = "left";
                    let textBaseline = "bottom";
                    if ((0, $idDdm.isNumberEqual)(sin, 0)) textBaseline = "middle";
                    else if (sin > 0) textBaseline = "top";
                    labelNodeDatum = {
                        x: x + cos * marker.size,
                        y: y + sin * marker.size,
                        text: labelText,
                        textAlign: textAlign,
                        textBaseline: textBaseline
                    };
                }
            }
            return {
                series: this,
                datum: datum,
                datumIndex: datumIndex,
                index: datumIndex,
                point: {
                    x: x,
                    y: y,
                    size: marker.size
                },
                midPoint: {
                    x: x,
                    y: y
                },
                label: labelNodeDatum,
                angleValue: angleDatum,
                radiusValue: radiusDatum,
                missing: !(0, $idDdm.isFiniteNumber)(angle) || !(0, $idDdm.isFiniteNumber)(radius)
            };
        });
        return {
            itemId: radiusKey,
            nodeData: nodeData,
            labelData: nodeData
        };
    }
    update({ seriesRect: seriesRect }) {
        const resize = this.checkResize(seriesRect);
        const animationEnabled = !this.ctx.animationManager.isSkipped();
        const { series: series } = this.ctx.highlightManager?.getActiveHighlight() ?? {};
        this.highlightGroup.visible = (animationEnabled || this.visible) && series === this;
        this.maybeRefreshNodeData();
        this.contentGroup.translationX = this.centerX;
        this.contentGroup.translationY = this.centerY;
        this.highlightGroup.translationX = this.centerX;
        this.highlightGroup.translationY = this.centerY;
        if (this.labelGroup) {
            this.labelGroup.translationX = this.centerX;
            this.labelGroup.translationY = this.centerY;
        }
        this.updatePathSelections();
        this.updateMarkerSelection();
        this.updateMarkers(this.itemSelection, false);
        this.updateMarkers(this.highlightSelection, true);
        this.updateLabels();
        if (resize) this.animationState.transition("resize");
        this.animationState.transition("update");
    }
    updatePathSelections() {
        const pathData = this.visible ? [
            true
        ] : [];
        this.lineSelection.update(pathData);
    }
    updateMarkerSelection() {
        if (this.properties.marker.isDirty()) {
            this.itemSelection.clear();
            this.itemSelection.cleanup();
            this.itemSelection = $2fb96651e8aa1522$var$Selection14.select(this.itemGroup, ()=>this.nodeFactory(), false);
        }
        this.itemSelection.update(this.properties.marker.enabled ? this.nodeData : []);
    }
    getMarkerFill(highlightedStyle) {
        return highlightedStyle?.fill ?? this.properties.marker.fill;
    }
    getDatumStylerProperties(datum) {
        const { id: seriesId, properties: properties } = this;
        const { angleKey: angleKey, radiusKey: radiusKey } = properties;
        return {
            seriesId: seriesId,
            datum: datum,
            angleKey: angleKey,
            radiusKey: radiusKey
        };
    }
    updateMarkers(selection, highlight) {
        const { visible: visible } = this;
        const { marker: marker, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, highlightStyle: highlightStyle } = this.properties;
        let selectionData = [];
        if (visible && marker.shape && marker.enabled) {
            if (highlight) {
                const highlighted = this.ctx.highlightManager?.getActiveHighlight();
                if (highlighted?.datum) selectionData = [
                    highlighted
                ];
            } else selectionData = this.nodeData;
        }
        const baseStyle = $2fb96651e8aa1522$var$mergeDefaults6(highlight && highlightStyle.item, marker.getStyle(), {
            stroke: stroke2,
            strokeWidth: strokeWidth,
            strokeOpacity: strokeOpacity
        });
        const fillBBox = this.getShapeFillBBox();
        selection.update(selectionData).each((node, datum)=>{
            this.updateMarkerStyle(marker, node, datum.datum, datum.point, this.getDatumStylerProperties(datum), highlight, baseStyle, fillBBox);
        });
    }
    updateLabels() {
        const { label: label } = this.properties;
        this.labelSelection.update(this.nodeData).each((node, datum)=>{
            if (label.enabled && datum.label) {
                node.x = datum.label.x;
                node.y = datum.label.y;
                node.fill = label.color;
                node.fontFamily = label.fontFamily;
                node.fontSize = label.fontSize;
                node.fontStyle = label.fontStyle;
                node.fontWeight = label.fontWeight;
                node.text = datum.label.text;
                node.textAlign = datum.label.textAlign;
                node.textBaseline = datum.label.textBaseline;
                node.visible = true;
            } else node.visible = false;
        });
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, axes: axes, properties: properties } = this;
        const { angleKey: angleKey, angleName: angleName, radiusKey: radiusKey, radiusName: radiusName, tooltip: tooltip, marker: marker } = properties;
        const angleAxis = axes[$2fb96651e8aa1522$var$ChartAxisDirection27.Angle];
        const radiusAxis = axes[$2fb96651e8aa1522$var$ChartAxisDirection27.Radius];
        if (!dataModel || !processedData || !angleAxis || !radiusAxis) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const angleValue = dataModel.resolveColumnById(this, `angleValue`, processedData)[datumIndex];
        const radiusValue = dataModel.resolveColumnById(this, `radiusValue`, processedData)[datumIndex];
        if (angleValue == null) return;
        const activeStyle = this.getMarkerStyle(marker, datum, this.getDatumStylerProperties(datum), false);
        return this.formatTooltipWithContext(tooltip, {
            heading: angleAxis.formatDatum(angleValue),
            symbol: this.legendItemSymbol(),
            data: [
                {
                    label: radiusName,
                    fallbackLabel: radiusKey,
                    value: radiusAxis.formatDatum(radiusValue)
                }
            ]
        }, {
            seriesId: seriesId,
            datum: datum,
            title: angleName,
            angleKey: angleKey,
            radiusKey: radiusKey,
            angleName: angleName,
            radiusName: radiusName,
            ...activeStyle
        });
    }
    legendItemSymbol() {
        const { stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, marker: marker } = this.properties;
        const markerStyle = $2fb96651e8aa1522$var$getShapeStyle15({
            shape: marker.shape,
            enabled: marker.enabled || strokeWidth <= 0,
            fill: this.getMarkerFill() ?? marker.stroke ?? stroke2 ?? "rgba(0, 0, 0, 0)",
            stroke: marker.stroke ?? stroke2 ?? "rgba(0, 0, 0, 0)",
            fillOpacity: marker.fillOpacity,
            strokeOpacity: marker.strokeOpacity,
            strokeWidth: marker.strokeWidth,
            lineDash: marker.lineDash,
            lineDashOffset: marker.lineDashOffset
        }, marker.fillGradientDefaults, marker.fillPatternDefaults, marker.fillImageDefaults);
        return {
            marker: markerStyle,
            line: {
                stroke: stroke2,
                strokeOpacity: strokeOpacity,
                strokeWidth: strokeWidth,
                lineDash: lineDash
            }
        };
    }
    getLegendData(legendType) {
        if (legendType !== "category") return [];
        const { id: seriesId, ctx: { legendManager: legendManager }, visible: visible } = this;
        const { radiusKey: radiusKey, radiusName: radiusName, showInLegend: showInLegend } = this.properties;
        return [
            {
                legendType: "category",
                id: seriesId,
                itemId: radiusKey,
                seriesId: seriesId,
                enabled: visible && legendManager.getItemEnabled({
                    seriesId: seriesId,
                    itemId: radiusKey
                }),
                label: {
                    text: radiusName ?? radiusKey
                },
                symbol: this.legendItemSymbol(),
                hideInLegend: !showInLegend
            }
        ];
    }
    pickNodeClosestDatum(hitPoint) {
        const { nodeData: nodeData, centerX: cx, centerY: cy } = this;
        const { x: x, y: y } = hitPoint;
        const radius = this.radius;
        const distanceFromCenter = Math.sqrt((x - cx) ** 2 + (y - cy) ** 2);
        if (distanceFromCenter > radius + this.properties.marker.size) return;
        let minDistance = Infinity;
        let closestDatum;
        for (const datum of nodeData){
            const { point: { x: datumX = NaN, y: datumY = NaN } = {} } = datum;
            if (isNaN(datumX) || isNaN(datumY)) continue;
            const distance = Math.sqrt((hitPoint.x - datumX - cx) ** 2 + (hitPoint.y - datumY - cy) ** 2);
            if (distance < minDistance) {
                minDistance = distance;
                closestDatum = datum;
            }
        }
        if (closestDatum) {
            const distance = Math.max(minDistance - (closestDatum.point?.size ?? 0), 0);
            return {
                datum: closestDatum,
                distance: distance
            };
        }
    }
    computeLabelsBBox() {
        const { label: label } = this.properties;
        this.maybeRefreshNodeData();
        const textBoxes = [];
        const tempText2 = new $2fb96651e8aa1522$var$Text7();
        this.nodeData.forEach((nodeDatum)=>{
            if (!label.enabled || !nodeDatum.label) return;
            tempText2.text = nodeDatum.label.text;
            tempText2.x = nodeDatum.label.x;
            tempText2.y = nodeDatum.label.y;
            tempText2.setFont(label);
            tempText2.setAlign(nodeDatum.label);
            const box = tempText2.getBBox();
            textBoxes.push(box);
        });
        if (textBoxes.length === 0) return null;
        return $2fb96651e8aa1522$var$BBox21.merge(textBoxes);
    }
    getLineNode() {
        return this.lineSelection?.at(0);
    }
    beforePathAnimation() {
        const lineNode = this.getLineNode();
        if (!lineNode) return;
        lineNode.fill = void 0;
        lineNode.lineJoin = "round";
        lineNode.lineCap = "round";
        lineNode.pointerEvents = $2fb96651e8aa1522$var$PointerEvents10.None;
        lineNode.stroke = this.properties.stroke;
        lineNode.strokeWidth = this.getStrokeWidth(this.properties.strokeWidth);
        lineNode.strokeOpacity = this.properties.strokeOpacity;
        lineNode.lineDash = this.properties.lineDash;
        lineNode.lineDashOffset = this.properties.lineDashOffset;
    }
    getLinePoints() {
        const { nodeData: nodeData, resetInvalidToZero: resetInvalidToZero } = this;
        const { connectMissingData: connectMissingData } = this.properties;
        if (nodeData.length === 0) return [];
        const radiusAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection27.Radius];
        const angleAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection27.Angle];
        const reversedAngleAxis = angleAxis?.isReversed();
        const reversedRadiusAxis = radiusAxis?.isReversed();
        const data = reversedRadiusAxis && !reversedAngleAxis ? [
            ...nodeData
        ].reverse() : nodeData;
        const points = [];
        let prevPointInvalid = false;
        let firstValid;
        data.forEach((datum, index)=>{
            let { x: x, y: y } = datum.point;
            const isPointInvalid = isNaN(x) || isNaN(y);
            if (!isPointInvalid) firstValid ?? (firstValid = datum);
            if (isPointInvalid && !connectMissingData) {
                x = 0;
                y = 0;
            }
            const moveTo = index === 0 || !resetInvalidToZero && !connectMissingData && (isPointInvalid || prevPointInvalid);
            points.push({
                x: x,
                y: y,
                moveTo: moveTo
            });
            prevPointInvalid = isPointInvalid;
        });
        if (firstValid !== void 0) points.push({
            x: firstValid.point.x,
            y: firstValid.point.y,
            moveTo: false
        });
        return points;
    }
    animateSinglePath(pathNode, points, ratio3) {
        const { path: path } = pathNode;
        path.clear(true);
        const axisInnerRadius = this.getAxisInnerRadius();
        const radiusAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection27.Radius];
        const reversedRadiusAxis = radiusAxis?.isReversed();
        const radiusZero = reversedRadiusAxis ? this.radius + axisInnerRadius - radiusAxis?.scale.convert(0) : axisInnerRadius;
        points.forEach((point)=>{
            const { x: x1, y: y1, arc: arc, radius: radius = 0, startAngle: startAngle = 0, endAngle: endAngle = 0, moveTo: moveTo } = point;
            const angle = Math.atan2(y1, x1);
            const x0 = radiusZero * Math.cos(angle);
            const y0 = radiusZero * Math.sin(angle);
            const t = ratio3;
            const x = x0 * (1 - t) + x1 * t;
            const y = y0 * (1 - t) + y1 * t;
            if (arc) path.arc(x1, y1, radius, startAngle, endAngle);
            else if (moveTo) path.moveTo(x, y);
            else path.lineTo(x, y);
        });
        pathNode.checkPathDirty();
    }
    animatePaths(ratio3) {
        const linePoints = this.getLinePoints();
        const lineNode = this.getLineNode();
        if (!lineNode) return;
        this.animateSinglePath(lineNode, linePoints, ratio3);
    }
    animateEmptyUpdateReady() {
        const { itemSelection: itemSelection, labelSelection: labelSelection } = this;
        const { animationManager: animationManager } = this.ctx;
        this.beforePathAnimation();
        animationManager.animate({
            id: `${this.id}_'path`,
            groupId: this.id,
            from: 0,
            to: 1,
            phase: "initial",
            collapsable: false,
            onUpdate: (ratio3)=>this.animatePaths(ratio3),
            onStop: ()=>this.animatePaths(1)
        });
        $2fb96651e8aa1522$var$markerFadeInAnimation2(this, animationManager, "added", itemSelection);
        $2fb96651e8aa1522$var$seriesLabelFadeInAnimation7(this, "labels", animationManager, labelSelection);
    }
    animateWaitingUpdateReady(data) {
        super.animateWaitingUpdateReady(data);
        this.resetPaths();
    }
    animateReadyResize(data) {
        super.animateReadyResize(data);
        this.resetPaths();
    }
    resetPaths() {
        const lineNode = this.getLineNode();
        if (lineNode) {
            const { path: linePath } = lineNode;
            const linePoints = this.getLinePoints();
            lineNode.fill = void 0;
            lineNode.stroke = this.properties.stroke;
            lineNode.strokeWidth = this.getStrokeWidth(this.properties.strokeWidth);
            lineNode.strokeOpacity = this.properties.strokeOpacity;
            lineNode.lineDash = this.properties.lineDash;
            lineNode.lineDashOffset = this.properties.lineDashOffset;
            linePath.clear(true);
            for (const { x: x, y: y, moveTo: moveTo } of linePoints)if (moveTo) linePath.moveTo(x, y);
            else linePath.lineTo(x, y);
            lineNode.checkPathDirty();
        }
    }
    getFormattedMarkerStyle(datum) {
        const { angleKey: angleKey, radiusKey: radiusKey } = this.properties;
        return this.getMarkerStyle(this.properties.marker, datum.datum, {
            angleKey: angleKey,
            radiusKey: radiusKey
        }, true);
    }
    computeFocusBounds(opts) {
        return $2fb96651e8aa1522$var$computeMarkerFocusBounds3(this, opts);
    }
};
$2fb96651e8aa1522$var$RadarSeries.className = "RadarSeries";
var { FillGradientDefaults: $2fb96651e8aa1522$var$FillGradientDefaults14, FillPatternDefaults: $2fb96651e8aa1522$var$FillPatternDefaults14, FillImageDefaults: $2fb96651e8aa1522$var$FillImageDefaults14, Property: $2fb96651e8aa1522$var$Property78 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadarAreaSeriesProperties = class extends $2fb96651e8aa1522$var$RadarSeriesProperties {
    constructor(){
        super(...arguments);
        this.fill = "black";
        this.fillGradientDefaults = new $2fb96651e8aa1522$var$FillGradientDefaults14();
        this.fillPatternDefaults = new $2fb96651e8aa1522$var$FillPatternDefaults14();
        this.fillImageDefaults = new $2fb96651e8aa1522$var$FillImageDefaults14();
        this.fillOpacity = 1;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property78
], $2fb96651e8aa1522$var$RadarAreaSeriesProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property78
], $2fb96651e8aa1522$var$RadarAreaSeriesProperties.prototype, "fillGradientDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property78
], $2fb96651e8aa1522$var$RadarAreaSeriesProperties.prototype, "fillPatternDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property78
], $2fb96651e8aa1522$var$RadarAreaSeriesProperties.prototype, "fillImageDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property78
], $2fb96651e8aa1522$var$RadarAreaSeriesProperties.prototype, "fillOpacity", 2);
// packages/ag-charts-enterprise/src/series/radar-area/radarAreaSeries.ts
var { Group: $2fb96651e8aa1522$var$Group19, Path: $2fb96651e8aa1522$var$Path12, PointerEvents: $2fb96651e8aa1522$var$PointerEvents11, Selection: $2fb96651e8aa1522$var$Selection15, ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection28, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle13, getShapeFill: $2fb96651e8aa1522$var$getShapeFill4, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle16 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadarAreaSeries = class extends $2fb96651e8aa1522$var$RadarSeries {
    constructor(moduleCtx){
        super(moduleCtx);
        this.properties = new $2fb96651e8aa1522$var$RadarAreaSeriesProperties();
        this.areaGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group19({
            name: "radar-area"
        }));
        this.areaSelection = $2fb96651e8aa1522$var$Selection15.select(this.areaGroup, $2fb96651e8aa1522$var$Path12);
        this.resetInvalidToZero = true;
        this.areaGroup.zIndex = -1;
    }
    updatePathSelections() {
        const pathData = this.visible ? [
            true
        ] : [];
        this.areaSelection.update(pathData);
        super.updatePathSelections();
    }
    getAreaNode() {
        return this.areaSelection.at(0);
    }
    getMarkerFill(highlightedStyle) {
        return highlightedStyle?.fill ?? this.properties.marker.fill ?? this.properties.fill;
    }
    beforePathAnimation() {
        super.beforePathAnimation();
        const areaNode = this.getAreaNode();
        const { fillOpacity: fillOpacity, fill: fill } = this.properties;
        const style = $2fb96651e8aa1522$var$getShapeStyle16({
            fill: fill,
            fillOpacity: fillOpacity
        }, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
        $2fb96651e8aa1522$var$applyShapeStyle13(areaNode, style, void 0, this.getShapeFillBBox());
        areaNode.pointerEvents = $2fb96651e8aa1522$var$PointerEvents11.None;
        areaNode.stroke = void 0;
    }
    animatePaths(ratio3) {
        super.animatePaths(ratio3);
        this.animateSinglePath(this.getAreaNode(), this.getAreaPoints(), ratio3);
    }
    getAreaPoints() {
        const points = this.getLinePoints();
        const getPolarAxis = (direction)=>{
            const axis = this.axes[direction];
            return axis instanceof (0, $iTJTu._ModuleSupport).PolarAxis ? axis : void 0;
        };
        const radiusAxis = getPolarAxis($2fb96651e8aa1522$var$ChartAxisDirection28.Radius);
        const angleAxis = getPolarAxis($2fb96651e8aa1522$var$ChartAxisDirection28.Angle);
        const reversedRadiusAxis = radiusAxis?.isReversed();
        if (!reversedRadiusAxis) return points;
        const zeroLinePoints = angleAxis?.getAxisLinePoints()?.points ?? [];
        return points.concat(...zeroLinePoints);
    }
    resetPaths() {
        super.resetPaths();
        const areaNode = this.getAreaNode();
        if (areaNode) {
            const { path: areaPath } = areaNode;
            const areaPoints = this.getAreaPoints();
            const fill = $2fb96651e8aa1522$var$getShapeFill4(this.properties.fill, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
            const fillBBox = this.getShapeFillBBox();
            $2fb96651e8aa1522$var$applyShapeStyle13(areaNode, {
                fill: fill,
                stroke: void 0,
                fillOpacity: this.properties.fillOpacity,
                lineDash: this.properties.lineDash,
                lineDashOffset: this.properties.lineDashOffset
            }, void 0, fillBBox);
            areaNode.lineJoin = areaNode.lineCap = "round";
            areaPath.clear(true);
            areaPoints.forEach(({ x: x, y: y, moveTo: moveTo, arc: arc, radius: radius = 0, startAngle: startAngle = 0, endAngle: endAngle = 0 })=>{
                if (arc) areaPath.arc(x, y, radius, startAngle, endAngle);
                else if (moveTo) areaPath.moveTo(x, y);
                else areaPath.lineTo(x, y);
            });
            areaPath.closePath();
            areaNode.checkPathDirty();
        }
    }
};
$2fb96651e8aa1522$var$RadarAreaSeries.className = "RadarAreaSeries";
$2fb96651e8aa1522$var$RadarAreaSeries.type = "radar-area";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs17, radarAreaSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$radarAreaSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$radarAreaSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$radarAreaSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs17,
    type: (0, $idDdm.required)((0, $idDdm.constant)("radar-area")),
    angleKey: (0, $idDdm.required)((0, $idDdm.string)),
    radiusKey: (0, $idDdm.required)((0, $idDdm.string)),
    angleName: (0, $idDdm.string),
    radiusName: (0, $idDdm.string)
};
// packages/ag-charts-enterprise/src/series/radar-area/radarAreaModule.ts
var { ThemeConstants: { POLAR_AXIS_TYPE: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE4 } } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadarAreaModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "polar"
    ],
    identifier: "radar-area",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$RadarAreaSeries(ctx),
    tooltipDefaults: {
        range: "nearest"
    },
    defaultAxes: [
        {
            type: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE4.ANGLE_CATEGORY
        },
        {
            type: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE4.RADIUS_NUMBER
        }
    ],
    themeTemplate: $2fb96651e8aa1522$var$RADAR_AREA_SERIES_THEME
};
var $2fb96651e8aa1522$var$RadarAreaSeriesModule = {
    type: "series",
    name: "radar-area",
    chartType: "polar",
    enterprise: true,
    options: $2fb96651e8aa1522$var$radarAreaSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$RadarAreaSeries(ctx)
};
// packages/ag-charts-enterprise/src/series/radar-line/radarLineSeries.ts
var $2fb96651e8aa1522$var$RadarLineSeries = class extends $2fb96651e8aa1522$var$RadarSeries {
    updatePathSelections() {
        this.lineSelection.update(this.visible ? [
            true
        ] : []);
    }
};
$2fb96651e8aa1522$var$RadarLineSeries.className = "RadarLineSeries";
$2fb96651e8aa1522$var$RadarLineSeries.type = "radar-line";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs18, radarLineSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$radarLineSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$radarLineSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$radarLineSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs18,
    type: (0, $idDdm.required)((0, $idDdm.constant)("radar-line")),
    angleKey: (0, $idDdm.required)((0, $idDdm.string)),
    radiusKey: (0, $idDdm.required)((0, $idDdm.string)),
    angleName: (0, $idDdm.string),
    radiusName: (0, $idDdm.string)
};
// packages/ag-charts-enterprise/src/series/radar-line/radarLineModule.ts
var { POLAR_AXIS_TYPE: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE5 } = (0, $iTJTu._ModuleSupport).ThemeConstants;
var $2fb96651e8aa1522$var$RadarLineModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "polar"
    ],
    identifier: "radar-line",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$RadarLineSeries(ctx),
    tooltipDefaults: {
        range: "nearest"
    },
    defaultAxes: [
        {
            type: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE5.ANGLE_CATEGORY
        },
        {
            type: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE5.RADIUS_NUMBER
        }
    ],
    themeTemplate: $2fb96651e8aa1522$var$RADAR_LINE_SERIES_THEME
};
var $2fb96651e8aa1522$var$RadarLineSeriesModule = {
    type: "series",
    name: "radar-line",
    chartType: "polar",
    enterprise: true,
    options: $2fb96651e8aa1522$var$radarLineSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$RadarLineSeries(ctx)
};
var { SeriesProperties: $2fb96651e8aa1522$var$SeriesProperties11, FillGradientDefaults: $2fb96651e8aa1522$var$FillGradientDefaults15, FillPatternDefaults: $2fb96651e8aa1522$var$FillPatternDefaults15, FillImageDefaults: $2fb96651e8aa1522$var$FillImageDefaults15, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip20, Property: $2fb96651e8aa1522$var$Property79, Label: $2fb96651e8aa1522$var$Label15 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadialBarSeriesProperties = class extends $2fb96651e8aa1522$var$SeriesProperties11 {
    constructor(){
        super(...arguments);
        this.fill = "black";
        this.fillGradientDefaults = new $2fb96651e8aa1522$var$FillGradientDefaults15();
        this.fillPatternDefaults = new $2fb96651e8aa1522$var$FillPatternDefaults15();
        this.fillImageDefaults = new $2fb96651e8aa1522$var$FillImageDefaults15();
        this.fillOpacity = 1;
        this.stroke = "black";
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.cornerRadius = 0;
        this.rotation = 0;
        this.label = new $2fb96651e8aa1522$var$Label15();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip20();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "angleKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "radiusKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "angleName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "radiusName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "fillGradientDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "fillPatternDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "fillImageDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "cornerRadius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "itemStyler", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "rotation", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "stackGroup", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "normalizedTo", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property79
], $2fb96651e8aa1522$var$RadialBarSeriesProperties.prototype, "tooltip", 2);
var { SectorBox: $2fb96651e8aa1522$var$SectorBox3, motion: $2fb96651e8aa1522$var$motion9 } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$fixRadialBarAnimationStatus(node, datum, status) {
    if (status === "updated") {
        if (node.previousDatum == null || isNaN(node.previousDatum.innerRadius) || isNaN(node.previousDatum.outerRadius)) return "added";
        if (isNaN(datum.innerRadius) || isNaN(datum.outerRadius)) return "removed";
    }
    if (status === "added" && node.previousDatum != null) return "updated";
    return status;
}
function $2fb96651e8aa1522$var$prepareRadialBarSeriesAnimationFunctions(axisZeroAngle) {
    const fromFn = (sect, datum, status)=>{
        status = $2fb96651e8aa1522$var$fixRadialBarAnimationStatus(sect, datum, status);
        let startAngle;
        let endAngle;
        let innerRadius;
        let outerRadius;
        let clipSector;
        if (status === "removed" || status === "updated") {
            startAngle = sect.startAngle;
            endAngle = sect.endAngle;
            innerRadius = sect.innerRadius;
            outerRadius = sect.outerRadius;
            clipSector = sect.clipSector;
        } else {
            startAngle = axisZeroAngle;
            endAngle = axisZeroAngle;
            innerRadius = datum.innerRadius;
            outerRadius = datum.outerRadius;
        }
        clipSector ?? (clipSector = new $2fb96651e8aa1522$var$SectorBox3(startAngle, endAngle, innerRadius, outerRadius));
        const phase = $2fb96651e8aa1522$var$motion9.NODE_UPDATE_STATE_TO_PHASE_MAPPING[status];
        return {
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            clipSector: clipSector,
            phase: phase
        };
    };
    const toFn = (sect, datum, status)=>{
        let startAngle;
        let endAngle;
        let innerRadius;
        let outerRadius;
        let clipSector;
        if (status === "removed") {
            startAngle = axisZeroAngle;
            endAngle = axisZeroAngle;
            innerRadius = datum.innerRadius;
            outerRadius = datum.outerRadius;
            clipSector = new $2fb96651e8aa1522$var$SectorBox3(startAngle, endAngle, innerRadius, outerRadius);
        } else {
            startAngle = datum.startAngle;
            endAngle = datum.endAngle;
            innerRadius = isNaN(datum.innerRadius) ? sect.innerRadius : datum.innerRadius;
            outerRadius = isNaN(datum.outerRadius) ? sect.outerRadius : datum.outerRadius;
            clipSector = datum.clipSector;
        }
        return {
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            clipSector: clipSector
        };
    };
    return {
        toFn: toFn,
        fromFn: fromFn
    };
}
function $2fb96651e8aa1522$var$resetRadialBarSelectionsFn(_node, datum) {
    return {
        centerX: 0,
        centerY: 0,
        innerRadius: datum.innerRadius,
        outerRadius: datum.outerRadius,
        startAngle: datum.startAngle,
        endAngle: datum.endAngle,
        clipSector: datum.clipSector
    };
}
// packages/ag-charts-enterprise/src/series/radial-bar/radialBarSeries.ts
var { ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection29, PolarAxis: $2fb96651e8aa1522$var$PolarAxis3, diff: $2fb96651e8aa1522$var$diff7, groupAccumulativeValueProperty: $2fb96651e8aa1522$var$groupAccumulativeValueProperty3, keyProperty: $2fb96651e8aa1522$var$keyProperty10, normaliseGroupTo: $2fb96651e8aa1522$var$normaliseGroupTo2, valueProperty: $2fb96651e8aa1522$var$valueProperty18, fixNumericExtent: $2fb96651e8aa1522$var$fixNumericExtent10, resetLabelFn: $2fb96651e8aa1522$var$resetLabelFn6, seriesLabelFadeInAnimation: $2fb96651e8aa1522$var$seriesLabelFadeInAnimation8, seriesLabelFadeOutAnimation: $2fb96651e8aa1522$var$seriesLabelFadeOutAnimation2, animationValidation: $2fb96651e8aa1522$var$animationValidation9, angleBetween: $2fb96651e8aa1522$var$angleBetween3, createDatumId: $2fb96651e8aa1522$var$createDatumId20, CategoryScale: $2fb96651e8aa1522$var$CategoryScale4, Sector: $2fb96651e8aa1522$var$Sector5, SectorBox: $2fb96651e8aa1522$var$SectorBox4, motion: $2fb96651e8aa1522$var$motion10, isGradientFill: $2fb96651e8aa1522$var$isGradientFill4, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle14, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle17 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadialBarSeriesNodeEvent = class extends (0, $iTJTu._ModuleSupport).SeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.angleKey = series.properties.angleKey;
        this.radiusKey = series.properties.radiusKey;
    }
};
var $2fb96651e8aa1522$var$RadialBarSeries = class extends (0, $iTJTu._ModuleSupport).PolarSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            categoryKey: "radiusValue",
            useLabelLayer: true,
            canHaveAxes: true,
            animationResetFns: {
                item: $2fb96651e8aa1522$var$resetRadialBarSelectionsFn,
                label: $2fb96651e8aa1522$var$resetLabelFn6
            }
        });
        this.properties = new $2fb96651e8aa1522$var$RadialBarSeriesProperties();
        this.NodeEvent = $2fb96651e8aa1522$var$RadialBarSeriesNodeEvent;
        this.groupScale = new $2fb96651e8aa1522$var$CategoryScale4();
        this.circleCache = {
            r: 0,
            cx: 0,
            cy: 0
        };
    }
    get defaultShapeStyle() {
        const angleScale = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection29.Angle]?.scale;
        return {
            ...this.properties.fillGradientDefaults.toJson(),
            rotation: (0, $iTJTu._ModuleSupport).toDegrees(angleScale.range[0]) + 90
        };
    }
    nodeFactory() {
        return new $2fb96651e8aa1522$var$Sector5();
    }
    getSeriesDomain(direction) {
        const { dataModel: dataModel, processedData: processedData } = this;
        if (!processedData || !dataModel) return [];
        if (direction === $2fb96651e8aa1522$var$ChartAxisDirection29.Angle) {
            const xExtent = dataModel.getDomain(this, "angleValue-end", "value", processedData);
            const fixedXExtent = [
                xExtent[0] > 0 ? 0 : xExtent[0],
                xExtent[1] < 0 ? 0 : xExtent[1]
            ];
            return $2fb96651e8aa1522$var$fixNumericExtent10(fixedXExtent);
        } else return dataModel.getDomain(this, "radiusValue", "key", processedData);
    }
    async processData(dataController) {
        const { angleKey: angleKey, radiusKey: radiusKey, normalizedTo: normalizedTo } = this.properties;
        const animationEnabled = !this.ctx.animationManager.isSkipped();
        const stackGroupId = this.getStackId();
        const stackGroupTrailingId = `${stackGroupId}-trailing`;
        const extraProps = [];
        if ((0, $idDdm.isDefined)(normalizedTo)) extraProps.push($2fb96651e8aa1522$var$normaliseGroupTo2([
            stackGroupId,
            stackGroupTrailingId
        ], Math.abs(normalizedTo)));
        if (animationEnabled) {
            if (this.processedData) extraProps.push($2fb96651e8aa1522$var$diff7(this.id, this.processedData));
            extraProps.push($2fb96651e8aa1522$var$animationValidation9());
        }
        const visibleProps = this.visible ? {} : {
            forceValue: 0
        };
        const radiusScaleType = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection29.Radius]?.scale.type;
        const angleScaleType = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection29.Angle]?.scale.type;
        await this.requestDataModel(dataController, this.data, {
            props: [
                $2fb96651e8aa1522$var$keyProperty10(radiusKey, radiusScaleType, {
                    id: "radiusValue"
                }),
                $2fb96651e8aa1522$var$valueProperty18(angleKey, angleScaleType, {
                    id: "angleValue-raw",
                    invalidValue: null,
                    ...visibleProps
                }),
                ...$2fb96651e8aa1522$var$groupAccumulativeValueProperty3(angleKey, "normal", "current", {
                    id: `angleValue-end`,
                    rangeId: `angleValue-range`,
                    invalidValue: null,
                    groupId: stackGroupId,
                    separateNegative: true,
                    ...visibleProps
                }, angleScaleType),
                ...$2fb96651e8aa1522$var$groupAccumulativeValueProperty3(angleKey, "trailing", "current", {
                    id: `angleValue-start`,
                    invalidValue: null,
                    groupId: stackGroupTrailingId,
                    separateNegative: true,
                    ...visibleProps
                }, angleScaleType),
                ...extraProps
            ],
            groupByKeys: true,
            groupByData: false
        });
        this.animationState.transition("updateData");
    }
    didCircleChange() {
        const r = this.radius;
        const cx = this.centerX;
        const cy = this.centerY;
        const cache = this.circleCache;
        if (!(r === cache.r && cx === cache.cx && cy === cache.cy)) {
            this.circleCache = {
                r: r,
                cx: cx,
                cy: cy
            };
            return true;
        }
        return false;
    }
    maybeRefreshNodeData() {
        const circleChanged = this.didCircleChange();
        if (!circleChanged && !this.nodeDataRefresh) return;
        const { nodeData: nodeData = [] } = this.createNodeData() ?? {};
        this.nodeData = nodeData;
        this.nodeDataRefresh = false;
    }
    getAxisInnerRadius() {
        const radiusAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection29.Radius];
        return radiusAxis instanceof $2fb96651e8aa1522$var$PolarAxis3 ? this.radius * radiusAxis.innerRadiusRatio : 0;
    }
    createNodeData() {
        const { processedData: processedData, dataModel: dataModel } = this;
        if (!dataModel || !processedData || processedData.type !== "grouped") return;
        const angleAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection29.Angle];
        const radiusAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection29.Radius];
        const angleScale = angleAxis?.scale;
        const radiusScale = radiusAxis?.scale;
        if (!angleScale || !radiusScale) return;
        const radiusValues = dataModel.resolveKeysById(this, "radiusValue", processedData);
        const angleStartValues = dataModel.resolveColumnById(this, `angleValue-start`, processedData);
        const angleEndValues = dataModel.resolveColumnById(this, `angleValue-end`, processedData);
        const angleRawValues = dataModel.resolveColumnById(this, `angleValue-raw`, processedData);
        const angleRangeIndex = dataModel.resolveProcessedDataIndexById(this, `angleValue-range`);
        let groupPaddingInner = 0;
        if (radiusAxis instanceof $2fb96651e8aa1522$var$RadiusCategoryAxis) groupPaddingInner = radiusAxis.groupPaddingInner;
        const { groupScale: groupScale } = this;
        const { index: groupIndex, visibleGroupCount: visibleGroupCount } = this.ctx.seriesStateManager.getVisiblePeerGroupIndex(this);
        groupScale.domain = Array.from({
            length: visibleGroupCount
        }).map((_, i)=>String(i));
        groupScale.range = [
            0,
            Math.abs(radiusScale.bandwidth ?? 0)
        ];
        groupScale.paddingInner = visibleGroupCount > 1 ? groupPaddingInner : 0;
        const barWidth = groupScale.bandwidth >= 1 ? groupScale.bandwidth : groupScale.rawBandwidth;
        const angleAxisReversed = angleAxis.isReversed();
        const radiusAxisReversed = radiusAxis.isReversed();
        const axisInnerRadius = radiusAxisReversed ? this.radius : this.getAxisInnerRadius();
        const axisOuterRadius = radiusAxisReversed ? this.getAxisInnerRadius() : this.radius;
        const axisTotalRadius = axisOuterRadius + axisInnerRadius;
        const { angleKey: angleKey, radiusKey: radiusKey, angleName: angleName, radiusName: radiusName, label: label } = this.properties;
        const getLabelNodeDatum = (datum, angleDatum, x, y)=>{
            const labelText = this.getLabelText(label, {
                value: angleDatum,
                datum: datum,
                angleKey: angleKey,
                radiusKey: radiusKey,
                angleName: angleName,
                radiusName: radiusName
            });
            if (labelText) return {
                x: x,
                y: y,
                text: labelText,
                textAlign: "center",
                textBaseline: "middle"
            };
        };
        const nodeData = [];
        const context = {
            itemId: radiusKey,
            nodeData: nodeData,
            labelData: nodeData
        };
        if (!this.visible) return context;
        const { dataSources: dataSources } = processedData;
        const rawData = dataSources.get(this.id) ?? [];
        for (const { datumIndex: datumIndex, group: group } of dataModel.forEachGroupDatum(this, processedData)){
            const datum = rawData[datumIndex];
            const radiusDatum = radiusValues[datumIndex];
            if (radiusDatum == null) return;
            const angleDatum = angleRawValues[datumIndex];
            const angleStartDatum = angleStartValues[datumIndex];
            const angleEndDatum = angleEndValues[datumIndex];
            const isPositive = angleDatum >= 0 && !Object.is(angleDatum, -0);
            const angleRange = group.aggregation[angleRangeIndex][isPositive ? 1 : 0];
            const reversed = isPositive === angleAxisReversed;
            let startAngle = angleScale.convert(angleStartDatum, {
                clamp: true
            });
            let endAngle = angleScale.convert(angleEndDatum, {
                clamp: true
            });
            let rangeStartAngle = angleScale.convert(0, {
                clamp: true
            });
            let rangeEndAngle = angleScale.convert(angleRange, {
                clamp: true
            });
            if (reversed) {
                [rangeStartAngle, rangeEndAngle] = [
                    rangeEndAngle,
                    rangeStartAngle
                ];
                [startAngle, endAngle] = [
                    endAngle,
                    startAngle
                ];
            }
            const dataRadius = axisTotalRadius - radiusScale.convert(radiusDatum);
            const innerRadius = dataRadius + groupScale.convert(String(groupIndex));
            const outerRadius = innerRadius + barWidth;
            const midRadius = (innerRadius + outerRadius) / 2;
            const midAngle = startAngle + $2fb96651e8aa1522$var$angleBetween3(startAngle, endAngle) / 2;
            const x = Math.cos(midAngle) * midRadius;
            const y = Math.sin(midAngle) * midRadius;
            const labelNodeDatum = this.properties.label.enabled ? getLabelNodeDatum(datum, angleDatum, x, y) : void 0;
            const clipSector = new $2fb96651e8aa1522$var$SectorBox4(startAngle, endAngle, innerRadius, outerRadius);
            nodeData.push({
                series: this,
                datum: datum,
                datumIndex: datumIndex,
                point: {
                    x: x,
                    y: y,
                    size: 0
                },
                midPoint: {
                    x: x,
                    y: y
                },
                label: labelNodeDatum,
                angleValue: angleDatum,
                radiusValue: radiusDatum,
                innerRadius: innerRadius,
                outerRadius: outerRadius,
                startAngle: rangeStartAngle,
                endAngle: rangeEndAngle,
                clipSector: clipSector,
                reversed: reversed,
                index: datumIndex
            });
        }
        return context;
    }
    update({ seriesRect: seriesRect }) {
        const resize = this.checkResize(seriesRect);
        this.maybeRefreshNodeData();
        this.contentGroup.translationX = this.centerX;
        this.contentGroup.translationY = this.centerY;
        this.highlightGroup.translationX = this.centerX;
        this.highlightGroup.translationY = this.centerY;
        if (this.labelGroup) {
            this.labelGroup.translationX = this.centerX;
            this.labelGroup.translationY = this.centerY;
        }
        this.updateSectorSelection(this.itemSelection, false);
        this.updateSectorSelection(this.highlightSelection, true);
        this.updateLabels();
        if (resize) this.animationState.transition("resize");
        this.animationState.transition("update");
    }
    getItemBaseStyle(highlighted) {
        const { properties: properties } = this;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return $2fb96651e8aa1522$var$getShapeStyle17({
            fill: highlightStyle?.fill ?? properties.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? properties.fillOpacity,
            stroke: highlightStyle?.stroke ?? properties.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(properties.strokeWidth),
            strokeOpacity: highlightStyle?.strokeOpacity ?? properties.strokeOpacity,
            lineDash: highlightStyle?.lineDash ?? properties.lineDash,
            lineDashOffset: highlightStyle?.lineDashOffset ?? properties.lineDashOffset,
            cornerRadius: properties.cornerRadius
        }, this.defaultShapeStyle, properties.fillPatternDefaults, properties.fillImageDefaults);
    }
    getItemStyleOverrides(datumId, datum, format, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const { angleKey: angleKey, radiusKey: radiusKey, itemStyler: itemStyler } = properties;
        let overrides;
        if (itemStyler != null) overrides = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId20(datumId, highlighted ? "highlight" : "node"), ()=>{
            return this.callWithContext(itemStyler, {
                seriesId: seriesId,
                datum: datum,
                highlighted: highlighted,
                angleKey: angleKey,
                radiusKey: radiusKey,
                ...format
            });
        });
        return $2fb96651e8aa1522$var$getShapeStyle17(overrides, this.defaultShapeStyle, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
    }
    updateSectorSelection(selection, highlighted) {
        let selectionData = [];
        if (highlighted) {
            const activeHighlight = this.ctx.highlightManager?.getActiveHighlight();
            if (activeHighlight?.datum && activeHighlight.series === this) selectionData.push(activeHighlight);
        } else selectionData = this.nodeData;
        const style = this.getItemBaseStyle(highlighted);
        const fillBBox = this.getShapeFillBBox();
        selection.update(selectionData, void 0, (datum)=>this.getDatumId(datum)).each((node, nodeDatum)=>{
            const { datum: datum, datumIndex: datumIndex } = nodeDatum;
            const overrides = this.getItemStyleOverrides(String(datumIndex), datum, style, highlighted);
            const cornerRadius = overrides?.cornerRadius ?? style.cornerRadius;
            const fill = overrides?.fill ?? style.fill;
            const fillParams = (0, $iTJTu._ModuleSupport).isGradientFill(fill) && fill.bounds !== "item" ? {
                centerX: 0,
                centerY: 0
            } : void 0;
            $2fb96651e8aa1522$var$applyShapeStyle14(node, style, overrides, fillBBox, fillParams);
            node.lineJoin = "round";
            node.inset = node.stroke != null ? node.strokeWidth / 2 : 0;
            node.startInnerCornerRadius = datum.reversed ? cornerRadius : 0;
            node.startOuterCornerRadius = datum.reversed ? cornerRadius : 0;
            node.endInnerCornerRadius = datum.reversed ? 0 : cornerRadius;
            node.endOuterCornerRadius = datum.reversed ? 0 : cornerRadius;
            if (highlighted) {
                node.startAngle = nodeDatum.startAngle;
                node.endAngle = nodeDatum.endAngle;
                node.clipSector = nodeDatum.clipSector;
                node.innerRadius = nodeDatum.innerRadius;
                node.outerRadius = nodeDatum.outerRadius;
            }
        });
    }
    updateLabels() {
        const { label: label } = this.properties;
        this.labelSelection.update(this.nodeData).each((node, datum)=>{
            if (label.enabled && datum.label) {
                node.x = datum.label.x;
                node.y = datum.label.y;
                node.fill = label.color;
                node.fontFamily = label.fontFamily;
                node.fontSize = label.fontSize;
                node.fontStyle = label.fontStyle;
                node.fontWeight = label.fontWeight;
                node.text = datum.label.text;
                node.textAlign = datum.label.textAlign;
                node.textBaseline = datum.label.textBaseline;
                node.visible = true;
            } else node.visible = false;
        });
    }
    getBarTransitionFunctions() {
        const angleScale = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection29.Angle]?.scale;
        let axisZeroAngle = 0;
        if (!angleScale) return $2fb96651e8aa1522$var$prepareRadialBarSeriesAnimationFunctions(axisZeroAngle);
        const d0 = Math.min(angleScale.domain[0], angleScale.domain[1]);
        const d1 = Math.max(angleScale.domain[0], angleScale.domain[1]);
        if (d0 <= 0 && d1 >= 0) axisZeroAngle = angleScale.convert(0);
        return $2fb96651e8aa1522$var$prepareRadialBarSeriesAnimationFunctions(axisZeroAngle);
    }
    animateEmptyUpdateReady() {
        const { labelSelection: labelSelection } = this;
        const fns = this.getBarTransitionFunctions();
        $2fb96651e8aa1522$var$motion10.fromToMotion(this.id, "datums", this.ctx.animationManager, [
            this.itemSelection
        ], fns);
        $2fb96651e8aa1522$var$seriesLabelFadeInAnimation8(this, "labels", this.ctx.animationManager, labelSelection);
    }
    animateClearingUpdateEmpty() {
        const { itemSelection: itemSelection } = this;
        const { animationManager: animationManager } = this.ctx;
        const fns = this.getBarTransitionFunctions();
        $2fb96651e8aa1522$var$motion10.fromToMotion(this.id, "datums", animationManager, [
            itemSelection
        ], fns);
        $2fb96651e8aa1522$var$seriesLabelFadeOutAnimation2(this, "labels", animationManager, this.labelSelection);
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, dataModel: dataModel, processedData: processedData, axes: axes, properties: properties } = this;
        const { angleKey: angleKey, angleName: angleName, radiusKey: radiusKey, radiusName: radiusName, tooltip: tooltip } = properties;
        const angleAxis = axes[$2fb96651e8aa1522$var$ChartAxisDirection29.Angle];
        const radiusAxis = axes[$2fb96651e8aa1522$var$ChartAxisDirection29.Radius];
        if (!dataModel || !processedData || !angleAxis || !radiusAxis) return;
        const datum = processedData.dataSources.get(this.id)?.[datumIndex];
        const radiusValue = dataModel.resolveKeysById(this, `radiusValue`, processedData)[datumIndex];
        const angleValue = dataModel.resolveColumnById(this, `angleValue-raw`, processedData)[datumIndex];
        if (radiusValue == null) return;
        const format = this.getItemBaseStyle(false);
        Object.assign(format, this.getItemStyleOverrides(String(datumIndex), datumIndex, format, false));
        return this.formatTooltipWithContext(tooltip, {
            heading: radiusAxis.formatDatum(radiusValue),
            symbol: this.legendItemSymbol(),
            data: [
                {
                    label: angleName,
                    fallbackLabel: angleKey,
                    value: angleAxis.formatDatum(angleValue)
                }
            ]
        }, {
            seriesId: seriesId,
            datum: datum,
            title: angleName,
            angleKey: angleKey,
            angleName: angleName,
            radiusKey: radiusKey,
            radiusName: radiusName,
            ...format
        });
    }
    pickNodeClosestDatum(point) {
        return this.pickNodeNearestDistantObject(point, this.itemSelection.nodes());
    }
    legendItemSymbol() {
        const { fill: fill, stroke: stroke2, fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset, fillPatternDefaults: fillPatternDefaults4, fillImageDefaults: fillImageDefaults4 } = this.properties;
        const markerStyle = $2fb96651e8aa1522$var$getShapeStyle17({
            fill: fill ?? "rgba(0, 0, 0, 0)",
            stroke: stroke2 ?? "rgba(0, 0, 0, 0)",
            fillOpacity: fillOpacity,
            strokeOpacity: strokeOpacity,
            strokeWidth: strokeWidth,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset
        }, this.defaultShapeStyle, fillPatternDefaults4, fillImageDefaults4);
        if ($2fb96651e8aa1522$var$isGradientFill4(markerStyle.fill)) markerStyle.fill = {
            ...markerStyle.fill,
            gradient: "linear",
            rotation: 0,
            reverse: false
        };
        return {
            marker: markerStyle
        };
    }
    getLegendData(legendType) {
        if (legendType !== "category") return [];
        const { id: seriesId, visible: visible } = this;
        const { angleKey: angleKey, angleName: angleName, showInLegend: showInLegend } = this.properties;
        return [
            {
                legendType: "category",
                id: seriesId,
                itemId: angleKey,
                seriesId: seriesId,
                enabled: visible,
                label: {
                    text: angleName ?? angleKey
                },
                symbol: this.legendItemSymbol(),
                hideInLegend: !showInLegend
            }
        ];
    }
    getDatumId(datum) {
        return $2fb96651e8aa1522$var$createDatumId20(datum.radiusValue);
    }
    computeLabelsBBox() {
        return null;
    }
    getStackId() {
        const groupIndex = this.seriesGrouping?.groupIndex ?? this.id;
        return `radialBar-stack-${groupIndex}-xValues`;
    }
};
$2fb96651e8aa1522$var$RadialBarSeries.className = "RadialBarSeries";
$2fb96651e8aa1522$var$RadialBarSeries.type = "radial-bar";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs19, radialBarSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$radialBarSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$radialBarSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$radialBarSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs19,
    type: (0, $idDdm.required)((0, $idDdm.constant)("radial-bar")),
    angleKey: (0, $idDdm.required)((0, $idDdm.string)),
    radiusKey: (0, $idDdm.required)((0, $idDdm.string)),
    angleName: (0, $idDdm.string),
    radiusName: (0, $idDdm.string),
    grouped: (0, $idDdm.boolean),
    stacked: (0, $idDdm.boolean),
    stackGroup: (0, $idDdm.string),
    normalizedTo: (0, $idDdm.number)
};
var { ThemeConstants: { POLAR_AXIS_TYPE: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE6 } } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RADIAL_BAR_SERIES_THEME = {
    series: {
        fill: {
            $palette: "fill"
        },
        stroke: {
            $palette: "stroke"
        },
        // @ts-expect-error undocumented option
        fillGradientDefaults: {
            type: "gradient",
            gradient: "conic",
            bounds: "series",
            colorStops: {
                $palette: "gradient"
            },
            rotation: 0,
            reverse: false
        },
        fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
        fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
        strokeWidth: 0,
        label: {
            enabled: false,
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            fontWeight: {
                $ref: "fontWeight"
            },
            color: {
                $ref: "backgroundColor"
            }
        }
    },
    axes: {
        [$2fb96651e8aa1522$var$POLAR_AXIS_TYPE6.RADIUS_CATEGORY]: {
            innerRadiusRatio: 0.2,
            groupPaddingInner: 0.2,
            paddingInner: 0.2,
            paddingOuter: 0.1
        }
    }
};
// packages/ag-charts-enterprise/src/series/radial-bar/radialBarModule.ts
var { POLAR_AXIS_TYPE: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE7 } = (0, $iTJTu._ModuleSupport).ThemeConstants;
var $2fb96651e8aa1522$var$RadialBarModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "polar"
    ],
    identifier: "radial-bar",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$RadialBarSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    defaultAxes: [
        {
            type: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE7.ANGLE_NUMBER
        },
        {
            type: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE7.RADIUS_CATEGORY
        }
    ],
    themeTemplate: $2fb96651e8aa1522$var$RADIAL_BAR_SERIES_THEME,
    stackable: true,
    groupable: true
};
var $2fb96651e8aa1522$var$RadialBarSeriesModule = {
    type: "series",
    name: "radial-bar",
    chartType: "polar",
    enterprise: true,
    options: $2fb96651e8aa1522$var$radialBarSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$RadialBarSeries(ctx)
};
var { Property: $2fb96651e8aa1522$var$Property80 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadialColumnSeriesProperties = class extends $2fb96651e8aa1522$var$RadialColumnSeriesBaseProperties {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property80
], $2fb96651e8aa1522$var$RadialColumnSeriesProperties.prototype, "columnWidthRatio", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property80
], $2fb96651e8aa1522$var$RadialColumnSeriesProperties.prototype, "maxColumnWidthRatio", 2);
// packages/ag-charts-enterprise/src/series/radial-column/radialColumnSeries.ts
var { ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection30, PolarAxis: $2fb96651e8aa1522$var$PolarAxis4, RadialColumnShape: $2fb96651e8aa1522$var$RadialColumnShape, getRadialColumnWidth: $2fb96651e8aa1522$var$getRadialColumnWidth } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadialColumnSeries = class extends $2fb96651e8aa1522$var$RadialColumnSeriesBase {
    constructor(moduleCtx){
        super(moduleCtx, {
            animationResetFns: {
                item: $2fb96651e8aa1522$var$resetRadialColumnSelectionFn
            }
        });
        this.properties = new $2fb96651e8aa1522$var$RadialColumnSeriesProperties();
    }
    getStackId() {
        const groupIndex = this.seriesGrouping?.groupIndex ?? this.id;
        return `radarColumn-stack-${groupIndex}-yValues`;
    }
    nodeFactory() {
        return new $2fb96651e8aa1522$var$RadialColumnShape();
    }
    getColumnTransitionFunctions() {
        const axisZeroRadius = this.isRadiusAxisReversed() ? this.radius : this.getAxisInnerRadius();
        return $2fb96651e8aa1522$var$prepareRadialColumnAnimationFunctions(axisZeroRadius);
    }
    isRadiusAxisCircle() {
        const radiusAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection30.Radius];
        return radiusAxis instanceof $2fb96651e8aa1522$var$PolarAxis4 ? radiusAxis.shape === "circle" : false;
    }
    updateItemPath(node, datum, highlight) {
        node.isBeveled = this.isRadiusAxisCircle();
        node.isRadiusAxisReversed = this.isRadiusAxisReversed();
        if (highlight) {
            node.innerRadius = datum.innerRadius;
            node.outerRadius = datum.outerRadius;
            node.startAngle = datum.startAngle;
            node.endAngle = datum.endAngle;
            node.columnWidth = datum.columnWidth;
            node.axisInnerRadius = datum.axisInnerRadius;
            node.axisOuterRadius = datum.axisOuterRadius;
        }
    }
    getColumnWidth(startAngle, endAngle) {
        const { columnWidthRatio: columnWidthRatio = 0.5, maxColumnWidthRatio: maxColumnWidthRatio = 0.5 } = this.properties;
        return $2fb96651e8aa1522$var$getRadialColumnWidth(startAngle, endAngle, this.radius, columnWidthRatio, maxColumnWidthRatio);
    }
};
$2fb96651e8aa1522$var$RadialColumnSeries.className = "RadialColumnSeries";
$2fb96651e8aa1522$var$RadialColumnSeries.type = "radial-column";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs20, radialColumnSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$radialColumnSeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$radialColumnSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$radialColumnSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs20,
    type: (0, $idDdm.required)((0, $idDdm.constant)("radial-column")),
    angleKey: (0, $idDdm.required)((0, $idDdm.string)),
    radiusKey: (0, $idDdm.required)((0, $idDdm.string)),
    angleName: (0, $idDdm.string),
    radiusName: (0, $idDdm.string),
    grouped: (0, $idDdm.boolean),
    stacked: (0, $idDdm.boolean),
    stackGroup: (0, $idDdm.string),
    normalizedTo: (0, $idDdm.number)
};
var { ThemeConstants: { POLAR_AXIS_TYPE: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE8, POLAR_AXIS_SHAPE: $2fb96651e8aa1522$var$POLAR_AXIS_SHAPE2 } } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$axisShape2 = {
    $path: [
        "./shape",
        $2fb96651e8aa1522$var$POLAR_AXIS_SHAPE2.CIRCLE,
        {
            $find: [
                {
                    $not: [
                        {
                            $isOperation: "./shape"
                        }
                    ]
                },
                {
                    $path: ".."
                }
            ]
        }
    ]
};
var $2fb96651e8aa1522$var$RADIAL_COLUMN_SERIES_THEME = {
    series: {
        fill: {
            $palette: "fill"
        },
        stroke: {
            $palette: "stroke"
        },
        // @ts-expect-error undocumented option
        fillGradientDefaults: {
            type: "gradient",
            gradient: "radial",
            bounds: "series",
            colorStops: {
                $palette: "gradient"
            },
            rotation: 0,
            reverse: false
        },
        fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
        fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
        columnWidthRatio: 0.5,
        maxColumnWidthRatio: 0.5,
        strokeWidth: 0,
        label: {
            enabled: false,
            fontSize: {
                $ref: "fontSize"
            },
            fontFamily: {
                $ref: "fontFamily"
            },
            fontWeight: {
                $ref: "fontWeight"
            },
            color: {
                $ref: "textColor"
            }
        }
    },
    axes: {
        [$2fb96651e8aa1522$var$POLAR_AXIS_TYPE8.ANGLE_CATEGORY]: {
            shape: $2fb96651e8aa1522$var$axisShape2,
            groupPaddingInner: 0,
            paddingInner: 0,
            label: {
                spacing: 10
            }
        },
        [$2fb96651e8aa1522$var$POLAR_AXIS_TYPE8.RADIUS_NUMBER]: {
            shape: $2fb96651e8aa1522$var$axisShape2,
            innerRadiusRatio: 0.5
        }
    }
};
// packages/ag-charts-enterprise/src/series/radial-column/radialColumnModule.ts
var { POLAR_AXIS_TYPE: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE9 } = (0, $iTJTu._ModuleSupport).ThemeConstants;
var $2fb96651e8aa1522$var$RadialColumnModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "polar"
    ],
    identifier: "radial-column",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$RadialColumnSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    defaultAxes: [
        {
            type: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE9.ANGLE_CATEGORY
        },
        {
            type: $2fb96651e8aa1522$var$POLAR_AXIS_TYPE9.RADIUS_NUMBER
        }
    ],
    themeTemplate: $2fb96651e8aa1522$var$RADIAL_COLUMN_SERIES_THEME,
    stackable: true,
    groupable: true
};
var $2fb96651e8aa1522$var$RadialColumnSeriesModule = {
    type: "series",
    name: "radial-column",
    chartType: "polar",
    enterprise: true,
    options: $2fb96651e8aa1522$var$radialColumnSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$RadialColumnSeries(ctx)
};
var { SvgPath: $2fb96651e8aa1522$var$SvgPath, Rotatable: $2fb96651e8aa1522$var$Rotatable, Translatable: $2fb96651e8aa1522$var$Translatable, Scalable: $2fb96651e8aa1522$var$Scalable } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadialGaugeNeedle = class extends $2fb96651e8aa1522$var$Rotatable($2fb96651e8aa1522$var$Scalable($2fb96651e8aa1522$var$Translatable($2fb96651e8aa1522$var$SvgPath))) {
    constructor(){
        super(...arguments);
        this.scalingCenterX = 0.5;
        this.scalingCenterY = 0.5;
        this.rotationCenterX = 0.5;
        this.rotationCenterY = 0.5;
    }
};
$2fb96651e8aa1522$var$RadialGaugeNeedle.defaultPathData = "M0.50245 0.53745C0.481767 0.53745 0.465 0.520683 0.465 0.5C0.465 0.479317 0.481767 0.46255 0.50245 0.46255L1 0.500012L0.50245 0.53745Z";
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties27, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip21, SeriesProperties: $2fb96651e8aa1522$var$SeriesProperties12, PropertiesArray: $2fb96651e8aa1522$var$PropertiesArray8, AxisLabel: $2fb96651e8aa1522$var$AxisLabel5, Property: $2fb96651e8aa1522$var$Property81, Label: $2fb96651e8aa1522$var$Label16 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadialGaugeDefaultTargetLabelProperties = class extends $2fb96651e8aa1522$var$Label16 {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeDefaultTargetLabelProperties.prototype, "spacing", 2);
var $2fb96651e8aa1522$var$RadialGaugeTargetProperties = class extends $2fb96651e8aa1522$var$BaseProperties27 {
    constructor(){
        super(...arguments);
        this.label = new $2fb96651e8aa1522$var$RadialGaugeDefaultTargetLabelProperties();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeTargetProperties.prototype, "text", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeTargetProperties.prototype, "value", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeTargetProperties.prototype, "shape", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeTargetProperties.prototype, "placement", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeTargetProperties.prototype, "spacing", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeTargetProperties.prototype, "size", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeTargetProperties.prototype, "rotation", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeTargetProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeTargetProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeTargetProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeTargetProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeTargetProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeTargetProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeTargetProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeTargetProperties.prototype, "label", 2);
var $2fb96651e8aa1522$var$RadialGaugeBarProperties = class extends $2fb96651e8aa1522$var$BaseProperties27 {
    constructor(){
        super(...arguments);
        this.enabled = true;
        this.fills = new $2fb96651e8aa1522$var$PropertiesArray8((0, $iTJTu._ModuleSupport).StopProperties);
        this.fillMode = "continuous";
        this.fillOpacity = 1;
        this.stroke = "black";
        this.strokeWidth = 0;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeBarProperties.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeBarProperties.prototype, "fills", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeBarProperties.prototype, "fillMode", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeBarProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeBarProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeBarProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeBarProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeBarProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeBarProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeBarProperties.prototype, "lineDashOffset", 2);
var $2fb96651e8aa1522$var$RadialGaugeScaleIntervalProperties = class extends $2fb96651e8aa1522$var$BaseProperties27 {
    constructor(){
        super(...arguments);
        this.values = void 0;
        this.step = void 0;
        this.minSpacing = 0;
        this.maxSpacing = 1e3;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleIntervalProperties.prototype, "values", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleIntervalProperties.prototype, "step", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleIntervalProperties.prototype, "minSpacing", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleIntervalProperties.prototype, "maxSpacing", 2);
var $2fb96651e8aa1522$var$RadialGaugeScaleLabelProperties = class extends $2fb96651e8aa1522$var$AxisLabel5 {
};
var $2fb96651e8aa1522$var$RadialGaugeScaleProperties = class extends $2fb96651e8aa1522$var$BaseProperties27 {
    constructor(){
        super(...arguments);
        this.min = 0;
        this.max = 1;
        this.fills = new $2fb96651e8aa1522$var$PropertiesArray8((0, $iTJTu._ModuleSupport).StopProperties);
        this.fillMode = "continuous";
        this.fillOpacity = 1;
        this.stroke = "black";
        this.strokeWidth = 0;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.defaultFill = "black";
        this.interval = new $2fb96651e8aa1522$var$RadialGaugeScaleIntervalProperties();
        this.label = new $2fb96651e8aa1522$var$RadialGaugeScaleLabelProperties();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleProperties.prototype, "min", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleProperties.prototype, "max", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleProperties.prototype, "fills", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleProperties.prototype, "fillMode", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleProperties.prototype, "defaultFill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleProperties.prototype, "interval", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeScaleProperties.prototype, "label", 2);
var $2fb96651e8aa1522$var$RadialGaugeNeedleProperties = class extends $2fb96651e8aa1522$var$BaseProperties27 {
    constructor(){
        super(...arguments);
        this.enabled = true;
        this.spacing = 0;
        this.fill = "black";
        this.fillOpacity = 1;
        this.stroke = "black";
        this.strokeWidth = 0;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeNeedleProperties.prototype, "enabled", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeNeedleProperties.prototype, "radiusRatio", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeNeedleProperties.prototype, "spacing", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeNeedleProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeNeedleProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeNeedleProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeNeedleProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeNeedleProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeNeedleProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeNeedleProperties.prototype, "lineDashOffset", 2);
var $2fb96651e8aa1522$var$RadialGaugeLabelProperties = class extends $2fb96651e8aa1522$var$AutoSizedLabel {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeLabelProperties.prototype, "text", 2);
var $2fb96651e8aa1522$var$RadialGaugeSecondaryLabelProperties = class extends $2fb96651e8aa1522$var$AutoSizedSecondaryLabel {
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSecondaryLabelProperties.prototype, "text", 2);
var $2fb96651e8aa1522$var$RadialGaugeSeriesProperties = class extends $2fb96651e8aa1522$var$SeriesProperties12 {
    constructor(){
        super(...arguments);
        this.startAngle = 0;
        this.endAngle = 0;
        this.segmentation = new $2fb96651e8aa1522$var$GaugeSegmentationProperties();
        this.defaultColorRange = [];
        this.targets = new $2fb96651e8aa1522$var$PropertiesArray8($2fb96651e8aa1522$var$RadialGaugeTargetProperties);
        this.defaultTarget = new $2fb96651e8aa1522$var$RadialGaugeTargetProperties();
        this.outerRadiusRatio = 1;
        this.innerRadiusRatio = 1;
        this.cornerRadius = 0;
        this.cornerMode = "container";
        this.spacing = 0;
        this.scale = new $2fb96651e8aa1522$var$RadialGaugeScaleProperties();
        this.bar = new $2fb96651e8aa1522$var$RadialGaugeBarProperties();
        this.needle = new $2fb96651e8aa1522$var$RadialGaugeNeedleProperties();
        this.label = new $2fb96651e8aa1522$var$RadialGaugeLabelProperties();
        this.secondaryLabel = new $2fb96651e8aa1522$var$RadialGaugeSecondaryLabelProperties();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip21();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "value", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "startAngle", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "endAngle", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "segmentation", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "defaultColorRange", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "targets", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "defaultTarget", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "outerRadiusRatio", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "innerRadiusRatio", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "outerRadius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "innerRadius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "cornerRadius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "cornerMode", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "spacing", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "scale", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "bar", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "needle", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "secondaryLabel", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property81
], $2fb96651e8aa1522$var$RadialGaugeSeriesProperties.prototype, "tooltip", 2);
var { SectorBox: $2fb96651e8aa1522$var$SectorBox5 } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$computeClipSector(datum) {
    const { startAngle: startAngle, endAngle: endAngle, clipStartAngle: clipStartAngle, clipEndAngle: clipEndAngle, innerRadius: innerRadius, outerRadius: outerRadius } = datum;
    if (clipStartAngle == null || clipEndAngle == null) return;
    return new $2fb96651e8aa1522$var$SectorBox5(Math.max(clipStartAngle, startAngle), Math.min(clipEndAngle, endAngle), innerRadius, outerRadius);
}
function $2fb96651e8aa1522$var$clipSectorVisibility(startAngle, endAngle, clipSector) {
    return Math.max(startAngle, clipSector.startAngle) <= Math.min(endAngle, clipSector.endAngle);
}
function $2fb96651e8aa1522$var$hasClipSector(datum) {
    return datum.clipStartAngle != null && datum.clipEndAngle != null;
}
function $2fb96651e8aa1522$var$datumClipSector(datum, zero) {
    const { clipStartAngle: clipStartAngle, clipEndAngle: clipEndAngle, innerRadius: innerRadius, outerRadius: outerRadius } = datum;
    return new $2fb96651e8aa1522$var$SectorBox5(clipStartAngle, zero ? clipStartAngle : clipEndAngle, innerRadius, outerRadius);
}
function $2fb96651e8aa1522$var$prepareRadialGaugeSeriesAnimationFunctions(initialLoad, initialStartAngle) {
    const phase = initialLoad ? "initial" : "update";
    const node = {
        fromFn (sect, datum) {
            const previousDatum = sect.previousDatum;
            let { startAngle: startAngle, endAngle: endAngle } = previousDatum ?? datum;
            const previousClipSector = previousDatum != null && $2fb96651e8aa1522$var$hasClipSector(previousDatum) ? $2fb96651e8aa1522$var$datumClipSector(previousDatum, initialLoad) : void 0;
            const nextClipSector = $2fb96651e8aa1522$var$hasClipSector(datum) ? $2fb96651e8aa1522$var$datumClipSector(datum, initialLoad) : void 0;
            let clipSector;
            if (previousClipSector != null && nextClipSector != null) clipSector = previousClipSector;
            else if (previousClipSector == null && nextClipSector != null) {
                clipSector = nextClipSector;
                startAngle = datum.startAngle;
                endAngle = datum.endAngle;
            } else if (previousClipSector != null && nextClipSector == null) {
                clipSector = void 0;
                startAngle = datum.startAngle;
                endAngle = datum.endAngle;
            } else if (initialLoad) endAngle = startAngle;
            return {
                startAngle: startAngle,
                endAngle: endAngle,
                clipSector: clipSector,
                phase: phase
            };
        },
        toFn (_sect, datum) {
            const { startAngle: startAngle, endAngle: endAngle } = datum;
            let clipSector;
            if ($2fb96651e8aa1522$var$hasClipSector(datum)) clipSector = $2fb96651e8aa1522$var$datumClipSector(datum, false);
            return {
                startAngle: startAngle,
                endAngle: endAngle,
                clipSector: clipSector
            };
        },
        applyFn (sect, params) {
            const { startAngle: startAngle, endAngle: endAngle } = params;
            let { clipSector: clipSector } = params;
            if (clipSector != null) clipSector = new $2fb96651e8aa1522$var$SectorBox5(Math.max(startAngle, clipSector.startAngle), Math.min(endAngle, clipSector.endAngle), clipSector.innerRadius, clipSector.outerRadius);
            const visible = clipSector == null || $2fb96651e8aa1522$var$clipSectorVisibility(startAngle, endAngle, clipSector);
            sect.startAngle = startAngle;
            sect.endAngle = endAngle;
            sect.clipSector = clipSector;
            sect.visible = visible;
        }
    };
    const needle = {
        fromFn (needleNode) {
            let { angle: rotation } = needleNode.previousDatum ?? needleNode.datum;
            if (initialLoad) rotation = initialStartAngle;
            return {
                rotation: rotation,
                phase: phase
            };
        },
        toFn (_needleNode, datum) {
            const { angle: rotation } = datum;
            return {
                rotation: rotation
            };
        }
    };
    return {
        node: node,
        needle: needle
    };
}
function $2fb96651e8aa1522$var$resetRadialGaugeSeriesResetSectorFunction(_node, datum) {
    const { startAngle: startAngle, endAngle: endAngle } = datum;
    const clipSector = $2fb96651e8aa1522$var$computeClipSector(datum);
    const visible = clipSector == null || $2fb96651e8aa1522$var$clipSectorVisibility(startAngle, endAngle, clipSector);
    return {
        startAngle: startAngle,
        endAngle: endAngle,
        clipSector: clipSector,
        visible: visible
    };
}
function $2fb96651e8aa1522$var$resetRadialGaugeSeriesResetNeedleFunction(_node, datum) {
    const { angle: angle } = datum;
    return {
        rotation: angle
    };
}
var $2fb96651e8aa1522$var$verticalAlignFactors3 = {
    top: 0,
    middle: 0.5,
    bottom: 1
};
function $2fb96651e8aa1522$var$formatRadialGaugeLabels(series, ctx, selection, opts, innerRadius, datumOverrides) {
    const { padding: padding, textAlign: textAlign, verticalAlign: verticalAlign } = opts;
    let labelDatum;
    let secondaryLabelDatum;
    selection.each((_node, datum)=>{
        if (datum.label === "primary" /* Primary */ ) labelDatum = datum;
        else if (datum.label === "secondary" /* Secondary */ ) secondaryLabelDatum = datum;
    });
    if (labelDatum == null) return;
    const labelText = $2fb96651e8aa1522$var$getLabelText(series.id, ctx, labelDatum, datumOverrides?.label);
    if (labelText == null) return;
    const secondaryLabelText = secondaryLabelDatum != null ? $2fb96651e8aa1522$var$getLabelText(series.id, ctx, secondaryLabelDatum, datumOverrides?.secondaryLabel) : void 0;
    const params = {
        padding: padding
    };
    const horizontalFactor = textAlign === "center" ? 2 : 1;
    const verticalFactor = verticalAlign === "middle" ? 2 : 1;
    const sizeFittingHeight = (height2)=>({
            width: Math.sqrt(Math.max(innerRadius ** 2 - (height2 / verticalFactor) ** 2, 0)) * horizontalFactor,
            height: Math.min(height2, verticalFactor * innerRadius),
            meta: null
        });
    let labelLayout;
    let secondaryLabelLayout;
    let height;
    if (secondaryLabelDatum != null && secondaryLabelText != null) {
        const layout = $2fb96651e8aa1522$var$formatStackedLabels(labelText, labelDatum, secondaryLabelText, secondaryLabelDatum, params, sizeFittingHeight);
        labelLayout = layout?.label;
        secondaryLabelLayout = layout?.secondaryLabel;
        height = layout?.height ?? 0;
    } else {
        const layout = $2fb96651e8aa1522$var$formatSingleLabel(labelText, labelDatum, params, sizeFittingHeight);
        labelLayout = layout?.[0];
        secondaryLabelLayout = void 0;
        height = layout?.[0].height ?? 0;
    }
    const rectYOffset = height * $2fb96651e8aa1522$var$verticalAlignFactors3[verticalAlign];
    selection.each((label, datum)=>{
        let layout;
        if (datum.label === "primary" /* Primary */ ) layout = labelLayout;
        else if (datum.label === "secondary" /* Secondary */ ) layout = secondaryLabelLayout;
        if (layout == null) {
            label.visible = false;
            return;
        }
        label.visible = true;
        label.text = layout.text;
        label.fontSize = layout.fontSize;
        label.lineHeight = layout.lineHeight;
        label.textAlign = textAlign;
        label.textBaseline = "middle";
        const rectOriginInLabelRect = datum.label === "primary" /* Primary */  ? layout.height / 2 : height - layout.height / 2;
        label.y = datum.centerY + rectOriginInLabelRect - rectYOffset;
        label.x = datum.centerX;
    });
}
// packages/ag-charts-enterprise/src/series/radial-gauge/radialGaugeSeries.ts
var { fromToMotion: $2fb96651e8aa1522$var$fromToMotion5, resetMotion: $2fb96651e8aa1522$var$resetMotion4, CachedTextMeasurerPool: $2fb96651e8aa1522$var$CachedTextMeasurerPool11, SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode17, StateMachine: $2fb96651e8aa1522$var$StateMachine15, createDatumId: $2fb96651e8aa1522$var$createDatumId21, normalizeAngle360: $2fb96651e8aa1522$var$normalizeAngle3606, normalizeAngle360Inclusive: $2fb96651e8aa1522$var$normalizeAngle360Inclusive2, isBetweenAngles: $2fb96651e8aa1522$var$isBetweenAngles2, sectorBox: $2fb96651e8aa1522$var$sectorBox, toDegrees: $2fb96651e8aa1522$var$toDegrees, toRadians: $2fb96651e8aa1522$var$toRadians5, BBox: $2fb96651e8aa1522$var$BBox22, Group: $2fb96651e8aa1522$var$Group20, PointerEvents: $2fb96651e8aa1522$var$PointerEvents12, Selection: $2fb96651e8aa1522$var$Selection16, Sector: $2fb96651e8aa1522$var$Sector6, SectorBox: $2fb96651e8aa1522$var$SectorBox6, Text: $2fb96651e8aa1522$var$Text8, Marker: $2fb96651e8aa1522$var$Marker5, getColorStops: $2fb96651e8aa1522$var$getColorStops2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$targetPlacementRotation = {
    inside: 90,
    middle: 0,
    outside: -90
};
var $2fb96651e8aa1522$var$outsideLabelPlacements = [
    {
        textAlign: "left",
        textBaseline: "top"
    },
    {
        textAlign: "right",
        textBaseline: "top"
    },
    {
        textAlign: "right",
        textBaseline: "bottom"
    },
    {
        textAlign: "left",
        textBaseline: "bottom"
    }
];
var $2fb96651e8aa1522$var$insideLabelPlacements = [
    {
        textAlign: "right",
        textBaseline: "bottom"
    },
    {
        textAlign: "left",
        textBaseline: "bottom"
    },
    {
        textAlign: "left",
        textBaseline: "top"
    },
    {
        textAlign: "right",
        textBaseline: "top"
    }
];
var $2fb96651e8aa1522$var$RadialGaugeSeries = class extends (0, $iTJTu._ModuleSupport).Series {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            useLabelLayer: true,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode17.EXACT_SHAPE_MATCH,
                $2fb96651e8aa1522$var$SeriesNodePickMode17.NEAREST_NODE
            ]
        });
        this.centerX = 0;
        this.centerY = 0;
        this.radius = 0;
        this.textAlign = "center";
        this.verticalAlign = "middle";
        this.properties = new $2fb96651e8aa1522$var$RadialGaugeSeriesProperties();
        this.scale = new $2fb96651e8aa1522$var$LinearAngleScale();
        this.scaleGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group20({
            name: "scaleGroup"
        }));
        this.itemGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group20({
            name: "itemGroup"
        }));
        this.itemNeedleGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group20({
            name: "itemNeedleGroup"
        }));
        this.itemTargetGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group20({
            name: "itemTargetGroup"
        }));
        this.itemTargetLabelGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group20({
            name: "itemTargetLabelGroup"
        }));
        this.itemLabelGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group20({
            name: "itemLabelGroup"
        }));
        this.highlightTargetGroup = this.highlightGroup.appendChild(new $2fb96651e8aa1522$var$Group20({
            name: "itemTargetLabelGroup"
        }));
        this.tickGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group20({
            name: "tickGroup"
        }));
        this.scaleSelection = $2fb96651e8aa1522$var$Selection16.select(this.scaleGroup, ()=>this.nodeFactory());
        this.datumSelection = $2fb96651e8aa1522$var$Selection16.select(this.itemGroup, ()=>this.nodeFactory());
        this.needleSelection = $2fb96651e8aa1522$var$Selection16.select(this.itemNeedleGroup, $2fb96651e8aa1522$var$RadialGaugeNeedle);
        this.targetSelection = $2fb96651e8aa1522$var$Selection16.select(this.itemTargetGroup, ()=>this.markerFactory());
        this.targetLabelSelection = $2fb96651e8aa1522$var$Selection16.select(this.itemTargetLabelGroup, $2fb96651e8aa1522$var$Text8);
        this.labelSelection = $2fb96651e8aa1522$var$Selection16.select(this.itemLabelGroup, $2fb96651e8aa1522$var$Text8);
        this.highlightTargetSelection = $2fb96651e8aa1522$var$Selection16.select(this.highlightTargetGroup, ()=>this.markerFactory());
        this.tickSelection = $2fb96651e8aa1522$var$Selection16.select(this.tickGroup, (0, $iTJTu._ModuleSupport).TransformableText);
        this.datumUnion = new $2fb96651e8aa1522$var$DatumUnion();
        this.animationState = new $2fb96651e8aa1522$var$StateMachine15("empty", {
            empty: {
                update: {
                    target: "ready",
                    action: ()=>this.animateEmptyUpdateReady()
                },
                reset: "empty",
                skip: "ready"
            },
            ready: {
                updateData: "waiting",
                clear: "clearing",
                resize: ()=>this.animateReadyResize(),
                reset: "empty",
                skip: "ready"
            },
            waiting: {
                update: {
                    target: "ready",
                    action: ()=>this.animateWaitingUpdateReady()
                },
                reset: "empty",
                skip: "ready"
            },
            clearing: {
                update: {
                    target: "empty"
                },
                reset: "empty",
                skip: "ready"
            }
        });
        this.scaleGroup.pointerEvents = $2fb96651e8aa1522$var$PointerEvents12.None;
        this.tickGroup.pointerEvents = $2fb96651e8aa1522$var$PointerEvents12.None;
        this.itemNeedleGroup.pointerEvents = $2fb96651e8aa1522$var$PointerEvents12.None;
        this.itemLabelGroup.pointerEvents = $2fb96651e8aa1522$var$PointerEvents12.None;
    }
    get hasData() {
        return this.properties.value != null;
    }
    nodeFactory() {
        return new $2fb96651e8aa1522$var$Sector6();
    }
    markerFactory() {
        const marker = new $2fb96651e8aa1522$var$Marker5();
        marker.size = 1;
        return marker;
    }
    processData() {
        this.nodeDataRefresh = true;
        this.animationState.transition("updateData");
    }
    formatLabel(value) {
        const { min: min, max: max } = this.properties.scale;
        return $2fb96651e8aa1522$var$formatLabel(value, {
            min: min,
            max: max
        });
    }
    layoutScale() {
        const { scale: scale, properties: properties } = this;
        const { seriesRectWidth: seriesRectWidth, seriesRectHeight: seriesRectHeight } = this.nodeDataDependencies;
        const { scale: scaleProps, outerRadius: outerRadius } = this.properties;
        const { min: min, max: max, label: label, interval: interval } = scaleProps;
        const startAngle = $2fb96651e8aa1522$var$toRadians5(properties.startAngle - 90);
        const endAngle = $2fb96651e8aa1522$var$toRadians5(properties.endAngle - 90);
        const sweepAngle = $2fb96651e8aa1522$var$normalizeAngle360Inclusive2(endAngle - startAngle);
        const largerThanHalf = sweepAngle > Math.PI;
        const containsTop = largerThanHalf || $2fb96651e8aa1522$var$isBetweenAngles2(1.5 * Math.PI, startAngle, endAngle);
        const containsRight = largerThanHalf || $2fb96651e8aa1522$var$isBetweenAngles2(0 * Math.PI, startAngle, endAngle);
        const containsBottom = largerThanHalf || $2fb96651e8aa1522$var$isBetweenAngles2(0.5 * Math.PI, startAngle, endAngle);
        const containsLeft = largerThanHalf || $2fb96651e8aa1522$var$isBetweenAngles2(1 * Math.PI, startAngle, endAngle);
        let textAlign;
        if (containsLeft && !containsRight) textAlign = "right";
        else if (!containsLeft && containsRight) textAlign = "left";
        else textAlign = "center";
        let verticalAlign;
        if (containsTop && !containsBottom) verticalAlign = "bottom";
        else if (!containsTop && containsBottom) verticalAlign = "top";
        else verticalAlign = "middle";
        const unitBox = $2fb96651e8aa1522$var$sectorBox({
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: 0,
            outerRadius: 0.5
        });
        const centerXOffset = -(unitBox.x + unitBox.width / 2) * 2;
        const centerYOffset = -(unitBox.y + unitBox.height / 2) * 2;
        const unitBoxSize = Math.min(seriesRectWidth / unitBox.width, seriesRectHeight / unitBox.height);
        scale.domain = [
            min,
            max
        ];
        scale.range = [
            startAngle,
            endAngle
        ];
        scale.arcLength = unitBoxSize / 2;
        const { maxSpacing: maxSpacing, minSpacing: minSpacing } = interval;
        const { arcLength: arcLength } = scale;
        const minTickCount = maxSpacing ? Math.floor(arcLength / maxSpacing) : 1;
        const maxTickCount = minSpacing ? Math.floor(arcLength / minSpacing) : Infinity;
        const preferredTickCount = Math.floor(4 / Math.PI * Math.abs(scale.range[0] - scale.range[1]));
        const tickCount = Math.max(minTickCount, Math.min(maxTickCount, preferredTickCount));
        const ticks = interval.values ?? scale.ticks({
            nice: false,
            interval: interval.step,
            minTickCount: minTickCount,
            maxTickCount: maxTickCount,
            tickCount: tickCount
        })?.ticks ?? [];
        const fractionDigits = ticks.reduce((f, tick)=>Math.max(f, typeof tick === "number" ? (0, $idDdm.countFractionDigits)(tick) : 0), 0);
        const tickFormatter = scale.tickFormatter({
            domain: scale.domain,
            ticks: ticks,
            fractionDigits: fractionDigits,
            specifier: typeof label.format === "string" ? label.format : void 0
        });
        const font2 = label.getFont();
        const tickData = ticks.map((value, index)=>{
            let text2;
            if (label.formatter) text2 = $2fb96651e8aa1522$var$formatWithContext(this.ctx, label.formatter, {
                value: value,
                index: index,
                domain: scale.domain,
                boundSeries: void 0
            });
            if (text2 === void 0) text2 = tickFormatter(value);
            const { width: width, height: height } = $2fb96651e8aa1522$var$CachedTextMeasurerPool11.measureText(text2, {
                font: font2
            });
            return {
                index: index,
                value: value,
                text: text2,
                width: width,
                height: height
            };
        });
        const maxWidth = tickData.reduce((m, t)=>Math.max(m, t.width), 0);
        const maxHeight = tickData.reduce((m, t)=>Math.max(m, t.height), 0);
        const labelInset = label.enabled ? Math.max(maxWidth, maxHeight) + label.spacing : 0;
        const radiusBounds = Math.max(0.5 * unitBoxSize - labelInset, // seriesRect may have negative size
        0);
        const radius = outerRadius ?? radiusBounds;
        this.centerX = seriesRectWidth / 2 + centerXOffset * radius;
        this.centerY = seriesRectHeight / 2 + centerYOffset * radius;
        this.radius = radius;
        this.textAlign = textAlign;
        this.verticalAlign = verticalAlign;
        return tickData;
    }
    createConicGradient(fills, fillMode) {
        const { scale: scale } = this;
        const { domain: domain, range: range2 } = scale;
        const [startAngle, endAngle] = range2;
        const { defaultColorRange: defaultColorRange } = this.properties;
        const conicAngle = $2fb96651e8aa1522$var$normalizeAngle3606((startAngle + endAngle) / 2 + Math.PI);
        const sweepAngle = $2fb96651e8aa1522$var$normalizeAngle360Inclusive2(endAngle - startAngle);
        const colorStops = $2fb96651e8aa1522$var$getColorStops2(fills, defaultColorRange, domain, fillMode).map(({ color: color6, stop: stop })=>{
            stop = Math.min(Math.max(stop, 0), 1);
            const angle = startAngle + sweepAngle * stop;
            stop = (angle - conicAngle) / (2 * Math.PI);
            stop = (stop % 1 + 1) % 1;
            return {
                stop: stop,
                color: color6
            };
        });
        return {
            type: "gradient",
            gradient: "conic",
            colorSpace: "oklch",
            colorStops: colorStops,
            rotation: $2fb96651e8aa1522$var$toDegrees(conicAngle) + 90
        };
    }
    getShapeFillBBox() {
        const { centerX: centerX, centerY: centerY, radius: radius } = this;
        return new $2fb96651e8aa1522$var$BBox22(centerX - radius, centerY - radius, 2 * radius, 2 * radius);
    }
    getTargets() {
        const { properties: properties } = this;
        const defaultTarget = properties.defaultTarget;
        return Array.from(properties.targets).map((target)=>{
            const { text: text2 = defaultTarget.text, value: value = defaultTarget.value ?? 0, shape: shape = defaultTarget.shape ?? "triangle", rotation: rotation = defaultTarget.rotation ?? 0, strokeWidth: strokeWidth = defaultTarget.strokeWidth ?? 0, placement: placement = defaultTarget.placement ?? "middle", spacing: spacing = defaultTarget.spacing ?? 0, size: size = defaultTarget.size ?? 0, fill: fill = defaultTarget.fill ?? "black", fillOpacity: fillOpacity = defaultTarget.fillOpacity ?? 1, stroke: stroke2 = defaultTarget.stroke ?? "black", strokeOpacity: strokeOpacity = defaultTarget.strokeOpacity ?? 1, lineDash: lineDash = defaultTarget.lineDash ?? [
                0
            ], lineDashOffset: lineDashOffset = defaultTarget.lineDashOffset ?? 0 } = target;
            const { enabled: labelEnabled = defaultTarget.label.enabled, color: labelColor = defaultTarget.label.color ?? "black", fontStyle: labelFontStyle = defaultTarget.label.fontStyle ?? "normal", fontWeight: labelFontWeight = defaultTarget.label.fontWeight ?? "normal", fontSize: labelFontSize = defaultTarget.label.fontSize, fontFamily: labelFontFamily = defaultTarget.label.fontFamily, spacing: labelSpacing = defaultTarget.label.spacing ?? 0 } = target.label;
            return {
                text: text2,
                value: value,
                shape: shape,
                placement: placement,
                spacing: spacing,
                size: size,
                rotation: rotation,
                fill: fill,
                fillOpacity: fillOpacity,
                stroke: stroke2,
                strokeWidth: strokeWidth,
                strokeOpacity: strokeOpacity,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset,
                label: {
                    enabled: labelEnabled,
                    color: labelColor,
                    fontStyle: labelFontStyle,
                    fontWeight: labelFontWeight,
                    fontSize: labelFontSize,
                    fontFamily: labelFontFamily,
                    spacing: labelSpacing
                }
            };
        });
    }
    getTargetRadius(target) {
        const { radius: radius, properties: properties } = this;
        const { innerRadiusRatio: innerRadiusRatio, outerRadiusRatio: outerRadiusRatio } = properties;
        const { placement: placement, spacing: spacing, size: size } = target;
        const outerRadius = radius * outerRadiusRatio;
        const innerRadius = radius * innerRadiusRatio;
        switch(placement){
            case "inside":
                return Math.max(innerRadius - spacing - size / 2, 0);
            case "outside":
                return outerRadius + spacing + size / 2;
            default:
                return (innerRadius + outerRadius) / 2;
        }
    }
    getTargetLabel(target) {
        const { scale: scale } = this;
        const { value: value, size: size, placement: placement, label: label } = target;
        const { spacing: spacing, color: fill, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily } = label;
        const lineHeight = void 0;
        const angle = scale.convert(value);
        const quadrant = $2fb96651e8aa1522$var$normalizeAngle3606(angle) / (Math.PI / 2) | 0;
        const offset = size / 2 + spacing;
        let textAlign;
        let textBaseline;
        let offsetX;
        let offsetY;
        switch(placement){
            case "outside":
                ({ textAlign: textAlign, textBaseline: textBaseline } = $2fb96651e8aa1522$var$outsideLabelPlacements[quadrant]);
                offsetX = offset * Math.cos(angle);
                offsetY = offset * Math.sin(angle);
                break;
            case "inside":
                ({ textAlign: textAlign, textBaseline: textBaseline } = $2fb96651e8aa1522$var$insideLabelPlacements[quadrant]);
                offsetX = -offset * Math.cos(angle);
                offsetY = -offset * Math.sin(angle);
                break;
            default:
                textAlign = "center";
                textBaseline = "bottom";
                offsetX = 0;
                offsetY = -offset;
                break;
        }
        return {
            offsetX: offsetX,
            offsetY: offsetY,
            fill: fill,
            textAlign: textAlign,
            textBaseline: textBaseline,
            fontStyle: fontStyle,
            fontWeight: fontWeight,
            fontSize: fontSize,
            fontFamily: fontFamily,
            lineHeight: lineHeight
        };
    }
    createNodeData() {
        const tickData = this.layoutScale();
        const { id: seriesId, scale: scale, properties: properties, radius: radius, centerX: centerX, centerY: centerY } = this;
        const { value: value, innerRadiusRatio: innerRadiusRatio, outerRadiusRatio: outerRadiusRatio, segmentation: segmentation, cornerRadius: cornerRadius, cornerMode: cornerMode, needle: needle, bar: bar, scale: scaleProps, label: label, secondaryLabel: secondaryLabel } = properties;
        const { outerRadius: outerRadius = radius * outerRadiusRatio, innerRadius: innerRadius = radius * innerRadiusRatio } = properties;
        const targets = this.getTargets();
        const nodeData = [];
        const targetData = [];
        const needleData = [];
        const labelData = [];
        const scaleData = [];
        const cornersOnAllItems = cornerMode === "item";
        const containerStartAngle = scale.convert(scale.domain[0]);
        const containerEndAngle = scale.convert(value);
        const maxTicks = Math.ceil($2fb96651e8aa1522$var$normalizeAngle360Inclusive2(containerEndAngle - containerStartAngle) * radius);
        let segments = segmentation.enabled ? segmentation.interval.getSegments(scale, maxTicks) : void 0;
        const barFill = !bar.enabled ? "rgba(0,0,0,0)" : bar.fill ?? this.createConicGradient(bar.fills, bar.fillMode);
        const scaleFill = scaleProps.fill ?? (bar.enabled && scaleProps.fills.length === 0 ? scaleProps.defaultFill : void 0) ?? this.createConicGradient(scaleProps.fills, scaleProps.fillMode);
        if (segments == null && cornersOnAllItems) {
            const segmentStart = Math.min(...scale.domain);
            const segmentEnd = Math.max(...scale.domain);
            const datum = {
                value: value,
                segmentStart: segmentStart,
                segmentEnd: segmentEnd
            };
            const appliedCornerRadius = Math.min(cornerRadius, (outerRadius - innerRadius) / 2);
            const angleInset = appliedCornerRadius / ((innerRadius + outerRadius) / 2);
            nodeData.push({
                series: this,
                itemId: `value`,
                datum: datum,
                datumIndex: {
                    type: 0 /* Node */ 
                },
                type: 0 /* Node */ ,
                centerX: centerX,
                centerY: centerY,
                outerRadius: outerRadius,
                innerRadius: innerRadius,
                startAngle: containerStartAngle - angleInset,
                endAngle: containerEndAngle + angleInset,
                clipStartAngle: void 0,
                clipEndAngle: void 0,
                startCornerRadius: cornerRadius,
                endCornerRadius: cornerRadius,
                fill: barFill
            });
            scaleData.push({
                series: this,
                itemId: `scale`,
                datum: datum,
                datumIndex: {
                    type: 0 /* Node */ 
                },
                type: 0 /* Node */ ,
                centerX: centerX,
                centerY: centerY,
                outerRadius: outerRadius,
                innerRadius: innerRadius,
                startAngle: scale.range[0] - angleInset,
                endAngle: scale.range[1] + angleInset,
                clipStartAngle: void 0,
                clipEndAngle: void 0,
                startCornerRadius: cornerRadius,
                endCornerRadius: cornerRadius,
                fill: scaleFill
            });
        } else {
            segments ?? (segments = scale.domain);
            for(let i = 0; i < segments.length - 1; i++){
                const segmentStart = segments[i];
                const segmentEnd = segments[i + 1];
                const datum = {
                    value: value,
                    segmentStart: segmentStart,
                    segmentEnd: segmentEnd
                };
                const isStart = i === 0;
                const isEnd = i === segments.length - 2;
                const itemStartAngle = scale.convert(segmentStart);
                const itemEndAngle = scale.convert(segmentEnd);
                nodeData.push({
                    series: this,
                    itemId: `value-${i}`,
                    datum: datum,
                    datumIndex: {
                        type: 0 /* Node */ 
                    },
                    type: 0 /* Node */ ,
                    centerX: centerX,
                    centerY: centerY,
                    outerRadius: outerRadius,
                    innerRadius: innerRadius,
                    startAngle: itemStartAngle,
                    endAngle: itemEndAngle,
                    clipStartAngle: containerStartAngle,
                    clipEndAngle: containerEndAngle,
                    startCornerRadius: cornersOnAllItems || isStart ? cornerRadius : 0,
                    endCornerRadius: cornersOnAllItems || isEnd ? cornerRadius : 0,
                    fill: barFill
                });
                scaleData.push({
                    series: this,
                    itemId: `scale-${i}`,
                    datum: datum,
                    datumIndex: {
                        type: 0 /* Node */ 
                    },
                    type: 0 /* Node */ ,
                    centerX: centerX,
                    centerY: centerY,
                    outerRadius: outerRadius,
                    innerRadius: innerRadius,
                    startAngle: itemStartAngle,
                    endAngle: itemEndAngle,
                    clipStartAngle: void 0,
                    clipEndAngle: void 0,
                    startCornerRadius: cornersOnAllItems || isStart ? cornerRadius : 0,
                    endCornerRadius: cornersOnAllItems || isEnd ? cornerRadius : 0,
                    fill: scaleFill
                });
            }
        }
        if (!needle.enabled && label.enabled) {
            const { text: text2, color: fill, fontSize: fontSize, minimumFontSize: minimumFontSize, fontStyle: fontStyle, fontWeight: fontWeight, fontFamily: fontFamily, lineHeight: lineHeight, formatter: formatter = (params)=>this.formatLabel(params.value) } = label;
            labelData.push({
                label: "primary" /* Primary */ ,
                centerX: centerX,
                centerY: centerY,
                text: text2,
                value: value,
                fill: fill,
                fontSize: fontSize,
                minimumFontSize: minimumFontSize,
                fontStyle: fontStyle,
                fontWeight: fontWeight,
                fontFamily: fontFamily,
                lineHeight: lineHeight,
                formatter: formatter
            });
        }
        if (!needle.enabled && secondaryLabel.enabled) {
            const { text: text2, color: fill, fontSize: fontSize, minimumFontSize: minimumFontSize, fontStyle: fontStyle, fontWeight: fontWeight, fontFamily: fontFamily, lineHeight: lineHeight, formatter: formatter } = secondaryLabel;
            labelData.push({
                label: "secondary" /* Secondary */ ,
                centerX: centerX,
                centerY: centerY,
                text: text2,
                value: value,
                fill: fill,
                fontSize: fontSize,
                minimumFontSize: minimumFontSize,
                fontStyle: fontStyle,
                fontWeight: fontWeight,
                fontFamily: fontFamily,
                lineHeight: lineHeight,
                formatter: formatter
            });
        }
        if (needle.enabled) {
            let needleRadius = needle.radiusRatio != null ? radius * needle.radiusRatio : innerRadius;
            needleRadius = Math.max(needleRadius - needle.spacing, 0);
            const needleAngle = scale.convert(value);
            needleData.push({
                centerX: centerX,
                centerY: centerY,
                radius: needleRadius,
                angle: needleAngle,
                series: this
            });
        }
        for(let i = 0; i < targets.length; i += 1){
            const target = targets[i];
            const { value: targetValue, text: text2, size: size, shape: shape, fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = target;
            if (targetValue < Math.min(...scale.domain) || targetValue > Math.max(...scale.domain)) continue;
            const targetRadius = this.getTargetRadius(target);
            const targetAngle = scale.convert(targetValue);
            const targetRotation = $2fb96651e8aa1522$var$toRadians5(target.rotation + $2fb96651e8aa1522$var$targetPlacementRotation[target.placement]);
            targetData.push({
                series: this,
                itemId: `target-${i}`,
                midPoint: {
                    x: targetRadius * Math.cos(targetAngle) + centerX,
                    y: targetRadius * Math.sin(targetAngle) + centerY
                },
                datum: {
                    value: targetValue
                },
                datumIndex: {
                    type: 1 /* Target */ ,
                    index: i
                },
                type: 1 /* Target */ ,
                value: targetValue,
                text: text2,
                centerX: centerX,
                centerY: centerY,
                shape: shape,
                radius: targetRadius,
                angle: targetAngle,
                rotation: targetRotation,
                size: size,
                fill: fill,
                fillOpacity: fillOpacity,
                stroke: stroke2,
                strokeOpacity: strokeOpacity,
                strokeWidth: strokeWidth,
                lineDash: lineDash,
                lineDashOffset: lineDashOffset,
                label: this.getTargetLabel(target)
            });
        }
        return {
            itemId: seriesId,
            nodeData: nodeData,
            needleData: needleData,
            targetData: targetData,
            labelData: labelData,
            scaleData: scaleData,
            tickData: tickData
        };
    }
    updateSelections(resize) {
        if (this.nodeDataRefresh || resize) {
            this.contextNodeData = this.createNodeData();
            this.nodeDataRefresh = false;
        }
    }
    highlightDatum(node) {
        if (node != null && node.series === this && node.type === 1 /* Target */ ) return node;
    }
    update({ seriesRect: seriesRect }) {
        const { datumSelection: datumSelection, labelSelection: labelSelection, needleSelection: needleSelection, targetSelection: targetSelection, targetLabelSelection: targetLabelSelection, scaleSelection: scaleSelection, highlightTargetSelection: highlightTargetSelection, tickSelection: tickSelection } = this;
        const resize = this.checkResize(seriesRect);
        this.updateSelections(resize);
        this.contentGroup.visible = this.visible;
        this.contentGroup.opacity = this.getOpacity();
        const nodeData = this.contextNodeData?.nodeData ?? [];
        const labelData = this.contextNodeData?.labelData ?? [];
        const needleData = this.contextNodeData?.needleData ?? [];
        const targetData = this.contextNodeData?.targetData ?? [];
        const scaleData = this.contextNodeData?.scaleData ?? [];
        const tickData = this.contextNodeData?.tickData ?? [];
        const highlightTargetDatum = this.highlightDatum(this.ctx.highlightManager.getActiveHighlight());
        this.scaleSelection = this.updateScaleSelection({
            scaleData: scaleData,
            scaleSelection: scaleSelection
        });
        this.updateScaleNodes({
            scaleSelection: scaleSelection
        });
        this.needleSelection = this.updateNeedleSelection({
            needleData: needleData,
            needleSelection: needleSelection
        });
        this.updateNeedleNodes({
            needleSelection: needleSelection
        });
        this.targetSelection = this.updateTargetSelection({
            targetData: targetData,
            targetSelection: targetSelection
        });
        this.updateTargetNodes({
            targetSelection: targetSelection,
            isHighlight: false
        });
        this.targetLabelSelection = this.updateTargetLabelSelection({
            targetData: targetData,
            targetLabelSelection: targetLabelSelection
        });
        this.updateTargetLabelNodes({
            targetLabelSelection: targetLabelSelection
        });
        this.datumSelection = this.updateDatumSelection({
            nodeData: nodeData,
            datumSelection: datumSelection
        });
        this.updateDatumNodes({
            datumSelection: datumSelection
        });
        this.labelSelection = this.updateLabelSelection({
            labelData: labelData,
            labelSelection: labelSelection
        });
        this.updateLabelNodes({
            labelSelection: labelSelection
        });
        this.highlightTargetSelection = this.updateTargetSelection({
            targetData: highlightTargetDatum != null ? [
                highlightTargetDatum
            ] : [],
            targetSelection: highlightTargetSelection
        });
        this.updateTargetNodes({
            targetSelection: highlightTargetSelection,
            isHighlight: true
        });
        this.tickSelection = this.updateTickSelection({
            tickData: tickData,
            tickSelection: tickSelection
        });
        this.updateTickNodes({
            tickSelection: tickSelection
        });
        if (resize) this.animationState.transition("resize");
        this.animationState.transition("update");
    }
    updateDatumSelection(opts) {
        return opts.datumSelection.update(opts.nodeData, void 0, (datum)=>{
            return $2fb96651e8aa1522$var$createDatumId21(opts.nodeData.length, datum.itemId);
        });
    }
    updateDatumNodes(opts) {
        const { datumSelection: datumSelection } = opts;
        const { ctx: ctx, properties: properties } = this;
        const { bar: bar, segmentation: segmentation } = properties;
        const sectorSpacing = segmentation.spacing ?? 0;
        const { fillOpacity: fillOpacity, stroke: stroke2, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = bar;
        const strokeWidth = this.getStrokeWidth(bar.strokeWidth);
        const animationDisabled = ctx.animationManager.isSkipped();
        const fillBBox = this.getShapeFillBBox();
        datumSelection.each((sector, datum)=>{
            const { centerX: centerX, centerY: centerY, innerRadius: innerRadius, outerRadius: outerRadius, startCornerRadius: startCornerRadius, endCornerRadius: endCornerRadius, fill: fill } = datum;
            sector.centerX = centerX;
            sector.centerY = centerY;
            sector.innerRadius = innerRadius;
            sector.outerRadius = outerRadius;
            sector.pointerEvents = this.properties.bar.enabled ? (0, $iTJTu._ModuleSupport).PointerEvents.All : (0, $iTJTu._ModuleSupport).PointerEvents.None;
            sector.fill = fill;
            sector.fillBBox = fillBBox;
            sector.fillOpacity = fillOpacity;
            sector.stroke = stroke2;
            sector.strokeOpacity = strokeOpacity;
            sector.strokeWidth = strokeWidth;
            sector.lineDash = lineDash;
            sector.lineDashOffset = lineDashOffset;
            sector.startOuterCornerRadius = startCornerRadius;
            sector.startInnerCornerRadius = startCornerRadius;
            sector.endOuterCornerRadius = endCornerRadius;
            sector.endInnerCornerRadius = endCornerRadius;
            sector.radialEdgeInset = (sectorSpacing + sector.strokeWidth) / 2;
            sector.concentricEdgeInset = sector.strokeWidth / 2;
            if (animationDisabled || sector.previousDatum == null) sector.setProperties($2fb96651e8aa1522$var$resetRadialGaugeSeriesResetSectorFunction(sector, datum));
        });
        this.datumUnion.update(datumSelection, this.itemGroup, (0, $iTJTu._ModuleSupport).Sector, (node, first, last)=>{
            node.clipSector ?? (node.clipSector = new $2fb96651e8aa1522$var$SectorBox6(NaN, NaN, NaN, NaN));
            node.centerX = first.centerX;
            node.centerY = first.centerY;
            node.outerRadius = node.clipSector.outerRadius = first.outerRadius;
            node.innerRadius = node.clipSector.innerRadius = first.innerRadius;
            node.startAngle = node.clipSector.startAngle = first.startAngle;
            node.startInnerCornerRadius = first.startInnerCornerRadius;
            node.startOuterCornerRadius = first.startOuterCornerRadius;
            node.endAngle = last.endAngle;
            node.clipSector.endAngle = last.clipSector?.endAngle ?? last.endAngle;
            node.endInnerCornerRadius = last.endInnerCornerRadius;
            node.endOuterCornerRadius = last.endOuterCornerRadius;
            node.pointerEvents = (0, $iTJTu._ModuleSupport).PointerEvents.None;
        });
    }
    updateScaleSelection(opts) {
        return opts.scaleSelection.update(opts.scaleData, void 0, (datum)=>{
            return $2fb96651e8aa1522$var$createDatumId21(opts.scaleData.length, datum.itemId);
        });
    }
    updateScaleNodes(opts) {
        const { scaleSelection: scaleSelection } = opts;
        const { scale: scale, segmentation: segmentation } = this.properties;
        const sectorSpacing = segmentation.spacing ?? 0;
        const { fillOpacity: fillOpacity, stroke: stroke2, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset } = scale;
        const fillBBox = this.getShapeFillBBox();
        scaleSelection.each((sector, datum)=>{
            const { centerX: centerX, centerY: centerY, innerRadius: innerRadius, outerRadius: outerRadius, startCornerRadius: startCornerRadius, endCornerRadius: endCornerRadius, fill: fill } = datum;
            sector.centerX = centerX;
            sector.centerY = centerY;
            sector.innerRadius = innerRadius;
            sector.outerRadius = outerRadius;
            sector.fill = fill;
            sector.fillBBox = fillBBox;
            sector.fillOpacity = fillOpacity;
            sector.stroke = stroke2;
            sector.strokeOpacity = strokeOpacity;
            sector.strokeWidth = strokeWidth;
            sector.lineDash = lineDash;
            sector.lineDashOffset = lineDashOffset;
            sector.startOuterCornerRadius = startCornerRadius;
            sector.startInnerCornerRadius = startCornerRadius;
            sector.endOuterCornerRadius = endCornerRadius;
            sector.endInnerCornerRadius = endCornerRadius;
            sector.radialEdgeInset = (sectorSpacing + sector.strokeWidth) / 2;
            sector.concentricEdgeInset = sector.strokeWidth / 2;
            sector.setProperties($2fb96651e8aa1522$var$resetRadialGaugeSeriesResetSectorFunction(sector, datum));
        });
    }
    updateNeedleSelection(opts) {
        return opts.needleSelection.update(opts.needleData, void 0, ()=>$2fb96651e8aa1522$var$createDatumId21([]));
    }
    updateNeedleNodes(opts) {
        const { needleSelection: needleSelection } = opts;
        const { fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset } = this.properties.needle;
        const animationDisabled = this.ctx.animationManager.isSkipped();
        needleSelection.each((needle, datum)=>{
            const { centerX: centerX, centerY: centerY, radius: radius } = datum;
            const scale = radius * 2;
            needle.d = $2fb96651e8aa1522$var$RadialGaugeNeedle.defaultPathData;
            needle.fill = fill;
            needle.fillOpacity = fillOpacity;
            needle.stroke = stroke2;
            needle.strokeOpacity = strokeOpacity;
            needle.strokeWidth = strokeWidth / scale;
            needle.lineDash = lineDash.map((d)=>d / scale);
            needle.lineDashOffset = lineDashOffset / scale;
            needle.translationX = centerX;
            needle.translationY = centerY;
            needle.scalingX = scale;
            needle.scalingY = scale;
            if (animationDisabled) needle.setProperties($2fb96651e8aa1522$var$resetRadialGaugeSeriesResetNeedleFunction(needle, datum));
        });
    }
    updateTargetSelection(opts) {
        return opts.targetSelection.update(opts.targetData, void 0, (target)=>target.itemId);
    }
    updateTargetNodes(opts) {
        const { targetSelection: targetSelection, isHighlight: isHighlight } = opts;
        const highlightStyle = isHighlight ? this.properties.highlightStyle.item : void 0;
        targetSelection.each((target, datum)=>{
            const { centerX: centerX, centerY: centerY, angle: angle, radius: radius, shape: shape, size: size, rotation: rotation, fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, lineDashOffset: lineDashOffset } = datum;
            target.shape = shape === "line" ? $2fb96651e8aa1522$var$lineMarker : shape;
            target.size = size;
            target.fill = highlightStyle?.fill ?? fill;
            target.fillOpacity = highlightStyle?.fillOpacity ?? fillOpacity;
            target.stroke = highlightStyle?.stroke ?? stroke2;
            target.strokeOpacity = highlightStyle?.strokeOpacity ?? strokeOpacity;
            target.strokeWidth = highlightStyle?.strokeWidth ?? strokeWidth;
            target.lineDash = highlightStyle?.lineDash ?? lineDash;
            target.lineDashOffset = highlightStyle?.lineDashOffset ?? lineDashOffset;
            target.translationX = centerX + radius * Math.cos(angle);
            target.translationY = centerY + radius * Math.sin(angle);
            target.rotation = angle + rotation;
        });
    }
    updateTargetLabelSelection(opts) {
        return opts.targetLabelSelection.update(opts.targetData, void 0, (target)=>target.itemId);
    }
    updateTargetLabelNodes(opts) {
        const { targetLabelSelection: targetLabelSelection } = opts;
        targetLabelSelection.each((label, target)=>{
            const { centerX: centerX, centerY: centerY, radius: radius, angle: angle, text: text2 } = target;
            const { offsetX: offsetX, offsetY: offsetY, fill: fill, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily, textAlign: textAlign, textBaseline: textBaseline } = target.label;
            if (text2 == null) {
                label.visible = false;
                return;
            }
            label.visible = true;
            label.x = centerX + radius * Math.cos(angle) + offsetX;
            label.y = centerY + radius * Math.sin(angle) + offsetY;
            label.text = text2;
            label.fill = fill;
            label.fontStyle = fontStyle;
            label.fontWeight = fontWeight;
            label.fontSize = fontSize;
            label.fontFamily = fontFamily;
            label.textAlign = textAlign;
            label.textBaseline = textBaseline;
        });
    }
    updateLabelSelection(opts) {
        return opts.labelSelection.update(opts.labelData, void 0, (datum)=>datum.label);
    }
    updateLabelNodes(opts) {
        const { labelSelection: labelSelection } = opts;
        const animationDisabled = this.ctx.animationManager.isSkipped();
        labelSelection.each((label, datum)=>{
            label.fill = datum.fill;
            label.fontStyle = datum.fontStyle;
            label.fontWeight = datum.fontWeight;
            label.fontFamily = datum.fontFamily;
        });
        if (animationDisabled || this.labelsHaveExplicitText()) this.formatLabelText();
    }
    updateTickSelection(opts) {
        return opts.tickSelection.update(opts.tickData, void 0, (datum)=>datum.index);
    }
    updateTickNodes(opts) {
        const { scale: scale, radius: radius, centerX: centerX, centerY: centerY, properties: properties } = this;
        const { enabled: enabled, color: color6, fontFamily: fontFamily, fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight, spacing: spacing } = properties.scale.label;
        const rotation = $2fb96651e8aa1522$var$toRadians5(properties.scale.label.rotation ?? 0);
        opts.tickSelection.each((label, datum)=>{
            if (!enabled) {
                label.visible = false;
                return;
            }
            label.visible = true;
            label.text = datum.text;
            label.fill = color6;
            label.fontFamily = fontFamily;
            label.fontSize = fontSize;
            label.fontStyle = fontStyle;
            label.fontWeight = fontWeight;
            label.textAlign = "center";
            label.textBaseline = "middle";
            const angle = scale.convert(datum.value);
            const { width: width, height: height } = datum;
            const originX = Math.abs(radius * Math.cos(angle));
            const originY = Math.abs(radius * Math.sin(angle));
            const x0 = Math.min(Math.max(Math.abs(radius / Math.tan(angle)), originX - width / 2), originX + width / 2);
            const y0 = Math.min(Math.max(Math.abs(radius * Math.tan(angle)), originY - height / 2), originY + height / 2);
            const outerR = Math.hypot(x0, y0);
            const x = centerX + (outerR + spacing) * Math.cos(angle);
            const y = centerY + (outerR + spacing) * Math.sin(angle);
            label.x = x;
            label.y = y;
            label.rotationCenterX = x;
            label.rotationCenterY = y;
            label.rotation = rotation;
        });
    }
    labelsHaveExplicitText() {
        for (const { datum: datum } of this.labelSelection){
            if (datum.text == null) return false;
        }
        return true;
    }
    formatLabelText(datum) {
        const { labelSelection: labelSelection, radius: radius, textAlign: textAlign, verticalAlign: verticalAlign } = this;
        const { spacing: padding, innerRadiusRatio: innerRadiusRatio } = this.properties;
        $2fb96651e8aa1522$var$formatRadialGaugeLabels(this, this.ctx, labelSelection, {
            padding: padding,
            textAlign: textAlign,
            verticalAlign: verticalAlign
        }, radius * innerRadiusRatio, datum);
    }
    resetAllAnimation() {
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
        $2fb96651e8aa1522$var$resetMotion4([
            this.datumSelection
        ], $2fb96651e8aa1522$var$resetRadialGaugeSeriesResetSectorFunction);
        $2fb96651e8aa1522$var$resetMotion4([
            this.needleSelection
        ], $2fb96651e8aa1522$var$resetRadialGaugeSeriesResetNeedleFunction);
        this.formatLabelText();
    }
    resetAnimation(phase) {
        if (phase === "initial") this.animationState.transition("reset");
        else if (phase === "ready") this.animationState.transition("skip");
    }
    animateLabelText(params = {}) {
        const { animationManager: animationManager } = this.ctx;
        let labelFrom;
        let labelTo;
        let secondaryLabelFrom;
        let secondaryLabelTo;
        this.labelSelection.each((label, datum)=>{
            label.opacity = 1;
            if (datum.label === "primary" /* Primary */ ) {
                labelFrom = label.previousDatum?.value ?? params.from ?? datum.value;
                labelTo = datum.value;
            } else if (datum.label === "secondary" /* Secondary */ ) {
                secondaryLabelFrom = label.previousDatum?.value ?? params.from ?? datum.value;
                secondaryLabelTo = datum.value;
            }
        });
        if (this.labelsHaveExplicitText()) ;
        else if (labelTo == null || secondaryLabelTo == null) this.formatLabelText();
        else if (labelFrom === labelTo && secondaryLabelFrom === secondaryLabelTo) this.formatLabelText({
            label: labelTo,
            secondaryLabel: secondaryLabelTo
        });
        else {
            const animationId = `${this.id}_labels`;
            animationManager.animate({
                id: animationId,
                groupId: "label",
                from: {
                    label: labelFrom,
                    secondaryLabel: secondaryLabelFrom
                },
                to: {
                    label: labelTo,
                    secondaryLabel: secondaryLabelTo
                },
                phase: params.phase ?? "update",
                onUpdate: (datum)=>this.formatLabelText(datum)
            });
        }
    }
    animateEmptyUpdateReady() {
        const { animationManager: animationManager } = this.ctx;
        const { node: node, needle: needle } = $2fb96651e8aa1522$var$prepareRadialGaugeSeriesAnimationFunctions(true, this.scale.range[0]);
        $2fb96651e8aa1522$var$fromToMotion5(this.id, "node", animationManager, [
            this.datumSelection
        ], node, (_sector, datum)=>datum.itemId);
        $2fb96651e8aa1522$var$fromToMotion5(this.id, "needle", animationManager, [
            this.needleSelection
        ], needle, ()=>"needle");
        $2fb96651e8aa1522$var$fromToMotion5(this.id, "label", animationManager, [
            this.labelSelection
        ], $2fb96651e8aa1522$var$fadeInFns, (_label, datum)=>datum.label);
        this.animateLabelText({
            from: this.properties.scale.min,
            phase: "initial"
        });
    }
    animateWaitingUpdateReady() {
        const { animationManager: animationManager } = this.ctx;
        const { node: node, needle: needle } = $2fb96651e8aa1522$var$prepareRadialGaugeSeriesAnimationFunctions(false, this.scale.range[0]);
        $2fb96651e8aa1522$var$fromToMotion5(this.id, "node", animationManager, [
            this.datumSelection
        ], node, (_sector, datum)=>datum.itemId);
        $2fb96651e8aa1522$var$fromToMotion5(this.id, "needle", animationManager, [
            this.needleSelection
        ], needle, ()=>"needle");
        this.animateLabelText();
    }
    animateReadyResize() {
        this.resetAllAnimation();
    }
    getSeriesDomain() {
        return [
            NaN,
            NaN
        ];
    }
    getSeriesRange(_direction, _visibleRange) {
        return [
            NaN,
            NaN
        ];
    }
    getLegendData() {
        return [];
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, properties: properties } = this;
        const { tooltip: tooltip } = properties;
        let value;
        let text2;
        if (datumIndex.type === 0 /* Node */ ) {
            value = properties.value;
            text2 = properties.label.text;
        } else ({ value: value, text: text2 } = properties.targets[datumIndex.index]);
        if (value == null) return;
        return this.formatTooltipWithContext(tooltip, {
            data: [
                {
                    label: text2,
                    fallbackLabel: "Value",
                    value: this.formatLabel(value)
                }
            ]
        }, {
            seriesId: seriesId,
            title: void 0,
            datum: void 0,
            value: value
        });
    }
    pickNodeClosestDatum(point) {
        return $2fb96651e8aa1522$var$pickGaugeNearestDatum(this, point);
    }
    pickFocus(opts) {
        return $2fb96651e8aa1522$var$pickGaugeFocus(this, opts);
    }
    getCaptionText() {
        const { value: value } = this.properties;
        const description = [];
        description.push(this.formatLabel(value));
        this.labelSelection.each((_label, datum)=>{
            const text2 = $2fb96651e8aa1522$var$getLabelText(this.id, this.ctx, datum);
            if (text2 != null) description.push(text2);
        });
        return description.join(". ");
    }
    getCategoryValue(_datumIndex) {
        return;
    }
    datumIndexForCategoryValue(_categoryValue) {
        return;
    }
};
$2fb96651e8aa1522$var$RadialGaugeSeries.className = "RadialGaugeSeries";
$2fb96651e8aa1522$var$RadialGaugeSeries.type = "radial-gauge";
// packages/ag-charts-enterprise/src/series/radial-gauge/radialGaugeModule.ts
var { FONT_SIZE_RATIO: $2fb96651e8aa1522$var$FONT_SIZE_RATIO2 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$RadialGaugeModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "gauge"
    ],
    identifier: "radial-gauge",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$RadialGaugeSeries(ctx),
    tooltipDefaults: {
        range: 10
    },
    themeTemplate: {
        minWidth: 200,
        minHeight: 200,
        tooltip: {
            enabled: false
        },
        series: {
            outerRadiusRatio: 1,
            innerRadiusRatio: 0.8,
            startAngle: 270,
            endAngle: 450,
            defaultColorRange: {
                $if: [
                    {
                        $eq: [
                            {
                                $palette: "type"
                            },
                            "inbuilt"
                        ]
                    },
                    {
                        $interpolate: [
                            {
                                $palette: "secondDivergingColors"
                            },
                            5
                        ]
                    },
                    (0, $iTJTu._ModuleSupport).SAFE_RANGE2_OPERATION
                ]
            },
            scale: {
                // @ts-expect-error undocumented option
                defaultFill: {
                    $path: [
                        "./1",
                        {
                            $palette: "fill"
                        },
                        {
                            $palette: "hierarchyColors"
                        }
                    ]
                },
                // TODO: mix backgroundColor and foregroundColor?
                stroke: {
                    $path: [
                        "./2",
                        (0, $iTJTu._ModuleSupport).SAFE_STROKE_FILL_OPERATION,
                        {
                            $palette: "hierarchyColors"
                        }
                    ]
                },
                // TODO: mix backgroundColor and foregroundColor?
                label: {
                    fontWeight: {
                        $ref: "fontWeight"
                    },
                    fontSize: {
                        $ref: "fontSize"
                    },
                    fontFamily: {
                        $ref: "fontFamily"
                    },
                    color: {
                        $ref: "textColor"
                    },
                    spacing: 12
                }
            },
            bar: {
                strokeWidth: 0
            },
            segmentation: {
                enabled: false,
                interval: {},
                spacing: 2
            },
            defaultTarget: {
                fill: {
                    $ref: "foregroundColor"
                },
                stroke: {
                    $ref: "foregroundColor"
                },
                size: 10,
                shape: "triangle",
                placement: "outside",
                spacing: 5,
                label: {
                    enabled: true,
                    fontWeight: {
                        $ref: "fontWeight"
                    },
                    fontSize: {
                        $ref: "fontSize"
                    },
                    fontFamily: {
                        $ref: "fontFamily"
                    },
                    color: {
                        $ref: "textColor"
                    },
                    spacing: 5
                }
            },
            needle: {
                enabled: false,
                fill: {
                    $ref: "foregroundColor"
                },
                spacing: 10
            },
            label: {
                enabled: true,
                fontWeight: {
                    $ref: "fontWeight"
                },
                fontSize: 56,
                minimumFontSize: 18 / 56,
                fontFamily: {
                    $ref: "fontFamily"
                },
                color: {
                    $ref: "textColor"
                }
            },
            secondaryLabel: {
                enabled: true,
                fontWeight: {
                    $ref: "fontWeight"
                },
                fontSize: {
                    $rem: [
                        $2fb96651e8aa1522$var$FONT_SIZE_RATIO2.LARGE
                    ]
                },
                minimumFontSize: {
                    $ref: "fontSize"
                },
                fontFamily: {
                    $ref: "fontFamily"
                },
                color: {
                    $ref: "subtleTextColor"
                }
            }
        }
    }
};
var $2fb96651e8aa1522$var$RadialGaugeSeriesModule = {
    type: "series",
    name: "radial-gauge",
    chartType: "gauge",
    enterprise: true,
    options: (0, $iTJTu._ModuleSupport).radialGaugeSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$RadialGaugeSeries(ctx)
};
// packages/ag-charts-enterprise/src/series/sankey/sankeyLayout.ts
function $2fb96651e8aa1522$var$sortNodesByY(column) {
    column.nodes.sort((a, b)=>Math.round((a.datum.y - b.datum.y) * 100) / 100 || -(a.datum.size - b.datum.size));
}
function $2fb96651e8aa1522$var$justifyNodesAcrossColumn({ nodes: nodes, size: size }, { seriesRectHeight: seriesRectHeight, nodeSpacing: nodeSpacing, sizeScale: sizeScale }) {
    const nodesHeight = seriesRectHeight * size * sizeScale;
    let y = (seriesRectHeight - (nodesHeight + nodeSpacing * (nodes.length - 1))) / 2;
    nodes.forEach(({ datum: node })=>{
        const height = seriesRectHeight * node.size * sizeScale;
        node.y = y;
        node.height = height;
        y += height + nodeSpacing;
    });
}
function $2fb96651e8aa1522$var$separateNodesInColumn(column, layout) {
    const { nodes: nodes } = column;
    const { seriesRectHeight: seriesRectHeight, nodeSpacing: nodeSpacing } = layout;
    $2fb96651e8aa1522$var$sortNodesByY(column);
    let totalShift = 0;
    let currentTop = 0;
    for (const { datum: node } of nodes){
        const shift = Math.max(currentTop - node.y, 0);
        node.y += shift;
        totalShift += shift;
        currentTop = node.y + node.height + nodeSpacing;
    }
    const lastNodeBottom = currentTop - nodeSpacing;
    if (lastNodeBottom < seriesRectHeight) return totalShift > 0;
    let currentBottom = seriesRectHeight;
    for(let i = nodes.length - 1; i >= 0; i -= 1){
        const { datum: node } = nodes[i];
        const nodeBottom = node.y + node.height;
        const shift = Math.min(currentBottom - nodeBottom, 0);
        node.y += shift;
        totalShift += shift;
        currentBottom = node.y - nodeSpacing;
    }
    return true;
}
function $2fb96651e8aa1522$var$hasCrossOver(x00, y00, x01, y01, x10, y10, x11, y11) {
    const recM0 = (x01 - x00) / (y01 - y00);
    const recM1 = (x11 - x10) / (y11 - y10);
    const x = ((y10 - y00) * (recM0 * recM1) + x00 * recM1 - x10 * recM0) / (recM1 - recM0);
    if (x00 < x01) return x > x00 && x < Math.min(x01, x11);
    else return x < x00 && x > Math.max(x01, x11);
}
function $2fb96651e8aa1522$var$removeColumnCrossoversInDirection(column, getLinks) {
    let didShift = false;
    const singleCrossoverColumns = column.nodes.filter((node)=>getLinks(node).length === 1);
    let didRemoveCrossover = true;
    for(let runs = 0; didRemoveCrossover && runs < singleCrossoverColumns.length; runs += 1){
        didRemoveCrossover = false;
        for(let i = 0; i < singleCrossoverColumns.length - 1; i += 1){
            const { datum: node } = singleCrossoverColumns[i];
            const nodeAfter = getLinks(singleCrossoverColumns[i])[0].node.datum;
            const { datum: otherNode } = singleCrossoverColumns[i + 1];
            const otherNodeAfter = getLinks(singleCrossoverColumns[i + 1])[0].node.datum;
            const crossover = $2fb96651e8aa1522$var$hasCrossOver(node.x, node.y, nodeAfter.x, nodeAfter.y, otherNode.x, otherNode.y, otherNodeAfter.x, otherNodeAfter.y) || $2fb96651e8aa1522$var$hasCrossOver(node.x, node.y + node.height / 2, nodeAfter.x, nodeAfter.y + nodeAfter.height / 2, otherNode.x, otherNode.y + otherNode.height / 2, otherNodeAfter.x, otherNodeAfter.y + otherNodeAfter.height / 2) || $2fb96651e8aa1522$var$hasCrossOver(node.x, node.y + node.height, nodeAfter.x, nodeAfter.y + nodeAfter.height, otherNode.x, otherNode.y + otherNode.height, otherNodeAfter.x, otherNodeAfter.y + otherNodeAfter.height);
            if (!crossover) continue;
            const current = singleCrossoverColumns[i];
            singleCrossoverColumns[i] = singleCrossoverColumns[i + 1];
            singleCrossoverColumns[i + 1] = current;
            const y = node.y;
            node.y = otherNode.y + otherNode.height - node.height;
            otherNode.y = y;
            didShift = true;
            didRemoveCrossover = true;
        }
    }
    return didShift;
}
function $2fb96651e8aa1522$var$removeColumnCrossovers(column) {
    let didShift = false;
    $2fb96651e8aa1522$var$sortNodesByY(column);
    didShift = $2fb96651e8aa1522$var$removeColumnCrossoversInDirection(column, (node)=>node.linksBefore) || didShift;
    didShift = $2fb96651e8aa1522$var$removeColumnCrossoversInDirection(column, (node)=>node.linksAfter) || didShift;
    return didShift;
}
function $2fb96651e8aa1522$var$weightedNodeY(links) {
    if (links.length === 0) return;
    let totalYValues = 0;
    let totalSize = 0;
    for (const { node: { datum: node } } of links){
        totalYValues += node.y * node.size;
        totalSize += node.size;
    }
    return totalYValues / totalSize;
}
function $2fb96651e8aa1522$var$layoutColumn(column, layout, weight, direction) {
    column.nodes.forEach(({ datum: node, linksBefore: linksBefore, linksAfter: linksAfter })=>{
        const forwardLinks = direction === 1 ? linksBefore : linksAfter;
        const backwardsLinks = direction === 1 ? linksAfter : linksBefore;
        const nextY = $2fb96651e8aa1522$var$weightedNodeY(forwardLinks);
        if (nextY != null) {
            const nodeWeight = backwardsLinks.length !== 0 ? weight : 1;
            node.y = node.y + (nextY - node.y) * nodeWeight;
        }
    });
    return $2fb96651e8aa1522$var$separateNodesInColumn(column, layout);
}
function $2fb96651e8aa1522$var$layoutColumnsForward(columns, layout, weight) {
    let didShift = false;
    for (const column of columns)didShift = $2fb96651e8aa1522$var$layoutColumn(column, layout, weight, 1) || didShift;
    return didShift;
}
function $2fb96651e8aa1522$var$layoutColumnsBackwards(columns, layout, weight) {
    let didShift = false;
    for(let i = columns.length - 1; i >= 0; i -= 1)didShift = $2fb96651e8aa1522$var$layoutColumn(columns[i], layout, weight, -1) || didShift;
    return didShift;
}
function $2fb96651e8aa1522$var$removeColumnsCrossovers(columns) {
    let didShift = false;
    for(let i = columns.length - 1; i >= 0; i -= 1)didShift = $2fb96651e8aa1522$var$removeColumnCrossovers(columns[i]) || didShift;
    return didShift;
}
function $2fb96651e8aa1522$var$layoutColumns(columns, layout) {
    columns.forEach((column)=>{
        $2fb96651e8aa1522$var$justifyNodesAcrossColumn(column, layout);
    });
    let didLayoutColumnsBackwards = false;
    for(let i = 0; i < 6; i += 1){
        const didLayoutColumnsForward = $2fb96651e8aa1522$var$layoutColumnsForward(columns, layout, 1);
        didLayoutColumnsBackwards = $2fb96651e8aa1522$var$layoutColumnsBackwards(columns, layout, 0.5);
        const didRemoveColumnCrossovers = $2fb96651e8aa1522$var$removeColumnsCrossovers(columns);
        if (!didLayoutColumnsForward && !didLayoutColumnsBackwards && !didRemoveColumnCrossovers) break;
    }
    if (didLayoutColumnsBackwards) {
        $2fb96651e8aa1522$var$layoutColumnsForward(columns, layout, 1);
        $2fb96651e8aa1522$var$removeColumnsCrossovers(columns);
    }
}
var { BBox: $2fb96651e8aa1522$var$BBox23, Path: $2fb96651e8aa1522$var$Path13, SceneChangeDetection: $2fb96651e8aa1522$var$SceneChangeDetection9, splitBezier: $2fb96651e8aa1522$var$splitBezier } = (0, $iTJTu._ModuleSupport);
function $2fb96651e8aa1522$var$offsetTrivialCubicBezier(path, p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y, offset) {
    let tx, ty;
    if (p1y !== p0y && p3y !== p2y) {
        const slope1 = -(p1x - p0x) / (p1y - p0y);
        const slope2 = -(p3x - p2x) / (p3y - p2y);
        tx = (p2y - p0y + slope1 * p0x - slope2 * p2x) / (slope1 - slope2);
        ty = slope1 * (tx - p0x) + p0y;
    } else if (p1y === p0y && p3y !== p2y) {
        tx = p0x;
        const slope2 = -(p3x - p2x) / (p3y - p2y);
        ty = slope2 * (tx - p3x) + p3y;
    } else if (p1y !== p0y && p3y === p2y) {
        tx = p3x;
        const slope1 = -(p1x - p0x) / (p1y - p0y);
        ty = slope1 * (tx - p0x) + p0y;
    } else throw new Error("Offsetting flat bezier curve");
    const d0 = Math.hypot(p0y - ty, p0x - tx);
    const s0 = (d0 + offset) / d0;
    const d1 = Math.hypot(p3y - ty, p3x - tx);
    const s1 = (d1 + offset) / d1;
    const q1x = tx + (p1x - tx) * s0;
    const q1y = ty + (p1y - ty) * s0;
    const q2x = tx + (p2x - tx) * s1;
    const q2y = ty + (p2y - ty) * s1;
    const q3x = tx + (p3x - tx) * s1;
    const q3y = ty + (p3y - ty) * s1;
    path.cubicCurveTo(q1x, q1y, q2x, q2y, q3x, q3y);
}
var $2fb96651e8aa1522$var$SankeyLink = class extends $2fb96651e8aa1522$var$Path13 {
    constructor(){
        super(...arguments);
        this.x1 = 0;
        this.x2 = 0;
        this.y1 = 0;
        this.y2 = 0;
        this.height = 0;
        this.inset = 0;
    }
    computeBBox() {
        const x = Math.min(this.x1, this.x2);
        const width = Math.max(this.x1, this.x2) - x;
        const y = Math.min(this.y1, this.y2);
        const height = Math.max(this.y1, this.y2) - y + this.height;
        return new $2fb96651e8aa1522$var$BBox23(x, y, width, height);
    }
    updatePath() {
        const { path: path, inset: inset } = this;
        path.clear();
        const x1 = this.x1 + inset;
        const x2 = this.x2 - inset;
        const y1 = this.y1 + inset;
        const y2 = this.y2 + inset;
        const height = this.height - 2 * inset;
        if (height < 0 || x1 > x2) return;
        const p0x = x1;
        const p0y = y1 + height / 2;
        const p1x = (x1 + x2) / 2;
        const p1y = y1 + height / 2;
        const p2x = (x1 + x2) / 2;
        const p2y = y2 + height / 2;
        const p3x = x2;
        const p3y = y2 + height / 2;
        path.moveTo(p0x, p0y - height / 2);
        if (Math.abs(this.y2 - this.y1) < 1 || this.x2 - this.x1 < this.height * Math.SQRT2) {
            path.cubicCurveTo(p1x, p1y - height / 2, p2x, p2y - height / 2, p3x, p3y - height / 2);
            path.lineTo(p3x, p3y + height / 2);
            path.cubicCurveTo(p2x, p2y + height / 2, p1x, p1y + height / 2, p0x, p0y + height / 2);
        } else {
            const [a, b] = $2fb96651e8aa1522$var$splitBezier(p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y, 0.5);
            const offset = (y2 > y1 ? 1 : -1) * height / 2;
            $2fb96651e8aa1522$var$offsetTrivialCubicBezier(path, a[0].x, a[0].y, a[1].x, a[1].y, a[2].x, a[2].y, a[3].x, a[3].y, offset);
            $2fb96651e8aa1522$var$offsetTrivialCubicBezier(path, b[0].x, b[0].y, b[1].x, b[1].y, b[2].x, b[2].y, b[3].x, b[3].y, -offset);
            path.lineTo(p3x, p3y + height / 2);
            $2fb96651e8aa1522$var$offsetTrivialCubicBezier(path, b[3].x, b[3].y, b[2].x, b[2].y, b[1].x, b[1].y, b[0].x, b[0].y, offset);
            $2fb96651e8aa1522$var$offsetTrivialCubicBezier(path, a[3].x, a[3].y, a[2].x, a[2].y, a[1].x, a[1].y, a[0].x, a[0].y, -offset);
        }
        path.closePath();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection9()
], $2fb96651e8aa1522$var$SankeyLink.prototype, "x1", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection9()
], $2fb96651e8aa1522$var$SankeyLink.prototype, "x2", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection9()
], $2fb96651e8aa1522$var$SankeyLink.prototype, "y1", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection9()
], $2fb96651e8aa1522$var$SankeyLink.prototype, "y2", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection9()
], $2fb96651e8aa1522$var$SankeyLink.prototype, "height", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$SceneChangeDetection9()
], $2fb96651e8aa1522$var$SankeyLink.prototype, "inset", 2);
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties28, FillGradientDefaults: $2fb96651e8aa1522$var$FillGradientDefaults16, FillPatternDefaults: $2fb96651e8aa1522$var$FillPatternDefaults16, FillImageDefaults: $2fb96651e8aa1522$var$FillImageDefaults16, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip22, SeriesProperties: $2fb96651e8aa1522$var$SeriesProperties13, Property: $2fb96651e8aa1522$var$Property82, Label: $2fb96651e8aa1522$var$Label17 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$SankeySeriesLabelProperties = class extends $2fb96651e8aa1522$var$Label17 {
    constructor(){
        super(...arguments);
        this.spacing = 1;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesLabelProperties.prototype, "spacing", 2);
var $2fb96651e8aa1522$var$SankeySeriesLinkProperties = class extends $2fb96651e8aa1522$var$BaseProperties28 {
    constructor(){
        super(...arguments);
        this.fill = void 0;
        this.fillOpacity = 1;
        this.stroke = void 0;
        this.strokeOpacity = 1;
        this.strokeWidth = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesLinkProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesLinkProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesLinkProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesLinkProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesLinkProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesLinkProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesLinkProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesLinkProperties.prototype, "itemStyler", 2);
var $2fb96651e8aa1522$var$SankeySeriesNodeProperties = class extends $2fb96651e8aa1522$var$BaseProperties28 {
    constructor(){
        super(...arguments);
        this.spacing = 1;
        this.width = 1;
        this.alignment = "justify";
        this.fill = void 0;
        this.fillOpacity = 1;
        this.stroke = void 0;
        this.strokeOpacity = 1;
        this.strokeWidth = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesNodeProperties.prototype, "spacing", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesNodeProperties.prototype, "width", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesNodeProperties.prototype, "alignment", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesNodeProperties.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesNodeProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesNodeProperties.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesNodeProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesNodeProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesNodeProperties.prototype, "lineDash", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesNodeProperties.prototype, "lineDashOffset", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesNodeProperties.prototype, "itemStyler", 2);
var $2fb96651e8aa1522$var$SankeySeriesProperties = class extends $2fb96651e8aa1522$var$SeriesProperties13 {
    constructor(){
        super(...arguments);
        this.nodes = void 0;
        this.idKey = "";
        this.idName = void 0;
        this.labelKey = void 0;
        this.labelName = void 0;
        this.sizeKey = void 0;
        this.sizeName = void 0;
        this.fillGradientDefaults = new $2fb96651e8aa1522$var$FillGradientDefaults16();
        this.fillPatternDefaults = new $2fb96651e8aa1522$var$FillPatternDefaults16();
        this.fillImageDefaults = new $2fb96651e8aa1522$var$FillImageDefaults16();
        this.defaultColorRange = [];
        this.defaultPatternFills = [];
        this.fills = [];
        this.strokes = [];
        this.label = new $2fb96651e8aa1522$var$SankeySeriesLabelProperties();
        this.link = new $2fb96651e8aa1522$var$SankeySeriesLinkProperties();
        this.node = new $2fb96651e8aa1522$var$SankeySeriesNodeProperties();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip22();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "nodes", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "fromKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "toKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "idKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "idName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "labelKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "labelName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "sizeKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "sizeName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "fillGradientDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "fillPatternDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "fillImageDefaults", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "defaultColorRange", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "defaultPatternFills", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "fills", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "strokes", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "link", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "node", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property82
], $2fb96651e8aa1522$var$SankeySeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-enterprise/src/series/sankey/sankeySeries.ts
var { Transformable: $2fb96651e8aa1522$var$Transformable3, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle15, SeriesNodePickMode: $2fb96651e8aa1522$var$SeriesNodePickMode18, CachedTextMeasurerPool: $2fb96651e8aa1522$var$CachedTextMeasurerPool12, TextWrapper: $2fb96651e8aa1522$var$TextWrapper6, TextUtils: $2fb96651e8aa1522$var$TextUtils8, createDatumId: $2fb96651e8aa1522$var$createDatumId22, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle18, Rect: $2fb96651e8aa1522$var$Rect9, BBox: $2fb96651e8aa1522$var$BBox24 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$SankeySeries = class extends $2fb96651e8aa1522$var$FlowProportionSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            pickModes: [
                $2fb96651e8aa1522$var$SeriesNodePickMode18.NEAREST_NODE,
                $2fb96651e8aa1522$var$SeriesNodePickMode18.EXACT_SHAPE_MATCH
            ]
        });
        this.properties = new $2fb96651e8aa1522$var$SankeySeriesProperties();
    }
    isLabelEnabled() {
        return (this.properties.labelKey != null || this.nodes == null) && this.properties.label.enabled;
    }
    linkFactory() {
        return new $2fb96651e8aa1522$var$SankeyLink();
    }
    nodeFactory() {
        return new $2fb96651e8aa1522$var$Rect9();
    }
    createNodeData() {
        const { id: seriesId, _nodeDataDependencies: { seriesRectWidth: seriesRectWidth, seriesRectHeight: seriesRectHeight } = {
            seriesRectWidth: 0,
            seriesRectHeight: 0
        } } = this;
        const { fromKey: fromKey, toKey: toKey, sizeKey: sizeKey, label: { spacing: labelSpacing }, node: { spacing: nodeSpacing, width: nodeWidth, alignment: alignment } } = this.properties;
        const { nodeGraph: baseNodeGraph, links: links, maxPathLength: maxPathLength } = this.getNodeGraph((node)=>({
                ...node,
                x: NaN,
                y: NaN,
                width: nodeWidth,
                height: NaN
            }), (link)=>({
                ...link,
                x1: NaN,
                x2: NaN,
                y1: NaN,
                y2: NaN,
                height: NaN
            }), {
            includeCircularReferences: false
        });
        const nodeGraph = baseNodeGraph;
        const inset = this.isLabelEnabled() ? (seriesRectWidth - nodeWidth) * (1 - maxPathLength / (maxPathLength + 1)) : 0;
        const columnWidth = (seriesRectWidth - nodeWidth - 2 * inset) / (maxPathLength - 1);
        const columns = [];
        for(let index = 0; index < maxPathLength; index += 1){
            const x = inset + index * columnWidth;
            columns.push({
                index: index,
                size: 0,
                nodes: [],
                x: x
            });
        }
        nodeGraph.forEach((graphNode)=>{
            const { datum: node, linksBefore: linksBefore, linksAfter: linksAfter, maxPathLengthBefore: maxPathLengthBefore, maxPathLengthAfter: maxPathLengthAfter } = graphNode;
            const size = Math.max(linksBefore.reduce((acc, { link: link })=>acc + link.size, 0), linksAfter.reduce((acc, { link: link })=>acc + link.size, 0));
            if (linksBefore.length === 0 && linksAfter.length === 0 || size === 0) {
                graphNode.columnIndex = -1;
                return;
            }
            let column;
            switch(alignment){
                case "left":
                    column = columns[maxPathLengthBefore];
                    break;
                case "right":
                    column = columns[maxPathLength - 1 - maxPathLengthAfter];
                    break;
                case "center":
                    if (linksBefore.length !== 0) column = columns[maxPathLengthBefore];
                    else if (linksAfter.length !== 0) {
                        const columnIndex = linksAfter.reduce((acc, link)=>Math.min(acc, link.node.maxPathLengthBefore), maxPathLength) - 1;
                        column = columns[columnIndex];
                    } else column = columns[0];
                    break;
                case "justify":
                    column = linksAfter.length === 0 ? columns[maxPathLength - 1] : columns[maxPathLengthBefore];
                    break;
            }
            node.x = column.x;
            node.size = size;
            const label = this.getLabelText(this.properties.label, {
                datum: node.datum,
                value: node.label,
                fromKey: fromKey,
                toKey: toKey,
                sizeKey: sizeKey,
                size: size
            });
            node.label = String(label);
            column.nodes.push(graphNode);
            column.size += size;
            graphNode.columnIndex = column.index;
        });
        nodeGraph.forEach((graphNode)=>{
            let closestColumnIndex = Infinity;
            let maxSizeOfClosestNodesAfter = 0;
            graphNode.linksAfter.forEach((link)=>{
                const node = link.node;
                const { columnIndex: columnIndex } = node;
                if (columnIndex < closestColumnIndex) {
                    closestColumnIndex = columnIndex;
                    maxSizeOfClosestNodesAfter = node.datum.size;
                } else if (columnIndex === closestColumnIndex) maxSizeOfClosestNodesAfter = Math.max(maxSizeOfClosestNodesAfter, node.datum.size);
            });
            graphNode.closestColumnIndex = closestColumnIndex;
            graphNode.maxSizeOfClosestNodesAfter = maxSizeOfClosestNodesAfter;
        });
        const sizeScale = columns.reduce((acc, { size: size, nodes: nodes })=>{
            const columnSizeScale = (1 - (nodes.length - 1) * (nodeSpacing / seriesRectHeight)) / size;
            return Math.min(acc, columnSizeScale);
        }, Infinity);
        for(let i = columns.length - 1; i >= 0; i -= 1){
            const nodes = columns[i].nodes;
            nodes.sort((a, b)=>a.closestColumnIndex - b.closestColumnIndex || a.maxSizeOfClosestNodesAfter - b.maxSizeOfClosestNodesAfter || a.datum.size - b.datum.size);
        }
        $2fb96651e8aa1522$var$layoutColumns(columns, {
            seriesRectHeight: seriesRectHeight,
            nodeSpacing: nodeSpacing,
            sizeScale: sizeScale
        });
        let hasNegativeNodeHeight = false;
        nodeGraph.forEach(({ datum: node, linksBefore: linksBefore, linksAfter: linksAfter })=>{
            hasNegativeNodeHeight || (hasNegativeNodeHeight = node.height < 0);
            const bottom = node.y + node.height;
            const sortNodes = (l)=>{
                return l.sort((a, b)=>{
                    const aNode = a.node.datum;
                    const bNode = b.node.datum;
                    const aBottom = aNode.y + aNode.height;
                    const bBottom = bNode.y + bNode.height;
                    const dAngleTop = Math.atan2(aNode.y - node.y, Math.abs(aNode.x - node.x)) - Math.atan2(bNode.y - node.y, Math.abs(bNode.x - node.x));
                    const dAngleBottom = Math.atan2(aBottom - bottom, Math.abs(aNode.x - node.x)) - Math.atan2(bBottom - bottom, Math.abs(bNode.x - node.x));
                    return dAngleTop + dAngleBottom;
                });
            };
            let y2 = node.y;
            sortNodes(linksBefore).forEach(({ link: link })=>{
                link.y2 = y2;
                y2 += link.size * seriesRectHeight * sizeScale;
            });
            let y1 = node.y;
            sortNodes(linksAfter).forEach(({ link: link })=>{
                link.y1 = y1;
                y1 += link.size * seriesRectHeight * sizeScale;
            });
        });
        if (hasNegativeNodeHeight) {
            (0, $idDdm.Logger).warnOnce("There was insufficient space to display the Sankey Series. Reduce the node spacing, or provide a larger container.");
            return;
        }
        const nodeData = [];
        const labelData = [];
        const { fontSize: fontSize } = this.properties.label;
        const canvasFont = this.properties.label.getFont();
        columns.forEach((column, index)=>{
            const leading = index === 0;
            const trailing = index === columns.length - 1;
            let bottom = -Infinity;
            column.nodes.sort((a, b)=>a.datum.y - b.datum.y);
            column.nodes.forEach(({ datum: node })=>{
                node.midPoint = {
                    x: node.x + node.width / 2,
                    y: node.y + node.height / 2
                };
                nodeData.push(node);
                if (node.label == null) return;
                const x = leading ? node.x - labelSpacing : node.x + node.width + labelSpacing;
                const y = node.y + node.height / 2;
                let text2;
                if (!leading && !trailing) {
                    const y12 = y - $2fb96651e8aa1522$var$TextUtils8.getLineHeight(fontSize);
                    const y2 = y + $2fb96651e8aa1522$var$TextUtils8.getLineHeight(fontSize);
                    let maxX = seriesRectWidth;
                    nodeGraph.forEach(({ datum: datum })=>{
                        const intersectsLabel = datum.x > node.x && Math.max(datum.y, y12) <= Math.min(datum.y + datum.height, y2);
                        if (intersectsLabel) maxX = Math.min(maxX, datum.x - labelSpacing);
                    });
                    const maxWidth = maxX - node.x - 2 * labelSpacing;
                    text2 = $2fb96651e8aa1522$var$TextWrapper6.wrapText(node.label, {
                        maxWidth: maxWidth,
                        maxHeight: node.height,
                        font: this.properties.label,
                        textWrap: "never",
                        overflow: "hide"
                    });
                }
                if (text2 == null || text2 === "") {
                    const labelInset = leading || trailing ? labelSpacing : labelSpacing * 2;
                    text2 = $2fb96651e8aa1522$var$TextWrapper6.wrapText(node.label, {
                        maxWidth: columnWidth - labelInset,
                        maxHeight: node.height,
                        font: this.properties.label,
                        textWrap: "never"
                    });
                }
                if (text2 === "") return;
                const { height: height } = $2fb96651e8aa1522$var$CachedTextMeasurerPool12.measureText(text2, {
                    font: canvasFont,
                    textAlign: "left",
                    textBaseline: "middle"
                });
                const y0 = y - height / 2;
                const y1 = y + height / 2;
                if (y0 >= bottom) {
                    labelData.push({
                        x: x,
                        y: y,
                        leading: leading,
                        text: text2
                    });
                    bottom = y1;
                }
            });
        });
        links.forEach((link)=>{
            const { fromNode: fromNode, toNode: toNode, size: size } = link;
            link.height = seriesRectHeight * size * sizeScale;
            link.x1 = fromNode.x + nodeWidth;
            link.x2 = toNode.x;
            link.midPoint = {
                x: (link.x1 + link.x2) / 2,
                y: (link.y1 + link.y2) / 2 + link.height / 2
            };
            nodeData.push(link);
        });
        return {
            itemId: seriesId,
            nodeData: nodeData,
            labelData: labelData
        };
    }
    updateLabelSelection(opts) {
        const labels = this.isLabelEnabled() ? opts.labelData : [];
        return opts.labelSelection.update(labels);
    }
    updateLabelNodes(opts) {
        const { labelSelection: labelSelection } = opts;
        const { color: fill, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily } = this.properties.label;
        labelSelection.each((label, { x: x, y: y, leading: leading, text: text2 })=>{
            label.visible = true;
            label.x = x;
            label.y = y;
            label.text = text2;
            label.fill = fill;
            label.fontStyle = fontStyle;
            label.fontWeight = fontWeight;
            label.fontSize = fontSize;
            label.fontFamily = fontFamily;
            label.textAlign = leading ? "right" : "left";
            label.textBaseline = "middle";
        });
    }
    updateNodeSelection(opts) {
        return opts.datumSelection.update(opts.nodeData, void 0, (datum)=>$2fb96651e8aa1522$var$createDatumId22([
                datum.type,
                datum.id
            ]));
    }
    getBaseNodeStyle(highlighted) {
        const { properties: properties } = this;
        const { fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = properties.node;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return $2fb96651e8aa1522$var$getShapeStyle18({
            fill: highlightStyle?.fill ?? fill,
            fillOpacity: highlightStyle?.fillOpacity ?? fillOpacity,
            stroke: highlightStyle?.stroke ?? stroke2,
            strokeOpacity: highlightStyle?.strokeOpacity ?? strokeOpacity,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(properties.node.strokeWidth),
            lineDash: highlightStyle?.lineDash ?? lineDash,
            lineDashOffset: highlightStyle?.lineDashOffset ?? lineDashOffset
        }, properties.fillGradientDefaults, properties.fillPatternDefaults, properties.fillImageDefaults);
    }
    getNodeStyleOverrides(datumId, datum, datumIndex, size, label, format, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const { fills: fills, strokes: strokes, defaultColorRange: defaultColorRange, defaultPatternFills: defaultPatternFills } = properties;
        const { itemStyler: itemStyler } = properties.node;
        const fill = format.fill ?? fills[datumIndex % fills.length];
        const stroke2 = format.stroke ?? strokes[datumIndex % strokes.length];
        const defaultColorStops = defaultColorRange[datumIndex % defaultColorRange.length].map((color6)=>({
                color: color6
            }));
        const defaultPatternFill = defaultPatternFills[datumIndex % defaultPatternFills.length];
        let overrides;
        if (!highlighted) {
            overrides ?? (overrides = {});
            overrides.fill = fill;
            overrides.stroke = stroke2;
        }
        if (itemStyler != null) {
            const itemStyle = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId22(datumId, "node", highlighted ? "highlight" : "node"), ()=>{
                const { fillOpacity: fillOpacity = 1, strokeOpacity: strokeOpacity = 1, strokeWidth: strokeWidth = 0, lineDash: lineDash = [], lineDashOffset: lineDashOffset = 0 } = format;
                return this.callWithContext(itemStyler, {
                    seriesId: seriesId,
                    datum: datum,
                    highlighted: highlighted,
                    label: label,
                    size: size,
                    fill: fill,
                    fillOpacity: fillOpacity,
                    stroke: stroke2,
                    strokeOpacity: strokeOpacity,
                    strokeWidth: strokeWidth,
                    lineDash: lineDash,
                    lineDashOffset: lineDashOffset
                });
            });
            overrides ?? (overrides = {});
            Object.assign(overrides, itemStyle);
        }
        return $2fb96651e8aa1522$var$getShapeStyle18(overrides, {
            ...this.properties.fillGradientDefaults.toJson(),
            colorStops: defaultColorStops
        }, {
            ...this.properties.fillPatternDefaults.toJson(),
            fill: defaultPatternFill,
            stroke: defaultPatternFill
        }, this.properties.fillImageDefaults);
    }
    updateNodeNodes(opts) {
        const { datumSelection: datumSelection, isHighlight: isHighlight } = opts;
        const style = this.getBaseNodeStyle(isHighlight);
        const fillBBox = this.getShapeFillBBox();
        datumSelection.each((rect, datum)=>{
            const { datumIndex: datumIndex, size: size, label: label } = datum;
            const overrides = this.getNodeStyleOverrides(String(datumIndex.index), datum.datum, datumIndex.index, size, label, style, isHighlight);
            rect.x = datum.x;
            rect.y = datum.y;
            rect.width = Math.max(datum.width, 0);
            rect.height = Math.max(datum.height, 0);
            $2fb96651e8aa1522$var$applyShapeStyle15(rect, style, overrides, fillBBox);
        });
    }
    getShapeFillBBox() {
        const width = this._nodeDataDependencies?.seriesRectWidth ?? 0;
        const height = this._nodeDataDependencies?.seriesRectHeight ?? 0;
        const bbox = new $2fb96651e8aa1522$var$BBox24(0, 0, width, height);
        return {
            series: bbox,
            axis: bbox
        };
    }
    updateLinkSelection(opts) {
        return opts.datumSelection.update(opts.nodeData, void 0, (datum)=>$2fb96651e8aa1522$var$createDatumId22([
                datum.type,
                datum.index,
                datum.fromNode.id,
                datum.toNode.id
            ]));
    }
    getBaseLinkStyle(highlighted) {
        const { properties: properties } = this;
        const { fill: fill, fillOpacity: fillOpacity, stroke: stroke2, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset } = properties.link;
        const highlightStyle = highlighted ? properties.highlightStyle.item : void 0;
        return $2fb96651e8aa1522$var$getShapeStyle18({
            fill: highlightStyle?.fill ?? fill,
            fillOpacity: highlightStyle?.fillOpacity ?? fillOpacity,
            stroke: highlightStyle?.stroke ?? stroke2,
            strokeOpacity: highlightStyle?.strokeOpacity ?? strokeOpacity,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(properties.link.strokeWidth),
            lineDash: highlightStyle?.lineDash ?? lineDash,
            lineDashOffset: highlightStyle?.lineDashOffset ?? lineDashOffset
        }, properties.fillGradientDefaults, properties.fillPatternDefaults, properties.fillImageDefaults);
    }
    getLinkStyleOverrides(datumId, datum, datumIndex, format, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const { fills: fills, strokes: strokes, defaultColorRange: defaultColorRange, defaultPatternFills: defaultPatternFills } = properties;
        const { itemStyler: itemStyler } = properties.link;
        const fill = format.fill ?? fills[datumIndex % fills.length];
        const stroke2 = format.stroke ?? strokes[datumIndex % strokes.length];
        const defaultColorStops = defaultColorRange[datumIndex % defaultColorRange.length].map((color6)=>({
                color: color6
            }));
        const defaultPatternFill = defaultPatternFills[datumIndex % defaultPatternFills.length];
        let overrides;
        if (!highlighted) {
            overrides ?? (overrides = {});
            overrides.fill = fill;
            overrides.stroke = stroke2;
        }
        if (itemStyler != null) {
            const itemStyle = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId22(datumId, "link", highlighted ? "highlight" : "node"), ()=>{
                const { fillOpacity: fillOpacity = 1, strokeOpacity: strokeOpacity = 1, strokeWidth: strokeWidth = 0, lineDash: lineDash = [], lineDashOffset: lineDashOffset = 0 } = format;
                return this.callWithContext(itemStyler, {
                    seriesId: seriesId,
                    datum: datum,
                    highlighted: highlighted,
                    fill: fill,
                    fillOpacity: fillOpacity,
                    stroke: stroke2,
                    strokeOpacity: strokeOpacity,
                    strokeWidth: strokeWidth,
                    lineDash: lineDash,
                    lineDashOffset: lineDashOffset
                });
            });
            overrides ?? (overrides = {});
            Object.assign(overrides, itemStyle);
        }
        return $2fb96651e8aa1522$var$getShapeStyle18(overrides, {
            ...this.properties.fillGradientDefaults.toJson(),
            colorStops: defaultColorStops
        }, {
            ...this.properties.fillPatternDefaults.toJson(),
            fill: defaultPatternFill,
            stroke: defaultPatternFill
        }, this.properties.fillImageDefaults);
    }
    updateLinkNodes(opts) {
        const { datumSelection: datumSelection, isHighlight: isHighlight } = opts;
        const style = this.getBaseLinkStyle(isHighlight);
        const fillBBox = this.getShapeFillBBox();
        datumSelection.each((link, datum)=>{
            const { datumIndex: datumIndex } = datum;
            const fromNodeDatumIndex = datum.fromNode.datumIndex;
            const overrides = this.getLinkStyleOverrides(String(datumIndex.index), datum.datum, fromNodeDatumIndex.index, style, isHighlight);
            link.x1 = datum.x1;
            link.y1 = datum.y1;
            link.x2 = datum.x2;
            link.y2 = datum.y2;
            link.height = datum.height;
            $2fb96651e8aa1522$var$applyShapeStyle15(link, style, overrides, fillBBox);
            link.inset = link.strokeWidth / 2;
        });
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, linksProcessedData: linksProcessedData, nodesProcessedData: nodesProcessedData, properties: properties } = this;
        const { fromKey: fromKey, toKey: toKey, sizeKey: sizeKey, sizeName: sizeName, tooltip: tooltip } = properties;
        const seriesDatum = this.contextNodeData?.nodeData.find((d)=>d.datumIndex.type === datumIndex.type && d.datumIndex.index === datumIndex.index);
        if (seriesDatum == null) return;
        const nodeIndex = seriesDatum.type === 0 /* Link */  ? seriesDatum.fromNode.index : seriesDatum.index;
        const title = seriesDatum.type === 0 /* Link */  ? `${seriesDatum.fromNode.label} - ${seriesDatum.toNode.label}` : seriesDatum.label;
        const datum = datumIndex.type === 0 /* Link */  ? linksProcessedData?.dataSources.get(this.id)?.[datumIndex.index] : nodesProcessedData?.dataSources.get(this.id)?.[datumIndex.index];
        const size = seriesDatum.size;
        let format;
        if (seriesDatum.type === 0 /* Link */ ) {
            const fromNodeDatumIndex = seriesDatum.fromNode.datumIndex;
            const linkFormat = this.getBaseLinkStyle(false);
            Object.assign(linkFormat, this.getLinkStyleOverrides(String(datumIndex.index), datum, fromNodeDatumIndex.index, linkFormat, false));
            format = linkFormat;
        } else {
            const label = seriesDatum.label;
            const nodeFormat = this.getBaseNodeStyle(false);
            Object.assign(nodeFormat, this.getNodeStyleOverrides(String(datumIndex.index), datum, datumIndex.index, size, label, nodeFormat, false));
            format = nodeFormat;
        }
        return this.formatTooltipWithContext(tooltip, {
            title: title,
            symbol: this.legendItemSymbol(seriesDatum.type, nodeIndex, format),
            data: sizeKey != null ? [
                {
                    label: sizeName,
                    fallbackLabel: sizeKey,
                    value: String(size)
                }
            ] : []
        }, {
            seriesId: seriesId,
            datum: datum,
            title: title,
            fromKey: fromKey,
            toKey: toKey,
            sizeKey: sizeKey,
            sizeName: sizeName,
            size: size,
            ...format
        });
    }
    computeFocusBounds(node) {
        if (node instanceof $2fb96651e8aa1522$var$Rect9) {
            const { x: x, y: y, width: width, height: height } = node;
            const bbox = new $2fb96651e8aa1522$var$BBox24(x, y, width, height);
            return $2fb96651e8aa1522$var$Transformable3.toCanvas(this.contentGroup, bbox);
        }
        return node;
    }
};
$2fb96651e8aa1522$var$SankeySeries.className = "SankeySeries";
$2fb96651e8aa1522$var$SankeySeries.type = "sankey";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs21, sankeySeriesThemeableOptionsDef: $2fb96651e8aa1522$var$sankeySeriesThemeableOptionsDef } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$sankeySeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$sankeySeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$commonSeriesOptionsDefs21,
    type: (0, $idDdm.required)((0, $idDdm.constant)("sankey")),
    fromKey: (0, $idDdm.required)((0, $idDdm.string)),
    toKey: (0, $idDdm.required)((0, $idDdm.string)),
    sizeKey: (0, $idDdm.string),
    sizeName: (0, $idDdm.string)
};
$2fb96651e8aa1522$var$sankeySeriesOptionsDef.fillGradientDefaults = (0, $idDdm.undocumented)((0, $idDdm.fillGradientDefaults));
$2fb96651e8aa1522$var$sankeySeriesOptionsDef.fillPatternDefaults = (0, $idDdm.undocumented)((0, $idDdm.fillPatternDefaults));
$2fb96651e8aa1522$var$sankeySeriesOptionsDef.fillImageDefaults = (0, $idDdm.undocumented)((0, $idDdm.fillImageDefaults));
$2fb96651e8aa1522$var$sankeySeriesOptionsDef.defaultColorRange = (0, $idDdm.undocumented)((0, $idDdm.arrayOf)((0, $idDdm.arrayOf)((0, $idDdm.color))));
$2fb96651e8aa1522$var$sankeySeriesOptionsDef.defaultPatternFills = (0, $idDdm.undocumented)((0, $idDdm.arrayOf)((0, $idDdm.color)));
// packages/ag-charts-enterprise/src/series/sankey/sankeyModule.ts
var $2fb96651e8aa1522$var$SankeyModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "flow-proportion"
    ],
    solo: true,
    identifier: "sankey",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$SankeySeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    themeTemplate: {
        seriesArea: {
            padding: {
                top: 10,
                bottom: 10
            }
        },
        series: {
            fills: {
                $palette: "fills"
            },
            strokes: {
                $palette: "strokes"
            },
            // @ts-expect-error undocumented option
            fillGradientDefaults: {
                type: "gradient",
                gradient: "linear",
                bounds: "item",
                colorStops: {
                    $palette: "gradient"
                },
                rotation: 0,
                reverse: false
            },
            fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
            fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
            defaultColorRange: {
                $palette: "gradients"
            },
            defaultPatternFills: (0, $iTJTu._ModuleSupport).SAFE_FILLS_OPERATION,
            highlightStyle: {
                series: {
                    dimOpacity: 0.2
                }
            },
            label: {
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontSize: {
                    $ref: "fontSize"
                },
                fontWeight: {
                    $ref: "fontWeight"
                },
                color: {
                    $ref: "textColor"
                },
                spacing: 10
            },
            node: {
                spacing: 20,
                width: 10,
                strokeWidth: 0
            },
            link: {
                fillOpacity: 0.5,
                strokeWidth: 0
            }
        },
        legend: {
            enabled: false,
            toggleSeries: false
        }
    }
};
var $2fb96651e8aa1522$var$SankeySeriesModule = {
    type: "series",
    name: "sankey",
    chartType: "flow-proportion",
    enterprise: true,
    options: $2fb96651e8aa1522$var$sankeySeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$SankeySeries(ctx)
};
var { HierarchySeriesProperties: $2fb96651e8aa1522$var$HierarchySeriesProperties, HighlightStyle: $2fb96651e8aa1522$var$HighlightStyle, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip23, Property: $2fb96651e8aa1522$var$Property83 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$SunburstSeriesTileHighlightStyle = class extends $2fb96651e8aa1522$var$HighlightStyle {
    constructor(){
        super(...arguments);
        this.label = new $2fb96651e8aa1522$var$AutoSizedLabel();
        this.secondaryLabel = new $2fb96651e8aa1522$var$AutoSizedLabel();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesTileHighlightStyle.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesTileHighlightStyle.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesTileHighlightStyle.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesTileHighlightStyle.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesTileHighlightStyle.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesTileHighlightStyle.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesTileHighlightStyle.prototype, "secondaryLabel", 2);
var $2fb96651e8aa1522$var$SunburstSeriesProperties = class extends $2fb96651e8aa1522$var$HierarchySeriesProperties {
    constructor(){
        super(...arguments);
        this.fillOpacity = 1;
        this.strokeWidth = 0;
        this.strokeOpacity = 1;
        this.cornerRadius = 0;
        this.highlightStyle = new $2fb96651e8aa1522$var$SunburstSeriesTileHighlightStyle();
        this.label = new $2fb96651e8aa1522$var$AutoSizedLabel();
        this.secondaryLabel = new $2fb96651e8aa1522$var$AutoSizedSecondaryLabel();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip23();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesProperties.prototype, "sizeName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesProperties.prototype, "labelKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesProperties.prototype, "secondaryLabelKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesProperties.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesProperties.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesProperties.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesProperties.prototype, "cornerRadius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesProperties.prototype, "sectorSpacing", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesProperties.prototype, "padding", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesProperties.prototype, "itemStyler", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesProperties.prototype, "highlightStyle", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesProperties.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesProperties.prototype, "secondaryLabel", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property83
], $2fb96651e8aa1522$var$SunburstSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-enterprise/src/series/sunburst/sunburstSeries.ts
var { fromToMotion: $2fb96651e8aa1522$var$fromToMotion6, normalizeAngle360: $2fb96651e8aa1522$var$normalizeAngle3607, createDatumId: $2fb96651e8aa1522$var$createDatumId23, Sector: $2fb96651e8aa1522$var$Sector7, Group: $2fb96651e8aa1522$var$Group21, ScalableGroup: $2fb96651e8aa1522$var$ScalableGroup2, Selection: $2fb96651e8aa1522$var$Selection17, TransformableText: $2fb96651e8aa1522$var$TransformableText3, BBox: $2fb96651e8aa1522$var$BBox25, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle16, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle19 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$SunburstNode = class extends (0, $iTJTu._ModuleSupport).HierarchyNode {
    constructor(){
        super(...arguments);
        this.label = void 0;
        this.secondaryLabel = void 0;
        this.contentHeight = 0;
        this.bbox = void 0;
        this.startAngle = 0;
        this.endAngle = 0;
    }
};
function $2fb96651e8aa1522$var$setAngleData(node, startAngle = 0, angleScale = 2 * Math.PI / node.sumSize) {
    for (const child of node.children){
        const endAngle = startAngle + child.sumSize * angleScale;
        child.startAngle = startAngle;
        child.endAngle = endAngle;
        $2fb96651e8aa1522$var$setAngleData(child, startAngle, angleScale);
        startAngle = endAngle;
    }
}
var $2fb96651e8aa1522$var$SunburstSeries = class extends (0, $iTJTu._ModuleSupport).HierarchySeries {
    constructor(){
        super(...arguments);
        this.NodeClass = $2fb96651e8aa1522$var$SunburstNode;
        this.properties = new $2fb96651e8aa1522$var$SunburstSeriesProperties();
        this.scalingGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$ScalableGroup2());
        this.sectorGroup = this.scalingGroup.appendChild(new $2fb96651e8aa1522$var$Group21());
        this.sectorLabelGroup = this.scalingGroup.appendChild(new $2fb96651e8aa1522$var$Group21());
        this.highlightSectorGroup = this.scalingGroup.appendChild(new $2fb96651e8aa1522$var$Group21());
        this.datumSelection = $2fb96651e8aa1522$var$Selection17.select(this.sectorGroup, $2fb96651e8aa1522$var$Sector7);
        this.labelSelection = $2fb96651e8aa1522$var$Selection17.select(this.sectorLabelGroup, $2fb96651e8aa1522$var$Group21);
        this.highlightSelection = $2fb96651e8aa1522$var$Selection17.select(this.highlightSectorGroup, $2fb96651e8aa1522$var$Sector7);
    }
    processData() {
        super.processData();
        $2fb96651e8aa1522$var$setAngleData(this.rootNode);
    }
    updateSelections() {
        const highlightedNode = this.ctx.highlightManager?.getActiveHighlight();
        this.highlightSelection.update(highlightedNode != null ? [
            highlightedNode
        ] : [], void 0, (node)=>this.getDatumId(node));
        if (!this.nodeDataRefresh) return;
        this.nodeDataRefresh = false;
        const { chart: chart } = this;
        if (chart == null) return;
        const seriesRect = chart.seriesRect;
        if (seriesRect == null) return;
        const descendants = Array.from(this.rootNode);
        const updateLabelGroup = (group)=>{
            group.append([
                new $2fb96651e8aa1522$var$TransformableText3({
                    tag: 0 /* Primary */ 
                }),
                new $2fb96651e8aa1522$var$TransformableText3({
                    tag: 1 /* Secondary */ 
                })
            ]);
        };
        this.datumSelection.update(descendants, void 0, (node)=>this.getDatumId(node));
        this.labelSelection.update(descendants, updateLabelGroup, (node)=>this.getDatumId(node));
    }
    getItemBaseStyle(highlighted) {
        const { properties: properties } = this;
        const highlightStyle = highlighted ? properties.highlightStyle : void 0;
        return $2fb96651e8aa1522$var$getShapeStyle19({
            fill: highlightStyle?.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? properties.fillOpacity,
            stroke: highlightStyle?.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? this.getStrokeWidth(properties.strokeWidth),
            strokeOpacity: highlightStyle?.strokeOpacity ?? properties.strokeOpacity
        }, properties.fillGradientDefaults, properties.fillPatternDefaults, properties.fillImageDefaults);
    }
    getItemStyleOverrides(datumId, datum, depth, colorValue, format, highlighted) {
        const { id: seriesId, properties: properties, colorScale: colorScale } = this;
        const { fills: fills, strokes: strokes, itemStyler: itemStyler } = properties;
        const rootIndex = datumId[0];
        const fill = format.fill ?? fills[rootIndex % fills.length];
        const stroke2 = format.stroke ?? strokes[rootIndex % strokes.length];
        const overrides = {};
        if (!highlighted) {
            overrides.fill = colorValue != null ? colorScale.convert(colorValue) : fill;
            overrides.stroke = stroke2;
        }
        if (itemStyler != null) {
            const itemStyle = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId23(datumId.join(":"), highlighted ? "highlight" : "node"), ()=>{
                return this.callWithContext(itemStyler, {
                    seriesId: seriesId,
                    datum: datum,
                    depth: depth,
                    highlighted: highlighted,
                    fill: fill,
                    stroke: stroke2,
                    ...format
                });
            });
            Object.assign(overrides, itemStyle);
        }
        return $2fb96651e8aa1522$var$getShapeStyle19(overrides, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
    }
    updateNodes() {
        const { chart: chart, data: data, maxDepth: maxDepth } = this;
        if (chart == null || data == null) return;
        const { width: width, height: height } = chart.seriesRect;
        const { sectorSpacing: sectorSpacing = 0, padding: padding = 0, cornerRadius: cornerRadius, childrenKey: childrenKey, colorKey: colorKey, colorName: colorName, labelKey: labelKey, secondaryLabelKey: secondaryLabelKey, sizeKey: sizeKey, sizeName: sizeName } = this.properties;
        this.contentGroup.translationX = width / 2;
        this.contentGroup.translationY = height / 2;
        const baseInset = sectorSpacing * 0.5;
        const radius = Math.min(width, height) / 2;
        const radiusScale = radius / (maxDepth + 1);
        const angleOffset = -Math.PI / 2;
        const seriesFillBBox = {
            series: new $2fb96651e8aa1522$var$BBox25(-radius, -radius, 2 * radius, 2 * radius),
            axis: new $2fb96651e8aa1522$var$BBox25(-radius, -radius, 2 * radius, 2 * radius)
        };
        this.rootNode?.walk((node)=>{
            const { startAngle: startAngle, endAngle: endAngle } = node;
            if (node.depth != null) {
                const midAngle = (startAngle + endAngle) / 2 + angleOffset;
                const midRadius = (node.depth + 0.5) * radiusScale;
                node.midPoint.x = Math.cos(midAngle) * midRadius;
                node.midPoint.y = Math.sin(midAngle) * midRadius;
            }
        });
        this.rootNode?.walk((node)=>{
            const { datum: datum, depth: depth, startAngle: startAngle, endAngle: endAngle, parent: parent, sumSize: sumSize } = node;
            node.label = void 0;
            node.secondaryLabel = void 0;
            node.contentHeight = 0;
            let labelValue;
            if (datum != null && depth != null && labelKey != null) {
                const value = datum[labelKey];
                labelValue = this.getLabelText(this.properties.label, {
                    depth: depth,
                    datum: datum,
                    childrenKey: childrenKey,
                    colorKey: colorKey,
                    colorName: colorName,
                    labelKey: labelKey,
                    secondaryLabelKey: secondaryLabelKey,
                    sizeKey: sizeKey,
                    sizeName: sizeName,
                    value: value
                });
            }
            if (labelValue === "") labelValue = void 0;
            let secondaryLabelValue;
            if (datum != null && depth != null && secondaryLabelKey != null) {
                const value = datum[secondaryLabelKey];
                secondaryLabelValue = this.getLabelText(this.properties.secondaryLabel, {
                    depth: depth,
                    datum: datum,
                    childrenKey: childrenKey,
                    colorKey: colorKey,
                    colorName: colorName,
                    labelKey: labelKey,
                    secondaryLabelKey: secondaryLabelKey,
                    sizeKey: sizeKey,
                    sizeName: sizeName,
                    value: value
                });
            }
            if (secondaryLabelValue === "") secondaryLabelValue = void 0;
            if (depth == null) return;
            const innerRadius = depth * radiusScale + baseInset;
            const outerRadius = (depth + 1) * radiusScale - baseInset;
            const innerAngleOffset = innerRadius > baseInset ? baseInset / innerRadius : baseInset;
            const outerAngleOffset = outerRadius > baseInset ? baseInset / outerRadius : baseInset;
            const innerStartAngle = startAngle + innerAngleOffset;
            const innerEndAngle = endAngle + innerAngleOffset;
            const deltaInnerAngle = innerEndAngle - innerStartAngle;
            const outerStartAngle = startAngle + outerAngleOffset;
            const outerEndAngle = endAngle + outerAngleOffset;
            const deltaOuterAngle = outerEndAngle - outerStartAngle;
            const sizeFittingHeight = (labelHeight2)=>{
                const isCenterCircle = depth === 0 && parent?.sumSize === sumSize;
                if (isCenterCircle) {
                    const labelWidth2 = 2 * Math.sqrt(outerRadius ** 2 - (labelHeight2 * 0.5) ** 2);
                    return {
                        width: labelWidth2,
                        height: labelHeight2,
                        meta: 0 /* CenterCircle */ 
                    };
                }
                const parallelHeight = labelHeight2;
                const availableWidthUntilItHitsTheOuterRadius = 2 * Math.sqrt(outerRadius ** 2 - (innerRadius + parallelHeight) ** 2);
                const availableWidthUntilItHitsTheStraightEdges = deltaInnerAngle < Math.PI ? 2 * innerRadius * Math.tan(deltaInnerAngle * 0.5) : Infinity;
                const parallelWidth = Math.min(availableWidthUntilItHitsTheOuterRadius, availableWidthUntilItHitsTheStraightEdges);
                const maxPerpendicularAngle = Math.PI / 4;
                let perpendicularHeight;
                let perpendicularWidth;
                if (depth === 0) {
                    perpendicularHeight = labelHeight2;
                    perpendicularWidth = Math.sqrt(outerRadius ** 2 - (perpendicularHeight / 2) ** 2) - labelHeight2 / (2 * Math.tan(deltaOuterAngle * 0.5));
                } else if ($2fb96651e8aa1522$var$normalizeAngle3607(deltaInnerAngle) < maxPerpendicularAngle) {
                    perpendicularHeight = 2 * innerRadius * Math.tan(deltaInnerAngle * 0.5);
                    perpendicularWidth = Math.sqrt(outerRadius ** 2 - (perpendicularHeight / 2) ** 2) - innerRadius;
                } else {
                    perpendicularWidth = 0;
                    perpendicularHeight = 0;
                }
                return parallelWidth >= perpendicularWidth ? {
                    width: parallelWidth,
                    height: parallelHeight,
                    meta: 1 /* Parallel */ 
                } : {
                    width: perpendicularWidth,
                    height: perpendicularHeight,
                    meta: 2 /* Perpendicular */ 
                };
            };
            const formatting = $2fb96651e8aa1522$var$formatLabels(labelValue, this.properties.label, secondaryLabelValue, this.properties.secondaryLabel, {
                padding: padding
            }, sizeFittingHeight);
            if (formatting == null) return;
            const { width: labelWidth, height: labelHeight, meta: labelPlacement, label: label, secondaryLabel: secondaryLabel } = formatting;
            const theta = angleOffset + (startAngle + endAngle) / 2;
            const top = Math.sin(theta) >= 0;
            const right = Math.cos(theta) >= 0;
            const circleQuarter = (top ? 3 /* Top */  : 12 /* Bottom */ ) & (right ? 6 /* Right */  : 9 /* Left */ );
            let labelRadius;
            switch(labelPlacement){
                case 0 /* CenterCircle */ :
                    labelRadius = 0;
                    break;
                case 1 /* Parallel */ :
                    {
                        const opticalCentering = 0.58;
                        const idealRadius = outerRadius - (radiusScale - labelHeight) * opticalCentering;
                        const maximumRadius = Math.sqrt((outerRadius - padding) ** 2 - (labelWidth / 2) ** 2);
                        labelRadius = Math.min(idealRadius, maximumRadius);
                        break;
                    }
                case 2 /* Perpendicular */ :
                    if (depth === 0) {
                        const minimumRadius = labelHeight / (2 * Math.tan(deltaInnerAngle * 0.5)) + labelWidth * 0.5;
                        const maximumRadius = Math.sqrt(outerRadius ** 2 - (labelHeight * 0.5) ** 2) - labelWidth * 0.5;
                        labelRadius = (minimumRadius + maximumRadius) * 0.5;
                    } else labelRadius = (innerRadius + outerRadius) * 0.5;
                    break;
            }
            if (label != null) {
                const { fontStyle: fontStyle = "normal", fontFamily: fontFamily, fontWeight: fontWeight = "normal", color: color6 = "black" } = this.properties.label;
                node.label = {
                    ...label,
                    fontStyle: fontStyle,
                    fontFamily: fontFamily,
                    fontWeight: fontWeight,
                    color: color6,
                    labelPlacement: labelPlacement,
                    circleQuarter: circleQuarter,
                    radius: labelRadius,
                    theta: theta
                };
            }
            if (secondaryLabel != null) {
                const { fontStyle: fontStyle = "normal", fontFamily: fontFamily, fontWeight: fontWeight = "normal", color: color6 = "black" } = this.properties.secondaryLabel;
                node.secondaryLabel = {
                    ...secondaryLabel,
                    fontStyle: fontStyle,
                    fontFamily: fontFamily,
                    fontWeight: fontWeight,
                    color: color6,
                    labelPlacement: labelPlacement,
                    circleQuarter: circleQuarter,
                    radius: labelRadius,
                    theta: theta
                };
            }
            node.contentHeight = formatting.height;
        });
        const updateSector = (nodeDatum, sector, style, highlighted)=>{
            const { datum: datum, datumIndex: datumIndex, depth: depth, colorValue: colorValue, startAngle: startAngle, endAngle: endAngle } = nodeDatum;
            if (depth == null) {
                sector.visible = false;
                return;
            }
            sector.visible = true;
            const overrides = this.getItemStyleOverrides(datumIndex, datum, depth, colorValue, style, highlighted);
            const fill = overrides.fill ?? style.fill;
            const strokeWidth = overrides.strokeWidth ?? style.strokeWidth;
            const fillBBox = (0, $iTJTu._ModuleSupport).isGradientFill(fill) && fill.bounds !== "item" ? seriesFillBBox : void 0;
            $2fb96651e8aa1522$var$applyShapeStyle16(sector, style, overrides, fillBBox);
            sector.centerX = 0;
            sector.centerY = 0;
            sector.innerRadius = depth * radiusScale;
            sector.outerRadius = (depth + 1) * radiusScale;
            sector.startAngle = startAngle + angleOffset;
            sector.endAngle = endAngle + angleOffset;
            sector.inset = baseInset + strokeWidth * 0.5;
            sector.cornerRadius = cornerRadius;
        };
        const baseFormat = this.getItemBaseStyle(false);
        this.datumSelection.each((sector, datum)=>{
            updateSector(datum, sector, baseFormat, false);
        });
        const highlightFormat = this.getItemBaseStyle(true);
        this.highlightSelection.each((rect, datum)=>{
            updateSector(datum, rect, highlightFormat, true);
        });
        const updateText = (node, text2, tag, highlighted)=>{
            const { depth: depth, contentHeight: contentHeight } = node;
            const primary = tag === 0 /* Primary */ ;
            const label = primary ? node.label : node.secondaryLabel;
            if (depth == null || label == null) {
                text2.visible = false;
                return;
            }
            const { labelPlacement: labelPlacement, circleQuarter: circleQuarter, radius: textRadius, theta: theta } = label;
            let highlightedColor;
            if (highlighted) {
                const highlightedLabelStyle = primary ? this.properties.highlightStyle.label : this.properties.highlightStyle.secondaryLabel;
                highlightedColor = highlightedLabelStyle.color;
            }
            text2.text = label.text;
            text2.fontSize = label.fontSize;
            text2.lineHeight = label.lineHeight;
            text2.fontStyle = label.fontStyle;
            text2.fontFamily = label.fontFamily;
            text2.fontWeight = label.fontWeight;
            text2.fill = highlightedColor ?? label.color;
            switch(labelPlacement){
                case 0 /* CenterCircle */ :
                    text2.textAlign = "center";
                    text2.textBaseline = "top";
                    text2.translationX = 0;
                    text2.translationY = (primary ? 0 : contentHeight - label.height) - contentHeight * 0.5;
                    text2.rotation = 0;
                    break;
                case 1 /* Parallel */ :
                    {
                        const topHalf = (circleQuarter & 3 /* Top */ ) !== 0;
                        const translationRadius = primary === !topHalf ? textRadius : textRadius - (contentHeight - label.height);
                        text2.textAlign = "center";
                        text2.textBaseline = topHalf ? "bottom" : "top";
                        text2.translationX = Math.cos(theta) * translationRadius;
                        text2.translationY = Math.sin(theta) * translationRadius;
                        text2.rotation = topHalf ? theta - Math.PI * 0.5 : theta + Math.PI * 0.5;
                        break;
                    }
                case 2 /* Perpendicular */ :
                    {
                        const rightHalf = (circleQuarter & 6 /* Right */ ) !== 0;
                        const translation = primary === !rightHalf ? (contentHeight - label.height) * 0.5 : (label.height - contentHeight) * 0.5;
                        text2.textAlign = "center";
                        text2.textBaseline = "middle";
                        text2.translationX = Math.cos(theta) * textRadius + Math.cos(theta + Math.PI / 2) * translation;
                        text2.translationY = Math.sin(theta) * textRadius + Math.sin(theta + Math.PI / 2) * translation;
                        text2.rotation = rightHalf ? theta : theta + Math.PI;
                        break;
                    }
            }
            text2.visible = true;
        };
        const highlightedDatum = this.ctx.highlightManager?.getActiveHighlight();
        this.labelSelection.selectByClass($2fb96651e8aa1522$var$TransformableText3).forEach((text2)=>{
            const datum = text2.closestDatum();
            updateText(datum, text2, text2.tag, datum === highlightedDatum);
        });
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, properties: properties } = this;
        const { labelKey: labelKey, secondaryLabelKey: secondaryLabelKey, childrenKey: childrenKey, sizeKey: sizeKey, sizeName: sizeName, colorKey: colorKey, colorName: colorName, tooltip: tooltip } = properties;
        const nodeDatum = datumIndex.reduce((n, i)=>n?.children[i], this.rootNode);
        if (nodeDatum == null) return;
        const { datum: datum, depth: depth } = nodeDatum;
        if (datum == null || depth == null) return;
        const data = [];
        const datumSize = sizeKey != null ? datum[sizeKey] : void 0;
        if (datumSize != null) data.push({
            label: sizeName,
            fallbackLabel: sizeKey,
            value: datumSize
        });
        const datumColor = colorKey != null ? datum[colorKey] : void 0;
        if (datumColor != null) data.push({
            label: colorName,
            fallbackLabel: colorKey,
            value: datumColor
        });
        const format = this.getItemBaseStyle(false);
        Object.assign(format, this.getItemStyleOverrides(datumIndex, datum, depth, datumColor, format, false));
        const color6 = format.fill;
        const markerStyle = $2fb96651e8aa1522$var$getShapeStyle19({
            shape: "square",
            fill: color6,
            fillOpacity: 1,
            stroke: void 0,
            strokeWidth: 0,
            strokeOpacity: 1,
            lineDash: [
                0
            ],
            lineDashOffset: 0
        }, properties.fillGradientDefaults, properties.fillPatternDefaults, properties.fillImageDefaults);
        if ((0, $iTJTu._ModuleSupport).isGradientFill(markerStyle.fill)) markerStyle.fill = {
            ...markerStyle.fill,
            gradient: "linear",
            rotation: 0,
            reverse: false
        };
        return this.formatTooltipWithContext(tooltip, {
            title: labelKey != null ? datum[labelKey] : void 0,
            symbol: {
                marker: markerStyle
            },
            data: data
        }, {
            seriesId: seriesId,
            datum: datum,
            title: void 0,
            depth: depth,
            labelKey: labelKey,
            secondaryLabelKey: secondaryLabelKey,
            childrenKey: childrenKey,
            sizeKey: sizeKey,
            sizeName: sizeName,
            colorKey: colorKey,
            colorName: colorName,
            ...format
        });
    }
    createNodeData() {
        return void 0;
    }
    pickNodeClosestDatum(point) {
        return this.pickNodeNearestDistantObject(point, this.datumSelection.selectByClass($2fb96651e8aa1522$var$Sector7));
    }
    animateEmptyUpdateReady() {
        $2fb96651e8aa1522$var$fromToMotion6(this.id, "nodes", this.ctx.animationManager, [
            this.scalingGroup
        ], {
            toFn () {
                return {
                    scalingX: 1,
                    scalingY: 1
                };
            },
            fromFn () {
                return {
                    scalingX: 0,
                    scalingY: 0
                };
            }
        });
    }
    computeFocusBounds(node) {
        return node;
    }
};
$2fb96651e8aa1522$var$SunburstSeries.className = "SunburstSeries";
$2fb96651e8aa1522$var$SunburstSeries.type = "sunburst";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs22, sunburstSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$sunburstSeriesThemeableOptionsDef, without: $2fb96651e8aa1522$var$without5 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$sunburstSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$sunburstSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$without5($2fb96651e8aa1522$var$commonSeriesOptionsDefs22, [
        "highlightStyle"
    ]),
    type: (0, $idDdm.required)((0, $idDdm.constant)("sunburst")),
    labelKey: (0, $idDdm.string),
    secondaryLabelKey: (0, $idDdm.string),
    childrenKey: (0, $idDdm.string),
    sizeKey: (0, $idDdm.string),
    colorKey: (0, $idDdm.string),
    sizeName: (0, $idDdm.string),
    colorName: (0, $idDdm.string)
};
// packages/ag-charts-enterprise/src/series/sunburst/sunburstModule.ts
var { FONT_SIZE_RATIO: $2fb96651e8aa1522$var$FONT_SIZE_RATIO3 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$SunburstModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "hierarchy"
    ],
    identifier: "sunburst",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$SunburstSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    solo: true,
    themeTemplate: {
        series: {
            fills: {
                $palette: "fills"
            },
            strokes: {
                $palette: "strokes"
            },
            colorRange: {
                $palette: "divergingColors"
            },
            // @ts-expect-error undocumented option
            fillGradientDefaults: {
                type: "gradient",
                gradient: "radial",
                bounds: "series",
                colorStops: {
                    $palette: "gradient"
                },
                rotation: 0,
                reverse: true
            },
            fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
            fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
            label: {
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontSize: {
                    $rem: [
                        $2fb96651e8aa1522$var$FONT_SIZE_RATIO3.LARGE
                    ]
                },
                minimumFontSize: {
                    $round: [
                        {
                            $mul: [
                                {
                                    $ref: "fontSize"
                                },
                                0.75
                            ]
                        }
                    ]
                },
                fontWeight: {
                    $ref: "fontWeight"
                },
                color: {
                    $ref: "backgroundColor"
                },
                overflowStrategy: "ellipsis",
                wrapping: "never",
                spacing: 2
            },
            secondaryLabel: {
                fontFamily: {
                    $ref: "fontFamily"
                },
                fontSize: {
                    $rem: [
                        $2fb96651e8aa1522$var$FONT_SIZE_RATIO3.SMALLEST
                    ]
                },
                minimumFontSize: {
                    $round: [
                        {
                            $mul: [
                                {
                                    $ref: "fontSize"
                                },
                                7 / 12
                            ]
                        }
                    ]
                },
                fontWeight: {
                    $ref: "fontWeight"
                },
                color: {
                    $ref: "backgroundColor"
                },
                overflowStrategy: "ellipsis",
                wrapping: "never"
            },
            sectorSpacing: 2,
            padding: 3,
            highlightStyle: {
                label: {
                    color: {
                        $ref: "backgroundColor"
                    }
                },
                secondaryLabel: {
                    color: {
                        $ref: "backgroundColor"
                    }
                },
                fill: "rgba(255,255,255, 0.33)",
                stroke: `rgba(0, 0, 0, 0.4)`,
                strokeWidth: 2
            }
        },
        gradientLegend: {
            enabled: true
        }
    }
};
var $2fb96651e8aa1522$var$SunburstSeriesModule = {
    type: "series",
    name: "sunburst",
    chartType: "hierarchy",
    enterprise: true,
    options: $2fb96651e8aa1522$var$sunburstSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$SunburstSeries(ctx)
};
var { BaseProperties: $2fb96651e8aa1522$var$BaseProperties29, HierarchySeriesProperties: $2fb96651e8aa1522$var$HierarchySeriesProperties2, HighlightStyle: $2fb96651e8aa1522$var$HighlightStyle2, SeriesTooltip: $2fb96651e8aa1522$var$SeriesTooltip24, Property: $2fb96651e8aa1522$var$Property84, Label: $2fb96651e8aa1522$var$Label18 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$TreemapGroupLabel = class extends $2fb96651e8aa1522$var$Label18 {
    constructor(){
        super(...arguments);
        this.spacing = 0;
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapGroupLabel.prototype, "spacing", 2);
var $2fb96651e8aa1522$var$TreemapSeriesGroup = class extends $2fb96651e8aa1522$var$BaseProperties29 {
    constructor(){
        super(...arguments);
        this.fill = void 0;
        this.fillOpacity = 1;
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.cornerRadius = 0;
        this.textAlign = "center";
        this.gap = 0;
        this.padding = 0;
        this.interactive = true;
        this.label = new $2fb96651e8aa1522$var$TreemapGroupLabel();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroup.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroup.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroup.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroup.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroup.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroup.prototype, "cornerRadius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroup.prototype, "textAlign", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroup.prototype, "gap", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroup.prototype, "padding", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroup.prototype, "interactive", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroup.prototype, "label", 2);
var $2fb96651e8aa1522$var$TreemapSeriesTile = class extends $2fb96651e8aa1522$var$BaseProperties29 {
    constructor(){
        super(...arguments);
        this.fill = void 0;
        this.fillOpacity = 1;
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.cornerRadius = 0;
        this.textAlign = "center";
        this.verticalAlign = "middle";
        this.gap = 0;
        this.padding = 0;
        this.label = new $2fb96651e8aa1522$var$AutoSizedLabel();
        this.secondaryLabel = new $2fb96651e8aa1522$var$AutoSizedSecondaryLabel();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTile.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTile.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTile.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTile.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTile.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTile.prototype, "cornerRadius", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTile.prototype, "textAlign", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTile.prototype, "verticalAlign", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTile.prototype, "gap", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTile.prototype, "padding", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTile.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTile.prototype, "secondaryLabel", 2);
var $2fb96651e8aa1522$var$TreemapSeriesGroupHighlightStyle = class extends $2fb96651e8aa1522$var$BaseProperties29 {
    constructor(){
        super(...arguments);
        this.label = new $2fb96651e8aa1522$var$AutoSizedLabel();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroupHighlightStyle.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroupHighlightStyle.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroupHighlightStyle.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroupHighlightStyle.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroupHighlightStyle.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesGroupHighlightStyle.prototype, "label", 2);
var $2fb96651e8aa1522$var$TreemapSeriesTileHighlightStyle = class extends $2fb96651e8aa1522$var$BaseProperties29 {
    constructor(){
        super(...arguments);
        this.label = new $2fb96651e8aa1522$var$AutoSizedLabel();
        this.secondaryLabel = new $2fb96651e8aa1522$var$AutoSizedSecondaryLabel();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTileHighlightStyle.prototype, "fill", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTileHighlightStyle.prototype, "fillOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTileHighlightStyle.prototype, "stroke", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTileHighlightStyle.prototype, "strokeWidth", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTileHighlightStyle.prototype, "strokeOpacity", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTileHighlightStyle.prototype, "label", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesTileHighlightStyle.prototype, "secondaryLabel", 2);
var $2fb96651e8aa1522$var$TreemapSeriesHighlightStyle = class extends $2fb96651e8aa1522$var$HighlightStyle2 {
    constructor(){
        super(...arguments);
        this.group = new $2fb96651e8aa1522$var$TreemapSeriesGroupHighlightStyle();
        this.tile = new $2fb96651e8aa1522$var$TreemapSeriesTileHighlightStyle();
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesHighlightStyle.prototype, "group", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesHighlightStyle.prototype, "tile", 2);
var $2fb96651e8aa1522$var$TreemapSeriesProperties = class extends $2fb96651e8aa1522$var$HierarchySeriesProperties2 {
    constructor(){
        super(...arguments);
        this.highlightStyle = new $2fb96651e8aa1522$var$TreemapSeriesHighlightStyle();
        this.tooltip = new $2fb96651e8aa1522$var$SeriesTooltip24();
        this.group = new $2fb96651e8aa1522$var$TreemapSeriesGroup();
        this.tile = new $2fb96651e8aa1522$var$TreemapSeriesTile();
        this.undocumentedGroupFills = [];
        this.undocumentedGroupStrokes = [];
    }
};
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesProperties.prototype, "sizeName", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesProperties.prototype, "labelKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesProperties.prototype, "secondaryLabelKey", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesProperties.prototype, "itemStyler", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesProperties.prototype, "highlightStyle", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesProperties.prototype, "tooltip", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesProperties.prototype, "group", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesProperties.prototype, "tile", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesProperties.prototype, "undocumentedGroupFills", 2);
$2fb96651e8aa1522$var$__decorateClass([
    $2fb96651e8aa1522$var$Property84
], $2fb96651e8aa1522$var$TreemapSeriesProperties.prototype, "undocumentedGroupStrokes", 2);
// packages/ag-charts-enterprise/src/series/treemap/treemapSeries.ts
var { TextUtils: $2fb96651e8aa1522$var$TextUtils9, TextWrapper: $2fb96651e8aa1522$var$TextWrapper7, createDatumId: $2fb96651e8aa1522$var$createDatumId24, Rect: $2fb96651e8aa1522$var$Rect10, Group: $2fb96651e8aa1522$var$Group22, BBox: $2fb96651e8aa1522$var$BBox26, Selection: $2fb96651e8aa1522$var$Selection18, Text: $2fb96651e8aa1522$var$Text9, Transformable: $2fb96651e8aa1522$var$Transformable4, applyShapeStyle: $2fb96651e8aa1522$var$applyShapeStyle17, getShapeStyle: $2fb96651e8aa1522$var$getShapeStyle20 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$TreemapNode = class extends (0, $iTJTu._ModuleSupport).HierarchyNode {
    constructor(){
        super(...arguments);
        this.labelValue = void 0;
        this.secondaryLabelValue = void 0;
        this.label = void 0;
        this.secondaryLabel = void 0;
        this.bbox = void 0;
        this.padding = void 0;
    }
};
var $2fb96651e8aa1522$var$tempText = new $2fb96651e8aa1522$var$Text9();
function $2fb96651e8aa1522$var$getTextSize(text2, style) {
    const { fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily } = style;
    $2fb96651e8aa1522$var$tempText.setProperties({
        text: text2,
        fontStyle: fontStyle,
        fontWeight: fontWeight,
        fontSize: fontSize,
        fontFamily: fontFamily,
        textAlign: "left",
        textBaseline: "top"
    });
    const { width: width, height: height } = $2fb96651e8aa1522$var$tempText.getBBox();
    return {
        width: width,
        height: height
    };
}
function $2fb96651e8aa1522$var$nodeSize(node) {
    return node.children.length > 0 ? node.sumSize - node.sizeValue : node.sizeValue;
}
var $2fb96651e8aa1522$var$textAlignFactors2 = {
    left: 0,
    center: 0.5,
    right: 1
};
var $2fb96651e8aa1522$var$verticalAlignFactors4 = {
    top: 0,
    middle: 0.5,
    bottom: 1
};
var $2fb96651e8aa1522$var$DistantGroup = class extends (0, $iTJTu._ModuleSupport).Group {
    distanceSquared(x, y) {
        return this.getBBox().distanceSquared(x, y);
    }
};
var $2fb96651e8aa1522$var$TreemapSeries = class extends (0, $iTJTu._ModuleSupport).HierarchySeries {
    constructor(){
        super(...arguments);
        this.NodeClass = $2fb96651e8aa1522$var$TreemapNode;
        this.properties = new $2fb96651e8aa1522$var$TreemapSeriesProperties();
        this.rectGroup = this.contentGroup.appendChild(new $2fb96651e8aa1522$var$Group22());
        this.datumSelection = $2fb96651e8aa1522$var$Selection18.select(this.rectGroup, $2fb96651e8aa1522$var$Rect10);
        this.labelSelection = $2fb96651e8aa1522$var$Selection18.select(this.labelGroup, $2fb96651e8aa1522$var$Group22);
        this.highlightSelection = $2fb96651e8aa1522$var$Selection18.select(this.rectGroup, $2fb96651e8aa1522$var$Rect10);
    }
    groupTitleHeight(node, bbox) {
        const { labelValue: labelValue } = node;
        const { label: font2 } = this.properties.group;
        const heightRatioThreshold = 3;
        if (labelValue == null) return;
        else if (font2.fontSize > bbox.width / heightRatioThreshold || font2.fontSize > bbox.height / heightRatioThreshold) return;
        else {
            const { height: fontHeight } = $2fb96651e8aa1522$var$getTextSize(labelValue, font2);
            return Math.max(fontHeight, font2.fontSize);
        }
    }
    getNodePadding(node, bbox) {
        if (node.parent == null) return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
        else if (node.children.length === 0) {
            const { padding: padding2 } = this.properties.tile;
            return {
                top: padding2,
                right: padding2,
                bottom: padding2,
                left: padding2
            };
        }
        const { label: { spacing: spacing }, padding: padding } = this.properties.group;
        const fontHeight = this.groupTitleHeight(node, bbox);
        const titleHeight = fontHeight != null ? fontHeight + spacing : 0;
        return {
            top: padding + titleHeight,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    sortChildren({ children: children }) {
        const sortedChildrenIndices = Array.from(children, (_, i)=>i).filter((i)=>$2fb96651e8aa1522$var$nodeSize(children[i]) > 0).sort((aIndex, bIndex)=>$2fb96651e8aa1522$var$nodeSize(children[bIndex]) - $2fb96651e8aa1522$var$nodeSize(children[aIndex]));
        const childAt = (i)=>{
            const sortedIndex = sortedChildrenIndices[i];
            return children[sortedIndex];
        };
        return {
            sortedChildrenIndices: sortedChildrenIndices,
            childAt: childAt
        };
    }
    /**
   * Squarified Treemap algorithm
   * https://www.win.tue.nl/~vanwijk/stm.pdf
   */ squarify(node, bbox) {
        const { datum: datum, children: children } = node;
        if (bbox.width <= 0 || bbox.height <= 0) {
            node.bbox = void 0;
            node.padding = void 0;
            node.midPoint.x = NaN;
            node.midPoint.y = NaN;
            return;
        }
        const padding = datum != null ? this.getNodePadding(node, bbox) : {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
        if (node.parent == null) {
            node.bbox = void 0;
            node.padding = void 0;
            node.midPoint.x = NaN;
            node.midPoint.y = NaN;
        } else {
            node.bbox = bbox;
            node.padding = padding;
            node.midPoint.x = bbox.x + bbox.width / 2;
            node.midPoint.y = bbox.y;
        }
        const { sortedChildrenIndices: sortedChildrenIndices, childAt: childAt } = this.sortChildren(node);
        const allLeafNodes = sortedChildrenIndices.every((sortedIndex)=>children[sortedIndex].children.length === 0);
        const targetTileAspectRatio = 1;
        const width = bbox.width - padding.left - padding.right;
        const height = bbox.height - padding.top - padding.bottom;
        if (width <= 0 || height <= 0) return;
        const numChildren = sortedChildrenIndices.length;
        let stackSum = 0;
        let startIndex = 0;
        let minRatioDiff = Infinity;
        let partitionSum = sortedChildrenIndices.reduce((sum, sortedIndex)=>sum + $2fb96651e8aa1522$var$nodeSize(children[sortedIndex]), 0);
        const innerBox = new $2fb96651e8aa1522$var$BBox26(bbox.x + padding.left, bbox.y + padding.top, width, height);
        const partition = innerBox.clone();
        let i = 0;
        while(i < numChildren){
            const value = $2fb96651e8aa1522$var$nodeSize(childAt(i));
            const firstValue = $2fb96651e8aa1522$var$nodeSize(childAt(startIndex));
            const isVertical2 = partition.width < partition.height;
            stackSum += value;
            const partThickness = isVertical2 ? partition.height : partition.width;
            const partLength = isVertical2 ? partition.width : partition.height;
            const firstTileLength = partLength * firstValue / stackSum;
            let stackThickness = partThickness * stackSum / partitionSum;
            const ratio3 = Math.max(firstTileLength, stackThickness) / Math.min(firstTileLength, stackThickness);
            const diff8 = Math.abs(targetTileAspectRatio - ratio3);
            if (diff8 < minRatioDiff) {
                minRatioDiff = diff8;
                i++;
                continue;
            }
            stackSum -= value;
            stackThickness = partThickness * stackSum / partitionSum;
            let start2 = isVertical2 ? partition.x : partition.y;
            for(let j = startIndex; j < i; j++){
                const child = childAt(j);
                const childSize = $2fb96651e8aa1522$var$nodeSize(child);
                const x = isVertical2 ? start2 : partition.x;
                const y = isVertical2 ? partition.y : start2;
                const length = partLength * childSize / stackSum;
                const stackWidth = isVertical2 ? length : stackThickness;
                const stackHeight = isVertical2 ? stackThickness : length;
                const childBbox = new $2fb96651e8aa1522$var$BBox26(x, y, stackWidth, stackHeight);
                this.applyGap(innerBox, childBbox, allLeafNodes);
                this.squarify(child, childBbox);
                partitionSum -= childSize;
                start2 += length;
            }
            if (isVertical2) {
                partition.y += stackThickness;
                partition.height -= stackThickness;
            } else {
                partition.x += stackThickness;
                partition.width -= stackThickness;
            }
            startIndex = i;
            stackSum = 0;
            minRatioDiff = Infinity;
        }
        const isVertical = partition.width < partition.height;
        let start = isVertical ? partition.x : partition.y;
        for(let childIdx = startIndex; childIdx < numChildren; childIdx++){
            const child = childAt(childIdx);
            const x = isVertical ? start : partition.x;
            const y = isVertical ? partition.y : start;
            const part = $2fb96651e8aa1522$var$nodeSize(child) / partitionSum;
            const childWidth = partition.width * (isVertical ? part : 1);
            const childHeight = partition.height * (isVertical ? 1 : part);
            const childBox = new $2fb96651e8aa1522$var$BBox26(x, y, childWidth, childHeight);
            this.applyGap(innerBox, childBox, allLeafNodes);
            this.squarify(child, childBox);
            start += isVertical ? childWidth : childHeight;
        }
    }
    applyGap(innerBox, childBox, allLeafNodes) {
        const gap = allLeafNodes ? this.properties.tile.gap * 0.5 : this.properties.group.gap * 0.5;
        const getBounds = (box)=>({
                left: box.x,
                top: box.y,
                right: box.x + box.width,
                bottom: box.y + box.height
            });
        const innerBounds = getBounds(innerBox);
        const childBounds = getBounds(childBox);
        const sides = [
            "top",
            "right",
            "bottom",
            "left"
        ];
        sides.forEach((side)=>{
            if (!(0, $idDdm.isNumberEqual)(innerBounds[side], childBounds[side])) childBox.shrink(gap, side);
        });
    }
    createNodeData() {
        return void 0;
    }
    getGroupBaseStyle(highlighted) {
        const { properties: properties } = this;
        const { group: group } = properties;
        const highlightStyle = highlighted ? properties.highlightStyle.group : void 0;
        return $2fb96651e8aa1522$var$getShapeStyle20({
            fill: highlightStyle?.fill ?? group.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? group.fillOpacity,
            stroke: highlightStyle?.stroke ?? group.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? group.strokeWidth,
            strokeOpacity: highlightStyle?.strokeOpacity ?? group.strokeOpacity
        }, properties.fillGradientDefaults, properties.fillPatternDefaults, properties.fillImageDefaults);
    }
    getGroupStyleOverrides(datumId, datum, depth, format, highlighted) {
        const { id: seriesId, properties: properties } = this;
        const { undocumentedGroupFills: undocumentedGroupFills, undocumentedGroupStrokes: undocumentedGroupStrokes, itemStyler: itemStyler } = properties;
        const fill = format.fill ?? undocumentedGroupFills[Math.min(depth ?? 0, undocumentedGroupFills.length)];
        const stroke2 = format.stroke ?? undocumentedGroupStrokes[Math.min(depth ?? 0, undocumentedGroupStrokes.length)];
        const overrides = {};
        if (!highlighted) {
            overrides.fill = fill;
            overrides.stroke = stroke2;
        }
        if (itemStyler != null) {
            const itemStyle = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId24(datumId.join(":"), highlighted ? "highlight" : "node"), ()=>{
                return this.callWithContext(itemStyler, {
                    seriesId: seriesId,
                    datum: datum,
                    depth: depth,
                    highlighted: highlighted,
                    fill: fill,
                    stroke: stroke2,
                    ...format
                });
            });
            Object.assign(overrides, itemStyle);
        }
        return $2fb96651e8aa1522$var$getShapeStyle20(overrides, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
    }
    getTileBaseStyle(highlighted) {
        const { properties: properties } = this;
        const { tile: tile } = properties;
        const highlightStyle = highlighted ? properties.highlightStyle.tile : void 0;
        return $2fb96651e8aa1522$var$getShapeStyle20({
            fill: highlightStyle?.fill ?? tile.fill,
            fillOpacity: highlightStyle?.fillOpacity ?? tile.fillOpacity,
            stroke: highlightStyle?.stroke ?? tile.stroke,
            strokeWidth: highlightStyle?.strokeWidth ?? tile.strokeWidth,
            strokeOpacity: highlightStyle?.strokeOpacity ?? tile.strokeOpacity
        }, properties.fillGradientDefaults, properties.fillPatternDefaults, properties.fillImageDefaults);
    }
    getTileStyleOverrides(datumId, datum, depth, colorValue, format, highlighted) {
        const { id: seriesId, properties: properties, colorScale: colorScale } = this;
        const { fills: fills, strokes: strokes, itemStyler: itemStyler } = properties;
        const rootIndex = datumId[0];
        const fill = format.fill ?? fills[rootIndex % fills.length];
        const stroke2 = format.stroke ?? strokes[rootIndex % strokes.length];
        const overrides = {};
        if (!highlighted) {
            overrides.fill = colorValue != null ? colorScale.convert(colorValue) : fill;
            overrides.stroke = stroke2;
        }
        if (itemStyler != null) {
            const itemStyle = this.cachedDatumCallback($2fb96651e8aa1522$var$createDatumId24(datumId.join(":"), highlighted ? "highlight" : "node"), ()=>{
                return this.callWithContext(itemStyler, {
                    seriesId: seriesId,
                    datum: datum,
                    depth: depth,
                    highlighted: highlighted,
                    fill: fill,
                    stroke: stroke2,
                    ...format
                });
            });
            Object.assign(overrides, itemStyle);
        }
        return $2fb96651e8aa1522$var$getShapeStyle20(overrides, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
    }
    updateSelections() {
        let highlightedNode = this.ctx.highlightManager?.getActiveHighlight();
        if (highlightedNode != null && !this.properties.group.interactive && highlightedNode.children.length !== 0) highlightedNode = void 0;
        this.highlightSelection.update(highlightedNode != null ? [
            highlightedNode
        ] : [], void 0, (node)=>this.getDatumId(node));
        if (!this.nodeDataRefresh) return;
        this.nodeDataRefresh = false;
        const { seriesRect: seriesRect } = this.chart ?? {};
        if (!seriesRect) return;
        const descendants = Array.from(this.rootNode);
        const updateLabelGroup = (group)=>{
            group.append([
                new $2fb96651e8aa1522$var$Text9({
                    tag: 0 /* Primary */ 
                }),
                new $2fb96651e8aa1522$var$Text9({
                    tag: 1 /* Secondary */ 
                })
            ]);
        };
        this.datumSelection.update(descendants, void 0, (node)=>this.getDatumId(node));
        this.labelSelection.update(descendants, updateLabelGroup, (node)=>this.getDatumId(node));
    }
    updateNodes() {
        const { rootNode: rootNode, data: data } = this;
        const { childrenKey: childrenKey, colorKey: colorKey, colorName: colorName, labelKey: labelKey, secondaryLabelKey: secondaryLabelKey, sizeKey: sizeKey, sizeName: sizeName, highlightStyle: highlightStyle, tile: tile, group: group } = this.properties;
        const { seriesRect: seriesRect } = this.chart ?? {};
        if (!seriesRect || !data) return;
        this.rootNode?.walk((node)=>{
            const { datum: datum, depth: depth, children: children } = node;
            const isLeaf = children.length === 0;
            const labelStyle = isLeaf ? tile.label : group.label;
            let labelValue;
            if (datum != null && depth != null && labelKey != null) {
                const value = datum[labelKey];
                labelValue = this.getLabelText(labelStyle, {
                    depth: depth,
                    datum: datum,
                    childrenKey: childrenKey,
                    colorKey: colorKey,
                    colorName: colorName,
                    labelKey: labelKey,
                    secondaryLabelKey: secondaryLabelKey,
                    sizeKey: sizeKey,
                    sizeName: sizeName,
                    value: value
                });
            }
            if (labelValue === "") labelValue = void 0;
            let secondaryLabelValue;
            if (isLeaf && datum != null && depth != null && secondaryLabelKey != null) {
                const value = datum[secondaryLabelKey];
                secondaryLabelValue = this.getLabelText(tile.secondaryLabel, {
                    depth: depth,
                    datum: datum,
                    childrenKey: childrenKey,
                    colorKey: colorKey,
                    colorName: colorName,
                    labelKey: labelKey,
                    secondaryLabelKey: secondaryLabelKey,
                    sizeKey: sizeKey,
                    sizeName: sizeName,
                    value: value
                });
            }
            if (secondaryLabelValue === "") secondaryLabelValue = void 0;
            node.labelValue = labelValue;
            node.secondaryLabelValue = secondaryLabelValue;
        });
        const { width: width, height: height } = seriesRect;
        this.squarify(rootNode, new $2fb96651e8aa1522$var$BBox26(0, 0, width, height));
        this.rootNode?.walk((node)=>{
            const { bbox: bbox, children: children, labelValue: labelValue, secondaryLabelValue: secondaryLabelValue } = node;
            node.label = void 0;
            node.secondaryLabel = void 0;
            if (bbox == null) return;
            if (children.length === 0) {
                const layout = {
                    width: bbox.width,
                    height: bbox.height,
                    meta: null
                };
                const formatting = $2fb96651e8aa1522$var$formatLabels(labelValue, this.properties.tile.label, secondaryLabelValue, this.properties.tile.secondaryLabel, {
                    padding: tile.padding
                }, ()=>layout);
                if (formatting == null) return;
                const { height: labelHeight, label: label, secondaryLabel: secondaryLabel } = formatting;
                const { textAlign: textAlign, verticalAlign: verticalAlign, padding: padding } = tile;
                const textAlignFactor = $2fb96651e8aa1522$var$textAlignFactors2[textAlign] ?? 0.5;
                const labelX = bbox.x + padding + (bbox.width - 2 * padding) * textAlignFactor;
                const verticalAlignFactor = $2fb96651e8aa1522$var$verticalAlignFactors4[verticalAlign] ?? 0.5;
                const labelYStart = bbox.y + padding + labelHeight * 0.5 + (bbox.height - 2 * padding - labelHeight) * verticalAlignFactor;
                if (label != null) {
                    const { fontStyle: fontStyle = "normal", fontFamily: fontFamily, fontWeight: fontWeight = "normal", color: color6 = "black" } = this.properties.tile.label;
                    node.label = {
                        text: label.text,
                        fontSize: label.fontSize,
                        lineHeight: label.lineHeight,
                        fontStyle: fontStyle,
                        fontFamily: fontFamily,
                        fontWeight: fontWeight,
                        color: color6,
                        textAlign: textAlign,
                        verticalAlign: "middle",
                        x: labelX,
                        y: labelYStart - (labelHeight - label.height) * 0.5
                    };
                }
                if (secondaryLabel != null) {
                    const { fontStyle: fontStyle = "normal", fontFamily: fontFamily, fontWeight: fontWeight = "normal", color: color6 = "black" } = this.properties.tile.secondaryLabel;
                    node.secondaryLabel = {
                        text: secondaryLabel.text,
                        fontSize: secondaryLabel.fontSize,
                        lineHeight: secondaryLabel.fontSize,
                        fontStyle: fontStyle,
                        fontFamily: fontFamily,
                        fontWeight: fontWeight,
                        color: color6,
                        textAlign: textAlign,
                        verticalAlign: "middle",
                        x: labelX,
                        y: labelYStart + (labelHeight - secondaryLabel.height) * 0.5
                    };
                }
            } else if (labelValue == null) return;
            else {
                const { padding: padding, textAlign: textAlign } = group;
                const groupTitleHeight = this.groupTitleHeight(node, bbox);
                if (groupTitleHeight == null) return;
                const innerWidth = bbox.width - 2 * padding;
                const text2 = $2fb96651e8aa1522$var$TextWrapper7.wrapText(labelValue, {
                    maxWidth: bbox.width - 2 * padding,
                    font: group.label,
                    textWrap: "never"
                });
                const textAlignFactor = $2fb96651e8aa1522$var$textAlignFactors2[textAlign] ?? 0.5;
                const { fontStyle: fontStyle = "normal", fontFamily: fontFamily, fontWeight: fontWeight = "normal", color: color6 = "black" } = this.properties.group.label;
                node.label = {
                    text: text2,
                    fontSize: group.label.fontSize,
                    lineHeight: $2fb96651e8aa1522$var$TextUtils9.getLineHeight(group.label.fontSize),
                    fontStyle: fontStyle,
                    fontFamily: fontFamily,
                    fontWeight: fontWeight,
                    color: color6,
                    textAlign: textAlign,
                    verticalAlign: "middle",
                    x: bbox.x + padding + innerWidth * textAlignFactor,
                    y: bbox.y + padding + groupTitleHeight * 0.5
                };
            }
        });
        const fillBBox = {
            series: new $2fb96651e8aa1522$var$BBox26(0, 0, width, height),
            axis: new $2fb96651e8aa1522$var$BBox26(0, 0, width, height)
        };
        const updateRectFn = (node, rect, groupStyle, tileStyle, highlighted)=>{
            const { bbox: bbox } = node;
            if (bbox == null) {
                rect.visible = false;
                return;
            }
            const { datum: datum, depth: depth = -1, datumIndex: datumIndex, colorValue: colorValue } = node;
            const isLeaf = node.children.length === 0;
            const style = isLeaf ? tileStyle : groupStyle;
            const overrides = isLeaf ? this.getTileStyleOverrides(datumIndex, datum, depth, colorValue, style, highlighted) : this.getGroupStyleOverrides(datumIndex, datum, depth, style, highlighted);
            rect.crisp = true;
            $2fb96651e8aa1522$var$applyShapeStyle17(rect, style, overrides, fillBBox);
            rect.cornerRadius = isLeaf ? tile.cornerRadius : group.cornerRadius;
            rect.zIndex = [
                0,
                depth,
                highlighted ? 1 : 0
            ];
            const onlyLeaves = node.parent?.children.every((n)=>n.children.length === 0);
            const parentBbox = node.parent != null ? node.parent.bbox : void 0;
            const parentPadding = node.parent != null ? node.parent.padding : void 0;
            if (onlyLeaves === true && parentBbox != null && parentPadding != null) {
                rect.clipBBox = bbox;
                rect.x = parentBbox.x + parentPadding.left;
                rect.y = parentBbox.y + parentPadding.top;
                rect.width = parentBbox.width - (parentPadding.left + parentPadding.right);
                rect.height = parentBbox.height - (parentPadding.top + parentPadding.bottom);
            } else {
                rect.clipBBox = void 0;
                rect.x = bbox.x;
                rect.y = bbox.y;
                rect.width = bbox.width;
                rect.height = bbox.height;
            }
            rect.visible = true;
        };
        const baseGroupFormat = this.getGroupBaseStyle(false);
        const baseTileFormat = this.getTileBaseStyle(false);
        this.datumSelection.each((rect, datum)=>updateRectFn(datum, rect, baseGroupFormat, baseTileFormat, false));
        const highlightGroupFormat = this.getGroupBaseStyle(true);
        const highlightTileFormat = this.getTileBaseStyle(true);
        this.highlightSelection.each((rect, datum)=>{
            updateRectFn(datum, rect, highlightGroupFormat, highlightTileFormat, true);
        });
        const updateLabelFn = (node, text2, tag, highlighted)=>{
            const isLeaf = node.children.length === 0;
            const label = tag === 0 /* Primary */  ? node.label : node.secondaryLabel;
            if (label == null) {
                text2.visible = false;
                return;
            }
            let highlightedColor;
            if (highlighted) {
                const { tile: hTitle, group: hGroup } = highlightStyle;
                highlightedColor = hTitle.secondaryLabel.color;
                if (!isLeaf) highlightedColor = hGroup.label.color;
                else if (tag === 0 /* Primary */ ) highlightedColor = hTitle.label.color;
            }
            text2.text = label.text;
            text2.fontSize = label.fontSize;
            text2.lineHeight = label.lineHeight;
            text2.fontStyle = label.fontStyle;
            text2.fontFamily = label.fontFamily;
            text2.fontWeight = label.fontWeight;
            text2.fill = highlightedColor ?? label.color;
            text2.textAlign = label.textAlign;
            text2.textBaseline = label.verticalAlign;
            text2.x = label.x;
            text2.y = label.y;
            text2.visible = true;
            text2.zIndex = 1;
        };
        const highlightedDatum = this.ctx.highlightManager?.getActiveHighlight();
        this.labelSelection.selectByClass($2fb96651e8aa1522$var$Text9).forEach((text2)=>{
            const datum = text2.closestDatum();
            updateLabelFn(datum, text2, text2.tag, datum === highlightedDatum);
        });
    }
    pickNodesExactShape(point) {
        const nodes = super.pickNodesExactShape(point);
        nodes.sort((a, b)=>b.datumIndex.length - a.datumIndex.length);
        return nodes;
    }
    pickNodeClosestDatum(point) {
        const exactMatch = this.pickNodesExactShape(point);
        if (exactMatch.length !== 0) return {
            datum: exactMatch[0],
            distance: 0
        };
        return this.pickNodeNearestDistantObject(point, this.datumSelection.nodes());
    }
    getTooltipContent(datumIndex) {
        const { id: seriesId, properties: properties } = this;
        const { labelKey: labelKey, secondaryLabelKey: secondaryLabelKey, childrenKey: childrenKey, sizeKey: sizeKey, sizeName: sizeName, colorKey: colorKey, colorName: colorName, tooltip: tooltip } = properties;
        const nodeDatum = datumIndex.reduce((n, i)=>n?.children[i], this.rootNode);
        if (nodeDatum == null) return;
        const { datum: datum, depth: depth, children: children } = nodeDatum;
        if (datum == null || depth == null) return;
        const isLeaf = children.length === 0;
        const data = [];
        const datumSize = sizeKey != null ? datum[sizeKey] : void 0;
        if (datumSize != null) data.push({
            label: sizeName,
            fallbackLabel: sizeKey,
            value: datumSize
        });
        const datumColor = colorKey != null ? datum[colorKey] : void 0;
        if (datumColor != null) data.push({
            label: colorName,
            fallbackLabel: colorKey,
            value: datumColor
        });
        let format;
        if (isLeaf) {
            format = this.getTileBaseStyle(false);
            Object.assign(format, this.getTileStyleOverrides(datumIndex, datum, depth, datumColor, format, false));
        } else {
            format = this.getGroupBaseStyle(false);
            Object.assign(format, this.getGroupStyleOverrides(datumIndex, datum, depth, format, false));
        }
        const color6 = format.fill;
        const markerStyle = $2fb96651e8aa1522$var$getShapeStyle20({
            shape: "square",
            fill: color6,
            fillOpacity: 1,
            stroke: void 0,
            strokeWidth: 0,
            strokeOpacity: 1,
            lineDash: [
                0
            ],
            lineDashOffset: 0
        }, this.properties.fillGradientDefaults, this.properties.fillPatternDefaults, this.properties.fillImageDefaults);
        if ((0, $iTJTu._ModuleSupport).isGradientFill(markerStyle.fill)) markerStyle.fill = {
            ...markerStyle.fill,
            gradient: "linear",
            rotation: 0,
            reverse: false
        };
        const symbol = isLeaf ? {
            marker: markerStyle
        } : void 0;
        return this.formatTooltipWithContext(tooltip, {
            title: labelKey != null ? datum[labelKey] : void 0,
            symbol: symbol,
            data: data
        }, {
            seriesId: seriesId,
            datum: datum,
            title: void 0,
            depth: depth,
            labelKey: labelKey,
            secondaryLabelKey: secondaryLabelKey,
            childrenKey: childrenKey,
            sizeKey: sizeKey,
            sizeName: sizeName,
            colorKey: colorKey,
            colorName: colorName,
            ...format
        });
    }
    computeFocusBounds(node) {
        return $2fb96651e8aa1522$var$Transformable4.toCanvas(this.contentGroup, node.getBBox());
    }
};
$2fb96651e8aa1522$var$TreemapSeries.className = "TreemapSeries";
$2fb96651e8aa1522$var$TreemapSeries.type = "treemap";
var { commonSeriesOptionsDefs: $2fb96651e8aa1522$var$commonSeriesOptionsDefs23, treemapSeriesThemeableOptionsDef: $2fb96651e8aa1522$var$treemapSeriesThemeableOptionsDef, without: $2fb96651e8aa1522$var$without6 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$treemapSeriesOptionsDef = {
    ...$2fb96651e8aa1522$var$treemapSeriesThemeableOptionsDef,
    ...$2fb96651e8aa1522$var$without6($2fb96651e8aa1522$var$commonSeriesOptionsDefs23, [
        "highlightStyle"
    ]),
    type: (0, $idDdm.required)((0, $idDdm.constant)("treemap")),
    labelKey: (0, $idDdm.string),
    secondaryLabelKey: (0, $idDdm.string),
    childrenKey: (0, $idDdm.string),
    sizeKey: (0, $idDdm.string),
    colorKey: (0, $idDdm.string),
    sizeName: (0, $idDdm.string),
    colorName: (0, $idDdm.string)
};
$2fb96651e8aa1522$var$treemapSeriesOptionsDef.fillGradientDefaults = (0, $idDdm.undocumented)((0, $idDdm.fillGradientDefaults));
$2fb96651e8aa1522$var$treemapSeriesOptionsDef.fillPatternDefaults = (0, $idDdm.undocumented)((0, $idDdm.fillPatternDefaults));
$2fb96651e8aa1522$var$treemapSeriesOptionsDef.fillImageDefaults = (0, $idDdm.undocumented)((0, $idDdm.fillImageDefaults));
$2fb96651e8aa1522$var$treemapSeriesOptionsDef.undocumentedGroupFills = (0, $idDdm.undocumented)((0, $idDdm.arrayOf)((0, $idDdm.color)));
$2fb96651e8aa1522$var$treemapSeriesOptionsDef.undocumentedGroupStrokes = (0, $idDdm.undocumented)((0, $idDdm.arrayOf)((0, $idDdm.color)));
// packages/ag-charts-enterprise/src/series/treemap/treemapModule.ts
var { FONT_SIZE_RATIO: $2fb96651e8aa1522$var$FONT_SIZE_RATIO4 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$TreemapModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "hierarchy"
    ],
    identifier: "treemap",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$TreemapSeries(ctx),
    tooltipDefaults: {
        range: "exact"
    },
    solo: true,
    themeTemplate: {
        series: {
            fills: {
                $palette: "fills"
            },
            strokes: {
                $palette: "strokes"
            },
            colorRange: {
                $palette: "divergingColors"
            },
            // @ts-expect-error undocumented option
            fillGradientDefaults: {
                type: "gradient",
                gradient: "linear",
                bounds: "item",
                colorStops: {
                    $palette: "gradient"
                },
                rotation: 0,
                reverse: false
            },
            fillPatternDefaults: (0, $iTJTu._ModuleSupport).FILL_PATTERN_DEFAULTS,
            fillImageDefaults: (0, $iTJTu._ModuleSupport).FILL_IMAGE_DEFAULTS,
            undocumentedGroupFills: {
                $palette: "hierarchyColors"
            },
            undocumentedGroupStrokes: {
                $palette: "secondHierarchyColors"
            },
            group: {
                label: {
                    enabled: true,
                    color: {
                        $ref: "textColor"
                    },
                    fontStyle: void 0,
                    fontWeight: {
                        $ref: "fontWeight"
                    },
                    fontSize: {
                        $ref: "fontSize"
                    },
                    fontFamily: {
                        $ref: "fontFamily"
                    },
                    spacing: 4
                },
                fill: void 0,
                // Override default fill
                stroke: void 0,
                // Override default stroke
                strokeWidth: 1,
                padding: 4,
                gap: 2,
                textAlign: "left"
            },
            tile: {
                label: {
                    enabled: true,
                    color: {
                        $ref: "backgroundColor"
                    },
                    fontStyle: void 0,
                    fontWeight: {
                        $ref: "fontWeight"
                    },
                    fontSize: {
                        $rem: [
                            1.5
                        ]
                    },
                    minimumFontSize: {
                        $rem: [
                            $2fb96651e8aa1522$var$FONT_SIZE_RATIO4.SMALLER
                        ]
                    },
                    fontFamily: {
                        $ref: "fontFamily"
                    },
                    wrapping: "on-space",
                    overflowStrategy: "ellipsis",
                    spacing: 2
                },
                secondaryLabel: {
                    enabled: true,
                    color: {
                        $ref: "backgroundColor"
                    },
                    fontStyle: void 0,
                    fontWeight: void 0,
                    fontSize: {
                        $ref: "fontSize"
                    },
                    minimumFontSize: {
                        $rem: [
                            $2fb96651e8aa1522$var$FONT_SIZE_RATIO4.SMALLER
                        ]
                    },
                    fontFamily: {
                        $ref: "fontFamily"
                    },
                    wrapping: "never",
                    overflowStrategy: "ellipsis"
                },
                fill: void 0,
                // Override default fill
                stroke: void 0,
                // Override default stroke
                strokeWidth: 0,
                padding: 3,
                gap: 1
            },
            // Override defaults
            highlightStyle: {
                group: {
                    label: {
                        color: {
                            $ref: "textColor"
                        }
                    },
                    fill: "rgba(255,255,255, 0.33)",
                    stroke: `rgba(0, 0, 0, 0.4)`,
                    strokeWidth: 2
                },
                tile: {
                    label: {
                        color: {
                            $ref: "backgroundColor"
                        }
                    },
                    secondaryLabel: {
                        color: {
                            $ref: "backgroundColor"
                        }
                    },
                    fill: "rgba(255,255,255, 0.33)",
                    stroke: `rgba(0, 0, 0, 0.4)`,
                    strokeWidth: 2
                }
            }
        },
        gradientLegend: {
            enabled: true
        }
    }
};
var $2fb96651e8aa1522$var$TreemapSeriesModule = {
    type: "series",
    name: "treemap",
    chartType: "hierarchy",
    enterprise: true,
    options: $2fb96651e8aa1522$var$treemapSeriesOptionsDef,
    create: (ctx)=>new $2fb96651e8aa1522$var$TreemapSeries(ctx)
};
// packages/ag-charts-enterprise/src/main-modules.ts
var $2fb96651e8aa1522$var$ModuleRegistry = (0, $iTJTu._ModuleSupport).ModuleRegistry;
var $2fb96651e8aa1522$var$AllCartesianEnterpriseModules = [
    $2fb96651e8aa1522$var$OrdinalTimeAxisModule2,
    $2fb96651e8aa1522$var$BoxPlotSeriesModule,
    $2fb96651e8aa1522$var$CandlestickSeriesModule,
    $2fb96651e8aa1522$var$ConeFunnelSeriesModule,
    $2fb96651e8aa1522$var$FunnelSeriesModule,
    $2fb96651e8aa1522$var$HeatmapSeriesModule,
    $2fb96651e8aa1522$var$OhlcSeriesModule,
    $2fb96651e8aa1522$var$RangeAreaSeriesModule,
    $2fb96651e8aa1522$var$RangeBarSeriesModule,
    $2fb96651e8aa1522$var$WaterfallSeriesModule
];
var $2fb96651e8aa1522$var$AllPolarEnterpriseModules = [
    $2fb96651e8aa1522$var$AngleNumberAxisModule2,
    $2fb96651e8aa1522$var$AngleCategoryAxisModule2,
    $2fb96651e8aa1522$var$RadiusNumberAxisModule2,
    $2fb96651e8aa1522$var$RadiusCategoryAxisModule2,
    $2fb96651e8aa1522$var$NightingaleSeriesModule,
    $2fb96651e8aa1522$var$RadarAreaSeriesModule,
    $2fb96651e8aa1522$var$RadarLineSeriesModule,
    $2fb96651e8aa1522$var$RadialBarSeriesModule,
    $2fb96651e8aa1522$var$RadialColumnSeriesModule
];
var $2fb96651e8aa1522$var$AllFlowProportionEnterpriseModules = [
    $2fb96651e8aa1522$var$FlowProportionChartModule,
    $2fb96651e8aa1522$var$ChordSeriesModule,
    $2fb96651e8aa1522$var$SankeySeriesModule
];
var $2fb96651e8aa1522$var$AllGaugeEnterpriseModules = [
    $2fb96651e8aa1522$var$GaugeChartModule,
    $2fb96651e8aa1522$var$LinearGaugeSeriesModule,
    $2fb96651e8aa1522$var$RadialGaugeSeriesModule
];
var $2fb96651e8aa1522$var$AllHierarchyEnterpriseModules = [
    $2fb96651e8aa1522$var$HierarchyChartModule,
    $2fb96651e8aa1522$var$SunburstSeriesModule,
    $2fb96651e8aa1522$var$TreemapSeriesModule
];
var $2fb96651e8aa1522$var$AllStandaloneEnterpriseModules = [
    $2fb96651e8aa1522$var$StandaloneChartModule,
    $2fb96651e8aa1522$var$PyramidSeriesModule
];
var $2fb96651e8aa1522$var$AllTopologyEnterpriseModules = [
    $2fb96651e8aa1522$var$TopologyChartModule,
    $2fb96651e8aa1522$var$MapLineSeriesModule,
    $2fb96651e8aa1522$var$MapLineBackgroundSeriesModule,
    $2fb96651e8aa1522$var$MapMarkerSeriesModule,
    $2fb96651e8aa1522$var$MapShapeSeriesModule,
    $2fb96651e8aa1522$var$MapShapeBackgroundSeriesModule
];
var $2fb96651e8aa1522$var$AllEnterpriseModules = [
    ...$2fb96651e8aa1522$var$AllCartesianEnterpriseModules,
    ...$2fb96651e8aa1522$var$AllPolarEnterpriseModules,
    ...$2fb96651e8aa1522$var$AllFlowProportionEnterpriseModules,
    ...$2fb96651e8aa1522$var$AllGaugeEnterpriseModules,
    ...$2fb96651e8aa1522$var$AllHierarchyEnterpriseModules,
    ...$2fb96651e8aa1522$var$AllStandaloneEnterpriseModules,
    ...$2fb96651e8aa1522$var$AllTopologyEnterpriseModules,
    // Plugins, WIP
    $2fb96651e8aa1522$var$AnnotationsModule2,
    $2fb96651e8aa1522$var$NavigatorModule2,
    $2fb96651e8aa1522$var$InitialStateModule
];
var $2fb96651e8aa1522$var$indexes = {
    xMin: $2fb96651e8aa1522$var$X_MIN,
    xMax: $2fb96651e8aa1522$var$X_MAX,
    yMin: $2fb96651e8aa1522$var$Y_MIN,
    yMax: $2fb96651e8aa1522$var$Y_MAX,
    span: $2fb96651e8aa1522$var$SPAN
};
var $2fb96651e8aa1522$var$AGGREGATION_THRESHOLD4 = 1e3;
var $2fb96651e8aa1522$var$PRECISION2 = 5;
function $2fb96651e8aa1522$var$getIndices(maxRange, indexData) {
    return Array.from({
        length: maxRange
    }, (_, index)=>{
        const aggIndex = index * $2fb96651e8aa1522$var$SPAN;
        const xMinIndex = indexData[aggIndex + $2fb96651e8aa1522$var$X_MIN];
        const xMaxIndex = indexData[aggIndex + $2fb96651e8aa1522$var$X_MAX];
        return (xMinIndex + xMaxIndex) / 2 | 0;
    });
}
function $2fb96651e8aa1522$var$aggregateBarData(xValues, yValues, domain) {
    if (xValues.length < $2fb96651e8aa1522$var$AGGREGATION_THRESHOLD4) return;
    const [d0, d1] = $2fb96651e8aa1522$var$aggregationDomain(domain);
    let maxRange = $2fb96651e8aa1522$var$maxRangeFittingPoints(xValues, $2fb96651e8aa1522$var$PRECISION2);
    let { indexData: indexData, valueData: valueData } = $2fb96651e8aa1522$var$createAggregationIndices(xValues, yValues, yValues, d0, d1, maxRange);
    let indices = $2fb96651e8aa1522$var$getIndices(maxRange, indexData);
    const filters = [
        {
            maxRange: maxRange,
            indexData: indexData,
            indices: indices,
            indexes: $2fb96651e8aa1522$var$indexes
        }
    ];
    while(maxRange > 64){
        ({ indexData: indexData, valueData: valueData, maxRange: maxRange } = $2fb96651e8aa1522$var$compactAggregationIndices(indexData, valueData, maxRange));
        indices = $2fb96651e8aa1522$var$getIndices(maxRange, indexData);
        filters.push({
            maxRange: maxRange,
            indexData: indexData,
            indices: indices,
            indexes: $2fb96651e8aa1522$var$indexes
        });
    }
    filters.reverse();
    return filters;
}
// packages/ag-charts-enterprise/src/series/bar/barSeries.ts
var { ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection31, ContinuousScale: $2fb96651e8aa1522$var$ContinuousScale10, DiscreteTimeScale: $2fb96651e8aa1522$var$DiscreteTimeScale4 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$BarSeries = class extends (0, $iTJTu._ModuleSupport).BarSeries {
    aggregateData(dataModel, processedData) {
        if (processedData?.type !== "ungrouped") return;
        const xAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection31.X];
        if (xAxis == null || !($2fb96651e8aa1522$var$ContinuousScale10.is(xAxis.scale) || $2fb96651e8aa1522$var$DiscreteTimeScale4.is(xAxis.scale))) return;
        const xValues = dataModel.resolveKeysById(this, `xValue`, processedData);
        const yValues = dataModel.resolveColumnById(this, `yValue-raw`, processedData);
        const { index: index } = dataModel.resolveProcessedDataDefById(this, `xValue`);
        const domain = processedData.domain.keys[index];
        return $2fb96651e8aa1522$var$aggregateBarData(xValues, yValues, domain);
    }
};
// packages/ag-charts-enterprise/src/series/bar/barModule.ts
var { BarSeriesModule: $2fb96651e8aa1522$var$BarSeriesModule } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$BarModule = {
    ...$2fb96651e8aa1522$var$BarSeriesModule,
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    identifier: "bar",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$BarSeries(ctx)
};
var $2fb96651e8aa1522$var$AGGREGATION_THRESHOLD5 = 1e3;
var $2fb96651e8aa1522$var$MAX_POINTS = 10;
function $2fb96651e8aa1522$var$aggregationContainsIndex(xValues, d0, d1, indexData, maxRange, datumIndex) {
    const xValue2 = xValues[datumIndex];
    if (xValue2 == null) return false;
    const xRatio = $2fb96651e8aa1522$var$xRatioForDatumIndex(xValue2, d0, d1);
    const aggIndex = $2fb96651e8aa1522$var$aggregationIndexForXRatio(xRatio, maxRange);
    return datumIndex === indexData[aggIndex + $2fb96651e8aa1522$var$X_MIN] || datumIndex === indexData[aggIndex + $2fb96651e8aa1522$var$X_MAX] || datumIndex === indexData[aggIndex + $2fb96651e8aa1522$var$Y_MIN] || datumIndex === indexData[aggIndex + $2fb96651e8aa1522$var$Y_MAX];
}
function $2fb96651e8aa1522$var$aggregateLineData(xValues, yValues, domain) {
    if (xValues.length < $2fb96651e8aa1522$var$AGGREGATION_THRESHOLD5) return;
    const [d0, d1] = $2fb96651e8aa1522$var$aggregationDomain(domain);
    let maxRange = $2fb96651e8aa1522$var$maxRangeFittingPoints(xValues, $2fb96651e8aa1522$var$MAX_POINTS);
    const { indexData: indexData, valueData: valueData } = $2fb96651e8aa1522$var$createAggregationIndices(xValues, yValues, yValues, d0, d1, maxRange);
    let indices = [];
    for(let datumIndex = 0; datumIndex < xValues.length; datumIndex += 1)if ($2fb96651e8aa1522$var$aggregationContainsIndex(xValues, d0, d1, indexData, maxRange, datumIndex)) indices.push(datumIndex);
    const filters = [
        {
            maxRange: maxRange,
            indices: indices
        }
    ];
    while(indices.length > $2fb96651e8aa1522$var$MAX_POINTS && maxRange > 64){
        ({ maxRange: maxRange } = $2fb96651e8aa1522$var$compactAggregationIndices(indexData, valueData, maxRange, {
            inPlace: true
        }));
        indices = indices.filter($2fb96651e8aa1522$var$aggregationContainsIndex.bind(null, xValues, d0, d1, indexData, maxRange));
        filters.push({
            maxRange: maxRange,
            indices: indices
        });
    }
    filters.reverse();
    return filters;
}
// packages/ag-charts-enterprise/src/series/line/lineSeries.ts
var { ChartAxisDirection: $2fb96651e8aa1522$var$ChartAxisDirection32, ContinuousScale: $2fb96651e8aa1522$var$ContinuousScale11, DiscreteTimeScale: $2fb96651e8aa1522$var$DiscreteTimeScale5 } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$LineSeries = class extends (0, $iTJTu._ModuleSupport).LineSeries {
    aggregateData(dataModel, processedData) {
        const xAxis = this.axes[$2fb96651e8aa1522$var$ChartAxisDirection32.X];
        if (xAxis == null || !($2fb96651e8aa1522$var$ContinuousScale11.is(xAxis.scale) || $2fb96651e8aa1522$var$DiscreteTimeScale5.is(xAxis.scale))) return;
        const xValues = dataModel.resolveColumnById(this, `xValue`, processedData);
        const yValues = dataModel.resolveColumnById(this, `yValueRaw`, processedData);
        const domain = dataModel.getDomain(this, `xValue`, "value", processedData);
        return $2fb96651e8aa1522$var$aggregateLineData(xValues, yValues, domain);
    }
};
// packages/ag-charts-enterprise/src/series/line/lineModule.ts
var { LineSeriesModule: $2fb96651e8aa1522$var$LineSeriesModule } = (0, $iTJTu._ModuleSupport);
var $2fb96651e8aa1522$var$LineModule = {
    ...$2fb96651e8aa1522$var$LineSeriesModule,
    type: "series",
    optionsKey: "series[]",
    packageType: "enterprise",
    chartTypes: [
        "cartesian"
    ],
    identifier: "line",
    moduleFactory: (ctx)=>new $2fb96651e8aa1522$var$LineSeries(ctx)
};
// packages/ag-charts-enterprise/src/styles.css
var $2fb96651e8aa1522$var$styles_default = `.ag-watermark{position:absolute;bottom:20px;right:25px;font-weight:700;font-family:Impact,sans-serif;font-size:19px;opacity:.7;animation:1s ease-out 3s ag-watermark-fadeout;color:#9b9b9b;pointer-events:none;&:before{content:"";display:block;height:40px;width:170px;background-image:url(data:image/svg+xml;base64,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);background-repeat:no-repeat;background-size:170px 40px}>span{padding-left:.7rem}}@keyframes ag-watermark-fadeout{0%{opacity:.5}to{opacity:0}}.ag-charts-dialog{display:flex;flex-direction:column;font-size:var(--ag-charts-chrome-font-size-large)}.ag-charts-dialog__tabs{display:flex;flex-direction:column}.ag-charts-dialog__header{border-bottom:1px solid var(--ag-charts-border-color);display:flex}.ag-charts-dialog__tab-list{display:flex;gap:calc(var(--ag-charts-spacing) * 2)}.ag-charts-dialog__drag-handle{align-items:center;color:inherit;cursor:grab;display:flex;padding:1px 6px;text-align:center}.ag-charts-dialog__drag-handle--dragging{cursor:grabbing}.ag-charts-dialog__tab-button{background:none;border:0;border-bottom:2px solid transparent;border-radius:0;color:var(--ag-charts-chrome-subtle-text-color);margin-bottom:-1px;padding:var(--input-padding) calc(var(--input-padding) / 2)}.ag-charts-dialog__tab-button:hover{background:none}.ag-charts-dialog__tab-button--active{border-color:var(--ag-charts-accent-color);color:inherit}.ag-charts-dialog__drag-handle+.ag-charts-dialog__tab-button{margin-left:calc(var(--ag-charts-spacing) * -2)}.ag-charts-button.ag-charts-dialog__close-button{background:none;border:0;margin-left:auto;padding:1px 6px}.ag-charts-dialog__close-button:focus-visible{outline:var(--ag-charts-focus-border);box-shadow:var(--ag-charts-focus-border-shadow);z-index:calc(var(--ag-charts-layer-ui-overlay) + 1)}.ag-charts-dialog__tab-panel{display:none;flex-direction:column;gap:calc(var(--ag-charts-spacing) * 4);margin:0 calc(var(--ag-charts-spacing) * 4);padding:calc(var(--ag-charts-spacing) * 4) 0}.ag-charts-dialog__tab-panel--active{display:flex}.ag-charts-dialog__input-group-line{display:flex;gap:16px 18px;flex-wrap:wrap}.ag-charts-dialog__input-group{align-items:center;display:flex;font-size:var(--ag-charts-chrome-font-size)}.ag-charts-dialog__input-group-label{color:var(--ag-charts-chrome-subtle-text-color);margin-right:5px}.ag-charts-dialog__input-group-label[for]{cursor:pointer}.ag-charts-dialog__button{border-radius:0;margin-right:-1px}.ag-charts-dialog__button.ag-charts-dialog__button--active{background:var(--ag-charts-button-focus-background-color);border-color:var(--ag-charts-input-focus-border-color);color:var(--ag-charts-input-focus-text-color);z-index:var(--input-layer-active)}.ag-charts-dialog__button:first-child,.ag-charts-dialog__input-group-label+.ag-charts-dialog__button{border-bottom-left-radius:var(--ag-charts-input-border-radius);border-top-left-radius:var(--ag-charts-input-border-radius)}.ag-charts-dialog__button:last-child{border-bottom-right-radius:var(--ag-charts-input-border-radius);border-top-right-radius:var(--ag-charts-input-border-radius)}.ag-charts-dialog__color-picker-button{--color: #000;background:var(--color);border:none;color:transparent;height:26px;width:26px}.ag-charts-dialog__color-picker-button:hover{background:var(--color)}.ag-charts-dialog__color-picker-button--multi-color,.ag-charts-dialog__color-picker-button--multi-color:hover{background:linear-gradient(135deg,red 0%,#ff0 calc(100% * 1 / 6),#0f0 calc(100% * 2 / 6),#0ff 50%,#00f calc(100% * 4 / 6),#f0f calc(100% * 5 / 6),red 100%)}.ag-charts-color-picker{width:190px;padding:8px;--h: 0;--s: 0;--v: 0;--a: 0;--color: #000;--color-a: #000;--thumb-size: 18px;--inner-width: 172px;--track-height: 12px;--palette-height: 136px;--checker: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="4" height="4"><rect x="0" y="0" width="4" height="4" fill="%23fff"/><path d="M0 0H2V4H4V2H0Z" fill="%23b2b2b2"/></svg>');--multi-color: linear-gradient( 135deg, #f00 0% , #ff0 calc(100% * 1 / 6), #0f0 calc(100% * 2 / 6), #0ff 50% , #00f calc(100% * 4 / 6), #f0f calc(100% * 5 / 6), #f00 100% )}.ag-charts-color-picker__content{display:flex;flex-direction:column}.ag-charts-color-picker__palette{position:relative;width:100%;height:var(--palette-height);margin-bottom:8px;background:linear-gradient(to bottom,#0000,#000),linear-gradient(to right,#fff,#fff0) hsl(var(--h),100%,50%);border-radius:calc(var(--ag-charts-border-radius) * 1.5);box-shadow:inset 0 0 0 1px #0003}.ag-charts-color-picker__palette:after{content:"";position:absolute;display:block;top:calc(var(--thumb-size) * -.5 + (1 - var(--v)) * 100%);left:calc(var(--thumb-size) * -.5 + var(--s) * 100%);background:var(--color);width:var(--thumb-size);height:var(--thumb-size);border-radius:calc(var(--ag-charts-border-radius) * 99);box-shadow:var(--box-shadow);--box-shadow: inset 0 0 0 3px white, inset 0 0 1px 3px #0006, 0 0 5px #00000038}.ag-charts-color-picker__palette:focus-visible:after{outline:var(--ag-charts-focus-border);box-shadow:var(--box-shadow),0 0 0 2px #fff8,var(--ag-charts-focus-border-shadow)}.ag-charts-color-picker__color-row{display:flex;gap:8px;align-items:center;margin-bottom:4px;--inset: calc((var(--thumb-size) - var(--track-height)) / 2)}.ag-charts-color-picker__hue-input,.ag-charts-color-picker__alpha-input{-webkit-appearance:none;display:block;position:relative;padding:0;margin:0 calc(var(--inset) * -1);border:0;height:var(--thumb-size);width:auto;background:transparent;--inset: calc((var(--thumb-size) - var(--track-height)) / 2)}.ag-charts-color-picker__hue-input::-webkit-slider-thumb,.ag-charts-color-picker__alpha-input::-webkit-slider-thumb{-webkit-appearance:none;width:var(--thumb-size);height:var(--thumb-size);border-radius:calc(var(--ag-charts-border-radius) * 99);box-shadow:var(--box-shadow);--box-shadow: inset 0 0 0 3px white, inset 0 0 1px 3px #0006, 0 0 5px #00000038;transform:translateZ(0)}.ag-charts-color-picker__hue-input::-webkit-slider-thumb{background:hsl(var(--h),100%,50%)}.ag-charts-color-picker__alpha-input::-webkit-slider-thumb{background:transparent}.ag-charts-color-picker__alpha-input--opaque::-webkit-slider-thumb{background:var(--color)}.ag-charts-color-picker__hue-input:focus-visible::-webkit-slider-thumb,.ag-charts-color-picker__alpha-input:focus-visible::-webkit-slider-thumb{outline:var(--ag-charts-focus-border);box-shadow:var(--box-shadow),var(--ag-charts-focus-border-shadow)}.ag-charts-color-picker__hue-input:before,.ag-charts-color-picker__alpha-input:before{position:absolute;content:"";display:block;top:calc(50% - var(--track-height) / 2);left:var(--inset);right:var(--inset);height:var(--track-height);border-radius:calc(var(--ag-charts-border-radius) * 99);box-shadow:inset 0 0 0 1px #0003}.ag-charts-color-picker__multi-color-button{width:36px;margin-left:var(--inset);height:var(--track-height);border-radius:calc(var(--ag-charts-border-radius) * 99);border:0;background:var(--multi-color);box-shadow:inset 0 0 0 1px #0003}.ag-charts-color-picker__multi-color-button--hidden{display:none}.ag-charts-color-picker__multi-color-button--active{box-shadow:inset 0 0 0 1px #0003;outline-offset:1px;outline:2px solid #2196f3}.ag-charts-color-picker__hue-input{flex:1 0 0}.ag-charts-color-picker__hue-input:before{background:linear-gradient(to right,red,red calc((100% - var(--track-height)) * 0 / 6 + var(--track-height) / 2),#ff0 calc((100% - var(--track-height)) * 1 / 6 + var(--track-height) / 2),#0f0 calc((100% - var(--track-height)) * 2 / 6 + var(--track-height) / 2),#0ff calc((100% - var(--track-height)) * 3 / 6 + var(--track-height) / 2),#00f calc((100% - var(--track-height)) * 4 / 6 + var(--track-height) / 2),#f0f calc((100% - var(--track-height)) * 5 / 6 + var(--track-height) / 2),red calc((100% - var(--track-height)) * 6 / 6 + var(--track-height) / 2))}.ag-charts-color-picker__alpha-input{margin-bottom:7px}.ag-charts-color-picker__alpha-input:before{background:linear-gradient(to right,transparent,var(--color)),var(--checker) top left / 4px 4px}.ag-charts-color-picker__color-field{display:flex;border:var(--ag-charts-border);background:var(--ag-charts-background-color);border-radius:var(--ag-charts-border-radius);overflow:hidden}.ag-charts-color-picker__color-field:has(:focus-visible){border-color:var(--ag-charts-accent-color);box-shadow:var(--ag-charts-focus-border-shadow)}.ag-charts-color-picker__color-label{width:16px;height:16px;margin:7px 0 7px 7px;color:transparent;background:linear-gradient(to right,var(--color-a),var(--color-a)),var(--checker) top left / 4px 4px;border-radius:calc(var(--ag-charts-border-radius) / 2);box-shadow:inset 0 0 0 1px #0003}.ag-charts-color-picker__color-label--multi-color{background:var(--multi-color)}.ag-charts-color-picker__color-input{flex:1;min-width:0;padding:7px 7px 7px 8px;border:0;margin:0;color:inherit;background:transparent;font-variant:tabular-nums}.ag-charts-color-picker__color-input:focus-visible{border:none;outline:none}.ag-charts-annotations__line-stroke-width-menu,.ag-charts-annotations__line-style-type-menu,.ag-charts-annotations__text-size-menu{border-top-left-radius:0;border-top-right-radius:0;.ag-charts-menu__row:first-child{border-radius:0}}.ag-charts-annotations__text-size-menu{--item-padding: 4px 8px;min-width:34px;text-align:center}.ag-charts-annotations__line-stroke-width-menu{--item-padding: 6px;column-gap:6px}.ag-charts-annotations__line-style-type-menu{--item-padding: 6px;column-gap:0}.ag-charts-annotations__stroke-width-button:before{background:var(--ag-charts-foreground-color);content:"";margin-right:var(--toolbar-button-padding);height:min(var(--stroke-width),20px);width:12px}.ag-charts-annotations__stroke-width-button[aria-disabled=true]:before{filter:grayscale(1);opacity:.5}.ag-charts-annotations__color-picker-button{--emblem: var(--color)}.ag-charts-annotations__color-picker-button--multi-color{--emblem: linear-gradient( to right, #f00 0% , #ff0 calc(100% * 1 / 6), #0f0 calc(100% * 2 / 6), #0ff 50% , #00f calc(100% * 4 / 6), #f0f calc(100% * 5 / 6), #f00 100% )}.ag-charts-annotations__color-picker-button:after{content:"";display:block;position:absolute;bottom:3px;left:5px;right:5px;height:4px;border-radius:99px;box-shadow:inset 0 0 0 1px color-mix(in srgb,var(--ag-charts-foreground-color) 10%,transparent);background:var(--emblem)}.ag-charts-annotations__color-picker-button[aria-disabled=true]:after{filter:grayscale(1);opacity:.5}.ag-charts-annotations__toolbar-menu{min-width:200px}.ag-charts-annotations__axis-button--hidden{display:none}.ag-charts-annotations__axis-button{background-color:var(--ag-charts-crosshair-label-background-color);border-radius:calc(var(--ag-charts-border-radius) / 2);border:none;box-sizing:border-box;color:var(--ag-charts-crosshair-label-text-color);cursor:pointer;font-family:var(--ag-charts-chrome-font-family);font-size:var(--ag-charts-chrome-font-size);font-weight:var(--ag-charts-chrome-font-weight);left:0;line-height:16px;overflow:hidden;padding:0;position:absolute;top:0;user-select:none;white-space:nowrap;z-index:var(--ag-charts-layer-annotations)}.ag-charts-annotations__axis-button:hover{opacity:.8;color:var(--ag-charts-background-color)}.ag-charts-dialog--annotation-settings{min-height:233px;width:289px}.ag-charts-dialog--annotation-settings .ag-charts-textarea{height:calc(10px * 2 + var(--textarea-line-height) * 1em * 3 + 2px);overflow-y:auto;resize:vertical}.ag-charts-context-menu{font-family:var(--ag-charts-chrome-font-family);font-size:calc(var(--ag-charts-chrome-font-size) * (13 / 12));font-weight:var(--ag-charts-chrome-font-weight);z-index:var(--ag-charts-layer-ui-overlay)}.ag-charts-context-menu__cover{position:fixed;left:0;top:0}.ag-charts-context-menu__menu{background:var(--ag-charts-chrome-background-color);border-radius:var(--ag-charts-border-radius);border:var(--ag-charts-border);box-shadow:var(--ag-charts-shadow);color:var(--ag-charts-chrome-text-color);display:table;flex-direction:column;padding:.5em 0;transition:transform .1s ease;white-space:nowrap}.ag-charts-context-menu__menu:focus{outline:none}.ag-charts-context-menu__item{align-items:center;background:none;border:none;box-sizing:border-box;color:inherit;display:table-row;font:inherit;justify-content:space-between;text-align:left;width:100%;-webkit-appearance:none;-moz-appearance:none}.ag-charts-context-menu__icon>img{width:var(--ag-charts-icon-size);height:var(--ag-charts-icon-size)}.ag-charts-context-menu__icon,.ag-charts-context-menu__label,.ag-charts-context-menu__rightarrowhead{display:table-cell;vertical-align:middle}.ag-charts-context-menu__cellpadding{padding:.5em 1em}.ag-charts-context-menu__icon{padding-right:0}.ag-charts-context-menu__item[data-focus-override=true],.ag-charts-context-menu__item:focus,.ag-charts-context-menu__item:active{background:var(--ag-charts-focus-color)}.ag-charts-context-menu__item[data-focus-visible-override=true]:focus,.ag-charts-context-menu__item:focus-visible{outline:var(--ag-charts-focus-border);box-shadow:var(--ag-charts-focus-border-shadow);z-index:calc(var(--ag-charts-layer-ui-overlay) + 1)}.ag-charts-context-menu__item[data-focus-visible-override=false]{outline:inherit;box-shadow:inherit;z-index:inherit}.ag-charts-context-menu__item[aria-disabled=true]{border:none;color:color-mix(in srgb,var(--ag-charts-input-text-color) 50%,transparent);text-align:left}.ag-charts-context-menu__item[aria-disabled=true]:focus{background:inherit;cursor:inherit}.ag-charts-context-menu__divider{display:table-row}.ag-charts-context-menu__divider>div{padding:5px 0}.ag-charts-context-menu__divider>div:after{content:"";display:block;border-top:1px solid #babfc7}.ag-charts-context-menu__divider.ag-charts-dark-context-menu{background:#2196f31a}.ag-charts-crosshair-label{position:absolute;left:0;top:0;user-select:none;pointer-events:none;font-family:var(--ag-charts-font-family);font-size:var(--ag-charts-font-size);font-weight:var(--ag-charts-font-weight);overflow:hidden;white-space:nowrap;z-index:var(--ag-charts-layer-crosshair);box-sizing:border-box}.ag-charts-crosshair-label-content{padding:0 8px;border-radius:calc(var(--ag-charts-border-radius) / 2);line-height:calc(var(--ag-charts-font-size) + 8px);background-color:var(--ag-charts-crosshair-label-background-color);color:var(--ag-charts-crosshair-label-text-color)}.ag-charts-crosshair-label--hidden{visibility:hidden!important}.ag-charts-text-input{position:absolute}.ag-charts-text-input__textarea{--placeholder-text-color: var(--ag-charts-input-placeholder-text-color);display:block;height:100%;width:100%;border:0;background:none;line-height:1.38;outline:none;transform:translateY(.09em)}.ag-charts-text-input__textarea[placeholder]:empty:before{content:attr(placeholder);color:var(--placeholder-text-color);font-weight:400}.ag-charts-text-input__textarea[placeholder]:not(:empty):before{content:""}.ag-charts-chart-toolbar__menu{min-width:200px}.ag-charts-range-buttons .ag-charts-toolbar__button{padding:var(--toolbar-button-padding) calc(var(--toolbar-button-padding) * 1.5)}.ag-charts-zoom-buttons{align-items:center;display:flex;height:44px;justify-content:center;overflow:hidden;padding-bottom:10px;pointer-events:none;width:100%;.ag-charts-toolbar{--toolbar-size: 24px;--toolbar-button-padding: 1px;display:flex;font-size:var(--ag-charts-chrome-font-size);height:var(--toolbar-size);justify-content:center;opacity:1;pointer-events:auto;transition:opacity .2s ease-in-out,transform .4s ease-in-out;.ag-charts-toolbar__button--first{border-bottom-left-radius:var(--ag-charts-border-radius);border-top-left-radius:var(--ag-charts-border-radius)}.ag-charts-toolbar__button--last{border-bottom-right-radius:var(--ag-charts-border-radius);border-top-right-radius:var(--ag-charts-border-radius)}.ag-charts-toolbar__label{padding-left:var(--ag-charts-spacing);padding-right:var(--ag-charts-spacing)}.ag-charts-toolbar__icon+.ag-charts-toolbar__label{padding-left:0}.ag-charts-toolbar__button--gap{margin-left:var(--toolbar-gap)}&.ag-charts-zoom-buttons__toolbar--hidden{opacity:0;transition:opacity .4s ease-in-out,transform .4s ease-in-out}}}.ag-charts-shared-toolbar{gap:var(--toolbar-gap);.ag-charts-toolbar__button{border-radius:var(--ag-charts-border-radius);margin:0}}
`;
// packages/ag-charts-enterprise/src/setup.ts
(0, $iTJTu._ModuleSupport).ModuleRegistry.registerMany($2fb96651e8aa1522$var$AllEnterpriseModules);
function $2fb96651e8aa1522$var$setupEnterpriseModules() {
    (0, $iTJTu._ModuleSupport).moduleRegistry.register($2fb96651e8aa1522$var$AngleCategoryAxisModule, $2fb96651e8aa1522$var$AngleNumberAxisModule, $2fb96651e8aa1522$var$AnimationModule, $2fb96651e8aa1522$var$AnnotationsModule, $2fb96651e8aa1522$var$BackgroundModule, $2fb96651e8aa1522$var$BarModule, $2fb96651e8aa1522$var$ForegroundModule, $2fb96651e8aa1522$var$BoxPlotModule, $2fb96651e8aa1522$var$CandlestickModule, $2fb96651e8aa1522$var$ChordModule, $2fb96651e8aa1522$var$ConeFunnelModule, $2fb96651e8aa1522$var$FunnelModule, $2fb96651e8aa1522$var$OhlcModule, $2fb96651e8aa1522$var$ChartToolbarModule, $2fb96651e8aa1522$var$ContextMenuModule, $2fb96651e8aa1522$var$CrosshairModule, $2fb96651e8aa1522$var$DataSourceModule, $2fb96651e8aa1522$var$ErrorBarsModule, $2fb96651e8aa1522$var$LinearGaugeModule, $2fb96651e8aa1522$var$LineModule, $2fb96651e8aa1522$var$MapLineModule, $2fb96651e8aa1522$var$MapLineBackgroundModule, $2fb96651e8aa1522$var$MapMarkerModule, $2fb96651e8aa1522$var$MapShapeModule, $2fb96651e8aa1522$var$MapShapeBackgroundModule, $2fb96651e8aa1522$var$NavigatorModule, $2fb96651e8aa1522$var$StatusBarModule, $2fb96651e8aa1522$var$GradientLegendModule, $2fb96651e8aa1522$var$HeatmapModule, $2fb96651e8aa1522$var$NightingaleModule, $2fb96651e8aa1522$var$OrdinalTimeAxisModule, $2fb96651e8aa1522$var$RadarAreaModule, $2fb96651e8aa1522$var$RadarLineModule, $2fb96651e8aa1522$var$RadialBarModule, $2fb96651e8aa1522$var$RadialColumnModule, $2fb96651e8aa1522$var$RadiusCategoryAxisModule, $2fb96651e8aa1522$var$RadialGaugeModule, $2fb96651e8aa1522$var$RadiusNumberAxisModule, $2fb96651e8aa1522$var$RangeBarModule, $2fb96651e8aa1522$var$RangeAreaModule, $2fb96651e8aa1522$var$RangesModule, $2fb96651e8aa1522$var$PyramidModule, $2fb96651e8aa1522$var$SankeyModule, $2fb96651e8aa1522$var$SharedToolbarModule, $2fb96651e8aa1522$var$SunburstModule, $2fb96651e8aa1522$var$SyncModule, $2fb96651e8aa1522$var$TreemapModule, $2fb96651e8aa1522$var$WaterfallModule, $2fb96651e8aa1522$var$ZoomModule);
    (0, $iTJTu._ModuleSupport).enterpriseModule.isEnterprise = true;
    (0, $iTJTu._ModuleSupport).enterpriseModule.styles = $2fb96651e8aa1522$var$styles_default;
    (0, $iTJTu._ModuleSupport).enterpriseModule.licenseManager = (options)=>new $2fb96651e8aa1522$var$LicenseManager(options.container?.ownerDocument ?? (typeof document === "undefined" ? void 0 : document));
    (0, $iTJTu._ModuleSupport).enterpriseModule.injectWatermark = $2fb96651e8aa1522$var$injectWatermark;
}
$2fb96651e8aa1522$var$setupEnterpriseModules();
var $2fb96651e8aa1522$export$91e2bbffdbb3852c = {
    setLicenseKey (key) {
        $2fb96651e8aa1522$var$LicenseManager.setLicenseKey(key);
    }
};
function $2fb96651e8aa1522$export$e26408c5f6041ed0() {
    $2fb96651e8aa1522$var$setupEnterpriseModules();
    (0, $iTJTu.setupCommunityModules)();
}
var $2fb96651e8aa1522$export$c258aefd13f96e85 = {
    VERSION: $iTJTu.VERSION,
    _Scene: $iTJTu._Scene,
    _Theme: $iTJTu._Theme,
    _Util: $iTJTu._Util,
    create: (0, $iTJTu.AgCharts).create.bind((0, $iTJTu.AgCharts)),
    createSparkline: (0, $iTJTu.AgCharts).__createSparkline.bind((0, $iTJTu.AgCharts)),
    setup: $2fb96651e8aa1522$export$e26408c5f6041ed0,
    setGridContext: $2fb96651e8aa1522$var$LicenseManager.setGridContext.bind($2fb96651e8aa1522$var$LicenseManager),
    setLicenseKey: $2fb96651e8aa1522$var$LicenseManager.setLicenseKey.bind($2fb96651e8aa1522$var$LicenseManager),
    isEnterprise: true
};

});



parcelRegister("cXDYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $96fa020988d12076$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $96fa020988d12076$var$ChevronRightIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m8.25 4.5 7.5 7.5-7.5 7.5"
    }));
}
const $96fa020988d12076$var$ForwardRef = $acw62.forwardRef($96fa020988d12076$var$ChevronRightIcon);
var $96fa020988d12076$export$2e2bcd8739ae039 = $96fa020988d12076$var$ForwardRef;

});

parcelRegister("iIDkB", function(module, exports) {

$parcel$export(module.exports, "default", () => $da0ad86e94a738d5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $da0ad86e94a738d5$var$ChevronLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.75 19.5 8.25 12l7.5-7.5"
    }));
}
const $da0ad86e94a738d5$var$ForwardRef = $acw62.forwardRef($da0ad86e94a738d5$var$ChevronLeftIcon);
var $da0ad86e94a738d5$export$2e2bcd8739ae039 = $da0ad86e94a738d5$var$ForwardRef;

});

parcelRegister("cMZ0q", function(module, exports) {

$parcel$export(module.exports, "useCompany", () => $4ad22ca2cfb4db8f$export$d762bc24addc096a);
parcelRequire("tL0U5");
var $7Y7Q4 = parcelRequire("7Y7Q4");
parcelRequire("agk6G");
var $kTlwO = parcelRequire("kTlwO");
parcelRequire("ct56T");
var $edg5W = parcelRequire("edg5W");

var $acw62 = parcelRequire("acw62");

var $9KsqC = parcelRequire("9KsqC");
function $4ad22ca2cfb4db8f$export$d762bc24addc096a() {
    const session = (0, $edg5W.useSession)();
    const company = (0, $7Y7Q4.useApiQuery)((0, $kTlwO.getCompany), {
        enabled: !!session.user?.organizationId
    });
    const isInitialLoading = (0, $acw62.useMemo)(()=>!session.user && session.isLoading || !company?.data && company.isLoading, [
        session.user?.id,
        session.isLoading,
        company.isLoading
    ]);
    const onboarding = (0, $acw62.useMemo)(()=>{
        if (!session.user) return undefined;
        return (0, $9KsqC.getOnboardingState)(session.user, company.data);
    }, [
        company.data?.id,
        session.user?.id
    ]);
    return {
        isInitialLoading: isInitialLoading,
        isLoading: company.isLoading,
        company: company.data,
        onboarding: onboarding
    };
}

});
parcelRegister("9KsqC", function(module, exports) {

$parcel$export(module.exports, "getOnboardingState", () => $61441cc0bb06c6fe$export$acd1e7e49775054c);

var $bWdQ9 = parcelRequire("bWdQ9");
parcelRequire("agk6G");
var $iIyrH = parcelRequire("iIyrH");
function $61441cc0bb06c6fe$export$acd1e7e49775054c(user, company) {
    const status = (0, $bWdQ9.getOnboardingStatus)(user, company);
    const state = {
        status: status,
        emailVerified: status > (0, $iIyrH.OnboardingStatus).VERIFY_EMAIL,
        basicInfoComplete: status > (0, $iIyrH.OnboardingStatus).BASIC_INFO,
        aboutYourBusinessComplete: status > (0, $iIyrH.OnboardingStatus).ABOUT_YOUR_BUSINESS,
        unsupportedCountry: status === (0, $iIyrH.OnboardingStatus).UNSUPPORTED_COUNTRY,
        shareYourGoalsComplete: status > (0, $iIyrH.OnboardingStatus).SHARE_YOUR_GOALS,
        fundraisingHistoryComplete: status > (0, $iIyrH.OnboardingStatus).FUNDRAISING_HISTORY,
        MNDASigned: status > (0, $iIyrH.OnboardingStatus).MNDA,
        dataRoomComplete: status > (0, $iIyrH.OnboardingStatus).DATAROOM,
        isComplete: status === (0, $iIyrH.OnboardingStatus).COMPLETE
    };
    return {
        ...state,
        profileComplete: state.emailVerified && state.basicInfoComplete && state.aboutYourBusinessComplete && state.shareYourGoalsComplete && state.fundraisingHistoryComplete,
        userId: user.id,
        organizationId: user.organizationId
    };
}

});
parcelRegister("bWdQ9", function(module, exports) {

$parcel$export(module.exports, "getOnboardingStatus", () => $30c1843eb8103ff5$export$376a941b4307217d);

var $iIyrH = parcelRequire("iIyrH");
parcelRequire("dRO48");
var $eUiRa = parcelRequire("eUiRa");
const $30c1843eb8103ff5$export$376a941b4307217d = (user, company)=>{
    if (!user || !user.emailVerified) return (0, $iIyrH.OnboardingStatus).VERIFY_EMAIL;
    if (!user.organizationId) return (0, $iIyrH.OnboardingStatus).BASIC_INFO;
    if (!company) return (0, $iIyrH.OnboardingStatus).ABOUT_YOUR_BUSINESS;
    const { signupStatus: signupStatus } = company;
    const hasBusinessInfo = signupStatus.hasBasicBusinessInfo;
    if (!hasBusinessInfo) return (0, $iIyrH.OnboardingStatus).ABOUT_YOUR_BUSINESS;
    else if (company.country && (0, $eUiRa.SENSITIVE_COUNTRIES).includes(company.country)) return (0, $iIyrH.OnboardingStatus).UNSUPPORTED_COUNTRY;
    const hasFundraisingGoals = signupStatus.hasFundraisingGoals;
    if (!hasFundraisingGoals) return (0, $iIyrH.OnboardingStatus).SHARE_YOUR_GOALS;
    const hasFundraisingHistory = signupStatus.hasFundraisingHistory;
    if (!hasFundraisingHistory) return (0, $iIyrH.OnboardingStatus).FUNDRAISING_HISTORY;
    if (!company.acceptedNda) return (0, $iIyrH.OnboardingStatus).MNDA;
    const data = company.activationStatus;
    const missingFiles = data.missingFileTypesInDataroom || [];
    const isIncomeAndBalanceMissing = missingFiles.includes((0, $iIyrH.CompanyFileDocumentType).IncomeStatement) && missingFiles.includes((0, $iIyrH.CompanyFileDocumentType).BalanceSheet);
    if (!(data.hasCompanyConfiguredConnector || data.hasCompanyConfiguredDataRoom || !isIncomeAndBalanceMissing) && signupStatus.complete) return (0, $iIyrH.OnboardingStatus).DATAROOM;
    return (0, $iIyrH.OnboardingStatus).COMPLETE;
};

});



parcelRegister("eQbhf", function(module, exports) {

$parcel$export(module.exports, "AccountLabel", () => $ca0d855e0527534d$export$54155dd2ffa34804);
$parcel$export(module.exports, "PeriodKind", () => $ca0d855e0527534d$export$464989a30bad0982);
$parcel$export(module.exports, "ACCOUNT_TAXONOMY", () => $ca0d855e0527534d$export$cf38e2d084787788);

var $c44Qc = parcelRequire("c44Qc");
var $ca0d855e0527534d$export$54155dd2ffa34804;
(function(AccountLabel) {
    AccountLabel["CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS"] = "current_assets.cash_and_cash_equivalents";
    AccountLabel["CURRENT_ASSETS_DEFERRED_EXPENSES"] = "current_assets.deferred_expenses";
    AccountLabel["CURRENT_ASSETS_DERIVATIVES_AND_HEDGES"] = "current_assets.derivatives_and_hedges";
    AccountLabel["CURRENT_ASSETS_NET_CONTRACTS_WITH_CUSTOMERS"] = "current_assets.net_contracts_with_customers";
    AccountLabel["CURRENT_ASSETS_NET_INVENTORY"] = "current_assets.net_inventory";
    AccountLabel["CURRENT_ASSETS_NET_RECEIVABLES"] = "current_assets.net_receivables";
    AccountLabel["CURRENT_ASSETS_OTHER_CURRENT_ASSETS"] = "current_assets.other_current_assets";
    AccountLabel["CURRENT_ASSETS_PREPAID_EXPENSES"] = "current_assets.prepaid_expenses";
    AccountLabel["NONCURRENT_ASSETS_DEFERRED_EXPENSES"] = "noncurrent_assets.deferred_expenses";
    AccountLabel["NONCURRENT_ASSETS_DERIVATIVES_AND_HEDGES"] = "noncurrent_assets.derivatives_and_hedges";
    AccountLabel["NONCURRENT_ASSETS_INVENTORY"] = "noncurrent_assets.inventory";
    AccountLabel["NONCURRENT_ASSETS_LONGTERM_INVESTMENTS_AND_RECEIVABLES"] = "noncurrent_assets.longterm_investments_and_receivables";
    AccountLabel["NONCURRENT_ASSETS_NET_CONTRACTS_WITH_CUSTOMERS"] = "noncurrent_assets.net_contracts_with_customers";
    AccountLabel["NONCURRENT_ASSETS_NET_INTANGIBLE_ASSETS_AND_GOODWILL"] = "noncurrent_assets.net_intangible_assets_and_goodwill";
    AccountLabel["NONCURRENT_ASSETS_OTHER_ASSETS"] = "noncurrent_assets.other_assets";
    AccountLabel["NONCURRENT_ASSETS_PREPAID_EXPENSES"] = "noncurrent_assets.prepaid_expenses";
    AccountLabel["NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT"] = "noncurrent_assets.property_plant_and_equipment";
    AccountLabel["NONCURRENT_ASSETS_RESTRICTED_CASH_AND_CASH_EQUIVALENTS"] = "noncurrent_assets.restricted_cash_and_cash_equivalents";
    AccountLabel["CURRENT_LIABILITIES_ACCOUNTS_PAYABLE"] = "current_liabilities.accounts_payable";
    AccountLabel["CURRENT_LIABILITIES_DEBT"] = "current_liabilities.debt";
    AccountLabel["CURRENT_LIABILITIES_DEFERRED_REVENUE"] = "current_liabilities.deferred_revenue";
    AccountLabel["CURRENT_LIABILITIES_DERIVATIVES_AND_HEDGES"] = "current_liabilities.derivatives_and_hedges";
    AccountLabel["CURRENT_LIABILITIES_OTHER_LIABILITIES"] = "current_liabilities.other_liabilities";
    AccountLabel["CURRENT_LIABILITIES_PROVISION_AND_ACCRUALS"] = "current_liabilities.provision_and_accruals";
    AccountLabel["CURRENT_LIABILITIES_PROVISION_FOR_LOSSES_ON_CONTRACTS"] = "current_liabilities.provision_for_losses_on_contracts";
    AccountLabel["CURRENT_LIABILITIES_PROVISION_FOR_REFUNDS"] = "current_liabilities.provision_for_refunds";
    AccountLabel["NONCURRENT_LIABILITIES_ACCOUNTS_PAYABLE"] = "noncurrent_liabilities.accounts_payable";
    AccountLabel["NONCURRENT_LIABILITIES_DEFERRED_REVENUE"] = "noncurrent_liabilities.deferred_revenue";
    AccountLabel["NONCURRENT_LIABILITIES_DERIVATIVES_HEDGES"] = "noncurrent_liabilities.derivatives_hedges";
    AccountLabel["NONCURRENT_LIABILITIES_LONGTERM_DEBT"] = "noncurrent_liabilities.longterm_debt";
    AccountLabel["NONCURRENT_LIABILITIES_OTHER_LIABILITIES"] = "noncurrent_liabilities.other_liabilities";
    AccountLabel["NONCURRENT_LIABILITIES_PROVISION_AND_ACCRUALS"] = "noncurrent_liabilities.provision_and_accruals";
    AccountLabel["NONCURRENT_LIABILITIES_PROVISION_FOR_LOSSES_ON_CONTRACTS"] = "noncurrent_liabilities.provision_for_losses_on_contracts";
    AccountLabel["NONCURRENT_LIABILITIES_PROVISION_FOR_REFUNDS"] = "noncurrent_liabilities.provision_for_refunds";
    AccountLabel["EQUITY_PAID_IN_CAPITAL"] = "equity.paid_in_capital";
    AccountLabel["EQUITY_RETAINED_EARNINGS"] = "equity.retained_earnings";
    AccountLabel["REVENUES_COHORT"] = "revenues.cohort";
    AccountLabel["REVENUES_NON_COHORT"] = "revenues.non_cohort";
    AccountLabel["REVENUES_NON_COHORT_SEPARATE_COGS"] = "revenues.non_cohort_separate_cogs";
    AccountLabel["REVENUES_NON_COHORT_NO_COGS"] = "revenues.non_cohort_no_cogs";
    AccountLabel["REVENUES_NON_RECURRING"] = "revenues.non_recurring";
    AccountLabel["EXPENSES_D_AND_A"] = "expenses.D_and_A";
    AccountLabel["EXPENSES_GROSS_CASHFLOW_RELATED"] = "expenses.gross_cashflow_related";
    AccountLabel["EXPENSES_NON_CASH_EXPENSES"] = "expenses.non_cash_expenses";
    AccountLabel["EXPENSES_NON_RECURRING"] = "expenses.non_recurring";
    AccountLabel["EXPENSES_OPEX_RELATED"] = "expenses.opex_related";
    AccountLabel["EXPENSES_R_AND_D_RELATED"] = "expenses.r_and_d_related";
    AccountLabel["EXPENSES_REVENUE_RELATED_FINANCIAL_PRINCIPAL_RECOUPMENT"] = "expenses.revenue_related.financial_principal_recoupment";
    AccountLabel["EXPENSES_REVENUE_RELATED_INVENTORY_RECOUPMENT"] = "expenses.revenue_related.inventory_recoupment";
    AccountLabel["EXPENSES_REVENUE_RELATED_INVENTORY_RECOUPMENT_NON_COHORT"] = "expenses.revenue_related.inventory_recoupment_non_cohort";
    AccountLabel["EXPENSES_REVENUE_RELATED_NON_INVENTORY_COGS"] = "expenses.revenue_related.non_inventory_cogs";
    AccountLabel["EXPENSES_REVENUE_RELATED_NON_INVENTORY_COGS_NON_COHORT"] = "expenses.revenue_related.non_inventory_cogs_non_cohort";
    AccountLabel["INVESTMENTS_SALES_AND_MARKETING"] = "investments.sales_and_marketing";
    AccountLabel["INVESTMENTS_EQUITY"] = "investments.equity";
    AccountLabel["INVESTMENTS_INVENTORY"] = "investments.inventory";
    AccountLabel["INVESTMENTS_LOAN"] = "investments.loan";
    AccountLabel["INVESTMENTS_OTHER"] = "investments.other";
    AccountLabel["BOOKINGS_COHORT"] = "bookings.cohort";
    AccountLabel["BOOKINGS_NON_COHORT"] = "bookings.non_cohort";
    AccountLabel["RECONCILED_NET_INCOME"] = "reconciled.net_income";
    AccountLabel["FINANCING_DEBT_RAISED"] = "financing.debt_raised";
    AccountLabel["FINANCING_DEBT_SERVICES_PRINCIPAL"] = "financing.debt_services.principal";
    AccountLabel["FINANCING_DEBT_SERVICES_INTEREST"] = "financing.debt_services.interest";
    AccountLabel["FINANCING_DEBT_SERVICES_FEES"] = "financing.debt_services.fees";
    AccountLabel["FINANCING_EQUITY_RAISED"] = "financing.equity_raised";
    AccountLabel["FINANCING_EQUITY_SERVICES_PRINCIPAL"] = "financing.equity_services.principal";
    AccountLabel["FINANCING_EQUITY_SERVICES_INCOME"] = "financing.equity_services.income";
    AccountLabel["GROSS_CASHFLOWS_COHORT"] = "gross_cashflows.cohort";
    AccountLabel["GROSS_CASHFLOWS_NON_COHORT"] = "gross_cashflows.non_cohort";
    AccountLabel["GROSS_CASHFLOWS_NON_RECURRING"] = "gross_cashflows.non_recurring";
    AccountLabel["OTHER_INCOME_EXPENSE_NET_OTHER_INCOME"] = "Other_income/expense_net.Other_income";
    AccountLabel["OTHER_INCOME_EXPENSE_NET_OTHER_INCOME_NEGATIVE"] = "Other_income/expense_net.Other_income_negative";
    AccountLabel["OTHER_INCOME_EXPENSE_NET_OTHER_EXPENSE"] = "Other_income/expense_net.Other_expense";
    AccountLabel["OTHER_INCOME_EXPENSE_NET_OTHER_EXPENSE_NEGATIVE"] = "Other_income/expense_net.Other_expense_negative";
    AccountLabel["WORKING_CAPITAL_CYCLE"] = "working_capital_cycle";
    AccountLabel["ASSETS"] = "assets";
    AccountLabel["CURRENT_ASSETS"] = "current_assets";
    AccountLabel["NONCURRENT_ASSETS"] = "noncurrent_assets";
    AccountLabel["LIABILITIES"] = "liabilities";
    AccountLabel["CURRENT_LIABILITIES"] = "current_liabilities";
    AccountLabel["NONCURRENT_LIABILITIES"] = "noncurrent_liabilities";
    AccountLabel["COGS"] = "cogs";
    AccountLabel["COSTS"] = "costs";
    AccountLabel["EBITDA"] = "ebitda";
    AccountLabel["EBITDA_MARGIN"] = "ebitdaMargin";
    AccountLabel["PRE_MARKETING_EBITDA_MARGIN"] = "pre_marketing_ebitda_margin";
    AccountLabel["GROSS_MARGIN"] = "gross_margin";
    AccountLabel["GROSS_PROFIT"] = "gross_profit";
    AccountLabel["NET_INCOME"] = "net_income";
    AccountLabel["NON_OPERATING_EXPENSES"] = "non_operating_expenses";
    AccountLabel["OPERATING_EXPENSES"] = "operating_expenses";
    AccountLabel["OPERATING_INCOME"] = "operating_income";
    AccountLabel["OTHER_INCOME"] = "other_income";
    AccountLabel["REVENUES"] = "revenues";
})($ca0d855e0527534d$export$54155dd2ffa34804 || ($ca0d855e0527534d$export$54155dd2ffa34804 = {}));
var $ca0d855e0527534d$export$464989a30bad0982;
(function(PeriodKind) {
    PeriodKind["MONTHLY"] = "monthly";
    PeriodKind["QUARTERLY"] = "quarterly";
    PeriodKind["YEARLY"] = "yearly";
})($ca0d855e0527534d$export$464989a30bad0982 || ($ca0d855e0527534d$export$464989a30bad0982 = {}));
const $ca0d855e0527534d$export$cf38e2d084787788 = {
    ["revenues.cohort"]: {
        color: "#08BDBA",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT,
        name: "Cohort-able Revenue"
    },
    ["revenues.non_cohort"]: {
        color: "#08BDBA",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT,
        name: "Non Cohort-able Revenue with Shared COGS"
    },
    ["revenues.non_cohort_separate_cogs"]: {
        color: "#08BDBA",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT,
        name: "Non Cohort-able Revenue with Separate COGS"
    },
    ["revenues.non_cohort_no_cogs"]: {
        color: "#08BDBA",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT,
        name: "Non Cohort-able Revenue without COGS"
    },
    ["revenues.non_recurring"]: {
        color: "#08BDBA",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT,
        name: "Non Recurring Revenue"
    },
    ["expenses.D_and_A"]: {
        color: "#DFBF03",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT,
        name: "Depreciation & Amortization"
    },
    ["expenses.gross_cashflow_related"]: {
        color: "#DFBF03",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["expenses.non_cash_expenses"]: {
        color: "#DFBF03",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["expenses.non_recurring"]: {
        color: "#DFBF03",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["expenses.opex_related"]: {
        color: "#DFBF03",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["expenses.r_and_d_related"]: {
        color: "#DFBF03",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["expenses.revenue_related.financial_principal_recoupment"]: {
        color: "#DFBF03",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["expenses.revenue_related.inventory_recoupment"]: {
        color: "#DFBF03",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["expenses.revenue_related.inventory_recoupment_non_cohort"]: {
        color: "#DFBF03",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["expenses.revenue_related.non_inventory_cogs"]: {
        color: "#DFBF03",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["expenses.revenue_related.non_inventory_cogs_non_cohort"]: {
        color: "#DFBF03",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["investments.sales_and_marketing"]: {
        color: "#4A66F4",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["investments.equity"]: {
        color: "#4A66F4",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["investments.inventory"]: {
        color: "#4A66F4",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["investments.loan"]: {
        color: "#4A66F4",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["investments.other"]: {
        color: "#4A66F4",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["bookings.cohort"]: {
        color: "#AEC3FC",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["bookings.non_cohort"]: {
        color: "#AEC3FC",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["financing.debt_raised"]: {
        color: "#DA348F",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["financing.debt_services.principal"]: {
        color: "#DA348F",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["financing.debt_services.interest"]: {
        color: "#DA348F",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["financing.debt_services.fees"]: {
        color: "#DA348F",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["financing.equity_raised"]: {
        color: "#DA348F",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["financing.equity_services.principal"]: {
        color: "#DA348F",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["financing.equity_services.income"]: {
        color: "#DA348F",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["gross_cashflows.cohort"]: {
        color: "#28A138",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["gross_cashflows.non_cohort"]: {
        color: "#28A138",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["gross_cashflows.non_recurring"]: {
        color: "#28A138",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["Other_income/expense_net.Other_income"]: {
        color: "#007D79",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["Other_income/expense_net.Other_income_negative"]: {
        color: "#007D79",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["Other_income/expense_net.Other_expense"]: {
        color: "#007D79",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["Other_income/expense_net.Other_expense_negative"]: {
        color: "#007D79",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["reconciled.net_income"]: {
        color: "#E8ECF2",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["current_assets.cash_and_cash_equivalents"]: {
        color: "#10B981",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_assets.deferred_expenses"]: {
        color: "#10B981",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_assets.derivatives_and_hedges"]: {
        color: "#10B981",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_assets.net_contracts_with_customers"]: {
        color: "#10B981",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_assets.net_inventory"]: {
        color: "#10B981",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_assets.net_receivables"]: {
        color: "#10B981",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_assets.other_current_assets"]: {
        color: "#10B981",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_assets.prepaid_expenses"]: {
        color: "#10B981",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_assets.deferred_expenses"]: {
        color: "#059669",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_assets.derivatives_and_hedges"]: {
        color: "#059669",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_assets.inventory"]: {
        color: "#059669",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_assets.longterm_investments_and_receivables"]: {
        color: "#059669",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_assets.net_contracts_with_customers"]: {
        color: "#059669",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_assets.net_intangible_assets_and_goodwill"]: {
        color: "#059669",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_assets.other_assets"]: {
        color: "#059669",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_assets.prepaid_expenses"]: {
        color: "#059669",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_assets.property_plant_and_equipment"]: {
        color: "#059669",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_assets.restricted_cash_and_cash_equivalents"]: {
        color: "#059669",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_liabilities.accounts_payable"]: {
        color: "#EF4444",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_liabilities.debt"]: {
        color: "#EF4444",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_liabilities.deferred_revenue"]: {
        color: "#EF4444",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_liabilities.derivatives_and_hedges"]: {
        color: "#EF4444",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_liabilities.other_liabilities"]: {
        color: "#EF4444",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_liabilities.provision_and_accruals"]: {
        color: "#EF4444",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_liabilities.provision_for_losses_on_contracts"]: {
        color: "#EF4444",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_liabilities.provision_for_refunds"]: {
        color: "#EF4444",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_liabilities.accounts_payable"]: {
        color: "#DC2626",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_liabilities.deferred_revenue"]: {
        color: "#DC2626",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_liabilities.derivatives_hedges"]: {
        color: "#DC2626",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_liabilities.longterm_debt"]: {
        color: "#DC2626",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_liabilities.other_liabilities"]: {
        color: "#DC2626",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_liabilities.provision_and_accruals"]: {
        color: "#DC2626",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_liabilities.provision_for_losses_on_contracts"]: {
        color: "#DC2626",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_liabilities.provision_for_refunds"]: {
        color: "#DC2626",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["equity.paid_in_capital"]: {
        color: "#8B5CF6",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["equity.retained_earnings"]: {
        color: "#8B5CF6",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["assets"]: {
        color: "#10B981",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_assets"]: {
        color: "#10B981",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_assets"]: {
        color: "#059669",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["liabilities"]: {
        color: "#EF4444",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["current_liabilities"]: {
        color: "#EF4444",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["noncurrent_liabilities"]: {
        color: "#DC2626",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    },
    ["cogs"]: {
        color: "#DFBF03",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["costs"]: {
        color: "#DFBF03",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["ebitda"]: {
        color: "#28A138",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["ebitdaMargin"]: {
        color: "#28A138",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["pre_marketing_ebitda_margin"]: {
        color: "#28A138",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["gross_margin"]: {
        color: "#08BDBA",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["gross_profit"]: {
        color: "#08BDBA",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["net_income"]: {
        color: "#E8ECF2",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["non_operating_expenses"]: {
        color: "#007D79",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["operating_expenses"]: {
        color: "#DFBF03",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["operating_income"]: {
        color: "#28A138",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["other_income"]: {
        color: "#007D79",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["revenues"]: {
        color: "#08BDBA",
        statementType: (0, $c44Qc.DataAssetDataType).INCOME_STATEMENT
    },
    ["working_capital_cycle"]: {
        color: "#6B7280",
        statementType: (0, $c44Qc.DataAssetDataType).BALANCE_SHEET
    }
};

});
parcelRegister("c44Qc", function(module, exports) {

$parcel$export(module.exports, "DataAssetSourceType", () => $656e5e0d4bc3aca6$export$f0e1bcb74f177f4b);
$parcel$export(module.exports, "DataAssetDataType", () => $656e5e0d4bc3aca6$export$ab73d32671d29830);
var $656e5e0d4bc3aca6$export$f0e1bcb74f177f4b;
(function(DataAssetSourceType) {
    DataAssetSourceType["FILE"] = "FILE";
    DataAssetSourceType["CONNECTOR"] = "CONNECTOR";
})($656e5e0d4bc3aca6$export$f0e1bcb74f177f4b || ($656e5e0d4bc3aca6$export$f0e1bcb74f177f4b = {}));
var $656e5e0d4bc3aca6$export$ab73d32671d29830;
(function(DataAssetDataType) {
    DataAssetDataType["BALANCE_SHEET"] = "BALANCE_SHEET";
    DataAssetDataType["CHART_OF_ACCOUNTS"] = "CHART_OF_ACCOUNTS";
    DataAssetDataType["INCOME_STATEMENT"] = "INCOME_STATEMENT";
    DataAssetDataType["PROFIT_AND_LOSS"] = "PROFIT_AND_LOSS";
})($656e5e0d4bc3aca6$export$ab73d32671d29830 || ($656e5e0d4bc3aca6$export$ab73d32671d29830 = {}));

});


parcelRegister("a9SWJ", function(module, exports) {
$parcel$export(module.exports, "dealStatusOptions", () => (parcelRequire("fpvYP")).dealStatusOptions);
$parcel$export(module.exports, "getDeal", () => (parcelRequire("lgOhz")).getDeal);
$parcel$export(module.exports, "getDeals", () => (parcelRequire("lgOhz")).getDeals);
$parcel$export(module.exports, "getSFDCData", () => (parcelRequire("lgOhz")).getSFDCData);
$parcel$export(module.exports, "createDeal", () => (parcelRequire("HTIAO")).createDeal);
$parcel$export(module.exports, "updateDeal", () => (parcelRequire("HTIAO")).updateDeal);
parcelRequire("9ediM");
parcelRequire("fpvYP");
parcelRequire("lgOhz");
parcelRequire("HTIAO");
parcelRequire("7CqV4");

});
parcelRegister("9ediM", function(module, exports) {

});

parcelRegister("fpvYP", function(module, exports) {

$parcel$export(module.exports, "DealStatus", () => $e1923e6824417cb0$export$c96b62e2d4d67136);
$parcel$export(module.exports, "dealStatusOptions", () => $e1923e6824417cb0$export$7cc14263b3565127);
var $e1923e6824417cb0$export$c96b62e2d4d67136;
(function(DealStatus) {
    DealStatus["INITIAL_OUTREACH"] = "Initial Outreach";
    DealStatus["HUM_MEETINGS_UNDERWAY"] = "Hum meetings underway";
    DealStatus["MANAGEMENT_MEETINGS_UNDERWAY"] = "Management meetings underway";
    DealStatus["RECEIVING_TERM_SHEETS"] = "Receiving term sheets";
    DealStatus["TERM_SHEET_SENT"] = "Term sheet sent";
    DealStatus["TERM_SHEET_SIGNED"] = "Term sheet signed";
    DealStatus["FUNDED"] = "Funded";
    DealStatus["PAUSED"] = "Paused";
    DealStatus["TERMINATED"] = "Terminated";
    DealStatus["UNDISCLOSED"] = "Undisclosed";
    DealStatus["CLOSED"] = "Closed";
})($e1923e6824417cb0$export$c96b62e2d4d67136 || ($e1923e6824417cb0$export$c96b62e2d4d67136 = {}));
const $e1923e6824417cb0$export$7cc14263b3565127 = Object.values($e1923e6824417cb0$export$c96b62e2d4d67136).map((status)=>({
        label: status,
        value: status
    }));

});

parcelRegister("lgOhz", function(module, exports) {

$parcel$export(module.exports, "getDeal", () => $cb1fef39950a71c6$export$6e558654f2c9befb);
$parcel$export(module.exports, "getDeals", () => $cb1fef39950a71c6$export$5dc24b934d715283);
$parcel$export(module.exports, "getSFDCData", () => $cb1fef39950a71c6$export$9103a47687e98b52);
$parcel$export(module.exports, "getSFDCDataV2", () => $cb1fef39950a71c6$export$486e7defa4ba9d43);
parcelRequire("gCemA");
var $9O2q1 = parcelRequire("9O2q1");
parcelRequire("tL0U5");
var $kkxkw = parcelRequire("kkxkw");
const $cb1fef39950a71c6$export$6e558654f2c9befb = (0, $kkxkw.createQuery)(({ api: api, router: router })=>{
    return api.get(`/deal-flow/v1/deals/${router.params.dealId}`);
});
const $cb1fef39950a71c6$export$5dc24b934d715283 = (0, $kkxkw.createQuery)(({ api: api, params: params, pagination: pagination })=>{
    const queryString = new (0, $9O2q1.QueryStringBuilder)().ilike("name", params?.searchTerm).in("status", params?.status).add("max_page_size", pagination?.maxPageSize || 20).build();
    const url = pagination?.currentUrl ? pagination.currentUrl.replace("/api", "") : `/deal-flow/v2/deals?${queryString}`;
    return api.get(url).then((res)=>({
            ...res,
            prev: res.links.prev ? `/deal-flow${res.links.prev}` : null,
            next: res.links.next ? `/deal-flow${res.links.next}` : null,
            items: res.items.sort((a, b)=>new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
        }));
});
const $cb1fef39950a71c6$export$9103a47687e98b52 = (0, $kkxkw.createQuery)(async ({ api: api, router: router })=>{
    const response = await api.get(`/deal-flow/v1/sfdc_data/${router.params.companyId}`);
    return response?.sfdcData;
});
const $cb1fef39950a71c6$export$486e7defa4ba9d43 = (0, $kkxkw.createQuery)(async ({ api: api, router: router })=>{
    return api.get(`/deal-flow/v2/sfdc_data/${router.params.companyId}`);
});

});

parcelRegister("HTIAO", function(module, exports) {

$parcel$export(module.exports, "createDeal", () => $39f5e4101c69e840$export$3914cece71cd0d80);
$parcel$export(module.exports, "updateDeal", () => $39f5e4101c69e840$export$38e2540ef3661883);
parcelRequire("i5Lss");
var $gBHSi = parcelRequire("gBHSi");

var $12eN8 = parcelRequire("12eN8");
const $39f5e4101c69e840$export$3914cece71cd0d80 = (0, $gBHSi.createMutation)(async ({ api: api, payload: payload })=>{
    const { uuid: uuid } = await api.get("/backend/companies/" + payload.icmCompanyId);
    const { publicToken: teaserProfileToken } = await api.get(`/backend/v1/companies/${payload.icmCompanyId}/teaser_profile`);
    return await api.post("/deal-flow/v1/deals", {
        name: payload.name,
        fundraisingAmountMin: payload.fundraisingAmountMin,
        fundraisingAmountMax: payload.fundraisingAmountMax,
        companyId: uuid,
        dataroomLink: payload.dataroomLink,
        teaserProfileToken: teaserProfileToken
    });
}, {
    invalidates: [
        "/deals"
    ],
    errorToast: {
        message: "Unable to create your deal.",
        options: {
            description: "There was a network error. Please try again."
        }
    }
});
const $39f5e4101c69e840$export$38e2540ef3661883 = (0, $gBHSi.createMutation)(({ api: api, payload: payload })=>{
    return api.patch(`/deal-flow/v1/deals/${payload.id}`, (0, (/*@__PURE__*/$parcel$interopDefault($12eN8)))(payload, "status", "fundraisingAmountMin", "fundraisingAmountMax", "name", "dataroomLink"));
}, {
    invalidates: [
        "/deals"
    ],
    errorToast: {
        message: "Unable to update this deal.",
        options: {
            description: "There was a network error. Please try again."
        }
    }
});

});
parcelRegister("12eN8", function(module, exports) {

var $1AWBt = parcelRequire("1AWBt");

var $8KK0w = parcelRequire("8KK0w");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $0c11739df3ac35ad$var$pick = $8KK0w(function(object, paths) {
    return object == null ? {} : $1AWBt(object, paths);
});
module.exports = $0c11739df3ac35ad$var$pick;

});
parcelRegister("1AWBt", function(module, exports) {

var $6IXDN = parcelRequire("6IXDN");

var $2VBx6 = parcelRequire("2VBx6");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $12969ca4851cc4ab$var$basePick(object, paths) {
    return $6IXDN(object, paths, function(value, path) {
        return $2VBx6(object, path);
    });
}
module.exports = $12969ca4851cc4ab$var$basePick;

});
parcelRegister("6IXDN", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");

var $eJzCK = parcelRequire("eJzCK");

var $4RK0h = parcelRequire("4RK0h");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $4e551d8e73f04819$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $lJEX1(object, path);
        if (predicate(value, path)) $eJzCK(result, $4RK0h(path, object), value);
    }
    return result;
}
module.exports = $4e551d8e73f04819$var$basePickBy;

});
parcelRegister("eJzCK", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $4RK0h = parcelRequire("4RK0h");

var $iyUuu = parcelRequire("iyUuu");

var $lsJ54 = parcelRequire("lsJ54");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $aba0e6d66e8d80dd$var$baseSet(object, path, value, customizer) {
    if (!$lsJ54(object)) return object;
    path = $4RK0h(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $6DSvu(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $lsJ54(objValue) ? objValue : $iyUuu(path[index + 1]) ? [] : {};
        }
        $5i71d(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $aba0e6d66e8d80dd$var$baseSet;

});


parcelRegister("2VBx6", function(module, exports) {

var $ij33W = parcelRequire("ij33W");

var $btvBm = parcelRequire("btvBm");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $btvBm(object, path, $ij33W);
}
module.exports = $221e04e57e35dd04$var$hasIn;

});
parcelRegister("ij33W", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $d53c6080f339a51f$var$baseHasIn;

});

parcelRegister("btvBm", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $iyUuu = parcelRequire("iyUuu");

var $1S9lz = parcelRequire("1S9lz");

var $6DSvu = parcelRequire("6DSvu");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $4RK0h(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $6DSvu(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1S9lz(length) && $iyUuu(key, length) && ($o8HxT(object) || $aJD6g(object));
}
module.exports = $85aaea8f77d790ae$var$hasPath;

});





parcelRegister("7CqV4", function(module, exports) {

var $fpvYP = parcelRequire("fpvYP");
function $8169055c621e08c5$export$73239103aa2996fa(deal) {
    return ![
        (0, $fpvYP.DealStatus).TERM_SHEET_SIGNED,
        (0, $fpvYP.DealStatus).FUNDED,
        (0, $fpvYP.DealStatus).PAUSED,
        (0, $fpvYP.DealStatus).TERMINATED
    ].includes(deal.status);
}

});


parcelRegister("62e6P", function(module, exports) {

$parcel$export(module.exports, "CapitalDeployment", () => $36f5f5c1a40c699a$export$c1fe4906c1693140);
$parcel$export(module.exports, "EquityRaised", () => $36f5f5c1a40c699a$export$3e850a124297906b);
$parcel$export(module.exports, "LastFundingRound", () => $36f5f5c1a40c699a$export$bdf6420a7a5d2491);
$parcel$export(module.exports, "FundingType", () => $36f5f5c1a40c699a$export$f911c97e3afc4b61);
$parcel$export(module.exports, "UseOfFunds", () => $36f5f5c1a40c699a$export$e36929f8ff0b4168);
$parcel$export(module.exports, "FundraisingTimeFrameMonths", () => $36f5f5c1a40c699a$export$69715a7b717d914e);
$parcel$export(module.exports, "CAPITAL_DEPLOYMENT", () => $36f5f5c1a40c699a$export$7de86c5b1a44a3df);
$parcel$export(module.exports, "FUNDRAISING_TIME_FRAME_MONTHS", () => $36f5f5c1a40c699a$export$9e7b7a7520ed5774);
$parcel$export(module.exports, "REVENUE_MODEL_V6", () => $36f5f5c1a40c699a$export$f9501c6844f77145);
$parcel$export(module.exports, "FUNDING_TYPE", () => $36f5f5c1a40c699a$export$dcbd53e1d74b954c);
$parcel$export(module.exports, "LAST_FUNDING_ROUND", () => $36f5f5c1a40c699a$export$80ab2d5be494364);
$parcel$export(module.exports, "USE_OF_FUNDS", () => $36f5f5c1a40c699a$export$ce12481ac10e8c52);
$parcel$export(module.exports, "EQUITY_RAISED", () => $36f5f5c1a40c699a$export$8c7a88524e25f665);
var $36f5f5c1a40c699a$export$fea4070ffadc9cbd;
(function(ApplicationStatus) {
    ApplicationStatus["Engage"] = "engage";
    ApplicationStatus["Pass"] = "pass";
})($36f5f5c1a40c699a$export$fea4070ffadc9cbd || ($36f5f5c1a40c699a$export$fea4070ffadc9cbd = {}));
var $36f5f5c1a40c699a$export$c1fe4906c1693140;
(function(CapitalDeployment) {
    CapitalDeployment["Once"] = "once";
    CapitalDeployment["Monthly"] = "monthly";
    CapitalDeployment["NotSure"] = "not_sure";
})($36f5f5c1a40c699a$export$c1fe4906c1693140 || ($36f5f5c1a40c699a$export$c1fe4906c1693140 = {}));
var $36f5f5c1a40c699a$export$86bdf0b5e9e974e5;
(function(ApplicationRecordSystem) {
    ApplicationRecordSystem["Swell"] = "Swell";
    ApplicationRecordSystem["Kizen"] = "Kizen";
    ApplicationRecordSystem["ThreeDCart"] = "3dcart";
    ApplicationRecordSystem["Checkbook"] = "Checkbook";
    ApplicationRecordSystem["StoreHippo"] = "StoreHippo";
    ApplicationRecordSystem["Exact"] = "Exact";
    ApplicationRecordSystem["CompanyHub"] = "CompanyHub";
    ApplicationRecordSystem["Affirm"] = "Affirm";
    ApplicationRecordSystem["AgileCRM"] = "AgileCRM";
    ApplicationRecordSystem["Quickbooks"] = "Quickbooks";
    ApplicationRecordSystem["SAP"] = "SAP";
    ApplicationRecordSystem["Xero"] = "Xero";
    ApplicationRecordSystem["NetSuite"] = "NetSuite";
    ApplicationRecordSystem["Workday"] = "Workday";
    ApplicationRecordSystem["Billomat"] = "Billomat";
    ApplicationRecordSystem["Clearbooks"] = "Clearbooks";
    ApplicationRecordSystem["Recurly"] = "Recurly";
    ApplicationRecordSystem["MX"] = "MX";
    ApplicationRecordSystem["Mixpanel"] = "Mixpanel";
    ApplicationRecordSystem["Paywhirl"] = "PayWhirl";
    ApplicationRecordSystem["Nimble"] = "Nimble";
    ApplicationRecordSystem["Revcent"] = "RevCent";
    ApplicationRecordSystem["Mailchimp"] = "Mailchimp";
    ApplicationRecordSystem["Holded"] = "Holded";
    ApplicationRecordSystem["Xcart"] = "X-Cart";
    ApplicationRecordSystem["Candis"] = "Candis";
    ApplicationRecordSystem["GoogleAnalytics"] = "Google Analytics";
    ApplicationRecordSystem["GoogleAdsense"] = "Google Adsense";
    ApplicationRecordSystem["Liftoff"] = "LiftOff";
    ApplicationRecordSystem["Enigma"] = "Enigma";
    ApplicationRecordSystem["Agenda"] = "Agenda";
    ApplicationRecordSystem["FastBill"] = "FastBill";
    ApplicationRecordSystem["MicrosoftDynamics"] = "Microsoft Dynamics";
    ApplicationRecordSystem["Other"] = "Other";
})($36f5f5c1a40c699a$export$86bdf0b5e9e974e5 || ($36f5f5c1a40c699a$export$86bdf0b5e9e974e5 = {}));
var $36f5f5c1a40c699a$export$58eab404bff08c1a;
(function(ApplicationPaymentProcessor) {
    ApplicationPaymentProcessor["PayPal"] = "PayPal";
    ApplicationPaymentProcessor["WooCommerce"] = "WooCommerce";
    ApplicationPaymentProcessor["Stripe"] = "Stripe";
    ApplicationPaymentProcessor["Squarespace"] = "Squarespace Online Stores";
    ApplicationPaymentProcessor["Shopify"] = "Shopify";
    ApplicationPaymentProcessor["Square"] = "Square";
    ApplicationPaymentProcessor["Braintree"] = "Braintree";
    ApplicationPaymentProcessor["Klarna"] = "Klarna";
    ApplicationPaymentProcessor["Afterpay"] = "Afterpay";
    ApplicationPaymentProcessor["AuthorizeNet"] = "Authorize.net";
    ApplicationPaymentProcessor["Billomat"] = "Billomat";
    ApplicationPaymentProcessor["Clearbooks"] = "Clearbooks";
    ApplicationPaymentProcessor["BillCom"] = "Bill.com";
    ApplicationPaymentProcessor["Worldpay"] = "Worldpay";
    ApplicationPaymentProcessor["Affirm"] = "Affirm";
    ApplicationPaymentProcessor["AgileCRM"] = "Agile CRM";
    ApplicationPaymentProcessor["CompanyHub"] = "CompanyHub";
    ApplicationPaymentProcessor["AmazonPay"] = "Amazon Pay";
    ApplicationPaymentProcessor["Finch"] = "Finch";
    ApplicationPaymentProcessor["Other"] = "Other";
})($36f5f5c1a40c699a$export$58eab404bff08c1a || ($36f5f5c1a40c699a$export$58eab404bff08c1a = {}));
var $36f5f5c1a40c699a$export$78db2d6537aa05c3;
(function(ApplicationEconomicTiers) {
    ApplicationEconomicTiers["Between0And1M"] = "between_0_and_1_m";
    ApplicationEconomicTiers["Between1And3M"] = "between_1_and_3_m";
    ApplicationEconomicTiers["Between3And5M"] = "between_3_and_5_m";
    ApplicationEconomicTiers["Between5And15M"] = "between_5_and_15_m";
    ApplicationEconomicTiers["Between15And25M"] = "between_15_and_25_m";
    ApplicationEconomicTiers["Between25And50M"] = "between_25_and_50_m";
    ApplicationEconomicTiers["Between50And100M"] = "between_50_and_100_m";
    ApplicationEconomicTiers["MoreThan100M"] = "more_than_100_m";
})($36f5f5c1a40c699a$export$78db2d6537aa05c3 || ($36f5f5c1a40c699a$export$78db2d6537aa05c3 = {}));
var $36f5f5c1a40c699a$export$fe0044bc98bf7c00;
(function(ApplicationRunwayMonths) {
    ApplicationRunwayMonths["LessThan6"] = "lessThan6";
    ApplicationRunwayMonths["Between6and12"] = "between6and12";
    ApplicationRunwayMonths["MoreThan12"] = "moreThan12";
})($36f5f5c1a40c699a$export$fe0044bc98bf7c00 || ($36f5f5c1a40c699a$export$fe0044bc98bf7c00 = {}));
var $36f5f5c1a40c699a$export$36655de2868043ae;
(function(ChannelType) {
    ChannelType["icm_organic"] = "icm_organic";
    ChannelType["icm_sales"] = "icm_sales";
    ChannelType["icm_company_invitation"] = "icm_company_invitation";
    ChannelType["icm_investor_invitation"] = "icm_investor_invitation";
    ChannelType["webform"] = "webform";
    ChannelType["social"] = "social";
    ChannelType["referral"] = "referral";
    ChannelType["events"] = "events";
    ChannelType["paid_list"] = "paid_list";
    ChannelType["paid_ads"] = "paid_ads";
    ChannelType["outbound_sales"] = "outbound_sales";
    ChannelType["unknown"] = "unknown";
})($36f5f5c1a40c699a$export$36655de2868043ae || ($36f5f5c1a40c699a$export$36655de2868043ae = {}));
var $36f5f5c1a40c699a$export$bcc3ec789deb1f8c;
(function(OnboardingStatus) {
    OnboardingStatus["Complete"] = "complete";
    OnboardingStatus["Incomplete"] = "incomplete";
    OnboardingStatus["LegacyComplete"] = "legacy_complete";
    OnboardingStatus["LegacyIncomplete"] = "legacy_incomplete";
    OnboardingStatus["CompleteButWaitingForMdaToBeDownloaded"] = "complete_but_waiting_for_mda_to_be_downloaded";
})($36f5f5c1a40c699a$export$bcc3ec789deb1f8c || ($36f5f5c1a40c699a$export$bcc3ec789deb1f8c = {}));
var $36f5f5c1a40c699a$export$b26c9c564f168968;
(function(CompanyRevenueModel) {
    CompanyRevenueModel["Saas"] = "saas";
    CompanyRevenueModel["Transactional"] = "transactional";
    CompanyRevenueModel["Licensing"] = "licensing";
    CompanyRevenueModel["TakeRate"] = "take_rate";
})($36f5f5c1a40c699a$export$b26c9c564f168968 || ($36f5f5c1a40c699a$export$b26c9c564f168968 = {}));
var $36f5f5c1a40c699a$export$728c355525e7922b;
(function(CompanyRevenueModelV6) {
    CompanyRevenueModelV6["TransactionalConsumer"] = "transactional_consumer";
    CompanyRevenueModelV6["TransactionalEnterprise"] = "transactional_enterprise";
    CompanyRevenueModelV6["RecurringSaaS"] = "recurring_saas";
    CompanyRevenueModelV6["RecurringSubscription"] = "recurring_subscription";
    CompanyRevenueModelV6["RecurringLicensingRoyalties"] = "recurring_licensing_royalties";
    CompanyRevenueModelV6["TakeRate"] = "take_rate";
    CompanyRevenueModelV6["LendingFinance"] = "lending_finance";
    CompanyRevenueModelV6["ServiceProject"] = "service_project";
    CompanyRevenueModelV6["ServiceFee"] = "service_fee";
    CompanyRevenueModelV6["Other"] = "other";
})($36f5f5c1a40c699a$export$728c355525e7922b || ($36f5f5c1a40c699a$export$728c355525e7922b = {}));
var $36f5f5c1a40c699a$export$3e850a124297906b;
(function(EquityRaised) {
    EquityRaised["Bootstrapped"] = "bootstrapped";
    EquityRaised["Between0And5M"] = "between_0_and_5_m";
    EquityRaised["Between5And15M"] = "between_5_and_15_m";
    EquityRaised["Between15And25M"] = "between_15_and_25_m";
    EquityRaised["Between25And50M"] = "between_25_and_50_m";
    EquityRaised["Between50And100M"] = "between_50_and_100_m";
    EquityRaised["MoreThan100M"] = "more_than_100_m";
})($36f5f5c1a40c699a$export$3e850a124297906b || ($36f5f5c1a40c699a$export$3e850a124297906b = {}));
var $36f5f5c1a40c699a$export$8186fe9999620ade;
(function(LeverageableAssets) {
    LeverageableAssets["NotApplicable"] = "not_applicable";
    LeverageableAssets["AccountsReceivable"] = "accounts_receivable";
    LeverageableAssets["Inventory"] = "inventory";
    LeverageableAssets["RealEstate"] = "real_estate";
    LeverageableAssets["CapitalEquipment"] = "capital_equipment";
})($36f5f5c1a40c699a$export$8186fe9999620ade || ($36f5f5c1a40c699a$export$8186fe9999620ade = {}));
var $36f5f5c1a40c699a$export$bdf6420a7a5d2491;
(function(LastFundingRound) {
    LastFundingRound["Bootstrapped"] = "bootstrapped";
    LastFundingRound["PreSeed"] = "preseed";
    LastFundingRound["Seed"] = "seed";
    LastFundingRound["SeriesA"] = "series_a";
    LastFundingRound["SeriesB"] = "series_b";
    LastFundingRound["SeriesC"] = "series_c";
    LastFundingRound["SeriesD"] = "series_d";
    LastFundingRound["SeriesE"] = "series_e";
})($36f5f5c1a40c699a$export$bdf6420a7a5d2491 || ($36f5f5c1a40c699a$export$bdf6420a7a5d2491 = {}));
var $36f5f5c1a40c699a$export$f911c97e3afc4b61;
(function(FundingType) {
    FundingType["Debt"] = "debt";
    FundingType["Equity"] = "equity";
    FundingType["Either"] = "either";
    FundingType["IDontKnow"] = "i_dont_know";
})($36f5f5c1a40c699a$export$f911c97e3afc4b61 || ($36f5f5c1a40c699a$export$f911c97e3afc4b61 = {}));
var $36f5f5c1a40c699a$export$19445fdc19724941;
(function(InvestmentType) {
    InvestmentType["Angel"] = "angel";
    InvestmentType["GrowthEquity"] = "growth_equity";
    InvestmentType["LeveragedBuyOut"] = "leveraged_buy_out";
    InvestmentType["MezzDebt"] = "mezz_debt";
    InvestmentType["PreIPO"] = "pre_IPO";
    InvestmentType["Seed"] = "seed";
    InvestmentType["SeniorBankDebt"] = "senior_bank_debt";
    InvestmentType["SeriesA"] = "series_a";
    InvestmentType["SeriesBPlus"] = "series_b_plus";
    InvestmentType["SpecialSituations"] = "special_situations";
    InvestmentType["VentureDebt"] = "venture_debt";
    InvestmentType["SmallCapPublic"] = "small_cap_public";
    InvestmentType["ReceivablesFinance"] = "receivables_finance";
})($36f5f5c1a40c699a$export$19445fdc19724941 || ($36f5f5c1a40c699a$export$19445fdc19724941 = {}));
var $36f5f5c1a40c699a$export$e36929f8ff0b4168;
(function(UseOfFunds) {
    UseOfFunds["OrganicGrowth"] = "organic_growth";
    UseOfFunds["ResearchAndDevelopment"] = "research_and_development";
    UseOfFunds["InventoryOrWorkingCapital"] = "inventory_or_working_capital";
    UseOfFunds["PurchaseOrders"] = "purchase_orders";
    UseOfFunds["Payables"] = "payables";
    UseOfFunds["TurnaroundFinancing"] = "turnaround_financing";
    UseOfFunds["CapitalEquipment"] = "capital_equipment";
    UseOfFunds["RealEstate"] = "real_estate";
    UseOfFunds["Acquisition"] = "acquisition";
    UseOfFunds["Lending"] = "lending";
    UseOfFunds["Recapitalization"] = "recapitalization";
    UseOfFunds["DebtRefinancing"] = "debt_refinancing";
    UseOfFunds["Other"] = "other";
})($36f5f5c1a40c699a$export$e36929f8ff0b4168 || ($36f5f5c1a40c699a$export$e36929f8ff0b4168 = {}));
var $36f5f5c1a40c699a$export$69715a7b717d914e;
(function(FundraisingTimeFrameMonths) {
    FundraisingTimeFrameMonths["Between0and3"] = "between_0_and_3_months";
    FundraisingTimeFrameMonths["Between3and6"] = "between_3_and_6_months";
    FundraisingTimeFrameMonths["Between6and12"] = "between_6_and_12_months";
    FundraisingTimeFrameMonths["MoreThan12"] = "more_than_12_months";
})($36f5f5c1a40c699a$export$69715a7b717d914e || ($36f5f5c1a40c699a$export$69715a7b717d914e = {}));
var $36f5f5c1a40c699a$export$af844a2dcae8301a;
(function(CompanyEquityRaised) {
    CompanyEquityRaised["Bootstrapped"] = "bootstrapped";
    CompanyEquityRaised["Between0And5M"] = "between_0_and_5_m";
    CompanyEquityRaised["Between5And15M"] = "between_5_and_15_m";
    CompanyEquityRaised["Between15And25M"] = "between_15_and_25_m";
    CompanyEquityRaised["Between25And50M"] = "between_25_and_50_m";
    CompanyEquityRaised["Between50And100M"] = "between_50_and_100_m";
    CompanyEquityRaised["MoreThan100M"] = "more_than_100_m";
})($36f5f5c1a40c699a$export$af844a2dcae8301a || ($36f5f5c1a40c699a$export$af844a2dcae8301a = {}));
const $36f5f5c1a40c699a$export$7de86c5b1a44a3df = {
    ["once"]: "All at once (one installment)",
    ["monthly"]: "Monthly installments",
    ["not_sure"]: "Not sure"
};
const $36f5f5c1a40c699a$export$9e7b7a7520ed5774 = {
    ["between_0_and_3_months"]: "Less than 3 months",
    ["between_3_and_6_months"]: "Between 3 and 6 months",
    ["between_6_and_12_months"]: "Between 6 and 12 months",
    ["more_than_12_months"]: "12 months or more"
};
const $36f5f5c1a40c699a$export$f9501c6844f77145 = {
    ["transactional_consumer"]: "Transactional (Consumer)",
    ["transactional_enterprise"]: "Transactional (Enterprise)",
    ["recurring_saas"]: "SaaS (Recurring)",
    ["recurring_subscription"]: "Subscription (Recurring)",
    ["recurring_licensing_royalties"]: "Licensing / Royalties (Recurring)",
    ["take_rate"]: "Take Rate (eg. Marketplace)",
    ["lending_finance"]: "Specialty Finance / Lending",
    ["service_project"]: "Service (Project-based)",
    ["service_fee"]: "Service (Fee-for-service)",
    ["other"]: "Other"
};
const $36f5f5c1a40c699a$export$dcbd53e1d74b954c = {
    ["debt"]: "Debt",
    ["equity"]: "Equity",
    ["either"]: "Either",
    ["i_dont_know"]: "I don't know"
};
const $36f5f5c1a40c699a$export$80ab2d5be494364 = {
    ["bootstrapped"]: "Bootstrapped (No external capital taken)",
    ["preseed"]: "Pre-seed",
    ["seed"]: "Seed",
    ["series_a"]: "Series A",
    ["series_b"]: "Series B",
    ["series_c"]: "Series C",
    ["series_d"]: "Series D",
    ["series_e"]: "Series E"
};
const $36f5f5c1a40c699a$export$ce12481ac10e8c52 = {
    ["acquisition"]: "Acquisition",
    ["capital_equipment"]: "Capital Equipment",
    ["debt_refinancing"]: "Debt Refinancing",
    ["inventory_or_working_capital"]: "Inventory or Working Capital",
    ["lending"]: "Lending",
    ["organic_growth"]: "Organic Growth",
    ["payables"]: "Payables",
    ["purchase_orders"]: "Purchase Orders",
    ["research_and_development"]: "R&D",
    ["real_estate"]: "Real Estate",
    ["recapitalization"]: "Recapitalization",
    ["turnaround_financing"]: "Turnaround Financing",
    ["other"]: "Other"
};
const $36f5f5c1a40c699a$export$8c7a88524e25f665 = {
    ["bootstrapped"]: "Bootstrapped (No external capital taken)",
    ["between_0_and_5_m"]: "$0\u2013$5M",
    ["between_5_and_15_m"]: "$5\u2013$15M",
    ["between_15_and_25_m"]: "$15\u2013$25M",
    ["between_25_and_50_m"]: "$25\u2013$50M",
    ["between_50_and_100_m"]: "$50\u2013$100M",
    ["more_than_100_m"]: "$100M+"
};

});

parcelRegister("gxPgh", function(module, exports) {

$parcel$export(module.exports, "AgGridReact", () => $0e439ae7301dd858$export$4074462c5969a5d8);
// packages/ag-grid-react/src/agGridReact.tsx

var $acw62 = parcelRequire("acw62");

var $jIDNV = parcelRequire("jIDNV");

var $1u0KT = parcelRequire("1u0KT");
var $0e439ae7301dd858$var$BeansContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
var $0e439ae7301dd858$var$RenderModeContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext("default");
// packages/ag-grid-react/src/reactUi/jsComp.tsx
var $0e439ae7301dd858$var$showJsComp = (compDetails, context, eParent, ref)=>{
    const doNothing = !compDetails || compDetails.componentFromFramework || context.isDestroyed();
    if (doNothing) return;
    const promise = compDetails.newAgStackInstance();
    let comp;
    let compGui;
    let destroyed = false;
    promise.then((c)=>{
        if (destroyed) {
            context.destroyBean(c);
            return;
        }
        comp = c;
        compGui = comp.getGui();
        eParent.appendChild(compGui);
        $0e439ae7301dd858$var$setRef(ref, comp);
    });
    return ()=>{
        destroyed = true;
        if (!comp) return;
        compGui?.parentElement?.removeChild(compGui);
        context.destroyBean(comp);
        if (ref) $0e439ae7301dd858$var$setRef(ref, void 0);
    };
};
var $0e439ae7301dd858$var$setRef = (ref, value)=>{
    if (!ref) return;
    if (ref instanceof Function) {
        const refCallback = ref;
        refCallback(value);
    } else {
        const refObj = ref;
        refObj.current = value;
    }
};
var $0e439ae7301dd858$var$classesList = (...list)=>{
    const filtered = list.filter((s)=>s != null && s !== "");
    return filtered.join(" ");
};
var $0e439ae7301dd858$var$CssClasses = class _CssClasses {
    constructor(...initialClasses){
        this.classesMap = {};
        initialClasses.forEach((className)=>{
            this.classesMap[className] = true;
        });
    }
    setClass(className, on) {
        const nothingHasChanged = !!this.classesMap[className] == on;
        if (nothingHasChanged) return this;
        const res = new _CssClasses();
        res.classesMap = {
            ...this.classesMap
        };
        res.classesMap[className] = on;
        return res;
    }
    toString() {
        const res = Object.keys(this.classesMap).filter((key)=>this.classesMap[key]).join(" ");
        return res;
    }
};
var $0e439ae7301dd858$var$isComponentStateless = (Component2)=>{
    const hasSymbol = ()=>typeof Symbol === "function" && Symbol.for;
    const getMemoType = ()=>hasSymbol() ? Symbol.for("react.memo") : 60115;
    return typeof Component2 === "function" && !(Component2.prototype && Component2.prototype.isReactComponent) || typeof Component2 === "object" && Component2.$$typeof === getMemoType();
};
var $0e439ae7301dd858$var$reactVersion = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version?.split(".")[0];
var $0e439ae7301dd858$var$isReactVersion17Minus = $0e439ae7301dd858$var$reactVersion === "16" || $0e439ae7301dd858$var$reactVersion === "17";
function $0e439ae7301dd858$var$isReact19() {
    return $0e439ae7301dd858$var$reactVersion === "19";
}
var $0e439ae7301dd858$var$disableFlushSync = false;
function $0e439ae7301dd858$var$runWithoutFlushSync(func) {
    if (!$0e439ae7301dd858$var$disableFlushSync) setTimeout(()=>$0e439ae7301dd858$var$disableFlushSync = false, 0);
    $0e439ae7301dd858$var$disableFlushSync = true;
    return func();
}
var $0e439ae7301dd858$var$agFlushSync = (useFlushSync, fn)=>{
    if (!$0e439ae7301dd858$var$isReactVersion17Minus && useFlushSync && !$0e439ae7301dd858$var$disableFlushSync) (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).flushSync(fn);
    else fn();
};
var $0e439ae7301dd858$var$agStartTransition = (fn)=>{
    if (!$0e439ae7301dd858$var$isReactVersion17Minus) (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).startTransition(fn);
    else fn();
};
function $0e439ae7301dd858$var$agUseSyncExternalStore(subscribe, getSnapshot, defaultSnapshot) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useSyncExternalStore) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useSyncExternalStore(subscribe, getSnapshot);
    else return defaultSnapshot;
}
function $0e439ae7301dd858$var$getNextValueIfDifferent(prev, next, maintainOrder) {
    if (next == null || prev == null) return next;
    if (prev === next || next.length === 0 && prev.length === 0) return prev;
    if (maintainOrder || prev.length === 0 && next.length > 0 || prev.length > 0 && next.length === 0) return next;
    const oldValues = [];
    const newValues = [];
    const prevMap = /* @__PURE__ */ new Map();
    const nextMap = /* @__PURE__ */ new Map();
    for(let i = 0; i < next.length; i++){
        const c = next[i];
        nextMap.set(c.instanceId, c);
    }
    for(let i = 0; i < prev.length; i++){
        const c = prev[i];
        prevMap.set(c.instanceId, c);
        if (nextMap.has(c.instanceId)) oldValues.push(c);
    }
    for(let i = 0; i < next.length; i++){
        const c = next[i];
        const instanceId = c.instanceId;
        if (!prevMap.has(instanceId)) newValues.push(c);
    }
    if (oldValues.length === prev.length && newValues.length === 0) return prev;
    if (oldValues.length === 0 && newValues.length === next.length) return next;
    if (oldValues.length === 0) return newValues;
    if (newValues.length === 0) return oldValues;
    return [
        ...oldValues,
        ...newValues
    ];
}
// packages/ag-grid-react/src/reactUi/cellRenderer/groupCellRenderer.tsx
var $0e439ae7301dd858$var$GroupCellRenderer = (0, $acw62.forwardRef)((props, ref)=>{
    const { registry: registry, context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const eGui = (0, $acw62.useRef)(null);
    const eValueRef = (0, $acw62.useRef)(null);
    const eCheckboxRef = (0, $acw62.useRef)(null);
    const eExpandedRef = (0, $acw62.useRef)(null);
    const eContractedRef = (0, $acw62.useRef)(null);
    const ctrlRef = (0, $acw62.useRef)();
    const [innerCompDetails, setInnerCompDetails] = (0, $acw62.useState)();
    const [childCount, setChildCount] = (0, $acw62.useState)();
    const [value, setValue] = (0, $acw62.useState)();
    const [cssClasses, setCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [expandedCssClasses, setExpandedCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses("ag-hidden"));
    const [contractedCssClasses, setContractedCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses("ag-hidden"));
    const [checkboxCssClasses, setCheckboxCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses("ag-invisible"));
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        return {
            // force new instance when grid tries to refresh
            refresh () {
                return false;
            }
        };
    });
    (0, $acw62.useLayoutEffect)(()=>{
        return $0e439ae7301dd858$var$showJsComp(innerCompDetails, context, eValueRef.current);
    }, [
        innerCompDetails
    ]);
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        if (!eRef) {
            ctrlRef.current = context.destroyBean(ctrlRef.current);
            return;
        }
        const compProxy = {
            setInnerRenderer: (details, valueToDisplay)=>{
                setInnerCompDetails(details);
                setValue(valueToDisplay);
            },
            setChildCount: (count)=>setChildCount(count),
            toggleCss: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            setContractedDisplayed: (displayed)=>setContractedCssClasses((prev)=>prev.setClass("ag-hidden", !displayed)),
            setExpandedDisplayed: (displayed)=>setExpandedCssClasses((prev)=>prev.setClass("ag-hidden", !displayed)),
            setCheckboxVisible: (visible)=>setCheckboxCssClasses((prev)=>prev.setClass("ag-invisible", !visible)),
            setCheckboxSpacing: (add)=>setCheckboxCssClasses((prev)=>prev.setClass("ag-group-checkbox-spacing", add))
        };
        const groupCellRendererCtrl = registry.createDynamicBean("groupCellRendererCtrl", true);
        if (groupCellRendererCtrl) {
            ctrlRef.current = context.createBean(groupCellRendererCtrl);
            ctrlRef.current.init(compProxy, eRef, eCheckboxRef.current, eExpandedRef.current, eContractedRef.current, $0e439ae7301dd858$var$GroupCellRenderer, props);
        }
    }, []);
    const className = (0, $acw62.useMemo)(()=>`ag-cell-wrapper ${cssClasses.toString()}`, [
        cssClasses
    ]);
    const expandedClassName = (0, $acw62.useMemo)(()=>`ag-group-expanded ${expandedCssClasses.toString()}`, [
        expandedCssClasses
    ]);
    const contractedClassName = (0, $acw62.useMemo)(()=>`ag-group-contracted ${contractedCssClasses.toString()}`, [
        contractedCssClasses
    ]);
    const checkboxClassName = (0, $acw62.useMemo)(()=>`ag-group-checkbox ${checkboxCssClasses.toString()}`, [
        checkboxCssClasses
    ]);
    const useFwRenderer = innerCompDetails?.componentFromFramework;
    const FwRenderer = useFwRenderer ? innerCompDetails.componentClass : void 0;
    const useValue = innerCompDetails == null && value != null;
    const escapedValue = (0, $jIDNV._toString)(value);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: className,
        ref: setRef2,
        ...!props.colDef ? {
            role: ctrlRef.current?.getCellAriaRole()
        } : {}
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: expandedClassName,
        ref: eExpandedRef
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: contractedClassName,
        ref: eContractedRef
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: checkboxClassName,
        ref: eCheckboxRef
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ag-group-value",
        ref: eValueRef
    }, useValue ? escapedValue : useFwRenderer ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FwRenderer, {
        ...innerCompDetails.params
    }) : null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ag-group-child-count"
    }, childCount));
});
var $0e439ae7301dd858$var$groupCellRenderer_default = $0e439ae7301dd858$var$GroupCellRenderer;
var $0e439ae7301dd858$export$9f6317c67b47ac67 = (0, $acw62.createContext)({
    setMethods: ()=>{}
});
// packages/ag-grid-react/src/reactUi/customComp/customWrapperComp.tsx
var $0e439ae7301dd858$var$CustomWrapperComp = (params)=>{
    const { initialProps: initialProps, addUpdateCallback: addUpdateCallback, CustomComponentClass: CustomComponentClass, setMethods: setMethods } = params;
    const [{ key: key, ...props }, setProps] = (0, $acw62.useState)(initialProps);
    (0, $acw62.useEffect)(()=>{
        addUpdateCallback((newProps)=>setProps(newProps));
    }, []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$export$9f6317c67b47ac67.Provider, {
        value: {
            setMethods: setMethods
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CustomComponentClass, {
        key: key,
        ...props
    }));
};
var $0e439ae7301dd858$var$customWrapperComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$CustomWrapperComp);
// packages/ag-grid-react/src/shared/keyGenerator.ts
var $0e439ae7301dd858$var$counter = 0;
function $0e439ae7301dd858$var$generateNewKey() {
    return `agPortalKey_${++$0e439ae7301dd858$var$counter}`;
}
// packages/ag-grid-react/src/shared/reactComponent.ts
var $0e439ae7301dd858$var$ReactComponent = class {
    constructor(reactComponent, portalManager, componentType, suppressFallbackMethods){
        this.portal = null;
        this.oldPortal = null;
        this.reactComponent = reactComponent;
        this.portalManager = portalManager;
        this.componentType = componentType;
        this.suppressFallbackMethods = !!suppressFallbackMethods;
        this.statelessComponent = this.isStateless(this.reactComponent);
        this.key = $0e439ae7301dd858$var$generateNewKey();
        this.portalKey = $0e439ae7301dd858$var$generateNewKey();
        this.instanceCreated = this.isStatelessComponent() ? (0, $jIDNV.AgPromise).resolve(false) : new (0, $jIDNV.AgPromise)((resolve)=>{
            this.resolveInstanceCreated = resolve;
        });
    }
    getGui() {
        return this.eParentElement;
    }
    /** `getGui()` returns the parent element. This returns the actual root element. */ getRootElement() {
        const firstChild = this.eParentElement.firstChild;
        return firstChild;
    }
    destroy() {
        if (this.componentInstance && typeof this.componentInstance.destroy == "function") this.componentInstance.destroy();
        const portal = this.portal;
        if (portal) this.portalManager.destroyPortal(portal);
    }
    createParentElement(params) {
        const componentWrappingElement = this.portalManager.getComponentWrappingElement();
        const eParentElement = document.createElement(componentWrappingElement || "div");
        eParentElement.classList.add("ag-react-container");
        params.reactContainer = eParentElement;
        return eParentElement;
    }
    statelessComponentRendered() {
        return this.eParentElement.childElementCount > 0 || this.eParentElement.childNodes.length > 0;
    }
    getFrameworkComponentInstance() {
        return this.componentInstance;
    }
    isStatelessComponent() {
        return this.statelessComponent;
    }
    getReactComponentName() {
        return this.reactComponent.name;
    }
    getMemoType() {
        return this.hasSymbol() ? Symbol.for("react.memo") : 60115;
    }
    hasSymbol() {
        return typeof Symbol === "function" && Symbol.for;
    }
    isStateless(Component2) {
        return typeof Component2 === "function" && !(Component2.prototype && Component2.prototype.isReactComponent) || typeof Component2 === "object" && Component2.$$typeof === this.getMemoType();
    }
    hasMethod(name) {
        const frameworkComponentInstance = this.getFrameworkComponentInstance();
        return !!frameworkComponentInstance && frameworkComponentInstance[name] != null || this.fallbackMethodAvailable(name);
    }
    callMethod(name, args) {
        const frameworkComponentInstance = this.getFrameworkComponentInstance();
        if (this.isStatelessComponent()) return this.fallbackMethod(name, !!args && args[0] ? args[0] : {});
        else if (!frameworkComponentInstance) {
            setTimeout(()=>this.callMethod(name, args));
            return;
        }
        const method = frameworkComponentInstance[name];
        if (method) return method.apply(frameworkComponentInstance, args);
        if (this.fallbackMethodAvailable(name)) return this.fallbackMethod(name, !!args && args[0] ? args[0] : {});
    }
    addMethod(name, callback) {
        this[name] = callback;
    }
    init(params) {
        this.eParentElement = this.createParentElement(params);
        this.createOrUpdatePortal(params);
        return new (0, $jIDNV.AgPromise)((resolve)=>this.createReactComponent(resolve));
    }
    createOrUpdatePortal(params) {
        if (!this.isStatelessComponent()) {
            this.ref = (element)=>{
                this.componentInstance = element;
                this.resolveInstanceCreated?.(true);
                this.resolveInstanceCreated = void 0;
            };
            params.ref = this.ref;
        }
        this.reactElement = this.createElement(this.reactComponent, {
            ...params,
            key: this.key
        });
        this.portal = (0, $1u0KT.createPortal)(this.reactElement, this.eParentElement, this.portalKey);
    }
    createElement(reactComponent, props) {
        return (0, $acw62.createElement)(reactComponent, props);
    }
    createReactComponent(resolve) {
        this.portalManager.mountReactPortal(this.portal, this, resolve);
    }
    rendered() {
        return this.isStatelessComponent() && this.statelessComponentRendered() || !!(!this.isStatelessComponent() && this.getFrameworkComponentInstance());
    }
    /*
   * fallback methods - these will be invoked if a corresponding instance method is not present
   * for example if refresh is called and is not available on the component instance, then refreshComponent on this
   * class will be invoked instead
   *
   * Currently only refresh is supported
   */ refreshComponent(args) {
        this.oldPortal = this.portal;
        this.createOrUpdatePortal(args);
        this.portalManager.updateReactPortal(this.oldPortal, this.portal);
    }
    fallbackMethod(name, params) {
        const method = this[`${name}Component`];
        if (!this.suppressFallbackMethods && !!method) return method.bind(this)(params);
    }
    fallbackMethodAvailable(name) {
        if (this.suppressFallbackMethods) return false;
        const method = this[`${name}Component`];
        return !!method;
    }
};
// packages/ag-grid-react/src/shared/customComp/customComponentWrapper.ts
function $0e439ae7301dd858$var$addOptionalMethods(optionalMethodNames, providedMethods, component) {
    optionalMethodNames.forEach((methodName)=>{
        const providedMethod = providedMethods[methodName];
        if (providedMethod) component[methodName] = providedMethod;
    });
}
var $0e439ae7301dd858$var$CustomComponentWrapper = class extends $0e439ae7301dd858$var$ReactComponent {
    constructor(){
        super(...arguments);
        this.awaitUpdateCallback = new (0, $jIDNV.AgPromise)((resolve)=>{
            this.resolveUpdateCallback = resolve;
        });
        this.wrapperComponent = $0e439ae7301dd858$var$customWrapperComp_default;
    }
    init(params) {
        this.sourceParams = params;
        return super.init(this.getProps());
    }
    addMethod() {}
    getInstance() {
        return this.instanceCreated.then(()=>this.componentInstance);
    }
    getFrameworkComponentInstance() {
        return this;
    }
    createElement(reactComponent, props) {
        return super.createElement(this.wrapperComponent, {
            initialProps: props,
            CustomComponentClass: reactComponent,
            setMethods: (methods)=>this.setMethods(methods),
            addUpdateCallback: (callback)=>{
                this.updateCallback = ()=>{
                    callback(this.getProps());
                    return new (0, $jIDNV.AgPromise)((resolve)=>{
                        setTimeout(()=>{
                            resolve();
                        });
                    });
                };
                this.resolveUpdateCallback();
            }
        });
    }
    setMethods(methods) {
        this.providedMethods = methods;
        $0e439ae7301dd858$var$addOptionalMethods(this.getOptionalMethods(), this.providedMethods, this);
    }
    getOptionalMethods() {
        return [];
    }
    getProps() {
        return {
            ...this.sourceParams,
            key: this.key,
            ref: this.ref
        };
    }
    refreshProps() {
        if (this.updateCallback) return this.updateCallback();
        return new (0, $jIDNV.AgPromise)((resolve)=>this.awaitUpdateCallback.then(()=>{
                this.updateCallback().then(()=>resolve());
            }));
    }
};
// packages/ag-grid-react/src/shared/customComp/cellRendererComponentWrapper.ts
var $0e439ae7301dd858$var$CellRendererComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
        return true;
    }
};
// packages/ag-grid-react/src/shared/customComp/dateComponentWrapper.ts
var $0e439ae7301dd858$var$DateComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.date = null;
        this.onDateChange = (date)=>this.updateDate(date);
    }
    getDate() {
        return this.date;
    }
    setDate(date) {
        this.date = date;
        this.refreshProps();
    }
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached",
            "setInputPlaceholder",
            "setInputAriaLabel",
            "setDisabled"
        ];
    }
    updateDate(date) {
        this.setDate(date);
        this.sourceParams.onDateChanged();
    }
    getProps() {
        const props = super.getProps();
        props.date = this.date;
        props.onDateChange = this.onDateChange;
        delete props.onDateChanged;
        return props;
    }
};
// packages/ag-grid-react/src/shared/customComp/dragAndDropImageComponentWrapper.ts
var $0e439ae7301dd858$var$DragAndDropImageComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.label = "";
        this.icon = null;
        this.shake = false;
    }
    setIcon(iconName, shake) {
        this.icon = iconName;
        this.shake = shake;
        this.refreshProps();
    }
    setLabel(label) {
        this.label = label;
        this.refreshProps();
    }
    getProps() {
        const props = super.getProps();
        const { label: label, icon: icon, shake: shake } = this;
        props.label = label;
        props.icon = icon;
        props.shake = shake;
        return props;
    }
};
var $0e439ae7301dd858$var$FilterComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.model = null;
        this.onModelChange = (model)=>this.updateModel(model);
        this.onUiChange = ()=>this.sourceParams.filterModifiedCallback();
        this.expectingNewMethods = true;
        this.hasBeenActive = false;
        this.awaitSetMethodsCallback = new (0, $jIDNV.AgPromise)((resolve)=>{
            this.resolveSetMethodsCallback = resolve;
        });
    }
    isFilterActive() {
        return this.model != null;
    }
    doesFilterPass(params) {
        return this.providedMethods.doesFilterPass(params);
    }
    getModel() {
        return this.model;
    }
    setModel(model) {
        this.expectingNewMethods = true;
        this.model = model;
        this.hasBeenActive || (this.hasBeenActive = this.isFilterActive());
        return this.refreshProps();
    }
    refresh(newParams) {
        this.sourceParams = newParams;
        this.refreshProps();
        return true;
    }
    afterGuiAttached(params) {
        const providedMethods = this.providedMethods;
        if (!providedMethods) this.awaitSetMethodsCallback.then(()=>this.providedMethods?.afterGuiAttached?.(params));
        else providedMethods.afterGuiAttached?.(params);
    }
    getOptionalMethods() {
        return [
            "afterGuiDetached",
            "onNewRowsLoaded",
            "getModelAsString",
            "onAnyFilterChanged"
        ];
    }
    setMethods(methods) {
        if (this.expectingNewMethods === false && this.hasBeenActive && this.providedMethods?.doesFilterPass !== methods?.doesFilterPass) setTimeout(()=>{
            this.sourceParams.filterChangedCallback();
        });
        this.expectingNewMethods = false;
        super.setMethods(methods);
        this.resolveSetMethodsCallback();
        this.resolveFilterPassCallback?.();
        this.resolveFilterPassCallback = void 0;
    }
    updateModel(model) {
        this.resolveFilterPassCallback?.();
        const awaitFilterPassCallback = new (0, $jIDNV.AgPromise)((resolve)=>{
            this.resolveFilterPassCallback = resolve;
        });
        this.setModel(model).then(()=>{
            awaitFilterPassCallback.then(()=>{
                this.sourceParams.filterChangedCallback();
            });
        });
    }
    getProps() {
        const props = super.getProps();
        props.model = this.model;
        props.onModelChange = this.onModelChange;
        props.onUiChange = this.onUiChange;
        delete props.filterChangedCallback;
        return props;
    }
};
var $0e439ae7301dd858$var$FilterDisplayComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.awaitSetMethodsCallback = new (0, $jIDNV.AgPromise)((resolve)=>{
            this.resolveSetMethodsCallback = resolve;
        });
    }
    refresh(newParams) {
        this.sourceParams = newParams;
        this.refreshProps();
        return true;
    }
    afterGuiAttached(params) {
        const providedMethods = this.providedMethods;
        if (!providedMethods) this.awaitSetMethodsCallback.then(()=>this.providedMethods?.afterGuiAttached?.(params));
        else providedMethods.afterGuiAttached?.(params);
    }
    getOptionalMethods() {
        return [
            "afterGuiDetached",
            "onNewRowsLoaded",
            "onAnyFilterChanged"
        ];
    }
    setMethods(methods) {
        super.setMethods(methods);
        this.resolveSetMethodsCallback();
    }
};
function $0e439ae7301dd858$var$updateFloatingFilterParent(params, model) {
    params.parentFilterInstance((instance)=>{
        (instance.setModel(model) || (0, $jIDNV.AgPromise).resolve()).then(()=>{
            params.filterParams.filterChangedCallback();
        });
    });
}
var $0e439ae7301dd858$var$FloatingFilterComponentProxy = class {
    constructor(floatingFilterParams, refreshProps){
        this.floatingFilterParams = floatingFilterParams;
        this.refreshProps = refreshProps;
        this.model = null;
        this.onModelChange = (model)=>this.updateModel(model);
    }
    getProps() {
        return {
            ...this.floatingFilterParams,
            model: this.model,
            onModelChange: this.onModelChange
        };
    }
    onParentModelChanged(parentModel) {
        this.model = parentModel;
        this.refreshProps();
    }
    refresh(params) {
        this.floatingFilterParams = params;
        this.refreshProps();
    }
    setMethods(methods) {
        $0e439ae7301dd858$var$addOptionalMethods(this.getOptionalMethods(), methods, this);
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached"
        ];
    }
    updateModel(model) {
        this.model = model;
        this.refreshProps();
        $0e439ae7301dd858$var$updateFloatingFilterParent(this.floatingFilterParams, model);
    }
};
// packages/ag-grid-react/src/shared/customComp/floatingFilterComponentWrapper.ts
var $0e439ae7301dd858$var$FloatingFilterComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.model = null;
        this.onModelChange = (model)=>this.updateModel(model);
    }
    onParentModelChanged(parentModel) {
        this.model = parentModel;
        this.refreshProps();
    }
    refresh(newParams) {
        this.sourceParams = newParams;
        this.refreshProps();
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached"
        ];
    }
    updateModel(model) {
        this.model = model;
        this.refreshProps();
        $0e439ae7301dd858$var$updateFloatingFilterParent(this.sourceParams, model);
    }
    getProps() {
        const props = super.getProps();
        props.model = this.model;
        props.onModelChange = this.onModelChange;
        return props;
    }
};
// packages/ag-grid-react/src/shared/customComp/floatingFilterDisplayComponentWrapper.ts
var $0e439ae7301dd858$var$FloatingFilterDisplayComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    refresh(newParams) {
        this.sourceParams = newParams;
        this.refreshProps();
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached"
        ];
    }
};
// packages/ag-grid-react/src/shared/customComp/innerHeaderComponentWrapper.ts
var $0e439ae7301dd858$var$InnerHeaderComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
        return true;
    }
};
// packages/ag-grid-react/src/shared/customComp/loadingOverlayComponentWrapper.ts
var $0e439ae7301dd858$var$LoadingOverlayComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
    }
};
// packages/ag-grid-react/src/shared/customComp/menuItemComponentWrapper.ts
var $0e439ae7301dd858$var$MenuItemComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.active = false;
        this.expanded = false;
        this.onActiveChange = (active)=>this.updateActive(active);
    }
    setActive(active) {
        this.awaitSetActive(active);
    }
    setExpanded(expanded) {
        this.expanded = expanded;
        this.refreshProps();
    }
    getOptionalMethods() {
        return [
            "select",
            "configureDefaults"
        ];
    }
    awaitSetActive(active) {
        this.active = active;
        return this.refreshProps();
    }
    updateActive(active) {
        const result = this.awaitSetActive(active);
        if (active) result.then(()=>this.sourceParams.onItemActivated());
    }
    getProps() {
        const props = super.getProps();
        props.active = this.active;
        props.expanded = this.expanded;
        props.onActiveChange = this.onActiveChange;
        delete props.onItemActivated;
        return props;
    }
};
// packages/ag-grid-react/src/shared/customComp/noRowsOverlayComponentWrapper.ts
var $0e439ae7301dd858$var$NoRowsOverlayComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
    }
};
// packages/ag-grid-react/src/shared/customComp/statusPanelComponentWrapper.ts
var $0e439ae7301dd858$var$StatusPanelComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
        return true;
    }
};
// packages/ag-grid-react/src/shared/customComp/toolPanelComponentWrapper.ts
var $0e439ae7301dd858$var$ToolPanelComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.onStateChange = (state)=>this.updateState(state);
    }
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
        return true;
    }
    getState() {
        return this.state;
    }
    updateState(state) {
        this.state = state;
        this.refreshProps();
        this.sourceParams.onStateUpdated();
    }
    getProps() {
        const props = super.getProps();
        props.state = this.state;
        props.onStateChange = this.onStateChange;
        return props;
    }
};
function $0e439ae7301dd858$export$8bedcca5bbd73999(wrapperComponent, callback) {
    const promise = wrapperComponent?.getInstance?.() ?? (0, $jIDNV.AgPromise).resolve(void 0);
    promise.then((comp)=>callback(comp));
}
function $0e439ae7301dd858$export$e83e01bcf62967be() {
    (0, $jIDNV._warn)(231);
}
// packages/ag-grid-react/src/shared/portalManager.ts
var $0e439ae7301dd858$var$MAX_COMPONENT_CREATION_TIME_IN_MS = 1e3;
var $0e439ae7301dd858$var$PortalManager = class {
    constructor(refresher, wrappingElement, maxComponentCreationTimeMs){
        this.destroyed = false;
        this.portals = [];
        this.hasPendingPortalUpdate = false;
        this.wrappingElement = wrappingElement ? wrappingElement : "div";
        this.refresher = refresher;
        this.maxComponentCreationTimeMs = maxComponentCreationTimeMs ? maxComponentCreationTimeMs : $0e439ae7301dd858$var$MAX_COMPONENT_CREATION_TIME_IN_MS;
    }
    getPortals() {
        return this.portals;
    }
    destroy() {
        this.destroyed = true;
    }
    destroyPortal(portal) {
        this.portals = this.portals.filter((curPortal)=>curPortal !== portal);
        this.batchUpdate();
    }
    getComponentWrappingElement() {
        return this.wrappingElement;
    }
    mountReactPortal(portal, reactComponent, resolve) {
        this.portals = [
            ...this.portals,
            portal
        ];
        this.waitForInstance(reactComponent, resolve);
        this.batchUpdate();
    }
    updateReactPortal(oldPortal, newPortal) {
        this.portals[this.portals.indexOf(oldPortal)] = newPortal;
        this.batchUpdate();
    }
    batchUpdate() {
        if (this.hasPendingPortalUpdate) return;
        setTimeout(()=>{
            if (!this.destroyed) {
                this.refresher();
                this.hasPendingPortalUpdate = false;
            }
        });
        this.hasPendingPortalUpdate = true;
    }
    waitForInstance(reactComponent, resolve, startTime = Date.now()) {
        if (this.destroyed) {
            resolve(null);
            return;
        }
        if (reactComponent.rendered()) resolve(reactComponent);
        else {
            if (Date.now() - startTime >= this.maxComponentCreationTimeMs && !this.hasPendingPortalUpdate) {
                $0e439ae7301dd858$var$agFlushSync(true, ()=>this.refresher());
                if (reactComponent.rendered()) resolve(reactComponent);
                return;
            }
            window.setTimeout(()=>{
                this.waitForInstance(reactComponent, resolve, startTime);
            });
        }
    }
};
var $0e439ae7301dd858$var$HeaderCellComp = ({ ctrl: ctrl })=>{
    const isAlive = ctrl.isAlive();
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const colId = isAlive ? ctrl.column.getColId() : void 0;
    const [userCompDetails, setUserCompDetails] = (0, $acw62.useState)();
    const [userStyles, setUserStyles] = (0, $acw62.useState)();
    const compBean = (0, $acw62.useRef)();
    const eGui = (0, $acw62.useRef)(null);
    const eResize = (0, $acw62.useRef)(null);
    const eHeaderCompWrapper = (0, $acw62.useRef)(null);
    const userCompRef = (0, $acw62.useRef)();
    const cssManager = (0, $acw62.useRef)();
    if (isAlive && !cssManager.current) cssManager.current = new (0, $jIDNV.CssClassManager)(()=>eGui.current);
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        compBean.current = eRef ? context.createBean(new (0, $jIDNV._EmptyBean)()) : context.destroyBean(compBean.current);
        if (!eRef || !ctrl.isAlive()) return;
        const refreshSelectAllGui = ()=>{
            const selectAllGui = ctrl.getSelectAllGui();
            if (selectAllGui) {
                eResize.current?.insertAdjacentElement("afterend", selectAllGui);
                compBean.current.addDestroyFunc(()=>selectAllGui.remove());
            }
        };
        const compProxy = {
            setWidth: (width)=>{
                if (eGui.current) eGui.current.style.width = width;
            },
            toggleCss: (name, on)=>cssManager.current.toggleCss(name, on),
            setUserStyles: (styles)=>setUserStyles(styles),
            setAriaSort: (sort)=>{
                if (eGui.current) sort ? (0, $jIDNV._setAriaSort)(eGui.current, sort) : (0, $jIDNV._removeAriaSort)(eGui.current);
            },
            setUserCompDetails: (compDetails)=>setUserCompDetails(compDetails),
            getUserCompInstance: ()=>userCompRef.current || void 0,
            refreshSelectAllGui: refreshSelectAllGui,
            removeSelectAllGui: ()=>ctrl.getSelectAllGui()?.remove()
        };
        ctrl.setComp(compProxy, eRef, eResize.current, eHeaderCompWrapper.current, compBean.current);
        refreshSelectAllGui();
    }, []);
    (0, $acw62.useLayoutEffect)(()=>$0e439ae7301dd858$var$showJsComp(userCompDetails, context, eHeaderCompWrapper.current, userCompRef), [
        userCompDetails
    ]);
    (0, $acw62.useEffect)(()=>{
        ctrl.setDragSource(eGui.current);
    }, [
        userCompDetails
    ]);
    const userCompStateless = (0, $acw62.useMemo)(()=>{
        const res = userCompDetails?.componentFromFramework && $0e439ae7301dd858$var$isComponentStateless(userCompDetails.componentClass);
        return !!res;
    }, [
        userCompDetails
    ]);
    const reactUserComp = userCompDetails?.componentFromFramework;
    const UserCompClass = userCompDetails?.componentClass;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        style: userStyles,
        className: "ag-header-cell",
        "col-id": colId,
        role: "columnheader"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eResize,
        className: "ag-header-cell-resize",
        role: "presentation"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eHeaderCompWrapper,
        className: "ag-header-cell-comp-wrapper",
        role: "presentation"
    }, reactUserComp ? userCompStateless ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, {
        ...userCompDetails.params
    }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, {
        ...userCompDetails.params,
        ref: userCompRef
    }) : null));
};
var $0e439ae7301dd858$var$headerCellComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$HeaderCellComp);
// packages/ag-grid-react/src/shared/customComp/floatingFilterDisplayComponentProxy.ts
var $0e439ae7301dd858$var$FloatingFilterDisplayComponentProxy = class {
    constructor(floatingFilterParams, refreshProps){
        this.floatingFilterParams = floatingFilterParams;
        this.refreshProps = refreshProps;
    }
    getProps() {
        return this.floatingFilterParams;
    }
    refresh(params) {
        this.floatingFilterParams = params;
        this.refreshProps();
    }
    setMethods(methods) {
        $0e439ae7301dd858$var$addOptionalMethods(this.getOptionalMethods(), methods, this);
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached"
        ];
    }
};
// packages/ag-grid-react/src/reactUi/header/headerFilterCellComp.tsx
var $0e439ae7301dd858$var$HeaderFilterCellComp = ({ ctrl: ctrl })=>{
    const { context: context, gos: gos } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const [userStyles, setUserStyles] = (0, $acw62.useState)();
    const [cssClasses, setCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses("ag-header-cell", "ag-floating-filter"));
    const [cssBodyClasses, setBodyCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [cssButtonWrapperClasses, setButtonWrapperCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses("ag-floating-filter-button", "ag-hidden"));
    const [buttonWrapperAriaHidden, setButtonWrapperAriaHidden] = (0, $acw62.useState)("false");
    const [userCompDetails, setUserCompDetails] = (0, $acw62.useState)();
    const [, setRenderKey] = (0, $acw62.useState)(1);
    const compBean = (0, $acw62.useRef)();
    const eGui = (0, $acw62.useRef)(null);
    const eFloatingFilterBody = (0, $acw62.useRef)(null);
    const eButtonWrapper = (0, $acw62.useRef)(null);
    const eButtonShowMainFilter = (0, $acw62.useRef)(null);
    const userCompResolve = (0, $acw62.useRef)();
    const userCompPromise = (0, $acw62.useRef)();
    const userCompRef = (value)=>{
        if (value == null) return;
        userCompResolve.current && userCompResolve.current(value);
    };
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        compBean.current = eRef ? context.createBean(new (0, $jIDNV._EmptyBean)()) : context.destroyBean(compBean.current);
        if (!eRef || !ctrl.isAlive()) return;
        userCompPromise.current = new (0, $jIDNV.AgPromise)((resolve)=>{
            userCompResolve.current = resolve;
        });
        const compProxy = {
            toggleCss: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            setUserStyles: (styles)=>setUserStyles(styles),
            addOrRemoveBodyCssClass: (name, on)=>setBodyCssClasses((prev)=>prev.setClass(name, on)),
            setButtonWrapperDisplayed: (displayed)=>{
                setButtonWrapperCssClasses((prev)=>prev.setClass("ag-hidden", !displayed));
                setButtonWrapperAriaHidden(!displayed ? "true" : "false");
            },
            setWidth: (width)=>{
                if (eGui.current) eGui.current.style.width = width;
            },
            setCompDetails: (compDetails)=>setUserCompDetails(compDetails),
            getFloatingFilterComp: ()=>userCompPromise.current ? userCompPromise.current : null,
            setMenuIcon: (eIcon)=>eButtonShowMainFilter.current?.appendChild(eIcon)
        };
        ctrl.setComp(compProxy, eRef, eButtonShowMainFilter.current, eFloatingFilterBody.current, compBean.current);
    }, []);
    (0, $acw62.useLayoutEffect)(()=>$0e439ae7301dd858$var$showJsComp(userCompDetails, context, eFloatingFilterBody.current, userCompRef), [
        userCompDetails
    ]);
    const className = (0, $acw62.useMemo)(()=>cssClasses.toString(), [
        cssClasses
    ]);
    const bodyClassName = (0, $acw62.useMemo)(()=>cssBodyClasses.toString(), [
        cssBodyClasses
    ]);
    const buttonWrapperClassName = (0, $acw62.useMemo)(()=>cssButtonWrapperClasses.toString(), [
        cssButtonWrapperClasses
    ]);
    const userCompStateless = (0, $acw62.useMemo)(()=>{
        const res = userCompDetails && userCompDetails.componentFromFramework && $0e439ae7301dd858$var$isComponentStateless(userCompDetails.componentClass);
        return !!res;
    }, [
        userCompDetails
    ]);
    const reactiveCustomComponents = (0, $acw62.useMemo)(()=>gos.get("reactiveCustomComponents"), []);
    const enableFilterHandlers = (0, $acw62.useMemo)(()=>gos.get("enableFilterHandlers"), []);
    const [floatingFilterCompProxy, setFloatingFilterCompProxy] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        if (userCompDetails?.componentFromFramework) {
            if (reactiveCustomComponents) {
                const ProxyClass = enableFilterHandlers ? $0e439ae7301dd858$var$FloatingFilterDisplayComponentProxy : $0e439ae7301dd858$var$FloatingFilterComponentProxy;
                const compProxy = new ProxyClass(userCompDetails.params, ()=>setRenderKey((prev)=>prev + 1));
                userCompRef(compProxy);
                setFloatingFilterCompProxy(compProxy);
            } else $0e439ae7301dd858$export$e83e01bcf62967be();
        }
    }, [
        userCompDetails
    ]);
    const floatingFilterProps = floatingFilterCompProxy?.getProps();
    const reactUserComp = userCompDetails?.componentFromFramework;
    const UserCompClass = userCompDetails?.componentClass;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        style: userStyles,
        className: className,
        role: "gridcell"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eFloatingFilterBody,
        className: bodyClassName,
        role: "presentation"
    }, reactUserComp ? reactiveCustomComponents ? floatingFilterProps && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$export$9f6317c67b47ac67.Provider, {
        value: {
            setMethods: (methods)=>floatingFilterCompProxy.setMethods(methods)
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, {
        ...floatingFilterProps
    })) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, {
        ...userCompDetails.params,
        ref: userCompStateless ? ()=>{} : userCompRef
    }) : null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eButtonWrapper,
        "aria-hidden": buttonWrapperAriaHidden,
        className: buttonWrapperClassName,
        role: "presentation"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: eButtonShowMainFilter,
        type: "button",
        className: "ag-button ag-floating-filter-button-button",
        tabIndex: -1
    })));
};
var $0e439ae7301dd858$var$headerFilterCellComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$HeaderFilterCellComp);
var $0e439ae7301dd858$var$HeaderGroupCellComp = ({ ctrl: ctrl })=>{
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const [userStyles, setUserStyles] = (0, $acw62.useState)();
    const [cssClasses, setCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [cssResizableClasses, setResizableCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [resizableAriaHidden, setResizableAriaHidden] = (0, $acw62.useState)("false");
    const [ariaExpanded, setAriaExpanded] = (0, $acw62.useState)();
    const [userCompDetails, setUserCompDetails] = (0, $acw62.useState)();
    const colId = (0, $acw62.useMemo)(()=>ctrl.column.getUniqueId(), []);
    const compBean = (0, $acw62.useRef)();
    const eGui = (0, $acw62.useRef)(null);
    const eResize = (0, $acw62.useRef)(null);
    const eHeaderCompWrapper = (0, $acw62.useRef)(null);
    const userCompRef = (0, $acw62.useRef)();
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        compBean.current = eRef ? context.createBean(new (0, $jIDNV._EmptyBean)()) : context.destroyBean(compBean.current);
        if (!eRef || !ctrl.isAlive()) return;
        const compProxy = {
            setWidth: (width)=>{
                if (eGui.current) eGui.current.style.width = width;
            },
            toggleCss: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            setUserStyles: (styles)=>setUserStyles(styles),
            setHeaderWrapperHidden: (hidden)=>{
                const headerCompWrapper = eHeaderCompWrapper.current;
                if (!headerCompWrapper) return;
                if (hidden) headerCompWrapper.style.setProperty("display", "none");
                else headerCompWrapper.style.removeProperty("display");
            },
            setHeaderWrapperMaxHeight: (value)=>{
                const headerCompWrapper = eHeaderCompWrapper.current;
                if (!headerCompWrapper) return;
                if (value != null) headerCompWrapper.style.setProperty("max-height", `${value}px`);
                else headerCompWrapper.style.removeProperty("max-height");
                headerCompWrapper.classList.toggle("ag-header-cell-comp-wrapper-limited-height", value != null);
            },
            setUserCompDetails: (compDetails)=>setUserCompDetails(compDetails),
            setResizableDisplayed: (displayed)=>{
                setResizableCssClasses((prev)=>prev.setClass("ag-hidden", !displayed));
                setResizableAriaHidden(!displayed ? "true" : "false");
            },
            setAriaExpanded: (expanded)=>setAriaExpanded(expanded),
            getUserCompInstance: ()=>userCompRef.current || void 0
        };
        ctrl.setComp(compProxy, eRef, eResize.current, eHeaderCompWrapper.current, compBean.current);
    }, []);
    (0, $acw62.useLayoutEffect)(()=>$0e439ae7301dd858$var$showJsComp(userCompDetails, context, eHeaderCompWrapper.current), [
        userCompDetails
    ]);
    (0, $acw62.useEffect)(()=>{
        if (eGui.current) ctrl.setDragSource(eGui.current);
    }, [
        userCompDetails
    ]);
    const userCompStateless = (0, $acw62.useMemo)(()=>{
        const res = userCompDetails?.componentFromFramework && $0e439ae7301dd858$var$isComponentStateless(userCompDetails.componentClass);
        return !!res;
    }, [
        userCompDetails
    ]);
    const className = (0, $acw62.useMemo)(()=>"ag-header-group-cell " + cssClasses.toString(), [
        cssClasses
    ]);
    const resizableClassName = (0, $acw62.useMemo)(()=>"ag-header-cell-resize " + cssResizableClasses.toString(), [
        cssResizableClasses
    ]);
    const reactUserComp = userCompDetails?.componentFromFramework;
    const UserCompClass = userCompDetails?.componentClass;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        style: userStyles,
        className: className,
        "col-id": colId,
        role: "columnheader",
        "aria-expanded": ariaExpanded
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eHeaderCompWrapper,
        className: "ag-header-cell-comp-wrapper",
        role: "presentation"
    }, reactUserComp ? userCompStateless ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, {
        ...userCompDetails.params
    }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, {
        ...userCompDetails.params,
        ref: userCompRef
    }) : null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eResize,
        "aria-hidden": resizableAriaHidden,
        className: resizableClassName
    }));
};
var $0e439ae7301dd858$var$headerGroupCellComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$HeaderGroupCellComp);
// packages/ag-grid-react/src/reactUi/header/headerRowComp.tsx
var $0e439ae7301dd858$var$HeaderRowComp = ({ ctrl: ctrl })=>{
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const { topOffset: topOffset, rowHeight: rowHeight } = (0, $acw62.useMemo)(()=>ctrl.getTopAndHeight(), []);
    const [ariaRowIndex, setAriaRowIndex] = (0, $acw62.useState)(()=>ctrl.getAriaRowIndex());
    const className = ctrl.headerRowClass;
    const [height, setHeight] = (0, $acw62.useState)(()=>rowHeight + "px");
    const [top, setTop] = (0, $acw62.useState)(()=>topOffset + "px");
    const cellCtrlsRef = (0, $acw62.useRef)(null);
    const [cellCtrls, setCellCtrls] = (0, $acw62.useState)(()=>ctrl.getUpdatedHeaderCtrls());
    const compBean = (0, $acw62.useRef)();
    const eGui = (0, $acw62.useRef)(null);
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        compBean.current = eRef ? context.createBean(new (0, $jIDNV._EmptyBean)()) : context.destroyBean(compBean.current);
        if (!eRef) return;
        const compProxy = {
            setHeight: (height2)=>setHeight(height2),
            setTop: (top2)=>setTop(top2),
            setHeaderCtrls: (ctrls, forceOrder, afterScroll)=>{
                const prevCellCtrls = cellCtrlsRef.current;
                const nextCells = $0e439ae7301dd858$var$getNextValueIfDifferent(prevCellCtrls, ctrls, forceOrder);
                if (nextCells !== prevCellCtrls) {
                    cellCtrlsRef.current = nextCells;
                    $0e439ae7301dd858$var$agFlushSync(afterScroll, ()=>setCellCtrls(nextCells));
                }
            },
            setWidth: (width)=>{
                if (eGui.current) eGui.current.style.width = width;
            },
            setRowIndex: (rowIndex)=>{
                setAriaRowIndex(rowIndex);
            }
        };
        ctrl.setComp(compProxy, compBean.current, false);
    }, []);
    const style = (0, $acw62.useMemo)(()=>({
            height: height,
            top: top
        }), [
        height,
        top
    ]);
    const createCellJsx = (0, $acw62.useCallback)((cellCtrl)=>{
        switch(ctrl.type){
            case "group":
                return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerGroupCellComp_default, {
                    ctrl: cellCtrl,
                    key: cellCtrl.instanceId
                });
            case "filter":
                return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerFilterCellComp_default, {
                    ctrl: cellCtrl,
                    key: cellCtrl.instanceId
                });
            default:
                return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerCellComp_default, {
                    ctrl: cellCtrl,
                    key: cellCtrl.instanceId
                });
        }
    }, []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: className,
        role: "row",
        style: style,
        "aria-rowindex": ariaRowIndex
    }, cellCtrls.map(createCellJsx));
};
var $0e439ae7301dd858$var$headerRowComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$HeaderRowComp);
// packages/ag-grid-react/src/reactUi/header/headerRowContainerComp.tsx
var $0e439ae7301dd858$var$HeaderRowContainerComp = ({ pinned: pinned })=>{
    const [displayed, setDisplayed] = (0, $acw62.useState)(true);
    const [headerRowCtrls, setHeaderRowCtrls] = (0, $acw62.useState)([]);
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const eGui = (0, $acw62.useRef)(null);
    const eCenterContainer = (0, $acw62.useRef)(null);
    const headerRowCtrlRef = (0, $acw62.useRef)();
    const pinnedLeft = pinned === "left";
    const pinnedRight = pinned === "right";
    const centre = !pinnedLeft && !pinnedRight;
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        headerRowCtrlRef.current = eRef ? context.createBean(new (0, $jIDNV.HeaderRowContainerCtrl)(pinned)) : context.destroyBean(headerRowCtrlRef.current);
        if (!eRef) return;
        const compProxy = {
            setDisplayed: setDisplayed,
            setCtrls: (ctrls)=>setHeaderRowCtrls(ctrls),
            // centre only
            setCenterWidth: (width)=>{
                if (eCenterContainer.current) eCenterContainer.current.style.width = width;
            },
            setViewportScrollLeft: (left)=>{
                if (eGui.current) eGui.current.scrollLeft = left;
            },
            // pinned only
            setPinnedContainerWidth: (width)=>{
                if (eGui.current) {
                    eGui.current.style.width = width;
                    eGui.current.style.minWidth = width;
                    eGui.current.style.maxWidth = width;
                }
            }
        };
        headerRowCtrlRef.current.setComp(compProxy, eGui.current);
    }, []);
    const className = !displayed ? "ag-hidden" : "";
    const insertRowsJsx = ()=>headerRowCtrls.map((ctrl)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerRowComp_default, {
                ctrl: ctrl,
                key: ctrl.instanceId
            }));
    return pinnedLeft ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: "ag-pinned-left-header " + className,
        "aria-hidden": !displayed,
        role: "rowgroup"
    }, insertRowsJsx()) : pinnedRight ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: "ag-pinned-right-header " + className,
        "aria-hidden": !displayed,
        role: "rowgroup"
    }, insertRowsJsx()) : centre ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: "ag-header-viewport " + className,
        role: "presentation",
        tabIndex: -1
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eCenterContainer,
        className: "ag-header-container",
        role: "rowgroup"
    }, insertRowsJsx())) : null;
};
var $0e439ae7301dd858$var$headerRowContainerComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$HeaderRowContainerComp);
// packages/ag-grid-react/src/reactUi/header/gridHeaderComp.tsx
var $0e439ae7301dd858$var$GridHeaderComp = ()=>{
    const [cssClasses, setCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [height, setHeight] = (0, $acw62.useState)();
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const eGui = (0, $acw62.useRef)(null);
    const gridCtrlRef = (0, $acw62.useRef)();
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        gridCtrlRef.current = eRef ? context.createBean(new (0, $jIDNV.GridHeaderCtrl)()) : context.destroyBean(gridCtrlRef.current);
        if (!eRef) return;
        const compProxy = {
            toggleCss: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            setHeightAndMinHeight: (height2)=>setHeight(height2)
        };
        gridCtrlRef.current.setComp(compProxy, eRef, eRef);
    }, []);
    const className = (0, $acw62.useMemo)(()=>{
        const res = cssClasses.toString();
        return "ag-header " + res;
    }, [
        cssClasses
    ]);
    const style = (0, $acw62.useMemo)(()=>({
            height: height,
            minHeight: height
        }), [
        height
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: className,
        style: style,
        role: "presentation"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerRowContainerComp_default, {
        pinned: "left"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerRowContainerComp_default, {
        pinned: null
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerRowContainerComp_default, {
        pinned: "right"
    }));
};
var $0e439ae7301dd858$var$gridHeaderComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$GridHeaderComp);
var $0e439ae7301dd858$var$useReactCommentEffect = (comment, eForCommentRef)=>{
    (0, $acw62.useEffect)(()=>{
        const eForComment = eForCommentRef.current;
        if (eForComment) {
            const eParent = eForComment.parentElement;
            if (eParent) {
                const eComment = document.createComment(comment);
                eParent.insertBefore(eComment, eForComment);
                return ()=>{
                    eParent.removeChild(eComment);
                };
            }
        }
    }, [
        comment
    ]);
};
var $0e439ae7301dd858$var$reactComment_default = $0e439ae7301dd858$var$useReactCommentEffect;
var $0e439ae7301dd858$var$CellEditorComponentProxy = class {
    constructor(cellEditorParams, refreshProps){
        this.cellEditorParams = cellEditorParams;
        this.refreshProps = refreshProps;
        this.instanceCreated = new (0, $jIDNV.AgPromise)((resolve)=>{
            this.resolveInstanceCreated = resolve;
        });
        this.onValueChange = (value)=>this.updateValue(value);
        this.value = cellEditorParams.value;
    }
    getProps() {
        return {
            ...this.cellEditorParams,
            initialValue: this.cellEditorParams.value,
            value: this.value,
            onValueChange: this.onValueChange
        };
    }
    getValue() {
        return this.value;
    }
    refresh(params) {
        this.cellEditorParams = params;
        this.refreshProps();
    }
    setMethods(methods) {
        $0e439ae7301dd858$var$addOptionalMethods(this.getOptionalMethods(), methods, this);
    }
    getInstance() {
        return this.instanceCreated.then(()=>this.componentInstance);
    }
    setRef(componentInstance) {
        this.componentInstance = componentInstance;
        this.resolveInstanceCreated?.();
        this.resolveInstanceCreated = void 0;
    }
    getOptionalMethods() {
        return [
            "isCancelBeforeStart",
            "isCancelAfterEnd",
            "focusIn",
            "focusOut",
            "afterGuiAttached",
            "getValidationErrors",
            "getValidationElement"
        ];
    }
    updateValue(value) {
        this.value = value;
        this.refreshProps();
    }
};
var $0e439ae7301dd858$var$useEffectOnce = (effect)=>{
    const effectFn = (0, $acw62.useRef)(effect);
    const destroyFn = (0, $acw62.useRef)();
    const effectCalled = (0, $acw62.useRef)(false);
    const rendered = (0, $acw62.useRef)(false);
    const [, setVal] = (0, $acw62.useState)(0);
    if (effectCalled.current) rendered.current = true;
    (0, $acw62.useEffect)(()=>{
        if (!effectCalled.current) {
            destroyFn.current = effectFn.current();
            effectCalled.current = true;
        }
        setVal((val)=>val + 1);
        return ()=>{
            if (!rendered.current) return;
            destroyFn.current?.();
        };
    }, []);
};
// packages/ag-grid-react/src/reactUi/cells/popupEditorComp.tsx
var $0e439ae7301dd858$var$PopupEditorComp = (props)=>{
    const [popupEditorWrapper, setPopupEditorWrapper] = (0, $acw62.useState)();
    const beans = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const { context: context, popupSvc: popupSvc, gos: gos, editSvc: editSvc } = beans;
    const { editDetails: editDetails, cellCtrl: cellCtrl, eParentCell: eParentCell } = props;
    $0e439ae7301dd858$var$useEffectOnce(()=>{
        const { compDetails: compDetails } = editDetails;
        const useModelPopup = gos.get("stopEditingWhenCellsLoseFocus");
        const wrapper = context.createBean(editSvc.createPopupEditorWrapper(compDetails.params));
        const ePopupGui = wrapper.getGui();
        if (props.jsChildComp) {
            const eChildGui = props.jsChildComp.getGui();
            if (eChildGui) ePopupGui.appendChild(eChildGui);
        }
        const { column: column, rowNode: rowNode } = cellCtrl;
        const positionParams = {
            column: column,
            rowNode: rowNode,
            type: "popupCellEditor",
            eventSource: eParentCell,
            ePopup: ePopupGui,
            position: editDetails.popupPosition,
            keepWithinBounds: true
        };
        const positionCallback = popupSvc?.positionPopupByComponent.bind(popupSvc, positionParams);
        const addPopupRes = popupSvc?.addPopup({
            modal: useModelPopup,
            eChild: ePopupGui,
            closeOnEsc: true,
            closedCallback: ()=>{
                cellCtrl.onPopupEditorClosed();
            },
            anchorToElement: eParentCell,
            positionCallback: positionCallback,
            ariaOwns: eParentCell
        });
        const hideEditorPopup = addPopupRes ? addPopupRes.hideFunc : void 0;
        setPopupEditorWrapper(wrapper);
        props.jsChildComp?.afterGuiAttached?.();
        return ()=>{
            hideEditorPopup?.();
            context.destroyBean(wrapper);
        };
    });
    (0, $acw62.useLayoutEffect)(()=>{
        return ()=>{
            if (cellCtrl.isCellFocused() && popupEditorWrapper?.getGui().contains((0, $jIDNV._getActiveDomElement)(beans))) eParentCell.focus({
                preventScroll: true
            });
        };
    }, [
        popupEditorWrapper
    ]);
    return popupEditorWrapper && props.wrappedContent ? (0, $1u0KT.createPortal)(props.wrappedContent, popupEditorWrapper.getGui()) : null;
};
var $0e439ae7301dd858$var$popupEditorComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$PopupEditorComp);
// packages/ag-grid-react/src/reactUi/cells/cellEditorComp.tsx
var $0e439ae7301dd858$var$jsxEditorProxy = (editDetails, CellEditorClass, setRef2)=>{
    const { compProxy: compProxy } = editDetails;
    setRef2(compProxy);
    const props = compProxy.getProps();
    const isStateless = $0e439ae7301dd858$var$isComponentStateless(CellEditorClass);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$export$9f6317c67b47ac67.Provider, {
        value: {
            setMethods: (methods)=>compProxy.setMethods(methods)
        }
    }, isStateless ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellEditorClass, {
        ...props
    }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellEditorClass, {
        ...props,
        ref: (ref)=>compProxy.setRef(ref)
    }));
};
var $0e439ae7301dd858$var$jsxEditor = (editDetails, CellEditorClass, setRef2)=>{
    const newFormat = editDetails.compProxy;
    return newFormat ? $0e439ae7301dd858$var$jsxEditorProxy(editDetails, CellEditorClass, setRef2) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellEditorClass, {
        ...editDetails.compDetails.params,
        ref: setRef2
    });
};
var $0e439ae7301dd858$var$jsxEditValue = (editDetails, setCellEditorRef, eGui, cellCtrl, jsEditorComp)=>{
    const compDetails = editDetails.compDetails;
    const CellEditorClass = compDetails.componentClass;
    const reactInlineEditor = compDetails.componentFromFramework && !editDetails.popup;
    const reactPopupEditor = compDetails.componentFromFramework && editDetails.popup;
    const jsPopupEditor = !compDetails.componentFromFramework && editDetails.popup;
    return reactInlineEditor ? $0e439ae7301dd858$var$jsxEditor(editDetails, CellEditorClass, setCellEditorRef) : reactPopupEditor ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$popupEditorComp_default, {
        editDetails: editDetails,
        cellCtrl: cellCtrl,
        eParentCell: eGui,
        wrappedContent: $0e439ae7301dd858$var$jsxEditor(editDetails, CellEditorClass, setCellEditorRef)
    }) : jsPopupEditor && jsEditorComp ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$popupEditorComp_default, {
        editDetails: editDetails,
        cellCtrl: cellCtrl,
        eParentCell: eGui,
        jsChildComp: jsEditorComp
    }) : null;
};
var $0e439ae7301dd858$var$useJsCellRenderer = (showDetails, showTools, eCellValue, cellValueVersion, jsCellRendererRef, eGui)=>{
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const destroyCellRenderer = (0, $acw62.useCallback)(()=>{
        const comp = jsCellRendererRef.current;
        if (!comp) return;
        const compGui = comp.getGui();
        if (compGui && compGui.parentElement) compGui.parentElement.removeChild(compGui);
        context.destroyBean(comp);
        jsCellRendererRef.current = void 0;
    }, []);
    (0, $acw62.useEffect)(()=>{
        const showValue = showDetails != null;
        const jsCompDetails = showDetails?.compDetails && !showDetails.compDetails.componentFromFramework;
        const waitingForToolsSetup = showTools && eCellValue == null;
        const showComp = showValue && jsCompDetails && !waitingForToolsSetup;
        if (!showComp) {
            destroyCellRenderer();
            return;
        }
        const compDetails = showDetails.compDetails;
        if (jsCellRendererRef.current) {
            const comp = jsCellRendererRef.current;
            const attemptRefresh = comp.refresh != null && showDetails.force == false;
            const refreshResult = attemptRefresh ? comp.refresh(compDetails.params) : false;
            const refreshWorked = refreshResult === true || refreshResult === void 0;
            if (refreshWorked) return;
            destroyCellRenderer();
        }
        const promise = compDetails.newAgStackInstance();
        promise.then((comp)=>{
            if (!comp) return;
            const compGui = comp.getGui();
            if (!compGui) return;
            const parent = showTools ? eCellValue : eGui.current;
            parent.appendChild(compGui);
            jsCellRendererRef.current = comp;
        });
    }, [
        showDetails,
        showTools,
        cellValueVersion
    ]);
    (0, $acw62.useEffect)(()=>{
        return destroyCellRenderer;
    }, []);
};
var $0e439ae7301dd858$var$showJsRenderer_default = $0e439ae7301dd858$var$useJsCellRenderer;
var $0e439ae7301dd858$var$SkeletonCellRenderer = ({ cellCtrl: cellCtrl, parent: parent })=>{
    const jsCellRendererRef = (0, $acw62.useRef)();
    const renderDetails = (0, $acw62.useMemo)(()=>{
        const { loadingComp: loadingComp } = cellCtrl.getDeferLoadingCellRenderer();
        return loadingComp ? {
            value: void 0,
            compDetails: loadingComp,
            force: false
        } : void 0;
    }, [
        cellCtrl
    ]);
    $0e439ae7301dd858$var$showJsRenderer_default(renderDetails, false, void 0, 1, jsCellRendererRef, parent);
    if (renderDetails?.compDetails?.componentFromFramework) {
        const CellRendererClass = renderDetails.compDetails.componentClass;
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellRendererClass, {
            ...renderDetails.compDetails.params
        });
    }
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
};
// packages/ag-grid-react/src/reactUi/cells/cellComp.tsx
var $0e439ae7301dd858$var$CellComp = ({ cellCtrl: cellCtrl, printLayout: printLayout, editingCell: editingCell })=>{
    const beans = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const { context: context } = beans;
    const { column: { colIdSanitised: colIdSanitised }, instanceId: instanceId } = cellCtrl;
    const compBean = (0, $acw62.useRef)();
    const [renderDetails, setRenderDetails] = (0, $acw62.useState)(()=>cellCtrl.isCellRenderer() ? void 0 : {
            compDetails: void 0,
            value: cellCtrl.getValueToDisplay(),
            force: false
        });
    const [editDetails, setEditDetails] = (0, $acw62.useState)();
    const [renderKey, setRenderKey] = (0, $acw62.useState)(1);
    const [userStyles, setUserStyles] = (0, $acw62.useState)();
    const [includeSelection, setIncludeSelection] = (0, $acw62.useState)(false);
    const [includeRowDrag, setIncludeRowDrag] = (0, $acw62.useState)(false);
    const [includeDndSource, setIncludeDndSource] = (0, $acw62.useState)(false);
    const [jsEditorComp, setJsEditorComp] = (0, $acw62.useState)();
    const forceWrapper = (0, $acw62.useMemo)(()=>cellCtrl.isForceWrapper(), [
        cellCtrl
    ]);
    const cellAriaRole = (0, $acw62.useMemo)(()=>cellCtrl.getCellAriaRole(), [
        cellCtrl
    ]);
    const eGui = (0, $acw62.useRef)(null);
    const eWrapper = (0, $acw62.useRef)(null);
    const cellRendererRef = (0, $acw62.useRef)(null);
    const jsCellRendererRef = (0, $acw62.useRef)();
    const cellEditorRef = (0, $acw62.useRef)();
    const eCellWrapper = (0, $acw62.useRef)();
    const cellWrapperDestroyFuncs = (0, $acw62.useRef)([]);
    const eCellValue = (0, $acw62.useRef)();
    const [cellValueVersion, setCellValueVersion] = (0, $acw62.useState)(0);
    const setCellValueRef = (0, $acw62.useCallback)((ref)=>{
        eCellValue.current = ref;
        setCellValueVersion((v)=>v + 1);
    }, []);
    const showTools = renderDetails != null && (includeSelection || includeDndSource || includeRowDrag) && (editDetails == null || !!editDetails.popup);
    const showCellWrapper = forceWrapper || showTools;
    const setCellEditorRef = (0, $acw62.useCallback)((cellEditor)=>{
        cellEditorRef.current = cellEditor;
        if (cellEditor) {
            const editingCancelledByUserComp = cellEditor.isCancelBeforeStart && cellEditor.isCancelBeforeStart();
            setTimeout(()=>{
                if (editingCancelledByUserComp) {
                    cellCtrl.stopEditing(true);
                    cellCtrl.focusCell(true);
                } else {
                    cellCtrl.cellEditorAttached();
                    cellCtrl.enableEditorTooltipFeature(cellEditor);
                }
            });
        }
    }, [
        cellCtrl
    ]);
    const cssManager = (0, $acw62.useRef)();
    if (!cssManager.current) cssManager.current = new (0, $jIDNV.CssClassManager)(()=>eGui.current);
    $0e439ae7301dd858$var$showJsRenderer_default(renderDetails, showCellWrapper, eCellValue.current, cellValueVersion, jsCellRendererRef, eGui);
    const lastRenderDetails = (0, $acw62.useRef)();
    (0, $acw62.useLayoutEffect)(()=>{
        const oldDetails = lastRenderDetails.current;
        const newDetails = renderDetails;
        lastRenderDetails.current = renderDetails;
        if (oldDetails == null || oldDetails.compDetails == null || newDetails == null || newDetails.compDetails == null) return;
        const oldCompDetails = oldDetails.compDetails;
        const newCompDetails = newDetails.compDetails;
        if (oldCompDetails.componentClass != newCompDetails.componentClass) return;
        if (cellRendererRef.current?.refresh == null) return;
        const result = cellRendererRef.current.refresh(newCompDetails.params);
        if (result != true) setRenderKey((prev)=>prev + 1);
    }, [
        renderDetails
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        const doingJsEditor = editDetails && !editDetails.compDetails.componentFromFramework;
        if (!doingJsEditor) return;
        const compDetails = editDetails.compDetails;
        const isPopup = editDetails.popup === true;
        const cellEditorPromise = compDetails.newAgStackInstance();
        cellEditorPromise.then((cellEditor)=>{
            if (!cellEditor) return;
            const compGui = cellEditor.getGui();
            setCellEditorRef(cellEditor);
            if (!isPopup) {
                const parentEl = (forceWrapper ? eCellWrapper : eGui).current;
                parentEl?.appendChild(compGui);
                cellEditor.afterGuiAttached && cellEditor.afterGuiAttached();
            }
            setJsEditorComp(cellEditor);
        });
        return ()=>{
            cellEditorPromise.then((cellEditor)=>{
                const compGui = cellEditor.getGui();
                cellCtrl.disableEditorTooltipFeature();
                context.destroyBean(cellEditor);
                setCellEditorRef(void 0);
                setJsEditorComp(void 0);
                compGui?.parentElement?.removeChild(compGui);
            });
        };
    }, [
        editDetails
    ]);
    const setCellWrapperRef = (0, $acw62.useCallback)((eRef)=>{
        eCellWrapper.current = eRef;
        if (!eRef) {
            cellWrapperDestroyFuncs.current.forEach((f)=>f());
            cellWrapperDestroyFuncs.current = [];
            return;
        }
        const addComp = (comp)=>{
            if (comp) {
                const eGui2 = comp.getGui();
                eRef.insertAdjacentElement("afterbegin", eGui2);
                cellWrapperDestroyFuncs.current.push(()=>{
                    context.destroyBean(comp);
                    (0, $jIDNV._removeFromParent)(eGui2);
                });
            }
            return comp;
        };
        if (includeSelection) {
            const checkboxSelectionComp = cellCtrl.createSelectionCheckbox();
            addComp(checkboxSelectionComp);
        }
        if (includeDndSource) addComp(cellCtrl.createDndSource());
        if (includeRowDrag) addComp(cellCtrl.createRowDragComp());
    }, [
        cellCtrl,
        context,
        includeDndSource,
        includeRowDrag,
        includeSelection
    ]);
    const init = (0, $acw62.useCallback)(()=>{
        const spanReady = !cellCtrl.isCellSpanning() || eWrapper.current;
        const eRef = eGui.current;
        compBean.current = eRef ? context.createBean(new (0, $jIDNV._EmptyBean)()) : context.destroyBean(compBean.current);
        if (!eRef || !spanReady || !cellCtrl) return;
        const compProxy = {
            toggleCss: (name, on)=>cssManager.current.toggleCss(name, on),
            setUserStyles: (styles)=>setUserStyles(styles),
            getFocusableElement: ()=>eGui.current,
            setIncludeSelection: (include)=>setIncludeSelection(include),
            setIncludeRowDrag: (include)=>setIncludeRowDrag(include),
            setIncludeDndSource: (include)=>setIncludeDndSource(include),
            getCellEditor: ()=>cellEditorRef.current || null,
            getCellRenderer: ()=>cellRendererRef.current ?? jsCellRendererRef.current,
            getParentOfValue: ()=>eCellValue.current ?? eCellWrapper.current ?? eGui.current,
            setRenderDetails: (compDetails, value, force)=>{
                const setDetails = ()=>{
                    setRenderDetails((prev)=>{
                        if (prev?.compDetails !== compDetails || prev?.value !== value || prev?.force !== force) return {
                            value: value,
                            compDetails: compDetails,
                            force: force
                        };
                        else return prev;
                    });
                };
                if (compDetails?.params?.deferRender && !cellCtrl.rowNode.group) {
                    const { loadingComp: loadingComp, onReady: onReady } = cellCtrl.getDeferLoadingCellRenderer();
                    if (loadingComp) {
                        setRenderDetails({
                            value: void 0,
                            compDetails: loadingComp,
                            force: false
                        });
                        onReady.then(()=>$0e439ae7301dd858$var$agStartTransition(setDetails));
                        return;
                    }
                }
                setDetails();
            },
            setEditDetails: (compDetails, popup, popupPosition, reactiveCustomComponents)=>{
                if (compDetails) {
                    let compProxy2 = void 0;
                    if (compDetails.componentFromFramework) {
                        if (reactiveCustomComponents) compProxy2 = new $0e439ae7301dd858$var$CellEditorComponentProxy(compDetails.params, ()=>setRenderKey((prev)=>prev + 1));
                        else $0e439ae7301dd858$export$e83e01bcf62967be();
                    }
                    setEditDetails({
                        compDetails: compDetails,
                        popup: popup,
                        popupPosition: popupPosition,
                        compProxy: compProxy2
                    });
                    if (!popup) setRenderDetails(void 0);
                } else {
                    const recoverFocus = cellCtrl.hasBrowserFocus();
                    if (recoverFocus) compProxy.getFocusableElement().focus({
                        preventScroll: true
                    });
                    setEditDetails((editDetails2)=>{
                        if (editDetails2?.compProxy) cellEditorRef.current = void 0;
                        return void 0;
                    });
                }
            },
            refreshEditStyles: (editing, isPopup)=>{
                if (!eGui.current) return;
                const { current: current } = cssManager;
                current.toggleCss("ag-cell-value", !showCellWrapper);
                current.toggleCss("ag-cell-inline-editing", !!editing && !isPopup);
                current.toggleCss("ag-cell-popup-editing", !!editing && !!isPopup);
                current.toggleCss("ag-cell-not-inline-editing", !editing || !!isPopup);
            }
        };
        const cellWrapperOrUndefined = eCellWrapper.current || void 0;
        cellCtrl.setComp(compProxy, eRef, eWrapper.current ?? void 0, cellWrapperOrUndefined, printLayout, editingCell, compBean.current);
    }, []);
    const setGuiRef = (0, $acw62.useCallback)((ref)=>{
        eGui.current = ref;
        init();
    }, []);
    const setWrapperRef = (0, $acw62.useCallback)((ref)=>{
        eWrapper.current = ref;
        init();
    }, []);
    const reactCellRendererStateless = (0, $acw62.useMemo)(()=>{
        const res = renderDetails?.compDetails?.componentFromFramework && $0e439ae7301dd858$var$isComponentStateless(renderDetails.compDetails.componentClass);
        return !!res;
    }, [
        renderDetails
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        if (!eGui.current) return;
        const { current: current } = cssManager;
        current.toggleCss("ag-cell-value", !showCellWrapper);
        current.toggleCss("ag-cell-inline-editing", !!editDetails && !editDetails.popup);
        current.toggleCss("ag-cell-popup-editing", !!editDetails && !!editDetails.popup);
        current.toggleCss("ag-cell-not-inline-editing", !editDetails || !!editDetails.popup);
    });
    const valueOrCellComp = ()=>{
        const { compDetails: compDetails, value: value } = renderDetails;
        if (!compDetails) return value?.toString?.() ?? value;
        if (compDetails.componentFromFramework) {
            const CellRendererClass = compDetails.componentClass;
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Suspense), {
                fallback: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$SkeletonCellRenderer, {
                    cellCtrl: cellCtrl,
                    parent: eGui
                })
            }, reactCellRendererStateless ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellRendererClass, {
                ...compDetails.params,
                key: renderKey
            }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellRendererClass, {
                ...compDetails.params,
                key: renderKey,
                ref: cellRendererRef
            }));
        }
    };
    const showCellOrEditor = ()=>{
        const showCellValue = ()=>{
            if (renderDetails == null) return null;
            return showCellWrapper ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                role: "presentation",
                id: `cell-${instanceId}`,
                className: "ag-cell-value",
                ref: setCellValueRef
            }, valueOrCellComp()) : valueOrCellComp();
        };
        const showEditValue = (details)=>$0e439ae7301dd858$var$jsxEditValue(details, setCellEditorRef, eGui.current, cellCtrl, jsEditorComp);
        if (editDetails != null) {
            if (editDetails.popup) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, showCellValue(), showEditValue(editDetails));
            return showEditValue(editDetails);
        }
        return showCellValue();
    };
    const renderCell = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: setGuiRef,
            style: userStyles,
            role: cellAriaRole,
            "col-id": colIdSanitised
        }, showCellWrapper ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ag-cell-wrapper",
            role: "presentation",
            ref: setCellWrapperRef
        }, showCellOrEditor()) : showCellOrEditor());
    if (cellCtrl.isCellSpanning()) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setWrapperRef,
        className: "ag-spanned-cell-wrapper",
        role: "presentation"
    }, renderCell());
    return renderCell();
};
var $0e439ae7301dd858$var$cellComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$CellComp);
// packages/ag-grid-react/src/reactUi/rows/rowComp.tsx
var $0e439ae7301dd858$var$RowComp = ({ rowCtrl: rowCtrl, containerType: containerType })=>{
    const { context: context, gos: gos, editSvc: editSvc } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const enableUses = (0, $acw62.useContext)($0e439ae7301dd858$var$RenderModeContext) === "default";
    const compBean = (0, $acw62.useRef)();
    const domOrderRef = (0, $acw62.useRef)(rowCtrl.getDomOrder());
    const isFullWidth = rowCtrl.isFullWidth();
    const isDisplayed = rowCtrl.rowNode.displayed;
    const [rowIndex, setRowIndex] = (0, $acw62.useState)(()=>isDisplayed ? rowCtrl.rowNode.getRowIndexString() : null);
    const [rowId, setRowId] = (0, $acw62.useState)(()=>rowCtrl.rowId);
    const [rowBusinessKey, setRowBusinessKey] = (0, $acw62.useState)(()=>rowCtrl.businessKey);
    const [userStyles, setUserStyles] = (0, $acw62.useState)(()=>rowCtrl.rowStyles);
    const cellCtrlsRef = (0, $acw62.useRef)(null);
    const [cellCtrlsFlushSync, setCellCtrlsFlushSync] = (0, $acw62.useState)(()=>null);
    const [fullWidthCompDetails, setFullWidthCompDetails] = (0, $acw62.useState)();
    const [top, setTop] = (0, $acw62.useState)(()=>isDisplayed ? rowCtrl.getInitialRowTop(containerType) : void 0);
    const [transform, setTransform] = (0, $acw62.useState)(()=>isDisplayed ? rowCtrl.getInitialTransform(containerType) : void 0);
    const eGui = (0, $acw62.useRef)(null);
    const fullWidthCompRef = (0, $acw62.useRef)();
    const autoHeightSetup = (0, $acw62.useRef)(false);
    const [autoHeightSetupAttempt, setAutoHeightSetupAttempt] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (autoHeightSetup.current || !fullWidthCompDetails || autoHeightSetupAttempt > 10) return;
        const eChild = eGui.current?.firstChild;
        if (eChild) {
            rowCtrl.setupDetailRowAutoHeight(eChild);
            autoHeightSetup.current = true;
        } else setAutoHeightSetupAttempt((prev)=>prev + 1);
    }, [
        fullWidthCompDetails,
        autoHeightSetupAttempt
    ]);
    const cssManager = (0, $acw62.useRef)();
    if (!cssManager.current) cssManager.current = new (0, $jIDNV.CssClassManager)(()=>eGui.current);
    const cellsChanged = (0, $acw62.useRef)(()=>{});
    const sub = (0, $acw62.useCallback)((onStoreChange)=>{
        cellsChanged.current = onStoreChange;
        return ()=>{
            cellsChanged.current = ()=>{};
        };
    }, []);
    const cellCtrlsUses = $0e439ae7301dd858$var$agUseSyncExternalStore(sub, ()=>{
        return cellCtrlsRef.current;
    }, []);
    const cellCtrlsMerged = enableUses ? cellCtrlsUses : cellCtrlsFlushSync;
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        compBean.current = eRef ? context.createBean(new (0, $jIDNV._EmptyBean)()) : context.destroyBean(compBean.current);
        if (!eRef) {
            rowCtrl.unsetComp(containerType);
            return;
        }
        if (!rowCtrl.isAlive()) return;
        const compProxy = {
            setTop: // the rowTop is managed by state, instead of direct style manipulation by rowCtrl (like all the other styles)
            // as we need to have an initial value when it's placed into he DOM for the first time, for animation to work.
            setTop,
            setTransform: setTransform,
            // i found using React for managing classes at the row level was to slow, as modifying classes caused a lot of
            // React code to execute, so avoiding React for managing CSS Classes made the grid go much faster.
            toggleCss: (name, on)=>cssManager.current.toggleCss(name, on),
            setDomOrder: (domOrder)=>domOrderRef.current = domOrder,
            setRowIndex: setRowIndex,
            setRowId: setRowId,
            setRowBusinessKey: setRowBusinessKey,
            setUserStyles: setUserStyles,
            // if we don't maintain the order, then cols will be ripped out and into the dom
            // when cols reordered, which would stop the CSS transitions from working
            setCellCtrls: (next, useFlushSync)=>{
                const prevCellCtrls = cellCtrlsRef.current;
                const nextCells = $0e439ae7301dd858$var$getNextValueIfDifferent(prevCellCtrls, next, domOrderRef.current);
                if (nextCells !== prevCellCtrls) {
                    cellCtrlsRef.current = nextCells;
                    if (enableUses) cellsChanged.current();
                    else $0e439ae7301dd858$var$agFlushSync(useFlushSync, ()=>setCellCtrlsFlushSync(nextCells));
                }
            },
            showFullWidth: (compDetails)=>setFullWidthCompDetails(compDetails),
            getFullWidthCellRenderer: ()=>fullWidthCompRef.current,
            refreshFullWidth: (getUpdatedParams)=>{
                if (canRefreshFullWidthRef.current) {
                    setFullWidthCompDetails((prevFullWidthCompDetails)=>({
                            ...prevFullWidthCompDetails,
                            params: getUpdatedParams()
                        }));
                    return true;
                } else {
                    if (!fullWidthCompRef.current || !fullWidthCompRef.current.refresh) return false;
                    return fullWidthCompRef.current.refresh(getUpdatedParams());
                }
            }
        };
        rowCtrl.setComp(compProxy, eRef, containerType, compBean.current);
    }, []);
    (0, $acw62.useLayoutEffect)(()=>$0e439ae7301dd858$var$showJsComp(fullWidthCompDetails, context, eGui.current, fullWidthCompRef), [
        fullWidthCompDetails
    ]);
    const rowStyles = (0, $acw62.useMemo)(()=>{
        const res = {
            top: top,
            transform: transform
        };
        Object.assign(res, userStyles);
        return res;
    }, [
        top,
        transform,
        userStyles
    ]);
    const showFullWidthFramework = isFullWidth && fullWidthCompDetails?.componentFromFramework;
    const showCells = !isFullWidth && cellCtrlsMerged != null;
    const reactFullWidthCellRendererStateless = (0, $acw62.useMemo)(()=>{
        const res = fullWidthCompDetails?.componentFromFramework && $0e439ae7301dd858$var$isComponentStateless(fullWidthCompDetails.componentClass);
        return !!res;
    }, [
        fullWidthCompDetails
    ]);
    const canRefreshFullWidthRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        canRefreshFullWidthRef.current = reactFullWidthCellRendererStateless && !!fullWidthCompDetails && !!gos.get("reactiveCustomComponents");
    }, [
        reactFullWidthCellRendererStateless,
        fullWidthCompDetails
    ]);
    const showCellsJsx = ()=>cellCtrlsMerged?.map((cellCtrl)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$cellComp_default, {
                cellCtrl: cellCtrl,
                editingCell: editSvc?.isEditing(cellCtrl, {
                    withOpenEditor: true
                }) ?? false,
                printLayout: rowCtrl.printLayout,
                key: cellCtrl.instanceId
            }));
    const showFullWidthFrameworkJsx = ()=>{
        const FullWidthComp = fullWidthCompDetails.componentClass;
        return reactFullWidthCellRendererStateless ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FullWidthComp, {
            ...fullWidthCompDetails.params
        }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FullWidthComp, {
            ...fullWidthCompDetails.params,
            ref: fullWidthCompRef
        });
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        role: "row",
        style: rowStyles,
        "row-index": rowIndex,
        "row-id": rowId,
        "row-business-key": rowBusinessKey
    }, showCells ? showCellsJsx() : showFullWidthFramework ? showFullWidthFrameworkJsx() : null);
};
var $0e439ae7301dd858$var$rowComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$RowComp);
// packages/ag-grid-react/src/reactUi/rows/rowContainerComp.tsx
var $0e439ae7301dd858$var$RowContainerComp = ({ name: name })=>{
    const { context: context, gos: gos } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const containerOptions = (0, $acw62.useMemo)(()=>(0, $jIDNV._getRowContainerOptions)(name), [
        name
    ]);
    const eViewport = (0, $acw62.useRef)(null);
    const eContainer = (0, $acw62.useRef)(null);
    const eSpanContainer = (0, $acw62.useRef)(null);
    const rowCtrlsRef = (0, $acw62.useRef)([]);
    const prevRowCtrlsRef = (0, $acw62.useRef)([]);
    const [rowCtrlsOrdered, setRowCtrlsOrdered] = (0, $acw62.useState)(()=>[]);
    const isSpanning = !!gos.get("enableCellSpan") && !!containerOptions.getSpannedRowCtrls;
    const spannedRowCtrlsRef = (0, $acw62.useRef)([]);
    const prevSpannedRowCtrlsRef = (0, $acw62.useRef)([]);
    const [spannedRowCtrlsOrdered, setSpannedRowCtrlsOrdered] = (0, $acw62.useState)(()=>[]);
    const domOrderRef = (0, $acw62.useRef)(false);
    const rowContainerCtrlRef = (0, $acw62.useRef)();
    const viewportClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-viewport", (0, $jIDNV._getRowViewportClass)(name)), [
        name
    ]);
    const containerClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList((0, $jIDNV._getRowContainerClass)(name)), [
        name
    ]);
    const spanClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-spanning-container", (0, $jIDNV._getRowSpanContainerClass)(name)), [
        name
    ]);
    const shouldRenderViewport = containerOptions.type === "center" || isSpanning;
    const topLevelRef = shouldRenderViewport ? eViewport : eContainer;
    $0e439ae7301dd858$var$reactComment_default(" AG Row Container " + name + " ", topLevelRef);
    const areElementsReady = (0, $acw62.useCallback)(()=>{
        const viewportReady = !shouldRenderViewport || eViewport.current != null;
        const containerReady = eContainer.current != null;
        const spanContainerReady = !isSpanning || eSpanContainer.current != null;
        return viewportReady && containerReady && spanContainerReady;
    }, []);
    const areElementsRemoved = (0, $acw62.useCallback)(()=>{
        return eViewport.current == null && eContainer.current == null && eSpanContainer.current == null;
    }, []);
    const setRef2 = (0, $acw62.useCallback)(()=>{
        if (areElementsRemoved()) rowContainerCtrlRef.current = context.destroyBean(rowContainerCtrlRef.current);
        if (areElementsReady()) {
            const updateRowCtrlsOrdered = (useFlushSync)=>{
                const next = $0e439ae7301dd858$var$getNextValueIfDifferent(prevRowCtrlsRef.current, rowCtrlsRef.current, domOrderRef.current);
                if (next !== prevRowCtrlsRef.current) {
                    prevRowCtrlsRef.current = next;
                    $0e439ae7301dd858$var$agFlushSync(useFlushSync, ()=>setRowCtrlsOrdered(next));
                }
            };
            const updateSpannedRowCtrlsOrdered = (useFlushSync)=>{
                const next = $0e439ae7301dd858$var$getNextValueIfDifferent(prevSpannedRowCtrlsRef.current, spannedRowCtrlsRef.current, domOrderRef.current);
                if (next !== prevSpannedRowCtrlsRef.current) {
                    prevSpannedRowCtrlsRef.current = next;
                    $0e439ae7301dd858$var$agFlushSync(useFlushSync, ()=>setSpannedRowCtrlsOrdered(next));
                }
            };
            const compProxy = {
                setHorizontalScroll: (offset)=>{
                    if (eViewport.current) eViewport.current.scrollLeft = offset;
                },
                setViewportHeight: (height)=>{
                    if (eViewport.current) eViewport.current.style.height = height;
                },
                setRowCtrls: ({ rowCtrls: rowCtrls, useFlushSync: useFlushSync })=>{
                    const useFlush = !!useFlushSync && rowCtrlsRef.current.length > 0 && rowCtrls.length > 0;
                    rowCtrlsRef.current = rowCtrls;
                    updateRowCtrlsOrdered(useFlush);
                },
                setSpannedRowCtrls: (rowCtrls, useFlushSync)=>{
                    const useFlush = !!useFlushSync && spannedRowCtrlsRef.current.length > 0 && rowCtrls.length > 0;
                    spannedRowCtrlsRef.current = rowCtrls;
                    updateSpannedRowCtrlsOrdered(useFlush);
                },
                setDomOrder: (domOrder)=>{
                    if (domOrderRef.current != domOrder) {
                        domOrderRef.current = domOrder;
                        updateRowCtrlsOrdered(false);
                    }
                },
                setContainerWidth: (width)=>{
                    if (eContainer.current) eContainer.current.style.width = width;
                },
                setOffsetTop: (offset)=>{
                    if (eContainer.current) eContainer.current.style.transform = `translateY(${offset})`;
                }
            };
            rowContainerCtrlRef.current = context.createBean(new (0, $jIDNV.RowContainerCtrl)(name));
            rowContainerCtrlRef.current.setComp(compProxy, eContainer.current, eSpanContainer.current ?? void 0, eViewport.current);
        }
    }, [
        areElementsReady,
        areElementsRemoved
    ]);
    const setContainerRef = (0, $acw62.useCallback)((e)=>{
        eContainer.current = e;
        setRef2();
    }, [
        setRef2
    ]);
    const setSpanContainerRef = (0, $acw62.useCallback)((e)=>{
        eSpanContainer.current = e;
        setRef2();
    }, [
        setRef2
    ]);
    const setViewportRef = (0, $acw62.useCallback)((e)=>{
        eViewport.current = e;
        setRef2();
    }, [
        setRef2
    ]);
    const buildContainer = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: containerClasses,
            ref: setContainerRef,
            role: "rowgroup"
        }, rowCtrlsOrdered.map((rowCtrl)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$rowComp_default, {
                rowCtrl: rowCtrl,
                containerType: containerOptions.type,
                key: rowCtrl.instanceId
            })));
    if (!shouldRenderViewport) return buildContainer();
    const buildSpanContainer = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: spanClasses,
            ref: setSpanContainerRef,
            role: "rowgroup"
        }, spannedRowCtrlsOrdered.map((rowCtrl)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$rowComp_default, {
                rowCtrl: rowCtrl,
                containerType: containerOptions.type,
                key: rowCtrl.instanceId
            })));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: viewportClasses,
        ref: setViewportRef,
        role: "presentation"
    }, buildContainer(), isSpanning ? buildSpanContainer() : null);
};
var $0e439ae7301dd858$var$rowContainerComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$RowContainerComp);
// packages/ag-grid-react/src/reactUi/gridBodyComp.tsx
var $0e439ae7301dd858$var$GridBodyComp = ()=>{
    const beans = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const { context: context, overlays: overlays } = beans;
    const [rowAnimationClass, setRowAnimationClass] = (0, $acw62.useState)("");
    const [topHeight, setTopHeight] = (0, $acw62.useState)(0);
    const [bottomHeight, setBottomHeight] = (0, $acw62.useState)(0);
    const [stickyTopHeight, setStickyTopHeight] = (0, $acw62.useState)("0px");
    const [stickyTopTop, setStickyTopTop] = (0, $acw62.useState)("0px");
    const [stickyTopWidth, setStickyTopWidth] = (0, $acw62.useState)("100%");
    const [stickyBottomHeight, setStickyBottomHeight] = (0, $acw62.useState)("0px");
    const [stickyBottomBottom, setStickyBottomBottom] = (0, $acw62.useState)("0px");
    const [stickyBottomWidth, setStickyBottomWidth] = (0, $acw62.useState)("100%");
    const [topInvisible, setTopInvisible] = (0, $acw62.useState)(true);
    const [bottomInvisible, setBottomInvisible] = (0, $acw62.useState)(true);
    const [forceVerticalScrollClass, setForceVerticalScrollClass] = (0, $acw62.useState)(null);
    const [topAndBottomOverflowY, setTopAndBottomOverflowY] = (0, $acw62.useState)("");
    const [cellSelectableCss, setCellSelectableCss] = (0, $acw62.useState)(null);
    const [layoutClass, setLayoutClass] = (0, $acw62.useState)("ag-layout-normal");
    const cssManager = (0, $acw62.useRef)();
    if (!cssManager.current) cssManager.current = new (0, $jIDNV.CssClassManager)(()=>eRoot.current);
    const eRoot = (0, $acw62.useRef)(null);
    const eTop = (0, $acw62.useRef)(null);
    const eStickyTop = (0, $acw62.useRef)(null);
    const eStickyBottom = (0, $acw62.useRef)(null);
    const eBody = (0, $acw62.useRef)(null);
    const eBodyViewport = (0, $acw62.useRef)(null);
    const eBottom = (0, $acw62.useRef)(null);
    const beansToDestroy = (0, $acw62.useRef)([]);
    const destroyFuncs = (0, $acw62.useRef)([]);
    $0e439ae7301dd858$var$reactComment_default(" AG Grid Body ", eRoot);
    $0e439ae7301dd858$var$reactComment_default(" AG Pinned Top ", eTop);
    $0e439ae7301dd858$var$reactComment_default(" AG Sticky Top ", eStickyTop);
    $0e439ae7301dd858$var$reactComment_default(" AG Middle ", eBodyViewport);
    $0e439ae7301dd858$var$reactComment_default(" AG Pinned Bottom ", eBottom);
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eRoot.current = eRef;
        if (!eRef) {
            beansToDestroy.current = context.destroyBeans(beansToDestroy.current);
            destroyFuncs.current.forEach((f)=>f());
            destroyFuncs.current = [];
            return;
        }
        if (!context) return;
        const attachToDom = (eParent, eChild)=>{
            eParent.appendChild(eChild);
            destroyFuncs.current.push(()=>eParent.removeChild(eChild));
        };
        const newComp = (compClass)=>{
            const comp = context.createBean(new compClass());
            beansToDestroy.current.push(comp);
            return comp;
        };
        const addComp = (eParent, compClass, comment)=>{
            attachToDom(eParent, document.createComment(comment));
            attachToDom(eParent, newComp(compClass).getGui());
        };
        addComp(eRef, (0, $jIDNV.FakeHScrollComp), " AG Fake Horizontal Scroll ");
        const overlayComp = overlays?.getOverlayWrapperCompClass();
        if (overlayComp) addComp(eRef, overlayComp, " AG Overlay Wrapper ");
        if (eBody.current) addComp(eBody.current, (0, $jIDNV.FakeVScrollComp), " AG Fake Vertical Scroll ");
        const compProxy = {
            setRowAnimationCssOnBodyViewport: setRowAnimationClass,
            setColumnCount: (count)=>{
                if (eRoot.current) (0, $jIDNV._setAriaColCount)(eRoot.current, count);
            },
            setRowCount: (count)=>{
                if (eRoot.current) (0, $jIDNV._setAriaRowCount)(eRoot.current, count);
            },
            setTopHeight: setTopHeight,
            setBottomHeight: setBottomHeight,
            setStickyTopHeight: setStickyTopHeight,
            setStickyTopTop: setStickyTopTop,
            setStickyTopWidth: setStickyTopWidth,
            setTopInvisible: setTopInvisible,
            setBottomInvisible: setBottomInvisible,
            setColumnMovingCss: (cssClass, flag)=>cssManager.current.toggleCss(cssClass, flag),
            updateLayoutClasses: setLayoutClass,
            setAlwaysVerticalScrollClass: setForceVerticalScrollClass,
            setPinnedTopBottomOverflowY: setTopAndBottomOverflowY,
            setCellSelectableCss: (cssClass, flag)=>setCellSelectableCss(flag ? cssClass : null),
            setBodyViewportWidth: (width)=>{
                if (eBodyViewport.current) eBodyViewport.current.style.width = width;
            },
            registerBodyViewportResizeListener: (listener)=>{
                if (eBodyViewport.current) {
                    const unsubscribeFromResize = (0, $jIDNV._observeResize)(beans, eBodyViewport.current, listener);
                    destroyFuncs.current.push(()=>unsubscribeFromResize());
                }
            },
            setStickyBottomHeight: setStickyBottomHeight,
            setStickyBottomBottom: setStickyBottomBottom,
            setStickyBottomWidth: setStickyBottomWidth,
            setGridRootRole: (role)=>eRef.setAttribute("role", role)
        };
        const ctrl = context.createBean(new (0, $jIDNV.GridBodyCtrl)());
        beansToDestroy.current.push(ctrl);
        ctrl.setComp(compProxy, eRef, eBodyViewport.current, eTop.current, eBottom.current, eStickyTop.current, eStickyBottom.current);
    }, []);
    const rootClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-root", "ag-unselectable", layoutClass), [
        layoutClass
    ]);
    const bodyViewportClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-body-viewport", rowAnimationClass, layoutClass, forceVerticalScrollClass, cellSelectableCss), [
        rowAnimationClass,
        layoutClass,
        forceVerticalScrollClass,
        cellSelectableCss
    ]);
    const bodyClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-body", layoutClass), [
        layoutClass
    ]);
    const topClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-floating-top", topInvisible ? "ag-invisible" : null, cellSelectableCss), [
        cellSelectableCss,
        topInvisible
    ]);
    const stickyTopClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-sticky-top", cellSelectableCss), [
        cellSelectableCss
    ]);
    const stickyBottomClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-sticky-bottom", stickyBottomHeight === "0px" ? "ag-invisible" : null, cellSelectableCss), [
        cellSelectableCss,
        stickyBottomHeight
    ]);
    const bottomClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-floating-bottom", bottomInvisible ? "ag-invisible" : null, cellSelectableCss), [
        cellSelectableCss,
        bottomInvisible
    ]);
    const topStyle = (0, $acw62.useMemo)(()=>({
            height: topHeight,
            minHeight: topHeight,
            overflowY: topAndBottomOverflowY
        }), [
        topHeight,
        topAndBottomOverflowY
    ]);
    const stickyTopStyle = (0, $acw62.useMemo)(()=>({
            height: stickyTopHeight,
            top: stickyTopTop,
            width: stickyTopWidth
        }), [
        stickyTopHeight,
        stickyTopTop,
        stickyTopWidth
    ]);
    const stickyBottomStyle = (0, $acw62.useMemo)(()=>({
            height: stickyBottomHeight,
            bottom: stickyBottomBottom,
            width: stickyBottomWidth
        }), [
        stickyBottomHeight,
        stickyBottomBottom,
        stickyBottomWidth
    ]);
    const bottomStyle = (0, $acw62.useMemo)(()=>({
            height: bottomHeight,
            minHeight: bottomHeight,
            overflowY: topAndBottomOverflowY
        }), [
        bottomHeight,
        topAndBottomOverflowY
    ]);
    const createRowContainer = (container)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$rowContainerComp_default, {
            name: container,
            key: `${container}-container`
        });
    const createSection = ({ section: section, children: children, className: className, style: style })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: section,
            className: className,
            role: "presentation",
            style: style
        }, children.map(createRowContainer));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: rootClasses
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$gridHeaderComp_default, null), createSection({
        section: eTop,
        className: topClasses,
        style: topStyle,
        children: [
            "topLeft",
            "topCenter",
            "topRight",
            "topFullWidth"
        ]
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: bodyClasses,
        ref: eBody,
        role: "presentation"
    }, createSection({
        section: eBodyViewport,
        className: bodyViewportClasses,
        children: [
            "left",
            "center",
            "right",
            "fullWidth"
        ]
    })), createSection({
        section: eStickyTop,
        className: stickyTopClasses,
        style: stickyTopStyle,
        children: [
            "stickyTopLeft",
            "stickyTopCenter",
            "stickyTopRight",
            "stickyTopFullWidth"
        ]
    }), createSection({
        section: eStickyBottom,
        className: stickyBottomClasses,
        style: stickyBottomStyle,
        children: [
            "stickyBottomLeft",
            "stickyBottomCenter",
            "stickyBottomRight",
            "stickyBottomFullWidth"
        ]
    }), createSection({
        section: eBottom,
        className: bottomClasses,
        style: bottomStyle,
        children: [
            "bottomLeft",
            "bottomCenter",
            "bottomRight",
            "bottomFullWidth"
        ]
    }));
};
var $0e439ae7301dd858$var$gridBodyComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$GridBodyComp);
var $0e439ae7301dd858$var$TabGuardCompRef = (props, forwardRef4)=>{
    const { children: children, eFocusableElement: eFocusableElement, onTabKeyDown: onTabKeyDown, gridCtrl: gridCtrl, forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty, isEmpty: isEmpty } = props;
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const topTabGuardRef = (0, $acw62.useRef)(null);
    const bottomTabGuardRef = (0, $acw62.useRef)(null);
    const tabGuardCtrlRef = (0, $acw62.useRef)();
    const setTabIndex = (value)=>{
        const processedValue = value == null ? void 0 : parseInt(value, 10).toString();
        [
            topTabGuardRef,
            bottomTabGuardRef
        ].forEach((tabGuard)=>{
            if (processedValue === void 0) tabGuard.current?.removeAttribute("tabindex");
            else tabGuard.current?.setAttribute("tabindex", processedValue);
        });
    };
    (0, $acw62.useImperativeHandle)(forwardRef4, ()=>({
            forceFocusOutOfContainer (up) {
                tabGuardCtrlRef.current?.forceFocusOutOfContainer(up);
            }
        }));
    const setupCtrl = (0, $acw62.useCallback)(()=>{
        const topTabGuard = topTabGuardRef.current;
        const bottomTabGuard = bottomTabGuardRef.current;
        if (!topTabGuard && !bottomTabGuard) {
            tabGuardCtrlRef.current = context.destroyBean(tabGuardCtrlRef.current);
            return;
        }
        if (topTabGuard && bottomTabGuard) {
            const compProxy = {
                setTabIndex: setTabIndex
            };
            tabGuardCtrlRef.current = context.createBean(new (0, $jIDNV.TabGuardCtrl)({
                comp: compProxy,
                eTopGuard: topTabGuard,
                eBottomGuard: bottomTabGuard,
                eFocusableElement: eFocusableElement,
                onTabKeyDown: onTabKeyDown,
                forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty,
                focusInnerElement: (fromBottom)=>gridCtrl.focusInnerElement(fromBottom),
                isEmpty: isEmpty
            }));
        }
    }, []);
    const setTopRef = (0, $acw62.useCallback)((e)=>{
        topTabGuardRef.current = e;
        setupCtrl();
    }, [
        setupCtrl
    ]);
    const setBottomRef = (0, $acw62.useCallback)((e)=>{
        bottomTabGuardRef.current = e;
        setupCtrl();
    }, [
        setupCtrl
    ]);
    const createTabGuard = (side)=>{
        const className = side === "top" ? (0, $jIDNV.TabGuardClassNames).TAB_GUARD_TOP : (0, $jIDNV.TabGuardClassNames).TAB_GUARD_BOTTOM;
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: `${(0, $jIDNV.TabGuardClassNames).TAB_GUARD} ${className}`,
            role: "presentation",
            ref: side === "top" ? setTopRef : setBottomRef
        });
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, createTabGuard("top"), children, createTabGuard("bottom"));
};
var $0e439ae7301dd858$var$TabGuardComp = (0, $acw62.forwardRef)($0e439ae7301dd858$var$TabGuardCompRef);
var $0e439ae7301dd858$var$tabGuardComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$TabGuardComp);
// packages/ag-grid-react/src/reactUi/gridComp.tsx
var $0e439ae7301dd858$var$GridComp = ({ context: context })=>{
    const [rtlClass, setRtlClass] = (0, $acw62.useState)("");
    const [layoutClass, setLayoutClass] = (0, $acw62.useState)("");
    const [cursor, setCursor] = (0, $acw62.useState)(null);
    const [userSelect, setUserSelect] = (0, $acw62.useState)(null);
    const [initialised, setInitialised] = (0, $acw62.useState)(false);
    const [tabGuardReady, setTabGuardReady] = (0, $acw62.useState)();
    const gridCtrlRef = (0, $acw62.useRef)();
    const eRootWrapperRef = (0, $acw62.useRef)(null);
    const tabGuardRef = (0, $acw62.useRef)();
    const [eGridBodyParent, setGridBodyParent] = (0, $acw62.useState)(null);
    const focusInnerElementRef = (0, $acw62.useRef)(()=>void 0);
    const paginationCompRef = (0, $acw62.useRef)();
    const focusableContainersRef = (0, $acw62.useRef)([]);
    const onTabKeyDown = (0, $acw62.useCallback)(()=>void 0, []);
    const beans = (0, $acw62.useMemo)(()=>{
        if (context.isDestroyed()) return null;
        return context.getBeans();
    }, [
        context
    ]);
    $0e439ae7301dd858$var$reactComment_default(" AG Grid ", eRootWrapperRef);
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eRootWrapperRef.current = eRef;
        gridCtrlRef.current = eRef ? context.createBean(new (0, $jIDNV.GridCtrl)()) : context.destroyBean(gridCtrlRef.current);
        if (!eRef || context.isDestroyed()) return;
        const gridCtrl = gridCtrlRef.current;
        focusInnerElementRef.current = gridCtrl.focusInnerElement.bind(gridCtrl);
        const compProxy = {
            destroyGridUi: ()=>{},
            setRtlClass: // do nothing, as framework users destroy grid by removing the comp
            setRtlClass,
            forceFocusOutOfContainer: (up)=>{
                if (!up && paginationCompRef.current?.isDisplayed()) {
                    paginationCompRef.current.forceFocusOutOfContainer(up);
                    return;
                }
                tabGuardRef.current?.forceFocusOutOfContainer(up);
            },
            updateLayoutClasses: setLayoutClass,
            getFocusableContainers: ()=>{
                const comps = [];
                const gridBodyCompEl = eRootWrapperRef.current?.querySelector(".ag-root");
                if (gridBodyCompEl) comps.push({
                    getGui: ()=>gridBodyCompEl
                });
                focusableContainersRef.current.forEach((comp)=>{
                    if (comp.isDisplayed()) comps.push(comp);
                });
                return comps;
            },
            setCursor: setCursor,
            setUserSelect: setUserSelect
        };
        gridCtrl.setComp(compProxy, eRef, eRef);
        setInitialised(true);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const gridCtrl = gridCtrlRef.current;
        const eRootWrapper = eRootWrapperRef.current;
        if (!tabGuardReady || !beans || !gridCtrl || !eGridBodyParent || !eRootWrapper || context.isDestroyed()) return;
        const beansToDestroy = [];
        const { watermarkSelector: watermarkSelector, paginationSelector: paginationSelector, sideBarSelector: sideBarSelector, statusBarSelector: statusBarSelector, gridHeaderDropZonesSelector: gridHeaderDropZonesSelector } = gridCtrl.getOptionalSelectors();
        const additionalEls = [];
        if (gridHeaderDropZonesSelector) {
            const headerDropZonesComp = context.createBean(new gridHeaderDropZonesSelector.component());
            const eGui = headerDropZonesComp.getGui();
            eRootWrapper.insertAdjacentElement("afterbegin", eGui);
            additionalEls.push(eGui);
            beansToDestroy.push(headerDropZonesComp);
        }
        if (sideBarSelector) {
            const sideBarComp = context.createBean(new sideBarSelector.component());
            const eGui = sideBarComp.getGui();
            const bottomTabGuard = eGridBodyParent.querySelector(".ag-tab-guard-bottom");
            if (bottomTabGuard) {
                bottomTabGuard.insertAdjacentElement("beforebegin", eGui);
                additionalEls.push(eGui);
            }
            beansToDestroy.push(sideBarComp);
            focusableContainersRef.current.push(sideBarComp);
        }
        const addComponentToDom = (component)=>{
            const comp = context.createBean(new component());
            const eGui = comp.getGui();
            eRootWrapper.insertAdjacentElement("beforeend", eGui);
            additionalEls.push(eGui);
            beansToDestroy.push(comp);
            return comp;
        };
        if (statusBarSelector) addComponentToDom(statusBarSelector.component);
        if (paginationSelector) {
            const paginationComp = addComponentToDom(paginationSelector.component);
            paginationCompRef.current = paginationComp;
            focusableContainersRef.current.push(paginationComp);
        }
        if (watermarkSelector) addComponentToDom(watermarkSelector.component);
        return ()=>{
            context.destroyBeans(beansToDestroy);
            additionalEls.forEach((el)=>{
                el.parentElement?.removeChild(el);
            });
        };
    }, [
        tabGuardReady,
        eGridBodyParent,
        beans
    ]);
    const rootWrapperClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-root-wrapper", rtlClass, layoutClass), [
        rtlClass,
        layoutClass
    ]);
    const rootWrapperBodyClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-root-wrapper-body", "ag-focus-managed", layoutClass), [
        layoutClass
    ]);
    const topStyle = (0, $acw62.useMemo)(()=>({
            userSelect: userSelect != null ? userSelect : "",
            WebkitUserSelect: userSelect != null ? userSelect : "",
            cursor: cursor != null ? cursor : ""
        }), [
        userSelect,
        cursor
    ]);
    const setTabGuardCompRef = (0, $acw62.useCallback)((ref)=>{
        tabGuardRef.current = ref;
        setTabGuardReady(ref !== null);
    }, []);
    const isFocusable = (0, $acw62.useCallback)(()=>!gridCtrlRef.current?.isFocusable(), []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: rootWrapperClasses,
        style: topStyle,
        role: "presentation"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: rootWrapperBodyClasses,
        ref: setGridBodyParent,
        role: "presentation"
    }, initialised && eGridBodyParent && beans && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$BeansContext.Provider, {
        value: beans
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$tabGuardComp_default, {
        ref: setTabGuardCompRef,
        eFocusableElement: eGridBodyParent,
        onTabKeyDown: onTabKeyDown,
        gridCtrl: gridCtrlRef.current,
        forceFocusOutWhenTabGuardsAreEmpty: true,
        isEmpty: isFocusable
    }, // we wait for initialised before rending the children, so GridComp has created and registered with it's
    // GridCtrl before we create the child GridBodyComp. Otherwise the GridBodyComp would initialise first,
    // before we have set the the Layout CSS classes, causing the GridBodyComp to render rows to a grid that
    // doesn't have it's height specified, which would result if all the rows getting rendered (and if many rows,
    // hangs the UI)
    /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$gridBodyComp_default, null)))));
};
var $0e439ae7301dd858$var$gridComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$GridComp);
var $0e439ae7301dd858$var$RenderStatusService = class extends (0, $jIDNV.BeanStub) {
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
    }
    areHeaderCellsRendered() {
        return this.ctrlsSvc.getHeaderRowContainerCtrls().every((container)=>container.getAllCtrls().every((ctrl)=>ctrl.areCellsRendered()));
    }
};
// packages/ag-grid-react/src/reactUi/agGridReactUi.tsx
var $0e439ae7301dd858$var$deprecatedProps = {
    setGridApi: void 0,
    maxComponentCreationTimeMs: void 0,
    children: void 0
};
var $0e439ae7301dd858$var$reactPropsNotGridOptions = {
    gridOptions: void 0,
    modules: void 0,
    containerStyle: void 0,
    className: void 0,
    passGridApi: void 0,
    componentWrappingElement: void 0,
    ...$0e439ae7301dd858$var$deprecatedProps
};
var $0e439ae7301dd858$var$excludeReactCompProps = new Set(Object.keys($0e439ae7301dd858$var$reactPropsNotGridOptions));
var $0e439ae7301dd858$var$deprecatedReactCompProps = new Set(Object.keys($0e439ae7301dd858$var$deprecatedProps));
var $0e439ae7301dd858$var$AgGridReactUi = (props)=>{
    const apiRef = (0, $acw62.useRef)();
    const eGui = (0, $acw62.useRef)(null);
    const portalManager = (0, $acw62.useRef)(null);
    const destroyFuncs = (0, $acw62.useRef)([]);
    const whenReadyFuncs = (0, $acw62.useRef)([]);
    const prevProps = (0, $acw62.useRef)(props);
    const frameworkOverridesRef = (0, $acw62.useRef)();
    const gridIdRef = (0, $acw62.useRef)();
    const ready = (0, $acw62.useRef)(false);
    const [context, setContext] = (0, $acw62.useState)(void 0);
    const [, setPortalRefresher] = (0, $acw62.useState)(0);
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGui.current = eRef;
        if (!eRef) {
            destroyFuncs.current.forEach((f)=>f());
            destroyFuncs.current.length = 0;
            return;
        }
        const modules = props.modules || [];
        if (!portalManager.current) {
            portalManager.current = new $0e439ae7301dd858$var$PortalManager(()=>setPortalRefresher((prev)=>prev + 1), props.componentWrappingElement, props.maxComponentCreationTimeMs);
            destroyFuncs.current.push(()=>{
                portalManager.current?.destroy();
                portalManager.current = null;
            });
        }
        const mergedGridOps = (0, $jIDNV._combineAttributesAndGridOptions)(props.gridOptions, props, Object.keys(props).filter((key)=>!$0e439ae7301dd858$var$excludeReactCompProps.has(key)));
        const processQueuedUpdates = ()=>{
            if (ready.current) {
                const getFn = ()=>frameworkOverridesRef.current?.shouldQueueUpdates() ? void 0 : whenReadyFuncs.current.shift();
                let fn = getFn();
                while(fn){
                    fn();
                    fn = getFn();
                }
            }
        };
        const frameworkOverrides = new $0e439ae7301dd858$var$ReactFrameworkOverrides(processQueuedUpdates);
        frameworkOverridesRef.current = frameworkOverrides;
        const renderStatus = new $0e439ae7301dd858$var$RenderStatusService();
        const gridParams = {
            providedBeanInstances: {
                frameworkCompWrapper: new $0e439ae7301dd858$var$ReactFrameworkComponentWrapper(portalManager.current, mergedGridOps),
                renderStatus: renderStatus
            },
            modules: modules,
            frameworkOverrides: frameworkOverrides,
            setThemeOnGridDiv: true
        };
        const createUiCallback = (context2)=>{
            setContext(context2);
            context2.createBean(renderStatus);
            destroyFuncs.current.push(()=>{
                context2.destroy();
            });
            context2.getBean("ctrlsSvc").whenReady({
                addDestroyFunc: (func)=>{
                    destroyFuncs.current.push(func);
                }
            }, ()=>{
                if (context2.isDestroyed()) return;
                const api = apiRef.current;
                if (api) props.passGridApi?.(api);
            });
        };
        const acceptChangesCallback = (context2)=>{
            context2.getBean("ctrlsSvc").whenReady({
                addDestroyFunc: (func)=>{
                    destroyFuncs.current.push(func);
                }
            }, ()=>{
                whenReadyFuncs.current.forEach((f)=>f());
                whenReadyFuncs.current.length = 0;
                ready.current = true;
            });
        };
        const gridCoreCreator = new (0, $jIDNV.GridCoreCreator)();
        mergedGridOps.gridId ?? (mergedGridOps.gridId = gridIdRef.current);
        apiRef.current = gridCoreCreator.create(eRef, mergedGridOps, createUiCallback, acceptChangesCallback, gridParams);
        destroyFuncs.current.push(()=>{
            apiRef.current = void 0;
        });
        if (apiRef.current) gridIdRef.current = apiRef.current.getGridId();
    }, []);
    const style = (0, $acw62.useMemo)(()=>{
        return {
            height: "100%",
            ...props.containerStyle || {}
        };
    }, [
        props.containerStyle
    ]);
    const processWhenReady = (0, $acw62.useCallback)((func)=>{
        if (ready.current && !frameworkOverridesRef.current?.shouldQueueUpdates()) func();
        else whenReadyFuncs.current.push(func);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const changes = $0e439ae7301dd858$var$extractGridPropertyChanges(prevProps.current, props);
        prevProps.current = props;
        processWhenReady(()=>{
            if (apiRef.current) (0, $jIDNV._processOnChange)(changes, apiRef.current);
        });
    }, [
        props
    ]);
    const renderMode = !(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useSyncExternalStore || (0, $jIDNV._getGridOption)(props, "renderingMode") === "legacy" ? "legacy" : "default";
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: style,
        className: props.className,
        ref: setRef2
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$RenderModeContext.Provider, {
        value: renderMode
    }, context && !context.isDestroyed() ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$gridComp_default, {
        context: context
    }) : null, portalManager.current?.getPortals() ?? null));
};
function $0e439ae7301dd858$var$extractGridPropertyChanges(prevProps, nextProps) {
    const changes = {};
    Object.keys(nextProps).forEach((propKey)=>{
        if ($0e439ae7301dd858$var$excludeReactCompProps.has(propKey)) {
            if ($0e439ae7301dd858$var$deprecatedReactCompProps.has(propKey)) (0, $jIDNV._warn)(274, {
                prop: propKey
            });
            return;
        }
        const propValue = nextProps[propKey];
        if (prevProps[propKey] !== propValue) changes[propKey] = propValue;
    });
    return changes;
}
var $0e439ae7301dd858$var$ReactFrameworkComponentWrapper = class extends (0, $jIDNV.BaseComponentWrapper) {
    constructor(parent, gridOptions){
        super();
        this.parent = parent;
        this.gridOptions = gridOptions;
    }
    createWrapper(UserReactComponent, componentType) {
        const gridOptions = this.gridOptions;
        const reactiveCustomComponents = (0, $jIDNV._getGridOption)(gridOptions, "reactiveCustomComponents");
        if (reactiveCustomComponents) {
            const getComponentClass = (propertyName)=>{
                switch(propertyName){
                    case "filter":
                        return (0, $jIDNV._getGridOption)(gridOptions, "enableFilterHandlers") ? $0e439ae7301dd858$var$FilterDisplayComponentWrapper : $0e439ae7301dd858$var$FilterComponentWrapper;
                    case "floatingFilterComponent":
                        return (0, $jIDNV._getGridOption)(gridOptions, "enableFilterHandlers") ? $0e439ae7301dd858$var$FloatingFilterDisplayComponentWrapper : $0e439ae7301dd858$var$FloatingFilterComponentWrapper;
                    case "dateComponent":
                        return $0e439ae7301dd858$var$DateComponentWrapper;
                    case "dragAndDropImageComponent":
                        return $0e439ae7301dd858$var$DragAndDropImageComponentWrapper;
                    case "loadingOverlayComponent":
                        return $0e439ae7301dd858$var$LoadingOverlayComponentWrapper;
                    case "noRowsOverlayComponent":
                        return $0e439ae7301dd858$var$NoRowsOverlayComponentWrapper;
                    case "statusPanel":
                        return $0e439ae7301dd858$var$StatusPanelComponentWrapper;
                    case "toolPanel":
                        return $0e439ae7301dd858$var$ToolPanelComponentWrapper;
                    case "menuItem":
                        return $0e439ae7301dd858$var$MenuItemComponentWrapper;
                    case "cellRenderer":
                        return $0e439ae7301dd858$var$CellRendererComponentWrapper;
                    case "innerHeaderComponent":
                        return $0e439ae7301dd858$var$InnerHeaderComponentWrapper;
                }
            };
            const ComponentClass = getComponentClass(componentType.name);
            if (ComponentClass) return new ComponentClass(UserReactComponent, this.parent, componentType);
        } else switch(componentType.name){
            case "filter":
            case "floatingFilterComponent":
            case "dateComponent":
            case "dragAndDropImageComponent":
            case "loadingOverlayComponent":
            case "noRowsOverlayComponent":
            case "statusPanel":
            case "toolPanel":
            case "menuItem":
            case "cellRenderer":
                $0e439ae7301dd858$export$e83e01bcf62967be();
                break;
        }
        const suppressFallbackMethods = !componentType.cellRenderer && componentType.name !== "toolPanel";
        return new $0e439ae7301dd858$var$ReactComponent(UserReactComponent, this.parent, componentType, suppressFallbackMethods);
    }
};
var $0e439ae7301dd858$var$DetailCellRenderer = (0, $acw62.forwardRef)((props, ref)=>{
    const beans = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const { registry: registry, context: context, gos: gos, rowModel: rowModel } = beans;
    const [cssClasses, setCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [gridCssClasses, setGridCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [detailGridOptions, setDetailGridOptions] = (0, $acw62.useState)();
    const [detailRowData, setDetailRowData] = (0, $acw62.useState)();
    const ctrlRef = (0, $acw62.useRef)();
    const eGuiRef = (0, $acw62.useRef)(null);
    const resizeObserverDestroyFunc = (0, $acw62.useRef)();
    const parentModules = (0, $acw62.useMemo)(()=>(0, $jIDNV._getGridRegisteredModules)(props.api.getGridId(), detailGridOptions?.rowModelType ?? "clientSide"), [
        props
    ]);
    const topClassName = (0, $acw62.useMemo)(()=>cssClasses.toString() + " ag-details-row", [
        cssClasses
    ]);
    const gridClassName = (0, $acw62.useMemo)(()=>gridCssClasses.toString() + " ag-details-grid", [
        gridCssClasses
    ]);
    if (ref) (0, $acw62.useImperativeHandle)(ref, ()=>({
            refresh () {
                return ctrlRef.current?.refresh() ?? false;
            }
        }));
    if (props.template) (0, $jIDNV._warn)(230);
    const setRef2 = (0, $acw62.useCallback)((eRef)=>{
        eGuiRef.current = eRef;
        if (!eRef) {
            ctrlRef.current = context.destroyBean(ctrlRef.current);
            resizeObserverDestroyFunc.current?.();
            return;
        }
        const compProxy = {
            toggleCss: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            toggleDetailGridCss: (name, on)=>setGridCssClasses((prev)=>prev.setClass(name, on)),
            setDetailGrid: (gridOptions)=>setDetailGridOptions(gridOptions),
            setRowData: (rowData)=>setDetailRowData(rowData),
            getGui: ()=>eGuiRef.current
        };
        const ctrl = registry.createDynamicBean("detailCellRendererCtrl", true);
        if (!ctrl) return;
        context.createBean(ctrl);
        ctrl.init(compProxy, props);
        ctrlRef.current = ctrl;
        if (gos.get("detailRowAutoHeight")) {
            const checkRowSizeFunc = ()=>{
                if (eGuiRef.current == null) return;
                const clientHeight = eGuiRef.current.clientHeight;
                if (clientHeight != null && clientHeight > 0) {
                    const updateRowHeightFunc = ()=>{
                        props.node.setRowHeight(clientHeight);
                        if ((0, $jIDNV._isClientSideRowModel)(gos, rowModel) || (0, $jIDNV._isServerSideRowModel)(gos, rowModel)) rowModel.onRowHeightChanged();
                    };
                    setTimeout(updateRowHeightFunc, 0);
                }
            };
            resizeObserverDestroyFunc.current = (0, $jIDNV._observeResize)(beans, eRef, checkRowSizeFunc);
            checkRowSizeFunc();
        }
    }, []);
    const registerGridApi = (0, $acw62.useCallback)((api)=>{
        ctrlRef.current?.registerDetailWithMaster(api);
    }, []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: topClassName,
        ref: setRef2
    }, detailGridOptions && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$AgGridReactUi, {
        className: gridClassName,
        ...detailGridOptions,
        modules: parentModules,
        rowData: detailRowData,
        passGridApi: registerGridApi
    }));
});
var $0e439ae7301dd858$var$ReactFrameworkOverrides = class extends (0, $jIDNV.VanillaFrameworkOverrides) {
    constructor(processQueuedUpdates){
        super("react");
        this.processQueuedUpdates = processQueuedUpdates;
        this.queueUpdates = false;
        this.renderingEngine = "react";
        this.frameworkComponents = {
            agGroupCellRenderer: $0e439ae7301dd858$var$groupCellRenderer_default,
            agGroupRowRenderer: $0e439ae7301dd858$var$groupCellRenderer_default,
            agDetailCellRenderer: $0e439ae7301dd858$var$DetailCellRenderer
        };
        this.wrapIncoming = (callback, source)=>{
            if (source === "ensureVisible") return $0e439ae7301dd858$var$runWithoutFlushSync(callback);
            return callback();
        };
    }
    frameworkComponent(name) {
        return this.frameworkComponents[name];
    }
    isFrameworkComponent(comp) {
        if (!comp) return false;
        const prototype = comp.prototype;
        const isJsComp = prototype && "getGui" in prototype;
        return !isJsComp;
    }
    getLockOnRefresh() {
        this.queueUpdates = true;
    }
    releaseLockOnRefresh() {
        this.queueUpdates = false;
        this.processQueuedUpdates();
    }
    shouldQueueUpdates() {
        return this.queueUpdates;
    }
    runWhenReadyAsync() {
        return $0e439ae7301dd858$var$isReact19();
    }
};
// packages/ag-grid-react/src/agGridReact.tsx
var $0e439ae7301dd858$export$4074462c5969a5d8 = class extends (0, $acw62.Component) {
    constructor(){
        super(...arguments);
        this.apiListeners = [];
        this.setGridApi = (api)=>{
            this.api = api;
            this.apiListeners.forEach((listener)=>listener(api));
        };
    }
    registerApiListener(listener) {
        this.apiListeners.push(listener);
    }
    componentWillUnmount() {
        this.apiListeners.length = 0;
    }
    render() {
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$AgGridReactUi, {
            ...this.props,
            passGridApi: this.setGridApi
        });
    }
};
function $0e439ae7301dd858$var$useGridCustomComponent(methods) {
    const { setMethods: setMethods } = (0, $acw62.useContext)($0e439ae7301dd858$export$9f6317c67b47ac67);
    setMethods(methods);
}
function $0e439ae7301dd858$export$70780aa16b46d041(callbacks) {
    $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}
function $0e439ae7301dd858$export$ae0fe569b475a61(callbacks) {
    return $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}
function $0e439ae7301dd858$export$42838275cbf666c4(callbacks) {
    return $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}
function $0e439ae7301dd858$export$1960c6fcb2ef5be2(callbacks) {
    return $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}
function $0e439ae7301dd858$export$a2cd2617441b4952(callbacks) {
    $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}
function $0e439ae7301dd858$export$bfb597f578b2979b(callbacks) {
    $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}

});
parcelRegister("jIDNV", function(module, exports) {

$parcel$export(module.exports, "LocalEventService", () => $437b23f6a393c3bf$export$820da7696a401cdc);
$parcel$export(module.exports, "_translate", () => $437b23f6a393c3bf$export$4ad3db330991f17d);
$parcel$export(module.exports, "_makeNull", () => $437b23f6a393c3bf$export$4978424c4f7b5fc0);
$parcel$export(module.exports, "_exists", () => $437b23f6a393c3bf$export$25d27f17d3af40f7);
$parcel$export(module.exports, "_missing", () => $437b23f6a393c3bf$export$672d9e47bc342bac);
$parcel$export(module.exports, "_toStringOrNull", () => $437b23f6a393c3bf$export$2a74c29220d5c88e);
$parcel$export(module.exports, "_jsonEquals", () => $437b23f6a393c3bf$export$dbc2068cc90f5875);
$parcel$export(module.exports, "_defaultComparator", () => $437b23f6a393c3bf$export$b0cca9f3c87c8df8);
$parcel$export(module.exports, "_mergeDeep", () => $437b23f6a393c3bf$export$8ade6bd474fcde42);
$parcel$export(module.exports, "_setAriaRole", () => $437b23f6a393c3bf$export$f8d01fa01787902);
$parcel$export(module.exports, "_getAriaPosInSet", () => $437b23f6a393c3bf$export$70c3a20563598672);
$parcel$export(module.exports, "_setAriaLabel", () => $437b23f6a393c3bf$export$e81cb0dd07f289f6);
$parcel$export(module.exports, "_setAriaLabelledBy", () => $437b23f6a393c3bf$export$84233c40c4c74001);
$parcel$export(module.exports, "_setAriaDescribedBy", () => $437b23f6a393c3bf$export$3c2bc877474a7797);
$parcel$export(module.exports, "_setAriaLevel", () => $437b23f6a393c3bf$export$9eaf1f20171625e8);
$parcel$export(module.exports, "_setAriaDisabled", () => $437b23f6a393c3bf$export$7ed376f43c6f2bbd);
$parcel$export(module.exports, "_setAriaHidden", () => $437b23f6a393c3bf$export$ee52c2b3744c455d);
$parcel$export(module.exports, "_setAriaActiveDescendant", () => $437b23f6a393c3bf$export$5db804730c3c8346);
$parcel$export(module.exports, "_setAriaExpanded", () => $437b23f6a393c3bf$export$3ad3518dddf15485);
$parcel$export(module.exports, "_removeAriaExpanded", () => $437b23f6a393c3bf$export$2254dfb132f01330);
$parcel$export(module.exports, "_setAriaSetSize", () => $437b23f6a393c3bf$export$3d494c2007bbcac1);
$parcel$export(module.exports, "_setAriaPosInSet", () => $437b23f6a393c3bf$export$c3d3aede41065a84);
$parcel$export(module.exports, "_setAriaRowCount", () => $437b23f6a393c3bf$export$1ad8496b26b660f8);
$parcel$export(module.exports, "_setAriaRowIndex", () => $437b23f6a393c3bf$export$ba731dedf9d88615);
$parcel$export(module.exports, "_setAriaColCount", () => $437b23f6a393c3bf$export$56744a26086b5898);
$parcel$export(module.exports, "_setAriaColIndex", () => $437b23f6a393c3bf$export$84b73ecd0b234e89);
$parcel$export(module.exports, "_setAriaColSpan", () => $437b23f6a393c3bf$export$371d80f0281454ce);
$parcel$export(module.exports, "_setAriaSort", () => $437b23f6a393c3bf$export$c8dd030b968c6fd2);
$parcel$export(module.exports, "_removeAriaSort", () => $437b23f6a393c3bf$export$26c7aa61eda05134);
$parcel$export(module.exports, "_setAriaSelected", () => $437b23f6a393c3bf$export$c22e3722e8a33469);
$parcel$export(module.exports, "_setAriaChecked", () => $437b23f6a393c3bf$export$43b4d6c0ec0fa4c7);
$parcel$export(module.exports, "_setAriaControls", () => $437b23f6a393c3bf$export$26fd6a3f123d4e67);
$parcel$export(module.exports, "_setAriaControlsAndLabel", () => $437b23f6a393c3bf$export$6ff31a4a210c60ad);
$parcel$export(module.exports, "_setAriaHasPopup", () => $437b23f6a393c3bf$export$668d180e9cbef6da);
$parcel$export(module.exports, "_isIOSUserAgent", () => $437b23f6a393c3bf$export$6b6034a68325bd8a);
$parcel$export(module.exports, "_radioCssClass", () => $437b23f6a393c3bf$export$605571c1b2992cfe);
$parcel$export(module.exports, "_isVisible", () => $437b23f6a393c3bf$export$2badf4aa566524cb);
$parcel$export(module.exports, "_setDisplayed", () => $437b23f6a393c3bf$export$9405f1cbb4e2383f);
$parcel$export(module.exports, "_setVisible", () => $437b23f6a393c3bf$export$a6c2c477cd60daa8);
$parcel$export(module.exports, "_setDisabled", () => $437b23f6a393c3bf$export$b6b4f08392e9bfaf);
$parcel$export(module.exports, "_getInnerHeight", () => $437b23f6a393c3bf$export$c20e968103d9c16e);
$parcel$export(module.exports, "_getInnerWidth", () => $437b23f6a393c3bf$export$cc615e4191ec3e0c);
$parcel$export(module.exports, "_getAbsoluteHeight", () => $437b23f6a393c3bf$export$d23c22492e0f7c0c);
$parcel$export(module.exports, "_getAbsoluteWidth", () => $437b23f6a393c3bf$export$642efcb17474eb51);
$parcel$export(module.exports, "_clearElement", () => $437b23f6a393c3bf$export$69e6e10709eabd91);
$parcel$export(module.exports, "_removeFromParent", () => $437b23f6a393c3bf$export$dd4d52e41fb4cef5);
$parcel$export(module.exports, "_isElementOverflowingCallback", () => $437b23f6a393c3bf$export$8980540b0a37a11d);
$parcel$export(module.exports, "_setFixedWidth", () => $437b23f6a393c3bf$export$ce98ba7f5cfe7725);
$parcel$export(module.exports, "_isNodeOrElement", () => $437b23f6a393c3bf$export$6e6303ef478b0c94);
$parcel$export(module.exports, "_observeResize", () => $437b23f6a393c3bf$export$9aef8476630687be);
$parcel$export(module.exports, "_getRootNode", () => $437b23f6a393c3bf$export$1911dd00c79744c0);
$parcel$export(module.exports, "_preserveRangesWhile", () => $437b23f6a393c3bf$export$13e15fa0b6986f21);
$parcel$export(module.exports, "_requestAnimationFrame", () => $437b23f6a393c3bf$export$7b1f5bd01973c897);
$parcel$export(module.exports, "_createElement", () => $437b23f6a393c3bf$export$a232bb0480ae674a);
$parcel$export(module.exports, "_doOnce", () => $437b23f6a393c3bf$export$e150fb6ea3b45c0d);
$parcel$export(module.exports, "_warnOnce", () => $437b23f6a393c3bf$export$2cf41453020eef66);
$parcel$export(module.exports, "_batchCall", () => $437b23f6a393c3bf$export$8ea55376d0d59592);
$parcel$export(module.exports, "_debounce", () => $437b23f6a393c3bf$export$cf7e39bfb94de6e);
$parcel$export(module.exports, "_waitUntil", () => $437b23f6a393c3bf$export$b863e7aac7884b8);
$parcel$export(module.exports, "_warn", () => $437b23f6a393c3bf$export$545083624300f13d);
$parcel$export(module.exports, "_error", () => $437b23f6a393c3bf$export$a20c7248650823a9);
$parcel$export(module.exports, "_errMsg", () => $437b23f6a393c3bf$export$680bb5102fca525e);
$parcel$export(module.exports, "_preInitErrMsg", () => $437b23f6a393c3bf$export$d73cab7876c2c868);
$parcel$export(module.exports, "_isClientSideRowModel", () => $437b23f6a393c3bf$export$9f182d9ca737e15);
$parcel$export(module.exports, "_isServerSideRowModel", () => $437b23f6a393c3bf$export$cf1bac0013650216);
$parcel$export(module.exports, "_isDomLayout", () => $437b23f6a393c3bf$export$aa3ea9d0da61306f);
$parcel$export(module.exports, "_isRowSelection", () => $437b23f6a393c3bf$export$5d5fd838f5df1dd2);
$parcel$export(module.exports, "_getRowSelectionMode", () => $437b23f6a393c3bf$export$80b6607444b3274f);
$parcel$export(module.exports, "_isGetRowHeightFunction", () => $437b23f6a393c3bf$export$f0ddd2d4ccc7fed8);
$parcel$export(module.exports, "_getRowHeightForNode", () => $437b23f6a393c3bf$export$b6de5fa3decc8f7b);
$parcel$export(module.exports, "_getRowHeightAsNumber", () => $437b23f6a393c3bf$export$8966875adec41e5b);
$parcel$export(module.exports, "_getDocument", () => $437b23f6a393c3bf$export$f63d0991874c6f81);
$parcel$export(module.exports, "_getActiveDomElement", () => $437b23f6a393c3bf$export$16bc98d422315038);
$parcel$export(module.exports, "_getPageBody", () => $437b23f6a393c3bf$export$50c54e860701cf22);
$parcel$export(module.exports, "_anchorElementToMouseMoveEvent", () => $437b23f6a393c3bf$export$3ce6b987cf48b8c2);
$parcel$export(module.exports, "_isNothingFocused", () => $437b23f6a393c3bf$export$8ff9eef09a45371f);
$parcel$export(module.exports, "_isGroupRowsSticky", () => $437b23f6a393c3bf$export$d5f33aacea6a0849);
$parcel$export(module.exports, "_isColumnsSortingCoupledToGroup", () => $437b23f6a393c3bf$export$96c51c2547b81aed);
$parcel$export(module.exports, "_getGroupAggFiltering", () => $437b23f6a393c3bf$export$3708afee0330994);
$parcel$export(module.exports, "_getGrandTotalRow", () => $437b23f6a393c3bf$export$c6fad27ed643a862);
$parcel$export(module.exports, "_getGroupTotalRowCallback", () => $437b23f6a393c3bf$export$713d6cabeaa7f2a5);
$parcel$export(module.exports, "_isGroupMultiAutoColumn", () => $437b23f6a393c3bf$export$7122eb216a66bef2);
$parcel$export(module.exports, "_isGroupUseEntireRow", () => $437b23f6a393c3bf$export$b911c5b172d227b4);
$parcel$export(module.exports, "_isFullWidthGroupRow", () => $437b23f6a393c3bf$export$410912a9c501b8cc);
$parcel$export(module.exports, "_getRowIdCallback", () => $437b23f6a393c3bf$export$57c3bb2f89b59a89);
$parcel$export(module.exports, "_getMaxConcurrentDatasourceRequests", () => $437b23f6a393c3bf$export$efae4c751fa7cc4d);
$parcel$export(module.exports, "_shouldUpdateColVisibilityAfterGroup", () => $437b23f6a393c3bf$export$d80073cdfb810fa8);
$parcel$export(module.exports, "_getCheckboxes", () => $437b23f6a393c3bf$export$6df3a55606bca6ae);
$parcel$export(module.exports, "_getCheckboxLocation", () => $437b23f6a393c3bf$export$8fb5d781b5c28347);
$parcel$export(module.exports, "_isUsingNewRowSelectionAPI", () => $437b23f6a393c3bf$export$d3c80fcacb2e2d55);
$parcel$export(module.exports, "_isUsingNewCellSelectionAPI", () => $437b23f6a393c3bf$export$63600d24670d494d);
$parcel$export(module.exports, "_getSuppressMultiRanges", () => $437b23f6a393c3bf$export$93073c0b97dd7eba);
$parcel$export(module.exports, "_isCellSelectionEnabled", () => $437b23f6a393c3bf$export$1f7ca6920544d9e4);
$parcel$export(module.exports, "_getFillHandle", () => $437b23f6a393c3bf$export$c96ba82819c56957);
$parcel$export(module.exports, "_isMultiRowSelection", () => $437b23f6a393c3bf$export$7bd8c52ebc4117d6);
$parcel$export(module.exports, "_getGroupSelectsDescendants", () => $437b23f6a393c3bf$export$460e5745f0e6a40d);
$parcel$export(module.exports, "_isSetFilterByDefault", () => $437b23f6a393c3bf$export$b68e6345dc6b83fa);
$parcel$export(module.exports, "_isLegacyMenuEnabled", () => $437b23f6a393c3bf$export$2f1c8e943ce1a1be);
$parcel$export(module.exports, "_isColumnMenuAnchoringEnabled", () => $437b23f6a393c3bf$export$cfe4cf52f3717a7b);
$parcel$export(module.exports, "_combineAttributesAndGridOptions", () => $437b23f6a393c3bf$export$bfe37fc2d3c03134);
$parcel$export(module.exports, "_processOnChange", () => $437b23f6a393c3bf$export$52208033bd24c2b2);
$parcel$export(module.exports, "_addGridCommonParams", () => $437b23f6a393c3bf$export$fcfd03fd78c6cf24);
$parcel$export(module.exports, "_getGroupingApproach", () => $437b23f6a393c3bf$export$e9780a3033a82b4f);
$parcel$export(module.exports, "_getGridOption", () => $437b23f6a393c3bf$export$aa5750e97994dd3);
$parcel$export(module.exports, "_stopPropagationForAgGrid", () => $437b23f6a393c3bf$export$456c40e80134d72a);
$parcel$export(module.exports, "_isStopPropagationForAgGrid", () => $437b23f6a393c3bf$export$9a48e23524c6d58);
$parcel$export(module.exports, "_isElementInEventPath", () => $437b23f6a393c3bf$export$b5446458166e97b4);
$parcel$export(module.exports, "BeanStub", () => $437b23f6a393c3bf$export$2032c8ef3788dfbd);
$parcel$export(module.exports, "_toString", () => $437b23f6a393c3bf$export$a16cfb6652fe466f);
$parcel$export(module.exports, "_escapeString", () => $437b23f6a393c3bf$export$3df06b741968da82);
$parcel$export(module.exports, "isColumn", () => $437b23f6a393c3bf$export$891484e65a02ec71);
$parcel$export(module.exports, "AgColumn", () => $437b23f6a393c3bf$export$a8da3e2b83e5ddf2);
$parcel$export(module.exports, "isProvidedColumnGroup", () => $437b23f6a393c3bf$export$bb4bfad2b594b78e);
$parcel$export(module.exports, "AgProvidedColumnGroup", () => $437b23f6a393c3bf$export$7ff27642a6ecc1cf);
$parcel$export(module.exports, "_EmptyArray", () => $437b23f6a393c3bf$export$c758d9371030a6ac);
$parcel$export(module.exports, "_last", () => $437b23f6a393c3bf$export$236389741107357f);
$parcel$export(module.exports, "_areEqual", () => $437b23f6a393c3bf$export$893967cdb9833fdd);
$parcel$export(module.exports, "_removeFromArray", () => $437b23f6a393c3bf$export$83a881c8b5120679);
$parcel$export(module.exports, "_flatten", () => $437b23f6a393c3bf$export$5e3f39c5068e375d);
$parcel$export(module.exports, "GROUP_AUTO_COLUMN_ID", () => $437b23f6a393c3bf$export$a7016588c430dba6);
$parcel$export(module.exports, "ROW_NUMBERS_COLUMN_ID", () => $437b23f6a393c3bf$export$f55c01dfb205b029);
$parcel$export(module.exports, "_getColumnsFromTree", () => $437b23f6a393c3bf$export$42da2aea8fab5b);
$parcel$export(module.exports, "_destroyColumnTree", () => $437b23f6a393c3bf$export$dbaaa57234b60d8f);
$parcel$export(module.exports, "isColumnGroupAutoCol", () => $437b23f6a393c3bf$export$61b34611dc010a97);
$parcel$export(module.exports, "isColumnSelectionCol", () => $437b23f6a393c3bf$export$f6074a9792015c5d);
$parcel$export(module.exports, "isRowNumberCol", () => $437b23f6a393c3bf$export$3d3e7d751f0445eb);
$parcel$export(module.exports, "isSpecialCol", () => $437b23f6a393c3bf$export$ee97d5717f8d44ec);
$parcel$export(module.exports, "_areColIdsEqual", () => $437b23f6a393c3bf$export$f56e341a1fe35ed4);
$parcel$export(module.exports, "_updateColsMap", () => $437b23f6a393c3bf$export$c82fd63ff1738bed);
$parcel$export(module.exports, "_convertColumnEventSourceType", () => $437b23f6a393c3bf$export$eb2a92b6162267d1);
$parcel$export(module.exports, "_columnsMatch", () => $437b23f6a393c3bf$export$f5687d41c39fa1b3);
$parcel$export(module.exports, "_createColumnTreeWithIds", () => $437b23f6a393c3bf$export$575b8d8234793d75);
$parcel$export(module.exports, "_addColumnDefaultAndTypes", () => $437b23f6a393c3bf$export$310bdd432cb2279e);
$parcel$export(module.exports, "_createColumnTree", () => $437b23f6a393c3bf$export$e03b26088dedc2ab);
$parcel$export(module.exports, "_applyColumnState", () => $437b23f6a393c3bf$export$b2854c1cb8f10386);
$parcel$export(module.exports, "_resetColumnState", () => $437b23f6a393c3bf$export$96a6cbc000255060);
$parcel$export(module.exports, "BaseColsService", () => $437b23f6a393c3bf$export$3687f0f5678a5df3);
$parcel$export(module.exports, "_EmptyBean", () => $437b23f6a393c3bf$export$4f8bbae47c6ad8d2);
$parcel$export(module.exports, "CssClassManager", () => $437b23f6a393c3bf$export$a7053cb7eb605bd2);
$parcel$export(module.exports, "RefPlaceholder", () => $437b23f6a393c3bf$export$6c811454646ed8be);
$parcel$export(module.exports, "Component", () => $437b23f6a393c3bf$export$16fa2f45be04daa8);
$parcel$export(module.exports, "_isPromise", () => $437b23f6a393c3bf$export$2395b9dc826192b2);
$parcel$export(module.exports, "AgPromise", () => $437b23f6a393c3bf$export$30ec7836a4847721);
$parcel$export(module.exports, "_getInnerCellRendererDetails", () => $437b23f6a393c3bf$export$c3f4e745c2fdf1c0);
$parcel$export(module.exports, "_getCellRendererDetails", () => $437b23f6a393c3bf$export$1f172e021e4d8401);
$parcel$export(module.exports, "_getEditorRendererDetails", () => $437b23f6a393c3bf$export$85a10ea90cfc8a53);
$parcel$export(module.exports, "_getFilterDetails", () => $437b23f6a393c3bf$export$e6db9a2d59456da0);
$parcel$export(module.exports, "_getFloatingFilterCompDetails", () => $437b23f6a393c3bf$export$14d0998f093f007e);
$parcel$export(module.exports, "_unwrapUserComp", () => $437b23f6a393c3bf$export$213d4c63c3df47e4);
$parcel$export(module.exports, "_getGridRegisteredModules", () => $437b23f6a393c3bf$export$7c244c452cd4b417);
$parcel$export(module.exports, "ModuleRegistry", () => $437b23f6a393c3bf$export$dc053975cc7f6c11);
$parcel$export(module.exports, "_createCellId", () => $437b23f6a393c3bf$export$c0c5a5ba9327269f);
$parcel$export(module.exports, "_areCellsEqual", () => $437b23f6a393c3bf$export$be3973033c2c5267);
$parcel$export(module.exports, "_isRowBefore", () => $437b23f6a393c3bf$export$6cce97428a227a31);
$parcel$export(module.exports, "_isSameRow", () => $437b23f6a393c3bf$export$de6f9fa10e9f4188);
$parcel$export(module.exports, "_getLastRow", () => $437b23f6a393c3bf$export$a1449222017e428);
$parcel$export(module.exports, "_getRowNode", () => $437b23f6a393c3bf$export$d4675a60917db7b0);
$parcel$export(module.exports, "_getCellByPosition", () => $437b23f6a393c3bf$export$1bd7ce47360c3c0);
$parcel$export(module.exports, "_getRowAbove", () => $437b23f6a393c3bf$export$b36b14fdaf41f4d8);
$parcel$export(module.exports, "_getRowBelow", () => $437b23f6a393c3bf$export$3077f3bcabdc5ad1);
$parcel$export(module.exports, "_getHeaderClassesFromColDef", () => $437b23f6a393c3bf$export$9ba3bd48c77c5e8a);
$parcel$export(module.exports, "_getToolPanelClassesFromColDef", () => $437b23f6a393c3bf$export$1784132bab54c462);
$parcel$export(module.exports, "KeyCode", () => $437b23f6a393c3bf$export$e9e0d96f49f57c33);
$parcel$export(module.exports, "_isKeyboardMode", () => $437b23f6a393c3bf$export$e4c8c227337b7f23);
$parcel$export(module.exports, "_addFocusableContainerListener", () => $437b23f6a393c3bf$export$8865b8c867776648);
$parcel$export(module.exports, "_findNextFocusableElement", () => $437b23f6a393c3bf$export$83fc12531358bd28);
$parcel$export(module.exports, "_focusNextGridCoreContainer", () => $437b23f6a393c3bf$export$987f3c95dc941f0c);
$parcel$export(module.exports, "_findFocusableElements", () => $437b23f6a393c3bf$export$7acf44f59625b1f6);
$parcel$export(module.exports, "_focusInto", () => $437b23f6a393c3bf$export$8598088d375f416f);
$parcel$export(module.exports, "_findTabbableParent", () => $437b23f6a393c3bf$export$c4c49c776025d475);
$parcel$export(module.exports, "_focusGridInnerElement", () => $437b23f6a393c3bf$export$b3beea4db79d8bb3);
$parcel$export(module.exports, "_interpretAsRightClick", () => $437b23f6a393c3bf$export$f8093014f10b296a);
$parcel$export(module.exports, "_getCellCtrlForEventTarget", () => $437b23f6a393c3bf$export$b5bf61dcea514250);
$parcel$export(module.exports, "_getCellPositionForEvent", () => $437b23f6a393c3bf$export$d85fcb0e6e51242);
$parcel$export(module.exports, "_getNormalisedMousePosition", () => $437b23f6a393c3bf$export$530c24bdfacb8cd1);
$parcel$export(module.exports, "DragSourceType", () => $437b23f6a393c3bf$export$46ba5a92125911d9);
$parcel$export(module.exports, "_ROW_ID_PREFIX_ROW_GROUP", () => $437b23f6a393c3bf$export$cb038fdaa8338d9f);
$parcel$export(module.exports, "RowNode", () => $437b23f6a393c3bf$export$6af91cd58ec2edf9);
$parcel$export(module.exports, "_createGlobalRowEvent", () => $437b23f6a393c3bf$export$5c5bd6257397e1bc);
$parcel$export(module.exports, "_createRowNodeSibling", () => $437b23f6a393c3bf$export$48fabbbfcde9fe36);
$parcel$export(module.exports, "_refreshHandlerAndUi", () => $437b23f6a393c3bf$export$1fc9ad198b29415d);
$parcel$export(module.exports, "_refreshFilterUi", () => $437b23f6a393c3bf$export$8e370ccb0273c891);
$parcel$export(module.exports, "_updateFilterModel", () => $437b23f6a393c3bf$export$3305e8c6f4c8572a);
$parcel$export(module.exports, "_getFilterModel", () => $437b23f6a393c3bf$export$8981db65da4532f2);
$parcel$export(module.exports, "FilterButtonComp", () => $437b23f6a393c3bf$export$226c2a54d31bd592);
$parcel$export(module.exports, "AgFilterButtonSelector", () => $437b23f6a393c3bf$export$4a8eed8acd632fcc);
$parcel$export(module.exports, "_translateForFilter", () => $437b23f6a393c3bf$export$e2a0ae4af921fff8);
$parcel$export(module.exports, "_isUseApplyButton", () => $437b23f6a393c3bf$export$527c1b777ebd9069);
$parcel$export(module.exports, "FilterWrapperComp", () => $437b23f6a393c3bf$export$70acaf0e0e30e7d);
$parcel$export(module.exports, "FilterComp", () => $437b23f6a393c3bf$export$7db6d402989d8b90);
$parcel$export(module.exports, "_serialiseDate", () => $437b23f6a393c3bf$export$3d7fedfb21962874);
$parcel$export(module.exports, "_getDateParts", () => $437b23f6a393c3bf$export$bb4eb333cc2b3e25);
$parcel$export(module.exports, "_parseDateTimeFromString", () => $437b23f6a393c3bf$export$26ded2d88c01b527);
$parcel$export(module.exports, "_getFilterParamsForDataType", () => $437b23f6a393c3bf$export$4a99b58ce484acc);
$parcel$export(module.exports, "_getDefaultSimpleFilter", () => $437b23f6a393c3bf$export$4a4e3cf6acc7e93);
$parcel$export(module.exports, "PositionableFeature", () => $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6);
$parcel$export(module.exports, "_FOCUS_MANAGED_CLASS", () => $437b23f6a393c3bf$export$e24a3eb8593af8d8);
$parcel$export(module.exports, "ManagedFocusFeature", () => $437b23f6a393c3bf$export$5510e53ed3962582);
$parcel$export(module.exports, "ProvidedFilter", () => $437b23f6a393c3bf$export$a927a1327c2cc7f0);
$parcel$export(module.exports, "_getDefaultFloatingFilterType", () => $437b23f6a393c3bf$export$47072b32bdaf5d61);
$parcel$export(module.exports, "Direction", () => $437b23f6a393c3bf$export$cacd6541cfeeb6c1);
$parcel$export(module.exports, "_isEventFromPrintableCharacter", () => $437b23f6a393c3bf$export$33ecd6e270298858);
$parcel$export(module.exports, "_selectAllCells", () => $437b23f6a393c3bf$export$57896ee3d2f5a3d);
$parcel$export(module.exports, "_getRowViewportClass", () => $437b23f6a393c3bf$export$65619730ec980d6a);
$parcel$export(module.exports, "_getRowContainerOptions", () => $437b23f6a393c3bf$export$a46aad9f8c79261f);
$parcel$export(module.exports, "_getRowContainerClass", () => $437b23f6a393c3bf$export$35e1b2dddf7fc6e9);
$parcel$export(module.exports, "_getRowSpanContainerClass", () => $437b23f6a393c3bf$export$cd6b90bdf6c4fcfd);
$parcel$export(module.exports, "RowContainerCtrl", () => $437b23f6a393c3bf$export$2d4385f6f566fe5e);
$parcel$export(module.exports, "GridBodyCtrl", () => $437b23f6a393c3bf$export$8bebc3145b40d221);
$parcel$export(module.exports, "FakeHScrollComp", () => $437b23f6a393c3bf$export$8f252e09ef6be2d3);
$parcel$export(module.exports, "FakeVScrollComp", () => $437b23f6a393c3bf$export$f496fc30dbebdfa3);
$parcel$export(module.exports, "_getHeaderRowCount", () => $437b23f6a393c3bf$export$4861f2356b3fc2d7);
$parcel$export(module.exports, "_getFloatingFiltersHeight", () => $437b23f6a393c3bf$export$b52d5533bf5be44);
$parcel$export(module.exports, "GridHeaderCtrl", () => $437b23f6a393c3bf$export$20b300eb69ca4d09);
$parcel$export(module.exports, "HeaderRowContainerCtrl", () => $437b23f6a393c3bf$export$1e864ee88f54e7b);
$parcel$export(module.exports, "_setColMenuVisible", () => $437b23f6a393c3bf$export$2f1bf9feac2f7fbd);
$parcel$export(module.exports, "PopupComponent", () => $437b23f6a393c3bf$export$9fac2d040f3ed438);
$parcel$export(module.exports, "AgAbstractCellEditor", () => $437b23f6a393c3bf$export$803b08aecd9af1a9);
$parcel$export(module.exports, "_createIcon", () => $437b23f6a393c3bf$export$f4e9fbdaadc5e5c1);
$parcel$export(module.exports, "_createIconNoSpan", () => $437b23f6a393c3bf$export$d8feba07bf373edb);
$parcel$export(module.exports, "AgAbstractLabel", () => $437b23f6a393c3bf$export$d72ea6e1c340e03b);
$parcel$export(module.exports, "AgAbstractInputField", () => $437b23f6a393c3bf$export$9671f513d4aa42e3);
$parcel$export(module.exports, "AgCheckbox", () => $437b23f6a393c3bf$export$b00c508c1ae18d07);
$parcel$export(module.exports, "AgCheckboxSelector", () => $437b23f6a393c3bf$export$2e2c317d2e31f2ca);
$parcel$export(module.exports, "AbstractClientSideNodeManager", () => $437b23f6a393c3bf$export$4d7e4be6cbba058c);
$parcel$export(module.exports, "ServerSideTransactionResultStatus", () => $437b23f6a393c3bf$export$58e95be8934cbc38);
$parcel$export(module.exports, "BaseSelectionService", () => $437b23f6a393c3bf$export$3d7b168c0c9c2a78);
$parcel$export(module.exports, "AgToggleButton", () => $437b23f6a393c3bf$export$167b21bf245ce0bf);
$parcel$export(module.exports, "AgToggleButtonSelector", () => $437b23f6a393c3bf$export$b825a5135f318030);
$parcel$export(module.exports, "AgInputTextField", () => $437b23f6a393c3bf$export$8c027679838afd47);
$parcel$export(module.exports, "AgInputTextFieldSelector", () => $437b23f6a393c3bf$export$31e2985be4ee06ab);
$parcel$export(module.exports, "AgInputNumberField", () => $437b23f6a393c3bf$export$c8aa0be99738aee);
$parcel$export(module.exports, "AgInputNumberFieldSelector", () => $437b23f6a393c3bf$export$c18153c9c909b7d7);
$parcel$export(module.exports, "AgInputDateField", () => $437b23f6a393c3bf$export$9e01ec8ba43de612);
$parcel$export(module.exports, "AgPickerField", () => $437b23f6a393c3bf$export$1f14489b6fdeb99b);
$parcel$export(module.exports, "AgSelect", () => $437b23f6a393c3bf$export$6f9c460854d56032);
$parcel$export(module.exports, "AgSelectSelector", () => $437b23f6a393c3bf$export$e32612175ad118ef);
$parcel$export(module.exports, "TabGuardClassNames", () => $437b23f6a393c3bf$export$3be5727576441c72);
$parcel$export(module.exports, "TabGuardCtrl", () => $437b23f6a393c3bf$export$3074753638c3772c);
$parcel$export(module.exports, "TabGuardFeature", () => $437b23f6a393c3bf$export$299cbf451479e921);
$parcel$export(module.exports, "TabGuardComp", () => $437b23f6a393c3bf$export$5a26e3abd1c845b6);
$parcel$export(module.exports, "TouchListener", () => $437b23f6a393c3bf$export$7b2e93987414b382);
$parcel$export(module.exports, "CellRangeType", () => $437b23f6a393c3bf$export$162bc75b85f28397);
$parcel$export(module.exports, "AutoScrollService", () => $437b23f6a393c3bf$export$c66bdc3d55a4f95);
$parcel$export(module.exports, "VanillaFrameworkOverrides", () => $437b23f6a393c3bf$export$8174ad74937c6482);
$parcel$export(module.exports, "GridCtrl", () => $437b23f6a393c3bf$export$f3c741dac0be9745);
$parcel$export(module.exports, "ChangedPath", () => $437b23f6a393c3bf$export$cb4d9114a9732e85);
$parcel$export(module.exports, "_DragModule", () => $437b23f6a393c3bf$export$e88a21946d283d22);
$parcel$export(module.exports, "_SharedDragAndDropModule", () => $437b23f6a393c3bf$export$4ad116d131ade5b4);
$parcel$export(module.exports, "_HorizontalResizeModule", () => $437b23f6a393c3bf$export$57b5b4ab4a8a663e);
$parcel$export(module.exports, "_ColumnMoveModule", () => $437b23f6a393c3bf$export$1458fbffed29c925);
$parcel$export(module.exports, "_ColumnGroupModule", () => $437b23f6a393c3bf$export$922da35340a6d14e);
$parcel$export(module.exports, "colorSchemeDark", () => $437b23f6a393c3bf$export$cd586495722a2c01);
$parcel$export(module.exports, "themeQuartz", () => $437b23f6a393c3bf$export$495b90cf446940a1);
$parcel$export(module.exports, "_KeyboardNavigationModule", () => $437b23f6a393c3bf$export$44f04c51d8088336);
$parcel$export(module.exports, "_SortModule", () => $437b23f6a393c3bf$export$1a6625c5691649e8);
$parcel$export(module.exports, "_fuzzySuggestions", () => $437b23f6a393c3bf$export$85cab1b5a4aa292c);
$parcel$export(module.exports, "createGrid", () => $437b23f6a393c3bf$export$fce123c48a7b4eae);
$parcel$export(module.exports, "GridCoreCreator", () => $437b23f6a393c3bf$export$7759b93c6200a2f9);
$parcel$export(module.exports, "_getClientSideRowModel", () => $437b23f6a393c3bf$export$f5285e6f27a03f95);
$parcel$export(module.exports, "_getServerSideRowModel", () => $437b23f6a393c3bf$export$aada92189a74e985);
$parcel$export(module.exports, "BaseComponentWrapper", () => $437b23f6a393c3bf$export$157f014d661b6f19);
$parcel$export(module.exports, "_isShowTooltipWhenTruncated", () => $437b23f6a393c3bf$export$58660753196c7cdf);
$parcel$export(module.exports, "_getShouldDisplayTooltip", () => $437b23f6a393c3bf$export$75f51ed61a5271e6);
$parcel$export(module.exports, "_formatNumberCommas", () => $437b23f6a393c3bf$export$c8980add4a69422e);
$parcel$export(module.exports, "BaseCreator", () => $437b23f6a393c3bf$export$b335f23c5aead909);
$parcel$export(module.exports, "BaseGridSerializingSession", () => $437b23f6a393c3bf$export$5018ab277b833b61);
$parcel$export(module.exports, "_downloadFile", () => $437b23f6a393c3bf$export$97aef6bcdc3f7ef5);
$parcel$export(module.exports, "_SharedMenuModule", () => $437b23f6a393c3bf$export$b0ea578339daf1f7);
$parcel$export(module.exports, "_PopupModule", () => $437b23f6a393c3bf$export$da5c9bb998e6c24d);
$parcel$export(module.exports, "_FilterCoreModule", () => $437b23f6a393c3bf$export$b8779358eaaabc87);
$parcel$export(module.exports, "_FilterValueModule", () => $437b23f6a393c3bf$export$55e846ac25ec4cc0);
$parcel$export(module.exports, "_ColumnFilterModule", () => $437b23f6a393c3bf$export$bee7a6b8183a1c61);
$parcel$export(module.exports, "TooltipModule", () => $437b23f6a393c3bf$export$d0c662c133b8814e);
$parcel$export(module.exports, "_EditCoreModule", () => $437b23f6a393c3bf$export$12c61a50add34259);
$parcel$export(module.exports, "_SharedRowSelectionModule", () => $437b23f6a393c3bf$export$16cbd1164b82410d);
$parcel$export(module.exports, "_CsrmSsrmSharedApiModule", () => $437b23f6a393c3bf$export$76fb120d9e251426);
$parcel$export(module.exports, "_SsrmInfiniteSharedApiModule", () => $437b23f6a393c3bf$export$2f6740e35dedc261);
$parcel$export(module.exports, "_SharedExportModule", () => $437b23f6a393c3bf$export$e6030935e93fda2b);
$parcel$export(module.exports, "CsvExportModule", () => $437b23f6a393c3bf$export$f744275d8b795fc2);
$parcel$export(module.exports, "HighlightChangesModule", () => $437b23f6a393c3bf$export$98e8472b11750a07);
$parcel$export(module.exports, "CellStyleModule", () => $437b23f6a393c3bf$export$be75c2ed74fb2144);
$parcel$export(module.exports, "EventApiModule", () => $437b23f6a393c3bf$export$d20c5df25778eac8);
$parcel$export(module.exports, "AllCommunityModule", () => $437b23f6a393c3bf$export$526323caf9d1af13);
// packages/ag-grid-community/src/localEventService.ts
var $437b23f6a393c3bf$export$820da7696a401cdc = class {
    constructor(){
        this.allSyncListeners = /* @__PURE__ */ new Map();
        this.allAsyncListeners = /* @__PURE__ */ new Map();
        this.globalSyncListeners = /* @__PURE__ */ new Set();
        this.globalAsyncListeners = /* @__PURE__ */ new Set();
        this.asyncFunctionsQueue = [];
        this.scheduled = false;
        // using an object performs better than a Set for the number of different events we have
        this.firedEvents = {};
    }
    setFrameworkOverrides(frameworkOverrides) {
        this.frameworkOverrides = frameworkOverrides;
    }
    getListeners(eventType, async, autoCreateListenerCollection) {
        const listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
        let listeners = listenerMap.get(eventType);
        if (!listeners && autoCreateListenerCollection) {
            listeners = /* @__PURE__ */ new Set();
            listenerMap.set(eventType, listeners);
        }
        return listeners;
    }
    noRegisteredListenersExist() {
        return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 && this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
    }
    addEventListener(eventType, listener, async = false) {
        this.getListeners(eventType, async, true).add(listener);
    }
    removeEventListener(eventType, listener, async = false) {
        const listeners = this.getListeners(eventType, async, false);
        if (!listeners) return;
        listeners.delete(listener);
        if (listeners.size === 0) (async ? this.allAsyncListeners : this.allSyncListeners).delete(eventType);
    }
    addGlobalListener(listener, async = false) {
        this.getGlobalListeners(async).add(listener);
    }
    removeGlobalListener(listener, async = false) {
        this.getGlobalListeners(async).delete(listener);
    }
    dispatchEvent(event) {
        this.dispatchToListeners(event, true);
        this.dispatchToListeners(event, false);
        this.firedEvents[event.type] = true;
    }
    dispatchEventOnce(event) {
        if (!this.firedEvents[event.type]) this.dispatchEvent(event);
    }
    dispatchToListeners(event, async) {
        const eventType = event.type;
        if (async && "event" in event) {
            const browserEvent = event.event;
            if (browserEvent instanceof Event) event.eventPath = browserEvent.composedPath();
        }
        const { frameworkOverrides: frameworkOverrides } = this;
        const runCallback = (func)=>{
            const callback = frameworkOverrides ? ()=>frameworkOverrides.wrapIncoming(func) : func;
            if (async) this.dispatchAsync(callback);
            else callback();
        };
        const originalListeners = this.getListeners(eventType, async, false);
        if ((originalListeners?.size ?? 0) > 0) {
            const listeners = new Set(originalListeners);
            for (const listener of listeners){
                if (!originalListeners?.has(listener)) continue;
                runCallback(()=>listener(event));
            }
        }
        const globalListenersSrc = this.getGlobalListeners(async);
        if (globalListenersSrc.size > 0) {
            const globalListeners = new Set(globalListenersSrc);
            for (const listener of globalListeners)runCallback(()=>listener(eventType, event));
        }
    }
    getGlobalListeners(async) {
        return async ? this.globalAsyncListeners : this.globalSyncListeners;
    }
    // this gets called inside the grid's thread, for each event that it
    // wants to set async. the grid then batches the events into one setTimeout()
    // because setTimeout() is an expensive operation. ideally we would have
    // each event in it's own setTimeout(), but we batch for performance.
    dispatchAsync(func) {
        this.asyncFunctionsQueue.push(func);
        if (!this.scheduled) {
            const flush = ()=>{
                window.setTimeout(this.flushAsyncQueue.bind(this), 0);
            };
            this.frameworkOverrides ? this.frameworkOverrides.wrapIncoming(flush) : flush();
            this.scheduled = true;
        }
    }
    // this happens in the next VM turn only, and empties the queue of events
    flushAsyncQueue() {
        this.scheduled = false;
        const queueCopy = this.asyncFunctionsQueue.slice();
        this.asyncFunctionsQueue = [];
        queueCopy.forEach((func)=>func());
    }
};
// packages/ag-grid-community/src/misc/locale/localeUtils.ts
function $437b23f6a393c3bf$var$defaultLocaleTextFunc(_key, defaultValue) {
    return defaultValue;
}
function $437b23f6a393c3bf$export$cc0bf4adff5b95e7(localeSvc) {
    return localeSvc?.getLocaleTextFunc() ?? $437b23f6a393c3bf$var$defaultLocaleTextFunc;
}
function $437b23f6a393c3bf$export$4ad3db330991f17d(bean, localeValues, key, variableValues) {
    const defaultValue = localeValues[key];
    return bean.getLocaleTextFunc()(key, typeof defaultValue === "function" ? defaultValue(variableValues) : defaultValue, variableValues);
}
// packages/ag-grid-community/src/utils/generic.ts
function $437b23f6a393c3bf$export$4978424c4f7b5fc0(value) {
    if (value == null || value === "") return null;
    return value;
}
function $437b23f6a393c3bf$export$25d27f17d3af40f7(value) {
    return value != null && value !== "";
}
function $437b23f6a393c3bf$export$672d9e47bc342bac(value) {
    return !$437b23f6a393c3bf$export$25d27f17d3af40f7(value);
}
function $437b23f6a393c3bf$export$2a74c29220d5c88e(value) {
    return value != null && typeof value.toString === "function" ? value.toString() : null;
}
function $437b23f6a393c3bf$export$dbc2068cc90f5875(val1, val2) {
    const val1Json = val1 ? JSON.stringify(val1) : null;
    const val2Json = val2 ? JSON.stringify(val2) : null;
    return val1Json === val2Json;
}
function $437b23f6a393c3bf$export$b0cca9f3c87c8df8(valueA, valueB, accentedCompare = false) {
    const valueAMissing = valueA == null;
    const valueBMissing = valueB == null;
    if (valueA && valueA.toNumber) valueA = valueA.toNumber();
    if (valueB && valueB.toNumber) valueB = valueB.toNumber();
    if (valueAMissing && valueBMissing) return 0;
    if (valueAMissing) return -1;
    if (valueBMissing) return 1;
    function doQuickCompare(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }
    if (typeof valueA !== "string") return doQuickCompare(valueA, valueB);
    if (!accentedCompare) return doQuickCompare(valueA, valueB);
    try {
        return valueA.localeCompare(valueB);
    } catch (e) {
        return doQuickCompare(valueA, valueB);
    }
}
// packages/ag-grid-community/src/utils/object.ts
var $437b23f6a393c3bf$var$SKIP_JS_BUILTINS = /* @__PURE__ */ new Set([
    "__proto__",
    "constructor",
    "prototype"
]);
function $437b23f6a393c3bf$var$_iterateObject(object, callback) {
    if (object == null) return;
    if (Array.isArray(object)) {
        for(let i = 0; i < object.length; i++)callback(i.toString(), object[i]);
        return;
    }
    for (const key of Object.keys(object).filter((key2)=>!$437b23f6a393c3bf$var$SKIP_JS_BUILTINS.has(key2)))callback(key, object[key]);
}
function $437b23f6a393c3bf$export$8ade6bd474fcde42(dest, source, copyUndefined = true, makeCopyOfSimpleObjects = false) {
    if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(source)) return;
    $437b23f6a393c3bf$var$_iterateObject(source, (key, sourceValue)=>{
        let destValue = dest[key];
        if (destValue === sourceValue) return;
        if (makeCopyOfSimpleObjects) {
            const objectIsDueToBeCopied = destValue == null && sourceValue != null;
            if (objectIsDueToBeCopied) {
                const doNotCopyAsSourceIsSimpleObject = typeof sourceValue === "object" && sourceValue.constructor === Object;
                if (doNotCopyAsSourceIsSimpleObject) {
                    destValue = {};
                    dest[key] = destValue;
                }
            }
        }
        if ($437b23f6a393c3bf$var$_isNonNullObject(sourceValue) && $437b23f6a393c3bf$var$_isNonNullObject(destValue) && !Array.isArray(destValue)) $437b23f6a393c3bf$export$8ade6bd474fcde42(destValue, sourceValue, copyUndefined, makeCopyOfSimpleObjects);
        else if (copyUndefined || sourceValue !== void 0) dest[key] = sourceValue;
    });
}
function $437b23f6a393c3bf$var$_getValueUsingField(data, field, fieldContainsDots) {
    if (!field || !data) return;
    if (!fieldContainsDots) return data[field];
    const fields = field.split(".");
    let currentObject = data;
    for(let i = 0; i < fields.length; i++){
        if (currentObject == null) return void 0;
        currentObject = currentObject[fields[i]];
    }
    return currentObject;
}
function $437b23f6a393c3bf$var$_isNonNullObject(value) {
    return typeof value === "object" && value !== null;
}
// packages/ag-grid-community/src/globalGridOptions.ts
var $437b23f6a393c3bf$var$_GlobalGridOptions = class _GlobalGridOptions {
    /**
   * @param providedOptions
   * @returns Shallow copy of the provided options with global options merged in.
   */ static applyGlobalGridOptions(providedOptions) {
        if (!_GlobalGridOptions.gridOptions) return {
            ...providedOptions
        };
        let mergedGridOps = {};
        $437b23f6a393c3bf$export$8ade6bd474fcde42(mergedGridOps, _GlobalGridOptions.gridOptions, true, true);
        if (_GlobalGridOptions.mergeStrategy === "deep") $437b23f6a393c3bf$export$8ade6bd474fcde42(mergedGridOps, providedOptions, true, true);
        else mergedGridOps = {
            ...mergedGridOps,
            ...providedOptions
        };
        if (_GlobalGridOptions.gridOptions.context) mergedGridOps.context = _GlobalGridOptions.gridOptions.context;
        if (providedOptions.context) {
            if (_GlobalGridOptions.mergeStrategy === "deep" && mergedGridOps.context) $437b23f6a393c3bf$export$8ade6bd474fcde42(providedOptions.context, mergedGridOps.context, true, true);
            mergedGridOps.context = providedOptions.context;
        }
        return mergedGridOps;
    }
};
$437b23f6a393c3bf$var$_GlobalGridOptions.gridOptions = void 0;
$437b23f6a393c3bf$var$_GlobalGridOptions.mergeStrategy = "shallow";
var $437b23f6a393c3bf$var$GlobalGridOptions = $437b23f6a393c3bf$var$_GlobalGridOptions;
function $437b23f6a393c3bf$export$9def8154c643bfd1(gridOptions, mergeStrategy = "shallow") {
    $437b23f6a393c3bf$var$GlobalGridOptions.gridOptions = gridOptions;
    $437b23f6a393c3bf$var$GlobalGridOptions.mergeStrategy = mergeStrategy;
}
function $437b23f6a393c3bf$export$c3524a7ed99826d4(gridOption) {
    return $437b23f6a393c3bf$var$GlobalGridOptions.gridOptions?.[gridOption];
}
// packages/ag-grid-community/src/gridOptionsDefault.ts
var $437b23f6a393c3bf$var$GRID_OPTION_DEFAULTS = {
    suppressContextMenu: false,
    preventDefaultOnContextMenu: false,
    allowContextMenuWithControlKey: false,
    suppressMenuHide: true,
    enableBrowserTooltips: false,
    tooltipTrigger: "hover",
    tooltipShowDelay: 2e3,
    tooltipHideDelay: 1e4,
    tooltipMouseTrack: false,
    tooltipShowMode: "standard",
    tooltipInteraction: false,
    copyHeadersToClipboard: false,
    copyGroupHeadersToClipboard: false,
    clipboardDelimiter: "	",
    suppressCopyRowsToClipboard: false,
    suppressCopySingleCellRanges: false,
    suppressLastEmptyLineOnPaste: false,
    suppressClipboardPaste: false,
    suppressClipboardApi: false,
    suppressCutToClipboard: false,
    maintainColumnOrder: false,
    enableStrictPivotColumnOrder: false,
    suppressFieldDotNotation: false,
    allowDragFromColumnsToolPanel: false,
    suppressMovableColumns: false,
    suppressColumnMoveAnimation: false,
    suppressMoveWhenColumnDragging: false,
    suppressDragLeaveHidesColumns: false,
    suppressRowGroupHidesColumns: false,
    suppressAutoSize: false,
    autoSizePadding: 20,
    skipHeaderOnAutoSize: false,
    singleClickEdit: false,
    suppressClickEdit: false,
    readOnlyEdit: false,
    stopEditingWhenCellsLoseFocus: false,
    enterNavigatesVertically: false,
    enterNavigatesVerticallyAfterEdit: false,
    enableCellEditingOnBackspace: false,
    undoRedoCellEditing: false,
    undoRedoCellEditingLimit: 10,
    suppressCsvExport: false,
    suppressExcelExport: false,
    cacheQuickFilter: false,
    includeHiddenColumnsInQuickFilter: false,
    excludeChildrenWhenTreeDataFiltering: false,
    enableAdvancedFilter: false,
    includeHiddenColumnsInAdvancedFilter: false,
    enableCharts: false,
    masterDetail: false,
    keepDetailRows: false,
    keepDetailRowsCount: 10,
    detailRowAutoHeight: false,
    tabIndex: 0,
    rowBuffer: 10,
    valueCache: false,
    valueCacheNeverExpires: false,
    enableCellExpressions: false,
    suppressTouch: false,
    suppressFocusAfterRefresh: false,
    suppressBrowserResizeObserver: false,
    suppressPropertyNamesCheck: false,
    suppressChangeDetection: false,
    debug: false,
    suppressLoadingOverlay: false,
    suppressNoRowsOverlay: false,
    pagination: false,
    paginationPageSize: 100,
    paginationPageSizeSelector: true,
    paginationAutoPageSize: false,
    paginateChildRows: false,
    suppressPaginationPanel: false,
    pivotMode: false,
    pivotPanelShow: "never",
    pivotDefaultExpanded: 0,
    pivotSuppressAutoColumn: false,
    suppressExpandablePivotGroups: false,
    functionsReadOnly: false,
    suppressAggFuncInHeader: false,
    alwaysAggregateAtRootLevel: false,
    aggregateOnlyChangedColumns: false,
    suppressAggFilteredOnly: false,
    removePivotHeaderRowWhenSingleValueColumn: false,
    animateRows: true,
    cellFlashDuration: 500,
    cellFadeDuration: 1e3,
    allowShowChangeAfterFilter: false,
    domLayout: "normal",
    ensureDomOrder: false,
    enableRtl: false,
    suppressColumnVirtualisation: false,
    suppressMaxRenderedRowRestriction: false,
    suppressRowVirtualisation: false,
    rowDragManaged: false,
    rowDragInsertDelay: 500,
    suppressRowDrag: false,
    suppressMoveWhenRowDragging: false,
    rowDragEntireRow: false,
    rowDragMultiRow: false,
    embedFullWidthRows: false,
    groupDisplayType: "singleColumn",
    groupDefaultExpanded: 0,
    groupMaintainOrder: false,
    groupSelectsChildren: false,
    groupSuppressBlankHeader: false,
    groupSelectsFiltered: false,
    showOpenedGroup: false,
    groupRemoveSingleChildren: false,
    groupRemoveLowestSingleChildren: false,
    groupHideOpenParents: false,
    groupAllowUnbalanced: false,
    rowGroupPanelShow: "never",
    suppressMakeColumnVisibleAfterUnGroup: false,
    treeData: false,
    rowGroupPanelSuppressSort: false,
    suppressGroupRowsSticky: false,
    rowModelType: "clientSide",
    asyncTransactionWaitMillis: 50,
    suppressModelUpdateAfterUpdateTransaction: false,
    cacheOverflowSize: 1,
    infiniteInitialRowCount: 1,
    serverSideInitialRowCount: 1,
    cacheBlockSize: 100,
    maxBlocksInCache: -1,
    maxConcurrentDatasourceRequests: 2,
    blockLoadDebounceMillis: 0,
    purgeClosedRowNodes: false,
    serverSideSortAllLevels: false,
    serverSideOnlyRefreshFilteredGroups: false,
    serverSidePivotResultFieldSeparator: "_",
    viewportRowModelPageSize: 5,
    viewportRowModelBufferSize: 5,
    alwaysShowHorizontalScroll: false,
    alwaysShowVerticalScroll: false,
    debounceVerticalScrollbar: false,
    suppressHorizontalScroll: false,
    suppressScrollOnNewData: false,
    suppressScrollWhenPopupsAreOpen: false,
    suppressAnimationFrame: false,
    suppressMiddleClickScrolls: false,
    suppressPreventDefaultOnMouseWheel: false,
    rowMultiSelectWithClick: false,
    suppressRowDeselection: false,
    suppressRowClickSelection: false,
    suppressCellFocus: false,
    suppressHeaderFocus: false,
    suppressMultiRangeSelection: false,
    enableCellTextSelection: false,
    enableRangeSelection: false,
    enableRangeHandle: false,
    enableFillHandle: false,
    fillHandleDirection: "xy",
    suppressClearOnFillReduction: false,
    accentedSort: false,
    unSortIcon: false,
    suppressMultiSort: false,
    alwaysMultiSort: false,
    suppressMaintainUnsortedOrder: false,
    suppressRowHoverHighlight: false,
    suppressRowTransform: false,
    columnHoverHighlight: false,
    deltaSort: false,
    enableGroupEdit: false,
    groupLockGroupColumns: 0,
    serverSideEnableClientSideSort: false,
    suppressServerSideFullWidthLoadingRow: false,
    pivotMaxGeneratedColumns: -1,
    columnMenu: "new",
    reactiveCustomComponents: true,
    suppressSetFilterByDefault: false,
    rowNumbers: false,
    enableFilterHandlers: false
};
// packages/ag-grid-community/src/utils/aria.ts
function $437b23f6a393c3bf$var$_toggleAriaAttribute(element, attribute, value) {
    if (value == null || typeof value === "string" && value == "") $437b23f6a393c3bf$var$_removeAriaAttribute(element, attribute);
    else $437b23f6a393c3bf$var$_setAriaAttribute(element, attribute, value);
}
function $437b23f6a393c3bf$var$_setAriaAttribute(element, attribute, value) {
    element.setAttribute($437b23f6a393c3bf$var$_ariaAttributeName(attribute), value.toString());
}
function $437b23f6a393c3bf$var$_removeAriaAttribute(element, attribute) {
    element.removeAttribute($437b23f6a393c3bf$var$_ariaAttributeName(attribute));
}
function $437b23f6a393c3bf$var$_ariaAttributeName(attribute) {
    return `aria-${attribute}`;
}
function $437b23f6a393c3bf$export$f8d01fa01787902(element, role) {
    if (role) element.setAttribute("role", role);
    else element.removeAttribute("role");
}
function $437b23f6a393c3bf$var$_getAriaSortState(sortDirection) {
    let sort;
    if (sortDirection === "asc") sort = "ascending";
    else if (sortDirection === "desc") sort = "descending";
    else if (sortDirection === "mixed") sort = "other";
    else sort = "none";
    return sort;
}
function $437b23f6a393c3bf$export$70c3a20563598672(element) {
    return parseInt(element.getAttribute("aria-posinset"), 10);
}
function $437b23f6a393c3bf$var$_getAriaLabel(element) {
    return element.getAttribute("aria-label");
}
function $437b23f6a393c3bf$export$e81cb0dd07f289f6(element, label) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "label", label);
}
function $437b23f6a393c3bf$export$84233c40c4c74001(element, labelledBy) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "labelledby", labelledBy);
}
function $437b23f6a393c3bf$export$3c2bc877474a7797(element, describedby) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "describedby", describedby);
}
function $437b23f6a393c3bf$var$_setAriaLive(element, live) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "live", live);
}
function $437b23f6a393c3bf$var$_setAriaAtomic(element, atomic) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "atomic", atomic);
}
function $437b23f6a393c3bf$var$_setAriaRelevant(element, relevant) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "relevant", relevant);
}
function $437b23f6a393c3bf$export$fd1450327e6900f2(element, invalid) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "invalid", invalid);
}
function $437b23f6a393c3bf$export$9eaf1f20171625e8(element, level) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "level", level);
}
function $437b23f6a393c3bf$export$7ed376f43c6f2bbd(element, disabled) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "disabled", disabled);
}
function $437b23f6a393c3bf$export$ee52c2b3744c455d(element, hidden) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "hidden", hidden);
}
function $437b23f6a393c3bf$export$5db804730c3c8346(element, descendantId) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "activedescendant", descendantId);
}
function $437b23f6a393c3bf$export$3ad3518dddf15485(element, expanded) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "expanded", expanded);
}
function $437b23f6a393c3bf$export$2254dfb132f01330(element) {
    $437b23f6a393c3bf$var$_removeAriaAttribute(element, "expanded");
}
function $437b23f6a393c3bf$export$3d494c2007bbcac1(element, setsize) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "setsize", setsize);
}
function $437b23f6a393c3bf$export$c3d3aede41065a84(element, position) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "posinset", position);
}
function $437b23f6a393c3bf$var$_setAriaMultiSelectable(element, multiSelectable) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "multiselectable", multiSelectable);
}
function $437b23f6a393c3bf$export$1ad8496b26b660f8(element, rowCount) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "rowcount", rowCount);
}
function $437b23f6a393c3bf$export$ba731dedf9d88615(element, rowIndex) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "rowindex", rowIndex);
}
function $437b23f6a393c3bf$var$_setAriaRowSpan(element, spanCount) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "rowspan", spanCount);
}
function $437b23f6a393c3bf$export$56744a26086b5898(element, colCount) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "colcount", colCount);
}
function $437b23f6a393c3bf$export$84b73ecd0b234e89(element, colIndex) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "colindex", colIndex);
}
function $437b23f6a393c3bf$export$371d80f0281454ce(element, colSpan) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "colspan", colSpan);
}
function $437b23f6a393c3bf$export$c8dd030b968c6fd2(element, sort) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "sort", sort);
}
function $437b23f6a393c3bf$export$26c7aa61eda05134(element) {
    $437b23f6a393c3bf$var$_removeAriaAttribute(element, "sort");
}
function $437b23f6a393c3bf$export$c22e3722e8a33469(element, selected) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "selected", selected);
}
function $437b23f6a393c3bf$export$43b4d6c0ec0fa4c7(element, checked) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "checked", checked === void 0 ? "mixed" : checked);
}
function $437b23f6a393c3bf$export$26fd6a3f123d4e67(controllerElement, controlledId) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(controllerElement, "controls", controlledId);
}
function $437b23f6a393c3bf$export$6ff31a4a210c60ad(controllerElement, controlledElement) {
    $437b23f6a393c3bf$export$26fd6a3f123d4e67(controllerElement, controlledElement.id);
    $437b23f6a393c3bf$export$84233c40c4c74001(controlledElement, controllerElement.id);
}
function $437b23f6a393c3bf$var$_setAriaOwns(ownerElement, ownedId) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(ownerElement, "owns", ownedId);
}
function $437b23f6a393c3bf$export$668d180e9cbef6da(element, hasPopup) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "haspopup", hasPopup === false ? null : hasPopup);
}
function $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, state) {
    return state === void 0 ? translate("ariaIndeterminate", "indeterminate") : state === true ? translate("ariaChecked", "checked") : translate("ariaUnchecked", "unchecked");
}
// packages/ag-grid-community/src/utils/browser.ts
var $437b23f6a393c3bf$var$isSafari;
var $437b23f6a393c3bf$var$isFirefox;
var $437b23f6a393c3bf$var$isMacOs;
var $437b23f6a393c3bf$var$isIOS;
var $437b23f6a393c3bf$var$invisibleScrollbar;
var $437b23f6a393c3bf$var$browserScrollbarWidth;
var $437b23f6a393c3bf$var$maxDivHeight;
function $437b23f6a393c3bf$var$_isBrowserSafari() {
    if ($437b23f6a393c3bf$var$isSafari === void 0) $437b23f6a393c3bf$var$isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return $437b23f6a393c3bf$var$isSafari;
}
function $437b23f6a393c3bf$var$_isBrowserFirefox() {
    if ($437b23f6a393c3bf$var$isFirefox === void 0) $437b23f6a393c3bf$var$isFirefox = /(firefox)/i.test(navigator.userAgent);
    return $437b23f6a393c3bf$var$isFirefox;
}
function $437b23f6a393c3bf$var$_isMacOsUserAgent() {
    if ($437b23f6a393c3bf$var$isMacOs === void 0) $437b23f6a393c3bf$var$isMacOs = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    return $437b23f6a393c3bf$var$isMacOs;
}
function $437b23f6a393c3bf$export$6b6034a68325bd8a() {
    if ($437b23f6a393c3bf$var$isIOS === void 0) $437b23f6a393c3bf$var$isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    return $437b23f6a393c3bf$var$isIOS;
}
function $437b23f6a393c3bf$var$_getTabIndex(el) {
    if (!el) return null;
    const numberTabIndex = el.tabIndex;
    const tabIndex = el.getAttribute("tabIndex");
    if (numberTabIndex === -1 && (tabIndex === null || tabIndex === "" && !$437b23f6a393c3bf$var$_isBrowserFirefox())) return null;
    return numberTabIndex.toString();
}
function $437b23f6a393c3bf$var$_getMaxDivHeight() {
    if ($437b23f6a393c3bf$var$maxDivHeight !== void 0) return $437b23f6a393c3bf$var$maxDivHeight;
    if (!document.body) return -1;
    let res = 1e6;
    const testUpTo = $437b23f6a393c3bf$var$_isBrowserFirefox() ? 6e6 : 1e9;
    const div = document.createElement("div");
    document.body.appendChild(div);
    while(true){
        const test = res * 2;
        div.style.height = test + "px";
        if (test > testUpTo || div.clientHeight !== test) break;
        else res = test;
    }
    document.body.removeChild(div);
    $437b23f6a393c3bf$var$maxDivHeight = res;
    return res;
}
function $437b23f6a393c3bf$var$_getScrollbarWidth() {
    if ($437b23f6a393c3bf$var$browserScrollbarWidth == null) $437b23f6a393c3bf$var$initScrollbarWidthAndVisibility();
    return $437b23f6a393c3bf$var$browserScrollbarWidth;
}
function $437b23f6a393c3bf$var$initScrollbarWidthAndVisibility() {
    const body = document.body;
    const div = document.createElement("div");
    div.style.width = div.style.height = "100px";
    div.style.opacity = "0";
    div.style.overflow = "scroll";
    div.style.msOverflowStyle = "scrollbar";
    div.style.position = "absolute";
    body.appendChild(div);
    let width = div.offsetWidth - div.clientWidth;
    if (width === 0 && div.clientWidth === 0) width = null;
    if (div.parentNode) div.parentNode.removeChild(div);
    if (width != null) {
        $437b23f6a393c3bf$var$browserScrollbarWidth = width;
        $437b23f6a393c3bf$var$invisibleScrollbar = width === 0;
    }
}
function $437b23f6a393c3bf$var$_isInvisibleScrollbar() {
    if ($437b23f6a393c3bf$var$invisibleScrollbar == null) $437b23f6a393c3bf$var$initScrollbarWidthAndVisibility();
    return $437b23f6a393c3bf$var$invisibleScrollbar;
}
// packages/ag-grid-community/src/utils/dom.ts
function $437b23f6a393c3bf$export$605571c1b2992cfe(element, elementClass, otherElementClass) {
    const parent = element.parentElement;
    let sibling = parent && parent.firstChild;
    while(sibling){
        if (elementClass) sibling.classList.toggle(elementClass, sibling === element);
        if (otherElementClass) sibling.classList.toggle(otherElementClass, sibling !== element);
        sibling = sibling.nextSibling;
    }
}
var $437b23f6a393c3bf$var$FOCUSABLE_SELECTOR = "[tabindex], input, select, button, textarea, [href]";
var $437b23f6a393c3bf$var$FOCUSABLE_EXCLUDE = "[disabled], .ag-disabled:not(.ag-button), .ag-disabled *";
function $437b23f6a393c3bf$var$_isFocusableFormField(element) {
    const matches = Element.prototype.matches || Element.prototype.msMatchesSelector;
    const inputSelector = "input, select, button, textarea";
    const isFocusable = matches.call(element, inputSelector);
    const isNotFocusable = matches.call(element, $437b23f6a393c3bf$var$FOCUSABLE_EXCLUDE);
    const isElementVisible = $437b23f6a393c3bf$export$2badf4aa566524cb(element);
    const focusable = isFocusable && !isNotFocusable && isElementVisible;
    return focusable;
}
function $437b23f6a393c3bf$export$9405f1cbb4e2383f(element, displayed, options = {}) {
    const { skipAriaHidden: skipAriaHidden } = options;
    element.classList.toggle("ag-hidden", !displayed);
    if (!skipAriaHidden) $437b23f6a393c3bf$export$ee52c2b3744c455d(element, !displayed);
}
function $437b23f6a393c3bf$export$a6c2c477cd60daa8(element, visible, options = {}) {
    const { skipAriaHidden: skipAriaHidden } = options;
    element.classList.toggle("ag-invisible", !visible);
    if (!skipAriaHidden) $437b23f6a393c3bf$export$ee52c2b3744c455d(element, !visible);
}
function $437b23f6a393c3bf$export$b6b4f08392e9bfaf(element, disabled) {
    const attributeName = "disabled";
    const addOrRemoveDisabledAttribute = disabled ? (e)=>e.setAttribute(attributeName, "") : (e)=>e.removeAttribute(attributeName);
    addOrRemoveDisabledAttribute(element);
    const inputs = element.querySelectorAll("input") ?? [];
    for (const input of inputs)addOrRemoveDisabledAttribute(input);
}
function $437b23f6a393c3bf$var$_isElementChildOfClass(element, cls, maxNest) {
    let counter = 0;
    while(element){
        if (element.classList.contains(cls)) return true;
        element = element.parentElement;
        if (typeof maxNest == "number") {
            if (++counter > maxNest) break;
        } else if (element === maxNest) break;
    }
    return false;
}
function $437b23f6a393c3bf$var$_getElementSize(el) {
    const { height: height, width: width, borderTopWidth: borderTopWidth, borderRightWidth: borderRightWidth, borderBottomWidth: borderBottomWidth, borderLeftWidth: borderLeftWidth, paddingTop: paddingTop, paddingRight: paddingRight, paddingBottom: paddingBottom, paddingLeft: paddingLeft, marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft, boxSizing: boxSizing } = window.getComputedStyle(el);
    return {
        height: parseFloat(height || "0"),
        width: parseFloat(width || "0"),
        borderTopWidth: parseFloat(borderTopWidth || "0"),
        borderRightWidth: parseFloat(borderRightWidth || "0"),
        borderBottomWidth: parseFloat(borderBottomWidth || "0"),
        borderLeftWidth: parseFloat(borderLeftWidth || "0"),
        paddingTop: parseFloat(paddingTop || "0"),
        paddingRight: parseFloat(paddingRight || "0"),
        paddingBottom: parseFloat(paddingBottom || "0"),
        paddingLeft: parseFloat(paddingLeft || "0"),
        marginTop: parseFloat(marginTop || "0"),
        marginRight: parseFloat(marginRight || "0"),
        marginBottom: parseFloat(marginBottom || "0"),
        marginLeft: parseFloat(marginLeft || "0"),
        boxSizing: boxSizing
    };
}
function $437b23f6a393c3bf$export$c20e968103d9c16e(el) {
    const size = $437b23f6a393c3bf$var$_getElementSize(el);
    if (size.boxSizing === "border-box") return size.height - size.paddingTop - size.paddingBottom;
    return size.height;
}
function $437b23f6a393c3bf$export$cc615e4191ec3e0c(el) {
    const size = $437b23f6a393c3bf$var$_getElementSize(el);
    if (size.boxSizing === "border-box") return size.width - size.paddingLeft - size.paddingRight;
    return size.width;
}
function $437b23f6a393c3bf$export$d23c22492e0f7c0c(el) {
    const { height: height, marginBottom: marginBottom, marginTop: marginTop } = $437b23f6a393c3bf$var$_getElementSize(el);
    return Math.floor(height + marginBottom + marginTop);
}
function $437b23f6a393c3bf$export$642efcb17474eb51(el) {
    const { width: width, marginLeft: marginLeft, marginRight: marginRight } = $437b23f6a393c3bf$var$_getElementSize(el);
    return Math.floor(width + marginLeft + marginRight);
}
function $437b23f6a393c3bf$var$_getElementRectWithOffset(el) {
    const offsetElementRect = el.getBoundingClientRect();
    const { borderTopWidth: borderTopWidth, borderLeftWidth: borderLeftWidth, borderRightWidth: borderRightWidth, borderBottomWidth: borderBottomWidth } = $437b23f6a393c3bf$var$_getElementSize(el);
    return {
        top: offsetElementRect.top + (borderTopWidth || 0),
        left: offsetElementRect.left + (borderLeftWidth || 0),
        right: offsetElementRect.right + (borderRightWidth || 0),
        bottom: offsetElementRect.bottom + (borderBottomWidth || 0)
    };
}
function $437b23f6a393c3bf$var$_getScrollLeft(element, rtl) {
    let scrollLeft = element.scrollLeft;
    if (rtl) scrollLeft = Math.abs(scrollLeft);
    return scrollLeft;
}
function $437b23f6a393c3bf$var$_setScrollLeft(element, value, rtl) {
    if (rtl) value *= -1;
    element.scrollLeft = value;
}
function $437b23f6a393c3bf$export$69e6e10709eabd91(el) {
    while(el && el.firstChild)el.removeChild(el.firstChild);
}
function $437b23f6a393c3bf$export$dd4d52e41fb4cef5(node) {
    if (node && node.parentNode) node.parentNode.removeChild(node);
}
function $437b23f6a393c3bf$var$_isInDOM(element) {
    return !!element.offsetParent;
}
function $437b23f6a393c3bf$export$2badf4aa566524cb(element) {
    const el = element;
    if (el.checkVisibility) return el.checkVisibility({
        checkVisibilityCSS: true
    });
    const isHidden = !$437b23f6a393c3bf$var$_isInDOM(element) || window.getComputedStyle(element).visibility !== "visible";
    return !isHidden;
}
function $437b23f6a393c3bf$export$b1f57d075ca6d5fb(template) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = (template || "").trim();
    return tempDiv.firstChild;
}
function $437b23f6a393c3bf$var$_ensureDomOrder(eContainer, eChild, eChildBefore) {
    if (eChildBefore && eChildBefore.nextSibling === eChild) return;
    if (!eContainer.firstChild) eContainer.appendChild(eChild);
    else if (eChildBefore) {
        if (eChildBefore.nextSibling) eContainer.insertBefore(eChild, eChildBefore.nextSibling);
        else eContainer.appendChild(eChild);
    } else if (eContainer.firstChild && eContainer.firstChild !== eChild) eContainer.insertAdjacentElement("afterbegin", eChild);
}
function $437b23f6a393c3bf$var$_setDomChildOrder(eContainer, orderedChildren) {
    for(let i = 0; i < orderedChildren.length; i++){
        const correctCellAtIndex = orderedChildren[i];
        const actualCellAtIndex = eContainer.children[i];
        if (actualCellAtIndex !== correctCellAtIndex) eContainer.insertBefore(correctCellAtIndex, actualCellAtIndex);
    }
}
function $437b23f6a393c3bf$var$_camelCaseToHyphenated(camelCase) {
    return camelCase.replace(/[A-Z]/g, (s)=>`-${s.toLocaleLowerCase()}`);
}
function $437b23f6a393c3bf$var$_addStylesToElement(eElement, styles) {
    if (!styles) return;
    for (const key of Object.keys(styles)){
        const value = styles[key];
        if (!key || !key.length || value == null) continue;
        const parsedKey = $437b23f6a393c3bf$var$_camelCaseToHyphenated(key);
        const valueAsString = value.toString();
        const parsedValue = valueAsString.replace(/\s*!important/g, "");
        const priority = parsedValue.length != valueAsString.length ? "important" : void 0;
        eElement.style.setProperty(parsedKey, parsedValue, priority);
    }
}
function $437b23f6a393c3bf$export$8980540b0a37a11d(getElement2) {
    return ()=>{
        const element = getElement2();
        if (!element) return true;
        return $437b23f6a393c3bf$var$_isHorizontalScrollShowing(element) || $437b23f6a393c3bf$var$_isVerticalScrollShowing(element);
    };
}
function $437b23f6a393c3bf$var$_isHorizontalScrollShowing(element) {
    return element.clientWidth < element.scrollWidth;
}
function $437b23f6a393c3bf$var$_isVerticalScrollShowing(element) {
    return element.clientHeight < element.scrollHeight;
}
function $437b23f6a393c3bf$var$_setElementWidth(element, width) {
    if (width === "flex") {
        element.style.removeProperty("width");
        element.style.removeProperty("minWidth");
        element.style.removeProperty("maxWidth");
        element.style.flex = "1 1 auto";
    } else $437b23f6a393c3bf$export$ce98ba7f5cfe7725(element, width);
}
function $437b23f6a393c3bf$export$ce98ba7f5cfe7725(element, width) {
    width = $437b23f6a393c3bf$var$_formatSize(width);
    element.style.width = width;
    element.style.maxWidth = width;
    element.style.minWidth = width;
}
function $437b23f6a393c3bf$var$_setFixedHeight(element, height) {
    height = $437b23f6a393c3bf$var$_formatSize(height);
    element.style.height = height;
    element.style.maxHeight = height;
    element.style.minHeight = height;
}
function $437b23f6a393c3bf$var$_formatSize(size) {
    return typeof size === "number" ? `${size}px` : size;
}
function $437b23f6a393c3bf$export$6e6303ef478b0c94(o) {
    return o instanceof Node || o instanceof HTMLElement;
}
function $437b23f6a393c3bf$var$_addOrRemoveAttribute(element, name, value) {
    if (value == null || value === "") element.removeAttribute(name);
    else element.setAttribute(name, value.toString());
}
function $437b23f6a393c3bf$export$9aef8476630687be(beans, element, callback) {
    const win = $437b23f6a393c3bf$var$_getWindow(beans);
    const ResizeObserverImpl = win.ResizeObserver;
    const resizeObserver = ResizeObserverImpl ? new ResizeObserverImpl(callback) : null;
    resizeObserver?.observe(element);
    return ()=>resizeObserver?.disconnect();
}
function $437b23f6a393c3bf$var$_getTextSelectionRanges(beans) {
    const rootNode = $437b23f6a393c3bf$export$1911dd00c79744c0(beans);
    const selection = "getSelection" in rootNode ? rootNode.getSelection() : null;
    const ranges = [];
    for(let i = 0; i < (selection?.rangeCount ?? 0); i++){
        const range = selection?.getRangeAt(i);
        if (range) ranges.push(range);
    }
    return {
        selection: selection,
        ranges: ranges
    };
}
function $437b23f6a393c3bf$export$13e15fa0b6986f21(beans, fn) {
    const enableCellTextSelection = beans.gos.get("enableCellTextSelection");
    if (!enableCellTextSelection) return fn();
    if (!$437b23f6a393c3bf$var$_isBrowserFirefox() && !$437b23f6a393c3bf$var$_isBrowserSafari()) return fn();
    const { selection: selection, ranges: ranges } = $437b23f6a393c3bf$var$_getTextSelectionRanges(beans);
    fn();
    selection?.removeAllRanges();
    for (const range of ranges)selection?.addRange(range);
}
function $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, callback) {
    const win = $437b23f6a393c3bf$var$_getWindow(beans);
    if (win.requestAnimationFrame) win.requestAnimationFrame(callback);
    else if (win.webkitRequestAnimationFrame) win.webkitRequestAnimationFrame(callback);
    else win.setTimeout(callback, 0);
}
var $437b23f6a393c3bf$var$DataRefAttribute = "data-ref";
var $437b23f6a393c3bf$var$whitespaceNode;
function $437b23f6a393c3bf$var$getWhitespaceNode() {
    $437b23f6a393c3bf$var$whitespaceNode ?? ($437b23f6a393c3bf$var$whitespaceNode = document.createTextNode(" "));
    return $437b23f6a393c3bf$var$whitespaceNode.cloneNode();
}
function $437b23f6a393c3bf$export$a232bb0480ae674a(params) {
    const { attrs: attrs, children: children, cls: cls, ref: ref, role: role, tag: tag } = params;
    const element = document.createElement(tag);
    if (cls) element.className = cls;
    if (ref) element.setAttribute($437b23f6a393c3bf$var$DataRefAttribute, ref);
    if (role) element.setAttribute("role", role);
    if (attrs) for (const key of Object.keys(attrs))element.setAttribute(key, attrs[key]);
    if (children) {
        if (typeof children === "string") element.textContent = children;
        else {
            let addFirstWhitespace = true;
            for (const child of children)if (child) {
                if (typeof child === "string") {
                    element.appendChild(document.createTextNode(child));
                    addFirstWhitespace = false;
                } else if (typeof child === "function") element.appendChild(child());
                else {
                    if (addFirstWhitespace) {
                        element.appendChild($437b23f6a393c3bf$var$getWhitespaceNode());
                        addFirstWhitespace = false;
                    }
                    element.append($437b23f6a393c3bf$export$a232bb0480ae674a(child));
                    element.appendChild($437b23f6a393c3bf$var$getWhitespaceNode());
                }
            }
        }
    }
    return element;
}
// packages/ag-grid-community/src/utils/function.ts
var $437b23f6a393c3bf$var$doOnceFlags = {};
function $437b23f6a393c3bf$export$e150fb6ea3b45c0d(func, key) {
    if ($437b23f6a393c3bf$var$doOnceFlags[key]) return;
    func();
    $437b23f6a393c3bf$var$doOnceFlags[key] = true;
}
function $437b23f6a393c3bf$var$_logIfDebug(gos, message, ...args) {
    if (gos.get("debug")) console.log("AG Grid: " + message, ...args);
}
function $437b23f6a393c3bf$export$2cf41453020eef66(msg, ...args) {
    $437b23f6a393c3bf$export$e150fb6ea3b45c0d(()=>console.warn("AG Grid: " + msg, ...args), msg + args?.join(""));
}
function $437b23f6a393c3bf$var$_errorOnce(msg, ...args) {
    $437b23f6a393c3bf$export$e150fb6ea3b45c0d(()=>console.error("AG Grid: " + msg, ...args), msg + args?.join(""));
}
var $437b23f6a393c3bf$var$batchedCallsSetTimeout = {
    pending: false,
    funcs: []
};
var $437b23f6a393c3bf$var$batchedCallsRaf = {
    pending: false,
    funcs: []
};
function $437b23f6a393c3bf$export$8ea55376d0d59592(func, mode = "setTimeout", beans) {
    const batch = mode === "raf" ? $437b23f6a393c3bf$var$batchedCallsRaf : $437b23f6a393c3bf$var$batchedCallsSetTimeout;
    batch.funcs.push(func);
    if (batch.pending) return;
    batch.pending = true;
    const runBatch = ()=>{
        const funcsCopy = batch.funcs.slice();
        batch.funcs.length = 0;
        batch.pending = false;
        funcsCopy.forEach((func2)=>func2());
    };
    if (mode === "raf") $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, runBatch);
    else window.setTimeout(runBatch, 0);
}
function $437b23f6a393c3bf$export$cf7e39bfb94de6e(bean, func, delay) {
    let timeout;
    return function(...args) {
        const context = this;
        window.clearTimeout(timeout);
        timeout = window.setTimeout(function() {
            if (bean.isAlive()) func.apply(context, args);
        }, delay);
    };
}
function $437b23f6a393c3bf$var$_throttle(func, wait) {
    let previousCall = 0;
    return function(...args) {
        const context = this;
        const currentCall = Date.now();
        if (currentCall - previousCall < wait) return;
        previousCall = currentCall;
        func.apply(context, args);
    };
}
function $437b23f6a393c3bf$export$b863e7aac7884b8(condition, callback, timeout = 100, timeoutMessage) {
    const timeStamp = Date.now();
    let interval = null;
    let executed = false;
    const internalCallback = ()=>{
        const reachedTimeout = Date.now() - timeStamp > timeout;
        if (condition() || reachedTimeout) {
            callback();
            executed = true;
            if (interval != null) {
                window.clearInterval(interval);
                interval = null;
            }
            if (reachedTimeout && timeoutMessage) $437b23f6a393c3bf$export$2cf41453020eef66(timeoutMessage);
        }
    };
    internalCallback();
    if (!executed) interval = window.setInterval(internalCallback, 10);
}
// packages/ag-grid-community/src/baseUrl.ts
var $437b23f6a393c3bf$var$BASE_URL = "https://www.ag-grid.com";
// packages/ag-grid-community/src/version.ts
var $437b23f6a393c3bf$var$VERSION = "34.1.2";
// packages/ag-grid-community/src/validation/logging.ts
var $437b23f6a393c3bf$var$MAX_URL_LENGTH = 2e3;
var $437b23f6a393c3bf$var$MIN_PARAM_LENGTH = 100;
var $437b23f6a393c3bf$var$VERSION_PARAM_NAME = "_version_";
var $437b23f6a393c3bf$var$validation = null;
var $437b23f6a393c3bf$var$baseDocLink = `${$437b23f6a393c3bf$var$BASE_URL}/javascript-data-grid`;
function $437b23f6a393c3bf$var$provideValidationServiceLogger(logger) {
    $437b23f6a393c3bf$var$validation = logger;
}
function $437b23f6a393c3bf$var$setValidationDocLink(docLink) {
    $437b23f6a393c3bf$var$baseDocLink = docLink;
}
function $437b23f6a393c3bf$var$getErrorParts(id, args, defaultMessage) {
    return $437b23f6a393c3bf$var$validation?.getConsoleMessage(id, args) ?? [
        $437b23f6a393c3bf$var$minifiedLog(id, args, defaultMessage)
    ];
}
function $437b23f6a393c3bf$var$getMsgOrDefault(logger, id, args, defaultMessage) {
    logger(`error #${id}`, ...$437b23f6a393c3bf$var$getErrorParts(id, args, defaultMessage));
}
function $437b23f6a393c3bf$var$stringifyObject(inputObj) {
    if (!inputObj) return String(inputObj);
    const object = {};
    for (const prop of Object.keys(inputObj))if (typeof inputObj[prop] !== "object" && typeof inputObj[prop] !== "function") object[prop] = inputObj[prop];
    return JSON.stringify(object);
}
function $437b23f6a393c3bf$var$stringifyValue(value) {
    let output = value;
    if (value instanceof Error) output = value.toString();
    else if (typeof value === "object") output = $437b23f6a393c3bf$var$stringifyObject(value);
    return output;
}
function $437b23f6a393c3bf$var$toStringWithNullUndefined(str) {
    return str === void 0 ? "undefined" : str === null ? "null" : str;
}
function $437b23f6a393c3bf$var$getParamsUrl(baseUrl, params) {
    return `${baseUrl}?${params.toString()}`;
}
function $437b23f6a393c3bf$var$truncateUrl(baseUrl, params, maxLength) {
    const sortedParams = Array.from(params.entries()).sort((a, b)=>b[1].length - a[1].length);
    let url = $437b23f6a393c3bf$var$getParamsUrl(baseUrl, params);
    for (const [key, value] of sortedParams){
        if (key === $437b23f6a393c3bf$var$VERSION_PARAM_NAME) continue;
        const excessLength = url.length - maxLength;
        if (excessLength <= 0) break;
        const ellipse = "...";
        const truncateAmount = excessLength + ellipse.length;
        const truncatedValue = value.length - truncateAmount > $437b23f6a393c3bf$var$MIN_PARAM_LENGTH ? value.slice(0, value.length - truncateAmount) + ellipse : value.slice(0, $437b23f6a393c3bf$var$MIN_PARAM_LENGTH) + ellipse;
        params.set(key, truncatedValue);
        url = $437b23f6a393c3bf$var$getParamsUrl(baseUrl, params);
    }
    return url;
}
function $437b23f6a393c3bf$var$getErrorLink(errorNum, args) {
    const params = new URLSearchParams();
    params.append($437b23f6a393c3bf$var$VERSION_PARAM_NAME, $437b23f6a393c3bf$var$VERSION);
    if (args) for (const key of Object.keys(args))params.append(key, $437b23f6a393c3bf$var$stringifyValue(args[key]));
    const baseUrl = `${$437b23f6a393c3bf$var$baseDocLink}/errors/${errorNum}`;
    const url = $437b23f6a393c3bf$var$getParamsUrl(baseUrl, params);
    return url.length <= $437b23f6a393c3bf$var$MAX_URL_LENGTH ? url : $437b23f6a393c3bf$var$truncateUrl(baseUrl, params, $437b23f6a393c3bf$var$MAX_URL_LENGTH);
}
var $437b23f6a393c3bf$var$minifiedLog = (errorNum, args, defaultMessage)=>{
    const errorLink = $437b23f6a393c3bf$var$getErrorLink(errorNum, args);
    return `${defaultMessage ? defaultMessage + " \n" : ""}Visit ${errorLink}${defaultMessage ? "" : " \n  Alternatively register the ValidationModule to see the full message in the console."}`;
};
function $437b23f6a393c3bf$export$545083624300f13d(...args) {
    $437b23f6a393c3bf$var$getMsgOrDefault($437b23f6a393c3bf$export$2cf41453020eef66, args[0], args[1]);
}
function $437b23f6a393c3bf$export$a20c7248650823a9(...args) {
    $437b23f6a393c3bf$var$getMsgOrDefault($437b23f6a393c3bf$var$_errorOnce, args[0], args[1]);
}
function $437b23f6a393c3bf$var$_logPreInitErr(id, args, defaultMessage) {
    $437b23f6a393c3bf$var$getMsgOrDefault($437b23f6a393c3bf$var$_errorOnce, id, args, defaultMessage);
}
function $437b23f6a393c3bf$var$getErrMsg(defaultMessage, args) {
    const id = args[0];
    return `error #${id} ` + $437b23f6a393c3bf$var$getErrorParts(id, args[1], defaultMessage).join(" ");
}
function $437b23f6a393c3bf$export$680bb5102fca525e(...args) {
    return $437b23f6a393c3bf$var$getErrMsg(void 0, args);
}
function $437b23f6a393c3bf$export$d73cab7876c2c868(...args) {
    return $437b23f6a393c3bf$var$getErrMsg("\n", args);
}
// packages/ag-grid-community/src/gridOptionsUtils.ts
function $437b23f6a393c3bf$var$isRowModelType(gos, rowModelType) {
    return gos.get("rowModelType") === rowModelType;
}
function $437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel) {
    return $437b23f6a393c3bf$var$isRowModelType(gos, "clientSide");
}
function $437b23f6a393c3bf$export$cf1bac0013650216(gos, rowModel) {
    return $437b23f6a393c3bf$var$isRowModelType(gos, "serverSide");
}
function $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, domLayout) {
    return gos.get("domLayout") === domLayout;
}
function $437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos) {
    return $437b23f6a393c3bf$export$80b6607444b3274f(gos) !== void 0;
}
function $437b23f6a393c3bf$export$f0ddd2d4ccc7fed8(gos) {
    return typeof gos.get("getRowHeight") === "function";
}
function $437b23f6a393c3bf$var$_shouldMaintainColumnOrder(gos, isPivotColumns) {
    if (isPivotColumns) return !gos.get("enableStrictPivotColumnOrder");
    return gos.get("maintainColumnOrder");
}
function $437b23f6a393c3bf$export$b6de5fa3decc8f7b(beans, rowNode, allowEstimate = false, defaultRowHeight) {
    const { gos: gos, environment: environment } = beans;
    if (defaultRowHeight == null) defaultRowHeight = environment.getDefaultRowHeight();
    if ($437b23f6a393c3bf$export$f0ddd2d4ccc7fed8(gos)) {
        if (allowEstimate) return {
            height: defaultRowHeight,
            estimated: true
        };
        const params = {
            node: rowNode,
            data: rowNode.data
        };
        const height = gos.getCallback("getRowHeight")(params);
        if ($437b23f6a393c3bf$var$isNumeric(height)) {
            if (height === 0) $437b23f6a393c3bf$export$545083624300f13d(23);
            return {
                height: Math.max(1, height),
                estimated: false
            };
        }
    }
    if (rowNode.detail && gos.get("masterDetail")) return $437b23f6a393c3bf$var$getMasterDetailRowHeight(gos);
    const gridOptionsRowHeight = gos.get("rowHeight");
    const rowHeight = gridOptionsRowHeight && $437b23f6a393c3bf$var$isNumeric(gridOptionsRowHeight) ? gridOptionsRowHeight : defaultRowHeight;
    return {
        height: rowHeight,
        estimated: false
    };
}
function $437b23f6a393c3bf$var$getMasterDetailRowHeight(gos) {
    if (gos.get("detailRowAutoHeight")) return {
        height: 1,
        estimated: false
    };
    const defaultRowHeight = gos.get("detailRowHeight");
    if ($437b23f6a393c3bf$var$isNumeric(defaultRowHeight)) return {
        height: defaultRowHeight,
        estimated: false
    };
    return {
        height: 300,
        estimated: false
    };
}
function $437b23f6a393c3bf$export$8966875adec41e5b(beans) {
    const { environment: environment, gos: gos } = beans;
    const gridOptionsRowHeight = gos.get("rowHeight");
    if (!gridOptionsRowHeight || $437b23f6a393c3bf$export$672d9e47bc342bac(gridOptionsRowHeight)) return environment.getDefaultRowHeight();
    const rowHeight = environment.refreshRowHeightVariable();
    if (rowHeight !== -1) return rowHeight;
    $437b23f6a393c3bf$export$545083624300f13d(24);
    return environment.getDefaultRowHeight();
}
function $437b23f6a393c3bf$var$isNumeric(value) {
    return !isNaN(value) && typeof value === "number" && isFinite(value);
}
function $437b23f6a393c3bf$var$_getDomData(gos, element, key) {
    const domData = element[gos.getDomDataKey()];
    return domData ? domData[key] : void 0;
}
function $437b23f6a393c3bf$var$_setDomData(gos, element, key, value) {
    const domDataKey = gos.getDomDataKey();
    let domData = element[domDataKey];
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(domData)) {
        domData = {};
        element[domDataKey] = domData;
    }
    domData[key] = value;
}
function $437b23f6a393c3bf$export$f63d0991874c6f81(beans) {
    const { gos: gos, eGridDiv: eGridDiv } = beans;
    let result = null;
    const gridOptionsGetDocument = gos.get("getDocument");
    if (gridOptionsGetDocument && $437b23f6a393c3bf$export$25d27f17d3af40f7(gridOptionsGetDocument)) result = gridOptionsGetDocument();
    else if (eGridDiv) result = eGridDiv.ownerDocument;
    if (result && $437b23f6a393c3bf$export$25d27f17d3af40f7(result)) return result;
    return document;
}
function $437b23f6a393c3bf$var$_getWindow(beans) {
    const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
    return eDocument.defaultView || window;
}
function $437b23f6a393c3bf$export$1911dd00c79744c0(beans) {
    return beans.eGridDiv.getRootNode();
}
function $437b23f6a393c3bf$export$16bc98d422315038(beans) {
    return $437b23f6a393c3bf$export$1911dd00c79744c0(beans).activeElement;
}
function $437b23f6a393c3bf$export$50c54e860701cf22(beans) {
    let rootNode = null;
    let targetEl = null;
    try {
        rootNode = $437b23f6a393c3bf$export$f63d0991874c6f81(beans).fullscreenElement;
    } catch (e) {} finally{
        if (!rootNode) rootNode = $437b23f6a393c3bf$export$1911dd00c79744c0(beans);
        const body = rootNode.querySelector("body");
        if (body) targetEl = body;
        else if (rootNode instanceof ShadowRoot) targetEl = rootNode;
        else if (rootNode instanceof Document) targetEl = rootNode?.documentElement;
        else targetEl = rootNode;
    }
    return targetEl;
}
function $437b23f6a393c3bf$var$_getBodyWidth(beans) {
    const body = $437b23f6a393c3bf$export$50c54e860701cf22(beans);
    return body?.clientWidth ?? (window.innerWidth || -1);
}
function $437b23f6a393c3bf$var$_getBodyHeight(beans) {
    const body = $437b23f6a393c3bf$export$50c54e860701cf22(beans);
    return body?.clientHeight ?? (window.innerHeight || -1);
}
function $437b23f6a393c3bf$export$3ce6b987cf48b8c2(element, mouseMoveEvent, beans) {
    const eRect = element.getBoundingClientRect();
    const height = eRect.height;
    const browserWidth = $437b23f6a393c3bf$var$_getBodyWidth(beans) - 2;
    const browserHeight = $437b23f6a393c3bf$var$_getBodyHeight(beans) - 2;
    const offsetParent = element.offsetParent;
    if (!offsetParent) return;
    const offsetParentSize = $437b23f6a393c3bf$var$_getElementRectWithOffset(element.offsetParent);
    const { clientY: clientY, clientX: clientX } = mouseMoveEvent;
    let top = clientY - offsetParentSize.top - height / 2;
    let left = clientX - offsetParentSize.left - 10;
    const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
    const win = eDocument.defaultView || window;
    const windowScrollY = win.pageYOffset || eDocument.documentElement.scrollTop;
    const windowScrollX = win.pageXOffset || eDocument.documentElement.scrollLeft;
    if (browserWidth > 0 && left + element.clientWidth > browserWidth + windowScrollX) left = browserWidth + windowScrollX - element.clientWidth;
    if (left < 0) left = 0;
    if (browserHeight > 0 && top + element.clientHeight > browserHeight + windowScrollY) top = browserHeight + windowScrollY - element.clientHeight;
    if (top < 0) top = 0;
    element.style.left = `${left}px`;
    element.style.top = `${top}px`;
}
function $437b23f6a393c3bf$export$8ff9eef09a45371f(beans) {
    const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(beans);
    return activeEl === null || activeEl === $437b23f6a393c3bf$export$f63d0991874c6f81(beans).body;
}
function $437b23f6a393c3bf$export$27adf74cf591fd1e(gos) {
    if (gos.get("ensureDomOrder")) return false;
    return gos.get("animateRows");
}
function $437b23f6a393c3bf$export$d5f33aacea6a0849(gos) {
    if (gos.get("paginateChildRows") || gos.get("groupHideOpenParents") || $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print")) return false;
    return true;
}
function $437b23f6a393c3bf$export$96c51c2547b81aed(gos) {
    const autoGroupColumnDef = gos.get("autoGroupColumnDef");
    return !autoGroupColumnDef?.comparator && !gos.get("treeData");
}
function $437b23f6a393c3bf$export$3708afee0330994(gos) {
    const userValue = gos.get("groupAggFiltering");
    if (typeof userValue === "function") return gos.getCallback("groupAggFiltering");
    if (userValue === true) return ()=>true;
    return void 0;
}
function $437b23f6a393c3bf$export$c6fad27ed643a862(gos) {
    return gos.get("grandTotalRow");
}
function $437b23f6a393c3bf$export$713d6cabeaa7f2a5(gos) {
    const userValue = gos.get("groupTotalRow");
    if (typeof userValue === "function") return gos.getCallback("groupTotalRow");
    return ()=>userValue ?? void 0;
}
function $437b23f6a393c3bf$export$7122eb216a66bef2(gos) {
    const isHideOpenParents = !!gos.get("groupHideOpenParents");
    if (isHideOpenParents) return true;
    return gos.get("groupDisplayType") === "multipleColumns";
}
function $437b23f6a393c3bf$export$b911c5b172d227b4(gos, pivotMode) {
    if (pivotMode) return false;
    return gos.get("groupDisplayType") === "groupRows";
}
function $437b23f6a393c3bf$export$410912a9c501b8cc(gos, node, pivotMode) {
    return !!node.group && !node.footer && $437b23f6a393c3bf$export$b911c5b172d227b4(gos, pivotMode);
}
function $437b23f6a393c3bf$export$57c3bb2f89b59a89(gos) {
    const getRowId = gos.getCallback("getRowId");
    if (getRowId === void 0) return getRowId;
    return (params)=>{
        let id = getRowId(params);
        if (typeof id !== "string") {
            $437b23f6a393c3bf$export$e150fb6ea3b45c0d(()=>$437b23f6a393c3bf$export$545083624300f13d(25, {
                    id: id
                }), "getRowIdString");
            id = String(id);
        }
        return id;
    };
}
function $437b23f6a393c3bf$export$2f5892ff24cc879d(gos, node) {
    const isSkippingGroups = gos.get("groupHideParentOfSingleChild");
    if (isSkippingGroups === true) return true;
    if (isSkippingGroups === "leafGroupsOnly" && node.leafGroup) return true;
    if (gos.get("groupRemoveSingleChildren")) return true;
    if (gos.get("groupRemoveLowestSingleChildren") && node.leafGroup) return true;
    return false;
}
function $437b23f6a393c3bf$export$efae4c751fa7cc4d(gos) {
    const res = gos.get("maxConcurrentDatasourceRequests");
    return res > 0 ? res : void 0;
}
function $437b23f6a393c3bf$export$d80073cdfb810fa8(gos, isGrouped) {
    const preventVisibilityChanges = gos.get("suppressGroupChangesColumnVisibility");
    if (preventVisibilityChanges === true) return false;
    if (isGrouped && preventVisibilityChanges === "suppressHideOnGroup") return false;
    if (!isGrouped && preventVisibilityChanges === "suppressShowOnUngroup") return false;
    const legacySuppressOnGroup = gos.get("suppressRowGroupHidesColumns");
    if (isGrouped && legacySuppressOnGroup === true) return false;
    const legacySuppressOnUngroup = gos.get("suppressMakeColumnVisibleAfterUnGroup");
    if (!isGrouped && legacySuppressOnUngroup === true) return false;
    return true;
}
function $437b23f6a393c3bf$export$6df3a55606bca6ae(selection) {
    return selection?.checkboxes ?? true;
}
function $437b23f6a393c3bf$export$e92e75627785d7a4(selection) {
    return selection?.mode === "multiRow" && (selection.headerCheckbox ?? true);
}
function $437b23f6a393c3bf$export$8fb5d781b5c28347(rowSelection) {
    if (typeof rowSelection !== "object") return void 0;
    return rowSelection.checkboxLocation ?? "selectionColumn";
}
function $437b23f6a393c3bf$var$_getHideDisabledCheckboxes(selection) {
    return selection?.hideDisabledCheckboxes ?? false;
}
function $437b23f6a393c3bf$export$d3c80fcacb2e2d55(gos) {
    const rowSelection = gos.get("rowSelection");
    return typeof rowSelection !== "string";
}
function $437b23f6a393c3bf$export$63600d24670d494d(gos) {
    return gos.get("cellSelection") !== void 0;
}
function $437b23f6a393c3bf$export$93073c0b97dd7eba(gos) {
    const selection = gos.get("cellSelection");
    const useNewAPI = selection !== void 0;
    if (!useNewAPI) return gos.get("suppressMultiRangeSelection");
    return typeof selection !== "boolean" ? selection?.suppressMultiRanges ?? false : false;
}
function $437b23f6a393c3bf$export$1f7ca6920544d9e4(gos) {
    const selection = gos.get("cellSelection");
    const useNewAPI = selection !== void 0;
    return useNewAPI ? !!selection : gos.get("enableRangeSelection");
}
function $437b23f6a393c3bf$export$c96ba82819c56957(gos) {
    const selection = gos.get("cellSelection");
    const useNewAPI = selection !== void 0;
    if (!useNewAPI) return {
        mode: "fill",
        setFillValue: gos.get("fillOperation"),
        direction: gos.get("fillHandleDirection"),
        suppressClearOnFillReduction: gos.get("suppressClearOnFillReduction")
    };
    return typeof selection !== "boolean" && selection.handle?.mode === "fill" ? selection.handle : void 0;
}
function $437b23f6a393c3bf$var$_getEnableClickSelection(gos) {
    const selection = gos.get("rowSelection") ?? "single";
    if (typeof selection === "string") {
        const suppressRowClickSelection = gos.get("suppressRowClickSelection");
        const suppressRowDeselection = gos.get("suppressRowDeselection");
        if (suppressRowClickSelection && suppressRowDeselection) return false;
        else if (suppressRowClickSelection) return "enableDeselection";
        else if (suppressRowDeselection) return "enableSelection";
        else return true;
    }
    return selection.mode === "singleRow" || selection.mode === "multiRow" ? selection.enableClickSelection ?? false : false;
}
function $437b23f6a393c3bf$var$_getEnableSelection(gos) {
    const enableClickSelection = $437b23f6a393c3bf$var$_getEnableClickSelection(gos);
    return enableClickSelection === true || enableClickSelection === "enableSelection";
}
function $437b23f6a393c3bf$var$_getEnableDeselection(gos) {
    const enableClickSelection = $437b23f6a393c3bf$var$_getEnableClickSelection(gos);
    return enableClickSelection === true || enableClickSelection === "enableDeselection";
}
function $437b23f6a393c3bf$export$351959be716b3b33(gos) {
    const selection = gos.get("rowSelection");
    if (typeof selection === "string") return gos.get("isRowSelectable");
    return selection?.isRowSelectable;
}
function $437b23f6a393c3bf$export$80b6607444b3274f(arg) {
    const selection = "beanName" in arg && arg.beanName === "gos" ? arg.get("rowSelection") : arg.rowSelection;
    if (typeof selection === "string") switch(selection){
        case "multiple":
            return "multiRow";
        case "single":
            return "singleRow";
        default:
            return;
    }
    switch(selection?.mode){
        case "multiRow":
        case "singleRow":
            return selection.mode;
        default:
            return;
    }
}
function $437b23f6a393c3bf$export$7bd8c52ebc4117d6(arg) {
    const mode = $437b23f6a393c3bf$export$80b6607444b3274f(arg);
    return mode === "multiRow";
}
function $437b23f6a393c3bf$var$_getEnableSelectionWithoutKeys(gos) {
    const selection = gos.get("rowSelection");
    if (typeof selection === "string") return gos.get("rowMultiSelectWithClick");
    return selection?.enableSelectionWithoutKeys ?? false;
}
function $437b23f6a393c3bf$export$673080972d8c733e(gos) {
    const selection = gos.get("rowSelection");
    if (typeof selection === "string") {
        const groupSelectsChildren = gos.get("groupSelectsChildren");
        const groupSelectsFiltered = gos.get("groupSelectsFiltered");
        if (groupSelectsChildren && groupSelectsFiltered) return "filteredDescendants";
        else if (groupSelectsChildren) return "descendants";
        else return "self";
    }
    return selection?.mode === "multiRow" ? selection.groupSelects : void 0;
}
function $437b23f6a393c3bf$var$_getSelectAll(gos, defaultValue = true) {
    const rowSelection = gos.get("rowSelection");
    if (typeof rowSelection !== "object") return defaultValue ? "all" : void 0;
    return rowSelection.mode === "multiRow" ? rowSelection.selectAll : "all";
}
function $437b23f6a393c3bf$export$460e5745f0e6a40d(gos) {
    const groupSelection = $437b23f6a393c3bf$export$673080972d8c733e(gos);
    return groupSelection === "descendants" || groupSelection === "filteredDescendants";
}
function $437b23f6a393c3bf$var$_getMasterSelects(gos) {
    const rowSelection = gos.get("rowSelection");
    return typeof rowSelection === "object" && rowSelection.masterSelects || "self";
}
function $437b23f6a393c3bf$export$b68e6345dc6b83fa(gos) {
    return gos.isModuleRegistered("SetFilter") && !gos.get("suppressSetFilterByDefault");
}
function $437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos) {
    return gos.get("columnMenu") === "legacy";
}
function $437b23f6a393c3bf$export$cfe4cf52f3717a7b(gos) {
    return !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos);
}
function $437b23f6a393c3bf$export$2badf35af69344c1(eventName) {
    if (!eventName || eventName.length < 2) return eventName;
    return "on" + eventName[0].toUpperCase() + eventName.substring(1);
}
function $437b23f6a393c3bf$export$bfe37fc2d3c03134(gridOptions, component, gridOptionsKeys) {
    if (typeof gridOptions !== "object") gridOptions = {};
    const mergedOptions = {
        ...gridOptions
    };
    gridOptionsKeys.forEach((key)=>{
        const value = component[key];
        if (typeof value !== "undefined") mergedOptions[key] = value;
    });
    return mergedOptions;
}
function $437b23f6a393c3bf$export$52208033bd24c2b2(changes, api) {
    if (!changes) return;
    const gridChanges = {};
    let hasChanges = false;
    Object.keys(changes).forEach((key)=>{
        gridChanges[key] = changes[key];
        hasChanges = true;
    });
    if (!hasChanges) return;
    const internalUpdateEvent = {
        type: "gridOptionsChanged",
        options: gridChanges
    };
    api.dispatchEvent(internalUpdateEvent);
    const event = {
        type: "componentStateChanged",
        ...gridChanges
    };
    api.dispatchEvent(event);
}
function $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, params) {
    return gos.addGridCommonParams(params);
}
function $437b23f6a393c3bf$export$e9780a3033a82b4f(gos) {
    if (gos.get("treeData")) {
        if (gos.get("treeDataParentIdField")) return "treeSelfRef";
        if (gos.get("treeDataChildrenField")) return "treeNested";
        return "treePath";
    }
    return "group";
}
function $437b23f6a393c3bf$export$aa5750e97994dd3(providedGridOptions, gridOption) {
    return providedGridOptions[gridOption] ?? providedGridOptions[`gridOptions`]?.[gridOption] ?? $437b23f6a393c3bf$export$c3524a7ed99826d4(gridOption) ?? $437b23f6a393c3bf$var$GRID_OPTION_DEFAULTS[gridOption];
}
// packages/ag-grid-community/src/utils/event.ts
var $437b23f6a393c3bf$var$AG_GRID_STOP_PROPAGATION = "__ag_Grid_Stop_Propagation";
var $437b23f6a393c3bf$var$PASSIVE_EVENTS = [
    "touchstart",
    "touchend",
    "touchmove",
    "touchcancel",
    "scroll"
];
var $437b23f6a393c3bf$var$NON_PASSIVE_EVENTS = [
    "wheel"
];
var $437b23f6a393c3bf$var$supports = {};
function $437b23f6a393c3bf$export$456c40e80134d72a(event) {
    event[$437b23f6a393c3bf$var$AG_GRID_STOP_PROPAGATION] = true;
}
function $437b23f6a393c3bf$export$9a48e23524c6d58(event) {
    return event[$437b23f6a393c3bf$var$AG_GRID_STOP_PROPAGATION] === true;
}
var $437b23f6a393c3bf$var$_isEventSupported = /* @__PURE__ */ (()=>{
    const tags = {
        select: "input",
        change: "input",
        submit: "form",
        reset: "form",
        error: "img",
        load: "img",
        abort: "img"
    };
    const eventChecker = (eventName)=>{
        if (typeof $437b23f6a393c3bf$var$supports[eventName] === "boolean") return $437b23f6a393c3bf$var$supports[eventName];
        const el = document.createElement(tags[eventName] || "div");
        eventName = "on" + eventName;
        return $437b23f6a393c3bf$var$supports[eventName] = eventName in el;
    };
    return eventChecker;
})();
function $437b23f6a393c3bf$var$_getCtrlForEventTarget(gos, eventTarget, type) {
    let sourceElement = eventTarget;
    while(sourceElement){
        const renderedComp = $437b23f6a393c3bf$var$_getDomData(gos, sourceElement, type);
        if (renderedComp) return renderedComp;
        sourceElement = sourceElement.parentElement;
    }
    return null;
}
function $437b23f6a393c3bf$export$b5446458166e97b4(element, event) {
    if (!event || !element) return false;
    return $437b23f6a393c3bf$var$_getEventPath(event).indexOf(element) >= 0;
}
function $437b23f6a393c3bf$var$_createEventPath(event) {
    const res = [];
    let pointer = event.target;
    while(pointer){
        res.push(pointer);
        pointer = pointer.parentElement;
    }
    return res;
}
function $437b23f6a393c3bf$var$_getEventPath(event) {
    const eventNoType = event;
    if (eventNoType.path) return eventNoType.path;
    if (eventNoType.composedPath) return eventNoType.composedPath();
    return $437b23f6a393c3bf$var$_createEventPath(eventNoType);
}
function $437b23f6a393c3bf$var$_addSafePassiveEventListener(frameworkOverrides, eElement, event, listener) {
    const passive = $437b23f6a393c3bf$var$getPassiveStateForEvent(event);
    let options;
    if (passive != null) options = {
        passive: passive
    };
    if (frameworkOverrides && frameworkOverrides.addEventListener) frameworkOverrides.addEventListener(eElement, event, listener, options);
}
var $437b23f6a393c3bf$var$getPassiveStateForEvent = (event)=>{
    const isPassive = $437b23f6a393c3bf$var$PASSIVE_EVENTS.includes(event);
    const isNonPassive = $437b23f6a393c3bf$var$NON_PASSIVE_EVENTS.includes(event);
    if (isPassive) return true;
    if (isNonPassive) return false;
};
// packages/ag-grid-community/src/context/beanStub.ts
var $437b23f6a393c3bf$export$2032c8ef3788dfbd = class {
    constructor(){
        // not named context to allow children to use 'context' as a variable name
        this.destroyFunctions = [];
        this.destroyed = false;
        // for vue 3 - prevents Vue from trying to make this (and obviously any sub classes) from being reactive
        // prevents vue from creating proxies for created objects and prevents identity related issues
        this.__v_skip = true;
        this.propertyListenerId = 0;
        // Enable multiple grid properties to be updated together by the user but only trigger shared logic once.
        // Closely related to logic in GridOptionsUtils.ts _processOnChange
        this.lastChangeSetIdLookup = {};
        this.isAlive = ()=>!this.destroyed;
    }
    preWireBeans(beans) {
        this.beans = beans;
        this.stubContext = beans.context;
        this.eventSvc = beans.eventSvc;
        this.gos = beans.gos;
    }
    // this was a test constructor niall built, when active, it prints after 5 seconds all beans/components that are
    // not destroyed. to use, create a new grid, then api.destroy() before 5 seconds. then anything that gets printed
    // points to a bean or component that was not properly disposed of.
    // constructor() {
    //     setTimeout(()=> {
    //         if (this.isAlive()) {
    //             let prototype: any = Object.getPrototypeOf(this);
    //             const constructor: any = prototype.constructor;
    //             const constructorString = constructor.toString();
    //             const beanName = constructorString.substring(9, constructorString.indexOf("("));
    //             console.log('is alive ' + beanName);
    //         }
    //     }, 5000);
    // }
    destroy() {
        const { destroyFunctions: destroyFunctions } = this;
        for(let i = 0; i < destroyFunctions.length; i++)destroyFunctions[i]();
        destroyFunctions.length = 0;
        this.destroyed = true;
        this.dispatchLocalEvent({
            type: "destroyed"
        });
    }
    // The typing of AgEventListener<any, any, any> is not ideal, but it's the best we can do at the moment to enable
    // eventSvc to have the best typing at the expense of BeanStub local events
    /** Add a local event listener against this BeanStub */ addEventListener(eventType, listener, async) {
        if (!this.localEventService) this.localEventService = new $437b23f6a393c3bf$export$820da7696a401cdc();
        this.localEventService.addEventListener(eventType, listener, async);
    }
    /** Remove a local event listener from this BeanStub */ removeEventListener(eventType, listener, async) {
        this.localEventService?.removeEventListener(eventType, listener, async);
    }
    dispatchLocalEvent(event) {
        this.localEventService?.dispatchEvent(event);
    }
    addManagedElementListeners(object, handlers) {
        return this._setupListeners(object, handlers);
    }
    addManagedEventListeners(handlers) {
        return this._setupListeners(this.eventSvc, handlers);
    }
    addManagedListeners(object, handlers) {
        return this._setupListeners(object, handlers);
    }
    _setupListeners(object, handlers) {
        const destroyFuncs = [];
        for (const k of Object.keys(handlers)){
            const handler = handlers[k];
            if (handler) destroyFuncs.push(this._setupListener(object, k, handler));
        }
        return destroyFuncs;
    }
    _setupListener(object, event, listener) {
        if (this.destroyed) return ()=>null;
        let destroyFunc;
        if ($437b23f6a393c3bf$var$isAgEventEmitter(object)) {
            object.__addEventListener(event, listener);
            destroyFunc = ()=>{
                object.__removeEventListener(event, listener);
                return null;
            };
        } else {
            if (object instanceof HTMLElement) $437b23f6a393c3bf$var$_addSafePassiveEventListener(this.beans.frameworkOverrides, object, event, listener);
            else object.addEventListener(event, listener);
            destroyFunc = ()=>{
                object.removeEventListener(event, listener);
                return null;
            };
        }
        this.destroyFunctions.push(destroyFunc);
        return ()=>{
            destroyFunc();
            this.destroyFunctions = this.destroyFunctions.filter((fn)=>fn !== destroyFunc);
            return null;
        };
    }
    /**
   * Setup a managed property listener for the given GridOption property.
   * However, stores the destroy function in the beanStub so that if this bean
   * is a component the destroy function will be called when the component is destroyed
   * as opposed to being cleaned up only when the GridOptionsService is destroyed.
   */ setupGridOptionListener(event, listener) {
        const { gos: gos } = this;
        gos.addPropertyEventListener(event, listener);
        const destroyFunc = ()=>{
            gos.removePropertyEventListener(event, listener);
            return null;
        };
        this.destroyFunctions.push(destroyFunc);
        return ()=>{
            destroyFunc();
            this.destroyFunctions = this.destroyFunctions.filter((fn)=>fn !== destroyFunc);
            return null;
        };
    }
    /**
   * Setup a managed property listener for the given GridOption property.
   * @param event GridOption property to listen to changes for.
   * @param listener Listener to run when property value changes
   */ addManagedPropertyListener(event, listener) {
        if (this.destroyed) return ()=>null;
        return this.setupGridOptionListener(event, listener);
    }
    /**
   * Setup managed property listeners for the given set of GridOption properties.
   * The listener will be run if any of the property changes but will only run once if
   * multiple of the properties change within the same framework lifecycle event.
   * Works on the basis that GridOptionsService updates all properties *before* any property change events are fired.
   * @param events Array of GridOption properties to listen for changes too.
   * @param listener Shared listener to run if any of the properties change
   */ addManagedPropertyListeners(events, listener) {
        if (this.destroyed) return;
        const eventsKey = events.join("-") + this.propertyListenerId++;
        const wrappedListener = (event)=>{
            if (event.changeSet) {
                if (event.changeSet && event.changeSet.id === this.lastChangeSetIdLookup[eventsKey]) return;
                this.lastChangeSetIdLookup[eventsKey] = event.changeSet.id;
            }
            const propertiesChangeEvent = {
                type: "gridPropertyChanged",
                changeSet: event.changeSet,
                source: event.source
            };
            listener(propertiesChangeEvent);
        };
        events.forEach((event)=>this.setupGridOptionListener(event, wrappedListener));
    }
    getLocaleTextFunc() {
        return $437b23f6a393c3bf$export$cc0bf4adff5b95e7(this.beans.localeSvc);
    }
    addDestroyFunc(func) {
        if (this.isAlive()) this.destroyFunctions.push(func);
        else func();
    }
    /** doesn't throw an error if `bean` is undefined */ createOptionalManagedBean(bean, context) {
        return bean ? this.createManagedBean(bean, context) : void 0;
    }
    createManagedBean(bean, context) {
        const res = this.createBean(bean, context);
        this.addDestroyFunc(this.destroyBean.bind(this, bean, context));
        return res;
    }
    createBean(bean, context, afterPreCreateCallback) {
        return (context || this.stubContext).createBean(bean, afterPreCreateCallback);
    }
    /**
   * Destroys a bean and returns undefined to support destruction and clean up in a single line.
   * this.dateComp = this.context.destroyBean(this.dateComp);
   */ destroyBean(bean, context) {
        return (context || this.stubContext).destroyBean(bean);
    }
    /**
   * Destroys an array of beans and returns an empty array to support destruction and clean up in a single line.
   * this.dateComps = this.context.destroyBeans(this.dateComps);
   */ destroyBeans(beans, context) {
        return (context || this.stubContext).destroyBeans(beans);
    }
};
function $437b23f6a393c3bf$var$isAgEventEmitter(object) {
    return object.__addEventListener !== void 0;
}
// packages/ag-grid-community/src/utils/string.ts
var $437b23f6a393c3bf$var$reUnescapedHtml = /[&<>"']/g;
var $437b23f6a393c3bf$var$HTML_ESCAPES = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
function $437b23f6a393c3bf$export$a16cfb6652fe466f(toEscape) {
    return toEscape?.toString().toString() ?? null;
}
function $437b23f6a393c3bf$export$3df06b741968da82(toEscape) {
    return $437b23f6a393c3bf$export$a16cfb6652fe466f(toEscape)?.replace($437b23f6a393c3bf$var$reUnescapedHtml, (chr)=>$437b23f6a393c3bf$var$HTML_ESCAPES[chr]) ?? null;
}
// packages/ag-grid-community/src/entities/agColumn.ts
var $437b23f6a393c3bf$var$COL_DEF_DEFAULTS = {
    resizable: true,
    sortable: true
};
var $437b23f6a393c3bf$var$instanceIdSequence = 0;
function $437b23f6a393c3bf$var$getNextColInstanceId() {
    return $437b23f6a393c3bf$var$instanceIdSequence++;
}
function $437b23f6a393c3bf$export$891484e65a02ec71(col) {
    return col instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2;
}
var $437b23f6a393c3bf$export$a8da3e2b83e5ddf2 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(colDef, userProvidedColDef, colId, primary){
        super();
        this.colDef = colDef;
        this.userProvidedColDef = userProvidedColDef;
        this.colId = colId;
        this.primary = primary;
        this.isColumn = true;
        // used by React (and possibly other frameworks) as key for rendering. also used to
        // identify old vs new columns for destroying cols when no longer used.
        this.instanceId = $437b23f6a393c3bf$var$getNextColInstanceId();
        // The measured height of this column's header when autoHeaderHeight is enabled
        this.autoHeaderHeight = null;
        this.moving = false;
        this.resizing = false;
        this.menuVisible = false;
        this.lastLeftPinned = false;
        this.firstRightPinned = false;
        this.filterActive = false;
        this.colEventSvc = new $437b23f6a393c3bf$export$820da7696a401cdc();
        this.tooltipEnabled = false;
        this.rowGroupActive = false;
        this.pivotActive = false;
        this.aggregationActive = false;
        this.flex = null;
        this.colIdSanitised = $437b23f6a393c3bf$export$3df06b741968da82(colId);
    }
    destroy() {
        super.destroy();
        this.beans.rowSpanSvc?.deregister(this);
    }
    getInstanceId() {
        return this.instanceId;
    }
    setState() {
        const { colDef: colDef, beans: { sortSvc: sortSvc, pinnedCols: pinnedCols, colFlex: colFlex } } = this;
        sortSvc?.initCol(this);
        const hide = colDef.hide;
        if (hide !== void 0) this.visible = !hide;
        else this.visible = !colDef.initialHide;
        pinnedCols?.initCol(this);
        colFlex?.initCol(this);
    }
    // gets called when user provides an alternative colDef, eg
    setColDef(colDef, userProvidedColDef, source) {
        const colSpanChanged = colDef.spanRows !== this.colDef.spanRows;
        this.colDef = colDef;
        this.userProvidedColDef = userProvidedColDef;
        this.initMinAndMaxWidths();
        this.initDotNotation();
        this.initTooltip();
        if (colSpanChanged) {
            this.beans.rowSpanSvc?.deregister(this);
            this.initRowSpan();
        }
        this.dispatchColEvent("colDefChanged", source);
    }
    getUserProvidedColDef() {
        return this.userProvidedColDef;
    }
    getParent() {
        return this.parent;
    }
    getOriginalParent() {
        return this.originalParent;
    }
    // this is done after constructor as it uses gridOptionsService
    postConstruct() {
        this.setState();
        this.initMinAndMaxWidths();
        this.resetActualWidth("gridInitializing");
        this.initDotNotation();
        this.initTooltip();
        this.initRowSpan();
        this.addPivotListener();
    }
    initDotNotation() {
        const { gos: gos, colDef: { field: field, tooltipField: tooltipField } } = this;
        const suppressDotNotation = gos.get("suppressFieldDotNotation");
        this.fieldContainsDots = $437b23f6a393c3bf$export$25d27f17d3af40f7(field) && field.indexOf(".") >= 0 && !suppressDotNotation;
        this.tooltipFieldContainsDots = $437b23f6a393c3bf$export$25d27f17d3af40f7(tooltipField) && tooltipField.indexOf(".") >= 0 && !suppressDotNotation;
    }
    initMinAndMaxWidths() {
        const colDef = this.colDef;
        this.minWidth = colDef.minWidth ?? this.beans.environment.getDefaultColumnMinWidth();
        this.maxWidth = colDef.maxWidth ?? Number.MAX_SAFE_INTEGER;
    }
    initTooltip() {
        this.beans.tooltipSvc?.initCol(this);
    }
    initRowSpan() {
        if (this.colDef.spanRows) this.beans.rowSpanSvc?.register(this);
    }
    addPivotListener() {
        const pivotColDefSvc = this.beans.pivotColDefSvc;
        const pivotValueColumn = this.colDef.pivotValueColumn;
        if (!pivotColDefSvc || !pivotValueColumn) return;
        this.addManagedListeners(pivotValueColumn, {
            colDefChanged: (evt)=>{
                const colDef = pivotColDefSvc.recreateColDef(this.colDef);
                this.setColDef(colDef, colDef, evt.source);
            }
        });
    }
    resetActualWidth(source) {
        const initialWidth = this.calculateColInitialWidth(this.colDef);
        this.setActualWidth(initialWidth, source, true);
    }
    calculateColInitialWidth(colDef) {
        let width;
        const colDefWidth = colDef.width;
        const colDefInitialWidth = colDef.initialWidth;
        if (colDefWidth != null) width = colDefWidth;
        else if (colDefInitialWidth != null) width = colDefInitialWidth;
        else width = 200;
        return Math.max(Math.min(width, this.maxWidth), this.minWidth);
    }
    isEmptyGroup() {
        return false;
    }
    isRowGroupDisplayed(colId) {
        return this.beans.showRowGroupCols?.isRowGroupDisplayed(this, colId) ?? false;
    }
    isPrimary() {
        return this.primary;
    }
    isFilterAllowed() {
        const filterDefined = !!this.colDef.filter;
        return filterDefined;
    }
    isFieldContainsDots() {
        return this.fieldContainsDots;
    }
    isTooltipEnabled() {
        return this.tooltipEnabled;
    }
    isTooltipFieldContainsDots() {
        return this.tooltipFieldContainsDots;
    }
    getHighlighted() {
        return this.highlighted;
    }
    __addEventListener(eventType, listener) {
        this.colEventSvc.addEventListener(eventType, listener);
    }
    __removeEventListener(eventType, listener) {
        this.colEventSvc.removeEventListener(eventType, listener);
    }
    /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */ addEventListener(eventType, userListener) {
        this.frameworkEventListenerService = this.beans.frameworkOverrides.createLocalEventListenerWrapper?.(this.frameworkEventListenerService, this.colEventSvc);
        const listener = this.frameworkEventListenerService?.wrap(eventType, userListener) ?? userListener;
        this.colEventSvc.addEventListener(eventType, listener);
    }
    /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */ removeEventListener(eventType, userListener) {
        const listener = this.frameworkEventListenerService?.unwrap(eventType, userListener) ?? userListener;
        this.colEventSvc.removeEventListener(eventType, listener);
    }
    createColumnFunctionCallbackParams(rowNode) {
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            node: rowNode,
            data: rowNode.data,
            column: this,
            colDef: this.colDef
        });
    }
    isSuppressNavigable(rowNode) {
        return this.beans.cellNavigation?.isSuppressNavigable(this, rowNode) ?? false;
    }
    isCellEditable(rowNode) {
        return this.beans.editSvc?.isCellEditable({
            rowNode: rowNode,
            column: this
        }) ?? false;
    }
    isSuppressFillHandle() {
        return !!this.colDef.suppressFillHandle;
    }
    isAutoHeight() {
        return !!this.colDef.autoHeight;
    }
    isAutoHeaderHeight() {
        return !!this.colDef.autoHeaderHeight;
    }
    isRowDrag(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef.rowDrag);
    }
    isDndSource(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef.dndSource);
    }
    isCellCheckboxSelection(rowNode) {
        return this.beans.selectionSvc?.isCellCheckboxSelection(this, rowNode) ?? false;
    }
    isSuppressPaste(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef?.suppressPaste ?? null);
    }
    isResizable() {
        return !!this.getColDefValue("resizable");
    }
    /** Get value from ColDef or default if it exists. */ getColDefValue(key) {
        return this.colDef[key] ?? $437b23f6a393c3bf$var$COL_DEF_DEFAULTS[key];
    }
    isColumnFunc(rowNode, value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "function") {
            const params = this.createColumnFunctionCallbackParams(rowNode);
            const editableFunc = value;
            return editableFunc(params);
        }
        return false;
    }
    createColumnEvent(type, source) {
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            type: type,
            column: this,
            columns: [
                this
            ],
            source: source
        });
    }
    isMoving() {
        return this.moving;
    }
    getSort() {
        return this.sort;
    }
    isSortable() {
        return !!this.getColDefValue("sortable");
    }
    /** @deprecated v32 use col.getSort() === 'asc */ isSortAscending() {
        return this.sort === "asc";
    }
    /** @deprecated v32 use col.getSort() === 'desc */ isSortDescending() {
        return this.sort === "desc";
    }
    /** @deprecated v32 use col.getSort() === undefined */ isSortNone() {
        return $437b23f6a393c3bf$export$672d9e47bc342bac(this.sort);
    }
    /** @deprecated v32 use col.getSort() !== undefined */ isSorting() {
        return $437b23f6a393c3bf$export$25d27f17d3af40f7(this.sort);
    }
    getSortIndex() {
        return this.sortIndex;
    }
    isMenuVisible() {
        return this.menuVisible;
    }
    getAggFunc() {
        return this.aggFunc;
    }
    getLeft() {
        return this.left;
    }
    getOldLeft() {
        return this.oldLeft;
    }
    getRight() {
        return this.left + this.actualWidth;
    }
    setLeft(left, source) {
        this.oldLeft = this.left;
        if (this.left !== left) {
            this.left = left;
            this.dispatchColEvent("leftChanged", source);
        }
    }
    isFilterActive() {
        return this.filterActive;
    }
    /** @deprecated v33 Use `api.isColumnHovered(column)` instead. */ isHovered() {
        $437b23f6a393c3bf$export$545083624300f13d(261);
        return !!this.beans.colHover?.isHovered(this);
    }
    setFirstRightPinned(firstRightPinned, source) {
        if (this.firstRightPinned !== firstRightPinned) {
            this.firstRightPinned = firstRightPinned;
            this.dispatchColEvent("firstRightPinnedChanged", source);
        }
    }
    setLastLeftPinned(lastLeftPinned, source) {
        if (this.lastLeftPinned !== lastLeftPinned) {
            this.lastLeftPinned = lastLeftPinned;
            this.dispatchColEvent("lastLeftPinnedChanged", source);
        }
    }
    isFirstRightPinned() {
        return this.firstRightPinned;
    }
    isLastLeftPinned() {
        return this.lastLeftPinned;
    }
    isPinned() {
        return this.pinned === "left" || this.pinned === "right";
    }
    isPinnedLeft() {
        return this.pinned === "left";
    }
    isPinnedRight() {
        return this.pinned === "right";
    }
    getPinned() {
        return this.pinned;
    }
    setVisible(visible, source) {
        const newValue = visible === true;
        if (this.visible !== newValue) {
            this.visible = newValue;
            this.dispatchColEvent("visibleChanged", source);
        }
        this.dispatchStateUpdatedEvent("hide");
    }
    isVisible() {
        return this.visible;
    }
    isSpanHeaderHeight() {
        const colDef = this.getColDef();
        return !colDef.suppressSpanHeaderHeight;
    }
    /**
   * Returns the first parent that is not a padding group.
   */ getFirstRealParent() {
        let parent = this.getOriginalParent();
        while(parent && parent.isPadding())parent = parent.getOriginalParent();
        return parent;
    }
    getColumnGroupPaddingInfo() {
        let parent = this.getParent();
        if (!parent || !parent.isPadding()) return {
            numberOfParents: 0,
            isSpanningTotal: false
        };
        const numberOfParents = parent.getPaddingLevel() + 1;
        let isSpanningTotal = true;
        while(parent){
            if (!parent.isPadding()) {
                isSpanningTotal = false;
                break;
            }
            parent = parent.getParent();
        }
        return {
            numberOfParents: numberOfParents,
            isSpanningTotal: isSpanningTotal
        };
    }
    getColDef() {
        return this.colDef;
    }
    getDefinition() {
        return this.colDef;
    }
    getColumnGroupShow() {
        return this.colDef.columnGroupShow;
    }
    getColId() {
        return this.colId;
    }
    getId() {
        return this.colId;
    }
    getUniqueId() {
        return this.colId;
    }
    getActualWidth() {
        return this.actualWidth;
    }
    getAutoHeaderHeight() {
        return this.autoHeaderHeight;
    }
    /** Returns true if the header height has changed */ setAutoHeaderHeight(height) {
        const changed = height !== this.autoHeaderHeight;
        this.autoHeaderHeight = height;
        return changed;
    }
    createBaseColDefParams(rowNode) {
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            node: rowNode,
            data: rowNode.data,
            colDef: this.colDef,
            column: this
        });
        return params;
    }
    getColSpan(rowNode) {
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(this.colDef.colSpan)) return 1;
        const params = this.createBaseColDefParams(rowNode);
        const colSpan = this.colDef.colSpan(params);
        return Math.max(colSpan, 1);
    }
    getRowSpan(rowNode) {
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(this.colDef.rowSpan)) return 1;
        const params = this.createBaseColDefParams(rowNode);
        const rowSpan = this.colDef.rowSpan(params);
        return Math.max(rowSpan, 1);
    }
    setActualWidth(actualWidth, source, silent = false) {
        actualWidth = Math.max(actualWidth, this.minWidth);
        actualWidth = Math.min(actualWidth, this.maxWidth);
        if (this.actualWidth !== actualWidth) {
            this.actualWidth = actualWidth;
            if (this.flex != null && source !== "flex" && source !== "gridInitializing") this.flex = null;
            if (!silent) this.fireColumnWidthChangedEvent(source);
        }
        this.dispatchStateUpdatedEvent("width");
    }
    fireColumnWidthChangedEvent(source) {
        this.dispatchColEvent("widthChanged", source);
    }
    isGreaterThanMax(width) {
        return width > this.maxWidth;
    }
    getMinWidth() {
        return this.minWidth;
    }
    getMaxWidth() {
        return this.maxWidth;
    }
    getFlex() {
        return this.flex;
    }
    isRowGroupActive() {
        return this.rowGroupActive;
    }
    isPivotActive() {
        return this.pivotActive;
    }
    isAnyFunctionActive() {
        return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
    }
    isAnyFunctionAllowed() {
        return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
    }
    isValueActive() {
        return this.aggregationActive;
    }
    isAllowPivot() {
        return this.colDef.enablePivot === true;
    }
    isAllowValue() {
        return this.colDef.enableValue === true;
    }
    isAllowRowGroup() {
        return this.colDef.enableRowGroup === true;
    }
    dispatchColEvent(type, source, additionalEventAttributes) {
        const colEvent = this.createColumnEvent(type, source);
        if (additionalEventAttributes) $437b23f6a393c3bf$export$8ade6bd474fcde42(colEvent, additionalEventAttributes);
        this.colEventSvc.dispatchEvent(colEvent);
    }
    dispatchStateUpdatedEvent(key) {
        this.colEventSvc.dispatchEvent({
            type: "columnStateUpdated",
            key: key
        });
    }
};
// packages/ag-grid-community/src/entities/agProvidedColumnGroup.ts
function $437b23f6a393c3bf$export$bb4bfad2b594b78e(col) {
    return col instanceof $437b23f6a393c3bf$export$7ff27642a6ecc1cf;
}
var $437b23f6a393c3bf$export$7ff27642a6ecc1cf = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(colGroupDef, groupId, padding, level){
        super();
        this.colGroupDef = colGroupDef;
        this.groupId = groupId;
        this.padding = padding;
        this.level = level;
        this.isColumn = false;
        this.expandable = false;
        // used by React (and possibly other frameworks) as key for rendering. also used to
        // identify old vs new columns for destroying cols when no longer used.
        this.instanceId = $437b23f6a393c3bf$var$getNextColInstanceId();
        this.expandableListenerRemoveCallback = null;
        this.expanded = !!colGroupDef?.openByDefault;
    }
    destroy() {
        if (this.expandableListenerRemoveCallback) this.reset(null, void 0);
        super.destroy();
    }
    reset(colGroupDef, level) {
        this.colGroupDef = colGroupDef;
        this.level = level;
        this.originalParent = null;
        if (this.expandableListenerRemoveCallback) this.expandableListenerRemoveCallback();
        this.children = void 0;
        this.expandable = void 0;
    }
    getInstanceId() {
        return this.instanceId;
    }
    getOriginalParent() {
        return this.originalParent;
    }
    getLevel() {
        return this.level;
    }
    isVisible() {
        if (this.children) return this.children.some((child)=>child.isVisible());
        return false;
    }
    isPadding() {
        return this.padding;
    }
    setExpanded(expanded) {
        this.expanded = expanded === void 0 ? false : expanded;
        this.dispatchLocalEvent({
            type: "expandedChanged"
        });
    }
    isExpandable() {
        return this.expandable;
    }
    isExpanded() {
        return this.expanded;
    }
    getGroupId() {
        return this.groupId;
    }
    getId() {
        return this.getGroupId();
    }
    setChildren(children) {
        this.children = children;
    }
    getChildren() {
        return this.children;
    }
    getColGroupDef() {
        return this.colGroupDef;
    }
    getLeafColumns() {
        const result = [];
        this.addLeafColumns(result);
        return result;
    }
    forEachLeafColumn(callback) {
        if (!this.children) return;
        for (const child of this.children){
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) callback(child);
            else if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) child.forEachLeafColumn(callback);
        }
    }
    addLeafColumns(leafColumns) {
        if (!this.children) return;
        this.children.forEach((child)=>{
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) leafColumns.push(child);
            else if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) child.addLeafColumns(leafColumns);
        });
    }
    getColumnGroupShow() {
        const colGroupDef = this.colGroupDef;
        if (!colGroupDef) return;
        return colGroupDef.columnGroupShow;
    }
    // need to check that this group has at least one col showing when both expanded and contracted.
    // if not, then we don't allow expanding and contracting on this group
    setupExpandable() {
        this.setExpandable();
        if (this.expandableListenerRemoveCallback) this.expandableListenerRemoveCallback();
        const listener = this.onColumnVisibilityChanged.bind(this);
        this.getLeafColumns().forEach((col)=>col.__addEventListener("visibleChanged", listener));
        this.expandableListenerRemoveCallback = ()=>{
            this.getLeafColumns().forEach((col)=>col.__removeEventListener("visibleChanged", listener));
            this.expandableListenerRemoveCallback = null;
        };
    }
    setExpandable() {
        if (this.isPadding()) return;
        let atLeastOneShowingWhenOpen = false;
        let atLeastOneShowingWhenClosed = false;
        let atLeastOneChangeable = false;
        const children = this.findChildrenRemovingPadding();
        for(let i = 0, j = children.length; i < j; i++){
            const abstractColumn = children[i];
            if (!abstractColumn.isVisible()) continue;
            const headerGroupShow = abstractColumn.getColumnGroupShow();
            if (headerGroupShow === "open") {
                atLeastOneShowingWhenOpen = true;
                atLeastOneChangeable = true;
            } else if (headerGroupShow === "closed") {
                atLeastOneShowingWhenClosed = true;
                atLeastOneChangeable = true;
            } else {
                atLeastOneShowingWhenOpen = true;
                atLeastOneShowingWhenClosed = true;
            }
        }
        const expandable = atLeastOneShowingWhenOpen && atLeastOneShowingWhenClosed && atLeastOneChangeable;
        if (this.expandable !== expandable) {
            this.expandable = expandable;
            this.dispatchLocalEvent({
                type: "expandableChanged"
            });
        }
    }
    findChildrenRemovingPadding() {
        const res = [];
        const process = (items)=>{
            items.forEach((item)=>{
                const skipBecausePadding = $437b23f6a393c3bf$export$bb4bfad2b594b78e(item) && item.isPadding();
                if (skipBecausePadding) process(item.children);
                else res.push(item);
            });
        };
        process(this.children);
        return res;
    }
    onColumnVisibilityChanged() {
        this.setExpandable();
    }
};
// packages/ag-grid-community/src/entities/defaultColumnTypes.ts
var $437b23f6a393c3bf$var$DefaultColumnTypes = {
    numericColumn: {
        headerClass: "ag-right-aligned-header",
        cellClass: "ag-right-aligned-cell"
    },
    rightAligned: {
        headerClass: "ag-right-aligned-header",
        cellClass: "ag-right-aligned-cell"
    }
};
// packages/ag-grid-community/src/columns/columnGroups/columnGroupUtils.ts
function $437b23f6a393c3bf$var$createMergedColGroupDef(beans, colGroupDef, groupId) {
    const colGroupDefMerged = {};
    const gos = beans.gos;
    Object.assign(colGroupDefMerged, gos.get("defaultColGroupDef"));
    Object.assign(colGroupDefMerged, colGroupDef);
    gos.validateColDef(colGroupDefMerged, groupId);
    return colGroupDefMerged;
}
// packages/ag-grid-community/src/columns/columnKeyCreator.ts
var $437b23f6a393c3bf$export$f67d1427302c96a3 = class {
    constructor(){
        this.existingKeys = {};
    }
    addExistingKeys(keys) {
        for(let i = 0; i < keys.length; i++)this.existingKeys[keys[i]] = true;
    }
    getUniqueKey(colId, colField) {
        colId = $437b23f6a393c3bf$export$2a74c29220d5c88e(colId);
        let count = 0;
        while(true){
            let idToTry = colId ?? colField;
            if (idToTry) {
                if (count !== 0) idToTry += "_" + count;
            } else idToTry = count;
            if (!this.existingKeys[idToTry]) {
                const usedId = String(idToTry);
                if (colId && count > 0) $437b23f6a393c3bf$export$545083624300f13d(273, {
                    providedId: colId,
                    usedId: usedId
                });
                this.existingKeys[usedId] = true;
                return usedId;
            }
            count++;
        }
    }
};
// packages/ag-grid-community/src/utils/array.ts
var $437b23f6a393c3bf$export$c758d9371030a6ac = Object.freeze([]);
function $437b23f6a393c3bf$export$236389741107357f(arr) {
    if (!arr?.length) return;
    return arr[arr.length - 1];
}
function $437b23f6a393c3bf$export$893967cdb9833fdd(a, b, comparator) {
    if (a == null && b == null) return true;
    return a != null && b != null && a.length === b.length && a.every((value, index)=>comparator ? comparator(value, b[index]) : b[index] === value);
}
function $437b23f6a393c3bf$var$_forAll(array, callback) {
    if (!array) return;
    for (const value of array)callback(value);
}
function $437b23f6a393c3bf$export$83a881c8b5120679(array, object) {
    const index = array.indexOf(object);
    if (index >= 0) array.splice(index, 1);
}
function $437b23f6a393c3bf$var$_moveInArray(array, objectsToMove, toIndex) {
    for(let i = 0; i < objectsToMove.length; i++)$437b23f6a393c3bf$export$83a881c8b5120679(array, objectsToMove[i]);
    for(let i = objectsToMove.length - 1; i >= 0; i--)array.splice(toIndex, 0, objectsToMove[i]);
}
function $437b23f6a393c3bf$export$5e3f39c5068e375d(arrays) {
    return [].concat.apply([], arrays);
}
// packages/ag-grid-community/src/columns/columnUtils.ts
var $437b23f6a393c3bf$export$a7016588c430dba6 = "ag-Grid-AutoColumn";
var $437b23f6a393c3bf$export$dd05e5f089eb2421 = "ag-Grid-SelectionColumn";
var $437b23f6a393c3bf$export$f55c01dfb205b029 = "ag-Grid-RowNumbersColumn";
function $437b23f6a393c3bf$export$42da2aea8fab5b(rootColumns) {
    const result = [];
    const recursiveFindColumns = (childColumns)=>{
        for(let i = 0; i < childColumns.length; i++){
            const child = childColumns[i];
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) result.push(child);
            else if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) recursiveFindColumns(child.getChildren());
        }
    };
    recursiveFindColumns(rootColumns);
    return result;
}
function $437b23f6a393c3bf$var$getWidthOfColsInList(columnList) {
    return columnList.reduce((width, col)=>width + col.getActualWidth(), 0);
}
function $437b23f6a393c3bf$export$dbaaa57234b60d8f(beans, oldTree, newTree) {
    const oldObjectsById = {};
    if (!oldTree) return;
    $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, oldTree, (child)=>{
        oldObjectsById[child.getInstanceId()] = child;
    });
    if (newTree) $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, newTree, (child)=>{
        oldObjectsById[child.getInstanceId()] = null;
    });
    const colsToDestroy = Object.values(oldObjectsById).filter((item)=>item != null);
    beans.context.destroyBeans(colsToDestroy);
}
function $437b23f6a393c3bf$export$61b34611dc010a97(col) {
    const colId = col.getId();
    return colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6);
}
function $437b23f6a393c3bf$export$f6074a9792015c5d(col) {
    const id = typeof col === "string" ? col : "getColId" in col ? col.getColId() : col.colId;
    return id?.startsWith($437b23f6a393c3bf$export$dd05e5f089eb2421) ?? false;
}
function $437b23f6a393c3bf$export$3d3e7d751f0445eb(col) {
    const id = typeof col === "string" ? col : "getColId" in col ? col.getColId() : col.colId;
    return id?.startsWith($437b23f6a393c3bf$export$f55c01dfb205b029) ?? false;
}
function $437b23f6a393c3bf$export$ee97d5717f8d44ec(col) {
    return $437b23f6a393c3bf$export$f6074a9792015c5d(col) || $437b23f6a393c3bf$export$3d3e7d751f0445eb(col);
}
function $437b23f6a393c3bf$var$convertColumnTypes(type) {
    let typeKeys = [];
    if (type instanceof Array) typeKeys = type;
    else if (typeof type === "string") typeKeys = type.split(",");
    return typeKeys;
}
function $437b23f6a393c3bf$export$f56e341a1fe35ed4(colsA, colsB) {
    return $437b23f6a393c3bf$export$893967cdb9833fdd(colsA, colsB, (a, b)=>a.getColId() === b.getColId());
}
function $437b23f6a393c3bf$export$c82fd63ff1738bed(cols) {
    cols.map = {};
    cols.list.forEach((col)=>cols.map[col.getId()] = col);
}
function $437b23f6a393c3bf$export$eb2a92b6162267d1(source) {
    return source === "gridOptionsUpdated" ? "gridOptionsChanged" : source;
}
function $437b23f6a393c3bf$export$f5687d41c39fa1b3(column, key) {
    const columnMatches = column === key;
    const colDefMatches = column.getColDef() === key;
    const idMatches = column.getColId() == key;
    return columnMatches || colDefMatches || idMatches;
}
var $437b23f6a393c3bf$var$getValueFactory = (stateItem, defaultState)=>(key1, key2)=>{
        const obj = {
            value1: void 0,
            value2: void 0
        };
        let calculated = false;
        if (stateItem) {
            if (stateItem[key1] !== void 0) {
                obj.value1 = stateItem[key1];
                calculated = true;
            }
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(key2) && stateItem[key2] !== void 0) {
                obj.value2 = stateItem[key2];
                calculated = true;
            }
        }
        if (!calculated && defaultState) {
            if (defaultState[key1] !== void 0) obj.value1 = defaultState[key1];
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(key2) && defaultState[key2] !== void 0) obj.value2 = defaultState[key2];
        }
        return obj;
    };
// packages/ag-grid-community/src/columns/columnFactoryUtils.ts
function $437b23f6a393c3bf$export$575b8d8234793d75(beans, defs = null, primaryColumns, existingTree, source) {
    const { existingCols: existingCols, existingGroups: existingGroups } = $437b23f6a393c3bf$var$extractExistingTreeData(existingTree);
    const colIdMap = new Map(existingCols.map((col)=>[
            col.getId(),
            col
        ]));
    const colGroupIdMap = new Map(existingGroups.map((group)=>[
            group.getId(),
            group
        ]));
    let maxDepth = 0;
    const recursivelyProcessColDef = (def, level)=>{
        maxDepth = Math.max(maxDepth, level);
        if ($437b23f6a393c3bf$var$isColumnGroupDef(def)) {
            if (!beans.colGroupSvc) return null;
            const groupId = def.groupId;
            const group = colGroupIdMap.get(groupId);
            const colGroupDef = $437b23f6a393c3bf$var$createMergedColGroupDef(beans, def, groupId);
            const newGroup = new $437b23f6a393c3bf$export$7ff27642a6ecc1cf(colGroupDef, groupId, false, level);
            beans.context.createBean(newGroup);
            if (group) newGroup.setExpanded(group.isExpanded());
            newGroup.setChildren(def.children.map((child)=>recursivelyProcessColDef(child, level + 1)));
            return newGroup;
        }
        const colId = def.colId;
        let column = colIdMap.get(colId);
        const colDefMerged = $437b23f6a393c3bf$export$310bdd432cb2279e(beans, def, column?.getColId() ?? colId);
        if (!column) {
            column = new $437b23f6a393c3bf$export$a8da3e2b83e5ddf2(colDefMerged, def, colId, primaryColumns);
            beans.context.createBean(column);
        } else {
            column.setColDef(colDefMerged, def, source);
            $437b23f6a393c3bf$export$ee3812d6139e74d4(beans, column, colDefMerged, source);
        }
        beans.dataTypeSvc?.addColumnListeners(column);
        return column;
    };
    const root = defs?.map((def)=>recursivelyProcessColDef(def, 0)) ?? [];
    let counter = 0;
    const keyCreator = {
        getUniqueKey: (_colId, _field)=>String(++counter)
    };
    const columnTree = beans.colGroupSvc ? beans.colGroupSvc.balanceColumnTree(root, 0, maxDepth, keyCreator) : root;
    const depthFirstCallback = (child, parent)=>{
        if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) child.setupExpandable();
        child.originalParent = parent;
    };
    $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, columnTree, depthFirstCallback);
    return {
        columnTree: columnTree,
        treeDepth: maxDepth
    };
}
function $437b23f6a393c3bf$export$e03b26088dedc2ab(beans, defs = null, primaryColumns, existingTree, source) {
    const columnKeyCreator = new $437b23f6a393c3bf$export$f67d1427302c96a3();
    const { existingCols: existingCols, existingGroups: existingGroups, existingColKeys: existingColKeys } = $437b23f6a393c3bf$var$extractExistingTreeData(existingTree);
    columnKeyCreator.addExistingKeys(existingColKeys);
    const unbalancedTree = $437b23f6a393c3bf$var$_recursivelyCreateColumns(beans, defs, 0, primaryColumns, existingCols, columnKeyCreator, existingGroups, source);
    const { colGroupSvc: colGroupSvc } = beans;
    const treeDepth = colGroupSvc?.findMaxDepth(unbalancedTree, 0) ?? 0;
    const columnTree = colGroupSvc ? colGroupSvc.balanceColumnTree(unbalancedTree, 0, treeDepth, columnKeyCreator) : unbalancedTree;
    const depthFirstCallback = (child, parent)=>{
        if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) child.setupExpandable();
        child.originalParent = parent;
    };
    $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, columnTree, depthFirstCallback);
    return {
        columnTree: columnTree,
        treeDepth: treeDepth
    };
}
function $437b23f6a393c3bf$var$extractExistingTreeData(existingTree) {
    const existingCols = [];
    const existingGroups = [];
    const existingColKeys = [];
    if (existingTree) $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, existingTree, (item)=>{
        if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(item)) {
            const group = item;
            existingGroups.push(group);
        } else {
            const col = item;
            existingColKeys.push(col.getId());
            existingCols.push(col);
        }
    });
    return {
        existingCols: existingCols,
        existingGroups: existingGroups,
        existingColKeys: existingColKeys
    };
}
function $437b23f6a393c3bf$var$_recursivelyCreateColumns(beans, defs, level, primaryColumns, existingColsCopy, columnKeyCreator, existingGroups, source) {
    if (!defs) return [];
    const { colGroupSvc: colGroupSvc } = beans;
    const result = new Array(defs.length);
    for(let i = 0; i < result.length; i++){
        const def = defs[i];
        if (colGroupSvc && $437b23f6a393c3bf$var$isColumnGroupDef(def)) result[i] = colGroupSvc.createProvidedColumnGroup(primaryColumns, def, level, existingColsCopy, columnKeyCreator, existingGroups, source);
        else result[i] = $437b23f6a393c3bf$var$createColumn(beans, primaryColumns, def, existingColsCopy, columnKeyCreator, source);
    }
    return result;
}
function $437b23f6a393c3bf$var$createColumn(beans, primaryColumns, colDef, existingColsCopy, columnKeyCreator, source) {
    const existingColAndIndex = $437b23f6a393c3bf$var$findExistingColumn(colDef, existingColsCopy);
    if (existingColAndIndex) existingColsCopy?.splice(existingColAndIndex.idx, 1);
    let column = existingColAndIndex?.column;
    if (!column) {
        const colId = columnKeyCreator.getUniqueKey(colDef.colId, colDef.field);
        const colDefMerged = $437b23f6a393c3bf$export$310bdd432cb2279e(beans, colDef, colId);
        column = new $437b23f6a393c3bf$export$a8da3e2b83e5ddf2(colDefMerged, colDef, colId, primaryColumns);
        beans.context.createBean(column);
    } else {
        const colDefMerged = $437b23f6a393c3bf$export$310bdd432cb2279e(beans, colDef, column.getColId());
        column.setColDef(colDefMerged, colDef, source);
        $437b23f6a393c3bf$export$ee3812d6139e74d4(beans, column, colDefMerged, source);
    }
    beans.dataTypeSvc?.addColumnListeners(column);
    return column;
}
function $437b23f6a393c3bf$var$updateSomeColumnState(beans, column, hide, sort, sortIndex, pinned, flex, source) {
    const { sortSvc: sortSvc, pinnedCols: pinnedCols, colFlex: colFlex } = beans;
    if (hide !== void 0) column.setVisible(!hide, source);
    if (sortSvc) {
        sortSvc.updateColSort(column, sort, source);
        if (sortIndex !== void 0) sortSvc.setColSortIndex(column, sortIndex);
    }
    if (pinned !== void 0) pinnedCols?.setColPinned(column, pinned);
    if (flex !== void 0) colFlex?.setColFlex(column, flex);
}
function $437b23f6a393c3bf$export$ee3812d6139e74d4(beans, column, colDef, source) {
    $437b23f6a393c3bf$var$updateSomeColumnState(beans, column, colDef.hide, colDef.sort, colDef.sortIndex, colDef.pinned, colDef.flex, source);
    const colFlex = column.getFlex();
    if (colFlex != null && colFlex > 0) return;
    if (colDef.width != null) column.setActualWidth(colDef.width, source);
    else {
        const widthBeforeUpdate = column.getActualWidth();
        column.setActualWidth(widthBeforeUpdate, source);
    }
}
function $437b23f6a393c3bf$var$findExistingColumn(newColDef, existingColsCopy) {
    if (!existingColsCopy) return void 0;
    for(let i = 0; i < existingColsCopy.length; i++){
        const def = existingColsCopy[i].getUserProvidedColDef();
        if (!def) continue;
        const newHasId = newColDef.colId != null;
        if (newHasId) {
            if (existingColsCopy[i].getId() === newColDef.colId) return {
                idx: i,
                column: existingColsCopy[i]
            };
            continue;
        }
        const newHasField = newColDef.field != null;
        if (newHasField) {
            if (def.field === newColDef.field) return {
                idx: i,
                column: existingColsCopy[i]
            };
            continue;
        }
        if (def === newColDef) return {
            idx: i,
            column: existingColsCopy[i]
        };
    }
    return void 0;
}
function $437b23f6a393c3bf$export$310bdd432cb2279e(beans, colDef, colId, isAutoCol) {
    const { gos: gos, dataTypeSvc: dataTypeSvc } = beans;
    const res = {};
    const defaultColDef = gos.get("defaultColDef");
    $437b23f6a393c3bf$export$8ade6bd474fcde42(res, defaultColDef, false, true);
    const columnType = $437b23f6a393c3bf$var$updateColDefAndGetColumnType(beans, res, colDef, colId);
    if (columnType) $437b23f6a393c3bf$var$assignColumnTypes(beans, columnType, res);
    const cellDataType = res.cellDataType;
    $437b23f6a393c3bf$export$8ade6bd474fcde42(res, colDef, false, true);
    if (cellDataType !== void 0) res.cellDataType = cellDataType;
    const autoGroupColDef = gos.get("autoGroupColumnDef");
    const isSortingCoupled = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
    if (colDef.rowGroup && autoGroupColDef && isSortingCoupled) $437b23f6a393c3bf$export$8ade6bd474fcde42(res, {
        sort: autoGroupColDef.sort,
        initialSort: autoGroupColDef.initialSort
    }, false, true);
    if (dataTypeSvc) {
        dataTypeSvc.postProcess(res);
        dataTypeSvc.validateColDef(res);
    }
    gos.validateColDef(res, colId, isAutoCol);
    return res;
}
function $437b23f6a393c3bf$var$updateColDefAndGetColumnType(beans, colDef, userColDef, colId) {
    const dataTypeDefinitionColumnType = beans.dataTypeSvc?.updateColDefAndGetColumnType(colDef, userColDef, colId);
    const columnTypes = userColDef.type ?? dataTypeDefinitionColumnType ?? colDef.type;
    colDef.type = columnTypes;
    return columnTypes ? $437b23f6a393c3bf$var$convertColumnTypes(columnTypes) : void 0;
}
function $437b23f6a393c3bf$var$assignColumnTypes(beans, typeKeys, colDefMerged) {
    if (!typeKeys.length) return;
    const allColumnTypes = Object.assign({}, $437b23f6a393c3bf$var$DefaultColumnTypes);
    const userTypes = beans.gos.get("columnTypes") || {};
    for (const key of Object.keys(userTypes)){
        const value = userTypes[key];
        if (key in allColumnTypes) $437b23f6a393c3bf$export$545083624300f13d(34, {
            key: key
        });
        else {
            const colType = value;
            if (colType.type) $437b23f6a393c3bf$export$545083624300f13d(35);
            allColumnTypes[key] = value;
        }
    }
    typeKeys.forEach((t)=>{
        const typeColDef = allColumnTypes[t.trim()];
        if (typeColDef) $437b23f6a393c3bf$export$8ade6bd474fcde42(colDefMerged, typeColDef, false, true);
        else $437b23f6a393c3bf$export$545083624300f13d(36, {
            t: t
        });
    });
}
function $437b23f6a393c3bf$var$isColumnGroupDef(abstractColDef) {
    return abstractColDef.children !== void 0;
}
function $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(parent, tree, callback) {
    if (!tree) return;
    for(let i = 0; i < tree.length; i++){
        const child = tree[i];
        if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(child, child.getChildren(), callback);
        callback(child, parent);
    }
}
// packages/ag-grid-community/src/columnMove/columnMoveUtils.ts
function $437b23f6a393c3bf$var$placeLockedColumns(cols, gos) {
    const left = [];
    const normal = [];
    const right = [];
    cols.forEach((col)=>{
        const position = col.getColDef().lockPosition;
        if (position === "right") right.push(col);
        else if (position === "left" || position === true) left.push(col);
        else normal.push(col);
    });
    const isRtl = gos.get("enableRtl");
    if (isRtl) return [
        ...right,
        ...normal,
        ...left
    ];
    return [
        ...left,
        ...normal,
        ...right
    ];
}
function $437b23f6a393c3bf$var$doesMovePassMarryChildren(allColumnsCopy, gridBalancedTree) {
    let rulePassed = true;
    $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, gridBalancedTree, (child)=>{
        if (!$437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) return;
        const columnGroup = child;
        const colGroupDef = columnGroup.getColGroupDef();
        const marryChildren = colGroupDef && colGroupDef.marryChildren;
        if (!marryChildren) return;
        const newIndexes = [];
        columnGroup.getLeafColumns().forEach((col)=>{
            const newColIndex = allColumnsCopy.indexOf(col);
            newIndexes.push(newColIndex);
        });
        const maxIndex = Math.max.apply(Math, newIndexes);
        const minIndex = Math.min.apply(Math, newIndexes);
        const spread = maxIndex - minIndex;
        const maxSpread = columnGroup.getLeafColumns().length - 1;
        if (spread > maxSpread) rulePassed = false;
    });
    return rulePassed;
}
// packages/ag-grid-community/src/columns/columnEventUtils.ts
function $437b23f6a393c3bf$var$getCommonValue(cols, valueGetter) {
    if (!cols || cols.length == 0) return void 0;
    const firstValue = valueGetter(cols[0]);
    for(let i = 1; i < cols.length; i++){
        if (firstValue !== valueGetter(cols[i])) return void 0;
    }
    return firstValue;
}
function $437b23f6a393c3bf$var$dispatchColumnPinnedEvent(eventSvc, changedColumns, source) {
    if (!changedColumns.length) return;
    const column = changedColumns.length === 1 ? changedColumns[0] : null;
    const pinned = $437b23f6a393c3bf$var$getCommonValue(changedColumns, (col)=>col.getPinned());
    eventSvc.dispatchEvent({
        type: "columnPinned",
        // mistake in typing, 'undefined' should be allowed, as 'null' means 'not pinned'
        pinned: pinned != null ? pinned : null,
        columns: changedColumns,
        column: column,
        source: source
    });
}
function $437b23f6a393c3bf$var$dispatchColumnVisibleEvent(eventSvc, changedColumns, source) {
    if (!changedColumns.length) return;
    const column = changedColumns.length === 1 ? changedColumns[0] : null;
    const visible = $437b23f6a393c3bf$var$getCommonValue(changedColumns, (col)=>col.isVisible());
    eventSvc.dispatchEvent({
        type: "columnVisible",
        visible: visible,
        columns: changedColumns,
        column: column,
        source: source
    });
}
function $437b23f6a393c3bf$var$dispatchColumnChangedEvent(eventSvc, type, columns, source) {
    eventSvc.dispatchEvent({
        type: type,
        columns: columns,
        column: columns && columns.length == 1 ? columns[0] : null,
        source: source
    });
}
function $437b23f6a393c3bf$var$dispatchColumnResizedEvent(eventSvc, columns, finished, source, flexColumns = null) {
    if (columns?.length) eventSvc.dispatchEvent({
        type: "columnResized",
        columns: columns,
        column: columns.length === 1 ? columns[0] : null,
        flexColumns: flexColumns,
        finished: finished,
        source: source
    });
}
// packages/ag-grid-community/src/columns/columnStateUtils.ts
function $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, params, source) {
    const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc, autoColSvc: autoColSvc, selectionColSvc: selectionColSvc, colAnimation: colAnimation, visibleCols: visibleCols, pivotResultCols: pivotResultCols, environment: environment, valueColsSvc: valueColsSvc, eventSvc: eventSvc, gos: gos } = beans;
    const providedCols = colModel.getColDefCols() ?? [];
    const selectionCols = selectionColSvc?.getColumns();
    if (!providedCols?.length && !selectionCols?.length) return false;
    if (params?.state && !params.state.forEach) {
        $437b23f6a393c3bf$export$545083624300f13d(32);
        return false;
    }
    const syncColumnWithStateItem = (column, stateItem, rowGroupIndexes, pivotIndexes, autoCol)=>{
        if (!column) return;
        const getValue = $437b23f6a393c3bf$var$getValueFactory(stateItem, params.defaultState);
        const flex = getValue("flex").value1;
        $437b23f6a393c3bf$var$updateSomeColumnState(beans, column, getValue("hide").value1, getValue("sort").value1, getValue("sortIndex").value1, getValue("pinned").value1, flex, source);
        if (flex == null) {
            const width = getValue("width").value1;
            if (width != null) {
                const minColWidth = column.getColDef().minWidth ?? environment.getDefaultColumnMinWidth();
                if (minColWidth != null && width >= minColWidth) column.setActualWidth(width, source);
            }
        }
        if (autoCol || !column.isPrimary()) return;
        valueColsSvc?.syncColumnWithState(column, source, getValue);
        rowGroupColsSvc?.syncColumnWithState(column, source, getValue, rowGroupIndexes);
        pivotColsSvc?.syncColumnWithState(column, source, getValue, pivotIndexes);
    };
    const applyStates = (states, existingColumns, getById2)=>{
        const dispatchEventsFunc = $437b23f6a393c3bf$var$_compareColumnStatesAndDispatchEvents(beans, source);
        const columnsWithNoState = existingColumns.slice();
        const rowGroupIndexes = {};
        const pivotIndexes = {};
        const autoColStates = [];
        const selectionColStates = [];
        const unmatchedAndAutoStates2 = [];
        let unmatchedCount2 = 0;
        const previousRowGroupCols = rowGroupColsSvc?.columns.slice() ?? [];
        const previousPivotCols = pivotColsSvc?.columns.slice() ?? [];
        states.forEach((state)=>{
            const colId = state.colId;
            const isAutoGroupColumn = colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6);
            if (isAutoGroupColumn) {
                autoColStates.push(state);
                unmatchedAndAutoStates2.push(state);
                return;
            }
            if ($437b23f6a393c3bf$export$f6074a9792015c5d(colId)) {
                selectionColStates.push(state);
                unmatchedAndAutoStates2.push(state);
                return;
            }
            const column = getById2(colId);
            if (!column) {
                unmatchedAndAutoStates2.push(state);
                unmatchedCount2 += 1;
            } else {
                syncColumnWithStateItem(column, state, rowGroupIndexes, pivotIndexes, false);
                $437b23f6a393c3bf$export$83a881c8b5120679(columnsWithNoState, column);
            }
        });
        const applyDefaultsFunc = (col)=>syncColumnWithStateItem(col, null, rowGroupIndexes, pivotIndexes, false);
        columnsWithNoState.forEach(applyDefaultsFunc);
        rowGroupColsSvc?.sortColumns($437b23f6a393c3bf$var$comparatorByIndex.bind(rowGroupColsSvc, rowGroupIndexes, previousRowGroupCols));
        pivotColsSvc?.sortColumns($437b23f6a393c3bf$var$comparatorByIndex.bind(pivotColsSvc, pivotIndexes, previousPivotCols));
        colModel.refreshCols(false);
        const syncColStates = (getCol, colStates, columns = [])=>{
            colStates.forEach((stateItem)=>{
                const col = getCol(stateItem.colId);
                $437b23f6a393c3bf$export$83a881c8b5120679(columns, col);
                syncColumnWithStateItem(col, stateItem, null, null, true);
            });
            columns.forEach(applyDefaultsFunc);
        };
        syncColStates((colId)=>autoColSvc?.getColumn(colId) ?? null, autoColStates, autoColSvc?.getColumns()?.slice());
        syncColStates((colId)=>selectionColSvc?.getColumn(colId) ?? null, selectionColStates, selectionColSvc?.getColumns()?.slice());
        $437b23f6a393c3bf$var$orderLiveColsLikeState(params, colModel, gos);
        visibleCols.refresh(source);
        eventSvc.dispatchEvent({
            type: "columnEverythingChanged",
            source: source
        });
        dispatchEventsFunc();
        return {
            unmatchedAndAutoStates: unmatchedAndAutoStates2,
            unmatchedCount: unmatchedCount2
        };
    };
    colAnimation?.start();
    let { unmatchedAndAutoStates: unmatchedAndAutoStates, unmatchedCount: unmatchedCount } = applyStates(params.state || [], providedCols, (id)=>colModel.getColDefCol(id));
    if (unmatchedAndAutoStates.length > 0 || $437b23f6a393c3bf$export$25d27f17d3af40f7(params.defaultState)) {
        const pivotResultColsList = pivotResultCols?.getPivotResultCols()?.list ?? [];
        unmatchedCount = applyStates(unmatchedAndAutoStates, pivotResultColsList, (id)=>pivotResultCols?.getPivotResultCol(id) ?? null).unmatchedCount;
    }
    colAnimation?.finish();
    return unmatchedCount === 0;
}
function $437b23f6a393c3bf$export$96a6cbc000255060(beans, source) {
    const { colModel: colModel, autoColSvc: autoColSvc, selectionColSvc: selectionColSvc, eventSvc: eventSvc, gos: gos } = beans;
    const primaryCols = colModel.getColDefCols();
    if (!primaryCols?.length) return;
    const primaryColumnTree = colModel.getColDefColTree();
    const primaryColumns = $437b23f6a393c3bf$export$42da2aea8fab5b(primaryColumnTree);
    const columnStates = [];
    let letRowGroupIndex = 1e3;
    let letPivotIndex = 1e3;
    const addColState = (col)=>{
        const stateItem = $437b23f6a393c3bf$var$getColumnStateFromColDef(col);
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(stateItem.rowGroupIndex) && stateItem.rowGroup) stateItem.rowGroupIndex = letRowGroupIndex++;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(stateItem.pivotIndex) && stateItem.pivot) stateItem.pivotIndex = letPivotIndex++;
        columnStates.push(stateItem);
    };
    autoColSvc?.getColumns()?.forEach(addColState);
    selectionColSvc?.getColumns()?.forEach(addColState);
    primaryColumns?.forEach(addColState);
    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
        state: columnStates
    }, source);
    const autoCols = autoColSvc?.getColumns() ?? [];
    const selectionCols = selectionColSvc?.getColumns() ?? [];
    const orderedCols = [
        ...selectionCols,
        ...autoCols,
        ...primaryCols
    ];
    const orderedColState = orderedCols.map((col)=>({
            colId: col.colId
        }));
    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
        state: orderedColState,
        applyOrder: true
    }, source);
    eventSvc.dispatchEvent($437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        type: "columnsReset",
        source: source
    }));
}
function $437b23f6a393c3bf$var$_compareColumnStatesAndDispatchEvents(beans, source) {
    const { rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc, valueColsSvc: valueColsSvc, colModel: colModel, sortSvc: sortSvc, eventSvc: eventSvc } = beans;
    const startState = {
        rowGroupColumns: rowGroupColsSvc?.columns.slice() ?? [],
        pivotColumns: pivotColsSvc?.columns.slice() ?? [],
        valueColumns: valueColsSvc?.columns.slice() ?? []
    };
    const columnStateBefore = $437b23f6a393c3bf$export$e7d9af1fb362df7b(beans);
    const columnStateBeforeMap = {};
    columnStateBefore.forEach((col)=>{
        columnStateBeforeMap[col.colId] = col;
    });
    return ()=>{
        const dispatchWhenListsDifferent = (eventType, colsBefore, colsAfter, idMapper)=>{
            const beforeList = colsBefore.map(idMapper);
            const afterList = colsAfter.map(idMapper);
            const unchanged = $437b23f6a393c3bf$export$893967cdb9833fdd(beforeList, afterList);
            if (unchanged) return;
            const changes = new Set(colsBefore);
            colsAfter.forEach((id)=>{
                if (!changes.delete(id)) changes.add(id);
            });
            const changesArr = [
                ...changes
            ];
            eventSvc.dispatchEvent({
                type: eventType,
                columns: changesArr,
                column: changesArr.length === 1 ? changesArr[0] : null,
                source: source
            });
        };
        const getChangedColumns = (changedPredicate)=>{
            const changedColumns2 = [];
            colModel.forAllCols((column)=>{
                const colStateBefore = columnStateBeforeMap[column.getColId()];
                if (colStateBefore && changedPredicate(colStateBefore, column)) changedColumns2.push(column);
            });
            return changedColumns2;
        };
        const columnIdMapper = (c)=>c.getColId();
        dispatchWhenListsDifferent("columnRowGroupChanged", startState.rowGroupColumns, rowGroupColsSvc?.columns ?? [], columnIdMapper);
        dispatchWhenListsDifferent("columnPivotChanged", startState.pivotColumns, pivotColsSvc?.columns ?? [], columnIdMapper);
        const valueChangePredicate = (cs, c)=>{
            const oldActive = cs.aggFunc != null;
            const activeChanged = oldActive != c.isValueActive();
            const aggFuncChanged = oldActive && cs.aggFunc != c.getAggFunc();
            return activeChanged || aggFuncChanged;
        };
        const changedValues = getChangedColumns(valueChangePredicate);
        if (changedValues.length > 0) $437b23f6a393c3bf$var$dispatchColumnChangedEvent(eventSvc, "columnValueChanged", changedValues, source);
        const resizeChangePredicate = (cs, c)=>cs.width != c.getActualWidth();
        $437b23f6a393c3bf$var$dispatchColumnResizedEvent(eventSvc, getChangedColumns(resizeChangePredicate), true, source);
        const pinnedChangePredicate = (cs, c)=>cs.pinned != c.getPinned();
        $437b23f6a393c3bf$var$dispatchColumnPinnedEvent(eventSvc, getChangedColumns(pinnedChangePredicate), source);
        const visibilityChangePredicate = (cs, c)=>cs.hide == c.isVisible();
        $437b23f6a393c3bf$var$dispatchColumnVisibleEvent(eventSvc, getChangedColumns(visibilityChangePredicate), source);
        const sortChangePredicate = (cs, c)=>cs.sort != c.getSort() || cs.sortIndex != c.getSortIndex();
        const changedColumns = getChangedColumns(sortChangePredicate);
        if (changedColumns.length > 0) sortSvc?.dispatchSortChangedEvents(source, changedColumns);
        const colStateAfter = $437b23f6a393c3bf$export$e7d9af1fb362df7b(beans);
        $437b23f6a393c3bf$var$normaliseColumnMovedEventForColumnState(columnStateBefore, colStateAfter, source, colModel, eventSvc);
    };
}
function $437b23f6a393c3bf$export$e7d9af1fb362df7b(beans) {
    const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc } = beans;
    const primaryCols = colModel.getColDefCols();
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(primaryCols) || !colModel.isAlive()) return [];
    const rowGroupColumns = rowGroupColsSvc?.columns;
    const pivotColumns = pivotColsSvc?.columns;
    const res = [];
    const createStateItemFromColumn = (column)=>{
        const rowGroupIndex = column.isRowGroupActive() && rowGroupColumns ? rowGroupColumns.indexOf(column) : null;
        const pivotIndex = column.isPivotActive() && pivotColumns ? pivotColumns.indexOf(column) : null;
        const aggFunc = column.isValueActive() ? column.getAggFunc() : null;
        const sort = column.getSort() != null ? column.getSort() : null;
        const sortIndex = column.getSortIndex() != null ? column.getSortIndex() : null;
        res.push({
            colId: column.getColId(),
            width: column.getActualWidth(),
            hide: !column.isVisible(),
            pinned: column.getPinned(),
            sort: sort,
            sortIndex: sortIndex,
            aggFunc: aggFunc,
            rowGroup: column.isRowGroupActive(),
            rowGroupIndex: rowGroupIndex,
            pivot: column.isPivotActive(),
            pivotIndex: pivotIndex,
            flex: column.getFlex() ?? null
        });
    };
    colModel.forAllCols((col)=>createStateItemFromColumn(col));
    const colIdToGridIndexMap = new Map(colModel.getCols().map((col, index)=>[
            col.getColId(),
            index
        ]));
    res.sort((itemA, itemB)=>{
        const posA = colIdToGridIndexMap.has(itemA.colId) ? colIdToGridIndexMap.get(itemA.colId) : -1;
        const posB = colIdToGridIndexMap.has(itemB.colId) ? colIdToGridIndexMap.get(itemB.colId) : -1;
        return posA - posB;
    });
    return res;
}
function $437b23f6a393c3bf$var$getColumnStateFromColDef(column) {
    const getValueOrNull = (a, b)=>a != null ? a : b != null ? b : null;
    const colDef = column.getColDef();
    const sort = getValueOrNull(colDef.sort, colDef.initialSort);
    const sortIndex = getValueOrNull(colDef.sortIndex, colDef.initialSortIndex);
    const hide = getValueOrNull(colDef.hide, colDef.initialHide);
    const pinned = getValueOrNull(colDef.pinned, colDef.initialPinned);
    const width = getValueOrNull(colDef.width, colDef.initialWidth);
    const flex = getValueOrNull(colDef.flex, colDef.initialFlex);
    let rowGroupIndex = getValueOrNull(colDef.rowGroupIndex, colDef.initialRowGroupIndex);
    let rowGroup = getValueOrNull(colDef.rowGroup, colDef.initialRowGroup);
    if (rowGroupIndex == null && (rowGroup == null || rowGroup == false)) {
        rowGroupIndex = null;
        rowGroup = null;
    }
    let pivotIndex = getValueOrNull(colDef.pivotIndex, colDef.initialPivotIndex);
    let pivot = getValueOrNull(colDef.pivot, colDef.initialPivot);
    if (pivotIndex == null && (pivot == null || pivot == false)) {
        pivotIndex = null;
        pivot = null;
    }
    const aggFunc = getValueOrNull(colDef.aggFunc, colDef.initialAggFunc);
    return {
        colId: column.getColId(),
        sort: sort,
        sortIndex: sortIndex,
        hide: hide,
        pinned: pinned,
        width: width,
        flex: flex,
        rowGroup: rowGroup,
        rowGroupIndex: rowGroupIndex,
        pivot: pivot,
        pivotIndex: pivotIndex,
        aggFunc: aggFunc
    };
}
function $437b23f6a393c3bf$var$orderLiveColsLikeState(params, colModel, gos) {
    if (!params.applyOrder || !params.state) return;
    const colIds = [];
    params.state.forEach((item)=>{
        if (item.colId != null) colIds.push(item.colId);
    });
    $437b23f6a393c3bf$var$sortColsLikeKeys(colModel.cols, colIds, colModel, gos);
}
function $437b23f6a393c3bf$var$sortColsLikeKeys(cols, colIds, colModel, gos) {
    if (cols == null) return;
    let newOrder = [];
    const processedColIds = {};
    colIds.forEach((colId)=>{
        if (processedColIds[colId]) return;
        const col = cols.map[colId];
        if (col) {
            newOrder.push(col);
            processedColIds[colId] = true;
        }
    });
    let autoGroupInsertIndex = 0;
    cols.list.forEach((col)=>{
        const colId = col.getColId();
        const alreadyProcessed = processedColIds[colId] != null;
        if (alreadyProcessed) return;
        const isAutoGroupCol = colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6);
        if (isAutoGroupCol) newOrder.splice(autoGroupInsertIndex++, 0, col);
        else newOrder.push(col);
    });
    newOrder = $437b23f6a393c3bf$var$placeLockedColumns(newOrder, gos);
    if (!$437b23f6a393c3bf$var$doesMovePassMarryChildren(newOrder, colModel.getColTree())) {
        $437b23f6a393c3bf$export$545083624300f13d(39);
        return;
    }
    cols.list = newOrder;
}
function $437b23f6a393c3bf$var$normaliseColumnMovedEventForColumnState(colStateBefore, colStateAfter, source, colModel, eventSvc) {
    const colStateAfterMapped = {};
    colStateAfter.forEach((s)=>colStateAfterMapped[s.colId] = s);
    const colsIntersectIds = {};
    colStateBefore.forEach((s)=>{
        if (colStateAfterMapped[s.colId]) colsIntersectIds[s.colId] = true;
    });
    const beforeFiltered = colStateBefore.filter((c)=>colsIntersectIds[c.colId]);
    const afterFiltered = colStateAfter.filter((c)=>colsIntersectIds[c.colId]);
    const movedColumns = [];
    afterFiltered.forEach((csAfter, index)=>{
        const csBefore = beforeFiltered && beforeFiltered[index];
        if (csBefore && csBefore.colId !== csAfter.colId) {
            const gridCol = colModel.getCol(csBefore.colId);
            if (gridCol) movedColumns.push(gridCol);
        }
    });
    if (!movedColumns.length) return;
    eventSvc.dispatchEvent({
        type: "columnMoved",
        columns: movedColumns,
        column: movedColumns.length === 1 ? movedColumns[0] : null,
        finished: true,
        source: source
    });
}
var $437b23f6a393c3bf$var$comparatorByIndex = (indexes, oldList, colA, colB)=>{
    const indexA = indexes[colA.getId()];
    const indexB = indexes[colB.getId()];
    const aHasIndex = indexA != null;
    const bHasIndex = indexB != null;
    if (aHasIndex && bHasIndex) return indexA - indexB;
    if (aHasIndex) return -1;
    if (bHasIndex) return 1;
    const oldIndexA = oldList.indexOf(colA);
    const oldIndexB = oldList.indexOf(colB);
    const aHasOldIndex = oldIndexA >= 0;
    const bHasOldIndex = oldIndexB >= 0;
    if (aHasOldIndex && bHasOldIndex) return oldIndexA - oldIndexB;
    if (aHasOldIndex) return -1;
    return 1;
};
// packages/ag-grid-community/src/columns/columnModel.ts
var $437b23f6a393c3bf$var$ColumnModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colModel";
        // if pivotMode is on, however pivot results are NOT shown if no pivot columns are set
        this.pivotMode = false;
        this.ready = false;
        this.changeEventsDispatching = false;
    }
    postConstruct() {
        this.pivotMode = this.gos.get("pivotMode");
        this.addManagedPropertyListeners([
            "groupDisplayType",
            "treeData",
            "treeDataDisplayType",
            "groupHideOpenParents",
            "rowNumbers",
            "hidePaddedHeaderRows"
        ], (event)=>this.refreshAll($437b23f6a393c3bf$export$eb2a92b6162267d1(event.source)));
        this.addManagedPropertyListeners([
            "defaultColDef",
            "defaultColGroupDef",
            "columnTypes",
            "suppressFieldDotNotation"
        ], this.recreateColumnDefs.bind(this));
        this.addManagedPropertyListener("pivotMode", (event)=>this.setPivotMode(this.gos.get("pivotMode"), $437b23f6a393c3bf$export$eb2a92b6162267d1(event.source)));
    }
    // called from SyncService, when grid has finished initialising
    createColsFromColDefs(source) {
        const { beans: beans } = this;
        const { valueCache: valueCache, colAutosize: colAutosize, rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc, valueColsSvc: valueColsSvc, visibleCols: visibleCols, eventSvc: eventSvc } = beans;
        const dispatchEventsFunc = this.colDefs ? $437b23f6a393c3bf$var$_compareColumnStatesAndDispatchEvents(beans, source) : void 0;
        valueCache?.expire();
        const oldCols = this.colDefCols?.list;
        const oldTree = this.colDefCols?.tree;
        const newTree = $437b23f6a393c3bf$export$e03b26088dedc2ab(beans, this.colDefs, true, oldTree, source);
        $437b23f6a393c3bf$export$dbaaa57234b60d8f(beans, this.colDefCols?.tree, newTree.columnTree);
        const tree = newTree.columnTree;
        const treeDepth = newTree.treeDepth;
        const list = $437b23f6a393c3bf$export$42da2aea8fab5b(tree);
        const map = {};
        list.forEach((col)=>map[col.getId()] = col);
        this.colDefCols = {
            tree: tree,
            treeDepth: treeDepth,
            list: list,
            map: map
        };
        rowGroupColsSvc?.extractCols(source, oldCols);
        pivotColsSvc?.extractCols(source, oldCols);
        valueColsSvc?.extractCols(source, oldCols);
        this.ready = true;
        this.refreshCols(true);
        visibleCols.refresh(source);
        eventSvc.dispatchEvent({
            type: "columnEverythingChanged",
            source: source
        });
        if (dispatchEventsFunc) {
            this.changeEventsDispatching = true;
            dispatchEventsFunc();
            this.changeEventsDispatching = false;
        }
        eventSvc.dispatchEvent({
            type: "newColumnsLoaded",
            source: source
        });
        if (source === "gridInitializing") colAutosize?.applyAutosizeStrategy();
    }
    // called from: buildAutoGroupColumns (events 'groupDisplayType', 'treeData', 'treeDataDisplayType', 'groupHideOpenParents')
    // createColsFromColDefs (recreateColumnDefs, setColumnsDefs),
    // setPivotMode, applyColumnState,
    // functionColsService.setPrimaryColList, functionColsService.updatePrimaryColList,
    // pivotResultCols.setPivotResultCols
    refreshCols(newColDefs) {
        if (!this.colDefCols) return;
        const prevColTree = this.cols?.tree;
        this.saveColOrder();
        const { autoColSvc: autoColSvc, selectionColSvc: selectionColSvc, rowNumbersSvc: rowNumbersSvc, quickFilter: quickFilter, pivotResultCols: pivotResultCols, showRowGroupCols: showRowGroupCols, rowAutoHeight: rowAutoHeight, visibleCols: visibleCols, colViewport: colViewport, eventSvc: eventSvc } = this.beans;
        const cols = this.selectCols(pivotResultCols, this.colDefCols);
        this.createColumnsForService([
            autoColSvc,
            selectionColSvc,
            rowNumbersSvc
        ], cols);
        const shouldSortNewColDefs = $437b23f6a393c3bf$var$_shouldMaintainColumnOrder(this.gos, this.showingPivotResult);
        if (!newColDefs || shouldSortNewColDefs) this.restoreColOrder(cols);
        this.positionLockedCols(cols);
        showRowGroupCols?.refresh();
        quickFilter?.refreshCols();
        this.setColSpanActive();
        rowAutoHeight?.setAutoHeightActive(cols);
        visibleCols.clear();
        colViewport.clear();
        const dispatchChangedEvent = !$437b23f6a393c3bf$export$893967cdb9833fdd(prevColTree, this.cols.tree);
        if (dispatchChangedEvent) eventSvc.dispatchEvent({
            type: "gridColumnsChanged"
        });
    }
    createColumnsForService(services, cols) {
        for (const service of services){
            if (!service) continue;
            service.createColumns(cols, (updateOrder)=>{
                this.lastOrder = updateOrder(this.lastOrder);
                this.lastPivotOrder = updateOrder(this.lastPivotOrder);
            });
            service.addColumns(cols);
        }
    }
    selectCols(pivotResultColsSvc, colDefCols) {
        const pivotResultCols = pivotResultColsSvc?.getPivotResultCols() ?? null;
        this.showingPivotResult = pivotResultCols != null;
        const { map: map, list: list, tree: tree, treeDepth: treeDepth } = pivotResultCols ?? colDefCols;
        this.cols = {
            list: list.slice(),
            map: {
                ...map
            },
            tree: tree.slice(),
            treeDepth: treeDepth
        };
        if (pivotResultCols) {
            const hasSameColumns = pivotResultCols.list.some((col)=>this.cols?.map[col.getColId()] !== void 0);
            if (!hasSameColumns) this.lastPivotOrder = null;
        }
        return this.cols;
    }
    getColsToShow() {
        if (!this.cols) return [];
        const { valueColsSvc: valueColsSvc, selectionColSvc: selectionColSvc, gos: gos } = this.beans;
        const showAutoGroupAndValuesOnly = this.isPivotMode() && !this.showingPivotResult;
        const showSelectionColumn = selectionColSvc?.isSelectionColumnEnabled();
        const showRowNumbers = gos.get("rowNumbers");
        const valueColumns = valueColsSvc?.columns;
        const res = this.cols.list.filter((col)=>{
            const isAutoGroupCol = $437b23f6a393c3bf$export$61b34611dc010a97(col);
            if (showAutoGroupAndValuesOnly) {
                const isValueCol = valueColumns?.includes(col);
                return isAutoGroupCol || isValueCol || showSelectionColumn && $437b23f6a393c3bf$export$f6074a9792015c5d(col) || showRowNumbers && $437b23f6a393c3bf$export$3d3e7d751f0445eb(col);
            } else return isAutoGroupCol || col.isVisible();
        });
        return res;
    }
    // on events 'groupDisplayType', 'treeData', 'treeDataDisplayType', 'groupHideOpenParents'
    refreshAll(source) {
        if (!this.ready) return;
        this.refreshCols(false);
        this.beans.visibleCols.refresh(source);
    }
    setColsVisible(keys, visible = false, source) {
        $437b23f6a393c3bf$export$b2854c1cb8f10386(this.beans, {
            state: keys.map((key)=>({
                    colId: typeof key === "string" ? key : key.getColId(),
                    hide: !visible
                }))
        }, source);
    }
    /**
   * Restores provided columns order to the previous order in this.lastPivotOrder / this.lastOrder
   * If columns are not in the last order:
   *  - Check column groups, and apply column after the last column in the lowest shared group
   *  - If no sibling is found, apply the column at the end of the cols
   */ restoreColOrder(cols) {
        const lastOrder = this.showingPivotResult ? this.lastPivotOrder : this.lastOrder;
        if (!lastOrder) return;
        const preservedOrder = lastOrder.filter((col)=>cols.map[col.getId()] != null);
        if (preservedOrder.length === 0) return;
        if (preservedOrder.length === cols.list.length) {
            cols.list = preservedOrder;
            return;
        }
        const hasSiblings = (col)=>{
            const ancestor = col.getOriginalParent();
            if (!ancestor) return false;
            const children = ancestor.getChildren();
            if (children.length > 1) return true;
            return hasSiblings(ancestor);
        };
        if (!preservedOrder.some((col)=>hasSiblings(col))) {
            const preservedOrderSet = new Set(preservedOrder);
            for (const col of cols.list)if (!preservedOrderSet.has(col)) preservedOrder.push(col);
            cols.list = preservedOrder;
            return;
        }
        const colPositionMap = /* @__PURE__ */ new Map();
        for(let i = 0; i < preservedOrder.length; i++){
            const col = preservedOrder[i];
            colPositionMap.set(col, i);
        }
        const additionalCols = cols.list.filter((col)=>!colPositionMap.has(col));
        if (additionalCols.length === 0) {
            cols.list = preservedOrder;
            return;
        }
        const getPreviousSibling = (col, group)=>{
            const parent = group ? group.getOriginalParent() : col.getOriginalParent();
            if (!parent) return null;
            let highestIdx = null;
            let highestSibling = null;
            for (const child of parent.getChildren()){
                if (child === group || child === col) continue;
                if (child instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2) {
                    const colIdx = colPositionMap.get(child);
                    if (colIdx == null) continue;
                    if (highestIdx == null || highestIdx < colIdx) {
                        highestIdx = colIdx;
                        highestSibling = child;
                    }
                    continue;
                }
                child.forEachLeafColumn((leafCol)=>{
                    const colIdx = colPositionMap.get(leafCol);
                    if (colIdx == null) return;
                    if (highestIdx == null || highestIdx < colIdx) {
                        highestIdx = colIdx;
                        highestSibling = leafCol;
                    }
                });
            }
            if (highestSibling == null) return getPreviousSibling(col, parent);
            return highestSibling;
        };
        const noSiblingsAvailable = [];
        const previousSiblingPosMap = /* @__PURE__ */ new Map();
        for (const col of additionalCols){
            const prevSiblingIdx = getPreviousSibling(col, null);
            if (prevSiblingIdx == null) {
                noSiblingsAvailable.push(col);
                continue;
            }
            const prev = previousSiblingPosMap.get(prevSiblingIdx);
            if (prev === void 0) previousSiblingPosMap.set(prevSiblingIdx, col);
            else if (Array.isArray(prev)) prev.push(col);
            else previousSiblingPosMap.set(prevSiblingIdx, [
                prev,
                col
            ]);
        }
        const result = new Array(cols.list.length);
        let resultPointer = result.length - 1;
        for(let i = noSiblingsAvailable.length - 1; i >= 0; i--)result[resultPointer--] = noSiblingsAvailable[i];
        for(let i = preservedOrder.length - 1; i >= 0; i--){
            const nextCol = preservedOrder[i];
            const extraCols = previousSiblingPosMap.get(nextCol);
            if (extraCols) {
                if (Array.isArray(extraCols)) for(let x = extraCols.length - 1; x >= 0; x--){
                    const col = extraCols[x];
                    result[resultPointer--] = col;
                }
                else result[resultPointer--] = extraCols;
            }
            result[resultPointer--] = nextCol;
        }
        cols.list = result;
    }
    positionLockedCols(cols) {
        cols.list = $437b23f6a393c3bf$var$placeLockedColumns(cols.list, this.gos);
    }
    saveColOrder() {
        if (this.showingPivotResult) this.lastPivotOrder = this.cols?.list ?? null;
        else this.lastOrder = this.cols?.list ?? null;
    }
    getColumnDefs() {
        return this.colDefCols ? this.beans.colDefFactory?.getColumnDefs(this.colDefCols.list, this.showingPivotResult, this.lastOrder, this.cols?.list ?? []) : void 0;
    }
    setColSpanActive() {
        this.colSpanActive = !!this.cols?.list.some((col)=>col.getColDef().colSpan != null);
    }
    isPivotMode() {
        return this.pivotMode;
    }
    setPivotMode(pivotMode, source) {
        if (pivotMode === this.pivotMode) return;
        this.pivotMode = pivotMode;
        if (!this.ready) return;
        this.refreshCols(false);
        const { visibleCols: visibleCols, eventSvc: eventSvc } = this.beans;
        visibleCols.refresh(source);
        eventSvc.dispatchEvent({
            type: "columnPivotModeChanged"
        });
    }
    // + clientSideRowModel
    isPivotActive() {
        const pivotColumns = this.beans.pivotColsSvc?.columns;
        return this.pivotMode && !!pivotColumns?.length;
    }
    // called when dataTypes change
    recreateColumnDefs(e) {
        if (!this.cols) return;
        this.beans.autoColSvc?.updateColumns(e);
        const source = $437b23f6a393c3bf$export$eb2a92b6162267d1(e.source);
        this.createColsFromColDefs(source);
    }
    setColumnDefs(columnDefs, source) {
        this.colDefs = columnDefs;
        this.createColsFromColDefs(source);
    }
    destroy() {
        $437b23f6a393c3bf$export$dbaaa57234b60d8f(this.beans, this.colDefCols?.tree);
        super.destroy();
    }
    getColTree() {
        return this.cols?.tree ?? [];
    }
    // + columnSelectPanel
    getColDefColTree() {
        return this.colDefCols?.tree ?? [];
    }
    // + clientSideRowController -> sorting, building quick filter text
    // + headerRenderer -> sorting (clearing icon)
    getColDefCols() {
        return this.colDefCols?.list ?? null;
    }
    // + moveColumnController
    getCols() {
        return this.cols?.list ?? [];
    }
    forAllCols(callback) {
        const { pivotResultCols: pivotResultCols, autoColSvc: autoColSvc, selectionColSvc: selectionColSvc } = this.beans;
        $437b23f6a393c3bf$var$_forAll(this.colDefCols?.list, callback);
        $437b23f6a393c3bf$var$_forAll(autoColSvc?.columns?.list, callback);
        $437b23f6a393c3bf$var$_forAll(selectionColSvc?.columns?.list, callback);
        $437b23f6a393c3bf$var$_forAll(pivotResultCols?.getPivotResultCols()?.list, callback);
    }
    getColsForKeys(keys) {
        if (!keys) return [];
        return keys.map((key)=>this.getCol(key)).filter((col)=>col != null);
    }
    getColDefCol(key) {
        if (!this.colDefCols?.list) return null;
        return this.getColFromCollection(key, this.colDefCols);
    }
    getCol(key) {
        if (key == null) return null;
        return this.getColFromCollection(key, this.cols);
    }
    /**
   * Get column exclusively by ID.
   *
   * Note getCol/getColFromCollection have poor performance when col has been removed.
   */ getColById(key) {
        return this.cols?.map[key] ?? null;
    }
    getColFromCollection(key, cols) {
        if (cols == null) return null;
        const { map: map, list: list } = cols;
        if (typeof key == "string" && map[key]) return map[key];
        for(let i = 0; i < list.length; i++){
            if ($437b23f6a393c3bf$export$f5687d41c39fa1b3(list[i], key)) return list[i];
        }
        return this.beans.autoColSvc?.getColumn(key) ?? this.beans.selectionColSvc?.getColumn(key) ?? null;
    }
};
// packages/ag-grid-community/src/columns/baseColsService.ts
var $437b23f6a393c3bf$export$3687f0f5678a5df3 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.dispatchColumnChangedEvent = $437b23f6a393c3bf$var$dispatchColumnChangedEvent;
        this.columns = [];
        this.columnIndexMap = {};
        this.updateIndexMap = ()=>{
            this.columnIndexMap = {};
            this.columns.forEach((col, index)=>this.columnIndexMap[col.getId()] = index);
        };
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.aggFuncSvc = beans.aggFuncSvc;
        this.visibleCols = beans.visibleCols;
    }
    sortColumns(compareFn) {
        this.columns.sort(compareFn);
        this.updateIndexMap();
    }
    setColumns(colKeys, source) {
        this.setColList(colKeys, this.columns, this.eventName, true, true, this.columnProcessors.set, source);
    }
    addColumns(colKeys, source) {
        this.updateColList(colKeys, this.columns, true, true, this.columnProcessors.add, this.eventName, source);
    }
    removeColumns(colKeys, source) {
        this.updateColList(colKeys, this.columns, false, true, this.columnProcessors.remove, this.eventName, source);
    }
    getColumnIndex(colId) {
        return this.columnIndexMap[colId];
    }
    setColList(colKeys = [], masterList, eventName, detectOrderChange, autoGroupsNeedBuilding, columnCallback, source) {
        const gridColumns = this.colModel.getCols();
        if (!gridColumns || gridColumns.length === 0) return;
        const changes = /* @__PURE__ */ new Map();
        masterList.forEach((col, idx)=>changes.set(col, idx));
        masterList.length = 0;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(colKeys)) colKeys.forEach((key)=>{
            const column = this.colModel.getColDefCol(key);
            if (column) masterList.push(column);
        });
        masterList.forEach((col, idx)=>{
            const oldIndex = changes.get(col);
            if (oldIndex === void 0) {
                changes.set(col, 0);
                return;
            }
            if (detectOrderChange && oldIndex !== idx) return;
            changes.delete(col);
        });
        this.updateIndexMap();
        const primaryCols = this.colModel.getColDefCols();
        (primaryCols || []).forEach((column)=>{
            const added = masterList.indexOf(column) >= 0;
            columnCallback(column, added, source);
        });
        autoGroupsNeedBuilding && this.colModel.refreshCols(false);
        this.visibleCols.refresh(source);
        this.dispatchColumnChangedEvent(this.eventSvc, eventName, [
            ...changes.keys()
        ], source);
    }
    updateColList(keys = [], masterList, actionIsAdd, autoGroupsNeedBuilding, columnCallback, eventType, source) {
        if (!keys || keys.length === 0) return;
        let atLeastOne = false;
        const updatedCols = /* @__PURE__ */ new Set();
        keys.forEach((key)=>{
            if (!key) return;
            const columnToAdd = this.colModel.getColDefCol(key);
            if (!columnToAdd) return;
            updatedCols.add(columnToAdd);
            if (actionIsAdd) {
                if (masterList.indexOf(columnToAdd) >= 0) return;
                masterList.push(columnToAdd);
            } else {
                const currentIndex = masterList.indexOf(columnToAdd);
                if (currentIndex < 0) return;
                for(let i = currentIndex + 1; i < masterList.length; i++)updatedCols.add(masterList[i]);
                $437b23f6a393c3bf$export$83a881c8b5120679(masterList, columnToAdd);
            }
            columnCallback(columnToAdd, actionIsAdd, source);
            atLeastOne = true;
        });
        if (!atLeastOne) return;
        this.updateIndexMap();
        if (autoGroupsNeedBuilding) this.colModel.refreshCols(false);
        this.visibleCols.refresh(source);
        const eventColumns = Array.from(updatedCols);
        this.eventSvc.dispatchEvent({
            type: eventType,
            columns: eventColumns,
            column: eventColumns.length === 1 ? eventColumns[0] : null,
            source: source
        });
    }
    extractCols(source, oldProvidedCols = []) {
        const previousCols = this.columns;
        const colsWithIndex = [];
        const colsWithValue = [];
        const { setFlagFunc: setFlagFunc, getIndexFunc: getIndexFunc, getInitialIndexFunc: getInitialIndexFunc, getValueFunc: getValueFunc, getInitialValueFunc: getInitialValueFunc } = this.columnExtractors;
        const primaryCols = this.colModel.getColDefCols() || [];
        primaryCols.forEach((col)=>{
            const colIsNew = oldProvidedCols.indexOf(col) < 0;
            const colDef = col.getColDef();
            const value = getValueFunc(colDef);
            const initialValue = getInitialValueFunc(colDef);
            const index = getIndexFunc(colDef);
            const initialIndex = getInitialIndexFunc(colDef);
            let include;
            const valuePresent = value !== void 0;
            const indexPresent = index !== void 0;
            const initialValuePresent = initialValue !== void 0;
            const initialIndexPresent = initialIndex !== void 0;
            if (valuePresent) include = value;
            else if (indexPresent) {
                if (index === null) include = false;
                else include = index >= 0;
            } else if (colIsNew) {
                if (initialValuePresent) include = initialValue;
                else if (initialIndexPresent) include = initialIndex != null && initialIndex >= 0;
                else include = false;
            } else include = previousCols.indexOf(col) >= 0;
            if (include) {
                const useIndex = colIsNew ? index != null || initialIndex != null : index != null;
                useIndex ? colsWithIndex.push(col) : colsWithValue.push(col);
            }
        });
        const getIndexForCol = (col)=>{
            const index = getIndexFunc(col.getColDef());
            const defaultIndex = getInitialIndexFunc(col.getColDef());
            return index != null ? index : defaultIndex;
        };
        colsWithIndex.sort((colA, colB)=>{
            const indexA = getIndexForCol(colA);
            const indexB = getIndexForCol(colB);
            if (indexA === indexB) return 0;
            if (indexA < indexB) return -1;
            return 1;
        });
        const res = [].concat(colsWithIndex);
        previousCols.forEach((col)=>{
            if (colsWithValue.indexOf(col) >= 0) res.push(col);
        });
        colsWithValue.forEach((col)=>{
            if (res.indexOf(col) < 0) res.push(col);
        });
        previousCols.forEach((col)=>{
            if (res.indexOf(col) < 0) setFlagFunc(col, false, source);
        });
        res.forEach((col)=>{
            if (previousCols.indexOf(col) < 0) setFlagFunc(col, true, source);
        });
        this.columns = res;
        this.updateIndexMap();
        return this.columns;
    }
    restoreColumnOrder(columnStateAccumulator, incomingColumnState) {
        const colList = this.columns;
        const primaryCols = this.colModel.getColDefCols();
        if (!colList.length || !primaryCols) return columnStateAccumulator;
        const updatedColIdArray = Object.keys(incomingColumnState);
        const updatedColIds = new Set(updatedColIdArray);
        const newColIds = new Set(updatedColIdArray);
        const allColIds = new Set(colList.map((column)=>{
            const colId = column.getColId();
            newColIds.delete(colId);
            return colId;
        }).concat(updatedColIdArray));
        const colIdsInOriginalOrder = [];
        const originalOrderMap = {};
        let orderIndex = 0;
        for(let i = 0; i < primaryCols.length; i++){
            const colId = primaryCols[i].getColId();
            if (allColIds.has(colId)) {
                colIdsInOriginalOrder.push(colId);
                originalOrderMap[colId] = orderIndex++;
            }
        }
        let index = 1e3;
        let hasAddedNewCols = false;
        let lastIndex = 0;
        const enableProp = this.columnOrdering.enableProp;
        const initialEnableProp = this.columnOrdering.initialEnableProp;
        const indexProp = this.columnOrdering.indexProp;
        const initialIndexProp = this.columnOrdering.initialIndexProp;
        const processPrecedingNewCols = (colId)=>{
            const originalOrderIndex = originalOrderMap[colId];
            for(let i = lastIndex; i < originalOrderIndex; i++){
                const newColId = colIdsInOriginalOrder[i];
                if (newColIds.has(newColId)) {
                    incomingColumnState[newColId][indexProp] = index++;
                    newColIds.delete(newColId);
                }
            }
            lastIndex = originalOrderIndex;
        };
        colList.forEach((column)=>{
            const colId = column.getColId();
            if (updatedColIds.has(colId)) {
                processPrecedingNewCols(colId);
                incomingColumnState[colId][indexProp] = index++;
            } else {
                const colDef = column.getColDef();
                const missingIndex = colDef[indexProp] === null || colDef[indexProp] === void 0 && colDef[initialIndexProp] == null;
                if (missingIndex) {
                    if (!hasAddedNewCols) {
                        const propEnabled = colDef[enableProp] || colDef[enableProp] === void 0 && colDef[initialEnableProp];
                        if (propEnabled) processPrecedingNewCols(colId);
                        else {
                            newColIds.forEach((newColId)=>{
                                incomingColumnState[newColId][indexProp] = index + originalOrderMap[newColId];
                            });
                            index += colIdsInOriginalOrder.length;
                            hasAddedNewCols = true;
                        }
                    }
                    if (!columnStateAccumulator[colId]) columnStateAccumulator[colId] = {
                        colId: colId
                    };
                    columnStateAccumulator[colId][indexProp] = index++;
                }
            }
        });
        return columnStateAccumulator;
    }
};
// packages/ag-grid-community/src/columns/groupInstanceIdCreator.ts
var $437b23f6a393c3bf$export$b3b24737a74261fb = class {
    constructor(){
        // this map contains keys to numbers, so we remember what the last call was
        this.existingIds = {};
    }
    getInstanceIdForKey(key) {
        const lastResult = this.existingIds[key];
        let result;
        if (typeof lastResult !== "number") result = 0;
        else result = lastResult + 1;
        this.existingIds[key] = result;
        return result;
    }
};
// packages/ag-grid-community/src/components/emptyBean.ts
var $437b23f6a393c3bf$export$4f8bbae47c6ad8d2 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
};
function $437b23f6a393c3bf$var$setupCompBean(ctrl, ctx, compBean) {
    if (compBean) ctrl.addDestroyFunc(()=>ctx.destroyBean(compBean));
    return compBean ?? ctrl;
}
// packages/ag-grid-community/src/rendering/cssClassManager.ts
var $437b23f6a393c3bf$export$a7053cb7eb605bd2 = class {
    constructor(getGui){
        // to minimise DOM hits, we only apply CSS classes if they have changed. as adding a CSS class that is already
        // there, or removing one that wasn't present, all takes CPU.
        this.cssClassStates = {};
        this.getGui = getGui;
    }
    toggleCss(className, addOrRemove) {
        if (!className) return;
        if (className.indexOf(" ") >= 0) {
            const list = (className || "").split(" ");
            if (list.length > 1) {
                list.forEach((cls)=>this.toggleCss(cls, addOrRemove));
                return;
            }
        }
        const updateNeeded = this.cssClassStates[className] !== addOrRemove;
        if (updateNeeded && className.length) {
            this.getGui()?.classList.toggle(className, addOrRemove);
            this.cssClassStates[className] = addOrRemove;
        }
    }
};
// packages/ag-grid-community/src/widgets/component.ts
var $437b23f6a393c3bf$var$compIdSequence = 0;
var $437b23f6a393c3bf$export$6c811454646ed8be = null;
var $437b23f6a393c3bf$export$16fa2f45be04daa8 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(templateOrParams, componentSelectors){
        super();
        this.suppressDataRefValidation = false;
        // if false, then CSS class "ag-hidden" is applied, which sets "display: none"
        this.displayed = true;
        // if false, then CSS class "ag-invisible" is applied, which sets "visibility: hidden"
        this.visible = true;
        // unique id for this row component. this is used for getting a reference to the HTML dom.
        // we cannot use the RowNode id as this is not unique (due to animation, old rows can be lying
        // around as we create a new rowComp instance for the same row node).
        this.compId = $437b23f6a393c3bf$var$compIdSequence++;
        this.cssManager = new $437b23f6a393c3bf$export$a7053cb7eb605bd2(()=>this.eGui);
        this.componentSelectors = new Map((componentSelectors ?? []).map((comp)=>[
                comp.selector,
                comp
            ]));
        if (templateOrParams) this.setTemplate(templateOrParams);
    }
    preConstruct() {
        this.wireTemplate(this.getGui());
        const debugId = "component-" + Object.getPrototypeOf(this)?.constructor?.name;
        this.css?.forEach((css)=>this.beans.environment.addGlobalCSS(css, debugId));
    }
    wireTemplate(element, paramsMap) {
        if (element && this.gos) {
            this.applyElementsToComponent(element);
            this.createChildComponentsFromTags(element, paramsMap);
        }
    }
    getCompId() {
        return this.compId;
    }
    getDataRefAttribute(element) {
        if (element.getAttribute) return element.getAttribute($437b23f6a393c3bf$var$DataRefAttribute);
        return null;
    }
    applyElementsToComponent(element, elementRef, paramsMap, newComponent = null) {
        if (elementRef === void 0) elementRef = this.getDataRefAttribute(element);
        if (elementRef) {
            const current = this[elementRef];
            if (current === $437b23f6a393c3bf$export$6c811454646ed8be) this[elementRef] = newComponent ?? element;
            else {
                const usedAsParamRef = paramsMap && paramsMap[elementRef];
                if (!this.suppressDataRefValidation && !usedAsParamRef) throw new Error(`data-ref: ${elementRef} on ${this.constructor.name} with ${current}`);
            }
        }
    }
    // for registered components only, eg creates AgCheckbox instance from ag-checkbox HTML tag
    createChildComponentsFromTags(parentNode, paramsMap) {
        const childNodeList = [];
        for (const childNode of parentNode.childNodes ?? [])childNodeList.push(childNode);
        childNodeList.forEach((childNode)=>{
            if (!(childNode instanceof HTMLElement)) return;
            const childComp = this.createComponentFromElement(childNode, (childComp2)=>{
                const childGui = childComp2.getGui();
                if (childGui) for (const attr of childNode.attributes ?? [])childGui.setAttribute(attr.name, attr.value);
            }, paramsMap);
            if (childComp) {
                if (childComp.addItems && childNode.children.length) {
                    this.createChildComponentsFromTags(childNode, paramsMap);
                    const items = Array.prototype.slice.call(childNode.children);
                    childComp.addItems(items);
                }
                this.swapComponentForNode(childComp, parentNode, childNode);
            } else if (childNode.childNodes) this.createChildComponentsFromTags(childNode, paramsMap);
        });
    }
    createComponentFromElement(element, afterPreCreateCallback, paramsMap) {
        const key = element.nodeName;
        const elementRef = this.getDataRefAttribute(element);
        const isAgGridComponent = key.indexOf("AG-") === 0;
        const componentSelector = isAgGridComponent ? this.componentSelectors.get(key) : null;
        let newComponent = null;
        if (componentSelector) {
            const componentParams = paramsMap && elementRef ? paramsMap[elementRef] : void 0;
            newComponent = new componentSelector.component(componentParams);
            newComponent.setParentComponent(this);
            this.createBean(newComponent, null, afterPreCreateCallback);
        } else if (isAgGridComponent) throw new Error(`selector: ${key}`);
        this.applyElementsToComponent(element, elementRef, paramsMap, newComponent);
        return newComponent;
    }
    swapComponentForNode(newComponent, parentNode, childNode) {
        const eComponent = newComponent.getGui();
        parentNode.replaceChild(eComponent, childNode);
        parentNode.insertBefore(document.createComment(childNode.nodeName), eComponent);
        this.addDestroyFunc(this.destroyBean.bind(this, newComponent));
    }
    activateTabIndex(elements) {
        const tabIndex = this.gos.get("tabIndex");
        if (!elements) elements = [];
        if (!elements.length) elements.push(this.getGui());
        elements.forEach((el)=>el.setAttribute("tabindex", tabIndex.toString()));
    }
    setTemplate(templateOrParams, componentSelectors, paramsMap) {
        let eGui;
        if (typeof templateOrParams === "string" || templateOrParams == null) eGui = $437b23f6a393c3bf$export$b1f57d075ca6d5fb(templateOrParams);
        else eGui = $437b23f6a393c3bf$export$a232bb0480ae674a(templateOrParams);
        this.setTemplateFromElement(eGui, componentSelectors, paramsMap);
    }
    setTemplateFromElement(element, components, paramsMap, suppressDataRefValidation = false) {
        this.eGui = element;
        this.suppressDataRefValidation = suppressDataRefValidation;
        if (components) for(let i = 0; i < components.length; i++){
            const component = components[i];
            this.componentSelectors.set(component.selector, component);
        }
        this.wireTemplate(element, paramsMap);
    }
    getGui() {
        return this.eGui;
    }
    getFocusableElement() {
        return this.eGui;
    }
    getAriaElement() {
        return this.getFocusableElement();
    }
    setParentComponent(component) {
        this.parentComponent = component;
    }
    getParentComponent() {
        return this.parentComponent;
    }
    // this method is for older code, that wants to provide the gui element,
    // it is not intended for this to be in ag-Stack
    setGui(eGui) {
        this.eGui = eGui;
    }
    queryForHtmlElement(cssSelector) {
        return this.eGui.querySelector(cssSelector);
    }
    getContainerAndElement(newChild, container) {
        let parent = container;
        if (newChild == null) return null;
        if (!parent) parent = this.eGui;
        if ($437b23f6a393c3bf$export$6e6303ef478b0c94(newChild)) return {
            element: newChild,
            parent: parent
        };
        return {
            element: newChild.getGui(),
            parent: parent
        };
    }
    prependChild(newChild, container) {
        const { element: element, parent: parent } = this.getContainerAndElement(newChild, container) || {};
        if (!element || !parent) return;
        parent.insertAdjacentElement("afterbegin", element);
    }
    appendChild(newChild, container) {
        const { element: element, parent: parent } = this.getContainerAndElement(newChild, container) || {};
        if (!element || !parent) return;
        parent.appendChild(element);
    }
    isDisplayed() {
        return this.displayed;
    }
    setVisible(visible, options = {}) {
        if (visible !== this.visible) {
            this.visible = visible;
            const { skipAriaHidden: skipAriaHidden } = options;
            $437b23f6a393c3bf$export$a6c2c477cd60daa8(this.eGui, visible, {
                skipAriaHidden: skipAriaHidden
            });
        }
    }
    setDisplayed(displayed, options = {}) {
        if (displayed !== this.displayed) {
            this.displayed = displayed;
            const { skipAriaHidden: skipAriaHidden } = options;
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eGui, displayed, {
                skipAriaHidden: skipAriaHidden
            });
            const event = {
                type: "displayChanged",
                visible: this.displayed
            };
            this.dispatchLocalEvent(event);
        }
    }
    destroy() {
        if (this.parentComponent) this.parentComponent = void 0;
        super.destroy();
    }
    addGuiEventListener(event, listener, options) {
        this.eGui.addEventListener(event, listener, options);
        this.addDestroyFunc(()=>this.eGui.removeEventListener(event, listener));
    }
    addCss(className) {
        this.cssManager.toggleCss(className, true);
    }
    removeCss(className) {
        this.cssManager.toggleCss(className, false);
    }
    toggleCss(className, addOrRemove) {
        this.cssManager.toggleCss(className, addOrRemove);
    }
    registerCSS(css) {
        this.css || (this.css = []);
        this.css.push(css);
    }
};
// packages/ag-grid-community/src/interfaces/iFilter.ts
function $437b23f6a393c3bf$var$isColumnFilterComp(filter) {
    return typeof filter === "object" && !!filter.component;
}
// packages/ag-grid-community/src/utils/promise.ts
function $437b23f6a393c3bf$export$2395b9dc826192b2(fn) {
    if (typeof fn.then === "function") return true;
    return false;
}
var $437b23f6a393c3bf$export$30ec7836a4847721 = class _AgPromise {
    constructor(callback){
        this.status = 0 /* IN_PROGRESS */ ;
        this.resolution = null;
        this.waiters = [];
        callback((value)=>this.onDone(value), (params)=>this.onReject(params));
    }
    static all(promises) {
        return promises.length ? new _AgPromise((resolve)=>{
            let remainingToResolve = promises.length;
            const combinedValues = new Array(remainingToResolve);
            promises.forEach((promise, index)=>{
                promise.then((value)=>{
                    combinedValues[index] = value;
                    remainingToResolve--;
                    if (remainingToResolve === 0) resolve(combinedValues);
                });
            });
        }) : _AgPromise.resolve();
    }
    static resolve(value = null) {
        return new _AgPromise((resolve)=>resolve(value));
    }
    then(func) {
        return new _AgPromise((resolve)=>{
            if (this.status === 1 /* RESOLVED */ ) resolve(func(this.resolution));
            else this.waiters.push((value)=>resolve(func(value)));
        });
    }
    onDone(value) {
        this.status = 1 /* RESOLVED */ ;
        this.resolution = value;
        this.waiters.forEach((waiter)=>waiter(value));
    }
    onReject(_) {}
};
// packages/ag-grid-community/src/components/framework/userComponentFactory.ts
function $437b23f6a393c3bf$var$doesImplementIComponent(candidate) {
    if (!candidate) return false;
    return candidate.prototype && "getGui" in candidate.prototype;
}
function $437b23f6a393c3bf$var$_getUserCompKeys(frameworkOverrides, defObject, type, params) {
    const { name: name } = type;
    let compName;
    let jsComp;
    let fwComp;
    let paramsFromSelector;
    let popupFromSelector;
    let popupPositionFromSelector;
    if (defObject) {
        const defObjectAny = defObject;
        const selectorFunc = defObjectAny[name + "Selector"];
        const selectorRes = selectorFunc ? selectorFunc(params) : null;
        const assignComp = (providedJsComp)=>{
            if (typeof providedJsComp === "string") compName = providedJsComp;
            else if (providedJsComp != null && providedJsComp !== true) {
                const isFwkComp = frameworkOverrides.isFrameworkComponent(providedJsComp);
                if (isFwkComp) fwComp = providedJsComp;
                else jsComp = providedJsComp;
            }
        };
        if (selectorRes) {
            assignComp(selectorRes.component);
            paramsFromSelector = selectorRes.params;
            popupFromSelector = selectorRes.popup;
            popupPositionFromSelector = selectorRes.popupPosition;
        } else assignComp(defObjectAny[name]);
    }
    return {
        compName: compName,
        jsComp: jsComp,
        fwComp: fwComp,
        paramsFromSelector: paramsFromSelector,
        popupFromSelector: popupFromSelector,
        popupPositionFromSelector: popupPositionFromSelector
    };
}
var $437b23f6a393c3bf$var$UserComponentFactory = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "userCompFactory";
    }
    wireBeans(beans) {
        this.agCompUtils = beans.agCompUtils;
        this.registry = beans.registry;
        this.frameworkCompWrapper = beans.frameworkCompWrapper;
        this.gridOptions = beans.gridOptions;
    }
    getCompDetailsFromGridOptions(type, defaultName, params, mandatory = false) {
        return this.getCompDetails(this.gridOptions, type, defaultName, params, mandatory);
    }
    getCompDetails(defObject, type, defaultName, params, mandatory = false) {
        const { name: name, cellRenderer: cellRenderer } = type;
        let { compName: compName, jsComp: jsComp, fwComp: fwComp, paramsFromSelector: paramsFromSelector, popupFromSelector: popupFromSelector, popupPositionFromSelector: popupPositionFromSelector } = $437b23f6a393c3bf$var$_getUserCompKeys(this.beans.frameworkOverrides, defObject, type, params);
        let defaultCompParams;
        let defaultCompProcessParams;
        const lookupFromRegistry = (key)=>{
            const item = this.registry.getUserComponent(name, key);
            if (item) {
                jsComp = !item.componentFromFramework ? item.component : void 0;
                fwComp = item.componentFromFramework ? item.component : void 0;
                defaultCompParams = item.params;
                defaultCompProcessParams = item.processParams;
            }
        };
        if (compName != null) lookupFromRegistry(compName);
        if (jsComp == null && fwComp == null && defaultName != null) lookupFromRegistry(defaultName);
        if (jsComp && cellRenderer && !$437b23f6a393c3bf$var$doesImplementIComponent(jsComp)) jsComp = this.agCompUtils?.adaptFunction(type, jsComp);
        if (!jsComp && !fwComp) {
            const { validation: validation2 } = this.beans;
            if (mandatory && (compName !== defaultName || !defaultName)) {
                if (compName) {
                    if (!validation2?.isProvidedUserComp(compName)) $437b23f6a393c3bf$export$a20c7248650823a9(50, {
                        compName: compName
                    });
                } else {
                    if (defaultName) {
                        if (!validation2) $437b23f6a393c3bf$export$a20c7248650823a9(260, {
                            ...this.gos.getModuleErrorParams(),
                            propName: name,
                            compName: defaultName
                        });
                    } else $437b23f6a393c3bf$export$a20c7248650823a9(216, {
                        name: name
                    });
                }
            } else if (defaultName && !validation2) $437b23f6a393c3bf$export$a20c7248650823a9(146, {
                comp: defaultName
            });
            return;
        }
        const paramsMerged = this.mergeParams(defObject, type, params, paramsFromSelector, defaultCompParams, defaultCompProcessParams);
        const componentFromFramework = jsComp == null;
        const componentClass = jsComp ?? fwComp;
        return {
            componentFromFramework: componentFromFramework,
            componentClass: componentClass,
            params: paramsMerged,
            type: type,
            popupFromSelector: popupFromSelector,
            popupPositionFromSelector: popupPositionFromSelector,
            newAgStackInstance: ()=>this.newAgStackInstance(componentClass, componentFromFramework, paramsMerged, type)
        };
    }
    newAgStackInstance(ComponentClass, componentFromFramework, params, type) {
        const jsComponent = !componentFromFramework;
        let instance;
        if (jsComponent) instance = new ComponentClass();
        else instance = this.frameworkCompWrapper.wrap(ComponentClass, type.mandatoryMethods, type.optionalMethods, type);
        this.createBean(instance);
        const deferredInit = instance.init?.(params);
        if (deferredInit == null) return $437b23f6a393c3bf$export$30ec7836a4847721.resolve(instance);
        return deferredInit.then(()=>instance);
    }
    /**
   * merges params with application provided params
   * used by Floating Filter
   */ mergeParams(defObject, type, paramsFromGrid, paramsFromSelector = null, defaultCompParams, defaultCompProcessParams) {
        const params = {
            ...paramsFromGrid,
            ...defaultCompParams
        };
        const defObjectAny = defObject;
        const userParams = defObjectAny && defObjectAny[type.name + "Params"];
        if (typeof userParams === "function") {
            const userParamsFromFunc = userParams(paramsFromGrid);
            $437b23f6a393c3bf$export$8ade6bd474fcde42(params, userParamsFromFunc);
        } else if (typeof userParams === "object") $437b23f6a393c3bf$export$8ade6bd474fcde42(params, userParams);
        $437b23f6a393c3bf$export$8ade6bd474fcde42(params, paramsFromSelector);
        return defaultCompProcessParams ? defaultCompProcessParams(params) : params;
    }
};
// packages/ag-grid-community/src/components/framework/userCompUtils.ts
var $437b23f6a393c3bf$var$DateComponent = {
    name: "dateComponent",
    mandatoryMethods: [
        "getDate",
        "setDate"
    ],
    optionalMethods: [
        "afterGuiAttached",
        "setInputPlaceholder",
        "setInputAriaLabel",
        "setDisabled",
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$DragAndDropImageComponent = {
    name: "dragAndDropImageComponent",
    mandatoryMethods: [
        "setIcon",
        "setLabel"
    ]
};
var $437b23f6a393c3bf$var$HeaderComponent = {
    name: "headerComponent",
    optionalMethods: [
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$InnerHeaderComponent = {
    name: "innerHeaderComponent"
};
var $437b23f6a393c3bf$var$InnerHeaderGroupComponent = {
    name: "innerHeaderGroupComponent"
};
var $437b23f6a393c3bf$var$HeaderGroupComponent = {
    name: "headerGroupComponent"
};
var $437b23f6a393c3bf$var$InnerCellRendererComponent = {
    name: "innerRenderer",
    cellRenderer: true,
    optionalMethods: [
        "afterGuiAttached"
    ]
};
var $437b23f6a393c3bf$var$CellRendererComponent = {
    name: "cellRenderer",
    optionalMethods: [
        "refresh",
        "afterGuiAttached"
    ],
    cellRenderer: true
};
var $437b23f6a393c3bf$var$EditorRendererComponent = {
    name: "cellRenderer",
    optionalMethods: [
        "refresh",
        "afterGuiAttached"
    ]
};
var $437b23f6a393c3bf$var$LoadingCellRendererComponent = {
    name: "loadingCellRenderer",
    cellRenderer: true
};
var $437b23f6a393c3bf$var$CellEditorComponent = {
    name: "cellEditor",
    mandatoryMethods: [
        "getValue"
    ],
    optionalMethods: [
        "isPopup",
        "isCancelBeforeStart",
        "isCancelAfterEnd",
        "getPopupPosition",
        "focusIn",
        "focusOut",
        "afterGuiAttached",
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$LoadingOverlayComponent = {
    name: "loadingOverlayComponent",
    optionalMethods: [
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$NoRowsOverlayComponent = {
    name: "noRowsOverlayComponent",
    optionalMethods: [
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$TooltipComponent = {
    name: "tooltipComponent"
};
var $437b23f6a393c3bf$var$FilterComponent = {
    name: "filter",
    mandatoryMethods: [
        "isFilterActive",
        "doesFilterPass",
        "getModel",
        "setModel"
    ],
    optionalMethods: [
        "afterGuiAttached",
        "afterGuiDetached",
        "onNewRowsLoaded",
        "getModelAsString",
        "onFloatingFilterChanged",
        "onAnyFilterChanged",
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$FloatingFilterComponent = {
    name: "floatingFilterComponent",
    mandatoryMethods: [
        "onParentModelChanged"
    ],
    optionalMethods: [
        "afterGuiAttached",
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$FullWidth = {
    name: "fullWidthCellRenderer",
    optionalMethods: [
        "refresh",
        "afterGuiAttached"
    ],
    cellRenderer: true
};
var $437b23f6a393c3bf$var$FullWidthLoading = {
    name: "loadingCellRenderer",
    cellRenderer: true
};
var $437b23f6a393c3bf$var$FullWidthGroup = {
    name: "groupRowRenderer",
    optionalMethods: [
        "afterGuiAttached"
    ],
    cellRenderer: true
};
var $437b23f6a393c3bf$var$FullWidthDetail = {
    name: "detailCellRenderer",
    optionalMethods: [
        "refresh"
    ],
    cellRenderer: true
};
function $437b23f6a393c3bf$var$_getDragAndDropImageCompDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$DragAndDropImageComponent, "agDragAndDropImage", params, true);
}
function $437b23f6a393c3bf$export$c3f4e745c2fdf1c0(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$InnerCellRendererComponent, void 0, params);
}
function $437b23f6a393c3bf$var$_getHeaderCompDetails(userCompFactory, colDef, params) {
    return userCompFactory.getCompDetails(colDef, $437b23f6a393c3bf$var$HeaderComponent, "agColumnHeader", params);
}
function $437b23f6a393c3bf$var$_getInnerHeaderCompDetails(userCompFactory, headerCompParams, params) {
    return userCompFactory.getCompDetails(headerCompParams, $437b23f6a393c3bf$var$InnerHeaderComponent, void 0, params);
}
function $437b23f6a393c3bf$var$_getHeaderGroupCompDetails(userCompFactory, params) {
    const colGroupDef = params.columnGroup.getColGroupDef();
    return userCompFactory.getCompDetails(colGroupDef, $437b23f6a393c3bf$var$HeaderGroupComponent, "agColumnGroupHeader", params);
}
function $437b23f6a393c3bf$var$_getInnerHeaderGroupCompDetails(userCompFactory, headerGroupCompParams, params) {
    return userCompFactory.getCompDetails(headerGroupCompParams, $437b23f6a393c3bf$var$InnerHeaderGroupComponent, void 0, params);
}
function $437b23f6a393c3bf$var$_getFullWidthCellRendererDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$FullWidth, void 0, params, true);
}
function $437b23f6a393c3bf$var$_getFullWidthLoadingCellRendererDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$FullWidthLoading, "agLoadingCellRenderer", params, true);
}
function $437b23f6a393c3bf$var$_getFullWidthGroupCellRendererDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$FullWidthGroup, "agGroupRowRenderer", params, true);
}
function $437b23f6a393c3bf$var$_getFullWidthDetailCellRendererDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$FullWidthDetail, "agDetailCellRenderer", params, true);
}
function $437b23f6a393c3bf$export$1f172e021e4d8401(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$CellRendererComponent, void 0, params);
}
function $437b23f6a393c3bf$export$85a10ea90cfc8a53(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$EditorRendererComponent, void 0, params);
}
function $437b23f6a393c3bf$var$_getLoadingCellRendererDetails(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$LoadingCellRendererComponent, "agSkeletonCellRenderer", params, true);
}
function $437b23f6a393c3bf$var$_getCellEditorDetails(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$CellEditorComponent, "agCellEditor", params, true);
}
function $437b23f6a393c3bf$export$e6db9a2d59456da0(userCompFactory, def, params, defaultFilter) {
    const filter = def.filter;
    if ($437b23f6a393c3bf$var$isColumnFilterComp(filter)) def = {
        filter: filter.component,
        filterParams: def.filterParams
    };
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$FilterComponent, defaultFilter, params, true);
}
function $437b23f6a393c3bf$var$_getDateCompDetails(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$DateComponent, "agDateInput", params, true);
}
function $437b23f6a393c3bf$var$_getLoadingOverlayCompDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$LoadingOverlayComponent, "agLoadingOverlay", params, true);
}
function $437b23f6a393c3bf$var$_getNoRowsOverlayCompDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$NoRowsOverlayComponent, "agNoRowsOverlay", params, true);
}
function $437b23f6a393c3bf$var$_getTooltipCompDetails(userCompFactory, params) {
    return userCompFactory.getCompDetails(params.colDef, $437b23f6a393c3bf$var$TooltipComponent, "agTooltipComponent", params, true);
}
function $437b23f6a393c3bf$export$14d0998f093f007e(userCompFactory, def, params, defaultFloatingFilter) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$FloatingFilterComponent, defaultFloatingFilter, params);
}
function $437b23f6a393c3bf$var$_getFilterCompKeys(frameworkOverrides, def) {
    return $437b23f6a393c3bf$var$_getUserCompKeys(frameworkOverrides, def, $437b23f6a393c3bf$var$FilterComponent);
}
function $437b23f6a393c3bf$var$_mergeFilterParamsWithApplicationProvidedParams(userCompFactory, defObject, paramsFromGrid) {
    return userCompFactory.mergeParams(defObject, $437b23f6a393c3bf$var$FilterComponent, paramsFromGrid);
}
// packages/ag-grid-community/src/components/framework/unwrapUserComp.ts
function $437b23f6a393c3bf$export$213d4c63c3df47e4(comp) {
    const compAsAny = comp;
    const isProxy = compAsAny != null && compAsAny.getFrameworkComponentInstance != null;
    return isProxy ? compAsAny.getFrameworkComponentInstance() : comp;
}
// packages/ag-grid-community/src/modules/moduleRegistry.ts
var $437b23f6a393c3bf$var$allRegisteredModules = /* @__PURE__ */ new Set();
var $437b23f6a393c3bf$var$globalModulesMap = {};
var $437b23f6a393c3bf$var$gridModulesMap = {};
var $437b23f6a393c3bf$var$currentModuleVersion;
var $437b23f6a393c3bf$var$userHasRegistered = false;
var $437b23f6a393c3bf$var$areGridScopedModules = false;
var $437b23f6a393c3bf$var$isUmd = false;
function $437b23f6a393c3bf$var$isValidModuleVersion(module) {
    const [moduleMajor, moduleMinor] = module.version.split(".") || [];
    const [currentModuleMajor, currentModuleMinor] = $437b23f6a393c3bf$var$currentModuleVersion.split(".") || [];
    return moduleMajor === currentModuleMajor && moduleMinor === currentModuleMinor;
}
function $437b23f6a393c3bf$var$runVersionChecks(module) {
    if (!$437b23f6a393c3bf$var$currentModuleVersion) $437b23f6a393c3bf$var$currentModuleVersion = module.version;
    const errorMsg = (details)=>`You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. ${details} Please update all modules to the same version.`;
    if (!module.version) $437b23f6a393c3bf$var$_errorOnce(errorMsg(`'${module.moduleName}' is incompatible.`));
    else if (!$437b23f6a393c3bf$var$isValidModuleVersion(module)) $437b23f6a393c3bf$var$_errorOnce(errorMsg(`'${module.moduleName}' is version ${module.version} but the other modules are version ${$437b23f6a393c3bf$var$currentModuleVersion}.`));
    if (module.validate) {
        const result = module.validate();
        if (!result.isValid) {
            const errorResult = result;
            $437b23f6a393c3bf$var$_errorOnce(`${errorResult.message}`);
        }
    }
}
function $437b23f6a393c3bf$export$d0b008fbcc09e577(module, gridId, isInternalRegistration = false) {
    if (!isInternalRegistration) $437b23f6a393c3bf$var$userHasRegistered = true;
    $437b23f6a393c3bf$var$runVersionChecks(module);
    const rowModels = module.rowModels ?? [
        "all"
    ];
    $437b23f6a393c3bf$var$allRegisteredModules.add(module);
    let moduleStore;
    if (gridId !== void 0) {
        $437b23f6a393c3bf$var$areGridScopedModules = true;
        if ($437b23f6a393c3bf$var$gridModulesMap[gridId] === void 0) $437b23f6a393c3bf$var$gridModulesMap[gridId] = {};
        moduleStore = $437b23f6a393c3bf$var$gridModulesMap[gridId];
    } else moduleStore = $437b23f6a393c3bf$var$globalModulesMap;
    rowModels.forEach((rowModel)=>{
        if (moduleStore[rowModel] === void 0) moduleStore[rowModel] = {};
        moduleStore[rowModel][module.moduleName] = module;
    });
    if (module.dependsOn) module.dependsOn.forEach((dependency)=>$437b23f6a393c3bf$export$d0b008fbcc09e577(dependency, gridId, isInternalRegistration));
}
function $437b23f6a393c3bf$var$_unRegisterGridModules(gridId) {
    delete $437b23f6a393c3bf$var$gridModulesMap[gridId];
}
function $437b23f6a393c3bf$var$_isModuleRegistered(moduleName, gridId, rowModel) {
    const isRegisteredForRowModel = (model)=>!!$437b23f6a393c3bf$var$globalModulesMap[model]?.[moduleName] || !!$437b23f6a393c3bf$var$gridModulesMap[gridId]?.[model]?.[moduleName];
    return isRegisteredForRowModel(rowModel) || isRegisteredForRowModel("all");
}
function $437b23f6a393c3bf$var$_areModulesGridScoped() {
    return $437b23f6a393c3bf$var$areGridScopedModules;
}
function $437b23f6a393c3bf$var$_getRegisteredModules(gridId, rowModel) {
    const gridModules = $437b23f6a393c3bf$var$gridModulesMap[gridId] ?? {};
    return [
        ...Object.values($437b23f6a393c3bf$var$globalModulesMap["all"] ?? {}),
        ...Object.values(gridModules["all"] ?? {}),
        ...Object.values($437b23f6a393c3bf$var$globalModulesMap[rowModel] ?? {}),
        ...Object.values(gridModules[rowModel] ?? {})
    ];
}
function $437b23f6a393c3bf$var$_getAllRegisteredModules() {
    return new Set($437b23f6a393c3bf$var$allRegisteredModules);
}
function $437b23f6a393c3bf$export$7c244c452cd4b417(gridId, rowModel) {
    const gridModules = $437b23f6a393c3bf$var$gridModulesMap[gridId] ?? {};
    return [
        ...Object.values(gridModules["all"] ?? {}),
        ...Object.values(gridModules[rowModel] ?? {})
    ];
}
function $437b23f6a393c3bf$var$_hasUserRegistered() {
    return $437b23f6a393c3bf$var$userHasRegistered;
}
function $437b23f6a393c3bf$var$_isUmd() {
    return $437b23f6a393c3bf$var$isUmd;
}
function $437b23f6a393c3bf$export$8bf1e03cfb50cab5() {
    $437b23f6a393c3bf$var$isUmd = true;
}
var $437b23f6a393c3bf$export$dc053975cc7f6c11 = class {
    /**
   * @deprecated v33 Use `registerModules([module])` instead.
   */ static register(module) {
        $437b23f6a393c3bf$export$d0b008fbcc09e577(module, void 0);
    }
    /**
   * Globally register the given modules for all grids.
   * @param modules - modules to register
   */ static registerModules(modules) {
        modules.forEach((module)=>$437b23f6a393c3bf$export$d0b008fbcc09e577(module, void 0));
    }
};
// packages/ag-grid-community/src/context/genericContext.ts
var $437b23f6a393c3bf$var$GenericContext = class {
    constructor(params){
        this.beans = {};
        this.createdBeans = [];
        this.destroyed = false;
        if (!params || !params.beanClasses) return;
        this.beanDestroyComparator = params.beanDestroyComparator;
        this.init(params);
    }
    init(params) {
        for (const beanName of Object.keys(params.providedBeanInstances))this.beans[beanName] = params.providedBeanInstances[beanName];
        params.beanClasses.forEach((BeanClass)=>{
            const instance = new BeanClass();
            if (instance.beanName) this.beans[instance.beanName] = instance;
            else console.error(`Bean ${BeanClass.name} is missing beanName`);
            this.createdBeans.push(instance);
        });
        params.derivedBeans?.forEach((beanFunc)=>{
            const { beanName: beanName, bean: bean } = beanFunc(this);
            this.beans[beanName] = bean;
            this.createdBeans.push(bean);
        });
        if (params.beanInitComparator) this.createdBeans.sort(params.beanInitComparator);
        this.initBeans(this.createdBeans);
    }
    getBeanInstances() {
        return Object.values(this.beans);
    }
    createBean(bean, afterPreCreateCallback) {
        this.initBeans([
            bean
        ], afterPreCreateCallback);
        return bean;
    }
    initBeans(beanInstances, afterPreCreateCallback) {
        beanInstances.forEach((instance)=>{
            instance.preWireBeans?.(this.beans);
            instance.wireBeans?.(this.beans);
        });
        beanInstances.forEach((instance)=>instance.preConstruct?.());
        if (afterPreCreateCallback) beanInstances.forEach(afterPreCreateCallback);
        beanInstances.forEach((instance)=>instance.postConstruct?.());
    }
    getBeans() {
        return this.beans;
    }
    getBean(name) {
        return this.beans[name];
    }
    destroy() {
        if (this.destroyed) return;
        this.destroyed = true;
        const beanInstances = this.getBeanInstances();
        if (this.beanDestroyComparator) beanInstances.sort(this.beanDestroyComparator);
        this.destroyBeans(beanInstances);
        this.beans = {};
        this.createdBeans = [];
    }
    /**
   * Destroys a bean and returns undefined to support destruction and clean up in a single line.
   * this.dateComp = this.context.destroyBean(this.dateComp);
   */ destroyBean(bean) {
        bean?.destroy?.();
    }
    /**
   * Destroys an array of beans and returns an empty array to support destruction and clean up in a single line.
   * this.dateComps = this.context.destroyBeans(this.dateComps);
   */ destroyBeans(beans) {
        if (beans) for(let i = 0; i < beans.length; i++)this.destroyBean(beans[i]);
        return [];
    }
    isDestroyed() {
        return this.destroyed;
    }
};
// packages/ag-grid-community/src/context/context.ts
function $437b23f6a393c3bf$var$isComponentMetaFunc(componentMeta) {
    return typeof componentMeta === "object" && !!componentMeta.getComp;
}
var $437b23f6a393c3bf$var$Context = class extends $437b23f6a393c3bf$var$GenericContext {
    init(params) {
        this.gridId = params.gridId;
        this.beans.context = this;
        this.destroyCallback = params.destroyCallback;
        super.init(params);
    }
    destroy() {
        super.destroy();
        $437b23f6a393c3bf$var$_unRegisterGridModules(this.gridId);
        this.destroyCallback?.();
    }
    getGridId() {
        return this.gridId;
    }
};
// packages/ag-grid-community/src/edit/editModelService.ts
var $437b23f6a393c3bf$var$EditModelService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "editModelSvc";
        this.edits = /* @__PURE__ */ new Map();
        this.cellValidations = new $437b23f6a393c3bf$var$EditCellValidationModel();
        this.rowValidations = new $437b23f6a393c3bf$var$EditRowValidationModel();
        // during some operations, we want to always return false from `hasEdits`
        this.suspendEdits = false;
    }
    suspend(suspend) {
        this.suspendEdits = suspend;
    }
    removeEdits({ rowNode: rowNode, column: column }) {
        if (!this.hasEdits({
            rowNode: rowNode
        }) || !rowNode) return;
        const editRow = this.getEditRow(rowNode);
        if (column) editRow.delete(column);
        else editRow.clear();
        if (editRow.size === 0) this.edits.delete(rowNode);
    }
    getEditRow(rowNode, params = {}) {
        if (this.suspendEdits) return void 0;
        if (this.edits.size === 0) return void 0;
        const edits = rowNode && this.edits.get(rowNode);
        if (edits) return edits;
        if (params.checkSiblings) {
            const pinnedSibling = rowNode.pinnedSibling;
            if (pinnedSibling) return this.getEditRow(pinnedSibling);
        }
        return void 0;
    }
    getEditRowDataValue(rowNode, { checkSiblings: checkSiblings } = {}) {
        if (this.edits.size === 0) return rowNode.data;
        const editRow = this.getEditRow(rowNode);
        const pinnedSibling = rowNode.pinnedSibling;
        const siblingRow = checkSiblings && pinnedSibling && this.getEditRow(pinnedSibling);
        if (!editRow && !siblingRow) return rowNode.data;
        const data = Object.assign({}, rowNode.data);
        const applyEdits = (edits, data2)=>edits.forEach(({ pendingValue: pendingValue }, column)=>{
                if (pendingValue !== $437b23f6a393c3bf$var$UNEDITED) data2[column.getColId()] = pendingValue;
            });
        if (editRow) applyEdits(editRow, data);
        if (siblingRow) applyEdits(siblingRow, data);
        return data;
    }
    getEdit(position, copy) {
        const edit = this._getEdit(position);
        return copy && edit ? {
            ...edit
        } : edit;
    }
    _getEdit(position) {
        if (this.suspendEdits) return void 0;
        if (this.edits.size === 0) return void 0;
        return position.rowNode && position.column && this.getEditRow(position.rowNode)?.get(position.column);
    }
    getEditMap(copy = true) {
        if (this.suspendEdits || this.edits.size === 0) return /* @__PURE__ */ new Map();
        if (!copy) return this.edits;
        const map = /* @__PURE__ */ new Map();
        this.edits.forEach((editRow, rowNode)=>map.set(rowNode, new Map(editRow)));
        return map;
    }
    setEditMap(newEdits) {
        this.edits.clear();
        newEdits.forEach((editRow, rowNode)=>{
            const newRow = /* @__PURE__ */ new Map();
            editRow.forEach((cellData, column)=>// Ensure we copy the cell data to avoid reference issues
                newRow.set(column, {
                    ...cellData
                }));
            this.edits.set(rowNode, newRow);
        });
    }
    setEdit(position, edit) {
        (this.edits.size === 0 || !this.edits.has(position.rowNode)) && this.edits.set(position.rowNode, /* @__PURE__ */ new Map());
        const currentEdit = {
            ...this._getEdit(position),
            ...edit
        };
        this.getEditRow(position.rowNode).set(position.column, currentEdit);
        return currentEdit;
    }
    clearEditValue(position) {
        const { rowNode: rowNode, column: column } = position;
        if (rowNode) {
            if (column) {
                const edit = this._getEdit(position);
                if (edit) {
                    edit.editorValue = void 0;
                    edit.pendingValue = edit.sourceValue;
                    edit.state = "changed";
                }
            } else this.getEditRow(rowNode)?.forEach((cellData)=>{
                cellData.editorValue = void 0;
                cellData.pendingValue = cellData.sourceValue;
                cellData.state = "changed";
            });
        }
    }
    getState(position) {
        if (this.suspendEdits) return void 0;
        return this.getEdit(position)?.state;
    }
    getEditPositions(editMap) {
        if (this.suspendEdits || (editMap ?? this.edits).size === 0) return [];
        const positions = [];
        (editMap ?? this.edits).forEach((editRow, rowNode)=>{
            for (const column of editRow.keys())positions.push({
                rowNode: rowNode,
                column: column,
                ...editRow.get(column)
            });
        });
        return positions;
    }
    hasRowEdits(rowNode, params) {
        if (this.suspendEdits) return false;
        if (this.edits.size === 0) return false;
        const rowEdits = this.getEditRow(rowNode, params);
        return !!rowEdits;
    }
    hasEdits(position = {}, params = {}) {
        if (this.suspendEdits) return false;
        if (this.edits.size === 0) return false;
        const { rowNode: rowNode, column: column } = position;
        const { withOpenEditor: withOpenEditor } = params;
        if (rowNode) {
            const rowEdits = this.getEditRow(rowNode, params);
            if (!rowEdits) return false;
            if (column) {
                if (withOpenEditor) return this.getEdit(position)?.state === "editing";
                return rowEdits.has(column) ?? false;
            }
            if (rowEdits.size !== 0) {
                if (withOpenEditor) return Array.from(rowEdits.values()).some(({ state: state })=>state === "editing");
                return true;
            }
            return false;
        }
        if (withOpenEditor) return this.getEditPositions().some(({ state: state })=>state === "editing");
        return this.edits.size > 0;
    }
    start(position) {
        const map = this.getEditRow(position.rowNode) ?? /* @__PURE__ */ new Map();
        const { rowNode: rowNode, column: column } = position;
        if (column && !map.has(column)) map.set(column, {
            editorValue: void 0,
            pendingValue: $437b23f6a393c3bf$var$UNEDITED,
            sourceValue: this.beans.valueSvc.getValue(column, rowNode, true, "api"),
            state: "editing"
        });
        this.edits.set(rowNode, map);
    }
    stop(position) {
        if (!this.hasEdits(position)) return;
        if (position) this.removeEdits(position);
        else this.clear();
        return;
    }
    clear() {
        for (const pendingRowEdits of this.edits.values())pendingRowEdits.clear();
        this.edits.clear();
    }
    getCellValidationModel() {
        return this.cellValidations;
    }
    getRowValidationModel() {
        return this.rowValidations;
    }
    setCellValidationModel(model) {
        this.cellValidations = model;
    }
    setRowValidationModel(model) {
        this.rowValidations = model;
    }
    destroy() {
        super.destroy();
        this.clear();
    }
};
var $437b23f6a393c3bf$var$EditCellValidationModel = class {
    constructor(){
        this.cellValidations = /* @__PURE__ */ new Map();
    }
    getCellValidation(position) {
        const { rowNode: rowNode, column: column } = position || {};
        return this.cellValidations?.get(rowNode)?.get(column);
    }
    hasCellValidation(position) {
        if (!position || !position.rowNode || !position.column) return this.cellValidations.size > 0;
        return !!this.getCellValidation(position);
    }
    setCellValidation(position, validation2) {
        const { rowNode: rowNode, column: column } = position;
        if (!this.cellValidations.has(rowNode)) this.cellValidations.set(rowNode, /* @__PURE__ */ new Map());
        this.cellValidations.get(rowNode).set(column, validation2);
    }
    clearCellValidation(position) {
        const { rowNode: rowNode, column: column } = position;
        this.cellValidations.get(rowNode)?.delete(column);
    }
    setCellValidationMap(validationMap) {
        this.cellValidations = validationMap;
    }
    getCellValidationMap() {
        return this.cellValidations;
    }
    clearCellValidationMap() {
        this.cellValidations.clear();
    }
};
var $437b23f6a393c3bf$var$EditRowValidationModel = class {
    constructor(){
        this.rowValidations = /* @__PURE__ */ new Map();
    }
    getRowValidation(position) {
        const { rowNode: rowNode } = position || {};
        return this.rowValidations.get(rowNode);
    }
    hasRowValidation(position) {
        if (!position || !position.rowNode) return this.rowValidations.size > 0;
        return !!this.getRowValidation(position);
    }
    setRowValidation({ rowNode: rowNode }, rowValidation) {
        this.rowValidations.set(rowNode, rowValidation);
    }
    clearRowValidation({ rowNode: rowNode }) {
        this.rowValidations.delete(rowNode);
    }
    setRowValidationMap(validationMap) {
        this.rowValidations = validationMap;
    }
    getRowValidationMap() {
        return this.rowValidations;
    }
    clearRowValidationMap() {
        this.rowValidations.clear();
    }
};
// packages/ag-grid-community/src/entities/positionUtils.ts
function $437b23f6a393c3bf$export$c0c5a5ba9327269f(cellPosition) {
    const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = cellPosition;
    return `${rowIndex}.${rowPinned == null ? "null" : rowPinned}.${column.getId()}`;
}
function $437b23f6a393c3bf$export$be3973033c2c5267(cellA, cellB) {
    const colsMatch = cellA.column === cellB.column;
    const floatingMatch = cellA.rowPinned === cellB.rowPinned;
    const indexMatch = cellA.rowIndex === cellB.rowIndex;
    return colsMatch && floatingMatch && indexMatch;
}
function $437b23f6a393c3bf$export$6cce97428a227a31(rowA, rowB) {
    switch(rowA.rowPinned){
        case "top":
            if (rowB.rowPinned !== "top") return true;
            break;
        case "bottom":
            if (rowB.rowPinned !== "bottom") return false;
            break;
        default:
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(rowB.rowPinned)) return rowB.rowPinned !== "top";
            break;
    }
    return rowA.rowIndex < rowB.rowIndex;
}
function $437b23f6a393c3bf$export$de6f9fa10e9f4188(rowA, rowB) {
    if (!rowA && !rowB) return true;
    if (rowA && !rowB || !rowA && rowB) return false;
    return rowA.rowIndex === rowB.rowIndex && rowA.rowPinned == rowB.rowPinned;
}
function $437b23f6a393c3bf$var$_getFirstRow(beans) {
    let rowIndex = 0;
    let rowPinned;
    const { pinnedRowModel: pinnedRowModel, rowModel: rowModel, pageBounds: pageBounds } = beans;
    if (pinnedRowModel?.getPinnedTopRowCount()) rowPinned = "top";
    else if (rowModel.getRowCount()) {
        rowPinned = null;
        rowIndex = pageBounds.getFirstRow();
    } else if (pinnedRowModel?.getPinnedBottomRowCount()) rowPinned = "bottom";
    return rowPinned === void 0 ? null : {
        rowIndex: rowIndex,
        rowPinned: rowPinned
    };
}
function $437b23f6a393c3bf$export$a1449222017e428(beans) {
    let rowIndex;
    let rowPinned = null;
    const { pinnedRowModel: pinnedRowModel, pageBounds: pageBounds } = beans;
    const pinnedBottomCount = pinnedRowModel?.getPinnedBottomRowCount();
    const pinnedTopCount = pinnedRowModel?.getPinnedTopRowCount();
    if (pinnedBottomCount) {
        rowPinned = "bottom";
        rowIndex = pinnedBottomCount - 1;
    } else if (beans.rowModel.getRowCount()) {
        rowPinned = null;
        rowIndex = pageBounds.getLastRow();
    } else if (pinnedTopCount) {
        rowPinned = "top";
        rowIndex = pinnedTopCount - 1;
    }
    return rowIndex === void 0 ? null : {
        rowIndex: rowIndex,
        rowPinned: rowPinned
    };
}
function $437b23f6a393c3bf$export$d4675a60917db7b0(beans, gridRow) {
    switch(gridRow.rowPinned){
        case "top":
            return beans.pinnedRowModel?.getPinnedTopRow(gridRow.rowIndex);
        case "bottom":
            return beans.pinnedRowModel?.getPinnedBottomRow(gridRow.rowIndex);
        default:
            return beans.rowModel.getRow(gridRow.rowIndex);
    }
}
function $437b23f6a393c3bf$export$1bd7ce47360c3c0(beans, cellPosition) {
    const spannedCellCtrl = beans.spannedRowRenderer?.getCellByPosition(cellPosition);
    if (spannedCellCtrl) return spannedCellCtrl;
    const rowCtrl = beans.rowRenderer.getRowByPosition(cellPosition);
    if (!rowCtrl) return null;
    return rowCtrl.getCellCtrl(cellPosition.column);
}
function $437b23f6a393c3bf$var$_getRowById(beans, rowId, rowPinned) {
    const { rowModel: rm, pinnedRowModel: prm } = beans;
    let node;
    node ?? (node = rm?.getRowNode(rowId));
    if (rowPinned) node ?? (node = prm?.getPinnedRowById(rowId, rowPinned));
    else {
        node ?? (node = prm?.getPinnedRowById(rowId, "top"));
        node ?? (node = prm?.getPinnedRowById(rowId, "bottom"));
    }
    return node;
}
function $437b23f6a393c3bf$export$b36b14fdaf41f4d8(beans, rowPosition) {
    const { rowIndex: index, rowPinned: pinned } = rowPosition;
    const { pageBounds: pageBounds, pinnedRowModel: pinnedRowModel, rowModel: rowModel } = beans;
    if (index === 0) {
        if (pinned === "top") return null;
        if (pinned === "bottom" && rowModel.isRowsToRender()) return {
            rowIndex: pageBounds.getLastRow(),
            rowPinned: null
        };
        return pinnedRowModel?.isRowsToRender("top") ? {
            rowIndex: pinnedRowModel.getPinnedTopRowCount() - 1,
            rowPinned: "top"
        } : null;
    }
    const rowNode = pinned ? void 0 : rowModel.getRow(index);
    return $437b23f6a393c3bf$var$getNextStickyPosition(beans, rowNode, true) ?? {
        rowIndex: index - 1,
        rowPinned: pinned
    };
}
function $437b23f6a393c3bf$export$3077f3bcabdc5ad1(beans, rowPosition) {
    const { rowIndex: index, rowPinned: pinned } = rowPosition;
    const { pageBounds: pageBounds, pinnedRowModel: pinnedRowModel, rowModel: rowModel } = beans;
    if ($437b23f6a393c3bf$var$isLastRowInContainer(beans, rowPosition)) {
        if (pinned === "bottom") return null;
        if (pinned === "top" && rowModel.isRowsToRender()) return {
            rowIndex: pageBounds.getFirstRow(),
            rowPinned: null
        };
        return pinnedRowModel?.isRowsToRender("bottom") ? {
            rowIndex: 0,
            rowPinned: "bottom"
        } : null;
    }
    const rowNode = pinned ? void 0 : rowModel.getRow(index);
    return $437b23f6a393c3bf$var$getNextStickyPosition(beans, rowNode) ?? {
        rowIndex: index + 1,
        rowPinned: pinned
    };
}
function $437b23f6a393c3bf$var$getNextStickyPosition(beans, rowNode, up = false) {
    const { gos: gos, rowRenderer: rowRenderer } = beans;
    if (!rowNode?.sticky || !$437b23f6a393c3bf$export$d5f33aacea6a0849(gos)) return;
    const stickyTopCtrls = rowRenderer.getStickyTopRowCtrls();
    const stickyBottomCtrls = rowRenderer.getStickyBottomRowCtrls();
    const isStickyTop = !stickyBottomCtrls.some((ctrl)=>ctrl.rowNode.rowIndex === rowNode.rowIndex);
    const stickyRowCtrls = isStickyTop ? stickyTopCtrls : stickyBottomCtrls;
    const increment = (up ? -1 : 1) * (isStickyTop ? -1 : 1);
    let nextCtrl;
    for(let i = 0; i < stickyRowCtrls.length; i++)if (stickyRowCtrls[i].rowNode.rowIndex === rowNode.rowIndex) {
        nextCtrl = stickyRowCtrls[i + increment];
        break;
    }
    return nextCtrl ? {
        rowIndex: nextCtrl.rowNode.rowIndex,
        rowPinned: null
    } : void 0;
}
function $437b23f6a393c3bf$var$isLastRowInContainer(beans, rowPosition) {
    const { rowPinned: rowPinned, rowIndex: rowIndex } = rowPosition;
    const { pinnedRowModel: pinnedRowModel, pageBounds: pageBounds } = beans;
    if (rowPinned === "top") {
        const lastTopIndex = (pinnedRowModel?.getPinnedTopRowCount() ?? 0) - 1;
        return lastTopIndex <= rowIndex;
    }
    if (rowPinned === "bottom") {
        const lastBottomIndex = (pinnedRowModel?.getPinnedBottomRowCount() ?? 0) - 1;
        return lastBottomIndex <= rowIndex;
    }
    const lastBodyIndex = pageBounds.getLastRow();
    return lastBodyIndex <= rowIndex;
}
// packages/ag-grid-community/src/edit/utils/controllers.ts
function $437b23f6a393c3bf$var$_getRowCtrl(beans, inputs = {}) {
    const { rowIndex: rowIndex, rowId: rowId, rowCtrl: rowCtrl, rowPinned: rowPinned } = inputs;
    if (rowCtrl) return rowCtrl;
    const { rowModel: rowModel, rowRenderer: rowRenderer } = beans;
    let { rowNode: rowNode } = inputs;
    if (!rowNode) {
        if (rowId) rowNode = $437b23f6a393c3bf$var$_getRowById(beans, rowId, rowPinned);
        else if (rowIndex != null) rowNode = rowModel.getRow(rowIndex);
    }
    return rowRenderer.getRowCtrls(rowNode ? [
        rowNode
    ] : [])?.[0];
}
function $437b23f6a393c3bf$var$_getCellCtrl(beans, inputs = {}) {
    const { cellCtrl: cellCtrl, colId: colId, columnId: columnId, column: column } = inputs;
    if (cellCtrl) return cellCtrl;
    const actualColumn = beans.colModel.getCol(colId ?? columnId ?? $437b23f6a393c3bf$var$_getColId(column));
    const rowCtrl = inputs.rowCtrl ?? $437b23f6a393c3bf$var$_getRowCtrl(beans, inputs);
    const result = rowCtrl?.getCellCtrl(actualColumn) ?? void 0;
    if (result) return result;
    const rowNode = inputs.rowNode ?? rowCtrl?.rowNode;
    if (rowNode) return beans.rowRenderer.getCellCtrls([
        rowNode
    ], [
        actualColumn
    ])?.[0];
    return void 0;
}
function $437b23f6a393c3bf$var$_stopEditing(beans) {
    const { editSvc: editSvc } = beans;
    if (editSvc?.isBatchEditing()) $437b23f6a393c3bf$var$_destroyEditors(beans);
    else editSvc?.stopEditing(void 0, {
        source: "api"
    });
}
function $437b23f6a393c3bf$var$_addStopEditingWhenGridLosesFocus(bean, beans, viewports) {
    const { gos: gos, popupSvc: popupSvc } = beans;
    if (!gos.get("stopEditingWhenCellsLoseFocus")) return;
    const focusOutListener = (event)=>{
        const elementWithFocus = event.relatedTarget;
        if ($437b23f6a393c3bf$var$_getTabIndex(elementWithFocus) === null) {
            $437b23f6a393c3bf$var$_stopEditing(beans);
            return;
        }
        let clickInsideGrid = // see if click came from inside the viewports
        viewports.some((viewport)=>viewport.contains(elementWithFocus)) && // and also that it's not from a detail grid
        $437b23f6a393c3bf$var$_isElementInThisGrid(gos, elementWithFocus);
        if (!clickInsideGrid) clickInsideGrid = !!popupSvc && (popupSvc.getActivePopups().some((popup)=>popup.contains(elementWithFocus)) || popupSvc.isElementWithinCustomPopup(elementWithFocus));
        if (!clickInsideGrid) $437b23f6a393c3bf$var$_stopEditing(beans);
    };
    viewports.forEach((viewport)=>bean.addManagedElementListeners(viewport, {
            focusout: focusOutListener
        }));
}
function $437b23f6a393c3bf$var$_getColId(column) {
    if (!column) return void 0;
    if (typeof column === "string") return column;
    return column.getColId();
}
// packages/ag-grid-community/src/edit/utils/editors.ts
var $437b23f6a393c3bf$var$UNEDITED = Symbol("unedited");
function $437b23f6a393c3bf$var$getCellEditorInstanceMap(beans, params = {}) {
    const res = [];
    const ctrls = beans.rowRenderer.getCellCtrls(params.rowNodes, params.columns);
    for (const ctrl of ctrls){
        const cellEditor = ctrl.comp?.getCellEditor();
        if (cellEditor) res.push({
            ctrl: ctrl,
            editor: $437b23f6a393c3bf$export$213d4c63c3df47e4(cellEditor)
        });
    }
    return res;
}
var $437b23f6a393c3bf$var$getCellEditorInstances = (beans, params = {})=>$437b23f6a393c3bf$var$getCellEditorInstanceMap(beans, params).map((res)=>res.editor);
function $437b23f6a393c3bf$var$_setupEditors(beans, editingCells, position, key, event, cellStartedEdit) {
    if (editingCells.length === 0 && position?.rowNode && position?.column) $437b23f6a393c3bf$var$_setupEditor(beans, position, {
        key: key,
        event: event,
        cellStartedEdit: cellStartedEdit
    });
    const { valueSvc: valueSvc, editSvc: editSvc, editModelSvc: editModelSvc } = beans;
    const { rowNode: rowNode, column: column } = position ?? {};
    for (const cellPosition of editingCells){
        const { rowNode: cellRowNode, column: cellColumn } = cellPosition;
        const curCellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, cellPosition);
        if (!curCellCtrl) {
            if (cellRowNode && cellColumn) {
                const oldValue = valueSvc.getValue(cellColumn, cellRowNode, void 0, "api");
                const isNewValueCell = position?.rowNode === cellRowNode && position?.column === cellColumn;
                const cellStartValue = isNewValueCell && key || void 0;
                const newValue = cellStartValue ?? editSvc?.getCellDataValue(cellPosition, false) ?? valueSvc.getValueForDisplay(cellColumn, cellRowNode)?.value ?? oldValue ?? $437b23f6a393c3bf$var$UNEDITED;
                editModelSvc?.setEdit(cellPosition, {
                    pendingValue: newValue,
                    sourceValue: oldValue,
                    state: "editing"
                });
            }
            continue;
        }
        const shouldStartEditing = cellStartedEdit && rowNode === curCellCtrl.rowNode && curCellCtrl.column === column;
        $437b23f6a393c3bf$var$_setupEditor(beans, {
            rowNode: rowNode,
            column: curCellCtrl.column
        }, {
            key: shouldStartEditing ? key : null,
            event: shouldStartEditing ? event : null,
            cellStartedEdit: shouldStartEditing && cellStartedEdit
        });
    }
    return;
}
function $437b23f6a393c3bf$var$_sourceAndPendingDiffer({ pendingValue: pendingValue, sourceValue: sourceValue }) {
    if (pendingValue === $437b23f6a393c3bf$var$UNEDITED) pendingValue = sourceValue;
    return pendingValue !== sourceValue;
}
function $437b23f6a393c3bf$var$_setupEditor(beans, position, params) {
    const { key: key, event: event, cellStartedEdit: cellStartedEdit, silent: silent } = params ?? {};
    const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, position);
    const editorComp = cellCtrl?.comp?.getCellEditor();
    const editorParams = $437b23f6a393c3bf$var$_createEditorParams(beans, position, key, cellStartedEdit && !silent);
    const previousEdit = beans.editModelSvc?.getEdit(position);
    let newValue = editorParams.value;
    if (newValue === void 0) newValue = previousEdit?.sourceValue;
    beans.editModelSvc?.setEdit(position, {
        editorValue: newValue,
        state: "editing"
    });
    if (editorComp) {
        editorComp.refresh?.(editorParams);
        return;
    }
    const colDef = position.column.getColDef();
    const compDetails = $437b23f6a393c3bf$var$_getCellEditorDetails(beans.userCompFactory, colDef, editorParams);
    const popup = compDetails?.popupFromSelector != null ? compDetails.popupFromSelector : !!colDef.cellEditorPopup;
    const popupLocation = compDetails?.popupPositionFromSelector != null ? compDetails.popupPositionFromSelector : colDef.cellEditorPopupPosition;
    $437b23f6a393c3bf$var$checkAndPreventDefault(compDetails.params, event);
    if (cellCtrl) {
        cellCtrl.editCompDetails = compDetails;
        cellCtrl.comp?.setEditDetails(compDetails, popup, popupLocation, beans.gos.get("reactiveCustomComponents"));
        cellCtrl?.rowCtrl?.refreshRow({
            suppressFlash: true
        });
        if (!silent) beans.editSvc?.dispatchCellEvent(position, event, "cellEditingStarted");
    }
    return;
}
function $437b23f6a393c3bf$var$_valueFromEditor(cellEditor) {
    const noValueResult = {
        editorValueExists: false
    };
    const validationErrors = cellEditor.getValidationErrors?.();
    if ((validationErrors?.length ?? 0) > 0) return noValueResult;
    const editorValue = cellEditor.getValue();
    return {
        editorValue: editorValue,
        editorValueExists: true
    };
}
function $437b23f6a393c3bf$var$_createEditorParams(beans, position, key, cellStartedEdit) {
    const { valueSvc: valueSvc, gos: gos, editSvc: editSvc } = beans;
    const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, position);
    const rowIndex = position.rowNode?.rowIndex ?? void 0;
    const batchEdit = editSvc?.isBatchEditing();
    const agColumn = beans.colModel.getCol(position.column.getId());
    const { rowNode: rowNode, column: column } = position;
    const editor = cellCtrl.comp?.getCellEditor();
    const initialNewValue = editSvc?.getCellDataValue(position, false) ?? (editor ? $437b23f6a393c3bf$var$_valueFromEditor(editor)?.editorValue : void 0);
    const value = initialNewValue === $437b23f6a393c3bf$var$UNEDITED ? valueSvc.getValueForDisplay(agColumn, rowNode)?.value : initialNewValue;
    return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        value: value,
        eventKey: key ?? null,
        column: column,
        colDef: column.getColDef(),
        rowIndex: rowIndex,
        node: rowNode,
        data: rowNode.data,
        cellStartedEdit: cellStartedEdit ?? false,
        onKeyDown: cellCtrl?.onKeyDown.bind(cellCtrl),
        stopEditing: (suppressNavigateAfterEdit)=>{
            editSvc.stopEditing(position, {
                source: batchEdit ? "ui" : "api",
                suppressNavigateAfterEdit: suppressNavigateAfterEdit
            });
            $437b23f6a393c3bf$var$_destroyEditor(beans, position);
        },
        eGridCell: cellCtrl?.eGui,
        parseValue: (newValue)=>valueSvc.parseValue(agColumn, rowNode, newValue, cellCtrl?.value),
        formatValue: cellCtrl?.formatValue.bind(cellCtrl),
        validate: ()=>{
            editSvc?.validateEdit();
        }
    });
}
function $437b23f6a393c3bf$var$_purgeUnchangedEdits(beans, includeEditing) {
    const { editModelSvc: editModelSvc } = beans;
    editModelSvc?.getEditMap().forEach((editRow, rowNode)=>{
        editRow.forEach((edit, column)=>{
            if (!includeEditing && (edit.state === "editing" || edit.pendingValue === $437b23f6a393c3bf$var$UNEDITED)) return;
            if (!$437b23f6a393c3bf$var$_sourceAndPendingDiffer(edit) && (edit.state !== "editing" || includeEditing)) editModelSvc?.removeEdits({
                rowNode: rowNode,
                column: column
            });
        });
    });
}
function $437b23f6a393c3bf$var$_refreshEditorOnColDefChanged(beans, cellCtrl) {
    const editor = cellCtrl.comp?.getCellEditor();
    if (!editor?.refresh) return;
    const { eventKey: eventKey, cellStartedEdit: cellStartedEdit } = cellCtrl.editCompDetails.params;
    const { column: column } = cellCtrl;
    const editorParams = $437b23f6a393c3bf$var$_createEditorParams(beans, cellCtrl, eventKey, cellStartedEdit);
    const colDef = column.getColDef();
    const compDetails = $437b23f6a393c3bf$var$_getCellEditorDetails(beans.userCompFactory, colDef, editorParams);
    editor.refresh($437b23f6a393c3bf$var$checkAndPreventDefault(compDetails.params, eventKey));
}
function $437b23f6a393c3bf$var$checkAndPreventDefault(params, event) {
    if (event instanceof KeyboardEvent && params.column.getColDef().cellEditor === "agNumberCellEditor") params.suppressPreventDefault = [
        "-",
        "+",
        ".",
        "e"
    ].includes(event?.key ?? "") || params.suppressPreventDefault;
    else event?.preventDefault?.();
    return params;
}
function $437b23f6a393c3bf$var$_syncFromEditors(beans, persist) {
    beans.editModelSvc?.getEditPositions().forEach((cellId)=>{
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, cellId);
        if (!cellCtrl) return;
        const editor = cellCtrl.comp?.getCellEditor();
        if (!editor) return;
        const { editorValue: editorValue, editorValueExists: editorValueExists } = $437b23f6a393c3bf$var$_valueFromEditor(editor);
        $437b23f6a393c3bf$var$_syncFromEditor(beans, cellId, persist, editorValue, void 0, !editorValueExists);
    });
}
function $437b23f6a393c3bf$var$_syncFromEditor(beans, position, persist, editorValue, _source, valueSameAsSource) {
    const { editModelSvc: editModelSvc, valueSvc: valueSvc } = beans;
    if (!editModelSvc) return;
    const { rowNode: rowNode, column: column } = position;
    if (!(rowNode && column)) return;
    const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, position);
    const hasEditor = !!cellCtrl?.comp?.getCellEditor();
    let edit = editModelSvc.getEdit(position, true);
    if (!edit?.sourceValue) edit = editModelSvc.setEdit(position, {
        sourceValue: valueSvc.getValue(column, rowNode, void 0, "api"),
        pendingValue: $437b23f6a393c3bf$var$UNEDITED,
        state: hasEditor ? "editing" : "changed"
    });
    editModelSvc.setEdit(position, {
        editorValue: valueSameAsSource ? edit.sourceValue : editorValue,
        state: hasEditor ? "editing" : "changed"
    });
    if (persist) $437b23f6a393c3bf$var$_persistEditorValue(beans, position);
}
function $437b23f6a393c3bf$var$_persistEditorValue(beans, position) {
    const { editModelSvc: editModelSvc } = beans;
    const edit = editModelSvc?.getEdit(position, true);
    editModelSvc?.setEdit(position, {
        pendingValue: edit?.editorValue
    });
}
function $437b23f6a393c3bf$var$_destroyEditors(beans, edits, params) {
    if (!edits) edits = beans.editModelSvc?.getEditPositions();
    edits.forEach((cellPosition)=>$437b23f6a393c3bf$var$_destroyEditor(beans, cellPosition, params));
}
function $437b23f6a393c3bf$var$_destroyEditor(beans, position, params) {
    const { editSvc: editSvc, editModelSvc: editModelSvc } = beans;
    const { rowNode: rowNode, column: column } = position;
    const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, position);
    if (!cellCtrl) {
        if (editModelSvc?.hasEdits(position) && rowNode && column) editModelSvc?.setEdit(position, {
            state: "changed"
        });
        return;
    }
    const { comp: comp } = cellCtrl;
    if (comp && !comp.getCellEditor()) {
        cellCtrl?.refreshCell();
        return;
    }
    const errorMessages = comp?.getCellEditor()?.getValidationErrors?.();
    const cellValidationModel = editModelSvc?.getCellValidationModel();
    if (errorMessages?.length) cellValidationModel?.setCellValidation(position, {
        errorMessages: errorMessages
    });
    else cellValidationModel?.clearCellValidation(position);
    if (editModelSvc?.getEdit(position)) editModelSvc?.setEdit(position, {
        state: "changed"
    });
    comp?.setEditDetails();
    comp?.refreshEditStyles(false, false);
    cellCtrl?.refreshCell({
        force: true,
        suppressFlash: true
    });
    const latest = editModelSvc?.getEdit(position);
    if (latest?.state === "changed" && !params?.silent) editSvc?.dispatchCellEvent(position, params?.event, "cellEditingStopped", {
        valueChanged: $437b23f6a393c3bf$var$_sourceAndPendingDiffer(latest),
        newValue: latest?.pendingValue,
        oldValue: latest?.sourceValue
    });
}
function $437b23f6a393c3bf$var$_populateModelValidationErrors(beans) {
    const mappedEditors = $437b23f6a393c3bf$var$getCellEditorInstanceMap(beans);
    const cellValidationModel = new $437b23f6a393c3bf$var$EditCellValidationModel();
    const { ariaAnnounce: ariaAnnounce, localeSvc: localeSvc, editModelSvc: editModelSvc, gos: gos } = beans;
    const includeRows = gos.get("editType") === "fullRow";
    const translate = $437b23f6a393c3bf$export$cc0bf4adff5b95e7(localeSvc);
    const ariaValidationErrorPrefix = translate("ariaValidationErrorPrefix", "Cell Editor Validation");
    for (const mappedEditor of mappedEditors){
        const { ctrl: ctrl, editor: editor } = mappedEditor;
        const { rowNode: rowNode, column: column } = ctrl;
        const errorMessages = editor.getValidationErrors?.() ?? [];
        const el = editor.getValidationElement?.(false) || !editor.isPopup?.() && ctrl.eGui;
        if (el) {
            const isInvalid = errorMessages != null && errorMessages.length > 0;
            const invalidMessage = isInvalid ? errorMessages.join(". ") : "";
            $437b23f6a393c3bf$export$fd1450327e6900f2(el, isInvalid);
            if (isInvalid) ariaAnnounce.announceValue(`${ariaValidationErrorPrefix} ${errorMessages}`, "editorValidation");
            if (el instanceof HTMLInputElement) el.setCustomValidity(invalidMessage);
            else el.classList.toggle("invalid", isInvalid);
        }
        if (errorMessages?.length > 0) cellValidationModel.setCellValidation({
            rowNode: rowNode,
            column: column
        }, {
            errorMessages: errorMessages
        });
    }
    $437b23f6a393c3bf$var$_syncFromEditors(beans, false);
    editModelSvc?.setCellValidationModel(cellValidationModel);
    const rowCtrlSet = /* @__PURE__ */ new Set();
    for (const { ctrl: ctrl } of mappedEditors)rowCtrlSet.add(ctrl.rowCtrl);
    if (includeRows) {
        const rowValidations = $437b23f6a393c3bf$var$_generateRowValidationErrors(beans);
        editModelSvc?.setRowValidationModel(rowValidations);
    }
    for (const rowCtrl of rowCtrlSet.values()){
        rowCtrl.rowEditStyleFeature?.applyRowStyles();
        for (const cellCtrl of rowCtrl.getAllCellCtrls()){
            cellCtrl.tooltipFeature?.refreshTooltip(true);
            cellCtrl.editorTooltipFeature?.refreshTooltip(true);
            cellCtrl.editStyleFeature?.applyCellStyles?.();
        }
    }
}
var $437b23f6a393c3bf$var$_generateRowValidationErrors = (beans)=>{
    const rowValidationModel = new $437b23f6a393c3bf$var$EditRowValidationModel();
    const getFullRowEditValidationErrors = beans.gos.get("getFullRowEditValidationErrors");
    const editMap = beans.editModelSvc?.getEditMap();
    if (!editMap) return rowValidationModel;
    for (const rowNode of editMap.keys()){
        const rowEditMap = editMap.get(rowNode);
        if (!rowEditMap) continue;
        const editorsState = [];
        const { rowIndex: rowIndex, rowPinned: rowPinned } = rowNode;
        for (const column of rowEditMap.keys()){
            const editValue = rowEditMap.get(column);
            if (!editValue) continue;
            const { editorValue: editorValue, pendingValue: pendingValue, sourceValue: sourceValue } = editValue;
            const newValue = editorValue ?? (pendingValue === $437b23f6a393c3bf$var$UNEDITED ? void 0 : pendingValue) ?? sourceValue;
            editorsState.push({
                column: column,
                colId: column.getColId(),
                rowIndex: rowIndex,
                rowPinned: rowPinned,
                oldValue: sourceValue,
                newValue: newValue
            });
        }
        const errorMessages = getFullRowEditValidationErrors?.({
            editorsState: editorsState
        }) ?? [];
        if (errorMessages.length > 0) rowValidationModel.setRowValidation({
            rowNode: rowNode
        }, {
            errorMessages: errorMessages
        });
    }
    return rowValidationModel;
};
function $437b23f6a393c3bf$var$_validateEdit(beans) {
    $437b23f6a393c3bf$var$_populateModelValidationErrors(beans);
    const map = beans.editModelSvc?.getCellValidationModel().getCellValidationMap();
    if (!map) return null;
    const validations = [];
    map.forEach((rowValidations, rowNode)=>{
        rowValidations.forEach(({ errorMessages: errorMessages }, column)=>{
            validations.push({
                column: column,
                rowIndex: rowNode.rowIndex,
                rowPinned: rowNode.rowPinned,
                messages: errorMessages ?? null
            });
        });
    });
    return validations;
}
// packages/ag-grid-community/src/headerRendering/cells/cssClassApplier.ts
var $437b23f6a393c3bf$var$CSS_FIRST_COLUMN = "ag-column-first";
var $437b23f6a393c3bf$var$CSS_LAST_COLUMN = "ag-column-last";
function $437b23f6a393c3bf$export$9ba3bd48c77c5e8a(abstractColDef, gos, column, columnGroup) {
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(abstractColDef)) return [];
    return $437b23f6a393c3bf$var$getColumnClassesFromCollDef(abstractColDef.headerClass, abstractColDef, gos, column, columnGroup);
}
function $437b23f6a393c3bf$export$1784132bab54c462(abstractColDef, gos, column, columnGroup) {
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(abstractColDef)) return [];
    return $437b23f6a393c3bf$var$getColumnClassesFromCollDef(abstractColDef.toolPanelClass, abstractColDef, gos, column, columnGroup);
}
function $437b23f6a393c3bf$var$refreshFirstAndLastStyles(comp, column, presentedColsService) {
    comp.toggleCss($437b23f6a393c3bf$var$CSS_FIRST_COLUMN, presentedColsService.isColAtEdge(column, "first"));
    comp.toggleCss($437b23f6a393c3bf$var$CSS_LAST_COLUMN, presentedColsService.isColAtEdge(column, "last"));
}
function $437b23f6a393c3bf$var$getClassParams(abstractColDef, gos, column, columnGroup) {
    return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        // bad naming, as colDef here can be a group or a column,
        // however most people won't appreciate the difference,
        // so keeping it as colDef to avoid confusion.
        colDef: abstractColDef,
        column: column,
        columnGroup: columnGroup
    });
}
function $437b23f6a393c3bf$var$getColumnClassesFromCollDef(classesOrFunc, abstractColDef, gos, column, columnGroup) {
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(classesOrFunc)) return [];
    let classToUse;
    if (typeof classesOrFunc === "function") {
        const params = $437b23f6a393c3bf$var$getClassParams(abstractColDef, gos, column, columnGroup);
        classToUse = classesOrFunc(params);
    } else classToUse = classesOrFunc;
    if (typeof classToUse === "string") return [
        classToUse
    ];
    if (Array.isArray(classToUse)) return [
        ...classToUse
    ];
    return [];
}
// packages/ag-grid-community/src/pinnedRowModel/pinnedRowUtils.ts
function $437b23f6a393c3bf$var$_isManualPinnedRow(rowNode) {
    return !!(rowNode.rowPinned && rowNode.pinnedSibling);
}
function $437b23f6a393c3bf$var$_getNodesInRangeForSelection(rowModel, float, start, end) {
    const isTop = float === "top";
    if (!start) return $437b23f6a393c3bf$var$_getNodesInRangeForSelection(rowModel, float, isTop ? rowModel.getPinnedTopRow(0) : rowModel.getPinnedBottomRow(0), end);
    if (!end) {
        const count = isTop ? rowModel.getPinnedTopRowCount() : rowModel.getPinnedBottomRowCount();
        return $437b23f6a393c3bf$var$_getNodesInRangeForSelection(rowModel, float, start, isTop ? rowModel.getPinnedTopRow(count - 1) : rowModel.getPinnedBottomRow(count - 1));
    }
    let started = false;
    let finished = false;
    const range = [];
    rowModel.forEachPinnedRow(float, (node)=>{
        if (node === start && !started) {
            started = true;
            range.push(node);
            return;
        }
        if (started && node === end) {
            finished = true;
            range.push(node);
            return;
        }
        if (started && !finished) range.push(node);
    });
    return range;
}
// packages/ag-grid-community/src/constants/keyCode.ts
var $437b23f6a393c3bf$export$e9e0d96f49f57c33 = {
    BACKSPACE: "Backspace",
    TAB: "Tab",
    ENTER: "Enter",
    ESCAPE: "Escape",
    SPACE: " ",
    LEFT: "ArrowLeft",
    UP: "ArrowUp",
    RIGHT: "ArrowRight",
    DOWN: "ArrowDown",
    DELETE: "Delete",
    F2: "F2",
    PAGE_UP: "PageUp",
    PAGE_DOWN: "PageDown",
    PAGE_HOME: "Home",
    PAGE_END: "End",
    // these should be used with `event.code` instead of `event.key`
    // as `event.key` changes when non-latin keyboards are used
    A: "KeyA",
    C: "KeyC",
    D: "KeyD",
    V: "KeyV",
    X: "KeyX",
    Y: "KeyY",
    Z: "KeyZ"
};
// packages/ag-grid-community/src/utils/focus.ts
var $437b23f6a393c3bf$var$keyboardModeActive = false;
var $437b23f6a393c3bf$var$instanceCount = 0;
function $437b23f6a393c3bf$var$addKeyboardModeEvents(doc) {
    if ($437b23f6a393c3bf$var$instanceCount > 0) return;
    doc.addEventListener("keydown", $437b23f6a393c3bf$var$toggleKeyboardMode);
    doc.addEventListener("mousedown", $437b23f6a393c3bf$var$toggleKeyboardMode);
}
function $437b23f6a393c3bf$var$removeKeyboardModeEvents(doc) {
    if ($437b23f6a393c3bf$var$instanceCount > 0) return;
    doc.removeEventListener("keydown", $437b23f6a393c3bf$var$toggleKeyboardMode);
    doc.removeEventListener("mousedown", $437b23f6a393c3bf$var$toggleKeyboardMode);
}
function $437b23f6a393c3bf$var$toggleKeyboardMode(event) {
    const isKeyboardActive = $437b23f6a393c3bf$var$keyboardModeActive;
    const isKeyboardEvent = event.type === "keydown";
    if (isKeyboardEvent) {
        if (event.ctrlKey || event.metaKey || event.altKey) return;
    }
    if (isKeyboardActive === isKeyboardEvent) return;
    $437b23f6a393c3bf$var$keyboardModeActive = isKeyboardEvent;
}
function $437b23f6a393c3bf$var$_registerKeyboardFocusEvents(beans) {
    const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
    $437b23f6a393c3bf$var$addKeyboardModeEvents(eDocument);
    $437b23f6a393c3bf$var$instanceCount++;
    return ()=>{
        $437b23f6a393c3bf$var$instanceCount--;
        $437b23f6a393c3bf$var$removeKeyboardModeEvents(eDocument);
    };
}
function $437b23f6a393c3bf$export$e4c8c227337b7f23() {
    return $437b23f6a393c3bf$var$keyboardModeActive;
}
function $437b23f6a393c3bf$export$8865b8c867776648(beans, comp, eGui) {
    comp.addManagedElementListeners(eGui, {
        keydown: (e)=>{
            if (!e.defaultPrevented && e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) {
                const backwards = e.shiftKey;
                if (!$437b23f6a393c3bf$export$83fc12531358bd28(beans, eGui, false, backwards)) {
                    if ($437b23f6a393c3bf$export$987f3c95dc941f0c(beans, backwards)) e.preventDefault();
                }
            }
        }
    });
}
function $437b23f6a393c3bf$export$7acf44f59625b1f6(rootNode, exclude, onlyUnmanaged = false) {
    const focusableString = $437b23f6a393c3bf$var$FOCUSABLE_SELECTOR;
    let excludeString = $437b23f6a393c3bf$var$FOCUSABLE_EXCLUDE;
    if (exclude) excludeString += ", " + exclude;
    if (onlyUnmanaged) excludeString += ', [tabindex="-1"]';
    const nodes = Array.prototype.slice.apply(rootNode.querySelectorAll(focusableString)).filter((node)=>{
        return $437b23f6a393c3bf$export$2badf4aa566524cb(node);
    });
    const excludeNodes = Array.prototype.slice.apply(rootNode.querySelectorAll(excludeString));
    if (!excludeNodes.length) return nodes;
    const diff = (a, b)=>a.filter((element)=>b.indexOf(element) === -1);
    return diff(nodes, excludeNodes);
}
function $437b23f6a393c3bf$export$8598088d375f416f(rootNode, up = false, onlyUnmanaged = false, excludeTabGuards = false) {
    const focusableElements = $437b23f6a393c3bf$export$7acf44f59625b1f6(rootNode, excludeTabGuards ? ".ag-tab-guard" : null, onlyUnmanaged);
    const toFocus = up ? $437b23f6a393c3bf$export$236389741107357f(focusableElements) : focusableElements[0];
    if (toFocus) {
        toFocus.focus({
            preventScroll: true
        });
        return true;
    }
    return false;
}
function $437b23f6a393c3bf$export$83fc12531358bd28(beans, rootNode, onlyManaged, backwards) {
    const focusable = $437b23f6a393c3bf$export$7acf44f59625b1f6(rootNode, onlyManaged ? ':not([tabindex="-1"])' : null);
    const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(beans);
    let currentIndex;
    if (onlyManaged) currentIndex = focusable.findIndex((el)=>el.contains(activeEl));
    else currentIndex = focusable.indexOf(activeEl);
    const nextIndex = currentIndex + (backwards ? -1 : 1);
    if (nextIndex < 0 || nextIndex >= focusable.length) return null;
    return focusable[nextIndex];
}
function $437b23f6a393c3bf$export$c4c49c776025d475(node, limit = 5) {
    let counter = 0;
    while(node && $437b23f6a393c3bf$var$_getTabIndex(node) === null && ++counter <= limit)node = node.parentElement;
    if ($437b23f6a393c3bf$var$_getTabIndex(node) === null) return null;
    return node;
}
function $437b23f6a393c3bf$export$b3beea4db79d8bb3(beans, fromBottom) {
    return beans.ctrlsSvc.get("gridCtrl").focusInnerElement(fromBottom);
}
function $437b23f6a393c3bf$var$_isHeaderFocusSuppressed(beans) {
    return beans.gos.get("suppressHeaderFocus") || !!beans.overlays?.isExclusive();
}
function $437b23f6a393c3bf$var$_isCellFocusSuppressed(beans) {
    return beans.gos.get("suppressCellFocus") || !!beans.overlays?.isExclusive();
}
function $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, backwards, forceOut = false) {
    const gridCtrl = beans.ctrlsSvc.get("gridCtrl");
    if (!forceOut && gridCtrl.focusNextInnerContainer(backwards)) return true;
    if (forceOut || !backwards && !gridCtrl.isDetailGrid()) gridCtrl.forceFocusOutOfContainer(backwards);
    return false;
}
// packages/ag-grid-community/src/rendering/cell/cellEvent.ts
function $437b23f6a393c3bf$var$_createCellEvent(beans, domEvent, eventType, { rowNode: rowNode, column: column }, value) {
    const event = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(beans.gos, {
        type: eventType,
        node: rowNode,
        data: rowNode.data,
        value: value,
        column: column,
        colDef: column.getColDef(),
        rowPinned: rowNode.rowPinned,
        event: domEvent,
        rowIndex: rowNode.rowIndex
    });
    return event;
}
// packages/ag-grid-community/src/rendering/cell/cellKeyboardListenerFeature.ts
function $437b23f6a393c3bf$var$_isDeleteKey(key, alwaysReturnFalseOnBackspace = false) {
    if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE) return true;
    if (!alwaysReturnFalseOnBackspace && key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE) return $437b23f6a393c3bf$var$_isMacOsUserAgent();
    return false;
}
var $437b23f6a393c3bf$var$CellKeyboardListenerFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans, rowNode, rowCtrl){
        super();
        this.cellCtrl = cellCtrl;
        this.rowNode = rowNode;
        this.rowCtrl = rowCtrl;
        this.beans = beans;
    }
    init() {
        this.eGui = this.cellCtrl.eGui;
    }
    onKeyDown(event) {
        const key = event.key;
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                this.onEnterKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2:
                this.onF2KeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                this.onEscapeKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB:
                this.onTabKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE:
                this.onBackspaceOrDeleteKeyDown(key, event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                this.onNavigationKeyDown(event, key);
                break;
        }
    }
    onNavigationKeyDown(event, key) {
        const { cellCtrl: cellCtrl, beans: beans } = this;
        if (beans.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) return;
        if (event.shiftKey && cellCtrl.isRangeSelectionEnabled()) this.onShiftRangeSelect(event);
        else {
            const currentCellPosition = cellCtrl.getFocusedCellPosition();
            beans.navigation?.navigateToNextCell(event, key, currentCellPosition, true);
        }
        event.preventDefault();
    }
    onShiftRangeSelect(event) {
        const { rangeSvc: rangeSvc, navigation: navigation } = this.beans;
        if (!rangeSvc) return;
        const endCell = rangeSvc.extendLatestRangeInDirection(event);
        if (!endCell) return;
        if (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT || event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT) navigation?.ensureColumnVisible(endCell.column);
        else navigation?.ensureRowVisible(endCell.rowIndex);
    }
    onTabKeyDown(event) {
        this.beans.navigation?.onTabKeyDown(this.cellCtrl, event);
    }
    onBackspaceOrDeleteKeyDown(key, event) {
        const { cellCtrl: cellCtrl, beans: beans, rowNode: rowNode } = this;
        const { gos: gos, rangeSvc: rangeSvc, eventSvc: eventSvc, editSvc: editSvc } = beans;
        eventSvc.dispatchEvent({
            type: "keyShortcutChangedCellStart"
        });
        if ($437b23f6a393c3bf$var$_isDeleteKey(key, gos.get("enableCellEditingOnBackspace")) && !editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) {
            if (rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(gos)) rangeSvc.clearCellRangeCellValues({
                dispatchWrapperEvents: true,
                wrapperEventSource: "deleteKey"
            });
            else if (cellCtrl.isCellEditable()) {
                const { column: column } = cellCtrl;
                const emptyValue = this.beans.valueSvc.getDeleteValue(column, rowNode);
                rowNode.setDataValue(column, emptyValue, "cellClear");
            }
        } else if (!editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) beans.editSvc?.startEditing(cellCtrl, {
            startedEdit: true,
            event: event
        });
        eventSvc.dispatchEvent({
            type: "keyShortcutChangedCellEnd"
        });
    }
    onEnterKeyDown(event) {
        const { cellCtrl: cellCtrl, beans: beans } = this;
        const { editSvc: editSvc, navigation: navigation } = beans;
        const cellEditing = editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        });
        const rowNode = cellCtrl.rowNode;
        const rowEditing = editSvc?.isRowEditing(rowNode, {
            withOpenEditor: true
        });
        const startEditingAction = (cellCtrl2)=>{
            const started = editSvc?.startEditing(cellCtrl2, {
                startedEdit: true,
                event: event,
                source: "edit"
            });
            if (started) event.preventDefault();
        };
        if (cellEditing || rowEditing) {
            if (this.isCtrlEnter(event)) {
                editSvc?.applyBulkEdit(cellCtrl, beans?.rangeSvc?.getCellRanges() || []);
                return;
            }
            $437b23f6a393c3bf$var$_populateModelValidationErrors(beans);
            if (editSvc?.checkNavWithValidation(void 0, event) === "block-stop") return;
            if (editSvc?.isEditing(cellCtrl, {
                withOpenEditor: true
            })) editSvc?.stopEditing(cellCtrl, {
                event: event,
                source: "edit"
            });
            else if (rowEditing && !cellCtrl.isCellEditable()) editSvc?.stopEditing({
                rowNode: rowNode
            }, {
                event: event,
                source: "edit"
            });
            else startEditingAction(cellCtrl);
        } else if (beans.gos.get("enterNavigatesVertically")) {
            const key = event.shiftKey ? $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP : $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
            navigation?.navigateToNextCell(null, key, cellCtrl.cellPosition, false);
        } else {
            if (editSvc?.hasValidationErrors()) return;
            if (editSvc?.hasValidationErrors(cellCtrl)) editSvc.revertSingleCellEdit(cellCtrl, true);
            startEditingAction(cellCtrl);
        }
    }
    isCtrlEnter(e) {
        return (e.ctrlKey || e.metaKey) && e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER;
    }
    onF2KeyDown(event) {
        const { cellCtrl: cellCtrl, beans: { editSvc: editSvc } } = this;
        const editing = editSvc?.isEditing();
        if (editing) {
            $437b23f6a393c3bf$var$_populateModelValidationErrors(this.beans);
            if (editSvc?.checkNavWithValidation(void 0, event) === "block-stop") return;
        }
        editSvc?.startEditing(cellCtrl, {
            startedEdit: true,
            event: event
        });
    }
    onEscapeKeyDown(event) {
        const { cellCtrl: cellCtrl, beans: { editSvc: editSvc } } = this;
        if (editSvc?.checkNavWithValidation(cellCtrl, event) === "block-stop") editSvc.revertSingleCellEdit(cellCtrl);
        editSvc?.stopEditing(cellCtrl, {
            event: event,
            cancel: true
        });
    }
    processCharacter(event) {
        const eventTarget = event.target;
        const eventOnChildComponent = eventTarget !== this.eGui;
        const { beans: { editSvc: editSvc }, cellCtrl: cellCtrl } = this;
        if (eventOnChildComponent) return;
        if (editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) return;
        const key = event.key;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) this.onSpaceKeyDown(event);
        else if (editSvc?.isCellEditable(cellCtrl, "ui")) {
            if (editSvc?.hasValidationErrors() && !editSvc?.hasValidationErrors(cellCtrl)) return;
            editSvc?.startEditing(cellCtrl, {
                startedEdit: true,
                event: event,
                source: "api"
            });
            const compDetails = cellCtrl.editCompDetails;
            const shouldPreventDefault = !compDetails?.params?.suppressPreventDefault;
            if (shouldPreventDefault) event.preventDefault();
        }
    }
    onSpaceKeyDown(event) {
        const { gos: gos, editSvc: editSvc } = this.beans;
        const { rowNode: rowNode } = this.cellCtrl;
        if (!editSvc?.isEditing(this.cellCtrl, {
            withOpenEditor: true
        }) && $437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos)) this.beans.selectionSvc?.handleSelectionEvent(event, rowNode, "spaceKey");
        event.preventDefault();
    }
};
// packages/ag-grid-community/src/utils/mouse.ts
function $437b23f6a393c3bf$var$_areEventsNear(e1, e2, pixelCount) {
    if (pixelCount === 0) return false;
    const diffX = Math.abs(e1.clientX - e2.clientX);
    const diffY = Math.abs(e1.clientY - e2.clientY);
    return Math.max(diffX, diffY) <= pixelCount;
}
function $437b23f6a393c3bf$export$f8093014f10b296a({ gos: gos }, event) {
    return event.button === 2 || event.ctrlKey && gos.get("allowContextMenuWithControlKey");
}
// packages/ag-grid-community/src/rendering/cell/cellMouseListenerFeature.ts
var $437b23f6a393c3bf$var$CellMouseListenerFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans, column){
        super();
        this.cellCtrl = cellCtrl;
        this.column = column;
        this.beans = beans;
    }
    onMouseEvent(eventName, mouseEvent) {
        if ($437b23f6a393c3bf$export$9a48e23524c6d58(mouseEvent)) return;
        switch(eventName){
            case "click":
                this.onCellClicked(mouseEvent);
                break;
            case "mousedown":
            case "touchstart":
                this.onMouseDown(mouseEvent);
                break;
            case "dblclick":
                this.onCellDoubleClicked(mouseEvent);
                break;
            case "mouseout":
                this.onMouseOut(mouseEvent);
                break;
            case "mouseover":
                this.onMouseOver(mouseEvent);
                break;
        }
    }
    onCellClicked(event) {
        if (this.beans.touchSvc?.handleCellDoubleClick(this, event)) return;
        const { eventSvc: eventSvc, rangeSvc: rangeSvc, editSvc: editSvc, editModelSvc: editModelSvc, frameworkOverrides: frameworkOverrides } = this.beans;
        const isMultiKey = event.ctrlKey || event.metaKey;
        const { cellCtrl: cellCtrl } = this;
        const { column: column, cellPosition: cellPosition } = cellCtrl;
        if (rangeSvc && isMultiKey) {
            if (rangeSvc.getCellRangeCount(cellPosition) > 1) rangeSvc.intersectLastRange(true);
        }
        const cellClickedEvent = cellCtrl.createEvent(event, "cellClicked");
        eventSvc.dispatchEvent(cellClickedEvent);
        const colDef = column.getColDef();
        if (colDef.onCellClicked) window.setTimeout(()=>{
            frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellClicked(cellClickedEvent);
            });
        }, 0);
        if (editModelSvc?.getState(cellCtrl) !== "editing") {
            const editing = editSvc?.isEditing();
            const cellValidations = editModelSvc?.getCellValidationModel().getCellValidationMap().size ?? 0;
            const rowValidations = editModelSvc?.getRowValidationModel().getRowValidationMap().size ?? 0;
            if (editing && (cellValidations > 0 || rowValidations > 0)) return;
            if (editSvc?.shouldStartEditing(cellCtrl, event)) editSvc?.startEditing(cellCtrl, {
                event: event
            });
            else if (editSvc?.shouldStopEditing(cellCtrl, event)) {
                if (this.beans.gos.get("editType") === "fullRow") editSvc?.stopEditing(cellCtrl, {
                    event: event,
                    source: "edit"
                });
                else editSvc?.stopEditing(void 0, {
                    event: event,
                    source: "edit"
                });
            }
        }
    }
    onCellDoubleClicked(event) {
        const { column: column, beans: beans, cellCtrl: cellCtrl } = this;
        const { eventSvc: eventSvc, frameworkOverrides: frameworkOverrides, editSvc: editSvc, editModelSvc: editModelSvc } = beans;
        const colDef = column.getColDef();
        const cellDoubleClickedEvent = cellCtrl.createEvent(event, "cellDoubleClicked");
        eventSvc.dispatchEvent(cellDoubleClickedEvent);
        if (typeof colDef.onCellDoubleClicked === "function") window.setTimeout(()=>{
            frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellDoubleClicked(cellDoubleClickedEvent);
            });
        }, 0);
        if (editSvc?.shouldStartEditing(this.cellCtrl, event) && this.beans.editModelSvc?.getState(this.cellCtrl) !== "editing") {
            const editing = editSvc?.isEditing();
            const cellValidations = editModelSvc?.getCellValidationModel().getCellValidationMap().size ?? 0;
            const rowValidations = editModelSvc?.getRowValidationModel().getRowValidationMap().size ?? 0;
            if (editing && (cellValidations > 0 || rowValidations > 0)) return;
            editSvc?.startEditing(cellCtrl, {
                event: event
            });
        }
    }
    onMouseDown(mouseEvent) {
        const { ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = mouseEvent;
        const target = mouseEvent.target;
        const { cellCtrl: cellCtrl, beans: beans } = this;
        const { eventSvc: eventSvc, rangeSvc: rangeSvc, rowNumbersSvc: rowNumbersSvc, focusSvc: focusSvc, gos: gos, editSvc: editSvc } = beans;
        if (this.isRightClickInExistingRange(mouseEvent)) return;
        const hasRanges = rangeSvc && !rangeSvc.isEmpty();
        const containsWidget = this.containsWidget(target);
        const { cellPosition: cellPosition, column: column } = cellCtrl;
        const isRowNumberColumn = $437b23f6a393c3bf$export$3d3e7d751f0445eb(column);
        if (rowNumbersSvc && isRowNumberColumn && !rowNumbersSvc.handleMouseDownOnCell(cellPosition, mouseEvent)) {
            if (rangeSvc) mouseEvent.preventDefault();
            mouseEvent.stopImmediatePropagation();
            return;
        }
        if (!shiftKey || !hasRanges) {
            const editing = editSvc?.isEditing(cellCtrl);
            const isEnableCellTextSelection = gos.get("enableCellTextSelection");
            const shouldFocus = isEnableCellTextSelection && mouseEvent.defaultPrevented;
            const forceBrowserFocus = ($437b23f6a393c3bf$var$_isBrowserSafari() || shouldFocus) && !editing && !$437b23f6a393c3bf$var$_isFocusableFormField(target) && !containsWidget;
            cellCtrl.focusCell(forceBrowserFocus, mouseEvent);
        }
        if (shiftKey && hasRanges && !focusSvc.isCellFocused(cellPosition)) {
            mouseEvent.preventDefault();
            const focusedCell = focusSvc.getFocusedCell();
            if (focusedCell) {
                const { column: column2, rowIndex: rowIndex, rowPinned: rowPinned } = focusedCell;
                if (editSvc?.isEditing(focusedCell)) editSvc?.stopEditing(focusedCell);
                focusSvc.setFocusedCell({
                    column: column2,
                    rowIndex: rowIndex,
                    rowPinned: rowPinned,
                    forceBrowserFocus: true,
                    preventScrollOnBrowserFocus: true,
                    sourceEvent: mouseEvent
                });
            }
        }
        if (containsWidget) return;
        if (rangeSvc) {
            if (isRowNumberColumn) mouseEvent.preventDefault();
            const hasRightClickedOnRowNumber = $437b23f6a393c3bf$export$f8093014f10b296a(this.beans, mouseEvent) && isRowNumberColumn;
            if (shiftKey) rangeSvc.extendLatestRangeToCell(cellPosition);
            else if (!hasRightClickedOnRowNumber) {
                const isMultiKey = ctrlKey || metaKey;
                rangeSvc.setRangeToCell(cellPosition, isMultiKey);
            }
        }
        eventSvc.dispatchEvent(this.cellCtrl.createEvent(mouseEvent, "cellMouseDown"));
    }
    isRightClickInExistingRange(mouseEvent) {
        const { rangeSvc: rangeSvc } = this.beans;
        if (rangeSvc) {
            const cellInRange = rangeSvc.isCellInAnyRange(this.cellCtrl.cellPosition);
            const isRightClick = $437b23f6a393c3bf$export$f8093014f10b296a(this.beans, mouseEvent);
            if (cellInRange && isRightClick) return true;
        }
        return false;
    }
    containsWidget(target) {
        return $437b23f6a393c3bf$var$_isElementChildOfClass(target, "ag-selection-checkbox", 3) || $437b23f6a393c3bf$var$_isElementChildOfClass(target, "ag-drag-handle", 3);
    }
    onMouseOut(mouseEvent) {
        if (this.mouseStayingInsideCell(mouseEvent)) return;
        const { eventSvc: eventSvc, colHover: colHover } = this.beans;
        eventSvc.dispatchEvent(this.cellCtrl.createEvent(mouseEvent, "cellMouseOut"));
        colHover?.clearMouseOver();
    }
    onMouseOver(mouseEvent) {
        if (this.mouseStayingInsideCell(mouseEvent)) return;
        const { eventSvc: eventSvc, colHover: colHover } = this.beans;
        eventSvc.dispatchEvent(this.cellCtrl.createEvent(mouseEvent, "cellMouseOver"));
        colHover?.setMouseOver([
            this.column
        ]);
    }
    mouseStayingInsideCell(e) {
        if (!e.target || !e.relatedTarget) return false;
        const eCell = this.cellCtrl.eGui;
        const cellContainsTarget = eCell.contains(e.target);
        const cellContainsRelatedTarget = eCell.contains(e.relatedTarget);
        return cellContainsTarget && cellContainsRelatedTarget;
    }
};
// packages/ag-grid-community/src/rendering/cell/cellPositionFeature.ts
var $437b23f6a393c3bf$var$CellPositionFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans){
        super();
        this.cellCtrl = cellCtrl;
        this.beans = beans;
        this.column = cellCtrl.column;
        this.rowNode = cellCtrl.rowNode;
    }
    setupRowSpan() {
        this.rowSpan = this.column.getRowSpan(this.rowNode);
        this.addManagedListeners(this.beans.eventSvc, {
            newColumnsLoaded: ()=>this.onNewColumnsLoaded()
        });
    }
    init() {
        this.eSetLeft = this.cellCtrl.getRootElement();
        this.eContent = this.cellCtrl.eGui;
        const cellSpan = this.cellCtrl.getCellSpan();
        if (!cellSpan) {
            this.setupColSpan();
            this.setupRowSpan();
        }
        this.onLeftChanged();
        this.onWidthChanged();
        if (!cellSpan) this._legacyApplyRowSpan();
        if (cellSpan) {
            const refreshSpanHeight = this.refreshSpanHeight.bind(this, cellSpan);
            refreshSpanHeight();
            this.addManagedListeners(this.beans.eventSvc, {
                paginationChanged: refreshSpanHeight,
                recalculateRowBounds: refreshSpanHeight,
                pinnedHeightChanged: refreshSpanHeight
            });
        }
    }
    refreshSpanHeight(cellSpan) {
        const spanHeight = cellSpan.getCellHeight();
        if (spanHeight != null) this.eContent.style.height = `${spanHeight}px`;
    }
    onNewColumnsLoaded() {
        const rowSpan = this.column.getRowSpan(this.rowNode);
        if (this.rowSpan === rowSpan) return;
        this.rowSpan = rowSpan;
        this._legacyApplyRowSpan(true);
    }
    onDisplayColumnsChanged() {
        const colsSpanning = this.getColSpanningList();
        if (!$437b23f6a393c3bf$export$893967cdb9833fdd(this.colsSpanning, colsSpanning)) {
            this.colsSpanning = colsSpanning;
            this.onWidthChanged();
            this.onLeftChanged();
        }
    }
    setupColSpan() {
        if (this.column.getColDef().colSpan == null) return;
        this.colsSpanning = this.getColSpanningList();
        this.addManagedListeners(this.beans.eventSvc, {
            // because we are col spanning, a reorder of the cols can change what cols we are spanning over
            displayedColumnsChanged: this.onDisplayColumnsChanged.bind(this),
            // because we are spanning over multiple cols, we check for width any time any cols width changes.
            // this is expensive - really we should be explicitly checking only the cols we are spanning over
            // instead of every col, however it would be tricky code to track the cols we are spanning over, so
            // because hardly anyone will be using colSpan, am favouring this easier way for more maintainable code.
            displayedColumnsWidthChanged: this.onWidthChanged.bind(this)
        });
    }
    onWidthChanged() {
        if (!this.eContent) return;
        const width = this.getCellWidth();
        this.eContent.style.width = `${width}px`;
    }
    getCellWidth() {
        if (!this.colsSpanning) return this.column.getActualWidth();
        return this.colsSpanning.reduce((width, col)=>width + col.getActualWidth(), 0);
    }
    getColSpanningList() {
        const { column: column, rowNode: rowNode } = this;
        const colSpan = column.getColSpan(rowNode);
        const colsSpanning = [];
        if (colSpan === 1) colsSpanning.push(column);
        else {
            let pointer = column;
            const pinned = column.getPinned();
            for(let i = 0; pointer && i < colSpan; i++){
                colsSpanning.push(pointer);
                pointer = this.beans.visibleCols.getColAfter(pointer);
                if (!pointer || $437b23f6a393c3bf$export$672d9e47bc342bac(pointer)) break;
                if (pinned !== pointer.getPinned()) break;
            }
        }
        return colsSpanning;
    }
    onLeftChanged() {
        if (!this.eSetLeft) return;
        const left = this.modifyLeftForPrintLayout(this.getCellLeft());
        this.eSetLeft.style.left = left + "px";
    }
    getCellLeft() {
        let mostLeftCol;
        if (this.beans.gos.get("enableRtl") && this.colsSpanning) mostLeftCol = $437b23f6a393c3bf$export$236389741107357f(this.colsSpanning);
        else mostLeftCol = this.column;
        return mostLeftCol.getLeft();
    }
    modifyLeftForPrintLayout(leftPosition) {
        if (!this.cellCtrl.printLayout || this.column.getPinned() === "left") return leftPosition;
        const { visibleCols: visibleCols } = this.beans;
        const leftWidth = visibleCols.getColsLeftWidth();
        if (this.column.getPinned() === "right") {
            const bodyWidth = visibleCols.bodyWidth;
            return leftWidth + bodyWidth + (leftPosition || 0);
        }
        return leftWidth + (leftPosition || 0);
    }
    _legacyApplyRowSpan(force) {
        if (this.rowSpan === 1 && !force) return;
        const singleRowHeight = $437b23f6a393c3bf$export$8966875adec41e5b(this.beans);
        const totalRowHeight = singleRowHeight * this.rowSpan;
        this.eContent.style.height = `${totalRowHeight}px`;
        this.eContent.style.zIndex = "1";
    }
    // overriding to make public, as we don't dispose this bean via context
    destroy() {
        super.destroy();
    }
};
// packages/ag-grid-community/src/rendering/cell/cellCtrl.ts
var $437b23f6a393c3bf$var$CSS_CELL = "ag-cell";
var $437b23f6a393c3bf$var$CSS_AUTO_HEIGHT = "ag-cell-auto-height";
var $437b23f6a393c3bf$var$CSS_NORMAL_HEIGHT = "ag-cell-normal-height";
var $437b23f6a393c3bf$var$CSS_CELL_FOCUS = "ag-cell-focus";
var $437b23f6a393c3bf$var$CSS_CELL_FIRST_RIGHT_PINNED = "ag-cell-first-right-pinned";
var $437b23f6a393c3bf$var$CSS_CELL_LAST_LEFT_PINNED = "ag-cell-last-left-pinned";
var $437b23f6a393c3bf$var$CSS_CELL_NOT_INLINE_EDITING = "ag-cell-not-inline-editing";
var $437b23f6a393c3bf$var$CSS_CELL_WRAP_TEXT = "ag-cell-wrap-text";
var $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL = "cellCtrl";
function $437b23f6a393c3bf$export$b5bf61dcea514250(gos, eventTarget) {
    return $437b23f6a393c3bf$var$_getCtrlForEventTarget(gos, eventTarget, $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL);
}
var $437b23f6a393c3bf$var$instanceIdSequence2 = 0;
var $437b23f6a393c3bf$var$CellCtrl = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column, rowNode, beans, rowCtrl){
        super();
        this.column = column;
        this.rowNode = rowNode;
        this.rowCtrl = rowCtrl;
        this.rangeFeature = void 0;
        this.rowResizeFeature = void 0;
        this.positionFeature = void 0;
        this.customStyleFeature = void 0;
        this.editStyleFeature = void 0;
        this.mouseListener = void 0;
        this.keyboardListener = void 0;
        this.suppressRefreshCell = false;
        this.onCompAttachedFuncs = [];
        this.onEditorAttachedFuncs = [];
        this.focusEventWhileNotReady = null;
        // if cell has been focused, check if it's focused when destroyed
        this.hasBeenFocused = false;
        this.hasEdit = false;
        this.tooltipFeature = void 0;
        this.editorTooltipFeature = void 0;
        this.beans = beans;
        this.gos = beans.gos;
        this.editSvc = beans.editSvc;
        this.hasEdit = !!beans.editSvc;
        const { colId: colId } = column;
        this.instanceId = colId + "-" + $437b23f6a393c3bf$var$instanceIdSequence2++;
        this.createCellPosition();
        this.updateAndFormatValue(false);
    }
    addFeatures() {
        const { beans: beans } = this;
        this.positionFeature = new $437b23f6a393c3bf$var$CellPositionFeature(this, beans);
        this.customStyleFeature = beans.cellStyles?.createCellCustomStyleFeature(this, beans);
        this.editStyleFeature = beans.editSvc?.createCellStyleFeature(this, beans);
        this.mouseListener = new $437b23f6a393c3bf$var$CellMouseListenerFeature(this, beans, this.column);
        this.keyboardListener = new $437b23f6a393c3bf$var$CellKeyboardListenerFeature(this, beans, this.rowNode, this.rowCtrl);
        this.enableTooltipFeature();
        const { rangeSvc: rangeSvc } = beans;
        const cellSelectionEnabled = rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(beans.gos);
        if (cellSelectionEnabled) this.rangeFeature = rangeSvc.createCellRangeFeature(beans, this);
        if ($437b23f6a393c3bf$export$3d3e7d751f0445eb(this.column)) this.rowResizeFeature = this.beans.rowNumbersSvc.createRowNumbersRowResizerFeature(beans, this);
    }
    isCellSpanning() {
        return false;
    }
    getCellSpan() {
        return void 0;
    }
    removeFeatures() {
        const context = this.beans.context;
        this.positionFeature = context.destroyBean(this.positionFeature);
        this.editorTooltipFeature = context.destroyBean(this.editorTooltipFeature);
        this.customStyleFeature = context.destroyBean(this.customStyleFeature);
        this.editStyleFeature = context.destroyBean(this.editStyleFeature);
        this.mouseListener = context.destroyBean(this.mouseListener);
        this.keyboardListener = context.destroyBean(this.keyboardListener);
        this.rangeFeature = context.destroyBean(this.rangeFeature);
        this.rowResizeFeature = context.destroyBean(this.rowResizeFeature);
        this.disableTooltipFeature();
    }
    enableTooltipFeature(value, shouldDisplayTooltip) {
        this.tooltipFeature = this.beans.tooltipSvc?.enableCellTooltipFeature(this, value, shouldDisplayTooltip);
    }
    disableTooltipFeature() {
        this.tooltipFeature = this.beans.context.destroyBean(this.tooltipFeature);
    }
    enableEditorTooltipFeature(editor) {
        if (this.editorTooltipFeature) this.disableEditorTooltipFeature();
        this.editorTooltipFeature = this.beans.tooltipSvc?.setupCellEditorTooltip(this, editor);
        $437b23f6a393c3bf$var$_populateModelValidationErrors(this.beans);
    }
    disableEditorTooltipFeature() {
        this.editorTooltipFeature = this.beans.context.destroyBean(this.editorTooltipFeature);
    }
    setComp(comp, eCell, _eWrapper, eCellWrapper, printLayout, startEditing, compBean) {
        this.comp = comp;
        this.eGui = eCell;
        this.printLayout = printLayout;
        compBean ?? (compBean = this);
        this.addDomData(compBean);
        this.addFeatures();
        compBean.addDestroyFunc(()=>this.removeFeatures());
        this.onSuppressCellFocusChanged(this.beans.gos.get("suppressCellFocus"));
        this.setupFocus();
        this.applyStaticCssClasses();
        this.setWrapText();
        this.onFirstRightPinnedChanged();
        this.onLastLeftPinnedChanged();
        this.onColumnHover();
        this.setupControlComps();
        this.setupAutoHeight(eCellWrapper, compBean);
        this.refreshFirstAndLastStyles();
        this.refreshAriaColIndex();
        this.positionFeature?.init();
        this.customStyleFeature?.setComp(comp);
        this.editStyleFeature?.setComp(comp);
        this.tooltipFeature?.refreshTooltip();
        this.keyboardListener?.init();
        this.rangeFeature?.setComp(comp);
        this.rowResizeFeature?.refreshRowResizer();
        if (startEditing && this.isCellEditable()) this.editSvc?.startEditing(this, {
            startedEdit: false,
            source: "api",
            silent: true
        });
        else this.showValue(false, true);
        if (this.onCompAttachedFuncs.length) {
            this.onCompAttachedFuncs.forEach((func)=>func());
            this.onCompAttachedFuncs = [];
        }
    }
    setupAutoHeight(eCellWrapper, compBean) {
        this.isAutoHeight = this.beans.rowAutoHeight?.setupCellAutoHeight(this, eCellWrapper, compBean) ?? false;
    }
    getCellAriaRole() {
        return this.column.getColDef().cellAriaRole ?? "gridcell";
    }
    isCellRenderer() {
        const colDef = this.column.getColDef();
        return colDef.cellRenderer != null || colDef.cellRendererSelector != null;
    }
    getValueToDisplay() {
        return this.valueFormatted ?? this.value;
    }
    getDeferLoadingCellRenderer() {
        const { beans: beans, column: column } = this;
        const { userCompFactory: userCompFactory, ctrlsSvc: ctrlsSvc, eventSvc: eventSvc } = beans;
        const colDef = column.getColDef();
        const params = this.createCellRendererParams();
        params.deferRender = true;
        const loadingDetails = $437b23f6a393c3bf$var$_getLoadingCellRendererDetails(userCompFactory, colDef, params);
        if (ctrlsSvc.getGridBodyCtrl()?.scrollFeature?.isScrolling()) {
            let resolver;
            const onReady = new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
                resolver = resolve;
            });
            this.addManagedListeners(eventSvc, {
                bodyScrollEnd: ()=>resolver()
            });
            return {
                loadingComp: loadingDetails,
                onReady: onReady
            };
        }
        return {
            loadingComp: loadingDetails,
            onReady: $437b23f6a393c3bf$export$30ec7836a4847721.resolve()
        };
    }
    showValue(forceNewCellRendererInstance, skipRangeHandleRefresh) {
        const { beans: beans, column: column, rowNode: rowNode, rangeFeature: rangeFeature } = this;
        const { userCompFactory: userCompFactory } = beans;
        let valueToDisplay = this.getValueToDisplay();
        let compDetails;
        const isSsrmLoading = rowNode.stub && rowNode.groupData?.[column.getId()] == null;
        const colDef = column.getColDef();
        if (isSsrmLoading || this.isCellRenderer()) {
            const params = this.createCellRendererParams();
            if (!isSsrmLoading || $437b23f6a393c3bf$export$3d3e7d751f0445eb(column)) compDetails = $437b23f6a393c3bf$export$1f172e021e4d8401(userCompFactory, colDef, params);
            else compDetails = $437b23f6a393c3bf$var$_getLoadingCellRendererDetails(userCompFactory, colDef, params);
        }
        if (!compDetails && !isSsrmLoading && beans.findSvc?.isMatch(rowNode, column)) {
            const params = this.createCellRendererParams();
            compDetails = $437b23f6a393c3bf$export$1f172e021e4d8401(userCompFactory, {
                ...column.getColDef(),
                cellRenderer: "agFindCellRenderer"
            }, params);
        }
        if (this.hasEdit && this.editSvc.isBatchEditing() && this.editSvc.isRowEditing(rowNode, {
            checkSiblings: true
        })) {
            const result = this.editSvc.prepDetailsDuringBatch(this, {
                compDetails: compDetails,
                valueToDisplay: valueToDisplay
            });
            if (result) {
                if (result.compDetails) compDetails = result.compDetails;
                else if (result.valueToDisplay) valueToDisplay = result.valueToDisplay;
            }
        }
        this.comp.setRenderDetails(compDetails, valueToDisplay, forceNewCellRendererInstance);
        if (!skipRangeHandleRefresh && rangeFeature) $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, ()=>rangeFeature?.refreshHandle());
        this.rowResizeFeature?.refreshRowResizer();
    }
    setupControlComps() {
        const colDef = this.column.getColDef();
        this.includeSelection = this.isIncludeControl(this.isCheckboxSelection(colDef), true);
        this.includeRowDrag = this.isIncludeControl(colDef.rowDrag);
        this.includeDndSource = this.isIncludeControl(colDef.dndSource);
        this.comp.setIncludeSelection(this.includeSelection);
        this.comp.setIncludeDndSource(this.includeDndSource);
        this.comp.setIncludeRowDrag(this.includeRowDrag);
    }
    isForceWrapper() {
        return this.beans.gos.get("enableCellTextSelection") || this.column.isAutoHeight();
    }
    /**
   * Wrapper providing general conditions under which control elements (e.g. checkboxes and drag handles)
   * are rendered for a particular cell.
   * @param value Whether to render the control in the specific context of the caller
   * @param allowManuallyPinned Whether manually pinned rows are permitted this form of control element
   */ // eslint-disable-next-line @typescript-eslint/ban-types
    isIncludeControl(value, allowManuallyPinned = false) {
        const rowUnpinned = this.rowNode.rowPinned == null;
        return (rowUnpinned || allowManuallyPinned && $437b23f6a393c3bf$var$_isManualPinnedRow(this.rowNode)) && !!value;
    }
    isCheckboxSelection(colDef) {
        const { rowSelection: rowSelection, groupDisplayType: groupDisplayType } = this.beans.gridOptions;
        const checkboxLocation = $437b23f6a393c3bf$export$8fb5d781b5c28347(rowSelection);
        const isSelectionColumn = $437b23f6a393c3bf$export$f6074a9792015c5d(this.column);
        if (groupDisplayType === "custom" && checkboxLocation !== "selectionColumn" && isSelectionColumn) return false;
        return colDef.checkboxSelection || isSelectionColumn && typeof rowSelection === "object" && $437b23f6a393c3bf$export$6df3a55606bca6ae(rowSelection);
    }
    refreshShouldDestroy() {
        const colDef = this.column.getColDef();
        const selectionChanged = this.includeSelection != this.isIncludeControl(this.isCheckboxSelection(colDef), true);
        const rowDragChanged = this.includeRowDrag != this.isIncludeControl(colDef.rowDrag);
        const dndSourceChanged = this.includeDndSource != this.isIncludeControl(colDef.dndSource);
        const autoHeightChanged = this.isAutoHeight != this.column.isAutoHeight();
        return selectionChanged || rowDragChanged || dndSourceChanged || autoHeightChanged;
    }
    onPopupEditorClosed() {
        const { editSvc: editSvc } = this.beans;
        if (!editSvc?.isEditing(this, {
            withOpenEditor: true
        })) return;
        editSvc?.stopEditing(this, {
            source: editSvc?.isBatchEditing() ? "ui" : "api"
        });
    }
    /**
   * Ends the Cell Editing
   * @param cancel `True` if the edit process is being canceled.
   * @returns `True` if the value of the `GridCell` has been updated, otherwise `False`.
   */ stopEditing(cancel = false) {
        const { editSvc: editSvc } = this.beans;
        return editSvc?.stopEditing(this, {
            cancel: cancel,
            source: editSvc?.isBatchEditing() ? "ui" : "api"
        }) ?? false;
    }
    createCellRendererParams() {
        const { value: value, valueFormatted: valueFormatted, column: column, rowNode: rowNode, comp: comp, eGui: eGui, beans: { valueSvc: valueSvc, gos: gos, editSvc: editSvc } } = this;
        const res = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            value: value,
            valueFormatted: valueFormatted,
            getValue: ()=>valueSvc.getValueForDisplay(column, rowNode).value,
            setValue: (value2)=>editSvc?.setDataValue({
                    rowNode: rowNode,
                    column: column
                }, value2) || valueSvc.setValue(rowNode, column, value2),
            formatValue: this.formatValue.bind(this),
            data: rowNode.data,
            node: rowNode,
            pinned: column.getPinned(),
            colDef: column.getColDef(),
            column: column,
            refreshCell: this.refreshCell.bind(this),
            eGridCell: eGui,
            eParentOfValue: comp.getParentOfValue(),
            registerRowDragger: (rowDraggerElement, dragStartPixels, value2, suppressVisibilityChange)=>this.registerRowDragger(rowDraggerElement, dragStartPixels, suppressVisibilityChange),
            setTooltip: (value2, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                if (this.tooltipFeature) this.disableTooltipFeature();
                this.enableTooltipFeature(value2, shouldDisplayTooltip);
                this.tooltipFeature?.refreshTooltip();
            }
        });
        return res;
    }
    onCellChanged(event) {
        const eventImpactsThisCell = event.column === this.column;
        if (eventImpactsThisCell) this.refreshCell({});
    }
    refreshOrDestroyCell(params) {
        if (this.refreshShouldDestroy()) this.rowCtrl?.recreateCell(this);
        else this.refreshCell(params);
        if (this.hasEdit && this.editCompDetails) {
            const { editSvc: editSvc, comp: comp } = this;
            if (!comp?.getCellEditor() && editSvc.isEditing(this, {
                withOpenEditor: true
            })) editSvc.startEditing(this, {
                startedEdit: false,
                source: "api",
                silent: true
            });
        }
    }
    // + stop editing {force: true, suppressFlash: true}
    // + event cellChanged {}
    // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
    // + rowCtrl: event dataChanged {suppressFlash: !update, newData: !update}
    // + rowCtrl: api refreshCells() {animate: true/false}
    // + rowRenderer: api softRefreshView() {}
    refreshCell({ force: force, suppressFlash: suppressFlash, newData: newData } = {}) {
        if (this.suppressRefreshCell) return;
        const colDef = this.column.getColDef();
        const noValueProvided = colDef.field == null && colDef.valueGetter == null && colDef.showRowGroup == null;
        const forceRefresh = force || noValueProvided || newData;
        const isCellCompReady = !!this.comp;
        const valuesDifferent = this.updateAndFormatValue(isCellCompReady);
        const dataNeedsUpdating = forceRefresh || valuesDifferent;
        if (!isCellCompReady) return;
        if (dataNeedsUpdating) {
            this.showValue(!!newData, false);
            const processingFilterChange = this.beans.filterManager?.isSuppressFlashingCellsBecauseFiltering();
            const flashCell = !suppressFlash && !processingFilterChange && colDef.enableCellChangeFlash;
            if (flashCell) this.beans.cellFlashSvc?.flashCell(this);
            this.editStyleFeature?.applyCellStyles?.();
            this.customStyleFeature?.applyUserStyles();
            this.customStyleFeature?.applyClassesFromColDef();
        }
        this.tooltipFeature?.refreshTooltip();
        this.customStyleFeature?.applyCellClassRules();
    }
    isCellEditable() {
        return this.column.isCellEditable(this.rowNode);
    }
    formatValue(value) {
        return this.callValueFormatter(value) ?? value;
    }
    callValueFormatter(value) {
        return this.beans.valueSvc.formatValue(this.column, this.rowNode, value);
    }
    updateAndFormatValue(compareValues) {
        const oldValue = this.value;
        const oldValueFormatted = this.valueFormatted;
        const { value: value, valueFormatted: valueFormatted } = this.beans.valueSvc.getValueForDisplay(this.column, this.rowNode, true);
        this.value = value;
        this.valueFormatted = valueFormatted;
        if (compareValues) return !this.valuesAreEqual(oldValue, this.value) || this.valueFormatted != oldValueFormatted;
        return true;
    }
    valuesAreEqual(val1, val2) {
        const colDef = this.column.getColDef();
        return colDef.equals ? colDef.equals(val1, val2) : val1 === val2;
    }
    addDomData(compBean) {
        const element = this.eGui;
        $437b23f6a393c3bf$var$_setDomData(this.beans.gos, element, $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL, this);
        compBean.addDestroyFunc(()=>$437b23f6a393c3bf$var$_setDomData(this.beans.gos, element, $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL, null));
    }
    createEvent(domEvent, eventType) {
        const { rowNode: rowNode, column: column, value: value, beans: beans } = this;
        return $437b23f6a393c3bf$var$_createCellEvent(beans, domEvent, eventType, {
            rowNode: rowNode,
            column: column
        }, value);
    }
    processCharacter(event) {
        this.keyboardListener?.processCharacter(event);
    }
    onKeyDown(event) {
        this.keyboardListener?.onKeyDown(event);
    }
    onMouseEvent(eventName, mouseEvent) {
        this.mouseListener?.onMouseEvent(eventName, mouseEvent);
    }
    getColSpanningList() {
        return this.positionFeature?.getColSpanningList() ?? [];
    }
    onLeftChanged() {
        if (!this.comp) return;
        this.positionFeature?.onLeftChanged();
    }
    onDisplayedColumnsChanged() {
        if (!this.eGui) return;
        this.refreshAriaColIndex();
        this.refreshFirstAndLastStyles();
    }
    refreshFirstAndLastStyles() {
        const { comp: comp, column: column, beans: beans } = this;
        $437b23f6a393c3bf$var$refreshFirstAndLastStyles(comp, column, beans.visibleCols);
    }
    refreshAriaColIndex() {
        const colIdx = this.beans.visibleCols.getAriaColIndex(this.column);
        $437b23f6a393c3bf$export$84b73ecd0b234e89(this.eGui, colIdx);
    }
    onWidthChanged() {
        return this.positionFeature?.onWidthChanged();
    }
    getRowPosition() {
        const { rowIndex: rowIndex, rowPinned: rowPinned } = this.cellPosition;
        return {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        };
    }
    updateRangeBordersIfRangeCount() {
        if (!this.comp) return;
        this.rangeFeature?.updateRangeBordersIfRangeCount();
    }
    onCellSelectionChanged() {
        if (!this.comp) return;
        this.rangeFeature?.onCellSelectionChanged();
    }
    isRangeSelectionEnabled() {
        return this.rangeFeature != null;
    }
    focusCell(forceBrowserFocus = false, sourceEvent) {
        const allowedTarget = this.editSvc?.allowedFocusTargetOnValidation(this);
        if (allowedTarget && allowedTarget !== this) return;
        this.beans.focusSvc.setFocusedCell({
            ...this.getFocusedCellPosition(),
            forceBrowserFocus: forceBrowserFocus,
            sourceEvent: sourceEvent
        });
    }
    /**
   * Restores focus to the cell, if it should have it
   * @param waitForRender if the cell has just setComp, it may not be rendered yet, so we wait for the next render
   */ restoreFocus(waitForRender = false) {
        const { beans: { editSvc: editSvc, focusSvc: focusSvc }, comp: comp } = this;
        if (!comp || editSvc?.isEditing(this) || !this.isCellFocused() || !focusSvc.shouldTakeFocus()) return;
        const focus = ()=>{
            if (!this.isAlive()) return;
            const focusableElement = comp.getFocusableElement();
            if (this.isCellFocused()) focusableElement.focus({
                preventScroll: true
            });
        };
        if (waitForRender) {
            setTimeout(focus, 0);
            return;
        }
        focus();
    }
    onRowIndexChanged() {
        this.createCellPosition();
        this.onCellFocused();
        this.restoreFocus();
        this.rangeFeature?.onCellSelectionChanged();
        this.rowResizeFeature?.refreshRowResizer();
    }
    onSuppressCellFocusChanged(suppressCellFocus) {
        const element = this.eGui;
        if (!element) return;
        if ($437b23f6a393c3bf$export$3d3e7d751f0445eb(this.column)) suppressCellFocus = true;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(element, "tabindex", suppressCellFocus ? void 0 : -1);
    }
    onFirstRightPinnedChanged() {
        if (!this.comp) return;
        const firstRightPinned = this.column.isFirstRightPinned();
        this.comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_FIRST_RIGHT_PINNED, firstRightPinned);
    }
    onLastLeftPinnedChanged() {
        if (!this.comp) return;
        const lastLeftPinned = this.column.isLastLeftPinned();
        this.comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_LAST_LEFT_PINNED, lastLeftPinned);
    }
    /**
   * Returns whether cell is focused by the focusSvc, overridden by spannedCellCtrl
   */ checkCellFocused() {
        return this.beans.focusSvc.isCellFocused(this.cellPosition);
    }
    isCellFocused() {
        const isFocused = this.checkCellFocused();
        this.hasBeenFocused || (this.hasBeenFocused = isFocused);
        return isFocused;
    }
    setupFocus() {
        this.restoreFocus(true);
        this.onCellFocused(this.focusEventWhileNotReady ?? void 0);
    }
    onCellFocused(event) {
        const { beans: beans } = this;
        if ($437b23f6a393c3bf$var$_isCellFocusSuppressed(beans)) return;
        if (!this.comp) {
            if (event) this.focusEventWhileNotReady = event;
            return;
        }
        const cellFocused = this.isCellFocused();
        const editing = beans.editSvc?.isEditing(this) ?? false;
        this.comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_FOCUS, cellFocused);
        if (cellFocused && event && event.forceBrowserFocus) {
            let focusEl = this.comp.getFocusableElement();
            if (editing) {
                const focusableEls = $437b23f6a393c3bf$export$7acf44f59625b1f6(focusEl, null, true);
                if (focusableEls.length) focusEl = focusableEls[0];
            }
            focusEl.focus({
                preventScroll: !!event.preventScrollOnBrowserFocus
            });
        }
        if (cellFocused) this.rowCtrl.announceDescription();
    }
    createCellPosition() {
        const { rowIndex: rowIndex, rowPinned: rowPinned } = this.rowNode;
        this.cellPosition = {
            rowIndex: rowIndex,
            rowPinned: $437b23f6a393c3bf$export$4978424c4f7b5fc0(rowPinned),
            column: this.column
        };
    }
    // CSS Classes that only get applied once, they never change
    applyStaticCssClasses() {
        const { comp: comp } = this;
        comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL, true);
        comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_NOT_INLINE_EDITING, true);
        const autoHeight = this.column.isAutoHeight() == true;
        comp.toggleCss($437b23f6a393c3bf$var$CSS_AUTO_HEIGHT, autoHeight);
        comp.toggleCss($437b23f6a393c3bf$var$CSS_NORMAL_HEIGHT, !autoHeight);
    }
    onColumnHover() {
        this.beans.colHover?.onCellColumnHover(this.column, this.comp);
    }
    onColDefChanged() {
        if (!this.comp) return;
        if (this.column.isTooltipEnabled()) {
            this.disableTooltipFeature();
            this.enableTooltipFeature();
        } else this.disableTooltipFeature();
        this.setWrapText();
        if (this.editSvc?.isEditing(this)) this.editSvc?.handleColDefChanged(this);
        else this.refreshOrDestroyCell({
            force: true,
            suppressFlash: true
        });
    }
    setWrapText() {
        const value = this.column.getColDef().wrapText == true;
        this.comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_WRAP_TEXT, value);
    }
    dispatchCellContextMenuEvent(event) {
        const colDef = this.column.getColDef();
        const cellContextMenuEvent = this.createEvent(event, "cellContextMenu");
        const { beans: beans } = this;
        beans.eventSvc.dispatchEvent(cellContextMenuEvent);
        if (colDef.onCellContextMenu) window.setTimeout(()=>{
            beans.frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellContextMenu(cellContextMenuEvent);
            });
        }, 0);
    }
    getCellRenderer() {
        return this.comp?.getCellRenderer() ?? null;
    }
    destroy() {
        this.onCompAttachedFuncs = [];
        this.onEditorAttachedFuncs = [];
        if (this.isCellFocused() && this.hasBrowserFocus()) this.beans.focusSvc.attemptToRecoverFocus();
        super.destroy();
    }
    hasBrowserFocus() {
        return this.eGui?.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans)) ?? false;
    }
    createSelectionCheckbox() {
        const cbSelectionComponent = this.beans.selectionSvc?.createCheckboxSelectionComponent();
        if (!cbSelectionComponent) return void 0;
        this.beans.context.createBean(cbSelectionComponent);
        cbSelectionComponent.init({
            rowNode: this.rowNode,
            column: this.column
        });
        return cbSelectionComponent;
    }
    createDndSource() {
        const dndSourceComp = this.beans.registry.createDynamicBean("dndSourceComp", false, this.rowNode, this.column, this.eGui);
        if (dndSourceComp) this.beans.context.createBean(dndSourceComp);
        return dndSourceComp;
    }
    registerRowDragger(customElement, dragStartPixels, suppressVisibilityChange) {
        if (this.customRowDragComp) {
            this.customRowDragComp.setDragElement(customElement, dragStartPixels);
            return;
        }
        const newComp = this.createRowDragComp(customElement, dragStartPixels, suppressVisibilityChange);
        if (newComp) {
            this.customRowDragComp = newComp;
            this.addDestroyFunc(()=>{
                this.beans.context.destroyBean(newComp);
                this.customRowDragComp = null;
            });
        }
    }
    createRowDragComp(customElement, dragStartPixels, suppressVisibilityChange) {
        const rowDragComp = this.beans.rowDragSvc?.createRowDragCompForCell(this.rowNode, this.column, ()=>this.value, customElement, dragStartPixels, suppressVisibilityChange);
        if (!rowDragComp) return void 0;
        this.beans.context.createBean(rowDragComp);
        return rowDragComp;
    }
    cellEditorAttached() {
        this.onEditorAttachedFuncs.forEach((func)=>func());
        this.onEditorAttachedFuncs = [];
    }
    setFocusedCellPosition(_cellPosition) {}
    getFocusedCellPosition() {
        return this.cellPosition;
    }
    // used by spannedCellCtrl
    refreshAriaRowIndex() {}
    /**
   * Returns the root element of the cell, could be a span container rather than the cell element.
   * @returns The root element of the cell.
   */ getRootElement() {
        return this.eGui;
    }
};
// packages/ag-grid-community/src/gridBodyComp/mouseEventUtils.ts
var $437b23f6a393c3bf$var$GRID_DOM_KEY = "__ag_grid_instance";
function $437b23f6a393c3bf$var$_stampTopLevelGridCompWithGridInstance(gos, eGridDiv) {
    eGridDiv[$437b23f6a393c3bf$var$GRID_DOM_KEY] = gos.gridInstanceId;
}
function $437b23f6a393c3bf$var$_isEventFromThisGrid(gos, event) {
    const res = $437b23f6a393c3bf$var$_isElementInThisGrid(gos, event.target);
    return res;
}
function $437b23f6a393c3bf$var$_isElementInThisGrid(gos, element) {
    let pointer = element;
    while(pointer){
        const instanceId = pointer[$437b23f6a393c3bf$var$GRID_DOM_KEY];
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(instanceId)) {
            const eventFromThisGrid = instanceId === gos.gridInstanceId;
            return eventFromThisGrid;
        }
        pointer = pointer.parentElement;
    }
    return false;
}
function $437b23f6a393c3bf$export$d85fcb0e6e51242(gos, event) {
    return $437b23f6a393c3bf$export$b5bf61dcea514250(gos, event.target)?.getFocusedCellPosition() ?? null;
}
function $437b23f6a393c3bf$export$530c24bdfacb8cd1(beans, event) {
    const gridPanelHasScrolls = $437b23f6a393c3bf$export$aa3ea9d0da61306f(beans.gos, "normal");
    const e = event;
    let x;
    let y;
    if (e.clientX != null || e.clientY != null) {
        x = e.clientX;
        y = e.clientY;
    } else {
        x = e.x;
        y = e.y;
    }
    const { pageFirstPixel: pageFirstPixel } = beans.pageBounds.getCurrentPagePixelRange();
    y += pageFirstPixel;
    if (gridPanelHasScrolls) {
        const scrollFeature = beans.ctrlsSvc.getScrollFeature();
        const vRange = scrollFeature.getVScrollPosition();
        const hRange = scrollFeature.getHScrollPosition();
        x += hRange.left;
        y += vRange.top;
    }
    return {
        x: x,
        y: y
    };
}
// packages/ag-grid-community/src/dragAndDrop/dragAndDropService.ts
var $437b23f6a393c3bf$export$46ba5a92125911d9 = /* @__PURE__ */ ((DragSourceType2)=>{
    DragSourceType2[DragSourceType2["ToolPanel"] = 0] = "ToolPanel";
    DragSourceType2[DragSourceType2["HeaderCell"] = 1] = "HeaderCell";
    DragSourceType2[DragSourceType2["RowDrag"] = 2] = "RowDrag";
    DragSourceType2[DragSourceType2["ChartPanel"] = 3] = "ChartPanel";
    DragSourceType2[DragSourceType2["AdvancedFilterBuilder"] = 4] = "AdvancedFilterBuilder";
    return DragSourceType2;
})($437b23f6a393c3bf$export$46ba5a92125911d9 || {});
var $437b23f6a393c3bf$var$DragAndDropService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "dragAndDrop";
        this.dragSourceAndParamsList = [];
        this.dropTargets = [];
    }
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
        this.dragSvc = beans.dragSvc;
        this.environment = beans.environment;
        this.userCompFactory = beans.userCompFactory;
    }
    addDragSource(dragSource, allowTouch = false) {
        const params = {
            eElement: dragSource.eElement,
            dragStartPixels: dragSource.dragStartPixels,
            onDragStart: this.onDragStart.bind(this, dragSource),
            onDragStop: this.onDragStop.bind(this),
            onDragging: this.onDragging.bind(this),
            onDragCancel: this.onDragCancel.bind(this),
            includeTouch: allowTouch
        };
        this.dragSourceAndParamsList.push({
            params: params,
            dragSource: dragSource
        });
        this.dragSvc.addDragSource(params);
    }
    getDragAndDropImageComponent() {
        const { dragAndDropImageComp: dragAndDropImageComp } = this;
        if (!dragAndDropImageComp || !dragAndDropImageComp.comp) return null;
        return dragAndDropImageComp.comp;
    }
    removeDragSource(dragSource) {
        const { dragSourceAndParamsList: dragSourceAndParamsList, dragSvc: dragSvc } = this;
        const sourceAndParams = dragSourceAndParamsList.find((item)=>item.dragSource === dragSource);
        if (sourceAndParams) {
            dragSvc.removeDragSource(sourceAndParams.params);
            $437b23f6a393c3bf$export$83a881c8b5120679(dragSourceAndParamsList, sourceAndParams);
        }
    }
    destroy() {
        const { dragSourceAndParamsList: dragSourceAndParamsList, dragSvc: dragSvc, dropTargets: dropTargets } = this;
        dragSourceAndParamsList.forEach((sourceAndParams)=>dragSvc.removeDragSource(sourceAndParams.params));
        dragSourceAndParamsList.length = 0;
        dropTargets.length = 0;
        this.clearDragAndDropProperties();
        super.destroy();
    }
    nudge() {
        if (this.dragging) this.onDragging(this.eventLastTime, true);
    }
    onDragStart(dragSource, mouseEvent) {
        this.dragging = true;
        this.dragSource = dragSource;
        this.eventLastTime = mouseEvent;
        this.dragItem = dragSource.getDragItem();
        dragSource.onDragStarted?.();
        this.createDragAndDropImageComponent();
    }
    onDragStop(mouseEvent) {
        this.dragSource?.onDragStopped?.();
        const { lastDropTarget: lastDropTarget } = this;
        if (lastDropTarget?.onDragStop) {
            const draggingEvent = this.createDropTargetEvent(lastDropTarget, mouseEvent, null, null, false);
            lastDropTarget.onDragStop(draggingEvent);
        }
        this.clearDragAndDropProperties();
    }
    onDragCancel() {
        const { dragSource: dragSource, lastDropTarget: lastDropTarget } = this;
        dragSource?.onDragCancelled?.();
        if (lastDropTarget?.onDragCancel) lastDropTarget.onDragCancel(this.createDropTargetEvent(lastDropTarget, this.eventLastTime, null, null, false));
        this.clearDragAndDropProperties();
    }
    clearDragAndDropProperties() {
        this.eventLastTime = null;
        this.dragging = false;
        this.lastDropTarget = void 0;
        this.dragItem = null;
        this.dragSource = null;
        this.removeDragAndDropImageComponent();
    }
    onDragging(mouseEvent, fromNudge = false) {
        const hDirection = this.getHorizontalDirection(mouseEvent);
        const vDirection = this.getVerticalDirection(mouseEvent);
        this.eventLastTime = mouseEvent;
        this.positionDragAndDropImageComp(mouseEvent);
        const validDropTargets = this.dropTargets.filter((target)=>this.isMouseOnDropTarget(mouseEvent, target));
        const dropTarget = this.findCurrentDropTarget(mouseEvent, validDropTargets);
        const { lastDropTarget: lastDropTarget, dragSource: dragSource, dragAndDropImageComp: dragAndDropImageComp, dragItem: dragItem } = this;
        if (dropTarget !== lastDropTarget) {
            this.leaveLastTargetIfExists(mouseEvent, hDirection, vDirection, fromNudge);
            if (lastDropTarget !== null && dropTarget === null) dragSource?.onGridExit?.(dragItem);
            if (lastDropTarget === null && dropTarget !== null) dragSource?.onGridEnter?.(dragItem);
            this.enterDragTargetIfExists(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            if (dropTarget && dragAndDropImageComp) {
                const { comp: comp, promise: promise } = dragAndDropImageComp;
                if (comp) comp.setIcon(dropTarget.getIconName ? dropTarget.getIconName() : null, false);
                else promise.then((resolvedComponent)=>{
                    if (resolvedComponent) resolvedComponent.setIcon(dropTarget.getIconName ? dropTarget.getIconName() : null, false);
                });
            }
            this.lastDropTarget = dropTarget;
        } else if (dropTarget && dropTarget.onDragging) {
            const draggingEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            dropTarget.onDragging(draggingEvent);
        }
    }
    getAllContainersFromDropTarget(dropTarget) {
        const secondaryContainers = dropTarget.getSecondaryContainers ? dropTarget.getSecondaryContainers() : null;
        const containers = [
            [
                dropTarget.getContainer()
            ]
        ];
        return secondaryContainers ? containers.concat(secondaryContainers) : containers;
    }
    // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
    isMouseOnDropTarget(mouseEvent, dropTarget) {
        const allContainersFromDropTarget = this.getAllContainersFromDropTarget(dropTarget);
        let mouseOverTarget = false;
        const allContainersIntersect = (mouseEvent2, containers)=>{
            for (const container of containers){
                const { width: width, height: height, left: left, right: right, top: top, bottom: bottom } = container.getBoundingClientRect();
                if (width === 0 || height === 0) return false;
                const horizontalFit = mouseEvent2.clientX >= left && mouseEvent2.clientX < right;
                const verticalFit = mouseEvent2.clientY >= top && mouseEvent2.clientY < bottom;
                if (!horizontalFit || !verticalFit) return false;
            }
            return true;
        };
        for (const currentContainers of allContainersFromDropTarget)if (allContainersIntersect(mouseEvent, currentContainers)) {
            mouseOverTarget = true;
            break;
        }
        const { eElement: eElement, type: type } = this.dragSource;
        if (dropTarget.targetContainsSource && !dropTarget.getContainer().contains(eElement)) return false;
        return mouseOverTarget && dropTarget.isInterestedIn(type, eElement);
    }
    findCurrentDropTarget(mouseEvent, validDropTargets) {
        const len = validDropTargets.length;
        if (len === 0) return null;
        if (len === 1) return validDropTargets[0];
        const rootNode = $437b23f6a393c3bf$export$1911dd00c79744c0(this.beans);
        const elementStack = rootNode.elementsFromPoint(mouseEvent.clientX, mouseEvent.clientY);
        for (const el of elementStack)for (const dropTarget of validDropTargets){
            const containers = this.getAllContainersFromDropTarget(dropTarget).flatMap((a)=>a);
            if (containers.indexOf(el) !== -1) return dropTarget;
        }
        return null;
    }
    enterDragTargetIfExists(dropTarget, mouseEvent, hDirection, vDirection, fromNudge) {
        if (!dropTarget) return;
        if (dropTarget.onDragEnter) {
            const dragEnterEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            dropTarget.onDragEnter(dragEnterEvent);
        }
    }
    leaveLastTargetIfExists(mouseEvent, hDirection, vDirection, fromNudge) {
        const { lastDropTarget: lastDropTarget } = this;
        if (!lastDropTarget) return;
        if (lastDropTarget.onDragLeave) {
            const dragLeaveEvent = this.createDropTargetEvent(lastDropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            lastDropTarget.onDragLeave(dragLeaveEvent);
        }
        const dragAndDropImageComponent = this.getDragAndDropImageComponent();
        if (dragAndDropImageComponent) dragAndDropImageComponent.setIcon(null, false);
    }
    addDropTarget(dropTarget) {
        this.dropTargets.push(dropTarget);
    }
    removeDropTarget(dropTarget) {
        this.dropTargets = this.dropTargets.filter((target)=>target.getContainer() !== dropTarget.getContainer());
    }
    hasExternalDropZones() {
        return this.dropTargets.some((zones)=>zones.external);
    }
    findExternalZone(params) {
        const externalTargets = this.dropTargets.filter((target)=>target.external);
        return externalTargets.find((zone)=>zone.getContainer() === params.getContainer()) || null;
    }
    isDropZoneWithinThisGrid(draggingEvent) {
        const gridBodyCon = this.ctrlsSvc.getGridBodyCtrl();
        const gridGui = gridBodyCon.eGridBody;
        const { dropZoneTarget: dropZoneTarget } = draggingEvent;
        return gridGui.contains(dropZoneTarget);
    }
    getHorizontalDirection(event) {
        const clientX = this.eventLastTime?.clientX;
        const eClientX = event.clientX;
        if (clientX === eClientX) return null;
        return clientX > eClientX ? "left" : "right";
    }
    getVerticalDirection(event) {
        const clientY = this.eventLastTime?.clientY;
        const eClientY = event.clientY;
        if (clientY === eClientY) return null;
        return clientY > eClientY ? "up" : "down";
    }
    createDropTargetEvent(dropTarget, event, hDirection, vDirection, fromNudge) {
        const dropZoneTarget = dropTarget.getContainer();
        const rect = dropZoneTarget.getBoundingClientRect();
        const { dragItem: dragItem, dragSource: dragSource, gos: gos } = this;
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            event: event,
            x: x,
            y: y,
            vDirection: vDirection,
            hDirection: hDirection,
            dragSource: dragSource,
            fromNudge: fromNudge,
            dragItem: dragItem,
            dropZoneTarget: dropZoneTarget
        });
    }
    positionDragAndDropImageComp(event) {
        const dragAndDropImageComponent = this.getDragAndDropImageComponent();
        if (!dragAndDropImageComponent) return;
        $437b23f6a393c3bf$export$3ce6b987cf48b8c2(dragAndDropImageComponent.getGui(), event, this.beans);
    }
    removeDragAndDropImageComponent() {
        const { dragAndDropImageComp: dragAndDropImageComp } = this;
        if (dragAndDropImageComp) {
            const { comp: comp } = dragAndDropImageComp;
            if (comp) {
                const eGui = comp.getGui();
                this.dragAndDropImageParent?.removeChild(eGui);
                this.destroyBean(comp);
            }
        }
        this.dragAndDropImageComp = null;
    }
    createDragAndDropImageComponent() {
        const { dragSource: dragSource, gos: gos, userCompFactory: userCompFactory } = this;
        if (!dragSource) return;
        const userCompDetails = $437b23f6a393c3bf$var$_getDragAndDropImageCompDetails(userCompFactory, $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            dragSource: dragSource
        }));
        if (!userCompDetails) return;
        const promise = userCompDetails.newAgStackInstance();
        this.dragAndDropImageComp = {
            promise: promise
        };
        promise.then((comp)=>{
            if (!comp || !this.isAlive()) return;
            this.processDragAndDropImageComponent(comp);
            this.dragAndDropImageComp.comp = comp;
        });
    }
    processDragAndDropImageComponent(dragAndDropImageComponent) {
        const { dragSource: dragSource, environment: environment } = this;
        if (!dragSource) return;
        const eGui = dragAndDropImageComponent.getGui();
        eGui.style.setProperty("position", "absolute");
        eGui.style.setProperty("z-index", "9999");
        $437b23f6a393c3bf$var$_stampTopLevelGridCompWithGridInstance(this.gos, eGui);
        environment.applyThemeClasses(eGui);
        dragAndDropImageComponent.setIcon(null, false);
        let { dragItemName: dragItemName } = dragSource;
        if (typeof dragItemName === "function") dragItemName = dragItemName();
        dragAndDropImageComponent.setLabel(dragItemName || "");
        eGui.style.top = "20px";
        eGui.style.left = "20px";
        const targetEl = $437b23f6a393c3bf$export$50c54e860701cf22(this.beans);
        this.dragAndDropImageParent = targetEl;
        if (!targetEl) $437b23f6a393c3bf$export$545083624300f13d(54);
        else targetEl.appendChild(eGui);
    }
    registerGridDropTarget(elementFn, ctrl) {
        const dropTarget = {
            getContainer: elementFn,
            isInterestedIn: (type)=>type === 1 /* HeaderCell */  || type === 0 /* ToolPanel */ ,
            getIconName: ()=>"notAllowed"
        };
        this.addDropTarget(dropTarget);
        ctrl.addDestroyFunc(()=>this.removeDropTarget(dropTarget));
    }
};
// packages/ag-grid-community/src/dragAndDrop/dragService.ts
var $437b23f6a393c3bf$var$DragService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "dragSvc";
        this.dragEndFunctions = [];
        this.dragSources = [];
    }
    destroy() {
        const { dragSources: dragSources } = this;
        dragSources.forEach(this.removeListener.bind(this));
        dragSources.length = 0;
        super.destroy();
    }
    removeListener(dragSourceAndListener) {
        const element = dragSourceAndListener.dragSource.eElement;
        const mouseDownListener = dragSourceAndListener.mouseDownListener;
        element.removeEventListener("mousedown", mouseDownListener);
        if (dragSourceAndListener.touchEnabled) {
            const touchStartListener = dragSourceAndListener.touchStartListener;
            element.removeEventListener("touchstart", touchStartListener, {
                passive: true
            });
        }
    }
    removeDragSource(params) {
        const { dragSources: dragSources } = this;
        const dragSourceAndListener = dragSources.find((item)=>item.dragSource === params);
        if (!dragSourceAndListener) return;
        this.removeListener(dragSourceAndListener);
        $437b23f6a393c3bf$export$83a881c8b5120679(dragSources, dragSourceAndListener);
    }
    addDragSource(params) {
        const mouseListener = this.onMouseDown.bind(this, params);
        const { eElement: eElement, includeTouch: includeTouch, stopPropagationForTouch: stopPropagationForTouch } = params;
        eElement.addEventListener("mousedown", mouseListener);
        let touchListener = null;
        const suppressTouch = this.gos.get("suppressTouch");
        if (includeTouch && !suppressTouch) {
            touchListener = (touchEvent)=>{
                if ($437b23f6a393c3bf$var$_isFocusableFormField(touchEvent.target)) return;
                if (stopPropagationForTouch) touchEvent.stopPropagation();
                this.onTouchStart(params, touchEvent);
            };
            eElement.addEventListener("touchstart", touchListener, {
                passive: false
            });
        }
        this.dragSources.push({
            dragSource: params,
            mouseDownListener: mouseListener,
            touchStartListener: touchListener,
            touchEnabled: !!includeTouch
        });
    }
    // gets called whenever mouse down on any drag source
    onTouchStart(params, touchEvent) {
        this.currentDragParams = params;
        this.dragging = false;
        const touch = touchEvent.touches[0];
        this.touchLastTime = touch;
        this.touchStart = touch;
        const touchMoveEvent = (e)=>this.onTouchMove(e, params.eElement);
        const touchEndEvent = (e)=>this.onTouchUp(e, params.eElement);
        const documentTouchMove = (e)=>{
            if (e.cancelable) e.preventDefault();
        };
        const target = touchEvent.target;
        const events = [
            // Prevents the page document from moving while we are dragging items around.
            // preventDefault needs to be called in the touchmove listener and never inside the
            // touchstart, because using touchstart causes the click event to be cancelled on touch devices.
            {
                target: $437b23f6a393c3bf$export$1911dd00c79744c0(this.beans),
                type: "touchmove",
                listener: documentTouchMove,
                options: {
                    passive: false
                }
            },
            {
                target: target,
                type: "touchmove",
                listener: touchMoveEvent,
                options: {
                    passive: true
                }
            },
            {
                target: target,
                type: "touchend",
                listener: touchEndEvent,
                options: {
                    passive: true
                }
            },
            {
                target: target,
                type: "touchcancel",
                listener: touchEndEvent,
                options: {
                    passive: true
                }
            }
        ];
        this.addTemporaryEvents(events);
        if (params.dragStartPixels === 0) this.onCommonMove(touch, this.touchStart, params.eElement);
    }
    // gets called whenever mouse down on any drag source
    onMouseDown(params, mouseEvent) {
        const e = mouseEvent;
        if (params.skipMouseEvent && params.skipMouseEvent(mouseEvent)) return;
        if (e._alreadyProcessedByDragService) return;
        e._alreadyProcessedByDragService = true;
        if (mouseEvent.button !== 0) return;
        if (this.shouldPreventMouseEvent(mouseEvent)) mouseEvent.preventDefault();
        this.currentDragParams = params;
        this.dragging = false;
        this.mouseStartEvent = mouseEvent;
        this.startTarget = mouseEvent.target;
        const mouseMoveEvent = (event)=>this.onMouseMove(event, params.eElement);
        const mouseUpEvent = (event)=>this.onMouseUp(event, params.eElement);
        const contextEvent = (event)=>event.preventDefault();
        const keydownEvent = (event)=>{
            if (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE) this.cancelDrag(params.eElement);
        };
        const target = $437b23f6a393c3bf$export$1911dd00c79744c0(this.beans);
        const events = [
            {
                target: target,
                type: "mousemove",
                listener: mouseMoveEvent
            },
            {
                target: target,
                type: "mouseup",
                listener: mouseUpEvent
            },
            {
                target: target,
                type: "contextmenu",
                listener: contextEvent
            },
            {
                target: target,
                type: "keydown",
                listener: keydownEvent
            }
        ];
        this.addTemporaryEvents(events);
        if (params.dragStartPixels === 0) this.onMouseMove(mouseEvent, params.eElement);
    }
    addTemporaryEvents(events) {
        events.forEach((currentEvent)=>{
            const { target: target, type: type, listener: listener, options: options } = currentEvent;
            target.addEventListener(type, listener, options);
        });
        this.dragEndFunctions.push(()=>{
            events.forEach((currentEvent)=>{
                const { target: target, type: type, listener: listener, options: options } = currentEvent;
                target.removeEventListener(type, listener, options);
            });
        });
    }
    // returns true if the event is close to the original event by X pixels either vertically or horizontally.
    // we only start dragging after X pixels so this allows us to know if we should start dragging yet.
    isEventNearStartEvent(currentEvent, startEvent) {
        const { dragStartPixels: dragStartPixels } = this.currentDragParams;
        const requiredPixelDiff = $437b23f6a393c3bf$export$25d27f17d3af40f7(dragStartPixels) ? dragStartPixels : 4;
        return $437b23f6a393c3bf$var$_areEventsNear(currentEvent, startEvent, requiredPixelDiff);
    }
    getFirstActiveTouch(touchList) {
        for(let i = 0; i < touchList.length; i++){
            if (touchList[i].identifier === this.touchStart.identifier) return touchList[i];
        }
        return null;
    }
    onCommonMove(currentEvent, startEvent, el) {
        if (!this.dragging) {
            if (this.isEventNearStartEvent(currentEvent, startEvent)) return;
            this.dragging = true;
            this.eventSvc.dispatchEvent({
                type: "dragStarted",
                target: el
            });
            this.currentDragParams.onDragStart(startEvent);
            if (!this.currentDragParams) {
                this.dragging = false;
                return;
            }
            this.currentDragParams.onDragging(startEvent);
        }
        this.currentDragParams?.onDragging(currentEvent);
    }
    onTouchMove(touchEvent, el) {
        const touch = this.getFirstActiveTouch(touchEvent.touches);
        if (!touch) return;
        this.onCommonMove(touch, this.touchStart, el);
    }
    // only gets called after a mouse down - as this is only added after mouseDown
    // and is removed when mouseUp happens
    onMouseMove(mouseEvent, el) {
        if ($437b23f6a393c3bf$var$_isBrowserSafari()) {
            const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
            eDocument.getSelection()?.removeAllRanges();
        }
        if (this.shouldPreventMouseEvent(mouseEvent)) mouseEvent.preventDefault();
        this.onCommonMove(mouseEvent, this.mouseStartEvent, el);
    }
    shouldPreventMouseEvent(mouseEvent) {
        const { gos: gos } = this;
        const isEnableCellTextSelect = gos.get("enableCellTextSelection");
        const isMouseMove = mouseEvent.type === "mousemove";
        const isOverFormFieldElement = (mouseEvent2)=>{
            const el = mouseEvent2.target;
            const tagName = el?.tagName.toLocaleLowerCase();
            return !!tagName?.match("^a$|textarea|input|select|button");
        };
        return(// when `isEnableCellTextSelect` is `true`, we need to preventDefault on mouseMove
        // to avoid the grid text being selected while dragging components.
        isEnableCellTextSelect && isMouseMove && mouseEvent.cancelable && $437b23f6a393c3bf$var$_isEventFromThisGrid(gos, mouseEvent) && !isOverFormFieldElement(mouseEvent));
    }
    onTouchUp(touchEvent, el) {
        let touch = this.getFirstActiveTouch(touchEvent.changedTouches);
        if (!touch) touch = this.touchLastTime;
        this.onUpCommon(touch, el);
    }
    onMouseUp(mouseEvent, el) {
        this.onUpCommon(mouseEvent, el);
    }
    onUpCommon(eventOrTouch, el) {
        if (this.dragging) {
            this.dragging = false;
            this.currentDragParams.onDragStop(eventOrTouch);
            this.eventSvc.dispatchEvent({
                type: "dragStopped",
                target: el
            });
        }
        this.resetDragProperties();
    }
    cancelDrag(el) {
        this.eventSvc.dispatchEvent({
            type: "dragCancelled",
            target: el
        });
        this.currentDragParams?.onDragCancel?.();
        this.resetDragProperties();
    }
    resetDragProperties() {
        this.mouseStartEvent = null;
        this.startTarget = null;
        this.touchStart = null;
        this.touchLastTime = null;
        this.currentDragParams = null;
        const { dragEndFunctions: dragEndFunctions } = this;
        dragEndFunctions.forEach((func)=>func());
        dragEndFunctions.length = 0;
    }
};
// packages/ag-grid-community/src/entities/agColumnGroup.ts
function $437b23f6a393c3bf$var$createUniqueColumnGroupId(groupId, instanceId) {
    return groupId + "_" + instanceId;
}
function $437b23f6a393c3bf$export$1f44a60fc23f9028(col) {
    return col instanceof $437b23f6a393c3bf$export$273c80940a54c770;
}
var $437b23f6a393c3bf$export$273c80940a54c770 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(providedColumnGroup, groupId, partId, pinned){
        super();
        this.providedColumnGroup = providedColumnGroup;
        this.groupId = groupId;
        this.partId = partId;
        this.pinned = pinned;
        this.isColumn = false;
        // depends on the open/closed state of the group, only displaying columns are stored here
        this.displayedChildren = [];
        // The measured height of this column's header when autoHeaderHeight is enabled
        this.autoHeaderHeight = null;
        this.parent = null;
    }
    // as the user is adding and removing columns, the groups are recalculated.
    // this reset clears out all children, ready for children to be added again
    reset() {
        this.parent = null;
        this.children = null;
        this.displayedChildren = null;
    }
    getParent() {
        return this.parent;
    }
    getUniqueId() {
        return $437b23f6a393c3bf$var$createUniqueColumnGroupId(this.groupId, this.partId);
    }
    isEmptyGroup() {
        return this.displayedChildren.length === 0;
    }
    isMoving() {
        const allLeafColumns = this.getProvidedColumnGroup().getLeafColumns();
        if (!allLeafColumns || allLeafColumns.length === 0) return false;
        return allLeafColumns.every((col)=>col.isMoving());
    }
    checkLeft() {
        this.displayedChildren.forEach((child)=>{
            if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) child.checkLeft();
        });
        if (this.displayedChildren.length > 0) {
            if (this.gos.get("enableRtl")) {
                const lastChild = $437b23f6a393c3bf$export$236389741107357f(this.displayedChildren);
                const lastChildLeft = lastChild.getLeft();
                this.setLeft(lastChildLeft);
            } else {
                const firstChildLeft = this.displayedChildren[0].getLeft();
                this.setLeft(firstChildLeft);
            }
        } else this.setLeft(null);
    }
    getLeft() {
        return this.left;
    }
    getOldLeft() {
        return this.oldLeft;
    }
    setLeft(left) {
        this.oldLeft = this.left;
        if (this.left !== left) {
            this.left = left;
            this.dispatchLocalEvent({
                type: "leftChanged"
            });
        }
    }
    getPinned() {
        return this.pinned;
    }
    getGroupId() {
        return this.groupId;
    }
    getPartId() {
        return this.partId;
    }
    getActualWidth() {
        let groupActualWidth = 0;
        this.displayedChildren?.forEach((child)=>{
            groupActualWidth += child.getActualWidth();
        });
        return groupActualWidth;
    }
    isResizable() {
        if (!this.displayedChildren) return false;
        let result = false;
        this.displayedChildren.forEach((child)=>{
            if (child.isResizable()) result = true;
        });
        return result;
    }
    getMinWidth() {
        let result = 0;
        this.displayedChildren.forEach((groupChild)=>{
            result += groupChild.getMinWidth();
        });
        return result;
    }
    addChild(child) {
        if (!this.children) this.children = [];
        this.children.push(child);
    }
    getDisplayedChildren() {
        return this.displayedChildren;
    }
    getLeafColumns() {
        const result = [];
        this.addLeafColumns(result);
        return result;
    }
    getDisplayedLeafColumns() {
        const result = [];
        this.addDisplayedLeafColumns(result);
        return result;
    }
    getDefinition() {
        return this.providedColumnGroup.getColGroupDef();
    }
    getColGroupDef() {
        return this.providedColumnGroup.getColGroupDef();
    }
    isPadding() {
        return this.providedColumnGroup.isPadding();
    }
    isExpandable() {
        return this.providedColumnGroup.isExpandable();
    }
    isExpanded() {
        return this.providedColumnGroup.isExpanded();
    }
    setExpanded(expanded) {
        this.providedColumnGroup.setExpanded(expanded);
    }
    isAutoHeaderHeight() {
        return !!this.getColGroupDef()?.autoHeaderHeight;
    }
    getAutoHeaderHeight() {
        return this.autoHeaderHeight;
    }
    /** Returns true if the header height has changed */ setAutoHeaderHeight(height) {
        const changed = height !== this.autoHeaderHeight;
        this.autoHeaderHeight = height;
        return changed;
    }
    addDisplayedLeafColumns(leafColumns) {
        this.displayedChildren.forEach((child)=>{
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) leafColumns.push(child);
            else if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) child.addDisplayedLeafColumns(leafColumns);
        });
    }
    addLeafColumns(leafColumns) {
        this.children.forEach((child)=>{
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) leafColumns.push(child);
            else if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) child.addLeafColumns(leafColumns);
        });
    }
    getChildren() {
        return this.children;
    }
    getColumnGroupShow() {
        return this.providedColumnGroup.getColumnGroupShow();
    }
    getProvidedColumnGroup() {
        return this.providedColumnGroup;
    }
    getPaddingLevel() {
        const parent = this.getParent();
        if (!this.isPadding() || !parent || !parent.isPadding()) return 0;
        return 1 + parent.getPaddingLevel();
    }
    calculateDisplayedColumns() {
        this.displayedChildren = [];
        let parentWithExpansion = this;
        while(parentWithExpansion != null && parentWithExpansion.isPadding())parentWithExpansion = parentWithExpansion.getParent();
        const isExpandable = parentWithExpansion ? parentWithExpansion.getProvidedColumnGroup().isExpandable() : false;
        if (!isExpandable) {
            this.displayedChildren = this.children;
            this.dispatchLocalEvent({
                type: "displayedChildrenChanged"
            });
            return;
        }
        this.children.forEach((child)=>{
            const emptyGroup = $437b23f6a393c3bf$export$1f44a60fc23f9028(child) && !child.displayedChildren?.length;
            if (emptyGroup) return;
            const headerGroupShow = child.getColumnGroupShow();
            switch(headerGroupShow){
                case "open":
                    if (parentWithExpansion.getProvidedColumnGroup().isExpanded()) this.displayedChildren.push(child);
                    break;
                case "closed":
                    if (!parentWithExpansion.getProvidedColumnGroup().isExpanded()) this.displayedChildren.push(child);
                    break;
                default:
                    this.displayedChildren.push(child);
                    break;
            }
        });
        this.dispatchLocalEvent({
            type: "displayedChildrenChanged"
        });
    }
};
// packages/ag-grid-community/src/entities/rowNode.ts
var $437b23f6a393c3bf$export$cb038fdaa8338d9f = "row-group-";
var $437b23f6a393c3bf$export$27b0e4a919abc336 = "t-";
var $437b23f6a393c3bf$export$5f755686e611c1ea = "b-";
var $437b23f6a393c3bf$var$OBJECT_ID_SEQUENCE = 0;
var $437b23f6a393c3bf$export$6af91cd58ec2edf9 = class {
    constructor(beans){
        /** `true` if this row is a master row, part of master / detail (ie row can be expanded to show detail) */ this.master = false;
        /** `true` if this row is a detail row, part of master / detail (ie child row of an expanded master row)*/ this.detail = void 0;
        /** The current row index. If the row is filtered out or in a collapsed group, this value is set to `null`. */ this.rowIndex = null;
        /** The key for the group eg Ireland, UK, USA */ this.key = null;
        /**
     * The index of the row in the source rowData array including any updates via transactions.
     * It does not change when sorting, filtering, grouping, pivoting or any other UI related operations.
     * If this is a filler node (a visual row created by AG Grid in tree data or grouping) the value is set to `-1`.
     *
     * Generally readonly. It is modified only by:
     * - ClientSideNodeManager, cast to ClientSideNodeManagerRowNode
     * - ClientSideRowModel, cast to ClientSideRowModelRowNode
     */ this.sourceRowIndex = -1;
        /** Children mapped by the pivot columns or group key */ this.childrenMapped = null;
        /**
     * Parent RowNode for tree data.
     * When set, the parent node in the hierarchy is updated during Client-Side Row Model (CSRM) grouping.
     * Used by the ClientSideChildrenTreeNodeManager, TreeGroupStrategy, RowDragFeature
     */ this.treeParent = null;
        /** The flags associated to this node. Used only internally within TreeGroupStrategy. */ this.treeNodeFlags = 0;
        /**
     * This is `true` if the row has a rowIndex assigned, otherwise `false`.
     */ this.displayed = false;
        /** The row top position in pixels. */ this.rowTop = null;
        /** The top pixel for this row last time, makes sense if data set was ordered or filtered,
     * it is used so new rows can animate in from their old position. */ this.oldRowTop = null;
        /** `true` by default - can be overridden via gridOptions.isRowSelectable(rowNode) */ this.selectable = true;
        /**
     * Used by sorting service - to give deterministic sort to groups. Previously we
     * just id for this, however id is a string and had slower sorting compared to numbers.
     * If re-naming this property, you must also update `IGNORED_SIBLING_PROPERTIES`
     */ this.__objectId = $437b23f6a393c3bf$var$OBJECT_ID_SEQUENCE++;
        /** `true` when nodes with the same id are being removed and added as part of the same batch transaction */ this.alreadyRendered = false;
        this.hovered = false;
        this.__selected = false;
        this.beans = beans;
    }
    /**
   * Replaces the data on the `rowNode`. When this method is called, the grid refreshes the entire rendered row if it is displayed.
   */ setData(data) {
        this.setDataCommon(data, false);
    }
    // similar to setRowData, however it is expected that the data is the same data item. this
    // is intended to be used with Redux type stores, where the whole data can be changed. we are
    // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
    // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
    // dataChanged event, refreshes the cells rather than rip them all out (so user can show transitions).
    /**
   * Updates the data on the `rowNode`. When this method is called, the grid refreshes the entire rendered row if it is displayed.
   */ updateData(data) {
        this.setDataCommon(data, true);
    }
    setDataCommon(data, update) {
        const { valueCache: valueCache, eventSvc: eventSvc } = this.beans;
        const oldData = this.data;
        this.data = data;
        valueCache?.onDataChanged();
        this.updateDataOnDetailNode();
        this.resetQuickFilterAggregateText();
        const event = this.createDataChangedEvent(data, oldData, update);
        this.__localEventService?.dispatchEvent(event);
        if (this.sibling) {
            this.sibling.data = data;
            const event2 = this.sibling.createDataChangedEvent(data, oldData, update);
            this.sibling.__localEventService?.dispatchEvent(event2);
        }
        eventSvc.dispatchEvent({
            type: "rowNodeDataChanged",
            node: this
        });
        const pinnedSibling = this.pinnedSibling;
        if (pinnedSibling) {
            pinnedSibling.data = data;
            pinnedSibling.__localEventService?.dispatchEvent(pinnedSibling.createDataChangedEvent(data, oldData, update));
            eventSvc.dispatchEvent({
                type: "rowNodeDataChanged",
                node: pinnedSibling
            });
        }
    }
    // when we are doing master / detail, the detail node is lazy created, but then kept around.
    // so if we show / hide the detail, the same detail rowNode is used. so we need to keep the data
    // in sync, otherwise expand/collapse of the detail would still show the old values.
    updateDataOnDetailNode() {
        if (this.detailNode) this.detailNode.data = this.data;
    }
    createDataChangedEvent(newData, oldData, update) {
        return {
            type: "dataChanged",
            node: this,
            oldData: oldData,
            newData: newData,
            update: update
        };
    }
    getRowIndexString() {
        if (this.rowIndex == null) {
            $437b23f6a393c3bf$export$a20c7248650823a9(13);
            return null;
        }
        if (this.rowPinned === "top") return $437b23f6a393c3bf$export$27b0e4a919abc336 + this.rowIndex;
        if (this.rowPinned === "bottom") return $437b23f6a393c3bf$export$5f755686e611c1ea + this.rowIndex;
        return this.rowIndex.toString();
    }
    setDataAndId(data, id) {
        const { selectionSvc: selectionSvc } = this.beans;
        const oldNode = selectionSvc?.createDaemonNode?.(this);
        const oldData = this.data;
        this.data = data;
        this.updateDataOnDetailNode();
        this.setId(id);
        if (selectionSvc) {
            selectionSvc.updateRowSelectable(this);
            selectionSvc.syncInRowNode(this, oldNode);
        }
        const event = this.createDataChangedEvent(data, oldData, false);
        this.__localEventService?.dispatchEvent(event);
    }
    setId(id) {
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.beans.gos);
        if (getRowIdFunc) {
            if (this.data) {
                const parentKeys = this.parent?.getRoute() ?? [];
                this.id = getRowIdFunc({
                    data: this.data,
                    parentKeys: parentKeys.length > 0 ? parentKeys : void 0,
                    level: this.level,
                    rowPinned: this.rowPinned
                });
                if (this.id.startsWith($437b23f6a393c3bf$export$cb038fdaa8338d9f)) $437b23f6a393c3bf$export$a20c7248650823a9(14, {
                    groupPrefix: $437b23f6a393c3bf$export$cb038fdaa8338d9f
                });
            } else this.id = void 0;
        } else this.id = id;
    }
    setRowTop(rowTop) {
        this.oldRowTop = this.rowTop;
        if (this.rowTop === rowTop) return;
        this.rowTop = rowTop;
        this.dispatchRowEvent("topChanged");
        this.setDisplayed(rowTop !== null);
    }
    clearRowTopAndRowIndex() {
        this.oldRowTop = null;
        this.setRowTop(null);
        this.setRowIndex(null);
    }
    setHovered(hovered) {
        this.hovered = hovered;
    }
    isHovered() {
        return this.hovered;
    }
    /**
   * Sets the row height.
   * Call if you want to change the height initially assigned to the row.
   * After calling, you must call `api.onRowHeightChanged()` so the grid knows it needs to work out the placement of the rows. */ setRowHeight(rowHeight, estimated = false) {
        this.rowHeight = rowHeight;
        this.rowHeightEstimated = estimated;
        this.dispatchRowEvent("heightChanged");
    }
    setExpanded(expanded, e, forceSync) {
        this.beans.expansionSvc?.setExpanded(this, expanded, e, forceSync);
    }
    /**
   * Replaces the value on the `rowNode` for the specified column. When complete,
   * the grid refreshes the rendered cell on the required row only.
   * **Note**: This method only fires `onCellEditRequest` when the Grid is in **Read Only** mode.
   * **Note**: This method defers to EditModule if available and batches the edit when `fullRow` or `batchEdit` is enabled.
   *
   * @param colKey The column where the value should be updated
   * @param newValue The new value
   * @param eventSource The source of the event
   * @returns `true` if the value was changed, otherwise `false`.
   */ setDataValue(colKey, newValue, eventSource) {
        const { colModel: colModel, valueSvc: valueSvc, gos: gos, editSvc: editSvc } = this.beans;
        const column = typeof colKey !== "string" ? colKey : colModel.getCol(colKey) ?? colModel.getColDefCol(colKey);
        if (!column) return false;
        const oldValue = valueSvc.getValueForDisplay(column, this, void 0, void 0, "api").value;
        if (gos.get("readOnlyEdit")) {
            const { beans: { eventSvc: eventSvc }, data: data, rowIndex: rowIndex, rowPinned: rowPinned } = this;
            eventSvc.dispatchEvent({
                type: "cellEditRequest",
                event: null,
                rowIndex: rowIndex,
                rowPinned: rowPinned,
                column: column,
                colDef: column.colDef,
                data: data,
                node: this,
                oldValue: oldValue,
                newValue: newValue,
                value: newValue,
                source: eventSource
            });
            return false;
        }
        if (editSvc && !editSvc.committing) {
            const result = editSvc.setDataValue({
                rowNode: this,
                column: column
            }, newValue, eventSource);
            if (result != null) return result;
        }
        const valueChanged = valueSvc.setValue(this, column, newValue, eventSource);
        this.dispatchCellChangedEvent(column, newValue, oldValue);
        const pinnedSibling = this.pinnedSibling;
        if (pinnedSibling) {
            if (valueChanged) pinnedSibling.dispatchCellChangedEvent(column, newValue, oldValue);
        }
        return valueChanged;
    }
    updateHasChildren() {
        let newValue = this.group && !this.footer || this.childrenAfterGroup && this.childrenAfterGroup.length > 0;
        const { rowChildrenSvc: rowChildrenSvc } = this.beans;
        if (rowChildrenSvc) newValue = rowChildrenSvc.getHasChildrenValue(this);
        if (newValue !== this.__hasChildren) {
            this.__hasChildren = !!newValue;
            this.dispatchRowEvent("hasChildrenChanged");
        }
    }
    hasChildren() {
        if (this.__hasChildren == null) this.updateHasChildren();
        return this.__hasChildren;
    }
    dispatchCellChangedEvent(column, newValue, oldValue) {
        const cellChangedEvent = {
            type: "cellChanged",
            node: this,
            column: column,
            newValue: newValue,
            oldValue: oldValue
        };
        this.__localEventService?.dispatchEvent(cellChangedEvent);
    }
    /**
   * The first time `quickFilter` runs, the grid creates a one-off string representation of the row.
   * This string is then used for the quick filter instead of hitting each column separately.
   * When you edit, using grid editing, this string gets cleared down.
   * However, if you edit without using grid editing, you need to clear this string down for the row to be updated with the new values.
   * Otherwise, new values would not work with the `quickFilter`. */ resetQuickFilterAggregateText() {
        this.quickFilterAggregateText = null;
    }
    /** Returns:
   * - `true` if the node can be expanded, i.e it is a group or master row.
   * - `false` if the node cannot be expanded
   */ isExpandable() {
        return this.beans.expansionSvc?.isExpandable(this) ?? false;
    }
    /** Returns:
   * - `true` if node is selected,
   * - `false` if the node isn't selected
   * - `undefined` if it's partially selected (group where not all children are selected). */ isSelected() {
        if (this.footer) return this.sibling.isSelected();
        if (this.rowPinned && this.pinnedSibling) return this.pinnedSibling.isSelected();
        return this.__selected;
    }
    /** Perform a depth-first search of this node and its children. */ depthFirstSearch(callback) {
        this.childrenAfterGroup?.forEach((child)=>child.depthFirstSearch(callback));
        callback(this);
    }
    dispatchRowEvent(type) {
        this.__localEventService?.dispatchEvent({
            type: type,
            node: this
        });
    }
    /**
   * Select (or deselect) the node.
   * @param newValue -`true` for selection, `false` for deselection.
   * @param clearSelection - If selecting, then passing `true` selects the node exclusively (i.e. NOT do multi select). If doing deselection, `clearSelection` has no impact.
   * @param source - Source property that appears in the `selectionChanged` event.
   */ setSelected(newValue, clearSelection = false, source = "api") {
        this.beans.selectionSvc?.setNodesSelected({
            nodes: [
                this
            ],
            newValue: newValue,
            clearSelection: clearSelection,
            source: source
        });
    }
    /**
   * Returns:
   * - `true` if node is either pinned to the `top` or `bottom`
   * - `false` if the node isn't pinned
   */ isRowPinned() {
        return !!this.rowPinned;
    }
    __addEventListener(eventType, listener) {
        if (!this.__localEventService) this.__localEventService = new $437b23f6a393c3bf$export$820da7696a401cdc();
        this.__localEventService.addEventListener(eventType, listener);
    }
    __removeEventListener(eventType, listener) {
        this.removeLocalListener(eventType, listener);
    }
    /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */ addEventListener(eventType, userListener) {
        this.beans.validation?.checkRowEvents(eventType);
        if (!this.__localEventService) this.__localEventService = new $437b23f6a393c3bf$export$820da7696a401cdc();
        this.frameworkEventListenerService = this.beans.frameworkOverrides.createLocalEventListenerWrapper?.(this.frameworkEventListenerService, this.__localEventService);
        const listener = this.frameworkEventListenerService?.wrap(eventType, userListener) ?? userListener;
        this.__localEventService.addEventListener(eventType, listener);
    }
    /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */ removeEventListener(eventType, userListener) {
        const listener = this.frameworkEventListenerService?.unwrap(eventType, userListener) ?? userListener;
        this.removeLocalListener(eventType, listener);
    }
    removeLocalListener(eventType, listener) {
        this.__localEventService?.removeEventListener(eventType, listener);
        if (this.__localEventService?.noRegisteredListenersExist()) this.__localEventService = null;
    }
    /**
   * @deprecated v32.2.0 Check `node.detail` then user provided callback `isFullWidthRow` instead.
   *
   * Returns:
   * - `true` if the node is a full width cell
   * - `false` if the node is not a full width cell
   */ isFullWidthCell() {
        $437b23f6a393c3bf$export$545083624300f13d(61);
        if (this.detail) return true;
        const isFullWidthCellFunc = this.beans.gos.getCallback("isFullWidthRow");
        return isFullWidthCellFunc ? isFullWidthCellFunc({
            rowNode: this
        }) : false;
    }
    /**
   * Returns the route of keys to the row node. Returns undefined if the node has no key.
   */ getRoute() {
        if (this.level === -1) return [];
        if (this.key == null) return void 0;
        const res = [];
        let pointer = this;
        while(pointer && pointer.key != null){
            res.push(pointer.key);
            pointer = pointer.parent;
        }
        return res.reverse();
    }
    setFirstChild(firstChild) {
        if (this.firstChild !== firstChild) {
            this.firstChild = firstChild;
            this.dispatchRowEvent("firstChildChanged");
        }
    }
    setDisplayed(displayed) {
        if (this.displayed !== displayed) {
            this.displayed = displayed;
            this.dispatchRowEvent("displayedChanged");
        }
    }
    setRowIndex(rowIndex) {
        if (this.rowIndex !== rowIndex) {
            this.rowIndex = rowIndex;
            this.dispatchRowEvent("rowIndexChanged");
        }
    }
    setAllChildrenCount(allChildrenCount) {
        if (this.allChildrenCount !== allChildrenCount) {
            this.allChildrenCount = allChildrenCount;
            this.dispatchRowEvent("allChildrenCountChanged");
        }
    }
    setUiLevel(uiLevel) {
        if (this.uiLevel !== uiLevel) {
            this.uiLevel = uiLevel;
            this.dispatchRowEvent("uiLevelChanged");
        }
    }
    getFirstChild() {
        if (this.childStore) return this.childStore.getFirstNode();
        return this.childrenAfterSort?.[0] ?? null;
    }
};
// packages/ag-grid-community/src/entities/rowNodeUtils.ts
function $437b23f6a393c3bf$export$5c5bd6257397e1bc(rowNode, gos, type) {
    return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        type: type,
        node: rowNode,
        data: rowNode.data,
        rowIndex: rowNode.rowIndex,
        rowPinned: rowNode.rowPinned
    });
}
var $437b23f6a393c3bf$var$IGNORED_SIBLING_PROPERTIES = /* @__PURE__ */ new Set([
    "__localEventService",
    "__objectId",
    "sticky",
    "__autoHeights",
    "__checkAutoHeightsDebounced",
    "childStore"
]);
function $437b23f6a393c3bf$export$48fabbbfcde9fe36(rowNode, beans) {
    const sibling = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(beans);
    Object.keys(rowNode).forEach((key)=>{
        if ($437b23f6a393c3bf$var$IGNORED_SIBLING_PROPERTIES.has(key)) return;
        sibling[key] = rowNode[key];
    });
    sibling.oldRowTop = null;
    return sibling;
}
// packages/ag-grid-community/src/filter/columnFilterUtils.ts
var $437b23f6a393c3bf$var$FILTER_HANDLER_MAP = {
    agSetColumnFilter: "agSetColumnFilterHandler",
    agMultiColumnFilter: "agMultiColumnFilterHandler",
    agGroupColumnFilter: "agGroupColumnFilterHandler",
    agNumberColumnFilter: "agNumberColumnFilterHandler",
    agDateColumnFilter: "agDateColumnFilterHandler",
    agTextColumnFilter: "agTextColumnFilterHandler"
};
var $437b23f6a393c3bf$var$FILTER_HANDLERS = new Set(Object.values($437b23f6a393c3bf$var$FILTER_HANDLER_MAP));
function $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper, skipCreate) {
    const filterUi = filterWrapper.filterUi;
    if (!filterUi) return null;
    if (filterUi.created) return filterUi.promise;
    if (skipCreate) return null;
    const promise = filterUi.create(filterUi.refreshed);
    const createdFilterUi = filterUi;
    createdFilterUi.created = true;
    createdFilterUi.promise = promise;
    return promise;
}
function $437b23f6a393c3bf$export$1fc9ad198b29415d(getFilterUi, handler, handlerParams, model, state, source) {
    handler.refresh?.({
        ...handlerParams,
        model: model,
        source: source
    });
    return getFilterUi().then((filterUi)=>{
        if (filterUi) {
            const { filter: filter, filterParams: filterParams } = filterUi;
            $437b23f6a393c3bf$export$8e370ccb0273c891(filter, filterParams, model, state, source);
        }
    });
}
function $437b23f6a393c3bf$export$8e370ccb0273c891(filter, filterParams, model, state, source) {
    filter?.refresh?.({
        ...filterParams,
        model: model,
        state: state,
        source: source
    });
}
function $437b23f6a393c3bf$var$getAndRefreshFilterUi(getFilterUi, getModel, getState2) {
    const filterUi = getFilterUi();
    if (filterUi?.created) filterUi.promise.then((filter)=>{
        const model = getModel();
        $437b23f6a393c3bf$export$8e370ccb0273c891(filter, filterUi.filterParams, model, getState2() ?? {
            model: model
        }, "ui");
    });
}
function $437b23f6a393c3bf$export$3305e8c6f4c8572a(action, getFilterUi, getModel, getState2, updateState, updateModel) {
    let state;
    let shouldUpdateModel = false;
    let model;
    switch(action){
        case "apply":
            {
                const oldState = getState2();
                model = oldState?.model ?? null;
                state = {
                    // keep the other UI state
                    state: oldState?.state,
                    model: model
                };
                shouldUpdateModel = true;
                break;
            }
        case "clear":
            state = {
                // wipe other UI state
                model: null
            };
            break;
        case "reset":
            state = {
                // wipe other UI state
                model: null
            };
            shouldUpdateModel = true;
            model = null;
            break;
        case "cancel":
            state = {
                // wipe other UI state
                model: getModel()
            };
            break;
    }
    updateState(state);
    if (shouldUpdateModel) updateModel(model);
    else $437b23f6a393c3bf$var$getAndRefreshFilterUi(getFilterUi, getModel, getState2);
}
function $437b23f6a393c3bf$export$8981db65da4532f2(model, colId) {
    return model[colId] ?? null;
}
// packages/ag-grid-community/src/filter/filterButtonComp.ts
function $437b23f6a393c3bf$var$getElement(className) {
    return {
        tag: "div",
        cls: className
    };
}
var $437b23f6a393c3bf$export$226c2a54d31bd592 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(config){
        const { className: className = "ag-filter-apply-panel" } = config ?? {};
        super($437b23f6a393c3bf$var$getElement(className));
        this.listeners = [];
        this.validationMessage = null;
        this.className = className;
    }
    updateButtons(buttons, useForm) {
        const oldButtons = this.buttons;
        this.buttons = buttons;
        if (oldButtons === buttons) return;
        const eGui = this.getGui();
        $437b23f6a393c3bf$export$69e6e10709eabd91(eGui);
        let eApplyButton;
        this.destroyListeners();
        const fragment = document.createDocumentFragment();
        const className = this.className;
        const addButton = ({ type: type, label: label })=>{
            const clickListener = (event)=>{
                this.dispatchLocalEvent({
                    type: type,
                    event: event
                });
            };
            if (![
                "apply",
                "clear",
                "reset",
                "cancel"
            ].includes(type)) $437b23f6a393c3bf$export$545083624300f13d(75);
            const isApply = type === "apply";
            const buttonType = isApply && useForm ? "submit" : "button";
            const button = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "button",
                attrs: {
                    type: buttonType
                },
                ref: `${type}FilterButton`,
                cls: `ag-button ag-standard-button ${className}-button${isApply ? " " + className + "-apply-button" : ""}`,
                children: label
            });
            this.activateTabIndex([
                button
            ]);
            if (isApply) eApplyButton = button;
            const keydownListener = (event)=>{
                if (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) {
                    event.preventDefault();
                    clickListener(event);
                }
            };
            const listeners = this.listeners;
            button.addEventListener("click", clickListener);
            listeners.push(()=>button.removeEventListener("click", clickListener));
            button.addEventListener("keydown", keydownListener);
            listeners.push(()=>button.removeEventListener("keydown", keydownListener));
            fragment.append(button);
        };
        buttons.forEach((button)=>addButton(button));
        this.eApply = eApplyButton;
        const tooltip = this.validationTooltipFeature;
        if (eApplyButton && !tooltip) this.validationTooltipFeature = this.createOptionalManagedBean(this.beans.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.eApply,
            getLocation: ()=>"advancedFilter",
            getTooltipShowDelayOverride: ()=>1e3
        }));
        else if (!eApplyButton && tooltip) this.validationTooltipFeature = this.destroyBean(tooltip);
        eGui.append(fragment);
    }
    getApplyButton() {
        return this.eApply;
    }
    updateValidity(valid, message = null) {
        const eApplyButton = this.eApply;
        if (!eApplyButton) return;
        $437b23f6a393c3bf$export$b6b4f08392e9bfaf(eApplyButton, valid === false);
        this.validationMessage = message ?? null;
        this.validationTooltipFeature?.setTooltipAndRefresh(this.validationMessage);
    }
    destroyListeners() {
        this.listeners.forEach((destroyFunc)=>destroyFunc());
        this.listeners = [];
    }
    destroy() {
        this.destroyListeners();
        super.destroy();
    }
};
var $437b23f6a393c3bf$export$4a8eed8acd632fcc = {
    selector: "AG-FILTER-BUTTON",
    component: $437b23f6a393c3bf$export$226c2a54d31bd592
};
// packages/ag-grid-community/src/filter/filterLocaleText.ts
var $437b23f6a393c3bf$var$FILTER_LOCALE_TEXT = {
    applyFilter: "Apply",
    clearFilter: "Clear",
    resetFilter: "Reset",
    cancelFilter: "Cancel",
    textFilter: "Text Filter",
    numberFilter: "Number Filter",
    dateFilter: "Date Filter",
    setFilter: "Set Filter",
    filterOoo: "Filter...",
    empty: "Choose one",
    equals: "Equals",
    notEqual: "Does not equal",
    lessThan: "Less than",
    greaterThan: "Greater than",
    inRange: "Between",
    inRangeStart: "From",
    inRangeEnd: "To",
    lessThanOrEqual: "Less than or equal to",
    greaterThanOrEqual: "Greater than or equal to",
    contains: "Contains",
    notContains: "Does not contain",
    startsWith: "Begins with",
    endsWith: "Ends with",
    blank: "Blank",
    notBlank: "Not blank",
    before: "Before",
    after: "After",
    andCondition: "AND",
    orCondition: "OR",
    dateFormatOoo: "yyyy-mm-dd",
    filterSummaryInactive: "is (All)",
    filterSummaryContains: "contains",
    filterSummaryNotContains: "does not contain",
    filterSummaryTextEquals: "equals",
    filterSummaryTextNotEqual: "does not equal",
    filterSummaryStartsWith: "begins with",
    filterSummaryEndsWith: "ends with",
    filterSummaryBlank: "is blank",
    filterSummaryNotBlank: "is not blank",
    filterSummaryEquals: "=",
    filterSummaryNotEqual: "!=",
    filterSummaryGreaterThan: ">",
    filterSummaryGreaterThanOrEqual: ">=",
    filterSummaryLessThan: "<",
    filterSummaryLessThanOrEqual: "<=",
    filterSummaryInRange: "between",
    filterSummaryInRangeValues: (variableValues)=>`(${variableValues[0]}, ${variableValues[1]})`,
    filterSummaryTextQuote: (variableValues)=>`"${variableValues[0]}"`
};
function $437b23f6a393c3bf$export$e2a0ae4af921fff8(bean, key, variableValues) {
    return $437b23f6a393c3bf$export$4ad3db330991f17d(bean, $437b23f6a393c3bf$var$FILTER_LOCALE_TEXT, key, variableValues);
}
// packages/ag-grid-community/src/filter/provided/providedFilterUtils.ts
function $437b23f6a393c3bf$var$getDebounceMs(params, debounceDefault) {
    const { debounceMs: debounceMs } = params;
    if ($437b23f6a393c3bf$export$527c1b777ebd9069(params)) {
        if (debounceMs != null) $437b23f6a393c3bf$export$545083624300f13d(71);
        return 0;
    }
    return debounceMs ?? debounceDefault;
}
function $437b23f6a393c3bf$export$527c1b777ebd9069(params) {
    return (params.buttons?.indexOf("apply") ?? -1) >= 0;
}
// packages/ag-grid-community/src/filter/filterWrapperComp.ts
var $437b23f6a393c3bf$export$70acaf0e0e30e7d = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(column, wrapper, eventParent, updateModel, isGlobalButtons, enableGlobalButtonCheck){
        super();
        this.column = column;
        this.wrapper = wrapper;
        this.eventParent = eventParent;
        this.updateModel = updateModel;
        this.isGlobalButtons = isGlobalButtons;
        this.enableGlobalButtonCheck = enableGlobalButtonCheck;
        this.hidePopup = null;
        this.applyActive = false;
    }
    postConstruct() {
        const { comp: comp, params: originalParams } = this.wrapper;
        const params = originalParams;
        const useForm = params.useForm;
        const tag = useForm ? "form" : "div";
        this.setTemplate({
            tag: tag,
            cls: "ag-filter-wrapper"
        });
        if (useForm) this.addManagedElementListeners(this.getGui(), {
            submit: (e)=>{
                e?.preventDefault();
            },
            keydown: this.handleKeyDown.bind(this)
        });
        this.appendChild(comp.getGui());
        this.params = params;
        this.resetButtonsPanel(params);
        this.addManagedListeners(this.eventParent, {
            filterParamsChanged: ({ column: column, params: eventParams })=>{
                if (column === this.column) this.resetButtonsPanel(eventParams, this.params);
            },
            filterStateChanged: ({ column: column, state: state })=>{
                if (column === this.column) this.eButtons?.updateValidity(state.valid !== false);
            },
            filterAction: ({ column: column, action: action, event: keyboardEvent })=>{
                if (column === this.column) this.afterAction(action, keyboardEvent);
            },
            ...this.enableGlobalButtonCheck ? {
                filterGlobalButtons: ({ isGlobal: isGlobal })=>{
                    if (isGlobal !== this.isGlobalButtons) {
                        this.isGlobalButtons = isGlobal;
                        const currentParams = this.params;
                        this.resetButtonsPanel(currentParams, currentParams, true);
                    }
                }
            } : void 0
        });
    }
    afterGuiAttached(params) {
        if (params) this.hidePopup = params.hidePopup;
    }
    resetButtonsPanel(newParams, oldParams, forceUpdate) {
        const { buttons: oldButtons, readOnly: oldReadOnly } = oldParams ?? {};
        const { buttons: newButtons, readOnly: readOnly, useForm: useForm } = newParams;
        if (!forceUpdate && oldReadOnly === readOnly && $437b23f6a393c3bf$export$dbc2068cc90f5875(oldButtons, newButtons)) return;
        const hasButtons = newButtons && newButtons.length > 0 && !newParams.readOnly && !this.isGlobalButtons;
        let eButtonsPanel = this.eButtons;
        if (hasButtons) {
            const buttons = newButtons.map((type)=>{
                const localeKey = `${type}Filter`;
                return {
                    type: type,
                    label: $437b23f6a393c3bf$export$e2a0ae4af921fff8(this, localeKey)
                };
            });
            this.applyActive = $437b23f6a393c3bf$export$527c1b777ebd9069(this.params);
            if (!eButtonsPanel) {
                eButtonsPanel = this.createBean(new $437b23f6a393c3bf$export$226c2a54d31bd592());
                this.appendChild(eButtonsPanel.getGui());
                const column = this.column;
                const getListener = (action)=>({ event: event })=>{
                        this.updateModel(column, action);
                        this.afterAction(action, event);
                    };
                eButtonsPanel?.addManagedListeners(eButtonsPanel, {
                    apply: getListener("apply"),
                    clear: getListener("clear"),
                    reset: getListener("reset"),
                    cancel: getListener("cancel")
                });
                this.eButtons = eButtonsPanel;
            }
            eButtonsPanel.updateButtons(buttons, useForm);
        } else {
            this.applyActive = false;
            if (eButtonsPanel) {
                $437b23f6a393c3bf$export$dd4d52e41fb4cef5(eButtonsPanel.getGui());
                this.eButtons = this.destroyBean(eButtonsPanel);
            }
        }
    }
    close(e) {
        const hidePopup = this.hidePopup;
        if (!hidePopup) return;
        const keyboardEvent = e;
        const key = keyboardEvent && keyboardEvent.key;
        let params;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) params = {
            keyboardEvent: keyboardEvent
        };
        hidePopup(params);
        this.hidePopup = null;
    }
    afterAction(action, event) {
        const { params: params, applyActive: applyActive } = this;
        const closeOnApply = params?.closeOnApply;
        switch(action){
            case "apply":
                event?.preventDefault();
                if (closeOnApply && applyActive) this.close(event);
                break;
            case "reset":
                if (closeOnApply && applyActive) this.close();
                break;
            case "cancel":
                if (closeOnApply) this.close(event);
                break;
        }
    }
    handleKeyDown(event) {
        if (!event.defaultPrevented && event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER && this.applyActive) {
            this.updateModel(this.column, "apply");
            this.afterAction("apply", event);
        }
    }
    destroy() {
        this.hidePopup = null;
        this.eButtons = this.destroyBean(this.eButtons);
    }
};
// packages/ag-grid-community/src/filter/filterComp.ts
var $437b23f6a393c3bf$var$FilterElement = {
    tag: "div",
    cls: "ag-filter"
};
var $437b23f6a393c3bf$export$7db6d402989d8b90 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(column, source, enableGlobalButtonCheck){
        super($437b23f6a393c3bf$var$FilterElement);
        this.column = column;
        this.source = source;
        this.enableGlobalButtonCheck = enableGlobalButtonCheck;
        this.wrapper = null;
    }
    postConstruct() {
        this.beans.colFilter?.activeFilterComps.add(this);
        this.createFilter(true);
        this.addManagedEventListeners({
            filterDestroyed: this.onFilterDestroyed.bind(this)
        });
    }
    hasFilter() {
        return this.wrapper != null;
    }
    getFilter() {
        return this.wrapper?.then((wrapper)=>wrapper.comp) ?? null;
    }
    afterInit() {
        return this.wrapper?.then(()=>{}) ?? $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
    }
    afterGuiAttached(params) {
        this.afterGuiAttachedParams = params;
        this.wrapper?.then((wrapper)=>{
            this.comp?.afterGuiAttached(params);
            wrapper?.comp?.afterGuiAttached?.(params);
        });
    }
    afterGuiDetached() {
        this.wrapper?.then((wrapper)=>{
            wrapper?.comp?.afterGuiDetached?.();
        });
    }
    createFilter(init) {
        const { column: column, source: source, beans: { colFilter: colFilter } } = this;
        const filterPromise = colFilter.getFilterUiForDisplay(column) ?? null;
        this.wrapper = filterPromise;
        filterPromise?.then((wrapper)=>{
            if (!wrapper) return;
            const { isHandler: isHandler, comp: comp } = wrapper;
            let filterGui;
            if (isHandler) {
                const enableGlobalButtonCheck = !!this.enableGlobalButtonCheck;
                const displayComp = this.createBean(new $437b23f6a393c3bf$export$70acaf0e0e30e7d(column, wrapper, colFilter, colFilter.updateModel.bind(colFilter), enableGlobalButtonCheck && colFilter.isGlobalButtons, enableGlobalButtonCheck));
                this.comp = displayComp;
                filterGui = displayComp.getGui();
            } else {
                filterGui = comp.getGui();
                if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(filterGui)) $437b23f6a393c3bf$export$545083624300f13d(69, {
                    guiFromFilter: filterGui
                });
            }
            this.appendChild(filterGui);
            if (init) this.eventSvc.dispatchEvent({
                type: "filterOpened",
                column: column,
                source: source,
                eGui: this.getGui()
            });
            else comp.afterGuiAttached?.(this.afterGuiAttachedParams);
        });
    }
    onFilterDestroyed(event) {
        const { source: source, column: column } = event;
        if ((source === "api" || source === "paramsUpdated") && column.getId() === this.column.getId() && this.beans.colModel.getColDefCol(this.column)) {
            $437b23f6a393c3bf$export$69e6e10709eabd91(this.getGui());
            this.comp = this.destroyBean(this.comp);
            this.createFilter();
        }
    }
    destroy() {
        this.beans.colFilter?.activeFilterComps.delete(this);
        this.eventSvc.dispatchEvent({
            type: "filterClosed",
            column: this.column
        });
        this.wrapper = null;
        this.comp = this.destroyBean(this.comp);
        this.afterGuiAttachedParams = void 0;
        super.destroy();
    }
};
// packages/ag-grid-community/src/utils/date.ts
var $437b23f6a393c3bf$var$DATE_TIME_SEPARATOR = "T";
var $437b23f6a393c3bf$var$DATE_TIME_REGEXP = new RegExp(`^\\d{4}-\\d{2}-\\d{2}(${$437b23f6a393c3bf$var$DATE_TIME_SEPARATOR}\\d{2}:\\d{2}:\\d{2}\\D?)?`);
function $437b23f6a393c3bf$var$_padStartWidthZeros(value, totalStringSize) {
    return value.toString().padStart(totalStringSize, "0");
}
function $437b23f6a393c3bf$export$3d7fedfb21962874(date, includeTime = true, separator = "-") {
    if (!date) return null;
    let serialised = [
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate()
    ].map((part)=>$437b23f6a393c3bf$var$_padStartWidthZeros(part, 2)).join(separator);
    if (includeTime) serialised += $437b23f6a393c3bf$var$DATE_TIME_SEPARATOR + [
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
    ].map((part)=>$437b23f6a393c3bf$var$_padStartWidthZeros(part, 2)).join(":");
    return serialised;
}
function $437b23f6a393c3bf$export$bb4eb333cc2b3e25(d, includeTime = true) {
    if (!d) return null;
    if (includeTime) return [
        String(d.getFullYear()),
        String(d.getMonth() + 1),
        $437b23f6a393c3bf$var$_padStartWidthZeros(d.getDate(), 2),
        $437b23f6a393c3bf$var$_padStartWidthZeros(d.getHours(), 2),
        `:${$437b23f6a393c3bf$var$_padStartWidthZeros(d.getMinutes(), 2)}`,
        `:${$437b23f6a393c3bf$var$_padStartWidthZeros(d.getSeconds(), 2)}`
    ];
    return [
        d.getFullYear(),
        d.getMonth() + 1,
        $437b23f6a393c3bf$var$_padStartWidthZeros(d.getDate(), 2)
    ].map(String);
}
var $437b23f6a393c3bf$var$calculateOrdinal = (value)=>{
    if (value > 3 && value < 21) return "th";
    const remainder = value % 10;
    switch(remainder){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
    }
    return "th";
};
function $437b23f6a393c3bf$var$_dateToFormattedString(date, format) {
    if (format == null) return $437b23f6a393c3bf$export$3d7fedfb21962874(date, false);
    const fullYear = $437b23f6a393c3bf$var$_padStartWidthZeros(date.getFullYear(), 4);
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    const replace = {
        YYYY: ()=>fullYear.slice(fullYear.length - 4, fullYear.length),
        YY: ()=>fullYear.slice(fullYear.length - 2, fullYear.length),
        Y: ()=>`${date.getFullYear()}`,
        MMMM: ()=>months[date.getMonth()],
        MMM: ()=>months[date.getMonth()].slice(0, 3),
        MM: ()=>$437b23f6a393c3bf$var$_padStartWidthZeros(date.getMonth() + 1, 2),
        Mo: ()=>`${date.getMonth() + 1}${$437b23f6a393c3bf$var$calculateOrdinal(date.getMonth() + 1)}`,
        M: ()=>`${date.getMonth() + 1}`,
        Do: ()=>`${date.getDate()}${$437b23f6a393c3bf$var$calculateOrdinal(date.getDate())}`,
        DD: ()=>$437b23f6a393c3bf$var$_padStartWidthZeros(date.getDate(), 2),
        D: ()=>`${date.getDate()}`,
        dddd: ()=>days[date.getDay()],
        ddd: ()=>days[date.getDay()].slice(0, 3),
        dd: ()=>days[date.getDay()].slice(0, 2),
        do: ()=>`${date.getDay()}${$437b23f6a393c3bf$var$calculateOrdinal(date.getDay())}`,
        d: ()=>`${date.getDay()}`
    };
    const regexp = new RegExp(Object.keys(replace).join("|"), "g");
    return format.replace(regexp, (match)=>{
        if (match in replace) return replace[match]();
        return match;
    });
}
function $437b23f6a393c3bf$var$_isValidDate(value, bailIfInvalidTime = false) {
    return !!$437b23f6a393c3bf$export$26ded2d88c01b527(value, bailIfInvalidTime);
}
function $437b23f6a393c3bf$var$_isValidDateTime(value) {
    return $437b23f6a393c3bf$var$_isValidDate(value, true);
}
function $437b23f6a393c3bf$export$26ded2d88c01b527(value, bailIfInvalidTime = false) {
    if (!value) return null;
    if (!$437b23f6a393c3bf$var$DATE_TIME_REGEXP.test(value)) return null;
    const [dateStr, timeStr] = value.split($437b23f6a393c3bf$var$DATE_TIME_SEPARATOR);
    if (!dateStr) return null;
    const fields = dateStr.split("-").map((f)=>parseInt(f, 10));
    if (fields.filter((f)=>!isNaN(f)).length !== 3) return null;
    const [year, month, day] = fields;
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
    if (!timeStr && bailIfInvalidTime) return null;
    if (!timeStr || timeStr === "00:00:00") return date;
    const [hours, minutes, seconds] = timeStr.split(":").map((part)=>parseInt(part, 10));
    if (hours >= 0 && hours < 24) date.setHours(hours);
    else if (bailIfInvalidTime) return null;
    if (minutes >= 0 && minutes < 60) date.setMinutes(minutes);
    else if (bailIfInvalidTime) return null;
    if (seconds >= 0 && seconds < 60) date.setSeconds(seconds);
    else if (bailIfInvalidTime) return null;
    return date;
}
// packages/ag-grid-community/src/filter/filterDataTypeUtils.ts
var $437b23f6a393c3bf$var$MONTH_LOCALE_TEXT = {
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December"
};
var $437b23f6a393c3bf$var$MONTH_KEYS = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
];
function $437b23f6a393c3bf$var$setFilterNumberComparator(a, b) {
    if (a == null) return -1;
    if (b == null) return 1;
    return parseFloat(a) - parseFloat(b);
}
function $437b23f6a393c3bf$var$isValidDate(value) {
    return value instanceof Date && !isNaN(value.getTime());
}
var $437b23f6a393c3bf$var$filterParamsForEachDataType = {
    number: ()=>void 0,
    boolean: ()=>({
            maxNumConditions: 1,
            debounceMs: 0,
            filterOptions: [
                "empty",
                {
                    displayKey: "true",
                    displayName: "True",
                    predicate: (_filterValues, cellValue)=>cellValue,
                    numberOfInputs: 0
                },
                {
                    displayKey: "false",
                    displayName: "False",
                    predicate: (_filterValues, cellValue)=>cellValue === false,
                    numberOfInputs: 0
                }
            ]
        }),
    date: ()=>({
            isValidDate: $437b23f6a393c3bf$var$isValidDate
        }),
    dateString: ({ dataTypeDefinition: dataTypeDefinition })=>({
            comparator: (filterDate, cellValue)=>{
                const cellAsDate = dataTypeDefinition.dateParser(cellValue);
                if (cellValue == null || cellAsDate < filterDate) return -1;
                if (cellAsDate > filterDate) return 1;
                return 0;
            },
            isValidDate: (value)=>typeof value === "string" && $437b23f6a393c3bf$var$isValidDate(dataTypeDefinition.dateParser(value))
        }),
    dateTime: (args)=>$437b23f6a393c3bf$var$filterParamsForEachDataType.date(args),
    dateTimeString: (args)=>$437b23f6a393c3bf$var$filterParamsForEachDataType.dateString(args),
    object: ()=>void 0,
    text: ()=>void 0
};
var $437b23f6a393c3bf$var$setFilterParamsForEachDataType = {
    number: ()=>({
            comparator: $437b23f6a393c3bf$var$setFilterNumberComparator
        }),
    boolean: ({ t: t })=>({
            valueFormatter: (params)=>$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value) ? t(String(params.value), params.value ? "True" : "False") : t("blanks", "(Blanks)")
        }),
    date: ({ formatValue: formatValue, t: t })=>({
            valueFormatter: (params)=>{
                const valueFormatted = formatValue(params);
                return $437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted) ? valueFormatted : t("blanks", "(Blanks)");
            },
            treeList: true,
            treeListFormatter: (pathKey, level)=>{
                if (pathKey === "NaN") return t("invalidDate", "Invalid Date");
                if (level === 1 && pathKey != null) {
                    const monthKey = $437b23f6a393c3bf$var$MONTH_KEYS[Number(pathKey) - 1];
                    return t(monthKey, $437b23f6a393c3bf$var$MONTH_LOCALE_TEXT[monthKey]);
                }
                return pathKey ?? t("blanks", "(Blanks)");
            },
            treeListPathGetter: (date)=>$437b23f6a393c3bf$export$bb4eb333cc2b3e25(date, false)
        }),
    dateString: ({ formatValue: formatValue, dataTypeDefinition: dataTypeDefinition, t: t })=>({
            valueFormatter: (params)=>{
                const valueFormatted = formatValue(params);
                return $437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted) ? valueFormatted : t("blanks", "(Blanks)");
            },
            treeList: true,
            treeListPathGetter: (value)=>$437b23f6a393c3bf$export$bb4eb333cc2b3e25(dataTypeDefinition.dateParser(value ?? void 0), false),
            treeListFormatter: (pathKey, level)=>{
                if (level === 1 && pathKey != null) {
                    const monthKey = $437b23f6a393c3bf$var$MONTH_KEYS[Number(pathKey) - 1];
                    return t(monthKey, $437b23f6a393c3bf$var$MONTH_LOCALE_TEXT[monthKey]);
                }
                return pathKey ?? t("blanks", "(Blanks)");
            }
        }),
    dateTime: (args)=>{
        const params = $437b23f6a393c3bf$var$setFilterParamsForEachDataType.date(args);
        params.treeListPathGetter = $437b23f6a393c3bf$export$bb4eb333cc2b3e25;
        return params;
    },
    dateTimeString (args) {
        const convertToDate = args.dataTypeDefinition.dateParser;
        const params = $437b23f6a393c3bf$var$setFilterParamsForEachDataType.dateString(args);
        params.treeListPathGetter = (value)=>$437b23f6a393c3bf$export$bb4eb333cc2b3e25(convertToDate(value ?? void 0));
        return params;
    },
    object: ({ formatValue: formatValue, t: t })=>({
            valueFormatter: (params)=>{
                const valueFormatted = formatValue(params);
                return $437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted) ? valueFormatted : t("blanks", "(Blanks)");
            }
        }),
    text: ()=>void 0
};
function $437b23f6a393c3bf$export$4a99b58ce484acc(filter, existingFilterParams, existingFilterValueGetter, dataTypeDefinition, formatValue, beans, translate) {
    let filterParams = existingFilterParams;
    let filterValueGetter = existingFilterValueGetter;
    const usingSetFilter = filter === "agSetColumnFilter";
    if (!filterValueGetter && dataTypeDefinition.baseDataType === "object" && !usingSetFilter) filterValueGetter = ({ column: column, node: node })=>formatValue({
            column: column,
            node: node,
            value: beans.valueSvc.getValue(column, node)
        });
    const filterParamsMap = usingSetFilter ? $437b23f6a393c3bf$var$setFilterParamsForEachDataType : $437b23f6a393c3bf$var$filterParamsForEachDataType;
    const filterParamsGetter = filterParamsMap[dataTypeDefinition.baseDataType];
    const newFilterParams = filterParamsGetter({
        dataTypeDefinition: dataTypeDefinition,
        formatValue: formatValue,
        t: translate
    });
    filterParams = typeof existingFilterParams === "object" ? {
        ...newFilterParams,
        ...existingFilterParams
    } : newFilterParams;
    return {
        filterParams: filterParams,
        filterValueGetter: filterValueGetter
    };
}
var $437b23f6a393c3bf$var$defaultFilters = {
    boolean: "agTextColumnFilter",
    date: "agDateColumnFilter",
    dateString: "agDateColumnFilter",
    dateTime: "agDateColumnFilter",
    dateTimeString: "agDateColumnFilter",
    number: "agNumberColumnFilter",
    object: "agTextColumnFilter",
    text: "agTextColumnFilter"
};
var $437b23f6a393c3bf$var$defaultFloatingFilters = {
    boolean: "agTextColumnFloatingFilter",
    date: "agDateColumnFloatingFilter",
    dateString: "agDateColumnFloatingFilter",
    dateTime: "agDateColumnFloatingFilter",
    dateTimeString: "agDateColumnFloatingFilter",
    number: "agNumberColumnFloatingFilter",
    object: "agTextColumnFloatingFilter",
    text: "agTextColumnFloatingFilter"
};
function $437b23f6a393c3bf$export$4a4e3cf6acc7e93(cellDataType, isFloating = false) {
    const filterSet = isFloating ? $437b23f6a393c3bf$var$defaultFloatingFilters : $437b23f6a393c3bf$var$defaultFilters;
    return filterSet[cellDataType ?? "text"];
}
// packages/ag-grid-community/src/rendering/features/positionableFeature.ts
var $437b23f6a393c3bf$var$RESIZE_CONTAINER_STYLE = "ag-resizer-wrapper";
var $437b23f6a393c3bf$var$makeDiv = (dataRefPrefix, classSuffix)=>({
        tag: "div",
        ref: `${dataRefPrefix}Resizer`,
        cls: `ag-resizer ag-resizer-${classSuffix}`
    });
var $437b23f6a393c3bf$var$RESIZE_TEMPLATE = {
    tag: "div",
    cls: $437b23f6a393c3bf$var$RESIZE_CONTAINER_STYLE,
    children: [
        $437b23f6a393c3bf$var$makeDiv("eTopLeft", "topLeft"),
        $437b23f6a393c3bf$var$makeDiv("eTop", "top"),
        $437b23f6a393c3bf$var$makeDiv("eTopRight", "topRight"),
        $437b23f6a393c3bf$var$makeDiv("eRight", "right"),
        $437b23f6a393c3bf$var$makeDiv("eBottomRight", "bottomRight"),
        $437b23f6a393c3bf$var$makeDiv("eBottom", "bottom"),
        $437b23f6a393c3bf$var$makeDiv("eBottomLeft", "bottomLeft"),
        $437b23f6a393c3bf$var$makeDiv("eLeft", "left")
    ]
};
var $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(element, config){
        super();
        this.element = element;
        this.dragStartPosition = {
            x: 0,
            y: 0
        };
        this.position = {
            x: 0,
            y: 0
        };
        this.lastSize = {
            width: -1,
            height: -1
        };
        this.positioned = false;
        this.resizersAdded = false;
        this.resizeListeners = [];
        this.boundaryEl = null;
        this.isResizing = false;
        this.isMoving = false;
        this.resizable = {};
        this.movable = false;
        this.currentResizer = null;
        this.config = Object.assign({}, {
            popup: false
        }, config);
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
        this.dragSvc = beans.dragSvc;
    }
    center(postProcessCallback) {
        const { clientHeight: clientHeight, clientWidth: clientWidth } = this.offsetParent;
        const x = clientWidth / 2 - this.getWidth() / 2;
        const y = clientHeight / 2 - this.getHeight() / 2;
        this.offsetElement(x, y, postProcessCallback);
    }
    initialisePosition(postProcessCallback) {
        if (this.positioned) return;
        const { centered: centered, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent, minWidth: minWidth, width: width, minHeight: minHeight, height: height, x: x, y: y } = this.config;
        if (!this.offsetParent) this.setOffsetParent();
        let computedMinHeight = 0;
        let computedMinWidth = 0;
        const isElementVisible = $437b23f6a393c3bf$export$2badf4aa566524cb(this.element);
        if (isElementVisible) {
            const boundaryEl = this.findBoundaryElement();
            const offsetParentComputedStyles = window.getComputedStyle(boundaryEl);
            if (offsetParentComputedStyles.minWidth != null) {
                const paddingWidth = boundaryEl.offsetWidth - this.element.offsetWidth;
                computedMinWidth = parseInt(offsetParentComputedStyles.minWidth, 10) - paddingWidth;
            }
            if (offsetParentComputedStyles.minHeight != null) {
                const paddingHeight = boundaryEl.offsetHeight - this.element.offsetHeight;
                computedMinHeight = parseInt(offsetParentComputedStyles.minHeight, 10) - paddingHeight;
            }
        }
        this.minHeight = minHeight || computedMinHeight;
        this.minWidth = minWidth || computedMinWidth;
        if (width) this.setWidth(width);
        if (height) this.setHeight(height);
        if (!width || !height) this.refreshSize();
        if (centered) this.center(postProcessCallback);
        else if (x || y) this.offsetElement(x, y, postProcessCallback);
        else if (isElementVisible && forcePopupParentAsOffsetParent) {
            let boundaryEl = this.boundaryEl;
            let initialisedDuringPositioning = true;
            if (!boundaryEl) {
                boundaryEl = this.findBoundaryElement();
                initialisedDuringPositioning = false;
            }
            if (boundaryEl) {
                const top = parseFloat(boundaryEl.style.top);
                const left = parseFloat(boundaryEl.style.left);
                if (initialisedDuringPositioning) this.offsetElement(isNaN(left) ? 0 : left, isNaN(top) ? 0 : top, postProcessCallback);
                else this.setPosition(left, top);
            }
        }
        this.positioned = !!this.offsetParent;
    }
    isPositioned() {
        return this.positioned;
    }
    getPosition() {
        return this.position;
    }
    setMovable(movable, moveElement) {
        if (!this.config.popup || movable === this.movable) return;
        this.movable = movable;
        const params = this.moveElementDragListener || {
            eElement: moveElement,
            onDragStart: this.onMoveStart.bind(this),
            onDragging: this.onMove.bind(this),
            onDragStop: this.onMoveEnd.bind(this)
        };
        if (movable) {
            this.dragSvc?.addDragSource(params);
            this.moveElementDragListener = params;
        } else {
            this.dragSvc?.removeDragSource(params);
            this.moveElementDragListener = void 0;
        }
    }
    setResizable(resizable) {
        this.clearResizeListeners();
        if (resizable) this.addResizers();
        else this.removeResizers();
        if (typeof resizable === "boolean") {
            if (resizable === false) return;
            resizable = {
                topLeft: resizable,
                top: resizable,
                topRight: resizable,
                right: resizable,
                bottomRight: resizable,
                bottom: resizable,
                bottomLeft: resizable,
                left: resizable
            };
        }
        Object.keys(resizable).forEach((side)=>{
            const resizableStructure = resizable;
            const isSideResizable = !!resizableStructure[side];
            const resizerEl = this.getResizerElement(side);
            const params = {
                dragStartPixels: 0,
                eElement: resizerEl,
                onDragStart: (e)=>this.onResizeStart(e, side),
                onDragging: this.onResize.bind(this),
                onDragStop: (e)=>this.onResizeEnd(e, side)
            };
            if (isSideResizable || !this.isAlive() && !isSideResizable) {
                if (isSideResizable) {
                    this.dragSvc?.addDragSource(params);
                    this.resizeListeners.push(params);
                    resizerEl.style.pointerEvents = "all";
                } else resizerEl.style.pointerEvents = "none";
                this.resizable[side] = isSideResizable;
            }
        });
    }
    removeSizeFromEl() {
        this.element.style.removeProperty("height");
        this.element.style.removeProperty("width");
        this.element.style.removeProperty("flex");
    }
    restoreLastSize() {
        this.element.style.flex = "0 0 auto";
        const { height: height, width: width } = this.lastSize;
        if (width !== -1) this.element.style.width = `${width}px`;
        if (height !== -1) this.element.style.height = `${height}px`;
    }
    getHeight() {
        return this.element.offsetHeight;
    }
    setHeight(height) {
        const { popup: popup } = this.config;
        const eGui = this.element;
        let isPercent = false;
        if (typeof height === "string" && height.indexOf("%") !== -1) {
            $437b23f6a393c3bf$var$_setFixedHeight(eGui, height);
            height = $437b23f6a393c3bf$export$d23c22492e0f7c0c(eGui);
            isPercent = true;
        } else {
            height = Math.max(this.minHeight, height);
            if (this.positioned) {
                const availableHeight = this.getAvailableHeight();
                if (availableHeight && height > availableHeight) height = availableHeight;
            }
        }
        if (this.getHeight() === height) return;
        if (!isPercent) {
            if (popup) $437b23f6a393c3bf$var$_setFixedHeight(eGui, height);
            else {
                eGui.style.height = `${height}px`;
                eGui.style.flex = "0 0 auto";
                this.lastSize.height = typeof height === "number" ? height : parseFloat(height);
            }
        } else {
            eGui.style.maxHeight = "unset";
            eGui.style.minHeight = "unset";
        }
    }
    getAvailableHeight() {
        const { popup: popup, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        if (!this.positioned) this.initialisePosition();
        const { clientHeight: clientHeight } = this.offsetParent;
        if (!clientHeight) return null;
        const elRect = this.element.getBoundingClientRect();
        const offsetParentRect = this.offsetParent.getBoundingClientRect();
        const yPosition = popup ? this.position.y : elRect.top;
        const parentTop = popup ? 0 : offsetParentRect.top;
        let additionalHeight = 0;
        if (forcePopupParentAsOffsetParent) {
            const parentEl = this.element.parentElement;
            if (parentEl) {
                const { bottom: bottom } = parentEl.getBoundingClientRect();
                additionalHeight = bottom - elRect.bottom;
            }
        }
        const availableHeight = clientHeight + parentTop - yPosition - additionalHeight;
        return availableHeight;
    }
    getWidth() {
        return this.element.offsetWidth;
    }
    setWidth(width) {
        const eGui = this.element;
        const { popup: popup } = this.config;
        let isPercent = false;
        if (typeof width === "string" && width.indexOf("%") !== -1) {
            $437b23f6a393c3bf$export$ce98ba7f5cfe7725(eGui, width);
            width = $437b23f6a393c3bf$export$642efcb17474eb51(eGui);
            isPercent = true;
        } else if (this.positioned) {
            width = Math.max(this.minWidth, width);
            const { clientWidth: clientWidth } = this.offsetParent;
            const xPosition = popup ? this.position.x : this.element.getBoundingClientRect().left;
            if (clientWidth && width + xPosition > clientWidth) width = clientWidth - xPosition;
        }
        if (this.getWidth() === width) return;
        if (!isPercent) {
            if (this.config.popup) $437b23f6a393c3bf$export$ce98ba7f5cfe7725(eGui, width);
            else {
                eGui.style.width = `${width}px`;
                eGui.style.flex = " unset";
                this.lastSize.width = typeof width === "number" ? width : parseFloat(width);
            }
        } else {
            eGui.style.maxWidth = "unset";
            eGui.style.minWidth = "unset";
        }
    }
    offsetElement(x = 0, y = 0, postProcessCallback) {
        const { forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        const ePopup = forcePopupParentAsOffsetParent ? this.boundaryEl : this.element;
        if (!ePopup) return;
        this.popupSvc?.positionPopup({
            ePopup: ePopup,
            keepWithinBounds: true,
            skipObserver: this.movable || this.isResizable(),
            updatePosition: ()=>({
                    x: x,
                    y: y
                }),
            postProcessCallback: postProcessCallback
        });
        this.setPosition(parseFloat(ePopup.style.left), parseFloat(ePopup.style.top));
    }
    constrainSizeToAvailableHeight(constrain) {
        if (!this.config.forcePopupParentAsOffsetParent) return;
        const applyMaxHeightToElement = ()=>{
            const availableHeight = this.getAvailableHeight();
            this.element.style.setProperty("max-height", `${availableHeight}px`);
        };
        if (constrain && this.popupSvc) {
            this.resizeObserverSubscriber?.();
            this.resizeObserverSubscriber = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, this.popupSvc?.getPopupParent(), applyMaxHeightToElement);
        } else {
            this.element.style.removeProperty("max-height");
            if (this.resizeObserverSubscriber) {
                this.resizeObserverSubscriber();
                this.resizeObserverSubscriber = void 0;
            }
        }
    }
    setPosition(x, y) {
        this.position.x = x;
        this.position.y = y;
    }
    updateDragStartPosition(x, y) {
        this.dragStartPosition = {
            x: x,
            y: y
        };
    }
    calculateMouseMovement(params) {
        const { e: e, isLeft: isLeft, isTop: isTop, anywhereWithin: anywhereWithin, topBuffer: topBuffer } = params;
        const xDiff = e.clientX - this.dragStartPosition.x;
        const yDiff = e.clientY - this.dragStartPosition.y;
        const movementX = this.shouldSkipX(e, !!isLeft, !!anywhereWithin, xDiff) ? 0 : xDiff;
        const movementY = this.shouldSkipY(e, !!isTop, topBuffer, yDiff) ? 0 : yDiff;
        return {
            movementX: movementX,
            movementY: movementY
        };
    }
    shouldSkipX(e, isLeft, anywhereWithin, diff) {
        const elRect = this.element.getBoundingClientRect();
        const parentRect = this.offsetParent.getBoundingClientRect();
        const boundaryElRect = this.boundaryEl.getBoundingClientRect();
        const xPosition = this.config.popup ? this.position.x : elRect.left;
        let skipX = xPosition <= 0 && parentRect.left >= e.clientX || parentRect.right <= e.clientX && parentRect.right <= boundaryElRect.right;
        if (skipX) return true;
        if (isLeft) skipX = // is positioned to the right of the left side anchor
        diff < 0 && e.clientX > xPosition + parentRect.left || // skip if we are moving to the right and the cursor
        // is positioned to the left of the dialog
        diff > 0 && e.clientX < xPosition + parentRect.left;
        else if (anywhereWithin) skipX = diff < 0 && e.clientX > boundaryElRect.right || diff > 0 && e.clientX < xPosition + parentRect.left;
        else skipX = // we skip if we are moving to the left and the cursor
        // is to the right of the dialog
        diff < 0 && e.clientX > boundaryElRect.right || // or skip if we are moving to the right and the cursor
        // is to the left of the right side anchor
        diff > 0 && e.clientX < boundaryElRect.right;
        return skipX;
    }
    shouldSkipY(e, isTop, topBuffer = 0, diff) {
        const elRect = this.element.getBoundingClientRect();
        const parentRect = this.offsetParent.getBoundingClientRect();
        const boundaryElRect = this.boundaryEl.getBoundingClientRect();
        const yPosition = this.config.popup ? this.position.y : elRect.top;
        let skipY = yPosition <= 0 && parentRect.top >= e.clientY || parentRect.bottom <= e.clientY && parentRect.bottom <= boundaryElRect.bottom;
        if (skipY) return true;
        if (isTop) skipY = // below the top anchor + topBuffer
        // note: topBuffer is used when moving the dialog using the title bar
        diff < 0 && e.clientY > yPosition + parentRect.top + topBuffer || // skip if we are moving to the bottom and the cursor is
        // above the top anchor
        diff > 0 && e.clientY < yPosition + parentRect.top;
        else skipY = // is below the bottom anchor
        diff < 0 && e.clientY > boundaryElRect.bottom || // skip if we are moving towards the bottom and the cursor
        // is above the bottom anchor
        diff > 0 && e.clientY < boundaryElRect.bottom;
        return skipY;
    }
    createResizeMap() {
        const getElement2 = (ref)=>({
                element: this.element.querySelector(`[data-ref=${ref}Resizer]`)
            });
        this.resizerMap = {
            topLeft: getElement2("eTopLeft"),
            top: getElement2("eTop"),
            topRight: getElement2("eTopRight"),
            right: getElement2("eRight"),
            bottomRight: getElement2("eBottomRight"),
            bottom: getElement2("eBottom"),
            bottomLeft: getElement2("eBottomLeft"),
            left: getElement2("eLeft")
        };
    }
    addResizers() {
        if (this.resizersAdded) return;
        const eGui = this.element;
        if (!eGui) return;
        eGui.appendChild($437b23f6a393c3bf$export$a232bb0480ae674a($437b23f6a393c3bf$var$RESIZE_TEMPLATE));
        this.createResizeMap();
        this.resizersAdded = true;
    }
    removeResizers() {
        this.resizerMap = void 0;
        const resizerEl = this.element.querySelector(`.${$437b23f6a393c3bf$var$RESIZE_CONTAINER_STYLE}`);
        if (resizerEl) this.element.removeChild(resizerEl);
        this.resizersAdded = false;
    }
    getResizerElement(side) {
        return this.resizerMap[side].element;
    }
    onResizeStart(e, side) {
        this.boundaryEl = this.findBoundaryElement();
        if (!this.positioned) this.initialisePosition();
        this.currentResizer = {
            isTop: !!side.match(/top/i),
            isRight: !!side.match(/right/i),
            isBottom: !!side.match(/bottom/i),
            isLeft: !!side.match(/left/i)
        };
        this.element.classList.add("ag-resizing");
        this.resizerMap[side].element.classList.add("ag-active");
        const { popup: popup, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        if (!popup && !forcePopupParentAsOffsetParent) this.applySizeToSiblings(this.currentResizer.isBottom || this.currentResizer.isTop);
        this.isResizing = true;
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    getSiblings() {
        const element = this.element;
        const parent = element.parentElement;
        if (!parent) return null;
        return Array.prototype.slice.call(parent.children).filter((el)=>!el.classList.contains("ag-hidden"));
    }
    getMinSizeOfSiblings() {
        const siblings = this.getSiblings() || [];
        let height = 0;
        let width = 0;
        for(let i = 0; i < siblings.length; i++){
            const currentEl = siblings[i];
            const isFlex = !!currentEl.style.flex && currentEl.style.flex !== "0 0 auto";
            if (currentEl === this.element) continue;
            let nextHeight = this.minHeight || 0;
            let nextWidth = this.minWidth || 0;
            if (isFlex) {
                const computedStyle = window.getComputedStyle(currentEl);
                if (computedStyle.minHeight) nextHeight = parseInt(computedStyle.minHeight, 10);
                if (computedStyle.minWidth) nextWidth = parseInt(computedStyle.minWidth, 10);
            } else {
                nextHeight = currentEl.offsetHeight;
                nextWidth = currentEl.offsetWidth;
            }
            height += nextHeight;
            width += nextWidth;
        }
        return {
            height: height,
            width: width
        };
    }
    applySizeToSiblings(vertical) {
        let containerToFlex = null;
        const siblings = this.getSiblings();
        if (!siblings) return;
        for(let i = 0; i < siblings.length; i++){
            const el = siblings[i];
            if (el === containerToFlex) continue;
            if (vertical) el.style.height = `${el.offsetHeight}px`;
            else el.style.width = `${el.offsetWidth}px`;
            el.style.flex = "0 0 auto";
            if (el === this.element) containerToFlex = siblings[i + 1];
        }
        if (containerToFlex) {
            containerToFlex.style.removeProperty("height");
            containerToFlex.style.removeProperty("min-height");
            containerToFlex.style.removeProperty("max-height");
            containerToFlex.style.flex = "1 1 auto";
        }
    }
    isResizable() {
        return Object.values(this.resizable).some((value)=>value);
    }
    onResize(e) {
        if (!this.isResizing || !this.currentResizer) return;
        const { popup: popup, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        const { isTop: isTop, isRight: isRight, isBottom: isBottom, isLeft: isLeft } = this.currentResizer;
        const isHorizontal = isRight || isLeft;
        const isVertical = isBottom || isTop;
        const { movementX: movementX, movementY: movementY } = this.calculateMouseMovement({
            e: e,
            isLeft: isLeft,
            isTop: isTop
        });
        const xPosition = this.position.x;
        const yPosition = this.position.y;
        let offsetLeft = 0;
        let offsetTop = 0;
        if (isHorizontal && movementX) {
            const direction = isLeft ? -1 : 1;
            const oldWidth = this.getWidth();
            const newWidth = oldWidth + movementX * direction;
            let skipWidth = false;
            if (isLeft) {
                offsetLeft = oldWidth - newWidth;
                if (xPosition + offsetLeft <= 0 || newWidth <= this.minWidth) {
                    skipWidth = true;
                    offsetLeft = 0;
                }
            }
            if (!skipWidth) this.setWidth(newWidth);
        }
        if (isVertical && movementY) {
            const direction = isTop ? -1 : 1;
            const oldHeight = this.getHeight();
            const newHeight = oldHeight + movementY * direction;
            let skipHeight = false;
            if (isTop) {
                offsetTop = oldHeight - newHeight;
                if (yPosition + offsetTop <= 0 || newHeight <= this.minHeight) {
                    skipHeight = true;
                    offsetTop = 0;
                }
            } else if (!this.config.popup && !this.config.forcePopupParentAsOffsetParent && oldHeight < newHeight && this.getMinSizeOfSiblings().height + newHeight > this.element.parentElement.offsetHeight) skipHeight = true;
            if (!skipHeight) this.setHeight(newHeight);
        }
        this.updateDragStartPosition(e.clientX, e.clientY);
        if ((popup || forcePopupParentAsOffsetParent) && offsetLeft || offsetTop) this.offsetElement(xPosition + offsetLeft, yPosition + offsetTop);
    }
    onResizeEnd(e, side) {
        this.isResizing = false;
        this.currentResizer = null;
        this.boundaryEl = null;
        this.element.classList.remove("ag-resizing");
        this.resizerMap[side].element.classList.remove("ag-active");
        this.dispatchLocalEvent({
            type: "resize"
        });
    }
    refreshSize() {
        const eGui = this.element;
        if (this.config.popup) {
            if (!this.config.width) this.setWidth(eGui.offsetWidth);
            if (!this.config.height) this.setHeight(eGui.offsetHeight);
        }
    }
    onMoveStart(e) {
        this.boundaryEl = this.findBoundaryElement();
        if (!this.positioned) this.initialisePosition();
        this.isMoving = true;
        this.element.classList.add("ag-moving");
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    onMove(e) {
        if (!this.isMoving) return;
        const { x: x, y: y } = this.position;
        let topBuffer;
        if (this.config.calculateTopBuffer) topBuffer = this.config.calculateTopBuffer();
        const { movementX: movementX, movementY: movementY } = this.calculateMouseMovement({
            e: e,
            isTop: true,
            anywhereWithin: true,
            topBuffer: topBuffer
        });
        this.offsetElement(x + movementX, y + movementY);
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    onMoveEnd() {
        this.isMoving = false;
        this.boundaryEl = null;
        this.element.classList.remove("ag-moving");
    }
    setOffsetParent() {
        if (this.config.forcePopupParentAsOffsetParent && this.popupSvc) this.offsetParent = this.popupSvc.getPopupParent();
        else this.offsetParent = this.element.offsetParent;
    }
    findBoundaryElement() {
        let el = this.element;
        while(el){
            if (window.getComputedStyle(el).position !== "static") return el;
            el = el.parentElement;
        }
        return this.element;
    }
    clearResizeListeners() {
        while(this.resizeListeners.length){
            const params = this.resizeListeners.pop();
            this.dragSvc?.removeDragSource(params);
        }
    }
    destroy() {
        super.destroy();
        if (this.moveElementDragListener) this.dragSvc?.removeDragSource(this.moveElementDragListener);
        this.constrainSizeToAvailableHeight(false);
        this.clearResizeListeners();
        this.removeResizers();
    }
};
// packages/ag-grid-community/src/widgets/managedFocusFeature.ts
var $437b23f6a393c3bf$export$e24a3eb8593af8d8 = "ag-focus-managed";
var $437b23f6a393c3bf$export$5510e53ed3962582 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eFocusable, callbacks = {}){
        super();
        this.eFocusable = eFocusable;
        this.callbacks = callbacks;
        this.callbacks = {
            shouldStopEventPropagation: ()=>false,
            onTabKeyDown: (e)=>{
                if (e.defaultPrevented) return;
                const nextRoot = $437b23f6a393c3bf$export$83fc12531358bd28(this.beans, this.eFocusable, false, e.shiftKey);
                if (!nextRoot) return;
                nextRoot.focus();
                e.preventDefault();
            },
            ...callbacks
        };
    }
    postConstruct() {
        const { eFocusable: eFocusable, callbacks: { onFocusIn: onFocusIn, onFocusOut: onFocusOut } } = this;
        eFocusable.classList.add($437b23f6a393c3bf$export$e24a3eb8593af8d8);
        this.addKeyDownListeners(eFocusable);
        if (onFocusIn) this.addManagedElementListeners(eFocusable, {
            focusin: onFocusIn
        });
        if (onFocusOut) this.addManagedElementListeners(eFocusable, {
            focusout: onFocusOut
        });
    }
    addKeyDownListeners(eGui) {
        this.addManagedElementListeners(eGui, {
            keydown: (e)=>{
                if (e.defaultPrevented || $437b23f6a393c3bf$export$9a48e23524c6d58(e)) return;
                const { callbacks: callbacks } = this;
                if (callbacks.shouldStopEventPropagation(e)) {
                    $437b23f6a393c3bf$export$456c40e80134d72a(e);
                    return;
                }
                if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) callbacks.onTabKeyDown(e);
                else if (callbacks.handleKeyDown) callbacks.handleKeyDown(e);
            }
        });
    }
};
// packages/ag-grid-community/src/filter/provided/providedFilter.ts
var $437b23f6a393c3bf$export$a927a1327c2cc7f0 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(filterNameKey, cssIdentifier){
        super();
        this.filterNameKey = filterNameKey;
        this.cssIdentifier = cssIdentifier;
        this.applyActive = false;
        this.debouncePending = false;
        // subclasses can override this to provide alternative debounce defaults
        this.defaultDebounceMs = 0;
    }
    postConstruct() {
        const element = {
            tag: "div",
            cls: `ag-filter-body-wrapper ag-${this.cssIdentifier}-body-wrapper`,
            children: [
                this.createBodyTemplate()
            ]
        };
        this.setTemplate(element, this.getAgComponents());
        this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(this.getFocusableElement(), {
            handleKeyDown: this.handleKeyDown.bind(this)
        }));
        this.positionableFeature = this.createBean(new $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6(this.getPositionableElement(), {
            forcePopupParentAsOffsetParent: true
        }));
    }
    handleKeyDown(_e) {}
    init(legacyParams) {
        const params = legacyParams;
        this.setParams(params);
        this.setModelIntoUi(params.state.model, true).then(()=>this.updateUiVisibility());
    }
    refresh(legacyNewParams) {
        const newParams = legacyNewParams;
        const oldParams = this.params;
        this.params = newParams;
        const source = newParams.source;
        if (source === "colDef") this.updateParams(newParams, oldParams);
        const newState = newParams.state;
        const oldState = this.state;
        this.state = newState;
        if (newState.model !== oldState.model || newState.state !== oldState.state) this.setModelIntoUi(newState.model);
        return true;
    }
    /** Called on init only. Override in subclasses */ setParams(params) {
        this.params = params;
        this.state = params.state;
        this.commonUpdateParams(params);
    }
    /** Called on refresh only. Override in subclasses */ updateParams(newParams, oldParams) {
        this.commonUpdateParams(newParams, oldParams);
    }
    commonUpdateParams(newParams, _oldParams) {
        this.applyActive = $437b23f6a393c3bf$export$527c1b777ebd9069(newParams);
        this.setupApplyDebounced();
    }
    /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */ doesFilterPass(params) {
        $437b23f6a393c3bf$export$545083624300f13d(283);
        const { getHandler: getHandler, model: model, column: column } = this.params;
        return getHandler().doesFilterPass({
            ...params,
            model: model,
            handlerParams: this.beans.colFilter.getHandlerParams(column)
        });
    }
    getFilterTitle() {
        return this.translate(this.filterNameKey);
    }
    /**
   * @deprecated v34 Filters are active when they have a model. Use `api.getColumnFilterModel()` instead.
   */ isFilterActive() {
        $437b23f6a393c3bf$export$545083624300f13d(284);
        return this.params.model != null;
    }
    setupApplyDebounced() {
        const debounceMs = $437b23f6a393c3bf$var$getDebounceMs(this.params, this.defaultDebounceMs);
        const debounceFunc = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.checkApplyDebounce.bind(this), debounceMs);
        this.applyDebounced = ()=>{
            this.debouncePending = true;
            debounceFunc();
        };
    }
    checkApplyDebounce() {
        if (this.debouncePending) {
            this.debouncePending = false;
            this.doApplyModel();
        }
    }
    /**
   * @deprecated v34 Use (`api.getColumnFilterModel()`) instead.
   */ getModel() {
        $437b23f6a393c3bf$export$545083624300f13d(285);
        return this.params.model;
    }
    /**
   * @deprecated v34 Use (`api.setColumnFilterModel()`) instead.
   */ setModel(model) {
        $437b23f6a393c3bf$export$545083624300f13d(286);
        const { beans: beans, params: params } = this;
        return beans.colFilter.setModelForColumnLegacy(params.column, model);
    }
    /**
   * Applies changes made in the UI to the filter, and returns true if the model has changed.
   */ applyModel(_source = "api") {
        return this.doApplyModel();
    }
    canApply(_model) {
        return true;
    }
    doApplyModel(additionalEventAttributes) {
        const { params: params, state: state } = this;
        const changed = !this.areModelsEqual(params.model, state.model);
        if (changed) params.onAction("apply", additionalEventAttributes);
        return changed;
    }
    /**
   * @deprecated v34 Internal method - should only be called by the grid.
   */ onNewRowsLoaded() {}
    /**
   * By default, if the change came from a floating filter it will be applied immediately, otherwise if there is no
   * apply button it will be applied after a debounce, otherwise it will not be applied at all. This behaviour can
   * be adjusted by using the apply parameter.
   */ onUiChanged(apply, afterFloatingFilter = false) {
        this.updateUiVisibility();
        const model = this.getModelFromUi();
        const state = {
            model: model,
            state: this.getState(),
            valid: this.canApply(model)
        };
        this.state = state;
        const params = this.params;
        params.onStateChange(state);
        params.onUiChange(this.getUiChangeEventParams());
        if (!this.gos.get("enableFilterHandlers")) this.eventSvc.dispatchEvent({
            type: "filterModified",
            column: params.column,
            filterInstance: this
        });
        apply ?? (apply = this.applyActive ? void 0 : "debounce");
        if (apply === "immediately") this.doApplyModel({
            afterFloatingFilter: afterFloatingFilter,
            afterDataChange: false
        });
        else if (apply === "debounce") this.applyDebounced();
    }
    getState() {
        return void 0;
    }
    getUiChangeEventParams() {
        return void 0;
    }
    afterGuiAttached(params) {
        this.lastContainerType = params?.container;
        this.refreshFilterResizer(params?.container);
    }
    refreshFilterResizer(containerType) {
        const { positionableFeature: positionableFeature, gos: gos } = this;
        if (!positionableFeature) return;
        const isResizable = containerType === "floatingFilter" || containerType === "columnFilter";
        if (isResizable) {
            positionableFeature.restoreLastSize();
            positionableFeature.setResizable(gos.get("enableRtl") ? {
                bottom: true,
                bottomLeft: true,
                left: true
            } : {
                bottom: true,
                bottomRight: true,
                right: true
            });
        } else {
            positionableFeature.removeSizeFromEl();
            positionableFeature.setResizable(false);
        }
        positionableFeature.constrainSizeToAvailableHeight(isResizable);
    }
    afterGuiDetached() {
        this.checkApplyDebounce();
        this.positionableFeature?.constrainSizeToAvailableHeight(false);
    }
    destroy() {
        this.positionableFeature = this.destroyBean(this.positionableFeature);
        super.destroy();
    }
    translate(key) {
        return $437b23f6a393c3bf$export$e2a0ae4af921fff8(this, key);
    }
    // override to control positionable feature
    getPositionableElement() {
        return this.getGui();
    }
    areModelsEqual(a, b) {
        if (a === b || a == null && b == null) return true;
        if (a == null || b == null) return false;
        return this.areNonNullModelsEqual(a, b);
    }
};
// packages/ag-grid-community/src/filter/provided/iSimpleFilter.ts
function $437b23f6a393c3bf$export$a3f343af66a0c1bd(model) {
    return !!model.operator;
}
// packages/ag-grid-community/src/filter/floating/floatingFilterMapper.ts
function $437b23f6a393c3bf$export$47072b32bdaf5d61(frameworkOverrides, def, getFromDefault) {
    if (def == null) return null;
    let defaultFloatingFilterType = null;
    const { compName: compName, jsComp: jsComp, fwComp: fwComp } = $437b23f6a393c3bf$var$_getFilterCompKeys(frameworkOverrides, def);
    if (compName) {
        const floatingFilterTypeMap = {
            agSetColumnFilter: "agSetColumnFloatingFilter",
            agMultiColumnFilter: "agMultiColumnFloatingFilter",
            agGroupColumnFilter: "agGroupColumnFloatingFilter",
            agNumberColumnFilter: "agNumberColumnFloatingFilter",
            agDateColumnFilter: "agDateColumnFloatingFilter",
            agTextColumnFilter: "agTextColumnFloatingFilter"
        };
        defaultFloatingFilterType = floatingFilterTypeMap[compName];
    } else {
        const usingDefaultFilter = jsComp == null && fwComp == null && def.filter === true;
        if (usingDefaultFilter) defaultFloatingFilterType = getFromDefault();
    }
    return defaultFloatingFilterType;
}
// packages/ag-grid-community/src/styling/layoutFeature.ts
var $437b23f6a393c3bf$var$LayoutCssClasses = {
    AUTO_HEIGHT: "ag-layout-auto-height",
    NORMAL: "ag-layout-normal",
    PRINT: "ag-layout-print"
};
var $437b23f6a393c3bf$var$LayoutFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(view){
        super();
        this.view = view;
    }
    postConstruct() {
        this.addManagedPropertyListener("domLayout", this.updateLayoutClasses.bind(this));
        this.updateLayoutClasses();
    }
    updateLayoutClasses() {
        const domLayout = this.gos.get("domLayout");
        const params = {
            autoHeight: domLayout === "autoHeight",
            normal: domLayout === "normal",
            print: domLayout === "print"
        };
        const cssClass = params.autoHeight ? $437b23f6a393c3bf$var$LayoutCssClasses.AUTO_HEIGHT : params.print ? $437b23f6a393c3bf$var$LayoutCssClasses.PRINT : $437b23f6a393c3bf$var$LayoutCssClasses.NORMAL;
        this.view.updateLayoutClasses(cssClass, params);
    }
};
// packages/ag-grid-community/src/constants/direction.ts
var $437b23f6a393c3bf$export$cacd6541cfeeb6c1 = /* @__PURE__ */ ((Direction2)=>{
    Direction2[Direction2["Vertical"] = 0] = "Vertical";
    Direction2[Direction2["Horizontal"] = 1] = "Horizontal";
    return Direction2;
})($437b23f6a393c3bf$export$cacd6541cfeeb6c1 || {});
// packages/ag-grid-community/src/gridBodyComp/gridBodyScrollFeature.ts
var $437b23f6a393c3bf$var$VIEWPORT = "Viewport";
var $437b23f6a393c3bf$var$FAKE_V_SCROLLBAR = "fakeVScrollComp";
var $437b23f6a393c3bf$var$HORIZONTAL_SOURCES = [
    "fakeHScrollComp",
    "centerHeader",
    "topCenter",
    "bottomCenter",
    "stickyTopCenter",
    "stickyBottomCenter"
];
var $437b23f6a393c3bf$var$SCROLL_DEBOUNCE_TIMEOUT = 100;
var $437b23f6a393c3bf$var$SCROLL_END_TIMEOUT = 150;
var $437b23f6a393c3bf$var$GridBodyScrollFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eBodyViewport){
        super();
        // listeners for when ensureIndexVisible is waiting for SSRM data to load
        this.clearRetryListenerFncs = [];
        this.lastScrollSource = [
            null,
            null
        ];
        this.scrollLeft = -1;
        this.nextScrollTop = -1;
        this.scrollTop = -1;
        // Used to provide approximate values of scrollTop and offsetHeight
        // without forcing the browser to recalculate styles.
        this.lastOffsetHeight = -1;
        this.lastScrollTop = -1;
        this.lastIsHorizontalScrollShowing = false;
        this.scrollTimer = 0;
        this.isScrollActive = false;
        this.isVerticalPositionInvalidated = true;
        this.isHorizontalPositionInvalidated = true;
        this.eBodyViewport = eBodyViewport;
        this.resetLastHScrollDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>this.lastScrollSource[1 /* Horizontal */ ] = null, $437b23f6a393c3bf$var$SCROLL_END_TIMEOUT);
        this.resetLastVScrollDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>this.lastScrollSource[0 /* Vertical */ ] = null, $437b23f6a393c3bf$var$SCROLL_END_TIMEOUT);
    }
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
        this.animationFrameSvc = beans.animationFrameSvc;
        this.visibleCols = beans.visibleCols;
    }
    destroy() {
        super.destroy();
        this.clearRetryListenerFncs = [];
        window.clearTimeout(this.scrollTimer);
    }
    postConstruct() {
        this.enableRtl = this.gos.get("enableRtl");
        const invalidateVerticalScroll = this.invalidateVerticalScroll.bind(this);
        const invalidateHorizontalScroll = this.invalidateHorizontalScroll.bind(this);
        this.addManagedEventListeners({
            displayedColumnsWidthChanged: this.onDisplayedColumnsWidthChanged.bind(this),
            gridSizeChanged: invalidateVerticalScroll,
            // We only invalidate horizontal scrolling when the viewport switches
            // between scrollable and non-scrollable, avoiding unnecessary
            // invalidation on every gridSizeChanged event. If more properties
            // require invalidation, read/write DOM cycles may be needed.
            scrollGapChanged: invalidateHorizontalScroll
        });
        this.addManagedElementListeners(this.eBodyViewport, {
            scroll: invalidateVerticalScroll
        });
        this.ctrlsSvc.whenReady(this, (p)=>{
            this.centerRowsCtrl = p.center;
            this.onDisplayedColumnsWidthChanged();
            this.addScrollListener();
        });
    }
    invalidateHorizontalScroll() {
        this.isHorizontalPositionInvalidated = true;
    }
    invalidateVerticalScroll() {
        this.isVerticalPositionInvalidated = true;
    }
    addScrollListener() {
        this.addHorizontalScrollListeners();
        this.addVerticalScrollListeners();
    }
    addHorizontalScrollListeners() {
        this.addManagedElementListeners(this.centerRowsCtrl.eViewport, {
            scroll: this.onHScroll.bind(this, $437b23f6a393c3bf$var$VIEWPORT)
        });
        for (const source of $437b23f6a393c3bf$var$HORIZONTAL_SOURCES){
            const scrollPartner = this.ctrlsSvc.get(source);
            this.registerScrollPartner(scrollPartner, this.onHScroll.bind(this, source));
        }
    }
    addVerticalScrollListeners() {
        const fakeVScrollComp = this.ctrlsSvc.get("fakeVScrollComp");
        const isDebounce = this.gos.get("debounceVerticalScrollbar");
        const onVScroll = isDebounce ? $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.onVScroll.bind(this, $437b23f6a393c3bf$var$VIEWPORT), $437b23f6a393c3bf$var$SCROLL_DEBOUNCE_TIMEOUT) : this.onVScroll.bind(this, $437b23f6a393c3bf$var$VIEWPORT);
        const onFakeVScroll = isDebounce ? $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.onVScroll.bind(this, $437b23f6a393c3bf$var$FAKE_V_SCROLLBAR), $437b23f6a393c3bf$var$SCROLL_DEBOUNCE_TIMEOUT) : this.onVScroll.bind(this, $437b23f6a393c3bf$var$FAKE_V_SCROLLBAR);
        this.addManagedElementListeners(this.eBodyViewport, {
            scroll: onVScroll
        });
        this.registerScrollPartner(fakeVScrollComp, onFakeVScroll);
    }
    registerScrollPartner(comp, callback) {
        comp.onScrollCallback(callback);
    }
    onDisplayedColumnsWidthChanged() {
        if (this.enableRtl) this.horizontallyScrollHeaderCenterAndFloatingCenter();
    }
    horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft) {
        const notYetInitialised = this.centerRowsCtrl == null;
        if (notYetInitialised) return;
        if (scrollLeft === void 0) scrollLeft = this.centerRowsCtrl.getCenterViewportScrollLeft();
        this.setScrollLeftForAllContainersExceptCurrent(Math.abs(scrollLeft));
    }
    setScrollLeftForAllContainersExceptCurrent(scrollLeft) {
        for (const container of [
            ...$437b23f6a393c3bf$var$HORIZONTAL_SOURCES,
            $437b23f6a393c3bf$var$VIEWPORT
        ]){
            if (this.lastScrollSource[1 /* Horizontal */ ] === container) continue;
            const viewport = this.getViewportForSource(container);
            $437b23f6a393c3bf$var$_setScrollLeft(viewport, scrollLeft, this.enableRtl);
        }
    }
    getViewportForSource(source) {
        if (source === $437b23f6a393c3bf$var$VIEWPORT) return this.centerRowsCtrl.eViewport;
        return this.ctrlsSvc.get(source).eViewport;
    }
    isControllingScroll(source, direction) {
        if (this.lastScrollSource[direction] == null) {
            if (direction === 0 /* Vertical */ ) this.lastScrollSource[0] = source;
            else this.lastScrollSource[1] = source;
            return true;
        }
        return this.lastScrollSource[direction] === source;
    }
    onHScroll(source) {
        if (!this.isControllingScroll(source, 1 /* Horizontal */ )) return;
        const centerContainerViewport = this.centerRowsCtrl.eViewport;
        const { scrollLeft: scrollLeft } = centerContainerViewport;
        if (this.shouldBlockScrollUpdate(1 /* Horizontal */ , scrollLeft, true)) return;
        const newScrollLeft = $437b23f6a393c3bf$var$_getScrollLeft(this.getViewportForSource(source), this.enableRtl);
        this.doHorizontalScroll(newScrollLeft);
        this.resetLastHScrollDebounced();
    }
    onVScroll(source) {
        if (!this.isControllingScroll(source, 0 /* Vertical */ )) return;
        let scrollTop;
        if (source === $437b23f6a393c3bf$var$VIEWPORT) scrollTop = this.eBodyViewport.scrollTop;
        else scrollTop = this.ctrlsSvc.get("fakeVScrollComp").getScrollPosition();
        if (this.shouldBlockScrollUpdate(0 /* Vertical */ , scrollTop, true)) return;
        const { animationFrameSvc: animationFrameSvc } = this;
        animationFrameSvc?.setScrollTop(scrollTop);
        this.nextScrollTop = scrollTop;
        if (source === $437b23f6a393c3bf$var$VIEWPORT) this.ctrlsSvc.get("fakeVScrollComp").setScrollPosition(scrollTop);
        else this.eBodyViewport.scrollTop = scrollTop;
        if (animationFrameSvc?.active) animationFrameSvc.schedule();
        else this.scrollGridIfNeeded(true);
        this.resetLastVScrollDebounced();
    }
    doHorizontalScroll(scrollLeft) {
        const fakeScrollLeft = this.ctrlsSvc.get("fakeHScrollComp").getScrollPosition();
        if (this.scrollLeft === scrollLeft && scrollLeft === fakeScrollLeft) return;
        this.scrollLeft = scrollLeft;
        this.fireScrollEvent(1 /* Horizontal */ );
        this.horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft);
        this.centerRowsCtrl.onHorizontalViewportChanged(true);
    }
    isScrolling() {
        return this.isScrollActive;
    }
    fireScrollEvent(direction) {
        const bodyScrollEvent = {
            type: "bodyScroll",
            direction: direction === 1 /* Horizontal */  ? "horizontal" : "vertical",
            left: this.scrollLeft,
            top: this.scrollTop
        };
        this.isScrollActive = true;
        this.eventSvc.dispatchEvent(bodyScrollEvent);
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(()=>{
            this.scrollTimer = 0;
            this.isScrollActive = false;
            this.eventSvc.dispatchEvent({
                ...bodyScrollEvent,
                type: "bodyScrollEnd"
            });
        }, $437b23f6a393c3bf$var$SCROLL_END_TIMEOUT);
    }
    shouldBlockScrollUpdate(direction, scrollTo, touchOnly = false) {
        if (touchOnly && !$437b23f6a393c3bf$export$6b6034a68325bd8a()) return false;
        if (direction === 0 /* Vertical */ ) return this.shouldBlockVerticalScroll(scrollTo);
        return this.shouldBlockHorizontalScroll(scrollTo);
    }
    shouldBlockVerticalScroll(scrollTo) {
        const clientHeight = $437b23f6a393c3bf$export$c20e968103d9c16e(this.eBodyViewport);
        const { scrollHeight: scrollHeight } = this.eBodyViewport;
        if (scrollTo < 0 || scrollTo + clientHeight > scrollHeight) return true;
        return false;
    }
    shouldBlockHorizontalScroll(scrollTo) {
        const clientWidth = this.centerRowsCtrl.getCenterWidth();
        const { scrollWidth: scrollWidth } = this.centerRowsCtrl.eViewport;
        if (this.enableRtl) {
            if (scrollTo > 0) return true;
        } else if (scrollTo < 0) return true;
        if (Math.abs(scrollTo) + clientWidth > scrollWidth) return true;
        return false;
    }
    redrawRowsAfterScroll() {
        this.fireScrollEvent(0 /* Vertical */ );
    }
    // this is to cater for AG-3274, where grid is removed from the dom and then inserted back in again.
    // (which happens with some implementations of tabbing). this can result in horizontal scroll getting
    // reset back to the left, however no scroll event is fired. so we need to get header to also scroll
    // back to the left to be kept in sync.
    // adding and removing the grid from the DOM both resets the scroll position and
    // triggers a resize event, so notify listeners if the scroll position has changed
    checkScrollLeft() {
        const scrollLeft = this.scrollLeft;
        let hasHorizontalScrollersOutOfSync = false;
        for (const source of $437b23f6a393c3bf$var$HORIZONTAL_SOURCES){
            const viewport = this.getViewportForSource(source);
            if (viewport.scrollLeft !== scrollLeft) {
                hasHorizontalScrollersOutOfSync = true;
                break;
            }
        }
        if (hasHorizontalScrollersOutOfSync) this.onHScroll($437b23f6a393c3bf$var$VIEWPORT);
    }
    scrollGridIfNeeded(suppressedAnimationFrame = false) {
        const frameNeeded = this.scrollTop != this.nextScrollTop;
        if (frameNeeded) {
            this.scrollTop = this.nextScrollTop;
            if (suppressedAnimationFrame) this.invalidateVerticalScroll();
            this.redrawRowsAfterScroll();
        }
        return frameNeeded;
    }
    // called by scrollHorizontally method and alignedGridsService
    setHorizontalScrollPosition(hScrollPosition, fromAlignedGridsService = false) {
        const minScrollLeft = 0;
        const maxScrollLeft = this.centerRowsCtrl.eViewport.scrollWidth - this.centerRowsCtrl.getCenterWidth();
        if (!fromAlignedGridsService && this.shouldBlockScrollUpdate(1 /* Horizontal */ , hScrollPosition)) {
            if (this.enableRtl) hScrollPosition = hScrollPosition > 0 ? 0 : maxScrollLeft;
            else hScrollPosition = Math.min(Math.max(hScrollPosition, minScrollLeft), maxScrollLeft);
        }
        $437b23f6a393c3bf$var$_setScrollLeft(this.centerRowsCtrl.eViewport, Math.abs(hScrollPosition), this.enableRtl);
        this.doHorizontalScroll(hScrollPosition);
    }
    setVerticalScrollPosition(vScrollPosition) {
        this.invalidateVerticalScroll();
        this.eBodyViewport.scrollTop = vScrollPosition;
    }
    getVScrollPosition() {
        if (!this.isVerticalPositionInvalidated) {
            const { lastOffsetHeight: lastOffsetHeight, lastScrollTop: lastScrollTop } = this;
            return {
                top: lastScrollTop,
                bottom: lastScrollTop + lastOffsetHeight
            };
        }
        this.isVerticalPositionInvalidated = false;
        const { scrollTop: scrollTop, offsetHeight: offsetHeight } = this.eBodyViewport;
        this.lastScrollTop = scrollTop;
        this.lastOffsetHeight = offsetHeight;
        return {
            top: scrollTop,
            bottom: scrollTop + offsetHeight
        };
    }
    /** Get an approximate scroll position that returns the last real value read.
   * This is useful for avoiding repeated DOM reads that force the browser to recalculate styles.
   * This can have big performance improvements but may not be 100% accurate so only use if this is acceptable.
   */ getApproximateVScollPosition() {
        if (this.lastScrollTop >= 0 && this.lastOffsetHeight >= 0) return {
            top: this.scrollTop,
            bottom: this.scrollTop + this.lastOffsetHeight
        };
        return this.getVScrollPosition();
    }
    getHScrollPosition() {
        return this.centerRowsCtrl.getHScrollPosition();
    }
    isHorizontalScrollShowing() {
        if (this.isHorizontalPositionInvalidated) {
            this.lastIsHorizontalScrollShowing = this.centerRowsCtrl.isHorizontalScrollShowing();
            this.isHorizontalPositionInvalidated = false;
        }
        return this.lastIsHorizontalScrollShowing;
    }
    // called by the headerRootComp and moveColumnController
    scrollHorizontally(pixels) {
        const oldScrollPosition = this.centerRowsCtrl.eViewport.scrollLeft;
        this.setHorizontalScrollPosition(oldScrollPosition + pixels);
        return this.centerRowsCtrl.eViewport.scrollLeft - oldScrollPosition;
    }
    // gets called by rowRenderer when new data loaded, as it will want to scroll to the top
    scrollToTop() {
        this.eBodyViewport.scrollTop = 0;
    }
    // Valid values for position are bottom, middle and top
    ensureNodeVisible(comparator, position = null) {
        const { rowModel: rowModel } = this.beans;
        const rowCount = rowModel.getRowCount();
        let indexToSelect = -1;
        for(let i = 0; i < rowCount; i++){
            const node = rowModel.getRow(i);
            if (typeof comparator === "function") {
                const predicate = comparator;
                if (node && predicate(node)) {
                    indexToSelect = i;
                    break;
                }
            } else if (comparator === node || comparator === node.data) {
                indexToSelect = i;
                break;
            }
        }
        if (indexToSelect >= 0) this.ensureIndexVisible(indexToSelect, position);
    }
    // Valid values for position are bottom, middle and top
    // position should be {'top','middle','bottom', or undefined/null}.
    // if undefined/null, then the grid will to the minimal amount of scrolling,
    // eg if grid needs to scroll up, it scrolls until row is on top,
    //    if grid needs to scroll down, it scrolls until row is on bottom,
    //    if row is already in view, grid does not scroll
    ensureIndexVisible(index, position, retry = 0) {
        if ($437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print")) return;
        const { rowModel: rowModel } = this.beans;
        const rowCount = rowModel.getRowCount();
        if (typeof index !== "number" || index < 0 || index >= rowCount) {
            $437b23f6a393c3bf$export$545083624300f13d(88, {
                index: index
            });
            return;
        }
        this.clearRetryListeners();
        const { frameworkOverrides: frameworkOverrides, pageBounds: pageBounds, rowContainerHeight: heightScaler, rowRenderer: rowRenderer } = this.beans;
        frameworkOverrides.wrapIncoming(()=>{
            const gridBodyCtrl = this.ctrlsSvc.getGridBodyCtrl();
            const rowNode = rowModel.getRow(index);
            let rowGotShiftedDuringOperation;
            let stickyHeightsChanged;
            let attempt = 0;
            this.invalidateVerticalScroll();
            do {
                const { stickyTopHeight: stickyTopHeight, stickyBottomHeight: stickyBottomHeight } = gridBodyCtrl;
                const startingRowTop = rowNode.rowTop;
                const startingRowHeight = rowNode.rowHeight;
                const paginationOffset = pageBounds.getPixelOffset();
                const rowTopPixel = rowNode.rowTop - paginationOffset;
                const rowBottomPixel = rowTopPixel + rowNode.rowHeight;
                const scrollPosition = this.getVScrollPosition();
                const heightOffset = heightScaler.divStretchOffset;
                const vScrollTop = scrollPosition.top + heightOffset;
                const vScrollBottom = scrollPosition.bottom + heightOffset;
                const viewportHeight = vScrollBottom - vScrollTop;
                const pxTop = heightScaler.getScrollPositionForPixel(rowTopPixel);
                const pxBottom = heightScaler.getScrollPositionForPixel(rowBottomPixel - viewportHeight);
                const pxMiddle = Math.min((pxTop + pxBottom) / 2, rowTopPixel);
                const rowAboveViewport = vScrollTop + stickyTopHeight > rowTopPixel;
                const rowBelowViewport = vScrollBottom - stickyBottomHeight < rowBottomPixel;
                let newScrollPosition = null;
                if (position === "top") newScrollPosition = pxTop - stickyTopHeight;
                else if (position === "bottom") newScrollPosition = pxBottom + stickyBottomHeight;
                else if (position === "middle") newScrollPosition = pxMiddle;
                else if (rowAboveViewport) newScrollPosition = pxTop - stickyTopHeight;
                else if (rowBelowViewport) {
                    if (pxBottom - pxTop > viewportHeight) newScrollPosition = pxTop - stickyTopHeight;
                    else newScrollPosition = pxBottom + stickyBottomHeight;
                }
                if (newScrollPosition !== null) {
                    this.setVerticalScrollPosition(newScrollPosition);
                    rowRenderer.redraw({
                        afterScroll: true
                    });
                }
                rowGotShiftedDuringOperation = startingRowTop !== rowNode.rowTop || startingRowHeight !== rowNode.rowHeight;
                stickyHeightsChanged = stickyTopHeight !== gridBodyCtrl.stickyTopHeight || stickyBottomHeight !== gridBodyCtrl.stickyBottomHeight;
                attempt++;
            }while ((rowGotShiftedDuringOperation || stickyHeightsChanged) && attempt < 10);
            this.animationFrameSvc?.flushAllFrames();
            if (retry < 10 && (rowNode?.stub || !this.beans.rowAutoHeight?.areRowsMeasured())) {
                const scrollTop = this.getVScrollPosition().top;
                this.clearRetryListenerFncs = this.addManagedEventListeners({
                    bodyScroll: ()=>{
                        const newScrollTop = this.getVScrollPosition().top;
                        if (scrollTop === newScrollTop) return;
                        this.clearRetryListeners();
                    },
                    modelUpdated: ()=>{
                        this.clearRetryListeners();
                        if (index >= rowModel.getRowCount()) return;
                        this.ensureIndexVisible(index, position, retry + 1);
                    }
                });
            }
        });
    }
    clearRetryListeners() {
        this.clearRetryListenerFncs.forEach((callback)=>callback());
        this.clearRetryListenerFncs = [];
    }
    ensureColumnVisible(key, position = "auto") {
        const { colModel: colModel, frameworkOverrides: frameworkOverrides } = this.beans;
        const column = colModel.getCol(key);
        if (!column) return;
        if (column.isPinned()) return;
        if (!this.visibleCols.isColDisplayed(column)) return;
        const newHorizontalScroll = this.getPositionedHorizontalScroll(column, position);
        frameworkOverrides.wrapIncoming(()=>{
            if (newHorizontalScroll !== null) this.centerRowsCtrl.setCenterViewportScrollLeft(newHorizontalScroll);
            this.centerRowsCtrl.onHorizontalViewportChanged();
            this.animationFrameSvc?.flushAllFrames();
        });
    }
    getPositionedHorizontalScroll(column, position) {
        const { columnBeforeStart: columnBeforeStart, columnAfterEnd: columnAfterEnd } = this.isColumnOutsideViewport(column);
        const viewportTooSmallForColumn = this.centerRowsCtrl.getCenterWidth() < column.getActualWidth();
        const viewportWidth = this.centerRowsCtrl.getCenterWidth();
        const isRtl = this.enableRtl;
        let alignColToStart = (isRtl ? columnBeforeStart : columnAfterEnd) || viewportTooSmallForColumn;
        let alignColToEnd = isRtl ? columnAfterEnd : columnBeforeStart;
        if (position !== "auto") {
            alignColToStart = position === "start";
            alignColToEnd = position === "end";
        }
        const isMiddle = position === "middle";
        if (alignColToStart || alignColToEnd || isMiddle) {
            const { colLeft: colLeft, colMiddle: colMiddle, colRight: colRight } = this.getColumnBounds(column);
            if (isMiddle) return colMiddle - viewportWidth / 2;
            if (alignColToStart) return isRtl ? colRight : colLeft;
            return isRtl ? colLeft - viewportWidth : colRight - viewportWidth;
        }
        return null;
    }
    isColumnOutsideViewport(column) {
        const { start: viewportStart, end: viewportEnd } = this.getViewportBounds();
        const { colLeft: colLeft, colRight: colRight } = this.getColumnBounds(column);
        const isRtl = this.enableRtl;
        const columnBeforeStart = isRtl ? viewportStart > colRight : viewportEnd < colRight;
        const columnAfterEnd = isRtl ? viewportEnd < colLeft : viewportStart > colLeft;
        return {
            columnBeforeStart: columnBeforeStart,
            columnAfterEnd: columnAfterEnd
        };
    }
    getColumnBounds(column) {
        const isRtl = this.enableRtl;
        const bodyWidth = this.visibleCols.bodyWidth;
        const colWidth = column.getActualWidth();
        const colLeft = column.getLeft();
        const multiplier = isRtl ? -1 : 1;
        const colLeftPixel = isRtl ? bodyWidth - colLeft : colLeft;
        const colRightPixel = colLeftPixel + colWidth * multiplier;
        const colMidPixel = colLeftPixel + colWidth / 2 * multiplier;
        return {
            colLeft: colLeftPixel,
            colMiddle: colMidPixel,
            colRight: colRightPixel
        };
    }
    getViewportBounds() {
        const viewportWidth = this.centerRowsCtrl.getCenterWidth();
        const scrollPosition = this.centerRowsCtrl.getCenterViewportScrollLeft();
        const viewportStartPixel = scrollPosition;
        const viewportEndPixel = viewportWidth + scrollPosition;
        return {
            start: viewportStartPixel,
            end: viewportEndPixel,
            width: viewportWidth
        };
    }
};
// packages/ag-grid-community/src/gridBodyComp/centerWidthFeature.ts
var $437b23f6a393c3bf$var$CenterWidthFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(callback, addSpacer = false){
        super();
        this.callback = callback;
        this.addSpacer = addSpacer;
    }
    postConstruct() {
        const listener = this.setWidth.bind(this);
        this.addManagedPropertyListener("domLayout", listener);
        this.addManagedEventListeners({
            columnContainerWidthChanged: listener,
            displayedColumnsChanged: listener,
            leftPinnedWidthChanged: listener
        });
        if (this.addSpacer) this.addManagedEventListeners({
            rightPinnedWidthChanged: listener,
            scrollVisibilityChanged: listener,
            scrollbarWidthChanged: listener
        });
        this.setWidth();
    }
    setWidth() {
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        const { visibleCols: visibleCols, scrollVisibleSvc: scrollVisibleSvc } = this.beans;
        const centerWidth = visibleCols.bodyWidth;
        const leftWidth = visibleCols.getColsLeftWidth();
        const rightWidth = visibleCols.getDisplayedColumnsRightWidth();
        let totalWidth;
        if (printLayout) totalWidth = centerWidth + leftWidth + rightWidth;
        else {
            totalWidth = centerWidth;
            if (this.addSpacer) {
                const relevantWidth = this.gos.get("enableRtl") ? leftWidth : rightWidth;
                if (relevantWidth === 0 && scrollVisibleSvc.verticalScrollShowing) totalWidth += scrollVisibleSvc.getScrollbarWidth();
            }
        }
        this.callback(totalWidth);
    }
};
// packages/ag-grid-community/src/gridBodyComp/viewportSizeFeature.ts
var $437b23f6a393c3bf$var$ViewportSizeFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(centerContainerCtrl){
        super();
        this.centerContainerCtrl = centerContainerCtrl;
    }
    wireBeans(beans) {
        this.scrollVisibleSvc = beans.scrollVisibleSvc;
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
            this.listenForResize();
        });
        this.addManagedEventListeners({
            scrollbarWidthChanged: this.onScrollbarWidthChanged.bind(this)
        });
        this.addManagedPropertyListeners([
            "alwaysShowHorizontalScroll",
            "alwaysShowVerticalScroll"
        ], ()=>{
            this.checkViewportAndScrolls();
        });
    }
    listenForResize() {
        const { beans: beans, centerContainerCtrl: centerContainerCtrl, gridBodyCtrl: gridBodyCtrl } = this;
        const listener = ()=>{
            $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, ()=>{
                this.onCenterViewportResized();
            });
        };
        centerContainerCtrl.registerViewportResizeListener(listener);
        gridBodyCtrl.registerBodyViewportResizeListener(listener);
    }
    onScrollbarWidthChanged() {
        this.checkViewportAndScrolls();
    }
    onCenterViewportResized() {
        this.scrollVisibleSvc.updateScrollGap();
        if (this.centerContainerCtrl.isViewportInTheDOMTree()) {
            const { pinnedCols: pinnedCols, colFlex: colFlex } = this.beans;
            pinnedCols?.keepPinnedColumnsNarrowerThanViewport();
            this.checkViewportAndScrolls();
            const newWidth = this.centerContainerCtrl.getCenterWidth();
            if (newWidth !== this.centerWidth) {
                this.centerWidth = newWidth;
                colFlex?.refreshFlexedColumns({
                    viewportWidth: this.centerWidth,
                    updateBodyWidths: true,
                    fireResizedEvent: true
                });
            }
        } else this.bodyHeight = 0;
    }
    // gets called every time the viewport size changes. we use this to check visibility of scrollbars
    // in the grid panel, and also to check size and position of viewport for row and column virtualisation.
    checkViewportAndScrolls() {
        this.updateScrollVisibleService();
        this.checkBodyHeight();
        this.onHorizontalViewportChanged();
        this.gridBodyCtrl.scrollFeature.checkScrollLeft();
    }
    getBodyHeight() {
        return this.bodyHeight;
    }
    checkBodyHeight() {
        const eBodyViewport = this.gridBodyCtrl.eBodyViewport;
        const bodyHeight = $437b23f6a393c3bf$export$c20e968103d9c16e(eBodyViewport);
        if (this.bodyHeight !== bodyHeight) {
            this.bodyHeight = bodyHeight;
            this.eventSvc.dispatchEvent({
                type: "bodyHeightChanged"
            });
        }
    }
    updateScrollVisibleService() {
        this.updateScrollVisibleServiceImpl();
        setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
    }
    updateScrollVisibleServiceImpl() {
        const params = {
            horizontalScrollShowing: this.centerContainerCtrl.isHorizontalScrollShowing(),
            verticalScrollShowing: this.gridBodyCtrl.isVerticalScrollShowing()
        };
        this.scrollVisibleSvc.setScrollsVisible(params);
    }
    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
    // out the virtual columns again. gets called from following locations:
    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
    onHorizontalViewportChanged() {
        const scrollWidth = this.centerContainerCtrl.getCenterWidth();
        const scrollPosition = this.centerContainerCtrl.getViewportScrollLeft();
        this.beans.colViewport.setScrollPosition(scrollWidth, scrollPosition);
    }
};
// packages/ag-grid-community/src/styling/stylingUtils.ts
function $437b23f6a393c3bf$var$processClassRules(expressionSvc, previousClassRules, classRules, params, onApplicableClass, onNotApplicableClass) {
    if (classRules == null && previousClassRules == null) return;
    const classesToApply = {};
    const classesToRemove = {};
    const forEachSingleClass = (className, callback)=>{
        className.split(" ").forEach((singleClass)=>{
            if (singleClass.trim() == "") return;
            callback(singleClass);
        });
    };
    if (classRules) {
        const classNames = Object.keys(classRules);
        for(let i = 0; i < classNames.length; i++){
            const className = classNames[i];
            const rule = classRules[className];
            let resultOfRule;
            if (typeof rule === "string") resultOfRule = expressionSvc ? expressionSvc.evaluate(rule, params) : true;
            else if (typeof rule === "function") resultOfRule = rule(params);
            forEachSingleClass(className, (singleClass)=>{
                resultOfRule ? classesToApply[singleClass] = true : classesToRemove[singleClass] = true;
            });
        }
    }
    if (previousClassRules && onNotApplicableClass) Object.keys(previousClassRules).forEach((className)=>forEachSingleClass(className, (singleClass)=>{
            if (!classesToApply[singleClass]) classesToRemove[singleClass] = true;
        }));
    if (onNotApplicableClass) Object.keys(classesToRemove).forEach(onNotApplicableClass);
    Object.keys(classesToApply).forEach(onApplicableClass);
}
// packages/ag-grid-community/src/styling/rowStyleService.ts
function $437b23f6a393c3bf$var$calculateRowLevel(rowNode) {
    if (rowNode.group) return rowNode.level;
    const parent = rowNode.parent;
    return parent ? parent.level + 1 : 0;
}
var $437b23f6a393c3bf$var$RowStyleService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowStyleSvc";
    }
    processClassesFromGridOptions(classes, rowNode) {
        const gos = this.gos;
        const process = (rowCls)=>{
            if (typeof rowCls === "string") classes.push(rowCls);
            else if (Array.isArray(rowCls)) rowCls.forEach((e)=>classes.push(e));
        };
        const rowClass = gos.get("rowClass");
        if (rowClass) process(rowClass);
        const rowClassFunc = gos.getCallback("getRowClass");
        if (rowClassFunc) {
            const params = {
                data: rowNode.data,
                node: rowNode,
                rowIndex: rowNode.rowIndex
            };
            const rowClassFuncResult = rowClassFunc(params);
            process(rowClassFuncResult);
        }
    }
    preProcessRowClassRules(classes, rowNode) {
        this.processRowClassRules(rowNode, (className)=>{
            classes.push(className);
        }, ()=>{});
    }
    processRowClassRules(rowNode, onApplicableClass, onNotApplicableClass) {
        const { gos: gos, expressionSvc: expressionSvc } = this.beans;
        const rowClassParams = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            data: rowNode.data,
            node: rowNode,
            rowIndex: rowNode.rowIndex
        });
        $437b23f6a393c3bf$var$processClassRules(expressionSvc, void 0, gos.get("rowClassRules"), rowClassParams, onApplicableClass, onNotApplicableClass);
    }
    processStylesFromGridOptions(rowNode) {
        const gos = this.gos;
        const rowStyle = gos.get("rowStyle");
        const rowStyleFunc = gos.getCallback("getRowStyle");
        let rowStyleFuncResult;
        if (rowStyleFunc) {
            const params = {
                data: rowNode.data,
                node: rowNode,
                rowIndex: rowNode.rowIndex
            };
            rowStyleFuncResult = rowStyleFunc(params);
        }
        if (rowStyleFuncResult || rowStyle) return Object.assign({}, rowStyle, rowStyleFuncResult);
        return void 0;
    }
};
// packages/ag-grid-community/src/rendering/row/rowCtrl.ts
var $437b23f6a393c3bf$var$instanceIdSequence3 = 0;
var $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL = "renderedRow";
var $437b23f6a393c3bf$var$RowCtrl = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(rowNode, beans, animateIn, useAnimationFrameForCreate, printLayout){
        super();
        this.rowNode = rowNode;
        this.useAnimationFrameForCreate = useAnimationFrameForCreate;
        this.printLayout = printLayout;
        this.allRowGuis = [];
        this.active = true;
        this.centerCellCtrls = {
            list: [],
            map: {}
        };
        this.leftCellCtrls = {
            list: [],
            map: {}
        };
        this.rightCellCtrls = {
            list: [],
            map: {}
        };
        this.slideInAnimation = {
            left: false,
            center: false,
            right: false,
            fullWidth: false
        };
        this.fadeInAnimation = {
            left: false,
            center: false,
            right: false,
            fullWidth: false
        };
        this.rowDragComps = [];
        this.lastMouseDownOnDragger = false;
        this.emptyStyle = {};
        this.updateColumnListsPending = false;
        this.rowId = null;
        /** sanitised */ this.businessKey = null;
        this.beans = beans;
        this.gos = beans.gos;
        this.paginationPage = beans.pagination?.getCurrentPage() ?? 0;
        this.suppressRowTransform = this.gos.get("suppressRowTransform");
        this.instanceId = rowNode.id + "-" + $437b23f6a393c3bf$var$instanceIdSequence3++;
        this.rowId = $437b23f6a393c3bf$export$3df06b741968da82(rowNode.id);
        this.initRowBusinessKey();
        this.rowFocused = beans.focusSvc.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
        this.rowLevel = $437b23f6a393c3bf$var$calculateRowLevel(this.rowNode);
        this.setRowType();
        this.setAnimateFlags(animateIn);
        this.rowStyles = this.processStylesFromGridOptions();
        this.rowEditStyleFeature = beans.editSvc?.createRowStyleFeature(this, beans);
        this.addListeners();
    }
    initRowBusinessKey() {
        this.businessKeyForNodeFunc = this.gos.get("getBusinessKeyForNode");
        this.updateRowBusinessKey();
    }
    updateRowBusinessKey() {
        if (typeof this.businessKeyForNodeFunc !== "function") return;
        const businessKey = this.businessKeyForNodeFunc(this.rowNode);
        this.businessKey = $437b23f6a393c3bf$export$3df06b741968da82(businessKey);
    }
    updateGui(containerType, gui) {
        if (containerType === "left") this.leftGui = gui;
        else if (containerType === "right") this.rightGui = gui;
        else if (containerType === "fullWidth") this.fullWidthGui = gui;
        else this.centerGui = gui;
    }
    setComp(rowComp, element, containerType, compBean) {
        const { context: context, focusSvc: focusSvc } = this.beans;
        compBean = $437b23f6a393c3bf$var$setupCompBean(this, context, compBean);
        const gui = {
            rowComp: rowComp,
            element: element,
            containerType: containerType,
            compBean: compBean
        };
        this.allRowGuis.push(gui);
        this.updateGui(containerType, gui);
        this.initialiseRowComp(gui);
        const rowNode = this.rowNode;
        const isSsrmLoadingRow = this.rowType === "FullWidthLoading" || rowNode.stub;
        const isIrmLoadingRow = !rowNode.data && this.beans.rowModel.getType() === "infinite";
        if (!isSsrmLoadingRow && !isIrmLoadingRow && !rowNode.rowPinned) this.beans.rowRenderer.dispatchFirstDataRenderedEvent();
        const focusableElement = this.fullWidthGui?.element;
        if (focusableElement) {
            const editing = this.beans.editSvc?.isEditing(this);
            if (!editing && focusSvc.isRowFocused(rowNode.rowIndex, rowNode.rowPinned) && focusSvc.shouldTakeFocus()) setTimeout(()=>focusableElement.focus({
                    preventScroll: true
                }), 0);
        }
    }
    unsetComp(containerType) {
        this.allRowGuis = this.allRowGuis.filter((rowGui)=>rowGui.containerType !== containerType);
        this.updateGui(containerType, void 0);
    }
    isCacheable() {
        return this.rowType === "FullWidthDetail" && this.gos.get("keepDetailRows");
    }
    setCached(cached) {
        const displayValue = cached ? "none" : "";
        this.allRowGuis.forEach((rg)=>rg.element.style.display = displayValue);
    }
    initialiseRowComp(gui) {
        const gos = this.gos;
        this.onSuppressCellFocusChanged(this.beans.gos.get("suppressCellFocus"));
        this.listenOnDomOrder(gui);
        this.onRowHeightChanged(gui);
        this.updateRowIndexes(gui);
        this.setFocusedClasses(gui);
        this.setStylesFromGridOptions(false, gui);
        if ($437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos) && this.rowNode.selectable) this.onRowSelected(gui);
        this.updateColumnLists(!this.useAnimationFrameForCreate);
        const comp = gui.rowComp;
        const initialRowClasses = this.getInitialRowClasses(gui.containerType);
        initialRowClasses.forEach((name)=>comp.toggleCss(name, true));
        this.executeSlideAndFadeAnimations(gui);
        if (this.rowNode.group) $437b23f6a393c3bf$export$3ad3518dddf15485(gui.element, this.rowNode.expanded == true);
        this.setRowCompRowId(comp);
        this.setRowCompRowBusinessKey(comp);
        $437b23f6a393c3bf$var$_setDomData(gos, gui.element, $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL, this);
        gui.compBean.addDestroyFunc(()=>$437b23f6a393c3bf$var$_setDomData(gos, gui.element, $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL, null));
        if (this.useAnimationFrameForCreate) this.beans.animationFrameSvc.createTask(this.addHoverFunctionality.bind(this, gui), this.rowNode.rowIndex, "p2", false);
        else this.addHoverFunctionality(gui);
        if (this.isFullWidth()) this.setupFullWidth(gui);
        if (gos.get("rowDragEntireRow")) this.addRowDraggerToRow(gui);
        if (this.useAnimationFrameForCreate) this.beans.animationFrameSvc.addDestroyTask(()=>{
            if (!this.isAlive()) return;
            gui.rowComp.toggleCss("ag-after-created", true);
        });
        this.executeProcessRowPostCreateFunc();
    }
    setRowCompRowBusinessKey(comp) {
        if (this.businessKey == null) return;
        comp.setRowBusinessKey(this.businessKey);
    }
    setRowCompRowId(comp) {
        const rowId = $437b23f6a393c3bf$export$3df06b741968da82(this.rowNode.id);
        this.rowId = rowId;
        if (rowId == null) return;
        comp.setRowId(rowId);
    }
    executeSlideAndFadeAnimations(gui) {
        const { containerType: containerType } = gui;
        const shouldSlide = this.slideInAnimation[containerType];
        if (shouldSlide) {
            $437b23f6a393c3bf$export$8ea55376d0d59592(()=>{
                this.onTopChanged();
            });
            this.slideInAnimation[containerType] = false;
        }
        const shouldFade = this.fadeInAnimation[containerType];
        if (shouldFade) {
            $437b23f6a393c3bf$export$8ea55376d0d59592(()=>{
                gui.rowComp.toggleCss("ag-opacity-zero", false);
            });
            this.fadeInAnimation[containerType] = false;
        }
    }
    addRowDraggerToRow(gui) {
        const rowDragComp = this.beans.rowDragSvc?.createRowDragCompForRow(this.rowNode, gui.element);
        if (!rowDragComp) return;
        const rowDragBean = this.createBean(rowDragComp, this.beans.context);
        this.rowDragComps.push(rowDragBean);
        gui.compBean.addDestroyFunc(()=>{
            this.rowDragComps = this.rowDragComps.filter((r)=>r !== rowDragBean);
            this.rowEditStyleFeature = this.destroyBean(this.rowEditStyleFeature, this.beans.context);
            this.destroyBean(rowDragBean, this.beans.context);
        });
    }
    setupFullWidth(gui) {
        const pinned = this.getPinnedForContainer(gui.containerType);
        const compDetails = this.createFullWidthCompDetails(gui.element, pinned);
        gui.rowComp.showFullWidth(compDetails);
    }
    getFullWidthCellRenderers() {
        if (this.gos.get("embedFullWidthRows")) return this.allRowGuis.map((gui)=>gui?.rowComp?.getFullWidthCellRenderer());
        return [
            this.fullWidthGui?.rowComp?.getFullWidthCellRenderer()
        ];
    }
    executeProcessRowPostCreateFunc() {
        const func = this.gos.getCallback("processRowPostCreate");
        if (!func || !this.areAllContainersReady()) return;
        const params = {
            // areAllContainersReady asserts that centerGui is not null
            eRow: this.centerGui.element,
            ePinnedLeftRow: this.leftGui ? this.leftGui.element : void 0,
            ePinnedRightRow: this.rightGui ? this.rightGui.element : void 0,
            node: this.rowNode,
            rowIndex: this.rowNode.rowIndex,
            addRenderedRowListener: this.addEventListener.bind(this)
        };
        func(params);
    }
    areAllContainersReady() {
        const { leftGui: leftGui, centerGui: centerGui, rightGui: rightGui, beans: { visibleCols: visibleCols } } = this;
        const isLeftReady = !!leftGui || !visibleCols.isPinningLeft();
        const isCenterReady = !!centerGui;
        const isRightReady = !!rightGui || !visibleCols.isPinningRight();
        return isLeftReady && isCenterReady && isRightReady;
    }
    isNodeFullWidthCell() {
        if (this.rowNode.detail) return true;
        const isFullWidthCellFunc = this.beans.gos.getCallback("isFullWidthRow");
        return isFullWidthCellFunc ? isFullWidthCellFunc({
            rowNode: this.rowNode
        }) : false;
    }
    setRowType() {
        const isStub = this.rowNode.stub && !this.gos.get("suppressServerSideFullWidthLoadingRow") && !this.gos.get("groupHideOpenParents");
        const isFullWidthCell = this.isNodeFullWidthCell();
        const isDetailCell = this.gos.get("masterDetail") && this.rowNode.detail;
        const pivotMode = this.beans.colModel.isPivotMode();
        const isFullWidthGroup = $437b23f6a393c3bf$export$410912a9c501b8cc(this.gos, this.rowNode, pivotMode);
        if (isStub) this.rowType = "FullWidthLoading";
        else if (isDetailCell) this.rowType = "FullWidthDetail";
        else if (isFullWidthCell) this.rowType = "FullWidth";
        else if (isFullWidthGroup) this.rowType = "FullWidthGroup";
        else this.rowType = "Normal";
    }
    updateColumnLists(suppressAnimationFrame = false, useFlushSync = false) {
        if (this.isFullWidth()) return;
        const { animationFrameSvc: animationFrameSvc } = this.beans;
        const noAnimation = !animationFrameSvc?.active || suppressAnimationFrame || this.printLayout;
        if (noAnimation) {
            this.updateColumnListsImpl(useFlushSync);
            return;
        }
        if (this.updateColumnListsPending) return;
        animationFrameSvc.createTask(()=>{
            if (!this.active) return;
            this.updateColumnListsImpl(true);
        }, this.rowNode.rowIndex, "p1", false);
        this.updateColumnListsPending = true;
    }
    /**
   * Overridden by SpannedRowCtrl
   */ getNewCellCtrl(col) {
        const isCellSpan = this.beans.rowSpanSvc?.isCellSpanning(col, this.rowNode);
        if (isCellSpan) return void 0;
        return new $437b23f6a393c3bf$var$CellCtrl(col, this.rowNode, this.beans, this);
    }
    /**
   * Overridden by SpannedRowCtrl, if span context changes cell needs rebuilt
   */ isCorrectCtrlForSpan(cell) {
        return !this.beans.rowSpanSvc?.isCellSpanning(cell.column, this.rowNode);
    }
    createCellCtrls(prev, cols, pinned = null) {
        const res = {
            list: [],
            map: {}
        };
        const addCell = (colInstanceId, cellCtrl, index)=>{
            if (index != null) res.list.splice(index, 0, cellCtrl);
            else res.list.push(cellCtrl);
            res.map[colInstanceId] = cellCtrl;
        };
        const colsFromPrev = [];
        for (const col of cols){
            const colInstanceId = col.getInstanceId();
            let cellCtrl = prev.map[colInstanceId];
            if (cellCtrl && !this.isCorrectCtrlForSpan(cellCtrl)) {
                cellCtrl.destroy();
                cellCtrl = void 0;
            }
            if (!cellCtrl) cellCtrl = this.getNewCellCtrl(col);
            if (!cellCtrl) continue;
            addCell(colInstanceId, cellCtrl);
        }
        for (const prevCellCtrl of prev.list){
            const colInstanceId = prevCellCtrl.column.getInstanceId();
            const cellInResult = res.map[colInstanceId] != null;
            if (cellInResult) continue;
            const keepCell = !this.isCellEligibleToBeRemoved(prevCellCtrl, pinned);
            if (keepCell) colsFromPrev.push([
                colInstanceId,
                prevCellCtrl
            ]);
            else prevCellCtrl.destroy();
        }
        if (colsFromPrev.length) for (const [colInstanceId, cellCtrl] of colsFromPrev){
            const index = res.list.findIndex((ctrl)=>ctrl.column.getLeft() > cellCtrl.column.getLeft());
            const normalisedIndex = index === -1 ? void 0 : Math.max(index - 1, 0);
            addCell(colInstanceId, cellCtrl, normalisedIndex);
        }
        const { focusSvc: focusSvc, visibleCols: visibleCols } = this.beans;
        const focusedCell = focusSvc.getFocusedCell();
        if (focusedCell && focusedCell.column.getPinned() == pinned) {
            const focusedColInstanceId = focusedCell.column.getInstanceId();
            const focusedCellCtrl = res.map[focusedColInstanceId];
            if (!focusedCellCtrl && visibleCols.allCols.includes(focusedCell.column)) {
                const cellCtrl = this.createFocusedCellCtrl();
                if (cellCtrl) {
                    const index = res.list.findIndex((ctrl)=>ctrl.column.getLeft() > cellCtrl.column.getLeft());
                    const normalisedIndex = index === -1 ? void 0 : Math.max(index - 1, 0);
                    addCell(focusedColInstanceId, cellCtrl, normalisedIndex);
                }
            }
        }
        return res;
    }
    /**
   * Creates a new cell ctrl for the focused cell, if this is the correct row ctrl.
   * @returns a CellCtrl for the focused cell, if required.
   */ createFocusedCellCtrl() {
        const { focusSvc: focusSvc, rowSpanSvc: rowSpanSvc } = this.beans;
        const focusedCell = focusSvc.getFocusedCell();
        if (!focusedCell) return void 0;
        const focusedSpan = rowSpanSvc?.getCellSpan(focusedCell.column, this.rowNode);
        if (focusedSpan) {
            if (focusedSpan.firstNode !== this.rowNode || !focusedSpan.doesSpanContain(focusedCell)) return void 0;
        } else {
            if (!focusSvc.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned)) return void 0;
        }
        return this.getNewCellCtrl(focusedCell.column);
    }
    updateColumnListsImpl(useFlushSync) {
        this.updateColumnListsPending = false;
        this.createAllCellCtrls();
        this.setCellCtrls(useFlushSync);
    }
    setCellCtrls(useFlushSync) {
        this.allRowGuis.forEach((item)=>{
            const cellControls = this.getCellCtrlsForContainer(item.containerType);
            item.rowComp.setCellCtrls(cellControls, useFlushSync);
        });
    }
    getCellCtrlsForContainer(containerType) {
        switch(containerType){
            case "left":
                return this.leftCellCtrls.list;
            case "right":
                return this.rightCellCtrls.list;
            case "fullWidth":
                return [];
            case "center":
                return this.centerCellCtrls.list;
        }
    }
    createAllCellCtrls() {
        const colViewport = this.beans.colViewport;
        const presentedColsService = this.beans.visibleCols;
        if (this.printLayout) {
            this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, presentedColsService.allCols);
            this.leftCellCtrls = {
                list: [],
                map: {}
            };
            this.rightCellCtrls = {
                list: [],
                map: {}
            };
        } else {
            const centerCols = colViewport.getColsWithinViewport(this.rowNode);
            this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, centerCols);
            const leftCols = presentedColsService.getLeftColsForRow(this.rowNode);
            this.leftCellCtrls = this.createCellCtrls(this.leftCellCtrls, leftCols, "left");
            const rightCols = presentedColsService.getRightColsForRow(this.rowNode);
            this.rightCellCtrls = this.createCellCtrls(this.rightCellCtrls, rightCols, "right");
        }
    }
    isCellEligibleToBeRemoved(cellCtrl, nextContainerPinned) {
        const REMOVE_CELL = true;
        const KEEP_CELL = false;
        const { column: column } = cellCtrl;
        if (column.getPinned() != nextContainerPinned) return REMOVE_CELL;
        if (!this.isCorrectCtrlForSpan(cellCtrl)) return REMOVE_CELL;
        const { visibleCols: visibleCols, editSvc: editSvc } = this.beans;
        const editing = editSvc?.isEditing(cellCtrl);
        const focused = cellCtrl.isCellFocused();
        const mightWantToKeepCell = editing || focused;
        if (mightWantToKeepCell) {
            const displayedColumns = visibleCols.allCols;
            const cellStillDisplayed = displayedColumns.indexOf(column) >= 0;
            return cellStillDisplayed ? KEEP_CELL : REMOVE_CELL;
        }
        return REMOVE_CELL;
    }
    getDomOrder() {
        const isEnsureDomOrder = this.gos.get("ensureDomOrder");
        return isEnsureDomOrder || $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
    }
    listenOnDomOrder(gui) {
        const listener = ()=>{
            gui.rowComp.setDomOrder(this.getDomOrder());
        };
        gui.compBean.addManagedPropertyListeners([
            "domLayout",
            "ensureDomOrder"
        ], listener);
    }
    setAnimateFlags(animateIn) {
        if (this.rowNode.sticky || !animateIn) return;
        const oldRowTopExists = $437b23f6a393c3bf$export$25d27f17d3af40f7(this.rowNode.oldRowTop);
        const { visibleCols: visibleCols } = this.beans;
        const pinningLeft = visibleCols.isPinningLeft();
        const pinningRight = visibleCols.isPinningRight();
        if (oldRowTopExists) {
            const { slideInAnimation: slideInAnimation } = this;
            if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
                slideInAnimation.fullWidth = true;
                return;
            }
            slideInAnimation.center = true;
            slideInAnimation.left = pinningLeft;
            slideInAnimation.right = pinningRight;
        } else {
            const { fadeInAnimation: fadeInAnimation } = this;
            if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
                fadeInAnimation.fullWidth = true;
                return;
            }
            fadeInAnimation.center = true;
            fadeInAnimation.left = pinningLeft;
            fadeInAnimation.right = pinningRight;
        }
    }
    isFullWidth() {
        return this.rowType !== "Normal";
    }
    refreshFullWidth() {
        const tryRefresh = (gui, pinned)=>{
            if (!gui) return true;
            return gui.rowComp.refreshFullWidth(()=>{
                const compDetails = this.createFullWidthCompDetails(gui.element, pinned);
                return compDetails.params;
            });
        };
        const fullWidthSuccess = tryRefresh(this.fullWidthGui, null);
        const centerSuccess = tryRefresh(this.centerGui, null);
        const leftSuccess = tryRefresh(this.leftGui, "left");
        const rightSuccess = tryRefresh(this.rightGui, "right");
        const allFullWidthRowsRefreshed = fullWidthSuccess && centerSuccess && leftSuccess && rightSuccess;
        return allFullWidthRowsRefreshed;
    }
    addListeners() {
        const { beans: beans, gos: gos, rowNode: rowNode } = this;
        const { expansionSvc: expansionSvc, eventSvc: eventSvc, context: context, rowSpanSvc: rowSpanSvc } = beans;
        this.addManagedListeners(this.rowNode, {
            heightChanged: ()=>this.onRowHeightChanged(),
            rowSelected: ()=>this.onRowSelected(),
            rowIndexChanged: this.onRowIndexChanged.bind(this),
            topChanged: this.onTopChanged.bind(this),
            ...expansionSvc?.getRowExpandedListeners(this) ?? {}
        });
        if (rowNode.detail) this.addManagedListeners(rowNode.parent, {
            dataChanged: this.onRowNodeDataChanged.bind(this)
        });
        this.addManagedListeners(rowNode, {
            dataChanged: this.onRowNodeDataChanged.bind(this),
            cellChanged: this.postProcessCss.bind(this),
            rowHighlightChanged: this.onRowNodeHighlightChanged.bind(this),
            draggingChanged: this.postProcessRowDragging.bind(this),
            uiLevelChanged: this.onUiLevelChanged.bind(this),
            rowPinned: this.onRowPinned.bind(this)
        });
        this.addManagedListeners(eventSvc, {
            paginationPixelOffsetChanged: this.onPaginationPixelOffsetChanged.bind(this),
            heightScaleChanged: this.onTopChanged.bind(this),
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
            virtualColumnsChanged: this.onVirtualColumnsChanged.bind(this),
            cellFocused: this.onCellFocusChanged.bind(this),
            cellFocusCleared: this.onCellFocusChanged.bind(this),
            paginationChanged: this.onPaginationChanged.bind(this),
            modelUpdated: this.refreshFirstAndLastRowStyles.bind(this),
            columnMoved: ()=>this.updateColumnLists()
        });
        if (rowSpanSvc) this.addManagedListeners(rowSpanSvc, {
            spannedCellsUpdated: ({ pinned: pinned })=>{
                if (pinned && !rowNode.rowPinned) return;
                this.updateColumnLists();
            }
        });
        this.addDestroyFunc(()=>{
            this.rowDragComps = this.destroyBeans(this.rowDragComps, context);
            this.tooltipFeature = this.destroyBean(this.tooltipFeature, context);
            this.rowEditStyleFeature = this.destroyBean(this.rowEditStyleFeature, context);
        });
        this.addManagedPropertyListeners([
            "rowStyle",
            "getRowStyle",
            "rowClass",
            "getRowClass",
            "rowClassRules"
        ], this.postProcessCss.bind(this));
        this.addManagedPropertyListener("rowDragEntireRow", ()=>{
            const useRowDragEntireRow = gos.get("rowDragEntireRow");
            if (useRowDragEntireRow) {
                this.allRowGuis.forEach((gui)=>{
                    this.addRowDraggerToRow(gui);
                });
                return;
            }
            this.rowDragComps = this.destroyBeans(this.rowDragComps, context);
        });
        this.addListenersForCellComps();
    }
    addListenersForCellComps() {
        this.addManagedListeners(this.rowNode, {
            rowIndexChanged: ()=>this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onRowIndexChanged()),
            cellChanged: (event)=>this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onCellChanged(event))
        });
    }
    /** Should only ever be triggered on source rows (i.e. not on pinned siblings) */ onRowPinned() {
        for (const gui of this.allRowGuis)gui.rowComp.toggleCss("ag-row-pinned-source", !!this.rowNode.pinnedSibling);
    }
    onRowNodeDataChanged(event) {
        this.refreshRow({
            suppressFlash: !event.update,
            newData: !event.update
        });
    }
    refreshRow(params) {
        const fullWidthChanged = this.isFullWidth() !== !!this.isNodeFullWidthCell();
        if (fullWidthChanged) {
            this.beans.rowRenderer.redrawRow(this.rowNode);
            return;
        }
        if (this.isFullWidth()) {
            const refresh = this.refreshFullWidth();
            if (!refresh) this.beans.rowRenderer.redrawRow(this.rowNode);
            return;
        }
        this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.refreshCell(params));
        this.allRowGuis.forEach((gui)=>{
            this.setRowCompRowId(gui.rowComp);
            this.updateRowBusinessKey();
            this.setRowCompRowBusinessKey(gui.rowComp);
        });
        this.onRowSelected();
        this.postProcessCss();
    }
    postProcessCss() {
        this.setStylesFromGridOptions(true);
        this.postProcessClassesFromGridOptions();
        this.postProcessRowClassRules();
        this.rowEditStyleFeature?.applyRowStyles();
        this.postProcessRowDragging();
    }
    onRowNodeHighlightChanged() {
        const rowDropHighlightSvc = this.beans.rowDropHighlightSvc;
        const highlighted = rowDropHighlightSvc?.row === this.rowNode ? rowDropHighlightSvc.position : "none";
        const aboveOn = highlighted === "above";
        const insideOn = highlighted === "inside";
        const belowOn = highlighted === "below";
        const treeData = this.gos.get("treeData");
        const indented = treeData && (belowOn || aboveOn);
        const uiLevel = this.rowNode.uiLevel.toString();
        this.allRowGuis.forEach((gui)=>{
            const rowComp = gui.rowComp;
            rowComp.toggleCss("ag-row-highlight-above", aboveOn);
            rowComp.toggleCss("ag-row-highlight-inside", insideOn);
            rowComp.toggleCss("ag-row-highlight-below", belowOn);
            rowComp.toggleCss("ag-row-highlight-indent", indented);
            if (indented) gui.element.style.setProperty("--ag-row-highlight-level", uiLevel);
            else gui.element.style.removeProperty("--ag-row-highlight-level");
        });
    }
    postProcessRowDragging() {
        const dragging = this.rowNode.dragging;
        this.allRowGuis.forEach((gui)=>gui.rowComp.toggleCss("ag-row-dragging", dragging));
    }
    onDisplayedColumnsChanged() {
        this.updateColumnLists(true);
        this.beans.rowAutoHeight?.requestCheckAutoHeight();
    }
    onVirtualColumnsChanged() {
        this.updateColumnLists(false, true);
    }
    getRowPosition() {
        return {
            rowPinned: $437b23f6a393c3bf$export$4978424c4f7b5fc0(this.rowNode.rowPinned),
            rowIndex: this.rowNode.rowIndex
        };
    }
    onKeyboardNavigate(keyboardEvent) {
        const groupInfo = this.findFullWidthInfoForEvent(keyboardEvent);
        if (!groupInfo) return;
        const { rowGui: rowGui, column: column } = groupInfo;
        const currentFullWidthContainer = rowGui.element;
        const isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
        if (!isFullWidthContainerFocused) return;
        const node = this.rowNode;
        const { focusSvc: focusSvc, navigation: navigation } = this.beans;
        const lastFocusedCell = focusSvc.getFocusedCell();
        const cellPosition = {
            rowIndex: node.rowIndex,
            rowPinned: node.rowPinned,
            column: lastFocusedCell?.column ?? column
        };
        navigation?.navigateToNextCell(keyboardEvent, keyboardEvent.key, cellPosition, true);
        keyboardEvent.preventDefault();
    }
    onTabKeyDown(keyboardEvent) {
        if (keyboardEvent.defaultPrevented || $437b23f6a393c3bf$export$9a48e23524c6d58(keyboardEvent)) return;
        const currentFullWidthComp = this.allRowGuis.find((c)=>c.element.contains(keyboardEvent.target));
        const currentFullWidthContainer = currentFullWidthComp ? currentFullWidthComp.element : null;
        const isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        let isDetailGridCellFocused = false;
        if (currentFullWidthContainer && activeEl) isDetailGridCellFocused = currentFullWidthContainer.contains(activeEl) && activeEl.classList.contains("ag-cell");
        let nextEl = null;
        if (!isFullWidthContainerFocused && !isDetailGridCellFocused) nextEl = $437b23f6a393c3bf$export$83fc12531358bd28(this.beans, currentFullWidthContainer, false, keyboardEvent.shiftKey);
        if (this.isFullWidth() && isFullWidthContainerFocused || !nextEl) this.beans.navigation?.onTabKeyDown(this, keyboardEvent);
    }
    getFullWidthElement() {
        if (this.fullWidthGui) return this.fullWidthGui.element;
        return null;
    }
    getRowYPosition() {
        const displayedEl = this.allRowGuis.find((el)=>$437b23f6a393c3bf$export$2badf4aa566524cb(el.element))?.element;
        if (displayedEl) return displayedEl.getBoundingClientRect().top;
        return 0;
    }
    onSuppressCellFocusChanged(suppressCellFocus) {
        const tabIndex = this.isFullWidth() && suppressCellFocus ? void 0 : -1;
        this.allRowGuis.forEach((gui)=>{
            $437b23f6a393c3bf$var$_addOrRemoveAttribute(gui.element, "tabindex", tabIndex);
        });
    }
    onFullWidthRowFocused(event) {
        const node = this.rowNode;
        const isFocused = !event ? false : this.isFullWidth() && event.rowIndex === node.rowIndex && event.rowPinned == node.rowPinned;
        let element;
        if (this.fullWidthGui) element = this.fullWidthGui.element;
        else {
            const column = this.beans.colModel.getCol(event?.column);
            const pinned = column?.pinned;
            if (pinned) element = pinned === "right" ? this.rightGui?.element : this.leftGui?.element;
            else element = this.centerGui?.element;
        }
        if (!element) return;
        element.classList.toggle("ag-full-width-focus", isFocused);
        if (isFocused && event?.forceBrowserFocus) element.focus({
            preventScroll: true
        });
    }
    recreateCell(cellCtrl) {
        this.centerCellCtrls = this.removeCellCtrl(this.centerCellCtrls, cellCtrl);
        this.leftCellCtrls = this.removeCellCtrl(this.leftCellCtrls, cellCtrl);
        this.rightCellCtrls = this.removeCellCtrl(this.rightCellCtrls, cellCtrl);
        cellCtrl.destroy();
        this.updateColumnLists();
    }
    removeCellCtrl(prev, cellCtrlToRemove) {
        const res = {
            list: [],
            map: {}
        };
        prev.list.forEach((cellCtrl)=>{
            if (cellCtrl === cellCtrlToRemove) return;
            res.list.push(cellCtrl);
            res.map[cellCtrl.column.getInstanceId()] = cellCtrl;
        });
        return res;
    }
    onMouseEvent(eventName, mouseEvent) {
        switch(eventName){
            case "dblclick":
                this.onRowDblClick(mouseEvent);
                break;
            case "click":
                this.onRowClick(mouseEvent);
                break;
            case "touchstart":
            case "mousedown":
                this.onRowMouseDown(mouseEvent);
                break;
        }
    }
    createRowEvent(type, domEvent) {
        const { rowNode: rowNode } = this;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            type: type,
            node: rowNode,
            data: rowNode.data,
            rowIndex: rowNode.rowIndex,
            rowPinned: rowNode.rowPinned,
            event: domEvent
        });
    }
    createRowEventWithSource(type, domEvent) {
        const event = this.createRowEvent(type, domEvent);
        event.source = this;
        return event;
    }
    onRowDblClick(mouseEvent) {
        if ($437b23f6a393c3bf$export$9a48e23524c6d58(mouseEvent)) return;
        this.beans.eventSvc.dispatchEvent(this.createRowEventWithSource("rowDoubleClicked", mouseEvent));
    }
    findFullWidthInfoForEvent(event) {
        if (!event) return;
        const rowGui = this.findFullWidthRowGui(event.target);
        const column = this.getColumnForFullWidth(rowGui);
        if (!rowGui || !column) return;
        return {
            rowGui: rowGui,
            column: column
        };
    }
    findFullWidthRowGui(target) {
        return this.allRowGuis.find((c)=>c.element.contains(target));
    }
    getColumnForFullWidth(fullWidthRowGui) {
        const { visibleCols: visibleCols } = this.beans;
        switch(fullWidthRowGui?.containerType){
            case "center":
                return visibleCols.centerCols[0];
            case "left":
                return visibleCols.leftCols[0];
            case "right":
                return visibleCols.rightCols[0];
            default:
                return visibleCols.allCols[0];
        }
    }
    onRowMouseDown(mouseEvent) {
        this.lastMouseDownOnDragger = $437b23f6a393c3bf$var$_isElementChildOfClass(mouseEvent.target, "ag-row-drag", 3);
        if (!this.isFullWidth()) return;
        const node = this.rowNode;
        const { rangeSvc: rangeSvc, focusSvc: focusSvc } = this.beans;
        rangeSvc?.removeAllCellRanges();
        const groupInfo = this.findFullWidthInfoForEvent(mouseEvent);
        if (!groupInfo) return;
        const { rowGui: rowGui, column: column } = groupInfo;
        const element = rowGui.element;
        const target = mouseEvent.target;
        let forceBrowserFocus = mouseEvent.defaultPrevented || $437b23f6a393c3bf$var$_isBrowserSafari();
        if (element && element.contains(target) && $437b23f6a393c3bf$var$_isFocusableFormField(target)) forceBrowserFocus = false;
        focusSvc.setFocusedCell({
            rowIndex: node.rowIndex,
            column: column,
            rowPinned: node.rowPinned,
            forceBrowserFocus: forceBrowserFocus
        });
    }
    onRowClick(mouseEvent) {
        const stop = $437b23f6a393c3bf$export$9a48e23524c6d58(mouseEvent) || this.lastMouseDownOnDragger;
        if (stop) return;
        const { eventSvc: eventSvc, selectionSvc: selectionSvc } = this.beans;
        eventSvc.dispatchEvent(this.createRowEventWithSource("rowClicked", mouseEvent));
        selectionSvc?.handleSelectionEvent(mouseEvent, this.rowNode, "rowClicked");
    }
    setupDetailRowAutoHeight(eDetailGui) {
        if (this.rowType !== "FullWidthDetail") return;
        this.beans.masterDetailSvc?.setupDetailRowAutoHeight(this, eDetailGui);
    }
    createFullWidthCompDetails(eRow, pinned) {
        const { gos: gos, rowNode: rowNode } = this;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            fullWidth: true,
            data: rowNode.data,
            node: rowNode,
            value: rowNode.key,
            valueFormatted: rowNode.key,
            // these need to be taken out, as part of 'afterAttached' now
            eGridCell: eRow,
            eParentOfValue: eRow,
            pinned: pinned,
            addRenderedRowListener: this.addEventListener.bind(this),
            // This is not on the type of ICellRendererParams
            registerRowDragger: (rowDraggerElement, dragStartPixels, value, suppressVisibilityChange)=>this.addFullWidthRowDragging(rowDraggerElement, dragStartPixels, value, suppressVisibilityChange),
            setTooltip: (value, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                this.setupFullWidthRowTooltip(value, shouldDisplayTooltip);
            }
        });
        const compFactory = this.beans.userCompFactory;
        switch(this.rowType){
            case "FullWidthDetail":
                return $437b23f6a393c3bf$var$_getFullWidthDetailCellRendererDetails(compFactory, params);
            case "FullWidthGroup":
                {
                    const { value: value, valueFormatted: valueFormatted } = this.beans.valueSvc.getValueForDisplay(void 0, this.rowNode, true);
                    params.value = value;
                    params.valueFormatted = valueFormatted;
                    return $437b23f6a393c3bf$var$_getFullWidthGroupCellRendererDetails(compFactory, params);
                }
            case "FullWidthLoading":
                return $437b23f6a393c3bf$var$_getFullWidthLoadingCellRendererDetails(compFactory, params);
            default:
                return $437b23f6a393c3bf$var$_getFullWidthCellRendererDetails(compFactory, params);
        }
    }
    setupFullWidthRowTooltip(value, shouldDisplayTooltip) {
        if (!this.fullWidthGui) return;
        this.tooltipFeature = this.beans.tooltipSvc?.setupFullWidthRowTooltip(this.tooltipFeature, this, value, shouldDisplayTooltip);
    }
    addFullWidthRowDragging(rowDraggerElement, dragStartPixels, value = "", suppressVisibilityChange) {
        const { rowDragSvc: rowDragSvc, context: context } = this.beans;
        if (!rowDragSvc || !this.isFullWidth()) return;
        const rowDragComp = rowDragSvc.createRowDragComp(()=>value, this.rowNode, void 0, rowDraggerElement, dragStartPixels, suppressVisibilityChange);
        this.createBean(rowDragComp, context);
        this.addDestroyFunc(()=>{
            this.destroyBean(rowDragComp, context);
        });
    }
    onUiLevelChanged() {
        const newLevel = $437b23f6a393c3bf$var$calculateRowLevel(this.rowNode);
        if (this.rowLevel != newLevel) {
            const classToAdd = "ag-row-level-" + newLevel;
            const classToRemove = "ag-row-level-" + this.rowLevel;
            this.allRowGuis.forEach((gui)=>{
                gui.rowComp.toggleCss(classToAdd, true);
                gui.rowComp.toggleCss(classToRemove, false);
            });
        }
        this.rowLevel = newLevel;
    }
    isFirstRowOnPage() {
        return this.rowNode.rowIndex === this.beans.pageBounds.getFirstRow();
    }
    isLastRowOnPage() {
        return this.rowNode.rowIndex === this.beans.pageBounds.getLastRow();
    }
    refreshFirstAndLastRowStyles() {
        const newFirst = this.isFirstRowOnPage();
        const newLast = this.isLastRowOnPage();
        if (this.firstRowOnPage !== newFirst) {
            this.firstRowOnPage = newFirst;
            this.allRowGuis.forEach((gui)=>gui.rowComp.toggleCss("ag-row-first", newFirst));
        }
        if (this.lastRowOnPage !== newLast) {
            this.lastRowOnPage = newLast;
            this.allRowGuis.forEach((gui)=>gui.rowComp.toggleCss("ag-row-last", newLast));
        }
    }
    getAllCellCtrls() {
        if (this.leftCellCtrls.list.length === 0 && this.rightCellCtrls.list.length === 0) return this.centerCellCtrls.list;
        const res = [
            ...this.centerCellCtrls.list,
            ...this.leftCellCtrls.list,
            ...this.rightCellCtrls.list
        ];
        return res;
    }
    postProcessClassesFromGridOptions() {
        const cssClasses = [];
        this.beans.rowStyleSvc?.processClassesFromGridOptions(cssClasses, this.rowNode);
        if (!cssClasses.length) return;
        cssClasses.forEach((classStr)=>{
            this.allRowGuis.forEach((c)=>c.rowComp.toggleCss(classStr, true));
        });
    }
    postProcessRowClassRules() {
        this.beans.rowStyleSvc?.processRowClassRules(this.rowNode, (className)=>{
            this.allRowGuis.forEach((gui)=>gui.rowComp.toggleCss(className, true));
        }, (className)=>{
            this.allRowGuis.forEach((gui)=>gui.rowComp.toggleCss(className, false));
        });
    }
    setStylesFromGridOptions(updateStyles, gui) {
        if (updateStyles) this.rowStyles = this.processStylesFromGridOptions();
        this.forEachGui(gui, (gui2)=>gui2.rowComp.setUserStyles(this.rowStyles));
    }
    getPinnedForContainer(rowContainerType) {
        if (rowContainerType === "left" || rowContainerType === "right") return rowContainerType;
        return null;
    }
    getInitialRowClasses(rowContainerType) {
        const pinned = this.getPinnedForContainer(rowContainerType);
        const fullWidthRow = this.isFullWidth();
        const { rowNode: rowNode, beans: beans } = this;
        const classes = [];
        classes.push("ag-row");
        classes.push(this.rowFocused ? "ag-row-focus" : "ag-row-no-focus");
        if (this.fadeInAnimation[rowContainerType]) classes.push("ag-opacity-zero");
        classes.push(rowNode.rowIndex % 2 === 0 ? "ag-row-even" : "ag-row-odd");
        if (rowNode.isRowPinned()) {
            classes.push("ag-row-pinned");
            if (beans.pinnedRowModel?.isManual()) classes.push("ag-row-pinned-manual");
        }
        if (!rowNode.isRowPinned() && rowNode.pinnedSibling) classes.push("ag-row-pinned-source");
        if (rowNode.isSelected()) classes.push("ag-row-selected");
        if (rowNode.footer) classes.push("ag-row-footer");
        classes.push("ag-row-level-" + this.rowLevel);
        if (rowNode.stub) classes.push("ag-row-loading");
        if (fullWidthRow) classes.push("ag-full-width-row");
        beans.expansionSvc?.addExpandedCss(classes, rowNode);
        if (rowNode.dragging) classes.push("ag-row-dragging");
        const { rowStyleSvc: rowStyleSvc } = beans;
        if (rowStyleSvc) {
            rowStyleSvc.processClassesFromGridOptions(classes, rowNode);
            rowStyleSvc.preProcessRowClassRules(classes, rowNode);
        }
        classes.push(this.printLayout ? "ag-row-position-relative" : "ag-row-position-absolute");
        if (this.isFirstRowOnPage()) classes.push("ag-row-first");
        if (this.isLastRowOnPage()) classes.push("ag-row-last");
        if (fullWidthRow) {
            if (pinned === "left") classes.push("ag-cell-last-left-pinned");
            if (pinned === "right") classes.push("ag-cell-first-right-pinned");
        }
        return classes;
    }
    processStylesFromGridOptions() {
        return this.beans.rowStyleSvc?.processStylesFromGridOptions(this.rowNode) ?? this.emptyStyle;
    }
    onRowSelected(gui) {
        this.beans.selectionSvc?.onRowCtrlSelected(this, (gui2)=>{
            if (gui2 === this.centerGui || gui2 === this.fullWidthGui) this.announceDescription();
        }, gui);
    }
    announceDescription() {
        this.beans.selectionSvc?.announceAriaRowSelection(this.rowNode);
    }
    addHoverFunctionality(eGui) {
        if (!this.active) return;
        const { element: element, compBean: compBean } = eGui;
        const { rowNode: rowNode, beans: beans, gos: gos } = this;
        compBean.addManagedListeners(element, {
            // We use pointer events here instead of mouse events, as pointer events
            // are more reliable for hover detection, especially with touch devices
            // or hybrid touch + mouse devices.
            pointerenter: (e)=>{
                if (e.pointerType === "mouse") rowNode.dispatchRowEvent("mouseEnter");
            },
            pointerleave: (e)=>{
                if (e.pointerType === "mouse") rowNode.dispatchRowEvent("mouseLeave");
            }
        });
        compBean.addManagedListeners(rowNode, {
            mouseEnter: ()=>{
                if (!beans.dragSvc?.dragging && !gos.get("suppressRowHoverHighlight")) {
                    element.classList.add("ag-row-hover");
                    rowNode.setHovered(true);
                }
            },
            mouseLeave: ()=>{
                this.resetHoveredStatus(element);
            }
        });
    }
    resetHoveredStatus(el) {
        const elements = el ? [
            el
        ] : this.allRowGuis.map((gui)=>gui.element);
        for (const element of elements)element.classList.remove("ag-row-hover");
        this.rowNode.setHovered(false);
    }
    // for animation, we don't want to animate entry or exit to a very far away pixel,
    // otherwise the row would move so fast, it would appear to disappear. so this method
    // moves the row closer to the viewport if it is far away, so the row slide in / out
    // at a speed the user can see.
    roundRowTopToBounds(rowTop) {
        const range = this.beans.ctrlsSvc.getScrollFeature().getApproximateVScollPosition();
        const minPixel = this.applyPaginationOffset(range.top, true) - 100;
        const maxPixel = this.applyPaginationOffset(range.bottom, true) + 100;
        return Math.min(Math.max(minPixel, rowTop), maxPixel);
    }
    forEachGui(gui, callback) {
        if (gui) callback(gui);
        else this.allRowGuis.forEach(callback);
    }
    isRowRendered() {
        return this.allRowGuis.length > 0;
    }
    onRowHeightChanged(gui) {
        if (this.rowNode.rowHeight == null) return;
        const rowHeight = this.rowNode.rowHeight;
        const defaultRowHeight = this.beans.environment.getDefaultRowHeight();
        const isHeightFromFunc = $437b23f6a393c3bf$export$f0ddd2d4ccc7fed8(this.gos);
        const heightFromFunc = isHeightFromFunc ? $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, this.rowNode).height : void 0;
        const lineHeight = heightFromFunc ? `${Math.min(defaultRowHeight, heightFromFunc) - 2}px` : void 0;
        this.forEachGui(gui, (gui2)=>{
            gui2.element.style.height = `${rowHeight}px`;
            if (lineHeight) gui2.element.style.setProperty("--ag-line-height", lineHeight);
        });
    }
    // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
    destroyFirstPass(suppressAnimation = false) {
        this.active = false;
        const { rowNode: rowNode } = this;
        if (!suppressAnimation && $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos) && !rowNode.sticky) {
            const rowStillVisibleJustNotInViewport = rowNode.rowTop != null;
            if (rowStillVisibleJustNotInViewport) {
                const rowTop = this.roundRowTopToBounds(rowNode.rowTop);
                this.setRowTop(rowTop);
            } else this.allRowGuis.forEach((gui)=>gui.rowComp.toggleCss("ag-opacity-zero", true));
        }
        if (this.fullWidthGui?.element.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans))) this.beans.focusSvc.attemptToRecoverFocus();
        rowNode.setHovered(false);
        const event = this.createRowEvent("virtualRowRemoved");
        this.dispatchLocalEvent(event);
        this.beans.eventSvc.dispatchEvent(event);
        super.destroy();
    }
    destroySecondPass() {
        this.allRowGuis.length = 0;
        const destroyCellCtrls = (ctrls)=>{
            ctrls.list.forEach((c)=>c.destroy());
            return {
                list: [],
                map: {}
            };
        };
        this.centerCellCtrls = destroyCellCtrls(this.centerCellCtrls);
        this.leftCellCtrls = destroyCellCtrls(this.leftCellCtrls);
        this.rightCellCtrls = destroyCellCtrls(this.rightCellCtrls);
    }
    setFocusedClasses(gui) {
        this.forEachGui(gui, (gui2)=>{
            gui2.rowComp.toggleCss("ag-row-focus", this.rowFocused);
            gui2.rowComp.toggleCss("ag-row-no-focus", !this.rowFocused);
        });
    }
    onCellFocusChanged() {
        const { focusSvc: focusSvc } = this.beans;
        const rowFocused = focusSvc.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
        if (rowFocused !== this.rowFocused) {
            this.rowFocused = rowFocused;
            this.setFocusedClasses();
        }
    }
    onPaginationChanged() {
        const currentPage = this.beans.pagination?.getCurrentPage() ?? 0;
        if (this.paginationPage !== currentPage) {
            this.paginationPage = currentPage;
            this.onTopChanged();
        }
        this.refreshFirstAndLastRowStyles();
    }
    onTopChanged() {
        this.setRowTop(this.rowNode.rowTop);
    }
    onPaginationPixelOffsetChanged() {
        this.onTopChanged();
    }
    // applies pagination offset, eg if on second page, and page height is 500px, then removes
    // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
    // reverse will take the offset away rather than add.
    applyPaginationOffset(topPx, reverse = false) {
        if (this.rowNode.isRowPinned() || this.rowNode.sticky) return topPx;
        const pixelOffset = this.beans.pageBounds.getPixelOffset();
        const multiplier = reverse ? 1 : -1;
        return topPx + pixelOffset * multiplier;
    }
    setRowTop(pixels) {
        if (this.printLayout) return;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(pixels)) {
            const afterPaginationPixels = this.applyPaginationOffset(pixels);
            const skipScaling = this.rowNode.isRowPinned() || this.rowNode.sticky;
            const afterScalingPixels = skipScaling ? afterPaginationPixels : this.beans.rowContainerHeight.getRealPixelPosition(afterPaginationPixels);
            const topPx = `${afterScalingPixels}px`;
            this.setRowTopStyle(topPx);
        }
    }
    // the top needs to be set into the DOM element when the element is created, not updated afterwards.
    // otherwise the transition would not work, as it would be transitioning from zero (the unset value).
    // for example, suppose a row that is outside the viewport, then user does a filter to remove other rows
    // and this row now appears in the viewport, and the row moves up (ie it was under the viewport and not rendered,
    // but now is in the viewport) then a new RowComp is created, however it should have it's position initialised
    // to below the viewport, so the row will appear to animate up. if we didn't set the initial position at creation
    // time, the row would animate down (ie from position zero).
    getInitialRowTop(rowContainerType) {
        return this.suppressRowTransform ? this.getInitialRowTopShared(rowContainerType) : void 0;
    }
    getInitialTransform(rowContainerType) {
        return this.suppressRowTransform ? void 0 : `translateY(${this.getInitialRowTopShared(rowContainerType)})`;
    }
    getInitialRowTopShared(rowContainerType) {
        if (this.printLayout) return "";
        const rowNode = this.rowNode;
        let rowTop;
        if (rowNode.sticky) rowTop = rowNode.stickyRowTop;
        else {
            const pixels = this.slideInAnimation[rowContainerType] ? this.roundRowTopToBounds(rowNode.oldRowTop) : rowNode.rowTop;
            const afterPaginationPixels = this.applyPaginationOffset(pixels);
            rowTop = rowNode.isRowPinned() ? afterPaginationPixels : this.beans.rowContainerHeight.getRealPixelPosition(afterPaginationPixels);
        }
        return rowTop + "px";
    }
    setRowTopStyle(topPx) {
        this.allRowGuis.forEach((gui)=>this.suppressRowTransform ? gui.rowComp.setTop(topPx) : gui.rowComp.setTransform(`translateY(${topPx})`));
    }
    getCellCtrl(column, skipColSpanSearch = false) {
        let res = null;
        this.getAllCellCtrls().forEach((cellCtrl)=>{
            if (cellCtrl.column == column) res = cellCtrl;
        });
        if (res != null || skipColSpanSearch) return res;
        this.getAllCellCtrls().forEach((cellCtrl)=>{
            if (cellCtrl?.getColSpanningList().indexOf(column) >= 0) res = cellCtrl;
        });
        return res;
    }
    onRowIndexChanged() {
        if (this.rowNode.rowIndex != null) {
            this.onCellFocusChanged();
            this.updateRowIndexes();
            this.postProcessCss();
        }
    }
    updateRowIndexes(gui) {
        const rowIndexStr = this.rowNode.getRowIndexString();
        if (rowIndexStr === null) return;
        const headerRowCount = (this.beans.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0) + (this.beans.filterManager?.getHeaderRowCount() ?? 0);
        const rowIsEven = this.rowNode.rowIndex % 2 === 0;
        const ariaRowIndex = headerRowCount + this.rowNode.rowIndex + 1;
        this.forEachGui(gui, (c)=>{
            c.rowComp.setRowIndex(rowIndexStr);
            c.rowComp.toggleCss("ag-row-even", rowIsEven);
            c.rowComp.toggleCss("ag-row-odd", !rowIsEven);
            $437b23f6a393c3bf$export$ba731dedf9d88615(c.element, ariaRowIndex);
        });
    }
};
// packages/ag-grid-community/src/utils/keyboard.ts
function $437b23f6a393c3bf$export$33ecd6e270298858(event) {
    if (event.altKey || event.ctrlKey || event.metaKey) return false;
    const printableCharacter = event.key?.length === 1;
    return printableCharacter;
}
function $437b23f6a393c3bf$var$_isUserSuppressingKeyboardEvent(gos, keyboardEvent, rowNode, column, editing) {
    const colDefFunc = column ? column.getColDef().suppressKeyboardEvent : void 0;
    if (!colDefFunc) return false;
    const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        event: keyboardEvent,
        editing: editing,
        column: column,
        node: rowNode,
        data: rowNode.data,
        colDef: column.getColDef()
    });
    if (colDefFunc) {
        const colDefFuncResult = colDefFunc(params);
        if (colDefFuncResult) return true;
    }
    return false;
}
// packages/ag-grid-community/src/utils/selection.ts
function $437b23f6a393c3bf$export$57896ee3d2f5a3d(beans) {
    const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = beans;
    const [isEmptyPinnedTop, isEmptyPinnedBottom] = [
        pinnedRowModel?.isEmpty("top") ?? true,
        pinnedRowModel?.isEmpty("bottom") ?? true
    ];
    const floatingStart = isEmptyPinnedTop ? null : "top";
    let floatingEnd;
    let rowEnd;
    if (isEmptyPinnedBottom) {
        floatingEnd = null;
        rowEnd = rowModel.getRowCount() - 1;
    } else {
        floatingEnd = "bottom";
        rowEnd = pinnedRowModel?.getPinnedBottomRowCount() ?? -1;
    }
    const { visibleCols: visibleCols, rangeSvc: rangeSvc } = beans;
    const allDisplayedColumns = visibleCols.allCols;
    if (!rangeSvc || !allDisplayedColumns?.length) return;
    rangeSvc.setCellRange({
        rowStartIndex: 0,
        rowStartPinned: floatingStart,
        rowEndIndex: rowEnd,
        rowEndPinned: floatingEnd
    });
}
// packages/ag-grid-community/src/gridBodyComp/rowContainer/rowContainerEventsFeature.ts
var $437b23f6a393c3bf$var$A_KEYCODE = 65;
var $437b23f6a393c3bf$var$C_KEYCODE = 67;
var $437b23f6a393c3bf$var$V_KEYCODE = 86;
var $437b23f6a393c3bf$var$D_KEYCODE = 68;
var $437b23f6a393c3bf$var$Z_KEYCODE = 90;
var $437b23f6a393c3bf$var$Y_KEYCODE = 89;
function $437b23f6a393c3bf$var$_normaliseQwertyAzerty(keyboardEvent) {
    const { keyCode: keyCode } = keyboardEvent;
    let code;
    switch(keyCode){
        case $437b23f6a393c3bf$var$A_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.A;
            break;
        case $437b23f6a393c3bf$var$C_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.C;
            break;
        case $437b23f6a393c3bf$var$V_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.V;
            break;
        case $437b23f6a393c3bf$var$D_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.D;
            break;
        case $437b23f6a393c3bf$var$Z_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.Z;
            break;
        case $437b23f6a393c3bf$var$Y_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.Y;
            break;
        default:
            code = keyboardEvent.code;
    }
    return code;
}
var $437b23f6a393c3bf$var$RowContainerEventsFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(element){
        super();
        this.element = element;
    }
    postConstruct() {
        this.addKeyboardListeners();
        this.addMouseListeners();
        this.beans.touchSvc?.mockRowContextMenu(this);
        this.editSvc = this.beans.editSvc;
    }
    addKeyboardListeners() {
        const eventName = "keydown";
        const listener = this.processKeyboardEvent.bind(this, eventName);
        this.addManagedElementListeners(this.element, {
            [eventName]: listener
        });
    }
    addMouseListeners() {
        const mouseDownEvent = $437b23f6a393c3bf$var$_isEventSupported("touchstart") ? "touchstart" : "mousedown";
        const eventNames = [
            "dblclick",
            "contextmenu",
            "mouseover",
            "mouseout",
            "click",
            mouseDownEvent
        ];
        eventNames.forEach((eventName)=>{
            const listener = this.processMouseEvent.bind(this, eventName);
            this.addManagedElementListeners(this.element, {
                [eventName]: listener
            });
        });
    }
    processMouseEvent(eventName, mouseEvent) {
        if (!$437b23f6a393c3bf$var$_isEventFromThisGrid(this.gos, mouseEvent) || $437b23f6a393c3bf$export$9a48e23524c6d58(mouseEvent)) return;
        const { cellCtrl: cellCtrl, rowCtrl: rowCtrl } = this.getControlsForEventTarget(mouseEvent.target);
        if (eventName === "contextmenu") {
            if (cellCtrl?.column) cellCtrl.dispatchCellContextMenuEvent(mouseEvent);
            this.beans.contextMenuSvc?.handleContextMenuMouseEvent(mouseEvent, void 0, rowCtrl, cellCtrl);
        } else {
            if (cellCtrl) cellCtrl.onMouseEvent(eventName, mouseEvent);
            if (rowCtrl) rowCtrl.onMouseEvent(eventName, mouseEvent);
        }
    }
    getControlsForEventTarget(target) {
        const { gos: gos } = this;
        return {
            cellCtrl: $437b23f6a393c3bf$export$b5bf61dcea514250(gos, target),
            rowCtrl: $437b23f6a393c3bf$var$_getCtrlForEventTarget(gos, target, $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL)
        };
    }
    processKeyboardEvent(eventName, keyboardEvent) {
        const { cellCtrl: cellCtrl, rowCtrl: rowCtrl } = this.getControlsForEventTarget(keyboardEvent.target);
        if (keyboardEvent.defaultPrevented) return;
        if (cellCtrl) this.processCellKeyboardEvent(cellCtrl, eventName, keyboardEvent);
        else if (rowCtrl?.isFullWidth()) this.processFullWidthRowKeyboardEvent(rowCtrl, eventName, keyboardEvent);
    }
    processCellKeyboardEvent(cellCtrl, eventName, keyboardEvent) {
        const editing = this.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        }) ?? false;
        const gridProcessingAllowed = !$437b23f6a393c3bf$var$_isUserSuppressingKeyboardEvent(this.gos, keyboardEvent, cellCtrl.rowNode, cellCtrl.column, editing);
        if (gridProcessingAllowed) {
            if (eventName === "keydown") {
                const wasScrollKey = !editing && this.beans.navigation?.handlePageScrollingKey(keyboardEvent);
                if (!wasScrollKey) cellCtrl.onKeyDown(keyboardEvent);
                this.doGridOperations(keyboardEvent, editing);
                if ($437b23f6a393c3bf$export$33ecd6e270298858(keyboardEvent)) cellCtrl.processCharacter(keyboardEvent);
            }
        }
        if (eventName === "keydown") this.eventSvc.dispatchEvent(cellCtrl.createEvent(keyboardEvent, "cellKeyDown"));
    }
    processFullWidthRowKeyboardEvent(rowCtrl, eventName, keyboardEvent) {
        const { rowNode: rowNode } = rowCtrl;
        const { focusSvc: focusSvc, navigation: navigation } = this.beans;
        const focusedCell = focusSvc.getFocusedCell();
        const column = focusedCell?.column;
        const gridProcessingAllowed = !$437b23f6a393c3bf$var$_isUserSuppressingKeyboardEvent(this.gos, keyboardEvent, rowNode, column, false);
        if (gridProcessingAllowed) {
            const key = keyboardEvent.key;
            if (eventName === "keydown") switch(key){
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
                    navigation?.handlePageScrollingKey(keyboardEvent, true);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                    if (!this.gos.get("embedFullWidthRows")) break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                    rowCtrl.onKeyboardNavigate(keyboardEvent);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB:
                    rowCtrl.onTabKeyDown(keyboardEvent);
                    break;
                default:
            }
        }
        if (eventName === "keydown") this.eventSvc.dispatchEvent(rowCtrl.createRowEvent("cellKeyDown", keyboardEvent));
    }
    doGridOperations(keyboardEvent, editing) {
        if (!keyboardEvent.ctrlKey && !keyboardEvent.metaKey) return;
        if (editing) return;
        if (!$437b23f6a393c3bf$var$_isEventFromThisGrid(this.gos, keyboardEvent)) return;
        const keyCode = $437b23f6a393c3bf$var$_normaliseQwertyAzerty(keyboardEvent);
        const { clipboardSvc: clipboardSvc, undoRedo: undoRedo } = this.beans;
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.A) return this.onCtrlAndA(keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.C) return this.onCtrlAndC(clipboardSvc, keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.D) return this.onCtrlAndD(clipboardSvc, keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.V) return this.onCtrlAndV(clipboardSvc, keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.X) return this.onCtrlAndX(clipboardSvc, keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.Y) return this.onCtrlAndY(undoRedo);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.Z) return this.onCtrlAndZ(undoRedo, keyboardEvent);
    }
    onCtrlAndA(event) {
        const { beans: { rowModel: rowModel, rangeSvc: rangeSvc, selectionSvc: selectionSvc }, gos: gos } = this;
        if (rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(gos) && rowModel.isRowsToRender()) $437b23f6a393c3bf$export$57896ee3d2f5a3d(this.beans);
        else if (selectionSvc) selectionSvc?.selectAllRowNodes({
            source: "keyboardSelectAll",
            selectAll: $437b23f6a393c3bf$var$_getSelectAll(gos)
        });
        event.preventDefault();
    }
    onCtrlAndC(clipboardSvc, event) {
        if (!clipboardSvc || this.gos.get("enableCellTextSelection")) return;
        const { cellCtrl: cellCtrl } = this.getControlsForEventTarget(event.target);
        if (this.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) return;
        event.preventDefault();
        clipboardSvc.copyToClipboard();
    }
    onCtrlAndX(clipboardSvc, event) {
        if (!clipboardSvc || this.gos.get("enableCellTextSelection") || this.gos.get("suppressCutToClipboard")) return;
        const { cellCtrl: cellCtrl } = this.getControlsForEventTarget(event.target);
        if (this.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) return;
        event.preventDefault();
        clipboardSvc.cutToClipboard(void 0, "ui");
    }
    onCtrlAndV(clipboardSvc, event) {
        const { cellCtrl: cellCtrl } = this.getControlsForEventTarget(event.target);
        if (this.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) return;
        if (clipboardSvc && !this.gos.get("suppressClipboardPaste")) clipboardSvc.pasteFromClipboard();
    }
    onCtrlAndD(clipboardSvc, event) {
        if (clipboardSvc && !this.gos.get("suppressClipboardPaste")) clipboardSvc.copyRangeDown();
        event.preventDefault();
    }
    onCtrlAndZ(undoRedo, event) {
        if (!this.gos.get("undoRedoCellEditing") || !undoRedo) return;
        event.preventDefault();
        if (event.shiftKey) undoRedo.redo("ui");
        else undoRedo.undo("ui");
    }
    onCtrlAndY(undoRedo) {
        undoRedo?.redo("ui");
    }
};
// packages/ag-grid-community/src/gridBodyComp/rowContainer/setHeightFeature.ts
var $437b23f6a393c3bf$var$SetHeightFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eContainer, eViewport){
        super();
        this.eContainer = eContainer;
        this.eViewport = eViewport;
    }
    postConstruct() {
        this.addManagedEventListeners({
            rowContainerHeightChanged: this.onHeightChanged.bind(this, this.beans.rowContainerHeight)
        });
    }
    onHeightChanged(maxDivHeightScaler) {
        const height = maxDivHeightScaler.uiContainerHeight;
        const heightString = height != null ? `${height}px` : ``;
        this.eContainer.style.height = heightString;
        if (this.eViewport) this.eViewport.style.height = heightString;
    }
};
// packages/ag-grid-community/src/gridBodyComp/rowContainer/rowContainerCtrl.ts
var $437b23f6a393c3bf$var$getTopRowCtrls = (r)=>r.topRowCtrls;
var $437b23f6a393c3bf$var$getStickyTopRowCtrls = (r)=>r.getStickyTopRowCtrls();
var $437b23f6a393c3bf$var$getStickyBottomRowCtrls = (r)=>r.getStickyBottomRowCtrls();
var $437b23f6a393c3bf$var$getBottomRowCtrls = (r)=>r.bottomRowCtrls;
var $437b23f6a393c3bf$var$getCentreRowCtrls = (r)=>r.allRowCtrls;
var $437b23f6a393c3bf$var$getSpannedTopRowCtrls = (r)=>r.getCtrls("top");
var $437b23f6a393c3bf$var$getSpannedCenterRowCtrls = (r)=>r.getCtrls("center");
var $437b23f6a393c3bf$var$getSpannedBottomRowCtrls = (r)=>r.getCtrls("bottom");
var $437b23f6a393c3bf$var$ContainerCssClasses = {
    center: {
        type: "center",
        name: "center-cols",
        getRowCtrls: $437b23f6a393c3bf$var$getCentreRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedCenterRowCtrls
    },
    left: {
        type: "left",
        name: "pinned-left-cols",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getCentreRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedCenterRowCtrls
    },
    right: {
        type: "right",
        name: "pinned-right-cols",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getCentreRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedCenterRowCtrls
    },
    fullWidth: {
        type: "fullWidth",
        name: "full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getCentreRowCtrls
    },
    topCenter: {
        type: "center",
        name: "floating-top",
        getRowCtrls: $437b23f6a393c3bf$var$getTopRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedTopRowCtrls
    },
    topLeft: {
        type: "left",
        name: "pinned-left-floating",
        container: "ag-pinned-left-floating-top",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getTopRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedTopRowCtrls
    },
    topRight: {
        type: "right",
        name: "pinned-right-floating",
        container: "ag-pinned-right-floating-top",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getTopRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedTopRowCtrls
    },
    topFullWidth: {
        type: "fullWidth",
        name: "floating-top-full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getTopRowCtrls
    },
    stickyTopCenter: {
        type: "center",
        name: "sticky-top",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyTopRowCtrls
    },
    stickyTopLeft: {
        type: "left",
        name: "pinned-left-sticky-top",
        container: "ag-pinned-left-sticky-top",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyTopRowCtrls
    },
    stickyTopRight: {
        type: "right",
        name: "pinned-right-sticky-top",
        container: "ag-pinned-right-sticky-top",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyTopRowCtrls
    },
    stickyTopFullWidth: {
        type: "fullWidth",
        name: "sticky-top-full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getStickyTopRowCtrls
    },
    stickyBottomCenter: {
        type: "center",
        name: "sticky-bottom",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyBottomRowCtrls
    },
    stickyBottomLeft: {
        type: "left",
        name: "pinned-left-sticky-bottom",
        container: "ag-pinned-left-sticky-bottom",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyBottomRowCtrls
    },
    stickyBottomRight: {
        type: "right",
        name: "pinned-right-sticky-bottom",
        container: "ag-pinned-right-sticky-bottom",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyBottomRowCtrls
    },
    stickyBottomFullWidth: {
        type: "fullWidth",
        name: "sticky-bottom-full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getStickyBottomRowCtrls
    },
    bottomCenter: {
        type: "center",
        name: "floating-bottom",
        getRowCtrls: $437b23f6a393c3bf$var$getBottomRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedBottomRowCtrls
    },
    bottomLeft: {
        type: "left",
        name: "pinned-left-floating-bottom",
        container: "ag-pinned-left-floating-bottom",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getBottomRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedBottomRowCtrls
    },
    bottomRight: {
        type: "right",
        name: "pinned-right-floating-bottom",
        container: "ag-pinned-right-floating-bottom",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getBottomRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedBottomRowCtrls
    },
    bottomFullWidth: {
        type: "fullWidth",
        name: "floating-bottom-full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getBottomRowCtrls
    }
};
function $437b23f6a393c3bf$export$65619730ec980d6a(name) {
    const options = $437b23f6a393c3bf$export$a46aad9f8c79261f(name);
    return `ag-${options.name}-viewport`;
}
function $437b23f6a393c3bf$export$35e1b2dddf7fc6e9(name) {
    const options = $437b23f6a393c3bf$export$a46aad9f8c79261f(name);
    return options.container ?? `ag-${options.name}-container`;
}
function $437b23f6a393c3bf$export$cd6b90bdf6c4fcfd(name) {
    const options = $437b23f6a393c3bf$export$a46aad9f8c79261f(name);
    return `ag-${options.name}-spanned-cells-container`;
}
function $437b23f6a393c3bf$export$a46aad9f8c79261f(name) {
    return $437b23f6a393c3bf$var$ContainerCssClasses[name];
}
var $437b23f6a393c3bf$var$allTopNoFW = [
    "topCenter",
    "topLeft",
    "topRight"
];
var $437b23f6a393c3bf$var$allBottomNoFW = [
    "bottomCenter",
    "bottomLeft",
    "bottomRight"
];
var $437b23f6a393c3bf$var$allMiddleNoFW = [
    "center",
    "left",
    "right"
];
var $437b23f6a393c3bf$var$allMiddle = [
    "center",
    "left",
    "right",
    "fullWidth"
];
var $437b23f6a393c3bf$var$allCenter = [
    "stickyTopCenter",
    "stickyBottomCenter",
    "center",
    "topCenter",
    "bottomCenter"
];
var $437b23f6a393c3bf$var$allLeft = [
    "left",
    "bottomLeft",
    "topLeft",
    "stickyTopLeft",
    "stickyBottomLeft"
];
var $437b23f6a393c3bf$var$allRight = [
    "right",
    "bottomRight",
    "topRight",
    "stickyTopRight",
    "stickyBottomRight"
];
var $437b23f6a393c3bf$var$allStickyTopNoFW = [
    "stickyTopCenter",
    "stickyTopLeft",
    "stickyTopRight"
];
var $437b23f6a393c3bf$var$allStickyBottomNoFW = [
    "stickyBottomCenter",
    "stickyBottomLeft",
    "stickyBottomRight"
];
var $437b23f6a393c3bf$var$allStickyContainers = [
    ...$437b23f6a393c3bf$var$allStickyTopNoFW,
    "stickyTopFullWidth",
    ...$437b23f6a393c3bf$var$allStickyBottomNoFW,
    "stickyBottomFullWidth"
];
var $437b23f6a393c3bf$var$allNoFW = [
    ...$437b23f6a393c3bf$var$allTopNoFW,
    ...$437b23f6a393c3bf$var$allBottomNoFW,
    ...$437b23f6a393c3bf$var$allMiddleNoFW,
    ...$437b23f6a393c3bf$var$allStickyTopNoFW,
    ...$437b23f6a393c3bf$var$allStickyBottomNoFW
];
var $437b23f6a393c3bf$export$2d4385f6f566fe5e = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(name){
        super();
        this.name = name;
        this.visible = true;
        // Maintaining a constant reference enables optimization in React.
        this.EMPTY_CTRLS = [];
        this.options = $437b23f6a393c3bf$export$a46aad9f8c79261f(name);
    }
    postConstruct() {
        this.enableRtl = this.gos.get("enableRtl");
        this.forContainers([
            "center"
        ], ()=>{
            this.viewportSizeFeature = this.createManagedBean(new $437b23f6a393c3bf$var$ViewportSizeFeature(this));
            this.addManagedEventListeners({
                stickyTopOffsetChanged: this.onStickyTopOffsetChanged.bind(this)
            });
        });
    }
    onStickyTopOffsetChanged(event) {
        this.comp.setOffsetTop(`${event.offset}px`);
    }
    registerWithCtrlsService() {
        if (this.options.fullWidth) return;
        this.beans.ctrlsSvc.register(this.name, this);
    }
    forContainers(names, callback) {
        if (names.indexOf(this.name) >= 0) callback();
    }
    setComp(view, eContainer, eSpannedContainer, eViewport) {
        this.comp = view;
        this.eContainer = eContainer;
        this.eSpannedContainer = eSpannedContainer;
        this.eViewport = eViewport;
        this.createManagedBean(new $437b23f6a393c3bf$var$RowContainerEventsFeature(this.eViewport ?? this.eContainer));
        this.addPreventScrollWhileDragging();
        this.listenOnDomOrder();
        const { pinnedCols: pinnedCols, rangeSvc: rangeSvc } = this.beans;
        const pinnedWidthChanged = ()=>this.onPinnedWidthChanged();
        this.forContainers($437b23f6a393c3bf$var$allLeft, ()=>{
            this.pinnedWidthFeature = this.createOptionalManagedBean(pinnedCols?.createPinnedWidthFeature(true, this.eContainer, this.eSpannedContainer));
            this.addManagedEventListeners({
                leftPinnedWidthChanged: pinnedWidthChanged
            });
        });
        this.forContainers($437b23f6a393c3bf$var$allRight, ()=>{
            this.pinnedWidthFeature = this.createOptionalManagedBean(pinnedCols?.createPinnedWidthFeature(false, this.eContainer, this.eSpannedContainer));
            this.addManagedEventListeners({
                rightPinnedWidthChanged: pinnedWidthChanged
            });
        });
        this.forContainers($437b23f6a393c3bf$var$allMiddle, ()=>this.createManagedBean(new $437b23f6a393c3bf$var$SetHeightFeature(this.eContainer, this.name === "center" ? eViewport : void 0)));
        if (rangeSvc) this.forContainers($437b23f6a393c3bf$var$allNoFW, ()=>this.createManagedBean(rangeSvc.createDragListenerFeature(this.eContainer)));
        this.forContainers($437b23f6a393c3bf$var$allCenter, ()=>this.createManagedBean(new $437b23f6a393c3bf$var$CenterWidthFeature((width)=>this.comp.setContainerWidth(`${width}px`))));
        this.visible = this.isContainerVisible();
        this.addListeners();
        this.registerWithCtrlsService();
    }
    onScrollCallback(fn) {
        this.addManagedElementListeners(this.eViewport, {
            scroll: fn
        });
    }
    addListeners() {
        const { spannedRowRenderer: spannedRowRenderer, gos: gos } = this.beans;
        const onDisplayedColumnsChanged = this.onDisplayedColumnsChanged.bind(this);
        this.addManagedEventListeners({
            displayedColumnsChanged: onDisplayedColumnsChanged,
            displayedColumnsWidthChanged: onDisplayedColumnsChanged,
            displayedRowsChanged: (params)=>this.onDisplayedRowsChanged(params.afterScroll)
        });
        onDisplayedColumnsChanged();
        this.onDisplayedRowsChanged();
        if (spannedRowRenderer && this.options.getSpannedRowCtrls && gos.get("enableCellSpan")) this.addManagedListeners(spannedRowRenderer, {
            spannedRowsUpdated: ()=>{
                const spannedCtrls = this.options.getSpannedRowCtrls(spannedRowRenderer);
                if (!spannedCtrls) return;
                this.comp.setSpannedRowCtrls(spannedCtrls, false);
            }
        });
    }
    listenOnDomOrder() {
        const isStickContainer = $437b23f6a393c3bf$var$allStickyContainers.indexOf(this.name) >= 0;
        if (isStickContainer) {
            this.comp.setDomOrder(true);
            return;
        }
        const listener = ()=>{
            const isEnsureDomOrder = this.gos.get("ensureDomOrder");
            const isPrintLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
            this.comp.setDomOrder(isEnsureDomOrder || isPrintLayout);
        };
        this.addManagedPropertyListener("domLayout", listener);
        listener();
    }
    onDisplayedColumnsChanged() {
        this.forContainers([
            "center"
        ], ()=>this.onHorizontalViewportChanged());
    }
    // this methods prevents the grid views from being scrolled while the dragService is being used
    // eg. the view should not scroll up and down while dragging rows using the rowDragComp.
    addPreventScrollWhileDragging() {
        const { dragSvc: dragSvc } = this.beans;
        if (!dragSvc) return;
        const preventScroll = (e)=>{
            if (dragSvc.dragging) {
                if (e.cancelable) e.preventDefault();
            }
        };
        this.eContainer.addEventListener("touchmove", preventScroll, {
            passive: false
        });
        this.addDestroyFunc(()=>this.eContainer.removeEventListener("touchmove", preventScroll));
    }
    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
    // out the virtual columns again. gets called from following locations:
    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
    onHorizontalViewportChanged(afterScroll = false) {
        const scrollWidth = this.getCenterWidth();
        const scrollPosition = this.getCenterViewportScrollLeft();
        this.beans.colViewport.setScrollPosition(scrollWidth, scrollPosition, afterScroll);
    }
    hasHorizontalScrollGap() {
        return this.eContainer.clientWidth - this.eViewport.clientWidth < 0;
    }
    hasVerticalScrollGap() {
        return this.eContainer.clientHeight - this.eViewport.clientHeight < 0;
    }
    getCenterWidth() {
        return $437b23f6a393c3bf$export$cc615e4191ec3e0c(this.eViewport);
    }
    getCenterViewportScrollLeft() {
        return $437b23f6a393c3bf$var$_getScrollLeft(this.eViewport, this.enableRtl);
    }
    registerViewportResizeListener(listener) {
        const unsubscribeFromResize = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, this.eViewport, listener);
        this.addDestroyFunc(()=>unsubscribeFromResize());
    }
    isViewportInTheDOMTree() {
        return $437b23f6a393c3bf$var$_isInDOM(this.eViewport);
    }
    getViewportScrollLeft() {
        return $437b23f6a393c3bf$var$_getScrollLeft(this.eViewport, this.enableRtl);
    }
    isHorizontalScrollShowing() {
        const isAlwaysShowHorizontalScroll = this.gos.get("alwaysShowHorizontalScroll");
        return isAlwaysShowHorizontalScroll || $437b23f6a393c3bf$var$_isHorizontalScrollShowing(this.eViewport);
    }
    setHorizontalScroll(offset) {
        this.comp.setHorizontalScroll(offset);
    }
    getHScrollPosition() {
        const res = {
            left: this.eViewport.scrollLeft,
            right: this.eViewport.scrollLeft + this.eViewport.offsetWidth
        };
        return res;
    }
    setCenterViewportScrollLeft(value) {
        $437b23f6a393c3bf$var$_setScrollLeft(this.eViewport, value, this.enableRtl);
    }
    isContainerVisible() {
        const pinned = this.options.pinnedType != null;
        return !pinned || !!this.pinnedWidthFeature && this.pinnedWidthFeature.getWidth() > 0;
    }
    onPinnedWidthChanged() {
        const visible = this.isContainerVisible();
        if (this.visible != visible) {
            this.visible = visible;
            this.onDisplayedRowsChanged();
        }
    }
    onDisplayedRowsChanged(afterScroll = false) {
        const rows = this.options.getRowCtrls(this.beans.rowRenderer);
        if (!this.visible || rows.length === 0) {
            this.comp.setRowCtrls({
                rowCtrls: this.EMPTY_CTRLS
            });
            return;
        }
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        const embedFullWidthRows = this.gos.get("embedFullWidthRows");
        const embedFW = embedFullWidthRows || printLayout;
        const rowsThisContainer = rows.filter((rowCtrl)=>{
            const fullWidthRow = rowCtrl.isFullWidth();
            const match = this.options.fullWidth ? !embedFW && fullWidthRow : embedFW || !fullWidthRow;
            return match;
        });
        this.comp.setRowCtrls({
            rowCtrls: rowsThisContainer,
            useFlushSync: afterScroll
        });
    }
};
// packages/ag-grid-community/src/gridBodyComp/gridBodyCtrl.ts
var $437b23f6a393c3bf$var$CSS_CLASS_FORCE_VERTICAL_SCROLL = "ag-force-vertical-scroll";
var $437b23f6a393c3bf$var$CSS_CLASS_CELL_SELECTABLE = "ag-selectable";
var $437b23f6a393c3bf$var$CSS_CLASS_COLUMN_MOVING = "ag-column-moving";
var $437b23f6a393c3bf$export$8bebc3145b40d221 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.stickyTopHeight = 0;
        this.stickyBottomHeight = 0;
    }
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
        this.colModel = beans.colModel;
        this.scrollVisibleSvc = beans.scrollVisibleSvc;
        this.pinnedRowModel = beans.pinnedRowModel;
        this.filterManager = beans.filterManager;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
    }
    setComp(comp, eGridBody, eBodyViewport, eTop, eBottom, eStickyTop, eStickyBottom) {
        this.comp = comp;
        this.eGridBody = eGridBody;
        this.eBodyViewport = eBodyViewport;
        this.eTop = eTop;
        this.eBottom = eBottom;
        this.eStickyTop = eStickyTop;
        this.eStickyBottom = eStickyBottom;
        this.eCenterColsViewport = eBodyViewport.querySelector(`.${$437b23f6a393c3bf$export$65619730ec980d6a("center")}`);
        this.eFullWidthContainer = eBodyViewport.querySelector(`.${$437b23f6a393c3bf$export$35e1b2dddf7fc6e9("fullWidth")}`);
        this.eStickyTopFullWidthContainer = eStickyTop.querySelector(`.${$437b23f6a393c3bf$export$35e1b2dddf7fc6e9("stickyTopFullWidth")}`);
        this.eStickyBottomFullWidthContainer = eStickyBottom.querySelector(`.${$437b23f6a393c3bf$export$35e1b2dddf7fc6e9("stickyBottomFullWidth")}`);
        this.setCellTextSelection(this.gos.get("enableCellTextSelection"));
        this.addManagedPropertyListener("enableCellTextSelection", (props)=>this.setCellTextSelection(props.currentValue));
        this.createManagedBean(new $437b23f6a393c3bf$var$LayoutFeature(this.comp));
        this.scrollFeature = this.createManagedBean(new $437b23f6a393c3bf$var$GridBodyScrollFeature(eBodyViewport));
        this.beans.rowDragSvc?.setupRowDrag(eBodyViewport, this);
        this.setupRowAnimationCssClass();
        this.addEventListeners();
        this.addFocusListeners([
            eTop,
            eBodyViewport,
            eBottom,
            eStickyTop,
            eStickyBottom
        ]);
        this.setGridRootRole();
        this.onGridColumnsChanged();
        this.addBodyViewportListener();
        this.setFloatingHeights();
        this.disableBrowserDragging();
        this.addStopEditingWhenGridLosesFocus();
        this.updateScrollingClasses();
        this.filterManager?.setupAdvFilterHeaderComp(eTop);
        this.ctrlsSvc.register("gridBodyCtrl", this);
    }
    addEventListeners() {
        const setFloatingHeights = this.setFloatingHeights.bind(this);
        const setGridRootRole = this.setGridRootRole.bind(this);
        const toggleRowResizeStyle = this.toggleRowResizeStyles.bind(this);
        this.addManagedEventListeners({
            gridColumnsChanged: this.onGridColumnsChanged.bind(this),
            scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this),
            scrollGapChanged: this.updateScrollingClasses.bind(this),
            pinnedRowDataChanged: setFloatingHeights,
            pinnedHeightChanged: setFloatingHeights,
            pinnedRowsChanged: setFloatingHeights,
            headerHeightChanged: this.setStickyTopOffsetTop.bind(this),
            columnRowGroupChanged: setGridRootRole,
            columnPivotChanged: setGridRootRole,
            rowResizeStarted: toggleRowResizeStyle,
            rowResizeEnded: toggleRowResizeStyle
        });
        this.addManagedPropertyListener("treeData", setGridRootRole);
    }
    toggleRowResizeStyles(params) {
        const isResizingRow = params.type === "rowResizeStarted";
        this.eBodyViewport.classList.toggle("ag-prevent-animation", isResizingRow);
    }
    onGridColumnsChanged() {
        const columns = this.beans.colModel.getCols();
        this.comp.setColumnCount(columns.length);
    }
    onScrollVisibilityChanged() {
        const { scrollVisibleSvc: scrollVisibleSvc } = this;
        const visible = scrollVisibleSvc.verticalScrollShowing;
        this.setVerticalScrollPaddingVisible(visible);
        this.setStickyWidth(visible);
        this.setStickyBottomOffsetBottom();
        const scrollbarWidth = visible ? scrollVisibleSvc.getScrollbarWidth() || 0 : 0;
        const pad = $437b23f6a393c3bf$var$_isInvisibleScrollbar() ? 16 : 0;
        const width = `calc(100% + ${scrollbarWidth + pad}px)`;
        $437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, ()=>this.comp.setBodyViewportWidth(width));
        this.updateScrollingClasses();
    }
    setGridRootRole() {
        const { rowGroupColsSvc: rowGroupColsSvc, colModel: colModel } = this;
        let isTreeGrid = this.gos.get("treeData");
        if (!isTreeGrid) {
            const isPivotActive = colModel.isPivotMode();
            const rowGroupColumnLen = !rowGroupColsSvc ? 0 : rowGroupColsSvc.columns.length;
            const columnsNeededForGrouping = isPivotActive ? 2 : 1;
            isTreeGrid = rowGroupColumnLen >= columnsNeededForGrouping;
        }
        this.comp.setGridRootRole(isTreeGrid ? "treegrid" : "grid");
    }
    addFocusListeners(elements) {
        elements.forEach((element)=>{
            this.addManagedElementListeners(element, {
                focusin: (e)=>{
                    const { target: target } = e;
                    const isFocusedElementNested = $437b23f6a393c3bf$var$_isElementChildOfClass(target, "ag-root", element);
                    element.classList.toggle("ag-has-focus", !isFocusedElementNested);
                },
                focusout: (e)=>{
                    const { target: target, relatedTarget: relatedTarget } = e;
                    const gridContainRelatedTarget = element.contains(relatedTarget);
                    const isNestedRelatedTarget = $437b23f6a393c3bf$var$_isElementChildOfClass(relatedTarget, "ag-root", element);
                    const isNestedTarget = $437b23f6a393c3bf$var$_isElementChildOfClass(target, "ag-root", element);
                    if (isNestedTarget) return;
                    if (!gridContainRelatedTarget || isNestedRelatedTarget) element.classList.remove("ag-has-focus");
                }
            });
        });
    }
    // used by ColumnAnimationService
    setColumnMovingCss(moving) {
        this.comp.setColumnMovingCss($437b23f6a393c3bf$var$CSS_CLASS_COLUMN_MOVING, moving);
    }
    setCellTextSelection(selectable = false) {
        this.comp.setCellSelectableCss($437b23f6a393c3bf$var$CSS_CLASS_CELL_SELECTABLE, selectable);
    }
    updateScrollingClasses() {
        const { eGridBody: { classList: classList }, scrollVisibleSvc: scrollVisibleSvc } = this;
        classList.toggle("ag-body-vertical-content-no-gap", !scrollVisibleSvc.verticalScrollGap);
        classList.toggle("ag-body-horizontal-content-no-gap", !scrollVisibleSvc.horizontalScrollGap);
    }
    // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
    // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
    disableBrowserDragging() {
        this.addManagedElementListeners(this.eGridBody, {
            dragstart: (event)=>{
                if (event.target instanceof HTMLImageElement) {
                    event.preventDefault();
                    return false;
                }
            }
        });
    }
    addStopEditingWhenGridLosesFocus() {
        this.beans.editSvc?.addStopEditingWhenGridLosesFocus([
            this.eBodyViewport,
            this.eBottom,
            this.eTop,
            this.eStickyTop,
            this.eStickyBottom
        ]);
    }
    updateRowCount() {
        const headerCount = (this.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0) + (this.filterManager?.getHeaderRowCount() ?? 0);
        const { rowModel: rowModel } = this.beans;
        const rowCount = rowModel.isLastRowIndexKnown() ? rowModel.getRowCount() : -1;
        const total = rowCount === -1 ? -1 : headerCount + rowCount;
        this.comp.setRowCount(total);
    }
    registerBodyViewportResizeListener(listener) {
        this.comp.registerBodyViewportResizeListener(listener);
    }
    setVerticalScrollPaddingVisible(visible) {
        const overflowY = visible ? "scroll" : "hidden";
        this.comp.setPinnedTopBottomOverflowY(overflowY);
    }
    isVerticalScrollShowing() {
        const show = this.gos.get("alwaysShowVerticalScroll");
        const cssClass = show ? $437b23f6a393c3bf$var$CSS_CLASS_FORCE_VERTICAL_SCROLL : null;
        const allowVerticalScroll = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "normal");
        this.comp.setAlwaysVerticalScrollClass(cssClass, show);
        return show || allowVerticalScroll && $437b23f6a393c3bf$var$_isVerticalScrollShowing(this.eBodyViewport);
    }
    setupRowAnimationCssClass() {
        const { rowContainerHeight: rowContainerHeight, environment: environment } = this.beans;
        let initialSizeMeasurementComplete = environment.sizesMeasured;
        const updateAnimationClass = ()=>{
            const animateRows = initialSizeMeasurementComplete && $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos) && !rowContainerHeight.stretching;
            const animateRowsCssClass = animateRows ? "ag-row-animation" : "ag-row-no-animation";
            this.comp.setRowAnimationCssOnBodyViewport(animateRowsCssClass, animateRows);
        };
        updateAnimationClass();
        this.addManagedEventListeners({
            heightScaleChanged: updateAnimationClass
        });
        this.addManagedPropertyListener("animateRows", updateAnimationClass);
        this.addManagedEventListeners({
            gridStylesChanged: ()=>{
                if (!initialSizeMeasurementComplete && environment.sizesMeasured) {
                    initialSizeMeasurementComplete = true;
                    updateAnimationClass();
                }
            }
        });
    }
    addBodyViewportListener() {
        const { eBodyViewport: eBodyViewport, eStickyTop: eStickyTop, eStickyBottom: eStickyBottom, eTop: eTop, eBottom: eBottom, beans: { popupSvc: popupSvc, touchSvc: touchSvc } } = this;
        const listener = this.onBodyViewportContextMenu.bind(this);
        this.addManagedElementListeners(eBodyViewport, {
            contextmenu: listener
        });
        touchSvc?.mockBodyContextMenu(this, listener);
        this.addManagedElementListeners(eBodyViewport, {
            wheel: this.onBodyViewportWheel.bind(this, popupSvc)
        });
        const onStickyWheel = this.onStickyWheel.bind(this);
        for (const container of [
            eStickyTop,
            eStickyBottom,
            eTop,
            eBottom
        ])this.addManagedElementListeners(container, {
            wheel: onStickyWheel
        });
        const onHorizontalWheel = this.onHorizontalWheel.bind(this);
        for (const container of [
            "left",
            "right",
            "topLeft",
            "topRight",
            "bottomLeft",
            "bottomRight"
        ])this.addManagedElementListeners(this.ctrlsSvc.get(container).eContainer, {
            wheel: onHorizontalWheel
        });
        this.addFullWidthContainerWheelListener();
    }
    addFullWidthContainerWheelListener() {
        this.addManagedElementListeners(this.eFullWidthContainer, {
            wheel: (e)=>this.onFullWidthContainerWheel(e)
        });
    }
    onFullWidthContainerWheel(e) {
        const { deltaX: deltaX, deltaY: deltaY, shiftKey: shiftKey } = e;
        const isHorizontalScroll = shiftKey || Math.abs(deltaX) > Math.abs(deltaY);
        if (isHorizontalScroll && $437b23f6a393c3bf$var$_isEventFromThisGrid(this.gos, e)) this.scrollGridBodyToMatchEvent(e);
    }
    onStickyWheel(e) {
        const { deltaY: deltaY } = e;
        const scrolled = this.scrollVertically(deltaY);
        if (scrolled > 0) e.preventDefault();
    }
    onHorizontalWheel(e) {
        const { deltaX: deltaX, deltaY: deltaY, shiftKey: shiftKey } = e;
        const isHorizontalScroll = shiftKey || Math.abs(deltaX) > Math.abs(deltaY);
        if (!isHorizontalScroll) return;
        this.scrollGridBodyToMatchEvent(e);
    }
    scrollGridBodyToMatchEvent(e) {
        const { deltaX: deltaX, deltaY: deltaY } = e;
        e.preventDefault();
        this.eCenterColsViewport.scrollBy({
            left: deltaX || deltaY
        });
    }
    onBodyViewportContextMenu(mouseEvent, touch, touchEvent) {
        if (!mouseEvent && !touchEvent) return;
        if (this.gos.get("preventDefaultOnContextMenu")) {
            const event = mouseEvent || touchEvent;
            event.preventDefault();
        }
        const { target: target } = mouseEvent || touch;
        if (target === this.eBodyViewport || target === this.ctrlsSvc.get("center").eViewport) this.beans.contextMenuSvc?.showContextMenu({
            mouseEvent: mouseEvent,
            touchEvent: touchEvent,
            value: null,
            anchorToElement: this.eGridBody,
            source: "ui"
        });
    }
    onBodyViewportWheel(popupSvc, e) {
        if (!this.gos.get("suppressScrollWhenPopupsAreOpen")) return;
        if (popupSvc?.hasAnchoredPopup()) e.preventDefault();
    }
    // called by rowDragFeature
    scrollVertically(pixels) {
        const oldScrollPosition = this.eBodyViewport.scrollTop;
        this.scrollFeature.setVerticalScrollPosition(oldScrollPosition + pixels);
        return this.eBodyViewport.scrollTop - oldScrollPosition;
    }
    setFloatingHeights() {
        const { pinnedRowModel: pinnedRowModel, beans: { environment: environment } } = this;
        const floatingTopHeight = pinnedRowModel?.getPinnedTopTotalHeight();
        const floatingBottomHeight = pinnedRowModel?.getPinnedBottomTotalHeight();
        const pinnedBorderWidth = environment.getPinnedRowBorderWidth();
        const rowBorderWidth = environment.getRowBorderWidth();
        const additionalHeight = pinnedBorderWidth - rowBorderWidth;
        const normalisedFloatingTopHeight = !floatingTopHeight ? 0 : additionalHeight + floatingTopHeight;
        const normalisedFloatingBottomHeight = !floatingBottomHeight ? 0 : additionalHeight + floatingBottomHeight;
        this.comp.setTopHeight(normalisedFloatingTopHeight);
        this.comp.setBottomHeight(normalisedFloatingBottomHeight);
        this.comp.setTopInvisible(normalisedFloatingTopHeight <= 0);
        this.comp.setBottomInvisible(normalisedFloatingBottomHeight <= 0);
        this.setStickyTopOffsetTop();
        this.setStickyBottomOffsetBottom();
    }
    setStickyTopHeight(height = 0) {
        this.comp.setStickyTopHeight(`${height}px`);
        this.stickyTopHeight = height;
    }
    setStickyBottomHeight(height = 0) {
        this.comp.setStickyBottomHeight(`${height}px`);
        this.stickyBottomHeight = height;
    }
    setStickyWidth(vScrollVisible) {
        if (!vScrollVisible) {
            this.comp.setStickyTopWidth("100%");
            this.comp.setStickyBottomWidth("100%");
        } else {
            const scrollbarWidth = this.scrollVisibleSvc.getScrollbarWidth();
            this.comp.setStickyTopWidth(`calc(100% - ${scrollbarWidth}px)`);
            this.comp.setStickyBottomWidth(`calc(100% - ${scrollbarWidth}px)`);
        }
    }
    setStickyTopOffsetTop() {
        const headerCtrl = this.ctrlsSvc.get("gridHeaderCtrl");
        const headerHeight = headerCtrl.headerHeight + (this.filterManager?.getHeaderHeight() ?? 0);
        const pinnedTopHeight = this.pinnedRowModel?.getPinnedTopTotalHeight() ?? 0;
        let height = 0;
        if (headerHeight > 0) height += headerHeight;
        if (pinnedTopHeight > 0) height += pinnedTopHeight;
        if (height > 0) height += 1;
        this.comp.setStickyTopTop(`${height}px`);
    }
    setStickyBottomOffsetBottom() {
        const { pinnedRowModel: pinnedRowModel, scrollVisibleSvc: scrollVisibleSvc, comp: comp } = this;
        const pinnedBottomHeight = pinnedRowModel?.getPinnedBottomTotalHeight() ?? 0;
        const hScrollShowing = scrollVisibleSvc.horizontalScrollShowing;
        const scrollbarWidth = hScrollShowing ? scrollVisibleSvc.getScrollbarWidth() || 0 : 0;
        const height = pinnedBottomHeight + scrollbarWidth;
        comp.setStickyBottomBottom(`${height}px`);
    }
};
// packages/ag-grid-community/src/gridBodyComp/abstractFakeScrollComp.ts
var $437b23f6a393c3bf$var$AbstractFakeScrollComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(template, direction){
        super();
        this.direction = direction;
        this.eViewport = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.hideTimeout = 0;
        this.setTemplate(template);
    }
    postConstruct() {
        this.addManagedEventListeners({
            scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this)
        });
        this.onScrollVisibilityChanged();
        this.toggleCss("ag-apple-scrollbar", $437b23f6a393c3bf$var$_isMacOsUserAgent() || $437b23f6a393c3bf$export$6b6034a68325bd8a());
    }
    destroy() {
        super.destroy();
        window.clearTimeout(this.hideTimeout);
    }
    initialiseInvisibleScrollbar() {
        if (this.invisibleScrollbar !== void 0) return;
        this.invisibleScrollbar = $437b23f6a393c3bf$var$_isInvisibleScrollbar();
        if (this.invisibleScrollbar) {
            this.hideAndShowInvisibleScrollAsNeeded();
            this.addActiveListenerToggles();
        }
    }
    addActiveListenerToggles() {
        const eGui = this.getGui();
        const onActivate = ()=>this.toggleCss("ag-scrollbar-active", true);
        const onDeactivate = ()=>this.toggleCss("ag-scrollbar-active", false);
        this.addManagedListeners(eGui, {
            mouseenter: onActivate,
            mousedown: onActivate,
            touchstart: onActivate,
            mouseleave: onDeactivate,
            touchend: onDeactivate
        });
    }
    onScrollVisibilityChanged() {
        if (this.invisibleScrollbar === void 0) this.initialiseInvisibleScrollbar();
        $437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, ()=>this.setScrollVisible());
    }
    hideAndShowInvisibleScrollAsNeeded() {
        this.addManagedEventListeners({
            bodyScroll: (params)=>{
                if (params.direction === this.direction) {
                    if (this.hideTimeout) {
                        window.clearTimeout(this.hideTimeout);
                        this.hideTimeout = 0;
                    }
                    this.toggleCss("ag-scrollbar-scrolling", true);
                }
            },
            bodyScrollEnd: ()=>{
                this.hideTimeout = window.setTimeout(()=>{
                    this.toggleCss("ag-scrollbar-scrolling", false);
                    this.hideTimeout = 0;
                }, 400);
            }
        });
    }
    attemptSettingScrollPosition(value) {
        const viewport = this.eViewport;
        $437b23f6a393c3bf$export$b863e7aac7884b8(()=>$437b23f6a393c3bf$export$2badf4aa566524cb(viewport), ()=>this.setScrollPosition(value), 100);
    }
    onScrollCallback(fn) {
        this.addManagedElementListeners(this.eViewport, {
            scroll: fn
        });
    }
};
// packages/ag-grid-community/src/gridBodyComp/fakeHScrollComp.ts
var $437b23f6a393c3bf$var$FakeHScrollElement = {
    tag: "div",
    cls: "ag-body-horizontal-scroll",
    attrs: {
        "aria-hidden": "true"
    },
    children: [
        {
            tag: "div",
            ref: "eLeftSpacer",
            cls: "ag-horizontal-left-spacer"
        },
        {
            tag: "div",
            ref: "eViewport",
            cls: "ag-body-horizontal-scroll-viewport",
            children: [
                {
                    tag: "div",
                    ref: "eContainer",
                    cls: "ag-body-horizontal-scroll-container"
                }
            ]
        },
        {
            tag: "div",
            ref: "eRightSpacer",
            cls: "ag-horizontal-right-spacer"
        }
    ]
};
var $437b23f6a393c3bf$export$8f252e09ef6be2d3 = class extends $437b23f6a393c3bf$var$AbstractFakeScrollComp {
    constructor(){
        super($437b23f6a393c3bf$var$FakeHScrollElement, "horizontal");
        this.eLeftSpacer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eRightSpacer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.setScrollVisibleDebounce = 0;
    }
    wireBeans(beans) {
        this.visibleCols = beans.visibleCols;
        this.scrollVisibleSvc = beans.scrollVisibleSvc;
    }
    postConstruct() {
        super.postConstruct();
        const spacerWidthsListener = this.setFakeHScrollSpacerWidths.bind(this);
        this.addManagedEventListeners({
            displayedColumnsChanged: spacerWidthsListener,
            displayedColumnsWidthChanged: spacerWidthsListener,
            pinnedRowDataChanged: this.refreshCompBottom.bind(this)
        });
        this.addManagedPropertyListener("domLayout", spacerWidthsListener);
        this.beans.ctrlsSvc.register("fakeHScrollComp", this);
        this.createManagedBean(new $437b23f6a393c3bf$var$CenterWidthFeature((width)=>this.eContainer.style.width = `${width}px`));
        this.addManagedPropertyListeners([
            "suppressHorizontalScroll"
        ], this.onScrollVisibilityChanged.bind(this));
    }
    destroy() {
        window.clearTimeout(this.setScrollVisibleDebounce);
        super.destroy();
    }
    initialiseInvisibleScrollbar() {
        if (this.invisibleScrollbar !== void 0) return;
        this.enableRtl = this.gos.get("enableRtl");
        super.initialiseInvisibleScrollbar();
        if (this.invisibleScrollbar) this.refreshCompBottom();
    }
    refreshCompBottom() {
        if (!this.invisibleScrollbar) return;
        const bottomPinnedHeight = this.beans.pinnedRowModel?.getPinnedBottomTotalHeight() ?? 0;
        this.getGui().style.bottom = `${bottomPinnedHeight}px`;
    }
    onScrollVisibilityChanged() {
        super.onScrollVisibilityChanged();
        this.setFakeHScrollSpacerWidths();
    }
    setFakeHScrollSpacerWidths() {
        const vScrollShowing = this.scrollVisibleSvc.verticalScrollShowing;
        let rightSpacing = this.visibleCols.getDisplayedColumnsRightWidth();
        const scrollOnRight = !this.enableRtl && vScrollShowing;
        const scrollbarWidth = this.scrollVisibleSvc.getScrollbarWidth();
        if (scrollOnRight) rightSpacing += scrollbarWidth;
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.eRightSpacer, rightSpacing);
        this.eRightSpacer.classList.toggle("ag-scroller-corner", rightSpacing <= scrollbarWidth);
        let leftSpacing = this.visibleCols.getColsLeftWidth();
        const scrollOnLeft = this.enableRtl && vScrollShowing;
        if (scrollOnLeft) leftSpacing += scrollbarWidth;
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.eLeftSpacer, leftSpacing);
        this.eLeftSpacer.classList.toggle("ag-scroller-corner", leftSpacing <= scrollbarWidth);
    }
    setScrollVisible() {
        const hScrollShowing = this.scrollVisibleSvc.horizontalScrollShowing;
        const invisibleScrollbar2 = this.invisibleScrollbar;
        const isSuppressHorizontalScroll = this.gos.get("suppressHorizontalScroll");
        const scrollbarWidth = hScrollShowing ? this.scrollVisibleSvc.getScrollbarWidth() || 0 : 0;
        const adjustedScrollbarWidth = scrollbarWidth === 0 && invisibleScrollbar2 ? 16 : scrollbarWidth;
        const scrollContainerSize = !isSuppressHorizontalScroll ? adjustedScrollbarWidth : 0;
        const apply = ()=>{
            this.setScrollVisibleDebounce = 0;
            this.toggleCss("ag-scrollbar-invisible", invisibleScrollbar2);
            $437b23f6a393c3bf$var$_setFixedHeight(this.getGui(), scrollContainerSize);
            $437b23f6a393c3bf$var$_setFixedHeight(this.eViewport, scrollContainerSize);
            $437b23f6a393c3bf$var$_setFixedHeight(this.eContainer, scrollContainerSize);
            if (!scrollContainerSize) this.eContainer.style.setProperty("min-height", "1px");
            this.setVisible(hScrollShowing, {
                skipAriaHidden: true
            });
        };
        window.clearTimeout(this.setScrollVisibleDebounce);
        if (!hScrollShowing) apply();
        else this.setScrollVisibleDebounce = window.setTimeout(apply, 100);
    }
    getScrollPosition() {
        return $437b23f6a393c3bf$var$_getScrollLeft(this.eViewport, this.enableRtl);
    }
    setScrollPosition(value) {
        if (!$437b23f6a393c3bf$export$2badf4aa566524cb(this.eViewport)) this.attemptSettingScrollPosition(value);
        $437b23f6a393c3bf$var$_setScrollLeft(this.eViewport, value, this.enableRtl);
    }
};
var $437b23f6a393c3bf$var$FakeHScrollSelector = {
    selector: "AG-FAKE-HORIZONTAL-SCROLL",
    component: $437b23f6a393c3bf$export$8f252e09ef6be2d3
};
// packages/ag-grid-community/src/gridBodyComp/fakeVScrollComp.ts
var $437b23f6a393c3bf$var$FakeVScrollElement = {
    tag: "div",
    cls: "ag-body-vertical-scroll",
    attrs: {
        "aria-hidden": "true"
    },
    children: [
        {
            tag: "div",
            ref: "eViewport",
            cls: "ag-body-vertical-scroll-viewport",
            children: [
                {
                    tag: "div",
                    ref: "eContainer",
                    cls: "ag-body-vertical-scroll-container"
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$export$f496fc30dbebdfa3 = class extends $437b23f6a393c3bf$var$AbstractFakeScrollComp {
    constructor(){
        super($437b23f6a393c3bf$var$FakeVScrollElement, "vertical");
    }
    postConstruct() {
        super.postConstruct();
        this.createManagedBean(new $437b23f6a393c3bf$var$SetHeightFeature(this.eContainer));
        const { ctrlsSvc: ctrlsSvc } = this.beans;
        ctrlsSvc.register("fakeVScrollComp", this);
        this.addManagedEventListeners({
            rowContainerHeightChanged: this.onRowContainerHeightChanged.bind(this, ctrlsSvc)
        });
    }
    setScrollVisible() {
        const { scrollVisibleSvc: scrollVisibleSvc } = this.beans;
        const vScrollShowing = scrollVisibleSvc.verticalScrollShowing;
        const invisibleScrollbar2 = this.invisibleScrollbar;
        const scrollbarWidth = vScrollShowing ? scrollVisibleSvc.getScrollbarWidth() || 0 : 0;
        const adjustedScrollbarWidth = scrollbarWidth === 0 && invisibleScrollbar2 ? 16 : scrollbarWidth;
        this.toggleCss("ag-scrollbar-invisible", invisibleScrollbar2);
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.getGui(), adjustedScrollbarWidth);
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.eViewport, adjustedScrollbarWidth);
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.eContainer, adjustedScrollbarWidth);
        this.setDisplayed(vScrollShowing, {
            skipAriaHidden: true
        });
    }
    onRowContainerHeightChanged(ctrlsSvc) {
        const gridBodyCtrl = ctrlsSvc.getGridBodyCtrl();
        const gridBodyViewportEl = gridBodyCtrl.eBodyViewport;
        const eViewportScrollTop = this.getScrollPosition();
        const gridBodyViewportScrollTop = gridBodyViewportEl.scrollTop;
        if (eViewportScrollTop != gridBodyViewportScrollTop) this.setScrollPosition(gridBodyViewportScrollTop, true);
    }
    getScrollPosition() {
        return this.eViewport.scrollTop;
    }
    setScrollPosition(value, force) {
        if (!force && !$437b23f6a393c3bf$export$2badf4aa566524cb(this.eViewport)) this.attemptSettingScrollPosition(value);
        this.eViewport.scrollTop = value;
    }
};
var $437b23f6a393c3bf$var$FakeVScrollSelector = {
    selector: "AG-FAKE-VERTICAL-SCROLL",
    component: $437b23f6a393c3bf$export$f496fc30dbebdfa3
};
// packages/ag-grid-community/src/headerRendering/headerUtils.ts
function $437b23f6a393c3bf$export$4861f2356b3fc2d7(colModel) {
    if (!colModel.cols) return -1;
    return colModel.cols.treeDepth + 1;
}
function $437b23f6a393c3bf$var$getFocusHeaderRowCount(beans) {
    return beans.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0;
}
function $437b23f6a393c3bf$var$getGroupRowsHeight(beans) {
    const heights = [];
    const headerRowContainerCtrls = beans.ctrlsSvc.getHeaderRowContainerCtrls();
    for (const headerRowContainerCtrl of headerRowContainerCtrls){
        if (!headerRowContainerCtrl) continue;
        const groupRowCount = headerRowContainerCtrl.getGroupRowCount() || 0;
        for(let i = 0; i < groupRowCount; i++){
            const headerRowCtrl = headerRowContainerCtrl.getGroupRowCtrlAtIndex(i);
            const currentHeightAtPos = heights[i];
            if (headerRowCtrl) {
                const newHeight = $437b23f6a393c3bf$var$getColumnGroupHeaderRowHeight(beans, headerRowCtrl);
                if (currentHeightAtPos == null || newHeight > currentHeightAtPos) heights[i] = newHeight;
            }
        }
    }
    return heights;
}
function $437b23f6a393c3bf$var$getColumnGroupHeaderRowHeight(beans, headerRowCtrl) {
    const defaultHeight = beans.colModel.isPivotMode() ? $437b23f6a393c3bf$var$getPivotGroupHeaderHeight(beans) : $437b23f6a393c3bf$var$getGroupHeaderHeight(beans);
    let maxDisplayedHeight = defaultHeight;
    const headerRowCellCtrls = headerRowCtrl.getHeaderCellCtrls();
    for (const headerCellCtrl of headerRowCellCtrls){
        const { column: column } = headerCellCtrl;
        const height = column.getAutoHeaderHeight();
        if (height != null && height > maxDisplayedHeight && column.isAutoHeaderHeight()) maxDisplayedHeight = height;
    }
    return maxDisplayedHeight;
}
function $437b23f6a393c3bf$var$getColumnHeaderRowHeight(beans) {
    const defaultHeight = beans.colModel.isPivotMode() ? $437b23f6a393c3bf$var$getPivotHeaderHeight(beans) : $437b23f6a393c3bf$var$getHeaderHeight(beans);
    let maxDisplayedHeight = defaultHeight;
    beans.colModel.forAllCols((col)=>{
        const height = col.getAutoHeaderHeight();
        if (height != null && height > maxDisplayedHeight && col.isAutoHeaderHeight()) maxDisplayedHeight = height;
    });
    return maxDisplayedHeight;
}
function $437b23f6a393c3bf$var$getHeaderHeight(beans) {
    return beans.gos.get("headerHeight") ?? beans.environment.getDefaultHeaderHeight();
}
function $437b23f6a393c3bf$export$b52d5533bf5be44(beans) {
    return beans.gos.get("floatingFiltersHeight") ?? $437b23f6a393c3bf$var$getHeaderHeight(beans);
}
function $437b23f6a393c3bf$var$getGroupHeaderHeight(beans) {
    return beans.gos.get("groupHeaderHeight") ?? $437b23f6a393c3bf$var$getHeaderHeight(beans);
}
function $437b23f6a393c3bf$var$getPivotHeaderHeight(beans) {
    return beans.gos.get("pivotHeaderHeight") ?? $437b23f6a393c3bf$var$getHeaderHeight(beans);
}
function $437b23f6a393c3bf$var$getPivotGroupHeaderHeight(beans) {
    return beans.gos.get("pivotGroupHeaderHeight") ?? $437b23f6a393c3bf$var$getGroupHeaderHeight(beans);
}
// packages/ag-grid-community/src/headerRendering/gridHeaderCtrl.ts
var $437b23f6a393c3bf$export$20b300eb69ca4d09 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    setComp(comp, eGui, eFocusableElement) {
        this.comp = comp;
        this.eGui = eGui;
        const { beans: beans } = this;
        const { headerNavigation: headerNavigation, touchSvc: touchSvc, ctrlsSvc: ctrlsSvc } = beans;
        if (headerNavigation) this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(eFocusableElement, {
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusOut: this.onFocusOut.bind(this)
        }));
        this.addManagedEventListeners({
            columnPivotModeChanged: this.onPivotModeChanged.bind(this, beans),
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this, beans)
        });
        this.onPivotModeChanged(beans);
        this.setupHeaderHeight();
        const listener = this.onHeaderContextMenu.bind(this);
        this.addManagedElementListeners(this.eGui, {
            contextmenu: listener
        });
        touchSvc?.mockHeaderContextMenu(this, listener);
        ctrlsSvc.register("gridHeaderCtrl", this);
    }
    setupHeaderHeight() {
        const listener = this.setHeaderHeight.bind(this);
        listener();
        this.addManagedPropertyListeners([
            "headerHeight",
            "pivotHeaderHeight",
            "groupHeaderHeight",
            "pivotGroupHeaderHeight",
            "floatingFiltersHeight"
        ], listener);
        this.addManagedEventListeners({
            headerRowsChanged: listener,
            columnHeaderHeightChanged: listener,
            // add this to the animation frame to avoid a feedback loop
            columnGroupHeaderHeightChanged: ()=>$437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, ()=>listener()),
            gridStylesChanged: listener,
            advancedFilterEnabledChanged: listener
        });
    }
    setHeaderHeight() {
        const { beans: beans } = this;
        let totalHeaderHeight = 0;
        const groupHeight = $437b23f6a393c3bf$var$getGroupRowsHeight(beans).reduce((prev, curr)=>prev + curr, 0);
        const headerHeight = $437b23f6a393c3bf$var$getColumnHeaderRowHeight(beans);
        if (beans.filterManager?.hasFloatingFilters()) totalHeaderHeight += $437b23f6a393c3bf$export$b52d5533bf5be44(beans);
        totalHeaderHeight += groupHeight;
        totalHeaderHeight += headerHeight;
        if (this.headerHeight === totalHeaderHeight) return;
        this.headerHeight = totalHeaderHeight;
        const px = `${totalHeaderHeight + 1}px`;
        this.comp.setHeightAndMinHeight(px);
        this.eventSvc.dispatchEvent({
            type: "headerHeightChanged"
        });
    }
    onPivotModeChanged(beans) {
        const pivotMode = beans.colModel.isPivotMode();
        this.comp.toggleCss("ag-pivot-on", pivotMode);
        this.comp.toggleCss("ag-pivot-off", !pivotMode);
    }
    onDisplayedColumnsChanged(beans) {
        const columns = beans.visibleCols.allCols;
        const shouldAllowOverflow = columns.some((col)=>col.isSpanHeaderHeight());
        this.comp.toggleCss("ag-header-allow-overflow", shouldAllowOverflow);
    }
    onTabKeyDown(e) {
        const isRtl = this.gos.get("enableRtl");
        const backwards = e.shiftKey;
        const direction = backwards !== isRtl ? "LEFT" : "RIGHT";
        const { beans: beans } = this;
        const { headerNavigation: headerNavigation, focusSvc: focusSvc } = beans;
        if (headerNavigation.navigateHorizontally(direction, true, e) || !backwards && focusSvc.focusOverlay(false) || $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, backwards, true)) e.preventDefault();
    }
    handleKeyDown(e) {
        let direction = null;
        const { headerNavigation: headerNavigation } = this.beans;
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                direction = "LEFT";
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(direction)) direction = "RIGHT";
                if (headerNavigation.navigateHorizontally(direction, false, e)) e.preventDefault();
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                direction = "UP";
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(direction)) direction = "DOWN";
                if (headerNavigation.navigateVertically(direction, e)) e.preventDefault();
                break;
            default:
                return;
        }
    }
    onFocusOut(e) {
        const { relatedTarget: relatedTarget } = e;
        const { eGui: eGui, beans: beans } = this;
        if (!relatedTarget && eGui.contains($437b23f6a393c3bf$export$16bc98d422315038(beans))) return;
        if (!eGui.contains(relatedTarget)) beans.focusSvc.focusedHeader = null;
    }
    onHeaderContextMenu(mouseEvent, touch, touchEvent) {
        const { menuSvc: menuSvc, ctrlsSvc: ctrlsSvc } = this.beans;
        if (!mouseEvent && !touchEvent || !menuSvc?.isHeaderContextMenuEnabled()) return;
        const { target: target } = mouseEvent ?? touch;
        if (target === this.eGui || target === ctrlsSvc.getHeaderRowContainerCtrl()?.eViewport) menuSvc.showHeaderContextMenu(void 0, mouseEvent, touchEvent);
    }
};
// packages/ag-grid-community/src/headerRendering/cells/abstractCell/abstractHeaderCellComp.ts
var $437b23f6a393c3bf$var$AbstractHeaderCellComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(template, ctrl){
        super(template);
        this.ctrl = ctrl;
    }
    getCtrl() {
        return this.ctrl;
    }
};
// packages/ag-grid-community/src/headerRendering/cells/column/headerCellComp.ts
var $437b23f6a393c3bf$var$HeaderCellElement = {
    tag: "div",
    cls: "ag-header-cell",
    role: "columnheader",
    children: [
        {
            tag: "div",
            ref: "eResize",
            cls: "ag-header-cell-resize",
            role: "presentation"
        },
        {
            tag: "div",
            ref: "eHeaderCompWrapper",
            cls: "ag-header-cell-comp-wrapper",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderCellComp = class extends $437b23f6a393c3bf$var$AbstractHeaderCellComp {
    constructor(ctrl){
        super($437b23f6a393c3bf$var$HeaderCellElement, ctrl);
        this.eResize = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eHeaderCompWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.headerCompVersion = 0;
    }
    postConstruct() {
        const eGui = this.getGui();
        const setAttribute = (name, value)=>{
            if (value != null && value != "") eGui.setAttribute(name, value);
            else eGui.removeAttribute(name);
        };
        const refreshSelectAllGui = ()=>{
            const selectAllGui = this.ctrl.getSelectAllGui();
            if (selectAllGui) {
                this.eResize.insertAdjacentElement("afterend", selectAllGui);
                this.addDestroyFunc(()=>selectAllGui.remove());
            }
        };
        setAttribute("col-id", this.ctrl.column.getColId());
        const compProxy = {
            setWidth: (width)=>eGui.style.width = width,
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(eGui, styles),
            setAriaSort: (sort)=>sort ? $437b23f6a393c3bf$export$c8dd030b968c6fd2(eGui, sort) : $437b23f6a393c3bf$export$26c7aa61eda05134(eGui),
            setUserCompDetails: (compDetails)=>this.setUserCompDetails(compDetails),
            getUserCompInstance: ()=>this.headerComp,
            refreshSelectAllGui: refreshSelectAllGui,
            removeSelectAllGui: ()=>this.ctrl.getSelectAllGui()?.remove()
        };
        this.ctrl.setComp(compProxy, this.getGui(), this.eResize, this.eHeaderCompWrapper, void 0);
        refreshSelectAllGui();
    }
    destroy() {
        this.destroyHeaderComp();
        super.destroy();
    }
    destroyHeaderComp() {
        if (this.headerComp) {
            this.eHeaderCompWrapper.removeChild(this.headerCompGui);
            this.headerComp = this.destroyBean(this.headerComp);
            this.headerCompGui = void 0;
        }
    }
    setUserCompDetails(compDetails) {
        this.headerCompVersion++;
        const versionCopy = this.headerCompVersion;
        compDetails.newAgStackInstance().then((comp)=>this.afterCompCreated(versionCopy, comp));
    }
    afterCompCreated(version, headerComp) {
        if (version != this.headerCompVersion || !this.isAlive()) {
            this.destroyBean(headerComp);
            return;
        }
        this.destroyHeaderComp();
        this.headerComp = headerComp;
        this.headerCompGui = headerComp.getGui();
        this.eHeaderCompWrapper.appendChild(this.headerCompGui);
        this.ctrl.setDragSource(this.getGui());
    }
};
// packages/ag-grid-community/src/headerRendering/cells/columnGroup/headerGroupCellComp.ts
var $437b23f6a393c3bf$var$HeaderGroupCellCompElement = {
    tag: "div",
    cls: "ag-header-group-cell",
    role: "columnheader",
    children: [
        {
            tag: "div",
            ref: "eHeaderCompWrapper",
            cls: "ag-header-cell-comp-wrapper",
            role: "presentation"
        },
        {
            tag: "div",
            ref: "eResize",
            cls: "ag-header-cell-resize",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderGroupCellComp = class extends $437b23f6a393c3bf$var$AbstractHeaderCellComp {
    constructor(ctrl){
        super($437b23f6a393c3bf$var$HeaderGroupCellCompElement, ctrl);
        this.eResize = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eHeaderCompWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        const eGui = this.getGui();
        const setAttribute = (key, value)=>value != void 0 ? eGui.setAttribute(key, value) : eGui.removeAttribute(key);
        eGui.setAttribute("col-id", this.ctrl.column.getUniqueId());
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(eGui, styles),
            setHeaderWrapperHidden: (hidden)=>{
                if (hidden) this.eHeaderCompWrapper.style.setProperty("display", "none");
                else this.eHeaderCompWrapper.style.removeProperty("display");
            },
            setHeaderWrapperMaxHeight: (value)=>{
                if (value != null) this.eHeaderCompWrapper.style.setProperty("max-height", `${value}px`);
                else this.eHeaderCompWrapper.style.removeProperty("max-height");
                this.eHeaderCompWrapper.classList.toggle("ag-header-cell-comp-wrapper-limited-height", value != null);
            },
            setResizableDisplayed: (displayed)=>$437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eResize, displayed),
            setWidth: (width)=>eGui.style.width = width,
            setAriaExpanded: (expanded)=>setAttribute("aria-expanded", expanded),
            setUserCompDetails: (details)=>this.setUserCompDetails(details),
            getUserCompInstance: ()=>this.headerGroupComp
        };
        this.ctrl.setComp(compProxy, eGui, this.eResize, this.eHeaderCompWrapper, void 0);
    }
    setUserCompDetails(details) {
        details.newAgStackInstance().then((comp)=>this.afterHeaderCompCreated(comp));
    }
    afterHeaderCompCreated(headerGroupComp) {
        const destroyFunc = ()=>this.destroyBean(headerGroupComp);
        if (!this.isAlive()) {
            destroyFunc();
            return;
        }
        const eGui = this.getGui();
        const eHeaderGroupGui = headerGroupComp.getGui();
        this.eHeaderCompWrapper.appendChild(eHeaderGroupGui);
        this.addDestroyFunc(destroyFunc);
        this.headerGroupComp = headerGroupComp;
        this.ctrl.setDragSource(eGui);
    }
};
// packages/ag-grid-community/src/headerRendering/cells/floatingFilter/headerFilterCellComp.ts
var $437b23f6a393c3bf$var$HeaderFilterCellCompElement = {
    tag: "div",
    cls: "ag-header-cell ag-floating-filter",
    role: "gridcell",
    children: [
        {
            tag: "div",
            ref: "eFloatingFilterBody",
            role: "presentation"
        },
        {
            tag: "div",
            ref: "eButtonWrapper",
            cls: "ag-floating-filter-button ag-hidden",
            role: "presentation",
            children: [
                {
                    tag: "button",
                    ref: "eButtonShowMainFilter",
                    cls: "ag-button ag-floating-filter-button-button",
                    attrs: {
                        type: "button",
                        tabindex: "-1"
                    }
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderFilterCellComp = class extends $437b23f6a393c3bf$var$AbstractHeaderCellComp {
    constructor(ctrl){
        super($437b23f6a393c3bf$var$HeaderFilterCellCompElement, ctrl);
        this.eFloatingFilterBody = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eButtonWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eButtonShowMainFilter = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        const eGui = this.getGui();
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(eGui, styles),
            addOrRemoveBodyCssClass: (cssClassName, on)=>this.eFloatingFilterBody.classList.toggle(cssClassName, on),
            setButtonWrapperDisplayed: (displayed)=>$437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eButtonWrapper, displayed),
            setCompDetails: (compDetails)=>this.setCompDetails(compDetails),
            getFloatingFilterComp: ()=>this.compPromise,
            setWidth: (width)=>eGui.style.width = width,
            setMenuIcon: (eIcon)=>this.eButtonShowMainFilter.appendChild(eIcon)
        };
        this.ctrl.setComp(compProxy, eGui, this.eButtonShowMainFilter, this.eFloatingFilterBody, void 0);
    }
    setCompDetails(compDetails) {
        if (!compDetails) {
            this.destroyFloatingFilterComp();
            this.compPromise = null;
            return;
        }
        this.compPromise = compDetails.newAgStackInstance();
        this.compPromise.then((comp)=>this.afterCompCreated(comp));
    }
    destroy() {
        this.destroyFloatingFilterComp();
        super.destroy();
    }
    destroyFloatingFilterComp() {
        if (this.floatingFilterComp) {
            this.eFloatingFilterBody.removeChild(this.floatingFilterComp.getGui());
            this.floatingFilterComp = this.destroyBean(this.floatingFilterComp);
        }
    }
    afterCompCreated(comp) {
        if (!comp) return;
        if (!this.isAlive()) {
            this.destroyBean(comp);
            return;
        }
        this.destroyFloatingFilterComp();
        this.floatingFilterComp = comp;
        this.eFloatingFilterBody.appendChild(comp.getGui());
        if (comp.afterGuiAttached) comp.afterGuiAttached();
    }
};
// packages/ag-grid-community/src/headerRendering/row/headerRowComp.ts
var $437b23f6a393c3bf$var$HeaderRowComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(ctrl){
        super({
            tag: "div",
            cls: ctrl.headerRowClass,
            role: "row"
        });
        this.ctrl = ctrl;
        this.headerComps = {};
    }
    postConstruct() {
        $437b23f6a393c3bf$export$ba731dedf9d88615(this.getGui(), this.ctrl.getAriaRowIndex());
        const compProxy = {
            setHeight: (height)=>this.getGui().style.height = height,
            setTop: (top)=>this.getGui().style.top = top,
            setHeaderCtrls: (ctrls, forceOrder)=>this.setHeaderCtrls(ctrls, forceOrder),
            setWidth: (width)=>this.getGui().style.width = width,
            setRowIndex: (rowIndex)=>$437b23f6a393c3bf$export$ba731dedf9d88615(this.getGui(), rowIndex)
        };
        this.ctrl.setComp(compProxy, void 0);
    }
    destroy() {
        this.setHeaderCtrls([], false);
        super.destroy();
    }
    setHeaderCtrls(ctrls, forceOrder) {
        if (!this.isAlive()) return;
        const oldComps = this.headerComps;
        this.headerComps = {};
        ctrls.forEach((ctrl)=>{
            const id = ctrl.instanceId;
            let comp = oldComps[id];
            delete oldComps[id];
            if (comp == null) {
                comp = this.createHeaderComp(ctrl);
                this.getGui().appendChild(comp.getGui());
            }
            this.headerComps[id] = comp;
        });
        Object.values(oldComps).forEach((comp)=>{
            this.getGui().removeChild(comp.getGui());
            this.destroyBean(comp);
        });
        if (forceOrder) {
            const comps = Object.values(this.headerComps);
            comps.sort((a, b)=>{
                const leftA = a.getCtrl().column.getLeft();
                const leftB = b.getCtrl().column.getLeft();
                return leftA - leftB;
            });
            const elementsInOrder = comps.map((c)=>c.getGui());
            $437b23f6a393c3bf$var$_setDomChildOrder(this.getGui(), elementsInOrder);
        }
    }
    createHeaderComp(headerCtrl) {
        let result;
        switch(this.ctrl.type){
            case "group":
                result = new $437b23f6a393c3bf$var$HeaderGroupCellComp(headerCtrl);
                break;
            case "filter":
                result = new $437b23f6a393c3bf$var$HeaderFilterCellComp(headerCtrl);
                break;
            default:
                result = new $437b23f6a393c3bf$var$HeaderCellComp(headerCtrl);
                break;
        }
        this.createBean(result);
        result.setParentComponent(this);
        return result;
    }
};
// packages/ag-grid-community/src/rendering/features/setLeftFeature.ts
var $437b23f6a393c3bf$var$SetLeftFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(columnOrGroup, eCell, beans, colsSpanning){
        super();
        this.columnOrGroup = columnOrGroup;
        this.eCell = eCell;
        this.colsSpanning = colsSpanning;
        this.columnOrGroup = columnOrGroup;
        this.ariaEl = eCell.querySelector("[role=columnheader]") || eCell;
        this.beans = beans;
    }
    setColsSpanning(colsSpanning) {
        this.colsSpanning = colsSpanning;
        this.onLeftChanged();
    }
    getColumnOrGroup() {
        const { beans: beans, colsSpanning: colsSpanning } = this;
        if (beans.gos.get("enableRtl") && colsSpanning) return $437b23f6a393c3bf$export$236389741107357f(colsSpanning);
        return this.columnOrGroup;
    }
    postConstruct() {
        const onLeftChanged = this.onLeftChanged.bind(this);
        this.addManagedListeners(this.columnOrGroup, {
            leftChanged: onLeftChanged
        });
        this.setLeftFirstTime();
        this.addManagedEventListeners({
            displayedColumnsWidthChanged: onLeftChanged
        });
        this.addManagedPropertyListener("domLayout", onLeftChanged);
    }
    setLeftFirstTime() {
        const { gos: gos, colAnimation: colAnimation } = this.beans;
        const suppressMoveAnimation = gos.get("suppressColumnMoveAnimation");
        const oldLeftExists = $437b23f6a393c3bf$export$25d27f17d3af40f7(this.columnOrGroup.getOldLeft());
        const animateColumnMove = colAnimation?.isActive() && oldLeftExists && !suppressMoveAnimation;
        if (animateColumnMove) this.animateInLeft();
        else this.onLeftChanged();
    }
    animateInLeft() {
        const colOrGroup = this.getColumnOrGroup();
        const oldActualLeft = this.modifyLeftForPrintLayout(colOrGroup, colOrGroup.getOldLeft());
        const actualLeft = this.modifyLeftForPrintLayout(colOrGroup, colOrGroup.getLeft());
        this.setLeft(oldActualLeft);
        this.actualLeft = actualLeft;
        this.beans.colAnimation.executeNextVMTurn(()=>{
            if (this.actualLeft === actualLeft) this.setLeft(actualLeft);
        });
    }
    onLeftChanged() {
        const colOrGroup = this.getColumnOrGroup();
        const left = colOrGroup.getLeft();
        this.actualLeft = this.modifyLeftForPrintLayout(colOrGroup, left);
        this.setLeft(this.actualLeft);
    }
    modifyLeftForPrintLayout(colOrGroup, leftPosition) {
        const { gos: gos, visibleCols: visibleCols } = this.beans;
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print");
        if (!printLayout) return leftPosition;
        if (colOrGroup.getPinned() === "left") return leftPosition;
        const leftWidth = visibleCols.getColsLeftWidth();
        if (colOrGroup.getPinned() === "right") {
            const bodyWidth = visibleCols.bodyWidth;
            return leftWidth + bodyWidth + leftPosition;
        }
        return leftWidth + leftPosition;
    }
    setLeft(value) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(value)) this.eCell.style.left = `${value}px`;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(this.columnOrGroup)) {
            const children = this.columnOrGroup.getLeafColumns();
            if (!children.length) return;
            if (children.length > 1) $437b23f6a393c3bf$export$371d80f0281454ce(this.ariaEl, children.length);
        }
    }
};
// packages/ag-grid-community/src/headerRendering/cells/abstractCell/abstractHeaderCellCtrl.ts
var $437b23f6a393c3bf$var$instanceIdSequence4 = 0;
var $437b23f6a393c3bf$var$DOM_DATA_KEY_HEADER_CTRL = "headerCtrl";
var $437b23f6a393c3bf$var$AbstractHeaderCellCtrl = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column, rowCtrl){
        super();
        this.column = column;
        this.rowCtrl = rowCtrl;
        this.resizeToggleTimeout = 0;
        this.resizeMultiplier = 1;
        this.resizeFeature = null;
        this.lastFocusEvent = null;
        this.dragSource = null;
        this.instanceId = column.getUniqueId() + "-" + $437b23f6a393c3bf$var$instanceIdSequence4++;
    }
    postConstruct() {
        const refreshTabIndex = this.refreshTabIndex.bind(this);
        this.addManagedPropertyListeners([
            "suppressHeaderFocus"
        ], refreshTabIndex);
        this.addManagedEventListeners({
            overlayExclusiveChanged: refreshTabIndex
        });
    }
    shouldStopEventPropagation(event) {
        const { headerRowIndex: headerRowIndex, column: column } = this.beans.focusSvc.focusedHeader;
        const colDef = column.getDefinition();
        const colDefFunc = colDef && colDef.suppressHeaderKeyboardEvent;
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(colDefFunc)) return false;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            colDef: colDef,
            column: column,
            headerRowIndex: headerRowIndex,
            event: event
        });
        return !!colDefFunc(params);
    }
    getWrapperHasFocus() {
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        return activeEl === this.eGui;
    }
    setGui(eGui, compBean) {
        this.eGui = eGui;
        this.addDomData(compBean);
        compBean.addManagedListeners(this.beans.eventSvc, {
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this)
        });
        compBean.addManagedElementListeners(this.eGui, {
            focus: this.onGuiFocus.bind(this)
        });
        this.onDisplayedColumnsChanged();
        this.refreshTabIndex();
    }
    refreshHeaderStyles() {
        const colDef = this.column.getDefinition();
        if (!colDef) return;
        const { headerStyle: headerStyle } = colDef;
        let styles;
        if (typeof headerStyle === "function") {
            const cellStyleParams = this.getHeaderClassParams();
            styles = headerStyle(cellStyleParams);
        } else styles = headerStyle;
        if (styles) this.comp.setUserStyles(styles);
    }
    onGuiFocus() {
        this.eventSvc.dispatchEvent({
            type: "headerFocused",
            column: this.column
        });
    }
    setupAutoHeight(params) {
        const { wrapperElement: wrapperElement, checkMeasuringCallback: checkMeasuringCallback, compBean: compBean } = params;
        const { beans: beans } = this;
        const measureHeight = (timesCalled)=>{
            if (!this.isAlive() || !compBean.isAlive()) return;
            const { paddingTop: paddingTop, paddingBottom: paddingBottom, borderBottomWidth: borderBottomWidth, borderTopWidth: borderTopWidth } = $437b23f6a393c3bf$var$_getElementSize(this.eGui);
            const extraHeight = paddingTop + paddingBottom + borderBottomWidth + borderTopWidth;
            const wrapperHeight = wrapperElement.offsetHeight;
            const autoHeight = wrapperHeight + extraHeight;
            if (timesCalled < 5) {
                const doc = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
                const notYetInDom = !doc || !doc.contains(wrapperElement);
                const possiblyNoContentYet = autoHeight == 0;
                if (notYetInDom || possiblyNoContentYet) {
                    $437b23f6a393c3bf$export$8ea55376d0d59592(()=>measureHeight(timesCalled + 1), "raf", beans);
                    return;
                }
            }
            this.setColHeaderHeight(this.column, autoHeight);
        };
        let isMeasuring = false;
        let stopResizeObserver;
        const checkMeasuring = ()=>{
            const newValue = this.column.isAutoHeaderHeight();
            if (newValue && !isMeasuring) startMeasuring();
            if (!newValue && isMeasuring) stopMeasuring();
        };
        const startMeasuring = ()=>{
            isMeasuring = true;
            measureHeight(0);
            this.comp.toggleCss("ag-header-cell-auto-height", true);
            stopResizeObserver = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, wrapperElement, ()=>measureHeight(0));
        };
        const stopMeasuring = ()=>{
            isMeasuring = false;
            if (stopResizeObserver) stopResizeObserver();
            this.comp.toggleCss("ag-header-cell-auto-height", false);
            stopResizeObserver = void 0;
        };
        checkMeasuring();
        compBean.addDestroyFunc(()=>stopMeasuring());
        compBean.addManagedListeners(this.column, {
            widthChanged: ()=>isMeasuring && measureHeight(0)
        });
        compBean.addManagedEventListeners({
            sortChanged: ()=>{
                if (isMeasuring) window.setTimeout(()=>measureHeight(0));
            }
        });
        if (checkMeasuringCallback) checkMeasuringCallback(checkMeasuring);
    }
    onDisplayedColumnsChanged() {
        const { comp: comp, column: column, beans: beans, eGui: eGui } = this;
        if (!comp || !column || !eGui) return;
        $437b23f6a393c3bf$var$refreshFirstAndLastStyles(comp, column, beans.visibleCols);
        $437b23f6a393c3bf$export$84b73ecd0b234e89(eGui, beans.visibleCols.getAriaColIndex(column));
    }
    addResizeAndMoveKeyboardListeners(compBean) {
        compBean.addManagedListeners(this.eGui, {
            keydown: this.onGuiKeyDown.bind(this),
            keyup: this.onGuiKeyUp.bind(this)
        });
    }
    refreshTabIndex() {
        const suppressHeaderFocus = $437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans);
        if (this.eGui) $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eGui, "tabindex", suppressHeaderFocus ? null : "-1");
    }
    onGuiKeyDown(e) {
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        const isLeftOrRight = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT || e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT;
        if (this.isResizing) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        if (// if elements within the header are focused, we don't process the event
        activeEl !== this.eGui || // if shiftKey and altKey are not pressed, it's cell navigation so we don't process the event
        !e.shiftKey && !e.altKey) return;
        if (this.isResizing || isLeftOrRight) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        if (!isLeftOrRight) return;
        const isLeft = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT !== this.gos.get("enableRtl");
        const direction = isLeft ? "left" : "right";
        if (e.altKey) {
            this.isResizing = true;
            this.resizeMultiplier += 1;
            const diff = this.getViewportAdjustedResizeDiff(e);
            this.resizeHeader(diff, e.shiftKey);
            this.resizeFeature?.toggleColumnResizing(true);
        } else this.moveHeader(direction);
    }
    moveHeader(hDirection) {
        this.beans.colMoves?.moveHeader(hDirection, this.eGui, this.column, this.rowCtrl.pinned, this);
    }
    getViewportAdjustedResizeDiff(e) {
        const diff = this.getResizeDiff(e);
        const { pinnedCols: pinnedCols } = this.beans;
        return pinnedCols ? pinnedCols.getHeaderResizeDiff(diff, this.column) : diff;
    }
    getResizeDiff(e) {
        const { gos: gos, column: column } = this;
        let isLeft = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT !== gos.get("enableRtl");
        const pinned = column.getPinned();
        const isRtl = gos.get("enableRtl");
        if (pinned) {
            if (isRtl !== (pinned === "right")) isLeft = !isLeft;
        }
        return (isLeft ? -1 : 1) * this.resizeMultiplier;
    }
    onGuiKeyUp() {
        if (!this.isResizing) return;
        if (this.resizeToggleTimeout) {
            window.clearTimeout(this.resizeToggleTimeout);
            this.resizeToggleTimeout = 0;
        }
        this.isResizing = false;
        this.resizeMultiplier = 1;
        this.resizeToggleTimeout = window.setTimeout(()=>{
            this.resizeFeature?.toggleColumnResizing(false);
        }, 150);
    }
    handleKeyDown(e) {
        const wrapperHasFocus = this.getWrapperHasFocus();
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                if (wrapperHasFocus) e.preventDefault();
        }
    }
    addDomData(compBean) {
        const key = $437b23f6a393c3bf$var$DOM_DATA_KEY_HEADER_CTRL;
        const { eGui: eGui, gos: gos } = this;
        $437b23f6a393c3bf$var$_setDomData(gos, eGui, key, this);
        compBean.addDestroyFunc(()=>$437b23f6a393c3bf$var$_setDomData(gos, eGui, key, null));
    }
    focus(event) {
        const { eGui: eGui } = this;
        if (!eGui) return false;
        this.lastFocusEvent = event || null;
        eGui.focus();
        return true;
    }
    focusThis() {
        this.beans.focusSvc.focusedHeader = {
            headerRowIndex: this.rowCtrl.rowIndex,
            column: this.column
        };
    }
    removeDragSource() {
        if (this.dragSource) {
            this.beans.dragAndDrop?.removeDragSource(this.dragSource);
            this.dragSource = null;
        }
    }
    handleContextMenuMouseEvent(mouseEvent, touchEvent, column) {
        const event = mouseEvent ?? touchEvent;
        const { menuSvc: menuSvc, gos: gos } = this.beans;
        if (gos.get("preventDefaultOnContextMenu")) event.preventDefault();
        if (menuSvc?.isHeaderContextMenuEnabled(column)) menuSvc.showHeaderContextMenu(column, mouseEvent, touchEvent);
        this.dispatchColumnMouseEvent("columnHeaderContextMenu", column);
    }
    dispatchColumnMouseEvent(eventType, column) {
        this.eventSvc.dispatchEvent({
            type: eventType,
            column: column
        });
    }
    setColHeaderHeight(col, height) {
        if (!col.setAutoHeaderHeight(height)) return;
        const { eventSvc: eventSvc } = this;
        if (col.isColumn) eventSvc.dispatchEvent({
            type: "columnHeaderHeightChanged",
            column: col,
            columns: [
                col
            ],
            source: "autosizeColumnHeaderHeight"
        });
        else eventSvc.dispatchEvent({
            type: "columnGroupHeaderHeightChanged",
            columnGroup: col,
            source: "autosizeColumnGroupHeaderHeight"
        });
    }
    clearComponent() {
        this.removeDragSource();
        this.resizeFeature = null;
        this.comp = null;
        this.eGui = null;
    }
    destroy() {
        super.destroy();
        this.column = null;
        this.lastFocusEvent = null;
        this.rowCtrl = null;
    }
};
// packages/ag-grid-community/src/headerRendering/cells/column/headerCellCtrl.ts
var $437b23f6a393c3bf$var$HeaderCellCtrl = class extends $437b23f6a393c3bf$var$AbstractHeaderCellCtrl {
    constructor(){
        super(...arguments);
        this.refreshFunctions = {};
        this.userHeaderClasses = /* @__PURE__ */ new Set();
        this.ariaDescriptionProperties = /* @__PURE__ */ new Map();
    }
    setComp(comp, eGui, eResize, eHeaderCompWrapper, compBeanInput) {
        this.comp = comp;
        const { rowCtrl: rowCtrl, column: column, beans: beans } = this;
        const { colResize: colResize, context: context, colHover: colHover, rangeSvc: rangeSvc } = beans;
        const compBean = $437b23f6a393c3bf$var$setupCompBean(this, context, compBeanInput);
        this.setGui(eGui, compBean);
        this.updateState();
        this.setupWidth(compBean);
        this.setupMovingCss(compBean);
        this.setupMenuClass(compBean);
        this.setupSortableClass(compBean);
        this.setupWrapTextClass();
        this.refreshSpanHeaderHeight();
        this.setupAutoHeight({
            wrapperElement: eHeaderCompWrapper,
            checkMeasuringCallback: (checkMeasuring)=>this.setRefreshFunction("measuring", checkMeasuring),
            compBean: compBean
        });
        this.addColumnHoverListener(compBean);
        this.setupFilterClass(compBean);
        this.setupStylesFromColDef();
        this.setupClassesFromColDef();
        this.setupTooltip();
        this.addActiveHeaderMouseListeners(compBean);
        this.setupSelectAll(compBean);
        this.setupUserComp();
        this.refreshAria();
        if (colResize) this.resizeFeature = compBean.createManagedBean(colResize.createResizeFeature(rowCtrl.pinned, column, eResize, comp, this));
        else $437b23f6a393c3bf$export$9405f1cbb4e2383f(eResize, false);
        colHover?.createHoverFeature(compBean, [
            column
        ], eGui);
        rangeSvc?.createRangeHighlightFeature(compBean, column, comp);
        compBean.createManagedBean(new $437b23f6a393c3bf$var$SetLeftFeature(column, eGui, beans));
        compBean.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(eGui, {
            shouldStopEventPropagation: (e)=>this.shouldStopEventPropagation(e),
            onTabKeyDown: ()=>null,
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this),
            onFocusOut: this.onFocusOut.bind(this)
        }));
        this.addResizeAndMoveKeyboardListeners(compBean);
        compBean.addManagedPropertyListeners([
            "suppressMovableColumns",
            "suppressMenuHide",
            "suppressAggFuncInHeader",
            "enableAdvancedFilter"
        ], ()=>this.refresh());
        compBean.addManagedListeners(column, {
            colDefChanged: ()=>this.refresh()
        });
        compBean.addManagedListeners(column, {
            headerHighlightChanged: this.onHeaderHighlightChanged.bind(this)
        });
        const listener = ()=>this.checkDisplayName();
        compBean.addManagedEventListeners({
            columnValueChanged: listener,
            columnRowGroupChanged: listener,
            columnPivotChanged: listener,
            headerHeightChanged: this.onHeaderHeightChanged.bind(this)
        });
        compBean.addDestroyFunc(()=>{
            this.refreshFunctions = {};
            this.selectAllFeature = null;
            this.dragSourceElement = void 0;
            this.userCompDetails = null;
            this.userHeaderClasses.clear();
            this.ariaDescriptionProperties.clear();
            this.clearComponent();
        });
    }
    resizeHeader(delta, shiftKey) {
        this.beans.colResize?.resizeHeader(this.column, delta, shiftKey);
    }
    getHeaderClassParams() {
        const { column: column, beans: beans } = this;
        const colDef = column.colDef;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(beans.gos, {
            colDef: colDef,
            column: column,
            floatingFilter: false
        });
    }
    setupUserComp() {
        const compDetails = this.lookupUserCompDetails();
        if (compDetails) this.setCompDetails(compDetails);
    }
    setCompDetails(compDetails) {
        this.userCompDetails = compDetails;
        this.comp.setUserCompDetails(compDetails);
    }
    lookupUserCompDetails() {
        const params = this.createParams();
        const colDef = this.column.getColDef();
        return $437b23f6a393c3bf$var$_getHeaderCompDetails(this.beans.userCompFactory, colDef, params);
    }
    createParams() {
        const { menuSvc: menuSvc, sortSvc: sortSvc, colFilter: colFilter, gos: gos } = this.beans;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            column: this.column,
            displayName: this.displayName,
            enableSorting: this.column.isSortable(),
            enableMenu: this.menuEnabled,
            enableFilterButton: this.openFilterEnabled && !!menuSvc?.isHeaderFilterButtonEnabled(this.column),
            enableFilterIcon: !!colFilter && (!this.openFilterEnabled || $437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos)),
            showColumnMenu: (buttonElement, onClosedCallback)=>{
                menuSvc?.showColumnMenu({
                    column: this.column,
                    buttonElement: buttonElement,
                    positionBy: "button",
                    onClosedCallback: onClosedCallback
                });
            },
            showColumnMenuAfterMouseClick: (mouseEvent, onClosedCallback)=>{
                menuSvc?.showColumnMenu({
                    column: this.column,
                    mouseEvent: mouseEvent,
                    positionBy: "mouse",
                    onClosedCallback: onClosedCallback
                });
            },
            showFilter: (buttonElement)=>{
                menuSvc?.showFilterMenu({
                    column: this.column,
                    buttonElement: buttonElement,
                    containerType: "columnFilter",
                    positionBy: "button"
                });
            },
            progressSort: (multiSort)=>{
                sortSvc?.progressSort(this.column, !!multiSort, "uiColumnSorted");
            },
            setSort: (sort, multiSort)=>{
                sortSvc?.setSortForColumn(this.column, sort, !!multiSort, "uiColumnSorted");
            },
            eGridHeader: this.eGui,
            setTooltip: (value, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                this.setupTooltip(value, shouldDisplayTooltip);
            }
        });
        return params;
    }
    setupSelectAll(compBean) {
        const { selectionSvc: selectionSvc } = this.beans;
        if (!selectionSvc) return;
        this.selectAllFeature = compBean.createOptionalManagedBean(selectionSvc.createSelectAllFeature(this.column));
        this.selectAllFeature?.setComp(this);
        compBean.addManagedPropertyListener("rowSelection", ()=>{
            const selectAllFeature = selectionSvc.createSelectAllFeature(this.column);
            if (selectAllFeature && !this.selectAllFeature) {
                this.selectAllFeature = compBean.createManagedBean(selectAllFeature);
                this.selectAllFeature?.setComp(this);
                this.comp.refreshSelectAllGui();
            } else if (this.selectAllFeature && !selectAllFeature) {
                this.comp.removeSelectAllGui();
                this.selectAllFeature = this.destroyBean(this.selectAllFeature);
            }
        });
    }
    getSelectAllGui() {
        return this.selectAllFeature?.getCheckboxGui();
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) this.selectAllFeature?.onSpaceKeyDown(e);
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) this.onEnterKeyDown(e);
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN && e.altKey) this.showMenuOnKeyPress(e, false);
    }
    onEnterKeyDown(e) {
        if (e.ctrlKey || e.metaKey) this.showMenuOnKeyPress(e, true);
        else if (this.sortable) this.beans.sortSvc?.progressSort(this.column, e.shiftKey, "uiColumnSorted");
    }
    showMenuOnKeyPress(e, isFilterShortcut) {
        const headerComp = this.comp.getUserCompInstance();
        if (!$437b23f6a393c3bf$var$isHeaderComp(headerComp)) return;
        if (headerComp.onMenuKeyboardShortcut(isFilterShortcut)) e.preventDefault();
    }
    onFocusIn(e) {
        if (!this.eGui.contains(e.relatedTarget)) {
            this.focusThis();
            this.announceAriaDescription();
        }
        if ($437b23f6a393c3bf$export$e4c8c227337b7f23()) this.setActiveHeader(true);
    }
    onFocusOut(e) {
        if (this.eGui.contains(e.relatedTarget)) return;
        this.setActiveHeader(false);
    }
    setupTooltip(value, shouldDisplayTooltip) {
        this.tooltipFeature = this.beans.tooltipSvc?.setupHeaderTooltip(this.tooltipFeature, this, value, shouldDisplayTooltip);
    }
    setupStylesFromColDef() {
        this.setRefreshFunction("headerStyles", this.refreshHeaderStyles.bind(this));
        this.refreshHeaderStyles();
    }
    setupClassesFromColDef() {
        const refreshHeaderClasses = ()=>{
            const colDef = this.column.getColDef();
            const classes = $437b23f6a393c3bf$export$9ba3bd48c77c5e8a(colDef, this.gos, this.column, null);
            const oldClasses = this.userHeaderClasses;
            this.userHeaderClasses = new Set(classes);
            classes.forEach((c)=>{
                if (oldClasses.has(c)) oldClasses.delete(c);
                else this.comp.toggleCss(c, true);
            });
            oldClasses.forEach((c)=>this.comp.toggleCss(c, false));
        };
        this.setRefreshFunction("headerClasses", refreshHeaderClasses);
        refreshHeaderClasses();
    }
    setDragSource(eSource) {
        this.dragSourceElement = eSource;
        this.removeDragSource();
        if (!eSource || !this.draggable) return;
        this.dragSource = this.beans.colMoves?.setDragSourceForHeader(eSource, this.column, this.displayName) ?? null;
    }
    updateState() {
        const { menuSvc: menuSvc } = this.beans;
        this.menuEnabled = !!menuSvc?.isColumnMenuInHeaderEnabled(this.column);
        this.openFilterEnabled = !!menuSvc?.isFilterMenuInHeaderEnabled(this.column);
        this.sortable = this.column.isSortable();
        this.displayName = this.calculateDisplayName();
        this.draggable = this.workOutDraggable();
    }
    setRefreshFunction(name, func) {
        this.refreshFunctions[name] = func;
    }
    refresh() {
        this.updateState();
        this.refreshHeaderComp();
        this.refreshAria();
        Object.values(this.refreshFunctions).forEach((f)=>f());
    }
    refreshHeaderComp() {
        const newCompDetails = this.lookupUserCompDetails();
        if (!newCompDetails) return;
        const compInstance = this.comp.getUserCompInstance();
        const attemptRefresh = compInstance != null && this.userCompDetails.componentClass == newCompDetails.componentClass;
        const headerCompRefreshed = attemptRefresh ? this.attemptHeaderCompRefresh(newCompDetails.params) : false;
        if (headerCompRefreshed) this.setDragSource(this.dragSourceElement);
        else this.setCompDetails(newCompDetails);
    }
    attemptHeaderCompRefresh(params) {
        const headerComp = this.comp.getUserCompInstance();
        if (!headerComp) return false;
        if (!headerComp.refresh) return false;
        const res = headerComp.refresh(params);
        return res;
    }
    calculateDisplayName() {
        return this.beans.colNames.getDisplayNameForColumn(this.column, "header", true);
    }
    checkDisplayName() {
        if (this.displayName !== this.calculateDisplayName()) this.refresh();
    }
    workOutDraggable() {
        const colDef = this.column.getColDef();
        const isSuppressMovableColumns = this.gos.get("suppressMovableColumns");
        const colCanMove = !isSuppressMovableColumns && !colDef.suppressMovable && !colDef.lockPosition;
        return !!colCanMove || !!colDef.enableRowGroup || !!colDef.enablePivot;
    }
    setupWidth(compBean) {
        const listener = ()=>{
            const columnWidth = this.column.getActualWidth();
            this.comp.setWidth(`${columnWidth}px`);
        };
        compBean.addManagedListeners(this.column, {
            widthChanged: listener
        });
        listener();
    }
    setupMovingCss(compBean) {
        const listener = ()=>{
            this.comp.toggleCss("ag-header-cell-moving", this.column.isMoving());
        };
        compBean.addManagedListeners(this.column, {
            movingChanged: listener
        });
        listener();
    }
    setupMenuClass(compBean) {
        const listener = ()=>{
            this.comp?.toggleCss("ag-column-menu-visible", this.column.isMenuVisible());
        };
        compBean.addManagedListeners(this.column, {
            menuVisibleChanged: listener
        });
        listener();
    }
    setupSortableClass(compBean) {
        const updateSortableCssClass = ()=>{
            this.comp.toggleCss("ag-header-cell-sortable", !!this.sortable);
        };
        updateSortableCssClass();
        this.setRefreshFunction("updateSortable", updateSortableCssClass);
        compBean.addManagedEventListeners({
            sortChanged: this.refreshAriaSort.bind(this)
        });
    }
    setupFilterClass(compBean) {
        const listener = ()=>{
            const isFilterActive = this.column.isFilterActive();
            this.comp.toggleCss("ag-header-cell-filtered", isFilterActive);
            this.refreshAria();
        };
        compBean.addManagedListeners(this.column, {
            filterActiveChanged: listener
        });
        listener();
    }
    setupWrapTextClass() {
        const listener = ()=>{
            const wrapText = !!this.column.getColDef().wrapHeaderText;
            this.comp.toggleCss("ag-header-cell-wrap-text", wrapText);
        };
        listener();
        this.setRefreshFunction("wrapText", listener);
    }
    onHeaderHighlightChanged() {
        const highlighted = this.column.getHighlighted();
        const beforeOn = highlighted === 0 /* Before */ ;
        const afterOn = highlighted === 1 /* After */ ;
        this.comp.toggleCss("ag-header-highlight-before", beforeOn);
        this.comp.toggleCss("ag-header-highlight-after", afterOn);
    }
    onDisplayedColumnsChanged() {
        super.onDisplayedColumnsChanged();
        if (!this.isAlive()) return;
        this.onHeaderHeightChanged();
    }
    onHeaderHeightChanged() {
        this.refreshSpanHeaderHeight();
    }
    refreshSpanHeaderHeight() {
        const { eGui: eGui, column: column, comp: comp, beans: beans } = this;
        const groupHeaderHeight = $437b23f6a393c3bf$var$getGroupRowsHeight(this.beans);
        const isZeroGroupHeight = groupHeaderHeight.reduce((total, next)=>total += next, 0) === 0;
        comp.toggleCss("ag-header-parent-hidden", isZeroGroupHeight);
        if (!column.isSpanHeaderHeight()) {
            eGui.style.removeProperty("top");
            eGui.style.removeProperty("height");
            comp.toggleCss("ag-header-span-height", false);
            comp.toggleCss("ag-header-span-total", false);
            return;
        }
        const { numberOfParents: numberOfParents, isSpanningTotal: isSpanningTotal } = this.column.getColumnGroupPaddingInfo();
        comp.toggleCss("ag-header-span-height", numberOfParents > 0);
        const headerHeight = $437b23f6a393c3bf$var$getColumnHeaderRowHeight(beans);
        if (numberOfParents === 0) {
            comp.toggleCss("ag-header-span-total", false);
            eGui.style.setProperty("top", `0px`);
            eGui.style.setProperty("height", `${headerHeight}px`);
            return;
        }
        comp.toggleCss("ag-header-span-total", isSpanningTotal);
        const indexToStartSpanning = (this.column.getFirstRealParent()?.getLevel() ?? -1) + 1;
        const rowsToSpan = groupHeaderHeight.length - indexToStartSpanning;
        let extraHeight = 0;
        for(let i = 0; i < rowsToSpan; i++)extraHeight += groupHeaderHeight[groupHeaderHeight.length - 1 - i];
        eGui.style.setProperty("top", `${-extraHeight}px`);
        eGui.style.setProperty("height", `${headerHeight + extraHeight}px`);
    }
    refreshAriaSort() {
        if (this.sortable) {
            const translate = this.getLocaleTextFunc();
            const sort = this.beans.sortSvc?.getDisplaySortForColumn(this.column) || null;
            this.comp.setAriaSort($437b23f6a393c3bf$var$_getAriaSortState(sort));
            this.setAriaDescriptionProperty("sort", translate("ariaSortableColumn", "Press ENTER to sort"));
        } else {
            this.comp.setAriaSort();
            this.setAriaDescriptionProperty("sort", null);
        }
    }
    refreshAriaMenu() {
        if (this.menuEnabled) {
            const translate = this.getLocaleTextFunc();
            this.setAriaDescriptionProperty("menu", translate("ariaMenuColumn", "Press ALT DOWN to open column menu"));
        } else this.setAriaDescriptionProperty("menu", null);
    }
    refreshAriaFilterButton() {
        if (this.openFilterEnabled && !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos)) {
            const translate = this.getLocaleTextFunc();
            this.setAriaDescriptionProperty("filterButton", translate("ariaFilterColumn", "Press CTRL ENTER to open filter"));
        } else this.setAriaDescriptionProperty("filterButton", null);
    }
    refreshAriaFiltered() {
        const translate = this.getLocaleTextFunc();
        const isFilterActive = this.column.isFilterActive();
        if (isFilterActive) this.setAriaDescriptionProperty("filter", translate("ariaColumnFiltered", "Column Filtered"));
        else this.setAriaDescriptionProperty("filter", null);
    }
    setAriaDescriptionProperty(property, value) {
        if (value != null) this.ariaDescriptionProperties.set(property, value);
        else this.ariaDescriptionProperties.delete(property);
    }
    announceAriaDescription() {
        if (!this.eGui.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans))) return;
        const ariaDescription = Array.from(this.ariaDescriptionProperties.keys()).sort((a, b)=>a === "filter" ? -1 : b.charCodeAt(0) - a.charCodeAt(0)).map((key)=>this.ariaDescriptionProperties.get(key)).join(". ");
        this.beans.ariaAnnounce?.announceValue(ariaDescription, "columnHeader");
    }
    refreshAria() {
        this.refreshAriaSort();
        this.refreshAriaMenu();
        this.refreshAriaFilterButton();
        this.refreshAriaFiltered();
    }
    addColumnHoverListener(compBean) {
        this.beans.colHover?.addHeaderColumnHoverListener(compBean, this.comp, this.column);
    }
    addActiveHeaderMouseListeners(compBean) {
        const listener = (e)=>this.handleMouseOverChange(e.type === "mouseenter");
        const clickListener = ()=>{
            this.setActiveHeader(true);
            this.dispatchColumnMouseEvent("columnHeaderClicked", this.column);
        };
        const contextMenuListener = (event)=>this.handleContextMenuMouseEvent(event, void 0, this.column);
        compBean.addManagedListeners(this.eGui, {
            mouseenter: listener,
            mouseleave: listener,
            click: clickListener,
            contextmenu: contextMenuListener
        });
    }
    handleMouseOverChange(isMouseOver) {
        this.setActiveHeader(isMouseOver);
        this.eventSvc.dispatchEvent({
            type: isMouseOver ? "columnHeaderMouseOver" : "columnHeaderMouseLeave",
            column: this.column
        });
    }
    setActiveHeader(active) {
        this.comp.toggleCss("ag-header-active", active);
    }
    getAnchorElementForMenu(isFilter) {
        const headerComp = this.comp.getUserCompInstance();
        if ($437b23f6a393c3bf$var$isHeaderComp(headerComp)) return headerComp.getAnchorElementForMenu(isFilter);
        return this.eGui;
    }
    destroy() {
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        super.destroy();
    }
};
function $437b23f6a393c3bf$var$isHeaderComp(headerComp) {
    return typeof headerComp?.getAnchorElementForMenu === "function" && typeof headerComp.onMenuKeyboardShortcut === "function";
}
// packages/ag-grid-community/src/headerRendering/row/headerRowCtrl.ts
var $437b23f6a393c3bf$var$instanceIdSequence5 = 0;
var $437b23f6a393c3bf$var$HeaderRowCtrl = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(rowIndex, pinned, type){
        super();
        this.rowIndex = rowIndex;
        this.pinned = pinned;
        this.type = type;
        this.instanceId = $437b23f6a393c3bf$var$instanceIdSequence5++;
        this.comp = null;
        this.allCtrls = [];
        let typeClass = "ag-header-row-column";
        if (type === "group") typeClass = "ag-header-row-group";
        else if (type === "filter") typeClass = "ag-header-row-filter";
        this.headerRowClass = `ag-header-row ${typeClass}`;
    }
    setRowIndex(rowIndex) {
        this.rowIndex = rowIndex;
        this.comp?.setRowIndex(this.getAriaRowIndex());
        this.onRowHeightChanged();
    }
    postConstruct() {
        this.isPrintLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        this.isEnsureDomOrder = this.gos.get("ensureDomOrder");
    }
    /** Checks that every header cell that is currently visible has been rendered.
   * Can only be false under some circumstances when using React
   */ areCellsRendered() {
        if (!this.comp) return false;
        return this.allCtrls.every((ctrl)=>ctrl.eGui != null);
    }
    /**
   *
   * @param comp Proxy to the actual component
   * @param initCompState Should the component be initialised with the current state of the controller. Default: true
   */ setComp(comp, compBean, initCompState = true) {
        this.comp = comp;
        compBean = $437b23f6a393c3bf$var$setupCompBean(this, this.beans.context, compBean);
        if (initCompState) {
            this.setRowIndex(this.rowIndex);
            this.onVirtualColumnsChanged();
        }
        this.setWidth();
        this.addEventListeners(compBean);
    }
    getAriaRowIndex() {
        return this.rowIndex + 1;
    }
    addEventListeners(compBean) {
        const onHeightChanged = this.onRowHeightChanged.bind(this);
        const onDisplayedColumnsChanged = this.onDisplayedColumnsChanged.bind(this);
        compBean.addManagedEventListeners({
            columnResized: this.setWidth.bind(this),
            displayedColumnsChanged: onDisplayedColumnsChanged,
            virtualColumnsChanged: (params)=>this.onVirtualColumnsChanged(params.afterScroll),
            columnGroupHeaderHeightChanged: onHeightChanged,
            columnHeaderHeightChanged: onHeightChanged,
            gridStylesChanged: onHeightChanged,
            advancedFilterEnabledChanged: onHeightChanged
        });
        compBean.addManagedPropertyListener("domLayout", onDisplayedColumnsChanged);
        compBean.addManagedPropertyListener("ensureDomOrder", (e)=>this.isEnsureDomOrder = e.currentValue);
        compBean.addManagedPropertyListeners([
            "headerHeight",
            "pivotHeaderHeight",
            "groupHeaderHeight",
            "pivotGroupHeaderHeight",
            "floatingFiltersHeight"
        ], onHeightChanged);
    }
    onDisplayedColumnsChanged() {
        this.isPrintLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        this.onVirtualColumnsChanged();
        this.setWidth();
        this.onRowHeightChanged();
    }
    setWidth() {
        if (!this.comp) return;
        const width = this.getWidthForRow();
        this.comp.setWidth(`${width}px`);
    }
    getWidthForRow() {
        const { visibleCols: visibleCols } = this.beans;
        if (this.isPrintLayout) {
            const pinned = this.pinned != null;
            if (pinned) return 0;
            return visibleCols.getContainerWidth("right") + visibleCols.getContainerWidth("left") + visibleCols.getContainerWidth(null);
        }
        return visibleCols.getContainerWidth(this.pinned);
    }
    onRowHeightChanged() {
        if (!this.comp) return;
        const { topOffset: topOffset, rowHeight: rowHeight } = this.getTopAndHeight();
        this.comp.setTop(topOffset + "px");
        this.comp.setHeight(rowHeight + "px");
    }
    getTopAndHeight() {
        let topOffset = 0;
        const groupHeadersHeight = $437b23f6a393c3bf$var$getGroupRowsHeight(this.beans);
        for(let i = 0; i < groupHeadersHeight.length; i++){
            if (i === this.rowIndex && this.type === "group") return {
                topOffset: topOffset,
                rowHeight: groupHeadersHeight[i]
            };
            topOffset += groupHeadersHeight[i];
        }
        const headerHeight = $437b23f6a393c3bf$var$getColumnHeaderRowHeight(this.beans);
        if (this.type === "column") return {
            topOffset: topOffset,
            rowHeight: headerHeight
        };
        topOffset += headerHeight;
        const filterHeight = $437b23f6a393c3bf$export$b52d5533bf5be44(this.beans);
        return {
            topOffset: topOffset,
            rowHeight: filterHeight
        };
    }
    onVirtualColumnsChanged(afterScroll = false) {
        if (!this.comp) return;
        const ctrlsToDisplay = this.getUpdatedHeaderCtrls();
        const forceOrder = this.isEnsureDomOrder || this.isPrintLayout;
        this.comp.setHeaderCtrls(ctrlsToDisplay, forceOrder, afterScroll);
    }
    /**
   * Recycles the header cell ctrls and creates new ones for the columns in the viewport
   * @returns The updated header cell ctrls
   */ getUpdatedHeaderCtrls() {
        const oldCtrls = this.ctrlsById;
        this.ctrlsById = /* @__PURE__ */ new Map();
        const columns = this.getColumnsInViewport();
        for (const child of columns)this.recycleAndCreateHeaderCtrls(child, this.ctrlsById, oldCtrls);
        const isFocusedAndDisplayed = (ctrl)=>{
            const { focusSvc: focusSvc, visibleCols: visibleCols } = this.beans;
            const isFocused = focusSvc.isHeaderWrapperFocused(ctrl);
            if (!isFocused) return false;
            const isDisplayed = visibleCols.isVisible(ctrl.column);
            return isDisplayed;
        };
        if (oldCtrls) for (const [id, oldCtrl] of oldCtrls){
            const keepCtrl = isFocusedAndDisplayed(oldCtrl);
            if (keepCtrl) this.ctrlsById.set(id, oldCtrl);
            else this.destroyBean(oldCtrl);
        }
        this.allCtrls = Array.from(this.ctrlsById.values());
        return this.allCtrls;
    }
    /** Get the current header cell ctrls */ getHeaderCellCtrls() {
        return this.allCtrls;
    }
    recycleAndCreateHeaderCtrls(headerColumn, currCtrls, oldCtrls) {
        if (headerColumn.isEmptyGroup()) return;
        const idOfChild = headerColumn.getUniqueId();
        let headerCtrl;
        if (oldCtrls) {
            headerCtrl = oldCtrls.get(idOfChild);
            oldCtrls.delete(idOfChild);
        }
        const forOldColumn = headerCtrl && headerCtrl.column != headerColumn;
        if (forOldColumn) {
            this.destroyBean(headerCtrl);
            headerCtrl = void 0;
        }
        if (headerCtrl == null) switch(this.type){
            case "filter":
                headerCtrl = this.createBean(this.beans.registry.createDynamicBean("headerFilterCellCtrl", true, headerColumn, this));
                break;
            case "group":
                headerCtrl = this.createBean(this.beans.registry.createDynamicBean("headerGroupCellCtrl", true, headerColumn, this));
                break;
            default:
                headerCtrl = this.createBean(new $437b23f6a393c3bf$var$HeaderCellCtrl(headerColumn, this));
                break;
        }
        currCtrls.set(idOfChild, headerCtrl);
    }
    getColumnsInViewport() {
        if (!this.isPrintLayout) return this.getComponentsToRender();
        if (this.pinned) return [];
        const viewportColumns = [];
        [
            "left",
            null,
            "right"
        ].forEach((pinned)=>{
            viewportColumns.push(...this.getComponentsToRender(pinned));
        });
        return viewportColumns;
    }
    getComponentsToRender(pinned = this.pinned) {
        if (this.type === "group") return this.beans.colViewport.getHeadersToRender(pinned, this.rowIndex);
        return this.beans.colViewport.getColumnHeadersToRender(pinned);
    }
    focusHeader(column, event) {
        const ctrl = this.allCtrls.find((ctrl2)=>ctrl2.column == column);
        if (!ctrl) return false;
        const focused = ctrl.focus(event);
        return focused;
    }
    destroy() {
        this.allCtrls = this.destroyBeans(this.allCtrls);
        this.ctrlsById = void 0;
        this.comp = null;
        super.destroy();
    }
};
// packages/ag-grid-community/src/headerRendering/rowContainer/headerRowContainerCtrl.ts
var $437b23f6a393c3bf$export$1e864ee88f54e7b = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned){
        super();
        this.pinned = pinned;
        this.hidden = false;
        this.includeFloatingFilter = false;
        this.groupsRowCtrls = [];
    }
    setComp(comp, eGui) {
        this.comp = comp;
        this.eViewport = eGui;
        const { pinnedCols: pinnedCols, ctrlsSvc: ctrlsSvc, colModel: colModel, colMoves: colMoves } = this.beans;
        this.setupCenterWidth();
        pinnedCols?.setupHeaderPinnedWidth(this);
        this.setupDragAndDrop(colMoves, this.eViewport);
        const onDisplayedColsChanged = this.refresh.bind(this, true);
        this.addManagedEventListeners({
            displayedColumnsChanged: onDisplayedColsChanged,
            advancedFilterEnabledChanged: onDisplayedColsChanged
        });
        const headerType = `${typeof this.pinned === "string" ? this.pinned : "center"}Header`;
        ctrlsSvc.register(headerType, this);
        if (colModel.ready) this.refresh();
    }
    getAllCtrls() {
        const res = [
            ...this.groupsRowCtrls
        ];
        if (this.columnsRowCtrl) res.push(this.columnsRowCtrl);
        if (this.filtersRowCtrl) res.push(this.filtersRowCtrl);
        return res;
    }
    refresh(keepColumns = false) {
        const { focusSvc: focusSvc, filterManager: filterManager, visibleCols: visibleCols } = this.beans;
        let sequence = 0;
        const focusedHeaderPosition = focusSvc.getFocusHeaderToUseAfterRefresh();
        const refreshColumnGroups = ()=>{
            const groupRowCount = visibleCols.headerGroupRowCount;
            sequence = groupRowCount;
            const currentGroupCount = this.groupsRowCtrls.length;
            if (currentGroupCount === groupRowCount) return;
            if (currentGroupCount > groupRowCount) {
                for(let i = groupRowCount; i < currentGroupCount; i++)this.destroyBean(this.groupsRowCtrls[i]);
                this.groupsRowCtrls.length = groupRowCount;
                return;
            }
            for(let i = currentGroupCount; i < groupRowCount; i++){
                const ctrl = this.createBean(new $437b23f6a393c3bf$var$HeaderRowCtrl(i, this.pinned, "group"));
                this.groupsRowCtrls.push(ctrl);
            }
        };
        const refreshColumns = ()=>{
            const rowIndex = sequence++;
            if (this.hidden) {
                this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
                return;
            }
            if (this.columnsRowCtrl == null || !keepColumns) {
                this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
                this.columnsRowCtrl = this.createBean(new $437b23f6a393c3bf$var$HeaderRowCtrl(rowIndex, this.pinned, "column"));
            } else if (this.columnsRowCtrl.rowIndex !== rowIndex) this.columnsRowCtrl.setRowIndex(rowIndex);
        };
        const refreshFilters = ()=>{
            this.includeFloatingFilter = !!filterManager?.hasFloatingFilters() && !this.hidden;
            const destroyPreviousComp = ()=>{
                this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
            };
            if (!this.includeFloatingFilter) {
                destroyPreviousComp();
                return;
            }
            if (!keepColumns) destroyPreviousComp();
            const rowIndex = sequence++;
            if (this.filtersRowCtrl) {
                const rowIndexMismatch = this.filtersRowCtrl.rowIndex !== rowIndex;
                if (rowIndexMismatch) this.filtersRowCtrl.setRowIndex(rowIndex);
            } else this.filtersRowCtrl = this.createBean(new $437b23f6a393c3bf$var$HeaderRowCtrl(rowIndex, this.pinned, "filter"));
        };
        const oldCtrls = this.getAllCtrls();
        refreshColumnGroups();
        refreshColumns();
        refreshFilters();
        const allCtrls = this.getAllCtrls();
        this.comp.setCtrls(allCtrls);
        this.restoreFocusOnHeader(focusSvc, focusedHeaderPosition);
        if (oldCtrls.length !== allCtrls.length) this.beans.eventSvc.dispatchEvent({
            type: "headerRowsChanged"
        });
    }
    getHeaderCtrlForColumn(column) {
        const findCtrl = (ctrl)=>ctrl?.getHeaderCellCtrls().find((ctrl2)=>ctrl2.column === column);
        if ($437b23f6a393c3bf$export$891484e65a02ec71(column)) return findCtrl(this.columnsRowCtrl);
        if (this.groupsRowCtrls.length === 0) return;
        for(let i = 0; i < this.groupsRowCtrls.length; i++){
            const ctrl = findCtrl(this.groupsRowCtrls[i]);
            if (ctrl) return ctrl;
        }
    }
    getHtmlElementForColumnHeader(column) {
        return this.getHeaderCtrlForColumn(column)?.eGui ?? null;
    }
    getRowType(rowIndex) {
        return this.getAllCtrls()[rowIndex]?.type;
    }
    focusHeader(rowIndex, column, event) {
        const allCtrls = this.getAllCtrls();
        const ctrl = allCtrls[rowIndex];
        if (!ctrl) return false;
        return ctrl.focusHeader(column, event);
    }
    getGroupRowCount() {
        return this.groupsRowCtrls.length;
    }
    getGroupRowCtrlAtIndex(index) {
        return this.groupsRowCtrls[index];
    }
    getRowCount() {
        return this.groupsRowCtrls.length + (this.columnsRowCtrl ? 1 : 0) + (this.filtersRowCtrl ? 1 : 0);
    }
    setHorizontalScroll(offset) {
        this.comp.setViewportScrollLeft(offset);
    }
    onScrollCallback(fn) {
        this.addManagedElementListeners(this.eViewport, {
            scroll: fn
        });
    }
    destroy() {
        this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
        this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
        this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls);
        super.destroy();
    }
    setupDragAndDrop(colMoves, dropContainer) {
        const bodyDropTarget = colMoves?.createBodyDropTarget(this.pinned, dropContainer);
        if (bodyDropTarget) this.createManagedBean(bodyDropTarget);
    }
    restoreFocusOnHeader(focusSvc, position) {
        if (!position) return;
        const { column: column } = position;
        if (column.getPinned() != this.pinned) return;
        focusSvc.focusHeaderPosition({
            headerPosition: position
        });
    }
    setupCenterWidth() {
        if (this.pinned != null) return;
        this.createManagedBean(new $437b23f6a393c3bf$var$CenterWidthFeature((width)=>this.comp.setCenterWidth(`${width}px`), true));
    }
};
// packages/ag-grid-community/src/misc/menu/menuService.ts
var $437b23f6a393c3bf$var$MenuService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "menuSvc";
    }
    postConstruct() {
        const { enterpriseMenuFactory: enterpriseMenuFactory, filterMenuFactory: filterMenuFactory } = this.beans;
        this.activeMenuFactory = enterpriseMenuFactory ?? filterMenuFactory;
    }
    showColumnMenu(params) {
        this.showColumnMenuCommon(this.activeMenuFactory, params, "columnMenu");
    }
    showFilterMenu(params) {
        this.showColumnMenuCommon($437b23f6a393c3bf$var$getFilterMenuFactory(this.beans), params, params.containerType, true);
    }
    showHeaderContextMenu(column, mouseEvent, touchEvent) {
        this.activeMenuFactory?.showMenuAfterContextMenuEvent(column, mouseEvent, touchEvent);
    }
    hidePopupMenu() {
        this.beans.contextMenuSvc?.hideActiveMenu();
        this.activeMenuFactory?.hideActiveMenu();
    }
    hideFilterMenu() {
        $437b23f6a393c3bf$var$getFilterMenuFactory(this.beans)?.hideActiveMenu();
    }
    isColumnMenuInHeaderEnabled(column) {
        const { suppressHeaderMenuButton: suppressHeaderMenuButton } = column.getColDef();
        return !suppressHeaderMenuButton && !!this.activeMenuFactory?.isMenuEnabled(column) && ($437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos) || !!this.beans.enterpriseMenuFactory);
    }
    isFilterMenuInHeaderEnabled(column) {
        return !column.getColDef().suppressHeaderFilterButton && !!this.beans.filterManager?.isFilterAllowed(column);
    }
    isHeaderContextMenuEnabled(column) {
        const colDef = column && $437b23f6a393c3bf$export$891484e65a02ec71(column) ? column.getColDef() : column?.getColGroupDef();
        return !colDef?.suppressHeaderContextMenu && this.gos.get("columnMenu") === "new";
    }
    isHeaderMenuButtonAlwaysShowEnabled() {
        return this.isSuppressMenuHide();
    }
    isHeaderMenuButtonEnabled() {
        const menuHides = !this.isSuppressMenuHide();
        const onIpadAndMenuHides = $437b23f6a393c3bf$export$6b6034a68325bd8a() && menuHides;
        return !onIpadAndMenuHides;
    }
    isHeaderFilterButtonEnabled(column) {
        return this.isFilterMenuInHeaderEnabled(column) && !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos) && !this.isFloatingFilterButtonDisplayed(column);
    }
    isFilterMenuItemEnabled(column) {
        return !!this.beans.filterManager?.isFilterAllowed(column) && !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos) && !this.isFilterMenuInHeaderEnabled(column) && !this.isFloatingFilterButtonDisplayed(column);
    }
    isFloatingFilterButtonEnabled(column) {
        return !column.getColDef().suppressFloatingFilterButton;
    }
    isFloatingFilterButtonDisplayed(column) {
        return !!column.getColDef().floatingFilter && this.isFloatingFilterButtonEnabled(column);
    }
    isSuppressMenuHide() {
        const gos = this.gos;
        const suppressMenuHide = gos.get("suppressMenuHide");
        if ($437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos)) return gos.exists("suppressMenuHide") ? suppressMenuHide : false;
        return suppressMenuHide;
    }
    showColumnMenuCommon(menuFactory, params, containerType, filtersOnly) {
        const { positionBy: positionBy, onClosedCallback: onClosedCallback } = params;
        const column = params.column;
        if (positionBy === "button") {
            const { buttonElement: buttonElement } = params;
            menuFactory?.showMenuAfterButtonClick(column, buttonElement, containerType, onClosedCallback, filtersOnly);
        } else if (positionBy === "mouse") {
            const { mouseEvent: mouseEvent } = params;
            menuFactory?.showMenuAfterMouseEvent(column, mouseEvent, containerType, onClosedCallback, filtersOnly);
        } else if (column) {
            const beans = this.beans;
            const ctrlsSvc = beans.ctrlsSvc;
            ctrlsSvc.getScrollFeature().ensureColumnVisible(column, "auto");
            $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, ()=>{
                const headerCellCtrl = ctrlsSvc.getHeaderRowContainerCtrl(column.getPinned())?.getHeaderCtrlForColumn(column);
                if (headerCellCtrl) menuFactory?.showMenuAfterButtonClick(column, headerCellCtrl.getAnchorElementForMenu(filtersOnly), containerType, onClosedCallback, filtersOnly);
            });
        }
    }
};
function $437b23f6a393c3bf$export$2f1bf9feac2f7fbd(column, visible, source) {
    if (column.menuVisible !== visible) {
        column.menuVisible = visible;
        column.dispatchColEvent("menuVisibleChanged", source);
    }
}
function $437b23f6a393c3bf$var$getFilterMenuFactory(beans) {
    const { enterpriseMenuFactory: enterpriseMenuFactory, filterMenuFactory: filterMenuFactory, gos: gos } = beans;
    return enterpriseMenuFactory && $437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos) ? enterpriseMenuFactory : filterMenuFactory;
}
// packages/ag-grid-community/src/widgets/popupComponent.ts
var $437b23f6a393c3bf$export$9fac2d040f3ed438 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    isPopup() {
        return true;
    }
    setParentComponent(container) {
        container.addCss("ag-has-popup");
        super.setParentComponent(container);
    }
    destroy() {
        const parentComp = this.parentComponent;
        const hasParent = parentComp && parentComp.isAlive();
        if (hasParent) parentComp.getGui().classList.remove("ag-has-popup");
        super.destroy();
    }
};
// packages/ag-grid-community/src/widgets/agAbstractCellEditor.ts
var $437b23f6a393c3bf$export$803b08aecd9af1a9 = class extends $437b23f6a393c3bf$export$9fac2d040f3ed438 {
    constructor(){
        super(...arguments);
        this.errorMessages = null;
    }
    init(params) {
        this.params = params;
        this.initialiseEditor(params);
        this.eEditor.onValueChange(()=>params.validate());
    }
    destroy() {
        this.errorMessages = null;
    }
};
// packages/ag-grid-community/src/rendering/overlays/overlayComponent.ts
var $437b23f6a393c3bf$var$OverlayComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super();
    }
};
// packages/ag-grid-community/src/rendering/overlays/loadingOverlayComponent.ts
var $437b23f6a393c3bf$var$LoadingOverlayElement = {
    tag: "span",
    cls: "ag-overlay-loading-center",
    attrs: {
        "aria-live": "polite",
        "aria-atomic": "true"
    }
};
var $437b23f6a393c3bf$var$LoadingOverlayComponent2 = class extends $437b23f6a393c3bf$var$OverlayComponent {
    init() {
        const customTemplate = $437b23f6a393c3bf$export$4978424c4f7b5fc0(this.gos.get("overlayLoadingTemplate")?.trim());
        this.setTemplate(customTemplate ?? $437b23f6a393c3bf$var$LoadingOverlayElement);
        if (!customTemplate) {
            const localeTextFunc = this.getLocaleTextFunc();
            setTimeout(()=>{
                this.getGui().textContent = localeTextFunc("loadingOoo", "Loading...");
            });
        }
    }
};
// packages/ag-grid-community/src/rendering/overlays/noRowsOverlayComponent.ts
var $437b23f6a393c3bf$var$NoRowsOverlayElement = {
    tag: "span",
    cls: "ag-overlay-no-rows-center"
};
var $437b23f6a393c3bf$var$NoRowsOverlayComponent2 = class extends $437b23f6a393c3bf$var$OverlayComponent {
    init() {
        const customTemplate = $437b23f6a393c3bf$export$4978424c4f7b5fc0(this.gos.get("overlayNoRowsTemplate")?.trim());
        this.setTemplate(customTemplate ?? $437b23f6a393c3bf$var$NoRowsOverlayElement);
        if (!customTemplate) {
            const localeTextFunc = this.getLocaleTextFunc();
            setTimeout(()=>{
                this.getGui().textContent = localeTextFunc("noRowsToShow", "No Rows To Show");
            });
        }
    }
};
// packages/ag-grid-community/src/utils/icon.ts
function $437b23f6a393c3bf$export$f4e9fbdaadc5e5c1(iconName, beans, column) {
    const iconContents = $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, beans, column);
    if (iconContents) {
        const { className: className } = iconContents;
        if (typeof className === "string" && className.indexOf("ag-icon") > -1 || typeof className === "object" && className["ag-icon"]) return iconContents;
    }
    const eResult = $437b23f6a393c3bf$export$a232bb0480ae674a({
        tag: "span"
    });
    eResult.appendChild(iconContents);
    return eResult;
}
function $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, beans, column) {
    let userProvidedIcon = null;
    if (iconName === "smallDown") $437b23f6a393c3bf$export$545083624300f13d(262);
    else if (iconName === "smallLeft") $437b23f6a393c3bf$export$545083624300f13d(263);
    else if (iconName === "smallRight") $437b23f6a393c3bf$export$545083624300f13d(264);
    const icons = column && column.getColDef().icons;
    if (icons) userProvidedIcon = icons[iconName];
    if (beans.gos && !userProvidedIcon) {
        const optionsIcons = beans.gos.get("icons");
        if (optionsIcons) userProvidedIcon = optionsIcons[iconName];
    }
    if (userProvidedIcon) {
        let rendererResult;
        if (typeof userProvidedIcon === "function") rendererResult = userProvidedIcon();
        else if (typeof userProvidedIcon === "string") rendererResult = userProvidedIcon;
        else {
            $437b23f6a393c3bf$export$545083624300f13d(38, {
                iconName: iconName
            });
            return void 0;
        }
        if (typeof rendererResult === "string") return $437b23f6a393c3bf$export$b1f57d075ca6d5fb(rendererResult);
        if ($437b23f6a393c3bf$export$6e6303ef478b0c94(rendererResult)) return rendererResult;
        $437b23f6a393c3bf$export$545083624300f13d(133, {
            iconName: iconName
        });
        return void 0;
    } else {
        const iconValue = beans.registry.getIcon(iconName);
        if (!iconValue) beans.validation?.validateIcon(iconName);
        return $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "span",
            cls: `ag-icon ag-icon-${iconValue ?? iconName}`,
            role: "presentation",
            attrs: {
                unselectable: "on"
            }
        });
    }
}
// packages/ag-grid-community/src/dragAndDrop/dragAndDropImageComponent.css-GENERATED.ts
var $437b23f6a393c3bf$var$dragAndDropImageComponentCSS = /*css*/ `.ag-dnd-ghost{align-items:center;background-color:var(--ag-drag-and-drop-image-background-color);border:var(--ag-drag-and-drop-image-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-drag-and-drop-image-shadow);color:var(--ag-text-color);cursor:move;display:flex;font-weight:500;gap:var(--ag-cell-widget-spacing);height:var(--ag-header-height);overflow:hidden;padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding);text-overflow:ellipsis;transform:translateY(calc(var(--ag-spacing)*2));white-space:nowrap}`;
// packages/ag-grid-community/src/dragAndDrop/dragAndDropImageComponent.ts
var $437b23f6a393c3bf$var$DragAndDropElement = {
    tag: "div",
    children: [
        {
            tag: "div",
            ref: "eGhost",
            cls: "ag-dnd-ghost ag-unselectable",
            children: [
                {
                    tag: "span",
                    ref: "eIcon",
                    cls: "ag-dnd-ghost-icon ag-shake-left-to-right"
                },
                {
                    tag: "div",
                    ref: "eLabel",
                    cls: "ag-dnd-ghost-label"
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$var$DragAndDropImageComponent2 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super();
        this.dragSource = null;
        this.eIcon = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eGhost = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.registerCSS($437b23f6a393c3bf$var$dragAndDropImageComponentCSS);
    }
    postConstruct() {
        const create = (iconName)=>$437b23f6a393c3bf$export$f4e9fbdaadc5e5c1(iconName, this.beans, null);
        this.dropIconMap = {
            pinned: create("columnMovePin"),
            hide: create("columnMoveHide"),
            move: create("columnMoveMove"),
            left: create("columnMoveLeft"),
            right: create("columnMoveRight"),
            group: create("columnMoveGroup"),
            aggregate: create("columnMoveValue"),
            pivot: create("columnMovePivot"),
            notAllowed: create("dropNotAllowed")
        };
    }
    init(params) {
        this.dragSource = params.dragSource;
        this.setTemplate($437b23f6a393c3bf$var$DragAndDropElement);
        this.beans.environment.applyThemeClasses(this.eGhost);
    }
    destroy() {
        this.dragSource = null;
        super.destroy();
    }
    setIcon(iconName, shake) {
        const { eIcon: eIcon, dragSource: dragSource, dropIconMap: dropIconMap, gos: gos } = this;
        $437b23f6a393c3bf$export$69e6e10709eabd91(eIcon);
        let eIconChild = null;
        if (!iconName) iconName = dragSource?.getDefaultIconName ? dragSource.getDefaultIconName() : "notAllowed";
        eIconChild = dropIconMap[iconName];
        eIcon.classList.toggle("ag-shake-left-to-right", shake);
        if (eIconChild === dropIconMap["hide"] && gos.get("suppressDragLeaveHidesColumns")) return;
        if (eIconChild) eIcon.appendChild(eIconChild);
    }
    setLabel(label) {
        this.eLabel.textContent = label;
    }
};
// packages/ag-grid-community/src/widgets/agAbstractLabel.css-GENERATED.ts
var $437b23f6a393c3bf$var$agAbstractLabelCSS = /*css*/ `.ag-label{white-space:nowrap}:where(.ag-ltr) .ag-label{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-label{margin-left:var(--ag-spacing)}:where(.ag-label-align-right) .ag-label{order:1}:where(.ag-ltr) :where(.ag-label-align-right) .ag-label{margin-left:var(--ag-spacing)}:where(.ag-rtl) :where(.ag-label-align-right) .ag-label{margin-right:var(--ag-spacing)}.ag-label-align-right>*{flex:none}.ag-label-align-top{align-items:flex-start;flex-direction:column;>*{align-self:stretch}}.ag-label-ellipsis{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(.ag-label-align-top) .ag-label{margin-bottom:calc(var(--ag-spacing)*.5)}`;
// packages/ag-grid-community/src/widgets/agAbstractLabel.ts
var $437b23f6a393c3bf$export$d72ea6e1c340e03b = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(config, template, components){
        super(template, components);
        this.labelSeparator = "";
        this.labelAlignment = "left";
        this.disabled = false;
        this.label = "";
        this.config = config || {};
        this.registerCSS($437b23f6a393c3bf$var$agAbstractLabelCSS);
    }
    postConstruct() {
        this.addCss("ag-labeled");
        this.eLabel.classList.add("ag-label");
        const { labelSeparator: labelSeparator, label: label, labelWidth: labelWidth, labelAlignment: labelAlignment, disabled: disabled } = this.config;
        if (disabled != null) this.setDisabled(disabled);
        if (labelSeparator != null) this.setLabelSeparator(labelSeparator);
        if (label != null) this.setLabel(label);
        if (labelWidth != null) this.setLabelWidth(labelWidth);
        this.setLabelAlignment(labelAlignment || this.labelAlignment);
        this.refreshLabel();
    }
    refreshLabel() {
        const { label: label, eLabel: eLabel } = this;
        $437b23f6a393c3bf$export$69e6e10709eabd91(eLabel);
        if (typeof label === "string") eLabel.innerText = label + this.labelSeparator;
        else if (label) eLabel.appendChild(label);
        if (label === "") {
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eLabel, false);
            $437b23f6a393c3bf$export$f8d01fa01787902(eLabel, "presentation");
        } else {
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eLabel, true);
            $437b23f6a393c3bf$export$f8d01fa01787902(eLabel, null);
        }
    }
    setLabelSeparator(labelSeparator) {
        if (this.labelSeparator === labelSeparator) return this;
        this.labelSeparator = labelSeparator;
        if (this.label != null) this.refreshLabel();
        return this;
    }
    getLabelId() {
        const eLabel = this.eLabel;
        eLabel.id = eLabel.id || `ag-${this.getCompId()}-label`;
        return eLabel.id;
    }
    getLabel() {
        return this.label;
    }
    setLabel(label) {
        if (this.label === label) return this;
        this.label = label;
        this.refreshLabel();
        return this;
    }
    setLabelAlignment(alignment) {
        const eGui = this.getGui();
        const eGuiClassList = eGui.classList;
        eGuiClassList.toggle("ag-label-align-left", alignment === "left");
        eGuiClassList.toggle("ag-label-align-right", alignment === "right");
        eGuiClassList.toggle("ag-label-align-top", alignment === "top");
        return this;
    }
    setLabelEllipsis(hasEllipsis) {
        this.eLabel.classList.toggle("ag-label-ellipsis", hasEllipsis);
        return this;
    }
    setLabelWidth(width) {
        if (this.label == null) return this;
        $437b23f6a393c3bf$var$_setElementWidth(this.eLabel, width);
        return this;
    }
    setDisabled(disabled) {
        disabled = !!disabled;
        const element = this.getGui();
        $437b23f6a393c3bf$export$b6b4f08392e9bfaf(element, disabled);
        element.classList.toggle("ag-disabled", disabled);
        this.disabled = disabled;
        return this;
    }
    isDisabled() {
        return !!this.disabled;
    }
};
// packages/ag-grid-community/src/widgets/agAbstractField.ts
var $437b23f6a393c3bf$var$AgAbstractField = class extends $437b23f6a393c3bf$export$d72ea6e1c340e03b {
    constructor(config, template, components, className){
        super(config, template, components);
        this.className = className;
    }
    postConstruct() {
        super.postConstruct();
        const { width: width, value: value, onValueChange: onValueChange } = this.config;
        if (width != null) this.setWidth(width);
        if (value != null) this.setValue(value);
        if (onValueChange != null) this.onValueChange(onValueChange);
        if (this.className) this.addCss(this.className);
        this.refreshAriaLabelledBy();
    }
    setLabel(label) {
        super.setLabel(label);
        this.refreshAriaLabelledBy();
        return this;
    }
    refreshAriaLabelledBy() {
        const ariaEl = this.getAriaElement();
        const labelId = this.getLabelId();
        const label = this.getLabel();
        if (label == null || label == "" || $437b23f6a393c3bf$var$_getAriaLabel(ariaEl) !== null) $437b23f6a393c3bf$export$84233c40c4c74001(ariaEl, "");
        else $437b23f6a393c3bf$export$84233c40c4c74001(ariaEl, labelId ?? "");
    }
    setAriaLabel(label) {
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.getAriaElement(), label);
        this.refreshAriaLabelledBy();
        return this;
    }
    onValueChange(callbackFn) {
        this.addManagedListeners(this, {
            fieldValueChanged: ()=>callbackFn(this.getValue())
        });
        return this;
    }
    getWidth() {
        return this.getGui().clientWidth;
    }
    setWidth(width) {
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.getGui(), width);
        return this;
    }
    getPreviousValue() {
        return this.previousValue;
    }
    getValue() {
        return this.value;
    }
    setValue(value, silent) {
        if (this.value === value) return this;
        this.previousValue = this.value;
        this.value = value;
        if (!silent) this.dispatchLocalEvent({
            type: "fieldValueChanged"
        });
        return this;
    }
};
// packages/ag-grid-community/src/widgets/agAbstractInputField.ts
function $437b23f6a393c3bf$var$buildTemplate(displayFieldTag) {
    return {
        tag: "div",
        role: "presentation",
        children: [
            {
                tag: "div",
                ref: "eLabel",
                cls: "ag-input-field-label"
            },
            {
                tag: "div",
                ref: "eWrapper",
                cls: "ag-wrapper ag-input-wrapper",
                role: "presentation",
                children: [
                    {
                        tag: displayFieldTag,
                        ref: "eInput",
                        cls: "ag-input-field-input"
                    }
                ]
            }
        ]
    };
}
var $437b23f6a393c3bf$export$9671f513d4aa42e3 = class extends $437b23f6a393c3bf$var$AgAbstractField {
    constructor(config, className, inputType = "text", displayFieldTag = "input"){
        super(config, config?.template ?? $437b23f6a393c3bf$var$buildTemplate(displayFieldTag), [], className);
        this.inputType = inputType;
        this.displayFieldTag = displayFieldTag;
        this.eLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eInput = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        super.postConstruct();
        this.setInputType(this.inputType);
        const { eLabel: eLabel, eWrapper: eWrapper, eInput: eInput, className: className } = this;
        eLabel.classList.add(`${className}-label`);
        eWrapper.classList.add(`${className}-input-wrapper`);
        eInput.classList.add(`${className}-input`);
        this.addCss("ag-input-field");
        eInput.id = eInput.id || `ag-${this.getCompId()}-input`;
        const { inputName: inputName, inputWidth: inputWidth } = this.config;
        if (inputName != null) this.setInputName(inputName);
        if (inputWidth != null) this.setInputWidth(inputWidth);
        this.addInputListeners();
        this.activateTabIndex([
            eInput
        ]);
    }
    addInputListeners() {
        this.addManagedElementListeners(this.eInput, {
            input: (e)=>this.setValue(e.target.value)
        });
    }
    setInputType(inputType) {
        if (this.displayFieldTag === "input") {
            this.inputType = inputType;
            $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "type", inputType);
        }
    }
    getInputElement() {
        return this.eInput;
    }
    setInputWidth(width) {
        $437b23f6a393c3bf$var$_setElementWidth(this.eWrapper, width);
        return this;
    }
    setInputName(name) {
        this.getInputElement().setAttribute("name", name);
        return this;
    }
    getFocusableElement() {
        return this.eInput;
    }
    setMaxLength(length) {
        const eInput = this.eInput;
        eInput.maxLength = length;
        return this;
    }
    setInputPlaceholder(placeholder) {
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "placeholder", placeholder);
        return this;
    }
    setInputAriaLabel(label) {
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.eInput, label);
        this.refreshAriaLabelledBy();
        return this;
    }
    setDisabled(disabled) {
        $437b23f6a393c3bf$export$b6b4f08392e9bfaf(this.eInput, disabled);
        return super.setDisabled(disabled);
    }
    setAutoComplete(value) {
        if (value === true) $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "autocomplete", null);
        else {
            const autoCompleteValue = typeof value === "string" ? value : "off";
            $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "autocomplete", autoCompleteValue);
        }
        return this;
    }
};
// packages/ag-grid-community/src/widgets/agCheckbox.ts
var $437b23f6a393c3bf$export$b00c508c1ae18d07 = class extends $437b23f6a393c3bf$export$9671f513d4aa42e3 {
    constructor(config, className = "ag-checkbox", inputType = "checkbox"){
        super(config, className, inputType);
        this.labelAlignment = "right";
        this.selected = false;
        this.readOnly = false;
        this.passive = false;
    }
    postConstruct() {
        super.postConstruct();
        const { readOnly: readOnly, passive: passive } = this.config;
        if (typeof readOnly === "boolean") this.setReadOnly(readOnly);
        if (typeof passive === "boolean") this.setPassive(passive);
    }
    addInputListeners() {
        this.addManagedElementListeners(this.eInput, {
            click: this.onCheckboxClick.bind(this)
        });
        this.addManagedElementListeners(this.eLabel, {
            click: this.toggle.bind(this)
        });
    }
    getNextValue() {
        return this.selected === void 0 ? true : !this.selected;
    }
    setPassive(passive) {
        this.passive = passive;
    }
    isReadOnly() {
        return this.readOnly;
    }
    setReadOnly(readOnly) {
        this.eWrapper.classList.toggle("ag-disabled", readOnly);
        this.eInput.disabled = readOnly;
        this.readOnly = readOnly;
    }
    setDisabled(disabled) {
        this.eWrapper.classList.toggle("ag-disabled", disabled);
        return super.setDisabled(disabled);
    }
    toggle() {
        if (this.eInput.disabled) return;
        const previousValue = this.isSelected();
        const nextValue = this.getNextValue();
        if (this.passive) this.dispatchChange(nextValue, previousValue);
        else this.setValue(nextValue);
    }
    getValue() {
        return this.isSelected();
    }
    setValue(value, silent) {
        this.refreshSelectedClass(value);
        this.setSelected(value, silent);
        return this;
    }
    setName(name) {
        const input = this.getInputElement();
        input.name = name;
        return this;
    }
    isSelected() {
        return this.selected;
    }
    setSelected(selected, silent) {
        if (this.isSelected() === selected) return;
        this.previousValue = this.isSelected();
        selected = this.selected = typeof selected === "boolean" ? selected : void 0;
        const eInput = this.eInput;
        eInput.checked = selected;
        eInput.indeterminate = selected === void 0;
        if (!silent) this.dispatchChange(this.selected, this.previousValue);
    }
    dispatchChange(selected, previousValue, event) {
        this.dispatchLocalEvent({
            type: "fieldValueChanged",
            selected: selected,
            previousValue: previousValue,
            event: event
        });
        const input = this.getInputElement();
        this.eventSvc.dispatchEvent({
            type: "checkboxChanged",
            id: input.id,
            name: input.name,
            selected: selected,
            previousValue: previousValue
        });
    }
    onCheckboxClick(e) {
        if (this.passive || this.eInput.disabled) return;
        const previousValue = this.isSelected();
        const selected = this.selected = e.target.checked;
        this.refreshSelectedClass(selected);
        this.dispatchChange(selected, previousValue, e);
    }
    refreshSelectedClass(value) {
        const classList = this.eWrapper.classList;
        classList.toggle("ag-checked", value === true);
        classList.toggle("ag-indeterminate", value == null);
    }
};
var $437b23f6a393c3bf$export$2e2c317d2e31f2ca = {
    selector: "AG-CHECKBOX",
    component: $437b23f6a393c3bf$export$b00c508c1ae18d07
};
// packages/ag-grid-community/src/rendering/cellRenderers/checkboxCellRenderer.css-GENERATED.ts
var $437b23f6a393c3bf$var$checkboxCellRendererCSS = /*css*/ `.ag-checkbox-cell{height:100%}`;
// packages/ag-grid-community/src/rendering/cellRenderers/checkboxCellRenderer.ts
var $437b23f6a393c3bf$var$CheckboxCellRendererElement = {
    tag: "div",
    cls: "ag-cell-wrapper ag-checkbox-cell",
    role: "presentation",
    children: [
        {
            tag: "ag-checkbox",
            ref: "eCheckbox",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$CheckboxCellRenderer = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$CheckboxCellRendererElement, [
            $437b23f6a393c3bf$export$2e2c317d2e31f2ca
        ]);
        this.eCheckbox = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.registerCSS($437b23f6a393c3bf$var$checkboxCellRendererCSS);
    }
    init(params) {
        this.refresh(params);
        const { eCheckbox: eCheckbox, beans: beans } = this;
        const inputEl = eCheckbox.getInputElement();
        inputEl.setAttribute("tabindex", "-1");
        $437b23f6a393c3bf$var$_setAriaLive(inputEl, "polite");
        this.addManagedListeners(inputEl, {
            click: (event)=>{
                $437b23f6a393c3bf$export$456c40e80134d72a(event);
                if (eCheckbox.isDisabled()) return;
                const isSelected = eCheckbox.getValue();
                this.onCheckboxChanged(isSelected);
            },
            dblclick: (event)=>{
                $437b23f6a393c3bf$export$456c40e80134d72a(event);
            }
        });
        this.addManagedElementListeners(params.eGridCell, {
            keydown: (event)=>{
                if (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE && !eCheckbox.isDisabled()) {
                    if (params.eGridCell === $437b23f6a393c3bf$export$16bc98d422315038(beans)) eCheckbox.toggle();
                    const isSelected = eCheckbox.getValue();
                    this.onCheckboxChanged(isSelected);
                    event.preventDefault();
                }
            }
        });
    }
    refresh(params) {
        this.params = params;
        this.updateCheckbox(params);
        return true;
    }
    updateCheckbox(params) {
        let isSelected;
        let displayed = true;
        const { value: value, column: column, node: node } = params;
        if (node.group && column) {
            if (typeof value === "boolean") isSelected = value;
            else {
                const colId = column.getColId();
                if (colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6)) isSelected = value == null || value === "" ? void 0 : value === "true";
                else if (node.aggData && node.aggData[colId] !== void 0) isSelected = value ?? void 0;
                else displayed = false;
            }
        } else isSelected = value ?? void 0;
        const { eCheckbox: eCheckbox } = this;
        if (!displayed) {
            eCheckbox.setDisplayed(false);
            return;
        }
        eCheckbox.setValue(isSelected);
        const disabled = params.disabled ?? !column?.isCellEditable(node);
        eCheckbox.setDisabled(disabled);
        const translate = this.getLocaleTextFunc();
        const stateName = $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, isSelected);
        const ariaLabel = disabled ? stateName : `${translate("ariaToggleCellValue", "Press SPACE to toggle cell value")} (${stateName})`;
        eCheckbox.setInputAriaLabel(ariaLabel);
    }
    onCheckboxChanged(isSelected) {
        const { params: params } = this;
        const { column: column, node: node, value: value } = params;
        this.beans?.editSvc?.setEditingCells([
            {
                column: column,
                colId: column.getColId(),
                rowIndex: node.rowIndex,
                rowPinned: node.rowPinned,
                state: "changed",
                oldValue: value,
                newValue: value
            }
        ], {
            update: true
        });
        const valueChanged = node.setDataValue(column, isSelected, "renderer");
        this.beans.editSvc?.stopEditing({
            rowNode: node,
            column: column
        }, {
            source: this.beans.editSvc?.isBatchEditing() ? "ui" : "api"
        });
        if (!valueChanged) this.updateCheckbox(params);
    }
};
// packages/ag-grid-community/src/pinnedRowModel/manualPinnedRowUtils.ts
var $437b23f6a393c3bf$var$PinnedRows = class {
    constructor(beans, floating){
        this.beans = beans;
        this.floating = floating;
        /** Canonical set of pinned nodes */ this.all = /* @__PURE__ */ new Set();
        /**
     * Set of nodes that should currently be visible given the context of the grid.
     * This is currently used for hiding leaf nodes in pivot mode and filtered nodes.
     */ this.visible = /* @__PURE__ */ new Set();
        /** Ordering of nodes in the pinned area */ this.order = [];
        /** IDs of nodes that need to be pinned once they are available from the row model (SSRM) */ this.queued = /* @__PURE__ */ new Set();
    }
    size() {
        return this.visible.size;
    }
    add(node) {
        const { all: all, visible: visible, order: order } = this;
        if (all.has(node)) return;
        all.add(node);
        visible.add(node);
        order.push(node);
        this.sort();
    }
    delete(item) {
        this.all.delete(item);
        this.visible.delete(item);
        this.queued.delete(item.id);
        $437b23f6a393c3bf$export$83a881c8b5120679(this.order, item);
    }
    has(item) {
        return this.visible.has(item);
    }
    forEach(fn) {
        this.order.forEach(fn);
    }
    getByIndex(i) {
        return this.order[i];
    }
    getById(id) {
        for (const node of this.visible){
            if (node.id == id) return node;
        }
    }
    clear() {
        const { all: all, visible: visible, order: order, queued: queued } = this;
        all.clear();
        queued.clear();
        visible.clear();
        order.length = 0;
    }
    sort() {
        const { sortSvc: sortSvc, rowNodeSorter: rowNodeSorter, gos: gos } = this.beans;
        const sortOptions = sortSvc?.getSortOptions() ?? [];
        const grandTotalNode = $437b23f6a393c3bf$var$_removeGrandTotalRow(this.order);
        this.order.sort((a, b)=>(a.pinnedSibling?.rowIndex ?? 0) - (b.pinnedSibling?.rowIndex ?? 0));
        this.order = rowNodeSorter?.doFullSort(this.order, sortOptions) ?? this.order;
        if (!grandTotalNode) return;
        const grandTotalRow = $437b23f6a393c3bf$export$c6fad27ed643a862(gos);
        if (grandTotalRow === "bottom" || grandTotalRow === "pinnedBottom") this.order.push(grandTotalNode);
        else this.order.unshift(grandTotalNode);
    }
    hide(shouldHide) {
        const { all: all, visible: visible } = this;
        all.forEach((node)=>shouldHide(node) ? visible.delete(node) : visible.add(node));
        this.order = Array.from(visible);
        this.sort();
    }
    queue(id) {
        this.queued.add(id);
    }
    unqueue(id) {
        this.queued.delete(id);
    }
    forEachQueued(fn) {
        this.queued.forEach(fn);
    }
};
function $437b23f6a393c3bf$var$_isDisplayedAfterFilterCSRM(node) {
    if (node.level === -1) return true;
    const parent = node.parent;
    if (parent?.childrenAfterSort?.some((child)=>child == node)) return $437b23f6a393c3bf$var$_isDisplayedAfterFilterCSRM(parent);
    return false;
}
function $437b23f6a393c3bf$var$_shouldHidePinnedRows(beans, node) {
    const { gos: gos, rowModel: rowModel, filterManager: filterManager } = beans;
    if ($437b23f6a393c3bf$export$cf1bac0013650216(gos, rowModel)) return !rowModel.getRowNode(node.id);
    if (filterManager?.isAnyFilterPresent()) return !$437b23f6a393c3bf$var$_isDisplayedAfterFilterCSRM(node);
    if (gos.get("pivotMode")) return !node.group;
    return false;
}
function $437b23f6a393c3bf$var$_isNodeGrandTotal(node) {
    return !!node.footer && node.level === -1;
}
function $437b23f6a393c3bf$var$_isPinnedNodeGrandTotal(node) {
    return !!node.pinnedSibling && $437b23f6a393c3bf$var$_isNodeGrandTotal(node.pinnedSibling);
}
function $437b23f6a393c3bf$var$_removeGrandTotalRow(order) {
    const index = order.findIndex($437b23f6a393c3bf$var$_isPinnedNodeGrandTotal);
    if (index > -1) return order.splice(index, 1)?.[0];
}
// packages/ag-grid-community/src/pinnedRowModel/manualPinnedRowModel.ts
var $437b23f6a393c3bf$var$ManualPinnedRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        const { gos: gos, beans: beans } = this;
        this.top = new $437b23f6a393c3bf$var$PinnedRows(beans, "top");
        this.bottom = new $437b23f6a393c3bf$var$PinnedRows(beans, "bottom");
        const shouldHide = (node)=>$437b23f6a393c3bf$var$_shouldHidePinnedRows(beans, node.pinnedSibling);
        const runIsRowPinned = ()=>{
            const isRowPinned = gos.get("isRowPinned");
            if (isRowPinned && gos.get("enableRowPinning")) beans.rowModel.forEachNode((node)=>this.pinRow(node, isRowPinned(node)), true);
            this.refreshRowPositions();
            this.dispatchRowPinnedEvents();
        };
        this.addManagedEventListeners({
            gridStylesChanged: this.onGridStylesChanges.bind(this),
            modelUpdated: ({ keepRenderedRows: keepRenderedRows })=>{
                this.tryToEmptyQueues();
                this.pinGrandTotalRow();
                this.forContainers((container)=>container.hide(shouldHide));
                this.refreshRowPositions();
                if (!keepRenderedRows) this.dispatchRowPinnedEvents();
            },
            columnRowGroupChanged: ()=>{
                this.forContainers($437b23f6a393c3bf$var$removeGroupRows);
                this.refreshRowPositions();
            },
            rowNodeDataChanged: ({ node: node })=>{
                const isRowPinnable = gos.get("isRowPinnable");
                const pinnable = isRowPinnable?.(node) ?? true;
                if (!pinnable) this.pinRow(node, null);
            },
            firstDataRendered: runIsRowPinned
        });
        this.addManagedPropertyListener("pivotMode", ()=>{
            this.forContainers((container)=>container.hide(shouldHide));
            this.dispatchRowPinnedEvents();
        });
        this.addManagedPropertyListener("grandTotalRow", ({ currentValue: currentValue })=>{
            this._grandTotalPinned = currentValue === "pinnedBottom" ? "bottom" : currentValue === "pinnedTop" ? "top" : null;
        });
        this.addManagedPropertyListener("isRowPinned", runIsRowPinned);
    }
    destroy() {
        this.reset(false);
        super.destroy();
    }
    reset(dispatch = true) {
        this.forContainers((container)=>{
            const nodesToUnpin = [];
            container.forEach((n)=>nodesToUnpin.push(n));
            nodesToUnpin.forEach((n)=>this.pinRow(n, null));
            container.clear();
        });
        if (dispatch) this.dispatchRowPinnedEvents();
    }
    pinRow(rowNode, float, column) {
        if (rowNode.footer && rowNode.level > -1) return;
        if (rowNode.footer && rowNode.level === -1) {
            this._grandTotalPinned = float;
            $437b23f6a393c3bf$var$refreshCSRM(this.beans);
            return;
        }
        const currentFloat = rowNode.rowPinned ?? rowNode.pinnedSibling?.rowPinned;
        const switching = currentFloat != null && float != null && float != currentFloat;
        if (switching) {
            const pinned = rowNode.rowPinned ? rowNode : rowNode.pinnedSibling;
            const source = rowNode.rowPinned ? rowNode.pinnedSibling : rowNode;
            this.pinRow(pinned, null, column);
            this.pinRow(source, float, column);
            return;
        }
        const spannedRows = column && $437b23f6a393c3bf$var$getSpannedRows(this.beans, rowNode, column);
        if (spannedRows) {
            spannedRows.forEach((node)=>this.pinRow(node, float));
            return;
        }
        if (float == null) {
            const node = rowNode.rowPinned ? rowNode : rowNode.pinnedSibling;
            const found = this.findPinnedRowNode(node);
            if (!found) return;
            found.delete(node);
            const source = node.pinnedSibling;
            $437b23f6a393c3bf$var$_destroyRowNodeSibling(node);
            this.refreshRowPositions(float);
            this.dispatchRowPinnedEvents(source);
        } else {
            const sibling = $437b23f6a393c3bf$var$_createPinnedSibling(this.beans, rowNode, float);
            const container = this.getContainer(float);
            container.add(sibling);
            if ($437b23f6a393c3bf$var$_shouldHidePinnedRows(this.beans, rowNode)) container.hide((node)=>$437b23f6a393c3bf$var$_shouldHidePinnedRows(this.beans, node.pinnedSibling));
            this.refreshRowPositions(float);
            this.dispatchRowPinnedEvents(rowNode);
        }
    }
    isManual() {
        return true;
    }
    isEmpty(floating) {
        return this.getContainer(floating).size() === 0;
    }
    isRowsToRender(floating) {
        return !this.isEmpty(floating);
    }
    ensureRowHeightsValid() {
        let anyChange = false;
        let rowTop = 0;
        const updateRowHeight = (rowNode)=>{
            if (rowNode.rowHeightEstimated) {
                const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, rowNode);
                rowNode.setRowTop(rowTop);
                rowNode.setRowHeight(rowHeight.height);
                rowTop += rowHeight.height;
                anyChange = true;
            }
        };
        this.bottom.forEach(updateRowHeight);
        rowTop = 0;
        this.top.forEach(updateRowHeight);
        this.eventSvc.dispatchEvent({
            type: "pinnedHeightChanged"
        });
        return anyChange;
    }
    getPinnedTopTotalHeight() {
        return $437b23f6a393c3bf$var$getTotalHeight(this.top);
    }
    getPinnedBottomTotalHeight() {
        return $437b23f6a393c3bf$var$getTotalHeight(this.bottom);
    }
    getPinnedTopRowCount() {
        return this.top.size();
    }
    getPinnedBottomRowCount() {
        return this.bottom.size();
    }
    getPinnedTopRow(index) {
        return this.top.getByIndex(index);
    }
    getPinnedBottomRow(index) {
        return this.bottom.getByIndex(index);
    }
    getPinnedRowById(id, floating) {
        return this.getContainer(floating).getById(id);
    }
    forEachPinnedRow(floating, callback) {
        this.getContainer(floating).forEach(callback);
    }
    getPinnedState() {
        const buildState = (floating)=>{
            const list = [];
            this.forEachPinnedRow(floating, (node)=>list.push(node.pinnedSibling.id));
            return list;
        };
        return {
            top: buildState("top"),
            bottom: buildState("bottom")
        };
    }
    setPinnedState(state) {
        this.forContainers((pinned, floating)=>{
            for (const id of state[floating]){
                const node = this.beans.rowModel.getRowNode(id);
                if (node) this.pinRow(node, floating);
                else pinned.queue(id);
            }
        });
    }
    getGrandTotalPinned() {
        return this._grandTotalPinned;
    }
    setGrandTotalPinned(value) {
        this._grandTotalPinned = value;
    }
    tryToEmptyQueues() {
        this.forContainers((pinned, container)=>{
            const nodesToPin = /* @__PURE__ */ new Set();
            pinned.forEachQueued((id)=>{
                const node = this.beans.rowModel.getRowNode(id);
                if (node) nodesToPin.add(node);
            });
            for (const node of nodesToPin){
                pinned.unqueue(node.id);
                this.pinRow(node, container);
            }
        });
    }
    pinGrandTotalRow() {
        const { gos: gos, beans: beans, _grandTotalPinned: float } = this;
        const rowModel = beans.rowModel;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) return;
        const sibling = rowModel.rootNode?.sibling;
        if (!sibling) return;
        const pinnedSibling = sibling.pinnedSibling;
        const container = pinnedSibling && this.findPinnedRowNode(pinnedSibling);
        if (!float) {
            if (!container) return;
            container.delete(pinnedSibling);
            $437b23f6a393c3bf$var$_destroyRowNodeSibling(pinnedSibling);
        } else {
            if (container && container.floating !== float) {
                container.delete(pinnedSibling);
                $437b23f6a393c3bf$var$_destroyRowNodeSibling(pinnedSibling);
            }
            if (!container || container.floating !== float) {
                const newPinnedSibling = $437b23f6a393c3bf$var$_createPinnedSibling(beans, sibling, float);
                this.getContainer(float).add(newPinnedSibling);
            }
        }
    }
    onGridStylesChanges(e) {
        if (e.rowHeightChanged) this.forContainers((container)=>container.forEach((rowNode)=>rowNode.setRowHeight(rowNode.rowHeight, true)));
    }
    getContainer(floating) {
        return floating === "top" ? this.top : this.bottom;
    }
    findPinnedRowNode(node) {
        if (this.top.has(node)) return this.top;
        if (this.bottom.has(node)) return this.bottom;
    }
    refreshRowPositions(floating) {
        const refreshAll = (pinned)=>$437b23f6a393c3bf$var$refreshRowPositions(this.beans, pinned);
        return floating == null ? this.forContainers(refreshAll) : refreshAll(this.getContainer(floating));
    }
    forContainers(fn) {
        fn(this.top, "top");
        fn(this.bottom, "bottom");
    }
    dispatchRowPinnedEvents(node) {
        this.eventSvc.dispatchEvent({
            type: "pinnedRowsChanged"
        });
        node?.dispatchRowEvent("rowPinned");
    }
};
function $437b23f6a393c3bf$var$refreshRowPositions(beans, container) {
    let rowTop = 0;
    container.forEach((node, index)=>{
        node.setRowTop(rowTop);
        if (node.rowHeightEstimated || node.rowHeight == null) node.setRowHeight($437b23f6a393c3bf$export$b6de5fa3decc8f7b(beans, node).height);
        node.setRowIndex(index);
        rowTop += node.rowHeight;
    });
}
function $437b23f6a393c3bf$var$_createPinnedSibling(beans, rowNode, floating) {
    if (rowNode.pinnedSibling) return rowNode.pinnedSibling;
    const sibling = $437b23f6a393c3bf$export$48fabbbfcde9fe36(rowNode, beans);
    sibling.setRowTop(null);
    sibling.setRowIndex(null);
    sibling.rowPinned = floating;
    const prefix = floating === "top" ? $437b23f6a393c3bf$export$27b0e4a919abc336 : $437b23f6a393c3bf$export$5f755686e611c1ea;
    sibling.id = `${prefix}${floating}-${rowNode.id}`;
    sibling.pinnedSibling = rowNode;
    rowNode.pinnedSibling = sibling;
    return sibling;
}
function $437b23f6a393c3bf$var$_destroyRowNodeSibling(rowNode) {
    if (!rowNode.pinnedSibling) return;
    rowNode.rowPinned = null;
    rowNode.setRowTop(null);
    rowNode.setRowIndex(null);
    const mainNode = rowNode.pinnedSibling;
    rowNode.pinnedSibling = void 0;
    if (mainNode) {
        mainNode.pinnedSibling = void 0;
        mainNode.rowPinned = null;
    }
}
function $437b23f6a393c3bf$var$removeGroupRows(set) {
    const rowsToRemove = /* @__PURE__ */ new Set();
    set.forEach((node)=>{
        if (node.group) rowsToRemove.add(node);
    });
    rowsToRemove.forEach((node)=>set.delete(node));
}
function $437b23f6a393c3bf$var$getSpannedRows(beans, rowNode, column) {
    const { rowSpanSvc: rowSpanSvc } = beans;
    const isCellSpanning = (column && rowSpanSvc?.isCellSpanning(column, rowNode)) ?? false;
    if (column && isCellSpanning) return rowSpanSvc?.getCellSpan(column, rowNode)?.spannedNodes;
}
function $437b23f6a393c3bf$var$getTotalHeight(container) {
    const size = container.size();
    if (size === 0) return 0;
    const node = container.getByIndex(size - 1);
    if (node === void 0) return 0;
    return node.rowTop + node.rowHeight;
}
function $437b23f6a393c3bf$var$refreshCSRM({ gos: gos, rowModel: rowModel }) {
    if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) rowModel.refreshModel({
        step: "map"
    });
}
// packages/ag-grid-community/src/pinnedRowModel/staticPinnedRowModel.ts
var $437b23f6a393c3bf$var$StaticPinnedRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.nextId = 0;
        this.pinnedTopRows = {
            cache: {},
            order: []
        };
        this.pinnedBottomRows = {
            cache: {},
            order: []
        };
    }
    postConstruct() {
        const gos = this.gos;
        this.setPinnedRowData(gos.get("pinnedTopRowData"), "top");
        this.setPinnedRowData(gos.get("pinnedBottomRowData"), "bottom");
        this.addManagedPropertyListener("pinnedTopRowData", (e)=>this.setPinnedRowData(e.currentValue, "top"));
        this.addManagedPropertyListener("pinnedBottomRowData", (e)=>this.setPinnedRowData(e.currentValue, "bottom"));
        this.addManagedEventListeners({
            gridStylesChanged: this.onGridStylesChanges.bind(this)
        });
    }
    reset() {}
    isEmpty(floating) {
        return this.getCache(floating).order.length === 0;
    }
    isRowsToRender(floating) {
        return !this.isEmpty(floating);
    }
    isManual() {
        return false;
    }
    pinRow(_node, _container) {}
    onGridStylesChanges(e) {
        if (e.rowHeightChanged) {
            const estimateRowHeight = (rowNode)=>{
                rowNode.setRowHeight(rowNode.rowHeight, true);
            };
            $437b23f6a393c3bf$var$forEach(this.pinnedBottomRows, estimateRowHeight);
            $437b23f6a393c3bf$var$forEach(this.pinnedTopRows, estimateRowHeight);
        }
    }
    ensureRowHeightsValid() {
        let anyChange = false;
        let rowTop = 0;
        const updateRowHeight = (rowNode)=>{
            if (rowNode.rowHeightEstimated) {
                const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, rowNode);
                rowNode.setRowTop(rowTop);
                rowNode.setRowHeight(rowHeight.height);
                rowTop += rowHeight.height;
                anyChange = true;
            }
        };
        $437b23f6a393c3bf$var$forEach(this.pinnedBottomRows, updateRowHeight);
        rowTop = 0;
        $437b23f6a393c3bf$var$forEach(this.pinnedTopRows, updateRowHeight);
        this.eventSvc.dispatchEvent({
            type: "pinnedHeightChanged"
        });
        return anyChange;
    }
    setPinnedRowData(rowData, floating) {
        this.updateNodesFromRowData(rowData, floating);
        this.eventSvc.dispatchEvent({
            type: "pinnedRowDataChanged"
        });
    }
    /**
   * Updates existing RowNode instances and creates new ones if necessary
   *
   * Setting data as `undefined` will clear row nodes
   */ updateNodesFromRowData(allData, floating) {
        const nodes = this.getCache(floating);
        if (allData === void 0) {
            nodes.order.length = 0;
            nodes.cache = {};
            return;
        }
        const getRowId = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        const idPrefix = floating === "top" ? $437b23f6a393c3bf$export$27b0e4a919abc336 : $437b23f6a393c3bf$export$5f755686e611c1ea;
        const nodesToRemove = new Set(nodes.order);
        const newOrder = [];
        const dataIds = /* @__PURE__ */ new Set();
        let nextRowTop = 0;
        let i = -1;
        for (const data of allData){
            const id = getRowId?.({
                data: data,
                level: 0,
                rowPinned: floating
            }) ?? idPrefix + this.nextId++;
            if (dataIds.has(id)) {
                $437b23f6a393c3bf$export$545083624300f13d(96, {
                    id: id,
                    data: data
                });
                continue;
            }
            i++;
            dataIds.add(id);
            newOrder.push(id);
            const existingNode = $437b23f6a393c3bf$var$getById(nodes, id);
            if (existingNode !== void 0) {
                if (existingNode.data !== data) existingNode.updateData(data);
                nextRowTop += this.setRowTopAndRowIndex(existingNode, nextRowTop, i);
                nodesToRemove.delete(id);
            } else {
                const rowNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
                rowNode.id = id;
                rowNode.data = data;
                rowNode.rowPinned = floating;
                nextRowTop += this.setRowTopAndRowIndex(rowNode, nextRowTop, i);
                nodes.cache[id] = rowNode;
                nodes.order.push(id);
            }
        }
        nodesToRemove.forEach((id)=>{
            $437b23f6a393c3bf$var$getById(nodes, id)?.clearRowTopAndRowIndex();
            delete nodes.cache[id];
        });
        nodes.order = newOrder;
    }
    setRowTopAndRowIndex(rowNode, rowTop, rowIndex) {
        rowNode.setRowTop(rowTop);
        rowNode.setRowHeight($437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, rowNode).height);
        rowNode.setRowIndex(rowIndex);
        return rowNode.rowHeight;
    }
    getPinnedTopTotalHeight() {
        return $437b23f6a393c3bf$var$getTotalHeight2(this.pinnedTopRows);
    }
    getPinnedBottomTotalHeight() {
        return $437b23f6a393c3bf$var$getTotalHeight2(this.pinnedBottomRows);
    }
    getPinnedTopRowCount() {
        return $437b23f6a393c3bf$var$getSize(this.pinnedTopRows);
    }
    getPinnedBottomRowCount() {
        return $437b23f6a393c3bf$var$getSize(this.pinnedBottomRows);
    }
    getPinnedTopRow(index) {
        return $437b23f6a393c3bf$var$getByIndex(this.pinnedTopRows, index);
    }
    getPinnedBottomRow(index) {
        return $437b23f6a393c3bf$var$getByIndex(this.pinnedBottomRows, index);
    }
    getPinnedRowById(id, floating) {
        return $437b23f6a393c3bf$var$getById(this.getCache(floating), id);
    }
    forEachPinnedRow(floating, callback) {
        return $437b23f6a393c3bf$var$forEach(this.getCache(floating), callback);
    }
    getCache(floating) {
        return floating === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
    }
    getPinnedState() {
        return {
            top: [],
            bottom: []
        };
    }
    setPinnedState() {}
    getGrandTotalPinned() {
        return;
    }
    setGrandTotalPinned() {}
};
function $437b23f6a393c3bf$var$getTotalHeight2(rowNodes) {
    const size = $437b23f6a393c3bf$var$getSize(rowNodes);
    if (size === 0) return 0;
    const node = $437b23f6a393c3bf$var$getByIndex(rowNodes, size - 1);
    if (node === void 0) return 0;
    return node.rowTop + node.rowHeight;
}
function $437b23f6a393c3bf$var$getById(cache, id) {
    return cache.cache[id];
}
function $437b23f6a393c3bf$var$getByIndex(cache, i) {
    return $437b23f6a393c3bf$var$getById(cache, cache.order[i]);
}
function $437b23f6a393c3bf$var$forEach(cache, callback) {
    cache.order.forEach((id, index)=>{
        const node = $437b23f6a393c3bf$var$getById(cache, id);
        node && callback(node, index);
    });
}
function $437b23f6a393c3bf$var$getSize(cache) {
    return cache.order.length;
}
// packages/ag-grid-community/src/pinnedRowModel/pinnedRowModel.ts
var $437b23f6a393c3bf$export$d44126a5f53c99d9 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pinnedRowModel";
    }
    postConstruct() {
        const { gos: gos } = this;
        const initialiseRowModel = ()=>{
            const enableRowPinning = gos.get("enableRowPinning");
            const grandTotalRow = $437b23f6a393c3bf$export$c6fad27ed643a862(gos);
            const isGrandTotalRowPinned = grandTotalRow === "pinnedBottom" || grandTotalRow === "pinnedTop";
            const useManualPinnedRowModel = !!enableRowPinning || isGrandTotalRowPinned;
            const shouldDestroy = useManualPinnedRowModel ? this.inner instanceof $437b23f6a393c3bf$var$StaticPinnedRowModel : this.inner instanceof $437b23f6a393c3bf$var$ManualPinnedRowModel;
            if (this.inner && shouldDestroy) this.destroyBean(this.inner);
            if (shouldDestroy || !this.inner) this.inner = this.createManagedBean(useManualPinnedRowModel ? new $437b23f6a393c3bf$var$ManualPinnedRowModel() : new $437b23f6a393c3bf$var$StaticPinnedRowModel());
        };
        this.addManagedPropertyListeners([
            "enableRowPinning",
            "grandTotalRow"
        ], initialiseRowModel);
        initialiseRowModel();
    }
    reset() {
        return this.inner.reset();
    }
    isEmpty(container) {
        return this.inner.isEmpty(container);
    }
    isManual() {
        return this.inner.isManual();
    }
    isRowsToRender(container) {
        return this.inner.isRowsToRender(container);
    }
    pinRow(node, container, column) {
        return this.inner.pinRow(node, container, column);
    }
    ensureRowHeightsValid() {
        return this.inner.ensureRowHeightsValid();
    }
    getPinnedRowById(id, container) {
        return this.inner.getPinnedRowById(id, container);
    }
    getPinnedTopTotalHeight() {
        return this.inner.getPinnedTopTotalHeight();
    }
    getPinnedBottomTotalHeight() {
        return this.inner.getPinnedBottomTotalHeight();
    }
    getPinnedTopRowCount() {
        return this.inner.getPinnedTopRowCount();
    }
    getPinnedBottomRowCount() {
        return this.inner.getPinnedBottomRowCount();
    }
    getPinnedTopRow(index) {
        return this.inner.getPinnedTopRow(index);
    }
    getPinnedBottomRow(index) {
        return this.inner.getPinnedBottomRow(index);
    }
    forEachPinnedRow(container, callback) {
        return this.inner.forEachPinnedRow(container, callback);
    }
    getPinnedState() {
        return this.inner.getPinnedState();
    }
    setPinnedState(state) {
        return this.inner.setPinnedState(state);
    }
    setGrandTotalPinned(value) {
        return this.inner.setGrandTotalPinned(value);
    }
    getGrandTotalPinned() {
        return this.inner.getGrandTotalPinned();
    }
};
// packages/ag-grid-community/src/clientSideRowModel/abstractClientSideNodeManager.ts
var $437b23f6a393c3bf$var$ROOT_NODE_ID = "ROOT_NODE_ID";
var $437b23f6a393c3bf$export$4d7e4be6cbba058c = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.nextId = 0;
        this.allNodesMap = {};
        this.rootNode = null;
    }
    getRowNode(id) {
        return this.allNodesMap[id];
    }
    extractRowData() {
        return this.rootNode?.allLeafChildren?.map((node)=>node.data);
    }
    activate(rootNode) {
        this.rootNode = rootNode;
        rootNode.group = true;
        rootNode.level = -1;
        rootNode.id = $437b23f6a393c3bf$var$ROOT_NODE_ID;
        rootNode.allLeafChildren = [];
        rootNode.childrenAfterGroup = [];
        rootNode.childrenAfterSort = [];
        rootNode.childrenAfterAggFilter = [];
        rootNode.childrenAfterFilter = [];
        this.updateRootSiblingArrays(rootNode);
    }
    deactivate() {
        if (this.rootNode) {
            this.allNodesMap = {};
            this.rootNode = null;
        }
    }
    destroy() {
        super.destroy();
        this.allNodesMap = {};
        this.rootNode = null;
    }
    setNewRowData(rowData) {
        const rootNode = this.rootNode;
        if (!rootNode) return;
        this.dispatchRowDataUpdateStartedEvent(rowData);
        rootNode.childrenAfterFilter = null;
        rootNode.childrenAfterGroup = null;
        rootNode.childrenAfterAggFilter = null;
        rootNode.childrenAfterSort = null;
        rootNode.childrenMapped = null;
        rootNode.updateHasChildren();
        this.allNodesMap = {};
        this.nextId = 0;
        this.loadNewRowData(rowData);
        this.updateRootSiblingArrays(rootNode);
    }
    updateRootSiblingArrays(rootNode) {
        const sibling = rootNode.sibling;
        if (sibling) {
            sibling.childrenAfterFilter = rootNode.childrenAfterFilter;
            sibling.childrenAfterGroup = rootNode.childrenAfterGroup;
            sibling.childrenAfterAggFilter = rootNode.childrenAfterAggFilter;
            sibling.childrenAfterSort = rootNode.childrenAfterSort;
            sibling.childrenMapped = rootNode.childrenMapped;
            sibling.allLeafChildren = rootNode.allLeafChildren;
        }
    }
    loadNewRowData(rowData) {
        this.rootNode.allLeafChildren = rowData?.map((dataItem, index)=>this.createRowNode(dataItem, index)) ?? [];
    }
    setImmutableRowData(params, rowData) {
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        const reorder = !this.gos.get("suppressMaintainUnsortedOrder");
        const changedRowNodes = params.changedRowNodes;
        const processedNodes = /* @__PURE__ */ new Set();
        const rootNode = this.rootNode;
        const oldAllLeafChildren = rootNode.allLeafChildren;
        const oldAllLeafChildrenLen = oldAllLeafChildren.length;
        let nodesAdded = false;
        let nodesRemoved = false;
        let nodesUpdated = false;
        let orderChanged = false;
        for(let i = 0, prevSourceRowIndex = -1, len = rowData.length; i < len; i++){
            const data = rowData[i];
            let node = this.getRowNode(getRowIdFunc({
                data: data,
                level: 0
            }));
            if (!node) {
                nodesAdded = true;
                node = this.createRowNode(data, -1);
                changedRowNodes.add(node);
            } else {
                if (reorder) {
                    const sourceRowIndex = node.sourceRowIndex;
                    orderChanged || (orderChanged = sourceRowIndex <= prevSourceRowIndex || // A node was moved up, so order changed
                    nodesAdded);
                    prevSourceRowIndex = sourceRowIndex;
                }
                if (node.data !== data) {
                    nodesUpdated = true;
                    node.updateData(data);
                    changedRowNodes.update(node);
                }
            }
            processedNodes.add(node);
        }
        const nodesToUnselect = [];
        for(let i = 0; i < oldAllLeafChildrenLen; i++){
            const node = oldAllLeafChildren[i];
            if (!processedNodes.has(node)) {
                nodesRemoved = true;
                if (node.isSelected()) nodesToUnselect.push(node);
                if (node.pinnedSibling) this.beans.pinnedRowModel?.pinRow(node.pinnedSibling, null);
                this.rowNodeDeleted(node);
                changedRowNodes.remove(node);
            }
        }
        if (nodesAdded || nodesRemoved || orderChanged) {
            const newAllLeafChildren = new Array(processedNodes.size);
            let writeIdx = 0;
            if (!reorder) for(let i = 0; i < oldAllLeafChildrenLen; ++i){
                const node = oldAllLeafChildren[i];
                if (processedNodes.delete(node)) {
                    node.sourceRowIndex = writeIdx;
                    newAllLeafChildren[writeIdx++] = node;
                }
            }
            for (const node of processedNodes){
                node.sourceRowIndex = writeIdx;
                newAllLeafChildren[writeIdx++] = node;
            }
            rootNode.allLeafChildren = newAllLeafChildren;
            const sibling = rootNode.sibling;
            if (sibling) sibling.allLeafChildren = newAllLeafChildren;
            params.rowNodesOrderChanged || (params.rowNodesOrderChanged = orderChanged);
        }
        if (nodesAdded || nodesRemoved || orderChanged || nodesUpdated) {
            this.deselectNodes(nodesToUnselect);
            params.rowDataUpdated = true;
        }
    }
    /** Called when a node needs to be deleted */ rowNodeDeleted(node) {
        node.clearRowTopAndRowIndex();
        const id = node.id;
        const allNodesMap = this.allNodesMap;
        if (allNodesMap[id] === node) delete allNodesMap[id];
    }
    updateRowData(rowDataTran, changedRowNodes) {
        this.dispatchRowDataUpdateStartedEvent(rowDataTran.add);
        const updateRowDataResult = {
            changedRowNodes: changedRowNodes,
            rowNodeTransaction: {
                remove: [],
                update: [],
                add: []
            },
            rowsInserted: false
        };
        const nodesToUnselect = [];
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        this.executeRemove(getRowIdFunc, rowDataTran, updateRowDataResult, nodesToUnselect);
        this.executeUpdate(getRowIdFunc, rowDataTran, updateRowDataResult, nodesToUnselect);
        this.executeAdd(rowDataTran, updateRowDataResult);
        this.deselectNodes(nodesToUnselect);
        return updateRowDataResult;
    }
    executeAdd(rowDataTran, result) {
        const add = rowDataTran.add;
        if (!add?.length) return;
        let allLeafChildren = this.rootNode.allLeafChildren;
        let addIndex = allLeafChildren.length;
        if (typeof rowDataTran.addIndex === "number") {
            addIndex = this.sanitizeAddIndex(rowDataTran.addIndex);
            if (addIndex > 0) {
                const getDataPath = this.gos.get("treeData") && this.gos.get("getDataPath");
                if (getDataPath) for(let i = 0; i < allLeafChildren.length; i++){
                    const node = allLeafChildren[i];
                    if (node?.rowIndex == addIndex - 1) {
                        addIndex = i + 1;
                        break;
                    }
                }
            }
        }
        const addLength = add.length;
        const changedRowNodes = result.changedRowNodes;
        const newNodes = new Array(addLength);
        for(let i = 0; i < addLength; i++){
            const newNode = this.createRowNode(add[i], addIndex + i);
            changedRowNodes.add(newNode);
            newNodes[i] = newNode;
        }
        const rootNode = this.rootNode;
        if (addIndex < allLeafChildren.length) {
            const nodesBeforeIndex = allLeafChildren.slice(0, addIndex);
            const nodesAfterIndex = allLeafChildren.slice(addIndex, allLeafChildren.length);
            const nodesAfterIndexFirstIndex = nodesBeforeIndex.length + newNodes.length;
            for(let index = 0, length = nodesAfterIndex.length; index < length; ++index)nodesAfterIndex[index].sourceRowIndex = nodesAfterIndexFirstIndex + index;
            allLeafChildren = [
                ...nodesBeforeIndex,
                ...newNodes,
                ...nodesAfterIndex
            ];
            result.rowsInserted = true;
        } else allLeafChildren = allLeafChildren.concat(newNodes);
        rootNode.allLeafChildren = allLeafChildren;
        const sibling = rootNode.sibling;
        if (sibling) sibling.allLeafChildren = allLeafChildren;
        result.rowNodeTransaction.add = newNodes;
    }
    executeRemove(getRowIdFunc, rowDataTran, { changedRowNodes: changedRowNodes, rowNodeTransaction: rowNodeTransaction }, nodesToUnselect) {
        const { remove: remove } = rowDataTran;
        if (!remove?.length) return;
        const rowIdsRemoved = {};
        remove.forEach((item)=>{
            const rowNode = this.lookupRowNode(getRowIdFunc, item);
            if (!rowNode) return;
            if (rowNode.isSelected()) nodesToUnselect.push(rowNode);
            if (rowNode.pinnedSibling) this.beans.pinnedRowModel?.pinRow(rowNode.pinnedSibling, null);
            rowNode.clearRowTopAndRowIndex();
            rowIdsRemoved[rowNode.id] = true;
            delete this.allNodesMap[rowNode.id];
            rowNodeTransaction.remove.push(rowNode);
            changedRowNodes.remove(rowNode);
        });
        const rootNode = this.rootNode;
        rootNode.allLeafChildren = rootNode.allLeafChildren?.filter((rowNode)=>!rowIdsRemoved[rowNode.id]) ?? null;
        rootNode.allLeafChildren?.forEach((node, idx)=>{
            node.sourceRowIndex = idx;
        });
        const sibling = rootNode.sibling;
        if (sibling) sibling.allLeafChildren = rootNode.allLeafChildren;
    }
    executeUpdate(getRowIdFunc, rowDataTran, { changedRowNodes: changedRowNodes, rowNodeTransaction: rowNodeTransaction }, nodesToUnselect) {
        const { update: update } = rowDataTran;
        if (!update?.length) return;
        update.forEach((item)=>{
            const rowNode = this.lookupRowNode(getRowIdFunc, item);
            if (!rowNode) return;
            rowNode.updateData(item);
            if (!rowNode.selectable && rowNode.isSelected()) nodesToUnselect.push(rowNode);
            rowNodeTransaction.update.push(rowNode);
            changedRowNodes.update(rowNode);
        });
    }
    dispatchRowDataUpdateStartedEvent(rowData) {
        this.eventSvc.dispatchEvent({
            type: "rowDataUpdateStarted",
            firstRowData: rowData?.length ? rowData[0] : null
        });
    }
    deselectNodes(nodesToUnselect) {
        const source = "rowDataChanged";
        const selectionSvc = this.beans.selectionSvc;
        const selectionChanged = nodesToUnselect.length > 0;
        if (selectionChanged) selectionSvc?.setNodesSelected({
            newValue: false,
            nodes: nodesToUnselect,
            suppressFinishActions: true,
            source: source
        });
        selectionSvc?.updateGroupsFromChildrenSelections?.(source);
        if (selectionChanged) this.eventSvc.dispatchEvent({
            type: "selectionChanged",
            source: source,
            selectedNodes: selectionSvc?.getSelectedNodes() ?? null,
            serverSideState: null
        });
    }
    sanitizeAddIndex(addIndex) {
        const allChildrenCount = this.rootNode.allLeafChildren?.length ?? 0;
        if (addIndex < 0 || addIndex >= allChildrenCount || Number.isNaN(addIndex)) return allChildrenCount;
        return Math.ceil(addIndex);
    }
    createRowNode(data, sourceRowIndex) {
        const node = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
        node.parent = this.rootNode;
        node.level = 0;
        node.group = false;
        node.expanded = false;
        node.sourceRowIndex = sourceRowIndex;
        node.setDataAndId(data, String(this.nextId));
        if (this.allNodesMap[node.id]) $437b23f6a393c3bf$export$545083624300f13d(2, {
            nodeId: node.id
        });
        this.allNodesMap[node.id] = node;
        this.nextId++;
        return node;
    }
    lookupRowNode(getRowIdFunc, data) {
        let rowNode;
        if (getRowIdFunc) {
            const id = getRowIdFunc({
                data: data,
                level: 0
            });
            rowNode = this.allNodesMap[id];
            if (!rowNode) {
                $437b23f6a393c3bf$export$a20c7248650823a9(4, {
                    id: id
                });
                return null;
            }
        } else {
            rowNode = this.rootNode?.allLeafChildren?.find((node)=>node.data === data);
            if (!rowNode) {
                $437b23f6a393c3bf$export$a20c7248650823a9(5, {
                    data: data
                });
                return null;
            }
        }
        return rowNode || null;
    }
};
// packages/ag-grid-community/src/interfaces/serverSideTransaction.ts
var $437b23f6a393c3bf$export$58e95be8934cbc38 = /* @__PURE__ */ ((ServerSideTransactionResultStatus2)=>{
    ServerSideTransactionResultStatus2["Applied"] = "Applied";
    ServerSideTransactionResultStatus2["StoreNotFound"] = "StoreNotFound";
    ServerSideTransactionResultStatus2["StoreLoading"] = "StoreLoading";
    ServerSideTransactionResultStatus2["StoreWaitingToLoad"] = "StoreWaitingToLoad";
    ServerSideTransactionResultStatus2["StoreLoadingFailed"] = "StoreLoadingFailed";
    ServerSideTransactionResultStatus2["StoreWrongType"] = "StoreWrongType";
    ServerSideTransactionResultStatus2["Cancelled"] = "Cancelled";
    ServerSideTransactionResultStatus2["StoreNotStarted"] = "StoreNotStarted";
    return ServerSideTransactionResultStatus2;
})($437b23f6a393c3bf$export$58e95be8934cbc38 || {});
// packages/ag-grid-community/src/selection/checkboxSelectionComponent.ts
var $437b23f6a393c3bf$var$CheckboxSelectionComponentElement = {
    tag: "div",
    cls: "ag-selection-checkbox",
    role: "presentation",
    children: [
        {
            tag: "ag-checkbox",
            ref: "eCheckbox",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$CheckboxSelectionComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$CheckboxSelectionComponentElement, [
            $437b23f6a393c3bf$export$2e2c317d2e31f2ca
        ]);
        this.eCheckbox = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        this.eCheckbox.setPassive(true);
    }
    onDataChanged() {
        this.onSelectionChanged();
    }
    onSelectableChanged() {
        this.showOrHideSelect();
    }
    onSelectionChanged() {
        const translate = this.getLocaleTextFunc();
        const { rowNode: rowNode, eCheckbox: eCheckbox } = this;
        const state = rowNode.isSelected();
        const stateName = $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, state);
        const [ariaKey, ariaLabel] = rowNode.selectable ? [
            "ariaRowToggleSelection",
            "Press Space to toggle row selection"
        ] : [
            "ariaRowSelectionDisabled",
            "Row Selection is disabled for this row"
        ];
        const translatedLabel = translate(ariaKey, ariaLabel);
        eCheckbox.setValue(state, true);
        eCheckbox.setInputAriaLabel(`${translatedLabel} (${stateName})`);
    }
    init(params) {
        this.rowNode = params.rowNode;
        this.column = params.column;
        this.overrides = params.overrides;
        this.onSelectionChanged();
        this.addManagedListeners(this.eCheckbox.getInputElement(), {
            // we don't want double click on this icon to open a group
            dblclick: $437b23f6a393c3bf$export$456c40e80134d72a,
            click: (event)=>{
                $437b23f6a393c3bf$export$456c40e80134d72a(event);
                this.beans.selectionSvc?.handleSelectionEvent(event, this.rowNode, "checkboxSelected");
            }
        });
        this.addManagedListeners(this.rowNode, {
            rowSelected: this.onSelectionChanged.bind(this),
            dataChanged: this.onDataChanged.bind(this),
            selectableChanged: this.onSelectableChanged.bind(this)
        });
        this.addManagedPropertyListener("rowSelection", ({ currentValue: currentValue, previousValue: previousValue })=>{
            const curr = typeof currentValue === "object" ? $437b23f6a393c3bf$var$_getHideDisabledCheckboxes(currentValue) : void 0;
            const prev = typeof previousValue === "object" ? $437b23f6a393c3bf$var$_getHideDisabledCheckboxes(previousValue) : void 0;
            if (curr !== prev) this.onSelectableChanged();
        });
        const isRowSelectableFunc = $437b23f6a393c3bf$export$351959be716b3b33(this.gos);
        const checkboxVisibleIsDynamic = isRowSelectableFunc || typeof this.getIsVisible() === "function";
        if (checkboxVisibleIsDynamic) {
            const showOrHideSelectListener = this.showOrHideSelect.bind(this);
            this.addManagedEventListeners({
                displayedColumnsChanged: showOrHideSelectListener
            });
            this.addManagedListeners(this.rowNode, {
                dataChanged: showOrHideSelectListener,
                cellChanged: showOrHideSelectListener
            });
            this.showOrHideSelect();
        }
        this.eCheckbox.getInputElement().setAttribute("tabindex", "-1");
    }
    showOrHideSelect() {
        const { column: column, rowNode: rowNode, overrides: overrides, gos: gos } = this;
        const selectable = rowNode.selectable;
        const isVisible = this.getIsVisible();
        let checkboxes = void 0;
        if (typeof isVisible === "function") {
            const extraParams = overrides?.callbackParams;
            if (!column) checkboxes = isVisible({
                ...extraParams,
                node: rowNode,
                data: rowNode.data
            });
            else {
                const params = column.createColumnFunctionCallbackParams(rowNode);
                checkboxes = isVisible({
                    ...extraParams,
                    ...params
                });
            }
        } else checkboxes = isVisible ?? false;
        const disabled = selectable && !checkboxes || !selectable && checkboxes;
        const visible = selectable || checkboxes;
        const so = gos.get("rowSelection");
        const showDisabledCheckboxes = so && typeof so !== "string" ? !$437b23f6a393c3bf$var$_getHideDisabledCheckboxes(so) : !!column?.getColDef().showDisabledCheckboxes;
        this.setVisible(visible && (disabled ? showDisabledCheckboxes : true));
        this.setDisplayed(visible && (disabled ? showDisabledCheckboxes : true));
        if (visible) this.eCheckbox.setDisabled(disabled);
        if (overrides?.removeHidden) {
            this.setDisplayed(visible);
            return;
        }
    }
    getIsVisible() {
        const overrides = this.overrides;
        if (overrides) return overrides.isVisible;
        const so = this.gos.get("rowSelection");
        if (so && typeof so !== "string") return $437b23f6a393c3bf$export$6df3a55606bca6ae(so);
        return this.column?.getColDef()?.checkboxSelection;
    }
};
// packages/ag-grid-community/src/selection/rowRangeSelectionContext.ts
var $437b23f6a393c3bf$var$RowRangeSelectionContext = class {
    constructor(rowModel, pinnedRowModel){
        this.rowModel = rowModel;
        this.pinnedRowModel = pinnedRowModel;
        /** Whether the user is currently selecting all nodes either via the header checkbox or API */ this.selectAll = false;
        this.rootId = null;
        /**
     * Note that the "end" `RowNode` may come before or after the "root" `RowNode` in the
     * actual grid.
     */ this.endId = null;
        this.cachedRange = [];
    }
    reset() {
        this.rootId = null;
        this.endId = null;
        this.cachedRange.length = 0;
    }
    setRoot(node) {
        this.rootId = node.id;
        this.endId = null;
        this.cachedRange.length = 0;
    }
    setEndRange(end) {
        this.endId = end.id;
        this.cachedRange.length = 0;
    }
    getRange() {
        if (this.cachedRange.length === 0) {
            const root = this.getRoot();
            const end = this.getEnd();
            if (root == null || end == null) return this.cachedRange;
            this.cachedRange = this.getNodesInRange(root, end) ?? [];
        }
        return this.cachedRange;
    }
    isInRange(node) {
        if (this.rootId === null) return false;
        return this.getRange().some((nodeInRange)=>nodeInRange.id === node.id);
    }
    getRoot(fallback) {
        if (this.rootId) return this.getRowNode(this.rootId);
        if (fallback) {
            this.setRoot(fallback);
            return fallback;
        }
    }
    getEnd() {
        if (this.endId) return this.getRowNode(this.endId);
    }
    getRowNode(id) {
        let node;
        const { rowModel: rowModel, pinnedRowModel: pinnedRowModel } = this;
        node ?? (node = rowModel.getRowNode(id));
        if (pinnedRowModel?.isManual()) {
            node ?? (node = pinnedRowModel.getPinnedRowById(id, "top"));
            node ?? (node = pinnedRowModel.getPinnedRowById(id, "bottom"));
        }
        return node;
    }
    /**
   * Truncates the range to the given node (assumed to be within the current range).
   * Returns nodes that remain in the current range and those that should be removed
   *
   * @param node - Node at which to truncate the range
   * @returns Object of nodes to either keep or discard (i.e. deselect) from the range
   */ truncate(node) {
        const range = this.getRange();
        if (range.length === 0) return {
            keep: [],
            discard: []
        };
        const discardAfter = range[0].id === this.rootId;
        const idx = range.findIndex((rowNode)=>rowNode.id === node.id);
        if (idx > -1) {
            const above = range.slice(0, idx);
            const below = range.slice(idx + 1);
            this.setEndRange(node);
            return discardAfter ? {
                keep: above,
                discard: below
            } : {
                keep: below,
                discard: above
            };
        } else return {
            keep: range,
            discard: []
        };
    }
    /**
   * Extends the range to the given node. Returns nodes that remain in the current range
   * and those that should be removed.
   *
   * @param node - Node marking the new end of the range
   * @returns Object of nodes to either keep or discard (i.e. deselect) from the range
   */ extend(node, groupSelectsChildren = false) {
        const root = this.getRoot();
        if (root == null) {
            const keep = this.getRange().slice();
            if (groupSelectsChildren) node.depthFirstSearch((node2)=>!node2.group && keep.push(node2));
            keep.push(node);
            this.setRoot(node);
            return {
                keep: keep,
                discard: []
            };
        }
        const newRange = this.getNodesInRange(root, node);
        if (!newRange) {
            this.setRoot(node);
            return {
                keep: [
                    node
                ],
                discard: []
            };
        }
        if (newRange.find((newRangeNode)=>newRangeNode.id === this.endId)) {
            this.setEndRange(node);
            return {
                keep: this.getRange(),
                discard: []
            };
        } else {
            const discard = this.getRange().slice();
            this.setEndRange(node);
            return {
                keep: this.getRange(),
                discard: discard
            };
        }
    }
    getNodesInRange(start, end) {
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = this;
        if (!pinnedRowModel?.isManual()) return rowModel.getNodesInRangeForSelection(start, end);
        if (start.rowPinned === "top" && !end.rowPinned) {
            const pinnedRange = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", start, void 0);
            return pinnedRange.concat(rowModel.getNodesInRangeForSelection(rowModel.getRow(0), end) ?? []);
        }
        if (start.rowPinned === "bottom" && !end.rowPinned) {
            const pinnedRange = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", void 0, start);
            const count = rowModel.getRowCount();
            const lastMain = rowModel.getRow(count - 1);
            return (rowModel.getNodesInRangeForSelection(end, lastMain) ?? []).concat(pinnedRange);
        }
        if (!start.rowPinned && !end.rowPinned) return rowModel.getNodesInRangeForSelection(start, end);
        if (start.rowPinned === "top" && end.rowPinned === "top") return $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", start, end);
        if (start.rowPinned === "bottom" && end.rowPinned === "top") {
            const top = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", end, void 0);
            const bottom = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", void 0, start);
            const first = rowModel.getRow(0);
            const last = rowModel.getRow(rowModel.getRowCount() - 1);
            return top.concat(rowModel.getNodesInRangeForSelection(first, last) ?? []).concat(bottom);
        }
        if (!start.rowPinned && end.rowPinned === "top") {
            const pinned = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", end, void 0);
            return pinned.concat(rowModel.getNodesInRangeForSelection(rowModel.getRow(0), start) ?? []);
        }
        if (start.rowPinned === "top" && end.rowPinned === "bottom") {
            const top = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", start, void 0);
            const bottom = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", void 0, end);
            const first = rowModel.getRow(0);
            const last = rowModel.getRow(rowModel.getRowCount() - 1);
            return top.concat(rowModel.getNodesInRangeForSelection(first, last) ?? []).concat(bottom);
        }
        if (start.rowPinned === "bottom" && end.rowPinned === "bottom") return $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", start, end);
        if (!start.rowPinned && end.rowPinned === "bottom") {
            const pinned = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", void 0, end);
            const last = rowModel.getRow(rowModel.getRowCount());
            return (rowModel.getNodesInRangeForSelection(start, last) ?? []).concat(pinned);
        }
        return null;
    }
};
// packages/ag-grid-community/src/selection/selectAllFeature.ts
var $437b23f6a393c3bf$var$SelectAllFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column){
        super();
        this.column = column;
        this.cbSelectAllVisible = false;
        this.processingEventFromCheckbox = false;
    }
    onSpaceKeyDown(e) {
        const checkbox = this.cbSelectAll;
        if (checkbox.isDisplayed() && !checkbox.getGui().contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans))) {
            e.preventDefault();
            checkbox.setValue(!checkbox.getValue());
        }
    }
    getCheckboxGui() {
        return this.cbSelectAll.getGui();
    }
    setComp(ctrl) {
        this.headerCellCtrl = ctrl;
        const cbSelectAll = this.createManagedBean(new $437b23f6a393c3bf$export$b00c508c1ae18d07());
        this.cbSelectAll = cbSelectAll;
        cbSelectAll.addCss("ag-header-select-all");
        $437b23f6a393c3bf$export$f8d01fa01787902(cbSelectAll.getGui(), "presentation");
        this.showOrHideSelectAll();
        const updateStateOfCheckbox = this.updateStateOfCheckbox.bind(this);
        this.addManagedEventListeners({
            newColumnsLoaded: ()=>this.showOrHideSelectAll(),
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
            selectionChanged: updateStateOfCheckbox,
            paginationChanged: updateStateOfCheckbox,
            modelUpdated: updateStateOfCheckbox
        });
        this.addManagedPropertyListener("rowSelection", ({ currentValue: currentValue, previousValue: previousValue })=>{
            const getSelectAll = (rowSelection)=>typeof rowSelection === "string" || !rowSelection || rowSelection.mode === "singleRow" ? void 0 : rowSelection.selectAll;
            if (getSelectAll(currentValue) !== getSelectAll(previousValue)) this.showOrHideSelectAll();
            this.updateStateOfCheckbox();
        });
        this.addManagedListeners(cbSelectAll, {
            fieldValueChanged: this.onCbSelectAll.bind(this)
        });
        cbSelectAll.getInputElement().setAttribute("tabindex", "-1");
        this.refreshSelectAllLabel();
    }
    onDisplayedColumnsChanged(e) {
        if (!this.isAlive()) return;
        this.showOrHideSelectAll(e.source === "uiColumnMoved");
    }
    showOrHideSelectAll(fromColumnMoved = false) {
        const cbSelectAllVisible = this.isCheckboxSelection();
        this.cbSelectAllVisible = cbSelectAllVisible;
        this.cbSelectAll.setDisplayed(cbSelectAllVisible);
        if (cbSelectAllVisible) {
            this.checkRightRowModelType("selectAllCheckbox");
            this.checkSelectionType("selectAllCheckbox");
            this.updateStateOfCheckbox();
        }
        this.refreshSelectAllLabel(fromColumnMoved);
    }
    updateStateOfCheckbox() {
        if (!this.cbSelectAllVisible || this.processingEventFromCheckbox) return;
        this.processingEventFromCheckbox = true;
        const selectAllMode = this.getSelectAllMode();
        const selectionSvc = this.beans.selectionSvc;
        const cbSelectAll = this.cbSelectAll;
        const allSelected = selectionSvc.getSelectAllState(selectAllMode);
        cbSelectAll.setValue(allSelected);
        const hasNodesToSelect = selectionSvc.hasNodesToSelect(selectAllMode);
        cbSelectAll.setDisabled(!hasNodesToSelect);
        this.refreshSelectAllLabel();
        this.processingEventFromCheckbox = false;
    }
    refreshSelectAllLabel(fromColumnMoved = false) {
        const translate = this.getLocaleTextFunc();
        const { headerCellCtrl: headerCellCtrl, cbSelectAll: cbSelectAll, cbSelectAllVisible: cbSelectAllVisible } = this;
        const checked = cbSelectAll.getValue();
        const ariaStatus = $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, checked);
        const ariaLabel = translate("ariaRowSelectAll", "Press Space to toggle all rows selection");
        headerCellCtrl.setAriaDescriptionProperty("selectAll", cbSelectAllVisible ? `${ariaLabel} (${ariaStatus})` : null);
        cbSelectAll.setInputAriaLabel(translate("ariaHeaderSelection", "Column with Header Selection"));
        if (!fromColumnMoved) headerCellCtrl.announceAriaDescription();
    }
    checkSelectionType(feature) {
        const isMultiSelect = $437b23f6a393c3bf$export$7bd8c52ebc4117d6(this.gos);
        if (!isMultiSelect) {
            $437b23f6a393c3bf$export$545083624300f13d(128, {
                feature: feature
            });
            return false;
        }
        return true;
    }
    checkRightRowModelType(feature) {
        const { gos: gos, rowModel: rowModel } = this.beans;
        const rowModelMatches = $437b23f6a393c3bf$export$9f182d9ca737e15(gos) || $437b23f6a393c3bf$export$cf1bac0013650216(gos);
        if (!rowModelMatches) {
            $437b23f6a393c3bf$export$545083624300f13d(129, {
                feature: feature,
                rowModel: rowModel.getType()
            });
            return false;
        }
        return true;
    }
    onCbSelectAll() {
        if (this.processingEventFromCheckbox) return;
        if (!this.cbSelectAllVisible) return;
        const value = this.cbSelectAll.getValue();
        const selectAll2 = this.getSelectAllMode();
        let source = "uiSelectAll";
        if (selectAll2 === "currentPage") source = "uiSelectAllCurrentPage";
        else if (selectAll2 === "filtered") source = "uiSelectAllFiltered";
        const params = {
            source: source,
            selectAll: selectAll2
        };
        const selectionSvc = this.beans.selectionSvc;
        if (value) selectionSvc.selectAllRowNodes(params);
        else selectionSvc.deselectAllRowNodes(params);
    }
    /**
   * Checkbox is enabled when either the `headerCheckbox` option is enabled in the new selection API
   * or `headerCheckboxSelection` is enabled in the legacy API.
   */ isCheckboxSelection() {
        const { column: column, gos: gos, beans: beans } = this;
        const rowSelection = gos.get("rowSelection");
        const newHeaderCheckbox = typeof rowSelection === "object";
        const featureName = newHeaderCheckbox ? "headerCheckbox" : "headerCheckboxSelection";
        return $437b23f6a393c3bf$var$isCheckboxSelection(beans, column) && this.checkRightRowModelType(featureName) && this.checkSelectionType(featureName);
    }
    getSelectAllMode() {
        const selectAll2 = $437b23f6a393c3bf$var$_getSelectAll(this.gos, false);
        if (selectAll2) return selectAll2;
        const { headerCheckboxSelectionCurrentPageOnly: headerCheckboxSelectionCurrentPageOnly, headerCheckboxSelectionFilteredOnly: headerCheckboxSelectionFilteredOnly } = this.column.getColDef();
        if (headerCheckboxSelectionCurrentPageOnly) return "currentPage";
        if (headerCheckboxSelectionFilteredOnly) return "filtered";
        return "all";
    }
    destroy() {
        super.destroy();
        this.cbSelectAll = void 0;
        this.headerCellCtrl = void 0;
    }
};
function $437b23f6a393c3bf$var$isCheckboxSelection({ gos: gos, selectionColSvc: selectionColSvc }, column) {
    const rowSelection = gos.get("rowSelection");
    const colDef = column.getColDef();
    const { headerCheckboxSelection: headerCheckboxSelection } = colDef;
    let result = false;
    const newHeaderCheckbox = typeof rowSelection === "object";
    if (newHeaderCheckbox) {
        const isSelectionCol = $437b23f6a393c3bf$export$f6074a9792015c5d(column);
        const isAutoCol = $437b23f6a393c3bf$export$61b34611dc010a97(column);
        const location = $437b23f6a393c3bf$export$8fb5d781b5c28347(rowSelection);
        if (location === "autoGroupColumn" && isAutoCol || isSelectionCol && selectionColSvc?.isSelectionColumnEnabled()) result = $437b23f6a393c3bf$export$e92e75627785d7a4(rowSelection);
    } else if (typeof headerCheckboxSelection === "function") result = headerCheckboxSelection($437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        column: column,
        colDef: colDef
    }));
    else result = !!headerCheckboxSelection;
    return result;
}
// packages/ag-grid-community/src/selection/baseSelectionService.ts
var $437b23f6a393c3bf$export$3d7b168c0c9c2a78 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        const { gos: gos, beans: beans } = this;
        this.selectionCtx = new $437b23f6a393c3bf$var$RowRangeSelectionContext(beans.rowModel, beans.pinnedRowModel);
        this.addManagedPropertyListeners([
            "isRowSelectable",
            "rowSelection"
        ], ()=>{
            const callback = $437b23f6a393c3bf$export$351959be716b3b33(gos);
            if (callback !== this.isRowSelectable) {
                this.isRowSelectable = callback;
                this.updateSelectable();
            }
        });
        this.isRowSelectable = $437b23f6a393c3bf$export$351959be716b3b33(gos);
        this.addManagedEventListeners({
            cellValueChanged: (e)=>this.updateRowSelectable(e.node),
            rowNodeDataChanged: (e)=>this.updateRowSelectable(e.node)
        });
    }
    destroy() {
        super.destroy();
        this.selectionCtx.reset();
    }
    createCheckboxSelectionComponent() {
        return new $437b23f6a393c3bf$var$CheckboxSelectionComponent();
    }
    createSelectAllFeature(column) {
        if ($437b23f6a393c3bf$var$isCheckboxSelection(this.beans, column)) return new $437b23f6a393c3bf$var$SelectAllFeature(column);
    }
    isMultiSelect() {
        return $437b23f6a393c3bf$export$7bd8c52ebc4117d6(this.gos);
    }
    onRowCtrlSelected(rowCtrl, hasFocusFunc, gui) {
        const selected = !!rowCtrl.rowNode.isSelected();
        rowCtrl.forEachGui(gui, (gui2)=>{
            gui2.rowComp.toggleCss("ag-row-selected", selected);
            const element = gui2.element;
            $437b23f6a393c3bf$export$c22e3722e8a33469(element, selected);
            const hasFocus = element.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans));
            if (hasFocus) hasFocusFunc(gui2);
        });
    }
    announceAriaRowSelection(rowNode) {
        if (this.isRowSelectionBlocked(rowNode)) return;
        const selected = rowNode.isSelected();
        if (!rowNode.selectable) return;
        const translate = this.getLocaleTextFunc();
        const label = translate(selected ? "ariaRowDeselect" : "ariaRowSelect", `Press SPACE to ${selected ? "deselect" : "select"} this row`);
        this.beans.ariaAnnounce?.announceValue(label, "rowSelection");
    }
    isRowSelectionBlocked(rowNode) {
        return !rowNode.selectable || rowNode.rowPinned && !$437b23f6a393c3bf$var$_isManualPinnedRow(rowNode) || !$437b23f6a393c3bf$export$5d5fd838f5df1dd2(this.gos);
    }
    updateRowSelectable(rowNode, suppressSelectionUpdate) {
        const selectable = rowNode.rowPinned && rowNode.pinnedSibling ? // If row node is pinned sibling, copy selectable status over from sibling row node
        rowNode.pinnedSibling.selectable : // otherwise calculate selectable state directly
        this.isRowSelectable?.(rowNode) ?? true;
        this.setRowSelectable(rowNode, selectable, suppressSelectionUpdate);
        return selectable;
    }
    setRowSelectable(rowNode, newVal, suppressSelectionUpdate) {
        if (rowNode.selectable !== newVal) {
            rowNode.selectable = newVal;
            rowNode.dispatchRowEvent("selectableChanged");
            if (suppressSelectionUpdate) return;
            const isGroupSelectsChildren = $437b23f6a393c3bf$export$460e5745f0e6a40d(this.gos);
            if (isGroupSelectsChildren) {
                const selected = this.calculateSelectedFromChildren(rowNode);
                this.setNodesSelected({
                    nodes: [
                        rowNode
                    ],
                    newValue: selected ?? false,
                    source: "selectableChanged"
                });
                return;
            }
            if (rowNode.isSelected() && !rowNode.selectable) this.setNodesSelected({
                nodes: [
                    rowNode
                ],
                newValue: false,
                source: "selectableChanged"
            });
        }
    }
    calculateSelectedFromChildren(rowNode) {
        let atLeastOneSelected = false;
        let atLeastOneDeSelected = false;
        if (!rowNode.childrenAfterGroup?.length) return rowNode.selectable ? rowNode.__selected : null;
        for(let i = 0; i < rowNode.childrenAfterGroup.length; i++){
            const child = rowNode.childrenAfterGroup[i];
            let childState = child.isSelected();
            if (!child.selectable) {
                const selectable = this.calculateSelectedFromChildren(child);
                if (selectable === null) continue;
                childState = selectable;
            }
            switch(childState){
                case true:
                    atLeastOneSelected = true;
                    break;
                case false:
                    atLeastOneDeSelected = true;
                    break;
                default:
                    return void 0;
            }
        }
        if (atLeastOneSelected && atLeastOneDeSelected) return void 0;
        if (atLeastOneSelected) return true;
        if (atLeastOneDeSelected) return false;
        if (!rowNode.selectable) return null;
        return rowNode.__selected;
    }
    selectRowNode(rowNode, newValue, e, source = "api") {
        const selectionNotAllowed = !rowNode.selectable && newValue;
        const selectionNotChanged = rowNode.__selected === newValue;
        if (selectionNotAllowed || selectionNotChanged) return false;
        rowNode.__selected = newValue;
        rowNode.dispatchRowEvent("rowSelected");
        const sibling = rowNode.sibling;
        if (sibling && sibling.footer && sibling.__localEventService) sibling.dispatchRowEvent("rowSelected");
        const pinnedSibling = rowNode.pinnedSibling;
        if (pinnedSibling && pinnedSibling.rowPinned && pinnedSibling.__localEventService) pinnedSibling.dispatchRowEvent("rowSelected");
        this.eventSvc.dispatchEvent({
            ...$437b23f6a393c3bf$export$5c5bd6257397e1bc(rowNode, this.gos, "rowSelected"),
            event: e || null,
            source: source
        });
        return true;
    }
    isCellCheckboxSelection(column, rowNode) {
        const so = this.gos.get("rowSelection");
        if (so && typeof so !== "string") {
            const checkbox = $437b23f6a393c3bf$export$f6074a9792015c5d(column) && $437b23f6a393c3bf$export$6df3a55606bca6ae(so);
            return column.isColumnFunc(rowNode, checkbox);
        } else return column.isColumnFunc(rowNode, column.colDef.checkboxSelection);
    }
    inferNodeSelections(node, shiftKey, metaKey, source) {
        const { gos: gos, selectionCtx: selectionCtx } = this;
        const currentSelection = node.isSelected();
        const groupSelectsDescendants = $437b23f6a393c3bf$export$460e5745f0e6a40d(gos);
        const enableClickSelection = $437b23f6a393c3bf$var$_getEnableSelection(gos);
        const enableDeselection = $437b23f6a393c3bf$var$_getEnableDeselection(gos);
        const isMultiSelect = this.isMultiSelect();
        const isRowClicked = source === "rowClicked";
        if (isRowClicked && !(enableClickSelection || enableDeselection)) return null;
        if (shiftKey && metaKey && isMultiSelect) {
            const root = selectionCtx.getRoot();
            if (!root) return null;
            else if (!root.isSelected()) {
                const partition = selectionCtx.extend(node, groupSelectsDescendants);
                return {
                    select: [],
                    deselect: partition.keep,
                    reset: false
                };
            } else {
                const partition = selectionCtx.isInRange(node) ? selectionCtx.truncate(node) : selectionCtx.extend(node, groupSelectsDescendants);
                return {
                    deselect: partition.discard,
                    select: partition.keep,
                    reset: false
                };
            }
        } else if (shiftKey && isMultiSelect) {
            const fallback = selectionCtx.selectAll ? this.beans.rowModel.getRow(0) : void 0;
            const root = selectionCtx.getRoot(fallback);
            const partition = selectionCtx.isInRange(node) ? selectionCtx.truncate(node) : selectionCtx.extend(node, groupSelectsDescendants);
            return {
                select: partition.keep,
                deselect: partition.discard,
                reset: selectionCtx.selectAll || !!(root && !root.isSelected())
            };
        } else if (metaKey) {
            if (isRowClicked) {
                const newValue = !currentSelection;
                const selectingWhenDisabled = newValue && !enableClickSelection;
                const deselectingWhenDisabled = !newValue && !enableDeselection;
                if (selectingWhenDisabled || deselectingWhenDisabled) return null;
                selectionCtx.setRoot(node);
                return {
                    node: node,
                    newValue: newValue,
                    clearSelection: false
                };
            }
            selectionCtx.setRoot(node);
            return {
                node: node,
                newValue: !currentSelection,
                clearSelection: !isMultiSelect
            };
        } else {
            selectionCtx.setRoot(node);
            const enableSelectionWithoutKeys = $437b23f6a393c3bf$var$_getEnableSelectionWithoutKeys(gos);
            const groupSelectsFiltered = $437b23f6a393c3bf$export$673080972d8c733e(gos) === "filteredDescendants";
            const shouldClear = isRowClicked && (!enableSelectionWithoutKeys || !enableClickSelection);
            if (groupSelectsFiltered && currentSelection === void 0 && $437b23f6a393c3bf$export$9f182d9ca737e15(gos)) return {
                node: node,
                newValue: false,
                clearSelection: !isMultiSelect || shouldClear
            };
            if (isRowClicked) {
                const newValue = currentSelection ? !enableSelectionWithoutKeys : enableClickSelection;
                const selectingWhenDisabled = newValue && !enableClickSelection;
                const deselectingWhenDisabled = !newValue && !enableDeselection;
                const wouldStateBeUnchanged = newValue === currentSelection && !shouldClear;
                if (wouldStateBeUnchanged || selectingWhenDisabled || deselectingWhenDisabled) return null;
                return {
                    node: node,
                    newValue: newValue,
                    clearSelection: !isMultiSelect || shouldClear,
                    keepDescendants: node.group && groupSelectsDescendants
                };
            }
            return {
                node: node,
                newValue: !currentSelection,
                clearSelection: !isMultiSelect || shouldClear
            };
        }
    }
};
// packages/ag-grid-community/src/widgets/agRadioButton.ts
var $437b23f6a393c3bf$export$5caa9ea96bbb722 = class extends $437b23f6a393c3bf$export$b00c508c1ae18d07 {
    constructor(config){
        super(config, "ag-radio-button", "radio");
    }
    isSelected() {
        return this.eInput.checked;
    }
    toggle() {
        if (this.eInput.disabled) return;
        if (!this.isSelected()) this.setValue(true);
    }
    addInputListeners() {
        super.addInputListeners();
        this.addManagedEventListeners({
            checkboxChanged: this.onChange.bind(this)
        });
    }
    /**
   * This ensures that if another radio button in the same named group is selected, we deselect this radio button.
   * By default the browser does this for you, but we are managing classes ourselves in order to ensure input
   * elements are styled correctly in IE11, and the DOM 'changed' event is only fired when a button is selected,
   * not deselected, so we need to use our own event.
   */ onChange(event) {
        const eInput = this.eInput;
        if (event.selected && event.name && eInput.name && eInput.name === event.name && event.id && eInput.id !== event.id) this.setValue(false, true);
    }
};
// packages/ag-grid-community/src/widgets/agToggleButton.css-GENERATED.ts
var $437b23f6a393c3bf$var$agToggleButtonCSS = /*css*/ `.ag-toggle-button{flex:none;min-width:unset;width:unset}.ag-toggle-button-input-wrapper{background-color:var(--ag-toggle-button-off-background-color);border-radius:calc(var(--ag-toggle-button-height)*.5);flex:none;height:var(--ag-toggle-button-height);max-width:var(--ag-toggle-button-width);min-width:var(--ag-toggle-button-width);position:relative;transition:background-color .1s;:where(.ag-toggle-button-input){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;display:block;height:var(--ag-toggle-button-height);margin:0;max-width:var(--ag-toggle-button-width);min-width:var(--ag-toggle-button-width);opacity:0}&:before{background-color:var(--ag-toggle-button-switch-background-color);border-radius:100%;content:"";display:block;height:calc(var(--ag-toggle-button-height) - var(--ag-toggle-button-switch-inset)*2);left:var(--ag-toggle-button-switch-inset);pointer-events:none;position:absolute;top:var(--ag-toggle-button-switch-inset);transition:left .1s;width:calc(var(--ag-toggle-button-height) - var(--ag-toggle-button-switch-inset)*2)}&.ag-checked{background-color:var(--ag-toggle-button-on-background-color);&:before{left:calc(100% - var(--ag-toggle-button-height) + var(--ag-toggle-button-switch-inset))}}&:focus-within{box-shadow:var(--ag-focus-shadow)}&.ag-disabled{opacity:.5}}`;
// packages/ag-grid-community/src/widgets/agToggleButton.ts
var $437b23f6a393c3bf$export$167b21bf245ce0bf = class extends $437b23f6a393c3bf$export$b00c508c1ae18d07 {
    constructor(config){
        super(config, "ag-toggle-button");
        this.registerCSS($437b23f6a393c3bf$var$agToggleButtonCSS);
    }
    setValue(value, silent) {
        super.setValue(value, silent);
        this.toggleCss("ag-selected", this.getValue());
        return this;
    }
};
var $437b23f6a393c3bf$export$b825a5135f318030 = {
    selector: "AG-TOGGLE-BUTTON",
    component: $437b23f6a393c3bf$export$167b21bf245ce0bf
};
// packages/ag-grid-community/src/widgets/agInputTextField.ts
var $437b23f6a393c3bf$export$8c027679838afd47 = class extends $437b23f6a393c3bf$export$9671f513d4aa42e3 {
    constructor(config, className = "ag-text-field", inputType = "text"){
        super(config, className, inputType);
    }
    postConstruct() {
        super.postConstruct();
        if (this.config.allowedCharPattern) this.preventDisallowedCharacters();
    }
    setValue(value, silent) {
        const eInput = this.eInput;
        if (eInput.value !== value) eInput.value = $437b23f6a393c3bf$export$25d27f17d3af40f7(value) ? value : "";
        return super.setValue(value, silent);
    }
    /** Used to set an initial value into the input without necessarily setting `this.value` or triggering events (e.g. to set an invalid value) */ setStartValue(value) {
        this.setValue(value, true);
    }
    preventDisallowedCharacters() {
        const pattern = new RegExp(`[${this.config.allowedCharPattern}]`);
        const preventCharacters = (event)=>{
            if (!$437b23f6a393c3bf$export$33ecd6e270298858(event)) return;
            if (event.key && !pattern.test(event.key)) event.preventDefault();
        };
        this.addManagedListeners(this.eInput, {
            keydown: preventCharacters,
            paste: (e)=>{
                const text = e.clipboardData?.getData("text");
                if (text && text.split("").some((c)=>!pattern.test(c))) e.preventDefault();
            }
        });
    }
};
var $437b23f6a393c3bf$export$31e2985be4ee06ab = {
    selector: "AG-INPUT-TEXT-FIELD",
    component: $437b23f6a393c3bf$export$8c027679838afd47
};
// packages/ag-grid-community/src/widgets/agInputTextArea.ts
var $437b23f6a393c3bf$export$fd677433260ffbc8 = class extends $437b23f6a393c3bf$export$9671f513d4aa42e3 {
    constructor(config){
        super(config, "ag-text-area", null, "textarea");
    }
    setValue(value, silent) {
        const ret = super.setValue(value, silent);
        this.eInput.value = value;
        return ret;
    }
    setCols(cols) {
        this.eInput.cols = cols;
        return this;
    }
    setRows(rows) {
        this.eInput.rows = rows;
        return this;
    }
};
var $437b23f6a393c3bf$var$AgInputTextAreaSelector = {
    selector: "AG-INPUT-TEXT-AREA",
    component: $437b23f6a393c3bf$export$fd677433260ffbc8
};
// packages/ag-grid-community/src/widgets/agInputNumberField.ts
var $437b23f6a393c3bf$export$c8aa0be99738aee = class extends $437b23f6a393c3bf$export$8c027679838afd47 {
    constructor(config){
        super(config, "ag-number-field", "number");
    }
    postConstruct() {
        super.postConstruct();
        const eInput = this.eInput;
        this.addManagedListeners(eInput, {
            blur: ()=>{
                const floatedValue = parseFloat(eInput.value);
                const value = isNaN(floatedValue) ? "" : this.normalizeValue(floatedValue.toString());
                if (this.value !== value) this.setValue(value);
            },
            wheel: this.onWheel.bind(this)
        });
        eInput.step = "any";
        const { precision: precision, min: min, max: max, step: step } = this.config;
        if (typeof precision === "number") this.setPrecision(precision);
        if (typeof min === "number") this.setMin(min);
        if (typeof max === "number") this.setMax(max);
        if (typeof step === "number") this.setStep(step);
    }
    onWheel(e) {
        if ($437b23f6a393c3bf$export$16bc98d422315038(this.beans) === this.eInput) e.preventDefault();
    }
    normalizeValue(value) {
        if (value === "") return "";
        if (this.precision != null) value = this.adjustPrecision(value);
        return value;
    }
    adjustPrecision(value, isScientificNotation) {
        const precision = this.precision;
        if (precision == null) return value;
        if (isScientificNotation) {
            const floatString = parseFloat(value).toFixed(precision);
            return parseFloat(floatString).toString();
        }
        const parts = String(value).split(".");
        if (parts.length > 1) {
            if (parts[1].length <= precision) return value;
            else if (precision > 0) return `${parts[0]}.${parts[1].slice(0, precision)}`;
        }
        return parts[0];
    }
    setMin(min) {
        if (this.min === min) return this;
        this.min = min;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "min", min);
        return this;
    }
    setMax(max) {
        if (this.max === max) return this;
        this.max = max;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "max", max);
        return this;
    }
    setPrecision(precision) {
        this.precision = precision;
        return this;
    }
    setStep(step) {
        if (this.step === step) return this;
        this.step = step;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "step", step);
        return this;
    }
    setValue(value, silent) {
        return this.setValueOrInputValue((v)=>super.setValue(v, silent), ()=>this, value);
    }
    setStartValue(value) {
        return this.setValueOrInputValue((v)=>super.setValue(v, true), (v)=>{
            this.eInput.value = v;
        }, value);
    }
    setValueOrInputValue(setValueFunc, setInputValueOnlyFunc, value) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(value)) {
            let setInputValueOnly = this.isScientificNotation(value);
            if (setInputValueOnly && this.eInput.validity.valid) return setValueFunc(value);
            if (!setInputValueOnly) {
                value = this.adjustPrecision(value);
                const normalizedValue = this.normalizeValue(value);
                setInputValueOnly = value != normalizedValue;
            }
            if (setInputValueOnly) return setInputValueOnlyFunc(value);
        }
        return setValueFunc(value);
    }
    getValue() {
        const eInput = this.eInput;
        if (!eInput.validity.valid) return void 0;
        const inputValue = eInput.value;
        if (this.isScientificNotation(inputValue)) return this.adjustPrecision(inputValue, true);
        return super.getValue();
    }
    isScientificNotation(value) {
        return typeof value === "string" && value.includes("e");
    }
};
var $437b23f6a393c3bf$export$c18153c9c909b7d7 = {
    selector: "AG-INPUT-NUMBER-FIELD",
    component: $437b23f6a393c3bf$export$c8aa0be99738aee
};
// packages/ag-grid-community/src/widgets/agInputDateField.ts
var $437b23f6a393c3bf$export$9e01ec8ba43de612 = class extends $437b23f6a393c3bf$export$8c027679838afd47 {
    constructor(config){
        super(config, "ag-date-field", "date");
    }
    postConstruct() {
        super.postConstruct();
        const usingSafari = $437b23f6a393c3bf$var$_isBrowserSafari();
        this.addManagedListeners(this.eInput, {
            wheel: this.onWheel.bind(this),
            mousedown: ()=>{
                if (this.isDisabled() || usingSafari) return;
                this.eInput.focus();
            }
        });
        this.eInput.step = "any";
    }
    onWheel(e) {
        if ($437b23f6a393c3bf$export$16bc98d422315038(this.beans) === this.eInput) e.preventDefault();
    }
    setMin(minDate) {
        const min = minDate instanceof Date ? $437b23f6a393c3bf$export$3d7fedfb21962874(minDate ?? null, !!this.includeTime) ?? void 0 : minDate;
        if (this.min === min) return this;
        this.min = min;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "min", min);
        return this;
    }
    setMax(maxDate) {
        const max = maxDate instanceof Date ? $437b23f6a393c3bf$export$3d7fedfb21962874(maxDate ?? null, !!this.includeTime) ?? void 0 : maxDate;
        if (this.max === max) return this;
        this.max = max;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "max", max);
        return this;
    }
    setStep(step) {
        if (this.step === step) return this;
        this.step = step;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "step", step);
        return this;
    }
    setIncludeTime(includeTime) {
        if (this.includeTime === includeTime) return this;
        this.includeTime = includeTime;
        super.setInputType(includeTime ? "datetime-local" : "date");
        if (includeTime) this.setStep(1);
        return this;
    }
    getDate() {
        if (!this.eInput.validity.valid) return void 0;
        return $437b23f6a393c3bf$export$26ded2d88c01b527(this.getValue()) ?? void 0;
    }
    setDate(date, silent) {
        this.setValue($437b23f6a393c3bf$export$3d7fedfb21962874(date ?? null, this.includeTime), silent);
    }
};
var $437b23f6a393c3bf$var$AgInputDateFieldSelector = {
    selector: "AG-INPUT-DATE-FIELD",
    component: $437b23f6a393c3bf$export$9e01ec8ba43de612
};
// packages/ag-grid-community/src/widgets/agList.ts
var $437b23f6a393c3bf$var$AgList = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(cssIdentifier = "default", unFocusable = false){
        super({
            tag: "div",
            cls: `ag-list ag-${cssIdentifier}-list`
        });
        this.cssIdentifier = cssIdentifier;
        this.unFocusable = unFocusable;
        this.activeClass = "ag-active-item";
        this.options = [];
        this.itemEls = [];
    }
    postConstruct() {
        const eGui = this.getGui();
        this.addManagedElementListeners(eGui, {
            mouseleave: ()=>this.clearHighlighted()
        });
        if (this.unFocusable) return;
        this.addManagedElementListeners(eGui, {
            keydown: this.handleKeyDown.bind(this)
        });
    }
    handleKeyDown(e) {
        const key = e.key;
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                if (!this.highlightedEl) this.setValue(this.getValue());
                else {
                    const pos = this.itemEls.indexOf(this.highlightedEl);
                    this.setValueByIndex(pos);
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                e.preventDefault();
                this.navigate(key);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                e.preventDefault();
                this.navigateToPage(key);
                break;
        }
    }
    navigate(key) {
        const isDown = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
        let itemToHighlight;
        const { itemEls: itemEls, highlightedEl: highlightedEl } = this;
        if (!highlightedEl) itemToHighlight = itemEls[isDown ? 0 : itemEls.length - 1];
        else {
            const currentIdx = itemEls.indexOf(highlightedEl);
            let nextPos = currentIdx + (isDown ? 1 : -1);
            nextPos = Math.min(Math.max(nextPos, 0), itemEls.length - 1);
            itemToHighlight = itemEls[nextPos];
        }
        this.highlightItem(itemToHighlight);
    }
    navigateToPage(key) {
        const { itemEls: itemEls, highlightedEl: highlightedEl } = this;
        if (!highlightedEl || itemEls.length === 0) return;
        const currentIdx = itemEls.indexOf(highlightedEl);
        const rowCount = this.options.length - 1;
        const itemHeight = itemEls[0].clientHeight;
        const pageSize = Math.floor(this.getGui().clientHeight / itemHeight);
        let newIndex = -1;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME) newIndex = 0;
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END) newIndex = rowCount;
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN) newIndex = Math.min(currentIdx + pageSize, rowCount);
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP) newIndex = Math.max(currentIdx - pageSize, 0);
        if (newIndex === -1) return;
        this.highlightItem(itemEls[newIndex]);
    }
    addOptions(listOptions) {
        listOptions.forEach((listOption)=>this.addOption(listOption));
        return this;
    }
    addOption(listOption) {
        const { value: value, text: text } = listOption;
        const valueToRender = text ?? value;
        this.options.push({
            value: value,
            text: valueToRender
        });
        this.renderOption(value, valueToRender);
        this.updateIndices();
        return this;
    }
    clearOptions() {
        this.options = [];
        this.reset(true);
        this.itemEls.forEach((itemEl)=>{
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(itemEl);
        });
        this.itemEls = [];
        this.refreshAriaRole();
    }
    refreshAriaRole() {
        const eGui = this.getGui();
        $437b23f6a393c3bf$export$f8d01fa01787902(eGui, this.options.length === 0 ? "presentation" : "listbox");
    }
    updateIndices() {
        const options = this.getGui().querySelectorAll(".ag-list-item");
        this.refreshAriaRole();
        options.forEach((option, idx)=>{
            $437b23f6a393c3bf$export$c3d3aede41065a84(option, idx + 1);
            $437b23f6a393c3bf$export$3d494c2007bbcac1(option, options.length);
        });
    }
    renderOption(value, text) {
        const itemEl = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: `ag-list-item ag-${this.cssIdentifier}-list-item`,
            attrs: {
                role: "option"
            }
        });
        const span = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "span",
            children: text
        });
        itemEl.appendChild(span);
        if (!this.unFocusable) itemEl.tabIndex = -1;
        this.itemEls.push(itemEl);
        this.addManagedListeners(itemEl, {
            mouseover: ()=>this.highlightItem(itemEl),
            mousedown: (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.setValue(value);
            }
        });
        this.createOptionalManagedBean(this.beans.registry.createDynamicBean("tooltipFeature", false, {
            getTooltipValue: ()=>text,
            getGui: ()=>itemEl,
            getLocation: ()=>"UNKNOWN",
            // only show tooltips for items where the text cannot be fully displayed
            shouldDisplayTooltip: ()=>span.scrollWidth > span.clientWidth
        }));
        this.getGui().appendChild(itemEl);
    }
    setValue(value, silent) {
        if (this.value === value) {
            this.fireItemSelected();
            return this;
        }
        if (value == null) {
            this.reset(silent);
            return this;
        }
        const idx = this.options.findIndex((option)=>option.value === value);
        if (idx !== -1) {
            const option = this.options[idx];
            this.value = option.value;
            this.displayValue = option.text;
            this.highlightItem(this.itemEls[idx]);
            if (!silent) this.fireChangeEvent();
        }
        return this;
    }
    setValueByIndex(idx) {
        return this.setValue(this.options[idx].value);
    }
    getValue() {
        return this.value;
    }
    getDisplayValue() {
        return this.displayValue;
    }
    refreshHighlighted() {
        this.clearHighlighted();
        const idx = this.options.findIndex((option)=>option.value === this.value);
        if (idx !== -1) this.highlightItem(this.itemEls[idx]);
    }
    reset(silent) {
        this.value = null;
        this.displayValue = null;
        this.clearHighlighted();
        if (!silent) this.fireChangeEvent();
    }
    highlightItem(el) {
        if (!$437b23f6a393c3bf$export$2badf4aa566524cb(el)) return;
        this.clearHighlighted();
        this.highlightedEl = el;
        el.classList.add(this.activeClass);
        $437b23f6a393c3bf$export$c22e3722e8a33469(el, true);
        const eGui = this.getGui();
        const { scrollTop: scrollTop, clientHeight: clientHeight } = eGui;
        const { offsetTop: offsetTop, offsetHeight: offsetHeight } = el;
        if (offsetTop + offsetHeight > scrollTop + clientHeight || offsetTop < scrollTop) el.scrollIntoView({
            block: "nearest"
        });
        if (!this.unFocusable) el.focus();
    }
    clearHighlighted() {
        const highlightedEl = this.highlightedEl;
        if (!highlightedEl || !$437b23f6a393c3bf$export$2badf4aa566524cb(highlightedEl)) return;
        highlightedEl.classList.remove(this.activeClass);
        $437b23f6a393c3bf$export$c22e3722e8a33469(highlightedEl, false);
        this.highlightedEl = null;
    }
    fireChangeEvent() {
        this.dispatchLocalEvent({
            type: "fieldValueChanged"
        });
        this.fireItemSelected();
    }
    fireItemSelected() {
        this.dispatchLocalEvent({
            type: "selectedItem"
        });
    }
};
// packages/ag-grid-community/src/widgets/agPickerField.css-GENERATED.ts
var $437b23f6a393c3bf$var$agPickerFieldCSS = /*css*/ `.ag-picker-field-display{flex:1 1 auto}.ag-picker-field{align-items:center;display:flex}.ag-picker-field-icon{border:0;cursor:pointer;display:flex;margin:0;padding:0}.ag-picker-field-wrapper{background-color:var(--ag-picker-button-background-color);border:var(--ag-picker-button-border);border-radius:5px;min-height:max(var(--ag-list-item-height),calc(var(--ag-spacing)*4));overflow:hidden;&:where(.ag-picker-has-focus),&:where(:focus-within){background-color:var(--ag-picker-button-focus-background-color);border:var(--ag-picker-button-focus-border);box-shadow:var(--ag-focus-shadow);&:where(.invalid){box-shadow:var(--ag-focus-error-shadow)}}&:where(.invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&:disabled{opacity:.5}}`;
// packages/ag-grid-community/src/widgets/agPickerField.ts
var $437b23f6a393c3bf$var$AgPickerFieldElement = {
    tag: "div",
    cls: "ag-picker-field",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eLabel"
        },
        {
            tag: "div",
            ref: "eWrapper",
            cls: "ag-wrapper ag-picker-field-wrapper ag-picker-collapsed",
            children: [
                {
                    tag: "div",
                    ref: "eDisplayField",
                    cls: "ag-picker-field-display"
                },
                {
                    tag: "div",
                    ref: "eIcon",
                    cls: "ag-picker-field-icon",
                    attrs: {
                        "aria-hidden": "true"
                    }
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$export$1f14489b6fdeb99b = class extends $437b23f6a393c3bf$var$AgAbstractField {
    constructor(config){
        super(config, config?.template || $437b23f6a393c3bf$var$AgPickerFieldElement, config?.agComponents || [], config?.className);
        this.isPickerDisplayed = false;
        this.skipClick = false;
        this.pickerGap = 4;
        this.hideCurrentPicker = null;
        this.eLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eDisplayField = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eIcon = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.registerCSS($437b23f6a393c3bf$var$agPickerFieldCSS);
        this.ariaRole = config?.ariaRole;
        this.onPickerFocusIn = this.onPickerFocusIn.bind(this);
        this.onPickerFocusOut = this.onPickerFocusOut.bind(this);
        if (!config) return;
        const { pickerGap: pickerGap, maxPickerHeight: maxPickerHeight, variableWidth: variableWidth, minPickerWidth: minPickerWidth, maxPickerWidth: maxPickerWidth } = config;
        if (pickerGap != null) this.pickerGap = pickerGap;
        this.variableWidth = !!variableWidth;
        if (maxPickerHeight != null) this.setPickerMaxHeight(maxPickerHeight);
        if (minPickerWidth != null) this.setPickerMinWidth(minPickerWidth);
        if (maxPickerWidth != null) this.setPickerMaxWidth(maxPickerWidth);
    }
    postConstruct() {
        super.postConstruct();
        this.setupAria();
        const displayId = `ag-${this.getCompId()}-display`;
        this.eDisplayField.setAttribute("id", displayId);
        const ariaEl = this.getAriaElement();
        this.addManagedElementListeners(ariaEl, {
            keydown: this.onKeyDown.bind(this)
        });
        this.addManagedElementListeners(this.eLabel, {
            mousedown: this.onLabelOrWrapperMouseDown.bind(this)
        });
        this.addManagedElementListeners(this.eWrapper, {
            mousedown: this.onLabelOrWrapperMouseDown.bind(this)
        });
        const { pickerIcon: pickerIcon, inputWidth: inputWidth } = this.config;
        if (pickerIcon) {
            const icon = $437b23f6a393c3bf$export$d8feba07bf373edb(pickerIcon, this.beans);
            if (icon) this.eIcon.appendChild(icon);
        }
        if (inputWidth != null) this.setInputWidth(inputWidth);
    }
    setupAria() {
        const ariaEl = this.getAriaElement();
        ariaEl.setAttribute("tabindex", this.gos.get("tabIndex").toString());
        $437b23f6a393c3bf$export$3ad3518dddf15485(ariaEl, false);
        if (this.ariaRole) $437b23f6a393c3bf$export$f8d01fa01787902(ariaEl, this.ariaRole);
    }
    onLabelOrWrapperMouseDown(e) {
        if (e) {
            const focusableEl = this.getFocusableElement();
            if (focusableEl !== this.eWrapper && e?.target === focusableEl) return;
            e.preventDefault();
            this.getFocusableElement().focus();
        }
        if (this.skipClick) {
            this.skipClick = false;
            return;
        }
        if (this.isDisabled()) return;
        if (this.isPickerDisplayed) this.hidePicker();
        else this.showPicker();
    }
    onKeyDown(e) {
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE:
                e.preventDefault();
                this.onLabelOrWrapperMouseDown();
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                if (this.isPickerDisplayed) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (this.hideCurrentPicker) this.hideCurrentPicker();
                }
                break;
        }
    }
    showPicker() {
        this.isPickerDisplayed = true;
        if (!this.pickerComponent) this.pickerComponent = this.createPickerComponent();
        const pickerGui = this.pickerComponent.getGui();
        pickerGui.addEventListener("focusin", this.onPickerFocusIn);
        pickerGui.addEventListener("focusout", this.onPickerFocusOut);
        this.hideCurrentPicker = this.renderAndPositionPicker();
        this.toggleExpandedStyles(true);
    }
    renderAndPositionPicker() {
        const ePicker = this.pickerComponent.getGui();
        if (!this.gos.get("suppressScrollWhenPopupsAreOpen")) [this.destroyMouseWheelFunc] = this.addManagedEventListeners({
            bodyScroll: ()=>{
                this.hidePicker();
            }
        });
        const translate = this.getLocaleTextFunc();
        const { config: { pickerAriaLabelKey: pickerAriaLabelKey, pickerAriaLabelValue: pickerAriaLabelValue, modalPicker: modalPicker = true }, maxPickerHeight: maxPickerHeight, minPickerWidth: minPickerWidth, maxPickerWidth: maxPickerWidth, variableWidth: variableWidth, beans: beans, eWrapper: eWrapper } = this;
        const popupParams = {
            modal: modalPicker,
            eChild: ePicker,
            closeOnEsc: true,
            closedCallback: ()=>{
                const shouldRestoreFocus = $437b23f6a393c3bf$export$8ff9eef09a45371f(beans);
                this.beforeHidePicker();
                if (shouldRestoreFocus && this.isAlive()) this.getFocusableElement().focus();
            },
            ariaLabel: translate(pickerAriaLabelKey, pickerAriaLabelValue),
            anchorToElement: eWrapper
        };
        ePicker.style.position = "absolute";
        const popupSvc = beans.popupSvc;
        const addPopupRes = popupSvc.addPopup(popupParams);
        if (variableWidth) {
            if (minPickerWidth) ePicker.style.minWidth = minPickerWidth;
            ePicker.style.width = $437b23f6a393c3bf$var$_formatSize($437b23f6a393c3bf$export$642efcb17474eb51(eWrapper));
            if (maxPickerWidth) ePicker.style.maxWidth = maxPickerWidth;
        } else $437b23f6a393c3bf$var$_setElementWidth(ePicker, maxPickerWidth ?? $437b23f6a393c3bf$export$642efcb17474eb51(eWrapper));
        const maxHeight = maxPickerHeight ?? `${$437b23f6a393c3bf$export$c20e968103d9c16e(popupSvc.getPopupParent())}px`;
        ePicker.style.setProperty("max-height", maxHeight);
        this.alignPickerToComponent();
        return addPopupRes.hideFunc;
    }
    alignPickerToComponent() {
        if (!this.pickerComponent) return;
        const { pickerGap: pickerGap, config: { pickerType: pickerType }, beans: { popupSvc: popupSvc, gos: gos }, eWrapper: eWrapper, pickerComponent: pickerComponent } = this;
        const alignSide = gos.get("enableRtl") ? "right" : "left";
        popupSvc.positionPopupByComponent({
            type: pickerType,
            eventSource: eWrapper,
            ePopup: pickerComponent.getGui(),
            position: "under",
            alignSide: alignSide,
            keepWithinBounds: true,
            nudgeY: pickerGap
        });
    }
    beforeHidePicker() {
        if (this.destroyMouseWheelFunc) {
            this.destroyMouseWheelFunc();
            this.destroyMouseWheelFunc = void 0;
        }
        this.toggleExpandedStyles(false);
        const pickerGui = this.pickerComponent.getGui();
        pickerGui.removeEventListener("focusin", this.onPickerFocusIn);
        pickerGui.removeEventListener("focusout", this.onPickerFocusOut);
        this.isPickerDisplayed = false;
        this.pickerComponent = void 0;
        this.hideCurrentPicker = null;
    }
    toggleExpandedStyles(expanded) {
        if (!this.isAlive()) return;
        const ariaEl = this.getAriaElement();
        $437b23f6a393c3bf$export$3ad3518dddf15485(ariaEl, expanded);
        const classList = this.eWrapper.classList;
        classList.toggle("ag-picker-expanded", expanded);
        classList.toggle("ag-picker-collapsed", !expanded);
    }
    onPickerFocusIn() {
        this.togglePickerHasFocus(true);
    }
    onPickerFocusOut(e) {
        if (!this.pickerComponent?.getGui().contains(e.relatedTarget)) this.togglePickerHasFocus(false);
    }
    togglePickerHasFocus(focused) {
        if (!this.pickerComponent) return;
        this.eWrapper.classList.toggle("ag-picker-has-focus", focused);
    }
    hidePicker() {
        if (this.hideCurrentPicker) {
            this.hideCurrentPicker();
            this.dispatchLocalEvent({
                type: "pickerHidden"
            });
        }
    }
    setInputWidth(width) {
        $437b23f6a393c3bf$var$_setElementWidth(this.eWrapper, width);
        return this;
    }
    getFocusableElement() {
        return this.eWrapper;
    }
    setPickerGap(gap) {
        this.pickerGap = gap;
        return this;
    }
    setPickerMinWidth(width) {
        if (typeof width === "number") width = `${width}px`;
        this.minPickerWidth = width == null ? void 0 : width;
        return this;
    }
    setPickerMaxWidth(width) {
        if (typeof width === "number") width = `${width}px`;
        this.maxPickerWidth = width == null ? void 0 : width;
        return this;
    }
    setPickerMaxHeight(height) {
        if (typeof height === "number") height = `${height}px`;
        this.maxPickerHeight = height == null ? void 0 : height;
        return this;
    }
    destroy() {
        this.hidePicker();
        super.destroy();
    }
};
// packages/ag-grid-community/src/widgets/agSelect.css-GENERATED.ts
var $437b23f6a393c3bf$var$agSelectCSS = /*css*/ `.ag-select{align-items:center;display:flex;&.ag-disabled{opacity:.5}}:where(.ag-select){.ag-picker-field-wrapper{cursor:default}&.ag-disabled .ag-picker-field-wrapper:focus{box-shadow:none}&:not(.ag-cell-editor,.ag-label-align-top){min-height:var(--ag-list-item-height)}.ag-picker-field-display{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-picker-field-icon{align-items:center;display:flex}}:where(.ag-ltr) :where(.ag-select){.ag-picker-field-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding)/2);padding-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-select){.ag-picker-field-wrapper{padding-left:var(--ag-spacing);padding-right:calc(var(--ag-cell-horizontal-padding)/2)}}`;
// packages/ag-grid-community/src/widgets/agSelect.ts
var $437b23f6a393c3bf$export$6f9c460854d56032 = class extends $437b23f6a393c3bf$export$1f14489b6fdeb99b {
    constructor(config){
        super({
            pickerAriaLabelKey: "ariaLabelSelectField",
            pickerAriaLabelValue: "Select Field",
            pickerType: "ag-list",
            className: "ag-select",
            pickerIcon: "selectOpen",
            ariaRole: "combobox",
            ...config
        });
        this.registerCSS($437b23f6a393c3bf$var$agSelectCSS);
    }
    postConstruct() {
        this.tooltipFeature = this.createOptionalManagedBean(this.beans.registry.createDynamicBean("tooltipFeature", false, {
            shouldDisplayTooltip: $437b23f6a393c3bf$export$8980540b0a37a11d(()=>this.eDisplayField),
            getGui: ()=>this.getGui()
        }));
        super.postConstruct();
        this.createListComponent();
        this.eWrapper.tabIndex = this.gos.get("tabIndex");
        const { options: options, value: value, placeholder: placeholder } = this.config;
        if (options != null) this.addOptions(options);
        if (value != null) this.setValue(value, true);
        if (placeholder && value == null) this.eDisplayField.textContent = placeholder;
        this.addManagedElementListeners(this.eWrapper, {
            focusout: this.onWrapperFocusOut.bind(this)
        });
    }
    onWrapperFocusOut(e) {
        if (!this.eWrapper.contains(e.relatedTarget)) this.hidePicker();
    }
    createListComponent() {
        const listComponent = this.createBean(new $437b23f6a393c3bf$var$AgList("select", true));
        this.listComponent = listComponent;
        listComponent.setParentComponent(this);
        const eListAriaEl = listComponent.getAriaElement();
        const listId = `ag-select-list-${listComponent.getCompId()}`;
        eListAriaEl.setAttribute("id", listId);
        $437b23f6a393c3bf$export$6ff31a4a210c60ad(this.getAriaElement(), eListAriaEl);
        listComponent.addManagedElementListeners(listComponent.getGui(), {
            mousedown: (e)=>{
                e?.preventDefault();
            }
        });
        listComponent.addManagedListeners(listComponent, {
            selectedItem: ()=>{
                this.hidePicker();
                this.dispatchLocalEvent({
                    type: "selectedItem"
                });
            },
            fieldValueChanged: ()=>{
                if (!this.listComponent) return;
                this.setValue(this.listComponent.getValue(), false, true);
                this.hidePicker();
            }
        });
    }
    createPickerComponent() {
        return this.listComponent;
    }
    onKeyDown(e) {
        const { key: key } = e;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) this.hidePicker();
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                e.preventDefault();
                if (this.isPickerDisplayed) this.listComponent?.handleKeyDown(e);
                else super.onKeyDown(e);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                super.onKeyDown(e);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE:
                if (this.isPickerDisplayed) e.preventDefault();
                else super.onKeyDown(e);
                break;
        }
    }
    showPicker() {
        const listComponent = this.listComponent;
        if (!listComponent) return;
        super.showPicker();
        listComponent.refreshHighlighted();
    }
    addOptions(options) {
        options.forEach((option)=>this.addOption(option));
        return this;
    }
    addOption(option) {
        this.listComponent.addOption(option);
        return this;
    }
    clearOptions() {
        this.listComponent?.clearOptions();
        this.setValue(void 0, true);
        return this;
    }
    setValue(value, silent, fromPicker) {
        const { listComponent: listComponent, config: { placeholder: placeholder }, eDisplayField: eDisplayField, tooltipFeature: tooltipFeature } = this;
        if (this.value === value || !listComponent) return this;
        if (!fromPicker) listComponent.setValue(value, true);
        const newValue = listComponent.getValue();
        if (newValue === this.getValue()) return this;
        let displayValue = listComponent.getDisplayValue();
        if (displayValue == null && placeholder) displayValue = placeholder;
        eDisplayField.textContent = displayValue;
        tooltipFeature?.setTooltipAndRefresh(displayValue ?? null);
        return super.setValue(value, silent);
    }
    destroy() {
        this.listComponent = this.destroyBean(this.listComponent);
        super.destroy();
    }
};
var $437b23f6a393c3bf$export$e32612175ad118ef = {
    selector: "AG-SELECT",
    component: $437b23f6a393c3bf$export$6f9c460854d56032
};
// packages/ag-grid-community/src/widgets/tabGuardCtrl.ts
var $437b23f6a393c3bf$export$3be5727576441c72 = {
    TAB_GUARD: "ag-tab-guard",
    TAB_GUARD_TOP: "ag-tab-guard-top",
    TAB_GUARD_BOTTOM: "ag-tab-guard-bottom"
};
var $437b23f6a393c3bf$export$3074753638c3772c = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(params){
        super();
        this.skipTabGuardFocus = false;
        this.forcingFocusOut = false;
        // Used when `isFocusableContainer` enabled
        this.allowFocus = false;
        const { comp: comp, eTopGuard: eTopGuard, eBottomGuard: eBottomGuard, focusTrapActive: focusTrapActive, forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty, isFocusableContainer: isFocusableContainer, focusInnerElement: focusInnerElement, onFocusIn: onFocusIn, onFocusOut: onFocusOut, shouldStopEventPropagation: shouldStopEventPropagation, onTabKeyDown: onTabKeyDown, handleKeyDown: handleKeyDown, isEmpty: isEmpty, eFocusableElement: eFocusableElement } = params;
        this.comp = comp;
        this.eTopGuard = eTopGuard;
        this.eBottomGuard = eBottomGuard;
        this.providedFocusInnerElement = focusInnerElement;
        this.eFocusableElement = eFocusableElement;
        this.focusTrapActive = !!focusTrapActive;
        this.forceFocusOutWhenTabGuardsAreEmpty = !!forceFocusOutWhenTabGuardsAreEmpty;
        this.isFocusableContainer = !!isFocusableContainer;
        this.providedFocusIn = onFocusIn;
        this.providedFocusOut = onFocusOut;
        this.providedShouldStopEventPropagation = shouldStopEventPropagation;
        this.providedOnTabKeyDown = onTabKeyDown;
        this.providedHandleKeyDown = handleKeyDown;
        this.providedIsEmpty = isEmpty;
    }
    postConstruct() {
        this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(this.eFocusableElement, {
            shouldStopEventPropagation: ()=>this.shouldStopEventPropagation(),
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.handleKeyDown(e),
            onFocusIn: (e)=>this.onFocusIn(e),
            onFocusOut: (e)=>this.onFocusOut(e)
        }));
        this.activateTabGuards();
        [
            this.eTopGuard,
            this.eBottomGuard
        ].forEach((guard)=>this.addManagedElementListeners(guard, {
                focus: this.onFocus.bind(this)
            }));
    }
    handleKeyDown(e) {
        if (this.providedHandleKeyDown) this.providedHandleKeyDown(e);
    }
    tabGuardsAreActive() {
        return !!this.eTopGuard && this.eTopGuard.hasAttribute("tabIndex");
    }
    shouldStopEventPropagation() {
        if (this.providedShouldStopEventPropagation) return this.providedShouldStopEventPropagation();
        return false;
    }
    activateTabGuards() {
        if (this.forcingFocusOut) return;
        const tabIndex = this.gos.get("tabIndex");
        this.comp.setTabIndex(tabIndex.toString());
    }
    deactivateTabGuards() {
        this.comp.setTabIndex();
    }
    onFocus(e) {
        if (this.isFocusableContainer && !this.eFocusableElement.contains(e.relatedTarget)) {
            if (!this.allowFocus) {
                this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
                return;
            }
        }
        if (this.skipTabGuardFocus) {
            this.skipTabGuardFocus = false;
            return;
        }
        if (this.forceFocusOutWhenTabGuardsAreEmpty) {
            const isEmpty = this.providedIsEmpty ? this.providedIsEmpty() : $437b23f6a393c3bf$export$7acf44f59625b1f6(this.eFocusableElement, ".ag-tab-guard").length === 0;
            if (isEmpty) {
                this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
                return;
            }
        }
        if (this.isFocusableContainer && this.eFocusableElement.contains(e.relatedTarget)) return;
        const fromBottom = e.target === this.eBottomGuard;
        const hasFocusedInnerElement = this.providedFocusInnerElement ? this.providedFocusInnerElement(fromBottom) : this.focusInnerElement(fromBottom);
        if (!hasFocusedInnerElement && this.forceFocusOutWhenTabGuardsAreEmpty) this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
    }
    findNextElementOutsideAndFocus(up) {
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        const focusableEls = $437b23f6a393c3bf$export$7acf44f59625b1f6(eDocument.body, null, true);
        const index = focusableEls.indexOf(up ? this.eTopGuard : this.eBottomGuard);
        if (index === -1) return;
        let start;
        let end;
        if (up) {
            start = 0;
            end = index;
        } else {
            start = index + 1;
            end = focusableEls.length;
        }
        const focusableRange = focusableEls.slice(start, end);
        const targetTabIndex = this.gos.get("tabIndex");
        focusableRange.sort((a, b)=>{
            const indexA = parseInt(a.getAttribute("tabindex") || "0");
            const indexB = parseInt(b.getAttribute("tabindex") || "0");
            if (indexB === targetTabIndex) return 1;
            if (indexA === targetTabIndex) return -1;
            if (indexA === 0) return 1;
            if (indexB === 0) return -1;
            return indexA - indexB;
        });
        focusableRange[up ? focusableRange.length - 1 : 0]?.focus();
    }
    onFocusIn(e) {
        if (this.focusTrapActive || this.forcingFocusOut) return;
        if (this.providedFocusIn) this.providedFocusIn(e);
        if (!this.isFocusableContainer) this.deactivateTabGuards();
    }
    onFocusOut(e) {
        if (this.focusTrapActive) return;
        if (this.providedFocusOut) this.providedFocusOut(e);
        if (!this.eFocusableElement.contains(e.relatedTarget)) this.activateTabGuards();
    }
    onTabKeyDown(e) {
        if (this.providedOnTabKeyDown) {
            this.providedOnTabKeyDown(e);
            return;
        }
        if (this.focusTrapActive) return;
        if (e.defaultPrevented) return;
        const tabGuardsAreActive = this.tabGuardsAreActive();
        if (tabGuardsAreActive) this.deactivateTabGuards();
        const nextRoot = this.getNextFocusableElement(e.shiftKey);
        if (tabGuardsAreActive) setTimeout(()=>this.activateTabGuards(), 0);
        if (!nextRoot) return;
        nextRoot.focus();
        e.preventDefault();
    }
    focusInnerElement(fromBottom = false) {
        const focusable = $437b23f6a393c3bf$export$7acf44f59625b1f6(this.eFocusableElement);
        if (this.tabGuardsAreActive()) {
            focusable.splice(0, 1);
            focusable.splice(focusable.length - 1, 1);
        }
        if (!focusable.length) return false;
        focusable[fromBottom ? focusable.length - 1 : 0].focus({
            preventScroll: true
        });
        return true;
    }
    getNextFocusableElement(backwards) {
        return $437b23f6a393c3bf$export$83fc12531358bd28(this.beans, this.eFocusableElement, false, backwards);
    }
    forceFocusOutOfContainer(up = false) {
        if (this.forcingFocusOut) return;
        const tabGuardToFocus = up ? this.eTopGuard : this.eBottomGuard;
        this.activateTabGuards();
        this.skipTabGuardFocus = true;
        this.forcingFocusOut = true;
        tabGuardToFocus.focus();
        window.setTimeout(()=>{
            this.forcingFocusOut = false;
            this.activateTabGuards();
        });
    }
    isTabGuard(element, bottom) {
        return element === this.eTopGuard && !bottom || element === this.eBottomGuard && (bottom ?? true);
    }
    setAllowFocus(allowFocus) {
        this.allowFocus = allowFocus;
    }
};
// packages/ag-grid-community/src/widgets/tabGuardFeature.ts
var $437b23f6a393c3bf$export$299cbf451479e921 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(comp){
        super();
        this.comp = comp;
    }
    initialiseTabGuard(params) {
        this.eTopGuard = this.createTabGuard("top");
        this.eBottomGuard = this.createTabGuard("bottom");
        this.eFocusableElement = this.comp.getFocusableElement();
        const { eTopGuard: eTopGuard, eBottomGuard: eBottomGuard, eFocusableElement: eFocusableElement } = this;
        const tabGuards = [
            eTopGuard,
            eBottomGuard
        ];
        const compProxy = {
            setTabIndex: (tabIndex)=>{
                tabGuards.forEach((tabGuard)=>tabIndex != null ? tabGuard.setAttribute("tabindex", tabIndex) : tabGuard.removeAttribute("tabindex"));
            }
        };
        this.addTabGuards(eTopGuard, eBottomGuard);
        const { focusTrapActive: focusTrapActive = false, onFocusIn: onFocusIn, onFocusOut: onFocusOut, focusInnerElement: focusInnerElement, handleKeyDown: handleKeyDown, onTabKeyDown: onTabKeyDown, shouldStopEventPropagation: shouldStopEventPropagation, isEmpty: isEmpty, forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty, isFocusableContainer: isFocusableContainer } = params;
        this.tabGuardCtrl = this.createManagedBean(new $437b23f6a393c3bf$export$3074753638c3772c({
            comp: compProxy,
            focusTrapActive: focusTrapActive,
            eTopGuard: eTopGuard,
            eBottomGuard: eBottomGuard,
            eFocusableElement: eFocusableElement,
            onFocusIn: onFocusIn,
            onFocusOut: onFocusOut,
            focusInnerElement: focusInnerElement,
            handleKeyDown: handleKeyDown,
            onTabKeyDown: onTabKeyDown,
            shouldStopEventPropagation: shouldStopEventPropagation,
            isEmpty: isEmpty,
            forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty,
            isFocusableContainer: isFocusableContainer
        }));
    }
    getTabGuardCtrl() {
        return this.tabGuardCtrl;
    }
    createTabGuard(side) {
        const tabGuard = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans).createElement("div");
        const cls = side === "top" ? $437b23f6a393c3bf$export$3be5727576441c72.TAB_GUARD_TOP : $437b23f6a393c3bf$export$3be5727576441c72.TAB_GUARD_BOTTOM;
        tabGuard.classList.add($437b23f6a393c3bf$export$3be5727576441c72.TAB_GUARD, cls);
        $437b23f6a393c3bf$export$f8d01fa01787902(tabGuard, "presentation");
        return tabGuard;
    }
    addTabGuards(topTabGuard, bottomTabGuard) {
        const eFocusableElement = this.eFocusableElement;
        eFocusableElement.insertAdjacentElement("afterbegin", topTabGuard);
        eFocusableElement.insertAdjacentElement("beforeend", bottomTabGuard);
    }
    removeAllChildrenExceptTabGuards() {
        const tabGuards = [
            this.eTopGuard,
            this.eBottomGuard
        ];
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.comp.getFocusableElement());
        this.addTabGuards(...tabGuards);
    }
    forceFocusOutOfContainer(up = false) {
        this.tabGuardCtrl.forceFocusOutOfContainer(up);
    }
    appendChild(appendChild, newChild, container) {
        if (!$437b23f6a393c3bf$export$6e6303ef478b0c94(newChild)) newChild = newChild.getGui();
        const { eBottomGuard: bottomTabGuard } = this;
        if (bottomTabGuard) bottomTabGuard.insertAdjacentElement("beforebegin", newChild);
        else appendChild(newChild, container);
    }
    destroy() {
        const { eTopGuard: eTopGuard, eBottomGuard: eBottomGuard } = this;
        $437b23f6a393c3bf$export$dd4d52e41fb4cef5(eTopGuard);
        $437b23f6a393c3bf$export$dd4d52e41fb4cef5(eBottomGuard);
        super.destroy();
    }
};
// packages/ag-grid-community/src/widgets/tabGuardComp.ts
var $437b23f6a393c3bf$export$5a26e3abd1c845b6 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    initialiseTabGuard(params) {
        this.tabGuardFeature = this.createManagedBean(new $437b23f6a393c3bf$export$299cbf451479e921(this));
        this.tabGuardFeature.initialiseTabGuard(params);
    }
    forceFocusOutOfContainer(up = false) {
        this.tabGuardFeature.forceFocusOutOfContainer(up);
    }
    appendChild(newChild, container) {
        this.tabGuardFeature.appendChild(super.appendChild.bind(this), newChild, container);
    }
};
// packages/ag-grid-community/src/widgets/touchListener.ts
var $437b23f6a393c3bf$export$7b2e93987414b382 = class {
    constructor(eElement, preventMouseClick = false){
        this.DOUBLE_TAP_MILLIS = 500;
        this.destroyFuncs = [];
        this.touching = false;
        this.localEventService = new $437b23f6a393c3bf$export$820da7696a401cdc();
        this.preventMouseClick = preventMouseClick;
        const startListener = this.onTouchStart.bind(this);
        const moveListener = this.onTouchMove.bind(this);
        const endListener = this.onTouchEnd.bind(this);
        eElement.addEventListener("touchstart", startListener, {
            passive: true
        });
        eElement.addEventListener("touchmove", moveListener, {
            passive: true
        });
        eElement.addEventListener("touchend", endListener, {
            passive: false
        });
        this.destroyFuncs.push(()=>{
            eElement.removeEventListener("touchstart", startListener, {
                passive: true
            });
            eElement.removeEventListener("touchmove", moveListener, {
                passive: true
            });
            eElement.removeEventListener("touchend", endListener, {
                passive: false
            });
        });
    }
    getActiveTouch(touchList) {
        for(let i = 0; i < touchList.length; i++){
            const matches = touchList[i].identifier === this.touchStart.identifier;
            if (matches) return touchList[i];
        }
        return null;
    }
    addEventListener(eventType, listener) {
        this.localEventService.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        this.localEventService.removeEventListener(eventType, listener);
    }
    onTouchStart(touchEvent) {
        if (this.touching) return;
        this.touchStart = touchEvent.touches[0];
        this.touching = true;
        this.moved = false;
        const touchStartCopy = this.touchStart;
        window.setTimeout(()=>{
            const touchesMatch = this.touchStart === touchStartCopy;
            if (this.touching && touchesMatch && !this.moved) {
                this.moved = true;
                const event = {
                    type: "longTap",
                    touchStart: this.touchStart,
                    touchEvent: touchEvent
                };
                this.localEventService.dispatchEvent(event);
            }
        }, 500);
    }
    onTouchMove(touchEvent) {
        if (!this.touching) return;
        const touch = this.getActiveTouch(touchEvent.touches);
        if (!touch) return;
        const eventIsFarAway = !$437b23f6a393c3bf$var$_areEventsNear(touch, this.touchStart, 4);
        if (eventIsFarAway) this.moved = true;
    }
    onTouchEnd(touchEvent) {
        if (!this.touching) return;
        if (!this.moved) {
            const event = {
                type: "tap",
                touchStart: this.touchStart
            };
            this.localEventService.dispatchEvent(event);
            this.checkForDoubleTap();
        }
        if (this.preventMouseClick && touchEvent.cancelable) touchEvent.preventDefault();
        this.touching = false;
    }
    checkForDoubleTap() {
        const now = Date.now();
        if (this.lastTapTime && this.lastTapTime > 0) {
            const interval = now - this.lastTapTime;
            if (interval > this.DOUBLE_TAP_MILLIS) {
                const event = {
                    type: "doubleTap",
                    touchStart: this.touchStart
                };
                this.localEventService.dispatchEvent(event);
                this.lastTapTime = null;
            } else this.lastTapTime = now;
        } else this.lastTapTime = now;
    }
    destroy() {
        this.destroyFuncs.forEach((func)=>func());
    }
};
// packages/ag-grid-community/src/interfaces/IRangeService.ts
var $437b23f6a393c3bf$export$162bc75b85f28397 = /* @__PURE__ */ ((CellRangeType2)=>{
    CellRangeType2[CellRangeType2["VALUE"] = 0] = "VALUE";
    CellRangeType2[CellRangeType2["DIMENSION"] = 1] = "DIMENSION";
    return CellRangeType2;
})($437b23f6a393c3bf$export$162bc75b85f28397 || {});
// packages/ag-grid-community/src/autoScrollService.ts
var $437b23f6a393c3bf$export$c66bdc3d55a4f95 = class {
    constructor(params){
        this.tickingInterval = null;
        this.onScrollCallback = null;
        this.scrollContainer = params.scrollContainer;
        this.scrollHorizontally = params.scrollAxis.indexOf("x") !== -1;
        this.scrollVertically = params.scrollAxis.indexOf("y") !== -1;
        this.scrollByTick = params.scrollByTick != null ? params.scrollByTick : 20;
        if (params.onScrollCallback) this.onScrollCallback = params.onScrollCallback;
        if (this.scrollVertically) {
            this.getVerticalPosition = params.getVerticalPosition;
            this.setVerticalPosition = params.setVerticalPosition;
        }
        if (this.scrollHorizontally) {
            this.getHorizontalPosition = params.getHorizontalPosition;
            this.setHorizontalPosition = params.setHorizontalPosition;
        }
        this.shouldSkipVerticalScroll = params.shouldSkipVerticalScroll || (()=>false);
        this.shouldSkipHorizontalScroll = params.shouldSkipHorizontalScroll || (()=>false);
    }
    check(mouseEvent, forceSkipVerticalScroll = false) {
        const skipVerticalScroll = forceSkipVerticalScroll || this.shouldSkipVerticalScroll();
        if (skipVerticalScroll && this.shouldSkipHorizontalScroll()) return;
        const rect = this.scrollContainer.getBoundingClientRect();
        const scrollTick = this.scrollByTick;
        this.tickLeft = mouseEvent.clientX < rect.left + scrollTick;
        this.tickRight = mouseEvent.clientX > rect.right - scrollTick;
        this.tickUp = mouseEvent.clientY < rect.top + scrollTick && !skipVerticalScroll;
        this.tickDown = mouseEvent.clientY > rect.bottom - scrollTick && !skipVerticalScroll;
        if (this.tickLeft || this.tickRight || this.tickUp || this.tickDown) this.ensureTickingStarted();
        else this.ensureCleared();
    }
    ensureTickingStarted() {
        if (this.tickingInterval === null) {
            this.tickingInterval = window.setInterval(this.doTick.bind(this), 100);
            this.tickCount = 0;
        }
    }
    doTick() {
        this.tickCount++;
        const tickAmount = this.tickCount > 20 ? 200 : this.tickCount > 10 ? 80 : 40;
        if (this.scrollVertically) {
            const vScrollPosition = this.getVerticalPosition();
            if (this.tickUp) this.setVerticalPosition(vScrollPosition - tickAmount);
            if (this.tickDown) this.setVerticalPosition(vScrollPosition + tickAmount);
        }
        if (this.scrollHorizontally) {
            const hScrollPosition = this.getHorizontalPosition();
            if (this.tickLeft) this.setHorizontalPosition(hScrollPosition - tickAmount);
            if (this.tickRight) this.setHorizontalPosition(hScrollPosition + tickAmount);
        }
        if (this.onScrollCallback) this.onScrollCallback();
    }
    ensureCleared() {
        if (this.tickingInterval) {
            window.clearInterval(this.tickingInterval);
            this.tickingInterval = null;
        }
    }
};
// packages/ag-grid-community/src/vanillaFrameworkOverrides.ts
var $437b23f6a393c3bf$export$8174ad74937c6482 = class {
    constructor(frameworkName = "javascript"){
        this.frameworkName = frameworkName;
        this.renderingEngine = "vanilla";
        this.batchFrameworkComps = false;
        this.wrapIncoming = (callback)=>callback();
        this.wrapOutgoing = (callback)=>callback();
        this.baseDocLink = `${$437b23f6a393c3bf$var$BASE_URL}/${this.frameworkName}-data-grid`;
        $437b23f6a393c3bf$var$setValidationDocLink(this.baseDocLink);
    }
    setInterval(action, timeout) {
        return new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
            resolve(window.setInterval(action, timeout));
        });
    }
    // for Vanilla JS, we just add the event to the element
    addEventListener(element, type, listener, options) {
        let eventListenerOptions = {};
        if (typeof options === "object") eventListenerOptions = options;
        else if (typeof options === "boolean") eventListenerOptions = {
            capture: options
        };
        if (eventListenerOptions.passive == null) {
            const passive = $437b23f6a393c3bf$var$getPassiveStateForEvent(type);
            if (passive != null) eventListenerOptions.passive = passive;
        }
        element.addEventListener(type, listener, eventListenerOptions);
    }
    frameworkComponent(_) {
        return null;
    }
    isFrameworkComponent(_) {
        return false;
    }
    getDocLink(path) {
        return `${this.baseDocLink}${path ? `/${path}` : ""}`;
    }
};
// packages/ag-grid-community/src/api/apiUtils.ts
function $437b23f6a393c3bf$var$createGridApi(context) {
    return {
        beanName: "gridApi",
        bean: context.getBean("apiFunctionSvc").api
    };
}
// packages/ag-grid-community/src/context/gridBeanComparator.ts
var $437b23f6a393c3bf$var$orderedCoreBeans = [
    // Validate license first
    "licenseManager",
    // core beans only
    "environment",
    "eventSvc",
    "gos",
    "paginationAutoPageSizeSvc",
    "apiFunctionSvc",
    "gridApi",
    "registry",
    "agCompUtils",
    "userCompFactory",
    "rowContainerHeight",
    "horizontalResizeSvc",
    "localeSvc",
    "pinnedRowModel",
    "dragSvc",
    "colGroupSvc",
    "visibleCols",
    "popupSvc",
    "selectionSvc",
    "colFilter",
    "quickFilter",
    "filterManager",
    "colModel",
    "headerNavigation",
    "pageBounds",
    "pagination",
    "pageBoundsListener",
    "rowSpanSvc",
    "stickyRowSvc",
    "rowRenderer",
    "expressionSvc",
    "alignedGridsSvc",
    "navigation",
    "valueCache",
    "valueSvc",
    "autoWidthCalc",
    "filterMenuFactory",
    "dragAndDrop",
    "focusSvc",
    "cellNavigation",
    "cellStyles",
    "scrollVisibleSvc",
    "sortSvc",
    "colHover",
    "colAnimation",
    "autoColSvc",
    "selectionColSvc",
    "changeDetectionSvc",
    "animationFrameSvc",
    "undoRedo",
    "colDefFactory",
    "rowStyleSvc",
    "rowNodeBlockLoader",
    "rowNodeSorter",
    "ctrlsSvc",
    "pinnedCols",
    "dataTypeSvc",
    "syncSvc",
    "overlays",
    "stateSvc",
    "expansionSvc",
    "apiEventSvc",
    "ariaAnnounce",
    "menuSvc",
    "colMoves",
    "colAutosize",
    "colFlex",
    "colResize",
    "pivotColsSvc",
    "valueColsSvc",
    "rowGroupColsSvc",
    "funcColsSvc",
    "colNames",
    "colViewport",
    "pivotResultCols",
    "showRowGroupCols",
    "validation"
];
var $437b23f6a393c3bf$var$beanNamePosition = Object.fromEntries($437b23f6a393c3bf$var$orderedCoreBeans.map((beanName, index)=>[
        beanName,
        index
    ]));
function $437b23f6a393c3bf$var$gridBeanInitComparator(bean1, bean2) {
    const index1 = (bean1.beanName ? $437b23f6a393c3bf$var$beanNamePosition[bean1.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER;
    const index2 = (bean2.beanName ? $437b23f6a393c3bf$var$beanNamePosition[bean2.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER;
    return index1 - index2;
}
function $437b23f6a393c3bf$var$gridBeanDestroyComparator(bean1, bean2) {
    if (bean1?.beanName === "gridDestroySvc") return -1;
    if (bean2?.beanName === "gridDestroySvc") return 1;
    return 0;
}
// packages/ag-grid-community/src/headerRendering/rowContainer/headerRowContainerComp.ts
var $437b23f6a393c3bf$var$PinnedLeftElement = {
    tag: "div",
    cls: "ag-pinned-left-header",
    role: "rowgroup"
};
var $437b23f6a393c3bf$var$PinnedRightElement = {
    tag: "div",
    cls: "ag-pinned-right-header",
    role: "rowgroup"
};
var $437b23f6a393c3bf$var$CenterElement = {
    tag: "div",
    cls: "ag-header-viewport",
    role: "presentation",
    attrs: {
        tabindex: "-1"
    },
    children: [
        {
            tag: "div",
            ref: "eCenterContainer",
            cls: "ag-header-container",
            role: "rowgroup"
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderRowContainerComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(pinned){
        super();
        this.eCenterContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.headerRowComps = {};
        this.rowCompsList = [];
        this.pinned = pinned;
    }
    postConstruct() {
        this.selectAndSetTemplate();
        const compProxy = {
            setDisplayed: (displayed)=>this.setDisplayed(displayed),
            setCtrls: (ctrls)=>this.setCtrls(ctrls),
            // only gets called for center section
            setCenterWidth: (width)=>this.eCenterContainer.style.width = width,
            setViewportScrollLeft: (left)=>this.getGui().scrollLeft = left,
            // only gets called for pinned sections
            setPinnedContainerWidth: (width)=>{
                const eGui = this.getGui();
                eGui.style.width = width;
                eGui.style.maxWidth = width;
                eGui.style.minWidth = width;
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$1e864ee88f54e7b(this.pinned));
        ctrl.setComp(compProxy, this.getGui());
    }
    selectAndSetTemplate() {
        const pinnedLeft = this.pinned == "left";
        const pinnedRight = this.pinned == "right";
        const template = pinnedLeft ? $437b23f6a393c3bf$var$PinnedLeftElement : pinnedRight ? $437b23f6a393c3bf$var$PinnedRightElement : $437b23f6a393c3bf$var$CenterElement;
        this.setTemplate(template);
        this.eRowContainer = this.eCenterContainer !== $437b23f6a393c3bf$export$6c811454646ed8be ? this.eCenterContainer : this.getGui();
    }
    destroy() {
        this.setCtrls([]);
        super.destroy();
    }
    destroyRowComp(rowComp) {
        this.destroyBean(rowComp);
        this.eRowContainer.removeChild(rowComp.getGui());
    }
    setCtrls(ctrls) {
        const oldRowComps = this.headerRowComps;
        this.headerRowComps = {};
        this.rowCompsList = [];
        let prevGui;
        const appendEnsuringDomOrder = (rowComp)=>{
            const eGui = rowComp.getGui();
            const notAlreadyIn = eGui.parentElement != this.eRowContainer;
            if (notAlreadyIn) this.eRowContainer.appendChild(eGui);
            if (prevGui) $437b23f6a393c3bf$var$_ensureDomOrder(this.eRowContainer, eGui, prevGui);
            prevGui = eGui;
        };
        ctrls.forEach((ctrl)=>{
            const ctrlId = ctrl.instanceId;
            const existingComp = oldRowComps[ctrlId];
            delete oldRowComps[ctrlId];
            const rowComp = existingComp ? existingComp : this.createBean(new $437b23f6a393c3bf$var$HeaderRowComp(ctrl));
            this.headerRowComps[ctrlId] = rowComp;
            this.rowCompsList.push(rowComp);
            appendEnsuringDomOrder(rowComp);
        });
        Object.values(oldRowComps).forEach((c)=>this.destroyRowComp(c));
    }
};
// packages/ag-grid-community/src/headerRendering/gridHeaderComp.ts
var $437b23f6a393c3bf$var$GridHeaderElement = {
    tag: "div",
    cls: "ag-header",
    role: "presentation"
};
var $437b23f6a393c3bf$var$GridHeaderComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$GridHeaderElement);
    }
    postConstruct() {
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            setHeightAndMinHeight: (height)=>{
                this.getGui().style.height = height;
                this.getGui().style.minHeight = height;
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$20b300eb69ca4d09());
        ctrl.setComp(compProxy, this.getGui(), this.getFocusableElement());
        const addContainer = (container)=>{
            this.createManagedBean(container);
            this.appendChild(container);
        };
        addContainer(new $437b23f6a393c3bf$var$HeaderRowContainerComp("left"));
        addContainer(new $437b23f6a393c3bf$var$HeaderRowContainerComp(null));
        addContainer(new $437b23f6a393c3bf$var$HeaderRowContainerComp("right"));
    }
};
var $437b23f6a393c3bf$var$GridHeaderSelector = {
    selector: "AG-HEADER-ROOT",
    component: $437b23f6a393c3bf$var$GridHeaderComp
};
// packages/ag-grid-community/src/rendering/cell/cellComp.ts
var $437b23f6a393c3bf$var$CellComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(beans, cellCtrl, printLayout, eRow, editingCell){
        super();
        this.cellCtrl = cellCtrl;
        // every time we go into edit mode, or back again, this gets incremented.
        // it's the components way of dealing with the async nature of framework components,
        // so if a framework component takes a while to be created, we know if the object
        // is still relevant when creating is finished. eg we could click edit / un-edit 20
        // times before the first React edit component comes back - we should discard
        // the first 19.
        this.rendererVersion = 0;
        this.editorVersion = 0;
        this.beans = beans;
        this.gos = beans.gos;
        this.column = cellCtrl.column;
        this.rowNode = cellCtrl.rowNode;
        this.eRow = eRow;
        const cellDiv = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            role: cellCtrl.getCellAriaRole(),
            attrs: {
                "comp-id": `${this.getCompId()}`,
                "col-id": cellCtrl.column.colIdSanitised
            }
        });
        this.eCell = cellDiv;
        let wrapperDiv;
        if (cellCtrl.isCellSpanning()) {
            wrapperDiv = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "div",
                cls: "ag-spanned-cell-wrapper",
                role: "presentation"
            });
            wrapperDiv.appendChild(cellDiv);
            this.setTemplateFromElement(wrapperDiv);
        } else this.setTemplateFromElement(cellDiv);
        this.cellCssManager = new $437b23f6a393c3bf$export$a7053cb7eb605bd2(()=>cellDiv);
        this.forceWrapper = cellCtrl.isForceWrapper();
        this.refreshWrapper(false);
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.cellCssManager.toggleCss(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(cellDiv, styles),
            getFocusableElement: ()=>cellDiv,
            setIncludeSelection: (include)=>this.includeSelection = include,
            setIncludeRowDrag: (include)=>this.includeRowDrag = include,
            setIncludeDndSource: (include)=>this.includeDndSource = include,
            setRenderDetails: (compDetails, valueToDisplay, force)=>this.setRenderDetails(compDetails, valueToDisplay, force),
            setEditDetails: (compDetails, popup, position)=>this.setEditDetails(compDetails, popup, position),
            getCellEditor: ()=>this.cellEditor || null,
            getCellRenderer: ()=>this.cellRenderer || null,
            getParentOfValue: ()=>this.getParentOfValue(),
            refreshEditStyles: (editing, isPopup)=>this.refreshEditStyles(editing, isPopup)
        };
        cellCtrl.setComp(compProxy, cellDiv, wrapperDiv, this.eCellWrapper, printLayout, editingCell, void 0);
    }
    getParentOfValue() {
        return this.eCellValue ?? this.eCellWrapper ?? this.eCell;
    }
    setRenderDetails(compDetails, valueToDisplay, forceNewCellRendererInstance) {
        const isInlineEditing = this.cellEditor && !this.cellEditorPopupWrapper;
        if (isInlineEditing) return;
        this.firstRender = this.firstRender == null;
        const controlWrapperChanged = this.refreshWrapper(false);
        this.refreshEditStyles(false);
        if (compDetails) {
            const neverRefresh = forceNewCellRendererInstance || controlWrapperChanged;
            const cellRendererRefreshSuccessful = neverRefresh ? false : this.refreshCellRenderer(compDetails);
            if (!cellRendererRefreshSuccessful) {
                this.destroyRenderer();
                this.createCellRendererInstance(compDetails);
            }
        } else {
            this.destroyRenderer();
            this.insertValueWithoutCellRenderer(valueToDisplay);
        }
    }
    setEditDetails(compDetails, popup, position) {
        if (compDetails) this.createCellEditorInstance(compDetails, popup, position);
        else this.destroyEditor();
    }
    removeControls() {
        const context = this.beans.context;
        this.checkboxSelectionComp = context.destroyBean(this.checkboxSelectionComp);
        this.dndSourceComp = context.destroyBean(this.dndSourceComp);
        this.rowDraggingComp = context.destroyBean(this.rowDraggingComp);
    }
    // returns true if wrapper was changed
    refreshWrapper(editing) {
        const providingControls = this.includeRowDrag || this.includeDndSource || this.includeSelection;
        const usingWrapper = providingControls || this.forceWrapper;
        const putWrapperIn = usingWrapper && this.eCellWrapper == null;
        if (putWrapperIn) {
            this.eCellWrapper = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "div",
                cls: "ag-cell-wrapper",
                role: "presentation"
            });
            this.eCell.appendChild(this.eCellWrapper);
        }
        const takeWrapperOut = !usingWrapper && this.eCellWrapper != null;
        if (takeWrapperOut) {
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.eCellWrapper);
            this.eCellWrapper = void 0;
        }
        this.cellCssManager.toggleCss("ag-cell-value", !usingWrapper);
        const usingCellValue = !editing && usingWrapper;
        const putCellValueIn = usingCellValue && this.eCellValue == null;
        if (putCellValueIn) {
            this.eCellValue = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "span",
                cls: "ag-cell-value",
                role: "presentation"
            });
            this.eCellWrapper.appendChild(this.eCellValue);
        }
        const takeCellValueOut = !usingCellValue && this.eCellValue != null;
        if (takeCellValueOut) {
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.eCellValue);
            this.eCellValue = void 0;
        }
        const templateChanged = putWrapperIn || takeWrapperOut || putCellValueIn || takeCellValueOut;
        if (templateChanged) this.removeControls();
        if (!editing && providingControls) this.addControls();
        return templateChanged;
    }
    addControls() {
        const { cellCtrl: cellCtrl, eCellWrapper: eCellWrapper, eCellValue: eCellValue, includeRowDrag: includeRowDrag, includeDndSource: includeDndSource, includeSelection: includeSelection } = this;
        const insertBefore = (comp)=>{
            if (comp) eCellWrapper.insertBefore(comp.getGui(), eCellValue);
        };
        if (includeRowDrag && this.rowDraggingComp == null) {
            this.rowDraggingComp = cellCtrl.createRowDragComp();
            insertBefore(this.rowDraggingComp);
        }
        if (includeDndSource && this.dndSourceComp == null) {
            this.dndSourceComp = cellCtrl.createDndSource();
            insertBefore(this.dndSourceComp);
        }
        if (includeSelection && this.checkboxSelectionComp == null) {
            this.checkboxSelectionComp = cellCtrl.createSelectionCheckbox();
            insertBefore(this.checkboxSelectionComp);
        }
    }
    createCellEditorInstance(compDetails, popup, position) {
        const versionCopy = this.editorVersion;
        const cellEditorPromise = compDetails.newAgStackInstance();
        const { params: params } = compDetails;
        cellEditorPromise.then((c)=>this.afterCellEditorCreated(versionCopy, c, params, popup, position));
        const cellEditorAsync = $437b23f6a393c3bf$export$672d9e47bc342bac(this.cellEditor);
        if (cellEditorAsync && params.cellStartedEdit) this.cellCtrl.focusCell(true);
    }
    insertValueWithoutCellRenderer(valueToDisplay) {
        const eParent = this.getParentOfValue();
        $437b23f6a393c3bf$export$69e6e10709eabd91(eParent);
        const escapedValue = $437b23f6a393c3bf$export$a16cfb6652fe466f(valueToDisplay);
        if (escapedValue != null) eParent.textContent = escapedValue;
    }
    destroyRenderer() {
        const { context: context } = this.beans;
        this.cellRenderer = context.destroyBean(this.cellRenderer);
        $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.cellRendererGui);
        this.cellRendererGui = null;
        this.rendererVersion++;
    }
    destroyEditor() {
        const { context: context } = this.beans;
        const recoverFocus = this.cellEditorPopupWrapper?.getGui().contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans)) || this.cellCtrl.hasBrowserFocus();
        if (recoverFocus) this.eCell.focus({
            preventScroll: true
        });
        this.hideEditorPopup?.();
        this.hideEditorPopup = void 0;
        this.cellEditor = context.destroyBean(this.cellEditor);
        this.cellEditorPopupWrapper = context.destroyBean(this.cellEditorPopupWrapper);
        $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.cellEditorGui);
        this.cellCtrl.disableEditorTooltipFeature();
        this.cellEditorGui = null;
        this.editorVersion++;
    }
    refreshCellRenderer(compClassAndParams) {
        if (this.cellRenderer?.refresh == null) return false;
        if (this.cellRendererClass !== compClassAndParams.componentClass) return false;
        const result = this.cellRenderer.refresh(compClassAndParams.params);
        return result === true || result === void 0;
    }
    createCellRendererInstance(compDetails) {
        const displayComponentVersionCopy = this.rendererVersion;
        const createCellRendererFunc = (details)=>(_)=>{
                const staleTask = this.rendererVersion !== displayComponentVersionCopy || !this.isAlive();
                if (staleTask) return;
                const componentPromise = details.newAgStackInstance();
                const callback = this.afterCellRendererCreated.bind(this, displayComponentVersionCopy, details.componentClass);
                componentPromise?.then(callback);
            };
        const { animationFrameSvc: animationFrameSvc } = this.beans;
        let createTask;
        if (animationFrameSvc?.active && this.firstRender) createTask = (details, isDeferred = false)=>{
            animationFrameSvc.createTask(createCellRendererFunc(details), this.rowNode.rowIndex, "p2", details.componentFromFramework, isDeferred);
        };
        else createTask = (details)=>createCellRendererFunc(details)();
        if (compDetails.params?.deferRender && !this.cellCtrl.rowNode.group) {
            const { loadingComp: loadingComp, onReady: onReady } = this.cellCtrl.getDeferLoadingCellRenderer();
            if (loadingComp) {
                createTask(loadingComp);
                onReady.then(()=>createTask(compDetails, true));
            }
        } else createTask(compDetails);
    }
    afterCellRendererCreated(cellRendererVersion, cellRendererClass, cellRenderer) {
        const staleTask = !this.isAlive() || cellRendererVersion !== this.rendererVersion;
        if (staleTask) {
            this.beans.context.destroyBean(cellRenderer);
            return;
        }
        this.cellRenderer = cellRenderer;
        this.cellRendererClass = cellRendererClass;
        const cellGui = cellRenderer.getGui();
        this.cellRendererGui = cellGui;
        if (cellGui != null) {
            const eParent = this.getParentOfValue();
            $437b23f6a393c3bf$export$69e6e10709eabd91(eParent);
            eParent.appendChild(cellGui);
        }
    }
    afterCellEditorCreated(requestVersion, cellEditor, params, popup, position) {
        const staleComp = requestVersion !== this.editorVersion;
        const { context: context } = this.beans;
        if (staleComp) {
            context.destroyBean(cellEditor);
            return;
        }
        const editingCancelledByUserComp = cellEditor.isCancelBeforeStart && cellEditor.isCancelBeforeStart();
        if (editingCancelledByUserComp) {
            context.destroyBean(cellEditor);
            this.cellCtrl.stopEditing(true);
            return;
        }
        if (!cellEditor.getGui) {
            $437b23f6a393c3bf$export$545083624300f13d(97, {
                colId: this.column.getId()
            });
            context.destroyBean(cellEditor);
            return;
        }
        this.cellEditor = cellEditor;
        this.cellEditorGui = cellEditor.getGui();
        const cellEditorInPopup = popup || cellEditor.isPopup !== void 0 && cellEditor.isPopup();
        if (cellEditorInPopup) this.addPopupCellEditor(params, position);
        else this.addInCellEditor();
        this.refreshEditStyles(true, cellEditorInPopup);
        cellEditor.afterGuiAttached?.();
        this.cellCtrl.enableEditorTooltipFeature(cellEditor);
        this.cellCtrl.cellEditorAttached();
    }
    refreshEditStyles(editing, isPopup) {
        const { cellCssManager: cellCssManager } = this;
        cellCssManager.toggleCss("ag-cell-inline-editing", editing && !isPopup);
        cellCssManager.toggleCss("ag-cell-popup-editing", editing && !!isPopup);
        cellCssManager.toggleCss("ag-cell-not-inline-editing", !editing || !!isPopup);
    }
    addInCellEditor() {
        const { eCell: eCell } = this;
        if (eCell.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans))) eCell.focus();
        this.destroyRenderer();
        this.refreshWrapper(true);
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.getParentOfValue());
        if (this.cellEditorGui) {
            const eParent = this.getParentOfValue();
            eParent.appendChild(this.cellEditorGui);
        }
    }
    addPopupCellEditor(params, position) {
        const { gos: gos, context: context, popupSvc: popupSvc, editSvc: editSvc } = this.beans;
        if (gos.get("editType") === "fullRow") $437b23f6a393c3bf$export$545083624300f13d(98);
        const cellEditorPopupWrapper = this.cellEditorPopupWrapper = context.createBean(editSvc.createPopupEditorWrapper(params));
        const { cellEditor: cellEditor, cellEditorGui: cellEditorGui, eCell: eCell, rowNode: rowNode, column: column, cellCtrl: cellCtrl } = this;
        const ePopupGui = cellEditorPopupWrapper.getGui();
        if (cellEditorGui) ePopupGui.appendChild(cellEditorGui);
        const useModelPopup = gos.get("stopEditingWhenCellsLoseFocus");
        const positionToUse = position != null ? position : cellEditor.getPopupPosition?.() ?? "over";
        const isRtl = gos.get("enableRtl");
        const positionParams = {
            ePopup: ePopupGui,
            column: column,
            rowNode: rowNode,
            type: "popupCellEditor",
            eventSource: eCell,
            position: positionToUse,
            alignSide: isRtl ? "right" : "left",
            keepWithinBounds: true
        };
        const positionCallback = popupSvc.positionPopupByComponent.bind(popupSvc, positionParams);
        const addPopupRes = popupSvc.addPopup({
            modal: useModelPopup,
            eChild: ePopupGui,
            closeOnEsc: true,
            closedCallback: ()=>{
                cellCtrl.onPopupEditorClosed();
            },
            anchorToElement: eCell,
            positionCallback: positionCallback,
            ariaOwns: eCell
        });
        if (addPopupRes) this.hideEditorPopup = addPopupRes.hideFunc;
    }
    detach() {
        this.eRow.removeChild(this.getGui());
    }
    // if the row is also getting destroyed, then we don't need to remove from dom,
    // as the row will also get removed, so no need to take out the cells from the row
    // if the row is going (removing is an expensive operation, so only need to remove
    // the top part)
    //
    // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
    destroy() {
        this.destroyRenderer();
        this.destroyEditor();
        this.removeControls();
        super.destroy();
    }
};
// packages/ag-grid-community/src/rendering/row/rowComp.ts
var $437b23f6a393c3bf$var$RowComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(ctrl, beans, containerType){
        super();
        this.cellComps = /* @__PURE__ */ new Map();
        this.beans = beans;
        this.rowCtrl = ctrl;
        const rowDiv = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            role: "row",
            attrs: {
                "comp-id": `${this.getCompId()}`
            }
        });
        this.setInitialStyle(rowDiv, containerType);
        this.setTemplateFromElement(rowDiv);
        const style = rowDiv.style;
        this.domOrder = this.rowCtrl.getDomOrder();
        const compProxy = {
            setDomOrder: (domOrder)=>this.domOrder = domOrder,
            setCellCtrls: (cellCtrls)=>this.setCellCtrls(cellCtrls),
            showFullWidth: (compDetails)=>this.showFullWidth(compDetails),
            getFullWidthCellRenderer: ()=>this.fullWidthCellRenderer,
            toggleCss: (name, on)=>this.toggleCss(name, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(rowDiv, styles),
            setTop: (top)=>style.top = top,
            setTransform: (transform)=>style.transform = transform,
            setRowIndex: (rowIndex)=>rowDiv.setAttribute("row-index", rowIndex),
            setRowId: (rowId)=>rowDiv.setAttribute("row-id", rowId),
            setRowBusinessKey: (businessKey)=>rowDiv.setAttribute("row-business-key", businessKey),
            refreshFullWidth: (getUpdatedParams)=>this.fullWidthCellRenderer?.refresh?.(getUpdatedParams()) ?? false
        };
        ctrl.setComp(compProxy, this.getGui(), containerType, void 0);
        this.addDestroyFunc(()=>{
            ctrl.unsetComp(containerType);
        });
    }
    setInitialStyle(container, containerType) {
        const transform = this.rowCtrl.getInitialTransform(containerType);
        if (transform) container.style.setProperty("transform", transform);
        else {
            const top = this.rowCtrl.getInitialRowTop(containerType);
            if (top) container.style.setProperty("top", top);
        }
    }
    showFullWidth(compDetails) {
        const callback = (cellRenderer)=>{
            if (this.isAlive()) {
                const eGui = cellRenderer.getGui();
                this.getGui().appendChild(eGui);
                this.rowCtrl.setupDetailRowAutoHeight(eGui);
                this.setFullWidthRowComp(cellRenderer);
            } else this.beans.context.destroyBean(cellRenderer);
        };
        const res = compDetails.newAgStackInstance();
        res.then(callback);
    }
    setCellCtrls(cellCtrls) {
        const cellsToRemove = new Map(this.cellComps);
        for (const cellCtrl of cellCtrls){
            const key = cellCtrl.instanceId;
            if (!this.cellComps.has(key)) this.newCellComp(cellCtrl);
            else cellsToRemove.delete(key);
        }
        this.destroyCells(cellsToRemove);
        this.ensureDomOrder(cellCtrls);
    }
    ensureDomOrder(cellCtrls) {
        if (!this.domOrder) return;
        const elementsInOrder = [];
        for (const cellCtrl of cellCtrls){
            const cellComp = this.cellComps.get(cellCtrl.instanceId);
            if (cellComp) elementsInOrder.push(cellComp.getGui());
        }
        $437b23f6a393c3bf$var$_setDomChildOrder(this.getGui(), elementsInOrder);
    }
    newCellComp(cellCtrl) {
        const editing = this.beans.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        }) ?? false;
        const cellComp = new $437b23f6a393c3bf$var$CellComp(this.beans, cellCtrl, this.rowCtrl.printLayout, this.getGui(), editing);
        this.cellComps.set(cellCtrl.instanceId, cellComp);
        this.getGui().appendChild(cellComp.getGui());
    }
    destroy() {
        super.destroy();
        this.destroyCells(this.cellComps);
    }
    setFullWidthRowComp(fullWidthRowComponent) {
        this.fullWidthCellRenderer = fullWidthRowComponent;
        this.addDestroyFunc(()=>{
            this.fullWidthCellRenderer = this.beans.context.destroyBean(this.fullWidthCellRenderer);
        });
    }
    destroyCells(cellComps) {
        for (const cellComp of cellComps.values()){
            if (!cellComp) return;
            const instanceId = cellComp.cellCtrl.instanceId;
            if (this.cellComps.get(instanceId) !== cellComp) return;
            cellComp.detach();
            cellComp.destroy();
            this.cellComps.delete(instanceId);
        }
    }
};
// packages/ag-grid-community/src/gridBodyComp/rowContainer/rowContainerComp.ts
function $437b23f6a393c3bf$var$getElementParams(name, options, beans) {
    const isCellSpanning = !!beans.gos.get("enableCellSpan") && !!options.getSpannedRowCtrls;
    const eContainerElement = {
        tag: "div",
        ref: "eContainer",
        cls: $437b23f6a393c3bf$export$35e1b2dddf7fc6e9(name),
        role: "rowgroup"
    };
    if (options.type === "center" || isCellSpanning) {
        const eSpannedContainerElement = {
            tag: "div",
            ref: "eSpannedContainer",
            cls: `ag-spanning-container ${$437b23f6a393c3bf$export$cd6b90bdf6c4fcfd(name)}`,
            role: "rowgroup"
        };
        return {
            tag: "div",
            ref: "eViewport",
            cls: `ag-viewport ${$437b23f6a393c3bf$export$65619730ec980d6a(name)}`,
            role: "presentation",
            children: [
                eContainerElement,
                isCellSpanning ? eSpannedContainerElement : null
            ]
        };
    }
    return eContainerElement;
}
var $437b23f6a393c3bf$var$RowContainerComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(params){
        super();
        this.eViewport = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSpannedContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.rowCompsNoSpan = {};
        this.rowCompsWithSpan = {};
        this.name = params?.name;
        this.options = $437b23f6a393c3bf$export$a46aad9f8c79261f(this.name);
    }
    postConstruct() {
        this.setTemplate($437b23f6a393c3bf$var$getElementParams(this.name, this.options, this.beans));
        const compProxy = {
            setHorizontalScroll: (offset)=>this.eViewport.scrollLeft = offset,
            setViewportHeight: (height)=>this.eViewport.style.height = height,
            setRowCtrls: ({ rowCtrls: rowCtrls })=>this.setRowCtrls(rowCtrls),
            setSpannedRowCtrls: (rowCtrls)=>this.setRowCtrls(rowCtrls, true),
            setDomOrder: (domOrder)=>{
                this.domOrder = domOrder;
            },
            setContainerWidth: (width)=>{
                this.eContainer.style.width = width;
                if (this.eSpannedContainer) this.eSpannedContainer.style.width = width;
            },
            setOffsetTop: (offset)=>{
                const top = `translateY(${offset})`;
                this.eContainer.style.transform = top;
                if (this.eSpannedContainer) this.eSpannedContainer.style.transform = top;
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$2d4385f6f566fe5e(this.name));
        ctrl.setComp(compProxy, this.eContainer, this.eSpannedContainer, this.eViewport);
    }
    destroy() {
        this.setRowCtrls([]);
        this.setRowCtrls([], true);
        super.destroy();
        this.lastPlacedElement = null;
    }
    setRowCtrls(rowCtrls, spanContainer) {
        const { beans: beans, options: options } = this;
        const container = spanContainer ? this.eSpannedContainer : this.eContainer;
        const oldRows = spanContainer ? {
            ...this.rowCompsWithSpan
        } : {
            ...this.rowCompsNoSpan
        };
        const newComps = {};
        if (spanContainer) this.rowCompsWithSpan = newComps;
        else this.rowCompsNoSpan = newComps;
        this.lastPlacedElement = null;
        const orderedRows = [];
        for (const rowCtrl of rowCtrls){
            const instanceId = rowCtrl.instanceId;
            const existingRowComp = oldRows[instanceId];
            let rowComp;
            if (existingRowComp) {
                rowComp = existingRowComp;
                delete oldRows[instanceId];
            } else {
                if (!rowCtrl.rowNode.displayed) continue;
                rowComp = new $437b23f6a393c3bf$var$RowComp(rowCtrl, beans, options.type);
            }
            newComps[instanceId] = rowComp;
            orderedRows.push([
                rowComp,
                !existingRowComp
            ]);
        }
        this.removeOldRows(Object.values(oldRows), container);
        this.addRowNodes(orderedRows, container);
    }
    addRowNodes(rows, container) {
        const { domOrder: domOrder } = this;
        for (const [rowComp, isNew] of rows){
            const eGui = rowComp.getGui();
            if (!domOrder) {
                if (isNew) container.appendChild(eGui);
            } else this.ensureDomOrder(eGui, container);
        }
    }
    removeOldRows(rowComps, container) {
        for (const oldRowComp of rowComps){
            container.removeChild(oldRowComp.getGui());
            oldRowComp.destroy();
        }
    }
    ensureDomOrder(eRow, container) {
        $437b23f6a393c3bf$var$_ensureDomOrder(container, eRow, this.lastPlacedElement);
        this.lastPlacedElement = eRow;
    }
};
var $437b23f6a393c3bf$var$RowContainerSelector = {
    selector: "AG-ROW-CONTAINER",
    component: $437b23f6a393c3bf$var$RowContainerComp
};
// packages/ag-grid-community/src/gridBodyComp/gridBodyComp.ts
function $437b23f6a393c3bf$var$makeRowContainers(paramsMap, names) {
    return names.map((name)=>{
        const refName = `e${name[0].toUpperCase() + name.substring(1)}RowContainer`;
        paramsMap[refName] = {
            name: name
        };
        return {
            tag: "ag-row-container",
            ref: refName,
            attrs: {
                name: name
            }
        };
    });
}
function $437b23f6a393c3bf$var$getGridBodyTemplate(includeOverlay) {
    const paramsMap = {};
    const elementParams = {
        tag: "div",
        ref: "eGridRoot",
        cls: "ag-root ag-unselectable",
        children: [
            {
                tag: "ag-header-root"
            },
            {
                tag: "div",
                ref: "eTop",
                cls: "ag-floating-top",
                role: "presentation",
                children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                    "topLeft",
                    "topCenter",
                    "topRight",
                    "topFullWidth"
                ])
            },
            {
                tag: "div",
                ref: "eBody",
                cls: "ag-body",
                role: "presentation",
                children: [
                    {
                        tag: "div",
                        ref: "eBodyViewport",
                        cls: "ag-body-viewport",
                        role: "presentation",
                        children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                            "left",
                            "center",
                            "right",
                            "fullWidth"
                        ])
                    },
                    {
                        tag: "ag-fake-vertical-scroll"
                    }
                ]
            },
            {
                tag: "div",
                ref: "eStickyTop",
                cls: "ag-sticky-top",
                role: "presentation",
                children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                    "stickyTopLeft",
                    "stickyTopCenter",
                    "stickyTopRight",
                    "stickyTopFullWidth"
                ])
            },
            {
                tag: "div",
                ref: "eStickyBottom",
                cls: "ag-sticky-bottom",
                role: "presentation",
                children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                    "stickyBottomLeft",
                    "stickyBottomCenter",
                    "stickyBottomRight",
                    "stickyBottomFullWidth"
                ])
            },
            {
                tag: "div",
                ref: "eBottom",
                cls: "ag-floating-bottom",
                role: "presentation",
                children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                    "bottomLeft",
                    "bottomCenter",
                    "bottomRight",
                    "bottomFullWidth"
                ])
            },
            {
                tag: "ag-fake-horizontal-scroll"
            },
            includeOverlay ? {
                tag: "ag-overlay-wrapper"
            } : null
        ]
    };
    return {
        paramsMap: paramsMap,
        elementParams: elementParams
    };
}
var $437b23f6a393c3bf$var$GridBodyComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(...arguments);
        this.eGridRoot = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eBodyViewport = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eStickyTop = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eStickyBottom = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eTop = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eBottom = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eBody = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        const { overlays: overlays, rangeSvc: rangeSvc } = this.beans;
        const overlaySelector = overlays?.getOverlayWrapperSelector();
        const { paramsMap: paramsMap, elementParams: elementParams } = $437b23f6a393c3bf$var$getGridBodyTemplate(!!overlaySelector);
        this.setTemplate(elementParams, [
            ...overlaySelector ? [
                overlaySelector
            ] : [],
            $437b23f6a393c3bf$var$FakeHScrollSelector,
            $437b23f6a393c3bf$var$FakeVScrollSelector,
            $437b23f6a393c3bf$var$GridHeaderSelector,
            $437b23f6a393c3bf$var$RowContainerSelector
        ], paramsMap);
        const setHeight = (height, element)=>{
            const heightString = `${height}px`;
            element.style.minHeight = heightString;
            element.style.height = heightString;
        };
        const compProxy = {
            setRowAnimationCssOnBodyViewport: (cssClass, animate)=>this.setRowAnimationCssOnBodyViewport(cssClass, animate),
            setColumnCount: (count)=>$437b23f6a393c3bf$export$56744a26086b5898(this.getGui(), count),
            setRowCount: (count)=>$437b23f6a393c3bf$export$1ad8496b26b660f8(this.getGui(), count),
            setTopHeight: (height)=>setHeight(height, this.eTop),
            setBottomHeight: (height)=>setHeight(height, this.eBottom),
            setTopInvisible: (invisible)=>this.eTop.classList.toggle("ag-invisible", invisible),
            setBottomInvisible: (invisible)=>this.eBottom.classList.toggle("ag-invisible", invisible),
            setStickyTopHeight: (height)=>this.eStickyTop.style.height = height,
            setStickyTopTop: (top)=>this.eStickyTop.style.top = top,
            setStickyTopWidth: (width)=>this.eStickyTop.style.width = width,
            setStickyBottomHeight: (height)=>{
                this.eStickyBottom.style.height = height;
                this.eStickyBottom.classList.toggle("ag-invisible", height === "0px");
            },
            setStickyBottomBottom: (bottom)=>this.eStickyBottom.style.bottom = bottom,
            setStickyBottomWidth: (width)=>this.eStickyBottom.style.width = width,
            setColumnMovingCss: (cssClass, flag)=>this.toggleCss(cssClass, flag),
            updateLayoutClasses: (cssClass, params)=>{
                const classLists = [
                    this.eBodyViewport.classList,
                    this.eBody.classList
                ];
                for (const classList of classLists){
                    classList.toggle($437b23f6a393c3bf$var$LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
                    classList.toggle($437b23f6a393c3bf$var$LayoutCssClasses.NORMAL, params.normal);
                    classList.toggle($437b23f6a393c3bf$var$LayoutCssClasses.PRINT, params.print);
                }
                this.toggleCss($437b23f6a393c3bf$var$LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
                this.toggleCss($437b23f6a393c3bf$var$LayoutCssClasses.NORMAL, params.normal);
                this.toggleCss($437b23f6a393c3bf$var$LayoutCssClasses.PRINT, params.print);
            },
            setAlwaysVerticalScrollClass: (cssClass, on)=>this.eBodyViewport.classList.toggle($437b23f6a393c3bf$var$CSS_CLASS_FORCE_VERTICAL_SCROLL, on),
            registerBodyViewportResizeListener: (listener)=>{
                const unsubscribeFromResize = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, this.eBodyViewport, listener);
                this.addDestroyFunc(()=>unsubscribeFromResize());
            },
            setPinnedTopBottomOverflowY: (overflow)=>this.eTop.style.overflowY = this.eBottom.style.overflowY = overflow,
            setCellSelectableCss: (cssClass, selectable)=>{
                [
                    this.eTop,
                    this.eBodyViewport,
                    this.eBottom
                ].forEach((ct)=>ct.classList.toggle(cssClass, selectable));
            },
            setBodyViewportWidth: (width)=>this.eBodyViewport.style.width = width,
            setGridRootRole: (role)=>$437b23f6a393c3bf$export$f8d01fa01787902(this.eGridRoot, role)
        };
        this.ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$8bebc3145b40d221());
        this.ctrl.setComp(compProxy, this.getGui(), this.eBodyViewport, this.eTop, this.eBottom, this.eStickyTop, this.eStickyBottom);
        if (rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(this.gos) || $437b23f6a393c3bf$export$7bd8c52ebc4117d6(this.gos)) $437b23f6a393c3bf$var$_setAriaMultiSelectable(this.getGui(), true);
    }
    setRowAnimationCssOnBodyViewport(cssClass, animateRows) {
        const bodyViewportClassList = this.eBodyViewport.classList;
        bodyViewportClassList.toggle("ag-row-animation", animateRows);
        bodyViewportClassList.toggle("ag-row-no-animation", !animateRows);
    }
};
var $437b23f6a393c3bf$var$GridBodySelector = {
    selector: "AG-GRID-BODY",
    component: $437b23f6a393c3bf$var$GridBodyComp
};
// packages/ag-grid-community/src/gridComp/gridCtrl.ts
var $437b23f6a393c3bf$export$f3c741dac0be9745 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.additionalFocusableContainers = /* @__PURE__ */ new Set();
    }
    setComp(view, eGridDiv, eGui) {
        this.view = view;
        this.eGridHostDiv = eGridDiv;
        this.eGui = eGui;
        this.eGui.setAttribute("grid-id", this.beans.context.getGridId());
        const { dragAndDrop: dragAndDrop, ctrlsSvc: ctrlsSvc } = this.beans;
        dragAndDrop?.registerGridDropTarget(()=>this.eGui, this);
        $437b23f6a393c3bf$var$_stampTopLevelGridCompWithGridInstance(this.gos, eGridDiv);
        this.createManagedBean(new $437b23f6a393c3bf$var$LayoutFeature(this.view));
        this.view.setRtlClass(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr");
        const unsubscribeFromResize = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, this.eGridHostDiv, this.onGridSizeChanged.bind(this));
        this.addDestroyFunc(()=>unsubscribeFromResize());
        ctrlsSvc.register("gridCtrl", this);
    }
    isDetailGrid() {
        const el = $437b23f6a393c3bf$export$c4c49c776025d475(this.getGui());
        return el?.getAttribute("row-id")?.startsWith("detail") || false;
    }
    getOptionalSelectors() {
        const beans = this.beans;
        return {
            paginationSelector: beans.pagination?.getPaginationSelector(),
            gridHeaderDropZonesSelector: beans.registry?.getSelector("AG-GRID-HEADER-DROP-ZONES"),
            sideBarSelector: beans.sideBar?.getSelector(),
            statusBarSelector: beans.registry?.getSelector("AG-STATUS-BAR"),
            watermarkSelector: beans.licenseManager?.getWatermarkSelector()
        };
    }
    onGridSizeChanged() {
        this.eventSvc.dispatchEvent({
            type: "gridSizeChanged",
            clientWidth: this.eGridHostDiv.clientWidth,
            clientHeight: this.eGridHostDiv.clientHeight
        });
    }
    destroyGridUi() {
        this.view.destroyGridUi();
    }
    getGui() {
        return this.eGui;
    }
    setResizeCursor(direction) {
        const { view: view } = this;
        if (direction === false) view.setCursor(null);
        else {
            const cursor = direction === 1 /* Horizontal */  ? "ew-resize" : "ns-resize";
            view.setCursor(cursor);
        }
    }
    disableUserSelect(on) {
        this.view.setUserSelect(on ? "none" : null);
    }
    focusNextInnerContainer(backwards) {
        const focusableContainers = this.getFocusableContainers();
        const { indexWithFocus: indexWithFocus, nextIndex: nextIndex } = this.getNextFocusableIndex(focusableContainers, backwards);
        if (nextIndex < 0 || nextIndex >= focusableContainers.length) return false;
        if (nextIndex === 0) {
            if (indexWithFocus > 0) {
                const { visibleCols: visibleCols, focusSvc: focusSvc } = this.beans;
                const allColumns = visibleCols.allCols;
                const lastColumn = $437b23f6a393c3bf$export$236389741107357f(allColumns);
                if (focusSvc.focusGridView({
                    column: lastColumn,
                    backwards: true
                })) return true;
            }
            return false;
        }
        return this.focusContainer(focusableContainers[nextIndex], backwards);
    }
    focusInnerElement(fromBottom) {
        const userCallbackFunction = this.gos.getCallback("focusGridInnerElement");
        if (userCallbackFunction && userCallbackFunction({
            fromBottom: !!fromBottom
        })) return true;
        const focusableContainers = this.getFocusableContainers();
        const { focusSvc: focusSvc, visibleCols: visibleCols } = this.beans;
        const allColumns = visibleCols.allCols;
        if (fromBottom) {
            if (focusableContainers.length > 1) return this.focusContainer($437b23f6a393c3bf$export$236389741107357f(focusableContainers), fromBottom);
            const lastColumn = $437b23f6a393c3bf$export$236389741107357f(allColumns);
            if (focusSvc.focusGridView({
                column: lastColumn,
                backwards: fromBottom
            })) return true;
        }
        if (this.gos.get("headerHeight") === 0 || $437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans)) {
            if (focusSvc.focusGridView({
                column: allColumns[0],
                backwards: fromBottom
            })) return true;
            for(let i = 1; i < focusableContainers.length; i++){
                if ($437b23f6a393c3bf$export$8598088d375f416f(focusableContainers[i].getGui(), fromBottom)) return true;
            }
            return false;
        }
        return focusSvc.focusFirstHeader();
    }
    forceFocusOutOfContainer(up = false) {
        this.view.forceFocusOutOfContainer(up);
    }
    addFocusableContainer(container) {
        this.additionalFocusableContainers.add(container);
    }
    removeFocusableContainer(container) {
        this.additionalFocusableContainers.delete(container);
    }
    allowFocusForNextCoreContainer(up) {
        const coreContainers = this.view.getFocusableContainers();
        const { nextIndex: nextIndex, indexWithFocus: indexWithFocus } = this.getNextFocusableIndex(coreContainers, up);
        if (indexWithFocus === -1 || nextIndex < 0 || nextIndex >= coreContainers.length) return;
        const comp = coreContainers[nextIndex];
        comp.setAllowFocus?.(true);
        setTimeout(()=>{
            comp.setAllowFocus?.(false);
        });
    }
    isFocusable() {
        const beans = this.beans;
        return !$437b23f6a393c3bf$var$_isCellFocusSuppressed(beans) || !$437b23f6a393c3bf$var$_isHeaderFocusSuppressed(beans) || !!beans.sideBar?.comp?.isDisplayed();
    }
    getNextFocusableIndex(focusableContainers, backwards) {
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        const indexWithFocus = focusableContainers.findIndex((container)=>container.getGui().contains(activeEl));
        const nextIndex = indexWithFocus + (backwards ? -1 : 1);
        return {
            indexWithFocus: indexWithFocus,
            nextIndex: nextIndex
        };
    }
    focusContainer(comp, up) {
        comp.setAllowFocus?.(true);
        const result = $437b23f6a393c3bf$export$8598088d375f416f(comp.getGui(), up, false, true);
        comp.setAllowFocus?.(false);
        return result;
    }
    getFocusableContainers() {
        return [
            ...this.view.getFocusableContainers(),
            ...this.additionalFocusableContainers
        ];
    }
    destroy() {
        this.additionalFocusableContainers.clear();
        super.destroy();
    }
};
// packages/ag-grid-community/src/gridComp/gridComp.ts
var $437b23f6a393c3bf$var$GridComp = class extends $437b23f6a393c3bf$export$5a26e3abd1c845b6 {
    constructor(eGridDiv){
        super();
        this.gridBody = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.sideBar = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.pagination = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.rootWrapperBody = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eGridDiv = eGridDiv;
    }
    postConstruct() {
        const compProxy = {
            destroyGridUi: ()=>this.destroyBean(this),
            setRtlClass: (cssClass)=>this.addCss(cssClass),
            forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this),
            updateLayoutClasses: this.updateLayoutClasses.bind(this),
            getFocusableContainers: this.getFocusableContainers.bind(this),
            setUserSelect: (value)=>{
                this.getGui().style.userSelect = value != null ? value : "";
                this.getGui().style.webkitUserSelect = value != null ? value : "";
            },
            setCursor: (value)=>{
                this.getGui().style.cursor = value != null ? value : "";
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$f3c741dac0be9745());
        const comps = ctrl.getOptionalSelectors();
        const template = this.createTemplate(comps);
        const requiredComps = [
            $437b23f6a393c3bf$var$GridBodySelector,
            ...Object.values(comps).filter((c)=>!!c)
        ];
        this.setTemplate(template, requiredComps);
        ctrl.setComp(compProxy, this.eGridDiv, this.getGui());
        this.insertGridIntoDom();
        this.initialiseTabGuard({
            // we want to override the default behaviour to do nothing for onTabKeyDown
            onTabKeyDown: ()=>void 0,
            focusInnerElement: (fromBottom)=>ctrl.focusInnerElement(fromBottom),
            forceFocusOutWhenTabGuardsAreEmpty: true,
            isEmpty: ()=>!ctrl.isFocusable()
        });
    }
    insertGridIntoDom() {
        const eGui = this.getGui();
        this.eGridDiv.appendChild(eGui);
        this.addDestroyFunc(()=>{
            this.eGridDiv.removeChild(eGui);
            $437b23f6a393c3bf$var$_logIfDebug(this.gos, "Grid removed from DOM");
        });
    }
    updateLayoutClasses(cssClass, params) {
        const eRootWrapperBodyClassList = this.rootWrapperBody.classList;
        const { AUTO_HEIGHT: AUTO_HEIGHT, NORMAL: NORMAL, PRINT: PRINT } = $437b23f6a393c3bf$var$LayoutCssClasses;
        const { autoHeight: autoHeight, normal: normal, print: print } = params;
        eRootWrapperBodyClassList.toggle(AUTO_HEIGHT, autoHeight);
        eRootWrapperBodyClassList.toggle(NORMAL, normal);
        eRootWrapperBodyClassList.toggle(PRINT, print);
        this.toggleCss(AUTO_HEIGHT, autoHeight);
        this.toggleCss(NORMAL, normal);
        this.toggleCss(PRINT, print);
    }
    createTemplate(params) {
        const dropZones = params.gridHeaderDropZonesSelector ? {
            tag: "ag-grid-header-drop-zones"
        } : null;
        const sideBar = params.sideBarSelector ? {
            tag: "ag-side-bar",
            ref: "sideBar"
        } : null;
        const statusBar = params.statusBarSelector ? {
            tag: "ag-status-bar"
        } : null;
        const watermark = params.watermarkSelector ? {
            tag: "ag-watermark"
        } : null;
        const pagination = params.paginationSelector ? {
            tag: "ag-pagination",
            ref: "pagination"
        } : null;
        return {
            tag: "div",
            cls: "ag-root-wrapper",
            role: "presentation",
            children: [
                dropZones,
                {
                    tag: "div",
                    ref: "rootWrapperBody",
                    cls: "ag-root-wrapper-body",
                    role: "presentation",
                    children: [
                        {
                            tag: "ag-grid-body",
                            ref: "gridBody"
                        },
                        sideBar
                    ]
                },
                statusBar,
                pagination,
                watermark
            ]
        };
    }
    getFocusableElement() {
        return this.rootWrapperBody;
    }
    forceFocusOutOfContainer(up = false) {
        if (!up && this.pagination?.isDisplayed()) {
            this.pagination.forceFocusOutOfContainer(up);
            return;
        }
        super.forceFocusOutOfContainer(up);
    }
    getFocusableContainers() {
        const focusableContainers = [
            this.gridBody
        ];
        [
            this.sideBar,
            this.pagination
        ].forEach((comp)=>{
            if (comp) focusableContainers.push(comp);
        });
        return focusableContainers.filter((el)=>$437b23f6a393c3bf$export$2badf4aa566524cb(el.getGui()));
    }
};
// packages/ag-grid-community/src/api/gridApiFunctions.ts
var $437b23f6a393c3bf$var$mod = (moduleName, input)=>{
    for (const key of Object.keys(input))input[key] = moduleName;
    return input;
};
var $437b23f6a393c3bf$var$gridApiFunctionsMap = {
    dispatchEvent: "CommunityCore",
    // this is always registered
    ...$437b23f6a393c3bf$var$mod("CommunityCore", {
        destroy: 0,
        getGridId: 0,
        getGridOption: 0,
        isDestroyed: 0,
        setGridOption: 0,
        updateGridOptions: 0,
        isModuleRegistered: 0
    }),
    ...$437b23f6a393c3bf$var$mod("GridState", {
        getState: 0,
        setState: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedRowSelection", {
        setNodesSelected: 0,
        selectAll: 0,
        deselectAll: 0,
        selectAllFiltered: 0,
        deselectAllFiltered: 0,
        selectAllOnCurrentPage: 0,
        deselectAllOnCurrentPage: 0,
        getSelectedNodes: 0,
        getSelectedRows: 0
    }),
    ...$437b23f6a393c3bf$var$mod("RowApi", {
        redrawRows: 0,
        setRowNodeExpanded: 0,
        getRowNode: 0,
        addRenderedRowListener: 0,
        getRenderedNodes: 0,
        forEachNode: 0,
        getFirstDisplayedRowIndex: 0,
        getLastDisplayedRowIndex: 0,
        getDisplayedRowAtIndex: 0,
        getDisplayedRowCount: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ScrollApi", {
        getVerticalPixelRange: 0,
        getHorizontalPixelRange: 0,
        ensureColumnVisible: 0,
        ensureIndexVisible: 0,
        ensureNodeVisible: 0
    }),
    ...$437b23f6a393c3bf$var$mod("KeyboardNavigation", {
        getFocusedCell: 0,
        clearFocusedCell: 0,
        setFocusedCell: 0,
        tabToNextCell: 0,
        tabToPreviousCell: 0,
        setFocusedHeader: 0
    }),
    ...$437b23f6a393c3bf$var$mod("EventApi", {
        addEventListener: 0,
        addGlobalListener: 0,
        removeEventListener: 0,
        removeGlobalListener: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ValueCache", {
        expireValueCache: 0
    }),
    ...$437b23f6a393c3bf$var$mod("CellApi", {
        getCellValue: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedMenu", {
        showColumnMenu: 0,
        hidePopupMenu: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Sort", {
        onSortChanged: 0
    }),
    ...$437b23f6a393c3bf$var$mod("PinnedRow", {
        getPinnedTopRowCount: 0,
        getPinnedBottomRowCount: 0,
        getPinnedTopRow: 0,
        getPinnedBottomRow: 0,
        forEachPinnedRow: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Overlay", {
        showLoadingOverlay: 0,
        showNoRowsOverlay: 0,
        hideOverlay: 0
    }),
    ...$437b23f6a393c3bf$var$mod("RenderApi", {
        setGridAriaProperty: 0,
        refreshCells: 0,
        refreshHeader: 0,
        isAnimationFrameQueueEmpty: 0,
        flushAllAnimationFrames: 0,
        getSizesForCurrentTheme: 0,
        getCellRendererInstances: 0
    }),
    ...$437b23f6a393c3bf$var$mod("HighlightChanges", {
        flashCells: 0
    }),
    ...$437b23f6a393c3bf$var$mod("RowDrag", {
        addRowDropZone: 0,
        removeRowDropZone: 0,
        getRowDropZoneParams: 0,
        getRowDropPositionIndicator: 0,
        setRowDropPositionIndicator: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnApi", {
        getColumnDefs: 0,
        getColumnDef: 0,
        getDisplayNameForColumn: 0,
        getColumn: 0,
        getColumns: 0,
        applyColumnState: 0,
        getColumnState: 0,
        resetColumnState: 0,
        isPinning: 0,
        isPinningLeft: 0,
        isPinningRight: 0,
        getDisplayedColAfter: 0,
        getDisplayedColBefore: 0,
        setColumnsVisible: 0,
        setColumnsPinned: 0,
        getAllGridColumns: 0,
        getDisplayedLeftColumns: 0,
        getDisplayedCenterColumns: 0,
        getDisplayedRightColumns: 0,
        getAllDisplayedColumns: 0,
        getAllDisplayedVirtualColumns: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnAutoSize", {
        sizeColumnsToFit: 0,
        autoSizeColumns: 0,
        autoSizeAllColumns: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnGroup", {
        setColumnGroupOpened: 0,
        getColumnGroup: 0,
        getProvidedColumnGroup: 0,
        getDisplayNameForColumnGroup: 0,
        getColumnGroupState: 0,
        setColumnGroupState: 0,
        resetColumnGroupState: 0,
        getLeftDisplayedColumnGroups: 0,
        getCenterDisplayedColumnGroups: 0,
        getRightDisplayedColumnGroups: 0,
        getAllDisplayedColumnGroups: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnMove", {
        moveColumnByIndex: 0,
        moveColumns: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnResize", {
        setColumnWidths: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnHover", {
        isColumnHovered: 0
    }),
    ...$437b23f6a393c3bf$var$mod("EditCore", {
        getCellEditorInstances: 0,
        getEditingCells: 0,
        stopEditing: 0,
        startEditingCell: 0,
        isEditing: 0,
        validateEdit: 0
    }),
    ...$437b23f6a393c3bf$var$mod("BatchEdit", {
        startBatchEdit: 0,
        cancelBatchEdit: 0,
        commitBatchEdit: 0,
        isBatchEditing: 0
    }),
    ...$437b23f6a393c3bf$var$mod("UndoRedoEdit", {
        undoCellEditing: 0,
        redoCellEditing: 0,
        getCurrentUndoSize: 0,
        getCurrentRedoSize: 0
    }),
    ...$437b23f6a393c3bf$var$mod("FilterCore", {
        isAnyFilterPresent: 0,
        onFilterChanged: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnFilter", {
        isColumnFilterPresent: 0,
        getColumnFilterInstance: 0,
        destroyFilter: 0,
        setFilterModel: 0,
        getFilterModel: 0,
        getColumnFilterModel: 0,
        setColumnFilterModel: 0,
        showColumnFilter: 0,
        hideColumnFilter: 0,
        getColumnFilterHandler: 0,
        doFilterAction: 0
    }),
    ...$437b23f6a393c3bf$var$mod("QuickFilter", {
        isQuickFilterPresent: 0,
        getQuickFilter: 0,
        resetQuickFilter: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Find", {
        findGetActiveMatch: 0,
        findGetTotalMatches: 0,
        findGoTo: 0,
        findNext: 0,
        findPrevious: 0,
        findGetNumMatches: 0,
        findGetParts: 0,
        findClearActive: 0,
        findRefresh: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Pagination", {
        paginationIsLastPageFound: 0,
        paginationGetPageSize: 0,
        paginationGetCurrentPage: 0,
        paginationGetTotalPages: 0,
        paginationGetRowCount: 0,
        paginationGoToNextPage: 0,
        paginationGoToPreviousPage: 0,
        paginationGoToFirstPage: 0,
        paginationGoToLastPage: 0,
        paginationGoToPage: 0
    }),
    ...$437b23f6a393c3bf$var$mod("CsrmSsrmSharedApi", {
        expandAll: 0,
        collapseAll: 0,
        onRowHeightChanged: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SsrmInfiniteSharedApi", {
        setRowCount: 0,
        getCacheBlockState: 0,
        isLastRowIndexKnown: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ClientSideRowModelApi", {
        onGroupExpandedOrCollapsed: 0,
        refreshClientSideRowModel: 0,
        isRowDataEmpty: 0,
        forEachLeafNode: 0,
        forEachNodeAfterFilter: 0,
        forEachNodeAfterFilterAndSort: 0,
        resetRowHeights: 0,
        applyTransaction: 0,
        applyTransactionAsync: 0,
        flushAsyncTransactions: 0,
        getBestCostNodeSelection: 0
    }),
    ...$437b23f6a393c3bf$var$mod("CsvExport", {
        getDataAsCsv: 0,
        exportDataAsCsv: 0
    }),
    ...$437b23f6a393c3bf$var$mod("InfiniteRowModel", {
        refreshInfiniteCache: 0,
        purgeInfiniteCache: 0,
        getInfiniteRowCount: 0
    }),
    ...$437b23f6a393c3bf$var$mod("AdvancedFilter", {
        getAdvancedFilterModel: 0,
        setAdvancedFilterModel: 0,
        showAdvancedFilterBuilder: 0,
        hideAdvancedFilterBuilder: 0
    }),
    ...$437b23f6a393c3bf$var$mod("IntegratedCharts", {
        getChartModels: 0,
        getChartRef: 0,
        getChartImageDataURL: 0,
        downloadChart: 0,
        openChartToolPanel: 0,
        closeChartToolPanel: 0,
        createRangeChart: 0,
        createPivotChart: 0,
        createCrossFilterChart: 0,
        updateChart: 0,
        restoreChart: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Clipboard", {
        copyToClipboard: 0,
        cutToClipboard: 0,
        copySelectedRowsToClipboard: 0,
        copySelectedRangeToClipboard: 0,
        copySelectedRangeDown: 0,
        pasteFromClipboard: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ExcelExport", {
        getDataAsExcel: 0,
        exportDataAsExcel: 0,
        getSheetDataForExcel: 0,
        getMultipleSheetsAsExcel: 0,
        exportMultipleSheetsAsExcel: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedMasterDetail", {
        addDetailGridInfo: 0,
        removeDetailGridInfo: 0,
        getDetailGridInfo: 0,
        forEachDetailGridInfo: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ContextMenu", {
        showContextMenu: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnMenu", {
        showColumnChooser: 0,
        hideColumnChooser: 0
    }),
    ...$437b23f6a393c3bf$var$mod("CellSelection", {
        getCellRanges: 0,
        addCellRange: 0,
        clearRangeSelection: 0,
        clearCellSelection: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedRowGrouping", {
        setRowGroupColumns: 0,
        removeRowGroupColumns: 0,
        addRowGroupColumns: 0,
        getRowGroupColumns: 0,
        moveRowGroupColumn: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedAggregation", {
        addAggFuncs: 0,
        clearAggFuncs: 0,
        setColumnAggFunc: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedPivot", {
        isPivotMode: 0,
        getPivotResultColumn: 0,
        setValueColumns: 0,
        getValueColumns: 0,
        removeValueColumns: 0,
        addValueColumns: 0,
        setPivotColumns: 0,
        removePivotColumns: 0,
        addPivotColumns: 0,
        getPivotColumns: 0,
        setPivotResultColumns: 0,
        getPivotResultColumns: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ServerSideRowModelApi", {
        getServerSideSelectionState: 0,
        setServerSideSelectionState: 0,
        applyServerSideTransaction: 0,
        applyServerSideTransactionAsync: 0,
        applyServerSideRowData: 0,
        retryServerSideLoads: 0,
        flushServerSideAsyncTransactions: 0,
        refreshServerSide: 0,
        getServerSideGroupLevelState: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SideBar", {
        isSideBarVisible: 0,
        setSideBarVisible: 0,
        setSideBarPosition: 0,
        openToolPanel: 0,
        closeToolPanel: 0,
        getOpenedToolPanel: 0,
        refreshToolPanel: 0,
        isToolPanelShowing: 0,
        getToolPanelInstance: 0,
        getSideBar: 0
    }),
    ...$437b23f6a393c3bf$var$mod("StatusBar", {
        getStatusPanel: 0
    })
};
// packages/ag-grid-community/src/api/apiFunctionService.ts
var $437b23f6a393c3bf$var$defaultFns = {
    isDestroyed: ()=>true,
    destroy () {},
    preConstruct () {},
    postConstruct () {},
    preWireBeans () {},
    wireBeans () {}
};
var $437b23f6a393c3bf$var$dispatchEvent = (beans, event)=>beans.eventSvc.dispatchEvent(event);
var $437b23f6a393c3bf$var$GridApiClass = class {
};
Reflect.defineProperty($437b23f6a393c3bf$var$GridApiClass, "name", {
    value: "GridApi"
});
var $437b23f6a393c3bf$var$ApiFunctionService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super();
        this.beanName = "apiFunctionSvc";
        this.api = new $437b23f6a393c3bf$var$GridApiClass();
        this.fns = {
            ...$437b23f6a393c3bf$var$defaultFns,
            dispatchEvent: // dispatchEvent is used by frameworks, also used by aligned grids to identify a grid api instance
            $437b23f6a393c3bf$var$dispatchEvent
        };
        this.preDestroyLink = "";
        const { api: api } = this;
        for (const key of Object.keys($437b23f6a393c3bf$var$gridApiFunctionsMap))api[key] = this.makeApi(key)[key];
    }
    postConstruct() {
        this.preDestroyLink = this.beans.frameworkOverrides.getDocLink("grid-lifecycle/#grid-pre-destroyed");
    }
    addFunction(functionName, func) {
        const { fns: fns, beans: beans } = this;
        if (fns !== $437b23f6a393c3bf$var$defaultFns) fns[functionName] = beans?.validation?.validateApiFunction(functionName, func) ?? func;
    }
    makeApi(apiName) {
        return {
            [apiName]: (...args)=>{
                const { beans: beans, fns: { [apiName]: fn } } = this;
                return fn ? fn(beans, ...args) : this.apiNotFound(apiName);
            }
        };
    }
    apiNotFound(fnName) {
        const { beans: beans, gos: gos, preDestroyLink: preDestroyLink } = this;
        if (!beans) $437b23f6a393c3bf$export$545083624300f13d(26, {
            fnName: fnName,
            preDestroyLink: preDestroyLink
        });
        else {
            const module = $437b23f6a393c3bf$var$gridApiFunctionsMap[fnName];
            if (gos.assertModuleRegistered(module, `api.${fnName}`)) $437b23f6a393c3bf$export$545083624300f13d(27, {
                fnName: fnName,
                module: module
            });
        }
    }
    destroy() {
        super.destroy();
        this.fns = $437b23f6a393c3bf$var$defaultFns;
        this.beans = null;
    }
};
// packages/ag-grid-community/src/api/coreApi.ts
function $437b23f6a393c3bf$var$getGridId(beans) {
    return beans.context.getGridId();
}
function $437b23f6a393c3bf$var$destroy(beans) {
    beans.gridDestroySvc.destroy();
}
function $437b23f6a393c3bf$var$isDestroyed(beans) {
    return beans.gridDestroySvc.destroyCalled;
}
function $437b23f6a393c3bf$var$getGridOption(beans, key) {
    return beans.gos.get(key);
}
function $437b23f6a393c3bf$var$setGridOption(beans, key, value) {
    $437b23f6a393c3bf$var$updateGridOptions(beans, {
        [key]: value
    });
}
function $437b23f6a393c3bf$var$updateGridOptions(beans, options) {
    beans.gos.updateGridOptions({
        options: options
    });
}
function $437b23f6a393c3bf$var$isModuleRegistered(beans, moduleName) {
    const withoutSuffix = moduleName.replace(/Module$/, "");
    return beans.gos.isModuleRegistered(withoutSuffix);
}
// packages/ag-grid-community/src/rendering/dndSourceComp.ts
var $437b23f6a393c3bf$var$DndSourceElement = {
    tag: "div",
    cls: "ag-drag-handle ag-row-drag",
    attrs: {
        draggable: "true"
    }
};
var $437b23f6a393c3bf$var$DndSourceComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(rowNode, column, eCell){
        super($437b23f6a393c3bf$var$DndSourceElement);
        this.rowNode = rowNode;
        this.column = column;
        this.eCell = eCell;
    }
    postConstruct() {
        const eGui = this.getGui();
        eGui.appendChild($437b23f6a393c3bf$export$d8feba07bf373edb("rowDrag", this.beans, null));
        this.addGuiEventListener("mousedown", (e)=>{
            e.stopPropagation();
        });
        this.addDragSource();
        this.checkVisibility();
    }
    addDragSource() {
        this.addGuiEventListener("dragstart", this.onDragStart.bind(this));
    }
    onDragStart(dragEvent) {
        const { rowNode: rowNode, column: column, eCell: eCell, gos: gos } = this;
        const providedOnRowDrag = column.getColDef().dndSourceOnRowDrag;
        const dataTransfer = dragEvent.dataTransfer;
        dataTransfer.setDragImage(eCell, 0, 0);
        if (providedOnRowDrag) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
                rowNode: rowNode,
                dragEvent: dragEvent
            });
            providedOnRowDrag(params);
        } else try {
            const jsonData = JSON.stringify(rowNode.data);
            dataTransfer.setData("application/json", jsonData);
            dataTransfer.setData("text/plain", jsonData);
        } catch (e) {}
    }
    checkVisibility() {
        const visible = this.column.isDndSource(this.rowNode);
        this.setDisplayed(visible);
    }
};
// packages/ag-grid-community/src/dragAndDrop/dragApi.ts
function $437b23f6a393c3bf$var$addRowDropZone(beans, params) {
    beans.rowDragSvc?.rowDragFeature?.addRowDropZone(params);
}
function $437b23f6a393c3bf$var$removeRowDropZone(beans, params) {
    const activeDropTarget = beans.dragAndDrop?.findExternalZone(params);
    if (activeDropTarget) beans.dragAndDrop?.removeDropTarget(activeDropTarget);
}
function $437b23f6a393c3bf$var$getRowDropZoneParams(beans, events) {
    return beans.rowDragSvc?.rowDragFeature?.getRowDropZone(events);
}
function $437b23f6a393c3bf$var$getRowDropPositionIndicator(beans) {
    const rowDropHighlightSvc = beans.rowDropHighlightSvc;
    return rowDropHighlightSvc ? {
        row: rowDropHighlightSvc.row,
        dropIndicatorPosition: rowDropHighlightSvc.position
    } : {
        row: null,
        dropIndicatorPosition: "none"
    };
}
function $437b23f6a393c3bf$var$setRowDropPositionIndicator(beans, params) {
    const rowDropHighlightSvc = beans.rowDropHighlightSvc;
    if (!rowDropHighlightSvc) return;
    const rowNode = params?.row;
    let position = params?.dropIndicatorPosition;
    if (position !== "above" && position !== "below" && position !== "inside") position = "none";
    const rowIndex = rowNode?.rowIndex;
    if (rowIndex === null || rowIndex === void 0 || position === "none") rowDropHighlightSvc.clear();
    else rowDropHighlightSvc.set(rowNode, position);
}
// packages/ag-grid-community/src/dragAndDrop/horizontalResizeService.ts
var $437b23f6a393c3bf$var$HorizontalResizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "horizontalResizeSvc";
    }
    addResizeBar(params) {
        const dragSource = {
            dragStartPixels: params.dragStartPixels || 0,
            eElement: params.eResizeBar,
            onDragStart: this.onDragStart.bind(this, params),
            onDragStop: this.onDragStop.bind(this, params),
            onDragging: this.onDragging.bind(this, params),
            onDragCancel: this.onDragStop.bind(this, params),
            includeTouch: true,
            stopPropagationForTouch: true
        };
        const { dragSvc: dragSvc } = this.beans;
        dragSvc.addDragSource(dragSource);
        const finishedWithResizeFunc = ()=>dragSvc.removeDragSource(dragSource);
        return finishedWithResizeFunc;
    }
    onDragStart(params, mouseEvent) {
        this.dragStartX = mouseEvent.clientX;
        this.setResizeIcons();
        const shiftKey = mouseEvent instanceof MouseEvent && mouseEvent.shiftKey === true;
        params.onResizeStart(shiftKey);
    }
    setResizeIcons() {
        const ctrl = this.beans.ctrlsSvc.get("gridCtrl");
        ctrl.setResizeCursor(1 /* Horizontal */ );
        ctrl.disableUserSelect(true);
    }
    onDragStop(params) {
        params.onResizeEnd(this.resizeAmount);
        this.resetIcons();
    }
    resetIcons() {
        const ctrl = this.beans.ctrlsSvc.get("gridCtrl");
        ctrl.setResizeCursor(false);
        ctrl.disableUserSelect(false);
    }
    onDragging(params, mouseEvent) {
        this.resizeAmount = mouseEvent.clientX - this.dragStartX;
        params.onResizing(this.resizeAmount);
    }
};
// packages/ag-grid-community/src/dragAndDrop/rowDragComp.ts
var $437b23f6a393c3bf$var$RowDragElement = {
    tag: "div",
    cls: "ag-drag-handle ag-row-drag",
    attrs: {
        "aria-hidden": "true"
    }
};
var $437b23f6a393c3bf$var$RowDragComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(cellValueFn, rowNode, column, customGui, dragStartPixels, suppressVisibilityChange){
        super();
        this.cellValueFn = cellValueFn;
        this.rowNode = rowNode;
        this.column = column;
        this.customGui = customGui;
        this.dragStartPixels = dragStartPixels;
        this.suppressVisibilityChange = suppressVisibilityChange;
        this.dragSource = null;
    }
    isCustomGui() {
        return this.customGui != null;
    }
    postConstruct() {
        const { beans: beans, rowNode: rowNode, column: column, gos: gos } = this;
        if (!this.customGui) {
            this.setTemplate($437b23f6a393c3bf$var$RowDragElement);
            this.getGui().appendChild($437b23f6a393c3bf$export$d8feba07bf373edb("rowDrag", beans, null));
            this.addDragSource();
        } else this.setDragElement(this.customGui, this.dragStartPixels);
        if (!this.suppressVisibilityChange) {
            const strategy = gos.get("rowDragManaged") ? new $437b23f6a393c3bf$var$ManagedVisibilityStrategy(this, rowNode, column) : new $437b23f6a393c3bf$var$NonManagedVisibilityStrategy(this, rowNode, column);
            this.createManagedBean(strategy, this.beans.context);
        }
    }
    setDragElement(dragElement, dragStartPixels) {
        this.setTemplateFromElement(dragElement, void 0, void 0, true);
        this.addDragSource(dragStartPixels);
    }
    getSelectedNodes() {
        const rowNode = this.rowNode;
        const isRowDragMultiRow = this.gos.get("rowDragMultiRow");
        if (!isRowDragMultiRow) return [
            rowNode
        ];
        const selection = this.beans.selectionSvc?.getSelectedNodes() ?? [];
        return selection.indexOf(rowNode) !== -1 ? selection : [
            rowNode
        ];
    }
    getDragItem() {
        const { column: column, rowNode: rowNode } = this;
        return {
            rowNode: rowNode,
            rowNodes: this.getSelectedNodes(),
            columns: column ? [
                column
            ] : void 0,
            defaultTextValue: this.cellValueFn()
        };
    }
    getRowDragText(column) {
        if (column) {
            const colDef = column.getColDef();
            if (colDef.rowDragText) return colDef.rowDragText;
        }
        return this.gos.get("rowDragText");
    }
    addDragSource(dragStartPixels = 4) {
        if (this.dragSource) this.removeDragSource();
        if (this.gos.get("rowDragManaged") && this.rowNode.footer) return;
        const eGui = this.getGui();
        if (this.gos.get("enableCellTextSelection")) {
            this.removeMouseDownListener();
            this.mouseDownListener = this.addManagedElementListeners(eGui, {
                mousedown: (e)=>{
                    e?.preventDefault();
                }
            })[0];
        }
        const translate = this.getLocaleTextFunc();
        this.dragSource = {
            type: 2 /* RowDrag */ ,
            eElement: eGui,
            dragItemName: ()=>{
                const dragItem = this.getDragItem();
                const dragItemCount = dragItem.rowNodes?.length || 1;
                const rowDragText = this.getRowDragText(this.column);
                if (rowDragText) return rowDragText(dragItem, dragItemCount);
                return dragItemCount === 1 ? this.cellValueFn() : `${dragItemCount} ${translate("rowDragRows", "rows")}`;
            },
            getDragItem: ()=>this.getDragItem(),
            dragStartPixels: dragStartPixels,
            dragSourceDomDataKey: this.gos.getDomDataKey()
        };
        this.beans.dragAndDrop.addDragSource(this.dragSource, true);
    }
    destroy() {
        this.removeDragSource();
        this.removeMouseDownListener();
        super.destroy();
    }
    removeDragSource() {
        if (!this.dragSource) return;
        this.beans.dragAndDrop.removeDragSource(this.dragSource);
        this.dragSource = null;
    }
    removeMouseDownListener() {
        if (!this.mouseDownListener) return;
        this.mouseDownListener();
        this.mouseDownListener = void 0;
    }
};
var $437b23f6a393c3bf$var$VisibilityStrategy = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(parent, rowNode, column){
        super();
        this.parent = parent;
        this.rowNode = rowNode;
        this.column = column;
    }
    setDisplayedOrVisible(neverDisplayed, alwaysHidden = false) {
        const displayedOptions = {
            skipAriaHidden: true
        };
        if (neverDisplayed) this.parent.setDisplayed(false, displayedOptions);
        else {
            let shown = !alwaysHidden;
            let isShownSometimes = false;
            const { column: column, rowNode: rowNode, parent: parent } = this;
            if (column) {
                const rowDrag = column.getColDef().rowDrag;
                isShownSometimes = typeof rowDrag === "function";
                shown = (alwaysHidden ? !!rowDrag : column.isRowDrag(rowNode)) || parent.isCustomGui();
            }
            if (isShownSometimes) {
                parent.setDisplayed(true, displayedOptions);
                parent.setVisible(shown && !alwaysHidden, displayedOptions);
            } else {
                parent.setDisplayed(shown, displayedOptions);
                parent.setVisible(!alwaysHidden, displayedOptions);
            }
        }
    }
};
var $437b23f6a393c3bf$var$NonManagedVisibilityStrategy = class extends $437b23f6a393c3bf$var$VisibilityStrategy {
    postConstruct() {
        this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this));
        const listener = this.workOutVisibility.bind(this);
        this.addManagedListeners(this.rowNode, {
            dataChanged: listener,
            cellChanged: listener
        });
        this.addManagedListeners(this.beans.eventSvc, {
            newColumnsLoaded: listener
        });
        this.workOutVisibility();
    }
    onSuppressRowDrag() {
        this.workOutVisibility();
    }
    workOutVisibility() {
        const neverDisplayed = this.gos.get("suppressRowDrag");
        this.setDisplayedOrVisible(neverDisplayed);
    }
};
var $437b23f6a393c3bf$var$ManagedVisibilityStrategy = class extends $437b23f6a393c3bf$var$VisibilityStrategy {
    postConstruct() {
        const listener = this.workOutVisibility.bind(this);
        this.addManagedListeners(this.beans.eventSvc, {
            sortChanged: listener,
            filterChanged: listener,
            columnRowGroupChanged: listener,
            newColumnsLoaded: listener
        });
        this.addManagedListeners(this.rowNode, {
            dataChanged: listener,
            cellChanged: listener
        });
        this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this));
        this.workOutVisibility();
    }
    onSuppressRowDrag() {
        this.workOutVisibility();
    }
    workOutVisibility() {
        const { rowDragSvc: rowDragSvc, dragAndDrop: dragAndDrop, gos: gos } = this.beans;
        const rowDragFeature = rowDragSvc.rowDragFeature;
        const shouldPreventRowMove = rowDragFeature && rowDragFeature.shouldPreventRowMove();
        const suppressRowDrag = gos.get("suppressRowDrag");
        const hasExternalDropZones = dragAndDrop.hasExternalDropZones();
        const neverDisplayed = shouldPreventRowMove && !hasExternalDropZones || suppressRowDrag;
        this.setDisplayedOrVisible(neverDisplayed, this.rowNode.footer);
    }
};
// packages/ag-grid-community/src/utils/changedPath.ts
var $437b23f6a393c3bf$export$cb4d9114a9732e85 = class {
    constructor(keepingColumns, rootNode){
        // whether changed path is active of not. it is active when a) doing
        // a transaction update or b) doing change detection. if we are doing
        // a CSRM refresh for other reasons (after sort or filter, or user calling
        // setRowData() without delta mode) then we are not active. we are also
        // marked as not active if secondary columns change in pivot (as this impacts
        // aggregations).
        // can be set inactive by:
        // a) ClientSideRowModel, if no transactions or
        // b) PivotService, if secondary columns changed
        this.active = true;
        // for each node in the change path, we also store which columns need
        // to be re-aggregated.
        this.nodeIdsToColumns = {};
        // for quick lookup, all items in the change path are mapped by nodeId
        this.mapToItems = {};
        this.keepingColumns = keepingColumns;
        this.pathRoot = {
            rowNode: rootNode,
            children: null
        };
        this.mapToItems[rootNode.id] = this.pathRoot;
    }
    depthFirstSearchChangedPath(pathItem, callback) {
        const { rowNode: rowNode, children: children } = pathItem;
        if (children) for(let i = 0; i < children.length; ++i)this.depthFirstSearchChangedPath(children[i], callback);
        callback(rowNode);
    }
    depthFirstSearchEverything(rowNode, callback, traverseEverything) {
        const childrenAfterGroup = rowNode.childrenAfterGroup;
        if (childrenAfterGroup) for(let i = 0, len = childrenAfterGroup.length; i < len; ++i){
            const childNode = childrenAfterGroup[i];
            if (childNode.childrenAfterGroup) this.depthFirstSearchEverything(childNode, callback, traverseEverything);
            else if (traverseEverything) callback(childNode);
        }
        callback(rowNode);
    }
    // traverseLeafNodes -> used when NOT doing changed path, ie traversing everything. the callback
    // will be called for child nodes in addition to parent nodes.
    forEachChangedNodeDepthFirst(callback, traverseLeafNodes = false, includeUnchangedNodes = false) {
        if (this.active && !includeUnchangedNodes) this.depthFirstSearchChangedPath(this.pathRoot, callback);
        else this.depthFirstSearchEverything(this.pathRoot.rowNode, callback, traverseLeafNodes);
    }
    executeFromRootNode(callback) {
        callback(this.pathRoot.rowNode);
    }
    createPathItems(rowNode) {
        let pointer = rowNode;
        let newEntryCount = 0;
        while(!this.mapToItems[pointer.id]){
            const newEntry = {
                rowNode: pointer,
                children: null
            };
            this.mapToItems[pointer.id] = newEntry;
            newEntryCount++;
            pointer = pointer.parent;
        }
        return newEntryCount;
    }
    populateColumnsMap(rowNode, columns) {
        if (!this.keepingColumns || !columns) return;
        let pointer = rowNode;
        while(pointer){
            if (!this.nodeIdsToColumns[pointer.id]) this.nodeIdsToColumns[pointer.id] = {};
            columns.forEach((col)=>this.nodeIdsToColumns[pointer.id][col.getId()] = true);
            pointer = pointer.parent;
        }
    }
    linkPathItems(rowNode, newEntryCount) {
        let pointer = rowNode;
        for(let i = 0; i < newEntryCount; i++){
            const thisItem = this.mapToItems[pointer.id];
            const parentItem = this.mapToItems[pointer.parent.id];
            if (!parentItem.children) parentItem.children = [];
            parentItem.children.push(thisItem);
            pointer = pointer.parent;
        }
    }
    // called by
    // 1) change detection (provides cols) and
    // 2) groupStage if doing transaction update (doesn't provide cols)
    addParentNode(rowNode, columns) {
        if (!rowNode || rowNode.isRowPinned()) return;
        const newEntryCount = this.createPathItems(rowNode);
        this.linkPathItems(rowNode, newEntryCount);
        this.populateColumnsMap(rowNode, columns);
    }
    canSkip(rowNode) {
        return this.active && !this.mapToItems[rowNode.id];
    }
    getValueColumnsForNode(rowNode, valueColumns) {
        if (!this.keepingColumns) return valueColumns;
        const colsForThisNode = this.nodeIdsToColumns[rowNode.id];
        const result = valueColumns.filter((col)=>colsForThisNode[col.getId()]);
        return result;
    }
    getNotValueColumnsForNode(rowNode, valueColumns) {
        if (!this.keepingColumns) return null;
        const colsForThisNode = this.nodeIdsToColumns[rowNode.id];
        const result = valueColumns.filter((col)=>!colsForThisNode[col.getId()]);
        return result;
    }
};
// packages/ag-grid-community/src/dragAndDrop/rowDragFeature.ts
var $437b23f6a393c3bf$var$RowDragFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eContainer){
        super();
        this.eContainer = null;
        this.lastDraggingEvent = null;
        this.autoScrollService = null;
        this.makeGroupThrottleTimer = null;
        this.makeGroupThrottleTarget = null;
        this.makeGroupThrottled = false;
        this.makeGroupThrottleCallback = ()=>{
            this.makeGroupThrottleTimer = null;
            const event = this.lastDraggingEvent;
            if (event) {
                this.makeGroupThrottled = true;
                this.doManagedDrag(event, false);
                this.makeGroupExpanded(this.makeGroupThrottleTarget);
            }
        };
        this.eContainer = eContainer;
    }
    postConstruct() {
        const { rowModel: rowModel, gos: gos, ctrlsSvc: ctrlsSvc } = this.beans;
        if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) this.clientSideRowModel = rowModel;
        ctrlsSvc.whenReady(this, (p)=>{
            const gridBodyCon = p.gridBodyCtrl;
            let oldVScroll = 0;
            const getVScroll2 = ()=>gridBodyCon.scrollFeature.getVScrollPosition().top;
            this.autoScrollService = new $437b23f6a393c3bf$export$c66bdc3d55a4f95({
                scrollContainer: gridBodyCon.eBodyViewport,
                scrollAxis: "y",
                getVerticalPosition: getVScroll2,
                setVerticalPosition: (position)=>gridBodyCon.scrollFeature.setVerticalScrollPosition(position),
                onScrollCallback: ()=>{
                    const newVScroll = getVScroll2();
                    if (oldVScroll !== newVScroll) {
                        oldVScroll = newVScroll;
                        const lastDraggingEvent = this.lastDraggingEvent;
                        if (lastDraggingEvent) this.onDragging(lastDraggingEvent);
                    }
                }
            });
        });
    }
    destroy() {
        super.destroy();
        this.eContainer = null;
        this.lastDraggingEvent = null;
        this.makeGroupThrottleClear();
        const autoScrollService = this.autoScrollService;
        if (autoScrollService) {
            this.autoScrollService = null;
            autoScrollService?.ensureCleared();
        }
    }
    getContainer() {
        return this.eContainer;
    }
    isInterestedIn(type) {
        return type === 2 /* RowDrag */ ;
    }
    getIconName() {
        const managedDrag = this.gos.get("rowDragManaged");
        if (managedDrag && this.shouldPreventRowMove()) return "notAllowed";
        return "move";
    }
    shouldPreventRowMove() {
        const { rowGroupColsSvc: rowGroupColsSvc, filterManager: filterManager, sortSvc: sortSvc } = this.beans;
        const rowGroupCols = rowGroupColsSvc?.columns ?? [];
        if (rowGroupCols.length) return true;
        const isFilterPresent = filterManager?.isAnyFilterPresent();
        if (isFilterPresent) return true;
        const isSortActive = sortSvc?.isSortActive();
        if (isSortActive) return true;
        return false;
    }
    getRowNodes(draggingEvent) {
        if (!this.isFromThisGrid(draggingEvent)) return draggingEvent.dragItem.rowNodes || [];
        const currentNode = draggingEvent.dragItem.rowNode;
        const isRowDragMultiRow = this.gos.get("rowDragMultiRow");
        if (isRowDragMultiRow) {
            const selectedNodes = [
                ...this.beans.selectionSvc?.getSelectedNodes() ?? []
            ].sort((a, b)=>{
                if (a.rowIndex == null || b.rowIndex == null) return 0;
                return this.getRowIndexNumber(a) - this.getRowIndexNumber(b);
            });
            if (selectedNodes.indexOf(currentNode) !== -1) return selectedNodes;
        }
        return [
            currentNode
        ];
    }
    onDragEnter(draggingEvent) {
        draggingEvent.dragItem.rowNodes = this.getRowNodes(draggingEvent);
        this.dispatchGridEvent("rowDragEnter", draggingEvent);
        this.getRowNodes(draggingEvent).forEach((rowNode)=>{
            this.setRowNodeDragging(rowNode, true);
        });
        this.onEnterOrDragging(draggingEvent);
    }
    onDragging(draggingEvent) {
        this.onEnterOrDragging(draggingEvent);
    }
    isFromThisGrid(draggingEvent) {
        const { dragSourceDomDataKey: dragSourceDomDataKey } = draggingEvent.dragSource;
        return dragSourceDomDataKey === this.gos.getDomDataKey();
    }
    onEnterOrDragging(draggingEvent) {
        if (!this.autoScrollService) return;
        this.dispatchGridEvent("rowDragMove", draggingEvent);
        this.lastDraggingEvent = draggingEvent;
        if (this.gos.get("rowDragManaged")) this.doManagedDrag(draggingEvent, true);
        this.autoScrollService.check(draggingEvent.event);
    }
    doManagedDrag(draggingEvent, throttleMakeGroup) {
        const { dragAndDrop: dragAndDrop, gos: gos } = this.beans;
        const isFromThisGrid = this.isFromThisGrid(draggingEvent);
        const managedDrag = gos.get("rowDragManaged");
        if (managedDrag && this.shouldPreventRowMove()) return;
        if (gos.get("suppressMoveWhenRowDragging") || !isFromThisGrid) {
            if (dragAndDrop.isDropZoneWithinThisGrid(draggingEvent)) {
                const rowsDrop = this.managedRowsDrop(draggingEvent, throttleMakeGroup);
                const target = rowsDrop?.target;
                const rowDropHighlightSvc = this.beans.rowDropHighlightSvc;
                if (target && rowsDrop.rows.length) rowDropHighlightSvc.set(target, rowsDrop.position);
                else rowDropHighlightSvc.clear();
            }
        } else {
            const rowsDrop = this.managedRowsDrop(draggingEvent, throttleMakeGroup);
            if (rowsDrop) this.dropRows(rowsDrop);
        }
    }
    getRowIndexNumber(rowNode) {
        const rowIndexStr = rowNode.getRowIndexString();
        return parseInt($437b23f6a393c3bf$export$236389741107357f(rowIndexStr.split("-")), 10);
    }
    managedRowsDrop(draggingEvent, throttleMakeGroup) {
        const { rowNode: rowNode, rowNodes: rows } = draggingEvent.dragItem;
        const rowsLen = rows?.length;
        const source = rowsLen && (rowNode ?? rows[0]);
        if (!source) {
            this.makeGroupThrottleClear();
            return null;
        }
        const { beans: beans, gos: gos, clientSideRowModel: clientSideRowModel } = this;
        const rootNode = clientSideRowModel.rootNode;
        const y = $437b23f6a393c3bf$export$530c24bdfacb8cd1(beans, draggingEvent).y;
        let targetRowIndex = clientSideRowModel.getRowIndexAtPixel(y);
        let target = clientSideRowModel.getRow(targetRowIndex) ?? null;
        const moved = source !== target;
        let yDelta = target ? (y - target.rowTop - target.rowHeight / 2) / target.rowHeight || 0 : 1;
        const sameGrid = this.isFromThisGrid(draggingEvent);
        const groupingApproach = $437b23f6a393c3bf$export$e9780a3033a82b4f(gos);
        const canSetParent = // We don't yet support drag and drop with grouping
        groupingApproach !== "group" && // We don't yet support moving tree rows from a different grid in a structured way
        sameGrid;
        let newParent = null;
        if (canSetParent && target?.footer) {
            newParent = target.sibling ?? rootNode;
            const found = $437b23f6a393c3bf$var$getPrevOrNext(clientSideRowModel, -1, target) ?? $437b23f6a393c3bf$var$getPrevOrNext(clientSideRowModel, 1, target);
            yDelta = found && found.rowIndex > target.rowIndex ? -0.5 : 0.5;
            target = found ?? null;
        }
        let above = yDelta < 0;
        let targetInRows = false;
        if (sameGrid && target) {
            if (!moved) {
                if (Math.abs(yDelta) <= 0.5) {
                    this.makeGroupThrottleClear();
                    return null;
                }
                targetInRows = true;
            } else {
                targetInRows = rows.indexOf(target) >= 0;
                if (targetInRows) {
                    const newTarget = $437b23f6a393c3bf$var$getRowsPrevOrNext(clientSideRowModel, targetRowIndex < source.rowIndex, rows);
                    if (newTarget?.parent === target.parent) {
                        target = newTarget;
                        targetRowIndex = target.rowIndex;
                    }
                }
            }
            if (targetInRows || !canSetParent && Math.abs(targetRowIndex - source.rowIndex) === 1) above = targetRowIndex < source.rowIndex;
        }
        const makeGroupThrottleTarget = this.makeGroupThrottleTarget;
        if (makeGroupThrottleTarget !== null && makeGroupThrottleTarget !== target) this.makeGroupThrottleClear();
        if (target?.expanded && target.childrenAfterSort?.length) {
            this.makeGroupThrottled = true;
            this.makeGroupThrottleTarget = target;
        }
        if (newParent === null && canSetParent) {
            if (!target || yDelta >= 0.5 && target.rowIndex === beans.pageBounds.getLastRow()) newParent = rootNode;
            else if (this.targetShouldBeParent(target, yDelta, targetInRows, rows)) {
                if (this.makeGroupThrottled) newParent = target;
                if (throttleMakeGroup && (newParent === null || !target.expanded)) {
                    this.makeGroupThrottleTarget = target;
                    this.makeGroupThrottleStart();
                }
            }
            newParent ?? (newParent = target?.parent ?? rootNode);
        }
        let inside = false;
        if (newParent !== null) {
            if (newParent === target && newParent !== rootNode) {
                inside = true;
                const firstRow = newParent.expanded ? $437b23f6a393c3bf$var$getPrevOrNext(clientSideRowModel, 1, target) : null;
                if (firstRow?.parent === newParent) {
                    target = firstRow;
                    inside = false;
                    above = true;
                }
            }
            if (target && !inside) {
                let current = target;
                while(current && current !== rootNode && current !== newParent){
                    target = current;
                    current = current.parent;
                }
            }
            if ($437b23f6a393c3bf$var$rowsHaveSameParent(rows, newParent)) newParent = null;
        }
        if (!newParent && targetInRows && (canSetParent || source === target)) return null;
        const position = inside ? "inside" : above ? "above" : "below";
        const result = {
            api: this.beans.gridApi,
            context: this.beans.gridOptions.context,
            draggingEvent: draggingEvent,
            sameGrid: sameGrid,
            position: position,
            source: source,
            target: target,
            newParent: newParent,
            rows: rows
        };
        let customPosition = false;
        const isRowValidDropPosition = gos.get("isRowValidDropPosition");
        if (isRowValidDropPosition) {
            const canDropResult = isRowValidDropPosition(result);
            if (!canDropResult) result.rows = $437b23f6a393c3bf$export$c758d9371030a6ac;
            else if (typeof canDropResult === "object") {
                if (canDropResult.rows !== void 0) result.rows = canDropResult.rows ?? $437b23f6a393c3bf$export$c758d9371030a6ac;
                if (canDropResult.newParent !== void 0) result.newParent = canDropResult.newParent;
                if (canDropResult.target !== void 0) result.target = canDropResult.target;
                if (canDropResult.position) {
                    customPosition = true;
                    result.position = canDropResult.position;
                }
            }
        }
        if ((!result.newParent || !result.rows.length) && !customPosition) result.position = above ? "above" : "below";
        return result;
    }
    makeGroupThrottleStart() {
        if (this.makeGroupThrottleTimer === null) this.makeGroupThrottleTimer = window.setTimeout(this.makeGroupThrottleCallback, this.gos.get("rowDragInsertDelay"));
    }
    makeGroupExpanded(target) {
        if (target && !target.expanded && target.childrenAfterSort?.length && target.isExpandable()) target.setExpanded(true, this.lastDraggingEvent?.event, true);
    }
    makeGroupThrottleClear() {
        this.makeGroupThrottled = false;
        this.makeGroupThrottleTarget = null;
        const timer = this.makeGroupThrottleTimer;
        if (timer !== null) {
            this.makeGroupThrottleTimer = null;
            clearTimeout(timer);
        }
    }
    targetShouldBeParent(target, yDelta, targetInRows, rows) {
        const targetRowIndex = target?.rowIndex;
        if (targetInRows || targetRowIndex === null) return false;
        const INSIDE_THRESHOLD = 0.25;
        if (yDelta < -0.5 + INSIDE_THRESHOLD) return false;
        if (yDelta < 0.5 - INSIDE_THRESHOLD) return true;
        let nextRow;
        let nextRowIndex = targetRowIndex + 1;
        const clientSideRowModel = this.clientSideRowModel;
        do nextRow = clientSideRowModel.getRow(nextRowIndex++);
        while (nextRow && nextRow.footer);
        const childrenAfterGroup = target.childrenAfterGroup;
        if (nextRow && nextRow.parent === target && childrenAfterGroup?.length) {
            const rowsSet = new Set(rows);
            for (const child of childrenAfterGroup){
                if (child.rowIndex !== null && !rowsSet.has(child)) return true;
            }
        }
        return false;
    }
    addRowDropZone(params) {
        if (!params.getContainer()) {
            $437b23f6a393c3bf$export$545083624300f13d(55);
            return;
        }
        const dragAndDrop = this.beans.dragAndDrop;
        if (dragAndDrop.findExternalZone(params)) {
            $437b23f6a393c3bf$export$545083624300f13d(56);
            return;
        }
        let processedParams = {
            getContainer: params.getContainer
        };
        if (params.fromGrid) processedParams = params;
        else {
            if (params.onDragEnter) processedParams.onDragEnter = (e)=>{
                params.onDragEnter(this.draggingToRowDragEvent("rowDragEnter", e));
            };
            if (params.onDragLeave) processedParams.onDragLeave = (e)=>{
                params.onDragLeave(this.draggingToRowDragEvent("rowDragLeave", e));
            };
            if (params.onDragging) processedParams.onDragging = (e)=>{
                params.onDragging(this.draggingToRowDragEvent("rowDragMove", e));
            };
            if (params.onDragStop) processedParams.onDragStop = (e)=>{
                params.onDragStop(this.draggingToRowDragEvent("rowDragEnd", e));
            };
            if (params.onDragCancel) processedParams.onDragCancel = (e)=>{
                params.onDragCancel(this.draggingToRowDragEvent("rowDragCancel", e));
            };
        }
        const dropTarget = {
            isInterestedIn: (type)=>type === 2 /* RowDrag */ ,
            getIconName: ()=>"move",
            external: true,
            ...processedParams
        };
        dragAndDrop.addDropTarget(dropTarget);
        this.addDestroyFunc(()=>dragAndDrop.removeDropTarget(dropTarget));
    }
    getRowDropZone(events) {
        const getContainer = this.getContainer.bind(this);
        const onDragEnter = this.onDragEnter.bind(this);
        const onDragLeave = this.onDragLeave.bind(this);
        const onDragging = this.onDragging.bind(this);
        const onDragStop = this.onDragStop.bind(this);
        const onDragCancel = this.onDragCancel.bind(this);
        let params;
        if (!events) params = {
            getContainer: getContainer,
            onDragEnter: onDragEnter,
            onDragLeave: onDragLeave,
            onDragging: onDragging,
            onDragStop: onDragStop,
            onDragCancel: onDragCancel,
            /* @private */ fromGrid: true
        };
        else params = {
            getContainer: getContainer,
            onDragEnter: events.onDragEnter ? (e)=>{
                onDragEnter(e);
                events.onDragEnter(this.draggingToRowDragEvent("rowDragEnter", e));
            } : onDragEnter,
            onDragLeave: events.onDragLeave ? (e)=>{
                onDragLeave(e);
                events.onDragLeave(this.draggingToRowDragEvent("rowDragLeave", e));
            } : onDragLeave,
            onDragging: events.onDragging ? (e)=>{
                onDragging(e);
                events.onDragging(this.draggingToRowDragEvent("rowDragMove", e));
            } : onDragging,
            onDragStop: events.onDragStop ? (e)=>{
                onDragStop(e);
                events.onDragStop(this.draggingToRowDragEvent("rowDragEnd", e));
            } : onDragStop,
            onDragCancel: events.onDragCancel ? (e)=>{
                onDragCancel(e);
                events.onDragCancel(this.draggingToRowDragEvent("rowDragCancel", e));
            } : onDragCancel,
            fromGrid: true
        };
        return params;
    }
    draggingToRowDragEvent(type, draggingEvent) {
        const beans = this.beans;
        const { pageBounds: pageBounds, rowModel: rowModel, gos: gos } = beans;
        const y = $437b23f6a393c3bf$export$530c24bdfacb8cd1(this.beans, draggingEvent).y;
        const mouseIsPastLastRow = y > pageBounds.getCurrentPagePixelRange().pageLastPixel;
        let overIndex = -1;
        let overNode;
        if (!mouseIsPastLastRow) {
            overIndex = rowModel.getRowIndexAtPixel(y);
            overNode = rowModel.getRow(overIndex);
        }
        const event = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            type: type,
            event: draggingEvent.event,
            node: draggingEvent.dragItem.rowNode,
            nodes: draggingEvent.dragItem.rowNodes,
            overIndex: overIndex,
            overNode: overNode,
            y: y,
            vDirection: draggingEvent.vDirection
        });
        return event;
    }
    dispatchGridEvent(type, draggingEvent) {
        const event = this.draggingToRowDragEvent(type, draggingEvent);
        this.eventSvc.dispatchEvent(event);
    }
    onDragLeave(draggingEvent) {
        this.dispatchGridEvent("rowDragLeave", draggingEvent);
        this.stopDragging(draggingEvent);
        if (this.gos.get("rowDragManaged")) this.beans.rowDropHighlightSvc.clear();
        this.makeGroupThrottleClear();
    }
    onDragStop(draggingEvent) {
        this.dispatchGridEvent("rowDragEnd", draggingEvent);
        this.stopDragging(draggingEvent);
        const { dragAndDrop: dragAndDrop, gos: gos } = this.beans;
        if (gos.get("rowDragManaged") && (gos.get("suppressMoveWhenRowDragging") || !this.isFromThisGrid(draggingEvent)) && dragAndDrop.isDropZoneWithinThisGrid(draggingEvent)) {
            const rowsDrop = this.managedRowsDrop(draggingEvent, false);
            if (rowsDrop) this.dropRows(rowsDrop);
            this.beans.rowDropHighlightSvc.clear();
        }
        this.makeGroupThrottleClear();
    }
    onDragCancel(draggingEvent) {
        this.dispatchGridEvent("rowDragCancel", draggingEvent);
        this.stopDragging(draggingEvent);
        const { dragAndDrop: dragAndDrop, gos: gos } = this.beans;
        if (gos.get("rowDragManaged") && (gos.get("suppressMoveWhenRowDragging") || !this.isFromThisGrid(draggingEvent)) && dragAndDrop.isDropZoneWithinThisGrid(draggingEvent)) this.beans.rowDropHighlightSvc.clear();
        this.makeGroupThrottleClear();
    }
    stopDragging(draggingEvent) {
        this.autoScrollService?.ensureCleared();
        this.getRowNodes(draggingEvent).forEach((rowNode)=>{
            this.setRowNodeDragging(rowNode, false);
        });
    }
    setRowNodeDragging(rowNode, dragging) {
        if (rowNode.dragging !== dragging) {
            rowNode.dragging = dragging;
            rowNode.dispatchRowEvent("draggingChanged");
        }
    }
    /** Drag and drop. Returns false if at least a row was moved, otherwise true */ dropRows(rowsDrop) {
        return rowsDrop.sameGrid ? this.moveRows(rowsDrop) : this.addRows(rowsDrop);
    }
    addRows({ position: position, target: target, rows: rows }) {
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        const clientSideRowModel = this.clientSideRowModel;
        const add = rows.filter(({ data: data, rowPinned: rowPinned })=>!clientSideRowModel.getRowNode(getRowIdFunc?.({
                data: data,
                level: 0,
                rowPinned: rowPinned
            }) ?? data.id)).map(({ data: data })=>data);
        if (add.length === 0) return false;
        const addIndex = target ? $437b23f6a393c3bf$var$getLeafSourceRowIndex(target) + (position === "above" ? 0 : 1) : void 0;
        clientSideRowModel.updateRowData({
            add: add,
            addIndex: addIndex
        });
        return true;
    }
    refreshModelAfterDrop() {
        this.clientSideRowModel.refreshModel({
            step: "group",
            keepRenderedRows: true,
            animate: !this.gos.get("suppressAnimationFrame"),
            changedPath: new $437b23f6a393c3bf$export$cb4d9114a9732e85(false, this.clientSideRowModel.rootNode),
            rowNodesOrderChanged: true
        });
    }
    moveRows({ position: position, target: target, rows: rows, newParent: newParent }) {
        let changed = false;
        const clientSideRowModel = this.clientSideRowModel;
        const leafs = /* @__PURE__ */ new Set();
        for (const row of rows){
            if (row.footer || row.rowTop === null && row !== clientSideRowModel.getRowNode(row.id)) continue;
            if (newParent && row.parent !== newParent) {
                if ($437b23f6a393c3bf$var$wouldFormCycle(row, newParent)) continue;
                row.treeParent = newParent;
                changed = true;
            }
            const leafRow = $437b23f6a393c3bf$var$getLeafRow(row);
            if (leafRow) leafs.add(leafRow);
        }
        if (!changed && leafs.size === 0) return false;
        const focusSvc = this.beans.focusSvc;
        const cellPosition = focusSvc.getFocusedCell();
        const cellCtrl = cellPosition && $437b23f6a393c3bf$export$1bd7ce47360c3c0(this.beans, cellPosition);
        if (leafs.size && this.reorderLeafChildren(leafs, ...this.getMoveRowsBounds(leafs, target, position === "above"))) changed = true;
        if (!changed) return false;
        this.refreshModelAfterDrop();
        if (cellCtrl) cellCtrl.focusCell();
        else focusSvc.clearFocusedCell();
        return true;
    }
    /** For reorderLeafChildren, returns min index of the rows to move, the target index and the max index of the rows to move. */ getMoveRowsBounds(leafs, target, above) {
        const totalRows = this.clientSideRowModel.rootNode?.allLeafChildren.length ?? 0;
        let targetPositionIdx = $437b23f6a393c3bf$var$getLeafSourceRowIndex(target);
        if (targetPositionIdx < 0 || targetPositionIdx >= totalRows) targetPositionIdx = totalRows;
        else if (!above) ++targetPositionIdx;
        let firstAffectedLeafIdx = targetPositionIdx;
        let lastAffectedLeafIndex = Math.min(targetPositionIdx, totalRows - 1);
        for (const row of leafs){
            const sourceRowIndex = row.sourceRowIndex;
            if (sourceRowIndex < firstAffectedLeafIdx) firstAffectedLeafIdx = sourceRowIndex;
            if (sourceRowIndex > lastAffectedLeafIndex) lastAffectedLeafIndex = sourceRowIndex;
        }
        return [
            firstAffectedLeafIdx,
            targetPositionIdx,
            lastAffectedLeafIndex
        ];
    }
    /** Reorders the children of the root node, so that the rows to move are in the correct order.
   * @param leafs The valid set of rows to move, as returned by getValidRowsToMove
   * @param firstAffectedLeafIdx The first index of the rows to move
   * @param targetPositionIdx The target index, where the rows will be moved
   * @param lastAffectedLeafIndex The last index of the rows to move
   * @returns True if the order of the rows changed, false otherwise
   */ reorderLeafChildren(leafs, firstAffectedLeafIdx, targetPositionIdx, lastAffectedLeafIndex) {
        let orderChanged = false;
        const allLeafChildren = this.clientSideRowModel.rootNode?.allLeafChildren;
        if (!leafs.size || !allLeafChildren) return false;
        let writeIdxLeft = firstAffectedLeafIdx;
        for(let readIdx = firstAffectedLeafIdx; readIdx < targetPositionIdx; ++readIdx){
            const row = allLeafChildren[readIdx];
            if (!leafs.has(row)) {
                if (row.sourceRowIndex !== writeIdxLeft) {
                    row.sourceRowIndex = writeIdxLeft;
                    allLeafChildren[writeIdxLeft] = row;
                    orderChanged = true;
                }
                ++writeIdxLeft;
            }
        }
        let writeIdxRight = lastAffectedLeafIndex;
        for(let readIdx = lastAffectedLeafIndex; readIdx >= targetPositionIdx; --readIdx){
            const row = allLeafChildren[readIdx];
            if (!leafs.has(row)) {
                if (row.sourceRowIndex !== writeIdxRight) {
                    row.sourceRowIndex = writeIdxRight;
                    allLeafChildren[writeIdxRight] = row;
                    orderChanged = true;
                }
                --writeIdxRight;
            }
        }
        for (const row of leafs){
            if (row.sourceRowIndex !== writeIdxLeft) {
                row.sourceRowIndex = writeIdxLeft;
                allLeafChildren[writeIdxLeft] = row;
                orderChanged = true;
            }
            ++writeIdxLeft;
        }
        return orderChanged;
    }
};
var $437b23f6a393c3bf$var$getRowsPrevOrNext = (clientSideRowModel, above, rows)=>{
    return above ? $437b23f6a393c3bf$var$getPrevOrNext(clientSideRowModel, -1, rows[0]) : $437b23f6a393c3bf$var$getPrevOrNext(clientSideRowModel, 1, $437b23f6a393c3bf$export$236389741107357f(rows));
};
var $437b23f6a393c3bf$var$getPrevOrNext = (clientSideRowModel, increment, initialRow)=>{
    if (initialRow) {
        const rowCount = clientSideRowModel.getRowCount();
        let rowIndex = initialRow.rowIndex + increment;
        while(rowIndex >= 0 && rowIndex < rowCount){
            const row = clientSideRowModel.getRow(rowIndex);
            if (!row || !row.footer) return row;
            rowIndex += increment;
        }
    }
    return void 0;
};
var $437b23f6a393c3bf$var$wouldFormCycle = (row, newParent)=>{
    let parent = newParent;
    while(parent){
        if (parent === row) return true;
        parent = parent.parent;
    }
    return false;
};
var $437b23f6a393c3bf$var$rowsHaveSameParent = (rows, newParent)=>{
    for(let i = 0, len = rows.length; i < len; ++i){
        if (rows[i].parent !== newParent) return false;
    }
    return true;
};
var $437b23f6a393c3bf$var$getLeafSourceRowIndex = (row)=>{
    const leaf = $437b23f6a393c3bf$var$getLeafRow(row);
    return leaf !== void 0 ? leaf.sourceRowIndex : -1;
};
var $437b23f6a393c3bf$var$getLeafRow = (row)=>{
    while(row){
        if (row.sourceRowIndex >= 0) return row;
        const childrenAfterGroup = row.childrenAfterGroup;
        if (!childrenAfterGroup?.length) return void 0;
        row = childrenAfterGroup[0];
    }
};
// packages/ag-grid-community/src/dragAndDrop/rowDragService.ts
var $437b23f6a393c3bf$var$RowDragService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowDragSvc";
    }
    setupRowDrag(element, ctrl) {
        const rowDragFeature = ctrl.createManagedBean(new $437b23f6a393c3bf$var$RowDragFeature(element));
        const dragAndDrop = this.beans.dragAndDrop;
        dragAndDrop.addDropTarget(rowDragFeature);
        ctrl.addDestroyFunc(()=>dragAndDrop.removeDropTarget(rowDragFeature));
        this.rowDragFeature = rowDragFeature;
    }
    createRowDragComp(cellValueFn, rowNode, column, customGui, dragStartPixels, suppressVisibilityChange) {
        return new $437b23f6a393c3bf$var$RowDragComp(cellValueFn, rowNode, column, customGui, dragStartPixels, suppressVisibilityChange);
    }
    createRowDragCompForRow(rowNode, element) {
        if ($437b23f6a393c3bf$export$1f7ca6920544d9e4(this.gos)) return void 0;
        const translate = this.getLocaleTextFunc();
        return this.createRowDragComp(()=>`1 ${translate("rowDragRow", "row")}`, rowNode, void 0, element, void 0, true);
    }
    createRowDragCompForCell(rowNode, column, cellValueFn, element, dragStartPixels, suppressVisibilityChange) {
        const gos = this.gos;
        if (gos.get("rowDragManaged")) {
            if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos) || gos.get("pagination")) return void 0;
        }
        const rowDragComp = this.createRowDragComp(cellValueFn, rowNode, column, element, dragStartPixels, suppressVisibilityChange);
        return rowDragComp;
    }
};
// packages/ag-grid-community/src/dragAndDrop/rowDropHighlightService.ts
var $437b23f6a393c3bf$var$RowDropHighlightService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowDropHighlightSvc";
        this.uiLevel = 0;
        this.row = null;
        this.position = "none";
    }
    postConstruct() {
        this.addManagedEventListeners({
            modelUpdated: this.onModelUpdated.bind(this)
        });
    }
    onModelUpdated() {
        const row = this.row;
        if (!row || row.rowIndex === null || this.position === "none") this.clear();
        else this.set(row, this.position);
    }
    destroy() {
        this.clear();
        super.destroy();
    }
    clear() {
        const last = this.row;
        if (last) {
            this.uiLevel = 0;
            this.position = "none";
            this.row = null;
            last.dispatchRowEvent("rowHighlightChanged");
        }
    }
    set(row, dropIndicatorPosition) {
        const nodeChanged = row !== this.row;
        const uiLevel = row.uiLevel;
        const highlightChanged = dropIndicatorPosition !== this.position;
        const uiLevelChanged = uiLevel !== this.uiLevel;
        if (nodeChanged || highlightChanged || uiLevelChanged) {
            if (nodeChanged) this.clear();
            this.uiLevel = uiLevel;
            this.position = dropIndicatorPosition;
            this.row = row;
            row.dispatchRowEvent("rowHighlightChanged");
        }
    }
};
// packages/ag-grid-community/src/dragAndDrop/dragModule.ts
var $437b23f6a393c3bf$export$e88a21946d283d22 = {
    moduleName: "Drag",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$DragService
    ]
};
var $437b23f6a393c3bf$export$b9bac28848e60126 = {
    moduleName: "DragAndDrop",
    version: $437b23f6a393c3bf$var$VERSION,
    dynamicBeans: {
        dndSourceComp: $437b23f6a393c3bf$var$DndSourceComp
    },
    icons: {
        // drag handle used to pick up draggable rows
        rowDrag: "grip"
    }
};
var $437b23f6a393c3bf$export$4ad116d131ade5b4 = {
    moduleName: "SharedDragAndDrop",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$DragAndDropService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$e88a21946d283d22
    ],
    userComponents: {
        agDragAndDropImage: $437b23f6a393c3bf$var$DragAndDropImageComponent2
    },
    icons: {
        // shown on drag and drop image component icon while dragging column to the side of the grid to pin
        columnMovePin: "pin",
        // shown on drag and drop image component icon while dragging over part of the page that is not a drop zone
        columnMoveHide: "eye-slash",
        // shown on drag and drop image component icon while dragging columns to reorder
        columnMoveMove: "arrows",
        // animating icon shown when dragging a column to the right of the grid causes horizontal scrolling
        columnMoveLeft: "left",
        // animating icon shown when dragging a column to the left of the grid causes horizontal scrolling
        columnMoveRight: "right",
        // shown on drag and drop image component icon while dragging over Row Groups drop zone
        columnMoveGroup: "group",
        // shown on drag and drop image component icon while dragging over Values drop zone
        columnMoveValue: "aggregation",
        // shown on drag and drop image component icon while dragging over pivot drop zone
        columnMovePivot: "pivot",
        // shown on drag and drop image component icon while dragging over drop zone that doesn't support it, e.g.
        // string column over aggregation drop zone
        dropNotAllowed: "not-allowed",
        // drag handle used to pick up draggable rows
        rowDrag: "grip"
    }
};
var $437b23f6a393c3bf$export$49c914873cdbe391 = {
    moduleName: "RowDrag",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$RowDropHighlightService,
        $437b23f6a393c3bf$var$RowDragService
    ],
    apiFunctions: {
        addRowDropZone: $437b23f6a393c3bf$var$addRowDropZone,
        removeRowDropZone: $437b23f6a393c3bf$var$removeRowDropZone,
        getRowDropZoneParams: $437b23f6a393c3bf$var$getRowDropZoneParams,
        getRowDropPositionIndicator: $437b23f6a393c3bf$var$getRowDropPositionIndicator,
        setRowDropPositionIndicator: $437b23f6a393c3bf$var$setRowDropPositionIndicator
    },
    dependsOn: [
        $437b23f6a393c3bf$export$4ad116d131ade5b4
    ]
};
var $437b23f6a393c3bf$export$57b5b4ab4a8a663e = {
    moduleName: "HorizontalResize",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$HorizontalResizeService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$e88a21946d283d22
    ]
};
// packages/ag-grid-community/src/columnMove/column-moving.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnMovingCSS = /*css*/ `:where(.ag-ltr) :where(.ag-column-moving){.ag-cell,.ag-header-cell,.ag-spanned-cell-wrapper{transition:left .2s}.ag-header-group-cell{transition:left .2s,width .2s}}:where(.ag-rtl) :where(.ag-column-moving){.ag-cell,.ag-header-cell,.ag-spanned-cell-wrapper{transition:right .2s}.ag-header-group-cell{transition:right .2s,width .2s}}`;
// packages/ag-grid-community/src/columnMove/columnAnimationService.ts
var $437b23f6a393c3bf$var$ColumnAnimationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colAnimation";
        this.executeNextFuncs = [];
        this.executeLaterFuncs = [];
        this.active = false;
        // activeNext starts with active but it is reset earlier after the nextFuncs are cleared
        // to prevent calls made to executeNextVMTurn from queuing functions after executeNextFuncs has already been flushed,
        this.activeNext = false;
        this.suppressAnimation = false;
        this.animationThreadCount = 0;
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>this.gridBodyCtrl = p.gridBodyCtrl);
    }
    isActive() {
        return this.active && !this.suppressAnimation;
    }
    setSuppressAnimation(suppress) {
        this.suppressAnimation = suppress;
    }
    start() {
        if (this.active) return;
        const { gos: gos } = this;
        if (gos.get("suppressColumnMoveAnimation")) return;
        if (gos.get("enableRtl")) return;
        this.ensureAnimationCssClassPresent();
        this.active = true;
        this.activeNext = true;
    }
    finish() {
        if (!this.active) return;
        this.flush(()=>this.activeNext = false, ()=>this.active = false);
    }
    executeNextVMTurn(func) {
        if (this.activeNext) this.executeNextFuncs.push(func);
        else func();
    }
    executeLaterVMTurn(func) {
        if (this.active) this.executeLaterFuncs.push(func);
        else func();
    }
    ensureAnimationCssClassPresent() {
        this.animationThreadCount++;
        const animationThreadCountCopy = this.animationThreadCount;
        const { gridBodyCtrl: gridBodyCtrl } = this;
        gridBodyCtrl.setColumnMovingCss(true);
        this.executeLaterFuncs.push(()=>{
            if (this.animationThreadCount === animationThreadCountCopy) gridBodyCtrl.setColumnMovingCss(false);
        });
    }
    flush(callbackNext, callbackLater) {
        const { executeNextFuncs: executeNextFuncs, executeLaterFuncs: executeLaterFuncs } = this;
        if (executeNextFuncs.length === 0 && executeLaterFuncs.length === 0) {
            callbackNext();
            callbackLater();
            return;
        }
        const runFuncs = (queue)=>{
            while(queue.length){
                const func = queue.pop();
                if (func) func();
            }
        };
        this.beans.frameworkOverrides.wrapIncoming(()=>{
            window.setTimeout(()=>{
                callbackNext();
                runFuncs(executeNextFuncs);
            }, 0);
            window.setTimeout(()=>{
                callbackLater();
                runFuncs(executeLaterFuncs);
            }, 200);
        });
    }
};
// packages/ag-grid-community/src/columnMove/columnMoveApi.ts
function $437b23f6a393c3bf$var$moveColumnByIndex(beans, fromIndex, toIndex) {
    beans.colMoves?.moveColumnByIndex(fromIndex, toIndex, "api");
}
function $437b23f6a393c3bf$var$moveColumns(beans, columnsToMoveKeys, toIndex) {
    beans.colMoves?.moveColumns(columnsToMoveKeys, toIndex, "api");
}
// packages/ag-grid-community/src/columnMove/columnDrag/bodyDropPivotTarget.ts
var $437b23f6a393c3bf$var$BodyDropPivotTarget = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned){
        super();
        this.pinned = pinned;
        this.columnsToAggregate = [];
        this.columnsToGroup = [];
        this.columnsToPivot = [];
    }
    /** Callback for when drag enters */ onDragEnter(draggingEvent) {
        this.clearColumnsList();
        if (this.gos.get("functionsReadOnly")) return;
        const dragColumns = draggingEvent.dragItem.columns;
        if (!dragColumns) return;
        dragColumns.forEach((column)=>{
            if (!column.isPrimary()) return;
            if (column.isAnyFunctionActive()) return;
            if (column.isAllowValue()) this.columnsToAggregate.push(column);
            else if (column.isAllowRowGroup()) this.columnsToGroup.push(column);
            else if (column.isAllowPivot()) this.columnsToPivot.push(column);
        });
    }
    getIconName() {
        const totalColumns = this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length;
        if (totalColumns > 0) return this.pinned ? "pinned" : "move";
        return null;
    }
    /** Callback for when drag leaves */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onDragLeave(draggingEvent) {
        this.clearColumnsList();
    }
    clearColumnsList() {
        this.columnsToAggregate.length = 0;
        this.columnsToGroup.length = 0;
        this.columnsToPivot.length = 0;
    }
    /** Callback for when dragging */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onDragging(draggingEvent) {}
    /** Callback for when drag stops */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onDragStop(draggingEvent) {
        const { valueColsSvc: valueColsSvc, rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc } = this.beans;
        if (this.columnsToAggregate.length > 0) valueColsSvc?.addColumns(this.columnsToAggregate, "toolPanelDragAndDrop");
        if (this.columnsToGroup.length > 0) rowGroupColsSvc?.addColumns(this.columnsToGroup, "toolPanelDragAndDrop");
        if (this.columnsToPivot.length > 0) pivotColsSvc?.addColumns(this.columnsToPivot, "toolPanelDragAndDrop");
    }
    onDragCancel() {
        this.clearColumnsList();
    }
};
// packages/ag-grid-community/src/columnMove/internalColumnMoveUtils.ts
function $437b23f6a393c3bf$var$sortColsLikeCols(colsList, cols) {
    if (!cols || cols.length <= 1) return;
    const notAllColsPresent = cols.filter((c)=>colsList.indexOf(c) < 0).length > 0;
    if (notAllColsPresent) return;
    cols.sort((a, b)=>{
        const indexA = colsList.indexOf(a);
        const indexB = colsList.indexOf(b);
        return indexA - indexB;
    });
}
function $437b23f6a393c3bf$var$getColsToMove(allMovingColumns) {
    const newCols = [
        ...allMovingColumns
    ];
    allMovingColumns.forEach((col)=>{
        let movingGroup = null;
        let parent = col.getParent();
        while(parent != null && parent.getDisplayedLeafColumns().length === 1){
            movingGroup = parent;
            parent = parent.getParent();
        }
        if (movingGroup != null) {
            const isMarryChildren = !!movingGroup.getColGroupDef()?.marryChildren;
            const columnsToMove = isMarryChildren ? // when marry children is true, we also have to move hidden
            // columns within the group, so grab them from the `providedColumnGroup`
            movingGroup.getProvidedColumnGroup().getLeafColumns() : movingGroup.getLeafColumns();
            columnsToMove.forEach((newCol)=>{
                if (!newCols.includes(newCol)) newCols.push(newCol);
            });
        }
    });
    return newCols;
}
function $437b23f6a393c3bf$var$getLowestFragMove(validMoves, allMovingColumnsOrdered, colMoves, visibleCols) {
    const displayedCols = visibleCols.allCols;
    let lowestFragMove = null;
    let targetOrder = null;
    for(let i = 0; i < validMoves.length; i++){
        const move = validMoves[i];
        const order = colMoves.getProposedColumnOrder(allMovingColumnsOrdered, move);
        if (!colMoves.doesOrderPassRules(order)) continue;
        const displayedOrder = order.filter((col)=>displayedCols.includes(col));
        if (targetOrder === null) targetOrder = displayedOrder;
        else if (!$437b23f6a393c3bf$export$893967cdb9833fdd(displayedOrder, targetOrder)) break;
        const fragCount = $437b23f6a393c3bf$var$groupFragCount(order);
        if (lowestFragMove === null || fragCount < lowestFragMove.fragCount) lowestFragMove = {
            move: move,
            fragCount: fragCount
        };
    }
    return lowestFragMove;
}
function $437b23f6a393c3bf$var$getBestColumnMoveIndexFromXPosition(params) {
    const { isFromHeader: isFromHeader, fromLeft: fromLeft, xPosition: xPosition, fromEnter: fromEnter, fakeEvent: fakeEvent, pinned: pinned, gos: gos, colModel: colModel, colMoves: colMoves, visibleCols: visibleCols } = params;
    let { allMovingColumns: allMovingColumns } = params;
    if (isFromHeader) allMovingColumns = $437b23f6a393c3bf$var$getColsToMove(allMovingColumns);
    const allMovingColumnsOrdered = allMovingColumns.slice();
    $437b23f6a393c3bf$var$sortColsLikeCols(colModel.getCols(), allMovingColumnsOrdered);
    const validMoves = $437b23f6a393c3bf$var$calculateValidMoves({
        movingCols: allMovingColumnsOrdered,
        draggingRight: fromLeft,
        xPosition: xPosition,
        pinned: pinned,
        gos: gos,
        colModel: colModel,
        visibleCols: visibleCols
    });
    const oldIndex = $437b23f6a393c3bf$var$calculateOldIndex(allMovingColumnsOrdered, colModel);
    if (validMoves.length === 0) return;
    const firstValidMove = validMoves[0];
    const constrainDirection = oldIndex !== null && (isFromHeader || !fromEnter);
    if (constrainDirection && !fakeEvent) {
        if (!fromLeft && firstValidMove >= oldIndex) return;
        if (fromLeft && firstValidMove <= oldIndex) return;
    }
    const lowestFragMove = $437b23f6a393c3bf$var$getLowestFragMove(validMoves, allMovingColumnsOrdered, colMoves, visibleCols);
    if (!lowestFragMove) return;
    const toIndex = lowestFragMove.move;
    if (toIndex > colModel.getCols().length - allMovingColumnsOrdered.length) return;
    return {
        columns: allMovingColumnsOrdered,
        toIndex: toIndex
    };
}
function $437b23f6a393c3bf$var$attemptMoveColumns(params) {
    const { columns: columns, toIndex: toIndex } = $437b23f6a393c3bf$var$getBestColumnMoveIndexFromXPosition(params) || {};
    const { finished: finished, colMoves: colMoves } = params;
    if (!columns || toIndex == null) return null;
    colMoves.moveColumns(columns, toIndex, "uiColumnMoved", finished);
    return finished ? null : {
        columns: columns,
        toIndex: toIndex
    };
}
function $437b23f6a393c3bf$var$calculateOldIndex(movingCols, colModel) {
    const gridCols = colModel.getCols();
    const indexes = movingCols.map((col)=>gridCols.indexOf(col)).sort((a, b)=>a - b);
    const firstIndex = indexes[0];
    const lastIndex = $437b23f6a393c3bf$export$236389741107357f(indexes);
    const spread = lastIndex - firstIndex;
    const gapsExist = spread !== indexes.length - 1;
    return gapsExist ? null : firstIndex;
}
function $437b23f6a393c3bf$var$groupFragCount(columns) {
    function parents(col) {
        const result = [];
        let parent = col.getOriginalParent();
        while(parent != null){
            result.push(parent);
            parent = parent.getOriginalParent();
        }
        return result;
    }
    let count = 0;
    for(let i = 0; i < columns.length - 1; i++){
        let a = parents(columns[i]);
        let b = parents(columns[i + 1]);
        [a, b] = a.length > b.length ? [
            a,
            b
        ] : [
            b,
            a
        ];
        a.forEach((parent)=>{
            if (b.indexOf(parent) === -1) count++;
        });
    }
    return count;
}
function $437b23f6a393c3bf$var$getDisplayedColumns(visibleCols, type) {
    switch(type){
        case "left":
            return visibleCols.leftCols;
        case "right":
            return visibleCols.rightCols;
        default:
            return visibleCols.centerCols;
    }
}
function $437b23f6a393c3bf$var$calculateValidMoves(params) {
    const { movingCols: movingCols, draggingRight: draggingRight, xPosition: xPosition, pinned: pinned, gos: gos, colModel: colModel, visibleCols: visibleCols } = params;
    const isMoveBlocked = gos.get("suppressMovableColumns") || movingCols.some((col)=>col.getColDef().suppressMovable);
    if (isMoveBlocked) return [];
    const allDisplayedCols = $437b23f6a393c3bf$var$getDisplayedColumns(visibleCols, pinned);
    const allGridCols = colModel.getCols();
    const movingDisplayedCols = allDisplayedCols.filter((col)=>movingCols.includes(col));
    const otherDisplayedCols = allDisplayedCols.filter((col)=>!movingCols.includes(col));
    const otherGridCols = allGridCols.filter((col)=>!movingCols.includes(col));
    let displayIndex = 0;
    let availableWidth = xPosition;
    if (draggingRight) {
        let widthOfMovingDisplayedCols = 0;
        movingDisplayedCols.forEach((col)=>widthOfMovingDisplayedCols += col.getActualWidth());
        availableWidth -= widthOfMovingDisplayedCols;
    }
    if (availableWidth > 0) {
        for(let i = 0; i < otherDisplayedCols.length; i++){
            const col = otherDisplayedCols[i];
            availableWidth -= col.getActualWidth();
            if (availableWidth < 0) break;
            displayIndex++;
        }
        if (draggingRight) displayIndex++;
    }
    let firstValidMove;
    if (displayIndex > 0) {
        const leftColumn = otherDisplayedCols[displayIndex - 1];
        firstValidMove = otherGridCols.indexOf(leftColumn) + 1;
    } else {
        firstValidMove = otherGridCols.indexOf(otherDisplayedCols[0]);
        if (firstValidMove === -1) firstValidMove = 0;
    }
    const validMoves = [
        firstValidMove
    ];
    const numberComparator = (a, b)=>a - b;
    if (draggingRight) {
        let pointer = firstValidMove + 1;
        const lastIndex = allGridCols.length - 1;
        while(pointer <= lastIndex){
            validMoves.push(pointer);
            pointer++;
        }
        validMoves.sort(numberComparator);
    } else {
        let pointer = firstValidMove;
        const lastIndex = allGridCols.length - 1;
        let displacedCol = allGridCols[pointer];
        while(pointer <= lastIndex && allDisplayedCols.indexOf(displacedCol) < 0){
            pointer++;
            validMoves.push(pointer);
            displacedCol = allGridCols[pointer];
        }
        pointer = firstValidMove - 1;
        const firstDisplayIndex = 0;
        while(pointer >= firstDisplayIndex){
            validMoves.push(pointer);
            pointer--;
        }
        validMoves.sort(numberComparator).reverse();
    }
    return validMoves;
}
function $437b23f6a393c3bf$var$normaliseX(params) {
    const { pinned: pinned, fromKeyboard: fromKeyboard, gos: gos, ctrlsSvc: ctrlsSvc, useHeaderRow: useHeaderRow, skipScrollPadding: skipScrollPadding } = params;
    let eViewport = ctrlsSvc.getHeaderRowContainerCtrl(pinned)?.eViewport;
    let { x: x } = params;
    if (!eViewport) return 0;
    if (fromKeyboard) x -= eViewport.getBoundingClientRect().left;
    if (gos.get("enableRtl")) {
        if (useHeaderRow) eViewport = eViewport.querySelector(".ag-header-row");
        x = eViewport.clientWidth - x;
    }
    if (pinned == null && !skipScrollPadding) x += ctrlsSvc.get("center").getCenterViewportScrollLeft();
    return x;
}
function $437b23f6a393c3bf$var$setColumnsMoving(columns, isMoving) {
    for (const column of columns){
        column.moving = isMoving;
        column.dispatchColEvent("movingChanged", "uiColumnMoved");
    }
}
// packages/ag-grid-community/src/columnMove/columnDrag/moveColumnFeature.ts
var $437b23f6a393c3bf$var$MOVE_FAIL_THRESHOLD = 7;
var $437b23f6a393c3bf$var$SCROLL_MOVE_WIDTH = 100;
var $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE = $437b23f6a393c3bf$var$SCROLL_MOVE_WIDTH / 2;
var $437b23f6a393c3bf$var$SCROLL_ACCELERATION_RATE = 5;
var $437b23f6a393c3bf$var$SCROLL_TIME_INTERVAL = 100;
var $437b23f6a393c3bf$var$MoveColumnFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned){
        super();
        this.pinned = pinned;
        this.needToMoveLeft = false;
        this.needToMoveRight = false;
        this.lastMovedInfo = null;
        this.isCenterContainer = !$437b23f6a393c3bf$export$25d27f17d3af40f7(pinned);
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
    }
    getIconName() {
        const { pinned: pinned, lastDraggingEvent: lastDraggingEvent } = this;
        const { dragItem: dragItem } = lastDraggingEvent || {};
        const columns = dragItem?.columns ?? [];
        for (const col of columns){
            const colPinned = col.getPinned();
            if (col.getColDef().lockPinned) {
                if (colPinned == pinned) return "move";
                continue;
            }
            const initialPinnedState = dragItem?.containerType;
            if (initialPinnedState === pinned || !pinned) return "move";
            if (pinned && (!colPinned || initialPinnedState !== pinned)) return "pinned";
        }
        return "notAllowed";
    }
    onDragEnter(draggingEvent) {
        const dragItem = draggingEvent.dragItem;
        const columns = dragItem.columns;
        const dragCameFromToolPanel = draggingEvent.dragSource.type === 0 /* ToolPanel */ ;
        if (dragCameFromToolPanel) this.setColumnsVisible(columns, true, "uiColumnDragged");
        else {
            const visibleState = dragItem.visibleState;
            const visibleColumns = (columns || []).filter((column)=>visibleState[column.getId()] && !column.isVisible());
            this.setColumnsVisible(visibleColumns, true, "uiColumnDragged");
        }
        if (!this.gos.get("suppressMoveWhenColumnDragging")) this.attemptToPinColumns(columns, this.pinned);
        this.onDragging(draggingEvent, true, true);
    }
    onDragging(draggingEvent = this.lastDraggingEvent, fromEnter = false, fakeEvent = false, finished = false) {
        const { gos: gos, ctrlsSvc: ctrlsSvc } = this.beans;
        const isSuppressMoveWhenDragging = gos.get("suppressMoveWhenColumnDragging");
        if (finished && !isSuppressMoveWhenDragging) {
            this.finishColumnMoving();
            return;
        }
        this.lastDraggingEvent = draggingEvent;
        if (!draggingEvent || !finished && $437b23f6a393c3bf$export$672d9e47bc342bac(draggingEvent.hDirection)) return;
        const mouseX = $437b23f6a393c3bf$var$normaliseX({
            x: draggingEvent.x,
            pinned: this.pinned,
            gos: gos,
            ctrlsSvc: ctrlsSvc
        });
        if (!fromEnter) this.checkCenterForScrolling(mouseX);
        if (isSuppressMoveWhenDragging) this.handleColumnDragWhileSuppressingMovement(draggingEvent, fromEnter, fakeEvent, mouseX, finished);
        else this.handleColumnDragWhileAllowingMovement(draggingEvent, fromEnter, fakeEvent, mouseX, finished);
    }
    onDragLeave() {
        this.ensureIntervalCleared();
        this.clearHighlighted();
        this.updateDragItemContainerType();
        this.lastMovedInfo = null;
    }
    onDragStop() {
        this.onDragging(this.lastDraggingEvent, false, true, true);
        this.ensureIntervalCleared();
        this.lastMovedInfo = null;
    }
    onDragCancel() {
        this.clearHighlighted();
        this.ensureIntervalCleared();
        this.lastMovedInfo = null;
    }
    setColumnsVisible(columns, visible, source) {
        if (!columns?.length) return;
        const allowedCols = columns.filter((c)=>!c.getColDef().lockVisible);
        if (!allowedCols.length) return;
        this.beans.colModel.setColsVisible(allowedCols, visible, source);
    }
    finishColumnMoving() {
        this.clearHighlighted();
        const lastMovedInfo = this.lastMovedInfo;
        if (!lastMovedInfo) return;
        const { columns: columns, toIndex: toIndex } = lastMovedInfo;
        this.beans.colMoves.moveColumns(columns, toIndex, "uiColumnMoved", true);
    }
    updateDragItemContainerType() {
        const { lastDraggingEvent: lastDraggingEvent } = this;
        if (this.gos.get("suppressMoveWhenColumnDragging") || !lastDraggingEvent) return;
        const dragItem = lastDraggingEvent.dragItem;
        if (!dragItem) return;
        dragItem.containerType = this.pinned;
    }
    handleColumnDragWhileSuppressingMovement(draggingEvent, fromEnter, fakeEvent, mouseX, finished) {
        const allMovingColumns = this.getAllMovingColumns(draggingEvent, true);
        if (finished) {
            const isAttemptingToPin = this.isAttemptingToPin(allMovingColumns);
            if (isAttemptingToPin) this.attemptToPinColumns(allMovingColumns, void 0, true);
            const { fromLeft: fromLeft, xPosition: xPosition } = this.getNormalisedXPositionInfo(allMovingColumns, isAttemptingToPin) || {};
            if (fromLeft == null || xPosition == null) {
                this.finishColumnMoving();
                return;
            }
            this.moveColumnsAfterHighlight({
                allMovingColumns: allMovingColumns,
                xPosition: xPosition,
                fromEnter: fromEnter,
                fakeEvent: fakeEvent,
                fromLeft: fromLeft
            });
        } else {
            if (!this.beans.dragAndDrop.isDropZoneWithinThisGrid(draggingEvent)) return;
            this.highlightHoveredColumn(allMovingColumns, mouseX);
        }
    }
    handleColumnDragWhileAllowingMovement(draggingEvent, fromEnter, fakeEvent, mouseX, finished) {
        const allMovingColumns = this.getAllMovingColumns(draggingEvent);
        const fromLeft = this.normaliseDirection(draggingEvent.hDirection) === "right";
        const isFromHeader = draggingEvent.dragSource.type === 1 /* HeaderCell */ ;
        const params = this.getMoveColumnParams({
            allMovingColumns: allMovingColumns,
            isFromHeader: isFromHeader,
            xPosition: mouseX,
            fromLeft: fromLeft,
            fromEnter: fromEnter,
            fakeEvent: fakeEvent
        });
        const lastMovedInfo = $437b23f6a393c3bf$var$attemptMoveColumns({
            ...params,
            finished: finished
        });
        if (lastMovedInfo) this.lastMovedInfo = lastMovedInfo;
    }
    getAllMovingColumns(draggingEvent, useSplit = false) {
        const dragItem = draggingEvent.dragSource.getDragItem();
        let columns = null;
        if (useSplit) {
            columns = dragItem.columnsInSplit;
            if (!columns) columns = dragItem.columns;
        } else columns = dragItem.columns;
        const conditionCallback = (col)=>col.getColDef().lockPinned ? col.getPinned() == this.pinned : true;
        if (!columns) return [];
        return columns.filter(conditionCallback);
    }
    getMoveColumnParams(params) {
        const { allMovingColumns: allMovingColumns, isFromHeader: isFromHeader, xPosition: xPosition, fromLeft: fromLeft, fromEnter: fromEnter, fakeEvent: fakeEvent } = params;
        const { gos: gos, colModel: colModel, colMoves: colMoves, visibleCols: visibleCols } = this.beans;
        return {
            allMovingColumns: allMovingColumns,
            isFromHeader: isFromHeader,
            fromLeft: fromLeft,
            xPosition: xPosition,
            pinned: this.pinned,
            fromEnter: fromEnter,
            fakeEvent: fakeEvent,
            gos: gos,
            colModel: colModel,
            colMoves: colMoves,
            visibleCols: visibleCols
        };
    }
    highlightHoveredColumn(movingColumns, mouseX) {
        const { gos: gos, colModel: colModel } = this.beans;
        const isRtl = gos.get("enableRtl");
        const consideredColumns = colModel.getCols().filter((col)=>col.isVisible() && col.getPinned() === this.pinned);
        let start = null;
        let width = null;
        let targetColumn = null;
        for (const col of consideredColumns){
            width = col.getActualWidth();
            start = this.getNormalisedColumnLeft(col, 0, isRtl);
            if (start != null) {
                const end = start + width;
                if (start <= mouseX && end >= mouseX) {
                    targetColumn = col;
                    break;
                }
            }
            start = null;
            width = null;
        }
        if (!targetColumn) {
            for(let i = consideredColumns.length - 1; i >= 0; i--){
                const currentColumn = consideredColumns[i];
                const parent = consideredColumns[i].getParent();
                if (!parent) {
                    targetColumn = currentColumn;
                    break;
                }
                const leafDisplayedCols = parent?.getDisplayedLeafColumns();
                if (leafDisplayedCols.length) {
                    targetColumn = $437b23f6a393c3bf$export$236389741107357f(leafDisplayedCols);
                    break;
                }
            }
            if (!targetColumn) return;
            start = this.getNormalisedColumnLeft(targetColumn, 0, isRtl);
            width = targetColumn.getActualWidth();
        } else if (movingColumns.indexOf(targetColumn) !== -1) targetColumn = null;
        if (this.lastHighlightedColumn?.column !== targetColumn) this.clearHighlighted();
        if (targetColumn == null || start == null || width == null) return;
        let position;
        if (mouseX - start < width / 2 !== isRtl) position = 0 /* Before */ ;
        else position = 1 /* After */ ;
        $437b23f6a393c3bf$var$setColumnHighlighted(targetColumn, position);
        this.lastHighlightedColumn = {
            column: targetColumn,
            position: position
        };
    }
    getNormalisedXPositionInfo(allMovingColumns, isAttemptingToPin) {
        const { gos: gos, visibleCols: visibleCols } = this.beans;
        const isRtl = gos.get("enableRtl");
        const { firstMovingCol: firstMovingCol, column: column, position: position } = this.getColumnMoveAndTargetInfo(allMovingColumns, isAttemptingToPin, isRtl);
        if (!firstMovingCol || !column || position == null) return;
        const visibleColumns = visibleCols.allCols;
        const movingColIndex = visibleColumns.indexOf(firstMovingCol);
        const targetIndex = visibleColumns.indexOf(column);
        const isBefore = position === 0 /* Before */  !== isRtl;
        const fromLeft = movingColIndex < targetIndex || movingColIndex === targetIndex && !isBefore;
        let diff = 0;
        if (isBefore) {
            if (fromLeft) diff -= 1;
        } else if (!fromLeft) diff += 1;
        if (targetIndex + diff === movingColIndex) return;
        const targetColumn = visibleColumns[targetIndex + diff];
        if (!targetColumn) return;
        const xPosition = this.getNormalisedColumnLeft(targetColumn, 20, isRtl);
        return {
            fromLeft: fromLeft,
            xPosition: xPosition
        };
    }
    getColumnMoveAndTargetInfo(allMovingColumns, isAttemptingToPin, isRtl) {
        const lastHighlightedColumn = this.lastHighlightedColumn || {};
        const { firstMovingCol: firstMovingCol, lastMovingCol: lastMovingCol } = $437b23f6a393c3bf$var$findFirstAndLastMovingColumns(allMovingColumns);
        if (!firstMovingCol || !lastMovingCol || lastHighlightedColumn.column || !isAttemptingToPin) return {
            firstMovingCol: firstMovingCol,
            ...lastHighlightedColumn
        };
        const pinned = this.getPinDirection();
        const isLeft = pinned === "left";
        return {
            firstMovingCol: firstMovingCol,
            position: isLeft ? 1 /* After */  : 0 /* Before */ ,
            column: isLeft !== isRtl ? firstMovingCol : lastMovingCol
        };
    }
    normaliseDirection(hDirection) {
        if (this.gos.get("enableRtl")) switch(hDirection){
            case "left":
                return "right";
            case "right":
                return "left";
        }
        return hDirection;
    }
    getNormalisedColumnLeft(col, padding, isRtl) {
        const { gos: gos, ctrlsSvc: ctrlsSvc } = this.beans;
        const left = col.getLeft();
        if (left == null) return null;
        const width = col.getActualWidth();
        return $437b23f6a393c3bf$var$normaliseX({
            x: isRtl ? left + width - padding : left + padding,
            pinned: col.getPinned(),
            useHeaderRow: isRtl,
            skipScrollPadding: true,
            gos: gos,
            ctrlsSvc: ctrlsSvc
        });
    }
    isAttemptingToPin(columns) {
        const isMovingHorizontally = this.needToMoveLeft || this.needToMoveRight;
        const isFailedMoreThanThreshold = this.failedMoveAttempts > $437b23f6a393c3bf$var$MOVE_FAIL_THRESHOLD;
        return isMovingHorizontally && isFailedMoreThanThreshold || columns.some((col)=>col.getPinned() !== this.pinned);
    }
    moveColumnsAfterHighlight(params) {
        const { allMovingColumns: allMovingColumns, xPosition: xPosition, fromEnter: fromEnter, fakeEvent: fakeEvent, fromLeft: fromLeft } = params;
        const columnMoveParams = this.getMoveColumnParams({
            allMovingColumns: allMovingColumns,
            isFromHeader: true,
            xPosition: xPosition,
            fromLeft: fromLeft,
            fromEnter: fromEnter,
            fakeEvent: fakeEvent
        });
        const { columns: columns, toIndex: toIndex } = $437b23f6a393c3bf$var$getBestColumnMoveIndexFromXPosition(columnMoveParams) || {};
        if (columns && toIndex != null) this.lastMovedInfo = {
            columns: columns,
            toIndex: toIndex
        };
        this.finishColumnMoving();
    }
    clearHighlighted() {
        const { lastHighlightedColumn: lastHighlightedColumn } = this;
        if (!lastHighlightedColumn) return;
        $437b23f6a393c3bf$var$setColumnHighlighted(lastHighlightedColumn.column, null);
        this.lastHighlightedColumn = null;
    }
    checkCenterForScrolling(xAdjustedForScroll) {
        if (!this.isCenterContainer) return;
        const centerCtrl = this.beans.ctrlsSvc.get("center");
        const firstVisiblePixel = centerCtrl.getCenterViewportScrollLeft();
        const lastVisiblePixel = firstVisiblePixel + centerCtrl.getCenterWidth();
        let needToMoveRight;
        let needToMoveLeft;
        if (this.gos.get("enableRtl")) {
            needToMoveRight = xAdjustedForScroll < firstVisiblePixel + $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE;
            needToMoveLeft = xAdjustedForScroll > lastVisiblePixel - $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE;
        } else {
            needToMoveLeft = xAdjustedForScroll < firstVisiblePixel + $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE;
            needToMoveRight = xAdjustedForScroll > lastVisiblePixel - $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE;
        }
        this.needToMoveRight = needToMoveRight;
        this.needToMoveLeft = needToMoveLeft;
        if (needToMoveLeft || needToMoveRight) this.ensureIntervalStarted();
        else this.ensureIntervalCleared();
    }
    ensureIntervalStarted() {
        if (this.movingIntervalId) return;
        this.intervalCount = 0;
        this.failedMoveAttempts = 0;
        this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), $437b23f6a393c3bf$var$SCROLL_TIME_INTERVAL);
        this.beans.dragAndDrop.getDragAndDropImageComponent()?.setIcon(this.needToMoveLeft ? "left" : "right", true);
    }
    ensureIntervalCleared() {
        if (!this.movingIntervalId) return;
        window.clearInterval(this.movingIntervalId);
        this.movingIntervalId = null;
        this.failedMoveAttempts = 0;
        this.beans.dragAndDrop.getDragAndDropImageComponent()?.setIcon(this.getIconName(), false);
    }
    moveInterval() {
        let pixelsToMove;
        this.intervalCount++;
        pixelsToMove = 10 + this.intervalCount * $437b23f6a393c3bf$var$SCROLL_ACCELERATION_RATE;
        if (pixelsToMove > $437b23f6a393c3bf$var$SCROLL_MOVE_WIDTH) pixelsToMove = $437b23f6a393c3bf$var$SCROLL_MOVE_WIDTH;
        let pixelsMoved = null;
        const scrollFeature = this.gridBodyCon.scrollFeature;
        if (this.needToMoveLeft) pixelsMoved = scrollFeature.scrollHorizontally(-pixelsToMove);
        else if (this.needToMoveRight) pixelsMoved = scrollFeature.scrollHorizontally(pixelsToMove);
        if (pixelsMoved !== 0) {
            this.onDragging(this.lastDraggingEvent);
            this.failedMoveAttempts = 0;
        } else {
            this.failedMoveAttempts++;
            const { pinnedCols: pinnedCols, dragAndDrop: dragAndDrop, gos: gos } = this.beans;
            if (this.failedMoveAttempts <= $437b23f6a393c3bf$var$MOVE_FAIL_THRESHOLD + 1 || !pinnedCols) return;
            dragAndDrop.getDragAndDropImageComponent()?.setIcon("pinned", false);
            if (!gos.get("suppressMoveWhenColumnDragging")) {
                const columns = this.lastDraggingEvent?.dragItem.columns;
                this.attemptToPinColumns(columns, void 0, true);
            }
        }
    }
    getPinDirection() {
        if (this.needToMoveLeft || this.pinned === "left") return "left";
        if (this.needToMoveRight || this.pinned === "right") return "right";
    }
    attemptToPinColumns(columns, pinned, fromMoving = false) {
        const allowedCols = (columns || []).filter((c)=>!c.getColDef().lockPinned);
        if (!allowedCols.length) return 0;
        if (fromMoving) pinned = this.getPinDirection();
        const { pinnedCols: pinnedCols, dragAndDrop: dragAndDrop } = this.beans;
        pinnedCols?.setColsPinned(allowedCols, pinned, "uiColumnDragged");
        if (fromMoving) dragAndDrop.nudge();
        return allowedCols.length;
    }
    destroy() {
        super.destroy();
        this.lastDraggingEvent = null;
        this.clearHighlighted();
        this.lastMovedInfo = null;
    }
};
function $437b23f6a393c3bf$var$setColumnHighlighted(column, highlighted) {
    if (column.highlighted === highlighted) return;
    column.highlighted = highlighted;
    column.dispatchColEvent("headerHighlightChanged", "uiColumnMoved");
}
function $437b23f6a393c3bf$var$findFirstAndLastMovingColumns(allMovingColumns) {
    const moveLen = allMovingColumns.length;
    let firstMovingCol;
    let lastMovingCol;
    for(let i = 0; i < moveLen; i++){
        if (!firstMovingCol) {
            const leftCol = allMovingColumns[i];
            if (leftCol.getLeft() != null) firstMovingCol = leftCol;
        }
        if (!lastMovingCol) {
            const rightCol = allMovingColumns[moveLen - 1 - i];
            if (rightCol.getLeft() != null) lastMovingCol = rightCol;
        }
        if (firstMovingCol && lastMovingCol) break;
    }
    return {
        firstMovingCol: firstMovingCol,
        lastMovingCol: lastMovingCol
    };
}
// packages/ag-grid-community/src/columnMove/columnDrag/bodyDropTarget.ts
var $437b23f6a393c3bf$var$BodyDropTarget = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned, eContainer){
        super();
        this.pinned = pinned;
        this.eContainer = eContainer;
    }
    postConstruct() {
        const { ctrlsSvc: ctrlsSvc, dragAndDrop: dragAndDrop } = this.beans;
        const pinned = this.pinned;
        ctrlsSvc.whenReady(this, (p)=>{
            let eSecondaryContainers;
            const eBodyViewport = p.gridBodyCtrl.eBodyViewport;
            switch(pinned){
                case "left":
                    eSecondaryContainers = [
                        [
                            eBodyViewport,
                            p.left.eContainer
                        ],
                        [
                            p.bottomLeft.eContainer
                        ],
                        [
                            p.topLeft.eContainer
                        ]
                    ];
                    break;
                case "right":
                    eSecondaryContainers = [
                        [
                            eBodyViewport,
                            p.right.eContainer
                        ],
                        [
                            p.bottomRight.eContainer
                        ],
                        [
                            p.topRight.eContainer
                        ]
                    ];
                    break;
                default:
                    eSecondaryContainers = [
                        [
                            eBodyViewport,
                            p.center.eViewport
                        ],
                        [
                            p.bottomCenter.eViewport
                        ],
                        [
                            p.topCenter.eViewport
                        ]
                    ];
                    break;
            }
            this.eSecondaryContainers = eSecondaryContainers;
        });
        this.moveColumnFeature = this.createManagedBean(new $437b23f6a393c3bf$var$MoveColumnFeature(pinned));
        this.bodyDropPivotTarget = this.createManagedBean(new $437b23f6a393c3bf$var$BodyDropPivotTarget(pinned));
        dragAndDrop.addDropTarget(this);
        this.addDestroyFunc(()=>dragAndDrop.removeDropTarget(this));
    }
    isInterestedIn(type) {
        return type === 1 /* HeaderCell */  || type === 0 /* ToolPanel */  && this.gos.get("allowDragFromColumnsToolPanel");
    }
    getSecondaryContainers() {
        return this.eSecondaryContainers;
    }
    getContainer() {
        return this.eContainer;
    }
    getIconName() {
        return this.currentDropListener.getIconName();
    }
    // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
    // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
    // dropped into the grid's body.
    isDropColumnInPivotMode(draggingEvent) {
        return this.beans.colModel.isPivotMode() && draggingEvent.dragSource.type === 0 /* ToolPanel */ ;
    }
    onDragEnter(draggingEvent) {
        this.currentDropListener = this.isDropColumnInPivotMode(draggingEvent) ? this.bodyDropPivotTarget : this.moveColumnFeature;
        this.currentDropListener.onDragEnter(draggingEvent);
    }
    onDragLeave(params) {
        this.currentDropListener.onDragLeave(params);
    }
    onDragging(params) {
        this.currentDropListener.onDragging(params);
    }
    onDragStop(params) {
        this.currentDropListener.onDragStop(params);
    }
    onDragCancel() {
        this.currentDropListener.onDragCancel();
    }
};
// packages/ag-grid-community/src/columnMove/columnMoveService.ts
var $437b23f6a393c3bf$var$ColumnMoveService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colMoves";
    }
    moveColumnByIndex(fromIndex, toIndex, source) {
        const gridColumns = this.beans.colModel.getCols();
        if (!gridColumns) return;
        const column = gridColumns[fromIndex];
        this.moveColumns([
            column
        ], toIndex, source);
    }
    moveColumns(columnsToMoveKeys, toIndex, source, finished = true) {
        const { colModel: colModel, colAnimation: colAnimation, visibleCols: visibleCols, eventSvc: eventSvc } = this.beans;
        const gridColumns = colModel.getCols();
        if (!gridColumns) return;
        if (toIndex > gridColumns.length - columnsToMoveKeys.length) {
            $437b23f6a393c3bf$export$545083624300f13d(30, {
                toIndex: toIndex
            });
            return;
        }
        colAnimation?.start();
        const movedColumns = colModel.getColsForKeys(columnsToMoveKeys);
        if (this.doesMovePassRules(movedColumns, toIndex)) {
            $437b23f6a393c3bf$var$_moveInArray(colModel.getCols(), movedColumns, toIndex);
            visibleCols.refresh(source);
            eventSvc.dispatchEvent({
                type: "columnMoved",
                columns: movedColumns,
                column: movedColumns.length === 1 ? movedColumns[0] : null,
                toIndex: toIndex,
                finished: finished,
                source: source
            });
        }
        colAnimation?.finish();
    }
    doesMovePassRules(columnsToMove, toIndex) {
        const proposedColumnOrder = this.getProposedColumnOrder(columnsToMove, toIndex);
        return this.doesOrderPassRules(proposedColumnOrder);
    }
    doesOrderPassRules(gridOrder) {
        const { colModel: colModel, gos: gos } = this.beans;
        if (!$437b23f6a393c3bf$var$doesMovePassMarryChildren(gridOrder, colModel.getColTree())) return false;
        const doesMovePassLockedPositions = (proposedColumnOrder)=>{
            const lockPositionToPlacement = (position)=>{
                if (!position) return 0 /* NONE */ ;
                return position === "left" || position === true ? -1 /* LEFT */  : 1 /* RIGHT */ ;
            };
            const isRtl = gos.get("enableRtl");
            let lastPlacement = isRtl ? 1 /* RIGHT */  : -1 /* LEFT */ ;
            let rulePassed = true;
            proposedColumnOrder.forEach((col)=>{
                const placement = lockPositionToPlacement(col.getColDef().lockPosition);
                if (isRtl) {
                    if (placement > lastPlacement) rulePassed = false;
                } else if (placement < lastPlacement) rulePassed = false;
                lastPlacement = placement;
            });
            return rulePassed;
        };
        if (!doesMovePassLockedPositions(gridOrder)) return false;
        return true;
    }
    getProposedColumnOrder(columnsToMove, toIndex) {
        const gridColumns = this.beans.colModel.getCols();
        const proposedColumnOrder = gridColumns.slice();
        $437b23f6a393c3bf$var$_moveInArray(proposedColumnOrder, columnsToMove, toIndex);
        return proposedColumnOrder;
    }
    createBodyDropTarget(pinned, dropContainer) {
        return new $437b23f6a393c3bf$var$BodyDropTarget(pinned, dropContainer);
    }
    moveHeader(hDirection, eGui, column, pinned, bean) {
        const { ctrlsSvc: ctrlsSvc, gos: gos, colModel: colModel, visibleCols: visibleCols, focusSvc: focusSvc } = this.beans;
        const rect = eGui.getBoundingClientRect();
        const left = rect.left;
        const isGroup = $437b23f6a393c3bf$export$1f44a60fc23f9028(column);
        const width = isGroup ? rect.width : column.getActualWidth();
        const isLeft = hDirection === "left" !== gos.get("enableRtl");
        const xPosition = $437b23f6a393c3bf$var$normaliseX({
            x: isLeft ? left - 20 : left + width + 20,
            pinned: pinned,
            fromKeyboard: true,
            gos: gos,
            ctrlsSvc: ctrlsSvc
        });
        const headerPosition = focusSvc.focusedHeader;
        $437b23f6a393c3bf$var$attemptMoveColumns({
            allMovingColumns: isGroup ? column.getLeafColumns() : [
                column
            ],
            isFromHeader: true,
            fromLeft: hDirection === "right",
            xPosition: xPosition,
            pinned: pinned,
            fromEnter: false,
            fakeEvent: false,
            gos: gos,
            colModel: colModel,
            colMoves: this,
            visibleCols: visibleCols,
            finished: true
        });
        let targetColumn;
        if (isGroup) {
            const displayedLeafColumns = column.getDisplayedLeafColumns();
            targetColumn = isLeft ? displayedLeafColumns[0] : $437b23f6a393c3bf$export$236389741107357f(displayedLeafColumns);
        } else targetColumn = column;
        ctrlsSvc.getScrollFeature().ensureColumnVisible(targetColumn, "auto");
        if ((!bean.isAlive() || gos.get("ensureDomOrder")) && headerPosition) {
            let restoreFocusColumn;
            if (isGroup) {
                const groupId = column.getGroupId();
                const leafCols = column.getLeafColumns();
                if (!leafCols.length) return;
                const parent = leafCols[0].getParent();
                if (!parent) return;
                restoreFocusColumn = $437b23f6a393c3bf$var$findGroupWidthId(parent, groupId);
            } else restoreFocusColumn = column;
            if (restoreFocusColumn) focusSvc.focusHeaderPosition({
                headerPosition: {
                    ...headerPosition,
                    column: restoreFocusColumn
                }
            });
        }
    }
    setDragSourceForHeader(eSource, column, displayName) {
        const { gos: gos, colModel: colModel, dragAndDrop: dragAndDrop, visibleCols: visibleCols } = this.beans;
        let hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
        const isGroup = $437b23f6a393c3bf$export$1f44a60fc23f9028(column);
        const columns = isGroup ? column.getProvidedColumnGroup().getLeafColumns() : [
            column
        ];
        const getDragItem = isGroup ? ()=>$437b23f6a393c3bf$var$createDragItemForGroup(column, visibleCols.allCols) : ()=>$437b23f6a393c3bf$var$createDragItem(column);
        const dragSource = {
            type: 1 /* HeaderCell */ ,
            eElement: eSource,
            getDefaultIconName: ()=>hideColumnOnExit ? "hide" : "notAllowed",
            getDragItem: getDragItem,
            dragItemName: displayName,
            onDragStarted: ()=>{
                hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
                $437b23f6a393c3bf$var$setColumnsMoving(columns, true);
            },
            onDragStopped: ()=>$437b23f6a393c3bf$var$setColumnsMoving(columns, false),
            onDragCancelled: ()=>$437b23f6a393c3bf$var$setColumnsMoving(columns, false),
            onGridEnter: (dragItem)=>{
                if (hideColumnOnExit) {
                    const { columns: columns2 = [], visibleState: visibleState } = dragItem ?? {};
                    const hasVisibleState = isGroup ? (col)=>!visibleState || visibleState[col.getColId()] : ()=>true;
                    const unlockedColumns = columns2.filter((col)=>!col.getColDef().lockVisible && hasVisibleState(col));
                    colModel.setColsVisible(unlockedColumns, true, "uiColumnMoved");
                }
            },
            onGridExit: (dragItem)=>{
                if (hideColumnOnExit) {
                    const unlockedColumns = dragItem?.columns?.filter((col)=>!col.getColDef().lockVisible) || [];
                    colModel.setColsVisible(unlockedColumns, false, "uiColumnMoved");
                }
            }
        };
        dragAndDrop.addDragSource(dragSource, true);
        return dragSource;
    }
};
function $437b23f6a393c3bf$var$findGroupWidthId(columnGroup, id) {
    while(columnGroup){
        if (columnGroup.getGroupId() === id) return columnGroup;
        columnGroup = columnGroup.getParent();
    }
    return void 0;
}
function $437b23f6a393c3bf$var$createDragItem(column) {
    const visibleState = {};
    visibleState[column.getId()] = column.isVisible();
    return {
        columns: [
            column
        ],
        visibleState: visibleState,
        containerType: column.pinned
    };
}
function $437b23f6a393c3bf$var$createDragItemForGroup(columnGroup, allCols) {
    const allColumnsOriginalOrder = columnGroup.getProvidedColumnGroup().getLeafColumns();
    const visibleState = {};
    allColumnsOriginalOrder.forEach((column)=>visibleState[column.getId()] = column.isVisible());
    const allColumnsCurrentOrder = [];
    allCols.forEach((column)=>{
        if (allColumnsOriginalOrder.indexOf(column) >= 0) {
            allColumnsCurrentOrder.push(column);
            $437b23f6a393c3bf$export$83a881c8b5120679(allColumnsOriginalOrder, column);
        }
    });
    allColumnsOriginalOrder.forEach((column)=>allColumnsCurrentOrder.push(column));
    const columnsInSplit = [];
    const columnGroupColumns = columnGroup.getLeafColumns();
    for (const col of allColumnsCurrentOrder)if (columnGroupColumns.indexOf(col) !== -1) columnsInSplit.push(col);
    return {
        columns: allColumnsCurrentOrder,
        columnsInSplit: columnsInSplit,
        visibleState: visibleState,
        containerType: columnsInSplit[0]?.pinned
    };
}
// packages/ag-grid-community/src/columnMove/columnMoveModule.ts
var $437b23f6a393c3bf$export$1458fbffed29c925 = {
    moduleName: "ColumnMove",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnMoveService,
        $437b23f6a393c3bf$var$ColumnAnimationService
    ],
    apiFunctions: {
        moveColumnByIndex: $437b23f6a393c3bf$var$moveColumnByIndex,
        moveColumns: $437b23f6a393c3bf$var$moveColumns
    },
    dependsOn: [
        $437b23f6a393c3bf$export$4ad116d131ade5b4
    ],
    css: [
        $437b23f6a393c3bf$var$columnMovingCSS
    ]
};
// packages/ag-grid-community/src/rendering/autoWidthCalculator.ts
var $437b23f6a393c3bf$var$AutoWidthCalculator = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "autoWidthCalc";
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.centerRowContainerCtrl = p.center;
        });
    }
    // this is the trick: we create a dummy container and clone all the cells
    // into the dummy, then check the dummy's width. then destroy the dummy
    // as we don't need it any more.
    // drawback: only the cells visible on the screen are considered
    getPreferredWidthForColumn(column, skipHeader) {
        const eHeaderCell = this.getHeaderCellForColumn(column);
        if (!eHeaderCell) return -1;
        const elements = this.beans.rowRenderer.getAllCellsNotSpanningForColumn(column);
        if (!skipHeader) elements.push(eHeaderCell);
        return this.getPreferredWidthForElements(elements);
    }
    getPreferredWidthForColumnGroup(columnGroup) {
        const eHeaderCell = this.getHeaderCellForColumn(columnGroup);
        if (!eHeaderCell) return -1;
        return this.getPreferredWidthForElements([
            eHeaderCell
        ]);
    }
    getPreferredWidthForElements(elements, extraPadding) {
        const eDummyContainer = document.createElement("form");
        eDummyContainer.style.position = "fixed";
        const eBodyContainer = this.centerRowContainerCtrl.eContainer;
        elements.forEach((el)=>this.cloneItemIntoDummy(el, eDummyContainer));
        eBodyContainer.appendChild(eDummyContainer);
        const dummyContainerWidth = eDummyContainer.offsetWidth;
        eBodyContainer.removeChild(eDummyContainer);
        extraPadding = extraPadding ?? this.gos.get("autoSizePadding");
        return dummyContainerWidth + extraPadding;
    }
    getHeaderCellForColumn(column) {
        let element = null;
        this.beans.ctrlsSvc.getHeaderRowContainerCtrls().forEach((container)=>{
            const res = container.getHtmlElementForColumnHeader(column);
            if (res != null) element = res;
        });
        return element;
    }
    cloneItemIntoDummy(eCell, eDummyContainer) {
        const eCellClone = eCell.cloneNode(true);
        eCellClone.style.width = "";
        eCellClone.style.position = "static";
        eCellClone.style.left = "";
        const eCloneParent = document.createElement("div");
        const eCloneParentClassList = eCloneParent.classList;
        const isHeader = [
            "ag-header-cell",
            "ag-header-group-cell"
        ].some((cls)=>eCellClone.classList.contains(cls));
        if (isHeader) {
            eCloneParentClassList.add("ag-header", "ag-header-row");
            eCloneParent.style.position = "static";
        } else eCloneParentClassList.add("ag-row");
        let pointer = eCell.parentElement;
        while(pointer){
            const isRow = [
                "ag-header-row",
                "ag-row"
            ].some((cls)=>pointer.classList.contains(cls));
            if (isRow) {
                for(let i = 0; i < pointer.classList.length; i++){
                    const item = pointer.classList[i];
                    if (item != "ag-row-position-absolute") eCloneParentClassList.add(item);
                }
                break;
            }
            pointer = pointer.parentElement;
        }
        eCloneParent.appendChild(eCellClone);
        eDummyContainer.appendChild(eCloneParent);
    }
};
// packages/ag-grid-community/src/rendering/autoWidthModule.ts
var $437b23f6a393c3bf$var$AutoWidthModule = {
    moduleName: "AutoWidth",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AutoWidthCalculator
    ]
};
// packages/ag-grid-community/src/columnResize/columnResizeApi.ts
function $437b23f6a393c3bf$var$setColumnWidths(beans, columnWidths, finished = true, source = "api") {
    beans.colResize?.setColumnWidths(columnWidths, false, finished, source);
}
// packages/ag-grid-community/src/columnResize/groupResizeFeature.ts
var $437b23f6a393c3bf$var$GroupResizeFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(comp, eResize, pinned, columnGroup){
        super();
        this.comp = comp;
        this.eResize = eResize;
        this.pinned = pinned;
        this.columnGroup = columnGroup;
    }
    postConstruct() {
        if (!this.columnGroup.isResizable()) {
            this.comp.setResizableDisplayed(false);
            return;
        }
        const { horizontalResizeSvc: horizontalResizeSvc, gos: gos, colAutosize: colAutosize } = this.beans;
        const finishedWithResizeFunc = horizontalResizeSvc.addResizeBar({
            eResizeBar: this.eResize,
            onResizeStart: this.onResizeStart.bind(this),
            onResizing: this.onResizing.bind(this, false),
            onResizeEnd: this.onResizing.bind(this, true)
        });
        this.addDestroyFunc(finishedWithResizeFunc);
        if (!gos.get("suppressAutoSize") && colAutosize) this.addDestroyFunc(colAutosize.addColumnGroupResize(this.eResize, this.columnGroup, ()=>this.resizeLeafColumnsToFit("uiColumnResized")));
    }
    onResizeStart(shiftKey) {
        const { columnsToResize: columnsToResize, resizeStartWidth: resizeStartWidth, resizeRatios: resizeRatios, groupAfterColumns: groupAfterColumns, groupAfterStartWidth: groupAfterStartWidth, groupAfterRatios: groupAfterRatios } = this.getInitialValues(shiftKey);
        this.resizeCols = columnsToResize;
        this.resizeStartWidth = resizeStartWidth;
        this.resizeRatios = resizeRatios;
        this.resizeTakeFromCols = groupAfterColumns;
        this.resizeTakeFromStartWidth = groupAfterStartWidth;
        this.resizeTakeFromRatios = groupAfterRatios;
        this.toggleColumnResizing(true);
    }
    onResizing(finished, resizeAmount, source = "uiColumnResized") {
        const resizeAmountNormalised = this.normaliseDragChange(resizeAmount);
        const width = this.resizeStartWidth + resizeAmountNormalised;
        this.resizeColumnsFromLocalValues(width, source, finished);
    }
    getInitialValues(shiftKey) {
        const getInitialSizeOfColumns = (columns)=>columns.reduce((totalWidth, column)=>totalWidth + column.getActualWidth(), 0);
        const getSizeRatiosOfColumns = (columns, initialSizeOfColumns)=>columns.map((column)=>column.getActualWidth() / initialSizeOfColumns);
        const columnsToResize = this.getColumnsToResize();
        const resizeStartWidth = getInitialSizeOfColumns(columnsToResize);
        const resizeRatios = getSizeRatiosOfColumns(columnsToResize, resizeStartWidth);
        const columnSizeAndRatios = {
            columnsToResize: columnsToResize,
            resizeStartWidth: resizeStartWidth,
            resizeRatios: resizeRatios
        };
        let groupAfter = null;
        if (shiftKey) groupAfter = this.beans.colGroupSvc?.getGroupAtDirection(this.columnGroup, "After") ?? null;
        if (groupAfter) {
            const takeFromLeafCols = groupAfter.getDisplayedLeafColumns();
            const groupAfterColumns = columnSizeAndRatios.groupAfterColumns = takeFromLeafCols.filter((col)=>col.isResizable());
            const groupAfterStartWidth = columnSizeAndRatios.groupAfterStartWidth = getInitialSizeOfColumns(groupAfterColumns);
            columnSizeAndRatios.groupAfterRatios = getSizeRatiosOfColumns(groupAfterColumns, groupAfterStartWidth);
        } else {
            columnSizeAndRatios.groupAfterColumns = void 0;
            columnSizeAndRatios.groupAfterStartWidth = void 0;
            columnSizeAndRatios.groupAfterRatios = void 0;
        }
        return columnSizeAndRatios;
    }
    resizeLeafColumnsToFit(source) {
        const preferredSize = this.beans.autoWidthCalc.getPreferredWidthForColumnGroup(this.columnGroup);
        const initialValues = this.getInitialValues();
        if (preferredSize > initialValues.resizeStartWidth) this.resizeColumns(initialValues, preferredSize, source, true);
    }
    resizeColumnsFromLocalValues(totalWidth, source, finished = true) {
        if (!this.resizeCols || !this.resizeRatios) return;
        const initialValues = {
            columnsToResize: this.resizeCols,
            resizeStartWidth: this.resizeStartWidth,
            resizeRatios: this.resizeRatios,
            groupAfterColumns: this.resizeTakeFromCols,
            groupAfterStartWidth: this.resizeTakeFromStartWidth,
            groupAfterRatios: this.resizeTakeFromRatios
        };
        this.resizeColumns(initialValues, totalWidth, source, finished);
    }
    resizeColumns(initialValues, totalWidth, source, finished = true) {
        const { columnsToResize: columnsToResize, resizeStartWidth: resizeStartWidth, resizeRatios: resizeRatios, groupAfterColumns: groupAfterColumns, groupAfterStartWidth: groupAfterStartWidth, groupAfterRatios: groupAfterRatios } = initialValues;
        const resizeSets = [];
        resizeSets.push({
            columns: columnsToResize,
            ratios: resizeRatios,
            width: totalWidth
        });
        if (groupAfterColumns) {
            const diff = totalWidth - resizeStartWidth;
            resizeSets.push({
                columns: groupAfterColumns,
                ratios: groupAfterRatios,
                width: groupAfterStartWidth - diff
            });
        }
        this.beans.colResize?.resizeColumnSets({
            resizeSets: resizeSets,
            finished: finished,
            source: source
        });
        if (finished) this.toggleColumnResizing(false);
    }
    toggleColumnResizing(resizing) {
        this.comp.toggleCss("ag-column-resizing", resizing);
    }
    getColumnsToResize() {
        const leafCols = this.columnGroup.getDisplayedLeafColumns();
        return leafCols.filter((col)=>col.isResizable());
    }
    // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderCell - should refactor out?
    normaliseDragChange(dragChange) {
        let result = dragChange;
        if (this.gos.get("enableRtl")) {
            if (this.pinned !== "left") result *= -1;
        } else if (this.pinned === "right") result *= -1;
        return result;
    }
    destroy() {
        super.destroy();
        this.resizeCols = void 0;
        this.resizeRatios = void 0;
        this.resizeTakeFromCols = void 0;
        this.resizeTakeFromRatios = void 0;
    }
};
// packages/ag-grid-community/src/columnResize/resizeFeature.ts
var $437b23f6a393c3bf$var$ResizeFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned, column, eResize, comp, ctrl){
        super();
        this.pinned = pinned;
        this.column = column;
        this.eResize = eResize;
        this.comp = comp;
        this.ctrl = ctrl;
    }
    postConstruct() {
        const destroyResizeFuncs = [];
        let canResize;
        let canAutosize;
        const addResize = ()=>{
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eResize, canResize);
            if (!canResize) return;
            const { horizontalResizeSvc: horizontalResizeSvc, colAutosize: colAutosize } = this.beans;
            const finishedWithResizeFunc = horizontalResizeSvc.addResizeBar({
                eResizeBar: this.eResize,
                onResizeStart: this.onResizeStart.bind(this),
                onResizing: this.onResizing.bind(this, false),
                onResizeEnd: this.onResizing.bind(this, true)
            });
            destroyResizeFuncs.push(finishedWithResizeFunc);
            if (canAutosize && colAutosize) destroyResizeFuncs.push(colAutosize.addColumnAutosize(this.eResize, this.column));
        };
        const removeResize = ()=>{
            destroyResizeFuncs.forEach((f)=>f());
            destroyResizeFuncs.length = 0;
        };
        const refresh = ()=>{
            const resize = this.column.isResizable();
            const autoSize = !this.gos.get("suppressAutoSize") && !this.column.getColDef().suppressAutoSize;
            const propertyChange = resize !== canResize || autoSize !== canAutosize;
            if (propertyChange) {
                canResize = resize;
                canAutosize = autoSize;
                removeResize();
                addResize();
            }
        };
        refresh();
        this.addDestroyFunc(removeResize);
        this.ctrl.setRefreshFunction("resize", refresh);
    }
    onResizing(finished, resizeAmount) {
        const { column: key, lastResizeAmount: lastResizeAmount, resizeStartWidth: resizeStartWidth, beans: beans } = this;
        const resizeAmountNormalised = this.normaliseResizeAmount(resizeAmount);
        const newWidth = resizeStartWidth + resizeAmountNormalised;
        const columnWidths = [
            {
                key: key,
                newWidth: newWidth
            }
        ];
        const { pinnedCols: pinnedCols, ctrlsSvc: ctrlsSvc, colResize: colResize } = beans;
        if (this.column.getPinned()) {
            const leftWidth = pinnedCols?.leftWidth ?? 0;
            const rightWidth = pinnedCols?.rightWidth ?? 0;
            const bodyWidth = $437b23f6a393c3bf$export$cc615e4191ec3e0c(ctrlsSvc.getGridBodyCtrl().eBodyViewport) - 50;
            if (leftWidth + rightWidth + (resizeAmountNormalised - lastResizeAmount) > bodyWidth) return;
        }
        this.lastResizeAmount = resizeAmountNormalised;
        colResize?.setColumnWidths(columnWidths, this.resizeWithShiftKey, finished, "uiColumnResized");
        if (finished) this.toggleColumnResizing(false);
    }
    onResizeStart(shiftKey) {
        this.resizeStartWidth = this.column.getActualWidth();
        this.lastResizeAmount = 0;
        this.resizeWithShiftKey = shiftKey;
        this.toggleColumnResizing(true);
    }
    toggleColumnResizing(resizing) {
        this.column.resizing = resizing;
        this.comp.toggleCss("ag-column-resizing", resizing);
    }
    // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
    normaliseResizeAmount(dragChange) {
        let result = dragChange;
        const notPinningLeft = this.pinned !== "left";
        const pinningRight = this.pinned === "right";
        if (this.gos.get("enableRtl")) {
            if (notPinningLeft) result *= -1;
        } else if (pinningRight) result *= -1;
        return result;
    }
};
// packages/ag-grid-community/src/columnResize/columnResizeService.ts
var $437b23f6a393c3bf$var$ColumnResizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colResize";
    }
    setColumnWidths(columnWidths, shiftKey, finished, source) {
        const sets = [];
        const { colModel: colModel, gos: gos, visibleCols: visibleCols } = this.beans;
        columnWidths.forEach((columnWidth)=>{
            const col = colModel.getColDefCol(columnWidth.key) || colModel.getCol(columnWidth.key);
            if (!col) return;
            sets.push({
                width: columnWidth.newWidth,
                ratios: [
                    1
                ],
                columns: [
                    col
                ]
            });
            const defaultIsShift = gos.get("colResizeDefault") === "shift";
            if (defaultIsShift) shiftKey = !shiftKey;
            if (shiftKey) {
                const otherCol = visibleCols.getColAfter(col);
                if (!otherCol) return;
                const widthDiff = col.getActualWidth() - columnWidth.newWidth;
                const otherColWidth = otherCol.getActualWidth() + widthDiff;
                sets.push({
                    width: otherColWidth,
                    ratios: [
                        1
                    ],
                    columns: [
                        otherCol
                    ]
                });
            }
        });
        if (sets.length === 0) return;
        this.resizeColumnSets({
            resizeSets: sets,
            finished: finished,
            source: source
        });
    }
    // method takes sets of columns and resizes them. either all sets will be resized, or nothing
    // be resized. this is used for example when user tries to resize a group and holds shift key,
    // then both the current group (grows), and the adjacent group (shrinks), will get resized,
    // so that's two sets for this method.
    resizeColumnSets(params) {
        const { resizeSets: resizeSets, finished: finished, source: source } = params;
        const passMinMaxCheck = !resizeSets || resizeSets.every((columnResizeSet)=>$437b23f6a393c3bf$var$checkMinAndMaxWidthsForSet(columnResizeSet));
        if (!passMinMaxCheck) {
            if (finished) {
                const columns = resizeSets && resizeSets.length > 0 ? resizeSets[0].columns : null;
                $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, columns, finished, source);
            }
            return;
        }
        const changedCols = [];
        const allResizedCols = [];
        resizeSets.forEach((set)=>{
            const { width: width, columns: columns, ratios: ratios } = set;
            const newWidths = {};
            const finishedCols = {};
            columns.forEach((col)=>allResizedCols.push(col));
            let finishedColsGrew = true;
            let loopCount = 0;
            while(finishedColsGrew){
                loopCount++;
                if (loopCount > 1e3) {
                    $437b23f6a393c3bf$export$a20c7248650823a9(31);
                    break;
                }
                finishedColsGrew = false;
                const subsetCols = [];
                let subsetRatioTotal = 0;
                let pixelsToDistribute = width;
                columns.forEach((col, index)=>{
                    const thisColFinished = finishedCols[col.getId()];
                    if (thisColFinished) pixelsToDistribute -= newWidths[col.getId()];
                    else {
                        subsetCols.push(col);
                        const ratioThisCol = ratios[index];
                        subsetRatioTotal += ratioThisCol;
                    }
                });
                const ratioScale = 1 / subsetRatioTotal;
                subsetCols.forEach((col, index)=>{
                    const lastCol = index === subsetCols.length - 1;
                    let colNewWidth;
                    if (lastCol) colNewWidth = pixelsToDistribute;
                    else {
                        colNewWidth = Math.round(ratios[index] * width * ratioScale);
                        pixelsToDistribute -= colNewWidth;
                    }
                    const minWidth = col.getMinWidth();
                    const maxWidth = col.getMaxWidth();
                    if (colNewWidth < minWidth) {
                        colNewWidth = minWidth;
                        finishedCols[col.getId()] = true;
                        finishedColsGrew = true;
                    } else if (maxWidth > 0 && colNewWidth > maxWidth) {
                        colNewWidth = maxWidth;
                        finishedCols[col.getId()] = true;
                        finishedColsGrew = true;
                    }
                    newWidths[col.getId()] = colNewWidth;
                });
            }
            columns.forEach((col)=>{
                const newWidth = newWidths[col.getId()];
                const actualWidth = col.getActualWidth();
                if (actualWidth !== newWidth) {
                    col.setActualWidth(newWidth, source);
                    changedCols.push(col);
                }
            });
        });
        const atLeastOneColChanged = changedCols.length > 0;
        let flexedCols = [];
        if (atLeastOneColChanged) {
            const { colFlex: colFlex, visibleCols: visibleCols, colViewport: colViewport } = this.beans;
            flexedCols = colFlex?.refreshFlexedColumns({
                resizingCols: allResizedCols,
                skipSetLeft: true
            }) ?? [];
            visibleCols.setLeftValues(source);
            visibleCols.updateBodyWidths();
            colViewport.checkViewportColumns();
        }
        const colsForEvent = allResizedCols.concat(flexedCols);
        if (atLeastOneColChanged || finished) $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, colsForEvent, finished, source, flexedCols);
    }
    resizeHeader(column, delta, shiftKey) {
        if (!column.isResizable()) return;
        const actualWidth = column.getActualWidth();
        const minWidth = column.getMinWidth();
        const maxWidth = column.getMaxWidth();
        const newWidth = Math.min(Math.max(actualWidth + delta, minWidth), maxWidth);
        this.setColumnWidths([
            {
                key: column,
                newWidth: newWidth
            }
        ], shiftKey, true, "uiColumnResized");
    }
    createResizeFeature(pinned, column, eResize, comp, ctrl) {
        return new $437b23f6a393c3bf$var$ResizeFeature(pinned, column, eResize, comp, ctrl);
    }
    createGroupResizeFeature(comp, eResize, pinned, columnGroup) {
        return new $437b23f6a393c3bf$var$GroupResizeFeature(comp, eResize, pinned, columnGroup);
    }
};
function $437b23f6a393c3bf$var$checkMinAndMaxWidthsForSet(columnResizeSet) {
    const { columns: columns, width: width } = columnResizeSet;
    let minWidthAccumulated = 0;
    let maxWidthAccumulated = 0;
    let maxWidthActive = true;
    columns.forEach((col)=>{
        const minWidth = col.getMinWidth();
        minWidthAccumulated += minWidth || 0;
        const maxWidth = col.getMaxWidth();
        if (maxWidth > 0) maxWidthAccumulated += maxWidth;
        else maxWidthActive = false;
    });
    const minWidthPasses = width >= minWidthAccumulated;
    const maxWidthPasses = !maxWidthActive || width <= maxWidthAccumulated;
    return minWidthPasses && maxWidthPasses;
}
// packages/ag-grid-community/src/columnResize/columnResizeModule.ts
var $437b23f6a393c3bf$var$ColumnResizeModule = {
    moduleName: "ColumnResize",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnResizeService
    ],
    apiFunctions: {
        setColumnWidths: $437b23f6a393c3bf$var$setColumnWidths
    },
    dependsOn: [
        $437b23f6a393c3bf$export$57b5b4ab4a8a663e,
        $437b23f6a393c3bf$var$AutoWidthModule
    ]
};
// packages/ag-grid-community/src/headerRendering/cells/columnGroup/groupWidthFeature.ts
var $437b23f6a393c3bf$var$GroupWidthFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(comp, columnGroup){
        super();
        // the children can change, we keep destroy functions related to listening to the children here
        this.removeChildListenersFuncs = [];
        this.columnGroup = columnGroup;
        this.comp = comp;
    }
    postConstruct() {
        this.addListenersToChildrenColumns();
        this.addManagedListeners(this.columnGroup, {
            displayedChildrenChanged: this.onDisplayedChildrenChanged.bind(this)
        });
        this.onWidthChanged();
        this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
    }
    addListenersToChildrenColumns() {
        this.removeListenersOnChildrenColumns();
        const widthChangedListener = this.onWidthChanged.bind(this);
        this.columnGroup.getLeafColumns().forEach((column)=>{
            column.__addEventListener("widthChanged", widthChangedListener);
            column.__addEventListener("visibleChanged", widthChangedListener);
            this.removeChildListenersFuncs.push(()=>{
                column.__removeEventListener("widthChanged", widthChangedListener);
                column.__removeEventListener("visibleChanged", widthChangedListener);
            });
        });
    }
    removeListenersOnChildrenColumns() {
        this.removeChildListenersFuncs.forEach((func)=>func());
        this.removeChildListenersFuncs = [];
    }
    onDisplayedChildrenChanged() {
        this.addListenersToChildrenColumns();
        this.onWidthChanged();
    }
    onWidthChanged() {
        const columnWidth = this.columnGroup.getActualWidth();
        this.comp.setWidth(`${columnWidth}px`);
        this.comp.toggleCss("ag-hidden", columnWidth === 0);
    }
};
// packages/ag-grid-community/src/headerRendering/cells/columnGroup/headerGroupCellCtrl.ts
var $437b23f6a393c3bf$var$HeaderGroupCellCtrl = class extends $437b23f6a393c3bf$var$AbstractHeaderCellCtrl {
    constructor(){
        super(...arguments);
        this.onSuppressColMoveChange = ()=>{
            if (!this.isAlive() || this.isSuppressMoving()) this.removeDragSource();
            else if (!this.dragSource) this.setDragSource(this.eGui);
        };
    }
    setComp(comp, eGui, eResize, eHeaderCompWrapper, compBean) {
        const { column: column, beans: beans } = this;
        const { context: context, colNames: colNames, colHover: colHover, rangeSvc: rangeSvc, colResize: colResize } = beans;
        this.comp = comp;
        compBean = $437b23f6a393c3bf$var$setupCompBean(this, context, compBean);
        this.setGui(eGui, compBean);
        this.displayName = colNames.getDisplayNameForColumnGroup(column, "header");
        this.refreshHeaderStyles();
        this.addClasses();
        this.setupMovingCss(compBean);
        this.setupExpandable(compBean);
        this.setupTooltip();
        this.setupAutoHeight({
            wrapperElement: eHeaderCompWrapper,
            compBean: compBean
        });
        this.setupUserComp();
        this.addHeaderMouseListeners(compBean);
        this.addManagedPropertyListener("groupHeaderHeight", this.refreshMaxHeaderHeight.bind(this));
        this.refreshMaxHeaderHeight();
        const pinned = this.rowCtrl.pinned;
        const leafCols = column.getProvidedColumnGroup().getLeafColumns();
        colHover?.createHoverFeature(compBean, leafCols, eGui);
        rangeSvc?.createRangeHighlightFeature(compBean, column, comp);
        compBean.createManagedBean(new $437b23f6a393c3bf$var$SetLeftFeature(column, eGui, beans));
        compBean.createManagedBean(new $437b23f6a393c3bf$var$GroupWidthFeature(comp, column));
        if (colResize) this.resizeFeature = compBean.createManagedBean(colResize.createGroupResizeFeature(comp, eResize, pinned, column));
        else comp.setResizableDisplayed(false);
        compBean.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(eGui, {
            shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
            onTabKeyDown: ()=>void 0,
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this)
        }));
        this.addHighlightListeners(compBean, leafCols);
        compBean.addManagedPropertyListener("suppressMovableColumns", this.onSuppressColMoveChange);
        this.addResizeAndMoveKeyboardListeners(compBean);
        compBean.addDestroyFunc(()=>this.clearComponent());
    }
    getHeaderClassParams() {
        const { column: column, beans: beans } = this;
        const colDef = column.getDefinition();
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(beans.gos, {
            colDef: colDef,
            columnGroup: column,
            floatingFilter: false
        });
    }
    refreshMaxHeaderHeight() {
        const { gos: gos, comp: comp } = this;
        const groupHeaderHeight = gos.get("groupHeaderHeight");
        if (groupHeaderHeight != null) {
            if (groupHeaderHeight === 0) comp.setHeaderWrapperHidden(true);
            else comp.setHeaderWrapperMaxHeight(groupHeaderHeight);
        } else {
            comp.setHeaderWrapperHidden(false);
            comp.setHeaderWrapperMaxHeight(null);
        }
    }
    addHighlightListeners(compBean, columns) {
        if (!this.beans.gos.get("suppressMoveWhenColumnDragging")) return;
        for (const column of columns)compBean.addManagedListeners(column, {
            headerHighlightChanged: this.onLeafColumnHighlightChanged.bind(this, column)
        });
    }
    onLeafColumnHighlightChanged(column) {
        const displayedColumns = this.column.getDisplayedLeafColumns();
        const isFirst = displayedColumns[0] === column;
        const isLast = $437b23f6a393c3bf$export$236389741107357f(displayedColumns) === column;
        if (!isFirst && !isLast) return;
        const highlighted = column.getHighlighted();
        const isColumnMoveAtThisLevel = !!this.rowCtrl.getHeaderCellCtrls().find((ctrl)=>{
            return ctrl.column.isMoving();
        });
        let beforeOn = false;
        let afterOn = false;
        if (isColumnMoveAtThisLevel) {
            const isRtl = this.beans.gos.get("enableRtl");
            const isHighlightAfter = highlighted === 1 /* After */ ;
            const isHighlightBefore = highlighted === 0 /* Before */ ;
            if (isFirst) {
                if (isRtl) afterOn = isHighlightAfter;
                else beforeOn = isHighlightBefore;
            }
            if (isLast) {
                if (isRtl) beforeOn = isHighlightBefore;
                else afterOn = isHighlightAfter;
            }
        }
        this.comp.toggleCss("ag-header-highlight-before", beforeOn);
        this.comp.toggleCss("ag-header-highlight-after", afterOn);
    }
    resizeHeader(delta, shiftKey) {
        const { resizeFeature: resizeFeature } = this;
        if (!resizeFeature) return;
        const initialValues = resizeFeature.getInitialValues(shiftKey);
        resizeFeature.resizeColumns(initialValues, initialValues.resizeStartWidth + delta, "uiColumnResized", true);
    }
    resizeLeafColumnsToFit(source) {
        this.resizeFeature?.resizeLeafColumnsToFit(source);
    }
    setupUserComp() {
        const { colGroupSvc: colGroupSvc, userCompFactory: userCompFactory, gos: gos, enterpriseMenuFactory: enterpriseMenuFactory } = this.beans;
        const columnGroup = this.column;
        const providedColumnGroup = columnGroup.getProvidedColumnGroup();
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            displayName: this.displayName,
            columnGroup: columnGroup,
            setExpanded: (expanded)=>{
                colGroupSvc.setColumnGroupOpened(providedColumnGroup, expanded, "gridInitializing");
            },
            setTooltip: (value, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                this.setupTooltip(value, shouldDisplayTooltip);
            },
            showColumnMenu: (buttonElement, onClosedCallback)=>enterpriseMenuFactory?.showMenuAfterButtonClick(providedColumnGroup, buttonElement, "columnMenu", onClosedCallback),
            showColumnMenuAfterMouseClick: (mouseEvent, onClosedCallback)=>enterpriseMenuFactory?.showMenuAfterMouseEvent(providedColumnGroup, mouseEvent, "columnMenu", onClosedCallback),
            eGridHeader: this.eGui
        });
        const compDetails = $437b23f6a393c3bf$var$_getHeaderGroupCompDetails(userCompFactory, params);
        if (compDetails) this.comp.setUserCompDetails(compDetails);
    }
    addHeaderMouseListeners(compBean) {
        const listener = (e)=>this.handleMouseOverChange(e.type === "mouseenter");
        const clickListener = ()=>this.dispatchColumnMouseEvent("columnHeaderClicked", this.column.getProvidedColumnGroup());
        const contextMenuListener = (event)=>this.handleContextMenuMouseEvent(event, void 0, this.column.getProvidedColumnGroup());
        compBean.addManagedListeners(this.eGui, {
            mouseenter: listener,
            mouseleave: listener,
            click: clickListener,
            contextmenu: contextMenuListener
        });
    }
    handleMouseOverChange(isMouseOver) {
        this.eventSvc.dispatchEvent({
            type: isMouseOver ? "columnHeaderMouseOver" : "columnHeaderMouseLeave",
            column: this.column.getProvidedColumnGroup()
        });
    }
    setupTooltip(value, shouldDisplayTooltip) {
        this.tooltipFeature = this.beans.tooltipSvc?.setupHeaderGroupTooltip(this.tooltipFeature, this, value, shouldDisplayTooltip);
    }
    setupExpandable(compBean) {
        const providedColGroup = this.column.getProvidedColumnGroup();
        this.refreshExpanded();
        const listener = this.refreshExpanded.bind(this);
        compBean.addManagedListeners(providedColGroup, {
            expandedChanged: listener,
            expandableChanged: listener
        });
    }
    refreshExpanded() {
        const { column: column } = this;
        this.expandable = column.isExpandable();
        const expanded = column.isExpanded();
        if (this.expandable) this.comp.setAriaExpanded(expanded ? "true" : "false");
        else this.comp.setAriaExpanded(void 0);
        this.refreshHeaderStyles();
    }
    addClasses() {
        const { column: column } = this;
        const colGroupDef = column.getColGroupDef();
        const classes = $437b23f6a393c3bf$export$9ba3bd48c77c5e8a(colGroupDef, this.gos, null, column);
        if (column.isPadding()) {
            classes.push("ag-header-group-cell-no-group");
            const leafCols = column.getLeafColumns();
            if (leafCols.every((col)=>col.isSpanHeaderHeight())) classes.push("ag-header-span-height");
        } else {
            classes.push("ag-header-group-cell-with-group");
            if (colGroupDef?.wrapHeaderText) classes.push("ag-header-cell-wrap-text");
        }
        classes.forEach((c)=>this.comp.toggleCss(c, true));
    }
    setupMovingCss(compBean) {
        const { column: column } = this;
        const providedColumnGroup = column.getProvidedColumnGroup();
        const leafColumns = providedColumnGroup.getLeafColumns();
        const listener = ()=>this.comp.toggleCss("ag-header-cell-moving", column.isMoving());
        leafColumns.forEach((col)=>{
            compBean.addManagedListeners(col, {
                movingChanged: listener
            });
        });
        listener();
    }
    onFocusIn(e) {
        if (!this.eGui.contains(e.relatedTarget)) this.focusThis();
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        const wrapperHasFocus = this.getWrapperHasFocus();
        if (!this.expandable || !wrapperHasFocus) return;
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) {
            const column = this.column;
            const newExpandedValue = !column.isExpanded();
            this.beans.colGroupSvc.setColumnGroupOpened(column.getProvidedColumnGroup(), newExpandedValue, "uiColumnExpanded");
        }
    }
    // unlike columns, this will only get called once, as we don't react on props on column groups
    // (we will always destroy and recreate this comp if something changes)
    setDragSource(eHeaderGroup) {
        if (!this.isAlive() || this.isSuppressMoving()) return;
        this.removeDragSource();
        if (!eHeaderGroup) return;
        this.dragSource = this.beans.colMoves?.setDragSourceForHeader(eHeaderGroup, this.column, this.displayName) ?? null;
    }
    isSuppressMoving() {
        return this.gos.get("suppressMovableColumns") || this.column.getLeafColumns().some((column)=>column.getColDef().suppressMovable || column.getColDef().lockPosition);
    }
    destroy() {
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        super.destroy();
    }
};
// packages/ag-grid-community/src/columns/columnGroups/columnGroupApi.ts
function $437b23f6a393c3bf$var$setColumnGroupOpened(beans, group, newValue) {
    beans.colGroupSvc?.setColumnGroupOpened(group, newValue, "api");
}
function $437b23f6a393c3bf$var$getColumnGroup(beans, name, instanceId) {
    return beans.colGroupSvc?.getColumnGroup(name, instanceId) ?? null;
}
function $437b23f6a393c3bf$var$getProvidedColumnGroup(beans, name) {
    return beans.colGroupSvc?.getProvidedColGroup(name) ?? null;
}
function $437b23f6a393c3bf$var$getDisplayNameForColumnGroup(beans, columnGroup, location) {
    return beans.colNames.getDisplayNameForColumnGroup(columnGroup, location) || "";
}
function $437b23f6a393c3bf$var$getColumnGroupState(beans) {
    return beans.colGroupSvc?.getColumnGroupState() ?? [];
}
function $437b23f6a393c3bf$var$setColumnGroupState(beans, stateItems) {
    beans.colGroupSvc?.setColumnGroupState(stateItems, "api");
}
function $437b23f6a393c3bf$var$resetColumnGroupState(beans) {
    beans.colGroupSvc?.resetColumnGroupState("api");
}
function $437b23f6a393c3bf$var$getLeftDisplayedColumnGroups(beans) {
    return beans.visibleCols.treeLeft;
}
function $437b23f6a393c3bf$var$getCenterDisplayedColumnGroups(beans) {
    return beans.visibleCols.treeCenter;
}
function $437b23f6a393c3bf$var$getRightDisplayedColumnGroups(beans) {
    return beans.visibleCols.treeRight;
}
function $437b23f6a393c3bf$var$getAllDisplayedColumnGroups(beans) {
    return beans.visibleCols.getAllTrees();
}
// packages/ag-grid-community/src/columns/visibleColsService.ts
function $437b23f6a393c3bf$var$_removeAllFromUnorderedArray(array, toRemove) {
    for(let i = 0; i < toRemove.length; i++){
        const index = array.indexOf(toRemove[i]);
        if (index >= 0) {
            array[index] = array[array.length - 1];
            array.pop();
        }
    }
}
var $437b23f6a393c3bf$var$VisibleColsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "visibleCols";
        // for fast lookup, to see if a column or group is still visible
        this.colsAndGroupsMap = {};
        // leave level columns of the displayed trees
        this.leftCols = [];
        this.rightCols = [];
        this.centerCols = [];
        // all three lists above combined
        this.allCols = [];
        this.headerGroupRowCount = 0;
        // used by:
        // + angularGrid -> for setting body width
        // + rowController -> setting main row widths (when inserting and resizing)
        // need to cache this
        this.bodyWidth = 0;
        this.leftWidth = 0;
        this.rightWidth = 0;
        this.isBodyWidthDirty = true;
    }
    refresh(source, skipTreeBuild = false) {
        const { colFlex: colFlex, colModel: colModel, colGroupSvc: colGroupSvc, colViewport: colViewport, selectionColSvc: selectionColSvc } = this.beans;
        if (!skipTreeBuild) this.buildTrees(colModel, colGroupSvc);
        colGroupSvc?.updateOpenClosedVisibility();
        this.leftCols = $437b23f6a393c3bf$var$pickDisplayedCols(this.treeLeft);
        this.centerCols = $437b23f6a393c3bf$var$pickDisplayedCols(this.treeCenter);
        this.rightCols = $437b23f6a393c3bf$var$pickDisplayedCols(this.treeRight);
        selectionColSvc?.refreshVisibility(this.leftCols, this.centerCols, this.rightCols);
        this.joinColsAriaOrder(colModel);
        this.joinCols();
        this.headerGroupRowCount = this.getHeaderRowCount();
        this.setLeftValues(source);
        this.autoHeightCols = this.allCols.filter((col)=>col.isAutoHeight());
        colFlex?.refreshFlexedColumns();
        this.updateBodyWidths();
        this.setFirstRightAndLastLeftPinned(colModel, this.leftCols, this.rightCols, source);
        colViewport.checkViewportColumns(false);
        this.eventSvc.dispatchEvent({
            type: "displayedColumnsChanged",
            source: source
        });
    }
    getHeaderRowCount() {
        if (!this.gos.get("hidePaddedHeaderRows")) return this.beans.colModel.cols.treeDepth;
        let headerGroupRowCount = 0;
        for (const col of this.allCols){
            let parent = col.getParent();
            while(parent){
                if (!parent.isPadding()) {
                    const level = parent.getProvidedColumnGroup().getLevel() + 1;
                    if (level > headerGroupRowCount) headerGroupRowCount = level;
                    break;
                }
                parent = parent.getParent();
            }
        }
        return headerGroupRowCount;
    }
    // after setColumnWidth or updateGroupsAndPresentedCols
    updateBodyWidths() {
        const newBodyWidth = $437b23f6a393c3bf$var$getWidthOfColsInList(this.centerCols);
        const newLeftWidth = $437b23f6a393c3bf$var$getWidthOfColsInList(this.leftCols);
        const newRightWidth = $437b23f6a393c3bf$var$getWidthOfColsInList(this.rightCols);
        this.isBodyWidthDirty = this.bodyWidth !== newBodyWidth;
        const atLeastOneChanged = this.bodyWidth !== newBodyWidth || this.leftWidth !== newLeftWidth || this.rightWidth !== newRightWidth;
        if (atLeastOneChanged) {
            this.bodyWidth = newBodyWidth;
            this.leftWidth = newLeftWidth;
            this.rightWidth = newRightWidth;
            this.eventSvc.dispatchEvent({
                type: "columnContainerWidthChanged"
            });
            this.eventSvc.dispatchEvent({
                type: "displayedColumnsWidthChanged"
            });
        }
    }
    // sets the left pixel position of each column
    setLeftValues(source) {
        this.setLeftValuesOfCols(source);
        this.setLeftValuesOfGroups();
    }
    setFirstRightAndLastLeftPinned(colModel, leftCols, rightCols, source) {
        let lastLeft;
        let firstRight;
        if (this.gos.get("enableRtl")) {
            lastLeft = leftCols ? leftCols[0] : null;
            firstRight = rightCols ? $437b23f6a393c3bf$export$236389741107357f(rightCols) : null;
        } else {
            lastLeft = leftCols ? $437b23f6a393c3bf$export$236389741107357f(leftCols) : null;
            firstRight = rightCols ? rightCols[0] : null;
        }
        colModel.getCols().forEach((col)=>{
            col.setLastLeftPinned(col === lastLeft, source);
            col.setFirstRightPinned(col === firstRight, source);
        });
    }
    buildTrees(colModel, columnGroupSvc) {
        const cols = colModel.getColsToShow();
        const leftCols = cols.filter((col)=>col.getPinned() == "left");
        const rightCols = cols.filter((col)=>col.getPinned() == "right");
        const centerCols = cols.filter((col)=>col.getPinned() != "left" && col.getPinned() != "right");
        const idCreator = new $437b23f6a393c3bf$export$b3b24737a74261fb();
        const createGroups = (params)=>{
            return columnGroupSvc ? columnGroupSvc.createColumnGroups(params) : params.columns;
        };
        this.treeLeft = createGroups({
            columns: leftCols,
            idCreator: idCreator,
            pinned: "left",
            oldDisplayedGroups: this.treeLeft
        });
        this.treeRight = createGroups({
            columns: rightCols,
            idCreator: idCreator,
            pinned: "right",
            oldDisplayedGroups: this.treeRight
        });
        this.treeCenter = createGroups({
            columns: centerCols,
            idCreator: idCreator,
            pinned: null,
            oldDisplayedGroups: this.treeCenter
        });
        this.updateColsAndGroupsMap();
    }
    clear() {
        this.leftCols = [];
        this.rightCols = [];
        this.centerCols = [];
        this.allCols = [];
        this.ariaOrderColumns = [];
    }
    joinColsAriaOrder(colModel) {
        const allColumns = colModel.getCols();
        const pinnedLeft = [];
        const center = [];
        const pinnedRight = [];
        for (const col of allColumns){
            const pinned = col.getPinned();
            if (!pinned) center.push(col);
            else if (pinned === true || pinned === "left") pinnedLeft.push(col);
            else pinnedRight.push(col);
        }
        this.ariaOrderColumns = pinnedLeft.concat(center).concat(pinnedRight);
    }
    getAriaColIndex(colOrGroup) {
        let col;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(colOrGroup)) col = colOrGroup.getLeafColumns()[0];
        else col = colOrGroup;
        return this.ariaOrderColumns.indexOf(col) + 1;
    }
    setLeftValuesOfGroups() {
        [
            this.treeLeft,
            this.treeRight,
            this.treeCenter
        ].forEach((columns)=>{
            columns.forEach((column)=>{
                if ($437b23f6a393c3bf$export$1f44a60fc23f9028(column)) {
                    const columnGroup = column;
                    columnGroup.checkLeft();
                }
            });
        });
    }
    setLeftValuesOfCols(source) {
        const { colModel: colModel } = this.beans;
        const primaryCols = colModel.getColDefCols();
        if (!primaryCols) return;
        const allColumns = colModel.getCols().slice(0);
        const doingRtl = this.gos.get("enableRtl");
        [
            this.leftCols,
            this.rightCols,
            this.centerCols
        ].forEach((columns)=>{
            if (doingRtl) {
                let left = $437b23f6a393c3bf$var$getWidthOfColsInList(columns);
                columns.forEach((column)=>{
                    left -= column.getActualWidth();
                    column.setLeft(left, source);
                });
            } else {
                let left = 0;
                columns.forEach((column)=>{
                    column.setLeft(left, source);
                    left += column.getActualWidth();
                });
            }
            $437b23f6a393c3bf$var$_removeAllFromUnorderedArray(allColumns, columns);
        });
        allColumns.forEach((column)=>{
            column.setLeft(null, source);
        });
    }
    joinCols() {
        if (this.gos.get("enableRtl")) this.allCols = this.rightCols.concat(this.centerCols).concat(this.leftCols);
        else this.allCols = this.leftCols.concat(this.centerCols).concat(this.rightCols);
    }
    getAllTrees() {
        if (this.treeLeft && this.treeRight && this.treeCenter) return this.treeLeft.concat(this.treeCenter).concat(this.treeRight);
        return null;
    }
    // gridPanel -> ensureColumnVisible
    isColDisplayed(column) {
        return this.allCols.indexOf(column) >= 0;
    }
    getLeftColsForRow(rowNode) {
        const { leftCols: leftCols, beans: { colModel: colModel } } = this;
        const colSpanActive = colModel.colSpanActive;
        if (!colSpanActive) return leftCols;
        return this.getColsForRow(rowNode, leftCols);
    }
    getRightColsForRow(rowNode) {
        const { rightCols: rightCols, beans: { colModel: colModel } } = this;
        const colSpanActive = colModel.colSpanActive;
        if (!colSpanActive) return rightCols;
        return this.getColsForRow(rowNode, rightCols);
    }
    getColsForRow(rowNode, displayedColumns, filterCallback, emptySpaceBeforeColumn) {
        const result = [];
        let lastConsideredCol = null;
        for(let i = 0; i < displayedColumns.length; i++){
            const col = displayedColumns[i];
            const maxAllowedColSpan = displayedColumns.length - i;
            const colSpan = Math.min(col.getColSpan(rowNode), maxAllowedColSpan);
            const columnsToCheckFilter = [
                col
            ];
            if (colSpan > 1) {
                const colsToRemove = colSpan - 1;
                for(let j = 1; j <= colsToRemove; j++)columnsToCheckFilter.push(displayedColumns[i + j]);
                i += colsToRemove;
            }
            let filterPasses;
            if (filterCallback) {
                filterPasses = false;
                columnsToCheckFilter.forEach((colForFilter)=>{
                    if (filterCallback(colForFilter)) filterPasses = true;
                });
            } else filterPasses = true;
            if (filterPasses) {
                if (result.length === 0 && lastConsideredCol) {
                    const gapBeforeColumn = emptySpaceBeforeColumn ? emptySpaceBeforeColumn(col) : false;
                    if (gapBeforeColumn) result.push(lastConsideredCol);
                }
                result.push(col);
            }
            lastConsideredCol = col;
        }
        return result;
    }
    getContainerWidth(pinned) {
        switch(pinned){
            case "left":
                return this.leftWidth;
            case "right":
                return this.rightWidth;
            default:
                return this.bodyWidth;
        }
    }
    getColBefore(col) {
        const allDisplayedColumns = this.allCols;
        const oldIndex = allDisplayedColumns.indexOf(col);
        if (oldIndex > 0) return allDisplayedColumns[oldIndex - 1];
        return null;
    }
    isPinningLeft() {
        return this.leftCols.length > 0;
    }
    isPinningRight() {
        return this.rightCols.length > 0;
    }
    updateColsAndGroupsMap() {
        this.colsAndGroupsMap = {};
        const func = (child)=>{
            this.colsAndGroupsMap[child.getUniqueId()] = child;
        };
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(this.treeCenter, false, func);
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(this.treeLeft, false, func);
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(this.treeRight, false, func);
    }
    isVisible(item) {
        const fromMap = this.colsAndGroupsMap[item.getUniqueId()];
        return fromMap === item;
    }
    getFirstColumn() {
        const isRtl = this.gos.get("enableRtl");
        const queryOrder = [
            "leftCols",
            "centerCols",
            "rightCols"
        ];
        if (isRtl) queryOrder.reverse();
        for(let i = 0; i < queryOrder.length; i++){
            const container = this[queryOrder[i]];
            if (container.length) return isRtl ? $437b23f6a393c3bf$export$236389741107357f(container) : container[0];
        }
        return null;
    }
    // used by:
    // + rowRenderer -> for navigation
    getColAfter(col) {
        const allDisplayedColumns = this.allCols;
        const oldIndex = allDisplayedColumns.indexOf(col);
        if (oldIndex < allDisplayedColumns.length - 1) return allDisplayedColumns[oldIndex + 1];
        return null;
    }
    // used by:
    // + angularGrid -> setting pinned body width
    // note: this should be cached
    getColsLeftWidth() {
        return $437b23f6a393c3bf$var$getWidthOfColsInList(this.leftCols);
    }
    // note: this should be cached
    getDisplayedColumnsRightWidth() {
        return $437b23f6a393c3bf$var$getWidthOfColsInList(this.rightCols);
    }
    isColAtEdge(col, edge) {
        const allColumns = this.allCols;
        if (!allColumns.length) return false;
        const isFirst = edge === "first";
        let columnToCompare;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(col)) {
            const leafColumns = col.getDisplayedLeafColumns();
            if (!leafColumns.length) return false;
            columnToCompare = isFirst ? leafColumns[0] : $437b23f6a393c3bf$export$236389741107357f(leafColumns);
        } else columnToCompare = col;
        return (isFirst ? allColumns[0] : $437b23f6a393c3bf$export$236389741107357f(allColumns)) === columnToCompare;
    }
};
function $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(tree, useDisplayedChildren, callback) {
    if (!tree) return;
    for(let i = 0; i < tree.length; i++){
        const child = tree[i];
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) {
            const childTree = useDisplayedChildren ? child.getDisplayedChildren() : child.getChildren();
            $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(childTree, useDisplayedChildren, callback);
        }
        callback(child);
    }
}
function $437b23f6a393c3bf$var$pickDisplayedCols(tree) {
    const res = [];
    $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(tree, true, (child)=>{
        if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) res.push(child);
    });
    return res;
}
// packages/ag-grid-community/src/columns/columnGroups/columnGroupService.ts
var $437b23f6a393c3bf$var$ColumnGroupService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colGroupSvc";
    }
    getColumnGroupState() {
        const columnGroupState = [];
        const gridBalancedTree = this.beans.colModel.getColTree();
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, gridBalancedTree, (node)=>{
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(node)) columnGroupState.push({
                groupId: node.getGroupId(),
                open: node.isExpanded()
            });
        });
        return columnGroupState;
    }
    resetColumnGroupState(source) {
        const primaryColumnTree = this.beans.colModel.getColDefColTree();
        if (!primaryColumnTree) return;
        const stateItems = [];
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, primaryColumnTree, (child)=>{
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) {
                const colGroupDef = child.getColGroupDef();
                const groupState = {
                    groupId: child.getGroupId(),
                    open: !colGroupDef ? void 0 : colGroupDef.openByDefault
                };
                stateItems.push(groupState);
            }
        });
        this.setColumnGroupState(stateItems, source);
    }
    setColumnGroupState(stateItems, source) {
        const { colModel: colModel, colAnimation: colAnimation, visibleCols: visibleCols, eventSvc: eventSvc } = this.beans;
        const gridBalancedTree = colModel.getColTree();
        if (!gridBalancedTree.length) return;
        colAnimation?.start();
        const impactedGroups = [];
        stateItems.forEach((stateItem)=>{
            const groupKey = stateItem.groupId;
            const newValue = stateItem.open;
            const providedColumnGroup = this.getProvidedColGroup(groupKey);
            if (!providedColumnGroup) return;
            if (providedColumnGroup.isExpanded() === newValue) return;
            providedColumnGroup.setExpanded(newValue);
            impactedGroups.push(providedColumnGroup);
        });
        visibleCols.refresh(source, true);
        if (impactedGroups.length) eventSvc.dispatchEvent({
            type: "columnGroupOpened",
            columnGroup: impactedGroups.length === 1 ? impactedGroups[0] : void 0,
            columnGroups: impactedGroups
        });
        colAnimation?.finish();
    }
    // called by headerRenderer - when a header is opened or closed
    setColumnGroupOpened(key, newValue, source) {
        let keyAsString;
        if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(key)) keyAsString = key.getId();
        else keyAsString = key || "";
        this.setColumnGroupState([
            {
                groupId: keyAsString,
                open: newValue
            }
        ], source);
    }
    getProvidedColGroup(key) {
        let res = null;
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, this.beans.colModel.getColTree(), (node)=>{
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(node)) {
                if (node.getId() === key) res = node;
            }
        });
        return res;
    }
    getGroupAtDirection(columnGroup, direction) {
        const requiredLevel = columnGroup.getProvidedColumnGroup().getLevel() + columnGroup.getPaddingLevel();
        const colGroupLeafColumns = columnGroup.getDisplayedLeafColumns();
        const col = direction === "After" ? $437b23f6a393c3bf$export$236389741107357f(colGroupLeafColumns) : colGroupLeafColumns[0];
        const getDisplayColMethod = `getCol${direction}`;
        while(true){
            const column = this.beans.visibleCols[getDisplayColMethod](col);
            if (!column) return null;
            const groupPointer = this.getColGroupAtLevel(column, requiredLevel);
            if (groupPointer !== columnGroup) return groupPointer;
        }
    }
    getColGroupAtLevel(column, level) {
        let groupPointer = column.getParent();
        let originalGroupLevel;
        let groupPointerLevel;
        while(true){
            const groupPointerProvidedColumnGroup = groupPointer.getProvidedColumnGroup();
            originalGroupLevel = groupPointerProvidedColumnGroup.getLevel();
            groupPointerLevel = groupPointer.getPaddingLevel();
            if (originalGroupLevel + groupPointerLevel <= level) break;
            groupPointer = groupPointer.getParent();
        }
        return groupPointer;
    }
    updateOpenClosedVisibility() {
        const allColumnGroups = this.beans.visibleCols.getAllTrees();
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(allColumnGroups, false, (child)=>{
            if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) child.calculateDisplayedColumns();
        });
    }
    // returns the group with matching colId and instanceId. If instanceId is missing,
    // matches only on the colId.
    getColumnGroup(colId, partId) {
        if (!colId) return null;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(colId)) return colId;
        const allColumnGroups = this.beans.visibleCols.getAllTrees();
        const checkPartId = typeof partId === "number";
        let result = null;
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(allColumnGroups, false, (child)=>{
            if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) {
                const columnGroup = child;
                let matched;
                if (checkPartId) matched = colId === columnGroup.getGroupId() && partId === columnGroup.getPartId();
                else matched = colId === columnGroup.getGroupId();
                if (matched) result = columnGroup;
            }
        });
        return result;
    }
    createColumnGroups(params) {
        const { columns: columns, idCreator: idCreator, pinned: pinned, oldDisplayedGroups: oldDisplayedGroups, isStandaloneStructure: isStandaloneStructure } = params;
        const oldColumnsMapped = this.mapOldGroupsById(oldDisplayedGroups);
        const topLevelResultCols = [];
        let groupsOrColsAtCurrentLevel = columns;
        while(groupsOrColsAtCurrentLevel.length){
            const currentlyIterating = groupsOrColsAtCurrentLevel;
            groupsOrColsAtCurrentLevel = [];
            let lastGroupedColIdx = 0;
            const createGroupToIndex = (to)=>{
                const from = lastGroupedColIdx;
                lastGroupedColIdx = to;
                const previousNode = currentlyIterating[from];
                const previousNodeProvided = $437b23f6a393c3bf$export$1f44a60fc23f9028(previousNode) ? previousNode.getProvidedColumnGroup() : previousNode;
                const previousNodeParent = previousNodeProvided.getOriginalParent();
                if (previousNodeParent == null) {
                    for(let i = from; i < to; i++)topLevelResultCols.push(currentlyIterating[i]);
                    return;
                }
                const newGroup = this.createColumnGroup(previousNodeParent, idCreator, oldColumnsMapped, pinned, isStandaloneStructure);
                for(let i = from; i < to; i++)newGroup.addChild(currentlyIterating[i]);
                groupsOrColsAtCurrentLevel.push(newGroup);
            };
            for(let i = 1; i < currentlyIterating.length; i++){
                const thisNode = currentlyIterating[i];
                const thisNodeProvided = $437b23f6a393c3bf$export$1f44a60fc23f9028(thisNode) ? thisNode.getProvidedColumnGroup() : thisNode;
                const thisNodeParent = thisNodeProvided.getOriginalParent();
                const previousNode = currentlyIterating[lastGroupedColIdx];
                const previousNodeProvided = $437b23f6a393c3bf$export$1f44a60fc23f9028(previousNode) ? previousNode.getProvidedColumnGroup() : previousNode;
                const previousNodeParent = previousNodeProvided.getOriginalParent();
                if (thisNodeParent !== previousNodeParent) createGroupToIndex(i);
            }
            if (lastGroupedColIdx < currentlyIterating.length) createGroupToIndex(currentlyIterating.length);
        }
        if (!isStandaloneStructure) this.setupParentsIntoCols(topLevelResultCols, null);
        return topLevelResultCols;
    }
    createProvidedColumnGroup(primaryColumns, colGroupDef, level, existingColumns, columnKeyCreator, existingGroups, source) {
        const groupId = columnKeyCreator.getUniqueKey(colGroupDef.groupId || null, null);
        const colGroupDefMerged = $437b23f6a393c3bf$var$createMergedColGroupDef(this.beans, colGroupDef, groupId);
        const providedGroup = new $437b23f6a393c3bf$export$7ff27642a6ecc1cf(colGroupDefMerged, groupId, false, level);
        this.createBean(providedGroup);
        const existingGroupAndIndex = this.findExistingGroup(colGroupDef, existingGroups);
        if (existingGroupAndIndex) existingGroups.splice(existingGroupAndIndex.idx, 1);
        const existingGroup = existingGroupAndIndex?.group;
        if (existingGroup) providedGroup.setExpanded(existingGroup.isExpanded());
        const children = $437b23f6a393c3bf$var$_recursivelyCreateColumns(this.beans, colGroupDefMerged.children, level + 1, primaryColumns, existingColumns, columnKeyCreator, existingGroups, source);
        providedGroup.setChildren(children);
        return providedGroup;
    }
    balanceColumnTree(unbalancedTree, currentDepth, columnDepth, columnKeyCreator) {
        const result = [];
        for(let i = 0; i < unbalancedTree.length; i++){
            const child = unbalancedTree[i];
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) {
                const originalGroup = child;
                const newChildren = this.balanceColumnTree(originalGroup.getChildren(), currentDepth + 1, columnDepth, columnKeyCreator);
                originalGroup.setChildren(newChildren);
                result.push(originalGroup);
            } else {
                let firstPaddedGroup;
                let currentPaddedGroup;
                for(let j = currentDepth; j < columnDepth; j++){
                    const newColId = columnKeyCreator.getUniqueKey(null, null);
                    const colGroupDefMerged = $437b23f6a393c3bf$var$createMergedColGroupDef(this.beans, null, newColId);
                    const paddedGroup = new $437b23f6a393c3bf$export$7ff27642a6ecc1cf(colGroupDefMerged, newColId, true, j);
                    this.createBean(paddedGroup);
                    if (currentPaddedGroup) currentPaddedGroup.setChildren([
                        paddedGroup
                    ]);
                    currentPaddedGroup = paddedGroup;
                    if (!firstPaddedGroup) firstPaddedGroup = currentPaddedGroup;
                }
                if (firstPaddedGroup && currentPaddedGroup) {
                    result.push(firstPaddedGroup);
                    const hasGroups = unbalancedTree.some((leaf)=>$437b23f6a393c3bf$export$bb4bfad2b594b78e(leaf));
                    if (hasGroups) {
                        currentPaddedGroup.setChildren([
                            child
                        ]);
                        continue;
                    } else {
                        currentPaddedGroup.setChildren(unbalancedTree);
                        break;
                    }
                }
                result.push(child);
            }
        }
        return result;
    }
    findDepth(balancedColumnTree) {
        let depth = 0;
        let pointer = balancedColumnTree;
        while(pointer && pointer[0] && $437b23f6a393c3bf$export$bb4bfad2b594b78e(pointer[0])){
            depth++;
            pointer = pointer[0].getChildren();
        }
        return depth;
    }
    findMaxDepth(treeChildren, depth) {
        let maxDepthThisLevel = depth;
        for(let i = 0; i < treeChildren.length; i++){
            const abstractColumn = treeChildren[i];
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(abstractColumn)) {
                const originalGroup = abstractColumn;
                const newDepth = this.findMaxDepth(originalGroup.getChildren(), depth + 1);
                if (maxDepthThisLevel < newDepth) maxDepthThisLevel = newDepth;
            }
        }
        return maxDepthThisLevel;
    }
    /**
   * Inserts dummy group columns in the hierarchy above auto-generated columns
   * in order to ensure auto-generated columns are leaf nodes (and therefore are
   * displayed correctly)
   */ balanceTreeForAutoCols(autoCols, depth) {
        const tree = [];
        autoCols.forEach((col)=>{
            let nextChild = col;
            for(let i = depth - 1; i >= 0; i--){
                const autoGroup = new $437b23f6a393c3bf$export$7ff27642a6ecc1cf(null, `FAKE_PATH_${col.getId()}}_${i}`, true, i);
                this.createBean(autoGroup);
                autoGroup.setChildren([
                    nextChild
                ]);
                nextChild.originalParent = autoGroup;
                nextChild = autoGroup;
            }
            if (depth === 0) col.originalParent = null;
            tree.push(nextChild);
        });
        return tree;
    }
    findExistingGroup(newGroupDef, existingGroups) {
        const newHasId = newGroupDef.groupId != null;
        if (!newHasId) return void 0;
        for(let i = 0; i < existingGroups.length; i++){
            const existingGroup = existingGroups[i];
            const existingDef = existingGroup.getColGroupDef();
            if (!existingDef) continue;
            if (existingGroup.getId() === newGroupDef.groupId) return {
                idx: i,
                group: existingGroup
            };
        }
        return void 0;
    }
    createColumnGroup(providedGroup, groupInstanceIdCreator, oldColumnsMapped, pinned, isStandaloneStructure) {
        const groupId = providedGroup.getGroupId();
        const instanceId = groupInstanceIdCreator.getInstanceIdForKey(groupId);
        const uniqueId = $437b23f6a393c3bf$var$createUniqueColumnGroupId(groupId, instanceId);
        let columnGroup = oldColumnsMapped[uniqueId];
        if (columnGroup && columnGroup.getProvidedColumnGroup() !== providedGroup) columnGroup = null;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(columnGroup)) columnGroup.reset();
        else {
            columnGroup = new $437b23f6a393c3bf$export$273c80940a54c770(providedGroup, groupId, instanceId, pinned);
            if (!isStandaloneStructure) this.createBean(columnGroup);
        }
        return columnGroup;
    }
    // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup
    mapOldGroupsById(displayedGroups) {
        const result = {};
        const recursive = (columnsOrGroups)=>{
            columnsOrGroups.forEach((columnOrGroup)=>{
                if ($437b23f6a393c3bf$export$1f44a60fc23f9028(columnOrGroup)) {
                    const columnGroup = columnOrGroup;
                    result[columnOrGroup.getUniqueId()] = columnGroup;
                    recursive(columnGroup.getChildren());
                }
            });
        };
        if (displayedGroups) recursive(displayedGroups);
        return result;
    }
    setupParentsIntoCols(columnsOrGroups, parent) {
        columnsOrGroups.forEach((columnsOrGroup)=>{
            if (columnsOrGroup.parent !== parent) this.beans.colViewport.colsWithinViewportHash = "";
            columnsOrGroup.parent = parent;
            if ($437b23f6a393c3bf$export$1f44a60fc23f9028(columnsOrGroup)) {
                const columnGroup = columnsOrGroup;
                this.setupParentsIntoCols(columnGroup.getChildren(), columnGroup);
            }
        });
    }
};
// packages/ag-grid-community/src/columns/columnGroups/columnGroupModule.ts
var $437b23f6a393c3bf$export$922da35340a6d14e = {
    moduleName: "ColumnGroup",
    version: $437b23f6a393c3bf$var$VERSION,
    dynamicBeans: {
        headerGroupCellCtrl: $437b23f6a393c3bf$var$HeaderGroupCellCtrl
    },
    beans: [
        $437b23f6a393c3bf$var$ColumnGroupService
    ],
    apiFunctions: {
        getAllDisplayedColumnGroups: $437b23f6a393c3bf$var$getAllDisplayedColumnGroups,
        getCenterDisplayedColumnGroups: $437b23f6a393c3bf$var$getCenterDisplayedColumnGroups,
        getColumnGroup: $437b23f6a393c3bf$var$getColumnGroup,
        getColumnGroupState: $437b23f6a393c3bf$var$getColumnGroupState,
        getDisplayNameForColumnGroup: $437b23f6a393c3bf$var$getDisplayNameForColumnGroup,
        getLeftDisplayedColumnGroups: $437b23f6a393c3bf$var$getLeftDisplayedColumnGroups,
        getProvidedColumnGroup: $437b23f6a393c3bf$var$getProvidedColumnGroup,
        getRightDisplayedColumnGroups: $437b23f6a393c3bf$var$getRightDisplayedColumnGroups,
        resetColumnGroupState: $437b23f6a393c3bf$var$resetColumnGroupState,
        setColumnGroupOpened: $437b23f6a393c3bf$var$setColumnGroupOpened,
        setColumnGroupState: $437b23f6a393c3bf$var$setColumnGroupState
    }
};
// packages/ag-grid-community/src/rendering/cellRenderers/skeletonCellRenderer.ts
var $437b23f6a393c3bf$var$SkeletonCellRendererElement = {
    tag: "div",
    cls: "ag-skeleton-container"
};
var $437b23f6a393c3bf$var$SkeletonCellRenderer = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$SkeletonCellRendererElement);
    }
    init(params) {
        const id = `ag-cell-skeleton-renderer-${this.getCompId()}`;
        this.getGui().setAttribute("id", id);
        this.addDestroyFunc(()=>$437b23f6a393c3bf$export$84233c40c4c74001(params.eParentOfValue));
        $437b23f6a393c3bf$export$84233c40c4c74001(params.eParentOfValue, id);
        if (params.deferRender) this.setupLoading(params);
        else params.node.failedLoad ? this.setupFailed() : this.setupLoading(params);
    }
    setupFailed() {
        const localeTextFunc = this.getLocaleTextFunc();
        this.getGui().textContent = localeTextFunc("loadingError", "ERR");
        const ariaFailed = localeTextFunc("ariaSkeletonCellLoadingFailed", "Row failed to load");
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.getGui(), ariaFailed);
    }
    setupLoading(params) {
        const skeletonEffect = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-skeleton-effect"
        });
        const rowIndex = params.node.rowIndex;
        if (rowIndex != null) {
            const width = 75 + 25 * (rowIndex % 2 === 0 ? Math.sin(rowIndex) : Math.cos(rowIndex));
            skeletonEffect.style.width = `${width}%`;
        }
        this.getGui().appendChild(skeletonEffect);
        const localeTextFunc = this.getLocaleTextFunc();
        const ariaLoading = params.deferRender ? localeTextFunc("ariaDeferSkeletonCellLoading", "Cell is loading") : localeTextFunc("ariaSkeletonCellLoading", "Row data is loading");
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.getGui(), ariaLoading);
    }
    refresh(_params) {
        return false;
    }
};
// packages/ag-grid-community/src/rendering/cellRenderers/cellRendererModule.ts
var $437b23f6a393c3bf$var$CheckboxCellRendererModule = {
    moduleName: "CheckboxCellRenderer",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agCheckboxCellRenderer: $437b23f6a393c3bf$var$CheckboxCellRenderer
    }
};
var $437b23f6a393c3bf$var$SkeletonCellRendererModule = {
    moduleName: "SkeletonCellRenderer",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agSkeletonCellRenderer: $437b23f6a393c3bf$var$SkeletonCellRenderer
    }
};
// packages/ag-grid-community/src/columns/columnApi.ts
function $437b23f6a393c3bf$var$getColumnDef(beans, key) {
    const column = beans.colModel.getColDefCol(key);
    if (column) return column.getColDef();
    return null;
}
function $437b23f6a393c3bf$var$getColumnDefs(beans) {
    return beans.colModel.getColumnDefs();
}
function $437b23f6a393c3bf$var$getDisplayNameForColumn(beans, column, location) {
    return beans.colNames.getDisplayNameForColumn(column, location) || "";
}
function $437b23f6a393c3bf$var$getColumn(beans, key) {
    return beans.colModel.getColDefCol(key);
}
function $437b23f6a393c3bf$var$getColumns(beans) {
    return beans.colModel.getColDefCols();
}
function $437b23f6a393c3bf$var$applyColumnState(beans, params) {
    return $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, params, "api");
}
function $437b23f6a393c3bf$var$getColumnState(beans) {
    return $437b23f6a393c3bf$export$e7d9af1fb362df7b(beans);
}
function $437b23f6a393c3bf$var$resetColumnState(beans) {
    $437b23f6a393c3bf$export$96a6cbc000255060(beans, "api");
}
function $437b23f6a393c3bf$var$isPinning(beans) {
    return beans.visibleCols.isPinningLeft() || beans.visibleCols.isPinningRight();
}
function $437b23f6a393c3bf$var$isPinningLeft(beans) {
    return beans.visibleCols.isPinningLeft();
}
function $437b23f6a393c3bf$var$isPinningRight(beans) {
    return beans.visibleCols.isPinningRight();
}
function $437b23f6a393c3bf$var$getDisplayedColAfter(beans, col) {
    return beans.visibleCols.getColAfter(col);
}
function $437b23f6a393c3bf$var$getDisplayedColBefore(beans, col) {
    return beans.visibleCols.getColBefore(col);
}
function $437b23f6a393c3bf$var$setColumnsVisible(beans, keys, visible) {
    beans.colModel.setColsVisible(keys, visible, "api");
}
function $437b23f6a393c3bf$var$setColumnsPinned(beans, keys, pinned) {
    beans.pinnedCols?.setColsPinned(keys, pinned, "api");
}
function $437b23f6a393c3bf$var$getAllGridColumns(beans) {
    return beans.colModel.getCols();
}
function $437b23f6a393c3bf$var$getDisplayedLeftColumns(beans) {
    return beans.visibleCols.leftCols;
}
function $437b23f6a393c3bf$var$getDisplayedCenterColumns(beans) {
    return beans.visibleCols.centerCols;
}
function $437b23f6a393c3bf$var$getDisplayedRightColumns(beans) {
    return beans.visibleCols.rightCols;
}
function $437b23f6a393c3bf$var$getAllDisplayedColumns(beans) {
    return beans.visibleCols.allCols;
}
function $437b23f6a393c3bf$var$getAllDisplayedVirtualColumns(beans) {
    return beans.colViewport.getViewportColumns();
}
// packages/ag-grid-community/src/columns/columnDefFactory.ts
function $437b23f6a393c3bf$var$_deepCloneDefinition(object, keysToSkip) {
    if (!object) return;
    const obj = object;
    const res = {};
    Object.keys(obj).forEach((key)=>{
        if (keysToSkip && keysToSkip.indexOf(key) >= 0 || $437b23f6a393c3bf$var$SKIP_JS_BUILTINS.has(key)) return;
        const value = obj[key];
        const sourceIsSimpleObject = typeof value === "object" && value !== null && value.constructor === Object;
        if (sourceIsSimpleObject) res[key] = $437b23f6a393c3bf$var$_deepCloneDefinition(value);
        else res[key] = value;
    });
    return res;
}
var $437b23f6a393c3bf$var$ColumnDefFactory = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colDefFactory";
    }
    wireBeans(beans) {
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
        this.pivotColsSvc = beans.pivotColsSvc;
    }
    getColumnDefs(colDefColsList, showingPivotResult, lastOrder, colsList) {
        const cols = colDefColsList.slice();
        if (showingPivotResult) cols.sort((a, b)=>lastOrder.indexOf(a) - lastOrder.indexOf(b));
        else if (lastOrder) cols.sort((a, b)=>colsList.indexOf(a) - colsList.indexOf(b));
        const rowGroupColumns = this.rowGroupColsSvc?.columns;
        const pivotColumns = this.pivotColsSvc?.columns;
        return this.buildColumnDefs(cols, rowGroupColumns, pivotColumns);
    }
    buildColumnDefs(cols, rowGroupColumns = [], pivotColumns = []) {
        const res = [];
        const colGroupDefs = {};
        cols.forEach((col)=>{
            const colDef = this.createDefFromColumn(col, rowGroupColumns, pivotColumns);
            let addToResult = true;
            let childDef = colDef;
            let pointer = col.getOriginalParent();
            let lastPointer = null;
            while(pointer){
                let parentDef = null;
                if (pointer.isPadding()) {
                    pointer = pointer.getOriginalParent();
                    continue;
                }
                const existingParentDef = colGroupDefs[pointer.getGroupId()];
                if (existingParentDef) {
                    existingParentDef.children.push(childDef);
                    addToResult = false;
                    break;
                }
                parentDef = this.createDefFromGroup(pointer);
                if (parentDef) {
                    parentDef.children = [
                        childDef
                    ];
                    colGroupDefs[parentDef.groupId] = parentDef;
                    childDef = parentDef;
                    pointer = pointer.getOriginalParent();
                }
                if (pointer != null && lastPointer === pointer) {
                    addToResult = false;
                    break;
                }
                lastPointer = pointer;
            }
            if (addToResult) res.push(childDef);
        });
        return res;
    }
    createDefFromGroup(group) {
        const defCloned = $437b23f6a393c3bf$var$_deepCloneDefinition(group.getColGroupDef(), [
            "children"
        ]);
        if (defCloned) defCloned.groupId = group.getGroupId();
        return defCloned;
    }
    createDefFromColumn(col, rowGroupColumns, pivotColumns) {
        const colDefCloned = $437b23f6a393c3bf$var$_deepCloneDefinition(col.getColDef());
        colDefCloned.colId = col.getColId();
        colDefCloned.width = col.getActualWidth();
        colDefCloned.rowGroup = col.isRowGroupActive();
        colDefCloned.rowGroupIndex = col.isRowGroupActive() ? rowGroupColumns.indexOf(col) : null;
        colDefCloned.pivot = col.isPivotActive();
        colDefCloned.pivotIndex = col.isPivotActive() ? pivotColumns.indexOf(col) : null;
        colDefCloned.aggFunc = col.isValueActive() ? col.getAggFunc() : null;
        colDefCloned.hide = col.isVisible() ? void 0 : true;
        colDefCloned.pinned = col.isPinned() ? col.getPinned() : null;
        colDefCloned.sort = col.getSort() ? col.getSort() : null;
        colDefCloned.sortIndex = col.getSortIndex() != null ? col.getSortIndex() : null;
        return colDefCloned;
    }
};
// packages/ag-grid-community/src/columns/columnFlexService.ts
var $437b23f6a393c3bf$var$ColumnFlexService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colFlex";
    }
    refreshFlexedColumns(params = {}) {
        const source = params.source ?? "flex";
        if (params.viewportWidth != null) this.flexViewportWidth = params.viewportWidth;
        const totalSpace = this.flexViewportWidth;
        if (!totalSpace) return [];
        const { visibleCols: visibleCols } = this.beans;
        const visibleCenterCols = visibleCols.centerCols;
        let flexAfterDisplayIndex = -1;
        if (params.resizingCols) {
            const allResizingCols = new Set(params.resizingCols);
            for(let i = visibleCenterCols.length - 1; i >= 0; i--)if (allResizingCols.has(visibleCenterCols[i])) {
                flexAfterDisplayIndex = i;
                break;
            }
        }
        let hasFlexItems = false;
        const items = visibleCenterCols.map((col, i)=>{
            const flex = col.getFlex();
            const isFlex = flex != null && flex > 0 && i > flexAfterDisplayIndex;
            hasFlexItems || (hasFlexItems = isFlex);
            return {
                col: col,
                isFlex: isFlex,
                flex: Math.max(0, flex ?? 0),
                initialSize: col.getActualWidth(),
                min: col.getMinWidth(),
                max: col.getMaxWidth(),
                targetSize: 0
            };
        });
        if (!hasFlexItems) return [];
        let unfrozenItemCount = items.length;
        let unfrozenFlex = items.reduce((acc, item)=>acc + item.flex, 0);
        let unfrozenSpace = totalSpace;
        const freeze = (item, width)=>{
            item.frozenSize = width;
            item.col.setActualWidth(width, source);
            unfrozenSpace -= width;
            unfrozenFlex -= item.flex;
            unfrozenItemCount -= 1;
        };
        const isFrozen = (item)=>item.frozenSize != null;
        for (const item of items)if (!item.isFlex) freeze(item, item.initialSize);
        while(unfrozenItemCount > 0){
            const spaceToFill = Math.round(unfrozenFlex < 1 ? unfrozenSpace * unfrozenFlex : unfrozenSpace);
            let lastUnfrozenItem;
            let actualLeft = 0;
            let idealRight = 0;
            for (const item of items){
                if (isFrozen(item)) continue;
                lastUnfrozenItem = item;
                idealRight += spaceToFill * (item.flex / unfrozenFlex);
                const idealSize = idealRight - actualLeft;
                const roundedSize = Math.round(idealSize);
                item.targetSize = roundedSize;
                actualLeft += roundedSize;
            }
            if (lastUnfrozenItem) lastUnfrozenItem.targetSize += spaceToFill - actualLeft;
            let totalViolation = 0;
            for (const item of items){
                if (isFrozen(item)) continue;
                const unclampedSize = item.targetSize;
                const clampedSize = Math.min(Math.max(unclampedSize, item.min), item.max);
                totalViolation += clampedSize - unclampedSize;
                item.violationType = clampedSize === unclampedSize ? void 0 : clampedSize < unclampedSize ? "max" : "min";
                item.targetSize = clampedSize;
            }
            const freezeType = totalViolation === 0 ? "all" : totalViolation > 0 ? "min" : "max";
            for (const item of items){
                if (isFrozen(item)) continue;
                if (freezeType === "all" || item.violationType === freezeType) freeze(item, item.targetSize);
            }
        }
        if (!params.skipSetLeft) visibleCols.setLeftValues(source);
        if (params.updateBodyWidths) visibleCols.updateBodyWidths();
        const unconstrainedFlexColumns = items.filter((item)=>item.isFlex && !item.violationType).map((item)=>item.col);
        if (params.fireResizedEvent) {
            const changedColumns = items.filter((item)=>item.initialSize !== item.frozenSize).map((item)=>item.col);
            const flexingColumns = items.filter((item)=>item.flex).map((item)=>item.col);
            $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, changedColumns, true, source, flexingColumns);
        }
        return unconstrainedFlexColumns;
    }
    initCol(column) {
        const { flex: flex, initialFlex: initialFlex } = column.colDef;
        if (flex !== void 0) column.flex = flex;
        else if (initialFlex !== void 0) column.flex = initialFlex;
    }
    // this method should only be used by the colModel to
    // change flex when required by the applyColumnState method.
    setColFlex(column, flex) {
        column.flex = flex ?? null;
        column.dispatchStateUpdatedEvent("flex");
    }
};
// packages/ag-grid-community/src/columns/dataTypeService.ts
var $437b23f6a393c3bf$var$SORTED_CELL_DATA_TYPES_FOR_MATCHING = [
    "dateTimeString",
    "dateString",
    "text",
    "number",
    "boolean",
    "date"
];
var $437b23f6a393c3bf$var$DataTypeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "dataTypeSvc";
        this.dataTypeDefinitions = {};
        this.isPendingInference = false;
        this.isColumnTypeOverrideInDataTypeDefinitions = false;
        // keep track of any column state updates whilst waiting for data types to be inferred
        this.columnStateUpdatesPendingInference = {};
        this.columnStateUpdateListenerDestroyFuncs = [];
        // using an object here to enforce dev to not forget to implement new types as they are added
        this.columnDefinitionPropsPerDataType = {
            number () {
                return {
                    cellEditor: "agNumberCellEditor"
                };
            },
            boolean () {
                return {
                    cellEditor: "agCheckboxCellEditor",
                    cellRenderer: "agCheckboxCellRenderer",
                    getFindText: ()=>null,
                    suppressKeyboardEvent: (params)=>!!params.colDef.editable && params.event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE
                };
            },
            date ({ formatValue: formatValue }) {
                return {
                    cellEditor: "agDateCellEditor",
                    keyCreator: formatValue
                };
            },
            dateString ({ formatValue: formatValue }) {
                return {
                    cellEditor: "agDateStringCellEditor",
                    keyCreator: formatValue
                };
            },
            dateTime (args) {
                return this.date(args);
            },
            dateTimeString (args) {
                return this.dateString(args);
            },
            object ({ formatValue: formatValue, colModel: colModel, colId: colId }) {
                return {
                    cellEditorParams: {
                        useFormatter: true
                    },
                    comparator: (a, b)=>{
                        const column = colModel.getColDefCol(colId);
                        const colDef = column?.getColDef();
                        if (!column || !colDef) return 0;
                        const valA = a == null ? "" : formatValue({
                            column: column,
                            node: null,
                            value: a
                        });
                        const valB = b == null ? "" : formatValue({
                            column: column,
                            node: null,
                            value: b
                        });
                        if (valA === valB) return 0;
                        return valA > valB ? 1 : -1;
                    },
                    keyCreator: formatValue
                };
            },
            text () {
                return {};
            }
        };
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
    }
    postConstruct() {
        this.processDataTypeDefinitions();
        this.addManagedPropertyListener("dataTypeDefinitions", (event)=>{
            this.processDataTypeDefinitions();
            this.colModel.recreateColumnDefs(event);
        });
    }
    processDataTypeDefinitions() {
        const defaultDataTypes = this.getDefaultDataTypes();
        const newDataTypeDefinitions = {};
        const newFormatValueFuncs = {};
        const generateFormatValueFunc = (dataTypeDefinition)=>{
            return (params)=>{
                const { column: column, node: node, value: value } = params;
                let valueFormatter = column.getColDef().valueFormatter;
                if (valueFormatter === dataTypeDefinition.groupSafeValueFormatter) valueFormatter = dataTypeDefinition.valueFormatter;
                return this.beans.valueSvc.formatValue(column, node, value, valueFormatter);
            };
        };
        for (const cellDataType of Object.keys(defaultDataTypes)){
            const defaultDataTypeDef = defaultDataTypes[cellDataType];
            const mergedDataTypeDefinition = {
                ...defaultDataTypeDef,
                groupSafeValueFormatter: $437b23f6a393c3bf$var$createGroupSafeValueFormatter(defaultDataTypeDef, this.gos)
            };
            newDataTypeDefinitions[cellDataType] = mergedDataTypeDefinition;
            newFormatValueFuncs[cellDataType] = generateFormatValueFunc(mergedDataTypeDefinition);
        }
        const userDataTypeDefs = this.gos.get("dataTypeDefinitions") ?? {};
        const newDataTypeMatchers = {};
        for (const cellDataType of Object.keys(userDataTypeDefs)){
            const userDataTypeDef = userDataTypeDefs[cellDataType];
            const mergedDataTypeDefinition = this.processDataTypeDefinition(userDataTypeDef, userDataTypeDefs, [
                cellDataType
            ], defaultDataTypes);
            if (mergedDataTypeDefinition) {
                newDataTypeDefinitions[cellDataType] = mergedDataTypeDefinition;
                if (userDataTypeDef.dataTypeMatcher) newDataTypeMatchers[cellDataType] = userDataTypeDef.dataTypeMatcher;
                newFormatValueFuncs[cellDataType] = generateFormatValueFunc(mergedDataTypeDefinition);
            }
        }
        const { valueParser: defaultValueParser, valueFormatter: defaultValueFormatter } = defaultDataTypes.object;
        const { valueParser: userValueParser, valueFormatter: userValueFormatter } = newDataTypeDefinitions.object;
        this.hasObjectValueParser = userValueParser !== defaultValueParser;
        this.hasObjectValueFormatter = userValueFormatter !== defaultValueFormatter;
        this.formatValueFuncs = newFormatValueFuncs;
        this.dataTypeDefinitions = newDataTypeDefinitions;
        this.dataTypeMatchers = this.sortKeysInMatchers(newDataTypeMatchers, defaultDataTypes);
    }
    /**
   * Sorts the keys in the matchers object.
   * Does not mutate the original object, creates a copy of it with sorted keys instead.
   */ sortKeysInMatchers(matchers, dataTypes) {
        const sortedMatchers = {
            ...matchers
        };
        for (const cellDataType of $437b23f6a393c3bf$var$SORTED_CELL_DATA_TYPES_FOR_MATCHING){
            delete sortedMatchers[cellDataType];
            sortedMatchers[cellDataType] = matchers[cellDataType] ?? dataTypes[cellDataType].dataTypeMatcher;
        }
        return sortedMatchers;
    }
    processDataTypeDefinition(userDataTypeDef, userDataTypeDefs, alreadyProcessedDataTypes, defaultDataTypes) {
        let mergedDataTypeDefinition;
        const extendsCellDataType = userDataTypeDef.extendsDataType;
        if (userDataTypeDef.columnTypes) this.isColumnTypeOverrideInDataTypeDefinitions = true;
        if (userDataTypeDef.extendsDataType === userDataTypeDef.baseDataType) {
            let baseDataTypeDefinition = defaultDataTypes[extendsCellDataType];
            const overriddenBaseDataTypeDefinition = userDataTypeDefs[extendsCellDataType];
            if (baseDataTypeDefinition && overriddenBaseDataTypeDefinition) baseDataTypeDefinition = overriddenBaseDataTypeDefinition;
            if (!$437b23f6a393c3bf$var$validateDataTypeDefinition(userDataTypeDef, baseDataTypeDefinition, extendsCellDataType)) return void 0;
            mergedDataTypeDefinition = $437b23f6a393c3bf$var$mergeDataTypeDefinitions(baseDataTypeDefinition, userDataTypeDef);
        } else {
            if (alreadyProcessedDataTypes.includes(extendsCellDataType)) {
                $437b23f6a393c3bf$export$545083624300f13d(44);
                return void 0;
            }
            const extendedDataTypeDefinition = userDataTypeDefs[extendsCellDataType];
            if (!$437b23f6a393c3bf$var$validateDataTypeDefinition(userDataTypeDef, extendedDataTypeDefinition, extendsCellDataType)) return void 0;
            const mergedExtendedDataTypeDefinition = this.processDataTypeDefinition(extendedDataTypeDefinition, userDataTypeDefs, [
                ...alreadyProcessedDataTypes,
                extendsCellDataType
            ], defaultDataTypes);
            if (!mergedExtendedDataTypeDefinition) return void 0;
            mergedDataTypeDefinition = $437b23f6a393c3bf$var$mergeDataTypeDefinitions(mergedExtendedDataTypeDefinition, userDataTypeDef);
        }
        return {
            ...mergedDataTypeDefinition,
            groupSafeValueFormatter: $437b23f6a393c3bf$var$createGroupSafeValueFormatter(mergedDataTypeDefinition, this.gos)
        };
    }
    updateColDefAndGetColumnType(colDef, userColDef, colId) {
        let { cellDataType: cellDataType } = userColDef;
        const { field: field } = userColDef;
        if (cellDataType === void 0) cellDataType = colDef.cellDataType;
        if (cellDataType == null || cellDataType === true) cellDataType = this.canInferCellDataType(colDef, userColDef) ? this.inferCellDataType(field, colId) : false;
        if (!cellDataType) {
            colDef.cellDataType = false;
            return void 0;
        }
        const dataTypeDefinition = this.dataTypeDefinitions[cellDataType];
        if (!dataTypeDefinition) {
            $437b23f6a393c3bf$export$545083624300f13d(47, {
                cellDataType: cellDataType
            });
            return void 0;
        }
        colDef.cellDataType = cellDataType;
        if (dataTypeDefinition.groupSafeValueFormatter) colDef.valueFormatter = dataTypeDefinition.groupSafeValueFormatter;
        if (dataTypeDefinition.valueParser) colDef.valueParser = dataTypeDefinition.valueParser;
        if (!dataTypeDefinition.suppressDefaultProperties) this.setColDefPropertiesForBaseDataType(colDef, cellDataType, dataTypeDefinition, colId);
        return dataTypeDefinition.columnTypes;
    }
    addColumnListeners(column) {
        if (!this.isPendingInference) return;
        const columnStateUpdates = this.columnStateUpdatesPendingInference[column.getColId()];
        if (!columnStateUpdates) return;
        const columnListener = (event)=>{
            columnStateUpdates.add(event.key);
        };
        column.__addEventListener("columnStateUpdated", columnListener);
        this.columnStateUpdateListenerDestroyFuncs.push(()=>column.__removeEventListener("columnStateUpdated", columnListener));
    }
    canInferCellDataType(colDef, userColDef) {
        const { gos: gos } = this;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos)) return false;
        const propsToCheckForInference = {
            cellRenderer: true,
            valueGetter: true,
            valueParser: true,
            refData: true
        };
        if ($437b23f6a393c3bf$var$doColDefPropsPreventInference(userColDef, propsToCheckForInference)) return false;
        const columnTypes = userColDef.type === null ? colDef.type : userColDef.type;
        if (columnTypes) {
            const columnTypeDefs = gos.get("columnTypes") ?? {};
            const hasPropsPreventingInference = $437b23f6a393c3bf$var$convertColumnTypes(columnTypes).some((columnType)=>{
                const columnTypeDef = columnTypeDefs[columnType.trim()];
                return columnTypeDef && $437b23f6a393c3bf$var$doColDefPropsPreventInference(columnTypeDef, propsToCheckForInference);
            });
            if (hasPropsPreventingInference) return false;
        }
        return !$437b23f6a393c3bf$var$doColDefPropsPreventInference(colDef, propsToCheckForInference);
    }
    inferCellDataType(field, colId) {
        if (!field) return void 0;
        let value;
        const initialData = this.getInitialData();
        if (initialData) {
            const fieldContainsDots = field.indexOf(".") >= 0 && !this.gos.get("suppressFieldDotNotation");
            value = $437b23f6a393c3bf$var$_getValueUsingField(initialData, field, fieldContainsDots);
        } else this.initWaitForRowData(colId);
        if (value == null) return void 0;
        const matchedType = Object.keys(this.dataTypeMatchers).find((_cellDataType)=>this.dataTypeMatchers[_cellDataType](value));
        return matchedType ?? "object";
    }
    getInitialData() {
        const rowData = this.gos.get("rowData");
        if (rowData?.length) return rowData[0];
        else if (this.initialData) return this.initialData;
        else {
            const rowNodes = this.beans.rowModel.rootNode?.allLeafChildren;
            if (rowNodes?.length) return rowNodes[0].data;
        }
        return null;
    }
    initWaitForRowData(colId) {
        this.columnStateUpdatesPendingInference[colId] = /* @__PURE__ */ new Set();
        if (this.isPendingInference) return;
        this.isPendingInference = true;
        const columnTypeOverridesExist = this.isColumnTypeOverrideInDataTypeDefinitions;
        const { colAutosize: colAutosize, eventSvc: eventSvc } = this.beans;
        if (columnTypeOverridesExist && colAutosize) colAutosize.shouldQueueResizeOperations = true;
        const [destroyFunc] = this.addManagedEventListeners({
            rowDataUpdateStarted: (event)=>{
                const { firstRowData: firstRowData } = event;
                if (!firstRowData) return;
                destroyFunc?.();
                this.isPendingInference = false;
                this.processColumnsPendingInference(firstRowData, columnTypeOverridesExist);
                this.columnStateUpdatesPendingInference = {};
                if (columnTypeOverridesExist) colAutosize?.processResizeOperations();
                eventSvc.dispatchEvent({
                    type: "dataTypesInferred"
                });
            }
        });
    }
    processColumnsPendingInference(firstRowData, columnTypeOverridesExist) {
        this.initialData = firstRowData;
        const state = [];
        this.destroyColumnStateUpdateListeners();
        const newRowGroupColumnStateWithoutIndex = {};
        const newPivotColumnStateWithoutIndex = {};
        for (const colId of Object.keys(this.columnStateUpdatesPendingInference)){
            const columnStateUpdates = this.columnStateUpdatesPendingInference[colId];
            const column = this.colModel.getCol(colId);
            if (!column) return;
            const oldColDef = column.getColDef();
            if (!this.resetColDefIntoCol(column, "cellDataTypeInferred")) return;
            const newColDef = column.getColDef();
            if (columnTypeOverridesExist && newColDef.type && newColDef.type !== oldColDef.type) {
                const updatedColumnState = $437b23f6a393c3bf$var$getUpdatedColumnState(column, columnStateUpdates);
                if (updatedColumnState.rowGroup && updatedColumnState.rowGroupIndex == null) newRowGroupColumnStateWithoutIndex[colId] = updatedColumnState;
                if (updatedColumnState.pivot && updatedColumnState.pivotIndex == null) newPivotColumnStateWithoutIndex[colId] = updatedColumnState;
                state.push(updatedColumnState);
            }
        }
        if (columnTypeOverridesExist) state.push(...this.generateColumnStateForRowGroupAndPivotIndexes(newRowGroupColumnStateWithoutIndex, newPivotColumnStateWithoutIndex));
        if (state.length) $437b23f6a393c3bf$export$b2854c1cb8f10386(this.beans, {
            state: state
        }, "cellDataTypeInferred");
        this.initialData = null;
    }
    generateColumnStateForRowGroupAndPivotIndexes(updatedRowGroupColumnState, updatedPivotColumnState) {
        const existingColumnStateUpdates = {};
        const { rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc } = this.beans;
        rowGroupColsSvc?.restoreColumnOrder(existingColumnStateUpdates, updatedRowGroupColumnState);
        pivotColsSvc?.restoreColumnOrder(existingColumnStateUpdates, updatedPivotColumnState);
        return Object.values(existingColumnStateUpdates);
    }
    resetColDefIntoCol(column, source) {
        const userColDef = column.getUserProvidedColDef();
        if (!userColDef) return false;
        const newColDef = $437b23f6a393c3bf$export$310bdd432cb2279e(this.beans, userColDef, column.getColId());
        column.setColDef(newColDef, userColDef, source);
        return true;
    }
    getDateStringTypeDefinition(column) {
        const { dateString: dateString } = this.dataTypeDefinitions;
        if (!column) return dateString;
        return this.getDataTypeDefinition(column) ?? dateString;
    }
    getDateParserFunction(column) {
        return this.getDateStringTypeDefinition(column).dateParser;
    }
    getDateFormatterFunction(column) {
        return this.getDateStringTypeDefinition(column).dateFormatter;
    }
    getDateIncludesTimeFlag(cellDataType) {
        return cellDataType === "dateTime" || cellDataType === "dateTimeString";
    }
    getDataTypeDefinition(column) {
        const colDef = column.getColDef();
        if (!colDef.cellDataType) return void 0;
        return this.dataTypeDefinitions[colDef.cellDataType];
    }
    getBaseDataType(column) {
        return this.getDataTypeDefinition(column)?.baseDataType;
    }
    checkType(column, value) {
        if (value == null) return true;
        const dataTypeMatcher = this.getDataTypeDefinition(column)?.dataTypeMatcher;
        if (!dataTypeMatcher) return true;
        return dataTypeMatcher(value);
    }
    validateColDef(colDef) {
        const warning = (property)=>$437b23f6a393c3bf$export$545083624300f13d(48, {
                property: property
            });
        if (colDef.cellDataType === "object") {
            const { object: object } = this.dataTypeDefinitions;
            if (colDef.valueFormatter === object.groupSafeValueFormatter && !this.hasObjectValueFormatter) warning("Formatter");
            if (colDef.editable && colDef.valueParser === object.valueParser && !this.hasObjectValueParser) warning("Parser");
        }
    }
    postProcess(colDef) {
        const cellDataType = colDef.cellDataType;
        if (!cellDataType || typeof cellDataType !== "string") return;
        const { dataTypeDefinitions: dataTypeDefinitions, beans: beans, formatValueFuncs: formatValueFuncs } = this;
        const dataTypeDefinition = dataTypeDefinitions[cellDataType];
        beans.colFilter?.setColDefPropsForDataType(colDef, dataTypeDefinition, formatValueFuncs[cellDataType]);
    }
    // noinspection JSUnusedGlobalSymbols
    getFormatValue(cellDataType) {
        return this.formatValueFuncs[cellDataType];
    }
    isColPendingInference(colId) {
        return this.isPendingInference && !!this.columnStateUpdatesPendingInference[colId];
    }
    setColDefPropertiesForBaseDataType(colDef, cellDataType, dataTypeDefinition, colId) {
        const formatValue = this.formatValueFuncs[cellDataType];
        const partialColDef = this.columnDefinitionPropsPerDataType[dataTypeDefinition.baseDataType]({
            colDef: colDef,
            cellDataType: cellDataType,
            colModel: this.colModel,
            dataTypeDefinition: dataTypeDefinition,
            colId: colId,
            formatValue: formatValue
        });
        Object.assign(colDef, partialColDef);
    }
    getDateObjectTypeDef(baseDataType) {
        const translate = this.getLocaleTextFunc();
        const includeTime = this.getDateIncludesTimeFlag(baseDataType);
        return {
            baseDataType: baseDataType,
            valueParser: (params)=>$437b23f6a393c3bf$export$26ded2d88c01b527(params.newValue && String(params.newValue)),
            valueFormatter: (params)=>{
                if (params.value == null) return "";
                if (!(params.value instanceof Date) || isNaN(params.value.getTime())) return translate("invalidDate", "Invalid Date");
                return $437b23f6a393c3bf$export$3d7fedfb21962874(params.value, includeTime) ?? "";
            },
            dataTypeMatcher: (value)=>value instanceof Date
        };
    }
    getDateStringTypeDef(baseDataType) {
        const includeTime = this.getDateIncludesTimeFlag(baseDataType);
        return {
            baseDataType: baseDataType,
            dateParser: (value)=>$437b23f6a393c3bf$export$26ded2d88c01b527(value) ?? void 0,
            dateFormatter: (value)=>$437b23f6a393c3bf$export$3d7fedfb21962874(value ?? null, includeTime) ?? void 0,
            valueParser: (params)=>$437b23f6a393c3bf$var$_isValidDate(String(params.newValue)) ? params.newValue : null,
            valueFormatter: (params)=>$437b23f6a393c3bf$var$_isValidDate(String(params.value)) ? String(params.value) : "",
            dataTypeMatcher: (value)=>typeof value === "string" && $437b23f6a393c3bf$var$_isValidDate(value)
        };
    }
    getDefaultDataTypes() {
        const translate = this.getLocaleTextFunc();
        return {
            number: {
                baseDataType: "number",
                // can be empty space with legacy copy
                valueParser: (params)=>params.newValue?.trim?.() === "" ? null : Number(params.newValue),
                valueFormatter: (params)=>{
                    if (params.value == null) return "";
                    if (typeof params.value !== "number" || isNaN(params.value)) return translate("invalidNumber", "Invalid Number");
                    return String(params.value);
                },
                dataTypeMatcher: (value)=>typeof value === "number"
            },
            text: {
                baseDataType: "text",
                valueParser: (params)=>params.newValue === "" ? null : $437b23f6a393c3bf$export$2a74c29220d5c88e(params.newValue),
                dataTypeMatcher: (value)=>typeof value === "string"
            },
            boolean: {
                baseDataType: "boolean",
                valueParser: (params)=>{
                    if (params.newValue == null) return params.newValue;
                    return params.newValue?.trim?.() === "" ? null : String(params.newValue).toLowerCase() === "true";
                },
                valueFormatter: (params)=>params.value == null ? "" : String(params.value),
                dataTypeMatcher: (value)=>typeof value === "boolean"
            },
            date: this.getDateObjectTypeDef("date"),
            dateString: this.getDateStringTypeDef("dateString"),
            dateTime: this.getDateObjectTypeDef("dateTime"),
            dateTimeString: {
                ...this.getDateStringTypeDef("dateTimeString"),
                dataTypeMatcher: (value)=>typeof value === "string" && $437b23f6a393c3bf$var$_isValidDateTime(value)
            },
            object: {
                baseDataType: "object",
                valueParser: ()=>null,
                valueFormatter: (params)=>$437b23f6a393c3bf$export$2a74c29220d5c88e(params.value) ?? ""
            }
        };
    }
    destroyColumnStateUpdateListeners() {
        this.columnStateUpdateListenerDestroyFuncs.forEach((destroyFunc)=>destroyFunc());
        this.columnStateUpdateListenerDestroyFuncs = [];
    }
    destroy() {
        this.dataTypeDefinitions = {};
        this.dataTypeMatchers = {};
        this.formatValueFuncs = {};
        this.columnStateUpdatesPendingInference = {};
        this.destroyColumnStateUpdateListeners();
        super.destroy();
    }
};
function $437b23f6a393c3bf$var$mergeDataTypeDefinitions(parentDataTypeDefinition, childDataTypeDefinition) {
    const mergedDataTypeDefinition = {
        ...parentDataTypeDefinition,
        ...childDataTypeDefinition
    };
    if (parentDataTypeDefinition.columnTypes && childDataTypeDefinition.columnTypes && childDataTypeDefinition.appendColumnTypes) mergedDataTypeDefinition.columnTypes = [
        ...$437b23f6a393c3bf$var$convertColumnTypes(parentDataTypeDefinition.columnTypes),
        ...$437b23f6a393c3bf$var$convertColumnTypes(childDataTypeDefinition.columnTypes)
    ];
    return mergedDataTypeDefinition;
}
function $437b23f6a393c3bf$var$validateDataTypeDefinition(dataTypeDefinition, parentDataTypeDefinition, parentCellDataType) {
    if (!parentDataTypeDefinition) {
        $437b23f6a393c3bf$export$545083624300f13d(45, {
            parentCellDataType: parentCellDataType
        });
        return false;
    }
    if (parentDataTypeDefinition.baseDataType !== dataTypeDefinition.baseDataType) {
        $437b23f6a393c3bf$export$545083624300f13d(46);
        return false;
    }
    return true;
}
function $437b23f6a393c3bf$var$createGroupSafeValueFormatter(dataTypeDefinition, gos) {
    if (!dataTypeDefinition.valueFormatter) return void 0;
    return (params)=>{
        if (params.node?.group) {
            const aggFunc = (params.colDef.pivotValueColumn ?? params.column).getAggFunc();
            if (aggFunc) {
                if (aggFunc === "first" || aggFunc === "last") return dataTypeDefinition.valueFormatter(params);
                if (dataTypeDefinition.baseDataType === "number" && aggFunc !== "count") {
                    if (typeof params.value === "number") return dataTypeDefinition.valueFormatter(params);
                    if (typeof params.value === "object") {
                        if (!params.value) return void 0;
                        if ("toNumber" in params.value) return dataTypeDefinition.valueFormatter({
                            ...params,
                            value: params.value.toNumber()
                        });
                        if ("value" in params.value) return dataTypeDefinition.valueFormatter({
                            ...params,
                            value: params.value.value
                        });
                    }
                }
                return void 0;
            }
        } else if (gos.get("groupHideOpenParents") && params.column.isRowGroupActive()) {
            if (typeof params.value === "string" && !dataTypeDefinition.dataTypeMatcher?.(params.value)) return void 0;
        }
        return dataTypeDefinition.valueFormatter(params);
    };
}
function $437b23f6a393c3bf$var$doesColDefPropPreventInference(colDef, checkProps, prop, comparisonValue) {
    if (!checkProps[prop]) return false;
    const value = colDef[prop];
    if (value === null) {
        checkProps[prop] = false;
        return false;
    } else return comparisonValue === void 0 ? !!value : value === comparisonValue;
}
function $437b23f6a393c3bf$var$doColDefPropsPreventInference(colDef, propsToCheckForInference) {
    return [
        [
            "cellRenderer",
            "agSparklineCellRenderer"
        ],
        [
            "valueGetter",
            void 0
        ],
        [
            "valueParser",
            void 0
        ],
        [
            "refData",
            void 0
        ]
    ].some(([prop, comparisonValue])=>$437b23f6a393c3bf$var$doesColDefPropPreventInference(colDef, propsToCheckForInference, prop, comparisonValue));
}
function $437b23f6a393c3bf$var$getUpdatedColumnState(column, columnStateUpdates) {
    const columnState = $437b23f6a393c3bf$var$getColumnStateFromColDef(column);
    columnStateUpdates.forEach((key)=>{
        delete columnState[key];
        if (key === "rowGroup") delete columnState.rowGroupIndex;
        else if (key === "pivot") delete columnState.pivotIndex;
    });
    return columnState;
}
// packages/ag-grid-community/src/columns/columnModule.ts
var $437b23f6a393c3bf$var$DataTypeModule = {
    moduleName: "DataType",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$DataTypeService
    ],
    dependsOn: [
        $437b23f6a393c3bf$var$CheckboxCellRendererModule
    ]
};
var $437b23f6a393c3bf$var$ColumnFlexModule = {
    moduleName: "ColumnFlex",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnFlexService
    ]
};
var $437b23f6a393c3bf$export$5c4abee658e86c68 = {
    moduleName: "ColumnApi",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnDefFactory
    ],
    apiFunctions: {
        getColumnDef: $437b23f6a393c3bf$var$getColumnDef,
        getDisplayNameForColumn: $437b23f6a393c3bf$var$getDisplayNameForColumn,
        getColumn: $437b23f6a393c3bf$var$getColumn,
        getColumns: $437b23f6a393c3bf$var$getColumns,
        applyColumnState: $437b23f6a393c3bf$var$applyColumnState,
        getColumnState: $437b23f6a393c3bf$var$getColumnState,
        resetColumnState: $437b23f6a393c3bf$var$resetColumnState,
        isPinning: $437b23f6a393c3bf$var$isPinning,
        isPinningLeft: $437b23f6a393c3bf$var$isPinningLeft,
        isPinningRight: $437b23f6a393c3bf$var$isPinningRight,
        getDisplayedColAfter: $437b23f6a393c3bf$var$getDisplayedColAfter,
        getDisplayedColBefore: $437b23f6a393c3bf$var$getDisplayedColBefore,
        setColumnsVisible: $437b23f6a393c3bf$var$setColumnsVisible,
        setColumnsPinned: $437b23f6a393c3bf$var$setColumnsPinned,
        getAllGridColumns: $437b23f6a393c3bf$var$getAllGridColumns,
        getDisplayedLeftColumns: $437b23f6a393c3bf$var$getDisplayedLeftColumns,
        getDisplayedCenterColumns: $437b23f6a393c3bf$var$getDisplayedCenterColumns,
        getDisplayedRightColumns: $437b23f6a393c3bf$var$getDisplayedRightColumns,
        getAllDisplayedColumns: $437b23f6a393c3bf$var$getAllDisplayedColumns,
        getAllDisplayedVirtualColumns: $437b23f6a393c3bf$var$getAllDisplayedVirtualColumns,
        getColumnDefs: $437b23f6a393c3bf$var$getColumnDefs
    }
};
// packages/ag-grid-community/src/columns/columnNameService.ts
function $437b23f6a393c3bf$var$_camelCaseToHumanText(camelCase) {
    if (!camelCase || camelCase == null) return null;
    const rex = /([a-z])([A-Z])/g;
    const rexCaps = /([A-Z]+)([A-Z])([a-z])/g;
    const words = camelCase.replace(rex, "$1 $2").replace(rexCaps, "$1 $2$3").replace(/\./g, " ").split(" ");
    return words.map((word)=>word.substring(0, 1).toUpperCase() + (word.length > 1 ? word.substring(1, word.length) : "")).join(" ");
}
var $437b23f6a393c3bf$var$ColumnNameService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colNames";
    }
    getDisplayNameForColumn(column, location, includeAggFunc = false) {
        if (!column) return null;
        const headerName = this.getHeaderName(column.getColDef(), column, null, null, location);
        const { aggColNameSvc: aggColNameSvc } = this.beans;
        if (includeAggFunc && aggColNameSvc) return aggColNameSvc.getHeaderName(column, headerName);
        return headerName;
    }
    getDisplayNameForProvidedColumnGroup(columnGroup, providedColumnGroup, location) {
        const colGroupDef = providedColumnGroup?.getColGroupDef();
        if (colGroupDef) return this.getHeaderName(colGroupDef, null, columnGroup, providedColumnGroup, location);
        return null;
    }
    getDisplayNameForColumnGroup(columnGroup, location) {
        return this.getDisplayNameForProvidedColumnGroup(columnGroup, columnGroup.getProvidedColumnGroup(), location);
    }
    // location is where the column is going to appear, ie who is calling us
    getHeaderName(colDef, column, columnGroup, providedColumnGroup, location) {
        const headerValueGetter = colDef.headerValueGetter;
        if (headerValueGetter) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                colDef: colDef,
                column: column,
                columnGroup: columnGroup,
                providedColumnGroup: providedColumnGroup,
                location: location
            });
            if (typeof headerValueGetter === "function") return headerValueGetter(params);
            else if (typeof headerValueGetter === "string") return this.beans.expressionSvc?.evaluate(headerValueGetter, params) ?? null;
            return "";
        } else if (colDef.headerName != null) return colDef.headerName;
        else if (colDef.field) return $437b23f6a393c3bf$var$_camelCaseToHumanText(colDef.field);
        return "";
    }
};
// packages/ag-grid-community/src/columns/columnViewportService.ts
var $437b23f6a393c3bf$var$ColumnViewportService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colViewport";
        // cols in center that are in the viewport
        this.colsWithinViewport = [];
        // same as colsWithinViewport, except we always include columns with headerAutoHeight
        this.headerColsWithinViewport = [];
        // A hash key to keep track of changes in viewport columns
        this.colsWithinViewportHash = "";
        // all columns & groups to be rendered, index by row.
        // used by header rows to get all items to render for that row.
        this.rowsOfHeadersToRenderLeft = {};
        this.rowsOfHeadersToRenderRight = {};
        this.rowsOfHeadersToRenderCenter = {};
        this.columnsToRenderLeft = [];
        this.columnsToRenderRight = [];
        this.columnsToRenderCenter = [];
    }
    wireBeans(beans) {
        this.visibleCols = beans.visibleCols;
        this.colModel = beans.colModel;
    }
    postConstruct() {
        this.suppressColumnVirtualisation = this.gos.get("suppressColumnVirtualisation");
    }
    setScrollPosition(scrollWidth, scrollPosition, afterScroll = false) {
        const { visibleCols: visibleCols } = this;
        const bodyWidthDirty = visibleCols.isBodyWidthDirty;
        const noChange = scrollWidth === this.scrollWidth && scrollPosition === this.scrollPosition && !bodyWidthDirty;
        if (noChange) return;
        this.scrollWidth = scrollWidth;
        this.scrollPosition = scrollPosition;
        visibleCols.isBodyWidthDirty = true;
        if (this.gos.get("enableRtl")) {
            const bodyWidth = visibleCols.bodyWidth;
            this.viewportLeft = bodyWidth - scrollPosition - scrollWidth;
            this.viewportRight = bodyWidth - scrollPosition;
        } else {
            this.viewportLeft = scrollPosition;
            this.viewportRight = scrollWidth + scrollPosition;
        }
        if (this.colModel.ready) this.checkViewportColumns(afterScroll);
    }
    /**
   * Returns the columns that are currently rendered in the viewport.
   */ getColumnHeadersToRender(type) {
        switch(type){
            case "left":
                return this.columnsToRenderLeft;
            case "right":
                return this.columnsToRenderRight;
            default:
                return this.columnsToRenderCenter;
        }
    }
    /**
   * Returns the column groups that are currently rendered in the viewport at a specific header row index.
   */ getHeadersToRender(type, depth) {
        let result;
        switch(type){
            case "left":
                result = this.rowsOfHeadersToRenderLeft[depth];
                break;
            case "right":
                result = this.rowsOfHeadersToRenderRight[depth];
                break;
            default:
                result = this.rowsOfHeadersToRenderCenter[depth];
                break;
        }
        return result ?? [];
    }
    extractViewportColumns() {
        const displayedColumnsCenter = this.visibleCols.centerCols;
        if (this.isColumnVirtualisationSuppressed()) {
            this.colsWithinViewport = displayedColumnsCenter;
            this.headerColsWithinViewport = displayedColumnsCenter;
        } else {
            this.colsWithinViewport = displayedColumnsCenter.filter(this.isColumnInRowViewport.bind(this));
            this.headerColsWithinViewport = displayedColumnsCenter.filter(this.isColumnInHeaderViewport.bind(this));
        }
    }
    isColumnVirtualisationSuppressed() {
        return this.suppressColumnVirtualisation || this.viewportRight === 0;
    }
    clear() {
        this.rowsOfHeadersToRenderLeft = {};
        this.rowsOfHeadersToRenderRight = {};
        this.rowsOfHeadersToRenderCenter = {};
        this.colsWithinViewportHash = "";
    }
    isColumnInHeaderViewport(col) {
        if (col.isAutoHeaderHeight() || $437b23f6a393c3bf$var$isAnyParentAutoHeaderHeight(col)) return true;
        return this.isColumnInRowViewport(col);
    }
    isColumnInRowViewport(col) {
        if (col.isAutoHeight()) return true;
        const columnLeft = col.getLeft() || 0;
        const columnRight = columnLeft + col.getActualWidth();
        const leftBounds = this.viewportLeft - 200;
        const rightBounds = this.viewportRight + 200;
        const columnToMuchLeft = columnLeft < leftBounds && columnRight < leftBounds;
        const columnToMuchRight = columnLeft > rightBounds && columnRight > rightBounds;
        return !columnToMuchLeft && !columnToMuchRight;
    }
    // used by Grid API only
    getViewportColumns() {
        const { leftCols: leftCols, rightCols: rightCols } = this.visibleCols;
        const res = this.colsWithinViewport.concat(leftCols).concat(rightCols);
        return res;
    }
    // + rowRenderer
    // if we are not column spanning, this just returns back the virtual centre columns,
    // however if we are column spanning, then different rows can have different virtual
    // columns, so we have to work out the list for each individual row.
    getColsWithinViewport(rowNode) {
        if (!this.colModel.colSpanActive) return this.colsWithinViewport;
        const emptySpaceBeforeColumn = (col)=>{
            const left = col.getLeft();
            return $437b23f6a393c3bf$export$25d27f17d3af40f7(left) && left > this.viewportLeft;
        };
        const inViewportCallback = this.isColumnVirtualisationSuppressed() ? void 0 : this.isColumnInRowViewport.bind(this);
        const { visibleCols: visibleCols } = this;
        const displayedColumnsCenter = visibleCols.centerCols;
        return visibleCols.getColsForRow(rowNode, displayedColumnsCenter, inViewportCallback, emptySpaceBeforeColumn);
    }
    // checks what columns are currently displayed due to column virtualisation. dispatches an event
    // if the list of columns has changed.
    // + setColumnWidth(), setViewportPosition(), setColumnDefs(), sizeColumnsToFit()
    checkViewportColumns(afterScroll = false) {
        const viewportColumnsChanged = this.extractViewport();
        if (viewportColumnsChanged) this.eventSvc.dispatchEvent({
            type: "virtualColumnsChanged",
            afterScroll: afterScroll
        });
    }
    calculateHeaderRows() {
        const { leftCols: leftCols, rightCols: rightCols } = this.visibleCols;
        this.columnsToRenderLeft = leftCols;
        this.columnsToRenderRight = rightCols;
        this.columnsToRenderCenter = this.colsWithinViewport;
        const workOutGroupsToRender = (cols)=>{
            const groupsToRenderSet = /* @__PURE__ */ new Set();
            const groupsToRender = {};
            for (const col of cols){
                let group = col.getParent();
                const skipFillers = col.isSpanHeaderHeight();
                while(group){
                    if (groupsToRenderSet.has(group)) break;
                    const skipFillerGroup = skipFillers && group.isPadding();
                    if (skipFillerGroup) {
                        group = group.getParent();
                        continue;
                    }
                    const level = group.getProvidedColumnGroup().getLevel();
                    groupsToRender[level] ?? (groupsToRender[level] = []);
                    groupsToRender[level].push(group);
                    groupsToRenderSet.add(group);
                    group = group.getParent();
                }
            }
            return groupsToRender;
        };
        this.rowsOfHeadersToRenderLeft = workOutGroupsToRender(leftCols);
        this.rowsOfHeadersToRenderRight = workOutGroupsToRender(rightCols);
        this.rowsOfHeadersToRenderCenter = workOutGroupsToRender(this.headerColsWithinViewport);
    }
    extractViewport() {
        const hashColumn = (c)=>`${c.getId()}-${c.getPinned() || "normal"}`;
        this.extractViewportColumns();
        const newHash = this.getViewportColumns().map(hashColumn).join("#");
        const changed = this.colsWithinViewportHash !== newHash;
        if (changed) {
            this.colsWithinViewportHash = newHash;
            this.calculateHeaderRows();
        }
        return changed;
    }
};
function $437b23f6a393c3bf$var$isAnyParentAutoHeaderHeight(col) {
    while(col){
        if (col.isAutoHeaderHeight()) return true;
        col = col.getParent();
    }
    return false;
}
// packages/ag-grid-community/src/components/framework/agComponentUtils.ts
var $437b23f6a393c3bf$var$AgComponentUtils = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "agCompUtils";
    }
    adaptFunction(type, jsCompFunc) {
        if (!type.cellRenderer) return null;
        class Adapter {
            refresh() {
                return false;
            }
            getGui() {
                return this.eGui;
            }
            init(params) {
                const callbackResult = jsCompFunc(params);
                const type2 = typeof callbackResult;
                if (type2 === "string" || type2 === "number" || type2 === "boolean") {
                    this.eGui = $437b23f6a393c3bf$export$b1f57d075ca6d5fb("<span>" + callbackResult + "</span>");
                    return;
                }
                if (callbackResult == null) {
                    this.eGui = $437b23f6a393c3bf$export$a232bb0480ae674a({
                        tag: "span"
                    });
                    return;
                }
                this.eGui = callbackResult;
            }
        }
        return Adapter;
    }
};
// packages/ag-grid-community/src/components/framework/cellRendererFunctionModule.ts
var $437b23f6a393c3bf$var$CellRendererFunctionModule = {
    moduleName: "CellRendererFunction",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AgComponentUtils
    ]
};
// packages/ag-grid-community/src/components/framework/registry.ts
var $437b23f6a393c3bf$var$Registry = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "registry";
        this.agGridDefaults = {};
        this.agGridDefaultOverrides = {};
        this.jsComps = {};
        this.selectors = {};
        this.icons = {};
    }
    postConstruct() {
        const comps = this.gos.get("components");
        if (comps != null) for (const key of Object.keys(comps))this.jsComps[key] = comps[key];
    }
    registerModule(module) {
        const { icons: icons, userComponents: userComponents, dynamicBeans: dynamicBeans, selectors: selectors } = module;
        if (userComponents) {
            const registerUserComponent = (name, component, params, processParams)=>{
                this.agGridDefaults[name] = component;
                if (params || processParams) this.agGridDefaultOverrides[name] = {
                    params: params,
                    processParams: processParams
                };
            };
            for (const name of Object.keys(userComponents)){
                let comp = userComponents[name];
                if ($437b23f6a393c3bf$var$isComponentMetaFunc(comp)) comp = comp.getComp(this.beans);
                if (typeof comp === "object") {
                    const { classImp: classImp, params: params, processParams: processParams } = comp;
                    registerUserComponent(name, classImp, params, processParams);
                } else registerUserComponent(name, comp);
            }
        }
        if (dynamicBeans) {
            this.dynamicBeans ?? (this.dynamicBeans = {});
            for (const name of Object.keys(dynamicBeans))this.dynamicBeans[name] = dynamicBeans[name];
        }
        selectors?.forEach((selector)=>{
            this.selectors[selector.selector] = selector;
        });
        if (icons) for (const name of Object.keys(icons))this.icons[name] = icons[name];
    }
    getUserComponent(propertyName, name) {
        const createResult = (component, componentFromFramework, params, processParams)=>({
                componentFromFramework: componentFromFramework,
                component: component,
                params: params,
                processParams: processParams
            });
        const { frameworkOverrides: frameworkOverrides } = this.beans;
        const registeredViaFrameworkComp = frameworkOverrides.frameworkComponent(name, this.gos.get("components"));
        if (registeredViaFrameworkComp != null) return createResult(registeredViaFrameworkComp, true);
        const jsComponent = this.jsComps[name];
        if (jsComponent) {
            const isFwkComp = frameworkOverrides.isFrameworkComponent(jsComponent);
            return createResult(jsComponent, isFwkComp);
        }
        const defaultComponent = this.agGridDefaults[name];
        if (defaultComponent) {
            const overrides = this.agGridDefaultOverrides[name];
            return createResult(defaultComponent, false, overrides?.params, overrides?.processParams);
        }
        this.beans.validation?.missingUserComponent(propertyName, name, this.agGridDefaults, this.jsComps);
        return null;
    }
    createDynamicBean(name, mandatory, ...args) {
        if (!this.dynamicBeans) throw new Error($437b23f6a393c3bf$export$680bb5102fca525e(279, {
            name: name
        }));
        const BeanClass = this.dynamicBeans[name];
        if (BeanClass == null) {
            if (mandatory) throw new Error(this.beans.validation?.missingDynamicBean(name) ?? $437b23f6a393c3bf$export$680bb5102fca525e(256));
            return void 0;
        }
        return new BeanClass(...args);
    }
    getSelector(name) {
        return this.selectors[name];
    }
    getIcon(name) {
        return this.icons[name];
    }
};
// packages/ag-grid-community/src/ctrlsService.ts
var $437b23f6a393c3bf$var$NUM_CTRLS = 23;
var $437b23f6a393c3bf$var$CtrlsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "ctrlsSvc";
        this.params = {};
        this.ready = false;
        this.readyCallbacks = [];
    }
    postConstruct() {
        this.addEventListener("ready", ()=>{
            this.updateReady();
            if (this.ready) {
                this.readyCallbacks.forEach((c)=>c(this.params));
                this.readyCallbacks.length = 0;
            }
        }, this.beans.frameworkOverrides.runWhenReadyAsync?.() ?? false);
    }
    updateReady() {
        const values = Object.values(this.params);
        this.ready = values.length === $437b23f6a393c3bf$var$NUM_CTRLS && values.every((ctrl)=>{
            return ctrl?.isAlive() ?? false;
        });
    }
    whenReady(caller, callback) {
        if (this.ready) callback(this.params);
        else this.readyCallbacks.push(callback);
        caller.addDestroyFunc(()=>{
            const index = this.readyCallbacks.indexOf(callback);
            if (index >= 0) this.readyCallbacks.splice(index, 1);
        });
    }
    register(ctrlType, ctrl) {
        this.params[ctrlType] = ctrl;
        this.updateReady();
        if (this.ready) this.dispatchLocalEvent({
            type: "ready"
        });
        ctrl.addDestroyFunc(()=>{
            this.updateReady();
        });
    }
    get(ctrlType) {
        return this.params[ctrlType];
    }
    getGridBodyCtrl() {
        return this.params.gridBodyCtrl;
    }
    getHeaderRowContainerCtrls() {
        const { leftHeader: leftHeader, centerHeader: centerHeader, rightHeader: rightHeader } = this.params;
        return [
            leftHeader,
            rightHeader,
            centerHeader
        ];
    }
    getHeaderRowContainerCtrl(pinned) {
        const params = this.params;
        switch(pinned){
            case "left":
                return params.leftHeader;
            case "right":
                return params.rightHeader;
            default:
                return params.centerHeader;
        }
    }
    getScrollFeature() {
        return this.getGridBodyCtrl().scrollFeature;
    }
};
// packages/ag-grid-community/src/theming/core/core.css-GENERATED.ts
var $437b23f6a393c3bf$var$coreCSS = /*css*/ `:where(.ag-root-wrapper,.ag-popup,.ag-dnd-ghost,.ag-chart),:where(.ag-root-wrapper,.ag-popup,.ag-dnd-ghost,.ag-chart) :where([class^=ag-]){box-sizing:border-box;&:after,&:before{box-sizing:border-box}&:where(div,span,label):focus-visible{box-shadow:inset var(--ag-focus-shadow);outline:none;&:where(.invalid){box-shadow:inset var(--ag-focus-error-shadow)}}&:where(button){color:inherit}}:where(.ag-root-wrapper,.ag-popup,.ag-dnd-ghost,.ag-chart) :where([class^=ag-]) ::-ms-clear{display:none}.ag-aria-description-container{border:0;z-index:9999;clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}.ag-hidden{display:none!important}.ag-invisible{visibility:hidden!important}.ag-unselectable{-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-selectable{-webkit-user-select:text;-moz-user-select:text;user-select:text}.ag-tab-guard{display:block;height:0;position:absolute;width:0}:where(.ag-virtual-list-viewport) .ag-tab-guard{position:sticky}.ag-tab-guard-top{top:1px}.ag-tab-guard-bottom{bottom:1px}.ag-shake-left-to-right{animation-direction:alternate;animation-duration:.2s;animation-iteration-count:infinite;animation-name:ag-shake-left-to-right}@keyframes ag-shake-left-to-right{0%{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}.ag-body-horizontal-scroll-viewport,.ag-body-vertical-scroll-viewport,.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-sticky-bottom-viewport,.ag-sticky-top-viewport,.ag-virtual-list-viewport{flex:1 1 auto;height:100%;min-width:0;overflow:hidden;position:relative}.ag-viewport{position:relative}.ag-spanning-container{position:absolute;top:0;z-index:1}.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-sticky-bottom-viewport,.ag-sticky-top-viewport{overflow-x:auto;-ms-overflow-style:none!important;scrollbar-width:none!important;&::-webkit-scrollbar{display:none!important}}.ag-body-viewport{display:flex;overflow-x:hidden;&:where(.ag-layout-normal){overflow-y:auto;-webkit-overflow-scrolling:touch}}.ag-floating-bottom-container,.ag-floating-top-container,.ag-sticky-bottom-container,.ag-sticky-top-container{min-height:1px}.ag-center-cols-viewport{min-height:100%;width:100%}.ag-body-horizontal-scroll-viewport{overflow-x:scroll}.ag-body-vertical-scroll-viewport{overflow-y:scroll}.ag-virtual-list-viewport{overflow:auto;width:100%}.ag-body-container,.ag-body-horizontal-scroll-container,.ag-body-vertical-scroll-container,.ag-center-cols-container,.ag-floating-bottom-container,.ag-floating-bottom-full-width-container,.ag-floating-top-container,.ag-full-width-container,.ag-header-container,.ag-pinned-left-cols-container,.ag-pinned-right-cols-container,.ag-sticky-bottom-container,.ag-sticky-top-container,.ag-virtual-list-container{position:relative}.ag-floating-bottom-container,.ag-floating-top-container,.ag-header-container,.ag-pinned-left-floating-bottom,.ag-pinned-left-floating-top,.ag-pinned-right-floating-bottom,.ag-pinned-right-floating-top,.ag-sticky-bottom-container,.ag-sticky-top-container{height:100%;white-space:nowrap}.ag-center-cols-container,.ag-pinned-right-cols-container{display:block}.ag-body-horizontal-scroll-container{height:100%}.ag-body-vertical-scroll-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container,.ag-full-width-container,.ag-sticky-bottom-full-width-container,.ag-sticky-top-full-width-container{pointer-events:none;position:absolute;top:0}:where(.ag-ltr) .ag-floating-bottom-full-width-container,:where(.ag-ltr) .ag-floating-top-full-width-container,:where(.ag-ltr) .ag-full-width-container,:where(.ag-ltr) .ag-sticky-bottom-full-width-container,:where(.ag-ltr) .ag-sticky-top-full-width-container{left:0}:where(.ag-rtl) .ag-floating-bottom-full-width-container,:where(.ag-rtl) .ag-floating-top-full-width-container,:where(.ag-rtl) .ag-full-width-container,:where(.ag-rtl) .ag-sticky-bottom-full-width-container,:where(.ag-rtl) .ag-sticky-top-full-width-container{right:0}.ag-full-width-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container{display:inline-block;height:100%;overflow:hidden;width:100%}.ag-virtual-list-container{overflow:hidden}.ag-body{display:flex;flex:1 1 auto;flex-direction:row!important;min-height:0;position:relative}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{display:flex;min-height:0;min-width:0;position:relative;&:where(.ag-scrollbar-invisible){bottom:0;position:absolute;&:where(.ag-apple-scrollbar){opacity:0;transition:opacity .4s;visibility:hidden;&:where(.ag-scrollbar-scrolling,.ag-scrollbar-active){opacity:1;visibility:visible}}}}.ag-body-horizontal-scroll{width:100%;&:where(.ag-scrollbar-invisible){left:0;right:0}}.ag-body-vertical-scroll{height:100%;&:where(.ag-scrollbar-invisible){top:0;z-index:10}}:where(.ag-ltr) .ag-body-vertical-scroll{&:where(.ag-scrollbar-invisible){right:0}}:where(.ag-rtl) .ag-body-vertical-scroll{&:where(.ag-scrollbar-invisible){left:0}}.ag-force-vertical-scroll{overflow-y:scroll!important}.ag-horizontal-left-spacer,.ag-horizontal-right-spacer{height:100%;min-width:0;overflow-x:scroll;&:where(.ag-scroller-corner){overflow-x:hidden}}:where(.ag-row-animation) .ag-row{transition:transform .4s,top .4s,opacity .2s;&:where(.ag-after-created){transition:transform .4s,top .4s,height .4s,opacity .2s}}:where(.ag-row-animation.ag-prevent-animation) .ag-row{transition:none!important;&:where(.ag-row.ag-after-created){transition:none!important}}:where(.ag-row-no-animation) .ag-row{transition:none}.ag-row-loading{align-items:center;display:flex}.ag-row-position-absolute{position:absolute}.ag-row-position-relative{position:relative}.ag-full-width-row{overflow:hidden;pointer-events:all}.ag-row-inline-editing{z-index:1}.ag-row-dragging{z-index:2}.ag-stub-cell{align-items:center;display:flex}.ag-cell{display:inline-block;height:100%;position:absolute;white-space:nowrap;&:focus-visible{box-shadow:none}}.ag-cell-value{flex:1 1 auto}.ag-cell-value,.ag-group-value{overflow:hidden;text-overflow:ellipsis}.ag-cell-wrap-text{white-space:normal;word-break:break-word}:where(.ag-cell) .ag-icon{display:inline-block;vertical-align:middle}.ag-floating-top{display:flex;overflow:hidden;position:relative;white-space:nowrap;width:100%}:where(.ag-floating-top:not(.ag-invisible)){border-bottom:var(--ag-pinned-row-border)}.ag-floating-bottom{display:flex;overflow:hidden;position:relative;white-space:nowrap;width:100%}:where(.ag-floating-bottom:not(.ag-invisible)){border-top:var(--ag-pinned-row-border)}.ag-sticky-bottom,.ag-sticky-top{background-color:var(--ag-background-color);display:flex;height:0;overflow:hidden;position:absolute;width:100%;z-index:1}.ag-opacity-zero{opacity:0!important}.ag-cell-label-container{align-items:center;display:flex;flex-direction:row-reverse;height:100%;justify-content:space-between;width:100%}:where(.ag-right-aligned-header){.ag-cell-label-container{flex-direction:row}.ag-header-cell-text{text-align:end}}.ag-column-group-icons{display:block;>*{cursor:pointer}}:where(.ag-ltr){direction:ltr;.ag-body,.ag-body-horizontal-scroll,.ag-body-viewport,.ag-floating-bottom,.ag-floating-top,.ag-header,.ag-sticky-bottom,.ag-sticky-top{flex-direction:row}}:where(.ag-rtl){direction:rtl;text-align:right;.ag-body,.ag-body-horizontal-scroll,.ag-body-viewport,.ag-floating-bottom,.ag-floating-top,.ag-header,.ag-sticky-bottom,.ag-sticky-top{flex-direction:row-reverse}.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{display:block}}:where(.ag-rtl){.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{transform:rotate(180deg)}}:where(.ag-rtl){.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{transform:rotate(-180deg)}}.ag-measurement-container{height:0;overflow:hidden;visibility:hidden;width:0}.ag-measurement-element-border{display:inline-block;&:before{border-left:var(--ag-internal-measurement-border);content:"";display:block}}.ag-group{position:relative;width:100%}.ag-group-title-bar{align-items:center;display:flex;padding:var(--ag-spacing)}.ag-group-title{display:inline;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(.ag-group-title-bar) .ag-group-title{cursor:default}.ag-group-toolbar{align-items:center;display:flex;padding:var(--ag-spacing)}.ag-group-container{display:flex}.ag-disabled .ag-group-container{pointer-events:none}.ag-disabled-group-container,.ag-disabled-group-title-bar{opacity:.5}.ag-group-container-horizontal{flex-flow:row wrap}.ag-group-container-vertical{flex-direction:column}.ag-group-title-bar-icon{cursor:pointer;flex:none}:where(.ag-ltr) .ag-group-title-bar-icon{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-group-title-bar-icon{margin-left:var(--ag-spacing)}:where(.ag-group-item-alignment-stretch) .ag-group-item{align-items:stretch}:where(.ag-group-item-alignment-start) .ag-group-item{align-items:flex-start}:where(.ag-group-item-alignment-end) .ag-group-item{align-items:flex-end}.ag-popup-child{top:0;z-index:5;&:where(:not(.ag-tooltip-custom)){box-shadow:var(--ag-popup-shadow)}}.ag-popup-editor{position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-large-text-input{display:block}:where(.ag-ltr) .ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}:where(.ag-rtl) .ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}:where(.ag-ltr) .ag-row-group-leaf-indent{margin-left:calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size))}:where(.ag-rtl) .ag-row-group-leaf-indent{margin-right:calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size))}.ag-value-change-delta{padding:0 2px}.ag-value-change-delta-up{color:var(--ag-value-change-delta-up-color)}.ag-value-change-delta-down{color:var(--ag-value-change-delta-down-color)}.ag-value-change-value{background-color:transparent;border-radius:1px;padding-left:1px;padding-right:1px;transition:background-color 1s}.ag-value-change-value-highlight{background-color:var(--ag-value-change-value-highlight-background-color);transition:background-color .1s}.ag-cell-data-changed{background-color:var(--ag-value-change-value-highlight-background-color)!important}.ag-cell-data-changed-animation{background-color:transparent}.ag-cell-highlight{background-color:var(--ag-range-selection-highlight-color)!important}.ag-row,.ag-spanned-row{color:var(--ag-cell-text-color);font-family:var(--ag-cell-font-family);font-size:var(--ag-data-font-size);white-space:nowrap;--ag-internal-content-line-height:calc(min(var(--ag-row-height), var(--ag-line-height, 1000px)) - var(--ag-internal-row-border-width, 1px) - 2px)}.ag-row{background-color:var(--ag-background-color);border-bottom:var(--ag-row-border);height:var(--ag-row-height);width:100%;&.ag-row-editing-invalid{background-color:var(--ag-full-row-edit-invalid-background-color)}}:where(.ag-body-vertical-content-no-gap>div>div>div,.ag-body-vertical-content-no-gap>div>div>div>div)>.ag-row-last{border-bottom-color:transparent}.ag-sticky-bottom{border-top:var(--ag-row-border);box-sizing:content-box!important}.ag-group-contracted,.ag-group-expanded{cursor:pointer}.ag-cell,.ag-full-width-row .ag-cell-wrapper.ag-row-group{border:1px solid transparent;line-height:var(--ag-internal-content-line-height);-webkit-font-smoothing:subpixel-antialiased}:where(.ag-ltr) .ag-cell{border-right:var(--ag-column-border)}:where(.ag-rtl) .ag-cell{border-left:var(--ag-column-border)}.ag-spanned-cell-wrapper{background-color:var(--ag-background-color);position:absolute}.ag-spanned-cell-wrapper>.ag-spanned-cell{display:block;position:relative}:where(.ag-ltr) :where(.ag-body-horizontal-content-no-gap) .ag-column-last{border-right-color:transparent}:where(.ag-rtl) :where(.ag-body-horizontal-content-no-gap) .ag-column-last{border-left-color:transparent}.ag-cell-wrapper{align-items:center;display:flex;>:where(:not(.ag-cell-value,.ag-group-value)){align-items:center;display:flex;height:var(--ag-internal-content-line-height)}&:where(.ag-row-group){align-items:flex-start}:where(.ag-full-width-row) &:where(.ag-row-group){align-items:center;height:100%}}:where(.ag-ltr) .ag-cell-wrapper{padding-left:calc(var(--ag-indentation-level)*var(--ag-row-group-indent-size))}:where(.ag-rtl) .ag-cell-wrapper{padding-right:calc(var(--ag-indentation-level)*var(--ag-row-group-indent-size))}:where(.ag-cell-wrap-text:not(.ag-cell-auto-height)) .ag-cell-wrapper{align-items:normal;height:100%;:where(.ag-cell-value){height:100%}}:where(.ag-ltr) .ag-row>.ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}:where(.ag-rtl) .ag-row>.ag-cell-wrapper.ag-row-group{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}.ag-cell-focus:not(.ag-cell-range-selected):focus-within,.ag-cell-range-single-cell,.ag-cell-range-single-cell.ag-cell-range-handle,.ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.ag-context-menu-open .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,.ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group{border:1px solid;border-color:var(--ag-range-selection-border-color);border-style:var(--ag-range-selection-border-style);outline:initial}.ag-full-width-row.ag-row-focus:focus{box-shadow:none}:where(.ag-ltr) .ag-group-contracted,:where(.ag-ltr) .ag-group-expanded,:where(.ag-ltr) .ag-row-drag,:where(.ag-ltr) .ag-selection-checkbox{margin-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-group-contracted,:where(.ag-rtl) .ag-group-expanded,:where(.ag-rtl) .ag-row-drag,:where(.ag-rtl) .ag-selection-checkbox{margin-left:var(--ag-cell-widget-spacing)}:where(.ag-ltr) .ag-group-child-count{margin-left:3px}:where(.ag-rtl) .ag-group-child-count{margin-right:3px}.ag-row-highlight-above:after,.ag-row-highlight-below:after,.ag-row-highlight-inside:after{background-color:var(--ag-range-selection-border-color);content:"";height:1px;pointer-events:none;position:absolute;width:calc(100% - 1px)}:where(.ag-ltr) .ag-row-highlight-above:after,:where(.ag-ltr) .ag-row-highlight-below:after,:where(.ag-ltr) .ag-row-highlight-inside:after{left:1px}:where(.ag-rtl) .ag-row-highlight-above:after,:where(.ag-rtl) .ag-row-highlight-below:after,:where(.ag-rtl) .ag-row-highlight-inside:after{right:1px}.ag-row-highlight-above:after{top:0}.ag-row-highlight-below:after{bottom:0}.ag-row-highlight-indent:after{display:block;width:auto}:where(.ag-ltr) .ag-row-highlight-indent:after{left:calc((var(--ag-cell-widget-spacing) + var(--ag-icon-size))*2 + var(--ag-cell-horizontal-padding) + var(--ag-row-highlight-level)*var(--ag-row-group-indent-size));right:1px}:where(.ag-rtl) .ag-row-highlight-indent:after{left:1px;right:calc((var(--ag-cell-widget-spacing) + var(--ag-icon-size))*2 + var(--ag-cell-horizontal-padding) + var(--ag-row-highlight-level)*var(--ag-row-group-indent-size))}.ag-row-highlight-inside:after{background-color:var(--ag-selected-row-background-color);border:1px solid var(--ag-range-selection-border-color);display:block;height:auto;inset:0;width:auto}.ag-row-odd{background-color:var(--ag-odd-row-background-color)}.ag-row-selected:before{background-color:var(--ag-selected-row-background-color);content:"";display:block;inset:0;pointer-events:none;position:absolute}.ag-row-hover.ag-full-width-row.ag-row-group:before,.ag-row-hover:not(.ag-full-width-row):before{background-color:var(--ag-row-hover-color);content:"";display:block;inset:0;pointer-events:none;position:absolute}.ag-row-hover.ag-row-selected:before{background-color:var(--ag-row-hover-color);background-image:linear-gradient(var(--ag-selected-row-background-color),var(--ag-selected-row-background-color))}.ag-row.ag-full-width-row.ag-row-group>*{position:relative}.ag-column-hover{background-color:var(--ag-column-hover-color)}.ag-header-range-highlight{background-color:var(--ag-range-header-highlight-color)}.ag-right-aligned-cell{font-variant-numeric:tabular-nums}:where(.ag-ltr) .ag-right-aligned-cell{text-align:right}:where(.ag-rtl) .ag-right-aligned-cell{text-align:left}.ag-right-aligned-cell .ag-cell-value,.ag-right-aligned-cell .ag-group-value{margin-left:auto}:where(.ag-ltr) .ag-cell:not(.ag-cell-inline-editing),:where(.ag-ltr) .ag-full-width-row .ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size)*var(--ag-indentation-level));padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}:where(.ag-rtl) .ag-cell:not(.ag-cell-inline-editing),:where(.ag-rtl) .ag-full-width-row .ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}.ag-row>.ag-cell-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}.ag-row-dragging{cursor:move;opacity:.5}.ag-details-row{background-color:var(--ag-background-color);padding:calc(var(--ag-spacing)*3.75)}.ag-layout-auto-height,.ag-layout-print{.ag-center-cols-container,.ag-center-cols-viewport{min-height:150px}}.ag-overlay-loading-wrapper{background-color:var(--ag-modal-overlay-background-color)}.ag-skeleton-container{align-content:center;height:100%;width:100%}.ag-skeleton-effect{animation:ag-skeleton-loading 1.5s ease-in-out .5s infinite;background-color:var(--ag-row-loading-skeleton-effect-color);border-radius:.25rem;height:1em;width:100%}:where(.ag-ltr) .ag-right-aligned-cell .ag-skeleton-effect{margin-left:auto}:where(.ag-rtl) .ag-right-aligned-cell .ag-skeleton-effect{margin-right:auto}@keyframes ag-skeleton-loading{0%{background-color:var(--ag-row-loading-skeleton-effect-color)}50%{background-color:color-mix(in srgb,transparent,var(--ag-row-loading-skeleton-effect-color) 40%)}to{background-color:var(--ag-row-loading-skeleton-effect-color)}}.ag-loading{align-items:center;display:flex;height:100%}:where(.ag-ltr) .ag-loading{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-loading{padding-right:var(--ag-cell-horizontal-padding)}:where(.ag-ltr) .ag-loading-icon{padding-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-loading-icon{padding-left:var(--ag-cell-widget-spacing)}.ag-icon-loading{animation-duration:1s;animation-iteration-count:infinite;animation-name:spin;animation-timing-function:linear}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.ag-input-wrapper,.ag-picker-field-wrapper{align-items:center;display:flex;flex:1 1 auto;line-height:normal;position:relative}.ag-input-field{align-items:center;display:flex;flex-direction:row}.ag-input-field-input:where(:not([type=checkbox],[type=radio])){flex:1 1 auto;min-width:0;width:100%}.ag-header{background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);color:var(--ag-header-text-color);display:flex;font-family:var(--ag-header-font-family);font-size:var(--ag-header-font-size);font-weight:var(--ag-header-font-weight);overflow:hidden;white-space:nowrap;width:100%}.ag-header-row{height:var(--ag-header-height);position:absolute}.ag-floating-filter-button-button,.ag-header-cell-filter-button,.ag-header-cell-menu-button,.ag-header-expand-icon,.ag-panel-title-bar-button,:where(.ag-header-cell-sortable) .ag-header-cell-label{cursor:pointer}:where(.ag-ltr) .ag-header-expand-icon{margin-left:4px}:where(.ag-rtl) .ag-header-expand-icon{margin-right:4px}.ag-header-row:where(:not(:first-child)){:where(.ag-header-cell:not(.ag-header-span-height.ag-header-span-total,.ag-header-parent-hidden),.ag-header-group-cell.ag-header-group-cell-with-group){border-top:var(--ag-header-row-border)}}.ag-header-row:where(:not(.ag-header-row-column-group)){overflow:hidden}:where(.ag-header.ag-header-allow-overflow) .ag-header-row{overflow:visible}.ag-header-cell{display:inline-flex;overflow:hidden}.ag-header-group-cell{contain:paint;display:flex}.ag-header-cell,.ag-header-group-cell{align-items:center;gap:var(--ag-cell-widget-spacing);height:100%;padding:0 var(--ag-cell-horizontal-padding);position:absolute}@property --ag-internal-moving-color{syntax:"<color>";inherits:false;initial-value:transparent}@property --ag-internal-hover-color{syntax:"<color>";inherits:false;initial-value:transparent}.ag-header-cell:where(:not(.ag-floating-filter)),.ag-header-group-cell{&:before{background-image:linear-gradient(var(--ag-internal-hover-color),var(--ag-internal-hover-color)),linear-gradient(var(--ag-internal-moving-color),var(--ag-internal-moving-color));content:"";inset:0;position:absolute;--ag-internal-moving-color:transparent;--ag-internal-hover-color:transparent;transition:--ag-internal-moving-color var(--ag-header-cell-background-transition-duration),--ag-internal-hover-color var(--ag-header-cell-background-transition-duration)}&:where(:hover):before{--ag-internal-hover-color:var(--ag-header-cell-hover-background-color)}&:where(.ag-header-cell-moving):before{--ag-internal-moving-color:var(--ag-header-cell-moving-background-color);--ag-internal-hover-color:var(--ag-header-cell-hover-background-color)}}:where(.ag-header-cell:not(.ag-floating-filter) *,.ag-header-group-cell *){position:relative;z-index:1}.ag-header-cell-menu-button:where(:not(.ag-header-menu-always-show)){opacity:0;transition:opacity .2s}.ag-header-cell-filter-button,:where(.ag-header-cell.ag-header-active) .ag-header-cell-menu-button{opacity:1}.ag-header-cell-label,.ag-header-group-cell-label{align-items:center;align-self:stretch;display:flex;flex:1 1 auto;overflow:hidden;padding:5px 0}:where(.ag-ltr) .ag-sort-indicator-icon{padding-left:var(--ag-spacing)}:where(.ag-rtl) .ag-sort-indicator-icon{padding-right:var(--ag-spacing)}.ag-header-cell-label{text-overflow:ellipsis}.ag-header-group-cell-label.ag-sticky-label{flex:none;max-width:100%;overflow:visible;position:sticky}:where(.ag-ltr) .ag-header-group-cell-label.ag-sticky-label{left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-header-group-cell-label.ag-sticky-label{right:var(--ag-cell-horizontal-padding)}.ag-header-cell-text,.ag-header-group-text{overflow:hidden;text-overflow:ellipsis}.ag-header-cell-text{word-break:break-word}.ag-header-cell-comp-wrapper{width:100%}:where(.ag-header-group-cell) .ag-header-cell-comp-wrapper{display:flex}:where(.ag-header-cell:not(.ag-header-cell-auto-height)) .ag-header-cell-comp-wrapper{align-items:center;display:flex;height:100%}.ag-header-cell-wrap-text .ag-header-cell-comp-wrapper{white-space:normal}.ag-header-cell-comp-wrapper-limited-height>*{overflow:hidden}:where(.ag-right-aligned-header) .ag-header-cell-label{flex-direction:row-reverse}:where(.ag-ltr) :where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-label-icon,.ag-header-menu-icon{margin-left:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-label-icon,.ag-header-menu-icon{margin-right:var(--ag-spacing)}}:where(.ag-ltr) :where(.ag-header-cell.ag-right-aligned-header){.ag-header-label-icon,.ag-header-menu-icon{margin-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-header-cell.ag-right-aligned-header){.ag-header-label-icon,.ag-header-menu-icon{margin-left:var(--ag-spacing)}}.ag-header-cell:after,.ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{content:"";height:var(--ag-header-column-border-height);position:absolute;top:calc(50% - var(--ag-header-column-border-height)*.5);z-index:1}:where(.ag-ltr) .ag-header-cell:after,:where(.ag-ltr) .ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{border-right:var(--ag-header-column-border);right:0}:where(.ag-rtl) .ag-header-cell:after,:where(.ag-rtl) .ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{border-left:var(--ag-header-column-border);left:0}.ag-header-highlight-after:after,.ag-header-highlight-before:after{background-color:var(--ag-accent-color);content:"";height:100%;position:absolute;width:1px}:where(.ag-ltr) .ag-header-highlight-before:after{left:0}:where(.ag-rtl) .ag-header-highlight-before:after{right:0}:where(.ag-ltr) .ag-header-highlight-after:after{right:0;:where(.ag-pinned-left-header) &{right:1px}}:where(.ag-rtl) .ag-header-highlight-after:after{left:0;:where(.ag-pinned-left-header) &{left:1px}}.ag-header-cell-resize{align-items:center;cursor:ew-resize;display:flex;height:100%;position:absolute;top:0;width:8px;z-index:2;&:after{background-color:var(--ag-header-column-resize-handle-color);content:"";height:var(--ag-header-column-resize-handle-height);position:absolute;top:calc(50% - var(--ag-header-column-resize-handle-height)*.5);width:var(--ag-header-column-resize-handle-width);z-index:1}}:where(.ag-ltr) .ag-header-cell-resize{right:-3px;&:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}}:where(.ag-rtl) .ag-header-cell-resize{left:-3px;&:after{right:calc(50% - var(--ag-header-column-resize-handle-width))}}:where(.ag-header-cell.ag-header-span-height) .ag-header-cell-resize:after{height:calc(100% - var(--ag-spacing)*4);top:calc(var(--ag-spacing)*2)}.ag-header-group-cell-no-group:where(.ag-header-span-height){display:none}.ag-sort-indicator-container{display:flex;gap:var(--ag-spacing)}.ag-layout-print{&.ag-body{display:block;height:unset}&.ag-root-wrapper{display:inline-block}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{display:none}&.ag-force-vertical-scroll{overflow-y:visible!important}}@media print{.ag-root-wrapper.ag-layout-print{display:table;.ag-body-horizontal-scroll-viewport,.ag-body-viewport,.ag-center-cols-container,.ag-center-cols-viewport,.ag-root,.ag-root-wrapper-body,.ag-virtual-list-viewport{display:block!important;height:auto!important;overflow:hidden!important}.ag-cell,.ag-row{-moz-column-break-inside:avoid;break-inside:avoid}}}ag-grid,ag-grid-angular{display:block}.ag-chart,.ag-dnd-ghost,.ag-popup,.ag-root-wrapper{cursor:default;line-height:normal;white-space:normal;-webkit-font-smoothing:antialiased;background-color:var(--ag-background-color);color:var(--ag-text-color);color-scheme:var(--ag-browser-color-scheme);font-family:var(--ag-font-family);font-size:var(--ag-font-size);--ag-indentation-level:0}.ag-root-wrapper{border:var(--ag-wrapper-border);border-radius:var(--ag-wrapper-border-radius);display:flex;flex-direction:column;overflow:hidden;position:relative;&.ag-layout-normal{height:100%}}.ag-root-wrapper-body{display:flex;flex-direction:row;&.ag-layout-normal{flex:1 1 auto;height:0;min-height:0}}.ag-root{display:flex;flex-direction:column;position:relative;&.ag-layout-auto-height,&.ag-layout-normal{flex:1 1 auto;overflow:hidden;width:0}&.ag-layout-normal{height:100%}}.ag-list-item,.ag-virtual-list-item{height:var(--ag-list-item-height)}.ag-virtual-list-item{position:absolute;width:100%}.ag-select-list{background-color:var(--ag-picker-list-background-color);border:var(--ag-picker-list-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);overflow:hidden auto}.ag-list-item{align-items:center;display:flex;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;&.ag-active-item{background-color:var(--ag-row-hover-color)}}.ag-select-list-item{cursor:default;-webkit-user-select:none;-moz-user-select:none;user-select:none;:where(span){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}:where(.ag-ltr) .ag-select-list-item{padding-left:calc(var(--ag-cell-horizontal-padding)/2)}:where(.ag-rtl) .ag-select-list-item{padding-right:calc(var(--ag-cell-horizontal-padding)/2)}.ag-list-item-hovered:after{background-color:var(--ag-accent-color);content:"";height:1px;left:0;position:absolute;right:0}.ag-item-highlight-top:after{top:0}.ag-item-highlight-bottom:after{bottom:0}:where(.ag-icon):before{align-items:center;background-color:currentcolor;color:inherit;content:"";display:flex;font-family:inherit;font-size:var(--ag-icon-size);font-style:normal;font-variant:normal;height:var(--ag-icon-size);justify-content:center;line-height:var(--ag-icon-size);-webkit-mask-size:contain;mask-size:contain;text-transform:none;width:var(--ag-icon-size)}.ag-icon{background-position:50%;background-repeat:no-repeat;background-size:contain;color:var(--ag-icon-color);display:block;height:var(--ag-icon-size);position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:var(--ag-icon-size)}.ag-column-select-column-group-readonly,.ag-column-select-column-readonly,.ag-disabled,[disabled]{.ag-icon{opacity:.5}&.ag-icon-grip{opacity:.35}}.ag-column-select-column-readonly{&.ag-icon-grip,.ag-icon-grip{opacity:.35}}.ag-drag-handle{color:var(--ag-drag-handle-color);cursor:grab;:where(.ag-icon){color:var(--ag-drag-handle-color)}}.ag-chart-menu-icon,.ag-chart-settings-next,.ag-chart-settings-prev,.ag-column-group-icons,.ag-column-select-header-icon,.ag-filter-toolpanel-expand,.ag-floating-filter-button-button,.ag-group-title-bar-icon,.ag-header-cell-filter-button,.ag-header-cell-menu-button,.ag-header-expand-icon,.ag-panel-title-bar-button,.ag-panel-title-bar-button-icon,.ag-set-filter-group-icons,:where(.ag-group-contracted) .ag-icon,:where(.ag-group-expanded) .ag-icon{background-color:var(--ag-icon-button-background-color);border-radius:var(--ag-icon-button-border-radius);box-shadow:0 0 0 var(--ag-icon-button-background-spread) var(--ag-icon-button-background-color);color:var(--ag-icon-button-color);&:hover{background-color:var(--ag-icon-button-hover-background-color);box-shadow:0 0 0 var(--ag-icon-button-background-spread) var(--ag-icon-button-hover-background-color);color:var(--ag-icon-button-hover-color)}}.ag-filter-active{background-image:linear-gradient(var(--ag-icon-button-active-background-color),var(--ag-icon-button-active-background-color));border-radius:1px;outline:solid var(--ag-icon-button-background-spread) var(--ag-icon-button-active-background-color);position:relative;&:after{background-color:var(--ag-icon-button-active-indicator-color);border-radius:50%;content:"";height:6px;position:absolute;top:-1px;width:6px}:where(.ag-icon-filter){clip-path:path("M8,0C8,4.415 11.585,8 16,8L16,16L0,16L0,0L8,0Z");color:var(--ag-icon-button-active-color)}}:where(.ag-ltr) .ag-filter-active{&:after{right:-1px}}:where(.ag-rtl) .ag-filter-active{&:after{left:-1px}}.ag-menu{background-color:var(--ag-menu-background-color);border:var(--ag-menu-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-menu-shadow);color:var(--ag-menu-text-color);max-height:100%;overflow-y:auto}.ag-menu,.ag-resizer{position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-resizer{pointer-events:none;z-index:1}:where(.ag-resizer){&.ag-resizer-topLeft{cursor:nwse-resize;height:5px;left:0;top:0;width:5px}&.ag-resizer-top{cursor:ns-resize;height:5px;left:5px;right:5px;top:0}&.ag-resizer-topRight{cursor:nesw-resize;height:5px;right:0;top:0;width:5px}&.ag-resizer-right{bottom:5px;cursor:ew-resize;right:0;top:5px;width:5px}&.ag-resizer-bottomRight{bottom:0;cursor:nwse-resize;height:5px;right:0;width:5px}&.ag-resizer-bottom{bottom:0;cursor:ns-resize;height:5px;left:5px;right:5px}&.ag-resizer-bottomLeft{bottom:0;cursor:nesw-resize;height:5px;left:0;width:5px}&.ag-resizer-left{bottom:5px;cursor:ew-resize;left:0;top:5px;width:5px}}`;
// packages/ag-grid-community/src/theming/inject.ts
var $437b23f6a393c3bf$var$IS_SSR = typeof window !== "object" || !window?.document?.fonts?.forEach;
var $437b23f6a393c3bf$var$_injectGlobalCSS = (css, styleContainer, debugId, layer, priority, nonce)=>{
    if ($437b23f6a393c3bf$var$IS_SSR) return;
    if ($437b23f6a393c3bf$var$FORCE_LEGACY_THEMES) return;
    if (layer) css = `@layer ${CSS.escape(layer)} { ${css} }`;
    let injections = $437b23f6a393c3bf$var$injectionState.map.get(styleContainer);
    if (!injections) {
        injections = [];
        $437b23f6a393c3bf$var$injectionState.map.set(styleContainer, injections);
    }
    if (injections.find((i)=>i.css === css)) return;
    const el = document.createElement("style");
    if (nonce) el.setAttribute("nonce", nonce);
    el.dataset.agGlobalCss = debugId;
    el.textContent = css;
    const newInjection = {
        css: css,
        el: el,
        priority: priority
    };
    let insertAfter;
    for (const injection of injections){
        if (injection.priority > priority) break;
        insertAfter = injection;
    }
    if (insertAfter) {
        insertAfter.el.insertAdjacentElement("afterend", el);
        const index = injections.indexOf(insertAfter);
        injections.splice(index + 1, 0, newInjection);
    } else {
        styleContainer.insertBefore(el, styleContainer.querySelector(":not(title, meta)"));
        injections.push(newInjection);
    }
};
var $437b23f6a393c3bf$var$_injectCoreAndModuleCSS = (styleContainer, layer, nonce)=>{
    $437b23f6a393c3bf$var$_injectGlobalCSS($437b23f6a393c3bf$var$coreCSS, styleContainer, "core", layer, 0, nonce);
    Array.from($437b23f6a393c3bf$var$_getAllRegisteredModules()).sort((a, b)=>a.moduleName.localeCompare(b.moduleName)).forEach((module)=>module.css?.forEach((css)=>$437b23f6a393c3bf$var$_injectGlobalCSS(css, styleContainer, `module-${module.moduleName}`, layer, 0, nonce)));
};
var $437b23f6a393c3bf$var$_registerGridUsingThemingAPI = (environment)=>{
    $437b23f6a393c3bf$var$injectionState.grids.add(environment);
};
var $437b23f6a393c3bf$var$_unregisterGridUsingThemingAPI = (environment)=>{
    $437b23f6a393c3bf$var$injectionState.grids.delete(environment);
    if ($437b23f6a393c3bf$var$injectionState.grids.size === 0) {
        $437b23f6a393c3bf$var$injectionState.map = /* @__PURE__ */ new WeakMap();
        for (const style of document.head.querySelectorAll("style[data-ag-global-css]"))style.remove();
    }
};
var $437b23f6a393c3bf$var$_a;
var $437b23f6a393c3bf$var$injectionState = ($437b23f6a393c3bf$var$_a = typeof window === "object" ? window : {}).agStyleInjectionState ?? ($437b23f6a393c3bf$var$_a.agStyleInjectionState = {
    map: /* @__PURE__ */ new WeakMap(),
    grids: /* @__PURE__ */ new Set()
});
// packages/ag-grid-community/src/theming/Part.ts
var $437b23f6a393c3bf$export$6e6f0e372f4cb988 = (args)=>{
    return new $437b23f6a393c3bf$var$PartImpl(args);
};
var $437b23f6a393c3bf$var$defaultModeName = "$default";
var $437b23f6a393c3bf$var$partCounter = 0;
var $437b23f6a393c3bf$var$PartImpl = class {
    constructor({ feature: feature, params: params, modeParams: modeParams = {}, css: css, cssImports: cssImports }){
        this.feature = feature;
        this.css = css;
        this.cssImports = cssImports;
        this.modeParams = {
            // NOTE: it's important that default is defined first, putting it
            // first in iteration order, because when merging params the default
            // params override any prior modal params, so modal params in this
            // part need to come after default params to prevent them from being
            // immediately overridden.
            [$437b23f6a393c3bf$var$defaultModeName]: {
                ...modeParams[$437b23f6a393c3bf$var$defaultModeName] ?? {},
                ...params ?? {}
            },
            ...modeParams
        };
    }
    use(styleContainer, layer, nonce) {
        let inject = this._inject;
        if (inject == null) {
            let { css: css } = this;
            if (css) {
                const className = `ag-theme-${this.feature ?? "part"}-${++$437b23f6a393c3bf$var$partCounter}`;
                if (typeof css === "function") css = css();
                css = `:where(.${className}) {
${css}
}
`;
                for (const cssImport of this.cssImports ?? [])css = `@import url(${JSON.stringify(cssImport)});
${css}`;
                inject = {
                    css: css,
                    class: className
                };
            } else inject = false;
            this._inject = inject;
        }
        if (inject && styleContainer) $437b23f6a393c3bf$var$_injectGlobalCSS(inject.css, styleContainer, inject.class, layer, 1, nonce);
        return inject ? inject.class : false;
    }
};
// packages/ag-grid-community/src/theming/theme-utils.ts
var $437b23f6a393c3bf$var$kebabCase = (str)=>str.replace(/[A-Z]/g, (m)=>`-${m}`).toLowerCase();
var $437b23f6a393c3bf$var$paramToVariableName = (paramName)=>`--ag-${$437b23f6a393c3bf$var$kebabCase(paramName)}`;
var $437b23f6a393c3bf$var$paramToVariableExpression = (paramName)=>`var(${$437b23f6a393c3bf$var$paramToVariableName(paramName)})`;
var $437b23f6a393c3bf$var$clamp = (value, min, max)=>Math.max(min, Math.min(max, value));
var $437b23f6a393c3bf$var$memoize = (fn)=>{
    const values = /* @__PURE__ */ new Map();
    return (a)=>{
        const key = a;
        if (!values.has(key)) values.set(key, fn(a));
        return values.get(key);
    };
};
var $437b23f6a393c3bf$var$accentMix = (mix)=>({
        ref: "accentColor",
        mix: mix
    });
var $437b23f6a393c3bf$var$foregroundMix = (mix)=>({
        ref: "foregroundColor",
        mix: mix
    });
var $437b23f6a393c3bf$var$foregroundBackgroundMix = (mix)=>({
        ref: "foregroundColor",
        mix: mix,
        onto: "backgroundColor"
    });
var $437b23f6a393c3bf$var$foregroundHeaderBackgroundMix = (mix)=>({
        ref: "foregroundColor",
        mix: mix,
        onto: "headerBackgroundColor"
    });
var $437b23f6a393c3bf$var$backgroundColor = {
    ref: "backgroundColor"
};
var $437b23f6a393c3bf$var$foregroundColor = {
    ref: "foregroundColor"
};
var $437b23f6a393c3bf$var$accentColor = {
    ref: "accentColor"
};
// packages/ag-grid-community/src/theming/core/core-css.ts
var $437b23f6a393c3bf$var$defaultLightColorSchemeParams = {
    backgroundColor: "#fff",
    foregroundColor: "#181d1f",
    borderColor: $437b23f6a393c3bf$var$foregroundMix(0.15),
    chromeBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.02),
    browserColorScheme: "light"
};
var $437b23f6a393c3bf$var$coreDefaults = {
    ...$437b23f6a393c3bf$var$defaultLightColorSchemeParams,
    textColor: $437b23f6a393c3bf$var$foregroundColor,
    accentColor: "#2196f3",
    invalidColor: "#e02525",
    wrapperBorder: true,
    rowBorder: true,
    headerRowBorder: true,
    footerRowBorder: {
        ref: "rowBorder"
    },
    columnBorder: {
        style: "solid",
        width: 1,
        color: "transparent"
    },
    headerColumnBorder: false,
    headerColumnBorderHeight: "100%",
    pinnedColumnBorder: true,
    pinnedRowBorder: true,
    sidePanelBorder: true,
    sideBarPanelWidth: 250,
    sideBarBackgroundColor: {
        ref: "chromeBackgroundColor"
    },
    sideButtonBarBackgroundColor: {
        ref: "sideBarBackgroundColor"
    },
    sideButtonBarTopPadding: 0,
    sideButtonSelectedUnderlineWidth: 2,
    sideButtonSelectedUnderlineColor: "transparent",
    sideButtonSelectedUnderlineTransitionDuration: 0,
    sideButtonBackgroundColor: "transparent",
    sideButtonTextColor: {
        ref: "textColor"
    },
    sideButtonHoverBackgroundColor: {
        ref: "sideButtonBackgroundColor"
    },
    sideButtonHoverTextColor: {
        ref: "sideButtonTextColor"
    },
    sideButtonSelectedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    sideButtonSelectedTextColor: {
        ref: "sideButtonTextColor"
    },
    sideButtonBorder: "solid 1px transparent",
    sideButtonSelectedBorder: true,
    sideButtonLeftPadding: {
        ref: "spacing"
    },
    sideButtonRightPadding: {
        ref: "spacing"
    },
    sideButtonVerticalPadding: {
        calc: "spacing * 3"
    },
    fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Roboto",
        "Oxygen-Sans",
        "Ubuntu",
        "Cantarell",
        "Helvetica Neue",
        "sans-serif"
    ],
    headerBackgroundColor: {
        ref: "chromeBackgroundColor"
    },
    headerFontFamily: {
        ref: "fontFamily"
    },
    cellFontFamily: {
        ref: "fontFamily"
    },
    headerFontWeight: 500,
    headerFontSize: {
        ref: "fontSize"
    },
    dataFontSize: {
        ref: "fontSize"
    },
    headerTextColor: {
        ref: "textColor"
    },
    headerCellHoverBackgroundColor: "transparent",
    headerCellMovingBackgroundColor: {
        ref: "headerCellHoverBackgroundColor"
    },
    headerCellBackgroundTransitionDuration: "0.2s",
    cellTextColor: {
        ref: "textColor"
    },
    subtleTextColor: {
        ref: "textColor",
        mix: 0.5
    },
    rangeSelectionBorderStyle: "solid",
    rangeSelectionBorderColor: $437b23f6a393c3bf$var$accentColor,
    rangeSelectionBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.2),
    rangeSelectionChartBackgroundColor: "#0058FF1A",
    rangeSelectionChartCategoryBackgroundColor: "#00FF841A",
    rangeSelectionHighlightColor: $437b23f6a393c3bf$var$accentMix(0.5),
    rangeHeaderHighlightColor: $437b23f6a393c3bf$var$foregroundHeaderBackgroundMix(0.08),
    rowNumbersSelectedColor: $437b23f6a393c3bf$var$accentMix(0.5),
    rowHoverColor: $437b23f6a393c3bf$var$accentMix(0.08),
    columnHoverColor: $437b23f6a393c3bf$var$accentMix(0.05),
    selectedRowBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.12),
    modalOverlayBackgroundColor: {
        ref: "backgroundColor",
        mix: 0.66
    },
    oddRowBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    borderWidth: 1,
    borderRadius: 4,
    wrapperBorderRadius: 8,
    cellHorizontalPadding: {
        calc: "spacing * 2 * cellHorizontalPaddingScale"
    },
    cellWidgetSpacing: {
        calc: "spacing * 1.5"
    },
    cellHorizontalPaddingScale: 1,
    rowGroupIndentSize: {
        calc: "cellWidgetSpacing + iconSize"
    },
    valueChangeDeltaUpColor: "#43a047",
    valueChangeDeltaDownColor: "#e53935",
    valueChangeValueHighlightBackgroundColor: "#16a08580",
    spacing: 8,
    fontSize: 14,
    rowHeight: {
        calc: "max(iconSize, dataFontSize) + spacing * 3.25 * rowVerticalPaddingScale"
    },
    rowVerticalPaddingScale: 1,
    headerHeight: {
        calc: "max(iconSize, dataFontSize) + spacing * 4 * headerVerticalPaddingScale"
    },
    headerVerticalPaddingScale: 1,
    paginationPanelHeight: {
        ref: "rowHeight",
        calc: "max(rowHeight, 22px)"
    },
    popupShadow: "0 0 16px #00000026",
    cardShadow: "0 1px 4px 1px #00000018",
    dropdownShadow: {
        ref: "cardShadow"
    },
    dragAndDropImageBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    dragAndDropImageBorder: true,
    dragAndDropImageShadow: {
        ref: "popupShadow"
    },
    dragHandleColor: $437b23f6a393c3bf$var$foregroundMix(0.7),
    focusShadow: {
        spread: 3,
        color: $437b23f6a393c3bf$var$accentMix(0.5)
    },
    focusErrorShadow: {
        spread: 3,
        color: {
            ref: "invalidColor",
            onto: "backgroundColor",
            mix: 0.5
        }
    },
    headerColumnResizeHandleHeight: "30%",
    headerColumnResizeHandleWidth: 2,
    headerColumnResizeHandleColor: {
        ref: "borderColor"
    },
    widgetContainerHorizontalPadding: {
        calc: "spacing * 1.5"
    },
    widgetContainerVerticalPadding: {
        calc: "spacing * 1.5"
    },
    widgetHorizontalSpacing: {
        calc: "spacing * 1.5"
    },
    widgetVerticalSpacing: {
        ref: "spacing"
    },
    listItemHeight: {
        calc: "max(iconSize, dataFontSize) + widgetVerticalSpacing"
    },
    iconSize: 16,
    iconColor: "inherit",
    iconButtonColor: {
        ref: "iconColor"
    },
    iconButtonBackgroundColor: "transparent",
    iconButtonBackgroundSpread: 4,
    iconButtonBorderRadius: 1,
    iconButtonHoverColor: {
        ref: "iconButtonColor"
    },
    iconButtonHoverBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.1),
    iconButtonActiveColor: $437b23f6a393c3bf$var$accentColor,
    iconButtonActiveBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.28),
    iconButtonActiveIndicatorColor: $437b23f6a393c3bf$var$accentColor,
    toggleButtonWidth: 28,
    toggleButtonHeight: 18,
    toggleButtonOnBackgroundColor: $437b23f6a393c3bf$var$accentColor,
    toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.3),
    toggleButtonSwitchBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    toggleButtonSwitchInset: 2,
    menuBorder: {
        color: $437b23f6a393c3bf$var$foregroundMix(0.2)
    },
    menuBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.03),
    menuTextColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.95),
    menuShadow: {
        ref: "popupShadow"
    },
    menuSeparatorColor: {
        ref: "borderColor"
    },
    setFilterIndentSize: {
        ref: "iconSize"
    },
    chartMenuPanelWidth: 260,
    chartMenuLabelColor: $437b23f6a393c3bf$var$foregroundMix(0.8),
    dialogShadow: {
        ref: "popupShadow"
    },
    cellEditingBorder: {
        color: $437b23f6a393c3bf$var$accentColor
    },
    cellEditingShadow: {
        ref: "cardShadow"
    },
    fullRowEditInvalidBackgroundColor: {
        ref: "invalidColor",
        onto: "backgroundColor",
        mix: 0.25
    },
    dialogBorder: {
        color: $437b23f6a393c3bf$var$foregroundMix(0.2)
    },
    panelBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    panelTitleBarBackgroundColor: {
        ref: "headerBackgroundColor"
    },
    panelTitleBarIconColor: {
        ref: "headerTextColor"
    },
    panelTitleBarTextColor: {
        ref: "headerTextColor"
    },
    panelTitleBarFontWeight: {
        ref: "headerFontWeight"
    },
    panelTitleBarBorder: true,
    columnSelectIndentSize: {
        ref: "iconSize"
    },
    toolPanelSeparatorBorder: true,
    tooltipBackgroundColor: {
        ref: "chromeBackgroundColor"
    },
    tooltipErrorBackgroundColor: {
        ref: "invalidColor",
        onto: "backgroundColor",
        mix: 0.1
    },
    tooltipTextColor: {
        ref: "textColor"
    },
    tooltipErrorTextColor: {
        ref: "invalidColor"
    },
    tooltipBorder: true,
    tooltipErrorBorder: {
        color: {
            ref: "invalidColor",
            onto: "backgroundColor",
            mix: 0.25
        }
    },
    columnDropCellBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.07),
    columnDropCellTextColor: {
        ref: "textColor"
    },
    columnDropCellDragHandleColor: {
        ref: "textColor"
    },
    columnDropCellBorder: {
        color: $437b23f6a393c3bf$var$foregroundMix(0.13)
    },
    selectCellBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.07),
    selectCellBorder: {
        color: $437b23f6a393c3bf$var$foregroundMix(0.13)
    },
    advancedFilterBuilderButtonBarBorder: true,
    advancedFilterBuilderIndentSize: {
        calc: "spacing * 2 + iconSize"
    },
    advancedFilterBuilderJoinPillColor: "#f08e8d",
    advancedFilterBuilderColumnPillColor: "#a6e194",
    advancedFilterBuilderOptionPillColor: "#f3c08b",
    advancedFilterBuilderValuePillColor: "#85c0e4",
    filterPanelApplyButtonColor: $437b23f6a393c3bf$var$backgroundColor,
    filterPanelApplyButtonBackgroundColor: $437b23f6a393c3bf$var$accentColor,
    filterPanelCardSubtleColor: {
        ref: "textColor",
        mix: 0.7
    },
    filterPanelCardSubtleHoverColor: {
        ref: "textColor"
    },
    findMatchColor: $437b23f6a393c3bf$var$foregroundColor,
    findMatchBackgroundColor: "#ffff00",
    findActiveMatchColor: $437b23f6a393c3bf$var$foregroundColor,
    findActiveMatchBackgroundColor: "#ffa500",
    filterToolPanelGroupIndent: {
        ref: "spacing"
    },
    rowLoadingSkeletonEffectColor: $437b23f6a393c3bf$var$foregroundMix(0.15),
    statusBarLabelColor: $437b23f6a393c3bf$var$foregroundColor,
    statusBarLabelFontWeight: 500,
    statusBarValueColor: $437b23f6a393c3bf$var$foregroundColor,
    statusBarValueFontWeight: 500,
    pinnedSourceRowTextColor: {
        ref: "textColor"
    },
    pinnedSourceRowBackgroundColor: {
        ref: "backgroundColor"
    },
    pinnedSourceRowFontWeight: 600,
    pinnedRowFontWeight: 600,
    pinnedRowBackgroundColor: {
        ref: "backgroundColor"
    },
    pinnedRowTextColor: {
        ref: "textColor"
    }
};
// packages/ag-grid-community/src/theming/parts/batch-edit/batch-edit-style-default.css-GENERATED.ts
var $437b23f6a393c3bf$var$batchEditStyleDefaultCSS = /*css*/ `.ag-cell-batch-edit{background-color:var(--ag-cell-batch-edit-background-color);color:var(--ag-cell-batch-edit-text-color);display:inherit}.ag-row-batch-edit{background-color:var(--ag-row-batch-edit-background-color);color:var(--ag-row-batch-edit-text-color)}`;
// packages/ag-grid-community/src/theming/parts/batch-edit/batch-edit-styles.ts
var $437b23f6a393c3bf$var$baseParams = {
    cellBatchEditBackgroundColor: "rgba(220 181 139 / 16%)",
    cellBatchEditTextColor: "#422f00",
    rowBatchEditBackgroundColor: {
        ref: "cellBatchEditBackgroundColor"
    },
    rowBatchEditTextColor: {
        ref: "cellBatchEditTextColor"
    }
};
var $437b23f6a393c3bf$var$baseDarkBatchEditParams = {
    ...$437b23f6a393c3bf$var$baseParams,
    cellBatchEditTextColor: "#f3d0b3"
};
var $437b23f6a393c3bf$var$makeBatchEditStyleBaseTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "batchEditStyle",
        params: $437b23f6a393c3bf$var$baseParams,
        css: $437b23f6a393c3bf$var$batchEditStyleDefaultCSS
    });
var $437b23f6a393c3bf$var$batchEditStyleBase = /* @__PURE__ */ $437b23f6a393c3bf$var$makeBatchEditStyleBaseTreeShakeable();
// packages/ag-grid-community/src/theming/parts/button-style/button-style-base.css-GENERATED.ts
var $437b23f6a393c3bf$var$buttonStyleBaseCSS = /*css*/ `:where(.ag-button){background:none;border:none;color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0;text-indent:inherit;text-shadow:inherit;text-transform:inherit;word-spacing:inherit;&:disabled{cursor:default}&:focus-visible{box-shadow:var(--ag-focus-shadow);outline:none}}.ag-standard-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--ag-button-background-color);border:var(--ag-button-border);border-radius:var(--ag-button-border-radius);color:var(--ag-button-text-color);cursor:pointer;font-weight:var(--ag-button-font-weight);padding:var(--ag-button-vertical-padding) var(--ag-button-horizontal-padding);&:hover{background-color:var(--ag-button-hover-background-color);border:var(--ag-button-hover-border);color:var(--ag-button-hover-text-color)}&:active{background-color:var(--ag-button-active-background-color);border:var(--ag-button-active-border);color:var(--ag-button-active-text-color)}&:disabled{background-color:var(--ag-button-disabled-background-color);border:var(--ag-button-disabled-border);color:var(--ag-button-disabled-text-color)}}`;
// packages/ag-grid-community/src/theming/parts/button-style/button-styles.ts
var $437b23f6a393c3bf$var$baseParams2 = {
    buttonTextColor: "inherit",
    buttonFontWeight: "normal",
    buttonBackgroundColor: "transparent",
    buttonBorder: false,
    buttonBorderRadius: {
        ref: "borderRadius"
    },
    buttonHorizontalPadding: {
        calc: "spacing * 2"
    },
    buttonVerticalPadding: {
        ref: "spacing"
    },
    buttonHoverTextColor: {
        ref: "buttonTextColor"
    },
    buttonHoverBackgroundColor: {
        ref: "buttonBackgroundColor"
    },
    buttonHoverBorder: {
        ref: "buttonBorder"
    },
    buttonActiveTextColor: {
        ref: "buttonHoverTextColor"
    },
    buttonActiveBackgroundColor: {
        ref: "buttonHoverBackgroundColor"
    },
    buttonActiveBorder: {
        ref: "buttonHoverBorder"
    },
    buttonDisabledTextColor: {
        ref: "inputDisabledTextColor"
    },
    buttonDisabledBackgroundColor: {
        ref: "inputDisabledBackgroundColor"
    },
    buttonDisabledBorder: {
        ref: "inputDisabledBorder"
    }
};
var $437b23f6a393c3bf$var$makeButtonStyleBaseTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "buttonStyle",
        params: $437b23f6a393c3bf$var$baseParams2,
        css: $437b23f6a393c3bf$var$buttonStyleBaseCSS
    });
var $437b23f6a393c3bf$export$ac3227978dde8e12 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeButtonStyleBaseTreeShakeable();
var $437b23f6a393c3bf$var$makeButtonStyleQuartzTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "buttonStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams2,
            buttonBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            buttonBorder: true,
            buttonHoverBackgroundColor: {
                ref: "rowHoverColor"
            },
            buttonActiveBorder: {
                color: $437b23f6a393c3bf$var$accentColor
            }
        },
        css: $437b23f6a393c3bf$var$buttonStyleBaseCSS
    });
var $437b23f6a393c3bf$export$a70529c52057ad6a = /* @__PURE__ */ $437b23f6a393c3bf$var$makeButtonStyleQuartzTreeShakeable();
var $437b23f6a393c3bf$var$makeButtonStyleAlpineTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "buttonStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams2,
            buttonBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            buttonBorder: {
                color: $437b23f6a393c3bf$var$accentColor
            },
            buttonFontWeight: 600,
            buttonTextColor: $437b23f6a393c3bf$var$accentColor,
            buttonHoverBackgroundColor: {
                ref: "rowHoverColor"
            },
            buttonActiveBackgroundColor: $437b23f6a393c3bf$var$accentColor,
            buttonActiveTextColor: $437b23f6a393c3bf$var$backgroundColor
        },
        css: $437b23f6a393c3bf$var$buttonStyleBaseCSS
    });
var $437b23f6a393c3bf$export$c5a38eb31ae86567 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeButtonStyleAlpineTreeShakeable();
var $437b23f6a393c3bf$var$makeButtonStyleBalhamTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "buttonStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams2,
            buttonBorder: {
                color: $437b23f6a393c3bf$var$foregroundColor,
                width: 2,
                style: "outset"
            },
            buttonActiveBorder: {
                color: $437b23f6a393c3bf$var$foregroundColor,
                width: 2,
                style: "inset"
            },
            buttonBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.07),
            buttonHoverBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            buttonVerticalPadding: {
                calc: "spacing * 0.5"
            }
        },
        css: $437b23f6a393c3bf$var$buttonStyleBaseCSS
    });
var $437b23f6a393c3bf$export$effe67f8e12191d5 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeButtonStyleBalhamTreeShakeable();
// packages/ag-grid-community/src/theming/parts/column-drop-style/column-drop-style-bordered.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnDropStyleBorderedCSS = /*css*/ `.ag-column-drop-vertical-empty-message{align-items:center;border:dashed var(--ag-border-width);border-color:var(--ag-border-color);display:flex;inset:0;justify-content:center;margin:calc(var(--ag-spacing)*1.5) calc(var(--ag-spacing)*2);overflow:hidden;padding:calc(var(--ag-spacing)*2);position:absolute}`;
// packages/ag-grid-community/src/theming/parts/column-drop-style/column-drop-style-plain.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnDropStylePlainCSS = /*css*/ `.ag-column-drop-vertical-empty-message{color:var(--ag-subtle-text-color);font-size:calc(var(--ag-font-size) - 1px);font-weight:600;padding-top:var(--ag-spacing)}:where(.ag-ltr) .ag-column-drop-vertical-empty-message{padding-left:calc(var(--ag-icon-size) + var(--ag-spacing) + var(--ag-widget-horizontal-spacing));padding-right:var(--ag-spacing)}:where(.ag-rtl) .ag-column-drop-vertical-empty-message{padding-left:var(--ag-spacing);padding-right:calc(var(--ag-icon-size) + var(--ag-spacing) + var(--ag-widget-horizontal-spacing))}`;
// packages/ag-grid-community/src/theming/parts/column-drop-style/column-drop-styles.ts
var $437b23f6a393c3bf$var$makeColumnDropStyleBorderedTreeShakeable = ()=>{
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "columnDropStyle",
        css: $437b23f6a393c3bf$var$columnDropStyleBorderedCSS
    });
};
var $437b23f6a393c3bf$export$9dd26d60e574ec0 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColumnDropStyleBorderedTreeShakeable();
var $437b23f6a393c3bf$var$makeColumnDropStylePlainTreeShakeable = ()=>{
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "columnDropStyle",
        css: $437b23f6a393c3bf$var$columnDropStylePlainCSS
    });
};
var $437b23f6a393c3bf$export$9eadc93b54e4a807 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColumnDropStylePlainTreeShakeable();
// packages/ag-grid-community/src/theming/theme-types.ts
var $437b23f6a393c3bf$var$paramTypes = [
    "colorScheme",
    "color",
    "length",
    "scale",
    "borderStyle",
    "border",
    "shadow",
    "image",
    "fontFamily",
    "fontWeight",
    "duration"
];
var $437b23f6a393c3bf$var$getParamType = $437b23f6a393c3bf$var$memoize((param)=>{
    param = param.toLowerCase();
    return $437b23f6a393c3bf$var$paramTypes.find((type)=>param.endsWith(type.toLowerCase())) ?? "length";
});
var $437b23f6a393c3bf$var$literalToCSS = (value)=>{
    if (typeof value === "object" && value?.ref) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    if (typeof value === "string") return value;
    if (typeof value === "number") return String(value);
    return false;
};
var $437b23f6a393c3bf$var$colorValueToCss = (value)=>{
    if (typeof value === "string") return value;
    if (value && "ref" in value) {
        const colorExpr = $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
        if (value.mix == null) return colorExpr;
        const backgroundExpr = value.onto ? $437b23f6a393c3bf$var$paramToVariableExpression(value.onto) : "transparent";
        return `color-mix(in srgb, ${backgroundExpr}, ${colorExpr} ${$437b23f6a393c3bf$var$clamp(value.mix * 100, 0, 100)}%)`;
    }
    return false;
};
var $437b23f6a393c3bf$var$colorSchemeValueToCss = $437b23f6a393c3bf$var$literalToCSS;
var $437b23f6a393c3bf$var$lengthValueToCss = (value)=>{
    if (typeof value === "string") return value;
    if (typeof value === "number") return `${value}px`;
    if (value && "calc" in value) {
        const valueWithSpaces = value.calc.replace(/ ?[*/+] ?/g, " $& ");
        return `calc(${valueWithSpaces.replace(/-?\b[a-z][a-z0-9]*\b(?![-(])/gi, (p)=>p[0] === "-" ? p : ` ${$437b23f6a393c3bf$var$paramToVariableExpression(p)} `)})`;
    }
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return false;
};
var $437b23f6a393c3bf$var$scaleValueToCss = $437b23f6a393c3bf$var$literalToCSS;
var $437b23f6a393c3bf$var$borderValueToCss = (value, param)=>{
    if (typeof value === "string") return value;
    if (value === true) return $437b23f6a393c3bf$var$borderValueToCss({}, param);
    if (value === false) return param === "columnBorder" ? $437b23f6a393c3bf$var$borderValueToCss({
        color: "transparent"
    }, param) : "none";
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return $437b23f6a393c3bf$var$borderStyleValueToCss(value.style ?? "solid") + " " + $437b23f6a393c3bf$var$lengthValueToCss(value.width ?? {
        ref: "borderWidth"
    }) + " " + $437b23f6a393c3bf$var$colorValueToCss(value.color ?? {
        ref: "borderColor"
    });
};
var $437b23f6a393c3bf$var$shadowValueToCss = (value)=>{
    if (typeof value === "string") return value;
    if (value === false) return "none";
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return [
        $437b23f6a393c3bf$var$lengthValueToCss(value.offsetX ?? 0),
        $437b23f6a393c3bf$var$lengthValueToCss(value.offsetY ?? 0),
        $437b23f6a393c3bf$var$lengthValueToCss(value.radius ?? 0),
        $437b23f6a393c3bf$var$lengthValueToCss(value.spread ?? 0),
        $437b23f6a393c3bf$var$colorValueToCss(value.color ?? {
            ref: "foregroundColor"
        })
    ].join(" ");
};
var $437b23f6a393c3bf$var$borderStyleValueToCss = $437b23f6a393c3bf$var$literalToCSS;
var $437b23f6a393c3bf$var$fontFamilyValueToCss = (value)=>{
    if (typeof value === "string") return value.includes(",") ? value : $437b23f6a393c3bf$var$quoteUnsafeChars(value);
    if (value && "googleFont" in value) return $437b23f6a393c3bf$var$fontFamilyValueToCss(value.googleFont);
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    if (Array.isArray(value)) return value.map((font)=>{
        if (typeof font === "object" && "googleFont" in font) font = font.googleFont;
        return $437b23f6a393c3bf$var$quoteUnsafeChars(font);
    }).join(", ");
    return false;
};
var $437b23f6a393c3bf$var$quoteUnsafeChars = (font)=>// don't quote var() expressions or quote safe identifier names, so that
    // people can specify fonts like sans-serif which are keywords not strings,
    // or var(--my-var)
    /^[\w-]+$|\w\(/.test(font) ? font : JSON.stringify(font);
var $437b23f6a393c3bf$var$fontWeightValueToCss = $437b23f6a393c3bf$var$literalToCSS;
var $437b23f6a393c3bf$var$imageValueToCss = (value)=>{
    if (typeof value === "string") return value;
    if (value && "url" in value) return `url(${JSON.stringify(value.url)})`;
    if (value && "svg" in value) return $437b23f6a393c3bf$var$imageValueToCss({
        url: `data:image/svg+xml,${encodeURIComponent(value.svg)}`
    });
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return false;
};
var $437b23f6a393c3bf$var$durationValueToCss = (value, param)=>{
    if (typeof value === "string") return value;
    if (typeof value === "number") {
        if (value >= 10) $437b23f6a393c3bf$export$a20c7248650823a9(104, {
            value: value,
            param: param
        });
        return `${value}s`;
    }
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return false;
};
var $437b23f6a393c3bf$var$paramValidators = {
    color: $437b23f6a393c3bf$var$colorValueToCss,
    colorScheme: $437b23f6a393c3bf$var$colorSchemeValueToCss,
    length: $437b23f6a393c3bf$var$lengthValueToCss,
    scale: $437b23f6a393c3bf$var$scaleValueToCss,
    border: $437b23f6a393c3bf$var$borderValueToCss,
    borderStyle: $437b23f6a393c3bf$var$borderStyleValueToCss,
    shadow: $437b23f6a393c3bf$var$shadowValueToCss,
    image: $437b23f6a393c3bf$var$imageValueToCss,
    fontFamily: $437b23f6a393c3bf$var$fontFamilyValueToCss,
    fontWeight: $437b23f6a393c3bf$var$fontWeightValueToCss,
    duration: $437b23f6a393c3bf$var$durationValueToCss
};
var $437b23f6a393c3bf$var$paramValueToCss = (param, value)=>{
    const type = $437b23f6a393c3bf$var$getParamType(param);
    return $437b23f6a393c3bf$var$paramValidators[type](value, param);
};
// packages/ag-grid-community/src/theming/Theme.ts
var $437b23f6a393c3bf$var$FORCE_LEGACY_THEMES = false;
var $437b23f6a393c3bf$export$638c0e26f33cd834 = (theme)=>{
    if (!(theme instanceof $437b23f6a393c3bf$var$ThemeImpl)) throw new Error("theme is not an object created by createTheme");
    return theme;
};
var $437b23f6a393c3bf$export$25d302a5b900a763 = ()=>new $437b23f6a393c3bf$var$ThemeImpl().withPart($437b23f6a393c3bf$export$a70529c52057ad6a).withPart($437b23f6a393c3bf$export$9dd26d60e574ec0).withPart($437b23f6a393c3bf$var$batchEditStyleBase);
var $437b23f6a393c3bf$var$ThemeImpl = class _ThemeImpl {
    constructor(parts = []){
        this.parts = parts;
    }
    withPart(part) {
        if (typeof part === "function") part = part();
        if (!(part instanceof $437b23f6a393c3bf$var$PartImpl)) {
            $437b23f6a393c3bf$var$_logPreInitErr(259, {
                part: part
            }, "Invalid part");
            return this;
        }
        return new _ThemeImpl([
            ...this.parts,
            part
        ]);
    }
    withoutPart(feature) {
        return this.withPart($437b23f6a393c3bf$export$6e6f0e372f4cb988({
            feature: feature
        }));
    }
    withParams(params, mode = $437b23f6a393c3bf$var$defaultModeName) {
        return this.withPart($437b23f6a393c3bf$export$6e6f0e372f4cb988({
            modeParams: {
                [mode]: params
            }
        }));
    }
    /**
   * Called by a grid instance when it starts using the theme. This installs
   * the theme's parts into document head, or the shadow DOM if the provided
   * container is within a shadow root.
   */ _startUse({ styleContainer: styleContainer, cssLayer: cssLayer, nonce: nonce, loadThemeGoogleFonts: loadThemeGoogleFonts }) {
        if ($437b23f6a393c3bf$var$IS_SSR) return;
        if ($437b23f6a393c3bf$var$FORCE_LEGACY_THEMES) return;
        $437b23f6a393c3bf$var$uninstallLegacyCSS();
        $437b23f6a393c3bf$var$_injectCoreAndModuleCSS(styleContainer, cssLayer, nonce);
        const googleFontsUsed = $437b23f6a393c3bf$var$getGoogleFontsUsed(this);
        if (googleFontsUsed.length > 0) {
            for (const googleFont of googleFontsUsed)if (loadThemeGoogleFonts) $437b23f6a393c3bf$var$loadGoogleFont(googleFont, nonce);
        }
        for (const part of this.parts)part.use(styleContainer, cssLayer, nonce);
    }
    /**
   * Return CSS that that applies the params of this theme to elements with
   * the provided class name
   */ _getCssClass() {
        if ($437b23f6a393c3bf$var$FORCE_LEGACY_THEMES) return "ag-theme-quartz";
        return this._cssClassCache ?? (this._cssClassCache = $437b23f6a393c3bf$var$deduplicatePartsByFeature(this.parts).map((part)=>part.use(void 0, void 0, void 0)).filter(Boolean).join(" "));
    }
    _getModeParams() {
        let paramsCache = this._paramsCache;
        if (!paramsCache) {
            const mergedModeParams = {
                // NOTE: defining the default mode here is important, it ensures
                // that the default mode is first in iteration order, which puts
                // it first in outputted CSS, allowing other modes to override it
                [$437b23f6a393c3bf$var$defaultModeName]: {
                    ...$437b23f6a393c3bf$var$coreDefaults
                }
            };
            for (const part of $437b23f6a393c3bf$var$deduplicatePartsByFeature(this.parts))for (const partMode of Object.keys(part.modeParams)){
                const partParams = part.modeParams[partMode];
                if (partParams) {
                    const mergedParams = mergedModeParams[partMode] ?? (mergedModeParams[partMode] = {});
                    const partParamNames = /* @__PURE__ */ new Set();
                    for (const partParamName of Object.keys(partParams)){
                        const partParamValue = partParams[partParamName];
                        if (partParamValue !== void 0) {
                            mergedParams[partParamName] = partParamValue;
                            partParamNames.add(partParamName);
                        }
                    }
                    if (partMode === $437b23f6a393c3bf$var$defaultModeName) for (const mergedMode of Object.keys(mergedModeParams)){
                        const mergedParams2 = mergedModeParams[mergedMode];
                        if (mergedMode !== $437b23f6a393c3bf$var$defaultModeName) for (const partParamName of partParamNames)delete mergedParams2[partParamName];
                    }
                }
            }
            this._paramsCache = paramsCache = mergedModeParams;
        }
        return paramsCache;
    }
    /**
   * Return the CSS chunk that is inserted into the grid DOM, and will
   * therefore be removed automatically when the grid is destroyed or it
   * starts to use a new theme.
   *
   * @param className a unique class name on the grid wrapper used to scope the returned CSS to the grid instance
   */ _getPerGridCss(className) {
        const selectorPlaceholder = "##SELECTOR##";
        let innerParamsCss = this._paramsCssCache;
        if (!innerParamsCss) {
            let variablesCss = "";
            let inheritanceCss = "";
            const modeParams = this._getModeParams();
            for (const mode of Object.keys(modeParams)){
                const params = modeParams[mode];
                if (mode !== $437b23f6a393c3bf$var$defaultModeName) {
                    const escapedMode = typeof CSS === "object" ? CSS.escape(mode) : mode;
                    const wrapPrefix = `:where([data-ag-theme-mode="${escapedMode}"]) & {
`;
                    variablesCss += wrapPrefix;
                    inheritanceCss += wrapPrefix;
                }
                for (const key of Object.keys(params).sort()){
                    const value = params[key];
                    const cssValue = $437b23f6a393c3bf$var$paramValueToCss(key, value);
                    if (cssValue === false) $437b23f6a393c3bf$export$a20c7248650823a9(107, {
                        key: key,
                        value: value
                    });
                    else {
                        const cssName = $437b23f6a393c3bf$var$paramToVariableName(key);
                        const inheritedName = cssName.replace("--ag-", "--ag-inherited-");
                        variablesCss += `	${cssName}: var(${inheritedName}, ${cssValue});
`;
                        inheritanceCss += `	${inheritedName}: var(${cssName});
`;
                    }
                }
                if (mode !== $437b23f6a393c3bf$var$defaultModeName) {
                    variablesCss += "}\n";
                    inheritanceCss += "}\n";
                }
            }
            let css = `${selectorPlaceholder} {
${variablesCss}}
`;
            css += `:has(> ${selectorPlaceholder}):not(${selectorPlaceholder}) {
${inheritanceCss}}
`;
            this._paramsCssCache = innerParamsCss = css;
        }
        return innerParamsCss.replaceAll(selectorPlaceholder, `:where(.${className})`);
    }
};
var $437b23f6a393c3bf$var$deduplicatePartsByFeature = (parts)=>{
    const lastPartByFeature = /* @__PURE__ */ new Map();
    for (const part of parts)lastPartByFeature.set(part.feature, part);
    const result = [];
    for (const part of parts)if (!part.feature || lastPartByFeature.get(part.feature) === part) result.push(part);
    return result;
};
var $437b23f6a393c3bf$var$getGoogleFontsUsed = (theme)=>{
    const googleFontsUsed = /* @__PURE__ */ new Set();
    const visitParamValue = (paramValue)=>{
        if (Array.isArray(paramValue)) paramValue.forEach(visitParamValue);
        else {
            const googleFont = paramValue?.googleFont;
            if (typeof googleFont === "string") googleFontsUsed.add(googleFont);
        }
    };
    const allModeValues = Object.values(theme._getModeParams());
    const allValues = allModeValues.flatMap((mv)=>Object.values(mv));
    allValues.forEach(visitParamValue);
    return Array.from(googleFontsUsed).sort();
};
var $437b23f6a393c3bf$var$uninstalledLegacyCSS = false;
var $437b23f6a393c3bf$var$uninstallLegacyCSS = ()=>{
    if ($437b23f6a393c3bf$var$uninstalledLegacyCSS) return;
    $437b23f6a393c3bf$var$uninstalledLegacyCSS = true;
    for (const style of Array.from(document.head.querySelectorAll('style[data-ag-scope="legacy"]')))style.remove();
};
var $437b23f6a393c3bf$var$googleFontsLoaded = /* @__PURE__ */ new Set();
var $437b23f6a393c3bf$var$loadGoogleFont = async (font, nonce)=>{
    $437b23f6a393c3bf$var$googleFontsLoaded.add(font);
    const css = `@import url('https://${$437b23f6a393c3bf$var$googleFontsDomain}/css2?family=${encodeURIComponent(font)}:wght@100;200;300;400;500;600;700;800;900&display=swap');
`;
    $437b23f6a393c3bf$var$_injectGlobalCSS(css, document.head, `googleFont:${font}`, void 0, 0, nonce);
};
var $437b23f6a393c3bf$var$googleFontsDomain = "fonts.googleapis.com";
// packages/ag-grid-community/src/theming/parts/checkbox-style/checkbox-style-default.css-GENERATED.ts
var $437b23f6a393c3bf$var$checkboxStyleDefaultCSS = /*css*/ `.ag-checkbox-input-wrapper,.ag-radio-button-input-wrapper{background-color:var(--ag-checkbox-unchecked-background-color);border:solid var(--ag-checkbox-border-width) var(--ag-checkbox-unchecked-border-color);flex:none;height:var(--ag-icon-size);position:relative;width:var(--ag-icon-size);:where(input){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;display:block;height:var(--ag-icon-size);margin:0;opacity:0;width:var(--ag-icon-size)}&:after{content:"";display:block;inset:0;-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;pointer-events:none;position:absolute}&:where(.ag-checked){background-color:var(--ag-checkbox-checked-background-color);border-color:var(--ag-checkbox-checked-border-color);&:after{background-color:var(--ag-checkbox-checked-shape-color)}}&:where(:focus-within,:active){box-shadow:var(--ag-focus-shadow)}&:where(.ag-disabled){filter:grayscale();opacity:.5}}.ag-checkbox-input-wrapper{border-radius:var(--ag-checkbox-border-radius);&:where(.ag-checked):after{-webkit-mask-image:var(--ag-checkbox-checked-shape-image);mask-image:var(--ag-checkbox-checked-shape-image)}&:where(.ag-indeterminate){background-color:var(--ag-checkbox-indeterminate-background-color);border-color:var(--ag-checkbox-indeterminate-border-color);&:after{background-color:var(--ag-checkbox-indeterminate-shape-color);-webkit-mask-image:var(--ag-checkbox-indeterminate-shape-image);mask-image:var(--ag-checkbox-indeterminate-shape-image)}}}.ag-cell-editing-error .ag-checkbox-input-wrapper:focus-within{box-shadow:var(--ag-focus-error-shadow)}.ag-radio-button-input-wrapper{border-radius:100%;&:where(.ag-checked):after{-webkit-mask-image:var(--ag-radio-checked-shape-image);mask-image:var(--ag-radio-checked-shape-image)}}`;
// packages/ag-grid-community/src/theming/parts/checkbox-style/checkbox-styles.ts
var $437b23f6a393c3bf$var$makeCheckboxStyleDefaultTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "checkboxStyle",
        params: {
            checkboxBorderWidth: 1,
            checkboxBorderRadius: {
                ref: "borderRadius"
            },
            checkboxUncheckedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.3),
            checkboxCheckedBackgroundColor: $437b23f6a393c3bf$var$accentColor,
            checkboxCheckedBorderColor: {
                ref: "checkboxCheckedBackgroundColor"
            },
            checkboxCheckedShapeImage: {
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" fill="none"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M1 3.5 3.5 6l5-5"/></svg>'
            },
            checkboxCheckedShapeColor: $437b23f6a393c3bf$var$backgroundColor,
            checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.3),
            checkboxIndeterminateBorderColor: {
                ref: "checkboxIndeterminateBackgroundColor"
            },
            checkboxIndeterminateShapeImage: {
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="2" fill="none"><rect width="10" height="2" fill="#000" rx="1"/></svg>'
            },
            checkboxIndeterminateShapeColor: $437b23f6a393c3bf$var$backgroundColor,
            radioCheckedShapeImage: {
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" fill="none"><circle cx="3" cy="3" r="3" fill="#000"/></svg>'
            }
        },
        css: $437b23f6a393c3bf$var$checkboxStyleDefaultCSS
    });
var $437b23f6a393c3bf$export$cb8a4bb75f2f86bb = /* @__PURE__ */ $437b23f6a393c3bf$var$makeCheckboxStyleDefaultTreeShakeable();
// packages/ag-grid-community/src/theming/parts/color-scheme/color-schemes.ts
var $437b23f6a393c3bf$var$makeColorSchemeLightTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: $437b23f6a393c3bf$var$defaultLightColorSchemeParams
    });
var $437b23f6a393c3bf$export$a116df924b17ca5b = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeLightTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeLightWarmTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: {
            ...$437b23f6a393c3bf$var$defaultLightColorSchemeParams,
            foregroundColor: "#000000de",
            borderColor: "#60300026",
            chromeBackgroundColor: "#60300005"
        }
    });
var $437b23f6a393c3bf$export$57dc871710981584 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeLightWarmTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeLightColdTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: {
            ...$437b23f6a393c3bf$var$defaultLightColorSchemeParams,
            foregroundColor: "#000",
            chromeBackgroundColor: "#f3f8f8"
        }
    });
var $437b23f6a393c3bf$export$4cac94f49a02889d = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeLightColdTreeShakeable();
var $437b23f6a393c3bf$var$darkParams = ()=>({
        ...$437b23f6a393c3bf$var$defaultLightColorSchemeParams,
        ...$437b23f6a393c3bf$var$baseDarkBatchEditParams,
        backgroundColor: "hsl(217, 0%, 17%)",
        foregroundColor: "#FFF",
        chromeBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.05),
        rowHoverColor: $437b23f6a393c3bf$var$accentMix(0.15),
        selectedRowBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.2),
        menuBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.1),
        browserColorScheme: "dark",
        popupShadow: "0 0px 20px #000A",
        cardShadow: "0 1px 4px 1px #000A",
        advancedFilterBuilderJoinPillColor: "#7a3a37",
        advancedFilterBuilderColumnPillColor: "#355f2d",
        advancedFilterBuilderOptionPillColor: "#5a3168",
        advancedFilterBuilderValuePillColor: "#374c86",
        filterPanelApplyButtonColor: $437b23f6a393c3bf$var$foregroundColor,
        findMatchColor: $437b23f6a393c3bf$var$backgroundColor,
        findActiveMatchColor: $437b23f6a393c3bf$var$backgroundColor,
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.4),
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.4),
        rowBatchEditBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.1)
    });
var $437b23f6a393c3bf$var$makeColorSchemeDarkTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: $437b23f6a393c3bf$var$darkParams()
    });
var $437b23f6a393c3bf$export$cd586495722a2c01 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeDarkTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeDarkWarmTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: {
            backgroundColor: "hsl(29, 10%, 17%)",
            foregroundColor: "#FFF",
            browserColorScheme: "dark"
        }
    });
var $437b23f6a393c3bf$var$darkBlueParams = ()=>({
        ...$437b23f6a393c3bf$var$darkParams(),
        backgroundColor: "#1f2836"
    });
var $437b23f6a393c3bf$export$cd0e0dbae95c289b = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeDarkWarmTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeDarkBlueTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: $437b23f6a393c3bf$var$darkBlueParams()
    });
var $437b23f6a393c3bf$export$55741f191f921eee = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeDarkBlueTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeVariableTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: $437b23f6a393c3bf$var$defaultLightColorSchemeParams,
        modeParams: {
            light: $437b23f6a393c3bf$var$defaultLightColorSchemeParams,
            dark: $437b23f6a393c3bf$var$darkParams(),
            "dark-blue": $437b23f6a393c3bf$var$darkBlueParams()
        }
    });
var $437b23f6a393c3bf$export$e4400993032942f7 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeVariableTreeShakeable();
// packages/ag-grid-community/src/theming/parts/icon-set/balham/icon-set-balham.css-GENERATED.ts
var $437b23f6a393c3bf$var$iconSetBalhamCSS = /*css*/ `.ag-icon-aggregation:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eaggregation%3C/title%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0M7.006 4c-1.57.02-2.946 1.348-3.004 2.922-.078 6.078-.23 12.16.002 18.234.094 1.484 1.354 2.746 2.84 2.84 6.1.232 12.212.232 18.312 0 1.48-.094 2.746-1.35 2.84-2.84.232-6.1.232-12.212 0-18.312-.094-1.48-1.35-2.746-2.84-2.84C19.11 3.774 13.056 4 7.006 4M22 12h-2v-2h-8v.092c.056 1.352 3.426 2.598 4.472 4.404.682 1.174.438 2.754-.572 3.72C14.29 19.618 12 20.924 12 22h8v-2h2v4H10c0-1.586-.098-3.304 1.016-4.314 1.904-1.632 4.89-3.108 3.54-4.42-1.918-1.68-4.464-2.936-4.554-5.12L10 8h12z'/%3E%3C/svg%3E")}.ag-icon-arrows:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Earrows%3C/title%3E%3Cpath d='m6.414 17 2.294 2.292-1.416 1.416L2.586 16l4.706-4.708 1.416 1.416L6.414 15H15V6.414l-2.292 2.294-1.416-1.416L16 2.586l4.708 4.706-1.416 1.416L17 6.414V15h8.586l-2.294-2.292 1.416-1.416L29.414 16l-4.706 4.708-1.416-1.416L25.586 17H17v8.586l2.292-2.294 1.416 1.416L16 29.414l-4.708-4.706 1.416-1.416L15 25.586V17z'/%3E%3C/svg%3E")}.ag-icon-asc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Easc%3C/title%3E%3Cpath d='m15 10.621-4.292 4.294-1.416-1.416L16 6.793l6.708 6.706-1.416 1.416L17 10.621v14.586h-2z'/%3E%3C/svg%3E")}.ag-icon-cancel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecancel%3C/title%3E%3Cpath d='M16 4C9.378 4 4 9.378 4 16s5.378 12 12 12 12-5.378 12-12S22.622 4 16 4m0 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S6 21.52 6 16 10.48 6 16 6m0 8.586 5.292-5.294 1.416 1.416L17.414 16l5.294 5.292-1.416 1.416L16 17.414l-5.292 5.294-1.416-1.416L14.586 16l-5.294-5.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-chart:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Echart%3C/title%3E%3Cpath d='M6.667 12.267h4v13.067h-4zm7.466-5.6h3.733v18.667h-3.733zM21.6 17.333h3.733v8H21.6z'/%3E%3C/svg%3E")}.ag-icon-color-picker:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecolor-picker%3C/title%3E%3Cpath d='M23.907 17.587 10.574 4.254l-1.88 1.88 3.173 3.173-8.28 8.28 10.16 10.16zm-16.547 0 6.387-6.387 6.387 6.387H7.361zm18.387 2s-2.667 2.893-2.667 4.667c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667c0-1.773-2.667-4.667-2.667-4.667'/%3E%3C/svg%3E")}.ag-icon-columns:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecolumns%3C/title%3E%3Cpath d='M14 25h-2V7h2zm6 0h-2V7h2zm6 0h-2V7h2zM8 25H6V7h2z'/%3E%3C/svg%3E")}.ag-icon-contracted:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Econtracted%3C/title%3E%3Cpath d='m21.061 16-8.706 8.708-1.416-1.416L18.233 16l-7.294-7.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-copy:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecopy%3C/title%3E%3Cpath d='M21.929 27.999h-7.828a5.09 5.09 0 0 1-5.086-5.086v-9.812a5.087 5.087 0 0 1 5.086-5.086h7.828a5.09 5.09 0 0 1 5.086 5.086v9.812a5.087 5.087 0 0 1-5.086 5.086m.16-17.984h-8.088a2.94 2.94 0 0 0-2.938 2.938v10.132a2.94 2.94 0 0 0 2.938 2.938h8.088a2.94 2.94 0 0 0 2.936-2.938V12.953a2.94 2.94 0 0 0-2.936-2.938M7.041 26.013h-2.05a4 4 0 0 1-.006-.228V9.065a5.07 5.07 0 0 1 5.064-5.064h12.812q.069 0 .134.002v2.012H9.915a2.876 2.876 0 0 0-2.874 2.874z'/%3E%3C/svg%3E")}.ag-icon-cross:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='4 4 24 24'%3E%3Ctitle%3Ecross%3C/title%3E%3Cpath d='m16 14.586 5.292-5.294 1.416 1.416L17.414 16l5.294 5.292-1.416 1.416L16 17.414l-5.292 5.294-1.416-1.416L14.586 16l-5.294-5.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-csv:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='matrix(.06285 0 0 .06285 3.934 -.054)'/%3E%3Cpath d='M.688-.226a.2.2 0 0 1-.017.074.28.28 0 0 1-.145.14.412.412 0 0 1-.234.013.28.28 0 0 1-.202-.168.468.468 0 0 1-.04-.19q0-.086.025-.155a.319.319 0 0 1 .182-.191.4.4 0 0 1 .134-.025q.087 0 .155.035a.3.3 0 0 1 .104.085.17.17 0 0 1 .036.097.06.06 0 0 1-.018.044.06.06 0 0 1-.042.019.06.06 0 0 1-.042-.013.2.2 0 0 1-.031-.046.2.2 0 0 0-.066-.079.16.16 0 0 0-.095-.027.17.17 0 0 0-.142.068.3.3 0 0 0-.053.193.4.4 0 0 0 .023.139.2.2 0 0 0 .067.083.2.2 0 0 0 .1.027q.063 0 .106-.031a.2.2 0 0 0 .065-.091.2.2 0 0 1 .023-.046q.014-.018.044-.018a.06.06 0 0 1 .044.018.06.06 0 0 1 .019.045' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 7.122 25.977)'/%3E%3Cpath d='M.622-.215a.2.2 0 0 1-.033.117.23.23 0 0 1-.098.081.4.4 0 0 1-.153.029.34.34 0 0 1-.175-.04.23.23 0 0 1-.079-.077.17.17 0 0 1-.031-.093q0-.027.019-.045a.06.06 0 0 1 .046-.019.06.06 0 0 1 .039.014.1.1 0 0 1 .027.044.3.3 0 0 0 .03.057q.015.023.044.038.03.015.076.015.065 0 .105-.03a.09.09 0 0 0 .04-.075.08.08 0 0 0-.022-.058.14.14 0 0 0-.056-.034 1 1 0 0 0-.092-.025.7.7 0 0 1-.129-.042.2.2 0 0 1-.083-.066.17.17 0 0 1-.03-.104q0-.058.032-.105a.2.2 0 0 1 .093-.07.4.4 0 0 1 .144-.025q.066 0 .114.016a.3.3 0 0 1 .08.044.2.2 0 0 1 .046.057q.015.03.015.058a.07.07 0 0 1-.018.046.06.06 0 0 1-.046.021q-.025 0-.038-.012a.2.2 0 0 1-.028-.041.2.2 0 0 0-.047-.063Q.387-.625.326-.625a.15.15 0 0 0-.09.025q-.035.024-.035.059 0 .021.012.037a.1.1 0 0 0 .032.027.4.4 0 0 0 .111.036q.06.015.11.031.048.018.083.042a.2.2 0 0 1 .054.062.2.2 0 0 1 .019.091' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 13.339 25.977)'/%3E%3Cpath d='m.184-.633.162.48.163-.483q.013-.038.019-.053a.062.062 0 0 1 .061-.039q.018 0 .034.009a.1.1 0 0 1 .025.025q.009.015.009.031L.654-.64l-.007.025-.009.024-.173.468-.019.051a.2.2 0 0 1-.021.042.1.1 0 0 1-.033.03.1.1 0 0 1-.049.012.1.1 0 0 1-.05-.011A.1.1 0 0 1 .26-.03a.2.2 0 0 1-.021-.042L.22-.123.05-.587.041-.612.033-.638.03-.662q0-.025.02-.046a.07.07 0 0 1 .05-.02q.037 0 .053.023.015.023.031.072' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 18.94 25.977)'/%3E%3C/svg%3E")}.ag-icon-cut:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14.703 15.096 6.215 4.719a1 1 0 1 1 1.548-1.267l13.058 15.965A5.001 5.001 0 0 1 28 23.916a5 5 0 0 1-4.999 4.999 5 5 0 0 1-4.999-4.999 4.98 4.98 0 0 1 1.23-3.283l-3.238-3.958-3.272 4.001a4.98 4.98 0 0 1 1.265 3.323 5 5 0 0 1-4.999 4.999 5 5 0 0 1-4.999-4.999 5 5 0 0 1 7.13-4.522zM8.991 20.8a3.1 3.1 0 0 0-3.1 3.1c0 1.711 1.389 3.1 3.1 3.1s3.1-1.389 3.1-3.1-1.389-3.1-3.1-3.1M23 20.8a3.1 3.1 0 0 0-3.1 3.1c0 1.711 1.389 3.1 3.1 3.1s3.1-1.389 3.1-3.1-1.389-3.1-3.1-3.1m-5.723-8.852 1.292 1.579 7.205-8.808a1 1 0 0 0-1.548-1.267z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-desc:before,.ag-icon-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Edesc%3C/title%3E%3Cpath d='m17 21.379 4.292-4.294 1.416 1.416L16 25.207l-6.708-6.706 1.416-1.416L15 21.379V6.793h2z'/%3E%3C/svg%3E")}.ag-icon-excel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='matrix(.06285 0 0 .06285 3.934 -.054)'/%3E%3Cpath d='m.052-.139.16-.234-.135-.208a.4.4 0 0 1-.028-.052.1.1 0 0 1-.01-.042.05.05 0 0 1 .018-.037.07.07 0 0 1 .045-.016q.03 0 .047.018a1 1 0 0 1 .047.066l.107.174.115-.174.024-.038.019-.026.021-.015a.1.1 0 0 1 .027-.005.06.06 0 0 1 .044.016.05.05 0 0 1 .018.039q0 .033-.038.089l-.141.211.152.234a.3.3 0 0 1 .03.051.1.1 0 0 1 .009.038.1.1 0 0 1-.008.031.1.1 0 0 1-.024.023.1.1 0 0 1-.034.008.1.1 0 0 1-.035-.008.1.1 0 0 1-.023-.022L.427-.067.301-.265l-.134.204-.022.034-.016.019a.1.1 0 0 1-.022.015.1.1 0 0 1-.03.005.06.06 0 0 1-.044-.016.06.06 0 0 1-.017-.047q0-.036.036-.088' style='fill-rule:nonzero' transform='matrix(17.82892 0 0 16.50777 10.371 25.928)'/%3E%3C/svg%3E")}.ag-icon-expanded:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eexpanded%3C/title%3E%3Cpath d='M21.061 8.708 13.767 16l7.294 7.292-1.416 1.416L10.939 16l8.706-8.708z'/%3E%3C/svg%3E")}.ag-icon-eye-slash:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye-slash%3C/title%3E%3Cpath d='M9.304 7.89a15.2 15.2 0 0 1 6.404-1.638c.294-.002.292-.002.584 0 5.956.174 11.328 4.088 13.62 9.748 0 0-1.318 3.178-3.224 5.174a13.6 13.6 0 0 1-2.226 1.874L26.414 25 25 26.414l-2.336-2.336C17.866 26.396 11.776 26.15 7.36 22.96a14.9 14.9 0 0 1-4.168-4.612c-.41-.71-.694-1.336-1.104-2.348 0 0 .898-2.218 2.002-3.718a14.6 14.6 0 0 1 3.442-3.334L5.586 7 7 5.586zm-.3 2.528c-2.038 1.344-3.708 3.246-4.724 5.508L4.248 16c2.46 5.762 9.622 9.064 15.63 7.15q.688-.219 1.342-.516l-.912-.912a6.96 6.96 0 0 1-4.19 1.394c-3.862 0-7-3.136-7-7 0-1.57.52-3.022 1.394-4.19zm14.032 11.204a13.25 13.25 0 0 0 4.684-5.548l.032-.074c-1.984-4.646-6.834-7.798-12.006-7.748-1.712.05-3.386.458-4.922 1.158l1.102 1.102a6.97 6.97 0 0 1 4.192-1.396 7.003 7.003 0 0 1 5.606 11.192zm-11.09-8.262a5.003 5.003 0 0 0 6.928 6.928zm8.342 5.514a5.002 5.002 0 0 0-6.928-6.928z'/%3E%3C/svg%3E")}.ag-icon-eye:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye%3C/title%3E%3Cpath d='M16.292 6.32c5.956.174 11.328 4.086 13.62 9.746 0 0-1.318 3.18-3.224 5.176-4.862 5.088-13.534 5.97-19.328 1.784a14.9 14.9 0 0 1-4.168-4.612c-.41-.71-.694-1.336-1.104-2.348 0 0 .898-2.216 2.002-3.716 2.678-3.64 7.03-5.896 11.618-6.03.294-.004.292-.004.584 0m-.546 2c-4.896.142-9.458 3.202-11.466 7.672l-.032.074c2.46 5.762 9.622 9.066 15.63 7.152 3.458-1.102 6.342-3.738 7.842-7.076l.032-.076C25.768 11.42 20.918 8.27 15.746 8.32m.254.946c3.754 0 6.8 3.048 6.8 6.8 0 3.754-3.046 6.8-6.8 6.8s-6.8-3.046-6.8-6.8c0-3.752 3.046-6.8 6.8-6.8m5 6.768V16c0-2.76-2.24-5-5-5s-5 2.24-5 5v.066c0 2.76 2.24 5 5 5s5-2.24 5-5z'/%3E%3C/svg%3E")}.ag-icon-filter:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Efilter%3C/title%3E%3Cpath d='M26 8.184c-.066 2.658-4.058 5.154-6.742 7.974a1.05 1.05 0 0 0-.258.682v3.66L13 25c0-2.74.066-5.482-.002-8.222a1.05 1.05 0 0 0-.256-.62C10.026 13.304 6.06 10.61 6 8.184V6h20zM8 8c0 .304.06.612.258.842 2.716 2.854 6.682 5.548 6.742 7.974V21l2-1.5v-2.684c.066-2.658 4.058-5.154 6.742-7.974.198-.23.258-.538.258-.842z'/%3E%3C/svg%3E")}.ag-icon-first:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Efirst%3C/title%3E%3Cpath d='M24.354 8.708 17.06 16l7.294 7.292-1.416 1.416L14.232 16l8.706-8.708zM9.646 8v16h-2V8z'/%3E%3C/svg%3E")}.ag-icon-group:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Egroup%3C/title%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0M7.006 4c-1.57.02-2.946 1.348-3.004 2.922-.078 6.078-.23 12.16.002 18.234.094 1.484 1.354 2.746 2.84 2.84 6.1.232 12.212.232 18.312 0 1.48-.094 2.746-1.35 2.84-2.84.232-6.1.232-12.212 0-18.312-.094-1.48-1.35-2.746-2.84-2.84C19.11 3.774 13.056 4 7.006 4M14 21h-4v-2h4zm12 0H16v-2h10zm-12-4h-4v-2h4zm12 0H16v-2h10zm-16-4H6v-2h4zm16 0H12v-2h14z'/%3E%3C/svg%3E")}.ag-icon-last:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Elast%3C/title%3E%3Cpath d='m17.768 16-8.706 8.708-1.416-1.416L14.94 16 7.646 8.708l1.416-1.416zm6.586 8h-2V8h2z'/%3E%3C/svg%3E")}.ag-icon-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eleft%3C/title%3E%3Cpath d='m17.621 11-2 2h12.586v6H15.621l2 2-4.414 4.414L3.793 16l9.414-9.414zm-11 5 6.586 6.586L14.793 21l-4-4h15.414v-2H10.793l4-4-1.586-1.586z'/%3E%3C/svg%3E")}.ag-icon-linked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Elinked%3C/title%3E%3Cpath d='M17.138 13.418a1.03 1.03 0 0 0-.298.658s.125.096.226.178c1.372 1.114 2.033 3.039 1.582 4.796a4.7 4.7 0 0 1-1.205 2.123c-1.145 1.151-2.296 2.294-3.445 3.441-1.241 1.232-3.185 1.691-4.864 1.105-1.546-.54-2.756-1.938-3.048-3.572-.267-1.496.246-3.108 1.319-4.186l.578-.578-.03-.092a10.5 10.5 0 0 1-.452-2.3v-.005c-.776.775-1.621 1.489-2.275 2.396-1.817 2.522-1.643 6.323.706 8.669 1.813 1.811 4.708 2.462 7.171 1.517a6.75 6.75 0 0 0 2.336-1.518l3.427-3.424c1.939-1.954 2.533-5.126 1.294-7.674a6.8 6.8 0 0 0-2.071-2.481l-.003-.002zM21.265 4a6.8 6.8 0 0 0-4.734 1.964l-3.427 3.424c-1.961 1.977-2.52 5.092-1.32 7.619a6.8 6.8 0 0 0 2.098 2.537l.003.002c.32-.32.643-.637.96-.96.167-.172.27-.401.286-.64l-.204-.167c-1.603-1.287-2.215-3.68-1.316-5.616a4.7 4.7 0 0 1 .918-1.32c1.145-1.151 2.296-2.294 3.445-3.441 1.239-1.23 3.178-1.694 4.864-1.105 1.83.639 3.16 2.498 3.12 4.493a4.8 4.8 0 0 1-1.391 3.265l-.578.578.03.092c.235.743.387 1.519.452 2.3v.005c.732-.731 1.521-1.406 2.162-2.244 1.192-1.559 1.643-3.651 1.204-5.575a6.8 6.8 0 0 0-3.98-4.703 6.8 6.8 0 0 0-2.529-.506h-.061z'/%3E%3C/svg%3E")}.ag-icon-loading:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eloading%3C/title%3E%3Cpath d='M17 29h-2v-8h2zm-3.586-9L7 26.414 5.586 25 12 18.586zm13 5L25 26.414 18.586 20 20 18.586zM29 17h-8v-2h8zm-18 0H3v-2h8zm2.414-5L12 13.414 5.586 7 7 5.586zm13-5L20 13.414 18.586 12 25 5.586zM17 11h-2V3h2z'/%3E%3C/svg%3E")}.ag-icon-maximize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='3 3 26 26'%3E%3Ctitle%3Emaximize%3C/title%3E%3Cpath d='m7.54 17.4.1 6.98 6.96.1-2.24-2.24L16 18.6 13.4 16l-3.64 3.64zm16.92-2.8-.1-6.98-6.96-.1 2.24 2.24L16 13.4l2.6 2.6 3.64-3.64z'/%3E%3C/svg%3E")}.ag-icon-menu:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Emenu%3C/title%3E%3Cpath d='M26 23H6v-2h20zm0-6H6v-2h20zm0-6H6V9h20z'/%3E%3C/svg%3E")}.ag-icon-menu-alt:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none'%3E%3Cpath fill='%23000' d='M16 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4'/%3E%3C/svg%3E")}.ag-icon-minimize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='3 3 26 26'%3E%3Ctitle%3Eminimize%3C/title%3E%3Cpath d='m14.8 24.26-.1-6.96-6.96-.1 2.24 2.24-3.64 3.64 2.6 2.6 3.64-3.64zm2.4-16.52.1 6.96 6.96.1-2.24-2.24 3.64-3.64-2.6-2.6-3.64 3.64z'/%3E%3C/svg%3E")}.ag-icon-minus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.515 7.515c-4.683 4.682-4.683 12.288 0 16.97 4.682 4.683 12.288 4.683 16.97 0 4.683-4.682 4.683-12.288 0-16.97-4.682-4.683-12.288-4.683-16.97 0m1.414 1.414c3.903-3.903 10.239-3.903 14.142 0s3.903 10.239 0 14.142-10.239 3.903-14.142 0-3.903-10.239 0-14.142m-1.414 6.07h16.97v2.002H7.515z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-next:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enext%3C/title%3E%3Cpath d='m21.061 16-8.706 8.708-1.416-1.416L18.233 16l-7.294-7.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-none:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enone%3C/title%3E%3Cpath d='m10.044 21.258 4.478-4.198L16 18.444 9 25l-7-6.556 1.478-1.384 4.478 4.198V7h2.088zm14 3.742h-2.088V10.742l-4.478 4.198L16 13.556 23 7q3.5 3.28 7 6.556l-1.478 1.384-4.478-4.198z'/%3E%3C/svg%3E")}.ag-icon-not-allowed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enot-allowed%3C/title%3E%3Cpath d='M16.186 3.646c8.188.154 14.898 9.796 11.17 17.78-3.298 7.066-13.932 9.374-19.848 3.87-3.9-3.632-5.076-9.896-2.684-14.708 2.082-4.19 6.588-6.974 11.362-6.942m-.298 1.998c-6.922.132-12.578 8.308-9.33 15.052 3.342 6.934 15.246 7.646 18.932 0 3.076-6.386-1.988-15.1-9.602-15.052m7.596 6.422c2.864 5.33-1.744 13.186-8.306 12.536a8.6 8.6 0 0 1-3.232-.998l-1.266-.706L22.778 10.8q.351.633.706 1.266m-9.422 10.276c3.296 1.028 7.246-1.006 8.216-4.418a6.6 6.6 0 0 0-.056-3.742zm2.104-14.696a8.8 8.8 0 0 1 3.936 1.038l1.266.706L9.27 21.488c-3.018-5.41-.99-13.37 6.318-13.834q.289-.01.578-.008m-.31 2c-4.06.154-7.23 4.614-6.03 8.46l8.16-8.16a6.8 6.8 0 0 0-2.13-.3'/%3E%3C/svg%3E")}.ag-icon-paste:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epaste%3C/title%3E%3Cpath d='M20 6.5c0-1-1-3-4-3s-4 2-4 3H8c-2.21 0-4 1.79-4 4v14c0 2.21 1.79 4 4 4h16c2.21 0 4-1.79 4-4v-14c0-2.21-1.79-4-4-4zm-4 .546c.734 0 1.334.572 1.334 1.272S16.734 9.59 16 9.59s-1.334-.572-1.334-1.272.6-1.272 1.334-1.272M24 26.5H8a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2h2v4h12v-4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2'/%3E%3C/svg%3E")}.ag-icon-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epin%3C/title%3E%3Cpath d='m10.78 19.777-4.668-4.666s.032-1 .67-1.87c1.366-1.86 4.052-1.96 6.056-1.572l3.158-3.108c-.7-2.342 3.352-5.046 3.352-5.046l9.166 9.168q-.334.447-.67.894c-1.074 1.426-2.538 2.63-4.272 2.338l-3.32 3.218c.046.344.042.03.118 1.152.144 2.13-.64 4.324-2.632 5.34l-.746.364-4.798-4.798-7.292 7.294-1.416-1.416zm8.24-13.672c-.688.568-1.416 1.45-1.024 2.072l.49.722-4.986 4.988c-1.988-.506-4.346-.636-5.156.614l9.02 9.032q.14-.099.272-.21c1.226-1.08.764-3.04.498-4.9l4.79-4.79s1.47.938 2.936-.776l-6.79-6.79q-.026.019-.05.038'/%3E%3C/svg%3E")}.ag-icon-pivot:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epivot%3C/title%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0m2.966 7.954H9.892v18.136c5.086.13 10.18.098 15.264-.096 1.48-.094 2.746-1.35 2.84-2.84.192-5.064.226-10.134.098-15.2M3.968 24.1q.015.528.036 1.056c.094 1.484 1.354 2.746 2.84 2.84l1.012.036V24.1zM22 15.414l-.292.294-1.416-1.416L23 11.586l2.708 2.706-1.416 1.416-.292-.294v3.592c-.032 2.604-2.246 4.892-4.872 4.992L15.414 24l.294.292-1.416 1.416L11.586 23l2.706-2.708 1.416 1.416-.322.32c3.372.03 6.578-.164 6.614-3.034zM3.88 18.038c.002 1.346.012 2.694.038 4.04h3.938v-4.04zm.05-6.062a681 681 0 0 0-.044 4.042h3.97v-4.042zm5.962-7.99Q8.449 3.999 7.006 4c-1.57.02-2.946 1.348-3.004 2.922q-.02 1.517-.042 3.034h3.896v-2.02h2.036zm14.244-.016v3.966h3.898q-.017-.546-.038-1.092c-.094-1.48-1.35-2.746-2.84-2.84q-.51-.019-1.02-.034m-8.14-.054q-2.035.022-4.07.048v3.972h4.07zm6.106.008c-1.358-.022-2.714-.026-4.07-.022v4.034h4.07z'/%3E%3C/svg%3E")}.ag-icon-plus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.515 7.515c-4.683 4.682-4.683 12.288 0 16.97 4.682 4.683 12.288 4.683 16.97 0 4.683-4.682 4.683-12.288 0-16.97-4.682-4.683-12.288-4.683-16.97 0m1.414 1.414c3.903-3.903 10.239-3.903 14.142 0s3.903 10.239 0 14.142-10.239 3.903-14.142 0-3.903-10.239 0-14.142M15 15l-.001-7.485h2.002L17 15l7.485-.001v2.002L17 17l.001 7.485h-2.002L15 17l-7.485.001v-2.002z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-previous:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eprevious%3C/title%3E%3Cpath d='M21.061 8.708 13.767 16l7.294 7.292-1.416 1.416L10.939 16l8.706-8.708z'/%3E%3C/svg%3E")}.ag-icon-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eright%3C/title%3E%3Cpath d='m28.207 16-9.414 9.414L14.379 21l2-2H3.793v-6h12.586l-2-2 4.414-4.414zm-11-5 4 4H5.793v2h15.414l-4 4 1.586 1.586L25.379 16l-6.586-6.586z'/%3E%3C/svg%3E")}.ag-icon-save:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esave%3C/title%3E%3Cpath d='M25.333 16v9.333H6.666V16H3.999v9.333C3.999 26.8 5.199 28 6.666 28h18.667C26.8 28 28 26.8 28 25.333V16zm-8 .893 3.453-3.44 1.88 1.88L15.999 22l-6.667-6.667 1.88-1.88 3.453 3.44V4h2.667v12.893z'/%3E%3C/svg%3E")}.ag-icon-small-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-down%3C/title%3E%3Cpath d='M24.708 12.355 16 21.061l-8.708-8.706 1.416-1.416L16 18.233l7.292-7.294z'/%3E%3C/svg%3E")}.ag-icon-small-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-left%3C/title%3E%3Cpath d='M21.061 8.708 13.767 16l7.294 7.292-1.416 1.416L10.939 16l8.706-8.708z'/%3E%3C/svg%3E")}.ag-icon-small-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-right%3C/title%3E%3Cpath d='m21.061 16-8.706 8.708-1.416-1.416L18.233 16l-7.294-7.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-small-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-up%3C/title%3E%3Cpath d='m24.708 19.645-1.416 1.416L16 13.767l-7.292 7.294-1.416-1.416L16 10.939z'/%3E%3C/svg%3E")}.ag-icon-tick:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etick%3C/title%3E%3Cpath d='M24.708 10.855 13 22.561l-5.708-5.706 1.416-1.416L13 19.733 23.292 9.439z'/%3E%3C/svg%3E")}.ag-icon-tree-closed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-closed%3C/title%3E%3Cpath d='m21.061 16-8.706 8.708-1.416-1.416L18.233 16l-7.294-7.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-tree-indeterminate:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-indeterminate%3C/title%3E%3Cpath d='M6 15h20v2H6z'/%3E%3C/svg%3E")}.ag-icon-tree-open:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-open%3C/title%3E%3Cpath d='M24.708 12.355 16 21.061l-8.708-8.706 1.416-1.416L16 18.233l7.292-7.294z'/%3E%3C/svg%3E")}.ag-icon-unlinked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eunlinked%3C/title%3E%3Cpath d='M5.35 3.999a.2.2 0 0 0-.14.058c-.388.38-.768.768-1.152 1.152a.21.21 0 0 0-.002.288c7.459 7.506 14.965 14.965 22.447 22.447a.21.21 0 0 0 .288.002q.576-.574 1.151-1.151a.21.21 0 0 0 .002-.288C20.484 19.002 12.979 11.542 5.497 4.06a.2.2 0 0 0-.146-.061zm.611 12.548c-1.933 1.939-2.538 5.119-1.289 7.688a6.79 6.79 0 0 0 4.891 3.672 6.82 6.82 0 0 0 5.893-1.866l1.984-1.984-1.438-1.438-1.986 1.986c-1.486 1.476-3.993 1.81-5.834.629a4.73 4.73 0 0 1-2.024-2.853 4.76 4.76 0 0 1 1.241-4.393l1.986-1.986-1.438-1.438-1.984 1.984zM21.273 3.999a6.78 6.78 0 0 0-4.727 1.963l-1.984 1.984L16 9.384l1.985-1.985a4.74 4.74 0 0 1 2.776-1.338c1.974-.224 4.045.926 4.845 2.834.712 1.699.329 3.778-1.004 5.12L22.616 16l1.439 1.438q1-1 2-2c2.012-2.031 2.557-5.368 1.112-7.982-1.144-2.07-3.432-3.441-5.834-3.459h-.061z'/%3E%3C/svg%3E")}.ag-icon-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Easc%3C/title%3E%3Cpath d='m15 10.621-4.292 4.294-1.416-1.416L16 6.793l6.708 6.706-1.416 1.416L17 10.621v14.586h-2z'/%3E%3C/svg%3E")}.ag-icon-grip:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Egrip%3C/title%3E%3Cpath d='M8 24H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 18H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 12H6V8h2zm6 0h-2V8h2zm6 0h-2V8h2zm6 0h-2V8h2z'/%3E%3C/svg%3E")}.ag-icon-settings:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30zm-9 4c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3M2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2zm9-4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3'/%3E%3C/svg%3E")}.ag-icon-column-arrow:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M11 4a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 13a1 1 0 0 1 1-1h23.5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 4h18v24H2zm2 2v20h14V6zM26.793 13 23 9.207l1.414-1.414L29.621 13l-5.207 5.207L23 16.793z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-un-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='m6.112 15.111 3.272 3.271 1.436-1.402-2.476-2.479c.81-1.25 3.168-1.12 5.156-.614l4.986-4.988-.49-.722c-.392-.622.336-1.504 1.024-2.072l.008-.007.01-.006.032-.025 1.447 1.447 1.432-1.397-2.601-2.602s-4.052 2.704-3.352 5.046l-3.158 3.108c-2.004-.388-4.69-.288-6.056 1.572-.638.87-.67 1.87-.67 1.87m.581 11.582.014.014 5.502-5.501 4.783 4.783.746-.364c1.992-1.016 2.776-3.21 2.632-5.34-.055-.805-.068-.87-.088-.97-.008-.04-.017-.085-.03-.182l3.32-3.218c1.734.292 3.198-.912 4.272-2.338q.337-.447.67-.894l-.001-.001-.007-.007-.007-.007-.007-.007-3.87-3.87 1.585-1.584-1.414-1.414-14.381 14.38-1.237 1.209-5.69 5.687 1.417 1.416zM23.21 10.206l2.65 2.651c-1.465 1.714-2.935.776-2.935.776l-4.79 4.79q.041.291.087.583c.257 1.676.513 3.35-.585 4.317a4 4 0 0 1-.272.21l-3.739-3.744z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-pinned-top:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='m16.708 10.878 8.708 8.706L24 21l-6.292-6.294V27h-2V14.706L9.416 21 8 19.584q4.348-4.344 8.691-8.69zM25 6H8v2h17z'/%3E%3C/svg%3E")}.ag-icon-pinned-bottom:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M16.708 22.122 8 13.416 9.416 12l6.292 6.294V6h2v12.294L24 12l1.416 1.416-8.691 8.69zM7.416 28h17v-2h-17z'/%3E%3C/svg%3E")}.ag-icon-chevron-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M3.479 10.521a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-3.47-3.47-3.47 3.47a.75.75 0 0 1-1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M12.521 5.461a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l3.47 3.47 3.47-3.47a.75.75 0 0 1 1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M10.53 12.512a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06l-3.47 3.47 3.47 3.47a.75.75 0 0 1 0 1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M5.47 3.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06L8.94 8 5.47 4.53a.75.75 0 0 1 0-1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-filter-add:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M19.834 8H8c0 .304.06.612.258.842 2.716 2.854 6.682 5.548 6.742 7.974V21l2-1.5v-2.684c.056-2.267 2.968-4.417 5.49-6.75v3.087c-1.081.974-2.245 1.968-3.232 3.005a1.05 1.05 0 0 0-.258.682v3.66L13 25c0-2.74.066-5.482-.002-8.222a1.05 1.05 0 0 0-.256-.62C10.026 13.304 6.06 10.61 6 8.184V6h13.834z'/%3E%3Cpath fill='currentColor' d='M26 6h2.946v2.002H26v3.313h-2.002V8.002h-2.946V6h2.946V3.04H26z'/%3E%3C/svg%3E")}.ag-icon-edit:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M23.182 5a3.82 3.82 0 0 1 2.83 6.383l-.131.137-2.09 2.088a1 1 0 0 1-.084.099 1 1 0 0 1-.098.084L12.533 24.869a3 3 0 0 1-1.245.746l-4.353 1.32-.003.002a1.5 1.5 0 0 1-1.87-1.867l.003-.004 1.32-4.352v-.003l.06-.174c.13-.344.321-.661.565-.936l.126-.135L18.209 8.39a1 1 0 0 1 .18-.181l2.092-2.09.137-.132A3.82 3.82 0 0 1 23.182 5M8.548 20.883a1 1 0 0 0-.25.415l-1.049 3.451 3.457-1.048.114-.042q.17-.076.301-.206l10.458-10.46-2.572-2.572zM23.182 7c-.482 0-.946.19-1.287.531v.001l-1.474 1.475 2.572 2.572 1.474-1.474.121-.133A1.82 1.82 0 0 0 23.182 7'/%3E%3C/svg%3E")}`;
// packages/ag-grid-community/src/theming/parts/icon-set/balham/icon-set-balham.ts
var $437b23f6a393c3bf$var$iconSetBalham = /* @__PURE__ */ $437b23f6a393c3bf$export$6e6f0e372f4cb988({
    feature: "iconSet",
    css: $437b23f6a393c3bf$var$iconSetBalhamCSS
});
// packages/ag-grid-community/src/theming/parts/icon-set/alpine/icon-set-alpine.css-GENERATED.ts
var $437b23f6a393c3bf$var$iconSetAlpineCSS = /*css*/ `.ag-icon-aggregation:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24 6H8v2l8 8-8 8v2h16v-2H11l8-8-8-8h13z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-arrows:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.515 11.171 2.687 16l4.828 4.829-1.414 1.414L-.142 16l6.243-6.243zm16.97 0 1.414-1.414L32.142 16l-6.243 6.243-1.414-1.414L29.313 16zM16.028 13.2l2.829 2.828-2.829 2.829-2.828-2.829zm-4.857 11.285L16 29.313l4.829-4.828 1.414 1.414L16 32.142l-6.243-6.243zm0-16.97L9.757 6.101 16-.142l6.243 6.243-1.414 1.414L16 2.687z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-asc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333 5.332 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-cancel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16 2.667A13.32 13.32 0 0 0 2.667 16c0 7.373 5.96 13.333 13.333 13.333S29.333 23.373 29.333 16 23.373 2.667 16 2.667m6.667 18.12-1.88 1.88L16 17.88l-4.787 4.787-1.88-1.88L14.12 16l-4.787-4.787 1.88-1.88L16 14.12l4.787-4.787 1.88 1.88L17.88 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-chart:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Echart%3C/title%3E%3Cg fill='%23000' fill-rule='nonzero'%3E%3Cpath d='M14 7h4v18h-4zM8 17h4v8H8zM20 13h4v12h-4z'/%3E%3C/g%3E%3C/svg%3E")}.ag-icon-color-picker:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M23.907 17.587 10.574 4.254l-1.88 1.88 3.173 3.173-8.28 8.28 10.16 10.16zm-16.547 0 6.387-6.387 6.387 6.387zm18.387 2s-2.667 2.893-2.667 4.667c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667c0-1.773-2.667-4.667-2.667-4.667' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-columns:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M26 25H6V7h20zM12 11H8v12h4zm6 0h-4v12h4zm6 12V11h-4v12z' style='fill-rule:nonzero' transform='translate(0 -1)'/%3E%3C/svg%3E")}.ag-icon-contracted:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m12 6 10 10-10 10-2-2 8-8-8-8z'/%3E%3C/svg%3E")}.ag-icon-copy:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M22 1.333H6A2.675 2.675 0 0 0 3.333 4v18.667H6V4h16zm4 5.334H11.333a2.675 2.675 0 0 0-2.667 2.667v18.667c0 1.467 1.2 2.667 2.667 2.667H26c1.467 0 2.667-1.2 2.667-2.667V9.334c0-1.467-1.2-2.667-2.667-2.667M26 28H11.333V9.333H26z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-cross:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M15.984 13.894 27.05 2.828l2.122 2.122-11.066 11.066 11.066 11.066-2.122 2.12-11.066-11.066L4.918 29.202l-2.12-2.12 11.066-11.066L2.798 4.95l2.12-2.122z'/%3E%3C/svg%3E")}.ag-icon-csv:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='matrix(.06285 0 0 .06285 3.934 -.054)'/%3E%3Cpath d='M.688-.226a.2.2 0 0 1-.017.074.28.28 0 0 1-.145.14.412.412 0 0 1-.234.013.28.28 0 0 1-.202-.168.468.468 0 0 1-.04-.19q0-.086.025-.155a.319.319 0 0 1 .182-.191.4.4 0 0 1 .134-.025q.087 0 .155.035a.3.3 0 0 1 .104.085.17.17 0 0 1 .036.097.06.06 0 0 1-.018.044.06.06 0 0 1-.042.019.06.06 0 0 1-.042-.013.2.2 0 0 1-.031-.046.2.2 0 0 0-.066-.079.16.16 0 0 0-.095-.027.17.17 0 0 0-.142.068.3.3 0 0 0-.053.193.4.4 0 0 0 .023.139.2.2 0 0 0 .067.083.2.2 0 0 0 .1.027q.063 0 .106-.031a.2.2 0 0 0 .065-.091.2.2 0 0 1 .023-.046q.014-.018.044-.018a.06.06 0 0 1 .044.018.06.06 0 0 1 .019.045' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 7.122 25.977)'/%3E%3Cpath d='M.622-.215a.2.2 0 0 1-.033.117.23.23 0 0 1-.098.081.4.4 0 0 1-.153.029.34.34 0 0 1-.175-.04.23.23 0 0 1-.079-.077.17.17 0 0 1-.031-.093q0-.027.019-.045a.06.06 0 0 1 .046-.019.06.06 0 0 1 .039.014.1.1 0 0 1 .027.044.3.3 0 0 0 .03.057q.015.023.044.038.03.015.076.015.065 0 .105-.03a.09.09 0 0 0 .04-.075.08.08 0 0 0-.022-.058.14.14 0 0 0-.056-.034 1 1 0 0 0-.092-.025.7.7 0 0 1-.129-.042.2.2 0 0 1-.083-.066.17.17 0 0 1-.03-.104q0-.058.032-.105a.2.2 0 0 1 .093-.07.4.4 0 0 1 .144-.025q.066 0 .114.016a.3.3 0 0 1 .08.044.2.2 0 0 1 .046.057q.015.03.015.058a.07.07 0 0 1-.018.046.06.06 0 0 1-.046.021q-.025 0-.038-.012a.2.2 0 0 1-.028-.041.2.2 0 0 0-.047-.063Q.387-.625.326-.625a.15.15 0 0 0-.09.025q-.035.024-.035.059 0 .021.012.037a.1.1 0 0 0 .032.027.4.4 0 0 0 .111.036q.06.015.11.031.048.018.083.042a.2.2 0 0 1 .054.062.2.2 0 0 1 .019.091' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 13.339 25.977)'/%3E%3Cpath d='m.184-.633.162.48.163-.483q.013-.038.019-.053a.062.062 0 0 1 .061-.039q.018 0 .034.009a.1.1 0 0 1 .025.025q.009.015.009.031L.654-.64l-.007.025-.009.024-.173.468-.019.051a.2.2 0 0 1-.021.042.1.1 0 0 1-.033.03.1.1 0 0 1-.049.012.1.1 0 0 1-.05-.011A.1.1 0 0 1 .26-.03a.2.2 0 0 1-.021-.042L.22-.123.05-.587.041-.612.033-.638.03-.662q0-.025.02-.046a.07.07 0 0 1 .05-.02q.037 0 .053.023.015.023.031.072' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 18.94 25.977)'/%3E%3C/svg%3E")}.ag-icon-cut:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M13.775 15.198 3.835 2.945a1.501 1.501 0 0 1 2.33-1.89l14.997 18.488A6.003 6.003 0 0 1 29.657 25c0 3.311-2.688 6-6 6s-6-2.689-6-6c0-1.335.437-2.569 1.176-3.566l-3.127-3.855-3.001 3.7A5.97 5.97 0 0 1 14 25c0 3.311-2.689 6-6 6s-6-2.689-6-6a6.003 6.003 0 0 1 8.315-5.536zm9.882 6.702a3.1 3.1 0 0 0-3.1 3.1c0 1.711 1.389 3.1 3.1 3.1s3.1-1.389 3.1-3.1-1.389-3.1-3.1-3.1M8 21.95a3.05 3.05 0 1 0 .001 6.101A3.05 3.05 0 0 0 8 21.95m9.63-11.505 1.932 2.381 8.015-9.881a1.5 1.5 0 0 0-2.329-1.89z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-desc:before,.ag-icon-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m26.667 16-1.88-1.88-7.453 7.44V5.333h-2.667V21.56l-7.44-7.453L5.334 16l10.667 10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-excel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='matrix(.06285 0 0 .06285 3.934 -.054)'/%3E%3Cpath d='m.052-.139.16-.234-.135-.208a.4.4 0 0 1-.028-.052.1.1 0 0 1-.01-.042.05.05 0 0 1 .018-.037.07.07 0 0 1 .045-.016q.03 0 .047.018a1 1 0 0 1 .047.066l.107.174.115-.174.024-.038.019-.026.021-.015a.1.1 0 0 1 .027-.005.06.06 0 0 1 .044.016.05.05 0 0 1 .018.039q0 .033-.038.089l-.141.211.152.234a.3.3 0 0 1 .03.051.1.1 0 0 1 .009.038.1.1 0 0 1-.008.031.1.1 0 0 1-.024.023.1.1 0 0 1-.034.008.1.1 0 0 1-.035-.008.1.1 0 0 1-.023-.022L.427-.067.301-.265l-.134.204-.022.034-.016.019a.1.1 0 0 1-.022.015.1.1 0 0 1-.03.005.06.06 0 0 1-.044-.016.06.06 0 0 1-.017-.047q0-.036.036-.088' style='fill-rule:nonzero' transform='matrix(17.82892 0 0 16.50777 10.371 25.928)'/%3E%3C/svg%3E")}.ag-icon-expanded:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M20 26 10 16 20 6l2 2-8 8 8 8z'/%3E%3C/svg%3E")}.ag-icon-eye-slash:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye-slash%3C/title%3E%3Cpath fill='%23000' fill-rule='nonzero' d='M8.95 10.364 7 8.414 8.414 7l2.32 2.32A13.2 13.2 0 0 1 16.5 8c5.608 0 10.542 3.515 12.381 8.667L29 17l-.119.333a13 13 0 0 1-4.255 5.879l1.466 1.466-1.414 1.414-1.754-1.753A13.2 13.2 0 0 1 16.5 26c-5.608 0-10.542-3.515-12.381-8.667L4 17l.119-.333a13 13 0 0 1 4.83-6.303m1.445 1.445A11.02 11.02 0 0 0 6.148 17c1.646 4.177 5.728 7 10.352 7 1.76 0 3.441-.409 4.94-1.146l-1.878-1.878A5.06 5.06 0 0 1 16.5 22c-2.789 0-5.05-2.239-5.05-5 0-1.158.398-2.223 1.065-3.07zm1.855-.974 1.794 1.795A5.07 5.07 0 0 1 16.5 12c2.789 0 5.05 2.239 5.05 5 0 .9-.24 1.745-.661 2.474l2.305 2.306A11 11 0 0 0 26.852 17c-1.646-4.177-5.728-7-10.352-7-1.495 0-2.933.295-4.25.835'/%3E%3C/svg%3E")}.ag-icon-eye:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16.5 23c4.624 0 8.706-2.823 10.352-7-1.646-4.177-5.728-7-10.352-7s-8.706 2.823-10.352 7c1.646 4.177 5.728 7 10.352 7M4.119 15.667C5.958 10.515 10.892 7 16.5 7s10.542 3.515 12.381 8.667L29 16l-.119.333C27.042 21.485 22.108 25 16.5 25S5.958 21.485 4.119 16.333L4 16zM16.5 21c2.789 0 5.049-2.239 5.049-5s-2.26-5-5.049-5-5.049 2.239-5.049 5 2.26 5 5.049 5' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-filter:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m28 8-8 8v5l-6 6V16L6 8V6h22zM9 8l7 7v7l2-2v-5l7-7z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-first:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24.273 22.12 18.153 16l6.12-6.12L22.393 8l-8 8 8 8zM7.727 8h2.667v16H7.727z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-group:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14 7v1H9V7zm0-3v1H5.001V4zm-7 7H5v-1h2zm0-3H5V7h2zM3 5H1V4h2zm11 5v1H9v-1zm-7 4H5v-1h2zm7-1v1H9v-1z' style='fill-rule:nonzero' transform='matrix(2 0 0 2 0 -2)'/%3E%3C/svg%3E")}.ag-icon-last:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m7.727 9.88 6.12 6.12-6.12 6.12L9.607 24l8-8-8-8zM21.607 8h2.667v16h-2.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M26.667 14.667H10.44l7.453-7.453L16 5.334 5.333 16.001 16 26.668l1.88-1.88-7.44-7.453h16.227z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-linked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M5.2 16a4.136 4.136 0 0 1 4.133-4.133h5.333V9.334H9.333a6.67 6.67 0 0 0-6.667 6.667 6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.333A4.136 4.136 0 0 1 5.2 16.002zm5.467 1.333h10.667v-2.667H10.667zm12-8h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133 4.136 4.136 0 0 1-4.133 4.133h-5.333v2.533h5.333a6.67 6.67 0 0 0 6.667-6.667 6.67 6.67 0 0 0-6.667-6.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-loading:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M17 29h-2v-8h2zm-3.586-9L7 26.414 5.586 25 12 18.586zm13 5L25 26.414 18.586 20 20 18.586zM29 17h-8v-2h8zm-18 0H3v-2h8zm2.414-5L12 13.414 5.586 7 7 5.586zm13-5L20 13.414 18.586 12 25 5.586zM17 11h-2V3h2z' style='fill-rule:nonzero' transform='translate(-3.692 -3.692)scale(1.23077)'/%3E%3C/svg%3E")}.ag-icon-maximize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14 30H2V18h2.828v7.05l8.254-8.252 2.12 2.12-8.252 8.254H14zm4-28h12v12h-2.828V6.95l-8.254 8.252-2.12-2.12 8.252-8.254H18z'/%3E%3C/svg%3E")}.ag-icon-menu:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M20 13H0v-2h20zm0-6H0V5h20zm0-6H0v-2h20z' style='fill-rule:nonzero' transform='translate(6 9)'/%3E%3C/svg%3E")}.ag-icon-menu-alt:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M16 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 27a3 3 0 1 0 0-6 3 3 0 0 0 0 6'/%3E%3C/svg%3E")}.ag-icon-minimize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M2 18h12v12h-2.828v-7.05l-8.254 8.252-2.12-2.12 8.252-8.254H2zm28-4H18V2h2.828v7.05L29.082.798l2.12 2.12-8.252 8.254H30z'/%3E%3C/svg%3E")}.ag-icon-minus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658H7.901v-2.658z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-next:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M10.94 6 9.06 7.88 17.167 16 9.06 24.12 10.94 26l10-10z' style='fill-rule:nonzero' transform='translate(1)'/%3E%3C/svg%3E")}.ag-icon-none:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enone%3C/title%3E%3Cg fill='%23000' fill-rule='nonzero'%3E%3Cpath d='M23.708 14.645 16 6.939l-7.708 7.706 1.416 1.416L16 9.767l6.292 6.294zM23.708 20.355 16 28.061l-7.708-7.706 1.416-1.416L16 25.233l6.292-6.294z'/%3E%3C/g%3E%3C/svg%3E")}.ag-icon-not-allowed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667M5.333 16c0-5.893 4.773-10.667 10.667-10.667 2.467 0 4.733.84 6.533 2.253L7.586 22.533A10.54 10.54 0 0 1 5.333 16M16 26.667c-2.467 0-4.733-.84-6.533-2.253L24.414 9.467A10.54 10.54 0 0 1 26.667 16c0 5.893-4.773 10.667-10.667 10.667' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-paste:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M25.334 4H19.76C19.2 2.453 17.733 1.333 16 1.333S12.8 2.453 12.24 4H6.667A2.675 2.675 0 0 0 4 6.667V28c0 1.467 1.2 2.667 2.667 2.667h18.667c1.467 0 2.667-1.2 2.667-2.667V6.667C28.001 5.2 26.801 4 25.334 4M16 4c.733 0 1.333.6 1.333 1.333s-.6 1.333-1.333 1.333-1.333-.6-1.333-1.333S15.267 4 16 4m9.333 24H6.666V6.667h2.667v4h13.333v-4h2.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m10.78 19.777-4.668-4.666s.032-1 .67-1.87c1.366-1.86 4.052-1.96 6.056-1.572l3.158-3.108c-.7-2.342 3.352-5.046 3.352-5.046l9.166 9.168q-.334.447-.67.894c-1.074 1.426-2.538 2.63-4.272 2.338l-3.32 3.218c.046.344.042.03.118 1.152.144 2.13-.64 4.324-2.632 5.34l-.746.364-4.798-4.798-7.292 7.294-1.416-1.416zm8.24-13.672c-.688.568-1.416 1.45-1.024 2.072l.49.722-4.986 4.988c-1.988-.506-4.346-.636-5.156.614l9.02 9.032q.14-.099.272-.21c1.226-1.08.764-3.04.498-4.9l4.79-4.79s1.47.938 2.936-.776l-6.79-6.79q-.026.019-.05.038' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-pivot:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0m2.966 7.954H9.892v18.136c5.086.13 10.18.098 15.264-.096 1.48-.094 2.746-1.35 2.84-2.84.192-5.064.226-10.134.098-15.2M3.968 24.1q.015.528.036 1.056c.094 1.484 1.354 2.746 2.84 2.84l1.012.036V24.1zM22 15.414l-.292.294-1.416-1.416L23 11.586l2.708 2.706-1.416 1.416-.292-.294v3.592c-.032 2.604-2.246 4.892-4.872 4.992L15.414 24l.294.292-1.416 1.416L11.586 23l2.706-2.708 1.416 1.416-.322.32c3.372.03 6.578-.164 6.614-3.034zM3.88 18.038c.002 1.346.012 2.694.038 4.04h3.938v-4.04zm.05-6.062a681 681 0 0 0-.044 4.042h3.97v-4.042zm5.962-7.99Q8.449 3.999 7.006 4c-1.57.02-2.946 1.348-3.004 2.922q-.02 1.517-.042 3.034h3.896v-2.02h2.036zm14.244-.016v3.966h3.898q-.017-.546-.038-1.092c-.094-1.48-1.35-2.746-2.84-2.84q-.51-.019-1.02-.034m-8.14-.054q-2.035.022-4.07.048v3.972h4.07zm6.106.008a213 213 0 0 0-4.07-.022v4.034h4.07z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-plus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658h-6.77v6.77h-2.658v-6.77h-6.77v-2.658h6.77v-6.77h2.658v6.77z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-previous:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M21.94 7.88 20.06 6l-10 10 10 10 1.88-1.88L13.833 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m16 5.333-1.88 1.88 7.44 7.453H5.333v2.667H21.56l-7.44 7.453 1.88 1.88 10.667-10.667L16 5.332z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-save:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M15.708 2.355 8 10.061.292 2.355 1.708.939 8 7.233 14.292.939z' style='fill-rule:nonzero' transform='translate(8 14)'/%3E%3Cpath d='M5 26h22v2H5zM15 4h2v18h-2z'/%3E%3C/svg%3E")}.ag-icon-small-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.334 10.667 16 21.334l8.667-10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M21.333 7.334 10.666 16l10.667 8.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M10.667 24.666 21.334 16 10.667 7.333z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.334 21.333 16 10.666l8.667 10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-tick:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M11.586 22.96 27.718 6.828 29.84 8.95 11.586 27.202 2.4 18.016l2.12-2.122z'/%3E%3C/svg%3E")}.ag-icon-tree-closed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m11.94 6-1.88 1.88L18.167 16l-8.107 8.12L11.94 26l10-10z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-tree-indeterminate:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6 13.5h20v3H6z'/%3E%3C/svg%3E")}.ag-icon-tree-open:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24.12 9.06 16 17.167 7.88 9.06 6 10.94l10 10 10-10z' style='fill-rule:nonzero' transform='translate(0 1)'/%3E%3C/svg%3E")}.ag-icon-unlinked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M22.667 9.333h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133c0 1.907-1.307 3.507-3.08 3.973l1.947 1.947c2.173-1.107 3.667-3.32 3.667-5.92a6.67 6.67 0 0 0-6.667-6.667zm-1.334 5.334h-2.92l2.667 2.667h.253zM2.667 5.693 6.814 9.84A6.65 6.65 0 0 0 2.667 16a6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.334a4.136 4.136 0 0 1-4.133-4.133c0-2.12 1.613-3.867 3.68-4.093l2.76 2.76h-.973v2.667h3.64l3.027 3.027v2.307h2.307l5.347 5.333 1.68-1.68L4.362 4.002 2.669 5.695z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333 5.332 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-grip:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M8 24H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 18H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 12H6V8h2zm6 0h-2V8h2zm6 0h-2V8h2zm6 0h-2V8h2z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-settings:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30zm-9 4c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3M2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2zm9-4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3'/%3E%3C/svg%3E")}.ag-icon-column-arrow:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M11 4a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 13a1 1 0 0 1 1-1h23.5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 4h18v24H2zm2 2v20h14V6zM26.793 13 23 9.207l1.414-1.414L29.621 13l-5.207 5.207L23 16.793z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-un-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='m6.112 15.111 3.272 3.271 1.436-1.402-2.476-2.479c.81-1.25 3.168-1.12 5.156-.614l4.986-4.988-.49-.722c-.392-.622.336-1.504 1.024-2.072l.008-.007.01-.006.032-.025 1.447 1.447 1.432-1.397-2.601-2.602s-4.052 2.704-3.352 5.046l-3.158 3.108c-2.004-.388-4.69-.288-6.056 1.572-.638.87-.67 1.87-.67 1.87m.581 11.582.014.014 5.502-5.501 4.783 4.783.746-.364c1.992-1.016 2.776-3.21 2.632-5.34-.055-.805-.068-.87-.088-.97-.008-.04-.017-.085-.03-.182l3.32-3.218c1.734.292 3.198-.912 4.272-2.338q.337-.447.67-.894l-.001-.001-.007-.007-.007-.007-.007-.007-3.87-3.87 1.585-1.584-1.414-1.414-14.381 14.38-1.237 1.209-5.69 5.687 1.417 1.416zM23.21 10.206l2.65 2.651c-1.465 1.714-2.935.776-2.935.776l-4.79 4.79q.041.291.087.583c.257 1.676.513 3.35-.585 4.317a4 4 0 0 1-.272.21l-3.739-3.744z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-pinned-top:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='m16.708 10.878 8.708 8.706L24 21l-6.292-6.294V27h-2V14.706L9.416 21 8 19.584q4.348-4.344 8.691-8.69zM25 6H8v2h17z'/%3E%3C/svg%3E")}.ag-icon-pinned-bottom:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M16.708 22.122 8 13.416 9.416 12l6.292 6.294V6h2v12.294L24 12l1.416 1.416-8.691 8.69zM7.416 28h17v-2h-17z'/%3E%3C/svg%3E")}.ag-icon-chevron-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M3.479 10.521a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-3.47-3.47-3.47 3.47a.75.75 0 0 1-1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M12.521 5.461a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l3.47 3.47 3.47-3.47a.75.75 0 0 1 1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M10.53 12.512a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06l-3.47 3.47 3.47 3.47a.75.75 0 0 1 0 1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M5.47 3.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06L8.94 8 5.47 4.53a.75.75 0 0 1 0-1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-filter-add:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M19.834 8H8c0 .304.06.612.258.842 2.716 2.854 6.682 5.548 6.742 7.974V21l2-1.5v-2.684c.056-2.267 2.968-4.417 5.49-6.75v3.087c-1.081.974-2.245 1.968-3.232 3.005a1.05 1.05 0 0 0-.258.682v3.66L13 25c0-2.74.066-5.482-.002-8.222a1.05 1.05 0 0 0-.256-.62C10.026 13.304 6.06 10.61 6 8.184V6h13.834z'/%3E%3Cpath fill='currentColor' d='M26 6h2.946v2.002H26v3.313h-2.002V8.002h-2.946V6h2.946V3.04H26z'/%3E%3C/svg%3E")}.ag-icon-edit:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M6.222 25.778h1.611l14.834-14.811-1.611-1.611-14.834 14.81zM4 28v-4.733L22.644 4.656a2.26 2.26 0 0 1 1.567-.634q.423 0 .833.167.412.166.734.478l1.589 1.6q.333.322.483.733t.15.822q0 .423-.161.839-.162.416-.472.728L8.733 28zm17.856-17.833-.8-.811 1.61 1.61z'/%3E%3C/svg%3E")}`;
// packages/ag-grid-community/src/theming/parts/icon-set/alpine/icon-set-alpine.ts
var $437b23f6a393c3bf$export$9bb4a1bee1653083 = /* @__PURE__ */ $437b23f6a393c3bf$export$6e6f0e372f4cb988({
    feature: "iconSet",
    css: $437b23f6a393c3bf$var$iconSetAlpineCSS
});
// packages/ag-grid-community/src/theming/parts/icon-set/material/icon-set-material.css-GENERATED.ts
var $437b23f6a393c3bf$var$iconSetMaterialCSS = /*css*/ `.ag-icon-aggregation:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eaggregation%3C/title%3E%3Cpath d='M24 5.333H8V8l8.667 8L8 24v2.667h16v-4h-9.333L21.334 16l-6.667-6.667H24z'/%3E%3C/svg%3E")}.ag-icon-arrows:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Earrows%3C/title%3E%3Cpath d='M13.333 11.556h5.333V8h3.556L16 1.778 9.778 8h3.556zm-1.777 1.777H8V9.777l-6.222 6.222L8 22.221v-3.556h3.556zM30.222 16 24 9.778v3.556h-3.556v5.333H24v3.556l6.222-6.222zm-11.555 4.444h-5.333V24H9.778L16 30.222 22.222 24h-3.556z'/%3E%3C/svg%3E")}.ag-icon-asc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Easc%3C/title%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333z'/%3E%3C/svg%3E")}.ag-icon-cancel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecancel%3C/title%3E%3Cpath d='M16 2.667C8.627 2.667 2.667 8.627 2.667 16S8.627 29.333 16 29.333 29.333 23.373 29.333 16 23.373 2.667 16 2.667m6.667 18.12-1.88 1.88L16 17.88l-4.787 4.787-1.88-1.88L14.12 16l-4.787-4.787 1.88-1.88L16 14.12l4.787-4.787 1.88 1.88L17.88 16z'/%3E%3C/svg%3E")}.ag-icon-chart:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Echart%3C/title%3E%3Cpath d='M6.667 12.267h4v13.067h-4zm7.466-5.6h3.733v18.667h-3.733zM21.6 17.333h3.733v8H21.6z'/%3E%3C/svg%3E")}.ag-icon-color-picker:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecolor-picker%3C/title%3E%3Cpath d='M23.907 17.587 10.574 4.254l-1.88 1.88 3.173 3.173-8.28 8.28 10.16 10.16zm-16.547 0 6.387-6.387 6.387 6.387H7.361zm18.387 2s-2.667 2.893-2.667 4.667c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667c0-1.773-2.667-4.667-2.667-4.667'/%3E%3C/svg%3E")}.ag-icon-columns:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecolumns%3C/title%3E%3Cpath d='M5.333 10.667h5.333V5.334H5.333zm8 16h5.333v-5.333h-5.333zm-8 0h5.333v-5.333H5.333zm0-8h5.333v-5.333H5.333zm8 0h5.333v-5.333h-5.333zm8-13.334v5.333h5.333V5.333zm-8 5.334h5.333V5.334h-5.333zm8 8h5.333v-5.333h-5.333zm0 8h5.333v-5.333h-5.333z'/%3E%3C/svg%3E")}.ag-icon-contracted:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Econtracted%3C/title%3E%3Cpath d='m12.94 8-1.88 1.88L17.167 16l-6.107 6.12L12.94 24l8-8z'/%3E%3C/svg%3E")}.ag-icon-copy:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecopy%3C/title%3E%3Cpath d='M22 1.333H6A2.675 2.675 0 0 0 3.333 4v18.667H6V4h16zm4 5.334H11.333a2.675 2.675 0 0 0-2.667 2.667v18.667c0 1.467 1.2 2.667 2.667 2.667H26c1.467 0 2.667-1.2 2.667-2.667V9.334c0-1.467-1.2-2.667-2.667-2.667M26 28H11.333V9.333H26z'/%3E%3C/svg%3E")}.ag-icon-cross:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecross%3C/title%3E%3Cpath d='m25.333 8.547-1.88-1.88L16 14.12 8.547 6.667l-1.88 1.88L14.12 16l-7.453 7.453 1.88 1.88L16 17.88l7.453 7.453 1.88-1.88L17.88 16z'/%3E%3C/svg%3E")}.ag-icon-csv:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='matrix(.06285 0 0 .06285 3.934 -.054)'/%3E%3Cpath d='M.688-.226a.2.2 0 0 1-.017.074.28.28 0 0 1-.145.14.412.412 0 0 1-.234.013.28.28 0 0 1-.202-.168.468.468 0 0 1-.04-.19q0-.086.025-.155a.319.319 0 0 1 .182-.191.4.4 0 0 1 .134-.025q.087 0 .155.035a.3.3 0 0 1 .104.085.17.17 0 0 1 .036.097.06.06 0 0 1-.018.044.06.06 0 0 1-.042.019.06.06 0 0 1-.042-.013.2.2 0 0 1-.031-.046.2.2 0 0 0-.066-.079.16.16 0 0 0-.095-.027.17.17 0 0 0-.142.068.3.3 0 0 0-.053.193.4.4 0 0 0 .023.139.2.2 0 0 0 .067.083.2.2 0 0 0 .1.027q.063 0 .106-.031a.2.2 0 0 0 .065-.091.2.2 0 0 1 .023-.046q.014-.018.044-.018a.06.06 0 0 1 .044.018.06.06 0 0 1 .019.045' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 7.122 25.977)'/%3E%3Cpath d='M.622-.215a.2.2 0 0 1-.033.117.23.23 0 0 1-.098.081.4.4 0 0 1-.153.029.34.34 0 0 1-.175-.04.23.23 0 0 1-.079-.077.17.17 0 0 1-.031-.093q0-.027.019-.045a.06.06 0 0 1 .046-.019.06.06 0 0 1 .039.014.1.1 0 0 1 .027.044.3.3 0 0 0 .03.057q.015.023.044.038.03.015.076.015.065 0 .105-.03a.09.09 0 0 0 .04-.075.08.08 0 0 0-.022-.058.14.14 0 0 0-.056-.034 1 1 0 0 0-.092-.025.7.7 0 0 1-.129-.042.2.2 0 0 1-.083-.066.17.17 0 0 1-.03-.104q0-.058.032-.105a.2.2 0 0 1 .093-.07.4.4 0 0 1 .144-.025q.066 0 .114.016a.3.3 0 0 1 .08.044.2.2 0 0 1 .046.057q.015.03.015.058a.07.07 0 0 1-.018.046.06.06 0 0 1-.046.021q-.025 0-.038-.012a.2.2 0 0 1-.028-.041.2.2 0 0 0-.047-.063Q.387-.625.326-.625a.15.15 0 0 0-.09.025q-.035.024-.035.059 0 .021.012.037a.1.1 0 0 0 .032.027.4.4 0 0 0 .111.036q.06.015.11.031.048.018.083.042a.2.2 0 0 1 .054.062.2.2 0 0 1 .019.091' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 13.339 25.977)'/%3E%3Cpath d='m.184-.633.162.48.163-.483q.013-.038.019-.053a.062.062 0 0 1 .061-.039q.018 0 .034.009a.1.1 0 0 1 .025.025q.009.015.009.031L.654-.64l-.007.025-.009.024-.173.468-.019.051a.2.2 0 0 1-.021.042.1.1 0 0 1-.033.03.1.1 0 0 1-.049.012.1.1 0 0 1-.05-.011A.1.1 0 0 1 .26-.03a.2.2 0 0 1-.021-.042L.22-.123.05-.587.041-.612.033-.638.03-.662q0-.025.02-.046a.07.07 0 0 1 .05-.02q.037 0 .053.023.015.023.031.072' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 18.94 25.977)'/%3E%3C/svg%3E")}.ag-icon-cut:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m19 3-6 6 2 2 7-7V3m-10 9.5a.503.503 0 0 1-.5-.5c0-.274.226-.5.5-.5s.5.226.5.5-.226.5-.5.5M6 20c-1.097 0-2-.903-2-2a2 2 0 0 1 2-2c1.097 0 2 .903 2 2a2 2 0 0 1-2 2M6 8c-1.097 0-2-.903-2-2a2 2 0 0 1 2-2c1.097 0 2 .903 2 2a2 2 0 0 1-2 2m3.64-.36c.23-.5.36-1.05.36-1.64 0-2.194-1.806-4-4-4S2 3.806 2 6s1.806 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.194 0-4 1.806-4 4s1.806 4 4 4 4-1.806 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1z' style='fill-rule:nonzero' transform='translate(4 4)'/%3E%3C/svg%3E")}.ag-icon-desc:before,.ag-icon-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Edesc%3C/title%3E%3Cpath d='m26.667 16-1.88-1.88-7.453 7.44V5.333h-2.667V21.56l-7.44-7.453L5.334 16l10.667 10.667L26.668 16z'/%3E%3C/svg%3E")}.ag-icon-excel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='matrix(.06285 0 0 .06285 3.934 -.054)'/%3E%3Cpath d='m.052-.139.16-.234-.135-.208a.4.4 0 0 1-.028-.052.1.1 0 0 1-.01-.042.05.05 0 0 1 .018-.037.07.07 0 0 1 .045-.016q.03 0 .047.018a1 1 0 0 1 .047.066l.107.174.115-.174.024-.038.019-.026.021-.015a.1.1 0 0 1 .027-.005.06.06 0 0 1 .044.016.05.05 0 0 1 .018.039q0 .033-.038.089l-.141.211.152.234a.3.3 0 0 1 .03.051.1.1 0 0 1 .009.038.1.1 0 0 1-.008.031.1.1 0 0 1-.024.023.1.1 0 0 1-.034.008.1.1 0 0 1-.035-.008.1.1 0 0 1-.023-.022L.427-.067.301-.265l-.134.204-.022.034-.016.019a.1.1 0 0 1-.022.015.1.1 0 0 1-.03.005.06.06 0 0 1-.044-.016.06.06 0 0 1-.017-.047q0-.036.036-.088' style='fill-rule:nonzero' transform='matrix(17.82892 0 0 16.50777 10.371 25.928)'/%3E%3C/svg%3E")}.ag-icon-expanded:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eexpanded%3C/title%3E%3Cpath d='M20.94 9.88 19.06 8l-8 8 8 8 1.88-1.88L14.833 16z'/%3E%3C/svg%3E")}.ag-icon-eye-slash:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye-slash%3C/title%3E%3Cpath d='M21.106 15.088A5.19 5.19 0 0 0 16 10.814a5.17 5.17 0 0 0-3.668 1.522L9.866 9.868a12.2 12.2 0 0 1 6.133-1.646c5.186 0 9.614 3.225 11.408 7.778a12.34 12.34 0 0 1-5.276 6.133l-2.468-2.466a5.17 5.17 0 0 0 1.449-2.802h-2.123c-.148.508-.42.964-.782 1.33l-1.33-1.33h-2.514l2.196 2.196q-.272.049-.56.05a3.11 3.11 0 0 1-2.99-2.245h-2.123a5.19 5.19 0 0 0 7.3 3.836l2.247 2.247a12.2 12.2 0 0 1-4.434.828c-5.186 0-9.614-3.225-11.408-7.778a12.3 12.3 0 0 1 3.781-5.111l2.924 2.924a5.1 5.1 0 0 0-.404 1.275h4.206l-1.296-1.296a3.1 3.1 0 0 1 2.196-.903c1.404 0 2.587.924 2.976 2.199h2.13z'/%3E%3C/svg%3E")}.ag-icon-eye:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye%3C/title%3E%3Cpath d='M16 8.222c-5.186 0-9.614 3.225-11.408 7.778 1.794 4.553 6.222 7.778 11.408 7.778S25.614 20.553 27.408 16C25.614 11.447 21.186 8.222 16 8.222m0 12.964c-2.862 0-5.186-2.324-5.186-5.186s2.324-5.186 5.186-5.186 5.186 2.324 5.186 5.186-2.324 5.186-5.186 5.186m0-8.297c-1.721 0-3.111 1.39-3.111 3.111s1.39 3.111 3.111 3.111 3.111-1.39 3.111-3.111-1.39-3.111-3.111-3.111'/%3E%3C/svg%3E")}.ag-icon-filter:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Efilter%3C/title%3E%3Cpath d='M13.333 24h5.333v-2.667h-5.333zM4 8v2.667h24V8zm4 9.333h16v-2.667H8z'/%3E%3C/svg%3E")}.ag-icon-first:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Efirst%3C/title%3E%3Cpath d='M24.273 22.12 18.153 16l6.12-6.12L22.393 8l-8 8 8 8zM7.727 8h2.667v16H7.727z'/%3E%3C/svg%3E")}.ag-icon-group:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Egroup%3C/title%3E%3Cpath d='M18.667 21.333h8.889A3.555 3.555 0 0 1 24 24.889h-5.333zm8.888-7.111v3.556h-8.889v-3.556zM24 7.111a3.555 3.555 0 0 1 3.556 3.556h-16V7.111zm-8.889 17.778h-3.556v-3.556h3.556zm0-7.111h-3.556v-3.556h3.556zM8 10.667H4.444A3.555 3.555 0 0 1 8 7.111z'/%3E%3C/svg%3E")}.ag-icon-last:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Elast%3C/title%3E%3Cpath d='m7.727 9.88 6.12 6.12-6.12 6.12L9.607 24l8-8-8-8zM21.607 8h2.667v16h-2.667z'/%3E%3C/svg%3E")}.ag-icon-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eleft%3C/title%3E%3Cpath d='M26.667 14.667H10.44l7.453-7.453L16 5.334 5.333 16.001 16 26.668l1.88-1.88-7.44-7.453h16.227v-2.667z'/%3E%3C/svg%3E")}.ag-icon-linked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Elinked%3C/title%3E%3Cpath d='M5.2 16a4.136 4.136 0 0 1 4.133-4.133h5.333V9.334H9.333c-3.68 0-6.667 2.987-6.667 6.667s2.987 6.667 6.667 6.667h5.333v-2.533H9.333A4.136 4.136 0 0 1 5.2 16.002zm5.467 1.333h10.667v-2.667H10.667zm12-8h-5.333v2.533h5.333c2.28 0 4.133 1.853 4.133 4.133s-1.853 4.133-4.133 4.133h-5.333v2.533h5.333c3.68 0 6.667-2.987 6.667-6.667s-2.987-6.667-6.667-6.667z'/%3E%3C/svg%3E")}.ag-icon-loading:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eloading%3C/title%3E%3Cpath d='m17.778 11.708 3.25-3.251 2.516 2.516-3.251 3.25h4.597v3.556h-4.597l3.251 3.25-2.516 2.516-3.25-3.251v4.597h-3.556v-4.597l-3.25 3.251-2.516-2.516 3.251-3.25H7.11v-3.556h4.597l-3.251-3.25 2.516-2.516 3.25 3.251V7.111h3.556zm-3.251 7.847h2.944l2.084-2.084v-2.944l-2.084-2.084h-2.944l-2.084 2.084v2.944z'/%3E%3C/svg%3E")}.ag-icon-maximize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Emaximize%3C/title%3E%3Cpath d='M4 4h24v2.667H4z'/%3E%3C/svg%3E")}.ag-icon-menu:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Emenu%3C/title%3E%3Cpath d='M4 24h24v-2.667H4zm0-6.667h24v-2.667H4zM4 8v2.667h24V8z'/%3E%3C/svg%3E")}.ag-icon-menu-alt:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M16 26.667a2.57 2.57 0 0 1-1.883-.784A2.57 2.57 0 0 1 13.333 24q0-1.1.784-1.883A2.57 2.57 0 0 1 16 21.333q1.1 0 1.883.784.784.783.784 1.883t-.784 1.883a2.57 2.57 0 0 1-1.883.784m0-8a2.57 2.57 0 0 1-1.883-.784A2.57 2.57 0 0 1 13.333 16q0-1.1.784-1.883A2.57 2.57 0 0 1 16 13.333q1.1 0 1.883.784.784.783.784 1.883t-.784 1.883a2.57 2.57 0 0 1-1.883.784m0-8a2.57 2.57 0 0 1-1.883-.784A2.57 2.57 0 0 1 13.333 8q0-1.1.784-1.883A2.57 2.57 0 0 1 16 5.333q1.1 0 1.883.784.784.783.784 1.883t-.784 1.883a2.57 2.57 0 0 1-1.883.784'/%3E%3C/svg%3E")}.ag-icon-minimize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eminimize%3C/title%3E%3Cpath d='M8 25.333h16V28H8z'/%3E%3C/svg%3E")}.ag-icon-minus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658H7.901v-2.658z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-next:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enext%3C/title%3E%3Cpath d='m12.94 8-1.88 1.88L17.167 16l-6.107 6.12L12.94 24l8-8z'/%3E%3C/svg%3E")}.ag-icon-none:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enone%3C/title%3E%3Cpath d='M4 24h16v-2.667H4zM4 8v2.667h24V8zm0 9.333h24v-2.667H4z'/%3E%3C/svg%3E")}.ag-icon-not-allowed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enot-allowed%3C/title%3E%3Cpath d='M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667M5.333 16c0-5.893 4.773-10.667 10.667-10.667 2.467 0 4.733.84 6.533 2.253L7.586 22.533A10.54 10.54 0 0 1 5.333 16M16 26.667c-2.467 0-4.733-.84-6.533-2.253L24.414 9.467A10.54 10.54 0 0 1 26.667 16c0 5.893-4.773 10.667-10.667 10.667'/%3E%3C/svg%3E")}.ag-icon-paste:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epaste%3C/title%3E%3Cpath d='M25.333 4H19.76C19.2 2.453 17.733 1.333 16 1.333S12.8 2.453 12.24 4H6.667A2.675 2.675 0 0 0 4 6.667V28c0 1.467 1.2 2.667 2.667 2.667h18.667c1.467 0 2.667-1.2 2.667-2.667V6.667C28.001 5.2 26.801 4 25.334 4zM16 4c.733 0 1.333.6 1.333 1.333s-.6 1.333-1.333 1.333-1.333-.6-1.333-1.333S15.267 4 16 4m9.333 24H6.666V6.667h2.667v4h13.333v-4h2.667z'/%3E%3C/svg%3E")}.ag-icon-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epin%3C/title%3E%3Cpath d='m11.106 22.093-4.444 4.444-1.259-1.259 4.444-4.444zm5.872-16.63 9.618 9.62-.962.962-.962-.962-7.694 3.847 1.924 1.924-2.74 2.74-7.696-7.696 2.741-2.74 1.924 1.925 3.847-7.696-.962-.962z'/%3E%3C/svg%3E")}.ag-icon-pivot:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epivot%3C/title%3E%3Cpath d='M26.667 30.223H5.334a3.556 3.556 0 0 1-3.556-3.556V5.334a3.556 3.556 0 0 1 3.556-3.556h21.333a3.556 3.556 0 0 1 3.556 3.556v21.333a3.556 3.556 0 0 1-3.556 3.556m-16-8.89H5.334v5.333h5.333zm16-7.11H12.444v12.444h14.223zm-9.15 6.85-2.039 2.037 2.039 2.039-1.257 1.257-3.295-3.296 3.295-3.295q.63.628 1.257 1.257zm-6.85-6.85H5.334v5.333h5.333zm15.74 3.816-1.257 1.256-2.039-2.037-2.037 2.037-1.257-1.256 3.295-3.296zM10.667 5.333H5.334v5.333h5.333zm8.889 0h-7.112v5.333h7.112zm7.111 0h-5.333v5.333h5.333z'/%3E%3C/svg%3E")}.ag-icon-plus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658h-6.77v6.77h-2.658v-6.77h-6.77v-2.658h6.77v-6.77h2.658v6.77z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-previous:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eprevious%3C/title%3E%3Cpath d='M20.94 9.88 19.06 8l-8 8 8 8 1.88-1.88L14.833 16z'/%3E%3C/svg%3E")}.ag-icon-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eright%3C/title%3E%3Cpath d='m16 5.333-1.88 1.88 7.44 7.453H5.333v2.667H21.56l-7.44 7.453 1.88 1.88 10.667-10.667L16 5.332z'/%3E%3C/svg%3E")}.ag-icon-save:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esave%3C/title%3E%3Cpath d='M25.333 16v9.333H6.666V16H3.999v9.333C3.999 26.8 5.199 28 6.666 28h18.667C26.8 28 28 26.8 28 25.333V16zm-8 .893 3.453-3.44 1.88 1.88L15.999 22l-6.667-6.667 1.88-1.88 3.453 3.44V4h2.667v12.893z'/%3E%3C/svg%3E")}.ag-icon-small-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-down%3C/title%3E%3Cpath d='M9.333 12.667 16 19.334l6.667-6.667H9.334z'/%3E%3C/svg%3E")}.ag-icon-small-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-left%3C/title%3E%3Cpath d='M19.333 9.333 12.666 16l6.667 6.667V9.334z'/%3E%3C/svg%3E")}.ag-icon-small-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-right%3C/title%3E%3Cpath d='M12.667 22.667 19.334 16l-6.667-6.667v13.333z'/%3E%3C/svg%3E")}.ag-icon-small-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-up%3C/title%3E%3Cpath d='M9.333 19.333 16 12.666l6.667 6.667H9.334z'/%3E%3C/svg%3E")}.ag-icon-tick:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etick%3C/title%3E%3Cpath d='m11.727 21.167-5.56-5.56-1.893 1.88 7.453 7.453 16-16-1.88-1.88z'/%3E%3C/svg%3E")}.ag-icon-tree-closed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-closed%3C/title%3E%3Cpath d='m12.94 8-1.88 1.88L17.167 16l-6.107 6.12L12.94 24l8-8z'/%3E%3C/svg%3E")}.ag-icon-tree-indeterminate:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-indeterminate%3C/title%3E%3Cpath d='M6.667 14.667h18.667v2.667H6.667z'/%3E%3C/svg%3E")}.ag-icon-tree-open:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-open%3C/title%3E%3Cpath d='M22.12 11.06 16 17.167 9.88 11.06 8 12.94l8 8 8-8z'/%3E%3C/svg%3E")}.ag-icon-unlinked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eunlinked%3C/title%3E%3Cpath d='M22.667 9.333h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133c0 1.907-1.307 3.507-3.08 3.973l1.947 1.947c2.173-1.107 3.667-3.32 3.667-5.92a6.67 6.67 0 0 0-6.667-6.667zm-1.334 5.334h-2.92l2.667 2.667h.253zM2.667 5.693 6.814 9.84A6.65 6.65 0 0 0 2.667 16a6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.334a4.136 4.136 0 0 1-4.133-4.133c0-2.12 1.613-3.867 3.68-4.093l2.76 2.76h-.973v2.667h3.64l3.027 3.027v2.307h2.307l5.347 5.333 1.68-1.68L4.362 4.002 2.669 5.695z'/%3E%3C/svg%3E")}.ag-icon-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Easc%3C/title%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333z'/%3E%3C/svg%3E")}.ag-icon-grip:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Egrip%3C/title%3E%3Cpath d='M26.667 12H5.334v2.667h21.333zM5.333 20h21.333v-2.667H5.333z'/%3E%3C/svg%3E")}.ag-icon-settings:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30zm-9 4c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3M2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2zm9-4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3'/%3E%3C/svg%3E")}.ag-icon-column-arrow:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M11 4a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 13a1 1 0 0 1 1-1h23.5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 4h18v24H2zm2 2v20h14V6zM26.793 13 23 9.207l1.414-1.414L29.621 13l-5.207 5.207L23 16.793z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-un-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' d='M8 11a.75.75 0 0 0-.75.75v3.333a.75.75 0 1 0 1.5 0V11.75A.75.75 0 0 0 8 11'/%3E%3Cpath fill='currentColor' d='M13.11 1.436a.75.75 0 0 0-1.22-.872l-10 14a.75.75 0 1 0 1.22.872L5.207 12.5h7.376a.75.75 0 0 0 .75-.75v-1.174a2.08 2.08 0 0 0-1.153-1.863l-1.185-.599-.005-.002a.58.58 0 0 1-.323-.522V5.165a2.083 2.083 0 0 0 1.854-2.904zm-3.943 5.52v.634a2.08 2.08 0 0 0 1.153 1.863l1.185.6.005.002a.58.58 0 0 1 .323.522V11H6.28zM9.277 1H5.25a2.084 2.084 0 0 0-.083 4.165v1.676l1.5-2.132v-.292a.75.75 0 0 0-.75-.75H5.25a.584.584 0 0 1 0-1.167h2.972z'/%3E%3C/svg%3E")}.ag-icon-pinned-top:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' d='M12.53 3.72A.75.75 0 0 1 12 5H4a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 .53.22M3.269 10.744a.75.75 0 0 1 .2-.524l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L8.75 8.56V14a.75.75 0 0 1-1.5 0V8.56l-2.72 2.72a.75.75 0 0 1-1.26-.536'/%3E%3C/svg%3E")}.ag-icon-pinned-bottom:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' d='M3.47 12.28A.75.75 0 0 1 4 11h8a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.53-.22M12.731 5.256a.75.75 0 0 1-.2.524l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V2a.75.75 0 0 1 1.5 0v5.44l2.72-2.72a.75.75 0 0 1 1.26.536'/%3E%3C/svg%3E")}.ag-icon-chevron-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M3.479 10.521a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-3.47-3.47-3.47 3.47a.75.75 0 0 1-1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M12.521 5.461a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l3.47 3.47 3.47-3.47a.75.75 0 0 1 1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M10.53 12.512a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06l-3.47 3.47 3.47 3.47a.75.75 0 0 1 0 1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M5.47 3.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06L8.94 8 5.47 4.53a.75.75 0 0 1 0-1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-filter-add:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M18.666 24h-5.333v-2.667h5.333zM24 17.333H8v-2.667h16zm3.59-9.344h3.221v2.657h-3.22v3.22h-2.656v-3.22h-3.221V7.989h3.22V4.77h2.657zm-8.582 2.678H4V8h15.008z'/%3E%3C/svg%3E")}.ag-icon-edit:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M6.222 25.778h1.611l14.834-14.811-1.611-1.611-14.834 14.81zM4 28v-4.733L22.644 4.656a2.26 2.26 0 0 1 1.567-.634q.423 0 .833.167.412.166.734.478l1.589 1.6q.333.322.483.733t.15.822q0 .423-.161.839-.162.416-.472.728L8.733 28zm17.856-17.833-.8-.811 1.61 1.61z'/%3E%3C/svg%3E")}`;
// packages/ag-grid-community/src/theming/parts/icon-set/material/icon-set-material.ts
var $437b23f6a393c3bf$export$e9404e008fead04f = /* @__PURE__ */ $437b23f6a393c3bf$export$6e6f0e372f4cb988({
    feature: "iconSet",
    css: $437b23f6a393c3bf$var$iconSetMaterialCSS
});
// packages/ag-grid-community/src/theming/parts/icon-set/overrides/icon-overrides.ts
var $437b23f6a393c3bf$export$32f04c7493939075 = (args)=>{
    const cssParts = [];
    if (args.type === "image") {
        const { icons: icons, mask: mask } = args;
        for (const key of Object.keys(icons)){
            const imageCssValue = $437b23f6a393c3bf$var$imageValueToCss(icons[key]);
            if (mask) cssParts.push(`.ag-icon-${key}::before { mask-image: ${imageCssValue}; }`);
            else cssParts.push(`.ag-icon-${key}::before { background-image: ${imageCssValue}; ${$437b23f6a393c3bf$var$unsetMaskIcon} }`);
        }
    }
    if (args.type === "font") {
        const { family: family, weight: weight, color: color, icons: icons } = args;
        let properties = $437b23f6a393c3bf$var$unsetMaskIcon;
        if (family) properties += ` font-family: ${$437b23f6a393c3bf$var$fontFamilyValueToCss(family)};`;
        if (weight) properties += ` font-weight: ${$437b23f6a393c3bf$var$fontWeightValueToCss(weight)};`;
        if (color) properties += ` color: ${$437b23f6a393c3bf$var$colorValueToCss(color)};`;
        for (const key of Object.keys(icons))cssParts.push(`.ag-icon-${key}::before { content: ${JSON.stringify(icons[key])}; ${properties} }`);
    }
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        css: cssParts.join(";\n"),
        cssImports: args.cssImports
    });
};
var $437b23f6a393c3bf$var$unsetMaskIcon = `background-color: unset; mask-image: unset; -webkit-mask-image: unset;`;
// packages/ag-grid-community/src/theming/parts/icon-set/quartz/quartz-icon-data.ts
var $437b23f6a393c3bf$var$iconNameToSvgFragment = {
    aggregation: '<path d="M18 7V4H6l6 8-6 8h12v-3"/>',
    arrows: '<polyline points="5 9 2 12 5 15"/><polyline points="9 5 12 2 15 5"/><polyline points="15 19 12 22 9 19"/><polyline points="19 9 22 12 19 15"/><line x1="2" x2="22" y1="12" y2="12"/><line x1="12" x2="12" y1="2" y2="22"/>',
    asc: '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>',
    cancel: '<path d="m18 6-12 12"/><path d="m6 6 12 12"/>',
    chart: '<line x1="18" x2="18" y1="20" y2="10"/><line x1="12" x2="12" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="14"/>',
    "color-picker": '<path d="m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z"/><path d="m5 2 5 5"/><path d="M2 13h15"/><path d="M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z"/>',
    columns: '<path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"/>',
    contracted: '<path d="m9 18 6-6-6-6"/>',
    copy: '<rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>',
    cross: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
    csv: '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2"/><path d="M8 17h2"/><path d="M14 13h2"/><path d="M14 17h2"/>',
    cut: '<circle cx="6" cy="6" r="3"/><path d="M8.12 8.12 12 12"/><path d="M20 4 8.12 15.88"/><circle cx="6" cy="18" r="3"/><path d="M14.8 14.8 20 20"/>',
    desc: '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',
    down: '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',
    excel: '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2"/><path d="M8 17h2"/><path d="M14 13h2"/><path d="M14 17h2"/>',
    expanded: '<path d="m15 18-6-6 6-6"/>',
    "eye-slash": '<path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/><line x1="2" x2="22" y1="2" y2="22"/>',
    eye: '<path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>',
    filter: '<path d="M3 6h18"/><path d="M7 12h10"/><path d="M10 18h4"/>',
    first: '<path d="m17 18-6-6 6-6"/><path d="M7 6v12"/>',
    group: '<path d="M16 12H3"/><path d="M16 18H3"/><path d="M10 6H3"/><path d="M21 18V8a2 2 0 0 0-2-2h-5"/><path d="m16 8-2-2 2-2"/>',
    last: '<path d="m7 18 6-6-6-6"/><path d="M17 6v12"/>',
    left: '<path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>',
    linked: '<path d="M9 17H7A5 5 0 0 1 7 7h2"/><path d="M15 7h2a5 5 0 1 1 0 10h-2"/><line x1="8" x2="16" y1="12" y2="12"/>',
    loading: '<line x1="12" x2="12" y1="2" y2="6"/><line x1="12" x2="12" y1="18" y2="22"/><line x1="4.93" x2="7.76" y1="4.93" y2="7.76"/><line x1="16.24" x2="19.07" y1="16.24" y2="19.07"/><line x1="2" x2="6" y1="12" y2="12"/><line x1="18" x2="22" y1="12" y2="12"/><line x1="4.93" x2="7.76" y1="19.07" y2="16.24"/><line x1="16.24" x2="19.07" y1="7.76" y2="4.93"/>',
    maximize: '<polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" x2="14" y1="3" y2="10"/><line x1="3" x2="10" y1="21" y2="14"/>',
    menu: '<line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/>',
    "menu-alt": '<circle cx="12" cy="5" r="0.75" fill="#D9D9D9"/><circle cx="12" cy="12" r="0.75" fill="#D9D9D9"/><circle cx="12" cy="19" r="0.75" fill="#D9D9D9"/>',
    minimize: '<polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/><line x1="14" x2="21" y1="10" y2="3"/><line x1="3" x2="10" y1="21" y2="14"/>',
    minus: '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/>',
    next: '<path d="m9 18 6-6-6-6"/>',
    none: '<path d="m7 15 5 5 5-5"/><path d="m7 9 5-5 5 5"/>',
    "not-allowed": '<circle cx="12" cy="12" r="10"/><path d="m4.9 4.9 14.2 14.2"/>',
    paste: '<path d="M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z"/><path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10"/><path d="m17 10 4 4-4 4"/>',
    pin: '<line x1="12" x2="12" y1="17" y2="22"/><path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"/>',
    pivot: '<path d="M15 3v18"/><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M21 9H3"/><path d="M21 15H3"/>',
    plus: '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/>',
    previous: '<path d="m15 18-6-6 6-6"/>',
    right: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
    save: '<path d="M12 17V3"/><path d="m6 11 6 6 6-6"/><path d="M19 21H5"/>',
    "small-left": '<path d="m15 18-6-6 6-6"/>',
    "small-right": '<path d="m9 18 6-6-6-6"/>',
    tick: '<path d="M20 6 9 17l-5-5"/>',
    "tree-closed": '<path d="m9 18 6-6-6-6"/>',
    "tree-indeterminate": '<path d="M5 12h14"/>',
    "tree-open": '<path d="m6 9 6 6 6-6"/>',
    unlinked: '<path d="M9 17H7A5 5 0 0 1 7 7"/><path d="M15 7h2a5 5 0 0 1 4 8"/><line x1="8" x2="12" y1="12" y2="12"/><line x1="2" x2="22" y1="2" y2="22"/>',
    up: '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>',
    grip: '<circle cx="5" cy="8" r="0.5"/><circle cx="12" cy="8" r="0.5"/><circle cx="19" cy="8" r="0.5"/><circle cx="5" cy="16" r="0.5"/><circle cx="12" cy="16" r="0.5"/><circle cx="19" cy="16" r="0.5"/><g stroke="none" fill="currentColor"><circle cx="5" cy="8" r="1"/><circle cx="12" cy="8" r="1"/><circle cx="19" cy="8" r="1"/><circle cx="5" cy="16" r="1"/><circle cx="12" cy="16" r="1"/><circle cx="19" cy="16" r="1"/></g>',
    settings: '<path d="M20 7h-9"/><path d="M14 17H5"/><circle cx="17" cy="17" r="3"/><circle cx="7" cy="7" r="3"/>'
};
var $437b23f6a393c3bf$var$iconNameToFullSvg = {
    "column-arrow": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" viewBox="0 0 32 32"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 26C0 28.2092 1.79086 30 4 30H14C16.2091 30 18 28.2092 18 26V15H25.8786L24.4394 16.4393C23.8536 17.0251 23.8536 17.9749 24.4394 18.5607C25.0252 19.1464 25.9748 19.1464 26.5606 18.5607L30.5606 14.5607C31.1464 13.9749 31.1464 13.0251 30.5606 12.4393L26.5606 8.43934C25.9748 7.85356 25.0252 7.85356 24.4394 8.43934C23.8536 9.02512 23.8536 9.97488 24.4394 10.5607L25.8786 12H18V6C18 3.79086 16.2091 2 14 2H4C1.79086 2 0 3.79086 0 6V26ZM14 5H10.5V12H15V6C15 5.44772 14.5523 5 14 5ZM4 5H7.5V12H3V6C3 5.44772 3.44772 5 4 5ZM10.5 15H15V26C15 26.5522 14.5523 27 14 27H10.5V15ZM4 27H7.5V15H3V26C3 26.5522 3.44772 27 4 27Z" fill="currentColor"/></svg>',
    "small-down": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="black" stroke="none" viewBox="0 0 32 32"><path d="M7.334 10.667 16 21.334l8.667-10.667H7.334Z"/></svg>',
    "small-up": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="black" stroke="none" viewBox="0 0 32 32"><path d="M7.334 21.333 16 10.666l8.667 10.667H7.334Z"/></svg>',
    "pinned-top": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12.53 3.72A.75.75 0 0 1 12 5H4a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 .53.22ZM3.269 10.744a.75.75 0 0 1 .2-.524l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L8.75 8.56V14a.75.75 0 0 1-1.5 0V8.56l-2.72 2.72a.75.75 0 0 1-1.26-.536Z"/></svg>',
    "pinned-bottom": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="ag-icon" viewBox="0 0 16 16"><path fill="currentColor" d="M3.47 12.28A.75.75 0 0 1 4 11h8a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.53-.22ZM12.731 5.256a.75.75 0 0 1-.2.524l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V2a.75.75 0 0 1 1.5 0v5.44l2.72-2.72a.75.75 0 0 1 1.26.536Z"/></svg>',
    "un-pin": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="ag-icon" viewBox="0 0 16 16"><path fill="currentColor" d="M8 11a.75.75 0 0 0-.75.75v3.333a.75.75 0 1 0 1.5 0V11.75A.75.75 0 0 0 8 11Z"/><path fill="currentColor" d="M13.11 1.436a.75.75 0 0 0-1.22-.872l-10 14a.75.75 0 1 0 1.22.872L5.207 12.5h7.376a.75.75 0 0 0 .75-.75v-1.174a2.08 2.08 0 0 0-1.153-1.863l-1.185-.599-.005-.002a.58.58 0 0 1-.323-.522V5.165a2.083 2.083 0 0 0 1.854-2.904l.589-.825Zm-3.943 5.52v.634a2.08 2.08 0 0 0 1.153 1.863l1.185.6.005.002a.58.58 0 0 1 .323.522V11H6.28l2.887-4.044ZM9.277 1H5.25a2.084 2.084 0 0 0-.083 4.165v1.676l1.5-2.132v-.292a.75.75 0 0 0-.75-.75H5.25a.584.584 0 0 1 0-1.167h2.972L9.277 1Z"/></svg>',
    "chevron-down": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 6L8 10L4 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    "chevron-up": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 10L8 6L12 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    "chevron-left": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    "chevron-right": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    "filter-add": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.12126 7.75L10.8517 7.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M6.65934 11.748L9.32778 11.748" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M12.2943 1.04872V6.19184M14.9886 3.74341H9.68478" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M8.25488 3C8.04799 3.18323 7.91706 3.45099 7.91699 3.74902C7.91713 4.04868 8.04988 4.31681 8.25879 4.5H2C1.58579 4.5 1.25 4.16421 1.25 3.75C1.25 3.33579 1.58579 3 2 3H8.25488Z" fill="currentColor"/></svg>',
    edit: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 10.6262V12.5012H5.375L10.905 6.97122L9.03 5.09622L3.5 10.6262ZM12.355 5.52122C12.4014 5.47497 12.4381 5.42002 12.4632 5.35953C12.4883 5.29905 12.5012 5.23421 12.5012 5.16872C12.5012 5.10324 12.4883 5.0384 12.4632 4.97791C12.4381 4.91742 12.4014 4.86248 12.355 4.81622L11.185 3.64622C11.1387 3.59987 11.0838 3.5631 11.0233 3.53801C10.9628 3.51291 10.898 3.5 10.8325 3.5C10.767 3.5 10.7022 3.51291 10.6417 3.53801C10.5812 3.5631 10.5263 3.59987 10.48 3.64622L9.565 4.56122L11.44 6.43622L12.355 5.52122Z" fill="currentColor"/></svg>'
};
var $437b23f6a393c3bf$var$getQuartzIconsCss = (args = {})=>{
    let result = "";
    for (const iconName of [
        ...Object.keys($437b23f6a393c3bf$var$iconNameToSvgFragment),
        ...Object.keys($437b23f6a393c3bf$var$iconNameToFullSvg)
    ]){
        const iconSvg = $437b23f6a393c3bf$var$quartzIconSvg(iconName, args.strokeWidth);
        result += `.ag-icon-${iconName}::before { mask-image: url('data:image/svg+xml,${encodeURIComponent(iconSvg)}'); }
`;
    }
    return result;
};
var $437b23f6a393c3bf$var$quartzIconSvg = (name, strokeWidth = 1.5)=>{
    const fullSVG = $437b23f6a393c3bf$var$iconNameToFullSvg[name];
    if (fullSVG) return fullSVG;
    const svgFragment = $437b23f6a393c3bf$var$iconNameToSvgFragment[name];
    if (!svgFragment) throw new Error(`Missing icon data for ${name}`);
    return `<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="black" stroke-width="${strokeWidth}" viewBox="0 0 24 24"><style>* { vector-effect: non-scaling-stroke; }</style>` + svgFragment + "</svg>";
};
// packages/ag-grid-community/src/theming/parts/icon-set/quartz/icon-set-quartz.ts
var $437b23f6a393c3bf$export$d2d85e4420173ddb = (args = {})=>{
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "iconSet",
        css: ()=>$437b23f6a393c3bf$var$getQuartzIconsCss(args)
    });
};
var $437b23f6a393c3bf$export$3147a7744202f5a7 = /* @__PURE__ */ $437b23f6a393c3bf$export$d2d85e4420173ddb({
    strokeWidth: 1
});
var $437b23f6a393c3bf$export$b60dff12ba08ba55 = /* @__PURE__ */ $437b23f6a393c3bf$export$d2d85e4420173ddb();
var $437b23f6a393c3bf$export$3a4c15e55a998025 = /* @__PURE__ */ $437b23f6a393c3bf$export$d2d85e4420173ddb({
    strokeWidth: 2
});
// packages/ag-grid-community/src/theming/parts/input-style/input-style-base.css-GENERATED.ts
var $437b23f6a393c3bf$var$inputStyleBaseCSS = /*css*/ `:where(.ag-input-field-input[type=number]:not(.ag-number-field-input-stepper)){-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield;&::-webkit-inner-spin-button,&::-webkit-outer-spin-button{-webkit-appearance:none;appearance:none;margin:0}}.ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){background-color:var(--ag-input-background-color);border:var(--ag-input-border);border-radius:var(--ag-input-border-radius);color:var(--ag-input-text-color);font-family:inherit;font-size:inherit;line-height:inherit;margin:0;min-height:var(--ag-input-height);padding:0;&:where(:disabled){background-color:var(--ag-input-disabled-background-color);border:var(--ag-input-disabled-border);color:var(--ag-input-disabled-text-color)}&:where(:focus){background-color:var(--ag-input-focus-background-color);border:var(--ag-input-focus-border);box-shadow:var(--ag-input-focus-shadow);color:var(--ag-input-focus-text-color);outline:none}&:where(:invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&:where(.invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&::-moz-placeholder{color:var(--ag-input-placeholder-text-color)}&::placeholder{color:var(--ag-input-placeholder-text-color)}}:where(.ag-ltr) .ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){padding-left:var(--ag-input-padding-start)}:where(.ag-rtl) .ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){padding-right:var(--ag-input-padding-start)}:where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select){.ag-input-wrapper:before{background-color:currentcolor;color:var(--ag-input-icon-color);content:"";display:block;height:12px;-webkit-mask-image:url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==");mask-image:url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==");-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;opacity:.5;position:absolute;width:12px}}:where(.ag-ltr) :where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select){.ag-input-wrapper:before{margin-left:var(--ag-spacing)}.ag-number-field-input,.ag-text-field-input{padding-left:calc(var(--ag-spacing)*1.5 + 12px)}}:where(.ag-rtl) :where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select){.ag-input-wrapper:before{margin-right:var(--ag-spacing)}.ag-number-field-input,.ag-text-field-input{padding-right:calc(var(--ag-spacing)*1.5 + 12px)}}`;
// packages/ag-grid-community/src/theming/parts/input-style/input-style-bordered.css-GENERATED.ts
var $437b23f6a393c3bf$var$inputStyleBorderedCSS = /*css*/ `.ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){&:focus{box-shadow:var(--ag-focus-shadow);&:where(.invalid),&:where(:invalid){box-shadow:var(--ag-focus-error-shadow)}}}`;
// packages/ag-grid-community/src/theming/parts/input-style/input-style-underlined.css-GENERATED.ts
var $437b23f6a393c3bf$var$inputStyleUnderlinedCSS = /*css*/ `.ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){border-left:none;border-right:none;border-top:none}`;
// packages/ag-grid-community/src/theming/parts/input-style/input-styles.ts
var $437b23f6a393c3bf$var$baseParams3 = {
    inputBackgroundColor: "transparent",
    inputBorder: false,
    inputBorderRadius: 0,
    inputTextColor: {
        ref: "textColor"
    },
    inputPlaceholderTextColor: {
        ref: "inputTextColor",
        mix: 0.5
    },
    inputPaddingStart: 0,
    inputHeight: {
        calc: "max(iconSize, fontSize) + spacing * 2"
    },
    inputFocusBackgroundColor: {
        ref: "inputBackgroundColor"
    },
    inputFocusBorder: {
        ref: "inputBorder"
    },
    inputFocusShadow: "none",
    inputFocusTextColor: {
        ref: "inputTextColor"
    },
    inputDisabledBackgroundColor: {
        ref: "inputBackgroundColor"
    },
    inputDisabledBorder: {
        ref: "inputBorder"
    },
    inputDisabledTextColor: {
        ref: "inputTextColor"
    },
    inputInvalidBackgroundColor: {
        ref: "inputBackgroundColor"
    },
    inputInvalidBorder: {
        ref: "inputBorder"
    },
    inputInvalidTextColor: {
        ref: "inputTextColor"
    },
    inputIconColor: {
        ref: "inputTextColor"
    },
    pickerButtonBorder: false,
    pickerButtonFocusBorder: {
        ref: "inputFocusBorder"
    },
    pickerButtonBackgroundColor: {
        ref: "backgroundColor"
    },
    pickerButtonFocusBackgroundColor: {
        ref: "backgroundColor"
    },
    pickerListBorder: false,
    pickerListBackgroundColor: {
        ref: "backgroundColor"
    },
    colorPickerThumbSize: 18,
    colorPickerTrackSize: 12,
    colorPickerThumbBorderWidth: 3,
    colorPickerTrackBorderRadius: 12,
    colorPickerColorBorderRadius: 4
};
var $437b23f6a393c3bf$var$makeInputStyleBaseTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "inputStyle",
        params: $437b23f6a393c3bf$var$baseParams3,
        css: $437b23f6a393c3bf$var$inputStyleBaseCSS
    });
var $437b23f6a393c3bf$export$2c8ad0489069516 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeInputStyleBaseTreeShakeable();
var $437b23f6a393c3bf$var$makeInputStyleBorderedTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "inputStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams3,
            inputBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            inputBorder: true,
            inputBorderRadius: {
                ref: "borderRadius"
            },
            inputPaddingStart: {
                ref: "spacing"
            },
            inputFocusBorder: {
                color: $437b23f6a393c3bf$var$accentColor
            },
            inputFocusShadow: {
                ref: "focusShadow"
            },
            inputDisabledBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.06),
            inputDisabledTextColor: {
                ref: "textColor",
                mix: 0.5
            },
            inputInvalidBorder: {
                color: {
                    ref: "invalidColor"
                }
            },
            pickerButtonBorder: true,
            pickerListBorder: true
        },
        css: ()=>$437b23f6a393c3bf$var$inputStyleBaseCSS + $437b23f6a393c3bf$var$inputStyleBorderedCSS
    });
var $437b23f6a393c3bf$export$df11db3e1948ad10 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeInputStyleBorderedTreeShakeable();
var $437b23f6a393c3bf$var$makeInputStyleUnderlinedTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "inputStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams3,
            inputBackgroundColor: "transparent",
            inputBorder: {
                width: 2,
                color: $437b23f6a393c3bf$var$foregroundMix(0.3)
            },
            inputPaddingStart: {
                ref: "spacing"
            },
            inputFocusBorder: "solid 2px var(--ag-accent-color)",
            inputDisabledTextColor: {
                ref: "textColor",
                mix: 0.5
            },
            inputDisabledBorder: "solid 1px var(--ag-border-color)",
            inputInvalidBorder: {
                width: 2,
                color: {
                    ref: "invalidColor",
                    mix: 0.3
                }
            }
        },
        css: ()=>$437b23f6a393c3bf$var$inputStyleBaseCSS + $437b23f6a393c3bf$var$inputStyleUnderlinedCSS
    });
var $437b23f6a393c3bf$export$c9667c02da45fcf0 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeInputStyleUnderlinedTreeShakeable();
// packages/ag-grid-community/src/theming/parts/tab-style/tab-style-base.css-GENERATED.ts
var $437b23f6a393c3bf$var$tabStyleBaseCSS = /*css*/ `.ag-tabs-header{background-color:var(--ag-tab-bar-background-color);border-bottom:var(--ag-tab-bar-border);display:flex;flex:1;gap:var(--ag-tab-spacing);padding:var(--ag-tab-bar-top-padding) var(--ag-tab-bar-horizontal-padding) 0}.ag-tabs-header-wrapper{display:flex}.ag-tabs-close-button-wrapper{align-items:center;border:0;display:flex;padding:var(--ag-spacing)}:where(.ag-ltr) .ag-tabs-close-button-wrapper{border-right:solid var(--ag-border-width) var(--ag-border-color)}:where(.ag-rtl) .ag-tabs-close-button-wrapper{border-left:solid var(--ag-border-width) var(--ag-border-color)}.ag-tabs-close-button{background-color:unset;border:0;cursor:pointer;padding:0}.ag-tab{align-items:center;background-color:var(--ag-tab-background-color);border-left:var(--ag-tab-selected-border-width) solid transparent;border-right:var(--ag-tab-selected-border-width) solid transparent;color:var(--ag-tab-text-color);cursor:pointer;display:flex;flex:1;justify-content:center;padding:var(--ag-tab-top-padding) var(--ag-tab-horizontal-padding) var(--ag-tab-bottom-padding);position:relative;&:hover{background-color:var(--ag-tab-hover-background-color);color:var(--ag-tab-hover-text-color)}&.ag-tab-selected{background-color:var(--ag-tab-selected-background-color);color:var(--ag-tab-selected-text-color)}&:after{background-color:var(--ag-tab-selected-underline-color);bottom:0;content:"";display:block;height:var(--ag-tab-selected-underline-width);left:0;opacity:0;position:absolute;right:0;transition:opacity var(--ag-tab-selected-underline-transition-duration)}&.ag-tab-selected:after{opacity:1}}:where(.ag-ltr) .ag-tab{&.ag-tab-selected{&:where(:not(:first-of-type)){border-left-color:var(--ag-tab-selected-border-color)}&:where(:not(:last-of-type)){border-right-color:var(--ag-tab-selected-border-color)}}}:where(.ag-rtl) .ag-tab{&.ag-tab-selected{&:where(:not(:first-of-type)){border-right-color:var(--ag-tab-selected-border-color)}&:where(:not(:last-of-type)){border-left-color:var(--ag-tab-selected-border-color)}}}`;
// packages/ag-grid-community/src/theming/parts/tab-style/tab-style-rolodex.css-GENERATED.ts
var $437b23f6a393c3bf$var$tabStyleRolodexCSS = /*css*/ `.ag-tab{border-left:var(--ag-tab-selected-border-width) solid transparent;border-right:var(--ag-tab-selected-border-width) solid transparent;border-top:var(--ag-tab-selected-border-width) solid transparent;flex:none;&.ag-tab-selected{border-left-color:var(--ag-tab-selected-border-color);border-right-color:var(--ag-tab-selected-border-color);border-top-color:var(--ag-tab-selected-border-color);margin-bottom:-1px;padding-bottom:calc(var(--ag-tab-bottom-padding) + 1px)}}`;
// packages/ag-grid-community/src/theming/parts/tab-style/tab-styles.ts
var $437b23f6a393c3bf$var$baseParams4 = {
    tabBarBackgroundColor: "transparent",
    tabBarHorizontalPadding: 0,
    tabBarTopPadding: 0,
    tabBackgroundColor: "transparent",
    tabTextColor: {
        ref: "textColor"
    },
    tabHorizontalPadding: {
        ref: "spacing"
    },
    tabTopPadding: {
        ref: "spacing"
    },
    tabBottomPadding: {
        ref: "spacing"
    },
    tabSpacing: "0",
    tabHoverBackgroundColor: {
        ref: "tabBackgroundColor"
    },
    tabHoverTextColor: {
        ref: "tabTextColor"
    },
    tabSelectedBackgroundColor: {
        ref: "tabBackgroundColor"
    },
    tabSelectedTextColor: {
        ref: "tabTextColor"
    },
    tabSelectedBorderWidth: {
        ref: "borderWidth"
    },
    tabSelectedBorderColor: "transparent",
    tabSelectedUnderlineColor: "transparent",
    tabSelectedUnderlineWidth: 0,
    tabSelectedUnderlineTransitionDuration: 0,
    tabBarBorder: false
};
var $437b23f6a393c3bf$var$makeTabStyleBaseTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: $437b23f6a393c3bf$var$baseParams4,
        css: $437b23f6a393c3bf$var$tabStyleBaseCSS
    });
var $437b23f6a393c3bf$export$7e3279c3902732ba = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleBaseTreeShakeable();
var $437b23f6a393c3bf$var$makeTabStyleQuartzTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams4,
            tabBarBorder: true,
            tabBarBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.05),
            tabTextColor: {
                ref: "textColor",
                mix: 0.7
            },
            tabSelectedTextColor: {
                ref: "textColor"
            },
            tabHoverTextColor: {
                ref: "textColor"
            },
            tabSelectedBorderColor: {
                ref: "borderColor"
            },
            tabSelectedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor
        },
        css: $437b23f6a393c3bf$var$tabStyleBaseCSS
    });
var $437b23f6a393c3bf$export$7ad22b51edfdfcfe = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleQuartzTreeShakeable();
var $437b23f6a393c3bf$var$makeTabStyleMaterialTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams4,
            tabBarBackgroundColor: {
                ref: "chromeBackgroundColor"
            },
            tabSelectedUnderlineColor: {
                ref: "primaryColor"
            },
            tabSelectedUnderlineWidth: 2,
            tabSelectedUnderlineTransitionDuration: 0
        },
        css: $437b23f6a393c3bf$var$tabStyleBaseCSS
    });
var $437b23f6a393c3bf$export$4c07fbd6ebedeb01 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleMaterialTreeShakeable();
var $437b23f6a393c3bf$var$makeTabStyleAlpineTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams4,
            tabBarBorder: true,
            tabBarBackgroundColor: {
                ref: "chromeBackgroundColor"
            },
            tabHoverTextColor: $437b23f6a393c3bf$var$accentColor,
            tabSelectedTextColor: $437b23f6a393c3bf$var$accentColor,
            tabSelectedUnderlineColor: $437b23f6a393c3bf$var$accentColor,
            tabSelectedUnderlineWidth: 2,
            tabSelectedUnderlineTransitionDuration: "0.3s"
        },
        css: $437b23f6a393c3bf$var$tabStyleBaseCSS
    });
var $437b23f6a393c3bf$export$e3b539837601fcda = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleAlpineTreeShakeable();
var $437b23f6a393c3bf$var$makeTabStyleRolodexTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams4,
            tabBarBackgroundColor: {
                ref: "chromeBackgroundColor"
            },
            tabBarHorizontalPadding: {
                ref: "spacing"
            },
            tabBarTopPadding: {
                ref: "spacing"
            },
            tabBarBorder: true,
            tabHorizontalPadding: {
                calc: "spacing * 2"
            },
            tabTopPadding: {
                ref: "spacing"
            },
            tabBottomPadding: {
                ref: "spacing"
            },
            tabSpacing: {
                ref: "spacing"
            },
            tabSelectedBorderColor: {
                ref: "borderColor"
            },
            tabSelectedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor
        },
        css: ()=>$437b23f6a393c3bf$var$tabStyleBaseCSS + $437b23f6a393c3bf$var$tabStyleRolodexCSS
    });
var $437b23f6a393c3bf$export$5c4a9ec5ca09df01 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleRolodexTreeShakeable();
// packages/ag-grid-community/src/theming/parts/theme/material-adjustments.css-GENERATED.ts
var $437b23f6a393c3bf$var$materialAdjustmentsCSS = /*css*/ `.ag-dnd-ghost,.ag-filter-toolpanel-header,.ag-filter-toolpanel-search,.ag-multi-filter-group-title-bar,.ag-panel-title-bar-title,.ag-status-bar{color:var(--ag-header-text-color);font-size:calc(var(--ag-font-size) - 1px);font-weight:600}.ag-column-drop-horizontal{background-color:color-mix(in srgb,var(--ag-background-color),var(--ag-foreground-color) 8%)}.ag-cell.ag-cell-inline-editing{background-color:var(--ag-background-color);background-image:linear-gradient(0deg,var(--ag-input-background-color),var(--ag-input-background-color));border:var(--ag-input-border)!important;border-width:1px!important;height:calc(var(--ag-row-height) + var(--ag-spacing)*3);padding:var(--ag-spacing);:where(.ag-row-last:not(.ag-row-first)) &{bottom:0}:where(.ag-has-focus) &{border:var(--ag-input-focus-border)!important;border-width:1px!important}}.ag-advanced-filter-builder-button,.ag-standard-button{text-transform:uppercase}.ag-status-bar{border:solid var(--ag-border-width) var(--ag-border-color)}.ag-list-item-hovered:after{background-color:var(--ag-primary-color)}.ag-pill-button:hover{color:var(--ag-primary-color)}.ag-header-highlight-after:after,.ag-header-highlight-before:after{background-color:var(--ag-primary-color)}.ag-filter-add-button,.ag-filter-add-button:hover{border-bottom:2px solid var(--ag-primary-color)}`;
// packages/ag-grid-community/src/theming/parts/theme/themes.ts
var $437b23f6a393c3bf$var$makeThemeQuartzTreeShakeable = ()=>$437b23f6a393c3bf$export$25d302a5b900a763().withPart($437b23f6a393c3bf$export$cb8a4bb75f2f86bb).withPart($437b23f6a393c3bf$export$e4400993032942f7).withPart($437b23f6a393c3bf$export$b60dff12ba08ba55).withPart($437b23f6a393c3bf$export$7ad22b51edfdfcfe).withPart($437b23f6a393c3bf$export$df11db3e1948ad10).withPart($437b23f6a393c3bf$export$9dd26d60e574ec0).withParams({
        fontFamily: [
            {
                googleFont: "IBM Plex Sans"
            },
            "-apple-system",
            "BlinkMacSystemFont",
            "Segoe UI",
            "Roboto",
            "Oxygen-Sans",
            "Ubuntu"
        ]
    });
var $437b23f6a393c3bf$export$495b90cf446940a1 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeThemeQuartzTreeShakeable();
var $437b23f6a393c3bf$var$makeThemeAlpineTreeShakeable = ()=>$437b23f6a393c3bf$export$25d302a5b900a763().withPart($437b23f6a393c3bf$export$c5a38eb31ae86567).withPart($437b23f6a393c3bf$export$cb8a4bb75f2f86bb).withPart($437b23f6a393c3bf$export$e4400993032942f7).withPart($437b23f6a393c3bf$export$9bb4a1bee1653083).withPart($437b23f6a393c3bf$export$e3b539837601fcda).withPart($437b23f6a393c3bf$export$df11db3e1948ad10).withPart($437b23f6a393c3bf$export$9dd26d60e574ec0).withParams({
        accentColor: "#2196f3",
        selectedRowBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.3),
        inputFocusBorder: {
            color: $437b23f6a393c3bf$var$accentMix(0.4)
        },
        focusShadow: {
            radius: 2,
            spread: 1.6,
            color: $437b23f6a393c3bf$var$accentMix(0.4)
        },
        iconButtonHoverBackgroundColor: "transparent",
        iconButtonActiveBackgroundColor: "transparent",
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.45),
        checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.45),
        checkboxIndeterminateBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.45),
        checkboxBorderWidth: 2,
        checkboxBorderRadius: 2,
        fontSize: 13,
        dataFontSize: 14,
        headerFontWeight: 700,
        borderRadius: 3,
        wrapperBorderRadius: 3,
        tabSelectedUnderlineColor: $437b23f6a393c3bf$var$accentColor,
        tabSelectedBorderWidth: 0,
        tabSelectedUnderlineTransitionDuration: 0.3,
        sideButtonSelectedUnderlineColor: $437b23f6a393c3bf$var$accentColor,
        sideButtonSelectedUnderlineWidth: 2,
        sideButtonSelectedUnderlineTransitionDuration: 0.3,
        sideButtonBorder: false,
        sideButtonSelectedBorder: false,
        sideButtonBarTopPadding: {
            calc: "spacing * 3"
        },
        sideButtonSelectedBackgroundColor: "transparent",
        sideButtonHoverTextColor: $437b23f6a393c3bf$var$accentColor,
        iconButtonHoverColor: $437b23f6a393c3bf$var$accentColor,
        toggleButtonWidth: 28,
        toggleButtonHeight: 18,
        toggleButtonSwitchInset: 1,
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.45),
        colorPickerThumbSize: 13,
        colorPickerTrackSize: 11,
        colorPickerThumbBorderWidth: 2,
        colorPickerTrackBorderRadius: 2,
        colorPickerColorBorderRadius: 2
    });
var $437b23f6a393c3bf$export$dfd7728c5c3233e9 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeThemeAlpineTreeShakeable();
var $437b23f6a393c3bf$var$makeThemeBalhamTreeShakeable = ()=>$437b23f6a393c3bf$export$25d302a5b900a763().withPart($437b23f6a393c3bf$export$effe67f8e12191d5).withPart($437b23f6a393c3bf$export$cb8a4bb75f2f86bb).withPart($437b23f6a393c3bf$export$e4400993032942f7).withPart($437b23f6a393c3bf$var$iconSetBalham).withPart($437b23f6a393c3bf$export$5c4a9ec5ca09df01).withPart($437b23f6a393c3bf$export$df11db3e1948ad10).withPart($437b23f6a393c3bf$export$9eadc93b54e4a807).withParams({
        accentColor: "#0091ea",
        borderColor: $437b23f6a393c3bf$var$foregroundMix(0.2),
        spacing: 4,
        widgetVerticalSpacing: {
            calc: "max(8px, spacing)"
        },
        borderRadius: 2,
        wrapperBorderRadius: 2,
        headerColumnResizeHandleColor: "transparent",
        headerColumnBorder: true,
        headerColumnBorderHeight: "50%",
        oddRowBackgroundColor: {
            ref: "chromeBackgroundColor",
            mix: 0.5
        },
        checkboxBorderRadius: 2,
        checkboxBorderWidth: 1,
        checkboxUncheckedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        checkboxCheckedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        checkboxCheckedBorderColor: $437b23f6a393c3bf$var$accentColor,
        checkboxCheckedShapeColor: $437b23f6a393c3bf$var$accentColor,
        checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        checkboxIndeterminateBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        checkboxIndeterminateShapeColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        focusShadow: {
            radius: 2,
            spread: 1,
            color: $437b23f6a393c3bf$var$accentColor
        },
        headerTextColor: $437b23f6a393c3bf$var$foregroundMix(0.6),
        iconButtonHoverBackgroundColor: "transparent",
        iconButtonActiveBackgroundColor: "transparent",
        fontSize: 12,
        tabSelectedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        headerFontWeight: "bold",
        toggleButtonWidth: 32,
        toggleButtonHeight: 16,
        toggleButtonSwitchInset: 1,
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        sideButtonBorder: true,
        sideButtonBarTopPadding: {
            calc: "spacing * 4"
        },
        popupShadow: "5px 5px 10px rgba(0, 0, 0, 0.3)",
        statusBarLabelColor: $437b23f6a393c3bf$var$foregroundMix(0.54),
        statusBarLabelFontWeight: 600,
        statusBarValueFontWeight: 600,
        panelTitleBarIconColor: $437b23f6a393c3bf$var$foregroundColor,
        colorPickerThumbSize: 13,
        colorPickerTrackSize: 11,
        colorPickerThumbBorderWidth: 2,
        colorPickerTrackBorderRadius: 2,
        colorPickerColorBorderRadius: 2
    });
var $437b23f6a393c3bf$export$679a577f1afc49d7 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeThemeBalhamTreeShakeable();
var $437b23f6a393c3bf$var$makeStyleMaterialTreeShakeable = ()=>{
    const sharedParams = {
        tabSelectedUnderlineColor: {
            ref: "primaryColor"
        },
        sideButtonSelectedUnderlineColor: {
            ref: "primaryColor"
        },
        buttonTextColor: {
            ref: "primaryColor"
        },
        rangeSelectionBackgroundColor: {
            ref: "primaryColor",
            mix: 0.2
        },
        rangeSelectionBorderColor: {
            ref: "primaryColor"
        },
        rangeSelectionHighlightColor: {
            ref: "primaryColor",
            mix: 0.5
        },
        rangeHeaderHighlightColor: {
            ref: "foregroundColor",
            mix: 0.08
        },
        rowNumbersSelectedColor: {
            ref: "primaryColor",
            mix: 0.5
        },
        inputFocusBorder: {
            width: 2,
            color: {
                ref: "primaryColor"
            }
        },
        pickerButtonFocusBorder: {
            width: 1,
            color: {
                ref: "primaryColor"
            }
        },
        cellEditingBorder: {
            color: {
                ref: "primaryColor"
            }
        },
        menuBackgroundColor: {
            ref: "backgroundColor"
        },
        sideButtonBarBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        sideButtonSelectedBackgroundColor: "transparent",
        sideButtonBarTopPadding: {
            calc: "spacing * 4"
        },
        headerColumnResizeHandleColor: "none",
        headerBackgroundColor: {
            ref: "backgroundColor"
        },
        rowHoverColor: $437b23f6a393c3bf$var$foregroundMix(0.08),
        columnHoverColor: $437b23f6a393c3bf$var$foregroundMix(0.08),
        headerCellHoverBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.05),
        statusBarLabelColor: $437b23f6a393c3bf$var$foregroundMix(0.63),
        statusBarLabelFontWeight: 600,
        statusBarValueFontWeight: 600,
        valueChangeValueHighlightBackgroundColor: "#00acc1",
        panelTitleBarIconColor: $437b23f6a393c3bf$var$foregroundColor,
        advancedFilterBuilderButtonBarBorder: false,
        filterPanelApplyButtonColor: {
            ref: "buttonTextColor"
        },
        filterPanelApplyButtonBackgroundColor: {
            ref: "buttonBackgroundColor"
        },
        colorPickerThumbSize: 13,
        colorPickerTrackSize: 11,
        colorPickerThumbBorderWidth: 2,
        colorPickerTrackBorderRadius: 2,
        colorPickerColorBorderRadius: 2
    };
    const lightParams = {
        ...sharedParams,
        primaryColor: "#3f51b5",
        foregroundColor: "#000D",
        headerTextColor: "#0008",
        accentColor: "#ff4081",
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundColor,
        checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$foregroundColor,
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundColor,
        selectedRowBackgroundColor: "rgba(33, 150, 243, 0.3)"
    };
    const darkParams2 = {
        ...sharedParams,
        primaryColor: "#3f51b5",
        foregroundColor: "#fffD",
        headerTextColor: "#fff8",
        accentColor: "#bb86fc",
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        selectedRowBackgroundColor: "#bb86fc33"
    };
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "styleMaterial",
        css: $437b23f6a393c3bf$var$materialAdjustmentsCSS,
        params: lightParams,
        modeParams: {
            light: lightParams,
            dark: darkParams2,
            "dark-blue": darkParams2
        }
    });
};
var $437b23f6a393c3bf$export$5fe7e1ddfe58a67 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeStyleMaterialTreeShakeable();
var $437b23f6a393c3bf$var$makeThemeMaterialTreeShakeable = ()=>/* @__PURE__ */ $437b23f6a393c3bf$export$25d302a5b900a763().withPart($437b23f6a393c3bf$export$ac3227978dde8e12).withPart($437b23f6a393c3bf$export$cb8a4bb75f2f86bb).withPart($437b23f6a393c3bf$export$e4400993032942f7).withPart($437b23f6a393c3bf$export$e9404e008fead04f).withPart($437b23f6a393c3bf$export$4c07fbd6ebedeb01).withPart($437b23f6a393c3bf$export$c9667c02da45fcf0).withPart($437b23f6a393c3bf$export$9eadc93b54e4a807).withPart($437b23f6a393c3bf$export$5fe7e1ddfe58a67).withParams({
        rowHeight: {
            calc: "max(iconSize, dataFontSize) + spacing * 3.75 * rowVerticalPaddingScale"
        },
        headerHeight: {
            calc: "max(iconSize, dataFontSize) + spacing * 4.75 * headerVerticalPaddingScale"
        },
        widgetVerticalSpacing: {
            calc: "spacing * 1.75"
        },
        cellHorizontalPadding: {
            calc: "spacing * 3"
        },
        buttonHorizontalPadding: {
            ref: "spacing"
        },
        widgetContainerHorizontalPadding: {
            calc: "spacing * 1.5"
        },
        widgetContainerVerticalPadding: {
            calc: "spacing * 2"
        },
        fontSize: 13,
        iconSize: 18,
        borderRadius: 0,
        wrapperBorderRadius: 0,
        wrapperBorder: false,
        menuBorder: false,
        dialogBorder: false,
        panelTitleBarBorder: false,
        tabSelectedBorderWidth: 0,
        tabSelectedUnderlineTransitionDuration: 0.3,
        sidePanelBorder: false,
        sideButtonSelectedBorder: false,
        sideButtonSelectedUnderlineWidth: 2,
        sideButtonSelectedUnderlineTransitionDuration: 0.3,
        sideButtonBorder: false,
        buttonBorder: false,
        buttonDisabledBorder: false,
        focusShadow: {
            spread: 4,
            color: $437b23f6a393c3bf$var$foregroundMix(0.16)
        },
        fontFamily: [
            {
                googleFont: "Roboto"
            },
            "-apple-system",
            "BlinkMacSystemFont",
            "Segoe UI",
            "Oxygen-Sans",
            "Ubuntu",
            "Cantarell",
            "Helvetica Neue",
            "sans-serif"
        ],
        inputHeight: {
            calc: "max(iconSize, fontSize) + spacing * 3"
        },
        pickerButtonBorder: {
            width: 1,
            color: "transparent"
        },
        headerFontWeight: 600,
        headerFontSize: {
            calc: "fontSize - 1px"
        },
        checkboxBorderWidth: 2,
        checkboxBorderRadius: 2,
        toggleButtonWidth: 34,
        toggleButtonSwitchInset: 1,
        cardShadow: "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
        popupShadow: "5px 5px 10px rgba(0, 0, 0, 0.3)"
    });
var $437b23f6a393c3bf$export$55ff169dc6a8025a = /* @__PURE__ */ $437b23f6a393c3bf$var$makeThemeMaterialTreeShakeable();
// packages/ag-grid-community/src/environment.ts
var $437b23f6a393c3bf$var$CELL_HORIZONTAL_PADDING = {
    cssName: "--ag-cell-horizontal-padding",
    changeKey: "cellHorizontalPaddingChanged",
    defaultValue: 16
};
var $437b23f6a393c3bf$var$INDENTATION_LEVEL = {
    cssName: "--ag-indentation-level",
    changeKey: "indentationLevelChanged",
    defaultValue: 0,
    noWarn: true,
    cacheDefault: true
};
var $437b23f6a393c3bf$var$ROW_GROUP_INDENT_SIZE = {
    cssName: "--ag-row-group-indent-size",
    changeKey: "rowGroupIndentSizeChanged",
    defaultValue: 0
};
var $437b23f6a393c3bf$var$ROW_HEIGHT = {
    cssName: "--ag-row-height",
    changeKey: "rowHeightChanged",
    defaultValue: 42
};
var $437b23f6a393c3bf$var$HEADER_HEIGHT = {
    cssName: "--ag-header-height",
    changeKey: "headerHeightChanged",
    defaultValue: 48
};
var $437b23f6a393c3bf$var$LIST_ITEM_HEIGHT = {
    cssName: "--ag-list-item-height",
    changeKey: "listItemHeightChanged",
    defaultValue: 24
};
var $437b23f6a393c3bf$var$ROW_BORDER_WIDTH = {
    cssName: "--ag-row-border",
    changeKey: "rowBorderWidthChanged",
    defaultValue: 1,
    border: true
};
var $437b23f6a393c3bf$var$PINNED_BORDER_WIDTH = {
    cssName: "--ag-pinned-row-border",
    changeKey: "pinnedRowBorderWidthChanged",
    defaultValue: 1,
    border: true
};
var $437b23f6a393c3bf$var$paramsId = 0;
var $437b23f6a393c3bf$var$Environment = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "environment";
        this.sizeEls = /* @__PURE__ */ new Map();
        this.lastKnownValues = /* @__PURE__ */ new Map();
        this.sizesMeasured = false;
        this.paramsClass = `ag-theme-params-${++$437b23f6a393c3bf$var$paramsId}`;
        this.globalCSS = [];
    }
    wireBeans(beans) {
        const { eGridDiv: eGridDiv, gridOptions: gridOptions } = beans;
        this.eGridDiv = eGridDiv;
        this.eStyleContainer = gridOptions.themeStyleContainer ?? (eGridDiv.getRootNode() === document ? document.head : eGridDiv);
        this.cssLayer = gridOptions.themeCssLayer;
        this.styleNonce = gridOptions.styleNonce;
    }
    postConstruct() {
        this.addManagedPropertyListener("theme", ()=>this.handleThemeGridOptionChange());
        this.handleThemeGridOptionChange();
        this.addManagedPropertyListener("rowHeight", ()=>this.refreshRowHeightVariable());
        this.getSizeEl($437b23f6a393c3bf$var$ROW_HEIGHT);
        this.getSizeEl($437b23f6a393c3bf$var$HEADER_HEIGHT);
        this.getSizeEl($437b23f6a393c3bf$var$LIST_ITEM_HEIGHT);
        this.getSizeEl($437b23f6a393c3bf$var$ROW_BORDER_WIDTH);
        this.getSizeEl($437b23f6a393c3bf$var$PINNED_BORDER_WIDTH);
        this.refreshRowBorderWidthVariable();
        this.addDestroyFunc(()=>$437b23f6a393c3bf$var$_unregisterGridUsingThemingAPI(this));
        this.mutationObserver = new MutationObserver(()=>{
            this.fireGridStylesChangedEvent("themeChanged");
        });
        this.addDestroyFunc(()=>this.mutationObserver.disconnect());
    }
    getPinnedRowBorderWidth() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$PINNED_BORDER_WIDTH);
    }
    getRowBorderWidth() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$ROW_BORDER_WIDTH);
    }
    getDefaultRowHeight() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$ROW_HEIGHT);
    }
    getDefaultHeaderHeight() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$HEADER_HEIGHT);
    }
    getDefaultCellHorizontalPadding() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$CELL_HORIZONTAL_PADDING);
    }
    getCellPaddingLeft() {
        const cellHorizontalPadding = this.getDefaultCellHorizontalPadding();
        const indentationLevel = this.getCSSVariablePixelValue($437b23f6a393c3bf$var$INDENTATION_LEVEL);
        const rowGroupIndentSize = this.getCSSVariablePixelValue($437b23f6a393c3bf$var$ROW_GROUP_INDENT_SIZE);
        return cellHorizontalPadding - 1 + rowGroupIndentSize * indentationLevel;
    }
    getCellPadding() {
        const cellPaddingRight = this.getDefaultCellHorizontalPadding() - 1;
        return this.getCellPaddingLeft() + cellPaddingRight;
    }
    getDefaultColumnMinWidth() {
        return Math.min(36, this.getDefaultRowHeight());
    }
    getDefaultListItemHeight() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$LIST_ITEM_HEIGHT);
    }
    applyThemeClasses(el) {
        const { gridTheme: gridTheme } = this;
        let themeClass = "";
        if (gridTheme) themeClass = `${this.paramsClass} ${gridTheme._getCssClass()}`;
        else {
            this.mutationObserver.disconnect();
            let node = this.eGridDiv;
            while(node){
                let isThemeEl = false;
                for (const className of Array.from(node.classList))if (className.startsWith("ag-theme-")) {
                    isThemeEl = true;
                    themeClass = themeClass ? `${themeClass} ${className}` : className;
                }
                if (isThemeEl) this.mutationObserver.observe(node, {
                    attributes: true,
                    attributeFilter: [
                        "class"
                    ]
                });
                node = node.parentElement;
            }
        }
        for (const className of Array.from(el.classList))if (className.startsWith("ag-theme-")) el.classList.remove(className);
        if (themeClass) {
            const oldClass = el.className;
            el.className = oldClass + (oldClass ? " " : "") + themeClass;
        }
    }
    refreshRowHeightVariable() {
        const { eGridDiv: eGridDiv } = this;
        const oldRowHeight = eGridDiv.style.getPropertyValue("--ag-line-height").trim();
        const height = this.gos.get("rowHeight");
        if (height == null || isNaN(height) || !isFinite(height)) {
            if (oldRowHeight !== null) eGridDiv.style.setProperty("--ag-line-height", null);
            return -1;
        }
        const newRowHeight = `${height}px`;
        if (oldRowHeight != newRowHeight) {
            eGridDiv.style.setProperty("--ag-line-height", newRowHeight);
            return height;
        }
        return oldRowHeight != "" ? parseFloat(oldRowHeight) : -1;
    }
    addGlobalCSS(css, debugId) {
        if (this.gridTheme) $437b23f6a393c3bf$var$_injectGlobalCSS(css, this.eStyleContainer, debugId, this.cssLayer, 0, this.styleNonce);
        else this.globalCSS.push([
            css,
            debugId
        ]);
    }
    getCSSVariablePixelValue(variable) {
        const cached = this.lastKnownValues.get(variable);
        if (cached != null) return cached;
        const measurement = this.measureSizeEl(variable);
        if (measurement === "detached" || measurement === "no-styles") {
            if (variable.cacheDefault) this.lastKnownValues.set(variable, variable.defaultValue);
            return variable.defaultValue;
        }
        this.lastKnownValues.set(variable, measurement);
        return measurement;
    }
    measureSizeEl(variable) {
        const sizeEl = this.getSizeEl(variable);
        if (sizeEl.offsetParent == null) return "detached";
        const newSize = sizeEl.offsetWidth;
        if (newSize === $437b23f6a393c3bf$var$NO_VALUE_SENTINEL) return "no-styles";
        this.sizesMeasured = true;
        return newSize;
    }
    getMeasurementContainer() {
        let container = this.eMeasurementContainer;
        if (!container) {
            container = this.eMeasurementContainer = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "div",
                cls: "ag-measurement-container"
            });
            this.eGridDiv.appendChild(container);
        }
        return container;
    }
    getSizeEl(variable) {
        let sizeEl = this.sizeEls.get(variable);
        if (sizeEl) return sizeEl;
        const container = this.getMeasurementContainer();
        sizeEl = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div"
        });
        const { border: border, noWarn: noWarn } = variable;
        if (border) {
            sizeEl.className = "ag-measurement-element-border";
            sizeEl.style.setProperty("--ag-internal-measurement-border", `var(${variable.cssName}, solid ${$437b23f6a393c3bf$var$NO_VALUE_SENTINEL}px)`);
        } else sizeEl.style.width = `var(${variable.cssName}, ${$437b23f6a393c3bf$var$NO_VALUE_SENTINEL}px)`;
        container.appendChild(sizeEl);
        this.sizeEls.set(variable, sizeEl);
        let lastMeasurement = this.measureSizeEl(variable);
        if (lastMeasurement === "no-styles" && !noWarn) $437b23f6a393c3bf$export$545083624300f13d(9, {
            variable: variable
        });
        const unsubscribe = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, sizeEl, ()=>{
            const newMeasurement = this.measureSizeEl(variable);
            if (newMeasurement === "detached" || newMeasurement === "no-styles") return;
            this.lastKnownValues.set(variable, newMeasurement);
            if (newMeasurement !== lastMeasurement) {
                lastMeasurement = newMeasurement;
                this.fireGridStylesChangedEvent(variable.changeKey);
            }
        });
        this.addDestroyFunc(()=>unsubscribe());
        return sizeEl;
    }
    fireGridStylesChangedEvent(change) {
        if (change === "rowBorderWidthChanged") this.refreshRowBorderWidthVariable();
        this.eventSvc.dispatchEvent({
            type: "gridStylesChanged",
            [change]: true
        });
    }
    refreshRowBorderWidthVariable() {
        const width = this.getCSSVariablePixelValue($437b23f6a393c3bf$var$ROW_BORDER_WIDTH);
        this.eGridDiv.style.setProperty("--ag-internal-row-border-width", `${width}px`);
    }
    handleThemeGridOptionChange() {
        const { gos: gos, eGridDiv: eGridDiv, globalCSS: globalCSS, gridTheme: oldGridTheme } = this;
        const themeGridOption = gos.get("theme");
        let newGridTheme;
        if (themeGridOption === "legacy") newGridTheme = void 0;
        else {
            const themeOrDefault = themeGridOption ?? $437b23f6a393c3bf$export$495b90cf446940a1;
            if (themeOrDefault instanceof $437b23f6a393c3bf$var$ThemeImpl) newGridTheme = themeOrDefault;
            else $437b23f6a393c3bf$export$a20c7248650823a9(240, {
                theme: themeOrDefault
            });
        }
        if (newGridTheme !== oldGridTheme) {
            if (newGridTheme) {
                $437b23f6a393c3bf$var$_registerGridUsingThemingAPI(this);
                $437b23f6a393c3bf$var$_injectCoreAndModuleCSS(this.eStyleContainer, this.cssLayer, this.styleNonce);
                for (const [css, debugId] of globalCSS)$437b23f6a393c3bf$var$_injectGlobalCSS(css, this.eStyleContainer, debugId, this.cssLayer, 0, this.styleNonce);
                globalCSS.length = 0;
            }
            this.gridTheme = newGridTheme;
            newGridTheme?._startUse({
                loadThemeGoogleFonts: gos.get("loadThemeGoogleFonts"),
                styleContainer: this.eStyleContainer,
                cssLayer: this.cssLayer,
                nonce: this.styleNonce
            });
            let eParamsStyle = this.eParamsStyle;
            if (!eParamsStyle) {
                eParamsStyle = this.eParamsStyle = $437b23f6a393c3bf$export$a232bb0480ae674a({
                    tag: "style"
                });
                const styleNonce = this.gos.get("styleNonce");
                if (styleNonce) eParamsStyle.setAttribute("nonce", styleNonce);
                eGridDiv.appendChild(eParamsStyle);
            }
            if (!$437b23f6a393c3bf$var$IS_SSR) eParamsStyle.textContent = newGridTheme?._getPerGridCss(this.paramsClass) || "";
            this.applyThemeClasses(eGridDiv);
            this.fireGridStylesChangedEvent("themeChanged");
        }
        if (newGridTheme && getComputedStyle(this.getMeasurementContainer()).getPropertyValue("--ag-legacy-styles-loaded")) {
            if (themeGridOption) $437b23f6a393c3bf$export$a20c7248650823a9(106);
            else $437b23f6a393c3bf$export$a20c7248650823a9(239);
        }
    }
};
var $437b23f6a393c3bf$var$NO_VALUE_SENTINEL = 15538;
// packages/ag-grid-community/src/eventService.ts
var $437b23f6a393c3bf$var$EventService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "eventSvc";
        this.globalSvc = new $437b23f6a393c3bf$export$820da7696a401cdc();
    }
    postConstruct() {
        const { globalListener: globalListener, globalSyncListener: globalSyncListener } = this.beans;
        if (globalListener) this.addGlobalListener(globalListener, true);
        if (globalSyncListener) this.addGlobalListener(globalSyncListener, false);
    }
    addEventListener(eventType, listener, async) {
        this.globalSvc.addEventListener(eventType, listener, async);
    }
    removeEventListener(eventType, listener, async) {
        this.globalSvc.removeEventListener(eventType, listener, async);
    }
    addGlobalListener(listener, async = false) {
        this.globalSvc.addGlobalListener(listener, async);
    }
    removeGlobalListener(listener, async = false) {
        this.globalSvc.removeGlobalListener(listener, async);
    }
    /** @deprecated DO NOT FIRE LOCAL EVENTS OFF THE EVENT SERVICE */ dispatchLocalEvent() {}
    dispatchEvent(event) {
        this.globalSvc.dispatchEvent($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, event));
    }
    dispatchEventOnce(event) {
        this.globalSvc.dispatchEventOnce($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, event));
    }
};
// packages/ag-grid-community/src/navigation/headerNavigationService.ts
function $437b23f6a393c3bf$var$getHeaderIndexToFocus(beans, column, level) {
    const columnRowIndex = beans.visibleCols.headerGroupRowCount;
    if (level >= columnRowIndex) return {
        column: column,
        headerRowIndex: level
    };
    let parent = column.getParent();
    while(parent && parent.getProvidedColumnGroup().getLevel() > level)parent = parent.getParent();
    const isColSpanning = column.isSpanHeaderHeight();
    if (!parent || isColSpanning && parent.isPadding()) return {
        column: column,
        headerRowIndex: columnRowIndex
    };
    return {
        column: parent,
        headerRowIndex: parent.getProvidedColumnGroup().getLevel()
    };
}
var $437b23f6a393c3bf$var$HeaderNavigationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "headerNavigation";
        this.currentHeaderRowWithoutSpan = -1;
    }
    postConstruct() {
        const beans = this.beans;
        beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
        this.addManagedElementListeners(eDocument, {
            mousedown: ()=>{
                this.currentHeaderRowWithoutSpan = -1;
            }
        });
    }
    getHeaderPositionForColumn(colKey, floatingFilter) {
        let column;
        const { colModel: colModel, colGroupSvc: colGroupSvc, ctrlsSvc: ctrlsSvc } = this.beans;
        if (typeof colKey === "string") {
            column = colModel.getCol(colKey);
            if (!column) column = colGroupSvc?.getColumnGroup(colKey) ?? null;
        } else column = colKey;
        if (!column) return null;
        const centerHeaderContainer = ctrlsSvc.getHeaderRowContainerCtrl();
        const allCtrls = centerHeaderContainer?.getAllCtrls();
        const isFloatingFilterVisible = $437b23f6a393c3bf$export$236389741107357f(allCtrls || []).type === "filter";
        const headerRowCount = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans) - 1;
        let row = -1;
        let col = column;
        while(col){
            row++;
            col = col.getParent();
        }
        let headerRowIndex = row;
        if (floatingFilter && isFloatingFilterVisible && headerRowIndex === headerRowCount - 1) headerRowIndex++;
        return headerRowIndex === -1 ? null : {
            headerRowIndex: headerRowIndex,
            column: column
        };
    }
    /*
   * This method navigates grid header vertically
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */ navigateVertically(direction, event) {
        const { focusSvc: focusSvc, visibleCols: visibleCols } = this.beans;
        const { focusedHeader: focusedHeader } = focusSvc;
        if (!focusedHeader) return false;
        const { headerRowIndex: headerRowIndex } = focusedHeader;
        const column = focusedHeader.column;
        const rowLen = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans);
        const currentRowType = this.getHeaderRowType(headerRowIndex);
        const columnHeaderRowIndex = visibleCols.headerGroupRowCount;
        let { headerRowIndex: nextRow, column: nextFocusColumn, headerRowIndexWithoutSpan: headerRowIndexWithoutSpan } = direction === "UP" ? $437b23f6a393c3bf$var$getColumnVisibleParent(currentRowType, column, headerRowIndex) : $437b23f6a393c3bf$var$getColumnVisibleChild(column, headerRowIndex, columnHeaderRowIndex);
        let skipColumn = false;
        if (nextRow < 0) {
            nextRow = 0;
            nextFocusColumn = column;
            skipColumn = true;
        }
        if (nextRow >= rowLen) {
            nextRow = -1;
            this.currentHeaderRowWithoutSpan = -1;
        } else if (headerRowIndexWithoutSpan !== void 0) this.currentHeaderRowWithoutSpan = headerRowIndexWithoutSpan;
        if (!skipColumn && !nextFocusColumn) return false;
        return focusSvc.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: nextRow,
                column: nextFocusColumn
            },
            allowUserOverride: true,
            event: event
        });
    }
    /*
   * This method navigates grid header horizontally
   * @returns {boolean} true to preventDefault on the event that caused this navigation.
   */ navigateHorizontally(direction, fromTab = false, event) {
        const { focusSvc: focusSvc, gos: gos } = this.beans;
        const focusedHeader = {
            ...focusSvc.focusedHeader
        };
        let nextHeader;
        let normalisedDirection;
        if (this.currentHeaderRowWithoutSpan !== -1) focusedHeader.headerRowIndex = this.currentHeaderRowWithoutSpan;
        else this.currentHeaderRowWithoutSpan = focusedHeader.headerRowIndex;
        if (direction === "LEFT" !== gos.get("enableRtl")) {
            normalisedDirection = "Before";
            nextHeader = this.findHeader(focusedHeader, normalisedDirection);
        } else {
            normalisedDirection = "After";
            nextHeader = this.findHeader(focusedHeader, normalisedDirection);
        }
        const userFunc = gos.getCallback("tabToNextHeader");
        if (fromTab && userFunc) {
            const wasFocusedFromUserFunc = focusSvc.focusHeaderPositionFromUserFunc({
                userFunc: userFunc,
                headerPosition: nextHeader,
                direction: normalisedDirection
            });
            if (wasFocusedFromUserFunc) {
                const { headerRowIndex: headerRowIndex } = focusSvc.focusedHeader || {};
                if (headerRowIndex != null && headerRowIndex != focusedHeader.headerRowIndex) this.currentHeaderRowWithoutSpan = headerRowIndex;
            }
            return wasFocusedFromUserFunc;
        }
        if (nextHeader || !fromTab) return focusSvc.focusHeaderPosition({
            headerPosition: nextHeader,
            direction: normalisedDirection,
            fromTab: fromTab,
            allowUserOverride: true,
            event: event
        });
        return this.focusNextHeaderRow(focusedHeader, normalisedDirection, event);
    }
    focusNextHeaderRow(focusedHeader, direction, event) {
        const beans = this.beans;
        const currentIndex = focusedHeader.headerRowIndex;
        let nextFocusedCol = null;
        let nextRowIndex;
        const headerRowCount = $437b23f6a393c3bf$var$getFocusHeaderRowCount(beans);
        const allVisibleCols = this.beans.visibleCols.allCols;
        if (direction === "Before") {
            if (currentIndex <= 0) return false;
            nextFocusedCol = $437b23f6a393c3bf$export$236389741107357f(allVisibleCols);
            nextRowIndex = currentIndex - 1;
            this.currentHeaderRowWithoutSpan -= 1;
        } else {
            nextFocusedCol = allVisibleCols[0];
            nextRowIndex = currentIndex + 1;
            if (this.currentHeaderRowWithoutSpan < headerRowCount) this.currentHeaderRowWithoutSpan += 1;
            else this.currentHeaderRowWithoutSpan = -1;
        }
        let { column: column, headerRowIndex: headerRowIndex } = $437b23f6a393c3bf$var$getHeaderIndexToFocus(this.beans, nextFocusedCol, nextRowIndex);
        if (headerRowIndex >= headerRowCount) headerRowIndex = -1;
        return beans.focusSvc.focusHeaderPosition({
            headerPosition: {
                column: column,
                headerRowIndex: headerRowIndex
            },
            direction: direction,
            fromTab: true,
            allowUserOverride: true,
            event: event
        });
    }
    scrollToColumn(column, direction = "After") {
        if (column.getPinned()) return;
        let columnToScrollTo;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(column)) {
            const columns = column.getDisplayedLeafColumns();
            columnToScrollTo = direction === "Before" ? $437b23f6a393c3bf$export$236389741107357f(columns) : columns[0];
        } else columnToScrollTo = column;
        this.gridBodyCon.scrollFeature.ensureColumnVisible(columnToScrollTo);
    }
    findHeader(focusedHeader, direction) {
        const { colGroupSvc: colGroupSvc, visibleCols: visibleCols } = this.beans;
        let currentFocusedColumn = focusedHeader.column;
        if (currentFocusedColumn instanceof $437b23f6a393c3bf$export$273c80940a54c770) {
            const leafChildren = currentFocusedColumn.getDisplayedLeafColumns();
            currentFocusedColumn = direction === "Before" ? leafChildren[0] : leafChildren[leafChildren.length - 1];
        }
        const nextFocusedCol = direction === "Before" ? visibleCols.getColBefore(currentFocusedColumn) : visibleCols.getColAfter(currentFocusedColumn);
        if (!nextFocusedCol) return void 0;
        const headerGroupRowIndex = visibleCols.headerGroupRowCount;
        if (focusedHeader.headerRowIndex >= headerGroupRowIndex) return {
            headerRowIndex: focusedHeader.headerRowIndex,
            column: nextFocusedCol
        };
        const groupAtLevel = colGroupSvc?.getColGroupAtLevel(nextFocusedCol, focusedHeader.headerRowIndex);
        if (!groupAtLevel) {
            const isSpanningCol = nextFocusedCol instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2 && nextFocusedCol.isSpanHeaderHeight();
            return {
                headerRowIndex: isSpanningCol ? visibleCols.headerGroupRowCount : focusedHeader.headerRowIndex,
                column: nextFocusedCol
            };
        }
        if (groupAtLevel.isPadding() && nextFocusedCol.isSpanHeaderHeight()) return {
            headerRowIndex: visibleCols.headerGroupRowCount,
            column: nextFocusedCol
        };
        return {
            headerRowIndex: focusedHeader.headerRowIndex,
            column: groupAtLevel ?? nextFocusedCol
        };
    }
    getHeaderRowType(rowIndex) {
        const centerHeaderContainer = this.beans.ctrlsSvc.getHeaderRowContainerCtrl();
        if (centerHeaderContainer) return centerHeaderContainer.getRowType(rowIndex);
    }
};
function $437b23f6a393c3bf$var$getColumnVisibleParent(currentRowType, currentColumn, currentIndex) {
    const optimisticNextIndex = currentIndex - 1;
    if (currentRowType !== "filter") {
        const isSpanningCol = currentColumn instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2 && currentColumn.isSpanHeaderHeight();
        let nextVisibleParent = currentColumn.getParent();
        while(nextVisibleParent && // skip if row isn't visible or col is padding and spanned
        (nextVisibleParent.getProvidedColumnGroup().getLevel() > optimisticNextIndex || isSpanningCol && nextVisibleParent.isPadding()))nextVisibleParent = nextVisibleParent.getParent();
        if (nextVisibleParent) {
            if (isSpanningCol) return {
                column: nextVisibleParent,
                headerRowIndex: nextVisibleParent.getProvidedColumnGroup().getLevel(),
                headerRowIndexWithoutSpan: optimisticNextIndex
            };
            else return {
                column: nextVisibleParent,
                headerRowIndex: optimisticNextIndex,
                headerRowIndexWithoutSpan: optimisticNextIndex
            };
        }
    }
    return {
        column: currentColumn,
        headerRowIndex: optimisticNextIndex,
        headerRowIndexWithoutSpan: optimisticNextIndex
    };
}
function $437b23f6a393c3bf$var$getColumnVisibleChild(column, currentIndex, columnHeaderRowIndex) {
    const optimisticNextIndex = currentIndex + 1;
    const result = {
        column: column,
        headerRowIndex: optimisticNextIndex,
        headerRowIndexWithoutSpan: optimisticNextIndex
    };
    if (column instanceof $437b23f6a393c3bf$export$273c80940a54c770) {
        if (optimisticNextIndex >= columnHeaderRowIndex) return {
            column: column.getDisplayedLeafColumns()[0],
            headerRowIndex: columnHeaderRowIndex,
            headerRowIndexWithoutSpan: optimisticNextIndex
        };
        const children = column.getDisplayedChildren();
        let firstChild = children[0];
        if (firstChild instanceof $437b23f6a393c3bf$export$273c80940a54c770 && firstChild.isPadding()) {
            const firstCol = firstChild.getDisplayedLeafColumns()[0];
            if (firstCol.isSpanHeaderHeight()) firstChild = firstCol;
        }
        result.column = firstChild;
        const isSpanningCol = firstChild instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2 && firstChild.isSpanHeaderHeight();
        if (isSpanningCol) {
            result.headerRowIndex = columnHeaderRowIndex;
            result.headerRowIndexWithoutSpan = optimisticNextIndex;
        }
    }
    return result;
}
// packages/ag-grid-community/src/focusService.ts
var $437b23f6a393c3bf$var$FocusService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "focusSvc";
        /** If a cell was destroyed that previously had focus, focus needs restored when the cell reappears */ this.focusFallbackTimeout = null;
        this.needsFocusRestored = false;
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.visibleCols = beans.visibleCols;
        this.rowRenderer = beans.rowRenderer;
        this.navigation = beans.navigation;
        this.filterManager = beans.filterManager;
        this.overlays = beans.overlays;
    }
    postConstruct() {
        const clearFocusedCellListener = this.clearFocusedCell.bind(this);
        this.addManagedEventListeners({
            columnPivotModeChanged: clearFocusedCellListener,
            newColumnsLoaded: this.onColumnEverythingChanged.bind(this),
            columnGroupOpened: clearFocusedCellListener,
            columnRowGroupChanged: clearFocusedCellListener
        });
        this.addDestroyFunc($437b23f6a393c3bf$var$_registerKeyboardFocusEvents(this.beans));
    }
    attemptToRecoverFocus() {
        this.needsFocusRestored = true;
        if (this.focusFallbackTimeout != null) clearTimeout(this.focusFallbackTimeout);
        this.focusFallbackTimeout = window.setTimeout(this.setFocusRecovered.bind(this), 100);
    }
    setFocusRecovered() {
        this.needsFocusRestored = false;
        if (this.focusFallbackTimeout != null) {
            clearTimeout(this.focusFallbackTimeout);
            this.focusFallbackTimeout = null;
        }
    }
    /**
   * Specifies whether to take focus, as grid either already has focus, or lost it due
   * to a destroyed cell
   * @returns true if the grid should re-take focus, otherwise false
   */ shouldTakeFocus() {
        if (this.gos.get("suppressFocusAfterRefresh")) {
            this.setFocusRecovered();
            return false;
        }
        if (this.needsFocusRestored) {
            this.setFocusRecovered();
            return true;
        }
        return this.doesRowOrCellHaveBrowserFocus();
    }
    onColumnEverythingChanged() {
        if (!this.focusedCell) return;
        const col = this.focusedCell.column;
        const colFromColumnModel = this.colModel.getCol(col.getId());
        if (col !== colFromColumnModel) this.clearFocusedCell();
    }
    // we check if the browser is focusing something, and if it is, and
    // it's the cell we think is focused, then return the cell. so this
    // methods returns the cell if a) we think it has focus and b) the
    // browser thinks it has focus. this then returns nothing if we
    // first focus a cell, then second click outside the grid, as then the
    // grid cell will still be focused as far as the grid is concerned,
    // however the browser focus will have moved somewhere else.
    getFocusCellToUseAfterRefresh() {
        const { gos: gos, focusedCell: focusedCell } = this;
        if (gos.get("suppressFocusAfterRefresh") || gos.get("suppressCellFocus") || !focusedCell) return null;
        if (!this.doesRowOrCellHaveBrowserFocus()) return null;
        return focusedCell;
    }
    getFocusHeaderToUseAfterRefresh() {
        if (this.gos.get("suppressFocusAfterRefresh") || !this.focusedHeader) return null;
        if (!this.isDomDataPresentInHierarchy($437b23f6a393c3bf$export$16bc98d422315038(this.beans), $437b23f6a393c3bf$var$DOM_DATA_KEY_HEADER_CTRL)) return null;
        return this.focusedHeader;
    }
    /**
   * Check for both cells and rows, as a row might be destroyed and the dom data removed before the cell if the
   * row is animating out.
   */ doesRowOrCellHaveBrowserFocus() {
        const activeElement = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        if (this.isDomDataPresentInHierarchy(activeElement, $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL)) return true;
        return this.isDomDataPresentInHierarchy(activeElement, $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL);
    }
    isDomDataPresentInHierarchy(eBrowserCell, key) {
        let ePointer = eBrowserCell;
        while(ePointer){
            const data = $437b23f6a393c3bf$var$_getDomData(this.gos, ePointer, key);
            if (data) return true;
            ePointer = ePointer.parentNode;
        }
        return false;
    }
    getFocusedCell() {
        return this.focusedCell;
    }
    getFocusEventParams(focusedCellPosition) {
        const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = focusedCellPosition;
        const params = {
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            column: column,
            isFullWidthCell: false
        };
        const rowCtrl = this.rowRenderer.getRowByPosition({
            rowIndex: rowIndex,
            rowPinned: rowPinned
        });
        if (rowCtrl) params.isFullWidthCell = rowCtrl.isFullWidth();
        return params;
    }
    clearFocusedCell() {
        if (this.focusedCell == null) return;
        const focusEventParams = this.getFocusEventParams(this.focusedCell);
        this.focusedCell = null;
        this.eventSvc.dispatchEvent({
            type: "cellFocusCleared",
            ...focusEventParams
        });
    }
    setFocusedCell(params) {
        this.setFocusRecovered();
        const { column: column, rowIndex: rowIndex, rowPinned: rowPinned, forceBrowserFocus: forceBrowserFocus = false, preventScrollOnBrowserFocus: preventScrollOnBrowserFocus = false, sourceEvent: sourceEvent } = params;
        const gridColumn = this.colModel.getCol(column);
        if (!gridColumn) {
            this.focusedCell = null;
            return;
        }
        this.focusedCell = {
            rowIndex: rowIndex,
            rowPinned: $437b23f6a393c3bf$export$4978424c4f7b5fc0(rowPinned),
            column: gridColumn
        };
        const focusEventParams = this.getFocusEventParams(this.focusedCell);
        this.eventSvc.dispatchEvent({
            type: "cellFocused",
            ...focusEventParams,
            ...this.previousCellFocusParams && {
                previousParams: this.previousCellFocusParams
            },
            forceBrowserFocus: forceBrowserFocus,
            preventScrollOnBrowserFocus: preventScrollOnBrowserFocus,
            sourceEvent: sourceEvent
        });
        this.previousCellFocusParams = focusEventParams;
    }
    isCellFocused(cellPosition) {
        if (this.focusedCell == null) return false;
        return $437b23f6a393c3bf$export$be3973033c2c5267(cellPosition, this.focusedCell);
    }
    isHeaderWrapperFocused(headerCtrl) {
        if (this.focusedHeader == null) return false;
        const { column: column, rowCtrl: { rowIndex: headerRowIndex, pinned: pinned } } = headerCtrl;
        const { column: focusedColumn, headerRowIndex: focusedHeaderRowIndex } = this.focusedHeader;
        return column === focusedColumn && headerRowIndex === focusedHeaderRowIndex && pinned == focusedColumn.getPinned();
    }
    focusHeaderPosition(params) {
        this.setFocusRecovered();
        if ($437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans)) return false;
        const { direction: direction, fromTab: fromTab, allowUserOverride: allowUserOverride, event: event, fromCell: fromCell, rowWithoutSpanValue: rowWithoutSpanValue } = params;
        let { headerPosition: headerPosition } = params;
        if (fromCell && this.filterManager?.isAdvFilterHeaderActive()) return this.focusAdvancedFilter(headerPosition);
        if (allowUserOverride) {
            const currentPosition = this.focusedHeader;
            const headerRowCount = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans);
            if (fromTab) {
                const userFunc = this.gos.getCallback("tabToNextHeader");
                if (userFunc) headerPosition = this.getHeaderPositionFromUserFunc({
                    userFunc: userFunc,
                    direction: direction,
                    currentPosition: currentPosition,
                    headerPosition: headerPosition,
                    headerRowCount: headerRowCount
                });
            } else {
                const userFunc = this.gos.getCallback("navigateToNextHeader");
                if (userFunc && event) {
                    const params2 = {
                        key: event.key,
                        previousHeaderPosition: currentPosition,
                        nextHeaderPosition: headerPosition,
                        headerRowCount: headerRowCount,
                        event: event
                    };
                    headerPosition = userFunc(params2);
                }
            }
        }
        if (!headerPosition) return false;
        return this.focusProvidedHeaderPosition({
            headerPosition: headerPosition,
            direction: direction,
            event: event,
            fromCell: fromCell,
            rowWithoutSpanValue: rowWithoutSpanValue
        });
    }
    focusHeaderPositionFromUserFunc(params) {
        if ($437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans)) return false;
        const { userFunc: userFunc, headerPosition: headerPosition, direction: direction, event: event } = params;
        const currentPosition = this.focusedHeader;
        const headerRowCount = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans);
        const newHeaderPosition = this.getHeaderPositionFromUserFunc({
            userFunc: userFunc,
            direction: direction,
            currentPosition: currentPosition,
            headerPosition: headerPosition,
            headerRowCount: headerRowCount
        });
        return !!newHeaderPosition && this.focusProvidedHeaderPosition({
            headerPosition: newHeaderPosition,
            direction: direction,
            event: event
        });
    }
    getHeaderPositionFromUserFunc(params) {
        const { userFunc: userFunc, direction: direction, currentPosition: currentPosition, headerPosition: headerPosition, headerRowCount: headerRowCount } = params;
        const userFuncParams = {
            backwards: direction === "Before",
            previousHeaderPosition: currentPosition,
            nextHeaderPosition: headerPosition,
            headerRowCount: headerRowCount
        };
        const userResult = userFunc(userFuncParams);
        if (userResult === true) return currentPosition;
        if (userResult === false) return null;
        return userResult;
    }
    focusProvidedHeaderPosition(params) {
        const { headerPosition: headerPosition, direction: direction, fromCell: fromCell, rowWithoutSpanValue: rowWithoutSpanValue, event: event } = params;
        const { column: column, headerRowIndex: headerRowIndex } = headerPosition;
        const { filterManager: filterManager, ctrlsSvc: ctrlsSvc, headerNavigation: headerNavigation } = this.beans;
        if (headerRowIndex === -1) {
            if (filterManager?.isAdvFilterHeaderActive()) return this.focusAdvancedFilter(headerPosition);
            return this.focusGridView({
                column: column,
                event: event
            });
        }
        headerNavigation?.scrollToColumn(column, direction);
        const headerRowContainerCtrl = ctrlsSvc.getHeaderRowContainerCtrl(column.getPinned());
        const focusSuccess = headerRowContainerCtrl?.focusHeader(headerPosition.headerRowIndex, column, event) || false;
        if (headerNavigation && focusSuccess && (rowWithoutSpanValue != null || fromCell)) headerNavigation.currentHeaderRowWithoutSpan = rowWithoutSpanValue ?? -1;
        return focusSuccess;
    }
    focusFirstHeader() {
        if (this.overlays?.isExclusive() && this.focusOverlay()) return true;
        const firstColumn = this.visibleCols.allCols[0];
        if (!firstColumn) return false;
        const headerPosition = $437b23f6a393c3bf$var$getHeaderIndexToFocus(this.beans, firstColumn, 0);
        return this.focusHeaderPosition({
            headerPosition: headerPosition,
            rowWithoutSpanValue: 0
        });
    }
    focusLastHeader(event) {
        if (this.overlays?.isExclusive() && this.focusOverlay(true)) return true;
        const headerRowIndex = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans) - 1;
        const column = $437b23f6a393c3bf$export$236389741107357f(this.visibleCols.allCols);
        return this.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: headerRowIndex,
                column: column
            },
            rowWithoutSpanValue: -1,
            event: event
        });
    }
    focusPreviousFromFirstCell(event) {
        if (this.filterManager?.isAdvFilterHeaderActive()) return this.focusAdvancedFilter(null);
        return this.focusLastHeader(event);
    }
    isAnyCellFocused() {
        return !!this.focusedCell;
    }
    isRowFocused(rowIndex, rowPinnedType) {
        if (this.focusedCell == null) return false;
        return this.focusedCell.rowIndex === rowIndex && this.focusedCell.rowPinned === $437b23f6a393c3bf$export$4978424c4f7b5fc0(rowPinnedType);
    }
    focusOverlay(backwards) {
        const overlayGui = this.overlays?.isVisible() && this.overlays.eWrapper?.getGui();
        return !!overlayGui && $437b23f6a393c3bf$export$8598088d375f416f(overlayGui, backwards);
    }
    focusGridView(params) {
        const { backwards: backwards = false, canFocusOverlay: canFocusOverlay = true, event: event } = params;
        if (this.overlays?.isExclusive()) return canFocusOverlay && this.focusOverlay(backwards);
        if ($437b23f6a393c3bf$var$_isCellFocusSuppressed(this.beans)) {
            if (backwards) {
                if (!$437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans)) return this.focusLastHeader();
            }
            if (canFocusOverlay && this.focusOverlay(backwards)) return true;
            if (backwards) return false;
            return $437b23f6a393c3bf$export$987f3c95dc941f0c(this.beans, backwards);
        }
        const nextRow = backwards ? $437b23f6a393c3bf$export$a1449222017e428(this.beans) : $437b23f6a393c3bf$var$_getFirstRow(this.beans);
        if (nextRow) {
            const column = params.column ?? this.focusedHeader?.column;
            const { rowIndex: rowIndex, rowPinned: rowPinned } = nextRow;
            const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, nextRow);
            if (!column || !rowNode || rowIndex == null) return false;
            if (column.isSuppressNavigable(rowNode)) {
                const isRtl = this.gos.get("enableRtl");
                let key;
                if (!event || event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) key = isRtl ? $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT : $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT;
                else key = event.key;
                this.beans.navigation?.navigateToNextCell(null, key, {
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned || null
                }, true);
                return true;
            }
            this.navigation?.ensureCellVisible({
                rowIndex: rowIndex,
                column: column,
                rowPinned: rowPinned
            });
            if (backwards) {
                const rowCtrl = this.rowRenderer.getRowByPosition(nextRow);
                if (rowCtrl?.isFullWidth() && this.navigation?.tryToFocusFullWidthRow(nextRow, backwards)) return true;
            }
            this.setFocusedCell({
                rowIndex: rowIndex,
                column: column,
                rowPinned: $437b23f6a393c3bf$export$4978424c4f7b5fc0(rowPinned),
                forceBrowserFocus: true
            });
            this.beans.rangeSvc?.setRangeToCell({
                rowIndex: rowIndex,
                rowPinned: rowPinned,
                column: column
            });
            return true;
        }
        if (canFocusOverlay && this.focusOverlay(backwards)) return true;
        if (backwards && this.focusLastHeader()) return true;
        return false;
    }
    focusAdvancedFilter(position) {
        this.advFilterFocusColumn = position?.column;
        return this.beans.advancedFilter?.getCtrl().focusHeaderComp() ?? false;
    }
    focusNextFromAdvancedFilter(backwards, forceFirstColumn) {
        const column = (forceFirstColumn ? void 0 : this.advFilterFocusColumn) ?? this.visibleCols.allCols?.[0];
        if (backwards) return this.focusHeaderPosition({
            headerPosition: {
                column: column,
                headerRowIndex: $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans) - 1
            }
        });
        else return this.focusGridView({
            column: column
        });
    }
    clearAdvancedFilterColumn() {
        this.advFilterFocusColumn = void 0;
    }
};
// packages/ag-grid-community/src/gridBodyComp/scrollVisibleService.ts
var $437b23f6a393c3bf$var$ScrollVisibleService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "scrollVisibleSvc";
    }
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
        this.colAnimation = beans.colAnimation;
    }
    postConstruct() {
        this.getScrollbarWidth();
        this.addManagedEventListeners({
            displayedColumnsChanged: this.updateScrollVisible.bind(this),
            displayedColumnsWidthChanged: this.updateScrollVisible.bind(this)
        });
    }
    updateScrollVisible() {
        const { colAnimation: colAnimation } = this;
        if (colAnimation?.isActive()) colAnimation.executeLaterVMTurn(()=>{
            colAnimation.executeLaterVMTurn(()=>this.updateScrollVisibleImpl());
        });
        else this.updateScrollVisibleImpl();
    }
    updateScrollVisibleImpl() {
        const centerRowCtrl = this.ctrlsSvc.get("center");
        if (!centerRowCtrl || this.colAnimation?.isActive()) return;
        const params = {
            horizontalScrollShowing: centerRowCtrl.isHorizontalScrollShowing(),
            verticalScrollShowing: this.verticalScrollShowing
        };
        this.setScrollsVisible(params);
        this.updateScrollGap();
    }
    updateScrollGap() {
        const centerRowCtrl = this.ctrlsSvc.get("center");
        const horizontalGap = centerRowCtrl.hasHorizontalScrollGap();
        const verticalGap = centerRowCtrl.hasVerticalScrollGap();
        const atLeastOneDifferent = this.horizontalScrollGap !== horizontalGap || this.verticalScrollGap !== verticalGap;
        if (atLeastOneDifferent) {
            this.horizontalScrollGap = horizontalGap;
            this.verticalScrollGap = verticalGap;
            this.eventSvc.dispatchEvent({
                type: "scrollGapChanged"
            });
        }
    }
    setScrollsVisible(params) {
        const atLeastOneDifferent = this.horizontalScrollShowing !== params.horizontalScrollShowing || this.verticalScrollShowing !== params.verticalScrollShowing;
        if (atLeastOneDifferent) {
            this.horizontalScrollShowing = params.horizontalScrollShowing;
            this.verticalScrollShowing = params.verticalScrollShowing;
            this.eventSvc.dispatchEvent({
                type: "scrollVisibilityChanged"
            });
        }
    }
    // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
    // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
    // allow the user to provide the scroll width before we work it out.
    getScrollbarWidth() {
        if (this.scrollbarWidth == null) {
            const gridOptionsScrollbarWidth = this.gos.get("scrollbarWidth");
            const useGridOptions = typeof gridOptionsScrollbarWidth === "number" && gridOptionsScrollbarWidth >= 0;
            const scrollbarWidth = useGridOptions ? gridOptionsScrollbarWidth : $437b23f6a393c3bf$var$_getScrollbarWidth();
            if (scrollbarWidth != null) {
                this.scrollbarWidth = scrollbarWidth;
                this.eventSvc.dispatchEvent({
                    type: "scrollbarWidthChanged"
                });
            }
        }
        return this.scrollbarWidth;
    }
};
// packages/ag-grid-community/src/gridDestroyService.ts
var $437b23f6a393c3bf$var$GridDestroyService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "gridDestroySvc";
        this.destroyCalled = false;
    }
    destroy() {
        if (this.destroyCalled) return;
        const { stateSvc: stateSvc, ctrlsSvc: ctrlsSvc, context: context } = this.beans;
        this.eventSvc.dispatchEvent({
            type: "gridPreDestroyed",
            state: stateSvc?.getState() ?? {}
        });
        this.destroyCalled = true;
        ctrlsSvc.get("gridCtrl")?.destroyGridUi();
        context.destroy();
        super.destroy();
    }
};
// packages/ag-grid-community/src/events.ts
var $437b23f6a393c3bf$export$12e4e9a3cbd0ec07 = /* @__PURE__ */ new Set([
    "gridPreDestroyed",
    "fillStart",
    "pasteStart"
]);
// packages/ag-grid-community/src/eventTypes.ts
var $437b23f6a393c3bf$export$e9c8ffb796317123 = [
    "columnEverythingChanged",
    "newColumnsLoaded",
    "columnPivotModeChanged",
    "pivotMaxColumnsExceeded",
    "columnRowGroupChanged",
    "expandOrCollapseAll",
    "columnPivotChanged",
    "gridColumnsChanged",
    "columnValueChanged",
    "columnMoved",
    "columnVisible",
    "columnPinned",
    "columnGroupOpened",
    "columnResized",
    "displayedColumnsChanged",
    "virtualColumnsChanged",
    "columnHeaderMouseOver",
    "columnHeaderMouseLeave",
    "columnHeaderClicked",
    "columnHeaderContextMenu",
    "asyncTransactionsFlushed",
    "rowGroupOpened",
    "rowDataUpdated",
    "pinnedRowDataChanged",
    "pinnedRowsChanged",
    "rangeSelectionChanged",
    "cellSelectionChanged",
    "chartCreated",
    "chartRangeSelectionChanged",
    "chartOptionsChanged",
    "chartDestroyed",
    "toolPanelVisibleChanged",
    "toolPanelSizeChanged",
    "modelUpdated",
    "cutStart",
    "cutEnd",
    "pasteStart",
    "pasteEnd",
    "fillStart",
    "fillEnd",
    "cellSelectionDeleteStart",
    "cellSelectionDeleteEnd",
    "rangeDeleteStart",
    "rangeDeleteEnd",
    "undoStarted",
    "undoEnded",
    "redoStarted",
    "redoEnded",
    "cellClicked",
    "cellDoubleClicked",
    "cellMouseDown",
    "cellContextMenu",
    "cellValueChanged",
    "cellEditRequest",
    "rowValueChanged",
    "headerFocused",
    "cellFocused",
    "rowSelected",
    "selectionChanged",
    "tooltipShow",
    "tooltipHide",
    "cellKeyDown",
    "cellMouseOver",
    "cellMouseOut",
    "filterChanged",
    "filterModified",
    "filterUiChanged",
    "filterOpened",
    "floatingFilterUiChanged",
    "advancedFilterBuilderVisibleChanged",
    "sortChanged",
    "virtualRowRemoved",
    "rowClicked",
    "rowDoubleClicked",
    "gridReady",
    "gridPreDestroyed",
    "gridSizeChanged",
    "viewportChanged",
    "firstDataRendered",
    "dragStarted",
    "dragStopped",
    "dragCancelled",
    "rowEditingStarted",
    "rowEditingStopped",
    "cellEditingStarted",
    "cellEditingStopped",
    "bodyScroll",
    "bodyScrollEnd",
    "paginationChanged",
    "componentStateChanged",
    "storeRefreshed",
    "stateUpdated",
    "columnMenuVisibleChanged",
    "contextMenuVisibleChanged",
    "rowDragEnter",
    "rowDragMove",
    "rowDragLeave",
    "rowDragEnd",
    "rowDragCancel",
    "findChanged",
    "rowResizeStarted",
    "rowResizeEnded",
    "columnsReset",
    "bulkEditingStarted",
    "bulkEditingStopped",
    "batchEditingStarted",
    "batchEditingStopped"
];
var $437b23f6a393c3bf$var$_INTERNAL_EVENTS = [
    "scrollbarWidthChanged",
    "keyShortcutChangedCellStart",
    "keyShortcutChangedCellEnd",
    "pinnedHeightChanged",
    "cellFocusCleared",
    "fullWidthRowFocused",
    "checkboxChanged",
    "heightScaleChanged",
    "suppressMovableColumns",
    "suppressMenuHide",
    "suppressFieldDotNotation",
    "columnPanelItemDragStart",
    "columnPanelItemDragEnd",
    "bodyHeightChanged",
    "columnContainerWidthChanged",
    "displayedColumnsWidthChanged",
    "scrollVisibilityChanged",
    "scrollGapChanged",
    "columnHoverChanged",
    "flashCells",
    "paginationPixelOffsetChanged",
    "displayedRowsChanged",
    "leftPinnedWidthChanged",
    "rightPinnedWidthChanged",
    "rowContainerHeightChanged",
    "headerHeightChanged",
    "columnGroupHeaderHeightChanged",
    "columnHeaderHeightChanged",
    "gridStylesChanged",
    "storeUpdated",
    "filterDestroyed",
    "rowDataUpdateStarted",
    "rowCountReady",
    "advancedFilterEnabledChanged",
    "dataTypesInferred",
    "fieldValueChanged",
    "fieldPickerValueSelected",
    "richSelectListRowSelected",
    "sideBarUpdated",
    "alignedGridScroll",
    "alignedGridColumn",
    "gridOptionsChanged",
    "chartTitleEdit",
    "recalculateRowBounds",
    "stickyTopOffsetChanged",
    "overlayExclusiveChanged",
    "rowNodeDataChanged",
    "cellEditValuesChanged",
    "filterSwitched",
    "filterClosed",
    "headerRowsChanged"
];
var $437b23f6a393c3bf$export$a4bee1102f884a4d = ()=>[
        ...$437b23f6a393c3bf$export$e9c8ffb796317123,
        ...$437b23f6a393c3bf$var$_INTERNAL_EVENTS
    ];
// packages/ag-grid-community/src/publicEventHandlersMap.ts
var $437b23f6a393c3bf$export$85716710781d6a6b = $437b23f6a393c3bf$export$e9c8ffb796317123.reduce((mem, ev)=>{
    mem[ev] = $437b23f6a393c3bf$export$2badf35af69344c1(ev);
    return mem;
}, {});
// packages/ag-grid-community/src/sort/sortIndicatorComp.ts
var $437b23f6a393c3bf$var$makeIconParams = (dataRefSuffix, classSuffix)=>({
        tag: "span",
        ref: `eSort${dataRefSuffix}`,
        cls: `ag-sort-indicator-icon ag-sort-${classSuffix} ag-hidden`,
        attrs: {
            "aria-hidden": "true"
        }
    });
var $437b23f6a393c3bf$var$SortIndicatorElement = {
    tag: "span",
    cls: "ag-sort-indicator-container",
    children: [
        $437b23f6a393c3bf$var$makeIconParams("Order", "order"),
        $437b23f6a393c3bf$var$makeIconParams("Asc", "ascending-icon"),
        $437b23f6a393c3bf$var$makeIconParams("Desc", "descending-icon"),
        $437b23f6a393c3bf$var$makeIconParams("Mixed", "mixed-icon"),
        $437b23f6a393c3bf$var$makeIconParams("None", "none-icon")
    ]
};
var $437b23f6a393c3bf$var$SortIndicatorComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(skipTemplate){
        super();
        // Elements might by undefined when the user provides a custom template
        this.eSortOrder = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortAsc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortDesc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortMixed = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortNone = $437b23f6a393c3bf$export$6c811454646ed8be;
        if (!skipTemplate) this.setTemplate($437b23f6a393c3bf$var$SortIndicatorElement);
    }
    attachCustomElements(eSortOrder, eSortAsc, eSortDesc, eSortMixed, eSortNone) {
        this.eSortOrder = eSortOrder;
        this.eSortAsc = eSortAsc;
        this.eSortDesc = eSortDesc;
        this.eSortMixed = eSortMixed;
        this.eSortNone = eSortNone;
    }
    setupSort(column, suppressOrder = false) {
        this.column = column;
        this.suppressOrder = suppressOrder;
        this.setupMultiSortIndicator();
        if (!column.isSortable() && !column.getColDef().showRowGroup) return;
        this.addInIcon("sortAscending", this.eSortAsc, column);
        this.addInIcon("sortDescending", this.eSortDesc, column);
        this.addInIcon("sortUnSort", this.eSortNone, column);
        const updateIcons = this.updateIcons.bind(this);
        const sortUpdated = this.onSortChanged.bind(this);
        this.addManagedPropertyListener("unSortIcon", updateIcons);
        this.addManagedEventListeners({
            newColumnsLoaded: updateIcons,
            // Watch global events, as row group columns can effect their display column.
            sortChanged: sortUpdated,
            // when grouping changes so can sort indexes and icons
            columnRowGroupChanged: sortUpdated
        });
        this.onSortChanged();
    }
    addInIcon(iconName, eParent, column) {
        if (eParent == null) return;
        const eIcon = $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, this.beans, column);
        if (eIcon) eParent.appendChild(eIcon);
    }
    onSortChanged() {
        this.updateIcons();
        if (!this.suppressOrder) this.updateSortOrder();
    }
    updateIcons() {
        const { eSortAsc: eSortAsc, eSortDesc: eSortDesc, eSortNone: eSortNone, column: column, gos: gos, beans: beans } = this;
        const sortDirection = beans.sortSvc.getDisplaySortForColumn(column);
        if (eSortAsc) {
            const isAscending = sortDirection === "asc";
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortAsc, isAscending, {
                skipAriaHidden: true
            });
        }
        if (eSortDesc) {
            const isDescending = sortDirection === "desc";
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortDesc, isDescending, {
                skipAriaHidden: true
            });
        }
        if (eSortNone) {
            const alwaysHideNoSort = !column.getColDef().unSortIcon && !gos.get("unSortIcon");
            const isNone = sortDirection === null || sortDirection === void 0;
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortNone, !alwaysHideNoSort && isNone, {
                skipAriaHidden: true
            });
        }
    }
    setupMultiSortIndicator() {
        const { eSortMixed: eSortMixed, column: column, gos: gos } = this;
        this.addInIcon("sortUnSort", eSortMixed, column);
        const isColumnShowingRowGroup = column.getColDef().showRowGroup;
        const areGroupsCoupled = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
        if (areGroupsCoupled && isColumnShowingRowGroup) {
            this.addManagedEventListeners({
                // Watch global events, as row group columns can effect their display column.
                sortChanged: this.updateMultiSortIndicator.bind(this),
                // when grouping changes so can sort indexes and icons
                columnRowGroupChanged: this.updateMultiSortIndicator.bind(this)
            });
            this.updateMultiSortIndicator();
        }
    }
    updateMultiSortIndicator() {
        const { eSortMixed: eSortMixed, beans: beans, column: column } = this;
        if (eSortMixed) {
            const isMixedSort = beans.sortSvc.getDisplaySortForColumn(column) === "mixed";
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortMixed, isMixedSort, {
                skipAriaHidden: true
            });
        }
    }
    // we listen here for global sort events, NOT column sort events, as we want to do this
    // when sorting has been set on all column (if we listened just for our col (where we
    // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.
    updateSortOrder() {
        const { eSortOrder: eSortOrder, column: column, beans: { sortSvc: sortSvc } } = this;
        if (!eSortOrder) return;
        const allColumnsWithSorting = sortSvc.getColumnsWithSortingOrdered();
        const indexThisCol = sortSvc.getDisplaySortIndexForColumn(column) ?? -1;
        const moreThanOneColSorting = allColumnsWithSorting.some((col)=>sortSvc.getDisplaySortIndexForColumn(col) ?? false);
        const showIndex = indexThisCol >= 0 && moreThanOneColSorting;
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortOrder, showIndex, {
            skipAriaHidden: true
        });
        if (indexThisCol >= 0) eSortOrder.textContent = (indexThisCol + 1).toString();
        else $437b23f6a393c3bf$export$69e6e10709eabd91(eSortOrder);
    }
};
var $437b23f6a393c3bf$var$SortIndicatorSelector = {
    selector: "AG-SORT-INDICATOR",
    component: $437b23f6a393c3bf$var$SortIndicatorComp
};
// packages/ag-grid-community/src/sort/sortService.ts
var $437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER = [
    "asc",
    "desc",
    null
];
var $437b23f6a393c3bf$var$SortService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "sortSvc";
    }
    progressSort(column, multiSort, source) {
        const nextDirection = this.getNextSortDirection(column);
        this.setSortForColumn(column, nextDirection, multiSort, source);
    }
    progressSortFromEvent(column, event) {
        const sortUsingCtrl = this.gos.get("multiSortKey") === "ctrl";
        const multiSort = sortUsingCtrl ? event.ctrlKey || event.metaKey : event.shiftKey;
        this.progressSort(column, multiSort, "uiColumnSorted");
    }
    setSortForColumn(column, sort, multiSort, source) {
        if (sort !== "asc" && sort !== "desc") sort = null;
        const { gos: gos, showRowGroupCols: showRowGroupCols } = this.beans;
        const isColumnsSortingCoupledToGroup = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
        let columnsToUpdate = [
            column
        ];
        if (isColumnsSortingCoupledToGroup) {
            if (column.getColDef().showRowGroup) {
                const rowGroupColumns = showRowGroupCols?.getSourceColumnsForGroupColumn?.(column);
                const sortableRowGroupColumns = rowGroupColumns?.filter((col)=>col.isSortable());
                if (sortableRowGroupColumns) columnsToUpdate = [
                    column,
                    ...sortableRowGroupColumns
                ];
            }
        }
        columnsToUpdate.forEach((col)=>this.setColSort(col, sort, source));
        const doingMultiSort = (multiSort || gos.get("alwaysMultiSort")) && !gos.get("suppressMultiSort");
        const updatedColumns = [];
        if (!doingMultiSort) {
            const clearedColumns = this.clearSortBarTheseColumns(columnsToUpdate, source);
            updatedColumns.push(...clearedColumns);
        }
        this.updateSortIndex(column);
        updatedColumns.push(...columnsToUpdate);
        this.dispatchSortChangedEvents(source, updatedColumns);
    }
    updateSortIndex(lastColToChange) {
        const { gos: gos, colModel: colModel, showRowGroupCols: showRowGroupCols } = this.beans;
        const isCoupled = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
        const groupParent = showRowGroupCols?.getShowRowGroupCol(lastColToChange.getId());
        const lastSortIndexCol = isCoupled ? groupParent || lastColToChange : lastColToChange;
        const allSortedCols = this.getColumnsWithSortingOrdered();
        colModel.forAllCols((col)=>this.setColSortIndex(col, null));
        const allSortedColsWithoutChangesOrGroups = allSortedCols.filter((col)=>{
            if (isCoupled && col.getColDef().showRowGroup) return false;
            return col !== lastSortIndexCol;
        });
        const sortedColsWithIndices = lastSortIndexCol.getSort() ? [
            ...allSortedColsWithoutChangesOrGroups,
            lastSortIndexCol
        ] : allSortedColsWithoutChangesOrGroups;
        sortedColsWithIndices.forEach((col, idx)=>this.setColSortIndex(col, idx));
    }
    // gets called by API, so if data changes, use can call this, which will end up
    // working out the sort order again of the rows.
    onSortChanged(source, columns) {
        this.dispatchSortChangedEvents(source, columns);
    }
    isSortActive() {
        let isSorting = false;
        this.beans.colModel.forAllCols((col)=>{
            if (col.getSort()) isSorting = true;
        });
        return isSorting;
    }
    dispatchSortChangedEvents(source, columns) {
        const event = {
            type: "sortChanged",
            source: source
        };
        if (columns) event.columns = columns;
        this.eventSvc.dispatchEvent(event);
    }
    clearSortBarTheseColumns(columnsToSkip, source) {
        const clearedColumns = [];
        this.beans.colModel.forAllCols((columnToClear)=>{
            if (!columnsToSkip.includes(columnToClear)) {
                if (columnToClear.getSort()) clearedColumns.push(columnToClear);
                this.setColSort(columnToClear, void 0, source);
            }
        });
        return clearedColumns;
    }
    getNextSortDirection(column) {
        const sortingOrder = column.getColDef().sortingOrder ?? this.gos.get("sortingOrder") ?? $437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER;
        const currentIndex = sortingOrder.indexOf(column.getSort());
        const notInArray = currentIndex < 0;
        const lastItemInArray = currentIndex == sortingOrder.length - 1;
        return notInArray || lastItemInArray ? sortingOrder[0] : sortingOrder[currentIndex + 1];
    }
    /**
   * @returns a map of sort indexes for every sorted column, if groups sort primaries then they will have equivalent indices
   */ getIndexedSortMap() {
        const { gos: gos, colModel: colModel, showRowGroupCols: showRowGroupCols, rowGroupColsSvc: rowGroupColsSvc } = this.beans;
        let allSortedCols = [];
        colModel.forAllCols((col)=>{
            if (col.getSort()) allSortedCols.push(col);
        });
        if (colModel.isPivotMode()) {
            const isSortingLinked = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
            allSortedCols = allSortedCols.filter((col)=>{
                const isAggregated = !!col.getAggFunc();
                const isSecondary = !col.isPrimary();
                const isGroup = isSortingLinked ? showRowGroupCols?.getShowRowGroupCol(col.getId()) : col.getColDef().showRowGroup;
                return isAggregated || isSecondary || isGroup;
            });
        }
        const sortedRowGroupCols = rowGroupColsSvc?.columns.filter((col)=>!!col.getSort()) ?? [];
        const allColsIndexes = {};
        allSortedCols.forEach((col, index)=>allColsIndexes[col.getId()] = index);
        allSortedCols.sort((a, b)=>{
            const iA = a.getSortIndex();
            const iB = b.getSortIndex();
            if (iA != null && iB != null) return iA - iB;
            else if (iA == null && iB == null) {
                const posA = allColsIndexes[a.getId()];
                const posB = allColsIndexes[b.getId()];
                return posA > posB ? 1 : -1;
            } else if (iB == null) return -1;
            else return 1;
        });
        const isSortLinked = $437b23f6a393c3bf$export$96c51c2547b81aed(gos) && !!sortedRowGroupCols.length;
        if (isSortLinked) allSortedCols = [
            ...new Set(// if linked sorting, replace all columns with the display group column for index purposes, and ensure uniqueness
            allSortedCols.map((col)=>showRowGroupCols?.getShowRowGroupCol(col.getId()) ?? col))
        ];
        const indexMap = /* @__PURE__ */ new Map();
        allSortedCols.forEach((col, idx)=>indexMap.set(col, idx));
        if (isSortLinked) sortedRowGroupCols.forEach((col)=>{
            const groupDisplayCol = showRowGroupCols.getShowRowGroupCol(col.getId());
            indexMap.set(col, indexMap.get(groupDisplayCol));
        });
        return indexMap;
    }
    getColumnsWithSortingOrdered() {
        return [
            ...this.getIndexedSortMap().entries()
        ].sort(([, idx1], [, idx2])=>idx1 - idx2).map(([col])=>col);
    }
    // used by server side row models, to sent sort to server
    getSortModel() {
        return this.getColumnsWithSortingOrdered().filter((column)=>column.getSort()).map((column)=>({
                sort: column.getSort(),
                colId: column.getId()
            }));
    }
    getSortOptions() {
        return this.getColumnsWithSortingOrdered().filter((column)=>column.getSort()).map((column)=>({
                sort: column.getSort(),
                column: column
            }));
    }
    canColumnDisplayMixedSort(column) {
        const isColumnSortCouplingActive = $437b23f6a393c3bf$export$96c51c2547b81aed(this.gos);
        const isGroupDisplayColumn = !!column.getColDef().showRowGroup;
        return isColumnSortCouplingActive && isGroupDisplayColumn;
    }
    getDisplaySortForColumn(column) {
        const linkedColumns = this.beans.showRowGroupCols?.getSourceColumnsForGroupColumn(column);
        if (!this.canColumnDisplayMixedSort(column) || !linkedColumns?.length) return column.getSort();
        const columnHasUniqueData = column.getColDef().field != null || !!column.getColDef().valueGetter;
        const sortableColumns = columnHasUniqueData ? [
            column,
            ...linkedColumns
        ] : linkedColumns;
        const firstSort = sortableColumns[0].getSort();
        const allMatch = sortableColumns.every((col)=>col.getSort() == firstSort);
        if (!allMatch) return "mixed";
        return firstSort;
    }
    getDisplaySortIndexForColumn(column) {
        return this.getIndexedSortMap().get(column);
    }
    setupHeader(comp, column, clickElement) {
        let lastMovingChanged = 0;
        comp.addManagedListeners(column, {
            movingChanged: ()=>{
                lastMovingChanged = Date.now();
            }
        });
        if (clickElement) comp.addManagedElementListeners(clickElement, {
            click: (event)=>{
                const moving = column.isMoving();
                const nowTime = Date.now();
                const movedRecently = nowTime - lastMovingChanged < 50;
                const columnMoving = moving || movedRecently;
                if (!columnMoving) this.progressSortFromEvent(column, event);
            }
        });
        const onSortingChanged = ()=>{
            const sort = column.getSort();
            comp.toggleCss("ag-header-cell-sorted-asc", sort === "asc");
            comp.toggleCss("ag-header-cell-sorted-desc", sort === "desc");
            comp.toggleCss("ag-header-cell-sorted-none", !sort);
            if (column.getColDef().showRowGroup) {
                const sourceColumns = this.beans.showRowGroupCols?.getSourceColumnsForGroupColumn(column);
                const sortDirectionsMatch = sourceColumns?.every((sourceCol)=>column.getSort() == sourceCol.getSort());
                const isMultiSorting = !sortDirectionsMatch;
                comp.toggleCss("ag-header-cell-sorted-mixed", isMultiSorting);
            }
        };
        comp.addManagedEventListeners({
            sortChanged: onSortingChanged,
            columnRowGroupChanged: onSortingChanged
        });
    }
    initCol(column) {
        const { sort: sort, initialSort: initialSort, sortIndex: sortIndex, initialSortIndex: initialSortIndex } = column.colDef;
        if (sort !== void 0) {
            if (sort === "asc" || sort === "desc") column.sort = sort;
        } else if (initialSort === "asc" || initialSort === "desc") column.sort = initialSort;
        if (sortIndex !== void 0) {
            if (sortIndex !== null) column.sortIndex = sortIndex;
        } else if (initialSortIndex !== null) column.sortIndex = initialSortIndex;
    }
    updateColSort(column, sort, source) {
        if (sort !== void 0) {
            if (sort === "desc" || sort === "asc") this.setColSort(column, sort, source);
            else this.setColSort(column, void 0, source);
        }
    }
    setColSort(column, sort, source) {
        if (column.sort !== sort) {
            column.sort = sort;
            column.dispatchColEvent("sortChanged", source);
        }
        column.dispatchStateUpdatedEvent("sort");
    }
    setColSortIndex(column, sortOrder) {
        column.sortIndex = sortOrder;
        column.dispatchStateUpdatedEvent("sortIndex");
    }
    createSortIndicator(skipTemplate) {
        return new $437b23f6a393c3bf$var$SortIndicatorComp(skipTemplate);
    }
    getSortIndicatorSelector() {
        return $437b23f6a393c3bf$var$SortIndicatorSelector;
    }
};
// packages/ag-grid-community/src/validation/rules/userCompValidations.ts
var $437b23f6a393c3bf$var$USER_COMP_MODULES = {
    agSetColumnFilter: "SetFilter",
    agSetColumnFloatingFilter: "SetFilter",
    agMultiColumnFilter: "MultiFilter",
    agMultiColumnFloatingFilter: "MultiFilter",
    agGroupColumnFilter: "GroupFilter",
    agGroupColumnFloatingFilter: "GroupFilter",
    agGroupCellRenderer: "GroupCellRenderer",
    agGroupRowRenderer: "GroupCellRenderer",
    agRichSelect: "RichSelect",
    agRichSelectCellEditor: "RichSelect",
    agDetailCellRenderer: "SharedMasterDetail",
    agSparklineCellRenderer: "Sparklines",
    agDragAndDropImage: "SharedDragAndDrop",
    agColumnHeader: "ColumnHeaderComp",
    agColumnGroupHeader: "ColumnGroupHeaderComp",
    agSortIndicator: "Sort",
    agAnimateShowChangeCellRenderer: "HighlightChanges",
    agAnimateSlideCellRenderer: "HighlightChanges",
    agLoadingCellRenderer: "LoadingCellRenderer",
    agSkeletonCellRenderer: "SkeletonCellRenderer",
    agCheckboxCellRenderer: "CheckboxCellRenderer",
    agLoadingOverlay: "Overlay",
    agNoRowsOverlay: "Overlay",
    agTooltipComponent: "Tooltip",
    agReadOnlyFloatingFilter: "CustomFilter",
    agTextColumnFilter: "TextFilter",
    agNumberColumnFilter: "NumberFilter",
    agDateColumnFilter: "DateFilter",
    agDateInput: "DateFilter",
    agTextColumnFloatingFilter: "TextFilter",
    agNumberColumnFloatingFilter: "NumberFilter",
    agDateColumnFloatingFilter: "DateFilter",
    agCellEditor: "TextEditor",
    agSelectCellEditor: "SelectEditor",
    agTextCellEditor: "TextEditor",
    agNumberCellEditor: "NumberEditor",
    agDateCellEditor: "DateEditor",
    agDateStringCellEditor: "DateEditor",
    agCheckboxCellEditor: "CheckboxEditor",
    agLargeTextCellEditor: "LargeTextEditor",
    agMenuItem: "MenuItem",
    agColumnsToolPanel: "ColumnsToolPanel",
    agFiltersToolPanel: "FiltersToolPanel",
    agNewFiltersToolPanel: "NewFiltersToolPanel",
    agAggregationComponent: "StatusBar",
    agSelectedRowCountComponent: "StatusBar",
    agTotalRowCountComponent: "StatusBar",
    agFilteredRowCountComponent: "StatusBar",
    agTotalAndFilteredRowCountComponent: "StatusBar",
    agFindCellRenderer: "Find"
};
// packages/ag-grid-community/src/validation/rules/colDefValidations.ts
var $437b23f6a393c3bf$var$COLUMN_DEFINITION_DEPRECATIONS = ()=>({
        checkboxSelection: {
            version: "32.2",
            message: "Use `rowSelection.checkboxes` in `GridOptions` instead."
        },
        headerCheckboxSelection: {
            version: "32.2",
            message: "Use `rowSelection.headerCheckbox = true` in `GridOptions` instead."
        },
        headerCheckboxSelectionFilteredOnly: {
            version: "32.2",
            message: 'Use `rowSelection.selectAll = "filtered"` in `GridOptions` instead.'
        },
        headerCheckboxSelectionCurrentPageOnly: {
            version: "32.2",
            message: 'Use `rowSelection.selectAll = "currentPage"` in `GridOptions` instead.'
        },
        showDisabledCheckboxes: {
            version: "32.2",
            message: "Use `rowSelection.hideDisabledCheckboxes = true` in `GridOptions` instead."
        }
    });
var $437b23f6a393c3bf$var$COLUMN_DEFINITION_MOD_VALIDATIONS = {
    aggFunc: "SharedAggregation",
    autoHeight: "RowAutoHeight",
    cellClass: "CellStyle",
    cellClassRules: "CellStyle",
    cellEditor: ({ cellEditor: cellEditor, editable: editable })=>{
        if (!editable) return null;
        if (typeof cellEditor === "string") return $437b23f6a393c3bf$var$USER_COMP_MODULES[cellEditor] ?? "CustomEditor";
        return "CustomEditor";
    },
    cellRenderer: ({ cellRenderer: cellRenderer })=>{
        if (typeof cellRenderer !== "string") return null;
        return $437b23f6a393c3bf$var$USER_COMP_MODULES[cellRenderer];
    },
    cellStyle: "CellStyle",
    columnChooserParams: "ColumnMenu",
    contextMenuItems: "ContextMenu",
    dndSource: "DragAndDrop",
    dndSourceOnRowDrag: "DragAndDrop",
    editable: ({ editable: editable, cellEditor: cellEditor })=>{
        if (editable && !cellEditor) return "TextEditor";
        return null;
    },
    enableCellChangeFlash: "HighlightChanges",
    enablePivot: "SharedPivot",
    enableRowGroup: "SharedRowGrouping",
    enableValue: "SharedAggregation",
    filter: ({ filter: filter })=>{
        if (filter && typeof filter !== "string" && typeof filter !== "boolean") return "CustomFilter";
        if (typeof filter === "string") return $437b23f6a393c3bf$var$USER_COMP_MODULES[filter] ?? "ColumnFilter";
        return "ColumnFilter";
    },
    floatingFilter: "ColumnFilter",
    getQuickFilterText: "QuickFilter",
    headerTooltip: "Tooltip",
    mainMenuItems: "ColumnMenu",
    menuTabs: (options)=>{
        const enterpriseMenuTabs = [
            "columnsMenuTab",
            "generalMenuTab"
        ];
        if (options.menuTabs?.some((tab)=>enterpriseMenuTabs.includes(tab))) return "ColumnMenu";
        return null;
    },
    pivot: "SharedPivot",
    pivotIndex: "SharedPivot",
    rowDrag: "RowDrag",
    rowGroup: "SharedRowGrouping",
    rowGroupIndex: "SharedRowGrouping",
    tooltipField: "Tooltip",
    tooltipValueGetter: "Tooltip",
    spanRows: "CellSpan"
};
var $437b23f6a393c3bf$var$COLUMN_DEFINITION_VALIDATIONS = ()=>{
    const validations = {
        autoHeight: {
            supportedRowModels: [
                "clientSide",
                "serverSide"
            ],
            validate: (_colDef, { paginationAutoPageSize: paginationAutoPageSize })=>{
                if (paginationAutoPageSize) return "colDef.autoHeight is not supported with paginationAutoPageSize.";
                return null;
            }
        },
        cellRendererParams: {
            validate: (colDef)=>{
                const groupColumn = colDef.rowGroup != null || colDef.rowGroupIndex != null || colDef.cellRenderer === "agGroupCellRenderer";
                if (groupColumn && "checkbox" in colDef.cellRendererParams) return 'Since v33.0, `cellRendererParams.checkbox` has been deprecated. Use `rowSelection.checkboxLocation = "autoGroupColumn"` instead.';
                return null;
            }
        },
        flex: {
            validate: (_options, gridOptions)=>{
                if (gridOptions.autoSizeStrategy) return "colDef.flex is not supported with gridOptions.autoSizeStrategy";
                return null;
            }
        },
        headerCheckboxSelection: {
            supportedRowModels: [
                "clientSide",
                "serverSide"
            ],
            validate: (_options, { rowSelection: rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelection is only supported with rowSelection=multiple"
        },
        headerCheckboxSelectionCurrentPageOnly: {
            supportedRowModels: [
                "clientSide"
            ],
            validate: (_options, { rowSelection: rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelectionCurrentPageOnly is only supported with rowSelection=multiple"
        },
        headerCheckboxSelectionFilteredOnly: {
            supportedRowModels: [
                "clientSide"
            ],
            validate: (_options, { rowSelection: rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelectionFilteredOnly is only supported with rowSelection=multiple"
        },
        headerValueGetter: {
            validate: (_options)=>{
                const headerValueGetter = _options.headerValueGetter;
                if (typeof headerValueGetter === "function" || typeof headerValueGetter === "string") return null;
                return "headerValueGetter must be a function or a valid string expression";
            }
        },
        icons: {
            validate: ({ icons: icons })=>{
                if (icons) {
                    if (icons["smallDown"]) return $437b23f6a393c3bf$export$680bb5102fca525e(262);
                    if (icons["smallLeft"]) return $437b23f6a393c3bf$export$680bb5102fca525e(263);
                    if (icons["smallRight"]) return $437b23f6a393c3bf$export$680bb5102fca525e(264);
                }
                return null;
            }
        },
        sortingOrder: {
            validate: (_options)=>{
                const sortingOrder = _options.sortingOrder;
                if (Array.isArray(sortingOrder) && sortingOrder.length > 0) {
                    const invalidItems = sortingOrder.filter((a)=>!$437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER.includes(a));
                    if (invalidItems.length > 0) return `sortingOrder must be an array with elements from [${$437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER.map($437b23f6a393c3bf$var$toStringWithNullUndefined).join()}], currently it includes [${invalidItems.map($437b23f6a393c3bf$var$toStringWithNullUndefined).join()}]`;
                } else if (!Array.isArray(sortingOrder) || sortingOrder.length <= 0) return `sortingOrder must be an array with at least one element, currently it's ${sortingOrder}`;
                return null;
            }
        },
        type: {
            validate: (_options)=>{
                const type = _options.type;
                if (type instanceof Array) {
                    const invalidArray = type.some((a)=>typeof a !== "string");
                    if (invalidArray) return "if colDef.type is supplied an array it should be of type 'string[]'";
                    return null;
                }
                if (typeof type === "string") return null;
                return "colDef.type should be of type 'string' | 'string[]'";
            }
        },
        rowSpan: {
            validate: (_options, { suppressRowTransform: suppressRowTransform })=>{
                if (!suppressRowTransform) return "colDef.rowSpan requires suppressRowTransform to be enabled.";
                return null;
            }
        },
        spanRows: {
            dependencies: {
                editable: {
                    required: [
                        false,
                        void 0
                    ]
                },
                rowDrag: {
                    required: [
                        false,
                        void 0
                    ]
                },
                colSpan: {
                    required: [
                        void 0
                    ]
                },
                rowSpan: {
                    required: [
                        void 0
                    ]
                }
            },
            validate: (_options, { rowSelection: rowSelection, cellSelection: cellSelection, suppressRowTransform: suppressRowTransform, enableCellSpan: enableCellSpan, rowDragEntireRow: rowDragEntireRow, enableCellTextSelection: enableCellTextSelection })=>{
                if (typeof rowSelection === "object") {
                    if (rowSelection?.mode === "singleRow" && rowSelection?.enableClickSelection) return "colDef.spanRows is not supported with rowSelection.clickSelection";
                }
                if (cellSelection) return "colDef.spanRows is not supported with cellSelection.";
                if (suppressRowTransform) return "colDef.spanRows is not supported with suppressRowTransform.";
                if (!enableCellSpan) return "colDef.spanRows requires enableCellSpan to be enabled.";
                if (rowDragEntireRow) return "colDef.spanRows is not supported with rowDragEntireRow.";
                if (enableCellTextSelection) return "colDef.spanRows is not supported with enableCellTextSelection.";
                return null;
            }
        }
    };
    return validations;
};
var $437b23f6a393c3bf$var$colDefPropertyMap = {
    headerName: void 0,
    columnGroupShow: void 0,
    headerStyle: void 0,
    headerClass: void 0,
    toolPanelClass: void 0,
    headerValueGetter: void 0,
    pivotKeys: void 0,
    groupId: void 0,
    colId: void 0,
    sort: void 0,
    initialSort: void 0,
    field: void 0,
    type: void 0,
    cellDataType: void 0,
    tooltipComponent: void 0,
    tooltipField: void 0,
    headerTooltip: void 0,
    cellClass: void 0,
    showRowGroup: void 0,
    filter: void 0,
    initialAggFunc: void 0,
    defaultAggFunc: void 0,
    aggFunc: void 0,
    pinned: void 0,
    initialPinned: void 0,
    chartDataType: void 0,
    cellAriaRole: void 0,
    cellEditorPopupPosition: void 0,
    headerGroupComponent: void 0,
    headerGroupComponentParams: void 0,
    cellStyle: void 0,
    cellRenderer: void 0,
    cellRendererParams: void 0,
    cellEditor: void 0,
    cellEditorParams: void 0,
    filterParams: void 0,
    pivotValueColumn: void 0,
    headerComponent: void 0,
    headerComponentParams: void 0,
    floatingFilterComponent: void 0,
    floatingFilterComponentParams: void 0,
    tooltipComponentParams: void 0,
    refData: void 0,
    columnChooserParams: void 0,
    children: void 0,
    sortingOrder: void 0,
    allowedAggFuncs: void 0,
    menuTabs: void 0,
    pivotTotalColumnIds: void 0,
    cellClassRules: void 0,
    icons: void 0,
    sortIndex: void 0,
    initialSortIndex: void 0,
    flex: void 0,
    initialFlex: void 0,
    width: void 0,
    initialWidth: void 0,
    minWidth: void 0,
    maxWidth: void 0,
    rowGroupIndex: void 0,
    initialRowGroupIndex: void 0,
    pivotIndex: void 0,
    initialPivotIndex: void 0,
    suppressColumnsToolPanel: void 0,
    suppressFiltersToolPanel: void 0,
    openByDefault: void 0,
    marryChildren: void 0,
    suppressStickyLabel: void 0,
    hide: void 0,
    initialHide: void 0,
    rowGroup: void 0,
    initialRowGroup: void 0,
    pivot: void 0,
    initialPivot: void 0,
    checkboxSelection: void 0,
    showDisabledCheckboxes: void 0,
    headerCheckboxSelection: void 0,
    headerCheckboxSelectionFilteredOnly: void 0,
    headerCheckboxSelectionCurrentPageOnly: void 0,
    suppressHeaderMenuButton: void 0,
    suppressMovable: void 0,
    lockPosition: void 0,
    lockVisible: void 0,
    lockPinned: void 0,
    unSortIcon: void 0,
    suppressSizeToFit: void 0,
    suppressAutoSize: void 0,
    enableRowGroup: void 0,
    enablePivot: void 0,
    enableValue: void 0,
    editable: void 0,
    suppressPaste: void 0,
    suppressNavigable: void 0,
    enableCellChangeFlash: void 0,
    rowDrag: void 0,
    dndSource: void 0,
    autoHeight: void 0,
    wrapText: void 0,
    sortable: void 0,
    resizable: void 0,
    singleClickEdit: void 0,
    floatingFilter: void 0,
    cellEditorPopup: void 0,
    suppressFillHandle: void 0,
    wrapHeaderText: void 0,
    autoHeaderHeight: void 0,
    dndSourceOnRowDrag: void 0,
    valueGetter: void 0,
    valueSetter: void 0,
    filterValueGetter: void 0,
    keyCreator: void 0,
    valueFormatter: void 0,
    valueParser: void 0,
    comparator: void 0,
    equals: void 0,
    pivotComparator: void 0,
    suppressKeyboardEvent: void 0,
    suppressHeaderKeyboardEvent: void 0,
    colSpan: void 0,
    rowSpan: void 0,
    spanRows: void 0,
    getQuickFilterText: void 0,
    onCellValueChanged: void 0,
    onCellClicked: void 0,
    onCellDoubleClicked: void 0,
    onCellContextMenu: void 0,
    rowDragText: void 0,
    tooltipValueGetter: void 0,
    cellRendererSelector: void 0,
    cellEditorSelector: void 0,
    suppressSpanHeaderHeight: void 0,
    useValueFormatterForExport: void 0,
    useValueParserForImport: void 0,
    mainMenuItems: void 0,
    contextMenuItems: void 0,
    suppressFloatingFilterButton: void 0,
    suppressHeaderFilterButton: void 0,
    suppressHeaderContextMenu: void 0,
    loadingCellRenderer: void 0,
    loadingCellRendererParams: void 0,
    loadingCellRendererSelector: void 0,
    context: void 0,
    dateComponent: void 0,
    dateComponentParams: void 0,
    getFindText: void 0
};
var $437b23f6a393c3bf$var$ALL_PROPERTIES = ()=>Object.keys($437b23f6a393c3bf$var$colDefPropertyMap);
var $437b23f6a393c3bf$var$COL_DEF_VALIDATORS = ()=>({
        objectName: "colDef",
        allProperties: $437b23f6a393c3bf$var$ALL_PROPERTIES(),
        docsUrl: "column-properties/",
        deprecations: $437b23f6a393c3bf$var$COLUMN_DEFINITION_DEPRECATIONS(),
        validations: $437b23f6a393c3bf$var$COLUMN_DEFINITION_VALIDATIONS()
    });
// packages/ag-grid-community/src/propertyKeys.ts
var $437b23f6a393c3bf$var$STRING_GRID_OPTIONS = [
    "overlayLoadingTemplate",
    "overlayNoRowsTemplate",
    "gridId",
    "quickFilterText",
    "rowModelType",
    "editType",
    "domLayout",
    "clipboardDelimiter",
    "rowGroupPanelShow",
    "multiSortKey",
    "pivotColumnGroupTotals",
    "pivotRowTotals",
    "pivotPanelShow",
    "fillHandleDirection",
    "groupDisplayType",
    "treeDataDisplayType",
    "treeDataChildrenField",
    "treeDataParentIdField",
    "colResizeDefault",
    "tooltipTrigger",
    "serverSidePivotResultFieldSeparator",
    "columnMenu",
    "tooltipShowMode",
    "invalidEditValueMode",
    "grandTotalRow",
    "themeCssLayer",
    "findSearchValue",
    "styleNonce",
    "renderingMode"
];
var $437b23f6a393c3bf$var$OBJECT_GRID_OPTIONS = [
    "components",
    "rowStyle",
    "context",
    "autoGroupColumnDef",
    "localeText",
    "icons",
    "datasource",
    "dragAndDropImageComponentParams",
    "serverSideDatasource",
    "viewportDatasource",
    "groupRowRendererParams",
    "aggFuncs",
    "fullWidthCellRendererParams",
    "defaultColGroupDef",
    "defaultColDef",
    "defaultCsvExportParams",
    "defaultExcelExportParams",
    "columnTypes",
    "rowClassRules",
    "detailCellRendererParams",
    "loadingCellRendererParams",
    "loadingOverlayComponentParams",
    "noRowsOverlayComponentParams",
    "popupParent",
    "themeStyleContainer",
    "statusBar",
    "chartThemeOverrides",
    "customChartThemes",
    "chartToolPanelsDef",
    "dataTypeDefinitions",
    "advancedFilterParent",
    "advancedFilterBuilderParams",
    "advancedFilterParams",
    "initialState",
    "autoSizeStrategy",
    "selectionColumnDef",
    "findOptions",
    "filterHandlers"
];
var $437b23f6a393c3bf$var$ARRAY_GRID_OPTIONS = [
    "sortingOrder",
    "alignedGrids",
    "rowData",
    "columnDefs",
    "excelStyles",
    "pinnedTopRowData",
    "pinnedBottomRowData",
    "chartThemes",
    "rowClass",
    "paginationPageSizeSelector"
];
var $437b23f6a393c3bf$var$_NUMBER_GRID_OPTIONS = [
    "rowHeight",
    "detailRowHeight",
    "rowBuffer",
    "headerHeight",
    "groupHeaderHeight",
    "groupLockGroupColumns",
    "floatingFiltersHeight",
    "pivotHeaderHeight",
    "pivotGroupHeaderHeight",
    "groupDefaultExpanded",
    "pivotDefaultExpanded",
    "viewportRowModelPageSize",
    "viewportRowModelBufferSize",
    "autoSizePadding",
    "maxBlocksInCache",
    "maxConcurrentDatasourceRequests",
    "tooltipShowDelay",
    "tooltipHideDelay",
    "cacheOverflowSize",
    "paginationPageSize",
    "cacheBlockSize",
    "infiniteInitialRowCount",
    "serverSideInitialRowCount",
    "scrollbarWidth",
    "asyncTransactionWaitMillis",
    "blockLoadDebounceMillis",
    "keepDetailRowsCount",
    "undoRedoCellEditingLimit",
    "cellFlashDuration",
    "cellFadeDuration",
    "tabIndex",
    "pivotMaxGeneratedColumns",
    "rowDragInsertDelay"
];
var $437b23f6a393c3bf$var$OTHER_GRID_OPTIONS = [
    "theme",
    "rowSelection"
];
var $437b23f6a393c3bf$export$fb22311288c545c2 = [
    "cellSelection",
    "sideBar",
    "rowNumbers",
    "suppressGroupChangesColumnVisibility",
    "groupAggFiltering",
    "suppressStickyTotalRow",
    "groupHideParentOfSingleChild",
    "enableRowPinning"
];
var $437b23f6a393c3bf$var$_BOOLEAN_GRID_OPTIONS = [
    "loadThemeGoogleFonts",
    "suppressMakeColumnVisibleAfterUnGroup",
    "suppressRowClickSelection",
    "suppressCellFocus",
    "suppressHeaderFocus",
    "suppressHorizontalScroll",
    "groupSelectsChildren",
    "alwaysShowHorizontalScroll",
    "alwaysShowVerticalScroll",
    "debug",
    "enableBrowserTooltips",
    "enableCellExpressions",
    "groupSuppressBlankHeader",
    "suppressMenuHide",
    "suppressRowDeselection",
    "unSortIcon",
    "suppressMultiSort",
    "alwaysMultiSort",
    "singleClickEdit",
    "suppressLoadingOverlay",
    "suppressNoRowsOverlay",
    "suppressAutoSize",
    "skipHeaderOnAutoSize",
    "suppressColumnMoveAnimation",
    "suppressMoveWhenColumnDragging",
    "suppressMovableColumns",
    "suppressFieldDotNotation",
    "enableRangeSelection",
    "enableRangeHandle",
    "enableFillHandle",
    "suppressClearOnFillReduction",
    "deltaSort",
    "suppressTouch",
    "allowContextMenuWithControlKey",
    "suppressContextMenu",
    "suppressDragLeaveHidesColumns",
    "suppressRowGroupHidesColumns",
    "suppressMiddleClickScrolls",
    "suppressPreventDefaultOnMouseWheel",
    "suppressCopyRowsToClipboard",
    "copyHeadersToClipboard",
    "copyGroupHeadersToClipboard",
    "pivotMode",
    "suppressAggFuncInHeader",
    "suppressColumnVirtualisation",
    "alwaysAggregateAtRootLevel",
    "suppressFocusAfterRefresh",
    "functionsReadOnly",
    "animateRows",
    "groupSelectsFiltered",
    "groupRemoveSingleChildren",
    "groupRemoveLowestSingleChildren",
    "enableRtl",
    "enableCellSpan",
    "suppressClickEdit",
    "rowDragEntireRow",
    "rowDragManaged",
    "suppressRowDrag",
    "suppressMoveWhenRowDragging",
    "rowDragMultiRow",
    "enableGroupEdit",
    "embedFullWidthRows",
    "suppressPaginationPanel",
    "groupHideOpenParents",
    "groupAllowUnbalanced",
    "pagination",
    "paginationAutoPageSize",
    "suppressScrollOnNewData",
    "suppressScrollWhenPopupsAreOpen",
    "purgeClosedRowNodes",
    "cacheQuickFilter",
    "includeHiddenColumnsInQuickFilter",
    "ensureDomOrder",
    "accentedSort",
    "suppressChangeDetection",
    "valueCache",
    "valueCacheNeverExpires",
    "aggregateOnlyChangedColumns",
    "suppressAnimationFrame",
    "suppressExcelExport",
    "suppressCsvExport",
    "includeHiddenColumnsInAdvancedFilter",
    "suppressMultiRangeSelection",
    "enterNavigatesVerticallyAfterEdit",
    "enterNavigatesVertically",
    "suppressPropertyNamesCheck",
    "rowMultiSelectWithClick",
    "suppressRowHoverHighlight",
    "suppressRowTransform",
    "suppressClipboardPaste",
    "suppressLastEmptyLineOnPaste",
    "enableCharts",
    "suppressMaintainUnsortedOrder",
    "enableCellTextSelection",
    "suppressBrowserResizeObserver",
    "suppressMaxRenderedRowRestriction",
    "excludeChildrenWhenTreeDataFiltering",
    "tooltipMouseTrack",
    "tooltipInteraction",
    "keepDetailRows",
    "paginateChildRows",
    "preventDefaultOnContextMenu",
    "undoRedoCellEditing",
    "allowDragFromColumnsToolPanel",
    "pivotSuppressAutoColumn",
    "suppressExpandablePivotGroups",
    "debounceVerticalScrollbar",
    "detailRowAutoHeight",
    "serverSideSortAllLevels",
    "serverSideEnableClientSideSort",
    "serverSideOnlyRefreshFilteredGroups",
    "suppressAggFilteredOnly",
    "showOpenedGroup",
    "suppressClipboardApi",
    "suppressModelUpdateAfterUpdateTransaction",
    "stopEditingWhenCellsLoseFocus",
    "groupMaintainOrder",
    "columnHoverHighlight",
    "readOnlyEdit",
    "suppressRowVirtualisation",
    "enableCellEditingOnBackspace",
    "resetRowDataOnUpdate",
    "removePivotHeaderRowWhenSingleValueColumn",
    "suppressCopySingleCellRanges",
    "suppressGroupRowsSticky",
    "suppressCutToClipboard",
    "rowGroupPanelSuppressSort",
    "allowShowChangeAfterFilter",
    "enableAdvancedFilter",
    "masterDetail",
    "treeData",
    "reactiveCustomComponents",
    "applyQuickFilterBeforePivotOrAgg",
    "suppressServerSideFullWidthLoadingRow",
    "suppressAdvancedFilterEval",
    "loading",
    "maintainColumnOrder",
    "enableStrictPivotColumnOrder",
    "suppressSetFilterByDefault",
    "enableFilterHandlers",
    "suppressStartEditOnTab",
    "hidePaddedHeaderRows"
];
var $437b23f6a393c3bf$var$_FUNCTION_GRID_OPTIONS = [
    "doesExternalFilterPass",
    "processPivotResultColDef",
    "processPivotResultColGroupDef",
    "getBusinessKeyForNode",
    "isRowSelectable",
    "rowDragText",
    "groupRowRenderer",
    "dragAndDropImageComponent",
    "fullWidthCellRenderer",
    "loadingCellRenderer",
    "loadingOverlayComponent",
    "noRowsOverlayComponent",
    "detailCellRenderer",
    "quickFilterParser",
    "quickFilterMatcher",
    "getLocaleText",
    "isExternalFilterPresent",
    "getRowHeight",
    "getRowClass",
    "getRowStyle",
    "getFullRowEditValidationErrors",
    "getContextMenuItems",
    "getMainMenuItems",
    "processRowPostCreate",
    "processCellForClipboard",
    "getGroupRowAgg",
    "isFullWidthRow",
    "sendToClipboard",
    "focusGridInnerElement",
    "navigateToNextHeader",
    "tabToNextHeader",
    "navigateToNextCell",
    "tabToNextCell",
    "processCellFromClipboard",
    "getDocument",
    "postProcessPopup",
    "getChildCount",
    "getDataPath",
    "isRowMaster",
    "postSortRows",
    "processHeaderForClipboard",
    "processUnpinnedColumns",
    "processGroupHeaderForClipboard",
    "paginationNumberFormatter",
    "processDataFromClipboard",
    "getServerSideGroupKey",
    "isServerSideGroup",
    "createChartContainer",
    "getChartToolbarItems",
    "fillOperation",
    "isApplyServerSideTransaction",
    "getServerSideGroupLevelParams",
    "isServerSideGroupOpenByDefault",
    "isGroupOpenByDefault",
    "initialGroupOrderComparator",
    "loadingCellRendererSelector",
    "getRowId",
    "chartMenuItems",
    "groupTotalRow",
    "alwaysPassFilter",
    "isRowPinnable",
    "isRowPinned",
    "isRowValidDropPosition"
];
var $437b23f6a393c3bf$export$a827a39ae0574df3 = ()=>[
        ...$437b23f6a393c3bf$var$ARRAY_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$OBJECT_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$STRING_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$_NUMBER_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$_FUNCTION_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$_BOOLEAN_GRID_OPTIONS,
        ...$437b23f6a393c3bf$export$fb22311288c545c2,
        ...$437b23f6a393c3bf$var$OTHER_GRID_OPTIONS
    ];
// packages/ag-grid-community/src/validation/rules/gridOptionsValidations.ts
var $437b23f6a393c3bf$var$GRID_OPTION_DEPRECATIONS = ()=>({
        suppressLoadingOverlay: {
            version: "32",
            message: "Use `loading`=false instead."
        },
        enableFillHandle: {
            version: "32.2",
            message: "Use `cellSelection.handle` instead."
        },
        enableRangeHandle: {
            version: "32.2",
            message: "Use `cellSelection.handle` instead."
        },
        enableRangeSelection: {
            version: "32.2",
            message: "Use `cellSelection = true` instead."
        },
        suppressMultiRangeSelection: {
            version: "32.2",
            message: "Use `cellSelection.suppressMultiRanges` instead."
        },
        suppressClearOnFillReduction: {
            version: "32.2",
            message: "Use `cellSelection.handle.suppressClearOnFillReduction` instead."
        },
        fillHandleDirection: {
            version: "32.2",
            message: "Use `cellSelection.handle.direction` instead."
        },
        fillOperation: {
            version: "32.2",
            message: "Use `cellSelection.handle.setFillValue` instead."
        },
        suppressRowClickSelection: {
            version: "32.2",
            message: "Use `rowSelection.enableClickSelection` instead."
        },
        suppressRowDeselection: {
            version: "32.2",
            message: "Use `rowSelection.enableClickSelection` instead."
        },
        rowMultiSelectWithClick: {
            version: "32.2",
            message: "Use `rowSelection.enableSelectionWithoutKeys` instead."
        },
        groupSelectsChildren: {
            version: "32.2",
            message: 'Use `rowSelection.groupSelects = "descendants"` instead.'
        },
        groupSelectsFiltered: {
            version: "32.2",
            message: 'Use `rowSelection.groupSelects = "filteredDescendants"` instead.'
        },
        isRowSelectable: {
            version: "32.2",
            message: "Use `selectionOptions.isRowSelectable` instead."
        },
        suppressCopySingleCellRanges: {
            version: "32.2",
            message: "Use `rowSelection.copySelectedRows` instead."
        },
        suppressCopyRowsToClipboard: {
            version: "32.2",
            message: "Use `rowSelection.copySelectedRows` instead."
        },
        onRangeSelectionChanged: {
            version: "32.2",
            message: "Use `onCellSelectionChanged` instead."
        },
        onRangeDeleteStart: {
            version: "32.2",
            message: "Use `onCellSelectionDeleteStart` instead."
        },
        onRangeDeleteEnd: {
            version: "32.2",
            message: "Use `onCellSelectionDeleteEnd` instead."
        },
        suppressBrowserResizeObserver: {
            version: "32.2",
            message: "The grid always uses the browser's ResizeObserver, this grid option has no effect."
        },
        onColumnEverythingChanged: {
            version: "32.2",
            message: "Either use `onDisplayedColumnsChanged` which is fired at the same time, or use one of the more specific column events."
        },
        groupRemoveSingleChildren: {
            version: "33",
            message: "Use `groupHideParentOfSingleChild` instead."
        },
        groupRemoveLowestSingleChildren: {
            version: "33",
            message: 'Use `groupHideParentOfSingleChild: "leafGroupsOnly"` instead.'
        },
        suppressRowGroupHidesColumns: {
            version: "33",
            message: 'Use `suppressGroupChangesColumnVisibility: "suppressHideOnGroup"` instead.'
        },
        suppressMakeColumnVisibleAfterUnGroup: {
            version: "33",
            message: 'Use `suppressGroupChangesColumnVisibility: "suppressShowOnUngroup"` instead.'
        },
        unSortIcon: {
            version: "33",
            message: "Use `defaultColDef.unSortIcon` instead."
        },
        sortingOrder: {
            version: "33",
            message: "Use `defaultColDef.sortingOrder` instead."
        },
        suppressPropertyNamesCheck: {
            version: "33",
            message: "`gridOptions` and `columnDefs` both have a `context` property that should be used for arbitrary user data. This means that column definitions and gridOptions should only contain valid properties making this property redundant."
        },
        suppressAdvancedFilterEval: {
            version: "34",
            message: "Advanced filter no longer uses function evaluation, so this option has no effect."
        }
    });
function $437b23f6a393c3bf$var$toConstrainedNum(key, value, min) {
    if (typeof value === "number" || value == null) {
        if (value == null) return null;
        return value >= min ? null : `${key}: value should be greater than or equal to ${min}`;
    }
    return `${key}: value should be a number`;
}
var $437b23f6a393c3bf$var$GRID_OPTIONS_MODULES = {
    alignedGrids: "AlignedGrids",
    allowContextMenuWithControlKey: "ContextMenu",
    autoSizeStrategy: "ColumnAutoSize",
    cellSelection: "CellSelection",
    columnHoverHighlight: "ColumnHover",
    datasource: "InfiniteRowModel",
    doesExternalFilterPass: "ExternalFilter",
    editType: "EditCore",
    invalidEditValueMode: "EditCore",
    enableAdvancedFilter: "AdvancedFilter",
    enableCellSpan: "CellSpan",
    enableCharts: "IntegratedCharts",
    enableRangeSelection: "CellSelection",
    enableRowPinning: "PinnedRow",
    findSearchValue: "Find",
    getFullRowEditValidationErrors: "EditCore",
    getContextMenuItems: "ContextMenu",
    getLocaleText: "Locale",
    getMainMenuItems: "ColumnMenu",
    getRowClass: "RowStyle",
    getRowStyle: "RowStyle",
    groupTotalRow: "SharedRowGrouping",
    grandTotalRow: "SharedRowGrouping",
    initialState: "GridState",
    isExternalFilterPresent: "ExternalFilter",
    isRowPinnable: "PinnedRow",
    isRowPinned: "PinnedRow",
    localeText: "Locale",
    masterDetail: "SharedMasterDetail",
    pagination: "Pagination",
    pinnedBottomRowData: "PinnedRow",
    pinnedTopRowData: "PinnedRow",
    pivotMode: "SharedPivot",
    pivotPanelShow: "RowGroupingPanel",
    quickFilterText: "QuickFilter",
    rowClass: "RowStyle",
    rowClassRules: "RowStyle",
    rowData: "ClientSideRowModel",
    rowDragManaged: "RowDrag",
    rowGroupPanelShow: "RowGroupingPanel",
    rowNumbers: "RowNumbers",
    rowSelection: "SharedRowSelection",
    rowStyle: "RowStyle",
    serverSideDatasource: "ServerSideRowModel",
    sideBar: "SideBar",
    statusBar: "StatusBar",
    treeData: "SharedTreeData",
    undoRedoCellEditing: "UndoRedoEdit",
    valueCache: "ValueCache",
    viewportDatasource: "ViewportRowModel"
};
var $437b23f6a393c3bf$var$GRID_OPTION_VALIDATIONS = ()=>{
    const definedValidations = {
        autoSizePadding: {
            validate ({ autoSizePadding: autoSizePadding }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("autoSizePadding", autoSizePadding, 0);
            }
        },
        cacheBlockSize: {
            supportedRowModels: [
                "serverSide",
                "infinite"
            ],
            validate ({ cacheBlockSize: cacheBlockSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("cacheBlockSize", cacheBlockSize, 1);
            }
        },
        cacheOverflowSize: {
            validate ({ cacheOverflowSize: cacheOverflowSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("cacheOverflowSize", cacheOverflowSize, 1);
            }
        },
        datasource: {
            supportedRowModels: [
                "infinite"
            ]
        },
        domLayout: {
            validate: (options)=>{
                const domLayout = options.domLayout;
                const validLayouts = [
                    "autoHeight",
                    "normal",
                    "print"
                ];
                if (domLayout && !validLayouts.includes(domLayout)) return `domLayout must be one of [${validLayouts.join()}], currently it's ${domLayout}`;
                return null;
            }
        },
        enableFillHandle: {
            dependencies: {
                enableRangeSelection: {
                    required: [
                        true
                    ]
                }
            }
        },
        enableRangeHandle: {
            dependencies: {
                enableRangeSelection: {
                    required: [
                        true
                    ]
                }
            }
        },
        enableRangeSelection: {
            dependencies: {
                rowDragEntireRow: {
                    required: [
                        false,
                        void 0
                    ]
                }
            }
        },
        enableRowPinning: {
            supportedRowModels: [
                "clientSide"
            ],
            validate ({ enableRowPinning: enableRowPinning, pinnedTopRowData: pinnedTopRowData, pinnedBottomRowData: pinnedBottomRowData }) {
                if (enableRowPinning && (pinnedTopRowData || pinnedBottomRowData)) return "Manual row pinning cannot be used together with pinned row data. Either set `enableRowPinning` to `false`, or remove `pinnedTopRowData` and `pinnedBottomRowData`.";
                return null;
            }
        },
        isRowPinnable: {
            supportedRowModels: [
                "clientSide"
            ],
            validate ({ enableRowPinning: enableRowPinning, isRowPinnable: isRowPinnable, pinnedTopRowData: pinnedTopRowData, pinnedBottomRowData: pinnedBottomRowData }) {
                if (isRowPinnable && (pinnedTopRowData || pinnedBottomRowData)) return "Manual row pinning cannot be used together with pinned row data. Either remove `isRowPinnable`, or remove `pinnedTopRowData` and `pinnedBottomRowData`.";
                if (!enableRowPinning && isRowPinnable) return "`isRowPinnable` requires `enableRowPinning` to be set.";
                return null;
            }
        },
        isRowPinned: {
            supportedRowModels: [
                "clientSide"
            ],
            validate ({ enableRowPinning: enableRowPinning, isRowPinned: isRowPinned, pinnedTopRowData: pinnedTopRowData, pinnedBottomRowData: pinnedBottomRowData }) {
                if (isRowPinned && (pinnedTopRowData || pinnedBottomRowData)) return "Manual row pinning cannot be used together with pinned row data. Either remove `isRowPinned`, or remove `pinnedTopRowData` and `pinnedBottomRowData`.";
                if (!enableRowPinning && isRowPinned) return "`isRowPinned` requires `enableRowPinning` to be set.";
                return null;
            }
        },
        groupDefaultExpanded: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        groupHideOpenParents: {
            supportedRowModels: [
                "clientSide",
                "serverSide"
            ],
            dependencies: {
                groupTotalRow: {
                    required: [
                        void 0,
                        "bottom"
                    ]
                },
                treeData: {
                    required: [
                        void 0,
                        false
                    ],
                    reason: "Tree Data has values at the group level so it doesn't make sense to hide them."
                }
            }
        },
        groupHideParentOfSingleChild: {
            dependencies: {
                groupHideOpenParents: {
                    required: [
                        void 0,
                        false
                    ]
                }
            }
        },
        groupRemoveLowestSingleChildren: {
            dependencies: {
                groupHideOpenParents: {
                    required: [
                        void 0,
                        false
                    ]
                },
                groupRemoveSingleChildren: {
                    required: [
                        void 0,
                        false
                    ]
                }
            }
        },
        groupRemoveSingleChildren: {
            dependencies: {
                groupHideOpenParents: {
                    required: [
                        void 0,
                        false
                    ]
                },
                groupRemoveLowestSingleChildren: {
                    required: [
                        void 0,
                        false
                    ]
                }
            }
        },
        groupSelectsChildren: {
            dependencies: {
                rowSelection: {
                    required: [
                        "multiple"
                    ]
                }
            }
        },
        icons: {
            validate: ({ icons: icons })=>{
                if (icons) {
                    if (icons["smallDown"]) return $437b23f6a393c3bf$export$680bb5102fca525e(262);
                    if (icons["smallLeft"]) return $437b23f6a393c3bf$export$680bb5102fca525e(263);
                    if (icons["smallRight"]) return $437b23f6a393c3bf$export$680bb5102fca525e(264);
                }
                return null;
            }
        },
        infiniteInitialRowCount: {
            validate ({ infiniteInitialRowCount: infiniteInitialRowCount }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("infiniteInitialRowCount", infiniteInitialRowCount, 1);
            }
        },
        initialGroupOrderComparator: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        keepDetailRowsCount: {
            validate ({ keepDetailRowsCount: keepDetailRowsCount }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("keepDetailRowsCount", keepDetailRowsCount, 1);
            }
        },
        paginationPageSize: {
            validate ({ paginationPageSize: paginationPageSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("paginationPageSize", paginationPageSize, 1);
            }
        },
        paginationPageSizeSelector: {
            validate: (options)=>{
                const values = options.paginationPageSizeSelector;
                if (typeof values === "boolean" || values == null) return null;
                if (!values.length) return `'paginationPageSizeSelector' cannot be an empty array.
                    If you want to hide the page size selector, set paginationPageSizeSelector to false.`;
                return null;
            }
        },
        pivotMode: {
            dependencies: {
                treeData: {
                    required: [
                        false,
                        void 0
                    ],
                    reason: "Pivot Mode is not supported with Tree Data."
                }
            }
        },
        quickFilterText: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        rowBuffer: {
            validate ({ rowBuffer: rowBuffer }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("rowBuffer", rowBuffer, 0);
            }
        },
        rowClass: {
            validate: (options)=>{
                const rowClass = options.rowClass;
                if (typeof rowClass === "function") return "rowClass should not be a function, please use getRowClass instead";
                return null;
            }
        },
        rowData: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        rowDragManaged: {
            supportedRowModels: [
                "clientSide"
            ],
            dependencies: {
                pagination: {
                    required: [
                        false,
                        void 0
                    ]
                }
            }
        },
        rowSelection: {
            validate ({ rowSelection: rowSelection }) {
                if (rowSelection && typeof rowSelection === "string") return 'As of version 32.2.1, using `rowSelection` with the values "single" or "multiple" has been deprecated. Use the object value instead.';
                if (rowSelection && typeof rowSelection !== "object") return "Expected `RowSelectionOptions` object for the `rowSelection` property.";
                if (rowSelection && rowSelection.mode !== "multiRow" && rowSelection.mode !== "singleRow") return `Selection mode "${rowSelection.mode}" is invalid. Use one of 'singleRow' or 'multiRow'.`;
                return null;
            }
        },
        rowStyle: {
            validate: (options)=>{
                const rowStyle = options.rowStyle;
                if (rowStyle && typeof rowStyle === "function") return "rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead";
                return null;
            }
        },
        serverSideDatasource: {
            supportedRowModels: [
                "serverSide"
            ]
        },
        serverSideInitialRowCount: {
            supportedRowModels: [
                "serverSide"
            ],
            validate ({ serverSideInitialRowCount: serverSideInitialRowCount }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("serverSideInitialRowCount", serverSideInitialRowCount, 1);
            }
        },
        serverSideOnlyRefreshFilteredGroups: {
            supportedRowModels: [
                "serverSide"
            ]
        },
        serverSideSortAllLevels: {
            supportedRowModels: [
                "serverSide"
            ]
        },
        sortingOrder: {
            validate: (_options)=>{
                const sortingOrder = _options.sortingOrder;
                if (Array.isArray(sortingOrder) && sortingOrder.length > 0) {
                    const invalidItems = sortingOrder.filter((a)=>!$437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER.includes(a));
                    if (invalidItems.length > 0) return `sortingOrder must be an array with elements from [${$437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER.map($437b23f6a393c3bf$var$toStringWithNullUndefined).join()}], currently it includes [${invalidItems.map($437b23f6a393c3bf$var$toStringWithNullUndefined).join()}]`;
                } else if (!Array.isArray(sortingOrder) || sortingOrder.length <= 0) return `sortingOrder must be an array with at least one element, currently it's ${sortingOrder}`;
                return null;
            }
        },
        tooltipHideDelay: {
            validate: (options)=>{
                if (options.tooltipHideDelay && options.tooltipHideDelay < 0) return "tooltipHideDelay should not be lower than 0";
                return null;
            }
        },
        tooltipShowDelay: {
            validate: (options)=>{
                if (options.tooltipShowDelay && options.tooltipShowDelay < 0) return "tooltipShowDelay should not be lower than 0";
                return null;
            }
        },
        treeData: {
            supportedRowModels: [
                "clientSide",
                "serverSide"
            ],
            validate: (options)=>{
                const rowModel = options.rowModelType ?? "clientSide";
                switch(rowModel){
                    case "clientSide":
                        {
                            const { treeDataChildrenField: treeDataChildrenField, treeDataParentIdField: treeDataParentIdField, getDataPath: getDataPath, getRowId: getRowId } = options;
                            if (!treeDataChildrenField && !treeDataParentIdField && !getDataPath) return "treeData requires either 'treeDataChildrenField' or 'treeDataParentIdField' or 'getDataPath' in the clientSide row model.";
                            if (treeDataChildrenField) {
                                if (getDataPath) return "Cannot use both 'treeDataChildrenField' and 'getDataPath' at the same time.";
                                if (treeDataParentIdField) return "Cannot use both 'treeDataChildrenField' and 'treeDataParentIdField' at the same time.";
                            }
                            if (treeDataParentIdField) {
                                if (!getRowId) return "getRowId callback not provided, tree data with parent id cannot be built.";
                                if (getDataPath) return "Cannot use both 'treeDataParentIdField' and 'getDataPath' at the same time.";
                            }
                            return null;
                        }
                    case "serverSide":
                        {
                            const ssrmWarning = `treeData requires 'isServerSideGroup' and 'getServerSideGroupKey' in the ${rowModel} row model.`;
                            return options.isServerSideGroup && options.getServerSideGroupKey ? null : ssrmWarning;
                        }
                }
                return null;
            }
        },
        viewportDatasource: {
            supportedRowModels: [
                "viewport"
            ]
        },
        viewportRowModelBufferSize: {
            validate ({ viewportRowModelBufferSize: viewportRowModelBufferSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("viewportRowModelBufferSize", viewportRowModelBufferSize, 0);
            }
        },
        viewportRowModelPageSize: {
            validate ({ viewportRowModelPageSize: viewportRowModelPageSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("viewportRowModelPageSize", viewportRowModelPageSize, 1);
            }
        },
        rowDragEntireRow: {
            dependencies: {
                cellSelection: {
                    required: [
                        void 0
                    ]
                }
            }
        },
        autoGroupColumnDef: {
            validate ({ autoGroupColumnDef: autoGroupColumnDef, showOpenedGroup: showOpenedGroup }) {
                if (autoGroupColumnDef?.field && showOpenedGroup) return "autoGroupColumnDef.field and showOpenedGroup are not supported when used together.";
                if (autoGroupColumnDef?.valueGetter && showOpenedGroup) return "autoGroupColumnDef.valueGetter and showOpenedGroup are not supported when used together.";
                return null;
            }
        },
        renderingMode: {
            validate: (options)=>{
                const renderingMode = options.renderingMode;
                const validModes = [
                    "default",
                    "legacy"
                ];
                if (renderingMode && !validModes.includes(renderingMode)) return `renderingMode must be one of [${validModes.join()}], currently it's ${renderingMode}`;
                return null;
            }
        }
    };
    const validations = {};
    $437b23f6a393c3bf$var$_BOOLEAN_GRID_OPTIONS.forEach((key)=>{
        validations[key] = {
            expectedType: "boolean"
        };
    });
    $437b23f6a393c3bf$var$_NUMBER_GRID_OPTIONS.forEach((key)=>{
        validations[key] = {
            expectedType: "number"
        };
    });
    $437b23f6a393c3bf$export$8ade6bd474fcde42(validations, definedValidations);
    return validations;
};
var $437b23f6a393c3bf$var$GRID_OPTIONS_VALIDATORS = ()=>({
        objectName: "gridOptions",
        allProperties: [
            ...$437b23f6a393c3bf$export$a827a39ae0574df3(),
            ...Object.values($437b23f6a393c3bf$export$85716710781d6a6b)
        ],
        propertyExceptions: [
            "api"
        ],
        docsUrl: "grid-options/",
        deprecations: $437b23f6a393c3bf$var$GRID_OPTION_DEPRECATIONS(),
        validations: $437b23f6a393c3bf$var$GRID_OPTION_VALIDATIONS()
    });
// packages/ag-grid-community/src/gridOptionsService.ts
var $437b23f6a393c3bf$var$changeSetId = 0;
var $437b23f6a393c3bf$var$gridInstanceSequence = 0;
var $437b23f6a393c3bf$var$GridOptionsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "gos";
        this.domDataKey = "__AG_" + Math.random().toString();
        /** This is only used for the main DOM element */ this.gridInstanceId = $437b23f6a393c3bf$var$gridInstanceSequence++;
        // Used to hold user events until the grid is ready
        // Required to support React 19 StrictMode. See IFrameworkOverrides.runWhenReadyAsync but also is likely a good idea that onGridReady is the first event fired.
        this.gridReadyFired = false;
        this.queueEvents = [];
        this.propEventSvc = new $437b23f6a393c3bf$export$820da7696a401cdc();
        // responsible for calling the onXXX functions on gridOptions
        // It forces events defined in GridOptionsService.alwaysSyncGlobalEvents to be fired synchronously.
        // This is required for events such as GridPreDestroyed.
        // Other events can be fired asynchronously or synchronously depending on config.
        this.globalEventHandlerFactory = (restrictToSyncOnly)=>{
            return (eventName, event)=>{
                if (!this.isAlive()) return;
                const alwaysSync = $437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventName);
                if (alwaysSync && !restrictToSyncOnly || !alwaysSync && restrictToSyncOnly) return;
                if (!$437b23f6a393c3bf$var$isPublicEventHandler(eventName)) return;
                const fireEvent = (name, e)=>{
                    const eventHandlerName = $437b23f6a393c3bf$export$85716710781d6a6b[name];
                    const eventHandler = this.gridOptions[eventHandlerName];
                    if (typeof eventHandler === "function") this.beans.frameworkOverrides.wrapOutgoing(()=>eventHandler(e));
                };
                if (this.gridReadyFired) fireEvent(eventName, event);
                else if (eventName === "gridReady") {
                    fireEvent(eventName, event);
                    this.gridReadyFired = true;
                    for (const q of this.queueEvents)fireEvent(q.eventName, q.event);
                    this.queueEvents = [];
                } else this.queueEvents.push({
                    eventName: eventName,
                    event: event
                });
            };
        };
    }
    wireBeans(beans) {
        this.gridOptions = beans.gridOptions;
        this.validation = beans.validation;
        this.api = beans.gridApi;
        this.gridId = beans.context.getGridId();
    }
    // This is quicker then having code call gridOptionsService.get('context')
    get gridOptionsContext() {
        return this.gridOptions["context"];
    }
    postConstruct() {
        this.validateGridOptions(this.gridOptions);
        this.eventSvc.addGlobalListener(this.globalEventHandlerFactory().bind(this), true);
        this.eventSvc.addGlobalListener(this.globalEventHandlerFactory(true).bind(this), false);
        this.propEventSvc.setFrameworkOverrides(this.beans.frameworkOverrides);
        this.addManagedEventListeners({
            gridOptionsChanged: ({ options: options })=>{
                this.updateGridOptions({
                    options: options,
                    force: true,
                    source: "gridOptionsUpdated"
                });
            }
        });
    }
    destroy() {
        super.destroy();
        this.queueEvents = [];
    }
    /**
   * Get the raw value of the GridOptions property provided.
   * @param property
   */ get(property) {
        return this.gridOptions[property] ?? $437b23f6a393c3bf$var$GRID_OPTION_DEFAULTS[property];
    }
    /**
   * Get the GridOption callback but wrapped so that the common params of api and context are automatically applied to the params.
   * @param property GridOption callback properties based on the fact that this property has a callback with params extending AgGridCommon
   */ getCallback(property) {
        return this.mergeGridCommonParams(this.gridOptions[property]);
    }
    /**
   * Returns `true` if a value has been specified for this GridOption.
   * @param property GridOption property
   */ exists(property) {
        return $437b23f6a393c3bf$export$25d27f17d3af40f7(this.gridOptions[property]);
    }
    /**
   * Wrap the user callback and attach the api and context to the params object on the way through.
   * @param callback User provided callback
   * @returns Wrapped callback where the params object not require api and context
   */ mergeGridCommonParams(callback) {
        if (callback) {
            const wrapped = (callbackParams)=>{
                return callback(this.addGridCommonParams(callbackParams));
            };
            return wrapped;
        }
        return callback;
    }
    updateGridOptions({ options: options, force: force, source: source = "api" }) {
        const changeSet = {
            id: $437b23f6a393c3bf$var$changeSetId++,
            properties: []
        };
        const events = [];
        const { gridOptions: gridOptions, validation: validation2 } = this;
        for (const key of Object.keys(options)){
            const value = options[key];
            validation2?.warnOnInitialPropertyUpdate(source, key);
            const shouldForce = force || typeof value === "object" && source === "api";
            const previousValue = gridOptions[key];
            if (shouldForce || previousValue !== value) {
                gridOptions[key] = value;
                const event = {
                    type: key,
                    currentValue: value,
                    previousValue: previousValue,
                    changeSet: changeSet,
                    source: source
                };
                events.push(event);
            }
        }
        this.validateGridOptions(this.gridOptions);
        changeSet.properties = events.map((event)=>event.type);
        events.forEach((event)=>{
            $437b23f6a393c3bf$var$_logIfDebug(this, `Updated property ${event.type} from`, event.previousValue, ` to `, event.currentValue);
            this.propEventSvc.dispatchEvent(event);
        });
    }
    addPropertyEventListener(key, listener) {
        this.propEventSvc.addEventListener(key, listener);
    }
    removePropertyEventListener(key, listener) {
        this.propEventSvc.removeEventListener(key, listener);
    }
    getDomDataKey() {
        return this.domDataKey;
    }
    /** Prefer _addGridCommonParams from gridOptionsUtils for bundle size savings */ addGridCommonParams(params) {
        params.api = this.api;
        params.context = this.gridOptionsContext;
        return params;
    }
    validateOptions(options, modValidations) {
        for (const key of Object.keys(options)){
            const value = options[key];
            if (value == null || value === false) continue;
            let moduleToCheck = modValidations[key];
            if (typeof moduleToCheck === "function") moduleToCheck = moduleToCheck(options, this.gridOptions, this.beans);
            if (moduleToCheck) this.assertModuleRegistered(moduleToCheck, key);
        }
    }
    validateGridOptions(gridOptions) {
        this.validateOptions(gridOptions, $437b23f6a393c3bf$var$GRID_OPTIONS_MODULES);
        this.validation?.processGridOptions(gridOptions);
    }
    validateColDef(colDef, colId, skipInferenceCheck) {
        if (skipInferenceCheck || !this.beans.dataTypeSvc?.isColPendingInference(colId)) {
            this.validateOptions(colDef, $437b23f6a393c3bf$var$COLUMN_DEFINITION_MOD_VALIDATIONS);
            this.validation?.validateColDef(colDef);
        }
    }
    assertModuleRegistered(moduleName, reasonOrId) {
        const registered = Array.isArray(moduleName) ? moduleName.some((modName)=>this.isModuleRegistered(modName)) : this.isModuleRegistered(moduleName);
        if (!registered) $437b23f6a393c3bf$export$a20c7248650823a9(200, {
            ...this.getModuleErrorParams(),
            moduleName: moduleName,
            reasonOrId: reasonOrId
        });
        return registered;
    }
    getModuleErrorParams() {
        return {
            gridId: this.gridId,
            gridScoped: $437b23f6a393c3bf$var$_areModulesGridScoped(),
            rowModelType: this.get("rowModelType"),
            isUmd: $437b23f6a393c3bf$var$_isUmd()
        };
    }
    isModuleRegistered(moduleName) {
        return $437b23f6a393c3bf$var$_isModuleRegistered(moduleName, this.gridId, this.get("rowModelType"));
    }
};
function $437b23f6a393c3bf$var$isPublicEventHandler(eventName) {
    return !!$437b23f6a393c3bf$export$85716710781d6a6b[eventName];
}
// packages/ag-grid-community/src/headerRendering/cells/column/headerComp.ts
function $437b23f6a393c3bf$var$getHeaderCompElementParams(includeSortIndicator) {
    const hiddenAttrs = {
        "aria-hidden": "true"
    };
    return {
        tag: "div",
        cls: "ag-cell-label-container",
        role: "presentation",
        children: [
            {
                tag: "span",
                ref: "eMenu",
                cls: "ag-header-icon ag-header-cell-menu-button",
                attrs: hiddenAttrs
            },
            {
                tag: "span",
                ref: "eFilterButton",
                cls: "ag-header-icon ag-header-cell-filter-button",
                attrs: hiddenAttrs
            },
            {
                tag: "div",
                ref: "eLabel",
                cls: "ag-header-cell-label",
                role: "presentation",
                children: [
                    {
                        tag: "span",
                        ref: "eText",
                        cls: "ag-header-cell-text"
                    },
                    {
                        tag: "span",
                        ref: "eFilter",
                        cls: "ag-header-icon ag-header-label-icon ag-filter-icon",
                        attrs: hiddenAttrs
                    },
                    includeSortIndicator ? {
                        tag: "ag-sort-indicator",
                        ref: "eSortIndicator"
                    } : null
                ]
            }
        ]
    };
}
var $437b23f6a393c3bf$var$HeaderCompElement = $437b23f6a393c3bf$var$getHeaderCompElementParams(true);
var $437b23f6a393c3bf$var$HeaderCompElementNoSort = $437b23f6a393c3bf$var$getHeaderCompElementParams(false);
var $437b23f6a393c3bf$export$266cd3930df0b35d = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(...arguments);
        // All the elements are optional, as they are not guaranteed to be present if the user provides a custom template
        this.eFilter = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eFilterButton = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortIndicator = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eMenu = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eText = $437b23f6a393c3bf$export$6c811454646ed8be;
        /**
     * Selectors for custom headers templates, i.e when the ag-sort-indicator is not present.
     */ this.eSortOrder = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortAsc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortDesc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortMixed = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortNone = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.isLoadingInnerComponent = false;
    }
    refresh(params) {
        const oldParams = this.params;
        this.params = params;
        if (this.workOutTemplate(params, !!this.beans?.sortSvc) != this.currentTemplate || this.workOutShowMenu() != this.currentShowMenu || params.enableSorting != this.currentSort || this.currentSuppressMenuHide != null && this.shouldSuppressMenuHide() != this.currentSuppressMenuHide || oldParams.enableFilterButton != params.enableFilterButton || oldParams.enableFilterIcon != params.enableFilterIcon) return false;
        if (this.innerHeaderComponent) {
            const mergedParams = {
                ...params
            };
            $437b23f6a393c3bf$export$8ade6bd474fcde42(mergedParams, params.innerHeaderComponentParams);
            this.innerHeaderComponent.refresh?.(mergedParams);
        } else this.setDisplayName(params);
        return true;
    }
    workOutTemplate(params, isSorting) {
        const paramsTemplate = params.template;
        if (paramsTemplate) return paramsTemplate?.trim ? paramsTemplate.trim() : paramsTemplate;
        else return isSorting ? $437b23f6a393c3bf$var$HeaderCompElement : $437b23f6a393c3bf$var$HeaderCompElementNoSort;
    }
    init(params) {
        this.params = params;
        const { sortSvc: sortSvc, touchSvc: touchSvc, rowNumbersSvc: rowNumbersSvc, userCompFactory: userCompFactory } = this.beans;
        const sortComp = sortSvc?.getSortIndicatorSelector();
        this.currentTemplate = this.workOutTemplate(params, !!sortComp);
        this.setTemplate(this.currentTemplate, sortComp ? [
            sortComp
        ] : void 0);
        touchSvc?.setupForHeader(this);
        this.setMenu();
        this.setupSort();
        rowNumbersSvc?.setupForHeader(this);
        this.setupFilterIcon();
        this.setupFilterButton();
        this.workOutInnerHeaderComponent(userCompFactory, params);
        this.setDisplayName(params);
    }
    workOutInnerHeaderComponent(userCompFactory, params) {
        const userCompDetails = $437b23f6a393c3bf$var$_getInnerHeaderCompDetails(userCompFactory, params, params);
        if (!userCompDetails) return;
        this.isLoadingInnerComponent = true;
        userCompDetails.newAgStackInstance().then((comp)=>{
            this.isLoadingInnerComponent = false;
            if (!comp) return;
            if (this.isAlive()) {
                this.innerHeaderComponent = comp;
                if (this.eText) this.eText.appendChild(comp.getGui());
            } else this.destroyBean(comp);
        });
    }
    setDisplayName(params) {
        const { displayName: displayName } = params;
        const oldDisplayName = this.currentDisplayName;
        this.currentDisplayName = displayName;
        if (!this.eText || oldDisplayName === displayName || this.innerHeaderComponent || this.isLoadingInnerComponent) return;
        this.eText.textContent = $437b23f6a393c3bf$export$a16cfb6652fe466f(displayName);
    }
    addInIcon(iconName, eParent, column) {
        const eIcon = $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, this.beans, column);
        if (eIcon) eParent.appendChild(eIcon);
    }
    workOutShowMenu() {
        return this.params.enableMenu && !!this.beans.menuSvc?.isHeaderMenuButtonEnabled();
    }
    shouldSuppressMenuHide() {
        return !!this.beans.menuSvc?.isHeaderMenuButtonAlwaysShowEnabled();
    }
    setMenu() {
        if (!this.eMenu) return;
        this.currentShowMenu = this.workOutShowMenu();
        if (!this.currentShowMenu) {
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.eMenu);
            this.eMenu = void 0;
            return;
        }
        const { gos: gos, eMenu: eMenu, params: params } = this;
        const isLegacyMenu = $437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos);
        this.addInIcon(isLegacyMenu ? "menu" : "menuAlt", eMenu, params.column);
        eMenu.classList.toggle("ag-header-menu-icon", !isLegacyMenu);
        const currentSuppressMenuHide = this.shouldSuppressMenuHide();
        this.currentSuppressMenuHide = currentSuppressMenuHide;
        this.addManagedElementListeners(eMenu, {
            click: ()=>this.showColumnMenu(this.eMenu)
        });
        this.toggleMenuAlwaysShow(currentSuppressMenuHide);
    }
    toggleMenuAlwaysShow(alwaysShow) {
        this.eMenu?.classList.toggle("ag-header-menu-always-show", alwaysShow);
    }
    showColumnMenu(element) {
        const { currentSuppressMenuHide: currentSuppressMenuHide, params: params } = this;
        if (!currentSuppressMenuHide) this.toggleMenuAlwaysShow(true);
        params.showColumnMenu(element, ()=>{
            if (!currentSuppressMenuHide) this.toggleMenuAlwaysShow(false);
        });
    }
    onMenuKeyboardShortcut(isFilterShortcut) {
        const { params: params, gos: gos, beans: beans, eMenu: eMenu, eFilterButton: eFilterButton } = this;
        const column = params.column;
        const isLegacyMenuEnabled = $437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos);
        if (isFilterShortcut && !isLegacyMenuEnabled) {
            if (beans.menuSvc?.isFilterMenuInHeaderEnabled(column)) {
                params.showFilter(eFilterButton ?? eMenu ?? this.getGui());
                return true;
            }
        } else if (params.enableMenu) {
            this.showColumnMenu(eMenu ?? eFilterButton ?? this.getGui());
            return true;
        }
        return false;
    }
    setupSort() {
        const { sortSvc: sortSvc } = this.beans;
        if (!sortSvc) return;
        const { enableSorting: enableSorting, column: column } = this.params;
        this.currentSort = enableSorting;
        if (!this.eSortIndicator) {
            this.eSortIndicator = this.createBean(sortSvc.createSortIndicator(true));
            const { eSortIndicator: eSortIndicator, eSortOrder: eSortOrder, eSortAsc: eSortAsc, eSortDesc: eSortDesc, eSortMixed: eSortMixed, eSortNone: eSortNone } = this;
            eSortIndicator.attachCustomElements(eSortOrder, eSortAsc, eSortDesc, eSortMixed, eSortNone);
        }
        this.eSortIndicator.setupSort(column);
        if (!this.currentSort) return;
        sortSvc.setupHeader(this, column, this.eLabel);
    }
    setupFilterIcon() {
        const { eFilter: eFilter, params: params } = this;
        if (!eFilter) return;
        const onFilterChangedIcon = ()=>{
            const filterPresent = params.column.isFilterActive();
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eFilter, filterPresent, {
                skipAriaHidden: true
            });
        };
        this.configureFilter(params.enableFilterIcon, eFilter, onFilterChangedIcon, "filterActive");
    }
    setupFilterButton() {
        const { eFilterButton: eFilterButton, params: params } = this;
        if (!eFilterButton) return;
        const configured = this.configureFilter(params.enableFilterButton, eFilterButton, this.onFilterChangedButton.bind(this), "filter");
        if (configured) this.addManagedElementListeners(eFilterButton, {
            click: ()=>params.showFilter(eFilterButton)
        });
        else this.eFilterButton = void 0;
    }
    configureFilter(enabled, element, filterChangedCallback, icon) {
        if (!enabled) {
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(element);
            return false;
        }
        const column = this.params.column;
        this.addInIcon(icon, element, column);
        this.addManagedListeners(column, {
            filterChanged: filterChangedCallback
        });
        filterChangedCallback();
        return true;
    }
    onFilterChangedButton() {
        const filterPresent = this.params.column.isFilterActive();
        this.eFilterButton.classList.toggle("ag-filter-active", filterPresent);
    }
    getAnchorElementForMenu(isFilter) {
        const { eFilterButton: eFilterButton, eMenu: eMenu } = this;
        if (isFilter) return eFilterButton ?? eMenu ?? this.getGui();
        return eMenu ?? eFilterButton ?? this.getGui();
    }
    destroy() {
        super.destroy();
        if (this.innerHeaderComponent) {
            this.destroyBean(this.innerHeaderComponent);
            this.innerHeaderComponent = void 0;
        }
    }
};
// packages/ag-grid-community/src/headerRendering/cells/columnGroup/headerGroupComp.ts
var $437b23f6a393c3bf$var$HeaderGroupCompElement = {
    tag: "div",
    cls: "ag-header-group-cell-label",
    role: "presentation",
    children: [
        {
            tag: "span",
            ref: "agLabel",
            cls: "ag-header-group-text",
            role: "presentation"
        },
        {
            tag: "span",
            ref: "agOpened",
            cls: `ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded`
        },
        {
            tag: "span",
            ref: "agClosed",
            cls: `ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed`
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderGroupComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$HeaderGroupCompElement);
        this.agOpened = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.agClosed = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.agLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.isLoadingInnerComponent = false;
    }
    init(params) {
        const { userCompFactory: userCompFactory, touchSvc: touchSvc } = this.beans;
        this.params = params;
        this.checkWarnings();
        this.workOutInnerHeaderGroupComponent(userCompFactory, params);
        this.setupLabel(params);
        this.addGroupExpandIcon(params);
        this.setupExpandIcons();
        touchSvc?.setupForHeaderGroup(this);
    }
    checkWarnings() {
        const paramsAny = this.params;
        if (paramsAny.template) $437b23f6a393c3bf$export$545083624300f13d(89);
    }
    workOutInnerHeaderGroupComponent(userCompFactory, params) {
        const userCompDetails = $437b23f6a393c3bf$var$_getInnerHeaderGroupCompDetails(userCompFactory, params, params);
        if (!userCompDetails) return;
        this.isLoadingInnerComponent = true;
        userCompDetails.newAgStackInstance().then((comp)=>{
            this.isLoadingInnerComponent = false;
            if (!comp) return;
            if (this.isAlive()) {
                this.innerHeaderGroupComponent = comp;
                this.agLabel.appendChild(comp.getGui());
            } else this.destroyBean(comp);
        });
    }
    setupExpandIcons() {
        const { agOpened: agOpened, agClosed: agClosed, params: { columnGroup: columnGroup }, beans: beans } = this;
        this.addInIcon("columnGroupOpened", agOpened);
        this.addInIcon("columnGroupClosed", agClosed);
        const expandAction = (event)=>{
            if ($437b23f6a393c3bf$export$9a48e23524c6d58(event)) return;
            const newExpandedValue = !columnGroup.isExpanded();
            beans.colGroupSvc.setColumnGroupOpened(columnGroup.getProvidedColumnGroup(), newExpandedValue, "uiColumnExpanded");
        };
        this.addTouchAndClickListeners(beans, agClosed, expandAction);
        this.addTouchAndClickListeners(beans, agOpened, expandAction);
        const stopPropagationAction = (event)=>{
            $437b23f6a393c3bf$export$456c40e80134d72a(event);
        };
        this.addManagedElementListeners(agClosed, {
            dblclick: stopPropagationAction
        });
        this.addManagedElementListeners(agOpened, {
            dblclick: stopPropagationAction
        });
        this.addManagedElementListeners(this.getGui(), {
            dblclick: expandAction
        });
        this.updateIconVisibility();
        const providedColumnGroup = columnGroup.getProvidedColumnGroup();
        const updateIcon = this.updateIconVisibility.bind(this);
        this.addManagedListeners(providedColumnGroup, {
            expandedChanged: updateIcon,
            expandableChanged: updateIcon
        });
    }
    addTouchAndClickListeners(beans, eElement, action) {
        beans.touchSvc?.setupForHeaderGroupElement(this, eElement, action);
        this.addManagedElementListeners(eElement, {
            click: action
        });
    }
    updateIconVisibility() {
        const { agOpened: agOpened, agClosed: agClosed, params: { columnGroup: columnGroup } } = this;
        if (columnGroup.isExpandable()) {
            const expanded = columnGroup.isExpanded();
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agOpened, expanded);
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agClosed, !expanded);
        } else {
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agOpened, false);
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agClosed, false);
        }
    }
    addInIcon(iconName, element) {
        const eIcon = $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, this.beans, null);
        if (eIcon) element.appendChild(eIcon);
    }
    addGroupExpandIcon(params) {
        if (!params.columnGroup.isExpandable()) {
            const { agOpened: agOpened, agClosed: agClosed } = this;
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agOpened, false);
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agClosed, false);
            return;
        }
    }
    setupLabel(params) {
        const { displayName: displayName, columnGroup: columnGroup } = params;
        const hasInnerComponent = this.innerHeaderGroupComponent || this.isLoadingInnerComponent;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(displayName) && !hasInnerComponent) this.agLabel.textContent = $437b23f6a393c3bf$export$a16cfb6652fe466f(displayName);
        this.toggleCss("ag-sticky-label", !columnGroup.getColGroupDef()?.suppressStickyLabel);
    }
    destroy() {
        super.destroy();
        if (this.innerHeaderGroupComponent) {
            this.destroyBean(this.innerHeaderGroupComponent);
            this.innerHeaderGroupComponent = void 0;
        }
    }
};
// packages/ag-grid-community/src/headerRendering/cells/headerModule.ts
var $437b23f6a393c3bf$var$ColumnHeaderCompModule = {
    moduleName: "ColumnHeaderComp",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agColumnHeader: $437b23f6a393c3bf$export$266cd3930df0b35d
    },
    icons: {
        // button to launch legacy column menu
        menu: "menu",
        // button to launch new enterprise column menu
        menuAlt: "menu-alt"
    }
};
var $437b23f6a393c3bf$var$ColumnGroupHeaderCompModule = {
    moduleName: "ColumnGroupHeaderComp",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agColumnGroupHeader: $437b23f6a393c3bf$var$HeaderGroupComp
    },
    icons: {
        // header column group shown when expanded (click to contract)
        columnGroupOpened: "expanded",
        // header column group shown when contracted (click to expand)
        columnGroupClosed: "contracted"
    }
};
// packages/ag-grid-community/src/misc/animationFrameService.ts
var $437b23f6a393c3bf$var$AnimationFrameService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "animationFrameSvc";
        // p1 and p2 are create tasks are to do with row and cell creation.
        // for them we want to execute according to row order, so we use
        // TaskItem so we know what index the item is for.
        this.p1 = {
            list: [],
            sorted: false
        };
        // eg drawing back-ground of rows
        this.p2 = {
            list: [],
            sorted: false
        };
        // eg cell renderers, adding hover functionality
        this.f1 = {
            list: [],
            sorted: false
        };
        // eg framework cell renderers
        // destroy tasks are to do with row removal. they are done after row creation as the user will need to see new
        // rows first (as blank is scrolled into view), when we remove the old rows (no longer in view) is not as
        // important.
        this.destroyTasks = [];
        this.ticking = false;
        // we need to know direction of scroll, to build up rows in the direction of
        // the scroll. eg if user scrolls down, we extend the rows by building down.
        this.scrollGoingDown = true;
        this.lastScrollTop = 0;
        this.taskCount = 0;
    }
    setScrollTop(scrollTop) {
        this.scrollGoingDown = scrollTop >= this.lastScrollTop;
        if (scrollTop === 0) this.scrollGoingDown = true;
        this.lastScrollTop = scrollTop;
    }
    postConstruct() {
        this.active = !this.gos.get("suppressAnimationFrame");
        this.batchFrameworkComps = this.beans.frameworkOverrides.batchFrameworkComps;
    }
    // this method is for our AG Grid sanity only - if animation frames are turned off,
    // then no place in the code should be looking to add any work to be done in animation
    // frames. this stops bugs - where some code is asking for a frame to be executed
    // when it should not.
    verify() {
        if (this.active === false) $437b23f6a393c3bf$export$545083624300f13d(92);
    }
    createTask(task, index, list, isFramework, isDeferred = false) {
        this.verify();
        let taskList = list;
        if (isFramework && this.batchFrameworkComps) taskList = "f1";
        const taskItem = {
            task: task,
            index: index,
            createOrder: ++this.taskCount,
            deferred: isDeferred
        };
        this.addTaskToList(this[taskList], taskItem);
        this.schedule();
    }
    addTaskToList(taskList, task) {
        taskList.list.push(task);
        taskList.sorted = false;
    }
    sortTaskList(taskList) {
        if (taskList.sorted) return;
        const sortDirection = this.scrollGoingDown ? 1 : -1;
        taskList.list.sort((a, b)=>{
            if (a.deferred !== b.deferred) return a.deferred ? -1 : 1;
            if (a.index !== b.index) return sortDirection * (b.index - a.index);
            return b.createOrder - a.createOrder;
        });
        taskList.sorted = true;
    }
    addDestroyTask(task) {
        this.verify();
        this.destroyTasks.push(task);
        this.schedule();
    }
    executeFrame(millis) {
        const { p1: p1, p2: p2, f1: f1, destroyTasks: destroyTasks, beans: beans } = this;
        const { ctrlsSvc: ctrlsSvc, frameworkOverrides: frameworkOverrides } = beans;
        const p1Tasks = p1.list;
        const p2Tasks = p2.list;
        const f1Tasks = f1.list;
        const frameStart = Date.now();
        let duration = 0;
        const noMaxMillis = millis <= 0;
        const scrollFeature = ctrlsSvc.getScrollFeature();
        while(noMaxMillis || duration < millis){
            const gridBodyDidSomething = scrollFeature.scrollGridIfNeeded();
            if (!gridBodyDidSomething) {
                let task;
                if (p1Tasks.length) {
                    this.sortTaskList(p1);
                    task = p1Tasks.pop().task;
                } else if (p2Tasks.length) {
                    this.sortTaskList(p2);
                    task = p2Tasks.pop().task;
                } else if (f1Tasks.length) {
                    frameworkOverrides.wrapOutgoing(()=>{
                        while(noMaxMillis || duration < millis){
                            const gridBodyDidSomething2 = scrollFeature.scrollGridIfNeeded();
                            if (!gridBodyDidSomething2) {
                                if (f1Tasks.length) {
                                    this.sortTaskList(f1);
                                    task = f1Tasks.pop().task;
                                    task();
                                } else break;
                            } else break;
                            duration = Date.now() - frameStart;
                        }
                    });
                    task = ()=>{};
                } else if (destroyTasks.length) task = destroyTasks.pop();
                else break;
                task();
            }
            duration = Date.now() - frameStart;
        }
        if (p1Tasks.length || p2Tasks.length || f1Tasks.length || destroyTasks.length) this.requestFrame();
        else this.ticking = false;
    }
    flushAllFrames() {
        if (!this.active) return;
        this.executeFrame(-1);
    }
    schedule() {
        if (!this.active) return;
        if (!this.ticking) {
            this.ticking = true;
            this.requestFrame();
        }
    }
    requestFrame() {
        const callback = this.executeFrame.bind(this, 60);
        $437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, callback);
    }
    isQueueEmpty() {
        return !this.ticking;
    }
};
// packages/ag-grid-community/src/misc/animationFrameModule.ts
var $437b23f6a393c3bf$var$AnimationFrameModule = {
    moduleName: "AnimationFrame",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AnimationFrameService
    ]
};
// packages/ag-grid-community/src/misc/touchService.ts
var $437b23f6a393c3bf$var$TouchService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "touchSvc";
    }
    mockBodyContextMenu(ctrl, listener) {
        this.mockContextMenu(ctrl, ctrl.eBodyViewport, listener);
    }
    mockHeaderContextMenu(ctrl, listener) {
        this.mockContextMenu(ctrl, ctrl.eGui, listener);
    }
    mockRowContextMenu(ctrl) {
        if (!$437b23f6a393c3bf$export$6b6034a68325bd8a()) return;
        const listener = (mouseListener, touch, touchEvent)=>{
            const { rowCtrl: rowCtrl, cellCtrl: cellCtrl } = ctrl.getControlsForEventTarget(touchEvent?.target ?? null);
            if (cellCtrl?.column) cellCtrl.dispatchCellContextMenuEvent(touchEvent ?? null);
            this.beans.contextMenuSvc?.handleContextMenuMouseEvent(void 0, touchEvent, rowCtrl, cellCtrl);
        };
        this.mockContextMenu(ctrl, ctrl.element, listener);
    }
    handleCellDoubleClick(ctrl, mouseEvent) {
        const isDoubleClickOnIPad = ()=>{
            if (!$437b23f6a393c3bf$export$6b6034a68325bd8a() || $437b23f6a393c3bf$var$_isEventSupported("dblclick")) return false;
            const nowMillis = Date.now();
            const res = nowMillis - ctrl.lastIPadMouseClickEvent < 200;
            ctrl.lastIPadMouseClickEvent = nowMillis;
            return res;
        };
        if (isDoubleClickOnIPad()) {
            ctrl.onCellDoubleClicked(mouseEvent);
            mouseEvent.preventDefault();
            return true;
        }
        return false;
    }
    setupForHeader(comp) {
        const { gos: gos, sortSvc: sortSvc, menuSvc: menuSvc } = this.beans;
        if (gos.get("suppressTouch")) return;
        const { params: params, eMenu: eMenu, eFilterButton: eFilterButton } = comp;
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(comp.getGui(), true);
        const suppressMenuHide = comp.shouldSuppressMenuHide();
        const tapMenuButton = suppressMenuHide && $437b23f6a393c3bf$export$25d27f17d3af40f7(eMenu) && params.enableMenu;
        const menuTouchListener = tapMenuButton ? new $437b23f6a393c3bf$export$7b2e93987414b382(eMenu, true) : touchListener;
        if (params.enableMenu || menuSvc?.isHeaderContextMenuEnabled(params.column)) {
            const eventType = tapMenuButton ? "tap" : "longTap";
            const showMenuFn = (event)=>params.showColumnMenuAfterMouseClick(event.touchStart);
            comp.addManagedListeners(menuTouchListener, {
                [eventType]: showMenuFn
            });
        }
        if (params.enableSorting) {
            const tapListener = (event)=>{
                const target = event.touchStart.target;
                if (suppressMenuHide && (eMenu?.contains(target) || eFilterButton?.contains(target))) return;
                sortSvc?.progressSort(params.column, false, "uiColumnSorted");
            };
            comp.addManagedListeners(touchListener, {
                tap: tapListener
            });
        }
        if (params.enableFilterButton && eFilterButton) {
            const filterButtonTouchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(eFilterButton, true);
            comp.addManagedListeners(filterButtonTouchListener, {
                tap: ()=>params.showFilter(eFilterButton)
            });
            comp.addDestroyFunc(()=>filterButtonTouchListener.destroy());
        }
        comp.addDestroyFunc(()=>touchListener.destroy());
        if (tapMenuButton) comp.addDestroyFunc(()=>menuTouchListener.destroy());
    }
    setupForHeaderGroup(comp) {
        const params = comp.params;
        if (this.beans.menuSvc?.isHeaderContextMenuEnabled(params.columnGroup.getProvidedColumnGroup())) {
            const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(params.eGridHeader, true);
            const showMenuFn = (event)=>params.showColumnMenuAfterMouseClick(event.touchStart);
            comp.addManagedListeners(touchListener, {
                longTap: showMenuFn
            });
            comp.addDestroyFunc(()=>touchListener.destroy());
        }
    }
    setupForHeaderGroupElement(comp, eElement, action) {
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(eElement, true);
        comp.addManagedListeners(touchListener, {
            tap: action
        });
        comp.addDestroyFunc(()=>touchListener.destroy());
    }
    mockContextMenu(ctrl, element, listener) {
        if (!$437b23f6a393c3bf$export$6b6034a68325bd8a()) return;
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(element);
        const longTapListener = (event)=>{
            if (!$437b23f6a393c3bf$var$_isEventFromThisGrid(this.gos, event.touchEvent)) return;
            listener(void 0, event.touchStart, event.touchEvent);
        };
        ctrl.addManagedListeners(touchListener, {
            longTap: longTapListener
        });
        ctrl.addDestroyFunc(()=>touchListener.destroy());
    }
};
// packages/ag-grid-community/src/misc/touchModule.ts
var $437b23f6a393c3bf$var$TouchModule = {
    moduleName: "Touch",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$TouchService
    ]
};
// packages/ag-grid-community/src/navigation/cellNavigationService.ts
var $437b23f6a393c3bf$var$CellNavigationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "cellNavigation";
    }
    wireBeans(beans) {
        this.rowSpanSvc = beans.rowSpanSvc;
    }
    // returns null if no cell to focus on, ie at the end of the grid
    getNextCellToFocus(key, focusedCell, ctrlPressed = false) {
        if (ctrlPressed) return this.getNextCellToFocusWithCtrlPressed(key, focusedCell);
        return this.getNextCellToFocusWithoutCtrlPressed(key, focusedCell);
    }
    getNextCellToFocusWithCtrlPressed(key, focusedCell) {
        const upKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP;
        const downKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
        const leftKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT;
        let column;
        let rowIndex;
        const { pageBounds: pageBounds, gos: gos, visibleCols: visibleCols, pinnedRowModel: pinnedRowModel } = this.beans;
        const { rowPinned: rowPinned } = focusedCell;
        if (upKey || downKey) {
            if (rowPinned && pinnedRowModel) {
                if (upKey) rowIndex = 0;
                else rowIndex = rowPinned === "top" ? pinnedRowModel.getPinnedTopRowCount() - 1 : pinnedRowModel.getPinnedBottomRowCount() - 1;
            } else rowIndex = upKey ? pageBounds.getFirstRow() : pageBounds.getLastRow();
            column = focusedCell.column;
        } else {
            const isRtl = gos.get("enableRtl");
            rowIndex = focusedCell.rowIndex;
            const allColumns = leftKey !== isRtl ? visibleCols.allCols : [
                ...visibleCols.allCols
            ].reverse();
            column = allColumns.find((col)=>this.isCellGoodToFocusOn({
                    rowIndex: rowIndex,
                    rowPinned: null,
                    column: col
                }));
        }
        return column ? {
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            column: column
        } : null;
    }
    getNextCellToFocusWithoutCtrlPressed(key, focusedCell) {
        let pointer = focusedCell;
        let finished = false;
        while(!finished){
            switch(key){
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                    pointer = this.getCellAbove(pointer);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                    pointer = this.getCellBelow(pointer);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                    pointer = this.gos.get("enableRtl") ? this.getCellToLeft(pointer) : this.getCellToRight(pointer);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                    pointer = this.gos.get("enableRtl") ? this.getCellToRight(pointer) : this.getCellToLeft(pointer);
                    break;
                default:
                    pointer = null;
                    $437b23f6a393c3bf$export$545083624300f13d(8, {
                        key: key
                    });
                    break;
            }
            if (pointer) finished = this.isCellGoodToFocusOn(pointer);
            else finished = true;
        }
        return pointer;
    }
    isCellGoodToFocusOn(gridCell) {
        const column = gridCell.column;
        let rowNode;
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = this.beans;
        switch(gridCell.rowPinned){
            case "top":
                rowNode = pinnedRowModel?.getPinnedTopRow(gridCell.rowIndex);
                break;
            case "bottom":
                rowNode = pinnedRowModel?.getPinnedBottomRow(gridCell.rowIndex);
                break;
            default:
                rowNode = rowModel.getRow(gridCell.rowIndex);
                break;
        }
        if (!rowNode) return false;
        const suppressNavigable = this.isSuppressNavigable(column, rowNode);
        return !suppressNavigable;
    }
    getCellToLeft(lastCell) {
        if (!lastCell) return null;
        const colToLeft = this.beans.visibleCols.getColBefore(lastCell.column);
        if (!colToLeft) return null;
        return {
            rowIndex: lastCell.rowIndex,
            column: colToLeft,
            rowPinned: lastCell.rowPinned
        };
    }
    getCellToRight(lastCell) {
        if (!lastCell) return null;
        const colToRight = this.beans.visibleCols.getColAfter(lastCell.column);
        if (!colToRight) return null;
        return {
            rowIndex: lastCell.rowIndex,
            column: colToRight,
            rowPinned: lastCell.rowPinned
        };
    }
    getCellBelow(lastCell) {
        if (!lastCell) return null;
        const adjustedLastCell = this.rowSpanSvc?.getCellEnd(lastCell) ?? lastCell;
        const rowBelow = $437b23f6a393c3bf$export$3077f3bcabdc5ad1(this.beans, adjustedLastCell);
        if (rowBelow) return {
            rowIndex: rowBelow.rowIndex,
            column: lastCell.column,
            rowPinned: rowBelow.rowPinned
        };
        return null;
    }
    getCellAbove(lastCell) {
        if (!lastCell) return null;
        const adjustedLastCell = this.rowSpanSvc?.getCellStart(lastCell) ?? lastCell;
        const rowAbove = $437b23f6a393c3bf$export$b36b14fdaf41f4d8(this.beans, {
            rowIndex: adjustedLastCell.rowIndex,
            rowPinned: adjustedLastCell.rowPinned
        });
        if (rowAbove) return {
            rowIndex: rowAbove.rowIndex,
            column: lastCell.column,
            rowPinned: rowAbove.rowPinned
        };
        return null;
    }
    getNextTabbedCell(gridCell, backwards) {
        if (backwards) return this.getNextTabbedCellBackwards(gridCell);
        return this.getNextTabbedCellForwards(gridCell);
    }
    getNextTabbedCellForwards(gridCell) {
        const { visibleCols: visibleCols, pagination: pagination } = this.beans;
        const displayedColumns = visibleCols.allCols;
        let newRowIndex = gridCell.rowIndex;
        let newFloating = gridCell.rowPinned;
        let newColumn = visibleCols.getColAfter(gridCell.column);
        if (!newColumn) {
            newColumn = displayedColumns[0];
            const rowBelow = $437b23f6a393c3bf$export$3077f3bcabdc5ad1(this.beans, gridCell);
            if ($437b23f6a393c3bf$export$672d9e47bc342bac(rowBelow)) return null;
            if (!rowBelow.rowPinned && !(pagination?.isRowInPage(rowBelow.rowIndex) ?? true)) return null;
            newRowIndex = rowBelow ? rowBelow.rowIndex : null;
            newFloating = rowBelow ? rowBelow.rowPinned : null;
        }
        return {
            rowIndex: newRowIndex,
            column: newColumn,
            rowPinned: newFloating
        };
    }
    getNextTabbedCellBackwards(gridCell) {
        const { beans: beans } = this;
        const { visibleCols: visibleCols, pagination: pagination } = beans;
        const displayedColumns = visibleCols.allCols;
        let newRowIndex = gridCell.rowIndex;
        let newFloating = gridCell.rowPinned;
        let newColumn = visibleCols.getColBefore(gridCell.column);
        if (!newColumn) {
            newColumn = $437b23f6a393c3bf$export$236389741107357f(displayedColumns);
            const rowAbove = $437b23f6a393c3bf$export$b36b14fdaf41f4d8(beans, {
                rowIndex: gridCell.rowIndex,
                rowPinned: gridCell.rowPinned
            });
            if ($437b23f6a393c3bf$export$672d9e47bc342bac(rowAbove)) return null;
            if (!rowAbove.rowPinned && !(pagination?.isRowInPage(rowAbove.rowIndex) ?? true)) return null;
            newRowIndex = rowAbove ? rowAbove.rowIndex : null;
            newFloating = rowAbove ? rowAbove.rowPinned : null;
        }
        return {
            rowIndex: newRowIndex,
            column: newColumn,
            rowPinned: newFloating
        };
    }
    isSuppressNavigable(column, rowNode) {
        const { suppressNavigable: suppressNavigable } = column.colDef;
        if (typeof suppressNavigable === "boolean") return suppressNavigable;
        if (typeof suppressNavigable === "function") {
            const params = column.createColumnFunctionCallbackParams(rowNode);
            const userFunc = suppressNavigable;
            return userFunc(params);
        }
        return false;
    }
};
// packages/ag-grid-community/src/navigation/navigationApi.ts
function $437b23f6a393c3bf$var$getFocusedCell(beans) {
    return beans.focusSvc.getFocusedCell();
}
function $437b23f6a393c3bf$var$clearFocusedCell(beans) {
    return beans.focusSvc.clearFocusedCell();
}
function $437b23f6a393c3bf$var$setFocusedCell(beans, rowIndex, colKey, rowPinned) {
    beans.focusSvc.setFocusedCell({
        rowIndex: rowIndex,
        column: colKey,
        rowPinned: rowPinned,
        forceBrowserFocus: true
    });
}
function $437b23f6a393c3bf$var$tabToNextCell(beans, event) {
    return beans.navigation?.tabToNextCell(false, event) ?? false;
}
function $437b23f6a393c3bf$var$tabToPreviousCell(beans, event) {
    return beans.navigation?.tabToNextCell(true, event) ?? false;
}
function $437b23f6a393c3bf$var$setFocusedHeader(beans, colKey, floatingFilter = false) {
    const headerPosition = beans.headerNavigation?.getHeaderPositionForColumn(colKey, floatingFilter);
    if (!headerPosition) return;
    beans.focusSvc.focusHeaderPosition({
        headerPosition: headerPosition
    });
}
// packages/ag-grid-community/src/navigation/navigationService.ts
var $437b23f6a393c3bf$var$NavigationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super();
        this.beanName = "navigation";
        this.onPageDown = $437b23f6a393c3bf$var$_throttle(this.onPageDown, 100);
        this.onPageUp = $437b23f6a393c3bf$var$_throttle(this.onPageUp, 100);
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
    }
    handlePageScrollingKey(event, fromFullWidth = false) {
        const key = event.key;
        const alt = event.altKey;
        const ctrl = event.ctrlKey || event.metaKey;
        const rangeServiceShouldHandleShift = !!this.beans.rangeSvc && event.shiftKey;
        const currentCell = $437b23f6a393c3bf$export$d85fcb0e6e51242(this.gos, event);
        let processed = false;
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                if (!ctrl && !alt) {
                    this.onHomeOrEndKey(key);
                    processed = true;
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                if (!currentCell) return false;
                if (ctrl && !alt && !rangeServiceShouldHandleShift) {
                    this.onCtrlUpDownLeftRight(key, currentCell);
                    processed = true;
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
                if (!ctrl && !alt) processed = this.handlePageUpDown(key, currentCell, fromFullWidth);
                break;
        }
        if (processed) event.preventDefault();
        return processed;
    }
    handlePageUpDown(key, currentCell, fromFullWidth) {
        if (fromFullWidth) currentCell = this.beans.focusSvc.getFocusedCell();
        if (!currentCell) return false;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP) this.onPageUp(currentCell);
        else this.onPageDown(currentCell);
        return true;
    }
    navigateTo({ scrollIndex: scrollIndex, scrollType: scrollType, scrollColumn: scrollColumn, focusIndex: focusIndex, focusColumn: focusColumn, isAsync: isAsync, rowPinned: rowPinned }) {
        const { scrollFeature: scrollFeature } = this.gridBodyCon;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(scrollColumn) && !scrollColumn.isPinned()) scrollFeature.ensureColumnVisible(scrollColumn);
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(scrollIndex)) scrollFeature.ensureIndexVisible(scrollIndex, scrollType);
        if (!isAsync) scrollFeature.ensureIndexVisible(focusIndex);
        const { focusSvc: focusSvc, rangeSvc: rangeSvc } = this.beans;
        focusSvc.setFocusedCell({
            rowIndex: focusIndex,
            column: focusColumn,
            rowPinned: rowPinned,
            forceBrowserFocus: true
        });
        rangeSvc?.setRangeToCell({
            rowIndex: focusIndex,
            rowPinned: rowPinned,
            column: focusColumn
        });
    }
    // this method is throttled, see the `constructor`
    onPageDown(gridCell) {
        const beans = this.beans;
        const scrollPosition = $437b23f6a393c3bf$var$getVScroll(beans);
        const pixelsInOnePage = this.getViewportHeight();
        const { pageBounds: pageBounds, rowModel: rowModel, rowAutoHeight: rowAutoHeight } = beans;
        const pagingPixelOffset = pageBounds.getPixelOffset();
        const currentPageBottomPixel = scrollPosition.top + pixelsInOnePage;
        const currentPageBottomRow = rowModel.getRowIndexAtPixel(currentPageBottomPixel + pagingPixelOffset);
        if (rowAutoHeight?.active) this.navigateToNextPageWithAutoHeight(gridCell, currentPageBottomRow);
        else this.navigateToNextPage(gridCell, currentPageBottomRow);
    }
    // this method is throttled, see the `constructor`
    onPageUp(gridCell) {
        const beans = this.beans;
        const scrollPosition = $437b23f6a393c3bf$var$getVScroll(beans);
        const { pageBounds: pageBounds, rowModel: rowModel, rowAutoHeight: rowAutoHeight } = beans;
        const pagingPixelOffset = pageBounds.getPixelOffset();
        const currentPageTopPixel = scrollPosition.top;
        const currentPageTopRow = rowModel.getRowIndexAtPixel(currentPageTopPixel + pagingPixelOffset);
        if (rowAutoHeight?.active) this.navigateToNextPageWithAutoHeight(gridCell, currentPageTopRow, true);
        else this.navigateToNextPage(gridCell, currentPageTopRow, true);
    }
    navigateToNextPage(gridCell, scrollIndex, up = false) {
        const { pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const pixelsInOnePage = this.getViewportHeight();
        const firstRow = pageBounds.getFirstRow();
        const lastRow = pageBounds.getLastRow();
        const pagingPixelOffset = pageBounds.getPixelOffset();
        const currentRowNode = rowModel.getRow(gridCell.rowIndex);
        const rowPixelDiff = up ? // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
        currentRowNode?.rowHeight - pixelsInOnePage - pagingPixelOffset : pixelsInOnePage - pagingPixelOffset;
        const nextCellPixel = currentRowNode?.rowTop + rowPixelDiff;
        let focusIndex = rowModel.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);
        if (focusIndex === gridCell.rowIndex) {
            const diff = up ? -1 : 1;
            scrollIndex = focusIndex = gridCell.rowIndex + diff;
        }
        let scrollType;
        if (up) {
            scrollType = "bottom";
            if (focusIndex < firstRow) focusIndex = firstRow;
            if (scrollIndex < firstRow) scrollIndex = firstRow;
        } else {
            scrollType = "top";
            if (focusIndex > lastRow) focusIndex = lastRow;
            if (scrollIndex > lastRow) scrollIndex = lastRow;
        }
        if (this.isRowTallerThanView(rowModel.getRow(focusIndex))) {
            scrollIndex = focusIndex;
            scrollType = "top";
        }
        this.navigateTo({
            scrollIndex: scrollIndex,
            scrollType: scrollType,
            scrollColumn: null,
            focusIndex: focusIndex,
            focusColumn: gridCell.column
        });
    }
    navigateToNextPageWithAutoHeight(gridCell, scrollIndex, up = false) {
        this.navigateTo({
            scrollIndex: scrollIndex,
            scrollType: up ? "bottom" : "top",
            scrollColumn: null,
            focusIndex: scrollIndex,
            focusColumn: gridCell.column
        });
        setTimeout(()=>{
            const focusIndex = this.getNextFocusIndexForAutoHeight(gridCell, up);
            this.navigateTo({
                scrollIndex: scrollIndex,
                scrollType: up ? "bottom" : "top",
                scrollColumn: null,
                focusIndex: focusIndex,
                focusColumn: gridCell.column,
                isAsync: true
            });
        }, 50);
    }
    getNextFocusIndexForAutoHeight(gridCell, up = false) {
        const step = up ? -1 : 1;
        const pixelsInOnePage = this.getViewportHeight();
        const { pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const lastRowIndex = pageBounds.getLastRow();
        let pixelSum = 0;
        let currentIndex = gridCell.rowIndex;
        while(currentIndex >= 0 && currentIndex <= lastRowIndex){
            const currentCell = rowModel.getRow(currentIndex);
            if (currentCell) {
                const currentCellHeight = currentCell.rowHeight ?? 0;
                if (pixelSum + currentCellHeight > pixelsInOnePage) break;
                pixelSum += currentCellHeight;
            }
            currentIndex += step;
        }
        return Math.max(0, Math.min(currentIndex, lastRowIndex));
    }
    getViewportHeight() {
        const beans = this.beans;
        const scrollPosition = $437b23f6a393c3bf$var$getVScroll(beans);
        const scrollbarWidth = this.beans.scrollVisibleSvc.getScrollbarWidth();
        let pixelsInOnePage = scrollPosition.bottom - scrollPosition.top;
        if (beans.ctrlsSvc.get("center").isHorizontalScrollShowing()) pixelsInOnePage -= scrollbarWidth;
        return pixelsInOnePage;
    }
    isRowTallerThanView(rowNode) {
        if (!rowNode) return false;
        const rowHeight = rowNode.rowHeight;
        if (typeof rowHeight !== "number") return false;
        return rowHeight > this.getViewportHeight();
    }
    onCtrlUpDownLeftRight(key, gridCell) {
        const cellToFocus = this.beans.cellNavigation.getNextCellToFocus(key, gridCell, true);
        const { rowIndex: rowIndex, rowPinned: rowPinned } = cellToFocus;
        const column = cellToFocus.column;
        this.navigateTo({
            scrollIndex: rowIndex,
            scrollType: null,
            scrollColumn: column,
            focusIndex: rowIndex,
            focusColumn: column,
            rowPinned: rowPinned
        });
    }
    // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
    // same cell into view (which means either scroll all the way up, or all the way down).
    onHomeOrEndKey(key) {
        const homeKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME;
        const { visibleCols: visibleCols, pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const allColumns = visibleCols.allCols;
        const scrollIndex = homeKey ? pageBounds.getFirstRow() : pageBounds.getLastRow();
        const rowNode = rowModel.getRow(scrollIndex);
        if (!rowNode) return;
        const columnToSelect = (homeKey ? allColumns : [
            ...allColumns
        ].reverse()).find((col)=>!col.isSuppressNavigable(rowNode));
        if (!columnToSelect) return;
        this.navigateTo({
            scrollIndex: scrollIndex,
            scrollType: null,
            scrollColumn: columnToSelect,
            focusIndex: scrollIndex,
            focusColumn: columnToSelect
        });
    }
    // result of keyboard event
    onTabKeyDown(previous, keyboardEvent) {
        const backwards = keyboardEvent.shiftKey;
        const movedToNextCell = this.tabToNextCellCommon(previous, backwards, keyboardEvent);
        const beans = this.beans;
        const { ctrlsSvc: ctrlsSvc, pageBounds: pageBounds, focusSvc: focusSvc, gos: gos } = beans;
        if (movedToNextCell !== false) {
            if (movedToNextCell) keyboardEvent.preventDefault();
            else if (movedToNextCell === null) ctrlsSvc.get("gridCtrl").allowFocusForNextCoreContainer(backwards);
            return;
        }
        if (backwards) {
            const { rowIndex: rowIndex, rowPinned: rowPinned } = previous.getRowPosition();
            const firstRow = rowPinned ? rowIndex === 0 : rowIndex === pageBounds.getFirstRow();
            if (firstRow) {
                if (gos.get("headerHeight") === 0 || $437b23f6a393c3bf$var$_isHeaderFocusSuppressed(beans)) $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, true, true);
                else {
                    keyboardEvent.preventDefault();
                    focusSvc.focusPreviousFromFirstCell(keyboardEvent);
                }
            }
        } else {
            if (previous instanceof $437b23f6a393c3bf$var$CellCtrl) previous.focusCell(true);
            if (!backwards && focusSvc.focusOverlay(false) || $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, backwards)) keyboardEvent.preventDefault();
        }
    }
    // comes from API
    tabToNextCell(backwards, event) {
        const beans = this.beans;
        const { focusSvc: focusSvc, rowRenderer: rowRenderer } = beans;
        const focusedCell = focusSvc.getFocusedCell();
        if (!focusedCell) return false;
        let cellOrRow = $437b23f6a393c3bf$export$1bd7ce47360c3c0(beans, focusedCell);
        if (!cellOrRow) {
            cellOrRow = rowRenderer.getRowByPosition(focusedCell);
            if (!cellOrRow || !cellOrRow.isFullWidth()) return false;
        }
        return !!this.tabToNextCellCommon(cellOrRow, backwards, event, "api");
    }
    tabToNextCellCommon(previous, backwards, event, source = "ui") {
        const { editSvc: editSvc, focusSvc: focusSvc } = this.beans;
        let res = void 0;
        const cellCtrl = previous instanceof $437b23f6a393c3bf$var$CellCtrl ? previous : previous.getAllCellCtrls()?.[0];
        if (editSvc?.isEditing()) res = editSvc?.moveToNextCell(cellCtrl, backwards, event, source);
        else res = this.moveToNextCellNotEditing(previous, backwards, event);
        if (res === null) return res;
        return res || !!focusSvc.focusedHeader;
    }
    // returns null if no navigation should be performed
    moveToNextCellNotEditing(previousCell, backwards, event) {
        const displayedColumns = this.beans.visibleCols.allCols;
        let cellPos;
        if (previousCell instanceof $437b23f6a393c3bf$var$RowCtrl) {
            cellPos = {
                ...previousCell.getRowPosition(),
                column: backwards ? displayedColumns[0] : $437b23f6a393c3bf$export$236389741107357f(displayedColumns)
            };
            if (this.gos.get("embedFullWidthRows") && event) {
                const focusedContainer = previousCell.findFullWidthInfoForEvent(event);
                if (focusedContainer) cellPos.column = focusedContainer.column;
            }
        } else cellPos = previousCell.getFocusedCellPosition();
        const nextCell = this.findNextCellToFocusOn(cellPos, {
            backwards: backwards,
            startEditing: false
        });
        if (nextCell === false) return null;
        if (nextCell instanceof $437b23f6a393c3bf$var$CellCtrl) nextCell.focusCell(true);
        else if (nextCell) return this.tryToFocusFullWidthRow(nextCell, backwards);
        return $437b23f6a393c3bf$export$25d27f17d3af40f7(nextCell);
    }
    /**
   * called by the cell, when tab is pressed while editing.
   * @returns RenderedCell when navigation successful, false if navigation should not be performed, otherwise null
   */ findNextCellToFocusOn(previousPosition, { backwards: backwards, startEditing: startEditing, skipToNextEditableCell: skipToNextEditableCell }) {
        let nextPosition = previousPosition;
        const beans = this.beans;
        const { cellNavigation: cellNavigation, gos: gos, focusSvc: focusSvc, rowRenderer: rowRenderer, rangeSvc: rangeSvc } = beans;
        while(true){
            if (previousPosition !== nextPosition) previousPosition = nextPosition;
            if (!backwards) nextPosition = this.getLastCellOfColSpan(nextPosition);
            nextPosition = cellNavigation.getNextTabbedCell(nextPosition, backwards);
            const userFunc = gos.getCallback("tabToNextCell");
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(userFunc)) {
                const params = {
                    backwards: backwards,
                    editing: startEditing,
                    previousCellPosition: previousPosition,
                    nextCellPosition: nextPosition ? nextPosition : null
                };
                const userResult = userFunc(params);
                if (userResult === true) nextPosition = previousPosition;
                else if (userResult === false) return false;
                else nextPosition = {
                    rowIndex: userResult.rowIndex,
                    column: userResult.column,
                    rowPinned: userResult.rowPinned
                };
            }
            if (!nextPosition) return null;
            if (nextPosition.rowIndex < 0) {
                const headerLen = $437b23f6a393c3bf$var$getFocusHeaderRowCount(beans);
                focusSvc.focusHeaderPosition({
                    headerPosition: {
                        headerRowIndex: headerLen + nextPosition.rowIndex,
                        column: nextPosition.column
                    },
                    fromCell: true
                });
                return null;
            }
            const fullRowEdit = gos.get("editType") === "fullRow";
            if (startEditing && (!fullRowEdit || skipToNextEditableCell)) {
                const cellIsEditable = this.isCellEditable(nextPosition);
                if (!cellIsEditable) continue;
            }
            this.ensureCellVisible(nextPosition);
            const nextCell = $437b23f6a393c3bf$export$1bd7ce47360c3c0(beans, nextPosition);
            if (!nextCell) {
                const row = rowRenderer.getRowByPosition(nextPosition);
                if (!row || !row.isFullWidth() || startEditing) continue;
                return {
                    ...row.getRowPosition(),
                    column: nextPosition?.column
                };
            }
            if (cellNavigation.isSuppressNavigable(nextCell.column, nextCell.rowNode)) continue;
            nextCell.setFocusedCellPosition(nextPosition);
            rangeSvc?.setRangeToCell(nextPosition);
            return nextCell;
        }
    }
    isCellEditable(cell) {
        const rowNode = this.lookupRowNodeForCell(cell);
        if (rowNode) return cell.column.isCellEditable(rowNode);
        return false;
    }
    lookupRowNodeForCell({ rowIndex: rowIndex, rowPinned: rowPinned }) {
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = this.beans;
        if (rowPinned === "top") return pinnedRowModel?.getPinnedTopRow(rowIndex);
        if (rowPinned === "bottom") return pinnedRowModel?.getPinnedBottomRow(rowIndex);
        return rowModel.getRow(rowIndex);
    }
    // we use index for rows, but column object for columns, as the next column (by index) might not
    // be visible (header grouping) so it's not reliable, so using the column object instead.
    navigateToNextCell(event, key, currentCell, allowUserOverride) {
        let nextCell = currentCell;
        let hitEdgeOfGrid = false;
        const beans = this.beans;
        const { cellNavigation: cellNavigation, focusSvc: focusSvc, gos: gos } = beans;
        while(nextCell && (nextCell === currentCell || !this.isValidNavigateCell(nextCell))){
            if (gos.get("enableRtl")) {
                if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT) nextCell = this.getLastCellOfColSpan(nextCell);
            } else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT) nextCell = this.getLastCellOfColSpan(nextCell);
            nextCell = cellNavigation.getNextCellToFocus(key, nextCell);
            hitEdgeOfGrid = $437b23f6a393c3bf$export$672d9e47bc342bac(nextCell);
        }
        if (hitEdgeOfGrid && event && event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP) nextCell = {
            rowIndex: -1,
            rowPinned: null,
            column: currentCell.column
        };
        if (allowUserOverride) {
            const userFunc = gos.getCallback("navigateToNextCell");
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(userFunc)) {
                const params = {
                    key: key,
                    previousCellPosition: currentCell,
                    nextCellPosition: nextCell ? nextCell : null,
                    event: event
                };
                const userCell = userFunc(params);
                if ($437b23f6a393c3bf$export$25d27f17d3af40f7(userCell)) nextCell = {
                    rowPinned: userCell.rowPinned,
                    rowIndex: userCell.rowIndex,
                    column: userCell.column
                };
                else nextCell = null;
            }
        }
        if (!nextCell) return;
        if (nextCell.rowIndex < 0) {
            const headerLen = $437b23f6a393c3bf$var$getFocusHeaderRowCount(beans);
            focusSvc.focusHeaderPosition({
                headerPosition: {
                    headerRowIndex: headerLen + nextCell.rowIndex,
                    column: currentCell.column
                },
                event: event || void 0,
                fromCell: true
            });
            return;
        }
        const normalisedPosition = this.getNormalisedPosition(nextCell);
        if (normalisedPosition) this.focusPosition(normalisedPosition);
        else this.tryToFocusFullWidthRow(nextCell);
    }
    getNormalisedPosition(cellPosition) {
        const isSpannedCell = !!this.beans.spannedRowRenderer?.getCellByPosition(cellPosition);
        if (isSpannedCell) return cellPosition;
        this.ensureCellVisible(cellPosition);
        const cellCtrl = $437b23f6a393c3bf$export$1bd7ce47360c3c0(this.beans, cellPosition);
        if (!cellCtrl) return null;
        cellPosition = cellCtrl.getFocusedCellPosition();
        this.ensureCellVisible(cellPosition);
        return cellPosition;
    }
    tryToFocusFullWidthRow(position, backwards) {
        const { visibleCols: visibleCols, rowRenderer: rowRenderer, focusSvc: focusSvc, eventSvc: eventSvc } = this.beans;
        const displayedColumns = visibleCols.allCols;
        const rowComp = rowRenderer.getRowByPosition(position);
        if (!rowComp || !rowComp.isFullWidth()) return false;
        const currentCellFocused = focusSvc.getFocusedCell();
        const cellPosition = {
            rowIndex: position.rowIndex,
            rowPinned: position.rowPinned,
            column: position.column || (backwards ? $437b23f6a393c3bf$export$236389741107357f(displayedColumns) : displayedColumns[0])
        };
        this.focusPosition(cellPosition);
        const fromBelow = backwards == null ? currentCellFocused != null && $437b23f6a393c3bf$export$6cce97428a227a31(cellPosition, currentCellFocused) : backwards;
        eventSvc.dispatchEvent({
            type: "fullWidthRowFocused",
            rowIndex: cellPosition.rowIndex,
            rowPinned: cellPosition.rowPinned,
            column: cellPosition.column,
            isFullWidthCell: true,
            fromBelow: fromBelow
        });
        return true;
    }
    focusPosition(cellPosition) {
        const { focusSvc: focusSvc, rangeSvc: rangeSvc } = this.beans;
        focusSvc.setFocusedCell({
            rowIndex: cellPosition.rowIndex,
            column: cellPosition.column,
            rowPinned: cellPosition.rowPinned,
            forceBrowserFocus: true
        });
        rangeSvc?.setRangeToCell(cellPosition);
    }
    isValidNavigateCell(cell) {
        const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, cell);
        return !!rowNode;
    }
    getLastCellOfColSpan(cell) {
        const cellCtrl = $437b23f6a393c3bf$export$1bd7ce47360c3c0(this.beans, cell);
        if (!cellCtrl) return cell;
        const colSpanningList = cellCtrl.getColSpanningList();
        if (colSpanningList.length === 1) return cell;
        return {
            rowIndex: cell.rowIndex,
            column: $437b23f6a393c3bf$export$236389741107357f(colSpanningList),
            rowPinned: cell.rowPinned
        };
    }
    ensureCellVisible(gridCell) {
        const isGroupStickyEnabled = $437b23f6a393c3bf$export$d5f33aacea6a0849(this.gos);
        const rowNode = this.beans.rowModel.getRow(gridCell.rowIndex);
        const skipScrollToRow = isGroupStickyEnabled && rowNode?.sticky;
        const { scrollFeature: scrollFeature } = this.gridBodyCon;
        if (!skipScrollToRow && $437b23f6a393c3bf$export$672d9e47bc342bac(gridCell.rowPinned)) scrollFeature.ensureIndexVisible(gridCell.rowIndex);
        if (!gridCell.column.isPinned()) scrollFeature.ensureColumnVisible(gridCell.column);
    }
    ensureColumnVisible(column) {
        const scrollFeature = this.gridBodyCon.scrollFeature;
        if (!column.isPinned()) scrollFeature.ensureColumnVisible(column);
    }
    ensureRowVisible(rowIndex) {
        const scrollFeature = this.gridBodyCon.scrollFeature;
        scrollFeature.ensureIndexVisible(rowIndex);
    }
};
function $437b23f6a393c3bf$var$getVScroll(beans) {
    return beans.ctrlsSvc.getScrollFeature().getVScrollPosition();
}
// packages/ag-grid-community/src/navigation/navigationModule.ts
var $437b23f6a393c3bf$export$44f04c51d8088336 = {
    moduleName: "KeyboardNavigation",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$NavigationService,
        $437b23f6a393c3bf$var$CellNavigationService,
        $437b23f6a393c3bf$var$HeaderNavigationService
    ],
    apiFunctions: {
        getFocusedCell: $437b23f6a393c3bf$var$getFocusedCell,
        clearFocusedCell: $437b23f6a393c3bf$var$clearFocusedCell,
        setFocusedCell: $437b23f6a393c3bf$var$setFocusedCell,
        setFocusedHeader: $437b23f6a393c3bf$var$setFocusedHeader,
        tabToNextCell: $437b23f6a393c3bf$var$tabToNextCell,
        tabToPreviousCell: $437b23f6a393c3bf$var$tabToPreviousCell
    }
};
// packages/ag-grid-community/src/pagination/pageBoundsListener.ts
var $437b23f6a393c3bf$var$PageBoundsListener = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pageBoundsListener";
    }
    postConstruct() {
        this.addManagedEventListeners({
            modelUpdated: this.onModelUpdated.bind(this),
            recalculateRowBounds: this.calculatePages.bind(this)
        });
        this.onModelUpdated();
    }
    onModelUpdated(modelUpdatedEvent) {
        this.calculatePages();
        this.eventSvc.dispatchEvent({
            type: "paginationChanged",
            animate: modelUpdatedEvent?.animate ?? false,
            newData: modelUpdatedEvent?.newData ?? false,
            newPage: modelUpdatedEvent?.newPage ?? false,
            newPageSize: modelUpdatedEvent?.newPageSize ?? false,
            keepRenderedRows: modelUpdatedEvent?.keepRenderedRows ?? false
        });
    }
    calculatePages() {
        const { pageBounds: pageBounds, pagination: pagination, rowModel: rowModel } = this.beans;
        if (pagination) pagination.calculatePages();
        else pageBounds.calculateBounds(0, rowModel.getRowCount() - 1);
    }
};
// packages/ag-grid-community/src/pagination/pageBoundsService.ts
var $437b23f6a393c3bf$var$PageBoundsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pageBounds";
        this.pixelOffset = 0;
    }
    getFirstRow() {
        return this.topRowBounds?.rowIndex ?? -1;
    }
    getLastRow() {
        return this.bottomRowBounds?.rowIndex ?? -1;
    }
    getCurrentPageHeight() {
        const { topRowBounds: topRowBounds, bottomRowBounds: bottomRowBounds } = this;
        if (!topRowBounds || !bottomRowBounds) return 0;
        return Math.max(bottomRowBounds.rowTop + bottomRowBounds.rowHeight - topRowBounds.rowTop, 0);
    }
    getCurrentPagePixelRange() {
        const { topRowBounds: topRowBounds, bottomRowBounds: bottomRowBounds } = this;
        const pageFirstPixel = topRowBounds?.rowTop ?? 0;
        const pageLastPixel = bottomRowBounds ? bottomRowBounds.rowTop + bottomRowBounds.rowHeight : 0;
        return {
            pageFirstPixel: pageFirstPixel,
            pageLastPixel: pageLastPixel
        };
    }
    calculateBounds(topDisplayedRowIndex, bottomDisplayedRowIndex) {
        const { rowModel: rowModel } = this.beans;
        const topRowBounds = rowModel.getRowBounds(topDisplayedRowIndex);
        if (topRowBounds) topRowBounds.rowIndex = topDisplayedRowIndex;
        this.topRowBounds = topRowBounds;
        const bottomRowBounds = rowModel.getRowBounds(bottomDisplayedRowIndex);
        if (bottomRowBounds) bottomRowBounds.rowIndex = bottomDisplayedRowIndex;
        this.bottomRowBounds = bottomRowBounds;
        this.calculatePixelOffset();
    }
    getPixelOffset() {
        return this.pixelOffset;
    }
    calculatePixelOffset() {
        const value = this.topRowBounds?.rowTop ?? 0;
        if (this.pixelOffset === value) return;
        this.pixelOffset = value;
        this.eventSvc.dispatchEvent({
            type: "paginationPixelOffsetChanged"
        });
    }
};
// packages/ag-grid-community/src/pinnedColumns/pinnedColumnModule.css-GENERATED.ts
var $437b23f6a393c3bf$var$pinnedColumnModuleCSS = /*css*/ `.ag-pinned-left-floating-bottom,.ag-pinned-left-floating-top,.ag-pinned-right-floating-bottom,.ag-pinned-right-floating-top{min-width:0;overflow:hidden;position:relative}.ag-pinned-left-sticky-top,.ag-pinned-right-sticky-top{height:100%;overflow:hidden;position:relative}.ag-sticky-bottom-full-width-container,.ag-sticky-top-full-width-container{height:100%;overflow:hidden;width:100%}.ag-pinned-left-header,.ag-pinned-right-header{display:inline-block;height:100%;overflow:hidden;position:relative}.ag-body-horizontal-scroll:not(.ag-scrollbar-invisible){.ag-horizontal-left-spacer:not(.ag-scroller-corner){border-right:var(--ag-pinned-column-border)}.ag-horizontal-right-spacer:not(.ag-scroller-corner){border-left:var(--ag-pinned-column-border)}}.ag-pinned-right-header{border-left:var(--ag-pinned-column-border)}.ag-pinned-left-header{border-right:var(--ag-pinned-column-border)}.ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left,.ag-cell-range-single-cell,.ag-cell-focus:not(.ag-cell-range-selected):focus-within){border-left:var(--ag-pinned-column-border)}.ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right,.ag-cell-range-single-cell,.ag-cell-focus:not(.ag-cell-range-selected):focus-within){border-right:var(--ag-pinned-column-border)}.ag-pinned-left-header .ag-header-cell-resize:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}.ag-pinned-right-header .ag-header-cell-resize:after{left:50%}.ag-pinned-left-header .ag-header-cell-resize{right:-3px}.ag-pinned-right-header .ag-header-cell-resize{left:-3px}`;
// packages/ag-grid-community/src/gridBodyComp/rowContainer/setPinnedWidthFeature.ts
var $437b23f6a393c3bf$var$SetPinnedWidthFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(isLeft, elements){
        super();
        this.isLeft = isLeft;
        this.elements = elements;
        this.getWidth = isLeft ? ()=>this.beans.pinnedCols.leftWidth : ()=>this.beans.pinnedCols.rightWidth;
    }
    postConstruct() {
        this.addManagedEventListeners({
            [`${this.isLeft ? "left" : "right"}PinnedWidthChanged`]: this.onPinnedWidthChanged.bind(this)
        });
    }
    onPinnedWidthChanged() {
        const width = this.getWidth();
        const displayed = width > 0;
        for (const element of this.elements)if (element) {
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(element, displayed);
            $437b23f6a393c3bf$export$ce98ba7f5cfe7725(element, width);
        }
    }
};
// packages/ag-grid-community/src/pinnedColumns/pinnedColumnService.ts
var $437b23f6a393c3bf$var$PinnedColumnService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pinnedCols";
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
        });
        const listener = this.checkContainerWidths.bind(this);
        this.addManagedEventListeners({
            displayedColumnsChanged: listener,
            displayedColumnsWidthChanged: listener
        });
        this.addManagedPropertyListener("domLayout", listener);
    }
    checkContainerWidths() {
        const { gos: gos, visibleCols: visibleCols, eventSvc: eventSvc } = this.beans;
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print");
        const newLeftWidth = printLayout ? 0 : visibleCols.getColsLeftWidth();
        const newRightWidth = printLayout ? 0 : visibleCols.getDisplayedColumnsRightWidth();
        if (newLeftWidth != this.leftWidth) {
            this.leftWidth = newLeftWidth;
            eventSvc.dispatchEvent({
                type: "leftPinnedWidthChanged"
            });
        }
        if (newRightWidth != this.rightWidth) {
            this.rightWidth = newRightWidth;
            eventSvc.dispatchEvent({
                type: "rightPinnedWidthChanged"
            });
        }
    }
    keepPinnedColumnsNarrowerThanViewport() {
        const eBodyViewport = this.gridBodyCtrl.eBodyViewport;
        const bodyWidth = $437b23f6a393c3bf$export$cc615e4191ec3e0c(eBodyViewport);
        if (bodyWidth <= 50) return;
        const processedColumnsToRemove = this.getPinnedColumnsOverflowingViewport(bodyWidth - 50);
        const processUnpinnedColumns = this.gos.getCallback("processUnpinnedColumns");
        const { columns: columns, hasLockedPinned: hasLockedPinned } = processedColumnsToRemove;
        let columnsToRemove = columns;
        if (!columnsToRemove.length && !hasLockedPinned) return;
        if (processUnpinnedColumns) {
            const params = {
                columns: columnsToRemove,
                viewportWidth: bodyWidth
            };
            columnsToRemove = processUnpinnedColumns(params);
        }
        if (!columnsToRemove || !columnsToRemove.length) return;
        columnsToRemove = columnsToRemove.filter((col)=>!$437b23f6a393c3bf$export$3d3e7d751f0445eb(col));
        this.setColsPinned(columnsToRemove, null, "viewportSizeFeature");
    }
    createPinnedWidthFeature(isLeft, ...elements) {
        return new $437b23f6a393c3bf$var$SetPinnedWidthFeature(isLeft, elements);
    }
    setColsPinned(keys, pinned, source) {
        const { colModel: colModel, colAnimation: colAnimation, visibleCols: visibleCols, gos: gos } = this.beans;
        if (!colModel.cols) return;
        if (!keys?.length) return;
        if ($437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print")) {
            $437b23f6a393c3bf$export$545083624300f13d(37);
            return;
        }
        colAnimation?.start();
        let actualPinned;
        if (pinned === true || pinned === "left") actualPinned = "left";
        else if (pinned === "right") actualPinned = "right";
        else actualPinned = null;
        const updatedCols = [];
        keys.forEach((key)=>{
            if (!key) return;
            const column = colModel.getCol(key);
            if (!column) return;
            if (column.getPinned() !== actualPinned) {
                this.setColPinned(column, actualPinned);
                updatedCols.push(column);
            }
        });
        if (updatedCols.length) {
            visibleCols.refresh(source);
            $437b23f6a393c3bf$var$dispatchColumnPinnedEvent(this.eventSvc, updatedCols, source);
        }
        colAnimation?.finish();
    }
    initCol(column) {
        const { pinned: pinned, initialPinned: initialPinned } = column.colDef;
        if (pinned !== void 0) this.setColPinned(column, pinned);
        else this.setColPinned(column, initialPinned);
    }
    setColPinned(column, pinned) {
        if (pinned === true || pinned === "left") column.pinned = "left";
        else if (pinned === "right") column.pinned = "right";
        else column.pinned = null;
        column.dispatchStateUpdatedEvent("pinned");
    }
    setupHeaderPinnedWidth(ctrl) {
        const { scrollVisibleSvc: scrollVisibleSvc } = this.beans;
        if (ctrl.pinned == null) return;
        const pinningLeft = ctrl.pinned === "left";
        const pinningRight = ctrl.pinned === "right";
        ctrl.hidden = true;
        const listener = ()=>{
            const width = pinningLeft ? this.leftWidth : this.rightWidth;
            if (width == null) return;
            const hidden = width == 0;
            const hiddenChanged = ctrl.hidden !== hidden;
            const isRtl = this.gos.get("enableRtl");
            const scrollbarWidth = scrollVisibleSvc.getScrollbarWidth();
            const addPaddingForScrollbar = scrollVisibleSvc.verticalScrollShowing && (isRtl && pinningLeft || !isRtl && pinningRight);
            const widthWithPadding = addPaddingForScrollbar ? width + scrollbarWidth : width;
            ctrl.comp.setPinnedContainerWidth(`${widthWithPadding}px`);
            ctrl.comp.setDisplayed(!hidden);
            if (hiddenChanged) {
                ctrl.hidden = hidden;
                ctrl.refresh();
            }
        };
        ctrl.addManagedEventListeners({
            leftPinnedWidthChanged: listener,
            rightPinnedWidthChanged: listener,
            scrollVisibilityChanged: listener,
            scrollbarWidthChanged: listener
        });
    }
    getHeaderResizeDiff(diff, column) {
        const pinned = column.getPinned();
        if (pinned) {
            const { leftWidth: leftWidth, rightWidth: rightWidth } = this;
            const bodyWidth = $437b23f6a393c3bf$export$cc615e4191ec3e0c(this.beans.ctrlsSvc.getGridBodyCtrl().eBodyViewport) - 50;
            if (leftWidth + rightWidth + diff > bodyWidth) {
                if (bodyWidth > leftWidth + rightWidth) diff = bodyWidth - leftWidth - rightWidth;
                else return 0;
            }
        }
        return diff;
    }
    getPinnedColumnsOverflowingViewport(viewportWidth) {
        const pinnedRightWidth = this.rightWidth ?? 0;
        const pinnedLeftWidth = this.leftWidth ?? 0;
        const totalPinnedWidth = pinnedRightWidth + pinnedLeftWidth;
        let hasLockedPinned = false;
        if (totalPinnedWidth < viewportWidth) return {
            columns: [],
            hasLockedPinned: hasLockedPinned
        };
        const { visibleCols: visibleCols } = this.beans;
        const pinnedLeftColumns = [
            ...visibleCols.leftCols
        ];
        const pinnedRightColumns = [
            ...visibleCols.rightCols
        ];
        let indexRight = 0;
        let indexLeft = 0;
        const totalWidthRemoved = 0;
        const columnsToRemove = [];
        let spaceNecessary = totalPinnedWidth - totalWidthRemoved - viewportWidth;
        while((indexLeft < pinnedLeftColumns.length || indexRight < pinnedRightColumns.length) && spaceNecessary > 0){
            if (indexRight < pinnedRightColumns.length) {
                const currentColumn = pinnedRightColumns[indexRight++];
                if (currentColumn.colDef.lockPinned) {
                    hasLockedPinned = true;
                    continue;
                }
                spaceNecessary -= currentColumn.getActualWidth();
                columnsToRemove.push(currentColumn);
            }
            if (indexLeft < pinnedLeftColumns.length && spaceNecessary > 0) {
                const currentColumn = pinnedLeftColumns[indexLeft++];
                if (currentColumn.colDef.lockPinned) {
                    hasLockedPinned = true;
                    continue;
                }
                spaceNecessary -= currentColumn.getActualWidth();
                columnsToRemove.push(currentColumn);
            }
        }
        return {
            columns: columnsToRemove,
            hasLockedPinned: hasLockedPinned
        };
    }
};
// packages/ag-grid-community/src/pinnedColumns/pinnedColumnModule.ts
var $437b23f6a393c3bf$var$PinnedColumnModule = {
    moduleName: "PinnedColumn",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$PinnedColumnService
    ],
    css: [
        $437b23f6a393c3bf$var$pinnedColumnModuleCSS
    ]
};
// packages/ag-grid-community/src/rendering/ariaAnnouncementService.ts
var $437b23f6a393c3bf$var$AriaAnnouncementService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super();
        this.beanName = "ariaAnnounce";
        this.descriptionContainer = null;
        this.pendingAnnouncements = /* @__PURE__ */ new Map();
        this.lastAnnouncement = "";
        this.updateAnnouncement = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.updateAnnouncement.bind(this), 200);
    }
    postConstruct() {
        const beans = this.beans;
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
        const div = this.descriptionContainer = eDocument.createElement("div");
        div.classList.add("ag-aria-description-container");
        $437b23f6a393c3bf$var$_setAriaLive(div, "polite");
        $437b23f6a393c3bf$var$_setAriaRelevant(div, "additions text");
        $437b23f6a393c3bf$var$_setAriaAtomic(div, true);
        beans.eGridDiv.appendChild(div);
    }
    /**
   * @param key used for debouncing calls
   */ announceValue(value, key) {
        this.pendingAnnouncements.set(key, value);
        this.updateAnnouncement();
    }
    updateAnnouncement() {
        if (!this.descriptionContainer) return;
        const value = Array.from(this.pendingAnnouncements.values()).join(". ");
        this.pendingAnnouncements.clear();
        this.descriptionContainer.textContent = "";
        setTimeout(()=>{
            this.handleAnnouncementUpdate(value);
        }, 50);
    }
    handleAnnouncementUpdate(value) {
        if (!this.isAlive() || !this.descriptionContainer) return;
        let valueToAnnounce = value;
        if (valueToAnnounce == null || valueToAnnounce.replace(/[ .]/g, "") == "") {
            this.lastAnnouncement = "";
            return;
        }
        if (this.lastAnnouncement === valueToAnnounce) valueToAnnounce = `${valueToAnnounce}\u200B`;
        this.lastAnnouncement = valueToAnnounce;
        this.descriptionContainer.textContent = valueToAnnounce;
    }
    destroy() {
        super.destroy();
        const { descriptionContainer: descriptionContainer } = this;
        if (descriptionContainer) {
            $437b23f6a393c3bf$export$69e6e10709eabd91(descriptionContainer);
            descriptionContainer.parentElement?.removeChild(descriptionContainer);
        }
        this.descriptionContainer = null;
        this.pendingAnnouncements.clear();
    }
};
// packages/ag-grid-community/src/rendering/ariaModule.ts
var $437b23f6a393c3bf$var$AriaModule = {
    moduleName: "Aria",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AriaAnnouncementService
    ]
};
// packages/ag-grid-community/src/rendering/overlays/overlayApi.ts
function $437b23f6a393c3bf$var$showLoadingOverlay(beans) {
    beans.overlays?.showLoadingOverlay();
}
function $437b23f6a393c3bf$var$showNoRowsOverlay(beans) {
    beans.overlays?.showNoRowsOverlay();
}
function $437b23f6a393c3bf$var$hideOverlay(beans) {
    beans.overlays?.hideOverlay();
}
// packages/ag-grid-community/src/rendering/overlays/overlayWrapperComponent.css-GENERATED.ts
var $437b23f6a393c3bf$var$overlayWrapperComponentCSS = /*css*/ `.ag-overlay{inset:0;pointer-events:none;position:absolute;z-index:2}.ag-overlay-panel,.ag-overlay-wrapper{display:flex;height:100%;width:100%}.ag-overlay-wrapper{align-items:center;flex:none;justify-content:center;text-align:center}.ag-overlay-loading-wrapper{pointer-events:all}.ag-overlay-loading-center{background:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-popup-shadow);padding:var(--ag-spacing)}`;
// packages/ag-grid-community/src/rendering/overlays/overlayWrapperComponent.ts
var $437b23f6a393c3bf$var$OverlayWrapperElement = {
    tag: "div",
    cls: "ag-overlay",
    role: "presentation",
    children: [
        {
            tag: "div",
            cls: "ag-overlay-panel",
            role: "presentation",
            children: [
                {
                    tag: "div",
                    ref: "eOverlayWrapper",
                    cls: "ag-overlay-wrapper",
                    role: "presentation"
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$var$OverlayWrapperComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$OverlayWrapperElement);
        this.eOverlayWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.activePromise = null;
        this.activeOverlay = null;
        this.updateListenerDestroyFunc = null;
        this.activeCssClass = null;
        this.elToFocusAfter = null;
        this.registerCSS($437b23f6a393c3bf$var$overlayWrapperComponentCSS);
    }
    handleKeyDown(e) {
        if (e.key !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB || e.defaultPrevented || $437b23f6a393c3bf$export$9a48e23524c6d58(e)) return;
        const beans = this.beans;
        const nextEl = $437b23f6a393c3bf$export$83fc12531358bd28(beans, this.eOverlayWrapper, false, e.shiftKey);
        if (nextEl) return;
        let isFocused = false;
        if (e.shiftKey) isFocused = beans.focusSvc.focusGridView({
            column: $437b23f6a393c3bf$export$236389741107357f(beans.visibleCols.allCols),
            backwards: true,
            canFocusOverlay: false
        });
        else isFocused = $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, false);
        if (isFocused) e.preventDefault();
    }
    updateLayoutClasses(cssClass, params) {
        const overlayWrapperClassList = this.eOverlayWrapper.classList;
        const { AUTO_HEIGHT: AUTO_HEIGHT, NORMAL: NORMAL, PRINT: PRINT } = $437b23f6a393c3bf$var$LayoutCssClasses;
        overlayWrapperClassList.toggle(AUTO_HEIGHT, params.autoHeight);
        overlayWrapperClassList.toggle(NORMAL, params.normal);
        overlayWrapperClassList.toggle(PRINT, params.print);
    }
    postConstruct() {
        this.createManagedBean(new $437b23f6a393c3bf$var$LayoutFeature(this));
        this.setDisplayed(false, {
            skipAriaHidden: true
        });
        this.beans.overlays.setOverlayWrapperComp(this);
        this.addManagedElementListeners(this.getFocusableElement(), {
            keydown: this.handleKeyDown.bind(this)
        });
    }
    setWrapperTypeClass(overlayWrapperCssClass) {
        const overlayWrapperClassList = this.eOverlayWrapper.classList;
        if (this.activeCssClass) overlayWrapperClassList.toggle(this.activeCssClass, false);
        this.activeCssClass = overlayWrapperCssClass;
        overlayWrapperClassList.toggle(overlayWrapperCssClass, true);
    }
    showOverlay(overlayComponentPromise, overlayWrapperCssClass, exclusive, gridOption) {
        this.setWrapperTypeClass(overlayWrapperCssClass);
        this.destroyActiveOverlay();
        this.elToFocusAfter = null;
        this.activePromise = overlayComponentPromise;
        if (!overlayComponentPromise) return;
        this.setDisplayed(true, {
            skipAriaHidden: true
        });
        if (exclusive && this.isGridFocused()) {
            const activeElement = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
            if (activeElement && !$437b23f6a393c3bf$export$8ff9eef09a45371f(this.beans)) this.elToFocusAfter = activeElement;
        }
        overlayComponentPromise.then((comp)=>{
            if (this.activePromise !== overlayComponentPromise) {
                if (this.activeOverlay !== comp) {
                    this.destroyBean(comp);
                    comp = null;
                }
                return;
            }
            this.activePromise = null;
            if (!comp) return;
            if (this.activeOverlay !== comp) {
                this.eOverlayWrapper.appendChild(comp.getGui());
                this.activeOverlay = comp;
                if (gridOption) {
                    const component = comp;
                    this.updateListenerDestroyFunc = this.addManagedPropertyListener(gridOption, ({ currentValue: currentValue })=>{
                        component.refresh?.($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                            ...currentValue ?? {}
                        }));
                    });
                }
            }
            if (exclusive && this.isGridFocused()) $437b23f6a393c3bf$export$8598088d375f416f(this.eOverlayWrapper);
        });
    }
    updateOverlayWrapperPaddingTop(padding) {
        this.eOverlayWrapper.style.setProperty("padding-top", `${padding}px`);
    }
    destroyActiveOverlay() {
        this.activePromise = null;
        const activeOverlay = this.activeOverlay;
        if (!activeOverlay) return;
        let elementToFocus = this.elToFocusAfter;
        this.activeOverlay = null;
        this.elToFocusAfter = null;
        if (elementToFocus && !this.isGridFocused()) elementToFocus = null;
        const updateListenerDestroyFunc = this.updateListenerDestroyFunc;
        if (updateListenerDestroyFunc) {
            updateListenerDestroyFunc();
            this.updateListenerDestroyFunc = null;
        }
        this.destroyBean(activeOverlay);
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.eOverlayWrapper);
        elementToFocus?.focus?.({
            preventScroll: true
        });
    }
    hideOverlay() {
        this.destroyActiveOverlay();
        this.setDisplayed(false, {
            skipAriaHidden: true
        });
    }
    isGridFocused() {
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        return !!activeEl && this.beans.eGridDiv.contains(activeEl);
    }
    destroy() {
        this.elToFocusAfter = null;
        this.destroyActiveOverlay();
        this.beans.overlays.setOverlayWrapperComp(void 0);
        super.destroy();
    }
};
var $437b23f6a393c3bf$var$OverlayWrapperSelector = {
    selector: "AG-OVERLAY-WRAPPER",
    component: $437b23f6a393c3bf$var$OverlayWrapperComponent
};
// packages/ag-grid-community/src/rendering/overlays/overlayService.ts
var $437b23f6a393c3bf$var$OverlayService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "overlays";
        this.state = 0 /* Hidden */ ;
        this.showInitialOverlay = true;
        this.wrapperPadding = 0;
    }
    postConstruct() {
        this.isClientSide = $437b23f6a393c3bf$export$9f182d9ca737e15(this.gos);
        this.isServerSide = !this.isClientSide && $437b23f6a393c3bf$export$cf1bac0013650216(this.gos);
        const updateOverlayVisibility = ()=>this.updateOverlayVisibility();
        this.addManagedEventListeners({
            newColumnsLoaded: updateOverlayVisibility,
            rowDataUpdated: updateOverlayVisibility,
            gridSizeChanged: this.refreshWrapperPadding.bind(this),
            rowCountReady: ()=>{
                this.showInitialOverlay = false;
                this.updateOverlayVisibility();
            }
        });
        this.addManagedPropertyListener("loading", updateOverlayVisibility);
    }
    setOverlayWrapperComp(overlayWrapperComp) {
        this.eWrapper = overlayWrapperComp;
        this.updateOverlayVisibility();
    }
    /** Returns true if the overlay is visible. */ isVisible() {
        return this.state !== 0 /* Hidden */  && !!this.eWrapper;
    }
    /** Returns true if the overlay is visible and is exclusive (popup over the grid) */ isExclusive() {
        return this.state === 1 /* Loading */  && !!this.eWrapper;
    }
    showLoadingOverlay() {
        this.showInitialOverlay = false;
        const gos = this.gos;
        const loading = gos.get("loading");
        if (!loading && (loading !== void 0 || gos.get("suppressLoadingOverlay"))) return;
        this.doShowLoadingOverlay();
    }
    showNoRowsOverlay() {
        this.showInitialOverlay = false;
        const gos = this.gos;
        if (gos.get("loading") || gos.get("suppressNoRowsOverlay")) return;
        this.doShowNoRowsOverlay();
    }
    hideOverlay() {
        this.showInitialOverlay = false;
        if (this.gos.get("loading")) {
            $437b23f6a393c3bf$export$545083624300f13d(99);
            return;
        }
        this.doHideOverlay();
    }
    getOverlayWrapperSelector() {
        return $437b23f6a393c3bf$var$OverlayWrapperSelector;
    }
    getOverlayWrapperCompClass() {
        return $437b23f6a393c3bf$var$OverlayWrapperComponent;
    }
    updateOverlayVisibility() {
        if (!this.eWrapper) {
            this.state = 0 /* Hidden */ ;
            return;
        }
        const { state: state, isClientSide: isClientSide, isServerSide: isServerSide, beans: { gos: gos, colModel: colModel, rowModel: rowModel } } = this;
        let loading = this.gos.get("loading");
        if (loading !== void 0) this.showInitialOverlay = false;
        if (this.showInitialOverlay && loading === void 0 && !gos.get("suppressLoadingOverlay")) loading = !gos.get("columnDefs") || !colModel.ready || !gos.get("rowData") && isClientSide;
        if (loading) {
            if (state !== 1 /* Loading */ ) this.doShowLoadingOverlay();
        } else {
            this.showInitialOverlay = false;
            if (isClientSide && rowModel.isEmpty() && !gos.get("suppressNoRowsOverlay")) {
                if (state !== 2 /* NoRows */ ) this.doShowNoRowsOverlay();
            } else if (state === 1 /* Loading */  || !isServerSide && state !== 0 /* Hidden */ ) this.doHideOverlay();
        }
    }
    doShowLoadingOverlay() {
        if (!this.eWrapper) return;
        this.state = 1 /* Loading */ ;
        this.showOverlay($437b23f6a393c3bf$var$_getLoadingOverlayCompDetails(this.beans.userCompFactory, $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {})), "ag-overlay-loading-wrapper", "loadingOverlayComponentParams");
        this.updateExclusive();
    }
    doShowNoRowsOverlay() {
        if (!this.eWrapper) return;
        this.state = 2 /* NoRows */ ;
        this.showOverlay($437b23f6a393c3bf$var$_getNoRowsOverlayCompDetails(this.beans.userCompFactory, $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {})), "ag-overlay-no-rows-wrapper", "noRowsOverlayComponentParams");
        this.updateExclusive();
    }
    doHideOverlay() {
        if (!this.eWrapper) return;
        this.state = 0 /* Hidden */ ;
        this.eWrapper.hideOverlay();
        this.updateExclusive();
    }
    showOverlay(compDetails, wrapperCssClass, gridOption) {
        const promise = compDetails?.newAgStackInstance() ?? null;
        this.eWrapper?.showOverlay(promise, wrapperCssClass, this.isExclusive(), gridOption);
        this.refreshWrapperPadding();
    }
    updateExclusive() {
        const wasExclusive = this.exclusive;
        this.exclusive = this.isExclusive();
        if (this.exclusive !== wasExclusive) this.eventSvc.dispatchEvent({
            type: "overlayExclusiveChanged"
        });
    }
    refreshWrapperPadding() {
        const eWrapper = this.eWrapper;
        if (!eWrapper) return;
        let newPadding = 0;
        if (this.state === 2 /* NoRows */ ) {
            const headerCtrl = this.beans.ctrlsSvc.get("gridHeaderCtrl");
            const headerHeight = headerCtrl?.headerHeight || 0;
            newPadding = headerHeight;
        } else if (this.wrapperPadding !== 0) newPadding = 0;
        if (this.wrapperPadding === newPadding) return;
        this.wrapperPadding = newPadding;
        eWrapper.updateOverlayWrapperPaddingTop(newPadding);
    }
};
// packages/ag-grid-community/src/rendering/overlays/overlayModule.ts
var $437b23f6a393c3bf$var$OverlayModule = {
    moduleName: "Overlay",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agLoadingOverlay: $437b23f6a393c3bf$var$LoadingOverlayComponent2,
        agNoRowsOverlay: $437b23f6a393c3bf$var$NoRowsOverlayComponent2
    },
    apiFunctions: {
        showLoadingOverlay: $437b23f6a393c3bf$var$showLoadingOverlay,
        showNoRowsOverlay: $437b23f6a393c3bf$var$showNoRowsOverlay,
        hideOverlay: $437b23f6a393c3bf$var$hideOverlay
    },
    beans: [
        $437b23f6a393c3bf$var$OverlayService
    ]
};
// packages/ag-grid-community/src/rendering/rowContainerHeightService.ts
var $437b23f6a393c3bf$var$RowContainerHeightService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowContainerHeight";
        // the scrollY position
        this.scrollY = 0;
        // how tall the body is
        this.uiBodyHeight = 0;
    }
    postConstruct() {
        this.addManagedEventListeners({
            bodyHeightChanged: this.updateOffset.bind(this)
        });
        this.maxDivHeight = $437b23f6a393c3bf$var$_getMaxDivHeight();
        $437b23f6a393c3bf$var$_logIfDebug(this.gos, "RowContainerHeightService - maxDivHeight = " + this.maxDivHeight);
    }
    updateOffset() {
        if (!this.stretching) return;
        const newScrollY = this.beans.ctrlsSvc.getScrollFeature().getVScrollPosition().top;
        const newBodyHeight = this.getUiBodyHeight();
        const atLeastOneChanged = newScrollY !== this.scrollY || newBodyHeight !== this.uiBodyHeight;
        if (atLeastOneChanged) {
            this.scrollY = newScrollY;
            this.uiBodyHeight = newBodyHeight;
            this.calculateOffset();
        }
    }
    calculateOffset() {
        this.setUiContainerHeight(this.maxDivHeight);
        this.pixelsToShave = this.modelHeight - this.uiContainerHeight;
        this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
        const scrollPercent = this.scrollY / this.maxScrollY;
        const divStretchOffset = scrollPercent * this.pixelsToShave;
        $437b23f6a393c3bf$var$_logIfDebug(this.gos, `RowContainerHeightService - Div Stretch Offset = ${divStretchOffset} (${this.pixelsToShave} * ${scrollPercent})`);
        this.setDivStretchOffset(divStretchOffset);
    }
    setUiContainerHeight(height) {
        if (height !== this.uiContainerHeight) {
            this.uiContainerHeight = height;
            this.eventSvc.dispatchEvent({
                type: "rowContainerHeightChanged"
            });
        }
    }
    clearOffset() {
        this.setUiContainerHeight(this.modelHeight);
        this.pixelsToShave = 0;
        this.setDivStretchOffset(0);
    }
    setDivStretchOffset(newOffset) {
        const newOffsetFloor = typeof newOffset === "number" ? Math.floor(newOffset) : null;
        if (this.divStretchOffset === newOffsetFloor) return;
        this.divStretchOffset = newOffsetFloor;
        this.eventSvc.dispatchEvent({
            type: "heightScaleChanged"
        });
    }
    setModelHeight(modelHeight) {
        this.modelHeight = modelHeight;
        this.stretching = modelHeight != null && // null happens when in print layout
        this.maxDivHeight > 0 && modelHeight > this.maxDivHeight;
        if (this.stretching) this.calculateOffset();
        else this.clearOffset();
    }
    getRealPixelPosition(modelPixel) {
        return modelPixel - this.divStretchOffset;
    }
    getUiBodyHeight() {
        const pos = this.beans.ctrlsSvc.getScrollFeature().getVScrollPosition();
        return pos.bottom - pos.top;
    }
    getScrollPositionForPixel(rowTop) {
        if (this.pixelsToShave <= 0) return rowTop;
        const modelMaxScroll = this.modelHeight - this.getUiBodyHeight();
        const scrollPercent = rowTop / modelMaxScroll;
        const scrollPixel = this.maxScrollY * scrollPercent;
        return scrollPixel;
    }
};
// packages/ag-grid-community/src/rendering/rowRenderer.ts
var $437b23f6a393c3bf$var$ROW_ANIMATION_TIMEOUT = 400;
var $437b23f6a393c3bf$var$RowRenderer = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowRenderer";
        this.destroyFuncsForColumnListeners = [];
        // map of row ids to row objects. keeps track of which elements
        // are rendered for which rows in the dom.
        this.rowCtrlsByRowIndex = {};
        this.zombieRowCtrls = {};
        this.allRowCtrls = [];
        this.topRowCtrls = [];
        this.bottomRowCtrls = [];
        // we only allow one refresh at a time, otherwise the internal memory structure here
        // will get messed up. this can happen if the user has a cellRenderer, and inside the
        // renderer they call an API method that results in another pass of the refresh,
        // then it will be trying to draw rows in the middle of a refresh.
        this.refreshInProgress = false;
        this.dataFirstRenderedFired = false;
        this.setupRangeSelectionListeners = ()=>{
            const onCellSelectionChanged = ()=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onCellSelectionChanged());
            };
            const onColumnMovedPinnedVisible = ()=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.updateRangeBordersIfRangeCount());
            };
            const addCellSelectionListeners = ()=>{
                this.eventSvc.addEventListener("cellSelectionChanged", onCellSelectionChanged);
                this.eventSvc.addEventListener("columnMoved", onColumnMovedPinnedVisible);
                this.eventSvc.addEventListener("columnPinned", onColumnMovedPinnedVisible);
                this.eventSvc.addEventListener("columnVisible", onColumnMovedPinnedVisible);
            };
            const removeCellSelectionListeners = ()=>{
                this.eventSvc.removeEventListener("cellSelectionChanged", onCellSelectionChanged);
                this.eventSvc.removeEventListener("columnMoved", onColumnMovedPinnedVisible);
                this.eventSvc.removeEventListener("columnPinned", onColumnMovedPinnedVisible);
                this.eventSvc.removeEventListener("columnVisible", onColumnMovedPinnedVisible);
            };
            this.addDestroyFunc(()=>removeCellSelectionListeners());
            this.addManagedPropertyListeners([
                "enableRangeSelection",
                "cellSelection"
            ], ()=>{
                const isEnabled = $437b23f6a393c3bf$export$1f7ca6920544d9e4(this.gos);
                if (isEnabled) addCellSelectionListeners();
                else removeCellSelectionListeners();
            });
            const cellSelectionEnabled = $437b23f6a393c3bf$export$1f7ca6920544d9e4(this.gos);
            if (cellSelectionEnabled) addCellSelectionListeners();
        };
    }
    wireBeans(beans) {
        this.pageBounds = beans.pageBounds;
        this.colModel = beans.colModel;
        this.pinnedRowModel = beans.pinnedRowModel;
        this.rowModel = beans.rowModel;
        this.focusSvc = beans.focusSvc;
        this.rowContainerHeight = beans.rowContainerHeight;
        this.ctrlsSvc = beans.ctrlsSvc;
        this.editSvc = beans.editSvc;
    }
    postConstruct() {
        this.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
            this.initialise();
        });
    }
    initialise() {
        this.addManagedEventListeners({
            paginationChanged: this.onPageLoaded.bind(this),
            pinnedRowDataChanged: this.onPinnedRowDataChanged.bind(this),
            pinnedRowsChanged: this.onPinnedRowsChanged.bind(this),
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
            bodyScroll: this.onBodyScroll.bind(this),
            bodyHeightChanged: this.redraw.bind(this, {})
        });
        this.addManagedPropertyListeners([
            "domLayout",
            "embedFullWidthRows"
        ], ()=>this.onDomLayoutChanged());
        this.addManagedPropertyListeners([
            "suppressMaxRenderedRowRestriction",
            "rowBuffer"
        ], ()=>this.redraw());
        this.addManagedPropertyListener("suppressCellFocus", (e)=>this.onSuppressCellFocusChanged(e.currentValue));
        this.addManagedPropertyListeners([
            "groupSuppressBlankHeader",
            "getBusinessKeyForNode",
            "fullWidthCellRenderer",
            "fullWidthCellRendererParams",
            "suppressStickyTotalRow",
            "groupRowRenderer",
            "groupRowRendererParams",
            // maybe only needs to refresh FW rows...
            "loadingCellRenderer",
            "loadingCellRendererParams",
            "detailCellRenderer",
            "detailCellRendererParams",
            "enableRangeSelection",
            "enableCellTextSelection"
        ], ()=>this.redrawRows());
        this.addManagedPropertyListener("cellSelection", ({ currentValue: currentValue, previousValue: previousValue })=>{
            if (!previousValue && currentValue || previousValue && !currentValue) this.redrawRows();
        });
        const { stickyRowSvc: stickyRowSvc, gos: gos, showRowGroupCols: showRowGroupCols } = this.beans;
        if (showRowGroupCols) this.addManagedPropertyListener("showOpenedGroup", ()=>{
            const columns = showRowGroupCols.getShowRowGroupCols();
            if (columns.length) this.refreshCells({
                columns: columns,
                force: true
            });
        });
        if (stickyRowSvc) this.stickyRowFeature = stickyRowSvc.createStickyRowFeature(this, this.createRowCon.bind(this), this.destroyRowCtrls.bind(this));
        else {
            const gridBodyCtrl = this.gridBodyCtrl;
            gridBodyCtrl.setStickyTopHeight(0);
            gridBodyCtrl.setStickyBottomHeight(0);
        }
        this.registerCellEventListeners();
        this.initialiseCache();
        this.printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print");
        this.embedFullWidthRows = this.printLayout || gos.get("embedFullWidthRows");
        this.redrawAfterModelUpdate();
    }
    initialiseCache() {
        if (this.gos.get("keepDetailRows")) {
            const countProp = this.getKeepDetailRowsCount();
            const count = countProp != null ? countProp : 3;
            this.cachedRowCtrls = new $437b23f6a393c3bf$var$RowCtrlCache(count);
        }
    }
    getKeepDetailRowsCount() {
        return this.gos.get("keepDetailRowsCount");
    }
    getStickyTopRowCtrls() {
        return this.stickyRowFeature?.stickyTopRowCtrls ?? [];
    }
    getStickyBottomRowCtrls() {
        return this.stickyRowFeature?.stickyBottomRowCtrls ?? [];
    }
    updateAllRowCtrls() {
        const liveList = Object.values(this.rowCtrlsByRowIndex);
        const zombieList = Object.values(this.zombieRowCtrls);
        const cachedList = this.cachedRowCtrls?.getEntries() ?? [];
        if (zombieList.length > 0 || cachedList.length > 0) this.allRowCtrls = [
            ...liveList,
            ...zombieList,
            ...cachedList
        ];
        else this.allRowCtrls = liveList;
    }
    /**
   * Checks if the cell is rendered or not. Also returns true if row ctrl is present but has not rendered
   * cells yet.
   * @returns true if cellCtrl is present, or if the row is present but has not rendered rows yet
   */ isCellBeingRendered(rowIndex, column) {
        const rowCtrl = this.rowCtrlsByRowIndex[rowIndex];
        if (!column || !rowCtrl) return !!rowCtrl;
        if (rowCtrl.isFullWidth()) return true;
        const spannedCell = this.beans.spannedRowRenderer?.getCellByPosition({
            rowIndex: rowIndex,
            column: column,
            rowPinned: null
        });
        return !!spannedCell || !!rowCtrl.getCellCtrl(column) || !rowCtrl.isRowRendered();
    }
    /**
   * Notifies all row and cell controls of any change in focused cell.
   * @param event cell focused event
   */ updateCellFocus(event) {
        this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onCellFocused(event));
        this.getFullWidthRowCtrls().forEach((rowCtrl)=>rowCtrl.onFullWidthRowFocused(event));
    }
    /**
   * Called when a new cell is focused in the grid
   * - if the focused cell isn't rendered; re-draw rows to dry to render it
   * - subsequently updates all cell and row controls with the new focused cell
   * @param event cell focused event
   */ onCellFocusChanged(event) {
        if (event && event.rowIndex != null && !event.rowPinned) {
            const col = this.beans.colModel.getCol(event.column) ?? void 0;
            if (!this.isCellBeingRendered(event.rowIndex, col)) this.redraw();
        }
        this.updateCellFocus(event);
    }
    onSuppressCellFocusChanged(suppressCellFocus) {
        this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onSuppressCellFocusChanged(suppressCellFocus));
        this.getFullWidthRowCtrls().forEach((rowCtrl)=>rowCtrl.onSuppressCellFocusChanged(suppressCellFocus));
    }
    // in a clean design, each cell would register for each of these events. however when scrolling, all the cells
    // registering and de-registering for events is a performance bottleneck. so we register here once and inform
    // all active cells.
    registerCellEventListeners() {
        this.addManagedEventListeners({
            cellFocused: (event)=>this.onCellFocusChanged(event),
            cellFocusCleared: ()=>this.updateCellFocus(),
            flashCells: (event)=>{
                const { cellFlashSvc: cellFlashSvc } = this.beans;
                if (cellFlashSvc) this.getAllCellCtrls().forEach((cellCtrl)=>cellFlashSvc.onFlashCells(cellCtrl, event));
            },
            columnHoverChanged: ()=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onColumnHover());
            },
            displayedColumnsChanged: ()=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onDisplayedColumnsChanged());
            },
            displayedColumnsWidthChanged: ()=>{
                if (this.printLayout) this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onLeftChanged());
            }
        });
        this.setupRangeSelectionListeners();
        this.refreshListenersToColumnsForCellComps();
        this.addManagedEventListeners({
            gridColumnsChanged: this.refreshListenersToColumnsForCellComps.bind(this)
        });
        this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
    }
    // executes all functions in destroyFuncsForColumnListeners and then clears the list
    removeGridColumnListeners() {
        this.destroyFuncsForColumnListeners.forEach((func)=>func());
        this.destroyFuncsForColumnListeners.length = 0;
    }
    // this function adds listeners onto all the grid columns, which are the column that we could have cellComps for.
    // when the grid columns change, we add listeners again. in an ideal design, each CellComp would just register to
    // the column it belongs to on creation, however this was a bottleneck with the number of cells, so do it here
    // once instead.
    refreshListenersToColumnsForCellComps() {
        this.removeGridColumnListeners();
        const cols = this.colModel.getCols();
        cols.forEach((col)=>{
            const forEachCellWithThisCol = (callback)=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>{
                    if (cellCtrl.column === col) callback(cellCtrl);
                });
            };
            const leftChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onLeftChanged());
            };
            const widthChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onWidthChanged());
            };
            const firstRightPinnedChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onFirstRightPinnedChanged());
            };
            const lastLeftPinnedChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onLastLeftPinnedChanged());
            };
            const colDefChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onColDefChanged());
            };
            col.__addEventListener("leftChanged", leftChangedListener);
            col.__addEventListener("widthChanged", widthChangedListener);
            col.__addEventListener("firstRightPinnedChanged", firstRightPinnedChangedListener);
            col.__addEventListener("lastLeftPinnedChanged", lastLeftPinnedChangedListener);
            col.__addEventListener("colDefChanged", colDefChangedListener);
            this.destroyFuncsForColumnListeners.push(()=>{
                col.__removeEventListener("leftChanged", leftChangedListener);
                col.__removeEventListener("widthChanged", widthChangedListener);
                col.__removeEventListener("firstRightPinnedChanged", firstRightPinnedChangedListener);
                col.__removeEventListener("lastLeftPinnedChanged", lastLeftPinnedChangedListener);
                col.__removeEventListener("colDefChanged", colDefChangedListener);
            });
        });
    }
    onDomLayoutChanged() {
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        const embedFullWidthRows = printLayout || this.gos.get("embedFullWidthRows");
        const destroyRows = embedFullWidthRows !== this.embedFullWidthRows || this.printLayout !== printLayout;
        this.printLayout = printLayout;
        this.embedFullWidthRows = embedFullWidthRows;
        if (destroyRows) this.redrawAfterModelUpdate({
            domLayoutChanged: true
        });
    }
    // for row models that have datasources, when we update the datasource, we need to force the rowRenderer
    // to redraw all rows. otherwise the old rows from the old datasource will stay displayed.
    datasourceChanged() {
        this.firstRenderedRow = 0;
        this.lastRenderedRow = -1;
        const rowIndexesToRemove = Object.keys(this.rowCtrlsByRowIndex);
        this.removeRowCtrls(rowIndexesToRemove);
    }
    onPageLoaded(event) {
        const params = {
            recycleRows: event.keepRenderedRows,
            animate: event.animate,
            newData: event.newData,
            newPage: event.newPage,
            // because this is a model updated event (not pinned rows), we
            // can skip updating the pinned rows. this is needed so that if user
            // is doing transaction updates, the pinned rows are not getting constantly
            // trashed - or editing cells in pinned rows are not refreshed and put into read mode
            onlyBody: true
        };
        this.redrawAfterModelUpdate(params);
    }
    /**
   * @param column AgColumn
   * @returns An array with HTMLElement for every cell of the column passed as param.
   * If the cell is spanning across multiple columns, it only returns the html element
   * if the column passed is the first column of the span (used for auto width calculation).
   */ getAllCellsNotSpanningForColumn(column) {
        const res = [];
        this.getAllRowCtrls().forEach((rowCtrl)=>{
            const eCell = rowCtrl.getCellCtrl(column, true)?.eGui;
            if (eCell) res.push(eCell);
        });
        return res;
    }
    refreshFloatingRowComps(recycleRows = true) {
        this.refreshFloatingRows(this.topRowCtrls, "top", recycleRows);
        this.refreshFloatingRows(this.bottomRowCtrls, "bottom", recycleRows);
    }
    /**
   * Determines which row controllers need to be destroyed and re-created vs which ones can
   * be re-used.
   *
   * This is operation is to pinned/floating rows as `this.recycleRows` is to normal/body rows.
   *
   * All `RowCtrl` instances in `rowCtrls` that don't correspond to `RowNode` instances in `rowNodes` are destroyed.
   * All `RowNode` instances in `rowNodes` that don't correspond to `RowCtrl` instances in `rowCtrls` are created.
   * All instances in `rowCtrls` must be in the same order as their corresponding nodes in `rowNodes`.
   *
   * @param rowCtrls The list of existing row controllers
   * @param rowNodes The canonical list of row nodes that should have associated controllers
   */ refreshFloatingRows(rowCtrls, floating, recycleRows) {
        const { pinnedRowModel: pinnedRowModel, beans: beans, printLayout: printLayout } = this;
        const rowCtrlMap = Object.fromEntries(rowCtrls.map((ctrl)=>[
                ctrl.rowNode.id,
                ctrl
            ]));
        pinnedRowModel?.forEachPinnedRow(floating, (node, i)=>{
            const rowCtrl = rowCtrls[i];
            const rowCtrlDoesNotExist = rowCtrl && pinnedRowModel.getPinnedRowById(rowCtrl.rowNode.id, floating) === void 0;
            if (rowCtrlDoesNotExist) {
                rowCtrl.destroyFirstPass();
                rowCtrl.destroySecondPass();
            }
            if (node.id in rowCtrlMap && recycleRows) {
                rowCtrls[i] = rowCtrlMap[node.id];
                delete rowCtrlMap[node.id];
            } else rowCtrls[i] = new $437b23f6a393c3bf$var$RowCtrl(node, beans, false, false, printLayout);
        });
        const rowNodeCount = (floating === "top" ? pinnedRowModel?.getPinnedTopRowCount() : pinnedRowModel?.getPinnedBottomRowCount()) ?? 0;
        rowCtrls.length = rowNodeCount;
    }
    onPinnedRowDataChanged() {
        const params = {
            recycleRows: true
        };
        this.redrawAfterModelUpdate(params);
    }
    onPinnedRowsChanged() {
        this.redrawAfterModelUpdate({
            recycleRows: true
        });
    }
    redrawRow(rowNode, suppressEvent = false) {
        if (rowNode.sticky) this.stickyRowFeature?.refreshStickyNode(rowNode);
        else if (this.cachedRowCtrls?.has(rowNode)) {
            this.cachedRowCtrls.removeRow(rowNode);
            return;
        } else {
            const destroyAndRecreateCtrl = (dataStruct)=>{
                const ctrl = dataStruct[rowNode.rowIndex];
                if (!ctrl) return;
                if (ctrl.rowNode !== rowNode) return;
                ctrl.destroyFirstPass();
                ctrl.destroySecondPass();
                dataStruct[rowNode.rowIndex] = this.createRowCon(rowNode, false, false);
            };
            switch(rowNode.rowPinned){
                case "top":
                    destroyAndRecreateCtrl(this.topRowCtrls);
                    break;
                case "bottom":
                    destroyAndRecreateCtrl(this.bottomRowCtrls);
                    break;
                default:
                    destroyAndRecreateCtrl(this.rowCtrlsByRowIndex);
                    this.updateAllRowCtrls();
            }
        }
        if (!suppressEvent) this.dispatchDisplayedRowsChanged(false);
    }
    redrawRows(rowNodes) {
        const { editSvc: editSvc } = this.beans;
        if (editSvc?.isEditing()) {
            if (editSvc.isBatchEditing()) editSvc.cleanupEditors();
            else editSvc.stopEditing(void 0, {
                source: "api"
            });
        }
        const partialRefresh = rowNodes != null;
        if (partialRefresh) {
            rowNodes?.forEach((node)=>this.redrawRow(node, true));
            this.dispatchDisplayedRowsChanged(false);
            return;
        }
        this.redrawAfterModelUpdate();
    }
    // gets called from:
    // +) initialisation (in registerGridComp) params = null
    // +) onDomLayoutChanged, params = null
    // +) onPageLoaded, recycleRows, animate, newData, newPage from event, onlyBody=true
    // +) onPinnedRowDataChanged, recycleRows = true
    // +) redrawRows (from Grid API), recycleRows = true/false
    redrawAfterModelUpdate(params = {}) {
        this.getLockOnRefresh();
        const focusedCell = this.beans.focusSvc?.getFocusCellToUseAfterRefresh();
        this.updateContainerHeights();
        this.scrollToTopIfNewData(params);
        const recycleRows = !params.domLayoutChanged && !!params.recycleRows;
        const animate = params.animate && $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos);
        const rowsToRecycle = recycleRows ? this.getRowsToRecycle() : null;
        if (!recycleRows) this.removeAllRowComps();
        this.workOutFirstAndLastRowsToRender();
        const { stickyRowFeature: stickyRowFeature, gos: gos } = this;
        if (stickyRowFeature) {
            stickyRowFeature.checkStickyRows();
            const extraHeight = stickyRowFeature.extraTopHeight + stickyRowFeature.extraBottomHeight;
            if (extraHeight) this.updateContainerHeights(extraHeight);
        }
        this.recycleRows(rowsToRecycle, animate);
        this.gridBodyCtrl.updateRowCount();
        if (!params.onlyBody) this.refreshFloatingRowComps(gos.get("enableRowPinning") ? recycleRows : void 0);
        this.dispatchDisplayedRowsChanged();
        if (focusedCell != null) this.restoreFocusedCell(focusedCell);
        this.releaseLockOnRefresh();
    }
    scrollToTopIfNewData(params) {
        const scrollToTop = params.newData || params.newPage;
        const suppressScrollToTop = this.gos.get("suppressScrollOnNewData");
        if (scrollToTop && !suppressScrollToTop) {
            this.gridBodyCtrl.scrollFeature.scrollToTop();
            this.stickyRowFeature?.resetOffsets();
        }
    }
    updateContainerHeights(additionalHeight = 0) {
        const { rowContainerHeight: rowContainerHeight } = this;
        if (this.printLayout) {
            rowContainerHeight.setModelHeight(null);
            return;
        }
        let containerHeight = this.pageBounds.getCurrentPageHeight();
        if (containerHeight === 0) containerHeight = 1;
        rowContainerHeight.setModelHeight(containerHeight + additionalHeight);
    }
    getLockOnRefresh() {
        if (this.refreshInProgress) throw new Error($437b23f6a393c3bf$export$680bb5102fca525e(252));
        this.refreshInProgress = true;
        this.beans.frameworkOverrides.getLockOnRefresh?.();
    }
    releaseLockOnRefresh() {
        this.refreshInProgress = false;
        this.beans.frameworkOverrides.releaseLockOnRefresh?.();
    }
    isRefreshInProgress() {
        return this.refreshInProgress;
    }
    // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
    // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
    // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
    // edited cell).
    restoreFocusedCell(cellPosition) {
        if (!cellPosition) return;
        const focusSvc = this.beans.focusSvc;
        const cellToFocus = this.findPositionToFocus(cellPosition);
        if (!cellToFocus) {
            focusSvc.focusHeaderPosition({
                headerPosition: {
                    headerRowIndex: $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans) - 1,
                    column: cellPosition.column
                }
            });
            return;
        }
        if (cellPosition.rowIndex !== cellToFocus.rowIndex || cellPosition.rowPinned != cellToFocus.rowPinned) {
            focusSvc.setFocusedCell({
                ...cellToFocus,
                preventScrollOnBrowserFocus: true,
                forceBrowserFocus: true
            });
            return;
        }
        if (!focusSvc.doesRowOrCellHaveBrowserFocus()) this.updateCellFocus($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            ...cellToFocus,
            forceBrowserFocus: true,
            preventScrollOnBrowserFocus: true,
            type: "cellFocused"
        }));
    }
    findPositionToFocus(cellPosition) {
        const { pagination: pagination, pageBounds: pageBounds } = this.beans;
        let rowPosition = cellPosition;
        if (rowPosition.rowPinned == null && pagination && pageBounds && !pagination.isRowInPage(rowPosition.rowIndex)) rowPosition = {
            rowPinned: null,
            rowIndex: pageBounds.getFirstRow()
        };
        while(rowPosition){
            if (rowPosition.rowPinned == null && pageBounds) {
                if (rowPosition.rowIndex < pageBounds.getFirstRow()) {
                    rowPosition = $437b23f6a393c3bf$export$b36b14fdaf41f4d8(this.beans, {
                        rowPinned: null,
                        rowIndex: 0
                    });
                    if (!rowPosition) return null;
                } else if (rowPosition.rowIndex > pageBounds.getLastRow()) rowPosition = {
                    rowPinned: null,
                    rowIndex: pageBounds.getLastRow()
                };
            }
            const row = this.getRowByPosition(rowPosition);
            if (row?.isAlive()) return {
                ...row.getRowPosition(),
                column: cellPosition.column
            };
            rowPosition = $437b23f6a393c3bf$export$b36b14fdaf41f4d8(this.beans, rowPosition);
        }
        return null;
    }
    getAllCellCtrls() {
        const res = [];
        const rowCtrls = this.getAllRowCtrls();
        const rowCtrlsLength = rowCtrls.length;
        for(let i = 0; i < rowCtrlsLength; i++){
            const cellCtrls = rowCtrls[i].getAllCellCtrls();
            const cellCtrlsLength = cellCtrls.length;
            for(let j = 0; j < cellCtrlsLength; j++)res.push(cellCtrls[j]);
        }
        return res;
    }
    getAllRowCtrls() {
        const { spannedRowRenderer: spannedRowRenderer } = this.beans;
        const stickyTopRowCtrls = this.getStickyTopRowCtrls();
        const stickyBottomRowCtrls = this.getStickyBottomRowCtrls();
        const res = [
            ...this.topRowCtrls,
            ...this.bottomRowCtrls,
            ...stickyTopRowCtrls,
            ...stickyBottomRowCtrls,
            ...spannedRowRenderer?.getCtrls("top") ?? [],
            ...spannedRowRenderer?.getCtrls("bottom") ?? [],
            ...spannedRowRenderer?.getCtrls("center") ?? [],
            ...Object.values(this.rowCtrlsByRowIndex)
        ];
        return res;
    }
    addRenderedRowListener(eventName, rowIndex, callback) {
        const rowComp = this.rowCtrlsByRowIndex[rowIndex];
        if (rowComp) rowComp.addEventListener(eventName, callback);
    }
    refreshCells({ rowNodes: rowNodes, columns: columns, force: force, suppressFlash: suppressFlash } = {}) {
        const refreshCellParams = {
            force: force,
            newData: false,
            suppressFlash: suppressFlash
        };
        for (const cellCtrl of this.getCellCtrls(rowNodes, columns))cellCtrl.refreshOrDestroyCell(refreshCellParams);
        this.refreshFullWidth(rowNodes);
    }
    refreshRows(params = {}) {
        this.getRowCtrls(params.rowNodes).forEach((rowCtrl)=>rowCtrl.refreshRow(params));
        this.refreshFullWidth(params.rowNodes);
    }
    refreshFullWidth(rowNodes) {
        if (!rowNodes) return;
        let rowRedrawn = false;
        for (const rowCtrl of this.getRowCtrls(rowNodes)){
            if (!rowCtrl.isFullWidth()) continue;
            const refreshed = rowCtrl.refreshFullWidth();
            if (!refreshed) {
                rowRedrawn = true;
                this.redrawRow(rowCtrl.rowNode, true);
            }
        }
        if (rowRedrawn) this.dispatchDisplayedRowsChanged(false);
    }
    /**
   * @param rowNodes if provided, returns the RowCtrls for the provided rowNodes. otherwise returns all RowCtrls.
   */ getRowCtrls(rowNodes) {
        const rowIdsMap = $437b23f6a393c3bf$var$mapRowNodes(rowNodes);
        const allRowCtrls = this.getAllRowCtrls();
        if (!rowNodes || !rowIdsMap) return allRowCtrls;
        return allRowCtrls.filter((rowCtrl)=>{
            const rowNode = rowCtrl.rowNode;
            return $437b23f6a393c3bf$var$isRowInMap(rowNode, rowIdsMap);
        });
    }
    // returns CellCtrl's that match the provided rowNodes and columns. eg if one row node
    // and two columns provided, that identifies 4 cells, so 4 CellCtrl's returned.
    getCellCtrls(rowNodes, columns) {
        let colIdsMap;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(columns)) {
            colIdsMap = {};
            columns.forEach((colKey)=>{
                const column = this.colModel.getCol(colKey);
                if ($437b23f6a393c3bf$export$25d27f17d3af40f7(column)) colIdsMap[column.getId()] = true;
            });
        }
        const res = [];
        this.getRowCtrls(rowNodes).forEach((rowCtrl)=>{
            rowCtrl.getAllCellCtrls().forEach((cellCtrl)=>{
                const colId = cellCtrl.column.getId();
                const excludeColFromRefresh = colIdsMap && !colIdsMap[colId];
                if (excludeColFromRefresh) return;
                res.push(cellCtrl);
            });
        });
        return res;
    }
    destroy() {
        this.removeAllRowComps(true);
        super.destroy();
    }
    removeAllRowComps(suppressAnimation = false) {
        const rowIndexesToRemove = Object.keys(this.rowCtrlsByRowIndex);
        this.removeRowCtrls(rowIndexesToRemove, suppressAnimation);
        this.stickyRowFeature?.destroyStickyCtrls();
    }
    getRowsToRecycle() {
        const stubNodeIndexes = [];
        for (const index of Object.keys(this.rowCtrlsByRowIndex)){
            const rowCtrl = this.rowCtrlsByRowIndex[index];
            const stubNode = rowCtrl.rowNode.id == null;
            if (stubNode) stubNodeIndexes.push(index);
        }
        this.removeRowCtrls(stubNodeIndexes);
        const ctrlsByIdMap = {};
        for (const rowCtrl of Object.values(this.rowCtrlsByRowIndex)){
            const rowNode = rowCtrl.rowNode;
            ctrlsByIdMap[rowNode.id] = rowCtrl;
        }
        this.rowCtrlsByRowIndex = {};
        return ctrlsByIdMap;
    }
    // takes array of row indexes
    removeRowCtrls(rowsToRemove, suppressAnimation = false) {
        rowsToRemove.forEach((indexToRemove)=>{
            const rowCtrl = this.rowCtrlsByRowIndex[indexToRemove];
            if (rowCtrl) {
                rowCtrl.destroyFirstPass(suppressAnimation);
                rowCtrl.destroySecondPass();
            }
            delete this.rowCtrlsByRowIndex[indexToRemove];
        });
    }
    onBodyScroll(e) {
        if (e.direction !== "vertical") return;
        this.redraw({
            afterScroll: true
        });
    }
    // gets called when rows don't change, but viewport does, so after:
    // 1) height of grid body changes, ie number of displayed rows has changed
    // 2) grid scrolled to new position
    // 3) ensure index visible (which is a scroll)
    redraw(params = {}) {
        const { focusSvc: focusSvc, animationFrameSvc: animationFrameSvc } = this.beans;
        const { afterScroll: afterScroll } = params;
        let cellFocused;
        const stickyRowFeature = this.stickyRowFeature;
        if (stickyRowFeature) cellFocused = focusSvc?.getFocusCellToUseAfterRefresh() || void 0;
        const oldFirstRow = this.firstRenderedRow;
        const oldLastRow = this.lastRenderedRow;
        this.workOutFirstAndLastRowsToRender();
        let hasStickyRowChanges = false;
        if (stickyRowFeature) {
            hasStickyRowChanges = stickyRowFeature.checkStickyRows();
            const extraHeight = stickyRowFeature.extraTopHeight + stickyRowFeature.extraBottomHeight;
            if (extraHeight) this.updateContainerHeights(extraHeight);
        }
        const rangeChanged = this.firstRenderedRow !== oldFirstRow || this.lastRenderedRow !== oldLastRow;
        if (afterScroll && !hasStickyRowChanges && !rangeChanged) return;
        this.getLockOnRefresh();
        this.recycleRows(null, false, afterScroll);
        this.releaseLockOnRefresh();
        this.dispatchDisplayedRowsChanged(afterScroll && !hasStickyRowChanges);
        if (cellFocused != null) {
            const newFocusedCell = focusSvc?.getFocusCellToUseAfterRefresh();
            if (cellFocused != null && newFocusedCell == null) {
                animationFrameSvc?.flushAllFrames();
                this.restoreFocusedCell(cellFocused);
            }
        }
    }
    removeRowCompsNotToDraw(indexesToDraw, suppressAnimation) {
        const indexesToDrawMap = {};
        indexesToDraw.forEach((index)=>indexesToDrawMap[index] = true);
        const existingIndexes = Object.keys(this.rowCtrlsByRowIndex);
        const indexesNotToDraw = existingIndexes.filter((index)=>!indexesToDrawMap[index]);
        this.removeRowCtrls(indexesNotToDraw, suppressAnimation);
    }
    calculateIndexesToDraw(rowsToRecycle) {
        const indexesToDraw = [];
        for(let i = this.firstRenderedRow; i <= this.lastRenderedRow; i++)indexesToDraw.push(i);
        const pagination = this.beans.pagination;
        const focusedRowIndex = this.beans.focusSvc?.getFocusedCell()?.rowIndex;
        if (focusedRowIndex != null && (focusedRowIndex < this.firstRenderedRow || focusedRowIndex > this.lastRenderedRow) && (!pagination || pagination.isRowInPage(focusedRowIndex)) && focusedRowIndex < this.rowModel.getRowCount()) indexesToDraw.push(focusedRowIndex);
        const checkRowToDraw = (rowComp)=>{
            const index = rowComp.rowNode.rowIndex;
            if (index == null || index === focusedRowIndex) return;
            if (index < this.firstRenderedRow || index > this.lastRenderedRow) {
                if (this.doNotUnVirtualiseRow(rowComp)) indexesToDraw.push(index);
            }
        };
        for (const rowCtrl of Object.values(this.rowCtrlsByRowIndex))checkRowToDraw(rowCtrl);
        if (rowsToRecycle) for (const rowCtrl of Object.values(rowsToRecycle))checkRowToDraw(rowCtrl);
        indexesToDraw.sort((a, b)=>a - b);
        const ret = [];
        for(let i = 0; i < indexesToDraw.length; i++){
            const currRow = indexesToDraw[i];
            const rowNode = this.rowModel.getRow(currRow);
            if (rowNode && !rowNode.sticky) ret.push(currRow);
        }
        return ret;
    }
    recycleRows(rowsToRecycle, animate = false, afterScroll = false) {
        const indexesToDraw = this.calculateIndexesToDraw(rowsToRecycle);
        if (this.printLayout || afterScroll) animate = false;
        this.removeRowCompsNotToDraw(indexesToDraw, !animate);
        const rowCtrls = [];
        indexesToDraw.forEach((rowIndex)=>{
            const rowCtrl = this.createOrUpdateRowCtrl(rowIndex, rowsToRecycle, animate, afterScroll);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(rowCtrl)) rowCtrls.push(rowCtrl);
        });
        if (rowsToRecycle) {
            const { animationFrameSvc: animationFrameSvc } = this.beans;
            const useAnimationFrame = animationFrameSvc?.active && afterScroll && !this.printLayout;
            if (useAnimationFrame) animationFrameSvc.addDestroyTask(()=>{
                this.destroyRowCtrls(rowsToRecycle, animate);
                this.updateAllRowCtrls();
                this.dispatchDisplayedRowsChanged();
            });
            else this.destroyRowCtrls(rowsToRecycle, animate);
        }
        this.updateAllRowCtrls();
    }
    dispatchDisplayedRowsChanged(afterScroll = false) {
        this.eventSvc.dispatchEvent({
            type: "displayedRowsChanged",
            afterScroll: afterScroll
        });
    }
    onDisplayedColumnsChanged() {
        const { visibleCols: visibleCols } = this.beans;
        const pinningLeft = visibleCols.isPinningLeft();
        const pinningRight = visibleCols.isPinningRight();
        const atLeastOneChanged = this.pinningLeft !== pinningLeft || pinningRight !== this.pinningRight;
        if (atLeastOneChanged) {
            this.pinningLeft = pinningLeft;
            this.pinningRight = pinningRight;
            if (this.embedFullWidthRows) this.redrawFullWidthEmbeddedRows();
        }
    }
    // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
    // then it should go into the pinned left area if pinning left, or the center area if not pinning.
    redrawFullWidthEmbeddedRows() {
        const rowsToRemove = [];
        this.getFullWidthRowCtrls().forEach((fullWidthCtrl)=>{
            const rowIndex = fullWidthCtrl.rowNode.rowIndex;
            rowsToRemove.push(rowIndex.toString());
        });
        this.refreshFloatingRowComps();
        this.removeRowCtrls(rowsToRemove);
        this.redraw({
            afterScroll: true
        });
    }
    getFullWidthRowCtrls(rowNodes) {
        const rowNodesMap = $437b23f6a393c3bf$var$mapRowNodes(rowNodes);
        return this.getAllRowCtrls().filter((rowCtrl)=>{
            if (!rowCtrl.isFullWidth()) return false;
            const rowNode = rowCtrl.rowNode;
            if (rowNodesMap != null && !$437b23f6a393c3bf$var$isRowInMap(rowNode, rowNodesMap)) return false;
            return true;
        });
    }
    createOrUpdateRowCtrl(rowIndex, rowsToRecycle, animate, afterScroll) {
        let rowNode;
        let rowCtrl = this.rowCtrlsByRowIndex[rowIndex];
        if (!rowCtrl) {
            rowNode = this.rowModel.getRow(rowIndex);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(rowNode) && $437b23f6a393c3bf$export$25d27f17d3af40f7(rowsToRecycle) && rowsToRecycle[rowNode.id] && rowNode.alreadyRendered) {
                rowCtrl = rowsToRecycle[rowNode.id];
                rowsToRecycle[rowNode.id] = null;
            }
        }
        const creatingNewRowCtrl = !rowCtrl;
        if (creatingNewRowCtrl) {
            if (!rowNode) rowNode = this.rowModel.getRow(rowIndex);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(rowNode)) rowCtrl = this.createRowCon(rowNode, animate, afterScroll);
            else return;
        }
        if (rowNode) rowNode.alreadyRendered = true;
        this.rowCtrlsByRowIndex[rowIndex] = rowCtrl;
        return rowCtrl;
    }
    destroyRowCtrls(rowCtrlsMap, animate) {
        const executeInAWhileFuncs = [];
        if (rowCtrlsMap) for (const rowCtrl of Object.values(rowCtrlsMap)){
            if (!rowCtrl) continue;
            if (this.cachedRowCtrls && rowCtrl.isCacheable()) {
                this.cachedRowCtrls.addRow(rowCtrl);
                continue;
            }
            rowCtrl.destroyFirstPass(!animate);
            if (animate) {
                const instanceId = rowCtrl.instanceId;
                this.zombieRowCtrls[instanceId] = rowCtrl;
                executeInAWhileFuncs.push(()=>{
                    rowCtrl.destroySecondPass();
                    delete this.zombieRowCtrls[instanceId];
                });
            } else rowCtrl.destroySecondPass();
        }
        if (animate) {
            executeInAWhileFuncs.push(()=>{
                this.updateAllRowCtrls();
                this.dispatchDisplayedRowsChanged();
            });
            window.setTimeout(()=>executeInAWhileFuncs.forEach((func)=>func()), $437b23f6a393c3bf$var$ROW_ANIMATION_TIMEOUT);
        }
    }
    getRowBuffer() {
        return this.gos.get("rowBuffer");
    }
    getRowBufferInPixels() {
        const rowsToBuffer = this.getRowBuffer();
        const defaultRowHeight = $437b23f6a393c3bf$export$8966875adec41e5b(this.beans);
        return rowsToBuffer * defaultRowHeight;
    }
    workOutFirstAndLastRowsToRender() {
        const { rowContainerHeight: rowContainerHeight, pageBounds: pageBounds, rowModel: rowModel } = this;
        rowContainerHeight.updateOffset();
        let newFirst;
        let newLast;
        if (!rowModel.isRowsToRender()) {
            newFirst = 0;
            newLast = -1;
        } else if (this.printLayout) {
            this.beans.environment.refreshRowHeightVariable();
            newFirst = pageBounds.getFirstRow();
            newLast = pageBounds.getLastRow();
        } else {
            const bufferPixels = this.getRowBufferInPixels();
            const scrollFeature = this.ctrlsSvc.getScrollFeature();
            const suppressRowVirtualisation = this.gos.get("suppressRowVirtualisation");
            let rowHeightsChanged = false;
            let firstPixel;
            let lastPixel;
            do {
                const paginationOffset = pageBounds.getPixelOffset();
                const { pageFirstPixel: pageFirstPixel, pageLastPixel: pageLastPixel } = pageBounds.getCurrentPagePixelRange();
                const divStretchOffset = rowContainerHeight.divStretchOffset;
                const bodyVRange = scrollFeature.getVScrollPosition();
                const bodyTopPixel = bodyVRange.top;
                const bodyBottomPixel = bodyVRange.bottom;
                if (suppressRowVirtualisation) {
                    firstPixel = pageFirstPixel + divStretchOffset;
                    lastPixel = pageLastPixel + divStretchOffset;
                } else {
                    firstPixel = Math.max(bodyTopPixel + paginationOffset - bufferPixels, pageFirstPixel) + divStretchOffset;
                    lastPixel = Math.min(bodyBottomPixel + paginationOffset + bufferPixels, pageLastPixel) + divStretchOffset;
                }
                this.firstVisibleVPixel = Math.max(bodyTopPixel + paginationOffset, pageFirstPixel) + divStretchOffset;
                this.lastVisibleVPixel = Math.min(bodyBottomPixel + paginationOffset, pageLastPixel) + divStretchOffset;
                rowHeightsChanged = this.ensureAllRowsInRangeHaveHeightsCalculated(firstPixel, lastPixel);
            }while (rowHeightsChanged);
            let firstRowIndex = rowModel.getRowIndexAtPixel(firstPixel);
            let lastRowIndex = rowModel.getRowIndexAtPixel(lastPixel);
            const pageFirstRow = pageBounds.getFirstRow();
            const pageLastRow = pageBounds.getLastRow();
            if (firstRowIndex < pageFirstRow) firstRowIndex = pageFirstRow;
            if (lastRowIndex > pageLastRow) lastRowIndex = pageLastRow;
            newFirst = firstRowIndex;
            newLast = lastRowIndex;
        }
        const rowLayoutNormal = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "normal");
        const suppressRowCountRestriction = this.gos.get("suppressMaxRenderedRowRestriction");
        const rowBufferMaxSize = Math.max(this.getRowBuffer(), 500);
        if (rowLayoutNormal && !suppressRowCountRestriction) {
            if (newLast - newFirst > rowBufferMaxSize) newLast = newFirst + rowBufferMaxSize;
        }
        const firstDiffers = newFirst !== this.firstRenderedRow;
        const lastDiffers = newLast !== this.lastRenderedRow;
        if (firstDiffers || lastDiffers) {
            this.firstRenderedRow = newFirst;
            this.lastRenderedRow = newLast;
            this.eventSvc.dispatchEvent({
                type: "viewportChanged",
                firstRow: newFirst,
                lastRow: newLast
            });
        }
    }
    /**
   * This event will only be fired once, and is queued until after the browser next renders.
   * This allows us to fire an event during the start of the render cycle, when we first see data being rendered
   * but not execute the event until all of the data has finished being rendered to the dom.
   */ dispatchFirstDataRenderedEvent() {
        if (this.dataFirstRenderedFired) return;
        this.dataFirstRenderedFired = true;
        $437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, ()=>{
            this.beans.eventSvc.dispatchEvent({
                type: "firstDataRendered",
                firstRow: this.firstRenderedRow,
                lastRow: this.lastRenderedRow
            });
        });
    }
    ensureAllRowsInRangeHaveHeightsCalculated(topPixel, bottomPixel) {
        const pinnedRowHeightsChanged = this.pinnedRowModel?.ensureRowHeightsValid();
        const stickyHeightsChanged = this.stickyRowFeature?.ensureRowHeightsValid();
        const { pageBounds: pageBounds, rowModel: rowModel } = this;
        const rowModelHeightsChanged = rowModel.ensureRowHeightsValid(topPixel, bottomPixel, pageBounds.getFirstRow(), pageBounds.getLastRow());
        if (rowModelHeightsChanged || stickyHeightsChanged) this.eventSvc.dispatchEvent({
            type: "recalculateRowBounds"
        });
        if (stickyHeightsChanged || rowModelHeightsChanged || pinnedRowHeightsChanged) {
            this.updateContainerHeights();
            return true;
        }
        return false;
    }
    // check that none of the rows to remove are editing or focused as:
    // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
    //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
    //    the edit is reset - so we want to keep it rendered.
    // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
    //    otherwise the user can range select and drag (with focus cell going out of the viewport)
    //    and then ctrl+c, nothing will happen if cell is removed from dom.
    // c) if detail record of master detail, as users complained that the context of detail rows
    //    was getting lost when detail row out of view. eg user expands to show detail row,
    //    then manipulates the detail panel (eg sorts the detail grid), then context is lost
    //    after detail panel is scrolled out of / into view.
    doNotUnVirtualiseRow(rowCtrl) {
        const REMOVE_ROW = false;
        const KEEP_ROW = true;
        const rowNode = rowCtrl.rowNode;
        const rowHasFocus = this.focusSvc.isRowFocused(rowNode.rowIndex, rowNode.rowPinned);
        const rowIsEditing = this.editSvc?.isEditing(rowCtrl);
        const rowIsDetail = rowNode.detail;
        const mightWantToKeepRow = rowHasFocus || rowIsEditing || rowIsDetail;
        if (!mightWantToKeepRow) return REMOVE_ROW;
        const rowNodePresent = this.isRowPresent(rowNode);
        return rowNodePresent ? KEEP_ROW : REMOVE_ROW;
    }
    isRowPresent(rowNode) {
        if (!this.rowModel.isRowPresent(rowNode)) return false;
        return this.beans.pagination?.isRowInPage(rowNode.rowIndex) ?? true;
    }
    createRowCon(rowNode, animate, afterScroll) {
        const rowCtrlFromCache = this.cachedRowCtrls?.getRow(rowNode) ?? null;
        if (rowCtrlFromCache) return rowCtrlFromCache;
        const useAnimationFrameForCreate = afterScroll && !this.printLayout && !!this.beans.animationFrameSvc?.active;
        const res = new $437b23f6a393c3bf$var$RowCtrl(rowNode, this.beans, animate, useAnimationFrameForCreate, this.printLayout);
        return res;
    }
    getRenderedNodes() {
        const viewportRows = Object.values(this.rowCtrlsByRowIndex).map((rowCtrl)=>rowCtrl.rowNode);
        const stickyTopRows = this.getStickyTopRowCtrls().map((rowCtrl)=>rowCtrl.rowNode);
        const stickyBottomRows = this.getStickyBottomRowCtrls().map((rowCtrl)=>rowCtrl.rowNode);
        return [
            ...stickyTopRows,
            ...viewportRows,
            ...stickyBottomRows
        ];
    }
    getRowByPosition(rowPosition) {
        let rowCtrl;
        const { rowIndex: rowIndex } = rowPosition;
        switch(rowPosition.rowPinned){
            case "top":
                rowCtrl = this.topRowCtrls[rowIndex];
                break;
            case "bottom":
                rowCtrl = this.bottomRowCtrls[rowIndex];
                break;
            default:
                rowCtrl = this.rowCtrlsByRowIndex[rowIndex];
                if (!rowCtrl) {
                    rowCtrl = this.getStickyTopRowCtrls().find((ctrl)=>ctrl.rowNode.rowIndex === rowIndex) || null;
                    if (!rowCtrl) rowCtrl = this.getStickyBottomRowCtrls().find((ctrl)=>ctrl.rowNode.rowIndex === rowIndex) || null;
                }
                break;
        }
        return rowCtrl;
    }
    // returns true if any row between startIndex and endIndex is rendered. used by
    // SSRM or IRM, as they don't want to purge visible blocks from cache.
    isRangeInRenderedViewport(startIndex, endIndex) {
        const parentClosed = startIndex == null || endIndex == null;
        if (parentClosed) return false;
        const blockAfterViewport = startIndex > this.lastRenderedRow;
        const blockBeforeViewport = endIndex < this.firstRenderedRow;
        const blockInsideViewport = !blockBeforeViewport && !blockAfterViewport;
        return blockInsideViewport;
    }
};
var $437b23f6a393c3bf$var$RowCtrlCache = class {
    constructor(maxCount){
        // map for fast access
        this.entriesMap = {};
        // list for keeping order
        this.entriesList = [];
        this.maxCount = maxCount;
    }
    addRow(rowCtrl) {
        this.entriesMap[rowCtrl.rowNode.id] = rowCtrl;
        this.entriesList.push(rowCtrl);
        rowCtrl.setCached(true);
        if (this.entriesList.length > this.maxCount) {
            const rowCtrlToDestroy = this.entriesList[0];
            rowCtrlToDestroy.destroyFirstPass();
            rowCtrlToDestroy.destroySecondPass();
            this.removeFromCache(rowCtrlToDestroy);
        }
    }
    getRow(rowNode) {
        if (rowNode == null || rowNode.id == null) return null;
        const res = this.entriesMap[rowNode.id];
        if (!res) return null;
        this.removeFromCache(res);
        res.setCached(false);
        const rowNodeMismatch = res.rowNode != rowNode;
        return rowNodeMismatch ? null : res;
    }
    has(rowNode) {
        return this.entriesMap[rowNode.id] != null;
    }
    removeRow(rowNode) {
        const rowNodeId = rowNode.id;
        const ctrl = this.entriesMap[rowNodeId];
        delete this.entriesMap[rowNodeId];
        $437b23f6a393c3bf$export$83a881c8b5120679(this.entriesList, ctrl);
    }
    removeFromCache(rowCtrl) {
        const rowNodeId = rowCtrl.rowNode.id;
        delete this.entriesMap[rowNodeId];
        $437b23f6a393c3bf$export$83a881c8b5120679(this.entriesList, rowCtrl);
    }
    getEntries() {
        return this.entriesList;
    }
};
function $437b23f6a393c3bf$var$mapRowNodes(rowNodes) {
    if (!rowNodes) return;
    const res = {
        top: {},
        bottom: {},
        normal: {}
    };
    rowNodes.forEach((rowNode)=>{
        const id = rowNode.id;
        switch(rowNode.rowPinned){
            case "top":
                res.top[id] = rowNode;
                break;
            case "bottom":
                res.bottom[id] = rowNode;
                break;
            default:
                res.normal[id] = rowNode;
                break;
        }
    });
    return res;
}
function $437b23f6a393c3bf$var$isRowInMap(rowNode, rowIdsMap) {
    const id = rowNode.id;
    const floating = rowNode.rowPinned;
    switch(floating){
        case "top":
            return rowIdsMap.top[id] != null;
        case "bottom":
            return rowIdsMap.bottom[id] != null;
        default:
            return rowIdsMap.normal[id] != null;
    }
}
// packages/ag-grid-community/src/sort/rowNodeSorter.ts
var $437b23f6a393c3bf$var$RowNodeSorter = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowNodeSorter";
    }
    postConstruct() {
        const { gos: gos } = this;
        this.isAccentedSort = gos.get("accentedSort");
        this.primaryColumnsSortGroups = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
        this.addManagedPropertyListener("accentedSort", (propChange)=>this.isAccentedSort = propChange.currentValue);
        this.addManagedPropertyListener("autoGroupColumnDef", ()=>this.primaryColumnsSortGroups = $437b23f6a393c3bf$export$96c51c2547b81aed(gos));
    }
    doFullSort(rowNodes, sortOptions) {
        const sortedRowNodes = rowNodes.map((rowNode, currentPos)=>({
                currentPos: currentPos,
                rowNode: rowNode
            }));
        sortedRowNodes.sort(this.compareRowNodes.bind(this, sortOptions));
        return sortedRowNodes.map((item)=>item.rowNode);
    }
    compareRowNodes(sortOptions, sortedNodeA, sortedNodeB) {
        const nodeA = sortedNodeA.rowNode;
        const nodeB = sortedNodeB.rowNode;
        for(let i = 0, len = sortOptions.length; i < len; i++){
            const sortOption = sortOptions[i];
            const isDescending = sortOption.sort === "desc";
            const valueA = this.getValue(nodeA, sortOption.column);
            const valueB = this.getValue(nodeB, sortOption.column);
            let comparatorResult;
            const providedComparator = this.getComparator(sortOption, nodeA);
            if (providedComparator) comparatorResult = providedComparator(valueA, valueB, nodeA, nodeB, isDescending);
            else comparatorResult = $437b23f6a393c3bf$export$b0cca9f3c87c8df8(valueA, valueB, this.isAccentedSort);
            const validResult = !isNaN(comparatorResult);
            if (validResult && comparatorResult !== 0) return sortOption.sort === "asc" ? comparatorResult : comparatorResult * -1;
        }
        return sortedNodeA.currentPos - sortedNodeB.currentPos;
    }
    getComparator(sortOption, rowNode) {
        const column = sortOption.column;
        const comparatorOnCol = column.getColDef().comparator;
        if (comparatorOnCol != null) return comparatorOnCol;
        if (!column.getColDef().showRowGroup) return;
        const groupLeafField = !rowNode.group && column.getColDef().field;
        if (!groupLeafField) return;
        const primaryColumn = this.beans.colModel.getColDefCol(groupLeafField);
        if (!primaryColumn) return;
        return primaryColumn.getColDef().comparator;
    }
    getValue(node, column) {
        const { valueSvc: valueSvc, colModel: colModel, showRowGroupCols: showRowGroupCols, gos: gos } = this.beans;
        if (!this.primaryColumnsSortGroups) return valueSvc.getValue(column, node, false);
        const isNodeGroupedAtLevel = node.rowGroupColumn === column;
        if (isNodeGroupedAtLevel) {
            const isGroupRows = $437b23f6a393c3bf$export$b911c5b172d227b4(gos, colModel.isPivotActive());
            if (isGroupRows) {
                const leafChild = node.allLeafChildren?.[0];
                if (leafChild) return valueSvc.getValue(column, leafChild, false);
                return void 0;
            }
            const displayCol = showRowGroupCols?.getShowRowGroupCol(column.getId());
            if (!displayCol) return void 0;
            return node.groupData?.[displayCol.getId()];
        }
        if (node.group && column.getColDef().showRowGroup) return void 0;
        return valueSvc.getValue(column, node, false);
    }
};
// packages/ag-grid-community/src/sort/sortApi.ts
function $437b23f6a393c3bf$var$onSortChanged(beans) {
    beans.sortSvc?.onSortChanged("api");
}
// packages/ag-grid-community/src/sort/sortModule.ts
var $437b23f6a393c3bf$export$1a6625c5691649e8 = {
    moduleName: "Sort",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$SortService,
        $437b23f6a393c3bf$var$RowNodeSorter
    ],
    apiFunctions: {
        onSortChanged: $437b23f6a393c3bf$var$onSortChanged
    },
    userComponents: {
        agSortIndicator: $437b23f6a393c3bf$var$SortIndicatorComp
    },
    icons: {
        // show on column header when column is sorted ascending
        sortAscending: "asc",
        // show on column header when column is sorted descending
        sortDescending: "desc",
        // show on column header when column has no sort, only when enabled with gridOptions.unSortIcon=true
        sortUnSort: "none"
    }
};
// packages/ag-grid-community/src/syncService.ts
var $437b23f6a393c3bf$var$SyncService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "syncSvc";
        this.waitingForColumns = false;
    }
    postConstruct() {
        this.addManagedPropertyListener("columnDefs", (event)=>this.setColumnDefs(event));
    }
    start() {
        this.beans.ctrlsSvc.whenReady(this, ()=>{
            const columnDefs = this.gos.get("columnDefs");
            if (columnDefs) this.setColumnsAndData(columnDefs);
            else this.waitingForColumns = true;
            this.gridReady();
        });
    }
    setColumnsAndData(columnDefs) {
        const { colModel: colModel, rowModel: rowModel } = this.beans;
        colModel.setColumnDefs(columnDefs ?? [], "gridInitializing");
        rowModel.start();
    }
    gridReady() {
        const { eventSvc: eventSvc, gos: gos } = this;
        eventSvc.dispatchEvent({
            type: "gridReady"
        });
        $437b23f6a393c3bf$var$_logIfDebug(gos, `initialised successfully, enterprise = ${gos.isModuleRegistered("EnterpriseCore")}`);
    }
    setColumnDefs(event) {
        const columnDefs = this.gos.get("columnDefs");
        if (!columnDefs) return;
        if (this.waitingForColumns) {
            this.waitingForColumns = false;
            this.setColumnsAndData(columnDefs);
            return;
        }
        this.beans.colModel.setColumnDefs(columnDefs, $437b23f6a393c3bf$export$eb2a92b6162267d1(event.source));
    }
};
// packages/ag-grid-community/src/valueService/cellApi.ts
function $437b23f6a393c3bf$var$expireValueCache(beans) {
    beans.valueCache?.expire();
}
function $437b23f6a393c3bf$var$getCellValue(beans, params) {
    const { colKey: colKey, rowNode: rowNode, useFormatter: useFormatter } = params;
    const column = beans.colModel.getColDefCol(colKey) ?? beans.colModel.getCol(colKey);
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(column)) return null;
    const result = beans.valueSvc.getValueForDisplay(column, rowNode, useFormatter);
    if (useFormatter) return result.valueFormatted ?? $437b23f6a393c3bf$export$a16cfb6652fe466f(result.value);
    return result.value;
}
// packages/ag-grid-community/src/valueService/changeDetectionService.ts
var $437b23f6a393c3bf$var$SOURCE_PASTE = "paste";
var $437b23f6a393c3bf$var$ChangeDetectionService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "changeDetectionSvc";
        this.clientSideRowModel = null;
    }
    postConstruct() {
        const { gos: gos, rowModel: rowModel } = this.beans;
        if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) this.clientSideRowModel = rowModel;
        this.addManagedEventListeners({
            cellValueChanged: this.onCellValueChanged.bind(this)
        });
    }
    onCellValueChanged(event) {
        const { gos: gos, rowRenderer: rowRenderer } = this.beans;
        if (event.source === $437b23f6a393c3bf$var$SOURCE_PASTE || gos.get("suppressChangeDetection")) return;
        const rowNode = event.node;
        const nodesToRefresh = [
            rowNode
        ];
        const clientSideRowModel = this.clientSideRowModel;
        const rootNode = clientSideRowModel?.rootNode;
        if (rootNode && !rowNode.isRowPinned()) {
            const onlyChangedColumns = gos.get("aggregateOnlyChangedColumns");
            const changedPath = new $437b23f6a393c3bf$export$cb4d9114a9732e85(onlyChangedColumns, rootNode);
            changedPath.addParentNode(rowNode.parent, [
                event.column
            ]);
            clientSideRowModel.doAggregate(changedPath);
            changedPath.forEachChangedNodeDepthFirst((rowNode2)=>{
                nodesToRefresh.push(rowNode2);
                if (rowNode2.sibling) nodesToRefresh.push(rowNode2.sibling);
            });
        }
        rowRenderer.refreshCells({
            rowNodes: nodesToRefresh
        });
    }
};
// packages/ag-grid-community/src/valueService/expressionService.ts
var $437b23f6a393c3bf$var$ExpressionService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "expressionSvc";
        this.cache = {};
    }
    evaluate(expression, params) {
        if (typeof expression === "string") return this.evaluateExpression(expression, params);
        else $437b23f6a393c3bf$export$a20c7248650823a9(15, {
            expression: expression
        });
    }
    evaluateExpression(expression, params) {
        try {
            const javaScriptFunction = this.createExpressionFunction(expression);
            const result = javaScriptFunction(params.value, params.context, params.oldValue, params.newValue, params.value, params.node, params.data, params.colDef, params.rowIndex, params.api, params.getValue, params.column, params.columnGroup);
            return result;
        } catch (e) {
            $437b23f6a393c3bf$export$a20c7248650823a9(16, {
                expression: expression,
                params: params,
                e: e
            });
            return null;
        }
    }
    createExpressionFunction(expression) {
        const expressionToFunctionCache = this.cache;
        if (expressionToFunctionCache[expression]) return expressionToFunctionCache[expression];
        const functionBody = this.createFunctionBody(expression);
        const theFunction = new Function("x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, getValue, column, columnGroup", functionBody);
        expressionToFunctionCache[expression] = theFunction;
        return theFunction;
    }
    createFunctionBody(expression) {
        if (expression.indexOf("return") >= 0) return expression;
        else return "return " + expression + ";";
    }
};
// packages/ag-grid-community/src/valueService/valueCache.ts
var $437b23f6a393c3bf$var$ValueCache = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "valueCache";
        this.cacheVersion = 0;
    }
    postConstruct() {
        const gos = this.gos;
        this.active = gos.get("valueCache");
        this.neverExpires = gos.get("valueCacheNeverExpires");
    }
    onDataChanged() {
        if (this.neverExpires) return;
        this.expire();
    }
    expire() {
        this.cacheVersion++;
    }
    setValue(rowNode, colId, value) {
        if (this.active) {
            const cacheVersion = this.cacheVersion;
            if (rowNode.__cacheVersion !== cacheVersion) {
                rowNode.__cacheVersion = cacheVersion;
                rowNode.__cacheData = {};
            }
            rowNode.__cacheData[colId] = value;
        }
    }
    getValue(rowNode, colId) {
        if (!this.active || rowNode.__cacheVersion !== this.cacheVersion) return void 0;
        return rowNode.__cacheData[colId];
    }
};
// packages/ag-grid-community/src/valueService/valueModule.ts
var $437b23f6a393c3bf$export$3110fedd6be63d8e = {
    moduleName: "ValueCache",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ValueCache
    ],
    apiFunctions: {
        expireValueCache: $437b23f6a393c3bf$var$expireValueCache
    }
};
var $437b23f6a393c3bf$var$ExpressionModule = {
    moduleName: "Expression",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ExpressionService
    ]
};
var $437b23f6a393c3bf$var$ChangeDetectionModule = {
    moduleName: "ChangeDetection",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ChangeDetectionService
    ]
};
var $437b23f6a393c3bf$export$d7a9d7f5c41fb970 = {
    moduleName: "CellApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        getCellValue: $437b23f6a393c3bf$var$getCellValue
    }
};
// packages/ag-grid-community/src/valueService/valueService.ts
var $437b23f6a393c3bf$var$EDITING_CHECK_SIBLINGS = {
    checkSiblings: true
};
var $437b23f6a393c3bf$var$ValueService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "valueSvc";
        this.hasEdit = false;
        this.initialised = false;
        this.isSsrm = false;
    }
    wireBeans(beans) {
        this.expressionSvc = beans.expressionSvc;
        this.colModel = beans.colModel;
        this.valueCache = beans.valueCache;
        this.dataTypeSvc = beans.dataTypeSvc;
        this.editSvc = beans.editSvc;
        this.hasEdit = !!beans.editSvc;
    }
    postConstruct() {
        if (!this.initialised) this.init();
    }
    init() {
        this.executeValueGetter = this.valueCache ? this.executeValueGetterWithValueCache.bind(this) : this.executeValueGetterWithoutValueCache.bind(this);
        this.isSsrm = $437b23f6a393c3bf$export$cf1bac0013650216(this.gos);
        this.cellExpressions = this.gos.get("enableCellExpressions");
        this.isTreeData = this.gos.get("treeData");
        this.initialised = true;
        const listener = (event)=>this.callColumnCellValueChangedHandler(event);
        this.eventSvc.addEventListener("cellValueChanged", listener, true);
        this.addDestroyFunc(()=>this.eventSvc.removeEventListener("cellValueChanged", listener, true));
        this.addManagedPropertyListener("treeData", (propChange)=>this.isTreeData = propChange.currentValue);
    }
    /**
   * Use this function to get a displayable cell value.
   * The values from this function are not used for sorting, filtering, or aggregation purposes.
   * Handles: groupHideOpenParents, showOpenedGroup and groupSuppressBlankHeader behaviours
   */ getValueForDisplay(column, node, includeValueFormatted = false, exporting = false, source = "ui") {
        const { showRowGroupColValueSvc: showRowGroupColValueSvc } = this.beans;
        const isFullWidthGroup = !column && node.group;
        const isGroupCol = column?.colDef.showRowGroup;
        const processTreeDataAsGroup = !this.isTreeData || node.footer;
        if (showRowGroupColValueSvc && processTreeDataAsGroup && (isFullWidthGroup || isGroupCol)) {
            const groupValue = showRowGroupColValueSvc.getGroupValue(node, column);
            if (groupValue == null) return {
                value: null,
                valueFormatted: null
            };
            if (!includeValueFormatted) return {
                value: groupValue.value,
                valueFormatted: null
            };
            const valueFormatted = showRowGroupColValueSvc.formatAndPrefixGroupColValue(groupValue, column, exporting);
            return {
                value: groupValue.value,
                valueFormatted: valueFormatted
            };
        }
        if (!column) return {
            value: node.key,
            valueFormatted: null
        };
        const isPivotLeaf = node.leafGroup && this.colModel.isPivotMode();
        const isOpenedGroup = node.group && node.expanded && !node.footer && !isPivotLeaf;
        const groupShowsAggData = this.gos.get("groupSuppressBlankHeader") || !node.sibling;
        const ignoreAggData = isOpenedGroup && !groupShowsAggData;
        const value = this.getValue(column, node, ignoreAggData, source);
        const format = includeValueFormatted && !(exporting && column.colDef.useValueFormatterForExport === false);
        return {
            value: value,
            valueFormatted: format ? this.formatValue(column, node, value) : null
        };
    }
    getValue(column, rowNode, ignoreAggData = false, source = "ui") {
        if (!this.initialised) this.init();
        if (!rowNode) return;
        const colDef = column.getColDef();
        const field = colDef.field;
        const colId = column.getColId();
        let data = rowNode.data;
        if (this.hasEdit && source === "ui") {
            const editSvc = this.editSvc;
            if (editSvc.isRowEditing(rowNode, $437b23f6a393c3bf$var$EDITING_CHECK_SIBLINGS)) data = editSvc.getRowDataValue(rowNode, $437b23f6a393c3bf$var$EDITING_CHECK_SIBLINGS);
            if (editSvc.isEditing()) {
                const newValue = editSvc.getCellDataValue({
                    rowNode: rowNode,
                    column: column
                }, true);
                if (newValue !== void 0) return newValue;
            }
        }
        let result;
        const rowGroupColId = colDef.showRowGroup;
        if (typeof rowGroupColId === "string") {
            const colRowGroupIndex = this.beans.rowGroupColsSvc?.getColumnIndex(rowGroupColId) ?? -1;
            if (colRowGroupIndex > rowNode.level) return null;
        }
        const allowUserValuesForCell = typeof rowGroupColId !== "string" || !rowNode.group;
        const groupDataExists = rowNode.groupData && colId in rowNode.groupData;
        const aggDataExists = !ignoreAggData && rowNode.aggData && rowNode.aggData[colId] !== void 0;
        const ignoreSsrmAggData = this.isSsrm && ignoreAggData && !!colDef.aggFunc;
        const ssrmFooterGroupCol = this.isSsrm && rowNode.footer && rowNode.field && (colDef.showRowGroup === true || colDef.showRowGroup === rowNode.field);
        if (this.isTreeData && aggDataExists) result = rowNode.aggData[colId];
        else if (this.isTreeData && colDef.valueGetter) result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
        else if (this.isTreeData && field && data) result = $437b23f6a393c3bf$var$_getValueUsingField(data, field, column.isFieldContainsDots());
        else if (groupDataExists) result = rowNode.groupData[colId];
        else if (aggDataExists) result = rowNode.aggData[colId];
        else if (colDef.valueGetter && !ignoreSsrmAggData) {
            if (!allowUserValuesForCell) return result;
            result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
        } else if (ssrmFooterGroupCol) result = $437b23f6a393c3bf$var$_getValueUsingField(data, rowNode.field, column.isFieldContainsDots());
        else if (field && data && !ignoreSsrmAggData) {
            if (!allowUserValuesForCell) return result;
            result = $437b23f6a393c3bf$var$_getValueUsingField(data, field, column.isFieldContainsDots());
        }
        if (this.cellExpressions && typeof result === "string" && result.indexOf("=") === 0) {
            const cellValueGetter = result.substring(1);
            result = this.executeValueGetter(cellValueGetter, data, column, rowNode);
        }
        return result;
    }
    parseValue(column, rowNode, newValue, oldValue) {
        const colDef = column.getColDef();
        const valueParser = colDef.valueParser;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(valueParser)) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                node: rowNode,
                data: rowNode?.data,
                oldValue: oldValue,
                newValue: newValue,
                colDef: colDef,
                column: column
            });
            if (typeof valueParser === "function") return valueParser(params);
            return this.expressionSvc?.evaluate(valueParser, params);
        }
        return newValue;
    }
    getDeleteValue(column, rowNode) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(column.getColDef().valueParser)) return this.parseValue(column, rowNode, "", this.getValueForDisplay(column, rowNode).value) ?? null;
        return null;
    }
    formatValue(column, node, value, suppliedFormatter, useFormatterFromColumn = true) {
        const { expressionSvc: expressionSvc } = this.beans;
        let result = null;
        let formatter;
        const colDef = column.getColDef();
        if (suppliedFormatter) formatter = suppliedFormatter;
        else if (useFormatterFromColumn) formatter = colDef.valueFormatter;
        if (formatter) {
            let data = node ? node.data : null;
            if (node) {
                const position = {
                    rowNode: node
                };
                if (this.hasEdit) {
                    const editSvc = this.editSvc;
                    if (editSvc.isEditing(position, $437b23f6a393c3bf$var$EDITING_CHECK_SIBLINGS)) data = editSvc.getRowDataValue(node, $437b23f6a393c3bf$var$EDITING_CHECK_SIBLINGS);
                }
            }
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                value: value,
                node: node,
                data: data,
                colDef: colDef,
                column: column
            });
            if (typeof formatter === "function") result = formatter(params);
            else result = expressionSvc ? expressionSvc.evaluate(formatter, params) : null;
        } else if (colDef.refData) return colDef.refData[value] || "";
        if (result == null && Array.isArray(value)) result = value.join(", ");
        return result;
    }
    /**
   * Sets the value of a GridCell
   * @param rowNode The `RowNode` to be updated
   * @param colKey The `Column` to be updated
   * @param newValue The new value to be set
   * @param eventSource The event source
   * @returns `True` if the value has been updated, otherwise`False`.
   */ setValue(rowNode, colKey, newValue, eventSource) {
        const column = this.colModel.getColDefCol(colKey);
        if (!rowNode || !column) return false;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(rowNode.data)) rowNode.data = {};
        const { field: field, valueSetter: valueSetter } = column.getColDef();
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(field) && $437b23f6a393c3bf$export$672d9e47bc342bac(valueSetter)) {
            $437b23f6a393c3bf$export$545083624300f13d(17);
            return false;
        }
        if (this.dataTypeSvc && !this.dataTypeSvc.checkType(column, newValue)) {
            $437b23f6a393c3bf$export$545083624300f13d(135);
            return false;
        }
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            node: rowNode,
            data: rowNode.data,
            oldValue: this.getValue(column, rowNode, void 0, eventSource),
            newValue: newValue,
            colDef: column.getColDef(),
            column: column
        });
        params.newValue = newValue;
        let valueWasDifferent;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(valueSetter)) {
            if (typeof valueSetter === "function") valueWasDifferent = valueSetter(params);
            else valueWasDifferent = this.expressionSvc?.evaluate(valueSetter, params);
        } else valueWasDifferent = this.setValueUsingField(rowNode.data, field, newValue, column.isFieldContainsDots());
        if (valueWasDifferent === void 0) valueWasDifferent = true;
        if (!valueWasDifferent) return false;
        rowNode.resetQuickFilterAggregateText();
        this.valueCache?.onDataChanged();
        const savedValue = this.getValue(column, rowNode);
        this.dispatchCellValueChangedEvent(rowNode, params, savedValue, eventSource);
        if (rowNode.pinnedSibling) this.dispatchCellValueChangedEvent(rowNode.pinnedSibling, params, savedValue, eventSource);
        return true;
    }
    dispatchCellValueChangedEvent(rowNode, params, value, source) {
        this.eventSvc.dispatchEvent({
            type: "cellValueChanged",
            event: null,
            rowIndex: rowNode.rowIndex,
            rowPinned: rowNode.rowPinned,
            column: params.column,
            colDef: params.colDef,
            data: rowNode.data,
            node: rowNode,
            oldValue: params.oldValue,
            newValue: value,
            value: value,
            source: source
        });
    }
    callColumnCellValueChangedHandler(event) {
        const onCellValueChanged = event.colDef.onCellValueChanged;
        if (typeof onCellValueChanged === "function") this.beans.frameworkOverrides.wrapOutgoing(()=>{
            onCellValueChanged({
                node: event.node,
                data: event.data,
                oldValue: event.oldValue,
                newValue: event.newValue,
                colDef: event.colDef,
                column: event.column,
                api: event.api,
                context: event.context
            });
        });
    }
    setValueUsingField(data, field, newValue, isFieldContainsDots) {
        if (!field) return false;
        let valuesAreSame = false;
        if (!isFieldContainsDots) {
            valuesAreSame = data[field] === newValue;
            if (!valuesAreSame) data[field] = newValue;
        } else {
            const fieldPieces = field.split(".");
            let currentObject = data;
            while(fieldPieces.length > 0 && currentObject){
                const fieldPiece = fieldPieces.shift();
                if (fieldPieces.length === 0) {
                    valuesAreSame = currentObject[fieldPiece] === newValue;
                    if (!valuesAreSame) currentObject[fieldPiece] = newValue;
                } else currentObject = currentObject[fieldPiece];
            }
        }
        return !valuesAreSame;
    }
    executeValueGetterWithValueCache(valueGetter, data, column, rowNode) {
        const colId = column.getColId();
        const valueFromCache = this.valueCache.getValue(rowNode, colId);
        if (valueFromCache !== void 0) return valueFromCache;
        const result = this.executeValueGetterWithoutValueCache(valueGetter, data, column, rowNode);
        this.valueCache.setValue(rowNode, colId, result);
        return result;
    }
    executeValueGetterWithoutValueCache(valueGetter, data, column, rowNode) {
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            data: data,
            node: rowNode,
            column: column,
            colDef: column.getColDef(),
            getValue: this.getValueCallback.bind(this, rowNode)
        });
        let result;
        if (typeof valueGetter === "function") result = valueGetter(params);
        else result = this.expressionSvc?.evaluate(valueGetter, params);
        return result;
    }
    getValueCallback(node, field) {
        const otherColumn = this.colModel.getColDefCol(field);
        if (otherColumn) return this.getValue(otherColumn, node);
        return null;
    }
    // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col
    getKeyForNode(col, rowNode) {
        const value = this.getValue(col, rowNode);
        const keyCreator = col.getColDef().keyCreator;
        let result = value;
        if (keyCreator) {
            const keyParams = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                value: value,
                colDef: col.getColDef(),
                column: col,
                node: rowNode,
                data: rowNode.data
            });
            result = keyCreator(keyParams);
        }
        if (typeof result === "string" || result == null) return result;
        result = String(result);
        if (result === "[object Object]") $437b23f6a393c3bf$export$545083624300f13d(121);
        return result;
    }
};
// packages/ag-grid-community/src/gridCoreModule.ts
var $437b23f6a393c3bf$var$CommunityCoreModule = {
    moduleName: "CommunityCore",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$GridDestroyService,
        $437b23f6a393c3bf$var$ApiFunctionService,
        $437b23f6a393c3bf$var$Registry,
        $437b23f6a393c3bf$var$UserComponentFactory,
        $437b23f6a393c3bf$var$RowContainerHeightService,
        $437b23f6a393c3bf$var$VisibleColsService,
        $437b23f6a393c3bf$var$EventService,
        $437b23f6a393c3bf$var$GridOptionsService,
        $437b23f6a393c3bf$var$ColumnModel,
        $437b23f6a393c3bf$var$PageBoundsService,
        $437b23f6a393c3bf$var$PageBoundsListener,
        $437b23f6a393c3bf$var$RowRenderer,
        $437b23f6a393c3bf$var$ValueService,
        $437b23f6a393c3bf$var$FocusService,
        $437b23f6a393c3bf$var$Environment,
        $437b23f6a393c3bf$var$ScrollVisibleService,
        $437b23f6a393c3bf$var$CtrlsService,
        $437b23f6a393c3bf$var$SyncService,
        $437b23f6a393c3bf$var$ColumnNameService,
        $437b23f6a393c3bf$var$ColumnViewportService
    ],
    icons: {
        // icon on select dropdowns (select cell editor, charts tool panels)
        selectOpen: "small-down",
        /** @deprecated v33 */ smallDown: "small-down",
        /** @deprecated v33 */ colorPicker: "color-picker",
        /** @deprecated v33 */ smallUp: "small-up",
        /** @deprecated v33 */ checkboxChecked: "small-up",
        /** @deprecated v33 */ checkboxIndeterminate: "checkbox-indeterminate",
        /** @deprecated v33 */ checkboxUnchecked: "checkbox-unchecked",
        /** @deprecated v33 */ radioButtonOn: "radio-button-on",
        /** @deprecated v33 */ radioButtonOff: "radio-button-off",
        /** @deprecated v33 */ smallLeft: "small-left",
        /** @deprecated v33 */ smallRight: "small-right"
    },
    apiFunctions: {
        getGridId: $437b23f6a393c3bf$var$getGridId,
        destroy: $437b23f6a393c3bf$var$destroy,
        isDestroyed: $437b23f6a393c3bf$var$isDestroyed,
        getGridOption: $437b23f6a393c3bf$var$getGridOption,
        setGridOption: $437b23f6a393c3bf$var$setGridOption,
        updateGridOptions: $437b23f6a393c3bf$var$updateGridOptions,
        isModuleRegistered: $437b23f6a393c3bf$var$isModuleRegistered
    },
    dependsOn: [
        $437b23f6a393c3bf$var$DataTypeModule,
        $437b23f6a393c3bf$export$1458fbffed29c925,
        $437b23f6a393c3bf$var$ColumnResizeModule,
        $437b23f6a393c3bf$export$1a6625c5691649e8,
        $437b23f6a393c3bf$var$ColumnHeaderCompModule,
        $437b23f6a393c3bf$export$922da35340a6d14e,
        $437b23f6a393c3bf$var$ColumnGroupHeaderCompModule,
        $437b23f6a393c3bf$var$OverlayModule,
        $437b23f6a393c3bf$var$ChangeDetectionModule,
        $437b23f6a393c3bf$var$AnimationFrameModule,
        $437b23f6a393c3bf$export$44f04c51d8088336,
        $437b23f6a393c3bf$var$PinnedColumnModule,
        $437b23f6a393c3bf$var$AriaModule,
        $437b23f6a393c3bf$var$TouchModule,
        $437b23f6a393c3bf$var$CellRendererFunctionModule,
        $437b23f6a393c3bf$var$ColumnFlexModule,
        $437b23f6a393c3bf$var$ExpressionModule,
        $437b23f6a393c3bf$var$SkeletonCellRendererModule
    ]
};
// packages/ag-grid-community/src/utils/fuzzyMatch.ts
function $437b23f6a393c3bf$export$85cab1b5a4aa292c(params) {
    const { inputValue: inputValue, allSuggestions: allSuggestions, hideIrrelevant: hideIrrelevant, filterByPercentageOfBestMatch: filterByPercentageOfBestMatch } = params;
    let thisSuggestions = (allSuggestions ?? []).map((text, idx)=>({
            value: text,
            relevance: $437b23f6a393c3bf$var$_getLevenshteinSimilarityDistance(inputValue, text),
            idx: idx
        }));
    thisSuggestions.sort((a, b)=>a.relevance - b.relevance);
    if (hideIrrelevant) thisSuggestions = thisSuggestions.filter((suggestion)=>suggestion.relevance < Math.max(suggestion.value.length, inputValue.length));
    if (thisSuggestions.length > 0 && filterByPercentageOfBestMatch && filterByPercentageOfBestMatch > 0) {
        const bestMatch = thisSuggestions[0].relevance;
        const limit = bestMatch * filterByPercentageOfBestMatch;
        thisSuggestions = thisSuggestions.filter((suggestion)=>limit - suggestion.relevance < 0);
    }
    const values = [];
    const indices = [];
    for (const suggestion of thisSuggestions){
        values.push(suggestion.value);
        indices.push(suggestion.idx);
    }
    return {
        values: values,
        indices: indices
    };
}
function $437b23f6a393c3bf$var$_getLevenshteinSimilarityDistance(inputText, suggestion) {
    if (inputText.length < suggestion.length) [inputText, suggestion] = [
        suggestion,
        inputText
    ];
    let previousRow = [];
    let currentRow = [];
    const sourceLength = inputText.length;
    const targetLength = suggestion.length;
    for(let j = 0; j <= targetLength; j++)previousRow[j] = j;
    let secondaryScore = 0;
    for(let i = 1; i <= sourceLength; i++){
        currentRow[0] = i;
        for(let j = 1; j <= targetLength; j++){
            const sourceChar = inputText[i - 1];
            const targetChar = suggestion[j - 1];
            if (sourceChar.toLocaleLowerCase() === targetChar.toLocaleLowerCase()) {
                ++secondaryScore;
                if (sourceChar === targetChar) ++secondaryScore;
                if (i > 1 && j > 1) {
                    if (inputText[i - 2].toLocaleLowerCase() === suggestion[j - 2].toLocaleLowerCase()) {
                        ++secondaryScore;
                        if (inputText[i - 2] === suggestion[j - 2]) ++secondaryScore;
                    }
                }
                if (i < sourceLength / 2 - 10) ++secondaryScore;
                currentRow[j] = previousRow[j - 1];
            } else {
                const insertCost = currentRow[j - 1];
                const deleteCost = previousRow[j];
                const replaceCost = previousRow[j - 1];
                currentRow[j] = 1 + Math.min(insertCost, deleteCost, replaceCost);
            }
        }
        [previousRow, currentRow] = [
            currentRow,
            previousRow
        ];
    }
    return previousRow[targetLength] / (secondaryScore + 1);
}
// packages/ag-grid-community/src/validation/enterpriseModuleNames.ts
var $437b23f6a393c3bf$var$ENTERPRISE_MODULE_NAMES = {
    AdvancedFilter: 1,
    AllEnterprise: 1,
    BatchEdit: 1,
    CellSelection: 1,
    Clipboard: 1,
    ColumnMenu: 1,
    ColumnsToolPanel: 1,
    ContextMenu: 1,
    ExcelExport: 1,
    FiltersToolPanel: 1,
    Find: 1,
    GridCharts: 1,
    IntegratedCharts: 1,
    GroupFilter: 1,
    MasterDetail: 1,
    Menu: 1,
    MultiFilter: 1,
    NewFiltersToolPanel: 1,
    Pivot: 1,
    RangeSelection: 1,
    RichSelect: 1,
    RowNumbers: 1,
    RowGrouping: 1,
    RowGroupingPanel: 1,
    ServerSideRowModelApi: 1,
    ServerSideRowModel: 1,
    SetFilter: 1,
    SideBar: 1,
    Sparklines: 1,
    StatusBar: 1,
    TreeData: 1,
    ViewportRowModel: 1
};
// packages/ag-grid-community/src/validation/resolvableModuleNames.ts
var $437b23f6a393c3bf$var$ALL_COLUMN_FILTERS = [
    "TextFilter",
    "NumberFilter",
    "DateFilter",
    "SetFilter",
    "MultiFilter",
    "GroupFilter",
    "CustomFilter"
];
var $437b23f6a393c3bf$var$RESOLVABLE_MODULE_NAMES = {
    EditCore: [
        "TextEditor",
        "NumberEditor",
        "DateEditor",
        "CheckboxEditor",
        "LargeTextEditor",
        "SelectEditor",
        "RichSelect",
        "CustomEditor"
    ],
    CheckboxCellRenderer: [
        "AllCommunity"
    ],
    ClientSideRowModelHierarchy: [
        "RowGrouping",
        "Pivot",
        "TreeData"
    ],
    ColumnFilter: $437b23f6a393c3bf$var$ALL_COLUMN_FILTERS,
    ColumnGroupHeaderComp: [
        "AllCommunity"
    ],
    ColumnGroup: [
        "AllCommunity"
    ],
    ColumnHeaderComp: [
        "AllCommunity"
    ],
    ColumnMove: [
        "AllCommunity"
    ],
    ColumnResize: [
        "AllCommunity"
    ],
    CommunityCore: [
        "AllCommunity"
    ],
    CsrmSsrmSharedApi: [
        "ClientSideRowModelApi",
        "ServerSideRowModelApi"
    ],
    EnterpriseCore: [
        "AllEnterprise"
    ],
    FilterCore: [
        ...$437b23f6a393c3bf$var$ALL_COLUMN_FILTERS,
        "QuickFilter",
        "ExternalFilter",
        "AdvancedFilter"
    ],
    GroupCellRenderer: [
        "RowGrouping",
        "Pivot",
        "TreeData",
        "MasterDetail",
        "ServerSideRowModel"
    ],
    KeyboardNavigation: [
        "AllCommunity"
    ],
    LoadingCellRenderer: [
        "ServerSideRowModel"
    ],
    MenuCore: [
        "ColumnMenu",
        "ContextMenu"
    ],
    MenuItem: [
        "ColumnMenu",
        "ContextMenu",
        "MultiFilter",
        "IntegratedCharts",
        "ColumnsToolPanel"
    ],
    Overlay: [
        "AllCommunity"
    ],
    PinnedColumn: [
        "AllCommunity"
    ],
    SharedAggregation: [
        "RowGrouping",
        "Pivot",
        "TreeData",
        "ServerSideRowModel"
    ],
    SharedDragAndDrop: [
        "AllCommunity"
    ],
    SharedMasterDetail: [
        "MasterDetail",
        "ServerSideRowModel"
    ],
    SharedMenu: [
        ...$437b23f6a393c3bf$var$ALL_COLUMN_FILTERS,
        "ColumnMenu",
        "ContextMenu"
    ],
    SharedPivot: [
        "Pivot",
        "ServerSideRowModel"
    ],
    SharedRowGrouping: [
        "RowGrouping",
        "ServerSideRowModel"
    ],
    SharedRowSelection: [
        "RowSelection",
        "ServerSideRowModel"
    ],
    SkeletonCellRenderer: [
        "ServerSideRowModel"
    ],
    Sort: [
        "AllCommunity"
    ],
    SsrmInfiniteSharedApi: [
        "InfiniteRowModel",
        "ServerSideRowModelApi"
    ],
    SharedTreeData: [
        "TreeData",
        "ServerSideRowModel"
    ]
};
var $437b23f6a393c3bf$var$MODULES_FOR_ROW_MODELS = {
    InfiniteRowModel: "infinite",
    ClientSideRowModelApi: "clientSide",
    ClientSideRowModel: "clientSide",
    ServerSideRowModelApi: "serverSide",
    ServerSideRowModel: "serverSide",
    ViewportRowModel: "viewport"
};
function $437b23f6a393c3bf$var$resolveModuleNames(moduleName, rowModelType) {
    const resolvedModuleNames = [];
    (Array.isArray(moduleName) ? moduleName : [
        moduleName
    ]).forEach((modName)=>{
        const resolved = $437b23f6a393c3bf$var$RESOLVABLE_MODULE_NAMES[modName];
        if (resolved) resolved.forEach((resolvedModName)=>{
            const rowModelForModule = $437b23f6a393c3bf$var$MODULES_FOR_ROW_MODELS[resolvedModName];
            if (!rowModelForModule || rowModelForModule === rowModelType) resolvedModuleNames.push(resolvedModName);
        });
        else resolvedModuleNames.push(modName);
    });
    return resolvedModuleNames;
}
// packages/ag-grid-community/src/validation/errorMessages/errorText.ts
var $437b23f6a393c3bf$var$NoModulesRegisteredError = ()=>`No AG Grid modules are registered! It is recommended to start with all Community features via the AllCommunityModule:
                    
    import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
    
    ModuleRegistry.registerModules([ AllCommunityModule ]);
    `;
var $437b23f6a393c3bf$var$moduleImportMsg = (moduleNames)=>{
    const imports = moduleNames.map((moduleName)=>`import { ${$437b23f6a393c3bf$var$convertToUserModuleName(moduleName)} } from '${$437b23f6a393c3bf$var$ENTERPRISE_MODULE_NAMES[moduleName] ? "ag-grid-enterprise" : "ag-grid-community"}';`);
    const includeCharts = moduleNames.some((m)=>m === "IntegratedCharts" || m === "Sparklines");
    if (includeCharts) {
        const chartImport = `import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';`;
        imports.push(chartImport);
    }
    return `import { ModuleRegistry } from 'ag-grid-community'; 
${imports.join(" \n")} 

ModuleRegistry.registerModules([ ${moduleNames.map((m)=>$437b23f6a393c3bf$var$convertToUserModuleName(m, true)).join(", ")} ]); 

For more info see: ${$437b23f6a393c3bf$var$baseDocLink}/modules/`;
};
function $437b23f6a393c3bf$var$convertToUserModuleName(moduleName, inModuleRegistration = false) {
    if (inModuleRegistration && (moduleName === "IntegratedCharts" || moduleName === "Sparklines")) return `${moduleName}Module.with(AgChartsEnterpriseModule)`;
    return `${moduleName}Module`;
}
function $437b23f6a393c3bf$var$umdMissingModule(reasonOrId, moduleNames) {
    const chartModules = moduleNames.filter((m)=>m === "IntegratedCharts" || m === "Sparklines");
    let message = "";
    const agChartsDynamic = globalThis?.agCharts;
    if (!agChartsDynamic && chartModules.length > 0) message = `Unable to use ${reasonOrId} as either the ag-charts-community or ag-charts-enterprise script needs to be included alongside ag-grid-enterprise.
`;
    else if (moduleNames.some((m)=>$437b23f6a393c3bf$var$ENTERPRISE_MODULE_NAMES[m])) message = message + `Unable to use ${reasonOrId} as that requires the ag-grid-enterprise script to be included.
`;
    return message;
}
function $437b23f6a393c3bf$var$missingRowModelTypeError({ moduleName: moduleName, rowModelType: rowModelType }) {
    return `To use the ${moduleName}Module you must set the gridOption "rowModelType='${rowModelType}'"`;
}
var $437b23f6a393c3bf$var$missingModule = ({ reasonOrId: reasonOrId, moduleName: moduleName, gridScoped: gridScoped, gridId: gridId, rowModelType: rowModelType, additionalText: additionalText, isUmd: isUmd2 })=>{
    const resolvedModuleNames = $437b23f6a393c3bf$var$resolveModuleNames(moduleName, rowModelType);
    const reason = typeof reasonOrId === "string" ? reasonOrId : $437b23f6a393c3bf$var$MISSING_MODULE_REASONS[reasonOrId];
    if (isUmd2) return $437b23f6a393c3bf$var$umdMissingModule(reason, resolvedModuleNames);
    const chartModules = resolvedModuleNames.filter((m)=>m === "IntegratedCharts" || m === "Sparklines");
    const chartImportRequired = chartModules.length > 0 ? `${chartModules.map((m)=>$437b23f6a393c3bf$var$convertToUserModuleName(m)).join()} must be initialised with an AG Charts module. One of 'AgChartsCommunityModule' / 'AgChartsEnterpriseModule'.` : "";
    const explanation = `Unable to use ${reason} as ${resolvedModuleNames.length > 1 ? "one of " + resolvedModuleNames.map((m)=>$437b23f6a393c3bf$var$convertToUserModuleName(m)).join(", ") : $437b23f6a393c3bf$var$convertToUserModuleName(resolvedModuleNames[0])} is not registered${gridScoped ? " for gridId: " + gridId : ""}. ${chartImportRequired} Check if you have registered the module:
`;
    return `${explanation}
${$437b23f6a393c3bf$var$moduleImportMsg(resolvedModuleNames)}` + (additionalText ? ` 

${additionalText}` : "");
};
var $437b23f6a393c3bf$var$missingChartsWithModule = (gridModule)=>{
    return `${gridModule} must be initialised with an AG Charts module. One of 'AgChartsCommunityModule' / 'AgChartsEnterpriseModule'.

import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';
import { ModuleRegistry } from 'ag-grid-community';
import { ${gridModule} } from 'ag-grid-enterprise';
    
ModuleRegistry.registerModules([${gridModule}.with(AgChartsEnterpriseModule)]);
    `;
};
var $437b23f6a393c3bf$var$clipboardApiError = (method)=>`AG Grid: Unable to use the Clipboard API (navigator.clipboard.${method}()). The reason why it could not be used has been logged in the previous line. For this reason the grid has defaulted to using a workaround which doesn't perform as well. Either fix why Clipboard API is blocked, OR stop this message from appearing by setting grid property suppressClipboardApi=true (which will default the grid to using the workaround rather than the API.`;
var $437b23f6a393c3bf$var$AG_GRID_ERRORS = {
    1: ()=>"`rowData` must be an array",
    2: ({ nodeId: nodeId })=>`Duplicate node id '${nodeId}' detected from getRowId callback, this could cause issues in your grid.`,
    3: ()=>"Calling gridApi.resetRowHeights() makes no sense when using Auto Row Height.",
    4: ({ id: id })=>`Could not find row id=${id}, data item was not found for this id`,
    5: ({ data: data })=>[
            `Could not find data item as object was not found.`,
            data,
            " Consider using getRowId to help the Grid find matching row data"
        ],
    6: ()=>`'groupHideOpenParents' only works when specifying specific columns for 'colDef.showRowGroup'`,
    7: ()=>"Pivoting is not supported with aligned grids as it may produce different columns in each grid.",
    8: ({ key: key })=>`Unknown key for navigation ${key}`,
    9: ({ variable: variable })=>`No value for ${variable?.cssName}. This usually means that the grid has been initialised before styles have been loaded. The default value of ${variable?.defaultValue} will be used and updated when styles load.`,
    10: ({ eventType: eventType })=>`As of v33, the '${eventType}' event is deprecated. Use the global 'modelUpdated' event to determine when row children have changed.`,
    11: ()=>"No gridOptions provided to createGrid",
    12: ({ colKey: colKey })=>[
            "column ",
            colKey,
            " not found"
        ],
    13: ()=>"Could not find rowIndex, this means tasks are being executed on a rowNode that has been removed from the grid.",
    14: ({ groupPrefix: groupPrefix })=>`Row IDs cannot start with ${groupPrefix}, this is a reserved prefix for AG Grid's row grouping feature.`,
    15: ({ expression: expression })=>[
            "value should be either a string or a function",
            expression
        ],
    16: ({ expression: expression, params: params, e: e })=>[
            "Processing of the expression failed",
            "Expression = ",
            expression,
            "Params = ",
            params,
            "Exception = ",
            e
        ],
    17: ()=>"you need either field or valueSetter set on colDef for editing to work",
    18: ()=>`alignedGrids contains an undefined option.`,
    19: ()=>`alignedGrids - No api found on the linked grid.`,
    20: ()=>`You may want to configure via a callback to avoid setup race conditions:
                     "alignedGrids: () => [linkedGrid]"`,
    21: ()=>"pivoting is not supported with aligned grids. You can only use one of these features at a time in a grid.",
    22: ({ key: key })=>`${key} is an initial property and cannot be updated.`,
    23: ()=>"The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead.",
    24: ()=>"row height must be a number if not using standard row model",
    25: ({ id: id })=>[
            `The getRowId callback must return a string. The ID `,
            id,
            ` is being cast to a string.`
        ],
    26: ({ fnName: fnName, preDestroyLink: preDestroyLink })=>{
        return `Grid API function ${fnName}() cannot be called as the grid has been destroyed.
 Either clear local references to the grid api, when it is destroyed, or check gridApi.isDestroyed() to avoid calling methods against a destroyed grid.
 To run logic when the grid is about to be destroyed use the gridPreDestroy event. See: ${preDestroyLink}`;
    },
    27: ({ fnName: fnName, module: module })=>`API function '${fnName}' not registered to module '${module}'`,
    28: ()=>"setRowCount cannot be used while using row grouping.",
    29: ()=>"tried to call sizeColumnsToFit() but the grid is coming back with zero width, maybe the grid is not visible yet on the screen?",
    30: ({ toIndex: toIndex })=>[
            "tried to insert columns in invalid location, toIndex = ",
            toIndex,
            "remember that you should not count the moving columns when calculating the new index"
        ],
    31: ()=>"infinite loop in resizeColumnSets",
    32: ()=>"applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state.",
    33: ()=>"stateItem.aggFunc must be a string. if using your own aggregation functions, register the functions first before using them in get/set state. This is because it is intended for the column state to be stored and retrieved as simple JSON.",
    34: ({ key: key })=>`the column type '${key}' is a default column type and cannot be overridden.`,
    35: ()=>`Column type definitions 'columnTypes' with a 'type' attribute are not supported because a column type cannot refer to another column type. Only column definitions 'columnDefs' can use the 'type' attribute to refer to a column type.`,
    36: ({ t: t })=>"colDef.type '" + t + "' does not correspond to defined gridOptions.columnTypes",
    37: ()=>`Changing the column pinning status is not allowed with domLayout='print'`,
    38: ({ iconName: iconName })=>`provided icon '${iconName}' needs to be a string or a function`,
    39: ()=>"Applying column order broke a group where columns should be married together. Applying new order has been discarded.",
    40: ({ e: e, method: method })=>`${e}
${$437b23f6a393c3bf$var$clipboardApiError(method)}`,
    41: ()=>"Browser did not allow document.execCommand('copy'). Ensure 'api.copySelectedRowsToClipboard() is invoked via a user event, i.e. button click, otherwise the browser will prevent it for security reasons.",
    42: ()=>"Browser does not support document.execCommand('copy') for clipboard operations",
    43: ({ iconName: iconName })=>`As of v33, icon '${iconName}' is deprecated. Use the icon CSS name instead.`,
    44: ()=>'Data type definition hierarchies (via the "extendsDataType" property) cannot contain circular references.',
    45: ({ parentCellDataType: parentCellDataType })=>`The data type definition ${parentCellDataType} does not exist.`,
    46: ()=>'The "baseDataType" property of a data type definition must match that of its parent.',
    47: ({ cellDataType: cellDataType })=>`Missing data type definition - "${cellDataType}"`,
    48: ({ property: property })=>`Cell data type is "object" but no Value ${property} has been provided. Please either provide an object data type definition with a Value ${property}, or set "colDef.value${property}"`,
    49: ({ methodName: methodName })=>`Framework component is missing the method ${methodName}()`,
    50: ({ compName: compName })=>`Could not find component ${compName}, did you forget to configure this component?`,
    51: ()=>`Export cancelled. Export is not allowed as per your configuration.`,
    52: ()=>"There is no `window` associated with the current `document`",
    53: ()=>`unknown value type during csv conversion`,
    54: ()=>"Could not find document body, it is needed for drag and drop and context menu.",
    55: ()=>"addRowDropZone - A container target needs to be provided",
    56: ()=>"addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.",
    57: ()=>"unable to show popup filter, filter instantiation failed",
    58: ()=>"no values found for select cellEditor",
    59: ()=>"cannot select pinned rows",
    60: ()=>"cannot select node until it has finished loading",
    61: ()=>"since version v32.2.0, rowNode.isFullWidthCell() has been deprecated. Instead check `rowNode.detail` followed by the user provided `isFullWidthRow` grid option.",
    62: ({ colId: colId })=>`setFilterModel() - no column found for colId: ${colId}`,
    63: ({ colId: colId })=>`setFilterModel() - unable to fully apply model, filtering disabled for colId: ${colId}`,
    64: ({ colId: colId })=>`setFilterModel() - unable to fully apply model, unable to create filter for colId: ${colId}`,
    65: ()=>"filter missing setModel method, which is needed for setFilterModel",
    66: ()=>"filter API missing getModel method, which is needed for getFilterModel",
    67: ()=>"Filter is missing isFilterActive() method",
    68: ()=>"Column Filter API methods have been disabled as Advanced Filters are enabled.",
    69: ({ guiFromFilter: guiFromFilter })=>`getGui method from filter returned ${guiFromFilter}; it should be a DOM element.`,
    70: ({ newFilter: newFilter })=>`Grid option quickFilterText only supports string inputs, received: ${typeof newFilter}`,
    71: ()=>"debounceMs is ignored when apply button is present",
    72: ({ keys: keys })=>[
            `ignoring FilterOptionDef as it doesn't contain one of `,
            keys
        ],
    73: ()=>`invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'`,
    74: ()=>"no filter options for filter",
    75: ()=>"Unknown button type specified",
    76: ({ filterModelType: filterModelType })=>[
            'Unexpected type of filter "',
            filterModelType,
            '", it looks like the filter was configured with incorrect Filter Options'
        ],
    77: ()=>`Filter model is missing 'conditions'`,
    78: ()=>'Filter Model contains more conditions than "filterParams.maxNumConditions". Additional conditions have been ignored.',
    79: ()=>'"filterParams.maxNumConditions" must be greater than or equal to zero.',
    80: ()=>'"filterParams.numAlwaysVisibleConditions" must be greater than or equal to zero.',
    81: ()=>'"filterParams.numAlwaysVisibleConditions" cannot be greater than "filterParams.maxNumConditions".',
    82: ({ param: param })=>`DateFilter ${param} is not a number`,
    83: ()=>`DateFilter minValidYear should be <= maxValidYear`,
    84: ()=>`DateFilter minValidDate should be <= maxValidDate`,
    85: ()=>"DateFilter should not have both minValidDate and minValidYear parameters set at the same time! minValidYear will be ignored.",
    86: ()=>"DateFilter should not have both maxValidDate and maxValidYear parameters set at the same time! maxValidYear will be ignored.",
    87: ()=>"DateFilter parameter minValidDate should always be lower than or equal to parameter maxValidDate.",
    88: ({ index: index })=>`Invalid row index for ensureIndexVisible: ${index}`,
    89: ()=>`A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)`,
    90: ()=>`datasource is missing getRows method`,
    91: ()=>"Filter is missing method doesFilterPass",
    92: ()=>`AnimationFrameService called but animation frames are off`,
    93: ()=>"cannot add multiple ranges when `cellSelection.suppressMultiRanges = true`",
    94: ({ paginationPageSizeOption: paginationPageSizeOption, pageSizeSet: pageSizeSet, pageSizesSet: pageSizesSet, pageSizeOptions: pageSizeOptions })=>`'paginationPageSize=${paginationPageSizeOption}'${pageSizeSet ? "" : " (default value)"}, but ${paginationPageSizeOption} is not included in${pageSizesSet ? "" : " the default"} paginationPageSizeSelector=[${pageSizeOptions?.join(", ")}].`,
    95: ({ paginationPageSizeOption: paginationPageSizeOption, paginationPageSizeSelector: paginationPageSizeSelector2 })=>`Either set '${paginationPageSizeSelector2}' to an array that includes ${paginationPageSizeOption} or to 'false' to disable the page size selector.`,
    96: ({ id: id, data: data })=>[
            "Duplicate ID",
            id,
            "found for pinned row with data",
            data,
            "When `getRowId` is defined, it must return unique IDs for all pinned rows. Use the `rowPinned` parameter."
        ],
    97: ({ colId: colId })=>`cellEditor for column ${colId} is missing getGui() method`,
    98: ()=>"popup cellEditor does not work with fullRowEdit - you cannot use them both - either turn off fullRowEdit, or stop using popup editors.",
    99: ()=>"Since v32, `api.hideOverlay()` does not hide the loading overlay when `loading=true`. Set `loading=false` instead.",
    // 100: ({ rowModelType }: { rowModelType: RowModelType }) =>
    //     `selectAll only available when rowModelType='clientSide', ie not ${rowModelType}` as const,
    101: ({ propertyName: propertyName, componentName: componentName, agGridDefaults: agGridDefaults, jsComps: jsComps })=>{
        const textOutput = [];
        const validComponents = [
            // Don't include the old names / internals in potential suggestions
            ...Object.keys(agGridDefaults ?? []).filter((k)=>![
                    "agCellEditor",
                    "agGroupRowRenderer",
                    "agSortIndicator"
                ].includes(k)),
            ...Object.keys(jsComps ?? []).filter((k)=>!!jsComps[k])
        ];
        const suggestions = $437b23f6a393c3bf$export$85cab1b5a4aa292c({
            inputValue: componentName,
            allSuggestions: validComponents,
            hideIrrelevant: true,
            filterByPercentageOfBestMatch: 0.8
        }).values;
        textOutput.push(`Could not find '${componentName}' component. It was configured as "${propertyName}: '${componentName}'" but it wasn't found in the list of registered components.
`);
        if (suggestions.length > 0) textOutput.push(`         Did you mean: [${suggestions.slice(0, 3)}]?
`);
        textOutput.push(`If using a custom component check it has been registered correctly.`);
        return textOutput;
    },
    102: ()=>"selectAll: 'filtered' only works when gridOptions.rowModelType='clientSide'",
    103: ()=>"Invalid selection state. When using client-side row model, the state must conform to `string[]`.",
    104: ({ value: value, param: param })=>`Numeric value ${value} passed to ${param} param will be interpreted as ${value} seconds. If this is intentional use "${value}s" to silence this warning.`,
    105: ({ e: e })=>[
            `chart rendering failed`,
            e
        ],
    106: ()=>`Theming API and Legacy Themes are both used in the same page. A Theming API theme has been provided to the 'theme' grid option, but the file (ag-grid.css) is also included and will cause styling issues. Remove ag-grid.css from the page. See the migration guide: ${$437b23f6a393c3bf$var$baseDocLink}/theming-migration/`,
    107: ({ key: key, value: value })=>`Invalid value for theme param ${key} - ${value}`,
    108: ({ e: e })=>[
            "chart update failed",
            e
        ],
    109: ({ inputValue: inputValue, allSuggestions: allSuggestions })=>{
        const suggestions = $437b23f6a393c3bf$export$85cab1b5a4aa292c({
            inputValue: inputValue,
            allSuggestions: allSuggestions,
            hideIrrelevant: true,
            filterByPercentageOfBestMatch: 0.8
        }).values;
        return [
            `Could not find '${inputValue}' aggregate function. It was configured as "aggFunc: '${inputValue}'" but it wasn't found in the list of registered aggregations.`,
            suggestions.length > 0 ? `         Did you mean: [${suggestions.slice(0, 3)}]?` : "",
            `If using a custom aggregation function check it has been registered correctly.`
        ].join("\n");
    },
    110: ()=>"groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup",
    111: ()=>"Invalid selection state. When `groupSelects` is enabled, the state must conform to `IServerSideGroupSelectionState`.",
    113: ()=>"Set Filter cannot initialise because you are using a row model that does not contain all rows in the browser. Either use a different filter type, or configure Set Filter such that you provide it with values",
    114: ({ component: component })=>`Could not find component with name of ${component}. Is it in Vue.components?`,
    // 115: () => 'The provided selection state should be an object.' as const,
    116: ()=>"Invalid selection state. The state must conform to `IServerSideSelectionState`.",
    117: ()=>"selectAll must be of boolean type.",
    118: ()=>"Infinite scrolling must be enabled in order to set the row count.",
    119: ()=>"Unable to instantiate filter",
    120: ()=>"MultiFloatingFilterComp expects MultiFilter as its parent",
    121: ()=>"a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (see AG Grid docs) or b) to toString() on the object to return a key",
    122: ()=>"could not find the document, document is empty",
    123: ()=>"Advanced Filter is only supported with the Client-Side Row Model or Server-Side Row Model.",
    124: ()=>"No active charts to update.",
    125: ({ chartId: chartId })=>`Unable to update chart. No active chart found with ID: ${chartId}.`,
    126: ()=>"unable to restore chart as no chart model is provided",
    127: ({ allRange: allRange })=>`unable to create chart as ${allRange ? "there are no columns in the grid" : "no range is selected"}.`,
    128: ({ feature: feature })=>`${feature} is only available if using 'multiRow' selection mode.`,
    129: ({ feature: feature, rowModel: rowModel })=>`${feature} is only available if using 'clientSide' or 'serverSide' rowModelType, you are using ${rowModel}.`,
    130: ()=>'cannot multi select unless selection mode is "multiRow"',
    // 131: () => 'cannot range select while selecting multiple rows' as const,
    132: ()=>"Row selection features are not available unless `rowSelection` is enabled.",
    133: ({ iconName: iconName })=>`icon '${iconName}' function should return back a string or a dom object`,
    134: ({ iconName: iconName })=>`Did not find icon '${iconName}'`,
    135: ()=>`Data type of the new value does not match the cell data type of the column`,
    136: ()=>`Unable to update chart as the 'type' is missing. It must be either 'rangeChartUpdate', 'pivotChartUpdate', or 'crossFilterChartUpdate'.`,
    137: ({ type: type, currentChartType: currentChartType })=>`Unable to update chart as a '${type}' update type is not permitted on a ${currentChartType}.`,
    138: ({ chartType: chartType })=>`invalid chart type supplied: ${chartType}`,
    139: ({ customThemeName: customThemeName })=>`a custom chart theme with the name ${customThemeName} has been supplied but not added to the 'chartThemes' list`,
    140: ({ name: name })=>`no stock theme exists with the name '${name}' and no custom chart theme with that name was supplied to 'customChartThemes'`,
    141: ()=>"cross filtering with row grouping is not supported.",
    142: ()=>"cross filtering is only supported in the client side row model.",
    143: ({ panel: panel })=>`'${panel}' is not a valid Chart Tool Panel name`,
    144: ({ type: type })=>`Invalid charts data panel group name supplied: '${type}'`,
    145: ({ group: group })=>`As of v32, only one charts customize panel group can be expanded at a time. '${group}' will not be expanded.`,
    146: ({ comp: comp })=>`Unable to instantiate component '${comp}' as its module hasn't been loaded. Add 'ValidationModule' to see which module is required.`,
    147: ({ group: group })=>`Invalid charts customize panel group name supplied: '${group}'`,
    148: ({ group: group })=>`invalid chartGroupsDef config '${group}'`,
    149: ({ group: group, chartType: chartType })=>`invalid chartGroupsDef config '${group}.${chartType}'`,
    150: ()=>`'seriesChartTypes' are required when the 'customCombo' chart type is specified.`,
    151: ({ chartType: chartType })=>`invalid chartType '${chartType}' supplied in 'seriesChartTypes', converting to 'line' instead.`,
    152: ({ colId: colId })=>`no 'seriesChartType' found for colId = '${colId}', defaulting to 'line'.`,
    153: ({ chartDataType: chartDataType })=>`unexpected chartDataType value '${chartDataType}' supplied, instead use 'category', 'series' or 'excluded'`,
    154: ({ colId: colId })=>`cross filtering requires a 'agSetColumnFilter' or 'agMultiColumnFilter' to be defined on the column with id: ${colId}`,
    155: ({ option: option })=>`'${option}' is not a valid Chart Toolbar Option`,
    156: ({ panel: panel })=>`Invalid panel in chartToolPanelsDef.panels: '${panel}'`,
    157: ({ unrecognisedGroupIds: unrecognisedGroupIds })=>[
            "unable to find group(s) for supplied groupIds:",
            unrecognisedGroupIds
        ],
    158: ()=>"can not expand a column item that does not represent a column group header",
    159: ()=>"Invalid params supplied to createExcelFileForExcel() - `ExcelExportParams.data` is empty.",
    160: ()=>`Export cancelled. Export is not allowed as per your configuration.`,
    161: ()=>"The Excel Exporter is currently on Multi Sheet mode. End that operation by calling 'api.getMultipleSheetAsExcel()' or 'api.exportMultipleSheetsAsExcel()'",
    162: ({ id: id, dataType: dataType })=>`Unrecognized data type for excel export [${id}.dataType=${dataType}]`,
    163: ({ featureName: featureName })=>`Excel table export does not work with ${featureName}. The exported Excel file will not contain any Excel tables.
 Please turn off ${featureName} to enable Excel table exports.`,
    164: ()=>"Unable to add data table to Excel sheet: A table already exists.",
    165: ()=>"Unable to add data table to Excel sheet: Missing required parameters.",
    166: ({ unrecognisedGroupIds: unrecognisedGroupIds })=>[
            "unable to find groups for these supplied groupIds:",
            unrecognisedGroupIds
        ],
    167: ({ unrecognisedColIds: unrecognisedColIds })=>[
            "unable to find columns for these supplied colIds:",
            unrecognisedColIds
        ],
    168: ()=>"detailCellRendererParams.template should be function or string",
    169: ()=>'Reference to eDetailGrid was missing from the details template. Please add data-ref="eDetailGrid" to the template.',
    170: ({ providedStrategy: providedStrategy })=>`invalid cellRendererParams.refreshStrategy = ${providedStrategy} supplied, defaulting to refreshStrategy = 'rows'.`,
    171: ()=>"could not find detail grid options for master detail, please set gridOptions.detailCellRendererParams.detailGridOptions",
    172: ()=>"could not find getDetailRowData for master / detail, please set gridOptions.detailCellRendererParams.getDetailRowData",
    173: ({ group: group })=>`invalid chartGroupsDef config '${group}'`,
    174: ({ group: group, chartType: chartType })=>`invalid chartGroupsDef config '${group}.${chartType}'`,
    175: ({ menuTabName: menuTabName, itemsToConsider: itemsToConsider })=>[
            `Trying to render an invalid menu item '${menuTabName}'. Check that your 'menuTabs' contains one of `,
            itemsToConsider
        ],
    176: ({ key: key })=>`unknown menu item type ${key}`,
    177: ()=>`valid values for cellSelection.handle.direction are 'x', 'y' and 'xy'. Default to 'xy'.`,
    178: ({ colId: colId })=>`column ${colId} is not visible`,
    179: ()=>"totalValueGetter should be either a function or a string (expression)",
    180: ()=>"agRichSelectCellEditor requires cellEditorParams.values to be set",
    181: ()=>"agRichSelectCellEditor cannot have `multiSelect` and `allowTyping` set to `true`. AllowTyping has been turned off.",
    182: ()=>'you cannot mix groupDisplayType = "multipleColumns" with treeData, only one column can be used to display groups when doing tree data',
    183: ()=>"Group Column Filter only works on group columns. Please use a different filter.",
    184: ({ parentGroupData: parentGroupData, childNodeData: childNodeData })=>[
            `duplicate group keys for row data, keys should be unique`,
            [
                parentGroupData,
                childNodeData
            ]
        ],
    185: ({ data: data })=>[
            `getDataPath() should not return an empty path`,
            [
                data
            ]
        ],
    186: ({ rowId: rowId, rowData: rowData, duplicateRowsData: duplicateRowsData })=>[
            `duplicate group keys for row data, keys should be unique`,
            rowId,
            rowData,
            ...duplicateRowsData ?? []
        ],
    187: ({ rowId: rowId, firstData: firstData, secondData: secondData })=>[
            `Duplicate node id ${rowId}. Row IDs are provided via the getRowId() callback. Please modify the getRowId() callback code to provide unique row id values.`,
            "first instance",
            firstData,
            "second instance",
            secondData
        ],
    188: ()=>`getRowId callback must be provided for Server Side Row Model selection to work correctly.`,
    189: ({ startRow: startRow })=>`invalid value ${startRow} for startRow, the value should be >= 0`,
    190: ({ rowGroupId: rowGroupId, data: data })=>[
            `null and undefined values are not allowed for server side row model keys`,
            rowGroupId ? `column = ${rowGroupId}` : ``,
            `data is `,
            data
        ],
    // 191: () => `cannot multi select unless selection mode is 'multiRow'` as const,
    // 192: () => `cannot use range selection when multi selecting rows` as const,
    // 193: () => "cannot multi select unless selection mode is 'multiRow'" as const,
    194: ({ method: method })=>`calling gridApi.${method}() is only possible when using rowModelType=\`clientSide\`.`,
    195: ({ justCurrentPage: justCurrentPage })=>`selecting just ${justCurrentPage ? "current page" : "filtered"} only works when gridOptions.rowModelType='clientSide'`,
    196: ({ key: key })=>`Provided ids must be of string type. Invalid id provided: ${key}`,
    197: ()=>"`toggledNodes` must be an array of string ids.",
    // 198: () => `cannot multi select unless selection mode is 'multiRow'` as const,
    199: ()=>`getSelectedNodes and getSelectedRows functions cannot be used with select all functionality with the server-side row model. Use \`api.getServerSideSelectionState()\` instead.`,
    200: $437b23f6a393c3bf$var$missingModule,
    201: ({ rowModelType: rowModelType })=>`Could not find row model for rowModelType = ${rowModelType}`,
    202: ()=>`\`getSelectedNodes\` and \`getSelectedRows\` functions cannot be used with \`groupSelectsChildren\` and the server-side row model. Use \`api.getServerSideSelectionState()\` instead.`,
    203: ()=>"Server Side Row Model does not support Dynamic Row Height and Cache Purging. Either a) remove getRowHeight() callback or b) remove maxBlocksInCache property. Purging has been disabled.",
    204: ()=>"Server Side Row Model does not support Auto Row Height and Cache Purging. Either a) remove colDef.autoHeight or b) remove maxBlocksInCache property. Purging has been disabled.",
    205: ({ duplicateIdText: duplicateIdText })=>`Unable to display rows as duplicate row ids (${duplicateIdText}) were returned by the getRowId callback. Please modify the getRowId callback to provide unique ids.`,
    206: ()=>"getRowId callback must be implemented for transactions to work. Transaction was ignored.",
    207: ()=>'The Set Filter Parameter "defaultToNothingSelected" value was ignored because it does not work when "excelMode" is used.',
    208: ()=>`Set Filter Value Formatter must return string values. Please ensure the Set Filter Value Formatter returns string values for complex objects.`,
    209: ()=>`Set Filter Key Creator is returning null for provided values and provided values are primitives. Please provide complex objects. See ${$437b23f6a393c3bf$var$baseDocLink}/filter-set-filter-list/#filter-value-types`,
    210: ()=>"Set Filter has a Key Creator, but provided values are primitives. Did you mean to provide complex objects?",
    211: ()=>"property treeList=true for Set Filter params, but you did not provide a treeListPathGetter or values of type Date.",
    212: ()=>`please review all your toolPanel components, it seems like at least one of them doesn't have an id`,
    213: ()=>"Advanced Filter does not work with Filters Tool Panel. Filters Tool Panel has been disabled.",
    214: ({ key: key })=>`unable to lookup Tool Panel as invalid key supplied: ${key}`,
    215: ({ key: key, defaultByKey: defaultByKey })=>`the key ${key} is not a valid key for specifying a tool panel, valid keys are: ${Object.keys(defaultByKey ?? {}).join(",")}`,
    216: ({ name: name })=>`Missing component for '${name}'`,
    217: ({ invalidColIds: invalidColIds })=>[
            "unable to find grid columns for the supplied colDef(s):",
            invalidColIds
        ],
    218: ({ property: property, defaultOffset: defaultOffset })=>`${property} must be a number, the value you provided is not a valid number. Using the default of ${defaultOffset}px.`,
    219: ({ property: property })=>`Property ${property} does not exist on the target object.`,
    220: ({ lineDash: lineDash })=>`'${lineDash}' is not a valid 'lineDash' option.`,
    221: ()=>`agAggregationComponent should only be used with the client and server side row model.`,
    222: ()=>`agFilteredRowCountComponent should only be used with the client side row model.`,
    223: ()=>`agSelectedRowCountComponent should only be used with the client and server side row model.`,
    224: ()=>`agTotalAndFilteredRowCountComponent should only be used with the client side row model.`,
    225: ()=>"agTotalRowCountComponent should only be used with the client side row model.",
    226: ()=>"viewport is missing init method.",
    227: ()=>"menu item icon must be DOM node or string",
    228: ({ menuItemOrString: menuItemOrString })=>`unrecognised menu item ${menuItemOrString}`,
    229: ({ index: index })=>[
            "invalid row index for ensureIndexVisible: ",
            index
        ],
    230: ()=>"detailCellRendererParams.template is not supported by AG Grid React. To change the template, provide a Custom Detail Cell Renderer. See https://www.ag-grid.com/react-data-grid/master-detail-custom-detail/",
    // @deprecated v32 mark for removal as part of v32 deprecated features
    231: ()=>"As of v32, using custom components with `reactiveCustomComponents = false` is deprecated.",
    232: ()=>"Using both rowData and v-model. rowData will be ignored.",
    233: ({ methodName: methodName })=>`Framework component is missing the method ${methodName}()`,
    234: ()=>'Group Column Filter does not work with the colDef property "field". This property will be ignored.',
    235: ()=>'Group Column Filter does not work with the colDef property "filterValueGetter". This property will be ignored.',
    236: ()=>'Group Column Filter does not work with the colDef property "filterParams". This property will be ignored.',
    237: ()=>"Group Column Filter does not work with Tree Data enabled. Please disable Tree Data, or use a different filter.",
    238: ()=>"setRowCount can only accept a positive row count.",
    239: ()=>'Theming API and CSS File Themes are both used in the same page. In v33 we released the Theming API as the new default method of styling the grid. See the migration docs https://www.ag-grid.com/react-data-grid/theming-migration/. Because no value was provided to the `theme` grid option it defaulted to themeQuartz. But the file (ag-grid.css) is also included and will cause styling issues. Either pass the string "legacy" to the theme grid option to use v32 style themes, or remove ag-grid.css from the page to use Theming API.',
    240: ({ theme: theme })=>`theme grid option must be a Theming API theme object or the string "legacy", received: ${theme}`,
    // 241: () => `cannot select multiple rows when rowSelection.mode is set to 'singleRow'` as const,
    // 242: () => 'cannot select multiple rows when using rangeSelect' as const,
    243: ()=>"Failed to deserialize state - each provided state object must be an object.",
    244: ()=>"Failed to deserialize state - `selectAllChildren` must be a boolean value or undefined.",
    245: ()=>"Failed to deserialize state - `toggledNodes` must be an array.",
    246: ()=>"Failed to deserialize state - Every `toggledNode` requires an associated string id.",
    247: ()=>`Row selection state could not be parsed due to invalid data. Ensure all child state has toggledNodes or does not conform with the parent rule. 
Please rebuild the selection state and reapply it.`,
    248: ()=>"SetFloatingFilter expects SetFilter as its parent",
    249: ()=>"Must supply a Value Formatter in Set Filter params when using a Key Creator",
    250: ()=>"Must supply a Key Creator in Set Filter params when `treeList = true` on a group column, and Tree Data or Row Grouping is enabled.",
    251: ({ chartType: chartType })=>`AG Grid: Unable to create chart as an invalid chartType = '${chartType}' was supplied.`,
    252: ()=>"cannot get grid to draw rows when it is in the middle of drawing rows. \nYour code probably called a grid API method while the grid was in the render stage. \nTo overcome this, put the API call into a timeout, e.g. instead of api.redrawRows(), call setTimeout(function() { api.redrawRows(); }, 0). \nTo see what part of your code that caused the refresh check this stacktrace.",
    253: ({ version: version })=>[
            "Illegal version string: ",
            version
        ],
    254: ()=>"Cannot create chart: no chart themes available.",
    255: ({ point: point })=>`Lone surrogate U+${point?.toString(16).toUpperCase()} is not a scalar value`,
    256: ()=>"Unable to initialise. See validation error, or load ValidationModule if missing.",
    257: ()=>$437b23f6a393c3bf$var$missingChartsWithModule("IntegratedChartsModule"),
    258: ()=>$437b23f6a393c3bf$var$missingChartsWithModule("SparklinesModule"),
    259: ({ part: part })=>`the argument to theme.withPart must be a Theming API part object, received: ${part}`,
    260: ({ propName: propName, compName: compName, gridScoped: gridScoped, gridId: gridId, rowModelType: rowModelType })=>$437b23f6a393c3bf$var$missingModule({
            reasonOrId: `AG Grid '${propName}' component: ${compName}`,
            moduleName: $437b23f6a393c3bf$var$USER_COMP_MODULES[compName],
            gridId: gridId,
            gridScoped: gridScoped,
            rowModelType: rowModelType
        }),
    261: ()=>"As of v33, `column.isHovered()` is deprecated. Use `api.isColumnHovered(column)` instead.",
    262: ()=>'As of v33, icon key "smallDown" is deprecated. Use "advancedFilterBuilderSelect" for Advanced Filter Builder dropdown, "selectOpen" for Select cell editor and dropdowns (e.g. Integrated Charts menu), "richSelectOpen" for Rich Select cell editor.',
    263: ()=>'As of v33, icon key "smallLeft" is deprecated. Use "panelDelimiterRtl" for Row Group Panel / Pivot Panel, "subMenuOpenRtl" for sub-menus.',
    264: ()=>'As of v33, icon key "smallRight" is deprecated. Use "panelDelimiter" for Row Group Panel / Pivot Panel, "subMenuOpen" for sub-menus.',
    265: ({ colId: colId })=>`Unable to infer chart data type for column '${colId}' if first data entry is null. Please specify "chartDataType", or a "cellDataType" in the column definition. For more information, see ${$437b23f6a393c3bf$var$baseDocLink}/integrated-charts-range-chart#coldefchartdatatype .`,
    266: ()=>'As of v33.1, using "keyCreator" with the Rich Select Editor has been deprecated. It now requires the "formatValue" callback to convert complex data to strings.',
    267: ()=>"Detail grids can not use a different theme to the master grid, the `theme` detail grid option will be ignored.",
    268: ()=>"Transactions aren't supported with tree data when using treeDataChildrenField",
    269: ()=>"When `masterSelects: 'detail'`, detail grids must be configured with multi-row selection",
    270: ({ id: id, parentId: parentId })=>`Cycle detected for row with id='${id}' and parent id='${parentId}'. Resetting the parent for row with id='${id}' and showing it as a root-level node.`,
    271: ({ id: id, parentId: parentId })=>`Parent row not found for row with id='${id}' and parent id='${parentId}'. Showing row with id='${id}' as a root-level node.`,
    272: ()=>$437b23f6a393c3bf$var$NoModulesRegisteredError(),
    273: ({ providedId: providedId, usedId: usedId })=>`Provided column id '${providedId}' was already in use, ensure all column and group ids are unique. Using '${usedId}' instead.`,
    274: ({ prop: prop })=>{
        let msg = `Since v33, ${prop} has been deprecated.`;
        switch(prop){
            case "maxComponentCreationTimeMs":
                msg += " This property is no longer required and so will be removed in a future version.";
                break;
            case "setGridApi":
                msg += ` This method is not called by AG Grid. To access the GridApi see: https://ag-grid.com/react-data-grid/grid-interface/#grid-api `;
                break;
            case "children":
                msg += ` For multiple versions AgGridReact does not support children.`;
                break;
        }
        return msg;
    },
    275: $437b23f6a393c3bf$var$missingRowModelTypeError,
    276: ()=>"Row Numbers Row Resizer cannot be used when Grid Columns have `autoHeight` enabled.",
    277: ({ colId: colId })=>`'enableFilterHandlers' is set to true, but column '${colId}' does not have 'filter.doesFilterPass' or 'filter.handler' set.`,
    278: ({ colId: colId })=>`Unable to create filter handler for column '${colId}'`,
    279: (_)=>{},
    // `Unable to create dynamic bean '${name}' during module init lifecycle, dynamic beans must be initialised on first use.` as const,
    280: ({ colId: colId })=>`'name' must be provided for custom filter components for column '${colId}`,
    281: ({ colId: colId })=>`Filter for column '${colId}' does not have 'filterParams.buttons', but the new Filters Tool Panel has buttons configured. Either configure buttons for the filter, or disable buttons on the Filters Tool Panel.`,
    282: ()=>"New filter tool panel requires `enableFilterHandlers: true`.",
    283: ()=>"As of v34, use the same method on the filter handler (`api.getColumnFilterHandler(colKey)`) instead.",
    284: ()=>"As of v34, filters are active when they have a model. Use `api.getColumnFilterModel()` instead.",
    285: ()=>"As of v34, use (`api.getColumnFilterModel()`) instead.",
    286: ()=>"As of v34, use (`api.setColumnFilterModel()`) instead.",
    287: ()=>"`api.doFilterAction()` requires `enableFilterHandlers = true",
    288: ()=>"`api.getColumnFilterModel(key, true)` requires `enableFilterHandlers = true",
    289: ({ rowModelType: rowModelType })=>`Row Model '${rowModelType}' is not supported with Batch Editing`,
    290: ({ rowIndex: rowIndex, rowPinned: rowPinned })=>`Row with index '${rowIndex}' and pinned state '${rowPinned}' not found`
};
function $437b23f6a393c3bf$var$getError(errorId, args) {
    const msgOrFunc = $437b23f6a393c3bf$var$AG_GRID_ERRORS[errorId];
    if (!msgOrFunc) return [
        `Missing error text for error id ${errorId}!`
    ];
    const errorBody = msgOrFunc(args);
    const errorLink = $437b23f6a393c3bf$var$getErrorLink(errorId, args);
    const errorSuffix = `
See ${errorLink}`;
    return Array.isArray(errorBody) ? errorBody.concat(errorSuffix) : [
        errorBody,
        errorSuffix
    ];
}
var $437b23f6a393c3bf$var$MISSING_MODULE_REASONS = {
    1: "Charting Aggregation",
    2: "pivotResultFields",
    3: "setTooltip"
};
// packages/ag-grid-community/src/grid.ts
var $437b23f6a393c3bf$var$_gridApiCache = /* @__PURE__ */ new WeakMap();
var $437b23f6a393c3bf$var$_gridElementCache = /* @__PURE__ */ new WeakMap();
function $437b23f6a393c3bf$export$fce123c48a7b4eae(eGridDiv, gridOptions, params) {
    if (!gridOptions) {
        $437b23f6a393c3bf$export$a20c7248650823a9(11);
        return {};
    }
    const gridParams = params;
    let destroyCallback;
    if (!gridParams?.setThemeOnGridDiv) {
        const newGridDiv = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div"
        });
        newGridDiv.style.height = "100%";
        eGridDiv.appendChild(newGridDiv);
        eGridDiv = newGridDiv;
        destroyCallback = ()=>eGridDiv.remove();
    }
    const api = new $437b23f6a393c3bf$export$7759b93c6200a2f9().create(eGridDiv, gridOptions, (context)=>{
        const gridComp = new $437b23f6a393c3bf$var$GridComp(eGridDiv);
        context.createBean(gridComp);
    }, void 0, params, destroyCallback);
    return api;
}
var $437b23f6a393c3bf$var$nextGridId = 1;
var $437b23f6a393c3bf$export$7759b93c6200a2f9 = class {
    create(eGridDiv, providedOptions, createUi, acceptChanges, params, _destroyCallback) {
        const gridOptions = $437b23f6a393c3bf$var$GlobalGridOptions.applyGlobalGridOptions(providedOptions);
        const gridId = gridOptions.gridId ?? String($437b23f6a393c3bf$var$nextGridId++);
        const registeredModules = this.getRegisteredModules(params, gridId, gridOptions.rowModelType);
        const beanClasses = this.createBeansList(gridOptions.rowModelType, registeredModules, gridId);
        const providedBeanInstances = this.createProvidedBeans(eGridDiv, gridOptions, params);
        if (!beanClasses) return void 0;
        const destroyCallback = ()=>{
            $437b23f6a393c3bf$var$_gridElementCache.delete(api);
            $437b23f6a393c3bf$var$_gridApiCache.delete(eGridDiv);
            _destroyCallback?.();
        };
        const contextParams = {
            providedBeanInstances: providedBeanInstances,
            beanClasses: beanClasses,
            gridId: gridId,
            beanInitComparator: $437b23f6a393c3bf$var$gridBeanInitComparator,
            beanDestroyComparator: $437b23f6a393c3bf$var$gridBeanDestroyComparator,
            derivedBeans: [
                $437b23f6a393c3bf$var$createGridApi
            ],
            destroyCallback: destroyCallback
        };
        const context = new $437b23f6a393c3bf$var$Context(contextParams);
        this.registerModuleFeatures(context, registeredModules);
        createUi(context);
        context.getBean("syncSvc").start();
        acceptChanges?.(context);
        const api = context.getBean("gridApi");
        $437b23f6a393c3bf$var$_gridApiCache.set(eGridDiv, api);
        $437b23f6a393c3bf$var$_gridElementCache.set(api, eGridDiv);
        return api;
    }
    getRegisteredModules(params, gridId, rowModelType) {
        $437b23f6a393c3bf$export$d0b008fbcc09e577($437b23f6a393c3bf$var$CommunityCoreModule, void 0, true);
        params?.modules?.forEach((m)=>$437b23f6a393c3bf$export$d0b008fbcc09e577(m, gridId));
        return $437b23f6a393c3bf$var$_getRegisteredModules(gridId, $437b23f6a393c3bf$var$getDefaultRowModelType(rowModelType));
    }
    registerModuleFeatures(context, registeredModules) {
        const registry = context.getBean("registry");
        const apiFunctionSvc = context.getBean("apiFunctionSvc");
        registeredModules.forEach((module)=>{
            registry.registerModule(module);
            const apiFunctions = module.apiFunctions;
            if (apiFunctions) {
                const names = Object.keys(apiFunctions);
                names.forEach((name)=>{
                    apiFunctionSvc?.addFunction(name, apiFunctions[name]);
                });
            }
        });
    }
    createProvidedBeans(eGridDiv, gridOptions, params) {
        let frameworkOverrides = params ? params.frameworkOverrides : null;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(frameworkOverrides)) frameworkOverrides = new $437b23f6a393c3bf$export$8174ad74937c6482();
        const seed = {
            gridOptions: gridOptions,
            eGridDiv: eGridDiv,
            globalListener: params ? params.globalListener : null,
            globalSyncListener: params ? params.globalSyncListener : null,
            frameworkOverrides: frameworkOverrides
        };
        if (params && params.providedBeanInstances) Object.assign(seed, params.providedBeanInstances);
        return seed;
    }
    createBeansList(userProvidedRowModelType, registeredModules, gridId) {
        const rowModelModuleNames = {
            clientSide: "ClientSideRowModel",
            infinite: "InfiniteRowModel",
            serverSide: "ServerSideRowModel",
            viewport: "ViewportRowModel"
        };
        const rowModelType = $437b23f6a393c3bf$var$getDefaultRowModelType(userProvidedRowModelType);
        const rowModuleModelName = rowModelModuleNames[rowModelType];
        if (!rowModuleModelName) {
            $437b23f6a393c3bf$var$_logPreInitErr(201, {
                rowModelType: rowModelType
            }, `Unknown rowModelType ${rowModelType}.`);
            return;
        }
        if (!$437b23f6a393c3bf$var$_hasUserRegistered()) {
            $437b23f6a393c3bf$var$_logPreInitErr(272, void 0, $437b23f6a393c3bf$var$NoModulesRegisteredError());
            return;
        }
        if (!userProvidedRowModelType) {
            const registeredRowModelModules = Object.entries(rowModelModuleNames).filter(([rowModelType2, module])=>$437b23f6a393c3bf$var$_isModuleRegistered(module, gridId, rowModelType2));
            if (registeredRowModelModules.length == 1) {
                const [userRowModelType, moduleName] = registeredRowModelModules[0];
                if (userRowModelType !== rowModelType) {
                    const params = {
                        moduleName: moduleName,
                        rowModelType: userRowModelType
                    };
                    $437b23f6a393c3bf$var$_logPreInitErr(275, params, $437b23f6a393c3bf$var$missingRowModelTypeError(params));
                    return;
                }
            }
        }
        if (!$437b23f6a393c3bf$var$_isModuleRegistered(rowModuleModelName, gridId, rowModelType)) {
            $437b23f6a393c3bf$var$_logPreInitErr(200, {
                reasonOrId: `rowModelType = '${rowModelType}'`,
                moduleName: rowModuleModelName,
                gridScoped: $437b23f6a393c3bf$var$_areModulesGridScoped(),
                gridId: gridId,
                rowModelType: rowModelType
            }, `Missing module ${rowModuleModelName}Module for rowModelType ${rowModelType}.`);
            return;
        }
        const beans = /* @__PURE__ */ new Set();
        registeredModules.forEach((module)=>module.beans?.forEach((bean)=>beans.add(bean)));
        return Array.from(beans);
    }
};
function $437b23f6a393c3bf$var$getDefaultRowModelType(passedRowModelType) {
    return passedRowModelType ?? "clientSide";
}
function $437b23f6a393c3bf$export$23a926ae0d6d33d3(gridElement) {
    if (typeof gridElement === "string") try {
        gridElement = document.querySelector(`[grid-id="${gridElement}"]`)?.parentElement ?? document.querySelector(gridElement)?.firstElementChild ?? document.getElementById(gridElement)?.firstElementChild;
    } catch  {
        gridElement = null;
    }
    return gridElement ? $437b23f6a393c3bf$var$_gridApiCache.get(gridElement) : void 0;
}
function $437b23f6a393c3bf$export$dbd289bae768c48d(api) {
    return $437b23f6a393c3bf$var$_gridElementCache.get(api);
}
// packages/ag-grid-community/src/api/rowModelApiUtils.ts
function $437b23f6a393c3bf$export$f5285e6f27a03f95(beans) {
    const rowModel = beans.rowModel;
    return rowModel.getType() === "clientSide" ? rowModel : void 0;
}
function $437b23f6a393c3bf$var$_getInfiniteRowModel(beans) {
    const rowModel = beans.rowModel;
    return rowModel.getType() === "infinite" ? rowModel : void 0;
}
function $437b23f6a393c3bf$export$aada92189a74e985(beans) {
    const rowModel = beans.rowModel;
    return rowModel.getType() === "serverSide" ? rowModel : void 0;
}
// packages/ag-grid-community/src/misc/locale/localeService.ts
var $437b23f6a393c3bf$export$f325e19d05d9c36d = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "localeSvc";
    }
    getLocaleTextFunc() {
        const gos = this.gos;
        const getLocaleText = gos.getCallback("getLocaleText");
        if (getLocaleText) return (key, defaultValue, variableValues)=>{
            const params = {
                key: key,
                defaultValue: defaultValue,
                variableValues: variableValues
            };
            return getLocaleText(params);
        };
        const localeText = gos.get("localeText");
        return (key, defaultValue, variableValues)=>{
            let localisedText = localeText && localeText[key];
            if (localisedText && variableValues && variableValues.length) {
                let found = 0;
                while(true){
                    if (found >= variableValues.length) break;
                    const idx = localisedText.indexOf("${variable}");
                    if (idx === -1) break;
                    localisedText = localisedText.replace("${variable}", variableValues[found++]);
                }
            }
            return localisedText ?? defaultValue;
        };
    }
};
// packages/ag-grid-community/src/misc/state/stateUtils.ts
function $437b23f6a393c3bf$export$9453e80be74134db(columnState, enablePivotMode = false) {
    const sortColumns = [];
    const groupColIds = [];
    const aggregationColumns = [];
    const pivotColIds = [];
    const leftColIds = [];
    const rightColIds = [];
    const hiddenColIds = [];
    const columnSizes = [];
    const columns = [];
    let defaultSortIndex = 0;
    for(let i = 0; i < columnState.length; i++){
        const { colId: colId, sort: sort, sortIndex: sortIndex, rowGroup: rowGroup, rowGroupIndex: rowGroupIndex, aggFunc: aggFunc, pivot: pivot, pivotIndex: pivotIndex, pinned: pinned, hide: hide, width: width, flex: flex } = columnState[i];
        columns.push(colId);
        if (sort) sortColumns[sortIndex ?? defaultSortIndex++] = {
            colId: colId,
            sort: sort
        };
        if (rowGroup) groupColIds[rowGroupIndex ?? 0] = colId;
        if (typeof aggFunc === "string") aggregationColumns.push({
            colId: colId,
            aggFunc: aggFunc
        });
        if (pivot) pivotColIds[pivotIndex ?? 0] = colId;
        if (pinned) (pinned === "right" ? rightColIds : leftColIds).push(colId);
        if (hide) hiddenColIds.push(colId);
        if (flex != null || width) columnSizes.push({
            colId: colId,
            flex: flex ?? void 0,
            width: width
        });
    }
    return {
        sort: sortColumns.length ? {
            sortModel: sortColumns
        } : void 0,
        rowGroup: groupColIds.length ? {
            groupColIds: groupColIds
        } : void 0,
        aggregation: aggregationColumns.length ? {
            aggregationModel: aggregationColumns
        } : void 0,
        pivot: pivotColIds.length || enablePivotMode ? {
            pivotMode: enablePivotMode,
            pivotColIds: pivotColIds
        } : void 0,
        columnPinning: leftColIds.length || rightColIds.length ? {
            leftColIds: leftColIds,
            rightColIds: rightColIds
        } : void 0,
        columnVisibility: hiddenColIds.length ? {
            hiddenColIds: hiddenColIds
        } : void 0,
        columnSizing: columnSizes.length ? {
            columnSizingModel: columnSizes
        } : void 0,
        columnOrder: columns.length ? {
            orderedColIds: columns
        } : void 0
    };
}
function $437b23f6a393c3bf$var$_convertColumnGroupState(columnGroupState) {
    const openColumnGroups = [];
    columnGroupState.forEach(({ groupId: groupId, open: open })=>{
        if (open) openColumnGroups.push(groupId);
    });
    return openColumnGroups.length ? {
        openColumnGroupIds: openColumnGroups
    } : void 0;
}
function $437b23f6a393c3bf$export$e5b0fd7258628d55(columnGroupState) {
    return {
        columnGroup: $437b23f6a393c3bf$var$_convertColumnGroupState(columnGroupState)
    };
}
// packages/ag-grid-community/src/components/framework/frameworkComponentWrapper.ts
var $437b23f6a393c3bf$export$157f014d661b6f19 = class {
    wrap(OriginalConstructor, mandatoryMethods, optionalMethods, componentType) {
        const wrapper = this.createWrapper(OriginalConstructor, componentType);
        mandatoryMethods?.forEach((methodName)=>{
            this.createMethod(wrapper, methodName, true);
        });
        optionalMethods?.forEach((methodName)=>{
            this.createMethod(wrapper, methodName, false);
        });
        return wrapper;
    }
    createMethod(wrapper, methodName, mandatory) {
        wrapper.addMethod(methodName, this.createMethodProxy(wrapper, methodName, mandatory));
    }
    createMethodProxy(wrapper, methodName, mandatory) {
        return function() {
            if (wrapper.hasMethod(methodName)) return wrapper.callMethod(methodName, arguments);
            if (mandatory) $437b23f6a393c3bf$export$545083624300f13d(49, {
                methodName: methodName
            });
            return null;
        };
    }
};
// packages/ag-grid-community/src/tooltip/tooltipComponent.ts
var $437b23f6a393c3bf$var$TooltipComponentElement = {
    tag: "div",
    cls: "ag-tooltip"
};
var $437b23f6a393c3bf$var$TooltipComponent2 = class extends $437b23f6a393c3bf$export$9fac2d040f3ed438 {
    constructor(){
        super($437b23f6a393c3bf$var$TooltipComponentElement);
    }
    // will need to type params
    init(params) {
        const { value: value } = params;
        const eGui = this.getGui();
        eGui.textContent = $437b23f6a393c3bf$export$a16cfb6652fe466f(value);
        const locationKebabCase = params.location.replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
        eGui.classList.add(`ag-${locationKebabCase}-tooltip`);
    }
};
// packages/ag-grid-community/src/tooltip/tooltipStateManager.ts
var $437b23f6a393c3bf$var$SHOW_QUICK_TOOLTIP_DIFF = 1e3;
var $437b23f6a393c3bf$var$FADE_OUT_TOOLTIP_TIMEOUT = 1e3;
var $437b23f6a393c3bf$var$INTERACTIVE_HIDE_DELAY = 100;
var $437b23f6a393c3bf$var$lastTooltipHideTime;
var $437b23f6a393c3bf$var$isLocked = false;
var $437b23f6a393c3bf$var$TooltipStateManager = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(tooltipCtrl, getTooltipValue){
        super();
        this.tooltipCtrl = tooltipCtrl;
        this.getTooltipValue = getTooltipValue;
        this.interactionEnabled = false;
        this.isInteractingWithTooltip = false;
        this.state = 0 /* NOTHING */ ;
        // when showing the tooltip, we need to make sure it's the most recent instance we request, as due to
        // async we could request two tooltips before the first instance returns, in which case we should
        // disregard the second instance.
        this.tooltipInstanceCount = 0;
        this.tooltipMouseTrack = false;
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
        this.userCompFactory = beans.userCompFactory;
    }
    postConstruct() {
        if (this.gos.get("tooltipInteraction")) this.interactionEnabled = true;
        this.tooltipTrigger = this.getTooltipTrigger();
        this.tooltipMouseTrack = this.gos.get("tooltipMouseTrack");
        const el = this.tooltipCtrl.getGui();
        if (this.tooltipTrigger === 0 /* HOVER */ ) this.addManagedListeners(el, {
            mouseenter: this.onMouseEnter.bind(this),
            mouseleave: this.onMouseLeave.bind(this)
        });
        if (this.tooltipTrigger === 1 /* FOCUS */ ) this.addManagedListeners(el, {
            focusin: this.onFocusIn.bind(this),
            focusout: this.onFocusOut.bind(this)
        });
        this.addManagedListeners(el, {
            mousemove: this.onMouseMove.bind(this)
        });
        if (!this.interactionEnabled) this.addManagedListeners(el, {
            mousedown: this.onMouseDown.bind(this),
            keydown: this.onKeyDown.bind(this)
        });
    }
    getGridOptionsTooltipDelay(delayOption) {
        const delay = this.gos.get(delayOption);
        return Math.max(200, delay);
    }
    getTooltipDelay(type) {
        if (type === "show") return this.tooltipCtrl.getTooltipShowDelayOverride?.() ?? this.getGridOptionsTooltipDelay("tooltipShowDelay");
        return this.tooltipCtrl.getTooltipHideDelayOverride?.() ?? this.getGridOptionsTooltipDelay("tooltipHideDelay");
    }
    destroy() {
        this.setToDoNothing();
        super.destroy();
    }
    getTooltipTrigger() {
        const trigger = this.gos.get("tooltipTrigger");
        if (!trigger || trigger === "hover") return 0 /* HOVER */ ;
        return 1 /* FOCUS */ ;
    }
    onMouseEnter(e) {
        if (this.interactionEnabled && this.interactiveTooltipTimeoutId) {
            this.unlockService();
            this.startHideTimeout();
        }
        if ($437b23f6a393c3bf$export$6b6034a68325bd8a()) return;
        if ($437b23f6a393c3bf$var$isLocked) this.showTooltipTimeoutId = window.setTimeout(()=>{
            this.prepareToShowTooltip(e);
        }, $437b23f6a393c3bf$var$INTERACTIVE_HIDE_DELAY);
        else this.prepareToShowTooltip(e);
    }
    onMouseMove(e) {
        if (this.lastMouseEvent) this.lastMouseEvent = e;
        if (this.tooltipMouseTrack && this.state === 2 /* SHOWING */  && this.tooltipComp) this.positionTooltip();
    }
    onMouseDown() {
        this.setToDoNothing();
    }
    onMouseLeave() {
        if (this.interactionEnabled) this.lockService();
        else this.setToDoNothing();
    }
    onFocusIn() {
        this.prepareToShowTooltip();
    }
    onFocusOut(e) {
        const relatedTarget = e.relatedTarget;
        const parentCompGui = this.tooltipCtrl.getGui();
        const tooltipGui = this.tooltipComp?.getGui();
        if (this.isInteractingWithTooltip || parentCompGui.contains(relatedTarget) || this.interactionEnabled && tooltipGui?.contains(relatedTarget)) return;
        this.setToDoNothing();
    }
    onKeyDown() {
        if (this.isInteractingWithTooltip) this.isInteractingWithTooltip = false;
        this.setToDoNothing();
    }
    prepareToShowTooltip(mouseEvent) {
        if (this.state != 0 /* NOTHING */  || $437b23f6a393c3bf$var$isLocked) return;
        let delay = 0;
        if (mouseEvent) delay = this.isLastTooltipHiddenRecently() ? 200 : this.getTooltipDelay("show");
        this.lastMouseEvent = mouseEvent || null;
        this.showTooltipTimeoutId = window.setTimeout(this.showTooltip.bind(this), delay);
        this.state = 1 /* WAITING_TO_SHOW */ ;
    }
    isLastTooltipHiddenRecently() {
        const now = Date.now();
        const then = $437b23f6a393c3bf$var$lastTooltipHideTime;
        return now - then < $437b23f6a393c3bf$var$SHOW_QUICK_TOOLTIP_DIFF;
    }
    setToDoNothing(fromHideTooltip) {
        if (!fromHideTooltip && this.state === 2 /* SHOWING */ ) this.hideTooltip();
        if (this.onBodyScrollEventCallback) {
            this.onBodyScrollEventCallback();
            this.onBodyScrollEventCallback = void 0;
        }
        if (this.onColumnMovedEventCallback) {
            this.onColumnMovedEventCallback();
            this.onColumnMovedEventCallback = void 0;
        }
        if (this.onDocumentKeyDownCallback) {
            this.onDocumentKeyDownCallback();
            this.onDocumentKeyDownCallback = void 0;
        }
        this.clearTimeouts();
        this.state = 0 /* NOTHING */ ;
        this.lastMouseEvent = null;
    }
    showTooltip() {
        const value = this.getTooltipValue();
        const ctrl = this.tooltipCtrl;
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) || ctrl.shouldDisplayTooltip && !ctrl.shouldDisplayTooltip()) {
            this.setToDoNothing();
            return;
        }
        const rowNode = ctrl.getRowNode?.();
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            location: ctrl.getLocation?.() ?? "UNKNOWN",
            //'cell',
            colDef: ctrl.getColDef?.(),
            column: ctrl.getColumn?.(),
            rowIndex: ctrl.getRowIndex?.(),
            node: rowNode,
            data: rowNode?.data,
            value: value,
            valueFormatted: ctrl.getValueFormatted?.(),
            hideTooltipCallback: ()=>this.hideTooltip(true),
            ...ctrl.getAdditionalParams?.() ?? {}
        });
        this.state = 2 /* SHOWING */ ;
        this.tooltipInstanceCount++;
        const callback = this.newTooltipComponentCallback.bind(this, this.tooltipInstanceCount);
        const userDetails = $437b23f6a393c3bf$var$_getTooltipCompDetails(this.userCompFactory, params);
        userDetails?.newAgStackInstance().then(callback);
    }
    hideTooltip(forceHide) {
        if (!forceHide && this.isInteractingWithTooltip) return;
        if (this.tooltipComp) {
            this.destroyTooltipComp();
            $437b23f6a393c3bf$var$lastTooltipHideTime = Date.now();
        }
        this.eventSvc.dispatchEvent({
            type: "tooltipHide",
            parentGui: this.tooltipCtrl.getGui()
        });
        if (forceHide) this.isInteractingWithTooltip = false;
        this.setToDoNothing(true);
    }
    newTooltipComponentCallback(tooltipInstanceCopy, tooltipComp) {
        const compNoLongerNeeded = this.state !== 2 /* SHOWING */  || this.tooltipInstanceCount !== tooltipInstanceCopy;
        if (compNoLongerNeeded) {
            this.destroyBean(tooltipComp);
            return;
        }
        const eGui = tooltipComp.getGui();
        this.tooltipComp = tooltipComp;
        if (!eGui.classList.contains("ag-tooltip")) eGui.classList.add("ag-tooltip-custom");
        if (this.tooltipTrigger === 0 /* HOVER */ ) eGui.classList.add("ag-tooltip-animate");
        if (this.interactionEnabled) eGui.classList.add("ag-tooltip-interactive");
        const translate = this.getLocaleTextFunc();
        const addPopupRes = this.popupSvc?.addPopup({
            eChild: eGui,
            ariaLabel: translate("ariaLabelTooltip", "Tooltip")
        });
        if (addPopupRes) this.tooltipPopupDestroyFunc = addPopupRes.hideFunc;
        this.positionTooltip();
        if (this.tooltipTrigger === 1 /* FOCUS */ ) {
            const listener = ()=>this.setToDoNothing();
            [this.onBodyScrollEventCallback, this.onColumnMovedEventCallback] = this.addManagedEventListeners({
                bodyScroll: listener,
                columnMoved: listener
            });
        }
        if (this.interactionEnabled) {
            [this.tooltipMouseEnterListener, this.tooltipMouseLeaveListener] = this.addManagedElementListeners(eGui, {
                mouseenter: this.onTooltipMouseEnter.bind(this),
                mouseleave: this.onTooltipMouseLeave.bind(this)
            });
            [this.onDocumentKeyDownCallback] = this.addManagedElementListeners($437b23f6a393c3bf$export$f63d0991874c6f81(this.beans), {
                keydown: (e)=>{
                    if (!eGui.contains(e?.target)) this.onKeyDown();
                }
            });
            if (this.tooltipTrigger === 1 /* FOCUS */ ) [this.tooltipFocusInListener, this.tooltipFocusOutListener] = this.addManagedElementListeners(eGui, {
                focusin: this.onTooltipFocusIn.bind(this),
                focusout: this.onTooltipFocusOut.bind(this)
            });
        }
        this.eventSvc.dispatchEvent({
            type: "tooltipShow",
            tooltipGui: eGui,
            parentGui: this.tooltipCtrl.getGui()
        });
        this.startHideTimeout();
    }
    onTooltipMouseEnter() {
        this.isInteractingWithTooltip = true;
        this.unlockService();
    }
    onTooltipMouseLeave() {
        if (this.isTooltipFocused()) return;
        this.isInteractingWithTooltip = false;
        this.lockService();
    }
    onTooltipFocusIn() {
        this.isInteractingWithTooltip = true;
    }
    isTooltipFocused() {
        const tooltipGui = this.tooltipComp?.getGui();
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        return !!tooltipGui && tooltipGui.contains(activeEl);
    }
    onTooltipFocusOut(e) {
        const parentGui = this.tooltipCtrl.getGui();
        if (this.isTooltipFocused()) return;
        this.isInteractingWithTooltip = false;
        if (parentGui.contains(e.relatedTarget)) this.startHideTimeout();
        else this.hideTooltip();
    }
    positionTooltip() {
        const params = {
            type: "tooltip",
            ePopup: this.tooltipComp.getGui(),
            nudgeY: 18,
            skipObserver: this.tooltipMouseTrack
        };
        if (this.lastMouseEvent) this.popupSvc?.positionPopupUnderMouseEvent({
            ...params,
            mouseEvent: this.lastMouseEvent
        });
        else this.popupSvc?.positionPopupByComponent({
            ...params,
            eventSource: this.tooltipCtrl.getGui(),
            position: "under",
            keepWithinBounds: true,
            nudgeY: 5
        });
    }
    destroyTooltipComp() {
        this.tooltipComp.getGui().classList.add("ag-tooltip-hiding");
        const tooltipPopupDestroyFunc = this.tooltipPopupDestroyFunc;
        const tooltipComp = this.tooltipComp;
        const delay = this.tooltipTrigger === 0 /* HOVER */  ? $437b23f6a393c3bf$var$FADE_OUT_TOOLTIP_TIMEOUT : 0;
        window.setTimeout(()=>{
            tooltipPopupDestroyFunc();
            this.destroyBean(tooltipComp);
        }, delay);
        this.clearTooltipListeners();
        this.tooltipPopupDestroyFunc = void 0;
        this.tooltipComp = void 0;
    }
    clearTooltipListeners() {
        [
            this.tooltipMouseEnterListener,
            this.tooltipMouseLeaveListener,
            this.tooltipFocusInListener,
            this.tooltipFocusOutListener
        ].forEach((listener)=>{
            if (listener) listener();
        });
        this.tooltipMouseEnterListener = this.tooltipMouseLeaveListener = this.tooltipFocusInListener = this.tooltipFocusOutListener = null;
    }
    lockService() {
        $437b23f6a393c3bf$var$isLocked = true;
        this.interactiveTooltipTimeoutId = window.setTimeout(()=>{
            this.unlockService();
            this.setToDoNothing();
        }, $437b23f6a393c3bf$var$INTERACTIVE_HIDE_DELAY);
    }
    unlockService() {
        $437b23f6a393c3bf$var$isLocked = false;
        this.clearInteractiveTimeout();
    }
    startHideTimeout() {
        this.clearHideTimeout();
        this.hideTooltipTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.getTooltipDelay("hide"));
    }
    clearShowTimeout() {
        if (!this.showTooltipTimeoutId) return;
        window.clearTimeout(this.showTooltipTimeoutId);
        this.showTooltipTimeoutId = void 0;
    }
    clearHideTimeout() {
        if (!this.hideTooltipTimeoutId) return;
        window.clearTimeout(this.hideTooltipTimeoutId);
        this.hideTooltipTimeoutId = void 0;
    }
    clearInteractiveTimeout() {
        if (!this.interactiveTooltipTimeoutId) return;
        window.clearTimeout(this.interactiveTooltipTimeoutId);
        this.interactiveTooltipTimeoutId = void 0;
    }
    clearTimeouts() {
        this.clearShowTimeout();
        this.clearHideTimeout();
        this.clearInteractiveTimeout();
    }
};
// packages/ag-grid-community/src/tooltip/tooltipFeature.ts
function $437b23f6a393c3bf$export$58660753196c7cdf(gos) {
    return gos.get("tooltipShowMode") === "whenTruncated";
}
function $437b23f6a393c3bf$export$75f51ed61a5271e6(gos, getElement2) {
    return $437b23f6a393c3bf$export$58660753196c7cdf(gos) ? $437b23f6a393c3bf$export$8980540b0a37a11d(getElement2) : void 0;
}
var $437b23f6a393c3bf$export$e5073a590d24815c = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(ctrl, beans){
        super();
        this.ctrl = ctrl;
        if (beans) this.beans = beans;
    }
    postConstruct() {
        this.refreshTooltip();
    }
    /**
   *
   * @param tooltip The tooltip value
   * @param allowEmptyString Set it to true to allow the title to be set to `''`. This is necessary
   * when the browser adds a default tooltip the element and the tooltip service will be displayed
   * next to a browser tooltip causing confusion.
   */ setBrowserTooltip(tooltip, allowEmptyString) {
        const name = "title";
        const eGui = this.ctrl.getGui();
        if (!eGui) return;
        if (tooltip != null && (tooltip != "" || allowEmptyString)) eGui.setAttribute(name, tooltip);
        else eGui.removeAttribute(name);
    }
    updateTooltipText() {
        const { getTooltipValue: getTooltipValue } = this.ctrl;
        if (getTooltipValue) this.tooltip = getTooltipValue();
    }
    createTooltipFeatureIfNeeded() {
        if (this.tooltipManager == null) this.tooltipManager = this.createBean(new $437b23f6a393c3bf$var$TooltipStateManager(this.ctrl, ()=>this.tooltip), this.beans.context);
    }
    setTooltipAndRefresh(tooltip) {
        this.tooltip = tooltip;
        this.refreshTooltip();
    }
    refreshTooltip(clearWithEmptyString) {
        this.browserTooltips = this.beans.gos.get("enableBrowserTooltips");
        this.updateTooltipText();
        if (this.browserTooltips) {
            this.setBrowserTooltip(this.tooltip);
            this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context);
        } else {
            this.setBrowserTooltip(clearWithEmptyString ? "" : null, clearWithEmptyString);
            this.createTooltipFeatureIfNeeded();
        }
    }
    destroy() {
        this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context);
        super.destroy();
    }
};
// packages/ag-grid-community/src/utils/number.ts
function $437b23f6a393c3bf$export$c8980add4a69422e(value, getLocaleTextFunc) {
    if (typeof value !== "number") return "";
    const localeTextFunc = getLocaleTextFunc();
    const thousandSeparator = localeTextFunc("thousandSeparator", ",");
    const decimalSeparator = localeTextFunc("decimalSeparator", ".");
    return value.toString().replace(".", decimalSeparator).replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandSeparator}`);
}
// packages/ag-grid-community/src/export/baseCreator.ts
var $437b23f6a393c3bf$export$b335f23c5aead909 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    getFileName(fileName) {
        const extension = this.getDefaultFileExtension();
        if (fileName == null || !fileName.length) fileName = this.getDefaultFileName();
        return fileName.indexOf(".") === -1 ? `${fileName}.${extension}` : fileName;
    }
    getData(params) {
        const serializingSession = this.createSerializingSession(params);
        return this.beans.gridSerializer.serialize(serializingSession, params);
    }
    getDefaultFileName() {
        return `export.${this.getDefaultFileExtension()}`;
    }
};
// packages/ag-grid-community/src/export/baseGridSerializingSession.ts
var $437b23f6a393c3bf$export$5018ab277b833b61 = class {
    constructor(config){
        const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc, colNames: colNames, valueSvc: valueSvc, gos: gos, processCellCallback: processCellCallback, processHeaderCallback: processHeaderCallback, processGroupHeaderCallback: processGroupHeaderCallback, processRowGroupCallback: processRowGroupCallback } = config;
        this.colModel = colModel;
        this.rowGroupColsSvc = rowGroupColsSvc;
        this.colNames = colNames;
        this.valueSvc = valueSvc;
        this.gos = gos;
        this.processCellCallback = processCellCallback;
        this.processHeaderCallback = processHeaderCallback;
        this.processGroupHeaderCallback = processGroupHeaderCallback;
        this.processRowGroupCallback = processRowGroupCallback;
    }
    prepare(_columnsToExport) {}
    extractHeaderValue(column) {
        const value = this.getHeaderName(this.processHeaderCallback, column);
        return value ?? "";
    }
    extractRowCellValue(column, currentColumnIndex, accumulatedRowIndex, type, node) {
        const isFullWidthGroup = currentColumnIndex === 0 && $437b23f6a393c3bf$export$410912a9c501b8cc(this.gos, node, this.colModel.isPivotMode());
        if (this.processRowGroupCallback && (this.gos.get("treeData") || node.group) && (column.isRowGroupDisplayed(node.rowGroupColumn?.getColId() ?? "") || isFullWidthGroup)) return {
            value: this.processRowGroupCallback($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                column: column,
                node: node
            })) ?? ""
        };
        if (this.processCellCallback) return {
            value: this.processCellCallback($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                accumulatedRowIndex: accumulatedRowIndex,
                column: column,
                node: node,
                value: this.valueSvc.getValueForDisplay(column, node, void 0, void 0).value,
                type: type,
                parseValue: (valueToParse)=>this.valueSvc.parseValue(column, node, valueToParse, this.valueSvc.getValue(column, node, void 0)),
                formatValue: (valueToFormat)=>this.valueSvc.formatValue(column, node, valueToFormat) ?? valueToFormat
            })) ?? ""
        };
        const isTreeData = this.gos.get("treeData");
        const valueService = this.valueSvc;
        const isGrandTotalRow = node.level === -1 && node.footer;
        const isMultiAutoCol = column.colDef.showRowGroup === true && (node.group || isTreeData);
        if (!isGrandTotalRow && (isFullWidthGroup || isMultiAutoCol)) {
            let concatenatedGroupValue = "";
            let pointer = node;
            while(pointer && pointer.level !== -1){
                const { value: value2, valueFormatted: valueFormatted2 } = valueService.getValueForDisplay(isFullWidthGroup ? void 0 : column, // full width group doesn't have a column
                pointer, true, true);
                concatenatedGroupValue = ` -> ${valueFormatted2 ?? value2 ?? ""}${concatenatedGroupValue}`;
                pointer = pointer.parent;
            }
            return {
                value: concatenatedGroupValue,
                // don't return the unformatted value; as if the grid detects number it'll not use the concatenated string
                valueFormatted: concatenatedGroupValue
            };
        }
        const { value: value, valueFormatted: valueFormatted } = valueService.getValueForDisplay(column, node, true, true);
        return {
            value: value ?? "",
            valueFormatted: valueFormatted
        };
    }
    getHeaderName(callback, column) {
        if (callback) return callback($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            column: column
        }));
        return this.colNames.getDisplayNameForColumn(column, "csv", true);
    }
};
// packages/ag-grid-community/src/export/downloader.ts
function $437b23f6a393c3bf$export$97aef6bcdc3f7ef5(fileName, content) {
    const win = document.defaultView || window;
    if (!win) {
        $437b23f6a393c3bf$export$545083624300f13d(52);
        return;
    }
    const element = document.createElement("a");
    const url = win.URL.createObjectURL(content);
    element.setAttribute("href", url);
    element.setAttribute("download", fileName);
    element.style.display = "none";
    document.body.appendChild(element);
    element.dispatchEvent(new MouseEvent("click", {
        bubbles: false,
        cancelable: true,
        view: win
    }));
    document.body.removeChild(element);
    win.setTimeout(()=>{
        win.URL.revokeObjectURL(url);
    }, 0);
}
// packages/ag-grid-community/src/gridOptionsInitial.ts
var $437b23f6a393c3bf$var$INITIAL_GRID_OPTION_KEYS = {
    enableBrowserTooltips: true,
    tooltipTrigger: true,
    tooltipMouseTrack: true,
    tooltipShowMode: true,
    tooltipInteraction: true,
    defaultColGroupDef: true,
    suppressAutoSize: true,
    skipHeaderOnAutoSize: true,
    autoSizeStrategy: true,
    components: true,
    stopEditingWhenCellsLoseFocus: true,
    undoRedoCellEditing: true,
    undoRedoCellEditingLimit: true,
    excelStyles: true,
    cacheQuickFilter: true,
    customChartThemes: true,
    chartThemeOverrides: true,
    chartToolPanelsDef: true,
    loadingCellRendererSelector: true,
    localeText: true,
    keepDetailRows: true,
    keepDetailRowsCount: true,
    detailRowHeight: true,
    detailRowAutoHeight: true,
    tabIndex: true,
    valueCache: true,
    valueCacheNeverExpires: true,
    enableCellExpressions: true,
    suppressTouch: true,
    suppressBrowserResizeObserver: true,
    suppressPropertyNamesCheck: true,
    debug: true,
    dragAndDropImageComponent: true,
    loadingOverlayComponent: true,
    suppressLoadingOverlay: true,
    noRowsOverlayComponent: true,
    paginationPageSizeSelector: true,
    paginateChildRows: true,
    pivotPanelShow: true,
    pivotSuppressAutoColumn: true,
    suppressExpandablePivotGroups: true,
    aggFuncs: true,
    allowShowChangeAfterFilter: true,
    ensureDomOrder: true,
    enableRtl: true,
    suppressColumnVirtualisation: true,
    suppressMaxRenderedRowRestriction: true,
    suppressRowVirtualisation: true,
    rowDragText: true,
    groupLockGroupColumns: true,
    suppressGroupRowsSticky: true,
    rowModelType: true,
    cacheOverflowSize: true,
    infiniteInitialRowCount: true,
    serverSideInitialRowCount: true,
    maxBlocksInCache: true,
    maxConcurrentDatasourceRequests: true,
    blockLoadDebounceMillis: true,
    serverSideOnlyRefreshFilteredGroups: true,
    serverSidePivotResultFieldSeparator: true,
    viewportRowModelPageSize: true,
    viewportRowModelBufferSize: true,
    debounceVerticalScrollbar: true,
    suppressAnimationFrame: true,
    suppressPreventDefaultOnMouseWheel: true,
    scrollbarWidth: true,
    icons: true,
    suppressRowTransform: true,
    gridId: true,
    enableGroupEdit: true,
    initialState: true,
    processUnpinnedColumns: true,
    createChartContainer: true,
    getLocaleText: true,
    getRowId: true,
    reactiveCustomComponents: true,
    renderingMode: true,
    columnMenu: true,
    suppressSetFilterByDefault: true,
    getDataPath: true,
    enableCellSpan: true,
    enableFilterHandlers: true,
    filterHandlers: true
};
// packages/ag-grid-community/src/validation/apiFunctionValidator.ts
var $437b23f6a393c3bf$var$clientSide = "clientSide";
var $437b23f6a393c3bf$var$serverSide = "serverSide";
var $437b23f6a393c3bf$var$infinite = "infinite";
var $437b23f6a393c3bf$var$functionRowModels = {
    onGroupExpandedOrCollapsed: [
        $437b23f6a393c3bf$var$clientSide
    ],
    refreshClientSideRowModel: [
        $437b23f6a393c3bf$var$clientSide
    ],
    isRowDataEmpty: [
        $437b23f6a393c3bf$var$clientSide
    ],
    forEachLeafNode: [
        $437b23f6a393c3bf$var$clientSide
    ],
    forEachNodeAfterFilter: [
        $437b23f6a393c3bf$var$clientSide
    ],
    forEachNodeAfterFilterAndSort: [
        $437b23f6a393c3bf$var$clientSide
    ],
    resetRowHeights: [
        $437b23f6a393c3bf$var$clientSide
    ],
    applyTransaction: [
        $437b23f6a393c3bf$var$clientSide
    ],
    applyTransactionAsync: [
        $437b23f6a393c3bf$var$clientSide
    ],
    flushAsyncTransactions: [
        $437b23f6a393c3bf$var$clientSide
    ],
    getBestCostNodeSelection: [
        $437b23f6a393c3bf$var$clientSide
    ],
    getServerSideSelectionState: [
        $437b23f6a393c3bf$var$serverSide
    ],
    setServerSideSelectionState: [
        $437b23f6a393c3bf$var$serverSide
    ],
    applyServerSideTransaction: [
        $437b23f6a393c3bf$var$serverSide
    ],
    applyServerSideTransactionAsync: [
        $437b23f6a393c3bf$var$serverSide
    ],
    applyServerSideRowData: [
        $437b23f6a393c3bf$var$serverSide
    ],
    retryServerSideLoads: [
        $437b23f6a393c3bf$var$serverSide
    ],
    flushServerSideAsyncTransactions: [
        $437b23f6a393c3bf$var$serverSide
    ],
    refreshServerSide: [
        $437b23f6a393c3bf$var$serverSide
    ],
    getServerSideGroupLevelState: [
        $437b23f6a393c3bf$var$serverSide
    ],
    refreshInfiniteCache: [
        $437b23f6a393c3bf$var$infinite
    ],
    purgeInfiniteCache: [
        $437b23f6a393c3bf$var$infinite
    ],
    getInfiniteRowCount: [
        $437b23f6a393c3bf$var$infinite
    ],
    isLastRowIndexKnown: [
        $437b23f6a393c3bf$var$infinite,
        $437b23f6a393c3bf$var$serverSide
    ],
    expandAll: [
        $437b23f6a393c3bf$var$clientSide,
        $437b23f6a393c3bf$var$serverSide
    ],
    collapseAll: [
        $437b23f6a393c3bf$var$clientSide,
        $437b23f6a393c3bf$var$serverSide
    ],
    onRowHeightChanged: [
        $437b23f6a393c3bf$var$clientSide,
        $437b23f6a393c3bf$var$serverSide
    ],
    setRowCount: [
        $437b23f6a393c3bf$var$infinite,
        $437b23f6a393c3bf$var$serverSide
    ],
    getCacheBlockState: [
        $437b23f6a393c3bf$var$infinite,
        $437b23f6a393c3bf$var$serverSide
    ]
};
var $437b23f6a393c3bf$var$deprecatedFunctions = {
    showLoadingOverlay: {
        version: "v32",
        message: '`showLoadingOverlay` is deprecated. Use the grid option "loading"=true instead or setGridOption("loading", true).'
    },
    clearRangeSelection: {
        version: "v32.2",
        message: "Use `clearCellSelection` instead."
    },
    getInfiniteRowCount: {
        version: "v32.2",
        old: "getInfiniteRowCount()",
        new: "getDisplayedRowCount()"
    },
    selectAllFiltered: {
        version: "v33",
        old: "selectAllFiltered()",
        new: 'selectAll("filtered")'
    },
    deselectAllFiltered: {
        version: "v33",
        old: "deselectAllFiltered()",
        new: 'deselectAll("filtered")'
    },
    selectAllOnCurrentPage: {
        version: "v33",
        old: "selectAllOnCurrentPage()",
        new: 'selectAll("currentPage")'
    },
    deselectAllOnCurrentPage: {
        version: "v33",
        old: "deselectAllOnCurrentPage()",
        new: 'deselectAll("currentPage")'
    }
};
function $437b23f6a393c3bf$var$validateApiFunction(functionName, apiFunction, beans) {
    const deprecation = $437b23f6a393c3bf$var$deprecatedFunctions[functionName];
    if (deprecation) {
        const { version: version, new: replacement, old: old, message: message } = deprecation;
        const apiMethod = old ?? functionName;
        return (...args)=>{
            const replacementMessage = replacement ? `Please use ${replacement} instead. ` : "";
            $437b23f6a393c3bf$export$2cf41453020eef66(`Since ${version} api.${apiMethod} is deprecated. ${replacementMessage}${message ?? ""}`);
            return apiFunction.apply(apiFunction, args);
        };
    }
    const rowModels = $437b23f6a393c3bf$var$functionRowModels[functionName];
    if (rowModels) return (...args)=>{
        const rowModel = beans.rowModel.getType();
        if (!rowModels.includes(rowModel)) {
            $437b23f6a393c3bf$var$_errorOnce(`api.${functionName} can only be called when gridOptions.rowModelType is ${rowModels.join(" or ")}`);
            return void 0;
        }
        return apiFunction.apply(apiFunction, args);
    };
    return apiFunction;
}
// packages/ag-grid-community/src/validation/rules/dynamicBeanValidations.ts
var $437b23f6a393c3bf$var$DYNAMIC_BEAN_MODULES = {
    detailCellRendererCtrl: "SharedMasterDetail",
    dndSourceComp: "DragAndDrop",
    fillHandle: "CellSelection",
    groupCellRendererCtrl: "GroupCellRenderer",
    headerFilterCellCtrl: "ColumnFilter",
    headerGroupCellCtrl: "ColumnGroup",
    rangeHandle: "CellSelection",
    tooltipFeature: "Tooltip",
    groupStrategy: "RowGrouping",
    treeGroupStrategy: "TreeData",
    rowNumberRowResizer: "RowNumbers",
    singleCell: "EditCore",
    fullRow: "EditCore",
    agSetColumnFilterHandler: "SetFilter",
    agMultiColumnFilterHandler: "MultiFilter",
    agGroupColumnFilterHandler: "GroupFilter",
    agNumberColumnFilterHandler: "NumberFilter",
    agDateColumnFilterHandler: "DateFilter",
    agTextColumnFilterHandler: "TextFilter"
};
// packages/ag-grid-community/src/validation/rules/iconValidations.ts
var $437b23f6a393c3bf$var$ICON_VALUES = {
    expanded: 1,
    contracted: 1,
    "tree-closed": 1,
    "tree-open": 1,
    "tree-indeterminate": 1,
    pin: 1,
    "eye-slash": 1,
    arrows: 1,
    left: 1,
    right: 1,
    group: 1,
    aggregation: 1,
    pivot: 1,
    "not-allowed": 1,
    chart: 1,
    cross: 1,
    cancel: 1,
    tick: 1,
    first: 1,
    previous: 1,
    next: 1,
    last: 1,
    linked: 1,
    unlinked: 1,
    "color-picker": 1,
    loading: 1,
    menu: 1,
    "menu-alt": 1,
    filter: 1,
    "filter-add": 1,
    columns: 1,
    maximize: 1,
    minimize: 1,
    copy: 1,
    cut: 1,
    paste: 1,
    grip: 1,
    save: 1,
    csv: 1,
    excel: 1,
    "small-down": 1,
    "small-left": 1,
    "small-right": 1,
    "small-up": 1,
    asc: 1,
    desc: 1,
    none: 1,
    up: 1,
    down: 1,
    plus: 1,
    minus: 1,
    settings: 1,
    "checkbox-checked": 1,
    "checkbox-indeterminate": 1,
    "checkbox-unchecked": 1,
    "radio-button-on": 1,
    "radio-button-off": 1,
    eye: 1,
    "column-arrow": 1,
    "un-pin": 1,
    "pinned-top": 1,
    "pinned-bottom": 1,
    "chevron-up": 1,
    "chevron-down": 1,
    "chevron-left": 1,
    "chevron-right": 1,
    edit: 1
};
var $437b23f6a393c3bf$var$ICON_MODULES = {
    chart: "MenuCore",
    cancel: "EnterpriseCore",
    first: "Pagination",
    previous: "Pagination",
    next: "Pagination",
    last: "Pagination",
    linked: "IntegratedCharts",
    loadingMenuItems: "MenuCore",
    unlinked: "IntegratedCharts",
    menu: "ColumnHeaderComp",
    legacyMenu: "ColumnMenu",
    filter: "ColumnFilter",
    filterActive: "ColumnFilter",
    filterAdd: "NewFiltersToolPanel",
    filterCardCollapse: "NewFiltersToolPanel",
    filterCardExpand: "NewFiltersToolPanel",
    filterCardEditing: "NewFiltersToolPanel",
    filterTab: "ColumnMenu",
    filtersToolPanel: "FiltersToolPanel",
    columns: [
        "MenuCore"
    ],
    columnsToolPanel: [
        "ColumnsToolPanel"
    ],
    maximize: "EnterpriseCore",
    minimize: "EnterpriseCore",
    save: "MenuCore",
    columnGroupOpened: "ColumnGroupHeaderComp",
    columnGroupClosed: "ColumnGroupHeaderComp",
    accordionOpen: "EnterpriseCore",
    accordionClosed: "EnterpriseCore",
    accordionIndeterminate: "EnterpriseCore",
    columnSelectClosed: [
        "ColumnsToolPanel",
        "ColumnMenu"
    ],
    columnSelectOpen: [
        "ColumnsToolPanel",
        "ColumnMenu"
    ],
    columnSelectIndeterminate: [
        "ColumnsToolPanel",
        "ColumnMenu"
    ],
    columnMovePin: "SharedDragAndDrop",
    columnMoveHide: "SharedDragAndDrop",
    columnMoveMove: "SharedDragAndDrop",
    columnMoveLeft: "SharedDragAndDrop",
    columnMoveRight: "SharedDragAndDrop",
    columnMoveGroup: "SharedDragAndDrop",
    columnMoveValue: "SharedDragAndDrop",
    columnMovePivot: "SharedDragAndDrop",
    dropNotAllowed: "SharedDragAndDrop",
    ensureColumnVisible: [
        "ColumnsToolPanel",
        "ColumnMenu"
    ],
    groupContracted: "GroupCellRenderer",
    groupExpanded: "GroupCellRenderer",
    setFilterGroupClosed: "SetFilter",
    setFilterGroupOpen: "SetFilter",
    setFilterGroupIndeterminate: "SetFilter",
    setFilterLoading: "SetFilter",
    close: "EnterpriseCore",
    check: "MenuItem",
    colorPicker: "CommunityCore",
    groupLoading: "LoadingCellRenderer",
    menuAlt: "ColumnHeaderComp",
    menuPin: "MenuCore",
    menuValue: "MenuCore",
    menuAddRowGroup: [
        "MenuCore",
        "ColumnsToolPanel"
    ],
    menuRemoveRowGroup: [
        "MenuCore",
        "ColumnsToolPanel"
    ],
    clipboardCopy: "MenuCore",
    clipboardCut: "MenuCore",
    clipboardPaste: "MenuCore",
    pivotPanel: [
        "ColumnsToolPanel",
        "RowGroupingPanel"
    ],
    rowGroupPanel: [
        "ColumnsToolPanel",
        "RowGroupingPanel"
    ],
    valuePanel: "ColumnsToolPanel",
    columnDrag: "EnterpriseCore",
    rowDrag: [
        "RowDrag",
        "DragAndDrop"
    ],
    csvExport: "MenuCore",
    excelExport: "MenuCore",
    smallDown: "CommunityCore",
    selectOpen: "CommunityCore",
    richSelectOpen: "RichSelect",
    richSelectRemove: "RichSelect",
    smallLeft: "CommunityCore",
    smallRight: "CommunityCore",
    subMenuOpen: "MenuItem",
    subMenuOpenRtl: "MenuItem",
    panelDelimiter: "RowGroupingPanel",
    panelDelimiterRtl: "RowGroupingPanel",
    smallUp: "CommunityCore",
    sortAscending: [
        "MenuCore",
        "Sort"
    ],
    sortDescending: [
        "MenuCore",
        "Sort"
    ],
    sortUnSort: [
        "MenuCore",
        "Sort"
    ],
    advancedFilterBuilder: "AdvancedFilter",
    advancedFilterBuilderDrag: "AdvancedFilter",
    advancedFilterBuilderInvalid: "AdvancedFilter",
    advancedFilterBuilderMoveUp: "AdvancedFilter",
    advancedFilterBuilderMoveDown: "AdvancedFilter",
    advancedFilterBuilderAdd: "AdvancedFilter",
    advancedFilterBuilderRemove: "AdvancedFilter",
    advancedFilterBuilderSelectOpen: "AdvancedFilter",
    chartsMenu: "IntegratedCharts",
    chartsMenuEdit: "IntegratedCharts",
    chartsMenuAdvancedSettings: "IntegratedCharts",
    chartsMenuAdd: "IntegratedCharts",
    chartsColorPicker: "IntegratedCharts",
    chartsThemePrevious: "IntegratedCharts",
    chartsThemeNext: "IntegratedCharts",
    chartsDownload: "IntegratedCharts",
    checkboxChecked: "CommunityCore",
    checkboxIndeterminate: "CommunityCore",
    checkboxUnchecked: "CommunityCore",
    radioButtonOn: "CommunityCore",
    radioButtonOff: "CommunityCore",
    rowPin: "PinnedRow",
    rowUnpin: "PinnedRow",
    rowPinBottom: "PinnedRow",
    rowPinTop: "PinnedRow"
};
var $437b23f6a393c3bf$var$DEPRECATED_ICONS_V33 = /* @__PURE__ */ new Set([
    "colorPicker",
    "smallUp",
    "checkboxChecked",
    "checkboxIndeterminate",
    "checkboxUnchecked",
    "radioButtonOn",
    "radioButtonOff",
    "smallDown",
    "smallLeft",
    "smallRight"
]);
// packages/ag-grid-community/src/validation/validationService.ts
var $437b23f6a393c3bf$var$ValidationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "validation";
    }
    wireBeans(beans) {
        this.gridOptions = beans.gridOptions;
        $437b23f6a393c3bf$var$provideValidationServiceLogger(this);
    }
    warnOnInitialPropertyUpdate(source, key) {
        if (source === "api" && $437b23f6a393c3bf$var$INITIAL_GRID_OPTION_KEYS[key]) $437b23f6a393c3bf$export$545083624300f13d(22, {
            key: key
        });
    }
    processGridOptions(options) {
        this.processOptions(options, $437b23f6a393c3bf$var$GRID_OPTIONS_VALIDATORS());
    }
    validateApiFunction(functionName, apiFunction) {
        return $437b23f6a393c3bf$var$validateApiFunction(functionName, apiFunction, this.beans);
    }
    missingUserComponent(propertyName, componentName, agGridDefaults, jsComps) {
        const moduleForComponent = $437b23f6a393c3bf$var$USER_COMP_MODULES[componentName];
        if (moduleForComponent) this.gos.assertModuleRegistered(moduleForComponent, `AG Grid '${propertyName}' component: ${componentName}`);
        else $437b23f6a393c3bf$export$545083624300f13d(101, {
            propertyName: propertyName,
            componentName: componentName,
            agGridDefaults: agGridDefaults,
            jsComps: jsComps
        });
    }
    missingDynamicBean(beanName) {
        const moduleName = $437b23f6a393c3bf$var$DYNAMIC_BEAN_MODULES[beanName];
        return moduleName ? $437b23f6a393c3bf$export$680bb5102fca525e(200, {
            ...this.gos.getModuleErrorParams(),
            moduleName: moduleName,
            reasonOrId: beanName
        }) : void 0;
    }
    checkRowEvents(eventType) {
        if ($437b23f6a393c3bf$var$DEPRECATED_ROW_NODE_EVENTS.has(eventType)) $437b23f6a393c3bf$export$545083624300f13d(10, {
            eventType: eventType
        });
    }
    validateIcon(iconName) {
        if ($437b23f6a393c3bf$var$DEPRECATED_ICONS_V33.has(iconName)) $437b23f6a393c3bf$export$545083624300f13d(43, {
            iconName: iconName
        });
        if ($437b23f6a393c3bf$var$ICON_VALUES[iconName]) return;
        const moduleName = $437b23f6a393c3bf$var$ICON_MODULES[iconName];
        if (moduleName) {
            $437b23f6a393c3bf$export$a20c7248650823a9(200, {
                reasonOrId: `icon '${iconName}'`,
                moduleName: moduleName,
                gridScoped: $437b23f6a393c3bf$var$_areModulesGridScoped(),
                gridId: this.beans.context.getGridId(),
                rowModelType: this.gos.get("rowModelType"),
                additionalText: "Alternatively, use the CSS icon name directly."
            });
            return;
        }
        $437b23f6a393c3bf$export$545083624300f13d(134, {
            iconName: iconName
        });
    }
    isProvidedUserComp(compName) {
        return !!$437b23f6a393c3bf$var$USER_COMP_MODULES[compName];
    }
    /** Should only be called via the GridOptionsService */ validateColDef(colDef) {
        this.processOptions(colDef, $437b23f6a393c3bf$var$COL_DEF_VALIDATORS());
    }
    processOptions(options, validator) {
        const { validations: validations, deprecations: deprecations, allProperties: allProperties, propertyExceptions: propertyExceptions, objectName: objectName, docsUrl: docsUrl } = validator;
        if (allProperties && this.gridOptions.suppressPropertyNamesCheck !== true) this.checkProperties(options, [
            ...propertyExceptions ?? [],
            ...Object.keys(deprecations)
        ], allProperties, objectName, docsUrl);
        const warnings = /* @__PURE__ */ new Set();
        const optionKeys = Object.keys(options);
        optionKeys.forEach((key)=>{
            const deprecation = deprecations[key];
            if (deprecation) {
                const { message: message, version: version } = deprecation;
                warnings.add(`As of v${version}, ${String(key)} is deprecated. ${message ?? ""}`);
            }
            const value = options[key];
            if (value == null || value === false) return;
            const rules = validations[key];
            if (!rules) return;
            const { dependencies: dependencies, validate: validate, supportedRowModels: supportedRowModels, expectedType: expectedType } = rules;
            if (expectedType) {
                const actualType = typeof value;
                if (actualType !== expectedType) {
                    warnings.add(`${String(key)} should be of type '${expectedType}' but received '${actualType}' (${value}).`);
                    return;
                }
            }
            if (supportedRowModels) {
                const rowModel = this.gridOptions.rowModelType ?? "clientSide";
                if (!supportedRowModels.includes(rowModel)) {
                    warnings.add(`${String(key)} is not supported with the '${rowModel}' row model. It is only valid with: ${supportedRowModels.join(", ")}.`);
                    return;
                }
            }
            if (dependencies) {
                const warning = this.checkForRequiredDependencies(key, dependencies, options);
                if (warning) {
                    warnings.add(warning);
                    return;
                }
            }
            if (validate) {
                const warning = validate(options, this.gridOptions, this.beans);
                if (warning) {
                    warnings.add(warning);
                    return;
                }
            }
        });
        if (warnings.size > 0) warnings.forEach((warning)=>{
            $437b23f6a393c3bf$export$2cf41453020eef66(warning);
        });
    }
    checkForRequiredDependencies(key, validator, options) {
        const optionEntries = Object.entries(validator);
        const failedOptions = optionEntries.filter(([key2, value])=>{
            const gridOptionValue = options[key2];
            return !value.required.includes(gridOptionValue);
        });
        if (failedOptions.length === 0) return null;
        return failedOptions.map(([failedKey, possibleOptions])=>`'${String(key)}' requires '${failedKey}' to be one of [${possibleOptions.required.map((o)=>{
                if (o === null) return "null";
                else if (o === void 0) return "undefined";
                return o;
            }).join(", ")}]. ${possibleOptions.reason ?? ""}`).join("\n           ");
    }
    checkProperties(object, exceptions, validProperties, containerName, docsUrl) {
        const VUE_FRAMEWORK_PROPS = [
            "__ob__",
            "__v_skip",
            "__metadata__"
        ];
        const invalidProperties = $437b23f6a393c3bf$var$_fuzzyCheckStrings(Object.getOwnPropertyNames(object), [
            ...VUE_FRAMEWORK_PROPS,
            ...exceptions,
            ...validProperties
        ], validProperties);
        const invalidPropertiesKeys = Object.keys(invalidProperties);
        for (const key of invalidPropertiesKeys){
            const value = invalidProperties[key];
            let message = `invalid ${containerName} property '${key}' did you mean any of these: ${value.slice(0, 8).join(", ")}.`;
            if (validProperties.includes("context")) message += `
If you are trying to annotate ${containerName} with application data, use the '${containerName}.context' property instead.`;
            $437b23f6a393c3bf$export$2cf41453020eef66(message);
        }
        if (invalidPropertiesKeys.length > 0 && docsUrl) {
            const url = this.beans.frameworkOverrides.getDocLink(docsUrl);
            $437b23f6a393c3bf$export$2cf41453020eef66(`to see all the valid ${containerName} properties please check: ${url}`);
        }
    }
    getConsoleMessage(id, args) {
        return $437b23f6a393c3bf$var$getError(id, args);
    }
};
function $437b23f6a393c3bf$var$_fuzzyCheckStrings(inputValues, validValues, allSuggestions) {
    const fuzzyMatches = {};
    const invalidInputs = inputValues.filter((inputValue)=>!validValues.some((validValue)=>validValue === inputValue));
    if (invalidInputs.length > 0) invalidInputs.forEach((invalidInput)=>fuzzyMatches[invalidInput] = $437b23f6a393c3bf$export$85cab1b5a4aa292c({
            inputValue: invalidInput,
            allSuggestions: allSuggestions
        }).values);
    return fuzzyMatches;
}
var $437b23f6a393c3bf$var$DEPRECATED_ROW_NODE_EVENTS = /* @__PURE__ */ new Set([
    "firstChildChanged",
    "lastChildChanged",
    "childIndexChanged"
]);
// packages/ag-grid-community/src/validation/validationModule.ts
var $437b23f6a393c3bf$export$798770a8f68ba4e7 = {
    moduleName: "Validation",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ValidationService
    ]
};
// packages/ag-grid-community/src/clientSideRowModel/filterStage.ts
function $437b23f6a393c3bf$var$updateRowNodeAfterFilter(rowNode) {
    if (rowNode.sibling) rowNode.sibling.childrenAfterFilter = rowNode.childrenAfterFilter;
}
var $437b23f6a393c3bf$var$FilterStage = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "filterStage";
        this.refreshProps = /* @__PURE__ */ new Set([
            "excludeChildrenWhenTreeDataFiltering"
        ]);
        this.step = "filter";
    }
    wireBeans(beans) {
        this.filterManager = beans.filterManager;
    }
    execute(params) {
        const { changedPath: changedPath } = params;
        this.filter(changedPath);
    }
    filter(changedPath) {
        const filterActive = !!this.filterManager?.isChildFilterPresent();
        this.filterNodes(filterActive, changedPath);
    }
    filterNodes(filterActive, changedPath) {
        const filterCallback = (rowNode, includeChildNodes)=>{
            if (rowNode.hasChildren()) {
                if (filterActive && !includeChildNodes) rowNode.childrenAfterFilter = rowNode.childrenAfterGroup.filter((childNode)=>{
                    const passBecauseChildren = childNode.childrenAfterFilter && childNode.childrenAfterFilter.length > 0;
                    const passBecauseDataPasses = childNode.data && this.filterManager.doesRowPassFilter({
                        rowNode: childNode
                    });
                    return passBecauseChildren || passBecauseDataPasses;
                });
                else rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            } else rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            $437b23f6a393c3bf$var$updateRowNodeAfterFilter(rowNode);
        };
        if (this.doingTreeDataFiltering()) {
            const treeDataDepthFirstFilter = (rowNode, alreadyFoundInParent)=>{
                if (rowNode.childrenAfterGroup) for(let i = 0; i < rowNode.childrenAfterGroup.length; i++){
                    const childNode = rowNode.childrenAfterGroup[i];
                    const foundInParent = alreadyFoundInParent || this.filterManager.doesRowPassFilter({
                        rowNode: childNode
                    });
                    if (childNode.childrenAfterGroup) treeDataDepthFirstFilter(rowNode.childrenAfterGroup[i], foundInParent);
                    else filterCallback(childNode, foundInParent);
                }
                filterCallback(rowNode, alreadyFoundInParent);
            };
            const treeDataFilterCallback = (rowNode)=>treeDataDepthFirstFilter(rowNode, false);
            changedPath.executeFromRootNode(treeDataFilterCallback);
        } else {
            const defaultFilterCallback = (rowNode)=>filterCallback(rowNode, false);
            changedPath.forEachChangedNodeDepthFirst(defaultFilterCallback, true);
        }
    }
    doingTreeDataFiltering() {
        return this.gos.get("treeData") && !this.gos.get("excludeChildrenWhenTreeDataFiltering");
    }
};
// packages/ag-grid-community/src/headerRendering/cells/floatingFilter/headerFilterCellCtrl.ts
var $437b23f6a393c3bf$var$HeaderFilterCellCtrl = class extends $437b23f6a393c3bf$var$AbstractHeaderCellCtrl {
    constructor(){
        super(...arguments);
        this.iconCreated = false;
    }
    setComp(comp, eGui, eButtonShowMainFilter, eFloatingFilterBody, compBeanInput) {
        this.comp = comp;
        const compBean = $437b23f6a393c3bf$var$setupCompBean(this, this.beans.context, compBeanInput);
        this.eButtonShowMainFilter = eButtonShowMainFilter;
        this.eFloatingFilterBody = eFloatingFilterBody;
        this.setGui(eGui, compBean);
        this.setupActive();
        this.refreshHeaderStyles();
        this.setupWidth(compBean);
        this.setupLeft(compBean);
        this.setupHover(compBean);
        this.setupFocus(compBean);
        this.setupAria();
        this.setupFilterButton();
        this.setupUserComp();
        this.setupSyncWithFilter(compBean);
        this.setupUi();
        compBean.addManagedElementListeners(this.eButtonShowMainFilter, {
            click: this.showParentFilter.bind(this)
        });
        this.setupFilterChangedListener(compBean);
        const colDefChanged = ()=>this.onColDefChanged(compBean);
        compBean.addManagedListeners(this.column, {
            colDefChanged: colDefChanged
        });
        compBean.addManagedEventListeners({
            filterSwitched: ({ column: column })=>{
                if (column === this.column) colDefChanged();
            }
        });
        compBean.addDestroyFunc(()=>{
            this.eButtonShowMainFilter = null;
            this.eFloatingFilterBody = null;
            this.userCompDetails = null;
            this.clearComponent();
        });
    }
    // empty abstract method
    resizeHeader() {}
    moveHeader() {}
    getHeaderClassParams() {
        const { column: column, beans: beans } = this;
        const colDef = column.colDef;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(beans.gos, {
            colDef: colDef,
            column: column,
            floatingFilter: true
        });
    }
    setupActive() {
        const colDef = this.column.getColDef();
        const filterExists = !!colDef.filter;
        const floatingFilterExists = !!colDef.floatingFilter;
        this.active = filterExists && floatingFilterExists;
    }
    setupUi() {
        this.comp.setButtonWrapperDisplayed(!this.suppressFilterButton && this.active);
        this.comp.addOrRemoveBodyCssClass("ag-floating-filter-full-body", this.suppressFilterButton);
        this.comp.addOrRemoveBodyCssClass("ag-floating-filter-body", !this.suppressFilterButton);
        if (!this.active || this.iconCreated) return;
        const eMenuIcon = $437b23f6a393c3bf$export$d8feba07bf373edb("filter", this.beans, this.column);
        if (eMenuIcon) {
            this.iconCreated = true;
            this.eButtonShowMainFilter.appendChild(eMenuIcon);
        }
    }
    setupFocus(compBean) {
        compBean.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(this.eGui, {
            shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this)
        }));
    }
    setupAria() {
        const localeTextFunc = this.getLocaleTextFunc();
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.eButtonShowMainFilter, localeTextFunc("ariaFilterMenuOpen", "Open Filter Menu"));
    }
    onTabKeyDown(e) {
        const { beans: beans } = this;
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(beans);
        const wrapperHasFocus = activeEl === this.eGui;
        if (wrapperHasFocus) return;
        const nextFocusableEl = $437b23f6a393c3bf$export$83fc12531358bd28(beans, this.eGui, null, e.shiftKey);
        if (nextFocusableEl) {
            beans.headerNavigation?.scrollToColumn(this.column);
            e.preventDefault();
            nextFocusableEl.focus();
            return;
        }
        const nextFocusableColumn = this.findNextColumnWithFloatingFilter(e.shiftKey);
        if (!nextFocusableColumn) return;
        if (beans.focusSvc.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: this.rowCtrl.rowIndex,
                column: nextFocusableColumn
            },
            event: e
        })) e.preventDefault();
    }
    findNextColumnWithFloatingFilter(backwards) {
        const presentedColsService = this.beans.visibleCols;
        let nextCol = this.column;
        do {
            nextCol = backwards ? presentedColsService.getColBefore(nextCol) : presentedColsService.getColAfter(nextCol);
            if (!nextCol) break;
        }while (!nextCol.getColDef().filter || !nextCol.getColDef().floatingFilter);
        return nextCol;
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        const wrapperHasFocus = this.getWrapperHasFocus();
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                if (wrapperHasFocus) return;
                $437b23f6a393c3bf$export$456c40e80134d72a(e);
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                if (wrapperHasFocus) {
                    if ($437b23f6a393c3bf$export$8598088d375f416f(this.eGui)) e.preventDefault();
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                if (!wrapperHasFocus) this.eGui.focus();
        }
    }
    onFocusIn(e) {
        const isRelatedWithin = this.eGui.contains(e.relatedTarget);
        if (isRelatedWithin) return;
        const notFromHeaderWrapper = !!e.relatedTarget && !e.relatedTarget.classList.contains("ag-floating-filter");
        const fromWithinHeader = !!e.relatedTarget && $437b23f6a393c3bf$var$_isElementChildOfClass(e.relatedTarget, "ag-floating-filter");
        if (notFromHeaderWrapper && fromWithinHeader && e.target === this.eGui) {
            const lastFocusEvent = this.lastFocusEvent;
            const fromTab = !!(lastFocusEvent && lastFocusEvent.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB);
            if (lastFocusEvent && fromTab) {
                const shouldFocusLast = lastFocusEvent.shiftKey;
                $437b23f6a393c3bf$export$8598088d375f416f(this.eGui, shouldFocusLast);
            }
        }
        this.focusThis();
    }
    setupHover(compBean) {
        this.beans.colHover?.addHeaderFilterColumnHoverListener(compBean, this.comp, this.column, this.eGui);
    }
    setupLeft(compBean) {
        const setLeftFeature = new $437b23f6a393c3bf$var$SetLeftFeature(this.column, this.eGui, this.beans);
        compBean.createManagedBean(setLeftFeature);
    }
    setupFilterButton() {
        this.suppressFilterButton = !this.beans.menuSvc?.isFloatingFilterButtonEnabled(this.column);
        this.highlightFilterButtonWhenActive = !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos);
    }
    setupUserComp() {
        if (!this.active) return;
        const compDetails = this.beans.colFilter?.getFloatingFilterCompDetails(this.column, ()=>this.showParentFilter());
        if (compDetails) this.setCompDetails(compDetails);
    }
    setCompDetails(compDetails) {
        this.userCompDetails = compDetails;
        this.comp.setCompDetails(compDetails);
    }
    showParentFilter() {
        const eventSource = this.suppressFilterButton ? this.eFloatingFilterBody : this.eButtonShowMainFilter;
        this.beans.menuSvc?.showFilterMenu({
            column: this.column,
            buttonElement: eventSource,
            containerType: "floatingFilter",
            positionBy: "button"
        });
    }
    setupSyncWithFilter(compBean) {
        if (!this.active) return;
        const { beans: { colFilter: colFilter }, column: column, gos: gos } = this;
        const syncWithFilter = (event)=>{
            if (event?.source === "filterDestroyed" && (!this.isAlive() || !colFilter?.isAlive())) return;
            const compPromise = this.comp.getFloatingFilterComp();
            if (!compPromise) return;
            compPromise.then((comp)=>{
                if (comp) {
                    if (gos.get("enableFilterHandlers")) {
                        const eventWithParams = event;
                        let source = "filter";
                        if (eventWithParams?.afterFloatingFilter) source = "ui";
                        else if (eventWithParams?.afterDataChange) source = "dataChanged";
                        else if (event?.source === "api") source = "api";
                        this.updateFloatingFilterParams(this.userCompDetails, source);
                        return;
                    }
                    const parentModel = colFilter?.getCurrentFloatingFilterParentModel(column);
                    const filterChangedEvent = event ? {
                        // event can have additional params like `afterDataChange` which need to be passed through
                        ...event,
                        columns: event.columns ?? [],
                        source: event.source === "api" ? "api" : "columnFilter"
                    } : null;
                    comp.onParentModelChanged(parentModel, filterChangedEvent);
                }
            });
        };
        [this.destroySyncListener] = compBean.addManagedListeners(column, {
            filterChanged: syncWithFilter
        });
        if (colFilter?.isFilterActive(column)) syncWithFilter(null);
    }
    setupWidth(compBean) {
        const listener = ()=>{
            const width = `${this.column.getActualWidth()}px`;
            this.comp.setWidth(width);
        };
        compBean.addManagedListeners(this.column, {
            widthChanged: listener
        });
        listener();
    }
    setupFilterChangedListener(compBean) {
        if (this.active) {
            [this.destroyFilterChangedListener] = compBean.addManagedListeners(this.column, {
                filterChanged: this.updateFilterButton.bind(this)
            });
            this.updateFilterButton();
        }
    }
    updateFilterButton() {
        if (!this.suppressFilterButton && this.comp) {
            const isFilterAllowed = !!this.beans.filterManager?.isFilterAllowed(this.column);
            this.comp.setButtonWrapperDisplayed(isFilterAllowed);
            if (this.highlightFilterButtonWhenActive && isFilterAllowed) this.eButtonShowMainFilter.classList.toggle("ag-filter-active", this.column.isFilterActive());
        }
    }
    onColDefChanged(compBean) {
        const wasActive = this.active;
        this.setupActive();
        const becomeActive = !wasActive && this.active;
        if (wasActive && !this.active) {
            this.destroySyncListener();
            this.destroyFilterChangedListener();
        }
        const colFilter = this.beans.colFilter;
        const newCompDetails = this.active ? colFilter?.getFloatingFilterCompDetails(this.column, ()=>this.showParentFilter()) : null;
        const compPromise = this.comp.getFloatingFilterComp();
        if (!compPromise || !newCompDetails) this.updateCompDetails(compBean, newCompDetails, becomeActive);
        else compPromise.then((compInstance)=>{
            if (!compInstance || colFilter?.areFilterCompsDifferent(this.userCompDetails ?? null, newCompDetails)) this.updateCompDetails(compBean, newCompDetails, becomeActive);
            else this.updateFloatingFilterParams(newCompDetails, "colDef");
        });
    }
    updateCompDetails(compBean, compDetails, becomeActive) {
        if (!this.isAlive()) return;
        this.setCompDetails(compDetails);
        this.setupFilterButton();
        this.setupUi();
        if (becomeActive) {
            this.setupSyncWithFilter(compBean);
            this.setupFilterChangedListener(compBean);
        }
    }
    updateFloatingFilterParams(userCompDetails, source) {
        if (!userCompDetails) return;
        let params = userCompDetails.params;
        this.comp.getFloatingFilterComp()?.then((floatingFilter)=>{
            if (typeof floatingFilter?.refresh === "function") {
                if (this.gos.get("enableFilterHandlers")) params = {
                    ...params,
                    model: $437b23f6a393c3bf$export$8981db65da4532f2(this.beans.colFilter?.model ?? {}, this.column.getColId()),
                    source: source
                };
                floatingFilter.refresh(params);
            }
        });
    }
    addResizeAndMoveKeyboardListeners() {}
    destroy() {
        super.destroy();
        this.destroySyncListener = null;
        this.destroyFilterChangedListener = null;
    }
};
// packages/ag-grid-community/src/misc/menu/menuApi.ts
function $437b23f6a393c3bf$var$showColumnMenu(beans, colKey) {
    const column = beans.colModel.getCol(colKey);
    if (!column) {
        $437b23f6a393c3bf$export$a20c7248650823a9(12, {
            colKey: colKey
        });
        return;
    }
    beans.menuSvc?.showColumnMenu({
        column: column,
        positionBy: "auto"
    });
}
function $437b23f6a393c3bf$var$hidePopupMenu(beans) {
    beans.menuSvc?.hidePopupMenu();
}
// packages/ag-grid-community/src/misc/menu/sharedMenuModule.ts
var $437b23f6a393c3bf$export$b0ea578339daf1f7 = {
    moduleName: "SharedMenu",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$MenuService
    ],
    apiFunctions: {
        showColumnMenu: $437b23f6a393c3bf$var$showColumnMenu,
        hidePopupMenu: $437b23f6a393c3bf$var$hidePopupMenu
    }
};
// packages/ag-grid-community/src/widgets/popupService.ts
var $437b23f6a393c3bf$var$instanceIdSeq = 0;
var $437b23f6a393c3bf$var$WAIT_FOR_POPUP_CONTENT_RESIZE = 200;
var $437b23f6a393c3bf$var$PopupService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "popupSvc";
        this.popupList = [];
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridCtrl = p.gridCtrl;
        });
        this.addManagedEventListeners({
            gridStylesChanged: this.handleThemeChange.bind(this)
        });
    }
    getPopupParent() {
        const ePopupParent = this.gos.get("popupParent");
        if (ePopupParent) return ePopupParent;
        return this.gridCtrl.getGui();
    }
    positionPopupForMenu(params) {
        const { eventSource: eventSource, ePopup: ePopup, column: column, node: node, event: event } = params;
        const sourceRect = eventSource.getBoundingClientRect();
        const parentRect = this.getParentRect();
        this.setAlignedTo(eventSource, ePopup);
        let minWidthSet = false;
        const updatePosition = ()=>{
            const y = this.keepXYWithinBounds(ePopup, sourceRect.top - parentRect.top, 0 /* Vertical */ );
            const minWidth = ePopup.clientWidth > 0 ? ePopup.clientWidth : 200;
            if (!minWidthSet) {
                ePopup.style.minWidth = `${minWidth}px`;
                minWidthSet = true;
            }
            const widthOfParent = parentRect.right - parentRect.left;
            const maxX = widthOfParent - minWidth;
            let x;
            if (this.gos.get("enableRtl")) {
                x = xLeftPosition();
                if (x < 0) {
                    x = xRightPosition();
                    this.setAlignedStyles(ePopup, "left");
                }
                if (x > maxX) {
                    x = 0;
                    this.setAlignedStyles(ePopup, "right");
                }
            } else {
                x = xRightPosition();
                if (x > maxX) {
                    x = xLeftPosition();
                    this.setAlignedStyles(ePopup, "right");
                }
                if (x < 0) {
                    x = 0;
                    this.setAlignedStyles(ePopup, "left");
                }
            }
            return {
                x: x,
                y: y
            };
            function xRightPosition() {
                return sourceRect.right - parentRect.left - 2;
            }
            function xLeftPosition() {
                return sourceRect.left - parentRect.left - minWidth;
            }
        };
        this.positionPopup({
            ePopup: ePopup,
            keepWithinBounds: true,
            updatePosition: updatePosition,
            postProcessCallback: ()=>this.callPostProcessPopup("subMenu", ePopup, eventSource, event instanceof MouseEvent ? event : void 0, column, node)
        });
    }
    positionPopupUnderMouseEvent(params) {
        const { ePopup: ePopup, nudgeX: nudgeX, nudgeY: nudgeY, skipObserver: skipObserver } = params;
        this.positionPopup({
            ePopup: ePopup,
            nudgeX: nudgeX,
            nudgeY: nudgeY,
            keepWithinBounds: true,
            skipObserver: skipObserver,
            updatePosition: ()=>this.calculatePointerAlign(params.mouseEvent),
            postProcessCallback: ()=>this.callPostProcessPopup(params.type, params.ePopup, null, params.mouseEvent, params.column, params.rowNode)
        });
    }
    calculatePointerAlign(e) {
        const parentRect = this.getParentRect();
        return {
            x: e.clientX - parentRect.left,
            y: e.clientY - parentRect.top
        };
    }
    positionPopupByComponent(params) {
        const { ePopup: ePopup, nudgeX: nudgeX, nudgeY: nudgeY, keepWithinBounds: keepWithinBounds, eventSource: eventSource, alignSide: alignSide = "left", position: position = "over", column: column, rowNode: rowNode, type: type } = params;
        const sourceRect = eventSource.getBoundingClientRect();
        const parentRect = this.getParentRect();
        this.setAlignedTo(eventSource, ePopup);
        const updatePosition = ()=>{
            let x = sourceRect.left - parentRect.left;
            if (alignSide === "right") x -= ePopup.offsetWidth - sourceRect.width;
            let y;
            if (position === "over") {
                y = sourceRect.top - parentRect.top;
                this.setAlignedStyles(ePopup, "over");
            } else {
                this.setAlignedStyles(ePopup, "under");
                const alignSide2 = this.shouldRenderUnderOrAbove(ePopup, sourceRect, parentRect, params.nudgeY || 0);
                if (alignSide2 === "under") y = sourceRect.top - parentRect.top + sourceRect.height;
                else y = sourceRect.top - ePopup.offsetHeight - (nudgeY || 0) * 2 - parentRect.top;
            }
            return {
                x: x,
                y: y
            };
        };
        this.positionPopup({
            ePopup: ePopup,
            nudgeX: nudgeX,
            nudgeY: nudgeY,
            keepWithinBounds: keepWithinBounds,
            updatePosition: updatePosition,
            postProcessCallback: ()=>this.callPostProcessPopup(type, ePopup, eventSource, null, column, rowNode)
        });
    }
    shouldRenderUnderOrAbove(ePopup, targetCompRect, parentRect, nudgeY) {
        const spaceAvailableUnder = parentRect.bottom - targetCompRect.bottom;
        const spaceAvailableAbove = targetCompRect.top - parentRect.top;
        const spaceRequired = ePopup.offsetHeight + nudgeY;
        if (spaceAvailableUnder > spaceRequired) return "under";
        if (spaceAvailableAbove > spaceRequired || spaceAvailableAbove > spaceAvailableUnder) return "above";
        return "under";
    }
    setAlignedStyles(ePopup, positioned) {
        const popupIdx = this.getPopupIndex(ePopup);
        if (popupIdx === -1) return;
        const popup = this.popupList[popupIdx];
        const { alignedToElement: alignedToElement } = popup;
        if (!alignedToElement) return;
        const positions = [
            "right",
            "left",
            "over",
            "above",
            "under"
        ];
        positions.forEach((position)=>{
            alignedToElement.classList.remove(`ag-has-popup-positioned-${position}`);
            ePopup.classList.remove(`ag-popup-positioned-${position}`);
        });
        if (!positioned) return;
        alignedToElement.classList.add(`ag-has-popup-positioned-${positioned}`);
        ePopup.classList.add(`ag-popup-positioned-${positioned}`);
    }
    setAlignedTo(eventSource, ePopup) {
        const popupIdx = this.getPopupIndex(ePopup);
        if (popupIdx !== -1) {
            const popup = this.popupList[popupIdx];
            popup.alignedToElement = eventSource;
        }
    }
    callPostProcessPopup(type, ePopup, eventSource, mouseEvent, column, rowNode) {
        const callback = this.gos.getCallback("postProcessPopup");
        if (callback) {
            const params = {
                column: column,
                rowNode: rowNode,
                ePopup: ePopup,
                type: type,
                eventSource: eventSource,
                mouseEvent: mouseEvent
            };
            callback(params);
        }
    }
    positionPopup(params) {
        const { ePopup: ePopup, keepWithinBounds: keepWithinBounds, nudgeX: nudgeX, nudgeY: nudgeY, skipObserver: skipObserver, updatePosition: updatePosition } = params;
        const lastSize = {
            width: 0,
            height: 0
        };
        const updatePopupPosition = (fromResizeObserver = false)=>{
            let { x: x, y: y } = updatePosition();
            if (fromResizeObserver && ePopup.clientWidth === lastSize.width && ePopup.clientHeight === lastSize.height) return;
            lastSize.width = ePopup.clientWidth;
            lastSize.height = ePopup.clientHeight;
            if (nudgeX) x += nudgeX;
            if (nudgeY) y += nudgeY;
            if (keepWithinBounds) {
                x = this.keepXYWithinBounds(ePopup, x, 1 /* Horizontal */ );
                y = this.keepXYWithinBounds(ePopup, y, 0 /* Vertical */ );
            }
            ePopup.style.left = `${x}px`;
            ePopup.style.top = `${y}px`;
            if (params.postProcessCallback) params.postProcessCallback();
        };
        updatePopupPosition();
        if (!skipObserver) {
            const resizeObserverDestroyFunc = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, ePopup, ()=>updatePopupPosition(true));
            setTimeout(()=>resizeObserverDestroyFunc(), $437b23f6a393c3bf$var$WAIT_FOR_POPUP_CONTENT_RESIZE);
        }
    }
    getActivePopups() {
        return this.popupList.map((popup)=>popup.element);
    }
    getParentRect() {
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        let popupParent = this.getPopupParent();
        if (popupParent === eDocument.body) popupParent = eDocument.documentElement;
        else if (getComputedStyle(popupParent).position === "static") popupParent = popupParent.offsetParent;
        return $437b23f6a393c3bf$var$_getElementRectWithOffset(popupParent);
    }
    keepXYWithinBounds(ePopup, position, direction) {
        const isVertical = direction === 0 /* Vertical */ ;
        const sizeProperty = isVertical ? "clientHeight" : "clientWidth";
        const anchorProperty = isVertical ? "top" : "left";
        const offsetProperty = isVertical ? "height" : "width";
        const scrollPositionProperty = isVertical ? "scrollTop" : "scrollLeft";
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        const docElement = eDocument.documentElement;
        const popupParent = this.getPopupParent();
        const popupRect = ePopup.getBoundingClientRect();
        const parentRect = popupParent.getBoundingClientRect();
        const documentRect = eDocument.documentElement.getBoundingClientRect();
        const isBody = popupParent === eDocument.body;
        const offsetSize = Math.ceil(popupRect[offsetProperty]);
        const getSize2 = isVertical ? $437b23f6a393c3bf$export$d23c22492e0f7c0c : $437b23f6a393c3bf$export$642efcb17474eb51;
        let sizeOfParent = isBody ? getSize2(docElement) + docElement[scrollPositionProperty] : popupParent[sizeProperty];
        if (isBody) sizeOfParent -= Math.abs(documentRect[anchorProperty] - parentRect[anchorProperty]);
        const max = sizeOfParent - offsetSize;
        return Math.min(Math.max(position, 0), Math.abs(max));
    }
    addPopup(params) {
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        const { eChild: eChild, ariaLabel: ariaLabel, ariaOwns: ariaOwns, alwaysOnTop: alwaysOnTop, positionCallback: positionCallback, anchorToElement: anchorToElement } = params;
        if (!eDocument) {
            $437b23f6a393c3bf$export$545083624300f13d(122);
            return {
                hideFunc: ()=>{}
            };
        }
        const pos = this.getPopupIndex(eChild);
        if (pos !== -1) {
            const popup = this.popupList[pos];
            return {
                hideFunc: popup.hideFunc
            };
        }
        this.initialisePopupPosition(eChild);
        const wrapperEl = this.createPopupWrapper(eChild, !!alwaysOnTop, ariaLabel, ariaOwns);
        const removeListeners = this.addEventListenersToPopup({
            ...params,
            wrapperEl: wrapperEl
        });
        if (positionCallback) positionCallback();
        this.addPopupToPopupList(eChild, wrapperEl, removeListeners, anchorToElement);
        return {
            hideFunc: removeListeners
        };
    }
    initialisePopupPosition(element) {
        const ePopupParent = this.getPopupParent();
        const ePopupParentRect = ePopupParent.getBoundingClientRect();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(element.style.top)) element.style.top = `${ePopupParentRect.top * -1}px`;
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(element.style.left)) element.style.left = `${ePopupParentRect.left * -1}px`;
    }
    createPopupWrapper(element, alwaysOnTop, ariaLabel, ariaOwns) {
        const ePopupParent = this.getPopupParent();
        const { environment: environment, gos: gos } = this.beans;
        const eWrapper = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div"
        });
        environment.applyThemeClasses(eWrapper);
        eWrapper.classList.add("ag-popup");
        element.classList.add(gos.get("enableRtl") ? "ag-rtl" : "ag-ltr", "ag-popup-child");
        if (!element.hasAttribute("role")) $437b23f6a393c3bf$export$f8d01fa01787902(element, "dialog");
        if (ariaLabel) $437b23f6a393c3bf$export$e81cb0dd07f289f6(element, ariaLabel);
        else if (ariaOwns) {
            element.id || (element.id = `popup-component-${$437b23f6a393c3bf$var$instanceIdSeq}`);
            $437b23f6a393c3bf$var$_setAriaOwns(ariaOwns, element.id);
        }
        eWrapper.appendChild(element);
        ePopupParent.appendChild(eWrapper);
        if (alwaysOnTop) this.setAlwaysOnTop(element, true);
        else this.bringPopupToFront(element);
        return eWrapper;
    }
    handleThemeChange(e) {
        if (e.themeChanged) {
            const environment = this.beans.environment;
            for (const popup of this.popupList)environment.applyThemeClasses(popup.wrapper);
        }
    }
    addEventListenersToPopup(params) {
        const beans = this.beans;
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
        const ePopupParent = this.getPopupParent();
        const { wrapperEl: wrapperEl, eChild: popupEl, closedCallback: closedCallback, afterGuiAttached: afterGuiAttached, closeOnEsc: closeOnEsc, modal: modal, ariaOwns: ariaOwns } = params;
        let popupHidden = false;
        const hidePopupOnKeyboardEvent = (event)=>{
            if (!wrapperEl.contains($437b23f6a393c3bf$export$16bc98d422315038(beans))) return;
            const key = event.key;
            if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE && !$437b23f6a393c3bf$export$9a48e23524c6d58(event)) removeListeners({
                keyboardEvent: event
            });
        };
        const hidePopupOnMouseEvent = (event)=>removeListeners({
                mouseEvent: event
            });
        const hidePopupOnTouchEvent = (event)=>removeListeners({
                touchEvent: event
            });
        const removeListeners = (popupParams = {})=>{
            const { mouseEvent: mouseEvent, touchEvent: touchEvent, keyboardEvent: keyboardEvent, forceHide: forceHide } = popupParams;
            if (!forceHide && // we don't hide popup if the event was on the child, or any
            // children of this child
            (this.isEventFromCurrentPopup({
                mouseEvent: mouseEvent,
                touchEvent: touchEvent
            }, popupEl) || // this method should only be called once. the client can have different
            // paths, each one wanting to close, so this method may be called multiple times.
            popupHidden)) return;
            popupHidden = true;
            ePopupParent.removeChild(wrapperEl);
            eDocument.removeEventListener("keydown", hidePopupOnKeyboardEvent);
            eDocument.removeEventListener("mousedown", hidePopupOnMouseEvent);
            eDocument.removeEventListener("touchstart", hidePopupOnTouchEvent);
            eDocument.removeEventListener("contextmenu", hidePopupOnMouseEvent);
            this.eventSvc.removeEventListener("dragStarted", hidePopupOnMouseEvent);
            if (closedCallback) closedCallback(mouseEvent || touchEvent || keyboardEvent);
            this.removePopupFromPopupList(popupEl, ariaOwns);
        };
        if (afterGuiAttached) afterGuiAttached({
            hidePopup: removeListeners
        });
        window.setTimeout(()=>{
            if (closeOnEsc) eDocument.addEventListener("keydown", hidePopupOnKeyboardEvent);
            if (modal) {
                eDocument.addEventListener("mousedown", hidePopupOnMouseEvent);
                this.eventSvc.addEventListener("dragStarted", hidePopupOnMouseEvent);
                eDocument.addEventListener("touchstart", hidePopupOnTouchEvent);
                eDocument.addEventListener("contextmenu", hidePopupOnMouseEvent);
            }
        }, 0);
        return removeListeners;
    }
    addPopupToPopupList(element, wrapperEl, removeListeners, anchorToElement) {
        this.popupList.push({
            element: element,
            wrapper: wrapperEl,
            hideFunc: removeListeners,
            instanceId: $437b23f6a393c3bf$var$instanceIdSeq,
            isAnchored: !!anchorToElement
        });
        if (anchorToElement) this.setPopupPositionRelatedToElement(element, anchorToElement);
        $437b23f6a393c3bf$var$instanceIdSeq = $437b23f6a393c3bf$var$instanceIdSeq + 1;
    }
    getPopupIndex(el) {
        return this.popupList.findIndex((p)=>p.element === el);
    }
    setPopupPositionRelatedToElement(popupEl, relativeElement) {
        const popupIndex = this.getPopupIndex(popupEl);
        if (popupIndex === -1) return;
        const popup = this.popupList[popupIndex];
        if (popup.stopAnchoringPromise) popup.stopAnchoringPromise.then((destroyFunc)=>destroyFunc && destroyFunc());
        popup.stopAnchoringPromise = void 0;
        popup.isAnchored = false;
        if (!relativeElement) return;
        const destroyPositionTracker = this.keepPopupPositionedRelativeTo({
            element: relativeElement,
            ePopup: popupEl,
            hidePopup: popup.hideFunc
        });
        popup.stopAnchoringPromise = destroyPositionTracker;
        popup.isAnchored = true;
        return destroyPositionTracker;
    }
    removePopupFromPopupList(element, ariaOwns) {
        this.setAlignedStyles(element, null);
        this.setPopupPositionRelatedToElement(element, null);
        if (ariaOwns) $437b23f6a393c3bf$var$_setAriaOwns(ariaOwns, null);
        this.popupList = this.popupList.filter((p)=>p.element !== element);
    }
    keepPopupPositionedRelativeTo(params) {
        const eParent = this.getPopupParent();
        const parentRect = eParent.getBoundingClientRect();
        const { element: element, ePopup: ePopup } = params;
        const sourceRect = element.getBoundingClientRect();
        const extractFromPixelValue = (pxSize)=>parseInt(pxSize.substring(0, pxSize.length - 1), 10);
        const createPosition = (prop, direction)=>{
            const initialDiff = parentRect[prop] - sourceRect[prop];
            const initial = extractFromPixelValue(ePopup.style[prop]);
            return {
                initialDiff: initialDiff,
                lastDiff: initialDiff,
                initial: initial,
                last: initial,
                direction: direction
            };
        };
        const topPosition = createPosition("top", 0 /* Vertical */ );
        const leftPosition = createPosition("left", 1 /* Horizontal */ );
        const fwOverrides = this.beans.frameworkOverrides;
        return new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
            fwOverrides.wrapIncoming(()=>{
                fwOverrides.setInterval(()=>{
                    const pRect = eParent.getBoundingClientRect();
                    const sRect = element.getBoundingClientRect();
                    const elementNotInDom = sRect.top == 0 && sRect.left == 0 && sRect.height == 0 && sRect.width == 0;
                    if (elementNotInDom) {
                        params.hidePopup();
                        return;
                    }
                    const calculateNewPosition = (position, prop)=>{
                        const current = extractFromPixelValue(ePopup.style[prop]);
                        if (position.last !== current) {
                            position.initial = current;
                            position.last = current;
                        }
                        const currentDiff = pRect[prop] - sRect[prop];
                        if (currentDiff != position.lastDiff) {
                            const newValue = this.keepXYWithinBounds(ePopup, position.initial + position.initialDiff - currentDiff, position.direction);
                            ePopup.style[prop] = `${newValue}px`;
                            position.last = newValue;
                        }
                        position.lastDiff = currentDiff;
                    };
                    calculateNewPosition(topPosition, "top");
                    calculateNewPosition(leftPosition, "left");
                }, 200).then((intervalId)=>{
                    const result = ()=>{
                        if (intervalId != null) window.clearInterval(intervalId);
                    };
                    resolve(result);
                });
            }, "popupPositioning");
        });
    }
    hasAnchoredPopup() {
        return this.popupList.some((popup)=>popup.isAnchored);
    }
    isEventFromCurrentPopup(params, target) {
        const { mouseEvent: mouseEvent, touchEvent: touchEvent } = params;
        const event = mouseEvent ? mouseEvent : touchEvent;
        if (!event) return false;
        const indexOfThisChild = this.getPopupIndex(target);
        if (indexOfThisChild === -1) return false;
        for(let i = indexOfThisChild; i < this.popupList.length; i++){
            const popup = this.popupList[i];
            if ($437b23f6a393c3bf$export$b5446458166e97b4(popup.element, event)) return true;
        }
        return this.isElementWithinCustomPopup(event.target);
    }
    isElementWithinCustomPopup(el) {
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        while(el && el !== eDocument.body){
            if (el.classList.contains("ag-custom-component-popup") || el.parentElement === null) return true;
            el = el.parentElement;
        }
        return false;
    }
    getWrapper(ePopup) {
        while(!ePopup.classList.contains("ag-popup") && ePopup.parentElement)ePopup = ePopup.parentElement;
        return ePopup.classList.contains("ag-popup") ? ePopup : null;
    }
    setAlwaysOnTop(ePopup, alwaysOnTop) {
        const eWrapper = this.getWrapper(ePopup);
        if (!eWrapper) return;
        eWrapper.classList.toggle("ag-always-on-top", !!alwaysOnTop);
        if (alwaysOnTop) this.bringPopupToFront(eWrapper);
    }
    /** @returns true if moved */ bringPopupToFront(ePopup) {
        const parent = this.getPopupParent();
        const popupList = Array.prototype.slice.call(parent.querySelectorAll(".ag-popup"));
        const popupLen = popupList.length;
        const eWrapper = this.getWrapper(ePopup);
        if (!eWrapper || popupLen <= 1 || !parent.contains(ePopup)) return;
        const standardPopupList = [];
        const alwaysOnTopList = [];
        for (const popup of popupList){
            if (popup === eWrapper) continue;
            if (popup.classList.contains("ag-always-on-top")) alwaysOnTopList.push(popup);
            else standardPopupList.push(popup);
        }
        const innerElsScrollMap = [];
        const onTopLength = alwaysOnTopList.length;
        const isPopupAlwaysOnTop = eWrapper.classList.contains("ag-always-on-top");
        const shouldBeLast = isPopupAlwaysOnTop || !onTopLength;
        const targetList = shouldBeLast ? [
            ...standardPopupList,
            ...alwaysOnTopList,
            eWrapper
        ] : [
            ...standardPopupList,
            eWrapper,
            ...alwaysOnTopList
        ];
        for(let i = 0; i <= popupLen; i++){
            const currentPopup = targetList[i];
            if (popupList[i] === targetList[i] || currentPopup === eWrapper) continue;
            const innerEls = currentPopup.querySelectorAll("div");
            innerEls.forEach((el)=>{
                if (el.scrollTop !== 0) innerElsScrollMap.push([
                    el,
                    el.scrollTop
                ]);
            });
            if (i === 0) parent.insertAdjacentElement("afterbegin", currentPopup);
            else targetList[i - 1].insertAdjacentElement("afterend", currentPopup);
        }
        while(innerElsScrollMap.length){
            const currentEl = innerElsScrollMap.pop();
            currentEl[0].scrollTop = currentEl[1];
        }
    }
};
// packages/ag-grid-community/src/widgets/popupModule.ts
var $437b23f6a393c3bf$export$da5c9bb998e6c24d = {
    moduleName: "Popup",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$PopupService
    ]
};
// packages/ag-grid-community/src/filter/column-filters.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnFiltersCSS = /*css*/ `.ag-set-filter{--ag-indentation-level:0}.ag-set-filter-item{align-items:center;display:flex;height:100%}:where(.ag-ltr) .ag-set-filter-item{padding-left:calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level)*var(--ag-set-filter-indent-size))}:where(.ag-rtl) .ag-set-filter-item{padding-right:calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level)*var(--ag-set-filter-indent-size))}.ag-set-filter-item-checkbox{display:flex;height:100%;width:100%}.ag-set-filter-group-icons{display:block;>*{cursor:pointer}}:where(.ag-ltr) .ag-set-filter-group-icons{margin-right:var(--ag-widget-container-horizontal-padding)}:where(.ag-rtl) .ag-set-filter-group-icons{margin-left:var(--ag-widget-container-horizontal-padding)}.ag-filter-body-wrapper{display:flex;flex-direction:column}:where(.ag-menu:not(.ag-tabs) .ag-filter) .ag-filter-body-wrapper,:where(.ag-menu:not(.ag-tabs) .ag-filter)>:not(.ag-filter-wrapper){min-width:180px}.ag-filter-filter{flex:1 1 0px}.ag-filter-condition{display:flex;justify-content:center}.ag-floating-filter-body{display:flex;flex:1 1 auto;height:100%;position:relative}.ag-floating-filter-full-body{align-items:center;display:flex;flex:1 1 auto;height:100%;overflow:hidden;width:100%}:where(.ag-floating-filter-full-body)>div{flex:1 1 auto}.ag-floating-filter-input{align-items:center;display:flex;width:100%;>*{flex:1 1 auto}:where(.ag-input-field-input[type=date]),:where(.ag-input-field-input[type=datetime-local]){width:1px}}.ag-floating-filter-button{display:flex;flex:none}.ag-date-floating-filter-wrapper{display:flex}.ag-set-floating-filter-input :where(input)[disabled]{pointer-events:none}.ag-floating-filter-button-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;height:var(--ag-icon-size);width:var(--ag-icon-size)}.ag-filter-loading{align-items:unset;background-color:var(--ag-chrome-background-color);height:100%;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:absolute;width:100%;z-index:1;:where(.ag-menu) &{background-color:var(--ag-menu-background-color)}}.ag-filter-separator{border-top:solid var(--ag-border-width) var(--menu-separator-color)}:where(.ag-filter-select) .ag-picker-field-wrapper{width:0}.ag-filter-condition-operator{height:17px}:where(.ag-ltr) .ag-filter-condition-operator-or{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-filter-condition-operator-or{margin-right:calc(var(--ag-spacing)*2)}.ag-set-filter-select-all{padding-top:var(--ag-widget-container-vertical-padding)}.ag-filter-no-matches,.ag-set-filter-list{height:calc(var(--ag-list-item-height)*6)}.ag-filter-no-matches{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}.ag-set-filter-tree-list{height:calc(var(--ag-list-item-height)*10)}.ag-set-filter-filter{margin-left:var(--ag-widget-container-horizontal-padding);margin-right:var(--ag-widget-container-horizontal-padding);margin-top:var(--ag-widget-container-vertical-padding)}.ag-filter-to{margin-top:var(--ag-widget-vertical-spacing)}.ag-mini-filter{margin:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}:where(.ag-ltr) .ag-set-filter-add-group-indent{margin-left:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}:where(.ag-rtl) .ag-set-filter-add-group-indent{margin-right:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}:where(.ag-filter-menu) .ag-set-filter-list{min-width:200px}.ag-filter-virtual-list-item:focus-visible{box-shadow:inset var(--ag-focus-shadow)}.ag-filter-apply-panel{display:flex;justify-content:flex-end;overflow:hidden;padding:var(--ag-widget-vertical-spacing) var(--ag-widget-container-horizontal-padding) var(--ag-widget-container-vertical-padding)}.ag-filter-apply-panel-button{line-height:1.5}:where(.ag-ltr) .ag-filter-apply-panel-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-filter-apply-panel-button{margin-right:calc(var(--ag-spacing)*2)}.ag-simple-filter-body-wrapper{display:flex;flex-direction:column;min-height:calc(var(--ag-list-item-height) + var(--ag-widget-container-vertical-padding) + var(--ag-widget-vertical-spacing));overflow-y:auto;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);padding-bottom:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));&>*{margin-bottom:var(--ag-widget-vertical-spacing)}:where(.ag-resizer-wrapper){margin:0}}.ag-multi-filter-menu-item{margin:var(--ag-spacing) 0}.ag-multi-filter-group-title-bar{background-color:transparent;color:var(--ag-header-text-color);font-weight:500;padding:calc(var(--ag-spacing)*1.5) var(--ag-spacing)}.ag-group-filter-field-select-wrapper{display:flex;flex-direction:column;gap:var(--ag-widget-vertical-spacing);padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}`;
// packages/ag-grid-community/src/filter/columnFilterApi.ts
function $437b23f6a393c3bf$var$isColumnFilterPresent(beans) {
    const filterManager = beans.filterManager;
    return !!filterManager?.isColumnFilterPresent() || !!filterManager?.isAggregateFilterPresent();
}
function $437b23f6a393c3bf$var$getColumnFilterInstance(beans, key) {
    return beans.filterManager?.getColumnFilterInstance(key) ?? Promise.resolve(void 0);
}
function $437b23f6a393c3bf$var$destroyFilter(beans, key) {
    const column = beans.colModel.getColDefCol(key);
    if (column) return beans.colFilter?.destroyFilter(column, "api");
}
function $437b23f6a393c3bf$var$setFilterModel(beans, model) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.filterManager?.setFilterModel(model));
}
function $437b23f6a393c3bf$var$getFilterModel(beans) {
    return beans.filterManager?.getFilterModel() ?? {};
}
function $437b23f6a393c3bf$var$getColumnFilterModel(beans, key, useUnapplied) {
    const { gos: gos, colModel: colModel, colFilter: colFilter } = beans;
    if (useUnapplied && !gos.get("enableFilterHandlers")) {
        $437b23f6a393c3bf$export$545083624300f13d(288);
        useUnapplied = false;
    }
    const column = colModel.getColDefCol(key);
    return column ? colFilter?.getModelForColumn(column, useUnapplied) ?? null : null;
}
function $437b23f6a393c3bf$var$setColumnFilterModel(beans, column, model) {
    return beans.filterManager?.setColumnFilterModel(column, model) ?? Promise.resolve();
}
function $437b23f6a393c3bf$var$showColumnFilter(beans, colKey) {
    const column = beans.colModel.getCol(colKey);
    if (!column) {
        $437b23f6a393c3bf$export$a20c7248650823a9(12, {
            colKey: colKey
        });
        return;
    }
    beans.menuSvc?.showFilterMenu({
        column: column,
        containerType: "columnFilter",
        positionBy: "auto"
    });
}
function $437b23f6a393c3bf$var$hideColumnFilter(beans) {
    beans.menuSvc?.hideFilterMenu();
}
function $437b23f6a393c3bf$var$getColumnFilterHandler(beans, colKey) {
    const column = beans.colModel.getCol(colKey);
    if (!column) {
        $437b23f6a393c3bf$export$a20c7248650823a9(12, {
            colKey: colKey
        });
        return void 0;
    }
    return beans.colFilter?.getHandler(column, true);
}
function $437b23f6a393c3bf$var$doFilterAction(beans, params) {
    const { colModel: colModel, colFilter: colFilter, gos: gos } = beans;
    if (!gos.get("enableFilterHandlers")) {
        $437b23f6a393c3bf$export$545083624300f13d(287);
        return;
    }
    const { colId: colId, action: action } = params;
    if (colId) {
        const column = colModel.getColById(colId);
        if (column) colFilter?.updateModel(column, action);
    } else colFilter?.updateAllModels(action);
}
// packages/ag-grid-community/src/filter/columnFilterService.ts
var $437b23f6a393c3bf$var$DUMMY_HANDLER = {
    filterHandler: ()=>({
            doesFilterPass: ()=>true
        })
};
var $437b23f6a393c3bf$var$ColumnFilterService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colFilter";
        this.allColumnFilters = /* @__PURE__ */ new Map();
        this.allColumnListeners = /* @__PURE__ */ new Map();
        this.activeAggregateFilters = [];
        this.activeColumnFilters = [];
        // this is true when the grid is processing the filter change. this is used by the cell comps, so that they
        // don't flash when data changes due to filter changes. there is no need to flash when filter changes as the
        // user is in control, so doesn't make sense to show flashing changes. for example, go to main demo where
        // this feature is turned off (hack code to always return false for isSuppressFlashingCellsBecauseFiltering(), put in)
        // 100,000 rows and group by country. then do some filtering. all the cells flash, which is silly.
        this.processingFilterChange = false;
        // when we're waiting for cell data types to be inferred, we need to defer filter model updates
        this.modelUpdates = [];
        this.columnModelUpdates = [];
        /** This contains the UI state for handler columns */ this.state = /* @__PURE__ */ new Map();
        this.handlerMap = {
            ...$437b23f6a393c3bf$var$FILTER_HANDLER_MAP
        };
        this.isGlobalButtons = false;
        this.activeFilterComps = /* @__PURE__ */ new Set();
    }
    postConstruct() {
        this.addManagedEventListeners({
            gridColumnsChanged: this.onColumnsChanged.bind(this),
            dataTypesInferred: this.processFilterModelUpdateQueue.bind(this)
        });
        const gos = this.gos;
        const initialFilterModel = {
            ...gos.get("initialState")?.filter?.filterModel ?? {}
        };
        this.initialModel = initialFilterModel;
        this.model = {
            ...initialFilterModel
        };
        if (!gos.get("enableFilterHandlers")) delete this.handlerMap["agMultiColumnFilter"];
    }
    refreshModel() {
        this.onNewRowsLoaded("rowDataUpdated");
    }
    setModel(model, source = "api") {
        const { colModel: colModel, dataTypeSvc: dataTypeSvc, filterManager: filterManager } = this.beans;
        if (dataTypeSvc?.isPendingInference) {
            this.modelUpdates.push({
                model: model,
                source: source
            });
            return;
        }
        const allPromises = [];
        const previousModel = this.getModel(true);
        if (model) {
            const modelKeys = new Set(Object.keys(model));
            this.allColumnFilters.forEach((filterWrapper, colId)=>{
                const newModel = model[colId];
                allPromises.push(this.setModelOnFilterWrapper(filterWrapper, newModel));
                modelKeys.delete(colId);
            });
            modelKeys.forEach((colId)=>{
                const column = colModel.getColDefCol(colId) || colModel.getCol(colId);
                if (!column) {
                    $437b23f6a393c3bf$export$545083624300f13d(62, {
                        colId: colId
                    });
                    return;
                }
                if (!column.isFilterAllowed()) {
                    $437b23f6a393c3bf$export$545083624300f13d(63, {
                        colId: colId
                    });
                    return;
                }
                const filterWrapper = this.getOrCreateFilterWrapper(column, true);
                if (!filterWrapper) {
                    $437b23f6a393c3bf$export$545083624300f13d(64, {
                        colId: colId
                    });
                    return;
                }
                allPromises.push(this.setModelOnFilterWrapper(filterWrapper, model[colId], true));
            });
        } else {
            this.model = {};
            this.allColumnFilters.forEach((filterWrapper)=>{
                allPromises.push(this.setModelOnFilterWrapper(filterWrapper, null));
            });
        }
        $437b23f6a393c3bf$export$30ec7836a4847721.all(allPromises).then(()=>{
            const currentModel = this.getModel(true);
            const columns = [];
            this.allColumnFilters.forEach((filterWrapper, colId)=>{
                const before = previousModel ? previousModel[colId] : null;
                const after = currentModel ? currentModel[colId] : null;
                if (!$437b23f6a393c3bf$export$dbc2068cc90f5875(before, after)) columns.push(filterWrapper.column);
            });
            if (columns.length > 0) filterManager?.onFilterChanged({
                columns: columns,
                source: source
            });
        });
    }
    getModel(excludeInitialState) {
        const result = {};
        const { allColumnFilters: allColumnFilters, initialModel: initialModel, beans: { colModel: colModel } } = this;
        allColumnFilters.forEach((filterWrapper, key)=>{
            const model = this.getModelFromFilterWrapper(filterWrapper);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(model)) result[key] = model;
        });
        if (!excludeInitialState) for (const colId of Object.keys(initialModel)){
            const model = initialModel[colId];
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(model) && !allColumnFilters.has(colId) && colModel.getCol(colId)?.isFilterAllowed()) result[colId] = model;
        }
        return result;
    }
    setState(model, state, source = "api") {
        this.state.clear();
        if (state) for (const colId of Object.keys(state)){
            const newState = state[colId];
            this.state.set(colId, {
                model: $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId),
                state: newState
            });
        }
        this.setModel(model, source);
    }
    getState() {
        const state = this.state;
        if (!state.size) return void 0;
        const newState = {};
        let hasNewState = false;
        state.forEach((colState, colId)=>{
            const actualState = colState.state;
            if (actualState != null) {
                hasNewState = true;
                newState[colId] = actualState;
            }
        });
        return hasNewState ? newState : void 0;
    }
    getModelFromFilterWrapper(filterWrapper) {
        const column = filterWrapper.column;
        const colId = column.getColId();
        if (filterWrapper.isHandler) return $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId);
        const filter = filterWrapper.filter;
        if (filter) {
            if (typeof filter.getModel !== "function") {
                $437b23f6a393c3bf$export$545083624300f13d(66);
                return null;
            }
            return filter.getModel();
        }
        return $437b23f6a393c3bf$export$8981db65da4532f2(this.initialModel, colId);
    }
    isFilterPresent() {
        return this.activeColumnFilters.length > 0;
    }
    isAggFilterPresent() {
        return !!this.activeAggregateFilters.length;
    }
    disableFilters() {
        this.initialModel = {};
        const { allColumnFilters: allColumnFilters } = this;
        if (allColumnFilters.size) {
            allColumnFilters.forEach((filterWrapper)=>this.disposeFilterWrapper(filterWrapper, "advancedFilterEnabled"));
            return true;
        }
        return false;
    }
    updateActiveFilters() {
        const isFilterActive = (filter)=>{
            if (!filter) return false;
            if (!filter.isFilterActive) {
                $437b23f6a393c3bf$export$545083624300f13d(67);
                return false;
            }
            return filter.isFilterActive();
        };
        const { colModel: colModel, gos: gos } = this.beans;
        const groupFilterEnabled = !!$437b23f6a393c3bf$export$3708afee0330994(gos);
        const isAggFilter = (column)=>{
            const isSecondary = !column.isPrimary();
            if (isSecondary) return true;
            const isShowingPrimaryColumns = !colModel.isPivotActive();
            const isValueActive = column.isValueActive();
            if (!isValueActive || !isShowingPrimaryColumns) return false;
            if (colModel.isPivotMode()) return true;
            return groupFilterEnabled;
        };
        const activeAggregateFilters = [];
        const activeColumnFilters = [];
        const addFilter = (column, filterActive, doesFilterPassWrapper)=>{
            if (filterActive) {
                if (isAggFilter(column)) activeAggregateFilters.push(doesFilterPassWrapper);
                else activeColumnFilters.push(doesFilterPassWrapper);
            }
        };
        const promises = [];
        this.allColumnFilters.forEach((filterWrapper)=>{
            const column = filterWrapper.column;
            const colId = column.getColId();
            if (filterWrapper.isHandler) promises.push($437b23f6a393c3bf$export$30ec7836a4847721.resolve().then(()=>{
                addFilter(column, this.isHandlerActive(column), {
                    colId: colId,
                    isHandler: true,
                    handler: filterWrapper.handler,
                    handlerParams: filterWrapper.handlerParams
                });
            }));
            else {
                const promise = $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper);
                if (promise) promises.push(promise.then((filter)=>{
                    addFilter(column, isFilterActive(filter), {
                        colId: colId,
                        isHandler: false,
                        comp: filter
                    });
                }));
            }
        });
        return $437b23f6a393c3bf$export$30ec7836a4847721.all(promises).then(()=>{
            this.activeAggregateFilters = activeAggregateFilters;
            this.activeColumnFilters = activeColumnFilters;
        });
    }
    updateFilterFlagInColumns(source, additionalEventAttributes) {
        const promises = [];
        this.allColumnFilters.forEach((filterWrapper)=>{
            const column = filterWrapper.column;
            if (filterWrapper.isHandler) promises.push($437b23f6a393c3bf$export$30ec7836a4847721.resolve().then(()=>{
                this.setColFilterActive(column, this.isHandlerActive(column), source, additionalEventAttributes);
            }));
            else {
                const promise = $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper);
                if (promise) promises.push(promise.then((filter)=>{
                    this.setColFilterActive(column, filter.isFilterActive(), source, additionalEventAttributes);
                }));
            }
        });
        this.beans.groupFilter?.updateFilterFlags(source, additionalEventAttributes);
        return $437b23f6a393c3bf$export$30ec7836a4847721.all(promises);
    }
    doFiltersPass(node, colIdToSkip, targetAggregates) {
        const { data: data, aggData: aggData } = node;
        const targetedFilters = targetAggregates ? this.activeAggregateFilters : this.activeColumnFilters;
        const targetedData = targetAggregates ? aggData : data;
        const model = this.model;
        for(let i = 0; i < targetedFilters.length; i++){
            const filter = targetedFilters[i];
            const { colId: colId, isHandler: isHandler } = filter;
            if (colId === colIdToSkip) continue;
            if (isHandler) {
                const { handler: handler, handlerParams: handlerParams } = filter;
                if (!handler.doesFilterPass({
                    node: node,
                    data: targetedData,
                    model: $437b23f6a393c3bf$export$8981db65da4532f2(model, colId),
                    handlerParams: handlerParams
                })) return false;
            } else {
                const comp = filter.comp;
                if (typeof comp.doesFilterPass !== "function") {
                    $437b23f6a393c3bf$export$a20c7248650823a9(91);
                    continue;
                }
                if (!comp.doesFilterPass({
                    node: node,
                    data: targetedData
                })) return false;
            }
        }
        return true;
    }
    getHandlerParams(column) {
        const wrapper = this.allColumnFilters.get(column.getColId());
        return wrapper?.isHandler ? wrapper.handlerParams : void 0;
    }
    // sometimes (especially in React) the filter can call onFilterChanged when we are in the middle
    // of a render cycle. this would be bad, so we wait for render cycle to complete when this happens.
    // this happens in react when we change React State in the grid (eg setting RowCtrl's in RowContainer)
    // which results in React State getting applied in the main application, triggering a useEffect() to
    // be kicked off adn then the application calling the grid's API. in AG-6554, the custom filter was
    // getting it's useEffect() triggered in this way.
    callOnFilterChangedOutsideRenderCycle(params) {
        const { rowRenderer: rowRenderer, filterManager: filterManager } = this.beans;
        const action = ()=>{
            if (this.isAlive()) filterManager?.onFilterChanged(params);
        };
        if (rowRenderer.isRefreshInProgress()) setTimeout(action, 0);
        else action();
    }
    updateBeforeFilterChanged(params = {}) {
        const { column: column, additionalEventAttributes: additionalEventAttributes } = params;
        const colId = column?.getColId();
        return this.updateActiveFilters().then(()=>this.updateFilterFlagInColumns("filterChanged", additionalEventAttributes).then(()=>{
                this.allColumnFilters.forEach((filterWrapper)=>{
                    const { column: filterColumn, isHandler: isHandler } = filterWrapper;
                    if (colId === filterColumn.getColId()) return;
                    if (isHandler) filterWrapper.handler.onAnyFilterChanged?.();
                    $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper, isHandler)?.then((filter)=>{
                        if (typeof filter?.onAnyFilterChanged === "function") filter.onAnyFilterChanged();
                    });
                });
                this.processingFilterChange = true;
            }));
    }
    updateAfterFilterChanged() {
        this.processingFilterChange = false;
    }
    isSuppressFlashingCellsBecauseFiltering() {
        const allowShowChangeAfterFilter = this.gos.get("allowShowChangeAfterFilter") ?? false;
        return !allowShowChangeAfterFilter && this.processingFilterChange;
    }
    onNewRowsLoaded(source) {
        const promises = [];
        this.allColumnFilters.forEach((filterWrapper)=>{
            const isHandler = filterWrapper.isHandler;
            if (isHandler) filterWrapper.handler.onNewRowsLoaded?.();
            const promise = $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper, isHandler);
            if (promise) promises.push(promise.then((filter)=>{
                filter.onNewRowsLoaded?.();
            }));
        });
        $437b23f6a393c3bf$export$30ec7836a4847721.all(promises).then(()=>this.updateFilterFlagInColumns(source, {
                afterDataChange: true
            })).then(()=>this.updateActiveFilters());
    }
    createGetValue(filterColumn, filterValueGetterOverride) {
        const { filterValueSvc: filterValueSvc, colModel: colModel } = this.beans;
        return (rowNode, column)=>{
            const columnToUse = column ? colModel.getCol(column) : filterColumn;
            return columnToUse ? filterValueSvc.getValue(columnToUse, rowNode, filterValueGetterOverride) : void 0;
        };
    }
    isFilterActive(column) {
        const filterWrapper = this.cachedFilter(column);
        if (filterWrapper?.isHandler) return this.isHandlerActive(column);
        const filter = filterWrapper?.filter;
        if (filter) return filter.isFilterActive();
        return $437b23f6a393c3bf$export$8981db65da4532f2(this.initialModel, column.getColId()) != null;
    }
    isHandlerActive(column) {
        const active = $437b23f6a393c3bf$export$25d27f17d3af40f7($437b23f6a393c3bf$export$8981db65da4532f2(this.model, column.getColId()));
        if (active) return active;
        const groupFilter = this.beans.groupFilter;
        return groupFilter?.isGroupFilter(column) ? groupFilter.isFilterActive(column) : false;
    }
    getOrCreateFilterUi(column) {
        const filterWrapper = this.getOrCreateFilterWrapper(column, true);
        return filterWrapper ? $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper) : null;
    }
    getFilterUiForDisplay(column) {
        const filterWrapper = this.getOrCreateFilterWrapper(column, true);
        if (!filterWrapper) return null;
        const compPromise = $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper);
        if (!compPromise) return null;
        return compPromise.then((comp)=>({
                comp: comp,
                params: filterWrapper.filterUi.filterParams,
                isHandler: filterWrapper.isHandler
            }));
    }
    getHandler(column, createIfMissing) {
        const filterWrapper = this.getOrCreateFilterWrapper(column, createIfMissing);
        return filterWrapper?.isHandler ? filterWrapper.handler : void 0;
    }
    getOrCreateFilterWrapper(column, createIfMissing) {
        if (!column.isFilterAllowed()) return void 0;
        let filterWrapper = this.cachedFilter(column);
        if (!filterWrapper && createIfMissing) {
            filterWrapper = this.createFilterWrapper(column);
            this.setColumnFilterWrapper(column, filterWrapper);
        }
        return filterWrapper;
    }
    cachedFilter(column) {
        return this.allColumnFilters.get(column.getColId());
    }
    getDefaultFilter(column, isFloating = false) {
        return this.getDefaultFilterFromDataType(()=>this.beans.dataTypeSvc?.getBaseDataType(column), isFloating);
    }
    getDefaultFilterFromDataType(getCellDataType, isFloating = false) {
        if ($437b23f6a393c3bf$export$b68e6345dc6b83fa(this.gos)) return isFloating ? "agSetColumnFloatingFilter" : "agSetColumnFilter";
        return $437b23f6a393c3bf$export$4a4e3cf6acc7e93(getCellDataType(), isFloating);
    }
    getDefaultFloatingFilter(column) {
        return this.getDefaultFilter(column, true);
    }
    createFilterComp(column, filterDef, defaultFilter, getFilterParams, isHandler, source) {
        const createFilterCompDetails = ()=>{
            const params = this.createFilterCompParams(column, isHandler, source);
            const updatedParams = getFilterParams(params, isHandler);
            return $437b23f6a393c3bf$export$e6db9a2d59456da0(this.beans.userCompFactory, filterDef, updatedParams, defaultFilter);
        };
        const compDetails = createFilterCompDetails();
        if (!compDetails) return null;
        const createFilterUi = (update)=>{
            return (update ? createFilterCompDetails() : compDetails).newAgStackInstance();
        };
        return {
            compDetails: compDetails,
            createFilterUi: createFilterUi
        };
    }
    createFilterInstance(column, filterDef, defaultFilter, getFilterParams) {
        const selectableFilter = this.beans.selectableFilter;
        if (selectableFilter?.isSelectable(filterDef)) filterDef = selectableFilter.getFilterDef(column, filterDef);
        const { handler: handler, handlerParams: handlerParams, handlerGenerator: handlerGenerator } = this.createHandler(column, filterDef, defaultFilter) ?? {};
        const filterCompDetails = this.createFilterComp(column, filterDef, defaultFilter, getFilterParams, !!handler, "init");
        if (!filterCompDetails) return {
            compDetails: null,
            createFilterUi: null,
            handler: handler,
            handlerGenerator: handlerGenerator,
            handlerParams: handlerParams
        };
        const { compDetails: compDetails, createFilterUi: createFilterUi } = filterCompDetails;
        if (this.isGlobalButtons) {
            const hasLocalButtons = !!compDetails.params?.buttons?.length;
            if (!hasLocalButtons) $437b23f6a393c3bf$export$545083624300f13d(281, {
                colId: column.getColId()
            });
        }
        return {
            compDetails: compDetails,
            handler: handler,
            handlerGenerator: handlerGenerator,
            handlerParams: handlerParams,
            createFilterUi: createFilterUi
        };
    }
    createBaseFilterParams(column, forFloatingFilter) {
        const { filterManager: filterManager, rowModel: rowModel } = this.beans;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            column: column,
            colDef: column.getColDef(),
            getValue: this.createGetValue(column),
            doesRowPassOtherFilter: forFloatingFilter ? ()=>true : (node)=>filterManager?.doesRowPassOtherFilters(column.getColId(), node) ?? true,
            rowModel: // to avoid breaking changes to `filterParams` defined as functions
            // we need to provide the below options even though they are not valid for handlers
            rowModel
        });
    }
    createFilterCompParams(column, useHandler, source, forFloatingFilter) {
        const filterChangedCallback = this.filterChangedCallbackFactory(column);
        const params = this.createBaseFilterParams(column, forFloatingFilter);
        params.filterChangedCallback = filterChangedCallback;
        params.filterModifiedCallback = forFloatingFilter ? ()=>{} : (additionalEventAttributes)=>this.filterModified(column, additionalEventAttributes);
        if (useHandler) {
            const displayParams = params;
            const colId = column.getColId();
            const model = $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId);
            displayParams.model = model;
            displayParams.state = this.state.get(colId) ?? {
                model: model
            };
            displayParams.onModelChange = (model2, additionalEventAttributes)=>{
                this.updateStoredModel(colId, model2);
                this.refreshHandlerAndUi(column, model2, "ui").then(()=>{
                    filterChangedCallback({
                        ...additionalEventAttributes,
                        source: "columnFilter"
                    });
                });
            };
            displayParams.onStateChange = (state)=>{
                this.updateState(column, state);
                this.updateOrRefreshFilterUi(column);
            };
            displayParams.onAction = (action, additionalEventAttributes, event)=>{
                this.updateModel(column, action, additionalEventAttributes);
                this.dispatchLocalEvent({
                    type: "filterAction",
                    column: column,
                    action: action,
                    event: event
                });
            };
            displayParams.getHandler = ()=>this.getHandler(column, true);
            displayParams.onUiChange = (additionalEventAttributes)=>this.filterUiChanged(column, additionalEventAttributes);
            displayParams.source = source;
        }
        return params;
    }
    createFilterUiForHandler(compDetails, createFilterUi) {
        return createFilterUi ? {
            created: false,
            create: createFilterUi,
            filterParams: compDetails.params,
            compDetails: compDetails
        } : null;
    }
    createFilterUiLegacy(compDetails, createFilterUi, updateInstanceCallback) {
        const promise = createFilterUi();
        const filterUi = {
            created: true,
            create: createFilterUi,
            filterParams: compDetails.params,
            compDetails: compDetails,
            promise: promise
        };
        promise.then(updateInstanceCallback);
        return filterUi;
    }
    createFilterWrapper(column) {
        const { compDetails: compDetails, handler: handler, handlerGenerator: handlerGenerator, handlerParams: handlerParams, createFilterUi: createFilterUi } = this.createFilterInstance(column, column.getColDef(), this.getDefaultFilter(column), (params)=>params);
        const colId = column.getColId();
        if (handler) {
            delete this.initialModel[colId];
            handler.init?.({
                ...handlerParams,
                source: "init",
                model: $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId)
            });
            return {
                column: column,
                isHandler: true,
                handler: handler,
                handlerGenerator: handlerGenerator,
                handlerParams: handlerParams,
                filterUi: this.createFilterUiForHandler(compDetails, createFilterUi)
            };
        }
        if (createFilterUi) {
            const filterWrapper = {
                column: column,
                filterUi: null,
                isHandler: false
            };
            filterWrapper.filterUi = this.createFilterUiLegacy(compDetails, createFilterUi, (filterComp)=>{
                filterWrapper.filter = filterComp ?? void 0;
            });
            return filterWrapper;
        }
        return {
            column: column,
            filterUi: null,
            isHandler: false
        };
    }
    createHandlerFunc(filterDef, defaultFilter) {
        const { gos: gos, frameworkOverrides: frameworkOverrides, registry: registry } = this.beans;
        let doesFilterPass;
        const getFilterHandlerFromDef = (filterDef2)=>{
            const filter = filterDef2.filter;
            if ($437b23f6a393c3bf$var$isColumnFilterComp(filter)) {
                const handler = filter.handler;
                if (handler) return handler;
                doesFilterPass = filter.doesFilterPass;
                if (doesFilterPass) return ()=>({
                        doesFilterPass: doesFilterPass
                    });
                return void 0;
            }
            return typeof filter === "string" ? filter : void 0;
        };
        const providedFilterHandler = gos.get("enableFilterHandlers") ? getFilterHandlerFromDef(filterDef) : void 0;
        const resolveProvidedFilterHandler = (handlerName2)=>()=>this.createBean(registry.createDynamicBean(handlerName2, true));
        let filterHandler;
        let handlerName;
        if (typeof providedFilterHandler === "string") {
            const userFilterHandler = gos.get("filterHandlers")?.[providedFilterHandler];
            if (userFilterHandler != null) filterHandler = userFilterHandler;
            else if ($437b23f6a393c3bf$var$FILTER_HANDLERS.has(providedFilterHandler)) {
                filterHandler = resolveProvidedFilterHandler(providedFilterHandler);
                handlerName = providedFilterHandler;
            }
        } else filterHandler = providedFilterHandler;
        if (!filterHandler) {
            let filterName;
            const { compName: compName, jsComp: jsComp, fwComp: fwComp } = $437b23f6a393c3bf$var$_getFilterCompKeys(frameworkOverrides, filterDef);
            if (compName) filterName = compName;
            else {
                const usingDefaultFilter = jsComp == null && fwComp == null && filterDef.filter === true;
                if (usingDefaultFilter) filterName = defaultFilter;
            }
            handlerName = this.handlerMap[filterName];
            if (handlerName) filterHandler = resolveProvidedFilterHandler(handlerName);
        }
        if (!filterHandler) return void 0;
        return {
            filterHandler: filterHandler,
            handlerNameOrCallback: doesFilterPass ?? handlerName
        };
    }
    createHandler(column, filterDef, defaultFilter) {
        let handlerFunc = this.createHandlerFunc(filterDef, defaultFilter);
        if (!handlerFunc) {
            const gos = this.gos;
            if (!gos.get("enableFilterHandlers")) return void 0;
            if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos)) $437b23f6a393c3bf$export$545083624300f13d(277, {
                colId: column.getColId()
            });
            handlerFunc = $437b23f6a393c3bf$var$DUMMY_HANDLER;
        }
        const filterParams = $437b23f6a393c3bf$var$_mergeFilterParamsWithApplicationProvidedParams(this.beans.userCompFactory, filterDef, this.createFilterCompParams(column, true, "init"));
        const { handlerNameOrCallback: handlerNameOrCallback, filterHandler: filterHandler } = handlerFunc;
        const { handler: handler, handlerParams: handlerParams } = this.createHandlerFromFunc(column, filterHandler, filterParams);
        return {
            handler: handler,
            handlerParams: handlerParams,
            handlerGenerator: handlerNameOrCallback ?? filterHandler
        };
    }
    createHandlerFromFunc(column, filterHandler, filterParams) {
        const colDef = column.getColDef();
        const handler = filterHandler($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            column: column,
            colDef: colDef
        }));
        const handlerParams = this.createHandlerParams(column, filterParams);
        return {
            handler: handler,
            handlerParams: handlerParams
        };
    }
    createHandlerParams(column, filterParams) {
        const colDef = column.getColDef();
        const colId = column.getColId();
        const filterChangedCallback = this.filterChangedCallbackFactory(column);
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            colDef: colDef,
            column: column,
            getValue: this.createGetValue(column),
            doesRowPassOtherFilter: (node)=>this.beans.filterManager?.doesRowPassOtherFilters(colId, node) ?? true,
            onModelChange: (newModel, additionalEventAttributes)=>{
                this.updateStoredModel(colId, newModel);
                this.refreshHandlerAndUi(column, newModel, "handler").then(()=>{
                    filterChangedCallback({
                        ...additionalEventAttributes,
                        source: "columnFilter"
                    });
                });
            },
            filterParams: filterParams
        });
    }
    onColumnsChanged() {
        const columns = [];
        const { colModel: colModel, filterManager: filterManager, groupFilter: groupFilter } = this.beans;
        this.allColumnFilters.forEach((wrapper, colId)=>{
            let currentColumn;
            if (wrapper.column.isPrimary()) currentColumn = colModel.getColDefCol(colId);
            else currentColumn = colModel.getCol(colId);
            if (currentColumn && currentColumn === wrapper.column) return;
            columns.push(wrapper.column);
            this.disposeFilterWrapper(wrapper, "columnChanged");
            this.disposeColumnListener(colId);
        });
        const allFiltersAreGroupFilters = groupFilter && columns.every((col)=>groupFilter.isGroupFilter(col));
        if (columns.length > 0 && !allFiltersAreGroupFilters) filterManager?.onFilterChanged({
            columns: columns,
            source: "api"
        });
    }
    isFilterAllowed(column) {
        const isFilterAllowed = column.isFilterAllowed();
        if (!isFilterAllowed) return false;
        const groupFilter = this.beans.groupFilter;
        if (groupFilter?.isGroupFilter(column)) return groupFilter.isFilterAllowed(column);
        return true;
    }
    getFloatingFilterCompDetails(column, showParentFilter) {
        const { userCompFactory: userCompFactory, frameworkOverrides: frameworkOverrides, selectableFilter: selectableFilter } = this.beans;
        const parentFilterInstance = (callback)=>{
            const filterComponent = this.getOrCreateFilterUi(column);
            if (filterComponent == null) return;
            filterComponent.then((instance)=>{
                callback($437b23f6a393c3bf$export$213d4c63c3df47e4(instance));
            });
        };
        const colDef = column.getColDef();
        const filterDef = selectableFilter?.isSelectable(colDef) ? selectableFilter.getFilterDef(column, colDef) : colDef;
        const defaultFloatingFilterType = $437b23f6a393c3bf$export$47072b32bdaf5d61(frameworkOverrides, filterDef, ()=>this.getDefaultFloatingFilter(column)) ?? "agReadOnlyFloatingFilter";
        const isReactive = this.gos.get("enableFilterHandlers");
        const filterParams = $437b23f6a393c3bf$var$_mergeFilterParamsWithApplicationProvidedParams(userCompFactory, filterDef, this.createFilterCompParams(column, isReactive, "init", true));
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            column: column,
            filterParams: filterParams,
            currentParentModel: ()=>this.getCurrentFloatingFilterParentModel(column),
            parentFilterInstance: parentFilterInstance,
            showParentFilter: showParentFilter
        });
        if (isReactive) {
            const displayParams = params;
            const colId = column.getColId();
            const filterChangedCallback = this.filterChangedCallbackFactory(column);
            displayParams.onUiChange = (additionalEventAttributes)=>this.floatingFilterUiChanged(column, additionalEventAttributes);
            displayParams.model = $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId);
            displayParams.onModelChange = (model, additionalEventAttributes)=>{
                this.updateStoredModel(colId, model);
                this.refreshHandlerAndUi(column, model, "floating", true).then(()=>{
                    filterChangedCallback({
                        ...additionalEventAttributes,
                        source: "columnFilter"
                    });
                });
            };
            displayParams.getHandler = ()=>this.getHandler(column, true);
            displayParams.source = "init";
        }
        return $437b23f6a393c3bf$export$14d0998f093f007e(userCompFactory, colDef, params, defaultFloatingFilterType);
    }
    getCurrentFloatingFilterParentModel(column) {
        return this.getModelFromFilterWrapper(this.cachedFilter(column) ?? {
            column: column
        });
    }
    destroyFilterUi(filterWrapper, column, compDetails, createFilterUi) {
        if (filterWrapper.isHandler) {
            const colId = column.getColId();
            delete this.initialModel[colId];
            this.state.delete(colId);
            const filterUi = filterWrapper.filterUi;
            const newFilterUi = this.createFilterUiForHandler(compDetails, createFilterUi);
            filterWrapper.filterUi = newFilterUi;
            if (filterUi?.created) filterUi.promise.then((filter)=>{
                this.destroyBean(filter);
                this.eventSvc.dispatchEvent({
                    type: "filterDestroyed",
                    source: "paramsUpdated",
                    column: filterWrapper.column
                });
            });
        } else this.destroyFilter(column, "paramsUpdated");
    }
    // destroys the filter, so it no longer takes part
    destroyFilter(column, source = "api") {
        const colId = column.getColId();
        const filterWrapper = this.allColumnFilters.get(colId);
        this.disposeColumnListener(colId);
        delete this.initialModel[colId];
        if (filterWrapper) this.disposeFilterWrapper(filterWrapper, source).then((wasActive)=>{
            if (wasActive && this.isAlive()) this.beans.filterManager?.onFilterChanged({
                columns: [
                    column
                ],
                source: "api"
            });
        });
    }
    disposeColumnListener(colId) {
        const columnListener = this.allColumnListeners.get(colId);
        if (columnListener) {
            this.allColumnListeners.delete(colId);
            columnListener();
        }
    }
    disposeFilterWrapper(filterWrapper, source) {
        let isActive = false;
        const { column: column, isHandler: isHandler, filterUi: filterUi } = filterWrapper;
        const colId = column.getColId();
        if (isHandler) {
            isActive = this.isHandlerActive(column);
            this.destroyBean(filterWrapper.handler);
            delete this.model[colId];
            this.state.delete(colId);
        }
        const removeFilter = ()=>{
            this.setColFilterActive(column, false, "filterDestroyed");
            this.allColumnFilters.delete(colId);
            this.eventSvc.dispatchEvent({
                type: "filterDestroyed",
                source: source,
                column: column
            });
        };
        if (filterUi) {
            if (filterUi.created) return filterUi.promise.then((filter)=>{
                isActive = isHandler ? isActive : !!filter?.isFilterActive();
                this.destroyBean(filter);
                removeFilter();
                return isActive;
            });
            else removeFilter();
        }
        return $437b23f6a393c3bf$export$30ec7836a4847721.resolve(isActive);
    }
    filterChangedCallbackFactory(column) {
        return (additionalEventAttributes)=>{
            this.callOnFilterChangedOutsideRenderCycle({
                additionalEventAttributes: additionalEventAttributes,
                columns: [
                    column
                ],
                column: column,
                source: additionalEventAttributes?.source ?? "columnFilter"
            });
        };
    }
    filterParamsChanged(colId, source = "api") {
        const filterWrapper = this.allColumnFilters.get(colId);
        if (!filterWrapper) return;
        const beans = this.beans;
        const column = filterWrapper.column;
        const colDef = column.getColDef();
        const isFilterAllowed = column.isFilterAllowed();
        const defaultFilter = this.getDefaultFilter(column);
        const selectableFilter = beans.selectableFilter;
        const filterDef = selectableFilter?.isSelectable(colDef) ? selectableFilter.getFilterDef(column, colDef) : colDef;
        const handlerFunc = isFilterAllowed ? this.createHandlerFunc(filterDef, this.getDefaultFilter(column)) : void 0;
        const isHandler = !!handlerFunc;
        const wasHandler = filterWrapper.isHandler;
        if (wasHandler != isHandler) {
            this.destroyFilter(column, "paramsUpdated");
            return;
        }
        const { compDetails: compDetails, createFilterUi: createFilterUi } = (isFilterAllowed ? this.createFilterComp(column, filterDef, defaultFilter, (params)=>params, isHandler, "colDef") : null) ?? {
            compDetails: null,
            createFilterUi: null
        };
        const newFilterParams = compDetails?.params ?? $437b23f6a393c3bf$var$_mergeFilterParamsWithApplicationProvidedParams(beans.userCompFactory, filterDef, this.createFilterCompParams(column, isHandler, "colDef"));
        if (wasHandler) {
            const handlerGenerator = handlerFunc?.handlerNameOrCallback ?? handlerFunc?.filterHandler;
            const existingModel = $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId);
            if (filterWrapper.handlerGenerator != handlerGenerator) {
                const oldHandler = filterWrapper.handler;
                const { handler: handler, handlerParams: handlerParams } = this.createHandlerFromFunc(column, handlerFunc.filterHandler, newFilterParams);
                filterWrapper.handler = handler;
                filterWrapper.handlerParams = handlerParams;
                filterWrapper.handlerGenerator = handlerGenerator;
                delete this.model[colId];
                handler.init?.({
                    ...handlerParams,
                    source: "init",
                    model: null
                });
                this.destroyBean(oldHandler);
                if (existingModel != null) this.beans.filterManager?.onFilterChanged({
                    columns: [
                        column
                    ],
                    source: source
                });
            } else {
                const handlerParams = this.createHandlerParams(column, compDetails?.params);
                filterWrapper.handlerParams = handlerParams;
                filterWrapper.handler.refresh?.({
                    ...handlerParams,
                    source: "colDef",
                    model: existingModel
                });
            }
        }
        if (this.areFilterCompsDifferent(filterWrapper.filterUi?.compDetails ?? null, compDetails) || !filterWrapper.filterUi || !compDetails) {
            this.destroyFilterUi(filterWrapper, column, compDetails, createFilterUi);
            return;
        }
        filterWrapper.filterUi.filterParams = newFilterParams;
        $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper, wasHandler)?.then((filter)=>{
            const shouldRefreshFilter = filter?.refresh ? filter.refresh(newFilterParams) : true;
            if (shouldRefreshFilter === false) this.destroyFilterUi(filterWrapper, column, compDetails, createFilterUi);
            else this.dispatchLocalEvent({
                type: "filterParamsChanged",
                column: column,
                params: newFilterParams
            });
        });
    }
    refreshHandlerAndUi(column, model, source, createIfMissing) {
        const filterWrapper = this.cachedFilter(column);
        if (!filterWrapper) {
            if (createIfMissing) this.getOrCreateFilterWrapper(column, true);
            return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
        }
        if (!filterWrapper.isHandler) return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
        const { filterUi: filterUi, handler: handler, handlerParams: handlerParams } = filterWrapper;
        return $437b23f6a393c3bf$export$1fc9ad198b29415d(()=>{
            if (filterUi) {
                const { created: created, filterParams: filterParams } = filterUi;
                if (created) return filterUi.promise.then((filter)=>{
                    return filter ? {
                        filter: filter,
                        filterParams: filterParams
                    } : void 0;
                });
                else filterUi.refreshed = true;
            }
            return $437b23f6a393c3bf$export$30ec7836a4847721.resolve(void 0);
        }, handler, handlerParams, model, this.state.get(column.getColId()) ?? {
            model: model
        }, source);
    }
    setColumnFilterWrapper(column, filterWrapper) {
        const colId = column.getColId();
        this.allColumnFilters.set(colId, filterWrapper);
        this.allColumnListeners.set(colId, this.addManagedListeners(column, {
            colDefChanged: ()=>this.filterParamsChanged(colId)
        })[0]);
    }
    areFilterCompsDifferent(oldCompDetails, newCompDetails) {
        if (!newCompDetails || !oldCompDetails) return true;
        const { componentClass: oldComponentClass } = oldCompDetails;
        const { componentClass: newComponentClass } = newCompDetails;
        const isSameComponentClass = oldComponentClass === newComponentClass || // react hooks returns new wrappers, so check nested render method
        oldComponentClass?.render && newComponentClass?.render && oldComponentClass.render === newComponentClass.render;
        return !isSameComponentClass;
    }
    hasFloatingFilters() {
        const gridColumns = this.beans.colModel.getCols();
        return gridColumns.some((col)=>col.getColDef().floatingFilter);
    }
    getFilterInstance(key) {
        const column = this.beans.colModel.getColDefCol(key);
        if (!column) return Promise.resolve(void 0);
        const filterPromise = this.getOrCreateFilterUi(column);
        if (!filterPromise) return Promise.resolve(null);
        return new Promise((resolve)=>{
            filterPromise.then((filter)=>{
                resolve($437b23f6a393c3bf$export$213d4c63c3df47e4(filter));
            });
        });
    }
    processFilterModelUpdateQueue() {
        this.modelUpdates.forEach(({ model: model, source: source })=>this.setModel(model, source));
        this.modelUpdates = [];
        this.columnModelUpdates.forEach(({ key: key, model: model, resolve: resolve })=>{
            this.setModelForColumn(key, model).then(()=>resolve());
        });
        this.columnModelUpdates = [];
    }
    getModelForColumn(column, useUnapplied) {
        if (useUnapplied) {
            const { state: state, model: model } = this;
            const colId = column.getColId();
            const colState = state.get(colId);
            if (colState) return colState.model ?? null;
            return $437b23f6a393c3bf$export$8981db65da4532f2(model, colId);
        }
        const filterWrapper = this.cachedFilter(column);
        return filterWrapper ? this.getModelFromFilterWrapper(filterWrapper) : null;
    }
    setModelForColumn(key, model) {
        if (this.beans.dataTypeSvc?.isPendingInference) {
            let resolve = ()=>{};
            const promise = new Promise((res)=>{
                resolve = res;
            });
            this.columnModelUpdates.push({
                key: key,
                model: model,
                resolve: resolve
            });
            return promise;
        }
        return new Promise((resolve)=>{
            this.setModelForColumnLegacy(key, model).then((result)=>resolve(result));
        });
    }
    getStateForColumn(colId) {
        return this.state.get(colId) ?? {
            model: $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId)
        };
    }
    setModelForColumnLegacy(key, model) {
        const column = this.beans.colModel.getColDefCol(key);
        const filterWrapper = column ? this.getOrCreateFilterWrapper(column, true) : null;
        return filterWrapper ? this.setModelOnFilterWrapper(filterWrapper, model) : $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
    }
    setColDefPropsForDataType(colDef, dataTypeDefinition, formatValue) {
        const providedFilter = colDef.filter;
        const filter = providedFilter === true ? this.getDefaultFilterFromDataType(()=>dataTypeDefinition.baseDataType) : providedFilter;
        if (typeof filter !== "string") return;
        let filterParams;
        let filterValueGetter;
        const beans = this.beans;
        const { filterParams: colDefFilterParams, filterValueGetter: colDefFilterValueGetter } = colDef;
        if (filter === "agMultiColumnFilter") ({ filterParams: filterParams, filterValueGetter: filterValueGetter } = beans.multiFilter?.getParamsForDataType(colDefFilterParams, colDefFilterValueGetter, dataTypeDefinition, formatValue) ?? {});
        else ({ filterParams: filterParams, filterValueGetter: filterValueGetter } = $437b23f6a393c3bf$export$4a99b58ce484acc(filter, colDefFilterParams, colDefFilterValueGetter, dataTypeDefinition, formatValue, beans, this.getLocaleTextFunc()));
        colDef.filterParams = filterParams;
        if (filterValueGetter) colDef.filterValueGetter = filterValueGetter;
    }
    // additionalEventAttributes is used by provided simple floating filter, so it can add 'floatingFilter=true' to the event
    setColFilterActive(column, active, source, additionalEventAttributes) {
        if (column.filterActive !== active) {
            column.filterActive = active;
            column.dispatchColEvent("filterActiveChanged", source);
        }
        column.dispatchColEvent("filterChanged", source, additionalEventAttributes);
    }
    setModelOnFilterWrapper(filterWrapper, newModel, justCreated) {
        return new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
            if (filterWrapper.isHandler) {
                const column = filterWrapper.column;
                const colId = column.getColId();
                const existingModel = this.model[colId];
                this.updateStoredModel(colId, newModel);
                if (justCreated && newModel === existingModel) {
                    resolve();
                    return;
                }
                this.refreshHandlerAndUi(column, newModel, "api").then(()=>resolve());
                return;
            }
            const uiPromise = $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper);
            if (uiPromise) {
                uiPromise.then((filter)=>{
                    if (typeof filter?.setModel !== "function") {
                        $437b23f6a393c3bf$export$545083624300f13d(65);
                        resolve();
                        return;
                    }
                    (filter.setModel(newModel) || $437b23f6a393c3bf$export$30ec7836a4847721.resolve()).then(()=>resolve());
                });
                return;
            }
            resolve();
        });
    }
    /** for handlers only */ updateStoredModel(colId, model) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(model)) this.model[colId] = model;
        else delete this.model[colId];
        const oldState = this.state.get(colId);
        const newState = {
            model: model,
            state: oldState?.state
        };
        this.state.set(colId, newState);
    }
    filterModified(column, additionalEventAttributes) {
        this.getOrCreateFilterUi(column)?.then((filterInstance)=>{
            this.eventSvc.dispatchEvent({
                type: "filterModified",
                column: column,
                filterInstance: filterInstance,
                ...additionalEventAttributes
            });
        });
    }
    filterUiChanged(column, additionalEventAttributes) {
        if (this.gos.get("enableFilterHandlers")) this.eventSvc.dispatchEvent({
            type: "filterUiChanged",
            column: column,
            ...additionalEventAttributes
        });
    }
    floatingFilterUiChanged(column, additionalEventAttributes) {
        if (this.gos.get("enableFilterHandlers")) this.eventSvc.dispatchEvent({
            type: "floatingFilterUiChanged",
            column: column,
            ...additionalEventAttributes
        });
    }
    updateModel(column, action, additionalEventAttributes) {
        const colId = column.getColId();
        const getFilterUi = ()=>this.cachedFilter(column)?.filterUi;
        $437b23f6a393c3bf$export$3305e8c6f4c8572a(action, getFilterUi, ()=>$437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId), ()=>this.state.get(colId), (state)=>this.updateState(column, state), (model)=>getFilterUi()?.filterParams?.onModelChange(model, additionalEventAttributes));
    }
    updateAllModels(action, additionalEventAttributes) {
        const promises = [];
        this.allColumnFilters.forEach((filter, colId)=>{
            const column = this.beans.colModel.getColDefCol(colId);
            if (column) $437b23f6a393c3bf$export$3305e8c6f4c8572a(action, ()=>filter.filterUi, ()=>$437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId), ()=>this.state.get(colId), (state)=>this.updateState(column, state), (model)=>{
                this.updateStoredModel(colId, model);
                this.dispatchLocalEvent({
                    type: "filterAction",
                    column: column,
                    action: action
                });
                promises.push(this.refreshHandlerAndUi(column, model, "ui"));
            });
        });
        if (promises.length) $437b23f6a393c3bf$export$30ec7836a4847721.all(promises).then(()=>{
            this.callOnFilterChangedOutsideRenderCycle({
                source: "columnFilter",
                additionalEventAttributes: additionalEventAttributes,
                columns: []
            });
        });
    }
    updateOrRefreshFilterUi(column) {
        const colId = column.getColId();
        $437b23f6a393c3bf$var$getAndRefreshFilterUi(()=>this.cachedFilter(column)?.filterUi, ()=>$437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId), ()=>this.state.get(colId));
    }
    updateState(column, state) {
        this.state.set(column.getColId(), state);
        this.dispatchLocalEvent({
            type: "filterStateChanged",
            column: column,
            state: state
        });
    }
    // for tool panel only
    canApplyAll() {
        const { state: state, model: model, activeFilterComps: activeFilterComps } = this;
        for (const comp of activeFilterComps){
            if (comp.source === "COLUMN_MENU") return false;
        }
        let hasChanges = false;
        for (const colId of state.keys()){
            const colState = state.get(colId);
            if (colState.valid === false) return false;
            if ((colState.model ?? null) !== $437b23f6a393c3bf$export$8981db65da4532f2(model, colId)) hasChanges = true;
        }
        return hasChanges;
    }
    hasUnappliedModel(colId) {
        const { model: model, state: state } = this;
        return (state.get(colId)?.model ?? null) !== $437b23f6a393c3bf$export$8981db65da4532f2(model, colId);
    }
    setGlobalButtons(isGlobal) {
        this.isGlobalButtons = isGlobal;
        this.dispatchLocalEvent({
            type: "filterGlobalButtons",
            isGlobal: isGlobal
        });
    }
    shouldKeepStateOnDetach(column, lastContainerType) {
        if (lastContainerType === "newFiltersToolPanel") return true;
        const filterPanelSvc = this.beans.filterPanelSvc;
        if (filterPanelSvc?.isActive) return !!filterPanelSvc.getState(column.getColId());
        return false;
    }
    destroy() {
        super.destroy();
        this.allColumnFilters.forEach((filterWrapper)=>this.disposeFilterWrapper(filterWrapper, "gridDestroyed"));
        this.allColumnListeners.clear();
        this.state.clear();
        this.activeFilterComps.clear();
    }
};
// packages/ag-grid-community/src/filter/filterApi.ts
function $437b23f6a393c3bf$var$isAnyFilterPresent(beans) {
    return !!beans.filterManager?.isAnyFilterPresent();
}
function $437b23f6a393c3bf$var$onFilterChanged(beans, source = "api") {
    beans.filterManager?.onFilterChanged({
        source: source
    });
}
// packages/ag-grid-community/src/filter/filterManager.ts
var $437b23f6a393c3bf$var$FilterManager = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "filterManager";
        // when we're waiting for cell data types to be inferred, we need to defer filter model updates
        this.advFilterModelUpdateQueue = [];
    }
    wireBeans(beans) {
        this.quickFilter = beans.quickFilter;
        this.advancedFilter = beans.advancedFilter;
        this.colFilter = beans.colFilter;
    }
    postConstruct() {
        const refreshFiltersForAggregations = this.refreshFiltersForAggregations.bind(this);
        const updateAdvFilterColumns = this.updateAdvFilterColumns.bind(this);
        this.addManagedEventListeners({
            columnValueChanged: refreshFiltersForAggregations,
            columnPivotChanged: refreshFiltersForAggregations,
            columnPivotModeChanged: refreshFiltersForAggregations,
            newColumnsLoaded: updateAdvFilterColumns,
            columnVisible: updateAdvFilterColumns,
            advancedFilterEnabledChanged: ({ enabled: enabled })=>this.onAdvFilterEnabledChanged(enabled),
            dataTypesInferred: this.processFilterModelUpdateQueue.bind(this)
        });
        this.externalFilterPresent = this.isExternalFilterPresentCallback();
        this.addManagedPropertyListeners([
            "isExternalFilterPresent",
            "doesExternalFilterPass"
        ], ()=>{
            this.onFilterChanged({
                source: "api"
            });
        });
        this.updateAggFiltering();
        this.addManagedPropertyListener("groupAggFiltering", ()=>{
            this.updateAggFiltering();
            this.onFilterChanged();
        });
        if (this.quickFilter) this.addManagedListeners(this.quickFilter, {
            quickFilterChanged: ()=>this.onFilterChanged({
                    source: "quickFilter"
                })
        });
        const { gos: gos } = this;
        this.alwaysPassFilter = gos.get("alwaysPassFilter");
        this.addManagedPropertyListener("alwaysPassFilter", ()=>{
            this.alwaysPassFilter = gos.get("alwaysPassFilter");
            this.onFilterChanged({
                source: "api"
            });
        });
    }
    isExternalFilterPresentCallback() {
        const isFilterPresent = this.gos.getCallback("isExternalFilterPresent");
        return typeof isFilterPresent === "function" && isFilterPresent({});
    }
    doesExternalFilterPass(node) {
        const doesFilterPass = this.gos.get("doesExternalFilterPass");
        return typeof doesFilterPass === "function" && doesFilterPass(node);
    }
    setFilterState(model, state, source = "api") {
        if (this.isAdvFilterEnabled()) return;
        this.colFilter?.setState(model, state, source);
    }
    setFilterModel(model, source = "api", skipWarning) {
        if (this.isAdvFilterEnabled()) {
            if (!skipWarning) this.warnAdvFilters();
            return;
        }
        this.colFilter?.setModel(model, source);
    }
    getFilterModel() {
        return this.colFilter?.getModel() ?? {};
    }
    getFilterState() {
        return this.colFilter?.getState();
    }
    isColumnFilterPresent() {
        return !!this.colFilter?.isFilterPresent();
    }
    isAggregateFilterPresent() {
        return !!this.colFilter?.isAggFilterPresent();
    }
    isChildFilterPresent() {
        return this.isColumnFilterPresent() || this.isQuickFilterPresent() || this.externalFilterPresent || this.isAdvFilterPresent();
    }
    isAnyFilterPresent() {
        return this.isChildFilterPresent() || this.isAggregateFilterPresent();
    }
    isAdvFilterPresent() {
        return this.isAdvFilterEnabled() && this.advancedFilter.isFilterPresent();
    }
    onAdvFilterEnabledChanged(enabled) {
        if (enabled) {
            if (this.colFilter?.disableFilters()) this.onFilterChanged({
                source: "advancedFilter"
            });
        } else if (this.advancedFilter?.isFilterPresent()) {
            this.advancedFilter.setModel(null);
            this.onFilterChanged({
                source: "advancedFilter"
            });
        }
    }
    isAdvFilterEnabled() {
        return !!this.advancedFilter?.isEnabled();
    }
    isAdvFilterHeaderActive() {
        return this.isAdvFilterEnabled() && this.advancedFilter.isHeaderActive();
    }
    refreshFiltersForAggregations() {
        if ($437b23f6a393c3bf$export$3708afee0330994(this.gos) && this.isAnyFilterPresent()) this.onFilterChanged();
    }
    onFilterChanged(params = {}) {
        const { source: source, additionalEventAttributes: additionalEventAttributes, columns: columns = [] } = params;
        this.externalFilterPresent = this.isExternalFilterPresentCallback();
        (this.colFilter ? this.colFilter.updateBeforeFilterChanged(params) : $437b23f6a393c3bf$export$30ec7836a4847721.resolve()).then(()=>{
            const filterChangedEvent = {
                source: source,
                type: "filterChanged",
                columns: columns
            };
            if (additionalEventAttributes) $437b23f6a393c3bf$export$8ade6bd474fcde42(filterChangedEvent, additionalEventAttributes);
            this.eventSvc.dispatchEvent(filterChangedEvent);
            this.colFilter?.updateAfterFilterChanged();
        });
    }
    isSuppressFlashingCellsBecauseFiltering() {
        return !!this.colFilter?.isSuppressFlashingCellsBecauseFiltering();
    }
    isQuickFilterPresent() {
        return !!this.quickFilter?.isFilterPresent();
    }
    updateAggFiltering() {
        this.aggFiltering = !!$437b23f6a393c3bf$export$3708afee0330994(this.gos);
    }
    isAggregateQuickFilterPresent() {
        return this.isQuickFilterPresent() && this.shouldApplyQuickFilterAfterAgg();
    }
    isNonAggregateQuickFilterPresent() {
        return this.isQuickFilterPresent() && !this.shouldApplyQuickFilterAfterAgg();
    }
    shouldApplyQuickFilterAfterAgg() {
        return (this.aggFiltering || this.beans.colModel.isPivotMode()) && !this.gos.get("applyQuickFilterBeforePivotOrAgg");
    }
    doesRowPassOtherFilters(colIdToSkip, rowNode) {
        return this.doesRowPassFilter({
            rowNode: rowNode,
            colIdToSkip: colIdToSkip
        });
    }
    doesRowPassAggregateFilters(params) {
        const { rowNode: rowNode } = params;
        if (this.alwaysPassFilter?.(rowNode)) return true;
        if (this.isAggregateQuickFilterPresent() && !this.quickFilter.doesRowPass(rowNode)) return false;
        if (this.isAggregateFilterPresent() && !this.colFilter.doFiltersPass(rowNode, params.colIdToSkip, true)) return false;
        return true;
    }
    doesRowPassFilter(params) {
        const { rowNode: rowNode } = params;
        if (this.alwaysPassFilter?.(rowNode)) return true;
        if (this.isNonAggregateQuickFilterPresent() && !this.quickFilter.doesRowPass(rowNode)) return false;
        if (this.externalFilterPresent && !this.doesExternalFilterPass(rowNode)) return false;
        if (this.isColumnFilterPresent() && !this.colFilter.doFiltersPass(rowNode, params.colIdToSkip)) return false;
        if (this.isAdvFilterPresent() && !this.advancedFilter.doesFilterPass(rowNode)) return false;
        return true;
    }
    // for group filters, can change dynamically whether they are allowed or not
    isFilterAllowed(column) {
        if (this.isAdvFilterEnabled()) return false;
        return !!this.colFilter?.isFilterAllowed(column);
    }
    getAdvFilterModel() {
        return this.isAdvFilterEnabled() ? this.advancedFilter.getModel() : null;
    }
    setAdvFilterModel(expression, source = "api") {
        if (!this.isAdvFilterEnabled()) return;
        if (this.beans.dataTypeSvc?.isPendingInference) {
            this.advFilterModelUpdateQueue.push(expression);
            return;
        }
        this.advancedFilter.setModel(expression ?? null);
        this.onFilterChanged({
            source: source
        });
    }
    toggleAdvFilterBuilder(show, source) {
        if (!this.isAdvFilterEnabled()) return;
        this.advancedFilter.getCtrl().toggleFilterBuilder({
            source: source,
            force: show
        });
    }
    updateAdvFilterColumns() {
        if (!this.isAdvFilterEnabled()) return;
        if (this.advancedFilter.updateValidity()) this.onFilterChanged({
            source: "advancedFilter"
        });
    }
    hasFloatingFilters() {
        if (this.isAdvFilterEnabled()) return false;
        return !!this.colFilter?.hasFloatingFilters();
    }
    getColumnFilterInstance(key) {
        if (this.isAdvFilterEnabled()) {
            this.warnAdvFilters();
            return Promise.resolve(void 0);
        }
        return this.colFilter?.getFilterInstance(key) ?? Promise.resolve(void 0);
    }
    warnAdvFilters() {
        $437b23f6a393c3bf$export$545083624300f13d(68);
    }
    setupAdvFilterHeaderComp(eCompToInsertBefore) {
        this.advancedFilter?.getCtrl().setupHeaderComp(eCompToInsertBefore);
    }
    getHeaderRowCount() {
        return this.isAdvFilterHeaderActive() ? 1 : 0;
    }
    getHeaderHeight() {
        return this.isAdvFilterHeaderActive() ? this.advancedFilter.getCtrl().getHeaderHeight() : 0;
    }
    processFilterModelUpdateQueue() {
        this.advFilterModelUpdateQueue.forEach((model)=>this.setAdvFilterModel(model));
        this.advFilterModelUpdateQueue = [];
    }
    setColumnFilterModel(key, model) {
        if (this.isAdvFilterEnabled()) {
            this.warnAdvFilters();
            return Promise.resolve();
        }
        return this.colFilter?.setModelForColumn(key, model) ?? Promise.resolve();
    }
};
// packages/ag-grid-community/src/filter/filterMenuFactory.ts
var $437b23f6a393c3bf$var$FilterMenuFactory = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "filterMenuFactory";
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
    }
    hideActiveMenu() {
        this.hidePopup?.();
    }
    showMenuAfterMouseEvent(column, mouseEvent, containerType, onClosedCallback) {
        if (column && !column.isColumn) return;
        this.showPopup(column, (eMenu)=>{
            this.popupSvc?.positionPopupUnderMouseEvent({
                column: column,
                type: containerType,
                mouseEvent: mouseEvent,
                ePopup: eMenu
            });
        }, containerType, mouseEvent.target, $437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos), onClosedCallback);
    }
    showMenuAfterButtonClick(column, eventSource, containerType, onClosedCallback) {
        if (column && !column.isColumn) return;
        let multiplier = -1;
        let alignSide = "left";
        const isLegacyMenuEnabled = $437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos);
        if (!isLegacyMenuEnabled && this.gos.get("enableRtl")) {
            multiplier = 1;
            alignSide = "right";
        }
        const nudgeX = isLegacyMenuEnabled ? void 0 : 4 * multiplier;
        const nudgeY = isLegacyMenuEnabled ? void 0 : 4;
        this.showPopup(column, (eMenu)=>{
            this.popupSvc?.positionPopupByComponent({
                type: containerType,
                eventSource: eventSource,
                ePopup: eMenu,
                nudgeX: nudgeX,
                nudgeY: nudgeY,
                alignSide: alignSide,
                keepWithinBounds: true,
                position: "under",
                column: column
            });
        }, containerType, eventSource, isLegacyMenuEnabled, onClosedCallback);
    }
    showPopup(column, positionCallback, containerType, eventSource, isLegacyMenuEnabled, onClosedCallback) {
        const comp = column ? this.createBean(new $437b23f6a393c3bf$export$7db6d402989d8b90(column, "COLUMN_MENU")) : void 0;
        this.activeMenu = comp;
        if (!comp?.hasFilter() || !column) {
            $437b23f6a393c3bf$export$a20c7248650823a9(57);
            return;
        }
        const eMenu = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: `ag-menu${!isLegacyMenuEnabled ? " ag-filter-menu" : ""}`,
            role: "presentation"
        });
        [this.tabListener] = this.addManagedElementListeners(eMenu, {
            keydown: (e)=>this.trapFocusWithin(e, eMenu)
        });
        eMenu.appendChild(comp?.getGui());
        let hidePopup;
        const afterGuiDetached = ()=>comp?.afterGuiDetached();
        const anchorToElement = $437b23f6a393c3bf$export$cfe4cf52f3717a7b(this.gos) ? eventSource ?? this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody : void 0;
        const closedCallback = (e)=>{
            $437b23f6a393c3bf$export$2f1bf9feac2f7fbd(column, false, "contextMenu");
            const isKeyboardEvent = e instanceof KeyboardEvent;
            if (this.tabListener) this.tabListener = this.tabListener();
            if (isKeyboardEvent && eventSource && $437b23f6a393c3bf$export$2badf4aa566524cb(eventSource)) {
                const focusableEl = $437b23f6a393c3bf$export$c4c49c776025d475(eventSource);
                focusableEl?.focus({
                    preventScroll: true
                });
            }
            afterGuiDetached();
            this.destroyBean(this.activeMenu);
            this.dispatchVisibleChangedEvent(false, containerType, column);
            onClosedCallback?.();
        };
        const translate = this.getLocaleTextFunc();
        const ariaLabel = isLegacyMenuEnabled && containerType !== "columnFilter" ? translate("ariaLabelColumnMenu", "Column Menu") : translate("ariaLabelColumnFilter", "Column Filter");
        const addPopupRes = this.popupSvc?.addPopup({
            modal: true,
            eChild: eMenu,
            closeOnEsc: true,
            closedCallback: closedCallback,
            positionCallback: ()=>positionCallback(eMenu),
            anchorToElement: anchorToElement,
            ariaLabel: ariaLabel
        });
        if (addPopupRes) this.hidePopup = hidePopup = addPopupRes.hideFunc;
        comp.afterInit().then(()=>{
            positionCallback(eMenu);
            comp.afterGuiAttached({
                container: containerType,
                hidePopup: hidePopup
            });
        });
        $437b23f6a393c3bf$export$2f1bf9feac2f7fbd(column, true, "contextMenu");
        this.dispatchVisibleChangedEvent(true, containerType, column);
    }
    trapFocusWithin(e, menu) {
        if (e.key !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB || e.defaultPrevented || $437b23f6a393c3bf$export$83fc12531358bd28(this.beans, menu, false, e.shiftKey)) return;
        e.preventDefault();
        $437b23f6a393c3bf$export$8598088d375f416f(menu, e.shiftKey);
    }
    dispatchVisibleChangedEvent(visible, containerType, column) {
        this.eventSvc.dispatchEvent({
            type: "columnMenuVisibleChanged",
            visible: visible,
            switchingTab: false,
            key: containerType,
            column: column ?? null,
            columnGroup: null
        });
    }
    isMenuEnabled(column) {
        return column.isFilterAllowed() && (column.getColDef().menuTabs ?? [
            "filterMenuTab"
        ]).includes("filterMenuTab");
    }
    showMenuAfterContextMenuEvent() {}
    destroy() {
        this.destroyBean(this.activeMenu);
        super.destroy();
    }
};
// packages/ag-grid-community/src/filter/filterValueService.ts
var $437b23f6a393c3bf$var$FilterValueService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "filterValueSvc";
    }
    getValue(column, rowNode, filterValueGetterOverride) {
        if (!rowNode) return;
        const colDef = column.getColDef();
        const { selectableFilter: selectableFilter, valueSvc: valueSvc } = this.beans;
        const filterValueGetter = filterValueGetterOverride ?? selectableFilter?.getFilterValueGetter(column.getColId()) ?? colDef.filterValueGetter;
        if (filterValueGetter) return this.executeFilterValueGetter(filterValueGetter, rowNode.data, column, rowNode, colDef);
        return valueSvc.getValue(column, rowNode);
    }
    executeFilterValueGetter(valueGetter, data, column, node, colDef) {
        const { expressionSvc: expressionSvc, valueSvc: valueSvc } = this.beans;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            data: data,
            node: node,
            column: column,
            colDef: colDef,
            getValue: valueSvc.getValueCallback.bind(valueSvc, node)
        });
        if (typeof valueGetter === "function") return valueGetter(params);
        return expressionSvc?.evaluate(valueGetter, params);
    }
};
// packages/ag-grid-community/src/filter/floating/provided/readOnlyFloatingFilter.ts
var $437b23f6a393c3bf$var$ReadOnlyFloatingFilterElement = {
    tag: "div",
    cls: "ag-floating-filter-input",
    role: "presentation",
    children: [
        {
            tag: "ag-input-text-field",
            ref: "eFloatingFilterText"
        }
    ]
};
var $437b23f6a393c3bf$var$ReadOnlyFloatingFilter = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$ReadOnlyFloatingFilterElement, [
            $437b23f6a393c3bf$export$31e2985be4ee06ab
        ]);
        this.eFloatingFilterText = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    init(params) {
        this.params = params;
        const displayName = this.beans.colNames.getDisplayNameForColumn(params.column, "header", true);
        this.eFloatingFilterText.setDisabled(true).setInputAriaLabel(`${displayName} ${this.getLocaleTextFunc()("ariaFilterInput", "Filter Input")}`);
        if (this.gos.get("enableFilterHandlers")) {
            const reactiveParams = params;
            const handler = reactiveParams.getHandler();
            if (handler.getModelAsString) {
                const modelAsString = handler.getModelAsString(reactiveParams.model);
                this.eFloatingFilterText.setValue(modelAsString);
            }
        }
    }
    onParentModelChanged(parentModel) {
        if (parentModel == null) {
            this.eFloatingFilterText.setValue("");
            return;
        }
        this.params.parentFilterInstance((filterInstance)=>{
            if (filterInstance.getModelAsString) {
                const modelAsString = filterInstance.getModelAsString(parentModel);
                this.eFloatingFilterText.setValue(modelAsString);
            }
        });
    }
    refresh(params) {
        this.init(params);
    }
};
// packages/ag-grid-community/src/filter/provided/optionsFactory.ts
var $437b23f6a393c3bf$var$OptionsFactory = class {
    constructor(){
        this.customFilterOptions = {};
    }
    init(params, defaultOptions) {
        this.filterOptions = params.filterOptions ?? defaultOptions;
        this.mapCustomOptions();
        this.defaultOption = this.getDefaultItem(params.defaultOption);
    }
    refresh(params, defaultOptions) {
        const filterOptions = params.filterOptions ?? defaultOptions;
        if (this.filterOptions !== filterOptions) {
            this.filterOptions = filterOptions;
            this.customFilterOptions = {};
            this.mapCustomOptions();
        }
        this.defaultOption = this.getDefaultItem(params.defaultOption);
    }
    mapCustomOptions() {
        const { filterOptions: filterOptions } = this;
        if (!filterOptions) return;
        filterOptions.forEach((filterOption)=>{
            if (typeof filterOption === "string") return;
            const requiredProperties = [
                [
                    "displayKey"
                ],
                [
                    "displayName"
                ],
                [
                    "predicate",
                    "test"
                ]
            ];
            const propertyCheck = (keys)=>{
                if (!keys.some((key)=>filterOption[key] != null)) {
                    $437b23f6a393c3bf$export$545083624300f13d(72, {
                        keys: keys
                    });
                    return false;
                }
                return true;
            };
            if (!requiredProperties.every(propertyCheck)) {
                this.filterOptions = filterOptions.filter((v)=>v === filterOption) || [];
                return;
            }
            this.customFilterOptions[filterOption.displayKey] = filterOption;
        });
    }
    getDefaultItem(defaultOption) {
        const { filterOptions: filterOptions } = this;
        if (defaultOption) return defaultOption;
        else if (filterOptions.length >= 1) {
            const firstFilterOption = filterOptions[0];
            if (typeof firstFilterOption === "string") return firstFilterOption;
            else if (firstFilterOption.displayKey) return firstFilterOption.displayKey;
            else $437b23f6a393c3bf$export$545083624300f13d(73);
        } else $437b23f6a393c3bf$export$545083624300f13d(74);
        return void 0;
    }
    getCustomOption(name) {
        return this.customFilterOptions[name];
    }
};
// packages/ag-grid-community/src/filter/provided/simpleFilterUtils.ts
function $437b23f6a393c3bf$var$removeItems(items, startPosition, deleteCount) {
    return deleteCount == null ? items.splice(startPosition) : items.splice(startPosition, deleteCount);
}
function $437b23f6a393c3bf$var$isBlank(cellValue) {
    return cellValue == null || typeof cellValue === "string" && cellValue.trim().length === 0;
}
function $437b23f6a393c3bf$var$getDefaultJoinOperator(defaultJoinOperator) {
    return defaultJoinOperator === "AND" || defaultJoinOperator === "OR" ? defaultJoinOperator : "AND";
}
function $437b23f6a393c3bf$var$evaluateCustomFilter(customFilterOption, values, cellValue) {
    if (customFilterOption == null) return;
    const { predicate: predicate } = customFilterOption;
    if (predicate != null && !values.some((v)=>v == null)) return predicate(values, cellValue);
    return;
}
function $437b23f6a393c3bf$var$validateAndUpdateConditions(conditions, maxNumConditions) {
    let numConditions = conditions.length;
    if (numConditions > maxNumConditions) {
        conditions.splice(maxNumConditions);
        $437b23f6a393c3bf$export$545083624300f13d(78);
        numConditions = maxNumConditions;
    }
    return numConditions;
}
function $437b23f6a393c3bf$var$getNumberOfInputs(type, optionsFactory) {
    const customOpts = optionsFactory.getCustomOption(type);
    if (customOpts) {
        const { numberOfInputs: numberOfInputs } = customOpts;
        return numberOfInputs != null ? numberOfInputs : 1;
    }
    const zeroInputTypes = [
        "empty",
        "notBlank",
        "blank"
    ];
    if (type && zeroInputTypes.indexOf(type) >= 0) return 0;
    else if (type === "inRange") return 2;
    return 1;
}
// packages/ag-grid-community/src/filter/provided/simpleFilter.ts
var $437b23f6a393c3bf$var$SimpleFilter = class extends $437b23f6a393c3bf$export$a927a1327c2cc7f0 {
    constructor(filterNameKey, mapValuesFromModel, defaultOptions){
        super(filterNameKey, "simple-filter");
        this.mapValuesFromModel = mapValuesFromModel;
        this.defaultOptions = defaultOptions;
        this.eTypes = [];
        this.eJoinPanels = [];
        this.eJoinAnds = [];
        this.eJoinOrs = [];
        this.eConditionBodies = [];
        this.listener = ()=>this.onUiChanged();
        this.lastUiCompletePosition = null;
        this.joinOperatorId = 0;
    }
    setParams(params) {
        super.setParams(params);
        const optionsFactory = new $437b23f6a393c3bf$var$OptionsFactory();
        this.optionsFactory = optionsFactory;
        optionsFactory.init(params, this.defaultOptions);
        this.commonUpdateSimpleParams(params);
        this.createOption();
        this.createMissingConditionsAndOperators();
    }
    updateParams(newParams, oldParams) {
        this.optionsFactory.refresh(newParams, this.defaultOptions);
        super.updateParams(newParams, oldParams);
        this.commonUpdateSimpleParams(newParams);
    }
    commonUpdateSimpleParams(params) {
        this.setNumConditions(params);
        this.defaultJoinOperator = $437b23f6a393c3bf$var$getDefaultJoinOperator(params.defaultJoinOperator);
        this.filterPlaceholder = params.filterPlaceholder;
        this.createFilterListOptions();
        const eGui = this.getGui();
        if (this.isReadOnly()) eGui.setAttribute("tabindex", "-1");
        else eGui.removeAttribute("tabindex");
    }
    // floating filter calls this when user applies filter from floating filter
    onFloatingFilterChanged(type, value) {
        this.setTypeFromFloatingFilter(type);
        this.setValueFromFloatingFilter(value);
        this.onUiChanged("immediately", true);
    }
    setTypeFromFloatingFilter(type) {
        this.eTypes.forEach((eType, position)=>{
            const value = position === 0 ? type : this.optionsFactory.defaultOption;
            eType.setValue(value, true);
        });
    }
    getModelFromUi() {
        const conditions = this.getUiCompleteConditions();
        if (conditions.length === 0) return null;
        if (this.maxNumConditions > 1 && conditions.length > 1) return {
            filterType: this.filterType,
            operator: this.getJoinOperator(),
            conditions: conditions
        };
        return conditions[0];
    }
    getConditionTypes() {
        return this.eTypes.map((eType)=>eType.getValue());
    }
    getConditionType(position) {
        return this.eTypes[position].getValue();
    }
    getJoinOperator() {
        const { eJoinOrs: eJoinOperatorsOr, defaultJoinOperator: defaultJoinOperator } = this;
        return eJoinOperatorsOr.length === 0 ? defaultJoinOperator : eJoinOperatorsOr[0].getValue() === true ? "OR" : "AND";
    }
    areNonNullModelsEqual(a, b) {
        const aIsSimple = !a.operator;
        const bIsSimple = !b.operator;
        const oneSimpleOneCombined = !aIsSimple && bIsSimple || aIsSimple && !bIsSimple;
        if (oneSimpleOneCombined) return false;
        let res;
        if (aIsSimple) {
            const aSimple = a;
            const bSimple = b;
            res = this.areSimpleModelsEqual(aSimple, bSimple);
        } else {
            const aCombined = a;
            const bCombined = b;
            res = aCombined.operator === bCombined.operator && $437b23f6a393c3bf$export$893967cdb9833fdd(aCombined.conditions, bCombined.conditions, (aModel, bModel)=>this.areSimpleModelsEqual(aModel, bModel));
        }
        return res;
    }
    setModelIntoUi(model, isInitialLoad) {
        if (model == null) {
            this.resetUiToDefaults(isInitialLoad);
            return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
        }
        const isCombined = model.operator;
        if (isCombined) {
            const combinedModel = model;
            let conditions = combinedModel.conditions;
            if (conditions == null) {
                conditions = [];
                $437b23f6a393c3bf$export$545083624300f13d(77);
            }
            const numConditions = $437b23f6a393c3bf$var$validateAndUpdateConditions(conditions, this.maxNumConditions);
            const numPrevConditions = this.getNumConditions();
            if (numConditions < numPrevConditions) this.removeConditionsAndOperators(numConditions);
            else if (numConditions > numPrevConditions) for(let i = numPrevConditions; i < numConditions; i++){
                this.createJoinOperatorPanel();
                this.createOption();
            }
            const orChecked = combinedModel.operator === "OR";
            this.eJoinAnds.forEach((eJoinOperatorAnd)=>eJoinOperatorAnd.setValue(!orChecked, true));
            this.eJoinOrs.forEach((eJoinOperatorOr)=>eJoinOperatorOr.setValue(orChecked, true));
            conditions.forEach((condition, position)=>{
                this.eTypes[position].setValue(condition.type, true);
                this.setConditionIntoUi(condition, position);
            });
        } else {
            const simpleModel = model;
            if (this.getNumConditions() > 1) this.removeConditionsAndOperators(1);
            this.eTypes[0].setValue(simpleModel.type, true);
            this.setConditionIntoUi(simpleModel, 0);
        }
        this.lastUiCompletePosition = this.getNumConditions() - 1;
        this.createMissingConditionsAndOperators();
        this.updateUiVisibility();
        if (!isInitialLoad) this.params.onUiChange(this.getUiChangeEventParams());
        return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
    }
    setNumConditions(params) {
        let maxNumConditions = params.maxNumConditions ?? 2;
        if (maxNumConditions < 1) {
            $437b23f6a393c3bf$export$545083624300f13d(79);
            maxNumConditions = 1;
        }
        this.maxNumConditions = maxNumConditions;
        let numAlwaysVisibleConditions = params.numAlwaysVisibleConditions ?? 1;
        if (numAlwaysVisibleConditions < 1) {
            $437b23f6a393c3bf$export$545083624300f13d(80);
            numAlwaysVisibleConditions = 1;
        }
        if (numAlwaysVisibleConditions > maxNumConditions) {
            $437b23f6a393c3bf$export$545083624300f13d(81);
            numAlwaysVisibleConditions = maxNumConditions;
        }
        this.numAlwaysVisibleConditions = numAlwaysVisibleConditions;
    }
    createOption() {
        const eGui = this.getGui();
        const eType = this.createManagedBean(new $437b23f6a393c3bf$export$6f9c460854d56032());
        this.eTypes.push(eType);
        eType.addCss("ag-filter-select");
        eGui.appendChild(eType.getGui());
        const eConditionBody = this.createEValue();
        this.eConditionBodies.push(eConditionBody);
        eGui.appendChild(eConditionBody);
        this.putOptionsIntoDropdown(eType);
        this.resetType(eType);
        const position = this.getNumConditions() - 1;
        this.forEachPositionInput(position, (element)=>this.resetInput(element));
        this.addChangedListeners(eType, position);
    }
    createJoinOperatorPanel() {
        const eJoinOperatorPanel = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-filter-condition"
        });
        this.eJoinPanels.push(eJoinOperatorPanel);
        const eJoinOperatorAnd = this.createJoinOperator(this.eJoinAnds, eJoinOperatorPanel, "and");
        const eJoinOperatorOr = this.createJoinOperator(this.eJoinOrs, eJoinOperatorPanel, "or");
        this.getGui().appendChild(eJoinOperatorPanel);
        const index = this.eJoinPanels.length - 1;
        const uniqueGroupId = this.joinOperatorId++;
        this.resetJoinOperatorAnd(eJoinOperatorAnd, index, uniqueGroupId);
        this.resetJoinOperatorOr(eJoinOperatorOr, index, uniqueGroupId);
        if (!this.isReadOnly()) {
            eJoinOperatorAnd.onValueChange(this.listener);
            eJoinOperatorOr.onValueChange(this.listener);
        }
    }
    createJoinOperator(eJoinOperators, eJoinOperatorPanel, andOr) {
        const eJoinOperator = this.createManagedBean(new $437b23f6a393c3bf$export$5caa9ea96bbb722());
        eJoinOperators.push(eJoinOperator);
        const baseClass = "ag-filter-condition-operator";
        eJoinOperator.addCss(baseClass);
        eJoinOperator.addCss(`${baseClass}-${andOr}`);
        eJoinOperatorPanel.appendChild(eJoinOperator.getGui());
        return eJoinOperator;
    }
    createFilterListOptions() {
        this.filterListOptions = this.optionsFactory.filterOptions.map((option)=>typeof option === "string" ? this.createBoilerplateListOption(option) : this.createCustomListOption(option));
    }
    putOptionsIntoDropdown(eType) {
        const { filterListOptions: filterListOptions } = this;
        filterListOptions.forEach((listOption)=>{
            eType.addOption(listOption);
        });
        eType.setDisabled(filterListOptions.length <= 1);
    }
    createBoilerplateListOption(option) {
        return {
            value: option,
            text: this.translate(option)
        };
    }
    createCustomListOption(option) {
        const { displayKey: displayKey } = option;
        const customOption = this.optionsFactory.getCustomOption(option.displayKey);
        return {
            value: displayKey,
            text: customOption ? this.getLocaleTextFunc()(customOption.displayKey, customOption.displayName) : this.translate(displayKey)
        };
    }
    createBodyTemplate() {
        return null;
    }
    getAgComponents() {
        return [];
    }
    updateUiVisibility() {
        const joinOperator = this.getJoinOperator();
        this.updateNumConditions();
        this.updateConditionStatusesAndValues(this.lastUiCompletePosition, joinOperator);
    }
    updateNumConditions() {
        let lastUiCompletePosition = -1;
        let areAllConditionsUiComplete = true;
        for(let position = 0; position < this.getNumConditions(); position++)if (this.isConditionUiComplete(position)) lastUiCompletePosition = position;
        else areAllConditionsUiComplete = false;
        if (this.shouldAddNewConditionAtEnd(areAllConditionsUiComplete)) {
            this.createJoinOperatorPanel();
            this.createOption();
        } else {
            const activePosition = this.lastUiCompletePosition ?? this.getNumConditions() - 2;
            if (lastUiCompletePosition < activePosition) {
                this.removeConditionsAndOperators(activePosition + 1);
                const removeStartPosition = lastUiCompletePosition + 1;
                const numConditionsToRemove = activePosition - removeStartPosition;
                if (numConditionsToRemove > 0) this.removeConditionsAndOperators(removeStartPosition, numConditionsToRemove);
                this.createMissingConditionsAndOperators();
            }
        }
        this.lastUiCompletePosition = lastUiCompletePosition;
    }
    updateConditionStatusesAndValues(lastUiCompletePosition, joinOperator) {
        this.eTypes.forEach((eType, position)=>{
            const disabled = this.isConditionDisabled(position, lastUiCompletePosition);
            eType.setDisabled(disabled || this.filterListOptions.length <= 1);
            if (position === 1) {
                $437b23f6a393c3bf$export$b6b4f08392e9bfaf(this.eJoinPanels[0], disabled);
                this.eJoinAnds[0].setDisabled(disabled);
                this.eJoinOrs[0].setDisabled(disabled);
            }
        });
        this.eConditionBodies.forEach((element, index)=>{
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(element, this.isConditionBodyVisible(index));
        });
        const orChecked = (joinOperator ?? this.getJoinOperator()) === "OR";
        this.eJoinAnds.forEach((eJoinOperatorAnd)=>{
            eJoinOperatorAnd.setValue(!orChecked, true);
        });
        this.eJoinOrs.forEach((eJoinOperatorOr)=>{
            eJoinOperatorOr.setValue(orChecked, true);
        });
        this.forEachInput((element, index, position, numberOfInputs)=>{
            this.setElementDisplayed(element, index < numberOfInputs);
            this.setElementDisabled(element, this.isConditionDisabled(position, lastUiCompletePosition));
        });
        this.resetPlaceholder();
    }
    shouldAddNewConditionAtEnd(areAllConditionsUiComplete) {
        return areAllConditionsUiComplete && this.getNumConditions() < this.maxNumConditions && !this.isReadOnly();
    }
    removeConditionsAndOperators(startPosition, deleteCount) {
        if (startPosition >= this.getNumConditions()) return;
        const { eTypes: eTypes, eConditionBodies: eConditionBodies, eJoinPanels: eJoinOperatorPanels, eJoinAnds: eJoinOperatorsAnd, eJoinOrs: eJoinOperatorsOr } = this;
        this.removeComponents(eTypes, startPosition, deleteCount);
        this.removeElements(eConditionBodies, startPosition, deleteCount);
        this.removeEValues(startPosition, deleteCount);
        const joinOperatorIndex = Math.max(startPosition - 1, 0);
        this.removeElements(eJoinOperatorPanels, joinOperatorIndex, deleteCount);
        this.removeComponents(eJoinOperatorsAnd, joinOperatorIndex, deleteCount);
        this.removeComponents(eJoinOperatorsOr, joinOperatorIndex, deleteCount);
    }
    removeElements(elements, startPosition, deleteCount) {
        const removedElements = $437b23f6a393c3bf$var$removeItems(elements, startPosition, deleteCount);
        removedElements.forEach((element)=>$437b23f6a393c3bf$export$dd4d52e41fb4cef5(element));
    }
    removeComponents(components, startPosition, deleteCount) {
        const removedComponents = $437b23f6a393c3bf$var$removeItems(components, startPosition, deleteCount);
        removedComponents.forEach((comp)=>{
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(comp.getGui());
            this.destroyBean(comp);
        });
    }
    afterGuiAttached(params) {
        super.afterGuiAttached(params);
        this.resetPlaceholder();
        if (!params?.suppressFocus) {
            let elementToFocus;
            if (!this.isReadOnly()) {
                const firstInput = this.getInputs(0)[0];
                if (firstInput instanceof $437b23f6a393c3bf$export$9671f513d4aa42e3 && this.isConditionBodyVisible(0)) elementToFocus = firstInput.getInputElement();
                else elementToFocus = this.eTypes[0]?.getFocusableElement();
            }
            (elementToFocus ?? this.getGui()).focus({
                preventScroll: true
            });
        }
    }
    afterGuiDetached() {
        super.afterGuiDetached();
        const params = this.params;
        if (this.beans.colFilter?.shouldKeepStateOnDetach(params.column)) return;
        params.onStateChange({
            model: params.model
        });
        let lastUiCompletePosition = -1;
        let updatedLastUiCompletePosition = -1;
        let conditionsRemoved = false;
        const joinOperator = this.getJoinOperator();
        for(let position = this.getNumConditions() - 1; position >= 0; position--){
            if (this.isConditionUiComplete(position)) {
                if (lastUiCompletePosition === -1) {
                    lastUiCompletePosition = position;
                    updatedLastUiCompletePosition = position;
                }
            } else {
                const shouldRemovePositionAtEnd = position >= this.numAlwaysVisibleConditions && !this.isConditionUiComplete(position - 1);
                const positionBeforeLastUiCompletePosition = position < lastUiCompletePosition;
                if (shouldRemovePositionAtEnd || positionBeforeLastUiCompletePosition) {
                    this.removeConditionsAndOperators(position, 1);
                    conditionsRemoved = true;
                    if (positionBeforeLastUiCompletePosition) updatedLastUiCompletePosition--;
                }
            }
        }
        let shouldUpdateConditionStatusesAndValues = false;
        if (this.getNumConditions() < this.numAlwaysVisibleConditions) {
            this.createMissingConditionsAndOperators();
            shouldUpdateConditionStatusesAndValues = true;
        }
        if (this.shouldAddNewConditionAtEnd(updatedLastUiCompletePosition === this.getNumConditions() - 1)) {
            this.createJoinOperatorPanel();
            this.createOption();
            shouldUpdateConditionStatusesAndValues = true;
        }
        if (shouldUpdateConditionStatusesAndValues) this.updateConditionStatusesAndValues(updatedLastUiCompletePosition, joinOperator);
        if (conditionsRemoved) this.updateJoinOperatorsDisabled();
        this.lastUiCompletePosition = updatedLastUiCompletePosition;
    }
    getModelAsString(model) {
        return this.params.getHandler()?.getModelAsString?.(model) ?? "";
    }
    getPlaceholderText(defaultPlaceholder, position) {
        let placeholder = this.translate(defaultPlaceholder);
        if (typeof this.filterPlaceholder === "function") {
            const filterOptionKey = this.eTypes[position].getValue();
            const filterOption = this.translate(filterOptionKey);
            placeholder = this.filterPlaceholder({
                filterOptionKey: filterOptionKey,
                filterOption: filterOption,
                placeholder: placeholder
            });
        } else if (typeof this.filterPlaceholder === "string") placeholder = this.filterPlaceholder;
        return placeholder;
    }
    // allow sub-classes to reset HTML placeholders after UI update.
    resetPlaceholder() {
        const globalTranslate = this.getLocaleTextFunc();
        this.forEachInput((element, index, position, numberOfInputs)=>{
            if (!(element instanceof $437b23f6a393c3bf$export$9671f513d4aa42e3)) return;
            const placeholder = index === 0 && numberOfInputs > 1 ? "inRangeStart" : index === 0 ? "filterOoo" : "inRangeEnd";
            const ariaLabel = index === 0 && numberOfInputs > 1 ? globalTranslate("ariaFilterFromValue", "Filter from value") : index === 0 ? globalTranslate("ariaFilterValue", "Filter Value") : globalTranslate("ariaFilterToValue", "Filter to Value");
            element.setInputPlaceholder(this.getPlaceholderText(placeholder, position));
            element.setInputAriaLabel(ariaLabel);
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setElementValue(element, value, fromFloatingFilter) {
        if (element instanceof $437b23f6a393c3bf$export$9671f513d4aa42e3) element.setValue(value != null ? String(value) : null, true);
    }
    setElementDisplayed(element, displayed) {
        if (element instanceof $437b23f6a393c3bf$export$16fa2f45be04daa8) $437b23f6a393c3bf$export$9405f1cbb4e2383f(element.getGui(), displayed);
    }
    setElementDisabled(element, disabled) {
        if (element instanceof $437b23f6a393c3bf$export$16fa2f45be04daa8) $437b23f6a393c3bf$export$b6b4f08392e9bfaf(element.getGui(), disabled);
    }
    attachElementOnChange(element, listener) {
        if (element instanceof $437b23f6a393c3bf$export$9671f513d4aa42e3) element.onValueChange(listener);
    }
    forEachInput(cb) {
        this.getConditionTypes().forEach((type, position)=>{
            this.forEachPositionTypeInput(position, type, cb);
        });
    }
    forEachPositionInput(position, cb) {
        const type = this.getConditionType(position);
        this.forEachPositionTypeInput(position, type, cb);
    }
    forEachPositionTypeInput(position, type, cb) {
        const numberOfInputs = $437b23f6a393c3bf$var$getNumberOfInputs(type, this.optionsFactory);
        const inputs = this.getInputs(position);
        for(let index = 0; index < inputs.length; index++){
            const input = inputs[index];
            if (input != null) cb(input, index, position, numberOfInputs);
        }
    }
    isConditionDisabled(position, lastUiCompletePosition) {
        if (this.isReadOnly()) return true;
        if (position === 0) return false;
        return position > lastUiCompletePosition + 1;
    }
    isConditionBodyVisible(position) {
        const type = this.getConditionType(position);
        const numberOfInputs = $437b23f6a393c3bf$var$getNumberOfInputs(type, this.optionsFactory);
        return numberOfInputs > 0;
    }
    // returns true if the UI represents a working filter, eg all parts are filled out.
    // eg if text filter and textfield blank then returns false.
    isConditionUiComplete(position) {
        if (position >= this.getNumConditions()) return false;
        const type = this.getConditionType(position);
        if (type === "empty") return false;
        if (this.getValues(position).some((v)=>v == null)) return false;
        return true;
    }
    getNumConditions() {
        return this.eTypes.length;
    }
    getUiCompleteConditions() {
        const conditions = [];
        for(let position = 0; position < this.getNumConditions(); position++)if (this.isConditionUiComplete(position)) conditions.push(this.createCondition(position));
        return conditions;
    }
    createMissingConditionsAndOperators() {
        if (this.isReadOnly()) return;
        for(let i = this.getNumConditions(); i < this.numAlwaysVisibleConditions; i++){
            this.createJoinOperatorPanel();
            this.createOption();
        }
    }
    resetUiToDefaults(silent) {
        this.removeConditionsAndOperators(this.isReadOnly() ? 1 : this.numAlwaysVisibleConditions);
        this.eTypes.forEach((eType)=>this.resetType(eType));
        this.eJoinAnds.forEach((eJoinOperatorAnd, index)=>this.resetJoinOperatorAnd(eJoinOperatorAnd, index, this.joinOperatorId + index));
        this.eJoinOrs.forEach((eJoinOperatorOr, index)=>this.resetJoinOperatorOr(eJoinOperatorOr, index, this.joinOperatorId + index));
        this.joinOperatorId++;
        this.forEachInput((element)=>this.resetInput(element));
        this.resetPlaceholder();
        this.createMissingConditionsAndOperators();
        this.lastUiCompletePosition = null;
        this.updateUiVisibility();
        if (!silent) this.params.onUiChange(this.getUiChangeEventParams());
    }
    resetType(eType) {
        const translate = this.getLocaleTextFunc();
        const filteringLabel = translate("ariaFilteringOperator", "Filtering operator");
        eType.setValue(this.optionsFactory.defaultOption, true).setAriaLabel(filteringLabel).setDisabled(this.isReadOnly() || this.filterListOptions.length <= 1);
    }
    resetJoinOperatorAnd(eJoinOperatorAnd, index, uniqueGroupId) {
        this.resetJoinOperator(eJoinOperatorAnd, index, this.defaultJoinOperator === "AND", this.translate("andCondition"), uniqueGroupId);
    }
    resetJoinOperatorOr(eJoinOperatorOr, index, uniqueGroupId) {
        this.resetJoinOperator(eJoinOperatorOr, index, this.defaultJoinOperator === "OR", this.translate("orCondition"), uniqueGroupId);
    }
    resetJoinOperator(eJoinOperator, index, value, label, uniqueGroupId) {
        this.updateJoinOperatorDisabled(eJoinOperator.setValue(value, true).setName(`ag-simple-filter-and-or-${this.getCompId()}-${uniqueGroupId}`).setLabel(label), index);
    }
    updateJoinOperatorsDisabled() {
        const updater = (eJoinOperator, index)=>this.updateJoinOperatorDisabled(eJoinOperator, index);
        this.eJoinAnds.forEach(updater);
        this.eJoinOrs.forEach(updater);
    }
    updateJoinOperatorDisabled(eJoinOperator, index) {
        eJoinOperator.setDisabled(this.isReadOnly() || index > 0);
    }
    resetInput(element) {
        this.setElementValue(element, null);
        this.setElementDisabled(element, this.isReadOnly());
    }
    // puts model values into the UI
    setConditionIntoUi(model, position) {
        const values = this.mapValuesFromModel(model, this.optionsFactory);
        this.forEachInput((element, index, elPosition)=>{
            if (elPosition !== position) return;
            this.setElementValue(element, values[index] != null ? values[index] : null);
        });
    }
    // after floating filter changes, this sets the 'value' section. this is implemented by the base class
    // (as that's where value is controlled), the 'type' part from the floating filter is dealt with in this class.
    setValueFromFloatingFilter(value) {
        this.forEachInput((element, index, position)=>{
            this.setElementValue(element, index === 0 && position === 0 ? value : null, true);
        });
    }
    addChangedListeners(eType, position) {
        if (this.isReadOnly()) return;
        eType.onValueChange(this.listener);
        this.forEachPositionInput(position, (element)=>{
            this.attachElementOnChange(element, this.listener);
        });
    }
    hasInvalidInputs() {
        return false;
    }
    isReadOnly() {
        return !!this.params.readOnly;
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateCompWrapper.ts
var $437b23f6a393c3bf$var$DateCompWrapper = class {
    constructor(context, userCompFactory, colDef, dateComponentParams, eParent, onReady){
        this.alive = true;
        this.context = context;
        this.eParent = eParent;
        const compDetails = $437b23f6a393c3bf$var$_getDateCompDetails(userCompFactory, colDef, dateComponentParams);
        if (!compDetails) return;
        compDetails.newAgStackInstance().then((dateComp)=>{
            if (!this.alive) {
                context.destroyBean(dateComp);
                return;
            }
            this.dateComp = dateComp;
            if (!dateComp) return;
            eParent.appendChild(dateComp.getGui());
            dateComp?.afterGuiAttached?.();
            const { tempValue: tempValue, disabled: disabled } = this;
            if (tempValue) dateComp.setDate(tempValue);
            if (disabled != null) dateComp.setDisabled?.(disabled);
            onReady?.(this);
        });
    }
    destroy() {
        this.alive = false;
        this.dateComp = this.context.destroyBean(this.dateComp);
    }
    getDate() {
        return this.dateComp ? this.dateComp.getDate() : this.tempValue;
    }
    setDate(value) {
        const dateComp = this.dateComp;
        if (dateComp) dateComp.setDate(value);
        else this.tempValue = value;
    }
    setDisabled(disabled) {
        const dateComp = this.dateComp;
        if (dateComp) dateComp.setDisabled?.(disabled);
        else this.disabled = disabled;
    }
    setDisplayed(displayed) {
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eParent, displayed);
    }
    setInputPlaceholder(placeholder) {
        this.dateComp?.setInputPlaceholder?.(placeholder);
    }
    setInputAriaLabel(label) {
        this.dateComp?.setInputAriaLabel?.(label);
    }
    afterGuiAttached(params) {
        this.dateComp?.afterGuiAttached?.(params);
    }
    updateParams(params) {
        this.dateComp?.refresh?.(params);
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateFilterConstants.ts
var $437b23f6a393c3bf$var$DEFAULT_DATE_FILTER_OPTIONS = [
    "equals",
    "notEqual",
    "lessThan",
    "greaterThan",
    "inRange",
    "blank",
    "notBlank"
];
// packages/ag-grid-community/src/filter/provided/date/dateFilterUtils.ts
function $437b23f6a393c3bf$var$mapValuesFromDateFilterModel(filterModel, optionsFactory) {
    const { dateFrom: dateFrom, dateTo: dateTo, type: type } = filterModel || {};
    return [
        dateFrom && $437b23f6a393c3bf$export$26ded2d88c01b527(dateFrom) || null,
        dateTo && $437b23f6a393c3bf$export$26ded2d88c01b527(dateTo) || null
    ].slice(0, $437b23f6a393c3bf$var$getNumberOfInputs(type, optionsFactory));
}
// packages/ag-grid-community/src/filter/provided/date/dateFilter.ts
var $437b23f6a393c3bf$var$DEFAULT_MIN_YEAR = 1e3;
var $437b23f6a393c3bf$var$DEFAULT_MAX_YEAR = Infinity;
var $437b23f6a393c3bf$var$DateFilter = class extends $437b23f6a393c3bf$var$SimpleFilter {
    constructor(){
        super("dateFilter", $437b23f6a393c3bf$var$mapValuesFromDateFilterModel, $437b23f6a393c3bf$var$DEFAULT_DATE_FILTER_OPTIONS);
        this.eConditionPanelsFrom = [];
        this.eConditionPanelsTo = [];
        this.dateConditionFromComps = [];
        this.dateConditionToComps = [];
        this.minValidYear = $437b23f6a393c3bf$var$DEFAULT_MIN_YEAR;
        this.maxValidYear = $437b23f6a393c3bf$var$DEFAULT_MAX_YEAR;
        this.minValidDate = null;
        this.maxValidDate = null;
        this.filterType = "date";
    }
    afterGuiAttached(params) {
        super.afterGuiAttached(params);
        this.dateConditionFromComps[0].afterGuiAttached(params);
    }
    commonUpdateSimpleParams(params) {
        super.commonUpdateSimpleParams(params);
        const yearParser = (param, fallback)=>{
            const value = params[param];
            if (value != null) {
                if (!isNaN(value)) return value == null ? fallback : Number(value);
                else $437b23f6a393c3bf$export$545083624300f13d(82, {
                    param: param
                });
            }
            return fallback;
        };
        const minValidYear = yearParser("minValidYear", $437b23f6a393c3bf$var$DEFAULT_MIN_YEAR);
        const maxValidYear = yearParser("maxValidYear", $437b23f6a393c3bf$var$DEFAULT_MAX_YEAR);
        this.minValidYear = minValidYear;
        this.maxValidYear = maxValidYear;
        if (minValidYear > maxValidYear) $437b23f6a393c3bf$export$545083624300f13d(83);
        const { minValidDate: minValidDate, maxValidDate: maxValidDate } = params;
        const parsedMinValidDate = minValidDate instanceof Date ? minValidDate : $437b23f6a393c3bf$export$26ded2d88c01b527(minValidDate);
        this.minValidDate = parsedMinValidDate;
        const parsedMaxValidDate = maxValidDate instanceof Date ? maxValidDate : $437b23f6a393c3bf$export$26ded2d88c01b527(maxValidDate);
        this.maxValidDate = parsedMaxValidDate;
        if (parsedMinValidDate && parsedMaxValidDate && parsedMinValidDate > parsedMaxValidDate) $437b23f6a393c3bf$export$545083624300f13d(84);
    }
    createDateCompWrapper(element) {
        const { beans: { userCompFactory: userCompFactory, context: context, gos: gos }, params: params } = this;
        const dateCompWrapper = new $437b23f6a393c3bf$var$DateCompWrapper(context, userCompFactory, params.colDef, $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            onDateChanged: ()=>this.onUiChanged(),
            filterParams: params,
            location: "filter"
        }), element);
        this.addDestroyFunc(()=>dateCompWrapper.destroy());
        return dateCompWrapper;
    }
    setElementValue(element, value) {
        element.setDate(value);
    }
    setElementDisplayed(element, displayed) {
        element.setDisplayed(displayed);
    }
    setElementDisabled(element, disabled) {
        element.setDisabled(disabled);
    }
    createEValue() {
        const eCondition = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-filter-body"
        });
        this.createFromToElement(eCondition, this.eConditionPanelsFrom, this.dateConditionFromComps, "from");
        this.createFromToElement(eCondition, this.eConditionPanelsTo, this.dateConditionToComps, "to");
        return eCondition;
    }
    createFromToElement(eCondition, eConditionPanels, dateConditionComps, fromTo) {
        const eConditionPanel = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: `ag-filter-${fromTo} ag-filter-date-${fromTo}`
        });
        eConditionPanels.push(eConditionPanel);
        eCondition.appendChild(eConditionPanel);
        dateConditionComps.push(this.createDateCompWrapper(eConditionPanel));
    }
    removeEValues(startPosition, deleteCount) {
        this.removeDateComps(this.dateConditionFromComps, startPosition, deleteCount);
        this.removeDateComps(this.dateConditionToComps, startPosition, deleteCount);
        $437b23f6a393c3bf$var$removeItems(this.eConditionPanelsFrom, startPosition, deleteCount);
        $437b23f6a393c3bf$var$removeItems(this.eConditionPanelsTo, startPosition, deleteCount);
    }
    removeDateComps(components, startPosition, deleteCount) {
        const removedComponents = $437b23f6a393c3bf$var$removeItems(components, startPosition, deleteCount);
        removedComponents.forEach((comp)=>comp.destroy());
    }
    isValidDateValue(value) {
        if (value === null) return false;
        const { minValidDate: minValidDate, maxValidDate: maxValidDate, minValidYear: minValidYear, maxValidYear: maxValidYear } = this;
        if (minValidDate) {
            if (value < minValidDate) return false;
        } else {
            if (value.getUTCFullYear() < minValidYear) return false;
        }
        if (maxValidDate) {
            if (value > maxValidDate) return false;
        } else {
            if (value.getUTCFullYear() > maxValidYear) return false;
        }
        return true;
    }
    isConditionUiComplete(position) {
        if (!super.isConditionUiComplete(position)) return false;
        let valid = true;
        this.forEachInput((element, index, elPosition, numberOfInputs)=>{
            if (elPosition !== position || !valid || index >= numberOfInputs) return;
            valid = valid && this.isValidDateValue(element.getDate());
        });
        return valid;
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.dateFrom === bSimple.dateFrom && aSimple.dateTo === bSimple.dateTo && aSimple.type === bSimple.type;
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {};
        const values = this.getValues(position);
        if (values.length > 0) model.dateFrom = $437b23f6a393c3bf$export$3d7fedfb21962874(values[0]);
        if (values.length > 1) model.dateTo = $437b23f6a393c3bf$export$3d7fedfb21962874(values[1]);
        return {
            dateFrom: null,
            dateTo: null,
            filterType: this.filterType,
            type: type,
            ...model
        };
    }
    resetPlaceholder() {
        const globalTranslate = this.getLocaleTextFunc();
        const placeholder = this.translate("dateFormatOoo");
        const ariaLabel = globalTranslate("ariaFilterValue", "Filter Value");
        this.forEachInput((element)=>{
            element.setInputPlaceholder(placeholder);
            element.setInputAriaLabel(ariaLabel);
        });
    }
    getInputs(position) {
        const { dateConditionFromComps: dateConditionFromComps, dateConditionToComps: dateConditionToComps } = this;
        if (position >= dateConditionFromComps.length) return [
            null,
            null
        ];
        return [
            dateConditionFromComps[position],
            dateConditionToComps[position]
        ];
    }
    getValues(position) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            if (index < numberOfInputs) result.push(element.getDate());
        });
        return result;
    }
    translate(key) {
        if (key === "lessThan") return super.translate("before");
        if (key === "greaterThan") return super.translate("after");
        return super.translate(key);
    }
};
// packages/ag-grid-community/src/filter/provided/simpleFilterHandler.ts
var $437b23f6a393c3bf$var$SimpleFilterHandler = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(mapValuesFromModel, defaultOptions){
        super();
        this.mapValuesFromModel = mapValuesFromModel;
        this.defaultOptions = defaultOptions;
    }
    init(params) {
        const filterParams = params.filterParams;
        const optionsFactory = new $437b23f6a393c3bf$var$OptionsFactory();
        this.optionsFactory = optionsFactory;
        optionsFactory.init(filterParams, this.defaultOptions);
        this.filterModelFormatter = this.createManagedBean(new this.FilterModelFormatterClass(optionsFactory, filterParams));
        this.updateParams(params);
        this.validateModel(params);
    }
    refresh(params) {
        if (params.source === "colDef") {
            const filterParams = params.filterParams;
            const optionsFactory = this.optionsFactory;
            optionsFactory.refresh(filterParams, this.defaultOptions);
            this.filterModelFormatter.updateParams({
                optionsFactory: optionsFactory,
                filterParams: filterParams
            });
            this.updateParams(params);
        }
        this.validateModel(params);
    }
    updateParams(params) {
        this.params = params;
    }
    doesFilterPass(params) {
        const model = params.model;
        if (model == null) return true;
        const { operator: operator } = model;
        const models = [];
        if (operator) {
            const combinedModel = model;
            models.push(...combinedModel.conditions ?? []);
        } else models.push(model);
        const combineFunction = operator && operator === "OR" ? "some" : "every";
        const cellValue = this.params.getValue(params.node);
        return models[combineFunction]((m)=>this.individualConditionPasses(params, m, cellValue));
    }
    getModelAsString(model, source) {
        return this.filterModelFormatter.getModelAsString(model, source) ?? "";
    }
    validateModel(params) {
        const { model: model, filterParams: { filterOptions: filterOptions, maxNumConditions: maxNumConditions } } = params;
        if (model == null) return;
        const isCombined = $437b23f6a393c3bf$export$a3f343af66a0c1bd(model);
        let conditions = isCombined ? model.conditions : [
            model
        ];
        const newOptionsList = filterOptions?.map((option)=>typeof option === "string" ? option : option.displayKey) ?? this.defaultOptions;
        const allConditionsExistInNewOptionsList = !conditions || conditions.every((condition)=>newOptionsList.find((option)=>option === condition.type) !== void 0);
        if (!allConditionsExistInNewOptionsList) {
            this.params = {
                ...params,
                model: null
            };
            params.onModelChange(null);
            return;
        }
        let needsUpdate = false;
        const filterType = this.filterType;
        if (conditions && !conditions.every((condition)=>condition.filterType === filterType) || model.filterType !== filterType) {
            conditions = conditions.map((condition)=>({
                    ...condition,
                    filterType: filterType
                }));
            needsUpdate = true;
        }
        if (typeof maxNumConditions === "number" && conditions && conditions.length > maxNumConditions) {
            conditions = conditions.slice(0, maxNumConditions);
            needsUpdate = true;
        }
        if (needsUpdate) {
            const updatedModel = conditions.length > 1 ? {
                ...model,
                filterType: filterType,
                conditions: conditions
            } : {
                ...conditions[0],
                filterType: filterType
            };
            this.params = {
                ...params,
                model: updatedModel
            };
            params.onModelChange(updatedModel);
            return;
        }
    }
    /** returns true if the row passes the said condition */ individualConditionPasses(params, filterModel, cellValue) {
        const optionsFactory = this.optionsFactory;
        const values = this.mapValuesFromModel(filterModel, optionsFactory);
        const customFilterOption = optionsFactory.getCustomOption(filterModel.type);
        const customFilterResult = $437b23f6a393c3bf$var$evaluateCustomFilter(customFilterOption, values, cellValue);
        if (customFilterResult != null) return customFilterResult;
        if (cellValue == null) return this.evaluateNullValue(filterModel.type);
        return this.evaluateNonNullValue(values, cellValue, filterModel, params);
    }
};
// packages/ag-grid-community/src/filter/provided/scalarFilterHandler.ts
var $437b23f6a393c3bf$var$ScalarFilterHandler = class extends $437b23f6a393c3bf$var$SimpleFilterHandler {
    evaluateNullValue(filterType) {
        const { includeBlanksInEquals: includeBlanksInEquals, includeBlanksInNotEqual: includeBlanksInNotEqual, includeBlanksInGreaterThan: includeBlanksInGreaterThan, includeBlanksInLessThan: includeBlanksInLessThan, includeBlanksInRange: includeBlanksInRange } = this.params.filterParams;
        switch(filterType){
            case "equals":
                if (includeBlanksInEquals) return true;
                break;
            case "notEqual":
                if (includeBlanksInNotEqual) return true;
                break;
            case "greaterThan":
            case "greaterThanOrEqual":
                if (includeBlanksInGreaterThan) return true;
                break;
            case "lessThan":
            case "lessThanOrEqual":
                if (includeBlanksInLessThan) return true;
                break;
            case "inRange":
                if (includeBlanksInRange) return true;
                break;
            case "blank":
                return true;
            case "notBlank":
                return false;
        }
        return false;
    }
    evaluateNonNullValue(values, cellValue, filterModel) {
        const type = filterModel.type;
        if (!this.isValid(cellValue)) return type === "notEqual" || type === "notBlank";
        const comparator = this.comparator();
        const compareResult = values[0] != null ? comparator(values[0], cellValue) : 0;
        switch(type){
            case "equals":
                return compareResult === 0;
            case "notEqual":
                return compareResult !== 0;
            case "greaterThan":
                return compareResult > 0;
            case "greaterThanOrEqual":
                return compareResult >= 0;
            case "lessThan":
                return compareResult < 0;
            case "lessThanOrEqual":
                return compareResult <= 0;
            case "inRange":
                {
                    const compareToResult = comparator(values[1], cellValue);
                    return this.params.filterParams.inRangeInclusive ? compareResult >= 0 && compareToResult <= 0 : compareResult > 0 && compareToResult < 0;
                }
            case "blank":
                return $437b23f6a393c3bf$var$isBlank(cellValue);
            case "notBlank":
                return !$437b23f6a393c3bf$var$isBlank(cellValue);
            default:
                $437b23f6a393c3bf$export$545083624300f13d(76, {
                    filterModelType: type
                });
                return true;
        }
    }
};
// packages/ag-grid-community/src/filter/provided/simpleFilterModelFormatter.ts
var $437b23f6a393c3bf$var$SCALAR_FILTER_TYPE_KEYS = {
    equals: "Equals",
    notEqual: "NotEqual",
    greaterThan: "GreaterThan",
    greaterThanOrEqual: "GreaterThanOrEqual",
    lessThan: "LessThan",
    lessThanOrEqual: "LessThanOrEqual",
    inRange: "InRange"
};
var $437b23f6a393c3bf$var$TEXT_FILTER_TYPE_KEYS = {
    contains: "Contains",
    notContains: "NotContains",
    equals: "TextEquals",
    notEqual: "TextNotEqual",
    startsWith: "StartsWith",
    endsWith: "EndsWith",
    inRange: "InRange"
};
var $437b23f6a393c3bf$var$SimpleFilterModelFormatter = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(optionsFactory, filterParams, valueFormatter){
        super();
        this.optionsFactory = optionsFactory;
        this.filterParams = filterParams;
        this.valueFormatter = valueFormatter;
    }
    // used by:
    // 1) NumberFloatingFilter & TextFloatingFilter: Always, for both when editable and read only.
    // 2) DateFloatingFilter: Only when read only (as we show text rather than a date picker when read only)
    getModelAsString(model, source) {
        const translate = this.getLocaleTextFunc();
        const forToolPanel = source === "filterToolPanel";
        if (!model) return forToolPanel ? $437b23f6a393c3bf$export$e2a0ae4af921fff8(this, "filterSummaryInactive") : null;
        const isCombined = model.operator != null;
        if (isCombined) {
            const combinedModel = model;
            const conditions = combinedModel.conditions ?? [];
            const customOptions = conditions.map((condition)=>this.getModelAsString(condition, source));
            const joinOperatorTranslateKey = combinedModel.operator === "AND" ? "andCondition" : "orCondition";
            return customOptions.join(` ${$437b23f6a393c3bf$export$e2a0ae4af921fff8(this, joinOperatorTranslateKey)} `);
        } else if (model.type === "blank" || model.type === "notBlank") return forToolPanel ? $437b23f6a393c3bf$export$e2a0ae4af921fff8(this, model.type === "blank" ? "filterSummaryBlank" : "filterSummaryNotBlank") : translate(model.type, model.type);
        else {
            const condition = model;
            const customOption = this.optionsFactory.getCustomOption(condition.type);
            const { displayKey: displayKey, displayName: displayName, numberOfInputs: numberOfInputs } = customOption || {};
            if (displayKey && displayName && numberOfInputs === 0) return translate(displayKey, displayName);
            return this.conditionToString(condition, forToolPanel, condition.type === "inRange" || numberOfInputs === 2, displayKey, displayName);
        }
    }
    updateParams(params) {
        const { optionsFactory: optionsFactory, filterParams: filterParams } = params;
        this.optionsFactory = optionsFactory;
        this.filterParams = filterParams;
    }
    conditionForToolPanel(type, isRange, getFilter, getFilterTo, customDisplayKey, customDisplayName) {
        let typeValue;
        const typeKey = this.getTypeKey(type);
        if (typeKey) typeValue = $437b23f6a393c3bf$export$e2a0ae4af921fff8(this, typeKey);
        if (customDisplayKey && customDisplayName) typeValue = this.getLocaleTextFunc()(customDisplayKey, customDisplayName);
        if (typeValue != null) {
            if (isRange) return `${typeValue} ${$437b23f6a393c3bf$export$e2a0ae4af921fff8(this, "filterSummaryInRangeValues", [
                getFilter(),
                getFilterTo()
            ])}`;
            else return `${typeValue} ${getFilter()}`;
        }
        return null;
    }
    getTypeKey(type) {
        const suffix = this.filterTypeKeys[type];
        return suffix ? `filterSummary${suffix}` : null;
    }
    formatValue(value) {
        const valueFormatter = this.valueFormatter;
        return valueFormatter ? valueFormatter(value ?? null) ?? "" : String(value);
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateFilterModelFormatter.ts
var $437b23f6a393c3bf$var$DateFilterModelFormatter = class extends $437b23f6a393c3bf$var$SimpleFilterModelFormatter {
    constructor(optionsFactory, filterParams){
        super(optionsFactory, filterParams, (value)=>{
            const { dataTypeSvc: dataTypeSvc, valueSvc: valueSvc } = this.beans;
            const column = filterParams.column;
            const dateFormatFn = dataTypeSvc?.getDateFormatterFunction(column);
            const dateStringStringValue = dateFormatFn?.(value ?? void 0);
            return valueSvc.formatValue(column, null, dateStringStringValue);
        });
        this.filterTypeKeys = $437b23f6a393c3bf$var$SCALAR_FILTER_TYPE_KEYS;
    }
    conditionToString(condition, forToolPanel, isRange, customDisplayKey, customDisplayName) {
        const { type: type } = condition;
        const dateFrom = $437b23f6a393c3bf$export$26ded2d88c01b527(condition.dateFrom);
        const dateTo = $437b23f6a393c3bf$export$26ded2d88c01b527(condition.dateTo);
        const format = this.filterParams.inRangeFloatingFilterDateFormat;
        const formatDate = forToolPanel ? this.formatValue.bind(this) : (value)=>$437b23f6a393c3bf$var$_dateToFormattedString(value, format);
        const formattedFrom = ()=>dateFrom !== null ? formatDate(dateFrom) : "null";
        const formattedTo = ()=>dateTo !== null ? formatDate(dateTo) : "null";
        if (forToolPanel) {
            const valueForToolPanel = this.conditionForToolPanel(type, isRange, formattedFrom, formattedTo, customDisplayKey, customDisplayName);
            if (valueForToolPanel != null) return valueForToolPanel;
        }
        if (isRange) return `${formattedFrom()}-${formattedTo()}`;
        if (dateFrom != null) return formatDate(dateFrom);
        return `${type}`;
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateFilterHandler.ts
function $437b23f6a393c3bf$var$defaultDateComparator(filterDate, cellValue) {
    const cellAsDate = cellValue;
    if (cellAsDate < filterDate) return -1;
    if (cellAsDate > filterDate) return 1;
    return 0;
}
var $437b23f6a393c3bf$var$DateFilterHandler = class extends $437b23f6a393c3bf$var$ScalarFilterHandler {
    constructor(){
        super($437b23f6a393c3bf$var$mapValuesFromDateFilterModel, $437b23f6a393c3bf$var$DEFAULT_DATE_FILTER_OPTIONS);
        this.filterType = "date";
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$DateFilterModelFormatter;
    }
    comparator() {
        return this.params.filterParams.comparator ?? $437b23f6a393c3bf$var$defaultDateComparator;
    }
    isValid(value) {
        const isValidDate2 = this.params.filterParams.isValidDate;
        return !isValidDate2 || isValidDate2(value);
    }
};
// packages/ag-grid-community/src/filter/floating/provided/simpleFloatingFilter.ts
var $437b23f6a393c3bf$var$SimpleFloatingFilter = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(...arguments);
        this.defaultDebounceMs = 0;
    }
    setLastTypeFromModel(model) {
        if (!model) {
            this.lastType = this.optionsFactory.defaultOption;
            return;
        }
        const isCombined = model.operator;
        let condition;
        if (isCombined) {
            const combinedModel = model;
            condition = combinedModel.conditions[0];
        } else condition = model;
        this.lastType = condition.type;
    }
    canWeEditAfterModelFromParentFilter(model) {
        if (!model) return this.isTypeEditable(this.lastType);
        const isCombined = model.operator;
        if (isCombined) return false;
        const simpleModel = model;
        return this.isTypeEditable(simpleModel.type);
    }
    init(params) {
        this.params = params;
        const reactive = this.gos.get("enableFilterHandlers");
        this.reactive = reactive;
        this.setParams(params);
        if (reactive) {
            const reactiveParams = params;
            this.onModelUpdated(reactiveParams.model);
        }
    }
    setParams(params) {
        const optionsFactory = new $437b23f6a393c3bf$var$OptionsFactory();
        this.optionsFactory = optionsFactory;
        optionsFactory.init(params.filterParams, this.defaultOptions);
        this.filterModelFormatter = this.createManagedBean(new this.FilterModelFormatterClass(optionsFactory, params.filterParams));
        this.setSimpleParams(params, false);
    }
    setSimpleParams(params, update = true) {
        const defaultOption = this.optionsFactory.defaultOption;
        if (!update) this.lastType = defaultOption;
        this.readOnly = !!params.filterParams.readOnly;
        const editable = this.isTypeEditable(defaultOption);
        this.setEditable(editable);
    }
    refresh(params) {
        this.params = params;
        const reactiveParams = params;
        const reactive = this.reactive;
        if (!reactive || reactiveParams.source === "colDef") this.updateParams(params);
        if (reactive) {
            const { source: source, model: model } = reactiveParams;
            if (source === "dataChanged" || source === "ui") return;
            this.onModelUpdated(model);
        }
    }
    updateParams(params) {
        const optionsFactory = this.optionsFactory;
        optionsFactory.refresh(params.filterParams, this.defaultOptions);
        this.setSimpleParams(params);
        this.filterModelFormatter.updateParams({
            optionsFactory: optionsFactory,
            filterParams: params.filterParams
        });
    }
    onParentModelChanged(model, event) {
        if (event?.afterFloatingFilter || event?.afterDataChange) return;
        this.onModelUpdated(model);
    }
    hasSingleInput(filterType) {
        const numberOfInputs = this.optionsFactory.getCustomOption(filterType)?.numberOfInputs;
        return numberOfInputs == null || numberOfInputs == 1;
    }
    isTypeEditable(type) {
        const uneditableTypes = [
            "inRange",
            "empty",
            "blank",
            "notBlank"
        ];
        return !!type && !this.readOnly && this.hasSingleInput(type) && uneditableTypes.indexOf(type) < 0;
    }
    getAriaLabel(params) {
        const displayName = this.beans.colNames.getDisplayNameForColumn(params.column, "header", true);
        return `${displayName} ${this.getLocaleTextFunc()("ariaFilterInput", "Filter Input")}`;
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateFloatingFilter.ts
var $437b23f6a393c3bf$var$DateFloatingFilterElement = {
    tag: "div",
    cls: "ag-floating-filter-input",
    role: "presentation",
    children: [
        {
            tag: "ag-input-text-field",
            ref: "eReadOnlyText"
        },
        {
            tag: "div",
            ref: "eDateWrapper",
            cls: "ag-date-floating-filter-wrapper"
        }
    ]
};
var $437b23f6a393c3bf$var$DateFloatingFilter = class extends $437b23f6a393c3bf$var$SimpleFloatingFilter {
    constructor(){
        super($437b23f6a393c3bf$var$DateFloatingFilterElement, [
            $437b23f6a393c3bf$export$31e2985be4ee06ab
        ]);
        this.eReadOnlyText = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eDateWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$DateFilterModelFormatter;
        this.filterType = "date";
        this.defaultOptions = $437b23f6a393c3bf$var$DEFAULT_DATE_FILTER_OPTIONS;
    }
    setParams(params) {
        super.setParams(params);
        this.createDateComponent();
        const translate = this.getLocaleTextFunc();
        this.eReadOnlyText.setDisabled(true).setInputAriaLabel(translate("ariaDateFilterInput", "Date Filter Input"));
    }
    updateParams(params) {
        super.updateParams(params);
        this.dateComp.updateParams(this.getDateComponentParams());
        this.updateCompOnModelChange(params.currentParentModel());
    }
    updateCompOnModelChange(model) {
        const allowEditing = !this.readOnly && this.canWeEditAfterModelFromParentFilter(model);
        this.setEditable(allowEditing);
        if (allowEditing) {
            const dateModel = model ? $437b23f6a393c3bf$export$26ded2d88c01b527(model.dateFrom) : null;
            this.dateComp.setDate(dateModel);
            this.eReadOnlyText.setValue("");
        } else {
            this.eReadOnlyText.setValue(this.filterModelFormatter.getModelAsString(model));
            this.dateComp.setDate(null);
        }
    }
    setEditable(editable) {
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eDateWrapper, editable);
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eReadOnlyText.getGui(), !editable);
    }
    onModelUpdated(model) {
        super.setLastTypeFromModel(model);
        this.updateCompOnModelChange(model);
    }
    onDateChanged() {
        const filterValueDate = this.dateComp.getDate();
        if (this.reactive) {
            const reactiveParams = this.params;
            reactiveParams.onUiChange();
            const model = reactiveParams.model;
            const filterValueText = $437b23f6a393c3bf$export$3d7fedfb21962874(filterValueDate);
            const newModel = filterValueText == null ? null : {
                ...model ?? {
                    filterType: this.filterType,
                    type: this.lastType ?? this.optionsFactory.defaultOption
                },
                dateFrom: filterValueText
            };
            reactiveParams.onModelChange(newModel, {
                afterFloatingFilter: true
            });
        } else this.params.parentFilterInstance((filterInstance)=>{
            filterInstance?.onFloatingFilterChanged(this.lastType || null, filterValueDate);
        });
    }
    getDateComponentParams() {
        const { filterParams: filterParams } = this.params;
        const debounceMs = $437b23f6a393c3bf$var$getDebounceMs(filterParams, this.defaultDebounceMs);
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            onDateChanged: $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.onDateChanged.bind(this), debounceMs),
            filterParams: filterParams,
            location: "floatingFilter"
        });
    }
    createDateComponent() {
        const { beans: { context: context, userCompFactory: userCompFactory }, eDateWrapper: eDateWrapper, params: params } = this;
        this.dateComp = new $437b23f6a393c3bf$var$DateCompWrapper(context, userCompFactory, params.column.getColDef(), this.getDateComponentParams(), eDateWrapper, (dateComp)=>{
            dateComp.setInputAriaLabel(this.getAriaLabel(params));
        });
        this.addDestroyFunc(()=>this.dateComp.destroy());
    }
};
// packages/ag-grid-community/src/filter/provided/date/defaultDateComponent.ts
var $437b23f6a393c3bf$var$DefaultDateElement = {
    tag: "div",
    cls: "ag-filter-filter",
    children: [
        {
            tag: "ag-input-text-field",
            ref: "eDateInput",
            cls: "ag-date-filter"
        }
    ]
};
var $437b23f6a393c3bf$var$DefaultDateComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$DefaultDateElement, [
            $437b23f6a393c3bf$export$31e2985be4ee06ab
        ]);
        this.eDateInput = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.isApply = false;
        this.applyOnFocusOut = false;
    }
    init(params) {
        this.params = params;
        this.setParams(params);
        const inputElement = this.eDateInput.getInputElement();
        this.addManagedListeners(inputElement, {
            // ensures that the input element is focussed when a clear button is clicked,
            // unless using safari as there is no clear button and focus does not work properly
            mouseDown: ()=>{
                if (this.eDateInput.isDisabled() || this.usingSafariDatePicker) return;
                inputElement.focus({
                    preventScroll: true
                });
            },
            input: this.handleInput.bind(this, false),
            change: this.handleInput.bind(this, true),
            focusout: this.handleFocusOut.bind(this)
        });
    }
    handleInput(isChange) {
        if (this.eDateInput.isDisabled()) return;
        if (this.isApply) {
            this.applyOnFocusOut = !isChange;
            if (isChange) this.params.onDateChanged();
            return;
        }
        if (!isChange) this.params.onDateChanged();
    }
    handleFocusOut() {
        if (this.applyOnFocusOut) {
            this.applyOnFocusOut = false;
            this.params.onDateChanged();
        }
    }
    setParams(params) {
        const inputElement = this.eDateInput.getInputElement();
        const shouldUseBrowserDatePicker = this.shouldUseBrowserDatePicker(params);
        this.usingSafariDatePicker = shouldUseBrowserDatePicker && $437b23f6a393c3bf$var$_isBrowserSafari();
        const { minValidYear: minValidYear, maxValidYear: maxValidYear, minValidDate: minValidDate, maxValidDate: maxValidDate, buttons: buttons, includeTime: includeTime, colDef: colDef } = params.filterParams || {};
        const dataTypeSvc = this.beans.dataTypeSvc;
        const shouldUseDateTimeLocal = includeTime ?? dataTypeSvc?.getDateIncludesTimeFlag?.(colDef.cellDataType) ?? false;
        if (shouldUseBrowserDatePicker) {
            if (shouldUseDateTimeLocal) {
                inputElement.type = "datetime-local";
                inputElement.step = "1";
            } else inputElement.type = "date";
        } else inputElement.type = "text";
        if (minValidDate && minValidYear) $437b23f6a393c3bf$export$545083624300f13d(85);
        if (maxValidDate && maxValidYear) $437b23f6a393c3bf$export$545083624300f13d(86);
        if (minValidDate && maxValidDate) {
            const [parsedMinValidDate, parsedMaxValidDate] = [
                minValidDate,
                maxValidDate
            ].map((v)=>v instanceof Date ? v : $437b23f6a393c3bf$export$26ded2d88c01b527(v));
            if (parsedMinValidDate && parsedMaxValidDate && parsedMinValidDate.getTime() > parsedMaxValidDate.getTime()) $437b23f6a393c3bf$export$545083624300f13d(87);
        }
        if (minValidDate) {
            if (minValidDate instanceof Date) inputElement.min = $437b23f6a393c3bf$var$_dateToFormattedString(minValidDate);
            else inputElement.min = minValidDate;
        } else if (minValidYear) inputElement.min = `${minValidYear}-01-01`;
        if (maxValidDate) {
            if (maxValidDate instanceof Date) inputElement.max = $437b23f6a393c3bf$var$_dateToFormattedString(maxValidDate);
            else inputElement.max = maxValidDate;
        } else if (maxValidYear) inputElement.max = `${maxValidYear}-12-31`;
        this.isApply = params.location === "floatingFilter" && !!buttons?.includes("apply");
    }
    refresh(params) {
        this.params = params;
        this.setParams(params);
    }
    getDate() {
        return $437b23f6a393c3bf$export$26ded2d88c01b527(this.eDateInput.getValue());
    }
    setDate(date) {
        const colType = this.params.filterParams.colDef.cellDataType;
        const includeTime = this.beans.dataTypeSvc?.getDateIncludesTimeFlag(colType) ?? false;
        this.eDateInput.setValue($437b23f6a393c3bf$export$3d7fedfb21962874(date, includeTime));
    }
    setInputPlaceholder(placeholder) {
        this.eDateInput.setInputPlaceholder(placeholder);
    }
    setInputAriaLabel(ariaLabel) {
        this.eDateInput.setAriaLabel(ariaLabel);
    }
    setDisabled(disabled) {
        this.eDateInput.setDisabled(disabled);
    }
    afterGuiAttached(params) {
        if (!params || !params.suppressFocus) this.eDateInput.getInputElement().focus({
            preventScroll: true
        });
    }
    shouldUseBrowserDatePicker(params) {
        return params?.filterParams?.browserDatePicker ?? true;
    }
};
// packages/ag-grid-community/src/filter/provided/number/numberFilterConstants.ts
var $437b23f6a393c3bf$var$DEFAULT_NUMBER_FILTER_OPTIONS = [
    "equals",
    "notEqual",
    "greaterThan",
    "greaterThanOrEqual",
    "lessThan",
    "lessThanOrEqual",
    "inRange",
    "blank",
    "notBlank"
];
// packages/ag-grid-community/src/filter/provided/number/numberFilterUtils.ts
function $437b23f6a393c3bf$var$getAllowedCharPattern(filterParams) {
    const { allowedCharPattern: allowedCharPattern } = filterParams ?? {};
    return allowedCharPattern ?? null;
}
function $437b23f6a393c3bf$var$processNumberFilterValue(value) {
    if (value == null) return null;
    return isNaN(value) ? null : value;
}
function $437b23f6a393c3bf$var$mapValuesFromNumberFilterModel(filterModel, optionsFactory) {
    const { filter: filter, filterTo: filterTo, type: type } = filterModel || {};
    return [
        $437b23f6a393c3bf$var$processNumberFilterValue(filter),
        $437b23f6a393c3bf$var$processNumberFilterValue(filterTo)
    ].slice(0, $437b23f6a393c3bf$var$getNumberOfInputs(type, optionsFactory));
}
// packages/ag-grid-community/src/filter/provided/number/numberFilter.ts
var $437b23f6a393c3bf$var$NumberFilter = class extends $437b23f6a393c3bf$var$SimpleFilter {
    constructor(){
        super("numberFilter", $437b23f6a393c3bf$var$mapValuesFromNumberFilterModel, $437b23f6a393c3bf$var$DEFAULT_NUMBER_FILTER_OPTIONS);
        this.eValuesFrom = [];
        this.eValuesTo = [];
        this.filterType = "number";
        this.defaultDebounceMs = 500;
    }
    setElementValue(element, value, fromFloatingFilter) {
        const { numberFormatter: numberFormatter } = this.params;
        const valueToSet = !fromFloatingFilter && numberFormatter ? numberFormatter(value ?? null) : value;
        super.setElementValue(element, valueToSet);
    }
    createEValue() {
        const allowedCharPattern = $437b23f6a393c3bf$var$getAllowedCharPattern(this.params);
        const eCondition = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-filter-body",
            role: "presentation"
        });
        this.createFromToElement(eCondition, this.eValuesFrom, "from", allowedCharPattern);
        this.createFromToElement(eCondition, this.eValuesTo, "to", allowedCharPattern);
        return eCondition;
    }
    createFromToElement(eCondition, eValues, fromTo, allowedCharPattern) {
        const eValue = this.createManagedBean(allowedCharPattern ? new $437b23f6a393c3bf$export$8c027679838afd47({
            allowedCharPattern: allowedCharPattern
        }) : new $437b23f6a393c3bf$export$c8aa0be99738aee());
        eValue.addCss(`ag-filter-${fromTo}`);
        eValue.addCss("ag-filter-filter");
        eValues.push(eValue);
        eCondition.appendChild(eValue.getGui());
    }
    removeEValues(startPosition, deleteCount) {
        const removeComps = (eGui)=>this.removeComponents(eGui, startPosition, deleteCount);
        removeComps(this.eValuesFrom);
        removeComps(this.eValuesTo);
    }
    getValues(position) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            if (index < numberOfInputs) result.push($437b23f6a393c3bf$var$processNumberFilterValue(this.stringToFloat(element.getValue())));
        });
        return result;
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.filter === bSimple.filter && aSimple.filterTo === bSimple.filterTo && aSimple.type === bSimple.type;
    }
    stringToFloat(value) {
        if (typeof value === "number") return value;
        let filterText = $437b23f6a393c3bf$export$4978424c4f7b5fc0(value);
        if (filterText != null && filterText.trim() === "") filterText = null;
        const numberParser = this.params.numberParser;
        if (numberParser) return numberParser(filterText);
        return filterText == null || filterText.trim() === "-" ? null : parseFloat(filterText);
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {
            filterType: this.filterType,
            type: type
        };
        const values = this.getValues(position);
        if (values.length > 0) model.filter = values[0];
        if (values.length > 1) model.filterTo = values[1];
        return model;
    }
    getInputs(position) {
        const { eValuesFrom: eValuesFrom, eValuesTo: eValuesTo } = this;
        if (position >= eValuesFrom.length) return [
            null,
            null
        ];
        return [
            eValuesFrom[position],
            eValuesTo[position]
        ];
    }
    hasInvalidInputs() {
        let invalidInputs = false;
        this.forEachInput((element)=>{
            if (!element.getInputElement().validity.valid) {
                invalidInputs = true;
                return;
            }
        });
        return invalidInputs;
    }
};
// packages/ag-grid-community/src/filter/provided/number/numberFilterModelFormatter.ts
var $437b23f6a393c3bf$var$NumberFilterModelFormatter = class extends $437b23f6a393c3bf$var$SimpleFilterModelFormatter {
    constructor(optionsFactory, filterParams){
        super(optionsFactory, filterParams, filterParams.numberFormatter);
        this.filterTypeKeys = $437b23f6a393c3bf$var$SCALAR_FILTER_TYPE_KEYS;
    }
    conditionToString(condition, forToolPanel, isRange, customDisplayKey, customDisplayName) {
        const { filter: filter, filterTo: filterTo, type: type } = condition;
        const formatValue = this.formatValue.bind(this);
        if (forToolPanel) {
            const valueForToolPanel = this.conditionForToolPanel(type, isRange, ()=>formatValue(filter), ()=>formatValue(filterTo), customDisplayKey, customDisplayName);
            if (valueForToolPanel != null) return valueForToolPanel;
        }
        if (isRange) return `${formatValue(filter)}-${formatValue(filterTo)}`;
        if (filter != null) return formatValue(filter);
        return `${type}`;
    }
};
// packages/ag-grid-community/src/filter/provided/number/numberFilterHandler.ts
var $437b23f6a393c3bf$var$NumberFilterHandler = class extends $437b23f6a393c3bf$var$ScalarFilterHandler {
    constructor(){
        super($437b23f6a393c3bf$var$mapValuesFromNumberFilterModel, $437b23f6a393c3bf$var$DEFAULT_NUMBER_FILTER_OPTIONS);
        this.filterType = "number";
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$NumberFilterModelFormatter;
    }
    comparator() {
        return (left, right)=>{
            if (left === right) return 0;
            return left < right ? 1 : -1;
        };
    }
    isValid(value) {
        return !isNaN(value);
    }
};
// packages/ag-grid-community/src/filter/floating/provided/floatingFilterTextInputService.ts
var $437b23f6a393c3bf$var$FloatingFilterTextInputService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(params){
        super();
        this.params = params;
        this.eInput = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.onValueChanged = ()=>{};
    }
    setupGui(parentElement) {
        this.eInput = this.createManagedBean(new $437b23f6a393c3bf$export$8c027679838afd47(this.params?.config));
        const eInput = this.eInput.getGui();
        parentElement.appendChild(eInput);
        const listener = (e)=>this.onValueChanged(e);
        this.addManagedListeners(eInput, {
            input: listener,
            keydown: listener
        });
    }
    setEditable(editable) {
        this.eInput.setDisabled(!editable);
    }
    getValue() {
        return this.eInput.getValue();
    }
    setValue(value, silent) {
        this.eInput.setValue(value, silent);
    }
    setValueChangedListener(listener) {
        this.onValueChanged = listener;
    }
    setParams({ ariaLabel: ariaLabel, autoComplete: autoComplete }) {
        const { eInput: eInput } = this;
        eInput.setInputAriaLabel(ariaLabel);
        if (autoComplete !== void 0) eInput.setAutoComplete(autoComplete);
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFilterUtils.ts
function $437b23f6a393c3bf$var$trimInputForFilter(value) {
    const trimmedInput = value?.trim();
    return trimmedInput === "" ? value : trimmedInput;
}
function $437b23f6a393c3bf$var$mapValuesFromTextFilterModel(filterModel, optionsFactory) {
    const { filter: filter, filterTo: filterTo, type: type } = filterModel || {};
    return [
        filter || null,
        filterTo || null
    ].slice(0, $437b23f6a393c3bf$var$getNumberOfInputs(type, optionsFactory));
}
// packages/ag-grid-community/src/filter/floating/provided/textInputFloatingFilter.ts
var $437b23f6a393c3bf$var$TextInputFloatingFilterElement = {
    tag: "div",
    ref: "eFloatingFilterInputContainer",
    cls: "ag-floating-filter-input",
    role: "presentation"
};
var $437b23f6a393c3bf$var$TextInputFloatingFilter = class extends $437b23f6a393c3bf$var$SimpleFloatingFilter {
    constructor(){
        super(...arguments);
        this.eFloatingFilterInputContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.defaultDebounceMs = 500;
    }
    postConstruct() {
        this.setTemplate($437b23f6a393c3bf$var$TextInputFloatingFilterElement);
    }
    onModelUpdated(model) {
        this.setLastTypeFromModel(model);
        this.setEditable(this.canWeEditAfterModelFromParentFilter(model));
        this.inputSvc.setValue(this.filterModelFormatter.getModelAsString(model));
    }
    setParams(params) {
        this.setupFloatingFilterInputService(params);
        super.setParams(params);
        this.setTextInputParams(params);
    }
    setupFloatingFilterInputService(params) {
        this.inputSvc = this.createFloatingFilterInputService(params);
        this.inputSvc.setupGui(this.eFloatingFilterInputContainer);
    }
    setTextInputParams(params) {
        const autoComplete = params.browserAutoComplete ?? false;
        const { inputSvc: inputSvc, defaultDebounceMs: defaultDebounceMs, readOnly: readOnly } = this;
        inputSvc.setParams({
            ariaLabel: this.getAriaLabel(params),
            autoComplete: autoComplete
        });
        this.applyActive = $437b23f6a393c3bf$export$527c1b777ebd9069(params.filterParams);
        if (!readOnly) {
            const debounceMs = $437b23f6a393c3bf$var$getDebounceMs(params.filterParams, defaultDebounceMs);
            const toDebounce = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.syncUpWithParentFilter.bind(this), debounceMs);
            inputSvc.setValueChangedListener(toDebounce);
        }
    }
    updateParams(params) {
        super.updateParams(params);
        this.setTextInputParams(params);
    }
    recreateFloatingFilterInputService(params) {
        const { inputSvc: inputSvc } = this;
        const value = inputSvc.getValue();
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.eFloatingFilterInputContainer);
        this.destroyBean(inputSvc);
        this.setupFloatingFilterInputService(params);
        inputSvc.setValue(value, true);
    }
    syncUpWithParentFilter(e) {
        const isEnterKey = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER;
        const reactive = this.reactive;
        if (reactive) {
            const reactiveParams = this.params;
            reactiveParams.onUiChange();
        }
        if (this.applyActive && !isEnterKey) return;
        const { inputSvc: inputSvc, params: params, lastType: lastType } = this;
        let value = inputSvc.getValue();
        if (params.filterParams.trimInput) {
            value = $437b23f6a393c3bf$var$trimInputForFilter(value);
            inputSvc.setValue(value, true);
        }
        if (reactive) {
            const reactiveParams = params;
            const model = reactiveParams.model;
            const parsedValue = this.convertValue(value);
            const newModel = parsedValue == null ? null : {
                ...model ?? {
                    filterType: this.filterType,
                    type: lastType ?? this.optionsFactory.defaultOption
                },
                filter: parsedValue
            };
            reactiveParams.onModelChange(newModel, {
                afterFloatingFilter: true
            });
        } else params.parentFilterInstance((filterInstance)=>{
            filterInstance?.onFloatingFilterChanged(lastType || null, value || null);
        });
    }
    convertValue(value) {
        return value || null;
    }
    setEditable(editable) {
        this.inputSvc.setEditable(editable);
    }
};
// packages/ag-grid-community/src/filter/provided/number/numberFloatingFilter.ts
var $437b23f6a393c3bf$var$FloatingFilterNumberInputService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.onValueChanged = ()=>{};
        this.numberInputActive = true;
    }
    setupGui(parentElement) {
        this.eNumberInput = this.createManagedBean(new $437b23f6a393c3bf$export$c8aa0be99738aee());
        this.eTextInput = this.createManagedBean(new $437b23f6a393c3bf$export$8c027679838afd47());
        this.eTextInput.setDisabled(true);
        const eNumberInput = this.eNumberInput.getGui();
        const eTextInput = this.eTextInput.getGui();
        parentElement.appendChild(eNumberInput);
        parentElement.appendChild(eTextInput);
        this.setupListeners(eNumberInput, (e)=>this.onValueChanged(e));
        this.setupListeners(eTextInput, (e)=>this.onValueChanged(e));
    }
    setEditable(editable) {
        this.numberInputActive = editable;
        this.eNumberInput.setDisplayed(this.numberInputActive);
        this.eTextInput.setDisplayed(!this.numberInputActive);
    }
    setAutoComplete(autoComplete) {
        this.eNumberInput.setAutoComplete(autoComplete);
        this.eTextInput.setAutoComplete(autoComplete);
    }
    getValue() {
        return this.getActiveInputElement().getValue();
    }
    setValue(value, silent) {
        this.getActiveInputElement().setValue(value, silent);
    }
    getActiveInputElement() {
        return this.numberInputActive ? this.eNumberInput : this.eTextInput;
    }
    setValueChangedListener(listener) {
        this.onValueChanged = listener;
    }
    setupListeners(element, listener) {
        this.addManagedListeners(element, {
            input: listener,
            keydown: listener
        });
    }
    setParams(params) {
        this.setAriaLabel(params.ariaLabel);
        if (params.autoComplete !== void 0) this.setAutoComplete(params.autoComplete);
    }
    setAriaLabel(ariaLabel) {
        this.eNumberInput.setInputAriaLabel(ariaLabel);
        this.eTextInput.setInputAriaLabel(ariaLabel);
    }
};
var $437b23f6a393c3bf$var$NumberFloatingFilter = class extends $437b23f6a393c3bf$var$TextInputFloatingFilter {
    constructor(){
        super(...arguments);
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$NumberFilterModelFormatter;
        this.filterType = "number";
        this.defaultOptions = $437b23f6a393c3bf$var$DEFAULT_NUMBER_FILTER_OPTIONS;
    }
    updateParams(params) {
        const allowedCharPattern = $437b23f6a393c3bf$var$getAllowedCharPattern(params.filterParams);
        if (allowedCharPattern !== this.allowedCharPattern) this.recreateFloatingFilterInputService(params);
        super.updateParams(params);
    }
    createFloatingFilterInputService(params) {
        this.allowedCharPattern = $437b23f6a393c3bf$var$getAllowedCharPattern(params.filterParams);
        if (this.allowedCharPattern) return this.createManagedBean(new $437b23f6a393c3bf$var$FloatingFilterTextInputService({
            config: {
                allowedCharPattern: this.allowedCharPattern
            }
        }));
        return this.createManagedBean(new $437b23f6a393c3bf$var$FloatingFilterNumberInputService());
    }
    convertValue(value) {
        return value ? Number(value) : null;
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFilterConstants.ts
var $437b23f6a393c3bf$var$DEFAULT_TEXT_FILTER_OPTIONS = [
    "contains",
    "notContains",
    "equals",
    "notEqual",
    "startsWith",
    "endsWith",
    "blank",
    "notBlank"
];
// packages/ag-grid-community/src/filter/provided/text/textFilter.ts
var $437b23f6a393c3bf$var$TextFilter = class extends $437b23f6a393c3bf$var$SimpleFilter {
    constructor(){
        super("textFilter", $437b23f6a393c3bf$var$mapValuesFromTextFilterModel, $437b23f6a393c3bf$var$DEFAULT_TEXT_FILTER_OPTIONS);
        this.filterType = "text";
        this.eValuesFrom = [];
        this.eValuesTo = [];
        this.defaultDebounceMs = 500;
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {
            filterType: this.filterType,
            type: type
        };
        const values = this.getValuesWithSideEffects(position, true);
        if (values.length > 0) model.filter = values[0];
        if (values.length > 1) model.filterTo = values[1];
        return model;
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.filter === bSimple.filter && aSimple.filterTo === bSimple.filterTo && aSimple.type === bSimple.type;
    }
    getInputs(position) {
        const { eValuesFrom: eValuesFrom, eValuesTo: eValuesTo } = this;
        if (position >= eValuesFrom.length) return [
            null,
            null
        ];
        return [
            eValuesFrom[position],
            eValuesTo[position]
        ];
    }
    getValues(position) {
        return this.getValuesWithSideEffects(position, false);
    }
    getValuesWithSideEffects(position, applySideEffects) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            if (index < numberOfInputs) {
                let value = $437b23f6a393c3bf$export$4978424c4f7b5fc0(element.getValue());
                if (applySideEffects && this.params.trimInput) {
                    value = $437b23f6a393c3bf$var$trimInputForFilter(value) ?? null;
                    element.setValue(value, true);
                }
                result.push(value);
            }
        });
        return result;
    }
    createEValue() {
        const eCondition = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-filter-body",
            role: "presentation"
        });
        const { eValuesFrom: eValuesFrom, eValuesTo: eValuesTo } = this;
        this.createFromToElement(eCondition, eValuesFrom, "from");
        this.createFromToElement(eCondition, eValuesTo, "to");
        return eCondition;
    }
    createFromToElement(eCondition, eValues, fromTo) {
        const eValue = this.createManagedBean(new $437b23f6a393c3bf$export$8c027679838afd47());
        eValue.addCss(`ag-filter-${fromTo}`);
        eValue.addCss("ag-filter-filter");
        eValues.push(eValue);
        eCondition.appendChild(eValue.getGui());
    }
    removeEValues(startPosition, deleteCount) {
        const removeComps = (eGui)=>this.removeComponents(eGui, startPosition, deleteCount);
        const { eValuesFrom: eValuesFrom, eValuesTo: eValuesTo } = this;
        removeComps(eValuesFrom);
        removeComps(eValuesTo);
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFilterModelFormatter.ts
var $437b23f6a393c3bf$var$TextFilterModelFormatter = class extends $437b23f6a393c3bf$var$SimpleFilterModelFormatter {
    constructor(){
        super(...arguments);
        this.filterTypeKeys = $437b23f6a393c3bf$var$TEXT_FILTER_TYPE_KEYS;
    }
    conditionToString(condition, forToolPanel, isRange, customDisplayKey, customDisplayName) {
        const { filter: filter, filterTo: filterTo, type: type } = condition;
        if (forToolPanel) {
            const getValueFunc = (value)=>()=>$437b23f6a393c3bf$export$e2a0ae4af921fff8(this, "filterSummaryTextQuote", [
                        value
                    ]);
            const valueForToolPanel = this.conditionForToolPanel(type, isRange, getValueFunc(filter), getValueFunc(filterTo), customDisplayKey, customDisplayName);
            if (valueForToolPanel != null) return valueForToolPanel;
        }
        if (isRange) return `${filter}-${filterTo}`;
        if (filter != null) return `${filter}`;
        return `${type}`;
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFilterHandler.ts
var $437b23f6a393c3bf$var$defaultMatcher = ({ filterOption: filterOption, value: value, filterText: filterText })=>{
    if (filterText == null) return false;
    switch(filterOption){
        case "contains":
            return value.indexOf(filterText) >= 0;
        case "notContains":
            return value.indexOf(filterText) < 0;
        case "equals":
            return value === filterText;
        case "notEqual":
            return value != filterText;
        case "startsWith":
            return value.indexOf(filterText) === 0;
        case "endsWith":
            {
                const index = value.lastIndexOf(filterText);
                return index >= 0 && index === value.length - filterText.length;
            }
        default:
            return false;
    }
};
var $437b23f6a393c3bf$var$defaultFormatter = (from)=>from;
var $437b23f6a393c3bf$var$defaultLowercaseFormatter = (from)=>from == null ? null : from.toString().toLowerCase();
var $437b23f6a393c3bf$var$TextFilterHandler = class extends $437b23f6a393c3bf$var$SimpleFilterHandler {
    constructor(){
        super($437b23f6a393c3bf$var$mapValuesFromTextFilterModel, $437b23f6a393c3bf$var$DEFAULT_TEXT_FILTER_OPTIONS);
        this.filterType = "text";
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$TextFilterModelFormatter;
    }
    updateParams(params) {
        super.updateParams(params);
        const filterParams = params.filterParams;
        this.matcher = filterParams.textMatcher ?? $437b23f6a393c3bf$var$defaultMatcher;
        this.formatter = filterParams.textFormatter ?? (filterParams.caseSensitive ? $437b23f6a393c3bf$var$defaultFormatter : $437b23f6a393c3bf$var$defaultLowercaseFormatter);
    }
    evaluateNullValue(filterType) {
        const filterTypesAllowNulls = [
            "notEqual",
            "notContains",
            "blank"
        ];
        return filterType ? filterTypesAllowNulls.indexOf(filterType) >= 0 : false;
    }
    evaluateNonNullValue(values, cellValue, filterModel, params) {
        const formattedValues = values.map((v)=>this.formatter(v)) || [];
        const cellValueFormatted = this.formatter(cellValue);
        const { api: api, colDef: colDef, column: column, context: context, filterParams: { textFormatter: textFormatter } } = this.params;
        if (filterModel.type === "blank") return $437b23f6a393c3bf$var$isBlank(cellValue);
        else if (filterModel.type === "notBlank") return !$437b23f6a393c3bf$var$isBlank(cellValue);
        const matcherParams = {
            api: api,
            colDef: colDef,
            column: column,
            context: context,
            node: params.node,
            data: params.data,
            filterOption: filterModel.type,
            value: cellValueFormatted,
            textFormatter: textFormatter
        };
        return formattedValues.some((v)=>this.matcher({
                ...matcherParams,
                filterText: v
            }));
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFloatingFilter.ts
var $437b23f6a393c3bf$var$TextFloatingFilter = class extends $437b23f6a393c3bf$var$TextInputFloatingFilter {
    constructor(){
        super(...arguments);
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$TextFilterModelFormatter;
        this.filterType = "text";
        this.defaultOptions = $437b23f6a393c3bf$var$DEFAULT_TEXT_FILTER_OPTIONS;
    }
    createFloatingFilterInputService() {
        return this.createManagedBean(new $437b23f6a393c3bf$var$FloatingFilterTextInputService());
    }
};
// packages/ag-grid-community/src/filter/quickFilterApi.ts
function $437b23f6a393c3bf$var$isQuickFilterPresent(beans) {
    return !!beans.quickFilter?.isFilterPresent();
}
function $437b23f6a393c3bf$var$getQuickFilter(beans) {
    return beans.quickFilter?.getText();
}
function $437b23f6a393c3bf$var$resetQuickFilter(beans) {
    beans.quickFilter?.resetCache();
}
// packages/ag-grid-community/src/filter/quickFilterService.ts
var $437b23f6a393c3bf$var$QuickFilterService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "quickFilter";
        this.quickFilter = null;
        this.quickFilterParts = null;
    }
    postConstruct() {
        const resetListener = this.resetCache.bind(this);
        const gos = this.gos;
        this.addManagedEventListeners({
            columnPivotModeChanged: resetListener,
            newColumnsLoaded: resetListener,
            columnRowGroupChanged: resetListener,
            columnVisible: ()=>{
                if (!gos.get("includeHiddenColumnsInQuickFilter")) this.resetCache();
            }
        });
        this.addManagedPropertyListener("quickFilterText", (e)=>this.setFilter(e.currentValue));
        this.addManagedPropertyListeners([
            "includeHiddenColumnsInQuickFilter",
            "applyQuickFilterBeforePivotOrAgg"
        ], ()=>this.onColumnConfigChanged());
        this.quickFilter = this.parseFilter(gos.get("quickFilterText"));
        this.parser = gos.get("quickFilterParser");
        this.matcher = gos.get("quickFilterMatcher");
        this.setFilterParts();
        this.addManagedPropertyListeners([
            "quickFilterMatcher",
            "quickFilterParser"
        ], ()=>this.setParserAndMatcher());
    }
    // if we are using autoGroupCols, then they should be included for quick filter. this covers the
    // following scenarios:
    // a) user provides 'field' into autoGroupCol of normal grid, so now because a valid col to filter leafs on
    // b) using tree data and user depends on autoGroupCol for first col, and we also want to filter on this
    //    (tree data is a bit different, as parent rows can be filtered on, unlike row grouping)
    refreshCols() {
        const { autoColSvc: autoColSvc, colModel: colModel, gos: gos, pivotResultCols: pivotResultCols } = this.beans;
        const pivotMode = colModel.isPivotMode();
        const groupAutoCols = autoColSvc?.getColumns();
        const providedCols = colModel.getColDefCols();
        let columnsForQuickFilter = (pivotMode && !gos.get("applyQuickFilterBeforePivotOrAgg") ? pivotResultCols?.getPivotResultCols()?.list : providedCols) ?? [];
        if (groupAutoCols) columnsForQuickFilter = columnsForQuickFilter.concat(groupAutoCols);
        this.colsToUse = gos.get("includeHiddenColumnsInQuickFilter") ? columnsForQuickFilter : columnsForQuickFilter.filter((col)=>col.isVisible() || col.isRowGroupActive());
    }
    isFilterPresent() {
        return this.quickFilter !== null;
    }
    doesRowPass(node) {
        const usingCache = this.gos.get("cacheQuickFilter");
        if (this.matcher) return this.doesRowPassMatcher(usingCache, node);
        return this.quickFilterParts.every((part)=>usingCache ? this.doesRowPassCache(node, part) : this.doesRowPassNoCache(node, part));
    }
    resetCache() {
        this.beans.rowModel.forEachNode((node)=>node.quickFilterAggregateText = null);
    }
    getText() {
        return this.gos.get("quickFilterText");
    }
    setFilterParts() {
        const { quickFilter: quickFilter, parser: parser } = this;
        if (quickFilter) this.quickFilterParts = parser ? parser(quickFilter) : quickFilter.split(" ");
        else this.quickFilterParts = null;
    }
    parseFilter(newFilter) {
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(newFilter)) return null;
        return newFilter.toUpperCase();
    }
    setFilter(newFilter) {
        if (newFilter != null && typeof newFilter !== "string") {
            $437b23f6a393c3bf$export$545083624300f13d(70, {
                newFilter: newFilter
            });
            return;
        }
        const parsedFilter = this.parseFilter(newFilter);
        if (this.quickFilter !== parsedFilter) {
            this.quickFilter = parsedFilter;
            this.setFilterParts();
            this.dispatchLocalEvent({
                type: "quickFilterChanged"
            });
        }
    }
    setParserAndMatcher() {
        const parser = this.gos.get("quickFilterParser");
        const matcher = this.gos.get("quickFilterMatcher");
        const hasChanged = parser !== this.parser || matcher !== this.matcher;
        this.parser = parser;
        this.matcher = matcher;
        if (hasChanged) {
            this.setFilterParts();
            this.dispatchLocalEvent({
                type: "quickFilterChanged"
            });
        }
    }
    onColumnConfigChanged() {
        this.refreshCols();
        this.resetCache();
        if (this.isFilterPresent()) this.dispatchLocalEvent({
            type: "quickFilterChanged"
        });
    }
    doesRowPassNoCache(node, filterPart) {
        return this.colsToUse.some((column)=>{
            const part = this.getTextForColumn(column, node);
            return $437b23f6a393c3bf$export$25d27f17d3af40f7(part) && part.indexOf(filterPart) >= 0;
        });
    }
    doesRowPassCache(node, filterPart) {
        this.checkGenerateAggText(node);
        return node.quickFilterAggregateText.indexOf(filterPart) >= 0;
    }
    doesRowPassMatcher(usingCache, node) {
        let quickFilterAggregateText;
        if (usingCache) {
            this.checkGenerateAggText(node);
            quickFilterAggregateText = node.quickFilterAggregateText;
        } else quickFilterAggregateText = this.getAggText(node);
        const { quickFilterParts: quickFilterParts, matcher: matcher } = this;
        return matcher(quickFilterParts, quickFilterAggregateText);
    }
    checkGenerateAggText(node) {
        if (!node.quickFilterAggregateText) node.quickFilterAggregateText = this.getAggText(node);
    }
    getTextForColumn(column, node) {
        let value = this.beans.filterValueSvc.getValue(column, node);
        const colDef = column.getColDef();
        if (colDef.getQuickFilterText) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                value: value,
                node: node,
                data: node.data,
                column: column,
                colDef: colDef
            });
            value = colDef.getQuickFilterText(params);
        }
        return $437b23f6a393c3bf$export$25d27f17d3af40f7(value) ? value.toString().toUpperCase() : null;
    }
    getAggText(node) {
        const stringParts = [];
        this.colsToUse.forEach((column)=>{
            const part = this.getTextForColumn(column, node);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(part)) stringParts.push(part);
        });
        return stringParts.join("\n");
    }
};
// packages/ag-grid-community/src/filter/filterModule.ts
var $437b23f6a393c3bf$var$ClientSideRowModelFilterModule = {
    moduleName: "ClientSideRowModelFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $437b23f6a393c3bf$var$FilterStage
    ]
};
var $437b23f6a393c3bf$export$b8779358eaaabc87 = {
    moduleName: "FilterCore",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$FilterManager
    ],
    apiFunctions: {
        isAnyFilterPresent: $437b23f6a393c3bf$var$isAnyFilterPresent,
        onFilterChanged: $437b23f6a393c3bf$var$onFilterChanged
    },
    css: [
        $437b23f6a393c3bf$var$columnFiltersCSS
    ],
    dependsOn: [
        $437b23f6a393c3bf$var$ClientSideRowModelFilterModule
    ]
};
var $437b23f6a393c3bf$export$55e846ac25ec4cc0 = {
    moduleName: "FilterValue",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$FilterValueService
    ]
};
var $437b23f6a393c3bf$export$bee7a6b8183a1c61 = {
    moduleName: "ColumnFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnFilterService,
        $437b23f6a393c3bf$var$FilterMenuFactory
    ],
    dynamicBeans: {
        headerFilterCellCtrl: $437b23f6a393c3bf$var$HeaderFilterCellCtrl
    },
    icons: {
        // open filter button - header, floating filter, menu
        filter: "filter",
        // filter is applied - header (legacy column menu), filter tool panel
        filterActive: "filter"
    },
    apiFunctions: {
        isColumnFilterPresent: $437b23f6a393c3bf$var$isColumnFilterPresent,
        getColumnFilterInstance: $437b23f6a393c3bf$var$getColumnFilterInstance,
        destroyFilter: $437b23f6a393c3bf$var$destroyFilter,
        setFilterModel: $437b23f6a393c3bf$var$setFilterModel,
        getFilterModel: $437b23f6a393c3bf$var$getFilterModel,
        getColumnFilterModel: $437b23f6a393c3bf$var$getColumnFilterModel,
        setColumnFilterModel: $437b23f6a393c3bf$var$setColumnFilterModel,
        showColumnFilter: $437b23f6a393c3bf$var$showColumnFilter,
        hideColumnFilter: $437b23f6a393c3bf$var$hideColumnFilter,
        getColumnFilterHandler: $437b23f6a393c3bf$var$getColumnFilterHandler,
        doFilterAction: $437b23f6a393c3bf$var$doFilterAction
    },
    dependsOn: [
        $437b23f6a393c3bf$export$b8779358eaaabc87,
        $437b23f6a393c3bf$export$da5c9bb998e6c24d,
        $437b23f6a393c3bf$export$55e846ac25ec4cc0,
        $437b23f6a393c3bf$export$b0ea578339daf1f7
    ]
};
var $437b23f6a393c3bf$export$c992812899d813d0 = {
    moduleName: "CustomFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agReadOnlyFloatingFilter: $437b23f6a393c3bf$var$ReadOnlyFloatingFilter
    },
    dependsOn: [
        $437b23f6a393c3bf$export$bee7a6b8183a1c61
    ]
};
var $437b23f6a393c3bf$export$5ce3e57cec1fecc9 = {
    moduleName: "TextFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$bee7a6b8183a1c61
    ],
    userComponents: {
        agTextColumnFilter: {
            classImp: $437b23f6a393c3bf$var$TextFilter,
            params: {
                useForm: true
            }
        },
        agTextColumnFloatingFilter: $437b23f6a393c3bf$var$TextFloatingFilter
    },
    dynamicBeans: {
        agTextColumnFilterHandler: $437b23f6a393c3bf$var$TextFilterHandler
    }
};
var $437b23f6a393c3bf$export$aabcd4399b0469bb = {
    moduleName: "NumberFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$bee7a6b8183a1c61
    ],
    userComponents: {
        agNumberColumnFilter: {
            classImp: $437b23f6a393c3bf$var$NumberFilter,
            params: {
                useForm: true
            }
        },
        agNumberColumnFloatingFilter: $437b23f6a393c3bf$var$NumberFloatingFilter
    },
    dynamicBeans: {
        agNumberColumnFilterHandler: $437b23f6a393c3bf$var$NumberFilterHandler
    }
};
var $437b23f6a393c3bf$export$2a2721fe06c4c013 = {
    moduleName: "DateFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$bee7a6b8183a1c61
    ],
    userComponents: {
        agDateColumnFilter: {
            classImp: $437b23f6a393c3bf$var$DateFilter,
            params: {
                useForm: true
            }
        },
        agDateInput: $437b23f6a393c3bf$var$DefaultDateComponent,
        agDateColumnFloatingFilter: $437b23f6a393c3bf$var$DateFloatingFilter
    },
    dynamicBeans: {
        agDateColumnFilterHandler: $437b23f6a393c3bf$var$DateFilterHandler
    }
};
var $437b23f6a393c3bf$var$QuickFilterCoreModule = {
    moduleName: "QuickFilterCore",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $437b23f6a393c3bf$var$QuickFilterService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$b8779358eaaabc87,
        $437b23f6a393c3bf$export$55e846ac25ec4cc0
    ]
};
var $437b23f6a393c3bf$export$7e8079ed742f8307 = {
    moduleName: "QuickFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        isQuickFilterPresent: $437b23f6a393c3bf$var$isQuickFilterPresent,
        getQuickFilter: $437b23f6a393c3bf$var$getQuickFilter,
        resetQuickFilter: $437b23f6a393c3bf$var$resetQuickFilter
    },
    dependsOn: [
        $437b23f6a393c3bf$var$QuickFilterCoreModule
    ]
};
var $437b23f6a393c3bf$export$fc403e59f6fc67b = {
    moduleName: "ExternalFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$b8779358eaaabc87
    ]
};
// packages/ag-grid-community/src/tooltip/tooltip.css-GENERATED.ts
var $437b23f6a393c3bf$var$tooltipCSS = /*css*/ `.ag-tooltip{background-color:var(--ag-tooltip-background-color);border:var(--ag-tooltip-border);border-radius:var(--ag-border-radius);color:var(--ag-tooltip-text-color);padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:absolute;white-space:normal;z-index:99999;&:where(.ag-cell-editor-tooltip){background-color:var(--ag-tooltip-error-background-color);border:var(--ag-tooltip-error-border);color:var(--ag-tooltip-error-text-color);font-weight:500}}.ag-tooltip-custom{position:absolute;z-index:99999}.ag-tooltip-custom:where(:not(.ag-tooltip-interactive)),.ag-tooltip:where(:not(.ag-tooltip-interactive)){pointer-events:none}.ag-tooltip-animate{transition:opacity 1s;&:where(.ag-tooltip-hiding){opacity:0}}`;
// packages/ag-grid-community/src/tooltip/tooltipService.ts
var $437b23f6a393c3bf$var$getEditErrorsForPosition = (beans, cellCtrl, translate)=>{
    const { editModelSvc: editModelSvc } = beans;
    const cellValidationErrors = editModelSvc?.getCellValidationModel()?.getCellValidation(cellCtrl)?.errorMessages;
    const rowValidationErrors = editModelSvc?.getRowValidationModel().getRowValidation(cellCtrl)?.errorMessages;
    const errors = cellValidationErrors || rowValidationErrors;
    return errors && errors.length ? errors.join(translate("tooltipValidationErrorSeparator", ". ")) : void 0;
};
var $437b23f6a393c3bf$var$TooltipService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "tooltipSvc";
    }
    setupHeaderTooltip(existingTooltipFeature, ctrl, value, shouldDisplayTooltip) {
        if (existingTooltipFeature) ctrl.destroyBean(existingTooltipFeature);
        const isTooltipWhenTruncated = $437b23f6a393c3bf$export$58660753196c7cdf(this.gos);
        const { column: column, eGui: eGui } = ctrl;
        const colDef = column.getColDef();
        if (!shouldDisplayTooltip && isTooltipWhenTruncated && !colDef.headerComponent) shouldDisplayTooltip = $437b23f6a393c3bf$export$8980540b0a37a11d(()=>eGui.querySelector(".ag-header-cell-text"));
        const tooltipCtrl = {
            getColumn: ()=>column,
            getColDef: ()=>column.getColDef(),
            getGui: ()=>eGui,
            getLocation: ()=>"header",
            getTooltipValue: ()=>{
                if (value != null) return value;
                const res = column.getColDef().headerTooltip;
                return res;
            },
            shouldDisplayTooltip: shouldDisplayTooltip
        };
        let tooltipFeature = this.createTooltipFeature(tooltipCtrl);
        if (tooltipFeature) {
            tooltipFeature = ctrl.createBean(tooltipFeature);
            ctrl.setRefreshFunction("tooltip", ()=>tooltipFeature.refreshTooltip());
        }
        return tooltipFeature;
    }
    setupHeaderGroupTooltip(existingTooltipFeature, ctrl, value, shouldDisplayTooltip) {
        if (existingTooltipFeature) ctrl.destroyBean(existingTooltipFeature);
        const isTooltipWhenTruncated = $437b23f6a393c3bf$export$58660753196c7cdf(this.gos);
        const { column: column, eGui: eGui } = ctrl;
        const colGroupDef = column.getColGroupDef();
        if (!shouldDisplayTooltip && isTooltipWhenTruncated && !colGroupDef?.headerGroupComponent) shouldDisplayTooltip = $437b23f6a393c3bf$export$8980540b0a37a11d(()=>eGui.querySelector(".ag-header-group-text"));
        const tooltipCtrl = {
            getColumn: ()=>column,
            getGui: ()=>eGui,
            getLocation: ()=>"headerGroup",
            getTooltipValue: ()=>value ?? (colGroupDef && colGroupDef.headerTooltip),
            shouldDisplayTooltip: shouldDisplayTooltip
        };
        if (colGroupDef) tooltipCtrl.getColDef = ()=>colGroupDef;
        const tooltipFeature = this.createTooltipFeature(tooltipCtrl);
        return tooltipFeature ? ctrl.createBean(tooltipFeature) : tooltipFeature;
    }
    enableCellTooltipFeature(ctrl, value, shouldDisplayTooltip) {
        const { beans: beans } = this;
        const { gos: gos, editSvc: editSvc } = beans;
        const { column: column, rowNode: rowNode } = ctrl;
        let location = "cell";
        const getTooltipValue = ()=>{
            const isEditing2 = !!editSvc?.isEditing(ctrl);
            const errorMessages = !isEditing2 && $437b23f6a393c3bf$var$getEditErrorsForPosition(beans, ctrl, this.getLocaleTextFunc());
            if (errorMessages) {
                location = "cellEditor";
                return errorMessages;
            }
            location = "cell";
            const colDef = column.getColDef();
            const data = rowNode.data;
            if (colDef.tooltipField && $437b23f6a393c3bf$export$25d27f17d3af40f7(data)) return $437b23f6a393c3bf$var$_getValueUsingField(data, colDef.tooltipField, column.isTooltipFieldContainsDots());
            const valueGetter = colDef.tooltipValueGetter;
            if (valueGetter) return valueGetter($437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
                location: "cell",
                colDef: column.getColDef(),
                column: column,
                rowIndex: ctrl.cellPosition.rowIndex,
                node: rowNode,
                data: rowNode.data,
                value: ctrl.value,
                valueFormatted: ctrl.valueFormatted
            }));
            return null;
        };
        const isTooltipWhenTruncated = $437b23f6a393c3bf$export$58660753196c7cdf(gos);
        if (!shouldDisplayTooltip) {
            if (isTooltipWhenTruncated && !ctrl.isCellRenderer()) shouldDisplayTooltip = ()=>{
                const isEditing2 = !!editSvc?.isEditing(ctrl);
                const errorMessages = !isEditing2 && $437b23f6a393c3bf$var$getEditErrorsForPosition(beans, ctrl, this.getLocaleTextFunc());
                if (errorMessages) return true;
                const isTooltipEnabled = column.isTooltipEnabled();
                if (!isTooltipEnabled) return false;
                const isElementOverflowing = $437b23f6a393c3bf$export$8980540b0a37a11d(()=>{
                    const eCell = ctrl.eGui;
                    return eCell.children.length === 0 ? eCell : eCell.querySelector(".ag-cell-value");
                });
                return !isEditing2 && isElementOverflowing();
            };
            else shouldDisplayTooltip = ()=>!editSvc?.isEditing(ctrl);
        }
        const tooltipCtrl = {
            getColumn: ()=>column,
            getColDef: ()=>column.getColDef(),
            getRowIndex: ()=>ctrl.cellPosition.rowIndex,
            getRowNode: ()=>rowNode,
            getGui: ()=>ctrl.eGui,
            getLocation: ()=>location,
            getTooltipValue: value != null ? ()=>value : getTooltipValue,
            // this makes no sense, why is the cell formatted value passed to the tooltip???
            getValueFormatted: ()=>ctrl.valueFormatted,
            shouldDisplayTooltip: shouldDisplayTooltip
        };
        return this.createTooltipFeature(tooltipCtrl, beans);
    }
    setupFullWidthRowTooltip(existingTooltipFeature, ctrl, value, shouldDisplayTooltip) {
        const tooltipParams = {
            getGui: ()=>ctrl.getFullWidthElement(),
            getTooltipValue: ()=>value,
            getLocation: ()=>"fullWidthRow",
            shouldDisplayTooltip: shouldDisplayTooltip
        };
        const beans = this.beans;
        const context = beans.context;
        if (existingTooltipFeature) ctrl.destroyBean(existingTooltipFeature, context);
        const tooltipFeature = this.createTooltipFeature(tooltipParams, beans);
        if (!tooltipFeature) return;
        return ctrl.createBean(tooltipFeature, context);
    }
    setupCellEditorTooltip(cellCtrl, editor) {
        const { beans: beans } = this;
        const { context: context } = beans;
        const el = editor.getValidationElement?.(true) || !editor.isPopup?.() && cellCtrl.eGui;
        if (!el) return;
        const tooltipParams = {
            getGui: ()=>el,
            getTooltipValue: ()=>$437b23f6a393c3bf$var$getEditErrorsForPosition(beans, cellCtrl, this.getLocaleTextFunc()),
            getLocation: ()=>"cellEditor",
            shouldDisplayTooltip: ()=>{
                const { editModelSvc: editModelSvc } = beans;
                const rowValidationMap = editModelSvc?.getRowValidationModel()?.getRowValidationMap();
                const cellValidationMap = editModelSvc?.getCellValidationModel()?.getCellValidationMap();
                const hasRowValidationErrors = !!rowValidationMap && rowValidationMap.size > 0;
                const hasCellValidationErrors = !!cellValidationMap && cellValidationMap.size > 0;
                return hasRowValidationErrors || hasCellValidationErrors;
            }
        };
        const tooltipFeature = this.createTooltipFeature(tooltipParams, beans);
        if (!tooltipFeature) return;
        return cellCtrl.createBean(tooltipFeature, context);
    }
    initCol(column) {
        const { colDef: colDef } = column;
        column.tooltipEnabled = $437b23f6a393c3bf$export$25d27f17d3af40f7(colDef.tooltipField) || $437b23f6a393c3bf$export$25d27f17d3af40f7(colDef.tooltipValueGetter) || $437b23f6a393c3bf$export$25d27f17d3af40f7(colDef.tooltipComponent);
    }
    createTooltipFeature(tooltipCtrl, beans) {
        return this.beans.registry.createDynamicBean("tooltipFeature", false, tooltipCtrl, beans);
    }
};
// packages/ag-grid-community/src/tooltip/tooltipModule.ts
var $437b23f6a393c3bf$export$d0c662c133b8814e = {
    moduleName: "Tooltip",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$TooltipService
    ],
    dynamicBeans: {
        tooltipFeature: $437b23f6a393c3bf$export$e5073a590d24815c
    },
    userComponents: {
        agTooltipComponent: $437b23f6a393c3bf$var$TooltipComponent2
    },
    dependsOn: [
        $437b23f6a393c3bf$export$da5c9bb998e6c24d
    ],
    css: [
        $437b23f6a393c3bf$var$tooltipCSS
    ]
};
// packages/ag-grid-community/src/undoRedo/undoRedoStack.ts
var $437b23f6a393c3bf$var$UndoRedoAction = class {
    constructor(cellValueChanges){
        this.cellValueChanges = cellValueChanges;
    }
};
var $437b23f6a393c3bf$var$RangeUndoRedoAction = class extends $437b23f6a393c3bf$var$UndoRedoAction {
    constructor(cellValueChanges, initialRange, finalRange, ranges){
        super(cellValueChanges);
        this.initialRange = initialRange;
        this.finalRange = finalRange;
        this.ranges = ranges;
    }
};
var $437b23f6a393c3bf$var$DEFAULT_STACK_SIZE = 10;
var $437b23f6a393c3bf$var$UndoRedoStack = class {
    constructor(maxStackSize){
        this.actionStack = [];
        this.maxStackSize = maxStackSize ? maxStackSize : $437b23f6a393c3bf$var$DEFAULT_STACK_SIZE;
        this.actionStack = new Array(this.maxStackSize);
    }
    pop() {
        return this.actionStack.pop();
    }
    push(item) {
        const shouldAddActions = item.cellValueChanges && item.cellValueChanges.length > 0;
        if (!shouldAddActions) return;
        if (this.actionStack.length === this.maxStackSize) this.actionStack.shift();
        this.actionStack.push(item);
    }
    clear() {
        this.actionStack = [];
    }
    getCurrentStackSize() {
        return this.actionStack.length;
    }
};
// packages/ag-grid-community/src/undoRedo/undoRedoService.ts
var $437b23f6a393c3bf$var$UndoRedoService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "undoRedo";
        this.cellValueChanges = [];
        this.activeCellEdit = null;
        this.activeRowEdit = null;
        this.isPasting = false;
        this.isRangeInAction = false;
        this.batchEditing = false;
        this.bulkEditing = false;
        this.onCellValueChanged = (event)=>{
            const eventCell = {
                column: event.column,
                rowIndex: event.rowIndex,
                rowPinned: event.rowPinned
            };
            const isCellEditing = this.activeCellEdit !== null && $437b23f6a393c3bf$export$be3973033c2c5267(this.activeCellEdit, eventCell);
            const isRowEditing = this.activeRowEdit !== null && $437b23f6a393c3bf$export$de6f9fa10e9f4188(this.activeRowEdit, eventCell);
            const shouldCaptureAction = isCellEditing || isRowEditing || this.isPasting || this.isRangeInAction;
            if (!shouldCaptureAction) return;
            const { rowPinned: rowPinned, rowIndex: rowIndex, column: column, oldValue: oldValue, value: value } = event;
            const cellValueChange = {
                rowPinned: rowPinned,
                rowIndex: rowIndex,
                columnId: column.getColId(),
                newValue: value,
                oldValue: oldValue
            };
            this.cellValueChanges.push(cellValueChange);
        };
        this.clearStacks = ()=>{
            this.undoStack.clear();
            this.redoStack.clear();
        };
    }
    postConstruct() {
        const { gos: gos, ctrlsSvc: ctrlsSvc } = this.beans;
        if (!gos.get("undoRedoCellEditing")) return;
        const undoRedoLimit = gos.get("undoRedoCellEditingLimit");
        if (undoRedoLimit <= 0) return;
        this.undoStack = new $437b23f6a393c3bf$var$UndoRedoStack(undoRedoLimit);
        this.redoStack = new $437b23f6a393c3bf$var$UndoRedoStack(undoRedoLimit);
        this.addListeners();
        const listener = this.clearStacks.bind(this);
        this.addManagedEventListeners({
            cellValueChanged: this.onCellValueChanged.bind(this),
            // undo / redo is restricted to actual editing so we clear the stacks when other operations are
            // performed that change the order of the row / cols.
            modelUpdated: (e)=>{
                if (!e.keepUndoRedoStack) this.clearStacks();
            },
            columnPivotModeChanged: listener,
            newColumnsLoaded: listener,
            columnGroupOpened: listener,
            columnRowGroupChanged: listener,
            columnMoved: listener,
            columnPinned: listener,
            columnVisible: listener,
            rowDragEnd: listener
        });
        ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
        });
    }
    getCurrentUndoStackSize() {
        return this.undoStack?.getCurrentStackSize() ?? 0;
    }
    getCurrentRedoStackSize() {
        return this.redoStack?.getCurrentStackSize() ?? 0;
    }
    undo(source) {
        const { eventSvc: eventSvc, undoStack: undoStack, redoStack: redoStack } = this;
        eventSvc.dispatchEvent({
            type: "undoStarted",
            source: source
        });
        const operationPerformed = this.undoRedo(undoStack, redoStack, "initialRange", "oldValue", "undo");
        eventSvc.dispatchEvent({
            type: "undoEnded",
            source: source,
            operationPerformed: operationPerformed
        });
    }
    redo(source) {
        const { eventSvc: eventSvc, undoStack: undoStack, redoStack: redoStack } = this;
        eventSvc.dispatchEvent({
            type: "redoStarted",
            source: source
        });
        const operationPerformed = this.undoRedo(redoStack, undoStack, "finalRange", "newValue", "redo");
        eventSvc.dispatchEvent({
            type: "redoEnded",
            source: source,
            operationPerformed: operationPerformed
        });
    }
    undoRedo(undoRedoStack, opposingUndoRedoStack, rangeProperty, cellValueChangeProperty, source) {
        if (!undoRedoStack) return false;
        const undoRedoAction = undoRedoStack.pop();
        if (!undoRedoAction || !undoRedoAction.cellValueChanges) return false;
        this.processAction(undoRedoAction, (cellValueChange)=>cellValueChange[cellValueChangeProperty], source);
        if (undoRedoAction instanceof $437b23f6a393c3bf$var$RangeUndoRedoAction) this.processRange(undoRedoAction.ranges || [
            undoRedoAction[rangeProperty]
        ]);
        else this.processCell(undoRedoAction.cellValueChanges);
        opposingUndoRedoStack.push(undoRedoAction);
        return true;
    }
    processAction(action, valueExtractor, source) {
        action.cellValueChanges.forEach((cellValueChange)=>{
            const { rowIndex: rowIndex, rowPinned: rowPinned, columnId: columnId } = cellValueChange;
            const rowPosition = {
                rowIndex: rowIndex,
                rowPinned: rowPinned
            };
            const currentRow = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, rowPosition);
            if (!currentRow.displayed) return;
            currentRow.setDataValue(columnId, valueExtractor(cellValueChange), source);
        });
    }
    processRange(ranges) {
        let lastFocusedCell;
        const rangeSvc = this.beans.rangeSvc;
        rangeSvc.removeAllCellRanges(true);
        ranges.forEach((range, idx)=>{
            if (!range) return;
            const startRow = range.startRow;
            const endRow = range.endRow;
            if (idx === ranges.length - 1) {
                lastFocusedCell = {
                    rowPinned: startRow.rowPinned,
                    rowIndex: startRow.rowIndex,
                    columnId: range.startColumn.getColId()
                };
                this.setLastFocusedCell(lastFocusedCell);
            }
            const cellRangeParams = {
                rowStartIndex: startRow.rowIndex,
                rowStartPinned: startRow.rowPinned,
                rowEndIndex: endRow.rowIndex,
                rowEndPinned: endRow.rowPinned,
                columnStart: range.startColumn,
                columns: range.columns
            };
            rangeSvc.addCellRange(cellRangeParams);
        });
    }
    processCell(cellValueChanges) {
        const cellValueChange = cellValueChanges[0];
        const { rowIndex: rowIndex, rowPinned: rowPinned } = cellValueChange;
        const rowPosition = {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        };
        const row = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, rowPosition);
        const lastFocusedCell = {
            rowPinned: cellValueChange.rowPinned,
            rowIndex: row.rowIndex,
            columnId: cellValueChange.columnId
        };
        this.setLastFocusedCell(lastFocusedCell);
    }
    setLastFocusedCell(lastFocusedCell) {
        const { rowIndex: rowIndex, columnId: columnId, rowPinned: rowPinned } = lastFocusedCell;
        const { colModel: colModel, focusSvc: focusSvc, rangeSvc: rangeSvc } = this.beans;
        const column = colModel.getCol(columnId);
        if (!column) return;
        const { scrollFeature: scrollFeature } = this.gridBodyCtrl;
        scrollFeature.ensureIndexVisible(rowIndex);
        scrollFeature.ensureColumnVisible(column);
        const cellPosition = {
            rowIndex: rowIndex,
            column: column,
            rowPinned: rowPinned
        };
        focusSvc.setFocusedCell({
            ...cellPosition,
            forceBrowserFocus: true
        });
        rangeSvc?.setRangeToCell(cellPosition);
    }
    addListeners() {
        this.addManagedEventListeners({
            rowEditingStarted: (e)=>{
                this.activeRowEdit = {
                    rowIndex: e.rowIndex,
                    rowPinned: e.rowPinned
                };
            },
            rowEditingStopped: ()=>{
                const action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                this.pushActionsToUndoStack(action);
                this.activeRowEdit = null;
            },
            cellEditingStarted: (e)=>{
                this.activeCellEdit = {
                    column: e.column,
                    rowIndex: e.rowIndex,
                    rowPinned: e.rowPinned
                };
            },
            cellEditingStopped: (e)=>{
                this.activeCellEdit = null;
                const shouldPushAction = e.valueChanged && !this.activeRowEdit && !this.isPasting && !this.isRangeInAction;
                if (shouldPushAction) {
                    const action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                    this.pushActionsToUndoStack(action);
                }
            },
            pasteStart: ()=>{
                this.isPasting = true;
            },
            pasteEnd: ()=>{
                const action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                this.pushActionsToUndoStack(action);
                this.isPasting = false;
            },
            fillStart: ()=>{
                this.isRangeInAction = true;
            },
            fillEnd: (event)=>{
                const action = new $437b23f6a393c3bf$var$RangeUndoRedoAction(this.cellValueChanges, event.initialRange, event.finalRange);
                this.pushActionsToUndoStack(action);
                this.isRangeInAction = false;
            },
            keyShortcutChangedCellStart: ()=>{
                this.isRangeInAction = true;
            },
            keyShortcutChangedCellEnd: ()=>{
                let action;
                const { rangeSvc: rangeSvc, gos: gos } = this.beans;
                if (rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(gos)) action = new $437b23f6a393c3bf$var$RangeUndoRedoAction(this.cellValueChanges, void 0, void 0, [
                    ...rangeSvc.getCellRanges()
                ]);
                else action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                this.pushActionsToUndoStack(action);
                this.isRangeInAction = false;
            },
            batchEditingStarted: ()=>this.startBigChange("batchEditing"),
            batchEditingStopped: ({ changes: changes })=>this.stopBigChange("batchEditing", changes),
            bulkEditingStarted: ()=>this.startBigChange("bulkEditing"),
            bulkEditingStopped: ({ changes: changes })=>this.stopBigChange("bulkEditing", changes)
        });
    }
    startBigChange(key) {
        this[key] = true;
    }
    stopBigChange(key, changes) {
        if (!this[key]) return;
        this[key] = false;
        if (changes?.length === 0) return;
        const action = new $437b23f6a393c3bf$var$UndoRedoAction(changes ?? []);
        this.pushActionsToUndoStack(action);
        this.cellValueChanges = [];
    }
    pushActionsToUndoStack(action) {
        this.undoStack.push(action);
        this.cellValueChanges = [];
        this.redoStack.clear();
    }
};
// packages/ag-grid-community/src/edit/cell-editing.css-GENERATED.ts
var $437b23f6a393c3bf$var$cellEditingCSS = /*css*/ `.ag-cell-inline-editing{border:var(--ag-cell-editing-border)!important;border-radius:var(--ag-border-radius);box-shadow:var(--ag-cell-editing-shadow);padding:0;z-index:1;.ag-cell-edit-wrapper,.ag-cell-editor,.ag-cell-wrapper,:where(.ag-cell-editor) .ag-input-field-input,:where(.ag-cell-editor) .ag-wrapper{height:100%;line-height:normal;min-height:100%;width:100%}&.ag-cell-editing-error{border-color:var(--ag-invalid-color)!important}}:where(.ag-popup-editor) .ag-large-text{background-color:var(--ag-background-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);padding:0}.ag-large-text-input{height:auto;padding:var(--ag-cell-horizontal-padding)}:where(.ag-rtl .ag-large-text-input) textarea{resize:none}:where(.ag-ltr) .ag-checkbox-edit{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-checkbox-edit{padding-right:var(--ag-cell-horizontal-padding)}:where(.ag-row.ag-row-editing-invalid .ag-cell-inline-editing){opacity:.8}`;
// packages/ag-grid-community/src/edit/cellEditors/checkboxCellEditor.ts
var $437b23f6a393c3bf$var$CheckboxCellEditorElement = {
    tag: "div",
    cls: "ag-cell-wrapper ag-cell-edit-wrapper ag-checkbox-edit",
    children: [
        {
            tag: "ag-checkbox",
            ref: "eEditor",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$CheckboxCellEditor = class extends $437b23f6a393c3bf$export$803b08aecd9af1a9 {
    constructor(){
        super($437b23f6a393c3bf$var$CheckboxCellEditorElement, [
            $437b23f6a393c3bf$export$2e2c317d2e31f2ca
        ]);
        this.eEditor = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    initialiseEditor(params) {
        const isSelected = params.value ?? void 0;
        const eEditor = this.eEditor;
        eEditor.setValue(isSelected);
        const inputEl = eEditor.getInputElement();
        inputEl.setAttribute("tabindex", "-1");
        this.setAriaLabel(isSelected);
        this.addManagedListeners(eEditor, {
            fieldValueChanged: (event)=>this.setAriaLabel(event.selected)
        });
    }
    getValue() {
        return this.eEditor.getValue();
    }
    focusIn() {
        this.eEditor.getFocusableElement().focus();
    }
    afterGuiAttached() {
        if (this.params.cellStartedEdit) this.focusIn();
    }
    isPopup() {
        return false;
    }
    setAriaLabel(isSelected) {
        const translate = this.getLocaleTextFunc();
        const stateName = $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, isSelected);
        const ariaLabel = translate("ariaToggleCellValue", "Press SPACE to toggle cell value");
        this.eEditor.setInputAriaLabel(`${ariaLabel} (${stateName})`);
    }
    getValidationElement(tooltip) {
        return tooltip ? this.params.eGridCell : this.eEditor.getInputElement();
    }
    getValidationErrors() {
        const { params: params } = this;
        const { getValidationErrors: getValidationErrors } = params;
        const value = this.getValue();
        if (!getValidationErrors) return null;
        return getValidationErrors({
            value: value,
            internalErrors: null,
            cellEditorParams: params
        });
    }
};
// packages/ag-grid-community/src/edit/cellEditors/simpleCellEditor.ts
var $437b23f6a393c3bf$var$SimpleCellEditor = class extends $437b23f6a393c3bf$export$803b08aecd9af1a9 {
    constructor(cellEditorInput){
        super();
        this.cellEditorInput = cellEditorInput;
        this.eEditor = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    initialiseEditor(params) {
        const { cellEditorInput: cellEditorInput } = this;
        this.setTemplate({
            tag: "div",
            cls: "ag-cell-edit-wrapper",
            children: [
                cellEditorInput.getTemplate()
            ]
        }, cellEditorInput.getAgComponents());
        const { eEditor: eEditor } = this;
        const { cellStartedEdit: cellStartedEdit, eventKey: eventKey, suppressPreventDefault: suppressPreventDefault } = params;
        eEditor.getInputElement().setAttribute("title", "");
        cellEditorInput.init(eEditor, params);
        let startValue;
        let shouldSetStartValue = true;
        if (cellStartedEdit) {
            this.focusAfterAttached = true;
            if (eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE || eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE) startValue = "";
            else if (eventKey && eventKey.length === 1) {
                if (suppressPreventDefault) shouldSetStartValue = false;
                else startValue = eventKey;
            } else {
                startValue = cellEditorInput.getStartValue();
                if (eventKey !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2) this.highlightAllOnFocus = true;
            }
        } else {
            this.focusAfterAttached = false;
            startValue = cellEditorInput.getStartValue();
        }
        if (shouldSetStartValue && startValue != null) eEditor.setStartValue(startValue);
        this.addGuiEventListener("keydown", (event)=>{
            const { key: key } = event;
            if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN) event.preventDefault();
        });
    }
    afterGuiAttached() {
        const translate = this.getLocaleTextFunc();
        const eInput = this.eEditor;
        eInput.setInputAriaLabel(translate("ariaInputEditor", "Input Editor"));
        if (!this.focusAfterAttached) return;
        if (!$437b23f6a393c3bf$var$_isBrowserSafari()) eInput.getFocusableElement().focus();
        const inputEl = eInput.getInputElement();
        if (this.highlightAllOnFocus) inputEl.select();
        else this.cellEditorInput.setCaret?.();
    }
    // gets called when tabbing through cells and in full row edit mode
    focusIn() {
        const { eEditor: eEditor } = this;
        const focusEl = eEditor.getFocusableElement();
        const inputEl = eEditor.getInputElement();
        focusEl.focus();
        inputEl.select();
    }
    getValue() {
        return this.cellEditorInput.getValue();
    }
    isPopup() {
        return false;
    }
    getValidationElement() {
        return this.eEditor.getInputElement();
    }
    getValidationErrors() {
        return this.cellEditorInput.getValidationErrors();
    }
};
// packages/ag-grid-community/src/edit/cellEditors/dateCellEditor.ts
var $437b23f6a393c3bf$var$DateCellElement = {
    tag: "ag-input-date-field",
    ref: "eEditor",
    cls: "ag-cell-editor"
};
var $437b23f6a393c3bf$var$DateCellEditorInput = class {
    constructor(getDataTypeService, getLocaleTextFunc){
        this.getDataTypeService = getDataTypeService;
        this.getLocaleTextFunc = getLocaleTextFunc;
    }
    getTemplate() {
        return $437b23f6a393c3bf$var$DateCellElement;
    }
    getAgComponents() {
        return [
            $437b23f6a393c3bf$var$AgInputDateFieldSelector
        ];
    }
    init(eEditor, params) {
        this.eEditor = eEditor;
        this.params = params;
        const { min: min, max: max, step: step, colDef: colDef } = params;
        if (min != null) eEditor.setMin(min);
        if (max != null) eEditor.setMax(max);
        if (step != null) eEditor.setStep(step);
        this.includeTime = params.includeTime ?? this.getDataTypeService()?.getDateIncludesTimeFlag?.(colDef.cellDataType);
        if (this.includeTime != null) eEditor.setIncludeTime(this.includeTime);
    }
    getValidationErrors() {
        const eInput = this.eEditor.getInputElement();
        const value = eInput.valueAsDate;
        const { params: params } = this;
        const { min: min, max: max, getValidationErrors: getValidationErrors } = params;
        let internalErrors = [];
        const translate = this.getLocaleTextFunc();
        if (value instanceof Date && !isNaN(value.getTime())) {
            if (min) {
                const minValue = min instanceof Date ? min : new Date(min);
                if (value < minValue) {
                    const minDateString = minValue.toLocaleDateString();
                    internalErrors.push(translate("minDateValidation", `Date must be after ${minDateString}`, [
                        minDateString
                    ]));
                }
            }
            if (max) {
                const maxValue = max instanceof Date ? max : new Date(max);
                if (value > maxValue) {
                    const maxDateString = maxValue.toLocaleDateString();
                    internalErrors.push(translate("maxDateValidation", `Date must be before ${maxDateString}`, [
                        maxDateString
                    ]));
                }
            }
        }
        if (!internalErrors.length) internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: value,
            cellEditorParams: params,
            internalErrors: internalErrors
        });
        return internalErrors;
    }
    getValue() {
        const { eEditor: eEditor, params: params } = this;
        const value = eEditor.getDate();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        return value ?? null;
    }
    getStartValue() {
        const { value: value } = this.params;
        if (!(value instanceof Date)) return void 0;
        return $437b23f6a393c3bf$export$3d7fedfb21962874(value, this.includeTime ?? false);
    }
};
var $437b23f6a393c3bf$var$DateCellEditor = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$DateCellEditorInput(()=>this.beans.dataTypeSvc, ()=>this.getLocaleTextFunc()));
    }
};
// packages/ag-grid-community/src/edit/cellEditors/dateStringCellEditor.ts
var $437b23f6a393c3bf$var$DateStringCellElement = {
    tag: "ag-input-date-field",
    ref: "eEditor",
    cls: "ag-cell-editor"
};
var $437b23f6a393c3bf$var$DateStringCellEditorInput = class {
    constructor(getDataTypeService, getLocaleTextFunc){
        this.getDataTypeService = getDataTypeService;
        this.getLocaleTextFunc = getLocaleTextFunc;
    }
    getTemplate() {
        return $437b23f6a393c3bf$var$DateStringCellElement;
    }
    getAgComponents() {
        return [
            $437b23f6a393c3bf$var$AgInputDateFieldSelector
        ];
    }
    init(eEditor, params) {
        this.eEditor = eEditor;
        this.params = params;
        const { min: min, max: max, step: step, colDef: colDef } = params;
        if (min != null) eEditor.setMin(min);
        if (max != null) eEditor.setMax(max);
        if (step != null) eEditor.setStep(step);
        this.includeTime = params.includeTime ?? this.getDataTypeService()?.getDateIncludesTimeFlag?.(colDef.cellDataType);
        if (this.includeTime != null) eEditor.setIncludeTime(this.includeTime);
    }
    getValidationErrors() {
        const { eEditor: eEditor, params: params } = this;
        const raw = eEditor.getInputElement().value;
        const value = this.formatDate(this.parseDate(raw ?? void 0));
        const { min: min, max: max, getValidationErrors: getValidationErrors } = params;
        let internalErrors = [];
        if (value) {
            const date = new Date(value);
            const translate = this.getLocaleTextFunc();
            if (min) {
                const minDate = new Date(min);
                if (date < minDate) {
                    const minDateString = minDate.toLocaleDateString();
                    internalErrors.push(translate("minDateValidation", `Date must be after ${minDateString}`, [
                        minDateString
                    ]));
                }
            }
            if (max) {
                const maxDate = new Date(max);
                if (date > maxDate) {
                    const maxDateString = maxDate.toLocaleDateString();
                    internalErrors.push(translate("maxDateValidation", `Date must be before ${maxDateString}`, [
                        maxDateString
                    ]));
                }
            }
        }
        if (!internalErrors.length) internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: this.getValue(),
            cellEditorParams: params,
            internalErrors: internalErrors
        });
        return internalErrors;
    }
    getValue() {
        const { params: params, eEditor: eEditor } = this;
        const value = this.formatDate(eEditor.getDate());
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        return params.parseValue(value ?? "");
    }
    getStartValue() {
        return $437b23f6a393c3bf$export$3d7fedfb21962874(this.parseDate(this.params.value ?? void 0) ?? null, this.includeTime ?? false);
    }
    parseDate(value) {
        const dataTypeSvc = this.getDataTypeService();
        return dataTypeSvc ? dataTypeSvc.getDateParserFunction(this.params.column)(value) : $437b23f6a393c3bf$export$26ded2d88c01b527(value) ?? void 0;
    }
    formatDate(value) {
        const dataTypeSvc = this.getDataTypeService();
        return dataTypeSvc ? dataTypeSvc.getDateFormatterFunction(this.params.column)(value) : $437b23f6a393c3bf$export$3d7fedfb21962874(value ?? null, this.includeTime ?? false) ?? void 0;
    }
};
var $437b23f6a393c3bf$var$DateStringCellEditor = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$DateStringCellEditorInput(()=>this.beans.dataTypeSvc, ()=>this.getLocaleTextFunc()));
    }
};
// packages/ag-grid-community/src/edit/cellEditors/largeTextCellEditor.ts
var $437b23f6a393c3bf$var$LargeTextCellElement = {
    tag: "div",
    cls: "ag-large-text",
    children: [
        {
            tag: "ag-input-text-area",
            ref: "eEditor",
            cls: "ag-large-text-input"
        }
    ]
};
var $437b23f6a393c3bf$var$LargeTextCellEditor = class extends $437b23f6a393c3bf$export$803b08aecd9af1a9 {
    constructor(){
        super($437b23f6a393c3bf$var$LargeTextCellElement, [
            $437b23f6a393c3bf$var$AgInputTextAreaSelector
        ]);
        this.eEditor = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    initialiseEditor(params) {
        const { eEditor: eEditor } = this;
        const { cellStartedEdit: cellStartedEdit, eventKey: eventKey, maxLength: maxLength, cols: cols, rows: rows } = params;
        this.focusAfterAttached = cellStartedEdit;
        eEditor.getInputElement().setAttribute("title", "");
        eEditor.setMaxLength(maxLength || 200).setCols(cols || 60).setRows(rows || 10);
        let startValue;
        if (cellStartedEdit) {
            this.focusAfterAttached = true;
            if (eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE || eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE) startValue = "";
            else if (eventKey && eventKey.length === 1) startValue = eventKey;
            else {
                startValue = this.getStartValue(params);
                if (eventKey !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2) this.highlightAllOnFocus = true;
            }
        } else {
            this.focusAfterAttached = false;
            startValue = this.getStartValue(params);
        }
        if (startValue != null) eEditor.setValue(startValue, true);
        this.addGuiEventListener("keydown", this.onKeyDown.bind(this));
        this.activateTabIndex();
    }
    getStartValue(params) {
        const { value: value } = params;
        return value?.toString() ?? value;
    }
    onKeyDown(event) {
        const key = event.key;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN || event.shiftKey && key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) event.stopPropagation();
    }
    afterGuiAttached() {
        const { eEditor: eEditor, focusAfterAttached: focusAfterAttached, highlightAllOnFocus: highlightAllOnFocus } = this;
        const translate = this.getLocaleTextFunc();
        eEditor.setInputAriaLabel(translate("ariaInputEditor", "Input Editor"));
        if (focusAfterAttached) {
            eEditor.getFocusableElement().focus();
            if (highlightAllOnFocus) eEditor.getInputElement().select();
        }
    }
    getValue() {
        const { eEditor: eEditor, params: params } = this;
        const { value: value } = params;
        const editorValue = eEditor.getValue();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(editorValue) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(value)) return value;
        return params.parseValue(editorValue);
    }
    getValidationElement() {
        return this.eEditor.getInputElement();
    }
    getValidationErrors() {
        const { params: params } = this;
        const { maxLength: maxLength, getValidationErrors: getValidationErrors } = params;
        const translate = this.getLocaleTextFunc();
        const value = this.getValue();
        let internalErrors = [];
        if (typeof value === "string" && maxLength != null && value.length > maxLength) internalErrors.push(translate("maxLengthValidation", `Must be ${maxLength} characters or fewer.`, [
            String(maxLength)
        ]));
        if (!internalErrors.length) internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: value,
            internalErrors: internalErrors,
            cellEditorParams: params
        });
        return internalErrors;
    }
};
// packages/ag-grid-community/src/edit/cellEditors/numberCellEditor.ts
var $437b23f6a393c3bf$var$NumberCellElement = {
    tag: "ag-input-number-field",
    ref: "eEditor",
    cls: "ag-cell-editor"
};
var $437b23f6a393c3bf$var$NumberCellEditorInput = class {
    constructor(getLocaleTextFunc){
        this.getLocaleTextFunc = getLocaleTextFunc;
    }
    getTemplate() {
        return $437b23f6a393c3bf$var$NumberCellElement;
    }
    getAgComponents() {
        return [
            $437b23f6a393c3bf$export$c18153c9c909b7d7
        ];
    }
    init(eEditor, params) {
        this.eEditor = eEditor;
        this.params = params;
        const { max: max, min: min, precision: precision, step: step } = params;
        if (max != null) eEditor.setMax(max);
        if (min != null) eEditor.setMin(min);
        if (precision != null) eEditor.setPrecision(precision);
        if (step != null) eEditor.setStep(step);
        const editorEl = eEditor.getInputElement();
        if (params.preventStepping) eEditor.addManagedElementListeners(editorEl, {
            keydown: this.preventStepping
        });
        else if (params.showStepperButtons) editorEl.classList.add("ag-number-field-input-stepper");
    }
    getValidationErrors() {
        const { params: params } = this;
        const { min: min, max: max, getValidationErrors: getValidationErrors } = params;
        const eInput = this.eEditor.getInputElement();
        const value = eInput.valueAsNumber;
        const translate = this.getLocaleTextFunc();
        let internalErrors = [];
        if (typeof value === "number") {
            if (min != null && value < min) internalErrors.push(translate("minValueValidation", `Must be greater than or equal to ${min}.`, [
                String(min)
            ]));
            if (max != null && value > max) internalErrors.push(translate("maxValueValidation", `Must be less than or equal to ${max}.`, [
                String(max)
            ]));
        }
        if (!internalErrors.length) internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: value,
            cellEditorParams: params,
            internalErrors: internalErrors
        });
        return internalErrors;
    }
    preventStepping(e) {
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP || e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN) e.preventDefault();
    }
    getValue() {
        const { eEditor: eEditor, params: params } = this;
        const value = eEditor.getValue();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        let parsedValue = params.parseValue(value);
        if (parsedValue == null) return parsedValue;
        if (typeof parsedValue === "string") {
            if (parsedValue === "") return null;
            parsedValue = Number(parsedValue);
        }
        return isNaN(parsedValue) ? null : parsedValue;
    }
    getStartValue() {
        return this.params.value;
    }
    setCaret() {
        if ($437b23f6a393c3bf$var$_isBrowserSafari()) this.eEditor.getInputElement().focus({
            preventScroll: true
        });
    }
};
var $437b23f6a393c3bf$var$NumberCellEditor = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$NumberCellEditorInput(()=>this.getLocaleTextFunc()));
    }
};
// packages/ag-grid-community/src/edit/cellEditors/selectCellEditor.ts
var $437b23f6a393c3bf$var$SelectCellElement = {
    tag: "div",
    cls: "ag-cell-edit-wrapper",
    children: [
        {
            tag: "ag-select",
            ref: "eEditor",
            cls: "ag-cell-editor"
        }
    ]
};
var $437b23f6a393c3bf$var$SelectCellEditor = class extends $437b23f6a393c3bf$export$803b08aecd9af1a9 {
    constructor(){
        super($437b23f6a393c3bf$var$SelectCellElement, [
            $437b23f6a393c3bf$export$e32612175ad118ef
        ]);
        this.eEditor = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.startedByEnter = false;
    }
    wireBeans(beans) {
        this.valueSvc = beans.valueSvc;
    }
    initialiseEditor(params) {
        this.focusAfterAttached = params.cellStartedEdit;
        const { eEditor: eEditor, valueSvc: valueSvc, gos: gos } = this;
        const { values: values, value: value, eventKey: eventKey } = params;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(values)) {
            $437b23f6a393c3bf$export$545083624300f13d(58);
            return;
        }
        this.startedByEnter = eventKey != null ? eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER : false;
        let hasValue = false;
        values.forEach((currentValue)=>{
            const option = {
                value: currentValue
            };
            const valueFormatted = valueSvc.formatValue(params.column, null, currentValue);
            const valueFormattedExits = valueFormatted !== null && valueFormatted !== void 0;
            option.text = valueFormattedExits ? valueFormatted : currentValue;
            eEditor.addOption(option);
            hasValue = hasValue || value === currentValue;
        });
        if (hasValue) eEditor.setValue(params.value, true);
        else if (params.values.length) eEditor.setValue(params.values[0], true);
        const { valueListGap: valueListGap, valueListMaxWidth: valueListMaxWidth, valueListMaxHeight: valueListMaxHeight } = params;
        if (valueListGap != null) eEditor.setPickerGap(valueListGap);
        if (valueListMaxHeight != null) eEditor.setPickerMaxHeight(valueListMaxHeight);
        if (valueListMaxWidth != null) eEditor.setPickerMaxWidth(valueListMaxWidth);
        if (gos.get("editType") !== "fullRow") this.addManagedListeners(this.eEditor, {
            selectedItem: ()=>params.stopEditing()
        });
    }
    afterGuiAttached() {
        if (this.focusAfterAttached) this.eEditor.getFocusableElement().focus();
        if (this.startedByEnter) setTimeout(()=>{
            if (this.isAlive()) this.eEditor.showPicker();
        });
    }
    focusIn() {
        this.eEditor.getFocusableElement().focus();
    }
    getValue() {
        return this.eEditor.getValue();
    }
    isPopup() {
        return false;
    }
    getValidationElement() {
        return this.eEditor.getAriaElement();
    }
    getValidationErrors() {
        const { params: params } = this;
        const { values: values, getValidationErrors: getValidationErrors } = params;
        const value = this.getValue();
        let internalErrors = [];
        if (values && !values.includes(value)) {
            const translate = this.getLocaleTextFunc();
            internalErrors.push(translate("invalidSelectionValidation", "Invalid selection."));
        } else internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: value,
            internalErrors: internalErrors,
            cellEditorParams: params
        });
        return internalErrors;
    }
};
// packages/ag-grid-community/src/edit/cellEditors/textCellEditor.ts
var $437b23f6a393c3bf$var$TextCellEditorElement = {
    tag: "ag-input-text-field",
    ref: "eEditor",
    cls: "ag-cell-editor"
};
var $437b23f6a393c3bf$var$TextCellEditorInput = class {
    constructor(getLocaleTextFunc){
        this.getLocaleTextFunc = getLocaleTextFunc;
    }
    getTemplate() {
        return $437b23f6a393c3bf$var$TextCellEditorElement;
    }
    getAgComponents() {
        return [
            $437b23f6a393c3bf$export$31e2985be4ee06ab
        ];
    }
    init(eEditor, params) {
        this.eEditor = eEditor;
        this.params = params;
        const maxLength = params.maxLength;
        if (maxLength != null) eEditor.setMaxLength(maxLength);
    }
    getValidationErrors() {
        const { params: params } = this;
        const { maxLength: maxLength, getValidationErrors: getValidationErrors } = params;
        const value = this.getValue();
        const translate = this.getLocaleTextFunc();
        let internalErrors = [];
        if (maxLength != null && typeof value === "string" && value.length > maxLength) internalErrors.push(translate("maxLengthValidation", `Must be ${maxLength} characters or fewer.`, [
            String(maxLength)
        ]));
        if (!internalErrors.length) internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: value,
            cellEditorParams: params,
            internalErrors: internalErrors
        });
        return internalErrors;
    }
    getValue() {
        const { eEditor: eEditor, params: params } = this;
        const value = eEditor.getValue();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        return params.parseValue(value);
    }
    getStartValue() {
        const params = this.params;
        const formatValue = params.useFormatter || params.column.getColDef().refData;
        return formatValue ? params.formatValue(params.value) : params.value;
    }
    setCaret() {
        const eInput = this.eEditor;
        const value = eInput.getValue();
        const len = $437b23f6a393c3bf$export$25d27f17d3af40f7(value) && value.length || 0;
        if (len) eInput.getInputElement().setSelectionRange(len, len);
    }
};
var $437b23f6a393c3bf$var$TextCellEditor = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$TextCellEditorInput(()=>this.getLocaleTextFunc()));
    }
};
// packages/ag-grid-community/src/api/scrollApi.ts
function $437b23f6a393c3bf$var$getVerticalPixelRange(beans) {
    return beans.ctrlsSvc.getScrollFeature().getVScrollPosition();
}
function $437b23f6a393c3bf$var$getHorizontalPixelRange(beans) {
    return beans.ctrlsSvc.getScrollFeature().getHScrollPosition();
}
function $437b23f6a393c3bf$var$ensureColumnVisible(beans, key, position = "auto") {
    beans.frameworkOverrides.wrapIncoming(()=>beans.ctrlsSvc.getScrollFeature().ensureColumnVisible(key, position), "ensureVisible");
}
function $437b23f6a393c3bf$var$ensureIndexVisible(beans, index, position) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.ctrlsSvc.getScrollFeature().ensureIndexVisible(index, position), "ensureVisible");
}
function $437b23f6a393c3bf$var$ensureNodeVisible(beans, nodeSelector, position = null) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.ctrlsSvc.getScrollFeature().ensureNodeVisible(nodeSelector, position), "ensureVisible");
}
// packages/ag-grid-community/src/edit/editApi.ts
function $437b23f6a393c3bf$var$undoCellEditing(beans) {
    beans.undoRedo?.undo("api");
}
function $437b23f6a393c3bf$var$redoCellEditing(beans) {
    beans.undoRedo?.redo("api");
}
function $437b23f6a393c3bf$var$getEditingCells(beans) {
    const edits = beans.editModelSvc?.getEditMap();
    const positions = [];
    edits?.forEach((editRow, rowNode)=>{
        const { rowIndex: rowIndex, rowPinned: rowPinned } = rowNode;
        editRow.forEach((editValue, column)=>{
            const { editorValue: editorValue, pendingValue: pendingValue, sourceValue: oldValue, state: state } = editValue;
            const diff = $437b23f6a393c3bf$var$_sourceAndPendingDiffer(editValue);
            let newValue = editorValue ?? pendingValue;
            if (newValue === $437b23f6a393c3bf$var$UNEDITED) newValue = void 0;
            const edit = {
                newValue: newValue,
                oldValue: oldValue,
                state: state,
                column: column,
                colId: column.getColId(),
                colKey: column.getColId(),
                rowIndex: rowIndex,
                rowPinned: rowPinned
            };
            const changed = state === "changed" && diff;
            const editing = state === "editing";
            if (editing || changed) positions.push(edit);
        });
    });
    return positions;
}
function $437b23f6a393c3bf$var$stopEditing(beans, cancel = false) {
    const { editSvc: editSvc } = beans;
    if (editSvc?.isBatchEditing()) {
        if (cancel) beans.editModelSvc?.getEditPositions().forEach((cellPosition)=>{
            if (cellPosition.state === "editing") editSvc.revertSingleCellEdit(cellPosition);
        });
        else $437b23f6a393c3bf$var$_syncFromEditors(beans, true);
        $437b23f6a393c3bf$var$_destroyEditors(beans);
    } else editSvc?.stopEditing(void 0, {
        cancel: cancel,
        source: "api"
    });
}
function $437b23f6a393c3bf$var$isEditing(beans, cellPosition) {
    const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, cellPosition);
    return beans.editSvc?.isEditing(cellCtrl) ?? false;
}
function $437b23f6a393c3bf$var$startEditingCell(beans, params) {
    const { key: key, colKey: colKey, rowIndex: rowIndex, rowPinned: rowPinned } = params;
    const { editSvc: editSvc, colModel: colModel } = beans;
    const column = colModel.getCol(colKey);
    if (!column) {
        $437b23f6a393c3bf$export$545083624300f13d(12, {
            colKey: colKey
        });
        return;
    }
    const cellPosition = {
        rowIndex: rowIndex,
        rowPinned: rowPinned || null,
        column: column
    };
    const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(beans, cellPosition);
    if (!rowNode) {
        $437b23f6a393c3bf$export$545083624300f13d(290, {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        });
        return;
    }
    if (!column.isCellEditable(rowNode)) return;
    const notPinned = rowPinned == null;
    if (notPinned) $437b23f6a393c3bf$var$ensureIndexVisible(beans, rowIndex);
    $437b23f6a393c3bf$var$ensureColumnVisible(beans, colKey);
    editSvc?.startEditing({
        rowNode: rowNode,
        column: column
    }, {
        event: key ? new KeyboardEvent("keydown", {
            key: key
        }) : void 0,
        source: "api"
    });
}
function $437b23f6a393c3bf$var$validateEdit(beans) {
    return beans.editSvc?.validateEdit() || null;
}
function $437b23f6a393c3bf$var$getCurrentUndoSize(beans) {
    return beans.undoRedo?.getCurrentUndoStackSize() ?? 0;
}
function $437b23f6a393c3bf$var$getCurrentRedoSize(beans) {
    return beans.undoRedo?.getCurrentRedoStackSize() ?? 0;
}
// packages/ag-grid-community/src/edit/cellEditors/popupEditorWrapper.ts
var $437b23f6a393c3bf$var$PopupEditorElement = {
    tag: "div",
    cls: "ag-popup-editor",
    attrs: {
        tabindex: "-1"
    }
};
var $437b23f6a393c3bf$var$PopupEditorWrapper = class extends $437b23f6a393c3bf$export$9fac2d040f3ed438 {
    constructor(params){
        super($437b23f6a393c3bf$var$PopupEditorElement);
        this.params = params;
    }
    postConstruct() {
        $437b23f6a393c3bf$var$_setDomData(this.gos, this.getGui(), "popupEditorWrapper", true);
        this.addKeyDownListener();
    }
    addKeyDownListener() {
        const eGui = this.getGui();
        const params = this.params;
        const listener = (event)=>{
            if (!$437b23f6a393c3bf$var$_isUserSuppressingKeyboardEvent(this.gos, event, params.node, params.column, true)) params.onKeyDown(event);
        };
        this.addManagedElementListeners(eGui, {
            keydown: listener
        });
    }
};
// packages/ag-grid-community/src/edit/styles/style-utils.ts
var $437b23f6a393c3bf$var$editHighlightFn = (edit, includeEditing = false)=>{
    if (edit !== void 0) return $437b23f6a393c3bf$var$_sourceAndPendingDiffer(edit) || includeEditing && edit.state === "editing";
};
function $437b23f6a393c3bf$var$_hasEdits(beans, position, includeEditing = false) {
    return $437b23f6a393c3bf$var$editHighlightFn(beans.editModelSvc?.getEdit(position), includeEditing);
}
function $437b23f6a393c3bf$var$_hasLeafEdits(beans, position) {
    const { editModelSvc: editModelSvc } = beans;
    const { column: column, rowNode: rowNode } = position;
    if (beans.gos.get("groupTotalRow") && !rowNode?.footer) return false;
    for (const node of rowNode?.allLeafChildren ?? []){
        const highlight = $437b23f6a393c3bf$var$editHighlightFn(editModelSvc?.getEdit({
            rowNode: node,
            column: column
        })) || $437b23f6a393c3bf$var$editHighlightFn(editModelSvc?.getEdit({
            rowNode: node.pinnedSibling,
            column: column
        }));
        if (highlight) return true;
    }
}
function $437b23f6a393c3bf$var$_hasPinnedEdits(beans, { rowNode: rowNode, column: column }) {
    rowNode = rowNode.pinnedSibling;
    if (!rowNode) return;
    return $437b23f6a393c3bf$var$editHighlightFn(beans.editModelSvc?.getEdit({
        rowNode: rowNode,
        column: column
    }));
}
// packages/ag-grid-community/src/edit/styles/cellEditStyleFeature.ts
var $437b23f6a393c3bf$var$CellEditStyleFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans){
        super();
        this.cellCtrl = cellCtrl;
        this.beans = beans;
        this.editSvc = beans.editSvc;
        this.editModelSvc = beans.editModelSvc;
    }
    setComp(comp) {
        this.cellComp = comp;
        this.applyCellStyles();
    }
    applyCellStyles() {
        const { cellCtrl: cellCtrl, editSvc: editSvc, beans: beans } = this;
        if (editSvc?.isBatchEditing() && editSvc.isEditing()) {
            const state = $437b23f6a393c3bf$var$_hasEdits(beans, cellCtrl) || $437b23f6a393c3bf$var$_hasLeafEdits(beans, cellCtrl) || $437b23f6a393c3bf$var$_hasPinnedEdits(beans, cellCtrl);
            this.applyBatchingStyle(state);
        } else this.applyBatchingStyle(false);
        const hasErrors = !!this.editModelSvc?.getCellValidationModel().hasCellValidation(this.cellCtrl);
        this.cellComp.toggleCss("ag-cell-editing-error", hasErrors);
    }
    applyBatchingStyle(newState) {
        this.cellComp.toggleCss("ag-cell-editing", newState ?? false);
        this.cellComp.toggleCss("ag-cell-batch-edit", (newState && this.editSvc?.isBatchEditing()) ?? false);
    }
};
// packages/ag-grid-community/src/edit/styles/rowEditStyleFeature.ts
var $437b23f6a393c3bf$var$RowEditStyleFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(rowCtrl, beans){
        super();
        this.rowCtrl = rowCtrl;
        this.beans = beans;
        this.gos = beans.gos;
        this.editSvc = beans.editSvc;
        this.editModelSvc = beans.editModelSvc;
    }
    applyRowStyles() {
        const { rowCtrl: rowCtrl, editModelSvc: editModelSvc, beans: beans } = this;
        let rowNode = rowCtrl.rowNode;
        let edits = editModelSvc?.getEditRow(rowNode);
        const hasErrors = this.editModelSvc?.getRowValidationModel().hasRowValidation({
            rowNode: rowNode
        });
        if (!edits && rowNode.pinnedSibling) {
            rowNode = rowNode.pinnedSibling;
            edits = editModelSvc?.getEditRow(rowNode);
        }
        if (edits) {
            const editing = Array.from(edits.keys()).some((column)=>{
                const position = {
                    rowNode: rowNode,
                    column: column
                };
                return $437b23f6a393c3bf$var$_hasEdits(beans, position, true) || $437b23f6a393c3bf$var$_hasLeafEdits(beans, position) || $437b23f6a393c3bf$var$_hasPinnedEdits(beans, position);
            });
            this.applyStyle(hasErrors, editing);
            return;
        }
        this.applyStyle(hasErrors);
    }
    applyStyle(hasErrors = false, editing = false) {
        const batchEdit = this.editSvc?.isBatchEditing() ?? false;
        const fullRow = this.gos.get("editType") === "fullRow";
        this.rowCtrl?.forEachGui(void 0, ({ rowComp: rowComp })=>{
            rowComp.toggleCss("ag-row-editing", fullRow && editing);
            rowComp.toggleCss("ag-row-batch-edit", fullRow && editing && batchEdit);
            rowComp.toggleCss("ag-row-inline-editing", editing);
            rowComp.toggleCss("ag-row-not-inline-editing", !editing);
            rowComp.toggleCss("ag-row-editing-invalid", fullRow && editing && hasErrors);
        });
    }
};
// packages/ag-grid-community/src/edit/utils/refresh.ts
var $437b23f6a393c3bf$var$purgeRows = ({ rowModel: rowModel, pinnedRowModel: pinnedRowModel, editModelSvc: editModelSvc }, rowNodes)=>{
    const found = /* @__PURE__ */ new Set();
    rowModel.forEachNode((node)=>rowNodes.has(node) && found.add(node));
    pinnedRowModel?.forEachPinnedRow("top", (node)=>rowNodes.has(node) && found.add(node));
    pinnedRowModel?.forEachPinnedRow("bottom", (node)=>rowNodes.has(node) && found.add(node));
    rowNodes.forEach((rowNode)=>{
        if (!found.has(rowNode)) editModelSvc.removeEdits({
            rowNode: rowNode
        });
    });
    return found;
};
var $437b23f6a393c3bf$var$purgeCells = ({ editModelSvc: editModelSvc }, rowNodes, columns)=>{
    rowNodes.forEach((rowNode)=>editModelSvc?.getEditRow(rowNode)?.forEach((_, column)=>!columns.has(column) && editModelSvc.removeEdits({
                rowNode: rowNode,
                column: column
            })));
};
var $437b23f6a393c3bf$var$_refreshEditCells = (beans)=>()=>{
        const columns = new Set(beans.colModel.getCols());
        const updates = beans.editModelSvc.getEditMap(true);
        const rowNodes = new Set(updates.keys());
        $437b23f6a393c3bf$var$purgeCells(beans, $437b23f6a393c3bf$var$purgeRows(beans, rowNodes), columns);
    };
// packages/ag-grid-community/src/edit/editService.ts
var $437b23f6a393c3bf$var$KEEP_EDITOR_SOURCES = /* @__PURE__ */ new Set([
    "undo",
    "redo",
    "paste",
    "bulk"
]);
var $437b23f6a393c3bf$var$STOP_EDIT_SOURCE_TRANSFORM = {
    paste: "api",
    rangeSvc: "api",
    fillHandle: "api",
    cellClear: "api",
    bulk: "api"
};
var $437b23f6a393c3bf$var$STOP_EDIT_SOURCE_TRANSFORM_KEYS = new Set(Object.keys($437b23f6a393c3bf$var$STOP_EDIT_SOURCE_TRANSFORM));
var $437b23f6a393c3bf$var$SET_DATA_SOURCE_AS_API = /* @__PURE__ */ new Set([
    "paste",
    "rangeSvc",
    "renderer",
    "cellClear",
    "redo",
    "undo"
]);
var $437b23f6a393c3bf$var$CANCEL_PARAMS = {
    cancel: true,
    source: "api"
};
var $437b23f6a393c3bf$var$COMMIT_PARAMS = {
    cancel: false,
    source: "api"
};
var $437b23f6a393c3bf$var$CHECK_SIBLING = {
    checkSiblings: true
};
var $437b23f6a393c3bf$var$FORCE_REFRESH = {
    force: true,
    suppressFlash: true
};
var $437b23f6a393c3bf$var$EditService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "editSvc";
        this.batch = false;
        this.stopping = false;
        this.committing = false;
    }
    postConstruct() {
        const { beans: beans } = this;
        this.model = beans.editModelSvc;
        this.valueSvc = beans.valueSvc;
        this.rangeSvc = beans.rangeSvc;
        this.addManagedPropertyListener("editType", ({ currentValue: currentValue })=>{
            this.stopEditing(void 0, $437b23f6a393c3bf$var$CANCEL_PARAMS);
            this.createStrategy(currentValue);
        });
        const handler = $437b23f6a393c3bf$var$_refreshEditCells(beans);
        const stopInvalidEdits = ()=>{
            const hasCellValidation = this.model.getCellValidationModel().getCellValidationMap().size > 0;
            const hasRowValidation = this.model.getRowValidationModel().getRowValidationMap().size > 0;
            if (hasCellValidation || hasRowValidation) this.stopEditing(void 0, $437b23f6a393c3bf$var$CANCEL_PARAMS);
            else if (this.isEditing()) {
                if (this.isBatchEditing()) $437b23f6a393c3bf$var$_destroyEditors(beans, this.model.getEditPositions());
                else this.stopEditing(void 0, $437b23f6a393c3bf$var$COMMIT_PARAMS);
            }
            return false;
        };
        this.addManagedEventListeners({
            columnPinned: handler,
            columnVisible: handler,
            columnRowGroupChanged: handler,
            rowGroupOpened: handler,
            pinnedRowsChanged: handler,
            displayedRowsChanged: handler,
            sortChanged: stopInvalidEdits,
            filterChanged: stopInvalidEdits,
            cellFocused: this.onCellFocused.bind(this)
        });
    }
    isBatchEditing() {
        return this.batch;
    }
    setBatchEditing(enabled) {
        if (enabled) {
            this.batch = true;
            this.stopEditing(void 0, $437b23f6a393c3bf$var$CANCEL_PARAMS);
        } else {
            this.stopEditing(void 0, $437b23f6a393c3bf$var$CANCEL_PARAMS);
            this.batch = false;
        }
    }
    createStrategy(editType) {
        const { beans: beans, gos: gos, strategy: strategy } = this;
        const name = editType ?? gos.get("editType") ?? "singleCell";
        if (strategy) {
            if (strategy.beanName === name) return strategy;
            this.destroyStrategy();
        }
        return this.strategy = this.createOptionalManagedBean(beans.registry.createDynamicBean(name, true));
    }
    destroyStrategy() {
        if (!this.strategy) return;
        this.strategy.destroy();
        this.strategy = this.destroyBean(this.strategy);
    }
    shouldStartEditing(position, event, cellStartedEdit, source = "ui") {
        this.strategy ?? (this.strategy = this.createStrategy());
        return this.strategy?.shouldStart(position, event, cellStartedEdit, source) ?? null;
    }
    shouldStopEditing(position, event, source = "ui") {
        return this.strategy?.shouldStop(position, event, source) ?? null;
    }
    shouldCancelEditing(position, event, source = "ui") {
        return this.strategy?.shouldCancel(position, event, source) ?? null;
    }
    validateEdit() {
        return $437b23f6a393c3bf$var$_validateEdit(this.beans);
    }
    isEditing(position, params) {
        return this.model.hasEdits(position, params ?? $437b23f6a393c3bf$var$CHECK_SIBLING);
    }
    isRowEditing(rowNode, params) {
        return (rowNode && this.model.hasRowEdits(rowNode, params)) ?? false;
    }
    /** @returns whether to prevent default on event */ startEditing(position, params) {
        const { startedEdit: startedEdit = true, event: event = null, source: source = "ui", ignoreEventKey: ignoreEventKey = false, silent: silent } = params;
        this.strategy ?? (this.strategy = this.createStrategy());
        if (!this.isCellEditable(position, "api")) return;
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, position);
        if (cellCtrl && !cellCtrl.comp) {
            cellCtrl.onCompAttachedFuncs.push(()=>this.startEditing(position, params));
            return;
        }
        const res = this.shouldStartEditing?.(position, event, startedEdit, source);
        if (res === false && source !== "api") {
            this.isEditing(position) && this.stopEditing();
            return;
        }
        if (!this.batch && this.shouldStopEditing(position, void 0, source)) this.stopEditing(void 0, {
            source: source
        });
        if (res && this.isBatchEditing()) this.dispatchBatchEvent("batchEditingStarted", /* @__PURE__ */ new Map());
        this.strategy.start({
            position: position,
            event: event,
            source: source,
            ignoreEventKey: ignoreEventKey,
            startedEdit: startedEdit,
            silent: silent
        });
        return;
    }
    stopEditing(position, params) {
        const { event: event, cancel: cancel, source: source = "ui", suppressNavigateAfterEdit: suppressNavigateAfterEdit } = params || {};
        const { beans: beans, model: model } = this;
        if ($437b23f6a393c3bf$var$STOP_EDIT_SOURCE_TRANSFORM_KEYS.has(source)) {
            if (this.isBatchEditing()) {
                this.bulkRefresh(position);
                return false;
            }
        }
        const treatAsSource = this.committing ? $437b23f6a393c3bf$var$STOP_EDIT_SOURCE_TRANSFORM[source] : source;
        const isEditingOrBatchWithEdits = this.committing || this.isEditing(position) || this.isBatchEditing() && model.hasEdits(position, $437b23f6a393c3bf$var$CHECK_SIBLING);
        if (!isEditingOrBatchWithEdits || !this.strategy) return false;
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, position);
        if (cellCtrl) cellCtrl.onEditorAttachedFuncs = [];
        let edits = model.getEditMap(true);
        let res = false;
        const willStop = !cancel && (!!this.shouldStopEditing(position, event, treatAsSource) || this.committing && !this.batch);
        const willCancel = cancel && !!this.shouldCancelEditing(position, event, treatAsSource);
        if (willStop || willCancel) {
            $437b23f6a393c3bf$var$_syncFromEditors(beans, true);
            const freshEdits = model.getEditMap();
            this.processEdits(freshEdits, cancel, source);
            this.strategy?.stop(cancel, event);
            this.bulkRefresh(void 0, edits);
            edits = freshEdits;
            res || (res = willStop);
        } else if (event instanceof KeyboardEvent && this.batch && this.strategy?.midBatchInputsAllowed(position) && this.isEditing(position, {
            withOpenEditor: true
        })) {
            const key = event.key;
            const isEnter = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER;
            const isEscape = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE;
            const isTab = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB;
            if (isEnter || isTab || isEscape) {
                if (isEnter || isTab) $437b23f6a393c3bf$var$_syncFromEditors(beans, true);
                else if (isEscape) this.revertSingleCellEdit(cellCtrl);
                if (this.isBatchEditing()) this.strategy?.cleanupEditors();
                else $437b23f6a393c3bf$var$_destroyEditors(beans, model.getEditPositions(), {
                    event: event
                });
                event.preventDefault();
                this.bulkRefresh(position, edits, {
                    suppressFlash: true
                });
                edits = model.getEditMap();
            }
        } else {
            $437b23f6a393c3bf$var$_syncFromEditors(beans, true);
            edits = model.getEditMap();
        }
        if (res && position) this.model.removeEdits(position);
        if (!suppressNavigateAfterEdit && cellCtrl) this.navigateAfterEdit(event instanceof KeyboardEvent && event.shiftKey, cellCtrl.cellPosition);
        $437b23f6a393c3bf$var$_purgeUnchangedEdits(beans);
        if (!this.model.hasEdits()) {
            this.model.getCellValidationModel().clearCellValidationMap();
            this.model.getRowValidationModel().clearRowValidationMap();
        }
        this.bulkRefresh();
        if (willCancel) this.beans.rowRenderer.refreshRows({
            rowNodes: Array.from(edits.keys())
        });
        if (this.isBatchEditing()) {
            this.beans.rowRenderer.refreshRows({
                suppressFlash: true,
                force: true
            });
            if (res && willStop) this.dispatchBatchEvent("batchEditingStopped", edits);
        }
        return res;
    }
    navigateAfterEdit(shiftKey, cellPosition) {
        const navAfterEdit = this.gos.get("enterNavigatesVerticallyAfterEdit");
        if (navAfterEdit) {
            const key = shiftKey ? $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP : $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
            this.beans.navigation?.navigateToNextCell(null, key, cellPosition, false);
        }
    }
    processEdits(edits, cancel = false, source) {
        const rowNodes = Array.from(edits.keys());
        const { beans: beans } = this;
        const hasValidationErrors = this.model.getCellValidationModel().getCellValidationMap().size > 0 || this.model.getRowValidationModel().getRowValidationMap().size > 0;
        const editsToDelete = [];
        for (const rowNode of rowNodes){
            const editRow = edits.get(rowNode);
            for (const column of editRow.keys()){
                const editValue = editRow.get(column);
                const position = {
                    rowNode: rowNode,
                    column: column
                };
                const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, position);
                const valueChanged = $437b23f6a393c3bf$var$_sourceAndPendingDiffer(editValue);
                const isCancelAfterEnd = cellCtrl?.comp?.getCellEditor()?.isCancelAfterEnd?.();
                if (!cancel && !isCancelAfterEnd && valueChanged && !hasValidationErrors) {
                    const success = this.setNodeDataValue(rowNode, column, editValue.pendingValue, void 0, source);
                    if (!success) editsToDelete.push(position);
                }
                cellCtrl?.refreshCell($437b23f6a393c3bf$var$FORCE_REFRESH);
            }
        }
        editsToDelete.forEach((position)=>{
            this.model.clearEditValue(position);
        });
    }
    setNodeDataValue(rowNode, column, newValue, refreshCell, originalSource) {
        const { beans: beans } = this;
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, {
            rowNode: rowNode,
            column: column
        });
        if (cellCtrl) cellCtrl.suppressRefreshCell = true;
        this.commitNextEdit();
        const success = rowNode.setDataValue(column, newValue, originalSource === "ui" ? "edit" : originalSource);
        if (cellCtrl) cellCtrl.suppressRefreshCell = false;
        if (refreshCell) cellCtrl?.refreshCell($437b23f6a393c3bf$var$FORCE_REFRESH);
        return success;
    }
    setEditMap(edits, params) {
        this.strategy ?? (this.strategy = this.createStrategy());
        this.strategy?.setEditMap(edits, params);
        this.bulkRefresh();
        this.beans.rowRenderer.refreshCells($437b23f6a393c3bf$var$FORCE_REFRESH);
    }
    dispatchEditValuesChanged({ rowNode: rowNode, column: column }, edit = {}) {
        if (!rowNode || !column || !edit) return;
        const { pendingValue: pendingValue, sourceValue: sourceValue } = edit;
        const { rowIndex: rowIndex, rowPinned: rowPinned, data: data } = rowNode;
        this.beans.eventSvc.dispatchEvent({
            type: "cellEditValuesChanged",
            node: rowNode,
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            column: column,
            source: "api",
            data: data,
            newValue: pendingValue,
            oldValue: sourceValue,
            value: pendingValue,
            colDef: column.getColDef()
        });
    }
    bulkRefresh(position = {}, editMap, params = {}) {
        const { beans: beans, gos: gos } = this;
        const { editModelSvc: editModelSvc, rowModel: rowModel } = beans;
        if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) {
            if (position.rowNode && position.column) this.refCell(position, this.model.getEdit(position), params);
            else if (editMap) editModelSvc?.getEditMap(false)?.forEach((editRow, rowNode)=>{
                for (const column of editRow.keys())this.refCell({
                    rowNode: rowNode,
                    column: column
                }, editRow.get(column), params);
            });
        }
    }
    refCell({ rowNode: rowNode, column: column }, edit, params = {}) {
        const { beans: beans, gos: gos } = this;
        const updatedNodes = /* @__PURE__ */ new Set([
            rowNode
        ]);
        const refreshNodes = /* @__PURE__ */ new Set();
        const pinnedSibling = rowNode.pinnedSibling;
        if (pinnedSibling) updatedNodes.add(pinnedSibling);
        const sibling = rowNode.sibling;
        if (sibling) refreshNodes.add(sibling);
        let parent = rowNode.parent;
        while(parent){
            if (parent.sibling?.footer && gos.get("groupTotalRow")) refreshNodes.add(parent.sibling);
            else if (!parent.parent && parent.sibling && gos.get("grandTotalRow")) refreshNodes.add(parent.sibling);
            else refreshNodes.add(parent);
            parent = parent.parent;
        }
        updatedNodes.forEach((node)=>this.dispatchEditValuesChanged({
                rowNode: node,
                column: column
            }, edit));
        updatedNodes.forEach((node)=>$437b23f6a393c3bf$var$_getCellCtrl(beans, {
                rowNode: node,
                column: column
            })?.refreshCell(params));
        refreshNodes.forEach((node)=>$437b23f6a393c3bf$var$_getCellCtrl(beans, {
                rowNode: node,
                column: column
            })?.refreshCell(params));
    }
    stopAllEditing(cancel = false, source = "ui") {
        if (this.isEditing()) this.stopEditing(void 0, {
            cancel: cancel,
            source: source
        });
    }
    isCellEditable(position, source = "ui") {
        const { rowNode: rowNode } = position;
        if (rowNode.group) {
            if (this.gos.get("treeData")) {
                if (!rowNode.data && !this.gos.get("enableGroupEdit")) return false;
            } else {
                if (!this.gos.get("enableGroupEdit")) return false;
            }
        }
        this.strategy ?? (this.strategy = this.createStrategy());
        return this.strategy?.isCellEditable(position, source) ?? false;
    }
    cellEditingInvalidCommitBlocks() {
        return this.gos.get("invalidEditValueMode") === "block";
    }
    checkNavWithValidation(position, event, focus = true) {
        if (this.hasValidationErrors(position)) {
            const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, position);
            if (this.cellEditingInvalidCommitBlocks()) {
                event?.preventDefault?.();
                if (focus) {
                    !cellCtrl?.hasBrowserFocus() && cellCtrl?.focusCell();
                    cellCtrl?.comp?.getCellEditor()?.focusIn?.();
                }
                return "block-stop";
            }
            cellCtrl && this.revertSingleCellEdit(cellCtrl);
            return "revert-continue";
        }
        return "continue";
    }
    revertSingleCellEdit(cellPosition, focus = false) {
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, cellPosition);
        if (!cellCtrl?.comp?.getCellEditor()) return;
        $437b23f6a393c3bf$var$_destroyEditors(this.beans, [
            cellPosition
        ], {
            silent: true
        });
        this.model.clearEditValue(cellPosition);
        $437b23f6a393c3bf$var$_setupEditor(this.beans, cellPosition, {
            silent: true
        });
        $437b23f6a393c3bf$var$_populateModelValidationErrors(this.beans);
        cellCtrl?.refreshCell($437b23f6a393c3bf$var$FORCE_REFRESH);
        cellCtrl.rowCtrl.rowEditStyleFeature?.applyRowStyles();
        if (!focus) return;
        cellCtrl?.focusCell();
        cellCtrl?.comp?.getCellEditor()?.focusIn?.();
    }
    hasValidationErrors(position) {
        $437b23f6a393c3bf$var$_populateModelValidationErrors(this.beans);
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, position);
        if (cellCtrl) {
            cellCtrl.refreshCell($437b23f6a393c3bf$var$FORCE_REFRESH);
            cellCtrl.rowCtrl.rowEditStyleFeature?.applyRowStyles();
        }
        let invalid = false;
        if (position?.rowNode) {
            invalid || (invalid = this.model.getRowValidationModel().hasRowValidation({
                rowNode: position.rowNode
            }));
            if (position.column) invalid || (invalid = this.model.getCellValidationModel().hasCellValidation({
                rowNode: position.rowNode,
                column: position.column
            }));
        } else {
            invalid || (invalid = this.model.getCellValidationModel().getCellValidationMap().size > 0);
            invalid || (invalid = this.model.getRowValidationModel().getRowValidationMap().size > 0);
        }
        return invalid;
    }
    moveToNextCell(prev, backwards, event, source = "ui") {
        let res;
        const editing = this.isEditing();
        const preventNavigation = editing && this.checkNavWithValidation(void 0, event) === "block-stop";
        if (prev instanceof $437b23f6a393c3bf$var$CellCtrl && editing) res = this.strategy?.moveToNextEditingCell(prev, backwards, event, source, preventNavigation);
        if (res === null) return res;
        res = res || !!this.beans.focusSvc.focusedHeader;
        if (res === false && !preventNavigation) this.stopEditing();
        return res;
    }
    getCellDataValue({ rowNode: rowNode, column: column }, preferEditor = true) {
        if (!rowNode || !column) return void 0;
        let edit = this.model.getEdit({
            rowNode: rowNode,
            column: column
        });
        const pinnedSibling = rowNode.pinnedSibling;
        if (pinnedSibling) {
            const siblingEdit = this.model.getEdit({
                rowNode: pinnedSibling,
                column: column
            });
            if (siblingEdit) edit = siblingEdit;
        }
        const newValue = preferEditor ? edit?.editorValue ?? edit?.pendingValue : edit?.pendingValue;
        return newValue === $437b23f6a393c3bf$var$UNEDITED || !edit ? this.valueSvc.getValue(column, rowNode, true, "api") : newValue;
    }
    getRowDataValue(rowNode, params) {
        return this.model.getEditRowDataValue(rowNode, params);
    }
    addStopEditingWhenGridLosesFocus(viewports) {
        $437b23f6a393c3bf$var$_addStopEditingWhenGridLosesFocus(this, this.beans, viewports);
    }
    createPopupEditorWrapper(params) {
        return new $437b23f6a393c3bf$var$PopupEditorWrapper(params);
    }
    commitNextEdit() {
        this.committing = true;
    }
    setDataValue(position, newValue, eventSource) {
        try {
            if ((!this.isEditing() || this.committing) && !$437b23f6a393c3bf$var$SET_DATA_SOURCE_AS_API.has(eventSource)) return;
            const { beans: beans } = this;
            this.strategy ?? (this.strategy = this.createStrategy());
            const source = this.isBatchEditing() ? "ui" : this.committing ? eventSource ?? "api" : "api";
            if (!eventSource || $437b23f6a393c3bf$var$KEEP_EDITOR_SOURCES.has(eventSource)) {
                $437b23f6a393c3bf$var$_syncFromEditor(beans, position, true, newValue, eventSource);
                return this.setNodeDataValue(position.rowNode, position.column, newValue, true, eventSource);
            }
            const existing = this.model.getEdit(position);
            if (existing) {
                if (existing.pendingValue === newValue) return false;
                if (existing.sourceValue !== newValue) {
                    $437b23f6a393c3bf$var$_syncFromEditor(beans, position, true, newValue, eventSource);
                    this.stopEditing(position, {
                        source: source,
                        suppressNavigateAfterEdit: true
                    });
                    return true;
                }
                if (existing.sourceValue === newValue) {
                    beans.editModelSvc?.removeEdits(position);
                    this.dispatchEditValuesChanged(position, {
                        ...existing,
                        pendingValue: newValue
                    });
                    return true;
                }
            }
            $437b23f6a393c3bf$var$_syncFromEditor(beans, position, true, newValue, eventSource);
            this.stopEditing(position, {
                source: source,
                suppressNavigateAfterEdit: true
            });
            return true;
        } finally{
            this.committing = false;
        }
    }
    handleColDefChanged(cellCtrl) {
        $437b23f6a393c3bf$var$_refreshEditorOnColDefChanged(this.beans, cellCtrl);
    }
    destroy() {
        this.model.clear();
        this.destroyStrategy();
        super.destroy();
    }
    prepDetailsDuringBatch(position, params) {
        if (!this.batch) return;
        const hasEdits = this.model.hasRowEdits(position.rowNode, $437b23f6a393c3bf$var$CHECK_SIBLING);
        if (!hasEdits) return;
        const { rowNode: rowNode, column: column } = position;
        const { compDetails: compDetails, valueToDisplay: valueToDisplay } = params;
        if (compDetails) {
            const { params: params2 } = compDetails;
            params2.data = this.model.getEditRowDataValue(rowNode, $437b23f6a393c3bf$var$CHECK_SIBLING);
            return {
                compDetails: compDetails
            };
        }
        const editRow = this.model.getEditRow(position.rowNode, $437b23f6a393c3bf$var$CHECK_SIBLING);
        if (valueToDisplay !== void 0 && editRow?.has(column)) return {
            valueToDisplay: this.valueSvc.getValue(column, rowNode)
        };
    }
    cleanupEditors() {
        this.strategy?.cleanupEditors();
    }
    dispatchCellEvent(position, event, type, payload) {
        this.strategy?.dispatchCellEvent(position, event, type, payload);
    }
    dispatchBatchEvent(type, edits) {
        this.eventSvc.dispatchEvent(this.createBatchEditEvent(type, edits));
    }
    createBatchEditEvent(type, edits) {
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            type: type,
            ...type === "batchEditingStopped" ? {
                changes: this.toEventChangeList(edits)
            } : {}
        });
    }
    toEventChangeList(edits) {
        return this.model.getEditPositions(edits).map((edit)=>({
                rowIndex: edit.rowNode.rowIndex,
                rowPinned: edit.rowNode.rowPinned,
                columnId: edit.column.getColId(),
                newValue: edit.pendingValue,
                oldValue: edit.sourceValue
            }));
    }
    applyBulkEdit({ rowNode: rowNode, column: column }, ranges) {
        if (!ranges || ranges.length === 0) return;
        const { beans: beans, rangeSvc: rangeSvc, valueSvc: valueSvc } = this;
        $437b23f6a393c3bf$var$_syncFromEditors(beans, true);
        const edits = this.model.getEditMap(true);
        const editValue = edits.get(rowNode)?.get(column)?.pendingValue;
        if (!this.batch) this.eventSvc.dispatchEvent({
            type: "bulkEditingStarted"
        });
        ranges.forEach((range)=>{
            rangeSvc?.forEachRowInRange(range, (position)=>{
                const rowNode2 = $437b23f6a393c3bf$export$d4675a60917db7b0(beans, position);
                if (rowNode2 === void 0) return;
                const editRow = edits.get(rowNode2) ?? /* @__PURE__ */ new Map();
                for (const column2 of range.columns){
                    if (!column2) continue;
                    if (this.isCellEditable({
                        rowNode: rowNode2,
                        column: column2
                    }, "api")) {
                        const sourceValue = valueSvc.getValue(column2, rowNode2, true, "api");
                        let pendingValue = valueSvc.parseValue(column2, rowNode2 ?? null, editValue, sourceValue);
                        if (Number.isNaN(pendingValue)) pendingValue = null;
                        editRow.set(column2, {
                            editorValue: void 0,
                            pendingValue: pendingValue,
                            sourceValue: sourceValue,
                            state: "changed"
                        });
                    }
                }
                if (editRow.size > 0) edits.set(rowNode2, editRow);
            });
            this.setEditMap(edits);
            if (this.batch) {
                this.cleanupEditors();
                $437b23f6a393c3bf$var$_purgeUnchangedEdits(beans);
                this.bulkRefresh();
                return;
            }
            this.commitNextEdit();
            this.stopEditing(void 0, {
                source: "bulk"
            });
            this.eventSvc.dispatchEvent({
                type: "bulkEditingStopped",
                changes: this.toEventChangeList(edits)
            });
        });
        this.bulkRefresh();
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, {
            rowNode: rowNode,
            column: column
        });
        if (cellCtrl) cellCtrl.focusCell(true);
    }
    createCellStyleFeature(cellCtrl, beans) {
        return new $437b23f6a393c3bf$var$CellEditStyleFeature(cellCtrl, beans);
    }
    createRowStyleFeature(rowCtrl, beans) {
        return new $437b23f6a393c3bf$var$RowEditStyleFeature(rowCtrl, beans);
    }
    setEditingCells(cells, params) {
        const { beans: beans } = this;
        const { colModel: colModel, valueSvc: valueSvc } = beans;
        const edits = /* @__PURE__ */ new Map();
        cells.forEach(({ colId: colId, column: column, colKey: colKey, rowIndex: rowIndex, rowPinned: rowPinned, newValue: pendingValue, state: state })=>{
            const col = colId ? colModel.getCol(colId) : colKey ? colModel.getCol(colKey) : column;
            if (!col) return;
            const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(beans, {
                rowIndex: rowIndex,
                rowPinned: rowPinned
            });
            if (!rowNode) return;
            const sourceValue = valueSvc.getValue(col, rowNode, true, "api");
            if (!$437b23f6a393c3bf$var$_sourceAndPendingDiffer({
                pendingValue: pendingValue,
                sourceValue: sourceValue
            }) && state !== "editing") return;
            let editRow = edits.get(rowNode);
            if (!editRow) {
                editRow = /* @__PURE__ */ new Map();
                edits.set(rowNode, editRow);
            }
            if (pendingValue === void 0) pendingValue = $437b23f6a393c3bf$var$UNEDITED;
            editRow.set(col, {
                editorValue: void 0,
                pendingValue: pendingValue,
                sourceValue: sourceValue,
                state: state ?? "changed"
            });
        });
        this.setEditMap(edits, params);
    }
    onCellFocused(event) {
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, event);
        if (!cellCtrl || !this.isEditing(cellCtrl, $437b23f6a393c3bf$var$CHECK_SIBLING)) return;
        const edit = this.model.getEdit(cellCtrl);
        if (!edit || !$437b23f6a393c3bf$var$_sourceAndPendingDiffer(edit)) return;
        const translate = this.getLocaleTextFunc();
        const label = translate("ariaPendingChange", "Pending Change");
        this.beans.ariaAnnounce?.announceValue(label, "pendingChange");
    }
    allowedFocusTargetOnValidation(cellPosition) {
        return $437b23f6a393c3bf$var$_getCellCtrl(this.beans, cellPosition);
    }
};
// packages/ag-grid-community/src/edit/strategy/baseEditStrategy.ts
var $437b23f6a393c3bf$var$BaseEditStrategy = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        this.model = this.beans.editModelSvc;
        this.editSvc = this.beans.editSvc;
        this.addManagedEventListeners({
            cellFocused: this.onCellFocusChanged?.bind(this),
            cellFocusCleared: this.onCellFocusChanged?.bind(this)
        });
    }
    clearEdits(position) {
        this.model.clearEditValue(position);
    }
    onCellFocusChanged(event) {
        let cellCtrl;
        const previous = event["previousParams"];
        const { editSvc: editSvc, beans: beans } = this;
        const sourceEvent = event.type === "cellFocused" ? event.sourceEvent : null;
        if (previous) cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, previous);
        const { gos: gos, editModelSvc: editModelSvc } = beans;
        const isFocusCleared = event.type === "cellFocusCleared";
        if (editSvc.isEditing(void 0, {
            withOpenEditor: true
        })) {
            const { column: column, rowIndex: rowIndex, rowPinned: rowPinned } = event;
            const cellPositionFromEvent = {
                column: column,
                rowNode: $437b23f6a393c3bf$export$d4675a60917db7b0(beans, {
                    rowIndex: rowIndex,
                    rowPinned: rowPinned
                })
            };
            const isBlock = gos.get("invalidEditValueMode") === "block";
            if (isBlock) return;
            const shouldRevert = !isBlock;
            const hasError = !!editModelSvc?.getCellValidationModel().hasCellValidation(cellPositionFromEvent);
            const shouldCancel = shouldRevert && hasError;
            const result = previous || isFocusCleared ? editSvc.stopEditing(void 0, {
                cancel: shouldCancel,
                source: isFocusCleared && shouldRevert ? "api" : void 0,
                event: sourceEvent
            }) : true;
            if (!result) {
                if (editSvc.isBatchEditing()) editSvc.cleanupEditors();
                else editSvc.stopEditing(void 0, {
                    source: "api"
                });
            }
        }
        cellCtrl?.refreshCell({
            suppressFlash: true,
            force: true
        });
    }
    isCellEditable({ rowNode: rowNode, column: column }, _source = "ui") {
        return column.isColumnFunc(rowNode, column.getColDef().editable);
    }
    stop(cancel, event) {
        const editingCells = this.model.getEditPositions();
        const results = {
            all: [],
            pass: [],
            fail: []
        };
        editingCells.forEach((cell)=>{
            results.all.push(cell);
            const validation2 = this.model.getCellValidationModel().getCellValidation(cell);
            if ((validation2?.errorMessages?.length ?? 0) > 0) {
                results.fail.push(cell);
                return;
            }
            results.pass.push(cell);
        });
        if (cancel) {
            editingCells.forEach((cell)=>{
                $437b23f6a393c3bf$var$_destroyEditor(this.beans, cell);
                this.model.stop(cell);
            });
            return true;
        }
        const actions = this.processValidationResults(results);
        if (actions.destroy.length > 0) actions.destroy.forEach((cell)=>{
            $437b23f6a393c3bf$var$_destroyEditor(this.beans, cell, {
                event: event
            });
            this.model.stop(cell);
        });
        if (actions.keep.length > 0) actions.keep.forEach((cell)=>{
            const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, cell);
            if (!this.editSvc?.cellEditingInvalidCommitBlocks()) cellCtrl && this.editSvc.revertSingleCellEdit(cellCtrl);
        });
        return true;
    }
    cleanupEditors({ rowNode: rowNode } = {}, includeEditing) {
        $437b23f6a393c3bf$var$_syncFromEditors(this.beans, false);
        const positions = this.model.getEditPositions();
        const discard = [];
        if (rowNode) positions.forEach((pos)=>{
            if (!(!rowNode || pos.rowNode === rowNode)) discard.push(pos);
        });
        else positions.forEach((pos)=>{
            discard.push(pos);
        });
        $437b23f6a393c3bf$var$_destroyEditors(this.beans, discard);
        $437b23f6a393c3bf$var$_purgeUnchangedEdits(this.beans, includeEditing);
    }
    setFocusOutOnEditor(cellCtrl) {
        cellCtrl.comp?.getCellEditor()?.focusOut?.();
    }
    setFocusInOnEditor(cellCtrl) {
        const comp = cellCtrl.comp;
        const editor = comp?.getCellEditor();
        if (editor?.focusIn) editor.focusIn();
        else {
            const isFullRow = this.beans.gos.get("editType") === "fullRow";
            cellCtrl.focusCell(isFullRow);
            cellCtrl.onEditorAttachedFuncs.push(()=>comp?.getCellEditor()?.focusIn?.());
        }
    }
    setupEditors(params) {
        const { event: event, ignoreEventKey: ignoreEventKey = false, startedEdit: startedEdit, position: position, cells: cells = this.model.getEditPositions() } = params;
        const key = event instanceof KeyboardEvent && !ignoreEventKey && event.key || void 0;
        $437b23f6a393c3bf$var$_setupEditors(this.beans, cells, position, key, event, startedEdit);
    }
    dispatchCellEvent(position, event, type, payload) {
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, position);
        if (cellCtrl) this.eventSvc.dispatchEvent({
            ...cellCtrl.createEvent(event ?? null, type),
            ...payload
        });
    }
    dispatchRowEvent(position, type, silent) {
        if (silent) return;
        const rowCtrl = $437b23f6a393c3bf$var$_getRowCtrl(this.beans, position);
        if (rowCtrl) this.eventSvc.dispatchEvent(rowCtrl.createRowEvent(type));
    }
    shouldStart({ column: column }, event, cellStartedEdit, source = "ui") {
        if (event instanceof KeyboardEvent && (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB || event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER || event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2 || event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE && cellStartedEdit)) return true;
        const extendingRange = event?.shiftKey && this.beans.rangeSvc?.getCellRanges().length != 0;
        if (extendingRange) return false;
        const colDef = column?.getColDef();
        const clickCount = this.deriveClickCount(colDef);
        const type = event?.type;
        if (type === "click" && event?.detail === 1 && clickCount === 1) return true;
        if (type === "dblclick" && event?.detail === 2 && clickCount === 2) return true;
        if (source === "api") return cellStartedEdit ?? false;
        return false;
    }
    shouldStop(_position, event, source = "ui") {
        const batch = this.editSvc.isBatchEditing();
        if (batch && source === "api") return true;
        if (batch && source === "ui") return false;
        if (source === "api") return true;
        if (event instanceof KeyboardEvent && !batch) return event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER;
        return null;
    }
    shouldCancel(_position, event, source = "ui") {
        const batch = this.editSvc.isBatchEditing();
        if (event instanceof KeyboardEvent && !batch) {
            const result = event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE;
            if (result) return true;
        }
        if (batch && source === "api") return true;
        if (source === "api") return true;
        return false;
    }
    setEditMap(edits, params) {
        if (!params?.update) this.editSvc.stopEditing(void 0, {
            cancel: true,
            source: "api"
        });
        const cells = [];
        edits.forEach((editRow, rowNode)=>{
            editRow.forEach((cellData, column)=>{
                if (cellData.state === "editing") cells.push({
                    ...cellData,
                    rowNode: rowNode,
                    column: column
                });
            });
        });
        if (params?.update) edits = new Map([
            ...this.model.getEditMap(),
            ...edits
        ]);
        this.model?.setEditMap(edits);
        if (cells.length > 0) {
            const position = cells.at(-1);
            const key = position.pendingValue === $437b23f6a393c3bf$var$UNEDITED ? void 0 : position.pendingValue;
            this.start({
                position: position,
                event: new KeyboardEvent("keydown", {
                    key: key
                }),
                source: "api"
            });
            const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, position);
            if (cellCtrl) this.setFocusInOnEditor(cellCtrl);
        }
    }
    deriveClickCount(colDef) {
        const { gos: gos } = this.beans;
        if (gos.get("suppressClickEdit") === true) return 0;
        if (gos.get("singleClickEdit") === true) return 1;
        if (colDef?.singleClickEdit) return 1;
        return 2;
    }
    destroy() {
        this.cleanupEditors();
        super.destroy();
    }
};
// packages/ag-grid-community/src/edit/strategy/fullRowEditStrategy.ts
var $437b23f6a393c3bf$var$FullRowEditStrategy = class extends $437b23f6a393c3bf$var$BaseEditStrategy {
    constructor(){
        super(...arguments);
        this.beanName = "fullRow";
        this.startedRows = [];
    }
    isCellEditable(position, source = "ui") {
        const editable = super.isCellEditable(position, source);
        if (editable === true || source === "ui") return editable;
        const columns = this.beans.colModel.getCols();
        return columns.some((col)=>super.isCellEditable({
                rowNode: position.rowNode,
                column: col
            }, source));
    }
    shouldStop(position, event, _source = "ui") {
        const { rowNode: rowNode } = position || {};
        const oldRowCtrl = $437b23f6a393c3bf$var$_getRowCtrl(this.beans, {
            rowNode: this.rowNode
        });
        if (!oldRowCtrl) return true;
        const res = super.shouldStop({
            rowNode: this.rowNode
        }, event, _source);
        if (res !== null) return res;
        if (!this.rowNode) return false;
        return rowNode !== this.rowNode;
    }
    midBatchInputsAllowed({ rowNode: rowNode }) {
        if (!rowNode) return false;
        return this.model.hasEdits({
            rowNode: rowNode
        });
    }
    clearEdits(position) {
        this.model.clearEditValue(position);
    }
    start(params) {
        const { position: position, silent: silent, startedEdit: startedEdit, event: event, ignoreEventKey: ignoreEventKey } = params;
        const { rowNode: rowNode } = position;
        if (this.rowNode !== rowNode) super.cleanupEditors(position);
        this.dispatchRowEvent({
            rowNode: rowNode
        }, "rowEditingStarted", silent);
        this.startedRows.push(rowNode);
        const columns = this.beans.visibleCols.allCols;
        const cells = [];
        columns.forEach((column)=>{
            if (!column.isCellEditable(rowNode)) return;
            const position2 = {
                rowNode: rowNode,
                column: column
            };
            cells.push(position2);
            if (!this.model.hasEdits(position2)) this.model.start(position2);
        });
        this.rowNode = rowNode;
        this.setupEditors({
            cells: cells,
            position: position,
            startedEdit: startedEdit,
            event: event,
            ignoreEventKey: ignoreEventKey
        });
    }
    processValidationResults(results) {
        const anyFailed = results.fail.length > 0;
        if (anyFailed && this.editSvc.cellEditingInvalidCommitBlocks()) return {
            destroy: [],
            keep: results.all
        };
        return {
            destroy: results.all,
            keep: []
        };
    }
    stop(cancel, event) {
        const { rowNode: rowNode } = this;
        if (rowNode && !this.model.hasRowEdits(rowNode)) return false;
        const changedRows = [];
        if (!cancel) this.model.getEditMap().forEach((rowEdits, rowNode2)=>{
            if (!rowEdits || rowEdits.size === 0) return;
            for (const edit of rowEdits.values())if ($437b23f6a393c3bf$var$_sourceAndPendingDiffer(edit)) {
                changedRows.push(rowNode2);
                break;
            }
        });
        $437b23f6a393c3bf$var$_populateModelValidationErrors(this.beans);
        if (!cancel && this.editSvc?.checkNavWithValidation({
            rowNode: rowNode
        }) === "block-stop") return false;
        super.stop(cancel, event);
        changedRows.forEach((rowNode2)=>this.dispatchRowEvent({
                rowNode: rowNode2
            }, "rowValueChanged"));
        this.cleanupEditors({
            rowNode: rowNode
        }, true);
        this.rowNode = void 0;
        return true;
    }
    onCellFocusChanged(event) {
        const { rowIndex: rowIndex } = event;
        const prev = event["previousParams"];
        if (prev?.rowIndex === rowIndex || event.sourceEvent instanceof KeyboardEvent) return;
        const prevCell = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, prev);
        const isBlock = this.gos.get("invalidEditValueMode") === "block";
        if (isBlock && prevCell && (this.model.getCellValidationModel().getCellValidation(prevCell) || this.model.getRowValidationModel().getRowValidation(prevCell))) return;
        super.onCellFocusChanged(event);
    }
    cleanupEditors(position = {}, includeEditing) {
        super.cleanupEditors(position, includeEditing);
        this.startedRows.forEach((rowNode)=>this.dispatchRowEvent({
                rowNode: rowNode
            }, "rowEditingStopped"));
        this.startedRows.length = 0;
    }
    // returns null if no navigation should be performed
    moveToNextEditingCell(prevCell, backwards, event, source = "ui", preventNavigation = false) {
        const prevPos = prevCell.cellPosition;
        let nextCell;
        this.model.suspend(true);
        try {
            nextCell = this.beans.navigation?.findNextCellToFocusOn(prevPos, {
                backwards: backwards,
                startEditing: true,
                // Default behaviour for fullRow is skip to the next cell,
                // editable or not. FullRow editing might have some editable
                // and some not editable cells in the row.
                // More complex logic needed to skip to the
                // next FullRow editable cell,
                skipToNextEditableCell: false
            });
        } finally{
            this.model.suspend(false);
        }
        if (nextCell === false) return null;
        if (nextCell == null) return false;
        const nextPos = nextCell.cellPosition;
        const prevEditable = prevCell.isCellEditable();
        const nextEditable = nextCell.isCellEditable();
        const rowsMatch = nextPos && prevPos.rowIndex === nextPos.rowIndex && prevPos.rowPinned === nextPos.rowPinned;
        if (prevEditable) this.setFocusOutOnEditor(prevCell);
        this.restoreEditors();
        const suppressStartEditOnTab = this.gos.get("suppressStartEditOnTab");
        if (nextEditable && !preventNavigation) {
            if (suppressStartEditOnTab) nextCell.focusCell(true, event);
            else {
                if (!nextCell.comp?.getCellEditor()) $437b23f6a393c3bf$var$_setupEditor(this.beans, nextCell, {
                    event: event,
                    cellStartedEdit: true
                });
                this.setFocusInOnEditor(nextCell);
                nextCell.focusCell(false, event);
            }
        } else {
            if (nextEditable && preventNavigation) this.setFocusInOnEditor(nextCell);
            nextCell.focusCell(true, event);
        }
        if (!rowsMatch && !preventNavigation) {
            this.cleanupEditors(nextCell, true);
            if (suppressStartEditOnTab) nextCell.focusCell(true, event);
            else this.editSvc.startEditing(nextCell, {
                startedEdit: true,
                event: event,
                source: source,
                ignoreEventKey: true
            });
        }
        prevCell.rowCtrl?.refreshRow({
            suppressFlash: true,
            force: true
        });
        return true;
    }
    restoreEditors() {
        this.model.getEditMap().forEach((rowEdits, rowNode)=>rowEdits.forEach(({ state: state }, column)=>{
                if (state !== "editing") return;
                const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, {
                    rowNode: rowNode,
                    column: column
                });
                if (cellCtrl && !cellCtrl.comp?.getCellEditor()) $437b23f6a393c3bf$var$_setupEditor(this.beans, cellCtrl, {
                    silent: true
                });
            }));
    }
    destroy() {
        super.destroy();
        this.rowNode = void 0;
        this.startedRows.length = 0;
    }
};
// packages/ag-grid-community/src/edit/strategy/singleCellEditStrategy.ts
var $437b23f6a393c3bf$var$SingleCellEditStrategy = class extends $437b23f6a393c3bf$var$BaseEditStrategy {
    constructor(){
        super(...arguments);
        this.beanName = "singleCell";
    }
    shouldStop(position, event, source = "ui") {
        const res = super.shouldStop(position, event, source);
        if (res !== null) return res;
        const { rowNode: rowNode, column: column } = position || {};
        if ((!this.rowNode || !this.column) && rowNode && column) return null;
        return this.rowNode !== rowNode || this.column !== column;
    }
    midBatchInputsAllowed(position) {
        return this.model.hasEdits(position);
    }
    start(params) {
        const { position: position, startedEdit: startedEdit, event: event, ignoreEventKey: ignoreEventKey } = params;
        if (this.rowNode !== position.rowNode || this.column !== position.column) super.cleanupEditors();
        this.rowNode = position.rowNode;
        this.column = position.column;
        this.model.start(position);
        this.setupEditors({
            cells: [
                position
            ],
            position: position,
            startedEdit: startedEdit,
            event: event,
            ignoreEventKey: ignoreEventKey
        });
    }
    dispatchRowEvent(_position, _type, _silent) {}
    processValidationResults(results) {
        const anyFailed = results.fail.length > 0;
        if (anyFailed && this.editSvc.cellEditingInvalidCommitBlocks()) return {
            destroy: [],
            keep: results.all
        };
        return {
            destroy: results.all,
            keep: []
        };
    }
    stop(cancel, event) {
        super.stop(cancel, event);
        this.rowNode = void 0;
        this.column = void 0;
        return true;
    }
    onCellFocusChanged(event) {
        const { colModel: colModel, editSvc: editSvc } = this.beans;
        const { rowIndex: rowIndex, column: column, rowPinned: rowPinned } = event;
        const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        });
        const curColId = $437b23f6a393c3bf$var$_getColId(column);
        const curCol = colModel.getCol(curColId);
        const previous = event["previousParams"];
        if (previous) {
            const prevColId = $437b23f6a393c3bf$var$_getColId(previous.column);
            if (previous?.rowIndex === rowIndex && prevColId === curColId && previous?.rowPinned === rowPinned) return;
        }
        if (editSvc?.isEditing({
            rowNode: rowNode,
            column: curCol
        }, {
            withOpenEditor: true
        }) && event.type === "cellFocused") return;
        super.onCellFocusChanged(event);
    }
    // returns null if no navigation should be performed
    moveToNextEditingCell(prevCell, backwards, event, source = "ui", preventNavigation = false) {
        const prevPos = prevCell.cellPosition;
        let nextCell;
        const shouldSuspend = this.beans.gos.get("editType") === "fullRow";
        if (shouldSuspend) this.model.suspend(true);
        if (!preventNavigation) {
            prevCell.eGui.focus();
            this.editSvc?.stopEditing(prevCell, {
                source: this.editSvc?.isBatchEditing() ? "ui" : "api",
                event: event
            });
        }
        try {
            nextCell = this.beans.navigation?.findNextCellToFocusOn(prevPos, {
                backwards: backwards,
                startEditing: true
            });
        } finally{
            if (shouldSuspend) this.model.suspend(false);
        }
        if (nextCell === false) return null;
        if (nextCell == null) return false;
        const nextPos = nextCell.cellPosition;
        const prevEditable = prevCell.isCellEditable();
        const nextEditable = nextCell.isCellEditable();
        const rowsMatch = nextPos && prevPos.rowIndex === nextPos.rowIndex && prevPos.rowPinned === nextPos.rowPinned;
        if (prevEditable && !preventNavigation) this.setFocusOutOnEditor(prevCell);
        const suppressStartEditOnTab = this.gos.get("suppressStartEditOnTab");
        if (!rowsMatch && !preventNavigation) {
            super.cleanupEditors(nextCell, true);
            if (suppressStartEditOnTab) nextCell.focusCell(true, event);
            else this.editSvc.startEditing(nextCell, {
                startedEdit: true,
                event: event,
                source: source,
                ignoreEventKey: true
            });
        }
        if (nextEditable && !preventNavigation) {
            nextCell.focusCell(false, event);
            if (suppressStartEditOnTab) nextCell.focusCell(true, event);
            else if (!nextCell.comp?.getCellEditor()) {
                $437b23f6a393c3bf$var$_setupEditor(this.beans, nextCell, {
                    event: event,
                    cellStartedEdit: true,
                    silent: true
                });
                this.setFocusInOnEditor(nextCell);
                this.cleanupEditors(nextCell);
            }
        } else {
            if (nextEditable && preventNavigation) this.setFocusInOnEditor(nextCell);
            nextCell.focusCell(true, event);
        }
        prevCell.rowCtrl?.refreshRow({
            suppressFlash: true,
            force: true
        });
        return true;
    }
    destroy() {
        super.destroy();
        this.rowNode = void 0;
        this.column = void 0;
    }
};
// packages/ag-grid-community/src/edit/editModule.ts
var $437b23f6a393c3bf$export$12c61a50add34259 = {
    moduleName: "EditCore",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$EditModelService,
        $437b23f6a393c3bf$var$EditService
    ],
    apiFunctions: {
        getEditingCells: $437b23f6a393c3bf$var$getEditingCells,
        getCellEditorInstances: $437b23f6a393c3bf$var$getCellEditorInstances,
        startEditingCell: $437b23f6a393c3bf$var$startEditingCell,
        stopEditing: $437b23f6a393c3bf$var$stopEditing,
        isEditing: $437b23f6a393c3bf$var$isEditing,
        validateEdit: $437b23f6a393c3bf$var$validateEdit
    },
    dynamicBeans: {
        singleCell: $437b23f6a393c3bf$var$SingleCellEditStrategy,
        fullRow: $437b23f6a393c3bf$var$FullRowEditStrategy
    },
    dependsOn: [
        $437b23f6a393c3bf$export$da5c9bb998e6c24d,
        $437b23f6a393c3bf$export$d0c662c133b8814e
    ],
    css: [
        $437b23f6a393c3bf$var$cellEditingCSS
    ]
};
var $437b23f6a393c3bf$export$2bb59c6ee8834731 = {
    moduleName: "UndoRedoEdit",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$UndoRedoService
    ],
    apiFunctions: {
        undoCellEditing: $437b23f6a393c3bf$var$undoCellEditing,
        redoCellEditing: $437b23f6a393c3bf$var$redoCellEditing,
        getCurrentUndoSize: $437b23f6a393c3bf$var$getCurrentUndoSize,
        getCurrentRedoSize: $437b23f6a393c3bf$var$getCurrentRedoSize
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$5e6636bea954ad4e = {
    moduleName: "TextEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agCellEditor: $437b23f6a393c3bf$var$TextCellEditor,
        agTextCellEditor: $437b23f6a393c3bf$var$TextCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$9bc83f811986c4f2 = {
    moduleName: "NumberEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agNumberCellEditor: {
            classImp: $437b23f6a393c3bf$var$NumberCellEditor
        }
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$d1dd3475f4d98a27 = {
    moduleName: "DateEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agDateCellEditor: $437b23f6a393c3bf$var$DateCellEditor,
        agDateStringCellEditor: $437b23f6a393c3bf$var$DateStringCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$b6d3a45586965934 = {
    moduleName: "CheckboxEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agCheckboxCellEditor: $437b23f6a393c3bf$var$CheckboxCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$ccaa44b10c75f1d = {
    moduleName: "SelectEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agSelectCellEditor: $437b23f6a393c3bf$var$SelectCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$e1b6b5aa47694f20 = {
    moduleName: "LargeTextEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agLargeTextCellEditor: $437b23f6a393c3bf$var$LargeTextCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$e1d2707568ed81f6 = {
    moduleName: "CustomEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
// packages/ag-grid-community/src/columns/selectionColService.ts
var $437b23f6a393c3bf$var$SelectionColService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "selectionColSvc";
    }
    postConstruct() {
        this.addManagedPropertyListener("rowSelection", (event)=>{
            this.onSelectionOptionsChanged(event.currentValue, event.previousValue, $437b23f6a393c3bf$export$eb2a92b6162267d1(event.source));
        });
        this.addManagedPropertyListener("selectionColumnDef", this.updateColumns.bind(this));
    }
    addColumns(cols) {
        const selectionCols = this.columns;
        if (selectionCols == null) return;
        cols.list = selectionCols.list.concat(cols.list);
        cols.tree = selectionCols.tree.concat(cols.tree);
        $437b23f6a393c3bf$export$c82fd63ff1738bed(cols);
    }
    createColumns(cols, updateOrders) {
        const destroyCollection = ()=>{
            $437b23f6a393c3bf$export$dbaaa57234b60d8f(this.beans, this.columns?.tree);
            this.columns = null;
        };
        const newTreeDepth = cols.treeDepth;
        const oldTreeDepth = this.columns?.treeDepth ?? -1;
        const treeDepthSame = oldTreeDepth == newTreeDepth;
        const list = this.generateSelectionCols();
        const areSame = $437b23f6a393c3bf$export$f56e341a1fe35ed4(list, this.columns?.list ?? []);
        if (areSame && treeDepthSame) return;
        destroyCollection();
        const { colGroupSvc: colGroupSvc } = this.beans;
        const treeDepth = colGroupSvc?.findDepth(cols.tree) ?? 0;
        const tree = colGroupSvc?.balanceTreeForAutoCols(list, treeDepth) ?? [];
        this.columns = {
            list: list,
            tree: tree,
            treeDepth: treeDepth,
            map: {}
        };
        const putSelectionColsFirstInList = (cols2)=>{
            if (!cols2) return null;
            const colsFiltered = cols2.filter((col)=>!$437b23f6a393c3bf$export$f6074a9792015c5d(col));
            return [
                ...list,
                ...colsFiltered
            ];
        };
        updateOrders(putSelectionColsFirstInList);
    }
    updateColumns(event) {
        const source = $437b23f6a393c3bf$export$eb2a92b6162267d1(event.source);
        this.columns?.list.forEach((col)=>{
            const newColDef = this.createSelectionColDef(event.currentValue);
            col.setColDef(newColDef, null, source);
            $437b23f6a393c3bf$export$b2854c1cb8f10386(this.beans, {
                state: [
                    {
                        ...newColDef,
                        colId: col.getColId()
                    }
                ]
            }, source);
        });
    }
    getColumn(key) {
        return this.columns?.list.find((col)=>$437b23f6a393c3bf$export$f5687d41c39fa1b3(col, key)) ?? null;
    }
    getColumns() {
        return this.columns?.list ?? null;
    }
    isSelectionColumnEnabled() {
        const { gos: gos, beans: beans } = this;
        const rowSelection = gos.get("rowSelection");
        if (typeof rowSelection !== "object" || !$437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos)) return false;
        const hasAutoCols = (beans.autoColSvc?.getColumns()?.length ?? 0) > 0;
        if (rowSelection.checkboxLocation === "autoGroupColumn" && hasAutoCols) return false;
        const checkboxes = !!$437b23f6a393c3bf$export$6df3a55606bca6ae(rowSelection);
        const headerCheckbox = $437b23f6a393c3bf$export$e92e75627785d7a4(rowSelection);
        return checkboxes || headerCheckbox;
    }
    createSelectionColDef(def) {
        const { gos: gos } = this.beans;
        const selectionColumnDef = def ?? gos.get("selectionColumnDef");
        const enableRTL = gos.get("enableRtl");
        const { rowSpan: _, spanRows: __, ...filteredSelColDef } = selectionColumnDef ?? {};
        return {
            // overridable properties
            width: 50,
            resizable: false,
            suppressHeaderMenuButton: true,
            sortable: false,
            suppressMovable: true,
            lockPosition: enableRTL ? "right" : "left",
            comparator (valueA, valueB, nodeA, nodeB) {
                const aSelected = nodeA.isSelected();
                const bSelected = nodeB.isSelected();
                return aSelected === bSelected ? 0 : aSelected ? 1 : -1;
            },
            editable: false,
            suppressFillHandle: true,
            pinned: null,
            // overrides
            ...filteredSelColDef,
            // non-overridable properties
            colId: $437b23f6a393c3bf$export$dd05e5f089eb2421,
            chartDataType: "excluded"
        };
    }
    generateSelectionCols() {
        if (!this.isSelectionColumnEnabled()) return [];
        const colDef = this.createSelectionColDef();
        const colId = colDef.colId;
        this.gos.validateColDef(colDef, colId, true);
        const col = new $437b23f6a393c3bf$export$a8da3e2b83e5ddf2(colDef, null, colId, false);
        this.createBean(col);
        return [
            col
        ];
    }
    onSelectionOptionsChanged(current, prev, source) {
        const prevCheckbox = prev && typeof prev !== "string" ? $437b23f6a393c3bf$export$6df3a55606bca6ae(prev) : void 0;
        const currCheckbox = current && typeof current !== "string" ? $437b23f6a393c3bf$export$6df3a55606bca6ae(current) : void 0;
        const checkboxHasChanged = prevCheckbox !== currCheckbox;
        const prevHeaderCheckbox = prev && typeof prev !== "string" ? $437b23f6a393c3bf$export$e92e75627785d7a4(prev) : void 0;
        const currHeaderCheckbox = current && typeof current !== "string" ? $437b23f6a393c3bf$export$e92e75627785d7a4(current) : void 0;
        const headerCheckboxHasChanged = prevHeaderCheckbox !== currHeaderCheckbox;
        const currLocation = $437b23f6a393c3bf$export$8fb5d781b5c28347(current);
        const prevLocation = $437b23f6a393c3bf$export$8fb5d781b5c28347(prev);
        const locationChanged = currLocation !== prevLocation;
        if (checkboxHasChanged || headerCheckboxHasChanged || locationChanged) this.beans.colModel.refreshAll(source);
    }
    destroy() {
        $437b23f6a393c3bf$export$dbaaa57234b60d8f(this.beans, this.columns?.tree);
        super.destroy();
    }
    /**
   * Refreshes visibility of the selection column based on which columns are currently visible.
   * Called by the VisibleColsService with the columns that are currently visible in left/center/right
   * containers. This method *MUTATES* those arrays directly.
   *
   * The selection column should be visible if all of the following are true
   * - The selection column is not disabled
   * - The number of visible columns excluding the selection column and row numbers column is greater than 0
   * @param leftCols Visible columns in the left-pinned container
   * @param centerCols Visible columns in the center viewport
   * @param rightCols Visible columns in the right-pinned container
   */ refreshVisibility(leftCols, centerCols, rightCols) {
        if (!this.columns?.list.length) return;
        const numVisibleCols = leftCols.length + centerCols.length + rightCols.length;
        if (numVisibleCols === 0) return;
        const column = this.columns.list[0];
        if (!column.isVisible()) return;
        const hideSelectionCol = ()=>{
            let cols;
            switch(column.pinned){
                case "left":
                case true:
                    cols = leftCols;
                    break;
                case "right":
                    cols = rightCols;
                    break;
                default:
                    cols = centerCols;
            }
            cols && $437b23f6a393c3bf$export$83a881c8b5120679(cols, column);
        };
        const rowNumbersCol = this.beans.rowNumbersSvc?.getColumn($437b23f6a393c3bf$export$f55c01dfb205b029);
        const expectedNumCols = rowNumbersCol ? 2 : 1;
        if (expectedNumCols === numVisibleCols) hideSelectionCol();
    }
};
// packages/ag-grid-community/src/selection/rowSelectionApi.ts
function $437b23f6a393c3bf$var$setNodesSelected(beans, params) {
    const allNodesValid = params.nodes.every((node)=>{
        if (node.rowPinned && !$437b23f6a393c3bf$var$_isManualPinnedRow(node)) {
            $437b23f6a393c3bf$export$545083624300f13d(59);
            return false;
        }
        if (node.id === void 0) {
            $437b23f6a393c3bf$export$545083624300f13d(60);
            return false;
        }
        return true;
    });
    if (!allNodesValid) return;
    const { nodes: nodes, source: source, newValue: newValue } = params;
    beans.selectionSvc?.setNodesSelected({
        nodes: nodes,
        source: source ?? "api",
        newValue: newValue
    });
}
function $437b23f6a393c3bf$var$selectAll(beans, selectAll2, source = "apiSelectAll") {
    beans.selectionSvc?.selectAllRowNodes({
        source: source,
        selectAll: selectAll2
    });
}
function $437b23f6a393c3bf$var$deselectAll(beans, selectAll2, source = "apiSelectAll") {
    beans.selectionSvc?.deselectAllRowNodes({
        source: source,
        selectAll: selectAll2
    });
}
function $437b23f6a393c3bf$var$selectAllFiltered(beans, source = "apiSelectAllFiltered") {
    beans.selectionSvc?.selectAllRowNodes({
        source: source,
        selectAll: "filtered"
    });
}
function $437b23f6a393c3bf$var$deselectAllFiltered(beans, source = "apiSelectAllFiltered") {
    beans.selectionSvc?.deselectAllRowNodes({
        source: source,
        selectAll: "filtered"
    });
}
function $437b23f6a393c3bf$var$selectAllOnCurrentPage(beans, source = "apiSelectAllCurrentPage") {
    beans.selectionSvc?.selectAllRowNodes({
        source: source,
        selectAll: "currentPage"
    });
}
function $437b23f6a393c3bf$var$deselectAllOnCurrentPage(beans, source = "apiSelectAllCurrentPage") {
    beans.selectionSvc?.deselectAllRowNodes({
        source: source,
        selectAll: "currentPage"
    });
}
function $437b23f6a393c3bf$var$getSelectedNodes(beans) {
    return beans.selectionSvc?.getSelectedNodes() ?? [];
}
function $437b23f6a393c3bf$var$getSelectedRows(beans) {
    return beans.selectionSvc?.getSelectedRows() ?? [];
}
// packages/ag-grid-community/src/selection/selectionService.ts
var $437b23f6a393c3bf$var$SelectionService = class extends $437b23f6a393c3bf$export$3d7b168c0c9c2a78 {
    constructor(){
        super(...arguments);
        this.beanName = "selectionSvc";
        this.selectedNodes = /* @__PURE__ */ new Map();
        /** Only used to track detail grid selection state when master/detail is enabled */ this.detailSelection = /* @__PURE__ */ new Map();
        this.masterSelectsDetail = false;
    }
    postConstruct() {
        super.postConstruct();
        const { gos: gos } = this;
        this.mode = $437b23f6a393c3bf$export$80b6607444b3274f(gos);
        this.groupSelectsDescendants = $437b23f6a393c3bf$export$460e5745f0e6a40d(gos);
        this.groupSelectsFiltered = $437b23f6a393c3bf$export$673080972d8c733e(gos) === "filteredDescendants";
        this.masterSelectsDetail = $437b23f6a393c3bf$var$_getMasterSelects(gos) === "detail";
        this.addManagedPropertyListeners([
            "groupSelectsChildren",
            "groupSelectsFiltered",
            "rowSelection"
        ], ()=>{
            const groupSelectsDescendants = $437b23f6a393c3bf$export$460e5745f0e6a40d(gos);
            const selectionMode = $437b23f6a393c3bf$export$80b6607444b3274f(gos);
            const groupSelectsFiltered = $437b23f6a393c3bf$export$673080972d8c733e(gos) === "filteredDescendants";
            this.masterSelectsDetail = $437b23f6a393c3bf$var$_getMasterSelects(gos) === "detail";
            if (groupSelectsDescendants !== this.groupSelectsDescendants || groupSelectsFiltered !== this.groupSelectsFiltered || selectionMode !== this.mode) {
                this.deselectAllRowNodes({
                    source: "api"
                });
                this.groupSelectsDescendants = groupSelectsDescendants;
                this.groupSelectsFiltered = groupSelectsFiltered;
                this.mode = selectionMode;
            }
        });
        this.addManagedEventListeners({
            rowSelected: this.onRowSelected.bind(this)
        });
    }
    destroy() {
        super.destroy();
        this.resetNodes();
    }
    handleSelectionEvent(event, rowNode, source) {
        if (this.isRowSelectionBlocked(rowNode)) return 0;
        const selection = this.inferNodeSelections(rowNode, event.shiftKey, event.metaKey || event.ctrlKey, source);
        if (selection == null) return 0;
        this.selectionCtx.selectAll = false;
        if ("select" in selection) {
            if (selection.reset) this.resetNodes();
            else this.selectRange(selection.deselect, false, source);
            return this.selectRange(selection.select, true, source);
        } else return this.setNodesSelected({
            nodes: [
                selection.node
            ],
            newValue: selection.newValue,
            clearSelection: selection.clearSelection,
            keepDescendants: selection.keepDescendants,
            event: event,
            source: source
        });
    }
    setNodesSelected({ newValue: newValue, clearSelection: clearSelection, suppressFinishActions: suppressFinishActions, nodes: nodes, event: event, source: source, keepDescendants: keepDescendants = false }) {
        if (!$437b23f6a393c3bf$export$5d5fd838f5df1dd2(this.gos) && newValue) {
            $437b23f6a393c3bf$export$545083624300f13d(132);
            return 0;
        }
        if (nodes.length === 0) return 0;
        if (nodes.length > 1 && !this.isMultiSelect()) {
            $437b23f6a393c3bf$export$545083624300f13d(130);
            return 0;
        }
        let updatedCount = 0;
        for(let i = 0; i < nodes.length; i++){
            const rowNode = nodes[i];
            const node = $437b23f6a393c3bf$var$_normaliseSiblingRef(rowNode);
            const skipThisNode = this.groupSelectsFiltered && node.group;
            if (node.rowPinned && !$437b23f6a393c3bf$var$_isManualPinnedRow(node)) {
                $437b23f6a393c3bf$export$545083624300f13d(59);
                continue;
            }
            if (node.id === void 0) {
                $437b23f6a393c3bf$export$545083624300f13d(60);
                continue;
            }
            if (!skipThisNode) {
                const thisNodeWasSelected = this.selectRowNode(node, newValue, event, source);
                if (thisNodeWasSelected) {
                    this.detailSelection.delete(node.id);
                    updatedCount++;
                }
            }
            if (this.groupSelectsDescendants && node.childrenAfterGroup?.length) updatedCount += this.selectChildren(node, newValue, source);
        }
        if (!suppressFinishActions) {
            if (nodes.length === 1 && source === "api") this.selectionCtx.setRoot($437b23f6a393c3bf$var$_normaliseSiblingRef(nodes[0]));
            const clearOtherNodes = newValue && (clearSelection || !this.isMultiSelect());
            if (clearOtherNodes) updatedCount += this.clearOtherNodes($437b23f6a393c3bf$var$_normaliseSiblingRef(nodes[0]), keepDescendants, source);
            if (updatedCount > 0) {
                this.updateGroupsFromChildrenSelections(source);
                this.dispatchSelectionChanged(source);
            }
        }
        return updatedCount;
    }
    // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
    // holding down 'shift'.
    selectRange(nodesToSelect, value, source) {
        let updatedCount = 0;
        nodesToSelect.forEach((node)=>{
            const rowNode = $437b23f6a393c3bf$var$_normaliseSiblingRef(node);
            if (rowNode.group && this.groupSelectsDescendants) return;
            const nodeWasSelected = this.selectRowNode(rowNode, value, void 0, source);
            if (nodeWasSelected) updatedCount++;
        });
        if (updatedCount > 0) {
            this.updateGroupsFromChildrenSelections(source);
            this.dispatchSelectionChanged(source);
        }
        return updatedCount;
    }
    selectChildren(node, newValue, source) {
        const children = this.groupSelectsFiltered ? node.childrenAfterAggFilter : node.childrenAfterGroup;
        if (!children) return 0;
        return this.setNodesSelected({
            newValue: newValue,
            clearSelection: false,
            suppressFinishActions: true,
            source: source,
            nodes: children
        });
    }
    getSelectedNodes() {
        return Array.from(this.selectedNodes.values());
    }
    getSelectedRows() {
        const selectedRows = [];
        this.selectedNodes.forEach((rowNode)=>rowNode.data && selectedRows.push(rowNode.data));
        return selectedRows;
    }
    getSelectionCount() {
        return this.selectedNodes.size;
    }
    /**
   * This method is used by the CSRM to remove groups which are being disposed of,
   * events do not need fired in this case
   */ filterFromSelection(predicate) {
        const newSelectedNodes = /* @__PURE__ */ new Map();
        this.selectedNodes.forEach((rowNode, key)=>{
            if (predicate(rowNode)) newSelectedNodes.set(key, rowNode);
        });
        this.selectedNodes = newSelectedNodes;
    }
    updateGroupsFromChildrenSelections(source, changedPath) {
        if (!this.groupSelectsDescendants) return false;
        const { gos: gos, rowModel: rowModel } = this.beans;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) return false;
        const rootNode = rowModel.rootNode;
        if (!rootNode) return false;
        if (!changedPath) {
            changedPath = new $437b23f6a393c3bf$export$cb4d9114a9732e85(true, rootNode);
            changedPath.active = false;
        }
        let selectionChanged = false;
        changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
            if (rowNode !== rootNode) {
                const selected = this.calculateSelectedFromChildren(rowNode);
                selectionChanged = this.selectRowNode(rowNode, selected === null ? false : selected, void 0, source) || selectionChanged;
            }
        });
        return selectionChanged;
    }
    clearOtherNodes(rowNodeToKeepSelected, keepDescendants, source) {
        const groupsToRefresh = /* @__PURE__ */ new Map();
        let updatedCount = 0;
        this.selectedNodes.forEach((otherRowNode)=>{
            const isNodeToKeep = otherRowNode.id == rowNodeToKeepSelected.id;
            const shouldClearDescendant = keepDescendants ? !$437b23f6a393c3bf$var$isDescendantOf(rowNodeToKeepSelected, otherRowNode) : true;
            if (shouldClearDescendant && !isNodeToKeep) {
                const rowNode = this.selectedNodes.get(otherRowNode.id);
                updatedCount += this.setNodesSelected({
                    nodes: [
                        rowNode
                    ],
                    newValue: false,
                    clearSelection: false,
                    suppressFinishActions: true,
                    source: source
                });
                if (this.groupSelectsDescendants && otherRowNode.parent) groupsToRefresh.set(otherRowNode.parent.id, otherRowNode.parent);
            }
        });
        groupsToRefresh.forEach((group)=>{
            const selected = this.calculateSelectedFromChildren(group);
            this.selectRowNode(group, selected === null ? false : selected, void 0, source);
        });
        return updatedCount;
    }
    onRowSelected(event) {
        const rowNode = event.node;
        if (this.groupSelectsDescendants && rowNode.group) return;
        if (rowNode.isSelected()) this.selectedNodes.set(rowNode.id, rowNode);
        else this.selectedNodes.delete(rowNode.id);
    }
    syncInRowNode(rowNode, oldNode) {
        this.syncInOldRowNode(rowNode, oldNode);
        this.syncInNewRowNode(rowNode);
    }
    createDaemonNode(rowNode) {
        if (!rowNode.id) return void 0;
        const oldNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
        oldNode.id = rowNode.id;
        oldNode.data = rowNode.data;
        oldNode.__daemon = true;
        oldNode.__selected = rowNode.__selected;
        oldNode.level = rowNode.level;
        return oldNode;
    }
    // if the id has changed for the node, then this means the rowNode
    // is getting used for a different data item, which breaks
    // our selectedNodes, as the node now is mapped by the old id
    // which is inconsistent. so to keep the old node as selected,
    // we swap in the clone (with the old id and old data). this means
    // the oldNode is effectively a daemon we keep a reference to,
    // so if client calls api.getSelectedNodes(), it gets the daemon
    // in the result. when the client un-selects, the reference to the
    // daemon is removed. the daemon, because it's an oldNode, is not
    // used by the grid for rendering, it's a copy of what the node used
    // to be like before the id was changed.
    syncInOldRowNode(rowNode, oldNode) {
        if (oldNode && rowNode.id !== oldNode.id) {
            const oldNodeSelected = this.selectedNodes.get(oldNode.id) == rowNode;
            if (oldNodeSelected) this.selectedNodes.set(oldNode.id, oldNode);
        }
    }
    syncInNewRowNode(rowNode) {
        if (this.selectedNodes.has(rowNode.id)) {
            rowNode.__selected = true;
            this.selectedNodes.set(rowNode.id, rowNode);
        } else rowNode.__selected = false;
    }
    reset(source) {
        const selectionCount = this.getSelectionCount();
        this.resetNodes();
        if (selectionCount) this.dispatchSelectionChanged(source);
    }
    resetNodes() {
        this.selectedNodes.forEach((node)=>{
            this.selectRowNode(node, false);
        });
        this.selectedNodes.clear();
    }
    // returns a list of all nodes at 'best cost' - a feature to be used
    // with groups / trees. if a group has all it's children selected,
    // then the group appears in the result, but not the children.
    // Designed for use with 'children' as the group selection type,
    // where groups don't actually appear in the selection normally.
    getBestCostNodeSelection() {
        const { gos: gos, rowModel: rowModel } = this.beans;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) return;
        const topLevelNodes = rowModel.getTopLevelNodes();
        if (topLevelNodes === null) return;
        const result = [];
        function traverse(nodes) {
            for(let i = 0, l = nodes.length; i < l; i++){
                const node = nodes[i];
                if (node.isSelected()) result.push(node);
                else if (node.group && node.childrenAfterGroup) traverse(node.childrenAfterGroup);
            }
        }
        traverse(topLevelNodes);
        return result;
    }
    isEmpty() {
        return this.getSelectionCount() === 0;
    }
    deselectAllRowNodes({ source: source, selectAll: selectAll2 }) {
        const rowModelClientSide = $437b23f6a393c3bf$export$9f182d9ca737e15(this.gos);
        let updatedNodes = false;
        const callback = (rowNode)=>{
            const updated = this.selectRowNode($437b23f6a393c3bf$var$_normaliseSiblingRef(rowNode), false, void 0, source);
            updatedNodes || (updatedNodes = updated);
        };
        if (selectAll2 === "currentPage" || selectAll2 === "filtered") {
            if (!rowModelClientSide) {
                $437b23f6a393c3bf$export$a20c7248650823a9(102);
                return;
            }
            this.getNodesToSelect(selectAll2).forEach(callback);
        } else {
            this.selectedNodes.forEach(callback);
            this.reset(source);
        }
        this.selectionCtx.selectAll = false;
        if (rowModelClientSide && this.groupSelectsDescendants) {
            const updated = this.updateGroupsFromChildrenSelections(source);
            updatedNodes || (updatedNodes = updated);
        }
        if (updatedNodes) this.dispatchSelectionChanged(source);
    }
    getSelectedCounts(selectAll2) {
        let selectedCount = 0;
        let notSelectedCount = 0;
        this.getNodesToSelect(selectAll2).forEach((node)=>{
            if (this.groupSelectsDescendants && node.group) return;
            if (node.isSelected()) selectedCount++;
            else if (node.selectable) notSelectedCount++;
        });
        return {
            selectedCount: selectedCount,
            notSelectedCount: notSelectedCount
        };
    }
    getSelectAllState(selectAll2) {
        const { selectedCount: selectedCount, notSelectedCount: notSelectedCount } = this.getSelectedCounts(selectAll2);
        return $437b23f6a393c3bf$var$_calculateSelectAllState(selectedCount, notSelectedCount) ?? null;
    }
    hasNodesToSelect(selectAll2) {
        return this.getNodesToSelect(selectAll2).filter((node)=>node.selectable).length > 0;
    }
    /**
   * @param selectAll See `MultiRowSelectionOptions.selectAll`
   * @returns all nodes including unselectable nodes which are the target of this selection attempt
   */ getNodesToSelect(selectAll2) {
        if (!this.canSelectAll()) return [];
        const nodes = [];
        const addToResult = (node)=>nodes.push(node);
        if (selectAll2 === "currentPage") {
            this.forEachNodeOnPage((node)=>{
                if (!node.group) {
                    addToResult(node);
                    return;
                }
                if (!node.expanded && !node.footer) {
                    const recursivelyAddChildren = (child)=>{
                        addToResult(child);
                        child.childrenAfterFilter?.forEach(recursivelyAddChildren);
                    };
                    recursivelyAddChildren(node);
                    return;
                }
                if (!this.groupSelectsDescendants) addToResult(node);
            });
            return nodes;
        }
        const clientSideRowModel = this.beans.rowModel;
        if (selectAll2 === "filtered") {
            clientSideRowModel.forEachNodeAfterFilter(addToResult);
            return nodes;
        }
        clientSideRowModel.forEachNode(addToResult);
        return nodes;
    }
    forEachNodeOnPage(callback) {
        const { pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const firstRow = pageBounds.getFirstRow();
        const lastRow = pageBounds.getLastRow();
        for(let i = firstRow; i <= lastRow; i++){
            const node = rowModel.getRow(i);
            if (node) callback(node);
        }
    }
    selectAllRowNodes(params) {
        const { gos: gos, selectionCtx: selectionCtx } = this;
        if (!$437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos)) {
            $437b23f6a393c3bf$export$545083624300f13d(132);
            return;
        }
        if ($437b23f6a393c3bf$export$d3c80fcacb2e2d55(gos) && !$437b23f6a393c3bf$export$7bd8c52ebc4117d6(gos)) {
            $437b23f6a393c3bf$export$545083624300f13d(130);
            return;
        }
        if (!this.canSelectAll()) return;
        const { source: source, selectAll: selectAll2 } = params;
        let updatedNodes = false;
        this.getNodesToSelect(selectAll2).forEach((rowNode)=>{
            const updated = this.selectRowNode($437b23f6a393c3bf$var$_normaliseSiblingRef(rowNode), true, void 0, source);
            updatedNodes || (updatedNodes = updated);
        });
        selectionCtx.selectAll = true;
        if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos) && this.groupSelectsDescendants) {
            const updated = this.updateGroupsFromChildrenSelections(source);
            updatedNodes || (updatedNodes = updated);
        }
        if (updatedNodes) this.dispatchSelectionChanged(source);
    }
    getSelectionState() {
        return this.isEmpty() ? null : Array.from(this.selectedNodes.keys());
    }
    setSelectionState(state, source, clearSelection) {
        if (!state) state = [];
        if (!Array.isArray(state)) {
            $437b23f6a393c3bf$export$a20c7248650823a9(103);
            return;
        }
        const rowIds = new Set(state);
        const nodes = [];
        this.beans.rowModel.forEachNode((node)=>{
            if (rowIds.has(node.id)) nodes.push(node);
        });
        if (clearSelection) this.resetNodes();
        this.setNodesSelected({
            newValue: true,
            nodes: nodes,
            source: source
        });
    }
    canSelectAll() {
        const { gos: gos } = this.beans;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos)) return false;
        return true;
    }
    /**
   * Updates the selectable state for a node by invoking isRowSelectable callback.
   * If the node is not selectable, it will be deselected.
   *
   * Callers:
   *  - property isRowSelectable changed
   *  - after grouping / treeData via `updateSelectableAfterGrouping`
   */ updateSelectable(changedPath) {
        const { gos: gos, rowModel: rowModel } = this.beans;
        if (!$437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos)) return;
        const source = "selectableChanged";
        const skipLeafNodes = changedPath !== void 0;
        const isCSRMGroupSelectsDescendants = $437b23f6a393c3bf$export$9f182d9ca737e15(gos) && this.groupSelectsDescendants;
        const nodesToDeselect = [];
        const nodeCallback = (node)=>{
            if (skipLeafNodes && !node.group) return;
            if (isCSRMGroupSelectsDescendants && node.group) {
                const hasSelectableChild = node.childrenAfterGroup?.some((rowNode)=>rowNode.selectable) ?? false;
                this.setRowSelectable(node, hasSelectableChild, true);
                return;
            }
            const rowSelectable = this.updateRowSelectable(node, true);
            if (!rowSelectable && node.isSelected()) nodesToDeselect.push(node);
        };
        if (isCSRMGroupSelectsDescendants) {
            if (changedPath === void 0) {
                const rootNode = rowModel.rootNode;
                changedPath = rootNode ? new $437b23f6a393c3bf$export$cb4d9114a9732e85(false, rootNode) : void 0;
            }
            changedPath?.forEachChangedNodeDepthFirst(nodeCallback, !skipLeafNodes, !skipLeafNodes);
        } else rowModel.forEachNode(nodeCallback);
        if (nodesToDeselect.length) this.setNodesSelected({
            nodes: nodesToDeselect,
            newValue: false,
            source: source
        });
        if (!skipLeafNodes && isCSRMGroupSelectsDescendants) this.updateGroupsFromChildrenSelections?.(source);
    }
    // only called by CSRM
    updateSelectableAfterGrouping(changedPath) {
        this.updateSelectable(changedPath);
        if (this.groupSelectsDescendants) {
            const selectionChanged = this.updateGroupsFromChildrenSelections?.("rowGroupChanged", changedPath);
            if (selectionChanged) this.dispatchSelectionChanged("rowGroupChanged");
        }
    }
    refreshMasterNodeState(node, e) {
        if (!this.masterSelectsDetail) return;
        const detailApi = node.detailNode?.detailGridInfo?.api;
        if (!detailApi) return;
        const isSelectAll = $437b23f6a393c3bf$var$_isAllSelected(detailApi);
        const current = node.isSelected();
        if (current !== isSelectAll) {
            const selectionChanged = this.selectRowNode(node, isSelectAll, e, "masterDetail");
            if (selectionChanged) this.dispatchSelectionChanged("masterDetail");
        }
        if (!isSelectAll) {
            const detailSelected = this.detailSelection.get(node.id) ?? /* @__PURE__ */ new Set();
            for (const n of detailApi.getSelectedNodes())detailSelected.add(n.id);
            this.detailSelection.set(node.id, detailSelected);
        }
    }
    setDetailSelectionState(masterNode, detailGridOptions, detailApi) {
        if (!this.masterSelectsDetail) return;
        if (!$437b23f6a393c3bf$export$7bd8c52ebc4117d6(detailGridOptions)) {
            $437b23f6a393c3bf$export$545083624300f13d(269);
            return;
        }
        switch(masterNode.isSelected()){
            case true:
                detailApi.selectAll();
                break;
            case false:
                detailApi.deselectAll();
                break;
            case void 0:
                {
                    const selectedIds = this.detailSelection.get(masterNode.id);
                    if (selectedIds) {
                        const nodes = [];
                        for (const id of selectedIds){
                            const n = detailApi.getRowNode(id);
                            if (n) nodes.push(n);
                        }
                        detailApi.setNodesSelected({
                            nodes: nodes,
                            newValue: true,
                            source: "masterDetail"
                        });
                    }
                    break;
                }
            default:
                break;
        }
    }
    dispatchSelectionChanged(source) {
        this.eventSvc.dispatchEvent({
            type: "selectionChanged",
            source: source,
            selectedNodes: this.getSelectedNodes(),
            serverSideState: null
        });
    }
};
function $437b23f6a393c3bf$var$_normaliseSiblingRef(node) {
    return $437b23f6a393c3bf$var$_isManualPinnedRow(node) ? node.pinnedSibling : node.footer ? node.sibling : node;
}
function $437b23f6a393c3bf$var$_isAllSelected(api) {
    let selectedCount = 0;
    let notSelectedCount = 0;
    api.forEachNode((node)=>{
        if (node.isSelected()) selectedCount++;
        else if (node.selectable) notSelectedCount++;
    });
    return $437b23f6a393c3bf$var$_calculateSelectAllState(selectedCount, notSelectedCount);
}
function $437b23f6a393c3bf$var$_calculateSelectAllState(selected, notSelected) {
    if (selected === 0 && notSelected === 0) return false;
    if (selected > 0 && notSelected > 0) return;
    return selected > 0;
}
function $437b23f6a393c3bf$var$isDescendantOf(root, child) {
    let parent = child.parent;
    while(parent){
        if (parent === root) return true;
        parent = parent.parent;
    }
    return false;
}
// packages/ag-grid-community/src/selection/rowSelectionModule.ts
var $437b23f6a393c3bf$export$16cbd1164b82410d = {
    moduleName: "SharedRowSelection",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$SelectionColService
    ],
    apiFunctions: {
        setNodesSelected: $437b23f6a393c3bf$var$setNodesSelected,
        selectAll: $437b23f6a393c3bf$var$selectAll,
        deselectAll: $437b23f6a393c3bf$var$deselectAll,
        selectAllFiltered: $437b23f6a393c3bf$var$selectAllFiltered,
        deselectAllFiltered: $437b23f6a393c3bf$var$deselectAllFiltered,
        selectAllOnCurrentPage: $437b23f6a393c3bf$var$selectAllOnCurrentPage,
        deselectAllOnCurrentPage: $437b23f6a393c3bf$var$deselectAllOnCurrentPage,
        getSelectedNodes: $437b23f6a393c3bf$var$getSelectedNodes,
        getSelectedRows: $437b23f6a393c3bf$var$getSelectedRows
    }
};
var $437b23f6a393c3bf$export$dae0b5c1ba15d66f = {
    moduleName: "RowSelection",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "clientSide",
        "infinite",
        "viewport"
    ],
    beans: [
        $437b23f6a393c3bf$var$SelectionService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$16cbd1164b82410d
    ]
};
// packages/ag-grid-community/src/api/csrmSsrmSharedApi.ts
function $437b23f6a393c3bf$var$expandAll(beans) {
    beans.expansionSvc?.expandAll(true);
}
function $437b23f6a393c3bf$var$collapseAll(beans) {
    beans.expansionSvc?.expandAll(false);
}
function $437b23f6a393c3bf$var$onRowHeightChanged(beans) {
    const clientSideRowModel = $437b23f6a393c3bf$export$f5285e6f27a03f95(beans);
    const serverSideRowModel = $437b23f6a393c3bf$export$aada92189a74e985(beans);
    if (clientSideRowModel) clientSideRowModel.onRowHeightChanged();
    else if (serverSideRowModel) serverSideRowModel.onRowHeightChanged();
}
// packages/ag-grid-community/src/api/ssrmInfiniteSharedApi.ts
function $437b23f6a393c3bf$var$setRowCount(beans, rowCount, maxRowFound) {
    const serverSideRowModel = $437b23f6a393c3bf$export$aada92189a74e985(beans);
    if (serverSideRowModel) {
        if (beans.rowGroupColsSvc?.columns.length === 0) {
            if (rowCount < 0) {
                $437b23f6a393c3bf$export$a20c7248650823a9(238);
                return;
            }
            serverSideRowModel.setRowCount(rowCount, maxRowFound);
            return;
        }
        $437b23f6a393c3bf$export$a20c7248650823a9(28);
        return;
    }
    const infiniteRowModel = $437b23f6a393c3bf$var$_getInfiniteRowModel(beans);
    if (infiniteRowModel) {
        infiniteRowModel.setRowCount(rowCount, maxRowFound);
        return;
    }
}
function $437b23f6a393c3bf$var$getCacheBlockState(beans) {
    if ($437b23f6a393c3bf$export$cf1bac0013650216(beans.gos)) {
        const ssrm = beans.rowModel;
        return ssrm.getBlockStates();
    }
    return beans.rowNodeBlockLoader?.getBlockState() ?? {};
}
function $437b23f6a393c3bf$var$isLastRowIndexKnown(beans) {
    return beans.rowModel.isLastRowIndexKnown();
}
// packages/ag-grid-community/src/api/sharedApiModule.ts
var $437b23f6a393c3bf$export$76fb120d9e251426 = {
    moduleName: "CsrmSsrmSharedApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        expandAll: $437b23f6a393c3bf$var$expandAll,
        collapseAll: $437b23f6a393c3bf$var$collapseAll,
        onRowHeightChanged: $437b23f6a393c3bf$var$onRowHeightChanged
    }
};
var $437b23f6a393c3bf$export$2f6740e35dedc261 = {
    moduleName: "SsrmInfiniteSharedApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        setRowCount: $437b23f6a393c3bf$var$setRowCount,
        getCacheBlockState: $437b23f6a393c3bf$var$getCacheBlockState,
        isLastRowIndexKnown: $437b23f6a393c3bf$var$isLastRowIndexKnown
    }
};
// packages/ag-grid-community/src/alignedGrids/alignedGridsService.ts
var $437b23f6a393c3bf$var$AlignedGridsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "alignedGridsSvc";
        // flag to mark if we are consuming. to avoid cyclic events (ie other grid firing back to master
        // while processing a master event) we mark this if consuming an event, and if we are, then
        // we don't fire back any events.
        this.consuming = false;
    }
    getAlignedGridApis() {
        let alignedGrids = this.gos.get("alignedGrids") ?? [];
        const isCallbackConfig = typeof alignedGrids === "function";
        if (typeof alignedGrids === "function") alignedGrids = alignedGrids();
        const apis = alignedGrids.map((alignedGrid)=>{
            if (!alignedGrid) {
                $437b23f6a393c3bf$export$a20c7248650823a9(18);
                if (!isCallbackConfig) $437b23f6a393c3bf$export$a20c7248650823a9(20);
                return;
            }
            if (this.isGridApi(alignedGrid)) return alignedGrid;
            const refOrComp = alignedGrid;
            if ("current" in refOrComp) return refOrComp.current?.api;
            if (!refOrComp.api) $437b23f6a393c3bf$export$a20c7248650823a9(19);
            return refOrComp.api;
        }).filter((api)=>!!api && !api.isDestroyed());
        return apis;
    }
    isGridApi(ref) {
        return !!ref && !!ref.dispatchEvent;
    }
    postConstruct() {
        const fireColumnEvent = this.fireColumnEvent.bind(this);
        this.addManagedEventListeners({
            columnMoved: fireColumnEvent,
            columnVisible: fireColumnEvent,
            columnPinned: fireColumnEvent,
            columnGroupOpened: fireColumnEvent,
            columnResized: fireColumnEvent,
            bodyScroll: this.fireScrollEvent.bind(this),
            alignedGridColumn: ({ event: event })=>this.onColumnEvent(event),
            alignedGridScroll: ({ event: event })=>this.onScrollEvent(event)
        });
    }
    // common logic across all the fire methods
    fireEvent(event) {
        if (this.consuming) return;
        this.getAlignedGridApis().forEach((api)=>{
            if (api.isDestroyed()) return;
            api.dispatchEvent(event);
        });
    }
    // common logic across all consume methods. very little common logic, however extracting
    // guarantees consistency across the methods.
    onEvent(callback) {
        this.consuming = true;
        callback();
        this.consuming = false;
    }
    fireColumnEvent(columnEvent) {
        this.fireEvent({
            type: "alignedGridColumn",
            event: columnEvent
        });
    }
    fireScrollEvent(scrollEvent) {
        if (scrollEvent.direction !== "horizontal") return;
        this.fireEvent({
            type: "alignedGridScroll",
            event: scrollEvent
        });
    }
    onScrollEvent(event) {
        this.onEvent(()=>{
            this.beans.ctrlsSvc.getScrollFeature().setHorizontalScrollPosition(event.left, true);
        });
    }
    extractDataFromEvent(event, func) {
        const result = [];
        if (event.columns) event.columns.forEach((column)=>{
            result.push(func(column));
        });
        else if (event.column) result.push(func(event.column));
        return result;
    }
    getMasterColumns(event) {
        return this.extractDataFromEvent(event, (col)=>col);
    }
    getColumnIds(event) {
        return this.extractDataFromEvent(event, (col)=>col.getColId());
    }
    onColumnEvent(event) {
        this.onEvent(()=>{
            switch(event.type){
                case "columnMoved":
                case "columnVisible":
                case "columnPinned":
                case "columnResized":
                    this.processColumnEvent(event);
                    break;
                case "columnGroupOpened":
                    this.processGroupOpenedEvent(event);
                    break;
                case "columnPivotChanged":
                    $437b23f6a393c3bf$export$545083624300f13d(21);
                    break;
            }
        });
    }
    processGroupOpenedEvent(groupOpenedEvent) {
        const { colGroupSvc: colGroupSvc } = this.beans;
        if (!colGroupSvc) return;
        groupOpenedEvent.columnGroups.forEach((masterGroup)=>{
            let otherColumnGroup = null;
            if (masterGroup) otherColumnGroup = colGroupSvc.getProvidedColGroup(masterGroup.getGroupId());
            if (masterGroup && !otherColumnGroup) return;
            colGroupSvc.setColumnGroupOpened(otherColumnGroup, masterGroup.isExpanded(), "alignedGridChanged");
        });
    }
    processColumnEvent(colEvent) {
        const masterColumn = colEvent.column;
        let otherColumn = null;
        const beans = this.beans;
        const { colResize: colResize, ctrlsSvc: ctrlsSvc, colModel: colModel } = beans;
        if (masterColumn) otherColumn = colModel.getColDefCol(masterColumn.getColId());
        if (masterColumn && !otherColumn) return;
        const masterColumns = this.getMasterColumns(colEvent);
        switch(colEvent.type){
            case "columnMoved":
                {
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId
                        }));
                    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                        state: destColState,
                        applyOrder: true
                    }, "alignedGridChanged");
                }
                break;
            case "columnVisible":
                {
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId,
                            hide: s.hide
                        }));
                    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                        state: destColState
                    }, "alignedGridChanged");
                }
                break;
            case "columnPinned":
                {
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId,
                            pinned: s.pinned
                        }));
                    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                        state: destColState
                    }, "alignedGridChanged");
                }
                break;
            case "columnResized":
                {
                    const resizedEvent = colEvent;
                    const columnWidths = {};
                    masterColumns.forEach((column)=>{
                        columnWidths[column.getId()] = {
                            key: column.getColId(),
                            newWidth: column.getActualWidth()
                        };
                    });
                    resizedEvent.flexColumns?.forEach((col)=>{
                        if (columnWidths[col.getId()]) delete columnWidths[col.getId()];
                    });
                    colResize?.setColumnWidths(Object.values(columnWidths), false, resizedEvent.finished, "alignedGridChanged");
                    break;
                }
        }
        const gridBodyCon = ctrlsSvc.getGridBodyCtrl();
        const isVerticalScrollShowing = gridBodyCon.isVerticalScrollShowing();
        this.getAlignedGridApis().forEach((api)=>{
            api.setGridOption("alwaysShowVerticalScroll", isVerticalScrollShowing);
        });
    }
};
// packages/ag-grid-community/src/alignedGrids/alignedGridsModule.ts
var $437b23f6a393c3bf$export$a8c763073927f695 = {
    moduleName: "AlignedGrids",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AlignedGridsService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$5c4abee658e86c68
    ]
};
// packages/ag-grid-community/src/clientSideRowModel/clientSideNodeManager.ts
var $437b23f6a393c3bf$var$ClientSideNodeManager = class extends $437b23f6a393c3bf$export$4d7e4be6cbba058c {
    constructor(){
        super(...arguments);
        this.beanName = "csrmNodeSvc";
    }
};
// packages/ag-grid-community/src/clientSideRowModel/changedRowNodes.ts
var $437b23f6a393c3bf$var$ChangedRowNodes = class {
    constructor(){
        this.removals = /* @__PURE__ */ new Set();
        this.updates = /* @__PURE__ */ new Set();
        this.adds = /* @__PURE__ */ new Set();
    }
    /** Marks a row as removed. Order of operations is: remove, update, add */ remove(node) {
        if (!this.adds.delete(node)) {
            this.updates.delete(node);
            this.removals.add(node);
        }
    }
    /** Marks a row as updated. Order of operations is: remove, update, add */ update(node) {
        if (!this.adds.has(node)) this.updates.add(node);
    }
    /** Marks a row as added. Order of operation is: remove, update, add */ add(node) {
        this.adds.add(node);
    }
};
// packages/ag-grid-community/src/clientSideRowModel/sortStage.ts
function $437b23f6a393c3bf$var$updateChildIndexes(rowNode) {
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(rowNode.childrenAfterSort)) return;
    const listToSort = rowNode.childrenAfterSort;
    for(let i = 0; i < listToSort.length; i++){
        const child = listToSort[i];
        const firstChild = i === 0;
        const lastChild = i === rowNode.childrenAfterSort.length - 1;
        child.setFirstChild(firstChild);
        if (child.lastChild !== lastChild) {
            child.lastChild = lastChild;
            child.dispatchRowEvent("lastChildChanged");
        }
        if (child.childIndex !== i) {
            child.childIndex = i;
            child.dispatchRowEvent("childIndexChanged");
        }
    }
}
function $437b23f6a393c3bf$var$updateRowNodeAfterSort(rowNode) {
    if (rowNode.sibling) rowNode.sibling.childrenAfterSort = rowNode.childrenAfterSort;
    $437b23f6a393c3bf$var$updateChildIndexes(rowNode);
}
var $437b23f6a393c3bf$var$SortStage = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "sortStage";
        this.refreshProps = /* @__PURE__ */ new Set([
            "postSortRows",
            "groupDisplayType",
            "accentedSort"
        ]);
        this.step = "sort";
    }
    execute(params) {
        const beans = this.beans;
        const sortOptions = beans.sortSvc.getSortOptions();
        const sortActive = $437b23f6a393c3bf$export$25d27f17d3af40f7(sortOptions) && sortOptions.length > 0;
        const deltaSort = sortActive && !!params.changedRowNodes && // in time we can remove this check, so that delta sort is always
        // on if transactions are present. it's off for now so that we can
        // selectively turn it on and test it with some select users before
        // rolling out to everyone.
        this.gos.get("deltaSort");
        const sortContainsGroupColumns = sortOptions.some(({ column: column })=>{
            const isSortingCoupled = $437b23f6a393c3bf$export$96c51c2547b81aed(beans.gos);
            if (isSortingCoupled) return column.isPrimary() && column.isRowGroupActive();
            return !!column.getColDef().showRowGroup;
        });
        this.sort(beans, sortOptions, sortActive, deltaSort, params.changedRowNodes, params.changedPath, sortContainsGroupColumns);
    }
    sort(beans, sortOptions, sortActive, useDeltaSort, changedRowNodes, changedPath, sortContainsGroupColumns) {
        const { gos: gos, colModel: colModel, rowGroupColsSvc: rowGroupColsSvc, rowNodeSorter: rowNodeSorter, rowRenderer: rowRenderer, showRowGroupCols: showRowGroupCols } = beans;
        const groupMaintainOrder = gos.get("groupMaintainOrder");
        const groupColumnsPresent = colModel.getCols().some((c)=>c.isRowGroupActive());
        const isPivotMode = colModel.isPivotMode();
        const postSortFunc = gos.getCallback("postSortRows");
        let hasAnyFirstChildChanged = false;
        const callback = (rowNode)=>{
            const skipSortingPivotLeafs = isPivotMode && rowNode.leafGroup;
            const skipSortingGroups = groupMaintainOrder && groupColumnsPresent && !rowNode.leafGroup && !sortContainsGroupColumns;
            let newChildrenAfterSort;
            if (skipSortingGroups) {
                const nextGroup = rowGroupColsSvc?.columns?.[rowNode.level + 1];
                const wasSortExplicitlyRemoved = nextGroup?.getSort() === null;
                const childrenToBeSorted = rowNode.childrenAfterAggFilter.slice(0);
                if (rowNode.childrenAfterSort && !wasSortExplicitlyRemoved) {
                    const indexedOrders = {};
                    rowNode.childrenAfterSort.forEach((node, idx)=>{
                        indexedOrders[node.id] = idx;
                    });
                    childrenToBeSorted.sort((row1, row2)=>(indexedOrders[row1.id] ?? 0) - (indexedOrders[row2.id] ?? 0));
                }
                newChildrenAfterSort = childrenToBeSorted;
            } else if (!sortActive || skipSortingPivotLeafs) newChildrenAfterSort = rowNode.childrenAfterAggFilter.slice(0);
            else if (useDeltaSort && changedRowNodes) newChildrenAfterSort = $437b23f6a393c3bf$var$doDeltaSort(rowNodeSorter, rowNode, changedRowNodes, changedPath, sortOptions);
            else newChildrenAfterSort = rowNodeSorter.doFullSort(rowNode.childrenAfterAggFilter, sortOptions);
            hasAnyFirstChildChanged || (hasAnyFirstChildChanged = rowNode.childrenAfterSort?.[0] !== newChildrenAfterSort[0]);
            rowNode.childrenAfterSort = newChildrenAfterSort;
            $437b23f6a393c3bf$var$updateRowNodeAfterSort(rowNode);
            if (postSortFunc) {
                const params = {
                    nodes: rowNode.childrenAfterSort
                };
                postSortFunc(params);
            }
        };
        changedPath?.forEachChangedNodeDepthFirst(callback);
        if (hasAnyFirstChildChanged && this.gos.get("groupHideOpenParents")) {
            const columns = showRowGroupCols?.getShowRowGroupCols();
            if (columns?.length) rowRenderer.refreshCells({
                columns: columns,
                force: true
            });
        }
    }
};
function $437b23f6a393c3bf$var$doDeltaSort(rowNodeSorter, rowNode, changedRowNodes, changedPath, sortOptions) {
    const unsortedRows = rowNode.childrenAfterAggFilter;
    const oldSortedRows = rowNode.childrenAfterSort;
    if (!oldSortedRows) return rowNodeSorter.doFullSort(unsortedRows, sortOptions);
    const untouchedRows = /* @__PURE__ */ new Set();
    const touchedRows = [];
    const { updates: updates, adds: adds } = changedRowNodes;
    for(let i = 0, len = unsortedRows.length; i < len; ++i){
        const row = unsortedRows[i];
        if (updates.has(row) || adds.has(row) || changedPath && !changedPath.canSkip(row)) touchedRows.push({
            currentPos: touchedRows.length,
            rowNode: row
        });
        else untouchedRows.add(row.id);
    }
    const sortedUntouchedRows = oldSortedRows.filter((child)=>untouchedRows.has(child.id)).map((rowNode2, currentPos)=>({
            currentPos: currentPos,
            rowNode: rowNode2
        }));
    touchedRows.sort((a, b)=>rowNodeSorter.compareRowNodes(sortOptions, a, b));
    return $437b23f6a393c3bf$var$mergeSortedArrays(rowNodeSorter, sortOptions, touchedRows, sortedUntouchedRows);
}
function $437b23f6a393c3bf$var$mergeSortedArrays(rowNodeSorter, sortOptions, arr1, arr2) {
    const res = [];
    let i = 0;
    let j = 0;
    const arr1Length = arr1.length;
    const arr2Length = arr2.length;
    while(i < arr1Length && j < arr2Length){
        const a = arr1[i];
        const b = arr2[j];
        const compareResult = rowNodeSorter.compareRowNodes(sortOptions, a, b);
        let chosen;
        if (compareResult < 0) {
            chosen = a;
            ++i;
        } else {
            chosen = b;
            ++j;
        }
        res.push(chosen.rowNode);
    }
    while(i < arr1Length)res.push(arr1[i++].rowNode);
    while(j < arr2Length)res.push(arr2[j++].rowNode);
    return res;
}
// packages/ag-grid-community/src/clientSideRowModel/clientSideRowModel.ts
var $437b23f6a393c3bf$var$ClientSideRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowModel";
        // top most node of the tree. the children are the user provided data.
        this.rootNode = null;
        this.rowsToDisplay = [];
        /** Keep track if row data was updated. Important with suppressModelUpdateAfterUpdateTransaction and refreshModel api is called  */ this.rowDataUpdatedPending = false;
        /** Has the start method been called */ this.started = false;
        /**
     * This is to prevent refresh model being called when it's already being called.
     * E.g. the group stage can trigger initial state filter model to be applied. This fires onFilterChanged,
     * which then triggers the listener here that calls refresh model again but at the filter stage
     * (which is about to be run by the original call).
     */ this.isRefreshingModel = false;
        this.rowNodesCountReady = false;
        this.rowCountReady = false;
        this.onRowHeightChanged_debounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.onRowHeightChanged.bind(this), 100);
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.valueCache = beans.valueCache;
        this.filterStage = beans.filterStage;
        this.sortStage = beans.sortStage;
        this.flattenStage = beans.flattenStage;
        this.groupStage = beans.groupStage;
        this.aggStage = beans.aggStage;
        this.pivotStage = beans.pivotStage;
        this.filterAggStage = beans.filterAggStage;
    }
    postConstruct() {
        this.orderedStages = [
            this.groupStage,
            this.filterStage,
            this.pivotStage,
            this.aggStage,
            this.sortStage,
            this.filterAggStage,
            this.flattenStage
        ].filter((stage)=>!!stage);
        const refreshEverythingFunc = this.refreshModel.bind(this, {
            step: "group"
        });
        const refreshEverythingAfterColsChangedFunc = this.refreshModel.bind(this, {
            step: "group",
            // after cols change, row grouping (the first stage) could of changed
            afterColumnsChanged: true,
            keepRenderedRows: true,
            // we want animations cos sorting or filtering could be applied
            animate: !this.gos.get("suppressAnimationFrame")
        });
        this.addManagedEventListeners({
            newColumnsLoaded: refreshEverythingAfterColsChangedFunc,
            columnRowGroupChanged: refreshEverythingFunc,
            columnValueChanged: this.onValueChanged.bind(this),
            columnPivotChanged: this.refreshModel.bind(this, {
                step: "pivot"
            }),
            filterChanged: this.onFilterChanged.bind(this),
            sortChanged: this.onSortChanged.bind(this),
            columnPivotModeChanged: refreshEverythingFunc,
            gridStylesChanged: this.onGridStylesChanges.bind(this),
            gridReady: this.onGridReady.bind(this)
        });
        this.addPropertyListeners();
        this.rootNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
        const nodeManager = this.getNewNodeManager();
        this.nodeManager = nodeManager;
        nodeManager.activate(this.rootNode);
    }
    getNewNodeManager() {
        const { gos: gos, beans: beans } = this;
        return $437b23f6a393c3bf$export$e9780a3033a82b4f(gos) === "treeNested" && beans.csrmChildrenTreeNodeSvc || beans.csrmNodeSvc;
    }
    addPropertyListeners() {
        const allProps = [
            "treeData",
            "treeDataChildrenField",
            ...this.orderedStages.flatMap(({ refreshProps: refreshProps })=>[
                    ...refreshProps
                ])
        ];
        this.addManagedPropertyListeners(allProps, (params)=>{
            const properties = params.changeSet?.properties;
            if (properties) this.onPropChange(properties);
        });
        this.addManagedPropertyListener("rowData", ()=>this.onPropChange([
                "rowData"
            ]));
        this.addManagedPropertyListener("rowHeight", ()=>this.resetRowHeights());
    }
    start() {
        this.started = true;
        if (this.rowNodesCountReady) this.refreshModel({
            step: "group",
            rowDataUpdated: true,
            newData: true
        });
        else this.setInitialData();
    }
    setInitialData() {
        const rowData = this.gos.get("rowData");
        if (rowData) this.onPropChange([
            "rowData"
        ]);
    }
    ensureRowHeightsValid(startPixel, endPixel, startLimitIndex, endLimitIndex) {
        let atLeastOneChange;
        let res = false;
        do {
            atLeastOneChange = false;
            const rowAtStartPixel = this.getRowIndexAtPixel(startPixel);
            const rowAtEndPixel = this.getRowIndexAtPixel(endPixel);
            const firstRow = Math.max(rowAtStartPixel, startLimitIndex);
            const lastRow = Math.min(rowAtEndPixel, endLimitIndex);
            for(let rowIndex = firstRow; rowIndex <= lastRow; rowIndex++){
                const rowNode = this.getRow(rowIndex);
                if (rowNode.rowHeightEstimated) {
                    const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, rowNode);
                    rowNode.setRowHeight(rowHeight.height);
                    atLeastOneChange = true;
                    res = true;
                }
            }
            if (atLeastOneChange) this.setRowTopAndRowIndex();
        }while (atLeastOneChange);
        return res;
    }
    onPropChange(properties) {
        if (!this.rootNode) return;
        const gos = this.gos;
        const changedProps = new Set(properties);
        const params = {
            step: "nothing",
            changedProps: changedProps
        };
        const rowDataChanged = changedProps.has("rowData");
        const oldNodeManager = this.nodeManager;
        const nodeManager = this.getNewNodeManager();
        const reset = oldNodeManager !== nodeManager || rowDataChanged && changedProps.has("treeData") && gos.get("treeData") || changedProps.has("treeDataChildrenField") && gos.get("treeData");
        let newRowData;
        if (reset || rowDataChanged) {
            newRowData = gos.get("rowData");
            if (newRowData != null && !Array.isArray(newRowData)) {
                newRowData = null;
                $437b23f6a393c3bf$export$545083624300f13d(1);
            }
        }
        if (reset) {
            if (!rowDataChanged) newRowData = oldNodeManager?.extractRowData() ?? newRowData;
            if (oldNodeManager !== nodeManager) {
                oldNodeManager?.deactivate();
                this.nodeManager = nodeManager;
            }
            nodeManager.activate(this.rootNode);
        }
        if (newRowData) {
            const immutable = !reset && !this.isEmpty() && newRowData.length > 0 && gos.exists("getRowId") && // this property is a backwards compatibility property, for those who want
            // the old behaviour of Row IDs but NOT Immutable Data.
            !gos.get("resetRowDataOnUpdate");
            if (immutable) {
                params.keepRenderedRows = true;
                params.animate = !this.gos.get("suppressAnimationFrame");
                params.changedRowNodes = new $437b23f6a393c3bf$var$ChangedRowNodes();
                nodeManager.setImmutableRowData(params, newRowData);
            } else {
                params.rowDataUpdated = true;
                params.newData = true;
                const { selectionSvc: selectionSvc, pinnedRowModel: pinnedRowModel } = this.beans;
                selectionSvc?.reset("rowDataChanged");
                if (pinnedRowModel?.isManual()) pinnedRowModel.reset();
                this.rowNodesCountReady = true;
                nodeManager.setNewRowData(newRowData);
            }
        }
        if (params.rowDataUpdated) params.step = "group";
        else if (params.step === "nothing") {
            for (const { refreshProps: refreshProps, step: step } of this.orderedStages)if (properties.some((prop)=>refreshProps.has(prop))) {
                params.step = step;
                break;
            }
        }
        if (params.step !== "nothing") this.refreshModel(params);
    }
    setRowTopAndRowIndex() {
        const { beans: beans, rowsToDisplay: rowsToDisplay } = this;
        const defaultRowHeight = beans.environment.getDefaultRowHeight();
        let nextRowTop = 0;
        const displayedRowsMapped = /* @__PURE__ */ new Set();
        const allowEstimate = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "normal");
        for(let i = 0, len = rowsToDisplay.length; i < len; ++i){
            const rowNode = rowsToDisplay[i];
            if (rowNode.id != null) displayedRowsMapped.add(rowNode.id);
            if (rowNode.rowHeight == null) {
                const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(beans, rowNode, allowEstimate, defaultRowHeight);
                rowNode.setRowHeight(rowHeight.height, rowHeight.estimated);
            }
            rowNode.setRowTop(nextRowTop);
            rowNode.setRowIndex(i);
            nextRowTop += rowNode.rowHeight;
        }
        return displayedRowsMapped;
    }
    clearRowTopAndRowIndex(changedPath, displayedRowsMapped) {
        const changedPathActive = changedPath.active;
        const clearIfNotDisplayed = (rowNode)=>{
            if (rowNode && rowNode.id != null && !displayedRowsMapped.has(rowNode.id)) rowNode.clearRowTopAndRowIndex();
        };
        const recurse = (rowNode)=>{
            if (rowNode === null) return;
            clearIfNotDisplayed(rowNode);
            clearIfNotDisplayed(rowNode.detailNode);
            clearIfNotDisplayed(rowNode.sibling);
            if (rowNode.hasChildren()) {
                if (rowNode.childrenAfterGroup) {
                    const isRootNode = rowNode.level == -1;
                    const skipChildren = changedPathActive && !isRootNode && !rowNode.expanded;
                    if (!skipChildren) rowNode.childrenAfterGroup.forEach(recurse);
                }
            }
        };
        recurse(this.rootNode);
    }
    isLastRowIndexKnown() {
        return true;
    }
    getRowCount() {
        if (this.rowsToDisplay) return this.rowsToDisplay.length;
        return 0;
    }
    /**
   * Returns the number of rows with level === 1
   */ getTopLevelRowCount() {
        const rootNode = this.rootNode;
        if (!rootNode) return 0;
        if (this.rowsToDisplay.length === 0) return 0;
        const showingRootNode = this.rowsToDisplay && this.rowsToDisplay[0] === rootNode;
        if (showingRootNode) return 1;
        const filteredChildren = rootNode.childrenAfterSort;
        const totalFooterInc = rootNode.sibling && rootNode.sibling.displayed ? 1 : 0;
        return (filteredChildren ? filteredChildren.length : 0) + totalFooterInc;
    }
    /**
   * Get the row display index by the top level index
   * top level index is the index of rows with level === 1
   */ getTopLevelRowDisplayedIndex(topLevelIndex) {
        const { rootNode: rootNode, rowsToDisplay: rowsToDisplay } = this;
        const showingRootNode = !rootNode || !rowsToDisplay.length || rowsToDisplay[0] === rootNode;
        if (showingRootNode) return topLevelIndex;
        const { childrenAfterSort: childrenAfterSort } = rootNode;
        const getDefaultIndex = (adjustedIndex)=>{
            let rowNode = childrenAfterSort[adjustedIndex];
            if (this.gos.get("groupHideOpenParents")) while(rowNode.expanded && rowNode.childrenAfterSort && rowNode.childrenAfterSort.length > 0)rowNode = rowNode.childrenAfterSort[0];
            return rowNode.rowIndex;
        };
        const { footerSvc: footerSvc } = this.beans;
        if (footerSvc) return footerSvc.getTopDisplayIndex(rowsToDisplay, topLevelIndex, childrenAfterSort, getDefaultIndex);
        else return getDefaultIndex(topLevelIndex);
    }
    /**
   * The opposite of `getTopLevelRowDisplayedIndex`
   */ getTopLevelIndexFromDisplayedIndex(displayedIndex) {
        const { rootNode: rootNode, rowsToDisplay: rowsToDisplay } = this;
        const showingRootNode = !rootNode || !rowsToDisplay.length || rowsToDisplay[0] === rootNode;
        if (showingRootNode) return displayedIndex;
        let node = this.getRow(displayedIndex);
        if (node.footer) node = node.sibling;
        while(node.parent && node.parent !== rootNode)node = node.parent;
        const topLevelIndex = rootNode.childrenAfterSort?.findIndex((childNode)=>childNode === node);
        return topLevelIndex === -1 ? displayedIndex : topLevelIndex ?? displayedIndex;
    }
    getRowBounds(index) {
        const rowNode = this.rowsToDisplay[index];
        if (rowNode) return {
            rowTop: rowNode.rowTop,
            rowHeight: rowNode.rowHeight
        };
        return null;
    }
    onRowGroupOpened() {
        const animate = $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos);
        this.refreshModel({
            step: "map",
            keepRenderedRows: true,
            animate: animate
        });
    }
    onFilterChanged(event) {
        if (event.afterDataChange) return;
        const animate = $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos);
        const primaryOrQuickFilterChanged = event.columns.length === 0 || event.columns.some((col)=>col.isPrimary());
        const step = primaryOrQuickFilterChanged ? "filter" : "filter_aggregates";
        this.refreshModel({
            step: step,
            keepRenderedRows: true,
            animate: animate
        });
    }
    onSortChanged() {
        const animate = $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos);
        this.refreshModel({
            step: "sort",
            keepRenderedRows: true,
            animate: animate
        });
    }
    getType() {
        return "clientSide";
    }
    onValueChanged() {
        this.refreshModel({
            step: this.colModel.isPivotActive() ? "pivot" : "aggregate"
        });
    }
    createChangePath(enabled) {
        const changedPath = new $437b23f6a393c3bf$export$cb4d9114a9732e85(false, this.rootNode);
        if (!enabled) changedPath.active = false;
        return changedPath;
    }
    isSuppressModelUpdateAfterUpdateTransaction(params) {
        if (!this.gos.get("suppressModelUpdateAfterUpdateTransaction")) return false;
        const { changedRowNodes: changedRowNodes, newData: newData, rowDataUpdated: rowDataUpdated } = params;
        if (!changedRowNodes || newData || !rowDataUpdated) return false;
        if (changedRowNodes.removals.size || changedRowNodes.adds.size) return false;
        return true;
    }
    refreshModel(params) {
        if (!this.rootNode) return;
        const beans = this.beans;
        let rowDataUpdated = !!params.rowDataUpdated;
        const changedPath = params.changedPath ?? (params.changedPath = this.createChangePath(!params.newData && rowDataUpdated));
        if (this.started && rowDataUpdated) this.eventSvc.dispatchEvent({
            type: "rowDataUpdated"
        });
        this.rowDataUpdatedPending || (this.rowDataUpdatedPending = rowDataUpdated);
        if (!this.started || this.isRefreshingModel || this.colModel.changeEventsDispatching || this.isSuppressModelUpdateAfterUpdateTransaction(params)) return;
        if (this.rowDataUpdatedPending) {
            this.rowDataUpdatedPending = false;
            params.rowDataUpdated = rowDataUpdated = true;
        }
        this.isRefreshingModel = true;
        beans.masterDetailSvc?.refreshModel(params);
        if (rowDataUpdated && params.step !== "group") beans.colFilter?.refreshModel();
        switch(params.step){
            case "group":
                {
                    const groupingChanged = this.doRowGrouping(params);
                    if (groupingChanged || rowDataUpdated) beans.colFilter?.refreshModel();
                    if (!this.rowCountReady && this.rowNodesCountReady) {
                        this.rowCountReady = true;
                        this.eventSvc.dispatchEventOnce({
                            type: "rowCountReady"
                        });
                    }
                }
            case "filter":
                this.doFilter(changedPath);
            case "pivot":
                this.doPivot(changedPath);
            case "aggregate":
                this.doAggregate(changedPath);
            case "filter_aggregates":
                this.doFilterAggregates(changedPath);
            case "sort":
                this.doSort(params.changedRowNodes, changedPath);
            case "map":
                this.doRowsToDisplay();
        }
        const displayedNodesMapped = this.setRowTopAndRowIndex();
        this.clearRowTopAndRowIndex(changedPath, displayedNodesMapped);
        this.isRefreshingModel = false;
        this.eventSvc.dispatchEvent({
            type: "modelUpdated",
            animate: params.animate,
            keepRenderedRows: params.keepRenderedRows,
            newData: params.newData,
            newPage: false,
            keepUndoRedoStack: params.keepUndoRedoStack
        });
    }
    isEmpty() {
        return !this.rootNode?.allLeafChildren?.length || !this.colModel?.ready;
    }
    isRowsToRender() {
        return this.rowsToDisplay.length > 0;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        let started = false;
        let finished = false;
        const result = [];
        const groupsSelectChildren = $437b23f6a393c3bf$export$460e5745f0e6a40d(this.gos);
        this.forEachNodeAfterFilterAndSort((rowNode)=>{
            if (finished) return;
            if (started) {
                if (rowNode === lastInRange || rowNode === firstInRange) {
                    finished = true;
                    if (rowNode.group && groupsSelectChildren) {
                        result.push(...rowNode.allLeafChildren);
                        return;
                    }
                }
            }
            if (!started) {
                if (rowNode !== lastInRange && rowNode !== firstInRange) return;
                started = true;
            }
            const includeThisNode = !rowNode.group || !groupsSelectChildren;
            if (includeThisNode) {
                result.push(rowNode);
                return;
            }
        });
        return result;
    }
    getTopLevelNodes() {
        return this.rootNode?.childrenAfterGroup ?? null;
    }
    getRow(index) {
        return this.rowsToDisplay[index];
    }
    isRowPresent(rowNode) {
        return this.rowsToDisplay.indexOf(rowNode) >= 0;
    }
    getRowIndexAtPixel(pixelToMatch) {
        const rowsToDisplay = this.rowsToDisplay;
        if (this.isEmpty() || rowsToDisplay.length === 0) return -1;
        let bottomPointer = 0;
        let topPointer = rowsToDisplay.length - 1;
        if (pixelToMatch <= 0) return 0;
        const lastNode = $437b23f6a393c3bf$export$236389741107357f(rowsToDisplay);
        if (lastNode.rowTop <= pixelToMatch) return rowsToDisplay.length - 1;
        let oldBottomPointer = -1;
        let oldTopPointer = -1;
        while(true){
            const midPointer = Math.floor((bottomPointer + topPointer) / 2);
            const currentRowNode = rowsToDisplay[midPointer];
            if (this.isRowInPixel(currentRowNode, pixelToMatch)) return midPointer;
            if (currentRowNode.rowTop < pixelToMatch) bottomPointer = midPointer + 1;
            else if (currentRowNode.rowTop > pixelToMatch) topPointer = midPointer - 1;
            const caughtInInfiniteLoop = oldBottomPointer === bottomPointer && oldTopPointer === topPointer;
            if (caughtInInfiniteLoop) return midPointer;
            oldBottomPointer = bottomPointer;
            oldTopPointer = topPointer;
        }
    }
    isRowInPixel(rowNode, pixelToMatch) {
        const topPixel = rowNode.rowTop;
        const bottomPixel = rowNode.rowTop + rowNode.rowHeight;
        const pixelInRow = topPixel <= pixelToMatch && bottomPixel > pixelToMatch;
        return pixelInRow;
    }
    forEachLeafNode(callback) {
        this.rootNode?.allLeafChildren?.forEach((rowNode, index)=>callback(rowNode, index));
    }
    forEachNode(callback, includeFooterNodes = false) {
        this.depthFirstSearchRowNodes(callback, includeFooterNodes);
    }
    forEachDisplayedNode(callback) {
        this.rowsToDisplay.forEach(callback);
    }
    forEachNodeAfterFilter(callback, includeFooterNodes = false) {
        this.depthFirstSearchRowNodes(callback, includeFooterNodes, (node)=>node.childrenAfterAggFilter);
    }
    forEachNodeAfterFilterAndSort(callback, includeFooterNodes = false) {
        this.depthFirstSearchRowNodes(callback, includeFooterNodes, (node)=>node.childrenAfterSort);
    }
    forEachPivotNode(callback, includeFooterNodes = false, afterSort = false) {
        const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc } = this.beans;
        if (!colModel.isPivotMode()) return;
        if (!rowGroupColsSvc?.columns.length) {
            callback(this.rootNode, 0);
            return;
        }
        const childrenField = afterSort ? "childrenAfterSort" : "childrenAfterGroup";
        this.depthFirstSearchRowNodes(callback, includeFooterNodes, (node)=>!node.leafGroup ? node[childrenField] : null);
    }
    /**
   * Iterate through each node and all of its children
   * @param callback the function to execute for each node
   * @param includeFooterNodes whether to also iterate over footer nodes
   * @param nodes the nodes to start iterating over
   * @param getChildren a function to determine the recursion strategy
   * @param startIndex the index to start from
   * @returns the index ended at
   */ depthFirstSearchRowNodes(callback, includeFooterNodes = false, getChildren = (node2)=>node2.childrenAfterGroup, node = this.rootNode, startIndex = 0) {
        let index = startIndex;
        if (!node) return index;
        const isRootNode = node === this.rootNode;
        if (!isRootNode) callback(node, index++);
        const { footerSvc: footerSvc } = this.beans;
        if (node.hasChildren() && !node.footer) {
            const children = getChildren(node);
            if (children) {
                index = footerSvc?.addTotalRows(index, node, callback, includeFooterNodes, isRootNode, "top") ?? index;
                for (const node2 of children)index = this.depthFirstSearchRowNodes(callback, includeFooterNodes, getChildren, node2, index);
                return footerSvc?.addTotalRows(index, node, callback, includeFooterNodes, isRootNode, "bottom") ?? index;
            }
        }
        return index;
    }
    // it's possible to recompute the aggregate without doing the other parts
    // + api.refreshClientSideRowModel('aggregate')
    doAggregate(changedPath) {
        const rootNode = this.rootNode;
        if (rootNode) this.aggStage?.execute({
            rowNode: rootNode,
            changedPath: changedPath
        });
    }
    doFilterAggregates(changedPath) {
        const rootNode = this.rootNode;
        if (this.filterAggStage) this.filterAggStage.execute({
            rowNode: rootNode,
            changedPath: changedPath
        });
        else rootNode.childrenAfterAggFilter = rootNode.childrenAfterFilter;
    }
    doSort(changedRowNodes, changedPath) {
        if (this.sortStage) this.sortStage.execute({
            rowNode: this.rootNode,
            changedRowNodes: changedRowNodes,
            changedPath: changedPath
        });
        else changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
            rowNode.childrenAfterSort = rowNode.childrenAfterAggFilter.slice(0);
            $437b23f6a393c3bf$var$updateRowNodeAfterSort(rowNode);
        });
    }
    doRowGrouping(params) {
        const rootNode = this.rootNode;
        const groupStageExecuted = this.groupStage?.execute({
            rowNode: rootNode,
            changedRowNodes: params.changedRowNodes,
            changedPath: params.changedPath,
            rowNodesOrderChanged: !!params.rowNodesOrderChanged,
            afterColumnsChanged: !!params.afterColumnsChanged
        });
        if (groupStageExecuted !== void 0) return groupStageExecuted;
        const sibling = rootNode.sibling;
        rootNode.childrenAfterGroup = rootNode.allLeafChildren;
        if (sibling) sibling.childrenAfterGroup = rootNode.childrenAfterGroup;
        rootNode.updateHasChildren();
        return false;
    }
    doFilter(changedPath) {
        if (this.filterStage) this.filterStage.execute({
            rowNode: this.rootNode,
            changedPath: changedPath
        });
        else changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
            rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            $437b23f6a393c3bf$var$updateRowNodeAfterFilter(rowNode);
        }, true);
    }
    doPivot(changedPath) {
        this.pivotStage?.execute({
            rowNode: this.rootNode,
            changedPath: changedPath
        });
    }
    getRowNode(id) {
        const found = this.nodeManager.getRowNode(id);
        if (typeof found === "object") return found;
        const idIsGroup = typeof id == "string" && id.indexOf($437b23f6a393c3bf$export$cb038fdaa8338d9f) === 0;
        return idIsGroup ? this.groupStage?.getNode(id) : void 0;
    }
    batchUpdateRowData(rowDataTransaction, callback) {
        if (this.applyAsyncTransactionsTimeout == null) {
            this.rowDataTransactionBatch = [];
            const waitMillis = this.gos.get("asyncTransactionWaitMillis");
            this.applyAsyncTransactionsTimeout = window.setTimeout(()=>{
                if (this.isAlive()) this.executeBatchUpdateRowData();
            }, waitMillis);
        }
        this.rowDataTransactionBatch.push({
            rowDataTransaction: rowDataTransaction,
            callback: callback
        });
    }
    flushAsyncTransactions() {
        if (this.applyAsyncTransactionsTimeout != null) {
            clearTimeout(this.applyAsyncTransactionsTimeout);
            this.executeBatchUpdateRowData();
        }
    }
    executeBatchUpdateRowData() {
        this.valueCache?.onDataChanged();
        const callbackFuncsBound = [];
        const rowNodeTrans = [];
        const changedRowNodes = new $437b23f6a393c3bf$var$ChangedRowNodes();
        let orderChanged = false;
        this.rowDataTransactionBatch?.forEach((tranItem)=>{
            this.rowNodesCountReady = true;
            const { rowNodeTransaction: rowNodeTransaction, rowsInserted: rowsInserted } = this.nodeManager.updateRowData(tranItem.rowDataTransaction, changedRowNodes);
            if (rowsInserted) orderChanged = true;
            rowNodeTrans.push(rowNodeTransaction);
            if (tranItem.callback) callbackFuncsBound.push(tranItem.callback.bind(null, rowNodeTransaction));
        });
        this.commitTransactions(orderChanged, changedRowNodes);
        if (callbackFuncsBound.length > 0) window.setTimeout(()=>{
            callbackFuncsBound.forEach((func)=>func());
        }, 0);
        if (rowNodeTrans.length > 0) this.eventSvc.dispatchEvent({
            type: "asyncTransactionsFlushed",
            results: rowNodeTrans
        });
        this.rowDataTransactionBatch = null;
        this.applyAsyncTransactionsTimeout = void 0;
    }
    /**
   * Used to apply transaction changes.
   * Called by gridApi & rowDragFeature
   */ updateRowData(rowDataTran) {
        this.valueCache?.onDataChanged();
        this.rowNodesCountReady = true;
        const changedRowNodes = new $437b23f6a393c3bf$var$ChangedRowNodes();
        const { rowNodeTransaction: rowNodeTransaction, rowsInserted: rowsInserted } = this.nodeManager.updateRowData(rowDataTran, changedRowNodes);
        this.commitTransactions(rowsInserted, changedRowNodes);
        return rowNodeTransaction;
    }
    /**
   * Common to:
   * - executeBatchUpdateRowData (batch transactions)
   * - updateRowData (single transaction)
   * - setImmutableRowData (generated transaction)
   *
   * @param rowNodeTrans - the transactions to apply
   * @param orderChanged - whether the order of the rows has changed, either via generated transaction or user provided addIndex
   */ commitTransactions(rowNodesOrderChanged, changedRowNodes) {
        this.refreshModel({
            step: "group",
            rowDataUpdated: true,
            rowNodesOrderChanged: rowNodesOrderChanged,
            keepRenderedRows: true,
            animate: !this.gos.get("suppressAnimationFrame"),
            changedRowNodes: changedRowNodes,
            changedPath: this.createChangePath(true)
        });
    }
    doRowsToDisplay() {
        const { flattenStage: flattenStage, rootNode: rootNode } = this;
        let rowsToDisplay;
        if (flattenStage) rowsToDisplay = flattenStage.execute({
            rowNode: rootNode
        });
        else {
            rowsToDisplay = rootNode?.childrenAfterSort ?? [];
            for (const row of rowsToDisplay)row.setUiLevel(0);
        }
        this.rowsToDisplay = rowsToDisplay;
    }
    onRowHeightChanged() {
        this.refreshModel({
            step: "map",
            keepRenderedRows: true,
            keepUndoRedoStack: true
        });
    }
    resetRowHeights() {
        const rootNode = this.rootNode;
        if (!rootNode) return;
        const atLeastOne = this.resetRowHeightsForAllRowNodes();
        rootNode.setRowHeight(rootNode.rowHeight, true);
        if (rootNode.sibling) rootNode.sibling.setRowHeight(rootNode.sibling.rowHeight, true);
        if (atLeastOne) this.onRowHeightChanged();
    }
    resetRowHeightsForAllRowNodes() {
        let atLeastOne = false;
        this.forEachNode((rowNode)=>{
            rowNode.setRowHeight(rowNode.rowHeight, true);
            const detailNode = rowNode.detailNode;
            if (detailNode) detailNode.setRowHeight(detailNode.rowHeight, true);
            if (rowNode.sibling) rowNode.sibling.setRowHeight(rowNode.sibling.rowHeight, true);
            atLeastOne = true;
        });
        return atLeastOne;
    }
    onGridStylesChanges(e) {
        if (e.rowHeightChanged) {
            if (this.beans.rowAutoHeight?.active) return;
            this.resetRowHeights();
        }
    }
    onGridReady() {
        if (!this.started) this.setInitialData();
    }
    isRowDataLoaded() {
        return this.rowCountReady;
    }
    destroy() {
        super.destroy();
        this.started = false;
        this.rootNode = null;
        this.nodeManager = null;
        this.rowDataTransactionBatch = null;
        this.orderedStages = $437b23f6a393c3bf$export$c758d9371030a6ac;
        this.rowsToDisplay = $437b23f6a393c3bf$export$c758d9371030a6ac;
    }
    /**
   * @deprecated v33.1
   */ onRowHeightChangedDebounced() {
        this.onRowHeightChanged_debounced();
    }
};
// packages/ag-grid-community/src/clientSideRowModel/clientSideRowModelApi.ts
function $437b23f6a393c3bf$var$onGroupExpandedOrCollapsed(beans) {
    beans.expansionSvc?.onGroupExpandedOrCollapsed();
}
function $437b23f6a393c3bf$var$refreshClientSideRowModel(beans, step) {
    const clientSideRowModel = $437b23f6a393c3bf$export$f5285e6f27a03f95(beans);
    if (clientSideRowModel) {
        if (!step || step === "everything") step = "group";
        clientSideRowModel.refreshModel({
            step: step,
            keepRenderedRows: true,
            animate: !beans.gos.get("suppressAnimationFrame")
        });
    }
}
function $437b23f6a393c3bf$var$isRowDataEmpty(beans) {
    return $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.isEmpty() ?? true;
}
function $437b23f6a393c3bf$var$forEachLeafNode(beans, callback) {
    $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.forEachLeafNode(callback);
}
function $437b23f6a393c3bf$var$forEachNodeAfterFilter(beans, callback) {
    $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.forEachNodeAfterFilter(callback);
}
function $437b23f6a393c3bf$var$forEachNodeAfterFilterAndSort(beans, callback) {
    $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.forEachNodeAfterFilterAndSort(callback);
}
function $437b23f6a393c3bf$var$resetRowHeights(beans) {
    if (beans.rowAutoHeight?.active) {
        $437b23f6a393c3bf$export$545083624300f13d(3);
        return;
    }
    $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.resetRowHeights();
}
function $437b23f6a393c3bf$var$applyTransaction(beans, rowDataTransaction) {
    return beans.frameworkOverrides.wrapIncoming(()=>$437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.updateRowData(rowDataTransaction));
}
function $437b23f6a393c3bf$var$applyTransactionAsync(beans, rowDataTransaction, callback) {
    beans.frameworkOverrides.wrapIncoming(()=>$437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.batchUpdateRowData(rowDataTransaction, callback));
}
function $437b23f6a393c3bf$var$flushAsyncTransactions(beans) {
    beans.frameworkOverrides.wrapIncoming(()=>$437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.flushAsyncTransactions());
}
function $437b23f6a393c3bf$var$getBestCostNodeSelection(beans) {
    return beans.selectionSvc?.getBestCostNodeSelection();
}
// packages/ag-grid-community/src/clientSideRowModel/clientSideRowModelModule.ts
var $437b23f6a393c3bf$export$4c74201d5a94c8e5 = {
    moduleName: "ClientSideRowModel",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $437b23f6a393c3bf$var$ClientSideNodeManager,
        $437b23f6a393c3bf$var$ClientSideRowModel,
        $437b23f6a393c3bf$var$SortStage
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$1a6625c5691649e8
    ]
};
var $437b23f6a393c3bf$export$15323dcce1401b05 = {
    moduleName: "ClientSideRowModelApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        onGroupExpandedOrCollapsed: $437b23f6a393c3bf$var$onGroupExpandedOrCollapsed,
        refreshClientSideRowModel: $437b23f6a393c3bf$var$refreshClientSideRowModel,
        isRowDataEmpty: $437b23f6a393c3bf$var$isRowDataEmpty,
        forEachLeafNode: $437b23f6a393c3bf$var$forEachLeafNode,
        forEachNodeAfterFilter: $437b23f6a393c3bf$var$forEachNodeAfterFilter,
        forEachNodeAfterFilterAndSort: $437b23f6a393c3bf$var$forEachNodeAfterFilterAndSort,
        resetRowHeights: $437b23f6a393c3bf$var$resetRowHeights,
        applyTransaction: $437b23f6a393c3bf$var$applyTransaction,
        applyTransactionAsync: $437b23f6a393c3bf$var$applyTransactionAsync,
        flushAsyncTransactions: $437b23f6a393c3bf$var$flushAsyncTransactions,
        getBestCostNodeSelection: $437b23f6a393c3bf$var$getBestCostNodeSelection
    },
    dependsOn: [
        $437b23f6a393c3bf$export$76fb120d9e251426
    ]
};
// packages/ag-grid-community/src/export/gridSerializer.ts
var $437b23f6a393c3bf$var$GridSerializer = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "gridSerializer";
    }
    wireBeans(beans) {
        this.visibleCols = beans.visibleCols;
        this.colModel = beans.colModel;
        this.rowModel = beans.rowModel;
        this.pinnedRowModel = beans.pinnedRowModel;
    }
    serialize(gridSerializingSession, params = {}) {
        const { allColumns: allColumns, columnKeys: columnKeys, skipRowGroups: skipRowGroups, exportRowNumbers: exportRowNumbers } = params;
        const columnsToExport = this.getColumnsToExport({
            allColumns: allColumns,
            skipRowGroups: skipRowGroups,
            columnKeys: columnKeys,
            exportRowNumbers: exportRowNumbers
        });
        return [
            // first pass, put in the header names of the cols
            this.prepareSession(columnsToExport),
            this.prependContent(params),
            this.exportColumnGroups(params, columnsToExport),
            this.exportHeaders(params, columnsToExport),
            this.processPinnedTopRows(params, columnsToExport),
            this.processRows(params, columnsToExport),
            this.processPinnedBottomRows(params, columnsToExport),
            this.appendContent(params)
        ].reduce((composed, f)=>f(composed), gridSerializingSession).parse();
    }
    processRow(gridSerializingSession, params, columnsToExport, node) {
        const rowSkipper = params.shouldRowBeSkipped || (()=>false);
        const isClipboardExport = params.rowPositions != null;
        const isExplicitExportSelection = isClipboardExport || !!params.onlySelected;
        const hideOpenParents = this.gos.get("groupHideOpenParents") && !isExplicitExportSelection;
        const isLeafNode = this.colModel.isPivotMode() ? node.leafGroup : !node.group;
        const isFooter = !!node.footer;
        const shouldSkipCurrentGroup = node.allChildrenCount === 1 && node.childrenAfterGroup?.length === 1 && $437b23f6a393c3bf$export$2f5892ff24cc879d(this.gos, node);
        if (!isLeafNode && !isFooter && (params.skipRowGroups || shouldSkipCurrentGroup || hideOpenParents) || params.onlySelected && !node.isSelected() || params.skipPinnedTop && node.rowPinned === "top" || params.skipPinnedBottom && node.rowPinned === "bottom" || node.stub) return;
        const nodeIsRootNode = node.level === -1;
        if (nodeIsRootNode && !isLeafNode && !isFooter) return;
        const shouldRowBeSkipped = rowSkipper($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            node: node
        }));
        if (shouldRowBeSkipped) return;
        const rowAccumulator = gridSerializingSession.onNewBodyRow(node);
        columnsToExport.forEach((column, index)=>{
            rowAccumulator.onColumn(column, index, node);
        });
        if (params.getCustomContentBelowRow) {
            const content = params.getCustomContentBelowRow($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                node: node
            }));
            if (content) gridSerializingSession.addCustomContent(content);
        }
    }
    appendContent(params) {
        return (gridSerializingSession)=>{
            const appendContent = params.appendContent;
            if (appendContent) gridSerializingSession.addCustomContent(appendContent);
            return gridSerializingSession;
        };
    }
    prependContent(params) {
        return (gridSerializingSession)=>{
            const prependContent = params.prependContent;
            if (prependContent) gridSerializingSession.addCustomContent(prependContent);
            return gridSerializingSession;
        };
    }
    prepareSession(columnsToExport) {
        return (gridSerializingSession)=>{
            gridSerializingSession.prepare(columnsToExport);
            return gridSerializingSession;
        };
    }
    exportColumnGroups(params, columnsToExport) {
        return (gridSerializingSession)=>{
            if (!params.skipColumnGroupHeaders) {
                const idCreator = new $437b23f6a393c3bf$export$b3b24737a74261fb();
                const { colGroupSvc: colGroupSvc } = this.beans;
                const displayedGroups = colGroupSvc ? colGroupSvc.createColumnGroups({
                    columns: columnsToExport,
                    idCreator: idCreator,
                    pinned: null,
                    isStandaloneStructure: true
                }) : columnsToExport;
                this.recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession, params.processGroupHeaderCallback);
            }
            return gridSerializingSession;
        };
    }
    exportHeaders(params, columnsToExport) {
        return (gridSerializingSession)=>{
            if (!params.skipColumnHeaders) {
                const gridRowIterator = gridSerializingSession.onNewHeaderRow();
                columnsToExport.forEach((column, index)=>{
                    gridRowIterator.onColumn(column, index, void 0);
                });
            }
            return gridSerializingSession;
        };
    }
    processPinnedTopRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            if (params.rowPositions) params.rowPositions.filter((position)=>position.rowPinned === "top").sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>this.pinnedRowModel?.getPinnedTopRow(position.rowIndex)).forEach(processRow);
            else if (!this.pinnedRowModel?.isManual()) this.pinnedRowModel?.forEachPinnedRow("top", processRow);
            return gridSerializingSession;
        };
    }
    processRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const rowModel = this.rowModel;
            const usingCsrm = $437b23f6a393c3bf$export$9f182d9ca737e15(this.gos, rowModel);
            const usingSsrm = $437b23f6a393c3bf$export$cf1bac0013650216(this.gos, rowModel);
            const onlySelectedNonStandardModel = !usingCsrm && params.onlySelected;
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            const { exportedRows: exportedRows = "filteredAndSorted" } = params;
            if (params.rowPositions) {
                params.rowPositions.filter((position)=>position.rowPinned == null).sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>rowModel.getRow(position.rowIndex)).forEach(processRow);
                return gridSerializingSession;
            }
            if (this.colModel.isPivotMode()) {
                if (usingCsrm) rowModel.forEachPivotNode(processRow, true, exportedRows === "filteredAndSorted");
                else if (usingSsrm) rowModel.forEachNodeAfterFilterAndSort(processRow, true);
                else rowModel.forEachNode(processRow);
                return gridSerializingSession;
            }
            if (params.onlySelectedAllPages || onlySelectedNonStandardModel) {
                const selectedNodes = this.beans.selectionSvc?.getSelectedNodes() ?? [];
                this.replicateSortedOrder(selectedNodes);
                selectedNodes.forEach(processRow);
            } else {
                if (exportedRows === "all") rowModel.forEachNode(processRow);
                else if (usingCsrm || usingSsrm) rowModel.forEachNodeAfterFilterAndSort(processRow, true);
                else rowModel.forEachNode(processRow);
            }
            return gridSerializingSession;
        };
    }
    replicateSortedOrder(rows) {
        const { sortSvc: sortSvc, rowNodeSorter: rowNodeSorter } = this.beans;
        if (!sortSvc || !rowNodeSorter) return;
        const sortOptions = sortSvc.getSortOptions();
        const compareNodes = (rowA, rowB)=>{
            if (rowA.rowIndex != null && rowB.rowIndex != null) return rowA.rowIndex - rowB.rowIndex;
            if (rowA.level === rowB.level) {
                if (rowA.parent?.id === rowB.parent?.id) return rowNodeSorter.compareRowNodes(sortOptions, {
                    rowNode: rowA,
                    currentPos: rowA.rowIndex ?? -1
                }, {
                    rowNode: rowB,
                    currentPos: rowB.rowIndex ?? -1
                });
                return compareNodes(rowA.parent, rowB.parent);
            }
            if (rowA.level > rowB.level) return compareNodes(rowA.parent, rowB);
            return compareNodes(rowA, rowB.parent);
        };
        rows.sort(compareNodes);
    }
    processPinnedBottomRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            if (params.rowPositions) params.rowPositions.filter((position)=>position.rowPinned === "bottom").sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>this.pinnedRowModel?.getPinnedBottomRow(position.rowIndex)).forEach(processRow);
            else if (!this.pinnedRowModel?.isManual()) this.pinnedRowModel?.forEachPinnedRow("bottom", processRow);
            return gridSerializingSession;
        };
    }
    getColumnsToExport(params) {
        const { allColumns: allColumns = false, skipRowGroups: skipRowGroups = false, exportRowNumbers: exportRowNumbers = false, columnKeys: columnKeys } = params;
        const { colModel: colModel, gos: gos, visibleCols: visibleCols } = this;
        const isPivotMode = colModel.isPivotMode();
        const filterSpecialColumns = (col)=>{
            if ($437b23f6a393c3bf$export$f6074a9792015c5d(col)) return false;
            return !$437b23f6a393c3bf$export$3d3e7d751f0445eb(col) || exportRowNumbers;
        };
        if (columnKeys && columnKeys.length) return colModel.getColsForKeys(columnKeys).filter(filterSpecialColumns);
        const isTreeData = gos.get("treeData");
        let columnsToExport = [];
        if (allColumns && !isPivotMode) columnsToExport = colModel.getCols();
        else columnsToExport = visibleCols.allCols;
        columnsToExport = columnsToExport.filter((column)=>filterSpecialColumns(column) && (skipRowGroups && !isTreeData ? !$437b23f6a393c3bf$export$61b34611dc010a97(column) : true));
        return columnsToExport;
    }
    recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession, processGroupHeaderCallback) {
        const directChildrenHeaderGroups = [];
        displayedGroups.forEach((columnGroupChild)=>{
            const columnGroup = columnGroupChild;
            if (!columnGroup.getChildren) return;
            columnGroup.getChildren().forEach((it)=>directChildrenHeaderGroups.push(it));
        });
        if (displayedGroups.length > 0 && $437b23f6a393c3bf$export$1f44a60fc23f9028(displayedGroups[0])) this.doAddHeaderHeader(gridSerializingSession, displayedGroups, processGroupHeaderCallback);
        if (directChildrenHeaderGroups && directChildrenHeaderGroups.length > 0) this.recursivelyAddHeaderGroups(directChildrenHeaderGroups, gridSerializingSession, processGroupHeaderCallback);
    }
    doAddHeaderHeader(gridSerializingSession, displayedGroups, processGroupHeaderCallback) {
        const gridRowIterator = gridSerializingSession.onNewHeaderGroupingRow();
        let columnIndex = 0;
        displayedGroups.forEach((columnGroupChild)=>{
            const columnGroup = columnGroupChild;
            let name;
            if (processGroupHeaderCallback) name = processGroupHeaderCallback($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                columnGroup: columnGroup
            }));
            else name = this.beans.colNames.getDisplayNameForColumnGroup(columnGroup, "header");
            const collapsibleGroupRanges = columnGroup.getLeafColumns().reduce((collapsibleGroups, currentColumn, currentIdx, arr)=>{
                let lastGroup = $437b23f6a393c3bf$export$236389741107357f(collapsibleGroups);
                const groupShow = currentColumn.getColumnGroupShow() === "open";
                if (!groupShow) {
                    if (lastGroup && lastGroup[1] == null) lastGroup[1] = currentIdx - 1;
                } else if (!lastGroup || lastGroup[1] != null) {
                    lastGroup = [
                        currentIdx
                    ];
                    collapsibleGroups.push(lastGroup);
                }
                if (currentIdx === arr.length - 1 && lastGroup && lastGroup[1] == null) lastGroup[1] = currentIdx;
                return collapsibleGroups;
            }, []);
            gridRowIterator.onColumn(columnGroup, name || "", columnIndex++, columnGroup.getLeafColumns().length - 1, collapsibleGroupRanges);
        });
    }
};
// packages/ag-grid-community/src/export/exportModule.ts
var $437b23f6a393c3bf$export$e6030935e93fda2b = {
    moduleName: "SharedExport",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$GridSerializer
    ]
};
// packages/ag-grid-community/src/csvExport/csvSerializingSession.ts
var $437b23f6a393c3bf$var$LINE_SEPARATOR = "\r\n";
var $437b23f6a393c3bf$var$CsvSerializingSession = class extends $437b23f6a393c3bf$export$5018ab277b833b61 {
    constructor(config){
        super(config);
        this.config = config;
        this.isFirstLine = true;
        this.result = "";
        const { suppressQuotes: suppressQuotes, columnSeparator: columnSeparator } = config;
        this.suppressQuotes = suppressQuotes;
        this.columnSeparator = columnSeparator;
    }
    addCustomContent(content) {
        if (!content) return;
        if (typeof content === "string") {
            if (!/^\s*\n/.test(content)) this.beginNewLine();
            content = content.replace(/\r?\n/g, $437b23f6a393c3bf$var$LINE_SEPARATOR);
            this.result += content;
        } else content.forEach((row)=>{
            this.beginNewLine();
            row.forEach((cell, index)=>{
                if (index !== 0) this.result += this.columnSeparator;
                this.result += this.putInQuotes(cell.data.value || "");
                if (cell.mergeAcross) this.appendEmptyCells(cell.mergeAcross);
            });
        });
    }
    onNewHeaderGroupingRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
        };
    }
    onNewHeaderGroupingRowColumn(columnGroup, header, index, span) {
        if (index != 0) this.result += this.columnSeparator;
        this.result += this.putInQuotes(header);
        this.appendEmptyCells(span);
    }
    appendEmptyCells(count) {
        for(let i = 1; i <= count; i++)this.result += this.columnSeparator + this.putInQuotes("");
    }
    onNewHeaderRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewHeaderRowColumn.bind(this)
        };
    }
    onNewHeaderRowColumn(column, index) {
        if (index != 0) this.result += this.columnSeparator;
        this.result += this.putInQuotes(this.extractHeaderValue(column));
    }
    onNewBodyRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewBodyRowColumn.bind(this)
        };
    }
    onNewBodyRowColumn(column, index, node) {
        if (index != 0) this.result += this.columnSeparator;
        const rowCellValue = this.extractRowCellValue(column, index, index, "csv", node);
        this.result += this.putInQuotes(rowCellValue.valueFormatted ?? rowCellValue.value);
    }
    putInQuotes(value) {
        if (this.suppressQuotes) return value;
        if (value === null || value === void 0) return '""';
        let stringValue;
        if (typeof value === "string") stringValue = value;
        else if (typeof value.toString === "function") stringValue = value.toString();
        else {
            $437b23f6a393c3bf$export$545083624300f13d(53);
            stringValue = "";
        }
        const valueEscaped = stringValue.replace(/"/g, '""');
        return '"' + valueEscaped + '"';
    }
    parse() {
        return this.result;
    }
    beginNewLine() {
        if (!this.isFirstLine) this.result += $437b23f6a393c3bf$var$LINE_SEPARATOR;
        this.isFirstLine = false;
    }
};
// packages/ag-grid-community/src/csvExport/csvCreator.ts
var $437b23f6a393c3bf$var$CsvCreator = class extends $437b23f6a393c3bf$export$b335f23c5aead909 {
    constructor(){
        super(...arguments);
        this.beanName = "csvCreator";
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.colNames = beans.colNames;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
        this.valueSvc = beans.valueSvc;
    }
    getMergedParams(params) {
        const baseParams5 = this.gos.get("defaultCsvExportParams");
        return Object.assign({}, baseParams5, params);
    }
    export(userParams) {
        if (this.isExportSuppressed()) {
            $437b23f6a393c3bf$export$545083624300f13d(51);
            return;
        }
        const mergedParams = this.getMergedParams(userParams);
        const data = this.getData(mergedParams);
        const packagedFile = new Blob([
            "\uFEFF",
            data
        ], {
            type: "text/plain"
        });
        const fileName = typeof mergedParams.fileName === "function" ? mergedParams.fileName($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {})) : mergedParams.fileName;
        $437b23f6a393c3bf$export$97aef6bcdc3f7ef5(this.getFileName(fileName), packagedFile);
    }
    exportDataAsCsv(params) {
        this.export(params);
    }
    getDataAsCsv(params, skipDefaultParams = false) {
        const mergedParams = skipDefaultParams ? Object.assign({}, params) : this.getMergedParams(params);
        return this.getData(mergedParams);
    }
    getDefaultFileExtension() {
        return "csv";
    }
    createSerializingSession(params) {
        const { colModel: colModel, colNames: colNames, rowGroupColsSvc: rowGroupColsSvc, valueSvc: valueSvc, gos: gos } = this;
        const { processCellCallback: processCellCallback, processHeaderCallback: processHeaderCallback, processGroupHeaderCallback: processGroupHeaderCallback, processRowGroupCallback: processRowGroupCallback, suppressQuotes: suppressQuotes, columnSeparator: columnSeparator } = params;
        return new $437b23f6a393c3bf$var$CsvSerializingSession({
            colModel: colModel,
            colNames: colNames,
            valueSvc: valueSvc,
            gos: gos,
            processCellCallback: processCellCallback || void 0,
            processHeaderCallback: processHeaderCallback || void 0,
            processGroupHeaderCallback: processGroupHeaderCallback || void 0,
            processRowGroupCallback: processRowGroupCallback || void 0,
            suppressQuotes: suppressQuotes || false,
            columnSeparator: columnSeparator || ",",
            rowGroupColsSvc: rowGroupColsSvc
        });
    }
    isExportSuppressed() {
        return this.gos.get("suppressCsvExport");
    }
};
// packages/ag-grid-community/src/csvExport/csvExportApi.ts
function $437b23f6a393c3bf$var$getDataAsCsv(beans, params) {
    return beans.csvCreator?.getDataAsCsv(params);
}
function $437b23f6a393c3bf$var$exportDataAsCsv(beans, params) {
    beans.csvCreator?.exportDataAsCsv(params);
}
// packages/ag-grid-community/src/csvExport/csvExportModule.ts
var $437b23f6a393c3bf$export$f744275d8b795fc2 = {
    moduleName: "CsvExport",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$CsvCreator
    ],
    apiFunctions: {
        getDataAsCsv: $437b23f6a393c3bf$var$getDataAsCsv,
        exportDataAsCsv: $437b23f6a393c3bf$var$exportDataAsCsv
    },
    dependsOn: [
        $437b23f6a393c3bf$export$e6030935e93fda2b
    ]
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteBlock.ts
var $437b23f6a393c3bf$var$InfiniteBlock = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(id, parentCache, params){
        super();
        this.id = id;
        this.parentCache = parentCache;
        this.params = params;
        this.state = "needsLoading";
        this.version = 0;
        this.startRow = id * params.blockSize;
        this.endRow = this.startRow + params.blockSize;
    }
    load() {
        this.state = "loading";
        this.loadFromDatasource();
    }
    setStateWaitingToLoad() {
        this.version++;
        this.state = "needsLoading";
    }
    pageLoadFailed(version) {
        const requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);
        if (requestMostRecentAndLive) this.state = "failed";
        this.dispatchLocalEvent({
            type: "loadComplete"
        });
    }
    pageLoaded(version, rows, lastRow) {
        this.successCommon(version, {
            rowData: rows,
            rowCount: lastRow
        });
    }
    isRequestMostRecentAndLive(version) {
        const thisIsMostRecentRequest = version === this.version;
        const weAreNotDestroyed = this.isAlive();
        return thisIsMostRecentRequest && weAreNotDestroyed;
    }
    successCommon(version, params) {
        this.dispatchLocalEvent({
            type: "loadComplete"
        });
        const requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);
        if (requestMostRecentAndLive) {
            this.state = "loaded";
            this.processServerResult(params);
        }
    }
    postConstruct() {
        this.rowNodes = [];
        const { params: { blockSize: blockSize, rowHeight: rowHeight }, startRow: startRow, beans: beans, rowNodes: rowNodes } = this;
        for(let i = 0; i < blockSize; i++){
            const rowIndex = startRow + i;
            const rowNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(beans);
            rowNode.setRowHeight(rowHeight);
            rowNode.uiLevel = 0;
            rowNode.setRowIndex(rowIndex);
            rowNode.setRowTop(rowHeight * rowIndex);
            rowNodes.push(rowNode);
        }
    }
    getBlockStateJson() {
        const { id: id, startRow: startRow, endRow: endRow, state: pageStatus } = this;
        return {
            id: "" + id,
            state: {
                blockNumber: id,
                startRow: startRow,
                endRow: endRow,
                pageStatus: pageStatus
            }
        };
    }
    setDataAndId(rowNode, data, index) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(data)) rowNode.setDataAndId(data, index.toString());
        else rowNode.setDataAndId(void 0, void 0);
    }
    loadFromDatasource() {
        const params = this.createLoadParams();
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(this.params.datasource.getRows)) {
            $437b23f6a393c3bf$export$545083624300f13d(90);
            return;
        }
        window.setTimeout(()=>{
            this.params.datasource.getRows(params);
        }, 0);
    }
    createLoadParams() {
        const { startRow: startRow, endRow: endRow, version: version, params: { sortModel: sortModel, filterModel: filterModel }, gos: gos } = this;
        const params = {
            startRow: startRow,
            endRow: endRow,
            successCallback: this.pageLoaded.bind(this, version),
            failCallback: this.pageLoadFailed.bind(this, version),
            sortModel: sortModel,
            filterModel: filterModel,
            context: $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {}).context
        };
        return params;
    }
    forEachNode(callback, sequence, rowCount) {
        this.rowNodes.forEach((rowNode, index)=>{
            const rowIndex = this.startRow + index;
            if (rowIndex < rowCount) callback(rowNode, sequence.value++);
        });
    }
    getRow(rowIndex, dontTouchLastAccessed = false) {
        if (!dontTouchLastAccessed) this.lastAccessed = this.params.lastAccessedSequence.value++;
        const localIndex = rowIndex - this.startRow;
        return this.rowNodes[localIndex];
    }
    processServerResult(params) {
        const { rowNodes: rowNodes, beans: beans } = this;
        rowNodes.forEach((rowNode, index)=>{
            const data = params.rowData ? params.rowData[index] : void 0;
            if (!rowNode.id && rowNode.alreadyRendered && data) {
                rowNodes[index] = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(beans);
                rowNodes[index].setRowIndex(rowNode.rowIndex);
                rowNodes[index].setRowTop(rowNode.rowTop);
                rowNodes[index].setRowHeight(rowNode.rowHeight);
                rowNode.clearRowTopAndRowIndex();
            }
            this.setDataAndId(rowNodes[index], data, this.startRow + index);
        });
        const finalRowCount = params.rowCount != null && params.rowCount >= 0 ? params.rowCount : void 0;
        this.parentCache.pageLoaded(this, finalRowCount);
    }
    destroy() {
        this.rowNodes.forEach((rowNode)=>{
            rowNode.clearRowTopAndRowIndex();
        });
        super.destroy();
    }
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteCache.ts
var $437b23f6a393c3bf$var$MAX_EMPTY_BLOCKS_TO_KEEP = 2;
var $437b23f6a393c3bf$var$InfiniteCache = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(params){
        super();
        this.params = params;
        this.lastRowIndexKnown = false;
        this.blocks = {};
        this.blockCount = 0;
        this.rowCount = params.initialRowCount;
    }
    // the rowRenderer will not pass dontCreatePage, meaning when rendering the grid,
    // it will want new pages in the cache as it asks for rows. only when we are inserting /
    // removing rows via the api is dontCreatePage set, where we move rows between the pages.
    getRow(rowIndex, dontCreatePage = false) {
        const blockId = Math.floor(rowIndex / this.params.blockSize);
        let block = this.blocks[blockId];
        if (!block) {
            if (dontCreatePage) return void 0;
            block = this.createBlock(blockId);
        }
        return block.getRow(rowIndex);
    }
    createBlock(blockNumber) {
        const params = this.params;
        const newBlock = this.createBean(new $437b23f6a393c3bf$var$InfiniteBlock(blockNumber, this, params));
        this.blocks[newBlock.id] = newBlock;
        this.blockCount++;
        this.purgeBlocksIfNeeded(newBlock);
        params.rowNodeBlockLoader.addBlock(newBlock);
        return newBlock;
    }
    // we have this on infinite row model only, not server side row model,
    // because for server side, it would leave the children in inconsistent
    // state - eg if a node had children, but after the refresh it had data
    // for a different row, then the children would be with the wrong row node.
    refreshCache() {
        const nothingToRefresh = this.blockCount == 0;
        if (nothingToRefresh) {
            this.purgeCache();
            return;
        }
        this.getBlocksInOrder().forEach((block)=>block.setStateWaitingToLoad());
        this.params.rowNodeBlockLoader.checkBlockToLoad();
    }
    destroy() {
        this.getBlocksInOrder().forEach((block)=>this.destroyBlock(block));
        super.destroy();
    }
    getRowCount() {
        return this.rowCount;
    }
    isLastRowIndexKnown() {
        return this.lastRowIndexKnown;
    }
    // block calls this, when page loaded
    pageLoaded(block, lastRow) {
        if (!this.isAlive()) return;
        $437b23f6a393c3bf$var$_logIfDebug(this.gos, `InfiniteCache - onPageLoaded: page = ${block.id}, lastRow = ${lastRow}`);
        this.checkRowCount(block, lastRow);
        this.onCacheUpdated();
    }
    purgeBlocksIfNeeded(blockToExclude) {
        const blocksForPurging = this.getBlocksInOrder().filter((b)=>b != blockToExclude);
        const lastAccessedComparator = (a, b)=>b.lastAccessed - a.lastAccessed;
        blocksForPurging.sort(lastAccessedComparator);
        const maxBlocksProvided = this.params.maxBlocksInCache > 0;
        const blocksToKeep = maxBlocksProvided ? this.params.maxBlocksInCache - 1 : null;
        const emptyBlocksToKeep = $437b23f6a393c3bf$var$MAX_EMPTY_BLOCKS_TO_KEEP - 1;
        blocksForPurging.forEach((block, index)=>{
            const purgeBecauseBlockEmpty = block.state === "needsLoading" && index >= emptyBlocksToKeep;
            const purgeBecauseCacheFull = maxBlocksProvided ? index >= blocksToKeep : false;
            if (purgeBecauseBlockEmpty || purgeBecauseCacheFull) {
                if (this.isBlockCurrentlyDisplayed(block)) return;
                if (this.isBlockFocused(block)) return;
                this.removeBlockFromCache(block);
            }
        });
    }
    isBlockFocused(block) {
        const focusedCell = this.beans.focusSvc.getFocusCellToUseAfterRefresh();
        if (!focusedCell) return false;
        if (focusedCell.rowPinned != null) return false;
        const { startRow: startRow, endRow: endRow } = block;
        const hasFocus = focusedCell.rowIndex >= startRow && focusedCell.rowIndex < endRow;
        return hasFocus;
    }
    isBlockCurrentlyDisplayed(block) {
        const { startRow: startRow, endRow: endRow } = block;
        return this.beans.rowRenderer.isRangeInRenderedViewport(startRow, endRow - 1);
    }
    removeBlockFromCache(blockToRemove) {
        if (!blockToRemove) return;
        this.destroyBlock(blockToRemove);
    }
    checkRowCount(block, lastRow) {
        if (typeof lastRow === "number" && lastRow >= 0) {
            this.rowCount = lastRow;
            this.lastRowIndexKnown = true;
        } else if (!this.lastRowIndexKnown) {
            const { blockSize: blockSize, overflowSize: overflowSize } = this.params;
            const lastRowIndex = (block.id + 1) * blockSize;
            const lastRowIndexPlusOverflow = lastRowIndex + overflowSize;
            if (this.rowCount < lastRowIndexPlusOverflow) this.rowCount = lastRowIndexPlusOverflow;
        }
    }
    setRowCount(rowCount, lastRowIndexKnown) {
        this.rowCount = rowCount;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(lastRowIndexKnown)) this.lastRowIndexKnown = lastRowIndexKnown;
        if (!this.lastRowIndexKnown) {
            if (this.rowCount % this.params.blockSize === 0) this.rowCount++;
        }
        this.onCacheUpdated();
    }
    forEachNodeDeep(callback) {
        const sequence = {
            value: 0
        };
        this.getBlocksInOrder().forEach((block)=>block.forEachNode(callback, sequence, this.rowCount));
    }
    getBlocksInOrder() {
        const blockComparator = (a, b)=>a.id - b.id;
        const blocks = Object.values(this.blocks).sort(blockComparator);
        return blocks;
    }
    destroyBlock(block) {
        delete this.blocks[block.id];
        this.destroyBean(block);
        this.blockCount--;
        this.params.rowNodeBlockLoader.removeBlock(block);
    }
    // gets called 1) row count changed 2) cache purged 3) items inserted
    onCacheUpdated() {
        if (this.isAlive()) {
            this.destroyAllBlocksPastVirtualRowCount();
            this.eventSvc.dispatchEvent({
                type: "storeUpdated"
            });
        }
    }
    destroyAllBlocksPastVirtualRowCount() {
        const blocksToDestroy = [];
        this.getBlocksInOrder().forEach((block)=>{
            const startRow = block.id * this.params.blockSize;
            if (startRow >= this.rowCount) blocksToDestroy.push(block);
        });
        if (blocksToDestroy.length > 0) blocksToDestroy.forEach((block)=>this.destroyBlock(block));
    }
    purgeCache() {
        this.getBlocksInOrder().forEach((block)=>this.removeBlockFromCache(block));
        this.lastRowIndexKnown = false;
        if (this.rowCount === 0) this.rowCount = this.params.initialRowCount;
        this.onCacheUpdated();
    }
    getRowNodesInRange(firstInRange, lastInRange) {
        const result = [];
        let lastBlockId = -1;
        let inActiveRange = false;
        const numberSequence = {
            value: 0
        };
        let foundGapInSelection = false;
        this.getBlocksInOrder().forEach((block)=>{
            if (foundGapInSelection) return;
            if (inActiveRange && lastBlockId + 1 !== block.id) {
                foundGapInSelection = true;
                return;
            }
            lastBlockId = block.id;
            block.forEachNode((rowNode)=>{
                const hitFirstOrLast = rowNode === firstInRange || rowNode === lastInRange;
                if (inActiveRange || hitFirstOrLast) result.push(rowNode);
                if (hitFirstOrLast) inActiveRange = !inActiveRange;
            }, numberSequence, this.rowCount);
        });
        const invalidRange = foundGapInSelection || inActiveRange;
        return invalidRange ? [] : result;
    }
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteRowModel.ts
var $437b23f6a393c3bf$var$InfiniteRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowModel";
    }
    getRowBounds(index) {
        return {
            rowHeight: this.rowHeight,
            rowTop: this.rowHeight * index
        };
    }
    // we don't implement as lazy row heights is not supported in this row model
    ensureRowHeightsValid() {
        return false;
    }
    postConstruct() {
        if (this.gos.get("rowModelType") !== "infinite") return;
        this.rowHeight = $437b23f6a393c3bf$export$8966875adec41e5b(this.beans);
        this.addEventListeners();
        this.addDestroyFunc(()=>this.destroyCache());
    }
    start() {
        this.setDatasource(this.gos.get("datasource"));
    }
    destroy() {
        this.destroyDatasource();
        super.destroy();
    }
    destroyDatasource() {
        if (this.datasource) {
            this.destroyBean(this.datasource);
            this.beans.rowRenderer.datasourceChanged();
            this.datasource = null;
        }
    }
    addEventListeners() {
        this.addManagedEventListeners({
            filterChanged: this.reset.bind(this),
            sortChanged: this.reset.bind(this),
            newColumnsLoaded: this.onColumnEverything.bind(this),
            storeUpdated: this.dispatchModelUpdatedEvent.bind(this)
        });
        this.addManagedPropertyListener("datasource", ()=>this.setDatasource(this.gos.get("datasource")));
        this.addManagedPropertyListener("cacheBlockSize", ()=>this.resetCache());
        this.addManagedPropertyListener("rowHeight", ()=>{
            this.rowHeight = $437b23f6a393c3bf$export$8966875adec41e5b(this.beans);
            this.cacheParams.rowHeight = this.rowHeight;
            this.updateRowHeights();
        });
    }
    onColumnEverything() {
        let resetRequired;
        if (this.cacheParams) resetRequired = !$437b23f6a393c3bf$export$dbc2068cc90f5875(this.cacheParams.sortModel, this.beans.sortSvc?.getSortModel() ?? []);
        else resetRequired = true;
        if (resetRequired) this.reset();
    }
    getType() {
        return "infinite";
    }
    setDatasource(datasource) {
        this.destroyDatasource();
        this.datasource = datasource;
        if (datasource) this.reset();
    }
    isEmpty() {
        return !this.infiniteCache;
    }
    isRowsToRender() {
        return !!this.infiniteCache;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        return this.infiniteCache?.getRowNodesInRange(firstInRange, lastInRange) ?? [];
    }
    reset() {
        if (!this.datasource) return;
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        const userGeneratingIds = getRowIdFunc != null;
        if (!userGeneratingIds) this.beans.selectionSvc?.reset("rowDataChanged");
        this.resetCache();
    }
    dispatchModelUpdatedEvent() {
        this.eventSvc.dispatchEvent({
            type: "modelUpdated",
            // not sure if these should all be false - noticed if after implementing,
            // maybe they should be true?
            newPage: false,
            newPageSize: false,
            newData: false,
            keepRenderedRows: true,
            animate: false
        });
    }
    resetCache() {
        this.destroyCache();
        const beans = this.beans;
        const { filterManager: filterManager, sortSvc: sortSvc, rowNodeBlockLoader: rowNodeBlockLoader, eventSvc: eventSvc, gos: gos } = beans;
        this.cacheParams = {
            // the user provided datasource
            datasource: this.datasource,
            // sort and filter model
            filterModel: filterManager?.getFilterModel() ?? {},
            sortModel: sortSvc?.getSortModel() ?? [],
            rowNodeBlockLoader: rowNodeBlockLoader,
            // properties - this way we take a snapshot of them, so if user changes any, they will be
            // used next time we create a new cache, which is generally after a filter or sort change,
            // or a new datasource is set
            initialRowCount: gos.get("infiniteInitialRowCount"),
            maxBlocksInCache: gos.get("maxBlocksInCache"),
            rowHeight: $437b23f6a393c3bf$export$8966875adec41e5b(beans),
            // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
            // the current page and request first row of next page
            overflowSize: gos.get("cacheOverflowSize"),
            // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
            // server for one page at a time. so the default if not specified is 100.
            blockSize: gos.get("cacheBlockSize"),
            // the cache could create this, however it is also used by the pages, so handy to create it
            // here as the settings are also passed to the pages
            lastAccessedSequence: {
                value: 0
            }
        };
        this.infiniteCache = this.createBean(new $437b23f6a393c3bf$var$InfiniteCache(this.cacheParams));
        eventSvc.dispatchEventOnce({
            type: "rowCountReady"
        });
        this.dispatchModelUpdatedEvent();
    }
    updateRowHeights() {
        this.forEachNode((node)=>{
            node.setRowHeight(this.rowHeight);
            node.setRowTop(this.rowHeight * node.rowIndex);
        });
        this.dispatchModelUpdatedEvent();
    }
    destroyCache() {
        this.infiniteCache = this.destroyBean(this.infiniteCache);
    }
    getRow(rowIndex) {
        const infiniteCache = this.infiniteCache;
        if (!infiniteCache) return void 0;
        if (rowIndex >= infiniteCache.getRowCount()) return void 0;
        return infiniteCache.getRow(rowIndex);
    }
    getRowNode(id) {
        let result;
        this.forEachNode((rowNode)=>{
            if (rowNode.id === id) result = rowNode;
        });
        return result;
    }
    forEachNode(callback) {
        this.infiniteCache?.forEachNodeDeep(callback);
    }
    getTopLevelRowCount() {
        return this.getRowCount();
    }
    getTopLevelRowDisplayedIndex(topLevelIndex) {
        return topLevelIndex;
    }
    getRowIndexAtPixel(pixel) {
        if (this.rowHeight !== 0) {
            const rowIndexForPixel = Math.floor(pixel / this.rowHeight);
            const lastRowIndex = this.getRowCount() - 1;
            if (rowIndexForPixel > lastRowIndex) return lastRowIndex;
            return rowIndexForPixel;
        }
        return 0;
    }
    getRowCount() {
        return this.infiniteCache ? this.infiniteCache.getRowCount() : 0;
    }
    isRowPresent(rowNode) {
        return !!this.getRowNode(rowNode.id);
    }
    refreshCache() {
        this.infiniteCache?.refreshCache();
    }
    purgeCache() {
        this.infiniteCache?.purgeCache();
    }
    // for iRowModel
    isLastRowIndexKnown() {
        return this.infiniteCache?.isLastRowIndexKnown() ?? false;
    }
    setRowCount(rowCount, lastRowIndexKnown) {
        this.infiniteCache?.setRowCount(rowCount, lastRowIndexKnown);
    }
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteRowModelApi.ts
function $437b23f6a393c3bf$var$refreshInfiniteCache(beans) {
    $437b23f6a393c3bf$var$_getInfiniteRowModel(beans)?.refreshCache();
}
function $437b23f6a393c3bf$var$purgeInfiniteCache(beans) {
    $437b23f6a393c3bf$var$_getInfiniteRowModel(beans)?.purgeCache();
}
function $437b23f6a393c3bf$var$getInfiniteRowCount(beans) {
    return $437b23f6a393c3bf$var$_getInfiniteRowModel(beans)?.getRowCount();
}
// packages/ag-grid-community/src/infiniteRowModel/rowNodeBlockLoader.ts
var $437b23f6a393c3bf$var$RowNodeBlockLoader = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowNodeBlockLoader";
        this.activeBlockLoadsCount = 0;
        this.blocks = [];
        this.active = true;
    }
    postConstruct() {
        this.maxConcurrentRequests = $437b23f6a393c3bf$export$efae4c751fa7cc4d(this.gos);
        const blockLoadDebounceMillis = this.gos.get("blockLoadDebounceMillis");
        if (blockLoadDebounceMillis && blockLoadDebounceMillis > 0) this.checkBlockToLoadDebounce = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.performCheckBlocksToLoad.bind(this), blockLoadDebounceMillis);
    }
    addBlock(block) {
        this.blocks.push(block);
        block.addEventListener("loadComplete", this.loadComplete.bind(this));
        this.checkBlockToLoad();
    }
    removeBlock(block) {
        $437b23f6a393c3bf$export$83a881c8b5120679(this.blocks, block);
    }
    destroy() {
        super.destroy();
        this.active = false;
    }
    loadComplete() {
        this.activeBlockLoadsCount--;
        this.checkBlockToLoad();
    }
    checkBlockToLoad() {
        if (this.checkBlockToLoadDebounce) this.checkBlockToLoadDebounce();
        else this.performCheckBlocksToLoad();
    }
    performCheckBlocksToLoad() {
        if (!this.active) return;
        this.printCacheStatus();
        if (this.maxConcurrentRequests != null && this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
            $437b23f6a393c3bf$var$_logIfDebug(this.gos, `RowNodeBlockLoader - checkBlockToLoad: max loads exceeded`);
            return;
        }
        const loadAvailability = this.maxConcurrentRequests != null ? this.maxConcurrentRequests - this.activeBlockLoadsCount : 1;
        const blocksToLoad = this.blocks.filter((block)=>block.state === "needsLoading").slice(0, loadAvailability);
        this.activeBlockLoadsCount += blocksToLoad.length;
        blocksToLoad.forEach((block)=>block.load());
        this.printCacheStatus();
    }
    getBlockState() {
        const result = {};
        this.blocks.forEach((block)=>{
            const { id: id, state: state } = block.getBlockStateJson();
            result[id] = state;
        });
        return result;
    }
    printCacheStatus() {
        $437b23f6a393c3bf$var$_logIfDebug(this.gos, `RowNodeBlockLoader - printCacheStatus: activePageLoadsCount = ${this.activeBlockLoadsCount}, blocks = ${JSON.stringify(this.getBlockState())}`);
    }
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteRowModelModule.ts
var $437b23f6a393c3bf$var$InfiniteRowModelCoreModule = {
    moduleName: "InfiniteRowModelCore",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "infinite"
    ],
    beans: [
        $437b23f6a393c3bf$var$InfiniteRowModel,
        $437b23f6a393c3bf$var$RowNodeBlockLoader
    ]
};
var $437b23f6a393c3bf$export$ca8341149bdd39bc = {
    moduleName: "InfiniteRowModel",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        refreshInfiniteCache: $437b23f6a393c3bf$var$refreshInfiniteCache,
        purgeInfiniteCache: $437b23f6a393c3bf$var$purgeInfiniteCache,
        getInfiniteRowCount: $437b23f6a393c3bf$var$getInfiniteRowCount
    },
    dependsOn: [
        $437b23f6a393c3bf$var$InfiniteRowModelCoreModule,
        $437b23f6a393c3bf$export$2f6740e35dedc261
    ]
};
// packages/ag-grid-community/src/rendering/cellRenderers/animateShowChangeCellRenderer.ts
var $437b23f6a393c3bf$var$ARROW_UP = "\u2191";
var $437b23f6a393c3bf$var$ARROW_DOWN = "\u2193";
var $437b23f6a393c3bf$var$AnimateShowChangeCellRendererElement = {
    tag: "span",
    children: [
        {
            tag: "span",
            ref: "eDelta",
            cls: "ag-value-change-delta"
        },
        {
            tag: "span",
            ref: "eValue",
            cls: "ag-value-change-value"
        }
    ]
};
var $437b23f6a393c3bf$var$AnimateShowChangeCellRenderer = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$AnimateShowChangeCellRendererElement);
        this.eValue = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eDelta = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.refreshCount = 0;
    }
    init(params) {
        this.refresh(params, true);
    }
    showDelta(params, delta) {
        const absDelta = Math.abs(delta);
        const valueFormatted = params.formatValue(absDelta);
        const valueToUse = $437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted) ? valueFormatted : absDelta;
        const deltaUp = delta >= 0;
        const eDelta = this.eDelta;
        if (deltaUp) eDelta.textContent = $437b23f6a393c3bf$var$ARROW_UP + valueToUse;
        else eDelta.textContent = $437b23f6a393c3bf$var$ARROW_DOWN + valueToUse;
        eDelta.classList.toggle("ag-value-change-delta-up", deltaUp);
        eDelta.classList.toggle("ag-value-change-delta-down", !deltaUp);
    }
    setTimerToRemoveDelta() {
        this.refreshCount++;
        const refreshCountCopy = this.refreshCount;
        this.beans.frameworkOverrides.wrapIncoming(()=>{
            window.setTimeout(()=>{
                if (refreshCountCopy === this.refreshCount) this.hideDeltaValue();
            }, 2e3);
        });
    }
    hideDeltaValue() {
        this.eValue.classList.remove("ag-value-change-value-highlight");
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.eDelta);
    }
    refresh(params, isInitialRender = false) {
        const { value: value, valueFormatted: valueFormatted } = params;
        const { eValue: eValue, lastValue: lastValue, beans: beans } = this;
        if (value === lastValue) return false;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted)) eValue.textContent = valueFormatted;
        else if ($437b23f6a393c3bf$export$25d27f17d3af40f7(value)) eValue.textContent = value;
        else $437b23f6a393c3bf$export$69e6e10709eabd91(eValue);
        if (beans.filterManager?.isSuppressFlashingCellsBecauseFiltering()) return false;
        const numericValue = value && typeof value === "object" && "toNumber" in value ? value.toNumber() : value;
        const numericLastValue = lastValue && typeof lastValue === "object" && "toNumber" in lastValue ? lastValue.toNumber() : lastValue;
        if (numericValue === numericLastValue) return false;
        if (typeof numericValue === "number" && typeof numericLastValue === "number") {
            const delta = numericValue - numericLastValue;
            this.showDelta(params, delta);
        }
        if (lastValue) eValue.classList.add("ag-value-change-value-highlight");
        if (!isInitialRender) this.setTimerToRemoveDelta();
        this.lastValue = value;
        return true;
    }
};
// packages/ag-grid-community/src/rendering/cellRenderers/animateSlideCellRenderer.css-GENERATED.ts
var $437b23f6a393c3bf$var$animateSlideCellRendererCSS = /*css*/ `.ag-value-slide-out{opacity:1}:where(.ag-ltr) .ag-value-slide-out{margin-right:5px;transition:opacity 3s,margin-right 3s}:where(.ag-rtl) .ag-value-slide-out{margin-left:5px;transition:opacity 3s,margin-left 3s}:where(.ag-ltr,.ag-rtl) .ag-value-slide-out{transition-timing-function:linear}.ag-value-slide-out-end{opacity:0}:where(.ag-ltr) .ag-value-slide-out-end{margin-right:10px}:where(.ag-rtl) .ag-value-slide-out-end{margin-left:10px}`;
// packages/ag-grid-community/src/rendering/cellRenderers/animateSlideCellRenderer.ts
var $437b23f6a393c3bf$var$AnimateSlideCellRendererElement = {
    tag: "span",
    children: [
        {
            tag: "span",
            ref: "eCurrent",
            cls: "ag-value-slide-current"
        }
    ]
};
var $437b23f6a393c3bf$var$AnimateSlideCellRenderer = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$AnimateSlideCellRendererElement);
        this.eCurrent = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.refreshCount = 0;
        this.registerCSS($437b23f6a393c3bf$var$animateSlideCellRendererCSS);
    }
    init(params) {
        this.refresh(params, true);
    }
    addSlideAnimation() {
        this.refreshCount++;
        const refreshCountCopy = this.refreshCount;
        if (this.ePrevious) this.getGui().removeChild(this.ePrevious);
        const { beans: beans, eCurrent: eCurrent } = this;
        const prevElement = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "span",
            cls: "ag-value-slide-previous ag-value-slide-out"
        });
        this.ePrevious = prevElement;
        prevElement.textContent = eCurrent.textContent;
        this.getGui().insertBefore(prevElement, eCurrent);
        beans.frameworkOverrides.wrapIncoming(()=>{
            window.setTimeout(()=>{
                if (refreshCountCopy !== this.refreshCount) return;
                this.ePrevious.classList.add("ag-value-slide-out-end");
            }, 50);
            window.setTimeout(()=>{
                if (refreshCountCopy !== this.refreshCount) return;
                this.getGui().removeChild(this.ePrevious);
                this.ePrevious = null;
            }, 3e3);
        });
    }
    refresh(params, isInitialRender = false) {
        let value = params.value;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(value)) value = "";
        if (value === this.lastValue) return false;
        if (this.beans.filterManager?.isSuppressFlashingCellsBecauseFiltering()) return false;
        if (!isInitialRender) this.addSlideAnimation();
        this.lastValue = value;
        const eCurrent = this.eCurrent;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(params.valueFormatted)) eCurrent.textContent = params.valueFormatted;
        else if ($437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) eCurrent.textContent = value;
        else $437b23f6a393c3bf$export$69e6e10709eabd91(eCurrent);
        return true;
    }
};
// packages/ag-grid-community/src/rendering/cell/cellFlashService.ts
var $437b23f6a393c3bf$var$CellFlashService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "cellFlashSvc";
        this.nextAnimationTime = null;
        this.nextAnimationCycle = null;
        this.animations = {
            highlight: /* @__PURE__ */ new Map(),
            "data-changed": /* @__PURE__ */ new Map()
        };
    }
    animateCell(cellCtrl, cssName, flashDuration = this.beans.gos.get("cellFlashDuration"), fadeDuration = this.beans.gos.get("cellFadeDuration")) {
        const animations = this.animations[cssName];
        animations.delete(cellCtrl);
        const time = Date.now();
        const flashEndTime = time + flashDuration;
        const fadeEndTime = time + flashDuration + fadeDuration;
        const animState = {
            phase: "flash",
            flashEndTime: flashEndTime,
            fadeEndTime: fadeEndTime
        };
        animations.set(cellCtrl, animState);
        const cssBase = `ag-cell-${cssName}`;
        const cssAnimation = `${cssBase}-animation`;
        const { comp: comp, eGui: { style: style } } = cellCtrl;
        comp.toggleCss(cssBase, true);
        comp.toggleCss(cssAnimation, false);
        style.removeProperty("transition");
        style.removeProperty("transition-delay");
        if (this.nextAnimationTime && flashEndTime + 15 < this.nextAnimationTime) {
            clearTimeout(this.nextAnimationCycle);
            this.nextAnimationCycle = null;
            this.nextAnimationTime = null;
        }
        if (!this.nextAnimationCycle) {
            this.beans.frameworkOverrides.wrapIncoming(()=>{
                this.nextAnimationCycle = setTimeout(this.advanceAnimations.bind(this), flashDuration);
            });
            this.nextAnimationTime = flashEndTime;
        }
    }
    advanceAnimations() {
        const time = Date.now();
        let nextAnimationTime = null;
        for (const cssName of Object.keys(this.animations)){
            const animations = this.animations[cssName];
            const cssBase = `ag-cell-${cssName}`;
            const cssAnimation = `${cssBase}-animation`;
            for (const [cell, animState] of animations){
                if (!cell.isAlive() || !cell.comp) {
                    animations.delete(cell);
                    continue;
                }
                const { phase: phase, flashEndTime: flashEndTime, fadeEndTime: fadeEndTime } = animState;
                const nextActionableTime = phase === "flash" ? flashEndTime : fadeEndTime;
                const requiresAction = time + 15 >= nextActionableTime;
                if (!requiresAction) {
                    nextAnimationTime = Math.min(nextActionableTime, nextAnimationTime ?? Infinity);
                    continue;
                }
                const { comp: comp, eGui: { style: style } } = cell;
                switch(phase){
                    case "flash":
                        comp.toggleCss(cssBase, false);
                        comp.toggleCss(cssAnimation, true);
                        style.transition = `background-color ${fadeEndTime - flashEndTime}ms`;
                        style.transitionDelay = `${flashEndTime - time}ms`;
                        nextAnimationTime = Math.min(fadeEndTime, nextAnimationTime ?? Infinity);
                        animState.phase = "fade";
                        break;
                    case "fade":
                        comp.toggleCss(cssBase, false);
                        comp.toggleCss(cssAnimation, false);
                        style.removeProperty("transition");
                        style.removeProperty("transition-delay");
                        animations.delete(cell);
                        break;
                }
            }
        }
        if (nextAnimationTime == null) {
            this.nextAnimationTime = null;
            this.nextAnimationCycle = null;
        } else if (nextAnimationTime) {
            this.nextAnimationCycle = setTimeout(this.advanceAnimations.bind(this), nextAnimationTime - time);
            this.nextAnimationTime = nextAnimationTime;
        }
    }
    onFlashCells(cellCtrl, event) {
        if (!cellCtrl.comp) return;
        const cellId = $437b23f6a393c3bf$export$c0c5a5ba9327269f(cellCtrl.cellPosition);
        const shouldFlash = event.cells[cellId];
        if (shouldFlash) this.animateCell(cellCtrl, "highlight");
    }
    flashCell(cellCtrl, delays) {
        this.animateCell(cellCtrl, "data-changed", delays?.flashDuration, delays?.fadeDuration);
    }
    destroy() {
        for (const cssName of Object.keys(this.animations)){
            const animations = this.animations[cssName];
            animations.clear();
        }
    }
};
// packages/ag-grid-community/src/rendering/cell/highlightChangesApi.ts
function $437b23f6a393c3bf$var$flashCells(beans, params = {}) {
    const { cellFlashSvc: cellFlashSvc } = beans;
    if (!cellFlashSvc) return;
    beans.frameworkOverrides.wrapIncoming(()=>{
        beans.rowRenderer.getCellCtrls(params.rowNodes, params.columns).forEach((cellCtrl)=>cellFlashSvc.flashCell(cellCtrl, params));
    });
}
// packages/ag-grid-community/src/rendering/cell/highlightChangesModule.ts
var $437b23f6a393c3bf$export$98e8472b11750a07 = {
    moduleName: "HighlightChanges",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$CellFlashService
    ],
    userComponents: {
        agAnimateShowChangeCellRenderer: $437b23f6a393c3bf$var$AnimateShowChangeCellRenderer,
        agAnimateSlideCellRenderer: $437b23f6a393c3bf$var$AnimateSlideCellRenderer
    },
    apiFunctions: {
        flashCells: $437b23f6a393c3bf$var$flashCells
    }
};
// packages/ag-grid-community/src/misc/state/stateApi.ts
function $437b23f6a393c3bf$var$getState(beans) {
    return beans.stateSvc?.getState() ?? {};
}
function $437b23f6a393c3bf$var$setState(beans, state, propertiesToIgnore) {
    return beans.stateSvc?.setState(state, propertiesToIgnore);
}
// packages/ag-grid-community/src/misc/state/stateModelMigration.ts
function $437b23f6a393c3bf$var$migrateGridStateModel(state) {
    state = {
        ...state
    };
    if (!state.version) state.version = "32.1.0";
    switch(state.version){
        case "32.1.0":
            state = $437b23f6a393c3bf$var$migrateV32_1(state);
    }
    state.version = $437b23f6a393c3bf$var$VERSION;
    return state;
}
function $437b23f6a393c3bf$var$migrateV32_1(state) {
    state.cellSelection = $437b23f6a393c3bf$var$jsonGet(state, "rangeSelection");
    return state;
}
function $437b23f6a393c3bf$var$jsonGet(json, key) {
    if (json && typeof json === "object") return json[key];
}
// packages/ag-grid-community/src/misc/state/stateService.ts
var $437b23f6a393c3bf$var$StateService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "stateSvc";
        this.updateRowGroupExpansionStateTimer = 0;
        this.suppressEvents = true;
        this.queuedUpdateSources = /* @__PURE__ */ new Set();
        this.dispatchStateUpdateEventDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>this.dispatchQueuedStateUpdateEvents(), 0);
        // If user is doing a manual expand all node by node, we don't want to process one at a time.
        // EVENT_ROW_GROUP_OPENED is already async, so no impact of making the state async here.
        this.onRowGroupOpenedDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>{
            this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState());
        }, 0);
        // similar to row expansion, want to debounce. However, selection is synchronous, so need to mark as stale in case `getState` is called.
        this.onRowSelectedDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>{
            this.staleStateKeys.delete("rowSelection");
            this.updateCachedState("rowSelection", this.getRowSelectionState());
        }, 0);
        this.staleStateKeys = /* @__PURE__ */ new Set();
    }
    postConstruct() {
        this.isClientSideRowModel = $437b23f6a393c3bf$export$9f182d9ca737e15(this.gos);
        const initialState = $437b23f6a393c3bf$var$migrateGridStateModel(this.gos.get("initialState") ?? {});
        const partialColumnState = initialState.partialColumnState;
        delete initialState.partialColumnState;
        this.cachedState = initialState;
        const suppressEventsAndDispatchInitEvent = this.suppressEventsAndDispatchInitEvent.bind(this);
        this.beans.ctrlsSvc.whenReady(this, ()=>suppressEventsAndDispatchInitEvent(()=>this.setupStateOnGridReady(initialState)));
        const [newColumnsLoadedDestroyFunc, rowCountReadyDestroyFunc, firstDataRenderedDestroyFunc] = this.addManagedEventListeners({
            newColumnsLoaded: ({ source: source })=>{
                if (source === "gridInitializing") {
                    newColumnsLoadedDestroyFunc();
                    suppressEventsAndDispatchInitEvent(()=>this.setupStateOnColumnsInitialised(initialState, !!partialColumnState));
                }
            },
            rowCountReady: ()=>{
                rowCountReadyDestroyFunc?.();
                suppressEventsAndDispatchInitEvent(()=>this.setupStateOnRowCountReady(initialState));
            },
            firstDataRendered: ()=>{
                firstDataRenderedDestroyFunc?.();
                suppressEventsAndDispatchInitEvent(()=>this.setupStateOnFirstDataRendered(initialState));
            }
        });
    }
    destroy() {
        super.destroy();
        clearTimeout(this.updateRowGroupExpansionStateTimer);
        this.queuedUpdateSources.clear();
    }
    getState() {
        if (this.staleStateKeys.size) this.refreshStaleState();
        return this.cachedState;
    }
    setState(providedState, propertiesToIgnore) {
        const state = $437b23f6a393c3bf$var$migrateGridStateModel(providedState);
        delete state.partialColumnState;
        this.cachedState = state;
        this.startSuppressEvents();
        const source = "api";
        const ignoreSet = propertiesToIgnore ? new Set(propertiesToIgnore) : void 0;
        this.setGridReadyState(state, source, ignoreSet);
        this.setColumnsInitialisedState(state, source, false, ignoreSet);
        this.setRowCountState(state, source, ignoreSet);
        setTimeout(()=>{
            if (this.isAlive()) this.setFirstDataRenderedState(state, source, ignoreSet);
            this.stopSuppressEvents(source);
        });
    }
    setGridReadyState(state, source, ignoreSet) {
        if (source === "api" && !ignoreSet?.has("sideBar")) this.beans.sideBar?.comp?.setState(state.sideBar);
        this.updateCachedState("sideBar", this.getSideBarState());
    }
    setupStateOnGridReady(initialState) {
        this.setGridReadyState(initialState, "gridInitializing");
        const stateUpdater = ()=>this.updateCachedState("sideBar", this.getSideBarState());
        this.addManagedEventListeners({
            toolPanelVisibleChanged: stateUpdater,
            sideBarUpdated: stateUpdater
        });
    }
    updateColumnAndGroupState() {
        this.updateColumnState([
            "aggregation",
            "columnOrder",
            "columnPinning",
            "columnSizing",
            "columnVisibility",
            "pivot",
            "rowGroup",
            "sort"
        ]);
        this.updateCachedState("columnGroup", this.getColumnGroupState());
    }
    setColumnsInitialisedState(state, source, partialColumnState, ignoreSet) {
        this.setColumnState(state, source, partialColumnState, ignoreSet);
        this.setColumnGroupState(state, source, ignoreSet);
        this.updateColumnAndGroupState();
    }
    setupStateOnColumnsInitialised(initialState, partialColumnState) {
        this.setColumnsInitialisedState(initialState, "gridInitializing", partialColumnState);
        const onUpdate = (state)=>()=>this.updateColumnState([
                    state
                ]);
        this.addManagedEventListeners({
            columnValueChanged: onUpdate("aggregation"),
            columnMoved: onUpdate("columnOrder"),
            columnPinned: onUpdate("columnPinning"),
            columnResized: onUpdate("columnSizing"),
            columnVisible: onUpdate("columnVisibility"),
            columnPivotChanged: onUpdate("pivot"),
            columnPivotModeChanged: onUpdate("pivot"),
            columnRowGroupChanged: onUpdate("rowGroup"),
            sortChanged: onUpdate("sort"),
            newColumnsLoaded: this.updateColumnAndGroupState.bind(this),
            columnGroupOpened: ()=>this.updateCachedState("columnGroup", this.getColumnGroupState())
        });
    }
    setRowCountState(state, source, ignoreSet) {
        const { filter: filterState, rowGroupExpansion: rowGroupExpansionState, rowSelection: rowSelectionState, pagination: paginationState } = state;
        const shouldSetState = (prop, propState)=>!ignoreSet?.has(prop) && (propState || source === "api");
        if (shouldSetState("filter", filterState)) this.setFilterState(filterState);
        if (shouldSetState("rowGroupExpansion", rowGroupExpansionState)) this.setRowGroupExpansionState(rowGroupExpansionState, source);
        if (shouldSetState("rowSelection", rowSelectionState)) this.setRowSelectionState(rowSelectionState, source);
        if (shouldSetState("pagination", paginationState)) this.setPaginationState(paginationState, source);
        const updateCachedState = this.updateCachedState.bind(this);
        updateCachedState("filter", this.getFilterState());
        updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState());
        updateCachedState("rowSelection", this.getRowSelectionState());
        updateCachedState("pagination", this.getPaginationState());
    }
    setupStateOnRowCountReady(initialState) {
        this.setRowCountState(initialState, "gridInitializing");
        const updateCachedState = this.updateCachedState.bind(this);
        const updateRowGroupExpansionState = ()=>{
            this.updateRowGroupExpansionStateTimer = 0;
            updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState());
        };
        const updateFilterState = ()=>updateCachedState("filter", this.getFilterState());
        const { gos: gos, colFilter: colFilter } = this.beans;
        this.addManagedEventListeners({
            filterChanged: updateFilterState,
            rowGroupOpened: ()=>this.onRowGroupOpenedDebounced(),
            expandOrCollapseAll: updateRowGroupExpansionState,
            // `groupDefaultExpanded`/`isGroupOpenByDefault` updates expansion state without an expansion event
            columnRowGroupChanged: updateRowGroupExpansionState,
            rowDataUpdated: ()=>{
                if (gos.get("groupDefaultExpanded") !== 0 || gos.get("isGroupOpenByDefault")) this.updateRowGroupExpansionStateTimer || (this.updateRowGroupExpansionStateTimer = setTimeout(updateRowGroupExpansionState));
            },
            selectionChanged: ()=>{
                this.staleStateKeys.add("rowSelection");
                this.onRowSelectedDebounced();
            },
            paginationChanged: (event)=>{
                if (event.newPage || event.newPageSize) updateCachedState("pagination", this.getPaginationState());
            }
        });
        if (colFilter) this.addManagedListeners(colFilter, {
            filterStateChanged: updateFilterState
        });
    }
    setFirstDataRenderedState(state, source, ignoreSet) {
        const { scroll: scrollState, cellSelection: cellSelectionState, focusedCell: focusedCellState, columnOrder: columnOrderState, rowPinning: rowPinning } = state;
        const shouldSetState = (prop, propState)=>!ignoreSet?.has(prop) && (propState || source === "api");
        if (shouldSetState("focusedCell", focusedCellState)) this.setFocusedCellState(focusedCellState);
        if (shouldSetState("cellSelection", cellSelectionState)) this.setCellSelectionState(cellSelectionState);
        if (shouldSetState("scroll", scrollState)) this.setScrollState(scrollState);
        if (shouldSetState("rowPinning", rowPinning)) this.setRowPinningState(rowPinning);
        this.setColumnPivotState(!!columnOrderState?.orderedColIds, source);
        const updateCachedState = this.updateCachedState.bind(this);
        updateCachedState("sideBar", this.getSideBarState());
        updateCachedState("focusedCell", this.getFocusedCellState());
        const cellSelection = this.getRangeSelectionState();
        updateCachedState("rangeSelection", cellSelection);
        updateCachedState("cellSelection", cellSelection);
        updateCachedState("scroll", this.getScrollState());
    }
    setupStateOnFirstDataRendered(initialState) {
        this.setFirstDataRenderedState(initialState, "gridInitializing");
        const updateCachedState = this.updateCachedState.bind(this);
        this.addManagedEventListeners({
            cellFocused: ()=>updateCachedState("focusedCell", this.getFocusedCellState()),
            cellSelectionChanged: (event)=>{
                if (event.finished) {
                    const cellSelection = this.getRangeSelectionState();
                    updateCachedState("rangeSelection", cellSelection);
                    updateCachedState("cellSelection", cellSelection);
                }
            },
            bodyScrollEnd: ()=>updateCachedState("scroll", this.getScrollState()),
            pinnedRowsChanged: ()=>updateCachedState("rowPinning", this.getRowPinningState())
        });
    }
    getColumnState() {
        const beans = this.beans;
        return $437b23f6a393c3bf$export$9453e80be74134db($437b23f6a393c3bf$export$e7d9af1fb362df7b(beans), beans.colModel.isPivotMode());
    }
    setColumnState(state, source, partialColumnState, ignoreSet) {
        const { sort: sortState, rowGroup: groupState, aggregation: aggregationState, pivot: pivotState, columnPinning: columnPinningState, columnVisibility: columnVisibilityState, columnSizing: columnSizingState, columnOrder: columnOrderState } = state;
        const shouldSetState = (prop, propState)=>!ignoreSet?.has(prop) && (propState || source === "api");
        const columnStateMap = {};
        const getColumnState2 = (colId)=>{
            let columnState = columnStateMap[colId];
            if (columnState) return columnState;
            columnState = {
                colId: colId
            };
            columnStateMap[colId] = columnState;
            return columnState;
        };
        const defaultState = {};
        const shouldSetSortState = shouldSetState("sort", sortState);
        if (shouldSetSortState) sortState?.sortModel.forEach(({ colId: colId, sort: sort }, sortIndex)=>{
            const columnState = getColumnState2(colId);
            columnState.sort = sort;
            columnState.sortIndex = sortIndex;
        });
        if (shouldSetSortState || !partialColumnState) {
            defaultState.sort = null;
            defaultState.sortIndex = null;
        }
        const shouldSetGroupState = shouldSetState("rowGroup", groupState);
        if (shouldSetGroupState) groupState?.groupColIds.forEach((colId, rowGroupIndex)=>{
            const columnState = getColumnState2(colId);
            columnState.rowGroup = true;
            columnState.rowGroupIndex = rowGroupIndex;
        });
        if (shouldSetGroupState || !partialColumnState) {
            defaultState.rowGroup = null;
            defaultState.rowGroupIndex = null;
        }
        const shouldSetAggregationState = shouldSetState("aggregation", aggregationState);
        if (shouldSetAggregationState) aggregationState?.aggregationModel.forEach(({ colId: colId, aggFunc: aggFunc })=>{
            getColumnState2(colId).aggFunc = aggFunc;
        });
        if (shouldSetAggregationState || !partialColumnState) defaultState.aggFunc = null;
        const shouldSetPivotState = shouldSetState("pivot", pivotState);
        if (shouldSetPivotState) {
            pivotState?.pivotColIds.forEach((colId, pivotIndex)=>{
                const columnState = getColumnState2(colId);
                columnState.pivot = true;
                columnState.pivotIndex = pivotIndex;
            });
            this.gos.updateGridOptions({
                options: {
                    pivotMode: !!pivotState?.pivotMode
                },
                source: source
            });
        }
        if (shouldSetPivotState || !partialColumnState) {
            defaultState.pivot = null;
            defaultState.pivotIndex = null;
        }
        const shouldSetColumnPinningState = shouldSetState("columnPinning", columnPinningState);
        if (shouldSetColumnPinningState) {
            columnPinningState?.leftColIds.forEach((colId)=>{
                getColumnState2(colId).pinned = "left";
            });
            columnPinningState?.rightColIds.forEach((colId)=>{
                getColumnState2(colId).pinned = "right";
            });
        }
        if (shouldSetColumnPinningState || !partialColumnState) defaultState.pinned = null;
        const shouldSetColumnVisibilityState = shouldSetState("columnVisibility", columnVisibilityState);
        if (shouldSetColumnVisibilityState) columnVisibilityState?.hiddenColIds.forEach((colId)=>{
            getColumnState2(colId).hide = true;
        });
        if (shouldSetColumnVisibilityState || !partialColumnState) defaultState.hide = null;
        const shouldSetColumnSizingState = shouldSetState("columnSizing", columnSizingState);
        if (shouldSetColumnSizingState) columnSizingState?.columnSizingModel.forEach(({ colId: colId, flex: flex, width: width })=>{
            const columnState = getColumnState2(colId);
            columnState.flex = flex ?? null;
            columnState.width = width;
        });
        if (shouldSetColumnSizingState || !partialColumnState) defaultState.flex = null;
        const columns = columnOrderState?.orderedColIds;
        const applyOrder = !!columns?.length && !ignoreSet?.has("columnOrder");
        const columnStates = applyOrder ? columns.map((colId)=>getColumnState2(colId)) : Object.values(columnStateMap);
        if (columnStates.length) {
            this.columnStates = columnStates;
            $437b23f6a393c3bf$export$b2854c1cb8f10386(this.beans, {
                state: columnStates,
                applyOrder: applyOrder,
                defaultState: defaultState
            }, source);
        }
    }
    setColumnPivotState(applyOrder, source) {
        const columnStates = this.columnStates;
        this.columnStates = void 0;
        const columnGroupStates = this.columnGroupStates;
        this.columnGroupStates = void 0;
        const beans = this.beans;
        const { pivotResultCols: pivotResultCols, colGroupSvc: colGroupSvc } = beans;
        if (!pivotResultCols?.isPivotResultColsPresent()) return;
        if (columnStates) {
            const secondaryColumnStates = [];
            for (const columnState of columnStates)if (pivotResultCols.getPivotResultCol(columnState.colId)) secondaryColumnStates.push(columnState);
            $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                state: secondaryColumnStates,
                applyOrder: applyOrder
            }, source);
        }
        if (columnGroupStates) colGroupSvc?.setColumnGroupState(columnGroupStates, source);
    }
    getColumnGroupState() {
        const colGroupSvc = this.beans.colGroupSvc;
        if (!colGroupSvc) return void 0;
        const columnGroupState = colGroupSvc.getColumnGroupState();
        return $437b23f6a393c3bf$var$_convertColumnGroupState(columnGroupState);
    }
    setColumnGroupState(state, source, ignoreSet) {
        const colGroupSvc = this.beans.colGroupSvc;
        if (!colGroupSvc || ignoreSet?.has("columnGroup") || source !== "api" && !Object.prototype.hasOwnProperty.call(state, "columnGroup")) return;
        const openColumnGroups = new Set(state.columnGroup?.openColumnGroupIds);
        const existingColumnGroupState = colGroupSvc.getColumnGroupState();
        const stateItems = existingColumnGroupState.map(({ groupId: groupId })=>{
            const open = openColumnGroups.has(groupId);
            if (open) openColumnGroups.delete(groupId);
            return {
                groupId: groupId,
                open: open
            };
        });
        openColumnGroups.forEach((groupId)=>{
            stateItems.push({
                groupId: groupId,
                open: true
            });
        });
        if (stateItems.length) this.columnGroupStates = stateItems;
        colGroupSvc.setColumnGroupState(stateItems, source);
    }
    getFilterState() {
        const filterManager = this.beans.filterManager;
        let filterModel = filterManager?.getFilterModel();
        if (filterModel && Object.keys(filterModel).length === 0) filterModel = void 0;
        const columnFilterState = filterManager?.getFilterState();
        const advancedFilterModel = filterManager?.getAdvFilterModel() ?? void 0;
        return filterModel || advancedFilterModel || columnFilterState ? {
            filterModel: filterModel,
            columnFilterState: columnFilterState,
            advancedFilterModel: advancedFilterModel
        } : void 0;
    }
    setFilterState(filterState) {
        const filterManager = this.beans.filterManager;
        const { filterModel: filterModel, columnFilterState: columnFilterState, advancedFilterModel: advancedFilterModel } = filterState ?? {
            filterModel: null,
            columnFilterState: null,
            advancedFilterModel: null
        };
        if (filterModel !== void 0 || columnFilterState !== void 0) filterManager?.setFilterState(filterModel ?? null, columnFilterState ?? null, "columnFilter");
        if (advancedFilterModel !== void 0) filterManager?.setAdvFilterModel(advancedFilterModel ?? null, "advancedFilter");
    }
    getRangeSelectionState() {
        const cellRanges = this.beans.rangeSvc?.getCellRanges().map((cellRange)=>{
            const { id: id, type: type, startRow: startRow, endRow: endRow, columns: columns, startColumn: startColumn } = cellRange;
            return {
                id: id,
                type: type,
                startRow: startRow,
                endRow: endRow,
                colIds: columns.map((column)=>column.getColId()),
                startColId: startColumn.getColId()
            };
        });
        return cellRanges?.length ? {
            cellRanges: cellRanges
        } : void 0;
    }
    setCellSelectionState(cellSelectionState) {
        const { gos: gos, rangeSvc: rangeSvc, colModel: colModel, visibleCols: visibleCols } = this.beans;
        if (!$437b23f6a393c3bf$export$1f7ca6920544d9e4(gos) || !rangeSvc) return;
        const cellRanges = [];
        cellSelectionState?.cellRanges.forEach((cellRange)=>{
            const columns = [];
            cellRange.colIds.forEach((colId)=>{
                const column = colModel.getCol(colId);
                if (column) columns.push(column);
            });
            if (!columns.length) return;
            let startColumn = colModel.getCol(cellRange.startColId);
            if (!startColumn) {
                const allColumns = visibleCols.allCols;
                const columnSet = new Set(columns);
                startColumn = allColumns.find((column)=>columnSet.has(column));
            }
            cellRanges.push({
                ...cellRange,
                columns: columns,
                startColumn: startColumn
            });
        });
        rangeSvc.setCellRanges(cellRanges);
    }
    getScrollState() {
        if (!this.isClientSideRowModel) return void 0;
        const scrollFeature = this.beans.ctrlsSvc.getScrollFeature();
        const { left: left } = scrollFeature?.getHScrollPosition() ?? {
            left: 0
        };
        const { top: top } = scrollFeature?.getVScrollPosition() ?? {
            top: 0
        };
        return top || left ? {
            top: top,
            left: left
        } : void 0;
    }
    setScrollState(scrollState) {
        if (!this.isClientSideRowModel) return;
        const { top: top, left: left } = scrollState ?? {
            top: 0,
            left: 0
        };
        const { frameworkOverrides: frameworkOverrides, rowRenderer: rowRenderer, animationFrameSvc: animationFrameSvc, ctrlsSvc: ctrlsSvc } = this.beans;
        frameworkOverrides.wrapIncoming(()=>{
            ctrlsSvc.get("center").setCenterViewportScrollLeft(left);
            ctrlsSvc.getScrollFeature()?.setVerticalScrollPosition(top);
            rowRenderer.redraw({
                afterScroll: true
            });
            animationFrameSvc?.flushAllFrames();
        });
    }
    getSideBarState() {
        return this.beans.sideBar?.comp?.getState();
    }
    getFocusedCellState() {
        if (!this.isClientSideRowModel) return void 0;
        const focusedCell = this.beans.focusSvc.getFocusedCell();
        if (focusedCell) {
            const { column: column, rowIndex: rowIndex, rowPinned: rowPinned } = focusedCell;
            return {
                colId: column.getColId(),
                rowIndex: rowIndex,
                rowPinned: rowPinned
            };
        }
        return void 0;
    }
    setFocusedCellState(focusedCellState) {
        if (!this.isClientSideRowModel) return;
        const { focusSvc: focusSvc, colModel: colModel } = this.beans;
        if (!focusedCellState) {
            focusSvc.clearFocusedCell();
            return;
        }
        const { colId: colId, rowIndex: rowIndex, rowPinned: rowPinned } = focusedCellState;
        focusSvc.setFocusedCell({
            column: colModel.getCol(colId),
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            forceBrowserFocus: true,
            preventScrollOnBrowserFocus: true
        });
    }
    getPaginationState() {
        const { pagination: pagination, gos: gos } = this.beans;
        if (!pagination) return void 0;
        const page = pagination.getCurrentPage();
        const pageSize = !gos.get("paginationAutoPageSize") ? pagination.getPageSize() : void 0;
        if (!page && !pageSize) return;
        return {
            page: page,
            pageSize: pageSize
        };
    }
    setPaginationState(paginationState, source) {
        const { pagination: pagination, gos: gos } = this.beans;
        if (!pagination) return;
        const { pageSize: pageSize, page: page } = paginationState ?? {
            page: 0,
            pageSize: gos.get("paginationPageSize")
        };
        const isInit = source === "gridInitializing";
        if (pageSize && !gos.get("paginationAutoPageSize")) pagination.setPageSize(pageSize, isInit ? "initialState" : "pageSizeSelector");
        if (typeof page === "number") {
            if (isInit) pagination.setPage(page);
            else pagination.goToPage(page);
        }
    }
    getRowSelectionState() {
        const selectionSvc = this.beans.selectionSvc;
        if (!selectionSvc) return void 0;
        const selectionState = selectionSvc.getSelectionState();
        const noSelections = !selectionState || !Array.isArray(selectionState) && (selectionState.selectAll === false || selectionState.selectAllChildren === false) && !selectionState?.toggledNodes?.length;
        return noSelections ? void 0 : selectionState;
    }
    setRowSelectionState(rowSelectionState, source) {
        this.beans.selectionSvc?.setSelectionState(rowSelectionState, source, source === "api");
    }
    getRowGroupExpansionState() {
        const { expansionSvc: expansionSvc, rowModel: rowModel } = this.beans;
        if (!expansionSvc) return void 0;
        const expandedRowGroups = [];
        rowModel.forEachNode(({ expanded: expanded, id: id })=>{
            if (expanded && id) expandedRowGroups.push(id);
        });
        return expandedRowGroups.length ? {
            expandedRowGroupIds: expandedRowGroups
        } : void 0;
    }
    getRowPinningState() {
        return this.beans.pinnedRowModel?.getPinnedState();
    }
    setRowPinningState(state) {
        const pinnedRowModel = this.beans.pinnedRowModel;
        if (state) pinnedRowModel?.setPinnedState(state);
        else pinnedRowModel?.reset();
    }
    setRowGroupExpansionState(rowGroupExpansionState, source) {
        const expansionSvc = this.beans.expansionSvc;
        if (!expansionSvc) return;
        const rowGroupIdsToExpand = rowGroupExpansionState?.expandedRowGroupIds ?? [];
        let rowGroupIdsToCollapse;
        if (source === "api") {
            const oldExpandedRowGroupIds = this.getRowGroupExpansionState()?.expandedRowGroupIds;
            if (oldExpandedRowGroupIds?.length) {
                const oldExpandedRowGroupIdsSet = new Set(oldExpandedRowGroupIds);
                for (const id of rowGroupIdsToExpand)oldExpandedRowGroupIdsSet.delete(id);
                rowGroupIdsToCollapse = Array.from(oldExpandedRowGroupIdsSet);
            }
        }
        expansionSvc.expandRows(rowGroupIdsToExpand, rowGroupIdsToCollapse);
    }
    updateColumnState(features) {
        const newColumnState = this.getColumnState();
        let hasChanged = false;
        const cachedState = this.cachedState;
        for (const key of Object.keys(newColumnState)){
            const value = newColumnState[key];
            if (!$437b23f6a393c3bf$export$dbc2068cc90f5875(value, cachedState[key])) hasChanged = true;
        }
        this.cachedState = {
            ...cachedState,
            ...newColumnState
        };
        if (hasChanged) this.dispatchStateUpdateEvent(features);
    }
    updateCachedState(key, value) {
        const existingValue = this.cachedState[key];
        this.setCachedStateValue(key, value);
        if (!$437b23f6a393c3bf$export$dbc2068cc90f5875(value, existingValue)) this.dispatchStateUpdateEvent([
            key
        ]);
    }
    setCachedStateValue(key, value) {
        this.cachedState = {
            ...this.cachedState,
            [key]: value
        };
    }
    refreshStaleState() {
        const staleStateKeys = this.staleStateKeys;
        staleStateKeys.forEach((key)=>{
            switch(key){
                case "rowSelection":
                    this.setCachedStateValue(key, this.getRowSelectionState());
                    break;
            }
        });
        staleStateKeys.clear();
    }
    dispatchStateUpdateEvent(sources) {
        if (this.suppressEvents) return;
        sources.forEach((source)=>this.queuedUpdateSources.add(source));
        this.dispatchStateUpdateEventDebounced();
    }
    dispatchQueuedStateUpdateEvents() {
        const queuedUpdateSources = this.queuedUpdateSources;
        const sources = Array.from(queuedUpdateSources);
        queuedUpdateSources.clear();
        this.eventSvc.dispatchEvent({
            type: "stateUpdated",
            sources: sources,
            state: this.cachedState
        });
    }
    startSuppressEvents() {
        this.suppressEvents = true;
        this.beans.colAnimation?.setSuppressAnimation(true);
    }
    stopSuppressEvents(source) {
        setTimeout(()=>{
            this.suppressEvents = false;
            this.queuedUpdateSources.clear();
            if (!this.isAlive()) return;
            this.beans.colAnimation?.setSuppressAnimation(false);
            this.dispatchStateUpdateEvent([
                source
            ]);
        });
    }
    suppressEventsAndDispatchInitEvent(updateFunc) {
        this.startSuppressEvents();
        updateFunc();
        this.stopSuppressEvents("gridInitializing");
    }
};
// packages/ag-grid-community/src/misc/state/stateModule.ts
var $437b23f6a393c3bf$export$3402149dbbda9537 = {
    moduleName: "GridState",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$StateService
    ],
    apiFunctions: {
        getState: $437b23f6a393c3bf$var$getState,
        setState: $437b23f6a393c3bf$var$setState
    }
};
// packages/ag-grid-community/src/pagination/paginationApi.ts
function $437b23f6a393c3bf$var$paginationIsLastPageFound(beans) {
    return beans.rowModel.isLastRowIndexKnown();
}
function $437b23f6a393c3bf$var$paginationGetPageSize(beans) {
    return beans.pagination?.getPageSize() ?? 100;
}
function $437b23f6a393c3bf$var$paginationGetCurrentPage(beans) {
    return beans.pagination?.getCurrentPage() ?? 0;
}
function $437b23f6a393c3bf$var$paginationGetTotalPages(beans) {
    return beans.pagination?.getTotalPages() ?? 1;
}
function $437b23f6a393c3bf$var$paginationGetRowCount(beans) {
    return beans.pagination ? beans.pagination.getMasterRowCount() : beans.rowModel.getRowCount();
}
function $437b23f6a393c3bf$var$paginationGoToNextPage(beans) {
    beans.pagination?.goToNextPage();
}
function $437b23f6a393c3bf$var$paginationGoToPreviousPage(beans) {
    beans.pagination?.goToPreviousPage();
}
function $437b23f6a393c3bf$var$paginationGoToFirstPage(beans) {
    beans.pagination?.goToFirstPage();
}
function $437b23f6a393c3bf$var$paginationGoToLastPage(beans) {
    beans.pagination?.goToLastPage();
}
function $437b23f6a393c3bf$var$paginationGoToPage(beans, page) {
    beans.pagination?.goToPage(page);
}
// packages/ag-grid-community/src/pagination/paginationAutoPageSizeService.ts
var $437b23f6a393c3bf$var$PaginationAutoPageSizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "paginationAutoPageSizeSvc";
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.centerRowsCtrl = p.center;
            const listener = this.checkPageSize.bind(this);
            this.addManagedEventListeners({
                bodyHeightChanged: listener,
                scrollVisibilityChanged: listener
            });
            this.addManagedPropertyListener("paginationAutoPageSize", this.onPaginationAutoSizeChanged.bind(this));
            this.checkPageSize();
        });
    }
    notActive() {
        return !this.gos.get("paginationAutoPageSize") || this.centerRowsCtrl == null;
    }
    onPaginationAutoSizeChanged() {
        if (this.notActive()) this.beans.pagination.unsetAutoCalculatedPageSize();
        else this.checkPageSize();
    }
    checkPageSize() {
        if (this.notActive()) return;
        const bodyHeight = this.centerRowsCtrl.viewportSizeFeature.getBodyHeight();
        if (bodyHeight > 0) {
            const beans = this.beans;
            const update = ()=>{
                const rowHeight = Math.max($437b23f6a393c3bf$export$8966875adec41e5b(beans), 1);
                const newPageSize = Math.floor(bodyHeight / rowHeight);
                beans.pagination.setPageSize(newPageSize, "autoCalculated");
            };
            if (!this.isBodyRendered) {
                update();
                this.isBodyRendered = true;
            } else $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, update, 50)();
        } else this.isBodyRendered = false;
    }
};
// packages/ag-grid-community/src/pagination/pageSizeSelector/pageSizeSelectorComp.ts
var $437b23f6a393c3bf$var$paginationPageSizeSelector = "paginationPageSizeSelector";
var $437b23f6a393c3bf$var$PageSizeSelectorCompElement = {
    tag: "span",
    cls: "ag-paging-page-size"
};
var $437b23f6a393c3bf$var$PageSizeSelectorComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$PageSizeSelectorCompElement);
        this.hasEmptyOption = false;
        this.handlePageSizeItemSelected = ()=>{
            if (!this.selectPageSizeComp) return;
            const newValue = this.selectPageSizeComp.getValue();
            if (!newValue) return;
            const paginationPageSize = Number(newValue);
            if (isNaN(paginationPageSize) || paginationPageSize < 1 || paginationPageSize === this.pagination.getPageSize()) return;
            this.pagination.setPageSize(paginationPageSize, "pageSizeSelector");
            if (this.hasEmptyOption) this.toggleSelectDisplay(true);
            this.selectPageSizeComp.getFocusableElement().focus();
        };
    }
    wireBeans(beans) {
        this.pagination = beans.pagination;
    }
    postConstruct() {
        this.addManagedPropertyListener($437b23f6a393c3bf$var$paginationPageSizeSelector, ()=>{
            this.onPageSizeSelectorValuesChange();
        });
        this.addManagedEventListeners({
            paginationChanged: (event)=>this.handlePaginationChanged(event)
        });
    }
    handlePaginationChanged(paginationChangedEvent) {
        if (!this.selectPageSizeComp || !paginationChangedEvent?.newPageSize) return;
        const paginationPageSize = this.pagination.getPageSize();
        if (this.getPageSizeSelectorValues().includes(paginationPageSize)) this.selectPageSizeComp.setValue(paginationPageSize.toString());
        else if (this.hasEmptyOption) this.selectPageSizeComp.setValue("");
        else this.toggleSelectDisplay(true);
    }
    toggleSelectDisplay(show) {
        if (this.selectPageSizeComp && !show) this.reset();
        if (!show) return;
        this.reloadPageSizesSelector();
        if (!this.selectPageSizeComp) return;
    }
    reset() {
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.getGui());
        if (!this.selectPageSizeComp) return;
        this.selectPageSizeComp = this.destroyBean(this.selectPageSizeComp);
    }
    onPageSizeSelectorValuesChange() {
        if (!this.selectPageSizeComp) return;
        if (this.shouldShowPageSizeSelector()) this.reloadPageSizesSelector();
    }
    shouldShowPageSizeSelector() {
        return this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel") && !this.gos.get("paginationAutoPageSize") && this.gos.get($437b23f6a393c3bf$var$paginationPageSizeSelector) !== false;
    }
    reloadPageSizesSelector() {
        const pageSizeOptions = this.getPageSizeSelectorValues();
        const paginationPageSizeOption = this.pagination.getPageSize();
        const shouldAddAndSelectEmptyOption = !paginationPageSizeOption || !pageSizeOptions.includes(paginationPageSizeOption);
        if (shouldAddAndSelectEmptyOption) {
            const pageSizeSet = this.gos.exists("paginationPageSize");
            const pageSizesSet = this.gos.get($437b23f6a393c3bf$var$paginationPageSizeSelector) !== true;
            $437b23f6a393c3bf$export$545083624300f13d(94, {
                pageSizeSet: pageSizeSet,
                pageSizesSet: pageSizesSet,
                pageSizeOptions: pageSizeOptions,
                paginationPageSizeOption: paginationPageSizeOption
            });
            if (!pageSizesSet) $437b23f6a393c3bf$export$545083624300f13d(95, {
                paginationPageSizeOption: paginationPageSizeOption,
                paginationPageSizeSelector: $437b23f6a393c3bf$var$paginationPageSizeSelector
            });
            pageSizeOptions.unshift("");
        }
        const value = String(shouldAddAndSelectEmptyOption ? "" : paginationPageSizeOption);
        if (this.selectPageSizeComp) {
            if (!$437b23f6a393c3bf$export$893967cdb9833fdd(this.pageSizeOptions, pageSizeOptions)) {
                this.selectPageSizeComp.clearOptions().addOptions(this.createPageSizeSelectOptions(pageSizeOptions));
                this.pageSizeOptions = pageSizeOptions;
            }
            this.selectPageSizeComp.setValue(value, true);
        } else this.createPageSizeSelectorComp(pageSizeOptions, value);
        this.hasEmptyOption = shouldAddAndSelectEmptyOption;
    }
    createPageSizeSelectOptions(pageSizeOptions) {
        return pageSizeOptions.map((value)=>({
                value: String(value)
            }));
    }
    createPageSizeSelectorComp(pageSizeOptions, value) {
        const localeTextFunc = this.getLocaleTextFunc();
        const localisedLabel = localeTextFunc("pageSizeSelectorLabel", "Page Size:");
        const localisedAriaLabel = localeTextFunc("ariaPageSizeSelectorLabel", "Page Size");
        this.selectPageSizeComp = this.createManagedBean(new $437b23f6a393c3bf$export$6f9c460854d56032()).addOptions(this.createPageSizeSelectOptions(pageSizeOptions)).setValue(value).setAriaLabel(localisedAriaLabel).setLabel(localisedLabel).onValueChange(()=>this.handlePageSizeItemSelected());
        this.appendChild(this.selectPageSizeComp);
    }
    getPageSizeSelectorValues() {
        const defaultValues = [
            20,
            50,
            100
        ];
        const paginationPageSizeSelectorValues = this.gos.get($437b23f6a393c3bf$var$paginationPageSizeSelector);
        if (!Array.isArray(paginationPageSizeSelectorValues) || !paginationPageSizeSelectorValues?.length) return defaultValues;
        return [
            ...paginationPageSizeSelectorValues
        ].sort((a, b)=>a - b);
    }
    destroy() {
        this.toggleSelectDisplay(false);
        super.destroy();
    }
};
var $437b23f6a393c3bf$var$PageSizeSelectorSelector = {
    selector: "AG-PAGE-SIZE-SELECTOR",
    component: $437b23f6a393c3bf$var$PageSizeSelectorComp
};
// packages/ag-grid-community/src/pagination/paginationComp.css-GENERATED.ts
var $437b23f6a393c3bf$var$paginationCompCSS = /*css*/ `.ag-paging-panel{align-items:center;border-top:var(--ag-footer-row-border);display:flex;gap:calc(var(--ag-spacing)*4);height:var(--ag-pagination-panel-height);justify-content:flex-end;padding:0 var(--ag-cell-horizontal-padding)}:where(.ag-paging-page-size) .ag-wrapper{min-width:50px}.ag-paging-page-summary-panel{align-items:center;display:flex;gap:var(--ag-cell-widget-spacing);.ag-disabled &{pointer-events:none}}.ag-paging-button{cursor:pointer;position:relative;&.ag-disabled{cursor:default;opacity:.5}}.ag-paging-number,.ag-paging-row-summary-panel-number{font-weight:500}`;
// packages/ag-grid-community/src/pagination/paginationComp.ts
var $437b23f6a393c3bf$var$PaginationComp = class extends $437b23f6a393c3bf$export$5a26e3abd1c845b6 {
    constructor(){
        super();
        this.btFirst = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.btPrevious = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.btNext = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.btLast = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbRecordCount = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbFirstRowOnPage = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbLastRowOnPage = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbCurrent = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbTotal = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.pageSizeComp = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.previousAndFirstButtonsDisabled = false;
        this.nextButtonDisabled = false;
        this.lastButtonDisabled = false;
        this.areListenersSetup = false;
        this.allowFocusInnerElement = false;
        this.registerCSS($437b23f6a393c3bf$var$paginationCompCSS);
    }
    wireBeans(beans) {
        this.rowModel = beans.rowModel;
        this.pagination = beans.pagination;
        this.ariaAnnounce = beans.ariaAnnounce;
    }
    postConstruct() {
        const isRtl = this.gos.get("enableRtl");
        this.setTemplate(this.getTemplate(), [
            $437b23f6a393c3bf$var$PageSizeSelectorSelector
        ]);
        const { btFirst: btFirst, btPrevious: btPrevious, btNext: btNext, btLast: btLast } = this;
        this.activateTabIndex([
            btFirst,
            btPrevious,
            btNext,
            btLast
        ]);
        btFirst.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$export$d8feba07bf373edb(isRtl ? "last" : "first", this.beans));
        btPrevious.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$export$d8feba07bf373edb(isRtl ? "next" : "previous", this.beans));
        btNext.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$export$d8feba07bf373edb(isRtl ? "previous" : "next", this.beans));
        btLast.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$export$d8feba07bf373edb(isRtl ? "first" : "last", this.beans));
        this.addManagedPropertyListener("pagination", this.onPaginationChanged.bind(this));
        this.addManagedPropertyListener("suppressPaginationPanel", this.onPaginationChanged.bind(this));
        this.addManagedPropertyListeners([
            "paginationPageSizeSelector",
            "paginationAutoPageSize",
            "suppressPaginationPanel"
        ], ()=>this.onPageSizeRelatedOptionsChange());
        this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
        this.initialiseTabGuard({
            // prevent tab guard default logic
            onTabKeyDown: ()=>{},
            focusInnerElement: (fromBottom)=>{
                if (this.allowFocusInnerElement) return this.tabGuardFeature.getTabGuardCtrl().focusInnerElement(fromBottom);
                else return $437b23f6a393c3bf$export$b3beea4db79d8bb3(this.beans, fromBottom);
            },
            forceFocusOutWhenTabGuardsAreEmpty: true
        });
        this.onPaginationChanged();
    }
    setAllowFocus(allowFocus) {
        this.allowFocusInnerElement = allowFocus;
    }
    onPaginationChanged() {
        const isPaging = this.gos.get("pagination");
        const paginationPanelEnabled = isPaging && !this.gos.get("suppressPaginationPanel");
        this.setDisplayed(paginationPanelEnabled);
        if (!paginationPanelEnabled) return;
        this.setupListeners();
        this.enableOrDisableButtons();
        this.updateLabels();
        this.onPageSizeRelatedOptionsChange();
    }
    onPageSizeRelatedOptionsChange() {
        this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
    }
    setupListeners() {
        if (!this.areListenersSetup) {
            this.addManagedEventListeners({
                paginationChanged: this.onPaginationChanged.bind(this)
            });
            [
                {
                    el: this.btFirst,
                    fn: this.onBtFirst.bind(this)
                },
                {
                    el: this.btPrevious,
                    fn: this.onBtPrevious.bind(this)
                },
                {
                    el: this.btNext,
                    fn: this.onBtNext.bind(this)
                },
                {
                    el: this.btLast,
                    fn: this.onBtLast.bind(this)
                }
            ].forEach((item)=>{
                const { el: el, fn: fn } = item;
                this.addManagedListeners(el, {
                    click: fn,
                    keydown: (e)=>{
                        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER || e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) {
                            e.preventDefault();
                            fn();
                        }
                    }
                });
            });
            $437b23f6a393c3bf$export$8865b8c867776648(this.beans, this, this.getGui());
            this.areListenersSetup = true;
        }
    }
    onBtFirst() {
        if (!this.previousAndFirstButtonsDisabled) this.pagination.goToFirstPage();
    }
    formatNumber(value) {
        const userFunc = this.gos.getCallback("paginationNumberFormatter");
        if (userFunc) {
            const params = {
                value: value
            };
            return userFunc(params);
        }
        return $437b23f6a393c3bf$export$c8980add4a69422e(value, this.getLocaleTextFunc.bind(this));
    }
    getTemplate() {
        const localeTextFunc = this.getLocaleTextFunc();
        const idPrefix = `ag-${this.getCompId()}`;
        return {
            tag: "div",
            cls: "ag-paging-panel ag-unselectable",
            attrs: {
                id: `${idPrefix}`
            },
            children: [
                {
                    tag: "ag-page-size-selector",
                    ref: "pageSizeComp"
                },
                {
                    tag: "span",
                    cls: "ag-paging-row-summary-panel",
                    children: [
                        {
                            tag: "span",
                            ref: "lbFirstRowOnPage",
                            cls: "ag-paging-row-summary-panel-number",
                            attrs: {
                                id: `${idPrefix}-first-row`
                            }
                        },
                        {
                            tag: "span",
                            attrs: {
                                id: `${idPrefix}-to`
                            },
                            children: localeTextFunc("to", "to")
                        },
                        {
                            tag: "span",
                            ref: "lbLastRowOnPage",
                            cls: "ag-paging-row-summary-panel-number",
                            attrs: {
                                id: `${idPrefix}-last-row`
                            }
                        },
                        {
                            tag: "span",
                            attrs: {
                                id: `${idPrefix}-of`
                            },
                            children: localeTextFunc("of", "of")
                        },
                        {
                            tag: "span",
                            ref: "lbRecordCount",
                            cls: "ag-paging-row-summary-panel-number",
                            attrs: {
                                id: `${idPrefix}-row-count`
                            }
                        }
                    ]
                },
                {
                    tag: "span",
                    cls: "ag-paging-page-summary-panel",
                    role: "presentation",
                    children: [
                        {
                            tag: "div",
                            ref: "btFirst",
                            cls: "ag-button ag-paging-button",
                            role: "button",
                            attrs: {
                                "aria-label": localeTextFunc("firstPage", "First Page")
                            }
                        },
                        {
                            tag: "div",
                            ref: "btPrevious",
                            cls: "ag-button ag-paging-button",
                            role: "button",
                            attrs: {
                                "aria-label": localeTextFunc("previousPage", "Previous Page")
                            }
                        },
                        {
                            tag: "span",
                            cls: "ag-paging-description",
                            children: [
                                {
                                    tag: "span",
                                    attrs: {
                                        id: `${idPrefix}-start-page`
                                    },
                                    children: localeTextFunc("page", "Page")
                                },
                                {
                                    tag: "span",
                                    ref: "lbCurrent",
                                    cls: "ag-paging-number",
                                    attrs: {
                                        id: `${idPrefix}-start-page-number`
                                    }
                                },
                                {
                                    tag: "span",
                                    attrs: {
                                        id: `${idPrefix}-of-page`
                                    },
                                    children: localeTextFunc("of", "of")
                                },
                                {
                                    tag: "span",
                                    ref: "lbTotal",
                                    cls: "ag-paging-number",
                                    attrs: {
                                        id: `${idPrefix}-of-page-number`
                                    }
                                }
                            ]
                        },
                        {
                            tag: "div",
                            ref: "btNext",
                            cls: "ag-button ag-paging-button",
                            role: "button",
                            attrs: {
                                "aria-label": localeTextFunc("nextPage", "Next Page")
                            }
                        },
                        {
                            tag: "div",
                            ref: "btLast",
                            cls: "ag-button ag-paging-button",
                            role: "button",
                            attrs: {
                                "aria-label": localeTextFunc("lastPage", "Last Page")
                            }
                        }
                    ]
                }
            ]
        };
    }
    onBtNext() {
        if (!this.nextButtonDisabled) this.pagination.goToNextPage();
    }
    onBtPrevious() {
        if (!this.previousAndFirstButtonsDisabled) this.pagination.goToPreviousPage();
    }
    onBtLast() {
        if (!this.lastButtonDisabled) this.pagination.goToLastPage();
    }
    enableOrDisableButtons() {
        const currentPage = this.pagination.getCurrentPage();
        const maxRowFound = this.rowModel.isLastRowIndexKnown();
        const totalPages = this.pagination.getTotalPages();
        this.previousAndFirstButtonsDisabled = currentPage === 0;
        this.toggleButtonDisabled(this.btFirst, this.previousAndFirstButtonsDisabled);
        this.toggleButtonDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
        const zeroPagesToDisplay = this.isZeroPagesToDisplay();
        const onLastPage = currentPage === totalPages - 1;
        this.nextButtonDisabled = onLastPage || zeroPagesToDisplay;
        this.lastButtonDisabled = !maxRowFound || zeroPagesToDisplay || currentPage === totalPages - 1;
        this.toggleButtonDisabled(this.btNext, this.nextButtonDisabled);
        this.toggleButtonDisabled(this.btLast, this.lastButtonDisabled);
    }
    toggleButtonDisabled(button, disabled) {
        $437b23f6a393c3bf$export$7ed376f43c6f2bbd(button, disabled);
        button.classList.toggle("ag-disabled", disabled);
    }
    isZeroPagesToDisplay() {
        const maxRowFound = this.rowModel.isLastRowIndexKnown();
        const totalPages = this.pagination.getTotalPages();
        return maxRowFound && totalPages === 0;
    }
    updateLabels() {
        const lastPageFound = this.rowModel.isLastRowIndexKnown();
        const totalPages = this.pagination.getTotalPages();
        const masterRowCount = this.pagination.getMasterRowCount();
        const rowCount = lastPageFound ? masterRowCount : null;
        const currentPage = this.pagination.getCurrentPage();
        const pageSize = this.pagination.getPageSize();
        let startRow;
        let endRow;
        if (this.isZeroPagesToDisplay()) startRow = endRow = 0;
        else {
            startRow = pageSize * currentPage + 1;
            endRow = startRow + pageSize - 1;
            if (lastPageFound && endRow > rowCount) endRow = rowCount;
        }
        const theoreticalEndRow = startRow + pageSize - 1;
        const isLoadingPageSize = !lastPageFound && masterRowCount < theoreticalEndRow;
        const lbFirstRowOnPage = this.formatNumber(startRow);
        this.lbFirstRowOnPage.textContent = lbFirstRowOnPage;
        let lbLastRowOnPage;
        const localeTextFunc = this.getLocaleTextFunc();
        if (isLoadingPageSize) lbLastRowOnPage = localeTextFunc("pageLastRowUnknown", "?");
        else lbLastRowOnPage = this.formatNumber(endRow);
        this.lbLastRowOnPage.textContent = lbLastRowOnPage;
        const pagesExist = totalPages > 0;
        const toDisplay = pagesExist ? currentPage + 1 : 0;
        const lbCurrent = this.formatNumber(toDisplay);
        this.lbCurrent.textContent = lbCurrent;
        let lbTotal;
        let lbRecordCount;
        if (lastPageFound) {
            lbTotal = this.formatNumber(totalPages);
            lbRecordCount = this.formatNumber(rowCount);
        } else {
            const moreText = localeTextFunc("more", "more");
            lbTotal = moreText;
            lbRecordCount = moreText;
        }
        this.lbTotal.textContent = lbTotal;
        this.lbRecordCount.textContent = lbRecordCount;
        this.announceAriaStatus(lbFirstRowOnPage, lbLastRowOnPage, lbRecordCount, lbCurrent, lbTotal);
    }
    announceAriaStatus(lbFirstRowOnPage, lbLastRowOnPage, lbRecordCount, lbCurrent, lbTotal) {
        const localeTextFunc = this.getLocaleTextFunc();
        const strPage = localeTextFunc("page", "Page");
        const strTo = localeTextFunc("to", "to");
        const strOf = localeTextFunc("of", "of");
        const ariaRowStatus = `${lbFirstRowOnPage} ${strTo} ${lbLastRowOnPage} ${strOf} ${lbRecordCount}`;
        const ariaPageStatus = `${strPage} ${lbCurrent} ${strOf} ${lbTotal}`;
        if (ariaRowStatus !== this.ariaRowStatus) {
            this.ariaRowStatus = ariaRowStatus;
            this.ariaAnnounce?.announceValue(ariaRowStatus, "paginationRow");
        }
        if (ariaPageStatus !== this.ariaPageStatus) {
            this.ariaPageStatus = ariaPageStatus;
            this.ariaAnnounce?.announceValue(ariaPageStatus, "paginationPage");
        }
    }
};
var $437b23f6a393c3bf$var$PaginationSelector = {
    selector: "AG-PAGINATION",
    component: $437b23f6a393c3bf$var$PaginationComp
};
// packages/ag-grid-community/src/pagination/paginationService.ts
var $437b23f6a393c3bf$var$PaginationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pagination";
        this.currentPage = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = 0;
        this.masterRowCount = 0;
    }
    postConstruct() {
        const gos = this.gos;
        this.active = gos.get("pagination");
        this.pageSizeFromGridOptions = gos.get("paginationPageSize");
        this.paginateChildRows = this.isPaginateChildRows();
        this.addManagedPropertyListener("pagination", this.onPaginationGridOptionChanged.bind(this));
        this.addManagedPropertyListener("paginationPageSize", this.onPageSizeGridOptionChanged.bind(this));
    }
    getPaginationSelector() {
        return $437b23f6a393c3bf$var$PaginationSelector;
    }
    isPaginateChildRows() {
        const gos = this.gos;
        const shouldPaginate = gos.get("groupHideParentOfSingleChild") || // following two properties deprecated v32.3.0
        gos.get("groupRemoveSingleChildren") || gos.get("groupRemoveLowestSingleChildren");
        if (shouldPaginate) return true;
        return gos.get("paginateChildRows");
    }
    onPaginationGridOptionChanged() {
        this.active = this.gos.get("pagination");
        this.calculatePages();
        this.dispatchPaginationChangedEvent({
            keepRenderedRows: true
        });
    }
    onPageSizeGridOptionChanged() {
        this.setPageSize(this.gos.get("paginationPageSize"), "gridOptions");
    }
    goToPage(page) {
        const currentPage = this.currentPage;
        if (!this.active || currentPage === page || typeof currentPage !== "number") return;
        const { editSvc: editSvc } = this.beans;
        if (editSvc?.isEditing()) {
            if (editSvc.isBatchEditing()) editSvc.cleanupEditors();
            else editSvc.stopEditing(void 0, {
                source: "api"
            });
        }
        this.currentPage = page;
        this.calculatePages();
        this.dispatchPaginationChangedEvent({
            newPage: true
        });
    }
    goToPageWithIndex(index) {
        if (!this.active) return;
        let adjustedIndex = index;
        if (!this.paginateChildRows) adjustedIndex = this.beans.rowModel.getTopLevelIndexFromDisplayedIndex?.(index) ?? index;
        this.goToPage(Math.floor(adjustedIndex / this.pageSize));
    }
    isRowInPage(rowIndex) {
        if (!this.active) return true;
        return rowIndex >= this.topDisplayedRowIndex && rowIndex <= this.bottomDisplayedRowIndex;
    }
    getCurrentPage() {
        return this.currentPage;
    }
    goToNextPage() {
        this.goToPage(this.currentPage + 1);
    }
    goToPreviousPage() {
        this.goToPage(this.currentPage - 1);
    }
    goToFirstPage() {
        this.goToPage(0);
    }
    goToLastPage() {
        const rowCount = this.beans.rowModel.getRowCount();
        const lastPage = Math.floor(rowCount / this.pageSize);
        this.goToPage(lastPage);
    }
    getPageSize() {
        return this.pageSize;
    }
    getTotalPages() {
        return this.totalPages;
    }
    /** This is only for state setting before data has been loaded */ setPage(page) {
        this.currentPage = page;
    }
    get pageSize() {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(this.pageSizeAutoCalculated) && this.gos.get("paginationAutoPageSize")) return this.pageSizeAutoCalculated;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(this.pageSizeFromPageSizeSelector)) return this.pageSizeFromPageSizeSelector;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(this.pageSizeFromInitialState)) return this.pageSizeFromInitialState;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(this.pageSizeFromGridOptions)) return this.pageSizeFromGridOptions;
        return this.defaultPageSize;
    }
    calculatePages() {
        if (this.active) {
            if (this.paginateChildRows) this.calculatePagesAllRows();
            else this.calculatePagesMasterRowsOnly();
        } else this.calculatedPagesNotActive();
        this.beans.pageBounds.calculateBounds(this.topDisplayedRowIndex, this.bottomDisplayedRowIndex);
    }
    unsetAutoCalculatedPageSize() {
        if (this.pageSizeAutoCalculated === void 0) return;
        const oldPageSize = this.pageSizeAutoCalculated;
        this.pageSizeAutoCalculated = void 0;
        if (this.pageSize === oldPageSize) return;
        this.calculatePages();
        this.dispatchPaginationChangedEvent({
            newPageSize: true
        });
    }
    setPageSize(size, source) {
        const currentSize = this.pageSize;
        switch(source){
            case "autoCalculated":
                this.pageSizeAutoCalculated = size;
                break;
            case "pageSizeSelector":
                this.pageSizeFromPageSizeSelector = size;
                if (this.currentPage !== 0) this.goToFirstPage();
                break;
            case "initialState":
                this.pageSizeFromInitialState = size;
                break;
            case "gridOptions":
                this.pageSizeFromGridOptions = size;
                this.pageSizeFromInitialState = void 0;
                this.pageSizeFromPageSizeSelector = void 0;
                if (this.currentPage !== 0) this.goToFirstPage();
                break;
        }
        if (currentSize !== this.pageSize) {
            this.calculatePages();
            this.dispatchPaginationChangedEvent({
                newPageSize: true,
                keepRenderedRows: true
            });
        }
    }
    setZeroRows() {
        this.masterRowCount = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = -1;
        this.currentPage = 0;
        this.totalPages = 0;
    }
    adjustCurrentPageIfInvalid() {
        const totalPages = this.totalPages;
        if (this.currentPage >= totalPages) this.currentPage = totalPages - 1;
        const currentPage = this.currentPage;
        if (!isFinite(currentPage) || isNaN(currentPage) || currentPage < 0) this.currentPage = 0;
    }
    calculatePagesMasterRowsOnly() {
        const rowModel = this.beans.rowModel;
        const masterRowCount = rowModel.getTopLevelRowCount();
        this.masterRowCount = masterRowCount;
        if (masterRowCount <= 0) {
            this.setZeroRows();
            return;
        }
        const pageSize = this.pageSize;
        const masterLastRowIndex = masterRowCount - 1;
        this.totalPages = Math.floor(masterLastRowIndex / pageSize) + 1;
        this.adjustCurrentPageIfInvalid();
        const currentPage = this.currentPage;
        const masterPageStartIndex = pageSize * currentPage;
        let masterPageEndIndex = pageSize * (currentPage + 1) - 1;
        if (masterPageEndIndex > masterLastRowIndex) masterPageEndIndex = masterLastRowIndex;
        this.topDisplayedRowIndex = rowModel.getTopLevelRowDisplayedIndex(masterPageStartIndex);
        if (masterPageEndIndex === masterLastRowIndex) this.bottomDisplayedRowIndex = rowModel.getRowCount() - 1;
        else {
            const firstIndexNotToShow = rowModel.getTopLevelRowDisplayedIndex(masterPageEndIndex + 1);
            this.bottomDisplayedRowIndex = firstIndexNotToShow - 1;
        }
    }
    getMasterRowCount() {
        return this.masterRowCount;
    }
    calculatePagesAllRows() {
        const masterRowCount = this.beans.rowModel.getRowCount();
        this.masterRowCount = masterRowCount;
        if (masterRowCount === 0) {
            this.setZeroRows();
            return;
        }
        const { pageSize: pageSize, currentPage: currentPage } = this;
        const maxRowIndex = masterRowCount - 1;
        this.totalPages = Math.floor(maxRowIndex / pageSize) + 1;
        this.adjustCurrentPageIfInvalid();
        this.topDisplayedRowIndex = pageSize * currentPage;
        this.bottomDisplayedRowIndex = pageSize * (currentPage + 1) - 1;
        if (this.bottomDisplayedRowIndex > maxRowIndex) this.bottomDisplayedRowIndex = maxRowIndex;
    }
    calculatedPagesNotActive() {
        this.setPageSize(void 0, "autoCalculated");
        this.totalPages = 1;
        this.currentPage = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = this.beans.rowModel.getRowCount() - 1;
    }
    dispatchPaginationChangedEvent(params) {
        const { keepRenderedRows: keepRenderedRows = false, newPage: newPage = false, newPageSize: newPageSize = false } = params;
        this.eventSvc.dispatchEvent({
            type: "paginationChanged",
            animate: false,
            newData: false,
            newPage: newPage,
            newPageSize: newPageSize,
            keepRenderedRows: keepRenderedRows
        });
    }
};
// packages/ag-grid-community/src/pagination/paginationModule.ts
var $437b23f6a393c3bf$export$a57c5ed18afb0c4 = {
    moduleName: "Pagination",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$PaginationService,
        $437b23f6a393c3bf$var$PaginationAutoPageSizeService
    ],
    icons: {
        // "go to first" button in pagination controls
        first: "first",
        // "go to previous" button in pagination controls
        previous: "previous",
        // "go to next" button in pagination controls
        next: "next",
        // "go to last" button in pagination controls
        last: "last"
    },
    apiFunctions: {
        paginationIsLastPageFound: $437b23f6a393c3bf$var$paginationIsLastPageFound,
        paginationGetPageSize: $437b23f6a393c3bf$var$paginationGetPageSize,
        paginationGetCurrentPage: $437b23f6a393c3bf$var$paginationGetCurrentPage,
        paginationGetTotalPages: $437b23f6a393c3bf$var$paginationGetTotalPages,
        paginationGetRowCount: $437b23f6a393c3bf$var$paginationGetRowCount,
        paginationGoToNextPage: $437b23f6a393c3bf$var$paginationGoToNextPage,
        paginationGoToPreviousPage: $437b23f6a393c3bf$var$paginationGoToPreviousPage,
        paginationGoToFirstPage: $437b23f6a393c3bf$var$paginationGoToFirstPage,
        paginationGoToLastPage: $437b23f6a393c3bf$var$paginationGoToLastPage,
        paginationGoToPage: $437b23f6a393c3bf$var$paginationGoToPage
    },
    dependsOn: [
        $437b23f6a393c3bf$export$da5c9bb998e6c24d
    ]
};
// packages/ag-grid-community/src/api/rowApi.ts
function $437b23f6a393c3bf$var$redrawRows(beans, params = {}) {
    const rowNodes = params ? params.rowNodes : void 0;
    beans.frameworkOverrides.wrapIncoming(()=>beans.rowRenderer.redrawRows(rowNodes));
}
function $437b23f6a393c3bf$var$setRowNodeExpanded(beans, rowNode, expanded, expandParents, forceSync) {
    if (rowNode) {
        if (expandParents && rowNode.parent && rowNode.parent.level !== -1) $437b23f6a393c3bf$var$setRowNodeExpanded(beans, rowNode.parent, expanded, expandParents, forceSync);
        rowNode.setExpanded(expanded, void 0, forceSync);
    }
}
function $437b23f6a393c3bf$var$getRowNode(beans, id) {
    return beans.rowModel.getRowNode(id);
}
function $437b23f6a393c3bf$var$addRenderedRowListener(beans, eventName, rowIndex, callback) {
    beans.rowRenderer.addRenderedRowListener(eventName, rowIndex, callback);
}
function $437b23f6a393c3bf$var$getRenderedNodes(beans) {
    return beans.rowRenderer.getRenderedNodes();
}
function $437b23f6a393c3bf$var$forEachNode(beans, callback, includeFooterNodes) {
    beans.rowModel.forEachNode(callback, includeFooterNodes);
}
function $437b23f6a393c3bf$var$getFirstDisplayedRowIndex(beans) {
    return beans.rowRenderer.firstRenderedRow;
}
function $437b23f6a393c3bf$var$getLastDisplayedRowIndex(beans) {
    return beans.rowRenderer.lastRenderedRow;
}
function $437b23f6a393c3bf$var$getDisplayedRowAtIndex(beans, index) {
    return beans.rowModel.getRow(index);
}
function $437b23f6a393c3bf$var$getDisplayedRowCount(beans) {
    return beans.rowModel.getRowCount();
}
// packages/ag-grid-community/src/api/apiModule.ts
var $437b23f6a393c3bf$export$12e9d7df2a270583 = {
    moduleName: "RowApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        redrawRows: $437b23f6a393c3bf$var$redrawRows,
        setRowNodeExpanded: $437b23f6a393c3bf$var$setRowNodeExpanded,
        getRowNode: $437b23f6a393c3bf$var$getRowNode,
        addRenderedRowListener: $437b23f6a393c3bf$var$addRenderedRowListener,
        getRenderedNodes: $437b23f6a393c3bf$var$getRenderedNodes,
        forEachNode: $437b23f6a393c3bf$var$forEachNode,
        getFirstDisplayedRowIndex: $437b23f6a393c3bf$var$getFirstDisplayedRowIndex,
        getLastDisplayedRowIndex: $437b23f6a393c3bf$var$getLastDisplayedRowIndex,
        getDisplayedRowAtIndex: $437b23f6a393c3bf$var$getDisplayedRowAtIndex,
        getDisplayedRowCount: $437b23f6a393c3bf$var$getDisplayedRowCount
    }
};
var $437b23f6a393c3bf$export$351f260d7f887abc = {
    moduleName: "ScrollApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        getVerticalPixelRange: $437b23f6a393c3bf$var$getVerticalPixelRange,
        getHorizontalPixelRange: $437b23f6a393c3bf$var$getHorizontalPixelRange,
        ensureColumnVisible: $437b23f6a393c3bf$var$ensureColumnVisible,
        ensureIndexVisible: $437b23f6a393c3bf$var$ensureIndexVisible,
        ensureNodeVisible: $437b23f6a393c3bf$var$ensureNodeVisible
    }
};
// packages/ag-grid-community/src/rendering/renderApi.ts
function $437b23f6a393c3bf$var$setGridAriaProperty(beans, property, value) {
    if (!property) return;
    const eGrid = beans.ctrlsSvc.getGridBodyCtrl().eGridBody;
    const ariaProperty = `aria-${property}`;
    if (value === null) eGrid.removeAttribute(ariaProperty);
    else eGrid.setAttribute(ariaProperty, value);
}
function $437b23f6a393c3bf$var$refreshCells(beans, params = {}) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.rowRenderer.refreshCells(params));
}
function $437b23f6a393c3bf$var$refreshHeader(beans) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.ctrlsSvc.getHeaderRowContainerCtrls().forEach((c)=>c.refresh()));
}
function $437b23f6a393c3bf$var$isAnimationFrameQueueEmpty(beans) {
    return beans.animationFrameSvc?.isQueueEmpty() ?? true;
}
function $437b23f6a393c3bf$var$flushAllAnimationFrames(beans) {
    beans.animationFrameSvc?.flushAllFrames();
}
function $437b23f6a393c3bf$var$getSizesForCurrentTheme(beans) {
    return {
        rowHeight: $437b23f6a393c3bf$export$8966875adec41e5b(beans),
        headerHeight: $437b23f6a393c3bf$var$getHeaderHeight(beans)
    };
}
function $437b23f6a393c3bf$var$getCellRendererInstances(beans, params = {}) {
    const cellRenderers = [];
    beans.rowRenderer.getCellCtrls(params.rowNodes, params.columns).forEach((cellCtrl)=>{
        const cellRenderer = cellCtrl.getCellRenderer();
        if (cellRenderer != null) cellRenderers.push($437b23f6a393c3bf$export$213d4c63c3df47e4(cellRenderer));
    });
    if (params.columns?.length) return cellRenderers;
    const fullWidthRenderers = [];
    const rowIdMap = $437b23f6a393c3bf$var$mapRowNodes(params.rowNodes);
    beans.rowRenderer.getAllRowCtrls().forEach((rowCtrl)=>{
        if (rowIdMap && !$437b23f6a393c3bf$var$isRowInMap(rowCtrl.rowNode, rowIdMap)) return;
        if (!rowCtrl.isFullWidth()) return;
        const renderers = rowCtrl.getFullWidthCellRenderers();
        for(let i = 0; i < renderers.length; i++){
            const renderer = renderers[i];
            if (renderer != null) fullWidthRenderers.push($437b23f6a393c3bf$export$213d4c63c3df47e4(renderer));
        }
    });
    return [
        ...fullWidthRenderers,
        ...cellRenderers
    ];
}
// packages/ag-grid-community/src/rendering/renderModule.ts
var $437b23f6a393c3bf$export$b67b27f72da743ce = {
    moduleName: "RenderApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        setGridAriaProperty: $437b23f6a393c3bf$var$setGridAriaProperty,
        refreshCells: $437b23f6a393c3bf$var$refreshCells,
        refreshHeader: $437b23f6a393c3bf$var$refreshHeader,
        isAnimationFrameQueueEmpty: $437b23f6a393c3bf$var$isAnimationFrameQueueEmpty,
        flushAllAnimationFrames: $437b23f6a393c3bf$var$flushAllAnimationFrames,
        getSizesForCurrentTheme: $437b23f6a393c3bf$var$getSizesForCurrentTheme,
        getCellRendererInstances: $437b23f6a393c3bf$var$getCellRendererInstances
    }
};
// packages/ag-grid-community/src/columnAutosize/columnAutosizeApi.ts
function $437b23f6a393c3bf$var$sizeColumnsToFit(beans, paramsOrGridWidth) {
    if (typeof paramsOrGridWidth === "number") beans.colAutosize?.sizeColumnsToFit(paramsOrGridWidth, "api");
    else beans.colAutosize?.sizeColumnsToFitGridBody(paramsOrGridWidth);
}
function $437b23f6a393c3bf$var$autoSizeColumns({ colAutosize: colAutosize, visibleCols: visibleCols }, keysOrParams, skipHeader) {
    if (Array.isArray(keysOrParams)) colAutosize?.autoSizeCols({
        colKeys: keysOrParams,
        skipHeader: skipHeader,
        source: "api"
    });
    else colAutosize?.autoSizeCols({
        colKeys: keysOrParams.colIds ?? visibleCols.allCols,
        skipHeader: keysOrParams.skipHeader,
        defaultMaxWidth: keysOrParams.defaultMaxWidth,
        defaultMinWidth: keysOrParams.defaultMinWidth,
        columnLimits: keysOrParams.columnLimits,
        source: "api"
    });
}
function $437b23f6a393c3bf$var$autoSizeAllColumns(beans, paramsOrSkipHeader) {
    if (paramsOrSkipHeader && typeof paramsOrSkipHeader === "object") $437b23f6a393c3bf$var$autoSizeColumns(beans, paramsOrSkipHeader);
    else beans.colAutosize?.autoSizeAllColumns({
        source: "api",
        skipHeader: paramsOrSkipHeader
    });
}
// packages/ag-grid-community/src/columnAutosize/columnAutosizeService.ts
var $437b23f6a393c3bf$var$ColumnAutosizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colAutosize";
        this.timesDelayed = 0;
        // when we're waiting for cell data types to be inferred, we need to defer column resizing
        this.shouldQueueResizeOperations = false;
        this.resizeOperationQueue = [];
    }
    postConstruct() {
        this.addManagedEventListeners({
            firstDataRendered: ()=>this.onFirstDataRendered()
        });
    }
    autoSizeCols(params) {
        if (this.shouldQueueResizeOperations) {
            this.pushResizeOperation(()=>this.autoSizeCols(params));
            return;
        }
        const { colKeys: colKeys, skipHeader: skipHeader, skipHeaderGroups: skipHeaderGroups, stopAtGroup: stopAtGroup, defaultMaxWidth: defaultMaxWidth, defaultMinWidth: defaultMinWidth, columnLimits: columnLimits = [], source: source = "api" } = params;
        const { animationFrameSvc: animationFrameSvc, renderStatus: renderStatus, colModel: colModel, autoWidthCalc: autoWidthCalc, visibleCols: visibleCols } = this.beans;
        animationFrameSvc?.flushAllFrames();
        if (this.timesDelayed < 5 && renderStatus && !renderStatus.areHeaderCellsRendered()) {
            this.timesDelayed++;
            setTimeout(()=>{
                if (this.isAlive()) this.autoSizeCols(params);
            });
            return;
        }
        this.timesDelayed = 0;
        const columnsAutoSized = [];
        let changesThisTimeAround = -1;
        const columnLimitsIndex = Object.fromEntries(columnLimits.map(({ colId: colId, maxWidth: maxWidth, minWidth: minWidth })=>[
                colId,
                {
                    maxWidth: maxWidth,
                    minWidth: minWidth
                }
            ]));
        const shouldSkipHeader = skipHeader != null ? skipHeader : this.gos.get("skipHeaderOnAutoSize");
        const shouldSkipHeaderGroups = skipHeaderGroups != null ? skipHeaderGroups : shouldSkipHeader;
        while(changesThisTimeAround !== 0){
            changesThisTimeAround = 0;
            const updatedColumns = [];
            colKeys.forEach((key)=>{
                if (!key || $437b23f6a393c3bf$export$ee97d5717f8d44ec(key)) return;
                const column = colModel.getCol(key);
                if (!column) return;
                if (columnsAutoSized.indexOf(column) >= 0) return;
                const preferredWidth = autoWidthCalc.getPreferredWidthForColumn(column, shouldSkipHeader);
                if (preferredWidth > 0) {
                    const columnLimit = columnLimitsIndex[column.colId] ?? {};
                    columnLimit.minWidth ?? (columnLimit.minWidth = defaultMinWidth);
                    columnLimit.maxWidth ?? (columnLimit.maxWidth = defaultMaxWidth);
                    const newWidth = $437b23f6a393c3bf$var$normaliseColumnWidth(column, preferredWidth, columnLimit);
                    column.setActualWidth(newWidth, source);
                    columnsAutoSized.push(column);
                    changesThisTimeAround++;
                }
                updatedColumns.push(column);
            });
            if (!updatedColumns.length) continue;
            visibleCols.refresh(source);
        }
        if (!shouldSkipHeaderGroups) this.autoSizeColumnGroupsByColumns(colKeys, source, stopAtGroup);
        $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, columnsAutoSized, true, "autosizeColumns");
    }
    autoSizeColumn(key, source, skipHeader) {
        if (key) this.autoSizeCols({
            colKeys: [
                key
            ],
            skipHeader: skipHeader,
            skipHeaderGroups: true,
            source: source
        });
    }
    autoSizeColumnGroupsByColumns(keys, source, stopAtGroup) {
        const { colModel: colModel, ctrlsSvc: ctrlsSvc } = this.beans;
        const columnGroups = /* @__PURE__ */ new Set();
        const columns = colModel.getColsForKeys(keys);
        columns.forEach((col)=>{
            let parent = col.getParent();
            while(parent && parent != stopAtGroup){
                if (!parent.isPadding()) columnGroups.add(parent);
                parent = parent.getParent();
            }
        });
        let headerGroupCtrl;
        const resizedColumns = [];
        for (const columnGroup of columnGroups){
            for (const headerContainerCtrl of ctrlsSvc.getHeaderRowContainerCtrls()){
                headerGroupCtrl = headerContainerCtrl.getHeaderCtrlForColumn(columnGroup);
                if (headerGroupCtrl) break;
            }
            if (headerGroupCtrl) headerGroupCtrl.resizeLeafColumnsToFit(source);
        }
        return resizedColumns;
    }
    autoSizeAllColumns(params) {
        if (this.shouldQueueResizeOperations) {
            this.pushResizeOperation(()=>this.autoSizeAllColumns(params));
            return;
        }
        const allDisplayedColumns = this.beans.visibleCols.allCols;
        this.autoSizeCols({
            colKeys: allDisplayedColumns,
            ...params
        });
    }
    addColumnAutosize(element, column) {
        const skipHeaderOnAutoSize = this.gos.get("skipHeaderOnAutoSize");
        const autoSizeColListener = ()=>{
            this.autoSizeColumn(column, "uiColumnResized", skipHeaderOnAutoSize);
        };
        element.addEventListener("dblclick", autoSizeColListener);
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(element);
        touchListener.addEventListener("doubleTap", autoSizeColListener);
        return ()=>{
            element.removeEventListener("dblclick", autoSizeColListener);
            touchListener.removeEventListener("doubleTap", autoSizeColListener);
            touchListener.destroy();
        };
    }
    addColumnGroupResize(element, columnGroup, callback) {
        const skipHeaderOnAutoSize = this.gos.get("skipHeaderOnAutoSize");
        const listener = ()=>{
            const keys = [];
            const leafCols = columnGroup.getDisplayedLeafColumns();
            leafCols.forEach((column)=>{
                if (!column.getColDef().suppressAutoSize) keys.push(column.getColId());
            });
            if (keys.length > 0) this.autoSizeCols({
                colKeys: keys,
                skipHeader: skipHeaderOnAutoSize,
                stopAtGroup: columnGroup,
                source: "uiColumnResized"
            });
            callback();
        };
        element.addEventListener("dblclick", listener);
        return ()=>element.removeEventListener("dblclick", listener);
    }
    // method will call itself if no available width. this covers if the grid
    // isn't visible, but is just about to be visible.
    sizeColumnsToFitGridBody(params, nextTimeout) {
        if (!this.isAlive()) return;
        const { ctrlsSvc: ctrlsSvc, scrollVisibleSvc: scrollVisibleSvc } = this.beans;
        const gridBodyCtrl = ctrlsSvc.getGridBodyCtrl();
        const removeScrollWidth = gridBodyCtrl.isVerticalScrollShowing();
        const scrollWidthToRemove = removeScrollWidth ? scrollVisibleSvc.getScrollbarWidth() : 0;
        const bodyViewportWidth = $437b23f6a393c3bf$export$cc615e4191ec3e0c(gridBodyCtrl.eGridBody);
        const availableWidth = bodyViewportWidth - scrollWidthToRemove;
        if (availableWidth > 0) {
            this.sizeColumnsToFit(availableWidth, "sizeColumnsToFit", false, params);
            return;
        }
        if (nextTimeout === void 0) window.setTimeout(()=>{
            this.sizeColumnsToFitGridBody(params, 100);
        }, 0);
        else if (nextTimeout === 100) window.setTimeout(()=>{
            this.sizeColumnsToFitGridBody(params, 500);
        }, 100);
        else if (nextTimeout === 500) window.setTimeout(()=>{
            this.sizeColumnsToFitGridBody(params, -1);
        }, 500);
        else $437b23f6a393c3bf$export$545083624300f13d(29);
    }
    // called from api
    sizeColumnsToFit(gridWidth, source = "sizeColumnsToFit", silent, params) {
        if (this.shouldQueueResizeOperations) {
            this.pushResizeOperation(()=>this.sizeColumnsToFit(gridWidth, source, silent, params));
            return;
        }
        const limitsMap = {};
        if (params) params?.columnLimits?.forEach(({ key: key, ...dimensions })=>{
            limitsMap[typeof key === "string" ? key : key.getColId()] = dimensions;
        });
        const allDisplayedColumns = this.beans.visibleCols.allCols;
        if (gridWidth <= 0 || !allDisplayedColumns.length) return;
        const doColumnsAlreadyFit = gridWidth === $437b23f6a393c3bf$var$getWidthOfColsInList(allDisplayedColumns);
        if (doColumnsAlreadyFit) {
            const doAllColumnsSatisfyConstraints = allDisplayedColumns.every((column)=>{
                if (column.colDef.suppressSizeToFit) return true;
                const widthOverride = limitsMap?.[column.getId()];
                const minWidth = widthOverride?.minWidth ?? params?.defaultMinWidth;
                const maxWidth = widthOverride?.maxWidth ?? params?.defaultMaxWidth;
                const colWidth = column.getActualWidth();
                return (minWidth == null || colWidth >= minWidth) && (maxWidth == null || colWidth <= maxWidth);
            });
            if (doAllColumnsSatisfyConstraints) return;
        }
        const colsToSpread = [];
        const colsToNotSpread = [];
        allDisplayedColumns.forEach((column)=>{
            if (column.getColDef().suppressSizeToFit === true) colsToNotSpread.push(column);
            else colsToSpread.push(column);
        });
        const colsToDispatchEventFor = colsToSpread.slice(0);
        let finishedResizing = false;
        const moveToNotSpread = (column)=>{
            $437b23f6a393c3bf$export$83a881c8b5120679(colsToSpread, column);
            colsToNotSpread.push(column);
        };
        colsToSpread.forEach((column)=>{
            column.resetActualWidth(source);
            const widthOverride = limitsMap?.[column.getId()];
            const minOverride = widthOverride?.minWidth ?? params?.defaultMinWidth;
            const maxOverride = widthOverride?.maxWidth ?? params?.defaultMaxWidth;
            const colWidth = column.getActualWidth();
            if (typeof minOverride === "number" && colWidth < minOverride) column.setActualWidth(minOverride, source, true);
            else if (typeof maxOverride === "number" && colWidth > maxOverride) column.setActualWidth(maxOverride, source, true);
        });
        while(!finishedResizing){
            finishedResizing = true;
            const availablePixels = gridWidth - $437b23f6a393c3bf$var$getWidthOfColsInList(colsToNotSpread);
            if (availablePixels <= 0) colsToSpread.forEach((column)=>{
                const widthOverride = limitsMap?.[column.getId()]?.minWidth ?? params?.defaultMinWidth;
                if (typeof widthOverride === "number") {
                    column.setActualWidth(widthOverride, source, true);
                    return;
                }
                column.setActualWidth(column.minWidth, source);
            });
            else {
                const scale = availablePixels / $437b23f6a393c3bf$var$getWidthOfColsInList(colsToSpread);
                let pixelsForLastCol = availablePixels;
                for(let i = colsToSpread.length - 1; i >= 0; i--){
                    const column = colsToSpread[i];
                    const widthOverride = limitsMap?.[column.getId()];
                    const minOverride = widthOverride?.minWidth ?? params?.defaultMinWidth;
                    const maxOverride = widthOverride?.maxWidth ?? params?.defaultMaxWidth;
                    const colMinWidth = column.getMinWidth();
                    const colMaxWidth = column.getMaxWidth();
                    const minWidth = typeof minOverride === "number" && minOverride > colMinWidth ? minOverride : colMinWidth;
                    const maxWidth = typeof maxOverride === "number" && maxOverride < colMaxWidth ? maxOverride : colMaxWidth;
                    let newWidth = Math.round(column.getActualWidth() * scale);
                    if (newWidth < minWidth) {
                        newWidth = minWidth;
                        moveToNotSpread(column);
                        finishedResizing = false;
                    } else if (newWidth > maxWidth) {
                        newWidth = maxWidth;
                        moveToNotSpread(column);
                        finishedResizing = false;
                    } else if (i === 0) newWidth = pixelsForLastCol;
                    column.setActualWidth(newWidth, source, true);
                    pixelsForLastCol -= newWidth;
                }
            }
        }
        colsToDispatchEventFor.forEach((col)=>{
            col.fireColumnWidthChangedEvent(source);
        });
        const visibleCols = this.beans.visibleCols;
        visibleCols.setLeftValues(source);
        visibleCols.updateBodyWidths();
        if (silent) return;
        $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, colsToDispatchEventFor, true, source);
    }
    applyAutosizeStrategy() {
        const autoSizeStrategy = this.gos.get("autoSizeStrategy");
        if (!autoSizeStrategy) return;
        const { type: type } = autoSizeStrategy;
        setTimeout(()=>{
            if (type === "fitGridWidth") {
                const { columnLimits: propColumnLimits, defaultMinWidth: defaultMinWidth, defaultMaxWidth: defaultMaxWidth } = autoSizeStrategy;
                const columnLimits = propColumnLimits?.map(({ colId: key, minWidth: minWidth, maxWidth: maxWidth })=>({
                        key: key,
                        minWidth: minWidth,
                        maxWidth: maxWidth
                    }));
                this.sizeColumnsToFitGridBody({
                    defaultMinWidth: defaultMinWidth,
                    defaultMaxWidth: defaultMaxWidth,
                    columnLimits: columnLimits
                });
            } else if (type === "fitProvidedWidth") this.sizeColumnsToFit(autoSizeStrategy.width, "sizeColumnsToFit");
        });
    }
    onFirstDataRendered() {
        const autoSizeStrategy = this.gos.get("autoSizeStrategy");
        if (autoSizeStrategy?.type !== "fitCellContents") return;
        const { colIds: columns, skipHeader: skipHeader, defaultMaxWidth: defaultMaxWidth, defaultMinWidth: defaultMinWidth, columnLimits: columnLimits } = autoSizeStrategy;
        setTimeout(()=>{
            const params = {
                skipHeader: skipHeader,
                source: "autosizeColumns",
                defaultMaxWidth: defaultMaxWidth,
                defaultMinWidth: defaultMinWidth,
                columnLimits: columnLimits
            };
            if (columns) this.autoSizeCols({
                colKeys: columns,
                ...params
            });
            else this.autoSizeAllColumns(params);
        });
    }
    processResizeOperations() {
        this.shouldQueueResizeOperations = false;
        this.resizeOperationQueue.forEach((resizeOperation)=>resizeOperation());
        this.resizeOperationQueue = [];
    }
    pushResizeOperation(func) {
        this.resizeOperationQueue.push(func);
    }
    destroy() {
        this.resizeOperationQueue.length = 0;
        super.destroy();
    }
};
function $437b23f6a393c3bf$var$normaliseColumnWidth(column, newWidth, limits = {}) {
    const minWidth = limits.minWidth ?? column.getMinWidth();
    if (newWidth < minWidth) newWidth = minWidth;
    const maxWidth = limits.maxWidth ?? column.getMaxWidth();
    if (newWidth > maxWidth) newWidth = maxWidth;
    return newWidth;
}
// packages/ag-grid-community/src/columnAutosize/columnAutosizeModule.ts
var $437b23f6a393c3bf$export$baf19ca56ec781d2 = {
    moduleName: "ColumnAutoSize",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnAutosizeService
    ],
    apiFunctions: {
        sizeColumnsToFit: $437b23f6a393c3bf$var$sizeColumnsToFit,
        autoSizeColumns: $437b23f6a393c3bf$var$autoSizeColumns,
        autoSizeAllColumns: $437b23f6a393c3bf$var$autoSizeAllColumns
    },
    dependsOn: [
        $437b23f6a393c3bf$var$AutoWidthModule
    ]
};
// packages/ag-grid-community/src/pinnedRowModel/manualPinnedRow.css-GENERATED.ts
var $437b23f6a393c3bf$var$manualPinnedRowCSS = /*css*/ `.ag-row-pinned-source{background-color:var(--ag-pinned-source-row-background-color);color:var(--ag-pinned-source-row-text-color);font-weight:var(--ag-pinned-source-row-font-weight)}.ag-row-pinned-manual{background-color:var(--ag-pinned-row-background-color);color:var(--ag-pinned-row-text-color);font-weight:var(--ag-pinned-row-font-weight)}`;
// packages/ag-grid-community/src/pinnedRowModel/pinnedRowApi.ts
function $437b23f6a393c3bf$var$getPinnedTopRowCount(beans) {
    return beans.pinnedRowModel?.getPinnedTopRowCount() ?? 0;
}
function $437b23f6a393c3bf$var$getPinnedBottomRowCount(beans) {
    return beans.pinnedRowModel?.getPinnedBottomRowCount() ?? 0;
}
function $437b23f6a393c3bf$var$getPinnedTopRow(beans, index) {
    return beans.pinnedRowModel?.getPinnedTopRow(index);
}
function $437b23f6a393c3bf$var$getPinnedBottomRow(beans, index) {
    return beans.pinnedRowModel?.getPinnedBottomRow(index);
}
function $437b23f6a393c3bf$var$forEachPinnedRow(beans, floating, callback) {
    return beans.pinnedRowModel?.forEachPinnedRow(floating, callback);
}
// packages/ag-grid-community/src/pinnedRowModel/pinnedRowModule.ts
var $437b23f6a393c3bf$export$b6e84cdeabbb116a = {
    moduleName: "PinnedRow",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$export$d44126a5f53c99d9
    ],
    css: [
        $437b23f6a393c3bf$var$manualPinnedRowCSS
    ],
    apiFunctions: {
        getPinnedTopRowCount: $437b23f6a393c3bf$var$getPinnedTopRowCount,
        getPinnedBottomRowCount: $437b23f6a393c3bf$var$getPinnedBottomRowCount,
        getPinnedTopRow: $437b23f6a393c3bf$var$getPinnedTopRow,
        getPinnedBottomRow: $437b23f6a393c3bf$var$getPinnedBottomRow,
        forEachPinnedRow: $437b23f6a393c3bf$var$forEachPinnedRow
    },
    icons: {
        rowPin: "pin",
        rowPinTop: "pinned-top",
        rowPinBottom: "pinned-bottom",
        rowUnpin: "un-pin"
    }
};
// packages/ag-grid-community/src/rendering/spanning/spannedCellCtrl.ts
var $437b23f6a393c3bf$var$SpannedCellCtrl = class extends $437b23f6a393c3bf$var$CellCtrl {
    constructor(cellSpan, rowCtrl, beans){
        super(cellSpan.col, cellSpan.firstNode, beans, rowCtrl);
        this.cellSpan = cellSpan;
        this.SPANNED_CELL_CSS_CLASS = "ag-spanned-cell";
    }
    setComp(comp, eCell, eWrapper, eCellWrapper, printLayout, startEditing, compBean) {
        this.eWrapper = eWrapper;
        super.setComp(comp, eCell, eWrapper, eCellWrapper, printLayout, startEditing, compBean);
        this.setAriaRowSpan();
        this.refreshAriaRowIndex();
    }
    isCellSpanning() {
        return true;
    }
    getCellSpan() {
        return this.cellSpan;
    }
    /**
   * When cell is spanning, ensure row index is also available on the cell
   */ refreshAriaRowIndex() {
        if (this.rowNode.rowIndex == null) return;
        $437b23f6a393c3bf$export$ba731dedf9d88615(this.eGui, this.rowNode.rowIndex);
    }
    /**
   * When cell is spanning, ensure row index is also available on the cell
   */ setAriaRowSpan() {
        $437b23f6a393c3bf$var$_setAriaRowSpan(this.eGui, this.cellSpan.spannedNodes.size);
    }
    // not ideal, for tabbing need to force the focused position
    setFocusedCellPosition(cellPos) {
        this.focusedCellPosition = cellPos;
    }
    getFocusedCellPosition() {
        return this.focusedCellPosition ?? this.cellPosition;
    }
    checkCellFocused() {
        const focusedCell = this.beans.focusSvc.getFocusedCell();
        return !!focusedCell && this.cellSpan.doesSpanContain(focusedCell);
    }
    applyStaticCssClasses() {
        super.applyStaticCssClasses();
        this.comp.toggleCss(this.SPANNED_CELL_CSS_CLASS, true);
    }
    onCellFocused(event) {
        const { beans: beans } = this;
        if ($437b23f6a393c3bf$var$_isCellFocusSuppressed(beans)) {
            this.focusedCellPosition = void 0;
            return;
        }
        const cellFocused = this.isCellFocused();
        if (!cellFocused) this.focusedCellPosition = void 0;
        if (event && cellFocused) this.focusedCellPosition = {
            rowIndex: event.rowIndex,
            rowPinned: event.rowPinned,
            column: event.column
        };
        super.onCellFocused(event);
    }
    getRootElement() {
        return this.eWrapper;
    }
};
// packages/ag-grid-community/src/rendering/spanning/spannedRowCtrl.ts
var $437b23f6a393c3bf$var$SpannedRowCtrl = class extends $437b23f6a393c3bf$var$RowCtrl {
    onRowIndexChanged() {
        super.onRowIndexChanged();
        this.getAllCellCtrls().forEach((c)=>c.refreshAriaRowIndex());
    }
    getInitialRowClasses(_rowContainerType) {
        return [
            "ag-spanned-row"
        ];
    }
    getNewCellCtrl(col) {
        const cellSpan = this.beans.rowSpanSvc?.getCellSpan(col, this.rowNode);
        if (!cellSpan) return;
        const firstRowOfSpan = cellSpan.firstNode !== this.rowNode;
        if (firstRowOfSpan) return;
        return new $437b23f6a393c3bf$var$SpannedCellCtrl(cellSpan, this, this.beans);
    }
    isCorrectCtrlForSpan(cell) {
        const cellSpan = this.beans.rowSpanSvc?.getCellSpan(cell.column, this.rowNode);
        if (!cellSpan) return false;
        const firstRowOfSpan = cellSpan.firstNode !== this.rowNode;
        if (firstRowOfSpan) return false;
        return cell.getCellSpan() === cellSpan;
    }
    /**
   * Below overrides are explicitly disabling styling and other unwanted behaviours for spannedRowCtrl
   */ // row height should be 0 in spanned row - they're only included for purpose of aria
    onRowHeightChanged() {}
    // no styling spanned rows
    refreshFirstAndLastRowStyles() {}
    // no hover functionality for spanned rows
    addHoverFunctionality() {}
    resetHoveredStatus() {}
};
// packages/ag-grid-community/src/rendering/spanning/spannedRowRenderer.ts
var $437b23f6a393c3bf$var$SpannedRowRenderer = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "spannedRowRenderer";
        this.topCtrls = /* @__PURE__ */ new Map();
        this.bottomCtrls = /* @__PURE__ */ new Map();
        this.centerCtrls = /* @__PURE__ */ new Map();
    }
    postConstruct() {
        this.addManagedEventListeners({
            displayedRowsChanged: this.createAllCtrls.bind(this)
        });
    }
    createAllCtrls() {
        this.createCtrls("top");
        this.createCtrls("bottom");
        this.createCtrls("center");
    }
    /**
   * When displayed rows or cols change, the spanned cell ctrls need to update
   */ createCtrls(ctrlsKey) {
        const { rowSpanSvc: rowSpanSvc } = this.beans;
        const ctrlsName = `${ctrlsKey}Ctrls`;
        const previousCtrls = this[ctrlsName];
        const previousCtrlsSize = previousCtrls.size;
        const rowCtrls = this.getAllRelevantRowControls(ctrlsKey);
        const newRowCtrls = /* @__PURE__ */ new Map();
        let hasNewSpans = false;
        for (const ctrl of rowCtrls){
            if (!ctrl.isAlive()) continue;
            rowSpanSvc?.forEachSpannedColumn(ctrl.rowNode, (col, cellSpan)=>{
                if (newRowCtrls.has(cellSpan.firstNode)) return;
                const existingCtrl = previousCtrls.get(cellSpan.firstNode);
                if (existingCtrl) {
                    newRowCtrls.set(cellSpan.firstNode, existingCtrl);
                    previousCtrls.delete(cellSpan.firstNode);
                    return;
                }
                hasNewSpans = true;
                const newCtrl = new $437b23f6a393c3bf$var$SpannedRowCtrl(cellSpan.firstNode, this.beans, false, false, false);
                newRowCtrls.set(cellSpan.firstNode, newCtrl);
            });
        }
        this[ctrlsName] = newRowCtrls;
        const sameCount = newRowCtrls.size === previousCtrlsSize;
        if (!hasNewSpans && sameCount) return;
        for (const oldCtrl of previousCtrls.values()){
            oldCtrl.destroyFirstPass(true);
            oldCtrl.destroySecondPass();
        }
        this.dispatchLocalEvent({
            type: `spannedRowsUpdated`,
            ctrlsKey: ctrlsKey
        });
    }
    // cannot use getAllRowCtrls as it returns this services row ctrls.
    getAllRelevantRowControls(ctrlsKey) {
        const { rowRenderer: rowRenderer } = this.beans;
        switch(ctrlsKey){
            case "top":
                return rowRenderer.topRowCtrls;
            case "bottom":
                return rowRenderer.bottomRowCtrls;
            case "center":
                return rowRenderer.allRowCtrls;
        }
    }
    getCellByPosition(cellPosition) {
        const { rowSpanSvc: rowSpanSvc } = this.beans;
        const cellSpan = rowSpanSvc?.getCellSpanByPosition(cellPosition);
        if (!cellSpan) return void 0;
        const ctrlsName = `${$437b23f6a393c3bf$var$_normalisePinnedValue(cellPosition.rowPinned)}Ctrls`;
        const ctrl = this[ctrlsName].get(cellSpan.firstNode);
        if (!ctrl) return void 0;
        return ctrl.getAllCellCtrls().find((cellCtrl)=>cellCtrl.column === cellPosition.column);
    }
    getCtrls(container) {
        const ctrlsName = `${container}Ctrls`;
        return [
            ...this[ctrlsName].values()
        ];
    }
    destroyRowCtrls(container) {
        const ctrlsName = `${container}Ctrls`;
        for (const ctrl of this[ctrlsName].values()){
            ctrl.destroyFirstPass(true);
            ctrl.destroySecondPass();
        }
        this[ctrlsName] = /* @__PURE__ */ new Map();
    }
    destroy() {
        super.destroy();
        this.destroyRowCtrls("top");
        this.destroyRowCtrls("bottom");
        this.destroyRowCtrls("center");
    }
};
var $437b23f6a393c3bf$var$_normalisePinnedValue = (pinned)=>{
    return pinned ?? "center";
};
// packages/ag-grid-community/src/rendering/spanning/rowSpanCache.ts
var $437b23f6a393c3bf$var$CellSpan = class {
    constructor(col, firstNode){
        this.col = col;
        this.firstNode = firstNode;
        // used for distinguishing between types
        this.cellSpan = true;
        this.spannedNodes = /* @__PURE__ */ new Set();
        this.addSpannedNode(firstNode);
    }
    /**
   * Reset the span leaving only the head.
   * Head is used as a comparison as this is the row used to render this cell
   * Even if the row data changes, the cell will properly reflect the correct value.
   */ reset() {
        this.spannedNodes.clear();
        this.addSpannedNode(this.firstNode);
    }
    addSpannedNode(node) {
        this.spannedNodes.add(node);
        this.lastNode = node;
    }
    getLastNode() {
        return this.lastNode;
    }
    getCellHeight() {
        return this.lastNode.rowTop + this.lastNode.rowHeight - this.firstNode.rowTop - 1;
    }
    doesSpanContain(cellPosition) {
        if (cellPosition.column !== this.col) return false;
        if (cellPosition.rowPinned != this.firstNode.rowPinned) return false;
        return this.firstNode.rowIndex <= cellPosition.rowIndex && cellPosition.rowIndex <= this.lastNode.rowIndex;
    }
    /**
   * Gets the auto height value for last node in the spanned cell.
   * The first node is used to store the auto height for the cell, but the additional height for this cell
   * needs applied to the last row in the span.
   */ getLastNodeAutoHeight() {
        const autoHeight = this.firstNode.__autoHeights?.[this.col.getColId()];
        if (autoHeight == null) return void 0;
        let allButLastHeights = 0;
        this.spannedNodes.forEach((node)=>{
            if (node === this.lastNode) return;
            allButLastHeights += node.rowHeight;
        });
        return autoHeight - allButLastHeights;
    }
};
var $437b23f6a393c3bf$var$RowSpanCache = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column){
        super();
        this.column = column;
    }
    buildCache(pinned) {
        const { column: column, beans: { gos: gos, pinnedRowModel: pinnedRowModel, rowModel: rowModel, valueSvc: valueSvc, pagination: pagination } } = this;
        const { colDef: colDef } = column;
        const oldMap = this[`${pinned}ValueNodeMap`];
        const newMap = /* @__PURE__ */ new Map();
        const isFullWidthCellFunc = gos.getCallback("isFullWidthRow");
        const equalsFnc = colDef.equals;
        const customCompare = colDef.spanRows;
        const isCustomCompare = typeof customCompare === "function";
        let lastNode = null;
        let spanData = null;
        let lastValue;
        const setNewHead = (node, value)=>{
            lastNode = node;
            spanData = null;
            lastValue = value;
        };
        const checkNodeForCache = (node)=>{
            const doesNodeSupportSpanning = !node.isExpandable() && !node.group && !node.detail && (isFullWidthCellFunc ? !isFullWidthCellFunc({
                rowNode: node
            }) : true);
            if (node.rowIndex == null || !doesNodeSupportSpanning) {
                setNewHead(null, null);
                return;
            }
            if (lastNode == null || node.level !== lastNode.level || // no span across groups
            node.footer || spanData && node.rowIndex - 1 !== spanData?.getLastNode().rowIndex) {
                setNewHead(node, valueSvc.getValue(column, node));
                return;
            }
            const value = valueSvc.getValue(column, node);
            if (isCustomCompare) {
                const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
                    valueA: lastValue,
                    nodeA: lastNode,
                    valueB: value,
                    nodeB: node,
                    column: column,
                    colDef: colDef
                });
                if (!customCompare(params)) {
                    setNewHead(node, value);
                    return;
                }
            } else if (equalsFnc ? !equalsFnc(lastValue, value) : lastValue !== value) {
                setNewHead(node, value);
                return;
            }
            if (!spanData) {
                const oldSpan = oldMap?.get(lastNode);
                if (oldSpan?.firstNode === lastNode) {
                    oldSpan.reset();
                    spanData = oldSpan;
                } else spanData = new $437b23f6a393c3bf$var$CellSpan(column, lastNode);
                newMap.set(lastNode, spanData);
            }
            spanData.addSpannedNode(node);
            newMap.set(node, spanData);
        };
        switch(pinned){
            case "center":
                rowModel.forEachDisplayedNode?.((node)=>{
                    const isNodeInPage = !pagination || pagination.isRowInPage(node.rowIndex);
                    if (!isNodeInPage) return;
                    checkNodeForCache(node);
                });
                break;
            case "top":
                pinnedRowModel?.forEachPinnedRow("top", checkNodeForCache);
                break;
            case "bottom":
                pinnedRowModel?.forEachPinnedRow("bottom", checkNodeForCache);
                break;
        }
        this[`${pinned}ValueNodeMap`] = newMap;
    }
    isCellSpanning(node) {
        return !!this.getCellSpan(node);
    }
    getCellSpan(node) {
        const map = this[`${$437b23f6a393c3bf$var$_normalisePinnedValue(node.rowPinned)}ValueNodeMap`];
        return map.get(node);
    }
};
// packages/ag-grid-community/src/rendering/spanning/rowSpanService.ts
var $437b23f6a393c3bf$var$RowSpanService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowSpanSvc";
        this.spanningColumns = /* @__PURE__ */ new Map();
        // debounced to allow spannedRowRenderer to run first, removing any old spanned rows
        this.debouncePinnedEvent = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.dispatchCellsUpdatedEvent.bind(this, true), 0);
        this.debounceModelEvent = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.dispatchCellsUpdatedEvent.bind(this, false), 0);
        this.pinnedTimeout = null;
        this.modelTimeout = null;
    }
    postConstruct() {
        const onRowDataUpdated = this.onRowDataUpdated.bind(this);
        const buildPinnedCaches = this.buildPinnedCaches.bind(this);
        this.addManagedEventListeners({
            paginationChanged: this.buildModelCaches.bind(this),
            pinnedRowDataChanged: buildPinnedCaches,
            pinnedRowsChanged: buildPinnedCaches,
            rowNodeDataChanged: onRowDataUpdated,
            cellValueChanged: onRowDataUpdated
        });
    }
    /**
   * When a new column is created with spanning (or spanning changes for a column)
   * @param column column that is now spanning
   */ register(column) {
        const { gos: gos } = this.beans;
        if (!gos.get("enableCellSpan")) return;
        if (this.spanningColumns.has(column)) return;
        const cache = this.createManagedBean(new $437b23f6a393c3bf$var$RowSpanCache(column));
        this.spanningColumns.set(column, cache);
        cache.buildCache("top");
        cache.buildCache("bottom");
        cache.buildCache("center");
        this.debouncePinnedEvent();
        this.debounceModelEvent();
    }
    dispatchCellsUpdatedEvent(pinned) {
        this.dispatchLocalEvent({
            type: "spannedCellsUpdated",
            pinned: pinned
        });
    }
    /**
   * When a new column is destroyed with spanning (or spanning changes for a column)
   * @param column column that is now spanning
   */ deregister(column) {
        this.spanningColumns.delete(column);
    }
    // called when data changes, as this could be a hot path it's debounced
    // it uses timeouts instead of debounce so that it can be cancelled by `modelUpdated`
    // which is expected to run immediately (to exec before the rowRenderer)
    onRowDataUpdated({ node: node }) {
        const { spannedRowRenderer: spannedRowRenderer } = this.beans;
        if (node.rowPinned) {
            if (this.pinnedTimeout != null) return;
            this.pinnedTimeout = window.setTimeout(()=>{
                this.pinnedTimeout = null;
                this.buildPinnedCaches();
                spannedRowRenderer?.createCtrls("top");
                spannedRowRenderer?.createCtrls("bottom");
            }, 0);
            return;
        }
        if (this.modelTimeout != null) return;
        this.modelTimeout = window.setTimeout(()=>{
            this.modelTimeout = null;
            this.buildModelCaches();
            spannedRowRenderer?.createCtrls("center");
        }, 0);
    }
    buildModelCaches() {
        if (this.modelTimeout != null) clearTimeout(this.modelTimeout);
        this.spanningColumns.forEach((cache)=>cache.buildCache("center"));
        this.debounceModelEvent();
    }
    buildPinnedCaches() {
        if (this.pinnedTimeout != null) clearTimeout(this.pinnedTimeout);
        this.spanningColumns.forEach((cache)=>{
            cache.buildCache("top");
            cache.buildCache("bottom");
        });
        this.debouncePinnedEvent();
    }
    isCellSpanning(col, rowNode) {
        const cache = this.spanningColumns.get(col);
        if (!cache) return false;
        return cache.isCellSpanning(rowNode);
    }
    getCellSpanByPosition(position) {
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = this.beans;
        const col = position.column;
        const index = position.rowIndex;
        const cache = this.spanningColumns.get(col);
        if (!cache) return void 0;
        let node;
        switch(position.rowPinned){
            case "top":
                node = pinnedRowModel?.getPinnedTopRow(index);
                break;
            case "bottom":
                node = pinnedRowModel?.getPinnedBottomRow(index);
                break;
            default:
                node = rowModel.getRow(index);
        }
        if (!node) return void 0;
        return cache.getCellSpan(node);
    }
    getCellStart(position) {
        const span = this.getCellSpanByPosition(position);
        if (!span) return position;
        return {
            ...position,
            rowIndex: span.firstNode.rowIndex
        };
    }
    getCellEnd(position) {
        const span = this.getCellSpanByPosition(position);
        if (!span) return position;
        return {
            ...position,
            rowIndex: span.getLastNode().rowIndex
        };
    }
    /**
   * Look-up a spanned cell given a col and node as position indicators
   *
   * @param col a column to lookup a span at this position
   * @param rowNode a node that may be spanned at this position
   * @returns the CellSpan object if one exists
   */ getCellSpan(col, rowNode) {
        const cache = this.spanningColumns.get(col);
        if (!cache) return void 0;
        return cache.getCellSpan(rowNode);
    }
    forEachSpannedColumn(rowNode, callback) {
        for (const [col, cache] of this.spanningColumns)if (cache.isCellSpanning(rowNode)) {
            const spanningNode = cache.getCellSpan(rowNode);
            callback(col, spanningNode);
        }
    }
    destroy() {
        super.destroy();
        this.spanningColumns.clear();
    }
};
// packages/ag-grid-community/src/rendering/spanning/cellSpanModule.ts
var $437b23f6a393c3bf$export$b7ca1fc11bfe19c3 = {
    moduleName: "CellSpan",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$RowSpanService,
        $437b23f6a393c3bf$var$SpannedRowRenderer
    ]
};
// packages/ag-grid-community/src/styling/cellCustomStyleFeature.ts
var $437b23f6a393c3bf$var$CellCustomStyleFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans){
        super();
        this.cellCtrl = cellCtrl;
        this.staticClasses = [];
        this.beans = beans;
        this.column = cellCtrl.column;
    }
    setComp(comp) {
        this.cellComp = comp;
        this.applyUserStyles();
        this.applyCellClassRules();
        this.applyClassesFromColDef();
    }
    applyCellClassRules() {
        const { column: column, cellComp: cellComp } = this;
        const colDef = column.colDef;
        const cellClassRules = colDef.cellClassRules;
        const cellClassParams = this.getCellClassParams(column, colDef);
        $437b23f6a393c3bf$var$processClassRules(this.beans.expressionSvc, // if current was previous, skip
        cellClassRules === this.cellClassRules ? void 0 : this.cellClassRules, cellClassRules, cellClassParams, (className)=>cellComp.toggleCss(className, true), (className)=>cellComp.toggleCss(className, false));
        this.cellClassRules = cellClassRules;
    }
    applyUserStyles() {
        const column = this.column;
        const colDef = column.colDef;
        const cellStyle = colDef.cellStyle;
        if (!cellStyle) return;
        let styles;
        if (typeof cellStyle === "function") {
            const cellStyleParams = this.getCellClassParams(column, colDef);
            styles = cellStyle(cellStyleParams);
        } else styles = cellStyle;
        if (styles) this.cellComp.setUserStyles(styles);
    }
    applyClassesFromColDef() {
        const { column: column, cellComp: cellComp } = this;
        const colDef = column.colDef;
        const cellClassParams = this.getCellClassParams(column, colDef);
        this.staticClasses.forEach((className)=>cellComp.toggleCss(className, false));
        const newStaticClasses = this.beans.cellStyles.getStaticCellClasses(colDef, cellClassParams);
        this.staticClasses = newStaticClasses;
        newStaticClasses.forEach((className)=>cellComp.toggleCss(className, true));
    }
    getCellClassParams(column, colDef) {
        const { value: value, rowNode: rowNode } = this.cellCtrl;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.beans.gos, {
            value: value,
            data: rowNode.data,
            node: rowNode,
            colDef: colDef,
            column: column,
            rowIndex: rowNode.rowIndex
        });
    }
};
// packages/ag-grid-community/src/styling/cellStyleService.ts
var $437b23f6a393c3bf$var$CellStyleService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "cellStyles";
    }
    processAllCellClasses(colDef, params, onApplicableClass, onNotApplicableClass) {
        $437b23f6a393c3bf$var$processClassRules(this.beans.expressionSvc, void 0, colDef.cellClassRules, params, onApplicableClass, onNotApplicableClass);
        this.processStaticCellClasses(colDef, params, onApplicableClass);
    }
    getStaticCellClasses(colDef, params) {
        const { cellClass: cellClass } = colDef;
        if (!cellClass) return [];
        let classOrClasses;
        if (typeof cellClass === "function") {
            const cellClassFunc = cellClass;
            classOrClasses = cellClassFunc(params);
        } else classOrClasses = cellClass;
        if (typeof classOrClasses === "string") classOrClasses = [
            classOrClasses
        ];
        return classOrClasses || [];
    }
    createCellCustomStyleFeature(ctrl, beans) {
        return new $437b23f6a393c3bf$var$CellCustomStyleFeature(ctrl, beans);
    }
    processStaticCellClasses(colDef, params, onApplicableClass) {
        const classOrClasses = this.getStaticCellClasses(colDef, params);
        classOrClasses.forEach((cssClassItem)=>{
            onApplicableClass(cssClassItem);
        });
    }
};
// packages/ag-grid-community/src/styling/stylingModule.ts
var $437b23f6a393c3bf$export$be75c2ed74fb2144 = {
    moduleName: "CellStyle",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$CellStyleService
    ]
};
var $437b23f6a393c3bf$export$dbb09c7a8266fd30 = {
    moduleName: "RowStyle",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$RowStyleService
    ]
};
// packages/ag-grid-community/src/columns/columnHover/columnHoverApi.ts
function $437b23f6a393c3bf$var$isColumnHovered(beans, column) {
    return !!beans.colHover?.isHovered(column);
}
// packages/ag-grid-community/src/columns/columnHover/hoverFeature.ts
var $437b23f6a393c3bf$var$HoverFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(columns, element){
        super();
        this.columns = columns;
        this.element = element;
        this.destroyManagedListeners = [];
        this.enableFeature = (enabled)=>{
            const { beans: beans, gos: gos, element: element, columns: columns } = this;
            const colHover = beans.colHover;
            const active = enabled ?? !!gos.get("columnHoverHighlight");
            if (active) this.destroyManagedListeners = this.addManagedElementListeners(element, {
                mouseover: colHover.setMouseOver.bind(colHover, columns),
                mouseout: colHover.clearMouseOver.bind(colHover)
            });
            else {
                this.destroyManagedListeners.forEach((fn)=>fn());
                this.destroyManagedListeners = [];
            }
        };
    }
    postConstruct() {
        this.addManagedPropertyListener("columnHoverHighlight", ({ currentValue: currentValue })=>{
            this.enableFeature(currentValue);
        });
        this.enableFeature();
    }
    destroy() {
        super.destroy();
        this.destroyManagedListeners = null;
    }
};
// packages/ag-grid-community/src/columns/columnHover/columnHoverService.ts
var $437b23f6a393c3bf$var$CSS_COLUMN_HOVER = "ag-column-hover";
var $437b23f6a393c3bf$var$ColumnHoverService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colHover";
    }
    postConstruct() {
        this.addManagedPropertyListener("columnHoverHighlight", ({ currentValue: currentValue })=>{
            if (!currentValue) this.clearMouseOver();
        });
    }
    setMouseOver(columns) {
        this.updateState(columns);
    }
    clearMouseOver() {
        this.updateState(null);
    }
    isHovered(column) {
        if (!this.gos.get("columnHoverHighlight")) return false;
        const selectedColumns = this.selectedColumns;
        return !!selectedColumns && selectedColumns.indexOf(column) >= 0;
    }
    addHeaderColumnHoverListener(compBean, comp, column) {
        const listener = ()=>{
            const isHovered = this.isHovered(column);
            comp.toggleCss("ag-column-hover", isHovered);
        };
        compBean.addManagedEventListeners({
            columnHoverChanged: listener
        });
        listener();
    }
    onCellColumnHover(column, cellComp) {
        if (!cellComp) return;
        const isHovered = this.isHovered(column);
        cellComp.toggleCss($437b23f6a393c3bf$var$CSS_COLUMN_HOVER, isHovered);
    }
    addHeaderFilterColumnHoverListener(compBean, comp, column, eGui) {
        this.createHoverFeature(compBean, [
            column
        ], eGui);
        const listener = ()=>{
            const hovered = this.isHovered(column);
            comp.toggleCss("ag-column-hover", hovered);
        };
        compBean.addManagedEventListeners({
            columnHoverChanged: listener
        });
        listener();
    }
    createHoverFeature(compBean, columns, eGui) {
        compBean.createManagedBean(new $437b23f6a393c3bf$var$HoverFeature(columns, eGui));
    }
    updateState(columns) {
        this.selectedColumns = columns;
        this.eventSvc.dispatchEvent({
            type: "columnHoverChanged"
        });
    }
};
// packages/ag-grid-community/src/columns/columnHover/columnHoverModule.ts
var $437b23f6a393c3bf$export$ca683b579c0df457 = {
    moduleName: "ColumnHover",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnHoverService
    ],
    apiFunctions: {
        isColumnHovered: $437b23f6a393c3bf$var$isColumnHovered
    }
};
// packages/ag-grid-community/src/misc/apiEvents/apiEventService.ts
var $437b23f6a393c3bf$var$ApiEventService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "apiEventSvc";
        this.syncListeners = /* @__PURE__ */ new Map();
        this.asyncListeners = /* @__PURE__ */ new Map();
        this.syncGlobalListeners = /* @__PURE__ */ new Set();
        this.globalListenerPairs = /* @__PURE__ */ new Map();
    }
    postConstruct() {
        this.wrapSvc = this.beans.frameworkOverrides.createGlobalEventListenerWrapper?.();
    }
    addEventListener(eventType, userListener) {
        const listener = this.wrapSvc?.wrap(eventType, userListener) ?? userListener;
        const async = !$437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventType);
        const listeners = async ? this.asyncListeners : this.syncListeners;
        if (!listeners.has(eventType)) listeners.set(eventType, /* @__PURE__ */ new Set());
        listeners.get(eventType).add(listener);
        this.eventSvc.addEventListener(eventType, listener, async);
    }
    removeEventListener(eventType, userListener) {
        const listener = this.wrapSvc?.unwrap(eventType, userListener) ?? userListener;
        const asyncListeners = this.asyncListeners.get(eventType);
        const hasAsync = !!asyncListeners?.delete(listener);
        if (!hasAsync) this.syncListeners.get(eventType)?.delete(listener);
        this.eventSvc.removeEventListener(eventType, listener, hasAsync);
    }
    addGlobalListener(userListener) {
        const listener = this.wrapSvc?.wrapGlobal(userListener) ?? userListener;
        const syncListener = (eventType, event)=>{
            if ($437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventType)) listener(eventType, event);
        };
        const asyncListener = (eventType, event)=>{
            if (!$437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventType)) listener(eventType, event);
        };
        this.globalListenerPairs.set(userListener, {
            syncListener: syncListener,
            asyncListener: asyncListener
        });
        const eventSvc = this.eventSvc;
        eventSvc.addGlobalListener(syncListener, false);
        eventSvc.addGlobalListener(asyncListener, true);
    }
    removeGlobalListener(userListener) {
        const { eventSvc: eventSvc, wrapSvc: wrapSvc, globalListenerPairs: globalListenerPairs } = this;
        const listener = wrapSvc?.unwrapGlobal(userListener) ?? userListener;
        const hasAsync = globalListenerPairs.has(listener);
        if (hasAsync) {
            const { syncListener: syncListener, asyncListener: asyncListener } = globalListenerPairs.get(listener);
            eventSvc.removeGlobalListener(syncListener, false);
            eventSvc.removeGlobalListener(asyncListener, true);
            globalListenerPairs.delete(userListener);
        } else {
            this.syncGlobalListeners.delete(listener);
            eventSvc.removeGlobalListener(listener, false);
        }
    }
    destroyEventListeners(map, async) {
        map.forEach((listeners, eventType)=>{
            listeners.forEach((listener)=>this.eventSvc.removeEventListener(eventType, listener, async));
            listeners.clear();
        });
        map.clear();
    }
    destroyGlobalListeners(set, async) {
        set.forEach((listener)=>this.eventSvc.removeGlobalListener(listener, async));
        set.clear();
    }
    destroy() {
        super.destroy();
        this.destroyEventListeners(this.syncListeners, false);
        this.destroyEventListeners(this.asyncListeners, true);
        this.destroyGlobalListeners(this.syncGlobalListeners, false);
        const { globalListenerPairs: globalListenerPairs, eventSvc: eventSvc } = this;
        globalListenerPairs.forEach(({ syncListener: syncListener, asyncListener: asyncListener })=>{
            eventSvc.removeGlobalListener(syncListener, false);
            eventSvc.removeGlobalListener(asyncListener, true);
        });
        globalListenerPairs.clear();
    }
};
// packages/ag-grid-community/src/misc/apiEvents/eventApi.ts
function $437b23f6a393c3bf$var$addEventListener(beans, eventType, listener) {
    beans.apiEventSvc?.addEventListener(eventType, listener);
}
function $437b23f6a393c3bf$var$removeEventListener(beans, eventType, listener) {
    beans.apiEventSvc?.removeEventListener(eventType, listener);
}
function $437b23f6a393c3bf$var$addGlobalListener(beans, listener) {
    beans.apiEventSvc?.addGlobalListener(listener);
}
function $437b23f6a393c3bf$var$removeGlobalListener(beans, listener) {
    beans.apiEventSvc?.removeGlobalListener(listener);
}
// packages/ag-grid-community/src/misc/apiEvents/apiEventModule.ts
var $437b23f6a393c3bf$export$d20c5df25778eac8 = {
    moduleName: "EventApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        addEventListener: $437b23f6a393c3bf$var$addEventListener,
        addGlobalListener: $437b23f6a393c3bf$var$addGlobalListener,
        removeEventListener: $437b23f6a393c3bf$var$removeEventListener,
        removeGlobalListener: $437b23f6a393c3bf$var$removeGlobalListener
    },
    beans: [
        $437b23f6a393c3bf$var$ApiEventService
    ]
};
// packages/ag-grid-community/src/misc/locale/localeModule.ts
var $437b23f6a393c3bf$export$77471a542fe056d = {
    moduleName: "Locale",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$export$f325e19d05d9c36d
    ]
};
// packages/ag-grid-community/src/rendering/row/rowAutoHeightService.ts
var $437b23f6a393c3bf$var$RowAutoHeightService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowAutoHeight";
        this.wasEverActive = false;
        this._debouncedCalculateRowHeights = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.calculateRowHeights.bind(this), 1);
    }
    /**
   * If row height has been active, request a refresh of the row heights.
   */ requestCheckAutoHeight() {
        if (!this.wasEverActive) return;
        this._debouncedCalculateRowHeights();
    }
    calculateRowHeights() {
        const { visibleCols: visibleCols, rowModel: rowModel, rowSpanSvc: rowSpanSvc, pinnedRowModel: pinnedRowModel } = this.beans;
        const displayedAutoHeightCols = visibleCols.autoHeightCols;
        let anyNodeChanged = false;
        const updateDisplayedRowHeights = (row)=>{
            const autoHeights = row.__autoHeights;
            let newRowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, row).height;
            for (const col of displayedAutoHeightCols){
                let cellHeight = autoHeights?.[col.getColId()];
                const spannedCell = rowSpanSvc?.getCellSpan(col, row);
                if (spannedCell) {
                    if (spannedCell.getLastNode() !== row) continue;
                    cellHeight = rowSpanSvc?.getCellSpan(col, row)?.getLastNodeAutoHeight();
                    if (!cellHeight) return;
                }
                if (cellHeight == null) {
                    if (this.colSpanSkipCell(col, row)) continue;
                    return;
                }
                newRowHeight = Math.max(cellHeight, newRowHeight);
            }
            if (newRowHeight !== row.rowHeight) {
                row.setRowHeight(newRowHeight);
                anyNodeChanged = true;
            }
        };
        pinnedRowModel?.forEachPinnedRow?.("top", updateDisplayedRowHeights);
        pinnedRowModel?.forEachPinnedRow?.("bottom", updateDisplayedRowHeights);
        rowModel.forEachDisplayedNode?.(updateDisplayedRowHeights);
        if (anyNodeChanged) rowModel.onRowHeightChanged?.();
    }
    /**
   * Set the cell height into the row node, and request a refresh of the row heights if there's been a change.
   * @param rowNode the node to set the auto height on
   * @param cellHeight the height to set, undefined if the cell has just been destroyed
   * @param column the column of the cell
   */ setRowAutoHeight(rowNode, cellHeight, column) {
        rowNode.__autoHeights ?? (rowNode.__autoHeights = {});
        if (cellHeight == void 0) {
            delete rowNode.__autoHeights[column.getId()];
            return;
        }
        const previousCellHeight = rowNode.__autoHeights[column.getId()];
        rowNode.__autoHeights[column.getId()] = cellHeight;
        if (previousCellHeight !== cellHeight) this.requestCheckAutoHeight();
    }
    /**
   * If using col span, then cells which have been spanned over do not need an auto height value
   * @param col the column of the cell
   * @param node the node of the cell
   * @returns whether the row needs auto height value for that column
   */ colSpanSkipCell(col, node) {
        const { colModel: colModel, colViewport: colViewport, visibleCols: visibleCols } = this.beans;
        if (!colModel.colSpanActive) return false;
        let activeColsForRow = [];
        switch(col.getPinned()){
            case "left":
                activeColsForRow = visibleCols.getLeftColsForRow(node);
                break;
            case "right":
                activeColsForRow = visibleCols.getRightColsForRow(node);
                break;
            case null:
                activeColsForRow = colViewport.getColsWithinViewport(node);
                break;
        }
        return !activeColsForRow.includes(col);
    }
    /**
   * If required, sets up observers to continuously measure changes in the cell height.
   * @param cellCtrl the cellCtrl of the cell
   * @param eCellWrapper the HTMLElement to track the height of
   * @param compBean the component bean to add the destroy/cleanup function to
   * @returns whether or not auto height has been set up on this cell
   */ setupCellAutoHeight(cellCtrl, eCellWrapper, compBean) {
        if (!cellCtrl.column.isAutoHeight() || !eCellWrapper) return false;
        this.wasEverActive = true;
        const eParentCell = eCellWrapper.parentElement;
        const { rowNode: rowNode, column: column } = cellCtrl;
        const beans = this.beans;
        const measureHeight = (timesCalled)=>{
            if (this.beans.editSvc?.isEditing(cellCtrl)) return;
            if (!cellCtrl.isAlive() || !compBean.isAlive()) return;
            const { paddingTop: paddingTop, paddingBottom: paddingBottom, borderBottomWidth: borderBottomWidth, borderTopWidth: borderTopWidth } = $437b23f6a393c3bf$var$_getElementSize(eParentCell);
            const extraHeight = paddingTop + paddingBottom + borderBottomWidth + borderTopWidth;
            const wrapperHeight = eCellWrapper.offsetHeight;
            const autoHeight = wrapperHeight + extraHeight;
            if (timesCalled < 5) {
                const doc = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
                const notYetInDom = !doc || !doc.contains(eCellWrapper);
                const possiblyNoContentYet = autoHeight == 0;
                if (notYetInDom || possiblyNoContentYet) {
                    window.setTimeout(()=>measureHeight(timesCalled + 1), 0);
                    return;
                }
            }
            this.setRowAutoHeight(rowNode, autoHeight, column);
        };
        const listener = ()=>measureHeight(0);
        listener();
        const destroyResizeObserver = $437b23f6a393c3bf$export$9aef8476630687be(beans, eCellWrapper, listener);
        compBean.addDestroyFunc(()=>{
            destroyResizeObserver();
            this.setRowAutoHeight(rowNode, void 0, column);
        });
        return true;
    }
    setAutoHeightActive(cols) {
        this.active = cols.list.some((col)=>col.isVisible() && col.isAutoHeight());
    }
    /**
   * Determines if the row auto height service has cells to grow.
   * @returns true if all of the rendered rows are at least as tall as their rendered cells.
   */ areRowsMeasured() {
        if (!this.active) return true;
        const rowCtrls = this.beans.rowRenderer.getAllRowCtrls();
        let renderedAutoHeightCols = null;
        for (const { rowNode: rowNode } of rowCtrls){
            if (!renderedAutoHeightCols || this.beans.colModel.colSpanActive) {
                const renderedCols = this.beans.colViewport.getColsWithinViewport(rowNode);
                renderedAutoHeightCols = renderedCols.filter((col)=>col.isAutoHeight());
            }
            if (renderedAutoHeightCols.length === 0) continue;
            if (!rowNode.__autoHeights) return false;
            for (const col of renderedAutoHeightCols){
                const cellHeight = rowNode.__autoHeights[col.getColId()];
                if (!cellHeight || rowNode.rowHeight < cellHeight) return false;
            }
        }
        return true;
    }
};
// packages/ag-grid-community/src/rendering/row/rowAutoHeightModule.ts
var $437b23f6a393c3bf$export$dd3171a7609a981f = {
    moduleName: "RowAutoHeight",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$RowAutoHeightService
    ]
};
// packages/ag-grid-community/src/allCommunityModule.ts
var $437b23f6a393c3bf$export$526323caf9d1af13 = {
    moduleName: "AllCommunity",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$4c74201d5a94c8e5,
        $437b23f6a393c3bf$export$f744275d8b795fc2,
        $437b23f6a393c3bf$export$ca8341149bdd39bc,
        $437b23f6a393c3bf$export$798770a8f68ba4e7,
        $437b23f6a393c3bf$export$5e6636bea954ad4e,
        $437b23f6a393c3bf$export$9bc83f811986c4f2,
        $437b23f6a393c3bf$export$d1dd3475f4d98a27,
        $437b23f6a393c3bf$export$b6d3a45586965934,
        $437b23f6a393c3bf$export$ccaa44b10c75f1d,
        $437b23f6a393c3bf$export$e1b6b5aa47694f20,
        $437b23f6a393c3bf$export$e1d2707568ed81f6,
        $437b23f6a393c3bf$export$2bb59c6ee8834731,
        $437b23f6a393c3bf$export$5ce3e57cec1fecc9,
        $437b23f6a393c3bf$export$aabcd4399b0469bb,
        $437b23f6a393c3bf$export$2a2721fe06c4c013,
        $437b23f6a393c3bf$export$c992812899d813d0,
        $437b23f6a393c3bf$export$7e8079ed742f8307,
        $437b23f6a393c3bf$export$fc403e59f6fc67b,
        $437b23f6a393c3bf$export$3402149dbbda9537,
        $437b23f6a393c3bf$export$a8c763073927f695,
        $437b23f6a393c3bf$export$a57c5ed18afb0c4,
        $437b23f6a393c3bf$export$5c4abee658e86c68,
        $437b23f6a393c3bf$export$12e9d7df2a270583,
        $437b23f6a393c3bf$export$351f260d7f887abc,
        $437b23f6a393c3bf$export$b67b27f72da743ce,
        $437b23f6a393c3bf$export$baf19ca56ec781d2,
        $437b23f6a393c3bf$export$49c914873cdbe391,
        $437b23f6a393c3bf$export$b6e84cdeabbb116a,
        $437b23f6a393c3bf$export$dae0b5c1ba15d66f,
        $437b23f6a393c3bf$export$3110fedd6be63d8e,
        $437b23f6a393c3bf$export$be75c2ed74fb2144,
        $437b23f6a393c3bf$export$ca683b579c0df457,
        $437b23f6a393c3bf$export$dbb09c7a8266fd30,
        $437b23f6a393c3bf$export$d20c5df25778eac8,
        $437b23f6a393c3bf$export$d7a9d7f5c41fb970,
        $437b23f6a393c3bf$export$98e8472b11750a07,
        $437b23f6a393c3bf$export$d0c662c133b8814e,
        $437b23f6a393c3bf$export$77471a542fe056d,
        $437b23f6a393c3bf$export$dd3171a7609a981f,
        $437b23f6a393c3bf$export$b9bac28848e60126,
        $437b23f6a393c3bf$export$15323dcce1401b05,
        $437b23f6a393c3bf$export$b7ca1fc11bfe19c3
    ]
};
// packages/ag-grid-community/src/testing/testIdUtils.ts
function $437b23f6a393c3bf$var$formatTestId(name, attributes = {}) {
    const params = Object.keys(attributes).map((k)=>{
        const v = attributes[k];
        return v != null ? `${k}=${v}` : null;
    }).filter(Boolean).join(";");
    return [
        name,
        params
    ].filter((s)=>s.length > 0).join(":");
}
var $437b23f6a393c3bf$export$11b44e0a72aa6bc3 = {
    grid (gridId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-grid-root", {
            gridId: gridId
        });
    },
    /** Headers */ headerGroupCell (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-group-cell", {
            colId: colId
        });
    },
    headerCell (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-cell", {
            colId: colId
        });
    },
    headerCheckbox (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-selection-checkbox", {
            colId: colId
        });
    },
    headerFilterButton (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-cell-filter-button", {
            colId: colId
        });
    },
    floatingFilterButton (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-floating-filter-button", {
            colId: colId
        });
    },
    headerCellMenuButton (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-cell-menu-button", {
            colId: colId
        });
    },
    headerResizeHandle (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-cell-resize", {
            colId: colId
        });
    },
    /** Column Filters */ filterInstancePickerDisplay (spec) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-picker-display`, spec.source === "filter-toolpanel" ? {
            label: spec.colLabel
        } : {
            colId: spec.colId
        });
    },
    numberFilterInstanceInput (spec) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-number-input`, spec.source === "filter-toolpanel" ? {
            label: spec.colLabel
        } : {
            colId: spec.colId
        });
    },
    textFilterInstanceInput (spec) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-text-input`, spec.source === "filter-toolpanel" ? {
            label: spec.colLabel
        } : {
            colId: spec.colId
        });
    },
    dateFilterInstanceInput (spec) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-date-input`, spec.source === "filter-toolpanel" ? {
            label: spec.colLabel
        } : {
            colId: spec.colId
        });
    },
    setFilterInstanceMiniFilterInput (spec) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-set-filter-mini-filter-input`, spec.source === "filter-toolpanel" ? {
            label: spec.colLabel
        } : {
            colId: spec.colId
        });
    },
    setFilterInstanceItem (spec, itemLabel) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-set-filter-item`, spec.source === "filter-toolpanel" ? {
            colLabel: spec.colLabel,
            itemLabel: itemLabel
        } : {
            colId: spec.colId,
            itemLabel: itemLabel
        });
    },
    setFilterApplyPanelButton (spec, buttonLabel) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-set-filter-apply-panel-button`, spec.source === "filter-toolpanel" ? {
            colLabel: spec.colLabel,
            buttonLabel: buttonLabel
        } : {
            colId: spec.colId,
            buttonLabel: buttonLabel
        });
    },
    filterConditionRadioButton (spec, buttonLabel) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-filter-condition-radio-button`, spec.source === "filter-toolpanel" ? {
            colLabel: spec.colLabel,
            buttonLabel: buttonLabel
        } : {
            colId: spec.colId,
            buttonLabel: buttonLabel
        });
    },
    /** Advanced Filter */ advancedFilterInput () {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-input");
    },
    advancedFilterButton (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-button", {
            label: label
        });
    },
    advancedFilterBuilderButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-builder-button");
    },
    advancedFilterPanelMaximiseButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-builder-panel-maximise");
    },
    advancedFilterPanelCloseButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-builder-panel-close");
    },
    advancedFilterPill (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-builder-pill", {
            label: label
        });
    },
    advancedFilterBuilderAddItemButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-builder-add-item-button");
    },
    /** Rows */ rowNode (rowId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-row", {
            ["row-id"]: rowId
        });
    },
    /** Cells */ cell (rowId, colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-cell", {
            ["row-id"]: rowId,
            colId: colId
        });
    },
    autoGroupCell (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.cell(rowId, $437b23f6a393c3bf$export$a7016588c430dba6);
    },
    checkbox (rowId, colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-selection-checkbox", {
            ["row-id"]: rowId,
            colId: colId
        });
    },
    selectionColumnCheckbox (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.checkbox(rowId, $437b23f6a393c3bf$export$dd05e5f089eb2421);
    },
    autoGroupColumnCheckbox (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.checkbox(rowId, $437b23f6a393c3bf$export$a7016588c430dba6);
    },
    dragHandle (rowId, colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-drag-handle", {
            ["row-id"]: rowId,
            colId: colId
        });
    },
    groupContracted (rowId, colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-group-contracted", {
            ["row-id"]: rowId,
            colId: colId
        });
    },
    groupExpanded (rowId, colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-group-expanded", {
            ["row-id"]: rowId,
            colId: colId
        });
    },
    autoGroupContracted (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.groupContracted(rowId, $437b23f6a393c3bf$export$a7016588c430dba6);
    },
    autoGroupExpanded (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.groupExpanded(rowId, $437b23f6a393c3bf$export$a7016588c430dba6);
    },
    rowNumber (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.cell(rowId, $437b23f6a393c3bf$export$f55c01dfb205b029);
    },
    /** Menu */ menu () {
        return $437b23f6a393c3bf$var$formatTestId("ag-menu");
    },
    menuOption (option) {
        return $437b23f6a393c3bf$var$formatTestId("ag-menu-option", {
            ["option"]: option
        });
    },
    /** SideBar */ sideBar () {
        return $437b23f6a393c3bf$var$formatTestId("ag-side-bar");
    },
    sideBarButton (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-side-button", {
            label: label
        });
    },
    /** Column Tool Panel */ columnToolPanel () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-panel");
    },
    pivotModeSelect () {
        return $437b23f6a393c3bf$var$formatTestId("ag-pivot-mode-select");
    },
    columnPanelSelectHeaderCheckbox () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-panel-select-header-checkbox");
    },
    columnPanelSelectHeaderFilter () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-panel-select-header-filter");
    },
    columnSelectListItemGroupClosedIcon (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-select-list-item-group-closed-icon", {
            label: label
        });
    },
    columnSelectListItemCheckbox (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-select-list-item-checkbox", {
            label: label
        });
    },
    columnSelectListItemDragHandle (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-select-list-item-drag-handle", {
            label: label
        });
    },
    columnDropCellDragHandle (source, area, label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-drop-cell-drag-handle", {
            source: source,
            area: area,
            label: label
        });
    },
    columnDropCellCancelButton (source, area, label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-drop-cell-cancel", {
            source: source,
            area: area,
            label: label
        });
    },
    columnDropArea (source, name) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-drop-area", {
            source: source,
            name: name
        });
    },
    /** Filter Tool Panel (New) */ filterToolPanel () {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-panel");
    },
    filterToolPanelAddFilterButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-panel-add-filter-button");
    },
    filterToolPanelFilterTypeSelector (colLabel) {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-panel-filter-type-selector", {
            colLabel: colLabel
        });
    },
    /** Filter Tool Panel (Old) */ filterToolPanelSearchInput () {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-toolpanel-search-input");
    },
    filterToolPanelGroup (title) {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-toolpanel-group", {
            title: title
        });
    },
    filterToolPanelGroupCollapsedIcon (title) {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-toolpanel-group-collapsed-icon", {
            title: title
        });
    },
    /** Status Bar */ statusBarTotalAndFilteredRowCount () {
        return $437b23f6a393c3bf$var$formatTestId("ag-status-bar-total-and-filtered-row-count");
    },
    statusBarTotalRowCount () {
        return $437b23f6a393c3bf$var$formatTestId("ag-status-bar-total-row-count");
    },
    statusBarFilteredRowCount () {
        return $437b23f6a393c3bf$var$formatTestId("ag-status-bar-filtered-row-count");
    },
    statusBarSelectedRowCount () {
        return $437b23f6a393c3bf$var$formatTestId("ag-status-bar-selected-row-count");
    },
    statusBarAggregations () {
        return $437b23f6a393c3bf$var$formatTestId("ag-status-bar-aggregations");
    },
    /** Pagination */ paginationPanelSizePickerDisplay (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-pagination-page-size-picker-field-display", {
            value: value
        });
    },
    paginationPanelFirstRowOnPage (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-row-summary-panel-first-row-on-page", {
            value: value
        });
    },
    paginationPanelLastRowOnPage (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-row-summary-panel-last-row-on-page", {
            value: value
        });
    },
    paginationPanelRecordCount (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-row-summary-panel-record-count", {
            value: value
        });
    },
    paginationSummaryPanelButton (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-page-summary-panel-btn", {
            label: label
        });
    },
    paginationSummaryPanelCurrentPage (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-page-summary-panel-current-page", {
            value: value
        });
    },
    paginationSummaryPanelTotalPage (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-page-summary-panel-total-page", {
            value: value
        });
    },
    /** Fill Handle */ fillHandle () {
        return $437b23f6a393c3bf$var$formatTestId("ag-fill-handle");
    },
    /** Column Chooser */ columnChooserCloseButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-close-button");
    },
    columnChooserSearchBarCheckbox () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-header-checkbox");
    },
    columnChooserSearchBarFilter () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-searchbar-filter");
    },
    columnChooserListItemGroupClosedIcon (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-list-item-group-closed-icon", {
            label: label
        });
    },
    columnChooserListItemCheckbox (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-list-item-checkbox", {
            label: label
        });
    },
    columnChooserListItemDragHandle (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-list-item-drag-handle", {
            label: label
        });
    },
    /** Overlay */ overlay () {
        return $437b23f6a393c3bf$var$formatTestId("ag-overlay");
    }
};
var $437b23f6a393c3bf$export$387ead18f69f83ca = (fn)=>{
    const locators = {};
    const keys = Object.keys($437b23f6a393c3bf$export$11b44e0a72aa6bc3);
    keys.forEach((k)=>{
        locators[k] = (...args)=>{
            return fn($437b23f6a393c3bf$export$11b44e0a72aa6bc3[k](...args));
        };
    });
    return locators;
};
// packages/ag-grid-community/src/testing/testIdService.ts
var $437b23f6a393c3bf$var$TEST_ID_ATTR = "data-testid";
function $437b23f6a393c3bf$var$setTestId(element, testId) {
    element?.setAttribute($437b23f6a393c3bf$var$TEST_ID_ATTR, testId);
}
function $437b23f6a393c3bf$var$setTestIdAttribute(attr) {
    $437b23f6a393c3bf$var$TEST_ID_ATTR = attr;
}
var $437b23f6a393c3bf$var$TestIdService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "testIdSvc";
    }
    postConstruct() {
        const setup = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>this.setupAllTestIds(), 0);
        this.addManagedEventListeners({
            firstDataRendered: setup,
            displayedRowsChanged: setup,
            displayedColumnsChanged: setup,
            displayedColumnsWidthChanged: setup,
            virtualColumnsChanged: setup,
            columnMenuVisibleChanged: setup,
            contextMenuVisibleChanged: setup,
            advancedFilterBuilderVisibleChanged: setup,
            fieldPickerValueSelected: setup,
            modelUpdated: setup,
            sideBarUpdated: setup,
            pinnedHeightChanged: setup,
            gridReady: setup,
            overlayExclusiveChanged: setup,
            rowGroupOpened: setup,
            scrollVisibilityChanged: setup,
            gridSizeChanged: setup,
            filterOpened: setup,
            filterChanged: setup,
            cellSelectionChanged: setup
        });
    }
    setupAllTestIds() {
        const root = $437b23f6a393c3bf$export$1911dd00c79744c0(this.beans);
        const gridId = $437b23f6a393c3bf$var$getGridId(this.beans);
        const gridWrapper = root.querySelector(`[grid-id="${gridId}"]`);
        $437b23f6a393c3bf$var$setTestId(gridWrapper, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.grid(gridId));
        root.querySelectorAll(".ag-header-group-cell").forEach((groupCell)=>{
            $437b23f6a393c3bf$var$setTestId(groupCell, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerGroupCell(groupCell.getAttribute("col-id")));
        });
        root.querySelectorAll(".ag-header-cell").forEach((cell)=>{
            const colId = cell.getAttribute("col-id");
            $437b23f6a393c3bf$var$setTestId(cell, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerCell(colId));
            $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-header-cell-filter-button"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerFilterButton(colId));
            $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-header-cell-menu-button"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerCellMenuButton(colId));
            $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-header-cell-resize"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerResizeHandle(colId));
            $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-checkbox input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerCheckbox(colId));
            $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-floating-filter-button button"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.floatingFilterButton(colId));
            this.setupFilterInstance(cell.querySelector(".ag-floating-filter-body"), {
                source: "floating-filter",
                colId: colId
            });
        });
        const filterMenu = root.querySelector(".ag-filter-menu");
        this.setupFilterInstance(filterMenu, {
            source: "column-filter"
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-advanced-filter input[type=text]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterInput());
        root.querySelectorAll(".ag-advanced-filter-buttons button").forEach((button)=>{
            $437b23f6a393c3bf$var$setTestId(button, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterButton(button.textContent));
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector("button.ag-advanced-filter-builder-button"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterBuilderButton());
        root.querySelectorAll('.ag-panel[aria-label="Advanced Filter"] .ag-panel-title-bar-button').forEach((button, i)=>{
            $437b23f6a393c3bf$var$setTestId(button, i === 0 ? $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterPanelMaximiseButton() : $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterPanelCloseButton());
        });
        root.querySelectorAll('.ag-panel[aria-lable="Advanced Filter"] .ag-advanced-filter-builder-pill').forEach((pill)=>{
            $437b23f6a393c3bf$var$setTestId(pill, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterPill(pill.querySelector(".ag-picker-field-display")?.textContent));
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector('.ag-panel[aria-label="Advanced Filter"] .ag-advanced-filter-builder-item-button'), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterBuilderAddItemButton());
        root.querySelectorAll(".ag-row").forEach((row)=>{
            const rowId = row.getAttribute("row-id");
            $437b23f6a393c3bf$var$setTestId(row, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.rowNode(rowId));
            row.querySelectorAll(".ag-cell").forEach((cell)=>{
                const colId = cell.getAttribute("col-id");
                $437b23f6a393c3bf$var$setTestId(cell, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.cell(rowId, colId));
                $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-selection-checkbox input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.checkbox(rowId, colId));
                $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-drag-handle"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.dragHandle(rowId, colId));
                $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-group-contracted"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.groupContracted(rowId, colId));
                $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-group-expanded"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.groupExpanded(rowId, colId));
            });
        });
        root.querySelectorAll(".ag-menu-list").forEach((menu)=>{
            $437b23f6a393c3bf$var$setTestId(menu, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.menu());
            menu.querySelectorAll(".ag-menu-option").forEach((option)=>{
                $437b23f6a393c3bf$var$setTestId(option, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.menuOption(option.querySelector(".ag-menu-option-text")?.textContent));
            });
        });
        root.querySelectorAll(".ag-side-bar").forEach((sideBar)=>{
            $437b23f6a393c3bf$var$setTestId(sideBar, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.sideBar());
            sideBar.querySelectorAll(".ag-side-button button").forEach((button)=>{
                $437b23f6a393c3bf$var$setTestId(button, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.sideBarButton(button.querySelector(".ag-side-button-label")?.textContent));
            });
            sideBar.querySelectorAll(".ag-column-panel").forEach((panel)=>{
                $437b23f6a393c3bf$var$setTestId(panel, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnToolPanel());
                $437b23f6a393c3bf$var$setTestId(panel.querySelector(".ag-pivot-mode-select input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.pivotModeSelect());
                $437b23f6a393c3bf$var$setTestId(panel.querySelector(".ag-column-select-header-checkbox input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnPanelSelectHeaderCheckbox());
                $437b23f6a393c3bf$var$setTestId(panel.querySelector(".ag-column-select-header-filter-wrapper input[type=text]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnPanelSelectHeaderFilter());
                panel.querySelectorAll(".ag-column-select-list").forEach((list)=>{
                    list.querySelectorAll(".ag-column-select-virtual-list-item").forEach((item)=>{
                        const label = item.getAttribute("aria-label");
                        $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-column-group-closed-icon"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnSelectListItemGroupClosedIcon(label));
                        $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-column-select-checkbox input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnSelectListItemCheckbox(label));
                        $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-drag-handle"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnSelectListItemDragHandle(label));
                    });
                });
                this.setupColumnDropArea(panel, "toolbar");
            });
            sideBar.querySelectorAll(".ag-filter-panel").forEach((panel)=>{
                $437b23f6a393c3bf$var$setTestId(panel, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanel());
                $437b23f6a393c3bf$var$setTestId(panel.querySelector("button.ag-filter-add-button"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanelAddFilterButton());
                panel.querySelectorAll(".ag-filter-card").forEach((filterCard)=>{
                    const colLabel = filterCard.querySelector(".ag-filter-card-title")?.textContent;
                    const typeSelector = filterCard.querySelector(".ag-filter-type-select");
                    $437b23f6a393c3bf$var$setTestId(typeSelector, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanelFilterTypeSelector(colLabel));
                    filterCard.querySelectorAll(".ag-filter").forEach((filter)=>this.setupFilterInstance(filter, {
                            source: "filter-toolpanel",
                            colLabel: colLabel
                        }));
                });
            });
            sideBar.querySelectorAll(".ag-filter-toolpanel").forEach((panel)=>{
                $437b23f6a393c3bf$var$setTestId(panel.querySelector(".ag-filter-toolpanel-search-input input[type=text]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanelSearchInput());
                panel.querySelectorAll(".ag-filter-toolpanel-group").forEach((group)=>{
                    const title = group.querySelector(".ag-filter-toolpanel-group-title")?.textContent;
                    $437b23f6a393c3bf$var$setTestId(group, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanelGroup(title));
                    $437b23f6a393c3bf$var$setTestId(group.querySelector(".ag-filter-toolpanel-group-title-bar-icon .ag-icon-tree-closed"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanelGroupCollapsedIcon(title));
                    const filterRoot = group.querySelector(".ag-filter-toolpanel-instance-filter");
                    if (filterRoot) this.setupFilterInstance(filterRoot, {
                        source: "filter-toolpanel",
                        colLabel: title
                    });
                });
            });
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-status-bar .ag-status-panel-total-and-filtered-row-count"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.statusBarTotalAndFilteredRowCount());
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-status-bar .ag-status-panel-total-row-count"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.statusBarTotalRowCount());
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-status-bar .ag-status-panel-filtered-row-count"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.statusBarFilteredRowCount());
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-status-bar .ag-status-panel-selected-row-count"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.statusBarSelectedRowCount());
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-status-bar .ag-status-panel-filtered-row-count"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.statusBarAggregations());
        root.querySelectorAll(".ag-paging-panel").forEach((pagingPanel)=>{
            $437b23f6a393c3bf$var$setTestId(pagingPanel.querySelector(".ag-paging-page-size .ag-picker-field-display"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationPanelSizePickerDisplay(pagingPanel.querySelector(".ag-paging-page-size .ag-picker-field-display")?.textContent));
            pagingPanel.querySelectorAll(".ag-paging-row-summary-panel-number").forEach((panelNumber)=>{
                const dataRef = panelNumber.getAttribute("data-ref");
                switch(dataRef){
                    case "lbFirstRowOnPage":
                        $437b23f6a393c3bf$var$setTestId(panelNumber, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationPanelFirstRowOnPage(panelNumber.textContent));
                        break;
                    case "lbLastRowOnPage":
                        $437b23f6a393c3bf$var$setTestId(panelNumber, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationPanelLastRowOnPage(panelNumber.textContent));
                        break;
                    case "lbRecordCount":
                        $437b23f6a393c3bf$var$setTestId(panelNumber, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationPanelRecordCount(panelNumber.textContent));
                        break;
                }
            });
            pagingPanel.querySelectorAll(".ag-paging-page-summary-panel .ag-button").forEach((pagingButton)=>{
                $437b23f6a393c3bf$var$setTestId(pagingButton, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationSummaryPanelButton(pagingButton.getAttribute("aria-label")?.toLowerCase()));
            });
            pagingPanel.querySelectorAll(".ag-paging-page-summary-panel .ag-paging-number").forEach((pagingNumber)=>{
                const dataRef = pagingNumber.getAttribute("data-ref");
                switch(dataRef){
                    case "lbCurrent":
                        $437b23f6a393c3bf$var$setTestId(pagingNumber, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationSummaryPanelCurrentPage(pagingNumber.textContent));
                        break;
                    case "lbTotal":
                        $437b23f6a393c3bf$var$setTestId(pagingNumber, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationSummaryPanelTotalPage(pagingNumber.textContent));
                        break;
                }
            });
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-fill-handle"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.fillHandle());
        root.querySelectorAll('.ag-panel[aria-label="Choose Columns"]').forEach((panel)=>{
            $437b23f6a393c3bf$var$setTestId(panel.querySelector(".ag-panel-title-bar-button-icon"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserCloseButton());
            $437b23f6a393c3bf$var$setTestId(panel.querySelector('.ag-column-select-header-checkbox input[type="checkbox"]'), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserSearchBarCheckbox());
            $437b23f6a393c3bf$var$setTestId(panel.querySelector('.ag-column-select-header-filter-wrapper input[type="text"]'), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserSearchBarFilter());
            panel.querySelectorAll(".ag-column-select-list").forEach((list)=>{
                list.querySelectorAll(".ag-column-select-virtual-list-item").forEach((item)=>{
                    const label = item.getAttribute("aria-label");
                    $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-column-group-closed-icon"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserListItemGroupClosedIcon(label));
                    $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-column-select-checkbox input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserListItemCheckbox(label));
                    $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-drag-handle"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserListItemDragHandle(label));
                });
            });
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-overlay-wrapper"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.overlay());
        this.setupColumnDropArea(root, "panel");
    }
    setupFilterInstance(filterRoot, spec) {
        if (!filterRoot) return;
        filterRoot.querySelectorAll(".ag-filter-select .ag-picker-field-display").forEach((fieldDisplay)=>{
            $437b23f6a393c3bf$var$setTestId(fieldDisplay, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterInstancePickerDisplay(spec));
        });
        const numberInput = filterRoot.querySelector('.ag-filter-body input[type="number"]');
        $437b23f6a393c3bf$var$setTestId(numberInput, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.numberFilterInstanceInput(spec));
        const textInput = filterRoot.querySelector('.ag-filter-body input[type="text"]');
        $437b23f6a393c3bf$var$setTestId(textInput, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.textFilterInstanceInput(spec));
        const dateInput = filterRoot.querySelector('.ag-filter-body input[type="date"]');
        $437b23f6a393c3bf$var$setTestId(dateInput, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.dateFilterInstanceInput(spec));
        const setMiniFilterInput = filterRoot.querySelector('.ag-mini-filter input[type="text"]');
        $437b23f6a393c3bf$var$setTestId(setMiniFilterInput, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.setFilterInstanceMiniFilterInput(spec));
        filterRoot.querySelectorAll(".ag-set-filter-list .ag-set-filter-item").forEach((item)=>{
            const label = item.querySelector(".ag-checkbox-label")?.textContent;
            const checkbox = item.querySelector('input[type="checkbox"]');
            $437b23f6a393c3bf$var$setTestId(checkbox, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.setFilterInstanceItem(spec, label));
        });
        filterRoot.querySelectorAll(".ag-filter-apply-panel button").forEach((button)=>{
            $437b23f6a393c3bf$var$setTestId(button, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.setFilterApplyPanelButton(spec, button.textContent));
        });
        filterRoot.querySelectorAll(".ag-filter-condition .ag-radio-button").forEach((radioButton)=>{
            const label = radioButton.querySelector(".ag-radio-button-label")?.textContent;
            $437b23f6a393c3bf$var$setTestId(radioButton.querySelector("input[type=radio]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterConditionRadioButton(spec, label));
        });
    }
    setupColumnDropArea(root, source) {
        root.querySelectorAll(".ag-column-drop").forEach((columnDrop)=>{
            const dropAreaName = columnDrop.querySelector(".ag-column-drop-list")?.getAttribute("aria-label");
            $437b23f6a393c3bf$var$setTestId(columnDrop.querySelector(".ag-column-drop-empty-message"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnDropArea(source, dropAreaName));
            columnDrop.querySelectorAll(".ag-column-drop-cell").forEach((columnDropCell)=>{
                const label = columnDropCell.querySelector(".ag-column-drop-cell-text")?.textContent;
                $437b23f6a393c3bf$var$setTestId(columnDropCell.querySelector(".ag-drag-handle"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnDropCellDragHandle(source, dropAreaName, label));
                $437b23f6a393c3bf$var$setTestId(columnDropCell.querySelector(".ag-column-drop-cell-button .ag-icon-cancel"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnDropCellCancelButton(source, dropAreaName, label));
            });
        });
    }
};
// packages/ag-grid-community/src/testing/testingModule.ts
var $437b23f6a393c3bf$var$TestingModule = {
    moduleName: "Testing",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$TestIdService
    ]
};
function $437b23f6a393c3bf$export$a2068793f28bf00e({ testIdAttribute: testIdAttribute } = {}) {
    if (testIdAttribute) $437b23f6a393c3bf$var$setTestIdAttribute(testIdAttribute);
    $437b23f6a393c3bf$export$dc053975cc7f6c11.registerModules([
        $437b23f6a393c3bf$var$TestingModule
    ]);
}

});


parcelRegister("cjWtv", function(module, exports) {

$parcel$export(module.exports, "Axis", () => $b50843af9b9b0ea7$export$d06866a9fb0606da);

var $7op73 = parcelRequire("7op73");

var $f1q41 = parcelRequire("f1q41");
function $b50843af9b9b0ea7$var$GroupedCategoryAxis(options, depth = 1) {
    const visibleDepth = {
        tick: {
            stroke: "#6B7280",
            width: 1
        },
        label: {
            fontSize: 11
        }
    };
    let depthOptions = [
        visibleDepth
    ];
    if (depth === 2) depthOptions = [
        {
            tick: {
                width: 0
            }
        },
        {
            ...visibleDepth,
            label: {
                ...visibleDepth.label,
                spacing: 16
            }
        }
    ];
    const defaultOptions = {
        type: "grouped-category",
        position: "bottom",
        depthOptions: depthOptions,
        line: {
            width: 1,
            stroke: "#9CA3AF"
        },
        gridLine: {
            enabled: false
        },
        paddingInner: 0.3,
        label: {
            rotation: 0
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge(defaultOptions, options);
}
function $b50843af9b9b0ea7$var$BasicCategoryAxis(options) {
    const defaultOptions = {
        type: "category",
        position: "bottom",
        line: {
            width: 1,
            stroke: "#9CA3AF"
        },
        gridLine: {
            enabled: false
        },
        label: {
            avoidCollisions: true,
            rotation: 45
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge(defaultOptions, options);
}
function $b50843af9b9b0ea7$var$MoneyAxis(options) {
    const defaultOptions = {
        type: "number",
        position: "right",
        label: {
            formatter: (params)=>"$" + (0, $7op73.abbreviate)(`${params.value}`)
        },
        crosshair: {
            enabled: false
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge(defaultOptions, options);
}
function $b50843af9b9b0ea7$var$PercentageAxis(options) {
    const defaultOptions = {
        type: "number",
        position: "left",
        label: {
            formatter: (params)=>`${(params.value * 100).toFixed(0)}%`
        },
        crosshair: {
            enabled: false
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge(defaultOptions, options);
}
const $b50843af9b9b0ea7$export$d06866a9fb0606da = {
    GroupedCategory: $b50843af9b9b0ea7$var$GroupedCategoryAxis,
    Money: $b50843af9b9b0ea7$var$MoneyAxis,
    Percentage: $b50843af9b9b0ea7$var$PercentageAxis,
    Category: $b50843af9b9b0ea7$var$BasicCategoryAxis
};

});

parcelRegister("5dpz5", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("f0DMB"),
    $Gr8vk("gtici")
]).then(()=>parcelRequire("imvrC"));

});

parcelRegister("6nQVO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("55reY"),
    $Gr8vk("f0DMB"),
    $Gr8vk("7XeEb")
]).then(()=>parcelRequire("jIXhA"));

});

parcelRegister("hmQAE", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("55reY"),
    $Gr8vk("f0DMB"),
    $Gr8vk("ilTbi")
]).then(()=>parcelRequire("cRRbH"));

});

parcelRegister("g3x7b", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3VrYo").then(()=>parcelRequire("3FLmT"));

});

parcelRegister("02Jdy", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5MYxu").then(()=>parcelRequire("77UN0"));

});

parcelRegister("kkjLa", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gyUdc").then(()=>parcelRequire("8R6zo"));

});


var $ayMG0 = parcelRequire("ayMG0");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $1u0KT.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $1u0KT.hydrateRoot;



var $ayMG0 = parcelRequire("ayMG0");

var $f19YE = parcelRequire("f19YE");

var $aphAM = parcelRequire("aphAM");
parcelRequire("tL0U5");
var $eX6Sv = parcelRequire("eX6Sv");
parcelRequire("18L7n");
var $jg6kN = parcelRequire("jg6kN");
var $3oOMC = parcelRequire("3oOMC");
parcelRequire("h33ag");
var $gXZ39 = parcelRequire("gXZ39");
var $gMxRY = parcelRequire("gMxRY");
var $au8D6 = parcelRequire("au8D6");
var $bBFEN = parcelRequire("bBFEN");
var $1bRue = parcelRequire("1bRue");
var $GnB8W = parcelRequire("GnB8W");
var $7EKKo = parcelRequire("7EKKo");
var $7vE2c = parcelRequire("7vE2c");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("ct56T");
var $edg5W = parcelRequire("edg5W");

var $aphAM = parcelRequire("aphAM");
parcelRequire("18L7n");
var $5Ttm9 = parcelRequire("5Ttm9");
parcelRequire("gCemA");
var $7gcOJ = parcelRequire("7gcOJ");
var $fp4OM = parcelRequire("fp4OM");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");
parcelRequire("18L7n");
var $5Ttm9 = parcelRequire("5Ttm9");
parcelRequire("feEs1");
var $2xY7I = parcelRequire("2xY7I");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("18L7n");
var $4oMrS = parcelRequire("4oMrS");

var $aphAM = parcelRequire("aphAM");
parcelRequire("jLMBL");
var $7JXNE = parcelRequire("7JXNE");
parcelRequire("anJVh");
var $7gcOJ = parcelRequire("7gcOJ");

var $ayMG0 = parcelRequire("ayMG0");

var $5mL0X = parcelRequire("5mL0X");

var $aphAM = parcelRequire("aphAM");

var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $5mL0X = parcelRequire("5mL0X");
var $fRJCp = parcelRequire("fRJCp");

var $r2uF6 = parcelRequire("r2uF6");
const $f09089f5cc75b534$export$1e9ee88f033039e9 = 0.2;
const $f09089f5cc75b534$export$3de4a6ce7a47c453 = 0.1;
const $f09089f5cc75b534$export$da1e9475c942285b = {
    duration: $f09089f5cc75b534$export$1e9ee88f033039e9 * 2,
    ease: "easeInOut",
    type: "tween"
};



var $r2uF6 = parcelRequire("r2uF6");
var $30c17e6838b1ddb3$export$7cc95808d41d73a3;
(function(SidebarState) {
    SidebarState["CLOSED"] = "closed";
    SidebarState["LEFT_SIDEBAR"] = "left_sidebar";
    SidebarState["RIGHT_DRAWER"] = "right_drawer";
})($30c17e6838b1ddb3$export$7cc95808d41d73a3 || ($30c17e6838b1ddb3$export$7cc95808d41d73a3 = {}));
var $30c17e6838b1ddb3$export$fcbbb141329b865d;
(function(RightDrawerSize) {
    RightDrawerSize["DEFAULT"] = "default";
    RightDrawerSize["EXPANDED"] = "expanded";
})($30c17e6838b1ddb3$export$fcbbb141329b865d || ($30c17e6838b1ddb3$export$fcbbb141329b865d = {}));
const $30c17e6838b1ddb3$export$cc9cb8ca37bd505b = (0, $r2uF6.atom)(null);
const $30c17e6838b1ddb3$export$4085ed3565a3eb10 = (0, $r2uF6.atom)(true);
const $30c17e6838b1ddb3$export$91978c9add0e5354 = (0, $r2uF6.atom)("left_sidebar");
const $30c17e6838b1ddb3$export$77306c2481da7c28 = (0, $r2uF6.atom)("default");
const $30c17e6838b1ddb3$export$dbcbe4e4de01bc0b = (0, $r2uF6.atom)(false);
const $30c17e6838b1ddb3$var$previousSidebarStateAtom = (0, $r2uF6.atom)("left_sidebar");
const $30c17e6838b1ddb3$export$1a43581c5b8980a9 = (0, $r2uF6.atom)((get)=>get($30c17e6838b1ddb3$export$91978c9add0e5354) === "left_sidebar", (get, set, value)=>{
    const currentState = get($30c17e6838b1ddb3$export$91978c9add0e5354);
    if (value) set($30c17e6838b1ddb3$export$91978c9add0e5354, "left_sidebar");
    else if (currentState === "left_sidebar") set($30c17e6838b1ddb3$export$91978c9add0e5354, "closed");
});
const $30c17e6838b1ddb3$export$7f94ead4211bc7ae = (0, $r2uF6.atom)((get)=>get($30c17e6838b1ddb3$export$91978c9add0e5354) === "right_drawer", (get, set, value)=>{
    const currentState = get($30c17e6838b1ddb3$export$91978c9add0e5354);
    if (value) {
        if (currentState !== "right_drawer") set($30c17e6838b1ddb3$var$previousSidebarStateAtom, currentState);
        set($30c17e6838b1ddb3$export$91978c9add0e5354, "right_drawer");
    } else if (currentState === "right_drawer") set($30c17e6838b1ddb3$export$91978c9add0e5354, get($30c17e6838b1ddb3$var$previousSidebarStateAtom));
});



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $dA5Dq = parcelRequire("dA5Dq");

var $9QePP = parcelRequire("9QePP");
parcelRequire("18L7n");
var $hUCih = parcelRequire("hUCih");

var $fRJCp = parcelRequire("fRJCp");


var $r2uF6 = parcelRequire("r2uF6");

const $520efa1e266b7dbe$var$DefaultLogo = /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
    href: "/",
    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hUCih.Icon).Hum, {
        width: "35",
        height: "32"
    })
});
const $520efa1e266b7dbe$export$b0135bf246f2ef7f = ({ className: className })=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M6 14L6 2M2 10.8L2 5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H10.8C11.9201 2 12.4802 2 12.908 2.21799C13.2843 2.40973 13.5903 2.71569 13.782 3.09202C14 3.51984 14 4.07989 14 5.2V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.07989 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
function $520efa1e266b7dbe$export$d9b273488cd8ce6f({ selectedValue: selectedValue, options: options, onValueChange: onValueChange, className: className }) {
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const menuRef = (0, $acw62.useRef)(null);
    const buttonRef = (0, $acw62.useRef)(null);
    const [sidebarOpen, setSidebarOpen] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$1a43581c5b8980a9));
    const toggleMenu = ()=>{
        setIsOpen(!isOpen);
    };
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) setIsOpen(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fRJCp.motion).div, {
        initial: {
            height: 72,
            display: sidebarOpen ? "flex" : "none"
        },
        animate: {
            display: sidebarOpen ? "flex" : "none"
        },
        exit: {
            width: 0
        },
        transition: {
            duration: (0, $f09089f5cc75b534$export$1e9ee88f033039e9),
            ease: "easeInOut",
            delay: sidebarOpen ? (0, $f09089f5cc75b534$export$1e9ee88f033039e9) : 0,
            display: {
                duration: (0, $f09089f5cc75b534$export$1e9ee88f033039e9),
                ease: "easeInOut",
                delay: 0
            }
        },
        className: (0, $9QePP.default)("sm:border-default border border-transparent sm:px-6 sm:py-5 sm:shadow-search-bar", "items-center justify-between gap-3 rounded-lg", !sidebarOpen && "pointer-events-none"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fRJCp.motion).div, {
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: sidebarOpen ? 1 : 0
                },
                exit: {
                    opacity: 0
                },
                transition: {
                    duration: (0, $f09089f5cc75b534$export$1e9ee88f033039e9),
                    ease: "easeInOut",
                    delay: sidebarOpen ? (0, $f09089f5cc75b534$export$1e9ee88f033039e9) : 0
                },
                className: (0, $9QePP.default)("flex items-center gap-3", !sidebarOpen && "pointer-events-none"),
                children: [
                    $520efa1e266b7dbe$var$DefaultLogo,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                ref: buttonRef,
                                onClick: toggleMenu,
                                className: (0, $9QePP.default)("flex cursor-pointer items-center gap-2", "sm:heading-m heading-s subdued transition-colors hover:text-gray-300", className),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: selectedValue || options[0]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dA5Dq.default), {
                                        className: (0, $9QePP.default)("size-3 transition-transform duration-200", isOpen && "rotate-180")
                                    })
                                ]
                            }),
                            isOpen && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                ref: menuRef,
                                className: (0, $9QePP.default)("bg-slate-800", "rounded-lg shadow-400", "custom-scrollbar max-h-[400px] overflow-auto p-2", "absolute left-0 top-full z-50 mt-1", "min-w-[160px]", "flex flex-col gap-1"),
                                children: options.map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>onValueChange?.(option),
                                        className: (0, $9QePP.default)("flex h-[36px] w-full items-center gap-2 rounded-md px-2 py-1.5", "menu-item hover:bg-slate-600", selectedValue === option && "bg-gray-100 font-medium dark:bg-slate-700"),
                                        role: "menuitem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "body-s",
                                            children: option
                                        })
                                    }, option))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                className: "hidden shrink-0 sm:block",
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: sidebarOpen ? 1 : 0
                },
                exit: {
                    opacity: 0
                },
                transition: {
                    duration: (0, $f09089f5cc75b534$export$1e9ee88f033039e9),
                    ease: "easeInOut",
                    delay: sidebarOpen ? (0, $f09089f5cc75b534$export$1e9ee88f033039e9) : 0
                },
                children: sidebarOpen && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    type: "button",
                    onClick: ()=>setSidebarOpen(!sidebarOpen),
                    "aria-label": "Toggle sidebar",
                    className: "collapse-menu-btn cursor-pointer focus:outline-none",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($520efa1e266b7dbe$export$b0135bf246f2ef7f, {
                        className: "size-4 cursor-pointer"
                    })
                })
            })
        ]
    });
}



var $r2uF6 = parcelRequire("r2uF6");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $faa88de4f0afd1d0$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $faa88de4f0afd1d0$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $faa88de4f0afd1d0$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $faa88de4f0afd1d0$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $faa88de4f0afd1d0$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $faa88de4f0afd1d0$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $faa88de4f0afd1d0$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $faa88de4f0afd1d0$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $faa88de4f0afd1d0$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $faa88de4f0afd1d0$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $faa88de4f0afd1d0$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $faa88de4f0afd1d0$var$root = $faa88de4f0afd1d0$var$freeGlobal || $faa88de4f0afd1d0$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $faa88de4f0afd1d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $faa88de4f0afd1d0$var$objectToString = $faa88de4f0afd1d0$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $faa88de4f0afd1d0$var$nativeMax = Math.max, $faa88de4f0afd1d0$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $faa88de4f0afd1d0$var$now = function() {
    return $faa88de4f0afd1d0$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $faa88de4f0afd1d0$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($faa88de4f0afd1d0$var$FUNC_ERROR_TEXT);
    wait = $faa88de4f0afd1d0$var$toNumber(wait) || 0;
    if ($faa88de4f0afd1d0$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $faa88de4f0afd1d0$var$nativeMax($faa88de4f0afd1d0$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $faa88de4f0afd1d0$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $faa88de4f0afd1d0$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($faa88de4f0afd1d0$var$now());
    }
    function debounced() {
        var time = $faa88de4f0afd1d0$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $faa88de4f0afd1d0$var$isSymbol(value) {
    return typeof value == "symbol" || $faa88de4f0afd1d0$var$isObjectLike(value) && $faa88de4f0afd1d0$var$objectToString.call(value) == $faa88de4f0afd1d0$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $faa88de4f0afd1d0$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($faa88de4f0afd1d0$var$isSymbol(value)) return $faa88de4f0afd1d0$var$NAN;
    if ($faa88de4f0afd1d0$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $faa88de4f0afd1d0$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($faa88de4f0afd1d0$var$reTrim, "");
    var isBinary = $faa88de4f0afd1d0$var$reIsBinary.test(value);
    return isBinary || $faa88de4f0afd1d0$var$reIsOctal.test(value) ? $faa88de4f0afd1d0$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $faa88de4f0afd1d0$var$reIsBadHex.test(value) ? $faa88de4f0afd1d0$var$NAN : +value;
}
$faa88de4f0afd1d0$exports = $faa88de4f0afd1d0$var$debounce;


// src/useBoolean/useBoolean.ts
function $48948c44af5d8a00$export$c32275ecbd12948f(defaultValue = false) {
    if (typeof defaultValue !== "boolean") throw new Error("defaultValue must be `true` or `false`");
    const [value, setValue] = (0, $acw62.useState)(defaultValue);
    const setTrue = (0, $acw62.useCallback)(()=>{
        setValue(true);
    }, []);
    const setFalse = (0, $acw62.useCallback)(()=>{
        setValue(false);
    }, []);
    const toggle = (0, $acw62.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return {
        value: value,
        setValue: setValue,
        setTrue: setTrue,
        setFalse: setFalse,
        toggle: toggle
    };
}
var $48948c44af5d8a00$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// src/useEventListener/useEventListener.ts
function $48948c44af5d8a00$export$7080b3e976bc91ab(eventName, handler, element, options) {
    const savedHandler = (0, $acw62.useRef)(handler);
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $acw62.useEffect)(()=>{
        const targetElement = (element == null ? void 0 : element.current) ?? window;
        if (!(targetElement && targetElement.addEventListener)) return;
        const listener = (event)=>{
            savedHandler.current(event);
        };
        targetElement.addEventListener(eventName, listener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
}
// src/useClickAnyWhere/useClickAnyWhere.ts
function $48948c44af5d8a00$export$5139c081cbc6c8bb(handler) {
    $48948c44af5d8a00$export$7080b3e976bc91ab("click", (event)=>{
        handler(event);
    });
}
function $48948c44af5d8a00$export$b2199c37e85de4a7() {
    const [copiedText, setCopiedText] = (0, $acw62.useState)(null);
    const copy = (0, $acw62.useCallback)(async (text)=>{
        if (!(navigator == null ? void 0 : navigator.clipboard)) {
            console.warn("Clipboard not supported");
            return false;
        }
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        } catch (error) {
            console.warn("Copy failed", error);
            setCopiedText(null);
            return false;
        }
    }, []);
    return [
        copiedText,
        copy
    ];
}
function $48948c44af5d8a00$export$70c4067197c60e2d(initialValue) {
    const [count, setCount] = (0, $acw62.useState)(initialValue ?? 0);
    const increment = (0, $acw62.useCallback)(()=>{
        setCount((x)=>x + 1);
    }, []);
    const decrement = (0, $acw62.useCallback)(()=>{
        setCount((x)=>x - 1);
    }, []);
    const reset = (0, $acw62.useCallback)(()=>{
        setCount(initialValue ?? 0);
    }, [
        initialValue
    ]);
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset,
        setCount: setCount
    };
}
function $48948c44af5d8a00$export$f4b266cd2aae9cb1(callback, delay) {
    const savedCallback = (0, $acw62.useRef)(callback);
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $acw62.useEffect)(()=>{
        if (delay === null) return;
        const id = setInterval(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearInterval(id);
        };
    }, [
        delay
    ]);
}
// src/useCountdown/useCountdown.ts
function $48948c44af5d8a00$export$8103f7eb37e19f7b({ countStart: countStart, countStop: countStop = 0, intervalMs: intervalMs = 1e3, isIncrement: isIncrement = false }) {
    const { count: count, increment: increment, decrement: decrement, reset: resetCounter } = $48948c44af5d8a00$export$70c4067197c60e2d(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown } = $48948c44af5d8a00$export$c32275ecbd12948f(false);
    const resetCountdown = (0, $acw62.useCallback)(()=>{
        stopCountdown();
        resetCounter();
    }, [
        stopCountdown,
        resetCounter
    ]);
    const countdownCallback = (0, $acw62.useCallback)(()=>{
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) increment();
        else decrement();
    }, [
        count,
        countStop,
        decrement,
        increment,
        isIncrement,
        stopCountdown
    ]);
    $48948c44af5d8a00$export$f4b266cd2aae9cb1(countdownCallback, isCountdownRunning ? intervalMs : null);
    return [
        count,
        {
            startCountdown: startCountdown,
            stopCountdown: stopCountdown,
            resetCountdown: resetCountdown
        }
    ];
}
function $48948c44af5d8a00$export$ee5b5d04074a389e(fn) {
    const ref = (0, $acw62.useRef)(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    return (0, $acw62.useCallback)((...args)=>{
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.call(ref, ...args);
    }, [
        ref
    ]);
}
// src/useLocalStorage/useLocalStorage.ts
var $48948c44af5d8a00$var$IS_SERVER = typeof window === "undefined";
function $48948c44af5d8a00$export$86e2cef2561044ac(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $acw62.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $acw62.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $acw62.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($48948c44af5d8a00$var$IS_SERVER) return initialValueToUse;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $48948c44af5d8a00$export$ee5b5d04074a389e((value)=>{
        if ($48948c44af5d8a00$var$IS_SERVER) console.warn(`Tried setting localStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.localStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("local-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting localStorage key \u201C${key}\u201D:`, error);
        }
    });
    const removeValue = $48948c44af5d8a00$export$ee5b5d04074a389e(()=>{
        if ($48948c44af5d8a00$var$IS_SERVER) console.warn(`Tried removing localStorage key \u201C${key}\u201D even though environment is not a client`);
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        window.localStorage.removeItem(key);
        setStoredValue(defaultValue);
        window.dispatchEvent(new StorageEvent("local-storage", {
            key: key
        }));
    });
    (0, $acw62.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $acw62.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $48948c44af5d8a00$export$7080b3e976bc91ab("storage", handleStorageChange);
    $48948c44af5d8a00$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return [
        storedValue,
        setValue,
        removeValue
    ];
}
var $48948c44af5d8a00$var$IS_SERVER2 = typeof window === "undefined";
function $48948c44af5d8a00$export$32d5543ab307c01(query, { defaultValue: defaultValue = false, initializeWithValue: initializeWithValue = true } = {}) {
    const getMatches = (query2)=>{
        if ($48948c44af5d8a00$var$IS_SERVER2) return defaultValue;
        return window.matchMedia(query2).matches;
    };
    const [matches, setMatches] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return getMatches(query);
        return defaultValue;
    });
    function handleChange() {
        setMatches(getMatches(query));
    }
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) matchMedia.addListener(handleChange);
        else matchMedia.addEventListener("change", handleChange);
        return ()=>{
            if (matchMedia.removeListener) matchMedia.removeListener(handleChange);
            else matchMedia.removeEventListener("change", handleChange);
        };
    }, [
        query
    ]);
    return matches;
}
// src/useDarkMode/useDarkMode.ts
var $48948c44af5d8a00$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
var $48948c44af5d8a00$var$LOCAL_STORAGE_KEY = "usehooks-ts-dark-mode";
function $48948c44af5d8a00$export$4673cbff94e146e2(options = {}) {
    const { defaultValue: defaultValue, localStorageKey: localStorageKey = $48948c44af5d8a00$var$LOCAL_STORAGE_KEY, initializeWithValue: initializeWithValue = true } = options;
    const isDarkOS = $48948c44af5d8a00$export$32d5543ab307c01($48948c44af5d8a00$var$COLOR_SCHEME_QUERY, {
        initializeWithValue: initializeWithValue,
        defaultValue: defaultValue
    });
    const [isDarkMode, setDarkMode] = $48948c44af5d8a00$export$86e2cef2561044ac(localStorageKey, defaultValue ?? isDarkOS ?? false, {
        initializeWithValue: initializeWithValue
    });
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        if (isDarkOS !== isDarkMode) setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    return {
        isDarkMode: isDarkMode,
        toggle: ()=>{
            setDarkMode((prev)=>!prev);
        },
        enable: ()=>{
            setDarkMode(true);
        },
        disable: ()=>{
            setDarkMode(false);
        },
        set: (value)=>{
            setDarkMode(value);
        }
    };
}
function $48948c44af5d8a00$export$89e33b3d84d8c331(func) {
    const funcRef = (0, $acw62.useRef)(func);
    funcRef.current = func;
    (0, $acw62.useEffect)(()=>()=>{
            funcRef.current();
        }, []);
}
// src/useDebounceCallback/useDebounceCallback.ts
function $48948c44af5d8a00$export$40ae01be0011c1e6(func, delay = 500, options) {
    const debouncedFunc = (0, $acw62.useRef)();
    $48948c44af5d8a00$export$89e33b3d84d8c331(()=>{
        if (debouncedFunc.current) debouncedFunc.current.cancel();
    });
    const debounced = (0, $acw62.useMemo)(()=>{
        const debouncedFuncInstance = (0, (/*@__PURE__*/$parcel$interopDefault($faa88de4f0afd1d0$exports)))(func, delay, options);
        const wrappedFunc = (...args)=>{
            return debouncedFuncInstance(...args);
        };
        wrappedFunc.cancel = ()=>{
            debouncedFuncInstance.cancel();
        };
        wrappedFunc.isPending = ()=>{
            return !!debouncedFunc.current;
        };
        wrappedFunc.flush = ()=>{
            return debouncedFuncInstance.flush();
        };
        return wrappedFunc;
    }, [
        func,
        delay,
        options
    ]);
    (0, $acw62.useEffect)(()=>{
        debouncedFunc.current = (0, (/*@__PURE__*/$parcel$interopDefault($faa88de4f0afd1d0$exports)))(func, delay, options);
    }, [
        func,
        delay,
        options
    ]);
    return debounced;
}
function $48948c44af5d8a00$export$52bae15610182273(initialValue, delay, options) {
    const eq = (options == null ? void 0 : options.equalityFn) ?? ((left, right)=>left === right);
    const unwrappedInitialValue = initialValue instanceof Function ? initialValue() : initialValue;
    const [debouncedValue, setDebouncedValue] = (0, $acw62.useState)(unwrappedInitialValue);
    const previousValueRef = (0, $acw62.useRef)(unwrappedInitialValue);
    const updateDebouncedValue = $48948c44af5d8a00$export$40ae01be0011c1e6(setDebouncedValue, delay, options);
    if (!eq(previousValueRef.current, unwrappedInitialValue)) {
        updateDebouncedValue(unwrappedInitialValue);
        previousValueRef.current = unwrappedInitialValue;
    }
    return [
        debouncedValue,
        updateDebouncedValue
    ];
}
function $48948c44af5d8a00$export$4b208edda918084f(title, options = {}) {
    const { preserveTitleOnUnmount: preserveTitleOnUnmount = true } = options;
    const defaultTitle = (0, $acw62.useRef)(null);
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        defaultTitle.current = window.document.title;
    }, []);
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        window.document.title = title;
    }, [
        title
    ]);
    $48948c44af5d8a00$export$89e33b3d84d8c331(()=>{
        if (!preserveTitleOnUnmount && defaultTitle.current) window.document.title = defaultTitle.current;
    });
}
function $48948c44af5d8a00$export$ae780daf29e6d456(elementRef) {
    const [value, setValue] = (0, $acw62.useState)(false);
    const handleMouseEnter = ()=>{
        setValue(true);
    };
    const handleMouseLeave = ()=>{
        setValue(false);
    };
    $48948c44af5d8a00$export$7080b3e976bc91ab("mouseenter", handleMouseEnter, elementRef);
    $48948c44af5d8a00$export$7080b3e976bc91ab("mouseleave", handleMouseLeave, elementRef);
    return value;
}
function $48948c44af5d8a00$export$a7395f9832c00176({ threshold: threshold = 0, root: root = null, rootMargin: rootMargin = "0%", freezeOnceVisible: freezeOnceVisible = false, initialIsIntersecting: initialIsIntersecting = false, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = (0, $acw62.useState)(null);
    const [state, setState] = (0, $acw62.useState)(()=>({
            isIntersecting: initialIsIntersecting,
            entry: void 0
        }));
    const callbackRef = (0, $acw62.useRef)();
    callbackRef.current = onChange;
    const frozen = ((_a = state.entry) == null ? void 0 : _a.isIntersecting) && freezeOnceVisible;
    (0, $acw62.useEffect)(()=>{
        if (!ref) return;
        if (!("IntersectionObserver" in window)) return;
        if (frozen) return;
        let unobserve;
        const observer = new IntersectionObserver((entries)=>{
            const thresholds = Array.isArray(observer.thresholds) ? observer.thresholds : [
                observer.thresholds
            ];
            entries.forEach((entry)=>{
                const isIntersecting = entry.isIntersecting && thresholds.some((threshold2)=>entry.intersectionRatio >= threshold2);
                setState({
                    isIntersecting: isIntersecting,
                    entry: entry
                });
                if (callbackRef.current) callbackRef.current(isIntersecting, entry);
                if (isIntersecting && freezeOnceVisible && unobserve) {
                    unobserve();
                    unobserve = void 0;
                }
            });
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(threshold),
        root,
        rootMargin,
        frozen,
        freezeOnceVisible
    ]);
    const prevRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        var _a2;
        if (!ref && ((_a2 = state.entry) == null ? void 0 : _a2.target) && !freezeOnceVisible && !frozen && prevRef.current !== state.entry.target) {
            prevRef.current = state.entry.target;
            setState({
                isIntersecting: initialIsIntersecting,
                entry: void 0
            });
        }
    }, [
        ref,
        state.entry,
        freezeOnceVisible,
        frozen,
        initialIsIntersecting
    ]);
    const result = [
        setRef,
        !!state.isIntersecting,
        state.entry
    ];
    result.ref = result[0];
    result.isIntersecting = result[1];
    result.entry = result[2];
    return result;
}
function $48948c44af5d8a00$export$7c8949515a63d2a1() {
    const [isClient, setClient] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setClient(true);
    }, []);
    return isClient;
}
function $48948c44af5d8a00$export$80c2a3957bcb42ea() {
    const isMounted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $acw62.useCallback)(()=>isMounted.current, []);
}
function $48948c44af5d8a00$export$86f8f9f08863e403(initialState = /* @__PURE__ */ new Map()) {
    const [map, setMap] = (0, $acw62.useState)(new Map(initialState));
    const actions = {
        set: (0, $acw62.useCallback)((key, value)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0, $acw62.useCallback)((entries)=>{
            setMap(()=>new Map(entries));
        }, []),
        remove: (0, $acw62.useCallback)((key)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0, $acw62.useCallback)(()=>{
            setMap(()=>/* @__PURE__ */ new Map());
        }, [])
    };
    return [
        map,
        actions
    ];
}
// src/useOnClickOutside/useOnClickOutside.ts
function $48948c44af5d8a00$export$9afc64c180e82dc4(ref, handler, eventType = "mousedown", eventListenerOptions = {}) {
    $48948c44af5d8a00$export$7080b3e976bc91ab(eventType, (event)=>{
        const target = event.target;
        if (!target || !target.isConnected) return;
        const isOutside = Array.isArray(ref) ? ref.filter((r)=>Boolean(r.current)).every((r)=>r.current && !r.current.contains(target)) : ref.current && !ref.current.contains(target);
        if (isOutside) handler(event);
    }, void 0, eventListenerOptions);
}
var $48948c44af5d8a00$var$IS_SERVER3 = typeof window === "undefined";
function $48948c44af5d8a00$export$558ff211cfc1c1fe(key, options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($48948c44af5d8a00$var$IS_SERVER3) initializeWithValue = false;
    const deserializer = (0, $acw62.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return null;
        }
        return parsed;
    }, [
        options
    ]);
    const readValue = (0, $acw62.useCallback)(()=>{
        if ($48948c44af5d8a00$var$IS_SERVER3) return null;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : null;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return null;
        }
    }, [
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return readValue();
        return void 0;
    });
    (0, $acw62.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $acw62.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $48948c44af5d8a00$export$7080b3e976bc91ab("storage", handleStorageChange);
    $48948c44af5d8a00$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return storedValue;
}
var $48948c44af5d8a00$var$initialSize = {
    width: void 0,
    height: void 0
};
function $48948c44af5d8a00$export$683480f191c0e3ea(options) {
    const { ref: ref, box: box = "content-box" } = options;
    const [{ width: width, height: height }, setSize] = (0, $acw62.useState)($48948c44af5d8a00$var$initialSize);
    const isMounted = $48948c44af5d8a00$export$80c2a3957bcb42ea();
    const previousSize = (0, $acw62.useRef)({
        ...$48948c44af5d8a00$var$initialSize
    });
    const onResize = (0, $acw62.useRef)(void 0);
    onResize.current = options.onResize;
    (0, $acw62.useEffect)(()=>{
        if (!ref.current) return;
        if (typeof window === "undefined" || !("ResizeObserver" in window)) return;
        const observer = new ResizeObserver(([entry])=>{
            const boxProp = box === "border-box" ? "borderBoxSize" : box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
            const newWidth = $48948c44af5d8a00$var$extractSize(entry, boxProp, "inlineSize");
            const newHeight = $48948c44af5d8a00$var$extractSize(entry, boxProp, "blockSize");
            const hasChanged = previousSize.current.width !== newWidth || previousSize.current.height !== newHeight;
            if (hasChanged) {
                const newSize = {
                    width: newWidth,
                    height: newHeight
                };
                previousSize.current.width = newWidth;
                previousSize.current.height = newHeight;
                if (onResize.current) onResize.current(newSize);
                else if (isMounted()) setSize(newSize);
            }
        });
        observer.observe(ref.current, {
            box: box
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        box,
        ref,
        isMounted
    ]);
    return {
        width: width,
        height: height
    };
}
function $48948c44af5d8a00$var$extractSize(entry, box, sizeType) {
    if (!entry[box]) {
        if (box === "contentBoxSize") return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
        return void 0;
    }
    return Array.isArray(entry[box]) ? entry[box][0][sizeType] : // @ts-ignore Support Firefox's non-standard behavior
    entry[box][sizeType];
}
var $48948c44af5d8a00$var$IS_SERVER4 = typeof window === "undefined";
function $48948c44af5d8a00$export$654d3fb7a8fef387(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($48948c44af5d8a00$var$IS_SERVER4) initializeWithValue = false;
    const readScreen = ()=>{
        if ($48948c44af5d8a00$var$IS_SERVER4) return void 0;
        return window.screen;
    };
    const [screen, setScreen] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return readScreen();
        return void 0;
    });
    const debouncedSetScreen = $48948c44af5d8a00$export$40ae01be0011c1e6(setScreen, options.debounceDelay);
    function handleSize() {
        const newScreen = readScreen();
        const setSize = options.debounceDelay ? debouncedSetScreen : setScreen;
        if (newScreen) {
            const { width: width, height: height, availHeight: availHeight, availWidth: availWidth, colorDepth: colorDepth, orientation: orientation, pixelDepth: pixelDepth } = newScreen;
            setSize({
                width: width,
                height: height,
                availHeight: availHeight,
                availWidth: availWidth,
                colorDepth: colorDepth,
                orientation: orientation,
                pixelDepth: pixelDepth
            });
        }
    }
    $48948c44af5d8a00$export$7080b3e976bc91ab("resize", handleSize);
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return screen;
}
var $48948c44af5d8a00$var$cachedScriptStatuses = /* @__PURE__ */ new Map();
function $48948c44af5d8a00$var$getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node == null ? void 0 : node.getAttribute("data-status");
    return {
        node: node,
        status: status
    };
}
function $48948c44af5d8a00$export$1d3955b0b5cace9c(src, options) {
    const [status, setStatus] = (0, $acw62.useState)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return "idle";
        if (typeof window === "undefined") return "loading";
        return $48948c44af5d8a00$var$cachedScriptStatuses.get(src) ?? "loading";
    });
    (0, $acw62.useEffect)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return;
        const cachedScriptStatus = $48948c44af5d8a00$var$cachedScriptStatuses.get(src);
        if (cachedScriptStatus === "ready" || cachedScriptStatus === "error") {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = $48948c44af5d8a00$var$getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement("script");
            scriptNode.src = src;
            scriptNode.async = true;
            if (options == null ? void 0 : options.id) scriptNode.id = options.id;
            scriptNode.setAttribute("data-status", "loading");
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event)=>{
                const scriptStatus = event.type === "load" ? "ready" : "error";
                scriptNode == null || scriptNode.setAttribute("data-status", scriptStatus);
            };
            scriptNode.addEventListener("load", setAttributeFromEvent);
            scriptNode.addEventListener("error", setAttributeFromEvent);
        } else setStatus(script.status ?? cachedScriptStatus ?? "loading");
        const setStateFromEvent = (event)=>{
            const newStatus = event.type === "load" ? "ready" : "error";
            setStatus(newStatus);
            $48948c44af5d8a00$var$cachedScriptStatuses.set(src, newStatus);
        };
        scriptNode.addEventListener("load", setStateFromEvent);
        scriptNode.addEventListener("error", setStateFromEvent);
        return ()=>{
            if (scriptNode) {
                scriptNode.removeEventListener("load", setStateFromEvent);
                scriptNode.removeEventListener("error", setStateFromEvent);
            }
            if (scriptNode && (options == null ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
                $48948c44af5d8a00$var$cachedScriptStatuses.delete(src);
            }
        };
    }, [
        src,
        options == null ? void 0 : options.shouldPreventLoad,
        options == null ? void 0 : options.removeOnUnmount,
        options == null ? void 0 : options.id
    ]);
    return status;
}
var $48948c44af5d8a00$var$IS_SERVER5 = typeof window === "undefined";
function $48948c44af5d8a00$export$e47ba1b900da5d3b(options = {}) {
    const { autoLock: autoLock = true, lockTarget: lockTarget, widthReflow: widthReflow = true } = options;
    const [isLocked, setIsLocked] = (0, $acw62.useState)(false);
    const target = (0, $acw62.useRef)(null);
    const originalStyle = (0, $acw62.useRef)(null);
    const lock = ()=>{
        if (target.current) {
            const { overflow: overflow, paddingRight: paddingRight } = target.current.style;
            originalStyle.current = {
                overflow: overflow,
                paddingRight: paddingRight
            };
            if (widthReflow) {
                const offsetWidth = target.current === document.body ? window.innerWidth : target.current.offsetWidth;
                const currentPaddingRight = parseInt(window.getComputedStyle(target.current).paddingRight, 10) || 0;
                const scrollbarWidth = offsetWidth - target.current.scrollWidth;
                target.current.style.paddingRight = `${scrollbarWidth + currentPaddingRight}px`;
            }
            target.current.style.overflow = "hidden";
            setIsLocked(true);
        }
    };
    const unlock = ()=>{
        if (target.current && originalStyle.current) {
            target.current.style.overflow = originalStyle.current.overflow;
            if (widthReflow) target.current.style.paddingRight = originalStyle.current.paddingRight;
        }
        setIsLocked(false);
    };
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        if ($48948c44af5d8a00$var$IS_SERVER5) return;
        if (lockTarget) target.current = typeof lockTarget === "string" ? document.querySelector(lockTarget) : lockTarget;
        if (!target.current) target.current = document.body;
        if (autoLock) lock();
        return ()=>{
            unlock();
        };
    }, [
        autoLock,
        lockTarget,
        widthReflow
    ]);
    return {
        isLocked: isLocked,
        lock: lock,
        unlock: unlock
    };
}
var $48948c44af5d8a00$var$IS_SERVER6 = typeof window === "undefined";
function $48948c44af5d8a00$export$864b6828bd07eda6(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $acw62.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $acw62.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $acw62.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($48948c44af5d8a00$var$IS_SERVER6) return initialValueToUse;
        try {
            const raw = window.sessionStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading sessionStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $48948c44af5d8a00$export$ee5b5d04074a389e((value)=>{
        if ($48948c44af5d8a00$var$IS_SERVER6) console.warn(`Tried setting sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.sessionStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("session-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting sessionStorage key \u201C${key}\u201D:`, error);
        }
    });
    const removeValue = $48948c44af5d8a00$export$ee5b5d04074a389e(()=>{
        if ($48948c44af5d8a00$var$IS_SERVER6) console.warn(`Tried removing sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        window.sessionStorage.removeItem(key);
        setStoredValue(defaultValue);
        window.dispatchEvent(new StorageEvent("session-storage", {
            key: key
        }));
    });
    (0, $acw62.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $acw62.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $48948c44af5d8a00$export$7080b3e976bc91ab("storage", handleStorageChange);
    $48948c44af5d8a00$export$7080b3e976bc91ab("session-storage", handleStorageChange);
    return [
        storedValue,
        setValue,
        removeValue
    ];
}
function $48948c44af5d8a00$export$7896576cb7635832(maxStep) {
    const [currentStep, setCurrentStep] = (0, $acw62.useState)(1);
    const canGoToNextStep = currentStep + 1 <= maxStep;
    const canGoToPrevStep = currentStep - 1 > 0;
    const setStep = (0, $acw62.useCallback)((step)=>{
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error("Step not valid");
    }, [
        maxStep,
        currentStep
    ]);
    const goToNextStep = (0, $acw62.useCallback)(()=>{
        if (canGoToNextStep) setCurrentStep((step)=>step + 1);
    }, [
        canGoToNextStep
    ]);
    const goToPrevStep = (0, $acw62.useCallback)(()=>{
        if (canGoToPrevStep) setCurrentStep((step)=>step - 1);
    }, [
        canGoToPrevStep
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep: goToNextStep,
            goToPrevStep: goToPrevStep,
            canGoToNextStep: canGoToNextStep,
            canGoToPrevStep: canGoToPrevStep,
            setStep: setStep,
            reset: reset
        }
    ];
}
// src/useTernaryDarkMode/useTernaryDarkMode.ts
var $48948c44af5d8a00$var$COLOR_SCHEME_QUERY2 = "(prefers-color-scheme: dark)";
var $48948c44af5d8a00$var$LOCAL_STORAGE_KEY2 = "usehooks-ts-ternary-dark-mode";
function $48948c44af5d8a00$export$ec561688e440eda6({ defaultValue: defaultValue = "system", localStorageKey: localStorageKey = $48948c44af5d8a00$var$LOCAL_STORAGE_KEY2, initializeWithValue: initializeWithValue = true } = {}) {
    const isDarkOS = $48948c44af5d8a00$export$32d5543ab307c01($48948c44af5d8a00$var$COLOR_SCHEME_QUERY2, {
        initializeWithValue: initializeWithValue
    });
    const [mode, setMode] = $48948c44af5d8a00$export$86e2cef2561044ac(localStorageKey, defaultValue, {
        initializeWithValue: initializeWithValue
    });
    const isDarkMode = mode === "dark" || mode === "system" && isDarkOS;
    const toggleTernaryDarkMode = ()=>{
        const modes = [
            "light",
            "system",
            "dark"
        ];
        setMode((prevMode)=>{
            const nextIndex = (modes.indexOf(prevMode) + 1) % modes.length;
            return modes[nextIndex];
        });
    };
    return {
        isDarkMode: isDarkMode,
        ternaryDarkMode: mode,
        setTernaryDarkMode: setMode,
        toggleTernaryDarkMode: toggleTernaryDarkMode
    };
}
function $48948c44af5d8a00$export$d8e6abf214c9ec0f(callback, delay) {
    const savedCallback = (0, $acw62.useRef)(callback);
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setTimeout(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearTimeout(id);
        };
    }, [
        delay
    ]);
}
function $48948c44af5d8a00$export$cbe85ee05b554577(defaultValue) {
    const [value, setValue] = (0, $acw62.useState)(!!defaultValue);
    const toggle = (0, $acw62.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return [
        value,
        toggle,
        setValue
    ];
}
var $48948c44af5d8a00$var$IS_SERVER7 = typeof window === "undefined";
function $48948c44af5d8a00$export$42c02f33970a2afa(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($48948c44af5d8a00$var$IS_SERVER7) initializeWithValue = false;
    const [windowSize, setWindowSize] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        return {
            width: void 0,
            height: void 0
        };
    });
    const debouncedSetWindowSize = $48948c44af5d8a00$export$40ae01be0011c1e6(setWindowSize, options.debounceDelay);
    function handleSize() {
        const setSize = options.debounceDelay ? debouncedSetWindowSize : setWindowSize;
        setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }
    $48948c44af5d8a00$export$7080b3e976bc91ab("resize", handleSize);
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return windowSize;
}


const $0f2dbfb231b2e001$export$e16d65bed5c03472 = (0, $r2uF6.atom)({
    width: window.innerWidth,
    height: window.innerHeight
});
function $0f2dbfb231b2e001$export$74639c356da413e0() {
    const newWindowSize = (0, $48948c44af5d8a00$export$42c02f33970a2afa)({
        debounceDelay: 200
    });
    const setWindowSize = (0, $r2uF6.useSetAtom)($0f2dbfb231b2e001$export$e16d65bed5c03472);
    (0, $acw62.useEffect)(()=>{
        setWindowSize({
            width: newWindowSize.width,
            height: newWindowSize.height
        });
    }, [
        newWindowSize
    ]);
}
function $0f2dbfb231b2e001$export$42c02f33970a2afa() {
    const [windowSize] = (0, $r2uF6.useAtom)($0f2dbfb231b2e001$export$e16d65bed5c03472);
    return windowSize;
}


function $edf67564a97cb65a$export$1ba59dacbcbf90fe({ parentSections: parentSections, testId: testId, className: className }) {
    (0, $0f2dbfb231b2e001$export$74639c356da413e0)();
    const OPEN_WIDTH = 364;
    const CLOSED_WIDTH = 40;
    const [sidebarOpen, setSidebarOpen] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$1a43581c5b8980a9));
    const [parentSection, setParentSection] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$cc9cb8ca37bd505b));
    const [showParentHeader] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$4085ed3565a3eb10));
    const hasCloseSidebarHeight = !showParentHeader || !sidebarOpen;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5mL0X.LayoutGroup), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                initial: false,
                animate: {
                    width: sidebarOpen ? OPEN_WIDTH : CLOSED_WIDTH
                },
                transition: (0, $f09089f5cc75b534$export$da1e9475c942285b),
                className: "shrink-0"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fRJCp.motion).div, {
                initial: false,
                animate: {
                    width: sidebarOpen ? OPEN_WIDTH : CLOSED_WIDTH
                },
                transition: (0, $f09089f5cc75b534$export$da1e9475c942285b),
                className: (0, $9QePP.default)("hide-scrollbar overflow-y-scrol h-[calc(100vh-36px)]", "flex flex-col", "shrink-0 gap-4", "fixed inset-y-5 left-4 z-[60]"),
                children: [
                    parentSections && showParentHeader && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $520efa1e266b7dbe$export$d9b273488cd8ce6f), {
                        options: parentSections,
                        selectedValue: parentSection,
                        onValueChange: (value)=>setParentSection(value)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fRJCp.motion).aside, {
                        className: (0, $9QePP.default)("border-default flex flex-col rounded-lg border bg-slate-800 px-3 py-5", "shadow-search-bar", hasCloseSidebarHeight ? "h-[calc(100vh-36px)]" : "h-[calc(100vh-155px)]", className),
                        "data-testid": testId,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex flex-col items-center",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                                    className: "shrink-0",
                                    layout: true,
                                    initial: {
                                        opacity: 0,
                                        height: 0,
                                        paddingTop: 0
                                    },
                                    animate: {
                                        opacity: sidebarOpen ? 0 : 1,
                                        height: sidebarOpen ? 0 : 20,
                                        paddingTop: sidebarOpen ? 0 : 8
                                    },
                                    exit: {
                                        opacity: 0,
                                        height: 0,
                                        paddingTop: 0
                                    },
                                    transition: {
                                        duration: (0, $f09089f5cc75b534$export$3de4a6ce7a47c453),
                                        ease: "easeInOut",
                                        delay: sidebarOpen ? 0 : (0, $f09089f5cc75b534$export$1e9ee88f033039e9),
                                        opacity: {
                                            duration: 0,
                                            ease: "easeInOut",
                                            delay: sidebarOpen ? 0 : (0, $f09089f5cc75b534$export$1e9ee88f033039e9)
                                        },
                                        paddingTop: {
                                            duration: 0,
                                            ease: "easeInOut",
                                            delay: (0, $f09089f5cc75b534$export$1e9ee88f033039e9)
                                        }
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: (e)=>{
                                            setSidebarOpen(!sidebarOpen);
                                            e.currentTarget.blur();
                                        },
                                        "aria-label": "Toggle sidebar",
                                        className: (0, $9QePP.default)("collapse-menu-btn cursor-pointer focus:outline-none"),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $520efa1e266b7dbe$export$b0135bf246f2ef7f), {
                                            className: "size-4 cursor-pointer"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                                id: "sidebar-header",
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: sidebarOpen ? 1 : 0
                                },
                                exit: {
                                    opacity: 0
                                },
                                transition: {
                                    duration: (0, $f09089f5cc75b534$export$1e9ee88f033039e9),
                                    ease: "easeInOut",
                                    delay: sidebarOpen ? (0, $f09089f5cc75b534$export$1e9ee88f033039e9) : 0
                                },
                                className: (0, $9QePP.default)("flex flex-col", "min-h-0 gap-5", !sidebarOpen && "pointer-events-none")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                                id: "sidebar-content",
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: sidebarOpen ? 1 : 0
                                },
                                exit: {
                                    opacity: 0
                                },
                                transition: {
                                    duration: (0, $f09089f5cc75b534$export$1e9ee88f033039e9),
                                    ease: "easeInOut",
                                    delay: sidebarOpen ? (0, $f09089f5cc75b534$export$1e9ee88f033039e9) : 0
                                },
                                className: (0, $9QePP.default)("flex flex-col", "min-h-0 flex-1 gap-5", !sidebarOpen && "pointer-events-none")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $edf67564a97cb65a$export$2e2bcd8739ae039 = $edf67564a97cb65a$export$1ba59dacbcbf90fe;



var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $47600cea13312b3c$var$Bars3CenterLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 6.75h16.5M3.75 12H12m-8.25 5.25h16.5"
    }));
}
const $47600cea13312b3c$var$ForwardRef = $acw62.forwardRef($47600cea13312b3c$var$Bars3CenterLeftIcon);
var $47600cea13312b3c$export$2e2bcd8739ae039 = $47600cea13312b3c$var$ForwardRef;



var $9QePP = parcelRequire("9QePP");

var $75mQk = parcelRequire("75mQk");
const $dc6cbec3a25f3e04$export$8b963b556e800487 = ({ onMenuClick: onMenuClick })=>{
    const [isScrolled, setIsScrolled] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const handleScroll = ()=>{
            const scrollTop = window.scrollY;
            setIsScrolled(scrollTop > 20);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>window.removeEventListener("scroll", handleScroll);
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("fixed inset-x-0 top-0 z-50", "block lg:hidden", "bg-slate-800 text-white", "transition-all duration-300 ease-in-out"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("p-6", "flex items-center justify-between", "relative"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75mQk.default), {
                            className: "size-[32px]",
                            width: "32",
                            height: "32"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: onMenuClick,
                        className: "menu-item",
                        "aria-label": "Open menu",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47600cea13312b3c$export$2e2bcd8739ae039), {
                            className: "size-8"
                        })
                    })
                ]
            }),
            isScrolled && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("absolute inset-x-0 -bottom-8 h-12", "bg-gradient-to-b from-slate-800 from-30% via-slate-800/50 via-50% to-slate-800/5 to-100%", "pointer-events-none")
            })
        ]
    });
};



var $2hw4u = parcelRequire("2hw4u");
var $fRJCp = parcelRequire("fRJCp");

var $9QePP = parcelRequire("9QePP");

var $cVodR = parcelRequire("cVodR");


var $r2uF6 = parcelRequire("r2uF6");

const $423db289f5b121f2$export$e72363736d421dcd = ({ parentSections: parentSections })=>{
    const [sidebarOpen, setSidebarOpen] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$1a43581c5b8980a9));
    const [parentSection, setParentSection] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$cc9cb8ca37bd505b));
    const [showParentHeader] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$4085ed3565a3eb10));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dc6cbec3a25f3e04$export$8b963b556e800487), {
                onMenuClick: ()=>setSidebarOpen(true)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2hw4u.AnimatePresence), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fRJCp.motion).div, {
                    initial: {
                        x: sidebarOpen ? 0 : "-100%"
                    },
                    animate: {
                        x: sidebarOpen ? 0 : "-100%"
                    },
                    exit: {
                        x: sidebarOpen ? 0 : "-100%"
                    },
                    transition: {
                        type: "spring",
                        damping: 30,
                        stiffness: 300,
                        duration: 0.3
                    },
                    className: (0, $9QePP.default)("fixed inset-0 z-50", "flex flex-col bg-slate-800 text-white", "lg:hidden"),
                    children: [
                        parentSections && showParentHeader && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: (0, $9QePP.default)("p-6", "flex items-center justify-between"),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex items-start gap-1",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $520efa1e266b7dbe$export$d9b273488cd8ce6f), {
                                        options: parentSections || [],
                                        selectedValue: parentSection,
                                        onValueChange: (value)=>setParentSection(value)
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>setSidebarOpen(false),
                                    className: "menu-item rounded-lg p-1 transition-colors",
                                    "aria-label": "Close menu",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVodR.default), {
                                        className: "size-6"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: (0, $9QePP.default)("p-6", "flex flex-1 flex-col", "overflow-hidden"),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    id: "mobile-sidebar-header"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    id: "mobile-sidebar-content",
                                    className: "flex min-h-0 flex-1 flex-col"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $2hw4u = parcelRequire("2hw4u");
var $fRJCp = parcelRequire("fRJCp");

var $r2uF6 = parcelRequire("r2uF6");


const $cbdd9e200d939287$var$RIGHT_DRAWER_WIDTH = {
    [(0, $30c17e6838b1ddb3$export$fcbbb141329b865d).DEFAULT]: 386,
    [(0, $30c17e6838b1ddb3$export$fcbbb141329b865d).EXPANDED]: 700
};
const $cbdd9e200d939287$export$84d58c19c21f637f = ()=>{
    const [rightDrawerOpen] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae));
    const [rightDrawerSize] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$77306c2481da7c28));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2hw4u.AnimatePresence), {
        mode: "wait",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
            initial: false,
            animate: {
                opacity: rightDrawerOpen ? 1 : 0,
                width: rightDrawerOpen ? $cbdd9e200d939287$var$RIGHT_DRAWER_WIDTH[rightDrawerSize] : 0
            },
            exit: {
                opacity: rightDrawerOpen ? 1 : 0,
                width: rightDrawerOpen ? $cbdd9e200d939287$var$RIGHT_DRAWER_WIDTH[rightDrawerSize] : 0
            },
            transition: (0, $f09089f5cc75b534$export$da1e9475c942285b),
            className: (0, $9QePP.default)("shrink-0"),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).aside, {
                initial: false,
                animate: {
                    // paddingRight: rightDrawerOpen ? 32 : 0,
                    // paddingLeft: rightDrawerOpen ? 32 : 0,
                    // paddingTop: rightDrawerOpen ? 32 : 0,
                    // paddingBottom: rightDrawerOpen ? 32 : 0,
                    width: rightDrawerOpen ? $cbdd9e200d939287$var$RIGHT_DRAWER_WIDTH[rightDrawerSize] : 0
                },
                exit: {
                    width: rightDrawerOpen ? $cbdd9e200d939287$var$RIGHT_DRAWER_WIDTH[rightDrawerSize] : 0
                },
                transition: (0, $f09089f5cc75b534$export$da1e9475c942285b),
                className: (0, $9QePP.default)("flex flex-col rounded-lg bg-slate-800", "shadow-search-bar", "z-[60] h-[calc(100vh-36px)] shrink-0", "fixed inset-y-5 right-6", rightDrawerOpen && "border-default border"),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                    id: "right-drawer-content",
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: rightDrawerOpen ? 1 : 0
                    },
                    exit: {
                        opacity: 0
                    },
                    transition: {
                        duration: rightDrawerOpen ? (0, $f09089f5cc75b534$export$1e9ee88f033039e9) : (0, $f09089f5cc75b534$export$1e9ee88f033039e9) * 0.5,
                        ease: "easeInOut",
                        delay: rightDrawerOpen ? (0, $f09089f5cc75b534$export$1e9ee88f033039e9) * 1.5 : 0
                    },
                    className: (0, $9QePP.default)("min-h-0 flex-1 flex-col gap-5 px-6 pb-4", "hide-scrollbar relative flex overflow-y-auto", !rightDrawerOpen && "pointer-events-none")
                })
            })
        })
    });
};




var $r2uF6 = parcelRequire("r2uF6");

var $ayMG0 = parcelRequire("ayMG0");

var $2hw4u = parcelRequire("2hw4u");
var $fRJCp = parcelRequire("fRJCp");

var $9QePP = parcelRequire("9QePP");

var $cXDYR = parcelRequire("cXDYR");

var $r2uF6 = parcelRequire("r2uF6");

const $61ff2c9a6425271b$export$7cca49d91399c60 = ()=>{
    const [mobileRightDrawerOpen, setMobileRightDrawerOpen] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$dbcbe4e4de01bc0b));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2hw4u.AnimatePresence), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fRJCp.motion).div, {
            initial: {
                x: "100%"
            },
            animate: {
                x: mobileRightDrawerOpen ? 0 : "100%"
            },
            exit: {
                x: "100%"
            },
            transition: {
                type: "spring",
                damping: 30,
                stiffness: 300,
                duration: 0.3
            },
            className: (0, $9QePP.default)("fixed inset-0 z-50", "flex flex-col bg-slate-800 text-white", "lg:hidden"),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: (0, $9QePP.default)("p-6", "flex items-center justify-between"),
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setMobileRightDrawerOpen(false),
                        className: (0, $9QePP.default)("menu-item ui-element subdued text-sm", "mb-4 flex cursor-pointer items-center gap-1"),
                        children: [
                            "Close",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cXDYR.default), {
                                className: "size-3",
                                color: "#E5E7EB"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: (0, $9QePP.default)("p-6", "flex flex-1 flex-col", "overflow-hidden"),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        id: "mobile-right-drawer-content",
                        className: (0, $9QePP.default)("min-h-0 flex-1 flex-col gap-5", "hide-scrollbar flex overflow-y-auto")
                    })
                })
            ]
        })
    });
};


function $80c92d026b832583$export$5d146e06dd3b3225() {
    const [rightDrawerOpen] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5mL0X.LayoutGroup), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, $9QePP.default)("min-h-screen w-full px-6 pb-4 pt-5", "flex", rightDrawerOpen ? "justify-between" : "justify-start"),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lg:hidden",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $423db289f5b121f2$export$e72363736d421dcd), {
                        parentSections: [
                            "Companies",
                            "Deals",
                            "Credit Boxes"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lg:hidden",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $61ff2c9a6425271b$export$7cca49d91399c60), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "hidden lg:block",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $edf67564a97cb65a$export$2e2bcd8739ae039), {
                        parentSections: [
                            "Companies",
                            "Deals",
                            "Credit Boxes"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: (0, $9QePP.default)("flex flex-1 items-center justify-center"),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Outlet), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "hidden lg:block",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbdd9e200d939287$export$84d58c19c21f637f), {})
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $5mL0X = parcelRequire("5mL0X");

var $aphAM = parcelRequire("aphAM");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
function $63c42b32dd564eae$export$32d5543ab307c01(query) {
    const [matches, setMatches] = (0, $acw62.useState)(()=>{
        if (typeof window !== "undefined") return window.matchMedia(query).matches;
        return false;
    });
    (0, $acw62.useEffect)(()=>{
        const mediaQuery = window.matchMedia(query);
        const handler = (event)=>setMatches(event.matches);
        mediaQuery.addEventListener("change", handler);
        return ()=>mediaQuery.removeEventListener("change", handler);
    }, [
        query
    ]);
    return matches;
}



var $1u0KT = parcelRequire("1u0KT");
function $6d137961520e2401$export$26c4ec9456bef7c4({ children: children }) {
    const isMobile = (0, $63c42b32dd564eae$export$32d5543ab307c01)("(max-width: 1023px)");
    const portalContainer = document.getElementById("sidebar-content");
    const mobilePortalContainer = document.getElementById("mobile-sidebar-content");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            portalContainer && isMobile === false && /*#__PURE__*/ (0, $1u0KT.createPortal)(children, portalContainer),
            mobilePortalContainer && isMobile === true && /*#__PURE__*/ (0, $1u0KT.createPortal)(children, mobilePortalContainer)
        ]
    });
}
function $6d137961520e2401$export$e575a964a1fe8b0({ children: children }) {
    const portalContainer = document.getElementById("sidebar-header");
    const mobilePortalContainer = document.getElementById("mobile-sidebar-header");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            portalContainer && /*#__PURE__*/ (0, $1u0KT.createPortal)(children, portalContainer),
            mobilePortalContainer && /*#__PURE__*/ (0, $1u0KT.createPortal)(children, mobilePortalContainer)
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $dA5Dq = parcelRequire("dA5Dq");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");
parcelRequire("2bFYF");
var $fp4OM = parcelRequire("fp4OM");
function $cc5dc6059dc1df43$export$33f46f996a60c559(config) {
    const { pathname: pathname, isPathMatch: isPathMatch, params: params } = (0, $fp4OM.useRouter)();
    const sections = (0, $acw62.useMemo)(()=>{
        return config.map(({ label: label, regex: regex, getHref: getHref })=>({
                label: label,
                href: getHref(params),
                regex: regex,
                isCurrent: isPathMatch(regex)
            }));
    }, [
        pathname,
        isPathMatch,
        config,
        params
    ]);
    return {
        sections: sections
    };
}


function $0548d99235c76c1b$export$8dc6765e8be191c7({ title: title, navigationConfig: navigationConfig, onValueChange: onValueChange, className: className }) {
    const { sections: sections } = (0, $cc5dc6059dc1df43$export$33f46f996a60c559)(navigationConfig);
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const menuRef = (0, $acw62.useRef)(null);
    const buttonRef = (0, $acw62.useRef)(null);
    const navigate = (0, $aphAM.useNavigate)();
    const selectedOption = sections.find((section)=>section.isCurrent);
    const displayLabel = selectedOption?.label || "-";
    const handleOptionSelect = (section)=>{
        const url = section.href;
        if (url.startsWith("http") || url.includes("://")) window.location.href = url;
        else navigate(url);
        onValueChange?.(section);
        setIsOpen(false);
    };
    const toggleMenu = ()=>{
        setIsOpen(!isOpen);
    };
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) setIsOpen(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex shrink-0 flex-col gap-2",
        children: [
            title && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "pageheading text-default",
                children: title
            }),
            selectedOption && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        ref: buttonRef,
                        onClick: toggleMenu,
                        className: (0, $9QePP.default)("flex cursor-pointer items-center gap-1", "heading-s subdued transition-colors hover:text-gray-300", className),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: displayLabel
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dA5Dq.default), {
                                className: (0, $9QePP.default)("size-3 transition-transform duration-200", isOpen && "rotate-180")
                            })
                        ]
                    }),
                    isOpen && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        ref: menuRef,
                        className: (0, $9QePP.default)("bg-slate-800", "rounded-lg shadow-400", "custom-scrollbar max-h-[400px] overflow-auto p-2", "absolute left-0 top-full z-50 mt-1", "min-w-[160px]", "flex flex-col gap-1"),
                        children: sections.map((section)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>handleOptionSelect(section),
                                className: (0, $9QePP.default)("flex h-[36px] w-full items-center gap-2 rounded-md px-2 py-1.5", "menu-item hover:bg-slate-600", section.isCurrent && "bg-gray-100 font-medium dark:bg-slate-700"),
                                role: "menuitem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "heading-s",
                                    children: section.label
                                })
                            }, section.label))
                    })
                ]
            })
        ]
    });
}


parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");

var $r2uF6 = parcelRequire("r2uF6");


var $ayMG0 = parcelRequire("ayMG0");

var $iIDkB = parcelRequire("iIDkB");
var $cXDYR = parcelRequire("cXDYR");
var $cVodR = parcelRequire("cVodR");

var $9QePP = parcelRequire("9QePP");

var $r2uF6 = parcelRequire("r2uF6");


var $ayMG0 = parcelRequire("ayMG0");
const $16a363f1d9266658$export$b0135bf246f2ef7f = ({ className: className })=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M6 14L6 2M2 10.8L2 5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H10.8C11.9201 2 12.4802 2 12.908 2.21799C13.2843 2.40973 13.5903 2.71569 13.782 3.09202C14 3.51984 14 4.07989 14 5.2V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.07989 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });


function $e92c534ca3ac9f32$export$f58d7c1aecd6a463({ backLink: backLink, className: className, isMobile: isMobile, rightSidebar: rightSidebar = false }) {
    const [sidebarOpen, setSidebarOpen] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$1a43581c5b8980a9));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("flex items-center py-1", rightSidebar ? "mb-4" : "mb-12 justify-between lg:mb-4", className),
        children: [
            backLink && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex cursor-pointer items-center gap-2",
                onClick: backLink.onClick,
                children: rightSidebar ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "ui-element subdued",
                            children: backLink.label
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cXDYR.default), {
                            width: 12,
                            height: 12,
                            className: "text-gray-400"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iIDkB.default), {
                            width: 12,
                            height: 12,
                            className: "text-gray-400"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "ui-element subdued",
                            children: backLink.label
                        })
                    ]
                })
            }),
            !rightSidebar && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                onClick: ()=>setSidebarOpen(!sidebarOpen),
                "aria-label": "Toggle sidebar",
                className: "collapse-menu-btn cursor-pointer focus:outline-none",
                children: !isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $16a363f1d9266658$export$b0135bf246f2ef7f), {
                    className: "size-4 cursor-pointer"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVodR.default), {
                    className: "size-6 cursor-pointer"
                })
            })
        ]
    });
}
var $e92c534ca3ac9f32$export$2e2bcd8739ae039 = $e92c534ca3ac9f32$export$f58d7c1aecd6a463;



var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
const $4c011da701eff750$export$a1b5b219ef771a88 = ({ company: company, onClick: onClick, active: active })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("w-full cursor-pointer select-none rounded-md p-4", "body-s text-left", active ? "text-default bg-slate-700" : "subdued hover:bg-slate-700 hover:text-slate-200", "transition-colors duration-150 ease-in-out"),
        onClick: onClick,
        role: "button",
        tabIndex: 0,
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick();
            }
        },
        children: company.name
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $fd4Y7 = parcelRequire("fd4Y7");
var $cVodR = parcelRequire("cVodR");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");
const $1cfefb25babf4c58$export$79d13b60110f33be = ({ testId: testId, className: className, placeholder: placeholder = "Search Memo", hotkeyLabel: hotkeyLabel = "\u2318K", value: value, onChange: onChange })=>{
    const inputRef = (0, $acw62.useRef)(null);
    const hasValue = value && value.length > 0;
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if ((event.metaKey || event.ctrlKey) && event.key === "k") {
                event.preventDefault();
                inputRef.current?.focus();
            }
            if (event.key === "k" && !event.metaKey && !event.ctrlKey && document.activeElement?.tagName !== "INPUT" && document.activeElement?.tagName !== "TEXTAREA") {
                event.preventDefault();
                inputRef.current?.focus();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, []);
    const handleClear = ()=>{
        onChange?.("");
        inputRef.current?.focus();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("relative my-2", className),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fd4Y7.default), {
                stroke: "#9CA3AF",
                strokeWidth: 1.5,
                className: (0, $9QePP.default)("-translate-y-1/2", "pointer-events-none absolute left-3 top-1/2 size-4 text-gray-400")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                ref: inputRef,
                type: "search",
                name: "search-sidebar",
                "aria-label": placeholder,
                placeholder: placeholder,
                value: value,
                onChange: (e)=>onChange?.(e.target.value),
                className: (0, $9QePP.default)("border-default bg-default text-default flex border", "placeholder:text-gray-400", "body-s my-0 w-full rounded-lg py-2.5 pl-9 pr-16 focus:ring-0 focus:ring-offset-0", "focus:bg-default outline-none focus:border-gray-500", "transition-colors duration-150 ease-in-out", "[&::-webkit-search-cancel-button]:appearance-none", "[&::-webkit-search-decoration]:appearance-none", "[&::-ms-clear]:hidden", "[&::-ms-reveal]:hidden")
            }),
            hasValue ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                onClick: handleClear,
                className: (0, $9QePP.default)("-translate-y-1/2 bg-gray-500", "absolute right-3 top-1/2 rounded-full p-1", "transition-colors duration-150 ease-in-out", "focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"),
                "aria-label": "Clear search",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVodR.default), {
                    stroke: "#1E293B",
                    className: "size-3",
                    strokeWidth: 2
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: (0, $9QePP.default)("-translate-y-1/2 bg-gray-500 px-1 py-0.5", "text-bg-default text-slate-800", "body-micro pointer-events-none absolute right-3 top-1/2 rounded-md"),
                children: hotkeyLabel
            })
        ]
    });
};
var $1cfefb25babf4c58$export$2e2bcd8739ae039 = $1cfefb25babf4c58$export$79d13b60110f33be;



var $cMZ0q = parcelRequire("cMZ0q");

var $9QePP = parcelRequire("9QePP");


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $af43570ba0a8567e$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    function memoizedFunction() {
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    }
    memoizedFunction.updateDeps = (newDeps)=>{
        deps = newDeps;
    };
    return memoizedFunction;
}
function $af43570ba0a8567e$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $af43570ba0a8567e$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1.01;
const $af43570ba0a8567e$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    };
};


const $ae8077da5dad972b$var$getRect = (element)=>{
    const { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = element;
    return {
        width: offsetWidth,
        height: offsetHeight
    };
};
const $ae8077da5dad972b$export$76974b428a49f15b = (index)=>index;
const $ae8077da5dad972b$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $ae8077da5dad972b$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler($ae8077da5dad972b$var$getRect(element));
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const run = ()=>{
            const entry = entries[0];
            if (entry == null ? void 0 : entry.borderBoxSize) {
                const box = entry.borderBoxSize[0];
                if (box) {
                    handler({
                        width: box.inlineSize,
                        height: box.blockSize
                    });
                    return;
                }
            }
            handler($ae8077da5dad972b$var$getRect(element));
        };
        instance.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $ae8077da5dad972b$var$addEventListenerOptions = {
    passive: true
};
const $ae8077da5dad972b$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $ae8077da5dad972b$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $ae8077da5dad972b$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $ae8077da5dad972b$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = instance.options.useScrollendEvent && $ae8077da5dad972b$var$supportsScrollend ? ()=>void 0 : (0, $af43570ba0a8567e$export$61fc7d43ac8f84b0)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            const { horizontal: horizontal, isRtl: isRtl } = instance.options;
            offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $ae8077da5dad972b$var$addEventListenerOptions);
    const registerScrollendEvent = instance.options.useScrollendEvent && $ae8077da5dad972b$var$supportsScrollend;
    if (registerScrollendEvent) element.addEventListener("scrollend", endHandler, $ae8077da5dad972b$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        if (registerScrollendEvent) element.removeEventListener("scrollend", endHandler);
    };
};
const $ae8077da5dad972b$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = instance.options.useScrollendEvent && $ae8077da5dad972b$var$supportsScrollend ? ()=>void 0 : (0, $af43570ba0a8567e$export$61fc7d43ac8f84b0)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $ae8077da5dad972b$var$addEventListenerOptions);
    const registerScrollendEvent = instance.options.useScrollendEvent && $ae8077da5dad972b$var$supportsScrollend;
    if (registerScrollendEvent) element.addEventListener("scrollend", endHandler, $ae8077da5dad972b$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        if (registerScrollendEvent) element.removeEventListener("scrollend", endHandler);
    };
};
const $ae8077da5dad972b$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return element[instance.options.horizontal ? "offsetWidth" : "offsetHeight"];
};
const $ae8077da5dad972b$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $ae8077da5dad972b$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $ae8077da5dad972b$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        const run = ()=>{
                            this._measureElement(entry.target, entry);
                        };
                        this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $ae8077da5dad972b$export$76974b428a49f15b,
                rangeExtractor: $ae8077da5dad972b$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $ae8077da5dad972b$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                useScrollendEvent: false,
                useAnimationFrameWithResizeObserver: false,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this.maybeNotify();
                }));
            }
        };
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurementOptions = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled
            ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled
            };
        }, {
            key: false
        });
        this.getMeasurements = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                return [];
            }
            if (this.measurementsCache.length === 0) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset(),
                this.options.lanes
            ], (measurements, outerSize, scrollOffset, lanes)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $ae8077da5dad972b$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset,
                lanes: lanes
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualIndexes = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>{
            let startIndex = null;
            let endIndex = null;
            const range = this.calculateRange();
            if (range) {
                startIndex = range.startIndex;
                endIndex = range.endIndex;
            }
            this.maybeNotify.updateDeps([
                this.isScrolling,
                startIndex,
                endIndex
            ]);
            return [
                this.options.rangeExtractor,
                this.options.overscan,
                this.options.count,
                startIndex,
                endIndex
            ];
        }, (rangeExtractor, overscan, count, startIndex, endIndex)=>{
            return startIndex === null || endIndex === null ? [] : rangeExtractor({
                startIndex: startIndex,
                endIndex: endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const index = this.indexFromElement(node);
            const item = this.measurementsCache[index];
            if (!item) return;
            const key = item.key;
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
        };
        this.resizeItem = (index, size)=>{
            const item = this.measurementsCache[index];
            if (!item) return;
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key);
                    }
                });
                return;
            }
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.getVirtualIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            return (0, $af43570ba0a8567e$export$9a1adf421b69c6a)(measurements[$ae8077da5dad972b$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $af43570ba0a8567e$export$9a1adf421b69c6a)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align, itemSize = 0)=>{
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") align = toOffset >= scrollOffset + size ? "end" : "start";
            if (align === "center") toOffset += (itemSize - size) / 2;
            else if (align === "end") toOffset -= size;
            const maxOffset = this.getTotalSize() + this.options.scrollMargin - size;
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const item = this.measurementsCache[index];
            if (!item) return void 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align, item.size),
                align
            ];
        };
        this.isDynamicMode = ()=>this.elementsCache.size > 0;
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            index = Math.max(0, Math.min(index, this.options.count - 1));
            let attempts = 0;
            const maxAttempts = 10;
            const tryScroll = (currentAlign)=>{
                if (!this.targetWindow) return;
                const offsetInfo = this.getOffsetForIndex(index, currentAlign);
                if (!offsetInfo) {
                    console.warn("Failed to get offset for index:", index);
                    return;
                }
                const [offset, align] = offsetInfo;
                this._scrollToOffset(offset, {
                    adjustments: void 0,
                    behavior: behavior
                });
                this.targetWindow.requestAnimationFrame(()=>{
                    const currentOffset = this.getScrollOffset();
                    const afterInfo = this.getOffsetForIndex(index, align);
                    if (!afterInfo) {
                        console.warn("Failed to get offset for index:", index);
                        return;
                    }
                    if (!(0, $af43570ba0a8567e$export$8a4f1dcc58a69dbd)(afterInfo[0], currentOffset)) scheduleRetry(align);
                });
            };
            const scheduleRetry = (align)=>{
                if (!this.targetWindow) return;
                attempts++;
                if (attempts < maxAttempts) this.targetWindow.requestAnimationFrame(()=>tryScroll(align));
                else console.warn(`Failed to scroll to index ${index} after ${maxAttempts} attempts.`);
            };
            tryScroll(initialAlign);
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getScrollOffset() + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else if (this.options.lanes === 1) end = ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0;
            else {
                const endByLane = Array(this.options.lanes).fill(null);
                let endIndex = measurements.length - 1;
                while(endIndex >= 0 && endByLane.some((val)=>val === null)){
                    const item = measurements[endIndex];
                    if (endByLane[item.lane] === null) endByLane[item.lane] = item.end;
                    endIndex--;
                }
                end = Math.max(...endByLane.filter((val)=>val !== null));
            }
            return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
    }
}
const $ae8077da5dad972b$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $ae8077da5dad972b$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset, lanes: lanes }) {
    const lastIndex = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    if (measurements.length <= lanes) return {
        startIndex: 0,
        endIndex: lastIndex
    };
    let startIndex = $ae8077da5dad972b$var$findNearestBinarySearch(0, lastIndex, getOffset, scrollOffset);
    let endIndex = startIndex;
    if (lanes === 1) while(endIndex < lastIndex && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    else if (lanes > 1) {
        const endPerLane = Array(lanes).fill(0);
        while(endIndex < lastIndex && endPerLane.some((pos)=>pos < scrollOffset + outerSize)){
            const item = measurements[endIndex];
            endPerLane[item.lane] = item.end;
            endIndex++;
        }
        const startPerLane = Array(lanes).fill(scrollOffset + outerSize);
        while(startIndex >= 0 && startPerLane.some((pos)=>pos >= scrollOffset)){
            const item = measurements[startIndex];
            startPerLane[item.lane] = item.start;
            startIndex--;
        }
        startIndex = Math.max(0, startIndex - startIndex % lanes);
        endIndex = Math.min(lastIndex, endIndex + (lanes - 1 - endIndex % lanes));
    }
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}


const $64d08e094a93fa77$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
function $64d08e094a93fa77$var$useVirtualizerBase(options) {
    const rerender = $acw62.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $1u0KT.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $acw62.useState(()=>new (0, $ae8077da5dad972b$export$89be5a243e59c4b2)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $64d08e094a93fa77$var$useIsomorphicLayoutEffect(()=>{
        return instance._didMount();
    }, []);
    $64d08e094a93fa77$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $64d08e094a93fa77$export$dd6d526d88b5a137(options) {
    return $64d08e094a93fa77$var$useVirtualizerBase({
        observeElementRect: $ae8077da5dad972b$export$5a50ff2cde8c3802,
        observeElementOffset: $ae8077da5dad972b$export$fbc040aee017375a,
        scrollToFn: (0, $ae8077da5dad972b$export$1cdb988e5ab69fe7),
        ...options
    });
}
function $64d08e094a93fa77$export$645722dcac657cb9(options) {
    return $64d08e094a93fa77$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $ae8077da5dad972b$export$e911b82c7a99311),
        observeElementOffset: (0, $ae8077da5dad972b$export$518998f8c5d09287),
        scrollToFn: (0, $ae8077da5dad972b$export$2162c5b3eeedd27),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}



var $acw62 = parcelRequire("acw62");
parcelRequire("tL0U5");
var $7Y7Q4 = parcelRequire("7Y7Q4");

var $kTlwO = parcelRequire("kTlwO");
const $93cd293188c32ab7$export$7329268b5a34d4c1 = (searchTerm)=>{
    const [allCompanies, setAllCompanies] = (0, $acw62.useState)([]);
    const [currentPage, setCurrentPage] = (0, $acw62.useState)(1);
    const [totalResults, setTotalResults] = (0, $acw62.useState)(0);
    const [totalPages, setTotalPages] = (0, $acw62.useState)(0);
    const [hasNextPage, setHasNextPage] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        setAllCompanies([]);
        setCurrentPage(1);
        setTotalResults(0);
        setTotalPages(0);
        setHasNextPage(true);
    }, [
        searchTerm
    ]);
    const { data: data, isLoading: isLoading, error: error, isSuccess: isSuccess } = (0, $7Y7Q4.useApiQuery)((0, $kTlwO.searchCompanies), {
        params: {
            query: searchTerm || "",
            page: currentPage,
            pageSize: 10
        },
        enabled: currentPage > 0 && hasNextPage,
        key: [
            `companies-search-${searchTerm || "all"}-page-${currentPage}`
        ]
    });
    (0, $acw62.useEffect)(()=>{
        if (isSuccess && data) {
            const { results: results, pagination: pagination } = data;
            setAllCompanies((prev)=>{
                if (currentPage === 1) return results;
                else return [
                    ...prev,
                    ...results
                ];
            });
            setTotalResults(pagination.totalResults);
            setTotalPages(pagination.numPages);
            setHasNextPage(currentPage < pagination.numPages);
        }
    }, [
        data,
        isSuccess,
        currentPage
    ]);
    const loadNextPage = (0, $acw62.useCallback)(()=>{
        if (!isLoading && hasNextPage && currentPage < totalPages) setCurrentPage((prev)=>prev + 1);
    }, [
        isLoading,
        hasNextPage,
        currentPage,
        totalPages
    ]);
    const isInitialLoading = (0, $acw62.useMemo)(()=>{
        return isLoading && currentPage === 1;
    }, [
        isLoading,
        currentPage
    ]);
    const isLoadingMore = (0, $acw62.useMemo)(()=>{
        return isLoading && currentPage > 1;
    }, [
        isLoading,
        currentPage
    ]);
    return {
        companies: allCompanies,
        totalCount: totalResults,
        loadedCount: allCompanies.length,
        loadNextPage: loadNextPage,
        hasNextPage: hasNextPage,
        isLoading: isInitialLoading,
        isLoadingMore: isLoadingMore,
        error: error,
        pagination: {
            totalResults: totalResults,
            totalPages: totalPages,
            currentPage: currentPage,
            pageSize: 10
        }
    };
};


parcelRequire("5R0Xk");
var $5Ttm9 = parcelRequire("5Ttm9");
const $9b7b211c4c2184d7$export$2627579a5e93fc70 = (0, $r2uF6.atom)(false);
const $9b7b211c4c2184d7$export$9c2b95809c390304 = [
    // {
    //     label: "Company Overview",
    //     getHref: (params) => `/beta/companies/${params.companyId}`,
    //     regex: "^/beta/companies/[^/]+/?$",
    // },
    {
        label: "Investment Memo",
        getHref: (params)=>`/beta/companies/${params.companyId}/investment-memo`,
        regex: "^/beta/companies/[^/]+/investment-memo/?$"
    },
    {
        label: "Connectors",
        getHref: (params)=>`/beta/companies/${params.companyId}/connectors`,
        regex: "^/beta/companies/[^/]+/connectors(/.*)?/?$"
    },
    {
        label: "Uploads",
        getHref: (params)=>`/beta/companies/${params.companyId}/uploads`,
        regex: "^/beta/companies/[^/]+/uploads(/.*)?/?$"
    },
    {
        label: "Labeling",
        getHref: (params)=>`/beta/companies/${params.companyId}/labeling`,
        regex: "^/beta/companies/[^/]+/labeling(/.*)?/?$"
    },
    {
        label: "Opportunities",
        getHref: (params)=>`/beta/companies/${params.companyId}/opportunities`,
        regex: "^/beta/companies/[^/]+/opportunities(/.*)?/?$"
    },
    {
        label: "Metric Lab",
        getHref: (params)=>`/beta/companies/${params.companyId}/metrics`,
        regex: "^/beta/companies/[^/]+/metrics(/.*)?/?$"
    }
];
function $9b7b211c4c2184d7$export$fcc5ff4e66800788() {
    const { company: company } = (0, $cMZ0q.useCompany)();
    const router = (0, $fp4OM.useRouter)();
    const [showCompanyList, setShowCompanyList] = (0, $r2uF6.useAtom)($9b7b211c4c2184d7$export$2627579a5e93fc70);
    const setShowParentHeader = (0, $r2uF6.useSetAtom)((0, $30c17e6838b1ddb3$export$4085ed3565a3eb10));
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const { companies: companies, loadNextPage: loadNextPage, hasNextPage: hasNextPage, isLoading: isLoading, isLoadingMore: isLoadingMore, error: error } = (0, $93cd293188c32ab7$export$7329268b5a34d4c1)(searchTerm);
    const parentRef = (0, $acw62.useRef)(null);
    const virtualizer = (0, $64d08e094a93fa77$export$dd6d526d88b5a137)({
        count: companies.length,
        getScrollElement: ()=>parentRef.current,
        estimateSize: ()=>60,
        overscan: 10
    });
    const handleScroll = (0, $acw62.useCallback)(()=>{
        const virtualItems = virtualizer.getVirtualItems();
        if (virtualItems.length === 0) return;
        const lastItem = virtualItems[virtualItems.length - 1];
        if (lastItem.index, companies.length, hasNextPage && !isLoadingMore) loadNextPage();
    }, [
        virtualizer,
        companies.length,
        hasNextPage,
        isLoadingMore,
        loadNextPage
    ]);
    const isIndex = router.isPathMatch("^/beta/companies(/)?$");
    const matchingConfig = $9b7b211c4c2184d7$export$9c2b95809c390304.find((section)=>router.isPathMatch(section.regex));
    const isMobile = (0, $63c42b32dd564eae$export$32d5543ab307c01)("(max-width: 640px)");
    (0, $acw62.useEffect)(()=>{
        if (isIndex && !showCompanyList) setShowCompanyList(true);
    }, [
        router.pathname,
        showCompanyList
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isIndex || showCompanyList) setShowParentHeader(true);
        else setShowParentHeader(false);
    }, [
        router.pathname,
        showCompanyList
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5mL0X.LayoutGroup), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d137961520e2401$export$e575a964a1fe8b0), {
                children: !showCompanyList && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mb-3 sm:px-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e92c534ca3ac9f32$export$2e2bcd8739ae039), {
                            isMobile: isMobile,
                            backLink: {
                                label: "Companies",
                                onClick: ()=>setShowCompanyList(true)
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0548d99235c76c1b$export$8dc6765e8be191c7), {
                            title: company?.name || "-",
                            navigationConfig: $9b7b211c4c2184d7$export$9c2b95809c390304
                        })
                    ]
                })
            }),
            showCompanyList && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6d137961520e2401$export$26c4ec9456bef7c4), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d137961520e2401$export$e575a964a1fe8b0), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cfefb25babf4c58$export$2e2bcd8739ae039), {
                            value: searchTerm,
                            onChange: setSearchTerm,
                            placeholder: "Search..."
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        ref: parentRef,
                        className: (0, $9QePP.default)("mt-6", "flex flex-col", "hide-scrollbar overflow-y-auto", "min-h-0 flex-1"),
                        style: {
                            contain: "strict"
                        },
                        onScroll: handleScroll,
                        children: [
                            isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex justify-center py-8",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {})
                            }),
                            !isLoading && companies.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    height: `${virtualizer.getTotalSize()}px`,
                                    width: "100%",
                                    position: "relative"
                                },
                                children: virtualizer.getVirtualItems().map((virtualItem)=>{
                                    const company = companies[virtualItem.index];
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: `${virtualItem.size}px`,
                                            transform: `translateY(${virtualItem.start}px)`
                                        },
                                        children: company && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c011da701eff750$export$a1b5b219ef771a88), {
                                            company: company,
                                            onClick: ()=>{
                                                setShowCompanyList(false);
                                                router.navigate(matchingConfig?.getHref({
                                                    companyId: company.uuid
                                                }) || `/beta/companies/${company.uuid}`);
                                            },
                                            active: router.isPathMatch(`/beta/companies/${company.uuid}`)
                                        })
                                    }, virtualItem.key);
                                })
                            }),
                            !isLoading && !error && companies.length === 0 && searchTerm && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "body-s subdued py-8 text-center",
                                children: [
                                    'No companies found for "',
                                    searchTerm,
                                    '"'
                                ]
                            }),
                            error && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-s subdued py-8 text-center",
                                children: "Error loading companies. Please try again."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Outlet), {})
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("eoXvj");
var $cjuU3 = parcelRequire("cjuU3");

var $ayMG0 = parcelRequire("ayMG0");

var $04Y2Q = parcelRequire("04Y2Q");
const $eb3baba2011e6e91$export$a6c7ac8248d6e38a = ({ href: href, title: title })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        href: href,
        role: "button",
        className: "link-memo",
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: "inline-flex items-center gap-2",
            children: [
                title && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "ui-label max-w-[90px] truncate",
                    children: title
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04Y2Q.default), {
                    className: "size-4 shrink-0"
                })
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
parcelRequire("agk6G");
var $kTlwO = parcelRequire("kTlwO");
parcelRequire("tL0U5");
var $7Y7Q4 = parcelRequire("7Y7Q4");
function $1416c023a16bbb44$export$9716a88f5535df7c() {
    const company = (0, $7Y7Q4.useApiQuery)((0, $kTlwO.getCompany));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("sm:mb-4"),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "flex justify-between",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "display-l",
                children: company.data?.name
            })
        })
    });
}



var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
parcelRequire("tL0U5");
var $7Y7Q4 = parcelRequire("7Y7Q4");
parcelRequire("agk6G");
var $kTlwO = parcelRequire("kTlwO");

var $acw62 = parcelRequire("acw62");
function $12764094adeb71cd$export$85ed839e6898dc60() {
    const company = (0, $7Y7Q4.useApiQuery)((0, $kTlwO.getCompany));
    const domain = company.data?.website?.split("//")[1];
    const [logoUrl, setLogoUrl] = (0, $acw62.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!domain) {
            setLogoUrl(undefined);
            return;
        }
        const url = `https://cdn.brandfetch.io/${domain}?c=1id_c-RSkEnaPP4iucC`;
        setIsLoading(true);
        const testImg = new Image();
        testImg.onload = ()=>{
            if (testImg.naturalWidth > 0 && testImg.naturalHeight > 0) setLogoUrl(url);
            else setLogoUrl(undefined);
            setIsLoading(false);
        };
        testImg.onerror = ()=>{
            setLogoUrl(undefined);
            setIsLoading(false);
        };
        testImg.src = url;
        return ()=>{
            testImg.onload = null;
            testImg.onerror = null;
        };
    }, [
        domain
    ]);
    return {
        logoUrl: logoUrl,
        isLoading: isLoading,
        notFound: !logoUrl && !isLoading
    };
}



var $75mQk = parcelRequire("75mQk");
function $ae4d8655e1f6bf27$export$b447ceeb6cd4731e({ className: className = "sm:mb-6 h-[68px] w-[66px] rounded-lg", fallbackClassName: fallbackClassName = "mb-3 h-[68px] w-[66px] rounded-lg ", alt: alt = "Logo" }) {
    const { logoUrl: logoUrl, isLoading: isLoading } = (0, $12764094adeb71cd$export$85ed839e6898dc60)();
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)(fallbackClassName, "animate-pulse bg-gray-200")
    });
    if (logoUrl) return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        src: logoUrl,
        alt: alt,
        className: className
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75mQk.default), {
        className: fallbackClassName,
        width: "40",
        height: "40"
    });
}





parcelRequire("5R0Xk");
var $5Ttm9 = parcelRequire("5Ttm9");
parcelRequire("tL0U5");
var $4CoXh = parcelRequire("4CoXh");
var $7Y7Q4 = parcelRequire("7Y7Q4");
parcelRequire("agk6G");
var $kTlwO = parcelRequire("kTlwO");
parcelRequire("i5Lss");
var $kkxkw = parcelRequire("kkxkw");
const $373556c5044190a1$export$72ae9d99a50eb0bb = (0, $kkxkw.createQuery)(async ({ api: api, router: router, params: params })=>{
    const response = await api.get(`/deal-flow/alpha/companies/${router.params.companyId}/memo-texts${params.type ? `?type=${params.type}` : ""}`);
    return response.items?.map((item)=>({
            ...item,
            type: item.id
        })) || [];
});


parcelRequire("i5Lss");
var $gBHSi = parcelRequire("gBHSi");

var $lvlqo = parcelRequire("lvlqo");
const $86c1a89ae3883995$export$573c87758d6cb99 = (0, $gBHSi.createMutation)(async ({ api: api, router: router, payload: payload })=>{
    const response = await api.post(`/deal-flow/alpha/companies/${router.params.companyId}/memo-texts/generate`, {
        companyWebsite: payload.companyWebsite ? (0, $lvlqo.ensureHttps)(payload.companyWebsite) : ""
    });
    return response.items.map((item)=>({
            ...item,
            type: item.id
        }));
}, {
    invalidates: [
        "/memo-texts"
    ],
    errorToast: {
        message: "Unable to generate memo text."
    }
});


var $b082cd036e01ace0$export$3c704bcecc108d48;
(function(MemoTextMarkdownTypeEnum) {
    MemoTextMarkdownTypeEnum["COMPANY_SUMMARY"] = "company_summary";
})($b082cd036e01ace0$export$3c704bcecc108d48 || ($b082cd036e01ace0$export$3c704bcecc108d48 = {}));
var $b082cd036e01ace0$export$8eb29354037a9c7c;
(function(MemoTextJsonTypeEnum) {
    MemoTextJsonTypeEnum["COMPANY_METADATA"] = "company_metadata";
})($b082cd036e01ace0$export$8eb29354037a9c7c || ($b082cd036e01ace0$export$8eb29354037a9c7c = {}));
var $b082cd036e01ace0$export$68ff9927e98f2976;
(function(MemoTextCompetitiveAnalysisTypeEnum) {
    MemoTextCompetitiveAnalysisTypeEnum["COMPETITIVE_ANALYSIS"] = "competitive_analysis";
})($b082cd036e01ace0$export$68ff9927e98f2976 || ($b082cd036e01ace0$export$68ff9927e98f2976 = {}));
var $b082cd036e01ace0$export$471b0ac2b63f1fa8;
(function(MemoTextBackgroundCheckTypeEnum) {
    MemoTextBackgroundCheckTypeEnum["BACKGROUND_CHECK"] = "background_check";
})($b082cd036e01ace0$export$471b0ac2b63f1fa8 || ($b082cd036e01ace0$export$471b0ac2b63f1fa8 = {}));



var $acw62 = parcelRequire("acw62");
function $aa9920dff4a9c63d$var$arrayToTextObject(memoTexts) {
    return {
        [(0, $b082cd036e01ace0$export$3c704bcecc108d48).COMPANY_SUMMARY]: memoTexts?.find((memoText)=>memoText.type === (0, $b082cd036e01ace0$export$3c704bcecc108d48).COMPANY_SUMMARY),
        [(0, $b082cd036e01ace0$export$8eb29354037a9c7c).COMPANY_METADATA]: memoTexts?.find((memoText)=>memoText.type === (0, $b082cd036e01ace0$export$8eb29354037a9c7c).COMPANY_METADATA),
        [(0, $b082cd036e01ace0$export$68ff9927e98f2976).COMPETITIVE_ANALYSIS]: memoTexts?.find((memoText)=>memoText.type === (0, $b082cd036e01ace0$export$68ff9927e98f2976).COMPETITIVE_ANALYSIS),
        [(0, $b082cd036e01ace0$export$471b0ac2b63f1fa8).BACKGROUND_CHECK]: memoTexts?.find((memoText)=>memoText.type === (0, $b082cd036e01ace0$export$471b0ac2b63f1fa8).BACKGROUND_CHECK)
    };
}
function $aa9920dff4a9c63d$export$9c91c33a46c3167e() {
    const company = (0, $7Y7Q4.useApiQuery)((0, $kTlwO.getCompany));
    const memoTexts = (0, $7Y7Q4.useApiQuery)((0, $373556c5044190a1$export$72ae9d99a50eb0bb), {
        params: {
            companyId: company.data?.uuid || ""
        },
        enabled: !!company.data?.uuid
    });
    const [generationBuffer, setGenerationBuffer] = (0, $acw62.useState)({});
    const generateMemoText = (0, $4CoXh.useApiMutation)((0, $86c1a89ae3883995$export$573c87758d6cb99), {
        onSuccess: (data)=>{
            setGenerationBuffer($aa9920dff4a9c63d$var$arrayToTextObject(data));
        }
    });
    const text = (0, $acw62.useMemo)(()=>{
        return $aa9920dff4a9c63d$var$arrayToTextObject(memoTexts.data);
    }, [
        memoTexts.data
    ]);
    const clearKeyFromBuffer = (0, $acw62.useCallback)((key)=>{
        setGenerationBuffer((prev)=>{
            const newBuffer = {
                ...prev
            };
            delete newBuffer[key];
            return newBuffer;
        });
    }, [
        setGenerationBuffer
    ]);
    return {
        text: text,
        generationBuffer: generationBuffer,
        generateMemoText: (companyWebsite)=>{
            generateMemoText.mutate({
                companyWebsite: companyWebsite
            });
        },
        setGenerationBuffer: setGenerationBuffer,
        clearKeyFromBuffer: clearKeyFromBuffer,
        isGenerating: generateMemoText.isPending
    };
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $gGwtt = parcelRequire("gGwtt");
/**
 * Checks if text is a JSON response with results array and extracts values
 * Handles format: {"results":[{"value":"text1"},{"value":"text2"}]}
 */ const $c2560609a068b22c$var$extractResultsValues = (text)=>{
    try {
        const trimmed = text.trim();
        if (!trimmed.startsWith("{") || !trimmed.includes("results")) return null;
        const parsed = JSON.parse(trimmed);
        if (parsed && typeof parsed === "object" && Array.isArray(parsed.results) && parsed.results.length > 0) {
            const hasValues = parsed.results.every((item)=>item && typeof item === "object" && "value" in item && typeof item.value === "string");
            if (hasValues) {
                const values = parsed.results.map((item)=>item.value);
                return values.map((val, idx)=>`${idx + 1}. ${val}`).join("\n\n");
            }
        }
        return null;
    } catch  {
        return null;
    }
};
const $c2560609a068b22c$export$4bbb6880c2bce4a2 = ({ text: text, maxLength: maxLength = 500, className: className })=>{
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(false);
    if (!text) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: (0, $9QePP.default)(className, "body-s subdued"),
        children: "-"
    });
    const processedText = $c2560609a068b22c$var$extractResultsValues(text) || text;
    const shouldTruncate = processedText.length > maxLength;
    if (!shouldTruncate) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gGwtt.Markdown), {
            children: processedText
        })
    });
    const displayText = isExpanded ? processedText : `${Array.from(processedText).slice(0, maxLength).join("")}...`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gGwtt.Markdown), {
                children: displayText
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                role: "button",
                onClick: ()=>setIsExpanded(!isExpanded),
                tabIndex: 0,
                className: "text-link ml-1 cursor-pointer",
                children: isExpanded ? "Show less" : "See more"
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $iIt79 = parcelRequire("iIt79");
var $cWbAg = parcelRequire("cWbAg");
var $ib9V1 = parcelRequire("ib9V1");
var $acw62 = parcelRequire("acw62");
function $67494f418924d466$var$ShoppingBagIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M7.5 6v.75H5.513c-.96 0-1.764.724-1.865 1.679l-1.263 12A1.875 1.875 0 0 0 4.25 22.5h15.5a1.875 1.875 0 0 0 1.865-2.071l-1.263-12a1.875 1.875 0 0 0-1.865-1.679H16.5V6a4.5 4.5 0 1 0-9 0ZM12 3a3 3 0 0 0-3 3v.75h6V6a3 3 0 0 0-3-3Zm-3 8.25a3 3 0 1 0 6 0v-.75a.75.75 0 0 1 1.5 0v.75a4.5 4.5 0 1 1-9 0v-.75a.75.75 0 0 1 1.5 0v.75Z",
        clipRule: "evenodd"
    }));
}
const $67494f418924d466$var$ForwardRef = $acw62.forwardRef($67494f418924d466$var$ShoppingBagIcon);
var $67494f418924d466$export$2e2bcd8739ae039 = $67494f418924d466$var$ForwardRef;


var $bRCUQ = parcelRequire("bRCUQ");

parcelRequire("iuVpE");
var $lvlqo = parcelRequire("lvlqo");
var $kdwja = parcelRequire("kdwja");

var $cstYm = parcelRequire("cstYm");

var $9QePP = parcelRequire("9QePP");

var $9QePP = parcelRequire("9QePP");

var $r2uF6 = parcelRequire("r2uF6");

var $r2uF6 = parcelRequire("r2uF6");

var $eQbhf = parcelRequire("eQbhf");
const $e8aa26b1ef42f359$export$4bba709a6a23ef4d = (0, $r2uF6.atom)(false);
const $e8aa26b1ef42f359$export$dc84001c1f4f3a7d = (0, $r2uF6.atom)((0, $eQbhf.AccountLabel).REVENUES);
const $e8aa26b1ef42f359$export$aae87475dc36dcea = (0, $r2uF6.atom)(null);
const $e8aa26b1ef42f359$export$a2bdedb1c10962aa = (0, $r2uF6.atom)(null);
const $e8aa26b1ef42f359$export$4494aab2612fe793 = (0, $r2uF6.atom)(false);


var $3ed9e5cde76bd4e1$export$accd73d198d77d2f;
(function(DataSource) {
    DataSource["FINANCE_API"] = "finance-api";
    DataSource["LEGACY_BACKEND"] = "legacy-backend";
    DataSource["SFDC"] = "sfdc";
    DataSource["FINANCE_LAB"] = "finance-lab";
    DataSource["MEMO_TEXT"] = "memo-text";
})($3ed9e5cde76bd4e1$export$accd73d198d77d2f || ($3ed9e5cde76bd4e1$export$accd73d198d77d2f = {}));
const $3ed9e5cde76bd4e1$export$36b6dde38a2cf52b = {
    ["finance-api"]: "text-blue-500",
    ["legacy-backend"]: "text-cyan-500",
    ["sfdc"]: "text-green-500",
    ["finance-lab"]: "text-purple-500",
    ["memo-text"]: "text-orange-500"
};
const $3ed9e5cde76bd4e1$export$4aba7aa5a8467462 = {
    ["finance-api"]: "text-blue-500",
    ["legacy-backend"]: "text-cyan-500",
    ["sfdc"]: "text-green-500",
    ["finance-lab"]: "text-purple-500",
    ["memo-text"]: "text-orange-500"
};
function $3ed9e5cde76bd4e1$export$59157b4b30178565(value, source, fieldKey) {
    const showDataSources = (0, $r2uF6.useAtomValue)((0, $e8aa26b1ef42f359$export$4bba709a6a23ef4d));
    const stringValue = value?.toString() || "-";
    // Always return the value, but only add color classes when flag is enabled and we have a real value
    if (!showDataSources) return {
        value: stringValue,
        className: "",
        source: null,
        sourceClassName: ""
    };
    return {
        value: stringValue,
        className: (0, $9QePP.default)($3ed9e5cde76bd4e1$export$36b6dde38a2cf52b[source], "font-medium"),
        source: fieldKey || source,
        sourceClassName: (0, $9QePP.default)($3ed9e5cde76bd4e1$export$36b6dde38a2cf52b[source], "font-medium")
    };
}



var $eUiRa = parcelRequire("eUiRa");

var $r2uF6 = parcelRequire("r2uF6");

const $fa04cce42fac0f3e$var$InfoDisplay = ({ value: value, isLoading: isLoading, valueClassName: valueClassName, source: source, sourceClassName: sourceClassName, showDataSources: showDataSources })=>{
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("h-3 w-10 bg-slate-700", "animate-pulse rounded")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: (0, $9QePP.default)("body-s subdued", valueClassName),
                children: value || "-"
            }),
            showDataSources && source && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: (0, $9QePP.default)("text-[9px] font-medium tracking-wide", sourceClassName),
                children: source
            })
        ]
    });
};
const $fa04cce42fac0f3e$export$4e0ee67fd4a7d890 = ({ company: company, sfdcData: sfdcData, text: text = {}, isGenerating: isGenerating, isLoadingCompany: isLoadingCompany = false, isLoadingSfdc: isLoadingSfdc = false, hideDataSources: hideDataSources = false })=>{
    const showDataSourcesAtomValue = (0, $r2uF6.useAtomValue)((0, $e8aa26b1ef42f359$export$4bba709a6a23ef4d));
    const showDataSources = !hideDataSources && showDataSourcesAtomValue;
    const facilitySize = sfdcData?.[0]?.totalFacilitySize;
    const metadata = text?.[(0, $b082cd036e01ace0$export$8eb29354037a9c7c).COMPANY_METADATA]?.data;
    const companyState = company?.state ? (0, $eUiRa.US_STATES)[company?.state] : null;
    const companyCountry = company?.country;
    const locationValue = [
        companyState,
        companyCountry
    ].filter(Boolean).join(", ");
    const facilitySizeColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(facilitySize ? (0, $kdwja.money)(facilitySize) : undefined, (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).SFDC, "sfdc.totalFacilitySize");
    const locationColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(locationValue || undefined, (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).LEGACY_BACKEND, "company.state, company.country");
    const industryColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $cstYm.NAICS_6_DIGIT_CODE)[metadata?.naicsCode] || (0, $cstYm.NAICS_INDUSTRY_GROUP_OPTIONS)[company?.capitalApplication.selfReportedIndustry], metadata?.naicsCode ? (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).MEMO_TEXT : (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).LEGACY_BACKEND, metadata?.naicsCode ? "memoText.companyMetadata.naicsCode" : "company.capitalApplication.selfReportedIndustry");
    const headcountColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(metadata?.headcountEstimate, (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).MEMO_TEXT, "memoText.companyMetadata.headcountEstimate");
    const websiteColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $lvlqo.formattedUrl)(company?.website || null), (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).LEGACY_BACKEND, "company.website");
    const stageName = sfdcData?.[0]?.stage;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-wrap gap-x-6 gap-y-2",
        children: [
            stageName && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: (0, $9QePP.default)("max-h-[24px] w-fit rounded-full bg-[#93C5FD] px-2 py-1", "flex items-center"),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "ui-label text-slate-900",
                        children: stageName
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iIt79.default), {
                        className: " size-4"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($fa04cce42fac0f3e$var$InfoDisplay, {
                        value: facilitySizeColorized.value,
                        valueClassName: hideDataSources ? "" : facilitySizeColorized.className,
                        source: facilitySizeColorized.source,
                        sourceClassName: facilitySizeColorized.sourceClassName,
                        showDataSources: showDataSources,
                        isLoading: isLoadingSfdc
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ib9V1.default), {
                        className: " size-4"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($fa04cce42fac0f3e$var$InfoDisplay, {
                        value: locationColorized.value,
                        valueClassName: hideDataSources ? "" : locationColorized.className,
                        source: locationColorized.source,
                        sourceClassName: locationColorized.sourceClassName,
                        showDataSources: showDataSources,
                        isLoading: isLoadingCompany
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bRCUQ.default), {
                        className: " size-4"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($fa04cce42fac0f3e$var$InfoDisplay, {
                        value: headcountColorized.value,
                        valueClassName: hideDataSources ? "" : headcountColorized.className,
                        source: headcountColorized.source,
                        sourceClassName: headcountColorized.sourceClassName,
                        showDataSources: showDataSources,
                        isLoading: isGenerating
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cWbAg.default), {
                        className: " size-4"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($fa04cce42fac0f3e$var$InfoDisplay, {
                        value: websiteColorized.value,
                        valueClassName: hideDataSources ? "" : websiteColorized.className,
                        source: websiteColorized.source,
                        sourceClassName: websiteColorized.sourceClassName,
                        showDataSources: showDataSources,
                        isLoading: isLoadingCompany
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67494f418924d466$export$2e2bcd8739ae039), {
                        className: " size-4"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($fa04cce42fac0f3e$var$InfoDisplay, {
                        value: industryColorized.value,
                        valueClassName: hideDataSources ? "" : industryColorized.className,
                        source: industryColorized.source,
                        sourceClassName: industryColorized.sourceClassName,
                        showDataSources: showDataSources,
                        isLoading: isLoadingCompany || isGenerating
                    })
                ]
            })
        ]
    });
};



var $r2uF6 = parcelRequire("r2uF6");


var $r2uF6 = parcelRequire("r2uF6");

const $57f1ca4385a7301a$export$4027fbee048e5c3d = (0, $r2uF6.atom)(null);
const $57f1ca4385a7301a$export$c65e5de3b3a2e247 = (0, $r2uF6.atom)((get)=>get($57f1ca4385a7301a$export$4027fbee048e5c3d), (get, set, newValue)=>{
    if (!newValue) {
        set((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae), false);
        set($57f1ca4385a7301a$export$4027fbee048e5c3d, newValue);
    } else {
        set($57f1ca4385a7301a$export$4027fbee048e5c3d, newValue);
        set((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae), true);
        if (newValue?.isExpanded) set((0, $30c17e6838b1ddb3$export$77306c2481da7c28), (0, $30c17e6838b1ddb3$export$fcbbb141329b865d).EXPANDED);
        else set((0, $30c17e6838b1ddb3$export$77306c2481da7c28), (0, $30c17e6838b1ddb3$export$fcbbb141329b865d).DEFAULT);
    }
});


var $0e9c1faaf8e0eb7e$export$88fa5c7cfbd4d210;
(function(AIMViewType) {
    AIMViewType["DELTA_LINEAGE"] = "DELTA_LINEAGE";
    AIMViewType["VALUE_LINEAGE"] = "VALUE_LINEAGE";
    AIMViewType["LABS_LINEAGE"] = "LABS_LINEAGE";
    AIMViewType["DATA_SOURCES_SETTINGS"] = "DATA_SOURCES_SETTINGS";
    AIMViewType["INVESTMENT_CRITERIA"] = "INVESTMENT_CRITERIA";
})($0e9c1faaf8e0eb7e$export$88fa5c7cfbd4d210 || ($0e9c1faaf8e0eb7e$export$88fa5c7cfbd4d210 = {}));


parcelRequire("tL0U5");
var $7Y7Q4 = parcelRequire("7Y7Q4");
parcelRequire("agk6G");
var $kTlwO = parcelRequire("kTlwO");
parcelRequire("a9SWJ");
var $lgOhz = parcelRequire("lgOhz");

var $acw62 = parcelRequire("acw62");
function $a08ef469b8107069$var$ArrowPathIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
    }));
}
const $a08ef469b8107069$var$ForwardRef = $acw62.forwardRef($a08ef469b8107069$var$ArrowPathIcon);
var $a08ef469b8107069$export$2e2bcd8739ae039 = $a08ef469b8107069$var$ForwardRef;


var $ihuRA = parcelRequire("ihuRA");

var $ayMG0 = parcelRequire("ayMG0");

var $i8Fxz = parcelRequire("i8Fxz");

var $acw62 = parcelRequire("acw62");
function $654d2e9fb8687050$export$2e2bcd8739ae039({ text: text, typingSpeed: typingSpeed = 12, onComplete: onComplete, className: className = "" }) {
    const [displayedText, setDisplayedText] = (0, $acw62.useState)("");
    const [currentIndex, setCurrentIndex] = (0, $acw62.useState)(0);
    const [isComplete, setIsComplete] = (0, $acw62.useState)(false);
    const timeoutRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (currentIndex < text.length && !isComplete) timeoutRef.current = window.setTimeout(()=>{
            setDisplayedText(text.slice(0, currentIndex + 1));
            setCurrentIndex(currentIndex + 1);
        }, typingSpeed);
        else if (currentIndex >= text.length && !isComplete) {
            setIsComplete(true);
            if (onComplete) onComplete();
        }
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [
        currentIndex,
        text,
        typingSpeed,
        isComplete,
        onComplete
    ]);
    (0, $acw62.useEffect)(()=>{
        setDisplayedText("");
        setCurrentIndex(0);
        setIsComplete(false);
    }, [
        text
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: `inline-flex items-center whitespace-pre-wrap ${className}`,
        children: (0, $i8Fxz.sanitize)(displayedText)
    });
}



var $fRJCp = parcelRequire("fRJCp");

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $dKUtl = parcelRequire("dKUtl");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
const $35aceb44e08862e6$export$3d2710274f64e897 = ({ text: text, maxLength: maxLength = 500, className: className })=>{
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(false);
    if (!text) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: (0, $9QePP.default)(className, "body-s subdued"),
        children: "-"
    });
    const shouldTruncate = text.length > maxLength;
    if (!shouldTruncate) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: (0, $9QePP.default)(className, "body-s subdued"),
        children: text
    });
    const displayText = isExpanded ? text : `${text.slice(0, maxLength)}...`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: (0, $9QePP.default)(className, "body-s subdued"),
        children: [
            displayText,
            " ",
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                role: "button",
                onClick: ()=>setIsExpanded(!isExpanded),
                tabIndex: 0,
                className: "text-link",
                children: isExpanded ? "Show less" : "See more"
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $9dEbd = parcelRequire("9dEbd");
var $acw62 = parcelRequire("acw62");
function $3b81e5eb98e77539$var$ArrowUpIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M10 17a.75.75 0 0 1-.75-.75V5.612L5.29 9.77a.75.75 0 0 1-1.08-1.04l5.25-5.5a.75.75 0 0 1 1.08 0l5.25 5.5a.75.75 0 1 1-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0 1 10 17Z",
        clipRule: "evenodd"
    }));
}
const $3b81e5eb98e77539$var$ForwardRef = $acw62.forwardRef($3b81e5eb98e77539$var$ArrowUpIcon);
var $3b81e5eb98e77539$export$2e2bcd8739ae039 = $3b81e5eb98e77539$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $449758aadd79f00e$var$MinusIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M4 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 10Z",
        clipRule: "evenodd"
    }));
}
const $449758aadd79f00e$var$ForwardRef = $acw62.forwardRef($449758aadd79f00e$var$MinusIcon);
var $449758aadd79f00e$export$2e2bcd8739ae039 = $449758aadd79f00e$var$ForwardRef;


function $e8a49ad6d29ec67c$export$37170585f10dec80({ delta: delta, className: className }) {
    if (delta === null || !Number.isFinite(delta)) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: (0, $9QePP.default)("body-s subdued", className),
        children: "-"
    });
    const changePercent = delta * 100 || 0;
    const isPositive = delta > 0;
    const isNegative = delta < 0;
    const isNeutral = delta === 0;
    const formattedPercent = changePercent.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: (0, $9QePP.default)("body-s flex items-center gap-1", isPositive && "text-green-400", isNegative && "text-red-400", isNeutral && "text-gray-400", className),
        children: [
            formattedPercent,
            "%",
            isPositive && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3b81e5eb98e77539$export$2e2bcd8739ae039), {
                className: "size-4 fill-green-400"
            }),
            isNegative && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9dEbd.default), {
                className: "size-4 fill-red-400"
            }),
            isNeutral && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $449758aadd79f00e$export$2e2bcd8739ae039), {
                className: "size-4 stroke-gray-400"
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");
function $c6621b5b97e553aa$var$CalendarDaysIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
    }));
}
const $c6621b5b97e553aa$var$ForwardRef = $acw62.forwardRef($c6621b5b97e553aa$var$CalendarDaysIcon);
var $c6621b5b97e553aa$export$2e2bcd8739ae039 = $c6621b5b97e553aa$var$ForwardRef;



var $7gcOJ = parcelRequire("7gcOJ");

var $ayMG0 = parcelRequire("ayMG0");

var $j46bT = parcelRequire("j46bT");

var $acw62 = parcelRequire("acw62");
function $5f7cc04a2cba0193$export$dbdcde5ca046596e({ children: children, trigger: trigger }) {
    const [isVisible, setIsVisible] = (0, $acw62.useState)(false);
    const [position, setPosition] = (0, $acw62.useState)({
        top: -9999,
        left: -9999
    });
    const triggerRef = (0, $acw62.useRef)(null);
    const tooltipRef = (0, $acw62.useRef)(null);
    const calculatePosition = (0, $acw62.useCallback)(()=>{
        if (!triggerRef.current || !tooltipRef.current) return;
        const triggerRect = triggerRef.current.getBoundingClientRect();
        const tooltipRect = tooltipRef.current.getBoundingClientRect();
        const tooltipWidth = tooltipRect.width || 320;
        const tooltipHeight = tooltipRect.height || 150;
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const centeredLeft = triggerRect.left + triggerRect.width / 2 - tooltipWidth / 2;
        const clampedLeft = Math.max(8, Math.min(centeredLeft, viewportWidth - tooltipWidth - 8));
        const defaultTop = triggerRect.bottom + 8;
        const wouldOverflowBottom = defaultTop + tooltipHeight > viewportHeight;
        const finalTop = wouldOverflowBottom ? triggerRect.top - tooltipHeight - 8 : defaultTop;
        setPosition({
            top: finalTop,
            left: clampedLeft
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!isVisible) return;
        const frameId = requestAnimationFrame(()=>{
            calculatePosition();
        });
        return ()=>{
            cancelAnimationFrame(frameId);
        };
    }, [
        isVisible,
        calculatePosition
    ]);
    const handleMouseEnter = (0, $acw62.useCallback)(()=>{
        setIsVisible(true);
    }, []);
    const handleMouseLeave = (0, $acw62.useCallback)(()=>{
        setIsVisible(false);
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: triggerRef,
        className: "tt-trigger group",
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: [
            trigger || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j46bT.default), {
                className: "size-4 fill-gray-500"
            }),
            isVisible && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: tooltipRef,
                className: "tt-container !fixed z-[1000]",
                style: {
                    top: `${position.top}px`,
                    left: `${position.left}px`
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "tt w-80",
                    children: children
                })
            })
        ]
    });
}


var $c6c3d2606e6cb499$export$464989a30bad0982;
(function(PeriodKind) {
    PeriodKind["LTM"] = "LTM";
    PeriodKind["NTM"] = "NTM";
    PeriodKind["LAST_CLOSED_MONTH"] = "Last Closed Month";
})($c6c3d2606e6cb499$export$464989a30bad0982 || ($c6c3d2606e6cb499$export$464989a30bad0982 = {}));
const $c6c3d2606e6cb499$var$PERIOD_DESCRIPTIONS = {
    ["LTM"]: "Data is as of the last twelve months.",
    ["NTM"]: "Data is as of the next twelve months.",
    ["Last Closed Month"]: "Balance Sheet data is surfaced as of the last closed calendar month."
};
function $c6c3d2606e6cb499$export$208f774c0f9d0c93({ title: title, data: data, className: className, icon: icon, href: href, asOfDate: asOfDate, isLoading: isLoading = false, periodKind: periodKind }) {
    const flags = (0, $7gcOJ.useFlags)();
    const showM05 = flags.enabled("show-im-m05");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("w-full", className),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "heading-m mb-3",
                        children: title
                    }),
                    periodKind && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "tt-trigger group",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6621b5b97e553aa$export$2e2bcd8739ae039), {
                                className: "size-4 stroke-gray-400"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-micro text-gray-400",
                                children: periodKind
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "tt-container tt-bottom-custom",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tt w-48",
                                    children: $c6c3d2606e6cb499$var$PERIOD_DESCRIPTIONS[periodKind]
                                })
                            })
                        ]
                    })
                ]
            }),
            asOfDate && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("mb-3 mt-2", "body-s flex items-center gap-1"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "subdued italic",
                        children: [
                            "Data as of ",
                            asOfDate
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5f7cc04a2cba0193$export$dbdcde5ca046596e), {
                        children: "The data displayed is from the last closed, complete calendar period available in the company's accounting system. Hum does not display partial period data."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("grid grid-cols-1", "gap-0 overflow-hidden", "sm:grid-cols-2 sm:gap-x-4"),
                children: data.map((row, index)=>{
                    const rowInGrid = Math.floor(index / 2);
                    const isEvenRow = rowInGrid % 2 === 0;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: (0, $9QePP.default)("flex items-center justify-between gap-4 border-x border-slate-700 px-4 py-3", isEvenRow ? "bg-[#2E3849]" : "bg-[#353E4F]", row.onClick && "cursor-pointer hover:opacity-90", index === 0 && "rounded-t border-x border-t border-slate-700", index === 1 && "border-x border-t border-slate-700 sm:rounded-t", index === data.length - 1 && "rounded-b border-x border-b border-slate-700", index === data.length - 2 && "border-x border-b border-slate-700 sm:rounded-b"),
                        onClick: row.onClick,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: (0, $9QePP.default)("heading-s cursor-pointer break-words", row.delta !== undefined && showM05 ? "w-1/3" : "w-1/2"),
                                children: row.label
                            }),
                            href && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: (0, $9QePP.default)("group flex items-start gap-2", row.delta !== undefined && showM05 ? "w-1/3" : "w-1/2"),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: href,
                                        className: "text-link break-words",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: row.value
                                    }),
                                    icon && icon
                                ]
                            }),
                            !href && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: (0, $9QePP.default)("flex flex-col items-start", row.delta !== undefined && showM05 ? "w-1/3" : "w-1/2"),
                                children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: (0, $9QePP.default)("h-3 w-16 bg-slate-700", "animate-pulse rounded")
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        typeof row.value === "string" ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "body-s cursor-pointer text-left",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35aceb44e08862e6$export$3d2710274f64e897), {
                                                text: row.value,
                                                maxLength: 200,
                                                className: (0, $9QePP.default)(row.value === (0, $dKUtl.COMING_SOON) && "text-disabled", "cursor-pointer", row.valueClassName)
                                            })
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: (0, $9QePP.default)("body-s break-words text-left", row.valueClassName),
                                            children: row.value
                                        }),
                                        row.source && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: (0, $9QePP.default)("break-all text-right text-[9px] tracking-wide", row.sourceClassName),
                                            children: row.source
                                        })
                                    ]
                                })
                            }),
                            row.delta !== undefined && showM05 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex w-1/3 items-end justify-end",
                                children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: (0, $9QePP.default)("h-3 w-12 bg-slate-700", "animate-pulse rounded")
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8a49ad6d29ec67c$export$37170585f10dec80), {
                                    delta: row.delta
                                })
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");
parcelRequire("UXGeS");
var $7Y7Q4 = parcelRequire("7Y7Q4");

var $lgOhz = parcelRequire("lgOhz");

var $kdwja = parcelRequire("kdwja");

var $62e6P = parcelRequire("62e6P");
parcelRequire("i5Lss");
var $kkxkw = parcelRequire("kkxkw");
parcelRequire("iuVpE");
var $bxdbx = parcelRequire("bxdbx");

var $9O2q1 = parcelRequire("9O2q1");
var $eb67e7ba0742cb25$export$bfafd28a577531fc;
(function(FinanceLabStatus) {
    FinanceLabStatus["Running"] = "RUNNING";
    FinanceLabStatus["Pending"] = "PENDING";
    FinanceLabStatus["Started"] = "STARTED";
    FinanceLabStatus["Success"] = "SUCCESS";
    FinanceLabStatus["Failure"] = "FAILURE";
})($eb67e7ba0742cb25$export$bfafd28a577531fc || ($eb67e7ba0742cb25$export$bfafd28a577531fc = {}));
var $eb67e7ba0742cb25$export$6641c87b6affeb22;
(function(CapitalProductType) {
    CapitalProductType["EQUITY"] = "equity";
    CapitalProductType["VENTURE_DEBT"] = "venture_debt";
    CapitalProductType["CASHFLOW_DEBT"] = "cashflow_debt";
    CapitalProductType["ABL"] = "abl";
    CapitalProductType["FACTORING"] = "factoring";
    CapitalProductType["PO_FINANCING"] = "po_financing";
    CapitalProductType["SPECIALTY_FINANCE"] = "specialty_finance";
    CapitalProductType["GROWTH_DEBT"] = "growth_debt";
    CapitalProductType["MCA"] = "mca";
})($eb67e7ba0742cb25$export$6641c87b6affeb22 || ($eb67e7ba0742cb25$export$6641c87b6affeb22 = {}));
const $eb67e7ba0742cb25$export$ddc9924e09003c33 = {
    ["equity"]: "Equity",
    ["venture_debt"]: "Venture Debt",
    ["cashflow_debt"]: "Cashflow Debt",
    ["abl"]: "ABL",
    ["factoring"]: "Factoring",
    ["po_financing"]: "PO Financing",
    ["specialty_finance"]: "Specialty Finance",
    ["growth_debt"]: "Growth Debt",
    ["mca"]: "MCA"
};
var $eb67e7ba0742cb25$export$44c95d3770756ed2;
(function(Frequency) {
    Frequency["DAILY"] = "D";
    Frequency["WEEKLY"] = "W";
    Frequency["MONTHLY"] = "M";
    Frequency["QUARTERLY"] = "Q";
    Frequency["HALF_YEARLY"] = "6M";
    Frequency["YEARLY"] = "Y";
    Frequency["UNKNOWN"] = "U";
})($eb67e7ba0742cb25$export$44c95d3770756ed2 || ($eb67e7ba0742cb25$export$44c95d3770756ed2 = {}));
const $eb67e7ba0742cb25$export$c1f285b1fd79b54e = {
    ["D"]: "Daily",
    ["W"]: "Weekly",
    ["M"]: "Monthly",
    ["Q"]: "Quarterly",
    ["6M"]: "Semi-Annually",
    ["Y"]: "Annually",
    ["U"]: "Unknown"
};
var $eb67e7ba0742cb25$export$c5b1d99d27e4978d;
(function(FinanceLabField) {
    FinanceLabField["DEAL_CHECK_SIZE"] = "deal.check_size";
    FinanceLabField["ORGANIZATION_HEADQUARTERS"] = "organization.headquarters";
    FinanceLabField["ORGANIZATION_HEADCOUNT"] = "organization.headcount";
    FinanceLabField["ORGANIZATION_INDUSTRY"] = "organization.industry";
    FinanceLabField["ORGANIZATION_URLS_WEBSITE"] = "organization.urls.website";
    FinanceLabField["ORGANIZATION_LEGAL_NAME"] = "organization.legal_name";
    FinanceLabField["ORGANIZATION_ABOUT"] = "organization.about";
    FinanceLabField["ORGANIZATION_REVENUE_MODEL"] = "organization.revenue_model";
    FinanceLabField["ORGANIZATION_NAICS"] = "organization.naics";
    FinanceLabField["ORGANIZATION_CRM_ACCOUNT_ID"] = "organization.crm_account_id";
    FinanceLabField["ORGANIZATION_CRM_OPPORTUNITY_ID"] = "organization.crm_opportunity_id";
    FinanceLabField["ORGANIZATION_CRM_OPPORTUNITY_NAME"] = "organization.crm_opportunity_name";
    FinanceLabField["ORGANIZATION_ICM_ID"] = "organization.icm_id";
    FinanceLabField["ORGANIZATION_DUNS_NUMBER"] = "organization.duns_number";
    FinanceLabField["ORGANIZATION_BACKGROUND_CHECK"] = "organization.background_check";
    FinanceLabField["DEAL_TRANSACTION_SUMMARY"] = "deal.transaction_summary";
    FinanceLabField["DEAL_CAPITAL_PRODUCT"] = "deal.capital_product";
    FinanceLabField["DEAL_MATCHING_INVESTMENT_STRATEGIES_SUMMARY"] = "deal.matching_investment_strategies.summary";
    FinanceLabField["DEAL_INITIAL_DISBURSEMENT"] = "deal.initial_disbursement";
    FinanceLabField["DEAL_TERM"] = "deal.term";
    FinanceLabField["DEAL_CURRENT_PAY_TYPE"] = "deal.current_pay_type";
    FinanceLabField["DEAL_CURRENT_PAY_P"] = "deal.current_pay_p";
    FinanceLabField["DEAL_UP_FRONT_FEE"] = "deal.up_front_fee";
    FinanceLabField["DEAL_BROKER_FEE"] = "deal.broker_fee";
    FinanceLabField["DEAL_MOIC"] = "deal.moic";
    FinanceLabField["DEAL_IRR"] = "deal.irr";
    FinanceLabField["DEAL_CURRENT_PAY_CASH_P"] = "deal.current_pay_cash_p";
    FinanceLabField["DEAL_MONITORING_FEE"] = "deal.monitoring_fee";
    FinanceLabField["DEAL_LEGAL_FEES"] = "deal.legal_fees";
    FinanceLabField["DEAL_COMMITMENT_FEE"] = "deal.commitment_fee";
    FinanceLabField["DEAL_PREPAYMENT_PENALTY"] = "deal.prepayment_penalty";
    FinanceLabField["DEAL_RECURRING_PAYMENT"] = "deal.recurring_payment";
    FinanceLabField["DEAL_SECURITY_PACKAGE"] = "deal.security_package";
    FinanceLabField["DEAL_CLOSE_DATE_TARGET"] = "deal.close_date.target";
    FinanceLabField["DEAL_CLOSE_DATE"] = "deal.close_date";
    FinanceLabField["DEAL_FUNDED_DATED"] = "deal.funded_dated";
    FinanceLabField["DEAL_OPERATIONAL_CONTROLS"] = "deal.operational_controls";
    FinanceLabField["DEAL_COLLECTIONS"] = "deal.collections";
    FinanceLabField["DEAL_DISBURSEMENTS"] = "deal.disbursements";
    FinanceLabField["DEAL_COVENANTS_SUMMARY"] = "deal.covenants.summary";
    FinanceLabField["DEAL_MATERIAL_LEGAL_TERMS"] = "deal.material_legal_terms";
    FinanceLabField["DEAL_USE_OF_PROCEEDS"] = "deal.use_of_proceeds";
    FinanceLabField["DEAL_CONDITIONS_PRECEDENT_TO_CLOSING"] = "deal.conditions_precedent_to_closing";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_TOTAL_REVENUE"] = "organization.financial_data.total_revenue";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_GROSS_MARGIN_P"] = "organization.financial_data.gross_margin_p";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_EBITDA"] = "organization.financial_data.ebitda";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_EBITDA_MARGIN_P"] = "organization.financial_data.ebitda_margin_p";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_CASH"] = "organization.financial_data.cash";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_SALES_AND_MARKETING_EFFICIENCY"] = "organization.financial_data.sales_and_marketing_efficiency";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_NET_INCOME"] = "organization.financial_data.net_income";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_NET_INCOME_MARGIN_P"] = "organization.financial_data.net_income_margin_p";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS"] = "organization.financial_data.total_assets";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_TOTAL_LIABILITIES"] = "organization.financial_data.total_liabilities";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_JUNIOR_DEBT_BALANCE_AVG"] = "organization.financial_data.debt.junior.balance_avg";
    FinanceLabField["DEAL_INVESTMENT_RATIONALE"] = "deal.investment_rationale";
    FinanceLabField["DEAL_RISKS_SUMMARY"] = "deal.risks.summary";
    FinanceLabField["ORGANIZATION_ENTITY_STRUCTURE_LIEN_SEARCH_SUMMARY"] = "organization.entity_structure.lien_search.summary";
    FinanceLabField["ORGANIZATION_TEAM_KEY_PEOPLE_BACKGROUND_CHECK_SUMMARY"] = "organization.team.key_people.background_check.summary";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_HISTORICAL_NET_INCOME_TABLE_L3YTTM"] = "organization.financial_data.historical_net_income_table_l3yttm";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_TOTAL_EQUITY_RAISED"] = "organization.financial_data.total_equity_raised";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_SENIOR_DEBT_BALANCE_AVG"] = "organization.financial_data.debt.senior.balance_avg";
    FinanceLabField["DEAL_CREDIT_COVERAGE"] = "deal.credit_coverage";
    FinanceLabField["DEAL_LEVERAGE"] = "deal.leverage";
    FinanceLabField["DEAL_INTEREST_COVERAGE"] = "deal.interest_coverage";
    FinanceLabField["DEAL_GROSS_DEBT_TO_ASSETS"] = "deal.gross_debt_to_assets";
    FinanceLabField["DEAL_GROSS_DEBT_TO_EBITDA"] = "deal.gross_debt_to_ebitda";
    FinanceLabField["DEAL_FCCR"] = "deal.fccr";
    FinanceLabField["DEAL_DSCR"] = "deal.dscr";
    FinanceLabField["DEAL_DEBT_TO_EQUITY"] = "deal.debt_to_equity";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS_TO_EQUITY"] = "organization.financial_data.total_assets_to_equity";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_CASH_BURN_MONTHLY"] = "organization.financial_data.cash_burn.monthly";
    FinanceLabField["DEAL_SOURCES_AND_USES"] = "deal.sources_and_uses";
    FinanceLabField["ORGANIZATION_ENTITY_STRUCTURE_DIAGRAM"] = "organization.entity_structure.diagram";
    FinanceLabField["ORGANIZATION_CUSTOMERS_TOP_5"] = "organization.customers.top_5";
    FinanceLabField["ORGANIZATION_COMPETITORS_TOP_5"] = "organization.competitors.top_5";
    FinanceLabField["ORGANIZATION_SUPPLIERS_TOP_5"] = "organization.suppliers.top_5";
    FinanceLabField["ORGANIZATION_DATA_STATUS_TABLE"] = "organization.data_status.table";
    FinanceLabField["ORGANIZATION_CAPITAL_STRUCTURE_CAP_TABLE_SUMMARY"] = "organization.capital_structure.cap_table.summary";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_VALUATION"] = "organization.financial_data.valuation";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_TOTAL_REVENUE"] = "organization.financial_data.projections.hum_base_case.total_revenue";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_GROSS_MARGIN_P"] = "organization.financial_data.projections.hum_base_case.gross_margin_p";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_EBITDA"] = "organization.financial_data.projections.hum_base_case.ebitda";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_EBITDA_MARGIN_P"] = "organization.financial_data.projections.hum_base_case.ebitda_margin_p";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_CASH"] = "organization.financial_data.projections.hum_base_case.cash";
    FinanceLabField["ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_SALES_AND_MARKETING_EFFICIENCY"] = "organization.financial_data.projections.hum_base_case.sales_and_marketing_efficiency";
    FinanceLabField["DEAL_REPAYMENT_FREQUENCY"] = "deal.repayment_frequency";
    FinanceLabField["DEAL_CRM_OPPORTUNITY_ID"] = "deal.crm_opportunity_id";
    FinanceLabField["DEAL_CRM_OPPORTUNITY_NAME"] = "deal.crm_opportunity_name";
})($eb67e7ba0742cb25$export$c5b1d99d27e4978d || ($eb67e7ba0742cb25$export$c5b1d99d27e4978d = {}));
var $eb67e7ba0742cb25$export$b570835b381015d3;
(function(FinanceLabFieldType) {
    FinanceLabFieldType["CURRENCY"] = "Currency";
    FinanceLabFieldType["STRING"] = "String";
    FinanceLabFieldType["PERCENTAGE"] = "Percentage";
    FinanceLabFieldType["RATIO"] = "Ratio";
    FinanceLabFieldType["MULTIPLE"] = "Multiple";
    FinanceLabFieldType["DATE"] = "Date";
    FinanceLabFieldType["BOOLEAN"] = "Boolean";
    FinanceLabFieldType["INTEGER"] = "Integer";
    FinanceLabFieldType["PERIOD"] = "Period";
})($eb67e7ba0742cb25$export$b570835b381015d3 || ($eb67e7ba0742cb25$export$b570835b381015d3 = {}));
var $eb67e7ba0742cb25$export$f8f06d0783412536;
(function(ResampleTransform) {
    ResampleTransform["YEARLY"] = "y";
    ResampleTransform["LAST_12_MONTHS"] = "l12m";
    ResampleTransform["MONTHLY_FROM_INCEPTION"] = "mfi";
    ResampleTransform["LAST_3_MONTHS_1_ORDER_OF_MAGNITUDE_FILTER_UNCLOSED_PERIODS"] = "l3m1omfup";
})($eb67e7ba0742cb25$export$f8f06d0783412536 || ($eb67e7ba0742cb25$export$f8f06d0783412536 = {}));



var $gngdn = parcelRequire("gngdn");

var $lHTSI = parcelRequire("lHTSI");
(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).extend((0, (/*@__PURE__*/$parcel$interopDefault($lHTSI))));
const $a2eab1b4aea8a761$export$3a080a70bebaaf4c = (value, fieldType)=>{
    if (value === null || value === undefined) return "-";
    if (!fieldType) return String(value);
    switch(fieldType){
        case (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY:
            return $a2eab1b4aea8a761$var$formatCurrency(value);
        case (0, $eb67e7ba0742cb25$export$b570835b381015d3).PERCENTAGE:
            return $a2eab1b4aea8a761$var$formatPercentage(value);
        case (0, $eb67e7ba0742cb25$export$b570835b381015d3).RATIO:
            return $a2eab1b4aea8a761$var$formatRatio(value);
        case (0, $eb67e7ba0742cb25$export$b570835b381015d3).MULTIPLE:
            return $a2eab1b4aea8a761$var$formatMultiple(value);
        case (0, $eb67e7ba0742cb25$export$b570835b381015d3).DATE:
            return $a2eab1b4aea8a761$var$formatDate(value);
        case (0, $eb67e7ba0742cb25$export$b570835b381015d3).BOOLEAN:
            return String(value);
        case (0, $eb67e7ba0742cb25$export$b570835b381015d3).INTEGER:
            return String(value);
        case (0, $eb67e7ba0742cb25$export$b570835b381015d3).PERIOD:
            return String(value);
        case (0, $eb67e7ba0742cb25$export$b570835b381015d3).STRING:
        default:
            return String(value);
    }
};
/**
 * Format currency: $1,234.56
 */ const $a2eab1b4aea8a761$var$formatCurrency = (value)=>{
    if (isNaN(value)) return "-";
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};
/**
 * Format percentage: 50.00% or 1,234.56%
 * Value is expected to be decimal (0.5 -> 50%)
 */ const $a2eab1b4aea8a761$var$formatPercentage = (value)=>{
    if (isNaN(value)) return "-";
    const percentValue = value * 100;
    const formattedNumber = percentValue.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    return `${formattedNumber}%`;
};
/**
 * Format ratio: 0.50
 */ const $a2eab1b4aea8a761$var$formatRatio = (value)=>{
    if (isNaN(value)) return "-";
    return value.toFixed(2);
};
/**
 * Format multiple: 2.30x
 */ const $a2eab1b4aea8a761$var$formatMultiple = (value)=>{
    if (isNaN(value)) return "-";
    return `${value.toFixed(2)}x`;
};
/**
 * Format date: mm/dd/yyyy -> Dec 10, 2025
 */ const $a2eab1b4aea8a761$var$formatDate = (value)=>{
    if (!value || value === "-" || value === "NaT") return "-";
    const parsedDate = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(value, "MM/DD/YYYY");
    if (!parsedDate.isValid()) return "-";
    return parsedDate.format("MMM D, YYYY");
};



var $gngdn = parcelRequire("gngdn");
const $3185906cbd4f0e83$export$796c6171a330b576 = ()=>{
    const now = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))();
    const twoMonthsAgo = now.subtract(2, "month");
    const lastDayOfMonth = twoMonthsAgo.endOf("month");
    return lastDayOfMonth.format("YYYY-MM-DD");
};


const $1cf2065342823807$var$parseMeta = (metaString)=>{
    try {
        return (0, $bxdbx.camelCased)(JSON.parse(metaString));
    } catch (error) {
        try {
            const jsonString = metaString.replace(/'/g, '"');
            return (0, $bxdbx.camelCased)(JSON.parse(jsonString));
        } catch  {
            return {};
        }
    }
};
const $1cf2065342823807$export$9813dd697f9dfeee = (0, $kkxkw.createQuery)(({ api: api, params: params })=>{
    return api.get(`/hum-finance-lab/v1/finance_fields/task_status/${params.taskId}`).then((res)=>{
        return {
            ...res,
            meta: $1cf2065342823807$var$parseMeta(res.meta)
        };
    });
});
const $1cf2065342823807$export$33bf4d4bd60a05b5 = (0, $kkxkw.createQuery)(async ({ api: api, params: params, router: router })=>{
    const toDate = params.to || (0, $3185906cbd4f0e83$export$796c6171a330b576)();
    const queryString = new (0, $9O2q1.QueryStringBuilder)().add("period_kind", params.periodKind).add("value_kind", "plain").add("resample_transform", params.resampleTransform).add("to_", toDate).add("from_", params.from);
    params.labels.forEach((label)=>{
        queryString.add("label", label);
    });
    const response = await api.get(`/hum-finance-lab/v1/companies/${router.params.companyId}/metrics?${queryString.build()}`);
    const metrics = response.data;
    if (!metrics || !Array.isArray(metrics)) return [];
    return metrics.map((metric)=>({
            ...metric,
            values: metric.values?.map((v)=>({
                    ...v,
                    formattedValue: (0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)(v.value, metric.description?.fieldType)
                })) || []
        }));
});


parcelRequire("i5Lss");
var $gBHSi = parcelRequire("gBHSi");
const $573977ae4b9a2e0b$export$b15994194b967fa9 = (0, $gBHSi.createMutation)(({ api: api, payload: payload })=>{
    return api.post(`/hum-finance-lab/v1/companies/${payload.companyId}/metrics/generate`);
});




parcelRequire("tL0U5");
var $4CoXh = parcelRequire("4CoXh");
var $ioTAq = parcelRequire("ioTAq");
var $7Y7Q4 = parcelRequire("7Y7Q4");



var $acw62 = parcelRequire("acw62");

var $eQbhf = parcelRequire("eQbhf");
parcelRequire("18L7n");
var $3oOMC = parcelRequire("3oOMC");
const $bcfccea9b862dce3$export$268736677778b952 = (params)=>{
    const [displayMessage, setDisplayMessage] = (0, $acw62.useState)("");
    const pollCountRef = (0, $acw62.useRef)(0);
    const { data: task, isPolling: isPolling, startPolling: startPolling, stopPolling: stopPolling, isError: isTaskError, queryClient: queryClient } = (0, $ioTAq.useApiPolling)((0, $1cf2065342823807$export$9813dd697f9dfeee), {
        onPollSuccess (data) {
            if (data?.meta?.displayMsg) {
                setDisplayMessage(data.meta.displayMsg);
                pollCountRef.current += 1;
                const duration = 5000 + pollCountRef.current * 1000;
                (0, $3oOMC.toast).updating("Refreshing memo...", {
                    description: data.meta.displayMsg,
                    duration: duration
                });
            }
            if (data?.state === (0, $eb67e7ba0742cb25$export$bfafd28a577531fc).Failure) {
                stopPolling();
                setDisplayMessage("");
                pollCountRef.current = 0;
                (0, $3oOMC.toast).error("Failed to generate metrics", {
                    description: "Please try again later"
                });
            }
            if (data?.state === (0, $eb67e7ba0742cb25$export$bfafd28a577531fc).Success) {
                stopPolling();
                setDisplayMessage("");
                pollCountRef.current = 0;
                queryClient?.invalidateQueries({
                    predicate: (query)=>{
                        const queryKey = query.queryKey;
                        return Array.isArray(queryKey) && queryKey.some((key)=>typeof key === "string" && key.includes("/hum-finance-lab/"));
                    }
                });
                (0, $3oOMC.toast).success("Refresh successful", {
                    description: "Check the Financial Highlights for the latest numbers"
                });
            }
        }
    });
    const { data: metricsQuery, isLoading: isLoadingMetrics } = (0, $7Y7Q4.useApiQuery)((0, $1cf2065342823807$export$33bf4d4bd60a05b5), {
        params: {
            labels: params?.labels || [],
            periodKind: params?.periodKind || (0, $eQbhf.PeriodKind).MONTHLY
        },
        enabled: task?.state === (0, $eb67e7ba0742cb25$export$bfafd28a577531fc).Success
    });
    const { mutate: generateMetrics, isError: isGenerateMetricsError } = (0, $4CoXh.useApiMutation)((0, $573977ae4b9a2e0b$export$b15994194b967fa9), {
        onSuccess (data) {
            if (data.taskId) {
                setDisplayMessage("");
                startPolling(data);
            }
        }
    });
    const isError = isTaskError || isGenerateMetricsError || task?.state === (0, $eb67e7ba0742cb25$export$bfafd28a577531fc).Failure;
    const isSuccess = task?.state === (0, $eb67e7ba0742cb25$export$bfafd28a577531fc).Success;
    const stopTask = (0, $acw62.useCallback)(()=>{
        stopPolling();
    }, [
        stopPolling
    ]);
    return {
        task: task,
        isPolling: isPolling,
        startGenerateMetrics: (payload)=>generateMetrics(payload),
        stopPolling: stopTask,
        isError: isError,
        isSuccess: isSuccess,
        displayMessage: displayMessage,
        metrics: metricsQuery,
        isLoadingMetrics: isLoadingMetrics
    };
};




parcelRequire("tL0U5");
var $7Y7Q4 = parcelRequire("7Y7Q4");

var $eQbhf = parcelRequire("eQbhf");
function $2a5011cb4beaeebb$export$be752fcf9917f653(values) {
    if (!values || values.length === 0) return null;
    const sortedValues = values.slice().sort((a, b)=>a.period.localeCompare(b.period));
    const last12Months = sortedValues.slice(-12);
    const hasValidValue = last12Months.some((item)=>item.value !== null);
    if (!hasValidValue) return null;
    return last12Months.reduce((sum, item)=>sum + (item.value ?? 0), 0);
}
function $2a5011cb4beaeebb$export$67351c7e7093bcbe(values) {
    if (!values || values.length === 0) return null;
    const validValues = values.filter((item)=>item.value !== null && item.value !== "N/A" && item.value !== "nan" && item.value !== "NaT");
    if (validValues.length === 0) return null;
    return validValues[validValues.length - 1];
}
function $2a5011cb4beaeebb$export$491ead4a38ddd97e(values, targetDate = new Date()) {
    if (!values || values.length === 0) return null;
    if (targetDate instanceof Date && isNaN(targetDate.getTime())) return null;
    const validValues = values.filter((item)=>item.value !== null && item.value !== "N/A" && item.value !== "nan" && item.value !== "NaT");
    if (validValues.length === 0) return null;
    const targetYearMonth = targetDate instanceof Date ? (()=>{
        const year = targetDate.getFullYear();
        const month = String(targetDate.getMonth() + 1).padStart(2, "0");
        return `${year}-${month}`;
    })() : targetDate.substring(0, 7);
    const sortedValues = validValues.slice().sort((a, b)=>a.period.localeCompare(b.period));
    const closestValue = sortedValues.filter((item)=>item.period <= targetYearMonth).pop();
    return closestValue ?? null;
}


function $3f300ca0a42da99b$export$b098577f8da2a3b3() {
    const metrics = (0, $7Y7Q4.useApiQuery)((0, $1cf2065342823807$export$33bf4d4bd60a05b5), {
        params: {
            labels: [
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_REVENUE,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_EBITDA,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_CASH,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_LIABILITIES,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_NET_INCOME
            ],
            periodKind: (0, $eQbhf.PeriodKind).MONTHLY
        }
    });
    const ltmMetrics = (0, $7Y7Q4.useApiQuery)((0, $1cf2065342823807$export$33bf4d4bd60a05b5), {
        params: {
            labels: [
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_REVENUE,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_EBITDA,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_NET_INCOME,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_SALES_AND_MARKETING_EFFICIENCY
            ],
            resampleTransform: (0, $eb67e7ba0742cb25$export$f8f06d0783412536).LAST_12_MONTHS
        }
    });
    const revenueValues = ltmMetrics.data?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_REVENUE)?.values;
    const ebitdaValues = ltmMetrics.data?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_EBITDA)?.values;
    const salesAndMarketingEfficiencyValues = ltmMetrics.data?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_SALES_AND_MARKETING_EFFICIENCY)?.values;
    const cashValues = metrics.data?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_CASH)?.values;
    const totalAssetsValues = metrics.data?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS)?.values;
    const totalLiabilitiesValues = metrics.data?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_LIABILITIES)?.values;
    const netIncomeValues = ltmMetrics.data?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_NET_INCOME)?.values;
    return {
        revenue: (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(revenueValues)?.formattedValue || "-",
        ebitda: (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(ebitdaValues)?.formattedValue || "-",
        cash: (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(cashValues)?.formattedValue || "-",
        totalAssets: (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(totalAssetsValues)?.formattedValue || "-",
        totalLiabilities: (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(totalLiabilitiesValues)?.formattedValue || "-",
        netIncome: (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(netIncomeValues)?.formattedValue || "-",
        salesAndMarketingEfficiency: (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(salesAndMarketingEfficiencyValues)?.formattedValue || "-",
        revenueValues: revenueValues,
        ebitdaValues: ebitdaValues,
        cashValues: cashValues,
        totalAssetsValues: totalAssetsValues,
        totalLiabilitiesValues: totalLiabilitiesValues,
        netIncomeValues: netIncomeValues,
        metrics: [
            ...metrics.data ?? [],
            ...ltmMetrics.data ?? []
        ],
        isLoading: metrics.isLoading || ltmMetrics.isLoading,
        isError: metrics.isError || ltmMetrics.isError
    };
}


parcelRequire("tL0U5");
var $7Y7Q4 = parcelRequire("7Y7Q4");



var $acw62 = parcelRequire("acw62");

function $ab8c2bcf66cd554c$export$1c084b291917c13a() {
    const [generationBuffer, setGenerationBuffer] = (0, $acw62.useState)(undefined);
    const { data: data, isLoading: isLoading, isError: isError } = (0, $7Y7Q4.useApiQuery)((0, $1cf2065342823807$export$33bf4d4bd60a05b5), {
        params: {
            labels: [
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_ABOUT
            ]
        }
    });
    const aboutMetric = data?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_ABOUT)?.values;
    const aboutText = (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(aboutMetric)?.formattedValue || (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(aboutMetric)?.value.toString() || "-";
    const clearBuffer = (0, $acw62.useCallback)(()=>{
        setGenerationBuffer(undefined);
    }, []);
    return {
        aboutText: aboutText,
        generationBuffer: generationBuffer,
        isLoading: isLoading || false,
        isError: isError,
        clearBuffer: clearBuffer
    };
}






var $dKUtl = parcelRequire("dKUtl");

var $r2uF6 = parcelRequire("r2uF6");

var $7gcOJ = parcelRequire("7gcOJ");



function $e667c4961b5d739b$export$f3830df9ca88c6d3({ opportunityId: opportunityId } = {}) {
    const flags = (0, $7gcOJ.useFlags)();
    const showComingSoon = flags.enabled("show-coming-soon-placeholders");
    const showPreAlphaFields = flags.enabled("show-pre-alpha-fields");
    const setAIMContextView = (0, $r2uF6.useSetAtom)((0, $57f1ca4385a7301a$export$c65e5de3b3a2e247));
    const sfdcData = (0, $7Y7Q4.useApiQuery)((0, $lgOhz.getSFDCData));
    const data = opportunityId ? sfdcData.data?.find((data)=>data.id === opportunityId) : sfdcData.data?.[0];
    const currentYearMonth = (0, $acw62.useMemo)(()=>new Date().toISOString(), []);
    const previousYearMonth = (0, $acw62.useMemo)(()=>{
        const date = new Date();
        date.setFullYear(date.getFullYear() - 1);
        return date.toISOString();
    }, []);
    const { data: metrics, isLoading: isLoadingMetrics } = (0, $7Y7Q4.useApiQuery)((0, $1cf2065342823807$export$33bf4d4bd60a05b5), {
        params: {
            labels: [
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CAPITAL_PRODUCT,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_INITIAL_DISBURSEMENT,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_TERM,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CURRENT_PAY_P,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CURRENT_PAY_CASH_P,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CURRENT_PAY_TYPE,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_BROKER_FEE,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_MOIC,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_IRR,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_MONITORING_FEE,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_PREPAYMENT_PENALTY,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_LEGAL_FEES,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_RECURRING_PAYMENT,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_REPAYMENT_FREQUENCY,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_SECURITY_PACKAGE,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_FUNDED_DATED,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_USE_OF_PROCEEDS,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_OPERATIONAL_CONTROLS,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CLOSE_DATE,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_COVENANTS_SUMMARY
            ],
            from: previousYearMonth,
            to: currentYearMonth
        }
    });
    const { data: mfiMetrics, isLoading: isLoadingMfiMetrics } = (0, $7Y7Q4.useApiQuery)((0, $1cf2065342823807$export$33bf4d4bd60a05b5), {
        params: {
            labels: [
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_COLLECTIONS,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_DISBURSEMENTS
            ],
            resampleTransform: (0, $eb67e7ba0742cb25$export$f8f06d0783412536).MONTHLY_FROM_INCEPTION
        }
    });
    const handleMetricClick = (financeLabField, title)=>{
        const metric = [
            ...metrics ?? [],
            ...mfiMetrics ?? []
        ]?.find((m)=>m.info.derived.label === financeLabField);
        setAIMContextView({
            type: (0, $0e9c1faaf8e0eb7e$export$88fa5c7cfbd4d210).VALUE_LINEAGE,
            metric: metric || null,
            period: "current",
            title: title,
            isExpanded: true
        });
    };
    const capitalProductValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CAPITAL_PRODUCT)?.values;
    const initialDisbursementValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_INITIAL_DISBURSEMENT)?.values;
    const termValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_TERM)?.values;
    const currentPayPValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CURRENT_PAY_P)?.values;
    const repaymentFrequencyValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_REPAYMENT_FREQUENCY)?.values;
    const currentPayTypeValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CURRENT_PAY_TYPE)?.values;
    const brokerFeeValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_BROKER_FEE)?.values;
    const moicValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_MOIC)?.values;
    const irrValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_IRR)?.values;
    const monitoringFeeValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_MONITORING_FEE)?.values;
    const prepaymentPenaltyValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_PREPAYMENT_PENALTY)?.values;
    const legalFeesValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_LEGAL_FEES)?.values;
    const recurringPaymentValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_RECURRING_PAYMENT)?.values;
    const fundedDatedValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_FUNDED_DATED)?.values;
    const collectionsValues = mfiMetrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_COLLECTIONS)?.values;
    const disbursementsValues = mfiMetrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_DISBURSEMENTS)?.values;
    const closeDateValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CLOSE_DATE)?.values;
    const cashYieldValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CURRENT_PAY_CASH_P)?.values;
    const covenantsSummaryValues = metrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_COVENANTS_SUMMARY)?.values;
    const capitalProductRaw = (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(capitalProductValues);
    const capitalTypeColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(capitalProductRaw?.value ?? capitalProductRaw?.formattedValue ?? "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CAPITAL_PRODUCT);
    const facilitySizeColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $kdwja.longFormMoney)(data?.totalFacilitySize), (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).SFDC, "sfdc.totalFacilitySize");
    const initialAdvanceColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(initialDisbursementValues)?.formattedValue || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_INITIAL_DISBURSEMENT);
    const termValue = (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(termValues);
    const facilityTermColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(termValue?.value ? `${termValue.value} months` : undefined, (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_TERM);
    const productData = [
        {
            label: "Capital Type",
            value: capitalTypeColorized.value,
            valueClassName: capitalTypeColorized.className,
            source: capitalTypeColorized.source,
            sourceClassName: capitalTypeColorized.sourceClassName,
            onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CAPITAL_PRODUCT, "Capital Type")
        },
        {
            label: "Initial Advance",
            value: initialAdvanceColorized.value,
            valueClassName: initialAdvanceColorized.className,
            source: initialAdvanceColorized.source,
            sourceClassName: initialAdvanceColorized.sourceClassName,
            onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_INITIAL_DISBURSEMENT, "Initial Advance")
        },
        {
            label: "Facility Size",
            value: facilitySizeColorized.value,
            valueClassName: facilitySizeColorized.className,
            source: facilitySizeColorized.source,
            sourceClassName: facilitySizeColorized.sourceClassName
        },
        ...showPreAlphaFields ? [
            {
                label: "Facility Term",
                value: facilityTermColorized.value,
                valueClassName: facilityTermColorized.className,
                source: facilityTermColorized.source,
                sourceClassName: facilityTermColorized.sourceClassName,
                onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_TERM, "Facility Term")
            }
        ] : []
    ];
    const interestRateColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(currentPayPValues)?.formattedValue || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CURRENT_PAY_P);
    const originationFeeColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $kdwja.longFormMoney)(data?.originationFees), (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).SFDC, "sfdc.originationFees");
    const moicColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(moicValues)?.formattedValue || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_MOIC);
    const cashYieldColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(cashYieldValues)?.formattedValue || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CURRENT_PAY_CASH_P);
    const legalFeesColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(legalFeesValues)?.formattedValue || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_LEGAL_FEES);
    const feeTypeColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(currentPayTypeValues)?.formattedValue || (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(currentPayTypeValues)?.value || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CURRENT_PAY_TYPE);
    const brokerFeeColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(brokerFeeValues)?.formattedValue || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_BROKER_FEE);
    const irrColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$491ead4a38ddd97e)(irrValues)?.formattedValue || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_IRR);
    const monitoringFeeColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(monitoringFeeValues)?.formattedValue || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_MONITORING_FEE);
    const prepaymentPenaltyColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(prepaymentPenaltyValues)?.formattedValue || (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(prepaymentPenaltyValues)?.value || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_PREPAYMENT_PENALTY);
    const recurringPaymentRaw = (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(recurringPaymentValues);
    const recurringPaymentValue = recurringPaymentRaw?.formattedValue || recurringPaymentRaw?.value || "-";
    // Extract only the value before parentheses for display
    const recurringPaymentDisplay = typeof recurringPaymentValue === "string" && recurringPaymentValue.includes("(") ? recurringPaymentValue.split("(")[0].trim() : recurringPaymentValue;
    const monthlyPaymentColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(recurringPaymentDisplay, (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_RECURRING_PAYMENT);
    const repaymentFrequencyRaw = (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(repaymentFrequencyValues);
    const repaymentFrequencyLabel = repaymentFrequencyRaw?.value && typeof repaymentFrequencyRaw.value === "string" ? (0, $eb67e7ba0742cb25$export$c1f285b1fd79b54e)[repaymentFrequencyRaw.value] : undefined;
    const repaymentFrequencyColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(repaymentFrequencyLabel ?? repaymentFrequencyRaw?.formattedValue ?? repaymentFrequencyRaw?.value ?? "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_REPAYMENT_FREQUENCY);
    const targetCloseDateColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(data?.closeDate ? (0, $kdwja.formatDate)(data.closeDate, {
        hideTime: true,
        parseAsUTC: false,
        dateFormat: "YYYY-MM-DD"
    }) : "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).SFDC, "sfdc.closeDate");
    const actualFundingDateColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(fundedDatedValues)?.formattedValue || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_FUNDED_DATED);
    const collectionsColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(collectionsValues)?.formattedValue || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_COLLECTIONS);
    const actualCloseDateColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(closeDateValues)?.formattedValue || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CLOSE_DATE);
    const advancesColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(disbursementsValues)?.formattedValue || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_DISBURSEMENTS);
    const useOfProceedsColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $62e6P.USE_OF_FUNDS)[data?.useOfProceeds], (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).SFDC, "sfdc.useOfProceeds");
    const covenantsColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(covenantsSummaryValues)?.formattedValue || (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(covenantsSummaryValues)?.value || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_COVENANTS_SUMMARY);
    const economicsData = [
        ...showPreAlphaFields ? [
            {
                label: "Fee Type",
                value: feeTypeColorized.value,
                valueClassName: feeTypeColorized.className,
                source: feeTypeColorized.source,
                sourceClassName: feeTypeColorized.sourceClassName,
                onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CURRENT_PAY_TYPE, "Fee Type")
            }
        ] : [],
        {
            label: "Referral Fee",
            value: brokerFeeColorized.value,
            valueClassName: brokerFeeColorized.className,
            source: brokerFeeColorized.source,
            sourceClassName: brokerFeeColorized.sourceClassName,
            onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_BROKER_FEE, "Referral Fee")
        },
        ...showPreAlphaFields ? [
            {
                label: "Interest Rate/Fee",
                value: interestRateColorized.value,
                valueClassName: interestRateColorized.className,
                source: interestRateColorized.source,
                sourceClassName: interestRateColorized.sourceClassName,
                onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CURRENT_PAY_P, "Interest Rate/Fee")
            },
            {
                label: "Prepayment Penalty",
                value: prepaymentPenaltyColorized.value,
                valueClassName: prepaymentPenaltyColorized.className,
                source: prepaymentPenaltyColorized.source,
                sourceClassName: prepaymentPenaltyColorized.sourceClassName,
                onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_PREPAYMENT_PENALTY, "Prepayment Penalty")
            }
        ] : [],
        {
            label: "Origination Fee",
            value: originationFeeColorized.value,
            valueClassName: originationFeeColorized.className,
            source: originationFeeColorized.source,
            sourceClassName: originationFeeColorized.sourceClassName
        },
        {
            label: "Cash Yield",
            value: cashYieldColorized.value,
            valueClassName: cashYieldColorized.className,
            source: cashYieldColorized.source,
            sourceClassName: cashYieldColorized.sourceClassName,
            onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CURRENT_PAY_CASH_P, "Cash Yield")
        },
        ...showPreAlphaFields ? [
            {
                label: "Monitoring Fee",
                value: monitoringFeeColorized.value,
                valueClassName: monitoringFeeColorized.className,
                source: monitoringFeeColorized.source,
                sourceClassName: monitoringFeeColorized.sourceClassName,
                onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_MONITORING_FEE, "Monitoring Fee")
            },
            {
                label: "MOIC",
                value: moicColorized.value,
                valueClassName: moicColorized.className,
                source: moicColorized.source,
                sourceClassName: moicColorized.sourceClassName,
                onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_MOIC, "MOIC")
            },
            {
                label: "Legal Fees",
                value: legalFeesColorized.value,
                valueClassName: legalFeesColorized.className,
                source: legalFeesColorized.source,
                sourceClassName: legalFeesColorized.sourceClassName,
                onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_LEGAL_FEES, "Legal Fees")
            },
            {
                label: "IRR",
                value: irrColorized.value,
                valueClassName: irrColorized.className,
                source: irrColorized.source,
                sourceClassName: irrColorized.sourceClassName,
                onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_IRR, "IRR")
            }
        ] : []
    ];
    const termsConditionsData = [
        {
            label: "Target Close Date",
            value: targetCloseDateColorized.value,
            valueClassName: targetCloseDateColorized.className,
            source: targetCloseDateColorized.source,
            sourceClassName: targetCloseDateColorized.sourceClassName
        },
        {
            label: "Repayment Frequency",
            value: repaymentFrequencyColorized.value,
            valueClassName: repaymentFrequencyColorized.className,
            source: repaymentFrequencyColorized.source,
            sourceClassName: repaymentFrequencyColorized.sourceClassName,
            onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_REPAYMENT_FREQUENCY, "Repayment Frequency")
        },
        {
            label: "Actual Close Date",
            value: actualCloseDateColorized.value,
            valueClassName: actualCloseDateColorized.className,
            source: actualCloseDateColorized.source,
            sourceClassName: actualCloseDateColorized.sourceClassName,
            onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CLOSE_DATE, "Actual Close Date")
        },
        {
            label: "Total Advanced To Date",
            value: advancesColorized.value,
            valueClassName: advancesColorized.className,
            source: advancesColorized.source,
            sourceClassName: advancesColorized.sourceClassName,
            onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_DISBURSEMENTS, "Total Advanced To Date")
        },
        {
            label: "Actual Funding Date",
            value: actualFundingDateColorized.value,
            valueClassName: actualFundingDateColorized.className,
            source: actualFundingDateColorized.source,
            sourceClassName: actualFundingDateColorized.sourceClassName,
            onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_FUNDED_DATED, "Actual Funding Date")
        },
        ...showComingSoon ? [
            {
                label: "Security",
                value: (0, $dKUtl.COMING_SOON)
            }
        ] : [],
        {
            label: "Collections To Date",
            value: collectionsColorized.value,
            valueClassName: collectionsColorized.className,
            source: collectionsColorized.source,
            sourceClassName: collectionsColorized.sourceClassName,
            onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_COLLECTIONS, "Collections To Date")
        },
        ...showComingSoon ? [
            {
                label: "Security Features",
                value: (0, $dKUtl.COMING_SOON)
            }
        ] : [],
        {
            label: "Repayment Amount",
            value: monthlyPaymentColorized.value,
            valueClassName: monthlyPaymentColorized.className,
            source: monthlyPaymentColorized.source,
            sourceClassName: monthlyPaymentColorized.sourceClassName,
            onClick: ()=>handleMetricClick((0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_RECURRING_PAYMENT, "Repayment Amount")
        },
        {
            label: "Use of Proceeds",
            value: useOfProceedsColorized.value,
            valueClassName: useOfProceedsColorized.className,
            source: useOfProceedsColorized.source,
            sourceClassName: useOfProceedsColorized.sourceClassName
        }
    ];
    return {
        productData: productData,
        economicsData: economicsData,
        termsConditionsData: termsConditionsData,
        covenantsSummaryValues: covenantsSummaryValues,
        covenantsColorized: covenantsColorized,
        isLoading: sfdcData.isLoading || isLoadingMetrics || isLoadingMfiMetrics,
        error: sfdcData.error
    };
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
function $f64a4ef9514b684d$var$ArrowDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"
    }));
}
const $f64a4ef9514b684d$var$ForwardRef = $acw62.forwardRef($f64a4ef9514b684d$var$ArrowDownIcon);
var $f64a4ef9514b684d$export$2e2bcd8739ae039 = $f64a4ef9514b684d$var$ForwardRef;



var $9QePP = parcelRequire("9QePP");

var $7gcOJ = parcelRequire("7gcOJ");
function $e5cbb248d749c652$export$6c0783fc6eb13aa1({ targetSection: targetSection, label: label }) {
    const flags = (0, $7gcOJ.useFlags)();
    const showDataSources = flags.enabled("show-coming-soon-placeholders");
    const handleClick = (e)=>{
        e.preventDefault();
        const element = document.getElementById(targetSection);
        if (element) element.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };
    if (!showDataSources) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
        href: `#${targetSection}`,
        onClick: handleClick,
        className: (0, $9QePP.default)("text-link flex items-center gap-2", "transition-colors duration-200", "my-6 sm:mb-10", "group"),
        children: [
            label,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f64a4ef9514b684d$export$2e2bcd8739ae039), {
                className: (0, $9QePP.default)("size-4 transition-all duration-300 ease-out", "group-hover:translate-y-1 group-hover:stroke-brand-400")
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");
function $4f7c08395b53fdc4$var$SparklesIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M9 4.5a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.813a3.75 3.75 0 0 0-2.576 2.576l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.576l-2.846-.813a.75.75 0 0 1 0-1.442l2.846-.813A3.75 3.75 0 0 0 7.466 7.89l.813-2.846A.75.75 0 0 1 9 4.5ZM18 1.5a.75.75 0 0 1 .728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 0 1 0 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 0 1-1.456 0l-.258-1.036a2.625 2.625 0 0 0-1.91-1.91l-1.036-.258a.75.75 0 0 1 0-1.456l1.036-.258a2.625 2.625 0 0 0 1.91-1.91l.258-1.036A.75.75 0 0 1 18 1.5ZM16.5 15a.75.75 0 0 1 .712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 0 1 0 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 0 1-1.422 0l-.395-1.183a1.5 1.5 0 0 0-.948-.948l-1.183-.395a.75.75 0 0 1 0-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0 1 16.5 15Z",
        clipRule: "evenodd"
    }));
}
const $4f7c08395b53fdc4$var$ForwardRef = $acw62.forwardRef($4f7c08395b53fdc4$var$SparklesIcon);
var $4f7c08395b53fdc4$export$2e2bcd8739ae039 = $4f7c08395b53fdc4$var$ForwardRef;


function $411db1f77d5b08b1$export$7752db215400b41d() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("w-fit bg-slate-700 px-2 py-1", "flex items-center gap-2 rounded-full"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "ui-label text-white",
                children: "AI-Generated"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f7c08395b53fdc4$export$2e2bcd8739ae039), {
                className: "size-4"
            })
        ]
    });
}



var $r2uF6 = parcelRequire("r2uF6");

function $e418782b77f5d987$export$52ac9a1b9e51900({ opportunityId: opportunityId }) {
    const { productData: productData, economicsData: economicsData, termsConditionsData: termsConditionsData, covenantsColorized: covenantsColorized, isLoading: isLoading } = (0, $e667c4961b5d739b$export$f3830df9ca88c6d3)({
        opportunityId: opportunityId
    });
    const showDataSources = (0, $r2uF6.useAtomValue)((0, $e8aa26b1ef42f359$export$4bba709a6a23ef4d));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-12",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6c3d2606e6cb499$export$208f774c0f9d0c93), {
                        title: "Product",
                        data: productData,
                        isLoading: isLoading
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6c3d2606e6cb499$export$208f774c0f9d0c93), {
                        title: "Economics",
                        data: economicsData,
                        isLoading: isLoading
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6c3d2606e6cb499$export$208f774c0f9d0c93), {
                        title: "Terms & Conditions",
                        data: termsConditionsData,
                        isLoading: isLoading
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "space-y-6",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "heading-m mb-3",
                            children: "Covenants"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "mb-2",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c2560609a068b22c$export$4bbb6880c2bce4a2), {
                                        text: covenantsColorized.value,
                                        maxLength: 1800
                                    })
                                }),
                                showDataSources && covenantsColorized.source && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: (0, $9QePP.default)("mt-1 text-[9px] font-medium tracking-wide", covenantsColorized.sourceClassName),
                                    children: covenantsColorized.source
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $411db1f77d5b08b1$export$7752db215400b41d), {})
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5cbb248d749c652$export$6c0783fc6eb13aa1), {
                targetSection: "capital-and-deal-structure",
                label: "Jump to Capital & Deal Structure"
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");


var $7Y7Q4 = parcelRequire("7Y7Q4");

var $r2uF6 = parcelRequire("r2uF6");

var $acw62 = parcelRequire("acw62");
function $35ccd0e0f94b0171$export$fdf798407d60fdf(query, atom, hookOptions) {
    const result = (0, $7Y7Q4.useApiQuery)(query, hookOptions);
    const setAtom = (0, $r2uF6.useSetAtom)(atom);
    const atomValue = (0, $acw62.useMemo)(()=>({
            isLoading: !!result.isLoading,
            isError: !!result.isError,
            data: result.data ?? null
        }), [
        result.isLoading,
        result.isError,
        result.data,
        result.dataUpdatedAt
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        setAtom(atomValue);
    }, [
        atomValue,
        setAtom
    ]);
    return result;
}


parcelRequire("i5Lss");
var $2mq6B = parcelRequire("2mq6B");
var $kkxkw = parcelRequire("kkxkw");
const $4900ce30e40bb477$var$unwrapDatum = (maybeWrapped)=>{
    if (maybeWrapped && "value" in maybeWrapped && maybeWrapped.value?.meta) return maybeWrapped.value;
    return maybeWrapped;
};
function $4900ce30e40bb477$export$2e2bcd8739ae039(raw) {
    return {
        description: raw.description,
        info: raw.info,
        lineagedValues: raw.lineagedValues.map((lineagedValue)=>{
            const accountDatums = "add" in lineagedValue.expr ? lineagedValue.expr.add : "value" in lineagedValue.expr ? [
                lineagedValue.expr.value
            ] : [];
            return {
                period: lineagedValue.period,
                value: lineagedValue.value,
                accounts: accountDatums.map((item)=>{
                    const datum = $4900ce30e40bb477$var$unwrapDatum(item);
                    return {
                        value: datum.value.number,
                        dataAssetId: datum.meta.dataAssetId,
                        accountId: datum.meta.accountId
                    };
                })
            };
        })
    };
}



const $75f146eb90ff0682$export$4c527c96df2f0f53 = (0, $kkxkw.createQuery)(async ({ api: api, router: router, params: params })=>{
    const toDate = (0, $3185906cbd4f0e83$export$796c6171a330b576)();
    const response = await api.get(`/finance/companies/${router.params.companyId}/metrics?period_kind=${params.periodKind}&value_kind=lineage&to=${toDate}${params.labels.reduce((acc, curr)=>{
        return `${acc}&label=${curr}`;
    }, "")}`);
    return response.data;
});
const $75f146eb90ff0682$export$c1b9374d33a8c73b = (0, $kkxkw.createQuery)(async ({ router: router, session: session, params: params })=>{
    const metricQuery = params.metricQuery ?? router.search["metric-query"];
    if (Array.isArray(metricQuery) ? metricQuery.length === 0 : !metricQuery) return [];
    const queries = Array.isArray(metricQuery) ? metricQuery : [
        metricQuery
    ];
    const queryString = queries.map((q)=>`m=${encodeURIComponent(q)}`).join("&");
    const response = await (0, $2mq6B.createApiClient)({
        token: session.token.data || undefined
    }).get(`${"https://finance.humcapital.com"}/api/beta/companies/${router.params.companyId}/metric-query?value_kind=lineage&${queryString}`);
    return response.data;
});
const $75f146eb90ff0682$export$2fe86a4f526c8643 = (0, $kkxkw.createQuery)(async ({ api: api, params: params, router: router })=>{
    const response = await api.get(`/finance/companies/${router.params.companyId}/metrics?period_kind=monthly&value_kind=lineage${params.labels.reduce((acc, curr)=>{
        return `${acc}&label=${curr}`;
    }, "")}`);
    return (Array.isArray(response.data) ? response.data : []).map((0, $4900ce30e40bb477$export$2e2bcd8739ae039));
});
const $75f146eb90ff0682$export$4f9234baf34abd0 = (0, $kkxkw.createQuery)(async ({ api: api, params: params })=>{
    const response = await api.get(`/finance/accounts/${params.accountId}`);
    return response.data;
});
const $75f146eb90ff0682$export$d5d451a14adbc067 = (0, $kkxkw.createQuery)(async ({ api: api, router: router })=>{
    const response = await api.get(`/finance/accounts?limit=1000&company_id=${router.params.companyId}`);
    return response.data?.reduce((acc, curr)=>{
        acc[curr.id] = curr;
        return acc;
    }, {}) || {};
});



var $eQbhf = parcelRequire("eQbhf");

var $r2uF6 = parcelRequire("r2uF6");

var $eQbhf = parcelRequire("eQbhf");



var $eQbhf = parcelRequire("eQbhf");
const $5b4e6b4ee867778c$export$5cc18c49722ddde6 = new Set([
    (0, $eQbhf.AccountLabel).ASSETS,
    (0, $eQbhf.AccountLabel).CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS,
    (0, $eQbhf.AccountLabel).CURRENT_ASSETS_NET_RECEIVABLES,
    (0, $eQbhf.AccountLabel).CURRENT_ASSETS_NET_INVENTORY,
    (0, $eQbhf.AccountLabel).NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT,
    (0, $eQbhf.AccountLabel).LIABILITIES,
    (0, $eQbhf.AccountLabel).CURRENT_LIABILITIES_ACCOUNTS_PAYABLE,
    (0, $eQbhf.AccountLabel).CURRENT_LIABILITIES_DEBT,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_CASH,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_LIABILITIES
]);
const $5b4e6b4ee867778c$export$19a37e7186436a94 = new Set([
    (0, $eQbhf.AccountLabel).REVENUES,
    (0, $eQbhf.AccountLabel).EBITDA,
    (0, $eQbhf.AccountLabel).EBITDA_MARGIN,
    (0, $eQbhf.AccountLabel).GROSS_MARGIN,
    (0, $eQbhf.AccountLabel).NET_INCOME,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_REVENUE,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_EBITDA,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_NET_INCOME,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_NET_INCOME_MARGIN_P,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_EBITDA_MARGIN_P,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_GROSS_MARGIN_P,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_SALES_AND_MARKETING_EFFICIENCY
]);
const $5b4e6b4ee867778c$export$6fe11e3fc7a06e2d = new Set([
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_INTEREST_COVERAGE,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_DSCR,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_GROSS_DEBT_TO_ASSETS,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_GROSS_DEBT_TO_EBITDA,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS_TO_EQUITY,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_DEBT_TO_EQUITY,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_CASH_BURN_MONTHLY
]);
const $5b4e6b4ee867778c$export$50ae977a0309c119 = new Set([
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_TOTAL_REVENUE,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_EBITDA_MARGIN_P,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_GROSS_MARGIN_P,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_CASH,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_EBITDA,
    (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_SALES_AND_MARKETING_EFFICIENCY
]);
const $5b4e6b4ee867778c$export$b4e85b0920c960c4 = [
    [
        (0, $eQbhf.AccountLabel).REVENUES,
        (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_REVENUE
    ],
    [
        (0, $eQbhf.AccountLabel).GROSS_MARGIN,
        (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_GROSS_MARGIN_P
    ],
    [
        (0, $eQbhf.AccountLabel).EBITDA,
        (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_EBITDA
    ],
    [
        (0, $eQbhf.AccountLabel).EBITDA_MARGIN,
        (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_EBITDA_MARGIN_P
    ],
    [
        (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_SALES_AND_MARKETING_EFFICIENCY,
        undefined
    ],
    [
        (0, $eQbhf.AccountLabel).NET_INCOME,
        (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_NET_INCOME
    ],
    [
        (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_NET_INCOME_MARGIN_P,
        undefined
    ]
];
const $5b4e6b4ee867778c$export$fd82f015dc9562e0 = [
    [
        (0, $eQbhf.AccountLabel).ASSETS,
        (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS
    ],
    [
        (0, $eQbhf.AccountLabel).CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS,
        (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_CASH
    ],
    [
        (0, $eQbhf.AccountLabel).CURRENT_ASSETS_NET_RECEIVABLES,
        undefined
    ],
    [
        (0, $eQbhf.AccountLabel).CURRENT_ASSETS_NET_INVENTORY,
        undefined
    ],
    [
        (0, $eQbhf.AccountLabel).NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT,
        undefined
    ],
    [
        (0, $eQbhf.AccountLabel).LIABILITIES,
        (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_LIABILITIES
    ],
    [
        (0, $eQbhf.AccountLabel).CURRENT_LIABILITIES_ACCOUNTS_PAYABLE,
        undefined
    ],
    [
        (0, $eQbhf.AccountLabel).CURRENT_LIABILITIES_DEBT,
        undefined
    ]
];


function $816da3fb2055a0ef$var$parseExpression(expr) {
    const values = [];
    function traverse(node) {
        if (node.value) {
            const val = node.value;
            const index = values.length;
            if (val.meta) values.push({
                value: val.value.number,
                ref: `$${index}`,
                meta: {
                    period: val.meta.origPeriod,
                    accountId: val.meta.accountId,
                    dataAssetId: val.meta.dataAssetId,
                    location: val.meta.loc
                }
            });
            else values.push({
                value: val.value.number,
                ref: `$${index}`
            });
            return `$${index}`;
        }
        if (node.add) {
            const parts = node.add.map((n)=>{
                const result = traverse(n);
                const needsParens = n.sub;
                return needsParens ? `(${result})` : result;
            });
            return parts.join(" + ");
        }
        if (node.sub) {
            const parts = node.sub.map((n, idx)=>{
                const result = traverse(n);
                const needsParens = idx > 0 && (n.add || n.sub);
                return needsParens ? `(${result})` : result;
            });
            return parts.join(" - ");
        }
        if (node.mul) {
            const parts = node.mul.map((n)=>{
                const result = traverse(n);
                const needsParens = n.add || n.sub;
                return needsParens ? `(${result})` : result;
            });
            return parts.join(" * ");
        }
        if (node.div) {
            const parts = node.div.map((n, idx)=>{
                const result = traverse(n);
                const needsParens = n.add || n.sub || idx > 0 && (n.mul || n.div);
                return needsParens ? `(${result})` : result;
            });
            return parts.join(" / ");
        }
        return "";
    }
    const formula = traverse(expr);
    return {
        formula: formula,
        values: values
    };
}
function $816da3fb2055a0ef$export$fab482abed15876e(data) {
    const results = [];
    if (!data.metrics) return results;
    for (const metricKey of Object.keys(data.metrics)){
        const metricArray = data.metrics[metricKey];
        for (const metric of metricArray){
            if (!metric.lineagedValues) continue;
            for (const lineagedValue of metric.lineagedValues){
                if (lineagedValue.expr) {
                    const { formula: formula, values: values } = $816da3fb2055a0ef$var$parseExpression(lineagedValue.expr);
                    results.push({
                        period: lineagedValue.period,
                        result: lineagedValue.value,
                        formula: formula,
                        values: values
                    });
                } else if (lineagedValue.lineage) results.push({
                    period: lineagedValue.period,
                    result: lineagedValue.value,
                    formula: "$0",
                    values: [
                        {
                            value: lineagedValue.value,
                            ref: "$0",
                            meta: {
                                period: lineagedValue.lineage.origPeriod,
                                accountId: lineagedValue.lineage.accountId,
                                dataAssetId: lineagedValue.lineage.dataAssetId,
                                location: lineagedValue.lineage.loc
                            }
                        }
                    ]
                });
            }
        }
    }
    return results;
}



var $gngdn = parcelRequire("gngdn");


var $eQbhf = parcelRequire("eQbhf");

var $gngdn = parcelRequire("gngdn");
var $2b7e8d4c5d764ba7$exports = {};
!function(t, n) {
    $2b7e8d4c5d764ba7$exports = n();
}($2b7e8d4c5d764ba7$exports, function() {
    "use strict";
    var t = "month", n = "quarter";
    return function(e, i) {
        var r = i.prototype;
        r.quarter = function(t) {
            return this.$utils().u(t) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (t - 1));
        };
        var s = r.add;
        r.add = function(e, i) {
            return e = Number(e), this.$utils().p(i) === n ? this.add(3 * e, t) : s.bind(this)(e, i);
        };
        var u = r.startOf;
        r.startOf = function(e, i) {
            var r = this.$utils(), s = !!r.u(i) || i;
            if (r.p(e) === n) {
                var o = this.quarter() - 1;
                return s ? this.month(3 * o).startOf(t).startOf("day") : this.month(3 * o + 2).endOf(t).endOf("day");
            }
            return u.bind(this)(e, i);
        };
    };
});


(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).extend((0, (/*@__PURE__*/$parcel$interopDefault($2b7e8d4c5d764ba7$exports))));
function $a0038ff09b9cb167$export$bd4e9dc97961ceeb(period) {
    const date = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(period);
    if (!date.isValid()) return period;
    if (period.length === 4) return period;
    else if (period.includes("Q")) return period.replace("-", "-").slice(0, -2);
    else return date.format("MM-YY");
}
function $a0038ff09b9cb167$export$c75eee9396dea764(period) {
    if (period.length === 4) return period;
    if (period.includes("Q")) {
        const match = period.match(/^(\d{4})-?(Q\d)$|^(Q\d)-(\d{2})$/);
        if (match) {
            const quarter = match[2] || match[3];
            const year = match[1] || `20${match[4]}`;
            return `${quarter} ${year}`;
        }
        return period;
    }
    const date = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(period);
    if (!date.isValid()) return period;
    return date.format("MMMM YYYY");
}
function $a0038ff09b9cb167$export$254c7990ecbe689e(periods) {
    const parsed = periods.map($a0038ff09b9cb167$export$c75eee9396dea764);
    if (parsed.length === 1) return parsed[0];
    return `${parsed[0]} - ${parsed[parsed.length - 1]}`;
}
function $a0038ff09b9cb167$export$b3ab20afa21fa2d4(periods) {
    return periods.sort((a, b)=>a.localeCompare(b));
}
function $a0038ff09b9cb167$export$d56dd646acc2a9d9(periods) {
    return periods.map($a0038ff09b9cb167$export$c75eee9396dea764);
}
function $a0038ff09b9cb167$export$2bf0c9af12dfcd01(periods) {
    return periods.map((period)=>({
            field: period,
            headerName: $a0038ff09b9cb167$export$bd4e9dc97961ceeb(period)
        }));
}
function $a0038ff09b9cb167$export$abe1a4d78fb59613(metrics) {
    return $a0038ff09b9cb167$export$b3ab20afa21fa2d4([
        ...new Set(metrics.map((metric)=>metric.values.map((value)=>value.period)).flat())
    ]);
}
function $a0038ff09b9cb167$var$isEndOfMonth(date) {
    return date.isSame(date.endOf("month"), "day");
}
function $a0038ff09b9cb167$var$isEndOfQuarterMonth(date) {
    return date.month() === date.endOf("quarter").month();
}
function $a0038ff09b9cb167$export$d579eebe314e9a5(asOfDate, periodKind, windowSize) {
    const date = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(asOfDate);
    if (!date.isValid() || windowSize <= 0) return [];
    const periods = [];
    if (periodKind === (0, $eQbhf.PeriodKind).MONTHLY) {
        let current = $a0038ff09b9cb167$var$isEndOfMonth(date) ? date.endOf("month") : date.subtract(1, "month").endOf("month");
        for(let i = 0; i < windowSize; i++){
            periods.unshift(current.format("YYYY-MM"));
            current = current.subtract(1, "month").endOf("month");
        }
    } else if (periodKind === (0, $eQbhf.PeriodKind).QUARTERLY) {
        let current = $a0038ff09b9cb167$var$isEndOfQuarterMonth(date) ? date.endOf("quarter") : date.subtract(1, "quarter").endOf("quarter");
        for(let i = 0; i < windowSize; i++){
            const year = current.year();
            const quarter = current.quarter();
            periods.unshift(`${year}-Q${quarter}`);
            current = current.subtract(1, "quarter").endOf("quarter");
        }
    } else if (periodKind === (0, $eQbhf.PeriodKind).YEARLY) {
        let current = date.subtract(1, "year");
        for(let i = 0; i < windowSize; i++){
            periods.unshift(current.format("YYYY"));
            current = current.subtract(1, "year");
        }
    }
    return periods;
}
function $a0038ff09b9cb167$export$d20da80facbf85ca(periods, asOfDate) {
    if (periods.length === 0) return [];
    const year = asOfDate.slice(0, 4);
    return periods.filter((period)=>period.includes(year) && period <= asOfDate);
}
function $a0038ff09b9cb167$export$18870a65b84e7f44(periods, asOfDate) {
    if (periods.length === 0) return [];
    return periods.filter((period)=>period <= asOfDate);
}



const $a0b0e4e94524bfb3$var$interleave = (arr, sep)=>arr.flatMap((v, i)=>i === 0 ? [
            v
        ] : [
            sep,
            v
        ]);
function $a0b0e4e94524bfb3$export$ac4d890ffdd9be01(slice) {
    return slice.reduce((sum, [, val])=>sum + val, 0);
}
function $a0b0e4e94524bfb3$export$dd06a9ea4a8fd59e(windowSize = 1, valuesByPeriod) {
    if (valuesByPeriod.length < windowSize * 2) return null;
    const periods = valuesByPeriod.sort((a, b)=>a[0].localeCompare(b[0])).slice(-windowSize * 2);
    const previous = periods.slice(0, windowSize);
    const current = periods.slice(windowSize);
    return {
        previous: previous,
        current: current
    };
}
function $a0b0e4e94524bfb3$export$42395004151c5189(slice, fieldType = (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY) {
    const values = slice.map(([, val])=>(0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)(val, fieldType));
    return {
        title: (0, $a0038ff09b9cb167$export$254c7990ecbe689e)(slice.map(([period])=>period)),
        formula: $a0b0e4e94524bfb3$var$interleave(values, "+")
    };
}
function $a0b0e4e94524bfb3$export$a85cface4f0d5167(previousPeriods, currentPeriods, resolutionWindow) {
    const previous = previousPeriods.length ? (0, $a0038ff09b9cb167$export$254c7990ecbe689e)(previousPeriods) : "";
    const current = currentPeriods.length ? (0, $a0038ff09b9cb167$export$254c7990ecbe689e)(currentPeriods) : "";
    return {
        title: $a0b0e4e94524bfb3$export$cef478891122337a(resolutionWindow),
        formula: [
            "(",
            current,
            "-",
            previous,
            ")",
            "/",
            previous
        ]
    };
}
function $a0b0e4e94524bfb3$export$4b13ea46348dc970(currentSlice, previousSlice) {
    const currentSum = $a0b0e4e94524bfb3$export$ac4d890ffdd9be01(currentSlice);
    const previousSum = $a0b0e4e94524bfb3$export$ac4d890ffdd9be01(previousSlice);
    if (previousSum === 0) return null;
    return (currentSum - previousSum) / previousSum;
}
function $a0b0e4e94524bfb3$export$cef478891122337a(resolutionWindow) {
    const match = resolutionWindow.match(/^l(\d+)([mqy])$/);
    if (!match) return "% \u0394 PoP";
    const count = parseInt(match[1], 10);
    const unit = match[2];
    if (unit === "m" && count === 12) return "% \u0394 YoY";
    if (unit === "m" && count === 3) return "% \u0394 QoQ";
    if (unit === "q" && count === 4) return "% \u0394 YoY";
    return "% \u0394 PoP";
}
function $a0b0e4e94524bfb3$export$489e23dc7473f561(resolutionWindow) {
    const match = resolutionWindow.match(/^l(\d+)[mqy]$/);
    return match ? parseInt(match[1], 10) : 1;
}


const $ac1aa0283079b21c$var$getMaxAllowedDate = ()=>{
    const now = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))();
    const twoMonthsAgo = now.subtract(2, "month");
    return twoMonthsAgo.endOf("month").format("YYYY-MM-DD");
};
const $ac1aa0283079b21c$export$99acf3ba7e4e0c8a = (0, $r2uF6.atom)({
    periodKind: (0, $eQbhf.PeriodKind).MONTHLY,
    window: "l12m"
});
const $ac1aa0283079b21c$export$dfed62957d17fdf5 = (0, $r2uF6.atom)({
    periodKind: (0, $eQbhf.PeriodKind).MONTHLY,
    window: "l12m"
});
const $ac1aa0283079b21c$export$ff87f6fcc4f8a7a3 = (0, $r2uF6.atom)({
    periodKind: (0, $eQbhf.PeriodKind).MONTHLY,
    window: "l12m"
});
const $ac1aa0283079b21c$export$b94ff1565236ec9d = $ac1aa0283079b21c$export$99acf3ba7e4e0c8a;
const $ac1aa0283079b21c$export$e02867a648d51fa3 = (0, $r2uF6.atom)({
    data: null,
    isLoading: false,
    isError: false
});
const $ac1aa0283079b21c$export$c311318117b7047b = (0, $r2uF6.atom)({
    data: null,
    isLoading: false,
    isError: false
});
const $ac1aa0283079b21c$export$f68248781bb89c68 = (0, $r2uF6.atom)({
    data: null,
    isLoading: false,
    isError: false
});
const $ac1aa0283079b21c$export$a3ca8edc13ccf742 = (0, $r2uF6.atom)({
    data: null,
    isLoading: false,
    isError: false
});
const $ac1aa0283079b21c$export$b7b377ca7aa833f2 = (0, $r2uF6.atom)({
    data: null,
    isLoading: false,
    isError: false
});
const $ac1aa0283079b21c$export$5fa8aa4979d40738 = (0, $r2uF6.atom)({
    data: null,
    isLoading: false,
    isError: false
});
const $ac1aa0283079b21c$export$94ccd1aa6182cd65 = (0, $r2uF6.atom)({
    data: null,
    isLoading: false,
    isError: false
});
const $ac1aa0283079b21c$export$833af3e8cf96f469 = (0, $r2uF6.atom)({
    data: null,
    isLoading: false,
    isError: false
});
const $ac1aa0283079b21c$export$84ebb64439769704 = (0, $r2uF6.atom)({
    data: null,
    isLoading: false,
    isError: false
});
const $ac1aa0283079b21c$export$1a88a30dea58e5b = (0, $r2uF6.atom)({
    data: null,
    isLoading: false,
    isError: false
});
const $ac1aa0283079b21c$export$397955998ef11b18 = (0, $r2uF6.atom)({
    data: null,
    isLoading: false,
    isError: false
});
const $ac1aa0283079b21c$export$bb48b1ed324c8e9a = (0, $r2uF6.atom)({
    data: null,
    isLoading: false,
    isError: false
});
const $ac1aa0283079b21c$export$5230d3951890ac19 = (0, $r2uF6.atom)({
    data: null,
    isLoading: false,
    isError: false
});
const $ac1aa0283079b21c$export$68a5bd6752c3931e = (0, $r2uF6.atom)((get)=>$ac1aa0283079b21c$var$normalizeLineageMetrics(get($ac1aa0283079b21c$export$833af3e8cf96f469), (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_API));
const $ac1aa0283079b21c$export$32de1568f471864b = (0, $r2uF6.atom)((get)=>$ac1aa0283079b21c$var$normalizeLineageMetrics(get($ac1aa0283079b21c$export$84ebb64439769704), (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_API));
const $ac1aa0283079b21c$export$ac44adf8870dac20 = (0, $r2uF6.atom)((get)=>$ac1aa0283079b21c$var$normalizeLineageMetrics(get($ac1aa0283079b21c$export$1a88a30dea58e5b), (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_API));
const $ac1aa0283079b21c$export$400d700aaca7e3fb = (0, $r2uF6.atom)((get)=>$ac1aa0283079b21c$var$normalizeMetrics(get($ac1aa0283079b21c$export$397955998ef11b18), (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB));
const $ac1aa0283079b21c$export$6a39a2fdb68bd80e = (0, $r2uF6.atom)((get)=>$ac1aa0283079b21c$var$normalizeMetrics(get($ac1aa0283079b21c$export$bb48b1ed324c8e9a), (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB));
const $ac1aa0283079b21c$export$c6341ed30065340a = (0, $r2uF6.atom)((get)=>$ac1aa0283079b21c$var$normalizeMetrics(get($ac1aa0283079b21c$export$5230d3951890ac19), (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB));
function $ac1aa0283079b21c$var$calculateLastTwoPeriodsDeltas(values) {
    const maxDate = $ac1aa0283079b21c$var$getMaxAllowedDate();
    const lastDate = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(maxDate);
    const currentPeriod = lastDate.format("YYYY-MM");
    const previousPeriod = lastDate.subtract(1, "month").format("YYYY-MM");
    const valuesByPeriod = new Map(values.filter((v)=>v.value !== null && v.value !== undefined).map((v)=>[
            v.period,
            v.value
        ]));
    const currentValue = valuesByPeriod.get(currentPeriod);
    const previousValue = valuesByPeriod.get(previousPeriod);
    if (currentValue === undefined || previousValue === undefined) return null;
    return (0, $a0b0e4e94524bfb3$export$4b13ea46348dc970)([
        [
            currentPeriod,
            currentValue
        ]
    ], [
        [
            previousPeriod,
            previousValue
        ]
    ]);
}
function $ac1aa0283079b21c$var$calculateCumulativeDelta(values) {
    const windowSize = 12;
    const maxDate = $ac1aa0283079b21c$var$getMaxAllowedDate();
    const lastDate = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(maxDate);
    const expectedPeriods = [];
    for(let i = windowSize * 2 - 1; i >= 0; i--)expectedPeriods.push(lastDate.subtract(i, "month").format("YYYY-MM"));
    const valuesByPeriod = new Map(values.filter((v)=>v.value !== null && v.value !== undefined).map((v)=>[
            v.period,
            v.value
        ]));
    if (!expectedPeriods.every((p)=>valuesByPeriod.has(p))) return null;
    const previousSlice = expectedPeriods.slice(0, windowSize).map((p)=>[
            p,
            valuesByPeriod.get(p)
        ]);
    const currentSlice = expectedPeriods.slice(windowSize).map((p)=>[
            p,
            valuesByPeriod.get(p)
        ]);
    return (0, $a0b0e4e94524bfb3$export$4b13ea46348dc970)(currentSlice, previousSlice);
}
function $ac1aa0283079b21c$var$isBalanceSheetMetric(label) {
    return (0, $5b4e6b4ee867778c$export$5cc18c49722ddde6).has(label);
}
function $ac1aa0283079b21c$var$addDeltaToMetric(metric, source) {
    const isBalanceSheet = $ac1aa0283079b21c$var$isBalanceSheetMetric(metric.info.derived.label);
    const delta = isBalanceSheet ? $ac1aa0283079b21c$var$calculateLastTwoPeriodsDeltas(metric.values) : $ac1aa0283079b21c$var$calculateCumulativeDelta(metric.values);
    return {
        ...metric,
        delta: delta,
        source: source
    };
}
function $ac1aa0283079b21c$var$convertLineageMetricToMetric(lineageMetric, source) {
    const values = lineageMetric.lineagedValues?.map((lv)=>({
            period: lv.period,
            value: lv.value
        })) || [];
    const isBalanceSheet = $ac1aa0283079b21c$var$isBalanceSheetMetric(lineageMetric.info.derived.label);
    const delta = isBalanceSheet ? $ac1aa0283079b21c$var$calculateLastTwoPeriodsDeltas(values) : $ac1aa0283079b21c$var$calculateCumulativeDelta(values);
    const parsedMetrics = lineageMetric.lineagedValues && lineageMetric.lineagedValues.length > 0 ? (0, $816da3fb2055a0ef$export$fab482abed15876e)({
        metrics: {
            [lineageMetric.info.derived.label]: [
                lineageMetric
            ]
        }
    }) : [];
    return {
        info: lineageMetric.info,
        description: lineageMetric.description,
        values: values,
        lineagedValues: parsedMetrics,
        delta: delta,
        source: source
    };
}
function $ac1aa0283079b21c$export$69f15c14d019bb0a(metrics, labels) {
    return Object.fromEntries(labels.map((label)=>[
            label,
            metrics[label]
        ]).filter(([, metric])=>metric !== undefined));
}
const $ac1aa0283079b21c$var$normalizeMetrics = (query, source)=>{
    if (!query.data) return {};
    const result = {};
    for (const metric of query.data)result[metric.info.derived.label] = $ac1aa0283079b21c$var$addDeltaToMetric(metric, source);
    return result;
};
const $ac1aa0283079b21c$var$normalizeLineageMetrics = (query, source)=>{
    if (!query.data) return {};
    const result = {};
    for (const lineageMetric of query.data)result[lineageMetric.info.derived.label] = $ac1aa0283079b21c$var$convertLineageMetricToMetric(lineageMetric, source);
    return result;
};
const $ac1aa0283079b21c$export$7fced9fb157c158b = (0, $r2uF6.atom)((get)=>$ac1aa0283079b21c$var$normalizeLineageMetrics(get($ac1aa0283079b21c$export$e02867a648d51fa3), (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_API));
const $ac1aa0283079b21c$export$d3bfec36223e9c25 = (0, $r2uF6.atom)((get)=>$ac1aa0283079b21c$var$normalizeLineageMetrics(get($ac1aa0283079b21c$export$c311318117b7047b), (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_API));
const $ac1aa0283079b21c$export$9a66daf5c1dcf97 = (0, $r2uF6.atom)((get)=>$ac1aa0283079b21c$var$normalizeLineageMetrics(get($ac1aa0283079b21c$export$f68248781bb89c68), (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_API));
const $ac1aa0283079b21c$export$653e91f1cd1504f1 = (0, $r2uF6.atom)((get)=>$ac1aa0283079b21c$var$normalizeMetrics(get($ac1aa0283079b21c$export$a3ca8edc13ccf742), (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB));
const $ac1aa0283079b21c$export$21da7bdbbe5626ab = (0, $r2uF6.atom)((get)=>$ac1aa0283079b21c$var$normalizeMetrics(get($ac1aa0283079b21c$export$b7b377ca7aa833f2), (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB));
const $ac1aa0283079b21c$export$6e897075342497c1 = (0, $r2uF6.atom)((get)=>$ac1aa0283079b21c$var$normalizeMetrics(get($ac1aa0283079b21c$export$5fa8aa4979d40738), (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB));
const $ac1aa0283079b21c$export$a49c19c282c3baac = (0, $r2uF6.atom)((get)=>$ac1aa0283079b21c$var$normalizeMetrics(get($ac1aa0283079b21c$export$94ccd1aa6182cd65), (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB));
const $ac1aa0283079b21c$export$167853aa0aa64cd1 = (0, $r2uF6.atom)((0, $eQbhf.PeriodKind).MONTHLY);
const $ac1aa0283079b21c$export$b479bf8505037b29 = (0, $r2uF6.atom)((get)=>{
    const { periodKind: periodKind } = get($ac1aa0283079b21c$export$99acf3ba7e4e0c8a);
    const periodMap = {
        [(0, $eQbhf.PeriodKind).MONTHLY]: $ac1aa0283079b21c$export$7fced9fb157c158b,
        [(0, $eQbhf.PeriodKind).QUARTERLY]: $ac1aa0283079b21c$export$d3bfec36223e9c25,
        [(0, $eQbhf.PeriodKind).YEARLY]: $ac1aa0283079b21c$export$9a66daf5c1dcf97
    };
    return get(periodMap[periodKind] ?? $ac1aa0283079b21c$export$7fced9fb157c158b);
});
const $ac1aa0283079b21c$export$5bc80f01ae288874 = (0, $r2uF6.atom)((get)=>{
    const { periodKind: periodKind } = get($ac1aa0283079b21c$export$99acf3ba7e4e0c8a);
    const periodMap = {
        [(0, $eQbhf.PeriodKind).MONTHLY]: $ac1aa0283079b21c$export$653e91f1cd1504f1,
        [(0, $eQbhf.PeriodKind).QUARTERLY]: $ac1aa0283079b21c$export$21da7bdbbe5626ab,
        [(0, $eQbhf.PeriodKind).YEARLY]: $ac1aa0283079b21c$export$6e897075342497c1
    };
    return get(periodMap[periodKind] ?? $ac1aa0283079b21c$export$653e91f1cd1504f1);
});
const $ac1aa0283079b21c$export$902a8a2e511babda = (0, $r2uF6.atom)((get)=>{
    const { periodKind: periodKind } = get($ac1aa0283079b21c$export$dfed62957d17fdf5);
    const periodMap = {
        [(0, $eQbhf.PeriodKind).MONTHLY]: $ac1aa0283079b21c$export$68a5bd6752c3931e,
        [(0, $eQbhf.PeriodKind).QUARTERLY]: $ac1aa0283079b21c$export$32de1568f471864b,
        [(0, $eQbhf.PeriodKind).YEARLY]: $ac1aa0283079b21c$export$ac44adf8870dac20
    };
    return get(periodMap[periodKind] ?? $ac1aa0283079b21c$export$68a5bd6752c3931e);
});
const $ac1aa0283079b21c$export$381dde81c2f67880 = (0, $r2uF6.atom)((get)=>{
    const { periodKind: periodKind } = get($ac1aa0283079b21c$export$dfed62957d17fdf5);
    const periodMap = {
        [(0, $eQbhf.PeriodKind).MONTHLY]: $ac1aa0283079b21c$export$400d700aaca7e3fb,
        [(0, $eQbhf.PeriodKind).QUARTERLY]: $ac1aa0283079b21c$export$6a39a2fdb68bd80e,
        [(0, $eQbhf.PeriodKind).YEARLY]: $ac1aa0283079b21c$export$c6341ed30065340a
    };
    return get(periodMap[periodKind] ?? $ac1aa0283079b21c$export$400d700aaca7e3fb);
});
const $ac1aa0283079b21c$export$2aa54d925664f166 = (0, $r2uF6.atom)((get)=>{
    const financeMetrics = get($ac1aa0283079b21c$export$b479bf8505037b29);
    const finLabMetrics = get($ac1aa0283079b21c$export$5bc80f01ae288874);
    const projectionMetrics = get($ac1aa0283079b21c$export$a49c19c282c3baac);
    return {
        ...finLabMetrics,
        ...projectionMetrics,
        ...financeMetrics
    };
});
function $ac1aa0283079b21c$var$filterMetricsByMaxDate(metrics) {
    const maxDate = $ac1aa0283079b21c$var$getMaxAllowedDate();
    const filtered = {};
    for (const [key, metric] of Object.entries(metrics)){
        const filteredValues = metric.values.filter((v)=>v.period <= maxDate);
        const isBalanceSheet = $ac1aa0283079b21c$var$isBalanceSheetMetric(metric.info.derived.label);
        const delta = isBalanceSheet ? $ac1aa0283079b21c$var$calculateLastTwoPeriodsDeltas(filteredValues) : $ac1aa0283079b21c$var$calculateCumulativeDelta(filteredValues);
        filtered[key] = {
            ...metric,
            values: filteredValues,
            delta: delta
        };
    }
    return filtered;
}
const $ac1aa0283079b21c$export$12e2b84d2db22786 = (0, $r2uF6.atom)((get)=>{
    const financeMetrics = get($ac1aa0283079b21c$export$7fced9fb157c158b);
    const finLabMetrics = get($ac1aa0283079b21c$export$653e91f1cd1504f1);
    const unified = {
        ...finLabMetrics,
        ...financeMetrics
    };
    const labels = Array.from((0, $5b4e6b4ee867778c$export$19a37e7186436a94));
    const labelFiltered = $ac1aa0283079b21c$export$69f15c14d019bb0a(unified, labels);
    return $ac1aa0283079b21c$var$filterMetricsByMaxDate(labelFiltered);
});
const $ac1aa0283079b21c$export$8a657426c281479d = (0, $r2uF6.atom)((get)=>{
    const financeMetrics = get($ac1aa0283079b21c$export$68a5bd6752c3931e);
    const finLabMetrics = get($ac1aa0283079b21c$export$400d700aaca7e3fb);
    const unified = {
        ...finLabMetrics,
        ...financeMetrics
    };
    const labels = Array.from((0, $5b4e6b4ee867778c$export$5cc18c49722ddde6));
    const labelFiltered = $ac1aa0283079b21c$export$69f15c14d019bb0a(unified, labels);
    return $ac1aa0283079b21c$var$filterMetricsByMaxDate(labelFiltered);
});
const $ac1aa0283079b21c$export$f86d18e84dd54899 = (0, $r2uF6.atom)((get)=>{
    const projectionMetrics = get($ac1aa0283079b21c$export$2aa54d925664f166);
    const labels = Array.from((0, $5b4e6b4ee867778c$export$50ae977a0309c119));
    return $ac1aa0283079b21c$export$69f15c14d019bb0a(projectionMetrics, labels);
});
const $ac1aa0283079b21c$export$ecd603b0f67db905 = (0, $r2uF6.atom)((get)=>{
    const postClosingMetrics = get($ac1aa0283079b21c$export$2aa54d925664f166);
    const labels = Array.from((0, $5b4e6b4ee867778c$export$6fe11e3fc7a06e2d));
    return $ac1aa0283079b21c$export$69f15c14d019bb0a(postClosingMetrics, labels);
});
function $ac1aa0283079b21c$var$getLatestPeriodFromMetrics(metrics) {
    let latestPeriod = null;
    metrics.forEach((metric)=>{
        const validValues = metric.values.filter((v)=>v.value !== null && v.value !== undefined);
        if (validValues.length > 0) {
            const sortedValues = [
                ...validValues
            ].sort((a, b)=>b.period.localeCompare(a.period));
            const metricLatest = sortedValues[0].period;
            if (!latestPeriod || metricLatest > latestPeriod) latestPeriod = metricLatest;
        }
    });
    return latestPeriod;
}
const $ac1aa0283079b21c$export$68b8c61fed1001b3 = (0, $r2uF6.atom)((get)=>{
    const projectionMetrics = get($ac1aa0283079b21c$export$a49c19c282c3baac);
    return $ac1aa0283079b21c$var$getLatestPeriodFromMetrics(Object.values(projectionMetrics));
});
function $ac1aa0283079b21c$var$getPeriodsFromMetricPairs(metrics, metricPairs) {
    const periods = new Set();
    for (const [primary, fallback] of metricPairs){
        const metric = metrics[primary] ?? (fallback ? metrics[fallback] : undefined);
        metric?.values.forEach((v)=>periods.add(v.period));
    }
    return Array.from(periods).sort();
}
const $ac1aa0283079b21c$export$63f2c08ec55a7c8b = (0, $r2uF6.atom)((get)=>{
    const monthlyFinance = get($ac1aa0283079b21c$export$7fced9fb157c158b);
    const monthlyFinLab = get($ac1aa0283079b21c$export$653e91f1cd1504f1);
    const combined = {
        ...monthlyFinLab,
        ...monthlyFinance
    };
    const filtered = $ac1aa0283079b21c$var$filterMetricsByMaxDate(combined);
    const periods = $ac1aa0283079b21c$var$getPeriodsFromMetricPairs(filtered, (0, $5b4e6b4ee867778c$export$b4e85b0920c960c4));
    const earliestPeriod = periods[0];
    return earliestPeriod ? (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(earliestPeriod).endOf("month").format("YYYY-MM-DD") : null;
});
const $ac1aa0283079b21c$export$40712ac478dd6036 = (0, $r2uF6.atom)((get)=>{
    const monthlyFinance = get($ac1aa0283079b21c$export$7fced9fb157c158b);
    const monthlyFinLab = get($ac1aa0283079b21c$export$653e91f1cd1504f1);
    const combined = {
        ...monthlyFinLab,
        ...monthlyFinance
    };
    const filtered = $ac1aa0283079b21c$var$filterMetricsByMaxDate(combined);
    const periods = $ac1aa0283079b21c$var$getPeriodsFromMetricPairs(filtered, (0, $5b4e6b4ee867778c$export$b4e85b0920c960c4));
    const lastPeriod = periods[periods.length - 1];
    return lastPeriod ? (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(lastPeriod).endOf("month").format("YYYY-MM-DD") : null;
});
const $ac1aa0283079b21c$export$791d9a958ce94640 = (0, $r2uF6.atom)((get)=>{
    const monthlyFinance = get($ac1aa0283079b21c$export$68a5bd6752c3931e);
    const monthlyFinLab = get($ac1aa0283079b21c$export$400d700aaca7e3fb);
    const combined = {
        ...monthlyFinLab,
        ...monthlyFinance
    };
    const filtered = $ac1aa0283079b21c$var$filterMetricsByMaxDate(combined);
    const periods = $ac1aa0283079b21c$var$getPeriodsFromMetricPairs(filtered, (0, $5b4e6b4ee867778c$export$fd82f015dc9562e0));
    const earliestPeriod = periods[0];
    return earliestPeriod ? (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(earliestPeriod).endOf("month").format("YYYY-MM-DD") : null;
});
const $ac1aa0283079b21c$export$85932cbce02e0bb2 = (0, $r2uF6.atom)((get)=>{
    const monthlyFinance = get($ac1aa0283079b21c$export$68a5bd6752c3931e);
    const monthlyFinLab = get($ac1aa0283079b21c$export$400d700aaca7e3fb);
    const combined = {
        ...monthlyFinLab,
        ...monthlyFinance
    };
    const filtered = $ac1aa0283079b21c$var$filterMetricsByMaxDate(combined);
    const periods = $ac1aa0283079b21c$var$getPeriodsFromMetricPairs(filtered, (0, $5b4e6b4ee867778c$export$fd82f015dc9562e0));
    const lastPeriod = periods[periods.length - 1];
    return lastPeriod ? (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(lastPeriod).endOf("month").format("YYYY-MM-DD") : null;
});
const $ac1aa0283079b21c$export$a74510d510ea4008 = (0, $r2uF6.atom)((get)=>{
    const isDate = get($ac1aa0283079b21c$export$40712ac478dd6036);
    const bsDate = get($ac1aa0283079b21c$export$85932cbce02e0bb2);
    if (!isDate && !bsDate) return null;
    if (!isDate) return bsDate;
    if (!bsDate) return isDate;
    return isDate < bsDate ? isDate : bsDate;
});



var $r2uF6 = parcelRequire("r2uF6");



function $22d65479bbd58794$export$3826b261599cbd03() {
    const incomeStatementResolution = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$99acf3ba7e4e0c8a));
    const balanceSheetResolution = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$dfed62957d17fdf5));
    // Determine which query atoms to use for Income Statement based on periodKind
    const isFinLabQueryAtom = incomeStatementResolution.periodKind === "quarterly" ? (0, $ac1aa0283079b21c$export$b7b377ca7aa833f2) : incomeStatementResolution.periodKind === "yearly" ? (0, $ac1aa0283079b21c$export$5fa8aa4979d40738) : (0, $ac1aa0283079b21c$export$a3ca8edc13ccf742);
    const isFinanceQueryAtom = incomeStatementResolution.periodKind === "quarterly" ? (0, $ac1aa0283079b21c$export$c311318117b7047b) : incomeStatementResolution.periodKind === "yearly" ? (0, $ac1aa0283079b21c$export$f68248781bb89c68) : (0, $ac1aa0283079b21c$export$e02867a648d51fa3);
    // Determine which query atoms to use for Balance Sheet based on its own periodKind
    // Use dedicated BS atoms to keep data separate
    const bsFinLabQueryAtom = balanceSheetResolution.periodKind === "quarterly" ? (0, $ac1aa0283079b21c$export$bb48b1ed324c8e9a) : balanceSheetResolution.periodKind === "yearly" ? (0, $ac1aa0283079b21c$export$5230d3951890ac19) : (0, $ac1aa0283079b21c$export$397955998ef11b18);
    const bsFinanceQueryAtom = balanceSheetResolution.periodKind === "quarterly" ? (0, $ac1aa0283079b21c$export$84ebb64439769704) : balanceSheetResolution.periodKind === "yearly" ? (0, $ac1aa0283079b21c$export$1a88a30dea58e5b) : (0, $ac1aa0283079b21c$export$833af3e8cf96f469);
    // Income Statement - FinanceLab metrics
    (0, $35ccd0e0f94b0171$export$fdf798407d60fdf)((0, $1cf2065342823807$export$33bf4d4bd60a05b5), isFinLabQueryAtom, {
        key: [
            "finance-lab-metrics-is",
            incomeStatementResolution.periodKind,
            incomeStatementResolution.window || "all"
        ],
        params: {
            labels: [
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_REVENUE,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_EBITDA,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_GROSS_MARGIN_P,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_NET_INCOME,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_EBITDA_MARGIN_P,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_NET_INCOME_MARGIN_P,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_SALES_AND_MARKETING_EFFICIENCY
            ],
            periodKind: incomeStatementResolution.periodKind
        }
    });
    // Income Statement - Finance API metrics
    (0, $35ccd0e0f94b0171$export$fdf798407d60fdf)((0, $75f146eb90ff0682$export$4c527c96df2f0f53), isFinanceQueryAtom, {
        key: [
            "finance-api-metrics-is",
            incomeStatementResolution.periodKind,
            incomeStatementResolution.window || "all"
        ],
        params: {
            labels: [
                (0, $eQbhf.AccountLabel).REVENUES,
                (0, $eQbhf.AccountLabel).GROSS_MARGIN,
                (0, $eQbhf.AccountLabel).EBITDA,
                (0, $eQbhf.AccountLabel).EBITDA_MARGIN,
                (0, $eQbhf.AccountLabel).NET_INCOME
            ],
            periodKind: incomeStatementResolution.periodKind
        }
    });
    // Balance Sheet - FinanceLab metrics (using BS resolution and separate atoms)
    (0, $35ccd0e0f94b0171$export$fdf798407d60fdf)((0, $1cf2065342823807$export$33bf4d4bd60a05b5), bsFinLabQueryAtom, {
        key: [
            "finance-lab-metrics-bs",
            balanceSheetResolution.periodKind,
            balanceSheetResolution.window || "all"
        ],
        params: {
            labels: [
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_CASH,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_LIABILITIES
            ],
            periodKind: balanceSheetResolution.periodKind
        }
    });
    // Balance Sheet - Finance API metrics (using BS resolution and separate atoms)
    (0, $35ccd0e0f94b0171$export$fdf798407d60fdf)((0, $75f146eb90ff0682$export$4c527c96df2f0f53), bsFinanceQueryAtom, {
        key: [
            "finance-api-metrics-bs",
            balanceSheetResolution.periodKind,
            balanceSheetResolution.window || "all"
        ],
        params: {
            labels: [
                (0, $eQbhf.AccountLabel).ASSETS,
                (0, $eQbhf.AccountLabel).CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS,
                (0, $eQbhf.AccountLabel).CURRENT_ASSETS_NET_RECEIVABLES,
                (0, $eQbhf.AccountLabel).CURRENT_ASSETS_NET_INVENTORY,
                (0, $eQbhf.AccountLabel).NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT,
                (0, $eQbhf.AccountLabel).LIABILITIES,
                (0, $eQbhf.AccountLabel).CURRENT_LIABILITIES_ACCOUNTS_PAYABLE,
                (0, $eQbhf.AccountLabel).CURRENT_LIABILITIES_DEBT
            ],
            periodKind: balanceSheetResolution.periodKind
        }
    });
    // Projections - FinanceLab metrics (using projections resolution atom)
    // Fetch both Projected Financials and Post-Closing Metrics together
    const projectionsResolution = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$ff87f6fcc4f8a7a3));
    (0, $35ccd0e0f94b0171$export$fdf798407d60fdf)((0, $1cf2065342823807$export$33bf4d4bd60a05b5), (0, $ac1aa0283079b21c$export$94ccd1aa6182cd65), {
        key: [
            "finance-lab-projections",
            projectionsResolution.periodKind,
            projectionsResolution.window || "all"
        ],
        params: {
            labels: Array.from(new Set([
                ...(0, $5b4e6b4ee867778c$export$50ae977a0309c119),
                ...(0, $5b4e6b4ee867778c$export$6fe11e3fc7a06e2d)
            ])),
            periodKind: projectionsResolution.periodKind
        }
    });
}



var $r2uF6 = parcelRequire("r2uF6");





var $eQbhf = parcelRequire("eQbhf");
function $25397e9d43ca4a5e$export$ed0dc1178a679c67(metrics, primaryLabel, fallbackLabel) {
    return metrics[primaryLabel] ?? (fallbackLabel ? metrics[fallbackLabel] : undefined);
}


/**
 * Scrolls to a section and highlights a specific row in an AG-Grid table
 * @param sectionId - The DOM ID of the section to scroll to
 * @param metricName - The name of the metric/row to highlight (matches the text in the "metric" column)
 */ function $72bc1ad783661600$export$5b8d04439e9c246c(sectionId, metricName) {
    const section = document.getElementById(sectionId);
    if (!section) return;
    const yOffset = -100;
    const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({
        top: y,
        behavior: "smooth"
    });
    setTimeout(()=>{
        const allRows = section.querySelectorAll('[role="row"]');
        allRows.forEach((row)=>{
            const cell = row.querySelector('[col-id="label"]');
            if (cell?.textContent === metricName) {
                const rowIndex = row.getAttribute("row-index");
                const matchingRows = section.querySelectorAll(`[role="row"][row-index="${rowIndex}"]`);
                matchingRows.forEach((r)=>{
                    const htmlRow = r;
                    htmlRow.style.transition = "background-color 0.3s ease";
                    htmlRow.style.setProperty("background-color", "#2C384B", "important");
                });
                setTimeout(()=>{
                    matchingRows.forEach((r)=>{
                        const htmlRow = r;
                        htmlRow.style.backgroundColor = "";
                        setTimeout(()=>{
                            htmlRow.style.transition = "";
                        }, 300);
                    });
                }, 3000);
            }
        });
    }, 800);
}



var $7gcOJ = parcelRequire("7gcOJ");

var $r2uF6 = parcelRequire("r2uF6");

var $acw62 = parcelRequire("acw62");


function $b085c6e18988e4af$export$dc4ed7d6a15188bd() {
    const setAIMContextView = (0, $r2uF6.useSetAtom)((0, $57f1ca4385a7301a$export$c65e5de3b3a2e247));
    return (0, $acw62.useCallback)((metric, title)=>{
        setAIMContextView({
            type: (0, $0e9c1faaf8e0eb7e$export$88fa5c7cfbd4d210).LABS_LINEAGE,
            metric: metric,
            title: title
        });
    }, [
        setAIMContextView
    ]);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $04e5498dc1cafae1$var$UserPlusIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5.25 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM2.25 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM18.75 7.5a.75.75 0 0 0-1.5 0v2.25H15a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-2.25H21a.75.75 0 0 0 0-1.5h-2.25V7.5Z"
    }));
}
const $04e5498dc1cafae1$var$ForwardRef = $acw62.forwardRef($04e5498dc1cafae1$var$UserPlusIcon);
var $04e5498dc1cafae1$export$2e2bcd8739ae039 = $04e5498dc1cafae1$var$ForwardRef;


const $0ea51272c2ca428e$var$SELF_REPORTED_DATA = "self_reported_company_data";
function $0ea51272c2ca428e$export$ca348ece31ebdab7(localLabel) {
    return localLabel.includes($0ea51272c2ca428e$var$SELF_REPORTED_DATA);
}
function $0ea51272c2ca428e$var$SelfReportedTooltip() {
    const [tooltipPosition, setTooltipPosition] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        top: -9999,
        left: -9999,
        position: "right"
    });
    const [isVisible, setIsVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const handleMouseEnter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setIsVisible(true);
        if (triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            const tooltipWidth = 320;
            const wouldOverflowRight = rect.right + tooltipWidth > viewportWidth;
            const position = wouldOverflowRight ? "left" : "right";
            const top = rect.bottom + 8;
            const left = position === "right" ? rect.left : Math.max(0, rect.right - tooltipWidth);
            setTooltipPosition({
                top: top,
                left: left,
                position: position
            });
        }
    }, []);
    const handleMouseLeave = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setIsVisible(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: triggerRef,
        className: "tt-trigger group relative",
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center justify-center rounded-full bg-slate-600 px-2 py-1"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04e5498dc1cafae1$export$2e2bcd8739ae039), {
        className: "h-4 w-4"
    })), isVisible && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `tt-container tt-${tooltipPosition.position} !fixed`,
        style: {
            top: `${tooltipPosition.top}px`,
            left: `${tooltipPosition.left}px`
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "tt w-80"
    }, "This is self-reported data by the company. There is no period over period comparison available for this data point.")));
}
function $0ea51272c2ca428e$export$ab707fc52ab1bc5b(label) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center gap-2"
    }, label, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0ea51272c2ca428e$var$SelfReportedTooltip));
}


function $6de353f57d20bb16$export$c614c1e735abfe2c(label, localLabel) {
    if (localLabel && (0, $0ea51272c2ca428e$export$ca348ece31ebdab7)(localLabel)) return (0, $0ea51272c2ca428e$export$ab707fc52ab1bc5b)(label);
    return label;
}


function $53c54bc134c736aa$export$e7340f6a219ff9b6() {
    const incomeStatementMetrics = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$12e2b84d2db22786));
    const flags = (0, $7gcOJ.useFlags)();
    const showM05 = flags.enabled("show-im-m05");
    const handleMetricClick = (0, $b085c6e18988e4af$export$dc4ed7d6a15188bd)();
    const revenue = (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(incomeStatementMetrics, (0, $eQbhf.AccountLabel).REVENUES, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_REVENUE);
    const ebitda = (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(incomeStatementMetrics, (0, $eQbhf.AccountLabel).EBITDA, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_EBITDA);
    const ebitdaMargin = (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(incomeStatementMetrics, (0, $eQbhf.AccountLabel).EBITDA_MARGIN, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_EBITDA_MARGIN_P);
    const grossMargin = (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(incomeStatementMetrics, (0, $eQbhf.AccountLabel).GROSS_MARGIN, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_GROSS_MARGIN_P);
    const netIncome = (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(incomeStatementMetrics, (0, $eQbhf.AccountLabel).NET_INCOME, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_NET_INCOME);
    const netIncomeMargin = (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(incomeStatementMetrics, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_NET_INCOME_MARGIN_P);
    const salesAndMarketingEfficiency = (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(incomeStatementMetrics, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_SALES_AND_MARKETING_EFFICIENCY);
    const revenueColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(revenue?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY) || "-", revenue?.source, revenue?.info.derived.label);
    const ebitdaColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(ebitda?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY) || "-", ebitda?.source, ebitda?.info.derived.label);
    const ebitdaMarginColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(ebitdaMargin?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).PERCENTAGE) || "-", ebitdaMargin?.source, ebitdaMargin?.info.derived.label);
    const grossMarginColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(grossMargin?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).PERCENTAGE) || "-", grossMargin?.source, grossMargin?.info.derived.label);
    const netIncomeColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(netIncome?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY) || "-", netIncome?.source, netIncome?.info.derived.label);
    const netIncomeMarginColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(netIncomeMargin?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).PERCENTAGE) || "-", netIncomeMargin?.source, netIncomeMargin?.info.derived.label);
    const salesAndMarketingEfficiencyColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(salesAndMarketingEfficiency?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).MULTIPLE) || "-", salesAndMarketingEfficiency?.source, salesAndMarketingEfficiency?.info.derived.label);
    return [
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Revenue", revenue?.info.derived.localLabel),
            value: revenueColorized.value,
            valueClassName: revenueColorized.className,
            source: revenueColorized.source,
            sourceClassName: revenueColorized.sourceClassName,
            delta: revenue?.delta,
            onClick: ()=>showM05 ? (0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-income-statement", "Revenue") : handleMetricClick(revenue, "Revenue")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Sales & Marketing Efficiency", salesAndMarketingEfficiency?.info.derived.localLabel),
            value: salesAndMarketingEfficiencyColorized.value,
            valueClassName: salesAndMarketingEfficiencyColorized.className,
            source: salesAndMarketingEfficiencyColorized.source,
            sourceClassName: salesAndMarketingEfficiencyColorized.sourceClassName,
            delta: salesAndMarketingEfficiency?.delta,
            onClick: ()=>showM05 ? (0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-income-statement", "Sales & Marketing Efficiency") : handleMetricClick(salesAndMarketingEfficiency, "Sales & Marketing Efficiency")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Gross Margin %", grossMargin?.info.derived.localLabel),
            value: grossMarginColorized.value,
            valueClassName: grossMarginColorized.className,
            source: grossMarginColorized.source,
            sourceClassName: grossMarginColorized.sourceClassName,
            delta: grossMargin?.delta,
            onClick: ()=>showM05 ? (0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-income-statement", "Gross Margin %") : handleMetricClick(grossMargin, "Gross Margin %")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Net Income", netIncome?.info.derived.localLabel),
            value: netIncomeColorized.value,
            valueClassName: netIncomeColorized.className,
            source: netIncomeColorized.source,
            sourceClassName: netIncomeColorized.sourceClassName,
            delta: netIncome?.delta,
            onClick: ()=>showM05 ? (0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-income-statement", "Net Income") : handleMetricClick(netIncome, "Net Income")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("EBITDA", ebitda?.info.derived.localLabel),
            value: ebitdaColorized.value,
            valueClassName: ebitdaColorized.className,
            source: ebitdaColorized.source,
            sourceClassName: ebitdaColorized.sourceClassName,
            delta: ebitda?.delta,
            onClick: ()=>showM05 ? (0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-income-statement", "EBITDA") : handleMetricClick(ebitda, "EBITDA")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Net Income Margin %", netIncomeMargin?.info.derived.localLabel),
            value: netIncomeMarginColorized.value,
            valueClassName: netIncomeMarginColorized.className,
            source: netIncomeMarginColorized.source,
            sourceClassName: netIncomeMarginColorized.sourceClassName,
            delta: netIncomeMargin?.delta,
            onClick: ()=>showM05 ? (0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-income-statement", "Net Income Margin %") : handleMetricClick(netIncomeMargin, "Net Income Margin %")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("EBITDA Margin %", ebitdaMargin?.info.derived.localLabel),
            value: ebitdaMarginColorized.value,
            valueClassName: ebitdaMarginColorized.className,
            source: ebitdaMarginColorized.source,
            sourceClassName: ebitdaMarginColorized.sourceClassName,
            delta: ebitdaMargin?.delta,
            onClick: ()=>showM05 ? (0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-income-statement", "EBITDA Margin %") : handleMetricClick(ebitdaMargin, "EBITDA Margin %")
        }
    ];
}



var $r2uF6 = parcelRequire("r2uF6");

var $7gcOJ = parcelRequire("7gcOJ");





var $eQbhf = parcelRequire("eQbhf");




function $4fd25f80b42d997f$export$c84681308f8a7bd4() {
    const flags = (0, $7gcOJ.useFlags)();
    const showM05 = flags.enabled("show-im-m05");
    const handleMetricClick = (0, $b085c6e18988e4af$export$dc4ed7d6a15188bd)();
    const balanceSheetMetrics = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$8a657426c281479d));
    const cash = (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(balanceSheetMetrics, (0, $eQbhf.AccountLabel).CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_CASH);
    const totalAssets = (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(balanceSheetMetrics, (0, $eQbhf.AccountLabel).ASSETS, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS);
    const grossPPE = (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(balanceSheetMetrics, (0, $eQbhf.AccountLabel).NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT);
    const totalLiabilities = (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(balanceSheetMetrics, (0, $eQbhf.AccountLabel).LIABILITIES, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_LIABILITIES);
    const accountsReceivable = (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(balanceSheetMetrics, (0, $eQbhf.AccountLabel).CURRENT_ASSETS_NET_RECEIVABLES);
    const accountsPayable = (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(balanceSheetMetrics, (0, $eQbhf.AccountLabel).CURRENT_LIABILITIES_ACCOUNTS_PAYABLE);
    const inventory = (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(balanceSheetMetrics, (0, $eQbhf.AccountLabel).CURRENT_ASSETS_NET_INVENTORY);
    const currentDebt = (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(balanceSheetMetrics, (0, $eQbhf.AccountLabel).CURRENT_LIABILITIES_DEBT);
    const assetsColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(totalAssets?.values)?.value, (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY) || "-", totalAssets?.source, totalAssets?.info.derived.label);
    const grossPPEColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(grossPPE?.values)?.value, (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY) || "-", grossPPE?.source, grossPPE?.info.derived.label);
    const liabilitiesColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(totalLiabilities?.values)?.value, (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY) || "-", totalLiabilities?.source, totalLiabilities?.info.derived.label);
    const cashBalanceColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(cash?.values)?.value, (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY) || "-", cash?.source, cash?.info.derived.label);
    const accountsReceivableColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(accountsReceivable?.values)?.value, (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY) || "-", accountsReceivable?.source, accountsReceivable?.info.derived.label);
    const accountsPayableColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(accountsPayable?.values)?.value, (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY) || "-", accountsPayable?.source, accountsPayable?.info.derived.label);
    const inventoryColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(inventory?.values)?.value, (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY) || "-", inventory?.source, inventory?.info.derived.label);
    const currentDebtColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(currentDebt?.values)?.value, (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY) || "-", currentDebt?.source, currentDebt?.info.derived.label);
    return [
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Total Assets", totalAssets?.info.derived.localLabel),
            value: assetsColorized.value,
            valueClassName: assetsColorized.className,
            source: assetsColorized.source,
            sourceClassName: assetsColorized.sourceClassName,
            delta: totalAssets?.delta,
            onClick: ()=>showM05 ? (0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-balance-sheet", "Total Assets") : handleMetricClick(totalAssets, "Total Assets")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Gross PP&E", grossPPE?.info.derived.localLabel),
            value: grossPPEColorized.value,
            valueClassName: grossPPEColorized.className,
            source: grossPPEColorized.source,
            sourceClassName: grossPPEColorized.sourceClassName,
            delta: grossPPE?.delta,
            onClick: ()=>handleMetricClick(grossPPE, "Gross PP&E")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Cash & Equivalents", cash?.info.derived.localLabel),
            value: cashBalanceColorized.value,
            valueClassName: cashBalanceColorized.className,
            source: cashBalanceColorized.source,
            sourceClassName: cashBalanceColorized.sourceClassName,
            delta: cash?.delta,
            onClick: ()=>showM05 ? (0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-balance-sheet", "Cash & Equivalents") : handleMetricClick(cash, "Cash & Equivalents")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Total Liabilities", totalLiabilities?.info.derived.localLabel),
            value: liabilitiesColorized.value,
            valueClassName: liabilitiesColorized.className,
            source: liabilitiesColorized.source,
            sourceClassName: liabilitiesColorized.sourceClassName,
            delta: totalLiabilities?.delta,
            onClick: ()=>showM05 ? (0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-balance-sheet", "Total Liabilities") : handleMetricClick(totalLiabilities, "Total Liabilities")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Accounts Receivable", accountsReceivable?.info.derived.localLabel),
            value: accountsReceivableColorized.value,
            valueClassName: accountsReceivableColorized.className,
            source: accountsReceivableColorized.source,
            sourceClassName: accountsReceivableColorized.sourceClassName,
            delta: accountsReceivable?.delta,
            onClick: ()=>showM05 ? (0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-balance-sheet", "Accounts Receivable") : handleMetricClick(accountsReceivable, "Accounts Receivable")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Accounts Payable", accountsPayable?.info.derived.localLabel),
            value: accountsPayableColorized.value,
            valueClassName: accountsPayableColorized.className,
            source: accountsPayableColorized.source,
            sourceClassName: accountsPayableColorized.sourceClassName,
            delta: accountsPayable?.delta,
            onClick: ()=>showM05 ? (0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-balance-sheet", "Accounts Payable") : handleMetricClick(accountsPayable, "Accounts Payable")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Inventory", inventory?.info.derived.localLabel),
            value: inventoryColorized.value,
            valueClassName: inventoryColorized.className,
            source: inventoryColorized.source,
            sourceClassName: inventoryColorized.sourceClassName,
            delta: inventory?.delta,
            onClick: ()=>showM05 ? (0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-balance-sheet", "Inventory") : handleMetricClick(inventory, "Inventory")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Current Debt Balance", currentDebt?.info.derived.localLabel),
            value: currentDebtColorized.value,
            valueClassName: currentDebtColorized.className,
            source: currentDebtColorized.source,
            sourceClassName: currentDebtColorized.sourceClassName,
            delta: currentDebt?.delta,
            onClick: ()=>showM05 ? (0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-balance-sheet", "Current Debt Balance") : handleMetricClick(currentDebt, "Current Debt Balance")
        }
    ];
}



var $7gcOJ = parcelRequire("7gcOJ");
parcelRequire("UXGeS");
var $7Y7Q4 = parcelRequire("7Y7Q4");


var $dKUtl = parcelRequire("dKUtl");

var $kTlwO = parcelRequire("kTlwO");

var $62e6P = parcelRequire("62e6P");

function $7529688d7b441e81$export$6b53a32f09f07a89() {
    const flags = (0, $7gcOJ.useFlags)();
    const showComingSoonFields = flags.enabled("show-coming-soon-placeholders");
    const company = (0, $7Y7Q4.useApiQuery)((0, $kTlwO.getCompany));
    const totalEquityRaised = company.data?.capitalApplication.equityRaised;
    const totalEquityRaisedColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(totalEquityRaised && (0, $62e6P.EQUITY_RAISED)[totalEquityRaised] || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).LEGACY_BACKEND, "company.capitalApplication.equityRaised");
    return [
        ...showComingSoonFields ? [
            {
                label: "Senior Debt",
                value: (0, $dKUtl.COMING_SOON)
            }
        ] : [],
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Total Equity Raised", "self_reported_company_data"),
            value: totalEquityRaisedColorized.value,
            valueClassName: totalEquityRaisedColorized.className,
            source: totalEquityRaisedColorized.source,
            sourceClassName: totalEquityRaisedColorized.sourceClassName,
            onClick: ()=>{}
        },
        ...showComingSoonFields ? [
            {
                label: "Junior Debt",
                value: (0, $dKUtl.COMING_SOON)
            }
        ] : []
    ];
}



var $7gcOJ = parcelRequire("7gcOJ");





var $dKUtl = parcelRequire("dKUtl");

var $r2uF6 = parcelRequire("r2uF6");


function $c1a2f645f50cadb1$export$7c3dfacdb36c561c() {
    const flags = (0, $7gcOJ.useFlags)();
    const showComingSoonFields = flags.enabled("show-coming-soon-placeholders");
    const metricsProjectionsMetrics = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$ecd603b0f67db905));
    const totalAssetsToEquityMetric = metricsProjectionsMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS_TO_EQUITY];
    const interestCoverageMetric = metricsProjectionsMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_INTEREST_COVERAGE];
    const dscrMetric = metricsProjectionsMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_DSCR];
    const grossDebtToAssetsMetric = metricsProjectionsMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_GROSS_DEBT_TO_ASSETS];
    const debtToEquityMetric = metricsProjectionsMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_DEBT_TO_EQUITY];
    const grossDebtToEbitdaMetric = metricsProjectionsMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_GROSS_DEBT_TO_EBITDA];
    const cashBurnMonthlyMetric = metricsProjectionsMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_CASH_BURN_MONTHLY];
    const interestCoverageColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(interestCoverageMetric?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).PERCENTAGE) || "-", interestCoverageMetric?.source, interestCoverageMetric?.info.derived.label);
    const dscrColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(dscrMetric?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).PERCENTAGE) || "-", dscrMetric?.source, dscrMetric?.info.derived.label);
    const debtToAssetsColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(grossDebtToAssetsMetric?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).MULTIPLE) || "-", grossDebtToAssetsMetric?.source, grossDebtToAssetsMetric?.info.derived.label);
    const debtToEquityColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(debtToEquityMetric?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).MULTIPLE) || "-", debtToEquityMetric?.source, debtToEquityMetric?.info.derived.label);
    const debtToEbitdaColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(grossDebtToEbitdaMetric?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).MULTIPLE) || "-", grossDebtToEbitdaMetric?.source, grossDebtToEbitdaMetric?.info.derived.label);
    const assetToEquityColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(totalAssetsToEquityMetric?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).MULTIPLE) || "-", totalAssetsToEquityMetric?.source, totalAssetsToEquityMetric?.info.derived.label);
    const monthlyCashBurnColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(cashBurnMonthlyMetric?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY) || "-", cashBurnMonthlyMetric?.source, cashBurnMonthlyMetric?.info.derived.label);
    return [
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Interest Coverage Ratio", interestCoverageMetric?.info.derived.localLabel),
            value: interestCoverageColorized.value,
            valueClassName: interestCoverageColorized.className,
            source: interestCoverageColorized.source,
            sourceClassName: interestCoverageColorized.sourceClassName,
            delta: interestCoverageMetric?.delta,
            onClick: ()=>(0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-post-closing-metrics", "Interest Coverage Ratio")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Debt Service Coverage Ratio", dscrMetric?.info.derived.localLabel),
            value: dscrColorized.value,
            valueClassName: dscrColorized.className,
            source: dscrColorized.source,
            sourceClassName: dscrColorized.sourceClassName,
            delta: dscrMetric?.delta,
            onClick: ()=>(0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-post-closing-metrics", "Debt Service Coverage Ratio")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Debt-to-Assets Ratio", grossDebtToAssetsMetric?.info.derived.localLabel),
            value: debtToAssetsColorized.value,
            valueClassName: debtToAssetsColorized.className,
            source: debtToAssetsColorized.source,
            sourceClassName: debtToAssetsColorized.sourceClassName,
            delta: grossDebtToAssetsMetric?.delta,
            onClick: ()=>(0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-post-closing-metrics", "Debt-to-Assets Ratio")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Debt-to-Equity Ratio", debtToEquityMetric?.info.derived.localLabel),
            value: debtToEquityColorized.value,
            valueClassName: debtToEquityColorized.className,
            source: debtToEquityColorized.source,
            sourceClassName: debtToEquityColorized.sourceClassName,
            delta: debtToEquityMetric?.delta,
            onClick: ()=>(0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-post-closing-metrics", "Debt-to-Equity Ratio")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Debt-to-EBITDA Ratio", grossDebtToEbitdaMetric?.info.derived.localLabel),
            value: debtToEbitdaColorized.value,
            valueClassName: debtToEbitdaColorized.className,
            source: debtToEbitdaColorized.source,
            sourceClassName: debtToEbitdaColorized.sourceClassName,
            delta: grossDebtToEbitdaMetric?.delta,
            onClick: ()=>(0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-post-closing-metrics", "Debt-to-EBITDA Ratio")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Asset-to-Equity", totalAssetsToEquityMetric?.info.derived.localLabel),
            value: assetToEquityColorized.value,
            valueClassName: assetToEquityColorized.className,
            source: assetToEquityColorized.source,
            sourceClassName: assetToEquityColorized.sourceClassName,
            delta: totalAssetsToEquityMetric?.delta,
            onClick: ()=>(0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-post-closing-metrics", "Asset-to-Equity")
        },
        ...showComingSoonFields ? [
            {
                label: "Fixed Charge Ratio",
                value: (0, $dKUtl.COMING_SOON)
            }
        ] : [],
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Monthly cash burn", cashBurnMonthlyMetric?.info.derived.localLabel),
            value: monthlyCashBurnColorized.value,
            valueClassName: monthlyCashBurnColorized.className,
            source: monthlyCashBurnColorized.source,
            sourceClassName: monthlyCashBurnColorized.sourceClassName,
            delta: cashBurnMonthlyMetric?.delta,
            onClick: ()=>(0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-post-closing-metrics", "Monthly cash burn")
        }
    ];
}



var $r2uF6 = parcelRequire("r2uF6");






function $2bbc3ef6240d1ac3$export$1c21f7aeec396a36() {
    const unifiedMetrics = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$2aa54d925664f166));
    const projectedRevenue = unifiedMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_TOTAL_REVENUE];
    const projectedEbitdaMargin = unifiedMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_EBITDA_MARGIN_P];
    const projectedGrossMargin = unifiedMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_GROSS_MARGIN_P];
    const projectedCashBalance = unifiedMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_CASH];
    const projectedEbitda = unifiedMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_EBITDA];
    const projectedSalesMarketingEfficiency = unifiedMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_SALES_AND_MARKETING_EFFICIENCY];
    const revenueColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(projectedRevenue?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY) || "-", projectedRevenue?.source, projectedRevenue?.info.derived.label);
    const ebitdaMarginColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(projectedEbitdaMargin?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).PERCENTAGE) || "-", projectedEbitdaMargin?.source, projectedEbitdaMargin?.info.derived.label);
    const grossMarginColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(projectedGrossMargin?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).PERCENTAGE) || "-", projectedGrossMargin?.source, projectedGrossMargin?.info.derived.label);
    const cashBalanceColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(projectedCashBalance?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY) || "-", projectedCashBalance?.source, projectedCashBalance?.info.derived.label);
    const ebitdaColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(projectedEbitda?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY) || "-", projectedEbitda?.source, projectedEbitda?.info.derived.label);
    const salesMarketingEfficiencyColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $2a5011cb4beaeebb$export$be752fcf9917f653)(projectedSalesMarketingEfficiency?.values), (0, $eb67e7ba0742cb25$export$b570835b381015d3).MULTIPLE) || "-", projectedSalesMarketingEfficiency?.source, projectedSalesMarketingEfficiency?.info.derived.label);
    return [
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Revenue", projectedRevenue?.info.derived.localLabel),
            value: revenueColorized.value,
            valueClassName: revenueColorized.className,
            source: revenueColorized.source,
            sourceClassName: revenueColorized.sourceClassName,
            delta: projectedRevenue?.delta,
            onClick: ()=>(0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-projected-financials", "Revenue")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("EBITDA Margin %", projectedEbitdaMargin?.info.derived.localLabel),
            value: ebitdaMarginColorized.value,
            valueClassName: ebitdaMarginColorized.className,
            source: ebitdaMarginColorized.source,
            sourceClassName: ebitdaMarginColorized.sourceClassName,
            delta: projectedEbitdaMargin?.delta,
            onClick: ()=>(0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-projected-financials", "EBITDA Margin %")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Gross Margin %", projectedGrossMargin?.info.derived.localLabel),
            value: grossMarginColorized.value,
            valueClassName: grossMarginColorized.className,
            source: grossMarginColorized.source,
            sourceClassName: grossMarginColorized.sourceClassName,
            delta: projectedGrossMargin?.delta,
            onClick: ()=>(0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-projected-financials", "Gross Margin %")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Cash Balance", projectedCashBalance?.info.derived.localLabel),
            value: cashBalanceColorized.value,
            valueClassName: cashBalanceColorized.className,
            source: cashBalanceColorized.source,
            sourceClassName: cashBalanceColorized.sourceClassName,
            delta: projectedCashBalance?.delta,
            onClick: ()=>(0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-projected-financials", "Cash Balance")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("EBITDA", projectedEbitda?.info.derived.localLabel),
            value: ebitdaColorized.value,
            valueClassName: ebitdaColorized.className,
            source: ebitdaColorized.source,
            sourceClassName: ebitdaColorized.sourceClassName,
            delta: projectedEbitda?.delta,
            onClick: ()=>(0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-projected-financials", "EBITDA")
        },
        {
            label: (0, $6de353f57d20bb16$export$c614c1e735abfe2c)("Sales & Marketing Efficiency", projectedSalesMarketingEfficiency?.info.derived.localLabel),
            value: salesMarketingEfficiencyColorized.value,
            valueClassName: salesMarketingEfficiencyColorized.className,
            source: salesMarketingEfficiencyColorized.source,
            sourceClassName: salesMarketingEfficiencyColorized.sourceClassName,
            delta: projectedSalesMarketingEfficiency?.delta,
            onClick: ()=>(0, $72bc1ad783661600$export$5b8d04439e9c246c)("summary-projected-financials", "Sales & Marketing Efficiency")
        }
    ];
}





var $r2uF6 = parcelRequire("r2uF6");

function $60e5842b4987c8e7$export$c9ef29accac42abd() {
    const handleMetricClick = (0, $b085c6e18988e4af$export$dc4ed7d6a15188bd)();
    const projectedFinancialsMetrics = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$f86d18e84dd54899));
    const getYearValue = (metricValues, year)=>{
        if (!metricValues) return "-";
        const yearData = metricValues.find((item)=>item.period === year);
        return yearData?.formattedValue || "-";
    };
    const projectedRevenueMetric = projectedFinancialsMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_TOTAL_REVENUE];
    const projectedGrossMarginMetric = projectedFinancialsMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_GROSS_MARGIN_P];
    const projectedEbitdaMetric = projectedFinancialsMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_EBITDA];
    const projectedEbitdaMarginMetric = projectedFinancialsMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_EBITDA_MARGIN_P];
    const projectedCashMetric = projectedFinancialsMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_CASH];
    const projectedSalesMarketingEfficiencyMetric = projectedFinancialsMetrics[(0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_SALES_AND_MARKETING_EFFICIENCY];
    return [
        {
            metric: "Revenue",
            "2026": getYearValue(projectedRevenueMetric?.values, "2026"),
            "2027": getYearValue(projectedRevenueMetric?.values, "2027"),
            "2028": getYearValue(projectedRevenueMetric?.values, "2028"),
            onClick: ()=>handleMetricClick(projectedRevenueMetric, "Revenue")
        },
        {
            metric: "Gross Margin %",
            "2026": getYearValue(projectedGrossMarginMetric?.values, "2026"),
            "2027": getYearValue(projectedGrossMarginMetric?.values, "2027"),
            "2028": getYearValue(projectedGrossMarginMetric?.values, "2028"),
            onClick: ()=>handleMetricClick(projectedGrossMarginMetric, "Gross Margin %")
        },
        {
            metric: "EBITDA",
            "2026": getYearValue(projectedEbitdaMetric?.values, "2026"),
            "2027": getYearValue(projectedEbitdaMetric?.values, "2027"),
            "2028": getYearValue(projectedEbitdaMetric?.values, "2028"),
            onClick: ()=>handleMetricClick(projectedEbitdaMetric, "EBITDA")
        },
        {
            metric: "EBITDA Margin %",
            "2026": getYearValue(projectedEbitdaMarginMetric?.values, "2026"),
            "2027": getYearValue(projectedEbitdaMarginMetric?.values, "2027"),
            "2028": getYearValue(projectedEbitdaMarginMetric?.values, "2028"),
            onClick: ()=>handleMetricClick(projectedEbitdaMarginMetric, "EBITDA Margin %")
        },
        {
            metric: "Cash Balance",
            "2026": getYearValue(projectedCashMetric?.values, "2026"),
            "2027": getYearValue(projectedCashMetric?.values, "2027"),
            "2028": getYearValue(projectedCashMetric?.values, "2028"),
            onClick: ()=>handleMetricClick(projectedCashMetric, "Cash Balance")
        },
        {
            metric: "Sales & Marketing Efficiency",
            "2026": getYearValue(projectedSalesMarketingEfficiencyMetric?.values, "2026"),
            "2027": getYearValue(projectedSalesMarketingEfficiencyMetric?.values, "2027"),
            "2028": getYearValue(projectedSalesMarketingEfficiencyMetric?.values, "2028"),
            onClick: ()=>handleMetricClick(projectedSalesMarketingEfficiencyMetric, "Sales & Marketing Efficiency")
        }
    ];
}


function $2999acffbdc87b56$export$bb13aa651604efdb() {
    (0, $22d65479bbd58794$export$3826b261599cbd03)();
    const incomeStatementData = (0, $53c54bc134c736aa$export$e7340f6a219ff9b6)();
    const balanceSheetData = (0, $4fd25f80b42d997f$export$c84681308f8a7bd4)();
    const capitalStructureData = (0, $7529688d7b441e81$export$6b53a32f09f07a89)();
    const postClosingMetricsData = (0, $c1a2f645f50cadb1$export$7c3dfacdb36c561c)();
    const projectedFinancialsData = (0, $60e5842b4987c8e7$export$c9ef29accac42abd)();
    const projectedFinancialsM05Data = (0, $2bbc3ef6240d1ac3$export$1c21f7aeec396a36)();
    return {
        incomeStatementData: incomeStatementData,
        balanceSheetData: balanceSheetData,
        capitalStructureData: capitalStructureData,
        projectedFinancialsData: projectedFinancialsData,
        projectedFinancialsM05Data: projectedFinancialsM05Data,
        postClosingMetricsData: postClosingMetricsData
    };
}




var $ayMG0 = parcelRequire("ayMG0");

var $gxPgh = parcelRequire("gxPgh");

var $acw62 = parcelRequire("acw62");

var $jIDNV = parcelRequire("jIDNV");

var $dKUtl = parcelRequire("dKUtl");
(0, $jIDNV.ModuleRegistry).registerModules([
    (0, $jIDNV.AllCommunityModule)
]);
const $990d0f56d10de165$var$myTheme = (0, $jIDNV.themeQuartz).withPart((0, $jIDNV.colorSchemeDark)).withParams({
    accentColor: "#6B7280",
    backgroundColor: "#1E293B",
    borderColor: "#334155",
    browserColorScheme: "dark",
    chromeBackgroundColor: {
        ref: "foregroundColor",
        mix: 0.07,
        onto: "backgroundColor"
    },
    fontFamily: {
        googleFont: "Inter"
    },
    foregroundColor: "#FFFFFF",
    headerFontSize: 14,
    headerVerticalPaddingScale: 1,
    rowHoverColor: "transparent",
    rowBorder: {
        color: "#0f172a"
    },
    rangeSelectionBorderStyle: "none",
    selectedRowBackgroundColor: "#334155",
    rangeSelectionBackgroundColor: "#334155",
    headerHeight: 42
});
function $990d0f56d10de165$export$3ae2824b8d61e4dc({ data: data, columns: columns, ...gridProps }) {
    const columnDefs = (0, $acw62.useMemo)(()=>columns.map((col)=>({
                ...col,
                headerClass: col.headerClass || "heading-s",
                flex: col.flex ?? 1,
                minWidth: col.minWidth ?? 140,
                wrapHeaderText: col.wrapHeaderText ?? true,
                autoHeaderHeight: col.autoHeaderHeight ?? true,
                cellStyle: col.cellStyle || {
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.4",
                    padding: "10px 16px",
                    cursor: "pointer"
                },
                cellClassRules: {
                    "text-disabled": (params)=>{
                        return params.value === (0, $dKUtl.COMING_SOON);
                    },
                    ...col.cellClassRules
                }
            })), [
        columns
    ]);
    const defaultColDef = (0, $acw62.useMemo)(()=>({
            resizable: false,
            sortable: false,
            filter: false,
            editable: false,
            suppressMovable: true,
            wrapText: true,
            autoHeight: true,
            wrapHeaderText: true,
            autoHeaderHeight: true,
            suppressHeaderMenuButton: true,
            suppressHeaderContextMenu: true,
            cellStyle: {
                display: "flex",
                alignItems: "left",
                whiteSpace: "normal",
                wordWrap: "break-word",
                lineHeight: "1.4",
                padding: "12px 12px"
            }
        }), []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "ag-theme-quartz-dark overflow-hidden rounded",
        style: {
            height: "auto"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gxPgh.AgGridReact), {
            ...gridProps,
            theme: $990d0f56d10de165$var$myTheme,
            rowData: data,
            columnDefs: columnDefs,
            defaultColDef: {
                ...defaultColDef,
                ...gridProps.defaultColDef
            },
            domLayout: "autoHeight",
            suppressAnimationFrame: true,
            suppressRowTransform: true,
            animateRows: false,
            onRowClicked: (params)=>{
                if (params.data?.onClick) params.data?.onClick();
            }
        })
    });
}




var $7gcOJ = parcelRequire("7gcOJ");


var $r2uF6 = parcelRequire("r2uF6");


var $gngdn = parcelRequire("gngdn");
function $23f1bc8e6da879d9$export$368813ca779e3c0f(period) {
    if (!period) return "N/A";
    if (period.includes("Q")) {
        const quarterMatch = period.match(/(\d{4})-Q(\d)|Q(\d)-(\d{2})/);
        if (quarterMatch) {
            const year = quarterMatch[1] || `20${quarterMatch[4]}`;
            const quarter = parseInt(quarterMatch[2] || quarterMatch[3]);
            const lastMonthOfQuarter = quarter * 3;
            const date = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(`${year}-${lastMonthOfQuarter.toString().padStart(2, "0")}-01`);
            return date.format("MMM YYYY");
        }
    }
    if (/^\d{4}$/.test(period)) {
        const date = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(`${period}-12-01`);
        return date.format("MMM YYYY");
    }
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(period);
    if (parsed.isValid()) return parsed.format("MMM YYYY");
    return "N/A";
}


function $9d26e2c376d7507c$export$f9f5f42292f2fe4d() {
    const flags = (0, $7gcOJ.useFlags)();
    const showM05 = flags.enabled("show-im-m05");
    const showProjectionMetrics = flags.enabled("show-projection-metrics");
    const { incomeStatementData: incomeStatementData, balanceSheetData: balanceSheetData, capitalStructureData: capitalStructureData, projectedFinancialsData: projectedFinancialsData, projectedFinancialsM05Data: projectedFinancialsM05Data, postClosingMetricsData: postClosingMetricsData } = (0, $2999acffbdc87b56$export$bb13aa651604efdb)();
    const { isPolling: isPolling } = (0, $bcfccea9b862dce3$export$268736677778b952)();
    const asOfDate = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$a74510d510ea4008));
    const projectionsAsOfDate = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$68b8c61fed1001b3));
    const isLoadingMetrics = isPolling;
    const formattedAsOfDate = (0, $23f1bc8e6da879d9$export$368813ca779e3c0f)(asOfDate);
    const formattedProjectionsAsOfDate = (0, $23f1bc8e6da879d9$export$368813ca779e3c0f)(projectionsAsOfDate);
    const projectedFinancialsColumns = [
        {
            field: "metric",
            headerName: "",
            flex: 1.5,
            minWidth: 200
        },
        {
            field: "2026",
            headerName: "2026",
            flex: 1,
            minWidth: 120
        },
        {
            field: "2027",
            headerName: "2027",
            flex: 1,
            minWidth: 120
        },
        {
            field: "2028",
            headerName: "2028",
            flex: 1,
            minWidth: 120
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "body-s flex items-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "subdued italic",
                                        children: [
                                            "Data as of ",
                                            formattedAsOfDate
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5f7cc04a2cba0193$export$dbdcde5ca046596e), {
                                        children: "The data displayed is from the last closed, complete calendar period available in the company's accounting system. Hum does not display partial period data."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-s",
                                children: "Income statement and Projections are presented Annually, Balance Sheet data is presented Monthly. Total Equity Raised is not effected by timeframe. Click any metric to see an interactive deepdive in the Financials and Projections section."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6c3d2606e6cb499$export$208f774c0f9d0c93), {
                        title: "Income Statement",
                        data: incomeStatementData,
                        isLoading: isLoadingMetrics,
                        periodKind: (0, $c6c3d2606e6cb499$export$464989a30bad0982).LTM
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6c3d2606e6cb499$export$208f774c0f9d0c93), {
                        title: "Balance Sheet",
                        data: balanceSheetData,
                        isLoading: isLoadingMetrics,
                        periodKind: (0, $c6c3d2606e6cb499$export$464989a30bad0982).LAST_CLOSED_MONTH
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6c3d2606e6cb499$export$208f774c0f9d0c93), {
                        title: "Capital Structure",
                        data: capitalStructureData,
                        isLoading: isLoadingMetrics
                    }),
                    showProjectionMetrics && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            showM05 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6c3d2606e6cb499$export$208f774c0f9d0c93), {
                                title: "Projected Financials",
                                data: projectedFinancialsM05Data,
                                isLoading: isLoadingMetrics,
                                asOfDate: formattedProjectionsAsOfDate,
                                periodKind: (0, $c6c3d2606e6cb499$export$464989a30bad0982).NTM
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "heading-m mb-4",
                                        children: "Projected Financials Table (next 3 years)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $990d0f56d10de165$export$3ae2824b8d61e4dc), {
                                        data: projectedFinancialsData,
                                        columns: projectedFinancialsColumns
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6c3d2606e6cb499$export$208f774c0f9d0c93), {
                                title: "Projected Post-Closing Metrics",
                                data: postClosingMetricsData,
                                isLoading: isLoadingMetrics,
                                asOfDate: "Target Close Date",
                                periodKind: (0, $c6c3d2606e6cb499$export$464989a30bad0982).NTM
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5cbb248d749c652$export$6c0783fc6eb13aa1), {
                targetSection: "financial-highlights",
                label: "Jump to Financials & Projections"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("tL0U5");
var $7Y7Q4 = parcelRequire("7Y7Q4");
parcelRequire("agk6G");
var $eRTY4 = parcelRequire("eRTY4");
var $kTlwO = parcelRequire("kTlwO");

var $kdwja = parcelRequire("kdwja");

var $9QePP = parcelRequire("9QePP");

var $gxPgh = parcelRequire("gxPgh");

var $acw62 = parcelRequire("acw62");

var $jIDNV = parcelRequire("jIDNV");

var $jIDNV = parcelRequire("jIDNV");
const $a2756431b51c61a4$export$c0aca059b20b3008 = (0, $jIDNV.themeQuartz).withPart((0, $jIDNV.colorSchemeDark)).withParams({
    accentColor: "#6B7280",
    backgroundColor: "#1E293B",
    borderColor: "#334155",
    browserColorScheme: "dark",
    chromeBackgroundColor: {
        ref: "foregroundColor",
        mix: 0.07,
        onto: "backgroundColor"
    },
    fontFamily: {
        googleFont: "Inter"
    },
    foregroundColor: "#FFFFFF",
    headerFontSize: 14,
    headerVerticalPaddingScale: 1,
    rowHoverColor: "#1E293B",
    rowBorder: {
        color: "#0f172a"
    },
    rangeSelectionBorderStyle: "none",
    pinnedColumnBorder: "none",
    headerHeight: 42
});


(0, $jIDNV.ModuleRegistry).registerModules([
    (0, $jIDNV.AllCommunityModule)
]);
const $f48b4f99cd476d50$var$getStatusTooltip = (status)=>{
    const tooltips = {
        active: "We got valid credentials with all the needed scopes to get data",
        disconnected: "The client disconnected the connection or we lost the credentials. Credentials are not valid anymore, we need the client to reconnect.",
        deauthorized: "The client deauthorized us from their application. Credentials are not valid anymore, we need the client to reconnect.",
        authenticating: "The client started the connection but didn't finish it",
        pending: "The client started the connection but didn't finish it"
    };
    return tooltips[status] || "Provides information about credentials status";
};
const $f48b4f99cd476d50$var$getHealthTooltip = (health)=>{
    const tooltips = {
        healthy: "We pulled all the latest data",
        pending: "We are waiting for data to be pulled the first time",
        initial_pull_in_progress: "The first data pull is in progress",
        pull_in_progress: "Data pull is in progress",
        critical: "The last data pull failed",
        recovering: "The last data pull failed but was successfully retried",
        stale: "The last data pull was more than 7 days ago"
    };
    return tooltips[health] || "Provides information about data pull status";
};
function $f48b4f99cd476d50$export$bed5bc9cf2a9906d({ companyId: companyId, showActiveOnly: showActiveOnly = false }) {
    const { data: connectors, isLoading: isLoading } = (0, $7Y7Q4.useApiQuery)((0, $kTlwO.getCompanyConnectors), {
        params: {
            uuid: companyId
        }
    });
    const filteredConnectors = (0, $acw62.useMemo)(()=>{
        if (!connectors) return [];
        if (!showActiveOnly) return connectors;
        return connectors.filter((connector)=>connector.status === (0, $eRTY4.ConnectorStatus).Active);
    }, [
        connectors,
        showActiveOnly
    ]);
    const tableHeight = (0, $acw62.useMemo)(()=>{
        const rowCount = filteredConnectors.length;
        const headerHeight = 42;
        const rowHeight = 80;
        const calculatedHeight = headerHeight + rowCount * rowHeight;
        const maxHeight = 400;
        return Math.min(calculatedHeight, maxHeight);
    }, [
        filteredConnectors.length
    ]);
    const columnDefs = (0, $acw62.useMemo)(()=>[
            {
                field: "connectorType",
                headerName: "Service",
                headerClass: "heading-s",
                flex: 1.5,
                minWidth: 180,
                suppressHeaderMenuButton: true,
                cellRenderer: ({ value: value, data: data })=>{
                    const connectorIdentifier = data.meta?.connectorIdentifier ?? {
                        institutionName: "",
                        accounts: []
                    };
                    const { institutionName: institutionName, accounts: accounts = [] } = connectorIdentifier;
                    const accountNames = accounts ? `account${accounts.length > 1 ? "s" : ""} ending ${accounts.map((account)=>account.accountNumber).join(", ")}` : "";
                    const accountLabel = institutionName || data.name;
                    const formattedType = value ? value.charAt(0).toUpperCase() + value.slice(1) : "";
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col py-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: formattedType
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-xs text-slate-400",
                                children: accountLabel
                            }),
                            accounts.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-xs text-slate-400",
                                children: `${accounts.length} account${accounts.length > 1 ? "s" : ""} (${accountNames})`
                            })
                        ]
                    });
                }
            },
            {
                field: "createdAt",
                headerName: "Created at",
                headerClass: "heading-s",
                flex: 1,
                minWidth: 150,
                cellStyle: {
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.4"
                },
                valueFormatter: ({ value: value })=>{
                    return (0, $kdwja.formatDate)(value, {
                        hideTime: true
                    });
                }
            },
            {
                field: "status",
                headerName: "Status",
                headerClass: "heading-s",
                headerTooltip: "Provides information about credentials status",
                flex: 1,
                minWidth: 140,
                cellStyle: {
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.4"
                },
                tooltipValueGetter: ({ value: value })=>$f48b4f99cd476d50$var$getStatusTooltip(value),
                cellRenderer: ({ value: value })=>{
                    const statusColors = {
                        active: "bg-green-200",
                        pending: "bg-orange-200",
                        disconnected: "bg-red-200",
                        deauthorized: "bg-gray-200",
                        authenticating: "bg-blue-200"
                    };
                    const colorClass = statusColors[value] || "bg-gray-200";
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, $9QePP.default)("lozenge w-max rounded-xl px-2 py-1 text-brand-900", colorClass),
                        children: value
                    });
                }
            },
            {
                field: "healthStatus",
                headerName: "Health",
                headerClass: "heading-s",
                headerTooltip: "Provides information about data pull status",
                flex: 1,
                minWidth: 150,
                cellStyle: {
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.4"
                },
                tooltipValueGetter: ({ value: value })=>$f48b4f99cd476d50$var$getHealthTooltip(value),
                cellRenderer: ({ value: value })=>{
                    const healthColors = {
                        healthy: "bg-green-200",
                        pending: "bg-orange-200",
                        critical: "bg-red-200",
                        recovering: "bg-orange-200",
                        stale: "bg-gray-200",
                        initial_pull_in_progress: "bg-blue-200",
                        pull_in_progress: "bg-blue-200"
                    };
                    const colorClass = healthColors[value] || "bg-gray-200";
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, $9QePP.default)("lozenge w-max rounded-xl px-2 py-1 text-brand-900", colorClass),
                        children: value?.replace(/_/g, " ")
                    });
                }
            },
            {
                field: "lastSuccessPullAt",
                headerName: "Last Pull",
                headerClass: "heading-s",
                flex: 0.8,
                minWidth: 140,
                cellStyle: {
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.4"
                },
                valueFormatter: ({ value: value })=>{
                    if (!value) return "Never";
                    return (0, $kdwja.formatDate)(value, {
                        hideTime: true
                    });
                }
            }
        ], []);
    const defaultColDef = (0, $acw62.useMemo)(()=>({
            resizable: true,
            sortable: false,
            filter: false,
            wrapText: true,
            autoHeight: true,
            suppressHeaderMenuButton: true,
            suppressCellFlash: true,
            animateRows: false,
            cellStyle: {
                display: "flex",
                alignItems: "center",
                whiteSpace: "normal",
                wordWrap: "break-word",
                lineHeight: "1.4"
            }
        }), []);
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "rounded-[14px]-xl h-64 animate-pulse bg-slate-800"
    });
    if (!connectors || connectors.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("h-32 bg-slate-800/50", "border border-slate-700", "flex items-center justify-center rounded-xl"),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "text-slate-400",
            children: "No connectors configured"
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: filteredConnectors.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: (0, $9QePP.default)("h-32 bg-slate-800/50", "border border-slate-700", "flex items-center justify-center rounded-xl"),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-slate-400",
                children: "No active connectors found"
            })
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: (0, $9QePP.default)("ag-theme-quartz-dark rounded"),
            style: {
                height: `${tableHeight}px`
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gxPgh.AgGridReact), {
                theme: (0, $a2756431b51c61a4$export$c0aca059b20b3008),
                rowData: filteredConnectors,
                columnDefs: columnDefs,
                defaultColDef: defaultColDef,
                suppressAnimationFrame: true,
                suppressRowTransform: true,
                animateRows: false
            })
        })
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $dKUtl = parcelRequire("dKUtl");
parcelRequire("18L7n");
var $4qH0K = parcelRequire("4qH0K");

var $7gcOJ = parcelRequire("7gcOJ");
const $34c0a8205cd987b6$export$b18c6348c3479976 = ({ title: title })=>{
    const flags = (0, $7gcOJ.useFlags)();
    const showComingSoon = flags.enabled("show-coming-soon-placeholders");
    if (!showComingSoon) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center gap-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                className: "heading-m",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qH0K.Chip), {
                text: (0, $dKUtl.COMING_SOON)
            })
        ]
    });
};



var $3djtJ = parcelRequire("3djtJ");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $ayMG0 = parcelRequire("ayMG0");

var $gxPgh = parcelRequire("gxPgh");

var $acw62 = parcelRequire("acw62");

var $jIDNV = parcelRequire("jIDNV");

var $9QePP = parcelRequire("9QePP");


var $kdwja = parcelRequire("kdwja");
parcelRequire("UXGeS");
var $7Y7Q4 = parcelRequire("7Y7Q4");

var $9ohvd = parcelRequire("9ohvd");

var $dKUtl = parcelRequire("dKUtl");

var $lgOhz = parcelRequire("lgOhz");
(0, $jIDNV.ModuleRegistry).registerModules([
    (0, $jIDNV.AllCommunityModule)
]);
function $3a2a98c7ce0fe243$export$66e3f2781a280906({ opportunityId: opportunityId }) {
    const sfdcData = (0, $7Y7Q4.useApiQuery)((0, $lgOhz.getSFDCData));
    const sfdcOpportunityId = opportunityId ? sfdcData.data?.find((data)=>data.id === opportunityId)?.id : sfdcData.data?.[0]?.id;
    const { data: funds } = (0, $7Y7Q4.useApiQuery)((0, $9ohvd.getFunds));
    const fundCreditBoxIds = (funds || []).map((fund)=>fund.id);
    const { data: criteriaData, isLoading: isLoading } = (0, $7Y7Q4.useApiQuery)((0, $9ohvd.getInvestmentCriteria), {
        params: {
            sfdcOpportunityId: sfdcOpportunityId || "",
            creditBoxIds: fundCreditBoxIds
        },
        enabled: fundCreditBoxIds.length > 0
    });
    const data = (0, $acw62.useMemo)(()=>{
        if (!criteriaData?.creditBoxResultDetails) return [];
        return criteriaData.creditBoxResultDetails.map((result)=>{
            const capitalProductCriteria = result.details[0]?.details?.find((d)=>d.featureName === "Capital Product Type");
            return {
                creditBoxId: result.creditBoxId,
                creditBoxName: result.creditBoxName,
                capitalProductType: capitalProductCriteria?.creditBoxValue || null,
                score: result.score,
                value: result.score > 0 ? (0, $dKUtl.CreditBoxResult).PASS : (0, $dKUtl.CreditBoxResult).FAIL,
                lastPull: result.updatedAt,
                details: result.details
            };
        }).sort((a, b)=>{
            if (a.value === (0, $dKUtl.CreditBoxResult).PASS && b.value === (0, $dKUtl.CreditBoxResult).FAIL) return -1;
            if (a.value === (0, $dKUtl.CreditBoxResult).FAIL && b.value === (0, $dKUtl.CreditBoxResult).PASS) return 1;
            return 0;
        });
    }, [
        criteriaData
    ]);
    const tableHeight = (0, $acw62.useMemo)(()=>{
        const rowCount = data.length;
        const headerHeight = 42;
        const rowHeight = 52;
        const calculatedHeight = headerHeight + rowCount * rowHeight;
        const maxHeight = 400;
        return Math.min(calculatedHeight, maxHeight);
    }, [
        data.length
    ]);
    const columnDefs = (0, $acw62.useMemo)(()=>[
            {
                field: "creditBoxName",
                headerName: "Strategy Name",
                headerClass: "heading-s",
                flex: 2,
                minWidth: 200,
                suppressHeaderMenuButton: true,
                wrapText: true,
                autoHeight: true,
                cellStyle: {
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.4",
                    paddingTop: "12px",
                    paddingBottom: "12px"
                }
            },
            {
                field: "capitalProductType",
                headerName: "Capital Product Type",
                headerClass: "heading-s",
                flex: 1.5,
                minWidth: 180,
                suppressHeaderMenuButton: true,
                wrapText: true,
                autoHeight: true,
                cellStyle: {
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.4",
                    paddingTop: "12px",
                    paddingBottom: "12px"
                }
            },
            {
                field: "score",
                headerName: "Score",
                headerClass: "heading-s",
                flex: 0.8,
                minWidth: 100,
                suppressHeaderMenuButton: true,
                wrapText: true,
                autoHeight: true,
                valueFormatter: ({ value: value })=>{
                    return value?.toFixed(1) || "-";
                },
                cellStyle: {
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.4",
                    paddingTop: "12px",
                    paddingBottom: "12px"
                }
            },
            {
                field: "value",
                headerName: "Value",
                headerClass: "heading-s",
                flex: 1,
                minWidth: 120,
                suppressHeaderMenuButton: true,
                wrapText: true,
                autoHeight: true,
                cellRenderer: ({ value: value })=>{
                    const valueColors = {
                        [(0, $dKUtl.CreditBoxResult).PASS]: "bg-green-200",
                        [(0, $dKUtl.CreditBoxResult).FAIL]: "bg-red-200"
                    };
                    const colorClass = valueColors[value] || "bg-gray-200";
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, $9QePP.default)("lozenge w-max rounded-xl px-2 py-1 text-brand-900", colorClass),
                        children: value
                    });
                },
                cellStyle: {
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.4",
                    paddingTop: "12px",
                    paddingBottom: "12px"
                }
            },
            {
                field: "lastPull",
                headerName: "Last Pull",
                headerClass: "heading-s",
                flex: 1,
                minWidth: 140,
                suppressHeaderMenuButton: true,
                wrapText: true,
                autoHeight: true,
                valueFormatter: ({ value: value })=>{
                    if (!value) return "-";
                    return (0, $kdwja.formatDate)(value, {
                        hideTime: true
                    });
                },
                cellStyle: {
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.4",
                    paddingTop: "12px",
                    paddingBottom: "12px"
                }
            }
        ], []);
    const defaultColDef = (0, $acw62.useMemo)(()=>({
            resizable: true,
            sortable: false,
            filter: false,
            suppressHeaderMenuButton: true,
            suppressCellFlash: true,
            animateRows: false,
            wrapText: true,
            autoHeight: true,
            wrapHeaderText: true,
            autoHeaderHeight: true,
            cellStyle: {
                display: "flex",
                alignItems: "center",
                paddingTop: "12px",
                paddingBottom: "12px"
            }
        }), []);
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "h-64 animate-pulse rounded-xl bg-slate-800"
    });
    if (!data || data.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("h-32 bg-slate-800/50", "border border-slate-700", "flex items-center justify-center rounded-xl"),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "text-slate-400",
            children: "No investment criteria available"
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("ag-theme-quartz-dark rounded"),
        style: {
            height: `${tableHeight}px`
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gxPgh.AgGridReact), {
            theme: (0, $a2756431b51c61a4$export$c0aca059b20b3008),
            rowData: data,
            columnDefs: columnDefs,
            defaultColDef: defaultColDef,
            suppressAnimationFrame: true,
            suppressRowTransform: true,
            animateRows: false
        })
    });
}



var $cXDYR = parcelRequire("cXDYR");

var $r2uF6 = parcelRequire("r2uF6");

parcelRequire("tL0U5");
var $7Y7Q4 = parcelRequire("7Y7Q4");




function $7233dd35ac4f7780$export$621348d1e3862539({ companyId: companyId, opportunityId: opportunityId }) {
    const [showActiveOnly, setShowActiveOnly] = (0, $acw62.useState)(false);
    const { data: backgroundCheckMetrics } = (0, $7Y7Q4.useApiQuery)((0, $1cf2065342823807$export$33bf4d4bd60a05b5), {
        params: {
            labels: [
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_BACKGROUND_CHECK
            ]
        }
    });
    const showDataSources = (0, $r2uF6.useAtomValue)((0, $e8aa26b1ef42f359$export$4bba709a6a23ef4d));
    const setAIMContextView = (0, $r2uF6.useSetAtom)((0, $57f1ca4385a7301a$export$c65e5de3b3a2e247));
    const handleViewDetails = ()=>{
        setAIMContextView({
            type: (0, $0e9c1faaf8e0eb7e$export$88fa5c7cfbd4d210).INVESTMENT_CRITERIA,
            isExpanded: true
        });
    };
    const backgroundCheckValue = backgroundCheckMetrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_BACKGROUND_CHECK)?.values;
    const backgroundCheckColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(backgroundCheckValue?.[0]?.formattedValue || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_BACKGROUND_CHECK);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-4 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "heading-m",
                                        children: "Investment Criteria"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        role: "button",
                                        onClick: handleViewDetails,
                                        className: (0, $9QePP.default)("group", "text-link", "flex cursor-pointer items-center gap-2"),
                                        children: [
                                            "View Details",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cXDYR.default), {
                                                className: "size-4 stroke-brand-300 group-hover:stroke-brand-400"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3a2a98c7ce0fe243$export$66e3f2781a280906), {
                                opportunityId: opportunityId
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt-6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-4 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "heading-m",
                                        children: "Connectivity"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-sm text-slate-200",
                                                children: "Show Active Only"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3djtJ.Toggle), {
                                                checked: showActiveOnly,
                                                onChange: setShowActiveOnly,
                                                testId: "show-active-only-toggle"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f48b4f99cd476d50$export$bed5bc9cf2a9906d), {
                                companyId: companyId,
                                showActiveOnly: showActiveOnly
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34c0a8205cd987b6$export$b18c6348c3479976), {
                        title: "Cap Table"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34c0a8205cd987b6$export$b18c6348c3479976), {
                        title: "Sources & Uses"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34c0a8205cd987b6$export$b18c6348c3479976), {
                        title: "Corporate Structure"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34c0a8205cd987b6$export$b18c6348c3479976), {
                        title: "Lien Search"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt-6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "heading-m mb-3",
                                children: "Background Checks"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mb-2",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c2560609a068b22c$export$4bbb6880c2bce4a2), {
                                            text: backgroundCheckColorized.value,
                                            maxLength: 1800
                                        })
                                    }),
                                    showDataSources && backgroundCheckColorized.source && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: (0, $9QePP.default)("mt-1 text-[9px] font-medium tracking-wide", backgroundCheckColorized.sourceClassName),
                                        children: backgroundCheckColorized.source
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $411db1f77d5b08b1$export$7752db215400b41d), {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5cbb248d749c652$export$6c0783fc6eb13aa1), {
                targetSection: "capital-and-deal-structure",
                label: "Jump to Capital & Deal Structure"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("tL0U5");
var $7Y7Q4 = parcelRequire("7Y7Q4");

var $9QePP = parcelRequire("9QePP");





var $r2uF6 = parcelRequire("r2uF6");

function $6a59b81d3abdf9af$export$18819ff39d34bfd1() {
    const { data: summary } = (0, $7Y7Q4.useApiQuery)((0, $1cf2065342823807$export$33bf4d4bd60a05b5), {
        params: {
            labels: [
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_TRANSACTION_SUMMARY
            ]
        }
    });
    const showDataSources = (0, $r2uF6.useAtomValue)((0, $e8aa26b1ef42f359$export$4bba709a6a23ef4d));
    const summaryColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(summary?.[0]?.values)?.formattedValue || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_TRANSACTION_SUMMARY);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c2560609a068b22c$export$4bbb6880c2bce4a2), {
                    text: summaryColorized.value,
                    maxLength: 1800
                })
            }),
            showDataSources && summaryColorized.source && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: (0, $9QePP.default)("mt-1 text-[9px] tracking-wide", summaryColorized.sourceClassName),
                children: summaryColorized.source
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $411db1f77d5b08b1$export$7752db215400b41d), {})
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("tL0U5");
var $7Y7Q4 = parcelRequire("7Y7Q4");


var $9QePP = parcelRequire("9QePP");





var $r2uF6 = parcelRequire("r2uF6");

function $9db023a52503f1cc$export$f228e0c68fce74ea() {
    const { data: rationale } = (0, $7Y7Q4.useApiQuery)((0, $1cf2065342823807$export$33bf4d4bd60a05b5), {
        params: {
            labels: [
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_INVESTMENT_RATIONALE
            ]
        }
    });
    const showDataSources = (0, $r2uF6.useAtomValue)((0, $e8aa26b1ef42f359$export$4bba709a6a23ef4d));
    const rationaleColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(rationale?.[0]?.values)?.formattedValue || "-", (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_INVESTMENT_RATIONALE);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c2560609a068b22c$export$4bbb6880c2bce4a2), {
                    text: rationaleColorized.value,
                    maxLength: 1800
                })
            }),
            showDataSources && rationaleColorized.source && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: (0, $9QePP.default)("mt-1 text-[9px] font-medium tracking-wide", rationaleColorized.sourceClassName),
                children: rationaleColorized.source
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $411db1f77d5b08b1$export$7752db215400b41d), {})
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");


var $7gcOJ = parcelRequire("7gcOJ");

var $dKUtl = parcelRequire("dKUtl");
function $bccbb7cbed705653$export$59e0ec2e7804451e() {
    const flags = (0, $7gcOJ.useFlags)();
    const showComingSoon = flags.enabled("show-coming-soon-placeholders");
    if (!showComingSoon) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: (0, $9QePP.default)("body-s", "text-slate-600 dark:text-slate-300"),
                    children: (0, $dKUtl.COMING_SOON)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5cbb248d749c652$export$6c0783fc6eb13aa1), {
                targetSection: "returns-and-risk",
                label: "Jump to Returns & Risk"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $dKUtl = parcelRequire("dKUtl");

var $7gcOJ = parcelRequire("7gcOJ");
function $31b4459d5cac463e$export$c08826fed26bda08() {
    const flags = (0, $7gcOJ.useFlags)();
    const showComingSoon = flags.enabled("show-coming-soon-placeholders");
    const valuationData = [
        ...showComingSoon ? [
            {
                label: "Total Value",
                value: (0, $dKUtl.COMING_SOON)
            },
            {
                label: "Methodology",
                value: (0, $dKUtl.COMING_SOON)
            },
            {
                label: "Loan to Value",
                value: (0, $dKUtl.COMING_SOON)
            }
        ] : []
    ];
    if (!showComingSoon) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "space-y-12",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6c3d2606e6cb499$export$208f774c0f9d0c93), {
            title: "Valuation",
            data: valuationData
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");



/**
 * Parses a markdown table string into structured data
 * @param markdown - The markdown table string
 * @returns Array of objects representing table rows
 */ function $2d887e44ea6d234f$export$60ee18ce74e9ea9e(markdown) {
    if (!markdown) return [];
    const lines = markdown.trim().split("\n");
    if (lines.length < 3) return [];
    const headerLine = lines[0];
    const headers = headerLine.split("|").map((h)=>h.trim()).filter((h)=>h !== "");
    const keys = headers.map((header)=>header.toLowerCase().replace(/[^\w\s]/g, "").replace(/\s+(.)/g, (_, char)=>char.toUpperCase()).replace(/\s/g, ""));
    const dataRows = lines.slice(2);
    return dataRows.map((line)=>{
        const values = line.split("|").map((v)=>v.trim()).filter((v)=>v !== "");
        if (values.length !== keys.length) return null;
        const row = {};
        keys.forEach((key, index)=>{
            row[key] = values[index];
        });
        return row;
    }).filter((row)=>row !== null);
}



var $acw62 = parcelRequire("acw62");
parcelRequire("iuVpE");
var $lvlqo = parcelRequire("lvlqo");


parcelRequire("gCemA");
var $hJQbt = parcelRequire("hJQbt");
parcelRequire("tL0U5");
var $7Y7Q4 = parcelRequire("7Y7Q4");


const $72591427a577b488$var$WebsiteCellRenderer = ({ value: value })=>{
    if (!value) return "-";
    return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        href: value,
        target: "_blank",
        rel: "noreferrer",
        className: "text-link",
        children: "Visit website"
    });
};
const $72591427a577b488$var$CellWithLinksRenderer = ({ value: value })=>{
    if (!value) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: "-"
    });
    const parts = (0, $hJQbt.parseMarkdownLinks)(value);
    const textParts = parts.filter((part)=>typeof part === "string");
    const linkParts = parts.filter((part)=>typeof part !== "string");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col gap-3 py-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "break-words",
                children: textParts.join(" ")
            }),
            linkParts.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex flex-wrap gap-2",
                children: linkParts.map((part, index)=>{
                    if (typeof part === "string") return null;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eb3baba2011e6e91$export$a6c7ac8248d6e38a), {
                        href: part.url,
                        title: part.text
                    }, index);
                })
            })
        ]
    });
};
function $72591427a577b488$export$64c23eed0765bd8a() {
    const { data: competitiveAnalysisMetrics, isLoading: isLoadingCompetitiveAnalysis } = (0, $7Y7Q4.useApiQuery)((0, $1cf2065342823807$export$33bf4d4bd60a05b5), {
        params: {
            labels: [
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_COMPETITORS_TOP_5
            ]
        }
    });
    const competitorsData = (0, $acw62.useMemo)(()=>{
        const competitiveAnalysis = competitiveAnalysisMetrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_COMPETITORS_TOP_5)?.values;
        if (!competitiveAnalysis) return [];
        const parsedData = (0, $2d887e44ea6d234f$export$60ee18ce74e9ea9e)(competitiveAnalysis?.[0]?.formattedValue || "");
        return parsedData.map((row)=>({
                ...row,
                websiteUrl: row.websiteUrl ? (0, $lvlqo.ensureHttps)(row.websiteUrl) : ""
            }));
    }, [
        competitiveAnalysisMetrics
    ]);
    const competitorTableColumns = (0, $acw62.useMemo)(()=>{
        if (competitorsData.length === 0) return [];
        const firstRow = competitorsData[0];
        const keys = Object.keys(firstRow);
        return keys.map((key)=>{
            const headerMap = {
                companyName: "Name",
                websiteUrl: "Website",
                estimatedRevenue: "Estimated Revenue",
                headcount: "Headcount",
                headquartersLocation: "HQ Location",
                naicsId: "NAICS ID",
                keyDifferences: "Key Differences",
                score: "Score"
            };
            const column = {
                field: key,
                headerName: headerMap[key] || key,
                flex: key === "keyDifferences" ? 3 : 1,
                minWidth: key === "keyDifferences" ? 300 : key === "companyName" || key === "estimatedRevenue" || key === "headcount" ? 160 : 140
            };
            if (key === "websiteUrl") column.cellRenderer = $72591427a577b488$var$WebsiteCellRenderer;
            if (key === "estimatedRevenue" || key === "headcount" || key === "headquartersLocation") {
                column.cellRenderer = $72591427a577b488$var$CellWithLinksRenderer;
                column.wrapText = true;
                column.autoHeight = true;
            }
            if (key === "score") column.headerTooltip = "This score is a competitor match score, which factors in a combination of offering similarity, market visibility, and market traction. A score of 5 represents the strongest possible match.";
            return column;
        });
    }, [
        competitorsData
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-8",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34c0a8205cd987b6$export$b18c6348c3479976), {
                            title: "Top 5 Customers"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "heading-m mb-4",
                                children: "Top 5 Competitors"
                            }),
                            isLoadingCompetitiveAnalysis ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex w-full flex-col gap-4",
                                children: [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5
                                ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: (0, $9QePP.default)("h-12 w-full bg-slate-700", "animate-pulse rounded")
                                    }, i))
                            }) : competitorsData.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mb-2",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $990d0f56d10de165$export$3ae2824b8d61e4dc), {
                                            data: competitorsData,
                                            columns: competitorTableColumns
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mb-2",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "body-micro subdued",
                                            children: "Scores are based on weighted factors including product/offering similarity, revenue proximity, geographic relevance, search visibility across multiple sources, and publicly reported traction. Higher scores indicate a closer competitive match."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $411db1f77d5b08b1$export$7752db215400b41d), {})
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-s subdued",
                                children: "No competitive analysis data available."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34c0a8205cd987b6$export$b18c6348c3479976), {
                            title: "Top 5 Suppliers"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5cbb248d749c652$export$6c0783fc6eb13aa1), {
                targetSection: "company-background",
                label: "Jump to Company Background"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");

var $iDSqy = parcelRequire("iDSqy");

parcelRequire("UXGeS");
var $7Y7Q4 = parcelRequire("7Y7Q4");

var $lgOhz = parcelRequire("lgOhz");
parcelRequire("agk6G");
var $kTlwO = parcelRequire("kTlwO");

var $cstYm = parcelRequire("cstYm");

var $62e6P = parcelRequire("62e6P");



var $dKUtl = parcelRequire("dKUtl");


var $7gcOJ = parcelRequire("7gcOJ");


function $30f5b28858bdec5d$export$6875ed68e27eae29({ opportunityId: opportunityId } = {}) {
    const flags = (0, $7gcOJ.useFlags)();
    const showComingSoon = flags.enabled("show-coming-soon-placeholders");
    const showPreAlphaFields = flags.enabled("show-pre-alpha-fields");
    const useFinanceLabDefault = flags.enabled("use-finance-lab-metrics");
    const sfdcData = (0, $7Y7Q4.useApiQuery)((0, $lgOhz.getSFDCData));
    const company = (0, $7Y7Q4.useApiQuery)((0, $kTlwO.getCompany));
    const { text: text } = (0, $aa9920dff4a9c63d$export$9c91c33a46c3167e)();
    const data = opportunityId ? sfdcData.data?.find((data)=>data.id === opportunityId) : sfdcData.data?.[0];
    const { data: legalNameMetrics } = (0, $7Y7Q4.useApiQuery)((0, $1cf2065342823807$export$33bf4d4bd60a05b5), {
        params: {
            labels: [
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_LEGAL_NAME
            ]
        }
    });
    const { data: crmOpportunityMetrics } = (0, $7Y7Q4.useApiQuery)((0, $1cf2065342823807$export$33bf4d4bd60a05b5), {
        params: {
            labels: [
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CRM_OPPORTUNITY_ID,
                (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CRM_OPPORTUNITY_NAME
            ]
        }
    });
    const legalNameValues = legalNameMetrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_LEGAL_NAME)?.values;
    const legalNameValue = (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(legalNameValues);
    const crmOpportunityIdValues = crmOpportunityMetrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CRM_OPPORTUNITY_ID)?.values;
    const crmOpportunityIdValue = (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(crmOpportunityIdValues);
    const crmOpportunityNameValues = crmOpportunityMetrics?.find((metric)=>metric.info.derived.label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CRM_OPPORTUNITY_NAME)?.values;
    const crmOpportunityNameValue = (0, $2a5011cb4beaeebb$export$67351c7e7093bcbe)(crmOpportunityNameValues);
    // Colorized values for general data
    const legalNameColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(legalNameValue?.formattedValue || legalNameValue?.value, (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_LEGAL_NAME);
    const industryColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $cstYm.NAICS_INDUSTRY_GROUP_OPTIONS)[company.data?.capitalApplication.selfReportedIndustry], (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).LEGACY_BACKEND, "company.capitalApplication.selfReportedIndustry");
    const revenueModelColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $62e6P.REVENUE_MODEL_V6)[company.data?.capitalApplication.revenueModel], (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).LEGACY_BACKEND, "company.capitalApplication.revenueModel");
    const linkedinColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(sfdcData.data?.[0]?.companyPageLinkedinUrl, (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).SFDC, "sfdc.companyPageLinkedinUrl");
    const generalData = [
        ...showPreAlphaFields ? [
            {
                label: "Legal Name",
                value: legalNameColorized.value,
                valueClassName: legalNameColorized.className,
                source: legalNameColorized.source,
                sourceClassName: legalNameColorized.sourceClassName
            }
        ] : [],
        {
            label: "Self-Reported Industry",
            value: industryColorized.value,
            valueClassName: industryColorized.className,
            source: industryColorized.source,
            sourceClassName: industryColorized.sourceClassName
        },
        {
            label: "LinkedIn",
            value: linkedinColorized.value !== "-" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                href: linkedinColorized.value,
                target: "_blank",
                rel: "noreferrer",
                className: "text-link flex items-center gap-2 group"
            }, `${company.data?.name} - LinkedIn`, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iDSqy.default), {
                className: "h-4 w-4 fill-none stroke-brand-300 group-hover:stroke-brand-400"
            })) : "-",
            source: linkedinColorized.value ? linkedinColorized.source : null,
            sourceClassName: linkedinColorized.sourceClassName
        },
        {
            label: "Revenue Model",
            value: revenueModelColorized.value,
            valueClassName: revenueModelColorized.className,
            source: revenueModelColorized.source,
            sourceClassName: revenueModelColorized.sourceClassName
        }
    ];
    // Colorized values for identifiers data
    const sfdcAccountColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(data?.accountName, (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).SFDC, "sfdc.accountName");
    const crmOpportunityId = useFinanceLabDefault ? crmOpportunityIdValue?.formattedValue || crmOpportunityIdValue?.value : data?.id;
    const sfdcOpportunityIdColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(crmOpportunityId, useFinanceLabDefault ? (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB : (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).SFDC, useFinanceLabDefault ? (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CRM_OPPORTUNITY_ID : "sfdc.id");
    const crmOpportunityName = useFinanceLabDefault ? crmOpportunityNameValue?.formattedValue || crmOpportunityNameValue?.value : data?.opportunityName;
    const sfdcOpportunityNameColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(crmOpportunityName, useFinanceLabDefault ? (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB : (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).SFDC, useFinanceLabDefault ? (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_CRM_OPPORTUNITY_NAME : "sfdc.opportunityName");
    const icmIdColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(company.data?.id, (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).LEGACY_BACKEND, "company.id");
    const aiNaicsColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)((0, $cstYm.NAICS_6_DIGIT_CODE)[text[(0, $b082cd036e01ace0$export$8eb29354037a9c7c).COMPANY_METADATA]?.data?.naicsCode] || text[(0, $b082cd036e01ace0$export$8eb29354037a9c7c).COMPANY_METADATA]?.data?.naicsCode, (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).MEMO_TEXT, "memoText.companyMetadata.naicsCode");
    const humNaicsCodeListColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(data?.naicsCodeList, (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).SFDC, "sfdc.naicsCodeList");
    const humNaicsIndustryColorized = (0, $3ed9e5cde76bd4e1$export$59157b4b30178565)(data?.naicsIndustry, (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).SFDC, "sfdc.naicsIndustry");
    const identifiersData = [
        {
            label: "Hum ID",
            value: icmIdColorized.value,
            valueClassName: icmIdColorized.className,
            source: icmIdColorized.source,
            sourceClassName: icmIdColorized.sourceClassName
        },
        ...showComingSoon ? [
            {
                label: "DUNS",
                value: (0, $dKUtl.COMING_SOON)
            }
        ] : [],
        {
            label: "Account ID",
            value: sfdcAccountColorized.value !== "-" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                href: `https://captec.lightning.force.com/lightning/r/Account/${sfdcAccountColorized.value}/view`,
                target: "_blank",
                rel: "noreferrer",
                className: "text-link flex items-center gap-2 group"
            }, sfdcAccountColorized.value, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iDSqy.default), {
                className: "h-4 w-4 fill-none stroke-brand-300 group-hover:stroke-brand-400"
            })) : "-",
            source: sfdcAccountColorized.value ? sfdcAccountColorized.source : null,
            sourceClassName: sfdcAccountColorized.sourceClassName
        },
        {
            label: "Hum NAICS Code",
            value: humNaicsCodeListColorized.value,
            valueClassName: humNaicsCodeListColorized.className,
            source: humNaicsCodeListColorized.source,
            sourceClassName: humNaicsCodeListColorized.sourceClassName
        },
        {
            label: "Opportunity Name",
            value: sfdcOpportunityNameColorized.value,
            valueClassName: sfdcOpportunityNameColorized.className,
            source: sfdcOpportunityNameColorized.source,
            sourceClassName: sfdcOpportunityNameColorized.sourceClassName
        },
        {
            label: "Hum NAICS Industry",
            value: humNaicsIndustryColorized.value,
            valueClassName: humNaicsIndustryColorized.className,
            source: humNaicsIndustryColorized.source,
            sourceClassName: humNaicsIndustryColorized.sourceClassName
        },
        {
            label: "Opportunity ID",
            value: sfdcOpportunityIdColorized.value !== "-" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                href: `https://captec.lightning.force.com/lightning/r/Opportunity/${sfdcOpportunityIdColorized.value}/view`,
                target: "_blank",
                rel: "noreferrer",
                className: "text-link flex items-center gap-2 group"
            }, sfdcOpportunityIdColorized.value, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iDSqy.default), {
                className: "h-4 w-4 fill-none stroke-brand-300 group-hover:stroke-brand-400"
            })) : "-",
            source: sfdcOpportunityIdColorized.value ? sfdcOpportunityIdColorized.source : null,
            sourceClassName: sfdcOpportunityIdColorized.sourceClassName
        },
        {
            label: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "flex items-center gap-2"
            }, "NAICS", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "flex items-center justify-center rounded-full bg-slate-600 px-2 py-1"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f7c08395b53fdc4$export$2e2bcd8739ae039), {
                className: "h-4 w-4"
            }))),
            value: aiNaicsColorized.value,
            valueClassName: aiNaicsColorized.className,
            source: aiNaicsColorized.source,
            sourceClassName: aiNaicsColorized.sourceClassName
        }
    ];
    return {
        generalData: generalData,
        identifiersData: identifiersData,
        isLoading: sfdcData.isLoading,
        error: sfdcData.error
    };
}


function $db4463712dde00ea$export$e2f70c04e8dedc56({ opportunityId: opportunityId }) {
    const { generalData: generalData, identifiersData: identifiersData } = (0, $30f5b28858bdec5d$export$6875ed68e27eae29)({
        opportunityId: opportunityId
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-12",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6c3d2606e6cb499$export$208f774c0f9d0c93), {
                title: "General",
                data: generalData
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6c3d2606e6cb499$export$208f774c0f9d0c93), {
                title: "Identifiers",
                data: identifiersData
            })
        ]
    });
}



var $lvlqo = parcelRequire("lvlqo");

var $ayMG0 = parcelRequire("ayMG0");

var $dA5Dq = parcelRequire("dA5Dq");

var $2hw4u = parcelRequire("2hw4u");
var $fRJCp = parcelRequire("fRJCp");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");
function $e0633724389f295f$export$d74477c340368ec6({ id: id, title: title, children: children, defaultOpen: defaultOpen = false }) {
    const [isOpen, setIsOpen] = (0, $acw62.useState)(defaultOpen);
    const generatedId = (0, $acw62.useId)();
    const panelId = id ? `${id}-panel` : `${generatedId}-panel`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        id: id,
        className: "w-full",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                onClick: ()=>setIsOpen((prev)=>!prev),
                "aria-expanded": isOpen,
                "aria-controls": panelId,
                className: (0, $9QePP.default)("flex cursor-pointer items-center justify-between border-b py-6", isOpen ? "border-b-0" : "border-slate-700"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "display-s",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                        animate: {
                            rotate: isOpen ? 180 : 0
                        },
                        transition: {
                            duration: 0.2,
                            ease: "easeInOut"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dA5Dq.default), {
                            className: "size-5 shrink-0"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2hw4u.AnimatePresence), {
                initial: false,
                children: isOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                    id: panelId,
                    initial: "collapsed",
                    animate: "open",
                    exit: "collapsed",
                    variants: {
                        open: {
                            opacity: 1,
                            height: "auto",
                            transition: {
                                opacity: {
                                    duration: 0.6,
                                    ease: [
                                        0.04,
                                        0.62,
                                        0.23,
                                        0.98
                                    ]
                                },
                                height: {
                                    duration: 0.2,
                                    ease: [
                                        0.04,
                                        0.62,
                                        0.23,
                                        0.98
                                    ]
                                }
                            }
                        },
                        collapsed: {
                            opacity: 0,
                            height: 0,
                            transition: {
                                opacity: {
                                    duration: 0.2,
                                    ease: [
                                        0.04,
                                        0.62,
                                        0.23,
                                        0.98
                                    ]
                                },
                                height: {
                                    duration: 0.6,
                                    ease: [
                                        0.04,
                                        0.62,
                                        0.23,
                                        0.98
                                    ]
                                }
                            }
                        }
                    },
                    className: "overflow-hidden border-b border-slate-700",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "pb-8",
                        children: children
                    })
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $r2uF6 = parcelRequire("r2uF6");



var $ayMG0 = parcelRequire("ayMG0");

var $r2uF6 = parcelRequire("r2uF6");



var $acw62 = parcelRequire("acw62");
var $1cd14341ea007c9d$export$b0f66506e639cd60;
(function(MetricsType) {
    MetricsType["INCOME_STATEMENT"] = "incomeStatement";
    MetricsType["BALANCE_SHEET"] = "balanceSheet";
})($1cd14341ea007c9d$export$b0f66506e639cd60 || ($1cd14341ea007c9d$export$b0f66506e639cd60 = {}));



var $ayMG0 = parcelRequire("ayMG0");

var $r2uF6 = parcelRequire("r2uF6");

var $eQbhf = parcelRequire("eQbhf");

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $0c6ba30950984529$var$CalendarIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
    }));
}
const $0c6ba30950984529$var$ForwardRef = $acw62.forwardRef($0c6ba30950984529$var$CalendarIcon);
var $0c6ba30950984529$export$2e2bcd8739ae039 = $0c6ba30950984529$var$ForwardRef;


var $dA5Dq = parcelRequire("dA5Dq");
var $cXDYR = parcelRequire("cXDYR");
function $1cdcb35ed908b5f9$export$850d3a5442e004d9({ categories: categories, selectedCategoryId: selectedCategoryId, selectedOptionId: selectedOptionId, onSelect: onSelect, displayLabel: displayLabel }) {
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [hoveredCategoryId, setHoveredCategoryId] = (0, $acw62.useState)(null);
    const menuRef = (0, $acw62.useRef)(null);
    const toggleMenu = ()=>{
        if (isOpen) setHoveredCategoryId(null);
        else setHoveredCategoryId(selectedCategoryId);
        setIsOpen(!isOpen);
    };
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
                setHoveredCategoryId(null);
            }
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen
    ]);
    const handleCategoryHover = (categoryId)=>{
        setHoveredCategoryId(categoryId);
    };
    const handleOptionClick = (categoryId, optionId)=>{
        onSelect(categoryId, optionId);
        setIsOpen(false);
        setHoveredCategoryId(null);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "relative",
        ref: menuRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                onClick: toggleMenu,
                className: (0, $9QePP.default)("period-selector-button", "flex w-fit cursor-pointer items-center justify-between gap-3 rounded-md border border-slate-600 bg-slate-800 px-3 py-2", "body-s text-gray-200 transition-colors hover:border-slate-500 hover:bg-slate-700"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0c6ba30950984529$export$2e2bcd8739ae039), {
                                className: "size-4 text-gray-400"
                            }),
                            displayLabel
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dA5Dq.default), {
                        className: (0, $9QePP.default)("size-3 text-gray-400 transition-transform duration-200", isOpen && "rotate-180")
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("absolute right-0 top-full mt-1", "z-50", "flex items-start"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, $9QePP.default)("w-[180px]", "rounded-l-lg bg-slate-800 shadow-400", "flex flex-col"),
                        children: categories.map((category)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onMouseEnter: ()=>handleCategoryHover(category.id),
                                className: (0, $9QePP.default)("period-selector-category", "flex items-center justify-between px-4 py-3", "body-s text-left transition-colors", hoveredCategoryId === category.id ? "bg-slate-700 text-white" : "text-gray-300 hover:bg-slate-700/50"),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: category.label
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cXDYR.default), {
                                        className: "size-4"
                                    })
                                ]
                            }, category.id))
                    }),
                    hoveredCategoryId && (()=>{
                        const category = categories.find((c)=>c.id === hoveredCategoryId);
                        if (!category) return null;
                        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: (0, $9QePP.default)("w-[220px]", "rounded-r-lg bg-slate-800 shadow-400", "flex flex-col p-2"),
                            children: category.options.map((option)=>{
                                const isSelected = selectedCategoryId === category.id && selectedOptionId === option.id;
                                const isDisabled = option.disabled;
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>{
                                        if (!isDisabled) handleOptionClick(category.id, option.id);
                                    },
                                    disabled: isDisabled,
                                    className: (0, $9QePP.default)("period-selector-option", "flex items-center gap-3 rounded px-3 py-2.5", "body-s text-left transition-colors", isDisabled ? "cursor-not-allowed opacity-40" : "hover:bg-slate-700"),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: (0, $9QePP.default)("flex size-4 shrink-0 items-center justify-center rounded-full border-2", isSelected ? "border-blue-500" : "border-gray-500"),
                                            children: isSelected && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "size-2 rounded-full bg-blue-500"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: (0, $9QePP.default)("flex-1", isSelected ? "text-white" : "text-gray-300"),
                                            children: option.label
                                        })
                                    ]
                                }, option.id);
                            })
                        });
                    })()
                ]
            })
        ]
    });
}





var $gngdn = parcelRequire("gngdn");

var $acw62 = parcelRequire("acw62");
const $25097ef2e76a3499$var$MONTHLY_OPTIONS_HISTORICAL = [
    {
        id: "ytd",
        label: "Year to Date"
    },
    {
        id: "l3m",
        label: "Last 3 Months"
    },
    {
        id: "l6m",
        label: "Last 6 Months"
    },
    {
        id: "l12m",
        label: "Last 12 Months"
    },
    {
        id: "l24m",
        label: "Last 24 Months"
    },
    {
        id: "l36m",
        label: "Last 36 Months"
    },
    {
        id: "l48m",
        label: "Last 48 Months"
    },
    {
        id: "l60m",
        label: "Last 60 Months"
    },
    {
        id: "all",
        label: "All Available Data"
    }
];
const $25097ef2e76a3499$var$QUARTERLY_OPTIONS_HISTORICAL = [
    {
        id: "ytd",
        label: "Year to Date"
    },
    {
        id: "l4q",
        label: "Last 4 Quarters"
    },
    {
        id: "l8q",
        label: "Last 8 Quarters"
    },
    {
        id: "l12q",
        label: "Last 12 Quarters"
    },
    {
        id: "l16q",
        label: "Last 16 Quarters"
    },
    {
        id: "l20q",
        label: "Last 20 Quarters"
    },
    {
        id: "all",
        label: "All Available Data"
    }
];
const $25097ef2e76a3499$var$ANNUAL_OPTIONS_HISTORICAL = [
    {
        id: "l3y",
        label: "Last 3 Years"
    },
    {
        id: "l5y",
        label: "Last 5 Years"
    },
    {
        id: "all",
        label: "All Available Data"
    }
];
const $25097ef2e76a3499$var$MONTHLY_OPTIONS_PROJECTION = [
    {
        id: "l3m",
        label: "Next 3 Months"
    },
    {
        id: "l6m",
        label: "Next 6 Months"
    },
    {
        id: "l12m",
        label: "Next 12 Months"
    },
    {
        id: "l24m",
        label: "Next 24 Months"
    },
    {
        id: "l36m",
        label: "Next 36 Months"
    },
    {
        id: "l48m",
        label: "Next 48 Months"
    },
    {
        id: "l60m",
        label: "Next 60 Months"
    },
    {
        id: "all",
        label: "All Available Data"
    }
];
const $25097ef2e76a3499$var$QUARTERLY_OPTIONS_PROJECTION = [
    {
        id: "l4q",
        label: "Next 4 Quarters"
    },
    {
        id: "l8q",
        label: "Next 8 Quarters"
    },
    {
        id: "l12q",
        label: "Next 12 Quarters"
    },
    {
        id: "l16q",
        label: "Next 16 Quarters"
    },
    {
        id: "l20q",
        label: "Next 20 Quarters"
    },
    {
        id: "all",
        label: "All Available Data"
    }
];
const $25097ef2e76a3499$var$ANNUAL_OPTIONS_PROJECTION = [
    {
        id: "l3y",
        label: "Next 3 Years"
    },
    {
        id: "l5y",
        label: "Next 5 Years"
    },
    {
        id: "all",
        label: "All Available Data"
    }
];
const $25097ef2e76a3499$var$CATEGORIES_HISTORICAL = [
    {
        id: "monthly",
        label: "Monthly",
        options: $25097ef2e76a3499$var$MONTHLY_OPTIONS_HISTORICAL
    },
    {
        id: "quarterly",
        label: "Quarterly",
        options: $25097ef2e76a3499$var$QUARTERLY_OPTIONS_HISTORICAL
    },
    {
        id: "annual",
        label: "Annual",
        options: $25097ef2e76a3499$var$ANNUAL_OPTIONS_HISTORICAL
    }
];
const $25097ef2e76a3499$var$CATEGORIES_PROJECTION = [
    {
        id: "monthly",
        label: "Monthly",
        options: $25097ef2e76a3499$var$MONTHLY_OPTIONS_PROJECTION
    },
    {
        id: "quarterly",
        label: "Quarterly",
        options: $25097ef2e76a3499$var$QUARTERLY_OPTIONS_PROJECTION
    },
    {
        id: "annual",
        label: "Annual",
        options: $25097ef2e76a3499$var$ANNUAL_OPTIONS_PROJECTION
    }
];
function $25097ef2e76a3499$export$a40b280c06fb7dd6({ resolutionAtom: resolutionAtom, variant: variant = "historical", metricsType: metricsType = (0, $1cd14341ea007c9d$export$b0f66506e639cd60).INCOME_STATEMENT }) {
    const [metricResolution, setMetricResolution] = (0, $r2uF6.useAtom)(resolutionAtom);
    const incomeStatementEarliestDate = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$63f2c08ec55a7c8b));
    const balanceSheetEarliestDate = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$791d9a958ce94640));
    const incomeStatementAsOfDate = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$40712ac478dd6036));
    const balanceSheetAsOfDate = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$85932cbce02e0bb2));
    const earliestDate = metricsType === (0, $1cd14341ea007c9d$export$b0f66506e639cd60).BALANCE_SHEET ? balanceSheetEarliestDate : incomeStatementEarliestDate;
    const asOfDate = metricsType === (0, $1cd14341ea007c9d$export$b0f66506e639cd60).BALANCE_SHEET ? balanceSheetAsOfDate : incomeStatementAsOfDate;
    const calculateAvailableMonths = (0, $acw62.useMemo)(()=>{
        if (!earliestDate || !asOfDate) return null;
        const earliest = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(earliestDate);
        const latest = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(asOfDate);
        return latest.diff(earliest, "month") + 1;
    }, [
        earliestDate,
        asOfDate
    ]);
    const isOptionDisabled = (optionId)=>{
        if (variant === "projection" || optionId === "all" || optionId === "ytd") return false;
        if (!calculateAvailableMonths) return true;
        const requiredMonths = {
            l3m: 3,
            l6m: 6,
            l12m: 12,
            l24m: 24,
            l36m: 36,
            l48m: 48,
            l60m: 60,
            l4q: 12,
            l8q: 24,
            l12q: 36,
            l16q: 48,
            l20q: 60,
            l3y: 36,
            l5y: 60
        };
        const required = requiredMonths[optionId];
        if (!required) return false;
        return calculateAvailableMonths < required;
    };
    const CATEGORIES_WITH_DISABLED = (0, $acw62.useMemo)(()=>{
        const categories = variant === "projection" ? $25097ef2e76a3499$var$CATEGORIES_PROJECTION : $25097ef2e76a3499$var$CATEGORIES_HISTORICAL;
        return categories.map((category)=>({
                ...category,
                options: category.options.map((option)=>({
                        ...option,
                        disabled: isOptionDisabled(option.id)
                    }))
            }));
    }, [
        variant,
        calculateAvailableMonths
    ]);
    const CATEGORIES = CATEGORIES_WITH_DISABLED;
    const getCurrentCategoryId = ()=>{
        const { periodKind: periodKind } = metricResolution;
        if (periodKind === (0, $eQbhf.PeriodKind).MONTHLY) return "monthly";
        if (periodKind === (0, $eQbhf.PeriodKind).QUARTERLY) return "quarterly";
        if (periodKind === (0, $eQbhf.PeriodKind).YEARLY) return "annual";
        return "monthly";
    };
    const getCurrentOptionId = ()=>{
        const { periodKind: periodKind, window: window } = metricResolution;
        if (window) return window;
        if (periodKind === (0, $eQbhf.PeriodKind).MONTHLY) return "l12m";
        if (periodKind === (0, $eQbhf.PeriodKind).QUARTERLY) return "l4q";
        if (periodKind === (0, $eQbhf.PeriodKind).YEARLY) return "all";
        return "l12m";
    };
    const getDisplayLabel = ()=>{
        const categoryId = getCurrentCategoryId();
        const optionId = getCurrentOptionId();
        const category = CATEGORIES.find((c)=>c.id === categoryId);
        const option = category?.options.find((o)=>o.id === optionId);
        if (category && option) return `${category.label} - ${option.label}`;
        return "Select Period";
    };
    const handleSelect = (categoryId, optionId)=>{
        let periodKind = (0, $eQbhf.PeriodKind).MONTHLY;
        if (categoryId === "monthly") periodKind = (0, $eQbhf.PeriodKind).MONTHLY;
        else if (categoryId === "quarterly") periodKind = (0, $eQbhf.PeriodKind).QUARTERLY;
        else if (categoryId === "annual") periodKind = (0, $eQbhf.PeriodKind).YEARLY;
        setMetricResolution({
            periodKind: periodKind,
            window: optionId
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cdcb35ed908b5f9$export$850d3a5442e004d9), {
        categories: CATEGORIES,
        selectedCategoryId: getCurrentCategoryId(),
        selectedOptionId: getCurrentOptionId(),
        onSelect: handleSelect,
        displayLabel: getDisplayLabel()
    });
}





var $r2uF6 = parcelRequire("r2uF6");





var $ayMG0 = parcelRequire("ayMG0");

function $12df8b74c0631184$export$7b9deb30117d866f(props) {
    const tooltipText = props.tooltipText || props.tooltipText || props.column?.getColDef()?.headerComponentParams?.tooltipText;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "heading-s",
                children: props.displayName
            }),
            tooltipText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5f7cc04a2cba0193$export$dbdcde5ca046596e), {
                children: tooltipText
            })
        ]
    });
}




var $eQbhf = parcelRequire("eQbhf");
const $ef04603c6136708f$export$160c60c76e49b67a = [
    {
        label: "Total Assets",
        codes: [
            (0, $eQbhf.AccountLabel).ASSETS,
            (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS
        ],
        fieldType: (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY,
        indentLevel: 0
    },
    {
        label: "Cash & Equivalents",
        codes: [
            (0, $eQbhf.AccountLabel).CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS,
            (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_CASH
        ],
        fieldType: (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY,
        indentLevel: 1
    },
    {
        label: "Accounts Receivable",
        codes: [
            (0, $eQbhf.AccountLabel).CURRENT_ASSETS_NET_RECEIVABLES
        ],
        fieldType: (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY,
        indentLevel: 1
    },
    {
        label: "Inventory",
        codes: [
            (0, $eQbhf.AccountLabel).CURRENT_ASSETS_NET_INVENTORY
        ],
        fieldType: (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY,
        indentLevel: 1
    },
    {
        label: "Gross PP&E",
        codes: [
            (0, $eQbhf.AccountLabel).NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT
        ],
        fieldType: (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY,
        indentLevel: 1
    },
    {
        label: "Total Liabilities",
        codes: [
            (0, $eQbhf.AccountLabel).LIABILITIES,
            (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_LIABILITIES
        ],
        fieldType: (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY,
        indentLevel: 0
    },
    {
        label: "Accounts Payable",
        codes: [
            (0, $eQbhf.AccountLabel).CURRENT_LIABILITIES_ACCOUNTS_PAYABLE
        ],
        fieldType: (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY,
        indentLevel: 1
    },
    {
        label: "Current Debt Balance",
        codes: [
            (0, $eQbhf.AccountLabel).CURRENT_LIABILITIES_DEBT
        ],
        fieldType: (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY,
        indentLevel: 1
    }
];




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
function $21785f74a3e2a82b$var$ArrowDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M12 2.25a.75.75 0 0 1 .75.75v16.19l6.22-6.22a.75.75 0 1 1 1.06 1.06l-7.5 7.5a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 1 1 1.06-1.06l6.22 6.22V3a.75.75 0 0 1 .75-.75Z",
        clipRule: "evenodd"
    }));
}
const $21785f74a3e2a82b$var$ForwardRef = $acw62.forwardRef($21785f74a3e2a82b$var$ArrowDownIcon);
var $21785f74a3e2a82b$export$2e2bcd8739ae039 = $21785f74a3e2a82b$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $b36cb8f42e796a48$var$ArrowUpIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M11.47 2.47a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06l-6.22-6.22V21a.75.75 0 0 1-1.5 0V4.81l-6.22 6.22a.75.75 0 1 1-1.06-1.06l7.5-7.5Z",
        clipRule: "evenodd"
    }));
}
const $b36cb8f42e796a48$var$ForwardRef = $acw62.forwardRef($b36cb8f42e796a48$var$ArrowUpIcon);
var $b36cb8f42e796a48$export$2e2bcd8739ae039 = $b36cb8f42e796a48$var$ForwardRef;



var $9QePP = parcelRequire("9QePP");

function $59dd829a8f22fee8$export$26d2dd7b6e04961(params) {
    const delta = params.value;
    if (delta === null || !Number.isFinite(delta)) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: (0, $9QePP.default)("body-s subdued"),
        children: "-"
    });
    const changePercent = delta * 100 || 0;
    const isPositive = delta > 0;
    const isNegative = delta < 0;
    const isNeutral = delta === 0;
    const formattedPercent = changePercent.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: (0, $9QePP.default)("body-s hover:bg-hover flex cursor-pointer items-center gap-3"),
        children: [
            isPositive && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b36cb8f42e796a48$export$2e2bcd8739ae039), {
                className: "size-4 stroke-emerald-500"
            }),
            isNegative && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $21785f74a3e2a82b$export$2e2bcd8739ae039), {
                className: "size-4 stroke-red-500"
            }),
            isNeutral && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $449758aadd79f00e$export$2e2bcd8739ae039), {
                className: "size-4 stroke-gray-400"
            }),
            formattedPercent,
            "%"
        ]
    });
}



const $bef530b6bbaa60b0$export$666c8b01b85124c5 = (0, $r2uF6.atom)((get)=>{
    const financeMetrics = get((0, $ac1aa0283079b21c$export$902a8a2e511babda));
    const finLabMetrics = get((0, $ac1aa0283079b21c$export$381dde81c2f67880));
    const unified = {
        ...finLabMetrics,
        ...financeMetrics
    };
    const labels = Array.from((0, $5b4e6b4ee867778c$export$5cc18c49722ddde6));
    const metrics = (0, $ac1aa0283079b21c$export$69f15c14d019bb0a)(unified, labels);
    return (0, $ef04603c6136708f$export$160c60c76e49b67a).map((row)=>{
        return {
            metric: (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(metrics, row.codes[0], row.codes[1]),
            ...row
        };
    });
});
const $bef530b6bbaa60b0$export$52db9c68038d0f93 = (0, $r2uF6.atom)((get)=>{
    const metricResolution = get((0, $ac1aa0283079b21c$export$dfed62957d17fdf5));
    const tablePeriodCount = (0, $a0b0e4e94524bfb3$export$489e23dc7473f561)(metricResolution.window || "");
    const asOfDate = get((0, $ac1aa0283079b21c$export$a74510d510ea4008));
    console.log("metric resolution", metricResolution);
    if (!asOfDate) return [];
    if (![
        "all",
        "ytd"
    ].includes(metricResolution.window || "")) return (0, $a0038ff09b9cb167$export$b3ab20afa21fa2d4)((0, $a0038ff09b9cb167$export$d579eebe314e9a5)(asOfDate, metricResolution.periodKind, tablePeriodCount));
    const metrics = get($bef530b6bbaa60b0$export$666c8b01b85124c5);
    const periods = (0, $a0038ff09b9cb167$export$18870a65b84e7f44)((0, $a0038ff09b9cb167$export$abe1a4d78fb59613)(metrics.map((m)=>m.metric).filter((m)=>m !== undefined)), asOfDate);
    if (metricResolution.periodKind === "yearly" && metricResolution.window === "all") periods.pop();
    return metricResolution.window?.includes("ytd") ? (0, $a0038ff09b9cb167$export$d20da80facbf85ca)(periods, asOfDate) : periods;
});
const $bef530b6bbaa60b0$export$c37ce656bbe627e5 = (0, $r2uF6.atom)((get)=>{
    const periods = get($bef530b6bbaa60b0$export$52db9c68038d0f93);
    const periodColumns = (0, $a0038ff09b9cb167$export$2bf0c9af12dfcd01)(periods);
    return [
        {
            field: "label",
            headerName: "",
            flex: 1.5,
            pinned: "left",
            cellClass: "heading-s"
        },
        ...periodColumns,
        {
            field: "popChange",
            maxWidth: 150,
            pinned: "right",
            headerName: periodColumns.length >= 2 ? `% \u{394} ${periodColumns[periodColumns.length - 2].headerName} \u{2014} ${periodColumns[periodColumns.length - 1].headerName}` : "% \u0394",
            headerComponent: (0, $12df8b74c0631184$export$7b9deb30117d866f),
            cellRenderer: (0, $59dd829a8f22fee8$export$26d2dd7b6e04961),
            headerComponentParams: {
                tooltipText: "Shows the % difference between the latest two available periods. Eg. if the last closed period is Q1-25, the delta shows the difference between Q1-25 and Q4-24."
            }
        }
    ];
});
const $bef530b6bbaa60b0$export$a71cffe26071dc1e = (0, $r2uF6.atom)((get)=>{
    const rows = get($bef530b6bbaa60b0$export$666c8b01b85124c5);
    const periods = get($bef530b6bbaa60b0$export$52db9c68038d0f93);
    console.log(periods, rows);
    return rows.map((r)=>{
        const row = {
            ...r,
            previousSlice: [],
            currentSlice: []
        };
        if (!r.metric) {
            periods.forEach((period)=>{
                row[period] = "-";
            });
            row.popChange = null;
            return row;
        }
        const valuesByPeriod = new Map(periods.map((p)=>[
                p,
                r.metric?.values.filter((value)=>value.period === p).pop()?.value
            ]));
        const arr = Array.from(valuesByPeriod.entries());
        const currentSlice = arr.pop();
        const previousSlice = arr.pop();
        const slices = {
            previous: [
                previousSlice
            ].filter((s)=>Array.isArray(s) && typeof s[1] === "number"),
            current: [
                currentSlice
            ].filter((s)=>Array.isArray(s) && typeof s[1] === "number")
        };
        const delta = (0, $a0b0e4e94524bfb3$export$4b13ea46348dc970)(slices?.current || [], slices?.previous || []);
        if (delta !== null) {
            row.popChange = delta;
            row.previousSlice = slices.previous;
            row.currentSlice = slices.current;
        }
        periods.forEach((period)=>{
            row[period] = valuesByPeriod.get(period) !== undefined ? (0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)(valuesByPeriod.get(period), row.fieldType) : "-";
        });
        return row;
    });
});
const $bef530b6bbaa60b0$export$6613f320a2778d11 = (0, $r2uF6.atom)((get)=>{
    const balanceSheetResolution = get((0, $ac1aa0283079b21c$export$dfed62957d17fdf5));
    const bsFinLabQueryAtom = balanceSheetResolution.periodKind === "quarterly" ? (0, $ac1aa0283079b21c$export$bb48b1ed324c8e9a) : balanceSheetResolution.periodKind === "yearly" ? (0, $ac1aa0283079b21c$export$5230d3951890ac19) : (0, $ac1aa0283079b21c$export$397955998ef11b18);
    const bsFinanceQueryAtom = balanceSheetResolution.periodKind === "quarterly" ? (0, $ac1aa0283079b21c$export$84ebb64439769704) : balanceSheetResolution.periodKind === "yearly" ? (0, $ac1aa0283079b21c$export$1a88a30dea58e5b) : (0, $ac1aa0283079b21c$export$833af3e8cf96f469);
    return get(bsFinLabQueryAtom).isLoading || get(bsFinanceQueryAtom).isLoading;
});


const $45782928504bd86d$export$5f30cdac9dff15e2 = (selectedCell, gridId)=>{
    return {
        cellStyle: (params)=>{
            return {
                paddingLeft: (params.data?.indentLevel ?? 0) * 8 + "px"
            };
        },
        flex: 1,
        minWidth: 140,
        cellClass: (params)=>{
            const isSelected = gridId === params.gridId && selectedCell?.rowId === params.node.id && selectedCell?.colField === params.colDef.field;
            return params.colDef.field !== "label" ? `cursor-pointer hover:bg-hover ${isSelected ? "bg-selected" : ""}` : "";
        }
    };
};



var $9QePP = parcelRequire("9QePP");
function $ded0968bd52e5b2e$export$627e57b839b99505() {
    const metrics = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$8a657426c281479d));
    const resolution = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$dfed62957d17fdf5));
    const data = (0, $r2uF6.useAtomValue)((0, $bef530b6bbaa60b0$export$a71cffe26071dc1e));
    console.log("balance sheet table", metrics, data);
    const columns = (0, $r2uF6.useAtomValue)((0, $bef530b6bbaa60b0$export$c37ce656bbe627e5));
    const [getAIMContextView, setAIMContextView] = (0, $r2uF6.useAtom)((0, $57f1ca4385a7301a$export$c65e5de3b3a2e247));
    const isLoading = (0, $r2uF6.useAtomValue)((0, $bef530b6bbaa60b0$export$6613f320a2778d11));
    const selectedCell = getAIMContextView?.selectedCell;
    const gridId = "summary-balance-sheet-grid";
    const handleClick = (0, $acw62.useCallback)((params)=>{
        const field = params.colDef.field;
        if (field === "label" || !params.data?.metric || !field) return;
        if (field === "popChange" && params.data.popChange) {
            setAIMContextView({
                type: (0, $0e9c1faaf8e0eb7e$export$88fa5c7cfbd4d210).DELTA_LINEAGE,
                props: {
                    metric: params.data.metric,
                    metricLabel: params.data.label,
                    currentSlice: params.data.currentSlice,
                    previousSlice: params.data.previousSlice,
                    popChange: params.data.popChange,
                    fieldType: params.data.fieldType,
                    resolutionWindow: resolution.window || "",
                    popLabel: params.colDef.headerName
                },
                selectedCell: {
                    rowId: params.node?.id ?? "",
                    colField: field,
                    gridId: gridId
                }
            });
            return;
        } else setAIMContextView({
            type: (0, $0e9c1faaf8e0eb7e$export$88fa5c7cfbd4d210).VALUE_LINEAGE,
            metric: params.data.metric,
            period: field,
            title: params.data.label,
            isExpanded: field === "popChange" ? false : true,
            selectedCell: {
                rowId: params.node?.id ?? "",
                colField: field,
                gridId: gridId
            }
        });
    }, [
        metrics,
        resolution,
        setAIMContextView
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        id: "summary-balance-sheet",
        className: "space-y-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "heading-m",
                        children: "Summary Balance Sheet"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25097ef2e76a3499$export$a40b280c06fb7dd6), {
                        resolutionAtom: (0, $ac1aa0283079b21c$export$dfed62957d17fdf5),
                        metricsType: (0, $1cd14341ea007c9d$export$b0f66506e639cd60).BALANCE_SHEET
                    })
                ]
            }),
            isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("h-[400px] w-full animate-pulse rounded-lg bg-slate-600")
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $990d0f56d10de165$export$3ae2824b8d61e4dc), {
                data: data,
                columns: columns,
                onCellClicked: handleClick,
                defaultColDef: (0, $45782928504bd86d$export$5f30cdac9dff15e2)(selectedCell, gridId),
                gridId: gridId + "-" + selectedCell?.rowId + "-" + selectedCell?.colField
            })
        ]
    });
}





var $ayMG0 = parcelRequire("ayMG0");





var $acw62 = parcelRequire("acw62");

var $r2uF6 = parcelRequire("r2uF6");



var $r2uF6 = parcelRequire("r2uF6");









var $eQbhf = parcelRequire("eQbhf");
const $dd42b1c6d4f25831$export$160c60c76e49b67a = [
    {
        label: "Revenue",
        codes: [
            (0, $eQbhf.AccountLabel).REVENUES,
            (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_REVENUE
        ],
        fieldType: (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY,
        indentLevel: 0
    },
    {
        label: "Gross Margin %",
        codes: [
            (0, $eQbhf.AccountLabel).GROSS_MARGIN,
            (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_GROSS_MARGIN_P
        ],
        fieldType: (0, $eb67e7ba0742cb25$export$b570835b381015d3).PERCENTAGE,
        indentLevel: 0
    },
    {
        label: "EBITDA",
        codes: [
            (0, $eQbhf.AccountLabel).EBITDA,
            (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_EBITDA
        ],
        fieldType: (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY,
        indentLevel: 0
    },
    {
        label: "EBITDA Margin %",
        codes: [
            (0, $eQbhf.AccountLabel).EBITDA_MARGIN,
            (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_EBITDA_MARGIN_P
        ],
        fieldType: (0, $eb67e7ba0742cb25$export$b570835b381015d3).PERCENTAGE,
        indentLevel: 0
    },
    {
        label: "Sales & Marketing Efficiency",
        codes: [
            (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_SALES_AND_MARKETING_EFFICIENCY
        ],
        fieldType: (0, $eb67e7ba0742cb25$export$b570835b381015d3).MULTIPLE,
        indentLevel: 0
    },
    {
        label: "Net Income",
        codes: [
            (0, $eQbhf.AccountLabel).NET_INCOME,
            (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_NET_INCOME
        ],
        fieldType: (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY,
        indentLevel: 0
    },
    {
        label: "Net Income Margin %",
        codes: [
            (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_NET_INCOME_MARGIN_P
        ],
        fieldType: (0, $eb67e7ba0742cb25$export$b570835b381015d3).PERCENTAGE,
        indentLevel: 0
    }
];



const $6a8caeff65adf764$export$f7f9a286c2ee463d = (0, $r2uF6.atom)((get)=>{
    const financeMetrics = get((0, $ac1aa0283079b21c$export$b479bf8505037b29));
    const finLabMetrics = get((0, $ac1aa0283079b21c$export$5bc80f01ae288874));
    const unified = {
        ...finLabMetrics,
        ...financeMetrics
    };
    const labels = Array.from((0, $5b4e6b4ee867778c$export$19a37e7186436a94));
    const metrics = (0, $ac1aa0283079b21c$export$69f15c14d019bb0a)(unified, labels);
    return (0, $dd42b1c6d4f25831$export$160c60c76e49b67a).map((row)=>{
        return {
            metric: (0, $25397e9d43ca4a5e$export$ed0dc1178a679c67)(metrics, row.codes[0], row.codes[1]),
            ...row
        };
    });
});
const $6a8caeff65adf764$export$d622de2706035e97 = (0, $r2uF6.atom)((get)=>{
    const metricResolution = get((0, $ac1aa0283079b21c$export$99acf3ba7e4e0c8a));
    const deltaPeriodCount = (0, $a0b0e4e94524bfb3$export$489e23dc7473f561)(metricResolution.window || "");
    const asOfDate = get((0, $ac1aa0283079b21c$export$a74510d510ea4008));
    console.log("metric resolution", metricResolution);
    if (!asOfDate) return {
        periods: [],
        tablePeriods: []
    };
    if (![
        "all",
        "ytd"
    ].includes(metricResolution.window || "")) {
        const periods = (0, $a0038ff09b9cb167$export$b3ab20afa21fa2d4)((0, $a0038ff09b9cb167$export$d579eebe314e9a5)(asOfDate, metricResolution.periodKind, deltaPeriodCount * 2 || 1));
        return {
            periods: periods,
            tablePeriods: periods.slice(-deltaPeriodCount)
        };
    }
    const metrics = get($6a8caeff65adf764$export$f7f9a286c2ee463d);
    const periods = (0, $a0038ff09b9cb167$export$18870a65b84e7f44)((0, $a0038ff09b9cb167$export$abe1a4d78fb59613)(metrics.map((m)=>m.metric).filter((m)=>m !== undefined)), asOfDate);
    if (metricResolution.periodKind === "yearly" && metricResolution.window === "all") periods.pop();
    return {
        periods: periods,
        tablePeriods: metricResolution.window?.includes("ytd") ? (0, $a0038ff09b9cb167$export$d20da80facbf85ca)(periods, asOfDate) : periods
    };
});
const $6a8caeff65adf764$export$8a62bccc3c910502 = (0, $r2uF6.atom)((get)=>{
    const metricResolution = get((0, $ac1aa0283079b21c$export$99acf3ba7e4e0c8a));
    const periods = get($6a8caeff65adf764$export$d622de2706035e97).tablePeriods;
    const periodColumns = (0, $a0038ff09b9cb167$export$2bf0c9af12dfcd01)(periods);
    return [
        {
            field: "label",
            headerName: "",
            flex: 1.5,
            pinned: "left",
            cellClass: "heading-s"
        },
        ...periodColumns,
        {
            field: "popChange",
            maxWidth: 150,
            pinned: "right",
            headerName: (0, $a0b0e4e94524bfb3$export$cef478891122337a)(metricResolution.window || ""),
            headerComponent: (0, $12df8b74c0631184$export$7b9deb30117d866f),
            cellRenderer: (0, $59dd829a8f22fee8$export$26d2dd7b6e04961),
            headerComponentParams: {
                tooltipText: "Shows the % difference between the latest two available periods. Eg. if the last closed period is Q1-25, the delta shows the difference between Q1-25 and Q4-24."
            }
        }
    ];
});
const $6a8caeff65adf764$export$a50126d3a3af4402 = (0, $r2uF6.atom)((get)=>{
    const metricResolution = get((0, $ac1aa0283079b21c$export$99acf3ba7e4e0c8a));
    const deltaPeriodCount = (0, $a0b0e4e94524bfb3$export$489e23dc7473f561)(metricResolution.window || "");
    const rows = get($6a8caeff65adf764$export$f7f9a286c2ee463d);
    const { periods: periods, tablePeriods: tablePeriods } = get($6a8caeff65adf764$export$d622de2706035e97);
    console.log("IS rows", rows);
    return rows.map((r)=>{
        const row = {
            ...r,
            previousSlice: [],
            currentSlice: []
        };
        const returnBlankRow = ()=>{
            tablePeriods.forEach((period)=>{
                row[period] = "-";
            });
            row.popChange = null;
            return row;
        };
        if (!r.metric) return returnBlankRow();
        const valuesByPeriod = new Map(periods.map((p)=>[
                p,
                r.metric?.values.filter((value)=>value.period === p).pop()?.value
            ]));
        const slices = (0, $a0b0e4e94524bfb3$export$dd06a9ea4a8fd59e)(deltaPeriodCount || 1, Array.from(valuesByPeriod.entries()).filter((entry)=>entry[1] !== undefined));
        const delta = (0, $a0b0e4e94524bfb3$export$4b13ea46348dc970)(slices?.current || [], slices?.previous || []);
        if (slices && delta !== null) {
            row.popChange = delta;
            row.previousSlice = slices.previous;
            row.currentSlice = slices.current;
        }
        tablePeriods.forEach((period)=>{
            row[period] = valuesByPeriod.get(period) !== undefined ? (0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)(valuesByPeriod.get(period), row.fieldType) : "-";
        });
        return row;
    });
});
const $6a8caeff65adf764$export$6613f320a2778d11 = (0, $r2uF6.atom)((get)=>{
    const resolution = get((0, $ac1aa0283079b21c$export$99acf3ba7e4e0c8a));
    const isFinLabQueryAtom = resolution.periodKind === "quarterly" ? (0, $ac1aa0283079b21c$export$b7b377ca7aa833f2) : resolution.periodKind === "yearly" ? (0, $ac1aa0283079b21c$export$5fa8aa4979d40738) : (0, $ac1aa0283079b21c$export$a3ca8edc13ccf742);
    const isFinanceQueryAtom = resolution.periodKind === "quarterly" ? (0, $ac1aa0283079b21c$export$c311318117b7047b) : resolution.periodKind === "yearly" ? (0, $ac1aa0283079b21c$export$f68248781bb89c68) : (0, $ac1aa0283079b21c$export$e02867a648d51fa3);
    return get(isFinLabQueryAtom).isLoading || get(isFinanceQueryAtom).isLoading;
});




var $9QePP = parcelRequire("9QePP");
function $06ce686a5048b91c$export$dbad2f43cc70e3f() {
    const metrics = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$12e2b84d2db22786));
    const resolution = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$99acf3ba7e4e0c8a));
    const data = (0, $r2uF6.useAtomValue)((0, $6a8caeff65adf764$export$a50126d3a3af4402));
    console.log("income statement table", metrics, data);
    const columns = (0, $r2uF6.useAtomValue)((0, $6a8caeff65adf764$export$8a62bccc3c910502));
    const [getAIMContextView, setAIMContextView] = (0, $r2uF6.useAtom)((0, $57f1ca4385a7301a$export$c65e5de3b3a2e247));
    const isLoading = (0, $r2uF6.useAtomValue)((0, $6a8caeff65adf764$export$6613f320a2778d11));
    const selectedCell = getAIMContextView?.selectedCell;
    const gridId = "summary-income-statement-grid";
    const handleClick = (0, $acw62.useCallback)((params)=>{
        const field = params.colDef.field;
        if (field === "label" || !params.data?.metric || !field) return;
        if (field === "popChange" && params.data.popChange) {
            setAIMContextView({
                type: (0, $0e9c1faaf8e0eb7e$export$88fa5c7cfbd4d210).DELTA_LINEAGE,
                props: {
                    metric: params.data.metric,
                    metricLabel: params.data.label,
                    currentSlice: params.data.currentSlice,
                    previousSlice: params.data.previousSlice,
                    popChange: params.data.popChange,
                    fieldType: params.data.fieldType,
                    resolutionWindow: resolution.window || "",
                    popLabel: params.colDef.headerName
                },
                selectedCell: {
                    rowId: params.node?.id ?? "",
                    colField: field,
                    gridId: gridId
                }
            });
            return;
        } else setAIMContextView({
            type: (0, $0e9c1faaf8e0eb7e$export$88fa5c7cfbd4d210).VALUE_LINEAGE,
            metric: params.data.metric,
            period: field === "popChange" ? "% Change" : field,
            title: params.data.label,
            isExpanded: field === "popChange" ? false : true,
            selectedCell: {
                rowId: params.node?.id ?? "",
                colField: field,
                gridId: gridId
            }
        });
    }, [
        metrics,
        resolution,
        setAIMContextView
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        id: "summary-income-statement",
        className: "space-y-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "heading-m",
                        children: "Summary Income Statement"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25097ef2e76a3499$export$a40b280c06fb7dd6), {
                        resolutionAtom: (0, $ac1aa0283079b21c$export$99acf3ba7e4e0c8a),
                        metricsType: (0, $1cd14341ea007c9d$export$b0f66506e639cd60).INCOME_STATEMENT
                    })
                ]
            }),
            isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("h-[377px] w-full animate-pulse rounded-lg bg-slate-600")
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $990d0f56d10de165$export$3ae2824b8d61e4dc), {
                data: data,
                columns: columns,
                onCellClicked: handleClick,
                defaultColDef: (0, $45782928504bd86d$export$5f30cdac9dff15e2)(getAIMContextView?.selectedCell),
                gridId: gridId + "-" + selectedCell?.rowId + "-" + selectedCell?.colField
            })
        ]
    });
}




function $28ee52ee060a7df5$export$e5d1eac46059cbf8() {
    const asOfDate = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$a74510d510ea4008));
    const formattedAsOfDate = (0, $23f1bc8e6da879d9$export$368813ca779e3c0f)(asOfDate);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-8",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "body-s flex items-center gap-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "subdued italic",
                        children: [
                            "Data as of ",
                            formattedAsOfDate
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5f7cc04a2cba0193$export$dbdcde5ca046596e), {
                        children: "The data displayed is from the last closed, complete calendar period available in the company's accounting system. Hum does not display partial period data."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $06ce686a5048b91c$export$dbad2f43cc70e3f), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ded0968bd52e5b2e$export$627e57b839b99505), {})
        ]
    });
}





var $ayMG0 = parcelRequire("ayMG0");

var $r2uF6 = parcelRequire("r2uF6");




var $gngdn = parcelRequire("gngdn");
function $c23bb75d13f3cc8e$export$63094f4f99a2d2d8(windowId) {
    if (!windowId || windowId === "all") return undefined;
    if (windowId === "ytd") return "ytd";
    // Extract number from patterns like "l12m", "l4q", "l3y"
    const match = windowId.match(/^l(\d+)[mqy]$/);
    if (match) return parseInt(match[1], 10);
    return undefined;
}
function $c23bb75d13f3cc8e$export$dd510e1984c5dcc4(periods, windowId) {
    const parsedWindow = $c23bb75d13f3cc8e$export$63094f4f99a2d2d8(windowId);
    if (parsedWindow === undefined) return periods;
    if (parsedWindow === "ytd") {
        if (periods.length === 0) return [];
        const latestPeriod = periods[periods.length - 1];
        const latestDate = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(latestPeriod);
        if (!latestDate.isValid()) return periods;
        const yearOfLatestPeriod = latestDate.year();
        const startOfYear = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(`${yearOfLatestPeriod}-01-01`);
        return periods.filter((period)=>{
            const periodDate = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(period);
            return periodDate.isValid() && periodDate.isAfter(startOfYear.subtract(1, "day")) && (periodDate.isBefore(latestDate) || periodDate.isSame(latestDate));
        });
    }
    if (typeof parsedWindow === "number") return periods.slice(-parsedWindow);
    return periods;
}
function $c23bb75d13f3cc8e$export$93f30fdb87ca2877(values, windowId) {
    if (!windowId || windowId === "all") return values;
    const sortedValues = [
        ...values
    ].sort((a, b)=>a.period.localeCompare(b.period));
    const periods = sortedValues.map((v)=>v.period);
    const filteredPeriods = new Set($c23bb75d13f3cc8e$export$dd510e1984c5dcc4(periods, windowId));
    return sortedValues.filter((v)=>filteredPeriods.has(v.period));
}



function $0982d4fc4b750e65$var$calculateLastTwoPeriodsDeltas(values) {
    if (values.length < 2) return null;
    const sorted = [
        ...values
    ].sort((a, b)=>a.period.localeCompare(b.period));
    const lastValue = sorted[sorted.length - 1].value;
    const secondLastValue = sorted[sorted.length - 2].value;
    if (secondLastValue === 0) return null;
    const delta = (lastValue - secondLastValue) / secondLastValue;
    return delta === 0 ? 0 : delta;
}
function $0982d4fc4b750e65$var$calculateCumulativeDelta(values) {
    if (values.length < 2) return null;
    const sorted = [
        ...values
    ].sort((a, b)=>a.period.localeCompare(b.period));
    let totalDelta = 0;
    let comparisons = 0;
    for(let i = 1; i < sorted.length; i++){
        const previousValue = sorted[i - 1].value;
        if (previousValue === 0) continue;
        const currentValue = sorted[i].value;
        const periodDelta = (currentValue - previousValue) / previousValue;
        totalDelta += periodDelta;
        comparisons++;
    }
    return comparisons > 0 ? totalDelta : null;
}
function $0982d4fc4b750e65$var$isBalanceSheetMetric(label) {
    return (0, $5b4e6b4ee867778c$export$5cc18c49722ddde6).has(label);
}
function $0982d4fc4b750e65$export$534ad7352de18a0a(metric, windowId) {
    // Filter values based on window
    const filteredValues = (0, $c23bb75d13f3cc8e$export$93f30fdb87ca2877)(metric.values, windowId);
    // Recalculate delta based on filtered values
    const isBalanceSheet = $0982d4fc4b750e65$var$isBalanceSheetMetric(metric.info.derived.label);
    const delta = isBalanceSheet ? $0982d4fc4b750e65$var$calculateLastTwoPeriodsDeltas(filteredValues) : $0982d4fc4b750e65$var$calculateCumulativeDelta(filteredValues);
    return {
        ...metric,
        values: filteredValues,
        delta: delta
    };
}
function $0982d4fc4b750e65$export$9c324dfc0fb09861(metrics, windowId) {
    if (!windowId || windowId === "all") return metrics;
    return Object.fromEntries(Object.entries(metrics).map(([key, metric])=>[
            key,
            $0982d4fc4b750e65$export$534ad7352de18a0a(metric, windowId)
        ]));
}



var $gngdn = parcelRequire("gngdn");

function $a56d1eec47c4e87f$var$formatPeriodHeader(period) {
    const date = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(period);
    if (!date.isValid()) return period;
    if (period.length === 4) return period;
    else if (period.includes("Q")) return period.replace("-", "-").slice(0, -2);
    else return date.format("MM-YY");
}
function $a56d1eec47c4e87f$var$calculateYoYDelta(firstValue, lastValue) {
    if (firstValue === null || lastValue === null || firstValue === 0) return null;
    const delta = (lastValue - firstValue) / Math.abs(firstValue);
    return delta;
}
function $a56d1eec47c4e87f$var$getMetric(metrics, field) {
    return metrics[field];
}
function $a56d1eec47c4e87f$export$455de8e4d0236ffd() {
    const handleMetricClick = (0, $b085c6e18988e4af$export$dc4ed7d6a15188bd)();
    const projectedFinancialsMetrics = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$f86d18e84dd54899));
    const projectionsResolution = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$ff87f6fcc4f8a7a3));
    const windowedMetrics = (0, $0982d4fc4b750e65$export$9c324dfc0fb09861)(projectedFinancialsMetrics, projectionsResolution.window);
    const revenue = $a56d1eec47c4e87f$var$getMetric(windowedMetrics, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_TOTAL_REVENUE);
    const grossMargin = $a56d1eec47c4e87f$var$getMetric(windowedMetrics, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_GROSS_MARGIN_P);
    const ebitda = $a56d1eec47c4e87f$var$getMetric(windowedMetrics, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_EBITDA);
    const ebitdaMargin = $a56d1eec47c4e87f$var$getMetric(windowedMetrics, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_EBITDA_MARGIN_P);
    const cash = $a56d1eec47c4e87f$var$getMetric(windowedMetrics, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_CASH);
    const salesMarketingEfficiency = $a56d1eec47c4e87f$var$getMetric(windowedMetrics, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_SALES_AND_MARKETING_EFFICIENCY);
    const allPeriods = new Set();
    [
        revenue,
        grossMargin,
        ebitda,
        ebitdaMargin,
        cash,
        salesMarketingEfficiency
    ].forEach((metric)=>{
        metric?.values.forEach((v)=>allPeriods.add(v.period));
    });
    const sortedPeriods = Array.from(allPeriods).sort();
    const periodColumns = sortedPeriods.map((period)=>({
            field: period,
            headerName: $a56d1eec47c4e87f$var$formatPeriodHeader(period)
        }));
    const columns = [
        {
            field: "metric",
            headerName: ""
        },
        ...periodColumns,
        {
            field: "yoyChange",
            headerName: "% \u0394 YoY",
            headerComponent: (0, $12df8b74c0631184$export$7b9deb30117d866f),
            headerComponentParams: {
                tooltipText: "Shows the % difference from the current period over the previous period. Eg. if last 4 quarters is selected (Q4-24\u2014 Q3-25), the delta shows the difference between (Q4-24\u2014 Q3-25) and (Q4-23\u2014 Q3-24)."
            }
        }
    ];
    function createRow(label, metric, fieldType) {
        const row = {
            metric: label
        };
        if (!metric) {
            sortedPeriods.forEach((period)=>{
                row[period] = "-";
            });
            row.yoyChange = null;
            return row;
        }
        const valuesByPeriod = new Map(metric.values.map((v)=>[
                v.period,
                v.value
            ]));
        sortedPeriods.forEach((period)=>{
            const value = valuesByPeriod.get(period);
            row[period] = value !== undefined ? (0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)(value, fieldType) : "-";
        });
        const firstValue = valuesByPeriod.get(sortedPeriods[0]) ?? null;
        const lastValue = valuesByPeriod.get(sortedPeriods[sortedPeriods.length - 1]) ?? null;
        row.yoyChange = $a56d1eec47c4e87f$var$calculateYoYDelta(firstValue, lastValue);
        row.onClick = ()=>handleMetricClick(metric, label);
        return row;
    }
    const data = [
        createRow("Revenue", revenue, (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY),
        createRow("Gross Margin %", grossMargin, (0, $eb67e7ba0742cb25$export$b570835b381015d3).PERCENTAGE),
        createRow("EBITDA", ebitda, (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY),
        createRow("EBITDA Margin %", ebitdaMargin, (0, $eb67e7ba0742cb25$export$b570835b381015d3).PERCENTAGE),
        createRow("Cash Balance", cash, (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY),
        createRow("Sales & Marketing Efficiency", salesMarketingEfficiency, (0, $eb67e7ba0742cb25$export$b570835b381015d3).MULTIPLE)
    ];
    return {
        data: data,
        columns: columns
    };
}



var $r2uF6 = parcelRequire("r2uF6");





var $gngdn = parcelRequire("gngdn");

function $9a28375550220d31$var$formatPeriodHeader(period) {
    const date = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(period);
    if (!date.isValid()) return period;
    if (period.length === 4) return period;
    else if (period.includes("Q")) return period.replace("-", "-").slice(0, -2);
    else return date.format("MM-YY");
}
function $9a28375550220d31$var$calculateYoYDelta(firstValue, lastValue) {
    if (firstValue === null || lastValue === null || firstValue === 0) return null;
    const delta = (lastValue - firstValue) / Math.abs(firstValue);
    return delta;
}
function $9a28375550220d31$var$getMetric(metrics, field) {
    return metrics[field];
}
function $9a28375550220d31$export$be91655039655fb1() {
    const handleMetricClick = (0, $b085c6e18988e4af$export$dc4ed7d6a15188bd)();
    const metricsProjectionsMetrics = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$ecd603b0f67db905));
    const projectionsResolution = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$ff87f6fcc4f8a7a3));
    const windowedMetrics = (0, $0982d4fc4b750e65$export$9c324dfc0fb09861)(metricsProjectionsMetrics, projectionsResolution.window);
    const interestCoverage = $9a28375550220d31$var$getMetric(windowedMetrics, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_INTEREST_COVERAGE);
    const debtToAssets = $9a28375550220d31$var$getMetric(windowedMetrics, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_GROSS_DEBT_TO_ASSETS);
    const debtToEbitda = $9a28375550220d31$var$getMetric(windowedMetrics, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_GROSS_DEBT_TO_EBITDA);
    const monthlyCashBurn = $9a28375550220d31$var$getMetric(windowedMetrics, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_CASH_BURN_MONTHLY);
    const dscr = $9a28375550220d31$var$getMetric(windowedMetrics, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_DSCR);
    const debtToEquity = $9a28375550220d31$var$getMetric(windowedMetrics, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_DEBT_TO_EQUITY);
    const assetToEquity = $9a28375550220d31$var$getMetric(windowedMetrics, (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS_TO_EQUITY);
    const allPeriods = new Set();
    [
        interestCoverage,
        debtToAssets,
        debtToEbitda,
        monthlyCashBurn,
        dscr,
        debtToEquity,
        assetToEquity
    ].forEach((metric)=>{
        metric?.values.forEach((v)=>allPeriods.add(v.period));
    });
    const sortedPeriods = Array.from(allPeriods).sort();
    const periodColumns = sortedPeriods.map((period)=>({
            field: period,
            headerName: $9a28375550220d31$var$formatPeriodHeader(period)
        }));
    const columns = [
        {
            field: "metric",
            headerName: ""
        },
        ...periodColumns,
        {
            field: "yoyChange",
            headerName: "% \u0394 YoY",
            headerComponent: (0, $12df8b74c0631184$export$7b9deb30117d866f),
            headerComponentParams: {
                tooltipText: "Shows the % difference from the current period over the previous period. Eg. if last 4 quarters is selected (Q4-24\u2014 Q3-25), the delta shows the difference between (Q4-24\u2014 Q3-25) and (Q4-23\u2014 Q3-24)."
            }
        }
    ];
    function createRow(label, metric, fieldType) {
        const row = {
            metric: label
        };
        if (!metric) {
            sortedPeriods.forEach((period)=>{
                row[period] = "-";
            });
            row.yoyChange = null;
            return row;
        }
        const valuesByPeriod = new Map(metric.values.map((v)=>[
                v.period,
                v.value
            ]));
        sortedPeriods.forEach((period)=>{
            const value = valuesByPeriod.get(period);
            row[period] = value !== undefined ? (0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)(value, fieldType) : "-";
        });
        const firstValue = valuesByPeriod.get(sortedPeriods[0]) ?? null;
        const lastValue = valuesByPeriod.get(sortedPeriods[sortedPeriods.length - 1]) ?? null;
        row.yoyChange = $9a28375550220d31$var$calculateYoYDelta(firstValue, lastValue);
        row.onClick = ()=>handleMetricClick(metric, label);
        return row;
    }
    const data = [
        createRow("Interest Coverage Ratio", interestCoverage, (0, $eb67e7ba0742cb25$export$b570835b381015d3).RATIO),
        createRow("Debt-to-Assets Ratio", debtToAssets, (0, $eb67e7ba0742cb25$export$b570835b381015d3).RATIO),
        createRow("Debt-to-EBITDA Ratio", debtToEbitda, (0, $eb67e7ba0742cb25$export$b570835b381015d3).RATIO),
        createRow("Monthly Cash Burn", monthlyCashBurn, (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY),
        createRow("Debt Service Coverage Ratio", dscr, (0, $eb67e7ba0742cb25$export$b570835b381015d3).RATIO),
        createRow("Debt-to-Equity Ratio", debtToEquity, (0, $eb67e7ba0742cb25$export$b570835b381015d3).RATIO),
        createRow("Asset-to-Equity Ratio", assetToEquity, (0, $eb67e7ba0742cb25$export$b570835b381015d3).RATIO)
    ];
    return {
        data: data,
        columns: columns
    };
}






var $acw62 = parcelRequire("acw62");



var $r2uF6 = parcelRequire("r2uF6");


var $7gcOJ = parcelRequire("7gcOJ");
function $aa7b56f9e04ab67e$var$DeltaCellRenderer(params) {
    const delta = params.value;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8a49ad6d29ec67c$export$37170585f10dec80), {
        delta: delta
    });
}
function $aa7b56f9e04ab67e$export$241972bab95a4063() {
    const flags = (0, $7gcOJ.useFlags)();
    const projectedFinancialsResult = (0, $a56d1eec47c4e87f$export$455de8e4d0236ffd)();
    const postClosingMetricsResult = (0, $9a28375550220d31$export$be91655039655fb1)();
    const projectionsAsOfDate = (0, $r2uF6.useAtomValue)((0, $ac1aa0283079b21c$export$68b8c61fed1001b3));
    const showProjectionMetrics = flags.enabled("show-projection-metrics");
    const projectedFinancialsColumns = (0, $acw62.useMemo)(()=>{
        return projectedFinancialsResult.columns.map((col, index)=>{
            if (index === 0) return {
                field: col.field,
                headerName: col.headerName,
                pinned: "left",
                flex: 1.5,
                minWidth: 140,
                cellClass: "body-s font-medium"
            };
            if (index === projectedFinancialsResult.columns.length - 1) return {
                field: col.field,
                headerName: col.headerName,
                pinned: "right",
                maxWidth: 140,
                cellRenderer: $aa7b56f9e04ab67e$var$DeltaCellRenderer,
                headerComponent: col.headerComponent,
                headerComponentParams: col.headerComponentParams
            };
            return {
                field: col.field,
                headerName: col.headerName,
                flex: 1,
                minWidth: 140
            };
        });
    }, [
        projectedFinancialsResult.columns
    ]);
    const postClosingMetricsColumns = (0, $acw62.useMemo)(()=>{
        return postClosingMetricsResult.columns.map((col, index)=>{
            if (index === 0) return {
                field: col.field,
                headerName: col.headerName,
                pinned: "left",
                flex: 1.5,
                minWidth: 140,
                cellClass: "body-s font-medium"
            };
            if (index === postClosingMetricsResult.columns.length - 1) return {
                field: col.field,
                headerName: col.headerName,
                pinned: "right",
                maxWidth: 140,
                cellRenderer: $aa7b56f9e04ab67e$var$DeltaCellRenderer,
                headerComponent: col.headerComponent,
                headerComponentParams: col.headerComponentParams
            };
            return {
                field: col.field,
                headerName: col.headerName,
                flex: 1,
                minWidth: 140
            };
        });
    }, [
        postClosingMetricsResult.columns
    ]);
    if (!showProjectionMetrics) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-8",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                id: "summary-projected-financials",
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-start justify-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "heading-m mb-2",
                                        children: "Summary Projected Financials"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "body-s flex items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "subdued italic",
                                                children: [
                                                    "Data as of ",
                                                    (0, $23f1bc8e6da879d9$export$368813ca779e3c0f)(projectionsAsOfDate)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5f7cc04a2cba0193$export$dbdcde5ca046596e), {
                                                children: "Gross Margin, Sales & Marketing Efficiency and Sales & Marketing spend are projected from historical data using <link to knowledge base article>ARIMA</link>. Revenue is derived"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25097ef2e76a3499$export$a40b280c06fb7dd6), {
                                resolutionAtom: (0, $ac1aa0283079b21c$export$ff87f6fcc4f8a7a3),
                                variant: "projection"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-s text-gray-400",
                        children: "Gross Margin, Sales & Marketing Efficiency and Sales & Marketing spend are projected from historical data using <link to knowledge base article>ARIMA</link>. Revenue is derived by multiplying Sales & Marketing Efficiency by Sales & Marketing Spend. COGS are derived by multiplying Revenue by Gross Margin."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $990d0f56d10de165$export$3ae2824b8d61e4dc), {
                        data: projectedFinancialsResult.data,
                        columns: projectedFinancialsColumns
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                id: "summary-post-closing-metrics",
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex items-start justify-between",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "heading-m mb-2",
                                    children: "Summary Post-Closing Metrics"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "body-s flex items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "subdued italic",
                                            children: "Data as of Target Close Date"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5f7cc04a2cba0193$export$dbdcde5ca046596e), {
                                            children: "This is the target close date for this deal."
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $990d0f56d10de165$export$3ae2824b8d61e4dc), {
                        data: postClosingMetricsResult.data,
                        columns: postClosingMetricsColumns
                    })
                ]
            })
        ]
    });
}




var $7gcOJ = parcelRequire("7gcOJ");

var $acw62 = parcelRequire("acw62");

function $8bf6d8656b8823a4$export$2e2bcd8739ae039({ opportunityId: opportunityId }) {
    const company = (0, $7Y7Q4.useApiQuery)((0, $kTlwO.getCompany));
    const { startGenerateMetrics: startGenerateMetrics, isPolling: isPolling } = (0, $bcfccea9b862dce3$export$268736677778b952)();
    const sfdcData = (0, $7Y7Q4.useApiQuery)((0, $lgOhz.getSFDCData));
    const [rightDrawerOpen] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae));
    const setAIMContextView = (0, $r2uF6.useSetAtom)((0, $57f1ca4385a7301a$export$c65e5de3b3a2e247));
    const flags = (0, $7gcOJ.useFlags)();
    const showComingSoon = flags.enabled("show-coming-soon-placeholders");
    const showProjectionMetrics = flags.enabled("show-projection-metrics");
    const { text: text, isGenerating: isGenerating, generateMemoText: generateMemoText } = (0, $aa9920dff4a9c63d$export$9c91c33a46c3167e)();
    const { aboutText: aboutText, generationBuffer: aboutBuffer, isLoading: isLoadingAbout, clearBuffer: clearBuffer } = (0, $ab8c2bcf66cd554c$export$1c084b291917c13a)();
    const [showCompanyName, setShowCompanyName] = (0, $acw62.useState)(false);
    const overviewRef = (0, $acw62.useRef)(null);
    const timeoutRef = (0, $acw62.useRef)(null);
    const otherWebsites = text[(0, $b082cd036e01ace0$export$8eb29354037a9c7c).COMPANY_METADATA]?.data.otherWebsites;
    const handleGenerateMetrics = ()=>{
        if (company.data?.uuid) {
            startGenerateMetrics({
                companyId: company.data.uuid
            });
            generateMemoText(company.data.website);
        }
    };
    const handleOpenDataSources = ()=>{
        setAIMContextView({
            type: (0, $0e9c1faaf8e0eb7e$export$88fa5c7cfbd4d210).DATA_SOURCES_SETTINGS
        });
    };
    (0, $acw62.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(()=>{
                setShowCompanyName(!entry.isIntersecting);
            }, 800);
        }, {
            threshold: 0,
            rootMargin: "-150px 0px 0px 0px"
        });
        if (overviewRef.current) observer.observe(overviewRef.current);
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            observer.disconnect();
        };
    }, []);
    if (!company.data) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
        fullScreen: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: (0, $9QePP.default)("flex-1", "mt-8 pt-16 sm:pt-8 lg:mt-0 lg:pt-0", "flex flex-col items-center justify-center"),
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fRJCp.motion).div, {
                initial: false,
                animate: {
                    paddingRight: rightDrawerOpen ? 24 : 0,
                    paddingLeft: rightDrawerOpen ? 24 : 0
                },
                exit: {
                    paddingRight: rightDrawerOpen ? 24 : 0,
                    paddingLeft: rightDrawerOpen ? 24 : 0
                },
                transition: {
                    ...(0, $f09089f5cc75b534$export$da1e9475c942285b),
                    paddingRight: {
                        duration: (0, $f09089f5cc75b534$export$1e9ee88f033039e9),
                        ease: "easeInOut",
                        delay: rightDrawerOpen ? 0 : (0, $f09089f5cc75b534$export$1e9ee88f033039e9)
                    },
                    paddingLeft: {
                        duration: (0, $f09089f5cc75b534$export$1e9ee88f033039e9),
                        ease: "easeInOut",
                        delay: rightDrawerOpen ? 0 : (0, $f09089f5cc75b534$export$1e9ee88f033039e9)
                    }
                },
                className: "mx-auto w-full max-w-[834px]",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, $9QePP.default)("hidden sm:block", "sticky top-0 z-10", "px-4 sm:px-6 lg:px-12 xl:px-0"),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mx-auto",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: (0, $9QePP.default)("bg-default py-4 sm:pb-4 sm:pt-8", "relative flex flex-col gap-2 sm:flex-row sm:justify-between sm:gap-0"),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: (0, $9QePP.default)("flex flex-col", "max-w-[400px] justify-center gap-2"),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjuU3.Breadcrumbs), {
                                                pages: [
                                                    {
                                                        name: "Legacy Admin",
                                                        href: "/"
                                                    },
                                                    {
                                                        name: company.data.name,
                                                        href: `/beta/companies/${company.data.uuid}`,
                                                        truncate: true
                                                    },
                                                    {
                                                        name: "Investor Memo"
                                                    }
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: (0, $9QePP.default)("bg-default absolute left-0 top-full w-full", "px-4 transition-all duration-300 ease-in-out sm:px-6 lg:px-0", showCompanyName ? "max-h-60 py-4 opacity-100" : "max-h-0 overflow-hidden opacity-0"),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex flex-col gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex items-center gap-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae4d8655e1f6bf27$export$b447ceeb6cd4731e), {
                                                                    className: "size-8 rounded-lg"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                                    className: "display-s",
                                                                    children: company.data.name
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa04cce42fac0f3e$export$4e0ee67fd4a7d890), {
                                                            company: company.data,
                                                            sfdcData: sfdcData.data,
                                                            text: text,
                                                            isGenerating: false,
                                                            isLoadingCompany: company.isLoading,
                                                            isLoadingSfdc: sfdcData.isLoading,
                                                            hideDataSources: true
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex flex-row gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: (0, $9QePP.default)("secondary flex min-w-0 items-center gap-2"),
                                                onClick: handleGenerateMetrics,
                                                disabled: isPolling || !company.data?.uuid,
                                                children: isPolling ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
                                                    className: "shrink-0"
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a08ef469b8107069$export$2e2bcd8739ae039), {
                                                            className: "size-4",
                                                            strokeWidth: 2
                                                        }),
                                                        " ",
                                                        !rightDrawerOpen && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Refresh Metrics"
                                                        })
                                                    ]
                                                })
                                            }),
                                            flags.enabled("show-data-sources") && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: (0, $9QePP.default)("secondary flex size-10 shrink-0 items-center justify-center"),
                                                onClick: handleOpenDataSources,
                                                "aria-label": "Data Sources Settings",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ihuRA.default), {
                                                    className: "size-5",
                                                    strokeWidth: 2
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, $9QePP.default)("flex-1 overflow-y-auto"),
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: (0, $9QePP.default)("mx-auto px-6 py-4", "sm:py-8 lg:px-12 xl:px-0"),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    id: "company-overview",
                                    ref: overviewRef,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: (0, $9QePP.default)("flex flex-row", "mb-6 items-center gap-6 sm:mb-0", "sm:block"),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae4d8655e1f6bf27$export$b447ceeb6cd4731e), {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1416c023a16bbb44$export$9716a88f5535df7c), {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mb-4 sm:mb-6",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa04cce42fac0f3e$export$4e0ee67fd4a7d890), {
                                                company: company.data,
                                                sfdcData: sfdcData.data,
                                                text: text,
                                                isGenerating: isGenerating,
                                                isLoadingCompany: company.isLoading,
                                                isLoadingSfdc: sfdcData.isLoading
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e0633724389f295f$export$d74477c340368ec6), {
                                    id: "about-company",
                                    title: "About Company",
                                    defaultOpen: true,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mb-4 w-full sm:mb-6",
                                            children: [
                                                !aboutBuffer && !isLoadingAbout && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c2560609a068b22c$export$4bbb6880c2bce4a2), {
                                                    text: aboutText,
                                                    maxLength: 1800
                                                }),
                                                isLoadingAbout && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "flex w-full flex-col gap-4",
                                                    children: [
                                                        1,
                                                        2,
                                                        3
                                                    ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: (0, $9QePP.default)("h-6 w-full bg-slate-700", "animate-pulse rounded")
                                                        }, i))
                                                }),
                                                aboutBuffer && !isLoadingAbout && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $654d2e9fb8687050$export$2e2bcd8739ae039), {
                                                        text: aboutBuffer,
                                                        className: "body-s",
                                                        onComplete: ()=>{
                                                            clearBuffer();
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: (0, $9QePP.default)("mb-6", "flex flex-wrap", "gap-2", "sm:mb-10"),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $411db1f77d5b08b1$export$7752db215400b41d), {}),
                                                [
                                                    company.data.website,
                                                    ...otherWebsites || []
                                                ].filter((href)=>!!href).map((href)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $eb3baba2011e6e91$export$a6c7ac8248d6e38a), {
                                                        href: href,
                                                        title: (0, $lvlqo.formattedUrl)(href)
                                                    }, href))
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $db4463712dde00ea$export$e2f70c04e8dedc56), {
                                            opportunityId: opportunityId
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0633724389f295f$export$d74477c340368ec6), {
                                    id: "transaction-summary",
                                    title: "Transaction summary",
                                    defaultOpen: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6a59b81d3abdf9af$export$18819ff39d34bfd1), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0633724389f295f$export$d74477c340368ec6), {
                                    id: "deal-structure",
                                    title: "Deal Structure",
                                    defaultOpen: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e418782b77f5d987$export$52ac9a1b9e51900), {
                                        opportunityId: opportunityId
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0633724389f295f$export$d74477c340368ec6), {
                                    id: "financial-highlights",
                                    title: "Financial Highlights",
                                    defaultOpen: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d26e2c376d7507c$export$f9f5f42292f2fe4d), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0633724389f295f$export$d74477c340368ec6), {
                                    id: "investment-rationale",
                                    title: "Investment Rationale",
                                    defaultOpen: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9db023a52503f1cc$export$f228e0c68fce74ea), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0633724389f295f$export$d74477c340368ec6), {
                                    id: "due-diligence",
                                    title: "Due Diligence",
                                    defaultOpen: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7233dd35ac4f7780$export$621348d1e3862539), {
                                        companyId: company.data.uuid,
                                        opportunityId: opportunityId
                                    })
                                }),
                                showComingSoon && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0633724389f295f$export$d74477c340368ec6), {
                                            id: "key-risks",
                                            title: "Key Risks",
                                            defaultOpen: true,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bccbb7cbed705653$export$59e0ec2e7804451e), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0633724389f295f$export$d74477c340368ec6), {
                                            id: "funding-and-valuation",
                                            title: "Funding and Valuation",
                                            defaultOpen: true,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $31b4459d5cac463e$export$c08826fed26bda08), {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0633724389f295f$export$d74477c340368ec6), {
                                    id: "industry-overview",
                                    title: "Industry & Value Chain Analysis",
                                    defaultOpen: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $72591427a577b488$export$64c23eed0765bd8a), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0633724389f295f$export$d74477c340368ec6), {
                                    id: "summary-financials",
                                    title: "Summary Financials",
                                    defaultOpen: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28ee52ee060a7df5$export$e5d1eac46059cbf8), {})
                                }),
                                showProjectionMetrics && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0633724389f295f$export$d74477c340368ec6), {
                                    id: "summary-projections",
                                    title: "Summary Projections",
                                    defaultOpen: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa7b56f9e04ab67e$export$241972bab95a4063), {})
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}



var $r2uF6 = parcelRequire("r2uF6");



var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
const $3e35b24e38f9fceb$export$e3925dbaeffcc83f = ({ label: label, active: active = false, item: item, onNavigate: onNavigate })=>{
    const handleClick = ()=>{
        if (item && onNavigate) onNavigate(item);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("w-full cursor-pointer select-none rounded-md px-3 py-2", "body-s text-left", active ? "text-default bg-slate-700" : "subdued hover:bg-slate-700 hover:text-slate-200", "transition-colors duration-150 ease-in-out"),
        onClick: handleClick,
        role: "button",
        tabIndex: 0,
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleClick();
            }
        },
        children: label
    });
};
var $3e35b24e38f9fceb$export$2e2bcd8739ae039 = $3e35b24e38f9fceb$export$e3925dbaeffcc83f;




var $acw62 = parcelRequire("acw62");
function $e1290ea13eee6b70$export$d0fd4b7106de2769({ onNavigate: onNavigate, scrollBehavior: scrollBehavior = "smooth", scrollOffset: scrollOffset = 90 } = {}) {
    const handleNavigation = (0, $acw62.useCallback)((item)=>{
        if (item.onClick) {
            item.onClick();
            return;
        }
        if (item.anchor) {
            const element = document.getElementById(item.anchor);
            if (element) {
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.scrollY - scrollOffset;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: scrollBehavior
                });
                window.history.replaceState(null, "", `#${item.anchor}`);
            }
            onNavigate?.(item);
            return;
        }
        if (item.href) {
            if (item.href.startsWith("http")) window.open(item.href, "_blank", "noopener,noreferrer");
            else onNavigate?.(item);
            return;
        }
        onNavigate?.(item);
    }, [
        onNavigate,
        scrollBehavior,
        scrollOffset
    ]);
    return {
        handleNavigation: handleNavigation
    };
}
var $e1290ea13eee6b70$export$2e2bcd8739ae039 = $e1290ea13eee6b70$export$d0fd4b7106de2769;



var $acw62 = parcelRequire("acw62");
function $c54be506fe257401$export$bd221a7c56b93941({ items: items, searchFields: searchFields = [
    "searchableText"
], caseSensitive: caseSensitive = false }) {
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const filteredItems = (0, $acw62.useMemo)(()=>{
        if (!searchTerm.trim()) return items;
        const normalizedSearch = caseSensitive ? searchTerm.trim() : searchTerm.trim().toLowerCase();
        return items.filter((item)=>searchFields.some((field)=>{
                const fieldValue = String(item[field] || "");
                const normalizedField = caseSensitive ? fieldValue : fieldValue.toLowerCase();
                return normalizedField.includes(normalizedSearch);
            }));
    }, [
        items,
        searchTerm,
        searchFields,
        caseSensitive
    ]);
    return {
        searchTerm: searchTerm,
        setSearchTerm: setSearchTerm,
        filteredItems: filteredItems,
        hasResults: filteredItems.length > 0,
        totalResults: filteredItems.length
    };
}
var $c54be506fe257401$export$2e2bcd8739ae039 = $c54be506fe257401$export$bd221a7c56b93941;



var $4IZRg = parcelRequire("4IZRg");

var $gEbPi = parcelRequire("gEbPi");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");

var $7gcOJ = parcelRequire("7gcOJ");

var $r2uF6 = parcelRequire("r2uF6");


function $676dc7524d193e04$export$36b59815eb65b3eb() {
    const flags = (0, $7gcOJ.useFlags)();
    const showComingSoon = flags.enabled("show-coming-soon-placeholders");
    const showM05 = flags.enabled("show-im-m05");
    const showProjectionMetrics = flags.enabled("show-projection-metrics");
    const [, setSidebarOpen] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$1a43581c5b8980a9));
    const isMobile = (0, $63c42b32dd564eae$export$32d5543ab307c01)("(max-width: 1024px)");
    const sections = (0, $acw62.useMemo)(()=>[
            {
                id: "investor-memo",
                title: "Executive Summary",
                defaultOpen: true,
                items: [
                    {
                        id: "company-overview",
                        label: "Company Overview",
                        anchor: "company-overview"
                    },
                    {
                        id: "transaction-summary",
                        label: "Transaction Summary",
                        anchor: "transaction-summary"
                    },
                    {
                        id: "deal-structure",
                        label: "Deal Structure",
                        anchor: "deal-structure"
                    },
                    {
                        id: "financial-highlights",
                        label: "Financial Highlights",
                        anchor: "financial-highlights"
                    },
                    {
                        id: "investment-rationale",
                        label: "Investment Rationale",
                        anchor: "investment-rationale"
                    },
                    {
                        id: "due-diligence",
                        label: "Due Diligence",
                        anchor: "due-diligence"
                    },
                    ...showComingSoon ? [
                        {
                            id: "key-risks",
                            label: "Key Risks",
                            anchor: "key-risks"
                        },
                        {
                            id: "funding-and-valuation",
                            label: "Funding & Valuation",
                            anchor: "funding-and-valuation"
                        }
                    ] : [],
                    {
                        id: "industry-overview",
                        label: "Industry & Value Chain Analysis",
                        anchor: "industry-overview"
                    }
                ]
            },
            ...showM05 ? [
                {
                    id: "financials-projections",
                    title: "Financials & Projections",
                    items: [
                        {
                            id: "summary-financials",
                            label: "Summary Financials",
                            anchor: "summary-financials"
                        },
                        ...showProjectionMetrics ? [
                            {
                                id: "summary-projections",
                                label: "Summary Projections",
                                anchor: "summary-projections"
                            }
                        ] : []
                    ]
                }
            ] : []
        ], [
        showComingSoon,
        showM05,
        showProjectionMetrics
    ]);
    const allItems = (0, $acw62.useMemo)(()=>sections.flatMap((section)=>(section.items || []).map((item)=>({
                    ...item,
                    searchableText: item.label,
                    sectionId: section.id,
                    sectionTitle: section.title
                }))), [
        sections
    ]);
    const [activeItemId, setActiveItemId] = (0, $acw62.useState)();
    const { handleNavigation: handleNavigation } = (0, $e1290ea13eee6b70$export$2e2bcd8739ae039)({
        onNavigate: (item)=>{
            setActiveItemId(item.id);
            if (isMobile) setSidebarOpen(false);
        },
        scrollBehavior: "smooth"
    });
    const { searchTerm: searchTerm, setSearchTerm: setSearchTerm, filteredItems: filteredItems } = (0, $c54be506fe257401$export$2e2bcd8739ae039)({
        items: allItems,
        searchFields: [
            "searchableText",
            "label"
        ]
    });
    const filteredSections = (0, $acw62.useMemo)(()=>{
        if (!searchTerm.trim() || !sections) return sections;
        const sectionsWithItems = sections.map((section)=>({
                ...section,
                items: filteredItems.filter((item)=>item.sectionId === section.id)
            })).filter((section)=>section.items && section.items.length > 0);
        return sectionsWithItems;
    }, [
        sections,
        filteredItems,
        searchTerm
    ]);
    const initialExpanded = (0, $acw62.useMemo)(()=>sections.filter((section)=>section.defaultOpen).map((section)=>section.id), [
        sections
    ]);
    const { expanded: expanded, setExpanded: setExpanded, onClick: onClick } = (0, $gEbPi.useAccordionList)({
        allowMultiple: true,
        initialExpanded: initialExpanded
    });
    (0, $acw62.useEffect)(()=>{
        if (searchTerm.trim()) setExpanded(filteredSections.map((section)=>section.id));
    }, [
        searchTerm,
        filteredSections,
        setExpanded
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col gap-3 sm:px-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cfefb25babf4c58$export$2e2bcd8739ae039), {
                value: searchTerm,
                onChange: setSearchTerm
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("flex min-h-0 flex-1 flex-col gap-2", "overflow-y-auto overflow-x-hidden"),
                children: searchTerm.trim() && filteredSections?.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: (0, $9QePP.default)("px-2 py-4", "subdued text-center", "body-s"),
                    children: [
                        'No results found for "',
                        searchTerm,
                        '"'
                    ]
                }) : filteredSections?.map((section)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4IZRg.Accordion), {
                        i: section.title,
                        isOpen: expanded.includes(section.id),
                        onClick: ()=>onClick(section.id),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "body-s flex flex-col gap-1",
                            children: section.items?.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3e35b24e38f9fceb$export$2e2bcd8739ae039), {
                                    label: item.label,
                                    active: activeItemId === item.id,
                                    item: item,
                                    onNavigate: handleNavigation
                                }, item.id))
                        })
                    }, section.id))
            })
        ]
    });
}



var $cMZ0q = parcelRequire("cMZ0q");
parcelRequire("5R0Xk");
var $5Ttm9 = parcelRequire("5Ttm9");

var $ayMG0 = parcelRequire("ayMG0");

var $1u0KT = parcelRequire("1u0KT");


var $r2uF6 = parcelRequire("r2uF6");

var $acw62 = parcelRequire("acw62");
function $fff2b4a85aca8f0e$export$40e2914dc29c2bf9({ children: children, onClose: onClose, size: size = (0, $30c17e6838b1ddb3$export$fcbbb141329b865d).DEFAULT }) {
    const [needsCloseResolution, setNeedsCloseResolution] = (0, $acw62.useState)(false);
    const rightDrawerOpen = (0, $r2uF6.useAtomValue)((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae));
    const [rightDrawerSize, setRightDrawerSize] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$77306c2481da7c28));
    const mobilePortalContainer = document.getElementById("mobile-right-drawer-content");
    const portalContainer = document.getElementById("right-drawer-content");
    (0, $acw62.useEffect)(()=>{
        if (size !== rightDrawerSize) setRightDrawerSize(size);
    }, [
        size,
        rightDrawerSize,
        setRightDrawerSize
    ]);
    (0, $acw62.useEffect)(()=>{
        if (rightDrawerOpen) setNeedsCloseResolution(true);
    }, [
        rightDrawerOpen,
        setNeedsCloseResolution
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!rightDrawerOpen && needsCloseResolution && onClose) onClose();
    }, [
        onClose,
        rightDrawerOpen,
        needsCloseResolution
    ]);
    if (!portalContainer) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
        children: [
            portalContainer && /*#__PURE__*/ (0, $1u0KT.createPortal)(children, portalContainer),
            mobilePortalContainer && /*#__PURE__*/ (0, $1u0KT.createPortal)(children, mobilePortalContainer)
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $r2uF6 = parcelRequire("r2uF6");


var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");

var $fRJCp = parcelRequire("fRJCp");


var $r2uF6 = parcelRequire("r2uF6");


var $iIDkB = parcelRequire("iIDkB");
var $cXDYR = parcelRequire("cXDYR");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");
function $e3cf5aabb212ae04$export$dd2c3c8c2104a426(callback) {
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (e.key === "Escape") {
                e.preventDefault();
                callback();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>window.removeEventListener("keydown", handleKeyDown);
    }, [
        callback
    ]);
}



var $acw62 = parcelRequire("acw62");
function $3398e3e074fa037e$export$2e2bcd8739ae039({ onClick: onClick, label: label = "Close", iconDirection: iconDirection = "right", useEscapeToClose: useEscapeToClose = false }) {
    const [isOpen, setIsOpen] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae));
    (0, $e3cf5aabb212ae04$export$dd2c3c8c2104a426)((0, $acw62.useCallback)(()=>{
        if (useEscapeToClose) {
            if (onClick) onClick();
            else setIsOpen(false);
        }
    }, [
        useEscapeToClose,
        onClick,
        setIsOpen
    ]));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: isOpen ? 1 : 0
        },
        exit: {
            opacity: 0
        },
        transition: (0, $f09089f5cc75b534$export$da1e9475c942285b),
        className: "flex items-center justify-between pb-2",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
            type: "button",
            onClick: onClick || (()=>setIsOpen(false)),
            className: (0, $9QePP.default)("menu-item ui-element subdued text-sm", "mb-4 flex cursor-pointer items-center gap-1"),
            children: [
                iconDirection === "right" && label,
                iconDirection === "right" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cXDYR.default), {
                    className: "size-3",
                    color: "#E5E7EB"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iIDkB.default), {
                    className: "size-3",
                    color: "#E5E7EB"
                }),
                iconDirection === "left" && label
            ]
        })
    });
}



var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $0682b19766de6cfd$var$VariableIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.745 3A23.933 23.933 0 0 0 3 12c0 3.183.62 6.22 1.745 9M19.5 3c.967 2.78 1.5 5.817 1.5 9s-.533 6.22-1.5 9M8.25 8.885l1.444-.89a.75.75 0 0 1 1.105.402l2.402 7.206a.75.75 0 0 0 1.104.401l1.445-.889m-8.25.75.213.09a1.687 1.687 0 0 0 2.062-.617l4.45-6.676a1.688 1.688 0 0 1 2.062-.618l.213.09"
    }));
}
const $0682b19766de6cfd$var$ForwardRef = $acw62.forwardRef($0682b19766de6cfd$var$VariableIcon);
var $0682b19766de6cfd$export$2e2bcd8739ae039 = $0682b19766de6cfd$var$ForwardRef;



var $9QePP = parcelRequire("9QePP");

const $4a82edfdfe4a6d1b$var$COMPOSITION_DESCRIPTIONS = {
    derived: "A field calculated or generated from one or more base fields using logic or formulas.",
    base: "A primary, raw data field stored directly in the system (entered or ingested as-is).",
    raw: "A primary, raw data field stored directly in the system (entered or ingested as-is)."
};
function $4a82edfdfe4a6d1b$export$7a39fc3f811ab806({ metric: metric }) {
    const [showFormula, setShowFormula] = (0, $acw62.useState)(false);
    const compositionDisplay = (0, $acw62.useMemo)(()=>{
        const composition = metric.description?.composition;
        if (!composition) return undefined;
        return composition.toLowerCase() === "raw" ? "base" : composition;
    }, [
        metric.description?.composition
    ]);
    const description = (0, $acw62.useMemo)(()=>{
        const fullDescription = metric.description?.description;
        if (!fullDescription) return undefined;
        const parts = fullDescription.split("\n\n");
        const out = parts.length >= 3 ? parts[1] : fullDescription;
        return out;
    }, [
        metric.description?.description
    ]);
    const formula = (0, $acw62.useMemo)(()=>{
        const fullDescription = metric.description?.description;
        if (!fullDescription) return [];
        const afterExpression = fullDescription.split("With the expression:\n")[1];
        if (!afterExpression) return [];
        const codeBlockMatch = afterExpression.match(/```text\n([\s\S]*?)```/);
        if (!codeBlockMatch) return [];
        const formulaString = codeBlockMatch[1];
        const functionMatch = formulaString.match(/(\w+)\s*\(([\s\S]*)\)/);
        if (!functionMatch) return [];
        const [, , innerContent] = functionMatch;
        return innerContent.split(",").map((operand)=>operand.trim()).filter((operand)=>operand && operand !== "");
    }, [
        metric.description?.description
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            description && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "body-s italic text-gray-400",
                children: description
            }),
            compositionDisplay && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "body-s flex items-center gap-1 text-gray-400",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "capitalize italic",
                        children: compositionDisplay
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5f7cc04a2cba0193$export$dbdcde5ca046596e), {
                        children: $4a82edfdfe4a6d1b$var$COMPOSITION_DESCRIPTIONS[compositionDisplay.toLowerCase()] || compositionDisplay
                    })
                ]
            }),
            formula.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: (0, $9QePP.default)("body-s subdued flex cursor-pointer items-center gap-1"),
                        onClick: ()=>setShowFormula(!showFormula),
                        children: [
                            showFormula ? "Hide formula" : "Show formula",
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0682b19766de6cfd$export$2e2bcd8739ae039), {
                                className: "size-4"
                            })
                        ]
                    }),
                    showFormula && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, $9QePP.default)("bg-[#263142] p-5", "flex flex-wrap", "gap-2 rounded"),
                        children: formula.map((line, idx)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "py-1 font-[300]",
                                children: line + (line === formula[formula.length - 1] ? "" : " +")
                            }, `${line}-${idx}`);
                        })
                    })
                ]
            })
        ]
    });
}




var $r2uF6 = parcelRequire("r2uF6");




var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $d5068cd7b7d7e14a$export$57899b84ad852429({ value: value, showEqualSign: showEqualSign = true }) {
    if (value === null) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mt-2 w-full",
        children: [
            showEqualSign && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "text-default py-0.5 pr-2",
                children: "="
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: (0, $9QePP.default)("text-default bg-default-overlay-7 rounded-lg border border-slate-700 px-2 py-1"),
                children: value
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("2bFYF");
var $fp4OM = parcelRequire("fp4OM");
parcelRequire("UXGeS");
var $7Y7Q4 = parcelRequire("7Y7Q4");

var $9QePP = parcelRequire("9QePP");

var $kkxkw = parcelRequire("kkxkw");
var $f19d5eec019b83cc$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType["CLEANED"] = "cleaned";
    DocumentType["LABELED"] = "labeled";
})($f19d5eec019b83cc$export$d1d99cf900472499 || ($f19d5eec019b83cc$export$d1d99cf900472499 = {}));
var $f19d5eec019b83cc$export$41e58614ac70f6e0;
(function(StatementType) {
    StatementType["INCOME_STATEMENT"] = "income_statement";
    StatementType["BALANCE_SHEET"] = "balance_sheet";
    StatementType["MIXED"] = "mixed";
})($f19d5eec019b83cc$export$41e58614ac70f6e0 || ($f19d5eec019b83cc$export$41e58614ac70f6e0 = {}));
var $f19d5eec019b83cc$export$18dbf40ba8d1d9db;
(function(ConnectorType) {
    ConnectorType["QUICKBOOKS"] = "quickbooks";
    ConnectorType["QUICKBOOKS_DESKTOP"] = "quickbooks_desktop";
    ConnectorType["QUICKBOOKS_SANDBOX"] = "quickbooks_sandbox";
    ConnectorType["NETSUITE"] = "netsuite";
    ConnectorType["PLAID"] = "plaid";
    ConnectorType["STRIPE"] = "stripe";
    ConnectorType["STRIPE_TEST"] = "stripe_test";
    ConnectorType["SQUARE"] = "square";
    ConnectorType["SQUARE_TEST"] = "square_test";
    ConnectorType["WAVE"] = "wave";
    ConnectorType["SHOPIFY"] = "shopify";
    ConnectorType["SAGE_50"] = "sage_50";
    ConnectorType["SAGE_INTACCT"] = "sage_intacct";
    ConnectorType["XERO"] = "xero";
})($f19d5eec019b83cc$export$18dbf40ba8d1d9db || ($f19d5eec019b83cc$export$18dbf40ba8d1d9db = {}));
var $f19d5eec019b83cc$export$d95e7684b6658cc2;
(function(SourceType) {
    SourceType["Connector"] = "connector";
    SourceType["UploadedFile"] = "uploaded_file";
})($f19d5eec019b83cc$export$d95e7684b6658cc2 || ($f19d5eec019b83cc$export$d95e7684b6658cc2 = {}));


function $51001a49088f04a5$export$33262deb61669587(raw) {
    if (!raw) return raw;
    return {
        ...raw.draftInfo,
        rows: raw.rows,
        meta: raw.meta,
        isCodat: raw.draftInfo.identifierSource === "codat",
        isFile: raw.draftInfo.identifierSource === "file",
        isCleaned: raw.draftInfo.documentType === (0, $f19d5eec019b83cc$export$d1d99cf900472499).CLEANED,
        isLabeled: raw.draftInfo.documentType === (0, $f19d5eec019b83cc$export$d1d99cf900472499).LABELED
    };
}


parcelRequire("gCemA");
var $9O2q1 = parcelRequire("9O2q1");
const $d467c533cc3c7dc1$export$8b3ca78f81ec578c = (0, $kkxkw.createQuery)(async ({ api: api, params: params, router: router })=>{
    const response = await api.get(`/data-association/files/${params?.fileId || router.params.fileId}`);
    return response;
});
const $d467c533cc3c7dc1$export$d964e69f1fd5fd4c = (0, $kkxkw.createQuery)(async ({ api: api, router: router })=>{
    const response = await api.get(`/data-association/files?company_id=in.("${router.params.companyId}")`);
    return response.items;
});
const $d467c533cc3c7dc1$export$a548b27ddc2558f6 = (0, $kkxkw.createQuery)(async ({ api: api, router: router })=>{
    const query = new (0, $9O2q1.QueryStringBuilder)().equals("company_id", router.params.companyId || "").equals("source_type", "connector").equals("document_type", "cleaned").add("max_page_size", "999").build();
    const response = await api.get(`/data-association/files?${query}`);
    return response.items;
});
const $d467c533cc3c7dc1$export$df6ee07eb0d78049 = (0, $kkxkw.createQuery)(async ({ api: api, router: router })=>{
    const response = await api.get(`/data-association/files/${router.params.fileId}/draft`);
    return (0, $51001a49088f04a5$export$33262deb61669587)(response);
});
const $d467c533cc3c7dc1$export$1a473231c51c1d5b = (0, $kkxkw.createQuery)(async ({ api: api, router: router })=>{
    const response = await api.get(`/data-association/files/${router.params.fileId}/drafts/${router.params.draftId}`);
    return (0, $51001a49088f04a5$export$33262deb61669587)(response);
});
const $d467c533cc3c7dc1$export$d705ef743e424c06 = (0, $kkxkw.createQuery)(async ({ api: api, router: router })=>{
    const response = await api.get(`/data-association/drafts?company_id=in.("${router.params.companyId}")`);
    return response.items;
});
const $d467c533cc3c7dc1$export$d5d451a14adbc067 = (0, $kkxkw.createQuery)(async ({ api: api, router: router, params: params })=>{
    let querystring = "";
    if (params?.labels || params?.accountNames) querystring = "&" + new (0, $9O2q1.QueryStringBuilder)().in("label", params.labels).in("name", params.accountNames).build();
    const response = await api.get(`/data-association/accounts?company_id=in.("${router.params.companyId}")${querystring}`);
    return response.items;
});
const $d467c533cc3c7dc1$export$7d94143c01232fd3 = (0, $kkxkw.createQuery)(async ({ api: api, router: router })=>{
    const response = await api.get(`/data-association/tasks?draft_id=eq.${router.params.draftId}`);
    return response.items;
});


function $bd649a13364bf2d5$export$185e80fa08dae04b({ fileId: fileId, onSelect: onSelect }) {
    const router = (0, $fp4OM.useRouter)();
    const { data: file, isLoading: isLoading } = (0, $7Y7Q4.useApiQuery)((0, $d467c533cc3c7dc1$export$8b3ca78f81ec578c), {
        params: {
            fileId: fileId
        }
    });
    if (!file && isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.clsx)("bg-selected h-6 w-full", "animate-pulse rounded")
    });
    if (!file) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        onClick: ()=>{
            onSelect();
            setTimeout(()=>{
                router.navigate(`/beta/companies/${router.params.companyId}/labeling/files/${file.id}`);
            }, 0);
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, $9QePP.clsx)("flex cursor-pointer items-center gap-2 rounded-lg px-2 py-1", "hover:bg-hover"),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                    className: (0, $9QePP.clsx)("body-s cursor-pointer", "font-semibold"),
                    children: "Labeled File"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: (0, $9QePP.clsx)("body-s cursor-pointer text-slate-500"),
                    children: file.id.slice(-6)
                })
            ]
        })
    });
}


function $22a552b8c722c3a2$export$4b65d6703406e4c0({ metric: metric, metricLabel: metricLabel, currentSlice: currentSlice, previousSlice: previousSlice, resolutionWindow: resolutionWindow, fieldType: fieldType, popLabel: popLabel }) {
    const previousFormula = (0, $a0b0e4e94524bfb3$export$42395004151c5189)(previousSlice, fieldType);
    const currentForumla = (0, $a0b0e4e94524bfb3$export$42395004151c5189)(currentSlice, fieldType);
    const deltaFormula = (0, $a0b0e4e94524bfb3$export$a85cface4f0d5167)(previousSlice.map(([period])=>period), currentSlice.map(([period])=>period), resolutionWindow);
    const setAIMContextView = (0, $r2uF6.useSetAtom)((0, $57f1ca4385a7301a$export$c65e5de3b3a2e247));
    const delta = (0, $a0b0e4e94524bfb3$export$4b13ea46348dc970)(currentSlice, previousSlice);
    const sources = [
        ...new Set(metric?.lineagedValues?.flatMap((lv)=>lv.values?.map((value)=>value.meta?.dataAssetId)))
    ].filter(Boolean);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("px-6 pb-6", "custom-scrollbar absolute inset-0 flex min-h-0 flex-col overflow-hidden"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "sticky my-4 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3398e3e074fa037e$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            setAIMContextView(null);
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        className: "pageheading ",
                        children: [
                            metricLabel,
                            " - % Change"
                        ]
                    }),
                    metric && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a82edfdfe4a6d1b$export$7a39fc3f811ab806), {
                        metric: metric
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "custom-scrollbar hide-scrollbar overflow-y-scroll",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "heading-l mb-4 mt-6",
                            children: "Calculations"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-col gap-6",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "heading-m mb-3",
                                            children: (0, $a0038ff09b9cb167$export$254c7990ecbe689e)(previousSlice.map(([period])=>period))
                                        }),
                                        previousFormula.formula.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "formula-display flex flex-wrap leading-loose",
                                            children: previousFormula.formula.map((part, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "py-0.5 pr-2",
                                                    children: part
                                                }, `previous-${part}-${index}`))
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5068cd7b7d7e14a$export$57899b84ad852429), {
                                            value: (0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $a0b0e4e94524bfb3$export$ac4d890ffdd9be01)(previousSlice), fieldType),
                                            showEqualSign: previousFormula.formula.length > 1
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "heading-m mb-3",
                                            children: (0, $a0038ff09b9cb167$export$254c7990ecbe689e)(currentSlice.map(([period])=>period))
                                        }),
                                        currentForumla.formula.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "formula-display flex flex-wrap leading-loose",
                                            children: currentForumla.formula.map((part, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "py-0.5 pr-2",
                                                    children: part
                                                }, `current-${part}-${index}`))
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5068cd7b7d7e14a$export$57899b84ad852429), {
                                            showEqualSign: currentForumla.formula.length > 1,
                                            value: (0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)((0, $a0b0e4e94524bfb3$export$ac4d890ffdd9be01)(currentSlice), fieldType)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "heading-m mb-3",
                                            children: popLabel || deltaFormula.title
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: (0, $9QePP.default)("flex flex-wrap", "formula-display items-center gap-y-2"),
                                            children: [
                                                deltaFormula.formula.map((part, index)=>[
                                                        "(",
                                                        ")",
                                                        "/",
                                                        "-"
                                                    ].includes(part) ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "py-0.5 pr-2",
                                                        children: part
                                                    }, `delta-${part}-${index}`) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: (0, $9QePP.default)("text-default mr-2 px-2 py-0.5", "border-default rounded-lg border"),
                                                        style: {
                                                            color: "white"
                                                        },
                                                        children: part
                                                    }, `delta-${part}-${index}`)),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5068cd7b7d7e14a$export$57899b84ad852429), {
                                                    value: delta ? `${delta < 0 ? "" : "+"}${(delta * 100).toFixed(2)}%` : null
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "heading-l mb-4 mt-6",
                            children: "Sources"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex flex-col gap-3",
                            children: sources.map((source)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd649a13364bf2d5$export$185e80fa08dae04b), {
                                    fileId: source,
                                    onSelect: ()=>{
                                        setAIMContextView(null);
                                    }
                                }, source))
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $gxPgh = parcelRequire("gxPgh");

var $acw62 = parcelRequire("acw62");

var $jIDNV = parcelRequire("jIDNV");
// packages/ag-grid-enterprise/src/license/gridLicenseManager.ts

var $jIDNV = parcelRequire("jIDNV");
// packages/ag-grid-enterprise/src/license/shared/md5.ts
var $5b7ccabde48fae90$var$MD5 = class {
    constructor(){
        this.ieCompatibility = false;
    }
    init() {
        this.ieCompatibility = this.md5("hello") != "5d41402abc4b2a76b9719d911017c592";
    }
    md5cycle(x, k) {
        let a = x[0], b = x[1], c = x[2], d = x[3];
        a = this.ff(a, b, c, d, k[0], 7, -680876936);
        d = this.ff(d, a, b, c, k[1], 12, -389564586);
        c = this.ff(c, d, a, b, k[2], 17, 606105819);
        b = this.ff(b, c, d, a, k[3], 22, -1044525330);
        a = this.ff(a, b, c, d, k[4], 7, -176418897);
        d = this.ff(d, a, b, c, k[5], 12, 1200080426);
        c = this.ff(c, d, a, b, k[6], 17, -1473231341);
        b = this.ff(b, c, d, a, k[7], 22, -45705983);
        a = this.ff(a, b, c, d, k[8], 7, 1770035416);
        d = this.ff(d, a, b, c, k[9], 12, -1958414417);
        c = this.ff(c, d, a, b, k[10], 17, -42063);
        b = this.ff(b, c, d, a, k[11], 22, -1990404162);
        a = this.ff(a, b, c, d, k[12], 7, 1804603682);
        d = this.ff(d, a, b, c, k[13], 12, -40341101);
        c = this.ff(c, d, a, b, k[14], 17, -1502002290);
        b = this.ff(b, c, d, a, k[15], 22, 1236535329);
        a = this.gg(a, b, c, d, k[1], 5, -165796510);
        d = this.gg(d, a, b, c, k[6], 9, -1069501632);
        c = this.gg(c, d, a, b, k[11], 14, 643717713);
        b = this.gg(b, c, d, a, k[0], 20, -373897302);
        a = this.gg(a, b, c, d, k[5], 5, -701558691);
        d = this.gg(d, a, b, c, k[10], 9, 38016083);
        c = this.gg(c, d, a, b, k[15], 14, -660478335);
        b = this.gg(b, c, d, a, k[4], 20, -405537848);
        a = this.gg(a, b, c, d, k[9], 5, 568446438);
        d = this.gg(d, a, b, c, k[14], 9, -1019803690);
        c = this.gg(c, d, a, b, k[3], 14, -187363961);
        b = this.gg(b, c, d, a, k[8], 20, 1163531501);
        a = this.gg(a, b, c, d, k[13], 5, -1444681467);
        d = this.gg(d, a, b, c, k[2], 9, -51403784);
        c = this.gg(c, d, a, b, k[7], 14, 1735328473);
        b = this.gg(b, c, d, a, k[12], 20, -1926607734);
        a = this.hh(a, b, c, d, k[5], 4, -378558);
        d = this.hh(d, a, b, c, k[8], 11, -2022574463);
        c = this.hh(c, d, a, b, k[11], 16, 1839030562);
        b = this.hh(b, c, d, a, k[14], 23, -35309556);
        a = this.hh(a, b, c, d, k[1], 4, -1530992060);
        d = this.hh(d, a, b, c, k[4], 11, 1272893353);
        c = this.hh(c, d, a, b, k[7], 16, -155497632);
        b = this.hh(b, c, d, a, k[10], 23, -1094730640);
        a = this.hh(a, b, c, d, k[13], 4, 681279174);
        d = this.hh(d, a, b, c, k[0], 11, -358537222);
        c = this.hh(c, d, a, b, k[3], 16, -722521979);
        b = this.hh(b, c, d, a, k[6], 23, 76029189);
        a = this.hh(a, b, c, d, k[9], 4, -640364487);
        d = this.hh(d, a, b, c, k[12], 11, -421815835);
        c = this.hh(c, d, a, b, k[15], 16, 530742520);
        b = this.hh(b, c, d, a, k[2], 23, -995338651);
        a = this.ii(a, b, c, d, k[0], 6, -198630844);
        d = this.ii(d, a, b, c, k[7], 10, 1126891415);
        c = this.ii(c, d, a, b, k[14], 15, -1416354905);
        b = this.ii(b, c, d, a, k[5], 21, -57434055);
        a = this.ii(a, b, c, d, k[12], 6, 1700485571);
        d = this.ii(d, a, b, c, k[3], 10, -1894986606);
        c = this.ii(c, d, a, b, k[10], 15, -1051523);
        b = this.ii(b, c, d, a, k[1], 21, -2054922799);
        a = this.ii(a, b, c, d, k[8], 6, 1873313359);
        d = this.ii(d, a, b, c, k[15], 10, -30611744);
        c = this.ii(c, d, a, b, k[6], 15, -1560198380);
        b = this.ii(b, c, d, a, k[13], 21, 1309151649);
        a = this.ii(a, b, c, d, k[4], 6, -145523070);
        d = this.ii(d, a, b, c, k[11], 10, -1120210379);
        c = this.ii(c, d, a, b, k[2], 15, 718787259);
        b = this.ii(b, c, d, a, k[9], 21, -343485551);
        x[0] = this.add32(a, x[0]);
        x[1] = this.add32(b, x[1]);
        x[2] = this.add32(c, x[2]);
        x[3] = this.add32(d, x[3]);
    }
    cmn(q, a, b, x, s, t) {
        a = this.add32(this.add32(a, q), this.add32(x, t));
        return this.add32(a << s | a >>> 32 - s, b);
    }
    ff(a, b, c, d, x, s, t) {
        return this.cmn(b & c | ~b & d, a, b, x, s, t);
    }
    gg(a, b, c, d, x, s, t) {
        return this.cmn(b & d | c & ~d, a, b, x, s, t);
    }
    hh(a, b, c, d, x, s, t) {
        return this.cmn(b ^ c ^ d, a, b, x, s, t);
    }
    ii(a, b, c, d, x, s, t) {
        return this.cmn(c ^ (b | ~d), a, b, x, s, t);
    }
    md51(s) {
        const n = s.length;
        const state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        let i;
        for(i = 64; i <= s.length; i += 64)this.md5cycle(state, this.md5blk(s.substring(i - 64, i)));
        s = s.substring(i - 64);
        const tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < s.length; i++)tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
        tail[i >> 2] |= 128 << (i % 4 << 3);
        if (i > 55) {
            this.md5cycle(state, tail);
            for(i = 0; i < 16; i++)tail[i] = 0;
        }
        tail[14] = n * 8;
        this.md5cycle(state, tail);
        return state;
    }
    /* there needs to be support for Unicode here, * unless we pretend that we can redefine the MD-5
   * algorithm for multi-byte characters (perhaps by adding every four 16-bit characters and
   * shortening the sum to 32 bits). Otherwise I suthis.ggest performing MD-5 as if every character
   * was two bytes--e.g., 0040 0025 = @%--but then how will an ordinary MD-5 sum be matched?
   * There is no way to standardize text to something like UTF-8 before transformation; speed cost is
   * utterly prohibitive. The JavaScript standard itself needs to look at this: it should start
   * providing access to strings as preformed UTF-8 8-bit unsigned value arrays.
   */ md5blk(s) {
        const md5blks = [];
        for(let i = 0; i < 64; i += 4)md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
        return md5blks;
    }
    rhex(n) {
        const hex_chr = "0123456789abcdef".split("");
        let s = "", j = 0;
        for(; j < 4; j++)s += hex_chr[n >> j * 8 + 4 & 15] + hex_chr[n >> j * 8 & 15];
        return s;
    }
    hex(x) {
        for(let i = 0; i < x.length; i++)x[i] = this.rhex(x[i]);
        return x.join("");
    }
    md5(s) {
        return this.hex(this.md51(s));
    }
    add32(a, b) {
        return this.ieCompatibility ? this.add32Compat(a, b) : this.add32Std(a, b);
    }
    /* this function is much faster, so if possible we use it. Some IEs are the only ones I know of that
   need the idiotic second function, generated by an if clause.  */ add32Std(a, b) {
        return a + b & 4294967295;
    }
    add32Compat(x, y) {
        const lsw = (x & 65535) + (y & 65535), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 65535;
    }
};
// packages/ag-grid-enterprise/src/license/shared/licenseManager.ts
var $5b7ccabde48fae90$var$LICENSE_TYPES = {
    "01": "GRID",
    "02": "CHARTS",
    "0102": "BOTH"
};
var $5b7ccabde48fae90$var$LICENSING_HELP_URL = "https://www.ag-grid.com/licensing/";
var $5b7ccabde48fae90$var$_LicenseManager = class _LicenseManager {
    constructor(document2){
        this.watermarkMessage = void 0;
        this.totalMessageLength = 124;
        this.document = document2;
        this.md5 = new $5b7ccabde48fae90$var$MD5();
        this.md5.init();
    }
    validateLicense() {
        const licenseDetails = this.getLicenseDetails(_LicenseManager.licenseKey);
        const currentLicenseName = `AG Grid ${licenseDetails.currentLicenseType === "BOTH" ? "and AG Charts " : ""}Enterprise`;
        const suppliedLicenseName = licenseDetails.suppliedLicenseType === void 0 ? "" : `AG ${licenseDetails.suppliedLicenseType === "BOTH" ? "Grid and AG Charts" : licenseDetails.suppliedLicenseType === "GRID" ? "Grid" : "Charts"} Enterprise`;
        if (licenseDetails.missing) {
            if (!this.isWebsiteUrl() || this.isForceWatermark()) this.outputMissingLicenseKey(currentLicenseName);
        } else if (licenseDetails.expired) {
            const gridReleaseDate = _LicenseManager.getGridReleaseDate();
            const formattedReleaseDate = _LicenseManager.formatDate(gridReleaseDate);
            this.outputExpiredKey(licenseDetails.expiry, formattedReleaseDate, currentLicenseName, suppliedLicenseName);
        } else if (!licenseDetails.valid) this.outputInvalidLicenseKey(!!licenseDetails.incorrectLicenseType, currentLicenseName, suppliedLicenseName);
        else if (licenseDetails.isTrial && licenseDetails.trialExpired) this.outputExpiredTrialKey(licenseDetails.expiry, currentLicenseName, suppliedLicenseName);
    }
    static extractExpiry(license) {
        const restrictionHashed = license.substring(license.lastIndexOf("_") + 1, license.length);
        return new Date(parseInt(_LicenseManager.decode(restrictionHashed), 10));
    }
    static extractLicenseComponents(licenseKey) {
        let cleanedLicenseKey = licenseKey.replace(/[\u200B-\u200D\uFEFF]/g, "");
        cleanedLicenseKey = cleanedLicenseKey.replace(/\r?\n|\r/g, "");
        if (licenseKey.length <= 32) return {
            md5: null,
            license: licenseKey,
            version: null,
            isTrial: null
        };
        const hashStart = cleanedLicenseKey.length - 32;
        const md5 = cleanedLicenseKey.substring(hashStart);
        const license = cleanedLicenseKey.substring(0, hashStart);
        const [version, isTrial, type] = _LicenseManager.extractBracketedInformation(cleanedLicenseKey);
        return {
            md5: md5,
            license: license,
            version: version,
            isTrial: isTrial,
            type: type
        };
    }
    getLicenseDetails(licenseKey) {
        const currentLicenseType = _LicenseManager.chartsLicenseManager ? "BOTH" : "GRID";
        if (!licenseKey?.length) return {
            licenseKey: licenseKey,
            valid: false,
            missing: true,
            currentLicenseType: currentLicenseType
        };
        const gridReleaseDate = _LicenseManager.getGridReleaseDate();
        const { md5: md5, license: license, version: version, isTrial: isTrial, type: type } = _LicenseManager.extractLicenseComponents(licenseKey);
        let valid = md5 === this.md5.md5(license) && licenseKey.indexOf("For_Trialing_ag-Grid_Only") === -1;
        let trialExpired = void 0;
        let expired = void 0;
        let expiry = null;
        let incorrectLicenseType = false;
        let suppliedLicenseType = void 0;
        function handleTrial() {
            const now = /* @__PURE__ */ new Date();
            trialExpired = expiry < now;
            expired = void 0;
        }
        if (valid) {
            expiry = _LicenseManager.extractExpiry(license);
            valid = !isNaN(expiry.getTime());
            if (valid) {
                expired = gridReleaseDate > expiry;
                switch(version){
                    case "legacy":
                    case "2":
                        if (isTrial) handleTrial();
                        break;
                    case "3":
                        if (!type?.length) valid = false;
                        else {
                            suppliedLicenseType = type;
                            if (type !== $5b7ccabde48fae90$var$LICENSE_TYPES["01"] && type !== $5b7ccabde48fae90$var$LICENSE_TYPES["0102"] || currentLicenseType === "BOTH" && suppliedLicenseType !== "BOTH") {
                                valid = false;
                                incorrectLicenseType = true;
                            } else if (isTrial) handleTrial();
                        }
                }
            }
        }
        if (!valid) return {
            licenseKey: licenseKey,
            valid: valid,
            incorrectLicenseType: incorrectLicenseType,
            currentLicenseType: currentLicenseType,
            suppliedLicenseType: suppliedLicenseType
        };
        return {
            licenseKey: licenseKey,
            valid: valid,
            expiry: _LicenseManager.formatDate(expiry),
            expired: expired,
            version: version,
            isTrial: isTrial,
            trialExpired: trialExpired,
            incorrectLicenseType: incorrectLicenseType,
            currentLicenseType: currentLicenseType,
            suppliedLicenseType: suppliedLicenseType
        };
    }
    isDisplayWatermark() {
        return this.isForceWatermark() || !this.isLocalhost() && !this.isWebsiteUrl() && !!this.watermarkMessage?.length;
    }
    getWatermarkMessage() {
        return this.watermarkMessage || "";
    }
    getHostname() {
        const win = this.document.defaultView || window;
        const loc = win.location;
        const { hostname: hostname = "" } = loc;
        return hostname;
    }
    isForceWatermark() {
        const win = this.document.defaultView || window;
        const loc = win.location;
        const { pathname: pathname } = loc;
        return pathname ? pathname.indexOf("forceWatermark") !== -1 : false;
    }
    isWebsiteUrl() {
        const hostname = this.getHostname();
        return hostname.match(/^((?:[\w-]+\.)?ag-grid\.com)$/) !== null;
    }
    isLocalhost() {
        const hostname = this.getHostname();
        return hostname.match(/^(?:127\.0\.0\.1|localhost)$/) !== null;
    }
    static formatDate(date) {
        const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();
        return day + " " + monthNames[monthIndex] + " " + year;
    }
    static getGridReleaseDate() {
        return new Date(parseInt(_LicenseManager.decode(_LicenseManager.RELEASE_INFORMATION), 10));
    }
    static decode(input) {
        const keystr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        let t = "";
        let n, r, i;
        let s, o, u, a;
        let f = 0;
        const e = input.replace(/[^A-Za-z0-9+/=]/g, "");
        while(f < e.length){
            s = keystr.indexOf(e.charAt(f++));
            o = keystr.indexOf(e.charAt(f++));
            u = keystr.indexOf(e.charAt(f++));
            a = keystr.indexOf(e.charAt(f++));
            n = s << 2 | o >> 4;
            r = (o & 15) << 4 | u >> 2;
            i = (u & 3) << 6 | a;
            t = t + String.fromCharCode(n);
            if (u != 64) t = t + String.fromCharCode(r);
            if (a != 64) t = t + String.fromCharCode(i);
        }
        t = _LicenseManager.utf8_decode(t);
        return t;
    }
    static utf8_decode(input) {
        input = input.replace(/rn/g, "n");
        let t = "";
        for(let n = 0; n < input.length; n++){
            const r = input.charCodeAt(n);
            if (r < 128) t += String.fromCharCode(r);
            else if (r > 127 && r < 2048) {
                t += String.fromCharCode(r >> 6 | 192);
                t += String.fromCharCode(r & 63 | 128);
            } else {
                t += String.fromCharCode(r >> 12 | 224);
                t += String.fromCharCode(r >> 6 & 63 | 128);
                t += String.fromCharCode(r & 63 | 128);
            }
        }
        return t;
    }
    static setChartsLicenseManager(dependantLicenseManager) {
        this.chartsLicenseManager = dependantLicenseManager;
        this.chartsLicenseManager?.setLicenseKey(this.licenseKey, true);
    }
    static setLicenseKey(licenseKey) {
        this.licenseKey = licenseKey;
        this.chartsLicenseManager?.setLicenseKey(licenseKey, true);
    }
    static extractBracketedInformation(licenseKey) {
        if (!licenseKey.includes("[")) return [
            "legacy",
            false,
            void 0
        ];
        const matches = licenseKey.match(/\[(.*?)\]/g).map((match)=>match.replace("[", "").replace("]", ""));
        if (!matches || matches.length === 0) return [
            "legacy",
            false,
            void 0
        ];
        const isTrial = matches.filter((match)=>match === "TRIAL").length === 1;
        const rawVersion = matches.filter((match)=>match.indexOf("v") === 0)[0];
        const version = rawVersion ? rawVersion.replace("v", "") : "legacy";
        const type = $5b7ccabde48fae90$var$LICENSE_TYPES[matches.filter((match)=>$5b7ccabde48fae90$var$LICENSE_TYPES[match])[0]];
        return [
            version,
            isTrial,
            type
        ];
    }
    centerPadAndOutput(input) {
        const paddingRequired = this.totalMessageLength - input.length;
        console.error(input.padStart(paddingRequired / 2 + input.length, "*").padEnd(this.totalMessageLength, "*"));
    }
    padAndOutput(input, padding = "*", terminateWithPadding = "") {
        console.error(input.padEnd(this.totalMessageLength - terminateWithPadding.length, padding) + terminateWithPadding);
    }
    outputInvalidLicenseKey(incorrectLicenseType, currentLicenseName, suppliedLicenseName) {
        if (incorrectLicenseType) {
            this.centerPadAndOutput("");
            this.centerPadAndOutput(` ${currentLicenseName} License `);
            this.centerPadAndOutput(" Incompatible License Key ");
            this.padAndOutput(`* Your license key is for ${suppliedLicenseName} only and does not cover you for ${currentLicenseName}.`, " ", "*");
            this.padAndOutput(`* To troubleshoot your license key visit ${$5b7ccabde48fae90$var$LICENSING_HELP_URL}.`, " ", "*");
            this.centerPadAndOutput("");
            this.centerPadAndOutput("");
        } else {
            this.centerPadAndOutput("");
            this.centerPadAndOutput(` ${currentLicenseName} License `);
            this.centerPadAndOutput(" Invalid License Key ");
            this.padAndOutput(`* Your license key is not valid.`, " ", "*");
            this.padAndOutput(`* To troubleshoot your license key visit ${$5b7ccabde48fae90$var$LICENSING_HELP_URL}.`, " ", "*");
            this.centerPadAndOutput("");
            this.centerPadAndOutput("");
        }
        this.watermarkMessage = "Invalid License";
    }
    outputExpiredTrialKey(formattedExpiryDate, currentLicenseName, suppliedLicenseName) {
        this.centerPadAndOutput("");
        this.centerPadAndOutput(` ${currentLicenseName} License `);
        this.centerPadAndOutput(" Trial Period Expired. ");
        this.padAndOutput(`* Your trial only license for ${suppliedLicenseName} expired on ${formattedExpiryDate}.`, " ", "*");
        this.padAndOutput("* Please email info@ag-grid.com to purchase a license.", " ", "*");
        this.centerPadAndOutput("");
        this.centerPadAndOutput("");
        this.watermarkMessage = "Trial Period Expired";
    }
    outputMissingLicenseKey(currentLicenseName) {
        this.centerPadAndOutput("");
        this.centerPadAndOutput(` ${currentLicenseName} License `);
        this.centerPadAndOutput(" License Key Not Found ");
        this.padAndOutput(`* All ${currentLicenseName} features are unlocked for trial.`, " ", "*");
        this.padAndOutput("* If you want to hide the watermark please email info@ag-grid.com for a trial license key.", " ", "*");
        this.centerPadAndOutput("");
        this.centerPadAndOutput("");
        this.watermarkMessage = "For Trial Use Only";
    }
    outputExpiredKey(formattedExpiryDate, formattedReleaseDate, currentLicenseName, suppliedLicenseName) {
        this.centerPadAndOutput("");
        this.centerPadAndOutput(` ${currentLicenseName} License `);
        this.centerPadAndOutput(" Incompatible Software Version ");
        this.padAndOutput(`* Your license key works with versions${suppliedLicenseName == "" ? "" : ` of ${suppliedLicenseName}`} released before ${formattedExpiryDate}.`, " ", "*");
        this.padAndOutput(`* The version you are trying to use was released on ${formattedReleaseDate}.`, " ", "*");
        this.padAndOutput("* Please contact info@ag-grid.com to renew your license key.", " ", "*");
        this.centerPadAndOutput("");
        this.centerPadAndOutput("");
        this.watermarkMessage = "License Expired";
    }
};
$5b7ccabde48fae90$var$_LicenseManager.RELEASE_INFORMATION = "MTc1NTA5MjQ4MDczNA==";
var $5b7ccabde48fae90$var$LicenseManager = $5b7ccabde48fae90$var$_LicenseManager;
// packages/ag-grid-enterprise/src/license/watermark.css-GENERATED.ts
var $5b7ccabde48fae90$var$watermarkCSS = /*css*/ `.ag-watermark{bottom:20px;color:#9b9b9b;opacity:.7;position:absolute;transition:opacity 1s ease-out 3s;&:before{background-image:url("data:image/svg+xml;base64,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");background-repeat:no-repeat;background-size:170px 40px;content:"";display:block;height:40px;width:170px}}:where(.ag-ltr) .ag-watermark{right:25px}:where(.ag-rtl) .ag-watermark{left:25px}.ag-watermark-text{font-family:Impact,sans-serif;font-size:19px;font-weight:700;opacity:.5}:where(.ag-ltr) .ag-watermark-text{padding-left:.7rem}:where(.ag-rtl) .ag-watermark-text{padding-right:.7rem}`;
// packages/ag-grid-enterprise/src/license/watermark.ts
var $5b7ccabde48fae90$var$WatermarkElement = {
    tag: "div",
    cls: "ag-watermark",
    children: [
        {
            tag: "div",
            ref: "eLicenseTextRef",
            cls: "ag-watermark-text"
        }
    ]
};
var $5b7ccabde48fae90$var$AgWatermark = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$WatermarkElement);
        this.eLicenseTextRef = (0, $jIDNV.RefPlaceholder);
        this.registerCSS($5b7ccabde48fae90$var$watermarkCSS);
    }
    wireBeans(beans) {
        this.licenseManager = beans.licenseManager;
    }
    postConstruct() {
        const show = this.shouldDisplayWatermark();
        this.setDisplayed(show);
        if (show) {
            this.eLicenseTextRef.textContent = this.licenseManager.getWatermarkMessage();
            window.setTimeout(()=>this.addCss("ag-opacity-zero"), 0);
            window.setTimeout(()=>this.setDisplayed(false), 5e3);
        }
    }
    shouldDisplayWatermark() {
        return this.licenseManager.isDisplayWatermark();
    }
};
var $5b7ccabde48fae90$var$AgWatermarkSelector = {
    selector: "AG-WATERMARK",
    component: $5b7ccabde48fae90$var$AgWatermark
};
// packages/ag-grid-enterprise/src/license/gridLicenseManager.ts
var $5b7ccabde48fae90$export$91e2bbffdbb3852c = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "licenseManager";
    }
    postConstruct() {
        this.validateLicense();
    }
    validateLicense() {
        this.licenseManager = new $5b7ccabde48fae90$var$LicenseManager((0, $jIDNV._getDocument)(this.beans));
        this.licenseManager.validateLicense();
    }
    static getLicenseDetails(licenseKey) {
        return new $5b7ccabde48fae90$var$LicenseManager(null).getLicenseDetails(licenseKey);
    }
    getWatermarkSelector() {
        return $5b7ccabde48fae90$var$AgWatermarkSelector;
    }
    isDisplayWatermark() {
        return this.licenseManager.isDisplayWatermark();
    }
    getWatermarkMessage() {
        return this.licenseManager.getWatermarkMessage();
    }
    static setLicenseKey(licenseKey) {
        $5b7ccabde48fae90$var$LicenseManager.setLicenseKey(licenseKey);
    }
    static setChartsLicenseManager(chartsLicenseManager) {
        $5b7ccabde48fae90$var$LicenseManager.setChartsLicenseManager(chartsLicenseManager);
    }
};
// packages/ag-grid-enterprise/src/excelExport/assets/excelConstants.ts
var $5b7ccabde48fae90$var$INCH_TO_EMU = 9525;
var $5b7ccabde48fae90$var$numberFormatMap = {
    "0": 1,
    "0.00": 2,
    "#,##0": 3,
    "#,##0.00": 4,
    "0%": 9,
    "0.00%": 10,
    "0.00E+00": 11,
    "# ?/?": 12,
    "# ??/??": 13,
    "mm-dd-yy": 14,
    "d-mmm-yy": 15,
    "d-mmm": 16,
    "mmm-yy": 17,
    "h:mm AM/PM": 18,
    "h:mm:ss AM/PM": 19,
    "h:mm": 20,
    "h:mm:ss": 21,
    "m/d/yy h:mm": 22,
    "#,##0 ;(#,##0)": 37,
    "#,##0 ;[Red](#,##0)": 38,
    "#,##0.00;(#,##0.00)": 39,
    "#,##0.00;[Red](#,##0.00)": 40,
    "mm:ss": 45,
    "[h]:mm:ss": 46,
    "mmss.0": 47,
    "##0.0E+0": 48,
    "@": 49
};
// packages/ag-grid-enterprise/src/excelExport/assets/xmlFactory.ts
var $5b7ccabde48fae90$var$LINE_SEPARATOR = "\r\n";
function $5b7ccabde48fae90$var$returnAttributeIfPopulated(key, value, booleanTransformer) {
    if (!value && value !== "" && value !== 0) return "";
    let xmlValue = value;
    if (typeof value === "boolean") {
        if (booleanTransformer) xmlValue = booleanTransformer(value);
    }
    return ` ${key}="${xmlValue}"`;
}
function $5b7ccabde48fae90$var$createXmlHeader(headerElement = {}) {
    const headerStart = "<?";
    const headerEnd = "?>";
    const keys = [
        "version"
    ];
    if (!headerElement.version) headerElement.version = "1.0";
    if (headerElement.encoding) keys.push("encoding");
    if (headerElement.standalone) keys.push("standalone");
    const att = keys.map((key)=>`${key}="${headerElement[key]}"`).join(" ");
    return `${headerStart}xml ${att} ${headerEnd}`;
}
function $5b7ccabde48fae90$var$createXml(xmlElement, booleanTransformer) {
    let props = "";
    if (xmlElement.properties) {
        if (xmlElement.properties.prefixedAttributes) xmlElement.properties.prefixedAttributes.forEach((prefixedSet)=>{
            Object.keys(prefixedSet.map).forEach((key)=>{
                props += $5b7ccabde48fae90$var$returnAttributeIfPopulated(prefixedSet.prefix + key, prefixedSet.map[key], booleanTransformer);
            });
        });
        if (xmlElement.properties.rawMap) Object.keys(xmlElement.properties.rawMap).forEach((key)=>{
            props += $5b7ccabde48fae90$var$returnAttributeIfPopulated(key, xmlElement.properties.rawMap[key], booleanTransformer);
        });
    }
    let result = "<" + xmlElement.name + props;
    if (!xmlElement.children && xmlElement.textNode == null) return result + "/>" + $5b7ccabde48fae90$var$LINE_SEPARATOR;
    if (xmlElement.textNode != null) return result + ">" + xmlElement.textNode + "</" + xmlElement.name + ">" + $5b7ccabde48fae90$var$LINE_SEPARATOR;
    result += ">" + $5b7ccabde48fae90$var$LINE_SEPARATOR;
    if (xmlElement.children) xmlElement.children.forEach((it)=>{
        result += $5b7ccabde48fae90$var$createXml(it, booleanTransformer);
    });
    return result + "</" + xmlElement.name + ">" + $5b7ccabde48fae90$var$LINE_SEPARATOR;
}
// packages/ag-grid-enterprise/src/excelExport/assets/excelUtils.ts
var $5b7ccabde48fae90$var$pointsToPixel = (points)=>{
    return Math.round(points * 96 / 72);
};
var $5b7ccabde48fae90$var$pixelsToEMU = (value)=>{
    return Math.ceil(value * $5b7ccabde48fae90$var$INCH_TO_EMU);
};
var $5b7ccabde48fae90$var$getFontFamilyId = (name)=>{
    if (name === void 0) return;
    const families = [
        "Automatic",
        "Roman",
        "Swiss",
        "Modern",
        "Script",
        "Decorative"
    ];
    const pos = families.indexOf(name || "Automatic");
    return Math.max(pos, 0);
};
var $5b7ccabde48fae90$var$getHeightFromProperty = (rowIndex, height)=>{
    if (!height) return;
    let finalHeight;
    if (typeof height === "number") finalHeight = height;
    else {
        const heightFunc = height;
        finalHeight = heightFunc({
            rowIndex: rowIndex
        });
    }
    return finalHeight;
};
var $5b7ccabde48fae90$var$setExcelImageTotalWidth = (image, columnsToExport)=>{
    const { colSpan: colSpan, column: column } = image.position;
    if (!image.width) return;
    if (colSpan) {
        const columnsInSpan = columnsToExport.slice(column - 1, column + colSpan - 1);
        let totalWidth = 0;
        for(let i = 0; i < columnsInSpan.length; i++){
            const colWidth = columnsInSpan[i].getActualWidth();
            if (image.width < totalWidth + colWidth) {
                image.position.colSpan = i + 1;
                image.totalWidth = image.width;
                image.width = image.totalWidth - totalWidth;
                break;
            }
            totalWidth += colWidth;
        }
    } else image.totalWidth = image.width;
};
var $5b7ccabde48fae90$var$setExcelImageTotalHeight = (image, rowHeight)=>{
    const { rowSpan: rowSpan, row: row } = image.position;
    if (!image.height) return;
    if (rowSpan) {
        let totalHeight = 0;
        let counter = 0;
        for(let i = row; i < row + rowSpan; i++){
            const nextRowHeight = $5b7ccabde48fae90$var$pointsToPixel($5b7ccabde48fae90$var$getHeightFromProperty(i, rowHeight) || 20);
            if (image.height < totalHeight + nextRowHeight) {
                image.position.rowSpan = counter + 1;
                image.totalHeight = image.height;
                image.height = image.totalHeight - totalHeight;
                break;
            }
            totalHeight += nextRowHeight;
            counter++;
        }
    } else image.totalHeight = image.height;
};
var $5b7ccabde48fae90$var$createXmlPart = (body, skipHeader)=>{
    const header = $5b7ccabde48fae90$var$createXmlHeader({
        encoding: "UTF-8",
        standalone: "yes"
    });
    const xmlBody = $5b7ccabde48fae90$var$createXml(body);
    if (skipHeader) return xmlBody;
    return `${header}${xmlBody}`;
};
var $5b7ccabde48fae90$var$getExcelColumnName = (colIdx)=>{
    const startCode = 65;
    const tableWidth = 26;
    const fromCharCode = String.fromCharCode;
    const pos = Math.floor(colIdx / tableWidth);
    const tableIdx = colIdx % tableWidth;
    if (!pos || colIdx === tableWidth) return fromCharCode(startCode + colIdx - 1);
    if (!tableIdx) return $5b7ccabde48fae90$var$getExcelColumnName(pos - 1) + "Z";
    if (pos < tableWidth) return fromCharCode(startCode + pos - 1) + fromCharCode(startCode + tableIdx - 1);
    return $5b7ccabde48fae90$var$getExcelColumnName(pos) + fromCharCode(startCode + tableIdx - 1);
};
var $5b7ccabde48fae90$var$sanitizeTableName = (name)=>{
    return name.replaceAll("\n", "_x000a_");
};
var $5b7ccabde48fae90$var$replaceInvisibleCharacters = (str)=>{
    if (str == null) return null;
    let newString = "";
    for(let i = 0; i < str.length; i++){
        const point = str.charCodeAt(i);
        if (point >= 0 && point <= 31 && point !== 10) {
            const convertedCode = point.toString(16).toUpperCase();
            const paddedCode = convertedCode.padStart(4, "0");
            const newValue = `_x${paddedCode}_`;
            newString += newValue;
        } else newString += str[i];
    }
    return newString;
};
var $5b7ccabde48fae90$var$buildSharedString = (strMap)=>{
    const ret = [];
    for (const key of strMap.keys()){
        const textNode = key.toString();
        const child = {
            name: "t",
            textNode: (0, $jIDNV._escapeString)($5b7ccabde48fae90$var$replaceInvisibleCharacters(textNode))
        };
        const preserveSpaces = textNode.trim().length !== textNode.length;
        if (preserveSpaces) child.properties = {
            rawMap: {
                "xml:space": "preserve"
            }
        };
        ret.push({
            name: "si",
            children: [
                child
            ]
        });
    }
    return ret;
};
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/contentType.ts
var $5b7ccabde48fae90$var$contentTypeFactory = {
    getTemplate (config) {
        const { name: name, ContentType: ContentType, Extension: Extension, PartName: PartName } = config;
        return {
            name: name,
            properties: {
                rawMap: {
                    Extension: Extension,
                    PartName: PartName,
                    ContentType: ContentType
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$contentType_default = $5b7ccabde48fae90$var$contentTypeFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/contentTypes.ts
var $5b7ccabde48fae90$var$_normaliseImageExtension = (ext)=>ext === "jpg" ? "jpeg" : ext;
var $5b7ccabde48fae90$var$contentTypesFactory = {
    getTemplate (sheetLen) {
        const worksheets = new Array(sheetLen).fill(void 0).map((v, i)=>({
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
                PartName: `/xl/worksheets/sheet${i + 1}.xml`
            }));
        const sheetsWithImages = $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGES.size;
        const headerFooterImages = $5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES.size;
        const imageTypesObject = {};
        $5b7ccabde48fae90$var$XLSX_WORKBOOK_IMAGE_IDS.forEach((v)=>{
            imageTypesObject[$5b7ccabde48fae90$var$_normaliseImageExtension(v.type)] = true;
        });
        const imageDocs = new Array(sheetsWithImages).fill(void 0).map((v, i)=>({
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.drawing+xml",
                PartName: `/xl/drawings/drawing${i + 1}.xml`
            }));
        const tableDocs = [];
        $5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES.forEach(({ name: name })=>{
            tableDocs.push({
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml",
                PartName: `/xl/tables/${name}.xml`
            });
        });
        const imageTypes = Object.keys(imageTypesObject).map((ext)=>({
                name: "Default",
                ContentType: `image/${ext}`,
                Extension: ext
            }));
        if (headerFooterImages) imageTypes.push({
            name: "Default",
            Extension: "vml",
            ContentType: "application/vnd.openxmlformats-officedocument.vmlDrawing"
        });
        const children = [
            ...imageTypes,
            {
                name: "Default",
                Extension: "rels",
                ContentType: "application/vnd.openxmlformats-package.relationships+xml"
            },
            {
                name: "Default",
                ContentType: "application/xml",
                Extension: "xml"
            },
            {
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
                PartName: "/xl/workbook.xml"
            },
            ...worksheets,
            {
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.theme+xml",
                PartName: "/xl/theme/theme1.xml"
            },
            {
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
                PartName: "/xl/styles.xml"
            },
            {
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
                PartName: "/xl/sharedStrings.xml"
            },
            ...imageDocs,
            ...tableDocs,
            {
                name: "Override",
                ContentType: "application/vnd.openxmlformats-package.core-properties+xml",
                PartName: "/docProps/core.xml"
            }
        ].map((contentType)=>$5b7ccabde48fae90$var$contentType_default.getTemplate(contentType));
        return {
            name: "Types",
            properties: {
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/content-types"
                }
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$contentTypes_default = $5b7ccabde48fae90$var$contentTypesFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/core.ts
var $5b7ccabde48fae90$var$coreFactory = {
    getTemplate (author) {
        const dt = /* @__PURE__ */ new Date();
        const jsonDate = dt.toJSON();
        return {
            name: "cp:coreProperties",
            properties: {
                prefixedAttributes: [
                    {
                        prefix: "xmlns:",
                        map: {
                            cp: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
                            dc: "http://purl.org/dc/elements/1.1/",
                            dcterms: "http://purl.org/dc/terms/",
                            dcmitype: "http://purl.org/dc/dcmitype/",
                            xsi: "http://www.w3.org/2001/XMLSchema-instance"
                        }
                    }
                ]
            },
            children: [
                {
                    name: "dc:creator",
                    textNode: author
                },
                {
                    name: "dc:title",
                    textNode: "Workbook"
                },
                {
                    name: "dcterms:created",
                    properties: {
                        rawMap: {
                            "xsi:type": "dcterms:W3CDTF"
                        }
                    },
                    textNode: jsonDate
                },
                {
                    name: "dcterms:modified",
                    properties: {
                        rawMap: {
                            "xsi:type": "dcterms:W3CDTF"
                        }
                    },
                    textNode: jsonDate
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$core_default = $5b7ccabde48fae90$var$coreFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/drawing.ts
var $5b7ccabde48fae90$var$getAnchor = (name, imageAnchor)=>({
        name: `xdr:${name}`,
        children: [
            {
                name: "xdr:col",
                textNode: imageAnchor.col.toString()
            },
            {
                name: "xdr:colOff",
                textNode: imageAnchor.offsetX.toString()
            },
            {
                name: "xdr:row",
                textNode: imageAnchor.row.toString()
            },
            {
                name: "xdr:rowOff",
                textNode: imageAnchor.offsetY.toString()
            }
        ]
    });
var $5b7ccabde48fae90$var$getExt = (image)=>{
    const children = [
        {
            name: "a:ext",
            properties: {
                rawMap: {
                    uri: "{FF2B5EF4-FFF2-40B4-BE49-F238E27FC236}"
                }
            },
            children: [
                {
                    name: "a16:creationId",
                    properties: {
                        rawMap: {
                            id: "{822E6D20-D7BC-2841-A643-D49A6EF008A2}",
                            "xmlns:a16": "http://schemas.microsoft.com/office/drawing/2014/main"
                        }
                    }
                }
            ]
        }
    ];
    const recolor = image.recolor && image.recolor.toLowerCase();
    switch(recolor){
        case "grayscale":
        case "sepia":
        case "washout":
            children.push({
                name: "a:ext",
                properties: {
                    rawMap: {
                        uri: "{C183D7F6-B498-43B3-948B-1728B52AA6E4}"
                    }
                },
                children: [
                    {
                        name: "adec:decorative",
                        properties: {
                            rawMap: {
                                val: "0",
                                "xmlns:adec": "http://schemas.microsoft.com/office/drawing/2017/decorative"
                            }
                        }
                    }
                ]
            });
    }
    return {
        name: "a:extLst",
        children: children
    };
};
var $5b7ccabde48fae90$var$getNvPicPr = (image, index)=>({
        name: "xdr:nvPicPr",
        children: [
            {
                name: "xdr:cNvPr",
                properties: {
                    rawMap: {
                        id: index,
                        name: image.id,
                        descr: image.altText != null ? image.altText : void 0
                    }
                },
                children: [
                    $5b7ccabde48fae90$var$getExt(image)
                ]
            },
            {
                name: "xdr:cNvPicPr",
                properties: {
                    rawMap: {
                        preferRelativeResize: "0"
                    }
                },
                children: [
                    {
                        name: "a:picLocks"
                    }
                ]
            }
        ]
    });
var $5b7ccabde48fae90$var$getColorDetails = (color)=>{
    if (!color.saturation && !color.tint) return;
    const ret = [];
    if (color.saturation) ret.push({
        name: "a:satMod",
        properties: {
            rawMap: {
                val: color.saturation * 1e3
            }
        }
    });
    if (color.tint) ret.push({
        name: "a:tint",
        properties: {
            rawMap: {
                val: color.tint * 1e3
            }
        }
    });
    return ret;
};
var $5b7ccabde48fae90$var$getDuoTone = (primaryColor, secondaryColor)=>{
    return {
        name: "a:duotone",
        children: [
            {
                name: "a:prstClr",
                properties: {
                    rawMap: {
                        val: primaryColor.color
                    }
                },
                children: $5b7ccabde48fae90$var$getColorDetails(primaryColor)
            },
            {
                name: "a:srgbClr",
                properties: {
                    rawMap: {
                        val: secondaryColor.color
                    }
                },
                children: $5b7ccabde48fae90$var$getColorDetails(secondaryColor)
            }
        ]
    };
};
var $5b7ccabde48fae90$var$getBlipFill = (image, index)=>{
    let blipChildren;
    if (image.transparency) {
        const transparency = Math.min(Math.max(image.transparency, 0), 100);
        blipChildren = [
            {
                name: "a:alphaModFix",
                properties: {
                    rawMap: {
                        amt: 1e5 - Math.round(transparency * 1e3)
                    }
                }
            }
        ];
    }
    if (image.recolor) {
        if (!blipChildren) blipChildren = [];
        switch(image.recolor.toLocaleLowerCase()){
            case "grayscale":
                blipChildren.push({
                    name: "a:grayscl"
                });
                break;
            case "sepia":
                blipChildren.push($5b7ccabde48fae90$var$getDuoTone({
                    color: "black"
                }, {
                    color: "D9C3A5",
                    tint: 50,
                    saturation: 180
                }));
                break;
            case "washout":
                blipChildren.push({
                    name: "a:lum",
                    properties: {
                        rawMap: {
                            bright: "70000",
                            contrast: "-70000"
                        }
                    }
                });
                break;
            default:
        }
    }
    return {
        name: "xdr:blipFill",
        children: [
            {
                name: "a:blip",
                properties: {
                    rawMap: {
                        cstate: "print",
                        "r:embed": `rId${index}`,
                        "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
                    }
                },
                children: blipChildren
            },
            {
                name: "a:stretch",
                children: [
                    {
                        name: "a:fillRect"
                    }
                ]
            }
        ]
    };
};
var $5b7ccabde48fae90$var$getSpPr = (image, imageBoxSize)=>{
    const xfrm = {
        name: "a:xfrm",
        children: [
            {
                name: "a:off",
                properties: {
                    rawMap: {
                        x: 0,
                        y: 0
                    }
                }
            },
            {
                name: "a:ext",
                properties: {
                    rawMap: {
                        cx: imageBoxSize.width,
                        cy: imageBoxSize.height
                    }
                }
            }
        ]
    };
    if (image.rotation) {
        const rotation = image.rotation;
        xfrm.properties = {
            rawMap: {
                rot: Math.min(Math.max(rotation, 0), 360) * 6e4
            }
        };
    }
    const prstGeom = {
        name: "a:prstGeom",
        properties: {
            rawMap: {
                prst: "rect"
            }
        },
        children: [
            {
                name: "a:avLst"
            }
        ]
    };
    const ret = {
        name: "xdr:spPr",
        children: [
            xfrm,
            prstGeom
        ]
    };
    return ret;
};
var $5b7ccabde48fae90$var$getImageBoxSize = (image)=>{
    image.fitCell = !!image.fitCell || !image.width || !image.height;
    const { position: position = {}, fitCell: fitCell, width: width = 0, height: height = 0, totalHeight: totalHeight, totalWidth: totalWidth } = image;
    const { offsetX: offsetX = 0, offsetY: offsetY = 0, row: row = 1, rowSpan: rowSpan = 1, column: column = 1, colSpan: colSpan = 1 } = position;
    return {
        from: {
            row: row - 1,
            col: column - 1,
            offsetX: $5b7ccabde48fae90$var$pixelsToEMU(offsetX),
            offsetY: $5b7ccabde48fae90$var$pixelsToEMU(offsetY)
        },
        to: {
            row: row - 1 + (fitCell ? 1 : rowSpan - 1),
            col: column - 1 + (fitCell ? 1 : colSpan - 1),
            offsetX: $5b7ccabde48fae90$var$pixelsToEMU(width + offsetX),
            offsetY: $5b7ccabde48fae90$var$pixelsToEMU(height + offsetY)
        },
        height: $5b7ccabde48fae90$var$pixelsToEMU(totalHeight || height),
        width: $5b7ccabde48fae90$var$pixelsToEMU(totalWidth || width)
    };
};
var $5b7ccabde48fae90$var$getPicture = (image, currentIndex, worksheetImageIndex, imageBoxSize)=>{
    return {
        name: "xdr:pic",
        children: [
            $5b7ccabde48fae90$var$getNvPicPr(image, currentIndex + 1),
            $5b7ccabde48fae90$var$getBlipFill(image, worksheetImageIndex + 1),
            $5b7ccabde48fae90$var$getSpPr(image, imageBoxSize)
        ]
    };
};
var $5b7ccabde48fae90$var$drawingFactory = {
    getTemplate (config) {
        const { sheetIndex: sheetIndex } = config;
        const sheetImages = $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGES.get(sheetIndex);
        const sheetImageIds = $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGE_IDS.get(sheetIndex);
        const children = sheetImages.map((image, idx)=>{
            const boxSize = $5b7ccabde48fae90$var$getImageBoxSize(image);
            return {
                name: "xdr:twoCellAnchor",
                properties: {
                    rawMap: {
                        editAs: "absolute"
                    }
                },
                children: [
                    $5b7ccabde48fae90$var$getAnchor("from", boxSize.from),
                    $5b7ccabde48fae90$var$getAnchor("to", boxSize.to),
                    $5b7ccabde48fae90$var$getPicture(image, idx, sheetImageIds.get(image.id).index, boxSize),
                    {
                        name: "xdr:clientData"
                    }
                ]
            };
        });
        return {
            name: "xdr:wsDr",
            properties: {
                rawMap: {
                    "xmlns:a": "http://schemas.openxmlformats.org/drawingml/2006/main",
                    "xmlns:xdr": "http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing"
                }
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$drawing_default = $5b7ccabde48fae90$var$drawingFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/relationship.ts
var $5b7ccabde48fae90$var$relationshipFactory = {
    getTemplate (config) {
        const { Id: Id, Type: Type, Target: Target } = config;
        return {
            name: "Relationship",
            properties: {
                rawMap: {
                    Id: Id,
                    Type: Type,
                    Target: Target
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$relationship_default = $5b7ccabde48fae90$var$relationshipFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/relationships.ts
var $5b7ccabde48fae90$var$relationshipsFactory = {
    getTemplate (c) {
        const children = c.map((relationship)=>$5b7ccabde48fae90$var$relationship_default.getTemplate(relationship));
        return {
            name: "Relationships",
            properties: {
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
                }
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$relationships_default = $5b7ccabde48fae90$var$relationshipsFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/sharedStrings.ts
var $5b7ccabde48fae90$var$sharedStrings = {
    getTemplate (strings) {
        return {
            name: "sst",
            properties: {
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    count: strings.size,
                    uniqueCount: strings.size
                }
            },
            children: $5b7ccabde48fae90$var$buildSharedString(strings)
        };
    }
};
var $5b7ccabde48fae90$var$sharedStrings_default = $5b7ccabde48fae90$var$sharedStrings;
// packages/ag-grid-enterprise/src/excelExport/assets/excelLegacyConvert.ts
var $5b7ccabde48fae90$var$getWeightName = (value)=>{
    switch(value){
        case 1:
            return "thin";
        case 2:
            return "medium";
        case 3:
            return "thick";
        default:
            return "hair";
    }
};
var $5b7ccabde48fae90$var$mappedBorderNames = {
    None: "None",
    Dot: "Dotted",
    Dash: "Dashed",
    Double: "Double",
    DashDot: "DashDot",
    DashDotDot: "DashDotDot",
    SlantDashDot: "SlantDashDot",
    Continuous: "Continuous"
};
var $5b7ccabde48fae90$var$mediumBorders = [
    "Dashed",
    "DashDot",
    "DashDotDot"
];
var $5b7ccabde48fae90$var$colorMap = {
    None: "none",
    Solid: "solid",
    Gray50: "mediumGray",
    Gray75: "darkGray",
    Gray25: "lightGray",
    HorzStripe: "darkHorizontal",
    VertStripe: "darkVertical",
    ReverseDiagStripe: "darkDown",
    DiagStripe: "darkUp",
    DiagCross: "darkGrid",
    ThickDiagCross: "darkTrellis",
    ThinHorzStripe: "lightHorizontal",
    ThinVertStripe: "lightVertical",
    ThinReverseDiagStripe: "lightDown",
    ThinDiagStripe: "lightUp",
    ThinHorzCross: "lightGrid",
    ThinDiagCross: "lightTrellis",
    Gray125: "gray125",
    Gray0625: "gray0625"
};
var $5b7ccabde48fae90$var$horizontalAlignmentMap = {
    Automatic: "general",
    Left: "left",
    Center: "center",
    Right: "right",
    Fill: "fill",
    Justify: "justify",
    CenterAcrossSelection: "centerContinuous",
    Distributed: "distributed",
    JustifyDistributed: "justify"
};
var $5b7ccabde48fae90$var$verticalAlignmentMap = {
    Automatic: void 0,
    Top: "top",
    Bottom: "bottom",
    Center: "center",
    Justify: "justify",
    Distributed: "distributed",
    JustifyDistributed: "justify"
};
var $5b7ccabde48fae90$var$convertLegacyPattern = (name)=>{
    if (!name) return "none";
    return $5b7ccabde48fae90$var$colorMap[name] || name;
};
var $5b7ccabde48fae90$var$convertLegacyColor = (color)=>{
    if (color == void 0) return color;
    if (color.charAt(0) === "#") color = color.substring(1);
    return color.length === 6 ? "FF" + color : color;
};
var $5b7ccabde48fae90$var$convertLegacyBorder = (type, weight)=>{
    if (!type) return "thin";
    const namedWeight = $5b7ccabde48fae90$var$getWeightName(weight);
    if (type === "Continuous") return namedWeight;
    const mappedName = $5b7ccabde48fae90$var$mappedBorderNames[type];
    if (namedWeight === "medium" && $5b7ccabde48fae90$var$mediumBorders.some((type2)=>type2 === mappedName)) return `medium${mappedName}`;
    return `${mappedName.charAt(0).toLowerCase()}${mappedName.substring(1)}`;
};
var $5b7ccabde48fae90$var$convertLegacyHorizontalAlignment = (alignment)=>{
    return $5b7ccabde48fae90$var$horizontalAlignmentMap[alignment] || "general";
};
var $5b7ccabde48fae90$var$convertLegacyVerticalAlignment = (alignment)=>{
    return $5b7ccabde48fae90$var$verticalAlignmentMap[alignment] || void 0;
};
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/border.ts
var $5b7ccabde48fae90$var$getBorderColor = (color)=>{
    return {
        name: "color",
        properties: {
            rawMap: {
                rgb: $5b7ccabde48fae90$var$convertLegacyColor(color || "#000000")
            }
        }
    };
};
var $5b7ccabde48fae90$var$borderFactory = {
    getTemplate (border) {
        const { left: left, right: right, top: top, bottom: bottom, diagonal: diagonal } = border;
        const leftChildren = left ? [
            $5b7ccabde48fae90$var$getBorderColor(left.color)
        ] : void 0;
        const rightChildren = right ? [
            $5b7ccabde48fae90$var$getBorderColor(right.color)
        ] : void 0;
        const topChildren = top ? [
            $5b7ccabde48fae90$var$getBorderColor(top.color)
        ] : void 0;
        const bottomChildren = bottom ? [
            $5b7ccabde48fae90$var$getBorderColor(bottom.color)
        ] : void 0;
        const diagonalChildren = diagonal ? [
            $5b7ccabde48fae90$var$getBorderColor(diagonal.color)
        ] : void 0;
        return {
            name: "border",
            children: [
                {
                    name: "left",
                    properties: {
                        rawMap: {
                            style: left && left.style
                        }
                    },
                    children: leftChildren
                },
                {
                    name: "right",
                    properties: {
                        rawMap: {
                            style: right && right.style
                        }
                    },
                    children: rightChildren
                },
                {
                    name: "top",
                    properties: {
                        rawMap: {
                            style: top && top.style
                        }
                    },
                    children: topChildren
                },
                {
                    name: "bottom",
                    properties: {
                        rawMap: {
                            style: bottom && bottom.style
                        }
                    },
                    children: bottomChildren
                },
                {
                    name: "diagonal",
                    properties: {
                        rawMap: {
                            style: diagonal && diagonal.style
                        }
                    },
                    children: diagonalChildren
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$border_default = $5b7ccabde48fae90$var$borderFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/borders.ts
var $5b7ccabde48fae90$var$bordersFactory = {
    getTemplate (borders) {
        return {
            name: "borders",
            properties: {
                rawMap: {
                    count: borders.length
                }
            },
            children: borders.map((border)=>$5b7ccabde48fae90$var$border_default.getTemplate(border))
        };
    }
};
var $5b7ccabde48fae90$var$borders_default = $5b7ccabde48fae90$var$bordersFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/alignment.ts
var $5b7ccabde48fae90$var$getReadingOrderId = (readingOrder)=>{
    const order = [
        "Context",
        "LeftToRight",
        "RightToLeft"
    ];
    const pos = order.indexOf(readingOrder);
    return Math.max(pos, 0);
};
var $5b7ccabde48fae90$var$alignmentFactory = {
    getTemplate (alignment) {
        const { horizontal: horizontal, indent: indent, readingOrder: readingOrder, rotate: rotate, shrinkToFit: shrinkToFit, vertical: vertical, wrapText: wrapText } = alignment;
        return {
            name: "alignment",
            properties: {
                rawMap: {
                    horizontal: horizontal && $5b7ccabde48fae90$var$convertLegacyHorizontalAlignment(horizontal),
                    indent: indent,
                    readingOrder: readingOrder && $5b7ccabde48fae90$var$getReadingOrderId(readingOrder),
                    textRotation: rotate,
                    shrinkToFit: shrinkToFit,
                    vertical: vertical && $5b7ccabde48fae90$var$convertLegacyVerticalAlignment(vertical),
                    wrapText: wrapText
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$alignment_default = $5b7ccabde48fae90$var$alignmentFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/protection.ts
var $5b7ccabde48fae90$var$protectionFactory = {
    getTemplate (protection) {
        const locked = protection.protected === false ? 0 : 1;
        const hidden = protection.hideFormula === true ? 1 : 0;
        return {
            name: "protection",
            properties: {
                rawMap: {
                    hidden: hidden,
                    locked: locked
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$protection_default = $5b7ccabde48fae90$var$protectionFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/xf.ts
var $5b7ccabde48fae90$var$xfFactory = {
    getTemplate (xf) {
        const { alignment: alignment, borderId: borderId, fillId: fillId, fontId: fontId, numFmtId: numFmtId, protection: protection, quotePrefix: quotePrefix, xfId: xfId } = xf;
        const children = [];
        if (alignment) children.push($5b7ccabde48fae90$var$alignment_default.getTemplate(alignment));
        if (protection) children.push($5b7ccabde48fae90$var$protection_default.getTemplate(protection));
        return {
            name: "xf",
            properties: {
                rawMap: {
                    applyAlignment: alignment ? 1 : void 0,
                    applyProtection: protection ? 1 : void 0,
                    applyBorder: borderId ? 1 : void 0,
                    applyFill: fillId ? 1 : void 0,
                    borderId: borderId,
                    fillId: fillId,
                    applyFont: fontId ? 1 : void 0,
                    fontId: fontId,
                    applyNumberFormat: numFmtId ? 1 : void 0,
                    numFmtId: numFmtId,
                    quotePrefix: quotePrefix ? 1 : void 0,
                    xfId: xfId
                }
            },
            children: children.length ? children : void 0
        };
    }
};
var $5b7ccabde48fae90$var$xf_default = $5b7ccabde48fae90$var$xfFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/cellStyleXfs.ts
var $5b7ccabde48fae90$var$cellStylesXfsFactory = {
    getTemplate (xfs) {
        return {
            name: "cellStyleXfs",
            properties: {
                rawMap: {
                    count: xfs.length
                }
            },
            children: xfs.map((xf)=>$5b7ccabde48fae90$var$xf_default.getTemplate(xf))
        };
    }
};
var $5b7ccabde48fae90$var$cellStyleXfs_default = $5b7ccabde48fae90$var$cellStylesXfsFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/cellStyle.ts
var $5b7ccabde48fae90$var$borderFactory2 = {
    getTemplate (cellStyle) {
        const { builtinId: builtinId, name: name, xfId: xfId } = cellStyle;
        return {
            name: "cellStyle",
            properties: {
                rawMap: {
                    builtinId: builtinId,
                    name: name,
                    xfId: xfId
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$cellStyle_default = $5b7ccabde48fae90$var$borderFactory2;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/cellStyles.ts
var $5b7ccabde48fae90$var$cellStylesFactory = {
    getTemplate (cellStyles) {
        return {
            name: "cellStyles",
            properties: {
                rawMap: {
                    count: cellStyles.length
                }
            },
            children: cellStyles.map((cellStyle)=>$5b7ccabde48fae90$var$cellStyle_default.getTemplate(cellStyle))
        };
    }
};
var $5b7ccabde48fae90$var$cellStyles_default = $5b7ccabde48fae90$var$cellStylesFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/cellXfs.ts
var $5b7ccabde48fae90$var$cellXfsFactory = {
    getTemplate (xfs) {
        return {
            name: "cellXfs",
            properties: {
                rawMap: {
                    count: xfs.length
                }
            },
            children: xfs.map((xf)=>$5b7ccabde48fae90$var$xf_default.getTemplate(xf))
        };
    }
};
var $5b7ccabde48fae90$var$cellXfs_default = $5b7ccabde48fae90$var$cellXfsFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/fill.ts
var $5b7ccabde48fae90$var$fillFactory = {
    getTemplate (fill) {
        const { patternType: patternType, fgTheme: fgTheme, fgTint: fgTint, fgRgb: fgRgb, bgRgb: bgRgb, bgIndexed: bgIndexed } = fill;
        const pf = {
            name: "patternFill",
            properties: {
                rawMap: {
                    patternType: patternType
                }
            }
        };
        if (fgTheme || fgTint || fgRgb) pf.children = [
            {
                name: "fgColor",
                properties: {
                    rawMap: {
                        theme: fgTheme,
                        tint: fgTint,
                        rgb: fgRgb
                    }
                }
            }
        ];
        if (bgIndexed || bgRgb) {
            if (!pf.children) pf.children = [];
            pf.children.push({
                name: "bgColor",
                properties: {
                    rawMap: {
                        indexed: bgIndexed,
                        rgb: bgRgb
                    }
                }
            });
        }
        return {
            name: "fill",
            children: [
                pf
            ]
        };
    }
};
var $5b7ccabde48fae90$var$fill_default = $5b7ccabde48fae90$var$fillFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/fills.ts
var $5b7ccabde48fae90$var$fillsFactory = {
    getTemplate (fills) {
        return {
            name: "fills",
            properties: {
                rawMap: {
                    count: fills.length
                }
            },
            children: fills.map((fill)=>$5b7ccabde48fae90$var$fill_default.getTemplate(fill))
        };
    }
};
var $5b7ccabde48fae90$var$fills_default = $5b7ccabde48fae90$var$fillsFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/font.ts
var $5b7ccabde48fae90$var$fontFactory = {
    getTemplate (font) {
        const { size: size, colorTheme: colorTheme, color: color = "FF000000", fontName: fontName = "Calibri", family: family, scheme: scheme, italic: italic, bold: bold, strikeThrough: strikeThrough, outline: outline, shadow: shadow2, underline: underline, verticalAlign: verticalAlign } = font;
        const children = [
            {
                name: "sz",
                properties: {
                    rawMap: {
                        val: size
                    }
                }
            },
            {
                name: "color",
                properties: {
                    rawMap: {
                        theme: colorTheme,
                        rgb: color
                    }
                }
            },
            {
                name: "name",
                properties: {
                    rawMap: {
                        val: fontName
                    }
                }
            }
        ];
        if (family) children.push({
            name: "family",
            properties: {
                rawMap: {
                    val: family
                }
            }
        });
        if (scheme) children.push({
            name: "scheme",
            properties: {
                rawMap: {
                    val: scheme
                }
            }
        });
        if (italic) children.push({
            name: "i"
        });
        if (bold) children.push({
            name: "b"
        });
        if (strikeThrough) children.push({
            name: "strike"
        });
        if (outline) children.push({
            name: "outline"
        });
        if (shadow2) children.push({
            name: "shadow"
        });
        if (underline) children.push({
            name: "u",
            properties: {
                rawMap: {
                    val: underline
                }
            }
        });
        if (verticalAlign) children.push({
            name: "vertAlign",
            properties: {
                rawMap: {
                    val: verticalAlign
                }
            }
        });
        return {
            name: "font",
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$font_default = $5b7ccabde48fae90$var$fontFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/fonts.ts
var $5b7ccabde48fae90$var$fontsFactory = {
    getTemplate (fonts) {
        return {
            name: "fonts",
            properties: {
                rawMap: {
                    count: fonts.length
                }
            },
            children: fonts.map((font)=>$5b7ccabde48fae90$var$font_default.getTemplate(font))
        };
    }
};
var $5b7ccabde48fae90$var$fonts_default = $5b7ccabde48fae90$var$fontsFactory;
function $5b7ccabde48fae90$var$prepareString(str) {
    const split = str.split(/(\[[^\]]*\])/);
    for(let i = 0; i < split.length; i++){
        let currentString = split[i];
        if (!currentString.length) continue;
        if (!currentString.startsWith("[")) currentString = currentString.replace(/\$/g, '"$"');
        split[i] = (0, $jIDNV._escapeString)(currentString);
    }
    return split.join("");
}
var $5b7ccabde48fae90$var$numberFormatFactory = {
    getTemplate (numberFormat) {
        let { formatCode: formatCode, numFmtId: numFmtId } = numberFormat;
        if (formatCode.length) formatCode = $5b7ccabde48fae90$var$prepareString(formatCode);
        return {
            name: "numFmt",
            properties: {
                rawMap: {
                    formatCode: formatCode,
                    numFmtId: numFmtId
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$numberFormat_default = $5b7ccabde48fae90$var$numberFormatFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/numberFormats.ts
var $5b7ccabde48fae90$var$numberFormatsFactory = {
    getTemplate (numberFormats) {
        return {
            name: "numFmts",
            properties: {
                rawMap: {
                    count: numberFormats.length
                }
            },
            children: numberFormats.map((numberFormat)=>$5b7ccabde48fae90$var$numberFormat_default.getTemplate(numberFormat))
        };
    }
};
var $5b7ccabde48fae90$var$numberFormats_default = $5b7ccabde48fae90$var$numberFormatsFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/stylesheet.ts
var $5b7ccabde48fae90$var$stylesMap;
var $5b7ccabde48fae90$var$registeredNumberFmts;
var $5b7ccabde48fae90$var$registeredFonts;
var $5b7ccabde48fae90$var$registeredFills;
var $5b7ccabde48fae90$var$registeredBorders;
var $5b7ccabde48fae90$var$registeredCellStyleXfs;
var $5b7ccabde48fae90$var$registeredCellXfs;
var $5b7ccabde48fae90$var$registeredCellStyles;
var $5b7ccabde48fae90$var$currentSheet;
var $5b7ccabde48fae90$var$getStyleName = (name, currentSheet2)=>{
    if (name.indexOf("mixedStyle") !== -1 && currentSheet2 > 1) name += `_${currentSheet2}`;
    return name;
};
var $5b7ccabde48fae90$var$resetStylesheetValues = ()=>{
    $5b7ccabde48fae90$var$stylesMap = {
        base: 0
    };
    $5b7ccabde48fae90$var$registeredNumberFmts = [];
    $5b7ccabde48fae90$var$registeredFonts = [
        {
            fontName: "Calibri",
            colorTheme: "1",
            family: "2",
            scheme: "minor"
        }
    ];
    $5b7ccabde48fae90$var$registeredFills = [
        {
            patternType: "none"
        },
        {
            patternType: "gray125"
        }
    ];
    $5b7ccabde48fae90$var$registeredBorders = [
        {
            left: void 0,
            right: void 0,
            top: void 0,
            bottom: void 0,
            diagonal: void 0
        }
    ];
    $5b7ccabde48fae90$var$registeredCellStyleXfs = [
        {
            borderId: 0,
            fillId: 0,
            fontId: 0,
            numFmtId: 0
        }
    ];
    $5b7ccabde48fae90$var$registeredCellXfs = [
        {
            borderId: 0,
            fillId: 0,
            fontId: 0,
            numFmtId: 0,
            xfId: 0
        }
    ];
    $5b7ccabde48fae90$var$registeredCellStyles = [
        {
            builtinId: 0,
            name: "Normal",
            xfId: 0
        }
    ];
};
var $5b7ccabde48fae90$var$registerFill = (fill)=>{
    const convertedPattern = $5b7ccabde48fae90$var$convertLegacyPattern(fill.pattern);
    const convertedFillColor = $5b7ccabde48fae90$var$convertLegacyColor(fill.color);
    const convertedPatternColor = $5b7ccabde48fae90$var$convertLegacyColor(fill.patternColor);
    let pos = $5b7ccabde48fae90$var$registeredFills.findIndex((currentFill)=>{
        const { patternType: patternType, fgRgb: fgRgb, bgRgb: bgRgb } = currentFill;
        if (patternType != convertedPattern || fgRgb != convertedFillColor || bgRgb != convertedPatternColor) return false;
        return true;
    });
    if (pos === -1) {
        pos = $5b7ccabde48fae90$var$registeredFills.length;
        $5b7ccabde48fae90$var$registeredFills.push({
            patternType: convertedPattern,
            fgRgb: convertedFillColor,
            bgRgb: convertedPatternColor
        });
    }
    return pos;
};
var $5b7ccabde48fae90$var$registerNumberFmt = (format)=>{
    if ($5b7ccabde48fae90$var$numberFormatMap[format]) return $5b7ccabde48fae90$var$numberFormatMap[format];
    let pos = $5b7ccabde48fae90$var$registeredNumberFmts.findIndex((currentFormat)=>currentFormat.formatCode === format);
    if (pos === -1) {
        pos = $5b7ccabde48fae90$var$registeredNumberFmts.length + 164;
        $5b7ccabde48fae90$var$registeredNumberFmts.push({
            formatCode: format,
            numFmtId: pos
        });
    } else pos = $5b7ccabde48fae90$var$registeredNumberFmts[pos].numFmtId;
    return pos;
};
var $5b7ccabde48fae90$var$registerBorders = (borders)=>{
    const { borderBottom: borderBottom, borderTop: borderTop, borderLeft: borderLeft, borderRight: borderRight } = borders;
    let bottomStyle;
    let topStyle;
    let leftStyle;
    let rightStyle;
    let bottomColor;
    let topColor;
    let leftColor;
    let rightColor;
    if (borderLeft) {
        leftStyle = $5b7ccabde48fae90$var$convertLegacyBorder(borderLeft.lineStyle, borderLeft.weight);
        leftColor = $5b7ccabde48fae90$var$convertLegacyColor(borderLeft.color);
    }
    if (borderRight) {
        rightStyle = $5b7ccabde48fae90$var$convertLegacyBorder(borderRight.lineStyle, borderRight.weight);
        rightColor = $5b7ccabde48fae90$var$convertLegacyColor(borderRight.color);
    }
    if (borderBottom) {
        bottomStyle = $5b7ccabde48fae90$var$convertLegacyBorder(borderBottom.lineStyle, borderBottom.weight);
        bottomColor = $5b7ccabde48fae90$var$convertLegacyColor(borderBottom.color);
    }
    if (borderTop) {
        topStyle = $5b7ccabde48fae90$var$convertLegacyBorder(borderTop.lineStyle, borderTop.weight);
        topColor = $5b7ccabde48fae90$var$convertLegacyColor(borderTop.color);
    }
    let pos = $5b7ccabde48fae90$var$registeredBorders.findIndex((currentBorder)=>{
        const { left: left, right: right, top: top, bottom: bottom } = currentBorder;
        if (!left && (leftStyle || leftColor)) return false;
        if (!right && (rightStyle || rightColor)) return false;
        if (!top && (topStyle || topColor)) return false;
        if (!bottom && (bottomStyle || bottomColor)) return false;
        const { style: clS, color: clC } = left || {};
        const { style: crS, color: crC } = right || {};
        const { style: ctS, color: ctC } = top || {};
        const { style: cbS, color: cbC } = bottom || {};
        if (clS != leftStyle || clC != leftColor) return false;
        if (crS != rightStyle || crC != rightColor) return false;
        if (ctS != topStyle || ctC != topColor) return false;
        if (cbS != bottomStyle || cbC != bottomColor) return false;
        return true;
    });
    if (pos === -1) {
        pos = $5b7ccabde48fae90$var$registeredBorders.length;
        $5b7ccabde48fae90$var$registeredBorders.push({
            left: {
                style: leftStyle,
                color: leftColor
            },
            right: {
                style: rightStyle,
                color: rightColor
            },
            top: {
                style: topStyle,
                color: topColor
            },
            bottom: {
                style: bottomStyle,
                color: bottomColor
            },
            diagonal: {
                style: void 0,
                color: void 0
            }
        });
    }
    return pos;
};
var $5b7ccabde48fae90$var$registerFont = (font)=>{
    const { fontName: name = "Calibri", color: color, size: size, bold: bold, italic: italic, outline: outline, shadow: shadow2, strikeThrough: strikeThrough, underline: underline, family: family, verticalAlign: verticalAlign } = font;
    const convertedColor = $5b7ccabde48fae90$var$convertLegacyColor(color);
    const familyId = $5b7ccabde48fae90$var$getFontFamilyId(family);
    const convertedUnderline = underline ? underline.toLocaleLowerCase() : void 0;
    const convertedVerticalAlign = verticalAlign ? verticalAlign.toLocaleLowerCase() : void 0;
    let pos = $5b7ccabde48fae90$var$registeredFonts.findIndex((currentFont)=>{
        if (currentFont.fontName != name || currentFont.color != convertedColor || currentFont.size != size || currentFont.bold != bold || currentFont.italic != italic || currentFont.outline != outline || currentFont.shadow != shadow2 || currentFont.strikeThrough != strikeThrough || currentFont.underline != convertedUnderline || currentFont.verticalAlign != convertedVerticalAlign || currentFont.family != familyId) return false;
        return true;
    });
    if (pos === -1) {
        pos = $5b7ccabde48fae90$var$registeredFonts.length;
        $5b7ccabde48fae90$var$registeredFonts.push({
            fontName: name,
            color: convertedColor,
            size: size,
            bold: bold,
            italic: italic,
            outline: outline,
            shadow: shadow2,
            strikeThrough: strikeThrough,
            underline: convertedUnderline,
            verticalAlign: convertedVerticalAlign,
            family: familyId != null ? familyId.toString() : void 0
        });
    }
    return pos;
};
var $5b7ccabde48fae90$var$registerStyle = (config)=>{
    const { alignment: alignment, borders: borders, font: font, interior: interior, numberFormat: numberFormat, protection: protection, quotePrefix: quotePrefix } = config;
    let { id: id } = config;
    let currentFill = 0;
    let currentBorder = 0;
    let currentFont = 0;
    let currentNumberFmt = 0;
    if (!id) return;
    id = $5b7ccabde48fae90$var$getStyleName(id, $5b7ccabde48fae90$var$currentSheet);
    if ($5b7ccabde48fae90$var$stylesMap[id] != void 0) return;
    if (interior) currentFill = $5b7ccabde48fae90$var$registerFill(interior);
    if (borders) currentBorder = $5b7ccabde48fae90$var$registerBorders(borders);
    if (font) currentFont = $5b7ccabde48fae90$var$registerFont(font);
    if (numberFormat) currentNumberFmt = $5b7ccabde48fae90$var$registerNumberFmt(numberFormat.format);
    $5b7ccabde48fae90$var$stylesMap[id] = $5b7ccabde48fae90$var$registeredCellXfs.length;
    $5b7ccabde48fae90$var$registeredCellXfs.push({
        alignment: alignment,
        borderId: currentBorder || 0,
        fillId: currentFill || 0,
        fontId: currentFont || 0,
        numFmtId: currentNumberFmt || 0,
        protection: protection,
        quotePrefix: quotePrefix,
        xfId: 0
    });
};
var $5b7ccabde48fae90$var$stylesheetFactory = {
    getTemplate (defaultFontSize) {
        const numberFormats = $5b7ccabde48fae90$var$numberFormats_default.getTemplate($5b7ccabde48fae90$var$registeredNumberFmts);
        const fonts = $5b7ccabde48fae90$var$fonts_default.getTemplate($5b7ccabde48fae90$var$registeredFonts.map((font)=>({
                ...font,
                size: font.size != null ? font.size : defaultFontSize
            })));
        const fills = $5b7ccabde48fae90$var$fills_default.getTemplate($5b7ccabde48fae90$var$registeredFills);
        const borders = $5b7ccabde48fae90$var$borders_default.getTemplate($5b7ccabde48fae90$var$registeredBorders);
        const cellStylesXfs = $5b7ccabde48fae90$var$cellStyleXfs_default.getTemplate($5b7ccabde48fae90$var$registeredCellStyleXfs);
        const cellXfs = $5b7ccabde48fae90$var$cellXfs_default.getTemplate($5b7ccabde48fae90$var$registeredCellXfs);
        const cellStyles = $5b7ccabde48fae90$var$cellStyles_default.getTemplate($5b7ccabde48fae90$var$registeredCellStyles);
        $5b7ccabde48fae90$var$resetStylesheetValues();
        return {
            name: "styleSheet",
            properties: {
                rawMap: {
                    "mc:Ignorable": "x14ac x16r2 xr",
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "xmlns:x14ac": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac",
                    "xmlns:x16r2": "http://schemas.microsoft.com/office/spreadsheetml/2015/02/main",
                    "xmlns:xr": "http://schemas.microsoft.com/office/spreadsheetml/2014/revision"
                }
            },
            children: [
                numberFormats,
                fonts,
                fills,
                borders,
                cellStylesXfs,
                cellXfs,
                cellStyles,
                {
                    name: "tableStyles",
                    properties: {
                        rawMap: {
                            count: 0,
                            defaultPivotStyle: "PivotStyleLight16",
                            defaultTableStyle: "TableStyleMedium2"
                        }
                    }
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$getStyleId = (name, currentSheet2)=>{
    return $5b7ccabde48fae90$var$stylesMap[$5b7ccabde48fae90$var$getStyleName(name, currentSheet2)] || 0;
};
var $5b7ccabde48fae90$var$registerStyles = (styles, _currentSheet)=>{
    $5b7ccabde48fae90$var$currentSheet = _currentSheet;
    if ($5b7ccabde48fae90$var$currentSheet === 1) $5b7ccabde48fae90$var$resetStylesheetValues();
    styles.forEach($5b7ccabde48fae90$var$registerStyle);
};
var $5b7ccabde48fae90$var$stylesheet_default = $5b7ccabde48fae90$var$stylesheetFactory;
var $5b7ccabde48fae90$var$tableFactory = {
    getTemplate (dataTable, idx) {
        const { name: name, columns: columns, rowRange: rowRange, displayName: displayName, showRowStripes: showRowStripes, showColumnStripes: showColumnStripes, showFilterButtons: showFilterButtons, highlightFirstColumn: highlightFirstColumn, highlightLastColumn: highlightLastColumn } = dataTable || {};
        const noRows = !rowRange || rowRange[0] - rowRange[1] === 0;
        if (!dataTable || !name || !Array.isArray(columns) || !columns.length || noRows) return {
            name: "table"
        };
        const filterColumns = columns.map((col, idx2)=>({
                name: "filterColumn",
                properties: {
                    rawMap: {
                        colId: idx2.toString(),
                        // For filters, this should start with 0
                        hiddenButton: showFilterButtons[idx2] ? 0 : 1
                    }
                }
            }));
        const firstCell = `A${rowRange[0]}`;
        const lastCell = `${$5b7ccabde48fae90$var$getExcelColumnName(columns.length)}${rowRange[1]}`;
        const ref = `${firstCell}:${lastCell}`;
        const id = `${idx + 1}`;
        const displayNameToUse = idx ? `${displayName}_${id}` : displayName;
        return {
            name: "table",
            properties: {
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "xr xr3",
                    "xmlns:xr": "http://schemas.microsoft.com/office/spreadsheetml/2014/revision",
                    "xmlns:xr3": "http://schemas.microsoft.com/office/spreadsheetml/2016/revision3",
                    name: name,
                    displayName: displayNameToUse,
                    ref: ref,
                    totalsRowShown: 0,
                    id: id
                }
            },
            children: [
                {
                    name: "autoFilter",
                    properties: {
                        rawMap: {
                            ref: ref
                        }
                    },
                    children: filterColumns
                },
                {
                    name: "tableColumns",
                    properties: {
                        rawMap: {
                            count: columns.length
                        }
                    },
                    children: columns.map((col, idx2)=>({
                            name: "tableColumn",
                            properties: {
                                rawMap: {
                                    id: (idx2 + 1).toString(),
                                    name: (0, $jIDNV._escapeString)($5b7ccabde48fae90$var$sanitizeTableName(col)),
                                    dataCellStyle: "Normal"
                                }
                            }
                        }))
                },
                {
                    name: "tableStyleInfo",
                    properties: {
                        rawMap: {
                            name: "TableStyleLight1",
                            showFirstColumn: highlightFirstColumn ? 1 : 0,
                            showLastColumn: highlightLastColumn ? 1 : 0,
                            showRowStripes: showRowStripes ? 1 : 0,
                            showColumnStripes: showColumnStripes ? 1 : 0
                        }
                    }
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$table_default = $5b7ccabde48fae90$var$tableFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/themes/office/colorScheme.ts
var $5b7ccabde48fae90$var$getColorChildren = (props)=>{
    const [type, innerType, val, lastClr] = props;
    return {
        name: `a:${type}`,
        children: [
            {
                name: `a:${innerType}`,
                properties: {
                    rawMap: {
                        val: val,
                        lastClr: lastClr
                    }
                }
            }
        ]
    };
};
var $5b7ccabde48fae90$var$colorScheme = {
    getTemplate () {
        return {
            name: "a:clrScheme",
            properties: {
                rawMap: {
                    name: "Office"
                }
            },
            children: [
                $5b7ccabde48fae90$var$getColorChildren([
                    "dk1",
                    "sysClr",
                    "windowText",
                    "000000"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "lt1",
                    "sysClr",
                    "window",
                    "FFFFFF"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "dk2",
                    "srgbClr",
                    "44546A"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "lt2",
                    "srgbClr",
                    "E7E6E6"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent1",
                    "srgbClr",
                    "4472C4"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent2",
                    "srgbClr",
                    "ED7D31"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent3",
                    "srgbClr",
                    "A5A5A5"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent4",
                    "srgbClr",
                    "FFC000"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent5",
                    "srgbClr",
                    "5B9BD5"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent6",
                    "srgbClr",
                    "70AD47"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "hlink",
                    "srgbClr",
                    "0563C1"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "folHlink",
                    "srgbClr",
                    "954F72"
                ])
            ]
        };
    }
};
var $5b7ccabde48fae90$var$colorScheme_default = $5b7ccabde48fae90$var$colorScheme;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/themes/office/fontScheme.ts
var $5b7ccabde48fae90$var$getFont = (props)=>{
    const [type, typeface, script, panose] = props;
    return {
        name: `a:${type}`,
        properties: {
            rawMap: {
                script: script,
                typeface: typeface,
                panose: panose
            }
        }
    };
};
var $5b7ccabde48fae90$var$fontScheme = {
    getTemplate () {
        return {
            name: "a:fontScheme",
            properties: {
                rawMap: {
                    name: "Office"
                }
            },
            children: [
                {
                    name: "a:majorFont",
                    children: [
                        $5b7ccabde48fae90$var$getFont([
                            "latin",
                            "Calibri Light",
                            void 0,
                            "020F0302020204030204"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "ea",
                            ""
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "cs",
                            ""
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u6E38\u30B4\u30B7\u30C3\u30AF Light",
                            "Jpan"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\uB9D1\uC740 \uACE0\uB515",
                            "Hang"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u7B49\u7EBF Light",
                            "Hans"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u65B0\u7D30\u660E\u9AD4",
                            "Hant"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Times New Roman",
                            "Arab"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Times New Roman",
                            "Hebr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Tahoma",
                            "Thai"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nyala",
                            "Ethi"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Vrinda",
                            "Beng"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Shruti",
                            "Gujr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "MoolBoran",
                            "Khmr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Tunga",
                            "Knda"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Raavi",
                            "Guru"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Euphemia",
                            "Cans"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Plantagenet Cherokee",
                            "Cher"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Yi Baiti",
                            "Yiii"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Himalaya",
                            "Tibt"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "MV Boli",
                            "Thaa"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Mangal",
                            "Deva"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Gautami",
                            "Telu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Latha",
                            "Taml"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrc"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Kalinga",
                            "Orya"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Kartika",
                            "Mlym"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "DokChampa",
                            "Laoo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Iskoola Pota",
                            "Sinh"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Mongolian Baiti",
                            "Mong"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Times New Roman",
                            "Viet"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Uighur",
                            "Uigh"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Sylfaen",
                            "Geor"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Arial",
                            "Armn"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Leelawadee UI",
                            "Bugi"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft JhengHei",
                            "Bopo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Javanese Text",
                            "Java"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Segoe UI",
                            "Lisu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Myanmar Text",
                            "Mymr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Nkoo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nirmala UI",
                            "Olck"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Osma"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Phagspa",
                            "Phag"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrn"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrj"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syre"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nirmala UI",
                            "Sora"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Tai Le",
                            "Tale"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft New Tai Lue",
                            "Talu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Tfng"
                        ])
                    ]
                },
                {
                    name: "a:minorFont",
                    children: [
                        $5b7ccabde48fae90$var$getFont([
                            "latin",
                            "Calibri",
                            void 0,
                            "020F0502020204030204"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "ea",
                            ""
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "cs",
                            ""
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u6E38\u30B4\u30B7\u30C3\u30AF",
                            "Jpan"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\uB9D1\uC740 \uACE0\uB515",
                            "Hang"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u7B49\u7EBF",
                            "Hans"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u65B0\u7D30\u660E\u9AD4",
                            "Hant"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Arial",
                            "Arab"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Arial",
                            "Hebr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Tahoma",
                            "Thai"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nyala",
                            "Ethi"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Vrinda",
                            "Beng"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Shruti",
                            "Gujr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "DaunPenh",
                            "Khmr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Tunga",
                            "Knda"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Raavi",
                            "Guru"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Euphemia",
                            "Cans"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Plantagenet Cherokee",
                            "Cher"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Yi Baiti",
                            "Yiii"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Himalaya",
                            "Tibt"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "MV Boli",
                            "Thaa"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Mangal",
                            "Deva"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Gautami",
                            "Telu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Latha",
                            "Taml"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrc"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Kalinga",
                            "Orya"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Kartika",
                            "Mlym"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "DokChampa",
                            "Laoo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Iskoola Pota",
                            "Sinh"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Mongolian Baiti",
                            "Mong"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Arial",
                            "Viet"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Uighur",
                            "Uigh"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Sylfaen",
                            "Geor"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Arial",
                            "Armn"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Leelawadee UI",
                            "Bugi"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft JhengHei",
                            "Bopo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Javanese Text",
                            "Java"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Segoe UI",
                            "Lisu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Myanmar Text",
                            "Mymr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Nkoo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nirmala UI",
                            "Olck"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Osma"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Phagspa",
                            "Phag"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrn"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrj"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syre"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nirmala UI",
                            "Sora"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Tai Le",
                            "Tale"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft New Tai Lue",
                            "Talu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Tfng"
                        ])
                    ]
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$fontScheme_default = $5b7ccabde48fae90$var$fontScheme;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/themes/office/formatScheme.ts
var $5b7ccabde48fae90$var$getPropertyVal = (name, val, children)=>({
        name: `a:${name}`,
        properties: {
            rawMap: {
                val: val
            }
        },
        children: children
    });
var $5b7ccabde48fae90$var$getGs = (props)=>{
    const [pos, schemeColor, satMod, lumMod, tint, shade] = props;
    const children = [];
    children.push($5b7ccabde48fae90$var$getPropertyVal("satMod", satMod));
    if (lumMod) children.push($5b7ccabde48fae90$var$getPropertyVal("lumMod", lumMod));
    if (tint) children.push($5b7ccabde48fae90$var$getPropertyVal("tint", tint));
    if (shade) children.push($5b7ccabde48fae90$var$getPropertyVal("shade", shade));
    return {
        name: "a:gs",
        properties: {
            rawMap: {
                pos: pos
            }
        },
        children: [
            {
                name: "a:schemeClr",
                properties: {
                    rawMap: {
                        val: schemeColor
                    }
                },
                children: children
            }
        ]
    };
};
var $5b7ccabde48fae90$var$getSolidFill = (val, children)=>({
        name: "a:solidFill",
        children: [
            $5b7ccabde48fae90$var$getPropertyVal("schemeClr", val, children)
        ]
    });
var $5b7ccabde48fae90$var$getGradFill = (props)=>{
    const [rotWithShape, gs1, gs2, gs3, lin] = props;
    const [ang, scaled] = lin;
    return {
        name: "a:gradFill",
        properties: {
            rawMap: {
                rotWithShape: rotWithShape
            }
        },
        children: [
            {
                name: "a:gsLst",
                children: [
                    $5b7ccabde48fae90$var$getGs(gs1),
                    $5b7ccabde48fae90$var$getGs(gs2),
                    $5b7ccabde48fae90$var$getGs(gs3)
                ]
            },
            {
                name: "a:lin",
                properties: {
                    rawMap: {
                        ang: ang,
                        scaled: scaled
                    }
                }
            }
        ]
    };
};
var $5b7ccabde48fae90$var$getLine = (props)=>{
    const [w, cap, cmpd, algn] = props;
    return {
        name: "a:ln",
        properties: {
            rawMap: {
                w: w,
                cap: cap,
                cmpd: cmpd,
                algn: algn
            }
        },
        children: [
            $5b7ccabde48fae90$var$getSolidFill("phClr"),
            $5b7ccabde48fae90$var$getPropertyVal("prstDash", "solid"),
            {
                name: "a:miter",
                properties: {
                    rawMap: {
                        lim: "800000"
                    }
                }
            }
        ]
    };
};
var $5b7ccabde48fae90$var$getEffectStyle = (shadow2)=>{
    const children = [];
    if (shadow2) {
        const [blurRad, dist, dir, algn, rotWithShape] = shadow2;
        children.push({
            name: "a:outerShdw",
            properties: {
                rawMap: {
                    blurRad: blurRad,
                    dist: dist,
                    dir: dir,
                    algn: algn,
                    rotWithShape: rotWithShape
                }
            },
            children: [
                $5b7ccabde48fae90$var$getPropertyVal("srgbClr", "000000", [
                    $5b7ccabde48fae90$var$getPropertyVal("alpha", "63000")
                ])
            ]
        });
    }
    return {
        name: "a:effectStyle",
        children: [
            Object.assign({}, {
                name: "a:effectLst"
            }, children.length ? {
                children: children
            } : {})
        ]
    };
};
var $5b7ccabde48fae90$var$getFillStyleList = ()=>({
        name: "a:fillStyleLst",
        children: [
            $5b7ccabde48fae90$var$getSolidFill("phClr"),
            $5b7ccabde48fae90$var$getGradFill([
                "1",
                [
                    "0",
                    "phClr",
                    "105000",
                    "110000",
                    "67000"
                ],
                [
                    "50000",
                    "phClr",
                    "103000",
                    "105000",
                    "73000"
                ],
                [
                    "100000",
                    "phClr",
                    "109000",
                    "105000",
                    "81000"
                ],
                [
                    "5400000",
                    "0"
                ]
            ]),
            $5b7ccabde48fae90$var$getGradFill([
                "1",
                [
                    "0",
                    "phClr",
                    "103000",
                    "102000",
                    "94000"
                ],
                [
                    "50000",
                    "phClr",
                    "110000",
                    "100000",
                    void 0,
                    "100000"
                ],
                [
                    "100000",
                    "phClr",
                    "120000",
                    "99000",
                    void 0,
                    "78000"
                ],
                [
                    "5400000",
                    "0"
                ]
            ])
        ]
    });
var $5b7ccabde48fae90$var$getLineStyleList = ()=>({
        name: "a:lnStyleLst",
        children: [
            $5b7ccabde48fae90$var$getLine([
                "6350",
                "flat",
                "sng",
                "ctr"
            ]),
            $5b7ccabde48fae90$var$getLine([
                "12700",
                "flat",
                "sng",
                "ctr"
            ]),
            $5b7ccabde48fae90$var$getLine([
                "19050",
                "flat",
                "sng",
                "ctr"
            ])
        ]
    });
var $5b7ccabde48fae90$var$getEffectStyleList = ()=>({
        name: "a:effectStyleLst",
        children: [
            $5b7ccabde48fae90$var$getEffectStyle(),
            $5b7ccabde48fae90$var$getEffectStyle(),
            $5b7ccabde48fae90$var$getEffectStyle([
                "57150",
                "19050",
                "5400000",
                "ctr",
                "0"
            ])
        ]
    });
var $5b7ccabde48fae90$var$getBgFillStyleList = ()=>({
        name: "a:bgFillStyleLst",
        children: [
            $5b7ccabde48fae90$var$getSolidFill("phClr"),
            $5b7ccabde48fae90$var$getSolidFill("phClr", [
                $5b7ccabde48fae90$var$getPropertyVal("tint", "95000"),
                $5b7ccabde48fae90$var$getPropertyVal("satMod", "170000")
            ]),
            $5b7ccabde48fae90$var$getGradFill([
                "1",
                [
                    "0",
                    "phClr",
                    "150000",
                    "102000",
                    "93000",
                    "98000"
                ],
                [
                    "50000",
                    "phClr",
                    "130000",
                    "103000",
                    "98000",
                    "90000"
                ],
                [
                    "100000",
                    "phClr",
                    "120000",
                    void 0,
                    void 0,
                    "63000"
                ],
                [
                    "5400000",
                    "0"
                ]
            ])
        ]
    });
var $5b7ccabde48fae90$var$formatScheme = {
    getTemplate () {
        return {
            name: "a:fmtScheme",
            properties: {
                rawMap: {
                    name: "Office"
                }
            },
            children: [
                $5b7ccabde48fae90$var$getFillStyleList(),
                $5b7ccabde48fae90$var$getLineStyleList(),
                $5b7ccabde48fae90$var$getEffectStyleList(),
                $5b7ccabde48fae90$var$getBgFillStyleList()
            ]
        };
    }
};
var $5b7ccabde48fae90$var$formatScheme_default = $5b7ccabde48fae90$var$formatScheme;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/themes/office/themeElements.ts
var $5b7ccabde48fae90$var$themeElements = {
    getTemplate () {
        return {
            name: "a:themeElements",
            children: [
                $5b7ccabde48fae90$var$colorScheme_default.getTemplate(),
                $5b7ccabde48fae90$var$fontScheme_default.getTemplate(),
                $5b7ccabde48fae90$var$formatScheme_default.getTemplate()
            ]
        };
    }
};
var $5b7ccabde48fae90$var$themeElements_default = $5b7ccabde48fae90$var$themeElements;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/themes/office.ts
var $5b7ccabde48fae90$var$officeTheme = {
    getTemplate () {
        return {
            name: "a:theme",
            properties: {
                prefixedAttributes: [
                    {
                        prefix: "xmlns:",
                        map: {
                            a: "http://schemas.openxmlformats.org/drawingml/2006/main"
                        }
                    }
                ],
                rawMap: {
                    name: "Office Theme"
                }
            },
            children: [
                $5b7ccabde48fae90$var$themeElements_default.getTemplate(),
                {
                    name: "a:objectDefaults"
                },
                {
                    name: "a:extraClrSchemeLst"
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$office_default = $5b7ccabde48fae90$var$officeTheme;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/vmlDrawing.ts
var $5b7ccabde48fae90$var$getShapeLayout = ()=>({
        name: "o:shapelayout",
        properties: {
            prefixedAttributes: [
                {
                    prefix: "v:",
                    map: {
                        ext: "edit"
                    }
                }
            ]
        },
        children: [
            {
                name: "o:idmap",
                properties: {
                    prefixedAttributes: [
                        {
                            prefix: "v:",
                            map: {
                                ext: "edit"
                            }
                        }
                    ],
                    rawMap: {
                        data: "1"
                    }
                }
            }
        ]
    });
var $5b7ccabde48fae90$var$getStroke = ()=>({
        name: "v:stroke",
        properties: {
            rawMap: {
                joinstyle: "miter"
            }
        }
    });
var $5b7ccabde48fae90$var$getFormulas = (formulas)=>({
        name: "v:formulas",
        children: formulas.map((formula)=>({
                name: "v:f",
                properties: {
                    rawMap: {
                        eqn: formula
                    }
                }
            }))
    });
var $5b7ccabde48fae90$var$getPath = ()=>({
        name: "v:path",
        properties: {
            prefixedAttributes: [
                {
                    prefix: "o:",
                    map: {
                        connecttype: "rect",
                        extrusionok: "f"
                    }
                }
            ],
            rawMap: {
                gradientshapeok: "t"
            }
        }
    });
var $5b7ccabde48fae90$var$getLock = (params)=>{
    const { aspectratio: aspectratio, rotation: rotation } = params || {};
    const rawMap = {};
    if (aspectratio) rawMap.aspectratio = "t";
    if (rotation) rawMap.rotation = "t";
    return {
        name: "o:lock",
        properties: {
            prefixedAttributes: [
                {
                    prefix: "v:",
                    map: {
                        ext: "edit"
                    }
                }
            ],
            rawMap: rawMap
        }
    };
};
function $5b7ccabde48fae90$var$mapNumber(value, startSource, endSource, startTarget, endTarget) {
    return (value - startSource) / (endSource - startSource) * (endTarget - startTarget) + startTarget;
}
var $5b7ccabde48fae90$var$getImageData = (image, idx)=>{
    let rawMap;
    const { recolor: recolor, brightness: brightness, contrast: contrast, id: id } = image;
    if (recolor) {
        rawMap = {};
        if (recolor === "Washout" || recolor === "Grayscale") {
            rawMap.gain = "19661f";
            rawMap.blacklevel = "22938f";
        }
        if (recolor === "Black & White" || recolor === "Grayscale") {
            rawMap.grayscale = "t";
            if (recolor === "Black & White") rawMap.bilevel = "t";
        }
    }
    if (!recolor || recolor === "Grayscale") {
        if (!rawMap) rawMap = {};
        if (contrast != null && contrast !== 50) {
            let gain = "1";
            if (contrast >= 0) {
                if (contrast < 50) gain = String(contrast / 50);
                else if (contrast < 100) gain = String(50 / (100 - contrast));
                else if (contrast === 100) gain = "2147483647f";
            }
            rawMap.gain = gain;
        }
        if (brightness != null && brightness !== 50) rawMap.blacklevel = $5b7ccabde48fae90$var$mapNumber(brightness, 0, 100, -0.5, 0.5).toString();
    }
    return {
        name: "v:imagedata",
        properties: {
            prefixedAttributes: [
                {
                    prefix: "o:",
                    map: {
                        relid: `rId${idx}`,
                        title: id
                    }
                }
            ],
            rawMap: rawMap
        }
    };
};
var $5b7ccabde48fae90$var$getShapeType = ()=>{
    const formulas = [
        "if lineDrawn pixelLineWidth 0",
        "sum @0 1 0",
        "sum 0 0 @1",
        "prod @2 1 2",
        "prod @3 21600 pixelWidth",
        "prod @3 21600 pixelHeight",
        "sum @0 0 1",
        "prod @6 1 2",
        "prod @7 21600 pixelWidth",
        "sum @8 21600 0",
        "prod @7 21600 pixelHeight",
        "sum @10 21600 0"
    ];
    return {
        name: "v:shapetype",
        properties: {
            prefixedAttributes: [
                {
                    prefix: "o:",
                    map: {
                        spt: "75",
                        preferrelative: "t"
                    }
                }
            ],
            rawMap: {
                coordsize: "21600,21600",
                filled: "f",
                id: "_x0000_t75",
                path: "m@4@5l@4@11@9@11@9@5xe",
                stroked: "f"
            }
        },
        children: [
            $5b7ccabde48fae90$var$getStroke(),
            $5b7ccabde48fae90$var$getFormulas(formulas),
            $5b7ccabde48fae90$var$getPath(),
            $5b7ccabde48fae90$var$getLock({
                aspectratio: true
            })
        ]
    };
};
var $5b7ccabde48fae90$var$pixelToPoint = (value)=>Math.floor((value ?? 0) * 0.74999943307122);
var $5b7ccabde48fae90$var$getShape = (image, idx)=>{
    const { width: width = 0, height: height = 0, altText: altText } = image;
    const imageWidth = $5b7ccabde48fae90$var$pixelToPoint(width);
    const imageHeight = $5b7ccabde48fae90$var$pixelToPoint(height);
    return {
        name: "v:shape",
        properties: {
            rawMap: {
                id: image.headerFooterPosition,
                "o:spid": "_x0000_s1025",
                style: `position: absolute; margin-left: 0; margin-top: 10in; margin-bottom: 0; margin-right: 0; width: ${imageWidth}pt; height: ${imageHeight}pt; z-index: ${idx + 1}`,
                type: "#_x0000_t75",
                alt: altText
            }
        },
        children: [
            $5b7ccabde48fae90$var$getImageData(image, idx + 1),
            $5b7ccabde48fae90$var$getLock({
                rotation: true
            })
        ]
    };
};
var $5b7ccabde48fae90$var$vmlDrawingFactory = {
    getTemplate (params) {
        const headerFooterImages = $5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES.get(params.sheetIndex) || [];
        const children = [
            $5b7ccabde48fae90$var$getShapeLayout(),
            $5b7ccabde48fae90$var$getShapeType(),
            ...headerFooterImages.map((img, idx)=>$5b7ccabde48fae90$var$getShape(img, idx))
        ];
        return {
            name: "xml",
            properties: {
                prefixedAttributes: [
                    {
                        prefix: "xmlns:",
                        map: {
                            v: "urn:schemas-microsoft-com:vml",
                            o: "urn:schemas-microsoft-com:office:office",
                            x: "urn:schemas-microsoft-com:office:excel"
                        }
                    }
                ]
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$vmlDrawing_default = $5b7ccabde48fae90$var$vmlDrawingFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/sheet.ts
var $5b7ccabde48fae90$var$sheetFactory = {
    getTemplate (name, idx) {
        const sheetId = (idx + 1).toString();
        return {
            name: "sheet",
            properties: {
                rawMap: {
                    name: name,
                    sheetId: sheetId,
                    "r:id": `rId${sheetId}`
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$sheet_default = $5b7ccabde48fae90$var$sheetFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/sheets.ts
var $5b7ccabde48fae90$var$sheetsFactory = {
    getTemplate (names) {
        return {
            name: "sheets",
            children: names.map((sheet, idx)=>$5b7ccabde48fae90$var$sheet_default.getTemplate(sheet, idx))
        };
    }
};
var $5b7ccabde48fae90$var$sheets_default = $5b7ccabde48fae90$var$sheetsFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/workbook.ts
var $5b7ccabde48fae90$var$workbookFactory = {
    getTemplate (names, activeTab) {
        return {
            name: "workbook",
            properties: {
                prefixedAttributes: [
                    {
                        prefix: "xmlns:",
                        map: {
                            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
                        }
                    }
                ],
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
                }
            },
            children: [
                {
                    name: "bookViews",
                    children: [
                        {
                            name: "workbookView",
                            properties: {
                                rawMap: {
                                    activeTab: activeTab
                                }
                            }
                        }
                    ]
                },
                $5b7ccabde48fae90$var$sheets_default.getTemplate(names)
            ]
        };
    }
};
var $5b7ccabde48fae90$var$workbook_default = $5b7ccabde48fae90$var$workbookFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/column.ts
var $5b7ccabde48fae90$var$getExcelCellWidth = (width)=>Math.ceil((width - 12) / 7 + 1);
var $5b7ccabde48fae90$var$colFactory = {
    getTemplate (config) {
        const { min: min, max: max, outlineLevel: outlineLevel, s: s, width: width, hidden: hidden, bestFit: bestFit } = config;
        let excelWidth = 1;
        let customWidth = "0";
        if (width > 1) {
            excelWidth = $5b7ccabde48fae90$var$getExcelCellWidth(width);
            customWidth = "1";
        }
        return {
            name: "col",
            properties: {
                rawMap: {
                    min: min,
                    max: max,
                    outlineLevel: outlineLevel != null ? outlineLevel : void 0,
                    width: excelWidth,
                    style: s,
                    hidden: hidden ? "1" : "0",
                    bestFit: bestFit ? "1" : "0",
                    customWidth: customWidth
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$column_default = $5b7ccabde48fae90$var$colFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/mergeCell.ts
var $5b7ccabde48fae90$var$mergeCellFactory = {
    getTemplate (ref) {
        return {
            name: "mergeCell",
            properties: {
                rawMap: {
                    ref: ref
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$mergeCell_default = $5b7ccabde48fae90$var$mergeCellFactory;
var $5b7ccabde48fae90$var$convertLegacyType = (type)=>{
    const t = type.charAt(0).toLowerCase();
    return t === "s" ? "inlineStr" : t;
};
var $5b7ccabde48fae90$var$cellFactory = {
    getTemplate (config, idx, currentSheet2) {
        const { ref: ref, data: data, styleId: styleId } = config;
        const { type: type, value: value } = data || {
            type: "empty",
            value: null
        };
        let convertedType = type;
        if (type === "f") convertedType = "str";
        else if (type.charAt(0) === type.charAt(0).toUpperCase()) convertedType = $5b7ccabde48fae90$var$convertLegacyType(type);
        const obj = {
            name: "c",
            properties: {
                rawMap: {
                    r: ref,
                    t: convertedType === "empty" ? void 0 : convertedType,
                    s: styleId ? $5b7ccabde48fae90$var$getStyleId(styleId, currentSheet2) : void 0
                }
            }
        };
        if (convertedType === "empty") return obj;
        let children;
        if (convertedType === "str" && type === "f") children = [
            {
                name: "f",
                textNode: (0, $jIDNV._escapeString)($5b7ccabde48fae90$var$replaceInvisibleCharacters(value))
            }
        ];
        else if (convertedType === "inlineStr") children = [
            {
                name: "is",
                children: [
                    {
                        name: "t",
                        textNode: (0, $jIDNV._escapeString)($5b7ccabde48fae90$var$replaceInvisibleCharacters(value))
                    }
                ]
            }
        ];
        else children = [
            {
                name: "v",
                textNode: value
            }
        ];
        return Object.assign({}, obj, {
            children: children
        });
    }
};
var $5b7ccabde48fae90$var$cell_default = $5b7ccabde48fae90$var$cellFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/row.ts
var $5b7ccabde48fae90$var$addEmptyCells = (cells, rowIdx)=>{
    const mergeMap = [];
    let posCounter = 0;
    for(let i = 0; i < cells.length; i++){
        const cell = cells[i];
        if (cell.mergeAcross) {
            mergeMap.push({
                pos: i,
                excelPos: posCounter
            });
            posCounter += cell.mergeAcross;
        }
        posCounter++;
    }
    if (mergeMap.length) for(let i = mergeMap.length - 1; i >= 0; i--){
        const mergedCells = [];
        const cell = cells[mergeMap[i].pos];
        for(let j = 1; j <= cell.mergeAcross; j++)mergedCells.push({
            ref: `${$5b7ccabde48fae90$var$getExcelColumnName(mergeMap[i].excelPos + 1 + j)}${rowIdx + 1}`,
            styleId: cell.styleId,
            data: {
                type: "empty",
                value: null
            }
        });
        if (mergedCells.length) cells.splice(mergeMap[i].pos + 1, 0, ...mergedCells);
    }
};
var $5b7ccabde48fae90$var$shouldDisplayCell = (cell)=>cell.data?.value !== "" || cell.styleId !== void 0;
var $5b7ccabde48fae90$var$rowFactory = {
    getTemplate (config, idx, currentSheet2) {
        const { collapsed: collapsed, hidden: hidden, height: height, outlineLevel: outlineLevel, cells: cells = [] } = config;
        $5b7ccabde48fae90$var$addEmptyCells(cells, idx);
        const children = cells.filter($5b7ccabde48fae90$var$shouldDisplayCell).map((cell, idx2)=>$5b7ccabde48fae90$var$cell_default.getTemplate(cell, idx2, currentSheet2));
        return {
            name: "row",
            properties: {
                rawMap: {
                    r: idx + 1,
                    collapsed: collapsed ? "1" : "0",
                    hidden: hidden ? "1" : "0",
                    ht: height,
                    customHeight: height != null ? "1" : "0",
                    spans: "1:1",
                    outlineLevel: outlineLevel || void 0
                }
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$row_default = $5b7ccabde48fae90$var$rowFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/worksheet.ts
var $5b7ccabde48fae90$var$getMergedCellsAndAddColumnGroups = (rows, cols, suppressColumnOutline)=>{
    const mergedCells = [];
    const cellsWithCollapsibleGroups = [];
    rows.forEach((currentRow, rowIdx)=>{
        const cells = currentRow.cells;
        let merges = 0;
        let lastCol;
        cells.forEach((currentCell, cellIdx)=>{
            const min = cellIdx + merges + 1;
            const start = $5b7ccabde48fae90$var$getExcelColumnName(min);
            const outputRow = rowIdx + 1;
            if (currentCell.mergeAcross) {
                merges += currentCell.mergeAcross;
                const end = $5b7ccabde48fae90$var$getExcelColumnName(cellIdx + merges + 1);
                mergedCells.push(`${start}${outputRow}:${end}${outputRow}`);
            }
            if (!cols[min - 1]) cols[min - 1] = {};
            const { collapsibleRanges: collapsibleRanges } = currentCell;
            if (collapsibleRanges) collapsibleRanges.forEach((range)=>{
                cellsWithCollapsibleGroups.push([
                    min + range[0],
                    min + range[1]
                ]);
            });
            lastCol = cols[min - 1];
            lastCol.min = min;
            lastCol.max = min;
            currentCell.ref = `${start}${outputRow}`;
        });
    });
    cellsWithCollapsibleGroups.sort((a, b)=>{
        if (a[0] !== b[0]) return a[0] - b[0];
        return b[1] - a[1];
    });
    const rangeMap = /* @__PURE__ */ new Map();
    const outlineLevel = /* @__PURE__ */ new Map();
    cellsWithCollapsibleGroups.filter((currentRange)=>{
        const rangeString = currentRange.toString();
        const inMap = rangeMap.get(rangeString);
        if (inMap) return false;
        rangeMap.set(rangeString, true);
        return true;
    }).forEach((range)=>{
        const refCol = cols.find((col)=>col.min == range[0] && col.max == range[1]);
        const currentOutlineLevel = outlineLevel.get(range[0]);
        cols.push({
            min: range[0],
            max: range[1],
            outlineLevel: suppressColumnOutline ? void 0 : currentOutlineLevel || 1,
            width: (refCol || {
                width: 100
            }).width
        });
        outlineLevel.set(range[0], (currentOutlineLevel || 0) + 1);
    });
    return mergedCells;
};
var $5b7ccabde48fae90$var$getPageOrientation = (orientation)=>{
    if (!orientation || orientation !== "Portrait" && orientation !== "Landscape") return "portrait";
    return orientation.toLocaleLowerCase();
};
var $5b7ccabde48fae90$var$getPageSize = (pageSize)=>{
    if (pageSize == null) return 1;
    const positions = [
        "Letter",
        "Letter Small",
        "Tabloid",
        "Ledger",
        "Legal",
        "Statement",
        "Executive",
        "A3",
        "A4",
        "A4 Small",
        "A5",
        "A6",
        "B4",
        "B5",
        "Folio",
        "Envelope",
        "Envelope DL",
        "Envelope C5",
        "Envelope B5",
        "Envelope C3",
        "Envelope C4",
        "Envelope C6",
        "Envelope Monarch",
        "Japanese Postcard",
        "Japanese Double Postcard"
    ];
    const pos = positions.indexOf(pageSize);
    return pos === -1 ? 1 : pos + 1;
};
var $5b7ccabde48fae90$var$replaceHeaderFooterTokens = (value)=>{
    const map = {
        "&[Page]": "&P",
        "&[Pages]": "&N",
        "&[Date]": "&D",
        "&[Time]": "&T",
        "&[Tab]": "&A",
        "&[Path]": "&Z",
        "&[File]": "&F",
        "&[Picture]": "&G"
    };
    for (const key of Object.keys(map))value = value.replace(key, map[key]);
    return value;
};
var $5b7ccabde48fae90$var$getHeaderPosition = (position)=>{
    if (position === "Center") return "C";
    if (position === "Right") return "R";
    return "L";
};
var $5b7ccabde48fae90$var$applyHeaderFontStyle = (headerString, font)=>{
    if (!font) return headerString;
    headerString += "&amp;&quot;";
    headerString += font.fontName || "Calibri";
    if (font.bold !== font.italic) headerString += font.bold ? ",Bold" : ",Italic";
    else if (font.bold) headerString += ",Bold Italic";
    else headerString += ",Regular";
    headerString += "&quot;";
    if (font.size) headerString += `&amp;${font.size}`;
    if (font.strikeThrough) headerString += "&amp;S";
    if (font.underline) headerString += `&amp;${font.underline === "Double" ? "E" : "U"}`;
    if (font.color) headerString += `&amp;K${font.color.replace("#", "").toUpperCase()}`;
    return headerString;
};
var $5b7ccabde48fae90$var$processHeaderFooterContent = (content, location, rule)=>content.reduce((prev, curr, idx)=>{
        const pos = $5b7ccabde48fae90$var$getHeaderPosition(curr.position);
        const output = $5b7ccabde48fae90$var$applyHeaderFontStyle(`${prev}&amp;${pos}`, curr.font);
        const PositionMap = [
            "Left",
            "Center",
            "Right"
        ];
        if (!curr.position) curr.position = PositionMap[idx];
        const { image: image } = curr;
        if (curr.value === "&[Picture]" && image) {
            const imagePosition = `${pos}${location}${rule}`;
            $5b7ccabde48fae90$var$addXlsxHeaderFooterImageToMap(image, imagePosition);
        }
        return `${output}${(0, $jIDNV._escapeString)($5b7ccabde48fae90$var$replaceHeaderFooterTokens(curr.value))}`;
    }, "");
var $5b7ccabde48fae90$var$buildHeaderFooter = (headerFooterConfig)=>{
    const rules = [
        "all",
        "first",
        "even"
    ];
    const headersAndFooters = [];
    rules.forEach((rule)=>{
        const headerFooter = headerFooterConfig[rule];
        const namePrefix = rule === "all" ? "odd" : rule;
        if (!headerFooter) return;
        for (const key of Object.keys(headerFooter)){
            const value = headerFooter[key];
            const nameSuffix = `${key.charAt(0).toUpperCase()}${key.slice(1)}`;
            const location = key[0].toUpperCase();
            if (value) {
                const normalizedRule = rule === "all" ? "" : rule.toUpperCase();
                headersAndFooters.push({
                    name: `${namePrefix}${nameSuffix}`,
                    properties: {
                        rawMap: {
                            "xml:space": "preserve"
                        }
                    },
                    textNode: $5b7ccabde48fae90$var$processHeaderFooterContent(value, location, normalizedRule)
                });
            }
        }
    });
    return headersAndFooters;
};
var $5b7ccabde48fae90$var$addColumns = (columns)=>{
    return (params)=>{
        if (columns.length) params.children.push({
            name: "cols",
            children: columns.map((column)=>$5b7ccabde48fae90$var$column_default.getTemplate(column))
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addSheetData = (rows, sheetNumber)=>{
    return (params)=>{
        if (rows.length) params.children.push({
            name: "sheetData",
            children: rows.map((row, idx)=>$5b7ccabde48fae90$var$row_default.getTemplate(row, idx, sheetNumber))
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addMergeCells = (mergeCells)=>{
    return (params)=>{
        if (mergeCells.length) params.children.push({
            name: "mergeCells",
            properties: {
                rawMap: {
                    count: mergeCells.length
                }
            },
            children: mergeCells.map((mergedCell)=>$5b7ccabde48fae90$var$mergeCell_default.getTemplate(mergedCell))
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addPageMargins = (margins)=>{
    return (params)=>{
        const { top: top = 0.75, right: right = 0.7, bottom: bottom = 0.75, left: left = 0.7, header: header = 0.3, footer: footer = 0.3 } = margins;
        params.children.push({
            name: "pageMargins",
            properties: {
                rawMap: {
                    bottom: bottom,
                    footer: footer,
                    header: header,
                    left: left,
                    right: right,
                    top: top
                }
            }
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addPageSetup = (pageSetup)=>{
    return (params)=>{
        if (pageSetup) params.children.push({
            name: "pageSetup",
            properties: {
                rawMap: {
                    horizontalDpi: 0,
                    verticalDpi: 0,
                    orientation: $5b7ccabde48fae90$var$getPageOrientation(pageSetup.orientation),
                    paperSize: $5b7ccabde48fae90$var$getPageSize(pageSetup.pageSize)
                }
            }
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addHeaderFooter = (headerFooterConfig)=>{
    return (params)=>{
        if (!headerFooterConfig) return params;
        const differentFirst = headerFooterConfig.first != null ? 1 : 0;
        const differentOddEven = headerFooterConfig.even != null ? 1 : 0;
        params.children.push({
            name: "headerFooter",
            properties: {
                rawMap: {
                    differentFirst: differentFirst,
                    differentOddEven: differentOddEven
                }
            },
            children: $5b7ccabde48fae90$var$buildHeaderFooter(headerFooterConfig)
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addExcelTableRel = (excelTable)=>{
    return (params)=>{
        if (excelTable) params.children.push({
            name: "tableParts",
            properties: {
                rawMap: {
                    count: "1"
                }
            },
            children: [
                {
                    name: "tablePart",
                    properties: {
                        rawMap: {
                            "r:id": `rId${++params.rIdCounter}`
                        }
                    }
                }
            ]
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addDrawingRel = (currentSheet2)=>{
    return (params)=>{
        const worksheetImages = $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGES.get(currentSheet2);
        if (worksheetImages?.length) params.children.push({
            name: "drawing",
            properties: {
                rawMap: {
                    "r:id": `rId${++params.rIdCounter}`
                }
            }
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addVmlDrawingRel = (currentSheet2)=>{
    return (params)=>{
        if ($5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES.get(currentSheet2)) params.children.push({
            name: "legacyDrawingHF",
            properties: {
                rawMap: {
                    "r:id": `rId${++params.rIdCounter}`
                }
            }
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$getPane = (xSplit = 0, ySplit = 0)=>{
    const shouldSplit = xSplit > 0 || ySplit > 0;
    return shouldSplit ? [
        {
            name: "pane",
            properties: {
                rawMap: {
                    state: shouldSplit ? "frozen" : void 0,
                    topLeftCell: shouldSplit ? `${$5b7ccabde48fae90$var$getExcelColumnName(xSplit + 1)}${ySplit + 1}` : void 0,
                    xSplit: xSplit === 0 ? void 0 : xSplit,
                    ySplit: ySplit === 0 ? void 0 : ySplit
                }
            }
        }
    ] : void 0;
};
var $5b7ccabde48fae90$var$addSheetViews = (rtl = false, xSplit, ySplit)=>{
    return (params)=>{
        params.children.push({
            name: "sheetViews",
            children: [
                {
                    name: "sheetView",
                    properties: {
                        rawMap: {
                            rightToLeft: rtl === true ? "1" : "0",
                            workbookViewId: "0"
                        }
                    },
                    children: $5b7ccabde48fae90$var$getPane(xSplit, ySplit)
                }
            ]
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addSheetPr = ()=>{
    return (params)=>{
        params.children.push({
            name: "sheetPr",
            children: [
                {
                    name: "outlinePr",
                    properties: {
                        rawMap: {
                            summaryBelow: 0
                        }
                    }
                }
            ]
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addSheetFormatPr = (rows)=>{
    return (params)=>{
        const maxOutline = rows.reduce((prev, row)=>{
            if (row.outlineLevel && row.outlineLevel > prev) return row.outlineLevel;
            return prev;
        }, 0);
        params.children.push({
            name: "sheetFormatPr",
            properties: {
                rawMap: {
                    baseColWidth: 10,
                    defaultRowHeight: 16,
                    outlineLevelRow: maxOutline ? maxOutline : void 0
                }
            }
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$worksheetFactory = {
    getTemplate (params) {
        const { worksheet: worksheet, currentSheet: currentSheet2, config: config } = params;
        const { margins: margins = {}, pageSetup: pageSetup, headerFooterConfig: headerFooterConfig, suppressColumnOutline: suppressColumnOutline, rightToLeft: rightToLeft, frozenRowCount: frozenRowCount, frozenColumnCount: frozenColumnCount } = config;
        const { table: table } = worksheet;
        const { rows: rows, columns: columns } = table;
        const mergedCells = columns && columns.length ? $5b7ccabde48fae90$var$getMergedCellsAndAddColumnGroups(rows, columns, !!suppressColumnOutline) : [];
        const worksheetExcelTables = $5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES.get(currentSheet2);
        const { children: children } = [
            $5b7ccabde48fae90$var$addSheetPr(),
            $5b7ccabde48fae90$var$addSheetViews(rightToLeft, frozenColumnCount, frozenRowCount),
            $5b7ccabde48fae90$var$addSheetFormatPr(rows),
            $5b7ccabde48fae90$var$addColumns(columns),
            $5b7ccabde48fae90$var$addSheetData(rows, currentSheet2 + 1),
            $5b7ccabde48fae90$var$addMergeCells(mergedCells),
            $5b7ccabde48fae90$var$addPageMargins(margins),
            $5b7ccabde48fae90$var$addPageSetup(pageSetup),
            $5b7ccabde48fae90$var$addHeaderFooter(headerFooterConfig),
            $5b7ccabde48fae90$var$addDrawingRel(currentSheet2),
            $5b7ccabde48fae90$var$addVmlDrawingRel(currentSheet2),
            $5b7ccabde48fae90$var$addExcelTableRel(worksheetExcelTables)
        ].reduce((composed, f)=>f(composed), {
            children: [],
            rIdCounter: 0
        });
        return {
            name: "worksheet",
            properties: {
                prefixedAttributes: [
                    {
                        prefix: "xmlns:",
                        map: {
                            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
                        }
                    }
                ],
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
                }
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$worksheet_default = $5b7ccabde48fae90$var$worksheetFactory;
// packages/ag-grid-enterprise/src/excelExport/excelXlsxFactory.ts
var $5b7ccabde48fae90$var$XLSX_SHARED_STRINGS = /* @__PURE__ */ new Map();
var $5b7ccabde48fae90$var$XLSX_SHEET_NAMES = [];
var $5b7ccabde48fae90$var$XLSX_IMAGES = /* @__PURE__ */ new Map();
var $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGES = /* @__PURE__ */ new Map();
var $5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES = /* @__PURE__ */ new Map();
var $5b7ccabde48fae90$var$XLSX_WORKBOOK_IMAGE_IDS = /* @__PURE__ */ new Map();
var $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGE_IDS = /* @__PURE__ */ new Map();
var $5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES = /* @__PURE__ */ new Map();
var $5b7ccabde48fae90$var$DEFAULT_TABLE_DISPLAY_NAME = "AG-GRID-TABLE";
var $5b7ccabde48fae90$var$XLSX_FACTORY_MODE = "SINGLE_SHEET";
function $5b7ccabde48fae90$var$getXlsxFactoryMode() {
    return $5b7ccabde48fae90$var$XLSX_FACTORY_MODE;
}
function $5b7ccabde48fae90$var$setXlsxFactoryMode(factoryMode) {
    $5b7ccabde48fae90$var$XLSX_FACTORY_MODE = factoryMode;
}
function $5b7ccabde48fae90$var$createXlsxExcel(styles, worksheet, config) {
    $5b7ccabde48fae90$var$addSheetName(worksheet);
    $5b7ccabde48fae90$var$registerStyles(styles, $5b7ccabde48fae90$var$XLSX_SHEET_NAMES.length);
    const newConfig = Object.assign({}, config);
    if (config.exportAsExcelTable) {
        if (config.colModel.isPivotActive()) {
            (0, $jIDNV._warn)(163, {
                featureName: "pivot mode"
            });
            newConfig.exportAsExcelTable = false;
        }
    }
    $5b7ccabde48fae90$var$processTableConfig(worksheet, newConfig);
    return $5b7ccabde48fae90$var$createWorksheet(worksheet, newConfig);
}
function $5b7ccabde48fae90$var$getXlsxSanitizedTableName(name) {
    return name.replace(/^[^a-zA-Z_]+/, "_").replace(/\s/g, "_").replace(/[^a-zA-Z0-9_]/g, "_");
}
function $5b7ccabde48fae90$var$addXlsxTableToSheet(sheetIndex, table) {
    if ($5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES.has(sheetIndex)) {
        (0, $jIDNV._warn)(164);
        return;
    }
    $5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES.set(sheetIndex, table);
}
function $5b7ccabde48fae90$var$processTableConfig(worksheet, config) {
    const { exportAsExcelTable: exportAsExcelTable, prependContent: prependContent, appendContent: appendContent, colModel: colModel } = config;
    if (!exportAsExcelTable) return;
    const tableConfig = typeof exportAsExcelTable === "boolean" ? {} : exportAsExcelTable;
    const { name: nameFromConfig, showColumnStripes: showColumnStripes, showRowStripes: showRowStripes, showFilterButton: showFilterButton, highlightFirstColumn: highlightFirstColumn, highlightLastColumn: highlightLastColumn } = tableConfig;
    const tableName = $5b7ccabde48fae90$var$getXlsxSanitizedTableName(nameFromConfig || $5b7ccabde48fae90$var$DEFAULT_TABLE_DISPLAY_NAME);
    const sheetIndex = $5b7ccabde48fae90$var$XLSX_SHEET_NAMES.length - 1;
    const { table: table } = worksheet;
    const { rows: rows, columns: columns } = table;
    const headerRowCount = (0, $jIDNV._getHeaderRowCount)(colModel);
    const skipTopRows = prependContent ? prependContent.length : 0;
    const removeFromBottom = appendContent ? appendContent.length : 0;
    const tableRowCount = rows.length;
    const tableColCount = columns.length;
    const tableColumns = [];
    const showFilterButtons = [];
    for(let i = 0; i < tableColCount; i++){
        const col = columns[i];
        tableColumns.push(col.displayName || "");
        showFilterButtons.push(showFilterButton === "match" || showFilterButton === void 0 ? col.filterAllowed ?? false : showFilterButton);
    }
    if (!tableColumns || !tableColumns.length || !tableRowCount || !tableName) {
        (0, $jIDNV._warn)(165);
        return;
    }
    $5b7ccabde48fae90$var$addXlsxTableToSheet(sheetIndex, {
        name: `table${$5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES.size + 1}`,
        displayName: tableName,
        columns: tableColumns,
        showFilterButtons: showFilterButtons,
        rowRange: [
            headerRowCount + skipTopRows,
            headerRowCount + (tableRowCount - headerRowCount) - removeFromBottom
        ],
        showRowStripes: showRowStripes ?? true,
        showColumnStripes: showColumnStripes ?? false,
        highlightFirstColumn: highlightFirstColumn ?? false,
        highlightLastColumn: highlightLastColumn ?? false
    });
}
function $5b7ccabde48fae90$var$addXlsxHeaderFooterImageToMap(image, position) {
    const sheetIndex = $5b7ccabde48fae90$var$XLSX_SHEET_NAMES.length - 1;
    const headerFooterImage = image;
    headerFooterImage.headerFooterPosition = position;
    $5b7ccabde48fae90$var$buildImageMap({
        imageToAdd: headerFooterImage,
        idx: sheetIndex
    });
    let headerFooterImagesForSheet = $5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES.get(sheetIndex);
    if (!headerFooterImagesForSheet) {
        headerFooterImagesForSheet = [];
        $5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES.set(sheetIndex, headerFooterImagesForSheet);
    }
    if (!headerFooterImagesForSheet.find((img)=>img.id === image.id)) headerFooterImagesForSheet.push(image);
}
function $5b7ccabde48fae90$var$addXlsxBodyImageToMap(image, rowIndex, col, columnsToExport, rowHeight) {
    const sheetIndex = $5b7ccabde48fae90$var$XLSX_SHEET_NAMES.length;
    const { row: row, column: column } = image.position || {};
    const calculatedImage = image;
    if (columnsToExport) {
        if (rowIndex != null && col != null && (!row || !column)) {
            if (!image.position) image.position = {};
            image.position = Object.assign({}, image.position, {
                row: rowIndex,
                column: columnsToExport.indexOf(col) + 1
            });
        }
        $5b7ccabde48fae90$var$setExcelImageTotalWidth(calculatedImage, columnsToExport);
        $5b7ccabde48fae90$var$setExcelImageTotalHeight(calculatedImage, rowHeight);
    }
    $5b7ccabde48fae90$var$buildImageMap({
        imageToAdd: calculatedImage,
        idx: sheetIndex
    });
    let worksheetImageIdMap = $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGE_IDS.get(sheetIndex);
    if (!worksheetImageIdMap) {
        worksheetImageIdMap = /* @__PURE__ */ new Map();
        $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGE_IDS.set(sheetIndex, worksheetImageIdMap);
    }
    const sheetImages = $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGES.get(sheetIndex);
    if (!sheetImages) $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGES.set(sheetIndex, [
        calculatedImage
    ]);
    else sheetImages.push(calculatedImage);
    if (!worksheetImageIdMap.get(image.id)) worksheetImageIdMap.set(image.id, {
        index: worksheetImageIdMap.size,
        type: image.imageType
    });
}
function $5b7ccabde48fae90$var$buildImageMap(params) {
    const { imageToAdd: imageToAdd, idx: idx } = params;
    const mappedImagesToSheet = $5b7ccabde48fae90$var$XLSX_IMAGES.get(imageToAdd.id);
    if (mappedImagesToSheet) {
        const currentSheetImages = mappedImagesToSheet.find((currentImage)=>currentImage.sheetId === idx);
        if (currentSheetImages) currentSheetImages.image.push(imageToAdd);
        else mappedImagesToSheet.push({
            sheetId: idx,
            image: [
                imageToAdd
            ]
        });
    } else {
        $5b7ccabde48fae90$var$XLSX_IMAGES.set(imageToAdd.id, [
            {
                sheetId: idx,
                image: [
                    imageToAdd
                ]
            }
        ]);
        $5b7ccabde48fae90$var$XLSX_WORKBOOK_IMAGE_IDS.set(imageToAdd.id, {
            type: imageToAdd.imageType,
            index: $5b7ccabde48fae90$var$XLSX_WORKBOOK_IMAGE_IDS.size
        });
    }
}
function $5b7ccabde48fae90$var$addSheetName(worksheet) {
    const name = (0, $jIDNV._escapeString)(worksheet.name) || "";
    let append = "";
    while($5b7ccabde48fae90$var$XLSX_SHEET_NAMES.indexOf(`${name}${append}`) !== -1)if (append === "") append = "_1";
    else {
        const curr = parseInt(append.slice(1), 10);
        append = `_${curr + 1}`;
    }
    worksheet.name = `${name}${append}`;
    $5b7ccabde48fae90$var$XLSX_SHEET_NAMES.push(worksheet.name);
}
function $5b7ccabde48fae90$var$getXlsxStringPosition(str) {
    if ($5b7ccabde48fae90$var$XLSX_SHARED_STRINGS.has(str)) return $5b7ccabde48fae90$var$XLSX_SHARED_STRINGS.get(str);
    $5b7ccabde48fae90$var$XLSX_SHARED_STRINGS.set(str, $5b7ccabde48fae90$var$XLSX_SHARED_STRINGS.size);
    return $5b7ccabde48fae90$var$XLSX_SHARED_STRINGS.size - 1;
}
function $5b7ccabde48fae90$var$resetXlsxFactory() {
    $5b7ccabde48fae90$var$XLSX_SHARED_STRINGS.clear();
    $5b7ccabde48fae90$var$XLSX_IMAGES.clear();
    $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGES.clear();
    $5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES.clear();
    $5b7ccabde48fae90$var$XLSX_WORKBOOK_IMAGE_IDS.clear();
    $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGE_IDS.clear();
    $5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES.clear();
    $5b7ccabde48fae90$var$XLSX_SHEET_NAMES = [];
    $5b7ccabde48fae90$var$XLSX_FACTORY_MODE = "SINGLE_SHEET";
}
function $5b7ccabde48fae90$var$createXlsxWorkbook(currentSheet2) {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$workbook_default.getTemplate($5b7ccabde48fae90$var$XLSX_SHEET_NAMES, currentSheet2));
}
function $5b7ccabde48fae90$var$createXlsxStylesheet(defaultFontSize) {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$stylesheet_default.getTemplate(defaultFontSize));
}
function $5b7ccabde48fae90$var$createXlsxSharedStrings() {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$sharedStrings_default.getTemplate($5b7ccabde48fae90$var$XLSX_SHARED_STRINGS));
}
function $5b7ccabde48fae90$var$createXlsxCore(author) {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$core_default.getTemplate(author));
}
function $5b7ccabde48fae90$var$createXlsxContentTypes(sheetLen) {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$contentTypes_default.getTemplate(sheetLen));
}
function $5b7ccabde48fae90$var$createXlsxRels() {
    const rs = $5b7ccabde48fae90$var$relationships_default.getTemplate([
        {
            Id: "rId1",
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
            Target: "xl/workbook.xml"
        },
        {
            Id: "rId2",
            Type: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
            Target: "docProps/core.xml"
        }
    ]);
    return $5b7ccabde48fae90$var$createXmlPart(rs);
}
function $5b7ccabde48fae90$var$createXlsxTheme() {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$office_default.getTemplate());
}
function $5b7ccabde48fae90$var$createXlsxTable(dataTable, index) {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$table_default.getTemplate(dataTable, index));
}
function $5b7ccabde48fae90$var$createXlsxWorkbookRels(sheetLen) {
    const worksheets = new Array(sheetLen).fill(void 0).map((v, i)=>({
            Id: `rId${i + 1}`,
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
            Target: `worksheets/sheet${i + 1}.xml`
        }));
    const rs = $5b7ccabde48fae90$var$relationships_default.getTemplate([
        ...worksheets,
        {
            Id: `rId${sheetLen + 1}`,
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
            Target: "theme/theme1.xml"
        },
        {
            Id: `rId${sheetLen + 2}`,
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
            Target: "styles.xml"
        },
        {
            Id: `rId${sheetLen + 3}`,
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
            Target: "sharedStrings.xml"
        }
    ]);
    return $5b7ccabde48fae90$var$createXmlPart(rs);
}
function $5b7ccabde48fae90$var$createXlsxDrawing(sheetIndex) {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$drawing_default.getTemplate({
        sheetIndex: sheetIndex
    }));
}
function $5b7ccabde48fae90$var$createXlsxDrawingRel(sheetIndex) {
    const worksheetImageIds = $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGE_IDS.get(sheetIndex) || [];
    const XMLArr = [];
    for (const [key, value] of worksheetImageIds){
        const { index: index, type: type } = value;
        XMLArr.push({
            Id: `rId${index + 1}`,
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
            Target: `../media/image${$5b7ccabde48fae90$var$XLSX_WORKBOOK_IMAGE_IDS.get(key).index + 1}.${$5b7ccabde48fae90$var$_normaliseImageExtension(type)}`
        });
    }
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$relationships_default.getTemplate(XMLArr));
}
function $5b7ccabde48fae90$var$createXlsxVmlDrawing(sheetIndex) {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$vmlDrawing_default.getTemplate({
        sheetIndex: sheetIndex
    }), true);
}
function $5b7ccabde48fae90$var$createXlsxVmlDrawingRel(sheetIndex) {
    const worksheetHeaderFooterImages = $5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES.get(sheetIndex) || [];
    const XMLArr = [];
    for(let i = 0; i < worksheetHeaderFooterImages.length; i++){
        const headerFooterImage = worksheetHeaderFooterImages[i];
        const workbookImage = $5b7ccabde48fae90$var$XLSX_WORKBOOK_IMAGE_IDS.get(headerFooterImage.id);
        if (!workbookImage) continue;
        const { index: index, type: type } = workbookImage;
        XMLArr.push({
            Id: `rId${i + 1}`,
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
            Target: `../media/image${index + 1}.${$5b7ccabde48fae90$var$_normaliseImageExtension(type)}`
        });
    }
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$relationships_default.getTemplate(XMLArr));
}
function $5b7ccabde48fae90$var$createXlsxRelationships({ drawingIndex: drawingIndex, vmlDrawingIndex: vmlDrawingIndex, tableName: tableName } = {}) {
    if (drawingIndex === void 0 && vmlDrawingIndex === void 0 && tableName === void 0) return "";
    const config = [];
    if (drawingIndex != null) config.push({
        Id: `rId${config.length + 1}`,
        Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
        Target: `../drawings/drawing${drawingIndex + 1}.xml`
    });
    if (vmlDrawingIndex != null) config.push({
        Id: `rId${config.length + 1}`,
        Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
        Target: `../drawings/vmlDrawing${vmlDrawingIndex + 1}.vml`
    });
    if (tableName != null) config.push({
        Id: `rId${config.length + 1}`,
        Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/table",
        Target: `../tables/${tableName}.xml`
    });
    const rs = $5b7ccabde48fae90$var$relationships_default.getTemplate(config);
    return $5b7ccabde48fae90$var$createXmlPart(rs);
}
function $5b7ccabde48fae90$var$createWorksheet(worksheet, config) {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$worksheet_default.getTemplate({
        worksheet: worksheet,
        currentSheet: $5b7ccabde48fae90$var$XLSX_SHEET_NAMES.length - 1,
        config: config
    }));
}
// packages/ag-grid-enterprise/src/excelExport/excelSerializingSession.ts
var $5b7ccabde48fae90$var$ExcelSerializingSession = class extends (0, $jIDNV.BaseGridSerializingSession) {
    constructor(config){
        super(config);
        this.mixedStyles = {};
        this.mixedStyleCounter = 0;
        this.rows = [];
        this.frozenRowCount = 0;
        this.skipFrozenRows = false;
        this.frozenColumnCount = 0;
        this.skipFrozenColumns = false;
        this.config = Object.assign({}, config);
        this.stylesByIds = {};
        this.config.baseExcelStyles.forEach((style)=>{
            this.stylesByIds[style.id] = style;
        });
        this.excelStyles = [
            ...this.config.baseExcelStyles,
            {
                id: "_quotePrefix",
                quotePrefix: 1
            }
        ];
    }
    addCustomContent(customContent) {
        customContent.forEach((row)=>{
            const rowLen = this.rows.length + 1;
            let outlineLevel;
            if (!this.config.suppressRowOutline && row.outlineLevel != null) outlineLevel = row.outlineLevel;
            const rowObj = {
                height: $5b7ccabde48fae90$var$getHeightFromProperty(rowLen, row.height || this.config.rowHeight),
                cells: (row.cells || []).map((cell, idx)=>{
                    const image = this.addImage(rowLen, this.columnsToExport[idx], cell.data?.value);
                    let excelStyles = null;
                    if (cell.styleId) excelStyles = typeof cell.styleId === "string" ? [
                        cell.styleId
                    ] : cell.styleId;
                    const excelStyleId = this.getStyleId(excelStyles);
                    if (image) return this.createCell(excelStyleId, this.getDataTypeForValue(image.value), image.value == null ? "" : image.value);
                    const value = cell.data?.value ?? "";
                    const type = this.getDataTypeForValue(value);
                    if (cell.mergeAcross) return this.createMergedCell(excelStyleId, type, value, cell.mergeAcross);
                    return this.createCell(excelStyleId, type, value);
                }),
                outlineLevel: outlineLevel
            };
            if (row.collapsed != null) rowObj.collapsed = row.collapsed;
            if (row.hidden != null) rowObj.hidden = row.hidden;
            this.rows.push(rowObj);
        });
    }
    onNewHeaderGroupingRow() {
        const currentCells = [];
        const { freezeRows: freezeRows, headerRowHeight: headerRowHeight } = this.config;
        this.rows.push({
            cells: currentCells,
            height: $5b7ccabde48fae90$var$getHeightFromProperty(this.rows.length + 1, headerRowHeight)
        });
        if (freezeRows) this.frozenRowCount++;
        return {
            onColumn: (columnGroup, header, index, span, collapsibleRanges)=>{
                const styleIds = this.config.styleLinker({
                    rowType: "HEADER_GROUPING",
                    rowIndex: 1,
                    value: `grouping-${header}`,
                    columnGroup: columnGroup
                });
                currentCells.push({
                    ...this.createMergedCell(this.getStyleId(styleIds), this.getDataTypeForValue("string"), header, span),
                    collapsibleRanges: collapsibleRanges
                });
            }
        };
    }
    onNewHeaderRow() {
        const { freezeRows: freezeRows, headerRowHeight: headerRowHeight } = this.config;
        if (freezeRows) this.frozenRowCount++;
        return this.onNewRow(this.onNewHeaderColumn, headerRowHeight);
    }
    onNewBodyRow(node) {
        const { freezeRows: freezeRows, rowHeight: rowHeight } = this.config;
        if (!this.skipFrozenRows) {
            if (freezeRows === "headersAndPinnedRows" && node?.rowPinned === "top") this.frozenRowCount++;
            else if (typeof freezeRows === "function") {
                if (freezeRows((0, $jIDNV._addGridCommonParams)(this.gos, {
                    node: node
                }))) this.frozenRowCount++;
                else this.skipFrozenRows = true;
            } else this.skipFrozenRows = true;
        }
        const rowAccumulator = this.onNewRow(this.onNewBodyColumn, rowHeight);
        if (node) this.addRowOutlineIfNecessary(node);
        return rowAccumulator;
    }
    prepare(columnsToExport) {
        super.prepare(columnsToExport);
        this.columnsToExport = [
            ...columnsToExport
        ];
        this.cols = columnsToExport.map((col, i)=>this.convertColumnToExcel(col, i));
    }
    parse() {
        const longestRow = this.rows.reduce((a, b)=>Math.max(a, b.cells.length), 0);
        while(this.cols.length < longestRow)this.cols.push(this.convertColumnToExcel(null, this.cols.length + 1));
        const { config: config } = this;
        let name;
        if (config.sheetName != null) {
            const { sheetName: sheetName } = config;
            const sheetNameValue = typeof sheetName === "function" ? sheetName((0, $jIDNV._addGridCommonParams)(this.gos, {})) : sheetName;
            name = String(sheetNameValue).substring(0, 31);
        } else name = "ag-grid";
        const data = {
            name: name,
            table: {
                columns: this.cols,
                rows: this.rows
            }
        };
        return this.createExcel(data);
    }
    addRowOutlineIfNecessary(node) {
        const { gos: gos, suppressRowOutline: suppressRowOutline, rowGroupExpandState: rowGroupExpandState = "expanded" } = this.config;
        const isGroupHideOpenParents = gos.get("groupHideOpenParents");
        if (isGroupHideOpenParents || suppressRowOutline || node.level == null) return;
        const padding = node.footer ? 1 : 0;
        const currentRow = (0, $jIDNV._last)(this.rows);
        const outlineLevel = Math.min(node.level + padding, 7);
        currentRow.outlineLevel = outlineLevel;
        if (rowGroupExpandState === "expanded") return;
        const collapseAll = rowGroupExpandState === "collapsed";
        if (node.isExpandable()) {
            const isExpanded = !collapseAll && node.expanded;
            currentRow.collapsed = !isExpanded;
        }
        currentRow.hidden = !!node.parent && // or if it is a child of the root node
        node.parent.level !== -1 && (collapseAll || this.isAnyParentCollapsed(node.parent));
    }
    isAnyParentCollapsed(node) {
        while(node && node.level !== -1){
            if (!node.expanded) return true;
            node = node.parent;
        }
        return false;
    }
    convertColumnToExcel(column, index) {
        const columnWidth = this.config.columnWidth;
        const headerValue = column ? this.extractHeaderValue(column) : void 0;
        const displayName = headerValue ?? "";
        const filterAllowed = column ? column.isFilterAllowed() : false;
        if (columnWidth) {
            if (typeof columnWidth === "number") return {
                width: columnWidth,
                displayName: displayName,
                filterAllowed: filterAllowed
            };
            return {
                width: columnWidth({
                    column: column,
                    index: index
                }),
                displayName: displayName,
                filterAllowed: filterAllowed
            };
        }
        if (column) {
            const smallestUsefulWidth = 75;
            return {
                width: Math.max(column.getActualWidth(), smallestUsefulWidth),
                displayName: displayName,
                filterAllowed: filterAllowed
            };
        }
        return {
            displayName: displayName,
            filterAllowed: filterAllowed
        };
    }
    onNewHeaderColumn(rowIndex, currentCells) {
        return (column)=>{
            const nameForCol = this.extractHeaderValue(column);
            const styleIds = this.config.styleLinker({
                rowType: "HEADER",
                rowIndex: rowIndex,
                value: nameForCol,
                column: column
            });
            currentCells.push(this.createCell(this.getStyleId(styleIds), this.getDataTypeForValue("string"), nameForCol));
        };
    }
    onNewBodyColumn(rowIndex, currentCells) {
        let skipCols = 0;
        const { freezeColumns: freezeColumns, rightToLeft: rightToLeft } = this.config;
        return (column, index, node)=>{
            if (skipCols > 0) {
                skipCols -= 1;
                return;
            }
            if (!this.skipFrozenColumns) {
                const pinned = column.getPinned();
                const isPinnedLeft = pinned === true || pinned === "left";
                if (freezeColumns === "pinned" && pinned && isPinnedLeft !== rightToLeft) this.frozenColumnCount++;
                else if (typeof freezeColumns === "function" && freezeColumns((0, $jIDNV._addGridCommonParams)(this.gos, {
                    column: column
                }))) this.frozenColumnCount++;
                else this.skipFrozenColumns = true;
            }
            const { value: valueForCell, valueFormatted: valueFormatted } = this.extractRowCellValue(column, index, rowIndex, "excel", node);
            const styleIds = this.config.styleLinker({
                rowType: "BODY",
                rowIndex: rowIndex,
                value: valueForCell,
                column: column,
                node: node
            });
            const excelStyleId = this.getStyleId(styleIds);
            const colSpan = column.getColSpan(node);
            const addedImage = this.addImage(rowIndex, column, valueForCell);
            if (addedImage) currentCells.push(this.createCell(excelStyleId, this.getDataTypeForValue(addedImage.value), addedImage.value == null ? "" : addedImage.value));
            else if (colSpan > 1) {
                skipCols = colSpan - 1;
                currentCells.push(this.createMergedCell(excelStyleId, this.getDataTypeForValue(valueForCell), valueForCell, colSpan - 1));
            } else currentCells.push(this.createCell(excelStyleId, this.getDataTypeForValue(valueForCell), valueForCell, valueFormatted));
        };
    }
    onNewRow(onNewColumnAccumulator, height) {
        const currentCells = [];
        this.rows.push({
            cells: currentCells,
            height: $5b7ccabde48fae90$var$getHeightFromProperty(this.rows.length + 1, height)
        });
        return {
            onColumn: onNewColumnAccumulator.bind(this, this.rows.length, currentCells)()
        };
    }
    createExcel(data) {
        const { excelStyles: excelStyles, config: config } = this;
        if (this.frozenColumnCount) config.frozenColumnCount = this.frozenColumnCount;
        if (this.frozenRowCount) config.frozenRowCount = this.frozenRowCount;
        return $5b7ccabde48fae90$var$createXlsxExcel(excelStyles, data, config);
    }
    getDataTypeForValue(valueForCell) {
        if (valueForCell === void 0) return "empty";
        let dataType = "s";
        try {
            if (this.isNumerical(valueForCell)) dataType = "n";
        } catch (e) {}
        return dataType;
    }
    getTypeFromStyle(style, value) {
        if (this.isFormula(value)) return "f";
        if (style && style.dataType) switch(style.dataType.toLocaleLowerCase()){
            case "formula":
                return "f";
            case "string":
                return "s";
            case "number":
                return "n";
            case "datetime":
                return "d";
            case "error":
                return "e";
            case "boolean":
                return "b";
            default:
                (0, $jIDNV._warn)(162, {
                    id: style.id,
                    dataType: style.dataType
                });
        }
        return null;
    }
    addImage(rowIndex, column, value) {
        if (!this.config.addImageToCell) return;
        const addedImage = this.config.addImageToCell(rowIndex, column, value);
        if (!addedImage) return;
        $5b7ccabde48fae90$var$addXlsxBodyImageToMap(addedImage.image, rowIndex, column, this.columnsToExport, this.config.rowHeight);
        return addedImage;
    }
    createCell(styleId, type, value, valueFormatted) {
        const actualStyle = this.getStyleById(styleId);
        if (!actualStyle?.dataType && type === "s" && valueFormatted != null) value = valueFormatted;
        const processedType = this.getTypeFromStyle(actualStyle, value) || type;
        const { value: processedValue, escaped: escaped } = this.getCellValue(processedType, value);
        const styles = [];
        if (actualStyle) styles.push(styleId);
        if (escaped) styles.push("_quotePrefix");
        styleId = this.getStyleId(styles) || void 0;
        return {
            styleId: styleId,
            data: {
                type: processedType,
                value: processedValue
            }
        };
    }
    createMergedCell(styleId, type, value, numOfCells) {
        const valueToUse = value == null ? "" : value;
        return {
            styleId: this.getStyleById(styleId) ? styleId : void 0,
            data: {
                type: type,
                value: type === "s" ? $5b7ccabde48fae90$var$getXlsxStringPosition(valueToUse).toString() : value
            },
            mergeAcross: numOfCells
        };
    }
    getCellValue(type, value) {
        let escaped = false;
        if (value == null || type === "s" && value === "") return {
            value: "",
            escaped: false
        };
        if (type === "s") {
            if (value && value[0] === "'") {
                escaped = true;
                value = value.slice(1);
            }
            value = $5b7ccabde48fae90$var$getXlsxStringPosition(value).toString();
        } else if (type === "f") value = value.slice(1);
        else if (type === "n") {
            const numberValue = Number(value);
            if (isNaN(numberValue)) value = "";
            else if (value !== "") value = numberValue.toString();
        }
        return {
            value: value,
            escaped: escaped
        };
    }
    getStyleId(styleIds) {
        if (!styleIds || !styleIds.length) return null;
        if (styleIds.length === 1) return styleIds[0];
        const key = styleIds.join("-");
        if (!this.mixedStyles[key]) this.addNewMixedStyle(styleIds);
        return this.mixedStyles[key].excelID;
    }
    deepCloneObject(object) {
        return JSON.parse(JSON.stringify(object));
    }
    addNewMixedStyle(styleIds) {
        this.mixedStyleCounter += 1;
        const excelId = `mixedStyle${this.mixedStyleCounter}`;
        const resultantStyle = {};
        for (const styleId of styleIds){
            for (const excelStyle of this.excelStyles)if (excelStyle.id === styleId) (0, $jIDNV._mergeDeep)(resultantStyle, this.deepCloneObject(excelStyle));
        }
        resultantStyle.id = excelId;
        const key = styleIds.join("-");
        this.mixedStyles[key] = {
            excelID: excelId,
            key: key,
            result: resultantStyle
        };
        this.excelStyles.push(resultantStyle);
        this.stylesByIds[excelId] = resultantStyle;
    }
    isFormula(value) {
        if (value == null) return false;
        return this.config.autoConvertFormulas && value.toString().startsWith("=");
    }
    isNumerical(value) {
        if (typeof value === "bigint") return true;
        return isFinite(value) && value !== "" && !isNaN(parseFloat(value));
    }
    getStyleById(styleId) {
        if (styleId == null) return null;
        return this.stylesByIds[styleId] || null;
    }
};
// packages/ag-grid-enterprise/src/excelExport/zipContainer/compress.ts
var $5b7ccabde48fae90$var$compressBlob = async (data)=>{
    let chunksSize = 0;
    const chunks = [];
    const writeCompressedData = new WritableStream({
        write: (chunk)=>{
            chunks.push(chunk);
            chunksSize += chunk.length;
        }
    });
    const readable = new ReadableStream({
        start: (controller)=>{
            const reader = new FileReader();
            reader.onload = (e)=>{
                if (e.target?.result) controller.enqueue(e.target.result);
                controller.close();
            };
            reader.readAsArrayBuffer(data);
        }
    });
    const compressStream = new window.CompressionStream("deflate-raw");
    await readable.pipeThrough(compressStream).pipeTo(writeCompressedData);
    return {
        size: chunksSize,
        content: new Blob(chunks)
    };
};
var $5b7ccabde48fae90$var$deflateLocalFile = async (rawContent)=>{
    const contentAsBlob = new Blob([
        rawContent
    ]);
    const { size: compressedSize, content: compressedContent } = await $5b7ccabde48fae90$var$compressBlob(contentAsBlob);
    const compressedContentAsUint8Array = new Uint8Array(await compressedContent.arrayBuffer());
    return {
        size: compressedSize,
        content: compressedContentAsUint8Array
    };
};
// packages/ag-grid-enterprise/src/excelExport/zipContainer/convert.ts
var $5b7ccabde48fae90$var$convertTime = (date)=>{
    let time = date.getHours();
    time <<= 6;
    time = time | date.getMinutes();
    time <<= 5;
    time = time | date.getSeconds() / 2;
    return time;
};
var $5b7ccabde48fae90$var$convertDate = (date)=>{
    let dt = date.getFullYear() - 1980;
    dt <<= 4;
    dt = dt | date.getMonth() + 1;
    dt <<= 5;
    dt = dt | date.getDate();
    return dt;
};
function $5b7ccabde48fae90$var$convertDecToHex(number, bytes) {
    let hex = "";
    for(let i = 0; i < bytes; i++){
        hex += String.fromCharCode(number & 255);
        number >>>= 8;
    }
    return hex;
}
// packages/ag-grid-enterprise/src/excelExport/zipContainer/crcTable.ts
var $5b7ccabde48fae90$var$getCrcFromCrc32TableAndByteArray = (content)=>{
    if (!content.length) return 0;
    let crc = -1;
    let j = 0;
    let k = 0;
    let l = 0;
    for(let i = 0; i < content.length; i++){
        j = content[i];
        k = (crc ^ j) & 255;
        l = $5b7ccabde48fae90$var$crcTable[k];
        crc = crc >>> 8 ^ l;
    }
    return crc ^ -1;
};
var $5b7ccabde48fae90$var$getCrcFromCrc32Table = (content)=>{
    if (!content.length) return 0;
    if (typeof content === "string") return $5b7ccabde48fae90$var$getCrcFromCrc32TableAndByteArray(new TextEncoder().encode(content));
    return $5b7ccabde48fae90$var$getCrcFromCrc32TableAndByteArray(content);
};
var $5b7ccabde48fae90$var$crcTable = /* @__PURE__ */ new Uint32Array([
    0,
    1996959894,
    3993919788,
    2567524794,
    124634137,
    1886057615,
    3915621685,
    2657392035,
    249268274,
    2044508324,
    3772115230,
    2547177864,
    162941995,
    2125561021,
    3887607047,
    2428444049,
    498536548,
    1789927666,
    4089016648,
    2227061214,
    450548861,
    1843258603,
    4107580753,
    2211677639,
    325883990,
    1684777152,
    4251122042,
    2321926636,
    335633487,
    1661365465,
    4195302755,
    2366115317,
    997073096,
    1281953886,
    3579855332,
    2724688242,
    1006888145,
    1258607687,
    3524101629,
    2768942443,
    901097722,
    1119000684,
    3686517206,
    2898065728,
    853044451,
    1172266101,
    3705015759,
    2882616665,
    651767980,
    1373503546,
    3369554304,
    3218104598,
    565507253,
    1454621731,
    3485111705,
    3099436303,
    671266974,
    1594198024,
    3322730930,
    2970347812,
    795835527,
    1483230225,
    3244367275,
    3060149565,
    1994146192,
    31158534,
    2563907772,
    4023717930,
    1907459465,
    112637215,
    2680153253,
    3904427059,
    2013776290,
    251722036,
    2517215374,
    3775830040,
    2137656763,
    141376813,
    2439277719,
    3865271297,
    1802195444,
    476864866,
    2238001368,
    4066508878,
    1812370925,
    453092731,
    2181625025,
    4111451223,
    1706088902,
    314042704,
    2344532202,
    4240017532,
    1658658271,
    366619977,
    2362670323,
    4224994405,
    1303535960,
    984961486,
    2747007092,
    3569037538,
    1256170817,
    1037604311,
    2765210733,
    3554079995,
    1131014506,
    879679996,
    2909243462,
    3663771856,
    1141124467,
    855842277,
    2852801631,
    3708648649,
    1342533948,
    654459306,
    3188396048,
    3373015174,
    1466479909,
    544179635,
    3110523913,
    3462522015,
    1591671054,
    702138776,
    2966460450,
    3352799412,
    1504918807,
    783551873,
    3082640443,
    3233442989,
    3988292384,
    2596254646,
    62317068,
    1957810842,
    3939845945,
    2647816111,
    81470997,
    1943803523,
    3814918930,
    2489596804,
    225274430,
    2053790376,
    3826175755,
    2466906013,
    167816743,
    2097651377,
    4027552580,
    2265490386,
    503444072,
    1762050814,
    4150417245,
    2154129355,
    426522225,
    1852507879,
    4275313526,
    2312317920,
    282753626,
    1742555852,
    4189708143,
    2394877945,
    397917763,
    1622183637,
    3604390888,
    2714866558,
    953729732,
    1340076626,
    3518719985,
    2797360999,
    1068828381,
    1219638859,
    3624741850,
    2936675148,
    906185462,
    1090812512,
    3747672003,
    2825379669,
    829329135,
    1181335161,
    3412177804,
    3160834842,
    628085408,
    1382605366,
    3423369109,
    3138078467,
    570562233,
    1426400815,
    3317316542,
    2998733608,
    733239954,
    1555261956,
    3268935591,
    3050360625,
    752459403,
    1541320221,
    2607071920,
    3965973030,
    1969922972,
    40735498,
    2617837225,
    3943577151,
    1913087877,
    83908371,
    2512341634,
    3803740692,
    2075208622,
    213261112,
    2463272603,
    3855990285,
    2094854071,
    198958881,
    2262029012,
    4057260610,
    1759359992,
    534414190,
    2176718541,
    4139329115,
    1873836001,
    414664567,
    2282248934,
    4279200368,
    1711684554,
    285281116,
    2405801727,
    4167216745,
    1634467795,
    376229701,
    2685067896,
    3608007406,
    1308918612,
    956543938,
    2808555105,
    3495958263,
    1231636301,
    1047427035,
    2932959818,
    3654703836,
    1088359270,
    936918e3,
    2847714899,
    3736837829,
    1202900863,
    817233897,
    3183342108,
    3401237130,
    1404277552,
    615818150,
    3134207493,
    3453421203,
    1423857449,
    601450431,
    3009837614,
    3294710456,
    1567103746,
    711928724,
    3020668471,
    3272380065,
    1510334235,
    755167117
]);
// packages/ag-grid-enterprise/src/excelExport/zipContainer/zipContainerHelper.ts
function $5b7ccabde48fae90$var$_utf8_encode(s) {
    const stringFromCharCode = String.fromCharCode;
    function ucs2decode(string) {
        const output = [];
        if (!string) return [];
        const len = string.length;
        let counter = 0;
        let value;
        let extra;
        while(counter < len){
            value = string.charCodeAt(counter++);
            if (value >= 55296 && value <= 56319 && counter < len) {
                extra = string.charCodeAt(counter++);
                if ((extra & 64512) == 56320) output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
                else {
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    function checkScalarValue(point) {
        if (point >= 55296 && point <= 57343) throw Error((0, $jIDNV._errMsg)(255, {
            point: point
        }));
    }
    function createByte(point, shift) {
        return stringFromCharCode(point >> shift & 63 | 128);
    }
    function encodeCodePoint(point) {
        if ((point & 4294967168) == 0) return stringFromCharCode(point);
        let symbol = "";
        if ((point & 4294965248) == 0) symbol = stringFromCharCode(point >> 6 & 31 | 192);
        else if ((point & 4294901760) == 0) {
            checkScalarValue(point);
            symbol = stringFromCharCode(point >> 12 & 15 | 224);
            symbol += createByte(point, 6);
        } else if ((point & 4292870144) == 0) {
            symbol = stringFromCharCode(point >> 18 & 7 | 240);
            symbol += createByte(point, 12);
            symbol += createByte(point, 6);
        }
        symbol += stringFromCharCode(point & 63 | 128);
        return symbol;
    }
    const codePoints = ucs2decode(s);
    const length = codePoints.length;
    let index = -1;
    let codePoint;
    let byteString = "";
    while(++index < length){
        codePoint = codePoints[index];
        byteString += encodeCodePoint(codePoint);
    }
    return byteString;
}
var $5b7ccabde48fae90$var$getHeaders = (currentFile, isCompressed, offset, rawSize, rawContent, deflatedSize)=>{
    const { content: content, path: path, created: creationDate } = currentFile;
    const time = $5b7ccabde48fae90$var$convertTime(creationDate);
    const dt = $5b7ccabde48fae90$var$convertDate(creationDate);
    const crcFlag = $5b7ccabde48fae90$var$getCrcFromCrc32Table(rawContent);
    const zipSize = deflatedSize !== void 0 ? deflatedSize : rawSize;
    const utfPath = $5b7ccabde48fae90$var$_utf8_encode(path);
    const isUTF8 = utfPath !== path;
    let extraFields = "";
    if (isUTF8) {
        const uExtraFieldPath = $5b7ccabde48fae90$var$convertDecToHex(1, 1) + $5b7ccabde48fae90$var$convertDecToHex($5b7ccabde48fae90$var$getCrcFromCrc32Table(utfPath), 4) + utfPath;
        extraFields = "up" + $5b7ccabde48fae90$var$convertDecToHex(uExtraFieldPath.length, 2) + uExtraFieldPath;
    }
    const commonHeader = "\x14\0" + // version needed to extract
    (isUTF8 ? "\0\b" : "\0\0") + // Language encoding flag (EFS) (12th bit turned on)
    $5b7ccabde48fae90$var$convertDecToHex(isCompressed ? 8 : 0, 2) + // As per ECMA-376 Part 2 specs
    $5b7ccabde48fae90$var$convertDecToHex(time, 2) + // last modified time
    $5b7ccabde48fae90$var$convertDecToHex(dt, 2) + // last modified date
    $5b7ccabde48fae90$var$convertDecToHex(zipSize ? crcFlag : 0, 4) + $5b7ccabde48fae90$var$convertDecToHex(deflatedSize ?? rawSize, 4) + // compressed size
    $5b7ccabde48fae90$var$convertDecToHex(rawSize, 4) + // uncompressed size
    $5b7ccabde48fae90$var$convertDecToHex(utfPath.length, 2) + // file name length
    $5b7ccabde48fae90$var$convertDecToHex(extraFields.length, 2);
    const localFileHeader = "PK\x03\x04" + commonHeader + utfPath + extraFields;
    const centralDirectoryHeader = "PK\x01\x02\x14\0" + commonHeader + // file header
    "\0\0\0\0\0\0" + (content ? "\0\0\0\0" : "\x10\0\0\0") + // external file attributes
    $5b7ccabde48fae90$var$convertDecToHex(offset, 4) + // relative offset of local header
    utfPath + // file name
    extraFields;
    return {
        localFileHeader: Uint8Array.from(localFileHeader, (c)=>c.charCodeAt(0)),
        centralDirectoryHeader: Uint8Array.from(centralDirectoryHeader, (c)=>c.charCodeAt(0))
    };
};
var $5b7ccabde48fae90$var$getDecodedContent = (content)=>{
    let contentToUse;
    if (typeof content === "string") {
        const base64String = atob(content.split(";base64,")[1]);
        contentToUse = Uint8Array.from(base64String, (c)=>c.charCodeAt(0));
    } else contentToUse = content;
    return {
        size: contentToUse.length,
        content: contentToUse
    };
};
var $5b7ccabde48fae90$var$getDeflatedHeaderAndContent = async (currentFile, offset)=>{
    const { content: content } = currentFile;
    const { size: size, content: rawContent } = !content ? {
        size: 0,
        content: Uint8Array.from([])
    } : $5b7ccabde48fae90$var$getDecodedContent(content);
    let deflatedContent = void 0;
    let deflatedSize = void 0;
    let deflationPerformed = false;
    const shouldDeflate = currentFile.type === "file" && rawContent && size > 0;
    if (shouldDeflate) {
        const result = await $5b7ccabde48fae90$var$deflateLocalFile(rawContent);
        deflatedContent = result.content;
        deflatedSize = result.size;
        deflationPerformed = true;
    }
    const headers = $5b7ccabde48fae90$var$getHeaders(currentFile, deflationPerformed, offset, size, rawContent, deflatedSize);
    return {
        ...headers,
        content: deflatedContent || rawContent,
        isCompressed: deflationPerformed
    };
};
var $5b7ccabde48fae90$var$getHeaderAndContent = (currentFile, offset)=>{
    const { content: content } = currentFile;
    const { content: rawContent } = !content ? {
        content: Uint8Array.from([])
    } : $5b7ccabde48fae90$var$getDecodedContent(content);
    const headers = $5b7ccabde48fae90$var$getHeaders(currentFile, false, offset, rawContent.length, rawContent, void 0);
    return {
        ...headers,
        content: rawContent,
        isCompressed: false
    };
};
var $5b7ccabde48fae90$var$buildCentralDirectoryEnd = (tLen, cLen, lLen)=>{
    const str = "PK\x05\x06\0\0\0\0" + $5b7ccabde48fae90$var$convertDecToHex(tLen, 2) + // total number of entries in the central folder
    $5b7ccabde48fae90$var$convertDecToHex(tLen, 2) + // total number of entries in the central folder
    $5b7ccabde48fae90$var$convertDecToHex(cLen, 4) + // size of the central folder
    $5b7ccabde48fae90$var$convertDecToHex(lLen, 4) + // central folder start offset
    "\0\0";
    return Uint8Array.from(str, (c)=>c.charCodeAt(0));
};
// packages/ag-grid-enterprise/src/excelExport/zipContainer/zipContainer.ts
var $5b7ccabde48fae90$var$ZipContainer = class {
    constructor(){
        this.folders = [];
        this.files = [];
    }
    addFolders(paths) {
        paths.forEach(this.addFolder.bind(this));
    }
    addFolder(path) {
        this.folders.push({
            path: path,
            created: /* @__PURE__ */ new Date(),
            isBase64: false,
            type: "folder"
        });
    }
    addFile(path, content, isBase64 = false) {
        this.files.push({
            path: path,
            created: /* @__PURE__ */ new Date(),
            content: isBase64 ? content : new TextEncoder().encode(content),
            isBase64: isBase64,
            type: "file"
        });
    }
    async getZipFile(mimeType = "application/zip") {
        const textOutput = await this.buildCompressedFileStream();
        this.clearStream();
        return new Blob([
            textOutput
        ], {
            type: mimeType
        });
    }
    getUncompressedZipFile(mimeType = "application/zip") {
        const textOutput = this.buildFileStream();
        this.clearStream();
        return new Blob([
            textOutput
        ], {
            type: mimeType
        });
    }
    clearStream() {
        this.folders = [];
        this.files = [];
    }
    packageFiles(files) {
        let fileLen = 0;
        let folderLen = 0;
        for (const currentFile of files){
            const { localFileHeader: localFileHeader, centralDirectoryHeader: centralDirectoryHeader, content: content } = currentFile;
            fileLen += localFileHeader.length + content.length;
            folderLen += centralDirectoryHeader.length;
        }
        const fileData = new Uint8Array(fileLen);
        const folderData = new Uint8Array(folderLen);
        let fileOffset = 0;
        let folderOffset = 0;
        for (const currentFile of files){
            const { localFileHeader: localFileHeader, centralDirectoryHeader: centralDirectoryHeader, content: content } = currentFile;
            fileData.set(localFileHeader, fileOffset);
            fileOffset += localFileHeader.length;
            fileData.set(content, fileOffset);
            fileOffset += content.length;
            folderData.set(centralDirectoryHeader, folderOffset);
            folderOffset += centralDirectoryHeader.length;
        }
        const folderEnd = $5b7ccabde48fae90$var$buildCentralDirectoryEnd(files.length, folderLen, fileLen);
        const result = new Uint8Array(fileData.length + folderData.length + folderEnd.length);
        result.set(fileData);
        result.set(folderData, fileData.length);
        result.set(folderEnd, fileData.length + folderData.length);
        return result;
    }
    async buildCompressedFileStream() {
        const totalFiles = [
            ...this.folders,
            ...this.files
        ];
        const readyFiles = [];
        let lL = 0;
        for (const currentFile of totalFiles){
            const output = await $5b7ccabde48fae90$var$getDeflatedHeaderAndContent(currentFile, lL);
            const { localFileHeader: localFileHeader, content: content } = output;
            readyFiles.push(output);
            lL += localFileHeader.length + content.length;
        }
        return this.packageFiles(readyFiles);
    }
    buildFileStream() {
        const totalFiles = [
            ...this.folders,
            ...this.files
        ];
        const readyFiles = [];
        let lL = 0;
        for (const currentFile of totalFiles){
            const readyFile = $5b7ccabde48fae90$var$getHeaderAndContent(currentFile, lL);
            const { localFileHeader: localFileHeader, content: content } = readyFile;
            readyFiles.push(readyFile);
            lL += localFileHeader.length + content.length;
        }
        return this.packageFiles(readyFiles);
    }
};
// packages/ag-grid-enterprise/src/excelExport/excelCreator.ts
var $5b7ccabde48fae90$var$createExcelXMLCoreFolderStructure = (zipContainer)=>{
    zipContainer.addFolders([
        "_rels/",
        "docProps/",
        "xl/",
        "xl/theme/",
        "xl/_rels/",
        "xl/worksheets/"
    ]);
    if (!$5b7ccabde48fae90$var$XLSX_IMAGES.size) return;
    zipContainer.addFolders([
        "xl/worksheets/_rels",
        "xl/drawings/",
        "xl/drawings/_rels",
        "xl/media/"
    ]);
    let imgCounter = 0;
    $5b7ccabde48fae90$var$XLSX_IMAGES.forEach((value)=>{
        const firstImage = value[0].image[0];
        const { base64: base64, imageType: imageType } = firstImage;
        zipContainer.addFile(`xl/media/image${++imgCounter}.${$5b7ccabde48fae90$var$_normaliseImageExtension(imageType)}`, base64, true);
    });
};
var $5b7ccabde48fae90$var$createExcelXmlWorksheets = (zipContainer, data)=>{
    let imageRelationCounter = 0;
    let headerFooterImageCounter = 0;
    for(let i = 0; i < data.length; i++){
        const value = data[i];
        zipContainer.addFile(`xl/worksheets/sheet${i + 1}.xml`, value, false);
        const hasImages = $5b7ccabde48fae90$var$XLSX_IMAGES.size > 0 && $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGES.has(i);
        const tableData = $5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES.size > 0 && $5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES.get(i);
        const hasHeaderFooterImages = $5b7ccabde48fae90$var$XLSX_IMAGES.size && $5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES.has(i);
        if (!hasImages && !tableData && !hasHeaderFooterImages) continue;
        let tableName;
        let drawingIndex;
        let vmlDrawingIndex;
        if (hasImages) {
            $5b7ccabde48fae90$var$createExcelXmlDrawings(zipContainer, i, imageRelationCounter);
            drawingIndex = imageRelationCounter;
            imageRelationCounter++;
        }
        if (hasHeaderFooterImages) {
            $5b7ccabde48fae90$var$createExcelVmlDrawings(zipContainer, i, headerFooterImageCounter);
            vmlDrawingIndex = headerFooterImageCounter;
            headerFooterImageCounter++;
        }
        if (tableData) tableName = tableData.name;
        const worksheetRelFile = `xl/worksheets/_rels/sheet${i + 1}.xml.rels`;
        zipContainer.addFile(worksheetRelFile, $5b7ccabde48fae90$var$createXlsxRelationships({
            tableName: tableName,
            drawingIndex: drawingIndex,
            vmlDrawingIndex: vmlDrawingIndex
        }));
    }
};
var $5b7ccabde48fae90$var$createExcelXmlDrawings = (zipContainer, sheetIndex, drawingIndex)=>{
    const drawingFolder = "xl/drawings";
    const drawingFileName = `${drawingFolder}/drawing${drawingIndex + 1}.xml`;
    const relFileName = `${drawingFolder}/_rels/drawing${drawingIndex + 1}.xml.rels`;
    zipContainer.addFile(relFileName, $5b7ccabde48fae90$var$createXlsxDrawingRel(sheetIndex));
    zipContainer.addFile(drawingFileName, $5b7ccabde48fae90$var$createXlsxDrawing(sheetIndex));
};
var $5b7ccabde48fae90$var$createExcelVmlDrawings = (zipContainer, sheetIndex, drawingIndex)=>{
    const drawingFolder = "xl/drawings";
    const drawingFileName = `${drawingFolder}/vmlDrawing${drawingIndex + 1}.vml`;
    const relFileName = `${drawingFolder}/_rels/vmlDrawing${drawingIndex + 1}.vml.rels`;
    zipContainer.addFile(drawingFileName, $5b7ccabde48fae90$var$createXlsxVmlDrawing(sheetIndex));
    zipContainer.addFile(relFileName, $5b7ccabde48fae90$var$createXlsxVmlDrawingRel(sheetIndex));
};
var $5b7ccabde48fae90$var$createExcelXmlTables = (zipContainer)=>{
    const tablesDataByWorksheet = $5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES;
    const worksheetKeys = Array.from(tablesDataByWorksheet.keys());
    for(let i = 0; i < worksheetKeys.length; i++){
        const sheetIndex = worksheetKeys[i];
        const table = tablesDataByWorksheet.get(sheetIndex);
        if (!table) continue;
        zipContainer.addFile(`xl/tables/${table.name}.xml`, $5b7ccabde48fae90$var$createXlsxTable(table, i));
    }
};
var $5b7ccabde48fae90$var$createExcelXmlCoreSheets = (zipContainer, fontSize, author, sheetLen, activeTab)=>{
    zipContainer.addFile("xl/workbook.xml", $5b7ccabde48fae90$var$createXlsxWorkbook(activeTab));
    zipContainer.addFile("xl/styles.xml", $5b7ccabde48fae90$var$createXlsxStylesheet(fontSize));
    zipContainer.addFile("xl/sharedStrings.xml", $5b7ccabde48fae90$var$createXlsxSharedStrings());
    zipContainer.addFile("xl/theme/theme1.xml", $5b7ccabde48fae90$var$createXlsxTheme());
    zipContainer.addFile("xl/_rels/workbook.xml.rels", $5b7ccabde48fae90$var$createXlsxWorkbookRels(sheetLen));
    zipContainer.addFile("docProps/core.xml", $5b7ccabde48fae90$var$createXlsxCore(author));
    zipContainer.addFile("[Content_Types].xml", $5b7ccabde48fae90$var$createXlsxContentTypes(sheetLen));
    zipContainer.addFile("_rels/.rels", $5b7ccabde48fae90$var$createXlsxRels());
};
var $5b7ccabde48fae90$var$createExcelFileForExcel = (zipContainer, data, options = {})=>{
    if (!data || data.length === 0) {
        (0, $jIDNV._warn)(159);
        $5b7ccabde48fae90$var$resetXlsxFactory();
        return false;
    }
    const { fontSize: fontSize = 11, author: author = "AG Grid", activeTab: activeTab = 0 } = options;
    const len = data.length;
    const activeTabWithinBounds = Math.max(Math.min(activeTab, len - 1), 0);
    $5b7ccabde48fae90$var$createExcelXMLCoreFolderStructure(zipContainer);
    $5b7ccabde48fae90$var$createExcelXmlTables(zipContainer);
    $5b7ccabde48fae90$var$createExcelXmlWorksheets(zipContainer, data);
    $5b7ccabde48fae90$var$createExcelXmlCoreSheets(zipContainer, fontSize, author, len, activeTabWithinBounds);
    $5b7ccabde48fae90$var$resetXlsxFactory();
    return true;
};
var $5b7ccabde48fae90$var$getMultipleSheetsAsExcelCompressed = (params)=>{
    const { data: data, fontSize: fontSize, author: author, activeSheetIndex: activeSheetIndex } = params;
    const mimeType = params.mimeType || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const zipContainer = new $5b7ccabde48fae90$var$ZipContainer();
    if (!$5b7ccabde48fae90$var$createExcelFileForExcel(zipContainer, data, {
        author: author,
        fontSize: fontSize,
        activeTab: activeSheetIndex
    })) return Promise.resolve(void 0);
    return zipContainer.getZipFile(mimeType);
};
var $5b7ccabde48fae90$export$cdca9ad0c864c7f0 = (params)=>{
    const { data: data, fontSize: fontSize, author: author, activeSheetIndex: activeSheetIndex } = params;
    const mimeType = params.mimeType || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const zipContainer = new $5b7ccabde48fae90$var$ZipContainer();
    if (!$5b7ccabde48fae90$var$createExcelFileForExcel(zipContainer, data, {
        author: author,
        fontSize: fontSize,
        activeTab: activeSheetIndex
    })) return;
    return zipContainer.getUncompressedZipFile(mimeType);
};
var $5b7ccabde48fae90$export$e871bbb2307806ee = (params)=>{
    const { fileName: fileName = "export.xlsx" } = params;
    $5b7ccabde48fae90$var$getMultipleSheetsAsExcelCompressed(params).then((contents)=>{
        if (contents) {
            const downloadFileName = typeof fileName === "function" ? fileName() : fileName;
            (0, $jIDNV._downloadFile)(downloadFileName, contents);
        }
    });
};
var $5b7ccabde48fae90$var$ExcelCreator = class extends (0, $jIDNV.BaseCreator) {
    constructor(){
        super(...arguments);
        this.beanName = "excelCreator";
    }
    getMergedParams(params) {
        const baseParams = this.gos.get("defaultExcelExportParams");
        return Object.assign({}, baseParams, params);
    }
    export(userParams) {
        if (this.isExportSuppressed()) {
            (0, $jIDNV._warn)(160);
            return;
        }
        const mergedParams = this.getMergedParams(userParams);
        const data = this.getData(mergedParams);
        const exportParams = {
            data: [
                data
            ],
            fontSize: mergedParams.fontSize,
            author: mergedParams.author,
            mimeType: mergedParams.mimeType
        };
        this.packageCompressedFile(exportParams).then((packageFile)=>{
            if (packageFile) {
                const { fileName: fileName } = mergedParams;
                const providedFileName = typeof fileName === "function" ? fileName((0, $jIDNV._addGridCommonParams)(this.gos, {})) : fileName;
                (0, $jIDNV._downloadFile)(this.getFileName(providedFileName), packageFile);
            }
        });
    }
    exportDataAsExcel(params) {
        this.export(params);
    }
    getDataAsExcel(params) {
        const mergedParams = this.getMergedParams(params);
        const data = this.getData(mergedParams);
        const exportParams = {
            data: [
                data
            ],
            fontSize: mergedParams.fontSize,
            author: mergedParams.author,
            mimeType: mergedParams.mimeType
        };
        return this.packageFile(exportParams);
    }
    setFactoryMode(factoryMode) {
        $5b7ccabde48fae90$var$setXlsxFactoryMode(factoryMode);
    }
    getFactoryMode() {
        return $5b7ccabde48fae90$var$getXlsxFactoryMode();
    }
    getSheetDataForExcel(params) {
        const mergedParams = this.getMergedParams(params);
        return this.getData(mergedParams);
    }
    getMultipleSheetsAsExcel(params) {
        return $5b7ccabde48fae90$export$cdca9ad0c864c7f0(params);
    }
    exportMultipleSheetsAsExcel(params) {
        $5b7ccabde48fae90$export$e871bbb2307806ee(params);
    }
    getDefaultFileExtension() {
        return "xlsx";
    }
    createSerializingSession(params) {
        const { colModel: colModel, colNames: colNames, rowGroupColsSvc: rowGroupColsSvc, valueSvc: valueSvc, gos: gos } = this.beans;
        const config = {
            ...params,
            colModel: colModel,
            colNames: colNames,
            rowGroupColsSvc: rowGroupColsSvc,
            valueSvc: valueSvc,
            gos: gos,
            suppressRowOutline: params.suppressRowOutline || params.skipRowGroups,
            headerRowHeight: params.headerRowHeight || params.rowHeight,
            baseExcelStyles: gos.get("excelStyles") || [],
            rightToLeft: params.rightToLeft ?? gos.get("enableRtl"),
            styleLinker: this.styleLinker.bind(this)
        };
        return new $5b7ccabde48fae90$var$ExcelSerializingSession(config);
    }
    styleLinker(params) {
        const { rowType: rowType, rowIndex: rowIndex, value: value, column: column, columnGroup: columnGroup, node: node } = params;
        const isHeader = rowType === "HEADER";
        const isGroupHeader = rowType === "HEADER_GROUPING";
        const col = isHeader ? column : columnGroup;
        let headerClasses = [];
        const { gos: gos, cellStyles: cellStyles } = this.beans;
        if (isHeader || isGroupHeader) {
            headerClasses.push("header");
            if (isGroupHeader) headerClasses.push("headerGroup");
            if (col) headerClasses = headerClasses.concat((0, $jIDNV._getHeaderClassesFromColDef)(col.getDefinition(), gos, column || null, columnGroup || null));
            return headerClasses;
        }
        const styles = gos.get("excelStyles");
        const applicableStyles = [
            "cell"
        ];
        if (!styles || !styles.length) return applicableStyles;
        const styleIds = styles.map((it)=>{
            return it.id;
        });
        const colDef = column.getDefinition();
        cellStyles?.processAllCellClasses(colDef, (0, $jIDNV._addGridCommonParams)(gos, {
            value: value,
            data: node.data,
            node: node,
            colDef: colDef,
            column: column,
            rowIndex: rowIndex
        }), (className)=>{
            if (styleIds.indexOf(className) > -1) applicableStyles.push(className);
        });
        return applicableStyles.sort((left, right)=>{
            return styleIds.indexOf(left) < styleIds.indexOf(right) ? -1 : 1;
        });
    }
    isExportSuppressed() {
        return this.gos.get("suppressExcelExport");
    }
    packageCompressedFile(params) {
        return $5b7ccabde48fae90$var$getMultipleSheetsAsExcelCompressed(params);
    }
    packageFile(params) {
        return $5b7ccabde48fae90$export$cdca9ad0c864c7f0(params);
    }
};
// packages/ag-grid-enterprise/src/version.ts
var $5b7ccabde48fae90$var$VERSION = "34.1.2";
// packages/ag-grid-enterprise/src/agGridEnterpriseModule.ts
var $5b7ccabde48fae90$var$EnterpriseCoreModule = {
    moduleName: "EnterpriseCore",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$export$91e2bbffdbb3852c
    ],
    icons: {
        // accordion open (filter tool panel group, charts group)
        accordionOpen: "tree-open",
        // accordion closed (filter tool panel group, charts group)
        accordionClosed: "tree-closed",
        // accordion indeterminate - shown when some children are expanded and
        //     others are collapsed (filter tool panel group, charts group)
        accordionIndeterminate: "tree-indeterminate",
        // dialog title bar
        close: "cross",
        // X (remove) on column 'pill' after adding it to a drop zone list
        cancel: "cancel",
        // button in chart regular size window title bar (click to maximise)
        maximize: "maximize",
        // button in chart maximised window title bar (click to make regular size)
        minimize: "minimize",
        // drag handle used to pick up draggable columns
        columnDrag: "grip"
    },
    dependsOn: []
};
// packages/ag-grid-enterprise/src/advancedFilter/advanced-filter.css-GENERATED.ts
var $5b7ccabde48fae90$var$advancedFilterCSS = /*css*/ `.ag-advanced-filter-header{align-items:center;background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);display:flex;position:relative}.ag-advanced-filter{align-items:center;display:flex;width:100%}.ag-advanced-filter-buttons{display:contents}.ag-advanced-filter-header-cell{height:100%;padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding)}.ag-advanced-filter-apply-button,.ag-advanced-filter-builder-button{align-items:center;background-color:unset;border:0;display:flex;font-size:var(--ag-font-size);font-weight:600;line-height:normal;padding:var(--ag-spacing);white-space:nowrap;&:where(:not(:disabled)){cursor:pointer;&:hover{background-color:var(--ag-row-hover-color)}}}:where(.ag-ltr) .ag-advanced-filter-apply-button,:where(.ag-ltr) .ag-advanced-filter-builder-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-advanced-filter-apply-button,:where(.ag-rtl) .ag-advanced-filter-builder-button{margin-right:calc(var(--ag-spacing)*2)}:where(.ag-ltr) .ag-advanced-filter-builder-button-label{margin-left:var(--ag-spacing)}:where(.ag-rtl) .ag-advanced-filter-builder-button-label{margin-right:var(--ag-spacing)}.ag-advanced-filter-builder{display:flex;flex-direction:column;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:100%}.ag-advanced-filter-builder-list{flex:1;overflow:auto}.ag-advanced-filter-builder-button-panel{border-top:var(--ag-advanced-filter-builder-button-bar-border);display:flex;justify-content:flex-end;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}:where(.ag-ltr) .ag-advanced-filter-builder-apply-button,:where(.ag-ltr) .ag-advanced-filter-builder-cancel-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-advanced-filter-builder-apply-button,:where(.ag-rtl) .ag-advanced-filter-builder-cancel-button{margin-right:calc(var(--ag-spacing)*2)}.ag-advanced-filter-builder-item-wrapper{align-items:center;display:flex;flex:1 1 auto;justify-content:space-between;overflow:hidden}:where(.ag-ltr) .ag-advanced-filter-builder-item-wrapper{padding-left:calc(var(--ag-icon-size)/2);padding-right:var(--ag-icon-size)}:where(.ag-rtl) .ag-advanced-filter-builder-item-wrapper{padding-left:var(--ag-icon-size);padding-right:calc(var(--ag-icon-size)/2)}:where(.ag-virtual-list-viewport .ag-advanced-filter-builder-item-wrapper) .ag-tab-guard{position:absolute}.ag-advanced-filter-builder-item-tree-lines>*{width:var(--ag-advanced-filter-builder-indent-size)}.ag-advanced-filter-builder-item-tree-line-root{width:var(--ag-icon-size);&:before{height:50%;top:50%}}.ag-advanced-filter-builder-item-tree-line-horizontal,.ag-advanced-filter-builder-item-tree-line-vertical,.ag-advanced-filter-builder-item-tree-line-vertical-bottom,.ag-advanced-filter-builder-item-tree-line-vertical-top{align-items:center;display:flex;height:100%;position:relative;&:after,&:before{content:"";height:100%;position:absolute}}.ag-advanced-filter-builder-item-tree-line-horizontal:after{border-bottom:var(--ag-border-width) solid var(--ag-border-color);height:50%;top:0;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size))}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-horizontal:after{left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-horizontal:after{right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-tree-line-vertical:before{top:0;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size)/2)}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-vertical:before{border-left:var(--ag-border-width) solid var(--ag-border-color);left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-vertical:before{border-right:var(--ag-border-width) solid var(--ag-border-color);right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-tree-line-vertical-top:before{height:50%;top:0;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size)/2)}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-vertical-top:before{border-left:var(--ag-border-width) solid var(--ag-border-color);left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-vertical-top:before{border-right:var(--ag-border-width) solid var(--ag-border-color);right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{height:calc(50% - var(--ag-icon-size)*1.5/2);top:calc(50% + var(--ag-icon-size)*1.5/2);width:calc(var(--ag-icon-size)/2)}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{border-left:var(--ag-border-width) solid var(--ag-border-color);left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{border-right:var(--ag-border-width) solid var(--ag-border-color);right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-condition{padding-bottom:var(--ag-spacing);padding-top:var(--ag-spacing)}.ag-advanced-filter-builder-item,.ag-advanced-filter-builder-item-buttons,.ag-advanced-filter-builder-item-condition,.ag-advanced-filter-builder-item-tree-lines,.ag-advanced-filter-builder-pill,.ag-advanced-filter-builder-pill-wrapper{align-items:center;display:flex;height:100%}.ag-advanced-filter-builder-pill-wrapper{margin:0 var(--ag-spacing)}.ag-advanced-filter-builder-pill{border-radius:var(--ag-border-radius);min-height:calc(100% - var(--ag-spacing)*3);min-width:calc(var(--ag-spacing)*2);padding:var(--ag-spacing) calc(var(--ag-spacing)*2);position:relative}:where(.ag-advanced-filter-builder-pill){.ag-advanced-filter-builder-value-number{font-family:monospace;font-weight:700}.ag-advanced-filter-builder-value-empty{color:var(--ag-subtle-text-color)}}:where(.ag-ltr) :where(.ag-advanced-filter-builder-pill){.ag-picker-field-display{margin-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-advanced-filter-builder-pill){.ag-picker-field-display{margin-left:var(--ag-spacing)}}.ag-advanced-filter-builder-pill-display{font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-advanced-filter-builder-join-pill{background-color:var(--ag-advanced-filter-builder-join-pill-color);cursor:pointer}.ag-advanced-filter-builder-column-pill{background-color:var(--ag-advanced-filter-builder-column-pill-color);cursor:pointer}.ag-advanced-filter-builder-option-pill{background-color:var(--ag-advanced-filter-builder-option-pill-color);cursor:pointer}.ag-advanced-filter-builder-value-pill{background-color:var(--ag-advanced-filter-builder-value-pill-color);cursor:text;max-width:140px;:where(.ag-advanced-filter-builder-pill-display){display:block}}.ag-advanced-filter-builder-item-buttons>*{margin:0 calc(var(--ag-spacing)*.5)}.ag-advanced-filter-builder-item-button{color:var(--ag-subtle-text-color);cursor:pointer;position:relative}.ag-advanced-filter-builder-item-button,.ag-advanced-filter-builder-pill{&:focus-visible{box-shadow:var(--ag-focus-shadow)}}.ag-advanced-filter-builder-item-button-disabled{cursor:default;opacity:.5}.ag-advanced-filter-builder-virtual-list-container{top:var(--ag-spacing)}.ag-advanced-filter-builder-virtual-list-item{cursor:default;display:flex;height:var(--ag-list-item-height);&:hover{background-color:var(--ag-row-hover-color);:where(.ag-advanced-filter-builder-item-button){opacity:1}}}.ag-advanced-filter-builder-invalid{color:var(--ag-subtle-text-color);cursor:default;margin:0 var(--ag-spacing)}:where(.ag-advanced-filter-builder-validation) .ag-advanced-filter-builder-invalid{color:var(--ag-invalid-color)}:where(.ag-advanced-filter-builder-virtual-list-item-highlight) .ag-advanced-filter-builder-item-button:focus-visible{opacity:1}`;
// packages/ag-grid-enterprise/src/advancedFilter/advancedFilterApi.ts
function $5b7ccabde48fae90$var$getAdvancedFilterModel(beans) {
    return beans.filterManager?.getAdvFilterModel() ?? null;
}
function $5b7ccabde48fae90$var$setAdvancedFilterModel(beans, advancedFilterModel) {
    beans.filterManager?.setAdvFilterModel(advancedFilterModel);
}
function $5b7ccabde48fae90$var$showAdvancedFilterBuilder(beans) {
    beans.filterManager?.toggleAdvFilterBuilder(true, "api");
}
function $5b7ccabde48fae90$var$hideAdvancedFilterBuilder(beans) {
    beans.filterManager?.toggleAdvFilterBuilder(false, "api");
}
// packages/ag-grid-enterprise/src/advancedFilter/advancedFilterLocaleText.ts
var $5b7ccabde48fae90$var$ADVANCED_FILTER_LOCALE_TEXT = {
    ariaAdvancedFilterBuilderItem: (variableValues)=>`${variableValues[0]}. Level ${variableValues[1]}. Press ENTER to edit`,
    ariaAdvancedFilterBuilderItemValidation: (variableValues)=>`${variableValues[0]}. Level ${variableValues[1]}. ${variableValues[2]} Press ENTER to edit`,
    ariaAdvancedFilterBuilderList: "Advanced Filter Builder List",
    ariaAdvancedFilterBuilderFilterItem: "Filter Condition",
    ariaAdvancedFilterBuilderGroupItem: "Filter Group",
    ariaAdvancedFilterBuilderColumn: "Column",
    ariaAdvancedFilterBuilderOption: "Option",
    ariaAdvancedFilterBuilderValue: "Value",
    ariaAdvancedFilterBuilderJoinOperator: "Join Operator",
    ariaAdvancedFilterInput: "Advanced Filter Input",
    ariaLabelAdvancedFilterAutocomplete: "Advanced Filter Autocomplete",
    advancedFilterContains: "contains",
    advancedFilterNotContains: "does not contain",
    advancedFilterTextEquals: "equals",
    advancedFilterTextNotEqual: "does not equal",
    advancedFilterStartsWith: "begins with",
    advancedFilterEndsWith: "ends with",
    advancedFilterBlank: "is blank",
    advancedFilterNotBlank: "is not blank",
    advancedFilterEquals: "=",
    advancedFilterNotEqual: "!=",
    advancedFilterGreaterThan: ">",
    advancedFilterGreaterThanOrEqual: ">=",
    advancedFilterLessThan: "<",
    advancedFilterLessThanOrEqual: "<=",
    advancedFilterTrue: "is true",
    advancedFilterFalse: "is false",
    advancedFilterAnd: "AND",
    advancedFilterOr: "OR",
    advancedFilterApply: "Apply",
    advancedFilterReset: "Reset",
    advancedFilterCancel: "Cancel",
    advancedFilterClear: "Clear",
    advancedFilterBuilder: "Builder",
    advancedFilterValidationMissingColumn: "Column is missing",
    advancedFilterValidationMissingOption: "Option is missing",
    advancedFilterValidationMissingValue: "Value is missing",
    advancedFilterValidationInvalidColumn: "Column not found",
    advancedFilterValidationInvalidOption: "Option not found",
    advancedFilterValidationMissingQuote: "Value is missing an end quote",
    advancedFilterValidationNotANumber: "Value is not a number",
    advancedFilterValidationInvalidDate: "Value is not a valid date",
    advancedFilterValidationMissingCondition: "Condition is missing",
    advancedFilterValidationJoinOperatorMismatch: "Join operators within a condition must be the same",
    advancedFilterValidationInvalidJoinOperator: "Join operator not found",
    advancedFilterValidationMissingEndBracket: "Missing end bracket",
    advancedFilterValidationExtraEndBracket: "Too many end brackets",
    advancedFilterValidationMessage: (variableValues)=>`Expression has an error. ${variableValues[0]} - ${variableValues[1]}.`,
    advancedFilterValidationMessageAtEnd: (variableValues)=>`Expression has an error. ${variableValues[0]} at end of expression.`,
    advancedFilterBuilderTitle: "Advanced Filter",
    advancedFilterBuilderApply: "Apply",
    advancedFilterBuilderCancel: "Cancel",
    advancedFilterBuilderClear: "Clear",
    advancedFilterBuilderReset: "Reset",
    advancedFilterBuilderAddButtonTooltip: "Add Filter or Group",
    advancedFilterBuilderRemoveButtonTooltip: "Remove",
    advancedFilterBuilderMoveUpButtonTooltip: "Move Up",
    advancedFilterBuilderMoveDownButtonTooltip: "Move Down",
    advancedFilterBuilderAddJoin: "Add Group",
    advancedFilterBuilderAddCondition: "Add Filter",
    advancedFilterBuilderSelectColumn: "Select a column",
    advancedFilterBuilderSelectOption: "Select an option",
    advancedFilterBuilderEnterValue: "Enter a value...",
    advancedFilterBuilderValidationAlreadyApplied: "Current filter already applied.",
    advancedFilterBuilderValidationIncomplete: "Not all conditions are complete.",
    advancedFilterBuilderValidationSelectColumn: "Must select a column.",
    advancedFilterBuilderValidationSelectOption: "Must select an option.",
    advancedFilterBuilderValidationEnterValue: "Must enter a value."
};
// packages/ag-grid-enterprise/src/advancedFilter/filterExpressionUtils.ts
function $5b7ccabde48fae90$var$getSearchString(value, position, endPosition) {
    if (!value) return "";
    const numChars = endPosition - position;
    return numChars ? value.slice(0, value.length - numChars) : value;
}
function $5b7ccabde48fae90$var$updateExpression(expression, startPosition, endPosition, updatedValuePart, appendSpace, appendQuote, empty) {
    const secondPartStartPosition = endPosition + (!expression.length || empty ? 0 : 1);
    let positionOffset = 0;
    if (appendSpace) {
        if (expression[secondPartStartPosition] === " ") positionOffset = 1;
        else {
            updatedValuePart += " ";
            if (appendQuote) updatedValuePart += `"`;
        }
    }
    const updatedValue = expression.slice(0, startPosition) + updatedValuePart + expression.slice(secondPartStartPosition);
    return {
        updatedValue: updatedValue,
        updatedPosition: startPosition + updatedValuePart.length + positionOffset
    };
}
function $5b7ccabde48fae90$var$findStartPosition(expression, position, endPosition) {
    let startPosition = position;
    while(startPosition < endPosition){
        const char = expression[startPosition];
        if (char !== " ") break;
        startPosition++;
    }
    return startPosition;
}
function $5b7ccabde48fae90$var$findEndPosition(expression, position, includeCloseBracket, isStartPositionUnknown) {
    let endPosition = position;
    let isEmpty = false;
    while(endPosition < expression.length){
        const char = expression[endPosition];
        if (char === "(") {
            if (isStartPositionUnknown && expression[endPosition - 1] === " ") isEmpty = true;
            else endPosition = endPosition - 1;
            break;
        } else if (char === " " || includeCloseBracket && char === ")") {
            endPosition = endPosition - 1;
            break;
        }
        endPosition++;
    }
    return {
        endPosition: endPosition,
        isEmpty: isEmpty
    };
}
function $5b7ccabde48fae90$var$checkAndUpdateExpression(params, userValue, displayValue, endPosition) {
    if (displayValue !== userValue) params.expression = $5b7ccabde48fae90$var$updateExpression(params.expression, endPosition - userValue.length + 1, endPosition, displayValue).updatedValue;
}
// packages/ag-grid-enterprise/src/advancedFilter/colFilterExpressionParser.ts
var $5b7ccabde48fae90$var$ColumnParser = class {
    constructor(params, startPosition){
        this.params = params;
        this.startPosition = startPosition;
        this.type = "column";
        this.valid = true;
        this.hasStartChar = false;
        this.hasEndChar = false;
        this.colName = "";
    }
    parse(char, position) {
        if (char === $5b7ccabde48fae90$var$COL_FILTER_EXPRESSION_START_CHAR && !this.colName) this.hasStartChar = true;
        else if (char === $5b7ccabde48fae90$var$COL_FILTER_EXPRESSION_END_CHAR && this.hasStartChar) {
            const isMatch = this.parseColumn(false, position);
            if (isMatch) {
                this.hasEndChar = true;
                return false;
            } else this.colName += char;
        } else this.colName += char;
        return void 0;
    }
    getDisplayValue() {
        return (this.hasStartChar ? $5b7ccabde48fae90$var$COL_FILTER_EXPRESSION_START_CHAR : "") + this.colName + (this.hasEndChar ? $5b7ccabde48fae90$var$COL_FILTER_EXPRESSION_END_CHAR : "");
    }
    getColId() {
        return this.colId;
    }
    complete(position) {
        this.parseColumn(true, position);
    }
    getValidationError() {
        return this.valid ? null : {
            message: this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidColumn"),
            startPosition: this.startPosition,
            endPosition: this.endPosition ?? this.params.expression.length - 1
        };
    }
    parseColumn(fromComplete, endPosition) {
        this.endPosition = endPosition;
        const colValue = this.params.advFilterExpSvc.getColId(this.colName);
        if (colValue && this.hasStartChar) {
            this.colId = colValue.colId;
            $5b7ccabde48fae90$var$checkAndUpdateExpression(this.params, this.colName, colValue.columnName, endPosition - 1);
            this.colName = colValue.columnName;
            this.column = this.params.colModel.getColDefCol(this.colId);
            if (this.column) {
                this.baseCellDataType = this.params.dataTypeSvc?.getBaseDataType(this.column) ?? "text";
                return true;
            }
        }
        if (fromComplete) this.valid = false;
        this.baseCellDataType = "text";
        return false;
    }
};
var $5b7ccabde48fae90$var$OperatorParser = class {
    constructor(params, startPosition, baseCellDataType){
        this.params = params;
        this.startPosition = startPosition;
        this.baseCellDataType = baseCellDataType;
        this.type = "operator";
        this.valid = true;
        this.expectedNumOperands = 0;
        this.operator = "";
    }
    parse(char, position) {
        if (char === " " || char === ")") {
            const isMatch = this.parseOperator(false, position - 1);
            if (isMatch) return true;
            else this.operator += char;
        } else this.operator += char;
        return void 0;
    }
    complete(position) {
        this.parseOperator(true, position);
    }
    getValidationError() {
        return this.valid ? null : {
            message: this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidOption"),
            startPosition: this.startPosition,
            endPosition: this.endPosition ?? this.params.expression.length - 1
        };
    }
    getDisplayValue() {
        return this.operator;
    }
    getOperatorKey() {
        return this.parsedOperator;
    }
    parseOperator(fromComplete, endPosition) {
        const operatorForType = this.params.advFilterExpSvc.getDataTypeExpressionOperator(this.baseCellDataType);
        const parsedOperator = operatorForType.findOperator(this.operator);
        this.endPosition = endPosition;
        if (parsedOperator) {
            this.parsedOperator = parsedOperator;
            const operator = operatorForType.operators[parsedOperator];
            this.expectedNumOperands = operator.numOperands;
            const operatorDisplayValue = operator.displayValue;
            $5b7ccabde48fae90$var$checkAndUpdateExpression(this.params, this.operator, operatorDisplayValue, endPosition);
            this.operator = operatorDisplayValue;
            return true;
        }
        const isPartialMatch = parsedOperator === null;
        if (fromComplete || !isPartialMatch) this.valid = false;
        return false;
    }
};
var $5b7ccabde48fae90$var$OperandParser = class {
    constructor(params, startPosition, baseCellDataType, column){
        this.params = params;
        this.startPosition = startPosition;
        this.baseCellDataType = baseCellDataType;
        this.column = column;
        this.type = "operand";
        this.valid = true;
        this.operand = "";
        this.validationMessage = null;
        this.filterValidationSetters = {
            number: ()=>{
                if (this.quotes || isNaN(this.modelValue)) {
                    this.valid = false;
                    this.validationMessage = this.params.advFilterExpSvc.translate("advancedFilterValidationNotANumber");
                }
            },
            date: (modelValue)=>{
                if (modelValue == null) {
                    this.valid = false;
                    this.validationMessage = this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidDate");
                }
            },
            dateString: (...args)=>this.filterValidationSetters.date(...args),
            dateTime: (...args)=>this.filterValidationSetters.date(...args),
            dateTimeString: (...args)=>this.filterValidationSetters.date(...args),
            boolean () {},
            object () {},
            text () {}
        };
    }
    parse(char, position) {
        if (char === " ") {
            if (this.quotes) this.operand += char;
            else {
                this.parseOperand(false, position);
                return true;
            }
        } else if (char === ")") {
            if (this.baseCellDataType === "number" || !this.quotes) {
                this.parseOperand(false, position - 1);
                return true;
            } else this.operand += char;
        } else if (!this.operand && !this.quotes && (char === `'` || char === `"`)) this.quotes = char;
        else if (this.quotes && char === this.quotes) {
            this.parseOperand(false, position);
            return false;
        } else this.operand += char;
        return void 0;
    }
    complete(position) {
        this.parseOperand(true, position);
    }
    getValidationError() {
        return this.validationMessage ? {
            message: this.validationMessage,
            startPosition: this.startPosition,
            endPosition: this.endPosition ?? this.params.expression.length - 1
        } : null;
    }
    getRawValue() {
        return this.operand;
    }
    getModelValue() {
        return this.modelValue;
    }
    parseOperand(fromComplete, position) {
        const { advFilterExpSvc: advFilterExpSvc } = this.params;
        this.endPosition = position;
        this.modelValue = this.operand;
        if (fromComplete && this.quotes) {
            this.valid = false;
            this.validationMessage = advFilterExpSvc.translate("advancedFilterValidationMissingQuote");
        } else if (this.modelValue === "") {
            this.valid = false;
            this.validationMessage = advFilterExpSvc.translate("advancedFilterValidationMissingValue");
        } else {
            const modelValue = advFilterExpSvc.getOperandModelValue(this.operand, this.baseCellDataType, this.column);
            if (modelValue != null) this.modelValue = modelValue;
            this.filterValidationSetters[this.baseCellDataType](modelValue);
        }
    }
};
var $5b7ccabde48fae90$var$COL_FILTER_EXPRESSION_START_CHAR = "[";
var $5b7ccabde48fae90$var$COL_FILTER_EXPRESSION_END_CHAR = "]";
var $5b7ccabde48fae90$var$ColFilterExpressionParser = class {
    constructor(params, startPosition){
        this.params = params;
        this.startPosition = startPosition;
        this.isAwaiting = true;
        this.operandValueGetters = {
            number: Number,
            date: (operand)=>this.params.valueSvc.parseValue(this.columnParser.column, null, operand, void 0),
            dateString: (...args)=>this.operandValueGetters.date(...args),
            dateTime: (...args)=>this.operandValueGetters.date(...args),
            dateTimeString: (...args)=>this.operandValueGetters.date(...args),
            boolean: (operand)=>operand,
            object: (operand)=>operand,
            text: (operand)=>operand
        };
    }
    parseExpression() {
        let i = this.startPosition;
        const { expression: expression } = this.params;
        while(i < expression.length){
            const char = expression[i];
            if (char === " " && this.isAwaiting) ;
            else {
                this.isAwaiting = false;
                if (!this.parser) {
                    let parser;
                    if (!this.columnParser) {
                        this.columnParser = new $5b7ccabde48fae90$var$ColumnParser(this.params, i);
                        parser = this.columnParser;
                    } else if (!this.operatorParser) {
                        this.operatorParser = new $5b7ccabde48fae90$var$OperatorParser(this.params, i, this.columnParser.baseCellDataType);
                        parser = this.operatorParser;
                    } else {
                        this.operandParser = new $5b7ccabde48fae90$var$OperandParser(this.params, i, this.columnParser.baseCellDataType, this.columnParser.column);
                        parser = this.operandParser;
                    }
                    this.parser = parser;
                }
                const hasCompletedOnPrevChar = this.parser.parse(char, i);
                if (hasCompletedOnPrevChar != null) {
                    if (this.isComplete()) return this.returnEndPosition(hasCompletedOnPrevChar ? i - 1 : i, true);
                    this.parser = void 0;
                    this.isAwaiting = true;
                }
            }
            i++;
        }
        this.parser?.complete?.(i - 1);
        return this.returnEndPosition(i);
    }
    isValid() {
        return this.isComplete() && this.columnParser.valid && this.operatorParser.valid && (!this.operandParser || this.operandParser.valid);
    }
    getValidationError() {
        const validationError = this.columnParser?.getValidationError() ?? this.operatorParser?.getValidationError() ?? this.operandParser?.getValidationError();
        if (validationError) return validationError;
        const endPosition = this.params.expression.length;
        let translateKey;
        if (!this.columnParser) translateKey = "advancedFilterValidationMissingColumn";
        else if (!this.operatorParser) translateKey = "advancedFilterValidationMissingOption";
        else if (this.operatorParser.expectedNumOperands && !this.operandParser) translateKey = "advancedFilterValidationMissingValue";
        if (translateKey) return {
            message: this.params.advFilterExpSvc.translate(translateKey),
            startPosition: endPosition,
            endPosition: endPosition
        };
        return null;
    }
    getFunction(params) {
        return this.getFunctionCommon(params, (operandIndex, operatorIndex, colId, evaluatorParamsIndex)=>{
            return (expressionProxy, node, p)=>p.operators[operatorIndex].evaluator(expressionProxy.getValue(colId, node), node, p.evaluatorParams[evaluatorParamsIndex], operandIndex == null ? void 0 : p.operands[operandIndex]);
        });
    }
    getAutocompleteListParams(position) {
        if (this.isColumnPosition(position)) return this.getColumnAutocompleteListParams(position);
        if (this.isOperatorPosition(position)) return this.getOperatorAutocompleteListParams(position);
        if (this.isBeyondEndPosition(position)) return void 0;
        return {
            enabled: false
        };
    }
    updateExpression(position, updateEntry, type) {
        const { expression: expression } = this.params;
        if (this.isColumnPosition(position)) return $5b7ccabde48fae90$var$updateExpression(this.params.expression, this.startPosition, this.columnParser?.getColId() ? this.columnParser.endPosition : $5b7ccabde48fae90$var$findEndPosition(expression, position).endPosition, this.params.advFilterExpSvc.getColumnValue(updateEntry), true);
        else if (this.isOperatorPosition(position)) {
            const baseCellDataType = this.getBaseCellDataTypeFromOperatorAutocompleteType(type);
            const hasOperand = this.hasOperand(baseCellDataType, updateEntry.key);
            const doesOperandNeedQuotes = hasOperand && this.doesOperandNeedQuotes(baseCellDataType);
            let update;
            if (this.operatorParser?.startPosition != null && position < this.operatorParser.startPosition) update = $5b7ccabde48fae90$var$updateExpression(expression, position, position, updateEntry.displayValue ?? updateEntry.key, hasOperand, doesOperandNeedQuotes);
            else {
                let endPosition;
                let empty = false;
                if (this.operatorParser?.getOperatorKey()) endPosition = this.operatorParser.endPosition;
                else {
                    const { endPosition: calculatedEndPosition, isEmpty: isEmpty } = $5b7ccabde48fae90$var$findEndPosition(expression, position, true, true);
                    endPosition = calculatedEndPosition;
                    empty = isEmpty;
                }
                update = $5b7ccabde48fae90$var$updateExpression(expression, $5b7ccabde48fae90$var$findStartPosition(expression, this.columnParser.endPosition + 1, endPosition), endPosition, updateEntry.displayValue ?? updateEntry.key, hasOperand, doesOperandNeedQuotes, empty);
            }
            return {
                ...update,
                hideAutocomplete: !hasOperand
            };
        }
        return null;
    }
    getModel() {
        const colId = this.columnParser.getColId();
        const model = {
            filterType: this.columnParser.baseCellDataType,
            colId: colId,
            type: this.operatorParser.getOperatorKey()
        };
        if (this.operatorParser.expectedNumOperands) model.filter = this.operandParser.getModelValue();
        return model;
    }
    getFunctionCommon(params, processFunc) {
        const colId = this.columnParser.getColId();
        const operator = this.operatorParser?.getOperatorKey();
        const { operators: operators, evaluatorParams: evaluatorParams, operands: operands } = params;
        const operatorForColumn = this.params.advFilterExpSvc.getExpressionOperator(this.columnParser.baseCellDataType, operator);
        const operatorIndex = this.addToListAndGetIndex(operators, operatorForColumn);
        const evaluatorParamsForColumn = this.params.advFilterExpSvc.getExpressionEvaluatorParams(colId);
        const evaluatorParamsIndex = this.addToListAndGetIndex(evaluatorParams, evaluatorParamsForColumn);
        const operandIndex = this.operatorParser?.expectedNumOperands === 0 ? void 0 : this.addToListAndGetIndex(operands, this.getOperandValue());
        return processFunc(operandIndex, operatorIndex, colId, evaluatorParamsIndex);
    }
    getOperandValue() {
        const { baseCellDataType: baseCellDataType, column: column } = this.columnParser;
        const operand = this.operandValueGetters[baseCellDataType](this.operandParser.getRawValue());
        if (baseCellDataType === "dateString" || baseCellDataType === "dateTimeString") return this.params.dataTypeSvc?.getDateParserFunction(column)(operand) ?? operand;
        return operand;
    }
    isComplete() {
        return !!(this.operatorParser && (!this.operatorParser.expectedNumOperands || this.operatorParser.expectedNumOperands && this.operandParser));
    }
    isColumnPosition(position) {
        return !this.columnParser || this.columnParser.endPosition == null || position <= this.columnParser.endPosition + 1;
    }
    isOperatorPosition(position) {
        return !this.operatorParser || this.operatorParser.endPosition == null || position <= this.operatorParser.endPosition + 1;
    }
    isBeyondEndPosition(position) {
        return this.isComplete() && this.endPosition != null && position > this.endPosition + 1 && this.endPosition + 1 < this.params.expression.length;
    }
    returnEndPosition(returnPosition, treatAsEnd) {
        this.endPosition = treatAsEnd ? returnPosition : returnPosition - 1;
        return returnPosition;
    }
    getColumnAutocompleteListParams(position) {
        return this.params.advFilterExpSvc.generateAutocompleteListParams(this.params.advFilterExpSvc.getColumnAutocompleteEntries(), "column", this.getColumnSearchString(position));
    }
    getColumnSearchString(position) {
        const columnName = this.columnParser?.getDisplayValue() ?? "";
        const searchString = $5b7ccabde48fae90$var$getSearchString(columnName, position, this.columnParser?.endPosition == null ? this.params.expression.length : this.columnParser.endPosition + 1);
        const containsStartChar = this.columnParser?.hasStartChar && searchString.length > 0;
        const containsEndChar = this.columnParser?.hasEndChar && searchString.length === columnName.length + 2;
        if (containsStartChar) return searchString.slice(1, containsEndChar ? -1 : void 0);
        return searchString;
    }
    getOperatorAutocompleteListParams(position) {
        const column = this.columnParser?.column;
        if (!column) return {
            enabled: false
        };
        const baseCellDataType = this.columnParser.baseCellDataType;
        const searchString = this.operatorParser?.startPosition != null && position < this.operatorParser.startPosition ? "" : $5b7ccabde48fae90$var$getSearchString(this.operatorParser?.getDisplayValue() ?? "", position, this.operatorParser?.endPosition == null ? this.params.expression.length : this.operatorParser.endPosition + 1);
        return this.params.advFilterExpSvc.generateAutocompleteListParams(this.params.advFilterExpSvc.getOperatorAutocompleteEntries(column, baseCellDataType), `operator-${baseCellDataType}`, searchString);
    }
    getBaseCellDataTypeFromOperatorAutocompleteType(type) {
        return type?.replace("operator-", "");
    }
    hasOperand(baseCellDataType, operator) {
        return !baseCellDataType || !operator || (this.params.advFilterExpSvc.getExpressionOperator(baseCellDataType, operator)?.numOperands ?? 0) > 0;
    }
    doesOperandNeedQuotes(baseCellDataType) {
        return baseCellDataType !== "number";
    }
    addToListAndGetIndex(list, value) {
        const index = list.length;
        list.push(value);
        return index;
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/filterExpressionOperators.ts
function $5b7ccabde48fae90$var$findMatch(searchValue, values, getDisplayValue) {
    let partialMatch = false;
    const searchValueLowerCase = searchValue.toLocaleLowerCase();
    const partialSearchValue = searchValueLowerCase + " ";
    const parsedValue = Object.keys(values).find((key)=>{
        const value = values[key];
        const displayValueLowerCase = getDisplayValue(value).toLocaleLowerCase();
        if (displayValueLowerCase.startsWith(partialSearchValue)) partialMatch = true;
        return displayValueLowerCase === searchValueLowerCase;
    });
    if (parsedValue) return parsedValue;
    else if (partialMatch) return null;
    else return void 0;
}
function $5b7ccabde48fae90$var$getEntries(operators, activeOperatorKeys) {
    const keys = activeOperatorKeys ?? Object.keys(operators);
    return keys.map((key)=>({
            key: key,
            displayValue: operators[key].displayValue
        }));
}
var $5b7ccabde48fae90$var$TextFilterExpressionOperators = class {
    constructor(params){
        this.params = params;
        this.initOperators();
    }
    getEntries(activeOperators) {
        return $5b7ccabde48fae90$var$getEntries(this.operators, activeOperators);
    }
    findOperator(displayValue) {
        return $5b7ccabde48fae90$var$findMatch(displayValue, this.operators, ({ displayValue: displayValue2 })=>displayValue2);
    }
    initOperators() {
        const { translate: translate } = this.params;
        this.operators = {
            contains: {
                displayValue: translate("advancedFilterContains"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, false, (v, o)=>v.includes(o)),
                numOperands: 1
            },
            notContains: {
                displayValue: translate("advancedFilterNotContains"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, true, (v, o)=>!v.includes(o)),
                numOperands: 1
            },
            equals: {
                displayValue: translate("advancedFilterTextEquals"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, false, (v, o)=>v === o),
                numOperands: 1
            },
            notEqual: {
                displayValue: translate("advancedFilterTextNotEqual"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, true, (v, o)=>v != o),
                numOperands: 1
            },
            startsWith: {
                displayValue: translate("advancedFilterStartsWith"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, false, (v, o)=>v.startsWith(o)),
                numOperands: 1
            },
            endsWith: {
                displayValue: translate("advancedFilterEndsWith"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, false, (v, o)=>v.endsWith(o)),
                numOperands: 1
            },
            blank: {
                displayValue: translate("advancedFilterBlank"),
                evaluator: (value)=>value == null || typeof value === "string" && value.trim().length === 0,
                numOperands: 0
            },
            notBlank: {
                displayValue: translate("advancedFilterNotBlank"),
                evaluator: (value)=>value != null && (typeof value !== "string" || value.trim().length > 0),
                numOperands: 0
            }
        };
    }
    evaluateExpression(value, node, params, operand, nullsMatch, expression) {
        if (value == null) return nullsMatch;
        return params.caseSensitive ? expression(params.valueConverter(value, node), operand) : expression(params.valueConverter(value, node).toLocaleLowerCase(), operand.toLocaleLowerCase());
    }
};
var $5b7ccabde48fae90$var$ScalarFilterExpressionOperators = class {
    constructor(params){
        this.params = params;
        this.initOperators();
    }
    getEntries(activeOperators) {
        return $5b7ccabde48fae90$var$getEntries(this.operators, activeOperators);
    }
    findOperator(displayValue) {
        return $5b7ccabde48fae90$var$findMatch(displayValue, this.operators, ({ displayValue: displayValue2 })=>displayValue2);
    }
    initOperators() {
        const { translate: translate, equals: equals } = this.params;
        this.operators = {
            equals: {
                displayValue: translate("advancedFilterEquals"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInEquals, equals),
                numOperands: 1
            },
            notEqual: {
                displayValue: translate("advancedFilterNotEqual"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInEquals, (v, o)=>!equals(v, o)),
                numOperands: 1
            },
            greaterThan: {
                displayValue: translate("advancedFilterGreaterThan"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInGreaterThan, (v, o)=>v > o),
                numOperands: 1
            },
            greaterThanOrEqual: {
                displayValue: translate("advancedFilterGreaterThanOrEqual"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInGreaterThan, (v, o)=>v >= o),
                numOperands: 1
            },
            lessThan: {
                displayValue: translate("advancedFilterLessThan"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInLessThan, (v, o)=>v < o),
                numOperands: 1
            },
            lessThanOrEqual: {
                displayValue: translate("advancedFilterLessThanOrEqual"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInLessThan, (v, o)=>v <= o),
                numOperands: 1
            },
            blank: {
                displayValue: translate("advancedFilterBlank"),
                evaluator: (value)=>value == null,
                numOperands: 0
            },
            notBlank: {
                displayValue: translate("advancedFilterNotBlank"),
                evaluator: (value)=>value != null,
                numOperands: 0
            }
        };
    }
    evaluateSingleOperandExpression(value, node, params, operand, nullsMatch, expression) {
        if (value == null) return nullsMatch;
        return expression(params.valueConverter(value, node), operand);
    }
};
var $5b7ccabde48fae90$var$BooleanFilterExpressionOperators = class {
    constructor(params){
        this.params = params;
        this.initOperators();
    }
    getEntries(activeOperators) {
        return $5b7ccabde48fae90$var$getEntries(this.operators, activeOperators);
    }
    findOperator(displayValue) {
        return $5b7ccabde48fae90$var$findMatch(displayValue, this.operators, ({ displayValue: displayValue2 })=>displayValue2);
    }
    initOperators() {
        const { translate: translate } = this.params;
        this.operators = {
            true: {
                displayValue: translate("advancedFilterTrue"),
                evaluator: (value)=>!!value,
                numOperands: 0
            },
            false: {
                displayValue: translate("advancedFilterFalse"),
                evaluator: (value)=>value === false,
                numOperands: 0
            },
            blank: {
                displayValue: translate("advancedFilterBlank"),
                evaluator: (value)=>value == null,
                numOperands: 0
            },
            notBlank: {
                displayValue: translate("advancedFilterNotBlank"),
                evaluator: (value)=>value != null,
                numOperands: 0
            }
        };
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/advancedFilterExpressionService.ts
var $5b7ccabde48fae90$var$AdvancedFilterExpressionService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "advFilterExpSvc";
        this.filterOperandGetters = {
            number: (model)=>(0, $jIDNV._toStringOrNull)(model.filter) ?? "",
            date: (model)=>{
                const column = this.colModel.getColDefCol(model.colId);
                if (!column) return null;
                return this.valueSvc.formatValue(column, null, (0, $jIDNV._parseDateTimeFromString)(model.filter));
            },
            dateTime: (model)=>this.filterOperandGetters.date(model),
            dateString: (model)=>{
                const column = this.colModel.getColDefCol(model.colId);
                if (!column) return null;
                const { filter: filter } = model;
                const dateFormatFn = this.dataTypeSvc?.getDateFormatterFunction(column);
                const dateStringStringValue = dateFormatFn?.((0, $jIDNV._parseDateTimeFromString)(filter) ?? void 0) ?? filter;
                return this.valueSvc.formatValue(column, null, dateStringStringValue);
            },
            dateTimeString: (model)=>this.filterOperandGetters.dateString(model),
            boolean: ()=>null,
            object: ()=>null,
            text: ()=>null
        };
        this.operandModelValueGetters = {
            number: (operand)=>(0, $jIDNV._exists)(operand) ? Number(operand) : null,
            date: (operand, column, baseCellDataType)=>(0, $jIDNV._serialiseDate)(this.valueSvc.parseValue(column, null, operand, void 0), !!this.dataTypeSvc?.getDateIncludesTimeFlag(baseCellDataType)),
            dateTime: (...args)=>this.operandModelValueGetters.date(...args),
            dateString: (operand, column, baseCellDataType)=>{
                const parsedDateString = this.valueSvc.parseValue(column, null, operand, void 0);
                if (this.dataTypeSvc) return (0, $jIDNV._serialiseDate)(this.dataTypeSvc.getDateParserFunction(column)(parsedDateString) ?? null, this.dataTypeSvc.getDateIncludesTimeFlag(baseCellDataType));
                return parsedDateString;
            },
            dateTimeString: (...args)=>this.operandModelValueGetters.dateString(...args),
            boolean: (operand)=>operand,
            object: (operand)=>operand,
            text: (operand)=>operand
        };
        this.columnNameToIdMap = {};
        this.columnAutocompleteEntries = null;
        this.expressionEvaluatorParams = {};
    }
    wireBeans(beans) {
        this.valueSvc = beans.valueSvc;
        this.colModel = beans.colModel;
        this.colNames = beans.colNames;
        this.dataTypeSvc = beans.dataTypeSvc;
    }
    postConstruct() {
        this.expressionJoinOperators = this.generateExpressionJoinOperators();
        this.expressionOperators = this.generateExpressionOperators();
    }
    parseJoinOperator(model) {
        const { type: type } = model;
        return this.expressionJoinOperators[type] ?? type;
    }
    getColumnDisplayValue(model) {
        const { colId: colId } = model;
        const columnEntries = this.getColumnAutocompleteEntries();
        const columnEntry = columnEntries.find(({ key: key })=>key === colId);
        let columnName;
        if (columnEntry) {
            columnName = columnEntry.displayValue;
            this.columnNameToIdMap[columnName.toLocaleUpperCase()] = {
                colId: colId,
                columnName: columnName
            };
        } else columnName = colId;
        return columnName;
    }
    getOperatorDisplayValue(model) {
        return this.getExpressionOperator(model.filterType, model.type)?.displayValue ?? model.type;
    }
    getOperandModelValue(operand, baseCellDataType, column) {
        return this.operandModelValueGetters[baseCellDataType](operand, column, baseCellDataType);
    }
    getOperandDisplayValue(model, skipFormatting) {
        const { filter: filter } = model;
        if (filter == null) return "";
        let operand1 = this.filterOperandGetters[model.filterType](model);
        if (model.filterType !== "number") {
            operand1 ?? (operand1 = (0, $jIDNV._toStringOrNull)(filter) ?? "");
            if (!skipFormatting) operand1 = `"${operand1}"`;
        }
        return skipFormatting ? operand1 : ` ${operand1}`;
    }
    parseColumnFilterModel(model) {
        const columnName = this.getColumnDisplayValue(model) ?? "";
        const operator = this.getOperatorDisplayValue(model) ?? "";
        const operands = this.getOperandDisplayValue(model);
        return `[${columnName}] ${operator}${operands}`;
    }
    updateAutocompleteCache(updateEntry, type) {
        if (type === "column") {
            const { key: colId, displayValue: displayValue } = updateEntry;
            this.columnNameToIdMap[updateEntry.displayValue.toLocaleUpperCase()] = {
                colId: colId,
                columnName: displayValue
            };
        }
    }
    translate(key, variableValues) {
        let defaultValue = $5b7ccabde48fae90$var$ADVANCED_FILTER_LOCALE_TEXT[key];
        if (typeof defaultValue === "function") defaultValue = defaultValue(variableValues);
        return this.getLocaleTextFunc()(key, defaultValue, variableValues);
    }
    generateAutocompleteListParams(entries, type, searchString) {
        return {
            enabled: true,
            type: type,
            searchString: searchString,
            entries: entries
        };
    }
    getColumnAutocompleteEntries() {
        if (this.columnAutocompleteEntries) return this.columnAutocompleteEntries;
        const columns = this.colModel.getColDefCols() ?? [];
        const entries = [];
        const includeHiddenColumns = this.gos.get("includeHiddenColumnsInAdvancedFilter");
        columns.forEach((column)=>{
            if (column.getColDef().filter && (includeHiddenColumns || column.isVisible() || column.isRowGroupActive())) entries.push({
                key: column.getColId(),
                displayValue: this.colNames.getDisplayNameForColumn(column, "advancedFilter")
            });
        });
        entries.sort((a, b)=>{
            const aValue = a.displayValue ?? "";
            const bValue = b.displayValue ?? "";
            if (aValue < bValue) return -1;
            else if (bValue > aValue) return 1;
            return 0;
        });
        return entries;
    }
    getOperatorAutocompleteEntries(column, baseCellDataType) {
        const activeOperators = this.getActiveOperators(column);
        return this.getDataTypeExpressionOperator(baseCellDataType).getEntries(activeOperators);
    }
    getJoinOperatorAutocompleteEntries() {
        return Object.entries(this.expressionJoinOperators).map(([key, displayValue])=>({
                key: key,
                displayValue: displayValue
            }));
    }
    getDefaultAutocompleteListParams(searchString) {
        return this.generateAutocompleteListParams(this.getColumnAutocompleteEntries(), "column", searchString);
    }
    getDataTypeExpressionOperator(baseCellDataType) {
        return this.expressionOperators[baseCellDataType];
    }
    getExpressionOperator(baseCellDataType, operator) {
        return this.getDataTypeExpressionOperator(baseCellDataType)?.operators?.[operator];
    }
    getExpressionJoinOperators() {
        return this.expressionJoinOperators;
    }
    getColId(columnName) {
        const upperCaseColumnName = columnName.toLocaleUpperCase();
        const cachedColId = this.columnNameToIdMap[upperCaseColumnName];
        if (cachedColId) return cachedColId;
        const columnAutocompleteEntries = this.getColumnAutocompleteEntries();
        const colEntry = columnAutocompleteEntries.find(({ displayValue: displayValue })=>displayValue.toLocaleUpperCase() === upperCaseColumnName);
        if (colEntry) {
            const { key: colId, displayValue: displayValue } = colEntry;
            const colValue = {
                colId: colId,
                columnName: displayValue
            };
            this.columnNameToIdMap[upperCaseColumnName] = colValue;
            return colValue;
        }
        return null;
    }
    getExpressionEvaluatorParams(colId) {
        let params = this.expressionEvaluatorParams[colId];
        if (params) return params;
        const column = this.colModel.getColDefCol(colId);
        if (!column) return {
            valueConverter: (v)=>v
        };
        const baseCellDataType = this.dataTypeSvc?.getBaseDataType(column);
        switch(baseCellDataType){
            case "dateTimeString":
            case "dateString":
                params = {
                    valueConverter: this.dataTypeSvc?.getDateParserFunction(column) ?? ((v)=>v)
                };
                break;
            case "object":
                if (column.getColDef().filterValueGetter) params = {
                    valueConverter: (v)=>v
                };
                else params = {
                    valueConverter: (value, node)=>this.valueSvc.formatValue(column, node, value) ?? (typeof value.toString === "function" ? value.toString() : "")
                };
                break;
            case "text":
            case void 0:
                params = {
                    valueConverter: (v)=>(0, $jIDNV._toStringOrNull)(v)
                };
                break;
            default:
                params = {
                    valueConverter: (v)=>v
                };
                break;
        }
        const { filterParams: filterParams } = column.getColDef();
        if (filterParams) [
            "caseSensitive",
            "includeBlanksInEquals",
            "includeBlanksInLessThan",
            "includeBlanksInGreaterThan"
        ].forEach((param)=>{
            const paramValue = filterParams[param];
            if (paramValue) params[param] = paramValue;
        });
        this.expressionEvaluatorParams[colId] = params;
        return params;
    }
    getColumnDetails(colId) {
        const column = this.colModel.getColDefCol(colId) ?? void 0;
        const baseCellDataType = (column ? this.dataTypeSvc?.getBaseDataType(column) : void 0) ?? "text";
        return {
            column: column,
            baseCellDataType: baseCellDataType
        };
    }
    generateExpressionOperators() {
        const translate = (key, variableValues)=>this.translate(key, variableValues);
        const dateOperatorsParams = {
            translate: translate,
            equals: (v, o)=>v.getTime() === o.getTime()
        };
        return {
            text: new $5b7ccabde48fae90$var$TextFilterExpressionOperators({
                translate: translate
            }),
            boolean: new $5b7ccabde48fae90$var$BooleanFilterExpressionOperators({
                translate: translate
            }),
            object: new $5b7ccabde48fae90$var$TextFilterExpressionOperators({
                translate: translate
            }),
            number: new $5b7ccabde48fae90$var$ScalarFilterExpressionOperators({
                translate: translate,
                equals: (v, o)=>v === o
            }),
            date: new $5b7ccabde48fae90$var$ScalarFilterExpressionOperators(dateOperatorsParams),
            dateString: new $5b7ccabde48fae90$var$ScalarFilterExpressionOperators(dateOperatorsParams),
            dateTime: new $5b7ccabde48fae90$var$ScalarFilterExpressionOperators(dateOperatorsParams),
            dateTimeString: new $5b7ccabde48fae90$var$ScalarFilterExpressionOperators(dateOperatorsParams)
        };
    }
    getColumnValue({ displayValue: displayValue }) {
        return `${$5b7ccabde48fae90$var$COL_FILTER_EXPRESSION_START_CHAR}${displayValue}${$5b7ccabde48fae90$var$COL_FILTER_EXPRESSION_END_CHAR}`;
    }
    generateExpressionJoinOperators() {
        return {
            AND: this.translate("advancedFilterAnd"),
            OR: this.translate("advancedFilterOr")
        };
    }
    getActiveOperators(column) {
        const filterOptions = column.getColDef().filterParams?.filterOptions;
        if (!filterOptions) return void 0;
        const isValid = filterOptions.every((filterOption)=>typeof filterOption === "string");
        return isValid ? filterOptions : void 0;
    }
    resetColumnCaches() {
        this.columnAutocompleteEntries = null;
        this.columnNameToIdMap = {};
        this.expressionEvaluatorParams = {};
    }
};
// packages/ag-grid-enterprise/src/widgets/agPanel.css-GENERATED.ts
var $5b7ccabde48fae90$var$agPanelCSS = /*css*/ `.ag-panel{background-color:var(--ag-panel-background-color);display:flex;flex-direction:column;overflow:hidden;position:relative}.ag-dialog{border:var(--ag-dialog-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dialog-shadow);position:absolute}.ag-panel-title-bar{align-items:center;background-color:var(--ag-panel-title-bar-background-color);border-bottom:var(--ag-panel-title-bar-border);color:var(--ag-panel-title-bar-text-color);cursor:default;display:flex;flex:none;font-weight:var(--ag-panel-title-bar-font-weight);height:var(--ag-header-height);padding:var(--ag-spacing) var(--ag-cell-horizontal-padding)}.ag-panel-title-bar-button{cursor:pointer;:where(.ag-icon){color:var(--ag-panel-title-bar-icon-color)}}:where(.ag-ltr) .ag-panel-title-bar-button{margin-left:calc(var(--ag-spacing)*2);margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-panel-title-bar-button{margin-left:var(--ag-spacing);margin-right:calc(var(--ag-spacing)*2)}.ag-panel-title-bar-title{flex:1 1 auto}.ag-panel-title-bar-buttons{display:flex}.ag-panel-content-wrapper{display:flex;flex:1 1 auto;overflow:hidden;position:relative}:where(.ag-dragging-fill-handle) .ag-dialog,:where(.ag-dragging-range-handle) .ag-dialog{opacity:.7;pointer-events:none}`;
// packages/ag-grid-enterprise/src/widgets/agPanel.ts
function $5b7ccabde48fae90$var$getTemplate(config) {
    const cssIdentifier = config.cssIdentifier || "default";
    return {
        tag: "div",
        cls: `ag-panel ag-${cssIdentifier}-panel`,
        attrs: {
            tabindex: "-1"
        },
        children: [
            {
                tag: "div",
                ref: "eTitleBar",
                cls: `ag-panel-title-bar ag-${cssIdentifier}-panel-title-bar ag-unselectable`,
                children: [
                    {
                        tag: "span",
                        ref: "eTitle",
                        cls: `ag-panel-title-bar-title ag-${cssIdentifier}-panel-title-bar-title`
                    },
                    {
                        tag: "div",
                        ref: "eTitleBarButtons",
                        cls: `ag-panel-title-bar-buttons ag-${cssIdentifier}-panel-title-bar-buttons`
                    }
                ]
            },
            {
                tag: "div",
                ref: "eContentWrapper",
                cls: `ag-panel-content-wrapper ag-${cssIdentifier}-panel-content-wrapper`
            }
        ]
    };
}
var $5b7ccabde48fae90$var$AgPanel = class extends (0, $jIDNV.Component) {
    constructor(config){
        super($5b7ccabde48fae90$var$getTemplate(config));
        this.config = config;
        this.closable = true;
        this.eContentWrapper = (0, $jIDNV.RefPlaceholder);
        this.eTitleBar = (0, $jIDNV.RefPlaceholder);
        this.eTitleBarButtons = (0, $jIDNV.RefPlaceholder);
        this.eTitle = (0, $jIDNV.RefPlaceholder);
        this.registerCSS($5b7ccabde48fae90$var$agPanelCSS);
    }
    postConstruct() {
        const { component: component, closable: closable, hideTitleBar: hideTitleBar, title: title, minWidth: minWidth = 250, width: width, minHeight: minHeight = 250, height: height, centered: centered, popup: popup, x: x, y: y, postProcessPopupParams: postProcessPopupParams } = this.config;
        const beans = this.beans;
        const positionableFeature = this.createManagedBean(new (0, $jIDNV.PositionableFeature)(this.getGui(), {
            minWidth: minWidth,
            width: width,
            minHeight: minHeight,
            height: height,
            centered: centered,
            x: x,
            y: y,
            popup: popup,
            calculateTopBuffer: ()=>this.positionableFeature.getHeight() - this.getBodyHeight()
        }));
        this.positionableFeature = positionableFeature;
        const eGui = this.getGui();
        if (component) this.setBodyComponent(component);
        if (!hideTitleBar) {
            if (title) this.setTitle(title);
            this.setClosable(closable != null ? closable : this.closable);
        } else (0, $jIDNV._setDisplayed)(this.eTitleBar, false);
        this.addManagedElementListeners(this.eTitleBar, {
            mousedown: (e)=>{
                if (eGui.contains(e.relatedTarget) || eGui.contains((0, $jIDNV._getActiveDomElement)(beans)) || this.eTitleBarButtons.contains(e.target)) {
                    e.preventDefault();
                    return;
                }
                const focusEl = this.eContentWrapper.querySelector("button, [href], input, select, textarea, [tabindex]");
                if (focusEl) focusEl.focus();
            }
        });
        if (popup && positionableFeature.isPositioned()) return;
        if (this.renderComponent) this.renderComponent();
        let postProcessCallback;
        if (postProcessPopupParams) {
            const { type: type, eventSource: eventSource, column: column, mouseEvent: mouseEvent, rowNode: rowNode } = postProcessPopupParams;
            postProcessCallback = ()=>beans.popupSvc?.callPostProcessPopup(type, eGui, eventSource, mouseEvent, column, rowNode);
        }
        positionableFeature.initialisePosition(postProcessCallback);
        this.eContentWrapper.style.height = "0";
    }
    renderComponent() {
        const eGui = this.getGui();
        eGui.focus();
        this.close = ()=>{
            eGui.parentElement.removeChild(eGui);
            this.destroy();
        };
    }
    getHeight() {
        return this.positionableFeature.getHeight();
    }
    setHeight(height) {
        this.positionableFeature.setHeight(height);
    }
    getWidth() {
        return this.positionableFeature.getWidth();
    }
    setWidth(width) {
        this.positionableFeature.setWidth(width);
    }
    setClosable(closable) {
        if (closable !== this.closable) this.closable = closable;
        if (closable) {
            const closeButtonComp = this.closeButtonComp = new (0, $jIDNV.Component)({
                tag: "div",
                cls: "ag-button"
            });
            this.createBean(closeButtonComp);
            const eGui = closeButtonComp.getGui();
            const child = (0, $jIDNV._createIconNoSpan)("close", this.beans);
            child.classList.add("ag-panel-title-bar-button-icon");
            eGui.appendChild(child);
            this.addTitleBarButton(closeButtonComp);
            closeButtonComp.addManagedElementListeners(eGui, {
                click: this.onBtClose.bind(this)
            });
        } else if (this.closeButtonComp) {
            const eGui = this.closeButtonComp.getGui();
            eGui.parentElement.removeChild(eGui);
            this.closeButtonComp = this.destroyBean(this.closeButtonComp);
        }
    }
    setBodyComponent(bodyComponent) {
        bodyComponent.setParentComponent(this);
        this.eContentWrapper.appendChild(bodyComponent.getGui());
    }
    addTitleBarButton(button, position) {
        const eTitleBarButtons = this.eTitleBarButtons;
        const buttons = eTitleBarButtons.children;
        const len = buttons.length;
        if (position == null) position = len;
        position = Math.max(0, Math.min(position, len));
        button.addCss("ag-panel-title-bar-button");
        const eGui = button.getGui();
        if (position === 0) eTitleBarButtons.insertAdjacentElement("afterbegin", eGui);
        else if (position === len) eTitleBarButtons.insertAdjacentElement("beforeend", eGui);
        else buttons[position - 1].insertAdjacentElement("afterend", eGui);
        button.setParentComponent(this);
    }
    getBodyHeight() {
        return (0, $jIDNV._getInnerHeight)(this.eContentWrapper);
    }
    getBodyWidth() {
        return (0, $jIDNV._getInnerWidth)(this.eContentWrapper);
    }
    setTitle(title) {
        this.eTitle.innerText = title;
    }
    // called when user hits the 'x' in the top right
    onBtClose() {
        this.close();
    }
    destroy() {
        if (this.closeButtonComp) this.closeButtonComp = this.destroyBean(this.closeButtonComp);
        const eGui = this.getGui();
        if (eGui && (0, $jIDNV._isVisible)(eGui)) this.close();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/widgets/agDialog.ts
var $5b7ccabde48fae90$var$AgDialog = class extends $5b7ccabde48fae90$var$AgPanel {
    constructor(config){
        super({
            ...config,
            popup: true
        });
        this.isMaximizable = false;
        this.isMaximized = false;
        this.maximizeListeners = [];
        this.resizeListenerDestroy = null;
        this.lastPosition = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
    }
    postConstruct() {
        const eGui = this.getGui();
        const { movable: movable, resizable: resizable, maximizable: maximizable, modal: modal } = this.config;
        this.addCss("ag-dialog");
        super.postConstruct();
        this.tabGuardFeature = this.createManagedBean(new (0, $jIDNV.TabGuardFeature)(this));
        this.tabGuardFeature.initialiseTabGuard({
            isFocusableContainer: true,
            onFocusIn: ()=>{
                this.popupSvc?.bringPopupToFront(eGui);
            },
            onTabKeyDown: (e)=>{
                if (modal) return;
                const backwards = e.shiftKey;
                const nextFocusableElement = (0, $jIDNV._findNextFocusableElement)(this.beans, eGui, false, backwards);
                if (!nextFocusableElement || this.tabGuardFeature.getTabGuardCtrl().isTabGuard(nextFocusableElement)) {
                    if ((0, $jIDNV._focusNextGridCoreContainer)(this.beans, backwards)) e.preventDefault();
                }
            }
        });
        if (movable) this.setMovable(movable);
        if (maximizable) this.setMaximizable(maximizable);
        if (resizable) this.setResizable(resizable);
        if (!this.config.modal) {
            const gridCtrl = this.beans.ctrlsSvc.get("gridCtrl");
            gridCtrl.addFocusableContainer(this);
            this.addDestroyFunc(()=>gridCtrl.removeFocusableContainer(this));
        }
    }
    setAllowFocus(allowFocus) {
        this.tabGuardFeature.getTabGuardCtrl().setAllowFocus(allowFocus);
    }
    renderComponent() {
        const eGui = this.getGui();
        const { alwaysOnTop: alwaysOnTop, modal: modal, title: title, afterGuiAttached: afterGuiAttached } = this.config;
        const translate = this.getLocaleTextFunc();
        const addPopupRes = this.popupSvc?.addPopup({
            modal: modal,
            eChild: eGui,
            closeOnEsc: true,
            closedCallback: this.onClosed.bind(this),
            alwaysOnTop: alwaysOnTop,
            ariaLabel: title || translate("ariaLabelDialog", "Dialog"),
            afterGuiAttached: afterGuiAttached
        });
        if (addPopupRes) this.close = addPopupRes.hideFunc;
    }
    onClosed(event) {
        this.destroy();
        this.config.closedCallback?.(event);
    }
    setMaximized(maximized) {
        if (this.isMaximizable && maximized !== this.isMaximized) this.toggleMaximize();
    }
    toggleMaximize() {
        const position = this.positionableFeature.getPosition();
        if (this.isMaximized) {
            const { x: x, y: y, width: width, height: height } = this.lastPosition;
            this.setWidth(width);
            this.setHeight(height);
            this.positionableFeature.offsetElement(x, y);
        } else {
            this.lastPosition.width = this.getWidth();
            this.lastPosition.height = this.getHeight();
            this.lastPosition.x = position.x;
            this.lastPosition.y = position.y;
            this.positionableFeature.offsetElement(0, 0);
            this.setHeight("100%");
            this.setWidth("100%");
        }
        this.isMaximized = !this.isMaximized;
        this.refreshMaximizeIcon();
    }
    refreshMaximizeIcon() {
        (0, $jIDNV._setDisplayed)(this.maximizeIcon, !this.isMaximized);
        (0, $jIDNV._setDisplayed)(this.minimizeIcon, this.isMaximized);
    }
    clearMaximizebleListeners() {
        if (this.maximizeListeners.length) {
            this.maximizeListeners.forEach((destroyListener)=>destroyListener());
            this.maximizeListeners.length = 0;
        }
        if (this.resizeListenerDestroy) {
            this.resizeListenerDestroy();
            this.resizeListenerDestroy = null;
        }
    }
    destroy() {
        this.maximizeButtonComp = this.destroyBean(this.maximizeButtonComp);
        this.clearMaximizebleListeners();
        super.destroy();
    }
    setResizable(resizable) {
        this.positionableFeature.setResizable(resizable);
    }
    setMovable(movable) {
        this.positionableFeature.setMovable(movable, this.eTitleBar);
    }
    setMaximizable(maximizable) {
        if (!maximizable) {
            this.clearMaximizebleListeners();
            if (this.maximizeButtonComp) {
                this.destroyBean(this.maximizeButtonComp);
                this.maximizeButtonComp = this.maximizeIcon = this.minimizeIcon = void 0;
            }
            return;
        }
        const eTitleBar = this.eTitleBar;
        if (!eTitleBar || maximizable === this.isMaximizable) return;
        this.isMaximizable = maximizable;
        const maximizeButtonComp = this.buildMaximizeAndMinimizeElements();
        this.refreshMaximizeIcon();
        maximizeButtonComp.addManagedElementListeners(maximizeButtonComp.getGui(), {
            click: this.toggleMaximize.bind(this)
        });
        this.addTitleBarButton(maximizeButtonComp, 0);
        this.maximizeListeners.push(...this.addManagedElementListeners(eTitleBar, {
            dblclick: this.toggleMaximize.bind(this)
        }));
        [this.resizeListenerDestroy] = this.addManagedListeners(this.positionableFeature, {
            resize: ()=>{
                this.isMaximized = false;
                this.refreshMaximizeIcon();
            }
        });
    }
    buildMaximizeAndMinimizeElements() {
        const maximizeButtonComp = this.maximizeButtonComp = this.createBean(new (0, $jIDNV.Component)({
            tag: "div",
            cls: "ag-dialog-button"
        }));
        const eGui = maximizeButtonComp.getGui();
        this.maximizeIcon = (0, $jIDNV._createIconNoSpan)("maximize", this.beans);
        eGui.appendChild(this.maximizeIcon);
        this.maximizeIcon.classList.add("ag-panel-title-bar-button-icon");
        this.minimizeIcon = (0, $jIDNV._createIconNoSpan)("minimize", this.beans);
        eGui.appendChild(this.minimizeIcon);
        this.minimizeIcon.classList.add("ag-panel-title-bar-button-icon");
        return maximizeButtonComp;
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/autocomplete/agAutocomplete.css-GENERATED.ts
var $5b7ccabde48fae90$var$agAutocompleteCSS = /*css*/ `.ag-autocomplete{align-items:center;display:flex;width:100%;>*{flex:1 1 auto}}.ag-autocomplete-list-popup{background-color:var(--ag-background-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);padding:0;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-autocomplete-list{height:calc(var(--ag-row-height)*6.5);min-width:200px;position:relative;width:100%}.ag-autocomplete-virtual-list-item{cursor:default;display:flex;height:var(--ag-list-item-height);&:focus-visible:after{content:none}&:hover{background-color:var(--ag-row-hover-color)}}.ag-autocomplete-row{align-items:center;display:flex;flex:1 1 auto;overflow:hidden}.ag-autocomplete-row-label{margin:0 var(--ag-widget-container-horizontal-padding);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-autocomplete-row-selected{background-color:var(--ag-selected-row-background-color)}`;
function $5b7ccabde48fae90$var$getVirtualListTemplate(cssIdentifier) {
    return {
        tag: "div",
        cls: `ag-virtual-list-viewport ag-${cssIdentifier}-virtual-list-viewport`,
        role: "presentation",
        children: [
            {
                tag: "div",
                ref: "eContainer",
                cls: `ag-virtual-list-container ag-${cssIdentifier}-virtual-list-container`
            }
        ]
    };
}
var $5b7ccabde48fae90$var$VirtualList = class extends (0, $jIDNV.TabGuardComp) {
    constructor(params){
        super($5b7ccabde48fae90$var$getVirtualListTemplate(params?.cssIdentifier || "default"));
        this.renderedRows = /* @__PURE__ */ new Map();
        this.rowHeight = 20;
        this.pageSize = -1;
        this.isScrolling = false;
        this.isHeightFromTheme = true;
        this.eContainer = (0, $jIDNV.RefPlaceholder);
        this.awaitStableCallbacks = [];
        const { cssIdentifier: cssIdentifier = "default", ariaRole: ariaRole = "listbox", listName: listName, moveItemCallback: moveItemCallback } = params || {};
        this.cssIdentifier = cssIdentifier;
        this.ariaRole = ariaRole;
        this.listName = listName;
        this.moveItemCallback = moveItemCallback;
    }
    wireBeans(beans) {
        this.environment = beans.environment;
    }
    postConstruct() {
        this.addScrollListener();
        this.rowHeight = this.getItemHeight();
        this.addResizeObserver();
        this.initialiseTabGuard({
            onFocusIn: (e)=>this.onFocusIn(e),
            onFocusOut: (e)=>this.onFocusOut(e),
            focusInnerElement: (fromBottom)=>this.focusInnerElement(fromBottom),
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.handleKeyDown(e)
        });
        this.refreshAriaProperties();
        this.addManagedEventListeners({
            gridStylesChanged: this.onGridStylesChanged.bind(this)
        });
    }
    onGridStylesChanged(e) {
        if (e.listItemHeightChanged) {
            this.rowHeight = this.getItemHeight();
            this.refresh();
        }
    }
    refreshAriaProperties() {
        const translate = this.getLocaleTextFunc();
        const listName = translate("ariaDefaultListName", this.listName || "List");
        const ariaEl = this.eContainer;
        (0, $jIDNV._setAriaRole)(ariaEl, this.model?.getRowCount() > 0 ? this.ariaRole : "presentation");
        (0, $jIDNV._setAriaLabel)(ariaEl, listName);
    }
    addResizeObserver() {
        const listener = ()=>(0, $jIDNV._requestAnimationFrame)(this.beans, ()=>this.drawVirtualRows());
        const destroyObserver = (0, $jIDNV._observeResize)(this.beans, this.getGui(), listener);
        this.addDestroyFunc(destroyObserver);
    }
    focusInnerElement(fromBottom) {
        this.focusRow(fromBottom ? this.model.getRowCount() - 1 : 0);
        return true;
    }
    onFocusIn(e) {
        const target = e.target;
        if (target.classList.contains("ag-virtual-list-item")) this.lastFocusedRowIndex = (0, $jIDNV._getAriaPosInSet)(target) - 1;
    }
    onFocusOut(e) {
        if (!this.getFocusableElement().contains(e.relatedTarget)) this.lastFocusedRowIndex = null;
    }
    handleKeyDown(e) {
        const { key: key, shiftKey: shiftKey } = e;
        switch(key){
            case (0, $jIDNV.KeyCode).UP:
            case (0, $jIDNV.KeyCode).DOWN:
                {
                    const isUp = key === (0, $jIDNV.KeyCode).UP;
                    e.preventDefault();
                    if (shiftKey) this.moveItem(isUp);
                    else this.navigate(isUp);
                }
                break;
            case (0, $jIDNV.KeyCode).PAGE_HOME:
            case (0, $jIDNV.KeyCode).PAGE_END:
            case (0, $jIDNV.KeyCode).PAGE_UP:
            case (0, $jIDNV.KeyCode).PAGE_DOWN:
                if (this.navigateToPage(key) !== null) e.preventDefault();
                break;
        }
    }
    onTabKeyDown(e) {
        (0, $jIDNV._stopPropagationForAgGrid)(e);
        this.forceFocusOutOfContainer(e.shiftKey);
    }
    getNextRow(up) {
        if (this.lastFocusedRowIndex == null) return void 0;
        const nextRow = this.lastFocusedRowIndex + (up ? -1 : 1);
        if (nextRow < 0 || nextRow >= this.model.getRowCount()) return void 0;
        return nextRow;
    }
    moveItem(up) {
        if (!this.moveItemCallback) return;
        const item = this.getComponentAt(this.lastFocusedRowIndex);
        if (!item) return;
        this.moveItemCallback(item, up);
    }
    navigate(up) {
        const nextRow = this.getNextRow(up);
        if (nextRow === void 0) return;
        this.focusRow(nextRow);
    }
    navigateToPage(key, fromItem = "focused") {
        let hasFocus = false;
        if (fromItem === "focused") {
            fromItem = this.getLastFocusedRow();
            hasFocus = true;
        }
        const rowCount = this.model.getRowCount() - 1;
        let newIndex = -1;
        if (key === (0, $jIDNV.KeyCode).PAGE_HOME) newIndex = 0;
        else if (key === (0, $jIDNV.KeyCode).PAGE_END) newIndex = rowCount;
        else if (key === (0, $jIDNV.KeyCode).PAGE_DOWN) newIndex = Math.min(fromItem + this.pageSize, rowCount);
        else if (key === (0, $jIDNV.KeyCode).PAGE_UP) newIndex = Math.max(fromItem - this.pageSize, 0);
        if (newIndex === -1) return null;
        if (hasFocus) this.focusRow(newIndex);
        else this.ensureIndexVisible(newIndex);
        return newIndex;
    }
    getLastFocusedRow() {
        return this.lastFocusedRowIndex;
    }
    focusRow(rowNumber) {
        if (this.isScrolling) return;
        this.isScrolling = true;
        this.ensureIndexVisible(rowNumber);
        (0, $jIDNV._requestAnimationFrame)(this.beans, ()=>{
            this.isScrolling = false;
            if (!this.isAlive()) return;
            const renderedRow = this.renderedRows.get(rowNumber);
            if (renderedRow) renderedRow.eDiv.focus();
        });
    }
    getComponentAt(rowIndex) {
        const comp = this.renderedRows.get(rowIndex);
        return comp && comp.rowComponent;
    }
    forEachRenderedRow(func) {
        this.renderedRows.forEach((value, key)=>func(value.rowComponent, key));
    }
    getItemHeight() {
        if (!this.isHeightFromTheme) return this.rowHeight;
        return this.environment.getDefaultListItemHeight();
    }
    /**
   * Returns true if the view had to be scrolled, otherwise, false.
   */ ensureIndexVisible(index, scrollPartialIntoView = true) {
        const lastRow = this.model.getRowCount();
        if (typeof index !== "number" || index < 0 || index >= lastRow) {
            (0, $jIDNV._warn)(229, {
                index: index
            });
            return false;
        }
        const rowTopPixel = index * this.rowHeight;
        const rowBottomPixel = rowTopPixel + this.rowHeight;
        const eGui = this.getGui();
        const viewportTopPixel = eGui.scrollTop;
        const viewportHeight = eGui.offsetHeight;
        const viewportBottomPixel = viewportTopPixel + viewportHeight;
        const diff = scrollPartialIntoView ? 0 : this.rowHeight;
        const viewportScrolledPastRow = viewportTopPixel > rowTopPixel + diff;
        const viewportScrolledBeforeRow = viewportBottomPixel < rowBottomPixel - diff;
        if (viewportScrolledPastRow) {
            eGui.scrollTop = rowTopPixel;
            return true;
        }
        if (viewportScrolledBeforeRow) {
            const newScrollPosition = rowBottomPixel - viewportHeight;
            eGui.scrollTop = newScrollPosition;
            return true;
        }
        return false;
    }
    setComponentCreator(componentCreator) {
        this.componentCreator = componentCreator;
    }
    setComponentUpdater(componentUpdater) {
        this.componentUpdater = componentUpdater;
    }
    getRowHeight() {
        return this.rowHeight;
    }
    getScrollTop() {
        return this.getGui().scrollTop;
    }
    setRowHeight(rowHeight) {
        this.isHeightFromTheme = false;
        this.rowHeight = rowHeight;
        this.refresh();
    }
    refresh(softRefresh) {
        if (this.model == null || !this.isAlive()) return;
        const rowCount = this.model.getRowCount();
        this.eContainer.style.height = `${rowCount * this.rowHeight}px`;
        this.refreshAriaProperties();
        this.awaitStable(()=>{
            if (!this.isAlive()) return;
            if (this.canSoftRefresh(softRefresh)) this.drawVirtualRows(true);
            else {
                this.clearVirtualRows();
                this.drawVirtualRows();
            }
        });
    }
    awaitStable(callback) {
        this.awaitStableCallbacks.push(callback);
        if (this.awaitStableCallbacks.length > 1) return;
        const rowCount = this.model.getRowCount();
        (0, $jIDNV._waitUntil)(()=>this.eContainer.clientHeight >= rowCount * this.rowHeight, ()=>{
            if (!this.isAlive()) return;
            const callbacks = this.awaitStableCallbacks;
            this.awaitStableCallbacks = [];
            callbacks.forEach((c)=>c());
        });
    }
    canSoftRefresh(softRefresh) {
        return !!(softRefresh && this.renderedRows.size && typeof this.model.areRowsEqual === "function" && this.componentUpdater);
    }
    clearVirtualRows() {
        this.renderedRows.forEach((_, rowIndex)=>this.removeRow(rowIndex));
    }
    drawVirtualRows(softRefresh) {
        if (!this.isAlive() || !this.model) return;
        const gui = this.getGui();
        const topPixel = gui.scrollTop;
        const bottomPixel = topPixel + gui.offsetHeight;
        if (topPixel === bottomPixel) this.clearVirtualRows();
        else {
            const firstRow = Math.floor(topPixel / this.rowHeight);
            const lastRow = Math.floor(bottomPixel / this.rowHeight);
            this.pageSize = Math.floor((bottomPixel - topPixel) / this.rowHeight);
            this.ensureRowsRendered(firstRow, lastRow, softRefresh);
        }
    }
    ensureRowsRendered(start, finish, softRefresh) {
        this.renderedRows.forEach((_, rowIndex)=>{
            if ((rowIndex < start || rowIndex > finish) && rowIndex !== this.lastFocusedRowIndex) this.removeRow(rowIndex);
        });
        if (softRefresh) this.refreshRows();
        for(let rowIndex = start; rowIndex <= finish; rowIndex++){
            if (this.renderedRows.has(rowIndex)) continue;
            if (rowIndex < this.model.getRowCount()) this.insertRow(rowIndex);
        }
    }
    insertRow(rowIndex) {
        const value = this.model.getRow(rowIndex);
        const role = this.ariaRole === "tree" ? "treeitem" : "option";
        const eDiv = (0, $jIDNV._createElement)({
            tag: "div",
            cls: `ag-virtual-list-item ag-${this.cssIdentifier}-virtual-list-item`,
            role: role,
            attrs: {
                tabindex: "-1"
            }
        });
        (0, $jIDNV._setAriaSetSize)(eDiv, this.model.getRowCount());
        (0, $jIDNV._setAriaPosInSet)(eDiv, rowIndex + 1);
        eDiv.style.height = `${this.rowHeight}px`;
        eDiv.style.top = `${this.rowHeight * rowIndex}px`;
        const rowComponent = this.componentCreator(value, eDiv);
        rowComponent.addGuiEventListener("focusin", ()=>this.lastFocusedRowIndex = rowIndex);
        eDiv.appendChild(rowComponent.getGui());
        if (this.renderedRows.has(rowIndex - 1)) this.renderedRows.get(rowIndex - 1).eDiv.insertAdjacentElement("afterend", eDiv);
        else if (this.renderedRows.has(rowIndex + 1)) this.renderedRows.get(rowIndex + 1).eDiv.insertAdjacentElement("beforebegin", eDiv);
        else this.eContainer.appendChild(eDiv);
        this.renderedRows.set(rowIndex, {
            rowComponent: rowComponent,
            eDiv: eDiv,
            value: value
        });
    }
    removeRow(rowIndex) {
        const component = this.renderedRows.get(rowIndex);
        this.eContainer.removeChild(component.eDiv);
        this.destroyBean(component.rowComponent);
        this.renderedRows.delete(rowIndex);
    }
    refreshRows() {
        const rowCount = this.model.getRowCount();
        this.renderedRows.forEach((row, rowIndex)=>{
            if (rowIndex >= rowCount) this.removeRow(rowIndex);
            else {
                const newValue = this.model.getRow(rowIndex);
                if (this.model.areRowsEqual?.(row.value, newValue)) this.componentUpdater(newValue, row.rowComponent);
                else this.removeRow(rowIndex);
            }
        });
    }
    addScrollListener() {
        this.addGuiEventListener("scroll", ()=>this.drawVirtualRows(), {
            passive: true
        });
    }
    setModel(model) {
        this.model = model;
    }
    getAriaElement() {
        return this.eContainer;
    }
    destroy() {
        if (!this.isAlive()) return;
        this.clearVirtualRows();
        this.awaitStableCallbacks.length = 0;
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$AgAutocompleteRowElement = {
    tag: "div",
    cls: "ag-autocomplete-row",
    role: "presentation",
    children: [
        {
            tag: "div",
            cls: "ag-autocomplete-row-label"
        }
    ]
};
var $5b7ccabde48fae90$var$AgAutocompleteRow = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$AgAutocompleteRowElement);
        this.hasHighlighting = false;
    }
    setState(value, selected) {
        this.value = value;
        this.render();
        this.updateSelected(selected);
    }
    updateSelected(selected) {
        this.toggleCss("ag-autocomplete-row-selected", selected);
    }
    setSearchString(searchString) {
        let keepHighlighting = false;
        const { value: value } = this;
        if (value && (0, $jIDNV._exists)(searchString)) {
            const index = value.toLocaleLowerCase().indexOf(searchString.toLocaleLowerCase());
            if (index >= 0) {
                keepHighlighting = true;
                this.hasHighlighting = true;
                const highlightEndIndex = index + searchString.length;
                const child = this.getGui().lastElementChild;
                (0, $jIDNV._clearElement)(child);
                child.append(// Start part
                value.slice(0, index), // Highlighted part wrapped in bold tag
                (0, $jIDNV._createElement)({
                    tag: "b",
                    children: value.slice(index, highlightEndIndex)
                }), // End part
                value.slice(highlightEndIndex));
            }
        }
        if (!keepHighlighting && this.hasHighlighting) {
            this.hasHighlighting = false;
            this.render();
        }
    }
    render() {
        this.getGui().lastElementChild.textContent = this.value ?? "\xa0";
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/autocomplete/agAutocompleteList.ts
var $5b7ccabde48fae90$var$AgAutocompleteListElement = {
    tag: "div",
    cls: "ag-autocomplete-list-popup",
    children: [
        {
            tag: "div",
            ref: "eList",
            cls: "ag-autocomplete-list"
        }
    ]
};
var $5b7ccabde48fae90$var$AgAutocompleteList = class extends (0, $jIDNV.PopupComponent) {
    constructor(params){
        super($5b7ccabde48fae90$var$AgAutocompleteListElement);
        this.params = params;
        this.eList = (0, $jIDNV.RefPlaceholder);
        this.searchString = "";
    }
    postConstruct() {
        this.autocompleteEntries = this.params.autocompleteEntries;
        this.virtualList = this.createManagedBean(new $5b7ccabde48fae90$var$VirtualList({
            cssIdentifier: "autocomplete"
        }));
        this.virtualList.setComponentCreator(this.createRowComponent.bind(this));
        this.eList.appendChild(this.virtualList.getGui());
        this.virtualList.setModel({
            getRowCount: ()=>this.autocompleteEntries.length,
            getRow: (index)=>this.autocompleteEntries[index]
        });
        const virtualListGui = this.virtualList.getGui();
        this.addManagedListeners(virtualListGui, {
            click: ()=>this.params.onConfirmed(),
            mousemove: this.onMouseMove.bind(this),
            mousedown: (e)=>e.preventDefault()
        });
        this.setSelectedValue(0);
    }
    onNavigationKeyDown(event, key) {
        event.preventDefault();
        const oldIndex = this.autocompleteEntries.indexOf(this.selectedValue);
        const newIndex = key === (0, $jIDNV.KeyCode).UP ? oldIndex - 1 : oldIndex + 1;
        this.checkSetSelectedValue(newIndex);
    }
    setSearch(searchString) {
        this.searchString = searchString;
        if ((0, $jIDNV._exists)(searchString)) this.runSearch();
        else {
            this.autocompleteEntries = this.params.autocompleteEntries;
            this.virtualList.refresh();
            this.checkSetSelectedValue(0);
        }
        this.updateSearchInList();
    }
    runContainsSearch(searchString, searchStrings) {
        let topMatch;
        let topMatchStartsWithSearchString = false;
        const lowerCaseSearchString = searchString.toLocaleLowerCase();
        const allMatches = searchStrings.filter((string)=>{
            const lowerCaseString = string.toLocaleLowerCase();
            const index = lowerCaseString.indexOf(lowerCaseSearchString);
            const startsWithSearchString = index === 0;
            const isMatch = index >= 0;
            if (isMatch && (!topMatch || !topMatchStartsWithSearchString && startsWithSearchString || topMatchStartsWithSearchString === startsWithSearchString && string.length < topMatch.length)) {
                topMatch = string;
                topMatchStartsWithSearchString = startsWithSearchString;
            }
            return isMatch;
        });
        if (!topMatch && allMatches.length) topMatch = allMatches[0];
        return {
            topMatch: topMatch,
            allMatches: allMatches
        };
    }
    runSearch() {
        const { autocompleteEntries: autocompleteEntries, useFuzzySearch: useFuzzySearch, forceLastSelection: forceLastSelection } = this.params;
        const searchStrings = autocompleteEntries.map((v)=>v.displayValue ?? v.key);
        let matchingStrings;
        let topSuggestion;
        if (useFuzzySearch) {
            matchingStrings = (0, $jIDNV._fuzzySuggestions)({
                inputValue: this.searchString,
                allSuggestions: searchStrings,
                hideIrrelevant: true
            }).values;
            topSuggestion = matchingStrings.length ? matchingStrings[0] : void 0;
        } else {
            const containsMatches = this.runContainsSearch(this.searchString, searchStrings);
            matchingStrings = containsMatches.allMatches;
            topSuggestion = containsMatches.topMatch;
        }
        let filteredEntries = autocompleteEntries.filter(({ key: key, displayValue: displayValue })=>matchingStrings.includes(displayValue ?? key));
        if (!filteredEntries.length && this.selectedValue && forceLastSelection?.(this.selectedValue, this.searchString)) filteredEntries = [
            this.selectedValue
        ];
        this.autocompleteEntries = filteredEntries;
        this.virtualList.refresh();
        if (!topSuggestion) return;
        const topSuggestionIndex = matchingStrings.indexOf(topSuggestion);
        this.checkSetSelectedValue(topSuggestionIndex);
    }
    updateSearchInList() {
        this.virtualList.forEachRenderedRow((row)=>row.setSearchString(this.searchString));
    }
    checkSetSelectedValue(index) {
        if (index >= 0 && index < this.autocompleteEntries.length) this.setSelectedValue(index);
    }
    setSelectedValue(index) {
        const value = this.autocompleteEntries[index];
        if (this.selectedValue === value) return;
        this.selectedValue = value;
        this.virtualList.ensureIndexVisible(index);
        this.virtualList.forEachRenderedRow((cmp, idx)=>{
            cmp.updateSelected(index === idx);
        });
    }
    createRowComponent(value) {
        const row = new $5b7ccabde48fae90$var$AgAutocompleteRow();
        this.createBean(row);
        row.setState(value.displayValue ?? value.key, value === this.selectedValue);
        return row;
    }
    onMouseMove(mouseEvent) {
        const virtualList = this.virtualList;
        const rect = virtualList.getGui().getBoundingClientRect();
        const scrollTop = virtualList.getScrollTop();
        const mouseY = mouseEvent.clientY - rect.top + scrollTop;
        const row = Math.floor(mouseY / virtualList.getRowHeight());
        this.checkSetSelectedValue(row);
    }
    afterGuiAttached() {
        this.virtualList.refresh();
    }
    getSelectedValue() {
        if (!this.autocompleteEntries.length) return null;
        return this.selectedValue ?? null;
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/autocomplete/agAutocomplete.ts
var $5b7ccabde48fae90$var$AgAutocompleteElement = {
    tag: "div",
    cls: "ag-autocomplete",
    role: "presentation",
    children: [
        {
            tag: "ag-input-text-field",
            ref: "eAutocompleteInput"
        }
    ]
};
var $5b7ccabde48fae90$var$AgAutocomplete = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$AgAutocompleteElement, [
            (0, $jIDNV.AgInputTextFieldSelector)
        ]);
        this.eAutocompleteInput = (0, $jIDNV.RefPlaceholder);
        this.isListOpen = false;
        this.lastPosition = 0;
        this.valid = true;
        this.registerCSS($5b7ccabde48fae90$var$agAutocompleteCSS);
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
    }
    postConstruct() {
        this.eAutocompleteInput.onValueChange((value)=>this.onValueChanged(value));
        this.eAutocompleteInput.getInputElement().setAttribute("autocomplete", "off");
        this.addGuiEventListener("keydown", this.onKeyDown.bind(this));
        this.addGuiEventListener("click", this.updatePositionAndList.bind(this));
        this.addDestroyFunc(()=>{
            this.destroyBean(this.autocompleteList);
        });
        this.addGuiEventListener("focusout", ()=>this.onFocusOut());
    }
    onValueChanged(value) {
        const parsedValue = (0, $jIDNV._makeNull)(value);
        this.updateValue(parsedValue);
        this.updateAutocompleteList(parsedValue);
    }
    updateValue(value) {
        this.updateLastPosition();
        this.dispatchLocalEvent({
            type: "eventValueChanged",
            value: value
        });
        this.validate(value);
    }
    updateAutocompleteList(value) {
        const autocompleteListParams = this.listGenerator?.(value, this.lastPosition) ?? {
            enabled: false
        };
        if (!autocompleteListParams.type || autocompleteListParams.type !== this.autocompleteListParams?.type) {
            if (this.isListOpen) this.closeList();
        }
        const isListOpen = this.isListOpen;
        this.autocompleteListParams = autocompleteListParams;
        if (autocompleteListParams?.enabled) {
            if (!isListOpen) this.openList();
            const { searchString: searchString } = autocompleteListParams;
            this.autocompleteList.setSearch(searchString ?? "");
        } else if (isListOpen) this.closeList();
    }
    onKeyDown(event) {
        const key = event.key;
        this.updateLastPosition();
        switch(key){
            case (0, $jIDNV.KeyCode).ENTER:
                this.onEnterKeyDown(event);
                break;
            case (0, $jIDNV.KeyCode).TAB:
                this.onTabKeyDown(event);
                break;
            case (0, $jIDNV.KeyCode).DOWN:
            case (0, $jIDNV.KeyCode).UP:
                this.onUpDownKeyDown(event, key);
                break;
            case (0, $jIDNV.KeyCode).LEFT:
            case (0, $jIDNV.KeyCode).RIGHT:
            case (0, $jIDNV.KeyCode).PAGE_HOME:
            case (0, $jIDNV.KeyCode).PAGE_END:
                setTimeout(()=>{
                    this.updatePositionAndList();
                });
                break;
            case (0, $jIDNV.KeyCode).ESCAPE:
                this.onEscapeKeyDown(event);
                break;
            case (0, $jIDNV.KeyCode).SPACE:
                if (event.ctrlKey && !this.isListOpen) {
                    event.preventDefault();
                    this.forceOpenList();
                }
                break;
        }
    }
    confirmSelection() {
        const selectedValue = this.autocompleteList?.getSelectedValue();
        if (selectedValue) {
            this.closeList();
            this.dispatchLocalEvent({
                type: "eventOptionSelected",
                value: this.getValue(),
                position: this.lastPosition,
                updateEntry: selectedValue,
                autocompleteType: this.autocompleteListParams.type
            });
        }
    }
    onTabKeyDown(event) {
        if (this.isListOpen) {
            event.preventDefault();
            event.stopPropagation();
            this.confirmSelection();
        }
    }
    onEnterKeyDown(event) {
        event.preventDefault();
        if (this.isListOpen) this.confirmSelection();
        else this.onCompleted();
    }
    onUpDownKeyDown(event, key) {
        event.preventDefault();
        if (!this.isListOpen) this.forceOpenList();
        else this.autocompleteList?.onNavigationKeyDown(event, key);
    }
    onEscapeKeyDown(event) {
        if (this.isListOpen) {
            event.preventDefault();
            event.stopPropagation();
            this.closeList();
            this.setCaret(this.lastPosition, true);
        }
    }
    onFocusOut() {
        if (this.isListOpen) this.closeList();
    }
    updatePositionAndList() {
        this.updateLastPosition();
        this.updateAutocompleteList(this.eAutocompleteInput.getValue() ?? null);
    }
    setCaret(position, setFocus) {
        if (setFocus || (0, $jIDNV._isNothingFocused)(this.beans)) this.eAutocompleteInput.getFocusableElement().focus();
        const eInput = this.eAutocompleteInput.getInputElement();
        eInput.setSelectionRange(position, position);
        if (position === eInput.value.length) eInput.scrollLeft = eInput.scrollWidth;
    }
    forceOpenList() {
        this.onValueChanged(this.eAutocompleteInput.getValue());
    }
    updateLastPosition() {
        this.lastPosition = this.eAutocompleteInput.getInputElement().selectionStart ?? 0;
    }
    validate(value) {
        if (!this.validator) return;
        const validationMessage = this.validationMessage = this.validator(value);
        this.eAutocompleteInput.getInputElement().setCustomValidity(validationMessage ?? "");
        this.valid = !validationMessage;
        this.dispatchLocalEvent({
            type: "eventValidChanged",
            isValid: this.valid,
            validationMessage: validationMessage
        });
    }
    openList() {
        this.isListOpen = true;
        this.autocompleteList = this.createBean(new $5b7ccabde48fae90$var$AgAutocompleteList({
            autocompleteEntries: this.autocompleteListParams.entries,
            onConfirmed: ()=>this.confirmSelection(),
            forceLastSelection: this.forceLastSelection
        }));
        const ePopupGui = this.autocompleteList.getGui();
        const positionParams = {
            ePopup: ePopupGui,
            type: "autocomplete",
            eventSource: this.getGui(),
            position: "under",
            alignSide: this.gos.get("enableRtl") ? "right" : "left",
            keepWithinBounds: true
        };
        const addPopupRes = this.popupSvc.addPopup({
            eChild: ePopupGui,
            anchorToElement: this.getGui(),
            positionCallback: ()=>this.popupSvc.positionPopupByComponent(positionParams),
            ariaLabel: this.listAriaLabel
        });
        this.hidePopup = addPopupRes.hideFunc;
        this.autocompleteList.afterGuiAttached();
    }
    closeList() {
        this.isListOpen = false;
        this.hidePopup();
        this.destroyBean(this.autocompleteList);
        this.autocompleteList = null;
    }
    onCompleted() {
        if (this.isListOpen) this.closeList();
        this.dispatchLocalEvent({
            type: "eventValueConfirmed",
            value: this.getValue(),
            isValid: this.isValid()
        });
    }
    getValue() {
        return (0, $jIDNV._makeNull)(this.eAutocompleteInput.getValue());
    }
    setInputPlaceholder(placeholder) {
        this.eAutocompleteInput.setInputPlaceholder(placeholder);
        return this;
    }
    setInputAriaLabel(label) {
        this.eAutocompleteInput.setInputAriaLabel(label);
        return this;
    }
    setListAriaLabel(label) {
        this.listAriaLabel = label;
        return this;
    }
    setListGenerator(listGenerator) {
        this.listGenerator = listGenerator;
        return this;
    }
    setValidator(validator) {
        this.validator = validator;
        return this;
    }
    isValid() {
        return this.valid;
    }
    setValue(params) {
        const { value: value, position: position, silent: silent, updateListOnlyIfOpen: updateListOnlyIfOpen, restoreFocus: restoreFocus } = params;
        this.eAutocompleteInput.setValue(value, true);
        this.setCaret(position ?? this.lastPosition, restoreFocus);
        if (!silent) this.updateValue(value);
        if (!updateListOnlyIfOpen || this.isListOpen) this.updateAutocompleteList(value);
    }
    setForceLastSelection(forceLastSelection) {
        this.forceLastSelection = forceLastSelection;
        return this;
    }
    setInputDisabled(disabled) {
        this.eAutocompleteInput.setDisabled(disabled);
        return this;
    }
};
var $5b7ccabde48fae90$var$AgAutocompleteSelector = {
    selector: "AG-AUTOCOMPLETE",
    component: $5b7ccabde48fae90$var$AgAutocomplete
};
// packages/ag-grid-enterprise/src/advancedFilter/advancedFilterComp.ts
var $5b7ccabde48fae90$var$DEFAULT_ADVANCED_FILTER_PARAMS = {
    buttons: [
        "apply"
    ],
    suppressBuilderButton: false
};
var $5b7ccabde48fae90$var$ButtonLocaleMap = {
    apply: "advancedFilterApply",
    clear: "advancedFilterClear",
    cancel: "advancedFilterCancel",
    reset: "advancedFilterReset"
};
var $5b7ccabde48fae90$var$AdvancedFilterElement = {
    tag: "div",
    cls: "ag-advanced-filter",
    role: "presentation",
    attrs: {
        tabindex: "-1"
    },
    children: [
        {
            tag: "ag-autocomplete",
            ref: "eAutocomplete"
        },
        {
            tag: "ag-filter-button",
            ref: "eButtons",
            cls: "ag-advanced-filter-buttons"
        },
        {
            tag: "button",
            ref: "eBuilderFilterButton",
            cls: "ag-button ag-advanced-filter-builder-button",
            children: [
                {
                    tag: "span",
                    ref: "eBuilderFilterButtonIcon",
                    attrs: {
                        "aria-hidden": "true"
                    }
                },
                {
                    tag: "span",
                    ref: "eBuilderFilterButtonLabel",
                    cls: "ag-advanced-filter-builder-button-label"
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$AdvancedFilterComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$AdvancedFilterElement, [
            $5b7ccabde48fae90$var$AgAutocompleteSelector,
            (0, $jIDNV.AgFilterButtonSelector)
        ]);
        this.eAutocomplete = (0, $jIDNV.RefPlaceholder);
        this.eButtons = (0, $jIDNV.RefPlaceholder);
        this.eBuilderFilterButton = (0, $jIDNV.RefPlaceholder);
        this.eBuilderFilterButtonIcon = (0, $jIDNV.RefPlaceholder);
        this.eBuilderFilterButtonLabel = (0, $jIDNV.RefPlaceholder);
        this.expressionParser = null;
        this.isApplyDisabled = true;
        this.builderOpen = false;
    }
    wireBeans(beans) {
        this.advFilterExpSvc = beans.advFilterExpSvc;
        this.advancedFilter = beans.advancedFilter;
        this.filterManager = beans.filterManager;
        this.registry = beans.registry;
    }
    postConstruct() {
        this.tooltipFeature = this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.getGui(),
            getTooltipShowDelayOverride: ()=>1e3,
            getLocation: ()=>"advancedFilter"
        }));
        this.eAutocomplete.setListGenerator((_value, position)=>this.generateAutocompleteListParams(position)).setValidator(()=>this.validateValue()).setForceLastSelection((lastSelection, searchString)=>this.forceLastSelection(lastSelection, searchString)).setInputAriaLabel(this.advFilterExpSvc.translate("ariaAdvancedFilterInput")).setListAriaLabel(this.advFilterExpSvc.translate("ariaLabelAdvancedFilterAutocomplete"));
        this.refresh();
        this.addManagedListeners(this.eAutocomplete, {
            eventValueChanged: ({ value: value })=>this.onValueChanged(value),
            eventValueConfirmed: ({ isValid: isValid })=>this.onValueConfirmed(isValid),
            eventOptionSelected: ({ position: position, updateEntry: updateEntry, autocompleteType: autocompleteType })=>this.onOptionSelected(position, updateEntry, autocompleteType),
            eventValidChanged: ({ isValid: isValid, validationMessage: validationMessage })=>this.onValidChanged(isValid, validationMessage)
        });
        const { buttons: buttons, suppressBuilderButton: suppressBuilderButton } = {
            ...$5b7ccabde48fae90$var$DEFAULT_ADVANCED_FILTER_PARAMS,
            ...this.gos.get("advancedFilterParams")
        };
        this.setupButtons(buttons);
        this.setupBuilderButton(suppressBuilderButton);
        this.beans.gos.addManagedPropertyListener("advancedFilterParams", (event)=>{
            const currentValue = {
                ...$5b7ccabde48fae90$var$DEFAULT_ADVANCED_FILTER_PARAMS,
                ...event.currentValue
            };
            const previousValue = {
                ...$5b7ccabde48fae90$var$DEFAULT_ADVANCED_FILTER_PARAMS,
                ...event.previousValue
            };
            if (currentValue.buttons !== previousValue.buttons) {
                const buttons2 = currentValue.buttons.map((type)=>({
                        type: type,
                        label: this.advFilterExpSvc.translate($5b7ccabde48fae90$var$ButtonLocaleMap[type])
                    }));
                this.eButtons.updateButtons(buttons2);
            }
            if (currentValue.suppressBuilderButton !== previousValue.suppressBuilderButton) (0, $jIDNV._setDisplayed)(this.eBuilderFilterButton, !currentValue.suppressBuilderButton);
        });
    }
    refresh() {
        const expression = this.advancedFilter.getExpressionDisplayValue();
        this.eAutocomplete.setValue({
            value: expression ?? "",
            position: expression?.length,
            updateListOnlyIfOpen: true
        });
    }
    setInputDisabled(disabled) {
        this.eAutocomplete.setInputDisabled(disabled);
        this.eButtons.updateValidity(!disabled && !this.isApplyDisabled && !this.advancedFilter.isCurrentExpressionApplied());
    }
    setupButtons(actions) {
        const buttons = actions.map((type)=>({
                type: type,
                label: this.advFilterExpSvc.translate($5b7ccabde48fae90$var$ButtonLocaleMap[type])
            }));
        const getListener = (action)=>()=>{
                this.updateModel(action);
            };
        this.eButtons.addManagedListeners(this.eButtons, {
            apply: getListener("apply"),
            clear: getListener("clear"),
            reset: getListener("reset"),
            cancel: getListener("cancel")
        });
        this.eButtons.updateButtons(buttons);
    }
    updateModel(action) {
        switch(action){
            case "apply":
                this.onValueConfirmed(this.eAutocomplete.isValid());
                break;
            case "reset":
                this.advancedFilter.setModel(null);
                this.filterManager?.onFilterChanged({
                    source: "advancedFilter"
                });
                break;
            case "cancel":
                this.advancedFilter.setModel(this.advancedFilter.getModel());
                this.filterManager?.onFilterChanged({
                    source: "advancedFilter"
                });
                break;
            case "clear":
                this.eAutocomplete.setValue({
                    value: "",
                    restoreFocus: true
                });
                break;
        }
    }
    setupBuilderButton(suppressed) {
        this.eBuilderFilterButtonIcon.appendChild((0, $jIDNV._createIconNoSpan)("advancedFilterBuilder", this.beans));
        this.eBuilderFilterButtonLabel.textContent = this.advFilterExpSvc.translate("advancedFilterBuilder");
        this.activateTabIndex([
            this.eBuilderFilterButton
        ]);
        this.addManagedElementListeners(this.eBuilderFilterButton, {
            click: ()=>this.openBuilder()
        });
        this.addManagedListeners(this.advancedFilter.getCtrl(), {
            advancedFilterBuilderClosed: ()=>this.closeBuilder()
        });
        (0, $jIDNV._setDisplayed)(this.eBuilderFilterButton, !suppressed);
    }
    onValueChanged(value) {
        value = (0, $jIDNV._makeNull)(value);
        this.advancedFilter.setExpressionDisplayValue(value);
        this.expressionParser = this.advancedFilter.createExpressionParser(value);
        const updatedExpression = this.expressionParser?.parseExpression();
        if (updatedExpression && updatedExpression !== value) this.eAutocomplete.setValue({
            value: updatedExpression,
            silent: true,
            restoreFocus: true
        });
    }
    onValueConfirmed(isValid) {
        if (!isValid || this.isApplyDisabled) return;
        this.eButtons?.updateValidity(false);
        this.advancedFilter.applyExpression();
        this.filterManager?.onFilterChanged({
            source: "advancedFilter"
        });
    }
    onOptionSelected(position, updateEntry, type) {
        const { updatedValue: updatedValue, updatedPosition: updatedPosition, hideAutocomplete: hideAutocomplete } = this.updateExpression(position, updateEntry, type);
        this.eAutocomplete.setValue({
            value: updatedValue,
            position: updatedPosition,
            updateListOnlyIfOpen: hideAutocomplete,
            restoreFocus: true
        });
    }
    validateValue() {
        return this.expressionParser?.isValid() ? null : this.expressionParser?.getValidationMessage() ?? null;
    }
    onValidChanged(isValid, validationMessage) {
        this.isApplyDisabled = !isValid || this.advancedFilter.isCurrentExpressionApplied();
        this.eButtons.updateValidity(!this.isApplyDisabled);
        this.tooltipFeature?.setTooltipAndRefresh(validationMessage);
    }
    generateAutocompleteListParams(position) {
        return this.expressionParser ? this.expressionParser.getAutocompleteListParams(position) : this.advFilterExpSvc.getDefaultAutocompleteListParams("");
    }
    updateExpression(position, updateEntry, type) {
        this.advFilterExpSvc.updateAutocompleteCache(updateEntry, type);
        return this.expressionParser?.updateExpression(position, updateEntry, type) ?? this.advancedFilter.getDefaultExpression(updateEntry);
    }
    forceLastSelection({ key: key, displayValue: displayValue }, searchString) {
        return !!searchString.toLocaleLowerCase().match(`^${(displayValue ?? key).toLocaleLowerCase()}\\s*$`);
    }
    openBuilder() {
        if (this.builderOpen) return;
        this.builderOpen = true;
        (0, $jIDNV._setDisabled)(this.eBuilderFilterButton, true);
        this.advancedFilter.getCtrl().toggleFilterBuilder({
            source: "ui",
            eventSource: this.eBuilderFilterButton
        });
    }
    closeBuilder() {
        if (!this.builderOpen) return;
        this.builderOpen = false;
        (0, $jIDNV._setDisabled)(this.eBuilderFilterButton, false);
        this.eBuilderFilterButton.focus();
    }
};
var $5b7ccabde48fae90$var$AdvancedFilterHeaderElement = {
    tag: "div",
    cls: "ag-advanced-filter-header",
    role: "row"
};
var $5b7ccabde48fae90$var$AdvancedFilterHeaderComp = class extends (0, $jIDNV.Component) {
    constructor(enabled){
        super($5b7ccabde48fae90$var$AdvancedFilterHeaderElement);
        this.enabled = enabled;
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.focusSvc = beans.focusSvc;
        this.ctrlsSvc = beans.ctrlsSvc;
    }
    postConstruct() {
        this.setupAdvancedFilter(this.enabled);
        this.addDestroyFunc(()=>this.destroyBean(this.eAdvancedFilter));
        const heightListener = ()=>{
            if (this.enabled) this.setEnabledHeight();
        };
        this.addManagedEventListeners({
            gridColumnsChanged: ()=>this.onGridColumnsChanged(),
            columnHeaderHeightChanged: heightListener,
            gridStylesChanged: heightListener
        });
        this.addManagedPropertyListener("headerHeight", heightListener);
        this.addManagedPropertyListener("floatingFiltersHeight", heightListener);
        this.addGuiEventListener("keydown", (event)=>this.onKeyDown(event));
        this.addGuiEventListener("focusout", (event)=>{
            if (!this.getFocusableElement().contains(event.relatedTarget)) this.focusSvc.clearAdvancedFilterColumn();
        });
    }
    getFocusableElement() {
        return this.eAdvancedFilter?.getGui() ?? this.getGui();
    }
    setEnabled(enabled) {
        if (enabled === this.enabled) return;
        this.setupAdvancedFilter(enabled);
    }
    refresh() {
        this.eAdvancedFilter?.refresh();
    }
    getHeight() {
        return this.height;
    }
    setInputDisabled(disabled) {
        this.eAdvancedFilter?.setInputDisabled(disabled);
    }
    setupAdvancedFilter(enabled) {
        const eGui = this.getGui();
        if (enabled) {
            this.eAdvancedFilter = this.createBean(new $5b7ccabde48fae90$var$AdvancedFilterComp());
            const eAdvancedFilterGui = this.eAdvancedFilter.getGui();
            this.eAdvancedFilter.addCss("ag-advanced-filter-header-cell");
            this.setEnabledHeight();
            this.setAriaRowIndex();
            (0, $jIDNV._setAriaRole)(eAdvancedFilterGui, "gridcell");
            (0, $jIDNV._setAriaColIndex)(eAdvancedFilterGui, 1);
            this.setAriaColumnCount(eAdvancedFilterGui);
            eGui.appendChild(eAdvancedFilterGui);
        } else {
            (0, $jIDNV._clearElement)(eGui);
            this.destroyBean(this.eAdvancedFilter);
            this.height = 0;
        }
        (0, $jIDNV._setDisplayed)(eGui, enabled);
        this.enabled = enabled;
    }
    setEnabledHeight() {
        const eGui = this.getGui();
        this.height = (0, $jIDNV._getFloatingFiltersHeight)(this.beans);
        const height = `${this.height}px`;
        eGui.style.height = height;
        eGui.style.minHeight = height;
    }
    setAriaColumnCount(eAdvancedFilterGui) {
        (0, $jIDNV._setAriaColSpan)(eAdvancedFilterGui, this.colModel.getCols().length);
    }
    setAriaRowIndex() {
        (0, $jIDNV._setAriaRowIndex)(this.getGui(), this.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0);
    }
    onGridColumnsChanged() {
        if (!this.eAdvancedFilter) return;
        this.setAriaColumnCount(this.eAdvancedFilter.getGui());
        this.setAriaRowIndex();
    }
    onKeyDown(event) {
        switch(event.key){
            case (0, $jIDNV.KeyCode).ENTER:
                if (this.hasFocus()) {
                    if ((0, $jIDNV._focusInto)(this.getFocusableElement())) event.preventDefault();
                }
                break;
            case (0, $jIDNV.KeyCode).ESCAPE:
                if (!this.hasFocus()) this.getFocusableElement().focus();
                break;
            case (0, $jIDNV.KeyCode).UP:
                this.navigateUpDown(true, event);
                break;
            case (0, $jIDNV.KeyCode).DOWN:
                this.navigateUpDown(false, event);
                break;
            case (0, $jIDNV.KeyCode).TAB:
                if (this.hasFocus()) this.navigateLeftRight(event);
                else {
                    const nextFocusableEl = (0, $jIDNV._findNextFocusableElement)(this.beans, this.getFocusableElement(), null, event.shiftKey);
                    if (nextFocusableEl) {
                        event.preventDefault();
                        nextFocusableEl.focus();
                    } else this.navigateLeftRight(event);
                }
                break;
        }
    }
    navigateUpDown(backwards, event) {
        if (this.hasFocus()) {
            if (this.focusSvc.focusNextFromAdvancedFilter(backwards)) event.preventDefault();
        }
    }
    navigateLeftRight(event) {
        if (event.shiftKey ? this.focusSvc.focusLastHeader() : this.focusSvc.focusNextFromAdvancedFilter(false, true)) event.preventDefault();
    }
    hasFocus() {
        return (0, $jIDNV._getActiveDomElement)(this.beans) === this.getFocusableElement();
    }
};
var $5b7ccabde48fae90$var$LIST_ITEM_HOVERED = "ag-list-item-hovered";
var $5b7ccabde48fae90$var$VirtualListDragFeature = class extends (0, $jIDNV.BeanStub) {
    constructor(comp, virtualList, params){
        super();
        this.comp = comp;
        this.virtualList = virtualList;
        this.params = params;
        this.currentDragValue = null;
        this.lastHoveredListItem = null;
    }
    wireBeans(beans) {
        this.dragAndDrop = beans.dragAndDrop;
    }
    postConstruct() {
        this.addManagedListeners(this.params.eventSource, {
            [this.params.listItemDragStartEvent]: this.listItemDragStart.bind(this),
            [this.params.listItemDragEndEvent]: this.listItemDragEnd.bind(this)
        });
        this.createDropTarget();
        this.createAutoScrollService();
    }
    listItemDragStart(event) {
        this.currentDragValue = this.params.getCurrentDragValue(event);
        this.moveBlocked = this.params.isMoveBlocked(this.currentDragValue);
    }
    listItemDragEnd() {
        window.setTimeout(()=>{
            this.currentDragValue = null;
            this.moveBlocked = false;
        }, 10);
    }
    createDropTarget() {
        const dropTarget = {
            isInterestedIn: (type)=>type === this.params.dragSourceType,
            getIconName: ()=>this.moveBlocked ? "pinned" : "move",
            getContainer: ()=>this.comp.getGui(),
            onDragging: (e)=>this.onDragging(e),
            onDragStop: ()=>this.onDragStop(),
            onDragLeave: ()=>this.onDragLeave(),
            onDragCancel: ()=>this.onDragCancel()
        };
        this.dragAndDrop?.addDropTarget(dropTarget);
    }
    createAutoScrollService() {
        const virtualListGui = this.virtualList.getGui();
        this.autoScrollService = new (0, $jIDNV.AutoScrollService)({
            scrollContainer: virtualListGui,
            scrollAxis: "y",
            getVerticalPosition: ()=>virtualListGui.scrollTop,
            setVerticalPosition: (position)=>virtualListGui.scrollTop = position
        });
    }
    onDragging(e) {
        if (!this.currentDragValue || this.moveBlocked) return;
        const hoveredListItem = this.getListDragItem(e);
        const comp = this.virtualList.getComponentAt(hoveredListItem.rowIndex);
        if (!comp) return;
        const el = comp.getGui().parentElement;
        if (this.lastHoveredListItem && this.lastHoveredListItem.rowIndex === hoveredListItem.rowIndex && this.lastHoveredListItem.position === hoveredListItem.position) return;
        this.autoScrollService.check(e.event);
        this.clearHoveredItems();
        this.lastHoveredListItem = hoveredListItem;
        (0, $jIDNV._radioCssClass)(el, $5b7ccabde48fae90$var$LIST_ITEM_HOVERED);
        (0, $jIDNV._radioCssClass)(el, `ag-item-highlight-${hoveredListItem.position}`);
    }
    getListDragItem(e) {
        const virtualListGui = this.virtualList.getGui();
        const paddingTop = parseFloat(window.getComputedStyle(virtualListGui).paddingTop);
        const rowHeight = this.virtualList.getRowHeight();
        const scrollTop = this.virtualList.getScrollTop();
        const rowIndex = Math.max(0, (e.y - paddingTop + scrollTop) / rowHeight);
        const maxLen = this.params.getNumRows(this.comp) - 1;
        const normalizedRowIndex = Math.min(maxLen, rowIndex) | 0;
        return {
            rowIndex: normalizedRowIndex,
            position: Math.round(rowIndex) > rowIndex || rowIndex > maxLen ? "bottom" : "top",
            component: this.virtualList.getComponentAt(normalizedRowIndex)
        };
    }
    onDragStop() {
        if (this.moveBlocked) return;
        this.params.moveItem(this.currentDragValue, this.lastHoveredListItem);
        this.clearDragProperties();
    }
    onDragCancel() {
        this.clearDragProperties();
    }
    onDragLeave() {
        this.clearDragProperties();
    }
    clearDragProperties() {
        this.clearHoveredItems();
        this.autoScrollService.ensureCleared();
    }
    clearHoveredItems() {
        const virtualListGui = this.virtualList.getGui();
        virtualListGui.querySelectorAll(`.${$5b7ccabde48fae90$var$LIST_ITEM_HOVERED}`).forEach((el)=>{
            [
                $5b7ccabde48fae90$var$LIST_ITEM_HOVERED,
                "ag-item-highlight-top",
                "ag-item-highlight-bottom"
            ].forEach((cls)=>{
                el.classList.remove(cls);
            });
        });
        this.lastHoveredListItem = null;
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/builder/advancedFilterBuilderDragFeature.ts
var $5b7ccabde48fae90$var$AdvancedFilterBuilderDragFeature = class extends (0, $jIDNV.BeanStub) {
    constructor(comp, virtualList){
        super();
        this.comp = comp;
        this.virtualList = virtualList;
    }
    postConstruct() {
        this.createManagedBean(new $5b7ccabde48fae90$var$VirtualListDragFeature(this.comp, this.virtualList, {
            dragSourceType: (0, $jIDNV.DragSourceType).AdvancedFilterBuilder,
            listItemDragStartEvent: "advancedFilterBuilderDragStarted",
            listItemDragEndEvent: "advancedFilterBuilderDragEnded",
            eventSource: this,
            getCurrentDragValue: (listItemDragStartEvent)=>this.getCurrentDragValue(listItemDragStartEvent),
            isMoveBlocked: ()=>false,
            getNumRows: (comp)=>comp.getNumItems(),
            moveItem: (currentDragValue, lastHoveredListItem)=>this.moveItem(currentDragValue, lastHoveredListItem)
        }));
    }
    getCurrentDragValue(listItemDragStartEvent) {
        return listItemDragStartEvent.item;
    }
    moveItem(currentDragValue, lastHoveredListItem) {
        this.comp.moveItem(currentDragValue, lastHoveredListItem);
    }
};
var $5b7ccabde48fae90$var$AgPillElement = {
    tag: "div",
    cls: "ag-pill",
    role: "option",
    children: [
        {
            tag: "span",
            ref: "eText",
            cls: "ag-pill-text"
        },
        {
            tag: "span",
            ref: "eButton",
            cls: "ag-button ag-pill-button",
            role: "presentation"
        }
    ]
};
var $5b7ccabde48fae90$var$AgPill = class extends (0, $jIDNV.Component) {
    constructor(config){
        super($5b7ccabde48fae90$var$AgPillElement);
        this.config = config;
        this.eText = (0, $jIDNV.RefPlaceholder);
        this.eButton = (0, $jIDNV.RefPlaceholder);
    }
    postConstruct() {
        const { config: config, eButton: eButton } = this;
        const { onKeyDown: onKeyDown, onButtonClick: onButtonClick } = config;
        this.getGui().setAttribute("tabindex", String(this.gos.get("tabIndex")));
        this.addGuiEventListener("focus", ()=>{
            this.eButton.focus();
        });
        if (onKeyDown) this.addGuiEventListener("keydown", onKeyDown);
        if (onButtonClick) this.addManagedElementListeners(eButton, {
            click: onButtonClick
        });
    }
    toggleCloseButtonClass(className, force) {
        this.eButton.classList.toggle(className, force);
    }
    setText(text) {
        this.eText.textContent = text;
    }
    getText() {
        return this.eText.textContent;
    }
};
// packages/ag-grid-enterprise/src/widgets/AgPillContainer.ts
var $5b7ccabde48fae90$var$AgPillContainerElement = {
    tag: "div",
    cls: "ag-pill-container"
};
var $5b7ccabde48fae90$var$AgPillContainer = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$AgPillContainerElement);
        this.pills = [];
    }
    init(params) {
        this.params = params;
        this.refresh();
    }
    refresh() {
        this.clearPills();
        const { params: params, onPillKeyDown: onPillKeyDown } = this;
        let values = params.getValue();
        if (!Array.isArray(values)) {
            if (values == null) return;
            values = [
                values
            ];
        }
        const valueFormatter = params.valueFormatter ?? ((v)=>String(v));
        const len = values.length;
        (0, $jIDNV._setAriaRole)(this.getGui(), len === 0 ? "presentation" : "listbox");
        for(let i = 0; i < len; i++){
            const value = values[i];
            const pill = this.createBean(new $5b7ccabde48fae90$var$AgPill({
                onButtonClick: ()=>this.onPillButtonClick(pill),
                onKeyDown: onPillKeyDown.bind(this)
            }));
            const pillGui = pill.getGui();
            (0, $jIDNV._setAriaPosInSet)(pillGui, i + 1);
            (0, $jIDNV._setAriaSetSize)(pillGui, len);
            if (params.onPillMouseDown) pill.addGuiEventListener("mousedown", params.onPillMouseDown);
            if (params.announceItemFocus) pill.addGuiEventListener("focus", params.announceItemFocus);
            pill.setText(valueFormatter(value) ?? "");
            pill.toggleCloseButtonClass("ag-icon-cancel", true);
            this.appendChild(pillGui);
            this.pills.push(pill);
        }
    }
    onNavigationKeyDown(e) {
        const { key: key } = e;
        if (!this.pills.length || key !== (0, $jIDNV.KeyCode).LEFT && key !== (0, $jIDNV.KeyCode).RIGHT) return;
        e.preventDefault();
        const { params: params, beans: beans } = this;
        const activeEl = (0, $jIDNV._getActiveDomElement)(beans);
        const eGui = this.getGui();
        if (eGui.contains(activeEl)) {
            const nextFocusableEl = (0, $jIDNV._findNextFocusableElement)(beans, eGui, false, key === (0, $jIDNV.KeyCode).LEFT);
            if (nextFocusableEl) nextFocusableEl.focus();
            else if (params.eWrapper) params.eWrapper.focus();
        } else {
            const focusableElements = (0, $jIDNV._findFocusableElements)(eGui);
            if (focusableElements.length > 0) focusableElements[key === (0, $jIDNV.KeyCode).RIGHT ? 0 : focusableElements.length - 1].focus();
        }
    }
    clearPills() {
        const eGui = this.getGui();
        if (eGui.contains((0, $jIDNV._getActiveDomElement)(this.beans)) && this.params.eWrapper) this.params.eWrapper.focus();
        (0, $jIDNV._clearElement)(eGui);
        this.destroyBeans(this.pills);
        this.pills = [];
    }
    onPillButtonClick(pill) {
        this.deletePill(pill);
    }
    onPillKeyDown(e) {
        const key = e.key;
        if (key !== (0, $jIDNV.KeyCode).DELETE && key !== (0, $jIDNV.KeyCode).BACKSPACE) return;
        e.preventDefault();
        const eDoc = (0, $jIDNV._getDocument)(this.beans);
        const pillIndex = this.pills.findIndex((pill2)=>pill2.getGui().contains(eDoc.activeElement));
        if (pillIndex === -1) return;
        const pill = this.pills[pillIndex];
        if (pill) this.deletePill(pill, pillIndex);
    }
    deletePill(pill, restoreFocusToIndex) {
        const value = pill.getText();
        const values = (this.params.getValue() || []).filter((val)=>val !== value);
        this.params.setValue(values);
        if (!values.length && this.params.eWrapper) this.params.eWrapper.focus();
        else if (restoreFocusToIndex != null) {
            const pill2 = this.pills[Math.min(restoreFocusToIndex, this.pills.length - 1)];
            if (pill2) pill2.getFocusableElement().focus();
        }
    }
    destroy() {
        this.clearPills();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/widgets/agRichSelect.css-GENERATED.ts
var $5b7ccabde48fae90$var$agRichSelectCSS = /*css*/ `.ag-rich-select{cursor:default;height:100%}.ag-rich-select-value{align-items:center;background-color:var(--ag-picker-button-background-color);display:flex;height:100%;padding:var(--ag-spacing);:where(.ag-picker-field-display){overflow:hidden;text-overflow:ellipsis;&:where(.ag-display-as-placeholder){opacity:.5}}}.ag-rich-select-list{background-color:var(--ag-picker-list-background-color);border:var(--ag-picker-list-border);border-radius:var(--ag-input-border-radius);box-shadow:var(--ag-dropdown-shadow);height:auto;position:relative;width:100%;:where(.ag-loading-text){padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}}.ag-rich-select-row{align-items:center;display:flex;flex:1 1 auto;height:100%;overflow:hidden;padding:0 var(--ag-spacing);white-space:nowrap}.ag-rich-select-row-selected{background-color:var(--ag-selected-row-background-color)}.ag-rich-select-row-highlighted,.ag-rich-select-row:hover{background-image:linear-gradient(var(--ag-row-hover-color),var(--ag-row-hover-color))}.ag-rich-select-row-text-highlight{font-weight:700}.ag-rich-select-field-input{flex:1 1 auto;:where(.ag-input-field-input){border:none!important;box-shadow:none!important;padding:0!important;text-overflow:ellipsis;&::-moz-placeholder{opacity:.8}&::placeholder{opacity:.8}}}:where(.ag-ltr) .ag-rich-select-field-input{left:var(--ag-spacing)}:where(.ag-rtl) .ag-rich-select-field-input{right:var(--ag-spacing)}:where(.ag-popup-editor) .ag-rich-select-value{height:var(--ag-row-height);min-width:200px}.ag-rich-select-virtual-list-item{cursor:default;height:var(--ag-list-item-height)}.ag-pill-container{display:flex;flex-wrap:nowrap;gap:.25rem}.ag-pill{align-items:center;background:var(--ag-select-cell-background-color);border:var(--ag-select-cell-border);border-radius:var(--ag-border-radius);display:flex;padding:0 .25rem;white-space:nowrap}.ag-pill-button{border:none;padding:0;&:hover{color:var(--ag-accent-color);cursor:pointer}}:where(.ag-ltr) .ag-pill-button{margin-left:var(--ag-spacing)}:where(.ag-rtl) .ag-pill-button{margin-right:var(--ag-spacing)}`;
var $5b7ccabde48fae90$var$RichSelectRowElement = {
    tag: "div",
    cls: "ag-rich-select-row",
    role: "presentation"
};
var $5b7ccabde48fae90$var$RichSelectRow = class extends (0, $jIDNV.Component) {
    constructor(params){
        super($5b7ccabde48fae90$var$RichSelectRowElement);
        this.params = params;
    }
    wireBeans(beans) {
        this.userCompFactory = beans.userCompFactory;
        this.registry = beans.registry;
    }
    postConstruct() {
        this.tooltipFeature = this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.getGui(),
            shouldDisplayTooltip: ()=>this.shouldDisplayTooltip?.() ?? true
        }));
    }
    setState(value) {
        const { params: params } = this;
        const formattedValue = params.valueFormatter?.(value) ?? "";
        const rendererSuccessful = this.populateWithRenderer(value, formattedValue);
        if (!rendererSuccessful) this.populateWithoutRenderer(value, formattedValue);
        this.value = value;
    }
    highlightString(matchString) {
        const { parsedValue: parsedValue, params: params } = this;
        if (params.cellRenderer || !(0, $jIDNV._exists)(parsedValue)) return;
        let hasMatch = (0, $jIDNV._exists)(matchString);
        if (hasMatch) {
            const index = parsedValue?.toLocaleLowerCase().indexOf(matchString.toLocaleLowerCase());
            if (index >= 0) {
                const highlightEndIndex = index + matchString.length;
                const child = this.getGui().querySelector("span");
                if (child) {
                    (0, $jIDNV._clearElement)(child);
                    child.append(// Start part
                    parsedValue.slice(0, index), // Highlighted part wrapped in bold tag
                    (0, $jIDNV._createElement)({
                        tag: "span",
                        cls: "ag-rich-select-row-text-highlight",
                        children: parsedValue.slice(index, highlightEndIndex)
                    }), // End part
                    parsedValue.slice(highlightEndIndex));
                }
            } else hasMatch = false;
        }
        if (!hasMatch) this.renderValueWithoutRenderer(parsedValue);
    }
    updateSelected(selected) {
        const eGui = this.getGui();
        (0, $jIDNV._setAriaSelected)(eGui.parentElement, selected);
        this.toggleCss("ag-rich-select-row-selected", selected);
    }
    getValue() {
        return this.value;
    }
    toggleHighlighted(highlighted) {
        this.toggleCss("ag-rich-select-row-highlighted", highlighted);
    }
    populateWithoutRenderer(value, valueFormatted) {
        const eGui = this.getGui();
        const span = (0, $jIDNV._createElement)({
            tag: "span"
        });
        span.style.overflow = "hidden";
        span.style.textOverflow = "ellipsis";
        const parsedValue = (0, $jIDNV._toString)((0, $jIDNV._exists)(valueFormatted) ? valueFormatted : value);
        this.parsedValue = (0, $jIDNV._exists)(parsedValue) ? parsedValue : null;
        eGui.appendChild(span);
        this.renderValueWithoutRenderer(parsedValue);
        this.shouldDisplayTooltip = (0, $jIDNV._isElementOverflowingCallback)(()=>span);
        this.tooltipFeature?.setTooltipAndRefresh(this.parsedValue);
    }
    renderValueWithoutRenderer(value) {
        const span = this.getGui().querySelector("span");
        if (!span) return;
        span.textContent = (0, $jIDNV._exists)(value) ? value : "\xa0";
    }
    populateWithRenderer(value, valueFormatted) {
        let cellRendererPromise;
        let userCompDetails;
        if (this.params.cellRenderer) {
            const richSelect = this.getParentComponent()?.getParentComponent();
            userCompDetails = (0, $jIDNV._getEditorRendererDetails)(this.userCompFactory, this.params, (0, $jIDNV._addGridCommonParams)(this.gos, {
                value: value,
                valueFormatted: valueFormatted,
                getValue: ()=>richSelect?.getValue(),
                setValue: (value2)=>{
                    richSelect?.setValue(value2, true);
                },
                setTooltip: (value2, shouldDisplayTooltip)=>{
                    this.gos.assertModuleRegistered("Tooltip", 3);
                    this.shouldDisplayTooltip = shouldDisplayTooltip;
                    this.tooltipFeature?.setTooltipAndRefresh(value2);
                }
            }));
        }
        if (userCompDetails) cellRendererPromise = userCompDetails.newAgStackInstance();
        if (cellRendererPromise) $5b7ccabde48fae90$var$_bindCellRendererToHtmlElement(cellRendererPromise, this.getGui());
        if (cellRendererPromise) {
            cellRendererPromise.then((childComponent)=>{
                this.addDestroyFunc(()=>{
                    this.destroyBean(childComponent);
                });
            });
            return true;
        }
        return false;
    }
};
// packages/ag-grid-enterprise/src/widgets/agRichSelectList.ts
var $5b7ccabde48fae90$var$LIST_COMPONENT_NAME = "ag-rich-select-list";
var $5b7ccabde48fae90$var$ROW_COMPONENT_NAME = "ag-rich-select-row";
var $5b7ccabde48fae90$var$AgRichSelectList = class extends $5b7ccabde48fae90$var$VirtualList {
    constructor(params, richSelectWrapper, getSearchString2){
        super({
            cssIdentifier: "rich-select"
        });
        this.params = params;
        this.richSelectWrapper = richSelectWrapper;
        this.getSearchString = getSearchString2;
        this.lastRowHovered = -1;
        this.selectedItems = /* @__PURE__ */ new Set();
        this.params = params;
        this.setComponentCreator(this.createRowComponent.bind(this));
        this.setComponentUpdater(()=>{});
    }
    postConstruct() {
        super.postConstruct();
        this.eLoading = (0, $jIDNV._createElement)({
            tag: "div",
            cls: "ag-loading-text",
            children: this.getLocaleTextFunc()("loadingOoo", "Loading...")
        });
        const { cellRowHeight: cellRowHeight, pickerAriaLabelKey: pickerAriaLabelKey, pickerAriaLabelValue: pickerAriaLabelValue } = this.params;
        if (cellRowHeight) this.setRowHeight(cellRowHeight);
        const eGui = this.getGui();
        const eListAriaEl = this.getAriaElement();
        this.addManagedListeners(eGui, {
            mousemove: this.onMouseMove.bind(this),
            mouseout: this.onMouseOut.bind(this),
            mousedown: this.onMouseDown.bind(this),
            click: this.onClick.bind(this)
        });
        eGui.classList.add($5b7ccabde48fae90$var$LIST_COMPONENT_NAME);
        const listId = `${$5b7ccabde48fae90$var$LIST_COMPONENT_NAME}-${this.getCompId()}`;
        eListAriaEl.setAttribute("id", listId);
        const translate = this.getLocaleTextFunc();
        const ariaLabel = translate(pickerAriaLabelKey, pickerAriaLabelValue);
        (0, $jIDNV._setAriaLabel)(eListAriaEl, ariaLabel);
        (0, $jIDNV._setAriaControlsAndLabel)(this.richSelectWrapper, eListAriaEl);
    }
    navigateToPage(key) {
        const newIndex = super.navigateToPage(key, this.lastRowHovered);
        if (newIndex != null) (0, $jIDNV._requestAnimationFrame)(this.beans, ()=>{
            if (!this.isAlive()) return null;
            this.highlightIndex(newIndex);
        });
        return newIndex;
    }
    drawVirtualRows(softRefresh) {
        super.drawVirtualRows(softRefresh);
        this.refreshSelectedItems();
    }
    highlightFilterMatch(searchString) {
        this.forEachRenderedRow((cmp)=>{
            cmp.highlightString(searchString);
        });
    }
    onNavigationKeyDown(key, announceItem) {
        (0, $jIDNV._requestAnimationFrame)(this.beans, ()=>{
            if (!this.currentList || !this.isAlive()) return;
            const len = this.currentList.length;
            const oldIndex = this.lastRowHovered;
            const diff = key === (0, $jIDNV.KeyCode).DOWN ? 1 : -1;
            const newIndex = Math.min(Math.max(oldIndex === -1 ? 0 : oldIndex + diff, 0), len - 1);
            this.highlightIndex(newIndex);
            announceItem();
        });
    }
    selectValue(value) {
        if (!this.currentList) {
            if (this.eLoading) this.appendChild(this.eLoading);
            return false;
        }
        if (this.eLoading?.offsetParent) this.eLoading.parentElement?.removeChild(this.eLoading);
        if (value == null) return false;
        const selectedPositions = this.getIndicesForValues(value);
        const refresh = selectedPositions.length > 0;
        if (refresh) {
            this.refresh();
            this.ensureIndexVisible(selectedPositions[0]);
            this.refresh(true);
        }
        this.selectListItems(Array.isArray(value) ? value : [
            value
        ]);
        return refresh;
    }
    selectListItems(values, append = false) {
        if (!append) this.selectedItems.clear();
        for(let i = 0; i < values.length; i++){
            const currentItem = values[i];
            if (this.findItemInSelected(currentItem) !== void 0) continue;
            this.selectedItems.add(currentItem);
        }
        this.refreshSelectedItems();
    }
    getCurrentList() {
        return this.currentList;
    }
    setCurrentList(list) {
        this.currentList = list;
        this.setModel({
            getRowCount: ()=>list.length,
            getRow: (index)=>list[index],
            areRowsEqual: (oldRow, newRow)=>oldRow === newRow
        });
    }
    getSelectedItems() {
        return this.selectedItems;
    }
    getLastItemHovered() {
        return this.currentList[this.lastRowHovered];
    }
    highlightIndex(index, preventUnnecessaryScroll) {
        if (!this.currentList) return;
        if (index < 0 || index >= this.currentList.length) this.lastRowHovered = -1;
        else {
            this.lastRowHovered = index;
            const wasScrolled = this.ensureIndexVisible(index, !preventUnnecessaryScroll);
            if (wasScrolled && !preventUnnecessaryScroll) this.refresh(true);
        }
        this.forEachRenderedRow((cmp, idx)=>{
            const highlighted = index === idx;
            cmp.toggleHighlighted(highlighted);
            if (highlighted) {
                const idForParent = `${$5b7ccabde48fae90$var$ROW_COMPONENT_NAME}-${cmp.getCompId()}`;
                (0, $jIDNV._setAriaActiveDescendant)(this.richSelectWrapper, idForParent);
                this.richSelectWrapper.setAttribute("data-active-option", idForParent);
            }
        });
    }
    getIndicesForValues(values) {
        const { currentList: currentList } = this;
        if (!currentList || currentList.length === 0 || values == null) return [];
        if (!Array.isArray(values)) values = [
            values
        ];
        if (values.length === 0) return [];
        const { valueFormatter: valueFormatter } = this.params;
        const positions = [];
        const isObject = typeof values[0] === "object";
        const formattedList = currentList.map(valueFormatter);
        for (const value of values){
            let idx = -1;
            if (isObject) idx = formattedList.indexOf(valueFormatter(value));
            else idx = currentList.indexOf(value);
            if (idx >= 0) positions.push(idx);
        }
        return positions;
    }
    toggleListItemSelection(value) {
        const item = this.findItemInSelected(value);
        if (item !== void 0) this.selectedItems.delete(item);
        else this.selectedItems.add(value);
        this.refreshSelectedItems();
        this.dispatchValueSelected();
    }
    refreshSelectedItems() {
        this.forEachRenderedRow((cmp)=>{
            const selected = this.findItemInSelected(cmp.getValue()) !== void 0;
            cmp.updateSelected(selected);
        });
    }
    findItemInSelected(value) {
        if (typeof value === "object") {
            const valueFormatter = this.params.valueFormatter;
            const valueFormatted = valueFormatter(value);
            for (const item of this.selectedItems){
                if (valueFormatter(item) === valueFormatted) return item;
            }
        } else return this.selectedItems.has(value) ? value : void 0;
    }
    createRowComponent(value, listItemElement) {
        const row = new $5b7ccabde48fae90$var$RichSelectRow(this.params);
        listItemElement.setAttribute("id", `${$5b7ccabde48fae90$var$ROW_COMPONENT_NAME}-${row.getCompId()}`);
        row.setParentComponent(this);
        this.createBean(row);
        row.setState(value);
        const { highlightMatch: highlightMatch, searchType: searchType = "fuzzy" } = this.params;
        if (highlightMatch && searchType !== "fuzzy") row.highlightString(this.getSearchString());
        return row;
    }
    getRowForMouseEvent(e) {
        if (!this.model) return -1;
        const eGui = this.getGui();
        const rect = eGui.getBoundingClientRect();
        const scrollTop = this.getScrollTop();
        const mouseY = e.clientY - rect.top + scrollTop;
        return Math.min(Math.floor(mouseY / this.getRowHeight()), this.model.getRowCount() - 1);
    }
    onMouseMove(e) {
        const row = this.getRowForMouseEvent(e);
        if (row !== -1 && row != this.lastRowHovered) {
            this.lastRowHovered = row;
            this.highlightIndex(row, true);
        }
    }
    onMouseDown(e) {
        e.preventDefault();
    }
    onMouseOut(e) {
        if (!this.getGui().contains(e.relatedTarget)) this.highlightIndex(-1);
    }
    onClick(e) {
        const { multiSelect: multiSelect } = this.params;
        if (!this.currentList) return;
        const row = this.getRowForMouseEvent(e);
        const item = this.currentList[row];
        if (multiSelect) this.toggleListItemSelection(item);
        else {
            this.selectListItems([
                item
            ]);
            this.dispatchValueSelected();
        }
    }
    dispatchValueSelected() {
        this.dispatchLocalEvent({
            type: "richSelectListRowSelected",
            fromEnterKey: false,
            value: this.selectedItems
        });
    }
    destroy() {
        super.destroy();
        this.eLoading = void 0;
    }
};
// packages/ag-grid-enterprise/src/widgets/agRichSelect.ts
var $5b7ccabde48fae90$var$AgRichSelectElement = {
    tag: "div",
    cls: "ag-picker-field",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eLabel"
        },
        {
            tag: "div",
            ref: "eWrapper",
            cls: "ag-wrapper ag-picker-field-wrapper ag-rich-select-value ag-picker-collapsed",
            children: [
                {
                    tag: "span",
                    ref: "eDisplayField",
                    cls: "ag-picker-field-display"
                },
                {
                    tag: "ag-input-text-field",
                    ref: "eInput",
                    cls: "ag-rich-select-field-input"
                },
                {
                    tag: "span",
                    ref: "eDeselect",
                    cls: "ag-rich-select-deselect-button ag-picker-field-icon",
                    role: "presentation"
                },
                {
                    tag: "span",
                    ref: "eIcon",
                    cls: "ag-picker-field-icon",
                    attrs: {
                        "aria-hidden": "true"
                    }
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$AgRichSelect = class extends (0, $jIDNV.AgPickerField) {
    constructor(config){
        super({
            pickerAriaLabelKey: "ariaLabelRichSelectField",
            pickerAriaLabelValue: "Rich Select Field",
            pickerType: "ag-list",
            className: "ag-rich-select",
            pickerIcon: "richSelectOpen",
            ariaRole: "combobox",
            template: config?.template ?? $5b7ccabde48fae90$var$AgRichSelectElement,
            agComponents: [
                (0, $jIDNV.AgInputTextFieldSelector)
            ],
            modalPicker: false,
            ...config,
            // maxPickerHeight needs to be set after expanding `config`
            maxPickerHeight: config?.maxPickerHeight ?? "calc(var(--ag-row-height) * 6.5)"
        });
        this.searchString = "";
        this.searchStringCreator = null;
        this.eInput = (0, $jIDNV.RefPlaceholder);
        this.eDeselect = (0, $jIDNV.RefPlaceholder);
        this.skipWrapperAnnouncement = false;
        const { value: value, valueList: valueList, searchStringCreator: searchStringCreator } = config || {};
        if (value !== void 0) this.value = value;
        if (searchStringCreator) this.searchStringCreator = searchStringCreator;
        if (valueList != null) this.setValues(valueList);
        this.registerCSS($5b7ccabde48fae90$var$agRichSelectCSS);
    }
    wireBeans(beans) {
        this.userCompFactory = beans.userCompFactory;
        this.ariaAnnounce = beans.ariaAnnounce;
        this.registry = beans.registry;
    }
    postConstruct() {
        this.tooltipFeature = this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.getGui(),
            shouldDisplayTooltip: ()=>this.shouldDisplayTooltip?.() ?? true
        }));
        super.postConstruct();
        this.createListComponent();
        this.eDeselect.appendChild((0, $jIDNV._createIconNoSpan)("richSelectRemove", this.beans));
        const { allowTyping: allowTyping, placeholder: placeholder, suppressDeselectAll: suppressDeselectAll } = this.config;
        this.eDeselect.classList.add("ag-hidden");
        if (allowTyping) {
            this.eInput.setAutoComplete(false).setInputPlaceholder(placeholder);
            this.eDisplayField.classList.add("ag-hidden");
        } else this.eInput.setDisplayed(false);
        this.setupAriaProperties();
        const { searchDebounceDelay: searchDebounceDelay = 300 } = this.config;
        this.clearSearchString = (0, $jIDNV._debounce)(this, this.clearSearchString.bind(this), searchDebounceDelay);
        this.renderSelectedValue();
        if (allowTyping) this.eInput.onValueChange((value)=>this.searchTextFromString(value));
        this.addManagedElementListeners(this.eWrapper, {
            focus: this.onWrapperFocus.bind(this)
        });
        this.addManagedElementListeners(this.eWrapper, {
            focusout: this.onWrapperFocusOut.bind(this)
        });
        if (!suppressDeselectAll) this.addManagedElementListeners(this.eDeselect, {
            mousedown: this.onDeselectAllMouseDown.bind(this),
            click: this.onDeselectAllClick.bind(this)
        });
    }
    setupAriaProperties() {
        const { eWrapper: eWrapper, gos: gos } = this;
        eWrapper.tabIndex = gos.get("tabIndex");
        const translate = this.getLocaleTextFunc();
        this.ariaDeleteSelection = translate("ariaLabelRichSelectDeleteSelection", "Press DELETE to deselect item");
        this.ariaDeselectAllItems = translate("ariaLabelRichSelectDeselectAllItems", "Press DELETE to deselect all items");
        this.ariaToggleSelection = translate("ariaLabelRichSelectToggleSelection", "Press SPACE to toggle selection");
    }
    createListComponent() {
        this.listComponent = this.createBean(new $5b7ccabde48fae90$var$AgRichSelectList(this.config, this.getFocusableElement(), ()=>this.searchString));
        this.listComponent.setParentComponent(this);
        this.addManagedListeners(this.listComponent, {
            richSelectListRowSelected: (e)=>{
                this.onListValueSelected(e.value, e.fromEnterKey);
            }
        });
    }
    renderSelectedValue() {
        const { value: value, eDisplayField: eDisplayField, config: config, gos: gos } = this;
        const { allowTyping: allowTyping, cellRenderer: cellRenderer, initialInputValue: initialInputValue, multiSelect: multiSelect, suppressDeselectAll: suppressDeselectAll, suppressMultiSelectPillRenderer: suppressMultiSelectPillRenderer, valueFormatter: valueFormatter } = config;
        const valueFormatted = $5b7ccabde48fae90$var$formatValueFn(value, valueFormatter);
        if (allowTyping) {
            this.eInput.setValue(initialInputValue ?? valueFormatted);
            return;
        }
        if (multiSelect && !suppressDeselectAll) {
            const isEmpty = value == null || Array.isArray(value) && value.length === 0;
            this.eDeselect.classList.toggle("ag-hidden", isEmpty);
        }
        let userCompDetails;
        if (multiSelect && !suppressMultiSelectPillRenderer) {
            this.createOrUpdatePillContainer(eDisplayField);
            return;
        }
        if (cellRenderer) userCompDetails = (0, $jIDNV._getEditorRendererDetails)(this.userCompFactory, config, (0, $jIDNV._addGridCommonParams)(this.gos, {
            value: value,
            valueFormatted: valueFormatted,
            getValue: ()=>this.getValue(),
            setValue: (value2)=>{
                this.setValue(value2, true);
            },
            setTooltip: (value2, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                this.shouldDisplayTooltip = shouldDisplayTooltip;
                this.tooltipFeature?.setTooltipAndRefresh(value2);
            }
        }));
        let userCompDetailsPromise;
        if (userCompDetails) userCompDetailsPromise = userCompDetails.newAgStackInstance();
        if (userCompDetailsPromise) {
            (0, $jIDNV._clearElement)(eDisplayField);
            $5b7ccabde48fae90$var$_bindCellRendererToHtmlElement(userCompDetailsPromise, eDisplayField);
            userCompDetailsPromise.then((renderer)=>{
                this.addDestroyFunc(()=>this.destroyBean(renderer));
            });
        } else {
            if ((0, $jIDNV._exists)(this.value)) {
                eDisplayField.innerText = valueFormatted;
                eDisplayField.classList.remove("ag-display-as-placeholder");
            } else {
                const { placeholder: placeholder } = config;
                if ((0, $jIDNV._exists)(placeholder)) {
                    eDisplayField.textContent = placeholder;
                    eDisplayField.classList.add("ag-display-as-placeholder");
                } else (0, $jIDNV._clearElement)(eDisplayField);
            }
            this.shouldDisplayTooltip = (0, $jIDNV._isElementOverflowingCallback)(()=>this.eDisplayField);
            this.tooltipFeature?.setTooltipAndRefresh(valueFormatted ?? null);
        }
    }
    createPickerComponent() {
        const { values: values } = this;
        if (values) this.setValueList({
            valueList: values
        });
        return this.listComponent;
    }
    setSearchStringCreator(searchStringFn) {
        this.searchStringCreator = searchStringFn;
    }
    setValueList(params) {
        const { valueList: valueList, refresh: refresh } = params;
        if (!this.listComponent || this.listComponent.getCurrentList() === valueList) return;
        this.listComponent.setCurrentList(valueList);
        if (refresh) {
            if (!this.values) {
                this.setValues(valueList);
                if (this.isPickerDisplayed) {
                    const hasRefreshed = this.listComponent.selectValue(this.value);
                    if (!hasRefreshed) this.listComponent.refresh();
                }
            } else this.listComponent.refresh(true);
            this.alignPickerToComponent();
        }
    }
    /**
   * This method updates the list of values
   */ setValues(values) {
        this.values = values;
        this.searchStrings = this.getSearchStringsFromValues(values);
    }
    showPicker() {
        super.showPicker();
        const { listComponent: listComponent, value: value } = this;
        if (!listComponent) return;
        let idx = null;
        listComponent.selectValue(this.value);
        if (this.value != null) idx = listComponent.getIndicesForValues(Array.isArray(value) ? value : [
            value
        ])[0];
        if (idx != null) listComponent.highlightIndex(idx);
        else listComponent.refresh();
        this.displayOrHidePicker();
    }
    beforeHidePicker() {
        super.beforeHidePicker();
    }
    createOrUpdatePillContainer(container) {
        if (!this.pillContainer) {
            const pillContainer = this.pillContainer = this.createBean(new $5b7ccabde48fae90$var$AgPillContainer());
            this.addDestroyFunc(()=>{
                this.destroyBean(this.pillContainer);
                this.pillContainer = null;
            });
            (0, $jIDNV._clearElement)(container);
            container.appendChild(pillContainer.getGui());
            const { config: config, eWrapper: eWrapper, ariaDeleteSelection: ariaDeleteSelection } = this;
            const { valueFormatter: valueFormatter } = config;
            pillContainer.init({
                eWrapper: eWrapper,
                valueFormatter: valueFormatter,
                onPillMouseDown: (e)=>{
                    e.stopImmediatePropagation();
                },
                announceItemFocus: ()=>{
                    this.announceAriaValue(ariaDeleteSelection);
                },
                getValue: ()=>this.getValue(),
                setValue: (value)=>this.setValue(value, true)
            });
        }
        this.doWhileBlockingAnnouncement(()=>this.pillContainer?.refresh());
    }
    doWhileBlockingAnnouncement(func) {
        this.skipWrapperAnnouncement = true;
        func();
        this.skipWrapperAnnouncement = false;
    }
    onWrapperFocus() {
        const { eInput: eInput, config: config } = this;
        const { allowTyping: allowTyping, multiSelect: multiSelect, suppressDeselectAll: suppressDeselectAll } = config;
        if (allowTyping) {
            const focusableEl = eInput.getFocusableElement();
            focusableEl.focus();
            focusableEl.select();
        } else if (multiSelect && !suppressDeselectAll && !this.skipWrapperAnnouncement) this.announceAriaValue(this.ariaDeselectAllItems);
    }
    onWrapperFocusOut(e) {
        if (!this.eWrapper.contains(e.relatedTarget)) this.hidePicker();
    }
    onDeselectAllMouseDown(e) {
        e.stopImmediatePropagation();
    }
    onDeselectAllClick() {
        this.setValue([], true);
    }
    buildSearchStringFromKeyboardEvent(searchKey) {
        let { key: key } = searchKey;
        if (key === (0, $jIDNV.KeyCode).BACKSPACE) {
            this.searchString = this.searchString.slice(0, -1);
            key = "";
        } else if (!(0, $jIDNV._isEventFromPrintableCharacter)(searchKey)) return;
        searchKey.preventDefault();
        this.searchTextFromCharacter(key);
    }
    searchTextFromCharacter(char) {
        this.searchString += char;
        this.runSearch();
        this.clearSearchString();
    }
    searchTextFromString(str) {
        if (str == null) str = "";
        this.searchString = str;
        this.runSearch();
    }
    getSearchStringsFromValues(values) {
        const { config: { valueFormatter: valueFormatter } } = this;
        if (typeof values[0] === "object" && this.searchStringCreator) return this.searchStringCreator(values);
        return values.map((value)=>$5b7ccabde48fae90$var$formatValueFn(value, valueFormatter));
    }
    filterListModel(filteredValues) {
        const { filterList: filterList } = this.config;
        if (!filterList) return;
        this.setValueList({
            valueList: filteredValues,
            refresh: true
        });
    }
    runSearch() {
        if (!this.listComponent) return;
        const { values: values } = this;
        const searchStrings = this.searchStrings;
        if (!searchStrings) {
            this.listComponent.highlightIndex(-1);
            return;
        }
        const { suggestions: suggestions, filteredValues: filteredValues } = this.getSuggestionsAndFilteredValues(this.searchString, searchStrings);
        const { filterList: filterList, highlightMatch: highlightMatch, searchType: searchType = "fuzzy" } = this.config;
        const shouldFilter = !!(filterList && this.searchString !== "");
        this.filterListModel(shouldFilter ? filteredValues : values);
        if (!this.highlightEmptyValue()) this.highlightListValue(suggestions, filteredValues, shouldFilter);
        if (highlightMatch && searchType !== "fuzzy") this.listComponent?.highlightFilterMatch(this.searchString);
        this.displayOrHidePicker();
    }
    highlightEmptyValue() {
        if (this.searchString === "") {
            const emptyIdx = this.searchStrings?.indexOf("");
            if (emptyIdx !== void 0 && emptyIdx !== -1) {
                this.listComponent?.highlightIndex(emptyIdx);
                return true;
            }
        }
        return false;
    }
    highlightListValue(suggestions, filteredValues, shouldFilter) {
        if (suggestions.length) {
            const topSuggestionIndex = shouldFilter ? 0 : this.searchStrings?.indexOf(suggestions[0]);
            if (topSuggestionIndex !== void 0) this.listComponent?.highlightIndex(topSuggestionIndex);
        } else {
            this.listComponent?.highlightIndex(-1);
            if (!shouldFilter || filteredValues.length) this.listComponent?.ensureIndexVisible(0);
            else if (shouldFilter) {
                this.getAriaElement().removeAttribute("data-active-option");
                const eListAriaEl = this.listComponent?.getAriaElement();
                if (eListAriaEl) (0, $jIDNV._setAriaActiveDescendant)(eListAriaEl, null);
            }
        }
    }
    getSuggestionsAndFilteredValues(searchValue, valueList) {
        let suggestions = [];
        const filteredValues = [];
        if (!searchValue.length) return {
            suggestions: suggestions,
            filteredValues: filteredValues
        };
        const { searchType: searchType = "fuzzy", filterList: filterList } = this.config;
        if (searchType === "fuzzy") {
            const fuzzySearchResult = (0, $jIDNV._fuzzySuggestions)({
                inputValue: searchValue,
                allSuggestions: valueList,
                hideIrrelevant: true
            });
            suggestions = fuzzySearchResult.values;
            const indices = fuzzySearchResult.indices;
            if (filterList && indices.length) for(let i = 0; i < indices.length; i++)filteredValues.push(this.values[indices[i]]);
        } else suggestions = valueList.filter((val, idx)=>{
            const currentValue = val.toLocaleLowerCase();
            const valueToMatch = this.searchString.toLocaleLowerCase();
            const isMatch = searchType === "match" ? currentValue.startsWith(valueToMatch) : currentValue.indexOf(valueToMatch) !== -1;
            if (filterList && isMatch) filteredValues.push(this.values[idx]);
            return isMatch;
        });
        return {
            suggestions: suggestions,
            filteredValues: filteredValues
        };
    }
    displayOrHidePicker() {
        if (!this.listComponent) return;
        const eListGui = this.listComponent.getGui();
        const list = this.listComponent.getCurrentList();
        const toggleValue = list ? list.length === 0 : false;
        eListGui.classList.toggle("ag-hidden", toggleValue);
    }
    clearSearchString() {
        this.searchString = "";
    }
    setValue(value, silent, fromPicker, skipRendering) {
        if (this.value === value) return this;
        const isArray = Array.isArray(value);
        if (value != null) {
            if (!isArray) {
                const list = this.listComponent?.getCurrentList();
                const index = list ? list.indexOf(value) : -1;
                if (index === -1) return this;
            }
            if (!fromPicker) this.listComponent?.selectValue(value);
        }
        super.setValue(value, silent);
        if (!skipRendering) this.renderSelectedValue();
        return this;
    }
    onNavigationKeyDown(event, key, announceItem) {
        event.preventDefault();
        const isDown = key === (0, $jIDNV.KeyCode).DOWN;
        if (!this.isPickerDisplayed && isDown) {
            this.showPicker();
            return;
        }
        this.listComponent?.onNavigationKeyDown(key, announceItem);
    }
    onEnterKeyDown(e) {
        if (!this.isPickerDisplayed) return;
        e.preventDefault();
        if (this.listComponent?.getCurrentList()) {
            const lastRowHovered = this.listComponent.getLastItemHovered();
            if (this.config.multiSelect || lastRowHovered == null) this.dispatchPickerEventAndHidePicker(this.value, true);
            else this.onListValueSelected(/* @__PURE__ */ new Set([
                lastRowHovered
            ]), true);
        }
    }
    onDeleteKeyDown(e) {
        const { eWrapper: eWrapper, beans: beans } = this;
        const activeEl = (0, $jIDNV._getActiveDomElement)(beans);
        if (activeEl === eWrapper) {
            e.preventDefault();
            this.setValue([], true);
        }
    }
    onTabKeyDown() {
        const { config: config, isPickerDisplayed: isPickerDisplayed, listComponent: listComponent } = this;
        const { multiSelect: multiSelect } = config;
        if (!isPickerDisplayed || !listComponent) return;
        if (multiSelect) {
            const values = this.getValueFromSet(listComponent.getSelectedItems());
            if (values) this.setValue(values, false, true, true);
        } else {
            const lastItemHovered = listComponent.getLastItemHovered();
            if (lastItemHovered) this.setValue(lastItemHovered, false, true);
        }
        this.hidePicker();
    }
    getValueFromSet(valueSet) {
        const { multiSelect: multiSelect } = this.config;
        let newValue = null;
        for (const value of valueSet){
            if (valueSet.size === 1 && !multiSelect) {
                newValue = value;
                break;
            }
            if (!newValue) newValue = [];
            newValue.push(value);
        }
        if (Array.isArray(newValue)) newValue.sort();
        return newValue;
    }
    onListValueSelected(valueSet, fromEnterKey) {
        const newValue = this.getValueFromSet(valueSet);
        this.setValue(newValue, false, true);
        if (!this.config.multiSelect) this.dispatchPickerEventAndHidePicker(newValue, fromEnterKey);
    }
    dispatchPickerEventAndHidePicker(value, fromEnterKey) {
        const event = {
            type: "fieldPickerValueSelected",
            fromEnterKey: fromEnterKey,
            value: value
        };
        this.dispatchLocalEvent(event);
        this.hidePicker();
    }
    getFocusableElement() {
        const { allowTyping: allowTyping } = this.config;
        if (allowTyping) return this.eInput.getFocusableElement();
        return super.getFocusableElement();
    }
    onKeyDown(e) {
        const { key: key, isComposing: isComposing } = e;
        const { isPickerDisplayed: isPickerDisplayed, config: { allowTyping: allowTyping, multiSelect: multiSelect, suppressDeselectAll: suppressDeselectAll }, listComponent: listComponent, pickerComponent: pickerComponent } = this;
        switch(key){
            case (0, $jIDNV.KeyCode).LEFT:
            case (0, $jIDNV.KeyCode).RIGHT:
                if (!allowTyping || this.pillContainer) {
                    e.preventDefault();
                    if (this.pillContainer) {
                        this.listComponent?.highlightIndex(-1);
                        this.pillContainer.onNavigationKeyDown(e);
                    }
                }
                break;
            case (0, $jIDNV.KeyCode).PAGE_HOME:
            case (0, $jIDNV.KeyCode).PAGE_END:
                if (allowTyping) {
                    e.preventDefault();
                    const inputEl = this.eInput.getInputElement();
                    const target = key === (0, $jIDNV.KeyCode).PAGE_HOME ? 0 : inputEl.value.length;
                    inputEl.setSelectionRange(target, target);
                    break;
                }
            case (0, $jIDNV.KeyCode).PAGE_UP:
            case (0, $jIDNV.KeyCode).PAGE_DOWN:
                e.preventDefault();
                if (pickerComponent) listComponent?.navigateToPage(key);
                break;
            case (0, $jIDNV.KeyCode).DOWN:
            case (0, $jIDNV.KeyCode).UP:
                if (!isComposing) this.onNavigationKeyDown(e, key, ()=>{
                    if (multiSelect) {
                        this.doWhileBlockingAnnouncement(()=>this.eWrapper.focus());
                        this.announceAriaValue(this.ariaToggleSelection);
                    }
                });
                break;
            case (0, $jIDNV.KeyCode).ESCAPE:
                if (isPickerDisplayed) {
                    if ((0, $jIDNV._isVisible)(this.listComponent.getGui())) {
                        e.preventDefault();
                        (0, $jIDNV._stopPropagationForAgGrid)(e);
                    }
                    this.hidePicker();
                }
                break;
            case (0, $jIDNV.KeyCode).ENTER:
                if (isComposing) e.preventDefault();
                else this.onEnterKeyDown(e);
                break;
            case (0, $jIDNV.KeyCode).SPACE:
                if (!allowTyping || isComposing) e.preventDefault();
                if (!isComposing && isPickerDisplayed && multiSelect && listComponent) {
                    const lastItemHovered = listComponent.getLastItemHovered();
                    if (lastItemHovered) listComponent.toggleListItemSelection(lastItemHovered);
                }
                break;
            case (0, $jIDNV.KeyCode).TAB:
                this.onTabKeyDown();
                break;
            case (0, $jIDNV.KeyCode).DELETE:
                if (multiSelect && !suppressDeselectAll) this.onDeleteKeyDown(e);
                break;
            default:
                if (!allowTyping) this.buildSearchStringFromKeyboardEvent(e);
        }
    }
    announceAriaValue(value) {
        this.ariaAnnounce?.announceValue(value, "richSelect");
    }
    destroy() {
        if (this.listComponent) this.listComponent = this.destroyBean(this.listComponent);
        this.searchStrings = void 0;
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$formatValueFn = (value, valueFormatter)=>valueFormatter?.(value) ?? String(value ?? "");
function $5b7ccabde48fae90$var$_bindCellRendererToHtmlElement(cellRendererPromise, eTarget) {
    cellRendererPromise.then((cellRenderer)=>{
        const gui = cellRenderer.getGui();
        if (gui != null) eTarget.appendChild(gui);
    });
}
// packages/ag-grid-enterprise/src/advancedFilter/builder/addDropdownComp.ts
var $5b7ccabde48fae90$var$AddDropdownCompElement = {
    tag: "div",
    cls: "ag-picker-field",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eLabel"
        },
        {
            tag: "div",
            ref: "eWrapper",
            cls: "ag-wrapper ag-picker-collapsed",
            children: [
                {
                    tag: "div",
                    ref: "eDisplayField",
                    cls: "ag-picker-field-display"
                },
                {
                    tag: "ag-input-text-field",
                    ref: "eInput",
                    cls: "ag-rich-select-field-input"
                },
                {
                    tag: "span",
                    ref: "eDeselect",
                    cls: "ag-rich-select-deselect-button ag-picker-field-icon",
                    role: "presentation"
                },
                {
                    tag: "div",
                    ref: "eIcon",
                    cls: "ag-picker-field-icon",
                    attrs: {
                        "aria-hidden": "true"
                    }
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$AddDropdownComp = class extends $5b7ccabde48fae90$var$AgRichSelect {
    constructor(params){
        super({
            ...params,
            template: $5b7ccabde48fae90$var$AddDropdownCompElement,
            agComponents: [
                (0, $jIDNV.AgInputTextFieldSelector)
            ]
        });
        this.params = params;
    }
    showPicker() {
        setTimeout(()=>super.showPicker());
    }
    hidePicker() {
        setTimeout(()=>super.hidePicker());
    }
    postConstruct() {
        super.postConstruct();
        const { wrapperClassName: wrapperClassName, ariaLabel: ariaLabel } = this.params;
        (0, $jIDNV._setDisplayed)(this.eDisplayField, false);
        if (wrapperClassName) this.eWrapper.classList.add(wrapperClassName);
        (0, $jIDNV._setAriaLabelledBy)(this.eWrapper, "");
        (0, $jIDNV._setAriaLabel)(this.eWrapper, ariaLabel);
    }
    onEnterKeyDown(event) {
        (0, $jIDNV._stopPropagationForAgGrid)(event);
        if (this.isPickerDisplayed) super.onEnterKeyDown(event);
        else {
            event.preventDefault();
            this.showPicker();
        }
    }
};
var $5b7ccabde48fae90$var$AdvancedFilterBuilderItemNavigationFeature = class extends (0, $jIDNV.BeanStub) {
    constructor(eGui, focusWrapper, eFocusableComp){
        super();
        this.eGui = eGui;
        this.focusWrapper = focusWrapper;
        this.eFocusableComp = eFocusableComp;
    }
    postConstruct() {
        this.addManagedElementListeners(this.eGui, {
            keydown: (event)=>{
                switch(event.key){
                    case (0, $jIDNV.KeyCode).TAB:
                        if (!event.defaultPrevented) (0, $jIDNV._stopPropagationForAgGrid)(event);
                        break;
                    case (0, $jIDNV.KeyCode).UP:
                    case (0, $jIDNV.KeyCode).DOWN:
                        (0, $jIDNV._stopPropagationForAgGrid)(event);
                        break;
                    case (0, $jIDNV.KeyCode).ESCAPE:
                        if ((0, $jIDNV._isStopPropagationForAgGrid)(event)) return;
                        if (this.eGui.contains((0, $jIDNV._getActiveDomElement)(this.beans))) {
                            event.preventDefault();
                            (0, $jIDNV._stopPropagationForAgGrid)(event);
                            this.focusWrapper.focus();
                        }
                        break;
                }
            }
        });
        const highlightClass = "ag-advanced-filter-builder-virtual-list-item-highlight";
        this.addManagedListeners(this.focusWrapper, {
            keydown: (event)=>{
                switch(event.key){
                    case (0, $jIDNV.KeyCode).ENTER:
                        if ((0, $jIDNV._isStopPropagationForAgGrid)(event)) return;
                        if ((0, $jIDNV._getActiveDomElement)(this.beans) === this.focusWrapper) {
                            event.preventDefault();
                            (0, $jIDNV._stopPropagationForAgGrid)(event);
                            this.eFocusableComp.getFocusableElement().focus();
                        }
                        break;
                }
            },
            focusin: ()=>{
                this.focusWrapper.classList.add(highlightClass);
            },
            focusout: (event)=>{
                if (!this.focusWrapper.contains(event.relatedTarget)) this.focusWrapper.classList.remove(highlightClass);
            }
        });
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/builder/advancedFilterBuilderUtils.ts
function $5b7ccabde48fae90$var$getAdvancedFilterBuilderAddButtonParams(translate, maxPickerWidth) {
    return {
        pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderAddField",
        pickerAriaLabelValue: "Advanced Filter Builder Add Field",
        pickerType: "ag-list",
        valueList: [
            {
                key: "condition",
                displayValue: translate("advancedFilterBuilderAddCondition")
            },
            {
                key: "join",
                displayValue: translate("advancedFilterBuilderAddJoin")
            }
        ],
        valueFormatter: (value)=>value == null ? "" : value.displayValue ?? value.key,
        pickerIcon: "advancedFilterBuilderAdd",
        maxPickerWidth: `${maxPickerWidth ?? 120}px`,
        wrapperClassName: "ag-advanced-filter-builder-item-button",
        ariaLabel: translate("advancedFilterBuilderAddButtonTooltip")
    };
}
// packages/ag-grid-enterprise/src/advancedFilter/builder/advancedFilterBuilderItemAddComp.ts
var $5b7ccabde48fae90$var$ItemAddElement = {
    tag: "div",
    cls: "ag-advanced-filter-builder-item-wrapper",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eItem",
            cls: "ag-advanced-filter-builder-item",
            role: "presentation",
            children: [
                {
                    tag: "div",
                    cls: "ag-advanced-filter-builder-item-tree-lines",
                    attrs: {
                        "aria-hidden": "true"
                    },
                    children: [
                        {
                            tag: "div",
                            cls: "ag-advanced-filter-builder-item-tree-line-vertical-top ag-advanced-filter-builder-item-tree-line-horizontal"
                        }
                    ]
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$AdvancedFilterBuilderItemAddComp = class extends (0, $jIDNV.Component) {
    constructor(item, focusWrapper){
        super($5b7ccabde48fae90$var$ItemAddElement);
        this.item = item;
        this.focusWrapper = focusWrapper;
        this.eItem = (0, $jIDNV.RefPlaceholder);
    }
    wireBeans(beans) {
        this.advFilterExpSvc = beans.advFilterExpSvc;
        this.registry = beans.registry;
    }
    postConstruct() {
        (0, $jIDNV._setAriaLevel)(this.focusWrapper, 2);
        const addButtonParams = $5b7ccabde48fae90$var$getAdvancedFilterBuilderAddButtonParams((key)=>this.advFilterExpSvc.translate(key), this.gos.get("advancedFilterBuilderParams")?.addSelectWidth);
        const eAddButton = this.createManagedBean(new $5b7ccabde48fae90$var$AddDropdownComp(addButtonParams));
        this.addManagedListeners(eAddButton, {
            fieldPickerValueSelected: ({ value: value })=>{
                this.dispatchLocalEvent({
                    type: "advancedFilterBuilderAdded",
                    item: this.item,
                    isJoin: value.key === "join"
                });
            }
        });
        this.eItem.appendChild(eAddButton.getGui());
        this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>eAddButton.getGui(),
            getLocation: ()=>"advancedFilter",
            getTooltipValue: ()=>this.advFilterExpSvc.translate("advancedFilterBuilderAddButtonTooltip")
        }));
        this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedFilterBuilderItemNavigationFeature(this.getGui(), this.focusWrapper, eAddButton));
        (0, $jIDNV._setAriaLabel)(this.focusWrapper, this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderItem", [
            this.advFilterExpSvc.translate("advancedFilterBuilderAddButtonTooltip"),
            `${this.item.level + 1}`
        ]));
    }
    afterAdd() {}
};
var $5b7ccabde48fae90$var$ConditionPillWrapperComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super({
            tag: "div",
            cls: "ag-advanced-filter-builder-item-condition",
            role: "presentation"
        });
        this.validationMessage = null;
    }
    wireBeans(beans) {
        this.advFilterExpSvc = beans.advFilterExpSvc;
    }
    init(params) {
        const { item: item, createPill: createPill } = params;
        this.item = item;
        this.createPill = createPill;
        this.filterModel = item.filterModel;
        this.setupColumnCondition(this.filterModel);
        this.validate();
        this.addDestroyFunc(()=>this.destroyBeans([
                this.eColumnPill,
                this.eOperatorPill,
                this.eOperandPill
            ]));
    }
    getDragName() {
        return this.filterModel.colId ? this.advFilterExpSvc.parseColumnFilterModel(this.filterModel) : this.getDefaultColumnDisplayValue();
    }
    getAriaLabel() {
        return `${this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderFilterItem")} ${this.getDragName()}`;
    }
    getValidationMessage() {
        return this.validationMessage;
    }
    getFocusableElement() {
        return this.eColumnPill.getFocusableElement();
    }
    setupColumnCondition(filterModel) {
        const columnDetails = this.advFilterExpSvc.getColumnDetails(filterModel.colId);
        this.baseCellDataType = columnDetails.baseCellDataType;
        this.column = columnDetails.column;
        this.numOperands = this.getNumOperands(this.getOperatorKey());
        this.eColumnPill = this.createPill({
            key: this.getColumnKey(),
            displayValue: this.getColumnDisplayValue() ?? this.getDefaultColumnDisplayValue(),
            cssClass: "ag-advanced-filter-builder-column-pill",
            isSelect: true,
            getEditorParams: ()=>({
                    values: this.advFilterExpSvc.getColumnAutocompleteEntries()
                }),
            update: (key)=>this.setColumnKey(key),
            pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderColumnSelectField",
            pickerAriaLabelValue: "Advanced Filter Builder Column Select Field",
            ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderColumn")
        });
        this.getGui().appendChild(this.eColumnPill.getGui());
        if ((0, $jIDNV._exists)(this.getColumnKey())) {
            this.createOperatorPill();
            if (this.hasOperand()) this.createOperandPill();
        }
    }
    createOperatorPill() {
        this.eOperatorPill = this.createPill({
            key: this.getOperatorKey(),
            displayValue: this.getOperatorDisplayValue() ?? this.getDefaultOptionSelectValue(),
            cssClass: "ag-advanced-filter-builder-option-pill",
            isSelect: true,
            getEditorParams: ()=>({
                    values: this.getOperatorAutocompleteEntries()
                }),
            update: (key)=>this.setOperatorKey(key),
            pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderOptionSelectField",
            pickerAriaLabelValue: "Advanced Filter Builder Option Select Field",
            ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderOption")
        });
        this.eColumnPill.getGui().insertAdjacentElement("afterend", this.eOperatorPill.getGui());
    }
    createOperandPill() {
        const { filter: filter } = this.filterModel;
        const key = (typeof filter === "number" ? (0, $jIDNV._toStringOrNull)(filter) : filter) ?? "";
        this.eOperandPill = this.createPill({
            key: key,
            // Convert from the input format to display format.
            // Input format matches model format except for numbers, but these get stringified anyway
            valueFormatter: (value)=>this.advFilterExpSvc.getOperandDisplayValue({
                    ...this.filterModel,
                    filter: value
                }, true),
            baseCellDataType: this.baseCellDataType,
            cssClass: "ag-advanced-filter-builder-value-pill",
            isSelect: false,
            update: (key2)=>this.setOperand(key2),
            ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderValue")
        });
        this.getGui().appendChild(this.eOperandPill.getGui());
    }
    getColumnKey() {
        return this.filterModel.colId;
    }
    getColumnDisplayValue() {
        return this.advFilterExpSvc.getColumnDisplayValue(this.filterModel);
    }
    getOperatorKey() {
        return this.filterModel.type;
    }
    getOperatorDisplayValue() {
        return this.advFilterExpSvc.getOperatorDisplayValue(this.filterModel);
    }
    getOperandDisplayValue() {
        return this.advFilterExpSvc.getOperandDisplayValue(this.filterModel, true);
    }
    hasOperand() {
        return this.numOperands > 0;
    }
    getOperatorAutocompleteEntries() {
        return this.column ? this.advFilterExpSvc.getOperatorAutocompleteEntries(this.column, this.baseCellDataType) : [];
    }
    setColumnKey(colId) {
        if (!this.eOperatorPill) this.createOperatorPill();
        const newColumnDetails = this.advFilterExpSvc.getColumnDetails(colId);
        this.column = newColumnDetails.column;
        const newBaseCellDataType = newColumnDetails.baseCellDataType;
        if (this.baseCellDataType !== newBaseCellDataType) {
            this.baseCellDataType = newBaseCellDataType;
            this.setOperatorKey(void 0);
            if (this.eOperatorPill) {
                (0, $jIDNV._removeFromParent)(this.eOperatorPill.getGui());
                this.destroyBean(this.eOperatorPill);
                this.createOperatorPill();
            }
            this.validate();
        }
        this.filterModel.colId = colId;
        this.filterModel.filterType = this.baseCellDataType;
    }
    setOperatorKey(operator) {
        const newNumOperands = this.getNumOperands(operator);
        if (newNumOperands !== this.numOperands) {
            this.numOperands = newNumOperands;
            if (newNumOperands === 0) this.destroyOperandPill();
            else {
                this.createOperandPill();
                if (this.baseCellDataType !== "number") this.setOperand("");
            }
        }
        this.filterModel.type = operator;
        this.validate();
    }
    setOperand(operand) {
        let parsedOperand = operand;
        if (this.baseCellDataType === "number") parsedOperand = (0, $jIDNV._exists)(operand) ? Number(operand) : "";
        this.filterModel.filter = parsedOperand;
        this.validate();
    }
    getNumOperands(operator) {
        return this.advFilterExpSvc.getExpressionOperator(this.baseCellDataType, operator)?.numOperands ?? 0;
    }
    destroyOperandPill() {
        delete this.filterModel.filter;
        this.getGui().removeChild(this.eOperandPill.getGui());
        this.destroyBean(this.eOperandPill);
        this.eOperandPill = void 0;
    }
    validate() {
        let validationMessage = null;
        if (!(0, $jIDNV._exists)(this.getColumnKey())) validationMessage = this.advFilterExpSvc.translate("advancedFilterBuilderValidationSelectColumn");
        else if (!(0, $jIDNV._exists)(this.getOperatorKey())) validationMessage = this.advFilterExpSvc.translate("advancedFilterBuilderValidationSelectOption");
        else if (this.numOperands > 0 && !(0, $jIDNV._exists)(this.getOperandDisplayValue())) validationMessage = this.advFilterExpSvc.translate("advancedFilterBuilderValidationEnterValue");
        this.item.valid = !validationMessage;
        if (validationMessage !== this.validationMessage) {
            this.validationMessage = validationMessage;
            this.dispatchLocalEvent({
                type: "advancedFilterBuilderValidChanged"
            });
        }
    }
    getDefaultColumnDisplayValue() {
        return this.advFilterExpSvc.translate("advancedFilterBuilderSelectColumn");
    }
    getDefaultOptionSelectValue() {
        return this.advFilterExpSvc.translate("advancedFilterBuilderSelectOption");
    }
};
var $5b7ccabde48fae90$var$inputComponentDescriptors = {
    number: [
        (0, $jIDNV.AgInputNumberField)
    ],
    boolean: [
        (0, $jIDNV.AgInputTextField)
    ],
    object: [
        (0, $jIDNV.AgInputTextField)
    ],
    text: [
        (0, $jIDNV.AgInputTextField)
    ],
    date: [
        (0, $jIDNV.AgInputDateField)
    ],
    dateString: [
        (0, $jIDNV.AgInputDateField)
    ],
    dateTime: [
        (0, $jIDNV.AgInputDateField),
        (i)=>i.setIncludeTime(true)
    ],
    dateTimeString: [
        (0, $jIDNV.AgInputDateField),
        (i)=>i.setIncludeTime(true)
    ]
};
var $5b7ccabde48fae90$var$InputPillElement = {
    tag: "div",
    cls: "ag-advanced-filter-builder-pill-wrapper",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "ePill",
            cls: "ag-advanced-filter-builder-pill",
            role: "button",
            children: [
                {
                    tag: "span",
                    ref: "eLabel",
                    cls: "ag-advanced-filter-builder-pill-display"
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$InputPillComp = class extends (0, $jIDNV.Component) {
    constructor(params){
        super($5b7ccabde48fae90$var$InputPillElement);
        this.params = params;
        this.ePill = (0, $jIDNV.RefPlaceholder);
        this.eLabel = (0, $jIDNV.RefPlaceholder);
        const { value: value, valueFormatter: valueFormatter } = params;
        this.value = value;
        this.displayValue = valueFormatter(value);
    }
    wireBeans(beans) {
        this.advFilterExpSvc = beans.advFilterExpSvc;
    }
    postConstruct() {
        const { cssClass: cssClass, ariaLabel: ariaLabel } = this.params;
        this.ePill.classList.add(cssClass);
        this.activateTabIndex([
            this.ePill
        ]);
        this.eLabel.id = `${this.getCompId()}`;
        (0, $jIDNV._setAriaDescribedBy)(this.ePill, this.eLabel.id);
        (0, $jIDNV._setAriaLabel)(this.ePill, ariaLabel);
        this.renderValue();
        this.addManagedListeners(this.ePill, {
            click: (event)=>{
                event.preventDefault();
                this.showEditor();
            },
            keydown: (event)=>{
                switch(event.key){
                    case (0, $jIDNV.KeyCode).ENTER:
                        event.preventDefault();
                        (0, $jIDNV._stopPropagationForAgGrid)(event);
                        this.showEditor();
                        break;
                }
            }
        });
        this.addDestroyFunc(()=>this.destroyBean(this.eEditor));
    }
    getFocusableElement() {
        return this.ePill;
    }
    showEditor() {
        if (this.eEditor) return;
        (0, $jIDNV._setDisplayed)(this.ePill, false);
        this.eEditor = this.createEditorComp(this.params.type);
        this.eEditor.setValue(this.value);
        const eEditorGui = this.eEditor.getGui();
        this.eEditor.addManagedElementListeners(eEditorGui, {
            keydown: (event)=>{
                switch(event.key){
                    case (0, $jIDNV.KeyCode).ENTER:
                        event.preventDefault();
                        (0, $jIDNV._stopPropagationForAgGrid)(event);
                        this.updateValue(true);
                        break;
                    case (0, $jIDNV.KeyCode).ESCAPE:
                        event.preventDefault();
                        (0, $jIDNV._stopPropagationForAgGrid)(event);
                        this.hideEditor(true);
                        break;
                }
            },
            focusout: ()=>this.updateValue(false)
        });
        this.getGui().appendChild(eEditorGui);
        this.eEditor.getFocusableElement().focus();
    }
    /**
   * Responsible for instantiating an InputField and calling some of the setup methods
   */ createEditorComp(type) {
        const [Comp, postConstruct] = $5b7ccabde48fae90$var$inputComponentDescriptors[type];
        const instance = this.createBean(new Comp());
        if (postConstruct) postConstruct(instance);
        return instance;
    }
    hideEditor(keepFocus) {
        const { eEditor: eEditor } = this;
        if (!eEditor) return;
        this.eEditor = void 0;
        this.getGui().removeChild(eEditor.getGui());
        this.destroyBean(eEditor);
        (0, $jIDNV._setDisplayed)(this.ePill, true);
        if (keepFocus) this.ePill.focus();
    }
    renderValue() {
        let value;
        const { displayValue: displayValue, eLabel: eLabel } = this;
        const { classList: classList } = eLabel;
        classList.remove("ag-advanced-filter-builder-value-empty", "ag-advanced-filter-builder-value-number", "ag-advanced-filter-builder-value-text");
        if (!(0, $jIDNV._exists)(displayValue)) {
            value = this.advFilterExpSvc.translate("advancedFilterBuilderEnterValue");
            classList.add("ag-advanced-filter-builder-value-empty");
        } else if (this.params.type === "number") {
            value = displayValue;
            classList.add("ag-advanced-filter-builder-value-number");
        } else {
            value = `"${displayValue}"`;
            classList.add("ag-advanced-filter-builder-value-text");
        }
        eLabel.textContent = value;
    }
    updateValue(keepFocus) {
        if (!this.eEditor) return;
        const value = this.eEditor.getValue() ?? "";
        this.dispatchLocalEvent({
            type: "fieldValueChanged",
            value: value
        });
        this.value = value;
        this.displayValue = this.params.valueFormatter(value);
        this.renderValue();
        this.hideEditor(keepFocus);
    }
};
var $5b7ccabde48fae90$var$JoinPillWrapperComp = class extends (0, $jIDNV.Component) {
    wireBeans(beans) {
        this.advFilterExpSvc = beans.advFilterExpSvc;
    }
    constructor(){
        super({
            tag: "div",
            cls: "ag-advanced-filter-builder-item-condition",
            role: "presentation"
        });
    }
    init(params) {
        const { item: item, createPill: createPill } = params;
        const filterModel = item.filterModel;
        this.filterModel = filterModel;
        this.ePill = createPill({
            key: filterModel.type,
            displayValue: this.advFilterExpSvc.parseJoinOperator(filterModel),
            cssClass: "ag-advanced-filter-builder-join-pill",
            isSelect: true,
            getEditorParams: ()=>({
                    values: this.advFilterExpSvc.getJoinOperatorAutocompleteEntries()
                }),
            update: (key)=>filterModel.type = key,
            pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderJoinSelectField",
            pickerAriaLabelValue: "Advanced Filter Builder Join Operator Select Field",
            ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderJoinOperator")
        });
        this.getGui().appendChild(this.ePill.getGui());
        this.addDestroyFunc(()=>this.destroyBean(this.ePill));
    }
    getDragName() {
        return this.advFilterExpSvc.parseJoinOperator(this.filterModel);
    }
    getAriaLabel() {
        return `${this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderGroupItem")} ${this.getDragName()}`;
    }
    getValidationMessage() {
        return null;
    }
    getFocusableElement() {
        return this.ePill.getFocusableElement();
    }
};
var $5b7ccabde48fae90$var$SelectPillElement = {
    tag: "div",
    cls: "ag-picker-field ag-advanced-filter-builder-pill-wrapper",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eLabel"
        },
        {
            tag: "div",
            ref: "eWrapper",
            cls: "ag-wrapper ag-advanced-filter-builder-pill ag-picker-collapsed",
            children: [
                {
                    tag: "div",
                    ref: "eDisplayField",
                    cls: "ag-picker-field-display ag-advanced-filter-builder-pill-display"
                },
                {
                    tag: "ag-input-text-field",
                    ref: "eInput",
                    cls: "ag-rich-select-field-input"
                },
                {
                    tag: "span",
                    ref: "eDeselect",
                    cls: "ag-rich-select-deselect-button ag-picker-field-icon",
                    role: "presentation"
                },
                {
                    tag: "div",
                    ref: "eIcon",
                    cls: "ag-picker-field-icon",
                    attrs: {
                        "aria-hidden": "true"
                    }
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$SelectPillComp = class extends $5b7ccabde48fae90$var$AgRichSelect {
    constructor(params){
        super({
            ...params,
            template: $5b7ccabde48fae90$var$SelectPillElement,
            agComponents: [
                (0, $jIDNV.AgInputTextFieldSelector)
            ]
        });
        this.params = params;
    }
    getFocusableElement() {
        return this.eWrapper;
    }
    showPicker() {
        setTimeout(()=>super.showPicker());
    }
    hidePicker() {
        setTimeout(()=>super.hidePicker());
    }
    postConstruct() {
        super.postConstruct();
        const { wrapperClassName: wrapperClassName, ariaLabel: ariaLabel } = this.params;
        this.eWrapper.classList.add(wrapperClassName);
        (0, $jIDNV._setAriaLabelledBy)(this.eWrapper, "");
        (0, $jIDNV._setAriaLabel)(this.eWrapper, ariaLabel);
    }
    createPickerComponent() {
        if (!this.values) {
            const { values: values } = this.params.getEditorParams();
            this.values = values;
            const key = this.value.key;
            const value = values.find((value2)=>value2.key === key) ?? {
                key: key,
                displayValue: this.value.displayValue
            };
            this.value = value;
        }
        return super.createPickerComponent();
    }
    onEnterKeyDown(event) {
        (0, $jIDNV._stopPropagationForAgGrid)(event);
        if (this.isPickerDisplayed) super.onEnterKeyDown(event);
        else {
            event.preventDefault();
            this.showPicker();
        }
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/builder/advancedFilterBuilderItemComp.ts
var $5b7ccabde48fae90$var$AdvancedFilterBuilderItemElement = {
    tag: "div",
    cls: "ag-advanced-filter-builder-item-wrapper",
    role: "presentation",
    children: [
        {
            tag: "div",
            cls: "ag-advanced-filter-builder-item",
            role: "presentation",
            children: [
                {
                    tag: "div",
                    ref: "eTreeLines",
                    cls: "ag-advanced-filter-builder-item-tree-lines",
                    attrs: {
                        "aria-hidden": "true"
                    }
                },
                {
                    tag: "span",
                    ref: "eDragHandle",
                    cls: "ag-drag-handle",
                    attrs: {
                        "aria-hidden": "true"
                    }
                },
                {
                    tag: "span",
                    ref: "eValidation",
                    cls: "ag-advanced-filter-builder-item-button ag-advanced-filter-builder-invalid",
                    attrs: {
                        "aria-hidden": "true"
                    }
                }
            ]
        },
        {
            tag: "div",
            ref: "eButtons",
            cls: "ag-advanced-filter-builder-item-buttons",
            children: [
                {
                    tag: "span",
                    ref: "eMoveUpButton",
                    cls: "ag-advanced-filter-builder-item-button",
                    role: "button"
                },
                {
                    tag: "span",
                    ref: "eMoveDownButton",
                    cls: "ag-advanced-filter-builder-item-button",
                    role: "button"
                },
                {
                    tag: "div",
                    ref: "eAddButton",
                    role: "presentation"
                },
                {
                    tag: "span",
                    ref: "eRemoveButton",
                    cls: "ag-advanced-filter-builder-item-button",
                    role: "button"
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp = class extends (0, $jIDNV.TabGuardComp) {
    constructor(item, dragFeature, focusWrapper){
        super($5b7ccabde48fae90$var$AdvancedFilterBuilderItemElement);
        this.item = item;
        this.dragFeature = dragFeature;
        this.focusWrapper = focusWrapper;
        this.eTreeLines = (0, $jIDNV.RefPlaceholder);
        this.eDragHandle = (0, $jIDNV.RefPlaceholder);
        this.eButtons = (0, $jIDNV.RefPlaceholder);
        this.eValidation = (0, $jIDNV.RefPlaceholder);
        this.eMoveUpButton = (0, $jIDNV.RefPlaceholder);
        this.eMoveDownButton = (0, $jIDNV.RefPlaceholder);
        this.eAddButton = (0, $jIDNV.RefPlaceholder);
        this.eRemoveButton = (0, $jIDNV.RefPlaceholder);
        this.moveUpDisabled = false;
        this.moveDownDisabled = false;
    }
    wireBeans(beans) {
        this.dragAndDrop = beans.dragAndDrop;
        this.advFilterExpSvc = beans.advFilterExpSvc;
        this.registry = beans.registry;
    }
    postConstruct() {
        const { filterModel: filterModel, level: level, showMove: showMove } = this.item;
        const isJoin = filterModel.filterType === "join";
        this.ePillWrapper = this.createManagedBean(isJoin ? new $5b7ccabde48fae90$var$JoinPillWrapperComp() : new $5b7ccabde48fae90$var$ConditionPillWrapperComp());
        this.ePillWrapper.init({
            item: this.item,
            createPill: (params)=>this.createPill(params)
        });
        this.eDragHandle.insertAdjacentElement("afterend", this.ePillWrapper.getGui());
        if (level === 0) {
            const eTreeLine = (0, $jIDNV._createElement)({
                tag: "div",
                cls: "ag-advanced-filter-builder-item-tree-line-vertical-bottom ag-advanced-filter-builder-item-tree-line-root"
            });
            this.eTreeLines.appendChild(eTreeLine);
            (0, $jIDNV._setDisplayed)(this.eDragHandle, false);
            (0, $jIDNV._setDisplayed)(this.eButtons, false);
            (0, $jIDNV._setAriaExpanded)(this.focusWrapper, true);
        } else {
            this.setupTreeLines(level);
            this.eDragHandle.appendChild((0, $jIDNV._createIconNoSpan)("advancedFilterBuilderDrag", this.beans));
            this.setupValidation();
            this.setupMoveButtons(showMove);
            this.setupAddButton();
            this.setupRemoveButton();
            this.setupDragging();
            this.updateAriaExpanded();
        }
        (0, $jIDNV._setAriaLevel)(this.focusWrapper, level + 1);
        this.initialiseTabGuard({});
        this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedFilterBuilderItemNavigationFeature(this.getGui(), this.focusWrapper, this.ePillWrapper));
        this.updateAriaLabel();
        this.addManagedListeners(this.ePillWrapper, {
            advancedFilterBuilderValueChanged: ()=>this.dispatchLocalEvent({
                    type: "advancedFilterBuilderValueChanged"
                }),
            advancedFilterBuilderValidChanged: ()=>this.updateValidity()
        });
    }
    setState(params) {
        const { level: level } = this.item;
        if (level === 0) return;
        const { showMove: showMove } = this.item;
        const { disableMoveUp: disableMoveUp, disableMoveDown: disableMoveDown, treeLines: treeLines, showStartTreeLine: showStartTreeLine } = params;
        this.updateTreeLines(treeLines, showStartTreeLine);
        this.updateAriaExpanded();
        if (showMove) {
            this.moveUpDisabled = !!disableMoveUp;
            this.moveDownDisabled = !!disableMoveDown;
            this.eMoveUpButton.classList.toggle("ag-advanced-filter-builder-item-button-disabled", disableMoveUp);
            this.eMoveDownButton.classList.toggle("ag-advanced-filter-builder-item-button-disabled", disableMoveDown);
            (0, $jIDNV._setAriaDisabled)(this.eMoveUpButton, !!disableMoveUp);
            (0, $jIDNV._setAriaDisabled)(this.eMoveDownButton, !!disableMoveDown);
            this.moveUpTooltipFeature?.refreshTooltip();
            this.moveDownTooltipFeature?.refreshTooltip();
        }
    }
    focusMoveButton(backwards) {
        (backwards ? this.eMoveUpButton : this.eMoveDownButton).focus();
    }
    afterAdd() {
        this.ePillWrapper.getFocusableElement().focus();
    }
    setupTreeLines(level) {
        for(let i = 0; i < level; i++)this.eTreeLines.appendChild((0, $jIDNV._createElement)({
            tag: "div"
        }));
    }
    updateTreeLines(treeLines, showStartTreeLine) {
        const lastTreeLineIndex = treeLines.length - 1;
        const { children: children } = this.eTreeLines;
        for(let i = 0; i < lastTreeLineIndex; i++){
            const eTreeLine2 = children.item(i);
            if (eTreeLine2) eTreeLine2.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical", !treeLines[i]);
        }
        const eTreeLine = children.item(lastTreeLineIndex);
        if (eTreeLine) {
            eTreeLine.classList.add("ag-advanced-filter-builder-item-tree-line-horizontal");
            const isLastChild = treeLines[lastTreeLineIndex];
            eTreeLine.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical-top", isLastChild);
            eTreeLine.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical", !isLastChild);
        }
        this.eDragHandle.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical-bottom", showStartTreeLine);
    }
    setupValidation() {
        this.eValidation.appendChild((0, $jIDNV._createIconNoSpan)("advancedFilterBuilderInvalid", this.beans));
        this.validationTooltipFeature = this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.eValidation,
            getLocation: ()=>"advancedFilter",
            getTooltipValue: ()=>this.ePillWrapper.getValidationMessage(),
            getTooltipShowDelayOverride: ()=>1e3
        }));
        this.updateValidity();
    }
    setupAddButton() {
        const addButtonParams = $5b7ccabde48fae90$var$getAdvancedFilterBuilderAddButtonParams((key)=>this.advFilterExpSvc.translate(key), this.gos.get("advancedFilterBuilderParams")?.addSelectWidth);
        const eAddButton = this.createManagedBean(new $5b7ccabde48fae90$var$AddDropdownComp(addButtonParams));
        this.addManagedListeners(eAddButton, {
            fieldPickerValueSelected: ({ value: value })=>this.dispatchLocalEvent({
                    type: "advancedFilterBuilderAdded",
                    item: this.item,
                    isJoin: value.key === "join"
                })
        });
        this.eAddButton.appendChild(eAddButton.getGui());
        this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.eAddButton,
            getLocation: ()=>"advancedFilter",
            getTooltipValue: ()=>this.advFilterExpSvc.translate("advancedFilterBuilderAddButtonTooltip")
        }));
    }
    setupRemoveButton() {
        this.eRemoveButton.appendChild((0, $jIDNV._createIconNoSpan)("advancedFilterBuilderRemove", this.beans));
        this.addManagedListeners(this.eRemoveButton, {
            click: ()=>this.removeItem(),
            keydown: (event)=>{
                switch(event.key){
                    case (0, $jIDNV.KeyCode).ENTER:
                        event.preventDefault();
                        (0, $jIDNV._stopPropagationForAgGrid)(event);
                        this.removeItem();
                        break;
                }
            }
        });
        this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.eRemoveButton,
            getLocation: ()=>"advancedFilter",
            getTooltipValue: ()=>this.advFilterExpSvc.translate("advancedFilterBuilderRemoveButtonTooltip")
        }));
        (0, $jIDNV._setAriaLabel)(this.eRemoveButton, this.advFilterExpSvc.translate("advancedFilterBuilderRemoveButtonTooltip"));
        this.activateTabIndex([
            this.eRemoveButton
        ]);
    }
    setupMoveButtons(showMove) {
        if (showMove) {
            this.eMoveUpButton.appendChild((0, $jIDNV._createIconNoSpan)("advancedFilterBuilderMoveUp", this.beans));
            this.addManagedListeners(this.eMoveUpButton, {
                click: ()=>this.moveItem(true),
                keydown: (event)=>{
                    switch(event.key){
                        case (0, $jIDNV.KeyCode).ENTER:
                            event.preventDefault();
                            (0, $jIDNV._stopPropagationForAgGrid)(event);
                            this.moveItem(true);
                            break;
                    }
                }
            });
            this.moveUpTooltipFeature = this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
                getGui: ()=>this.eMoveUpButton,
                getLocation: ()=>"advancedFilter",
                getTooltipValue: ()=>this.moveUpDisabled ? null : this.advFilterExpSvc.translate("advancedFilterBuilderMoveUpButtonTooltip")
            }));
            (0, $jIDNV._setAriaLabel)(this.eMoveUpButton, this.advFilterExpSvc.translate("advancedFilterBuilderMoveUpButtonTooltip"));
            this.eMoveDownButton.appendChild((0, $jIDNV._createIconNoSpan)("advancedFilterBuilderMoveDown", this.beans));
            this.addManagedListeners(this.eMoveDownButton, {
                click: ()=>this.moveItem(false),
                keydown: (event)=>{
                    switch(event.key){
                        case (0, $jIDNV.KeyCode).ENTER:
                            event.preventDefault();
                            (0, $jIDNV._stopPropagationForAgGrid)(event);
                            this.moveItem(false);
                            break;
                    }
                }
            });
            this.moveDownTooltipFeature = this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
                getGui: ()=>this.eMoveDownButton,
                getLocation: ()=>"advancedFilter",
                getTooltipValue: ()=>this.moveDownDisabled ? null : this.advFilterExpSvc.translate("advancedFilterBuilderMoveDownButtonTooltip")
            }));
            (0, $jIDNV._setAriaLabel)(this.eMoveDownButton, this.advFilterExpSvc.translate("advancedFilterBuilderMoveDownButtonTooltip"));
            this.activateTabIndex([
                this.eMoveUpButton,
                this.eMoveDownButton
            ]);
        } else {
            (0, $jIDNV._setDisplayed)(this.eMoveUpButton, false);
            (0, $jIDNV._setDisplayed)(this.eMoveDownButton, false);
        }
    }
    updateValidity() {
        (0, $jIDNV._setVisible)(this.eValidation, !this.item.valid);
        this.validationTooltipFeature?.refreshTooltip();
        this.updateAriaLabel();
    }
    createPill(params) {
        const { key: key, cssClass: cssClass, update: update, ariaLabel: ariaLabel } = params;
        const onUpdated = (key2)=>{
            if (key2 == null) return;
            update(key2);
            this.dispatchLocalEvent({
                type: "advancedFilterBuilderValueChanged"
            });
        };
        if (params.isSelect) {
            const { getEditorParams: getEditorParams, pickerAriaLabelKey: pickerAriaLabelKey, pickerAriaLabelValue: pickerAriaLabelValue, displayValue: displayValue } = params;
            const advancedFilterBuilderParams = this.gos.get("advancedFilterBuilderParams");
            const minPickerWidth = `${advancedFilterBuilderParams?.pillSelectMinWidth ?? 140}px`;
            const maxPickerWidth = `${advancedFilterBuilderParams?.pillSelectMaxWidth ?? 200}px`;
            const comp = this.createBean(new $5b7ccabde48fae90$var$SelectPillComp({
                pickerAriaLabelKey: pickerAriaLabelKey,
                pickerAriaLabelValue: pickerAriaLabelValue,
                pickerType: "ag-list",
                value: {
                    key: key,
                    displayValue: displayValue
                },
                valueFormatter: (value)=>value == null ? "" : value.displayValue ?? value.key,
                variableWidth: true,
                minPickerWidth: minPickerWidth,
                maxPickerWidth: maxPickerWidth,
                getEditorParams: getEditorParams,
                wrapperClassName: cssClass,
                ariaLabel: ariaLabel,
                pickerIcon: "advancedFilterBuilderSelectOpen"
            }));
            this.addManagedListeners(comp, {
                fieldPickerValueSelected: ({ value: value })=>onUpdated(value?.key)
            });
            return comp;
        } else {
            const { baseCellDataType: baseCellDataType, valueFormatter: valueFormatter } = params;
            const comp = this.createBean(new $5b7ccabde48fae90$var$InputPillComp({
                value: key,
                valueFormatter: valueFormatter,
                cssClass: cssClass,
                type: baseCellDataType,
                ariaLabel: ariaLabel
            }));
            this.addManagedListeners(comp, {
                fieldValueChanged: ({ value: value })=>onUpdated(value)
            });
            return comp;
        }
    }
    setupDragging() {
        const dragSource = {
            type: (0, $jIDNV.DragSourceType).AdvancedFilterBuilder,
            eElement: this.eDragHandle,
            dragItemName: ()=>this.ePillWrapper.getDragName(),
            getDefaultIconName: ()=>"notAllowed",
            getDragItem: ()=>({}),
            onDragStarted: ()=>this.dragFeature.dispatchLocalEvent({
                    type: "advancedFilterBuilderDragStarted",
                    item: this.item
                }),
            onDragStopped: ()=>this.dragFeature.dispatchLocalEvent({
                    type: "advancedFilterBuilderDragEnded"
                })
        };
        this.dragAndDrop.addDragSource(dragSource, true);
        this.addDestroyFunc(()=>this.dragAndDrop.removeDragSource(dragSource));
    }
    updateAriaLabel() {
        const wrapperLabel = this.ePillWrapper.getAriaLabel();
        const level = `${this.item.level + 1}`;
        const validationMessage = this.ePillWrapper.getValidationMessage();
        let ariaLabel;
        if (validationMessage) ariaLabel = this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderItemValidation", [
            wrapperLabel,
            level,
            validationMessage
        ]);
        else ariaLabel = this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderItem", [
            wrapperLabel,
            level
        ]);
        (0, $jIDNV._setAriaLabel)(this.focusWrapper, ariaLabel);
    }
    updateAriaExpanded() {
        (0, $jIDNV._removeAriaExpanded)(this.focusWrapper);
        const { filterModel: filterModel } = this.item;
        if (filterModel?.filterType === "join" && filterModel.conditions.length) (0, $jIDNV._setAriaExpanded)(this.focusWrapper, true);
    }
    removeItem() {
        this.dispatchLocalEvent({
            type: "advancedFilterBuilderRemoved",
            item: this.item
        });
    }
    moveItem(backwards) {
        this.dispatchLocalEvent({
            type: "advancedFilterBuilderMoved",
            item: this.item,
            backwards: backwards
        });
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/builder/advancedFilterBuilderComp.ts
var $5b7ccabde48fae90$var$ButtonLocaleMap2 = {
    apply: "advancedFilterBuilderApply",
    clear: "advancedFilterBuilderClear",
    cancel: "advancedFilterBuilderCancel",
    reset: "advancedFilterBuilderReset"
};
var $5b7ccabde48fae90$var$AdvancedFilterBuilderElement = {
    tag: "div",
    cls: "ag-advanced-filter-builder",
    role: "presentation",
    attrs: {
        tabindex: "-1"
    },
    children: [
        {
            tag: "div",
            ref: "eList",
            cls: "ag-advanced-filter-builder-list",
            role: "presentation"
        }
    ]
};
var $5b7ccabde48fae90$var$AdvancedFilterBuilderComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$AdvancedFilterBuilderElement);
        this.eList = (0, $jIDNV.RefPlaceholder);
    }
    wireBeans(beans) {
        this.filterManager = beans.filterManager;
        this.advancedFilter = beans.advancedFilter;
        this.advFilterExpSvc = beans.advFilterExpSvc;
    }
    postConstruct() {
        const params = this.gos.get("advancedFilterBuilderParams");
        this.params = {
            buttons: [
                "apply",
                "cancel"
            ],
            ...params
        };
        this.addManagedPropertyListener("advancedFilterBuilderParams", ({ currentValue: currentValue })=>{
            this.params.showMoveButtons = !!currentValue?.showMoveButtons;
            this.params.buttons = currentValue?.buttons ?? [
                "apply",
                "cancel"
            ];
            this.refreshList(false);
        });
        this.filterModel = this.setupFilterModel();
        this.setupVirtualList();
        this.dragFeature = this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedFilterBuilderDragFeature(this, this.virtualList));
        this.resetButtonsPanel(this.params.buttons);
    }
    refresh() {
        const virtualList = this.virtualList;
        let indexToFocus = virtualList.getLastFocusedRow();
        this.setupFilterModel();
        this.validateItems();
        this.refreshList(false);
        if (indexToFocus != null) {
            if (!virtualList.getComponentAt(indexToFocus)) indexToFocus = 0;
            virtualList.focusRow(indexToFocus);
        }
    }
    getNumItems() {
        return this.items.length;
    }
    moveItem(item, destination) {
        if (!destination || !item) return;
        this.moveItemToIndex(item, destination.rowIndex, destination.position);
    }
    afterGuiAttached() {
        this.virtualList.awaitStable(()=>this.virtualList.focusRow(0));
    }
    setupVirtualList() {
        const virtualList = this.virtualList = this.createManagedBean(new $5b7ccabde48fae90$var$VirtualList({
            cssIdentifier: "advanced-filter-builder",
            ariaRole: "tree",
            listName: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderList"),
            moveItemCallback: this.virtualListMoveItemCallback.bind(this)
        }));
        virtualList.setComponentCreator(this.createItemComponent.bind(this));
        virtualList.setComponentUpdater(this.updateItemComponent.bind(this));
        virtualList.setRowHeight(40);
        this.eList.appendChild(virtualList.getGui());
        virtualList.setModel({
            getRowCount: ()=>this.items?.length || 0,
            getRow: (index)=>this.items[index],
            areRowsEqual: (oldRow, newRow)=>oldRow === newRow
        });
        this.buildList();
        virtualList.refresh();
    }
    resetButtonsPanel(actions) {
        const hasButtons = actions && actions.length > 0;
        let eButtonsPanel = this.eButtons;
        if (hasButtons) {
            const buttons = actions.map((type)=>({
                    type: type,
                    label: this.advFilterExpSvc.translate($5b7ccabde48fae90$var$ButtonLocaleMap2[type])
                }));
            if (!eButtonsPanel) {
                eButtonsPanel = this.createBean(new (0, $jIDNV.FilterButtonComp)());
                this.appendChild(eButtonsPanel.getGui());
                const getListener = (action)=>({ event: event })=>{
                        this.updateModel(action);
                        this.afterAction(action, event);
                    };
                eButtonsPanel.addManagedListeners(eButtonsPanel, {
                    apply: getListener("apply"),
                    clear: getListener("clear"),
                    reset: getListener("reset"),
                    cancel: getListener("cancel")
                });
                this.eButtons = eButtonsPanel;
            }
            eButtonsPanel.updateButtons(buttons);
            const applyButton = eButtonsPanel.getApplyButton();
            if (applyButton) {
                const mouseListener = (isEnter)=>this.toggleCss("ag-advanced-filter-builder-validation", isEnter);
                this.addManagedElementListeners(applyButton, {
                    mouseenter: ()=>mouseListener(true),
                    mouseleave: ()=>mouseListener(false)
                });
            }
        } else if (eButtonsPanel) {
            (0, $jIDNV._removeFromParent)(eButtonsPanel.getGui());
            this.eButtons = this.destroyBean(eButtonsPanel);
        }
    }
    updateModel(action) {
        switch(action){
            case "apply":
                this.advancedFilter.setModel(this.filterModel);
                this.filterManager?.onFilterChanged({
                    source: "advancedFilter"
                });
                break;
            case "reset":
                this.advancedFilter.setModel(null);
                this.filterManager?.onFilterChanged({
                    source: "advancedFilter"
                });
                break;
            case "cancel":
                break;
            case "clear":
                this.filterModel = this.formatFilterModel(null);
                this.refreshList(false);
                break;
        }
    }
    afterAction(action, event) {
        switch(action){
            case "apply":
                event?.preventDefault();
                this.close();
                break;
            case "reset":
                this.close();
                break;
            case "cancel":
                this.close();
                break;
        }
    }
    removeItemFromParent(item) {
        const sourceParentIndex = item.parent.conditions.indexOf(item.filterModel);
        item.parent.conditions.splice(sourceParentIndex, 1);
        return sourceParentIndex;
    }
    moveItemToIndex(item, destinationRowIndex, destinationPosition) {
        const destinationItem = this.items[destinationRowIndex];
        const destinationIsParent = destinationItem.filterModel?.filterType === "join" && destinationPosition === "bottom";
        const destinationParent = destinationIsParent ? destinationItem.filterModel : destinationItem.parent;
        if (!destinationParent) return;
        if (this.isChildOrSelf(destinationParent, item.filterModel) || destinationItem === item) return;
        this.removeItemFromParent(item);
        let destinationParentIndex;
        if (destinationIsParent) destinationParentIndex = 0;
        else {
            destinationParentIndex = destinationParent.conditions.indexOf(destinationItem.filterModel);
            if (destinationParentIndex === -1) destinationParentIndex = destinationParent.conditions.length;
            else if (destinationPosition === "bottom") destinationParentIndex += 1;
        }
        destinationParent.conditions.splice(destinationParentIndex, 0, item.filterModel);
        this.refreshList(false);
    }
    isChildOrSelf(modelToCheck, potentialParentModel) {
        return modelToCheck === potentialParentModel || potentialParentModel.filterType === "join" && potentialParentModel.conditions.some((condition)=>this.isChildOrSelf(modelToCheck, condition));
    }
    setupFilterModel() {
        const filterModel = this.formatFilterModel(this.advancedFilter.getModel());
        this.stringifiedModel = JSON.stringify(filterModel);
        return filterModel;
    }
    formatFilterModel(filterModel) {
        filterModel = filterModel ?? {
            filterType: "join",
            type: "AND",
            conditions: []
        };
        if (filterModel.filterType !== "join") filterModel = {
            filterType: "join",
            type: "AND",
            conditions: [
                filterModel
            ]
        };
        return filterModel;
    }
    buildList() {
        const parseFilterModel = (filterModel, items, level, parent)=>{
            items.push({
                filterModel: filterModel,
                level: level,
                parent: parent,
                valid: true,
                showMove: this.params.showMoveButtons
            });
            if (filterModel.filterType === "join") {
                filterModel.conditions.forEach((childFilterModel)=>parseFilterModel(childFilterModel, items, level + 1, filterModel));
                if (level === 0) items.push({
                    filterModel: null,
                    level: level + 1,
                    parent: filterModel,
                    valid: true
                });
            }
        };
        this.items = [];
        parseFilterModel(this.filterModel, this.items, 0);
    }
    refreshList(softRefresh) {
        if (!softRefresh) {
            const invalidModels = [];
            this.items.forEach((item)=>{
                if (!item.valid) invalidModels.push(item.filterModel);
            });
            this.buildList();
            if (invalidModels.length) this.items.forEach((item)=>{
                if (item.filterModel && invalidModels.includes(item.filterModel)) item.valid = false;
            });
        }
        this.virtualList.refresh(softRefresh);
        this.validate();
    }
    updateItemComponent(item, comp) {
        const index = this.items.indexOf(item);
        const populateTreeLines = (filterModel2, treeLines2)=>{
            const parentItem = this.items.find((itemToCheck)=>itemToCheck.filterModel === filterModel2);
            const parentFilterModel = parentItem?.parent;
            if (parentFilterModel) {
                const { conditions: conditions } = parentFilterModel;
                populateTreeLines(parentFilterModel, treeLines2);
                treeLines2.push(conditions[conditions.length - 1] === filterModel2);
            }
        };
        const treeLines = [];
        const { filterModel: filterModel } = item;
        if (filterModel) {
            populateTreeLines(filterModel, treeLines);
            treeLines[0] = false;
        }
        const showStartTreeLine = filterModel?.filterType === "join" && !!filterModel.conditions.length;
        comp.setState({
            disableMoveUp: index === 1,
            disableMoveDown: !this.canMoveDown(item, index),
            treeLines: treeLines,
            showStartTreeLine: showStartTreeLine
        });
    }
    createItemComponent(item, focusWrapper) {
        const itemComp = this.createBean(item.filterModel ? new $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp(item, this.dragFeature, focusWrapper) : new $5b7ccabde48fae90$var$AdvancedFilterBuilderItemAddComp(item, focusWrapper));
        itemComp.addManagedListeners(itemComp, {
            advancedFilterBuilderRemoved: ({ item: item2 })=>this.removeItem(item2),
            advancedFilterBuilderValueChanged: ()=>this.validate(),
            advancedFilterBuilderAdded: ({ item: item2, isJoin: isJoin })=>this.addItem(item2, isJoin),
            advancedFilterBuilderMoved: ({ item: item2, backwards: backwards })=>this.moveItemUpDown(item2, backwards)
        });
        if (itemComp instanceof $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp) this.updateItemComponent(item, itemComp);
        return itemComp;
    }
    addItem(item, isJoin) {
        const { parent: itemParent, level: level, filterModel: itemFilterModel } = item;
        const itemIsJoin = itemFilterModel?.filterType === "join";
        const filterModel = isJoin ? {
            filterType: "join",
            type: "AND",
            conditions: []
        } : {};
        const parent = itemIsJoin ? itemFilterModel : itemParent;
        let insertIndex = itemIsJoin ? 0 : parent.conditions.indexOf(itemFilterModel);
        if (insertIndex >= 0) {
            if (!itemIsJoin) insertIndex += 1;
            parent.conditions.splice(insertIndex, 0, filterModel);
        } else parent.conditions.push(filterModel);
        let index = this.items.indexOf(item);
        const softRefresh = index >= 0;
        if (softRefresh) {
            if (item.filterModel) index++;
            const newItems = [
                {
                    filterModel: filterModel,
                    level: itemIsJoin ? level + 1 : level,
                    parent: parent,
                    valid: isJoin,
                    showMove: this.params.showMoveButtons
                }
            ];
            this.items.splice(index, 0, ...newItems);
        }
        this.refreshList(softRefresh);
        if (softRefresh) this.virtualList.getComponentAt(index)?.afterAdd();
    }
    removeItem(item) {
        const parent = item.parent;
        const { filterModel: filterModel } = item;
        const parentIndex = parent.conditions.indexOf(filterModel);
        parent.conditions.splice(parentIndex, 1);
        const isJoin = item.filterModel?.filterType === "join";
        const index = this.items.indexOf(item);
        const softRefresh = !isJoin && index >= 0;
        if (softRefresh) this.items.splice(index, 1);
        this.refreshList(softRefresh);
        if (index >= 0) this.virtualList.focusRow(index);
    }
    moveItemUpDown(item, backwards, fromVirtualList) {
        const itemIndex = this.items.indexOf(item);
        const destinationIndex = backwards ? itemIndex - 1 : itemIndex + 1;
        if (destinationIndex === 0 || !backwards && !this.canMoveDown(item, itemIndex)) return;
        const destinationItem = this.items[destinationIndex];
        const indexInParent = this.removeItemFromParent(item);
        const { level: level, filterModel: filterModel, parent: parent } = item;
        const { level: destinationLevel, filterModel: destinationFilterModel, parent: destinationParent } = destinationItem;
        if (backwards) {
            if (destinationLevel === level && destinationFilterModel.filterType === "join") destinationFilterModel.conditions.push(filterModel);
            else if (destinationLevel <= level) {
                const destinationIndex2 = destinationParent.conditions.indexOf(destinationFilterModel);
                destinationParent.conditions.splice(destinationIndex2, 0, filterModel);
            } else {
                const newParentItem = parent.conditions[indexInParent - 1];
                newParentItem.conditions.push(filterModel);
            }
        } else {
            if (destinationLevel === level) {
                if (destinationFilterModel.filterType === "join") destinationFilterModel.conditions.splice(0, 0, filterModel);
                else {
                    const destinationIndex2 = destinationParent.conditions.indexOf(destinationFilterModel);
                    destinationParent.conditions.splice(destinationIndex2 + 1, 0, filterModel);
                }
            } else if (indexInParent < parent.conditions.length) parent.conditions.splice(indexInParent + 1, 0, filterModel);
            else {
                const parentItem = this.items.find((itemToCheck)=>itemToCheck.filterModel === parent);
                const destinationIndex2 = parentItem.parent.conditions.indexOf(parentItem.filterModel) + 1;
                parentItem.parent.conditions.splice(destinationIndex2, 0, filterModel);
            }
        }
        this.refreshList(false);
        const newIndex = this.items.findIndex(({ filterModel: filterModelToCheck })=>filterModelToCheck === filterModel);
        if (newIndex < 0) return;
        const comp = this.virtualList.getComponentAt(newIndex);
        if (!(comp instanceof $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp)) return;
        if (!fromVirtualList) comp.focusMoveButton(backwards);
    }
    virtualListMoveItemCallback(itemComp, isUp) {
        const item = itemComp.item;
        const from = this.items.indexOf(item);
        if (from <= 0 || from === this.items.length - 1) return;
        if (isUp && from === 1 || !isUp && !this.canMoveDown(item, from)) return;
        this.moveItemUpDown(item, isUp, true);
        this.virtualList.focusRow(from + (isUp ? -1 : 1));
    }
    canMoveDown(item, index) {
        return !(item.level === 1 && index === this.items.length - 2 || item.level === 1 && item.parent.conditions[item.parent.conditions.length - 1] === item.filterModel);
    }
    close() {
        this.advancedFilter.getCtrl().toggleFilterBuilder({
            source: "ui"
        });
    }
    validate() {
        let isValid = this.items.every(({ valid: valid })=>valid);
        let validationMessage = null;
        if (isValid) {
            isValid = JSON.stringify(this.filterModel) !== this.stringifiedModel;
            if (!isValid) validationMessage = this.advFilterExpSvc.translate("advancedFilterBuilderValidationAlreadyApplied");
            else validationMessage = null;
        } else validationMessage = this.advFilterExpSvc.translate("advancedFilterBuilderValidationIncomplete");
        this.eButtons?.updateValidity(isValid, validationMessage);
    }
    validateItems() {
        const clearOperator = (filterModel)=>{
            filterModel.type = void 0;
        };
        const clearOperand = (filterModel)=>{
            delete filterModel.filter;
        };
        this.items.forEach((item)=>{
            if (!item.valid || !item.filterModel || item.filterModel.filterType === "join") return;
            const { filterModel: filterModel } = item;
            const { colId: colId } = filterModel;
            const hasColumn = this.advFilterExpSvc.getColumnAutocompleteEntries().find(({ key: key })=>key === colId);
            const columnDetails = this.advFilterExpSvc.getColumnDetails(filterModel.colId);
            if (!hasColumn || !columnDetails.column) {
                item.valid = false;
                filterModel.colId = void 0;
                clearOperator(filterModel);
                clearOperand(filterModel);
                return;
            }
            const operatorForType = this.advFilterExpSvc.getDataTypeExpressionOperator(columnDetails.baseCellDataType);
            const operator = operatorForType.operators[filterModel.type];
            if (!operator) {
                item.valid = false;
                clearOperator(filterModel);
                clearOperand(filterModel);
                return;
            }
            if (operator.numOperands > 0 && !(0, $jIDNV._exists)(filterModel.filter)) {
                item.valid = false;
                return;
            }
        });
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/advancedFilterCtrl.ts
var $5b7ccabde48fae90$var$AdvancedFilterCtrl = class extends (0, $jIDNV.BeanStub) {
    constructor(enabled){
        super();
        this.enabled = enabled;
    }
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
        this.popupSvc = beans.popupSvc;
        this.advFilterExpSvc = beans.advFilterExpSvc;
        this.environment = beans.environment;
    }
    postConstruct() {
        this.hasAdvancedFilterParent = !!this.gos.get("advancedFilterParent");
        this.ctrlsSvc.whenReady(this, ()=>this.setAdvancedFilterComp());
        this.addManagedEventListeners({
            advancedFilterEnabledChanged: ({ enabled: enabled })=>this.onEnabledChanged(enabled)
        });
        this.addManagedPropertyListener("advancedFilterParent", ()=>this.updateComps());
        this.addManagedPropertyListener("advancedFilterBuilderParams", (event)=>{
            if (event.currentValue?.suppressFullScreenButton !== event.previousValue?.suppressFullScreenButton) this.eBuilderDialog?.setMaximizable(event.currentValue?.suppressFullScreenButton ?? true);
        });
        this.addDestroyFunc(()=>{
            this.destroyAdvancedFilterComp();
            this.destroyBean(this.eBuilderComp);
            if (this.eBuilderDialog && this.eBuilderDialog.isAlive()) this.destroyBean(this.eBuilderDialog);
        });
    }
    setupHeaderComp(eCompToInsertBefore) {
        if (this.eHeaderComp) {
            this.eHeaderComp?.getGui().remove();
            this.destroyBean(this.eHeaderComp);
        }
        this.eHeaderComp = this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedFilterHeaderComp(this.enabled && !this.hasAdvancedFilterParent));
        eCompToInsertBefore.insertAdjacentElement("beforebegin", this.eHeaderComp.getGui());
    }
    focusHeaderComp() {
        if (this.eHeaderComp) {
            this.eHeaderComp.getFocusableElement().focus();
            return true;
        }
        return false;
    }
    refreshComp() {
        this.eFilterComp?.refresh();
        this.eHeaderComp?.refresh();
    }
    refreshBuilderComp() {
        this.eBuilderComp?.refresh();
    }
    getHeaderHeight() {
        return this.eHeaderComp?.getHeight() ?? 0;
    }
    setInputDisabled(disabled) {
        this.eFilterComp?.setInputDisabled(disabled);
        this.eHeaderComp?.setInputDisabled(disabled);
    }
    toggleFilterBuilder(params) {
        const { source: source, force: force, eventSource: eventSource } = params;
        if (force && this.eBuilderDialog || force === false && !this.eBuilderDialog) return;
        if (this.eBuilderDialog) {
            this.builderDestroySource = source;
            this.destroyBean(this.eBuilderDialog);
            return;
        }
        this.setInputDisabled(true);
        const { width: width, height: height, minWidth: minWidth } = this.getBuilderDialogSize();
        const { suppressFullScreenButton: suppressFullScreenButton } = {
            suppressFullScreenButton: false,
            ...this.gos.get("advancedFilterBuilderParams")
        };
        this.eBuilderComp = this.createBean(new $5b7ccabde48fae90$var$AdvancedFilterBuilderComp());
        this.eBuilderDialog = this.createBean(new $5b7ccabde48fae90$var$AgDialog({
            title: this.advFilterExpSvc.translate("advancedFilterBuilderTitle"),
            component: this.eBuilderComp,
            width: width,
            height: height,
            resizable: true,
            movable: true,
            maximizable: !suppressFullScreenButton,
            centered: true,
            closable: true,
            minWidth: minWidth,
            afterGuiAttached: ()=>this.eBuilderComp?.afterGuiAttached(),
            postProcessPopupParams: {
                type: "advancedFilterBuilder",
                eventSource: eventSource
            }
        }));
        this.dispatchFilterBuilderVisibleChangedEvent(source, true);
        this.eBuilderDialog.addEventListener("destroyed", ()=>{
            this.destroyBean(this.eBuilderComp);
            this.eBuilderComp = void 0;
            this.eBuilderDialog = void 0;
            this.setInputDisabled(false);
            this.dispatchLocalEvent({
                type: "advancedFilterBuilderClosed"
            });
            this.dispatchFilterBuilderVisibleChangedEvent(this.builderDestroySource ?? "ui", false);
            this.builderDestroySource = void 0;
        });
    }
    dispatchFilterBuilderVisibleChangedEvent(source, visible) {
        this.eventSvc.dispatchEvent({
            type: "advancedFilterBuilderVisibleChanged",
            source: source,
            visible: visible
        });
    }
    getBuilderDialogSize() {
        const minWidth = this.gos.get("advancedFilterBuilderParams")?.minWidth ?? 500;
        const popupParent = this.popupSvc.getPopupParent();
        const maxWidth = Math.round((0, $jIDNV._getAbsoluteWidth)(popupParent)) - 2;
        const maxHeight = Math.round((0, $jIDNV._getAbsoluteHeight)(popupParent) * 0.75) - 2;
        const width = Math.min(Math.max(700, minWidth), maxWidth);
        const height = Math.min(600, maxHeight);
        return {
            width: width,
            height: height,
            minWidth: minWidth
        };
    }
    onEnabledChanged(enabled) {
        this.enabled = enabled;
        this.updateComps();
    }
    updateComps() {
        this.setAdvancedFilterComp();
        this.setHeaderCompEnabled();
        this.eventSvc.dispatchEvent({
            type: "headerHeightChanged"
        });
    }
    setAdvancedFilterComp() {
        this.destroyAdvancedFilterComp();
        if (!this.enabled) return;
        const advancedFilterParent = this.gos.get("advancedFilterParent");
        this.hasAdvancedFilterParent = !!advancedFilterParent;
        if (advancedFilterParent) {
            const eAdvancedFilterComp = this.createBean(new $5b7ccabde48fae90$var$AdvancedFilterComp());
            const eAdvancedFilterCompGui = eAdvancedFilterComp.getGui();
            this.environment.applyThemeClasses(eAdvancedFilterCompGui);
            eAdvancedFilterCompGui.classList.add(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr");
            advancedFilterParent.appendChild(eAdvancedFilterCompGui);
            this.eFilterComp = eAdvancedFilterComp;
        }
    }
    setHeaderCompEnabled() {
        this.eHeaderComp?.setEnabled(this.enabled && !this.hasAdvancedFilterParent);
    }
    destroyAdvancedFilterComp() {
        if (this.eFilterComp) {
            (0, $jIDNV._removeFromParent)(this.eFilterComp.getGui());
            this.destroyBean(this.eFilterComp);
        }
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/joinFilterExpressionParser.ts
var $5b7ccabde48fae90$var$OperatorParser2 = class {
    constructor(params){
        this.params = params;
        this.operators = [];
        this.operatorStartPositions = [];
        this.operatorEndPositions = [];
        this.activeOperator = 0;
        this.validationError = null;
    }
    parseExpression(i) {
        this.operators.push("");
        this.operatorStartPositions.push(i);
        this.operatorEndPositions.push(void 0);
        const { expression: expression } = this.params;
        while(i < expression.length){
            const char = expression[i];
            if (char === " ") {
                const isComplete = this.parseOperator(i - 1);
                if (isComplete) {
                    this.activeOperator++;
                    return i - 1;
                } else this.operators[this.activeOperator] += char;
            } else this.operators[this.activeOperator] += char;
            i++;
        }
        this.parseOperator(i - 1);
        return i;
    }
    isValid() {
        return !this.validationError && (!this.operators.length || !!this.parsedOperator);
    }
    getValidationError() {
        return this.validationError;
    }
    getFunction() {
        return this.parsedOperator === "OR" ? "||" : "&&";
    }
    getModel() {
        return this.parsedOperator === "OR" ? "OR" : "AND";
    }
    getAutocompleteListParams(position, operatorIndex) {
        let searchString;
        if (operatorIndex == null) searchString = "";
        else {
            const operator = this.operators[operatorIndex];
            const operatorEndPosition = this.operatorEndPositions[operatorIndex];
            searchString = $5b7ccabde48fae90$var$getSearchString(operator, position, operatorEndPosition == null ? this.params.expression.length : operatorEndPosition + 1);
        }
        let entries = this.params.advFilterExpSvc.getJoinOperatorAutocompleteEntries();
        if (operatorIndex || operatorIndex == null && this.activeOperator) entries = entries.filter(({ key: key })=>key === this.parsedOperator);
        return this.params.advFilterExpSvc.generateAutocompleteListParams(entries, "join", searchString);
    }
    updateExpression(position, updateEntry, operatorIndex) {
        let { expression: expression } = this.params;
        const updatedValuePart = updateEntry.displayValue ?? updateEntry.key;
        if (operatorIndex === 0) for(let i = this.operatorEndPositions.length - 1; i > 0; i--){
            const operatorEndPosition = this.operatorEndPositions[i];
            if (operatorEndPosition == null) continue;
            expression = $5b7ccabde48fae90$var$updateExpression(expression, this.operatorStartPositions[i], operatorEndPosition, updatedValuePart).updatedValue;
        }
        const startPosition = this.operatorStartPositions.length > operatorIndex ? this.operatorStartPositions[operatorIndex] : position;
        const endPosition = (this.operatorEndPositions.length > operatorIndex ? this.operatorEndPositions[operatorIndex] : void 0) ?? $5b7ccabde48fae90$var$findEndPosition(expression, position, true).endPosition;
        return $5b7ccabde48fae90$var$updateExpression(expression, startPosition, endPosition, updatedValuePart, true);
    }
    getNumOperators() {
        return this.operators.length;
    }
    getLastOperatorEndPosition() {
        return this.operatorEndPositions[this.operatorEndPositions.length - 1];
    }
    parseOperator(endPosition) {
        const operator = this.operators.length > this.activeOperator ? this.operators[this.activeOperator] : "";
        const joinOperators = this.params.advFilterExpSvc.getExpressionJoinOperators();
        const parsedValue = $5b7ccabde48fae90$var$findMatch(operator, joinOperators, (v)=>v);
        if (parsedValue) {
            this.operatorEndPositions[this.activeOperator] = endPosition;
            const displayValue = joinOperators[parsedValue];
            if (this.activeOperator) {
                if (parsedValue !== this.parsedOperator) {
                    if (!this.validationError) this.validationError = {
                        message: this.params.advFilterExpSvc.translate("advancedFilterValidationJoinOperatorMismatch"),
                        startPosition: endPosition - operator.length + 1,
                        endPosition: endPosition
                    };
                    return false;
                }
            } else this.parsedOperator = parsedValue;
            if (operator !== displayValue) {
                $5b7ccabde48fae90$var$checkAndUpdateExpression(this.params, operator, displayValue, endPosition);
                this.operators[this.activeOperator] = displayValue;
            }
            return true;
        } else if (parsedValue === null) return false;
        else {
            if (!this.validationError) this.validationError = {
                message: this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidJoinOperator"),
                startPosition: endPosition - operator.length + 1,
                endPosition: endPosition
            };
            return true;
        }
    }
};
var $5b7ccabde48fae90$var$JoinFilterExpressionParser = class _JoinFilterExpressionParser {
    constructor(params, startPosition){
        this.params = params;
        this.startPosition = startPosition;
        this.expectingExpression = true;
        this.expectingOperator = false;
        this.expressionParsers = [];
        this.operatorParser = new $5b7ccabde48fae90$var$OperatorParser2(this.params);
        this.missingEndBracket = false;
        this.extraEndBracket = false;
    }
    parseExpression() {
        let i = this.startPosition;
        const { expression: expression } = this.params;
        while(i < expression.length){
            const char = expression[i];
            if (char === "(" && !this.expectingOperator) {
                const nestedParser = new _JoinFilterExpressionParser(this.params, i + 1);
                i = nestedParser.parseExpression();
                this.expressionParsers.push(nestedParser);
                this.expectingExpression = false;
                this.expectingOperator = true;
            } else if (char === ")") {
                this.endPosition = i - 1;
                if (this.startPosition === 0) this.extraEndBracket = true;
                return i;
            } else if (char === " ") ;
            else if (this.expectingExpression) {
                const nestedParser = new $5b7ccabde48fae90$var$ColFilterExpressionParser(this.params, i);
                i = nestedParser.parseExpression();
                this.expressionParsers.push(nestedParser);
                this.expectingExpression = false;
                this.expectingOperator = true;
            } else if (this.expectingOperator) {
                i = this.operatorParser.parseExpression(i);
                this.expectingOperator = false;
                this.expectingExpression = true;
            }
            i++;
        }
        if (this.startPosition > 0) this.missingEndBracket = true;
        return i;
    }
    isValid() {
        return !this.missingEndBracket && !this.extraEndBracket && this.expressionParsers.length === this.operatorParser.getNumOperators() + 1 && this.operatorParser.isValid() && this.expressionParsers.every((expressionParser)=>expressionParser.isValid());
    }
    getValidationError() {
        const operatorError = this.operatorParser.getValidationError();
        for(let i = 0; i < this.expressionParsers.length; i++){
            const expressionError = this.expressionParsers[i].getValidationError();
            if (expressionError) return operatorError && operatorError.startPosition < expressionError.startPosition ? operatorError : expressionError;
        }
        if (operatorError) return operatorError;
        if (this.extraEndBracket) return {
            message: this.params.advFilterExpSvc.translate("advancedFilterValidationExtraEndBracket"),
            startPosition: this.endPosition + 1,
            endPosition: this.endPosition + 1
        };
        let translateKey;
        if (this.expressionParsers.length === this.operatorParser.getNumOperators()) translateKey = "advancedFilterValidationMissingCondition";
        else if (this.missingEndBracket) translateKey = "advancedFilterValidationMissingEndBracket";
        if (translateKey) return {
            message: this.params.advFilterExpSvc.translate(translateKey),
            startPosition: this.params.expression.length,
            endPosition: this.params.expression.length
        };
        return null;
    }
    getFunction(params) {
        const operator = this.operatorParser.getFunction();
        const funcs = this.expressionParsers.map((expressionParser)=>expressionParser.getFunction(params));
        const arrayFunc = operator === "&&" ? "every" : "some";
        return (expressionProxy, node, p)=>funcs[arrayFunc]((func)=>func(expressionProxy, node, p));
    }
    getAutocompleteListParams(position) {
        if (this.endPosition != null && position > this.endPosition + 1) return void 0;
        if (!this.expressionParsers.length) return this.getColumnAutocompleteListParams();
        const expressionParserIndex = this.getExpressionParserIndex(position);
        if (expressionParserIndex == null) {
            if (this.params.expression[position] === "(") return {
                enabled: false
            };
            return this.getColumnAutocompleteListParams();
        }
        const expressionParser = this.expressionParsers[expressionParserIndex];
        const autocompleteType = expressionParser.getAutocompleteListParams(position);
        if (!autocompleteType) {
            if (expressionParserIndex < this.expressionParsers.length - 1) return this.operatorParser.getAutocompleteListParams(position, expressionParserIndex);
            if (this.expressionParsers.length === this.operatorParser.getNumOperators()) {
                const operatorEndPosition = this.operatorParser.getLastOperatorEndPosition();
                return operatorEndPosition == null || position <= operatorEndPosition + 1 ? this.operatorParser.getAutocompleteListParams(position, this.operatorParser.getNumOperators() - 1) : this.getColumnAutocompleteListParams();
            }
            if (this.params.expression[position - 1] === ")") return {
                enabled: false
            };
            return this.operatorParser.getAutocompleteListParams(position);
        }
        return autocompleteType;
    }
    updateExpression(position, updateEntry, type) {
        const expression = this.params.expression;
        const expressionParserIndex = this.getExpressionParserIndex(position);
        if (expressionParserIndex == null) {
            const updatedValuePart = type === "column" ? this.params.advFilterExpSvc.getColumnValue(updateEntry) : updateEntry.displayValue ?? updateEntry.key;
            return $5b7ccabde48fae90$var$updateExpression(expression, this.startPosition, this.startPosition, updatedValuePart, true);
        }
        const expressionParser = this.expressionParsers[expressionParserIndex];
        const updatedExpression = expressionParser.updateExpression(position, updateEntry, type);
        if (updatedExpression == null) {
            if (type === "column") return $5b7ccabde48fae90$var$updateExpression(expression, position, expression.length - 1, this.params.advFilterExpSvc.getColumnValue(updateEntry), true);
            else if (this.endPosition != null && position > this.endPosition + 1) return null;
            else return this.operatorParser.updateExpression(position, updateEntry, expressionParserIndex);
        }
        return updatedExpression;
    }
    getModel() {
        if (this.expressionParsers.length > 1) return {
            filterType: "join",
            type: this.operatorParser.getModel(),
            conditions: this.expressionParsers.map((parser)=>parser.getModel())
        };
        else return this.expressionParsers[0].getModel();
    }
    getColumnAutocompleteListParams() {
        return this.params.advFilterExpSvc.generateAutocompleteListParams(this.params.advFilterExpSvc.getColumnAutocompleteEntries(), "column", "");
    }
    getExpressionParserIndex(position) {
        let expressionParserIndex;
        for(let i = 0; i < this.expressionParsers.length; i++){
            const expressionParserToCheck = this.expressionParsers[i];
            if (expressionParserToCheck.startPosition > position) break;
            expressionParserIndex = i;
        }
        return expressionParserIndex;
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/filterExpressionParser.ts
var $5b7ccabde48fae90$var$FilterExpressionParser = class {
    constructor(params){
        this.params = params;
        this.valid = false;
    }
    parseExpression() {
        this.joinExpressionParser = new $5b7ccabde48fae90$var$JoinFilterExpressionParser(this.params, 0);
        const i = this.joinExpressionParser.parseExpression();
        this.valid = i >= this.params.expression.length - 1 && this.joinExpressionParser.isValid();
        return this.params.expression;
    }
    isValid() {
        return this.valid;
    }
    getValidationMessage() {
        const error = this.joinExpressionParser.getValidationError();
        if (!error) return null;
        const { message: message, startPosition: startPosition, endPosition: endPosition } = error;
        return startPosition < this.params.expression.length ? this.params.advFilterExpSvc.translate("advancedFilterValidationMessage", [
            message,
            this.params.expression.slice(startPosition, endPosition + 1).trim()
        ]) : this.params.advFilterExpSvc.translate("advancedFilterValidationMessageAtEnd", [
            message
        ]);
    }
    getFunction() {
        const params = this.createFunctionParams();
        return {
            expressionFunction: this.joinExpressionParser.getFunction(params),
            params: params
        };
    }
    getAutocompleteListParams(position) {
        return this.joinExpressionParser.getAutocompleteListParams(position) ?? {
            enabled: false
        };
    }
    updateExpression(position, updateEntry, type) {
        return this.joinExpressionParser.updateExpression(position, updateEntry, type);
    }
    getModel() {
        return this.isValid() ? this.joinExpressionParser.getModel() : null;
    }
    createFunctionParams() {
        return {
            operands: [],
            operators: [],
            evaluatorParams: []
        };
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/advancedFilterService.ts
var $5b7ccabde48fae90$var$AdvancedFilterService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "advancedFilter";
        this.appliedExpression = null;
        /** The value displayed in the input, which may be invalid */ this.expression = null;
        this.isValid = true;
    }
    wireBeans(beans) {
        this.valueSvc = beans.valueSvc;
        this.colModel = beans.colModel;
        this.dataTypeSvc = beans.dataTypeSvc;
        this.advFilterExpSvc = beans.advFilterExpSvc;
        this.filterValueSvc = beans.filterValueSvc;
    }
    postConstruct() {
        this.setEnabled(this.gos.get("enableAdvancedFilter"), true);
        this.ctrl = this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedFilterCtrl(this.enabled));
        this.expressionProxy = {
            getValue: (colId, node)=>{
                const column = this.colModel.getColDefCol(colId);
                return column ? this.filterValueSvc.getValue(column, node) : void 0;
            }
        };
        this.addManagedPropertyListener("enableAdvancedFilter", (event)=>this.setEnabled(!!event.currentValue));
        this.addManagedEventListeners({
            newColumnsLoaded: (event)=>this.onNewColumnsLoaded(event)
        });
        this.addManagedPropertyListener("includeHiddenColumnsInAdvancedFilter", ()=>this.updateValidity());
    }
    isEnabled() {
        return this.enabled;
    }
    isFilterPresent() {
        return !!this.expressionFunction;
    }
    doesFilterPass(node) {
        return this.expressionFunction(this.expressionProxy, node, this.expressionParams);
    }
    getModel() {
        const expressionParser = this.createExpressionParser(this.appliedExpression);
        expressionParser?.parseExpression();
        return expressionParser?.getModel() ?? null;
    }
    setModel(model) {
        const parseModel = (model2, isFirstParent)=>{
            if (model2.filterType === "join") {
                const operator = this.advFilterExpSvc.parseJoinOperator(model2);
                const expression2 = model2.conditions.map((condition)=>parseModel(condition)).filter((condition)=>(0, $jIDNV._exists)(condition)).join(` ${operator} `);
                return isFirstParent || model2.conditions.length <= 1 ? expression2 : `(${expression2})`;
            } else return this.advFilterExpSvc.parseColumnFilterModel(model2);
        };
        const expression = model ? parseModel(model, true) : null;
        this.setExpressionDisplayValue(expression);
        this.applyExpression();
        this.ctrl.refreshComp();
        this.ctrl.refreshBuilderComp();
    }
    getExpressionDisplayValue() {
        return this.expression;
    }
    setExpressionDisplayValue(expression) {
        this.expression = expression;
    }
    isCurrentExpressionApplied() {
        return this.appliedExpression === this.expression;
    }
    createExpressionParser(expression) {
        if (!expression) return null;
        return new $5b7ccabde48fae90$var$FilterExpressionParser({
            expression: expression,
            colModel: this.colModel,
            dataTypeSvc: this.dataTypeSvc,
            valueSvc: this.valueSvc,
            advFilterExpSvc: this.advFilterExpSvc
        });
    }
    getDefaultExpression(updateEntry) {
        const updatedValue = this.advFilterExpSvc.getColumnValue(updateEntry) + " ";
        return {
            updatedValue: updatedValue,
            updatedPosition: updatedValue.length
        };
    }
    isHeaderActive() {
        return !this.gos.get("advancedFilterParent");
    }
    getCtrl() {
        return this.ctrl;
    }
    setEnabled(enabled, silent) {
        const previousValue = this.enabled;
        const isValidRowModel = (0, $jIDNV._isClientSideRowModel)(this.gos) || (0, $jIDNV._isServerSideRowModel)(this.gos);
        if (enabled && !isValidRowModel) (0, $jIDNV._warn)(123);
        this.enabled = enabled && isValidRowModel;
        if (!silent && this.enabled !== previousValue) this.eventSvc.dispatchEvent({
            type: "advancedFilterEnabledChanged",
            enabled: this.enabled
        });
    }
    applyExpression() {
        const expressionParser = this.createExpressionParser(this.expression);
        expressionParser?.parseExpression();
        this.applyExpressionFromParser(expressionParser);
    }
    getAppliedExpressionDisplayValue() {
        return this.appliedExpression;
    }
    applyExpressionFromParser(expressionParser) {
        this.isValid = !expressionParser || expressionParser.isValid();
        if (!expressionParser || !this.isValid) {
            this.expressionFunction = null;
            this.expressionParams = null;
            this.appliedExpression = null;
            return;
        }
        const { expressionFunction: expressionFunction, params: params } = expressionParser.getFunction();
        this.expressionFunction = expressionFunction;
        this.expressionParams = params;
        this.appliedExpression = this.expression;
    }
    updateValidity() {
        this.advFilterExpSvc.resetColumnCaches();
        const expressionParser = this.createExpressionParser(this.expression);
        expressionParser?.parseExpression();
        const isValid = !expressionParser || expressionParser.isValid();
        const updatedValidity = isValid !== this.isValid;
        this.applyExpressionFromParser(expressionParser);
        this.ctrl.refreshComp();
        this.ctrl.refreshBuilderComp();
        return updatedValidity;
    }
    onNewColumnsLoaded(event) {
        if (event.source !== "gridInitializing" || !this.dataTypeSvc?.isPendingInference) return;
        this.ctrl.setInputDisabled(true);
        const [destroyFunc] = this.addManagedEventListeners({
            dataTypesInferred: ()=>{
                destroyFunc?.();
                this.ctrl.setInputDisabled(false);
            }
        });
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/advancedFilterModule.ts
var $5b7ccabde48fae90$export$5f40a5e44930bd02 = {
    moduleName: "AdvancedFilter",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$AdvancedFilterService,
        $5b7ccabde48fae90$var$AdvancedFilterExpressionService
    ],
    icons: {
        // Builder button in Advanced Filter
        advancedFilterBuilder: "group",
        // drag handle used to pick up Advanced Filter Builder rows
        advancedFilterBuilderDrag: "grip",
        // Advanced Filter Builder row validation error
        advancedFilterBuilderInvalid: "not-allowed",
        // shown on Advanced Filter Builder rows to move them up
        advancedFilterBuilderMoveUp: "up",
        // shown on Advanced Filter Builder rows to move them down
        advancedFilterBuilderMoveDown: "down",
        // shown on Advanced Filter Builder rows to add new rows
        advancedFilterBuilderAdd: "plus",
        // shown on Advanced Filter Builder rows to remove row
        advancedFilterBuilderRemove: "minus",
        // shown on Advanced Filter Builder selection pills
        advancedFilterBuilderSelectOpen: "small-down",
        // remove for rich select editor pills
        richSelectRemove: "cancel"
    },
    apiFunctions: {
        getAdvancedFilterModel: $5b7ccabde48fae90$var$getAdvancedFilterModel,
        setAdvancedFilterModel: $5b7ccabde48fae90$var$setAdvancedFilterModel,
        showAdvancedFilterBuilder: $5b7ccabde48fae90$var$showAdvancedFilterBuilder,
        hideAdvancedFilterBuilder: $5b7ccabde48fae90$var$hideAdvancedFilterBuilder
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $jIDNV._FilterCoreModule),
        (0, $jIDNV._SharedDragAndDropModule),
        (0, $jIDNV._PopupModule),
        (0, $jIDNV._FilterValueModule),
        (0, $jIDNV.TooltipModule)
    ],
    css: [
        $5b7ccabde48fae90$var$advancedFilterCSS
    ]
};
function $5b7ccabde48fae90$var$isSideBarVisible(beans) {
    return beans.sideBar?.comp.isDisplayed() ?? false;
}
function $5b7ccabde48fae90$var$setSideBarVisible(beans, show) {
    beans.sideBar?.comp.setDisplayed(show);
}
function $5b7ccabde48fae90$var$setSideBarPosition(beans, position) {
    beans.sideBar?.comp.setSideBarPosition(position);
}
function $5b7ccabde48fae90$var$openToolPanel(beans, key) {
    beans.sideBar?.comp.openToolPanel(key, "api");
}
function $5b7ccabde48fae90$var$closeToolPanel(beans) {
    beans.sideBar?.comp.close("api");
}
function $5b7ccabde48fae90$var$getOpenedToolPanel(beans) {
    return beans.sideBar?.comp.openedItem() ?? null;
}
function $5b7ccabde48fae90$var$refreshToolPanel(beans) {
    beans.sideBar?.comp.refresh();
}
function $5b7ccabde48fae90$var$isToolPanelShowing(beans) {
    return beans.sideBar?.comp.isToolPanelShowing() ?? false;
}
function $5b7ccabde48fae90$var$getToolPanelInstance(beans, id) {
    const comp = beans.sideBar?.comp.getToolPanelInstance(id);
    return (0, $jIDNV._unwrapUserComp)(comp);
}
function $5b7ccabde48fae90$var$getSideBar(beans) {
    return beans.sideBar?.comp.getDef();
}
function $5b7ccabde48fae90$var$findFocusableElementBeforeTabGuard(rootNode, referenceElement) {
    if (!referenceElement) return null;
    const focusableElements = (0, $jIDNV._findFocusableElements)(rootNode);
    const referenceIndex = focusableElements.indexOf(referenceElement);
    if (referenceIndex === -1) return null;
    let lastTabGuardIndex = -1;
    for(let i = referenceIndex - 1; i >= 0; i--)if (focusableElements[i].classList.contains((0, $jIDNV.TabGuardClassNames).TAB_GUARD_TOP)) {
        lastTabGuardIndex = i;
        break;
    }
    if (lastTabGuardIndex <= 0) return null;
    return focusableElements[lastTabGuardIndex - 1];
}
function $5b7ccabde48fae90$var$isTargetUnderManagedComponent(rootNode, target) {
    if (!target) return false;
    const managedContainers = rootNode.querySelectorAll(`.${(0, $jIDNV._FOCUS_MANAGED_CLASS)}`);
    if (!managedContainers.length) return false;
    for(let i = 0; i < managedContainers.length; i++){
        if (managedContainers[i].contains(target)) return true;
    }
    return false;
}
// packages/ag-grid-enterprise/src/sideBar/agSideBar.css-GENERATED.ts
var $5b7ccabde48fae90$var$agSideBarCSS = /*css*/ `.ag-tool-panel-wrapper{display:flex;overflow:hidden auto;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:var(--ag-side-bar-panel-width)}.ag-select-agg-func-item{align-items:center;display:flex;flex:1 1 auto;flex-flow:row nowrap;height:100%;overflow:hidden;position:relative;text-overflow:ellipsis;white-space:nowrap;>*{flex:none}}.ag-tool-panel-horizontal-resize{cursor:ew-resize;height:100%;position:absolute;top:0;width:5px;z-index:1}.ag-side-bar{background-color:var(--ag-side-bar-background-color);display:flex;flex-direction:row-reverse;position:relative}:where(.ag-ltr) :where(.ag-side-bar-left) .ag-tool-panel-horizontal-resize{right:-3px}:where(.ag-rtl) :where(.ag-side-bar-left) .ag-tool-panel-horizontal-resize{left:-3px}:where(.ag-ltr) :where(.ag-side-bar-right) .ag-tool-panel-horizontal-resize{left:-3px}:where(.ag-rtl) :where(.ag-side-bar-right) .ag-tool-panel-horizontal-resize{right:-3px}.ag-side-bar-left{flex-direction:row;order:-1}.ag-side-buttons{background-color:var(--ag-side-button-bar-background-color);padding-top:var(--ag-side-button-bar-top-padding);position:relative}.ag-side-button{background-color:var(--ag-side-button-background-color);border-bottom:var(--ag-side-button-border);border-top:var(--ag-side-button-border);color:var(--ag-side-button-text-color);margin-top:-1px;position:relative;&:before{background-color:transparent;bottom:0;content:"";display:block;position:absolute;top:0;transition:background-color var(--ag-side-button-selected-underline-transition-duration);width:var(--ag-side-button-selected-underline-width)}&:hover{background-color:var(--ag-side-button-hover-background-color);color:var(--ag-side-button-hover-text-color)}&.ag-selected{background-color:var(--ag-side-button-selected-background-color);border-bottom:var(--ag-side-button-selected-border);border-top:var(--ag-side-button-selected-border);color:var(--ag-side-button-selected-text-color);&:before{background-color:var(--ag-side-button-selected-underline-color)}}}:where(.ag-ltr) .ag-side-button{&:before{left:0}}:where(.ag-rtl) .ag-side-button{&:before{right:0}}.ag-side-button-button{align-items:center;display:flex;flex-direction:column;gap:var(--ag-spacing);position:relative;white-space:nowrap;width:100%;&:focus{box-shadow:none}}:where(.ag-ltr) .ag-side-button-button{padding:var(--ag-side-button-vertical-padding) var(--ag-side-button-right-padding) var(--ag-side-button-vertical-padding) var(--ag-side-button-left-padding)}:where(.ag-rtl) .ag-side-button-button{padding:var(--ag-side-button-vertical-padding) var(--ag-side-button-left-padding) var(--ag-side-button-vertical-padding) var(--ag-side-button-right-padding)}.ag-side-button-button:focus-visible{box-shadow:inset var(--ag-focus-shadow)}.ag-side-button-label{writing-mode:vertical-lr}@media (resolution <= 1.5x){.ag-side-button-label{font-family:"Segoe UI",var(--ag-font-family)}:where(.ag-ltr) .ag-side-button-label{transform:rotate(.05deg)}:where(.ag-rtl) .ag-side-button-label{transform:rotate(-.05deg)}}:where(.ag-ltr) .ag-side-bar-left,:where(.ag-rtl) .ag-side-bar-right{border-right:var(--ag-side-panel-border);:where(.ag-tool-panel-wrapper){border-left:var(--ag-side-panel-border)}}:where(.ag-ltr) .ag-side-bar-right,:where(.ag-rtl) .ag-side-bar-left{border-left:var(--ag-side-panel-border);:where(.ag-tool-panel-wrapper){border-right:var(--ag-side-panel-border)}}`;
var $5b7ccabde48fae90$var$SideBarButtonElement = {
    tag: "div",
    cls: "ag-side-button",
    role: "presentation",
    children: [
        {
            tag: "button",
            ref: "eToggleButton",
            cls: "ag-button ag-side-button-button",
            role: "tab",
            attrs: {
                type: "button",
                tabindex: "-1",
                "aria-expanded": "false"
            },
            children: [
                {
                    tag: "div",
                    ref: "eIconWrapper",
                    cls: "ag-side-button-icon-wrapper",
                    attrs: {
                        "aria-hidden": "true"
                    }
                },
                {
                    tag: "span",
                    ref: "eLabel",
                    cls: "ag-side-button-label"
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$SideBarButtonComp = class extends (0, $jIDNV.Component) {
    constructor(toolPanelDef){
        super();
        this.toolPanelDef = toolPanelDef;
        this.eToggleButton = (0, $jIDNV.RefPlaceholder);
        this.eIconWrapper = (0, $jIDNV.RefPlaceholder);
        this.eLabel = (0, $jIDNV.RefPlaceholder);
    }
    getToolPanelId() {
        return this.toolPanelDef.id;
    }
    postConstruct() {
        this.setTemplate($5b7ccabde48fae90$var$SideBarButtonElement, []);
        this.setLabel();
        this.setIcon();
        this.addManagedElementListeners(this.eToggleButton, {
            click: this.onButtonPressed.bind(this)
        });
        this.eToggleButton.setAttribute("id", `ag-${this.getCompId()}-button`);
    }
    setLabel() {
        const def = this.toolPanelDef;
        const label = this.getLocaleTextFunc()(def.labelKey, def.labelDefault);
        this.eLabel.textContent = label;
    }
    setIcon() {
        this.eIconWrapper.insertAdjacentElement("afterbegin", (0, $jIDNV._createIconNoSpan)(this.toolPanelDef.iconKey, this.beans));
    }
    onButtonPressed() {
        this.dispatchLocalEvent({
            type: "toggleButtonClicked"
        });
    }
    setSelected(selected) {
        this.toggleCss("ag-selected", selected);
        (0, $jIDNV._setAriaExpanded)(this.eToggleButton, selected);
    }
};
// packages/ag-grid-enterprise/src/sideBar/agSideBarButtons.ts
var $5b7ccabde48fae90$var$SideBarElement = {
    tag: "div",
    cls: "ag-side-buttons",
    role: "tablist"
};
var $5b7ccabde48fae90$var$AgSideBarButtons = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$SideBarElement);
        this.buttonComps = [];
    }
    postConstruct() {
        this.addManagedElementListeners(this.getFocusableElement(), {
            keydown: this.handleKeyDown.bind(this)
        });
    }
    handleKeyDown(e) {
        if (e.key !== (0, $jIDNV.KeyCode).TAB || !e.shiftKey) return;
        if ((0, $jIDNV._focusNextGridCoreContainer)(this.beans, true)) {
            e.preventDefault();
            return;
        }
        (0, $jIDNV._stopPropagationForAgGrid)(e);
    }
    setActiveButton(id) {
        this.buttonComps.forEach((comp)=>{
            comp.setSelected(id === comp.getToolPanelId());
        });
    }
    addButtonComp(def) {
        const buttonComp = this.createBean(new $5b7ccabde48fae90$var$SideBarButtonComp(def));
        this.buttonComps.push(buttonComp);
        this.appendChild(buttonComp);
        buttonComp.addEventListener("toggleButtonClicked", ()=>{
            this.dispatchLocalEvent({
                type: "sideBarButtonClicked",
                toolPanelId: def.id
            });
        });
        return buttonComp;
    }
    clearButtons() {
        this.buttonComps = this.destroyBeans(this.buttonComps);
        (0, $jIDNV._clearElement)(this.getGui());
        super.destroy();
    }
    destroy() {
        this.clearButtons();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$AgSideBarButtonsSelector = {
    selector: "AG-SIDE-BAR-BUTTONS",
    component: $5b7ccabde48fae90$var$AgSideBarButtons
};
var $5b7ccabde48fae90$var$DEFAULT_COLUMN_COMP = {
    id: "columns",
    labelDefault: "Columns",
    labelKey: "columns",
    iconKey: "columnsToolPanel",
    toolPanel: "agColumnsToolPanel"
};
var $5b7ccabde48fae90$var$DEFAULT_FILTER_COMP = {
    id: "filters",
    labelDefault: "Filters",
    labelKey: "filters",
    iconKey: "filtersToolPanel",
    toolPanel: "agFiltersToolPanel"
};
var $5b7ccabde48fae90$var$DEFAULT_NEW_FILTER_COMP = {
    id: "filters-new",
    labelDefault: "Filters",
    labelKey: "filters",
    iconKey: "filtersToolPanel",
    toolPanel: "agNewFiltersToolPanel"
};
var $5b7ccabde48fae90$var$DEFAULT_BY_KEY = {
    columns: $5b7ccabde48fae90$var$DEFAULT_COLUMN_COMP,
    filters: $5b7ccabde48fae90$var$DEFAULT_FILTER_COMP,
    "filters-new": $5b7ccabde48fae90$var$DEFAULT_NEW_FILTER_COMP
};
function $5b7ccabde48fae90$var$parseSideBarDef(toParse) {
    if (!toParse) return void 0;
    if (toParse === true) return {
        toolPanels: [
            $5b7ccabde48fae90$var$DEFAULT_COLUMN_COMP,
            $5b7ccabde48fae90$var$DEFAULT_FILTER_COMP
        ],
        defaultToolPanel: "columns"
    };
    if (typeof toParse === "string") return $5b7ccabde48fae90$var$parseSideBarDef([
        toParse
    ]);
    if (Array.isArray(toParse)) {
        const comps = [];
        toParse.forEach((key)=>{
            const lookupResult = $5b7ccabde48fae90$var$DEFAULT_BY_KEY[key];
            if (!lookupResult) {
                (0, $jIDNV._warn)(215, {
                    key: key,
                    defaultByKey: $5b7ccabde48fae90$var$DEFAULT_BY_KEY
                });
                return;
            }
            comps.push(lookupResult);
        });
        if (comps.length === 0) return void 0;
        return {
            toolPanels: comps,
            defaultToolPanel: comps[0].id
        };
    }
    const result = {
        toolPanels: $5b7ccabde48fae90$var$parseComponents(toParse.toolPanels),
        defaultToolPanel: toParse.defaultToolPanel,
        hiddenByDefault: toParse.hiddenByDefault,
        position: toParse.position
    };
    return result;
}
function $5b7ccabde48fae90$var$parseComponents(from) {
    const result = [];
    if (!from) return result;
    from.forEach((it)=>{
        let toAdd = null;
        if (typeof it === "string") {
            const lookupResult = $5b7ccabde48fae90$var$DEFAULT_BY_KEY[it];
            if (!lookupResult) {
                (0, $jIDNV._warn)(215, {
                    key: it,
                    defaultByKey: $5b7ccabde48fae90$var$DEFAULT_BY_KEY
                });
                return;
            }
            toAdd = lookupResult;
        } else toAdd = it;
        result.push(toAdd);
    });
    return result;
}
var $5b7ccabde48fae90$var$AgHorizontalResize = class extends (0, $jIDNV.Component) {
    constructor(){
        super({
            tag: "div",
            cls: "ag-tool-panel-horizontal-resize"
        });
        this.minWidth = 100;
        this.maxWidth = null;
    }
    postConstruct() {
        const finishedWithResizeFunc = this.beans.horizontalResizeSvc.addResizeBar({
            eResizeBar: this.getGui(),
            dragStartPixels: 1,
            onResizeStart: this.onResizeStart.bind(this),
            onResizing: this.onResizing.bind(this),
            onResizeEnd: this.onResizeEnd.bind(this)
        });
        this.addDestroyFunc(finishedWithResizeFunc);
        this.inverted = this.gos.get("enableRtl");
    }
    dispatchResizeEvent(start, end, width) {
        this.eventSvc.dispatchEvent({
            type: "toolPanelSizeChanged",
            width: width,
            started: start,
            ended: end
        });
    }
    onResizeStart() {
        this.startingWidth = this.elementToResize.offsetWidth;
        this.dispatchResizeEvent(true, false, this.startingWidth);
    }
    onResizeEnd(delta) {
        return this.onResizing(delta, true);
    }
    onResizing(delta, isEnd = false) {
        const direction = this.inverted ? -1 : 1;
        let newWidth = Math.max(this.minWidth, Math.floor(this.startingWidth - delta * direction));
        if (this.maxWidth != null) newWidth = Math.min(this.maxWidth, newWidth);
        this.elementToResize.style.width = `${newWidth}px`;
        this.dispatchResizeEvent(false, isEnd, newWidth);
    }
};
// packages/ag-grid-enterprise/src/sideBar/toolPanelWrapper.ts
function $5b7ccabde48fae90$var$getToolPanelCompDetails(userCompFactory, toolPanelDef, params) {
    return userCompFactory.getCompDetails(toolPanelDef, $5b7ccabde48fae90$var$ToolPanelComponent, void 0, params, true);
}
var $5b7ccabde48fae90$var$ToolPanelComponent = {
    name: "toolPanel",
    optionalMethods: [
        "refresh",
        "getState"
    ]
};
var $5b7ccabde48fae90$var$ToolPanelElement = {
    tag: "div",
    cls: "ag-tool-panel-wrapper",
    role: "tabpanel"
};
var $5b7ccabde48fae90$var$ToolPanelWrapper = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$ToolPanelElement);
    }
    postConstruct() {
        const eGui = this.getGui();
        const resizeBar = this.resizeBar = this.createManagedBean(new $5b7ccabde48fae90$var$AgHorizontalResize());
        eGui.setAttribute("id", `ag-${this.getCompId()}`);
        resizeBar.elementToResize = eGui;
        this.appendChild(resizeBar);
    }
    getToolPanelId() {
        return this.toolPanelId;
    }
    setToolPanelDef(toolPanelDef, params) {
        const { id: id, minWidth: minWidth, maxWidth: maxWidth, width: width } = toolPanelDef;
        this.toolPanelId = id;
        this.width = width;
        const compDetails = $5b7ccabde48fae90$var$getToolPanelCompDetails(this.beans.userCompFactory, toolPanelDef, params);
        if (compDetails == null) return false;
        const componentPromise = compDetails.newAgStackInstance();
        this.params = compDetails.params;
        componentPromise.then(this.setToolPanelComponent.bind(this));
        const resizeBar = this.resizeBar;
        if (minWidth != null) resizeBar.minWidth = minWidth;
        if (maxWidth != null) resizeBar.maxWidth = maxWidth;
        return true;
    }
    setToolPanelComponent(compInstance) {
        this.toolPanelCompInstance = compInstance;
        this.appendChild(compInstance.getGui());
        this.addDestroyFunc(()=>{
            this.destroyBean(compInstance);
        });
        const width = this.width;
        if (width) this.getGui().style.width = `${width}px`;
    }
    getToolPanelInstance() {
        return this.toolPanelCompInstance;
    }
    setResizerSizerSide(side) {
        const isRtl = this.gos.get("enableRtl");
        const isLeft = side === "left";
        const inverted = isRtl ? isLeft : !isLeft;
        this.resizeBar.inverted = inverted;
    }
    refresh() {
        this.toolPanelCompInstance?.refresh(this.params);
    }
};
// packages/ag-grid-enterprise/src/sideBar/agSideBar.ts
var $5b7ccabde48fae90$var$AgSideBarElement = {
    tag: "div",
    cls: "ag-side-bar ag-unselectable",
    children: [
        {
            tag: "ag-side-bar-buttons",
            ref: "sideBarButtons"
        }
    ]
};
var $5b7ccabde48fae90$var$AgSideBar = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$AgSideBarElement, [
            $5b7ccabde48fae90$var$AgSideBarButtonsSelector
        ]);
        this.sideBarButtons = (0, $jIDNV.RefPlaceholder);
        this.toolPanelWrappers = [];
        this.registerCSS($5b7ccabde48fae90$var$agSideBarCSS);
    }
    postConstruct() {
        this.sideBarButtons.addEventListener("sideBarButtonClicked", this.onToolPanelButtonClicked.bind(this));
        const { beans: beans, gos: gos } = this;
        const { sideBar: sideBarState } = gos.get("initialState") ?? {};
        this.setSideBarDef({
            sideBarDef: $5b7ccabde48fae90$var$parseSideBarDef(gos.get("sideBar")),
            sideBarState: sideBarState
        });
        this.addManagedPropertyListener("sideBar", ()=>this.setState());
        beans.sideBar.comp = this;
        const eGui = this.getFocusableElement();
        this.createManagedBean(new (0, $jIDNV.ManagedFocusFeature)(eGui, {
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this)
        }));
        (0, $jIDNV._addFocusableContainerListener)(beans, this, eGui);
    }
    onTabKeyDown(e) {
        if (e.defaultPrevented) return;
        const { beans: beans, sideBarButtons: sideBarButtons } = this;
        const eGui = this.getGui();
        const sideBarGui = sideBarButtons.getGui();
        const activeElement = (0, $jIDNV._getActiveDomElement)(beans);
        const openPanel = eGui.querySelector(".ag-tool-panel-wrapper:not(.ag-hidden)");
        const target = e.target;
        const backwards = e.shiftKey;
        if (!openPanel) {
            if ((0, $jIDNV._focusNextGridCoreContainer)(beans, backwards)) {
                e.preventDefault();
                return true;
            }
            return (0, $jIDNV._focusNextGridCoreContainer)(beans, backwards, true);
        }
        if (sideBarGui.contains(activeElement)) {
            if ((0, $jIDNV._focusInto)(openPanel, backwards)) e.preventDefault();
            return;
        }
        if (!backwards) return;
        let nextEl = null;
        if (openPanel.contains(activeElement)) nextEl = (0, $jIDNV._findNextFocusableElement)(beans, openPanel, void 0, true);
        else if ($5b7ccabde48fae90$var$isTargetUnderManagedComponent(openPanel, target) && backwards) nextEl = $5b7ccabde48fae90$var$findFocusableElementBeforeTabGuard(openPanel, target);
        if (!nextEl) nextEl = sideBarGui.querySelector(".ag-selected button");
        if (nextEl && nextEl !== e.target) {
            e.preventDefault();
            nextEl.focus();
        }
    }
    handleKeyDown(e) {
        const currentButton = (0, $jIDNV._getActiveDomElement)(this.beans);
        const sideBarButtons = this.sideBarButtons;
        if (!sideBarButtons.getGui().contains(currentButton)) return;
        const sideBarGui = sideBarButtons.getGui();
        const buttons = Array.prototype.slice.call(sideBarGui.querySelectorAll(".ag-side-button"));
        const currentPos = buttons.findIndex((button)=>button.contains(currentButton));
        let nextPos = null;
        switch(e.key){
            case (0, $jIDNV.KeyCode).LEFT:
            case (0, $jIDNV.KeyCode).UP:
                nextPos = Math.max(0, currentPos - 1);
                break;
            case (0, $jIDNV.KeyCode).RIGHT:
            case (0, $jIDNV.KeyCode).DOWN:
                nextPos = Math.min(currentPos + 1, buttons.length - 1);
                break;
        }
        if (nextPos === null) return;
        const innerButton = buttons[nextPos].querySelector("button");
        if (innerButton) {
            innerButton.focus();
            e.preventDefault();
        }
    }
    onToolPanelButtonClicked(event) {
        const id = event.toolPanelId;
        const openedItem = this.openedItem();
        if (openedItem === id) this.openToolPanel(void 0, "sideBarButtonClicked");
        else this.openToolPanel(id, "sideBarButtonClicked");
    }
    clearDownUi() {
        this.sideBarButtons.clearButtons();
        this.destroyToolPanelWrappers();
    }
    setSideBarDef({ sideBarDef: sideBarDef, sideBarState: sideBarState, existingToolPanelWrappers: existingToolPanelWrappers }) {
        this.setDisplayed(false);
        this.sideBar = sideBarDef;
        if (!!sideBarDef && !!sideBarDef.toolPanels) {
            const toolPanelDefs = sideBarDef.toolPanels;
            this.createToolPanelsAndSideButtons(toolPanelDefs, sideBarState, existingToolPanelWrappers);
            if (!this.toolPanelWrappers.length) return;
            const shouldDisplaySideBar = sideBarState ? sideBarState.visible : !sideBarDef.hiddenByDefault;
            this.setDisplayed(shouldDisplaySideBar);
            this.setSideBarPosition(sideBarState ? sideBarState.position : sideBarDef.position);
            if (shouldDisplaySideBar) {
                if (sideBarState) {
                    const { openToolPanel: openToolPanel2 } = sideBarState;
                    if (openToolPanel2) this.openToolPanel(openToolPanel2, "sideBarInitializing");
                } else this.openToolPanel(sideBarDef.defaultToolPanel, "sideBarInitializing");
            }
        }
    }
    getDef() {
        return this.sideBar;
    }
    setSideBarPosition(position) {
        if (!position) position = "right";
        this.position = position;
        const isLeft = position === "left";
        const resizerSide = isLeft ? "right" : "left";
        this.toggleCss("ag-side-bar-left", isLeft);
        this.toggleCss("ag-side-bar-right", !isLeft);
        this.toolPanelWrappers.forEach((wrapper)=>{
            wrapper.setResizerSizerSide(resizerSide);
        });
        this.dispatchSideBarUpdated();
        return this;
    }
    setDisplayed(displayed, options) {
        super.setDisplayed(displayed, options);
        this.dispatchSideBarUpdated();
    }
    getState() {
        const toolPanels = {};
        this.toolPanelWrappers.forEach((wrapper)=>{
            toolPanels[wrapper.getToolPanelId()] = wrapper.getToolPanelInstance()?.getState?.();
        });
        return {
            visible: this.isDisplayed(),
            position: this.position,
            openToolPanel: this.openedItem(),
            toolPanels: toolPanels
        };
    }
    createToolPanelsAndSideButtons(defs, sideBarState, existingToolPanelWrappers) {
        for (const def of defs)this.createToolPanelAndSideButton(def, sideBarState?.toolPanels?.[def.id], existingToolPanelWrappers?.[def.id]);
    }
    validateDef(def) {
        const { id: id, toolPanel: toolPanel } = def;
        if (id == null) {
            (0, $jIDNV._warn)(212);
            return false;
        }
        if (toolPanel === "agFiltersToolPanel" || toolPanel === "agNewFiltersToolPanel") {
            if (this.beans.filterManager?.isAdvFilterEnabled()) {
                (0, $jIDNV._warn)(213);
                return false;
            }
        }
        return true;
    }
    createToolPanelAndSideButton(def, initialState, existingToolPanelWrapper) {
        if (!this.validateDef(def)) return;
        let wrapper;
        if (existingToolPanelWrapper) wrapper = existingToolPanelWrapper;
        else {
            wrapper = this.createBean(new $5b7ccabde48fae90$var$ToolPanelWrapper());
            const created = wrapper.setToolPanelDef(def, (0, $jIDNV._addGridCommonParams)(this.gos, {
                initialState: initialState,
                onStateUpdated: ()=>this.dispatchSideBarUpdated()
            }));
            if (!created) return;
        }
        wrapper.setDisplayed(false);
        const wrapperGui = wrapper.getGui();
        this.appendChild(wrapperGui);
        this.toolPanelWrappers.push(wrapper);
        const button = this.sideBarButtons.addButtonComp(def);
        (0, $jIDNV._setAriaControlsAndLabel)(button.eToggleButton, wrapperGui);
    }
    refresh() {
        this.toolPanelWrappers.forEach((wrapper)=>wrapper.refresh());
    }
    openToolPanel(key, source = "api") {
        const currentlyOpenedKey = this.openedItem();
        if (currentlyOpenedKey === key) return;
        this.toolPanelWrappers.forEach((wrapper)=>{
            const show = key === wrapper.getToolPanelId();
            wrapper.setDisplayed(show);
        });
        const newlyOpenedKey = this.openedItem();
        const openToolPanelChanged = currentlyOpenedKey !== newlyOpenedKey;
        if (openToolPanelChanged) {
            this.sideBarButtons.setActiveButton(key);
            this.raiseToolPanelVisibleEvent(key, currentlyOpenedKey ?? void 0, source);
        }
    }
    getToolPanelInstance(key) {
        const toolPanelWrapper = this.toolPanelWrappers.filter((toolPanel)=>toolPanel.getToolPanelId() === key)[0];
        if (!toolPanelWrapper) {
            (0, $jIDNV._warn)(214, {
                key: key
            });
            return;
        }
        return toolPanelWrapper.getToolPanelInstance();
    }
    raiseToolPanelVisibleEvent(key, previousKey, source) {
        const switchingToolPanel = !!key && !!previousKey;
        const eventSvc = this.eventSvc;
        if (previousKey) eventSvc.dispatchEvent({
            type: "toolPanelVisibleChanged",
            source: source,
            key: previousKey,
            visible: false,
            switchingToolPanel: switchingToolPanel
        });
        if (key) eventSvc.dispatchEvent({
            type: "toolPanelVisibleChanged",
            source: source,
            key: key,
            visible: true,
            switchingToolPanel: switchingToolPanel
        });
    }
    close(source = "api") {
        this.openToolPanel(void 0, source);
    }
    isToolPanelShowing() {
        return !!this.openedItem();
    }
    openedItem() {
        let activeToolPanel = null;
        this.toolPanelWrappers.forEach((wrapper)=>{
            if (wrapper.isDisplayed()) activeToolPanel = wrapper.getToolPanelId();
        });
        return activeToolPanel;
    }
    setState(sideBarState) {
        const sideBarDef = $5b7ccabde48fae90$var$parseSideBarDef(this.gos.get("sideBar"));
        const existingToolPanelWrappers = {};
        if (sideBarDef && this.sideBar) sideBarDef.toolPanels?.forEach((toolPanelDef)=>{
            const { id: id } = toolPanelDef;
            if (!id) return;
            const existingToolPanelDef = this.sideBar.toolPanels?.find((toolPanelDefToCheck)=>toolPanelDefToCheck.id === id);
            if (!existingToolPanelDef || toolPanelDef.toolPanel !== existingToolPanelDef.toolPanel) return;
            const toolPanelWrapper = this.toolPanelWrappers.find((toolPanel)=>toolPanel.getToolPanelId() === id);
            if (!toolPanelWrapper) return;
            const params = (0, $jIDNV._addGridCommonParams)(this.gos, {
                ...toolPanelDef.toolPanelParams ?? {},
                onStateUpdated: ()=>this.dispatchSideBarUpdated()
            });
            const hasRefreshed = toolPanelWrapper.getToolPanelInstance()?.refresh(params);
            if (hasRefreshed !== true) return;
            this.toolPanelWrappers = this.toolPanelWrappers.filter((toolPanel)=>toolPanel !== toolPanelWrapper);
            (0, $jIDNV._removeFromParent)(toolPanelWrapper.getGui());
            existingToolPanelWrappers[id] = toolPanelWrapper;
        });
        this.clearDownUi();
        this.setSideBarDef({
            sideBarDef: sideBarDef,
            sideBarState: sideBarState,
            existingToolPanelWrappers: existingToolPanelWrappers
        });
    }
    dispatchSideBarUpdated() {
        this.eventSvc.dispatchEvent({
            type: "sideBarUpdated"
        });
    }
    destroyToolPanelWrappers() {
        this.toolPanelWrappers.forEach((wrapper)=>{
            (0, $jIDNV._removeFromParent)(wrapper.getGui());
            this.destroyBean(wrapper);
        });
        this.toolPanelWrappers.length = 0;
    }
    destroy() {
        this.destroyToolPanelWrappers();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$AgSideBarSelector = {
    selector: "AG-SIDE-BAR",
    component: $5b7ccabde48fae90$var$AgSideBar
};
// packages/ag-grid-enterprise/src/sideBar/sideBarService.ts
var $5b7ccabde48fae90$var$SideBarService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "sideBar";
    }
    getSelector() {
        return $5b7ccabde48fae90$var$AgSideBarSelector;
    }
};
// packages/ag-grid-enterprise/src/sideBar/sideBarModule.ts
var $5b7ccabde48fae90$export$707a9bd30915b7fe = {
    moduleName: "SideBar",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$SideBarService
    ],
    apiFunctions: {
        isSideBarVisible: $5b7ccabde48fae90$var$isSideBarVisible,
        setSideBarVisible: $5b7ccabde48fae90$var$setSideBarVisible,
        setSideBarPosition: $5b7ccabde48fae90$var$setSideBarPosition,
        openToolPanel: $5b7ccabde48fae90$var$openToolPanel,
        closeToolPanel: $5b7ccabde48fae90$var$closeToolPanel,
        getOpenedToolPanel: $5b7ccabde48fae90$var$getOpenedToolPanel,
        refreshToolPanel: $5b7ccabde48fae90$var$refreshToolPanel,
        isToolPanelShowing: $5b7ccabde48fae90$var$isToolPanelShowing,
        getToolPanelInstance: $5b7ccabde48fae90$var$getToolPanelInstance,
        getSideBar: $5b7ccabde48fae90$var$getSideBar
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $jIDNV._HorizontalResizeModule)
    ]
};
var $5b7ccabde48fae90$var$MenuItemElement = {
    tag: "div"
};
var $5b7ccabde48fae90$var$AgMenuItemRenderer = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$MenuItemElement);
    }
    init(params) {
        this.params = params;
        this.cssClassPrefix = this.params.cssClassPrefix ?? "ag-menu-option";
        this.addAriaAttributes();
        this.addIcon();
        this.addName();
        this.addShortcut();
        this.addSubMenu();
    }
    configureDefaults() {
        return true;
    }
    addAriaAttributes() {
        const { checked: checked, subMenu: subMenu } = this.params;
        const eGui = this.getGui();
        if (checked) (0, $jIDNV._setAriaChecked)(eGui, checked);
        if (subMenu) (0, $jIDNV._setAriaExpanded)(eGui, false);
    }
    addIcon() {
        if (this.params.isCompact) return;
        const iconWrapper = (0, $jIDNV._createElement)({
            tag: "span",
            ref: "eIcon",
            cls: `${this.getClassName("part")} ${this.getClassName("icon")}`,
            role: "presentation"
        });
        const { checked: checked, icon: icon } = this.params;
        if (checked) iconWrapper.appendChild((0, $jIDNV._createIconNoSpan)("check", this.beans));
        else if (icon) {
            if ((0, $jIDNV._isNodeOrElement)(icon)) iconWrapper.appendChild(icon);
            else if (typeof icon === "string") iconWrapper.innerHTML = icon;
            else (0, $jIDNV._warn)(227);
        }
        this.getGui().appendChild(iconWrapper);
    }
    addName() {
        const name = (0, $jIDNV._createElement)({
            tag: "span",
            ref: "eName",
            cls: `${this.getClassName("part")} ${this.getClassName("text")}`,
            children: this.params.name || ""
        });
        this.getGui().appendChild(name);
    }
    addShortcut() {
        if (this.params.isCompact) return;
        const shortcut = (0, $jIDNV._createElement)({
            tag: "span",
            ref: "eShortcut",
            cls: `${this.getClassName("part")} ${this.getClassName("shortcut")}`,
            children: this.params.shortcut || ""
        });
        this.getGui().appendChild(shortcut);
    }
    addSubMenu() {
        const pointer = (0, $jIDNV._createElement)({
            tag: "span",
            ref: "ePopupPointer",
            cls: `${this.getClassName("part")} ${this.getClassName("popup-pointer")}`
        });
        const eGui = this.getGui();
        if (this.params.subMenu) {
            const iconName = this.gos.get("enableRtl") ? "subMenuOpenRtl" : "subMenuOpen";
            pointer.appendChild((0, $jIDNV._createIconNoSpan)(iconName, this.beans));
        }
        eGui.appendChild(pointer);
    }
    getClassName(suffix) {
        return `${this.cssClassPrefix}-${suffix}`;
    }
};
// packages/ag-grid-enterprise/src/widgets/menu.css-GENERATED.ts
var $5b7ccabde48fae90$var$menuCSS = /*css*/ `.ag-menu-list{cursor:default;display:table;padding:var(--ag-spacing) 0;width:100%}.ag-menu-option,.ag-menu-separator{display:table-row}.ag-menu-option-part,.ag-menu-separator-part{display:table-cell;vertical-align:middle}.ag-menu-option{cursor:pointer;font-weight:500}:where(.ag-ltr) :where(.ag-menu-option-popup-pointer) .ag-icon{text-align:right}:where(.ag-rtl) :where(.ag-menu-option-popup-pointer) .ag-icon{text-align:left}.ag-menu-option-text{white-space:nowrap}.ag-menu-option-custom{display:contents}.ag-compact-menu-option{display:flex;flex-wrap:nowrap;width:100%}.ag-compact-menu-option-text{flex:1 1 auto;white-space:nowrap}.ag-menu-separator{height:calc(var(--ag-spacing)*2 + 1px)}.ag-menu-separator-part:after{border-top:solid var(--ag-border-width) var(--ag-menu-separator-color);content:"";display:block}.ag-compact-menu-option-active,.ag-menu-option-active{background-color:var(--ag-row-hover-color)}.ag-compact-menu-option-part,.ag-menu-option-part{line-height:var(--ag-icon-size);padding:calc(var(--ag-spacing) + 2px) 0}.ag-compact-menu-option-disabled,.ag-menu-option-disabled{cursor:not-allowed;opacity:.5}.ag-compact-menu-option-icon,.ag-menu-option-icon{width:var(--ag-icon-size)}:where(.ag-ltr) .ag-compact-menu-option-icon,:where(.ag-ltr) .ag-menu-option-icon{padding-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-compact-menu-option-icon,:where(.ag-rtl) .ag-menu-option-icon{padding-right:calc(var(--ag-spacing)*2)}.ag-compact-menu-option-text,.ag-menu-option-text{padding-left:calc(var(--ag-spacing)*2);padding-right:calc(var(--ag-spacing)*2)}:where(.ag-ltr) .ag-compact-menu-option-shortcut,:where(.ag-ltr) .ag-menu-option-shortcut{padding-right:var(--ag-spacing)}:where(.ag-rtl) .ag-compact-menu-option-shortcut,:where(.ag-rtl) .ag-menu-option-shortcut{padding-left:var(--ag-spacing)}:where(.ag-ltr) .ag-compact-menu-option-popup-pointer,:where(.ag-ltr) .ag-menu-option-popup-pointer{padding-right:var(--ag-spacing)}:where(.ag-rtl) .ag-compact-menu-option-popup-pointer,:where(.ag-rtl) .ag-menu-option-popup-pointer{padding-left:var(--ag-spacing)}.ag-menu-column-select-wrapper{height:265px;overflow:auto;:where(.ag-column-select){height:100%}}.ag-menu:where(.ag-tabs){min-width:290px}.ag-context-menu-loading-icon{pointer-events:none;position:absolute}`;
// packages/ag-grid-enterprise/src/widgets/menuItemModule.ts
var $5b7ccabde48fae90$var$MenuItemModule = {
    moduleName: "MenuItem",
    version: $5b7ccabde48fae90$var$VERSION,
    userComponents: {
        agMenuItem: $5b7ccabde48fae90$var$AgMenuItemRenderer
    },
    icons: {
        // indicates the currently active pin state in the "Pin column" sub-menu of the column menu
        check: "tick",
        // icon for sub menu item
        subMenuOpen: "small-right",
        // version of subMenuOpen used in RTL mode
        subMenuOpenRtl: "small-left"
    },
    css: [
        $5b7ccabde48fae90$var$menuCSS
    ]
};
// packages/ag-grid-enterprise/src/columnToolPanel/agPrimaryCols.css-GENERATED.ts
var $5b7ccabde48fae90$var$agPrimaryColsCSS = /*css*/ `.ag-column-select{display:flex;flex:3 1 0px;flex-direction:column;overflow:hidden;position:relative}.ag-column-select-header{align-items:center;display:flex;flex:none;gap:var(--ag-widget-horizontal-spacing);height:var(--ag-header-height);padding-left:var(--ag-widget-container-horizontal-padding);padding-right:var(--ag-widget-container-horizontal-padding);position:relative}.ag-column-select-column,.ag-column-select-column-group{align-items:center;display:flex;gap:var(--ag-widget-horizontal-spacing);height:100%;position:relative;&:where(:not(:last-child)){margin-bottom:var(--ag-widget-vertical-spacing)}}:where(.ag-ltr) .ag-column-select-column,:where(.ag-ltr) .ag-column-select-column-group{padding-left:calc(var(--ag-indentation-level)*var(--ag-column-select-indent-size))}:where(.ag-rtl) .ag-column-select-column,:where(.ag-rtl) .ag-column-select-column-group{padding-right:calc(var(--ag-indentation-level)*var(--ag-column-select-indent-size))}.ag-column-select-header-icon{border-radius:var(--ag-border-radius);cursor:pointer;height:var(--ag-icon-size);position:relative;width:var(--ag-icon-size);&:focus-visible{box-shadow:var(--ag-focus-shadow)}}.ag-column-select-header-filter-wrapper{flex:1 1 auto}.ag-column-select-header-filter{width:100%}.ag-column-select-list{flex:1 1 0px;overflow:hidden}:where(.ag-ltr) .ag-column-select-add-group-indent{margin-left:calc(var(--ag-icon-size) + var(--ag-spacing)*1.5)}:where(.ag-rtl) .ag-column-select-add-group-indent{margin-right:calc(var(--ag-icon-size) + var(--ag-spacing)*1.5)}.ag-column-select-column-group-readonly,.ag-column-select-column-readonly{opacity:.5;pointer-events:none}.ag-column-select-virtual-list-viewport{padding:calc(var(--ag-widget-container-vertical-padding)*.5) 0}.ag-column-select-virtual-list-item{padding:0 var(--ag-widget-container-horizontal-padding)}.ag-column-select-column-label{flex:1 1 auto;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-column-select-checkbox{display:flex}`;
var $5b7ccabde48fae90$var$DEBOUNCE_DELAY = 300;
var $5b7ccabde48fae90$var$AgPrimaryColsHeaderElement = {
    tag: "div",
    cls: "ag-column-select-header",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eExpand",
            cls: "ag-column-select-header-icon"
        },
        {
            tag: "ag-checkbox",
            ref: "eSelect",
            cls: "ag-column-select-header-checkbox"
        },
        {
            tag: "ag-input-text-field",
            ref: "eFilterTextField",
            cls: "ag-column-select-header-filter-wrapper"
        }
    ]
};
var $5b7ccabde48fae90$var$AgPrimaryColsHeader = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$AgPrimaryColsHeaderElement, [
            (0, $jIDNV.AgCheckboxSelector),
            (0, $jIDNV.AgInputTextFieldSelector)
        ]);
        this.eExpand = (0, $jIDNV.RefPlaceholder);
        this.eSelect = (0, $jIDNV.RefPlaceholder);
        this.eFilterTextField = (0, $jIDNV.RefPlaceholder);
    }
    postConstruct() {
        this.createExpandIcons();
        this.addManagedListeners(this.eExpand, {
            click: this.onExpandClicked.bind(this),
            keydown: (e)=>{
                if (e.key === (0, $jIDNV.KeyCode).SPACE) {
                    e.preventDefault();
                    this.onExpandClicked();
                }
            }
        });
        this.addManagedElementListeners(this.eSelect.getInputElement(), {
            click: this.onSelectClicked.bind(this)
        });
        this.addManagedPropertyListener("functionsReadOnly", ()=>this.onFunctionsReadOnlyPropChanged());
        this.eFilterTextField.setAutoComplete(false).onValueChange(()=>this.onFilterTextChanged());
        this.addManagedEventListeners({
            newColumnsLoaded: this.showOrHideOptions.bind(this)
        });
        const translate = this.getLocaleTextFunc();
        this.eSelect.setInputAriaLabel(translate("ariaColumnSelectAll", "Toggle All Columns Visibility"));
        this.eFilterTextField.setInputAriaLabel(translate("ariaFilterColumnsInput", "Filter Columns Input"));
        this.activateTabIndex([
            this.eExpand
        ]);
    }
    onFunctionsReadOnlyPropChanged() {
        const readOnly = this.gos.get("functionsReadOnly");
        this.eSelect.setReadOnly(readOnly);
        this.eSelect.toggleCss("ag-column-select-column-readonly", readOnly);
    }
    init(params) {
        this.params = params;
        const readOnly = this.gos.get("functionsReadOnly");
        this.eSelect.setReadOnly(readOnly);
        this.eSelect.toggleCss("ag-column-select-column-readonly", readOnly);
        if (this.beans.colModel.ready) this.showOrHideOptions();
    }
    createExpandIcons() {
        const beans = this.beans;
        this.eExpand.appendChild(this.eExpandChecked = (0, $jIDNV._createIconNoSpan)("columnSelectOpen", beans));
        this.eExpand.appendChild(this.eExpandUnchecked = (0, $jIDNV._createIconNoSpan)("columnSelectClosed", beans));
        this.eExpand.appendChild(this.eExpandIndeterminate = (0, $jIDNV._createIconNoSpan)("columnSelectIndeterminate", beans));
        this.setExpandState(0 /* EXPANDED */ );
    }
    // we only show expand / collapse if we are showing columns
    showOrHideOptions() {
        const params = this.params;
        const showFilter = !params.suppressColumnFilter;
        const showSelect = !params.suppressColumnSelectAll;
        const showExpand = !params.suppressColumnExpandAll;
        const groupsPresent = !!this.beans.colModel.colDefCols?.treeDepth;
        const translate = this.getLocaleTextFunc();
        this.eFilterTextField.setInputPlaceholder(translate("searchOoo", "Search..."));
        (0, $jIDNV._setDisplayed)(this.eFilterTextField.getGui(), showFilter);
        (0, $jIDNV._setDisplayed)(this.eSelect.getGui(), showSelect);
        (0, $jIDNV._setDisplayed)(this.eExpand, showExpand && groupsPresent);
    }
    onFilterTextChanged() {
        if (!this.onFilterTextChangedDebounced) this.onFilterTextChangedDebounced = (0, $jIDNV._debounce)(this, ()=>{
            const filterText = this.eFilterTextField.getValue();
            this.dispatchLocalEvent({
                type: "filterChanged",
                filterText: filterText
            });
        }, $5b7ccabde48fae90$var$DEBOUNCE_DELAY);
        this.onFilterTextChangedDebounced();
    }
    onSelectClicked() {
        this.dispatchLocalEvent({
            type: this.selectState ? "unselectAll" : "selectAll"
        });
    }
    onExpandClicked() {
        this.dispatchLocalEvent({
            type: this.expandState === 0 /* EXPANDED */  ? "collapseAll" : "expandAll"
        });
    }
    setExpandState(state) {
        this.expandState = state;
        (0, $jIDNV._setDisplayed)(this.eExpandChecked, state === 0 /* EXPANDED */ );
        (0, $jIDNV._setDisplayed)(this.eExpandUnchecked, state === 1 /* COLLAPSED */ );
        (0, $jIDNV._setDisplayed)(this.eExpandIndeterminate, state === 2 /* INDETERMINATE */ );
    }
    setSelectionState(state) {
        this.selectState = state;
        this.eSelect.setValue(this.selectState);
    }
};
var $5b7ccabde48fae90$var$AgPrimaryColsHeaderSelector = {
    selector: "AG-PRIMARY-COLS-HEADER",
    component: $5b7ccabde48fae90$var$AgPrimaryColsHeader
};
function $5b7ccabde48fae90$var$isColGroupDef(colDef) {
    return !!colDef && typeof colDef.children !== "undefined";
}
function $5b7ccabde48fae90$var$getId(colDef) {
    return $5b7ccabde48fae90$var$isColGroupDef(colDef) ? colDef.groupId : colDef.colId;
}
function $5b7ccabde48fae90$var$addChildrenToGroup(tree, groupId, colDef) {
    const subGroupIsSplit = (currentSubGroup, currentSubGroupToAdd)=>{
        const existingChildIds = currentSubGroup.children.map($5b7ccabde48fae90$var$getId);
        const childGroupAlreadyExists = existingChildIds.includes($5b7ccabde48fae90$var$getId(currentSubGroupToAdd));
        const lastChild = (0, $jIDNV._last)(currentSubGroup.children);
        const lastChildIsDifferent = lastChild && $5b7ccabde48fae90$var$getId(lastChild) !== $5b7ccabde48fae90$var$getId(currentSubGroupToAdd);
        return childGroupAlreadyExists && lastChildIsDifferent;
    };
    if (!$5b7ccabde48fae90$var$isColGroupDef(tree)) return true;
    const currentGroup = tree;
    const groupToAdd = colDef;
    if (subGroupIsSplit(currentGroup, groupToAdd)) {
        currentGroup.children.push(groupToAdd);
        return true;
    }
    if (currentGroup.groupId === groupId) {
        const existingChildIds = currentGroup.children.map($5b7ccabde48fae90$var$getId);
        const colDefAlreadyPresent = existingChildIds.includes($5b7ccabde48fae90$var$getId(groupToAdd));
        if (!colDefAlreadyPresent) {
            currentGroup.children.push(groupToAdd);
            return true;
        }
    }
    for(let i = currentGroup.children.length - 1; i >= 0; i--){
        if ($5b7ccabde48fae90$var$addChildrenToGroup(currentGroup.children[i], groupId, colDef)) break;
    }
    return false;
}
function $5b7ccabde48fae90$var$mergeLeafPathTrees(leafPathTrees) {
    const matchingRootGroupIds = (pathA, pathB)=>{
        const bothPathsAreGroups = $5b7ccabde48fae90$var$isColGroupDef(pathA) && $5b7ccabde48fae90$var$isColGroupDef(pathB);
        return bothPathsAreGroups && $5b7ccabde48fae90$var$getId(pathA) === $5b7ccabde48fae90$var$getId(pathB);
    };
    const mergeTrees = (treeA, treeB)=>{
        if (!$5b7ccabde48fae90$var$isColGroupDef(treeB)) return treeA;
        const mergeResult = treeA;
        const groupToMerge = treeB;
        if (groupToMerge.children && groupToMerge.groupId) {
            const added = $5b7ccabde48fae90$var$addChildrenToGroup(mergeResult, groupToMerge.groupId, groupToMerge.children[0]);
            if (added) return mergeResult;
        }
        groupToMerge.children.forEach((child)=>mergeTrees(mergeResult, child));
        return mergeResult;
    };
    const mergeColDefs = [];
    for(let i = 1; i <= leafPathTrees.length; i++){
        const first = leafPathTrees[i - 1];
        const second = leafPathTrees[i];
        if (matchingRootGroupIds(first, second)) leafPathTrees[i] = mergeTrees(first, second);
        else mergeColDefs.push(first);
    }
    return mergeColDefs;
}
// packages/ag-grid-enterprise/src/sideBar/common/toolPanelColDefService.ts
function $5b7ccabde48fae90$var$toolPanelCreateColumnTree(colModel, colDefs) {
    const invalidColIds = [];
    const createDummyColGroup = (abstractColDef, depth)=>{
        if ($5b7ccabde48fae90$var$isColGroupDef(abstractColDef)) {
            const groupDef = abstractColDef;
            const groupId = typeof groupDef.groupId !== "undefined" ? groupDef.groupId : groupDef.headerName;
            const group = new (0, $jIDNV.AgProvidedColumnGroup)(groupDef, groupId, false, depth);
            const children = [];
            groupDef.children.forEach((def)=>{
                const child = createDummyColGroup(def, depth + 1);
                if (child) children.push(child);
            });
            group.setChildren(children);
            return group;
        } else {
            const colDef = abstractColDef;
            const key = colDef.colId ? colDef.colId : colDef.field;
            const column = colModel.getColDefCol(key);
            if (!column) invalidColIds.push(colDef);
            return column;
        }
    };
    const mappedResults = [];
    colDefs.forEach((colDef)=>{
        const result = createDummyColGroup(colDef, 0);
        if (result) mappedResults.push(result);
    });
    if (invalidColIds.length > 0) (0, $jIDNV._warn)(217, {
        invalidColIds: invalidColIds
    });
    return mappedResults;
}
function $5b7ccabde48fae90$var$syncLayoutWithGrid(colModel, syncLayoutCallback) {
    const leafPathTrees = $5b7ccabde48fae90$var$getLeafPathTrees(colModel);
    const mergedColumnTrees = $5b7ccabde48fae90$var$mergeLeafPathTrees(leafPathTrees);
    syncLayoutCallback(mergedColumnTrees);
}
function $5b7ccabde48fae90$var$getLeafPathTrees(colModel) {
    const getLeafPathTree = (node, childDef)=>{
        let leafPathTree;
        if ((0, $jIDNV.isProvidedColumnGroup)(node)) {
            if (node.isPadding()) leafPathTree = childDef;
            else {
                const groupDef = Object.assign({}, node.getColGroupDef());
                groupDef.groupId = node.getGroupId();
                groupDef.children = [
                    childDef
                ];
                leafPathTree = groupDef;
            }
        } else {
            const colDef = Object.assign({}, node.getColDef());
            colDef.colId = node.getColId();
            leafPathTree = colDef;
        }
        const parent = node.getOriginalParent();
        if (parent) return getLeafPathTree(parent, leafPathTree);
        else return leafPathTree;
    };
    const allGridColumns = colModel.getCols();
    const allPrimaryGridColumns = allGridColumns.filter((column)=>{
        const colDef = column.getColDef();
        return column.isPrimary() && !colDef.showRowGroup;
    });
    return allPrimaryGridColumns.map((col)=>getLeafPathTree(col, col.getColDef()));
}
var $5b7ccabde48fae90$var$ColumnModelItem = class {
    constructor(displayName, columnOrGroup, depth, group = false, expanded){
        this.displayName = displayName;
        this.depth = depth;
        this.group = group;
        this.localEventService = new (0, $jIDNV.LocalEventService)();
        if (group) {
            this.columnGroup = columnOrGroup;
            this._expanded = expanded;
            this.children = [];
        } else this.column = columnOrGroup;
    }
    get expanded() {
        return !!this._expanded;
    }
    set expanded(expanded) {
        if (expanded === this._expanded) return;
        this._expanded = expanded;
        this.localEventService.dispatchEvent({
            type: "expandedChanged"
        });
    }
    addEventListener(eventType, listener) {
        this.localEventService.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        this.localEventService.removeEventListener(eventType, listener);
    }
};
function $5b7ccabde48fae90$var$selectAllChildren(beans, colTree, selectAllChecked, eventType) {
    const cols = $5b7ccabde48fae90$var$extractAllLeafColumns(colTree);
    $5b7ccabde48fae90$var$setAllColumns(beans, cols, selectAllChecked, eventType);
}
function $5b7ccabde48fae90$var$setAllColumns(beans, cols, selectAllChecked, eventType) {
    if (beans.colModel.isPivotMode()) $5b7ccabde48fae90$var$setAllPivot(beans, cols, selectAllChecked, eventType);
    else $5b7ccabde48fae90$var$setAllVisible(beans, cols, selectAllChecked, eventType);
}
function $5b7ccabde48fae90$var$extractAllLeafColumns(allItems) {
    const res = [];
    const recursiveFunc = (items)=>{
        items.forEach((item)=>{
            if (!item.passesFilter) return;
            if (item.group) recursiveFunc(item.children);
            else res.push(item.column);
        });
    };
    recursiveFunc(allItems);
    return res;
}
function $5b7ccabde48fae90$var$setAllVisible(beans, columns, visible, eventType) {
    const colStateItems = [];
    columns.forEach((col)=>{
        if (col.getColDef().lockVisible) return;
        if (col.isVisible() != visible) colStateItems.push({
            colId: col.getId(),
            hide: !visible
        });
    });
    if (colStateItems.length > 0) (0, $jIDNV._applyColumnState)(beans, {
        state: colStateItems
    }, eventType);
}
function $5b7ccabde48fae90$var$setAllPivot(beans, columns, value, eventType) {
    $5b7ccabde48fae90$var$setAllPivotActive(beans, columns, value, eventType);
}
function $5b7ccabde48fae90$var$setAllPivotActive(beans, columns, value, eventType) {
    const colStateItems = [];
    const turnOnAction = (col)=>{
        if (col.isAnyFunctionActive()) return;
        if (col.isAllowValue()) {
            const aggFunc = typeof col.getAggFunc() === "string" ? col.getAggFunc() : beans.aggFuncSvc?.getDefaultAggFunc(col);
            colStateItems.push({
                colId: col.getId(),
                aggFunc: aggFunc
            });
        } else if (col.isAllowRowGroup()) colStateItems.push({
            colId: col.getId(),
            rowGroup: true
        });
        else if (col.isAllowPivot()) colStateItems.push({
            colId: col.getId(),
            pivot: true
        });
    };
    const turnOffAction = (col)=>{
        const isActive = col.isPivotActive() || col.isRowGroupActive() || col.isValueActive();
        if (isActive) colStateItems.push({
            colId: col.getId(),
            pivot: false,
            rowGroup: false,
            aggFunc: null
        });
    };
    const action = value ? turnOnAction : turnOffAction;
    columns.forEach(action);
    if (colStateItems.length > 0) (0, $jIDNV._applyColumnState)(beans, {
        state: colStateItems
    }, eventType);
}
function $5b7ccabde48fae90$var$updateColumns(beans, params) {
    const { columns: columns, visibleState: visibleState, pivotState: pivotState, eventType: eventType } = params;
    const state = columns.map((column)=>{
        const colId = column.getColId();
        if (beans.colModel.isPivotMode()) {
            const pivotStateForColumn = pivotState?.[colId];
            return {
                colId: colId,
                pivot: pivotStateForColumn?.pivot,
                rowGroup: pivotStateForColumn?.rowGroup,
                aggFunc: pivotStateForColumn?.aggFunc
            };
        } else return {
            colId: colId,
            hide: !visibleState?.[colId]
        };
    });
    (0, $jIDNV._applyColumnState)(beans, {
        state: state
    }, eventType);
}
function $5b7ccabde48fae90$var$createPivotState(column) {
    return {
        pivot: column.isPivotActive(),
        rowGroup: column.isRowGroupActive(),
        aggFunc: column.isValueActive() ? column.getAggFunc() : void 0
    };
}
// packages/ag-grid-enterprise/src/rowGrouping/rowGroupingUtils.ts
function $5b7ccabde48fae90$var$setRowNodeGroupValue(rowNode, colModel, colKey, newValue) {
    const column = colModel.getCol(colKey);
    if (!rowNode.groupData) rowNode.groupData = {};
    const columnId = column.getColId();
    const oldValue = rowNode.groupData[columnId];
    if (oldValue === newValue) return;
    rowNode.groupData[columnId] = newValue;
    rowNode.dispatchCellChangedEvent(column, newValue, oldValue);
}
function $5b7ccabde48fae90$var$setRowNodeGroup(rowNode, beans, group) {
    if (rowNode.group === group) return;
    if (rowNode.group && !group) rowNode.expanded = false;
    rowNode.group = group;
    rowNode.updateHasChildren();
    beans.selectionSvc?.updateRowSelectable(rowNode);
    rowNode.dispatchRowEvent("groupChanged");
}
function $5b7ccabde48fae90$var$isRowGroupColLocked(column, beans) {
    const { gos: gos, rowGroupColsSvc: rowGroupColsSvc } = beans;
    if (!rowGroupColsSvc || !column) return false;
    const groupLockGroupColumns = gos.get("groupLockGroupColumns");
    if (!column.isRowGroupActive() || groupLockGroupColumns === 0) return false;
    if (groupLockGroupColumns === -1) return true;
    const colIndex = rowGroupColsSvc.columns.findIndex((groupCol)=>groupCol.getColId() === column.getColId());
    return groupLockGroupColumns > colIndex;
}
var $5b7ccabde48fae90$var$AgMenuPanel = class extends (0, $jIDNV.TabGuardComp) {
    constructor(wrappedComponent){
        super();
        this.setTemplateFromElement(wrappedComponent.getGui(), void 0, void 0, true);
    }
    postConstruct() {
        this.initialiseTabGuard({
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.handleKeyDown(e)
        });
    }
    handleKeyDown(e) {
        if (e.key === (0, $jIDNV.KeyCode).ESCAPE) this.closePanel();
    }
    onTabKeyDown(e) {
        if (e.defaultPrevented) return;
        this.closePanel();
        e.preventDefault();
    }
    closePanel() {
        const menuItem = this.parentComponent;
        menuItem.closeSubMenu();
        setTimeout(()=>menuItem.getGui().focus(), 0);
    }
};
// packages/ag-grid-enterprise/src/widgets/agMenuItemComponent.ts
function $5b7ccabde48fae90$var$getMenuItemCompDetails(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $5b7ccabde48fae90$var$MenuItemComponent, "agMenuItem", params, true);
}
var $5b7ccabde48fae90$var$MenuItemComponent = {
    name: "menuItem",
    optionalMethods: [
        "setActive",
        "select",
        "setExpanded",
        "configureDefaults"
    ]
};
var $5b7ccabde48fae90$var$MenuItemElement2 = {
    tag: "div",
    cls: "ag-menu",
    role: "presentation"
};
var $5b7ccabde48fae90$var$AgMenuItemComponent = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.ACTIVATION_DELAY = 80;
        this.isActive = false;
        this.subMenuIsOpen = false;
        this.subMenuIsOpening = false;
        this.suppressRootStyles = true;
        this.suppressAria = true;
        this.suppressFocus = true;
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
        this.userCompFactory = beans.userCompFactory;
        this.registry = beans.registry;
    }
    init(params) {
        const { menuItemDef: menuItemDef, isAnotherSubMenuOpen: isAnotherSubMenuOpen, level: level, childComponent: childComponent, contextParams: contextParams } = params;
        this.params = params.menuItemDef;
        this.level = level;
        this.isAnotherSubMenuOpen = isAnotherSubMenuOpen;
        this.childComponent = childComponent;
        this.contextParams = contextParams;
        this.cssClassPrefix = this.params.menuItemParams?.cssClassPrefix ?? "ag-menu-option";
        const compDetails = $5b7ccabde48fae90$var$getMenuItemCompDetails(this.userCompFactory, this.params, (0, $jIDNV._addGridCommonParams)(this.gos, {
            ...menuItemDef,
            level: level,
            isAnotherSubMenuOpen: isAnotherSubMenuOpen,
            openSubMenu: (activateFirstItem)=>this.openSubMenu(activateFirstItem),
            closeSubMenu: ()=>this.closeSubMenu(),
            closeMenu: (event)=>this.closeMenu(event),
            updateTooltip: (tooltip, shouldDisplayTooltip)=>this.refreshTooltip(tooltip, shouldDisplayTooltip),
            onItemActivated: ()=>this.onItemActivated()
        }));
        return compDetails?.newAgStackInstance().then((comp)=>{
            this.menuItemComp = comp;
            const configureDefaults = comp.configureDefaults?.();
            if (configureDefaults) this.configureDefaults(configureDefaults === true ? void 0 : configureDefaults);
        }) ?? (0, $jIDNV.AgPromise).resolve();
    }
    addListeners(eGui, params) {
        if (!params?.suppressClick) this.addManagedElementListeners(eGui, {
            click: (e)=>this.onItemSelected(e)
        });
        if (!params?.suppressKeyboardSelect) this.addManagedElementListeners(eGui, {
            keydown: (e)=>{
                if (e.key === (0, $jIDNV.KeyCode).ENTER || e.key === (0, $jIDNV.KeyCode).SPACE) {
                    e.preventDefault();
                    this.onItemSelected(e);
                }
            }
        });
        if (!params?.suppressMouseDown) this.addManagedElementListeners(eGui, {
            mousedown: (e)=>{
                e.stopPropagation();
                e.preventDefault();
            }
        });
        if (!params?.suppressMouseOver) this.addManagedElementListeners(eGui, {
            mouseenter: ()=>this.onMouseEnter(),
            mouseleave: ()=>this.onMouseLeave()
        });
    }
    isDisabled() {
        return !!this.params.disabled;
    }
    openSubMenu(activateFirstItem = false, event) {
        this.closeSubMenu();
        if (!this.params.subMenu) return;
        this.subMenuIsOpening = true;
        const ePopup = (0, $jIDNV._createElement)($5b7ccabde48fae90$var$MenuItemElement2);
        this.eSubMenuGui = ePopup;
        let destroySubMenu;
        let afterGuiAttached = ()=>{
            this.subMenuIsOpening = false;
        };
        if (this.childComponent) {
            const menuPanel = this.createBean(new $5b7ccabde48fae90$var$AgMenuPanel(this.childComponent));
            menuPanel.setParentComponent(this);
            const subMenuGui = menuPanel.getGui();
            const mouseEvent = "mouseenter";
            const mouseEnterListener = ()=>this.cancelDeactivate();
            subMenuGui.addEventListener(mouseEvent, mouseEnterListener);
            destroySubMenu = ()=>{
                subMenuGui.removeEventListener(mouseEvent, mouseEnterListener);
                this.destroyBean(menuPanel);
            };
            ePopup.appendChild(subMenuGui);
            if (this.childComponent.afterGuiAttached) afterGuiAttached = ()=>{
                this.childComponent.afterGuiAttached();
                this.subMenuIsOpening = false;
            };
        } else if (this.params.subMenu) {
            const childMenu = this.createBean(new $5b7ccabde48fae90$var$AgMenuList(this.level + 1, this.contextParams));
            childMenu.setParentComponent(this);
            childMenu.addMenuItems(this.params.subMenu);
            ePopup.appendChild(childMenu.getGui());
            this.addManagedListeners(childMenu, {
                closeMenu: (e)=>this.dispatchLocalEvent(e)
            });
            childMenu.addGuiEventListener("mouseenter", ()=>this.cancelDeactivate());
            destroySubMenu = ()=>this.destroyBean(childMenu);
            if (activateFirstItem) afterGuiAttached = ()=>{
                childMenu.activateFirstItem();
                this.subMenuIsOpening = false;
            };
        }
        const { popupSvc: popupSvc } = this;
        const positionCallback = ()=>{
            const eventSource = this.eGui;
            const { column: column, node: node } = this.contextParams;
            popupSvc?.positionPopupForMenu({
                eventSource: eventSource,
                ePopup: ePopup,
                event: event instanceof MouseEvent ? event : void 0,
                column: column,
                node: node
            });
        };
        const translate = this.getLocaleTextFunc();
        const addPopupRes = popupSvc?.addPopup({
            modal: true,
            eChild: ePopup,
            positionCallback: positionCallback,
            anchorToElement: this.eGui,
            ariaLabel: translate("ariaLabelSubMenu", "SubMenu"),
            afterGuiAttached: afterGuiAttached
        });
        this.subMenuIsOpen = true;
        this.setAriaExpanded(true);
        this.hideSubMenu = ()=>{
            if (addPopupRes) addPopupRes.hideFunc();
            this.subMenuIsOpen = false;
            this.setAriaExpanded(false);
            destroySubMenu();
            this.menuItemComp.setExpanded?.(false);
            this.eSubMenuGui = void 0;
        };
        this.menuItemComp.setExpanded?.(true);
    }
    setAriaExpanded(expanded) {
        if (!this.suppressAria) (0, $jIDNV._setAriaExpanded)(this.eGui, expanded);
    }
    closeSubMenu() {
        if (!this.hideSubMenu) return;
        this.hideSubMenu();
        this.hideSubMenu = null;
        this.setAriaExpanded(false);
    }
    isSubMenuOpen() {
        return this.subMenuIsOpen;
    }
    isSubMenuOpening() {
        return this.subMenuIsOpening;
    }
    activate(openSubMenu, fromKeyNav) {
        this.cancelActivate();
        if (this.params.disabled && !fromKeyNav) return;
        this.isActive = true;
        if (!this.suppressRootStyles) this.eGui.classList.add(`${this.cssClassPrefix}-active`);
        this.menuItemComp.setActive?.(true);
        if (!this.suppressFocus) (0, $jIDNV._preserveRangesWhile)(this.beans, ()=>this.eGui.focus({
                preventScroll: !fromKeyNav
            }));
        if (openSubMenu && this.params.subMenu) window.setTimeout(()=>{
            if (this.isAlive() && this.isActive) this.openSubMenu();
        }, 300);
        this.onItemActivated();
    }
    deactivate() {
        this.cancelDeactivate();
        if (!this.suppressRootStyles) this.eGui.classList.remove(`${this.cssClassPrefix}-active`);
        this.menuItemComp.setActive?.(false);
        this.isActive = false;
        if (this.subMenuIsOpen) this.closeSubMenu();
    }
    getGui() {
        return this.menuItemComp.getGui();
    }
    getParentComponent() {
        return this.parentComponent;
    }
    setParentComponent(component) {
        this.parentComponent = component;
    }
    getSubMenuGui() {
        return this.eSubMenuGui;
    }
    onItemSelected(event) {
        this.menuItemComp.select?.();
        if (this.params.action) this.beans.frameworkOverrides.wrapOutgoing(()=>this.params.action((0, $jIDNV._addGridCommonParams)(this.gos, {
                ...this.contextParams
            })));
        else this.openSubMenu(event && event.type === "keydown", event);
        if (this.params.subMenu && !this.params.action || this.params.suppressCloseOnSelect) return;
        this.closeMenu(event);
    }
    closeMenu(event) {
        const e = {
            type: "closeMenu"
        };
        if (event) {
            if (event instanceof MouseEvent) e.mouseEvent = event;
            else e.keyboardEvent = event;
        }
        this.dispatchLocalEvent(e);
    }
    onItemActivated() {
        const event = {
            type: "menuItemActivated",
            menuItem: this
        };
        this.dispatchLocalEvent(event);
    }
    cancelActivate() {
        if (this.activateTimeoutId) {
            window.clearTimeout(this.activateTimeoutId);
            this.activateTimeoutId = 0;
        }
    }
    cancelDeactivate() {
        if (this.deactivateTimeoutId) {
            window.clearTimeout(this.deactivateTimeoutId);
            this.deactivateTimeoutId = 0;
        }
    }
    onMouseEnter() {
        this.cancelDeactivate();
        if (this.isAnotherSubMenuOpen()) this.activateTimeoutId = window.setTimeout(()=>this.activate(true), this.ACTIVATION_DELAY);
        else this.activate(true);
    }
    onMouseLeave() {
        this.cancelActivate();
        if (this.isSubMenuOpen()) this.deactivateTimeoutId = window.setTimeout(()=>this.deactivate(), this.ACTIVATION_DELAY);
        else this.deactivate();
    }
    refreshRootElementGui(suppressRootStyles) {
        let eGui = this.menuItemComp.getGui();
        const { cssClassPrefix: cssClassPrefix, params: { cssClasses: cssClasses, disabled: disabled } } = this;
        const rootElement = this.menuItemComp.getRootElement?.();
        if (rootElement) {
            if (!suppressRootStyles) eGui.classList.add("ag-menu-option-custom");
            eGui = rootElement;
        }
        this.suppressRootStyles = !!suppressRootStyles;
        if (!this.suppressRootStyles) {
            eGui.classList.add(cssClassPrefix);
            cssClasses?.forEach((it)=>eGui.classList.add(it));
            if (disabled) eGui.classList.add(`${cssClassPrefix}-disabled`);
        }
        return eGui;
    }
    applyAriaProperties(eGui) {
        const { params: { checked: checked, subMenu: subMenu, subMenuRole: subMenuRole, disabled: disabled } } = this;
        const hasCheck = checked != null;
        (0, $jIDNV._setAriaRole)(eGui, hasCheck ? "menuitemcheckbox" : "menuitem");
        if (subMenu) (0, $jIDNV._setAriaHasPopup)(eGui, subMenuRole ?? "menu");
        if (disabled) (0, $jIDNV._setAriaDisabled)(eGui, true);
    }
    configureDefaults(configParams) {
        if (!this.menuItemComp) {
            setTimeout(()=>this.configureDefaults(configParams));
            return;
        }
        const { suppressRootStyles: suppressRootStyles, suppressTooltip: suppressTooltip, suppressAria: suppressAria, suppressTabIndex: suppressTabIndex, suppressFocus: suppressFocus } = configParams || {};
        const { params: { tooltip: tooltip, disabled: disabled } } = this;
        const eGui = this.eGui = this.refreshRootElementGui(!!suppressRootStyles);
        this.suppressAria = !!suppressAria;
        if (!suppressAria) this.applyAriaProperties(eGui);
        if (!suppressTabIndex) eGui.setAttribute("tabindex", "-1");
        if (!suppressTooltip) this.refreshTooltip(tooltip);
        if (!disabled) this.addListeners(eGui, configParams);
        this.suppressFocus = !!suppressFocus;
    }
    refreshTooltip(tooltip, shouldDisplayTooltip) {
        this.tooltip = tooltip;
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        if (!tooltip || !this.menuItemComp) return;
        const tooltipFeature = this.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.getGui(),
            getTooltipValue: ()=>this.tooltip,
            getLocation: ()=>"menu",
            shouldDisplayTooltip: shouldDisplayTooltip
        });
        if (tooltipFeature) this.tooltipFeature = this.createBean(tooltipFeature);
    }
    destroy() {
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        this.menuItemComp?.destroy?.();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/widgets/agMenuList.ts
var $5b7ccabde48fae90$var$AgMenuList = class extends (0, $jIDNV.TabGuardComp) {
    constructor(level = 0, params){
        super({
            tag: "div",
            cls: "ag-menu-list",
            role: "menu"
        });
        this.level = level;
        this.menuItems = [];
        this.params = params ?? {
            column: null,
            node: null,
            value: null
        };
    }
    postConstruct() {
        this.initialiseTabGuard({
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>(0, $jIDNV._preserveRangesWhile)(this.beans, ()=>this.handleKeyDown(e)),
            onFocusIn: (e)=>this.handleFocusIn(e),
            onFocusOut: (e)=>this.handleFocusOut(e)
        });
    }
    onTabKeyDown(e) {
        const parent = this.getParentComponent();
        const isManaged = parent?.getGui()?.classList.contains("ag-focus-managed");
        if (!isManaged) e.preventDefault();
        if (e.shiftKey) this.closeIfIsChild(e);
    }
    handleKeyDown(e) {
        switch(e.key){
            case (0, $jIDNV.KeyCode).UP:
            case (0, $jIDNV.KeyCode).RIGHT:
            case (0, $jIDNV.KeyCode).DOWN:
            case (0, $jIDNV.KeyCode).LEFT:
                e.preventDefault();
                this.handleNavKey(e.key);
                break;
            case (0, $jIDNV.KeyCode).ESCAPE:
                if (this.closeIfIsChild()) (0, $jIDNV._stopPropagationForAgGrid)(e);
                break;
        }
    }
    handleFocusIn(e) {
        const oldFocusedElement = e.relatedTarget;
        if (!this.tabGuardFeature.getTabGuardCtrl().isTabGuard(oldFocusedElement) && (this.getGui().contains(oldFocusedElement) || this.activeMenuItem?.getSubMenuGui()?.contains(oldFocusedElement))) return;
        if (this.activeMenuItem) this.activeMenuItem.activate();
        else this.activateFirstItem();
    }
    handleFocusOut(e) {
        const newFocusedElement = e.relatedTarget;
        if (!this.activeMenuItem || this.getGui().contains(newFocusedElement) || this.activeMenuItem.getSubMenuGui()?.contains(newFocusedElement)) return;
        if (!this.activeMenuItem.isSubMenuOpening()) this.activeMenuItem.deactivate();
    }
    clearActiveItem() {
        if (this.activeMenuItem) {
            this.activeMenuItem.deactivate();
            this.activeMenuItem = null;
        }
    }
    addMenuItems(menuItems) {
        if (menuItems == null) return;
        (0, $jIDNV.AgPromise).all(menuItems.map((menuItemOrString)=>{
            if (menuItemOrString === "separator") return (0, $jIDNV.AgPromise).resolve({
                eGui: this.createSeparator()
            });
            else if (typeof menuItemOrString === "string") {
                (0, $jIDNV._warn)(228, {
                    menuItemOrString: menuItemOrString
                });
                return (0, $jIDNV.AgPromise).resolve({
                    eGui: null
                });
            } else return this.addItem(menuItemOrString);
        })).then((elements)=>{
            (elements ?? []).forEach((element)=>{
                if (element?.eGui) {
                    this.appendChild(element.eGui);
                    if (element.comp) this.menuItems.push(element.comp);
                }
            });
        });
    }
    addItem(menuItemDef) {
        const menuItem = this.createManagedBean(new $5b7ccabde48fae90$var$AgMenuItemComponent());
        return menuItem.init({
            menuItemDef: menuItemDef,
            isAnotherSubMenuOpen: ()=>this.menuItems.some((m)=>m.isSubMenuOpen()),
            level: this.level,
            contextParams: this.params
        }).then(()=>{
            menuItem.setParentComponent(this);
            this.addManagedListeners(menuItem, {
                closeMenu: (event)=>{
                    this.dispatchLocalEvent(event);
                },
                menuItemActivated: (event)=>{
                    if (this.activeMenuItem && this.activeMenuItem !== event.menuItem) this.activeMenuItem.deactivate();
                    this.activeMenuItem = event.menuItem;
                }
            });
            return {
                comp: menuItem,
                eGui: menuItem.getGui()
            };
        });
    }
    activateFirstItem() {
        const item = this.menuItems.filter((currentItem)=>!currentItem.isDisabled())[0];
        if (!item) return;
        item.activate();
    }
    createSeparator() {
        const part = {
            tag: "div",
            cls: "ag-menu-separator-part"
        };
        return (0, $jIDNV._createElement)({
            tag: "div",
            cls: "ag-menu-separator",
            attrs: {
                "aria-hidden": "true"
            },
            children: [
                part,
                part,
                part,
                part
            ]
        });
    }
    handleNavKey(key) {
        switch(key){
            case (0, $jIDNV.KeyCode).UP:
            case (0, $jIDNV.KeyCode).DOWN:
                {
                    const nextItem = this.findNextItem(key === (0, $jIDNV.KeyCode).UP);
                    if (nextItem && nextItem !== this.activeMenuItem) nextItem.activate(false, true);
                    return;
                }
        }
        const left = this.gos.get("enableRtl") ? (0, $jIDNV.KeyCode).RIGHT : (0, $jIDNV.KeyCode).LEFT;
        if (key === left) this.closeIfIsChild();
        else this.openChild();
    }
    closeIfIsChild(e) {
        const parentItem = this.getParentComponent();
        if (parentItem && parentItem instanceof $5b7ccabde48fae90$var$AgMenuItemComponent) {
            if (e) e.preventDefault();
            parentItem.closeSubMenu();
            parentItem.getGui().focus();
            return true;
        }
        return false;
    }
    openChild() {
        if (this.activeMenuItem) this.activeMenuItem.openSubMenu(true);
    }
    findNextItem(up) {
        const items = [
            ...this.menuItems
        ];
        if (!items.length) return;
        if (!this.activeMenuItem) return up ? (0, $jIDNV._last)(items) : items[0];
        if (up) items.reverse();
        let nextItem;
        let foundCurrent = false;
        for (const item of items){
            if (!foundCurrent) {
                if (item === this.activeMenuItem) foundCurrent = true;
                continue;
            }
            nextItem = item;
            break;
        }
        if (foundCurrent && !nextItem) return items[0];
        return nextItem || this.activeMenuItem;
    }
    destroy() {
        this.clearActiveItem();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/columnToolPanel/toolPanelContextMenu.ts
var $5b7ccabde48fae90$var$ToolPanelContextMenu = class extends (0, $jIDNV.Component) {
    constructor(column, mouseEvent, parentEl){
        super({
            tag: "div",
            cls: "ag-menu"
        });
        this.column = column;
        this.mouseEvent = mouseEvent;
        this.parentEl = parentEl;
        this.displayName = null;
    }
    postConstruct() {
        const { column: column, beans: { colNames: colNames } } = this;
        this.initializeProperties(column);
        let displayName;
        if ((0, $jIDNV.isColumn)(column)) displayName = colNames.getDisplayNameForColumn(column, "columnToolPanel");
        else displayName = colNames.getDisplayNameForProvidedColumnGroup(null, column, "columnToolPanel");
        this.displayName = displayName;
        this.buildMenuItemMap();
        if (this.isActive()) {
            this.mouseEvent.preventDefault();
            const menuItemsMapped = this.getMappedMenuItems();
            if (menuItemsMapped.length === 0) return;
            this.displayContextMenu(menuItemsMapped);
        }
    }
    initializeProperties(column) {
        let columns;
        if ((0, $jIDNV.isProvidedColumnGroup)(column)) columns = column.getLeafColumns();
        else columns = [
            column
        ];
        this.columns = columns;
        const isPivotMode2 = this.beans.colModel.isPivotMode();
        this.allowScrollIntoView = !isPivotMode2 && columns.some(this.isColumnValidForScrollIntoView);
        this.allowGrouping = columns.some((col)=>col.isPrimary() && col.isAllowRowGroup());
        this.allowValues = columns.some((col)=>col.isPrimary() && col.isAllowValue());
        this.allowPivoting = isPivotMode2 && columns.some((col)=>col.isPrimary() && col.isAllowPivot());
    }
    buildMenuItemMap() {
        const localeTextFunc = this.getLocaleTextFunc();
        const { beans: beans, displayName: displayName } = this;
        const { rowGroupColsSvc: rowGroupColsSvc, valueColsSvc: valueColsSvc, pivotColsSvc: pivotColsSvc, colModel: colModel } = beans;
        const menuItemMap = /* @__PURE__ */ new Map();
        this.menuItemMap = menuItemMap;
        const isPivotMode2 = colModel.isPivotMode();
        menuItemMap.set("scrollIntoView", {
            allowedFunction: (col)=>!col.isPinned() && !isPivotMode2 && this.isColumnValidForScrollIntoView(col),
            activeFunction: ()=>false,
            activateLabel: ()=>localeTextFunc("scrollColumnIntoView", `Scroll ${displayName} into View`, [
                    displayName
                ]),
            activateFunction: ()=>{
                const firstVisibleColumn = this.columns.find(this.isColumnValidForScrollIntoView);
                if (firstVisibleColumn) this.beans.ctrlsSvc.getScrollFeature().ensureColumnVisible(firstVisibleColumn);
            },
            deActivateFunction: ()=>{},
            addIcon: "ensureColumnVisible"
        });
        menuItemMap.set("rowGroup", {
            allowedFunction: (col)=>col.isPrimary() && col.isAllowRowGroup() && !$5b7ccabde48fae90$var$isRowGroupColLocked(col, beans),
            activeFunction: (col)=>col.isRowGroupActive(),
            activateLabel: ()=>`${localeTextFunc("groupBy", "Group by")} ${displayName}`,
            deactivateLabel: ()=>`${localeTextFunc("ungroupBy", "Un-Group by")} ${displayName}`,
            activateFunction: ()=>rowGroupColsSvc?.setColumns(this.addColumnsToList(rowGroupColsSvc.columns), "toolPanelUi"),
            deActivateFunction: ()=>rowGroupColsSvc?.setColumns(this.removeColumnsFromList(rowGroupColsSvc.columns), "toolPanelUi"),
            addIcon: "menuAddRowGroup",
            removeIcon: "menuRemoveRowGroup"
        });
        menuItemMap.set("value", {
            allowedFunction: (col)=>col.isPrimary() && col.isAllowValue(),
            activeFunction: (col)=>col.isValueActive(),
            activateLabel: ()=>localeTextFunc("addToValues", `Add ${displayName} to values`, [
                    displayName
                ]),
            deactivateLabel: ()=>localeTextFunc("removeFromValues", `Remove ${displayName} from values`, [
                    displayName
                ]),
            activateFunction: ()=>valueColsSvc?.setColumns(this.addColumnsToList(valueColsSvc.columns), "toolPanelUi"),
            deActivateFunction: ()=>valueColsSvc?.setColumns(this.removeColumnsFromList(valueColsSvc.columns), "toolPanelUi"),
            addIcon: "valuePanel",
            removeIcon: "valuePanel"
        });
        menuItemMap.set("pivot", {
            allowedFunction: (col)=>isPivotMode2 && col.isPrimary() && col.isAllowPivot(),
            activeFunction: (col)=>col.isPivotActive(),
            activateLabel: ()=>localeTextFunc("addToLabels", `Add ${displayName} to labels`, [
                    displayName
                ]),
            deactivateLabel: ()=>localeTextFunc("removeFromLabels", `Remove ${displayName} from labels`, [
                    displayName
                ]),
            activateFunction: ()=>pivotColsSvc?.setColumns(this.addColumnsToList(pivotColsSvc.columns), "toolPanelUi"),
            deActivateFunction: ()=>pivotColsSvc?.setColumns(this.removeColumnsFromList(pivotColsSvc.columns), "toolPanelUi"),
            addIcon: "pivotPanel",
            removeIcon: "pivotPanel"
        });
    }
    isColumnValidForScrollIntoView(col) {
        const isVisible = col.isVisible();
        if (!isVisible) return false;
        const parent = col.getParent();
        if (!parent) return true;
        return parent.getDisplayedChildren()?.indexOf(col) !== -1;
    }
    addColumnsToList(columnList) {
        return [
            ...columnList
        ].concat(this.columns.filter((col)=>columnList.indexOf(col) === -1));
    }
    removeColumnsFromList(columnList) {
        return columnList.filter((col)=>this.columns.indexOf(col) === -1);
    }
    displayContextMenu(menuItemsMapped) {
        const eGui = this.getGui();
        const menuList = this.createBean(new $5b7ccabde48fae90$var$AgMenuList());
        const localeTextFunc = this.getLocaleTextFunc();
        let hideFunc = ()=>{};
        eGui.appendChild(menuList.getGui());
        menuList.addMenuItems(menuItemsMapped);
        menuList.addManagedListeners(menuList, {
            closeMenu: ()=>{
                this.parentEl.focus();
                hideFunc();
            }
        });
        const popupSvc = this.beans.popupSvc;
        const addPopupRes = popupSvc.addPopup({
            modal: true,
            eChild: eGui,
            closeOnEsc: true,
            afterGuiAttached: ()=>(0, $jIDNV._focusInto)(menuList.getGui()),
            ariaLabel: localeTextFunc("ariaLabelContextMenu", "Context Menu"),
            closedCallback: (e)=>{
                if (e instanceof KeyboardEvent) this.parentEl.focus();
                this.destroyBean(menuList);
            }
        });
        if (addPopupRes) hideFunc = addPopupRes.hideFunc;
        popupSvc.positionPopupUnderMouseEvent({
            type: "columnContextMenu",
            mouseEvent: this.mouseEvent,
            ePopup: eGui
        });
    }
    isActive() {
        return this.allowScrollIntoView || this.allowGrouping || this.allowValues || this.allowPivoting;
    }
    getMappedMenuItems() {
        const ret = [];
        const { menuItemMap: menuItemMap, columns: columns, displayName: displayName, beans: beans } = this;
        for (const val of menuItemMap.values()){
            const isInactive = columns.some((col)=>val.allowedFunction(col) && !val.activeFunction(col));
            const isActive = columns.some((col)=>val.allowedFunction(col) && val.activeFunction(col));
            if (isInactive) ret.push({
                name: val.activateLabel(displayName),
                icon: (0, $jIDNV._createIconNoSpan)(val.addIcon, beans, null),
                action: ()=>val.activateFunction()
            });
            if (isActive && val.removeIcon && val.deactivateLabel) ret.push({
                name: val.deactivateLabel(displayName),
                icon: (0, $jIDNV._createIconNoSpan)(val.removeIcon, beans, null),
                action: ()=>val.deActivateFunction?.()
            });
        }
        return ret;
    }
};
// packages/ag-grid-enterprise/src/columnToolPanel/toolPanelColumnGroupComp.ts
var $5b7ccabde48fae90$var$ToolPanelColumnGroupElement = {
    tag: "div",
    cls: "ag-column-select-column-group",
    children: [
        {
            tag: "span",
            ref: "eColumnGroupIcons",
            cls: "ag-column-group-icons",
            children: [
                {
                    tag: "span",
                    ref: "eGroupClosedIcon",
                    cls: "ag-column-group-closed-icon"
                },
                {
                    tag: "span",
                    ref: "eGroupOpenedIcon",
                    cls: "ag-column-group-opened-icon"
                }
            ]
        },
        {
            tag: "ag-checkbox",
            ref: "cbSelect",
            cls: "ag-column-select-checkbox"
        },
        {
            tag: "span",
            ref: "eLabel",
            cls: "ag-column-select-column-label"
        }
    ]
};
var $5b7ccabde48fae90$var$ToolPanelColumnGroupComp = class extends (0, $jIDNV.Component) {
    constructor(modelItem, allowDragging, eventType, focusWrapper){
        super();
        this.modelItem = modelItem;
        this.allowDragging = allowDragging;
        this.eventType = eventType;
        this.focusWrapper = focusWrapper;
        this.cbSelect = (0, $jIDNV.RefPlaceholder);
        this.eLabel = (0, $jIDNV.RefPlaceholder);
        this.eGroupOpenedIcon = (0, $jIDNV.RefPlaceholder);
        this.eGroupClosedIcon = (0, $jIDNV.RefPlaceholder);
        this.eColumnGroupIcons = (0, $jIDNV.RefPlaceholder);
        this.processingColumnStateChange = false;
        const { columnGroup: columnGroup, depth: depth, displayName: displayName } = modelItem;
        this.columnGroup = columnGroup;
        this.columnDepth = depth;
        this.displayName = displayName;
    }
    postConstruct() {
        this.setTemplate($5b7ccabde48fae90$var$ToolPanelColumnGroupElement, [
            (0, $jIDNV.AgCheckboxSelector)
        ]);
        const { beans: beans, cbSelect: cbSelect, eLabel: eLabel, displayName: displayName, columnDepth: columnDepth, modelItem: modelItem, focusWrapper: focusWrapper, columnGroup: columnGroup } = this;
        const { registry: registry, gos: gos } = beans;
        const eDragHandle = (0, $jIDNV._createIconNoSpan)("columnDrag", beans);
        this.eDragHandle = eDragHandle;
        eDragHandle.classList.add("ag-drag-handle", "ag-column-select-column-group-drag-handle");
        const checkboxGui = cbSelect.getGui();
        const checkboxInput = cbSelect.getInputElement();
        checkboxGui.insertAdjacentElement("afterend", eDragHandle);
        checkboxInput.setAttribute("tabindex", "-1");
        eLabel.textContent = displayName ?? "";
        this.setupExpandContract();
        this.addCss("ag-column-select-indent-" + columnDepth);
        this.getGui().style.setProperty("--ag-indentation-level", String(columnDepth));
        this.tooltipFeature = this.createOptionalManagedBean(registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.getGui(),
            getLocation: ()=>"columnToolPanelColumnGroup",
            shouldDisplayTooltip: (0, $jIDNV._getShouldDisplayTooltip)(gos, ()=>eLabel)
        }));
        this.addManagedEventListeners({
            columnPivotModeChanged: this.onColumnStateChanged.bind(this)
        });
        this.addManagedElementListeners(eLabel, {
            click: this.onLabelClicked.bind(this)
        });
        this.addManagedListeners(cbSelect, {
            fieldValueChanged: this.onCheckboxChanged.bind(this)
        });
        this.addManagedListeners(modelItem, {
            expandedChanged: this.onExpandChanged.bind(this)
        });
        this.addManagedListeners(focusWrapper, {
            keydown: this.handleKeyDown.bind(this),
            contextmenu: this.onContextMenu.bind(this)
        });
        this.setOpenClosedIcons();
        this.setupDragging();
        this.onColumnStateChanged();
        this.addVisibilityListenersToAllChildren();
        this.refreshAriaExpanded();
        this.refreshAriaLabel();
        this.setupTooltip();
        const classes = (0, $jIDNV._getToolPanelClassesFromColDef)(columnGroup.getColGroupDef(), gos, null, columnGroup);
        classes.forEach((c)=>this.toggleCss(c, true));
    }
    getColumns() {
        return this.columnGroup.getLeafColumns();
    }
    setupTooltip() {
        const colGroupDef = this.columnGroup.getColGroupDef();
        if (!colGroupDef) return;
        const refresh = ()=>this.tooltipFeature?.setTooltipAndRefresh(colGroupDef.headerTooltip);
        refresh();
        this.addManagedEventListeners({
            newColumnsLoaded: refresh
        });
    }
    handleKeyDown(e) {
        switch(e.key){
            case (0, $jIDNV.KeyCode).LEFT:
                e.preventDefault();
                this.modelItem.expanded = false;
                break;
            case (0, $jIDNV.KeyCode).RIGHT:
                e.preventDefault();
                this.modelItem.expanded = true;
                break;
            case (0, $jIDNV.KeyCode).SPACE:
                e.preventDefault();
                if (this.isSelectable()) this.onSelectAllChanged(!this.isSelected());
                break;
        }
    }
    onContextMenu(e) {
        const { columnGroup: columnGroup, gos: gos } = this;
        if (gos.get("functionsReadOnly")) return;
        const contextMenu = this.createBean(new $5b7ccabde48fae90$var$ToolPanelContextMenu(columnGroup, e, this.focusWrapper));
        this.addDestroyFunc(()=>{
            if (contextMenu.isAlive()) this.destroyBean(contextMenu);
        });
    }
    addVisibilityListenersToAllChildren() {
        const listener = this.onColumnStateChanged.bind(this);
        this.columnGroup.getLeafColumns().forEach((column)=>{
            this.addManagedListeners(column, {
                visibleChanged: listener,
                columnValueChanged: listener,
                columnPivotChanged: listener,
                columnRowGroupChanged: listener
            });
        });
    }
    setupDragging() {
        if (!this.allowDragging) {
            (0, $jIDNV._setDisplayed)(this.eDragHandle, false);
            return;
        }
        const beans = this.beans;
        const { gos: gos, eventSvc: eventSvc, dragAndDrop: dragAndDrop } = beans;
        let hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
        const dragSource = {
            type: (0, $jIDNV.DragSourceType).ToolPanel,
            eElement: this.eDragHandle,
            dragItemName: this.displayName,
            getDefaultIconName: ()=>hideColumnOnExit ? "hide" : "notAllowed",
            getDragItem: ()=>this.createDragItem(),
            onDragStarted: ()=>{
                hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
                eventSvc.dispatchEvent({
                    type: "columnPanelItemDragStart",
                    column: this.columnGroup
                });
            },
            onDragStopped: ()=>{
                eventSvc.dispatchEvent({
                    type: "columnPanelItemDragEnd"
                });
            },
            onGridEnter: (dragItem)=>{
                if (hideColumnOnExit) $5b7ccabde48fae90$var$updateColumns(beans, {
                    columns: this.columnGroup.getLeafColumns(),
                    visibleState: dragItem?.visibleState,
                    pivotState: dragItem?.pivotState,
                    eventType: this.eventType
                });
            },
            onGridExit: ()=>{
                if (hideColumnOnExit) this.onChangeCommon(false);
            }
        };
        dragAndDrop.addDragSource(dragSource, true);
        this.addDestroyFunc(()=>dragAndDrop.removeDragSource(dragSource));
    }
    createDragItem() {
        const columns = this.columnGroup.getLeafColumns();
        const visibleState = {};
        const pivotState = {};
        columns.forEach((col)=>{
            const colId = col.getId();
            visibleState[colId] = col.isVisible();
            pivotState[colId] = $5b7ccabde48fae90$var$createPivotState(col);
        });
        return {
            columns: columns,
            visibleState: visibleState,
            pivotState: pivotState
        };
    }
    setupExpandContract() {
        const { beans: beans, eGroupClosedIcon: eGroupClosedIcon, eGroupOpenedIcon: eGroupOpenedIcon, eColumnGroupIcons: eColumnGroupIcons } = this;
        eGroupClosedIcon.appendChild((0, $jIDNV._createIcon)("columnSelectClosed", beans, null));
        eGroupOpenedIcon.appendChild((0, $jIDNV._createIcon)("columnSelectOpen", beans, null));
        const listener = this.onExpandOrContractClicked.bind(this);
        this.addManagedElementListeners(eGroupClosedIcon, {
            click: listener
        });
        this.addManagedElementListeners(eGroupOpenedIcon, {
            click: listener
        });
        const touchListener = new (0, $jIDNV.TouchListener)(eColumnGroupIcons, true);
        this.addManagedListeners(touchListener, {
            tap: listener
        });
        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
    }
    onLabelClicked() {
        const nextState = !this.cbSelect.getValue();
        this.onChangeCommon(nextState);
    }
    onCheckboxChanged(event) {
        this.onChangeCommon(event.selected);
    }
    getVisibleLeafColumns() {
        const childColumns = [];
        const extractCols = (children)=>{
            children.forEach((child)=>{
                if (!child.passesFilter) return;
                if (child.group) extractCols(child.children);
                else childColumns.push(child.column);
            });
        };
        extractCols(this.modelItem.children);
        return childColumns;
    }
    onChangeCommon(nextState) {
        this.refreshAriaLabel();
        if (this.processingColumnStateChange) return;
        $5b7ccabde48fae90$var$selectAllChildren(this.beans, this.modelItem.children, nextState, this.eventType);
    }
    refreshAriaLabel() {
        const { cbSelect: cbSelect, focusWrapper: focusWrapper, displayName: displayName } = this;
        const translate = this.getLocaleTextFunc();
        const columnLabel = translate("ariaColumnGroup", "Column Group");
        const checkboxValue = cbSelect.getValue();
        const state = checkboxValue === void 0 ? translate("ariaIndeterminate", "indeterminate") : checkboxValue ? translate("ariaVisible", "visible") : translate("ariaHidden", "hidden");
        const visibilityLabel = translate("ariaToggleVisibility", "Press SPACE to toggle visibility");
        (0, $jIDNV._setAriaLabel)(focusWrapper, `${displayName} ${columnLabel}`);
        cbSelect.setInputAriaLabel(`${visibilityLabel} (${state})`);
        (0, $jIDNV._setAriaDescribedBy)(focusWrapper, cbSelect.getInputElement().id);
    }
    onColumnStateChanged() {
        const selectedValue = this.workOutSelectedValue();
        const readOnlyValue = this.workOutReadOnlyValue();
        this.processingColumnStateChange = true;
        const cbSelect = this.cbSelect;
        cbSelect.setValue(selectedValue);
        cbSelect.setReadOnly(readOnlyValue);
        this.toggleCss("ag-column-select-column-group-readonly", readOnlyValue);
        this.processingColumnStateChange = false;
    }
    workOutSelectedValue() {
        const pivotMode = this.beans.colModel.isPivotMode();
        const visibleLeafColumns = this.getVisibleLeafColumns();
        let checkedCount = 0;
        let uncheckedCount = 0;
        visibleLeafColumns.forEach((column)=>{
            if (!pivotMode && column.getColDef().lockVisible) return;
            if (this.isColumnChecked(column, pivotMode)) checkedCount++;
            else uncheckedCount++;
        });
        if (checkedCount > 0 && uncheckedCount > 0) return void 0;
        return checkedCount > 0;
    }
    workOutReadOnlyValue() {
        const pivotMode = this.beans.colModel.isPivotMode();
        let colsThatCanAction = 0;
        this.columnGroup.getLeafColumns().forEach((col)=>{
            if (pivotMode) {
                if (col.isAnyFunctionAllowed()) colsThatCanAction++;
            } else if (!col.getColDef().lockVisible) colsThatCanAction++;
        });
        return colsThatCanAction === 0;
    }
    isColumnChecked(column, pivotMode) {
        if (pivotMode) {
            const pivoted = column.isPivotActive();
            const grouped = column.isRowGroupActive();
            const aggregated = column.isValueActive();
            return pivoted || grouped || aggregated;
        }
        return column.isVisible();
    }
    onExpandOrContractClicked() {
        const modelItem = this.modelItem;
        const oldState = modelItem.expanded;
        modelItem.expanded = !oldState;
    }
    onExpandChanged() {
        this.setOpenClosedIcons();
        this.refreshAriaExpanded();
    }
    setOpenClosedIcons() {
        const folderOpen = this.modelItem.expanded;
        (0, $jIDNV._setDisplayed)(this.eGroupClosedIcon, !folderOpen);
        (0, $jIDNV._setDisplayed)(this.eGroupOpenedIcon, folderOpen);
    }
    refreshAriaExpanded() {
        (0, $jIDNV._setAriaExpanded)(this.focusWrapper, this.modelItem.expanded);
    }
    getDisplayName() {
        return this.displayName;
    }
    onSelectAllChanged(value) {
        const cbSelect = this.cbSelect;
        const cbValue = cbSelect.getValue();
        const readOnly = cbSelect.isReadOnly();
        if (!readOnly && (value && !cbValue || !value && cbValue)) cbSelect.toggle();
    }
    isSelected() {
        return this.cbSelect.getValue();
    }
    isSelectable() {
        return !this.cbSelect.isReadOnly();
    }
    setSelected(selected) {
        this.cbSelect.setValue(selected, true);
    }
};
// packages/ag-grid-enterprise/src/columnToolPanel/columnMoveUtils.ts
var $5b7ccabde48fae90$var$getCurrentColumnsBeingMoved = (column)=>{
    if ((0, $jIDNV.isProvidedColumnGroup)(column)) return column.getLeafColumns();
    return column ? [
        column
    ] : [];
};
var $5b7ccabde48fae90$var$getMoveTargetIndex = (beans, currentColumns, lastHoveredColumn, isBefore)=>{
    if (!lastHoveredColumn || !currentColumns) return null;
    const allColumns = beans.colModel.getCols();
    const targetColumnIndex = allColumns.indexOf(lastHoveredColumn);
    const adjustedTarget = isBefore ? targetColumnIndex : targetColumnIndex + 1;
    const diff = $5b7ccabde48fae90$var$getMoveDiff(allColumns, currentColumns, adjustedTarget);
    return adjustedTarget - diff;
};
var $5b7ccabde48fae90$var$getMoveDiff = (allColumns, currentColumns, end)=>{
    if (!currentColumns) return 0;
    const targetColumn = currentColumns[0];
    const span = currentColumns.length;
    const currentIndex = allColumns.indexOf(targetColumn);
    if (currentIndex < end) return span;
    return 0;
};
var $5b7ccabde48fae90$var$isMoveBlocked = (gos, beans, currentColumns)=>{
    const preventMoving = gos.get("suppressMovableColumns") || beans.colModel.isPivotMode();
    if (preventMoving) return true;
    const hasNotMovable = currentColumns.find(({ colDef: colDef })=>!!colDef.suppressMovable || !!colDef.lockPosition);
    return !!hasNotMovable;
};
var $5b7ccabde48fae90$var$moveItem = (beans, currentColumns, lastHoveredListItem)=>{
    if (!lastHoveredListItem) return;
    const { component: component } = lastHoveredListItem;
    let lastHoveredColumn = null;
    let isBefore = lastHoveredListItem.position === "top";
    if (component instanceof $5b7ccabde48fae90$var$ToolPanelColumnGroupComp) {
        const columns = component.getColumns();
        lastHoveredColumn = columns[0];
        isBefore = true;
    } else if (component) lastHoveredColumn = component.column;
    if (!lastHoveredColumn) return;
    const targetIndex = $5b7ccabde48fae90$var$getMoveTargetIndex(beans, currentColumns, lastHoveredColumn, isBefore);
    if (targetIndex != null) beans.colMoves?.moveColumns(currentColumns, targetIndex, "toolPanelUi");
};
var $5b7ccabde48fae90$var$getCurrentDragValue = (listItemDragStartEvent)=>{
    return listItemDragStartEvent.column;
};
var $5b7ccabde48fae90$var$ToolPanelColumnElement = {
    tag: "div",
    cls: "ag-column-select-column",
    children: [
        {
            tag: "ag-checkbox",
            ref: "cbSelect",
            cls: "ag-column-select-checkbox"
        },
        {
            tag: "span",
            ref: "eLabel",
            cls: "ag-column-select-column-label"
        }
    ]
};
var $5b7ccabde48fae90$var$ToolPanelColumnComp = class extends (0, $jIDNV.Component) {
    constructor(modelItem, allowDragging, groupsExist, focusWrapper){
        super();
        this.modelItem = modelItem;
        this.allowDragging = allowDragging;
        this.groupsExist = groupsExist;
        this.focusWrapper = focusWrapper;
        this.eLabel = (0, $jIDNV.RefPlaceholder);
        this.cbSelect = (0, $jIDNV.RefPlaceholder);
        this.processingColumnStateChange = false;
        const { column: column, depth: depth, displayName: displayName } = modelItem;
        this.column = column;
        this.columnDepth = depth;
        this.displayName = displayName;
    }
    postConstruct() {
        this.setTemplate($5b7ccabde48fae90$var$ToolPanelColumnElement, [
            (0, $jIDNV.AgCheckboxSelector)
        ]);
        const { beans: beans, cbSelect: cbSelect, displayName: displayName, eLabel: eLabel, columnDepth: indent, groupsExist: groupsExist, column: column, gos: gos, focusWrapper: focusWrapper } = this;
        const eDragHandle = (0, $jIDNV._createIconNoSpan)("columnDrag", beans);
        this.eDragHandle = eDragHandle;
        eDragHandle.classList.add("ag-drag-handle", "ag-column-select-column-drag-handle");
        const checkboxGui = cbSelect.getGui();
        const checkboxInput = cbSelect.getInputElement();
        checkboxGui.insertAdjacentElement("afterend", eDragHandle);
        checkboxInput.setAttribute("tabindex", "-1");
        eLabel.textContent = displayName;
        if (groupsExist) this.addCss("ag-column-select-add-group-indent");
        this.addCss(`ag-column-select-indent-${indent}`);
        this.getGui().style.setProperty("--ag-indentation-level", String(indent));
        this.tooltipFeature = this.createOptionalManagedBean(beans.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.getGui(),
            getLocation: ()=>"columnToolPanelColumn",
            getColDef: ()=>column.getColDef(),
            shouldDisplayTooltip: (0, $jIDNV._getShouldDisplayTooltip)(gos, ()=>eLabel)
        }));
        this.setupDragging();
        const onColStateChanged = this.onColumnStateChanged.bind(this);
        this.addManagedEventListeners({
            columnPivotModeChanged: onColStateChanged
        });
        this.addManagedListeners(column, {
            columnValueChanged: onColStateChanged,
            columnPivotChanged: onColStateChanged,
            columnRowGroupChanged: onColStateChanged,
            visibleChanged: onColStateChanged
        });
        this.addManagedListeners(focusWrapper, {
            keydown: this.handleKeyDown.bind(this),
            contextmenu: this.onContextMenu.bind(this)
        });
        this.addManagedPropertyListener("functionsReadOnly", this.onColumnStateChanged.bind(this));
        this.addManagedListeners(cbSelect, {
            fieldValueChanged: this.onCheckboxChanged.bind(this)
        });
        this.addManagedElementListeners(eLabel, {
            click: this.onLabelClicked.bind(this)
        });
        this.onColumnStateChanged();
        this.refreshAriaLabel();
        this.setupTooltip();
        const classes = (0, $jIDNV._getToolPanelClassesFromColDef)(column.getColDef(), gos, column, null);
        classes.forEach((c)=>this.toggleCss(c, true));
    }
    getColumn() {
        return this.column;
    }
    setupTooltip() {
        const refresh = ()=>this.tooltipFeature?.setTooltipAndRefresh(this.column.getColDef().headerTooltip);
        refresh();
        this.addManagedEventListeners({
            newColumnsLoaded: refresh
        });
    }
    onContextMenu(e) {
        const { column: column, gos: gos } = this;
        if (gos.get("functionsReadOnly")) return;
        const contextMenu = this.createBean(new $5b7ccabde48fae90$var$ToolPanelContextMenu(column, e, this.focusWrapper));
        this.addDestroyFunc(()=>{
            if (contextMenu.isAlive()) this.destroyBean(contextMenu);
        });
    }
    handleKeyDown(e) {
        if (e.key === (0, $jIDNV.KeyCode).SPACE) {
            e.preventDefault();
            if (this.isSelectable()) this.onSelectAllChanged(!this.isSelected());
        }
    }
    onLabelClicked() {
        if (this.gos.get("functionsReadOnly")) return;
        const nextState = !this.cbSelect.getValue();
        this.onChangeCommon(nextState);
    }
    onCheckboxChanged(event) {
        this.onChangeCommon(event.selected);
    }
    onChangeCommon(nextState) {
        if (this.cbSelect.isReadOnly()) return;
        this.refreshAriaLabel();
        if (this.processingColumnStateChange) return;
        $5b7ccabde48fae90$var$setAllColumns(this.beans, [
            this.column
        ], nextState, "toolPanelUi");
    }
    refreshAriaLabel() {
        const { cbSelect: cbSelect, focusWrapper: focusWrapper, displayName: displayName } = this;
        const translate = this.getLocaleTextFunc();
        const columnLabel = translate("ariaColumn", "Column");
        const state = cbSelect.getValue() ? translate("ariaVisible", "visible") : translate("ariaHidden", "hidden");
        const visibilityLabel = translate("ariaToggleVisibility", "Press SPACE to toggle visibility");
        (0, $jIDNV._setAriaLabel)(focusWrapper, `${displayName} ${columnLabel}`);
        this.cbSelect.setInputAriaLabel(`${visibilityLabel} (${state})`);
        (0, $jIDNV._setAriaDescribedBy)(focusWrapper, cbSelect.getInputElement().id);
    }
    setupDragging() {
        const eDragHandle = this.eDragHandle;
        if (!this.allowDragging) {
            (0, $jIDNV._setDisplayed)(eDragHandle, false);
            return;
        }
        const beans = this.beans;
        const { gos: gos, eventSvc: eventSvc, dragAndDrop: dragAndDrop } = beans;
        let hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
        const dragSource = {
            type: (0, $jIDNV.DragSourceType).ToolPanel,
            eElement: eDragHandle,
            dragItemName: this.displayName,
            getDefaultIconName: ()=>hideColumnOnExit ? "hide" : "notAllowed",
            getDragItem: ()=>this.createDragItem(),
            onDragStarted: ()=>{
                hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
                eventSvc.dispatchEvent({
                    type: "columnPanelItemDragStart",
                    column: this.column
                });
            },
            onDragStopped: ()=>{
                eventSvc.dispatchEvent({
                    type: "columnPanelItemDragEnd"
                });
            },
            onGridEnter: (dragItem)=>{
                if (hideColumnOnExit) $5b7ccabde48fae90$var$updateColumns(beans, {
                    columns: [
                        this.column
                    ],
                    visibleState: dragItem?.visibleState,
                    pivotState: dragItem?.pivotState,
                    eventType: "toolPanelUi"
                });
            },
            onGridExit: ()=>{
                if (hideColumnOnExit) this.onChangeCommon(false);
            }
        };
        dragAndDrop.addDragSource(dragSource, true);
        this.addDestroyFunc(()=>dragAndDrop.removeDragSource(dragSource));
    }
    createDragItem() {
        const colId = this.column.getColId();
        const visibleState = {
            [colId]: this.column.isVisible()
        };
        const pivotState = {
            [colId]: $5b7ccabde48fae90$var$createPivotState(this.column)
        };
        return {
            columns: [
                this.column
            ],
            visibleState: visibleState,
            pivotState: pivotState
        };
    }
    onColumnStateChanged() {
        this.processingColumnStateChange = true;
        const isPivotMode2 = this.beans.colModel.isPivotMode();
        if (isPivotMode2) {
            const anyFunctionActive = this.column.isAnyFunctionActive();
            this.cbSelect.setValue(anyFunctionActive);
        } else this.cbSelect.setValue(this.column.isVisible());
        let canBeToggled = true;
        let canBeDragged = true;
        if (isPivotMode2) {
            const functionsReadOnly = this.gos.get("functionsReadOnly");
            const noFunctionsAllowed = !this.column.isAnyFunctionAllowed();
            canBeToggled = !functionsReadOnly && !noFunctionsAllowed;
            canBeDragged = canBeToggled;
        } else {
            const { enableRowGroup: enableRowGroup, enableValue: enableValue, lockPosition: lockPosition, suppressMovable: suppressMovable, lockVisible: lockVisible } = this.column.getColDef();
            const forceDraggable = !!enableRowGroup || !!enableValue;
            const disableDraggable = !!lockPosition || !!suppressMovable;
            canBeToggled = !lockVisible;
            canBeDragged = forceDraggable || !disableDraggable;
        }
        this.cbSelect.setReadOnly(!canBeToggled);
        this.eDragHandle.classList.toggle("ag-column-select-column-readonly", !canBeDragged);
        this.toggleCss("ag-column-select-column-readonly", !canBeDragged && !canBeToggled);
        this.cbSelect.setPassive(false);
        this.processingColumnStateChange = false;
    }
    getDisplayName() {
        return this.displayName;
    }
    onSelectAllChanged(value) {
        const cbSelect = this.cbSelect;
        if (value !== cbSelect.getValue()) {
            if (!cbSelect.isReadOnly()) cbSelect.toggle();
        }
    }
    isSelected() {
        return this.cbSelect.getValue();
    }
    isSelectable() {
        return !this.cbSelect.isReadOnly();
    }
    isExpandable() {
        return false;
    }
    setExpanded(_value) {
        (0, $jIDNV._warn)(158);
    }
};
// packages/ag-grid-enterprise/src/columnToolPanel/agPrimaryColsList.ts
var $5b7ccabde48fae90$var$UIColumnModel = class {
    constructor(items){
        this.items = items;
    }
    getRowCount() {
        return this.items.length;
    }
    getRow(index) {
        return this.items[index];
    }
};
var $5b7ccabde48fae90$var$PRIMARY_COLS_LIST_PANEL_CLASS = "ag-column-select-list";
var $5b7ccabde48fae90$var$AgPrimaryColsList = class extends (0, $jIDNV.Component) {
    constructor(){
        super({
            tag: "div",
            cls: $5b7ccabde48fae90$var$PRIMARY_COLS_LIST_PANEL_CLASS,
            role: "presentation"
        });
        this.destroyColumnItemFuncs = [];
        this.hasLoadedInitialState = false;
        this.isInitialState = false;
        this.skipRefocus = false;
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
    }
    destroy() {
        this.destroyColumnTree();
        super.destroy();
    }
    destroyColumnTree() {
        this.allColsTree = [];
        this.destroyColumnItemFuncs.forEach((f)=>f());
        this.destroyColumnItemFuncs = [];
    }
    init(params, allowDragging, eventType) {
        this.params = params;
        const { suppressSyncLayoutWithGrid: suppressSyncLayoutWithGrid, contractColumnSelection: contractColumnSelection, suppressColumnMove: suppressColumnMove } = params;
        this.allowDragging = allowDragging;
        this.eventType = eventType;
        if (!suppressSyncLayoutWithGrid) this.addManagedEventListeners({
            columnMoved: this.onColumnsChanged.bind(this)
        });
        this.addManagedEventListeners({
            newColumnsLoaded: this.onColumnsChanged.bind(this)
        });
        const listener = this.fireSelectionChangedEvent.bind(this);
        this.addManagedEventListeners({
            columnPivotChanged: listener,
            columnPivotModeChanged: listener,
            columnRowGroupChanged: listener,
            columnValueChanged: listener,
            columnVisible: listener,
            newColumnsLoaded: listener
        });
        this.expandGroupsByDefault = !contractColumnSelection;
        const isPreventMove = suppressColumnMove || suppressSyncLayoutWithGrid;
        const virtualList = this.createManagedBean(new $5b7ccabde48fae90$var$VirtualList({
            cssIdentifier: "column-select",
            ariaRole: "tree",
            moveItemCallback: (item, isUp)=>{
                if (isPreventMove) return;
                this.moveItems(item, isUp);
            }
        }));
        this.virtualList = virtualList;
        this.appendChild(virtualList.getGui());
        virtualList.setComponentCreator((item, listItemElement)=>{
            (0, $jIDNV._setAriaLevel)(listItemElement, item.depth + 1);
            return this.createComponentFromItem(item, listItemElement);
        });
        if (this.colModel.ready) this.onColumnsChanged();
        if (isPreventMove) return;
        this.createItemDragFeature();
    }
    createItemDragFeature() {
        const { gos: gos, beans: beans, eventSvc: eventSvc, virtualList: virtualList } = this;
        this.createManagedBean(new $5b7ccabde48fae90$var$VirtualListDragFeature(this, virtualList, {
            dragSourceType: (0, $jIDNV.DragSourceType).ToolPanel,
            listItemDragStartEvent: "columnPanelItemDragStart",
            listItemDragEndEvent: "columnPanelItemDragEnd",
            eventSource: eventSvc,
            getCurrentDragValue: (listItemDragStartEvent)=>$5b7ccabde48fae90$var$getCurrentDragValue(listItemDragStartEvent),
            isMoveBlocked: (currentDragValue)=>$5b7ccabde48fae90$var$isMoveBlocked(gos, beans, $5b7ccabde48fae90$var$getCurrentColumnsBeingMoved(currentDragValue)),
            getNumRows: (comp)=>comp.getDisplayedColsList().length,
            moveItem: (currentDragValue, lastHoveredListItem)=>$5b7ccabde48fae90$var$moveItem(beans, $5b7ccabde48fae90$var$getCurrentColumnsBeingMoved(currentDragValue), lastHoveredListItem)
        }));
    }
    moveItems(item, isUp) {
        const { gos: gos, beans: beans } = this;
        const { modelItem: modelItem } = item;
        const { group: group, columnGroup: columnGroup, column: column, expanded: expanded } = modelItem;
        const currentColumns = $5b7ccabde48fae90$var$getCurrentColumnsBeingMoved(group ? columnGroup : column);
        if ($5b7ccabde48fae90$var$isMoveBlocked(gos, beans, currentColumns)) return;
        const currentIndex = this.displayedColsList.indexOf(modelItem);
        const diff = isUp ? -1 : 1;
        let movePadding = 0;
        if (isUp) {
            const children = item.columnDepth > 0 && column.getParent()?.getChildren();
            if (children && children.length && column === children[0]) movePadding = -1;
        } else if (group) movePadding = expanded ? modelItem.children.length : 0;
        const nextItem = Math.min(Math.max(currentIndex + movePadding + diff, 0), this.displayedColsList.length - 1);
        this.skipRefocus = true;
        $5b7ccabde48fae90$var$moveItem(beans, currentColumns, {
            rowIndex: nextItem,
            position: isUp ? "top" : "bottom",
            component: this.virtualList.getComponentAt(nextItem)
        });
        this.focusRowIfAlive(nextItem - movePadding).then(()=>{
            this.skipRefocus = false;
        });
    }
    createComponentFromItem(item, listItemElement) {
        const allowDragging = this.allowDragging;
        if (item.group) {
            const renderedGroup = new $5b7ccabde48fae90$var$ToolPanelColumnGroupComp(item, allowDragging, this.eventType, listItemElement);
            this.createBean(renderedGroup);
            return renderedGroup;
        }
        const columnComp = new $5b7ccabde48fae90$var$ToolPanelColumnComp(item, allowDragging, this.groupsExist, listItemElement);
        this.createBean(columnComp);
        return columnComp;
    }
    onColumnsChanged() {
        const params = this.params;
        if (!this.hasLoadedInitialState) {
            this.hasLoadedInitialState = true;
            this.isInitialState = !!params.initialState;
        }
        const expandedStates = this.getExpandedStates();
        const pivotModeActive = this.colModel.isPivotMode();
        const shouldSyncColumnLayoutWithGrid = !params.suppressSyncLayoutWithGrid && !pivotModeActive;
        if (shouldSyncColumnLayoutWithGrid) this.buildTreeFromWhatGridIsDisplaying();
        else this.buildTreeFromProvidedColumnDefs();
        this.setExpandedStates(expandedStates);
        this.markFilteredColumns();
        this.flattenAndFilterModel();
        this.isInitialState = false;
    }
    getDisplayedColsList() {
        return this.displayedColsList;
    }
    getExpandedStates() {
        const res = {};
        if (this.isInitialState) {
            const { expandedGroupIds: expandedGroupIds } = this.params.initialState;
            expandedGroupIds.forEach((id)=>{
                res[id] = true;
            });
            return res;
        }
        if (!this.allColsTree) return {};
        this.forEachItem((item)=>{
            if (!item.group) return;
            const colGroup = item.columnGroup;
            if (colGroup) res[colGroup.getId()] = item.expanded;
        });
        return res;
    }
    setExpandedStates(states) {
        if (!this.allColsTree) return;
        const { isInitialState: isInitialState } = this;
        this.forEachItem((item)=>{
            if (!item.group) return;
            const colGroup = item.columnGroup;
            if (colGroup) {
                const expanded = states[colGroup.getId()];
                const groupExistedLastTime = expanded != null;
                if (groupExistedLastTime || isInitialState) item.expanded = !!expanded;
            }
        });
    }
    buildTreeFromWhatGridIsDisplaying() {
        $5b7ccabde48fae90$var$syncLayoutWithGrid(this.colModel, this.setColumnLayout.bind(this));
    }
    setColumnLayout(colDefs) {
        const columnTree = $5b7ccabde48fae90$var$toolPanelCreateColumnTree(this.colModel, colDefs);
        this.buildListModel(columnTree);
        this.groupsExist = colDefs.some((colDef)=>{
            return colDef && typeof colDef.children !== "undefined";
        });
        this.markFilteredColumns();
        this.flattenAndFilterModel();
    }
    buildTreeFromProvidedColumnDefs() {
        const colModel = this.colModel;
        this.buildListModel(colModel.getColDefColTree());
        this.groupsExist = !!colModel.colDefCols?.treeDepth;
    }
    buildListModel(columnTree) {
        const columnExpandedListener = this.onColumnExpanded.bind(this);
        const addListeners = (item)=>{
            item.addEventListener("expandedChanged", columnExpandedListener);
            const removeFunc = item.removeEventListener.bind(item, "expandedChanged", columnExpandedListener);
            this.destroyColumnItemFuncs.push(removeFunc);
        };
        const colNames = this.beans.colNames;
        const recursivelyBuild = (tree, depth, parentList)=>{
            tree.forEach((child)=>{
                if ((0, $jIDNV.isProvidedColumnGroup)(child)) createGroupItem(child, depth, parentList);
                else createColumnItem(child, depth, parentList);
            });
        };
        const createGroupItem = (columnGroup, depth, parentList)=>{
            const columnGroupDef = columnGroup.getColGroupDef();
            const skipThisGroup = columnGroupDef && columnGroupDef.suppressColumnsToolPanel;
            if (skipThisGroup) return;
            if (columnGroup.isPadding()) {
                recursivelyBuild(columnGroup.getChildren(), depth, parentList);
                return;
            }
            const displayName = colNames.getDisplayNameForProvidedColumnGroup(null, columnGroup, "columnToolPanel");
            const item = new $5b7ccabde48fae90$var$ColumnModelItem(displayName, columnGroup, depth, true, this.expandGroupsByDefault);
            parentList.push(item);
            addListeners(item);
            recursivelyBuild(columnGroup.getChildren(), depth + 1, item.children);
        };
        const createColumnItem = (column, depth, parentList)=>{
            const skipThisColumn = column.getColDef() && column.getColDef().suppressColumnsToolPanel;
            if (skipThisColumn) return;
            const displayName = colNames.getDisplayNameForColumn(column, "columnToolPanel");
            parentList.push(new $5b7ccabde48fae90$var$ColumnModelItem(displayName, column, depth));
        };
        this.destroyColumnTree();
        recursivelyBuild(columnTree, 0, this.allColsTree);
    }
    onColumnExpanded() {
        this.flattenAndFilterModel();
    }
    flattenAndFilterModel() {
        this.displayedColsList = [];
        const recursiveFunc = (item)=>{
            if (!item.passesFilter) return;
            this.displayedColsList.push(item);
            if (item.group && item.expanded) item.children.forEach(recursiveFunc);
        };
        const virtualList = this.virtualList;
        this.allColsTree.forEach(recursiveFunc);
        virtualList.setModel(new $5b7ccabde48fae90$var$UIColumnModel(this.displayedColsList));
        let focusedRow = null;
        if (!this.skipRefocus) focusedRow = virtualList.getLastFocusedRow();
        virtualList.refresh();
        if (focusedRow != null) this.focusRowIfAlive(focusedRow);
        this.notifyListeners();
        this.refreshAriaLabel();
    }
    refreshAriaLabel() {
        const translate = this.getLocaleTextFunc();
        const columnListName = translate("ariaColumnPanelList", "Column List");
        const localeColumns = translate("columns", "Columns");
        const items = this.displayedColsList.length;
        (0, $jIDNV._setAriaLabel)(this.virtualList.getAriaElement(), `${columnListName} ${items} ${localeColumns}`);
    }
    focusRowIfAlive(rowIndex) {
        if (rowIndex === -1) return Promise.resolve();
        return new Promise((res)=>{
            window.setTimeout(()=>{
                if (this.isAlive()) this.virtualList.focusRow(rowIndex);
                res();
            }, 0);
        });
    }
    forEachItem(callback) {
        const recursiveFunc = (items)=>{
            items.forEach((item)=>{
                callback(item);
                if (item.group) recursiveFunc(item.children);
            });
        };
        const allColsTree = this.allColsTree;
        if (!allColsTree) return;
        recursiveFunc(allColsTree);
    }
    doSetExpandedAll(value) {
        this.forEachItem((item)=>{
            if (item.group) item.expanded = value;
        });
    }
    setGroupsExpanded(expand, groupIds) {
        if (!groupIds) {
            this.doSetExpandedAll(expand);
            return;
        }
        const expandedGroupIds = [];
        this.forEachItem((item)=>{
            if (!item.group) return;
            const groupId = item.columnGroup.getId();
            if (groupIds.indexOf(groupId) >= 0) {
                item.expanded = expand;
                expandedGroupIds.push(groupId);
            }
        });
        const unrecognisedGroupIds = groupIds.filter((groupId)=>!expandedGroupIds.includes(groupId));
        if (unrecognisedGroupIds.length > 0) (0, $jIDNV._warn)(157, {
            unrecognisedGroupIds: unrecognisedGroupIds
        });
    }
    getExpandState() {
        let expandedCount = 0;
        let notExpandedCount = 0;
        this.forEachItem((item)=>{
            if (!item.group) return;
            if (item.expanded) expandedCount++;
            else notExpandedCount++;
        });
        if (expandedCount > 0 && notExpandedCount > 0) return 2 /* INDETERMINATE */ ;
        if (notExpandedCount > 0) return 1 /* COLLAPSED */ ;
        return 0 /* EXPANDED */ ;
    }
    doSetSelectedAll(selectAllChecked) {
        $5b7ccabde48fae90$var$selectAllChildren(this.beans, this.allColsTree, selectAllChecked, this.eventType);
    }
    getSelectionState() {
        let checkedCount = 0;
        let uncheckedCount = 0;
        const pivotMode = this.colModel.isPivotMode();
        this.forEachItem((item)=>{
            if (item.group) return;
            if (!item.passesFilter) return;
            const column = item.column;
            const colDef = column.getColDef();
            let checked;
            if (pivotMode) {
                const noPivotModeOptionsAllowed = !column.isAllowPivot() && !column.isAllowRowGroup() && !column.isAllowValue();
                if (noPivotModeOptionsAllowed) return;
                checked = column.isValueActive() || column.isPivotActive() || column.isRowGroupActive();
            } else {
                if (colDef.lockVisible) return;
                checked = column.isVisible();
            }
            checked ? checkedCount++ : uncheckedCount++;
        });
        if (checkedCount > 0 && uncheckedCount > 0) return void 0;
        return !(checkedCount === 0 || uncheckedCount > 0);
    }
    setFilterText(filterText) {
        this.filterText = (0, $jIDNV._exists)(filterText) ? filterText.toLowerCase() : null;
        this.markFilteredColumns();
        this.flattenAndFilterModel();
    }
    markFilteredColumns() {
        const passesFilter = (item)=>{
            if (!(0, $jIDNV._exists)(this.filterText)) return true;
            const displayName = item.displayName;
            return displayName == null || displayName.toLowerCase().indexOf(this.filterText) !== -1;
        };
        const recursivelyCheckFilter = (item, parentPasses)=>{
            let atLeastOneChildPassed = false;
            if (item.group) {
                const groupPasses = passesFilter(item);
                item.children.forEach((child)=>{
                    const childPasses = recursivelyCheckFilter(child, groupPasses || parentPasses);
                    if (childPasses) atLeastOneChildPassed = childPasses;
                });
            }
            const filterPasses = parentPasses || atLeastOneChildPassed ? true : passesFilter(item);
            item.passesFilter = filterPasses;
            return filterPasses;
        };
        this.allColsTree.forEach((item)=>recursivelyCheckFilter(item, false));
    }
    notifyListeners() {
        this.fireGroupExpandedEvent();
        this.fireSelectionChangedEvent();
    }
    fireGroupExpandedEvent() {
        const expandState = this.getExpandState();
        this.dispatchLocalEvent({
            type: "groupExpanded",
            state: expandState
        });
    }
    fireSelectionChangedEvent() {
        if (!this.allColsTree) return;
        const selectionState = this.getSelectionState();
        this.dispatchLocalEvent({
            type: "selectionChanged",
            state: selectionState
        });
    }
    getExpandedGroups() {
        const expandedGroupIds = [];
        if (!this.allColsTree) return expandedGroupIds;
        this.forEachItem((item)=>{
            if (item.group && item.expanded) expandedGroupIds.push(item.columnGroup.getId());
        });
        return expandedGroupIds;
    }
};
var $5b7ccabde48fae90$var$AgPrimaryColsListSelector = {
    selector: "AG-PRIMARY-COLS-LIST",
    component: $5b7ccabde48fae90$var$AgPrimaryColsList
};
// packages/ag-grid-enterprise/src/columnToolPanel/agPrimaryCols.ts
var $5b7ccabde48fae90$var$AgPrimaryColsElement = {
    tag: "div",
    cls: "ag-column-select",
    children: [
        {
            tag: "ag-primary-cols-header",
            ref: "primaryColsHeaderPanel"
        },
        {
            tag: "ag-primary-cols-list",
            ref: "primaryColsListPanel"
        }
    ]
};
var $5b7ccabde48fae90$var$AgPrimaryCols = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$AgPrimaryColsElement, [
            $5b7ccabde48fae90$var$AgPrimaryColsHeaderSelector,
            $5b7ccabde48fae90$var$AgPrimaryColsListSelector
        ]);
        this.primaryColsHeaderPanel = (0, $jIDNV.RefPlaceholder);
        this.primaryColsListPanel = (0, $jIDNV.RefPlaceholder);
        this.registerCSS($5b7ccabde48fae90$var$agPrimaryColsCSS);
    }
    // we allow dragging in the toolPanel, but not when this component appears in the column menu
    init(allowDragging, params, eventType) {
        const { primaryColsHeaderPanel: primaryColsHeaderPanel, primaryColsListPanel: primaryColsListPanel } = this;
        primaryColsHeaderPanel.init(params);
        const hideFilter = params.suppressColumnFilter;
        const hideSelect = params.suppressColumnSelectAll;
        const hideExpand = params.suppressColumnExpandAll;
        if (hideExpand && hideFilter && hideSelect) primaryColsHeaderPanel.setDisplayed(false);
        this.addManagedListeners(primaryColsListPanel, {
            groupExpanded: (event)=>{
                primaryColsHeaderPanel.setExpandState(event.state);
                params.onStateUpdated();
            },
            selectionChanged: (event)=>primaryColsHeaderPanel.setSelectionState(event.state)
        });
        primaryColsListPanel.init(params, allowDragging, eventType);
        this.addManagedListeners(primaryColsHeaderPanel, {
            expandAll: primaryColsListPanel.doSetExpandedAll.bind(primaryColsListPanel, true),
            collapseAll: primaryColsListPanel.doSetExpandedAll.bind(primaryColsListPanel, false),
            selectAll: primaryColsListPanel.doSetSelectedAll.bind(primaryColsListPanel, true),
            unselectAll: primaryColsListPanel.doSetSelectedAll.bind(primaryColsListPanel, false),
            filterChanged: (event)=>primaryColsListPanel.setFilterText(event.filterText)
        });
        this.positionableFeature = this.createManagedBean(new (0, $jIDNV.PositionableFeature)(this.getGui(), {
            minHeight: 100
        }));
    }
    toggleResizable(resizable) {
        this.positionableFeature.setResizable(resizable ? {
            bottom: true
        } : false);
    }
    expandGroups(groupIds) {
        this.primaryColsListPanel.setGroupsExpanded(true, groupIds);
    }
    collapseGroups(groupIds) {
        this.primaryColsListPanel.setGroupsExpanded(false, groupIds);
    }
    setColumnLayout(colDefs) {
        this.primaryColsListPanel.setColumnLayout(colDefs);
    }
    syncLayoutWithGrid() {
        this.primaryColsListPanel.onColumnsChanged();
    }
    getExpandedGroups() {
        return this.primaryColsListPanel.getExpandedGroups();
    }
};
// packages/ag-grid-enterprise/src/columnToolPanel/columnToolPanel.css-GENERATED.ts
var $5b7ccabde48fae90$var$columnToolPanelCSS = /*css*/ `.ag-column-panel{display:flex;flex:1 1 auto;flex-direction:column;overflow:hidden}.ag-pivot-mode-panel{display:flex;height:var(--ag-header-height)}.ag-pivot-mode-select{align-items:center;display:flex}:where(.ag-ltr) .ag-pivot-mode-select{margin-left:var(--ag-widget-container-horizontal-padding)}:where(.ag-rtl) .ag-pivot-mode-select{margin-right:var(--ag-widget-container-horizontal-padding)}.ag-column-panel-column-select{border-bottom:var(--ag-tool-panel-separator-border)}.ag-column-panel-column-select:where(:nth-child(n+2 of :not(.ag-hidden))){border-top:var(--ag-tool-panel-separator-border)}:where(.ag-column-panel) .ag-column-drop-vertical{flex:1 1 0px;min-height:50px;&:where(:not(.ag-last-column-drop)){border-bottom:var(--ag-tool-panel-separator-border)}}`;
// packages/ag-grid-enterprise/src/columnToolPanel/columnToolPanel.ts
var $5b7ccabde48fae90$var$ColumnToolPanel = class extends (0, $jIDNV.Component) {
    constructor(){
        super({
            tag: "div",
            cls: "ag-column-panel"
        });
        this.initialised = false;
        this.childDestroyFuncs = [];
        this.registerCSS($5b7ccabde48fae90$var$columnToolPanelCSS);
    }
    wireBeans(beans) {
        this.colToolPanelFactory = beans.colToolPanelFactory;
    }
    // lazy initialise the panel
    setVisible(visible) {
        super.setDisplayed(visible);
        if (visible && !this.initialised) this.init(this.params);
    }
    init(params) {
        const defaultParams = (0, $jIDNV._addGridCommonParams)(this.gos, {
            suppressColumnMove: false,
            suppressColumnSelectAll: false,
            suppressColumnFilter: false,
            suppressColumnExpandAll: false,
            contractColumnSelection: false,
            suppressPivotMode: false,
            suppressRowGroups: false,
            suppressValues: false,
            suppressPivots: false,
            suppressSyncLayoutWithGrid: false
        });
        const mergedParams = {
            ...defaultParams,
            ...params
        };
        this.params = mergedParams;
        const { childDestroyFuncs: childDestroyFuncs, colToolPanelFactory: colToolPanelFactory, gos: gos } = this;
        const hasPivotModule = gos.isModuleRegistered("SharedPivot");
        const hasRowGroupingModule = hasPivotModule || gos.isModuleRegistered("SharedRowGrouping");
        if (!mergedParams.suppressPivotMode && colToolPanelFactory && hasPivotModule) this.pivotModePanel = colToolPanelFactory.createPivotModePanel(this, childDestroyFuncs);
        const primaryColsPanel = this.createBean(new $5b7ccabde48fae90$var$AgPrimaryCols());
        this.primaryColsPanel = primaryColsPanel;
        childDestroyFuncs.push(()=>this.destroyBean(this.primaryColsPanel));
        primaryColsPanel.init(true, mergedParams, "toolPanelUi");
        primaryColsPanel.addCss("ag-column-panel-column-select");
        this.appendChild(primaryColsPanel);
        if (colToolPanelFactory) {
            if (!mergedParams.suppressRowGroups && hasRowGroupingModule) this.rowGroupDropZonePanel = colToolPanelFactory.createRowGroupPanel(this, childDestroyFuncs);
            if (!mergedParams.suppressValues && hasRowGroupingModule) this.valuesDropZonePanel = colToolPanelFactory.createValuesPanel(this, childDestroyFuncs);
            if (!mergedParams.suppressPivots && hasPivotModule) this.pivotDropZonePanel = colToolPanelFactory.createPivotPanel(this, childDestroyFuncs);
            this.setLastVisible();
            const [pivotModeListener] = this.addManagedEventListeners({
                columnPivotModeChanged: ()=>{
                    this.resetChildrenHeight();
                    this.setLastVisible();
                }
            });
            childDestroyFuncs.push(()=>pivotModeListener());
        }
        this.initialised = true;
    }
    setPivotModeSectionVisible(visible) {
        const colToolPanelFactory = this.colToolPanelFactory;
        if (!colToolPanelFactory) return;
        this.pivotModePanel = colToolPanelFactory.setPanelVisible(this.pivotModePanel, visible, colToolPanelFactory.createPivotModePanel.bind(colToolPanelFactory, this, this.childDestroyFuncs, true));
        this.setLastVisible();
    }
    setRowGroupsSectionVisible(visible) {
        const colToolPanelFactory = this.colToolPanelFactory;
        if (!colToolPanelFactory) return;
        this.rowGroupDropZonePanel = colToolPanelFactory.setPanelVisible(this.rowGroupDropZonePanel, visible, colToolPanelFactory.createRowGroupPanel.bind(colToolPanelFactory, this, this.childDestroyFuncs));
        this.setLastVisible();
    }
    setValuesSectionVisible(visible) {
        const colToolPanelFactory = this.colToolPanelFactory;
        if (!colToolPanelFactory) return;
        this.valuesDropZonePanel = colToolPanelFactory.setPanelVisible(this.valuesDropZonePanel, visible, colToolPanelFactory.createValuesPanel.bind(colToolPanelFactory, this, this.childDestroyFuncs));
        this.setLastVisible();
    }
    setPivotSectionVisible(visible) {
        const colToolPanelFactory = this.colToolPanelFactory;
        if (!colToolPanelFactory) return;
        this.pivotDropZonePanel = colToolPanelFactory.setPanelVisible(this.pivotDropZonePanel, visible, colToolPanelFactory.createPivotPanel.bind(colToolPanelFactory, this, this.childDestroyFuncs));
        this.pivotDropZonePanel?.setDisplayed(visible);
        this.setLastVisible();
    }
    setResizers() {
        [
            this.primaryColsPanel,
            this.rowGroupDropZonePanel,
            this.valuesDropZonePanel,
            this.pivotDropZonePanel
        ].forEach((panel)=>{
            if (!panel) return;
            const eGui = panel.getGui();
            panel.toggleResizable(!eGui.classList.contains("ag-last-column-drop") && !eGui.classList.contains("ag-hidden"));
        });
    }
    setLastVisible() {
        const eGui = this.getGui();
        const columnDrops = Array.prototype.slice.call(eGui.querySelectorAll(".ag-column-drop"));
        columnDrops.forEach((columnDrop)=>columnDrop.classList.remove("ag-last-column-drop"));
        const columnDropEls = eGui.querySelectorAll(".ag-column-drop:not(.ag-hidden)");
        const lastVisible = (0, $jIDNV._last)(columnDropEls);
        if (lastVisible) lastVisible.classList.add("ag-last-column-drop");
        this.setResizers();
    }
    resetChildrenHeight() {
        const eGui = this.getGui();
        const children = eGui.children;
        for(let i = 0; i < children.length; i++){
            const { style: style } = children[i];
            style.removeProperty("height");
            style.removeProperty("flex");
        }
    }
    expandColumnGroups(groupIds) {
        this.primaryColsPanel.expandGroups(groupIds);
    }
    collapseColumnGroups(groupIds) {
        this.primaryColsPanel.collapseGroups(groupIds);
    }
    setColumnLayout(colDefs) {
        this.primaryColsPanel.setColumnLayout(colDefs);
    }
    syncLayoutWithGrid() {
        this.primaryColsPanel.syncLayoutWithGrid();
    }
    destroyChildren() {
        const childDestroyFuncs = this.childDestroyFuncs;
        childDestroyFuncs.forEach((func)=>func());
        childDestroyFuncs.length = 0;
        (0, $jIDNV._clearElement)(this.getGui());
    }
    refresh(params) {
        this.destroyChildren();
        this.init(params);
        return true;
    }
    getState() {
        return {
            expandedGroupIds: this.primaryColsPanel.getExpandedGroups()
        };
    }
    destroy() {
        this.destroyChildren();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/widgets/pillDropZonePanel.css-GENERATED.ts
var $5b7ccabde48fae90$var$pillDropZonePanelCSS = /*css*/ `.ag-column-drop{align-items:center;display:inline-flex;overflow:auto;position:relative;width:100%}.ag-column-drop-list{align-items:center;display:flex}.ag-column-drop-cell{align-items:center;background-color:var(--ag-column-drop-cell-background-color);border:var(--ag-column-drop-cell-border);border-radius:500px;color:var(--ag-column-drop-cell-text-color);display:flex;padding:calc(var(--ag-spacing)*.25);position:relative;&:focus-visible{box-shadow:var(--ag-focus-shadow)}:where(.ag-drag-handle){color:var(--ag-column-drop-cell-drag-handle-color)}}:where(.ag-ltr) .ag-column-drop-cell{padding-left:calc(var(--ag-spacing)*.75)}:where(.ag-rtl) .ag-column-drop-cell{padding-right:calc(var(--ag-spacing)*.75)}.ag-column-drop-cell-text{flex:1 1 auto;margin:0 var(--ag-spacing);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-column-drop-vertical{align-items:stretch;display:flex;flex-direction:column;min-height:75px;overflow:hidden}.ag-column-drop-vertical-title-bar{align-items:center;display:flex;flex:none;padding:var(--ag-widget-container-vertical-padding) calc(var(--ag-spacing)*2) 0}.ag-column-drop-vertical-list{align-items:stretch;flex-direction:column;flex-grow:1;overflow-x:auto;padding-bottom:var(--ag-spacing);padding-left:var(--ag-spacing);padding-right:var(--ag-spacing);position:relative;>*{flex:none}}:where(.ag-column-drop-empty) .ag-column-drop-vertical-list{overflow:hidden}.ag-column-drop-cell-button{cursor:pointer;min-width:0;opacity:.75;&:hover{opacity:1}}.ag-column-drop-wrapper{display:flex}.ag-column-drop-horizontal-half-width{width:50%!important}.ag-column-drop-cell-ghost{opacity:.5}.ag-column-drop-horizontal{background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);gap:var(--ag-cell-widget-spacing);height:var(--ag-header-height);overflow:hidden;white-space:nowrap}:where(.ag-ltr) .ag-column-drop-horizontal{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-column-drop-horizontal{padding-right:var(--ag-cell-horizontal-padding)}.ag-column-drop-horizontal-list{gap:var(--ag-cell-widget-spacing)}.ag-column-drop-vertical-cell{margin-top:var(--ag-spacing)}:where(.ag-ltr) .ag-column-drop-vertical-icon{margin-right:var(--ag-widget-horizontal-spacing)}:where(.ag-rtl) .ag-column-drop-vertical-icon{margin-left:var(--ag-widget-horizontal-spacing)}.ag-select-agg-func-popup{background:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);height:calc(var(--ag-spacing)*5*3.5);padding:0;position:absolute}.ag-select-agg-func-virtual-list-item{cursor:default;&:hover{background-color:var(--ag-selected-row-background-color)}}:where(.ag-ltr) .ag-select-agg-func-virtual-list-item{padding-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-select-agg-func-virtual-list-item{padding-right:calc(var(--ag-spacing)*2)}:where(.ag-ltr) .ag-column-drop-horizontal-half-width:where(:not(:last-child)){border-right:solid var(--ag-border-width) var(--ag-border-color)}:where(.ag-rtl) .ag-column-drop-horizontal-half-width:where(:not(:last-child)){border-left:solid var(--ag-border-width) var(--ag-border-color)}`;
// packages/ag-grid-enterprise/src/widgets/pillDropZonePanel.ts
function $5b7ccabde48fae90$var$_insertArrayIntoArray(dest, src, toIndex) {
    if (dest == null || src == null) return;
    dest.splice(toIndex, 0, ...src);
}
var $5b7ccabde48fae90$var$PillDropZonePanelElement = {
    tag: "div",
    cls: "ag-unselectable",
    role: "presentation"
};
var $5b7ccabde48fae90$var$PillDropZonePanel = class extends (0, $jIDNV.Component) {
    constructor(horizontal){
        super($5b7ccabde48fae90$var$PillDropZonePanelElement);
        this.horizontal = horizontal;
        this.state = "notDragging";
        this.guiDestroyFunctions = [];
        this.childPillComponents = [];
        this.resizeEnabled = false;
        this.addElementClasses(this.getGui());
        this.ePillDropList = (0, $jIDNV._createElement)({
            tag: "div"
        });
        this.addElementClasses(this.ePillDropList, "list");
        this.registerCSS($5b7ccabde48fae90$var$pillDropZonePanelCSS);
    }
    toggleResizable(resizable) {
        this.positionableFeature.setResizable(resizable ? {
            bottom: true
        } : false);
        this.resizeEnabled = resizable;
    }
    isSourceEventFromTarget(draggingEvent) {
        const { dropZoneTarget: dropZoneTarget, dragSource: dragSource } = draggingEvent;
        return dropZoneTarget.contains(dragSource.eElement);
    }
    destroy() {
        this.destroyGui();
        super.destroy();
    }
    destroyGui() {
        this.guiDestroyFunctions.forEach((func)=>func());
        this.guiDestroyFunctions.length = 0;
        this.childPillComponents.length = 0;
        (0, $jIDNV._clearElement)(this.getGui());
        (0, $jIDNV._clearElement)(this.ePillDropList);
    }
    init(params) {
        this.params = params ?? {};
        this.createManagedBean(new (0, $jIDNV.ManagedFocusFeature)(this.getFocusableElement(), {
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.onKeyDown.bind(this)
        }));
        this.setupDropTarget();
        this.positionableFeature = new (0, $jIDNV.PositionableFeature)(this.getGui());
        this.createManagedBean(this.positionableFeature);
        this.refreshGui();
        (0, $jIDNV._setAriaLabel)(this.ePillDropList, this.getAriaLabel());
    }
    onTabKeyDown(e) {
        const focusableElements = (0, $jIDNV._findFocusableElements)(this.getFocusableElement(), null, true);
        const len = focusableElements.length;
        if (len === 0) return;
        const { shiftKey: shiftKey } = e;
        const activeEl = (0, $jIDNV._getActiveDomElement)(this.beans);
        const isFirstFocused = activeEl === focusableElements[0];
        const isLastFocused = activeEl === (0, $jIDNV._last)(focusableElements);
        const shouldAllowDefaultTab = len === 1 || isFirstFocused && shiftKey || isLastFocused && !shiftKey;
        if (!shouldAllowDefaultTab) focusableElements[shiftKey ? 0 : len - 1].focus();
    }
    onKeyDown(e) {
        const { key: key } = e;
        const isVertical = !this.horizontal;
        let isNext = key === (0, $jIDNV.KeyCode).DOWN;
        let isPrevious = key === (0, $jIDNV.KeyCode).UP;
        if (!isVertical) {
            const isRtl = this.gos.get("enableRtl");
            isNext = !isRtl && key === (0, $jIDNV.KeyCode).RIGHT || isRtl && key === (0, $jIDNV.KeyCode).LEFT;
            isPrevious = !isRtl && key === (0, $jIDNV.KeyCode).LEFT || isRtl && key === (0, $jIDNV.KeyCode).RIGHT;
        }
        if (!isNext && !isPrevious) return;
        e.preventDefault();
        if (e.shiftKey) this.moveFocusedItem(isPrevious);
        else {
            const el = (0, $jIDNV._findNextFocusableElement)(this.beans, this.getFocusableElement(), false, isPrevious);
            if (el) el.focus();
        }
    }
    moveFocusedItem(isPrevious) {
        const currentItemIndex = this.getFocusedItem();
        if (currentItemIndex === -1) return;
        const diff = isPrevious ? -1 : 1;
        const changed = this.normalizeAndUpdateInsertIndex(currentItemIndex, currentItemIndex + diff);
        if (!changed) return;
        const comp = this.childPillComponents[currentItemIndex];
        if (!comp.isMovable()) return;
        const currentItem = comp.getItem();
        this.focusItemAtIndex(this.insertIndex);
        this.rearrangeItems([
            currentItem
        ], true);
    }
    addElementClasses(el, suffix) {
        suffix = suffix ? `-${suffix}` : "";
        const direction = this.horizontal ? "horizontal" : "vertical";
        el.classList.add(`ag-column-drop${suffix}`, `ag-column-drop-${direction}${suffix}`);
    }
    setupDropTarget() {
        this.dropTarget = {
            getContainer: this.getGui.bind(this),
            getIconName: this.getIconName.bind(this),
            onDragging: this.onDragging.bind(this),
            onDragEnter: this.onDragEnter.bind(this),
            onDragLeave: this.onDragLeave.bind(this),
            onDragStop: this.onDragStop.bind(this),
            onDragCancel: this.onDragCancel.bind(this),
            isInterestedIn: this.isInterestedIn.bind(this)
        };
        this.beans.dragAndDrop?.addDropTarget(this.dropTarget);
    }
    minimumAllowedNewInsertIndex() {
        return 0;
    }
    checkInsertIndex(draggingEvent) {
        const newIndex = this.getNewInsertIndex(draggingEvent);
        if (newIndex < 0) return false;
        return this.normalizeAndUpdateInsertIndex(this.insertIndex, newIndex);
    }
    normalizeAndUpdateInsertIndex(currentIndex, index) {
        const minimumAllowedIndex = this.minimumAllowedNewInsertIndex();
        const newAdjustedIndex = Math.max(minimumAllowedIndex, index);
        const changed = newAdjustedIndex !== currentIndex;
        if (changed) this.insertIndex = newAdjustedIndex;
        return changed;
    }
    getNewInsertIndex(draggingEvent) {
        const mouseEvent = draggingEvent.event;
        const mouseLocation = this.horizontal ? mouseEvent.clientX : mouseEvent.clientY;
        const boundsList = this.childPillComponents.map((comp)=>comp.getGui().getBoundingClientRect());
        const hoveredIndex = boundsList.findIndex((rect)=>this.horizontal ? rect.right > mouseLocation && rect.left < mouseLocation : rect.top < mouseLocation && rect.bottom > mouseLocation);
        if (hoveredIndex === -1) {
            const enableRtl = this.gos.get("enableRtl");
            const isLast = boundsList.every((rect)=>mouseLocation > (this.horizontal ? rect.right : rect.bottom));
            if (isLast) return enableRtl && this.horizontal ? 0 : this.childPillComponents.length;
            const isFirst = boundsList.every((rect)=>mouseLocation < (this.horizontal ? rect.left : rect.top));
            if (isFirst) return enableRtl && this.horizontal ? this.childPillComponents.length : 0;
            return this.insertIndex;
        }
        if (this.insertIndex <= hoveredIndex) return hoveredIndex + 1;
        return hoveredIndex;
    }
    checkDragStartedBySelf(draggingEvent) {
        if (this.state !== "notDragging") return;
        this.state = "rearrangeItems";
        this.potentialDndItems = this.getItems(draggingEvent.dragSource.getDragItem());
        this.refreshGui();
        this.checkInsertIndex(draggingEvent);
        this.refreshGui();
    }
    onDragging(draggingEvent) {
        this.checkDragStartedBySelf(draggingEvent);
        if (this.checkInsertIndex(draggingEvent)) this.refreshGui();
    }
    handleDragEnterEnd(_) {}
    onDragEnter(draggingEvent) {
        const dragItems = this.getItems(draggingEvent.dragSource.getDragItem());
        this.state = "newItemsIn";
        const goodDragItems = dragItems.filter((item)=>this.isItemDroppable(item, draggingEvent));
        const alreadyPresent = goodDragItems.every((item)=>this.childPillComponents.map((cmp)=>cmp.getItem()).indexOf(item) !== -1);
        if (goodDragItems.length === 0) return;
        this.potentialDndItems = goodDragItems;
        if (alreadyPresent) {
            this.state = "notDragging";
            return;
        }
        this.handleDragEnterEnd(draggingEvent);
        this.checkInsertIndex(draggingEvent);
        this.refreshGui();
    }
    isPotentialDndItems() {
        return !!this.potentialDndItems?.length;
    }
    handleDragLeaveEnd(_) {}
    onDragLeave(draggingEvent) {
        if (this.state === "rearrangeItems") {
            const items = this.getItems(draggingEvent.dragSource.getDragItem());
            this.removeItems(items);
        }
        if (this.isPotentialDndItems()) {
            this.handleDragLeaveEnd(draggingEvent);
            this.potentialDndItems = [];
            this.refreshGui();
        }
        this.state = "notDragging";
    }
    onDragCancel(draggingEvent) {
        if (this.isPotentialDndItems()) {
            if (this.state === "newItemsIn") this.handleDragLeaveEnd(draggingEvent);
            this.potentialDndItems = [];
            this.refreshGui();
        }
        this.state = "notDragging";
    }
    onDragStop() {
        if (this.isPotentialDndItems()) {
            if (this.state === "newItemsIn") this.addItems(this.potentialDndItems);
            else this.rearrangeItems(this.potentialDndItems);
            this.potentialDndItems = [];
            this.refreshGui();
        }
        this.state = "notDragging";
    }
    removeItems(itemsToRemove) {
        const newItemList = this.getExistingItems().filter((item)=>!itemsToRemove.includes(item));
        this.updateItems(newItemList);
    }
    addItems(itemsToAdd) {
        if (!itemsToAdd) return;
        const newItemList = this.getExistingItems().slice();
        const itemsToAddNoDuplicates = itemsToAdd.filter((item)=>newItemList.indexOf(item) < 0);
        $5b7ccabde48fae90$var$_insertArrayIntoArray(newItemList, itemsToAddNoDuplicates, this.insertIndex);
        this.updateItems(newItemList);
    }
    addItem(item) {
        this.insertIndex = this.getExistingItems().length;
        this.addItems([
            item
        ]);
        this.refreshGui();
    }
    rearrangeItems(itemsToAdd, fromKeyboard) {
        let newItemList;
        if (!fromKeyboard) newItemList = this.getNonGhostItems().slice();
        else newItemList = this.getExistingItems().filter((item)=>itemsToAdd.indexOf(item) === -1);
        $5b7ccabde48fae90$var$_insertArrayIntoArray(newItemList, itemsToAdd, this.insertIndex);
        if ((0, $jIDNV._areEqual)(newItemList, this.getExistingItems())) return false;
        this.updateItems(newItemList);
        return true;
    }
    refreshGui() {
        let scrollTop = 0;
        if (!this.horizontal) scrollTop = this.ePillDropList.scrollTop;
        const resizeEnabled = this.resizeEnabled;
        const focusedIndex = this.getFocusedItem();
        const { eGridDiv: eGridDiv } = this.beans;
        const isKeyboardMode = (0, $jIDNV._isKeyboardMode)();
        let alternateElement = null;
        if (isKeyboardMode) alternateElement = (0, $jIDNV._findNextFocusableElement)(this.beans, eGridDiv) ?? (0, $jIDNV._findNextFocusableElement)(this.beans, eGridDiv, false, true);
        this.toggleResizable(false);
        this.destroyGui();
        this.addIconAndTitleToGui();
        this.addEmptyMessageToGui();
        this.addItemsToGui();
        if (scrollTop !== 0) this.ePillDropList.scrollTop = scrollTop;
        if (resizeEnabled) this.toggleResizable(resizeEnabled);
        if (isKeyboardMode) this.restoreFocus(focusedIndex, alternateElement);
    }
    getFocusedItem() {
        const eGui = this.getGui();
        const activeElement = (0, $jIDNV._getActiveDomElement)(this.beans);
        if (!eGui.contains(activeElement)) return -1;
        const items = Array.from(eGui.querySelectorAll(".ag-column-drop-cell"));
        return items.indexOf(activeElement);
    }
    focusItemAtIndex(index) {
        const eGui = this.getGui();
        const items = Array.from(eGui.querySelectorAll(".ag-column-drop-cell"));
        const item = items[index];
        if (!item) return;
        item.focus({
            preventScroll: true
        });
    }
    restoreFocus(index, alternateElement) {
        const eGui = this.getGui();
        const items = Array.from(eGui.querySelectorAll(".ag-column-drop-cell"));
        if (index === -1) return;
        if (items.length === 0) alternateElement.focus();
        const indexToFocus = Math.min(items.length - 1, index);
        const el = items[indexToFocus];
        if (el) el.focus();
    }
    focusList(fromBottom) {
        const index = fromBottom ? this.childPillComponents.length - 1 : 0;
        this.restoreFocus(index, this.getFocusableElement());
    }
    getNonGhostItems() {
        const existingItems = this.getExistingItems();
        if (this.isPotentialDndItems()) return existingItems.filter((item)=>!this.potentialDndItems.includes(item));
        return existingItems;
    }
    addItemsToGui() {
        const nonGhostItems = this.getNonGhostItems();
        const itemsToAddToGui = nonGhostItems.map((item)=>this.createItemComponent(item, false));
        if (this.isPotentialDndItems()) {
            const dndItems = this.potentialDndItems.map((item)=>this.createItemComponent(item, true));
            if (this.insertIndex >= itemsToAddToGui.length) itemsToAddToGui.push(...dndItems);
            else itemsToAddToGui.splice(this.insertIndex, 0, ...dndItems);
        }
        this.appendChild(this.ePillDropList);
        itemsToAddToGui.forEach((itemComponent, index)=>{
            if (index > 0) this.addArrow(this.ePillDropList);
            this.ePillDropList.appendChild(itemComponent.getGui());
        });
        this.addAriaLabelsToComponents();
    }
    addAriaLabelsToComponents() {
        const { childPillComponents: childPillComponents, ePillDropList: ePillDropList } = this;
        const len = childPillComponents.length;
        (0, $jIDNV._setAriaRole)(ePillDropList, len === 0 ? "presentation" : "listbox");
        for(let i = 0; i < len; i++){
            const comp = childPillComponents[i];
            const eGui = comp.getGui();
            (0, $jIDNV._setAriaPosInSet)(eGui, i + 1);
            (0, $jIDNV._setAriaSetSize)(eGui, len);
        }
    }
    createItemComponent(item, ghost) {
        const itemComponent = this.createPillComponent(item, this.dropTarget, ghost, this.horizontal);
        itemComponent.addEventListener("columnRemove", this.removeItems.bind(this, [
            item
        ]));
        this.createBean(itemComponent);
        this.guiDestroyFunctions.push(()=>this.destroyBean(itemComponent));
        if (!ghost) this.childPillComponents.push(itemComponent);
        return itemComponent;
    }
    addIconAndTitleToGui() {
        const { title: title, icon: eGroupIcon } = this.params;
        if (!title || !eGroupIcon) return;
        const eTitleBar = (0, $jIDNV._createElement)({
            tag: "div"
        });
        (0, $jIDNV._setAriaHidden)(eTitleBar, true);
        this.addElementClasses(eTitleBar, "title-bar");
        this.addElementClasses(eGroupIcon, "icon");
        this.toggleCss("ag-column-drop-empty", this.isExistingItemsEmpty());
        eTitleBar.appendChild(eGroupIcon);
        if (!this.horizontal) {
            const eTitle = (0, $jIDNV._createElement)({
                tag: "span"
            });
            this.addElementClasses(eTitle, "title");
            eTitle.textContent = title;
            eTitleBar.appendChild(eTitle);
        }
        this.appendChild(eTitleBar);
    }
    isExistingItemsEmpty() {
        return this.getExistingItems().length === 0;
    }
    addEmptyMessageToGui() {
        const { emptyMessage: emptyMessage } = this.params;
        if (!emptyMessage || !this.isExistingItemsEmpty() || this.isPotentialDndItems()) return;
        const eMessage = (0, $jIDNV._createElement)({
            tag: "span"
        });
        eMessage.textContent = emptyMessage;
        this.addElementClasses(eMessage, "empty-message");
        this.ePillDropList.appendChild(eMessage);
    }
    addArrow(eParent) {
        if (this.horizontal) {
            const enableRtl = this.gos.get("enableRtl");
            const icon = (0, $jIDNV._createIconNoSpan)(enableRtl ? "panelDelimiterRtl" : "panelDelimiter", this.beans);
            this.addElementClasses(icon, "cell-separator");
            eParent.appendChild(icon);
        }
    }
};
var $5b7ccabde48fae90$var$PillDragCompElement = {
    tag: "span",
    role: "option",
    children: [
        {
            tag: "span",
            ref: "eDragHandle",
            cls: "ag-drag-handle ag-column-drop-cell-drag-handle",
            role: "presentation"
        },
        {
            tag: "span",
            ref: "eText",
            cls: "ag-column-drop-cell-text",
            attrs: {
                "aria-hidden": "true"
            }
        },
        {
            tag: "span",
            ref: "eButton",
            cls: "ag-column-drop-cell-button",
            role: "presentation"
        }
    ]
};
var $5b7ccabde48fae90$var$PillDragComp = class extends (0, $jIDNV.Component) {
    constructor(dragSourceDropTarget, ghost, horizontal, template, agComponents){
        super();
        this.dragSourceDropTarget = dragSourceDropTarget;
        this.ghost = ghost;
        this.horizontal = horizontal;
        this.template = template;
        this.agComponents = agComponents;
        this.eText = (0, $jIDNV.RefPlaceholder);
        this.eDragHandle = (0, $jIDNV.RefPlaceholder);
        this.eButton = (0, $jIDNV.RefPlaceholder);
    }
    postConstruct() {
        this.setTemplate(this.template ?? $5b7ccabde48fae90$var$PillDragCompElement, this.agComponents);
        const eGui = this.getGui();
        const { beans: beans, eDragHandle: eDragHandle, eText: eText, eButton: eButton } = this;
        this.addElementClasses(eGui);
        this.addElementClasses(eDragHandle, "drag-handle");
        this.addElementClasses(eText, "text");
        this.addElementClasses(eButton, "button");
        eDragHandle.appendChild((0, $jIDNV._createIconNoSpan)("columnDrag", beans));
        eButton.appendChild((0, $jIDNV._createIconNoSpan)("cancel", beans));
        this.tooltipFeature = this.createOptionalManagedBean(beans.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.getGui()
        }));
        this.setupComponents();
        if (!this.ghost && this.isDraggable()) this.addDragSource();
        this.setupAria();
        this.setupTooltip();
        this.activateTabIndex();
        this.refreshDraggable();
    }
    isDraggable() {
        return true;
    }
    refreshDraggable() {
        this.eDragHandle.classList.toggle("ag-column-select-column-readonly", !this.isDraggable());
    }
    setupAria() {
        const translate = this.getLocaleTextFunc();
        const ariaInstructions = [
            this.getAriaDisplayName()
        ];
        this.addAdditionalAriaInstructions(ariaInstructions, translate);
        (0, $jIDNV._setAriaLabel)(this.getGui(), ariaInstructions.join(". "));
    }
    addAdditionalAriaInstructions(ariaInstructions, translate) {
        if (this.isRemovable()) {
            const deleteAria = translate("ariaDropZoneColumnComponentDescription", "Press DELETE to remove");
            ariaInstructions.push(deleteAria);
        }
    }
    setupTooltip() {
        const refresh = ()=>this.tooltipFeature?.setTooltipAndRefresh(this.getTooltip());
        refresh();
        this.addManagedEventListeners({
            newColumnsLoaded: refresh
        });
    }
    getDragSourceId() {
        return void 0;
    }
    getDefaultIconName() {
        return "notAllowed";
    }
    addDragSource() {
        const { beans: { dragAndDrop: dragAndDrop }, eDragHandle: eDragHandle } = this;
        const getDragItem = this.createGetDragItem();
        const defaultIconName = this.getDefaultIconName();
        const dragSource = {
            type: this.getDragSourceType(),
            sourceId: this.getDragSourceId(),
            eElement: eDragHandle,
            getDefaultIconName: ()=>defaultIconName,
            getDragItem: getDragItem,
            dragItemName: this.getDisplayName()
        };
        dragAndDrop?.addDragSource(dragSource, true);
        this.addDestroyFunc(()=>dragAndDrop?.removeDragSource(dragSource));
    }
    setupComponents() {
        this.eText.textContent = this.getDisplayValue();
        this.setupRemove();
        if (this.ghost) this.addCss("ag-column-drop-cell-ghost");
    }
    isRemovable() {
        return true;
    }
    refreshRemove() {
        (0, $jIDNV._setDisplayed)(this.eButton, this.isRemovable());
    }
    setupRemove() {
        this.refreshRemove();
        const agEvent = {
            type: "columnRemove"
        };
        this.addGuiEventListener("keydown", (e)=>this.onKeyDown(e));
        this.addManagedElementListeners(this.eButton, {
            click: (mouseEvent)=>{
                this.dispatchLocalEvent(agEvent);
                mouseEvent.stopPropagation();
            }
        });
        const touchListener = new (0, $jIDNV.TouchListener)(this.eButton);
        this.addManagedListeners(touchListener, {
            tap: ()=>this.dispatchLocalEvent(agEvent)
        });
        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
    }
    onKeyDown(e) {
        const isDelete = e.key === (0, $jIDNV.KeyCode).DELETE;
        if (isDelete) {
            if (this.isRemovable()) {
                e.preventDefault();
                this.dispatchLocalEvent({
                    type: "columnRemove"
                });
            }
        }
    }
    getDisplayValue() {
        return this.getDisplayName();
    }
    addElementClasses(el, suffix) {
        suffix = suffix ? `-${suffix}` : "";
        const direction = this.horizontal ? "horizontal" : "vertical";
        el.classList.add(`ag-column-drop-cell${suffix}`, `ag-column-drop-${direction}-cell${suffix}`);
    }
    destroy() {
        super.destroy();
        this.dragSourceDropTarget = null;
    }
};
// packages/ag-grid-enterprise/src/rowGrouping/columnDropZones/dropZoneColumnComp.ts
var $5b7ccabde48fae90$var$DropZoneColumnComp = class extends $5b7ccabde48fae90$var$PillDragComp {
    constructor(column, dragSourceDropTarget, ghost, dropZonePurpose, horizontal){
        super(dragSourceDropTarget, ghost, horizontal);
        this.column = column;
        this.dropZonePurpose = dropZonePurpose;
        this.eSortIndicator = (0, $jIDNV.RefPlaceholder);
        this.popupShowing = false;
    }
    postConstruct() {
        const { sortSvc: sortSvc, colNames: colNames } = this.beans;
        this.template = {
            tag: "span",
            role: "option",
            children: [
                {
                    tag: "span",
                    ref: "eDragHandle",
                    cls: "ag-drag-handle ag-column-drop-cell-drag-handle",
                    role: "presentation"
                },
                {
                    tag: "span",
                    ref: "eText",
                    cls: "ag-column-drop-cell-text",
                    attrs: {
                        "aria-hidden": "true"
                    }
                },
                sortSvc ? {
                    tag: "ag-sort-indicator",
                    ref: "eSortIndicator"
                } : void 0,
                {
                    tag: "span",
                    ref: "eButton",
                    cls: "ag-column-drop-cell-button",
                    role: "presentation"
                }
            ]
        };
        if (sortSvc) this.agComponents = [
            sortSvc.getSortIndicatorSelector()
        ];
        this.displayName = colNames.getDisplayNameForColumn(this.column, "columnDrop");
        super.postConstruct();
        if (sortSvc) {
            this.setupSort();
            this.addManagedEventListeners({
                sortChanged: ()=>{
                    this.setupAria();
                }
            });
        }
        if (this.isGroupingZone()) this.addManagedPropertyListener("groupLockGroupColumns", ()=>{
            this.refreshRemove();
            this.refreshDraggable();
            this.setupAria();
        });
    }
    getItem() {
        return this.column;
    }
    getDisplayName() {
        return this.displayName;
    }
    getTooltip() {
        return this.column.getColDef().headerTooltip;
    }
    addAdditionalAriaInstructions(ariaInstructions, translate) {
        const isSortSuppressed = this.gos.get("rowGroupPanelSuppressSort");
        const isFunctionsReadOnly = this.gos.get("functionsReadOnly");
        if (this.isAggregationZone() && !isFunctionsReadOnly) {
            const aggregationMenuAria = translate("ariaDropZoneColumnValueItemDescription", "Press ENTER to change the aggregation type");
            ariaInstructions.push(aggregationMenuAria);
        }
        if (this.isGroupingZone() && this.column.isSortable() && !isSortSuppressed) {
            const sortProgressAria = translate("ariaDropZoneColumnGroupItemDescription", "Press ENTER to sort");
            ariaInstructions.push(sortProgressAria);
        }
        super.addAdditionalAriaInstructions(ariaInstructions, translate);
    }
    isMovable() {
        return this.isDraggable();
    }
    isDraggable() {
        return this.isReadOnly();
    }
    isRemovable() {
        return this.isReadOnly();
    }
    isReadOnly() {
        return !this.isGroupingAndLocked() && !this.gos.get("functionsReadOnly");
    }
    getAriaDisplayName() {
        const translate = this.getLocaleTextFunc();
        const { name: name, aggFuncName: aggFuncName } = this.getColumnAndAggFuncName();
        const aggSeparator = translate("ariaDropZoneColumnComponentAggFuncSeparator", " of ");
        const sortDirection = {
            asc: translate("ariaDropZoneColumnComponentSortAscending", "ascending"),
            desc: translate("ariaDropZoneColumnComponentSortDescending", "descending")
        };
        const columnSort = this.column.getSort();
        const isSortSuppressed = this.gos.get("rowGroupPanelSuppressSort");
        return [
            aggFuncName && `${aggFuncName}${aggSeparator}`,
            name,
            this.isGroupingZone() && !isSortSuppressed && columnSort && `, ${sortDirection[columnSort]}`
        ].filter((part)=>!!part).join("");
    }
    getColumnAndAggFuncName() {
        const name = this.displayName;
        let aggFuncName = "";
        if (this.isAggregationZone()) {
            const aggFunc = this.column.getAggFunc();
            const aggFuncString = typeof aggFunc === "string" ? aggFunc : "agg";
            const localeTextFunc = this.getLocaleTextFunc();
            aggFuncName = localeTextFunc(aggFuncString, aggFuncString);
        }
        return {
            name: name,
            aggFuncName: aggFuncName
        };
    }
    setupSort() {
        if (!this.column.isSortable() || !this.isGroupingZone()) return;
        if (!this.gos.get("rowGroupPanelSuppressSort")) {
            this.eSortIndicator.setupSort(this.column, true);
            const performSort = (event)=>{
                event.preventDefault();
                this.beans.sortSvc.progressSortFromEvent(this.column, event);
            };
            this.addGuiEventListener("click", performSort);
            this.addGuiEventListener("keydown", (e)=>{
                const isEnter = e.key === (0, $jIDNV.KeyCode).ENTER;
                if (isEnter && this.isGroupingZone()) performSort(e);
            });
        }
    }
    getDefaultIconName() {
        return "hide";
    }
    createGetDragItem() {
        const { column: column } = this;
        return ()=>{
            const visibleState = {};
            visibleState[column.getId()] = column.isVisible();
            return {
                columns: [
                    column
                ],
                visibleState: visibleState
            };
        };
    }
    setupComponents() {
        super.setupComponents();
        if (this.isAggregationZone() && !this.gos.get("functionsReadOnly")) this.addGuiEventListener("click", this.onShowAggFuncSelection.bind(this));
    }
    onKeyDown(e) {
        super.onKeyDown(e);
        const isEnter = e.key === (0, $jIDNV.KeyCode).ENTER;
        if (isEnter && this.isAggregationZone() && !this.gos.get("functionsReadOnly")) {
            e.preventDefault();
            this.onShowAggFuncSelection();
        }
    }
    getDisplayValue() {
        const { name: name, aggFuncName: aggFuncName } = this.getColumnAndAggFuncName();
        return this.isAggregationZone() ? `${aggFuncName}(${name})` : name;
    }
    onShowAggFuncSelection() {
        if (this.popupShowing) return;
        this.popupShowing = true;
        const { aggFuncSvc: aggFuncSvc, popupSvc: popupSvc } = this.beans;
        const virtualList = new $5b7ccabde48fae90$var$VirtualList({
            cssIdentifier: "select-agg-func"
        });
        const rows = aggFuncSvc.getFuncNames(this.column);
        const eGui = this.getGui();
        const virtualListGui = virtualList.getGui();
        virtualList.setModel({
            getRow: function(index) {
                return rows[index];
            },
            getRowCount: function() {
                return rows.length;
            }
        });
        this.createBean(virtualList);
        const ePopup = (0, $jIDNV._createElement)({
            tag: "div",
            cls: "ag-select-agg-func-popup"
        });
        ePopup.style.top = "0px";
        ePopup.style.left = "0px";
        ePopup.appendChild(virtualListGui);
        ePopup.style.width = `${eGui.clientWidth}px`;
        const [focusoutListener] = this.addManagedElementListeners(ePopup, {
            focusout: (e)=>{
                if (!ePopup.contains(e.relatedTarget) && addPopupRes) addPopupRes.hideFunc();
            }
        });
        const popupHiddenFunc = (callbackEvent)=>{
            this.destroyBean(virtualList);
            this.popupShowing = false;
            if (callbackEvent?.key === "Escape") eGui.focus();
            if (focusoutListener) focusoutListener();
        };
        const translate = this.getLocaleTextFunc();
        const addPopupRes = popupSvc.addPopup({
            modal: true,
            eChild: ePopup,
            closeOnEsc: true,
            closedCallback: popupHiddenFunc,
            ariaLabel: translate("ariaLabelAggregationFunction", "Aggregation Function")
        });
        if (addPopupRes) virtualList.setComponentCreator(this.createAggSelect.bind(this, addPopupRes.hideFunc));
        virtualList.addGuiEventListener("keydown", (e)=>{
            if (e.key === (0, $jIDNV.KeyCode).ENTER || e.key === (0, $jIDNV.KeyCode).SPACE) {
                const row = virtualList.getLastFocusedRow();
                if (row == null) return;
                const comp = virtualList.getComponentAt(row);
                if (comp) comp.selectItem();
            }
        });
        popupSvc.positionPopupByComponent({
            type: "aggFuncSelect",
            eventSource: eGui,
            ePopup: ePopup,
            keepWithinBounds: true,
            column: this.column,
            position: "under"
        });
        virtualList.refresh();
        let rowToFocus = rows.findIndex((r)=>r === this.column.getAggFunc());
        if (rowToFocus === -1) rowToFocus = 0;
        virtualList.focusRow(rowToFocus);
    }
    createAggSelect(hidePopup, value) {
        const itemSelected = ()=>{
            hidePopup();
            this.getGui().focus();
            this.beans.valueColsSvc?.setColumnAggFunc?.(this.column, value, "toolPanelDragAndDrop");
        };
        const localeTextFunc = this.getLocaleTextFunc();
        const aggFuncString = value.toString();
        const aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
        const comp = new $5b7ccabde48fae90$var$AggItemComp(itemSelected, aggFuncStringTranslated);
        return comp;
    }
    isGroupingAndLocked() {
        return this.isGroupingZone() && $5b7ccabde48fae90$var$isRowGroupColLocked(this.column, this.beans);
    }
    isAggregationZone() {
        return this.dropZonePurpose === "aggregation";
    }
    isGroupingZone() {
        return this.dropZonePurpose === "rowGroup";
    }
    getDragSourceType() {
        return (0, $jIDNV.DragSourceType).ToolPanel;
    }
    destroy() {
        super.destroy();
        this.column = null;
    }
};
var $5b7ccabde48fae90$var$AggItemComp = class extends (0, $jIDNV.Component) {
    constructor(itemSelected, value){
        super({
            tag: "div",
            cls: "ag-select-agg-func-item",
            children: value
        });
        this.selectItem = itemSelected;
        this.addGuiEventListener("click", this.selectItem);
    }
};
// packages/ag-grid-enterprise/src/rowGrouping/columnDropZones/baseDropZonePanel.ts
var $5b7ccabde48fae90$var$BaseDropZonePanel = class extends $5b7ccabde48fae90$var$PillDropZonePanel {
    constructor(horizontal, dropZonePurpose){
        super(horizontal);
        this.dropZonePurpose = dropZonePurpose;
        this.addElementClasses(this.getGui(), this.dropZonePurpose.toLowerCase());
    }
    init(params) {
        super.init(params);
        this.addManagedEventListeners({
            newColumnsLoaded: this.refreshGui.bind(this)
        });
        this.addManagedPropertyListeners([
            "functionsReadOnly",
            "rowGroupPanelSuppressSort",
            "groupLockGroupColumns"
        ], this.refreshGui.bind(this));
    }
    getItems(dragItem) {
        return dragItem.columns ?? [];
    }
    isInterestedIn(type) {
        return type === (0, $jIDNV.DragSourceType).HeaderCell || type === (0, $jIDNV.DragSourceType).ToolPanel;
    }
    minimumAllowedNewInsertIndex() {
        const { gos: gos, rowGroupColsSvc: rowGroupColsSvc } = this.beans;
        const numberOfLockedCols = gos.get("groupLockGroupColumns");
        const numberOfGroupCols = rowGroupColsSvc?.columns.length ?? 0;
        if (numberOfLockedCols === -1) return numberOfGroupCols;
        return Math.min(numberOfLockedCols, numberOfGroupCols);
    }
    showOrHideColumnOnExit(draggingEvent) {
        return this.isRowGroupPanel() && (0, $jIDNV._shouldUpdateColVisibilityAfterGroup)(this.gos, true) && !draggingEvent.fromNudge;
    }
    handleDragEnterEnd(draggingEvent) {
        const hideColumnOnExit = this.showOrHideColumnOnExit(draggingEvent);
        if (hideColumnOnExit) {
            const dragItem = draggingEvent.dragSource.getDragItem();
            const columns = dragItem.columns;
            this.setColumnsVisible(columns, false, "uiColumnDragged");
        }
    }
    handleDragLeaveEnd(draggingEvent) {
        const showColumnOnExit = this.showOrHideColumnOnExit(draggingEvent);
        if (showColumnOnExit) {
            const dragItem = draggingEvent.dragSource.getDragItem();
            this.setColumnsVisible(dragItem.columns, true, "uiColumnDragged");
        }
    }
    setColumnsVisible(columns, visible, source) {
        if (columns) {
            const allowedCols = columns.filter((c)=>!c.getColDef().lockVisible);
            this.beans.colModel.setColsVisible(allowedCols, visible, source);
        }
    }
    isRowGroupPanel() {
        return this.dropZonePurpose === "rowGroup";
    }
    createPillComponent(column, dropTarget, ghost, horizontal) {
        return new $5b7ccabde48fae90$var$DropZoneColumnComp(column, dropTarget, ghost, this.dropZonePurpose, horizontal);
    }
};
// packages/ag-grid-enterprise/src/rowGrouping/columnDropZones/pivotDropZonePanel.ts
var $5b7ccabde48fae90$var$PivotDropZonePanel = class extends $5b7ccabde48fae90$var$BaseDropZonePanel {
    constructor(horizontal){
        super(horizontal, "pivot");
    }
    postConstruct() {
        const localeTextFunc = this.getLocaleTextFunc();
        const emptyMessage = localeTextFunc("pivotColumnsEmptyMessage", "Drag here to set column labels");
        const title = localeTextFunc("pivots", "Column Labels");
        super.init({
            icon: (0, $jIDNV._createIconNoSpan)("pivotPanel", this.beans, null),
            emptyMessage: emptyMessage,
            title: title
        });
        this.addManagedEventListeners({
            newColumnsLoaded: this.refresh.bind(this),
            columnPivotChanged: this.refresh.bind(this),
            columnPivotModeChanged: this.checkVisibility.bind(this)
        });
        this.refresh();
    }
    getAriaLabel() {
        const translate = this.getLocaleTextFunc();
        const label = translate("ariaPivotDropZonePanelLabel", "Column Labels");
        return label;
    }
    refresh() {
        this.checkVisibility();
        this.refreshGui();
    }
    checkVisibility() {
        const colModel = this.beans.colModel;
        const pivotMode = colModel.isPivotMode();
        if (this.horizontal) switch(this.gos.get("pivotPanelShow")){
            case "always":
                this.setDisplayed(pivotMode);
                break;
            case "onlyWhenPivoting":
                {
                    const pivotActive = colModel.isPivotActive();
                    this.setDisplayed(pivotMode && pivotActive);
                    break;
                }
            default:
                this.setDisplayed(false);
                break;
        }
        else this.setDisplayed(pivotMode);
    }
    isItemDroppable(column, draggingEvent) {
        if (this.gos.get("functionsReadOnly") || !column.isPrimary()) return false;
        return column.isAllowPivot() && (!column.isPivotActive() || this.isSourceEventFromTarget(draggingEvent));
    }
    updateItems(columns) {
        this.beans.pivotColsSvc?.setColumns(columns, "toolPanelUi");
    }
    getIconName() {
        return this.isPotentialDndItems() ? "pivot" : "notAllowed";
    }
    getExistingItems() {
        return this.beans.pivotColsSvc?.columns ?? [];
    }
};
var $5b7ccabde48fae90$var$RowGroupDropZonePanel = class extends $5b7ccabde48fae90$var$BaseDropZonePanel {
    constructor(horizontal){
        super(horizontal, "rowGroup");
    }
    postConstruct() {
        const localeTextFunc = this.getLocaleTextFunc();
        const emptyMessage = localeTextFunc("rowGroupColumnsEmptyMessage", "Drag here to set row groups");
        const title = localeTextFunc("groups", "Row Groups");
        super.init({
            icon: (0, $jIDNV._createIconNoSpan)("rowGroupPanel", this.beans, null),
            emptyMessage: emptyMessage,
            title: title
        });
        this.addManagedEventListeners({
            columnRowGroupChanged: this.refreshGui.bind(this)
        });
    }
    getAriaLabel() {
        const translate = this.getLocaleTextFunc();
        const label = translate("ariaRowGroupDropZonePanelLabel", "Row Groups");
        return label;
    }
    isItemDroppable(column, draggingEvent) {
        if (this.gos.get("functionsReadOnly") || !column.isPrimary() || column.colDef.showRowGroup) return false;
        return column.isAllowRowGroup() && (!column.isRowGroupActive() || this.isSourceEventFromTarget(draggingEvent));
    }
    updateItems(columns) {
        this.beans.rowGroupColsSvc?.setColumns(columns, "toolPanelUi");
    }
    getIconName() {
        return this.isPotentialDndItems() ? "group" : "notAllowed";
    }
    getExistingItems() {
        return this.beans.rowGroupColsSvc?.columns ?? [];
    }
};
var $5b7ccabde48fae90$var$ValuesDropZonePanel = class extends $5b7ccabde48fae90$var$BaseDropZonePanel {
    constructor(horizontal){
        super(horizontal, "aggregation");
    }
    postConstruct() {
        const localeTextFunc = this.getLocaleTextFunc();
        const emptyMessage = localeTextFunc("valueColumnsEmptyMessage", "Drag here to aggregate");
        const title = localeTextFunc("values", "Values");
        super.init({
            icon: (0, $jIDNV._createIconNoSpan)("valuePanel", this.beans, null),
            emptyMessage: emptyMessage,
            title: title
        });
        this.addManagedEventListeners({
            columnValueChanged: this.refreshGui.bind(this)
        });
    }
    getAriaLabel() {
        const translate = this.getLocaleTextFunc();
        const label = translate("ariaValuesDropZonePanelLabel", "Values");
        return label;
    }
    getIconName() {
        return this.isPotentialDndItems() ? "aggregate" : "notAllowed";
    }
    isItemDroppable(column, draggingEvent) {
        if (this.gos.get("functionsReadOnly") || !column.isPrimary()) return false;
        return column.isAllowValue() && (!column.isValueActive() || this.isSourceEventFromTarget(draggingEvent));
    }
    updateItems(columns) {
        this.beans.valueColsSvc?.setColumns(columns, "toolPanelUi");
    }
    getExistingItems() {
        return this.beans.valueColsSvc?.columns ?? [];
    }
};
var $5b7ccabde48fae90$var$PivotModePanelElement = {
    tag: "div",
    cls: "ag-pivot-mode-panel",
    children: [
        {
            tag: "ag-toggle-button",
            ref: "cbPivotMode",
            cls: "ag-pivot-mode-select"
        }
    ]
};
var $5b7ccabde48fae90$var$PivotModePanel = class extends (0, $jIDNV.Component) {
    constructor(){
        super(...arguments);
        this.cbPivotMode = (0, $jIDNV.RefPlaceholder);
    }
    postConstruct() {
        this.setTemplate($5b7ccabde48fae90$var$PivotModePanelElement, [
            (0, $jIDNV.AgToggleButtonSelector)
        ]);
        const cbPivotMode = this.cbPivotMode;
        const { colModel: colModel, ctrlsSvc: ctrlsSvc, gos: gos } = this.beans;
        cbPivotMode.setValue(colModel.isPivotMode());
        const localeTextFunc = this.getLocaleTextFunc();
        cbPivotMode.setLabel(localeTextFunc("pivotMode", "Pivot Mode"));
        const onBtPivotMode = ()=>{
            const newValue = !!cbPivotMode.getValue();
            if (newValue !== colModel.isPivotMode()) {
                gos.updateGridOptions({
                    options: {
                        pivotMode: newValue
                    },
                    source: "toolPanelUi"
                });
                ctrlsSvc.getHeaderRowContainerCtrls().forEach((c)=>c.refresh());
            }
        };
        const onPivotModeChanged = ()=>{
            const pivotModeActive = colModel.isPivotMode();
            cbPivotMode.setValue(pivotModeActive);
        };
        this.addManagedListeners(cbPivotMode, {
            fieldValueChanged: onBtPivotMode
        });
        this.addManagedEventListeners({
            newColumnsLoaded: onPivotModeChanged,
            columnPivotModeChanged: onPivotModeChanged
        });
    }
};
// packages/ag-grid-enterprise/src/columnToolPanel/columnToolPanelFactory.ts
var $5b7ccabde48fae90$var$ColumnToolPanelFactory = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "colToolPanelFactory";
    }
    setPanelVisible(existingPanel, visible, createFunc) {
        if (existingPanel) existingPanel.setDisplayed(visible);
        else if (visible) existingPanel = createFunc();
        return existingPanel;
    }
    createRowGroupPanel(parent, destroyFuncs) {
        return this.createPanel(parent, destroyFuncs, new $5b7ccabde48fae90$var$RowGroupDropZonePanel(false));
    }
    createValuesPanel(parent, destroyFuncs) {
        return this.createPanel(parent, destroyFuncs, new $5b7ccabde48fae90$var$ValuesDropZonePanel(false));
    }
    createPivotPanel(parent, destroyFuncs) {
        return this.createPanel(parent, destroyFuncs, new $5b7ccabde48fae90$var$PivotDropZonePanel(false));
    }
    createPivotModePanel(parent, destroyFuncs, prepend) {
        return this.createPanel(parent, destroyFuncs, new $5b7ccabde48fae90$var$PivotModePanel(), prepend);
    }
    createPanel(parent, destroyFuncs, panel, prepend) {
        panel = parent.createBean(panel);
        destroyFuncs.push(()=>parent.destroyBean(panel));
        if (prepend) parent.prependChild(panel);
        else parent.appendChild(panel);
        return panel;
    }
};
// packages/ag-grid-enterprise/src/columnToolPanel/columnsToolPanelModule.ts
var $5b7ccabde48fae90$export$8ff0dc87b3f8200e = {
    moduleName: "ColumnsToolPanel",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$ColumnToolPanelFactory
    ],
    userComponents: {
        agColumnsToolPanel: $5b7ccabde48fae90$var$ColumnToolPanel
    },
    icons: {
        ensureColumnVisible: "column-arrow",
        // column tool panel tab
        columnsToolPanel: "columns",
        // "Group by {column-name}" item in column header menu
        menuAddRowGroup: "group",
        // "Un-Group by {column-name}" item in column header menu
        menuRemoveRowGroup: "group",
        // identifies the pivot drop zone
        pivotPanel: "pivot",
        // "Row groups" drop zone in column tool panel
        rowGroupPanel: "group",
        // columns tool panel Values drop zone
        valuePanel: "aggregation",
        // column tool panel column group contracted (click to expand)
        columnSelectClosed: "tree-closed",
        // column tool panel column group expanded (click to contract)
        columnSelectOpen: "tree-open",
        // column tool panel header expand/collapse all button, shown when some children are expanded and
        //     others are collapsed
        columnSelectIndeterminate: "tree-indeterminate"
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        $5b7ccabde48fae90$export$707a9bd30915b7fe,
        (0, $jIDNV._ColumnMoveModule),
        (0, $jIDNV._SharedDragAndDropModule),
        (0, $jIDNV._PopupModule),
        $5b7ccabde48fae90$var$MenuItemModule
    ]
};
var $5b7ccabde48fae90$var$ChartMenuItemMapper = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "chartMenuItemMapper";
    }
    getChartItems(key) {
        const beans = this.beans;
        const chartSvc = beans.chartSvc;
        const isPivot = key === "pivotChart";
        if (!chartSvc) return null;
        const getLocaleTextFunc = this.getLocaleTextFunc.bind(this);
        const builder = isPivot ? new $5b7ccabde48fae90$var$PivotMenuItemMapper(beans, chartSvc, getLocaleTextFunc) : new $5b7ccabde48fae90$var$RangeMenuItemMapper(beans, chartSvc, getLocaleTextFunc);
        const isEnterprise = chartSvc.isEnterprise();
        let topLevelMenuItem = builder.getMenuItem();
        if (topLevelMenuItem && topLevelMenuItem.subMenu && !isEnterprise) {
            const filterEnterpriseItems = (m)=>({
                    ...m,
                    subMenu: m.subMenu?.filter((menu)=>!menu._enterprise).map((menu)=>filterEnterpriseItems(menu))
                });
            topLevelMenuItem = filterEnterpriseItems(topLevelMenuItem);
        }
        const chartGroupsDef = this.gos.get("chartToolPanelsDef")?.settingsPanel?.chartGroupsDef;
        if (chartGroupsDef) topLevelMenuItem = this.filterAndOrderChartMenu(topLevelMenuItem, chartGroupsDef, builder.getConfigLookup());
        return this.cleanInternals(topLevelMenuItem);
    }
    // Remove our internal _key and _enterprise properties so this does not leak out of the class on the menu items.
    cleanInternals(menuItem) {
        if (!menuItem) return menuItem;
        const removeKeys = (m)=>{
            delete m?._key;
            delete m?._enterprise;
            m?.subMenu?.forEach((s)=>removeKeys(s));
            return m;
        };
        return removeKeys(menuItem);
    }
    buildLookup(menuItem) {
        const itemLookup = {};
        const addItem = (item)=>{
            itemLookup[item._key] = item;
            if (item.subMenu) item.subMenu.forEach((s)=>addItem(s));
        };
        addItem(menuItem);
        return itemLookup;
    }
    /**
   * Make the MenuItem match the charts provided and their ordering on the ChartGroupsDef config object as provided by the user.
   */ filterAndOrderChartMenu(topLevelMenuItem, chartGroupsDef, configLookup) {
        const menuItemLookup = this.buildLookup(topLevelMenuItem);
        const orderedAndFiltered = {
            ...topLevelMenuItem,
            subMenu: []
        };
        for (const group of Object.keys(chartGroupsDef)){
            const chartTypes = chartGroupsDef[group];
            const chartConfigGroup = configLookup[group];
            if (chartConfigGroup === null) continue;
            if (chartConfigGroup == void 0) {
                (0, $jIDNV._warn)(173, {
                    group: group
                });
                continue;
            }
            const menuItem = menuItemLookup[chartConfigGroup._key];
            if (menuItem) {
                if (menuItem.subMenu) {
                    const subMenus = chartTypes.map((chartType)=>{
                        const itemKey = chartConfigGroup[chartType];
                        if (itemKey == void 0) {
                            (0, $jIDNV._warn)(174, {
                                group: group,
                                chartType: chartType
                            });
                            return void 0;
                        }
                        return menuItemLookup[itemKey];
                    }).filter((s)=>s !== void 0);
                    if (subMenus.length > 0) {
                        menuItem.subMenu = subMenus;
                        orderedAndFiltered.subMenu?.push(menuItem);
                    }
                } else orderedAndFiltered.subMenu?.push(menuItem);
            }
        }
        if (orderedAndFiltered.subMenu?.length == 0) return null;
        return orderedAndFiltered;
    }
};
var $5b7ccabde48fae90$var$PivotMenuItemMapper = class {
    constructor(beans, chartSvc, getLocaleTextFunc){
        this.beans = beans;
        this.chartSvc = chartSvc;
        this.getLocaleTextFunc = getLocaleTextFunc;
    }
    getMenuItem() {
        const localeTextFunc = this.getLocaleTextFunc();
        const getMenuItem = (localeKey, defaultText, chartType, key, enterprise = false)=>{
            return {
                // will have a LRM character appended to ensure correct display in RTL languages
                name: localeTextFunc(localeKey, defaultText + "\u200E"),
                action: ()=>this.chartSvc.createPivotChart({
                        chartType: chartType
                    }),
                _key: key,
                _enterprise: enterprise
            };
        };
        return {
            name: localeTextFunc("pivotChart", "Pivot Chart"),
            _key: "pivotChart",
            subMenu: [
                {
                    _key: "pivotColumnChart",
                    name: localeTextFunc("columnChart", "Column"),
                    subMenu: [
                        getMenuItem("groupedColumn", "Grouped", "groupedColumn", "pivotGroupedColumn"),
                        getMenuItem("stackedColumn", "Stacked", "stackedColumn", "pivotStackedColumn"),
                        getMenuItem("normalizedColumn", "100% Stacked", "normalizedColumn", "pivotNormalizedColumn")
                    ]
                },
                {
                    _key: "pivotBarChart",
                    name: localeTextFunc("barChart", "Bar"),
                    subMenu: [
                        getMenuItem("groupedBar", "Grouped", "groupedBar", "pivotGroupedBar"),
                        getMenuItem("stackedBar", "Stacked", "stackedBar", "pivotStackedBar"),
                        getMenuItem("normalizedBar", "100% Stacked", "normalizedBar", "pivotNormalizedBar")
                    ]
                },
                {
                    _key: "pivotPieChart",
                    name: localeTextFunc("pieChart", "Pie"),
                    subMenu: [
                        getMenuItem("pie", "Pie", "pie", "pivotPie"),
                        getMenuItem("donut", "Donut", "donut", "pivotDonut")
                    ]
                },
                {
                    _key: "pivotLineChart",
                    name: localeTextFunc("lineChart", "Line"),
                    subMenu: [
                        getMenuItem("lineChart", "Line", "line", "pivotLineChart"),
                        getMenuItem("stackedLine", "Stacked", "stackedLine", "pivotStackedLine"),
                        getMenuItem("normalizedLine", "100% Stacked", "normalizedLine", "pivotNormalizedLine")
                    ]
                },
                {
                    _key: "pivotAreaChart",
                    name: localeTextFunc("areaChart", "Area"),
                    subMenu: [
                        getMenuItem("areaChart", "Area", "area", "pivotArea"),
                        getMenuItem("stackedArea", "Stacked", "stackedArea", "pivotStackedArea"),
                        getMenuItem("normalizedArea", "100% Stacked", "normalizedArea", "pivotNormalizedArea")
                    ]
                },
                {
                    _key: "pivotXYChart",
                    name: localeTextFunc("xyChart", "X Y (Scatter)"),
                    subMenu: [
                        getMenuItem("scatter", "Scatter", "scatter", "pivotScatter"),
                        getMenuItem("bubble", "Bubble", "bubble", "pivotBubble")
                    ]
                },
                {
                    _key: "pivotStatisticalChart",
                    _enterprise: false,
                    // histogram chart is available in both community and enterprise distributions
                    name: localeTextFunc("statisticalChart", "Statistical"),
                    subMenu: [
                        getMenuItem("histogramChart", "Histogram", "histogram", "pivotHistogram", false)
                    ]
                },
                {
                    _key: "pivotHierarchicalChart",
                    _enterprise: true,
                    name: localeTextFunc("hierarchicalChart", "Hierarchical"),
                    subMenu: [
                        getMenuItem("treemapChart", "Treemap", "treemap", "pivotTreemap", true),
                        getMenuItem("sunburstChart", "Sunburst", "sunburst", "pivotSunburst", true)
                    ]
                },
                {
                    _key: "pivotFunnel",
                    name: localeTextFunc("funnel", "Funnel"),
                    subMenu: [
                        getMenuItem("funnel", "Funnel", "funnel", "pivotFunnel"),
                        getMenuItem("coneFunnel", "Cone Funnel", "coneFunnel", "pivotConeFunnel"),
                        getMenuItem("pyramid", "Pyramid", "pyramid", "pivotPyramid")
                    ]
                },
                {
                    _key: "pivotCombinationChart",
                    name: localeTextFunc("combinationChart", "Combination"),
                    subMenu: [
                        getMenuItem("columnLineCombo", "Column & Line", "columnLineCombo", "pivotColumnLineCombo"),
                        getMenuItem("AreaColumnCombo", "Area & Column", "areaColumnCombo", "pivotAreaColumnCombo")
                    ]
                }
            ],
            icon: (0, $jIDNV._createIconNoSpan)("chart", this.beans, void 0)
        };
    }
    getConfigLookup() {
        return {
            columnGroup: {
                _key: "pivotColumnChart",
                column: "pivotGroupedColumn",
                stackedColumn: "pivotStackedColumn",
                normalizedColumn: "pivotNormalizedColumn"
            },
            barGroup: {
                _key: "pivotBarChart",
                bar: "pivotGroupedBar",
                stackedBar: "pivotStackedBar",
                normalizedBar: "pivotNormalizedBar"
            },
            pieGroup: {
                _key: "pivotPieChart",
                pie: "pivotPie",
                donut: "pivotDonut",
                doughnut: "pivotDonut"
            },
            lineGroup: {
                _key: "pivotLineChart",
                line: "pivotLineChart",
                stackedLine: "pivotStackedLine",
                normalizedLine: "pivotNormalizedLine"
            },
            areaGroup: {
                _key: "pivotAreaChart",
                area: "pivotArea",
                stackedArea: "pivotStackedArea",
                normalizedArea: "pivotNormalizedArea"
            },
            scatterGroup: {
                _key: "pivotXYChart",
                bubble: "pivotBubble",
                scatter: "pivotScatter"
            },
            combinationGroup: {
                _key: "pivotCombinationChart",
                columnLineCombo: "pivotColumnLineCombo",
                areaColumnCombo: "pivotAreaColumnCombo",
                customCombo: null
            },
            hierarchicalGroup: {
                _key: "pivotHierarchicalChart",
                treemap: "pivotTreemap",
                sunburst: "pivotSunburst"
            },
            statisticalGroup: {
                _key: "pivotStatisticalChart",
                histogram: "pivotHistogram",
                // Some statistical charts do not currently support pivot mode
                rangeBar: null,
                rangeArea: null,
                boxPlot: null
            },
            funnelGroup: {
                _key: "pivotFunnel",
                funnel: "pivotFunnel",
                coneFunnel: "pivotConeFunnel",
                pyramid: "pivotPyramid"
            },
            // Polar charts do not support pivot mode
            polarGroup: null,
            // Specialized charts do not currently support pivot mode
            specializedGroup: null
        };
    }
};
var $5b7ccabde48fae90$var$RangeMenuItemMapper = class {
    constructor(beans, chartSvc, getLocaleTextFunc){
        this.beans = beans;
        this.chartSvc = chartSvc;
        this.getLocaleTextFunc = getLocaleTextFunc;
    }
    getMenuItem() {
        const localeTextFunc = this.getLocaleTextFunc();
        const getMenuItem = (localeKey, defaultText, chartType, key, enterprise = false)=>{
            return {
                name: localeTextFunc(localeKey, defaultText),
                action: ()=>this.chartSvc.createChartFromCurrentRange(chartType),
                _key: key,
                _enterprise: enterprise
            };
        };
        return {
            name: localeTextFunc("chartRange", "Chart Range"),
            _key: "chartRange",
            subMenu: [
                {
                    name: localeTextFunc("columnChart", "Column"),
                    subMenu: [
                        getMenuItem("groupedColumn", "Grouped", "groupedColumn", "rangeGroupedColumn"),
                        getMenuItem("stackedColumn", "Stacked", "stackedColumn", "rangeStackedColumn"),
                        getMenuItem("normalizedColumn", "100% Stacked", "normalizedColumn", "rangeNormalizedColumn")
                    ],
                    _key: "rangeColumnChart"
                },
                {
                    name: localeTextFunc("barChart", "Bar"),
                    subMenu: [
                        getMenuItem("groupedBar", "Grouped", "groupedBar", "rangeGroupedBar"),
                        getMenuItem("stackedBar", "Stacked", "stackedBar", "rangeStackedBar"),
                        getMenuItem("normalizedBar", "100% Stacked", "normalizedBar", "rangeNormalizedBar")
                    ],
                    _key: "rangeBarChart"
                },
                {
                    name: localeTextFunc("pieChart", "Pie"),
                    subMenu: [
                        getMenuItem("pie", "Pie", "pie", "rangePie"),
                        getMenuItem("donut", "Donut", "donut", "rangeDonut")
                    ],
                    _key: "rangePieChart"
                },
                {
                    name: localeTextFunc("lineChart", "Line"),
                    subMenu: [
                        getMenuItem("lineChart", "Line", "line", "rangeLineChart"),
                        getMenuItem("stackedLine", "Stacked", "stackedLine", "rangeStackedLine"),
                        getMenuItem("normalizedLine", "100% Stacked", "normalizedLine", "rangeNormalizedLine")
                    ],
                    _key: "rangeLineChart"
                },
                {
                    name: localeTextFunc("areaChart", "Area"),
                    subMenu: [
                        getMenuItem("areaChart", "Area", "area", "rangeArea"),
                        getMenuItem("stackedArea", "Stacked", "stackedArea", "rangeStackedArea"),
                        getMenuItem("normalizedArea", "100% Stacked", "normalizedArea", "rangeNormalizedArea")
                    ],
                    _key: "rangeAreaChart"
                },
                {
                    name: localeTextFunc("xyChart", "X Y (Scatter)"),
                    subMenu: [
                        getMenuItem("scatter", "Scatter", "scatter", "rangeScatter"),
                        getMenuItem("bubble", "Bubble", "bubble", "rangeBubble")
                    ],
                    _key: "rangeXYChart"
                },
                {
                    name: localeTextFunc("polarChart", "Polar"),
                    subMenu: [
                        getMenuItem("radarLine", "Radar Line", "radarLine", "rangeRadarLine"),
                        getMenuItem("radarArea", "Radar Area", "radarArea", "rangeRadarArea"),
                        getMenuItem("nightingale", "Nightingale", "nightingale", "rangeNightingale"),
                        getMenuItem("radialColumn", "Radial Column", "radialColumn", "rangeRadialColumn"),
                        getMenuItem("radialBar", "Radial Bar", "radialBar", "rangeRadialBar")
                    ],
                    _key: "rangePolarChart",
                    _enterprise: true
                },
                {
                    name: localeTextFunc("statisticalChart", "Statistical"),
                    subMenu: [
                        getMenuItem("boxPlot", "Box Plot", "boxPlot", "rangeBoxPlot", true),
                        getMenuItem("histogramChart", "Histogram", "histogram", "rangeHistogram", false),
                        getMenuItem("rangeBar", "Range Bar", "rangeBar", "rangeRangeBar", true),
                        getMenuItem("rangeArea", "Range Area", "rangeArea", "rangeRangeArea", true)
                    ],
                    _key: "rangeStatisticalChart",
                    _enterprise: false
                },
                {
                    name: localeTextFunc("hierarchicalChart", "Hierarchical"),
                    subMenu: [
                        getMenuItem("treemap", "Treemap", "treemap", "rangeTreemap"),
                        getMenuItem("sunburst", "Sunburst", "sunburst", "rangeSunburst")
                    ],
                    _key: "rangeHierarchicalChart",
                    _enterprise: true
                },
                {
                    name: localeTextFunc("specializedChart", "Specialized"),
                    subMenu: [
                        getMenuItem("heatmap", "Heatmap", "heatmap", "rangeHeatmap"),
                        getMenuItem("waterfall", "Waterfall", "waterfall", "rangeWaterfall")
                    ],
                    _key: "rangeSpecializedChart",
                    _enterprise: true
                },
                {
                    name: localeTextFunc("funnel", "Funnel"),
                    subMenu: [
                        getMenuItem("funnel", "Funnel", "funnel", "rangeFunnel"),
                        getMenuItem("coneFunnel", "Cone Funnel", "coneFunnel", "rangeConeFunnel"),
                        getMenuItem("pyramid", "Pyramid", "pyramid", "rangePyramid")
                    ],
                    _key: "rangeFunnel",
                    _enterprise: true
                },
                {
                    name: localeTextFunc("combinationChart", "Combination"),
                    subMenu: [
                        getMenuItem("columnLineCombo", "Column & Line", "columnLineCombo", "rangeColumnLineCombo"),
                        getMenuItem("AreaColumnCombo", "Area & Column", "areaColumnCombo", "rangeAreaColumnCombo")
                    ],
                    _key: "rangeCombinationChart"
                }
            ],
            icon: (0, $jIDNV._createIconNoSpan)("chart", this.beans, void 0)
        };
    }
    getConfigLookup() {
        return {
            columnGroup: {
                _key: "rangeColumnChart",
                column: "rangeGroupedColumn",
                stackedColumn: "rangeStackedColumn",
                normalizedColumn: "rangeNormalizedColumn"
            },
            barGroup: {
                _key: "rangeBarChart",
                bar: "rangeGroupedBar",
                stackedBar: "rangeStackedBar",
                normalizedBar: "rangeNormalizedBar"
            },
            pieGroup: {
                _key: "rangePieChart",
                pie: "rangePie",
                donut: "rangeDonut",
                doughnut: "rangeDonut"
            },
            lineGroup: {
                _key: "rangeLineChart",
                line: "rangeLineChart",
                stackedLine: "rangeStackedLine",
                normalizedLine: "rangeNormalizedLine"
            },
            areaGroup: {
                _key: "rangeAreaChart",
                area: "rangeArea",
                stackedArea: "rangeStackedArea",
                normalizedArea: "rangeNormalizedArea"
            },
            scatterGroup: {
                _key: "rangeXYChart",
                bubble: "rangeBubble",
                scatter: "rangeScatter"
            },
            polarGroup: {
                _key: "rangePolarChart",
                radarLine: "rangeRadarLine",
                radarArea: "rangeRadarArea",
                nightingale: "rangeNightingale",
                radialColumn: "rangeRadialColumn",
                radialBar: "rangeRadialBar"
            },
            statisticalGroup: {
                _key: "rangeStatisticalChart",
                boxPlot: "rangeBoxPlot",
                histogram: "rangeHistogram",
                rangeBar: "rangeRangeBar",
                rangeArea: "rangeRangeArea"
            },
            hierarchicalGroup: {
                _key: "rangeHierarchicalChart",
                treemap: "rangeTreemap",
                sunburst: "rangeSunburst"
            },
            specializedGroup: {
                _key: "rangeSpecializedChart",
                heatmap: "rangeHeatmap",
                waterfall: "rangeWaterfall"
            },
            funnelGroup: {
                _key: "rangeFunnel",
                funnel: "rangeFunnel",
                coneFunnel: "rangeConeFunnel",
                pyramid: "rangePyramid"
            },
            combinationGroup: {
                _key: "rangeCombinationChart",
                columnLineCombo: "rangeColumnLineCombo",
                areaColumnCombo: "rangeAreaColumnCombo",
                customCombo: null
            }
        };
    }
};
var $5b7ccabde48fae90$var$ColumnChooserFactory = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "colChooserFactory";
    }
    createColumnSelectPanel(parent, column, draggable, params) {
        const columnSelectPanel = parent.createManagedBean(new $5b7ccabde48fae90$var$AgPrimaryCols());
        const columnChooserParams = params ?? column?.getColDef().columnChooserParams ?? {};
        const { contractColumnSelection: contractColumnSelection, suppressColumnExpandAll: suppressColumnExpandAll, suppressColumnFilter: suppressColumnFilter, suppressColumnSelectAll: suppressColumnSelectAll, suppressSyncLayoutWithGrid: suppressSyncLayoutWithGrid, columnLayout: columnLayout } = columnChooserParams;
        columnSelectPanel.init(!!draggable, (0, $jIDNV._addGridCommonParams)(this.gos, {
            suppressColumnMove: false,
            suppressValues: false,
            suppressPivots: false,
            suppressRowGroups: false,
            suppressPivotMode: false,
            contractColumnSelection: !!contractColumnSelection,
            suppressColumnExpandAll: !!suppressColumnExpandAll,
            suppressColumnFilter: !!suppressColumnFilter,
            suppressColumnSelectAll: !!suppressColumnSelectAll,
            suppressSyncLayoutWithGrid: !!columnLayout || !!suppressSyncLayoutWithGrid,
            onStateUpdated: ()=>{}
        }), "columnMenu");
        if (columnLayout) columnSelectPanel.setColumnLayout(columnLayout);
        return columnSelectPanel;
    }
    showColumnChooser({ column: column, chooserParams: chooserParams, eventSource: eventSource, headerPosition: providedHeaderPosition }) {
        this.hideActiveColumnChooser();
        const columnSelectPanel = this.createColumnSelectPanel(this, column, true, chooserParams);
        const translate = this.getLocaleTextFunc();
        const beans = this.beans;
        const { visibleCols: visibleCols, focusSvc: focusSvc, menuUtils: menuUtils } = beans;
        const columnIndex = visibleCols.allCols.indexOf(column);
        const headerPosition = column ? focusSvc.focusedHeader ?? providedHeaderPosition ?? null : null;
        this.activeColumnChooserDialog = this.createBean(new $5b7ccabde48fae90$var$AgDialog({
            title: translate("chooseColumns", "Choose Columns"),
            component: columnSelectPanel,
            width: 300,
            height: 300,
            resizable: true,
            movable: true,
            centered: true,
            closable: true,
            afterGuiAttached: ()=>{
                (0, $jIDNV._findNextFocusableElement)(beans, columnSelectPanel.getGui())?.focus({
                    preventScroll: true
                });
                this.dispatchVisibleChangedEvent(true, column);
            },
            closedCallback: (event)=>{
                const eComp = this.activeColumnChooser.getGui();
                this.destroyBean(this.activeColumnChooser);
                this.activeColumnChooser = void 0;
                this.activeColumnChooserDialog = void 0;
                this.dispatchVisibleChangedEvent(false, column);
                if (column) menuUtils.restoreFocusOnClose({
                    column: column,
                    headerPosition: headerPosition,
                    columnIndex: columnIndex,
                    eventSource: eventSource
                }, eComp, event, true);
            },
            postProcessPopupParams: {
                type: "columnChooser",
                column: column,
                eventSource: eventSource
            }
        }));
        this.activeColumnChooser = columnSelectPanel;
    }
    hideActiveColumnChooser() {
        this.destroyBean(this.activeColumnChooserDialog);
    }
    dispatchVisibleChangedEvent(visible, column) {
        this.eventSvc.dispatchEvent({
            type: "columnMenuVisibleChanged",
            visible: visible,
            switchingTab: false,
            key: "columnChooser",
            column: column ?? null
        });
    }
};
// packages/ag-grid-enterprise/src/menu/menuItemValidations.ts
var $5b7ccabde48fae90$var$MENU_ITEM_MODULES = {
    pinSubMenu: "PinnedColumn",
    pinLeft: "PinnedColumn",
    pinRight: "PinnedColumn",
    clearPinned: "PinnedColumn",
    pinRowSubMenu: "PinnedRow",
    pinBottom: "PinnedRow",
    pinTop: "PinnedRow",
    unpinRow: "PinnedRow",
    valueAggSubMenu: "SharedAggregation",
    autoSizeThis: "ColumnAutoSize",
    autoSizeAll: "ColumnAutoSize",
    rowGroup: "SharedRowGrouping",
    rowUnGroup: "SharedRowGrouping",
    resetColumns: "CommunityCore",
    expandAll: [
        "ClientSideRowModelHierarchy",
        "ServerSideRowModel"
    ],
    contractAll: [
        "ClientSideRowModelHierarchy",
        "ServerSideRowModel"
    ],
    copy: "Clipboard",
    copyWithHeaders: "Clipboard",
    copyWithGroupHeaders: "Clipboard",
    cut: "Clipboard",
    paste: "Clipboard",
    export: [
        "CsvExport",
        "ExcelExport"
    ],
    csvExport: "CsvExport",
    excelExport: "ExcelExport",
    separator: "CommunityCore",
    pivotChart: "IntegratedCharts",
    chartRange: "IntegratedCharts",
    columnFilter: "ColumnFilter",
    columnChooser: "ColumnMenu",
    sortAscending: "Sort",
    sortDescending: "Sort",
    sortUnSort: "Sort"
};
function $5b7ccabde48fae90$var$validateMenuItem(gos, key) {
    const moduleName4 = $5b7ccabde48fae90$var$MENU_ITEM_MODULES[key];
    if (moduleName4) gos.assertModuleRegistered(moduleName4, `menu item '${key}'`);
}
// packages/ag-grid-enterprise/src/menu/menuItemMapper.ts
var $5b7ccabde48fae90$var$MENU_ITEM_SEPARATOR = "separator";
function $5b7ccabde48fae90$var$_removeRepeatsFromArray(array, object) {
    if (!array) return;
    for(let index = array.length - 2; index >= 0; index--){
        const thisOneMatches = array[index] === object;
        const nextOneMatches = array[index + 1] === object;
        if (thisOneMatches && nextOneMatches) array.splice(index + 1, 1);
    }
}
var $5b7ccabde48fae90$var$MenuItemMapper = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "menuItemMapper";
    }
    mapWithStockItems(originalList, column, node, sourceElement, source) {
        if (!originalList) return [];
        const resultList = [];
        const localeTextFunc = this.getLocaleTextFunc();
        const { beans: beans, gos: gos } = this;
        const { pinnedCols: pinnedCols, colAutosize: colAutosize, aggFuncSvc: aggFuncSvc, rowGroupColsSvc: rowGroupColsSvc, colNames: colNames, colModel: colModel, clipboardSvc: clipboardSvc, expansionSvc: expansionSvc, focusSvc: focusSvc, csvCreator: csvCreator, excelCreator: excelCreator, menuSvc: menuSvc, colChooserFactory: colChooserFactory, sortSvc: sortSvc, chartMenuItemMapper: chartMenuItemMapper, valueColsSvc: valueColsSvc, pinnedRowModel: pinnedRowModel } = beans;
        const getStockMenuItem = (key, column2, sourceElement2, source2)=>{
            $5b7ccabde48fae90$var$validateMenuItem(gos, key);
            switch(key){
                case "pinSubMenu":
                    return pinnedCols && column2 ? {
                        name: localeTextFunc("pinColumn", "Pin Column"),
                        icon: (0, $jIDNV._createIconNoSpan)("menuPin", beans, null),
                        subMenu: [
                            "clearPinned",
                            "pinLeft",
                            "pinRight"
                        ]
                    } : null;
                case "pinLeft":
                    return pinnedCols && column2 ? {
                        name: localeTextFunc("pinLeft", "Pin Left"),
                        action: ()=>pinnedCols.setColsPinned([
                                column2
                            ], "left", source2),
                        checked: !!column2 && column2.isPinnedLeft()
                    } : null;
                case "pinRight":
                    return pinnedCols && column2 ? {
                        name: localeTextFunc("pinRight", "Pin Right"),
                        action: ()=>pinnedCols.setColsPinned([
                                column2
                            ], "right", source2),
                        checked: !!column2 && column2.isPinnedRight()
                    } : null;
                case "clearPinned":
                    return pinnedCols && column2 ? {
                        name: localeTextFunc("noPin", "No Pin"),
                        action: ()=>pinnedCols.setColsPinned([
                                column2
                            ], null, source2),
                        checked: !!column2 && !column2.isPinned()
                    } : null;
                case "pinRowSubMenu":
                    {
                        const enableRowPinning = gos.get("enableRowPinning");
                        const subMenu = [];
                        const pinned = node?.rowPinned ?? node?.pinnedSibling?.rowPinned;
                        if (pinned) subMenu.push("unpinRow");
                        if (enableRowPinning && enableRowPinning !== "bottom" && pinned != "top") subMenu.push("pinTop");
                        if (enableRowPinning && enableRowPinning !== "top" && pinned != "bottom") subMenu.push("pinBottom");
                        return pinnedRowModel?.isManual() ? {
                            name: localeTextFunc("pinRow", "Pin Row"),
                            icon: (0, $jIDNV._createIconNoSpan)("rowPin", beans, column2),
                            subMenu: subMenu
                        } : null;
                    }
                case "pinTop":
                    return pinnedRowModel?.isManual() ? {
                        name: localeTextFunc("pinTop", "Pin to Top"),
                        icon: (0, $jIDNV._createIconNoSpan)("rowPinTop", beans, column2),
                        action: ({ node: node2, column: column3 })=>node2 && pinnedRowModel.pinRow(node2, "top", column3)
                    } : null;
                case "pinBottom":
                    return pinnedRowModel?.isManual() ? {
                        name: localeTextFunc("pinBottom", "Pin to Bottom"),
                        icon: (0, $jIDNV._createIconNoSpan)("rowPinBottom", beans, column2),
                        action: ({ node: node2, column: column3 })=>node2 && pinnedRowModel.pinRow(node2, "bottom", column3)
                    } : null;
                case "unpinRow":
                    return pinnedRowModel?.isManual() ? {
                        name: localeTextFunc("unpinRow", "Unpin Row"),
                        icon: (0, $jIDNV._createIconNoSpan)("rowUnpin", beans, column2),
                        action: ({ node: node2, column: column3 })=>node2 && pinnedRowModel.pinRow(node2, null, column3)
                    } : null;
                case "valueAggSubMenu":
                    if (aggFuncSvc && valueColsSvc && (column2?.isPrimary() || column2?.getColDef().pivotValueColumn)) return {
                        name: localeTextFunc("valueAggregation", "Value Aggregation"),
                        icon: (0, $jIDNV._createIconNoSpan)("menuValue", beans, null),
                        subMenu: $5b7ccabde48fae90$var$createAggregationSubMenu(column2, aggFuncSvc, valueColsSvc, localeTextFunc),
                        disabled: gos.get("functionsReadOnly")
                    };
                    else return null;
                case "autoSizeThis":
                    return colAutosize ? {
                        name: localeTextFunc("autosizeThisColumn", "Autosize This Column"),
                        action: ()=>colAutosize.autoSizeColumn(column2, source2, gos.get("skipHeaderOnAutoSize"))
                    } : null;
                case "autoSizeAll":
                    return colAutosize ? {
                        name: localeTextFunc("autosizeAllColumns", "Autosize All Columns"),
                        action: ()=>colAutosize.autoSizeAllColumns({
                                source: source2,
                                skipHeader: gos.get("skipHeaderOnAutoSize")
                            })
                    } : null;
                case "rowGroup":
                    return rowGroupColsSvc ? {
                        name: localeTextFunc("groupBy", "Group by") + " " + colNames.getDisplayNameForColumn(column2, "header"),
                        disabled: gos.get("functionsReadOnly") || column2?.isRowGroupActive() || !column2?.getColDef().enableRowGroup,
                        action: ()=>rowGroupColsSvc.addColumns([
                                column2
                            ], source2),
                        icon: (0, $jIDNV._createIconNoSpan)("menuAddRowGroup", beans, null)
                    } : null;
                case "rowUnGroup":
                    if (rowGroupColsSvc && gos.isModuleRegistered("SharedRowGrouping")) {
                        const showRowGroup = column2?.getColDef().showRowGroup;
                        const lockedGroups = gos.get("groupLockGroupColumns");
                        let name;
                        let disabled;
                        let action;
                        if (showRowGroup === true) {
                            name = localeTextFunc("ungroupAll", "Un-Group All");
                            disabled = gos.get("functionsReadOnly") || lockedGroups === -1 || lockedGroups >= (rowGroupColsSvc.columns.length ?? 0);
                            action = ()=>rowGroupColsSvc.setColumns(rowGroupColsSvc.columns.slice(0, lockedGroups), source2);
                        } else if (typeof showRowGroup === "string") {
                            const underlyingColumn = colModel.getColDefCol(showRowGroup);
                            const ungroupByName = underlyingColumn != null ? colNames.getDisplayNameForColumn(underlyingColumn, "header") : showRowGroup;
                            name = localeTextFunc("ungroupBy", "Un-Group by") + " " + ungroupByName;
                            disabled = gos.get("functionsReadOnly") || $5b7ccabde48fae90$var$isRowGroupColLocked(underlyingColumn, beans);
                            action = ()=>{
                                rowGroupColsSvc.removeColumns([
                                    showRowGroup
                                ], source2);
                            };
                        } else {
                            name = localeTextFunc("ungroupBy", "Un-Group by") + " " + colNames.getDisplayNameForColumn(column2, "header");
                            disabled = gos.get("functionsReadOnly") || !column2?.isRowGroupActive() || !column2?.getColDef().enableRowGroup || $5b7ccabde48fae90$var$isRowGroupColLocked(column2, beans);
                            action = ()=>rowGroupColsSvc.removeColumns([
                                    column2
                                ], source2);
                        }
                        return {
                            name: name,
                            disabled: disabled,
                            action: action,
                            icon: (0, $jIDNV._createIconNoSpan)("menuRemoveRowGroup", beans, null)
                        };
                    } else return null;
                case "resetColumns":
                    return {
                        name: localeTextFunc("resetColumns", "Reset Columns"),
                        action: ()=>(0, $jIDNV._resetColumnState)(beans, source2)
                    };
                case "expandAll":
                    return expansionSvc ? {
                        name: localeTextFunc("expandAll", "Expand All Row Groups"),
                        action: ()=>expansionSvc.expandAll(true)
                    } : null;
                case "contractAll":
                    return expansionSvc ? {
                        name: localeTextFunc("collapseAll", "Collapse All Row Groups"),
                        action: ()=>expansionSvc.expandAll(false)
                    } : null;
                case "copy":
                    return clipboardSvc ? {
                        name: localeTextFunc("copy", "Copy"),
                        shortcut: localeTextFunc("ctrlC", "Ctrl+C"),
                        icon: (0, $jIDNV._createIconNoSpan)("clipboardCopy", beans, null),
                        action: ()=>clipboardSvc.copyToClipboard()
                    } : null;
                case "copyWithHeaders":
                    return clipboardSvc ? {
                        name: localeTextFunc("copyWithHeaders", "Copy with Headers"),
                        // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
                        icon: (0, $jIDNV._createIconNoSpan)("clipboardCopy", beans, null),
                        action: ()=>clipboardSvc.copyToClipboard({
                                includeHeaders: true
                            })
                    } : null;
                case "copyWithGroupHeaders":
                    return clipboardSvc ? {
                        name: localeTextFunc("copyWithGroupHeaders", "Copy with Group Headers"),
                        // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
                        icon: (0, $jIDNV._createIconNoSpan)("clipboardCopy", beans, null),
                        action: ()=>clipboardSvc.copyToClipboard({
                                includeHeaders: true,
                                includeGroupHeaders: true
                            })
                    } : null;
                case "cut":
                    if (clipboardSvc) {
                        const focusedCell = focusSvc.getFocusedCell();
                        const rowNode = focusedCell ? (0, $jIDNV._getRowNode)(beans, focusedCell) : null;
                        const isEditable = rowNode ? focusedCell?.column.isCellEditable(rowNode) : false;
                        return {
                            name: localeTextFunc("cut", "Cut"),
                            shortcut: localeTextFunc("ctrlX", "Ctrl+X"),
                            icon: (0, $jIDNV._createIconNoSpan)("clipboardCut", beans, null),
                            disabled: !isEditable || gos.get("suppressCutToClipboard"),
                            action: ()=>clipboardSvc.cutToClipboard(void 0, "contextMenu")
                        };
                    } else return null;
                case "paste":
                    return clipboardSvc ? {
                        name: localeTextFunc("paste", "Paste"),
                        shortcut: localeTextFunc("ctrlV", "Ctrl+V"),
                        disabled: true,
                        icon: (0, $jIDNV._createIconNoSpan)("clipboardPaste", beans, null),
                        action: ()=>clipboardSvc.pasteFromClipboard()
                    } : null;
                case "export":
                    {
                        const exportSubMenuItems = [];
                        if (!gos.get("suppressCsvExport") && csvCreator) exportSubMenuItems.push("csvExport");
                        if (!gos.get("suppressExcelExport") && excelCreator) exportSubMenuItems.push("excelExport");
                        return exportSubMenuItems.length ? {
                            name: localeTextFunc("export", "Export"),
                            subMenu: exportSubMenuItems,
                            icon: (0, $jIDNV._createIconNoSpan)("save", beans, null)
                        } : null;
                    }
                case "csvExport":
                    return csvCreator ? {
                        name: localeTextFunc("csvExport", "CSV Export"),
                        icon: (0, $jIDNV._createIconNoSpan)("csvExport", beans, null),
                        action: ()=>csvCreator.exportDataAsCsv()
                    } : null;
                case "excelExport":
                    return excelCreator ? {
                        name: localeTextFunc("excelExport", "Excel Export"),
                        icon: (0, $jIDNV._createIconNoSpan)("excelExport", beans, null),
                        action: ()=>excelCreator.exportDataAsExcel()
                    } : null;
                case "separator":
                    return key;
                case "pivotChart":
                case "chartRange":
                    return chartMenuItemMapper.getChartItems(key);
                case "columnFilter":
                    return menuSvc && column2 ? {
                        name: localeTextFunc("columnFilter", "Column Filter"),
                        icon: (0, $jIDNV._createIconNoSpan)("filter", beans, null),
                        action: ()=>menuSvc.showFilterMenu({
                                column: column2,
                                buttonElement: sourceElement2(),
                                containerType: "columnFilter",
                                positionBy: "button"
                            })
                    } : null;
                case "columnChooser":
                    {
                        const headerPosition = focusSvc.focusedHeader;
                        return colChooserFactory ? {
                            name: localeTextFunc("columnChooser", "Choose Columns"),
                            icon: (0, $jIDNV._createIconNoSpan)("columns", beans, null),
                            action: ()=>colChooserFactory.showColumnChooser({
                                    column: column2,
                                    eventSource: sourceElement2(),
                                    headerPosition: headerPosition
                                })
                        } : null;
                    }
                case "sortAscending":
                    return sortSvc ? {
                        name: localeTextFunc("sortAscending", "Sort Ascending"),
                        icon: (0, $jIDNV._createIconNoSpan)("sortAscending", beans, null),
                        action: ()=>sortSvc.setSortForColumn(column2, "asc", false, source2)
                    } : null;
                case "sortDescending":
                    return sortSvc ? {
                        name: localeTextFunc("sortDescending", "Sort Descending"),
                        icon: (0, $jIDNV._createIconNoSpan)("sortDescending", beans, null),
                        action: ()=>sortSvc.setSortForColumn(column2, "desc", false, source2)
                    } : null;
                case "sortUnSort":
                    return sortSvc ? {
                        name: localeTextFunc("sortUnSort", "Clear Sort"),
                        icon: (0, $jIDNV._createIconNoSpan)("sortUnSort", beans, null),
                        action: ()=>sortSvc.setSortForColumn(column2, null, false, source2)
                    } : null;
                default:
                    (0, $jIDNV._warn)(176, {
                        key: key
                    });
                    return null;
            }
        };
        originalList.forEach((menuItemOrString)=>{
            let result;
            if (typeof menuItemOrString === "string") result = getStockMenuItem(menuItemOrString, column, sourceElement, source);
            else result = {
                ...menuItemOrString
            };
            if (!result) return;
            const resultDef = result;
            const { subMenu: subMenu } = resultDef;
            if (subMenu && subMenu instanceof Array) resultDef.subMenu = this.mapWithStockItems(subMenu, column, node, sourceElement, source);
            if (result != null) resultList.push(result);
        });
        $5b7ccabde48fae90$var$_removeRepeatsFromArray(resultList, $5b7ccabde48fae90$var$MENU_ITEM_SEPARATOR);
        return resultList;
    }
};
function $5b7ccabde48fae90$var$createAggregationSubMenu(column, aggFuncSvc, valueColsSvc, localeTextFunc) {
    let columnToUse;
    if (column.isPrimary()) columnToUse = column;
    else {
        const pivotValueColumn = column.getColDef().pivotValueColumn;
        columnToUse = (0, $jIDNV._exists)(pivotValueColumn) ? pivotValueColumn : void 0;
    }
    const result = [];
    if (columnToUse) {
        const columnIsAlreadyAggValue = columnToUse.isValueActive();
        const funcNames = aggFuncSvc.getFuncNames(columnToUse);
        result.push({
            name: localeTextFunc("noAggregation", "None"),
            action: ()=>{
                valueColsSvc.removeColumns([
                    columnToUse
                ], "contextMenu");
                valueColsSvc.setColumnAggFunc(columnToUse, void 0, "contextMenu");
            },
            checked: !columnIsAlreadyAggValue
        });
        funcNames.forEach((funcName)=>{
            result.push({
                name: localeTextFunc(funcName, aggFuncSvc.getDefaultFuncLabel(funcName)),
                action: ()=>{
                    valueColsSvc.setColumnAggFunc(columnToUse, funcName, "contextMenu");
                    valueColsSvc.addColumns([
                        columnToUse
                    ], "contextMenu");
                },
                checked: columnIsAlreadyAggValue && columnToUse.getAggFunc() === funcName
            });
        });
    }
    return result;
}
// packages/ag-grid-enterprise/src/menu/columnMenuFactory.ts
var $5b7ccabde48fae90$var$ColumnMenuFactory = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "colMenuFactory";
    }
    createMenu(parent, menuItems, column, sourceElement) {
        const menuList = parent.createManagedBean(new $5b7ccabde48fae90$var$AgMenuList(0, {
            column: column ?? null,
            node: null,
            value: null
        }));
        const menuItemsMapped = this.beans.menuItemMapper.mapWithStockItems(menuItems, column ?? null, null, sourceElement, "columnMenu");
        menuList.addMenuItems(menuItemsMapped);
        return menuList;
    }
    getMenuItems(column = null, columnGroup = null) {
        const defaultItems = this.getDefaultMenuOptions(column);
        let result;
        const columnMainMenuItems = (column?.getColDef() ?? columnGroup?.getColGroupDef())?.mainMenuItems;
        if (Array.isArray(columnMainMenuItems)) result = columnMainMenuItems;
        else if (typeof columnMainMenuItems === "function") result = columnMainMenuItems((0, $jIDNV._addGridCommonParams)(this.gos, {
            column: column,
            columnGroup: columnGroup,
            defaultItems: defaultItems
        }));
        else {
            const userFunc = this.gos.getCallback("getMainMenuItems");
            if (userFunc) result = userFunc({
                column: column,
                columnGroup: columnGroup,
                defaultItems: defaultItems
            });
            else result = defaultItems;
        }
        $5b7ccabde48fae90$var$_removeRepeatsFromArray(result, $5b7ccabde48fae90$var$MENU_ITEM_SEPARATOR);
        return result;
    }
    getDefaultMenuOptions(column) {
        const result = [];
        const { beans: beans, gos: gos } = this;
        const { colChooserFactory: colChooserFactory, rowGroupColsSvc: rowGroupColsSvc, colModel: colModel, expansionSvc: expansionSvc, sortSvc: sortSvc, menuSvc: menuSvc, pinnedCols: pinnedCols, aggFuncSvc: aggFuncSvc, colAutosize: colAutosize } = beans;
        const isLegacyMenuEnabled = (0, $jIDNV._isLegacyMenuEnabled)(gos);
        const addColumnItems = ()=>{
            if (!isLegacyMenuEnabled && colChooserFactory) result.push("columnChooser");
            result.push("resetColumns");
        };
        if (!column) {
            addColumnItems();
            return result;
        }
        const { colDef: colDef } = column;
        const allowPinning = pinnedCols && !colDef.lockPinned;
        const rowGroupCount = rowGroupColsSvc?.columns.length ?? 0;
        const doingGrouping = rowGroupCount > 0;
        const isPrimary = column.isPrimary();
        const allowValueAgg = aggFuncSvc && // if primary, then only allow aggValue if grouping and it's a value columns
        isPrimary && doingGrouping && column.isAllowValue() || // secondary columns can always have aggValue, as it means it's a pivot value column
        !isPrimary;
        if (sortSvc && !isLegacyMenuEnabled && column.isSortable()) {
            const sort = column.getSort();
            if (sort !== "asc") result.push("sortAscending");
            if (sort !== "desc") result.push("sortDescending");
            if (sort) result.push("sortUnSort");
            result.push($5b7ccabde48fae90$var$MENU_ITEM_SEPARATOR);
        }
        if (menuSvc?.isFilterMenuItemEnabled(column)) {
            result.push("columnFilter");
            result.push($5b7ccabde48fae90$var$MENU_ITEM_SEPARATOR);
        }
        if (allowPinning) result.push("pinSubMenu");
        if (allowValueAgg) result.push("valueAggSubMenu");
        if (allowPinning || allowValueAgg) result.push($5b7ccabde48fae90$var$MENU_ITEM_SEPARATOR);
        if (colAutosize) {
            result.push("autoSizeThis");
            result.push("autoSizeAll");
            result.push($5b7ccabde48fae90$var$MENU_ITEM_SEPARATOR);
        }
        if (rowGroupColsSvc && gos.isModuleRegistered("SharedRowGrouping")) {
            const numItems = result.length;
            const showRowGroup = colDef.showRowGroup;
            if (showRowGroup) result.push("rowUnGroup");
            else if (column.isAllowRowGroup() && isPrimary) {
                if (column.isRowGroupActive()) {
                    const groupLocked = $5b7ccabde48fae90$var$isRowGroupColLocked(column, beans);
                    if (!groupLocked) result.push("rowUnGroup");
                } else result.push("rowGroup");
            }
            if (result.length > numItems) result.push($5b7ccabde48fae90$var$MENU_ITEM_SEPARATOR);
        }
        addColumnItems();
        if (expansionSvc && (0, $jIDNV._isClientSideRowModel)(gos) && (gos.get("treeData") || rowGroupCount > (colModel.isPivotMode() ? 1 : 0))) {
            result.push("expandAll");
            result.push("contractAll");
        }
        return result;
    }
};
var $5b7ccabde48fae90$var$CSS_MENU = "ag-menu";
var $5b7ccabde48fae90$var$CSS_CONTEXT_MENU_OPEN = "ag-context-menu-open";
var $5b7ccabde48fae90$var$CSS_CONTEXT_MENU_LOADING_ICON = "ag-context-menu-loading-icon";
var $5b7ccabde48fae90$var$ContextMenuService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "contextMenuSvc";
        this.destroyLoadingSpinner = null;
        this.lastPromise = 0;
    }
    hideActiveMenu() {
        this.destroyBean(this.activeMenu);
    }
    getMenuItems(node, column, value, mouseEvent) {
        const defaultMenuOptions = [];
        const { clipboardSvc: clipboardSvc, chartSvc: chartSvc, csvCreator: csvCreator, excelCreator: excelCreator, colModel: colModel, rangeSvc: rangeSvc, gos: gos } = this.beans;
        if ((0, $jIDNV._exists)(node) && clipboardSvc) {
            if (column) {
                if (!gos.get("suppressCutToClipboard")) defaultMenuOptions.push("cut");
                defaultMenuOptions.push("copy", "copyWithHeaders", "copyWithGroupHeaders", "paste", "separator");
            }
        }
        if (gos.get("enableCharts") && chartSvc) {
            if (colModel.isPivotMode()) defaultMenuOptions.push("pivotChart");
            if (rangeSvc && !rangeSvc.isEmpty()) defaultMenuOptions.push("chartRange");
        }
        if ((0, $jIDNV._exists)(node)) {
            const enableRowPinning = gos.get("enableRowPinning");
            const isRowPinnable = gos.get("isRowPinnable");
            if (enableRowPinning) {
                const isGroupTotalRow = node.level > -1 && node.footer;
                const isGrandTotalRow = node.level === -1 && node.footer;
                const grandTotalRow = (0, $jIDNV._getGrandTotalRow)(gos);
                const isGrandTotalRowFixed = grandTotalRow === "pinnedBottom" || grandTotalRow === "pinnedTop";
                if (isGrandTotalRow && !isGrandTotalRowFixed || !isGrandTotalRow && !isGroupTotalRow) {
                    const pinnable = isRowPinnable?.(node) ?? true;
                    if (pinnable) defaultMenuOptions.push("pinRowSubMenu");
                }
            }
            const suppressExcel = gos.get("suppressExcelExport") || !excelCreator;
            const suppressCsv = gos.get("suppressCsvExport") || !csvCreator;
            const onIPad = (0, $jIDNV._isIOSUserAgent)();
            const anyExport = !onIPad && (!suppressExcel || !suppressCsv);
            if (anyExport) defaultMenuOptions.push("export");
        }
        const defaultItems = defaultMenuOptions.length ? defaultMenuOptions : void 0;
        const columnContextMenuItems = column?.getColDef().contextMenuItems;
        if (Array.isArray(columnContextMenuItems)) return columnContextMenuItems;
        if (typeof columnContextMenuItems === "function") return columnContextMenuItems((0, $jIDNV._addGridCommonParams)(gos, {
            column: column,
            node: node,
            value: value,
            defaultItems: defaultItems,
            event: mouseEvent
        }));
        const userFunc = gos.getCallback("getContextMenuItems");
        return userFunc?.({
            column: column,
            node: node,
            value: value,
            defaultItems: defaultItems,
            event: mouseEvent
        }) ?? defaultMenuOptions;
    }
    getContextMenuPosition(rowNode, column) {
        const rowCtrl = this.getRowCtrl(rowNode);
        const eGui = this.getCellGui(rowCtrl, column);
        if (!eGui) return {
            x: 0,
            y: rowCtrl?.getRowYPosition() ?? 0
        };
        const rect = eGui.getBoundingClientRect();
        return {
            x: rect.x + rect.width / 2,
            y: rect.y + rect.height / 2
        };
    }
    showContextMenu(params) {
        const rowNode = params.rowNode ?? null;
        const column = params.column ?? null;
        let { anchorToElement: anchorToElement, value: value, source: source } = params;
        if (rowNode && column && value == null) value = this.beans.valueSvc.getValueForDisplay(column, rowNode).value;
        if (anchorToElement == null) anchorToElement = this.getContextMenuAnchorElement(rowNode, column);
        this.beans.menuUtils.onContextMenu({
            mouseEvent: params.mouseEvent ?? null,
            touchEvent: params.touchEvent ?? null,
            showMenuCallback: (eventOrTouch)=>this.showMenu(rowNode, column, value, eventOrTouch, anchorToElement),
            source: source
        });
    }
    handleContextMenuMouseEvent(mouseEvent, touchEvent, rowCtrl, cellCtrl) {
        const rowNode = cellCtrl?.rowNode ?? rowCtrl?.rowNode ?? null;
        const column = cellCtrl?.column ?? rowCtrl?.findFullWidthInfoForEvent(mouseEvent || touchEvent)?.column ?? null;
        const { valueSvc: valueSvc, ctrlsSvc: ctrlsSvc } = this.beans;
        const value = column ? valueSvc.getValue(column, rowNode) : null;
        const gridBodyCon = ctrlsSvc.getGridBodyCtrl();
        const anchorToElement = cellCtrl ? cellCtrl.eGui : gridBodyCon.eGridBody;
        this.showContextMenu({
            mouseEvent: mouseEvent,
            touchEvent: touchEvent,
            rowNode: rowNode,
            column: column,
            value: value,
            anchorToElement: anchorToElement,
            source: "ui"
        });
    }
    showMenu(node, column, value, mouseEvent, anchorToElement) {
        const menuItems = this.getMenuItems(node, column, value, mouseEvent);
        if ((0, $jIDNV._isPromise)(menuItems)) {
            const currentPromise = this.lastPromise + 1;
            this.lastPromise = currentPromise;
            if (!this.destroyLoadingSpinner) this.createLoadingIcon(mouseEvent);
            menuItems.then((menuItems2)=>{
                if (this.lastPromise !== currentPromise) return;
                const { target: target } = mouseEvent;
                const isFromFakeEvent = !target;
                const shouldShowMenu = // check if there are actual menu items to be displayed
                menuItems2 && menuItems2.length && // check if the element that triggered the context menu was removed from the DOM
                (isFromFakeEvent || (0, $jIDNV._isVisible)(target)) && // overlay was displayed
                !this.beans.overlays?.isExclusive();
                if (shouldShowMenu) this.createContextMenu({
                    menuItems: menuItems2,
                    node: node,
                    column: column,
                    value: value,
                    mouseEvent: mouseEvent,
                    anchorToElement: anchorToElement
                });
                this.destroyLoadingSpinner?.();
            });
            return true;
        }
        if (menuItems === void 0 || !menuItems?.length) return false;
        this.createContextMenu({
            menuItems: menuItems,
            node: node,
            column: column,
            value: value,
            mouseEvent: mouseEvent,
            anchorToElement: anchorToElement
        });
        return true;
    }
    createLoadingIcon(mouseEvent) {
        const { beans: beans } = this;
        const translate = this.getLocaleTextFunc();
        const loadingIcon = (0, $jIDNV._createIconNoSpan)("loadingMenuItems", beans);
        const wrapperEl = (0, $jIDNV._createElement)({
            tag: "div",
            cls: $5b7ccabde48fae90$var$CSS_CONTEXT_MENU_LOADING_ICON
        });
        wrapperEl.appendChild(loadingIcon);
        const rootNode = (0, $jIDNV._getRootNode)(beans);
        const targetEl = (0, $jIDNV._getPageBody)(beans);
        if (!targetEl) {
            (0, $jIDNV._warn)(54);
            return;
        }
        targetEl.appendChild(wrapperEl);
        beans.ariaAnnounce?.announceValue(translate("ariaLabelLoadingContextMenu", "Loading Context Menu"), "contextmenu");
        beans.environment.applyThemeClasses(wrapperEl);
        (0, $jIDNV._anchorElementToMouseMoveEvent)(wrapperEl, mouseEvent, beans);
        const mouseMoveCallback = (e)=>{
            (0, $jIDNV._anchorElementToMouseMoveEvent)(wrapperEl, e, beans);
        };
        rootNode.addEventListener("mousemove", mouseMoveCallback);
        this.destroyLoadingSpinner = ()=>{
            rootNode.removeEventListener("mousemove", mouseMoveCallback);
            targetEl.removeChild(wrapperEl);
            this.destroyLoadingSpinner = null;
        };
    }
    createContextMenu(params) {
        const { menuItems: menuItems, node: node, column: column, value: value, mouseEvent: mouseEvent, anchorToElement: anchorToElement } = params;
        const { ctrlsSvc: ctrlsSvc, focusSvc: focusSvc, popupSvc: popupSvc } = this.beans;
        const eGridBodyGui = ctrlsSvc.getGridBodyCtrl().eGridBody;
        const menu = new $5b7ccabde48fae90$var$ContextMenu(menuItems, column, node, value);
        this.createBean(menu);
        const eMenuGui = menu.getGui();
        if (!column) focusSvc.clearFocusedCell();
        const positionParams = {
            column: column,
            rowNode: node,
            type: "contextMenu",
            mouseEvent: mouseEvent,
            ePopup: eMenuGui,
            // move one pixel away so that accidentally double clicking
            // won't show the browser's contextmenu
            nudgeY: 1
        };
        const translate = this.getLocaleTextFunc();
        const addPopupRes = popupSvc?.addPopup({
            modal: true,
            eChild: eMenuGui,
            closeOnEsc: true,
            closedCallback: (e)=>{
                (0, $jIDNV._preserveRangesWhile)(this.beans, ()=>{
                    eGridBodyGui.classList.remove($5b7ccabde48fae90$var$CSS_CONTEXT_MENU_OPEN);
                    this.destroyBean(menu);
                    this.dispatchVisibleChangedEvent(false, e === void 0 ? "api" : "ui");
                });
            },
            click: mouseEvent,
            positionCallback: ()=>{
                const isRtl = this.gos.get("enableRtl");
                popupSvc?.positionPopupUnderMouseEvent({
                    ...positionParams,
                    nudgeX: isRtl ? (eMenuGui.offsetWidth + 1) * -1 : 1
                });
            },
            anchorToElement: // so when browser is scrolled down, or grid is scrolled, context menu stays with cell
            anchorToElement,
            ariaLabel: translate("ariaLabelContextMenu", "Context Menu")
        });
        if (addPopupRes) {
            eGridBodyGui.classList.add($5b7ccabde48fae90$var$CSS_CONTEXT_MENU_OPEN);
            menu.afterGuiAttached({
                container: "contextMenu",
                hidePopup: addPopupRes.hideFunc
            });
        }
        if (this.activeMenu) this.hideActiveMenu();
        this.activeMenu = menu;
        menu.addEventListener("destroyed", ()=>{
            if (this.activeMenu === menu) this.activeMenu = null;
        });
        if (addPopupRes) menu.addEventListener("closeMenu", (e)=>addPopupRes.hideFunc({
                mouseEvent: e.mouseEvent ?? void 0,
                keyboardEvent: e.keyboardEvent ?? void 0,
                forceHide: true
            }));
        const isApi = mouseEvent && mouseEvent instanceof MouseEvent && mouseEvent.type === "mousedown";
        this.dispatchVisibleChangedEvent(true, isApi ? "api" : "ui");
    }
    dispatchVisibleChangedEvent(visible, source = "ui") {
        this.eventSvc.dispatchEvent({
            type: "contextMenuVisibleChanged",
            visible: visible,
            source: source
        });
    }
    getRowCtrl(rowNode) {
        const { rowIndex: rowIndex, rowPinned: rowPinned } = rowNode || {};
        if (rowIndex == null) return;
        return this.beans.rowRenderer.getRowByPosition({
            rowIndex: rowIndex,
            rowPinned: rowPinned
        }) || void 0;
    }
    getCellGui(rowCtrl, column) {
        if (!rowCtrl || !column) return;
        const cellCtrl = rowCtrl.getCellCtrl(column);
        return cellCtrl?.eGui || void 0;
    }
    getContextMenuAnchorElement(rowNode, column) {
        const gridBodyEl = this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody;
        const rowCtrl = this.getRowCtrl(rowNode);
        if (!rowCtrl) return gridBodyEl;
        const cellGui = this.getCellGui(rowCtrl, column);
        if (cellGui) return cellGui;
        if (rowCtrl.isFullWidth()) return rowCtrl.getFullWidthElement();
        return gridBodyEl;
    }
    destroy() {
        this.destroyLoadingSpinner?.();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$ContextMenu = class extends (0, $jIDNV.Component) {
    constructor(menuItems, column, node, value){
        super({
            tag: "div",
            cls: $5b7ccabde48fae90$var$CSS_MENU,
            role: "presentation"
        });
        this.menuItems = menuItems;
        this.column = column;
        this.node = node;
        this.value = value;
        this.menuList = null;
        this.focusedCell = null;
    }
    postConstruct() {
        const menuList = this.createManagedBean(new $5b7ccabde48fae90$var$AgMenuList(0, {
            column: this.column,
            node: this.node,
            value: this.value
        }));
        const menuItemsMapped = this.beans.menuItemMapper.mapWithStockItems(this.menuItems, this.column, this.node, ()=>this.getGui(), "contextMenu");
        menuList.addMenuItems(menuItemsMapped);
        this.appendChild(menuList);
        this.menuList = menuList;
        menuList.addEventListener("closeMenu", (e)=>this.dispatchLocalEvent(e));
    }
    afterGuiAttached({ hidePopup: hidePopup }) {
        if (hidePopup) this.addDestroyFunc(hidePopup);
        this.focusedCell = this.beans.focusSvc.getFocusedCell();
        const menuList = this.menuList;
        if (menuList) (0, $jIDNV._preserveRangesWhile)(this.beans, ()=>(0, $jIDNV._focusInto)(menuList.getGui()));
    }
    restoreFocusedCell() {
        const { beans: beans, focusedCell: focusedCell } = this;
        const focusSvc = beans.focusSvc;
        const currentFocusedCell = focusSvc.getFocusedCell();
        if (currentFocusedCell && focusedCell && (0, $jIDNV._areCellsEqual)(currentFocusedCell, focusedCell)) {
            const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = focusedCell;
            if ((0, $jIDNV._isNothingFocused)(beans)) focusSvc.setFocusedCell({
                rowIndex: rowIndex,
                column: column,
                rowPinned: rowPinned,
                forceBrowserFocus: true,
                preventScrollOnBrowserFocus: !(0, $jIDNV._isKeyboardMode)()
            });
        }
    }
    destroy() {
        super.destroy();
        this.restoreFocusedCell();
    }
};
function $5b7ccabde48fae90$var$getTabbedLayoutTemplate(cssClass) {
    return {
        tag: "div",
        cls: `ag-tabs ${cssClass}`,
        children: [
            {
                tag: "div",
                ref: "eHeader"
            },
            {
                tag: "div",
                ref: "eBody",
                role: "presentation",
                cls: `ag-tabs-body ${cssClass ? `${cssClass}-body` : ""}`
            }
        ]
    };
}
var $5b7ccabde48fae90$var$TabbedLayout = class extends (0, $jIDNV.TabGuardComp) {
    constructor(params){
        super($5b7ccabde48fae90$var$getTabbedLayoutTemplate(params.cssClass));
        this.eHeader = (0, $jIDNV.RefPlaceholder);
        this.eBody = (0, $jIDNV.RefPlaceholder);
        this.items = [];
        this.tabbedItemScrollMap = /* @__PURE__ */ new Map();
        this.params = params;
    }
    postConstruct() {
        this.setupHeader();
        if (this.params.items) this.params.items.forEach((item)=>this.addItem(item));
        this.initialiseTabGuard({
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this),
            focusInnerElement: this.focusInnerElement.bind(this),
            focusTrapActive: true
        });
        this.addDestroyFunc(()=>this.activeItem?.tabbedItem?.afterDetachedCallback?.());
    }
    setupHeader() {
        const { enableCloseButton: enableCloseButton, cssClass: cssClass } = this.params;
        const addCssClasses = (el, suffix)=>{
            el.classList.add(`ag-tabs-${suffix}`);
            if (cssClass) el.classList.add(`${cssClass}-${suffix}`);
        };
        if (enableCloseButton) {
            this.setupCloseButton(addCssClasses);
            this.eTabHeader = (0, $jIDNV._createElement)({
                tag: "div",
                role: "presentation"
            });
            addCssClasses(this.eHeader, "header-wrapper");
            this.eHeader.appendChild(this.eTabHeader);
        } else this.eTabHeader = this.eHeader;
        (0, $jIDNV._setAriaRole)(this.eTabHeader, "tablist");
        addCssClasses(this.eTabHeader, "header");
    }
    setupCloseButton(addCssClasses) {
        const eCloseButton = (0, $jIDNV._createElement)({
            tag: "button"
        });
        addCssClasses(eCloseButton, "close-button");
        const eIcon = (0, $jIDNV._createIconNoSpan)("close", this.beans);
        (0, $jIDNV._setAriaLabel)(eCloseButton, this.params.closeButtonAriaLabel);
        eCloseButton.appendChild(eIcon);
        this.addManagedElementListeners(eCloseButton, {
            click: ()=>this.params.onCloseClicked?.()
        });
        const eCloseButtonWrapper = (0, $jIDNV._createElement)({
            tag: "div",
            role: "presentation"
        });
        addCssClasses(eCloseButtonWrapper, "close-button-wrapper");
        eCloseButtonWrapper.appendChild(eCloseButton);
        this.eHeader.appendChild(eCloseButtonWrapper);
        this.eCloseButton = eCloseButton;
    }
    handleKeyDown(e) {
        switch(e.key){
            case (0, $jIDNV.KeyCode).RIGHT:
            case (0, $jIDNV.KeyCode).LEFT:
                {
                    if (!this.eTabHeader.contains((0, $jIDNV._getActiveDomElement)(this.beans))) return;
                    const isRightKey = e.key === (0, $jIDNV.KeyCode).RIGHT;
                    const isRtl = this.gos.get("enableRtl");
                    const currentPosition = this.items.indexOf(this.activeItem);
                    const nextPosition = isRightKey !== isRtl ? Math.min(currentPosition + 1, this.items.length - 1) : Math.max(currentPosition - 1, 0);
                    if (currentPosition === nextPosition) return;
                    e.preventDefault();
                    const nextItem = this.items[nextPosition];
                    this.showItemWrapper(nextItem);
                    nextItem.eHeaderButton.focus();
                    break;
                }
            case (0, $jIDNV.KeyCode).UP:
            case (0, $jIDNV.KeyCode).DOWN:
                e.stopPropagation();
                break;
        }
    }
    onTabKeyDown(e) {
        if (e.defaultPrevented) return;
        const { beans: beans, eHeader: eHeader, eBody: eBody, activeItem: activeItem, params: params } = this;
        const { suppressTrapFocus: suppressTrapFocus, enableCloseButton: enableCloseButton } = params;
        const activeElement = (0, $jIDNV._getActiveDomElement)(beans);
        const target = e.target;
        const backwards = e.shiftKey;
        if (eHeader.contains(activeElement)) {
            e.preventDefault();
            if (enableCloseButton && backwards && !this.eCloseButton?.contains(activeElement)) this.eCloseButton?.focus();
            else if (suppressTrapFocus && backwards) $5b7ccabde48fae90$var$findFocusableElementBeforeTabGuard((0, $jIDNV._getDocument)(beans).body, target)?.focus();
            else this.focusBody(e.shiftKey);
            return;
        }
        let nextEl = null;
        if ($5b7ccabde48fae90$var$isTargetUnderManagedComponent(eBody, target)) {
            if (backwards) nextEl = $5b7ccabde48fae90$var$findFocusableElementBeforeTabGuard(eBody, target);
            if (!nextEl && !suppressTrapFocus) nextEl = activeItem.eHeaderButton;
        }
        if (!nextEl && eBody.contains(activeElement)) {
            nextEl = (0, $jIDNV._findNextFocusableElement)(beans, eBody, false, backwards);
            if (!nextEl) {
                if (suppressTrapFocus && !backwards) this.forceFocusOutOfContainer(backwards);
                else if (enableCloseButton && !backwards) {
                    e.preventDefault();
                    this.eCloseButton?.focus();
                } else {
                    e.preventDefault();
                    this.focusHeader();
                }
                return;
            }
        }
        if (nextEl) {
            e.preventDefault();
            nextEl.focus();
        }
    }
    focusInnerElement(fromBottom) {
        if (fromBottom) return this.focusBody(true);
        else {
            this.focusHeader();
            return true;
        }
    }
    focusHeader(preventScroll) {
        this.activeItem.eHeaderButton.focus({
            preventScroll: preventScroll
        });
    }
    focusBody(fromBottom) {
        return (0, $jIDNV._focusInto)(this.eBody, fromBottom);
    }
    setAfterAttachedParams(params) {
        this.afterAttachedParams = params;
    }
    showFirstItem() {
        if (this.items.length > 0) this.showItemWrapper(this.items[0]);
    }
    addItem(item) {
        const eHeaderButton = (0, $jIDNV._createElement)({
            tag: "span",
            cls: "ag-tab",
            role: "tab",
            attrs: {
                tabindex: "-1"
            }
        });
        eHeaderButton.appendChild(item.title);
        this.eTabHeader.appendChild(eHeaderButton);
        (0, $jIDNV._setAriaLabel)(eHeaderButton, item.titleLabel);
        const wrapper = {
            tabbedItem: item,
            eHeaderButton: eHeaderButton
        };
        this.items.push(wrapper);
        eHeaderButton.addEventListener("click", this.showItemWrapper.bind(this, wrapper));
    }
    showItem(tabbedItem) {
        const itemWrapper = this.items.find((wrapper)=>wrapper.tabbedItem === tabbedItem);
        if (itemWrapper) this.showItemWrapper(itemWrapper);
    }
    showItemWrapper(wrapper) {
        const { tabbedItem: tabbedItem, eHeaderButton: eHeaderButton } = wrapper;
        this.params.onItemClicked?.({
            item: tabbedItem
        });
        if (this.activeItem === wrapper) {
            this.params.onActiveItemClicked?.();
            return;
        }
        if (this.lastScrollListener) this.lastScrollListener = this.lastScrollListener();
        (0, $jIDNV._clearElement)(this.eBody);
        tabbedItem.bodyPromise.then((body)=>{
            this.eBody.appendChild(body);
            const onlyUnmanaged = !(0, $jIDNV._isKeyboardMode)();
            if (!this.params.suppressFocusBodyOnOpen) (0, $jIDNV._focusInto)(this.eBody, false, onlyUnmanaged);
            if (tabbedItem.afterAttachedCallback) tabbedItem.afterAttachedCallback(this.afterAttachedParams);
            if (this.params.keepScrollPosition) {
                const scrollableContainer = tabbedItem.getScrollableContainer && tabbedItem.getScrollableContainer() || body;
                [this.lastScrollListener] = this.addManagedElementListeners(scrollableContainer, {
                    scroll: ()=>{
                        this.tabbedItemScrollMap.set(tabbedItem.name, scrollableContainer.scrollTop);
                    }
                });
                const scrollPosition = this.tabbedItemScrollMap.get(tabbedItem.name);
                if (scrollPosition !== void 0) setTimeout(()=>{
                    scrollableContainer.scrollTop = scrollPosition;
                }, 0);
            }
        });
        if (this.activeItem) {
            this.activeItem.eHeaderButton.classList.remove("ag-tab-selected");
            this.activeItem.tabbedItem.afterDetachedCallback?.();
        }
        eHeaderButton.classList.add("ag-tab-selected");
        this.activeItem = wrapper;
    }
};
// packages/ag-grid-enterprise/src/menu/enterpriseMenu.ts
var $5b7ccabde48fae90$var$TAB_FILTER = "filterMenuTab";
var $5b7ccabde48fae90$var$TAB_GENERAL = "generalMenuTab";
var $5b7ccabde48fae90$var$TAB_COLUMNS = "columnsMenuTab";
var $5b7ccabde48fae90$var$TABS_DEFAULT = [
    $5b7ccabde48fae90$var$TAB_GENERAL,
    $5b7ccabde48fae90$var$TAB_FILTER,
    $5b7ccabde48fae90$var$TAB_COLUMNS
];
var $5b7ccabde48fae90$var$EnterpriseMenuFactory = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "enterpriseMenuFactory";
    }
    hideActiveMenu() {
        this.destroyBean(this.activeMenu);
    }
    showMenuAfterMouseEvent(columnOrGroup, mouseEvent, containerType, onClosedCallback, filtersOnly) {
        const { column: column, columnGroup: columnGroup } = this.splitColumnOrGroup(columnOrGroup);
        const defaultTab = filtersOnly ? "filterMenuTab" : void 0;
        this.showMenu(column, columnGroup, (menu)=>{
            const ePopup = menu.getGui();
            this.beans.popupSvc.positionPopupUnderMouseEvent({
                type: containerType,
                column: column,
                mouseEvent: mouseEvent,
                ePopup: ePopup
            });
            if (defaultTab) menu.showTab?.(defaultTab);
            this.dispatchVisibleChangedEvent(true, false, column, columnGroup, defaultTab);
        }, containerType, defaultTab, void 0, mouseEvent.target, onClosedCallback);
    }
    splitColumnOrGroup(columnOrGroup) {
        const colIsColumn = columnOrGroup && (0, $jIDNV.isColumn)(columnOrGroup);
        const column = colIsColumn ? columnOrGroup : void 0;
        const columnGroup = colIsColumn ? void 0 : columnOrGroup;
        return {
            column: column,
            columnGroup: columnGroup
        };
    }
    showMenuAfterButtonClick(columnOrGroup, eventSource, containerType, onClosedCallback, filtersOnly) {
        let multiplier = -1;
        let alignSide = "left";
        if (this.gos.get("enableRtl")) {
            multiplier = 1;
            alignSide = "right";
        }
        const defaultTab = filtersOnly ? "filterMenuTab" : void 0;
        const restrictToTabs = defaultTab ? [
            defaultTab
        ] : void 0;
        const isLegacyMenuEnabled = (0, $jIDNV._isLegacyMenuEnabled)(this.gos);
        const nudgeX = (isLegacyMenuEnabled ? 9 : 4) * multiplier;
        const nudgeY = isLegacyMenuEnabled ? -23 : 4;
        const { column: column, columnGroup: columnGroup } = this.splitColumnOrGroup(columnOrGroup);
        this.showMenu(column, columnGroup, (menu)=>{
            const ePopup = menu.getGui();
            this.beans.popupSvc.positionPopupByComponent({
                type: containerType,
                column: column,
                eventSource: eventSource,
                ePopup: ePopup,
                alignSide: alignSide,
                nudgeX: nudgeX,
                nudgeY: nudgeY,
                position: "under",
                keepWithinBounds: true
            });
            if (defaultTab) menu.showTab?.(defaultTab);
            this.dispatchVisibleChangedEvent(true, false, column, columnGroup, defaultTab);
        }, containerType, defaultTab, restrictToTabs, eventSource, onClosedCallback);
    }
    showMenu(column, columnGroup, positionCallback, containerType, defaultTab, restrictToTabs, eventSource, onClosedCallback) {
        const menuParams = this.getMenuParams(column, columnGroup, restrictToTabs, eventSource);
        if (!menuParams) return;
        const { menu: menu, eMenuGui: eMenuGui, anchorToElement: anchorToElement, restoreFocusParams: restoreFocusParams } = menuParams;
        const closedFuncs = [];
        const { menuUtils: menuUtils, popupSvc: popupSvc } = this.beans;
        closedFuncs.push((e)=>{
            const eComp = menu.getGui();
            this.destroyBean(menu);
            if (column) {
                (0, $jIDNV._setColMenuVisible)(column, false, "contextMenu");
                menuUtils.restoreFocusOnClose(restoreFocusParams, eComp, e);
            }
            onClosedCallback?.();
        });
        const translate = this.getLocaleTextFunc();
        popupSvc.addPopup({
            modal: true,
            eChild: eMenuGui,
            closeOnEsc: true,
            closedCallback: (e)=>{
                closedFuncs.forEach((f)=>f(e));
                this.dispatchVisibleChangedEvent(false, false, column, columnGroup, defaultTab);
            },
            afterGuiAttached: (params)=>menu.afterGuiAttached(Object.assign({}, {
                    container: containerType
                }, params)),
            // if defaultTab is not present, positionCallback will be called
            // after `showTabBasedOnPreviousSelection` is called.
            positionCallback: defaultTab ? ()=>positionCallback(menu) : void 0,
            ariaLabel: translate("ariaLabelColumnMenu", "Column Menu")
        });
        if (!defaultTab) {
            menu.showTabBasedOnPreviousSelection?.();
            positionCallback(menu);
        }
        if ((0, $jIDNV._isColumnMenuAnchoringEnabled)(this.gos)) {
            const stopAnchoringPromise = popupSvc.setPopupPositionRelatedToElement(eMenuGui, anchorToElement);
            if (stopAnchoringPromise && column) this.addStopAnchoring(stopAnchoringPromise, column, closedFuncs);
        }
        menu.addEventListener("tabSelected", (event)=>{
            this.dispatchVisibleChangedEvent(false, true, column);
            this.lastSelectedTab = event.key;
            this.dispatchVisibleChangedEvent(true, true, column);
        });
        if (column) (0, $jIDNV._setColMenuVisible)(column, true, "contextMenu");
        this.activeMenu = menu;
        menu.addEventListener("destroyed", ()=>{
            if (this.activeMenu === menu) this.activeMenu = null;
        });
    }
    addStopAnchoring(stopAnchoringPromise, column, closedFuncsArr) {
        stopAnchoringPromise.then((stopAnchoringFunc)=>{
            column.__addEventListener("leftChanged", stopAnchoringFunc);
            column.__addEventListener("visibleChanged", stopAnchoringFunc);
            closedFuncsArr.push(()=>{
                column.__removeEventListener("leftChanged", stopAnchoringFunc);
                column.__removeEventListener("visibleChanged", stopAnchoringFunc);
            });
        });
    }
    getMenuParams(column, columnGroup, restrictToTabs, eventSource) {
        const { focusSvc: focusSvc, visibleCols: visibleCols, ctrlsSvc: ctrlsSvc } = this.beans;
        const restoreFocusParams = {
            column: column,
            headerPosition: focusSvc.focusedHeader,
            columnIndex: visibleCols.allCols.indexOf(column),
            eventSource: eventSource
        };
        const menu = this.createMenu(column, columnGroup, restoreFocusParams, restrictToTabs, eventSource);
        return menu ? {
            menu: menu,
            eMenuGui: menu.getGui(),
            anchorToElement: eventSource || ctrlsSvc.getGridBodyCtrl().eGridBody,
            restoreFocusParams: restoreFocusParams
        } : void 0;
    }
    createMenu(column, columnGroup, restoreFocusParams, restrictToTabs, eventSource) {
        if ((0, $jIDNV._isLegacyMenuEnabled)(this.gos)) return this.createBean(new $5b7ccabde48fae90$var$TabbedColumnMenu(column, restoreFocusParams, this.lastSelectedTab, restrictToTabs, eventSource));
        else {
            const menuItems = this.beans.colMenuFactory.getMenuItems(column, columnGroup);
            return menuItems.length ? this.createBean(new $5b7ccabde48fae90$var$ColumnContextMenu(menuItems, column, restoreFocusParams, eventSource)) : void 0;
        }
    }
    dispatchVisibleChangedEvent(visible, switchingTab, column, columnGroup, defaultTab) {
        this.eventSvc.dispatchEvent({
            type: "columnMenuVisibleChanged",
            visible: visible,
            switchingTab: switchingTab,
            key: this.lastSelectedTab ?? defaultTab ?? ((0, $jIDNV._isLegacyMenuEnabled)(this.gos) ? $5b7ccabde48fae90$var$TAB_GENERAL : "columnMenu"),
            column: column ?? null,
            columnGroup: columnGroup ?? null
        });
    }
    isMenuEnabled(column) {
        if (!(0, $jIDNV._isLegacyMenuEnabled)(this.gos)) return true;
        const isFilterDisabled = !this.beans.filterManager?.isFilterAllowed(column);
        const tabs = column.getColDef().menuTabs ?? $5b7ccabde48fae90$var$TABS_DEFAULT;
        const numActiveTabs = isFilterDisabled && tabs.includes($5b7ccabde48fae90$var$TAB_FILTER) ? tabs.length - 1 : tabs.length;
        return numActiveTabs > 0;
    }
    showMenuAfterContextMenuEvent(column, mouseEvent, touchEvent) {
        this.beans.menuUtils.onContextMenu({
            mouseEvent: mouseEvent,
            touchEvent: touchEvent,
            source: "ui",
            showMenuCallback: (eventOrTouch)=>{
                this.showMenuAfterMouseEvent(column, eventOrTouch, "columnMenu");
                return true;
            }
        });
    }
};
var $5b7ccabde48fae90$var$TabbedColumnMenu = class extends (0, $jIDNV.BeanStub) {
    constructor(column, restoreFocusParams, initialSelection, restrictTo, sourceElement){
        super();
        this.column = column;
        this.restoreFocusParams = restoreFocusParams;
        this.initialSelection = initialSelection;
        this.restrictTo = restrictTo;
        this.sourceElement = sourceElement;
        this.tabFactories = {};
        this.includeChecks = {};
        const { tabFactories: tabFactories, includeChecks: includeChecks } = this;
        tabFactories[$5b7ccabde48fae90$var$TAB_GENERAL] = this.createMainPanel.bind(this);
        tabFactories[$5b7ccabde48fae90$var$TAB_FILTER] = this.createFilterPanel.bind(this);
        tabFactories[$5b7ccabde48fae90$var$TAB_COLUMNS] = this.createColumnsPanel.bind(this);
        includeChecks[$5b7ccabde48fae90$var$TAB_GENERAL] = ()=>true;
        includeChecks[$5b7ccabde48fae90$var$TAB_FILTER] = ()=>column ? !!this.beans.filterManager?.isFilterAllowed(column) : false;
        includeChecks[$5b7ccabde48fae90$var$TAB_COLUMNS] = ()=>true;
    }
    postConstruct() {
        const tabs = this.getTabsToCreate().map((name)=>this.createTab(name));
        const tabbedLayout = new $5b7ccabde48fae90$var$TabbedLayout({
            items: tabs,
            cssClass: "ag-menu",
            onActiveItemClicked: this.onHidePopup.bind(this),
            onItemClicked: this.onTabItemClicked.bind(this)
        });
        this.tabbedLayout = this.createBean(tabbedLayout);
        this.mainMenuList?.setParentComponent(tabbedLayout);
        this.addDestroyFunc(()=>this.destroyBean(tabbedLayout));
    }
    getTabsToCreate() {
        if (this.restrictTo) return this.restrictTo;
        return (this.column?.getColDef().menuTabs ?? $5b7ccabde48fae90$var$TABS_DEFAULT).filter((tabName)=>this.isValidMenuTabItem(tabName) && this.isNotSuppressed(tabName));
    }
    isValidMenuTabItem(menuTabName) {
        let isValid = true;
        let itemsToConsider = $5b7ccabde48fae90$var$TABS_DEFAULT;
        if (this.restrictTo != null) {
            isValid = this.restrictTo.indexOf(menuTabName) > -1;
            itemsToConsider = this.restrictTo;
        }
        isValid = isValid && $5b7ccabde48fae90$var$TABS_DEFAULT.indexOf(menuTabName) > -1;
        if (!isValid) (0, $jIDNV._warn)(175, {
            menuTabName: menuTabName,
            itemsToConsider: itemsToConsider
        });
        return isValid;
    }
    isNotSuppressed(menuTabName) {
        return this.includeChecks[menuTabName]();
    }
    createTab(name) {
        return this.tabFactories[name]();
    }
    showTabBasedOnPreviousSelection() {
        this.showTab(this.initialSelection);
    }
    showTab(toShow) {
        const { tabItemColumns: tabItemColumns, tabbedLayout: tabbedLayout, tabItemFilter: tabItemFilter, tabItemGeneral: tabItemGeneral } = this;
        if (tabItemColumns && toShow === $5b7ccabde48fae90$var$TAB_COLUMNS) tabbedLayout.showItem(tabItemColumns);
        else if (tabItemFilter && toShow === $5b7ccabde48fae90$var$TAB_FILTER) tabbedLayout.showItem(tabItemFilter);
        else if (tabItemGeneral && toShow === $5b7ccabde48fae90$var$TAB_GENERAL) tabbedLayout.showItem(tabItemGeneral);
        else tabbedLayout.showFirstItem();
    }
    onTabItemClicked(event) {
        let key = null;
        switch(event.item){
            case this.tabItemColumns:
                key = $5b7ccabde48fae90$var$TAB_COLUMNS;
                break;
            case this.tabItemFilter:
                key = $5b7ccabde48fae90$var$TAB_FILTER;
                break;
            case this.tabItemGeneral:
                key = $5b7ccabde48fae90$var$TAB_GENERAL;
                break;
        }
        if (key) this.activateTab(key);
    }
    activateTab(tab) {
        const ev = {
            type: "tabSelected",
            key: tab
        };
        this.dispatchLocalEvent(ev);
    }
    createMainPanel() {
        const { beans: beans, column: column } = this;
        const colMenuFactory = beans.colMenuFactory;
        const mainMenuList = colMenuFactory.createMenu(this, colMenuFactory.getMenuItems(column), this.column, ()=>this.sourceElement ?? this.getGui());
        this.mainMenuList = mainMenuList;
        mainMenuList.addEventListener("closeMenu", this.onHidePopup.bind(this));
        const tabItemGeneral = {
            title: (0, $jIDNV._createIconNoSpan)("legacyMenu", beans, column),
            titleLabel: $5b7ccabde48fae90$var$TAB_GENERAL.replace("MenuTab", ""),
            bodyPromise: (0, $jIDNV.AgPromise).resolve(mainMenuList.getGui()),
            name: $5b7ccabde48fae90$var$TAB_GENERAL
        };
        this.tabItemGeneral = tabItemGeneral;
        return tabItemGeneral;
    }
    onHidePopup(event) {
        this.beans.menuUtils.closePopupAndRestoreFocusOnSelect(this.hidePopupFunc, this.restoreFocusParams, event);
    }
    createFilterPanel() {
        const comp = this.column ? this.createBean(new (0, $jIDNV.FilterComp)(this.column, "COLUMN_MENU")) : null;
        this.filterComp = comp;
        if (!comp?.hasFilter()) (0, $jIDNV._error)(119);
        const afterAttachedCallback = (params)=>comp?.afterGuiAttached(params);
        const afterDetachedCallback = ()=>comp?.afterGuiDetached();
        this.tabItemFilter = {
            title: (0, $jIDNV._createIconNoSpan)("filterTab", this.beans, this.column),
            titleLabel: $5b7ccabde48fae90$var$TAB_FILTER.replace("MenuTab", ""),
            bodyPromise: (0, $jIDNV.AgPromise).resolve(comp?.getGui()),
            afterAttachedCallback: afterAttachedCallback,
            afterDetachedCallback: afterDetachedCallback,
            name: $5b7ccabde48fae90$var$TAB_FILTER
        };
        return this.tabItemFilter;
    }
    createColumnsPanel() {
        const eWrapperDiv = (0, $jIDNV._createElement)({
            tag: "div",
            cls: "ag-menu-column-select-wrapper"
        });
        const { beans: beans, column: column } = this;
        const columnSelectPanel = beans.colChooserFactory.createColumnSelectPanel(this, column);
        const columnSelectPanelGui = columnSelectPanel.getGui();
        columnSelectPanelGui.classList.add("ag-menu-column-select");
        eWrapperDiv.appendChild(columnSelectPanelGui);
        const tabItemColumns = {
            title: (0, $jIDNV._createIconNoSpan)("columns", beans, column),
            //createColumnsIcon(),
            titleLabel: $5b7ccabde48fae90$var$TAB_COLUMNS.replace("MenuTab", ""),
            bodyPromise: (0, $jIDNV.AgPromise).resolve(eWrapperDiv),
            name: $5b7ccabde48fae90$var$TAB_COLUMNS
        };
        this.tabItemColumns = tabItemColumns;
        return tabItemColumns;
    }
    afterGuiAttached(params) {
        const { container: container, hidePopup: hidePopup } = params;
        this.tabbedLayout.setAfterAttachedParams({
            container: container,
            hidePopup: hidePopup
        });
        if (hidePopup) {
            this.hidePopupFunc = hidePopup;
            this.addDestroyFunc(hidePopup);
        }
    }
    getGui() {
        return this.tabbedLayout.getGui();
    }
    destroy() {
        super.destroy();
        this.destroyBean(this.filterComp);
    }
};
var $5b7ccabde48fae90$var$ColumnContextMenu = class extends (0, $jIDNV.Component) {
    constructor(menuItems, column, restoreFocusParams, sourceElement){
        super({
            tag: "div",
            ref: "eColumnMenu",
            cls: "ag-menu ag-column-menu",
            role: "presentation"
        });
        this.menuItems = menuItems;
        this.column = column;
        this.restoreFocusParams = restoreFocusParams;
        this.sourceElement = sourceElement;
        this.eColumnMenu = (0, $jIDNV.RefPlaceholder);
    }
    postConstruct() {
        const mainMenuList = this.beans.colMenuFactory.createMenu(this, this.menuItems, this.column, ()=>this.sourceElement ?? this.getGui());
        this.mainMenuList = mainMenuList;
        mainMenuList.addEventListener("closeMenu", this.onHidePopup.bind(this));
        this.eColumnMenu.appendChild(mainMenuList.getGui());
    }
    onHidePopup(event) {
        this.beans.menuUtils.closePopupAndRestoreFocusOnSelect(this.hidePopupFunc, this.restoreFocusParams, event);
    }
    afterGuiAttached({ hidePopup: hidePopup }) {
        if (hidePopup) {
            this.hidePopupFunc = hidePopup;
            this.addDestroyFunc(hidePopup);
        }
        (0, $jIDNV._focusInto)(this.mainMenuList.getGui());
    }
};
// packages/ag-grid-enterprise/src/menu/menuApi.ts
function $5b7ccabde48fae90$var$showContextMenu(beans, params) {
    const { contextMenuSvc: contextMenuSvc } = beans;
    if (!contextMenuSvc) return;
    const { rowNode: rowNode, column: column, value: value, x: x, y: y } = params || {};
    let { x: clientX, y: clientY } = contextMenuSvc.getContextMenuPosition(rowNode, column);
    if (x != null) clientX = x;
    if (y != null) clientY = y;
    contextMenuSvc.showContextMenu({
        mouseEvent: new MouseEvent("mousedown", {
            clientX: clientX,
            clientY: clientY
        }),
        rowNode: rowNode,
        column: column,
        value: value,
        source: "api"
    });
}
function $5b7ccabde48fae90$var$showColumnChooser(beans, params) {
    beans.colChooserFactory?.showColumnChooser({
        chooserParams: params
    });
}
function $5b7ccabde48fae90$var$hideColumnChooser(beans) {
    beans.colChooserFactory?.hideActiveColumnChooser();
}
var $5b7ccabde48fae90$var$MenuUtils = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "menuUtils";
    }
    restoreFocusOnClose(restoreFocusParams, eComp, e, restoreIfMouseEvent) {
        const { eventSource: eventSource } = restoreFocusParams;
        const isKeyboardEvent = e instanceof KeyboardEvent;
        if (!restoreIfMouseEvent && !isKeyboardEvent || !eventSource) return;
        const activeEl = (0, $jIDNV._getActiveDomElement)(this.beans);
        if (// focus is outside of comp
        !eComp.contains(activeEl) && // something else has focus
        !(0, $jIDNV._isNothingFocused)(this.beans)) return;
        this.focusHeaderCell(restoreFocusParams);
    }
    closePopupAndRestoreFocusOnSelect(hidePopupFunc, restoreFocusParams, event) {
        let keyboardEvent;
        if (event && event.keyboardEvent) keyboardEvent = event.keyboardEvent;
        hidePopupFunc(keyboardEvent && {
            keyboardEvent: keyboardEvent
        });
        const beans = this.beans;
        const focusSvc = beans.focusSvc;
        const focusedCell = focusSvc.getFocusedCell();
        if ((0, $jIDNV._isNothingFocused)(beans)) {
            if (focusedCell) {
                const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = focusedCell;
                focusSvc.setFocusedCell({
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned,
                    forceBrowserFocus: true,
                    preventScrollOnBrowserFocus: true
                });
            } else this.focusHeaderCell(restoreFocusParams);
        }
    }
    onContextMenu(params) {
        const { mouseEvent: mouseEvent, touchEvent: touchEvent, showMenuCallback: showMenuCallback, source: source } = params;
        if (!this.gos.get("allowContextMenuWithControlKey")) {
            if (mouseEvent && (mouseEvent.ctrlKey || mouseEvent.metaKey)) return;
        }
        if (mouseEvent) this.blockMiddleClickScrollsIfNeeded(mouseEvent);
        if (source === "ui" && this.gos.get("suppressContextMenu")) return;
        const eventOrTouch = mouseEvent ?? touchEvent.touches[0];
        if (showMenuCallback(eventOrTouch)) {
            const event = mouseEvent ?? touchEvent;
            if (event && event.cancelable) event.preventDefault();
        }
    }
    // make this async for react
    async focusHeaderCell(restoreFocusParams) {
        const { column: column, columnIndex: columnIndex, headerPosition: headerPosition, eventSource: eventSource } = restoreFocusParams;
        const { visibleCols: visibleCols, headerNavigation: headerNavigation, focusSvc: focusSvc } = this.beans;
        const isColumnStillVisible = await visibleCols.allCols.some((col)=>col === column);
        if (!this.isAlive()) return;
        if (column?.isAlive() && isColumnStillVisible && eventSource && (0, $jIDNV._isVisible)(eventSource)) {
            const focusableEl = (0, $jIDNV._findTabbableParent)(eventSource);
            if (focusableEl) {
                headerNavigation?.scrollToColumn(column);
                focusableEl.focus();
            }
        } else if (headerPosition && columnIndex !== -1) {
            const allColumns = visibleCols.allCols;
            const columnToFocus = allColumns[columnIndex] || (0, $jIDNV._last)(allColumns);
            if (columnToFocus) focusSvc.focusHeaderPosition({
                headerPosition: {
                    headerRowIndex: headerPosition.headerRowIndex,
                    column: columnToFocus
                }
            });
        }
    }
    blockMiddleClickScrollsIfNeeded(mouseEvent) {
        if (this.gos.get("suppressMiddleClickScrolls") && mouseEvent.which === 2) mouseEvent.preventDefault();
    }
};
// packages/ag-grid-enterprise/src/menu/menuModule.ts
var $5b7ccabde48fae90$var$MenuCoreModule = {
    moduleName: "MenuCore",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$MenuItemMapper,
        $5b7ccabde48fae90$var$ChartMenuItemMapper,
        $5b7ccabde48fae90$var$MenuUtils
    ],
    icons: {
        // context menu chart item
        chart: "chart",
        // columns in menu (column chooser / columns tab)
        columns: "columns",
        // loading async menu items
        loadingMenuItems: "loading",
        // "Pin column" item in column header menu
        menuPin: "pin",
        // "Value aggregation" column menu item (shown on numeric columns when grouping is active)"
        menuValue: "aggregation",
        // "Group by {column-name}" item in column header menu
        menuAddRowGroup: "group",
        // "Un-Group by {column-name}" item in column header menu
        menuRemoveRowGroup: "group",
        // context menu copy item
        clipboardCopy: "copy",
        // context menu cut item
        clipboardCut: "cut",
        // context menu paste item
        clipboardPaste: "paste",
        // context menu export item
        save: "save",
        // csv export
        csvExport: "csv",
        // excel export,
        excelExport: "excel",
        // show on column header when column is sorted ascending
        sortAscending: "asc",
        // show on column header when column is sorted descending
        sortDescending: "desc",
        // show on column header when column has no sort, only when enabled with colDef.unSortIcon=true
        sortUnSort: "none"
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $jIDNV._PopupModule),
        (0, $jIDNV._SharedMenuModule),
        $5b7ccabde48fae90$var$MenuItemModule
    ]
};
var $5b7ccabde48fae90$export$af7cdc2b9a7c9c3 = {
    moduleName: "ColumnMenu",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$EnterpriseMenuFactory,
        $5b7ccabde48fae90$var$ColumnMenuFactory,
        $5b7ccabde48fae90$var$ColumnChooserFactory
    ],
    icons: {
        ensureColumnVisible: "column-arrow",
        // menu tab icon in legacy tabbed enterprise column menu
        legacyMenu: "menu",
        // filter tab icon in legacy tabbed enterprise column menu
        filterTab: "filter",
        // column tool panel column group contracted (click to expand)
        columnSelectClosed: "tree-closed",
        // column tool panel column group expanded (click to contract)
        columnSelectOpen: "tree-open",
        // column tool panel header expand/collapse all button, shown when some children are expanded and
        //     others are collapsed
        columnSelectIndeterminate: "tree-indeterminate"
    },
    apiFunctions: {
        showColumnChooser: $5b7ccabde48fae90$var$showColumnChooser,
        hideColumnChooser: $5b7ccabde48fae90$var$hideColumnChooser
    },
    dependsOn: [
        $5b7ccabde48fae90$var$MenuCoreModule,
        (0, $jIDNV._SharedDragAndDropModule),
        (0, $jIDNV._ColumnMoveModule)
    ]
};
var $5b7ccabde48fae90$export$30ae2785d49a9f03 = {
    moduleName: "ContextMenu",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$ContextMenuService
    ],
    apiFunctions: {
        showContextMenu: $5b7ccabde48fae90$var$showContextMenu
    },
    dependsOn: [
        $5b7ccabde48fae90$var$MenuCoreModule
    ]
};
var $5b7ccabde48fae90$export$f1ab43fc4c3c5ce0 = {
    moduleName: "Menu",
    version: $5b7ccabde48fae90$var$VERSION,
    dependsOn: [
        $5b7ccabde48fae90$export$af7cdc2b9a7c9c3,
        $5b7ccabde48fae90$export$30ae2785d49a9f03
    ]
};
var $5b7ccabde48fae90$var$RichSelectCellEditor = class extends (0, $jIDNV.AgAbstractCellEditor) {
    constructor(){
        super({
            tag: "div",
            cls: "ag-cell-edit-wrapper"
        });
        this.isAsync = false;
    }
    initialiseEditor(_params) {
        const { cellStartedEdit: cellStartedEdit, values: values, eventKey: eventKey } = this.params;
        if ((0, $jIDNV._missing)(values)) (0, $jIDNV._warn)(180);
        const { params: richSelectParams, valuesPromise: valuesPromise } = this.buildRichSelectParams();
        const richSelect = this.createManagedBean(new $5b7ccabde48fae90$var$AgRichSelect(richSelectParams));
        this.eEditor = richSelect;
        richSelect.addCss("ag-cell-editor");
        this.appendChild(richSelect);
        if (valuesPromise) {
            this.isAsync = true;
            valuesPromise.then((values2)=>{
                richSelect.setValueList({
                    valueList: values2,
                    refresh: true
                });
                const searchStringCallback = this.getSearchStringCallback(values2);
                if (searchStringCallback) richSelect.setSearchStringCreator(searchStringCallback);
                this.processEventKey(eventKey);
            });
        }
        this.addManagedListeners(richSelect, {
            fieldPickerValueSelected: this.onEditorPickerValueSelected.bind(this)
        });
        this.focusAfterAttached = cellStartedEdit;
    }
    onEditorPickerValueSelected(e) {
        if (this.gos.get("editType") !== "fullRow") setTimeout(()=>this.params.stopEditing(!e.fromEnterKey));
    }
    buildRichSelectParams() {
        const params = this.params;
        const { cellRenderer: cellRenderer, cellHeight: cellHeight, value: value, values: values, formatValue: formatValue, searchDebounceDelay: searchDebounceDelay, valueListGap: valueListGap, valueListMaxHeight: valueListMaxHeight, valueListMaxWidth: valueListMaxWidth, allowTyping: allowTyping, filterList: filterList, searchType: searchType, highlightMatch: highlightMatch, valuePlaceholder: valuePlaceholder, eventKey: eventKey, multiSelect: multiSelect, suppressDeselectAll: suppressDeselectAll, suppressMultiSelectPillRenderer: suppressMultiSelectPillRenderer } = params;
        const ret = {
            value: value,
            cellRenderer: cellRenderer,
            cellRowHeight: cellHeight,
            searchDebounceDelay: searchDebounceDelay,
            valueFormatter: formatValue,
            pickerAriaLabelKey: "ariaLabelRichSelectField",
            pickerAriaLabelValue: "Rich Select Field",
            pickerType: "virtual-list",
            pickerGap: valueListGap,
            allowTyping: allowTyping,
            filterList: filterList,
            searchType: searchType,
            highlightMatch: highlightMatch,
            maxPickerHeight: valueListMaxHeight,
            maxPickerWidth: valueListMaxWidth,
            placeholder: valuePlaceholder,
            initialInputValue: eventKey?.length === 1 ? eventKey : void 0,
            multiSelect: multiSelect,
            suppressDeselectAll: suppressDeselectAll,
            suppressMultiSelectPillRenderer: suppressMultiSelectPillRenderer
        };
        let valuesResult;
        let valuesPromise;
        if (typeof values === "function") valuesResult = values(params);
        else valuesResult = values ?? [];
        if (Array.isArray(valuesResult)) {
            ret.valueList = valuesResult;
            ret.searchStringCreator = this.getSearchStringCallback(valuesResult);
        } else valuesPromise = valuesResult;
        if (multiSelect && allowTyping) {
            params.allowTyping = ret.allowTyping = false;
            (0, $jIDNV._warn)(181);
        }
        return {
            params: ret,
            valuesPromise: valuesPromise
        };
    }
    getSearchStringCallback(values) {
        if (typeof values[0] !== "object") return;
        const params = this.params;
        const { colDef: colDef, formatValue: formatValue } = params;
        if (colDef.cellEditorParams?.formatValue) return (values2)=>values2.map(formatValue);
        const { keyCreator: keyCreator } = colDef;
        if (keyCreator) {
            (0, $jIDNV._warn)(266);
            const { column: column, node: node, data: data } = params;
            return (values2)=>values2.map((value)=>{
                    const keyParams = (0, $jIDNV._addGridCommonParams)(this.gos, {
                        value: value,
                        colDef: colDef,
                        column: column,
                        node: node,
                        data: data
                    });
                    return keyCreator(keyParams);
                });
        }
        return (values2)=>values2.map(formatValue);
    }
    // we need to have the gui attached before we can draw the virtual rows, as the
    // virtual row logic needs info about the gui state
    afterGuiAttached() {
        const { focusAfterAttached: focusAfterAttached, params: params } = this;
        setTimeout(()=>{
            if (!this.isAlive()) return;
            const richSelect = this.eEditor;
            const { allowTyping: allowTyping, eventKey: eventKey, cellStartedEdit: cellStartedEdit } = params;
            if (focusAfterAttached) {
                const focusableEl = richSelect.getFocusableElement();
                focusableEl.focus();
                if (allowTyping && (!eventKey || eventKey.length !== 1)) focusableEl.select();
            }
            if (cellStartedEdit) richSelect.showPicker();
            if (!this.isAsync) this.processEventKey(eventKey);
        });
    }
    processEventKey(eventKey) {
        if (!eventKey) return;
        if (eventKey?.length === 1) this.eEditor.searchTextFromString(eventKey);
    }
    focusIn() {
        this.eEditor.getFocusableElement().focus();
    }
    getValue() {
        const { params: params } = this;
        const value = this.eEditor.getValue();
        return params.parseValue?.(value) ?? value;
    }
    isPopup() {
        return false;
    }
    getValidationElement() {
        return this.eEditor.getAriaElement();
    }
    getValidationErrors() {
        const { params: params } = this;
        const { getValidationErrors: getValidationErrors } = params;
        if (!getValidationErrors) return null;
        return getValidationErrors({
            value: this.getValue(),
            internalErrors: null,
            cellEditorParams: params
        });
    }
};
// packages/ag-grid-enterprise/src/richSelect/richSelectModule.ts
var $5b7ccabde48fae90$export$9bd93207561bb9c = {
    moduleName: "RichSelect",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [],
    userComponents: {
        agRichSelect: $5b7ccabde48fae90$var$RichSelectCellEditor,
        agRichSelectCellEditor: $5b7ccabde48fae90$var$RichSelectCellEditor
    },
    icons: {
        // open icon for rich select editor
        richSelectOpen: "small-down",
        // remove for rich select editor pills
        richSelectRemove: "cancel"
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $jIDNV._EditCoreModule)
    ]
};
// packages/ag-grid-enterprise/src/setFilter/iSetDisplayValueModel.ts
var $5b7ccabde48fae90$var$SET_FILTER_SELECT_ALL = "__AG_SELECT_ALL__";
var $5b7ccabde48fae90$var$SET_FILTER_ADD_SELECTION_TO_FILTER = "__AG_ADD_SELECTION_TO_FILTER__";
// packages/ag-grid-enterprise/src/setFilter/flatSetDisplayValueModel.ts
var $5b7ccabde48fae90$var$FlatSetDisplayValueModel = class {
    constructor(valueSvc, getValueFormatter, formatter, column){
        this.valueSvc = valueSvc;
        this.getValueFormatter = getValueFormatter;
        this.formatter = formatter;
        this.column = column;
        /** All keys that are currently displayed, after the mini-filter has been applied. */ this.displayedKeys = [];
    }
    updateDisplayedValuesToAllAvailable(_getValue, _allKeys, availableKeys) {
        this.displayedKeys = Array.from(availableKeys);
    }
    updateDisplayedValuesToMatchMiniFilter(getValue, _allKeys, availableKeys, matchesFilter, nullMatchesFilter) {
        this.displayedKeys = [];
        const valueFormatter = this.getValueFormatter();
        for (const key of availableKeys){
            if (key == null) {
                if (nullMatchesFilter) this.displayedKeys.push(key);
            } else {
                const value = getValue(key);
                const valueFormatterValue = this.valueSvc.formatValue(this.column, null, value, valueFormatter, false);
                const textFormatterValue = this.formatter(valueFormatterValue);
                if (matchesFilter(textFormatterValue)) this.displayedKeys.push(key);
            }
        }
    }
    getDisplayedValueCount() {
        return this.displayedKeys.length;
    }
    getDisplayedItem(index) {
        return this.displayedKeys[index];
    }
    getSelectAllItem() {
        return $5b7ccabde48fae90$var$SET_FILTER_SELECT_ALL;
    }
    getAddSelectionToFilterItem() {
        return $5b7ccabde48fae90$var$SET_FILTER_ADD_SELECTION_TO_FILTER;
    }
    getDisplayedKeys() {
        return this.displayedKeys;
    }
    forEachDisplayedKey(func) {
        this.displayedKeys.forEach(func);
    }
    someDisplayedKey(func) {
        return this.displayedKeys.some(func);
    }
    hasGroups() {
        return false;
    }
    refresh() {}
};
var $5b7ccabde48fae90$var$SetFilterGroupElement = {
    tag: "div",
    cls: "ag-set-filter-item",
    attrs: {
        "aria-hidden": "true"
    },
    children: [
        {
            tag: "span",
            cls: "ag-set-filter-group-icons",
            children: [
                {
                    tag: "span",
                    ref: "eGroupClosedIcon",
                    cls: "ag-set-filter-group-closed-icon"
                },
                {
                    tag: "span",
                    ref: "eGroupOpenedIcon",
                    cls: "ag-set-filter-group-opened-icon"
                },
                {
                    tag: "span",
                    ref: "eGroupIndeterminateIcon",
                    cls: "ag-set-filter-group-indeterminate-icon"
                }
            ]
        },
        {
            tag: "ag-checkbox",
            ref: "eCheckbox",
            cls: "ag-set-filter-item-checkbox"
        }
    ]
};
var $5b7ccabde48fae90$var$SetFilterElement = {
    tag: "div",
    cls: "ag-set-filter-item",
    children: [
        {
            tag: "ag-checkbox",
            ref: "eCheckbox",
            cls: "ag-set-filter-item-checkbox"
        }
    ]
};
var $5b7ccabde48fae90$var$SetFilterListItem = class extends (0, $jIDNV.Component) {
    constructor(params){
        super(params.isGroup ? $5b7ccabde48fae90$var$SetFilterGroupElement : $5b7ccabde48fae90$var$SetFilterElement, [
            (0, $jIDNV.AgCheckboxSelector)
        ]);
        this.eCheckbox = (0, $jIDNV.RefPlaceholder);
        this.eGroupOpenedIcon = (0, $jIDNV.RefPlaceholder);
        this.eGroupClosedIcon = (0, $jIDNV.RefPlaceholder);
        this.eGroupIndeterminateIcon = (0, $jIDNV.RefPlaceholder);
        this.formattedValue = null;
        this.focusWrapper = params.focusWrapper;
        this.value = params.value;
        this.params = params.params;
        this.translate = params.translate;
        this.valueFormatter = params.valueFormatter;
        this.item = params.item;
        this.isSelected = params.isSelected;
        this.isTree = params.isTree;
        this.depth = params.depth ?? 0;
        this.isGroup = params.isGroup;
        this.groupsExist = params.groupsExist;
        this.isExpanded = params.isExpanded;
        this.hasIndeterminateExpandState = params.hasIndeterminateExpandState;
    }
    postConstruct() {
        this.tooltipFeature = this.createOptionalManagedBean(this.beans.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.getGui(),
            getColDef: ()=>this.params.colDef,
            getColumn: ()=>this.params.column,
            getLocation: ()=>"setFilterValue",
            shouldDisplayTooltip: ()=>this.shouldDisplayTooltip?.() ?? true,
            getValueFormatted: ()=>this.formattedValue,
            getAdditionalParams: ()=>this.isTree ? {
                    level: this.depth
                } : {}
        }));
        this.addDestroyFunc(()=>this.destroyCellRendererComponent?.());
        this.render();
        this.eCheckbox.setLabelEllipsis(true).setValue(this.isSelected, true).setDisabled(!!this.params.readOnly).getInputElement().setAttribute("tabindex", "-1");
        this.refreshVariableAriaLabels();
        if (this.isTree) {
            if (this.depth > 0) {
                this.addCss("ag-set-filter-indent-" + this.depth);
                this.getGui().style.setProperty("--ag-indentation-level", String(this.depth));
            }
            if (this.isGroup) this.setupExpansion();
            else if (this.groupsExist) this.addCss("ag-set-filter-add-group-indent");
            (0, $jIDNV._setAriaLevel)(this.getAriaElement(), this.depth + 1);
        }
        this.refreshAriaChecked();
        if (this.params.readOnly) return;
        this.eCheckbox.onValueChange((value)=>this.onCheckboxChanged(!!value));
    }
    getFocusableElement() {
        return this.focusWrapper;
    }
    setupExpansion() {
        const { eGroupClosedIcon: eGroupClosedIcon, eGroupOpenedIcon: eGroupOpenedIcon, eGroupIndeterminateIcon: eGroupIndeterminateIcon, hasIndeterminateExpandState: hasIndeterminateExpandState, beans: beans } = this;
        eGroupClosedIcon.appendChild((0, $jIDNV._createIcon)("setFilterGroupClosed", beans, null));
        eGroupOpenedIcon.appendChild((0, $jIDNV._createIcon)("setFilterGroupOpen", beans, null));
        const listener = this.onExpandOrContractClicked.bind(this);
        this.addManagedElementListeners(eGroupClosedIcon, {
            click: listener
        });
        this.addManagedElementListeners(eGroupOpenedIcon, {
            click: listener
        });
        if (hasIndeterminateExpandState) {
            eGroupIndeterminateIcon.appendChild((0, $jIDNV._createIcon)("setFilterGroupIndeterminate", beans, null));
            this.addManagedElementListeners(eGroupIndeterminateIcon, {
                click: listener
            });
        }
        this.setExpandedIcons();
        this.refreshAriaExpanded();
    }
    onExpandOrContractClicked() {
        this.setExpanded(!this.isExpanded);
    }
    setExpanded(isExpanded, silent) {
        if (this.isGroup && isExpanded !== this.isExpanded) {
            this.isExpanded = isExpanded;
            const event = {
                type: "expandedChanged",
                isExpanded: !!isExpanded,
                item: this.item
            };
            if (!silent) this.dispatchLocalEvent(event);
            this.setExpandedIcons();
            this.refreshAriaExpanded();
        }
    }
    setExpandedIcons() {
        const { isExpanded: isExpanded, hasIndeterminateExpandState: hasIndeterminateExpandState, eGroupClosedIcon: eGroupClosedIcon, eGroupOpenedIcon: eGroupOpenedIcon, eGroupIndeterminateIcon: eGroupIndeterminateIcon } = this;
        (0, $jIDNV._setDisplayed)(eGroupClosedIcon, hasIndeterminateExpandState ? isExpanded === false : !isExpanded);
        (0, $jIDNV._setDisplayed)(eGroupOpenedIcon, isExpanded === true);
        if (hasIndeterminateExpandState) (0, $jIDNV._setDisplayed)(eGroupIndeterminateIcon, isExpanded === void 0);
    }
    onCheckboxChanged(isSelected) {
        this.isSelected = isSelected;
        const event = {
            type: "selectionChanged",
            isSelected: isSelected,
            item: this.item
        };
        this.dispatchLocalEvent(event);
        this.refreshVariableAriaLabels();
        this.refreshAriaChecked();
    }
    toggleSelected() {
        if (this.params.readOnly) return;
        this.setSelected(!this.isSelected);
    }
    setSelected(isSelected, silent) {
        this.isSelected = isSelected;
        this.eCheckbox.setValue(isSelected, silent);
        this.refreshAriaChecked();
    }
    refreshVariableAriaLabels() {
        if (!this.isTree) return;
        const translate = this.getLocaleTextFunc();
        const checkboxValue = this.eCheckbox.getValue();
        const state = checkboxValue === void 0 ? translate("ariaIndeterminate", "indeterminate") : checkboxValue ? translate("ariaVisible", "visible") : translate("ariaHidden", "hidden");
        const visibilityLabel = translate("ariaToggleVisibility", "Press SPACE to toggle visibility");
        (0, $jIDNV._setAriaLabelledBy)(this.eCheckbox.getInputElement(), void 0);
        this.eCheckbox.setInputAriaLabel(`${visibilityLabel} (${state})`);
    }
    setupFixedAriaLabels(value) {
        if (!this.isTree) return;
        const translate = this.getLocaleTextFunc();
        const itemLabel = translate("ariaFilterValue", "Filter Value");
        const ariaEl = this.getAriaElement();
        (0, $jIDNV._setAriaLabel)(ariaEl, `${value} ${itemLabel}`);
        (0, $jIDNV._setAriaDescribedBy)(ariaEl, this.eCheckbox.getInputElement().id);
    }
    refreshAriaChecked() {
        const ariaEl = this.getAriaElement();
        (0, $jIDNV._setAriaChecked)(ariaEl, this.eCheckbox.getValue());
    }
    refreshAriaExpanded() {
        (0, $jIDNV._setAriaExpanded)(this.getAriaElement(), !!this.isExpanded);
    }
    refresh(item, isSelected, isExpanded) {
        this.item = item;
        if (isSelected !== this.isSelected) this.setSelected(isSelected, true);
        this.setExpanded(isExpanded, true);
        const { cellRendererComponent: cellRendererComponent, cellRendererParams: cellRendererParams, beans: beans, params: params } = this;
        if (this.valueFunction) {
            const value = this.valueFunction();
            this.setTooltipAndCellRendererParams(value, value);
            if (!cellRendererComponent) this.renderCellWithoutCellRenderer();
        }
        if (cellRendererComponent) {
            const compDetails = (0, $jIDNV._getCellRendererDetails)(beans.userCompFactory, params, cellRendererParams);
            const success = cellRendererComponent.refresh?.(compDetails?.params ?? cellRendererParams);
            if (!success) {
                const oldComponent = cellRendererComponent;
                this.renderCell();
                this.destroyBean(oldComponent);
            }
        }
    }
    render() {
        const { params: { column: column } } = this;
        let { value: value } = this;
        let formattedValue = null;
        if (typeof value === "function") {
            this.valueFunction = value;
            formattedValue = this.valueFunction();
            value = formattedValue;
        } else if (this.isTree) formattedValue = (0, $jIDNV._toStringOrNull)(value);
        else formattedValue = this.getFormattedValue(column, value);
        this.formattedValue = formattedValue;
        this.setTooltipAndCellRendererParams(value, formattedValue);
        this.renderCell();
    }
    setTooltipAndCellRendererParams(value, formattedValue) {
        const gos = this.gos;
        if (this.params.showTooltips && (!(0, $jIDNV._isShowTooltipWhenTruncated)(gos) || !this.params.cellRenderer)) {
            const newTooltipText = formattedValue != null ? formattedValue : (0, $jIDNV._toStringOrNull)(value);
            this.shouldDisplayTooltip = (0, $jIDNV._getShouldDisplayTooltip)(gos, ()=>this.eCheckbox.getGui().querySelector(".ag-label"));
            this.tooltipFeature?.setTooltipAndRefresh(newTooltipText);
        }
        this.cellRendererParams = (0, $jIDNV._addGridCommonParams)(gos, {
            value: value,
            valueFormatted: formattedValue,
            colDef: this.params.colDef,
            column: this.params.column,
            setTooltip: (value2, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                this.shouldDisplayTooltip = shouldDisplayTooltip;
                this.tooltipFeature?.setTooltipAndRefresh(value2);
            }
        });
    }
    getFormattedValue(column, value) {
        return this.beans.valueSvc.formatValue(column, null, value, this.valueFormatter, false);
    }
    renderCell() {
        const compDetails = (0, $jIDNV._getCellRendererDetails)(this.beans.userCompFactory, this.params, this.cellRendererParams);
        const cellRendererPromise = compDetails?.newAgStackInstance();
        if (cellRendererPromise == null) {
            this.renderCellWithoutCellRenderer();
            return;
        }
        cellRendererPromise.then((component)=>{
            if (component) {
                this.cellRendererComponent = component;
                this.eCheckbox.setLabel(component.getGui());
                this.destroyCellRendererComponent = ()=>this.destroyBean(component);
            }
        });
    }
    renderCellWithoutCellRenderer() {
        const { valueFormatted: valueFormatted, value: value } = this.cellRendererParams;
        let valueToRender = (valueFormatted == null ? value : valueFormatted) ?? this.translate("blanks");
        if (typeof valueToRender !== "string") {
            (0, $jIDNV._warn)(208);
            valueToRender = "";
        }
        this.eCheckbox.setLabel(valueToRender);
        this.setupFixedAriaLabels(valueToRender);
    }
    getComponentHolder() {
        return this.params.column.getColDef();
    }
};
// packages/ag-grid-enterprise/src/setFilter/localeText.ts
var $5b7ccabde48fae90$var$DEFAULT_LOCALE_TEXT = {
    loadingOoo: "Loading...",
    blanks: "(Blanks)",
    searchOoo: "Search...",
    selectAll: "(Select All)",
    selectAllSearchResults: "(Select All Search Results)",
    addCurrentSelectionToFilter: "Add current selection to filter",
    noMatches: "No matches.",
    ariaSearchFilterValues: "Search filter values",
    ariaFilterList: "Filter List",
    filterSummaryListInactive: "is (All)",
    filterSummaryListSeparator: ", ",
    filterSummaryListShort: (variableValues)=>`is (${variableValues[0]})`,
    filterSummaryListLong: (variableValues)=>`is (${variableValues[0]}) and ${variableValues[1]} more`
};
// packages/ag-grid-enterprise/src/setFilter/setFilterUtils.ts
function $5b7ccabde48fae90$var$processDataPath(dataPath, treeData, groupAllowUnbalanced) {
    let processedDataPath = dataPath;
    if (!processedDataPath) return null;
    processedDataPath = processedDataPath.map((treeKey)=>(0, $jIDNV._toStringOrNull)((0, $jIDNV._makeNull)(treeKey)));
    if (!treeData && groupAllowUnbalanced && processedDataPath.some((treeKey)=>treeKey == null)) {
        if ((0, $jIDNV._last)(processedDataPath) == null) return null;
        return processedDataPath.filter((treeKey)=>treeKey != null);
    }
    return processedDataPath;
}
function $5b7ccabde48fae90$var$translateForSetFilter(bean, key, variableValues) {
    return (0, $jIDNV._translate)(bean, $5b7ccabde48fae90$var$DEFAULT_LOCALE_TEXT, key, variableValues);
}
function $5b7ccabde48fae90$var$applyExcelModeOptions(params) {
    if (params.excelMode === "windows") {
        if (!params.buttons) params.buttons = [
            "apply",
            "cancel"
        ];
        if (params.closeOnApply == null) params.closeOnApply = true;
    } else if (params.excelMode === "mac") {
        if (!params.buttons) params.buttons = [
            "reset"
        ];
        if (params.applyMiniFilterWhileTyping == null) params.applyMiniFilterWhileTyping = true;
        if (params.debounceMs == null) params.debounceMs = 500;
    }
    if (params.excelMode && params.defaultToNothingSelected) {
        params.defaultToNothingSelected = false;
        (0, $jIDNV._warn)(207);
    }
}
function $5b7ccabde48fae90$var$createTreeDataOrGroupingComparator() {
    return ([_aKey, aValue], [_bKey, bValue])=>{
        if (aValue == null) return bValue == null ? 0 : -1;
        else if (bValue == null) return 1;
        for(let i = 0; i < aValue.length; i++){
            if (i >= bValue.length) return 1;
            const diff = (0, $jIDNV._defaultComparator)(aValue[i], bValue[i]);
            if (diff !== 0) return diff;
        }
        return 0;
    };
}
var $5b7ccabde48fae90$var$TreeSetDisplayValueModel = class {
    constructor(formatter, treeListPathGetter, treeListFormatter, treeDataOrGrouping){
        this.formatter = formatter;
        this.treeListPathGetter = treeListPathGetter;
        this.treeListFormatter = treeListFormatter;
        this.treeDataOrGrouping = treeDataOrGrouping;
        /** all displayed items in a tree structure */ this.allDisplayedItemsTree = /* @__PURE__ */ new Map();
        /** all displayed items flattened and filtered */ this.activeDisplayedItemsFlat = [];
        this.selectAllItem = {
            depth: 0,
            filterPasses: true,
            available: true,
            treeKey: $5b7ccabde48fae90$var$SET_FILTER_SELECT_ALL,
            children: this.allDisplayedItemsTree,
            expanded: true,
            key: $5b7ccabde48fae90$var$SET_FILTER_SELECT_ALL,
            parentTreeKeys: []
        };
        this.addSelectionToFilterItem = {
            depth: 0,
            filterPasses: true,
            available: true,
            treeKey: $5b7ccabde48fae90$var$SET_FILTER_ADD_SELECTION_TO_FILTER,
            expanded: true,
            key: $5b7ccabde48fae90$var$SET_FILTER_ADD_SELECTION_TO_FILTER,
            parentTreeKeys: []
        };
    }
    updateParams(treeListPathGetter, treeListFormatter) {
        this.treeListPathGetter = treeListPathGetter;
        this.treeListFormatter = treeListFormatter;
    }
    updateDisplayedValuesToAllAvailable(getValue, allKeys, availableKeys, source) {
        if (source === "reload") this.generateItemTree(getValue, allKeys, availableKeys);
        else if (source === "otherFilter") {
            this.updateAvailable(availableKeys);
            this.updateExpandAll();
        } else if (source === "miniFilter") {
            this.resetFilter();
            this.updateExpandAll();
        }
        this.flattenItems();
    }
    updateDisplayedValuesToMatchMiniFilter(getValue, allKeys, availableKeys, matchesFilter, nullMatchesFilter, source) {
        if (source === "reload") this.generateItemTree(getValue, allKeys, availableKeys);
        else if (source === "otherFilter") this.updateAvailable(availableKeys);
        this.updateFilter(matchesFilter, nullMatchesFilter);
        this.updateExpandAll();
        this.flattenItems();
    }
    generateItemTree(getValue, allKeys, availableKeys) {
        const allDisplayedItemsTree = /* @__PURE__ */ new Map();
        this.allDisplayedItemsTree = allDisplayedItemsTree;
        let groupsExist = false;
        const treeListPathGetter = this.getTreeListPathGetter(getValue, availableKeys);
        for (const key of allKeys){
            const value = getValue(key);
            const dataPath = treeListPathGetter(value) ?? [
                null
            ];
            const dataPathLength = dataPath.length;
            if (dataPathLength > 1) groupsExist = true;
            const available = availableKeys.has(key);
            let children = allDisplayedItemsTree;
            let item;
            let parentTreeKeys = [];
            for(let depth = 0; depth < dataPathLength; depth++){
                const treeKey = dataPath[depth];
                if (!children) {
                    children = /* @__PURE__ */ new Map();
                    item.children = children;
                }
                const treeKeyUpper = treeKey?.toUpperCase() ?? null;
                item = children.get(treeKeyUpper);
                if (!item) {
                    item = {
                        treeKey: treeKey,
                        depth: depth,
                        filterPasses: true,
                        expanded: false,
                        available: available,
                        parentTreeKeys: parentTreeKeys
                    };
                    if (depth === dataPath.length - 1) item.key = key;
                    children.set(treeKeyUpper, item);
                }
                children = item.children;
                parentTreeKeys = [
                    ...parentTreeKeys,
                    treeKey
                ];
            }
        }
        this.groupsExist = groupsExist;
        this.updateAvailable(availableKeys);
        this.selectAllItem.children = allDisplayedItemsTree;
        this.selectAllItem.expanded = false;
    }
    getTreeListPathGetter(getValue, availableKeys) {
        if (this.treeListPathGetter) return this.treeListPathGetter;
        if (this.treeDataOrGrouping) return (value)=>value;
        let isDate = false;
        for (const availableKey of availableKeys){
            const value = getValue(availableKey);
            if (value instanceof Date) {
                isDate = true;
                break;
            } else if (value != null) break;
        }
        if (isDate) return (value)=>(0, $jIDNV._getDateParts)(value, false);
        (0, $jIDNV._warn)(211);
        return (value)=>[
                String(value)
            ];
    }
    flattenItems() {
        this.activeDisplayedItemsFlat = [];
        const recursivelyFlattenDisplayedItems = (items)=>{
            for (const item of items.values()){
                if (!item.filterPasses || !item.available) continue;
                this.activeDisplayedItemsFlat.push(item);
                if (item.children && item.expanded) recursivelyFlattenDisplayedItems(item.children);
            }
        };
        recursivelyFlattenDisplayedItems(this.allDisplayedItemsTree);
    }
    resetFilter() {
        const recursiveFilterReset = (item)=>{
            const children = item.children;
            if (children) for (const child of children.values())recursiveFilterReset(child);
            item.filterPasses = true;
        };
        for (const item of this.allDisplayedItemsTree.values())recursiveFilterReset(item);
    }
    updateFilter(matchesFilter, nullMatchesFilter) {
        const passesFilter = (item)=>{
            if (!item.available) return false;
            if (item.treeKey == null) return nullMatchesFilter;
            return matchesFilter(this.formatter(this.treeListFormatter ? this.treeListFormatter(item.treeKey, item.depth, item.parentTreeKeys) : item.treeKey));
        };
        for (const item of this.allDisplayedItemsTree.values())this.recursiveItemCheck(item, false, passesFilter, "filterPasses");
    }
    getDisplayedValueCount() {
        return this.activeDisplayedItemsFlat.length;
    }
    getDisplayedItem(index) {
        return this.activeDisplayedItemsFlat[index];
    }
    getSelectAllItem() {
        return this.selectAllItem;
    }
    getAddSelectionToFilterItem() {
        return this.addSelectionToFilterItem;
    }
    getDisplayedKeys() {
        const displayedKeys = [];
        this.forEachDisplayedKey((key)=>displayedKeys.push(key));
        return displayedKeys;
    }
    forEachDisplayedKey(func) {
        const recursiveForEachItem = (item, topParentExpanded)=>{
            const children = item.children;
            if (children) {
                if (!item.expanded || !topParentExpanded) {
                    for (const child of children.values())if (child.filterPasses) recursiveForEachItem(child, false);
                }
            } else func(item.key);
        };
        this.activeDisplayedItemsFlat.forEach((item)=>recursiveForEachItem(item, true));
    }
    someDisplayedKey(func) {
        const recursiveSomeItem = (item, topParentExpanded)=>{
            const children = item.children;
            if (children) {
                if (!item.expanded || !topParentExpanded) {
                    for (const child of children.values()){
                        if (child.filterPasses && recursiveSomeItem(child, false)) return true;
                    }
                    return false;
                }
            } else return func(item.key);
            return false;
        };
        return this.activeDisplayedItemsFlat.some((item)=>recursiveSomeItem(item, true));
    }
    hasGroups() {
        return this.groupsExist;
    }
    refresh() {
        this.updateExpandAll();
        this.flattenItems();
    }
    updateExpandAll() {
        const recursiveExpansionCheck = (items, someTrue, someFalse)=>{
            for (const item2 of items.values()){
                if (!item2.filterPasses || !item2.available || !item2.children) continue;
                someTrue = someTrue || !!item2.expanded;
                someFalse = someFalse || !item2.expanded;
                if (someTrue && someFalse) return void 0;
                const childExpanded = recursiveExpansionCheck(item2.children, someTrue, someFalse);
                if (childExpanded === void 0) return void 0;
                else if (childExpanded) someTrue = true;
                else someFalse = true;
            }
            return someTrue && someFalse ? void 0 : someTrue;
        };
        const item = this.getSelectAllItem();
        item.expanded = recursiveExpansionCheck(item.children, false, false);
    }
    recursiveItemCheck(item, parentPasses, checkFunction, itemProp) {
        let atLeastOneChildPassed = false;
        const children = item.children;
        if (children) for (const child of children.values()){
            const childPasses = this.recursiveItemCheck(child, parentPasses || checkFunction(item), checkFunction, itemProp);
            atLeastOneChildPassed = atLeastOneChildPassed || childPasses;
        }
        const itemPasses = parentPasses || atLeastOneChildPassed || checkFunction(item);
        item[itemProp] = itemPasses;
        return itemPasses;
    }
    updateAvailable(availableKeys) {
        const isAvailable = (item)=>availableKeys.has(item.key);
        for (const item of this.allDisplayedItemsTree.values())this.recursiveItemCheck(item, false, isAvailable, "available");
    }
};
// packages/ag-grid-enterprise/src/setFilter/setFilter.ts
var $5b7ccabde48fae90$var$SetFilter = class extends (0, $jIDNV.ProvidedFilter) {
    constructor(){
        super("setFilter", "set-filter");
        this.filterType = "set";
        this.eMiniFilter = (0, $jIDNV.RefPlaceholder);
        this.eFilterLoading = (0, $jIDNV.RefPlaceholder);
        this.eFilterLoadingIcon = (0, $jIDNV.RefPlaceholder);
        this.eSetFilterList = (0, $jIDNV.RefPlaceholder);
        this.eFilterNoMatches = (0, $jIDNV.RefPlaceholder);
        this.hardRefreshVirtualList = false;
        this.miniFilterText = null;
        /** When true, in excelMode = 'windows', it adds previously selected filter items to newly checked filter selection */ this.addCurrentSelectionToFilter = false;
        /** Keys that have been selected for this filter. */ this.selectedKeys = /* @__PURE__ */ new Set();
    }
    setParams(params) {
        super.setParams(params);
        const handler = this.updateHandler(params.getHandler());
        const { column: column, textFormatter: textFormatter, treeList: treeList, treeListPathGetter: treeListPathGetter, treeListFormatter: treeListFormatter } = params;
        this.formatter = textFormatter ?? ((value)=>value ?? null);
        this.displayValueModel = treeList ? new $5b7ccabde48fae90$var$TreeSetDisplayValueModel(this.formatter, treeListPathGetter, treeListFormatter, handler.isTreeDataOrGrouping()) : new $5b7ccabde48fae90$var$FlatSetDisplayValueModel(this.beans.valueSvc, ()=>this.handler.valueFormatter, this.formatter, column);
        handler.valueModel.allKeys.then((values)=>{
            this.updateDisplayedValues("reload", values ?? []);
            this.resetSelectionState(values ?? []);
        });
        if (handler.valueModel.isLoading()) this.setIsLoading(true);
        this.initialiseFilterBodyUi();
    }
    refresh(legacyNewParams) {
        if (this.params.treeList !== legacyNewParams.treeList) return false;
        this.updateHandler(legacyNewParams.getHandler());
        return super.refresh(legacyNewParams);
    }
    updateParams(newParams, oldParams) {
        super.updateParams(newParams, oldParams);
        this.updateMiniFilter();
        if (newParams.suppressSelectAll !== oldParams.suppressSelectAll) this.createVirtualListModel(newParams);
        const { textFormatter: textFormatter, treeListPathGetter: treeListPathGetter, treeListFormatter: treeListFormatter } = newParams;
        this.formatter = textFormatter ?? ((value)=>value ?? null);
        if (this.displayValueModel instanceof $5b7ccabde48fae90$var$TreeSetDisplayValueModel) this.displayValueModel.updateParams(treeListPathGetter, treeListFormatter);
        this.handler.refreshFilterValues();
    }
    updateHandler(handler) {
        const oldHandler = this.handler;
        if (oldHandler !== handler) {
            this.handlerDestroyFuncs?.forEach((func)=>func());
            this.handlerDestroyFuncs = [
                ...this.addManagedListeners(handler, {
                    anyFilterChanged: (event)=>{
                        handler.valueModel.allKeys.then((values)=>{
                            if (this.isAlive()) {
                                this.updateDisplayedValues("otherFilter", values ?? []);
                                if (event.updated) {
                                    this.checkAndRefreshVirtualList();
                                    this.showOrHideResults();
                                }
                            }
                        });
                    },
                    dataChanged: ({ hardRefresh: hardRefresh })=>{
                        handler.valueModel.allKeys.then((values)=>{
                            if (this.isAlive()) {
                                this.updateDisplayedValues("reload", values ?? []);
                                this.setSelectedModel(this.state.model?.values ?? null);
                                if (hardRefresh) this.hardRefreshVirtualList = true;
                                this.checkAndRefreshVirtualList();
                            }
                        });
                    }
                }),
                ...this.addManagedListeners(handler.valueModel, {
                    loadingStart: ()=>this.setIsLoading(true),
                    loadingEnd: ()=>this.setIsLoading(false)
                })
            ];
            this.handler = handler;
        }
        return handler;
    }
    // unlike the simple filters, nothing in the set filter UI shows/hides.
    // maybe this method belongs in abstractSimpleFilter???
    updateUiVisibility() {}
    createBodyTemplate() {
        return {
            tag: "div",
            cls: "ag-set-filter",
            children: [
                {
                    tag: "div",
                    ref: "eFilterLoading",
                    cls: "ag-filter-loading ag-loading ag-hidden",
                    children: [
                        {
                            tag: "span",
                            ref: "eFilterLoadingIcon",
                            cls: "ag-loading-icon"
                        },
                        {
                            tag: "span",
                            cls: "ag-loading-text",
                            children: $5b7ccabde48fae90$var$translateForSetFilter(this, "loadingOoo")
                        }
                    ]
                },
                {
                    tag: "ag-input-text-field",
                    ref: "eMiniFilter",
                    cls: "ag-mini-filter"
                },
                {
                    tag: "div",
                    ref: "eFilterNoMatches",
                    cls: "ag-filter-no-matches ag-hidden",
                    children: $5b7ccabde48fae90$var$translateForSetFilter(this, "noMatches")
                },
                {
                    tag: "div",
                    ref: "eSetFilterList",
                    cls: "ag-set-filter-list",
                    role: "presentation"
                }
            ]
        };
    }
    getAgComponents() {
        return [
            (0, $jIDNV.AgInputTextFieldSelector)
        ];
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        if (e.defaultPrevented) return;
        const getComponentForKeyEvent = ()=>{
            if (!this.eSetFilterList.contains((0, $jIDNV._getActiveDomElement)(this.beans))) return;
            const currentItem = this.virtualList.getLastFocusedRow();
            if (currentItem == null) return;
            const component = this.virtualList.getComponentAt(currentItem);
            if (component == null) return;
            e.preventDefault();
            const { readOnly: readOnly } = this.params;
            if (readOnly) return;
            return component;
        };
        switch(e.key){
            case (0, $jIDNV.KeyCode).SPACE:
                getComponentForKeyEvent()?.toggleSelected();
                break;
            case (0, $jIDNV.KeyCode).ENTER:
                this.handleKeyEnter(e);
                break;
            case (0, $jIDNV.KeyCode).LEFT:
                getComponentForKeyEvent()?.setExpanded(false);
                break;
            case (0, $jIDNV.KeyCode).RIGHT:
                getComponentForKeyEvent()?.setExpanded(true);
                break;
        }
    }
    handleKeyEnter(e) {
        e.preventDefault();
        const { excelMode: excelMode, readOnly: readOnly } = this.params;
        if (!excelMode || !!readOnly) return;
        this.params.onAction("apply", void 0, e);
        if (this.params.excelMode === "mac") this.eMiniFilter.getInputElement().select();
    }
    setModelAndRefresh(values) {
        return this.setSelectedModel(values).then(()=>{
            if (this.isAlive()) this.checkAndRefreshVirtualList();
        });
    }
    setModelIntoUi(model) {
        this.setMiniFilter(this.params.state.state?.miniFilterValue ?? null);
        const values = model == null ? null : model.values;
        return this.setModelAndRefresh(values);
    }
    getModelFromUi() {
        const values = this.getSelectedModel();
        if (!values) return null;
        return {
            values: values,
            filterType: this.filterType
        };
    }
    areNonNullModelsEqual(a, b) {
        return (0, $jIDNV._areEqual)(a.values, b.values);
    }
    setIsLoading(isLoading) {
        (0, $jIDNV._setDisplayed)(this.eFilterLoading, isLoading);
        if (!isLoading) this.hardRefreshVirtualList = true;
    }
    initialiseFilterBodyUi() {
        this.initVirtualList();
        this.initMiniFilter();
        this.initLoading();
    }
    initLoading() {
        const loadingIcon = (0, $jIDNV._createIconNoSpan)("setFilterLoading", this.beans, this.params.column);
        if (loadingIcon) this.eFilterLoadingIcon.appendChild(loadingIcon);
    }
    initVirtualList() {
        const filterListName = $5b7ccabde48fae90$var$translateForSetFilter(this, "ariaFilterList");
        const isTree = !!this.params.treeList;
        const virtualList = this.virtualList = this.createBean(new $5b7ccabde48fae90$var$VirtualList({
            cssIdentifier: "filter",
            ariaRole: isTree ? "tree" : "listbox",
            listName: filterListName
        }));
        const eSetFilterList = this.eSetFilterList;
        if (isTree) eSetFilterList.classList.add("ag-set-filter-tree-list");
        eSetFilterList.appendChild(virtualList.getGui());
        const { cellHeight: cellHeight } = this.params;
        if (cellHeight != null) virtualList.setRowHeight(cellHeight);
        const componentCreator = (item, listItemElement)=>this.createSetListItem(item, isTree, listItemElement);
        virtualList.setComponentCreator(componentCreator);
        const componentUpdater = (item, component)=>this.updateSetListItem(item, component);
        virtualList.setComponentUpdater(componentUpdater);
        this.createVirtualListModel(this.params);
    }
    createVirtualListModel(params) {
        let model;
        if (params.suppressSelectAll) model = new $5b7ccabde48fae90$var$ModelWrapper(this.displayValueModel);
        else model = new $5b7ccabde48fae90$var$ModelWrapperWithSelectAll(this.displayValueModel, this.showAddCurrentSelectionToFilter.bind(this));
        if (params.treeList) model = new $5b7ccabde48fae90$var$TreeModelWrapper(model);
        this.virtualList.setModel(model);
    }
    getSelectAllLabel() {
        const key = this.miniFilterText == null || !this.params.excelMode ? "selectAll" : "selectAllSearchResults";
        return $5b7ccabde48fae90$var$translateForSetFilter(this, key);
    }
    getAddSelectionToFilterLabel() {
        return $5b7ccabde48fae90$var$translateForSetFilter(this, "addCurrentSelectionToFilter");
    }
    createSetListItem(item, isTree, focusWrapper) {
        const groupsExist = this.displayValueModel.hasGroups();
        const { isSelected: isSelected, isExpanded: isExpanded } = this.isSelectedExpanded(item);
        const { value: value, depth: depth, isGroup: isGroup, hasIndeterminateExpandState: hasIndeterminateExpandState, selectedListener: selectedListener, expandedListener: expandedListener } = this.newSetListItemAttributes(item);
        const itemParams = {
            focusWrapper: focusWrapper,
            value: value,
            params: this.params,
            translate: (translateKey)=>$5b7ccabde48fae90$var$translateForSetFilter(this, translateKey),
            valueFormatter: this.handler.valueFormatter,
            item: item,
            isSelected: isSelected,
            isTree: isTree,
            depth: depth,
            groupsExist: groupsExist,
            isGroup: isGroup,
            isExpanded: isExpanded,
            hasIndeterminateExpandState: hasIndeterminateExpandState
        };
        const listItem = this.createBean(new $5b7ccabde48fae90$var$SetFilterListItem(itemParams));
        listItem.addEventListener("selectionChanged", selectedListener);
        if (expandedListener) listItem.addEventListener("expandedChanged", expandedListener);
        return listItem;
    }
    newSetTreeItemAttributes(item) {
        const groupsExist = this.displayValueModel.hasGroups();
        if (item.key === $5b7ccabde48fae90$var$SET_FILTER_SELECT_ALL) return {
            value: ()=>this.getSelectAllLabel(),
            isGroup: groupsExist,
            depth: item.depth,
            hasIndeterminateExpandState: true,
            selectedListener: (e)=>this.onSelectAll(e.isSelected),
            expandedListener: (e)=>this.onExpandAll(e.item, e.isExpanded)
        };
        if (item.key === $5b7ccabde48fae90$var$SET_FILTER_ADD_SELECTION_TO_FILTER) return {
            value: ()=>this.getAddSelectionToFilterLabel(),
            depth: item.depth,
            isGroup: false,
            hasIndeterminateExpandState: false,
            selectedListener: (e)=>{
                this.addCurrentSelectionToFilter = e.isSelected;
                this.refreshAfterSelection();
            }
        };
        if (item.children) return {
            value: this.params.treeListFormatter?.(item.treeKey, item.depth, item.parentTreeKeys) ?? item.treeKey,
            depth: item.depth,
            isGroup: true,
            selectedListener: (e)=>this.onGroupItemSelected(e.item, e.isSelected),
            expandedListener: (e)=>this.onExpandedChanged(e.item, e.isExpanded)
        };
        return {
            value: this.params.treeListFormatter?.(item.treeKey, item.depth, item.parentTreeKeys) ?? item.treeKey,
            depth: item.depth,
            selectedListener: (e)=>this.onItemSelected(e.item.key, e.isSelected)
        };
    }
    newSetListItemAttributes(item) {
        if (this.isSetFilterModelTreeItem(item)) return this.newSetTreeItemAttributes(item);
        if (item === $5b7ccabde48fae90$var$SET_FILTER_SELECT_ALL) return {
            value: ()=>this.getSelectAllLabel(),
            selectedListener: (e)=>this.onSelectAll(e.isSelected)
        };
        if (item === $5b7ccabde48fae90$var$SET_FILTER_ADD_SELECTION_TO_FILTER) return {
            value: ()=>this.getAddSelectionToFilterLabel(),
            selectedListener: (e)=>{
                this.addCurrentSelectionToFilter = e.isSelected;
                this.refreshAfterSelection();
            }
        };
        return {
            value: this.handler.valueModel.allValues.get(item) ?? null,
            selectedListener: (e)=>this.onItemSelected(e.item, e.isSelected)
        };
    }
    updateSetListItem(item, component) {
        const { isSelected: isSelected, isExpanded: isExpanded } = this.isSelectedExpanded(item);
        component.refresh(item, isSelected, isExpanded);
    }
    isSelectedExpanded(item) {
        let isSelected;
        let isExpanded;
        if (this.isSetFilterModelTreeItem(item)) {
            isExpanded = item.expanded;
            if (item.key === $5b7ccabde48fae90$var$SET_FILTER_SELECT_ALL) isSelected = this.isSelectAllSelected();
            else if (item.key === $5b7ccabde48fae90$var$SET_FILTER_ADD_SELECTION_TO_FILTER) isSelected = this.isAddCurrentSelectionToFilterChecked();
            else if (item.children) isSelected = this.areAllChildrenSelected(item);
            else isSelected = this.selectedKeys.has(item.key);
        } else {
            if (item === $5b7ccabde48fae90$var$SET_FILTER_SELECT_ALL) isSelected = this.isSelectAllSelected();
            else if (item === $5b7ccabde48fae90$var$SET_FILTER_ADD_SELECTION_TO_FILTER) isSelected = this.isAddCurrentSelectionToFilterChecked();
            else isSelected = this.selectedKeys.has(item);
        }
        return {
            isSelected: isSelected,
            isExpanded: isExpanded
        };
    }
    isSetFilterModelTreeItem(item) {
        return item?.treeKey !== void 0;
    }
    initMiniFilter() {
        const { eMiniFilter: eMiniFilter } = this;
        this.updateMiniFilter();
        eMiniFilter.onValueChange(()=>this.onMiniFilterInput());
        eMiniFilter.setInputAriaLabel($5b7ccabde48fae90$var$translateForSetFilter(this, "ariaSearchFilterValues"));
        this.addManagedElementListeners(eMiniFilter.getInputElement(), {
            keydown: (e)=>this.onMiniFilterKeyDown(e)
        });
    }
    updateMiniFilter() {
        const { eMiniFilter: eMiniFilter, miniFilterText: miniFilterText, params: params } = this;
        eMiniFilter.setDisplayed(!params.suppressMiniFilter);
        eMiniFilter.setValue(miniFilterText);
    }
    // we need to have the GUI attached before we can draw the virtual rows, as the
    // virtual row logic needs info about the GUI state
    afterGuiAttached(params) {
        super.afterGuiAttached(params);
        this.resetExpansion();
        this.refreshVirtualList();
        const { eMiniFilter: eMiniFilter } = this;
        eMiniFilter.setInputPlaceholder($5b7ccabde48fae90$var$translateForSetFilter(this, "searchOoo"));
        if (!params || !params.suppressFocus) {
            if (eMiniFilter.isDisplayed()) eMiniFilter.getFocusableElement().focus();
            else this.virtualList.awaitStable(()=>this.virtualList.focusRow(0));
        }
    }
    afterGuiDetached() {
        super.afterGuiDetached();
        const { column: column, excelMode: excelMode, model: model, onStateChange: onStateChange } = this.params;
        if (this.beans.colFilter?.shouldKeepStateOnDetach(column)) return;
        if (excelMode) this.resetMiniFilter();
        if (excelMode || model !== this.state.model) {
            onStateChange({
                model: model,
                state: this.getState()
            });
            this.showOrHideResults();
        }
    }
    canApply(model) {
        return this.params.excelMode ? model == null || model.values.length > 0 : true;
    }
    /**
   * @deprecated v34 Internal method - should only be called by the grid.
   */ onNewRowsLoaded() {}
    /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */ setFilterValues(values) {
        (0, $jIDNV._warn)(283);
        this.handler.setFilterValues(values);
    }
    /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */ resetFilterValues() {
        (0, $jIDNV._warn)(283);
        this.handler.resetFilterValues();
    }
    /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */ refreshFilterValues() {
        (0, $jIDNV._warn)(283);
        this.doRefreshFilterValues();
    }
    doRefreshFilterValues() {
        this.handler.refreshFilterValues();
    }
    /**
   * @deprecated v34 Internal method - should only be called by the grid.
   */ onAnyFilterChanged() {}
    onMiniFilterInput() {
        if (!this.doSetMiniFilter(this.eMiniFilter.getValue())) return;
        const { applyMiniFilterWhileTyping: applyMiniFilterWhileTyping, readOnly: readOnly, excelMode: excelMode } = this.params;
        const updateSelections = !readOnly && (applyMiniFilterWhileTyping || !!excelMode);
        const apply = applyMiniFilterWhileTyping && !readOnly ? "debounce" : void 0;
        this.updateUiAfterMiniFilterChange(updateSelections, apply);
    }
    updateUiAfterMiniFilterChange(updateSelections, apply) {
        if (updateSelections) {
            const { excelMode: excelMode, readOnly: readOnly, model: model } = this.params;
            if (excelMode && !readOnly && this.miniFilterText == null) this.setModelAndRefresh(model?.values ?? null);
            else this.selectAllMatchingMiniFilter(true);
        }
        this.checkAndRefreshVirtualList();
        this.onUiChanged(updateSelections ? apply : "prevent");
        this.showOrHideResults();
    }
    showOrHideResults() {
        const hideResults = this.miniFilterText != null && this.displayValueModel.getDisplayedValueCount() < 1;
        (0, $jIDNV._setDisplayed)(this.eFilterNoMatches, hideResults);
        (0, $jIDNV._setDisplayed)(this.eSetFilterList, !hideResults);
    }
    resetMiniFilter() {
        this.eMiniFilter.setValue(null, true);
        this.doSetMiniFilter(null);
    }
    onMiniFilterKeyDown(e) {
        const { excelMode: excelMode, readOnly: readOnly } = this.params;
        if (e.key === (0, $jIDNV.KeyCode).ENTER && !excelMode && !readOnly) this.updateUiAfterMiniFilterChange(true, "immediately");
    }
    focusRowIfAlive(rowIndex) {
        if (rowIndex == null) return Promise.resolve();
        return new Promise((res)=>{
            window.setTimeout(()=>{
                if (this.isAlive()) this.virtualList.focusRow(rowIndex);
                res();
            }, 0);
        });
    }
    onSelectAll(isSelected) {
        if (isSelected) this.selectAllMatchingMiniFilter();
        else this.deselectAllMatchingMiniFilter();
        this.refreshAfterSelection();
    }
    onGroupItemSelected(item, isSelected) {
        const recursiveGroupSelection = (i)=>{
            if (!i.filterPasses) return;
            const children = i.children;
            if (children) for (const childItem of children.values())recursiveGroupSelection(childItem);
            else this.setKeySelected(i.key, isSelected);
        };
        recursiveGroupSelection(item);
        this.refreshAfterSelection();
    }
    onItemSelected(key, isSelected) {
        this.setKeySelected(key, isSelected);
        this.refreshAfterSelection();
    }
    onExpandAll(item, isExpanded) {
        const recursiveExpansion = (i)=>{
            if (i.filterPasses && i.available && i.children) {
                for (const childItem of i.children.values())recursiveExpansion(childItem);
                i.expanded = isExpanded;
            }
        };
        recursiveExpansion(item);
        this.refreshAfterExpansion();
    }
    onExpandedChanged(item, isExpanded) {
        item.expanded = isExpanded;
        this.refreshAfterExpansion();
    }
    refreshAfterExpansion() {
        const focusedRow = this.virtualList.getLastFocusedRow();
        this.updateDisplayedValues("expansion");
        this.checkAndRefreshVirtualList();
        this.focusRowIfAlive(focusedRow);
    }
    refreshAfterSelection() {
        const focusedRow = this.virtualList.getLastFocusedRow();
        this.checkAndRefreshVirtualList();
        this.onUiChanged();
        this.focusRowIfAlive(focusedRow);
    }
    setMiniFilter(newMiniFilter) {
        this.eMiniFilter.setValue(newMiniFilter);
        this.onMiniFilterInput();
    }
    /** Sets mini filter value. Returns true if it changed from last value, otherwise false. */ doSetMiniFilter(value) {
        value = (0, $jIDNV._makeNull)(value);
        if (this.miniFilterText === value) return false;
        if (value === null) this.addCurrentSelectionToFilter = false;
        this.miniFilterText = value;
        this.updateDisplayedValues("miniFilter");
        return true;
    }
    getMiniFilter() {
        return this.miniFilterText;
    }
    getUiChangeEventParams() {
        return {
            miniFilterValue: this.miniFilterText
        };
    }
    getState() {
        const miniFilterValue = this.miniFilterText;
        return miniFilterValue ? {
            miniFilterValue: miniFilterValue
        } : void 0;
    }
    checkAndRefreshVirtualList() {
        this.virtualList.refresh(!this.hardRefreshVirtualList);
        if (this.hardRefreshVirtualList) this.hardRefreshVirtualList = false;
    }
    /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */ getFilterKeys() {
        (0, $jIDNV._warn)(283);
        return this.handler.getFilterKeys();
    }
    /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */ getFilterValues() {
        (0, $jIDNV._warn)(283);
        return this.handler.getFilterValues();
    }
    refreshVirtualList() {
        if (this.params.refreshValuesOnOpen) this.doRefreshFilterValues();
        else this.checkAndRefreshVirtualList();
    }
    isSelectAllSelected() {
        if (!this.params.defaultToNothingSelected) {
            if (this.hasSelections() && this.isNothingVisibleSelected()) return false;
            if (this.isEverythingVisibleSelected()) return true;
        } else {
            if (this.hasSelections() && this.isEverythingVisibleSelected()) return true;
            if (this.isNothingVisibleSelected()) return false;
        }
        return void 0;
    }
    areAllChildrenSelected(item) {
        const recursiveChildSelectionCheck = (i)=>{
            if (i.children) {
                let someTrue = false;
                let someFalse = false;
                for (const child of i.children.values()){
                    if (!child.filterPasses || !child.available) continue;
                    const childSelected = recursiveChildSelectionCheck(child);
                    if (childSelected === void 0) return void 0;
                    if (childSelected) someTrue = true;
                    else someFalse = true;
                    if (someTrue && someFalse) return void 0;
                }
                return someTrue;
            } else return this.selectedKeys.has(i.key);
        };
        if (!this.params.defaultToNothingSelected) return recursiveChildSelectionCheck(item);
        else return this.hasSelections() && recursiveChildSelectionCheck(item);
    }
    resetExpansion() {
        if (!this.params.treeList) return;
        const selectAllItem = this.displayValueModel.getSelectAllItem();
        if (this.isSetFilterModelTreeItem(selectAllItem)) {
            const recursiveCollapse = (i)=>{
                const children = i.children;
                if (children) {
                    for (const childItem of children.values())recursiveCollapse(childItem);
                    i.expanded = false;
                }
            };
            recursiveCollapse(selectAllItem);
            this.updateDisplayedValues("expansion");
        }
    }
    getModelAsString(model) {
        return this.handler.getModelAsString(model);
    }
    getPositionableElement() {
        return this.eSetFilterList;
    }
    updateDisplayedValues(source, allKeys) {
        if (source === "expansion") {
            this.displayValueModel.refresh();
            return;
        }
        const handler = this.handler;
        const valueModel = handler.valueModel;
        if (this.miniFilterText == null) {
            this.displayValueModel.updateDisplayedValuesToAllAvailable((key)=>valueModel.allValues.get(key) ?? null, allKeys, valueModel.availableKeys, source);
            return;
        }
        const formattedFilterText = handler.caseFormat(this.formatter(this.miniFilterText) || "");
        const matchesFilter = (valueToCheck)=>valueToCheck != null && handler.caseFormat(valueToCheck).indexOf(formattedFilterText) >= 0;
        const nullMatchesFilter = !!this.params.excelMode && matchesFilter($5b7ccabde48fae90$var$translateForSetFilter(this, "blanks"));
        this.displayValueModel.updateDisplayedValuesToMatchMiniFilter((key)=>valueModel.allValues.get(key) ?? null, allKeys, valueModel.availableKeys, matchesFilter, nullMatchesFilter, source);
    }
    hasSelections() {
        return this.params.defaultToNothingSelected ? this.selectedKeys.size > 0 : this.handler.valueModel.allValues.size !== this.selectedKeys.size;
    }
    isInWindowsExcelMode() {
        return this.params.excelMode === "windows";
    }
    isAddCurrentSelectionToFilterChecked() {
        return this.isInWindowsExcelMode() && this.addCurrentSelectionToFilter;
    }
    showAddCurrentSelectionToFilter() {
        return this.isInWindowsExcelMode() && (0, $jIDNV._exists)(this.miniFilterText) && this.miniFilterText.length > 0;
    }
    selectAllMatchingMiniFilter(clearExistingSelection = false) {
        if (this.miniFilterText == null) this.selectedKeys = new Set(this.handler.valueModel.allValues.keys());
        else {
            if (clearExistingSelection) this.selectedKeys.clear();
            this.displayValueModel.forEachDisplayedKey((key)=>this.selectedKeys.add(key));
        }
    }
    deselectAllMatchingMiniFilter() {
        if (this.miniFilterText == null) this.selectedKeys.clear();
        else this.displayValueModel.forEachDisplayedKey((key)=>this.selectedKeys.delete(key));
    }
    setKeySelected(key, selected) {
        if (selected) this.selectedKeys.add(key);
        else {
            if (this.params.excelMode && this.isEverythingVisibleSelected()) this.resetSelectionState(this.displayValueModel.getDisplayedKeys());
            this.selectedKeys.delete(key);
        }
    }
    isEverythingVisibleSelected() {
        return !this.displayValueModel.someDisplayedKey((it)=>!this.selectedKeys.has(it));
    }
    isNothingVisibleSelected() {
        return !this.displayValueModel.someDisplayedKey((it)=>this.selectedKeys.has(it));
    }
    getSelectedModel() {
        if (!this.hasSelections()) return null;
        const filteringKeys = this.isAddCurrentSelectionToFilterChecked() ? this.params.model?.values : void 0;
        if (filteringKeys?.length) {
            if (this.selectedKeys) {
                const modelKeys = /* @__PURE__ */ new Set([
                    ...filteringKeys,
                    ...this.selectedKeys
                ]);
                return Array.from(modelKeys);
            }
            return Array.from(filteringKeys);
        }
        return Array.from(this.selectedKeys);
    }
    setSelectedModel(model) {
        const handler = this.handler;
        const valueModel = handler.valueModel;
        return valueModel.allKeys.then((keys)=>{
            if (model == null) this.resetSelectionState(keys ?? []);
            else {
                this.selectedKeys.clear();
                const existingFormattedKeys = /* @__PURE__ */ new Map();
                valueModel.allValues.forEach((_value, key)=>{
                    existingFormattedKeys.set(handler.caseFormat(key), key);
                });
                model.forEach((unformattedKey)=>{
                    const formattedKey = handler.caseFormat((0, $jIDNV._makeNull)(unformattedKey));
                    const existingUnformattedKey = existingFormattedKeys.get(formattedKey);
                    if (existingUnformattedKey !== void 0) this.selectedKeys.add(existingUnformattedKey);
                });
            }
        });
    }
    resetSelectionState(keys) {
        if (this.params.defaultToNothingSelected) this.selectedKeys.clear();
        else this.selectedKeys = new Set(keys);
    }
    getFilterHandler() {
        return this.handler;
    }
    destroy() {
        this.virtualList = this.destroyBean(this.virtualList);
        this.handlerDestroyFuncs?.forEach((func)=>func());
        this.handler = void 0;
        this.displayValueModel = void 0;
        this.selectedKeys.clear();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$ModelWrapper = class {
    constructor(model){
        this.model = model;
    }
    getRowCount() {
        return this.model.getDisplayedValueCount();
    }
    getRow(index) {
        return this.model.getDisplayedItem(index);
    }
    areRowsEqual(oldRow, newRow) {
        return oldRow === newRow;
    }
};
var $5b7ccabde48fae90$var$ModelWrapperWithSelectAll = class {
    constructor(model, showAddCurrentSelectionToFilter){
        this.model = model;
        this.showAddCurrentSelectionToFilter = showAddCurrentSelectionToFilter;
    }
    getRowCount() {
        const showAddCurrentSelectionToFilter = this.showAddCurrentSelectionToFilter();
        const outboundItems = showAddCurrentSelectionToFilter ? 2 : 1;
        return this.model.getDisplayedValueCount() + outboundItems;
    }
    getRow(index) {
        if (index === 0) return this.model.getSelectAllItem();
        const showAddCurrentSelectionToFilter = this.showAddCurrentSelectionToFilter();
        const outboundItems = showAddCurrentSelectionToFilter ? 2 : 1;
        if (index === 1 && showAddCurrentSelectionToFilter) return this.model.getAddSelectionToFilterItem();
        return this.model.getDisplayedItem(index - outboundItems);
    }
    areRowsEqual(oldRow, newRow) {
        return oldRow === newRow;
    }
};
var $5b7ccabde48fae90$var$TreeModelWrapper = class {
    constructor(model){
        this.model = model;
    }
    getRowCount() {
        return this.model.getRowCount();
    }
    getRow(index) {
        return this.model.getRow(index);
    }
    areRowsEqual(oldRow, newRow) {
        if (oldRow == null && newRow == null) return true;
        return oldRow != null && newRow != null && oldRow.treeKey === newRow.treeKey && oldRow.depth === newRow.depth;
    }
};
var $5b7ccabde48fae90$var$ClientSideValuesExtractor = class extends (0, $jIDNV.BeanStub) {
    constructor(createKey, caseFormat, getValue, isTreeDataOrGrouping, isTreeData){
        super();
        this.createKey = createKey;
        this.caseFormat = caseFormat;
        this.getValue = getValue;
        this.isTreeDataOrGrouping = isTreeDataOrGrouping;
        this.isTreeData = isTreeData;
    }
    extractUniqueValuesAsync(predicate, existingValues) {
        return new (0, $jIDNV.AgPromise)((resolve)=>{
            if (this.beans.rowModel.isRowDataLoaded()) resolve(this.extractUniqueValues(predicate, existingValues));
            else {
                const [destroyFunc] = this.addManagedEventListeners({
                    rowCountReady: ()=>{
                        destroyFunc?.();
                        resolve(this.extractUniqueValues(predicate, existingValues));
                    }
                });
            }
        });
    }
    extractUniqueValues(predicate, existingValues) {
        const values = /* @__PURE__ */ new Map();
        const existingFormattedKeys = this.extractExistingFormattedKeys(existingValues);
        const formattedKeys = /* @__PURE__ */ new Set();
        const treeData = this.isTreeData();
        const treeDataOrGrouping = this.isTreeDataOrGrouping();
        const groupedCols = this.beans.rowGroupColsSvc?.columns;
        const groupAllowUnbalanced = this.gos.get("groupAllowUnbalanced");
        const addValue = (unformattedKey, value)=>{
            const formattedKey = this.caseFormat(unformattedKey);
            if (!formattedKeys.has(formattedKey)) {
                formattedKeys.add(formattedKey);
                let keyToAdd = unformattedKey;
                let valueToAdd = (0, $jIDNV._makeNull)(value);
                const existingUnformattedKey = existingFormattedKeys?.get(formattedKey);
                if (existingUnformattedKey != null) {
                    keyToAdd = existingUnformattedKey;
                    valueToAdd = existingValues.get(existingUnformattedKey);
                }
                values.set(keyToAdd, valueToAdd);
            }
        };
        this.beans.rowModel.forEachLeafNode((node)=>{
            if (!node.data || !predicate(node)) return;
            if (treeDataOrGrouping) {
                this.addValueForTreeDataOrGrouping(node, treeData, groupedCols, addValue, groupAllowUnbalanced);
                return;
            }
            const value = this.getValue(node);
            if (value != null && Array.isArray(value)) {
                value.forEach((x)=>{
                    addValue(this.createKey(x, node), x);
                });
                if (value.length === 0) addValue(null, null);
            } else addValue(this.createKey(value, node), value);
        });
        return values;
    }
    addValueForTreeDataOrGrouping(node, treeData, groupedCols = [], addValue, groupAllowUnbalanced) {
        let dataPath;
        if (treeData) {
            if (node.childrenAfterGroup?.length) return;
            dataPath = node.getRoute() ?? [
                node.key ?? node.id
            ];
        } else {
            dataPath = groupedCols.map((groupCol)=>this.beans.valueSvc.getKeyForNode(groupCol, node));
            dataPath.push(this.getValue(node));
        }
        const processedDataPath = $5b7ccabde48fae90$var$processDataPath(dataPath, treeData, groupAllowUnbalanced);
        addValue(this.createKey(processedDataPath), processedDataPath);
    }
    extractExistingFormattedKeys(existingValues) {
        if (!existingValues) return null;
        const existingFormattedKeys = /* @__PURE__ */ new Map();
        existingValues.forEach((_value, key)=>{
            existingFormattedKeys.set(this.caseFormat(key), key);
        });
        return existingFormattedKeys;
    }
};
// packages/ag-grid-enterprise/src/setFilter/setFilterAppliedModel.ts
var $5b7ccabde48fae90$var$SetFilterAppliedModel = class {
    constructor(caseFormat){
        this.caseFormat = caseFormat;
        // This attribute contains keys that are actually used for filtering.
        // These keys take into account case sensitivity:
        // - When filtering is case-insensitive, all filtering keys are converted to upper case and stored here.
        this.keys = null;
    }
    /** No model applied */ isNull() {
        return this.keys == null;
    }
    /** Nothing selected */ isEmpty() {
        return !this.keys?.size;
    }
    update(appliedModel) {
        const keys = /* @__PURE__ */ new Set();
        this.keys = keys;
        const values = appliedModel?.values;
        if (values) {
            const caseFormat = this.caseFormat;
            for(let i = 0, len = values.length; i < len; i++)keys.add(caseFormat(values[i]));
        }
    }
    has(key) {
        return !!this.keys?.has(this.caseFormat(key));
    }
    destroy() {
        this.keys = null;
    }
};
var $5b7ccabde48fae90$var$SetFilterModelValuesType = /* @__PURE__ */ ((SetFilterModelValuesType2)=>{
    SetFilterModelValuesType2[SetFilterModelValuesType2["PROVIDED_LIST"] = 0] = "PROVIDED_LIST";
    SetFilterModelValuesType2[SetFilterModelValuesType2["PROVIDED_CALLBACK"] = 1] = "PROVIDED_CALLBACK";
    SetFilterModelValuesType2[SetFilterModelValuesType2["TAKEN_FROM_GRID_VALUES"] = 2] = "TAKEN_FROM_GRID_VALUES";
    return SetFilterModelValuesType2;
})($5b7ccabde48fae90$var$SetFilterModelValuesType || {});
var $5b7ccabde48fae90$var$setValueModel_default = $5b7ccabde48fae90$var$SetFilterModelValuesType;
var $5b7ccabde48fae90$var$SetValueModel = class extends (0, $jIDNV.BeanStub) {
    constructor(clientSideValuesExtractor, caseFormat, createKey, isTreeDataOrGrouping, params){
        super();
        this.clientSideValuesExtractor = clientSideValuesExtractor;
        this.caseFormat = caseFormat;
        this.createKey = createKey;
        this.isTreeDataOrGrouping = isTreeDataOrGrouping;
        this.params = params;
        /** All possible values for the filter, sorted if required. */ this.allValues = /* @__PURE__ */ new Map();
        /** Remaining keys when filters from other columns have been applied. */ this.availableKeys = /* @__PURE__ */ new Set();
        this.providedValues = null;
        this.initialised = false;
    }
    postConstruct() {
        const params = this.params;
        const values = params.handlerParams.filterParams.values;
        this.updateParams(params);
        if (values == null) this.valuesType = 2 /* TAKEN_FROM_GRID_VALUES */ ;
        else {
            this.valuesType = Array.isArray(values) ? 0 /* PROVIDED_LIST */  : 1 /* PROVIDED_CALLBACK */ ;
            this.providedValues = values;
        }
        this.updateAllValues();
    }
    refresh(params) {
        const handlerParams = params.handlerParams;
        if (handlerParams.source !== "colDef") return;
        const { values: values, suppressSorting: suppressSorting } = handlerParams.filterParams;
        const currentProvidedValues = this.providedValues;
        const currentSuppressSorting = this.params.handlerParams.filterParams.suppressSorting;
        this.params = params;
        this.updateParams(params);
        this.providedValues = values ?? null;
        if (this.providedValues !== currentProvidedValues || suppressSorting !== currentSuppressSorting) {
            if (!values || values.length === 0) {
                this.valuesType = 2 /* TAKEN_FROM_GRID_VALUES */ ;
                this.providedValues = null;
            } else this.valuesType = Array.isArray(values) ? 0 /* PROVIDED_LIST */  : 1 /* PROVIDED_CALLBACK */ ;
            this.updateAllValues();
        }
    }
    updateParams(params) {
        const { handlerParams: { colDef: colDef, filterParams: { comparator: comparator, treeList: treeList, treeListPathGetter: treeListPathGetter } }, usingComplexObjects: usingComplexObjects } = params;
        const keyComparator = comparator ?? colDef.comparator;
        const treeDataOrGrouping = this.isTreeDataOrGrouping();
        let entryComparator;
        if (treeDataOrGrouping && !keyComparator) entryComparator = $5b7ccabde48fae90$var$createTreeDataOrGroupingComparator();
        else if (treeList && !treeListPathGetter && !keyComparator) entryComparator = ([_aKey, aValue], [_bKey, bValue])=>(0, $jIDNV._defaultComparator)(aValue, bValue);
        else entryComparator = ([_aKey, aValue], [_bKey, bValue])=>keyComparator(aValue, bValue);
        this.entryComparator = entryComparator;
        this.keyComparator = keyComparator ?? (0, $jIDNV._defaultComparator);
        this.compareByValue = !!(usingComplexObjects && keyComparator || treeDataOrGrouping || treeList && !treeListPathGetter);
    }
    updateAllValues() {
        this.allKeys = new (0, $jIDNV.AgPromise)((resolve)=>{
            switch(this.valuesType){
                case 2 /* TAKEN_FROM_GRID_VALUES */ :
                    this.getValuesFromRowsAsync().then((values)=>resolve(this.processAllValues(values)));
                    break;
                case 0 /* PROVIDED_LIST */ :
                    resolve(this.processAllValues(this.uniqueValues(this.validateProvidedValues(this.providedValues))));
                    break;
                case 1 /* PROVIDED_CALLBACK */ :
                    {
                        this.dispatchLocalEvent({
                            type: "loadingStart"
                        });
                        const callback = this.providedValues;
                        const { column: column, colDef: colDef } = this.params.handlerParams;
                        const params = (0, $jIDNV._addGridCommonParams)(this.gos, {
                            success: (values)=>{
                                this.dispatchLocalEvent({
                                    type: "loadingEnd"
                                });
                                resolve(this.processAllValues(this.uniqueValues(this.validateProvidedValues(values))));
                            },
                            colDef: colDef,
                            column: column
                        });
                        window.setTimeout(()=>callback(params), 0);
                        break;
                    }
            }
        });
        this.allKeys.then((values)=>{
            this.updateAvailableKeys(values ?? []);
            this.initialised = true;
        });
        return this.allKeys;
    }
    getAvailableValues(predicate) {
        return this.sortKeys(this.getValuesFromRows(predicate));
    }
    overrideValues(valuesToUse) {
        return this.allKeys.then(()=>{
            this.valuesType = 0 /* PROVIDED_LIST */ ;
            this.providedValues = valuesToUse;
        });
    }
    refreshAvailable() {
        return new (0, $jIDNV.AgPromise)((resolve)=>{
            if (this.showAvailableOnly()) {
                this.allKeys.then((keys)=>{
                    const updatedKeys = keys ?? [];
                    this.updateAvailableKeys(updatedKeys);
                    resolve(true);
                });
                return;
            }
            resolve(false);
        });
    }
    refreshAll() {
        return new (0, $jIDNV.AgPromise)((resolve)=>{
            this.allKeys.then(()=>{
                this.updateAllValues().then(()=>{
                    resolve();
                });
            });
        });
    }
    isLoading() {
        return !this.initialised && this.valuesType === 1 /* PROVIDED_CALLBACK */ ;
    }
    isInitialised() {
        return this.initialised;
    }
    getValueForFormatter(key) {
        return this.initialised ? this.allValues.get(key) : key;
    }
    getAvailableKeys(values) {
        return this.initialised ? values.filter((v)=>this.availableKeys.has(v)) : values;
    }
    getParamsForValuesFromRows(removeUnavailableValues) {
        if (!this.clientSideValuesExtractor) {
            (0, $jIDNV._error)(113);
            return void 0;
        }
        const existingValues = removeUnavailableValues && !this.params.handlerParams.filterParams.caseSensitive ? this.allValues : void 0;
        return existingValues;
    }
    getValuesFromRows(predicate) {
        const existingValues = this.getParamsForValuesFromRows(true);
        return this.clientSideValuesExtractor?.extractUniqueValues(predicate, existingValues) ?? null;
    }
    getValuesFromRowsAsync() {
        const existingValues = this.getParamsForValuesFromRows(false);
        return this.clientSideValuesExtractor?.extractUniqueValuesAsync(()=>true, existingValues) ?? (0, $jIDNV.AgPromise).resolve(null);
    }
    processAllValues(values) {
        const sortedKeys = this.sortKeys(values);
        this.allValues = values ?? /* @__PURE__ */ new Map();
        return sortedKeys;
    }
    uniqueValues(values) {
        const uniqueValues = /* @__PURE__ */ new Map();
        const formattedKeys = /* @__PURE__ */ new Set();
        const { caseFormat: caseFormat, createKey: createKey } = this;
        (values ?? []).forEach((value)=>{
            const valueToUse = (0, $jIDNV._makeNull)(value);
            const unformattedKey = createKey(valueToUse);
            const formattedKey = caseFormat(unformattedKey);
            if (!formattedKeys.has(formattedKey)) {
                formattedKeys.add(formattedKey);
                uniqueValues.set(unformattedKey, valueToUse);
            }
        });
        return uniqueValues;
    }
    validateProvidedValues(values) {
        if (this.params.usingComplexObjects && values?.length) {
            const firstValue = values[0];
            if (firstValue && typeof firstValue !== "object" && typeof firstValue !== "function") {
                const firstKey = this.createKey(firstValue);
                if (firstKey == null) (0, $jIDNV._warn)(209);
                else (0, $jIDNV._warn)(210);
            }
        }
        return values;
    }
    sortKeys(nullableValues) {
        const values = nullableValues ?? /* @__PURE__ */ new Map();
        const filterParams = this.params.handlerParams.filterParams;
        if (filterParams.suppressSorting) return Array.from(values.keys());
        let sortedKeys;
        if (this.compareByValue) sortedKeys = Array.from(values.entries()).sort(this.entryComparator).map(([key])=>key);
        else sortedKeys = Array.from(values.keys()).sort(this.keyComparator);
        if (filterParams.excelMode && values.has(null)) {
            sortedKeys = sortedKeys.filter((v)=>v != null);
            sortedKeys.push(null);
        }
        return sortedKeys;
    }
    showAvailableOnly() {
        return this.valuesType === 2 /* TAKEN_FROM_GRID_VALUES */ ;
    }
    updateAvailableKeys(allKeys) {
        const availableKeys = this.showAvailableOnly() ? this.getAvailableValues((node)=>this.params.handlerParams.doesRowPassOtherFilter(node)) : allKeys;
        this.availableKeys = new Set(availableKeys);
        this.dispatchLocalEvent({
            type: "availableValuesChanged"
        });
    }
};
// packages/ag-grid-enterprise/src/setFilter/setFilterHandler.ts
var $5b7ccabde48fae90$var$SetFilterHandler = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        /** Used to get the filter type for filter models. */ this.filterType = "set";
        this.treeDataTreeList = false;
        this.groupingTreeList = false;
        this.caseSensitive = false;
        this.noValueFormatterSupplied = false;
    }
    init(params) {
        this.updateParams(params);
        const isTreeDataOrGrouping = this.isTreeDataOrGrouping.bind(this);
        const isTreeData = ()=>this.treeDataTreeList;
        const createKey = this.createKey;
        const caseFormat = this.caseFormat.bind(this);
        const { gos: gos, beans: beans } = this;
        const clientSideValuesExtractor = (0, $jIDNV._isClientSideRowModel)(gos, beans.rowModel) ? this.createManagedBean(new $5b7ccabde48fae90$var$ClientSideValuesExtractor(createKey, caseFormat, params.getValue, isTreeDataOrGrouping, isTreeData)) : void 0;
        this.valueModel = this.createManagedBean(new $5b7ccabde48fae90$var$SetValueModel(clientSideValuesExtractor, caseFormat, createKey, isTreeDataOrGrouping, {
            handlerParams: params,
            usingComplexObjects: !!(params.filterParams.keyCreator ?? params.colDef.keyCreator)
        }));
        this.appliedModel = new $5b7ccabde48fae90$var$SetFilterAppliedModel(this.caseFormat.bind(this));
        this.appliedModel.update(params.model);
        this.validateModel(params);
        this.addEventListenersForDataChanges();
    }
    refresh(params) {
        this.updateParams(params);
        this.valueModel.refresh({
            handlerParams: params,
            usingComplexObjects: !!(params.filterParams.keyCreator ?? params.colDef.keyCreator)
        });
        this.appliedModel.update(params.model);
        this.validateModel(params);
    }
    updateParams(params) {
        this.params = params;
        const { colDef: colDef, filterParams: { caseSensitive: caseSensitive, treeList: treeList, keyCreator: keyCreator, valueFormatter: valueFormatter } } = params;
        this.caseSensitive = !!caseSensitive;
        const isGroupCol = !!colDef.showRowGroup;
        this.treeDataTreeList = this.gos.get("treeData") && !!treeList && isGroupCol;
        this.groupingTreeList = !!this.beans.rowGroupColsSvc?.columns.length && !!treeList && isGroupCol;
        const resolvedKeyCreator = keyCreator ?? colDef.keyCreator;
        this.createKey = this.generateCreateKey(resolvedKeyCreator, this.isTreeDataOrGrouping());
        this.setValueFormatter(valueFormatter, resolvedKeyCreator, !!treeList, !!colDef.refData);
    }
    doesFilterPass(params) {
        const { appliedModel: appliedModel, treeDataTreeList: treeDataTreeList, groupingTreeList: groupingTreeList } = this;
        if (appliedModel.isNull()) return true;
        if (appliedModel.isEmpty()) return false;
        const { node: node } = params;
        if (treeDataTreeList) return this.doesFilterPassForTreeData(node);
        if (groupingTreeList) return this.doesFilterPassForGrouping(node);
        const value = this.params.getValue(node);
        if (value != null && Array.isArray(value)) {
            if (value.length === 0) return appliedModel.has(null);
            return value.some((v)=>appliedModel.has(this.createKey(v, node)));
        }
        return appliedModel.has(this.createKey(value, node));
    }
    getFormattedValue(key) {
        let value = this.valueModel.getValueForFormatter(key);
        if (this.noValueFormatterSupplied && this.isTreeDataOrGrouping() && Array.isArray(value)) value = (0, $jIDNV._last)(value);
        const formattedValue = this.beans.valueSvc.formatValue(this.params.column, null, value, this.valueFormatter, false);
        return (formattedValue == null ? (0, $jIDNV._toStringOrNull)(value) : formattedValue) ?? $5b7ccabde48fae90$var$translateForSetFilter(this, "blanks");
    }
    getModelAsString(model, source) {
        const { values: values } = model ?? {};
        const forToolPanel = source === "filterToolPanel";
        if (values == null) return forToolPanel ? $5b7ccabde48fae90$var$translateForSetFilter(this, "filterSummaryListInactive") : "";
        const availableKeys = this.valueModel.getAvailableKeys(values);
        const numValues = availableKeys.length;
        const numToDisplay = forToolPanel ? 3 : 10;
        const formattedValues = availableKeys.slice(0, numToDisplay).map((key)=>this.getFormattedValue(key));
        if (forToolPanel) {
            const valueList = formattedValues.join($5b7ccabde48fae90$var$translateForSetFilter(this, "filterSummaryListSeparator"));
            if (numValues > 3) return $5b7ccabde48fae90$var$translateForSetFilter(this, "filterSummaryListLong", [
                valueList,
                String(numValues - 3)
            ]);
            else return $5b7ccabde48fae90$var$translateForSetFilter(this, "filterSummaryListShort", [
                valueList
            ]);
        }
        return `(${numValues}) ${formattedValues.join(",")}${numValues > 10 ? ",..." : ""}`;
    }
    onAnyFilterChanged() {
        window.setTimeout(()=>{
            if (!this.isAlive()) return;
            this.valueModel.refreshAvailable().then((updated)=>{
                this.dispatchLocalEvent({
                    type: "anyFilterChanged",
                    updated: !!updated
                });
            });
        });
    }
    onNewRowsLoaded() {
        this.syncAfterDataChange();
    }
    setFilterValues(values) {
        this.valueModel.overrideValues(values).then(()=>{
            this.refreshFilterValues();
        });
    }
    resetFilterValues() {
        this.valueModel.valuesType = $5b7ccabde48fae90$var$setValueModel_default.TAKEN_FROM_GRID_VALUES;
        this.syncAfterDataChange();
    }
    refreshFilterValues() {
        if (!this.valueModel.isInitialised()) return;
        this.valueModel.refreshAll().then(()=>{
            this.dispatchLocalEvent({
                type: "dataChanged",
                hardRefresh: true
            });
            this.validateModel(this.params, void 0, true);
        });
    }
    getFilterKeys() {
        return Array.from(this.valueModel.allValues.keys());
    }
    getFilterValues() {
        return Array.from(this.valueModel.allValues.values());
    }
    isTreeDataOrGrouping() {
        return this.treeDataTreeList || this.groupingTreeList;
    }
    caseFormat(valueToFormat) {
        if (valueToFormat == null || typeof valueToFormat !== "string") return valueToFormat;
        return this.caseSensitive ? valueToFormat : valueToFormat.toUpperCase();
    }
    addEventListenersForDataChanges() {
        this.addManagedPropertyListeners([
            "groupAllowUnbalanced"
        ], ()=>this.syncAfterDataChange());
        const syncAfterDataChangeDebounced = (0, $jIDNV._debounce)(this, this.syncAfterDataChange.bind(this), 0);
        this.addManagedEventListeners({
            cellValueChanged: (event)=>{
                if (event.column === this.params.column) syncAfterDataChangeDebounced();
            }
        });
    }
    syncAfterDataChange() {
        if (!this.isValuesTakenFromGrid()) return;
        this.valueModel.refreshAll().then(()=>{
            this.dispatchLocalEvent({
                type: "dataChanged"
            });
            this.validateModel(this.params, {
                afterDataChange: true
            });
        });
    }
    validateModel(params, additionalEventAttributes, restrictToAvailableValues) {
        const valueModel = this.valueModel;
        valueModel.allKeys.then(()=>{
            const model = params.model;
            if (model == null) return;
            const existingFormattedKeys = /* @__PURE__ */ new Map();
            const addKey = (key)=>existingFormattedKeys.set(this.caseFormat(key), key);
            if (restrictToAvailableValues) for (const key of valueModel.availableKeys)addKey(key);
            else valueModel.allValues.forEach((_value, key)=>addKey(key));
            const newValues = [];
            let updated = false;
            for (const unformattedKey of model.values){
                const formattedKey = this.caseFormat((0, $jIDNV._makeNull)(unformattedKey));
                const existingUnformattedKey = existingFormattedKeys.get(formattedKey);
                if (existingUnformattedKey !== void 0) {
                    newValues.push(existingUnformattedKey);
                    if (existingUnformattedKey !== unformattedKey) updated = true;
                } else updated = true;
            }
            const numNewValues = newValues.length;
            if (numNewValues === 0 && params.filterParams.excelMode) {
                params.onModelChange(null, additionalEventAttributes);
                return;
            }
            const clearOnAllSelected = this.valueModel.valuesType === $5b7ccabde48fae90$var$setValueModel_default.TAKEN_FROM_GRID_VALUES || !params.filterParams.suppressClearModelOnRefreshValues;
            const allSelected = clearOnAllSelected && numNewValues === existingFormattedKeys.size;
            if (updated || !model.filterType || allSelected) {
                const newModel = allSelected ? null : {
                    filterType: this.filterType,
                    values: newValues
                };
                params.onModelChange(newModel, additionalEventAttributes);
                return;
            }
        });
    }
    isValuesTakenFromGrid() {
        return this.valueModel.valuesType === $5b7ccabde48fae90$var$setValueModel_default.TAKEN_FROM_GRID_VALUES;
    }
    doesFilterPassForTreeData(node) {
        if (node.childrenAfterGroup?.length) return false;
        const { gos: gos, appliedModel: appliedModel } = this;
        return appliedModel.has(this.createKey($5b7ccabde48fae90$var$processDataPath(node.getRoute() ?? [
            node.key ?? node.id
        ], true, gos.get("groupAllowUnbalanced"))));
    }
    doesFilterPassForGrouping(node) {
        const { appliedModel: appliedModel, params: params, gos: gos, beans: { rowGroupColsSvc: rowGroupColsSvc, valueSvc: valueSvc } } = this;
        const dataPath = (rowGroupColsSvc?.columns ?? []).map((groupCol)=>valueSvc.getKeyForNode(groupCol, node));
        dataPath.push(params.getValue(node));
        return appliedModel.has(this.createKey($5b7ccabde48fae90$var$processDataPath(dataPath, false, gos.get("groupAllowUnbalanced"))));
    }
    generateCreateKey(keyCreator, treeDataOrGrouping) {
        if (treeDataOrGrouping && !keyCreator) {
            (0, $jIDNV._error)(250);
            return ()=>null;
        }
        if (keyCreator) return (value, node = null)=>{
            const params = this.getKeyCreatorParams(value, node);
            return (0, $jIDNV._makeNull)(keyCreator(params));
        };
        return (value)=>(0, $jIDNV._makeNull)((0, $jIDNV._toStringOrNull)(value));
    }
    getKeyCreatorParams(value, node = null) {
        const { colDef: colDef, column: column } = this.params;
        return (0, $jIDNV._addGridCommonParams)(this.gos, {
            value: value,
            colDef: colDef,
            column: column,
            node: node,
            data: node?.data
        });
    }
    setValueFormatter(providedValueFormatter, keyCreator, treeList, isRefData) {
        let valueFormatter = providedValueFormatter;
        if (!valueFormatter) {
            if (keyCreator && !treeList) {
                (0, $jIDNV._error)(249);
                return;
            }
            this.noValueFormatterSupplied = true;
            if (!isRefData) valueFormatter = (params)=>(0, $jIDNV._toStringOrNull)(params.value);
        }
        this.valueFormatter = valueFormatter;
    }
    destroy() {
        this.appliedModel.destroy();
        super.destroy();
        this.valueModel = void 0;
    }
};
var $5b7ccabde48fae90$var$SetFloatingFilterElement = {
    tag: "div",
    cls: "ag-floating-filter-input ag-set-floating-filter-input",
    role: "presentation",
    children: [
        {
            tag: "ag-input-text-field",
            ref: "eFloatingFilterText"
        }
    ]
};
var $5b7ccabde48fae90$var$SetFloatingFilterComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$SetFloatingFilterElement, [
            (0, $jIDNV.AgInputTextFieldSelector)
        ]);
        this.eFloatingFilterText = (0, $jIDNV.RefPlaceholder);
        this.listenerAdded = false;
    }
    init(params) {
        this.params = params;
        this.eFloatingFilterText.setDisabled(true).addGuiEventListener("click", ()=>this.params.showParentFilter());
        this.setParams(params);
    }
    setParams(params) {
        const displayName = this.beans.colNames.getDisplayNameForColumn(params.column, "header", true);
        const translate = this.getLocaleTextFunc();
        this.eFloatingFilterText.setInputAriaLabel(`${displayName} ${translate("ariaFilterInput", "Filter Input")}`);
        if (this.gos.get("enableFilterHandlers")) {
            const reactiveParams = params;
            this.updateFloatingFilterText(reactiveParams.model);
        }
    }
    refresh(params) {
        this.params = params;
        this.setParams(params);
    }
    onParentModelChanged(parentModel) {
        this.updateFloatingFilterText(parentModel);
    }
    parentSetFilterInstance(cb) {
        this.params.parentFilterInstance((filter)=>{
            if (!(filter instanceof $5b7ccabde48fae90$var$SetFilter)) {
                (0, $jIDNV._error)(248);
                return;
            }
            cb(filter);
        });
    }
    addAvailableValuesListener() {
        const addListener = (handler)=>{
            if (handler == null || !handler.isAlive()) return;
            const valueModel = handler.valueModel;
            this.destroyListeners = valueModel.addManagedListeners(valueModel, {
                availableValuesChanged: ()=>this.updateFloatingFilterText(handler.params.model),
                destroyed: ()=>{
                    this.listenerAdded = false;
                    this.destroyListeners = void 0;
                }
            });
        };
        if (this.gos.get("enableFilterHandlers")) addListener(this.params.getHandler());
        else this.parentSetFilterInstance((setFilter)=>{
            addListener(setFilter.handler);
        });
        this.listenerAdded = true;
    }
    updateFloatingFilterText(parentModel) {
        if (!this.listenerAdded) this.addAvailableValuesListener();
        if (parentModel == null) this.eFloatingFilterText.setValue("");
        else if (this.gos.get("enableFilterHandlers")) this.eFloatingFilterText.setValue(this.params.getHandler().getModelAsString?.(parentModel) ?? "");
        else this.parentSetFilterInstance((setFilter)=>{
            this.eFloatingFilterText.setValue(setFilter.getModelAsString(parentModel));
        });
    }
    destroy() {
        const destroyListeners = this.destroyListeners;
        if (destroyListeners) {
            destroyListeners.forEach((destroyFunc)=>destroyFunc());
            destroyListeners.length = 0;
        }
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/setFilter/setFilterModule.ts
var $5b7ccabde48fae90$export$4ab172eba3fdda9e = {
    moduleName: "SetFilter",
    version: $5b7ccabde48fae90$var$VERSION,
    userComponents: {
        agSetColumnFilter: {
            classImp: $5b7ccabde48fae90$var$SetFilter,
            params: {
                useForm: true
            },
            processParams: (params)=>{
                $5b7ccabde48fae90$var$applyExcelModeOptions(params);
                return params;
            }
        },
        agSetColumnFloatingFilter: $5b7ccabde48fae90$var$SetFloatingFilterComp
    },
    dynamicBeans: {
        agSetColumnFilterHandler: $5b7ccabde48fae90$var$SetFilterHandler
    },
    icons: {
        // set filter tree list group contracted (click to expand)
        setFilterGroupClosed: "tree-closed",
        // set filter tree list group expanded (click to contract)
        setFilterGroupOpen: "tree-open",
        // set filter tree list expand/collapse all button, shown when some children are expanded and
        //     others are collapsed
        setFilterGroupIndeterminate: "tree-indeterminate",
        // set filter async values loading
        setFilterLoading: "loading"
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $jIDNV._ColumnFilterModule)
    ]
};
// packages/ag-grid-enterprise/src/statusBar/agStatusBar.css-GENERATED.ts
var $5b7ccabde48fae90$var$agStatusBarCSS = /*css*/ `.ag-status-bar{border-top:var(--ag-footer-row-border);display:flex;justify-content:space-between;line-height:1.5;overflow:hidden;padding-left:calc(var(--ag-spacing)*4);padding-right:calc(var(--ag-spacing)*4)}.ag-status-panel,:where(.ag-status-panel.ag-status-panel-aggregations .ag-status-name-value){display:inline-flex}.ag-status-name-value{color:var(--ag-status-bar-label-color);font-weight:var(--ag-status-bar-label-font-weight);margin-left:var(--ag-spacing);margin-right:var(--ag-spacing);padding-bottom:var(--ag-widget-container-vertical-padding);padding-top:var(--ag-widget-container-vertical-padding);white-space:nowrap}.ag-status-name-value-value{color:var(--ag-status-bar-value-color);font-weight:var(--ag-status-bar-value-font-weight)}.ag-status-bar-left{display:inline-flex}.ag-status-bar-center{display:inline-flex;text-align:center}.ag-status-bar-right{display:inline-flex}`;
// packages/ag-grid-enterprise/src/statusBar/agStatusBar.ts
function $5b7ccabde48fae90$var$getStatusPanelCompDetails(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $5b7ccabde48fae90$var$StatusPanelComponent, void 0, params, true);
}
var $5b7ccabde48fae90$var$StatusPanelComponent = {
    name: "statusPanel",
    optionalMethods: [
        "refresh"
    ]
};
var $5b7ccabde48fae90$var$AgStatusBarElement = {
    tag: "div",
    cls: "ag-status-bar",
    children: [
        {
            tag: "div",
            ref: "eStatusBarLeft",
            cls: "ag-status-bar-left",
            role: "status"
        },
        {
            tag: "div",
            ref: "eStatusBarCenter",
            cls: "ag-status-bar-center",
            role: "status"
        },
        {
            tag: "div",
            ref: "eStatusBarRight",
            cls: "ag-status-bar-right",
            role: "status"
        }
    ]
};
var $5b7ccabde48fae90$var$AgStatusBar = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$AgStatusBarElement);
        this.updateQueued = false;
        this.panelsPromise = (0, $jIDNV.AgPromise).resolve();
        this.eStatusBarLeft = (0, $jIDNV.RefPlaceholder);
        this.eStatusBarCenter = (0, $jIDNV.RefPlaceholder);
        this.eStatusBarRight = (0, $jIDNV.RefPlaceholder);
        this.compDestroyFunctions = {};
        this.registerCSS($5b7ccabde48fae90$var$agStatusBarCSS);
    }
    wireBeans(beans) {
        this.userCompFactory = beans.userCompFactory;
        this.statusBarSvc = beans.statusBarSvc;
    }
    postConstruct() {
        this.processStatusPanels(/* @__PURE__ */ new Map());
        this.addManagedPropertyListeners([
            "statusBar"
        ], this.handleStatusBarChanged.bind(this));
    }
    processStatusPanels(existingStatusPanelsToReuse) {
        const statusPanels = this.gos.get("statusBar")?.statusPanels;
        if (statusPanels) {
            const leftStatusPanelComponents = statusPanels.filter((componentConfig)=>componentConfig.align === "left");
            const centerStatusPanelComponents = statusPanels.filter((componentConfig)=>componentConfig.align === "center");
            const rightStatusPanelComponents = statusPanels.filter((componentConfig)=>!componentConfig.align || componentConfig.align === "right");
            this.panelsPromise = (0, $jIDNV.AgPromise).all([
                this.createAndRenderComponents(leftStatusPanelComponents, this.eStatusBarLeft, existingStatusPanelsToReuse),
                this.createAndRenderComponents(centerStatusPanelComponents, this.eStatusBarCenter, existingStatusPanelsToReuse),
                this.createAndRenderComponents(rightStatusPanelComponents, this.eStatusBarRight, existingStatusPanelsToReuse)
            ]);
        } else this.setDisplayed(false);
    }
    handleStatusBarChanged() {
        if (this.updateQueued) return;
        this.updateQueued = true;
        this.panelsPromise.then(()=>{
            this.updateStatusBar();
            this.updateQueued = false;
        });
    }
    updateStatusBar() {
        const statusPanels = this.gos.get("statusBar")?.statusPanels;
        const validStatusBarPanelsProvided = Array.isArray(statusPanels) && statusPanels.length > 0;
        this.setDisplayed(validStatusBarPanelsProvided);
        const existingStatusPanelsToReuse = /* @__PURE__ */ new Map();
        if (validStatusBarPanelsProvided) statusPanels.forEach((statusPanelConfig)=>{
            const key = statusPanelConfig.key ?? statusPanelConfig.statusPanel;
            const existingStatusPanel = this.statusBarSvc.getStatusPanel(key);
            if (existingStatusPanel?.refresh) {
                const newParams = (0, $jIDNV._addGridCommonParams)(this.gos, {
                    ...statusPanelConfig.statusPanelParams ?? {},
                    key: key
                });
                const hasRefreshed = existingStatusPanel.refresh(newParams);
                if (hasRefreshed) {
                    existingStatusPanelsToReuse.set(key, existingStatusPanel);
                    delete this.compDestroyFunctions[key];
                    (0, $jIDNV._removeFromParent)(existingStatusPanel.getGui());
                }
            }
        });
        this.resetStatusBar();
        if (validStatusBarPanelsProvided) this.processStatusPanels(existingStatusPanelsToReuse);
    }
    resetStatusBar() {
        (0, $jIDNV._clearElement)(this.eStatusBarLeft);
        (0, $jIDNV._clearElement)(this.eStatusBarCenter);
        (0, $jIDNV._clearElement)(this.eStatusBarRight);
        this.destroyComponents();
        this.statusBarSvc.unregisterAllComponents();
    }
    destroy() {
        this.destroyComponents();
        super.destroy();
    }
    destroyComponents() {
        Object.values(this.compDestroyFunctions).forEach((func)=>func());
        this.compDestroyFunctions = {};
    }
    createAndRenderComponents(statusBarComponents, ePanelComponent, existingStatusPanelsToReuse) {
        const componentDetails = [];
        statusBarComponents.forEach((componentConfig)=>{
            const key = componentConfig.key || componentConfig.statusPanel;
            const existingStatusPanel = existingStatusPanelsToReuse.get(key);
            let promise;
            if (existingStatusPanel) promise = (0, $jIDNV.AgPromise).resolve(existingStatusPanel);
            else {
                const compDetails = $5b7ccabde48fae90$var$getStatusPanelCompDetails(this.userCompFactory, componentConfig, (0, $jIDNV._addGridCommonParams)(this.gos, {
                    key: key
                }));
                if (compDetails == null) return;
                promise = compDetails.newAgStackInstance();
            }
            componentDetails.push({
                key: key,
                promise: promise
            });
        });
        return (0, $jIDNV.AgPromise).all(componentDetails.map((details)=>details.promise)).then(()=>{
            componentDetails.forEach((componentDetail)=>{
                componentDetail.promise.then((component)=>{
                    const destroyFunc = ()=>{
                        this.destroyBean(component);
                    };
                    if (this.isAlive()) {
                        this.statusBarSvc.registerStatusPanel(componentDetail.key, component);
                        ePanelComponent.appendChild(component.getGui());
                        this.compDestroyFunctions[componentDetail.key] = destroyFunc;
                    } else destroyFunc();
                });
            });
        });
    }
};
var $5b7ccabde48fae90$var$AgStatusBarSelector = {
    selector: "AG-STATUS-BAR",
    component: $5b7ccabde48fae90$var$AgStatusBar
};
var $5b7ccabde48fae90$var$AgNameValueElement = {
    tag: "div",
    cls: "ag-status-name-value",
    children: [
        {
            tag: "span",
            ref: "eLabel"
        },
        ":\xa0",
        {
            tag: "span",
            ref: "eValue",
            cls: "ag-status-name-value-value"
        }
    ]
};
var $5b7ccabde48fae90$var$AgNameValue = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$AgNameValueElement);
        this.eLabel = (0, $jIDNV.RefPlaceholder);
        this.eValue = (0, $jIDNV.RefPlaceholder);
    }
    setLabel(key, defaultValue) {
        this.setDisplayed(false);
        this.eLabel.textContent = this.getLocaleTextFunc()(key, defaultValue);
    }
    setValue(value, totalRows) {
        this.eValue.textContent = this.valueFormatter((0, $jIDNV._addGridCommonParams)(this.gos, {
            value: value,
            totalRows: totalRows,
            key: this.key
        }));
    }
};
var $5b7ccabde48fae90$var$AgNameValueSelector = {
    selector: "AG-NAME-VALUE",
    component: $5b7ccabde48fae90$var$AgNameValue
};
// packages/ag-grid-enterprise/src/statusBar/providedPanels/utils.ts
var $5b7ccabde48fae90$var$_getFilteredRowCount = (rowModel)=>{
    let filteredRowCount = 0;
    rowModel.forEachNodeAfterFilter((node)=>{
        if (node.data) filteredRowCount++;
    });
    return filteredRowCount;
};
var $5b7ccabde48fae90$var$_getTotalRowCount = (rowModel)=>{
    let totalRowCount = 0;
    rowModel.forEachNode((node)=>{
        if (node.data) totalRowCount++;
    });
    return totalRowCount;
};
// packages/ag-grid-enterprise/src/statusBar/providedPanels/aggregationComp.ts
function $5b7ccabde48fae90$var$_formatNumberTwoDecimalPlacesAndCommas(value, getLocaleTextFunc) {
    if (typeof value !== "number") return "";
    return (0, $jIDNV._formatNumberCommas)(Math.round(value * 100) / 100, getLocaleTextFunc);
}
var $5b7ccabde48fae90$var$AggregationCompElement = {
    tag: "div",
    cls: "ag-status-panel ag-status-panel-aggregations",
    children: [
        {
            tag: "ag-name-value",
            ref: "avgAggregationComp"
        },
        {
            tag: "ag-name-value",
            ref: "countAggregationComp"
        },
        {
            tag: "ag-name-value",
            ref: "minAggregationComp"
        },
        {
            tag: "ag-name-value",
            ref: "maxAggregationComp"
        },
        {
            tag: "ag-name-value",
            ref: "sumAggregationComp"
        }
    ]
};
var $5b7ccabde48fae90$var$AggregationComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$AggregationCompElement, [
            $5b7ccabde48fae90$var$AgNameValueSelector
        ]);
        this.sumAggregationComp = (0, $jIDNV.RefPlaceholder);
        this.countAggregationComp = (0, $jIDNV.RefPlaceholder);
        this.minAggregationComp = (0, $jIDNV.RefPlaceholder);
        this.maxAggregationComp = (0, $jIDNV.RefPlaceholder);
        this.avgAggregationComp = (0, $jIDNV.RefPlaceholder);
    }
    postConstruct() {
        if (!(0, $jIDNV._isClientSideRowModel)(this.gos) && !(0, $jIDNV._isServerSideRowModel)(this.gos)) {
            (0, $jIDNV._warn)(221);
            return;
        }
        this.avgAggregationComp.setLabel("avg", "Average");
        this.countAggregationComp.setLabel("count", "Count");
        this.minAggregationComp.setLabel("min", "Min");
        this.maxAggregationComp.setLabel("max", "Max");
        this.sumAggregationComp.setLabel("sum", "Sum");
        this.addManagedEventListeners({
            cellSelectionChanged: this.onCellSelectionChanged.bind(this),
            modelUpdated: this.onCellSelectionChanged.bind(this)
        });
    }
    init(params) {
        this.refresh(params);
    }
    refresh(params) {
        this.params = params;
        const valueFormatter = params.valueFormatter ?? (({ value: value })=>$5b7ccabde48fae90$var$_formatNumberTwoDecimalPlacesAndCommas(value, this.getLocaleTextFunc.bind(this)));
        const aggFuncNames = [
            "avg",
            "count",
            "min",
            "max",
            "sum"
        ];
        for (const key of aggFuncNames){
            const comp = this.getAllowedAggregationValueComponent(key);
            if (comp) {
                comp.key = key;
                comp.valueFormatter = valueFormatter.bind(this);
            }
        }
        this.onCellSelectionChanged();
        return true;
    }
    setAggregationComponentValue(aggFuncName, value, visible) {
        const statusBarValueComponent = this.getAllowedAggregationValueComponent(aggFuncName);
        const totalRow = $5b7ccabde48fae90$var$_getTotalRowCount(this.beans.rowModel);
        if ((0, $jIDNV._exists)(statusBarValueComponent) && statusBarValueComponent) {
            statusBarValueComponent.setValue(value, totalRow);
            statusBarValueComponent.setDisplayed(visible);
        } else this.getAggregationValueComponent(aggFuncName)?.setDisplayed(false);
    }
    getAllowedAggregationValueComponent(aggFuncName) {
        const { aggFuncs: aggFuncs } = this.params;
        if (!aggFuncs || aggFuncs.includes(aggFuncName)) return this.getAggregationValueComponent(aggFuncName);
        return null;
    }
    getAggregationValueComponent(aggFuncName) {
        const refComponentName = `${aggFuncName}AggregationComp`;
        return this[refComponentName];
    }
    onCellSelectionChanged() {
        const beans = this.beans;
        const { rangeSvc: rangeSvc, valueSvc: valueSvc } = beans;
        const cellRanges = rangeSvc?.getCellRanges();
        let sum = 0;
        let count = 0;
        let numberCount = 0;
        let min = null;
        let max = null;
        const cellsSoFar = {};
        if (cellRanges?.length && rangeSvc) for(let i = 0; i < cellRanges.length; i++){
            const cellRange = cellRanges[i];
            let currentRow = rangeSvc.getRangeStartRow(cellRange);
            const lastRow = rangeSvc.getRangeEndRow(cellRange);
            while(true){
                const finishedAllRows = (0, $jIDNV._missing)(currentRow) || !currentRow || (0, $jIDNV._isRowBefore)(lastRow, currentRow);
                if (finishedAllRows || !currentRow || !cellRange.columns) break;
                cellRange.columns.forEach((col)=>{
                    if (currentRow === null) return;
                    const cellId = (0, $jIDNV._createCellId)({
                        rowPinned: currentRow.rowPinned,
                        column: col,
                        rowIndex: currentRow.rowIndex
                    });
                    if (cellsSoFar[cellId]) return;
                    cellsSoFar[cellId] = true;
                    const rowNode = (0, $jIDNV._getRowNode)(beans, currentRow);
                    if ((0, $jIDNV._missing)(rowNode)) return;
                    let value = valueSvc.getValue(col, rowNode);
                    if ((0, $jIDNV._missing)(value) || value === "") return;
                    count++;
                    if (typeof value === "object" && "value" in value) {
                        value = value.value;
                        if (value === "") return;
                    }
                    if (typeof value === "string") value = Number(value);
                    if (typeof value === "number" && !isNaN(value)) {
                        sum += value;
                        if (max === null || value > max) max = value;
                        if (min === null || value < min) min = value;
                        numberCount++;
                    }
                });
                currentRow = (0, $jIDNV._getRowBelow)(beans, currentRow);
            }
        }
        const gotResult = count > 1;
        const gotNumberResult = numberCount > 1;
        this.setAggregationComponentValue("count", count, gotResult);
        this.setAggregationComponentValue("sum", sum, gotNumberResult);
        this.setAggregationComponentValue("min", min, gotNumberResult);
        this.setAggregationComponentValue("max", max, gotNumberResult);
        this.setAggregationComponentValue("avg", sum / numberCount, gotNumberResult);
    }
};
var $5b7ccabde48fae90$var$FilteredRowsComp = class extends $5b7ccabde48fae90$var$AgNameValue {
    postConstruct() {
        this.setLabel("filteredRows", "Filtered");
        if (!(0, $jIDNV._isClientSideRowModel)(this.gos)) {
            (0, $jIDNV._warn)(222);
            return;
        }
        this.addCss("ag-status-panel");
        this.addCss("ag-status-panel-filtered-row-count");
        this.setDisplayed(true);
        const listener = this.onDataChanged.bind(this);
        this.addManagedEventListeners({
            modelUpdated: listener
        });
    }
    onDataChanged() {
        const { rowModel: rowModel } = this.beans;
        const totalRowCountValue = $5b7ccabde48fae90$var$_getTotalRowCount(rowModel);
        const filteredRowCountValue = $5b7ccabde48fae90$var$_getFilteredRowCount(rowModel);
        this.setValue(filteredRowCountValue, totalRowCountValue);
        this.setDisplayed(totalRowCountValue !== filteredRowCountValue);
    }
    init(params) {
        this.refresh(params);
        this.onDataChanged();
    }
    updateValueFormatter(valueFormatter) {
        this.valueFormatter = valueFormatter ?? (({ value: value })=>(0, $jIDNV._formatNumberCommas)(value, this.getLocaleTextFunc.bind(this)));
    }
    refresh(params) {
        const { key: key, valueFormatter: valueFormatter } = params;
        this.key = key;
        this.updateValueFormatter(valueFormatter);
        return true;
    }
};
var $5b7ccabde48fae90$var$SelectedRowsComp = class extends $5b7ccabde48fae90$var$AgNameValue {
    postConstruct() {
        const gos = this.gos;
        if (!(0, $jIDNV._isClientSideRowModel)(gos) && !(0, $jIDNV._isServerSideRowModel)(gos)) {
            (0, $jIDNV._warn)(223);
            return;
        }
        this.setLabel("selectedRows", "Selected");
        this.addCss("ag-status-panel");
        this.addCss("ag-status-panel-selected-row-count");
        const eventListener = this.onRowSelectionChanged.bind(this);
        this.addManagedEventListeners({
            modelUpdated: eventListener,
            selectionChanged: eventListener
        });
    }
    onRowSelectionChanged() {
        const { selectionSvc: selectionSvc, rowModel: rowModel } = this.beans;
        const selectedRowCount = selectionSvc?.getSelectionCount() ?? 0;
        const totalRowCount = $5b7ccabde48fae90$var$_getTotalRowCount(rowModel);
        this.setValue(selectedRowCount, totalRowCount);
        if (selectedRowCount < 0) {
            this.setDisplayed(true);
            return;
        }
        this.setDisplayed(selectedRowCount > 0);
    }
    init(params) {
        this.refresh(params);
        this.onRowSelectionChanged();
    }
    updateValueFormatter(valueFormatter) {
        this.valueFormatter = valueFormatter ?? (({ value: value })=>{
            if (value == null || value >= 0) return (0, $jIDNV._formatNumberCommas)(value, this.getLocaleTextFunc.bind(this));
            return this.getLocaleTextFunc()("statusBarLastRowUnknown", "?");
        });
    }
    refresh(params) {
        const { key: key, valueFormatter: valueFormatter } = params;
        this.key = key;
        this.updateValueFormatter(valueFormatter);
        return true;
    }
};
var $5b7ccabde48fae90$var$TotalAndFilteredRowsComp = class extends $5b7ccabde48fae90$var$AgNameValue {
    postConstruct() {
        if (!(0, $jIDNV._isClientSideRowModel)(this.gos)) {
            (0, $jIDNV._warn)(224);
            return;
        }
        this.setLabel("totalAndFilteredRows", "Rows");
        this.addCss("ag-status-panel");
        this.addCss("ag-status-panel-total-and-filtered-row-count");
        this.setDisplayed(true);
        this.addManagedEventListeners({
            modelUpdated: this.onDataChanged.bind(this)
        });
    }
    onDataChanged() {
        const { rowModel: rowModel } = this.beans;
        const rowCount = $5b7ccabde48fae90$var$_getFilteredRowCount(rowModel);
        const totalRowCount = $5b7ccabde48fae90$var$_getTotalRowCount(rowModel);
        this.setValue(rowCount, totalRowCount);
    }
    init(params) {
        this.refresh(params);
        this.onDataChanged();
    }
    updateValueFormatter(valueFormatter) {
        this.valueFormatter = valueFormatter ?? (({ value: value, totalRows: totalRows })=>{
            const getLocaleTextFunc = this.getLocaleTextFunc.bind(this);
            const rowCount = (0, $jIDNV._formatNumberCommas)(value, getLocaleTextFunc);
            const totalRowCount = (0, $jIDNV._formatNumberCommas)(totalRows ?? value, getLocaleTextFunc);
            if (value === totalRows) return rowCount;
            const localeTextFunc = getLocaleTextFunc();
            return `${rowCount} ${localeTextFunc("of", "of")} ${totalRowCount}`;
        });
    }
    refresh(params) {
        const { key: key, valueFormatter: valueFormatter } = params;
        this.key = key;
        this.updateValueFormatter(valueFormatter);
        return true;
    }
};
var $5b7ccabde48fae90$var$TotalRowsComp = class extends $5b7ccabde48fae90$var$AgNameValue {
    postConstruct() {
        this.setLabel("totalRows", "Total Rows");
        if (!(0, $jIDNV._isClientSideRowModel)(this.gos)) {
            (0, $jIDNV._warn)(225);
            return;
        }
        this.addCss("ag-status-panel");
        this.addCss("ag-status-panel-total-row-count");
        this.setDisplayed(true);
        this.addManagedEventListeners({
            modelUpdated: this.onDataChanged.bind(this)
        });
    }
    onDataChanged() {
        const totalRow = $5b7ccabde48fae90$var$_getTotalRowCount(this.beans.rowModel);
        this.setValue(totalRow, totalRow);
    }
    init(params) {
        this.refresh(params);
        this.onDataChanged();
    }
    updateValueFormatter(valueFormatter) {
        this.valueFormatter = valueFormatter ?? (({ value: value })=>(0, $jIDNV._formatNumberCommas)(value, this.getLocaleTextFunc.bind(this)));
    }
    refresh(params) {
        const { key: key, valueFormatter: valueFormatter } = params;
        this.key = key;
        this.updateValueFormatter(valueFormatter);
        return true;
    }
};
function $5b7ccabde48fae90$var$getStatusPanel(beans, key) {
    const comp = beans.statusBarSvc?.getStatusPanel(key);
    return (0, $jIDNV._unwrapUserComp)(comp);
}
var $5b7ccabde48fae90$var$StatusBarService = class extends (0, $jIDNV.BeanStub) {
    // tslint:disable-next-line
    constructor(){
        super();
        this.beanName = "statusBarSvc";
        this.comps = /* @__PURE__ */ new Map();
    }
    registerStatusPanel(key, component) {
        this.comps.set(key, component);
    }
    unregisterStatusPanel(key) {
        this.comps.delete(key);
    }
    unregisterAllComponents() {
        this.comps.clear();
    }
    getStatusPanel(key) {
        return this.comps.get(key);
    }
    destroy() {
        this.unregisterAllComponents();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/statusBar/statusBarModule.ts
var $5b7ccabde48fae90$export$76a316c8c2f3bc28 = {
    moduleName: "StatusBar",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$StatusBarService
    ],
    userComponents: {
        agAggregationComponent: $5b7ccabde48fae90$var$AggregationComp,
        agTotalRowCountComponent: $5b7ccabde48fae90$var$TotalRowsComp,
        agFilteredRowCountComponent: $5b7ccabde48fae90$var$FilteredRowsComp,
        agTotalAndFilteredRowCountComponent: $5b7ccabde48fae90$var$TotalAndFilteredRowsComp,
        agSelectedRowCountComponent: $5b7ccabde48fae90$var$SelectedRowsComp
    },
    selectors: [
        $5b7ccabde48fae90$var$AgStatusBarSelector
    ],
    apiFunctions: {
        getStatusPanel: $5b7ccabde48fae90$var$getStatusPanel
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $jIDNV._KeyboardNavigationModule)
    ]
};
function $5b7ccabde48fae90$var$assertNotExcelMultiSheet(beans) {
    if (beans.excelCreator?.getFactoryMode() === "MULTI_SHEET") {
        (0, $jIDNV._warn)(161);
        return false;
    }
    return true;
}
function $5b7ccabde48fae90$var$getDataAsExcel(beans, params) {
    if ($5b7ccabde48fae90$var$assertNotExcelMultiSheet(beans)) return beans.excelCreator?.getDataAsExcel(params);
    return void 0;
}
function $5b7ccabde48fae90$var$exportDataAsExcel(beans, params) {
    if ($5b7ccabde48fae90$var$assertNotExcelMultiSheet(beans)) beans.excelCreator?.exportDataAsExcel(params);
}
function $5b7ccabde48fae90$var$getSheetDataForExcel(beans, params) {
    beans.excelCreator?.setFactoryMode("MULTI_SHEET");
    return beans.excelCreator?.getSheetDataForExcel(params);
}
function $5b7ccabde48fae90$var$getMultipleSheetsAsExcel2(beans, params) {
    return beans.excelCreator?.getMultipleSheetsAsExcel(params);
}
function $5b7ccabde48fae90$var$exportMultipleSheetsAsExcel2(beans, params) {
    beans.excelCreator?.exportMultipleSheetsAsExcel(params);
}
// packages/ag-grid-enterprise/src/excelExport/excelExportModule.ts
var $5b7ccabde48fae90$export$98f0c53ca0379def = {
    moduleName: "ExcelExport",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$ExcelCreator
    ],
    apiFunctions: {
        getDataAsExcel: $5b7ccabde48fae90$var$getDataAsExcel,
        exportDataAsExcel: $5b7ccabde48fae90$var$exportDataAsExcel,
        getSheetDataForExcel: $5b7ccabde48fae90$var$getSheetDataForExcel,
        getMultipleSheetsAsExcel: $5b7ccabde48fae90$var$getMultipleSheetsAsExcel2,
        exportMultipleSheetsAsExcel: $5b7ccabde48fae90$var$exportMultipleSheetsAsExcel2
    },
    dependsOn: [
        (0, $jIDNV._SharedExportModule),
        $5b7ccabde48fae90$var$EnterpriseCoreModule
    ]
};
function $5b7ccabde48fae90$var$getAgGroupComponentTemplate(params) {
    const cssIdentifier = params.cssIdentifier || "default";
    const direction = params.direction || "vertical";
    return {
        tag: "div",
        cls: `ag-group ag-${cssIdentifier}-group`,
        role: "presentation",
        children: [
            {
                tag: "div",
                ref: "eToolbar",
                cls: `ag-group-toolbar ag-${cssIdentifier}-group-toolbar`,
                children: [
                    {
                        tag: "ag-checkbox",
                        ref: "cbGroupEnabled"
                    }
                ]
            },
            {
                tag: "div",
                ref: "eContainer",
                cls: `ag-group-container ag-group-container-${direction} ag-${cssIdentifier}-group-container`
            }
        ]
    };
}
var $5b7ccabde48fae90$var$AgGroupComponent = class extends (0, $jIDNV.Component) {
    constructor(params = {}){
        super($5b7ccabde48fae90$var$getAgGroupComponentTemplate(params), [
            (0, $jIDNV.AgCheckboxSelector)
        ]);
        this.params = params;
        this.suppressEnabledCheckbox = true;
        this.suppressToggleExpandOnEnableChange = false;
        this.eToolbar = (0, $jIDNV.RefPlaceholder);
        this.cbGroupEnabled = (0, $jIDNV.RefPlaceholder);
        this.eContainer = (0, $jIDNV.RefPlaceholder);
        const { enabled: enabled, items: items, suppressEnabledCheckbox: suppressEnabledCheckbox, expanded: expanded, suppressToggleExpandOnEnableChange: suppressToggleExpandOnEnableChange, useToggle: toggleMode } = params;
        this.cssIdentifier = params.cssIdentifier || "default";
        this.enabled = enabled != null ? enabled : true;
        this.items = items || [];
        this.useToggle = toggleMode ?? false;
        this.alignItems = params.alignItems || "center";
        this.expanded = expanded == null ? true : expanded;
        if (suppressEnabledCheckbox != null) this.suppressEnabledCheckbox = suppressEnabledCheckbox;
        if (suppressToggleExpandOnEnableChange != null) this.suppressToggleExpandOnEnableChange = suppressToggleExpandOnEnableChange;
    }
    postConstruct() {
        this.setupTitleBar();
        if (this.items.length) {
            const initialItems = this.items;
            this.items = [];
            this.addItems(initialItems);
        }
        const localeTextFunc = this.getLocaleTextFunc();
        this.cbGroupEnabled.setLabel(localeTextFunc("enabled", "Enabled"));
        if (this.enabled) this.setEnabled(this.enabled, void 0, true);
        this.setAlignItems(this.alignItems);
        const { onEnableChange: onEnableChange, onExpandedChange: onExpandedChange, suppressOpenCloseIcons: suppressOpenCloseIcons } = this.params;
        this.hideEnabledCheckbox(this.suppressEnabledCheckbox);
        this.hideOpenCloseIcons(suppressOpenCloseIcons ?? false);
        this.refreshChildDisplay();
        (0, $jIDNV._setDisplayed)(this.eContainer, this.expanded);
        this.cbGroupEnabled.onValueChange((newSelection)=>{
            this.setEnabled(newSelection, true, this.suppressToggleExpandOnEnableChange);
            this.dispatchEnableChangeEvent(newSelection);
        });
        if (onEnableChange != null) this.onEnableChange(onEnableChange);
        if (onExpandedChange != null) this.onExpandedChange(onExpandedChange);
    }
    refreshChildDisplay() {
        (0, $jIDNV._setDisplayed)(this.eToolbar, this.expanded && !this.suppressEnabledCheckbox);
        this.eTitleBar?.refreshOnExpand(this.expanded);
    }
    isExpanded() {
        return this.expanded;
    }
    setAlignItems(alignment) {
        if (this.alignItems !== alignment) this.removeCss(`ag-group-item-alignment-${this.alignItems}`);
        this.alignItems = alignment;
        const newCls = `ag-group-item-alignment-${this.alignItems}`;
        this.addCss(newCls);
        return this;
    }
    toggleGroupExpand(expanded, silent) {
        if (this.eTitleBar?.isSuppressCollapse() && !this.useToggle) {
            expanded = true;
            silent = true;
        } else {
            expanded = expanded != null ? expanded : !this.expanded;
            if (this.expanded === expanded) return this;
        }
        this.expanded = expanded;
        this.refreshChildDisplay();
        (0, $jIDNV._setDisplayed)(this.eContainer, expanded);
        if (!silent) this.dispatchLocalEvent({
            type: expanded ? "expanded" : "collapsed"
        });
        return this;
    }
    addItems(items) {
        items.forEach((item)=>this.addItem(item));
    }
    prependItem(item) {
        this.insertItem(item, true);
    }
    addItem(item) {
        this.insertItem(item, false);
    }
    insertItem(item, prepend) {
        const container = this.eContainer;
        const el = item instanceof (0, $jIDNV.Component) ? item.getGui() : item;
        el.classList.add("ag-group-item", `ag-${this.cssIdentifier}-group-item`);
        if (prepend) {
            container.insertAdjacentElement("afterbegin", el);
            this.items.unshift(el);
        } else {
            container.appendChild(el);
            this.items.push(el);
        }
    }
    hideItem(hide, index) {
        const itemToHide = this.items[index];
        (0, $jIDNV._setDisplayed)(itemToHide, !hide);
    }
    getItemIndex(item) {
        const el = item instanceof (0, $jIDNV.Component) ? item.getGui() : item;
        return this.items.indexOf(el);
    }
    setTitle(title) {
        this.eTitleBar?.setTitle(title);
        return this;
    }
    addTitleBarWidget(el) {
        this.eTitleBar?.addWidget(el);
        return this;
    }
    addCssClassToTitleBar(cssClass) {
        this.eTitleBar?.addCss(cssClass);
    }
    dispatchEnableChangeEvent(enabled) {
        const event = {
            type: "enableChange",
            enabled: enabled
        };
        this.dispatchLocalEvent(event);
    }
    setEnabled(enabled, skipToggle, skipExpand) {
        this.enabled = enabled;
        this.refreshDisabledStyles();
        if (!skipExpand) this.toggleGroupExpand(enabled);
        if (!skipToggle) {
            this.cbGroupEnabled.setValue(enabled);
            this.eToggle?.setValue(enabled);
        }
        return this;
    }
    isEnabled() {
        return this.enabled;
    }
    onEnableChange(callbackFn) {
        this.addManagedListeners(this, {
            enableChange: (event)=>callbackFn(event.enabled)
        });
        return this;
    }
    onExpandedChange(callbackFn) {
        this.addManagedListeners(this, {
            expanded: ()=>callbackFn(true),
            collapsed: ()=>callbackFn(false)
        });
        return this;
    }
    hideEnabledCheckbox(hide) {
        this.suppressEnabledCheckbox = hide;
        this.refreshChildDisplay();
        this.refreshDisabledStyles();
        return this;
    }
    hideOpenCloseIcons(hide) {
        this.eTitleBar?.hideOpenCloseIcons(hide);
        return this;
    }
    refreshDisabledStyles() {
        const disabled = !this.enabled;
        this.eContainer.classList.toggle("ag-disabled", disabled);
        this.eTitleBar?.refreshDisabledStyles(this.suppressEnabledCheckbox && disabled);
        this.eContainer.classList.toggle("ag-disabled-group-container", disabled);
    }
    setupTitleBar() {
        const titleBar = this.useToggle ? this.createToggleTitleBar() : this.createDefaultTitleBar();
        this.eToolbar.insertAdjacentElement("beforebegin", titleBar.getGui());
    }
    createDefaultTitleBar() {
        const titleBar = this.createManagedBean(new $5b7ccabde48fae90$var$DefaultTitleBar(this.params));
        this.eTitleBar = titleBar;
        titleBar.refreshOnExpand(this.expanded);
        this.addManagedListeners(titleBar, {
            expandedChanged: (event)=>this.toggleGroupExpand(event.expanded)
        });
        return titleBar;
    }
    createToggleTitleBar() {
        const eToggle = this.createManagedBean(new (0, $jIDNV.AgToggleButton)({
            value: this.enabled,
            label: this.params.title,
            labelAlignment: "left",
            labelWidth: "flex",
            onValueChange: (enabled)=>{
                this.setEnabled(enabled, true);
                this.dispatchEnableChangeEvent(enabled);
            }
        }));
        eToggle.addCss("ag-group-title-bar");
        eToggle.addCss(`ag-${this.params.cssIdentifier ?? "default"}-group-title-bar ag-unselectable`);
        this.eToggle = eToggle;
        this.toggleGroupExpand(this.enabled);
        return eToggle;
    }
};
var $5b7ccabde48fae90$var$TITLE_BAR_DISABLED_CLASS = "ag-disabled-group-title-bar";
function $5b7ccabde48fae90$var$getDefaultTitleBarTemplate(params) {
    const cssIdentifier = params.cssIdentifier ?? "default";
    return {
        tag: "div",
        cls: `ag-group-title-bar ag-${cssIdentifier}-group-title-bar ag-unselectable`,
        role: params.suppressKeyboardNavigation ? "presentation" : "role",
        children: [
            {
                tag: "span",
                ref: "eGroupOpenedIcon",
                cls: `ag-group-title-bar-icon ag-${cssIdentifier}-group-title-bar-icon`,
                role: "presentation"
            },
            {
                tag: "span",
                ref: "eGroupClosedIcon",
                cls: `ag-group-title-bar-icon ag-${cssIdentifier}-group-title-bar-icon`,
                role: "presentation"
            },
            {
                tag: "span",
                ref: "eTitle",
                cls: `ag-group-title ag-${cssIdentifier}-group-title`
            }
        ]
    };
}
var $5b7ccabde48fae90$var$DefaultTitleBar = class extends (0, $jIDNV.Component) {
    constructor(params = {}){
        super($5b7ccabde48fae90$var$getDefaultTitleBarTemplate(params));
        this.suppressOpenCloseIcons = false;
        this.suppressKeyboardNavigation = false;
        this.eGroupOpenedIcon = (0, $jIDNV.RefPlaceholder);
        this.eGroupClosedIcon = (0, $jIDNV.RefPlaceholder);
        this.eTitle = (0, $jIDNV.RefPlaceholder);
        const { title: title, suppressOpenCloseIcons: suppressOpenCloseIcons, suppressKeyboardNavigation: suppressKeyboardNavigation } = params;
        if (!!title && title.length > 0) this.title = title;
        if (suppressOpenCloseIcons != null) this.suppressOpenCloseIcons = suppressOpenCloseIcons;
        this.suppressKeyboardNavigation = suppressKeyboardNavigation ?? false;
    }
    postConstruct() {
        this.setTitle(this.title);
        this.hideOpenCloseIcons(this.suppressOpenCloseIcons);
        this.setupExpandContract();
    }
    setupExpandContract() {
        this.eGroupClosedIcon.appendChild((0, $jIDNV._createIcon)("accordionClosed", this.beans, null));
        this.eGroupOpenedIcon.appendChild((0, $jIDNV._createIcon)("accordionOpen", this.beans, null));
        this.addManagedElementListeners(this.getGui(), {
            click: ()=>this.dispatchExpandChanged(),
            keydown: (e)=>{
                switch(e.key){
                    case (0, $jIDNV.KeyCode).ENTER:
                    case (0, $jIDNV.KeyCode).SPACE:
                        e.preventDefault();
                        this.dispatchExpandChanged();
                        break;
                    case (0, $jIDNV.KeyCode).RIGHT:
                    case (0, $jIDNV.KeyCode).LEFT:
                        e.preventDefault();
                        this.dispatchExpandChanged(e.key === (0, $jIDNV.KeyCode).RIGHT);
                        break;
                }
            }
        });
    }
    refreshOnExpand(expanded) {
        this.refreshAriaStatus(expanded);
        this.refreshOpenCloseIcons(expanded);
    }
    refreshAriaStatus(expanded) {
        if (!this.suppressOpenCloseIcons) (0, $jIDNV._setAriaExpanded)(this.getGui(), expanded);
    }
    refreshOpenCloseIcons(expanded) {
        const showIcon = !this.suppressOpenCloseIcons;
        (0, $jIDNV._setDisplayed)(this.eGroupOpenedIcon, showIcon && expanded);
        (0, $jIDNV._setDisplayed)(this.eGroupClosedIcon, showIcon && !expanded);
    }
    isSuppressCollapse() {
        return this.suppressOpenCloseIcons;
    }
    dispatchExpandChanged(expanded) {
        const event = {
            type: "expandedChanged",
            expanded: expanded
        };
        this.dispatchLocalEvent(event);
    }
    setTitle(title) {
        const eGui = this.getGui();
        const hasTitle = !!title && title.length > 0;
        title = hasTitle ? title : void 0;
        this.eTitle.textContent = title ?? "";
        (0, $jIDNV._setDisplayed)(eGui, hasTitle);
        if (title !== this.title) this.title = title;
        const disabled = eGui.classList.contains($5b7ccabde48fae90$var$TITLE_BAR_DISABLED_CLASS);
        this.refreshDisabledStyles(disabled);
        return this;
    }
    addWidget(el) {
        this.getGui().appendChild(el);
        return this;
    }
    hideOpenCloseIcons(hide) {
        this.suppressOpenCloseIcons = hide;
        if (hide) this.dispatchExpandChanged(true);
        return this;
    }
    refreshDisabledStyles(disabled) {
        const eGui = this.getGui();
        if (disabled) {
            eGui.classList.add($5b7ccabde48fae90$var$TITLE_BAR_DISABLED_CLASS);
            eGui.removeAttribute("tabindex");
        } else {
            eGui.classList.remove($5b7ccabde48fae90$var$TITLE_BAR_DISABLED_CLASS);
            if (typeof this.title === "string" && !this.suppressKeyboardNavigation) eGui.setAttribute("tabindex", "0");
            else eGui.removeAttribute("tabindex");
        }
    }
};
var $5b7ccabde48fae90$var$AgGroupComponentSelector = {
    selector: "AG-GROUP-COMPONENT",
    component: $5b7ccabde48fae90$var$AgGroupComponent
};
function $5b7ccabde48fae90$var$getMultiFilterDefs(params) {
    const { filters: filters } = params;
    return filters && filters.length > 0 ? filters : [
        {
            filter: "agTextColumnFilter"
        },
        {
            filter: "agSetColumnFilter"
        }
    ];
}
function $5b7ccabde48fae90$var$forEachReverse(list, action) {
    if (list == null) return;
    for(let i = list.length - 1; i >= 0; i--)action(list[i], i);
}
function $5b7ccabde48fae90$var$getFilterTitle(filter, filterDef) {
    if (filterDef.title != null) return filterDef.title;
    return filter instanceof (0, $jIDNV.ProvidedFilter) ? filter.getFilterTitle() : "Filter";
}
function $5b7ccabde48fae90$var$getUpdatedMultiFilterModel(existingModel, numFilters, newModel, index) {
    const filterModels = [];
    const existingFilterModels = existingModel?.filterModels;
    for(let i = 0; i < numFilters; i++)filterModels[i] = (i === index ? newModel : existingFilterModels?.[i]) ?? null;
    return filterModels.every((childModel)=>childModel == null) ? null : {
        filterType: "multi",
        filterModels: filterModels
    };
}
function $5b7ccabde48fae90$var$getFilterModelForIndex(model, index) {
    return model?.filterModels?.[index] ?? null;
}
function $5b7ccabde48fae90$var$updateGetValue(beans, column, filterDef, existingGetValue) {
    const filterValueGetter = filterDef.filterValueGetter;
    return filterValueGetter ? beans.colFilter.createGetValue(column, filterValueGetter) : existingGetValue;
}
// packages/ag-grid-enterprise/src/multiFilter/baseMultiFilter.ts
var $5b7ccabde48fae90$var$BaseMultiFilter = class extends (0, $jIDNV.TabGuardComp) {
    constructor(){
        super({
            tag: "div",
            cls: "ag-multi-filter ag-menu-list-compact"
        });
        this.filterDefs = [];
        this.guiDestroyFuncs = [];
        // this could be the accordion/sub menu element depending on the display type
        this.filterGuis = [];
        this.lastActivatedMenuItem = null;
    }
    postConstruct() {
        this.initialiseTabGuard({
            onFocusIn: (e)=>this.onFocusIn(e)
        });
    }
    refreshGui(container) {
        if (container === this.lastOpenedInContainer) return (0, $jIDNV.AgPromise).resolve();
        this.tabGuardFeature.removeAllChildrenExceptTabGuards();
        this.destroyChildren();
        return (0, $jIDNV.AgPromise).all(this.getFilterWrappers().map((wrapper, index)=>{
            if (!wrapper) return (0, $jIDNV.AgPromise).resolve(null);
            const filter = this.getFilterFromWrapper(wrapper);
            const comp = this.getCompFromWrapper(wrapper);
            const filterDef = this.filterDefs[index];
            const filterTitle = $5b7ccabde48fae90$var$getFilterTitle(filter, filterDef);
            let filterGuiPromise;
            if (filterDef.display === "subMenu" && container !== "toolPanel") filterGuiPromise = this.insertFilterMenu(comp, filter, filterTitle).then((menuItem)=>menuItem.getGui());
            else if (filterDef.display === "subMenu" || filterDef.display === "accordion") {
                const group = this.insertFilterGroup(filter, comp, filterTitle);
                filterGuiPromise = (0, $jIDNV.AgPromise).resolve(group.getGui());
            } else filterGuiPromise = (0, $jIDNV.AgPromise).resolve(comp.getGui());
            return filterGuiPromise;
        })).then((filterGuis)=>{
            filterGuis.forEach((filterGui, index)=>{
                if (!filterGui) return;
                if (index > 0) this.appendChild((0, $jIDNV._createElement)({
                    tag: "div",
                    cls: "ag-filter-separator"
                }));
                this.appendChild(filterGui);
            });
            this.filterGuis = filterGuis;
            this.lastOpenedInContainer = container;
        });
    }
    destroyChildren() {
        this.guiDestroyFuncs.forEach((func)=>func());
        this.guiDestroyFuncs.length = 0;
        this.filterGuis.length = 0;
    }
    insertFilterMenu(comp, filter, name) {
        const eGui = comp.getGui();
        (0, $jIDNV._setAriaRole)(eGui, "dialog");
        const menuItem = this.createBean(new $5b7ccabde48fae90$var$AgMenuItemComponent());
        const childComponent = {
            getGui: ()=>comp.getGui(),
            afterGuiAttached: (params)=>{
                comp.afterGuiAttached?.(params);
                if (comp !== filter) filter.afterGuiAttached?.(params);
            }
        };
        return menuItem.init({
            menuItemDef: {
                name: name,
                subMenu: [],
                subMenuRole: "dialog",
                cssClasses: [
                    "ag-multi-filter-menu-item"
                ],
                menuItem: $5b7ccabde48fae90$var$AgMenuItemRenderer,
                menuItemParams: {
                    cssClassPrefix: "ag-compact-menu-option",
                    isCompact: true
                }
            },
            level: 0,
            isAnotherSubMenuOpen: ()=>false,
            childComponent: childComponent,
            contextParams: {
                column: null,
                node: null,
                value: null
            }
        }).then(()=>{
            menuItem.setParentComponent(this);
            this.guiDestroyFuncs.push(()=>this.destroyBean(menuItem));
            this.addManagedListeners(menuItem, {
                menuItemActivated: (event)=>{
                    if (this.lastActivatedMenuItem && this.lastActivatedMenuItem !== event.menuItem) this.lastActivatedMenuItem.deactivate();
                    this.lastActivatedMenuItem = event.menuItem;
                }
            });
            const menuItemGui = menuItem.getGui();
            menuItem.addManagedElementListeners(menuItemGui, {
                // `AgMenuList` normally handles keyboard navigation, so need to do here
                keydown: (e)=>{
                    const { key: key } = e;
                    switch(key){
                        case (0, $jIDNV.KeyCode).UP:
                        case (0, $jIDNV.KeyCode).RIGHT:
                        case (0, $jIDNV.KeyCode).DOWN:
                        case (0, $jIDNV.KeyCode).LEFT:
                            e.preventDefault();
                            if (key === (0, $jIDNV.KeyCode).RIGHT) menuItem.openSubMenu(true);
                            break;
                    }
                },
                focusin: ()=>menuItem.activate(),
                focusout: ()=>{
                    if (!menuItem.isSubMenuOpen() && !menuItem.isSubMenuOpening()) menuItem.deactivate();
                }
            });
            return menuItem;
        });
    }
    insertFilterGroup(filter, comp, title) {
        const group = this.createBean(new $5b7ccabde48fae90$var$AgGroupComponent({
            title: title,
            cssIdentifier: "multi-filter"
        }));
        this.guiDestroyFuncs.push(()=>this.destroyBean(group));
        group.addItem(comp.getGui());
        group.toggleGroupExpand(false);
        if (filter.afterGuiAttached) group.addManagedListeners(group, {
            expanded: ()=>filter.afterGuiAttached({
                    container: this.lastOpenedInContainer,
                    suppressFocus: true,
                    hidePopup: this.hidePopup
                })
        });
        return group;
    }
    afterGuiAttached(params) {
        let refreshPromise;
        if (params) {
            this.hidePopup = params.hidePopup;
            refreshPromise = this.refreshGui(params.container);
        } else {
            this.hidePopup = void 0;
            refreshPromise = (0, $jIDNV.AgPromise).resolve();
        }
        const suppressFocus = params?.suppressFocus;
        refreshPromise.then(()=>{
            const { filterDefs: filterDefs, filterGuis: filterGuis, beans: beans } = this;
            const wrappers = this.getFilterWrappers();
            let hasFocused = !!suppressFocus;
            if (filterDefs) $5b7ccabde48fae90$var$forEachReverse(filterDefs, (filterDef, index)=>{
                const isFirst = index === 0;
                const notInlineDisplayType = filterDef.display && filterDef.display !== "inline";
                const suppressFocusForFilter = suppressFocus || !isFirst || notInlineDisplayType;
                const afterGuiAttachedParams = {
                    ...params ?? {},
                    suppressFocus: suppressFocusForFilter
                };
                const wrapper = wrappers[index];
                const filter = wrapper ? this.getFilterFromWrapper(wrapper) : void 0;
                if (wrapper) {
                    const comp = this.getCompFromWrapper(wrapper);
                    if (comp !== filter) comp.afterGuiAttached(afterGuiAttachedParams);
                }
                if (filter) {
                    this.executeFunctionIfExistsOnFilter(filter, "afterGuiAttached", afterGuiAttachedParams);
                    if (isFirst && !suppressFocusForFilter) hasFocused = true;
                }
                if (!suppressFocus && isFirst && notInlineDisplayType) {
                    const filterGui = filterGuis[index];
                    if (filterGui) {
                        if (!(0, $jIDNV._focusInto)(filterGui)) filterGui.focus({
                            preventScroll: true
                        });
                        hasFocused = true;
                    }
                }
            });
            const activeEl = (0, $jIDNV._getActiveDomElement)(beans);
            if (!hasFocused && ((0, $jIDNV._isNothingFocused)(beans) || this.getGui().contains(activeEl))) this.forceFocusOutOfContainer(true);
        });
    }
    afterGuiDetached() {
        this.executeFunctionIfExists("afterGuiDetached");
    }
    onAnyFilterChanged() {
        this.executeFunctionIfExists("onAnyFilterChanged", (wrapper)=>this.executeOnWrapper(wrapper, "onAnyFilterChanged"));
    }
    onNewRowsLoaded() {
        this.executeFunctionIfExists("onNewRowsLoaded", (wrapper)=>this.executeOnWrapper(wrapper, "onNewRowsLoaded"));
    }
    destroy() {
        this.destroyChildren();
        this.hidePopup = void 0;
        super.destroy();
    }
    executeOnWrapper(_wrapper, _name) {}
    executeFunctionIfExists(name, executeOnHandler) {
        $5b7ccabde48fae90$var$forEachReverse(this.getFilterWrappers(), (wrapper)=>{
            if (wrapper) {
                executeOnHandler?.(wrapper);
                this.executeFunctionIfExistsOnFilter(this.getFilterFromWrapper(wrapper), name);
            }
        });
    }
    executeFunctionIfExistsOnFilter(filter, name, ...params) {
        const func = filter[name];
        if (typeof func === "function") func.apply(filter, params);
    }
    onFocusIn(e) {
        const lastActivatedMenuItem = this.lastActivatedMenuItem;
        if (lastActivatedMenuItem != null && !lastActivatedMenuItem.getGui().contains(e.target)) {
            lastActivatedMenuItem.deactivate();
            this.lastActivatedMenuItem = null;
        }
    }
};
// packages/ag-grid-enterprise/src/multiFilter/multiFilter.ts
var $5b7ccabde48fae90$var$MultiFilter = class extends $5b7ccabde48fae90$var$BaseMultiFilter {
    constructor(){
        super(...arguments);
        this.filterType = "multi";
        this.wrappers = [];
        this.activeFilterIndices = [];
        this.afterFiltersReadyFuncs = [];
    }
    init(params) {
        this.params = params;
        this.filterDefs = $5b7ccabde48fae90$var$getMultiFilterDefs(params);
        const initialModel = (0, $jIDNV._getFilterModel)(this.beans.colFilter.model, params.column.getColId());
        const { filterChangedCallback: filterChangedCallback } = params;
        this.filterChangedCallback = filterChangedCallback;
        const filterPromises = this.filterDefs.map((filterDef, index)=>this.createFilter(filterDef, index, initialModel));
        return new (0, $jIDNV.AgPromise)((resolve)=>{
            (0, $jIDNV.AgPromise).all(filterPromises).then((wrappers)=>{
                this.wrappers = wrappers;
                this.refreshGui("columnMenu").then(()=>{
                    resolve();
                });
            });
        }).then(()=>{
            this.afterFiltersReadyFuncs.forEach((f)=>f());
            this.afterFiltersReadyFuncs.length = 0;
        });
    }
    refresh(params) {
        this.params = params;
        return true;
    }
    isFilterActive() {
        return this.wrappers.some((wrapper)=>{
            if (!wrapper) return false;
            const { filter: filter, handler: handler, model: model } = wrapper;
            if (handler) return model != null;
            return filter.isFilterActive();
        });
    }
    getLastActiveFilterIndex() {
        const activeFilterIndices = this.activeFilterIndices;
        return activeFilterIndices.length > 0 ? activeFilterIndices[activeFilterIndices.length - 1] : null;
    }
    doesFilterPass(params, indexToSkip) {
        return this.wrappers.every((wrapper, index)=>{
            if (!wrapper || indexToSkip != null && index === indexToSkip) return true;
            const { handler: handler, filter: filter, model: model } = wrapper;
            if (handler) return model == null || handler.doesFilterPass({
                ...params,
                model: model,
                handlerParams: wrapper.handlerParams
            });
            return !filter.isFilterActive() || filter.doesFilterPass(params);
        });
    }
    getModelFromUi() {
        const model = {
            filterType: this.filterType,
            filterModels: this.wrappers.map((wrapper)=>{
                if (!wrapper) return null;
                const providedFilter = wrapper.filter;
                if (typeof providedFilter.getModelFromUi === "function") return providedFilter.getModelFromUi();
                return null;
            })
        };
        return model;
    }
    getModel() {
        if (!this.isFilterActive()) return null;
        const model = {
            filterType: this.filterType,
            filterModels: this.wrappers.map((wrapper)=>{
                if (!wrapper) return null;
                const { filter: filter, handler: handler, model: model2 } = wrapper;
                if (handler) return model2;
                return filter.isFilterActive() ? filter.getModel() : null;
            })
        };
        return model;
    }
    setModel(model) {
        const setFilterModel = (filter, filterModel)=>{
            return new (0, $jIDNV.AgPromise)((resolve)=>{
                const promise = filter.setModel(filterModel);
                promise ? promise.then(()=>resolve()) : resolve();
            });
        };
        const promises = [];
        this.wrappers.forEach((wrapper, index)=>{
            if (!wrapper) return;
            const modelForFilter = $5b7ccabde48fae90$var$getFilterModelForIndex(model, index);
            const { filter: filter, filterParams: filterParams, handler: handler, handlerParams: handlerParams, state: state } = wrapper;
            if (handler) promises.push((0, $jIDNV._refreshHandlerAndUi)(()=>(0, $jIDNV.AgPromise).resolve({
                    filter: filter,
                    filterParams: filterParams
                }), handler, handlerParams, modelForFilter, state ?? {
                model: modelForFilter
            }, "api").then(()=>{
                wrapper.model = modelForFilter;
                this.updateActiveListForHandler(index, modelForFilter);
            }));
            else promises.push(setFilterModel(filter, modelForFilter).then(()=>{
                this.updateActiveListForFilter(index, filter);
            }));
        });
        return (0, $jIDNV.AgPromise).all(promises).then(()=>{});
    }
    applyModel(source = "api") {
        let result = false;
        this.wrappers.forEach((wrapper)=>{
            if (wrapper) {
                const filter = wrapper.filter;
                if (filter instanceof (0, $jIDNV.ProvidedFilter)) result = filter.applyModel(source) || result;
            }
        });
        return result;
    }
    getChildFilterInstance(index) {
        return this.wrappers[index]?.filter;
    }
    destroy() {
        this.wrappers.forEach((wrapper)=>{
            this.destroyBean(wrapper?.filter);
            this.destroyBean(wrapper?.handler);
        });
        this.wrappers.length = 0;
        super.destroy();
    }
    getFilterWrappers() {
        return this.wrappers;
    }
    getFilterFromWrapper(wrapper) {
        return wrapper.filter;
    }
    getCompFromWrapper(wrapper) {
        return wrapper.comp;
    }
    executeOnWrapper(wrapper, name) {
        wrapper.handler?.[name]?.();
    }
    createFilter(filterDef, index, initialModel) {
        const column = this.params.column;
        let initialModelForFilter = null;
        let createWrapperComp;
        const beans = this.beans;
        const { compDetails: compDetails, handler: handler, handlerParams: originalHandlerParams, createFilterUi: createFilterUi } = beans.colFilter.createFilterInstance(column, filterDef, "agTextColumnFilter", (defaultParams, isHandler)=>{
            const updatedParams = {
                ...defaultParams,
                filterChangedCallback: isHandler ? ()=>{} : (additionalEventAttributes)=>{
                    this.executeWhenAllFiltersReady(()=>this.onFilterModelChanged(index, additionalEventAttributes));
                },
                doesRowPassOtherFilter: (node)=>defaultParams.doesRowPassOtherFilter(node) && this.doesFilterPass({
                        node: node,
                        data: node.data
                    }, index),
                getValue: $5b7ccabde48fae90$var$updateGetValue(beans, column, filterDef, defaultParams.getValue)
            };
            if (isHandler) {
                initialModelForFilter = $5b7ccabde48fae90$var$getFilterModelForIndex(initialModel, index);
                createWrapperComp = this.updateDisplayParams(updatedParams, index, initialModelForFilter, ()=>compDetails, ()=>handler);
            }
            return updatedParams;
        });
        if (!createFilterUi) return (0, $jIDNV.AgPromise).resolve(null);
        let handlerParams;
        if (handler) {
            const { onModelChange: onModelChange, doesRowPassOtherFilter: doesRowPassOtherFilter, getValue: getValue } = originalHandlerParams;
            handlerParams = {
                ...originalHandlerParams,
                onModelChange: (newModel, additionalEventAttributes)=>onModelChange($5b7ccabde48fae90$var$getUpdatedMultiFilterModel(this.params.model, this.wrappers.length, newModel, index), additionalEventAttributes),
                doesRowPassOtherFilter: (node)=>doesRowPassOtherFilter(node) && this.doesFilterPass({
                        node: node,
                        data: node.data
                    }, index),
                getValue: $5b7ccabde48fae90$var$updateGetValue(beans, column, filterDef, getValue)
            };
            handler.init?.({
                ...handlerParams,
                model: initialModelForFilter,
                source: "init"
            });
        }
        return createFilterUi().then((filter)=>{
            if (!handler) return {
                filter: filter,
                comp: filter
            };
            const filterParams = compDetails?.params;
            const comp = createWrapperComp(filter);
            return {
                filter: filter,
                comp: comp,
                filterParams: filterParams,
                handler: handler,
                handlerParams: handlerParams,
                model: initialModelForFilter
            };
        });
    }
    updateDisplayParams(displayParams, index, initialModelForFilter, getCompDetails, getHandler) {
        const column = this.params.column;
        const eventSvc = new (0, $jIDNV.LocalEventService)();
        displayParams.model = initialModelForFilter;
        displayParams.state = {
            model: initialModelForFilter
        };
        displayParams.onModelChange = (model, additionalEventAttributes)=>{
            const wrapper = this.wrappers[index];
            if (!wrapper) return;
            (0, $jIDNV._refreshHandlerAndUi)(()=>(0, $jIDNV.AgPromise).resolve({
                    filter: wrapper.filter,
                    filterParams: wrapper.filterParams
                }), wrapper.handler, wrapper.handlerParams, model, wrapper.state ?? {
                model: model
            }, "ui").then(()=>{
                wrapper.model = model;
                this.onHandlerModelChanged(index, model, additionalEventAttributes);
            });
        };
        displayParams.getHandler = getHandler;
        const updateState = (wrapper, state)=>{
            wrapper.state = state;
            eventSvc.dispatchEvent({
                type: "filterStateChanged",
                column: column,
                state: state
            });
        };
        displayParams.onStateChange = (state)=>{
            const wrapper = this.wrappers[index];
            if (!wrapper) return;
            updateState(wrapper, state);
            (0, $jIDNV._refreshFilterUi)(wrapper.filter, wrapper.filterParams, wrapper.model ?? null, state, "ui");
        };
        const updateModel = (_column, action, additionalEventAttributes)=>{
            const wrapper = this.wrappers[index];
            if (!wrapper) return;
            const getModel = ()=>wrapper?.model ?? null;
            (0, $jIDNV._updateFilterModel)(action, ()=>{
                const promise = (0, $jIDNV.AgPromise).resolve(wrapper.filter);
                return {
                    created: true,
                    filterParams: wrapper.filterParams,
                    compDetails: getCompDetails(),
                    create: ()=>promise,
                    promise: promise
                };
            }, getModel, ()=>wrapper?.state ?? {
                    model: getModel()
                }, (state)=>updateState(wrapper, state), (newModel)=>wrapper.filterParams?.onModelChange(newModel, additionalEventAttributes));
        };
        displayParams.onAction = (action, additionalEventAttributes, event)=>{
            updateModel(column, action, additionalEventAttributes);
            eventSvc.dispatchEvent({
                type: "filterAction",
                column: column,
                action: action,
                event: event
            });
        };
        return (filter)=>{
            const filterParams = getCompDetails()?.params;
            return this.createManagedBean(new (0, $jIDNV.FilterWrapperComp)(column, {
                comp: filter,
                params: filterParams,
                isHandler: true
            }, eventSvc, updateModel, false));
        };
    }
    executeWhenAllFiltersReady(action) {
        if ((this.wrappers?.length ?? 0) > 0) action();
        else this.afterFiltersReadyFuncs.push(action);
    }
    updateActiveListForFilter(index, filter) {
        this.updateActiveList(index, ()=>filter?.isFilterActive());
    }
    updateActiveListForHandler(index, model) {
        this.updateActiveList(index, ()=>model != null);
    }
    updateActiveList(index, isActive) {
        const activeFilterIndices = this.activeFilterIndices;
        (0, $jIDNV._removeFromArray)(this.activeFilterIndices, index);
        if (isActive()) activeFilterIndices.push(index);
    }
    /** Only called for non-handlers */ onFilterModelChanged(index, additionalEventAttributes) {
        this.updateActiveListForFilter(index, this.wrappers[index]?.filter);
        this.filterChanged(index, additionalEventAttributes);
    }
    onHandlerModelChanged(index, model, additionalEventAttributes) {
        this.updateActiveListForHandler(index, model);
        this.filterChanged(index, additionalEventAttributes);
    }
    filterChanged(index, additionalEventAttributes) {
        this.filterChangedCallback(additionalEventAttributes);
        this.wrappers.forEach((wrapper, childIndex)=>{
            if (index === childIndex || !wrapper) return;
            const { filter: filter, handler: handler } = wrapper;
            handler?.onAnyFilterChanged?.();
            if (typeof filter.onAnyFilterChanged === "function") filter.onAnyFilterChanged();
        });
    }
    getModelAsString(model) {
        if (!model?.filterModels?.length) return "";
        const lastActiveIndex = this.getLastActiveFilterIndex() ?? 0;
        const activeFilter = this.wrappers[lastActiveIndex]?.filter;
        return activeFilter?.getModelAsString?.(model.filterModels[lastActiveIndex]) ?? "";
    }
};
var $5b7ccabde48fae90$var$MultiFilterHandler = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        /** Used to get the filter type for filter models. */ this.filterType = "multi";
        this.handlerWrappers = [];
        /** ui active. could still have null model */ this.activeFilterIndices = [];
        this.filterDefs = [];
    }
    init(params) {
        this.params = params;
        const filterDefs = $5b7ccabde48fae90$var$getMultiFilterDefs(params.filterParams);
        this.filterDefs = filterDefs;
        filterDefs.forEach((def, index)=>{
            const wrapper = this.beans.colFilter.createHandler(params.column, def, "agTextColumnFilter");
            this.handlerWrappers.push(wrapper);
            if (!wrapper) {
                (0, $jIDNV._warn)(278, {
                    colId: params.column.getColId()
                });
                return;
            }
            const { handler: handler, handlerParams: handlerParams } = wrapper;
            handler.init?.({
                ...this.updateHandlerParams(handlerParams, index),
                model: $5b7ccabde48fae90$var$getFilterModelForIndex(params.model, index),
                source: "init"
            });
        });
        this.resetActiveList(params.model);
    }
    refresh(params) {
        this.params = params;
        const { model: model, source: source, filterParams: filterParams } = params;
        const filters = filterParams?.filters;
        this.handlerWrappers.forEach((wrapper, index)=>{
            if (wrapper) {
                const handlerParams = this.updateHandlerParams(params, index);
                const originalFilterParams = handlerParams.filterParams;
                const providedFilterParams = filters?.[index].filterParams;
                const filterParamsForFilter = providedFilterParams ? {
                    ...originalFilterParams,
                    ...providedFilterParams
                } : originalFilterParams;
                const updatedParams = {
                    ...this.updateHandlerParams(params, index),
                    filterParams: filterParamsForFilter
                };
                wrapper.handlerParams = updatedParams;
                wrapper.handler.refresh?.({
                    ...updatedParams,
                    model: $5b7ccabde48fae90$var$getFilterModelForIndex(model, index),
                    source: source
                });
            }
        });
        if (params.source !== "floating" && params.source !== "ui") this.resetActiveList(params.model);
    }
    updateHandlerParams(params, index) {
        const { onModelChange: onModelChange, doesRowPassOtherFilter: doesRowPassOtherFilter, getValue: getValue } = params;
        const handlerParams = {
            ...params,
            onModelChange: (newModel, additionalEventAttributes)=>onModelChange($5b7ccabde48fae90$var$getUpdatedMultiFilterModel(this.params.model, this.handlerWrappers.length, newModel, index), additionalEventAttributes),
            doesRowPassOtherFilter: (node)=>doesRowPassOtherFilter(node) && this.doesFilterPass({
                    node: node,
                    data: node.data,
                    model: this.params.model,
                    handlerParams: handlerParams
                }, index),
            getValue: $5b7ccabde48fae90$var$updateGetValue(this.beans, params.column, this.filterDefs[index], getValue)
        };
        return handlerParams;
    }
    doesFilterPass(params, indexToSkip) {
        const filterModels = params.model?.filterModels;
        if (filterModels == null) return true;
        return this.handlerWrappers.every((wrapper, index)=>{
            const model = filterModels[index];
            if (model == null || indexToSkip != null && index === indexToSkip) return true;
            const handler = wrapper?.handler;
            return !handler || handler.doesFilterPass({
                ...params,
                model: model,
                handlerParams: wrapper.handlerParams
            });
        });
    }
    resetActiveList(model) {
        this.activeFilterIndices = [];
        const filterModels = model?.filterModels;
        if (filterModels == null) return;
        for(let i = 0; i < this.handlerWrappers.length; i++){
            const isActive = filterModels[i] != null;
            if (isActive) this.activeFilterIndices.push(i);
        }
    }
    updateActiveList(index, childModel) {
        const activeFilterIndices = this.activeFilterIndices;
        (0, $jIDNV._removeFromArray)(activeFilterIndices, index);
        if (childModel != null) activeFilterIndices.push(index);
    }
    getLastActiveFilterIndex() {
        const activeFilterIndices = this.activeFilterIndices;
        return activeFilterIndices.length > 0 ? activeFilterIndices[activeFilterIndices.length - 1] : null;
    }
    getModelAsString(model, source) {
        const isForToolPanel = source === "filterToolPanel";
        const defaultOption = ()=>isForToolPanel ? this.getLocaleTextFunc()("filterSummaryInactive", "is (All)") : "";
        if (!model?.filterModels?.length) return defaultOption();
        const lastActiveIndex = this.getLastActiveFilterIndex() ?? 0;
        const activeWrapper = this.handlerWrappers[lastActiveIndex];
        return activeWrapper?.handler.getModelAsString?.(model.filterModels[lastActiveIndex], source) ?? defaultOption();
    }
    getHandler(index) {
        return this.handlerWrappers[index]?.handler;
    }
    onAnyFilterChanged() {
        $5b7ccabde48fae90$var$forEachReverse(this.handlerWrappers, (wrapper)=>wrapper?.handler?.onAnyFilterChanged?.());
    }
    onNewRowsLoaded() {
        $5b7ccabde48fae90$var$forEachReverse(this.handlerWrappers, (wrapper)=>wrapper?.handler?.onNewRowsLoaded?.());
    }
    destroy() {
        this.handlerWrappers.forEach((wrapper)=>this.destroyBean(wrapper?.handler));
        this.handlerWrappers.length = 0;
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$MultiFilterService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "multiFilter";
    }
    getParamsForDataType(existingFilterParams, existingFilterValueGetter, dataTypeDefinition, formatValue) {
        let filters = existingFilterParams?.filters;
        const beans = this.beans;
        if (!filters) {
            const simpleFilter = (0, $jIDNV._getDefaultSimpleFilter)(dataTypeDefinition.baseDataType);
            filters = [
                {
                    filter: simpleFilter
                },
                {
                    filter: "agSetColumnFilter"
                }
            ];
        }
        const translate = this.getLocaleTextFunc();
        filters = filters.map((filterDef)=>{
            const { filter: filter, filterParams: existingChildFilterParams, filterValueGetter: existingChildFilterValueGetter } = filterDef;
            if (typeof filter !== "string") return filterDef;
            const { filterParams: filterParams, filterValueGetter: filterValueGetter } = (0, $jIDNV._getFilterParamsForDataType)(filter, existingChildFilterParams, existingChildFilterValueGetter ?? existingFilterValueGetter, dataTypeDefinition, formatValue, beans, translate);
            return {
                ...filterDef,
                filterParams: filterParams,
                filterValueGetter: filterValueGetter
            };
        });
        return {
            filterParams: {
                ...existingFilterParams,
                filters: filters
            }
        };
    }
};
var $5b7ccabde48fae90$var$MultiFilterUi = class extends $5b7ccabde48fae90$var$BaseMultiFilter {
    constructor(){
        super(...arguments);
        this.filterType = "multi";
        this.filters = [];
        this.filterParams = [];
        this.validity = [];
    }
    init(params) {
        this.params = params;
        this.filterDefs = $5b7ccabde48fae90$var$getMultiFilterDefs(params);
        this.allState = params.state;
        const filterPromises = this.filterDefs.map((filterDef, index)=>this.createFilter(filterDef, index));
        return new (0, $jIDNV.AgPromise)((resolve)=>{
            (0, $jIDNV.AgPromise).all(filterPromises).then((filters)=>{
                this.filters = filters;
                this.refreshGui("columnMenu").then(()=>{
                    resolve();
                });
            });
        });
    }
    refresh(params) {
        const { model: model, state: state, source: source } = params;
        if (source === "colDef") return false;
        this.params = params;
        const filterParams = this.filterParams;
        if (state === this.allState) return true;
        this.allState = state;
        const newAllStateState = state.state;
        this.filters.forEach((filter, index)=>{
            const modelForFilter = $5b7ccabde48fae90$var$getFilterModelForIndex(model, index);
            const stateForFilter = {
                state: newAllStateState?.[index],
                model: $5b7ccabde48fae90$var$getFilterModelForIndex(state.model, index)
            };
            (0, $jIDNV._refreshFilterUi)(filter, filterParams[index], modelForFilter, stateForFilter, source);
        });
        return true;
    }
    getLastActiveFilterIndex() {
        return this.getHandler().getLastActiveFilterIndex?.() ?? null;
    }
    getChildFilterInstance(index) {
        return this.filters[index] ?? void 0;
    }
    destroy() {
        this.filters.forEach((filter)=>this.destroyBean(filter));
        this.filters.length = 0;
        super.destroy();
    }
    getFilterWrappers() {
        return this.filters;
    }
    getFilterFromWrapper(wrapper) {
        return wrapper;
    }
    getCompFromWrapper(wrapper) {
        return wrapper;
    }
    createFilter(filterDef, index) {
        const userCompFactory = this.beans.userCompFactory;
        const filterParams = this.updateParams(filterDef, this.params, index);
        const compDetails = (0, $jIDNV._getFilterDetails)(userCompFactory, filterDef, filterParams, "agTextColumnFilter");
        if (!compDetails) return (0, $jIDNV.AgPromise).resolve(null);
        this.filterParams[index] = compDetails.params;
        return compDetails.newAgStackInstance();
    }
    updateParams(filterDef, params, index) {
        const { doesRowPassOtherFilter: doesRowPassOtherFilter, model: model, onModelChange: onModelChange, state: state, onStateChange: onStateChange, column: column, source: source, onAction: onAction, onUiChange: onUiChange, getValue: getValue } = params;
        const filterModel = $5b7ccabde48fae90$var$getFilterModelForIndex(model, index);
        const filterState = state ? {
            model: $5b7ccabde48fae90$var$getFilterModelForIndex(state.model, index),
            state: state.state?.[index]
        } : {
            model: filterModel
        };
        const onAnyFilterChanged = ()=>{
            const handler = this.getHandler();
            this.filters.forEach((filter, otherIndex)=>{
                if (index !== otherIndex) {
                    handler.getHandler(otherIndex)?.onAnyFilterChanged?.();
                    filter?.onAnyFilterChanged?.();
                }
            });
        };
        const colFilter = this.beans.colFilter;
        return {
            ...colFilter.createBaseFilterParams(column),
            ...filterDef,
            doesRowPassOtherFilter: (node)=>doesRowPassOtherFilter(node) && this.getHandler().doesFilterPass({
                    node: node,
                    data: node.data,
                    model: this.params.model,
                    handlerParams: colFilter.getHandlerParams(column)
                }, index),
            model: filterModel,
            state: filterState,
            onModelChange: (childModel, additionalEventAttributes)=>{
                const { filters: filters, params: params2 } = this;
                const newModel = $5b7ccabde48fae90$var$getUpdatedMultiFilterModel(params2.model, filters.length, childModel, index);
                this.updateActiveList(index, childModel);
                onModelChange(newModel, additionalEventAttributes);
                onAnyFilterChanged();
            },
            onStateChange: (newState)=>this.onStateChange(onStateChange, index, newState),
            getHandler: ()=>this.getHandler().getHandler(index),
            onAction: (action, additionalEventAttributes, event)=>{
                if ((0, $jIDNV._isUseApplyButton)(params)) return;
                const isChange = action === "apply" || action === "reset";
                if (isChange) this.updateActiveList(index, $5b7ccabde48fae90$var$getFilterModelForIndex(this.params.state.model, index));
                onAction(action, additionalEventAttributes, event);
                if (isChange) onAnyFilterChanged();
            },
            onUiChange: onUiChange,
            source: source,
            getValue: $5b7ccabde48fae90$var$updateGetValue(this.beans, column, filterDef, getValue)
        };
    }
    updateActiveList(index, childModel) {
        this.getHandler().updateActiveList?.(index, childModel);
    }
    getHandler() {
        return this.params.getHandler();
    }
    onStateChange(onStateChange, index, newState) {
        const { model: model, state: state, valid: valid } = newState;
        const validity = this.validity;
        validity[index] = valid;
        const allState = this.allState;
        const newModel = $5b7ccabde48fae90$var$getUpdatedMultiFilterModel(allState.model, this.filters.length, model, index);
        const allValid = validity.every((filterValid)=>filterValid !== false);
        const allStateState = [
            ...allState.state ?? []
        ];
        allStateState[index] = state;
        const newAllState = {
            state: allStateState,
            model: newModel,
            valid: allValid
        };
        this.allState = newAllState;
        onStateChange(newAllState);
    }
    getModelAsString(model) {
        return this.getHandler().getModelAsString?.(model) ?? "";
    }
};
var $5b7ccabde48fae90$var$MultiFloatingFilterElement = {
    tag: "div",
    cls: "ag-multi-floating-filter ag-floating-filter-input"
};
var $5b7ccabde48fae90$var$MultiFloatingFilterComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$MultiFloatingFilterElement);
        this.floatingFilters = [];
        this.compDetailsList = [];
    }
    init(params) {
        this.params = params;
        const { compDetailsList: compDetailsList } = this.getCompDetailsList(params);
        return this.setParams(compDetailsList);
    }
    setParams(compDetailsList) {
        const floatingFilterPromises = [];
        compDetailsList.forEach((compDetails)=>{
            const floatingFilterPromise = compDetails?.newAgStackInstance();
            if (floatingFilterPromise != null) {
                this.compDetailsList.push(compDetails);
                floatingFilterPromises.push(floatingFilterPromise);
            }
        });
        return (0, $jIDNV.AgPromise).all(floatingFilterPromises).then((floatingFilters)=>{
            floatingFilters.forEach((floatingFilter, index)=>{
                this.floatingFilters.push(floatingFilter);
                const gui = floatingFilter.getGui();
                this.appendChild(gui);
                if (index > 0) (0, $jIDNV._setDisplayed)(gui, false);
            });
        });
    }
    refresh(params) {
        this.params = params;
        const { compDetailsList: newCompDetailsList, floatingFilterParamsList: floatingFilterParamsList } = this.getCompDetailsList(params);
        const allFloatingFilterCompsUnchanged = newCompDetailsList.length === this.compDetailsList.length && newCompDetailsList.every((newCompDetails, index)=>!this.beans.colFilter?.areFilterCompsDifferent(this.compDetailsList[index], newCompDetails));
        if (allFloatingFilterCompsUnchanged) {
            floatingFilterParamsList.forEach((floatingFilterParams, index)=>{
                const floatingFilter = this.floatingFilters[index];
                floatingFilter.refresh?.(floatingFilterParams);
            });
            if (this.gos.get("enableFilterHandlers")) {
                const reactiveParams = params;
                if (reactiveParams.model == null) this.floatingFilters.forEach((filter, i)=>{
                    (0, $jIDNV._setDisplayed)(filter.getGui(), i === 0);
                });
                else {
                    const lastActiveFloatingFilterIndex = reactiveParams.getHandler()?.getLastActiveFilterIndex?.();
                    this.floatingFilters.forEach((filter, i)=>{
                        const shouldShow = lastActiveFloatingFilterIndex == null ? i === 0 : i === lastActiveFloatingFilterIndex;
                        (0, $jIDNV._setDisplayed)(filter.getGui(), shouldShow);
                    });
                }
            }
        } else {
            (0, $jIDNV._clearElement)(this.getGui());
            this.destroyBeans(this.floatingFilters);
            this.floatingFilters = [];
            this.compDetailsList = [];
            this.setParams(newCompDetailsList);
        }
    }
    getCompDetailsList(params) {
        const compDetailsList = [];
        const floatingFilterParamsList = [];
        const filterParams = params.filterParams;
        const currentParentModel = params.currentParentModel;
        const filterDefs = $5b7ccabde48fae90$var$getMultiFilterDefs(filterParams);
        filterDefs.forEach((filterDef, index)=>{
            const floatingFilterParams = {
                ...params,
                // set the parent filter instance for each floating filter to the relevant child filter instance
                parentFilterInstance: (callback)=>{
                    this.parentMultiFilterInstance((parent)=>{
                        const child = parent.getChildFilterInstance(index);
                        if (child == null) return;
                        callback(child);
                    });
                },
                // return the parent model for the specific filter
                currentParentModel: ()=>currentParentModel()?.filterModels?.[index] ?? null
            };
            if (this.gos.get("enableFilterHandlers")) {
                const reactiveParams = floatingFilterParams;
                reactiveParams.model = reactiveParams.model?.filterModels?.[index] ?? null;
                const { onModelChange: onModelChange, getHandler: getHandler } = reactiveParams;
                reactiveParams.onModelChange = (newModel, additionalEventAttributes)=>onModelChange($5b7ccabde48fae90$var$getUpdatedMultiFilterModel(this.params.model, filterDefs.length, newModel, index), additionalEventAttributes);
                reactiveParams.getHandler = ()=>{
                    const multiFilterHandler = getHandler();
                    return multiFilterHandler.getHandler(index);
                };
            }
            (0, $jIDNV._mergeDeep)(floatingFilterParams.filterParams, filterDef.filterParams);
            const compDetails = this.getCompDetails(filterDef, floatingFilterParams);
            if (compDetails) {
                compDetailsList.push(compDetails);
                floatingFilterParamsList.push(floatingFilterParams);
            }
        });
        return {
            compDetailsList: compDetailsList,
            floatingFilterParamsList: floatingFilterParamsList
        };
    }
    onParentModelChanged(model, event) {
        if (event && event.afterFloatingFilter) return;
        this.parentMultiFilterInstance((parent)=>{
            if (model == null) this.floatingFilters.forEach((filter, i)=>{
                filter.onParentModelChanged(null, event);
                (0, $jIDNV._setDisplayed)(filter.getGui(), i === 0);
            });
            else {
                const lastActiveFloatingFilterIndex = parent.getLastActiveFilterIndex();
                this.floatingFilters.forEach((filter, i)=>{
                    const filterModel = model.filterModels.length > i ? model.filterModels[i] : null;
                    filter.onParentModelChanged(filterModel, event);
                    const shouldShow = lastActiveFloatingFilterIndex == null ? i === 0 : i === lastActiveFloatingFilterIndex;
                    (0, $jIDNV._setDisplayed)(filter.getGui(), shouldShow);
                });
            }
        });
    }
    destroy() {
        this.destroyBeans(this.floatingFilters);
        this.floatingFilters.length = 0;
        super.destroy();
    }
    getCompDetails(filterDef, params) {
        const { colFilter: colFilter, frameworkOverrides: frameworkOverrides, userCompFactory: userCompFactory } = this.beans;
        const defaultComponentName = (0, $jIDNV._getDefaultFloatingFilterType)(frameworkOverrides, filterDef, ()=>colFilter.getDefaultFloatingFilter(this.params.column)) ?? "agReadOnlyFloatingFilter";
        return (0, $jIDNV._getFloatingFilterCompDetails)(userCompFactory, filterDef, params, defaultComponentName);
    }
    parentMultiFilterInstance(cb) {
        this.params.parentFilterInstance((parent)=>{
            if (!(parent instanceof $5b7ccabde48fae90$var$MultiFilter || parent instanceof $5b7ccabde48fae90$var$MultiFilterUi)) (0, $jIDNV._error)(120);
            cb(parent);
        });
    }
};
// packages/ag-grid-enterprise/src/multiFilter/multiFilterModule.ts
var $5b7ccabde48fae90$export$8897e17f4dd9d13a = {
    moduleName: "MultiFilter",
    version: $5b7ccabde48fae90$var$VERSION,
    userComponents: {
        agMultiColumnFilter: {
            getComp: (beans)=>beans.gos.get("enableFilterHandlers") ? {
                    classImp: $5b7ccabde48fae90$var$MultiFilterUi,
                    params: {
                        useForm: true
                    }
                } : $5b7ccabde48fae90$var$MultiFilter
        },
        agMultiColumnFloatingFilter: $5b7ccabde48fae90$var$MultiFloatingFilterComp
    },
    beans: [
        $5b7ccabde48fae90$var$MultiFilterService
    ],
    dynamicBeans: {
        agMultiColumnFilterHandler: $5b7ccabde48fae90$var$MultiFilterHandler
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $jIDNV._ColumnFilterModule),
        $5b7ccabde48fae90$var$MenuItemModule
    ]
};
var $5b7ccabde48fae90$var$AggColumnNameService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "aggColNameSvc";
    }
    getHeaderName(column, headerName) {
        if (this.gos.get("suppressAggFuncInHeader")) return headerName;
        const { valueColsSvc: valueColsSvc, colModel: colModel, rowGroupColsSvc: rowGroupColsSvc } = this.beans;
        const pivotValueColumn = column.getColDef().pivotValueColumn;
        const pivotActiveOnThisColumn = (0, $jIDNV._exists)(pivotValueColumn);
        let aggFunc = null;
        let aggFuncFound;
        if (pivotActiveOnThisColumn) {
            const valueColumns = valueColsSvc?.columns ?? [];
            const isCollapsedHeaderEnabled = this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && valueColumns.length === 1;
            const isTotalColumn = column.getColDef().pivotTotalColumnIds !== void 0;
            if (isCollapsedHeaderEnabled && !isTotalColumn) return headerName;
            aggFunc = pivotValueColumn ? pivotValueColumn.getAggFunc() : null;
            aggFuncFound = true;
        } else {
            const measureActive = column.isValueActive();
            const aggregationPresent = colModel.isPivotMode() || rowGroupColsSvc?.columns.length !== 0;
            if (measureActive && aggregationPresent) {
                aggFunc = column.getAggFunc();
                aggFuncFound = true;
            } else aggFuncFound = false;
        }
        if (aggFuncFound) {
            const aggFuncString = typeof aggFunc === "string" ? aggFunc : "func";
            const localeTextFunc = this.getLocaleTextFunc();
            const aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
            return `${aggFuncStringTranslated}(${headerName})`;
        }
        return headerName;
    }
};
var $5b7ccabde48fae90$var$defaultAggFuncNames = {
    sum: "Sum",
    first: "First",
    last: "Last",
    min: "Min",
    max: "Max",
    count: "Count",
    avg: "Average"
};
var $5b7ccabde48fae90$var$AggFuncService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "aggFuncSvc";
        this.aggFuncsMap = {};
        this.initialised = false;
    }
    postConstruct() {
        this.init();
    }
    init() {
        if (this.initialised) return;
        this.initialiseWithDefaultAggregations();
        this.addAggFuncs(this.gos.get("aggFuncs"));
    }
    initialiseWithDefaultAggregations() {
        const aggMap = this.aggFuncsMap;
        aggMap["sum"] = $5b7ccabde48fae90$var$aggSum;
        aggMap["first"] = $5b7ccabde48fae90$var$aggFirst;
        aggMap["last"] = $5b7ccabde48fae90$var$aggLast;
        aggMap["min"] = $5b7ccabde48fae90$var$aggMin;
        aggMap["max"] = $5b7ccabde48fae90$var$aggMax;
        aggMap["count"] = $5b7ccabde48fae90$var$aggCount;
        aggMap["avg"] = $5b7ccabde48fae90$var$aggAvg;
        this.initialised = true;
    }
    isAggFuncPossible(column, func) {
        const allKeys = this.getFuncNames(column);
        const allowed = allKeys.includes(func);
        const funcExists = (0, $jIDNV._exists)(this.aggFuncsMap[func]);
        return allowed && funcExists;
    }
    getDefaultFuncLabel(fctName) {
        return $5b7ccabde48fae90$var$defaultAggFuncNames[fctName] ?? fctName;
    }
    getDefaultAggFunc(column) {
        const defaultAgg = column.getColDef().defaultAggFunc;
        if ((0, $jIDNV._exists)(defaultAgg) && this.isAggFuncPossible(column, defaultAgg)) return defaultAgg;
        if (this.isAggFuncPossible(column, "sum")) return "sum";
        const allKeys = this.getFuncNames(column);
        return allKeys?.length ? allKeys[0] : null;
    }
    addAggFuncs(aggFuncs) {
        this.init();
        if (!aggFuncs) return;
        for (const key of Object.keys(aggFuncs))if (aggFuncs[key]) this.aggFuncsMap[key] = aggFuncs[key];
    }
    getAggFunc(name) {
        this.init();
        return this.aggFuncsMap[name];
    }
    getFuncNames(column) {
        const userAllowedFuncs = column.getColDef().allowedAggFuncs;
        return userAllowedFuncs == null ? Object.keys(this.aggFuncsMap).sort() : userAllowedFuncs;
    }
    clear() {
        this.aggFuncsMap = {};
    }
};
function $5b7ccabde48fae90$var$aggSum(params) {
    const { values: values } = params;
    let result = null;
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (typeof value === "number") {
            if (result === null) result = value;
            else result += typeof result === "number" ? value : BigInt(value);
        } else if (typeof value === "bigint") {
            if (result === null) result = value;
            else result = (typeof result === "bigint" ? result : BigInt(result)) + value;
        }
    }
    return result;
}
function $5b7ccabde48fae90$var$aggFirst(params) {
    return params.values.length > 0 ? params.values[0] : null;
}
function $5b7ccabde48fae90$var$aggLast(params) {
    return params.values.length > 0 ? (0, $jIDNV._last)(params.values) : null;
}
function $5b7ccabde48fae90$var$aggMin(params) {
    const { values: values } = params;
    let result = null;
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if ((typeof value === "number" || typeof value === "bigint") && (result === null || result > value)) result = value;
    }
    return result;
}
function $5b7ccabde48fae90$var$aggMax(params) {
    const { values: values } = params;
    let result = null;
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if ((typeof value === "number" || typeof value === "bigint") && (result === null || result < value)) result = value;
    }
    return result;
}
var $5b7ccabde48fae90$var$COUNT_PROTO = Object.freeze({
    // the grid by default uses toString to render values for an object, so this
    // is a trick to get the default cellRenderer to display the avg value
    toString: function() {
        return this.value.toString();
    },
    // used for sorting
    toNumber: function() {
        return this.value;
    }
});
function $5b7ccabde48fae90$var$aggCount(params) {
    const { values: values } = params;
    let count = 0;
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        count += value != null && typeof value.value === "number" ? value.value : 1;
    }
    const existingAggData = params.rowNode?.aggData?.[params.column.getColId()];
    if (existingAggData && existingAggData.value === count) return existingAggData;
    const result = Object.create($5b7ccabde48fae90$var$COUNT_PROTO);
    result.value = count;
    return result;
}
var $5b7ccabde48fae90$var$AVERAGE_PROTO = Object.freeze({
    // the grid by default uses toString to render values for an object, so this
    // is a trick to get the default cellRenderer to display the avg value
    toString: function() {
        return typeof this.value === "number" || typeof this.value === "bigint" ? this.value.toString() : "";
    },
    // used for sorting
    toNumber: function() {
        return this.value;
    }
});
function $5b7ccabde48fae90$var$aggAvg(params) {
    const { values: values } = params;
    let sum = 0;
    let count = 0;
    for(let i = 0; i < values.length; i++){
        const currentValue = values[i];
        let valueToAdd = null;
        if (typeof currentValue === "number" || typeof currentValue === "bigint") {
            valueToAdd = currentValue;
            count++;
        } else if (currentValue != null && (typeof currentValue.value === "number" || typeof currentValue.value === "bigint") && typeof currentValue.count === "number") {
            valueToAdd = currentValue.value * (typeof currentValue.value === "number" ? currentValue.count : BigInt(currentValue.count));
            count += currentValue.count;
        }
        if (typeof valueToAdd === "number") sum += typeof sum === "number" ? valueToAdd : BigInt(valueToAdd);
        else if (typeof valueToAdd === "bigint") sum = (typeof sum === "bigint" ? sum : BigInt(sum)) + valueToAdd;
    }
    let value = null;
    if (count > 0) value = sum / (typeof sum === "number" ? count : BigInt(count));
    const existingAggData = params.rowNode?.aggData?.[params.column?.getColId()];
    if (existingAggData && existingAggData.count === count && existingAggData.value === value) return existingAggData;
    const result = Object.create($5b7ccabde48fae90$var$AVERAGE_PROTO);
    result.count = count;
    result.value = value;
    return result;
}
// packages/ag-grid-enterprise/src/aggregation/aggregationApi.ts
function $5b7ccabde48fae90$var$addAggFuncs(beans, aggFuncs) {
    if (beans.aggFuncSvc) beans.aggFuncSvc.addAggFuncs(aggFuncs);
}
function $5b7ccabde48fae90$var$clearAggFuncs(beans) {
    if (beans.aggFuncSvc) beans.aggFuncSvc.clear();
}
function $5b7ccabde48fae90$var$setColumnAggFunc(beans, key, aggFunc) {
    beans.valueColsSvc?.setColumnAggFunc?.(key, aggFunc, "api");
}
function $5b7ccabde48fae90$var$_aggregateValues(beans, values, aggFuncOrString, column, rowNode, pivotResultColumn) {
    const aggFunc = typeof aggFuncOrString === "string" ? beans.aggFuncSvc.getAggFunc(aggFuncOrString) : aggFuncOrString;
    if (typeof aggFunc !== "function") {
        (0, $jIDNV._warn)(109, {
            inputValue: aggFuncOrString.toString(),
            allSuggestions: beans.aggFuncSvc.getFuncNames(column)
        });
        return null;
    }
    const params = (0, $jIDNV._addGridCommonParams)(beans.gos, {
        values: values,
        column: column,
        colDef: column.colDef,
        pivotResultColumn: pivotResultColumn,
        rowNode: rowNode,
        // this is typed incorrectly. Within CSRM, this will always be defined. When called from integrated charts, this will never be defined.
        data: rowNode?.data
    });
    return aggFunc(params);
}
// packages/ag-grid-enterprise/src/aggregation/aggregationStage.ts
var $5b7ccabde48fae90$var$AggregationStage = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "aggStage";
        this.refreshProps = /* @__PURE__ */ new Set([
            "getGroupRowAgg",
            "alwaysAggregateAtRootLevel",
            "suppressAggFilteredOnly",
            "grandTotalRow"
        ]);
        this.step = "aggregate";
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.pivotColsSvc = beans.pivotColsSvc;
        this.valueColsSvc = beans.valueColsSvc;
        this.pivotResultCols = beans.pivotResultCols;
        this.valueSvc = beans.valueSvc;
    }
    // it's possible to recompute the aggregate without doing the other parts
    // + api.refreshClientSideRowModel('aggregate')
    execute(params) {
        const noValueColumns = !this.valueColsSvc?.columns?.length;
        const noUserAgg = !this.gos.getCallback("getGroupRowAgg");
        if (noValueColumns && noUserAgg && params.changedPath?.active) return;
        const aggDetails = this.createAggDetails(params);
        this.recursivelyCreateAggData(aggDetails);
    }
    createAggDetails(params) {
        const pivotActive = this.colModel.isPivotActive();
        const measureColumns = this.valueColsSvc?.columns;
        const pivotColumns = pivotActive && this.pivotColsSvc ? this.pivotColsSvc.columns : [];
        const aggDetails = {
            alwaysAggregateAtRootLevel: this.gos.get("alwaysAggregateAtRootLevel"),
            groupIncludeTotalFooter: !!(0, $jIDNV._getGrandTotalRow)(this.gos),
            changedPath: params.changedPath,
            valueColumns: measureColumns ?? [],
            pivotColumns: pivotColumns,
            filteredOnly: !this.isSuppressAggFilteredOnly(),
            userAggFunc: this.gos.getCallback("getGroupRowAgg")
        };
        return aggDetails;
    }
    isSuppressAggFilteredOnly() {
        const isGroupAggFiltering = (0, $jIDNV._getGroupAggFiltering)(this.gos) !== void 0;
        return isGroupAggFiltering || this.gos.get("suppressAggFilteredOnly");
    }
    recursivelyCreateAggData(aggDetails) {
        const callback = (rowNode)=>{
            const hasNoChildren = !rowNode.hasChildren();
            if (hasNoChildren) {
                if (rowNode.aggData) this.setAggData(rowNode, null);
                return;
            }
            const isRootNode = rowNode.level === -1;
            if (isRootNode && !aggDetails.groupIncludeTotalFooter) {
                const notPivoting = !this.colModel.isPivotMode();
                if (!aggDetails.alwaysAggregateAtRootLevel && notPivoting) {
                    this.setAggData(rowNode, null);
                    return;
                }
            }
            this.aggregateRowNode(rowNode, aggDetails);
        };
        aggDetails.changedPath.forEachChangedNodeDepthFirst(callback, true);
    }
    aggregateRowNode(rowNode, aggDetails) {
        const measureColumnsMissing = aggDetails.valueColumns.length === 0;
        const pivotColumnsMissing = aggDetails.pivotColumns.length === 0;
        let aggResult;
        if (aggDetails.userAggFunc) aggResult = aggDetails.userAggFunc({
            nodes: rowNode.childrenAfterFilter
        });
        else if (measureColumnsMissing) aggResult = null;
        else if (pivotColumnsMissing) aggResult = this.aggregateRowNodeUsingValuesOnly(rowNode, aggDetails);
        else aggResult = this.aggregateRowNodeUsingValuesAndPivot(rowNode);
        this.setAggData(rowNode, aggResult);
        if (rowNode.sibling) {
            this.setAggData(rowNode.sibling, aggResult);
            if (rowNode.sibling.pinnedSibling) this.setAggData(rowNode.sibling.pinnedSibling, aggResult);
        }
    }
    aggregateRowNodeUsingValuesAndPivot(rowNode) {
        const result = {};
        const secondaryColumns = this.pivotResultCols?.getPivotResultCols()?.list ?? [];
        let canSkipTotalColumns = true;
        const beans = this.beans;
        for(let i = 0; i < secondaryColumns.length; i++){
            const secondaryCol = secondaryColumns[i];
            const colDef = secondaryCol.getColDef();
            if (colDef.pivotTotalColumnIds != null) {
                canSkipTotalColumns = false;
                continue;
            }
            const keys = colDef.pivotKeys ?? [];
            let values;
            if (rowNode.leafGroup) values = this.getValuesFromMappedSet(rowNode.childrenMapped, keys, colDef.pivotValueColumn);
            else values = this.getValuesPivotNonLeaf(rowNode, colDef.colId);
            result[colDef.colId] = $5b7ccabde48fae90$var$_aggregateValues(beans, values, colDef.pivotValueColumn.getAggFunc(), colDef.pivotValueColumn, rowNode, secondaryCol);
        }
        if (!canSkipTotalColumns) for(let i = 0; i < secondaryColumns.length; i++){
            const secondaryCol = secondaryColumns[i];
            const colDef = secondaryCol.getColDef();
            if (colDef.pivotTotalColumnIds == null || !colDef.pivotTotalColumnIds.length) continue;
            const aggResults = colDef.pivotTotalColumnIds.map((currentColId)=>result[currentColId]);
            result[colDef.colId] = $5b7ccabde48fae90$var$_aggregateValues(beans, aggResults, colDef.pivotValueColumn.getAggFunc(), colDef.pivotValueColumn, rowNode, secondaryCol);
        }
        return result;
    }
    aggregateRowNodeUsingValuesOnly(rowNode, aggDetails) {
        const result = {};
        const { changedPath: changedPath, valueColumns: valueColumns, filteredOnly: filteredOnly } = aggDetails;
        const changedValueColumns = changedPath.active ? changedPath.getValueColumnsForNode(rowNode, valueColumns) : valueColumns;
        const notChangedValueColumns = changedPath.active ? changedPath.getNotValueColumnsForNode(rowNode, valueColumns) : null;
        const values2d = this.getValuesNormal(rowNode, changedValueColumns, filteredOnly);
        const oldValues = rowNode.aggData;
        const beans = this.beans;
        changedValueColumns.forEach((valueColumn, index)=>{
            result[valueColumn.getId()] = $5b7ccabde48fae90$var$_aggregateValues(beans, values2d[index], valueColumn.getAggFunc(), valueColumn, rowNode);
        });
        if (notChangedValueColumns && oldValues) notChangedValueColumns.forEach((valueColumn)=>{
            result[valueColumn.getId()] = oldValues[valueColumn.getId()];
        });
        return result;
    }
    getValuesPivotNonLeaf(rowNode, colId) {
        return rowNode.childrenAfterFilter.map((childNode)=>childNode.aggData[colId]);
    }
    getValuesFromMappedSet(mappedSet, keys, valueColumn) {
        let mapPointer = mappedSet;
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            mapPointer = mapPointer ? mapPointer[key] : null;
        }
        if (!mapPointer) return [];
        return mapPointer.map((rowNode)=>this.valueSvc.getValue(valueColumn, rowNode));
    }
    getValuesNormal(rowNode, valueColumns, filteredOnly) {
        const values = [];
        valueColumns.forEach(()=>values.push([]));
        const valueColumnCount = valueColumns.length;
        const nodeList = filteredOnly ? rowNode.childrenAfterFilter : rowNode.childrenAfterGroup;
        const rowCount = nodeList.length;
        for(let i = 0; i < rowCount; i++){
            const childNode = nodeList[i];
            for(let j = 0; j < valueColumnCount; j++){
                const valueColumn = valueColumns[j];
                const value = this.valueSvc.getValue(valueColumn, childNode);
                values[j].push(value);
            }
        }
        return values;
    }
    setAggData(rowNode, newAggData) {
        const oldAggData = rowNode.aggData;
        rowNode.aggData = newAggData;
        if (rowNode.__localEventService) {
            const eventFunc = (colId)=>{
                const value = rowNode.aggData ? rowNode.aggData[colId] : void 0;
                const oldValue = oldAggData ? oldAggData[colId] : void 0;
                if (value === oldValue) return;
                const column = this.colModel.getColById(colId);
                if (!column) return;
                rowNode.dispatchCellChangedEvent(column, value, oldValue);
            };
            if (oldAggData) for (const key of Object.keys(oldAggData))eventFunc(key);
            if (newAggData) {
                for (const key of Object.keys(newAggData))if (!oldAggData || !(key in oldAggData)) eventFunc(key);
            }
        }
    }
};
var $5b7ccabde48fae90$var$FilterAggregatesStage = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "filterAggStage";
        this.refreshProps = /* @__PURE__ */ new Set([]);
        this.step = "filter_aggregates";
    }
    wireBeans(beans) {
        this.filterManager = beans.filterManager;
    }
    execute(params) {
        const isPivotMode2 = this.beans.colModel.isPivotMode();
        const isAggFilterActive = this.filterManager?.isAggregateFilterPresent() || this.filterManager?.isAggregateQuickFilterPresent();
        const defaultPrimaryColumnPredicate = (params2)=>!params2.node.group;
        const defaultSecondaryColumnPredicate = (params2)=>params2.node.leafGroup;
        const applyFilterToNode = (0, $jIDNV._getGroupAggFiltering)(this.gos) || (isPivotMode2 ? defaultSecondaryColumnPredicate : defaultPrimaryColumnPredicate);
        const { changedPath: changedPath } = params;
        const preserveChildren = (node, recursive = false)=>{
            if (node.childrenAfterFilter) {
                node.childrenAfterAggFilter = node.childrenAfterFilter;
                if (recursive) node.childrenAfterAggFilter.forEach((child)=>preserveChildren(child, recursive));
                this.setAllChildrenCount(node);
            }
            if (node.sibling) node.sibling.childrenAfterAggFilter = node.childrenAfterAggFilter;
        };
        const filterChildren = (node)=>{
            node.childrenAfterAggFilter = node.childrenAfterFilter?.filter((child)=>{
                const shouldFilterRow = applyFilterToNode({
                    node: child
                });
                if (shouldFilterRow) {
                    const doesNodePassFilter = this.filterManager.doesRowPassAggregateFilters({
                        rowNode: child
                    });
                    if (doesNodePassFilter) {
                        preserveChildren(child, true);
                        return true;
                    }
                }
                const hasChildPassed = child.childrenAfterAggFilter?.length;
                return hasChildPassed;
            }) || null;
            this.setAllChildrenCount(node);
            if (node.sibling) node.sibling.childrenAfterAggFilter = node.childrenAfterAggFilter;
        };
        changedPath.forEachChangedNodeDepthFirst(isAggFilterActive ? filterChildren : preserveChildren, true);
    }
    /** for tree data, we include all children, groups and leafs */ setAllChildrenCountTreeData(rowNode) {
        const childrenAfterAggFilter = rowNode.childrenAfterAggFilter;
        let allChildrenCount = 0;
        if (childrenAfterAggFilter) {
            const length = childrenAfterAggFilter.length;
            allChildrenCount = length;
            for(let i = 0; i < length; ++i)allChildrenCount += childrenAfterAggFilter[i].allChildrenCount ?? 0;
        }
        rowNode.setAllChildrenCount(// Maintain the historical behaviour:
        // - allChildrenCount is 0 in the root if there are no children
        // - allChildrenCount is null in any non-root row if there are no children
        allChildrenCount === 0 && rowNode.level >= 0 ? null : allChildrenCount);
    }
    /* for grid data, we only count the leafs */ setAllChildrenCountGridGrouping(rowNode) {
        let allChildrenCount = 0;
        rowNode.childrenAfterAggFilter.forEach((child)=>{
            if (child.group) allChildrenCount += child.allChildrenCount;
            else allChildrenCount++;
        });
        rowNode.setAllChildrenCount(allChildrenCount);
    }
    setAllChildrenCount(rowNode) {
        if (!rowNode.hasChildren()) {
            rowNode.setAllChildrenCount(null);
            return;
        }
        if (this.gos.get("treeData")) this.setAllChildrenCountTreeData(rowNode);
        else this.setAllChildrenCountGridGrouping(rowNode);
    }
};
function $5b7ccabde48fae90$var$_createRowNodeFooter(rowNode, beans) {
    if (rowNode.sibling) return;
    const footerNode = (0, $jIDNV._createRowNodeSibling)(rowNode, beans);
    footerNode.footer = true;
    footerNode.setRowTop(null);
    footerNode.setRowIndex(null);
    footerNode.oldRowTop = null;
    footerNode.id = "rowGroupFooter_" + rowNode.id;
    footerNode.sibling = rowNode;
    rowNode.sibling = footerNode;
}
function $5b7ccabde48fae90$var$_destroyRowNodeFooter(rowNode) {
    if (!rowNode.sibling) return;
    rowNode.sibling.setRowTop(null);
    rowNode.sibling.setRowIndex(null);
    rowNode.sibling = void 0;
}
// packages/ag-grid-enterprise/src/aggregation/footerService.ts
var $5b7ccabde48fae90$var$FooterService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "footerSvc";
    }
    addTotalRows(startIndex, node, callback, includeFooterNodes, isRootNode, position) {
        let index = startIndex;
        if (isRootNode) {
            const grandTotal = includeFooterNodes && (0, $jIDNV._getGrandTotalRow)(this.gos);
            if ($5b7ccabde48fae90$var$_positionMatchesGrandTotalRow(position, grandTotal)) {
                $5b7ccabde48fae90$var$_createRowNodeFooter(node, this.beans);
                callback(node.sibling, index++);
            }
            return index;
        }
        const isGroupIncludeFooter = (0, $jIDNV._getGroupTotalRowCallback)(this.gos);
        const groupTotal = includeFooterNodes && isGroupIncludeFooter({
            node: node
        });
        if (groupTotal === position) {
            $5b7ccabde48fae90$var$_createRowNodeFooter(node, this.beans);
            callback(node.sibling, index++);
        }
        return index;
    }
    getTopDisplayIndex(rowsToDisplay, topLevelIndex, childrenAfterSort, getDefaultIndex) {
        let adjustedIndex = topLevelIndex;
        if (rowsToDisplay[0].footer) {
            if (topLevelIndex === 0) return 0;
            adjustedIndex -= 1;
        }
        const lastRow = rowsToDisplay[rowsToDisplay.length - 1];
        const indexOutsideGroupBounds = adjustedIndex >= childrenAfterSort.length;
        if (lastRow.footer && indexOutsideGroupBounds) return lastRow.rowIndex;
        return getDefaultIndex(adjustedIndex);
    }
    doesCellShowTotalPrefix(node, col) {
        if (!node.footer || !col?.getColDef().showRowGroup) return false;
        if (this.gos.get("treeData")) return true;
        if (node.level === -1) return this.beans.showRowGroupCols?.getShowRowGroupCols()[0] === col;
        return !!node.rowGroupColumn && col && col.isRowGroupDisplayed(node.rowGroupColumn.getId());
    }
    applyTotalPrefix(value, formattedValue, node, column) {
        const totalValueGetter = column.getColDef().cellRendererParams?.totalValueGetter;
        if (totalValueGetter) {
            const valueGetterParams = (0, $jIDNV._addGridCommonParams)(this.gos, {
                column: column,
                node: node,
                value: value,
                formattedValue: formattedValue
            });
            const getterType = typeof totalValueGetter;
            if (getterType === "function") return totalValueGetter(valueGetterParams);
            if (typeof totalValueGetter === "string") return this.beans.expressionSvc?.evaluate(totalValueGetter, valueGetterParams);
            (0, $jIDNV._warn)(179);
        }
        if (node.level === -1) return this.getLocaleTextFunc()("footerTotal", "Total") + " ";
        return this.getTotalValue(formattedValue ?? value) ?? "";
    }
    getTotalValue(value) {
        return this.getLocaleTextFunc()("footerTotal", "Total") + " " + (value ?? "");
    }
};
function $5b7ccabde48fae90$var$_positionMatchesGrandTotalRow(position, grandTotaRow) {
    switch(grandTotaRow){
        case "top":
        case "pinnedTop":
            return position === "top";
        case "bottom":
        case "pinnedBottom":
            return position === "bottom";
        default:
            return false;
    }
}
var $5b7ccabde48fae90$var$ValueColsSvc = class extends (0, $jIDNV.BaseColsService) {
    constructor(){
        super(...arguments);
        this.beanName = "valueColsSvc";
        this.eventName = "columnValueChanged";
        this.columnProcessors = {
            set: (column, added, source)=>this.setValueActive(added, column, source),
            add: (column, added, source)=>this.setValueActive(true, column, source),
            remove: (column, added, source)=>this.setValueActive(false, column, source)
        };
        this.columnExtractors = {
            setFlagFunc: (col, flag, source)=>this.setColValueActive(col, flag, source),
            getIndexFunc: ()=>void 0,
            getInitialIndexFunc: ()=>void 0,
            getValueFunc: (colDef)=>{
                const aggFunc = colDef.aggFunc;
                if (aggFunc === null || aggFunc === "") return null;
                if (aggFunc === void 0) return;
                return !!aggFunc;
            },
            getInitialValueFunc: (colDef)=>{
                return colDef.initialAggFunc != null && colDef.initialAggFunc != "";
            }
        };
        this.modifyColumnsNoEventsCallbacks = {
            addCol: (column)=>this.columns.push(column),
            removeCol: (column)=>(0, $jIDNV._removeFromArray)(this.columns, column)
        };
    }
    extractCols(source, oldProvidedCols) {
        this.columns = super.extractCols(source, oldProvidedCols);
        this.columns.forEach((col)=>{
            const colDef = col.getColDef();
            if (colDef.aggFunc != null && colDef.aggFunc != "") this.setColAggFunc(col, colDef.aggFunc);
            else if (!col.getAggFunc()) this.setColAggFunc(col, colDef.initialAggFunc);
        });
        return this.columns;
    }
    setColumnAggFunc(key, aggFunc, source) {
        if (!key) return;
        const column = this.colModel.getColDefCol(key);
        if (!column) return;
        this.setColAggFunc(column, aggFunc);
        this.dispatchColumnChangedEvent(this.eventSvc, this.eventName, [
            column
        ], source);
    }
    syncColumnWithState(column, source, getValue) {
        const aggFunc = getValue("aggFunc").value1;
        if (aggFunc !== void 0) {
            if (typeof aggFunc === "string") {
                this.setColAggFunc(column, aggFunc);
                if (!column.isValueActive()) {
                    this.setColValueActive(column, true, source);
                    this.modifyColumnsNoEventsCallbacks.addCol(column);
                }
            } else {
                if ((0, $jIDNV._exists)(aggFunc)) (0, $jIDNV._warn)(33);
                if (column.isValueActive()) {
                    this.setColValueActive(column, false, source);
                    this.modifyColumnsNoEventsCallbacks.removeCol(column);
                }
            }
        }
    }
    setValueActive(active, column, source) {
        if (active === column.isValueActive()) return;
        this.setColValueActive(column, active, source);
        if (active && !column.getAggFunc() && this.aggFuncSvc) {
            const initialAggFunc = this.aggFuncSvc.getDefaultAggFunc(column);
            this.setColAggFunc(column, initialAggFunc);
        }
    }
    setColAggFunc(column, aggFunc) {
        column.aggFunc = aggFunc;
        column.dispatchStateUpdatedEvent("aggFunc");
    }
    setColValueActive(column, value, source) {
        if (column.aggregationActive !== value) {
            column.aggregationActive = value;
            column.dispatchColEvent("columnValueChanged", source);
        }
    }
};
// packages/ag-grid-enterprise/src/aggregation/aggregationModule.ts
var $5b7ccabde48fae90$var$SharedAggregationModule = {
    moduleName: "SharedAggregation",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$AggFuncService,
        $5b7ccabde48fae90$var$AggColumnNameService,
        $5b7ccabde48fae90$var$FooterService,
        $5b7ccabde48fae90$var$ValueColsSvc
    ],
    apiFunctions: {
        addAggFuncs: $5b7ccabde48fae90$var$addAggFuncs,
        clearAggFuncs: $5b7ccabde48fae90$var$clearAggFuncs,
        setColumnAggFunc: $5b7ccabde48fae90$var$setColumnAggFunc
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule
    ]
};
var $5b7ccabde48fae90$export$b53def5458540436 = {
    moduleName: "Aggregation",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$AggregationStage,
        $5b7ccabde48fae90$var$FilterAggregatesStage
    ],
    rowModels: [
        "clientSide"
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$SharedAggregationModule
    ]
};
var $5b7ccabde48fae90$var$PivotColsSvc = class extends (0, $jIDNV.BaseColsService) {
    constructor(){
        super(...arguments);
        this.beanName = "pivotColsSvc";
        this.eventName = "columnPivotChanged";
        this.columnProcessors = {
            set: (column, added, source)=>this.setColPivotActive(column, added, source),
            add: (column, added, source)=>this.setColPivotActive(column, true, source),
            remove: (column, added, source)=>this.setColPivotActive(column, false, source)
        };
        this.columnOrdering = {
            enableProp: "pivot",
            initialEnableProp: "initialPivot",
            indexProp: "pivotIndex",
            initialIndexProp: "initialPivotIndex"
        };
        this.columnExtractors = {
            setFlagFunc: (col, flag, source)=>this.setColPivotActive(col, flag, source),
            getIndexFunc: (colDef)=>colDef.pivotIndex,
            getInitialIndexFunc: (colDef)=>colDef.initialPivotIndex,
            getValueFunc: (colDef)=>colDef.pivot,
            getInitialValueFunc: (colDef)=>colDef.initialPivot
        };
        this.modifyColumnsNoEventsCallbacks = {
            addCol: (column)=>this.columns.push(column),
            removeCol: (column)=>(0, $jIDNV._removeFromArray)(this.columns, column)
        };
    }
    syncColumnWithState(column, source, getValue, rowIndex) {
        const { value1: pivot, value2: pivotIndex } = getValue("pivot", "pivotIndex");
        if (pivot !== void 0 || pivotIndex !== void 0) {
            if (typeof pivotIndex === "number" || pivot) {
                if (!column.isPivotActive()) {
                    this.setColPivotActive(column, true, source);
                    this.modifyColumnsNoEventsCallbacks.addCol(column);
                }
                if (rowIndex && typeof pivotIndex === "number") rowIndex[column.getId()] = pivotIndex;
            } else if (column.isPivotActive()) {
                this.setColPivotActive(column, false, source);
                this.modifyColumnsNoEventsCallbacks.removeCol(column);
            }
        }
    }
    setColPivotActive(column, pivot, source) {
        if (column.pivotActive !== pivot) {
            column.pivotActive = pivot;
            column.dispatchColEvent("columnPivotChanged", source);
        }
        column.dispatchStateUpdatedEvent("pivot");
    }
};
var $5b7ccabde48fae90$var$RowGroupColsSvc = class extends (0, $jIDNV.BaseColsService) {
    constructor(){
        super(...arguments);
        this.beanName = "rowGroupColsSvc";
        this.eventName = "columnRowGroupChanged";
        this.columnProcessors = {
            set: (column, added, source)=>this.setActive(added, column, source),
            add: (column, added, source)=>this.setActive(true, column, source),
            remove: (column, added, source)=>this.setActive(false, column, source)
        };
        this.columnOrdering = {
            enableProp: "rowGroup",
            initialEnableProp: "initialRowGroup",
            indexProp: "rowGroupIndex",
            initialIndexProp: "initialRowGroupIndex"
        };
        this.columnExtractors = {
            setFlagFunc: (col, flag, source)=>this.setColRowGroupActive(col, flag, source),
            getIndexFunc: (colDef)=>colDef.rowGroupIndex,
            getInitialIndexFunc: (colDef)=>colDef.initialRowGroupIndex,
            getValueFunc: (colDef)=>colDef.rowGroup,
            getInitialValueFunc: (colDef)=>colDef.initialRowGroup
        };
        this.modifyColumnsNoEventsCallbacks = {
            addCol: (column)=>this.columns.push(column),
            removeCol: (column)=>(0, $jIDNV._removeFromArray)(this.columns, column)
        };
    }
    moveColumn(fromIndex, toIndex, source) {
        if (this.columns.length === 0) return;
        const column = this.columns[fromIndex];
        const impactedColumns = this.columns.slice(fromIndex, toIndex);
        this.columns.splice(fromIndex, 1);
        this.columns.splice(toIndex, 0, column);
        this.updateIndexMap();
        this.eventSvc.dispatchEvent({
            type: this.eventName,
            columns: impactedColumns,
            column: impactedColumns.length === 1 ? impactedColumns[0] : null,
            source: source
        });
    }
    syncColumnWithState(column, source, getValue, rowIndex) {
        const { value1: rowGroup, value2: rowGroupIndex } = getValue("rowGroup", "rowGroupIndex");
        if (rowGroup !== void 0 || rowGroupIndex !== void 0) {
            if (typeof rowGroupIndex === "number" || rowGroup) {
                if (!column.isRowGroupActive()) {
                    this.setColRowGroupActive(column, true, source);
                    this.modifyColumnsNoEventsCallbacks.addCol(column);
                }
                if (rowIndex && typeof rowGroupIndex === "number") rowIndex[column.getId()] = rowGroupIndex;
            } else if (column.isRowGroupActive()) {
                this.setColRowGroupActive(column, false, source);
                this.modifyColumnsNoEventsCallbacks.removeCol(column);
            }
        }
    }
    setActive(active, column, source) {
        if (active === column.isRowGroupActive()) return;
        this.setColRowGroupActive(column, active, source);
        if ((0, $jIDNV._shouldUpdateColVisibilityAfterGroup)(this.gos, active)) this.colModel.setColsVisible([
            column
        ], !active, source);
    }
    setColRowGroupActive(column, rowGroup, source) {
        if (column.rowGroupActive !== rowGroup) {
            column.rowGroupActive = rowGroup;
            column.dispatchColEvent("columnRowGroupChanged", source);
        }
        column.dispatchStateUpdatedEvent("rowGroup");
    }
};
var $5b7ccabde48fae90$var$AutoColService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "autoColSvc";
    }
    postConstruct() {
        this.addManagedPropertyListener("autoGroupColumnDef", this.updateColumns.bind(this));
    }
    addColumns(cols) {
        if (this.columns == null) return;
        cols.list = this.columns.list.concat(cols.list);
        cols.tree = this.columns.tree.concat(cols.tree);
        (0, $jIDNV._updateColsMap)(cols);
    }
    createColumns(cols, updateOrders) {
        const beans = this.beans;
        const { colModel: colModel, gos: gos, rowGroupColsSvc: rowGroupColsSvc, colGroupSvc: colGroupSvc } = beans;
        const isPivotMode2 = colModel.isPivotMode();
        const groupFullWidthRow = (0, $jIDNV._isGroupUseEntireRow)(gos, isPivotMode2);
        const suppressAutoColumn = isPivotMode2 ? gos.get("pivotSuppressAutoColumn") : this.isSuppressAutoCol();
        const rowGroupCols = rowGroupColsSvc?.columns;
        const groupingActive = rowGroupCols && rowGroupCols.length > 0 || gos.get("treeData");
        const noAutoCols = !groupingActive || suppressAutoColumn || groupFullWidthRow;
        const destroyPrevious = ()=>{
            if (this.columns) {
                (0, $jIDNV._destroyColumnTree)(beans, this.columns.tree);
                this.columns = null;
            }
        };
        if (noAutoCols) {
            destroyPrevious();
            return;
        }
        const list = this.generateAutoCols(rowGroupCols);
        const autoColsSame = (0, $jIDNV._areColIdsEqual)(list, this.columns?.list || null);
        const newTreeDepth = cols.treeDepth;
        const oldTreeDepth = this.columns ? this.columns.treeDepth : -1;
        const treeDepthSame = oldTreeDepth == newTreeDepth;
        if (autoColsSame && treeDepthSame) return;
        destroyPrevious();
        const treeDepth = colGroupSvc?.findDepth(cols.tree) ?? 0;
        const tree = colGroupSvc?.balanceTreeForAutoCols(list, treeDepth) ?? [];
        this.columns = {
            list: list,
            tree: tree,
            treeDepth: treeDepth,
            map: {}
        };
        const putAutoColsFirstInList = (cols2)=>{
            if (!cols2) return null;
            const colsFiltered = cols2.filter((col)=>!(0, $jIDNV.isColumnGroupAutoCol)(col));
            return [
                ...list,
                ...colsFiltered
            ];
        };
        updateOrders(putAutoColsFirstInList);
    }
    updateColumns(event) {
        const source = (0, $jIDNV._convertColumnEventSourceType)(event.source);
        this.columns?.list.forEach((col, index)=>this.updateOneAutoCol(col, index, source));
    }
    getColumn(key) {
        return this.columns?.list.find((groupCol)=>(0, $jIDNV._columnsMatch)(groupCol, key)) ?? null;
    }
    getColumns() {
        return this.columns?.list ?? null;
    }
    generateAutoCols(rowGroupCols = []) {
        const autoCols = [];
        const doingTreeData = this.gos.get("treeData");
        let doingMultiAutoColumn = (0, $jIDNV._isGroupMultiAutoColumn)(this.gos);
        if (doingTreeData && doingMultiAutoColumn) {
            (0, $jIDNV._warn)(182);
            doingMultiAutoColumn = false;
        }
        if (doingMultiAutoColumn) rowGroupCols.forEach((rowGroupCol, index)=>{
            autoCols.push(this.createOneAutoCol(rowGroupCol, index));
        });
        else autoCols.push(this.createOneAutoCol());
        return autoCols;
    }
    isSuppressAutoCol() {
        const gos = this.gos;
        const groupDisplayType = gos.get("groupDisplayType");
        const isCustomRowGroups = groupDisplayType === "custom";
        if (isCustomRowGroups) return true;
        const treeDataDisplayType = gos.get("treeDataDisplayType");
        return treeDataDisplayType === "custom";
    }
    // rowGroupCol and index are missing if groupDisplayType != "multipleColumns"
    createOneAutoCol(rowGroupCol, index) {
        let colId;
        if (rowGroupCol) colId = `${0, $jIDNV.GROUP_AUTO_COLUMN_ID}-${rowGroupCol.getId()}`;
        else colId = (0, $jIDNV.GROUP_AUTO_COLUMN_ID);
        const colDef = this.createAutoColDef(colId, rowGroupCol, index);
        colDef.colId = colId;
        const newCol = new (0, $jIDNV.AgColumn)(colDef, null, colId, true);
        this.createBean(newCol);
        return newCol;
    }
    /**
   * Refreshes an auto group col to load changes from defaultColDef or autoGroupColDef
   */ updateOneAutoCol(colToUpdate, index, source) {
        const oldColDef = colToUpdate.getColDef();
        const underlyingColId = typeof oldColDef.showRowGroup == "string" ? oldColDef.showRowGroup : void 0;
        const beans = this.beans;
        const underlyingColumn = underlyingColId != null ? beans.colModel.getColDefCol(underlyingColId) : void 0;
        const colId = colToUpdate.getId();
        const colDef = this.createAutoColDef(colId, underlyingColumn ?? void 0, index);
        colToUpdate.setColDef(colDef, null, source);
        (0, $jIDNV._applyColumnState)(beans, {
            state: [
                {
                    colId: colId,
                    ...colDef
                }
            ]
        }, source);
    }
    createAutoColDef(colId, underlyingColumn, index) {
        let res = this.createBaseColDef(underlyingColumn);
        const autoGroupColumnDef = this.gos.get("autoGroupColumnDef");
        (0, $jIDNV._mergeDeep)(res, autoGroupColumnDef);
        res = (0, $jIDNV._addColumnDefaultAndTypes)(this.beans, res, colId, true);
        if (!this.gos.get("treeData")) {
            const noFieldOrValueGetter = (0, $jIDNV._missing)(res.field) && (0, $jIDNV._missing)(res.valueGetter) && (0, $jIDNV._missing)(res.filterValueGetter) && res.filter !== "agGroupColumnFilter";
            if (noFieldOrValueGetter) res.filter = false;
        }
        if (index && index > 0) res.headerCheckboxSelection = false;
        const isSortingCoupled = (0, $jIDNV._isColumnsSortingCoupledToGroup)(this.gos);
        const hasOwnData = res.valueGetter || res.field != null;
        if (isSortingCoupled && !hasOwnData) {
            res.sortIndex = void 0;
            res.initialSort = void 0;
        }
        return res;
    }
    createBaseColDef(rowGroupCol) {
        const userDef = this.gos.get("autoGroupColumnDef");
        const localeTextFunc = this.getLocaleTextFunc();
        const res = {
            headerName: localeTextFunc("group", "Group"),
            showRowGroup: rowGroupCol?.getColId() ?? true
        };
        const userHasProvidedGroupCellRenderer = userDef && (userDef.cellRenderer || userDef.cellRendererSelector);
        if (!userHasProvidedGroupCellRenderer) res.cellRenderer = "agGroupCellRenderer";
        if (rowGroupCol) {
            res.headerName = this.beans.colNames.getDisplayNameForColumn(rowGroupCol, "header") ?? void 0;
            res.headerValueGetter = rowGroupCol.colDef.headerValueGetter;
        }
        return res;
    }
    destroy() {
        (0, $jIDNV._destroyColumnTree)(this.beans, this.columns?.tree);
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$BaseExpansionService = class extends (0, $jIDNV.BeanStub) {
    addExpandedCss(classes, rowNode) {
        if (rowNode.isExpandable()) {
            classes.push("ag-row-group");
            classes.push(rowNode.expanded ? "ag-row-group-expanded" : "ag-row-group-contracted");
        }
    }
    getRowExpandedListeners(rowCtrl) {
        const { rowNode: rowNode } = rowCtrl;
        const updateExpandedCss = this.updateExpandedCss.bind(this, rowCtrl, rowNode);
        return {
            expandedChanged: updateExpandedCss,
            hasChildrenChanged: updateExpandedCss
        };
    }
    setExpanded(rowNode, expanded, e, forceSync) {
        if (rowNode.expanded === expanded) return;
        rowNode.expanded = expanded;
        rowNode.dispatchRowEvent("expandedChanged");
        const event = {
            ...(0, $jIDNV._createGlobalRowEvent)(rowNode, this.gos, "rowGroupOpened"),
            expanded: expanded,
            event: e || null
        };
        this.dispatchExpandedEvent(event, forceSync);
    }
    isExpandable(rowNode) {
        if (rowNode.footer) return false;
        if (this.beans.colModel.isPivotMode()) return rowNode.hasChildren() && !rowNode.leafGroup;
        return rowNode.hasChildren() || rowNode.master;
    }
    updateExpandedCss(rowCtrl, rowNode) {
        const expandable = rowNode.isExpandable();
        const expanded = rowNode.expanded == true;
        rowCtrl.forEachGui(void 0, (gui)=>{
            const rowComp = gui.rowComp;
            rowComp.toggleCss("ag-row-group", expandable);
            rowComp.toggleCss("ag-row-group-expanded", expandable && expanded);
            rowComp.toggleCss("ag-row-group-contracted", expandable && !expanded);
            (0, $jIDNV._setAriaExpanded)(gui.element, expandable && expanded);
        });
    }
};
// packages/ag-grid-enterprise/src/rowHierarchy/clientSideExpansionService.ts
var $5b7ccabde48fae90$var$ClientSideExpansionService = class extends $5b7ccabde48fae90$var$BaseExpansionService {
    constructor(){
        super(...arguments);
        this.beanName = "expansionSvc";
        this.events = [];
    }
    wireBeans(beans) {
        this.rowModel = beans.rowModel;
    }
    expandRows(rowIdsToExpand, rowIdsToCollapse) {
        const rowIdsToExpandSet = new Set(rowIdsToExpand);
        const rowIdsToCollapseSet = rowIdsToCollapse ? new Set(rowIdsToCollapse) : void 0;
        this.rowModel.forEachNode((node)=>{
            const id = node.id;
            if (!id) return;
            if (rowIdsToExpandSet.has(id)) node.expanded = true;
            else if (rowIdsToCollapseSet?.has(id)) node.expanded = false;
        });
        this.onGroupExpandedOrCollapsed();
    }
    expandAll(expand) {
        const { gos: gos, colModel: colModel, eventSvc: eventSvc } = this.beans;
        const rowModel = this.rowModel;
        const usingTreeData = gos.get("treeData");
        const usingPivotMode = colModel.isPivotActive();
        const recursiveExpandOrCollapse = (rowNodes)=>{
            if (!rowNodes) return;
            rowNodes.forEach((rowNode)=>{
                const actionRow = ()=>{
                    rowNode.expanded = expand;
                    recursiveExpandOrCollapse(rowNode.childrenAfterGroup);
                };
                if (usingTreeData) {
                    const hasChildren = (0, $jIDNV._exists)(rowNode.childrenAfterGroup);
                    if (hasChildren) actionRow();
                    return;
                }
                if (usingPivotMode) {
                    const notLeafGroup = !rowNode.leafGroup;
                    if (notLeafGroup) actionRow();
                    return;
                }
                const isRowGroup = rowNode.group;
                if (isRowGroup) actionRow();
            });
        };
        const rootNode = rowModel.rootNode;
        if (rootNode) recursiveExpandOrCollapse(rootNode.childrenAfterGroup);
        rowModel.refreshModel({
            step: "map"
        });
        eventSvc.dispatchEvent({
            type: "expandOrCollapseAll",
            source: expand ? "expandAll" : "collapseAll"
        });
    }
    onGroupExpandedOrCollapsed() {
        this.rowModel.refreshModel({
            step: "map"
        });
    }
    // because the user can call rowNode.setExpanded() many times in one VM turn,
    // we throttle the calls to ClientSideRowModel using animationFrameSvc. this means for 100
    // row nodes getting expanded, we only update the CSRM once, and then we fire all events after
    // CSRM has updated.
    //
    // if we did not do this, then the user could call setExpanded on 100+ rows, causing the grid
    // to re-render 100+ times, which would be a performance lag.
    //
    // we use animationFrameService
    // rather than debounce() so this will get done if anyone flushes the animationFrameService
    // (eg user calls api.ensureRowVisible(), which in turn flushes ).
    dispatchExpandedEvent(event, forceSync) {
        this.events.push(event);
        const func = ()=>{
            this.rowModel.onRowGroupOpened();
            this.events.forEach((e)=>this.eventSvc.dispatchEvent(e));
            const nodes = this.events.map((e)=>e.node);
            this.beans.rowRenderer.refreshCells({
                rowNodes: nodes
            });
            this.events = [];
        };
        if (forceSync) func();
        else {
            if (this.dispatchExpandedDebounced == null) this.dispatchExpandedDebounced = this.debounce(func);
            this.dispatchExpandedDebounced();
        }
    }
    // the advantage over normal debounce is the client can call flushAllFrames()
    // to make sure all rendering is complete. we don't wait any milliseconds,
    // as this is intended to batch calls in one VM turn.
    debounce(func) {
        const animationFrameSvc = this.beans.animationFrameSvc;
        if (!animationFrameSvc) return ()=>window.setTimeout(func, 0);
        let pending = false;
        return ()=>{
            if (!animationFrameSvc.active) {
                window.setTimeout(func, 0);
                return;
            }
            if (pending) return;
            pending = true;
            animationFrameSvc.addDestroyTask(()=>{
                pending = false;
                func();
            });
        };
    }
};
function $5b7ccabde48fae90$var$_getFlattenDetails(gos) {
    let groupHideParentOfSingleChild = gos.get("groupHideParentOfSingleChild");
    if (!groupHideParentOfSingleChild) {
        groupHideParentOfSingleChild = gos.get("groupRemoveSingleChildren");
        if (!groupHideParentOfSingleChild && gos.get("groupRemoveLowestSingleChildren")) groupHideParentOfSingleChild = "leafGroupsOnly";
    }
    return {
        groupHideParentOfSingleChild: groupHideParentOfSingleChild,
        isGroupMultiAutoColumn: (0, $jIDNV._isGroupMultiAutoColumn)(gos),
        hideOpenParents: gos.get("groupHideOpenParents"),
        grandTotalRow: (0, $jIDNV._getGrandTotalRow)(gos),
        groupTotalRow: (0, $jIDNV._getGroupTotalRowCallback)(gos)
    };
}
function $5b7ccabde48fae90$var$_isRemovedSingleChildrenGroup(details, rowNode, isParent) {
    return details.groupHideParentOfSingleChild === true && isParent && rowNode.childrenAfterGroup.length === 1;
}
function $5b7ccabde48fae90$var$_isRemovedLowestSingleChildrenGroup(details, rowNode, isParent) {
    return details.groupHideParentOfSingleChild === "leafGroupsOnly" && isParent && rowNode.leafGroup && rowNode.childrenAfterGroup.length === 1;
}
function $5b7ccabde48fae90$var$_shouldRowBeRendered(details, rowNode, isParent, skipLeafNodes, isRemovedSingleChildrenGroup, isRemovedLowestSingleChildrenGroup) {
    const isSkippedLeafNode = skipLeafNodes && !isParent;
    const neverAllowToExpand = skipLeafNodes && rowNode.leafGroup;
    const isHiddenOpenParent = details.hideOpenParents && rowNode.expanded && !rowNode.master && !neverAllowToExpand;
    return !isSkippedLeafNode && !isHiddenOpenParent && !isRemovedSingleChildrenGroup && !isRemovedLowestSingleChildrenGroup;
}
// packages/ag-grid-enterprise/src/rowHierarchy/flattenStage.ts
var $5b7ccabde48fae90$var$FlattenStage = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "flattenStage";
        this.refreshProps = /* @__PURE__ */ new Set([
            "groupHideParentOfSingleChild",
            "groupRemoveSingleChildren",
            "groupRemoveLowestSingleChildren",
            "groupTotalRow",
            "masterDetail"
        ]);
        this.step = "map";
    }
    execute(params) {
        const rootNode = params.rowNode;
        const result = [];
        const skipLeafNodes = this.beans.colModel.isPivotMode();
        const showRootNode = skipLeafNodes && rootNode.leafGroup && rootNode.aggData;
        const topList = showRootNode ? [
            rootNode
        ] : rootNode.childrenAfterSort;
        const details = $5b7ccabde48fae90$var$_getFlattenDetails(this.gos);
        this.recursivelyAddToRowsToDisplay(details, topList, result, skipLeafNodes, 0);
        const atLeastOneRowPresent = result.length > 0;
        const grandTotalRow = details.grandTotalRow;
        const includeGrandTotalRow = !showRootNode && // don't show total footer when showRootNode is true (i.e. in pivot mode and no groups)
        atLeastOneRowPresent && grandTotalRow;
        if (includeGrandTotalRow) {
            $5b7ccabde48fae90$var$_createRowNodeFooter(rootNode, this.beans);
            if (grandTotalRow === "pinnedBottom" || grandTotalRow === "pinnedTop") this.beans.pinnedRowModel?.setGrandTotalPinned(grandTotalRow === "pinnedBottom" ? "bottom" : "top");
            else {
                const addToTop = grandTotalRow === "top";
                this.addRowNodeToRowsToDisplay(details, rootNode.sibling, result, 0, addToTop);
            }
        }
        return result;
    }
    recursivelyAddToRowsToDisplay(details, rowsToFlatten, result, skipLeafNodes, uiLevel) {
        if (!rowsToFlatten?.length) return;
        const masterDetailSvc = this.beans.masterDetailSvc;
        for(let i = 0; i < rowsToFlatten.length; i++){
            const rowNode = rowsToFlatten[i];
            const isParent = rowNode.hasChildren();
            const isRemovedSingleChildrenGroup = $5b7ccabde48fae90$var$_isRemovedSingleChildrenGroup(details, rowNode, isParent);
            const isRemovedLowestSingleChildrenGroup = $5b7ccabde48fae90$var$_isRemovedLowestSingleChildrenGroup(details, rowNode, isParent);
            const thisRowShouldBeRendered = $5b7ccabde48fae90$var$_shouldRowBeRendered(details, rowNode, isParent, skipLeafNodes, isRemovedSingleChildrenGroup, isRemovedLowestSingleChildrenGroup);
            if (thisRowShouldBeRendered) this.addRowNodeToRowsToDisplay(details, rowNode, result, uiLevel);
            if (skipLeafNodes && rowNode.leafGroup) continue;
            if (isParent) {
                const excludedParent = isRemovedSingleChildrenGroup || isRemovedLowestSingleChildrenGroup;
                if (rowNode.expanded || excludedParent) {
                    const doesRowShowFooter = details.groupTotalRow({
                        node: rowNode
                    });
                    if (!doesRowShowFooter) $5b7ccabde48fae90$var$_destroyRowNodeFooter(rowNode);
                    const uiLevelForChildren = excludedParent ? uiLevel : uiLevel + 1;
                    if (doesRowShowFooter === "top") {
                        $5b7ccabde48fae90$var$_createRowNodeFooter(rowNode, this.beans);
                        this.addRowNodeToRowsToDisplay(details, rowNode.sibling, result, uiLevelForChildren);
                    }
                    const detailNode = masterDetailSvc?.getDetail(rowNode);
                    if (detailNode) this.addRowNodeToRowsToDisplay(details, detailNode, result, uiLevel);
                    this.recursivelyAddToRowsToDisplay(details, rowNode.childrenAfterSort, result, skipLeafNodes, uiLevelForChildren);
                    if (doesRowShowFooter === "bottom") {
                        $5b7ccabde48fae90$var$_createRowNodeFooter(rowNode, this.beans);
                        this.addRowNodeToRowsToDisplay(details, rowNode.sibling, result, uiLevelForChildren);
                    }
                }
            } else {
                const detailNode = masterDetailSvc?.getDetail(rowNode);
                if (detailNode) this.addRowNodeToRowsToDisplay(details, detailNode, result, uiLevel);
            }
        }
    }
    // duplicated method, it's also in floatingRowModel
    addRowNodeToRowsToDisplay(details, rowNode, result, uiLevel, addToTop) {
        if (addToTop) result.unshift(rowNode);
        else result.push(rowNode);
        rowNode.setUiLevel(details.isGroupMultiAutoColumn ? 0 : uiLevel);
    }
};
var $5b7ccabde48fae90$var$GroupStage = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "groupStage";
        this.refreshProps = /* @__PURE__ */ new Set([
            "groupDefaultExpanded",
            "groupAllowUnbalanced",
            "initialGroupOrderComparator",
            "groupHideOpenParents",
            "groupDisplayType",
            "treeData",
            "treeDataChildrenField",
            "treeDataParentIdField"
        ]);
        this.step = "group";
        this.approach = null;
        this.strategyBeanName = null;
        this.strategy = void 0;
    }
    /** Gets a filler row by id */ getNode(id) {
        return this.strategy?.getNode(id);
    }
    destroy() {
        super.destroy();
        this.strategy = void 0;
    }
    execute(params) {
        const approach = (0, $jIDNV._getGroupingApproach)(this.gos);
        const approachChanged = this.approach !== approach;
        const strategy = approachChanged ? this.changeApproach(params, approach) : this.strategy;
        if (!strategy) return void 0;
        return strategy.execute(params, approach) || approachChanged;
    }
    getStrategyBeanName(approach) {
        switch(approach){
            case "group":
                return "groupStrategy";
            case "treePath":
            case "treeNested":
            case "treeSelfRef":
                return "treeGroupStrategy";
            default:
                return null;
        }
    }
    changeApproach({ rowNode: rowNode }, approach) {
        this.approach = approach;
        const newBeanName = this.getStrategyBeanName(approach);
        const oldStrategy = this.strategy;
        let strategy = oldStrategy;
        if (this.strategyBeanName !== newBeanName) {
            this.destroyBean(strategy);
            strategy = void 0;
            if (newBeanName) {
                strategy = this.beans.registry.createDynamicBean(newBeanName, false);
                this.createOptionalManagedBean(strategy);
            }
            this.strategy = strategy;
            this.strategyBeanName = newBeanName;
        } else strategy?.reset?.();
        if (oldStrategy) $5b7ccabde48fae90$var$resetGrouping(rowNode, approach !== "treeNested");
        return strategy;
    }
};
var $5b7ccabde48fae90$var$resetGrouping = (rootNode, canResetTreeNode)=>{
    const allLeafChildren = rootNode.allLeafChildren;
    const rootSibling = rootNode.sibling;
    rootNode.treeNodeFlags = 0;
    rootNode.childrenAfterGroup = allLeafChildren;
    rootNode.childrenMapped = null;
    rootNode.groupData = null;
    if (rootSibling) {
        rootSibling.childrenAfterGroup = rootNode.childrenAfterGroup;
        rootSibling.childrenAfterAggFilter = rootNode.childrenAfterAggFilter;
        rootSibling.childrenAfterFilter = rootNode.childrenAfterFilter;
        rootSibling.childrenAfterSort = rootNode.childrenAfterSort;
        rootSibling.childrenMapped = null;
    }
    for (const row of allLeafChildren){
        const sibling = row.sibling;
        $5b7ccabde48fae90$var$resetChildRowGrouping(row);
        if (sibling) $5b7ccabde48fae90$var$resetChildRowGrouping(sibling);
        row.parent = rootNode;
        if (canResetTreeNode) row.treeParent = null;
        if (row.group || row.hasChildren()) {
            row.group = false;
            row.updateHasChildren();
        }
    }
    rootNode.updateHasChildren();
};
var $5b7ccabde48fae90$var$resetChildRowGrouping = (row)=>{
    row.key = null;
    row.treeNodeFlags = 0;
    row.allChildrenCount = null;
    row.allLeafChildren = null;
    row.childrenAfterGroup = null;
    row.childrenAfterAggFilter = null;
    row.childrenAfterFilter = null;
    row.childrenAfterSort = null;
    row.childrenMapped = null;
    row.level = 0;
    if (row.groupData) row.groupData = null;
};
// packages/ag-grid-enterprise/src/rowHierarchy/rowHierarchyUtils.ts
function $5b7ccabde48fae90$var$_isHiddenParent(node, ancestor, gos) {
    let currentNode = node;
    const levelDiff = currentNode.level - ancestor.level;
    if (levelDiff <= 0) return false;
    const isHideOpenParents = gos.get("groupHideOpenParents");
    if (!isHideOpenParents) return false;
    for(let i = 0; i < levelDiff; i++){
        const isFirstChild = currentNode.parent?.getFirstChild() === currentNode;
        if (!isFirstChild) return false;
        currentNode = currentNode.parent;
    }
    return currentNode === ancestor;
}
var $5b7ccabde48fae90$var$_getRowDefaultExpanded = (beans, rowNode, level, group = rowNode.group)=>{
    const gos = beans.gos;
    const isGroupOpenByDefault = group && gos.get("isGroupOpenByDefault");
    if (!isGroupOpenByDefault) {
        const groupDefaultExpanded = gos.get("groupDefaultExpanded");
        return groupDefaultExpanded === -1 || level < groupDefaultExpanded;
    }
    const params = {
        api: beans.gridApi,
        context: beans.gridOptions.context,
        rowNode: rowNode,
        field: rowNode.field,
        key: rowNode.key,
        level: level,
        rowGroupColumn: rowNode.rowGroupColumn
    };
    return isGroupOpenByDefault(params) == true;
};
// packages/ag-grid-enterprise/src/rowHierarchy/rendering/groupCellRendererCtrl.ts
var $5b7ccabde48fae90$var$GroupCellRendererCtrl = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        // keep reference to this, so we can remove again when indent changes
        this.indentClass = null;
    }
    init(comp, eGui, eCheckbox, eExpanded, eContracted, compClass, params) {
        this.params = params;
        this.eGui = eGui;
        this.eCheckbox = eCheckbox;
        this.eExpanded = eExpanded;
        this.eContracted = eContracted;
        this.comp = comp;
        this.compClass = compClass;
        const { node: node, column: column } = params;
        this.node = node;
        this.displayedNode = node;
        const embeddedRowMismatch = this.isEmbeddedRowMismatch();
        if (embeddedRowMismatch) return;
        if (node.footer) {
            this.initFooterCell();
            return;
        }
        if (!column) {
            this.initFullWidthCell();
            return;
        }
        this.displayedNode = this.beans.showRowGroupColValueSvc?.getDisplayedNode(node, column) ?? this.node;
        this.setupExpand();
        this.setupCheckbox();
        this.addGroupValue();
        this.setupIndent();
    }
    initFooterCell() {
        const { node: node } = this.params;
        this.addGroupValue();
        this.setupIndent();
        const isGrandTotal = node.level === -1;
        if (!isGrandTotal) this.comp.toggleCss("ag-row-group-leaf-indent", true);
    }
    initFullWidthCell() {
        const setupDragger = ()=>{
            const { rowDragSvc: rowDragSvc } = this.beans;
            if (!this.params.rowDrag || !rowDragSvc) return;
            const rowDragComp = rowDragSvc.createRowDragComp(()=>this.params.value, this.params.node);
            this.createManagedBean(rowDragComp);
            this.eGui.insertAdjacentElement("afterbegin", rowDragComp.getGui());
        };
        this.setupExpand();
        setupDragger();
        this.setupCheckbox();
        this.addGroupValue();
        this.setupIndent();
    }
    /**
   * Returns an aria "role" to place on full width group cells, or the parent wrapper.
   * @returns the aria role to place on the parent wrapper
   */ getCellAriaRole() {
        const colDefAriaRole = this.params.colDef?.cellAriaRole;
        const columnColDefAriaRole = this.params.column?.getColDef().cellAriaRole;
        return colDefAriaRole || columnColDefAriaRole || "gridcell";
    }
    /**
   * Determines if this cell should be rendered, as when using embeddedFullWidthRows
   * only one group cell should be rendered.
   *
   * if [enableRTL] all but pinned right cells should be skipped if available
   * otherwise prioritise pinned left cell if available
   * otherwise center viewport.
   *
   * @returns whether the cell should be skipped due to embedded full width rows
   */ isEmbeddedRowMismatch() {
        if (!this.params.fullWidth || !this.gos.get("embedFullWidthRows")) return false;
        const { visibleCols: visibleCols } = this.beans;
        const pinnedLeftCell = this.params.pinned === "left";
        const pinnedRightCell = this.params.pinned === "right";
        const bodyCell = !pinnedLeftCell && !pinnedRightCell;
        if (this.gos.get("enableRtl")) {
            if (visibleCols.isPinningLeft()) return !pinnedRightCell;
            return !bodyCell;
        }
        if (visibleCols.isPinningLeft()) return !pinnedLeftCell;
        return !bodyCell;
    }
    /**
   * Displays the group value for the displayed node
   */ addGroupValue() {
        const { params: { value: value, valueFormatted: valueFormatted } } = this;
        const innerCompDetails = this.getInnerCompDetails();
        this.comp.setInnerRenderer(innerCompDetails, valueFormatted ?? value ?? null);
    }
    /**
   * Sets up expand/collapse:
   * Chevron
   * Aria-expanded
   * Child count
   */ setupExpand() {
        const { colModel: colModel } = this.beans;
        const { eGridCell: eGridCell, column: column, suppressDoubleClickExpand: suppressDoubleClickExpand } = this.params;
        const addIconToDom = (iconName, element)=>{
            const icon = (0, $jIDNV._createIconNoSpan)(iconName, this.beans, null);
            if (icon) {
                element.appendChild(icon);
                this.addDestroyFunc(()=>element.removeChild(icon));
            }
        };
        addIconToDom("groupExpanded", this.eExpanded);
        addIconToDom("groupContracted", this.eContracted);
        const comp = this.comp;
        const onExpandedChanged = ()=>{
            const expandable = this.isExpandable();
            if (!expandable) return;
            const expanded = this.displayedNode.expanded;
            comp.setExpandedDisplayed(expanded);
            comp.setContractedDisplayed(!expanded);
            (0, $jIDNV._setAriaExpanded)(eGridCell, !!this.displayedNode.expanded);
        };
        const onExpandableChanged = ()=>{
            const expandable = this.isExpandable();
            comp.toggleCss("ag-cell-expandable", expandable);
            comp.toggleCss("ag-row-group", expandable);
            const pivotModeAndLeaf = !expandable && colModel.isPivotMode();
            comp.toggleCss("ag-pivot-leaf-group", pivotModeAndLeaf);
            const normalModeNotTotalFooter = !colModel.isPivotMode() && (!this.displayedNode.footer || this.displayedNode.level !== -1);
            comp.toggleCss("ag-row-group-leaf-indent", !expandable && normalModeNotTotalFooter);
            const count = this.getChildCount();
            const countString = count > 0 ? `(${count})` : ``;
            comp.setChildCount(countString);
            if (!expandable) {
                comp.setExpandedDisplayed(false);
                comp.setContractedDisplayed(false);
                (0, $jIDNV._removeAriaExpanded)(eGridCell);
            } else onExpandedChanged();
        };
        const setupListeners = ()=>{
            const isDoubleClickEdit = column?.isCellEditable(this.displayedNode) && this.gos.get("enableGroupEdit");
            if (!isDoubleClickEdit && !suppressDoubleClickExpand) this.addManagedListeners(eGridCell, {
                dblclick: this.onCellDblClicked.bind(this)
            });
            this.addManagedListeners(this.eExpanded, {
                click: this.onExpandClicked.bind(this)
            });
            this.addManagedListeners(this.eContracted, {
                click: this.onExpandClicked.bind(this)
            });
            this.addManagedListeners(eGridCell, {
                keydown: this.onKeyDown.bind(this)
            });
            this.addManagedListeners(this.displayedNode, {
                // Expandable state has changed
                allChildrenCountChanged: onExpandableChanged,
                masterChanged: onExpandableChanged,
                groupChanged: onExpandableChanged,
                hasChildrenChanged: onExpandableChanged,
                // Node expanded changed
                expandedChanged: onExpandedChanged
            });
        };
        setupListeners();
        onExpandableChanged();
    }
    /**
   * Return the inner renderer details for the cell
   *
   * Prioritises:
   * 1. Group row renderer for group rows
   * 2. agFindCellRenderer for find results in group rows
   * 3. Provided innerRenderer (i.e, cellRendererParams.innerRenderer)
   * 4. Cell renderer of the grouped column
   * 5. Inner renderer of the grouped column
   * 6. agFindCellRenderer for find results
   */ getInnerCompDetails() {
        const { userCompFactory: userCompFactory, findSvc: findSvc } = this.beans;
        const params = this.params;
        if (params.fullWidth) {
            const groupRowRendererParams = this.gos.get("groupRowRendererParams");
            const groupRowInnerCompDetails = (0, $jIDNV._getInnerCellRendererDetails)(userCompFactory, groupRowRendererParams, params);
            if (groupRowInnerCompDetails) return groupRowInnerCompDetails;
            if (findSvc?.isMatch(params.node, null)) return (0, $jIDNV._getInnerCellRendererDetails)(userCompFactory, {
                ...groupRowRendererParams,
                innerRenderer: "agFindCellRenderer"
            }, params);
            return void 0;
        }
        const isGroupRowRenderer = (details)=>details && details.componentClass == this.compClass;
        const innerCompDetails = (0, $jIDNV._getInnerCellRendererDetails)(userCompFactory, params, params);
        if (innerCompDetails && !isGroupRowRenderer(innerCompDetails)) return innerCompDetails;
        const { displayedNode: { rowGroupColumn: rowGroupColumn } } = this;
        const relatedColDef = rowGroupColumn?.colDef;
        const isShowingThisCol = rowGroupColumn && params.column?.isRowGroupDisplayed(rowGroupColumn.getId());
        if (relatedColDef && isShowingThisCol) {
            const relatedCompDetails = (0, $jIDNV._getCellRendererDetails)(userCompFactory, relatedColDef, params);
            if (relatedCompDetails) {
                if (isGroupRowRenderer(relatedCompDetails)) {
                    if (relatedColDef?.cellRendererParams?.innerRenderer) return (0, $jIDNV._getInnerCellRendererDetails)(userCompFactory, relatedColDef.cellRendererParams, params);
                } else return relatedCompDetails;
            }
        }
        if (findSvc?.isMatch(params.node, params.column)) return (0, $jIDNV._getCellRendererDetails)(userCompFactory, {
            ...relatedColDef ?? params.colDef,
            cellRenderer: "agFindCellRenderer"
        }, params);
    }
    /**
   * Get the allChildCount of a given node
   * @param node the node to return the count for
   * @returns 0 if the count should not be displayed, otherwise the count
   */ getChildCount() {
        const { column: column, suppressCount: suppressCount } = this.params;
        if (suppressCount) return 0;
        const { allChildrenCount: allChildrenCount, rowGroupColumn: rowGroupColumn } = this.displayedNode;
        const isDisplayingRowGroupCell = (allChildrenCount ?? 0) > 0 && (!rowGroupColumn || !column || column?.isRowGroupDisplayed(rowGroupColumn.getId()));
        if (!isDisplayingRowGroupCell) return 0;
        const isRepresentingOtherNode = this.gos.get("showOpenedGroup") && this.displayedNode !== this.node;
        if (isRepresentingOtherNode && !$5b7ccabde48fae90$var$_isHiddenParent(this.node, this.displayedNode, this.gos)) return 0;
        return allChildrenCount ?? 0;
    }
    /**
   * Checks whether the current cell is expandable, either due to [groupHideOpenParent] control or otherwise.
   * @returns whether this cell is expandable
   */ isExpandable() {
        const { node: node, column: column, colDef: colDef } = this.params;
        if (!this.displayedNode.isExpandable()) return false;
        if (node.rowPinned) return false;
        const isFullWidth = !column;
        if (isFullWidth) return true;
        const hasChildren = node.hasChildren();
        if (hasChildren && colDef) {
            const { showRowGroup: showRowGroup } = colDef;
            if (!showRowGroup) return false;
            if (showRowGroup === true) return true;
        }
        if (node === this.displayedNode) {
            if (node.rowGroupColumn) {
                const showingThisRowGroup = column?.isRowGroupDisplayed(node.rowGroupColumn.getId());
                if (showingThisRowGroup) return true;
            }
            if (node.master) return colDef?.showRowGroup === true || colDef?.showRowGroup == null;
            return false;
        }
        return $5b7ccabde48fae90$var$_isHiddenParent(this.node, this.displayedNode, this.gos);
    }
    /**
   * For full width group cells & single group column, indents child groups based on uiLevel
   */ setupIndent() {
        const { suppressPadding: suppressPadding, node: node, colDef: colDef } = this.params;
        if (suppressPadding) return;
        const setIndent = ()=>{
            let level = 0;
            if (colDef && colDef.showRowGroup !== true) level = 0;
            else level = node.uiLevel;
            const newIndentClass = "ag-row-group-indent-" + level;
            if (newIndentClass === this.indentClass) return;
            if (this.indentClass) this.comp.toggleCss(this.indentClass, false);
            this.indentClass = newIndentClass;
            this.comp.toggleCss(newIndentClass, true);
            this.eGui.style.setProperty("--ag-indentation-level", String(level));
        };
        this.addManagedListeners(node, {
            uiLevelChanged: setIndent.bind(this)
        });
        setIndent();
    }
    /**
   * Selection checkboxes
   */ setupCheckbox() {
        const { node: node } = this.params;
        const isRowSelectable = !node.footer && !node.rowPinned && !node.detail;
        if (!isRowSelectable) return;
        this.addManagedPropertyListener("rowSelection", ({ currentValue: currentValue, previousValue: previousValue })=>{
            const curr = typeof currentValue === "object" ? currentValue : void 0;
            const prev = typeof previousValue === "object" ? previousValue : void 0;
            if (curr?.checkboxLocation !== prev?.checkboxLocation) {
                this.destroyCheckbox();
                this.addCheckbox();
            }
        });
        this.addCheckbox();
    }
    addCheckbox() {
        const { selectionSvc: selectionSvc } = this.beans;
        if (!selectionSvc || !(0, $jIDNV._isRowSelection)(this.gos)) return;
        const { node: node, column: column } = this.params;
        const rowSelection = this.gos.get("rowSelection");
        const checkboxLocation = (0, $jIDNV._getCheckboxLocation)(rowSelection);
        if (checkboxLocation === "selectionColumn") return;
        if (checkboxLocation === "autoGroupColumn") {
            const isGroupColumn = column?.getColDef().showRowGroup != null;
            const isFullWidthGroupRow = !column && node.group;
            const isApplicableCell = isGroupColumn || isFullWidthGroupRow;
            if (!isApplicableCell) return;
        }
        const checkboxes = typeof rowSelection === "object" ? (0, $jIDNV._getCheckboxes)(rowSelection) : this.params.checkbox;
        const userWantsCheckboxes = typeof checkboxes === "function" || checkboxes === true;
        if (!userWantsCheckboxes) return;
        const isMultiAutoCol = typeof column?.getColDef().showRowGroup === "string";
        if (isMultiAutoCol && !this.isExpandable()) {
            this.comp.setCheckboxSpacing(true);
            return;
        }
        const cbSelectionComponent = selectionSvc.createCheckboxSelectionComponent();
        this.cbComp = cbSelectionComponent;
        this.createBean(cbSelectionComponent);
        cbSelectionComponent.init({
            rowNode: node,
            column: // when groupHideOpenParents = true and group expanded, we want the checkbox to refer to leaf node state (not group node state)
            column,
            overrides: {
                isVisible: checkboxes,
                callbackParams: this.params,
                removeHidden: true
            }
        });
        this.eCheckbox.appendChild(cbSelectionComponent.getGui());
        this.comp.setCheckboxVisible(true);
    }
    destroyCheckbox() {
        this.comp.setCheckboxSpacing(false);
        this.comp.setCheckboxVisible(false);
        this.cbComp && this.eCheckbox.removeChild(this.cbComp.getGui());
        this.cbComp = this.destroyBean(this.cbComp);
    }
    /**
   * Called when the expand / contract icon is clicked.
   */ onExpandClicked(mouseEvent) {
        if ((0, $jIDNV._isStopPropagationForAgGrid)(mouseEvent)) return;
        (0, $jIDNV._stopPropagationForAgGrid)(mouseEvent);
        this.onExpandOrContract(mouseEvent);
    }
    /**
   * Called on cell key press - only handles 'Enter' key for expand/collapse
   */ onKeyDown(event) {
        const isEnterKey = event.key === (0, $jIDNV.KeyCode).ENTER;
        if (!isEnterKey || this.params.suppressEnterExpand) return;
        const cellEditable = this.params.column && this.params.column.isCellEditable(this.params.node);
        if (cellEditable) return;
        this.onExpandOrContract(event);
    }
    /**
   * Called on cell double click - only expands/collapses if the event is not on the expand / contract icon
   */ onCellDblClicked(mouseEvent) {
        if ((0, $jIDNV._isStopPropagationForAgGrid)(mouseEvent)) return;
        const targetIsExpandIcon = (0, $jIDNV._isElementInEventPath)(this.eExpanded, mouseEvent) || (0, $jIDNV._isElementInEventPath)(this.eContracted, mouseEvent);
        if (!targetIsExpandIcon) this.onExpandOrContract(mouseEvent);
    }
    /**
   * Called when expand or contract is attempted, to scroll the row and update the node state
   * @param e originating event
   */ onExpandOrContract(e) {
        if (!this.isExpandable()) return;
        const rowNode = this.displayedNode;
        const nextExpandState = !rowNode.expanded;
        if (!nextExpandState && rowNode.sticky) this.beans.ctrlsSvc.getScrollFeature().setVerticalScrollPosition(rowNode.rowTop - rowNode.stickyRowTop);
        rowNode.setExpanded(nextExpandState, e);
    }
    destroy() {
        super.destroy();
        this.destroyCheckbox();
    }
};
// packages/ag-grid-enterprise/src/rowHierarchy/rendering/groupCellRenderer.ts
var $5b7ccabde48fae90$var$GroupCellRendererElement = {
    tag: "span",
    cls: "ag-cell-wrapper",
    children: [
        {
            tag: "span",
            ref: "eExpanded",
            cls: "ag-group-expanded ag-hidden"
        },
        {
            tag: "span",
            ref: "eContracted",
            cls: "ag-group-contracted ag-hidden"
        },
        {
            tag: "span",
            ref: "eCheckbox",
            cls: "ag-group-checkbox ag-invisible"
        },
        {
            tag: "span",
            ref: "eValue",
            cls: "ag-group-value"
        },
        {
            tag: "span",
            ref: "eChildCount",
            cls: "ag-group-child-count"
        }
    ]
};
var $5b7ccabde48fae90$var$GroupCellRenderer = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$GroupCellRendererElement);
        this.eExpanded = (0, $jIDNV.RefPlaceholder);
        this.eContracted = (0, $jIDNV.RefPlaceholder);
        this.eCheckbox = (0, $jIDNV.RefPlaceholder);
        this.eValue = (0, $jIDNV.RefPlaceholder);
        this.eChildCount = (0, $jIDNV.RefPlaceholder);
    }
    init(params) {
        const compProxy = {
            setInnerRenderer: (compDetails, valueToDisplay)=>this.setRenderDetails(compDetails, valueToDisplay),
            setChildCount: (count)=>this.eChildCount.textContent = count,
            toggleCss: (cssClass, value)=>this.toggleCss(cssClass, value),
            setContractedDisplayed: (expanded)=>(0, $jIDNV._setDisplayed)(this.eContracted, expanded),
            setExpandedDisplayed: (expanded)=>(0, $jIDNV._setDisplayed)(this.eExpanded, expanded),
            setCheckboxVisible: (visible)=>this.eCheckbox.classList.toggle("ag-invisible", !visible),
            setCheckboxSpacing: (add)=>this.eCheckbox.classList.toggle("ag-group-checkbox-spacing", add)
        };
        const ctrl = this.createManagedBean(new $5b7ccabde48fae90$var$GroupCellRendererCtrl());
        const fullWidth = !params.colDef;
        const eGui = this.getGui();
        ctrl.init(compProxy, eGui, this.eCheckbox, this.eExpanded, this.eContracted, this.constructor, params);
        if (fullWidth) (0, $jIDNV._setAriaRole)(eGui, ctrl.getCellAriaRole());
    }
    setRenderDetails(compDetails, valueToDisplay) {
        if (compDetails) compDetails.newAgStackInstance().then((comp)=>{
            if (!comp) return;
            const destroyComp = ()=>this.destroyBean(comp);
            if (this.isAlive()) {
                this.eValue.appendChild(comp.getGui());
                this.addDestroyFunc(destroyComp);
            } else destroyComp();
        });
        else this.eValue.innerText = valueToDisplay;
    }
    destroy() {
        this.destroyBean(this.innerCellRenderer);
        super.destroy();
    }
    refresh() {
        return false;
    }
};
// packages/ag-grid-enterprise/src/rowHierarchy/rendering/groupCellStyles.css-GENERATED.ts
var $5b7ccabde48fae90$var$groupCellStylesCSS = /*css*/ `.ag-group-checkbox-spacing{width:var(--ag-icon-size)}:where(.ag-ltr) .ag-group-checkbox-spacing{margin-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-group-checkbox-spacing{margin-left:var(--ag-cell-widget-spacing)}`;
var $5b7ccabde48fae90$var$ShowRowGroupColValueService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "showRowGroupColValueSvc";
    }
    /**
   * Get the value for format in the group column, also returns the displayedNode from which the value was
   * taken in cases of groupHideOpenParents and showOpenedGroup.
   */ getGroupValue(node, column) {
        if (!column) {
            if (!node.group) return null;
            return {
                displayedNode: node,
                value: node.groupValue
            };
        }
        const valueSvc = this.beans.valueSvc;
        const rowGroupColId = column.colDef.showRowGroup;
        if (!rowGroupColId) return null;
        if (node.level === -1 && node.footer) return {
            displayedNode: node,
            value: null
        };
        if (typeof rowGroupColId === "string") {
            const colRowGroupIndex = this.beans.rowGroupColsSvc?.getColumnIndex(rowGroupColId) ?? -1;
            if (colRowGroupIndex > node.level) return null;
            const hideOpenParentsNode = this.getDisplayedNode(node, column, true);
            if (hideOpenParentsNode) return {
                displayedNode: hideOpenParentsNode,
                value: valueSvc.getValue(column, hideOpenParentsNode)
            };
        }
        const value = valueSvc.getValue(column, node);
        if (value == null) {
            const displayedNode = this.getDisplayedNode(node, column);
            if (displayedNode) return {
                displayedNode: displayedNode,
                value: valueSvc.getValue(column, displayedNode)
            };
        }
        return {
            displayedNode: node,
            value: value
        };
    }
    /**
   * Formats a group col value, and prefixes it with the "Total" prefix if applicable
   */ formatAndPrefixGroupColValue(groupValue, column, exporting = false) {
        const formattedValue = this.formatGroupColValue(groupValue, column, exporting);
        const { value: value, displayedNode: displayedNode } = groupValue;
        const footerSvc = this.beans.footerSvc;
        if (footerSvc?.doesCellShowTotalPrefix(displayedNode, column)) {
            const footerValue = footerSvc.applyTotalPrefix(value, formattedValue, displayedNode, column);
            return footerValue;
        }
        if (displayedNode.footer && displayedNode.level === -1) return null;
        return formattedValue;
    }
    /**
   * Formats the group col value using the underlying column's value formatter
   */ formatGroupColValue(groupValue, column, exporting = false) {
        const valueSvc = this.beans.valueSvc;
        const { displayedNode: displayedNode, value: value } = groupValue;
        const groupedCol = displayedNode.rowGroupColumn;
        const isFullWidthGroup = displayedNode.group && !column;
        const isShowingGroupCell = groupedCol && (isFullWidthGroup || column?.isRowGroupDisplayed(groupedCol.colId));
        if (isShowingGroupCell) {
            if (exporting && groupedCol.colDef.useValueFormatterForExport === false) return null;
            const formattedValue = valueSvc.formatValue(groupedCol, displayedNode, value);
            if (formattedValue == null && displayedNode.key === "") {
                const localeTextFunc = this.getLocaleTextFunc();
                return localeTextFunc("blanks", "(Blanks)");
            }
            return formattedValue;
        }
        if (!column || displayedNode.group) return null;
        if (exporting && column.colDef.useValueFormatterForExport === false) return null;
        return valueSvc.formatValue(column, displayedNode, value);
    }
    /**
   * Checks if the node has a value to inherit from the parent node for display in the given column
   *
   * This is used when [groupHideOpenParents] or [showOpenedGroup] are enabled
   *
   * @param node node to check for preferential nodes to display
   * @param column column to get the displayed node for
   * @returns a parent node of node to display the value from, or undefined if no value will be inherited
   */ getDisplayedNode(node, column, onlyHideOpenParents = false) {
        const gos = this.gos;
        const isGroupHideOpenParents = gos.get("groupHideOpenParents");
        const isShowOpenedGroupValue = gos.get("showOpenedGroup") && !onlyHideOpenParents;
        if (!isGroupHideOpenParents && !isShowOpenedGroupValue) return void 0;
        const showRowGroup = column.colDef.showRowGroup;
        if (showRowGroup === true) {
            if (node.group) return void 0;
            return node.parent ?? void 0;
        }
        let pointer = node;
        while(pointer && pointer.rowGroupColumn?.getId() != showRowGroup){
            const isFirstChild = pointer === pointer.parent?.getFirstChild();
            if (!isShowOpenedGroupValue && !isFirstChild) return void 0;
            pointer = pointer.parent;
        }
        if (pointer === node) return void 0;
        return pointer ?? void 0;
    }
};
var $5b7ccabde48fae90$var$ShowRowGroupColsService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "showRowGroupCols";
    }
    refresh() {
        this.showRowGroupCols = [];
        this.showRowGroupColsMap = {};
        const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc } = this.beans;
        colModel.getCols().forEach((col)=>{
            const colDef = col.getColDef();
            const showRowGroup = colDef.showRowGroup;
            const isString2 = typeof showRowGroup === "string";
            const isTrue = showRowGroup === true;
            if (!isString2 && !isTrue) return;
            this.showRowGroupCols.push(col);
            if (isString2) this.showRowGroupColsMap[showRowGroup] = col;
            else if (rowGroupColsSvc) rowGroupColsSvc.columns.forEach((rowGroupCol)=>{
                this.showRowGroupColsMap[rowGroupCol.getId()] = col;
            });
        });
    }
    getShowRowGroupCols() {
        return this.showRowGroupCols;
    }
    getShowRowGroupCol(id) {
        return this.showRowGroupColsMap[id];
    }
    getSourceColumnsForGroupColumn(groupCol) {
        const sourceColumnId = groupCol.getColDef().showRowGroup;
        if (!sourceColumnId) return null;
        const { rowGroupColsSvc: rowGroupColsSvc, colModel: colModel } = this.beans;
        if (sourceColumnId === true && rowGroupColsSvc) return rowGroupColsSvc.columns.slice(0);
        const column = colModel.getColDefCol(sourceColumnId);
        return column ? [
            column
        ] : null;
    }
    isRowGroupDisplayed(column, colId) {
        const { colDef: colDef } = column;
        if (colDef?.showRowGroup == null) return false;
        const showingAllGroups = colDef.showRowGroup === true;
        const showingThisGroup = colDef.showRowGroup === colId;
        return showingAllGroups || showingThisGroup;
    }
};
var $5b7ccabde48fae90$var$StickyRowFeature = class extends (0, $jIDNV.BeanStub) {
    constructor(createRowCon, destroyRowCtrls){
        super();
        this.createRowCon = createRowCon;
        this.destroyRowCtrls = destroyRowCtrls;
        this.stickyTopRowCtrls = [];
        this.stickyBottomRowCtrls = [];
        // sticky rows pulls in extra rows from other pages which impacts row position
        this.extraTopHeight = 0;
        this.extraBottomHeight = 0;
    }
    postConstruct() {
        this.isClientSide = (0, $jIDNV._isClientSideRowModel)(this.gos);
        this.beans.ctrlsSvc.whenReady(this, (params)=>{
            this.gridBodyCtrl = params.gridBodyCtrl;
        });
        this.resetStickyContainers();
    }
    setOffsetTop(offset) {
        if (this.extraTopHeight === offset) return;
        this.extraTopHeight = offset;
        this.eventSvc.dispatchEvent({
            type: "stickyTopOffsetChanged",
            offset: offset
        });
    }
    setOffsetBottom(offset) {
        if (this.extraBottomHeight === offset) return;
        this.extraBottomHeight = offset;
    }
    resetOffsets() {
        this.setOffsetBottom(0);
        this.setOffsetTop(0);
    }
    /**
   * Get the last pixel of the group, this pixel is used to push the sticky node up out of the viewport.
   */ getLastPixelOfGroup(row) {
        return this.isClientSide ? $5b7ccabde48fae90$var$getClientSideLastPixelOfGroup(row) : $5b7ccabde48fae90$var$getServerSideLastPixelOfGroup(row);
    }
    /**
   * Get the first pixel of the group, this pixel is used to push the sticky node down out of the viewport
   */ getFirstPixelOfGroup(row) {
        if (row.footer) return row.sibling.rowTop + row.sibling.rowHeight - 1;
        if (row.hasChildren()) return row.rowTop - 1;
        return 0;
    }
    updateStickyRows(container) {
        const isTop = container === "top";
        let newStickyContainerHeight = 0;
        if (!this.canRowsBeSticky()) return this.refreshNodesAndContainerHeight(container, /* @__PURE__ */ new Set(), newStickyContainerHeight);
        const { rowModel: rowModel, rowRenderer: rowRenderer, pinnedRowModel: pinnedRowModel } = this.beans;
        const pixelAtContainerBoundary = isTop ? rowRenderer.firstVisibleVPixel - this.extraTopHeight : rowRenderer.lastVisibleVPixel - this.extraTopHeight;
        const newStickyRows = /* @__PURE__ */ new Set();
        const addStickyRow = (stickyRow)=>{
            newStickyRows.add(stickyRow);
            if (isTop) {
                const lastChildBottom = this.getLastPixelOfGroup(stickyRow);
                const stickRowBottom = pixelAtContainerBoundary + newStickyContainerHeight + stickyRow.rowHeight;
                if (lastChildBottom < stickRowBottom) stickyRow.stickyRowTop = newStickyContainerHeight + (lastChildBottom - stickRowBottom);
                else stickyRow.stickyRowTop = newStickyContainerHeight;
            } else {
                const lastChildBottom = this.getFirstPixelOfGroup(stickyRow);
                const stickRowTop = pixelAtContainerBoundary - (newStickyContainerHeight + stickyRow.rowHeight);
                if (lastChildBottom > stickRowTop) stickyRow.stickyRowTop = newStickyContainerHeight - (lastChildBottom - stickRowTop);
                else stickyRow.stickyRowTop = newStickyContainerHeight;
            }
            newStickyContainerHeight = 0;
            newStickyRows.forEach((rowNode)=>{
                const thisRowLastPx = rowNode.stickyRowTop + rowNode.rowHeight;
                if (newStickyContainerHeight < thisRowLastPx) newStickyContainerHeight = thisRowLastPx;
            });
        };
        const suppressFootersSticky = this.areFooterRowsStickySuppressed();
        const suppressGroupsSticky = this.gos.get("suppressGroupRowsSticky");
        const isRowSticky = (row)=>{
            if (!row.displayed) return false;
            if (row.footer) {
                if (suppressFootersSticky === true) return false;
                if (suppressFootersSticky === "grand" && row.level === -1) return false;
                if (suppressFootersSticky === "group" && row.level > -1) return false;
                const isFooterFirstRowInGroup = row.sibling.rowIndex ? row.sibling.rowIndex + 1 === row.rowIndex : false;
                if (container === "bottom" && isFooterFirstRowInGroup) return false;
                if (row.level === -1 && pinnedRowModel?.getGrandTotalPinned()) return false;
                const alreadySticking = newStickyRows.has(row);
                return !alreadySticking;
            }
            if (row.isExpandable()) {
                if (suppressGroupsSticky === true) return false;
                if (container === "bottom") return false;
                const alreadySticking = newStickyRows.has(row);
                return !alreadySticking && row.expanded;
            }
            return false;
        };
        for(let i = 0; i < 100; i++){
            let firstPixelAfterStickyRows = pixelAtContainerBoundary + newStickyContainerHeight;
            if (!isTop) firstPixelAfterStickyRows = pixelAtContainerBoundary - newStickyContainerHeight;
            const firstIndex = rowModel.getRowIndexAtPixel(firstPixelAfterStickyRows);
            const firstRow = rowModel.getRow(firstIndex);
            if (firstRow == null) break;
            const ancestors = this.getStickyAncestors(firstRow);
            const firstMissingParent = ancestors.find((parent)=>(isTop ? parent.rowIndex < firstIndex : parent.rowIndex > firstIndex) && isRowSticky(parent));
            if (firstMissingParent) {
                addStickyRow(firstMissingParent);
                continue;
            }
            const isFirstRowOutsideViewport = isTop ? firstRow.rowTop < firstPixelAfterStickyRows : firstRow.rowTop + firstRow.rowHeight > firstPixelAfterStickyRows;
            if (isFirstRowOutsideViewport && isRowSticky(firstRow)) {
                addStickyRow(firstRow);
                continue;
            }
            break;
        }
        if (!isTop) newStickyRows.forEach((rowNode)=>{
            rowNode.stickyRowTop = newStickyContainerHeight - (rowNode.stickyRowTop + rowNode.rowHeight);
        });
        return this.refreshNodesAndContainerHeight(container, newStickyRows, newStickyContainerHeight);
    }
    areFooterRowsStickySuppressed() {
        const suppressFootersSticky = this.gos.get("suppressStickyTotalRow");
        if (suppressFootersSticky === true) return true;
        const suppressGroupRows = suppressFootersSticky === "group";
        const suppressGrandRows = suppressFootersSticky === "grand";
        if (suppressGroupRows && suppressGrandRows) return true;
        if (suppressGrandRows) return "grand";
        if (suppressGroupRows) return "group";
        return false;
    }
    canRowsBeSticky() {
        const isStickyEnabled = (0, $jIDNV._isGroupRowsSticky)(this.gos);
        const suppressFootersSticky = this.areFooterRowsStickySuppressed();
        const suppressGroupsSticky = this.gos.get("suppressGroupRowsSticky");
        return isStickyEnabled && (!suppressFootersSticky || !suppressGroupsSticky);
    }
    getStickyAncestors(rowNode) {
        const ancestors = [];
        let p = rowNode.footer ? rowNode.sibling : rowNode.parent;
        while(p){
            if (p.sibling) ancestors.push(p.sibling);
            ancestors.push(p);
            p = p.parent;
        }
        return ancestors.reverse();
    }
    checkStickyRows() {
        const hasTopUpdated = this.updateStickyRows("top");
        const hasBottomUpdated = this.updateStickyRows("bottom");
        return hasTopUpdated || hasBottomUpdated;
    }
    destroyStickyCtrls() {
        this.resetStickyContainers();
    }
    resetStickyContainers() {
        this.refreshNodesAndContainerHeight("top", /* @__PURE__ */ new Set(), 0);
        this.refreshNodesAndContainerHeight("bottom", /* @__PURE__ */ new Set(), 0);
    }
    refreshStickyNode(stickRowNode) {
        const allStickyNodes = /* @__PURE__ */ new Set();
        if (this.stickyTopRowCtrls.some((ctrl)=>ctrl.rowNode === stickRowNode)) {
            for(let i = 0; i < this.stickyTopRowCtrls.length; i++){
                const currentNode = this.stickyTopRowCtrls[i].rowNode;
                if (currentNode !== stickRowNode) allStickyNodes.add(currentNode);
            }
            if (this.refreshNodesAndContainerHeight("top", allStickyNodes, this.topContainerHeight)) this.checkStickyRows();
            return;
        }
        for(let i = 0; i < this.stickyBottomRowCtrls.length; i++){
            const currentNode = this.stickyBottomRowCtrls[i].rowNode;
            if (currentNode !== stickRowNode) allStickyNodes.add(currentNode);
        }
        if (this.refreshNodesAndContainerHeight("bottom", allStickyNodes, this.bottomContainerHeight)) this.checkStickyRows();
    }
    /**
   * Destroy old ctrls and create new ctrls where necessary.
   */ refreshNodesAndContainerHeight(container, newStickyNodes, height) {
        const isTop = container === "top";
        const previousCtrls = isTop ? this.stickyTopRowCtrls : this.stickyBottomRowCtrls;
        const removedCtrlsMap = {};
        const remainingCtrls = [];
        for(let i = 0; i < previousCtrls.length; i++){
            const node = previousCtrls[i].rowNode;
            const hasBeenRemoved = !newStickyNodes.has(node);
            if (hasBeenRemoved) {
                removedCtrlsMap[node.id] = previousCtrls[i];
                node.sticky = false;
                continue;
            }
            remainingCtrls.push(previousCtrls[i]);
        }
        const existingNodes = /* @__PURE__ */ new Set();
        for(let i = 0; i < remainingCtrls.length; i++)existingNodes.add(remainingCtrls[i].rowNode);
        const newCtrls = [];
        newStickyNodes.forEach((node)=>{
            if (existingNodes.has(node)) return;
            node.sticky = true;
            newCtrls.push(this.createRowCon(node, false, false));
        });
        let hasSomethingChanged = !!newCtrls.length || remainingCtrls.length !== previousCtrls.length;
        if (isTop) {
            if (this.topContainerHeight !== height) {
                this.topContainerHeight = height;
                this.gridBodyCtrl.setStickyTopHeight(height);
                hasSomethingChanged = true;
            }
        } else if (this.bottomContainerHeight !== height) {
            this.bottomContainerHeight = height;
            this.gridBodyCtrl.setStickyBottomHeight(height);
            hasSomethingChanged = true;
        }
        this.destroyRowCtrls(removedCtrlsMap, false);
        const newCtrlsList = [
            ...remainingCtrls,
            ...newCtrls
        ];
        newCtrlsList.sort((a, b)=>b.rowNode.rowIndex - a.rowNode.rowIndex);
        if (!isTop) newCtrlsList.reverse();
        newCtrlsList.forEach((ctrl)=>ctrl.setRowTop(ctrl.rowNode.stickyRowTop));
        const pageBounds = this.beans.pageBounds;
        let extraHeight = 0;
        if (isTop) {
            newStickyNodes.forEach((node)=>{
                if (node.rowIndex < pageBounds.getFirstRow()) extraHeight += node.rowHeight;
            });
            if (extraHeight > this.topContainerHeight) extraHeight = this.topContainerHeight;
            this.setOffsetTop(extraHeight);
        } else {
            newStickyNodes.forEach((node)=>{
                if (node.rowIndex > pageBounds.getLastRow()) extraHeight += node.rowHeight;
            });
            if (extraHeight > this.bottomContainerHeight) extraHeight = this.bottomContainerHeight;
            this.setOffsetBottom(extraHeight);
        }
        if (!hasSomethingChanged) return false;
        if (isTop) this.stickyTopRowCtrls = newCtrlsList;
        else this.stickyBottomRowCtrls = newCtrlsList;
        return true;
    }
    ensureRowHeightsValid() {
        let anyChange = false;
        const updateRowHeight = (ctrl)=>{
            const rowNode = ctrl.rowNode;
            if (rowNode.rowHeightEstimated) {
                const rowHeight = (0, $jIDNV._getRowHeightForNode)(this.beans, rowNode);
                rowNode.setRowHeight(rowHeight.height);
                anyChange = true;
            }
        };
        this.stickyTopRowCtrls.forEach(updateRowHeight);
        this.stickyBottomRowCtrls.forEach(updateRowHeight);
        return anyChange;
    }
};
function $5b7ccabde48fae90$var$getServerSideLastPixelOfGroup(row) {
    if (row.isExpandable() || row.footer) {
        if (row.master && row.detailNode) return row.detailNode.rowTop + row.detailNode.rowHeight;
        const noOrContiguousSiblings = !row.sibling || Math.abs(row.sibling.rowIndex - row.rowIndex) === 1;
        if (noOrContiguousSiblings) {
            let storeBounds = row.childStore?.getStoreBounds();
            if (row.footer) storeBounds = row.sibling.childStore?.getStoreBounds();
            return (storeBounds?.heightPx ?? 0) + (storeBounds?.topPx ?? 0);
        }
        if (row.footer) return row.rowTop + row.rowHeight;
        return row.sibling.rowTop + row.sibling.rowHeight;
    }
    return Number.MAX_SAFE_INTEGER;
}
function $5b7ccabde48fae90$var$getClientSideLastPixelOfGroup(row) {
    if (row.isExpandable() || row.footer) {
        const grandTotalAtTop = row.footer && row.rowIndex === 0;
        if (grandTotalAtTop) return Number.MAX_SAFE_INTEGER;
        const noOrContiguousSiblings = !row.sibling || Math.abs(row.sibling.rowIndex - row.rowIndex) === 1;
        if (noOrContiguousSiblings) {
            let lastAncestor = row.footer ? row.sibling : row;
            while(lastAncestor.isExpandable() && lastAncestor.expanded){
                if (lastAncestor.master && lastAncestor.detailNode) lastAncestor = lastAncestor.detailNode;
                else if (lastAncestor.childrenAfterSort) {
                    if (lastAncestor.childrenAfterSort.length === 0) break;
                    lastAncestor = (0, $jIDNV._last)(lastAncestor.childrenAfterSort);
                }
            }
            return lastAncestor.rowTop + lastAncestor.rowHeight;
        }
        if (row.footer) return row.rowTop + row.rowHeight;
        return row.sibling.rowTop + row.sibling.rowHeight;
    }
    return Number.MAX_SAFE_INTEGER;
}
// packages/ag-grid-enterprise/src/rowHierarchy/stickyRowService.ts
var $5b7ccabde48fae90$var$StickyRowService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "stickyRowSvc";
    }
    createStickyRowFeature(ctrl, createRowCon, destroyRowCtrls) {
        const gos = this.gos;
        if ((0, $jIDNV._isGroupRowsSticky)(gos) && (0, $jIDNV._isClientSideRowModel)(gos) || (0, $jIDNV._isServerSideRowModel)(gos)) return ctrl.createManagedBean(new $5b7ccabde48fae90$var$StickyRowFeature(createRowCon, destroyRowCtrls));
        return void 0;
    }
};
// packages/ag-grid-enterprise/src/rowHierarchy/rowHierarchyModule.ts
var $5b7ccabde48fae90$var$GroupCellRendererModule = {
    moduleName: "GroupCellRenderer",
    version: $5b7ccabde48fae90$var$VERSION,
    userComponents: {
        agGroupRowRenderer: $5b7ccabde48fae90$var$GroupCellRenderer,
        agGroupCellRenderer: $5b7ccabde48fae90$var$GroupCellRenderer
    },
    dynamicBeans: {
        groupCellRendererCtrl: $5b7ccabde48fae90$var$GroupCellRendererCtrl
    },
    icons: {
        // shown on row group when contracted (click to expand)
        groupContracted: "tree-closed",
        // shown on row group when expanded (click to contract)
        groupExpanded: "tree-open"
    },
    css: [
        $5b7ccabde48fae90$var$groupCellStylesCSS
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule
    ]
};
var $5b7ccabde48fae90$var$GroupColumnModule = {
    moduleName: "GroupColumn",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$AutoColService,
        $5b7ccabde48fae90$var$ShowRowGroupColsService,
        $5b7ccabde48fae90$var$ShowRowGroupColValueService,
        $5b7ccabde48fae90$var$RowGroupColsSvc,
        $5b7ccabde48fae90$var$PivotColsSvc,
        $5b7ccabde48fae90$var$ValueColsSvc
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        $5b7ccabde48fae90$var$GroupCellRendererModule
    ]
};
var $5b7ccabde48fae90$var$ClientSideRowModelHierarchyModule = {
    moduleName: "ClientSideRowModelHierarchy",
    version: $5b7ccabde48fae90$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $5b7ccabde48fae90$var$GroupStage,
        $5b7ccabde48fae90$var$FlattenStage,
        $5b7ccabde48fae90$var$ClientSideExpansionService
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule
    ]
};
var $5b7ccabde48fae90$var$StickyRowModule = {
    moduleName: "StickyRow",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$StickyRowService
    ]
};
var $5b7ccabde48fae90$var$AgGridHeaderDropZones = class extends (0, $jIDNV.Component) {
    constructor(){
        super();
    }
    postConstruct() {
        this.setGui(this.createNorthPanel());
        const onRowGroupChanged = this.onRowGroupChanged.bind(this);
        this.addManagedEventListeners({
            columnRowGroupChanged: onRowGroupChanged,
            newColumnsLoaded: onRowGroupChanged
        });
        this.addManagedPropertyListener("rowGroupPanelShow", onRowGroupChanged);
        this.addManagedPropertyListener("pivotPanelShow", ()=>this.onPivotPanelShow());
        this.onRowGroupChanged();
    }
    createNorthPanel() {
        const topPanelGui = (0, $jIDNV._createElement)({
            tag: "div",
            cls: "ag-column-drop-wrapper",
            role: "presentation"
        });
        const rowGroupComp = new $5b7ccabde48fae90$var$RowGroupDropZonePanel(true);
        this.rowGroupComp = this.createManagedBean(rowGroupComp);
        const pivotComp = new $5b7ccabde48fae90$var$PivotDropZonePanel(true);
        this.pivotComp = this.createManagedBean(pivotComp);
        topPanelGui.appendChild(rowGroupComp.getGui());
        topPanelGui.appendChild(pivotComp.getGui());
        const listener = this.onDropPanelVisible.bind(this);
        this.addManagedListeners(rowGroupComp, {
            displayChanged: listener
        });
        this.addManagedListeners(pivotComp, {
            displayChanged: listener
        });
        this.onDropPanelVisible();
        return topPanelGui;
    }
    onDropPanelVisible() {
        const { rowGroupComp: rowGroupComp, pivotComp: pivotComp } = this;
        const bothDisplayed = rowGroupComp.isDisplayed() && pivotComp.isDisplayed();
        const classStr = "ag-column-drop-horizontal-half-width";
        rowGroupComp.toggleCss(classStr, bothDisplayed);
        pivotComp.toggleCss(classStr, bothDisplayed);
    }
    onRowGroupChanged() {
        const rowGroupComp = this.rowGroupComp;
        if (!rowGroupComp) return;
        const rowGroupPanelShow = this.gos.get("rowGroupPanelShow");
        if (rowGroupPanelShow === "always") rowGroupComp.setDisplayed(true);
        else if (rowGroupPanelShow === "onlyWhenGrouping") {
            const grouping = this.beans.rowGroupColsSvc?.columns?.length !== 0;
            rowGroupComp.setDisplayed(grouping);
        } else rowGroupComp.setDisplayed(false);
    }
    onPivotPanelShow() {
        const pivotComp = this.pivotComp;
        if (!pivotComp) return;
        const pivotPanelShow = this.gos.get("pivotPanelShow");
        if (pivotPanelShow === "always") pivotComp.setDisplayed(true);
        else if (pivotPanelShow === "onlyWhenPivoting") {
            const pivoting = this.beans.colModel.isPivotActive();
            pivotComp.setDisplayed(pivoting);
        } else pivotComp.setDisplayed(false);
    }
};
var $5b7ccabde48fae90$var$AgGridHeaderDropZonesSelector = {
    selector: "AG-GRID-HEADER-DROP-ZONES",
    component: $5b7ccabde48fae90$var$AgGridHeaderDropZones
};
var $5b7ccabde48fae90$var$GroupFilterElement = {
    tag: "div",
    cls: "ag-group-filter",
    children: [
        {
            tag: "div",
            ref: "eGroupField"
        },
        {
            tag: "div",
            ref: "eUnderlyingFilter"
        }
    ]
};
var $5b7ccabde48fae90$var$GroupFilter = class extends (0, $jIDNV.TabGuardComp) {
    constructor(){
        super($5b7ccabde48fae90$var$GroupFilterElement);
        this.filterType = "group";
        this.eGroupField = (0, $jIDNV.RefPlaceholder);
        this.eUnderlyingFilter = (0, $jIDNV.RefPlaceholder);
    }
    wireBeans(beans) {
        this.groupFilterSvc = beans.groupFilter;
    }
    postConstruct() {
        this.initialiseTabGuard({});
    }
    init(legacyParams) {
        this.params = legacyParams;
        return this.updateParams().then(()=>{
            this.addHandlerListeners(this.updateGroups.bind(this));
        });
    }
    refresh(legacyParams) {
        const params = legacyParams;
        this.params = params;
        if (params.source === "colDef") this.updateParams();
        return true;
    }
    updateParams() {
        this.validateParams();
        return this.updateGroups();
    }
    validateParams() {
        const { colDef: colDef } = this.params;
        if (colDef.field) (0, $jIDNV._warn)(234);
        if (colDef.filterValueGetter) (0, $jIDNV._warn)(235);
        if (colDef.filterParams) (0, $jIDNV._warn)(236);
    }
    addHandlerListeners(listener) {
        const destroyFunctions = this.addManagedListeners(this.getHandler(), {
            sourceColumnsChanged: ()=>{
                this.updateGroups();
            },
            destroyed: ()=>{
                destroyFunctions.forEach((func)=>func());
                this.addHandlerListeners(listener);
            }
        });
    }
    updateGroups() {
        const { sourceColumns: sourceColumns, selectedColumn: selectedColumn } = this.updateGroupField();
        this.dispatchLocalEvent({
            type: "columnsChanged"
        });
        return this.getUnderlyingFilters(sourceColumns, selectedColumn);
    }
    updateGroupField() {
        this.groupColumn = this.params.column;
        const handler = this.getHandler();
        if (!handler) return {
            sourceColumns: null
        };
        const { sourceColumns: sourceColumns, hasMultipleColumns: hasMultipleColumns, selectedColumn: selectedColumn } = handler;
        const eGroupField = this.eGroupField;
        (0, $jIDNV._clearElement)(eGroupField);
        if (this.eGroupFieldSelect) this.destroyBean(this.eGroupFieldSelect);
        if (hasMultipleColumns && sourceColumns) {
            this.createGroupFieldSelectElement(sourceColumns, selectedColumn);
            eGroupField.appendChild(this.eGroupFieldSelect.getGui());
            eGroupField.appendChild((0, $jIDNV._createElement)({
                tag: "div",
                cls: "ag-filter-separator"
            }));
        }
        (0, $jIDNV._setDisplayed)(eGroupField, hasMultipleColumns);
        return {
            sourceColumns: sourceColumns,
            selectedColumn: selectedColumn
        };
    }
    createGroupFieldSelectElement(sourceColumns, selectedColumn) {
        const eGroupFieldSelect = this.createManagedBean(new (0, $jIDNV.AgSelect)());
        this.eGroupFieldSelect = eGroupFieldSelect;
        const localeTextFunc = this.getLocaleTextFunc();
        eGroupFieldSelect.setLabel(localeTextFunc("groupFilterSelect", "Select field:"));
        eGroupFieldSelect.setLabelAlignment("top");
        eGroupFieldSelect.addOptions(sourceColumns.map((sourceColumn)=>({
                value: sourceColumn.getColId(),
                text: this.beans.colNames.getDisplayNameForColumn(sourceColumn, "groupFilter", false) ?? void 0
            })));
        eGroupFieldSelect.setValue(selectedColumn.getColId());
        eGroupFieldSelect.onValueChange((newValue)=>this.updateSelectedColumn(newValue));
        eGroupFieldSelect.addCss("ag-group-filter-field-select-wrapper");
        if (sourceColumns.length === 1) eGroupFieldSelect.setDisabled(true);
    }
    getUnderlyingFilters(sourceColumns, selectedColumn) {
        if (!sourceColumns) {
            this.filterColumnPairs = void 0;
            this.selectedFilter = void 0;
            return (0, $jIDNV.AgPromise).resolve();
        }
        const filterPromises = [];
        const filterColumnPairs = [];
        const colFilter = this.beans.colFilter;
        sourceColumns.forEach((column)=>{
            const filterPromise = colFilter.getOrCreateFilterUi(column);
            if (filterPromise) filterPromises.push(filterPromise.then((filter)=>{
                if (filter) filterColumnPairs.push({
                    filter: filter,
                    column: column
                });
                if (column.getColId() === selectedColumn.getColId()) this.selectedFilter = filter ?? void 0;
            }));
        });
        return (0, $jIDNV.AgPromise).all(filterPromises).then(()=>{
            this.filterColumnPairs = filterColumnPairs;
        });
    }
    addUnderlyingFilterElement(selectedColumn) {
        (0, $jIDNV._clearElement)(this.eUnderlyingFilter);
        if (!selectedColumn) return (0, $jIDNV.AgPromise).resolve();
        const comp = this.createManagedBean(new (0, $jIDNV.FilterComp)(selectedColumn, "COLUMN_MENU"));
        this.filterComp = comp;
        if (!comp.hasFilter()) return (0, $jIDNV.AgPromise).resolve();
        this.eUnderlyingFilter.appendChild(comp.getGui());
        return comp.getFilter()?.then(()=>{
            comp.afterGuiAttached?.(this.afterGuiAttachedParams);
            if (!this.afterGuiAttachedParams?.suppressFocus && this.eGroupFieldSelect && !this.eGroupFieldSelect.isDisabled()) this.eGroupFieldSelect.getFocusableElement().focus();
        }) ?? (0, $jIDNV.AgPromise).resolve();
    }
    updateSelectedColumn(columnId) {
        if (!columnId) return;
        this.filterComp?.afterGuiDetached();
        this.destroyBean(this.filterComp);
        const selectedFilterColumnPair = this.getFilterColumnPair(columnId);
        const selectedColumn = selectedFilterColumnPair?.column;
        this.selectedFilter = selectedFilterColumnPair?.filter;
        this.getHandler().setSelectedColumn(selectedColumn);
        this.dispatchLocalEvent({
            type: "columnsChanged"
        });
        this.addUnderlyingFilterElement(selectedColumn);
    }
    isFilterActive() {
        return this.groupFilterSvc.isFilterActive(this.groupColumn);
    }
    doesFilterPass() {
        return true;
    }
    getModel() {
        return null;
    }
    setModel() {}
    afterGuiAttached(params) {
        this.afterGuiAttachedParams = params;
        this.addUnderlyingFilterElement(this.getHandler().selectedColumn);
    }
    afterGuiDetached() {
        (0, $jIDNV._clearElement)(this.eUnderlyingFilter);
        this.selectedFilter?.afterGuiDetached?.();
    }
    getSelectedColumn() {
        return this.getHandler().selectedColumn;
    }
    getHandler() {
        return this.params.getHandler();
    }
    getFilterColumnPair(columnId) {
        if (!columnId) return void 0;
        return this.filterColumnPairs?.find(({ column: column })=>column.getColId() === columnId);
    }
};
var $5b7ccabde48fae90$var$GroupFilterHandler = class extends (0, $jIDNV.BeanStub) {
    init(params) {
        this.params = params;
        this.validateModel(params);
        this.updateColumns();
        this.addManagedEventListeners({
            columnRowGroupChanged: this.updateColumns.bind(this),
            filterDestroyed: (event)=>this.onFilterDestroyed(event)
        });
    }
    refresh(params) {
        this.params = params;
        this.validateModel(params);
        if (params.source === "colDef") this.updateColumns();
    }
    doesFilterPass() {
        return true;
    }
    setSelectedColumn(selectedColumn) {
        this.selectedColumn = selectedColumn;
        this.dispatchLocalEvent({
            type: "selectedColumnChanged"
        });
    }
    validateModel(params) {
        if (params.model != null) params.onModelChange(null);
    }
    getSourceColumns() {
        const groupColumn = this.params.column;
        if (this.gos.get("treeData")) {
            (0, $jIDNV._warn)(237);
            return [];
        }
        const sourceColumns = this.beans.groupFilter.getSourceColumns(groupColumn);
        if (!sourceColumns) {
            (0, $jIDNV._warn)(183);
            return [];
        }
        return sourceColumns;
    }
    updateColumns() {
        const allSourceColumns = this.getSourceColumns();
        const sourceColumns = allSourceColumns.filter((sourceColumn)=>sourceColumn.isFilterAllowed());
        this.sourceColumns = sourceColumns;
        let selectedColumn;
        let hasMultipleColumns;
        if (!sourceColumns.length) {
            selectedColumn = void 0;
            hasMultipleColumns = false;
        } else if (allSourceColumns.length === 1) {
            selectedColumn = sourceColumns[0];
            hasMultipleColumns = false;
        } else {
            selectedColumn = this.selectedColumn;
            if (!selectedColumn || !sourceColumns.some((column)=>column.getId() === selectedColumn.getId())) selectedColumn = sourceColumns[0];
            hasMultipleColumns = true;
        }
        this.selectedColumn = selectedColumn;
        this.hasMultipleColumns = hasMultipleColumns;
        this.dispatchLocalEvent({
            type: "sourceColumnsChanged"
        });
    }
    onFilterDestroyed({ column: eventColumn, source: source }) {
        if (source === "gridDestroyed") return;
        const colId = eventColumn.getColId();
        if (this.sourceColumns?.some((column)=>column.getColId() === colId)) setTimeout(()=>{
            if (this.isAlive()) this.updateColumns();
        });
    }
};
var $5b7ccabde48fae90$var$GroupFilterService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "groupFilter";
    }
    postConstruct() {
        this.addManagedEventListeners({
            columnRowGroupChanged: ()=>this.updateFilterFlags("columnRowGroupChanged")
        });
    }
    isGroupFilter(column) {
        return column.getColDef().filter === "agGroupColumnFilter";
    }
    isFilterAllowed(column) {
        const colFilter = this.beans.colFilter;
        return !!this.getSourceColumns(column)?.some((column2)=>colFilter?.isFilterAllowed(column2));
    }
    isFilterActive(column) {
        const colFilter = this.beans.colFilter;
        return !!this.getSourceColumns(column)?.some((column2)=>colFilter?.isFilterActive(column2));
    }
    getSourceColumns(column) {
        return this.beans.showRowGroupCols?.getSourceColumnsForGroupColumn(column);
    }
    updateFilterFlags(source, additionalEventAttributes) {
        const { autoColSvc: autoColSvc, colFilter: colFilter } = this.beans;
        autoColSvc?.getColumns()?.forEach((groupColumn)=>{
            if (this.isGroupFilter(groupColumn)) colFilter?.setColFilterActive(groupColumn, this.isFilterActive(groupColumn), source, additionalEventAttributes);
        });
    }
};
var $5b7ccabde48fae90$var$GroupFloatingFilterElement = {
    tag: "div",
    ref: "eFloatingFilter",
    cls: "ag-group-floating-filter ag-floating-filter-input",
    role: "presentation"
};
var $5b7ccabde48fae90$var$GroupFloatingFilterComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$GroupFloatingFilterElement);
        this.eFloatingFilter = (0, $jIDNV.RefPlaceholder);
        this.haveAddedColumnListeners = false;
    }
    init(params) {
        this.params = params;
        const canShowUnderlyingFloatingFilter = (0, $jIDNV._isGroupMultiAutoColumn)(this.gos);
        const onColChange = this.onColChange.bind(this);
        const setupFilterElement = (resolve)=>{
            if (canShowUnderlyingFloatingFilter) this.setupUnderlyingFloatingFilterElement().then(()=>resolve());
            else {
                this.setupReadOnlyFloatingFilterElement();
                resolve();
            }
        };
        if (this.gos.get("enableFilterHandlers")) return new (0, $jIDNV.AgPromise)((resolve)=>setupFilterElement(resolve)).then(()=>{
            this.addHandlerListeners(params, onColChange);
        });
        else return new (0, $jIDNV.AgPromise)((resolve)=>{
            this.params.parentFilterInstance((parentFilterInstance)=>{
                this.parentFilterInstance = parentFilterInstance;
                setupFilterElement(resolve);
            });
        }).then(()=>{
            this.addManagedListeners(this.parentFilterInstance, {
                columnsChanged: onColChange
            });
        });
    }
    refresh(params) {
        this.params = params;
        this.setParams();
        if (this.gos.get("enableFilterHandlers")) {
            if (this.showingUnderlyingFloatingFilter) {
                const column = this.getSelectedColumn();
                const compDetails = this.beans.colFilter.getFloatingFilterCompDetails(column, this.params.showParentFilter);
                this.underlyingFloatingFilter?.refresh?.(compDetails?.params);
            } else this.updateDisplayedValue();
        }
    }
    setParams() {
        const displayName = this.beans.colNames.getDisplayNameForColumn(this.params.column, "header", true);
        const translate = this.getLocaleTextFunc();
        this.eFloatingFilterText?.setInputAriaLabel(`${displayName} ${translate("ariaFilterInput", "Filter Input")}`);
    }
    addHandlerListeners(params, listener) {
        const destroyFunctions = this.addManagedListeners(params.getHandler(), {
            selectedColumnChanged: listener,
            sourceColumnsChanged: listener,
            destroyed: ()=>{
                destroyFunctions.forEach((func)=>func());
                this.addHandlerListeners(this.params, listener);
            }
        });
    }
    setupReadOnlyFloatingFilterElement() {
        if (!this.eFloatingFilterText) {
            this.eFloatingFilterText = this.createManagedBean(new (0, $jIDNV.AgInputTextField)());
            this.eFloatingFilterText.setDisabled(true).addGuiEventListener("click", ()=>this.params.showParentFilter());
            this.setParams();
        }
        this.updateDisplayedValue();
        this.eFloatingFilter.appendChild(this.eFloatingFilterText.getGui());
    }
    setupUnderlyingFloatingFilterElement() {
        this.showingUnderlyingFloatingFilter = false;
        this.underlyingFloatingFilter = void 0;
        (0, $jIDNV._clearElement)(this.eFloatingFilter);
        const column = this.getSelectedColumn();
        if (column && !column.isVisible()) {
            const colFilter = this.beans.colFilter;
            const compDetails = colFilter.getFloatingFilterCompDetails(column, this.params.showParentFilter);
            if (compDetails) {
                if (!this.haveAddedColumnListeners) {
                    this.haveAddedColumnListeners = true;
                    this.addManagedListeners(column, {
                        visibleChanged: this.onColumnVisibleChanged.bind(this),
                        colDefChanged: this.onColDefChanged.bind(this)
                    });
                }
                return compDetails.newAgStackInstance().then((floatingFilter)=>{
                    this.underlyingFloatingFilter = floatingFilter;
                    this.underlyingFloatingFilter?.onParentModelChanged(colFilter.getModelForColumn(column));
                    this.appendChild(floatingFilter.getGui());
                    this.showingUnderlyingFloatingFilter = true;
                });
            }
        }
        this.setupReadOnlyFloatingFilterElement();
        return (0, $jIDNV.AgPromise).resolve();
    }
    getSelectedColumn() {
        if (this.gos.get("enableFilterHandlers")) {
            const reactiveParams = this.params;
            return reactiveParams.getHandler().selectedColumn;
        } else return this.parentFilterInstance.getSelectedColumn();
    }
    onColumnVisibleChanged() {
        this.setupUnderlyingFloatingFilterElement();
    }
    onColDefChanged(event) {
        if (!event.column) return;
        const compDetails = this.beans.colFilter.getFloatingFilterCompDetails(event.column, this.params.showParentFilter);
        if (compDetails) this.underlyingFloatingFilter?.refresh?.(compDetails.params);
    }
    onParentModelChanged(_model, event) {
        if (this.showingUnderlyingFloatingFilter) this.underlyingFloatingFilter?.onParentModelChanged(this.beans.colFilter.getModelForColumn(this.getSelectedColumn()), event);
        else this.updateDisplayedValue();
    }
    updateDisplayedValue() {
        const eFloatingFilterText = this.eFloatingFilterText;
        if (!eFloatingFilterText) return;
        const colFilter = this.beans.colFilter;
        const column = this.getSelectedColumn();
        const updateText = (filterOrHandler)=>{
            if (!filterOrHandler) {
                eFloatingFilterText.setValue("");
                eFloatingFilterText.setDisplayed(false);
            } else {
                const model = column ? colFilter.getModelForColumn(column) : null;
                eFloatingFilterText.setValue(model == null ? "" : filterOrHandler.getModelAsString?.(model) ?? "");
                eFloatingFilterText.setDisplayed(true);
            }
        };
        if (this.gos.get("enableFilterHandlers")) updateText(colFilter.getHandler(column));
        else colFilter.getOrCreateFilterUi(column)?.then((filter)=>{
            updateText(filter);
        });
    }
    onColChange() {
        if (!this.showingUnderlyingFloatingFilter) this.updateDisplayedValue();
    }
};
// packages/ag-grid-enterprise/src/rowGrouping/groupStrategy/batchRemover.ts
var $5b7ccabde48fae90$var$BatchRemover = class {
    constructor(){
        this.allSets = /* @__PURE__ */ new Map();
    }
    removeFromChildrenAfterGroup(parent, child) {
        const set2 = this.getSet(parent);
        (set2.fromChildrenAfterGroup ?? (set2.fromChildrenAfterGroup = /* @__PURE__ */ new Set())).add(child);
    }
    isRemoveFromAllLeafChildren(parent, child) {
        return !!this.allSets.get(parent)?.fromAllLeafChildren?.has(child);
    }
    preventRemoveFromAllLeafChildren(parent, child) {
        this.allSets.get(parent)?.fromAllLeafChildren?.delete(child);
    }
    removeFromAllLeafChildren(parent, child) {
        const set2 = this.getSet(parent);
        (set2.fromAllLeafChildren ?? (set2.fromAllLeafChildren = /* @__PURE__ */ new Set())).add(child);
    }
    getSet(parent) {
        let set2 = this.allSets.get(parent);
        if (!set2) {
            set2 = {
                fromChildrenAfterGroup: null,
                fromAllLeafChildren: null
            };
            this.allSets.set(parent, set2);
        }
        return set2;
    }
    getAllParents() {
        return Array.from(this.allSets.keys());
    }
    flush() {
        const allSets = this.allSets;
        for (const parent of allSets.keys()){
            const nodeDetails = allSets.get(parent);
            if (nodeDetails) {
                const { fromChildrenAfterGroup: fromChildrenAfterGroup, fromAllLeafChildren: fromAllLeafChildren } = nodeDetails;
                const { childrenAfterGroup: childrenAfterGroup, allLeafChildren: allLeafChildren } = parent;
                if (childrenAfterGroup && fromChildrenAfterGroup) {
                    $5b7ccabde48fae90$var$filterRowNodesInPlace(childrenAfterGroup, fromChildrenAfterGroup);
                    parent.updateHasChildren();
                }
                if (allLeafChildren && fromAllLeafChildren) $5b7ccabde48fae90$var$filterRowNodesInPlace(allLeafChildren, fromAllLeafChildren);
            }
        }
        allSets.clear();
    }
};
function $5b7ccabde48fae90$var$filterRowNodesInPlace(array, removals) {
    let writeIdx = 0;
    for(let i = 0, len = array.length; i < len; ++i){
        const item = array[i];
        if (!removals.has(item)) array[writeIdx++] = item;
    }
    array.length = writeIdx;
}
// packages/ag-grid-enterprise/src/rowGrouping/groupStrategy/groupColumns.ts
var $5b7ccabde48fae90$var$makeGroupColumns = (columns)=>{
    if (!columns) return [];
    const len = columns.length;
    const result = new Array(len);
    for(let i = 0; i < len; i++){
        const col = columns[i];
        const colDef = col.getColDef();
        result[i] = {
            col: col,
            field: colDef.field,
            type: colDef.type,
            keyCreator: colDef.keyCreator,
            valueGetter: colDef.valueGetter
        };
    }
    return result;
};
var $5b7ccabde48fae90$var$groupColumnsChanged = (groupColumns, columns)=>{
    const len = groupColumns.length;
    if (len !== columns?.length) return true;
    for(let i = 0; i < len; i++){
        const a = groupColumns[i];
        const b = columns[i];
        if (a.col !== b) return true;
        const bColDef = b.getColDef();
        if (a.field !== bColDef.field || a.type !== bColDef.type || a.valueGetter !== bColDef.valueGetter || a.keyCreator !== bColDef.keyCreator) return true;
    }
    return false;
};
// packages/ag-grid-enterprise/src/rowGrouping/groupStrategy/sortGroupChildren.ts
function $5b7ccabde48fae90$var$sortGroupChildren(rowNodes) {
    if (!rowNodes) return false;
    const length = rowNodes.length;
    if (length < 2) return false;
    let atLeastOneOutOfOrder = false;
    for(let i = 1; i < length; i++)if ($5b7ccabde48fae90$var$compareGroupChildren(rowNodes[i - 1], rowNodes[i]) > 0) {
        atLeastOneOutOfOrder = true;
        break;
    }
    if (!atLeastOneOutOfOrder) return false;
    rowNodes.sort($5b7ccabde48fae90$var$compareGroupChildren);
    return true;
}
function $5b7ccabde48fae90$var$compareGroupChildren(nodeA, nodeB) {
    const positionA = nodeA.sourceRowIndex;
    const positionB = nodeB.sourceRowIndex;
    const aHasIndex = positionA >= 0;
    const bHasIndex = positionB >= 0;
    const bothNodesAreUserNodes = aHasIndex && bHasIndex;
    const bothNodesAreFillerNodes = !aHasIndex && !bHasIndex;
    if (bothNodesAreUserNodes) return positionA - positionB;
    if (bothNodesAreFillerNodes) return nodeA.__objectId - nodeB.__objectId;
    if (aHasIndex) return 1;
    return -1;
}
// packages/ag-grid-enterprise/src/rowGrouping/groupStrategy/groupStrategy.ts
var $5b7ccabde48fae90$var$GroupStrategy = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        // when grouping, these items are of note:
        // rowNode.parent: RowNode: set to the parent
        // rowNode.childrenAfterGroup: RowNode[] = the direct children of this group
        // rowNode.childrenMapped: string=>RowNode = children mapped by group key (when groups) or an empty map if leaf group (this is then used by pivot)
        // for leaf groups, rowNode.childrenAfterGroup = rowNode.allLeafChildren;
        this.prevGroupCols = null;
        this.prevShowGroupCols = null;
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.valueSvc = beans.valueSvc;
        this.selectionSvc = beans.selectionSvc;
        this.showRowGroupCols = beans.showRowGroupCols;
    }
    getNode(id) {
        let res = void 0;
        this.beans.rowModel.forEachNode((node)=>{
            if (node.id === id) res = node;
        });
        return res;
    }
    execute(params) {
        const details = this.createGroupingDetails(params);
        const changedRowNodes = params.changedRowNodes;
        if (changedRowNodes) this.handleDeltaUpdate(details, changedRowNodes);
        else this.shotgunResetEverything(details, !!params.afterColumnsChanged);
        const changedPath = params.changedPath;
        this.positionLeafsAndGroups(changedPath);
        this.orderGroups(details);
        this.selectionSvc?.updateSelectableAfterGrouping(changedPath);
    }
    positionLeafsAndGroups(changedPath) {
        changedPath.forEachChangedNodeDepthFirst((group)=>{
            if (group.childrenAfterGroup) {
                const leafNodes = [];
                const groupNodes = [];
                let unbalancedNode;
                group.childrenAfterGroup.forEach((row)=>{
                    if (!row.childrenAfterGroup?.length) leafNodes.push(row);
                    else if (row.key === "" && !unbalancedNode) unbalancedNode = row;
                    else groupNodes.push(row);
                });
                if (unbalancedNode) groupNodes.push(unbalancedNode);
                group.childrenAfterGroup = [
                    ...leafNodes,
                    ...groupNodes
                ];
            }
        }, false);
    }
    createGroupingDetails(params) {
        const { rowNode: rowNode, changedPath: changedPath, rowNodesOrderChanged: rowNodesOrderChanged } = params;
        let groupColsChanged = false;
        const cols = this.beans.rowGroupColsSvc?.columns;
        let groupCols = this.prevGroupCols;
        if (!groupCols || $5b7ccabde48fae90$var$groupColumnsChanged(groupCols, cols)) {
            groupColsChanged = !!groupCols;
            this.prevGroupCols = groupCols = $5b7ccabde48fae90$var$makeGroupColumns(cols);
        }
        const details = {
            groupCols: groupCols,
            rootNode: rowNode,
            pivotMode: this.colModel.isPivotMode(),
            rowNodesOrderChanged: !!rowNodesOrderChanged,
            groupColsChanged: groupColsChanged,
            changedPath: // if no transaction and not immutable row data set, then it's shotgun, changed path would be 'not active' at this point anyway
            changedPath,
            groupAllowUnbalanced: this.gos.get("groupAllowUnbalanced"),
            isGroupOpenByDefault: this.gos.getCallback("isGroupOpenByDefault"),
            initialGroupOrderComparator: this.gos.getCallback("initialGroupOrderComparator")
        };
        return details;
    }
    handleDeltaUpdate(details, { removals: removals, updates: updates, adds: adds }) {
        const batchRemover = new $5b7ccabde48fae90$var$BatchRemover();
        if (removals.size) this.removeNodes(removals, details, batchRemover);
        for (const rowNode of updates)this.moveNodeInWrongPath(rowNode, details, batchRemover);
        const changedPath = details.changedPath;
        for (const rowNode of adds){
            this.insertOneNode(rowNode, details);
            if (changedPath.active) changedPath.addParentNode(rowNode.parent);
        }
        const parentsWithChildrenRemoved = batchRemover.getAllParents();
        batchRemover.flush();
        this.removeEmptyGroups(parentsWithChildrenRemoved, details);
        if (details.rowNodesOrderChanged) this.sortChildren(details);
    }
    // this is used when doing delta updates, eg Redux, keeps nodes in right order
    sortChildren(details) {
        details.changedPath.forEachChangedNodeDepthFirst((node)=>{
            const didSort = $5b7ccabde48fae90$var$sortGroupChildren(node.childrenAfterGroup);
            if (didSort) details.changedPath.addParentNode(node);
        }, false, true);
    }
    orderGroups(details) {
        const comparator = details.initialGroupOrderComparator;
        if ((0, $jIDNV._exists)(comparator)) recursiveSort(details.rootNode);
        function recursiveSort(rowNode) {
            const doSort = (0, $jIDNV._exists)(rowNode.childrenAfterGroup) && // we only want to sort groups, so we do not sort leafs (a leaf group has leafs as children)
            !rowNode.leafGroup;
            if (doSort) {
                rowNode.childrenAfterGroup.sort((nodeA, nodeB)=>comparator({
                        nodeA: nodeA,
                        nodeB: nodeB
                    }));
                rowNode.childrenAfterGroup.forEach((childNode)=>recursiveSort(childNode));
            }
        }
    }
    getExistingPathForNode(node, details) {
        const res = [];
        let pointer = node.parent;
        while(pointer && pointer !== details.rootNode){
            res.push({
                key: pointer.key,
                rowGroupColumn: pointer.rowGroupColumn,
                field: pointer.field
            });
            pointer = pointer.parent;
        }
        res.reverse();
        return res;
    }
    moveNodeInWrongPath(childNode, details, batchRemover) {
        if (details.changedPath.active) details.changedPath.addParentNode(childNode.parent);
        const infoToKeyMapper = (item)=>item.key;
        const oldPath = this.getExistingPathForNode(childNode, details).map(infoToKeyMapper);
        const newPath = this.getGroupInfo(childNode, details).map(infoToKeyMapper);
        const nodeInCorrectPath = (0, $jIDNV._areEqual)(oldPath, newPath);
        if (!nodeInCorrectPath) this.moveNode(childNode, details, batchRemover);
    }
    moveNode(childNode, details, batchRemover) {
        this.removeNodesFromParents([
            childNode
        ], details, batchRemover);
        this.insertOneNode(childNode, details, batchRemover);
        childNode.setData(childNode.data);
        if (details.changedPath.active) {
            const newParent = childNode.parent;
            details.changedPath.addParentNode(newParent);
        }
    }
    removeNodes(leafRowNodes, details, batchRemover) {
        this.removeNodesFromParents(leafRowNodes, details, batchRemover);
        if (details.changedPath.active) for (const rowNode of leafRowNodes)details.changedPath.addParentNode(rowNode.parent);
    }
    forEachParentGroup(details, group, callback) {
        let pointer = group;
        while(pointer && pointer !== details.rootNode){
            callback(pointer);
            pointer = pointer.parent;
        }
    }
    removeNodesFromParents(nodesToRemove, details, provided) {
        const batchRemoverIsLocal = provided == null;
        const batchRemoverToUse = provided ? provided : new $5b7ccabde48fae90$var$BatchRemover();
        for (const nodeToRemove of nodesToRemove){
            this.removeFromParent(nodeToRemove, batchRemoverToUse);
            this.forEachParentGroup(details, nodeToRemove.parent, (parentNode)=>{
                batchRemoverToUse.removeFromAllLeafChildren(parentNode, nodeToRemove);
            });
        }
        if (batchRemoverIsLocal) batchRemoverToUse.flush();
    }
    removeEmptyGroups(possibleEmptyGroups, details) {
        let checkAgain = true;
        const groupShouldBeRemoved = (rowNode)=>{
            const mapKey = this.getChildrenMappedKey(rowNode.key, rowNode.rowGroupColumn);
            const parentChildrenMapped = rowNode.parent?.childrenMapped;
            const groupAlreadyRemoved = parentChildrenMapped ? !parentChildrenMapped[mapKey] : true;
            if (groupAlreadyRemoved) return false;
            return !!rowNode.group && (rowNode.childrenAfterGroup?.length ?? 0) === 0;
        };
        while(checkAgain){
            checkAgain = false;
            const batchRemover = new $5b7ccabde48fae90$var$BatchRemover();
            possibleEmptyGroups.forEach((possibleEmptyGroup)=>{
                this.forEachParentGroup(details, possibleEmptyGroup, (rowNode)=>{
                    if (groupShouldBeRemoved(rowNode)) {
                        checkAgain = true;
                        this.removeFromParent(rowNode, batchRemover);
                        this.selectionSvc?.setNodesSelected({
                            nodes: [
                                rowNode
                            ],
                            newValue: false,
                            source: "rowGroupChanged"
                        });
                    }
                });
            });
            batchRemover.flush();
        }
    }
    // removes the node from the parent by:
    // a) removing from childrenAfterGroup (using batchRemover if present, otherwise immediately)
    // b) removing from childrenMapped (immediately)
    // c) setRowTop(null) - as the rowRenderer uses this to know the RowNode is no longer needed
    // d) setRowIndex(null) - as the rowNode will no longer be displayed.
    removeFromParent(child, batchRemover) {
        if (child.parent) {
            if (batchRemover) batchRemover.removeFromChildrenAfterGroup(child.parent, child);
            else {
                (0, $jIDNV._removeFromArray)(child.parent.childrenAfterGroup, child);
                child.parent.updateHasChildren();
            }
        }
        const mapKey = this.getChildrenMappedKey(child.key, child.rowGroupColumn);
        const childParentChildrenMapped = child.parent?.childrenMapped;
        if (childParentChildrenMapped) delete childParentChildrenMapped[mapKey];
        child.setRowTop(null);
        child.setRowIndex(null);
    }
    /**
   * This is idempotent, but relies on the `key` field being the same throughout a RowNode's lifetime
   */ addToParent(child, parent) {
        const childrenMapped = parent.childrenMapped ?? (parent.childrenMapped = {});
        const mapKey = this.getChildrenMappedKey(child.key, child.rowGroupColumn);
        if (childrenMapped[mapKey] !== child) {
            childrenMapped[mapKey] = child;
            (parent.childrenAfterGroup ?? (parent.childrenAfterGroup = [])).push(child);
            $5b7ccabde48fae90$var$setRowNodeGroup(parent, this.beans, true);
        }
    }
    checkAllGroupDataAfterColsChanged(details) {
        const recurse = (rowNodes)=>{
            if (!rowNodes) return;
            rowNodes.forEach((rowNode)=>{
                const isLeafNode = !rowNode.group;
                if (isLeafNode) return;
                const groupInfo = {
                    field: rowNode.field,
                    key: rowNode.key,
                    rowGroupColumn: rowNode.rowGroupColumn,
                    leafNode: rowNode.allLeafChildren?.[0]
                };
                this.setGroupData(rowNode, groupInfo);
                recurse(rowNode.childrenAfterGroup);
            });
        };
        recurse(details.rootNode.childrenAfterGroup);
    }
    shotgunResetEverything(details, afterColumnsChanged) {
        if (this.noChangeInGroupingColumns(details, afterColumnsChanged)) return;
        this.selectionSvc?.filterFromSelection?.((node)=>!node.group);
        const rootNode = details.rootNode;
        rootNode.leafGroup = details.groupCols.length === 0;
        rootNode.childrenAfterGroup = [];
        rootNode.childrenMapped = {};
        rootNode.updateHasChildren();
        const sibling = rootNode.sibling;
        if (sibling) {
            sibling.childrenAfterGroup = rootNode.childrenAfterGroup;
            sibling.childrenMapped = rootNode.childrenMapped;
        }
        this.insertNodes(rootNode.allLeafChildren, details);
    }
    noChangeInGroupingColumns(details, afterColumnsChanged) {
        let showGroupColsChanged = false;
        const showGroupCols = this.prevShowGroupCols;
        const showCols = this.showRowGroupCols.getShowRowGroupCols();
        if (!showGroupCols || $5b7ccabde48fae90$var$groupColumnsChanged(showGroupCols, showCols)) {
            showGroupColsChanged = !!showGroupCols;
            this.prevShowGroupCols = $5b7ccabde48fae90$var$makeGroupColumns(showCols);
        }
        if (!afterColumnsChanged || details.groupColsChanged) return false;
        if (showGroupColsChanged) this.checkAllGroupDataAfterColsChanged(details);
        return true;
    }
    insertNodes(newRowNodes, details) {
        newRowNodes.forEach((rowNode)=>{
            this.insertOneNode(rowNode, details);
            if (details.changedPath.active) details.changedPath.addParentNode(rowNode.parent);
        });
    }
    insertOneNode(childNode, details, batchRemover) {
        const path = this.getGroupInfo(childNode, details);
        const parentGroup = this.findParentForNode(childNode, path, details, batchRemover);
        if (!parentGroup.group) (0, $jIDNV._warn)(184, {
            parentGroupData: parentGroup.data,
            childNodeData: childNode.data
        });
        childNode.parent = parentGroup;
        childNode.level = path.length;
        parentGroup.childrenAfterGroup.push(childNode);
        parentGroup.updateHasChildren();
    }
    findParentForNode(childNode, path, details, batchRemover) {
        let nextNode = details.rootNode;
        path.forEach((groupInfo, level)=>{
            nextNode = this.getOrCreateNextNode(nextNode, groupInfo, level, details);
            if (!batchRemover?.isRemoveFromAllLeafChildren(nextNode, childNode)) nextNode.allLeafChildren.push(childNode);
            else batchRemover?.preventRemoveFromAllLeafChildren(nextNode, childNode);
        });
        return nextNode;
    }
    getOrCreateNextNode(parentGroup, groupInfo, level, details) {
        const key = this.getChildrenMappedKey(groupInfo.key, groupInfo.rowGroupColumn);
        const parentChildrenMapped = parentGroup?.childrenMapped;
        let nextNode = parentChildrenMapped?.[key];
        if (!nextNode) {
            nextNode = this.createGroup(groupInfo, parentGroup, level, details);
            this.addToParent(nextNode, parentGroup);
        }
        return nextNode;
    }
    createGroup(groupInfo, parent, level, details) {
        const groupNode = new (0, $jIDNV.RowNode)(this.beans);
        groupNode.group = true;
        groupNode.field = groupInfo.field;
        groupNode.rowGroupColumn = groupInfo.rowGroupColumn;
        this.setGroupData(groupNode, groupInfo);
        groupNode.key = groupInfo.key;
        groupNode.id = this.createGroupId(groupNode, parent, level);
        groupNode.level = level;
        groupNode.leafGroup = level === details.groupCols.length - 1;
        groupNode.allLeafChildren = [];
        groupNode.setAllChildrenCount(0);
        groupNode.rowGroupIndex = level;
        groupNode.childrenAfterGroup = [];
        groupNode.childrenMapped = {};
        groupNode.updateHasChildren();
        groupNode.parent = parent;
        this.setExpandedInitialValue(details, groupNode);
        return groupNode;
    }
    createGroupId(node, parent, level) {
        const createGroupId = (node2, parent2)=>{
            if (!node2.rowGroupColumn) return null;
            const parentId = parent2 ? createGroupId(parent2, parent2.parent, 0) : null;
            return `${parentId == null ? "" : parentId + "-"}${node2.rowGroupColumn.getColId()}-${node2.key}`;
        };
        return (0, $jIDNV._ROW_ID_PREFIX_ROW_GROUP) + createGroupId(node, parent, level);
    }
    setGroupData(groupNode, groupInfo) {
        const rowGroupCol = groupInfo.rowGroupColumn;
        if (rowGroupCol && groupInfo.leafNode) groupNode.groupValue = this.valueSvc.getValue(rowGroupCol, groupInfo.leafNode);
        groupNode.groupData = {};
        const groupDisplayCols = this.showRowGroupCols.getShowRowGroupCols();
        groupDisplayCols.forEach((col)=>{
            const groupColumn = groupNode.rowGroupColumn;
            const isRowGroupDisplayed = groupColumn !== null && col.isRowGroupDisplayed(groupColumn.getId());
            if (isRowGroupDisplayed) groupNode.groupData[col.getColId()] = this.valueSvc.getValue(groupColumn, groupInfo.leafNode);
        });
    }
    getChildrenMappedKey(key, rowGroupColumn) {
        return rowGroupColumn ? rowGroupColumn.getId() + "-" + key : key;
    }
    setExpandedInitialValue(details, groupNode) {
        if (details.pivotMode && groupNode.leafGroup) {
            groupNode.expanded = false;
            return;
        }
        groupNode.expanded = $5b7ccabde48fae90$var$_getRowDefaultExpanded(this.beans, groupNode, groupNode.level);
    }
    getGroupInfo(rowNode, details) {
        const res = [];
        for (const { col: col, field: field } of details.groupCols){
            let key = this.valueSvc.getKeyForNode(col, rowNode);
            let keyExists = key !== null && key !== void 0 && key !== "";
            const createGroupForEmpty = details.pivotMode || !details.groupAllowUnbalanced;
            if (createGroupForEmpty && !keyExists) {
                key = "";
                keyExists = true;
            }
            if (keyExists) {
                const item = {
                    key: key,
                    field: field,
                    rowGroupColumn: col,
                    leafNode: rowNode
                };
                res.push(item);
            }
        }
        return res;
    }
};
// packages/ag-grid-enterprise/src/rowGrouping/rowGroupingApi.ts
function $5b7ccabde48fae90$var$setRowGroupColumns(beans, colKeys) {
    beans.rowGroupColsSvc?.setColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$removeRowGroupColumns(beans, colKeys) {
    beans.rowGroupColsSvc?.removeColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$addRowGroupColumns(beans, colKeys) {
    beans.rowGroupColsSvc?.addColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$moveRowGroupColumn(beans, fromIndex, toIndex) {
    beans.rowGroupColsSvc?.moveColumn?.(fromIndex, toIndex, "api");
}
function $5b7ccabde48fae90$var$getRowGroupColumns(beans) {
    return beans.rowGroupColsSvc?.columns ?? [];
}
// packages/ag-grid-enterprise/src/rowGrouping/rowGroupingModule.ts
var $5b7ccabde48fae90$var$SharedRowGroupingModule = {
    moduleName: "SharedRowGrouping",
    version: $5b7ccabde48fae90$var$VERSION,
    apiFunctions: {
        setRowGroupColumns: $5b7ccabde48fae90$var$setRowGroupColumns,
        removeRowGroupColumns: $5b7ccabde48fae90$var$removeRowGroupColumns,
        addRowGroupColumns: $5b7ccabde48fae90$var$addRowGroupColumns,
        getRowGroupColumns: $5b7ccabde48fae90$var$getRowGroupColumns,
        moveRowGroupColumn: $5b7ccabde48fae90$var$moveRowGroupColumn
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        $5b7ccabde48fae90$var$SharedAggregationModule,
        $5b7ccabde48fae90$var$GroupColumnModule,
        $5b7ccabde48fae90$var$StickyRowModule
    ]
};
var $5b7ccabde48fae90$export$e67935bd41653107 = {
    moduleName: "RowGrouping",
    version: $5b7ccabde48fae90$var$VERSION,
    dynamicBeans: {
        groupStrategy: $5b7ccabde48fae90$var$GroupStrategy
    },
    rowModels: [
        "clientSide"
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$SharedRowGroupingModule,
        $5b7ccabde48fae90$export$b53def5458540436,
        $5b7ccabde48fae90$var$ClientSideRowModelHierarchyModule
    ]
};
var $5b7ccabde48fae90$export$60c70655af65b0f1 = {
    moduleName: "RowGroupingPanel",
    version: $5b7ccabde48fae90$var$VERSION,
    selectors: [
        $5b7ccabde48fae90$var$AgGridHeaderDropZonesSelector
    ],
    icons: {
        // identifies the pivot drop zone
        pivotPanel: "pivot",
        // "Row groups" drop zone in column tool panel
        rowGroupPanel: "group",
        // separator between column 'pills' when you add multiple columns to the header drop zone
        panelDelimiter: "small-right",
        // version of panelDelimiter used in RTL mode
        panelDelimiterRtl: "small-left"
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $jIDNV._PopupModule)
    ]
};
var $5b7ccabde48fae90$export$aca1637eb4e24373 = {
    moduleName: "GroupFilter",
    version: $5b7ccabde48fae90$var$VERSION,
    userComponents: {
        agGroupColumnFilter: $5b7ccabde48fae90$var$GroupFilter,
        agGroupColumnFloatingFilter: $5b7ccabde48fae90$var$GroupFloatingFilterComp
    },
    beans: [
        $5b7ccabde48fae90$var$GroupFilterService
    ],
    dynamicBeans: {
        agGroupColumnFilterHandler: $5b7ccabde48fae90$var$GroupFilterHandler
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $jIDNV._ColumnFilterModule)
    ]
};
var $5b7ccabde48fae90$var$ViewportRowModel = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "rowModel";
        // rowRenderer tells us these
        this.firstRow = -1;
        this.lastRow = -1;
        // datasource tells us this
        this.rowCount = -1;
        this.rowNodesByIndex = {};
        /**
     * Used to see if setRowData has been called inside of the viewportChanged event context,
     * if so the new rows are already being calculated, and the model does not need updated
     * otherwise, a new model event needs to fire as rows have changed externally.
     */ this.viewportChangedContext = false;
    }
    // we don't implement as lazy row heights is not supported in this row model
    ensureRowHeightsValid(_startPixel, _endPixel, _startLimitIndex, _endLimitIndex) {
        return false;
    }
    postConstruct() {
        const beans = this.beans;
        this.rowHeight = (0, $jIDNV._getRowHeightAsNumber)(beans);
        this.addManagedEventListeners({
            viewportChanged: this.onViewportChanged.bind(this)
        });
        this.addManagedPropertyListener("viewportDatasource", ()=>this.updateDatasource());
        this.addManagedPropertyListener("rowHeight", ()=>{
            this.rowHeight = (0, $jIDNV._getRowHeightAsNumber)(beans);
            this.updateRowHeights();
        });
    }
    start() {
        this.updateDatasource();
    }
    isLastRowIndexKnown() {
        return true;
    }
    destroy() {
        this.destroyDatasource();
        super.destroy();
    }
    destroyDatasource() {
        const datasource = this.datasource;
        if (!datasource) return;
        datasource.destroy?.();
        this.beans.rowRenderer.datasourceChanged();
        this.firstRow = -1;
        this.lastRow = -1;
    }
    updateDatasource() {
        const datasource = this.gos.get("viewportDatasource");
        if (datasource) this.setViewportDatasource(datasource);
    }
    getPageSize() {
        return this.gos.get("viewportRowModelPageSize");
    }
    getBufferSize() {
        return this.gos.get("viewportRowModelBufferSize");
    }
    calculateFirstRow(firstRenderedRow) {
        const bufferSize = this.getBufferSize();
        const pageSize = this.getPageSize();
        const afterBuffer = firstRenderedRow - bufferSize;
        if (afterBuffer < 0) return 0;
        return Math.floor(afterBuffer / pageSize) * pageSize;
    }
    calculateLastRow(lastRenderedRow) {
        if (lastRenderedRow === -1) return lastRenderedRow;
        const bufferSize = this.getBufferSize();
        const pageSize = this.getPageSize();
        const afterBuffer = lastRenderedRow + bufferSize;
        const result = Math.ceil(afterBuffer / pageSize) * pageSize;
        const lastRowIndex = this.rowCount - 1;
        return Math.min(result, lastRowIndex);
    }
    onViewportChanged(event) {
        const newFirst = this.calculateFirstRow(event.firstRow);
        const newLast = this.calculateLastRow(event.lastRow);
        if (this.firstRow !== newFirst || this.lastRow !== newLast) {
            this.firstRow = newFirst;
            this.lastRow = newLast;
            this.purgeRowsNotInViewport();
            this.viewportChangedContext = true;
            this.datasource?.setViewportRange(this.firstRow, this.lastRow);
            this.viewportChangedContext = false;
        }
    }
    purgeRowsNotInViewport() {
        const rowNodesByIndex = this.rowNodesByIndex;
        Object.keys(rowNodesByIndex).forEach((indexStr)=>{
            const index = parseInt(indexStr, 10);
            if (index < this.firstRow || index > this.lastRow) {
                if (this.isRowFocused(index) || this.beans.editSvc?.isRowEditing(rowNodesByIndex[index])) return;
                delete rowNodesByIndex[index];
            }
        });
    }
    isRowFocused(rowIndex) {
        const focusedCell = this.beans.focusSvc.getFocusCellToUseAfterRefresh();
        if (!focusedCell) return false;
        if (focusedCell.rowPinned != null) return false;
        const hasFocus = focusedCell.rowIndex === rowIndex;
        return hasFocus;
    }
    setViewportDatasource(viewportDatasource) {
        this.destroyDatasource();
        this.datasource = viewportDatasource;
        this.rowCount = -1;
        if (!viewportDatasource.init) (0, $jIDNV._warn)(226);
        else viewportDatasource.init({
            setRowCount: this.setRowCount.bind(this),
            setRowData: this.setRowData.bind(this),
            getRow: this.getRow.bind(this)
        });
    }
    getType() {
        return "viewport";
    }
    getRow(rowIndex) {
        if (!this.rowNodesByIndex[rowIndex]) this.rowNodesByIndex[rowIndex] = this.createBlankRowNode(rowIndex);
        return this.rowNodesByIndex[rowIndex];
    }
    getRowNode(id) {
        let result;
        this.forEachNode((rowNode)=>{
            if (rowNode.id === id) result = rowNode;
        });
        return result;
    }
    getRowCount() {
        return this.rowCount === -1 ? 0 : this.rowCount;
    }
    getRowIndexAtPixel(pixel) {
        if (this.rowHeight !== 0) return Math.floor(pixel / this.rowHeight);
        return 0;
    }
    getRowBounds(index) {
        const rowHeight = this.rowHeight;
        return {
            rowHeight: rowHeight,
            rowTop: rowHeight * index
        };
    }
    updateRowHeights() {
        const rowHeight = this.rowHeight;
        this.forEachNode((node)=>{
            node.setRowHeight(rowHeight);
            node.setRowTop(rowHeight * node.rowIndex);
        });
        this.eventSvc.dispatchEvent({
            type: "modelUpdated",
            newData: false,
            newPage: false,
            keepRenderedRows: true,
            animate: false
        });
    }
    getTopLevelRowCount() {
        return this.getRowCount();
    }
    getTopLevelRowDisplayedIndex(topLevelIndex) {
        return topLevelIndex;
    }
    isEmpty() {
        return this.rowCount > 0;
    }
    isRowsToRender() {
        return this.rowCount > 0;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        const firstIndex = firstInRange.rowIndex;
        const lastIndex = lastInRange.rowIndex;
        const firstNodeOutOfRange = firstIndex < this.firstRow || firstIndex > this.lastRow;
        const lastNodeOutOfRange = lastIndex < this.firstRow || lastIndex > this.lastRow;
        if (firstNodeOutOfRange || lastNodeOutOfRange) return [];
        const result = [];
        const startIndex = firstIndex <= lastIndex ? firstIndex : lastIndex;
        const endIndex = firstIndex <= lastIndex ? lastIndex : firstIndex;
        for(let i = startIndex; i <= endIndex; i++)result.push(this.rowNodesByIndex[i]);
        return result;
    }
    forEachNode(callback) {
        let callbackCount = 0;
        Object.keys(this.rowNodesByIndex).forEach((indexStr)=>{
            const index = parseInt(indexStr, 10);
            const rowNode = this.rowNodesByIndex[index];
            callback(rowNode, callbackCount);
            callbackCount++;
        });
    }
    setRowData(rowData) {
        const getRowIdFunc = (0, $jIDNV._getRowIdCallback)(this.beans.gos);
        const existingNodesById = /* @__PURE__ */ new Map();
        if (getRowIdFunc) for (const row of Object.values(this.rowNodesByIndex))existingNodesById.set(row.id, row);
        for(let i = this.firstRow; i <= this.lastRow; i++){
            const data = rowData[i];
            if (!data) continue;
            let rowId;
            let row;
            if (getRowIdFunc) {
                rowId = getRowIdFunc({
                    data: data,
                    rowPinned: void 0,
                    level: 0,
                    parentKeys: void 0
                });
                row = existingNodesById.get(rowId);
            } else row = this.rowNodesByIndex[i];
            if (row) {
                row.updateData(data);
                row.setRowIndex(i);
                row.setRowTop(this.rowHeight * i);
            } else {
                row = this.createBlankRowNode(i);
                row.setDataAndId(data, rowId ?? i.toString());
            }
            this.rowNodesByIndex[i] = row;
        }
        if (!this.viewportChangedContext) this.eventSvc.dispatchEvent({
            type: "modelUpdated",
            newData: false,
            newPage: false,
            keepRenderedRows: true,
            animate: false
        });
    }
    createBlankRowNode(rowIndex) {
        const rowNode = new (0, $jIDNV.RowNode)(this.beans);
        const rowHeight = this.rowHeight;
        rowNode.setRowHeight(rowHeight);
        rowNode.setRowTop(rowHeight * rowIndex);
        rowNode.setRowIndex(rowIndex);
        return rowNode;
    }
    setRowCount(rowCount, keepRenderedRows = false) {
        if (rowCount === this.rowCount) return;
        this.rowCount = rowCount;
        const eventSvc = this.eventSvc;
        eventSvc.dispatchEventOnce({
            type: "rowCountReady"
        });
        eventSvc.dispatchEvent({
            type: "modelUpdated",
            newData: false,
            newPage: false,
            keepRenderedRows: keepRenderedRows,
            animate: false
        });
    }
    isRowPresent(rowNode) {
        const foundRowNode = this.getRowNode(rowNode.id);
        return !!foundRowNode;
    }
};
// packages/ag-grid-enterprise/src/viewportRowModel/viewportRowModelModule.ts
var $5b7ccabde48fae90$export$5afa3276c0fcf76 = {
    moduleName: "ViewportRowModel",
    version: $5b7ccabde48fae90$var$VERSION,
    rowModels: [
        "viewport"
    ],
    beans: [
        $5b7ccabde48fae90$var$ViewportRowModel
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule
    ]
};
// packages/ag-grid-enterprise/src/clipboard/clipboardApi.ts
function $5b7ccabde48fae90$var$copyToClipboard(beans, params) {
    beans.clipboardSvc?.copyToClipboard(params);
}
function $5b7ccabde48fae90$var$cutToClipboard(beans, params) {
    beans.clipboardSvc?.cutToClipboard(params);
}
function $5b7ccabde48fae90$var$copySelectedRowsToClipboard(beans, params) {
    beans.clipboardSvc?.copySelectedRowsToClipboard(params);
}
function $5b7ccabde48fae90$var$copySelectedRangeToClipboard(beans, params) {
    beans.clipboardSvc?.copySelectedRangeToClipboard(params);
}
function $5b7ccabde48fae90$var$copySelectedRangeDown(beans) {
    beans.clipboardSvc?.copyRangeDown();
}
function $5b7ccabde48fae90$var$pasteFromClipboard(beans) {
    beans.clipboardSvc?.pasteFromClipboard();
}
var $5b7ccabde48fae90$var$SOURCE_PASTE = "paste";
var $5b7ccabde48fae90$var$EXPORT_TYPE_DRAG_COPY = "dragCopy";
var $5b7ccabde48fae90$var$EXPORT_TYPE_CLIPBOARD = "clipboard";
function $5b7ccabde48fae90$var$stringToArray(strData, delimiter = ",") {
    const data = [];
    const isNewline = (char)=>char === "\r" || char === "\n";
    let insideQuotedField = false;
    if (strData === "") return [
        [
            ""
        ]
    ];
    for(let row = 0, column = 0, position = 0; position < strData.length; position++){
        const previousChar = strData[position - 1];
        const currentChar = strData[position];
        const nextChar = strData[position + 1];
        const ensureDataExists = ()=>{
            if (!data[row]) data[row] = [];
            if (!data[row][column]) data[row][column] = "";
        };
        ensureDataExists();
        if (currentChar === '"') {
            if (insideQuotedField) {
                if (nextChar === '"') {
                    data[row][column] += '"';
                    position++;
                } else insideQuotedField = false;
            } else if (previousChar === void 0 || previousChar === delimiter || isNewline(previousChar)) insideQuotedField = true;
        }
        if (!insideQuotedField && currentChar !== '"') {
            if (currentChar === delimiter) {
                column++;
                ensureDataExists();
                continue;
            } else if (isNewline(currentChar)) {
                column = 0;
                row++;
                ensureDataExists();
                if (currentChar === "\r" && nextChar === "\n") position++;
                continue;
            }
        }
        data[row][column] += currentChar;
    }
    return data;
}
var $5b7ccabde48fae90$var$ClipboardService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "clipboardSvc";
        this.clientSideRowModel = null;
        this.gridCtrl = null;
        this.lastPasteOperationTime = 0;
        this.navigatorApiFailed = false;
    }
    postConstruct() {
        const { gos: gos, rowModel: rowModel, ctrlsSvc: ctrlsSvc } = this.beans;
        if ((0, $jIDNV._isClientSideRowModel)(gos, rowModel)) this.clientSideRowModel = rowModel;
        ctrlsSvc.whenReady(this, (p)=>{
            this.gridCtrl = p.gridCtrl;
        });
    }
    destroy() {
        super.destroy();
        this.clientSideRowModel = null;
        this.gridCtrl = null;
    }
    pasteFromClipboard() {
        const allowNavigator = !this.gos.get("suppressClipboardApi");
        if (allowNavigator && !this.navigatorApiFailed && navigator.clipboard && navigator.clipboard.readText) navigator.clipboard.readText().then(this.processClipboardData.bind(this)).catch((e)=>{
            (0, $jIDNV._warn)(40, {
                e: e,
                method: "readText"
            });
            this.navigatorApiFailed = true;
            this.pasteFromClipboardLegacy();
        });
        else this.pasteFromClipboardLegacy();
    }
    pasteFromClipboardLegacy() {
        let defaultPrevented = false;
        const handlePasteEvent = (e)=>{
            const currentPastOperationTime = Date.now();
            if (currentPastOperationTime - this.lastPasteOperationTime < 50) {
                defaultPrevented = true;
                e.preventDefault();
            }
            this.lastPasteOperationTime = currentPastOperationTime;
        };
        this.executeOnTempElement((textArea)=>{
            textArea.addEventListener("paste", handlePasteEvent);
            textArea.focus({
                preventScroll: true
            });
        }, (element)=>{
            const data = element.value;
            if (!defaultPrevented) this.processClipboardData(data);
            else this.refocusLastFocusedCell();
            element.removeEventListener("paste", handlePasteEvent);
        });
    }
    refocusLastFocusedCell() {
        const { focusSvc: focusSvc } = this.beans;
        const focusedCell = focusSvc.getFocusedCell();
        if (focusedCell) focusSvc.setFocusedCell({
            rowIndex: focusedCell.rowIndex,
            column: focusedCell.column,
            rowPinned: focusedCell.rowPinned,
            forceBrowserFocus: true
        });
    }
    getClipboardDelimiter() {
        const delimiter = this.gos.get("clipboardDelimiter");
        return (0, $jIDNV._exists)(delimiter) ? delimiter : "	";
    }
    processClipboardData(data) {
        if (data == null) return;
        let parsedData = $5b7ccabde48fae90$var$stringToArray(data, this.getClipboardDelimiter());
        const userFunc = this.gos.getCallback("processDataFromClipboard");
        if (userFunc) parsedData = userFunc({
            data: parsedData
        });
        if (parsedData == null) return;
        if (this.gos.get("suppressLastEmptyLineOnPaste")) this.removeLastLineIfBlank(parsedData);
        const { rangeSvc: rangeSvc } = this.beans;
        const pasteOperation = (cellsToFlash, updatedRowNodes, focusedCell, changedPath)=>{
            const rangeActive = rangeSvc?.isMoreThanOneCell();
            const pasteIntoRange = rangeActive && !this.hasOnlyOneValueToPaste(parsedData);
            if (pasteIntoRange) this.pasteIntoActiveRange(rangeSvc, parsedData, cellsToFlash, updatedRowNodes, changedPath);
            else this.pasteStartingFromFocusedCell(parsedData, cellsToFlash, updatedRowNodes, focusedCell, changedPath);
            this.beans.editSvc?.stopEditing(void 0, {
                source: $5b7ccabde48fae90$var$SOURCE_PASTE
            });
        };
        this.doPasteOperation(pasteOperation);
    }
    // common code to paste operations, e.g. paste to cell, paste to range, and copy range down
    doPasteOperation(pasteOperationFunc) {
        const source = "clipboard";
        const { eventSvc: eventSvc, focusSvc: focusSvc, rowRenderer: rowRenderer, gos: gos } = this.beans;
        eventSvc.dispatchEvent({
            type: "pasteStart",
            source: source
        });
        const { clientSideRowModel: clientSideRowModel } = this;
        const rootNode = clientSideRowModel?.rootNode;
        const changedPath = rootNode && new (0, $jIDNV.ChangedPath)(gos.get("aggregateOnlyChangedColumns"), rootNode);
        const cellsToFlash = {};
        const updatedRowNodes = [];
        const focusedCell = focusSvc.getFocusedCell();
        pasteOperationFunc(cellsToFlash, updatedRowNodes, focusedCell, changedPath);
        const nodesToRefresh = [
            ...updatedRowNodes
        ];
        if (changedPath) {
            clientSideRowModel.doAggregate(changedPath);
            changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
                nodesToRefresh.push(rowNode);
            });
        }
        rowRenderer.refreshCells({
            rowNodes: nodesToRefresh
        });
        this.dispatchFlashCells(cellsToFlash);
        this.fireRowChanged(updatedRowNodes);
        this.refocusLastFocusedCell();
        eventSvc.dispatchEvent({
            type: "pasteEnd",
            source: source
        });
    }
    pasteIntoActiveRange(rangeSvc, clipboardData, cellsToFlash, updatedRowNodes, changedPath) {
        const abortRepeatingPasteIntoRows = this.getRangeSize(rangeSvc) % clipboardData.length != 0;
        let indexOffset = 0;
        let dataRowIndex = 0;
        const rowCallback = (currentRow, rowNode, columns, index)=>{
            const selectionColIdx = columns.findIndex((0, $jIDNV.isColumnSelectionCol));
            if (selectionColIdx !== -1) columns.splice(selectionColIdx, 1);
            const atEndOfClipboardData = index - indexOffset >= clipboardData.length;
            if (atEndOfClipboardData) {
                if (abortRepeatingPasteIntoRows) return;
                indexOffset += dataRowIndex;
                dataRowIndex = 0;
            }
            const currentRowData = clipboardData[index - indexOffset];
            updatedRowNodes.push(rowNode);
            const processCellFromClipboardFunc = this.gos.getCallback("processCellFromClipboard");
            for(let idx = 0; idx < columns.length; idx++){
                const column = columns[idx];
                if (!column.isCellEditable(rowNode) || column.isSuppressPaste(rowNode)) continue;
                let calculatedIdx = idx;
                if (idx >= currentRowData.length) calculatedIdx = idx % currentRowData.length;
                const newValue = this.processCell(rowNode, column, currentRowData[calculatedIdx], $5b7ccabde48fae90$var$EXPORT_TYPE_DRAG_COPY, processCellFromClipboardFunc, true);
                this.beans.editSvc?.commitNextEdit();
                rowNode.setDataValue(column, newValue, $5b7ccabde48fae90$var$SOURCE_PASTE);
                changedPath?.addParentNode(rowNode.parent, [
                    column
                ]);
                const { rowIndex: rowIndex, rowPinned: rowPinned } = currentRow;
                const cellId = (0, $jIDNV._createCellId)({
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned
                });
                cellsToFlash[cellId] = true;
            }
            dataRowIndex++;
        };
        this.iterateActiveRanges(false, rowCallback);
    }
    getDisplayedColumnsStartingAt(column) {
        let currentColumn = column;
        const columns = [];
        const { visibleCols: visibleCols } = this.beans;
        while(currentColumn && (0, $jIDNV.isSpecialCol)(currentColumn))currentColumn = visibleCols.getColAfter(currentColumn);
        while(currentColumn != null){
            columns.push(currentColumn);
            currentColumn = visibleCols.getColAfter(currentColumn);
        }
        return columns;
    }
    pasteStartingFromFocusedCell(parsedData, cellsToFlash, updatedRowNodes, focusedCell, changedPath) {
        if (!focusedCell) return;
        const currentRow = {
            rowIndex: focusedCell.rowIndex,
            rowPinned: focusedCell.rowPinned
        };
        const columnsToPasteInto = this.getDisplayedColumnsStartingAt(focusedCell.column);
        if (this.isPasteSingleValueIntoRange(parsedData)) this.pasteSingleValueIntoRange(parsedData, updatedRowNodes, cellsToFlash, changedPath);
        else this.pasteMultipleValues(parsedData, currentRow, updatedRowNodes, columnsToPasteInto, cellsToFlash, $5b7ccabde48fae90$var$EXPORT_TYPE_CLIPBOARD, changedPath);
    }
    // if range is active, and only one cell, then we paste this cell into all cells in the active range.
    isPasteSingleValueIntoRange(parsedData) {
        const rangeSvc = this.beans.rangeSvc;
        return this.hasOnlyOneValueToPaste(parsedData) && !!rangeSvc && !rangeSvc.isEmpty();
    }
    pasteSingleValueIntoRange(parsedData, updatedRowNodes, cellsToFlash, changedPath) {
        const value = parsedData[0][0];
        const rowCallback = (currentRow, rowNode, columns)=>{
            updatedRowNodes.push(rowNode);
            columns.forEach((column)=>this.updateCellValue(rowNode, column, value, cellsToFlash, $5b7ccabde48fae90$var$EXPORT_TYPE_CLIPBOARD, changedPath));
        };
        this.iterateActiveRanges(false, rowCallback);
    }
    hasOnlyOneValueToPaste(parsedData) {
        return parsedData.length === 1 && parsedData[0].length === 1;
    }
    copyRangeDown() {
        const { rangeSvc: rangeSvc, gos: gos, valueSvc: valueSvc } = this.beans;
        if (!rangeSvc || rangeSvc.isEmpty()) return;
        const firstRowValues = [];
        const pasteOperation = (cellsToFlash, updatedRowNodes, focusedCell, changedPath)=>{
            const processCellForClipboardFunc = gos.getCallback("processCellForClipboard");
            const processCellFromClipboardFunc = gos.getCallback("processCellFromClipboard");
            const rowCallback = (currentRow, rowNode, columns)=>{
                if (!firstRowValues.length) columns.forEach((column)=>{
                    const value = this.processCell(rowNode, column, valueSvc.getValue(column, rowNode), $5b7ccabde48fae90$var$EXPORT_TYPE_DRAG_COPY, processCellForClipboardFunc, false, true);
                    firstRowValues.push(value);
                });
                else {
                    updatedRowNodes.push(rowNode);
                    columns.forEach((column, index)=>{
                        if (!column.isCellEditable(rowNode) || column.isSuppressPaste(rowNode)) return;
                        const firstRowValue = this.processCell(rowNode, column, firstRowValues[index], $5b7ccabde48fae90$var$EXPORT_TYPE_DRAG_COPY, processCellFromClipboardFunc, true);
                        this.beans.editSvc?.commitNextEdit();
                        rowNode.setDataValue(column, firstRowValue, $5b7ccabde48fae90$var$SOURCE_PASTE);
                        if (changedPath) changedPath.addParentNode(rowNode.parent, [
                            column
                        ]);
                        const { rowIndex: rowIndex, rowPinned: rowPinned } = currentRow;
                        const cellId = (0, $jIDNV._createCellId)({
                            rowIndex: rowIndex,
                            column: column,
                            rowPinned: rowPinned
                        });
                        cellsToFlash[cellId] = true;
                    });
                }
            };
            this.iterateActiveRanges(true, rowCallback);
        };
        this.doPasteOperation(pasteOperation);
    }
    removeLastLineIfBlank(parsedData) {
        const lastLine = (0, $jIDNV._last)(parsedData);
        const lastLineIsBlank = lastLine && lastLine.length === 1 && lastLine[0] === "";
        if (lastLineIsBlank) {
            if (parsedData.length === 1) return;
            (0, $jIDNV._removeFromArray)(parsedData, lastLine);
        }
    }
    fireRowChanged(rowNodes) {
        if (this.gos.get("editType") !== "fullRow") return;
        rowNodes.forEach((rowNode)=>{
            this.eventSvc.dispatchEvent({
                type: "rowValueChanged",
                node: rowNode,
                data: rowNode.data,
                rowIndex: rowNode.rowIndex,
                rowPinned: rowNode.rowPinned
            });
        });
    }
    pasteMultipleValues(clipboardGridData, currentRow, updatedRowNodes, columnsToPasteInto, cellsToFlash, type, changedPath) {
        let rowPointer = currentRow;
        const beans = this.beans;
        const { gos: gos } = beans;
        const skipGroupRows = this.clientSideRowModel != null && !gos.get("enableGroupEdit") && !gos.get("treeData");
        const getNextGoodRowNode = ()=>{
            while(true){
                if (!rowPointer) return null;
                const res = (0, $jIDNV._getRowNode)(beans, rowPointer);
                rowPointer = (0, $jIDNV._getRowBelow)(beans, {
                    rowPinned: rowPointer.rowPinned,
                    rowIndex: rowPointer.rowIndex
                });
                if (res == null) return null;
                const skipRow = res.detail || res.footer || skipGroupRows && res.group;
                if (!skipRow) return res;
            }
        };
        clipboardGridData.forEach((clipboardRowData)=>{
            const rowNode = getNextGoodRowNode();
            if (!rowNode) return;
            clipboardRowData.forEach((value, index)=>this.updateCellValue(rowNode, columnsToPasteInto[index], value, cellsToFlash, type, changedPath));
            updatedRowNodes.push(rowNode);
        });
    }
    updateCellValue(rowNode, column, value, cellsToFlash, type, changedPath) {
        if (!rowNode || !column || !column.isCellEditable(rowNode) || column.isSuppressPaste(rowNode)) return;
        const processedValue = this.processCell(rowNode, column, value, type, this.gos.getCallback("processCellFromClipboard"), true);
        this.beans.editSvc?.commitNextEdit();
        rowNode.setDataValue(column, processedValue, $5b7ccabde48fae90$var$SOURCE_PASTE);
        const { rowIndex: rowIndex, rowPinned: rowPinned } = rowNode;
        const cellId = (0, $jIDNV._createCellId)({
            rowIndex: rowIndex,
            column: column,
            rowPinned: rowPinned
        });
        cellsToFlash[cellId] = true;
        if (changedPath) changedPath.addParentNode(rowNode.parent, [
            column
        ]);
    }
    copyToClipboard(params = {}) {
        this.copyOrCutToClipboard(params);
    }
    cutToClipboard(params = {}, source = "api") {
        if (this.gos.get("suppressCutToClipboard")) return;
        this.eventSvc.dispatchEvent({
            type: "cutStart",
            source: source
        });
        this.copyOrCutToClipboard(params, true);
        this.eventSvc.dispatchEvent({
            type: "cutEnd",
            source: source
        });
    }
    copyOrCutToClipboard(params, cut) {
        let { includeHeaders: includeHeaders, includeGroupHeaders: includeGroupHeaders } = params;
        const { gos: gos, focusSvc: focusSvc } = this.beans;
        if (includeHeaders == null) includeHeaders = gos.get("copyHeadersToClipboard");
        if (includeGroupHeaders == null) includeGroupHeaders = gos.get("copyGroupHeadersToClipboard");
        const copyParams = {
            includeHeaders: includeHeaders,
            includeGroupHeaders: includeGroupHeaders
        };
        const rowSelection = gos.get("rowSelection");
        const cellSelection = gos.get("cellSelection");
        let cellClearType = null;
        if (this.shouldCopyCells(cellSelection, rowSelection)) {
            this.copySelectedRangeToClipboard(copyParams);
            cellClearType = 0 /* CellRange */ ;
        } else if (this.shouldCopyRows(rowSelection)) {
            this.copySelectedRowsToClipboard(copyParams);
            cellClearType = 1 /* SelectedRows */ ;
        } else if (focusSvc.isAnyCellFocused()) {
            this.copyFocusedCellToClipboard(copyParams);
            cellClearType = 2 /* FocusedCell */ ;
        }
        if (cut && cellClearType !== null) this.clearCellsAfterCopy(cellClearType);
    }
    shouldCopyCells(cellSelection, rowSelection) {
        const { rangeSvc: rangeSvc, selectionSvc: selectionSvc, gos: gos } = this.beans;
        if (!rangeSvc || rangeSvc.isEmpty()) return false;
        if (cellSelection) {
            const shouldCopyRowsInstead = typeof rowSelection === "object" && rowSelection.copySelectedRows && !selectionSvc?.isEmpty();
            return !shouldCopyRowsInstead;
        } else {
            const suppressCopySingleCellRanges = gos.get("suppressCopySingleCellRanges");
            const shouldSkip = !rangeSvc.isMoreThanOneCell() && suppressCopySingleCellRanges;
            return !shouldSkip;
        }
    }
    shouldCopyRows(rowSelection) {
        const { selectionSvc: selectionSvc, gos: gos } = this.beans;
        if (selectionSvc?.isEmpty() ?? true) return false;
        if (rowSelection && typeof rowSelection !== "string") return rowSelection.copySelectedRows ?? false;
        else return !gos.get("suppressCopyRowsToClipboard");
    }
    clearCellsAfterCopy(type) {
        const beans = this.beans;
        const { rangeSvc: rangeSvc, focusSvc: focusSvc, eventSvc: eventSvc } = beans;
        eventSvc.dispatchEvent({
            type: "keyShortcutChangedCellStart"
        });
        if (type === 0 /* CellRange */ ) rangeSvc.clearCellRangeCellValues({
            cellEventSource: "clipboardSvc"
        });
        else if (type === 1 /* SelectedRows */ ) this.clearSelectedRows();
        else {
            const focusedCell = focusSvc.getFocusedCell();
            if (focusedCell == null) return;
            const rowNode = (0, $jIDNV._getRowNode)(beans, focusedCell);
            if (rowNode) this.clearCellValue(rowNode, focusedCell.column);
        }
        eventSvc.dispatchEvent({
            type: "keyShortcutChangedCellEnd"
        });
    }
    clearSelectedRows() {
        const { selectionSvc: selectionSvc, visibleCols: visibleCols } = this.beans;
        const selected = selectionSvc?.getSelectedNodes() ?? [];
        const columns = visibleCols.allCols;
        for (const row of selected)for (const col of columns)this.clearCellValue(row, col);
    }
    clearCellValue(rowNode, column) {
        if (!column.isCellEditable(rowNode)) return;
        const emptyValue = this.beans.valueSvc.getDeleteValue(column, rowNode);
        rowNode.setDataValue(column, emptyValue, "clipboardSvc");
    }
    iterateActiveRanges(onlyFirst, rowCallback, columnCallback) {
        const rangeSvc = this.beans.rangeSvc;
        if (!rangeSvc || rangeSvc.isEmpty()) return;
        const cellRanges = rangeSvc.getCellRanges();
        if (onlyFirst) this.iterateActiveRange(cellRanges[0], rowCallback, columnCallback, true);
        else cellRanges.forEach((range, idx)=>this.iterateActiveRange(range, rowCallback, columnCallback, idx === cellRanges.length - 1));
    }
    iterateActiveRange(range, rowCallback, columnCallback, isLastRange) {
        const { beans: beans } = this;
        const { rangeSvc: rangeSvc } = beans;
        if (!rangeSvc) return;
        let currentRow = rangeSvc.getRangeStartRow(range);
        const lastRow = rangeSvc.getRangeEndRow(range);
        if (columnCallback && range.columns) columnCallback(range.columns);
        let rangeIndex = 0;
        let isLastRow = false;
        while(!isLastRow && currentRow != null){
            const rowNode = (0, $jIDNV._getRowNode)(beans, currentRow);
            isLastRow = (0, $jIDNV._isSameRow)(currentRow, lastRow);
            rowCallback(currentRow, rowNode, range.columns, rangeIndex++, isLastRow && isLastRange);
            currentRow = (0, $jIDNV._getRowBelow)(beans, currentRow);
        }
    }
    copySelectedRangeToClipboard(params = {}) {
        const rangeSvc = this.beans.rangeSvc;
        if (!rangeSvc || rangeSvc.isEmpty()) return;
        const allRangesMerge = rangeSvc.areAllRangesAbleToMerge();
        const { data: data, cellsToFlash: cellsToFlash } = allRangesMerge ? this.buildDataFromMergedRanges(rangeSvc, params) : this.buildDataFromRanges(rangeSvc, params);
        this.copyDataToClipboard(data);
        this.dispatchFlashCells(cellsToFlash);
    }
    buildDataFromMergedRanges(rangeSvc, params) {
        const columnsSet = /* @__PURE__ */ new Set();
        const ranges = rangeSvc.getCellRanges();
        const rowPositionsMap = /* @__PURE__ */ new Map();
        const allRowPositions = [];
        const allCellsToFlash = {};
        ranges.forEach((range)=>{
            range.columns.forEach((col)=>columnsSet.add(col));
            const { rowPositions: rowPositions, cellsToFlash: cellsToFlash } = this.getRangeRowPositionsAndCellsToFlash(rangeSvc, range);
            rowPositions.forEach((rowPosition)=>{
                const rowPositionAsString = `${rowPosition.rowIndex}-${rowPosition.rowPinned || "null"}`;
                if (!rowPositionsMap.get(rowPositionAsString)) {
                    rowPositionsMap.set(rowPositionAsString, true);
                    allRowPositions.push(rowPosition);
                }
            });
            Object.assign(allCellsToFlash, cellsToFlash);
        });
        const allColumns = this.beans.visibleCols.allCols;
        const exportedColumns = Array.from(columnsSet);
        exportedColumns.sort((a, b)=>{
            const posA = allColumns.indexOf(a);
            const posB = allColumns.indexOf(b);
            return posA - posB;
        });
        const data = this.buildExportParams({
            columns: exportedColumns,
            rowPositions: allRowPositions,
            includeHeaders: params.includeHeaders,
            includeGroupHeaders: params.includeGroupHeaders
        });
        return {
            data: data,
            cellsToFlash: allCellsToFlash
        };
    }
    buildDataFromRanges(rangeSvc, params) {
        const ranges = rangeSvc.getCellRanges();
        const data = [];
        const allCellsToFlash = {};
        ranges.forEach((range)=>{
            const { rowPositions: rowPositions, cellsToFlash: cellsToFlash } = this.getRangeRowPositionsAndCellsToFlash(rangeSvc, range);
            Object.assign(allCellsToFlash, cellsToFlash);
            data.push(this.buildExportParams({
                columns: range.columns,
                rowPositions: rowPositions,
                includeHeaders: params.includeHeaders,
                includeGroupHeaders: params.includeGroupHeaders
            }));
        });
        return {
            data: data.join("\n"),
            cellsToFlash: allCellsToFlash
        };
    }
    getRangeRowPositionsAndCellsToFlash(rangeSvc, range) {
        const rowPositions = [];
        const cellsToFlash = {};
        const startRow = rangeSvc.getRangeStartRow(range);
        const lastRow = rangeSvc.getRangeEndRow(range);
        let node = startRow;
        while(node){
            rowPositions.push(node);
            range.columns.forEach((column)=>{
                const { rowIndex: rowIndex, rowPinned: rowPinned } = node;
                const cellId = (0, $jIDNV._createCellId)({
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned
                });
                cellsToFlash[cellId] = true;
            });
            if ((0, $jIDNV._isSameRow)(node, lastRow)) break;
            node = (0, $jIDNV._getRowBelow)(this.beans, node);
        }
        return {
            rowPositions: rowPositions,
            cellsToFlash: cellsToFlash
        };
    }
    getCellsToFlashFromRowNodes(rowNodes) {
        const allDisplayedColumns = this.beans.visibleCols.allCols;
        const cellsToFlash = {};
        for(let i = 0; i < rowNodes.length; i++){
            const { level: level, rowIndex: index, rowPinned: rowPinned, sibling: sibling } = rowNodes[i];
            const rowIndex = level === -1 ? sibling.rowIndex : index;
            if (rowIndex == null) continue;
            for(let j = 0; j < allDisplayedColumns.length; j++){
                const column = allDisplayedColumns[j];
                const cellId = (0, $jIDNV._createCellId)({
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned
                });
                cellsToFlash[cellId] = true;
            }
        }
        return cellsToFlash;
    }
    copyFocusedCellToClipboard(params = {}) {
        let focusedCell = this.beans.focusSvc.getFocusedCell();
        if (focusedCell == null) return;
        focusedCell = this.beans.rowSpanSvc?.getCellStart(focusedCell) ?? focusedCell;
        const cellId = (0, $jIDNV._createCellId)(focusedCell);
        const currentRow = {
            rowPinned: focusedCell.rowPinned,
            rowIndex: focusedCell.rowIndex
        };
        const column = focusedCell.column;
        const data = this.buildExportParams({
            columns: [
                column
            ],
            rowPositions: [
                currentRow
            ],
            includeHeaders: params.includeHeaders,
            includeGroupHeaders: params.includeGroupHeaders
        });
        this.copyDataToClipboard(data);
        this.dispatchFlashCells({
            [cellId]: true
        });
    }
    copySelectedRowsToClipboard(params = {}) {
        const { columnKeys: columnKeys, includeHeaders: includeHeaders, includeGroupHeaders: includeGroupHeaders } = params;
        const data = this.buildExportParams({
            columns: columnKeys,
            includeHeaders: includeHeaders,
            includeGroupHeaders: includeGroupHeaders
        });
        this.copyDataToClipboard(data);
        const rowNodes = this.beans.selectionSvc?.getSelectedNodes() || [];
        this.dispatchFlashCells(this.getCellsToFlashFromRowNodes(rowNodes));
    }
    buildExportParams(params) {
        const { columns: columns, rowPositions: rowPositions, includeHeaders: includeHeaders = false, includeGroupHeaders: includeGroupHeaders = false } = params;
        const { gos: gos, csvCreator: csvCreator } = this.beans;
        const processRowGroupCallback = ({ node: node, column: column })=>{
            const { value: value, valueFormatted: valueFormatted } = this.beans.valueSvc.getValueForDisplay(column, node, true);
            const val = valueFormatted ?? value ?? "";
            const cb = gos.getCallback("processCellForClipboard");
            if (!cb) return val;
            return cb({
                column: column,
                node: node,
                value: val,
                type: $5b7ccabde48fae90$var$EXPORT_TYPE_CLIPBOARD,
                formatValue: (valueToFormat)=>this.beans.valueSvc.formatValue(column, node, valueToFormat) ?? valueToFormat,
                parseValue: (valueToParse)=>this.beans.valueSvc.parseValue(column, node, valueToParse, value) ?? valueToParse
            });
        };
        const exportParams = {
            columnKeys: columns,
            rowPositions: rowPositions,
            skipColumnHeaders: !includeHeaders,
            skipColumnGroupHeaders: !includeGroupHeaders,
            suppressQuotes: true,
            columnSeparator: this.getClipboardDelimiter(),
            onlySelected: !rowPositions,
            processCellCallback: gos.getCallback("processCellForClipboard"),
            processRowGroupCallback: processRowGroupCallback,
            processHeaderCallback: gos.getCallback("processHeaderForClipboard"),
            processGroupHeaderCallback: gos.getCallback("processGroupHeaderForClipboard")
        };
        return csvCreator.getDataAsCsv(exportParams, true);
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    dispatchFlashCells(cellsToFlash) {
        window.setTimeout(()=>{
            this.eventSvc.dispatchEvent({
                type: "flashCells",
                cells: cellsToFlash
            });
        }, 0);
    }
    processCell(rowNode, column, value, type, func, canParse, canFormat) {
        const valueSvc = this.beans.valueSvc;
        if (func) {
            const params = {
                column: column,
                node: rowNode,
                value: value,
                type: type,
                formatValue: (valueToFormat)=>valueSvc.formatValue(column, rowNode ?? null, valueToFormat) ?? valueToFormat,
                parseValue: (valueToParse)=>valueSvc.parseValue(column, rowNode ?? null, valueToParse, valueSvc.getValue(column, rowNode))
            };
            return func(params);
        }
        if (canParse && column.getColDef().useValueParserForImport !== false) return valueSvc.parseValue(column, rowNode ?? null, value, valueSvc.getValue(column, rowNode));
        if (canFormat && column.getColDef().useValueFormatterForExport !== false) return valueSvc.formatValue(column, rowNode ?? null, value) ?? value;
        return value;
    }
    copyDataToClipboard(data) {
        const userProvidedFunc = this.gos.getCallback("sendToClipboard");
        if (userProvidedFunc) {
            userProvidedFunc({
                data: data
            });
            return;
        }
        const allowNavigator = !this.gos.get("suppressClipboardApi");
        if (allowNavigator && navigator.clipboard) {
            navigator.clipboard.writeText(data).catch((e)=>{
                (0, $jIDNV._warn)(40, {
                    e: e,
                    method: "writeText"
                });
                this.copyDataToClipboardLegacy(data);
            });
            return;
        }
        this.copyDataToClipboardLegacy(data);
    }
    copyDataToClipboardLegacy(data) {
        this.executeOnTempElement((element)=>{
            const eDocument = (0, $jIDNV._getDocument)(this.beans);
            const focusedElementBefore = (0, $jIDNV._getActiveDomElement)(this.beans);
            element.value = data || " ";
            element.select();
            element.focus({
                preventScroll: true
            });
            const result = eDocument.execCommand("copy");
            if (!result) (0, $jIDNV._warn)(41);
            if (focusedElementBefore != null && focusedElementBefore.focus != null) focusedElementBefore.focus({
                preventScroll: true
            });
        });
    }
    executeOnTempElement(callbackNow, callbackAfter) {
        if (!this.gridCtrl) return;
        const eDoc = (0, $jIDNV._getDocument)(this.beans);
        const eTempInput = eDoc.createElement("textarea");
        const style = eTempInput.style;
        style.width = "1px";
        style.height = "1px";
        const documentElement = eDoc.documentElement;
        style.top = documentElement.scrollTop + "px";
        style.left = documentElement.scrollLeft + "px";
        style.position = "absolute";
        style.opacity = "0";
        const guiRoot = this.gridCtrl.getGui();
        guiRoot.appendChild(eTempInput);
        try {
            callbackNow(eTempInput);
        } catch (err) {
            (0, $jIDNV._warn)(42);
        }
        if (callbackAfter) window.setTimeout(()=>{
            callbackAfter(eTempInput);
            guiRoot.removeChild(eTempInput);
        }, 100);
        else guiRoot.removeChild(eTempInput);
    }
    getRangeSize(rangeSvc) {
        const ranges = rangeSvc.getCellRanges();
        let startRangeIndex = 0;
        let endRangeIndex = 0;
        if (ranges.length > 0) {
            startRangeIndex = rangeSvc.getRangeStartRow(ranges[0]).rowIndex;
            endRangeIndex = rangeSvc.getRangeEndRow(ranges[0]).rowIndex;
        }
        return startRangeIndex - endRangeIndex + 1;
    }
};
// packages/ag-grid-enterprise/src/clipboard/clipboardModule.ts
var $5b7ccabde48fae90$export$3a36bd45ca02edda = {
    moduleName: "Clipboard",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$ClipboardService
    ],
    apiFunctions: {
        copyToClipboard: $5b7ccabde48fae90$var$copyToClipboard,
        cutToClipboard: $5b7ccabde48fae90$var$cutToClipboard,
        copySelectedRowsToClipboard: $5b7ccabde48fae90$var$copySelectedRowsToClipboard,
        copySelectedRangeToClipboard: $5b7ccabde48fae90$var$copySelectedRangeToClipboard,
        copySelectedRangeDown: $5b7ccabde48fae90$var$copySelectedRangeDown,
        pasteFromClipboard: $5b7ccabde48fae90$var$pasteFromClipboard
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $jIDNV.CsvExportModule),
        (0, $jIDNV._KeyboardNavigationModule),
        (0, $jIDNV.HighlightChangesModule)
    ]
};
// packages/ag-grid-enterprise/src/rowNumbers/rowNumbers.css-GENERATED.ts
var $5b7ccabde48fae90$var$rowNumbersCSS = /*css*/ `.ag-row-number-cell{background-color:var(--ag-header-background-color);border:none;color:var(--ag-header-text-color);font-family:var(--ag-header-font-family);font-size:var(--ag-header-font-size);font-weight:var(--ag-header-font-weight);overflow:hidden;-webkit-user-select:none;-moz-user-select:none;user-select:none;white-space:nowrap;width:100%}:where(.ag-ltr) .ag-row-number-cell{text-align:right}:where(.ag-rtl) .ag-row-number-cell{text-align:left}.ag-row-numbers-resizer{bottom:-2px;cursor:ns-resize;height:4px;position:absolute;width:100%}:where(.ag-ltr) .ag-row-numbers-resizer{left:0}:where(.ag-rtl) .ag-row-numbers-resizer{right:0}.ag-floating-bottom .ag-row-numbers-resizer{bottom:unset;top:-2px}:where(.ag-row-number-header.ag-row-number-selection-enabled){cursor:cell}.ag-row-number-range-highlight{background-color:var(--ag-range-header-highlight-color)}.ag-row-number-range-selected{background-color:var(--ag-row-numbers-selected-color)}:where(.ag-ltr){.ag-row-number-header,:where(.ag-cell.ag-row-number-cell):not(.ag-cell-last-left-pinned){border-right:var(--ag-pinned-column-border)}:where(.ag-cell.ag-row-number-cell.ag-row-number-selection-enabled){cursor:url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxLjUiPjxwYXRoIGQ9Ik0zLjQ0NSA4LjkxMVY3LjQwOUg5Ljc1VjYuMDE0bDIuNTM1IDIuMTQ2LTIuNTM1IDIuMTQ2VjguOTExeiIgc3R5bGU9InN0cm9rZTojZmZmO3N0cm9rZS13aWR0aDouNDFweCIgdHJhbnNmb3JtPSJtYXRyaXgoMS41Nzg0IDAgMCAxLjg2NDI5IC00LjQxMyAtNy4yMTIpIi8+PC9zdmc+"),auto}}:where(.ag-rtl){.ag-row-number-header,:where(.ag-cell.ag-row-number-cell):not(.ag-cell-first-right-pinned){border-left:var(--ag-pinned-column-border)}:where(.ag-cell.ag-row-number-cell.ag-row-number-selection-enabled){cursor:url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxLjUiPjxwYXRoIGQ9Ik01Ljk3OSA4LjkxMXYxLjM5NUwzLjQ0NSA4LjE2bDIuNTM0LTIuMTQ2djEuMzk1aDYuMzA2djEuNTAyeiIgc3R5bGU9InN0cm9rZTojZmZmO3N0cm9rZS13aWR0aDouNDFweCIgdHJhbnNmb3JtPSJtYXRyaXgoMS41Nzg0IDAgMCAxLjg2NDI5IC00LjQxMyAtNy4yMTIpIi8+PC9zdmc+"),auto}}`;
var $5b7ccabde48fae90$var$RowNumbersRowResizerElement = {
    tag: "div",
    cls: "ag-row-numbers-resizer"
};
var $5b7ccabde48fae90$var$AgRowNumbersRowResizer = class extends (0, $jIDNV.Component) {
    constructor(cellCtrl){
        super($5b7ccabde48fae90$var$RowNumbersRowResizerElement);
        this.cellCtrl = cellCtrl;
        this.initialYPosition = -1;
        this.dragging = false;
    }
    postConstruct() {
        const { beans: beans, cellCtrl: cellCtrl } = this;
        const { dragSvc: dragSvc, environment: environment } = beans;
        this.defaultRowHeight = environment.getDefaultRowHeight();
        dragSvc.addDragSource({
            dragStartPixels: 0,
            eElement: this.getGui(),
            onDragStart: this.onDragStart.bind(this),
            onDragging: this.onDragging.bind(this),
            onDragStop: this.onDragStop.bind(this),
            onDragCancel: this.onDragCancel.bind(this),
            includeTouch: true,
            stopPropagationForTouch: true
        });
        const rowPosition = cellCtrl.getRowPosition();
        this.node = (0, $jIDNV._getRowNode)(this.beans, rowPosition);
    }
    onDragStart(mouseEvent) {
        if (!this.node) return;
        const { beans: { ctrlsSvc: ctrlsSvc, eventSvc: eventSvc } } = this;
        const ctrl = ctrlsSvc.get("gridCtrl");
        ctrl.setResizeCursor((0, $jIDNV.Direction).Vertical);
        this.dragging = true;
        this.initialHeight = this.node.rowHeight;
        eventSvc.dispatchEvent({
            type: "rowResizeStarted",
            node: this.node,
            event: mouseEvent,
            rowHeight: this.initialHeight
        });
    }
    onDragging(mouseEvent) {
        let { clientY: clientY } = mouseEvent;
        if (this.cellCtrl.rowNode.rowPinned === "bottom") clientY *= -1;
        if (this.initialYPosition === -1 || !this.dragging) {
            this.initialYPosition = clientY;
            return;
        }
        const { beans: beans, initialHeight: initialHeight, initialYPosition: initialYPosition, defaultRowHeight: defaultRowHeight, node: node } = this;
        if (initialHeight == null) return;
        const currentSize = node?.rowHeight;
        const newSize = Math.max(initialHeight - (initialYPosition - clientY), defaultRowHeight);
        if (currentSize === newSize) return;
        node?.setRowHeight(newSize);
        const { rowRenderer: rowRenderer, rowModel: rowModel, pinnedRowModel: pinnedRowModel } = beans;
        const pinned = !!node?.rowPinned;
        if (pinned) rowRenderer.redraw({
            afterScroll: true
        });
        if (!pinned || pinnedRowModel?.isManual()) rowModel.onRowHeightChanged({
            animate: false
        });
    }
    onDragStop(mouseEvent) {
        this.beans.eventSvc.dispatchEvent({
            type: "rowResizeEnded",
            node: this.node,
            event: mouseEvent,
            rowHeight: this.node?.rowHeight
        });
        this.clearDragDetails(true);
    }
    onDragCancel() {
        this.clearDragDetails(true);
    }
    clearDragDetails(fromDragEvent) {
        this.initialYPosition = -1;
        this.initialHeight = null;
        this.dragging = false;
        if (fromDragEvent) {
            const ctrl = this.beans.ctrlsSvc.get("gridCtrl");
            ctrl.setResizeCursor(false);
        }
    }
    destroy() {
        this.clearDragDetails(false);
        this.node = void 0;
        super.destroy();
    }
};
function $5b7ccabde48fae90$var$_isRowNumbersResizerEnabled(gos) {
    const rowNumbers = gos.get("rowNumbers");
    if (!rowNumbers || typeof rowNumbers !== "object" || !rowNumbers.enableRowResizer) return false;
    return true;
}
var $5b7ccabde48fae90$var$RowNumbersRowResizeFeature = class {
    constructor(beans, cellCtrl){
        this.beans = beans;
        this.cellCtrl = cellCtrl;
    }
    refreshRowResizer() {
        if (!$5b7ccabde48fae90$var$_isRowNumbersResizerEnabled(this.beans.gos) || !this.isRowResizeSupported(this.cellCtrl.rowNode)) this.removeRowResizerFromCellComp();
        else this.addResizerToCellComp();
    }
    isRowResizeSupported(node) {
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel, visibleCols: visibleCols } = this.beans;
        const rowModelModelHasOnRowHeightChanged = !!rowModel.onRowHeightChanged;
        if (visibleCols.autoHeightCols.length) {
            (0, $jIDNV._warn)(276);
            return false;
        }
        if (node.rowPinned != null) return pinnedRowModel?.isManual() ? rowModelModelHasOnRowHeightChanged : true;
        return rowModelModelHasOnRowHeightChanged;
    }
    addResizerToCellComp() {
        const { beans: beans, cellCtrl: cellCtrl } = this;
        const { eGui: eGui } = cellCtrl;
        let { rowResizer: rowResizer } = this;
        if (!rowResizer) {
            rowResizer = beans.registry.createDynamicBean("rowNumberRowResizer", false, cellCtrl);
            if (!rowResizer) return;
            this.rowResizer = beans.context.createBean(rowResizer);
        }
        eGui.appendChild(rowResizer.getGui());
    }
    removeRowResizerFromCellComp() {
        if (!this.rowResizer) return;
        const { eGui: eGui } = this.cellCtrl;
        eGui.removeChild(this.rowResizer.getGui());
        this.rowResizer = this.beans.context.destroyBean(this.rowResizer);
    }
    destroy() {
        this.removeRowResizerFromCellComp();
    }
};
// packages/ag-grid-enterprise/src/rowNumbers/rowNumbersService.ts
var $5b7ccabde48fae90$var$RowNumbersService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "rowNumbersSvc";
        this.isIntegratedWithSelection = false;
        this.lastColumnResized = 0;
    }
    postConstruct() {
        const refreshCells_debounced = (0, $jIDNV._debounce)(this, this.refreshCells.bind(this), 10);
        this.addManagedEventListeners({
            columnResized: ()=>{
                this.lastColumnResized = Date.now();
            },
            modelUpdated: (params)=>{
                refreshCells_debounced(false, !params.keepRenderedRows);
            },
            rangeSelectionChanged: ()=>this.refreshCells(true),
            pinnedRowsChanged: ()=>refreshCells_debounced(false, true)
        });
        this.addManagedPropertyListeners([
            "rowNumbers",
            "cellSelection"
        ], (e)=>{
            this.refreshSelectionIntegration();
            this.updateColumns(e);
        });
        this.refreshSelectionIntegration();
    }
    addColumns(cols) {
        if (this.columns == null) return;
        cols.list = this.columns.list.concat(cols.list);
        cols.tree = this.columns.tree.concat(cols.tree);
        (0, $jIDNV._updateColsMap)(cols);
    }
    createColumns(cols, updateOrders) {
        const destroyCollection = ()=>{
            (0, $jIDNV._destroyColumnTree)(this.beans, this.columns?.tree);
            this.columns = null;
        };
        if (!this.gos.get("rowNumbers")) {
            destroyCollection();
            return;
        }
        const newTreeDepth = cols.treeDepth;
        const oldTreeDepth = this.columns?.treeDepth ?? -1;
        const treeDepthSame = oldTreeDepth == newTreeDepth;
        const list = this.generateRowNumberCols();
        const areSame = (0, $jIDNV._areColIdsEqual)(list, this.columns?.list ?? []);
        if (areSame && treeDepthSame) return;
        destroyCollection();
        const { colGroupSvc: colGroupSvc } = this.beans;
        const treeDepth = colGroupSvc?.findDepth(cols.tree) ?? 0;
        const tree = colGroupSvc?.balanceTreeForAutoCols(list, treeDepth) ?? [];
        this.columns = {
            list: list,
            tree: tree,
            treeDepth: treeDepth,
            map: {}
        };
        const putRowNumbersColsFirstInList = (cols2)=>{
            if (!cols2) return null;
            const colsFiltered = cols2.filter((col)=>!(0, $jIDNV.isRowNumberCol)(col));
            return [
                ...list,
                ...colsFiltered
            ];
        };
        updateOrders(putRowNumbersColsFirstInList);
    }
    handleMouseDownOnCell(cellPosition, mouseEvent) {
        if (!this.isIntegratedWithSelection || mouseEvent.target.classList.contains("ag-row-numbers-resizer")) return false;
        if (!mouseEvent.shiftKey && !(0, $jIDNV._interpretAsRightClick)(this.beans, mouseEvent)) setTimeout(()=>{
            this.focusFirstRenderedCellAtRowPosition(cellPosition);
        });
        return true;
    }
    updateColumns(event) {
        const source = (0, $jIDNV._convertColumnEventSourceType)(event.source);
        this.refreshSelectionIntegration();
        this.columns?.list.forEach((col)=>{
            const newColDef = this.createRowNumbersColDef();
            col.setColDef(newColDef, null, source);
            (0, $jIDNV._applyColumnState)(this.beans, {
                state: [
                    {
                        colId: col.getColId(),
                        ...newColDef
                    }
                ]
            }, source);
        });
    }
    getColumn() {
        return this.columns?.list.find((0, $jIDNV.isRowNumberCol)) ?? null;
    }
    getColumns() {
        return this.columns?.list ?? null;
    }
    setupForHeader(comp) {
        const { column: column, eGridHeader: eGridHeader } = comp.params;
        if (!(0, $jIDNV.isRowNumberCol)(column)) return;
        (0, $jIDNV._setAriaLabel)(eGridHeader, "Row Number");
        this.addManagedElementListeners(eGridHeader, {
            click: this.onHeaderClick.bind(this),
            keydown: this.onHeaderKeyDown.bind(this),
            focus: this.onHeaderFocus.bind(this)
        });
    }
    createRowNumbersRowResizerFeature(beans, ctrl) {
        if (!$5b7ccabde48fae90$var$_isRowNumbersResizerEnabled(this.gos)) return void 0;
        return new $5b7ccabde48fae90$var$RowNumbersRowResizeFeature(beans, ctrl);
    }
    refreshSelectionIntegration() {
        const { beans: beans } = this;
        const { gos: gos, rangeSvc: rangeSvc } = beans;
        const cellSelection = gos.get("cellSelection");
        this.refreshRowNumberOverrides();
        this.isIntegratedWithSelection = !!rangeSvc && !!cellSelection && !this.isSuppressCellSelectionIntegration;
    }
    refreshRowNumberOverrides() {
        const rowNumbers = this.gos.get("rowNumbers");
        this.rowNumberOverrides = {};
        if (!rowNumbers || typeof rowNumbers !== "object") return;
        if (rowNumbers.suppressCellSelectionIntegration) this.isSuppressCellSelectionIntegration = true;
        const colDefValidProps = [
            "contextMenuItems",
            "context",
            "onCellClicked",
            "onCellContextMenu",
            "onCellDoubleClicked",
            "headerTooltip",
            "headerStyle",
            "headerComponent",
            "headerComponentParams",
            "suppressHeaderKeyboardEvent",
            "tooltipField",
            "tooltipValueGetter",
            "tooltipComponent",
            "tooltipComponentParams",
            "valueGetter",
            "valueFormatter",
            "width",
            "maxWidth",
            "minWidth",
            "resizable"
        ];
        for (const prop of colDefValidProps)if (rowNumbers[prop] != null) this.rowNumberOverrides[prop] = rowNumbers[prop];
    }
    onHeaderFocus() {
        this.beans.ariaAnnounce?.announceValue("Press Space to select all cells", "ariaSelectAllCells");
    }
    onHeaderKeyDown(e) {
        if (!this.isIntegratedWithSelection || e.key !== (0, $jIDNV.KeyCode).SPACE) return;
        (0, $jIDNV._selectAllCells)(this.beans);
    }
    onHeaderClick(_e) {
        if (Date.now() - this.lastColumnResized < 100 || !this.isIntegratedWithSelection || this.getColumn()?.resizing) return;
        (0, $jIDNV._selectAllCells)(this.beans);
    }
    refreshCells(force, runAutoSize) {
        const column = this.getColumn();
        if (!column) return;
        if (runAutoSize) {
            const width = this.beans.autoWidthCalc?.getPreferredWidthForElements([
                this.createDummyElement(column)
            ], 2);
            if (width != null) this.beans.colResize?.setColumnWidths([
                {
                    key: column,
                    newWidth: width
                }
            ], false, true, "rowNumbersService");
        }
        this.beans.rowRenderer.refreshCells({
            columns: [
                column
            ],
            force: force
        });
    }
    createDummyElement(column) {
        const div = (0, $jIDNV._createElement)({
            tag: "div",
            cls: "ag-cell-value ag-cell"
        });
        let value = String(this.beans.rowModel.getRowCount() + 1);
        if (typeof this.rowNumberOverrides.valueFormatter === "function") {
            const valueFormatterParams = (0, $jIDNV._addGridCommonParams)(this.beans.gos, {
                data: void 0,
                value: value,
                node: null,
                column: column,
                colDef: column.colDef
            });
            value = this.rowNumberOverrides.valueFormatter(valueFormatterParams);
        }
        div.textContent = value;
        return div;
    }
    createRowNumbersColDef() {
        const { gos: gos, contextMenuSvc: contextMenuSvc } = this.beans;
        const enableRTL = gos.get("enableRtl");
        return {
            // overridable properties
            minWidth: 60,
            width: 60,
            resizable: false,
            valueGetter: this.valueGetter,
            contextMenuItems: this.isIntegratedWithSelection || !contextMenuSvc ? void 0 : ()=>[],
            // overrides
            ...this.rowNumberOverrides,
            // non-overridable properties
            colId: (0, $jIDNV.ROW_NUMBERS_COLUMN_ID),
            chartDataType: "excluded",
            suppressHeaderMenuButton: true,
            sortable: false,
            suppressMovable: true,
            lockPinned: true,
            pinned: enableRTL ? "right" : "left",
            lockPosition: enableRTL ? "right" : "left",
            editable: false,
            suppressFillHandle: true,
            suppressAutoSize: true,
            suppressSizeToFit: true,
            suppressHeaderContextMenu: true,
            suppressNavigable: true,
            headerClass: this.getHeaderClass(),
            cellClass: this.getCellClass.bind(this),
            cellAriaRole: "rowheader"
        };
    }
    valueGetter(params) {
        const node = params.node;
        if (node?.rowPinned && node.pinnedSibling) {
            const { rowIndex: rowIndex } = node.pinnedSibling;
            return `${rowIndex == null ? "-" : rowIndex + 1}`;
        }
        return String((node?.rowIndex || 0) + 1);
    }
    getHeaderClass() {
        const cssClass = [
            "ag-row-number-header"
        ];
        if (this.isIntegratedWithSelection) cssClass.push("ag-row-number-selection-enabled");
        return cssClass;
    }
    getCellClass(params) {
        const { beans: beans } = this;
        const { rangeSvc: rangeSvc, gos: gos } = beans;
        const { node: node } = params;
        const cssClasses = [
            "ag-row-number-cell"
        ];
        const cellSelection = gos.get("cellSelection");
        if (!rangeSvc || !cellSelection) return cssClasses;
        if (this.isIntegratedWithSelection) cssClasses.push("ag-row-number-selection-enabled");
        const ranges = rangeSvc.getCellRanges();
        if (!ranges.length) return cssClasses;
        const allColsLen = this.beans.visibleCols.allCols.length - 1;
        const shouldHighlight = typeof cellSelection === "object" && cellSelection.enableHeaderHighlight;
        for (const range of ranges)if (rangeSvc.isRowInRange(node.rowIndex, node.rowPinned, range)) {
            if (shouldHighlight) cssClasses.push("ag-row-number-range-highlight");
            if (range.columns.length === allColsLen) cssClasses.push("ag-row-number-range-selected");
        }
        return cssClasses;
    }
    generateRowNumberCols() {
        const { gos: gos } = this;
        if (!gos.get("rowNumbers")) return [];
        const colDef = this.createRowNumbersColDef();
        const colId = colDef.colId;
        gos.validateColDef(colDef, colId, true);
        const col = new (0, $jIDNV.AgColumn)(colDef, null, colId, false);
        this.createBean(col);
        return [
            col
        ];
    }
    // focus is disabled on the Row Numbers cells, when a click happens on it,
    // it should focus the first cell of that row.
    focusFirstRenderedCellAtRowPosition(rowPosition) {
        const { beans: beans, gos: gos } = this;
        const { visibleCols: visibleCols, colViewport: colViewport } = beans;
        const pinnedCols = gos.get("enableRtl") ? visibleCols.rightCols : visibleCols.leftCols;
        let columns;
        if (pinnedCols.length == 1) {
            const rowNode = (0, $jIDNV._getRowNode)(beans, rowPosition);
            if (!rowNode) return;
            columns = colViewport.getColsWithinViewport(rowNode);
        } else columns = pinnedCols;
        const column = columns.find((col)=>!(0, $jIDNV.isRowNumberCol)(col));
        if (!column) return;
        const { rowPinned: rowPinned, rowIndex: rowIndex } = rowPosition;
        beans.focusSvc.setFocusedCell({
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            column: column,
            forceBrowserFocus: true,
            preventScrollOnBrowserFocus: true
        });
    }
    destroy() {
        (0, $jIDNV._destroyColumnTree)(this.beans, this.columns?.tree);
        this.rowNumberOverrides = null;
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/rowNumbers/rowNumbersModule.ts
var $5b7ccabde48fae90$export$f0e5f58d7c17c748 = {
    moduleName: "RowNumbers",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$RowNumbersService
    ],
    dynamicBeans: {
        rowNumberRowResizer: $5b7ccabde48fae90$var$AgRowNumbersRowResizer
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $jIDNV.CellStyleModule),
        (0, $jIDNV._SharedDragAndDropModule)
    ],
    css: [
        $5b7ccabde48fae90$var$rowNumbersCSS
    ]
};
var $5b7ccabde48fae90$var$AgFiltersToolPanelHeaderElement = {
    tag: "div",
    cls: "ag-filter-toolpanel-search",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eExpand",
            cls: "ag-filter-toolpanel-expand"
        },
        {
            tag: "ag-input-text-field",
            ref: "eFilterTextField",
            cls: "ag-filter-toolpanel-search-input"
        }
    ]
};
var $5b7ccabde48fae90$var$AgFiltersToolPanelHeader = class extends (0, $jIDNV.Component) {
    constructor(){
        super(...arguments);
        this.eExpand = (0, $jIDNV.RefPlaceholder);
        this.eFilterTextField = (0, $jIDNV.RefPlaceholder);
    }
    postConstruct() {
        this.setTemplate($5b7ccabde48fae90$var$AgFiltersToolPanelHeaderElement, [
            (0, $jIDNV.AgInputTextFieldSelector)
        ]);
        const translate = this.getLocaleTextFunc();
        this.eFilterTextField.setAutoComplete(false).setInputAriaLabel(translate("ariaFilterColumnsInput", "Filter Columns Input")).onValueChange(this.onSearchTextChanged.bind(this));
        this.createExpandIcons();
        this.setExpandState(0 /* EXPANDED */ );
        this.addManagedElementListeners(this.eExpand, {
            click: this.onExpandClicked.bind(this)
        });
        this.addManagedEventListeners({
            newColumnsLoaded: this.showOrHideOptions.bind(this)
        });
    }
    init(params) {
        this.params = params;
        if (this.beans.colModel.ready) this.showOrHideOptions();
    }
    createExpandIcons() {
        const { eExpand: eExpand, beans: beans } = this;
        eExpand.appendChild(this.eExpandChecked = (0, $jIDNV._createIconNoSpan)("accordionOpen", beans));
        eExpand.appendChild(this.eExpandUnchecked = (0, $jIDNV._createIconNoSpan)("accordionClosed", beans));
        eExpand.appendChild(this.eExpandIndeterminate = (0, $jIDNV._createIconNoSpan)("accordionIndeterminate", beans));
    }
    // we only show expand / collapse if we are showing filters
    showOrHideOptions() {
        const { params: params, eFilterTextField: eFilterTextField } = this;
        const showFilterSearch = !params.suppressFilterSearch;
        const showExpand = !params.suppressExpandAll;
        const translate = this.getLocaleTextFunc();
        eFilterTextField.setInputPlaceholder(translate("searchOoo", "Search..."));
        const isFilterGroupPresent = (col)=>col.getOriginalParent() && col.isFilterAllowed();
        const filterGroupsPresent = this.beans.colModel.getCols().some(isFilterGroupPresent);
        (0, $jIDNV._setDisplayed)(eFilterTextField.getGui(), showFilterSearch);
        (0, $jIDNV._setDisplayed)(this.eExpand, showExpand && filterGroupsPresent);
    }
    onSearchTextChanged() {
        if (!this.onSearchTextChangedDebounced) this.onSearchTextChangedDebounced = (0, $jIDNV._debounce)(this, ()=>this.dispatchLocalEvent({
                type: "searchChanged",
                searchText: this.eFilterTextField.getValue()
            }), 300);
        this.onSearchTextChangedDebounced();
    }
    onExpandClicked() {
        const event = this.currentExpandState === 0 /* EXPANDED */  ? {
            type: "collapseAll"
        } : {
            type: "expandAll"
        };
        this.dispatchLocalEvent(event);
    }
    setExpandState(state) {
        this.currentExpandState = state;
        (0, $jIDNV._setDisplayed)(this.eExpandChecked, state === 0 /* EXPANDED */ );
        (0, $jIDNV._setDisplayed)(this.eExpandUnchecked, state === 1 /* COLLAPSED */ );
        (0, $jIDNV._setDisplayed)(this.eExpandIndeterminate, state === 2 /* INDETERMINATE */ );
    }
};
var $5b7ccabde48fae90$var$AgFiltersToolPanelHeaderSelector = {
    selector: "AG-FILTERS-TOOL-PANEL-HEADER",
    component: $5b7ccabde48fae90$var$AgFiltersToolPanelHeader
};
var $5b7ccabde48fae90$var$ToolPanelFilterElement = {
    tag: "div",
    cls: "ag-filter-toolpanel-instance",
    children: [
        {
            tag: "div",
            ref: "eFilterToolPanelHeader",
            cls: "ag-filter-toolpanel-header ag-filter-toolpanel-instance-header",
            role: "button",
            attrs: {
                "aria-expanded": "false"
            },
            children: [
                {
                    tag: "div",
                    ref: "eExpand",
                    cls: "ag-filter-toolpanel-expand"
                },
                {
                    tag: "span",
                    ref: "eFilterName",
                    cls: "ag-header-cell-text"
                },
                {
                    tag: "span",
                    ref: "eFilterIcon",
                    cls: "ag-header-icon ag-filter-icon ag-filter-toolpanel-instance-header-icon",
                    attrs: {
                        "aria-hidden": "true"
                    }
                }
            ]
        },
        {
            tag: "div",
            ref: "agFilterToolPanelBody",
            cls: "ag-filter-toolpanel-instance-body ag-filter"
        }
    ]
};
var $5b7ccabde48fae90$var$ToolPanelFilterComp = class extends (0, $jIDNV.Component) {
    constructor(hideHeader, expandedCallback){
        super($5b7ccabde48fae90$var$ToolPanelFilterElement);
        this.hideHeader = hideHeader;
        this.expandedCallback = expandedCallback;
        this.eFilterToolPanelHeader = (0, $jIDNV.RefPlaceholder);
        this.eFilterName = (0, $jIDNV.RefPlaceholder);
        this.agFilterToolPanelBody = (0, $jIDNV.RefPlaceholder);
        this.eFilterIcon = (0, $jIDNV.RefPlaceholder);
        this.eExpand = (0, $jIDNV.RefPlaceholder);
        this.expanded = false;
    }
    postConstruct() {
        const { beans: beans, eExpand: eExpand } = this;
        const eExpandChecked = (0, $jIDNV._createIconNoSpan)("accordionOpen", beans);
        this.eExpandChecked = eExpandChecked;
        const eExpandUnchecked = (0, $jIDNV._createIconNoSpan)("accordionClosed", beans);
        this.eExpandUnchecked = eExpandUnchecked;
        eExpand.appendChild(eExpandChecked);
        eExpand.appendChild(eExpandUnchecked);
    }
    setColumn(column) {
        this.column = column;
        const { beans: beans, eFilterToolPanelHeader: eFilterToolPanelHeader, eFilterIcon: eFilterIcon, eExpandChecked: eExpandChecked, hideHeader: hideHeader } = this;
        this.eFilterName.innerText = beans.colNames.getDisplayNameForColumn(column, "filterToolPanel", false) || "";
        this.addManagedListeners(eFilterToolPanelHeader, {
            click: this.toggleExpanded.bind(this),
            keydown: this.onKeyDown.bind(this)
        });
        this.addManagedEventListeners({
            filterOpened: this.onFilterOpened.bind(this)
        });
        this.addInIcon("filterActive", eFilterIcon, column);
        (0, $jIDNV._setDisplayed)(eFilterIcon, this.isFilterActive(), {
            skipAriaHidden: true
        });
        (0, $jIDNV._setDisplayed)(eExpandChecked, false);
        if (hideHeader) {
            (0, $jIDNV._setDisplayed)(eFilterToolPanelHeader, false);
            eFilterToolPanelHeader.removeAttribute("tabindex");
        } else eFilterToolPanelHeader.setAttribute("tabindex", "0");
        this.addManagedListeners(column, {
            filterChanged: this.onFilterChanged.bind(this)
        });
    }
    onKeyDown(e) {
        const { key: key } = e;
        const { ENTER: ENTER, SPACE: SPACE, LEFT: LEFT, RIGHT: RIGHT } = (0, $jIDNV.KeyCode);
        if (key !== ENTER && key !== SPACE && key !== LEFT && key !== RIGHT) return;
        e.preventDefault();
        if (key === ENTER || key === SPACE) this.toggleExpanded();
        else if (key === (0, $jIDNV.KeyCode).LEFT) this.collapse();
        else this.expand();
    }
    getColumn() {
        return this.column;
    }
    getColumnFilterName() {
        return this.beans.colNames.getDisplayNameForColumn(this.column, "filterToolPanel", false);
    }
    addCssClassToTitleBar(cssClass) {
        this.eFilterToolPanelHeader.classList.add(cssClass);
    }
    addInIcon(iconName, eParent, column) {
        if (eParent == null) return;
        const eIcon = (0, $jIDNV._createIconNoSpan)(iconName, this.beans, column);
        eParent.appendChild(eIcon);
    }
    isFilterActive() {
        return !!this.beans.colFilter?.isFilterActive(this.column);
    }
    onFilterChanged() {
        (0, $jIDNV._setDisplayed)(this.eFilterIcon, this.isFilterActive(), {
            skipAriaHidden: true
        });
        this.dispatchLocalEvent({
            type: "filterChanged"
        });
    }
    toggleExpanded() {
        this.expanded ? this.collapse() : this.expand();
    }
    expand() {
        if (this.expanded) return;
        this.expanded = true;
        (0, $jIDNV._setAriaExpanded)(this.eFilterToolPanelHeader, true);
        (0, $jIDNV._setDisplayed)(this.eExpandChecked, true);
        (0, $jIDNV._setDisplayed)(this.eExpandUnchecked, false);
        this.addFilterElement();
        this.expandedCallback();
    }
    addFilterElement(suppressFocus) {
        const filterPanelWrapper = (0, $jIDNV._createElement)({
            tag: "div",
            cls: "ag-filter-toolpanel-instance-filter"
        });
        const comp = this.createManagedBean(new (0, $jIDNV.FilterComp)(this.column, "TOOLBAR"));
        this.filterComp = comp;
        if (!comp.hasFilter()) return;
        comp.getFilter()?.then((filter)=>{
            this.underlyingFilter = filter;
            if (!filter) return;
            filterPanelWrapper.appendChild(comp.getGui());
            this.agFilterToolPanelBody.appendChild(filterPanelWrapper);
            comp.afterGuiAttached({
                container: "toolPanel",
                suppressFocus: suppressFocus
            });
        });
    }
    collapse() {
        if (!this.expanded) return;
        this.expanded = false;
        (0, $jIDNV._setAriaExpanded)(this.eFilterToolPanelHeader, false);
        this.removeFilterElement();
        (0, $jIDNV._setDisplayed)(this.eExpandChecked, false);
        (0, $jIDNV._setDisplayed)(this.eExpandUnchecked, true);
        const filterComp = this.filterComp;
        filterComp?.afterGuiDetached();
        this.destroyBean(filterComp);
        this.expandedCallback();
    }
    removeFilterElement() {
        (0, $jIDNV._clearElement)(this.agFilterToolPanelBody);
    }
    isExpanded() {
        return this.expanded;
    }
    onPanelHidden() {
        if (!this.expanded) return;
        const filter = this.underlyingFilter;
        if (!filter) return;
        filter.afterGuiDetached?.();
    }
    onFilterOpened(event) {
        if (event.source !== "COLUMN_MENU") return;
        if (event.column !== this.column) return;
        if (!this.expanded) return;
        this.collapse();
    }
};
var $5b7ccabde48fae90$var$ToolPanelFilterGroupComp = class extends (0, $jIDNV.Component) {
    constructor(columnGroup, childFilterComps, expandedCallback, depth, showingColumn){
        super();
        this.columnGroup = columnGroup;
        this.childFilterComps = childFilterComps;
        this.expandedCallback = expandedCallback;
        this.depth = depth;
        this.showingColumn = showingColumn;
        this.filterGroupComp = (0, $jIDNV.RefPlaceholder);
    }
    postConstruct() {
        const groupParams = {
            cssIdentifier: "filter-toolpanel",
            direction: "vertical"
        };
        this.setTemplate({
            tag: "div",
            cls: "ag-filter-toolpanel-group-wrapper",
            children: [
                {
                    tag: "ag-group-component",
                    ref: "filterGroupComp"
                }
            ]
        }, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector
        ], {
            filterGroupComp: groupParams
        });
        this.setGroupTitle();
        const { filterGroupComp: filterGroupComp, depth: depth, childFilterComps: childFilterComps, gos: gos } = this;
        filterGroupComp.setAlignItems("stretch");
        filterGroupComp.addCss(`ag-filter-toolpanel-group-level-${depth}`);
        filterGroupComp.getGui().style.setProperty("--ag-indentation-level", String(depth));
        filterGroupComp.addCssClassToTitleBar(`ag-filter-toolpanel-group-level-${depth}-header`);
        childFilterComps.forEach((filterComp)=>{
            filterGroupComp.addItem(filterComp);
            filterComp.addCssClassToTitleBar(`ag-filter-toolpanel-group-level-${depth + 1}-header`);
            filterComp.getGui().style.setProperty("--ag-indentation-level", String(depth + 1));
        });
        const column = this.showingColumn ? this.columnGroup : void 0;
        this.tooltipFeature = this.createOptionalManagedBean(this.beans.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.getGui(),
            getLocation: ()=>"filterToolPanelColumnGroup",
            shouldDisplayTooltip: (0, $jIDNV._getShouldDisplayTooltip)(gos, ()=>filterGroupComp.getGui().querySelector(".ag-group-title")),
            getColDef: column ? ()=>column.getColDef() : void 0,
            getColumn: column ? ()=>column : void 0
        }));
        this.refreshFilterClass();
        this.addExpandCollapseListeners();
        this.addFilterChangedListeners();
        this.setupTooltip();
        this.addInIcon("filterActive");
    }
    setupTooltip() {
        if (!this.showingColumn) return;
        const refresh = ()=>{
            this.tooltipFeature?.setTooltipAndRefresh(this.columnGroup.getColDef().headerTooltip);
        };
        refresh();
        this.addManagedEventListeners({
            newColumnsLoaded: refresh
        });
    }
    addCssClassToTitleBar(cssClass) {
        this.filterGroupComp.addCssClassToTitleBar(cssClass);
    }
    onPanelHidden() {
        this.childFilterComps.forEach((filterComp)=>filterComp.onPanelHidden());
    }
    isColumnGroup() {
        return (0, $jIDNV.isProvidedColumnGroup)(this.columnGroup);
    }
    isExpanded() {
        return this.filterGroupComp.isExpanded();
    }
    getChildren() {
        return this.childFilterComps;
    }
    getFilterGroupName() {
        return this.filterGroupName ?? "";
    }
    getFilterGroupId() {
        return this.columnGroup.getId();
    }
    hideGroupItem(hide, index) {
        this.filterGroupComp.hideItem(hide, index);
    }
    hideGroup(hide) {
        this.setDisplayed(!hide);
    }
    addInIcon(iconName) {
        const eIcon = (0, $jIDNV._createIconNoSpan)(iconName, this.beans);
        if (eIcon) eIcon.classList.add("ag-filter-toolpanel-group-instance-header-icon");
        this.filterGroupComp.addTitleBarWidget(eIcon);
    }
    forEachToolPanelFilterChild(action) {
        this.childFilterComps.forEach((filterComp)=>{
            if (filterComp instanceof $5b7ccabde48fae90$var$ToolPanelFilterComp) action(filterComp);
        });
    }
    addExpandCollapseListeners() {
        const expandListener = this.isColumnGroup() ? ()=>this.expandedCallback() : ()=>this.forEachToolPanelFilterChild((filterComp)=>filterComp.expand());
        const collapseListener = this.isColumnGroup() ? ()=>this.expandedCallback() : ()=>this.forEachToolPanelFilterChild((filterComp)=>filterComp.collapse());
        this.addManagedListeners(this.filterGroupComp, {
            expanded: expandListener,
            collapsed: collapseListener
        });
    }
    getColumns() {
        if ((0, $jIDNV.isProvidedColumnGroup)(this.columnGroup)) return this.columnGroup.getLeafColumns();
        return [
            this.columnGroup
        ];
    }
    addFilterChangedListeners() {
        this.getColumns().forEach((column)=>{
            this.addManagedListeners(column, {
                filterChanged: ()=>this.refreshFilterClass()
            });
        });
        if (!(0, $jIDNV.isProvidedColumnGroup)(this.columnGroup)) this.addManagedEventListeners({
            filterOpened: this.onFilterOpened.bind(this)
        });
    }
    refreshFilterClass() {
        const columns = this.getColumns();
        const anyChildFiltersActive = ()=>columns.some((col)=>col.isFilterActive());
        this.filterGroupComp.toggleCss("ag-has-filter", anyChildFiltersActive());
    }
    onFilterOpened(event) {
        if (event.source !== "COLUMN_MENU") return;
        if (event.column !== this.columnGroup) return;
        if (!this.isExpanded()) return;
        this.collapse();
    }
    expand() {
        this.filterGroupComp.toggleGroupExpand(true);
    }
    collapse() {
        this.filterGroupComp.toggleGroupExpand(false);
    }
    setGroupTitle() {
        const columnGroup = this.columnGroup;
        const filterGroupName = (0, $jIDNV.isProvidedColumnGroup)(columnGroup) ? this.getColumnGroupName(columnGroup) : this.getColumnName(columnGroup);
        this.filterGroupName = filterGroupName;
        this.filterGroupComp.setTitle(filterGroupName || "");
    }
    getColumnGroupName(columnGroup) {
        return this.beans.colNames.getDisplayNameForProvidedColumnGroup(null, columnGroup, "filterToolPanel");
    }
    getColumnName(column) {
        return this.beans.colNames.getDisplayNameForColumn(column, "filterToolPanel", false);
    }
    destroyFilters() {
        this.childFilterComps = this.destroyBeans(this.childFilterComps);
        (0, $jIDNV._clearElement)(this.getGui());
    }
    destroy() {
        this.destroyFilters();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/filterToolPanel/agFiltersToolPanelList.ts
var $5b7ccabde48fae90$var$AgFiltersToolPanelList = class extends (0, $jIDNV.Component) {
    constructor(){
        super({
            tag: "div",
            cls: "ag-filter-list-panel"
        });
        this.initialised = false;
        this.hasLoadedInitialState = false;
        this.isInitialState = false;
        this.filterGroupComps = [];
        // If a column drag is happening, we suppress handling the event until it has completed
        this.suppressOnColumnsChanged = false;
        this.onColumnsChangedPending = false;
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
    }
    init(params) {
        this.initialised = true;
        const defaultParams = (0, $jIDNV._addGridCommonParams)(this.gos, {
            suppressExpandAll: false,
            suppressFilterSearch: false,
            suppressSyncLayoutWithGrid: false
        });
        (0, $jIDNV._mergeDeep)(defaultParams, params);
        this.params = defaultParams;
        if (!defaultParams.suppressSyncLayoutWithGrid) this.addManagedEventListeners({
            columnMoved: ()=>this.onColumnsChanged()
        });
        this.addManagedEventListeners({
            newColumnsLoaded: ()=>this.onColumnsChanged(),
            toolPanelVisibleChanged: (event)=>{
                if (event.key === "filters" && !event.visible) this.onPanelHidden();
            },
            dragStarted: ()=>{
                this.suppressOnColumnsChanged = true;
            },
            dragStopped: ()=>{
                this.suppressOnColumnsChanged = false;
                if (this.onColumnsChangedPending) {
                    this.onColumnsChangedPending = false;
                    this.onColumnsChanged();
                }
            }
        });
        if (this.colModel.ready) this.onColumnsChanged();
    }
    onColumnsChanged() {
        if (this.suppressOnColumnsChanged) {
            this.onColumnsChangedPending = true;
            return;
        }
        const pivotModeActive = this.colModel.isPivotMode();
        const shouldSyncColumnLayoutWithGrid = !this.params.suppressSyncLayoutWithGrid && !pivotModeActive;
        shouldSyncColumnLayoutWithGrid ? this.syncFilterLayout() : this.buildTreeFromProvidedColumnDefs();
        this.refreshAriaLabel();
    }
    syncFilterLayout() {
        $5b7ccabde48fae90$var$syncLayoutWithGrid(this.colModel, this.setFiltersLayout.bind(this));
        this.refreshAriaLabel();
    }
    buildTreeFromProvidedColumnDefs() {
        const columnTree = this.colModel.getColDefColTree();
        this.recreateFilters(columnTree);
    }
    setFiltersLayout(colDefs) {
        const columnTree = $5b7ccabde48fae90$var$toolPanelCreateColumnTree(this.colModel, colDefs);
        this.recreateFilters(columnTree);
    }
    recreateFilters(columnTree) {
        const activeElement = (0, $jIDNV._getActiveDomElement)(this.beans);
        if (!this.hasLoadedInitialState) {
            this.hasLoadedInitialState = true;
            this.isInitialState = !!this.params.initialState;
        }
        const expansionState = this.getExpansionState();
        this.destroyFilters();
        const filterGroupComps = this.recursivelyAddComps(columnTree, 0, expansionState);
        this.filterGroupComps = filterGroupComps;
        const len = filterGroupComps.length;
        if (len) {
            filterGroupComps.forEach((comp)=>this.appendChild(comp));
            this.setFirstAndLastVisible(0, len - 1);
        }
        const searchFilterText = this.searchFilterText;
        if ((0, $jIDNV._exists)(searchFilterText)) this.searchFilters(searchFilterText);
        this.fireExpandedEvent();
        if (this.getGui().contains(activeElement)) activeElement.focus();
        this.isInitialState = false;
        this.refreshAriaLabel();
    }
    recursivelyAddComps(tree, depth, expansionState) {
        return tree.map((child)=>{
            if ((0, $jIDNV.isProvidedColumnGroup)(child)) return this.recursivelyAddFilterGroupComps(child, depth, expansionState)?.flatMap((a)=>a) ?? [];
            const column = child;
            if (!this.shouldDisplayFilter(column)) return [];
            const hideFilterCompHeader = depth === 0;
            const filterComp = new $5b7ccabde48fae90$var$ToolPanelFilterComp(hideFilterCompHeader, ()=>this.onFilterExpanded());
            this.createBean(filterComp);
            filterComp.setColumn(column);
            if (expansionState.get(column.getId())) filterComp.expand();
            if (depth > 0) return filterComp;
            const filterGroupComp = this.createBean(new $5b7ccabde48fae90$var$ToolPanelFilterGroupComp(column, [
                filterComp
            ], this.onGroupExpanded.bind(this), depth, true));
            filterGroupComp.addCssClassToTitleBar("ag-filter-toolpanel-header");
            if (!expansionState.get(filterGroupComp.getFilterGroupId())) filterGroupComp.collapse();
            return filterGroupComp;
        }).flatMap((a)=>a);
    }
    refreshAriaLabel() {
        const translate = this.getLocaleTextFunc();
        const filterListName = translate("ariaFilterPanelList", "Filter List");
        const localeFilters = translate("filters", "Filters");
        const eGui = this.getGui();
        const groupSelector = ".ag-filter-toolpanel-group-wrapper";
        const itemSelector = ".ag-filter-toolpanel-group-item";
        const hiddenSelector = ".ag-hidden";
        const visibleItems = eGui.querySelectorAll(`${itemSelector}:not(${groupSelector}, ${hiddenSelector})`);
        const totalVisibleItems = visibleItems.length;
        (0, $jIDNV._setAriaLabel)(this.getAriaElement(), `${filterListName} ${totalVisibleItems} ${localeFilters}`);
    }
    recursivelyAddFilterGroupComps(columnGroup, depth, expansionState) {
        if (!this.filtersExistInChildren(columnGroup.getChildren())) return;
        const colGroupDef = columnGroup.getColGroupDef();
        if (colGroupDef && colGroupDef.suppressFiltersToolPanel) return [];
        const newDepth = columnGroup.isPadding() ? depth : depth + 1;
        const childFilterComps = this.recursivelyAddComps(columnGroup.getChildren(), newDepth, expansionState).flatMap((a)=>a);
        if (columnGroup.isPadding()) return childFilterComps;
        const filterGroupComp = new $5b7ccabde48fae90$var$ToolPanelFilterGroupComp(columnGroup, childFilterComps, this.onGroupExpanded.bind(this), depth, false);
        this.createBean(filterGroupComp);
        filterGroupComp.addCssClassToTitleBar("ag-filter-toolpanel-header");
        const expansionStateValue = expansionState.get(filterGroupComp.getFilterGroupId());
        if (this.isInitialState && !expansionStateValue || expansionStateValue === false) filterGroupComp.collapse();
        return [
            filterGroupComp
        ];
    }
    filtersExistInChildren(tree) {
        return tree.some((child)=>{
            if ((0, $jIDNV.isProvidedColumnGroup)(child)) return this.filtersExistInChildren(child.getChildren());
            return this.shouldDisplayFilter(child);
        });
    }
    shouldDisplayFilter(column) {
        const suppressFiltersToolPanel = column.getColDef() && column.getColDef().suppressFiltersToolPanel;
        return column.isFilterAllowed() && !suppressFiltersToolPanel;
    }
    getExpansionState() {
        const expansionState = /* @__PURE__ */ new Map();
        if (this.isInitialState) {
            const { expandedColIds: expandedColIds, expandedGroupIds: expandedGroupIds } = this.params.initialState;
            expandedColIds.forEach((id)=>expansionState.set(id, true));
            expandedGroupIds.forEach((id)=>expansionState.set(id, true));
            return expansionState;
        }
        const recursiveGetExpansionState = (filterGroupComp)=>{
            expansionState.set(filterGroupComp.getFilterGroupId(), filterGroupComp.isExpanded());
            filterGroupComp.getChildren().forEach((child)=>{
                if (child instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp) recursiveGetExpansionState(child);
                else expansionState.set(child.getColumn().getId(), child.isExpanded());
            });
        };
        this.filterGroupComps.forEach(recursiveGetExpansionState);
        return expansionState;
    }
    // we don't support refreshing, but must implement because it's on the tool panel interface
    refresh() {}
    // lazy initialise the panel
    setVisible(visible) {
        super.setDisplayed(visible);
        if (visible && !this.initialised) this.init(this.params);
    }
    expandFilterGroups(expand, groupIds) {
        const updatedGroupIds = [];
        const updateGroupExpandState = (filterGroup)=>{
            const groupId = filterGroup.getFilterGroupId();
            const shouldExpandOrCollapse = !groupIds || groupIds.includes(groupId);
            if (shouldExpandOrCollapse) {
                if (expand && filterGroup.isColumnGroup()) filterGroup.expand();
                else filterGroup.collapse();
                updatedGroupIds.push(groupId);
            }
            filterGroup.getChildren().forEach((child)=>{
                if (child instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp) updateGroupExpandState(child);
            });
        };
        this.filterGroupComps.forEach(updateGroupExpandState);
        this.onGroupExpanded();
        if (groupIds) {
            const unrecognisedGroupIds = groupIds.filter((groupId)=>updatedGroupIds.indexOf(groupId) < 0);
            if (unrecognisedGroupIds.length > 0) (0, $jIDNV._warn)(166, {
                unrecognisedGroupIds: unrecognisedGroupIds
            });
        }
    }
    expandFilters(expand, colIds) {
        const updatedColIds = [];
        const updateGroupExpandState = (filterComp)=>{
            if (filterComp instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp) {
                let anyChildrenChanged = false;
                filterComp.getChildren().forEach((child)=>{
                    const childUpdated = updateGroupExpandState(child);
                    if (childUpdated) {
                        if (expand) {
                            filterComp.expand();
                            anyChildrenChanged = true;
                        } else if (!filterComp.isColumnGroup()) filterComp.collapse();
                    }
                });
                return anyChildrenChanged;
            }
            const colId = filterComp.getColumn().getColId();
            const updateFilterExpandState = !colIds || colIds.includes(colId);
            if (updateFilterExpandState) {
                expand ? filterComp.expand() : filterComp.collapse();
                updatedColIds.push(colId);
            }
            return updateFilterExpandState;
        };
        this.filterGroupComps.forEach(updateGroupExpandState);
        this.onGroupExpanded();
        if (colIds) {
            const unrecognisedColIds = colIds.filter((colId)=>updatedColIds.indexOf(colId) < 0);
            if (unrecognisedColIds.length > 0) (0, $jIDNV._warn)(167, {
                unrecognisedColIds: unrecognisedColIds
            });
        }
    }
    onGroupExpanded() {
        this.fireExpandedEvent();
    }
    onFilterExpanded() {
        this.dispatchLocalEvent({
            type: "filterExpanded"
        });
    }
    fireExpandedEvent() {
        let expandedCount = 0;
        let notExpandedCount = 0;
        const updateExpandCounts = (filterGroup)=>{
            if (!filterGroup.isColumnGroup()) return;
            filterGroup.isExpanded() ? expandedCount++ : notExpandedCount++;
            filterGroup.getChildren().forEach((child)=>{
                if (child instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp) updateExpandCounts(child);
            });
        };
        this.filterGroupComps.forEach(updateExpandCounts);
        let state;
        if (expandedCount > 0 && notExpandedCount > 0) state = 2 /* INDETERMINATE */ ;
        else if (notExpandedCount > 0) state = 1 /* COLLAPSED */ ;
        else state = 0 /* EXPANDED */ ;
        this.dispatchLocalEvent({
            type: "groupExpanded",
            state: state
        });
    }
    performFilterSearch(searchText) {
        this.searchFilterText = (0, $jIDNV._exists)(searchText) ? searchText.toLowerCase() : null;
        this.searchFilters(this.searchFilterText);
    }
    searchFilters(searchFilter) {
        const passesFilter = (groupName)=>{
            return !(0, $jIDNV._exists)(searchFilter) || groupName.toLowerCase().indexOf(searchFilter) !== -1;
        };
        const recursivelySearch = (filterItem, parentPasses)=>{
            if (!(filterItem instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp)) return passesFilter(filterItem.getColumnFilterName() || "");
            const children = filterItem.getChildren();
            const groupNamePasses = passesFilter(filterItem.getFilterGroupName());
            const alreadyPassed = parentPasses || groupNamePasses;
            if (alreadyPassed) {
                filterItem.hideGroup(false);
                for(let i = 0; i < children.length; i++){
                    recursivelySearch(children[i], alreadyPassed);
                    filterItem.hideGroupItem(false, i);
                }
                return true;
            }
            let anyChildPasses = false;
            children.forEach((child, index)=>{
                const childPasses = recursivelySearch(child, parentPasses);
                filterItem.hideGroupItem(!childPasses, index);
                if (childPasses) anyChildPasses = true;
            });
            filterItem.hideGroup(!anyChildPasses);
            return anyChildPasses;
        };
        let firstVisible;
        let lastVisible;
        this.filterGroupComps.forEach((filterGroup, idx)=>{
            recursivelySearch(filterGroup, false);
            const isHidden = filterGroup.getGui()?.classList.contains("ag-hidden");
            if (firstVisible === void 0) {
                if (!isHidden) {
                    firstVisible = idx;
                    lastVisible = idx;
                }
            } else if (!isHidden && lastVisible !== idx) lastVisible = idx;
        });
        this.setFirstAndLastVisible(firstVisible, lastVisible);
        this.refreshAriaLabel();
    }
    setFirstAndLastVisible(firstIdx, lastIdx) {
        this.filterGroupComps.forEach((filterGroup, idx)=>{
            filterGroup.removeCss("ag-first-group-visible");
            filterGroup.removeCss("ag-last-group-visible");
            if (idx === firstIdx) filterGroup.addCss("ag-first-group-visible");
            if (idx === lastIdx) filterGroup.addCss("ag-last-group-visible");
        });
    }
    onPanelHidden() {
        this.filterGroupComps.forEach((filterGroupComp)=>filterGroupComp.onPanelHidden());
    }
    getExpandedFiltersAndGroups() {
        const expandedGroupIds = [];
        const expandedColIds = /* @__PURE__ */ new Set();
        const getExpandedFiltersAndGroups = (filterComp)=>{
            if (filterComp instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp) {
                filterComp.getChildren().forEach((child)=>getExpandedFiltersAndGroups(child));
                const groupId = filterComp.getFilterGroupId();
                if (filterComp.isExpanded() && !expandedColIds.has(groupId)) expandedGroupIds.push(groupId);
            } else if (filterComp.isExpanded()) expandedColIds.add(filterComp.getColumn().getColId());
        };
        this.filterGroupComps.forEach(getExpandedFiltersAndGroups);
        return {
            expandedGroupIds: expandedGroupIds,
            expandedColIds: Array.from(expandedColIds)
        };
    }
    destroyFilters() {
        this.filterGroupComps = this.destroyBeans(this.filterGroupComps);
        (0, $jIDNV._clearElement)(this.getGui());
    }
    destroy() {
        this.destroyFilters();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$AgFiltersToolPanelListSelector = {
    selector: "AG-FILTERS-TOOL-PANEL-LIST",
    component: $5b7ccabde48fae90$var$AgFiltersToolPanelList
};
// packages/ag-grid-enterprise/src/filterToolPanel/filtersToolPanel.css-GENERATED.ts
var $5b7ccabde48fae90$var$filtersToolPanelCSS = /*css*/ `.ag-filter-toolpanel{flex:1 1 0px;min-width:0}.ag-filter-toolpanel-header,.ag-filter-toolpanel-search{align-items:center;color:var(--ag-header-text-color);display:flex;font-weight:var(--ag-header-font-weight);padding:0 var(--ag-spacing);>*{align-items:center;display:flex}}.ag-filter-toolpanel-header{padding-bottom:var(--ag-spacing);padding-top:var(--ag-spacing);position:relative;&:focus-visible{border-radius:var(--ag-border-radius);box-shadow:inset var(--ag-focus-shadow)}}:where(.ag-ltr) .ag-filter-toolpanel-group-instance-header-icon,:where(.ag-ltr) .ag-filter-toolpanel-instance-header-icon{margin-left:var(--ag-spacing)}:where(.ag-rtl) .ag-filter-toolpanel-group-instance-header-icon,:where(.ag-rtl) .ag-filter-toolpanel-instance-header-icon{margin-right:var(--ag-spacing)}.ag-filter-toolpanel-search{min-height:var(--ag-header-height);padding-bottom:var(--ag-spacing);padding-top:var(--ag-widget-container-vertical-padding)}:where(.ag-filter-toolpanel-group:not(.ag-has-filter)>.ag-group-title-bar) .ag-filter-toolpanel-group-instance-header-icon{display:none}.ag-filter-toolpanel-search-input{flex-grow:1;height:calc(var(--ag-spacing)*4)}:where(.ag-ltr) .ag-filter-toolpanel-group-title-bar-icon{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-filter-toolpanel-group-title-bar-icon{margin-left:var(--ag-spacing)}.ag-filter-toolpanel-expand{cursor:pointer}:where(.ag-ltr) .ag-filter-toolpanel-expand{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-filter-toolpanel-expand{margin-left:var(--ag-spacing)}:where(.ag-ltr) .ag-filter-toolpanel-group-title-bar,:where(.ag-ltr) .ag-filter-toolpanel-instance-header{padding-left:calc(var(--ag-spacing) + var(--ag-filter-tool-panel-group-indent)*var(--ag-indentation-level))}:where(.ag-rtl) .ag-filter-toolpanel-group-title-bar,:where(.ag-rtl) .ag-filter-toolpanel-instance-header{padding-right:calc(var(--ag-spacing) + var(--ag-filter-tool-panel-group-indent)*var(--ag-indentation-level))}:where(.ag-ltr) .ag-filter-toolpanel-instance-body{margin-left:var(--ag-filter-tool-panel-group-indent)}:where(.ag-rtl) .ag-filter-toolpanel-instance-body{margin-right:var(--ag-filter-tool-panel-group-indent)}.ag-filter-toolpanel-instance-filter{background-color:var(--ag-chrome-background-color)}.ag-filter-toolpanel-group-level-0{border-top:none}`;
// packages/ag-grid-enterprise/src/filterToolPanel/filtersToolPanel.ts
var $5b7ccabde48fae90$var$FiltersToolPanelElement = {
    tag: "div",
    cls: "ag-filter-toolpanel",
    children: [
        {
            tag: "ag-filters-tool-panel-header",
            ref: "filtersToolPanelHeaderPanel"
        },
        {
            tag: "ag-filters-tool-panel-list",
            ref: "filtersToolPanelListPanel"
        }
    ]
};
var $5b7ccabde48fae90$var$FiltersToolPanel = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$FiltersToolPanelElement, [
            $5b7ccabde48fae90$var$AgFiltersToolPanelHeaderSelector,
            $5b7ccabde48fae90$var$AgFiltersToolPanelListSelector
        ]);
        this.filtersToolPanelHeaderPanel = (0, $jIDNV.RefPlaceholder);
        this.filtersToolPanelListPanel = (0, $jIDNV.RefPlaceholder);
        this.initialised = false;
        this.listenerDestroyFuncs = [];
        this.registerCSS($5b7ccabde48fae90$var$filtersToolPanelCSS);
    }
    init(params) {
        if (this.initialised) {
            this.listenerDestroyFuncs.forEach((func)=>func());
            this.listenerDestroyFuncs = [];
        }
        this.initialised = true;
        const defaultParams = {
            suppressExpandAll: false,
            suppressFilterSearch: false,
            suppressSyncLayoutWithGrid: false
        };
        const newParams = {
            ...defaultParams,
            ...params
        };
        this.params = newParams;
        const { filtersToolPanelHeaderPanel: filtersToolPanelHeaderPanel, filtersToolPanelListPanel: filtersToolPanelListPanel } = this;
        filtersToolPanelHeaderPanel.init(newParams);
        filtersToolPanelListPanel.init(newParams);
        const { suppressExpandAll: hideExpand, suppressFilterSearch: hideSearch } = newParams;
        if (hideExpand && hideSearch) filtersToolPanelHeaderPanel.setDisplayed(false);
        this.listenerDestroyFuncs.push(...this.addManagedListeners(filtersToolPanelHeaderPanel, {
            expandAll: ()=>filtersToolPanelListPanel.expandFilterGroups(true),
            collapseAll: ()=>filtersToolPanelListPanel.expandFilterGroups(false),
            searchChanged: (event)=>filtersToolPanelListPanel.performFilterSearch(event.searchText)
        }), ...this.addManagedListeners(filtersToolPanelListPanel, {
            filterExpanded: newParams.onStateUpdated,
            groupExpanded: (event)=>{
                filtersToolPanelHeaderPanel.setExpandState(event.state);
                newParams.onStateUpdated();
            }
        }));
    }
    // lazy initialise the panel
    setVisible(visible) {
        super.setDisplayed(visible);
        if (visible && !this.initialised) this.init(this.params);
    }
    setFilterLayout(colDefs) {
        this.filtersToolPanelListPanel.setFiltersLayout(colDefs);
    }
    expandFilterGroups(groupIds) {
        this.filtersToolPanelListPanel.expandFilterGroups(true, groupIds);
    }
    collapseFilterGroups(groupIds) {
        this.filtersToolPanelListPanel.expandFilterGroups(false, groupIds);
    }
    expandFilters(colIds) {
        this.filtersToolPanelListPanel.expandFilters(true, colIds);
    }
    collapseFilters(colIds) {
        this.filtersToolPanelListPanel.expandFilters(false, colIds);
    }
    syncLayoutWithGrid() {
        this.filtersToolPanelListPanel.syncFilterLayout();
    }
    refresh(params) {
        this.init(params);
        return true;
    }
    getState() {
        return this.filtersToolPanelListPanel.getExpandedFiltersAndGroups();
    }
};
var $5b7ccabde48fae90$var$FilterPanelService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "filterPanelSvc";
        this.states = /* @__PURE__ */ new Map();
        this.orderedStates = [];
        this.initialStateApplied = false;
        this.isActive = false;
    }
    postConstruct() {
        if (!this.gos.get("enableFilterHandlers")) return;
        const updateFilterStates = this.updateFilterStates.bind(this);
        const updateApplyButton = ()=>this.dispatchStatesUpdates(void 0, true);
        this.addManagedEventListeners({
            newColumnsLoaded: ()=>{
                this.applyInitialState();
                updateFilterStates();
            },
            filterChanged: updateFilterStates,
            filterDestroyed: this.onFilterDestroyed.bind(this),
            filterOpened: updateApplyButton,
            filterClosed: updateApplyButton
        });
        this.addManagedListeners(this.beans.colFilter, {
            filterStateChanged: ({ column: column })=>{
                this.states.get(column.getColId())?.refresh?.();
                updateApplyButton();
            }
        });
    }
    getIds() {
        return Array.from(this.states.keys());
    }
    getAvailable() {
        const beans = this.beans;
        const availableFilters = [];
        for (const column of beans.colModel.getCols()){
            const id = column.getColId();
            if (column.isFilterAllowed() && !column.colDef.suppressFiltersToolPanel && !this.states.get(id)) availableFilters.push({
                id: id,
                name: $5b7ccabde48fae90$var$getDisplayName(beans, column)
            });
        }
        return availableFilters;
    }
    add(id) {
        this.createFilter(id, true);
        this.dispatchStatesUpdates(id);
    }
    remove(id) {
        const { states: states, orderedStates: orderedStates, beans: { colFilter: colFilter, selectableFilter: selectableFilter } } = this;
        const state = states.get(id);
        if (!state) return;
        state.destroy?.();
        const column = state.state.column;
        states.delete(id);
        selectableFilter?.clearActive(id);
        colFilter?.destroyFilter(column);
        this.eventSvc.dispatchEvent({
            type: "filterSwitched",
            column: column
        });
        const index = orderedStates.indexOf(id);
        orderedStates.splice(index, 1);
        const newActiveId = orderedStates[index];
        this.dispatchStatesUpdates(newActiveId);
    }
    getState(id) {
        return this.states.get(id)?.state;
    }
    updateFilterState(id, key, value, suppressEvents) {
        const filterState = this.getState(id);
        if (!filterState) return;
        filterState[key] = value;
        if (!suppressEvents) this.dispatchLocalEvent({
            type: "filterPanelStateChanged",
            id: id,
            state: filterState
        });
    }
    expand(id, expanded) {
        const existingFilterState = this.states.get(id);
        if (!existingFilterState) return;
        existingFilterState.destroy?.();
        const { handler: handler, state: { column: column } } = existingFilterState;
        const newFilterState = this.createFilterState(column, handler, expanded);
        this.states.set(id, newFilterState);
        this.dispatchLocalEvent({
            type: "filterPanelStateChanged",
            id: id,
            state: newFilterState.state
        });
    }
    updateType(id, filterDef) {
        const stateWrapper = this.states.get(id);
        if (!stateWrapper) return;
        const state = stateWrapper.state;
        if (state.expanded === false) return;
        const filterDefs = state.filterDefs;
        if (!filterDefs) return;
        const { colFilter: colFilter, selectableFilter: selectableFilter } = this.beans;
        selectableFilter?.setActive(id, filterDefs, filterDef);
        colFilter.filterParamsChanged(id, "columnFilter");
        const column = state.column;
        this.eventSvc.dispatchEvent({
            type: "filterSwitched",
            column: column
        });
        const newStateWrapper = this.states.get(id);
        if (!newStateWrapper) return;
        const newState = newStateWrapper.state;
        this.dispatchLocalEvent({
            type: "filterPanelStateChanged",
            id: id,
            state: newState
        });
    }
    getActions() {
        const actions = this.params?.buttons;
        if (!actions?.length) return void 0;
        const canApply = !!this.beans.colFilter?.canApplyAll();
        return {
            actions: actions,
            canApply: canApply
        };
    }
    doAction(action) {
        this.beans.colFilter?.updateAllModels(action);
    }
    updateParams(params, initialState) {
        this.params = params;
        if (initialState) this.initialState = initialState;
        this.dispatchStatesUpdates();
        this.beans.colFilter?.setGlobalButtons(!!params.buttons?.length);
    }
    getGridState() {
        const filters = [];
        this.states.forEach((stateWrapper, colId)=>{
            filters.push({
                colId: colId,
                expanded: stateWrapper.state.expanded
            });
        });
        return {
            filters: filters
        };
    }
    createFilter(id, expanded) {
        const stateWrapper = this.createFilterStateWrapper(id, expanded);
        if (stateWrapper) {
            this.states.set(id, stateWrapper);
            this.orderedStates.push(id);
        }
    }
    createFilterStateWrapper(id, expanded) {
        const { colModel: colModel, colFilter: colFilter } = this.beans;
        const column = colModel.getColById(id);
        if (column && !column.colDef.suppressFiltersToolPanel) {
            const handler = colFilter.getHandler(column, true);
            if (handler) return this.createFilterState(column, handler, expanded);
        }
        return void 0;
    }
    updateFilterStates() {
        const filterModel = this.beans.colFilter.getModel();
        const processedIds = /* @__PURE__ */ new Set();
        for (const id of Object.keys(filterModel)){
            const existingState = this.states.get(id);
            if (!existingState) this.createFilter(id);
            else existingState.refresh?.();
            processedIds.add(id);
        }
        this.states.forEach((state, id)=>{
            if (!processedIds.has(id)) state.refresh?.();
        });
        this.dispatchStatesUpdates();
    }
    createFilterState(column, handler, expanded) {
        const beans = this.beans;
        const { colFilter: colFilter, selectableFilter: selectableFilter } = beans;
        const name = $5b7ccabde48fae90$var$getDisplayName(beans, column);
        const colId = column.getColId();
        const getIsEditing = ()=>!!this.params?.buttons && colFilter.hasUnappliedModel(colId);
        const isEditing = getIsEditing();
        if (expanded) {
            const colDef = column.colDef;
            const { filterDefs: filterDefs, activeFilterDef: activeFilterDef } = selectableFilter?.getDefs(column, colDef) ?? {};
            const filterComp = this.createBean(new (0, $jIDNV.FilterComp)(column, "TOOLBAR", true));
            return {
                state: {
                    column: column,
                    name: name,
                    isEditing: isEditing,
                    expanded: expanded,
                    detail: filterComp.getGui(),
                    activeFilterDef: activeFilterDef,
                    filterDefs: filterDefs,
                    afterGuiAttached: filterComp.afterGuiAttached.bind(filterComp),
                    afterGuiDetached: filterComp.afterGuiDetached.bind(filterComp)
                },
                handler: handler,
                refresh: ()=>{
                    this.updateFilterState(colId, "isEditing", getIsEditing());
                },
                destroy: ()=>this.destroyBean(filterComp)
            };
        } else {
            const colId2 = column.getColId();
            const getSummary = ()=>handler.getModelAsString?.(colFilter.getStateForColumn(colId2).model, "filterToolPanel") ?? "";
            return {
                state: {
                    column: column,
                    name: name,
                    isEditing: isEditing,
                    expanded: false,
                    summary: getSummary()
                },
                handler: handler,
                refresh: ()=>{
                    this.updateFilterState(colId2, "isEditing", getIsEditing(), true);
                    this.updateFilterState(colId2, "summary", getSummary());
                }
            };
        }
    }
    onFilterDestroyed({ column: column, source: source }) {
        if (!this.beans.colFilter?.isAlive()) return;
        const states = this.states;
        const id = column.getColId();
        const existingState = states.get(id);
        if (existingState) {
            const stateWrapper = this.createFilterStateWrapper(id, existingState.state.expanded);
            if (stateWrapper) {
                existingState.destroy?.();
                states.set(id, stateWrapper);
            } else this.remove(id);
            if (source === "api") this.dispatchStatesUpdates();
        }
    }
    dispatchStatesUpdates(activeId, action) {
        this.dispatchLocalEvent({
            type: "filterPanelStatesChanged",
            activeId: activeId,
            action: action
        });
    }
    applyInitialState() {
        if (this.initialStateApplied) return;
        this.initialStateApplied = true;
        this.initialState?.filters?.forEach(({ colId: colId, expanded: expanded })=>this.createFilter(colId, expanded));
        this.initialState = void 0;
    }
    destroy() {
        const { states: states, orderedStates: orderedStates } = this;
        states.forEach((state)=>state.destroy?.());
        states.clear();
        orderedStates.length = 0;
        this.params = void 0;
        this.initialState = void 0;
        super.destroy();
    }
};
function $5b7ccabde48fae90$var$getDisplayName(beans, column) {
    return beans.colNames.getDisplayNameForColumn(column, "filterToolPanel") ?? column.getColId();
}
var $5b7ccabde48fae90$var$DEFAULT_LOCALE_TEXT2 = {
    addFilterCard: "Add Filter",
    ariaLabelAddFilterField: "Add Filter Field",
    ariaLabelFilterCardDelete: "Delete Filter",
    ariaLabelFilterCardHasEdits: "Has Edits",
    agTextColumnFilterDisplayName: "Simple Filter",
    agNumberColumnFilterDisplayName: "Simple Filter",
    agDateColumnFilterDisplayName: "Simple Filter",
    agSetColumnFilterDisplayName: "Selection Filter",
    agMultiColumnFilterDisplayName: "Combo Filter",
    addFilterPlaceholder: "Search columns..."
};
function $5b7ccabde48fae90$var$translateForFilterPanel(bean, key) {
    return (0, $jIDNV._translate)(bean, $5b7ccabde48fae90$var$DEFAULT_LOCALE_TEXT2, key);
}
function $5b7ccabde48fae90$var$compareAndUpdateListsInDom(eContainer, eNewItems, ePrevItems) {
    let newIndex = 0;
    for(let prevIndex = 0; prevIndex < ePrevItems.length; prevIndex++){
        const ePrevItem = ePrevItems[prevIndex];
        if (ePrevItem === eNewItems[newIndex]) newIndex++;
        else (0, $jIDNV._removeFromParent)(ePrevItem);
    }
    while(newIndex < eNewItems.length)eContainer.appendChild(eNewItems[newIndex++]);
}
// packages/ag-grid-enterprise/src/filterToolPanel/newFilterToolPanel/selectableFilterService.ts
var $5b7ccabde48fae90$var$SelectableFilterService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "selectableFilter";
        this.selectedFilters = /* @__PURE__ */ new Map();
        this.valueGetters = /* @__PURE__ */ new Map();
    }
    getFilterValueGetter(colId) {
        return this.valueGetters.get(colId);
    }
    isSelectable(filterDef) {
        return filterDef.filter === "agSelectableColumnFilter";
    }
    getFilterDef(column, filterDef) {
        return this.getDefs(column, filterDef).activeFilterDef;
    }
    getDefs(column, filterDef) {
        if (!this.isSelectable(filterDef)) return void 0;
        const beans = this.beans;
        const { gos: gos, dataTypeSvc: dataTypeSvc, colFilter: colFilter } = beans;
        let filterParams = filterDef.filterParams;
        const colDef = column.colDef;
        if (typeof filterParams === "function") filterParams = filterParams((0, $jIDNV._addGridCommonParams)(gos, {
            column: column,
            colDef: colDef
        }));
        const cellDataType = dataTypeSvc?.getBaseDataType(column);
        const dataTypeDefinition = dataTypeSvc?.getDataTypeDefinition(column);
        const formatValue = dataTypeSvc?.getFormatValue(cellDataType);
        const { filters: filters, defaultFilterParams: defaultFilterParams, defaultFilterIndex: defaultFilterIndex } = filterParams ?? {};
        const updateDef = (def)=>{
            const { filter: filter, filterParams: defFilterParams, name: name, filterValueGetter: filterValueGetter = colDef.filterValueGetter } = def;
            const userParams = defaultFilterParams ? {
                ...defaultFilterParams,
                ...defFilterParams
            } : defFilterParams;
            let updatedParams;
            if (dataTypeDefinition && formatValue) {
                if (filter === "agMultiColumnFilter") updatedParams = beans.multiFilter?.getParamsForDataType(userParams, filterValueGetter, dataTypeDefinition, formatValue);
                else updatedParams = (0, $jIDNV._getFilterParamsForDataType)(filter, userParams, filterValueGetter, dataTypeDefinition, formatValue, beans, this.getLocaleTextFunc());
            }
            let updatedName;
            if (!name) {
                let filterString = filter;
                if (typeof filter === "boolean") filterString = colFilter?.getDefaultFilterFromDataType(()=>cellDataType);
                if (typeof filterString === "string") updatedName = $5b7ccabde48fae90$var$translateForFilterPanel(this, `${filterString}DisplayName`);
                else {
                    (0, $jIDNV._warn)(280, {
                        colId: column.getColId()
                    });
                    updatedName = "";
                }
            }
            if (defaultFilterParams || updatedParams || updatedName) return {
                ...def,
                filterParams: userParams,
                name: updatedName ?? name,
                ...updatedParams
            };
            return def;
        };
        const filterDefs = (filters ?? this.getDefaultFilters(column)).map(updateDef);
        let index = this.selectedFilters.get(column.getColId()) ?? // UI selected value
        defaultFilterIndex ?? // col def value
        (!filters && (0, $jIDNV._isSetFilterByDefault)(gos) ? 1 : 0);
        if (index >= filterDefs.length) index = 0;
        const activeFilterDef = filterDefs[index];
        return {
            filterDefs: filterDefs,
            activeFilterDef: activeFilterDef
        };
    }
    setActive(colId, filterDefs, activeFilterDef) {
        const index = filterDefs.indexOf(activeFilterDef);
        if (index < 0) return;
        const { selectedFilters: selectedFilters, valueGetters: valueGetters } = this;
        selectedFilters.set(colId, index);
        const filterValueGetter = activeFilterDef.filterValueGetter;
        if (filterValueGetter) valueGetters.set(colId, filterValueGetter);
        else valueGetters.delete(colId);
    }
    clearActive(colId) {
        const { selectedFilters: selectedFilters, valueGetters: valueGetters } = this;
        selectedFilters.delete(colId);
        valueGetters.delete(colId);
    }
    destroy() {
        const { selectedFilters: selectedFilters, valueGetters: valueGetters } = this;
        selectedFilters.clear();
        valueGetters.clear();
        super.destroy();
    }
    getDefaultFilters(column) {
        const beans = this.beans;
        const { gos: gos, dataTypeSvc: dataTypeSvc } = beans;
        const isMultiFilterEnabled = gos.isModuleRegistered("MultiFilter");
        const cellDataType = dataTypeSvc?.getBaseDataType(column);
        const simpleFilter = (0, $jIDNV._getDefaultSimpleFilter)(cellDataType, false);
        return [
            {
                filter: simpleFilter
            },
            {
                filter: "agSetColumnFilter"
            },
            ...isMultiFilterEnabled ? [
                {
                    filter: "agMultiColumnFilter"
                }
            ] : []
        ];
    }
};
var $5b7ccabde48fae90$var$AddFilterElement = {
    tag: "div",
    cls: "ag-filter-card ag-filter-card-add"
};
var $5b7ccabde48fae90$var$AddFilterComp = class extends (0, $jIDNV.Component) {
    constructor(options){
        super($5b7ccabde48fae90$var$AddFilterElement);
        this.options = /* @__PURE__ */ new Map();
        this.setOptions(options);
    }
    postConstruct() {
        this.showButton();
    }
    refresh(newOptions) {
        this.setOptions(newOptions);
        const { eSelect: eSelect, options: options } = this;
        if (eSelect) eSelect.setValueList({
            valueList: Array.from(options.keys()),
            refresh: true
        });
    }
    showButton() {
        (0, $jIDNV._clearElement)(this.getGui());
        this.destroySelect();
        const eButton = (0, $jIDNV._createElement)({
            tag: "button",
            cls: "ag-button ag-standard-button ag-filter-add-button",
            children: [
                {
                    tag: "span",
                    children: [
                        ()=>(0, $jIDNV._createIconNoSpan)("filterAdd", this.beans)
                    ]
                },
                {
                    tag: "span",
                    cls: "ag-filter-add-button-label",
                    children: $5b7ccabde48fae90$var$translateForFilterPanel(this, "addFilterCard")
                }
            ]
        });
        this.activateTabIndex([
            eButton
        ]);
        const clickListener = this.showSelect.bind(this);
        eButton.addEventListener("click", clickListener);
        this.removeButton = ()=>{
            eButton.removeEventListener("click", clickListener);
        };
        this.appendChild(eButton);
        eButton.focus();
    }
    showSelect() {
        (0, $jIDNV._clearElement)(this.getGui());
        this.destroyButton();
        const pickerAriaLabelKey = "ariaLabelAddFilterField";
        const selectParams = {
            className: "ag-filter-add-select",
            pickerType: "virtual-list",
            pickerAriaLabelKey: pickerAriaLabelKey,
            pickerAriaLabelValue: $5b7ccabde48fae90$var$translateForFilterPanel(this, pickerAriaLabelKey),
            placeholder: $5b7ccabde48fae90$var$translateForFilterPanel(this, "addFilterPlaceholder"),
            value: "",
            valueList: Array.from(this.options.keys()),
            searchType: "matchAny",
            allowTyping: true,
            filterList: true,
            highlightMatch: true,
            valueFormatter: (value)=>this.options.get(value)
        };
        const eSelect = this.createManagedBean(new $5b7ccabde48fae90$var$AgRichSelect(selectParams));
        this.eSelect = eSelect;
        this.appendChild(eSelect.getGui());
        eSelect.showPicker();
        eSelect.getFocusableElement().focus();
        eSelect.addManagedListeners(eSelect, {
            fieldPickerValueSelected: ({ value: id })=>this.dispatchLocalEvent({
                    type: "filterSelected",
                    id: id
                }),
            pickerHidden: ()=>{
                this.showButton();
            }
        });
    }
    setOptions(newOptions) {
        const options = this.options;
        options.clear();
        for (const { id: id, name: name } of newOptions)options.set(id, name);
    }
    destroySelect() {
        this.eSelect = this.destroyBean(this.eSelect);
    }
    destroyButton() {
        this.removeButton = this.removeButton?.();
    }
    destroy() {
        this.destroySelect();
        this.destroyButton();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$FilterDetailElement = {
    tag: "div",
    cls: "ag-filter-card-body",
    children: [
        {
            tag: "ag-select",
            cls: "ag-filter-type-select",
            ref: "eFilterType"
        }
    ]
};
var $5b7ccabde48fae90$var$FilterDetailComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super(...arguments);
        this.eFilterType = (0, $jIDNV.RefPlaceholder);
    }
    postConstruct() {
        const eFilterTypeParams = {
            onValueChange: (filterDef)=>this.dispatchLocalEvent({
                    type: "filterTypeChanged",
                    filterDef: filterDef
                })
        };
        this.setTemplate($5b7ccabde48fae90$var$FilterDetailElement, [
            (0, $jIDNV.AgSelectSelector)
        ], {
            eFilterType: eFilterTypeParams
        });
        this.eFilterType.setDisplayed(false);
    }
    refresh(newState) {
        const oldState = this.state;
        this.state = newState;
        const { activeFilterDef: newActiveFilterDef, filterDefs: newFilterDefs, detail: newDetail, afterGuiAttached: afterGuiAttached, afterGuiDetached: afterGuiDetached } = newState;
        const { activeFilterDef: oldActiveFilterDef, filterDefs: oldFilterDefs, detail: oldDetail } = oldState ?? {};
        const eFilterType = this.eFilterType;
        if (newFilterDefs !== oldFilterDefs) {
            eFilterType.clearOptions();
            const options = newFilterDefs?.map((filterDef)=>({
                    value: filterDef,
                    text: filterDef.name
                }));
            if (options) eFilterType.clearOptions().addOptions(options).setValue(newActiveFilterDef, true);
            eFilterType.setDisplayed(!!options);
        } else if (newActiveFilterDef !== oldActiveFilterDef) eFilterType.setValue(newActiveFilterDef, true);
        if (newDetail !== oldDetail) {
            if (oldDetail) {
                (0, $jIDNV._removeFromParent)(oldDetail);
                afterGuiDetached();
            }
            this.appendChild(newDetail);
            afterGuiAttached({
                container: "newFiltersToolPanel",
                suppressFocus: true
            });
        }
    }
};
var $5b7ccabde48fae90$var$FilterSummaryElement = {
    tag: "div",
    cls: "ag-filter-card-summary",
    attrs: {
        "aria-hidden": "true"
    }
};
var $5b7ccabde48fae90$var$FilterSummaryComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$FilterSummaryElement);
    }
    refresh(state) {
        this.getGui().textContent = state.summary;
    }
};
// packages/ag-grid-enterprise/src/filterToolPanel/newFilterToolPanel/filterCardComp.ts
var $5b7ccabde48fae90$var$FilterCardElement = {
    tag: "div",
    cls: "ag-filter-card",
    children: [
        {
            tag: "div",
            cls: "ag-filter-card-header",
            role: "presentation",
            children: [
                {
                    tag: "div",
                    cls: "ag-filter-card-heading",
                    role: "heading",
                    attrs: {
                        "aria-level": "2"
                    },
                    children: [
                        {
                            tag: "button",
                            ref: "eExpand",
                            cls: "ag-button ag-filter-card-expand",
                            children: [
                                {
                                    tag: "span",
                                    ref: "eTitle",
                                    cls: "ag-filter-card-title"
                                },
                                {
                                    tag: "span",
                                    ref: "eEditing",
                                    cls: "ag-filter-card-editing-icon"
                                },
                                {
                                    tag: "span",
                                    ref: "eExpandIcon",
                                    cls: "ag-filter-card-expand-icon"
                                }
                            ]
                        }
                    ]
                },
                {
                    tag: "button",
                    ref: "eDelete",
                    cls: "ag-button ag-filter-card-delete",
                    children: [
                        {
                            tag: "span",
                            ref: "eDeleteIcon",
                            cls: "ag-filter-card-delete-icon"
                        }
                    ]
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$FilterCardComp = class extends (0, $jIDNV.Component) {
    constructor(id){
        super($5b7ccabde48fae90$var$FilterCardElement);
        this.id = id;
        this.eTitle = (0, $jIDNV.RefPlaceholder);
        this.eExpand = (0, $jIDNV.RefPlaceholder);
        this.eDelete = (0, $jIDNV.RefPlaceholder);
        this.eExpandIcon = (0, $jIDNV.RefPlaceholder);
        this.eDeleteIcon = (0, $jIDNV.RefPlaceholder);
        this.eEditing = (0, $jIDNV.RefPlaceholder);
    }
    postConstruct() {
        const { beans: beans, eDelete: eDelete, eExpand: eExpand, eDeleteIcon: eDeleteIcon, eEditing: eEditing, id: id } = this;
        const filterPanelService = beans.filterPanelSvc;
        (0, $jIDNV._setAriaLabel)(eDelete, $5b7ccabde48fae90$var$translateForFilterPanel(this, "ariaLabelFilterCardDelete"));
        eDeleteIcon.appendChild((0, $jIDNV._createIcon)("close", beans, null));
        this.activateTabIndex([
            eExpand,
            eDelete
        ]);
        this.addManagedElementListeners(eExpand, {
            click: ()=>filterPanelService.expand(id, !this.state?.expanded)
        });
        this.addManagedElementListeners(eDelete, {
            click: ()=>filterPanelService.remove(id)
        });
        this.addManagedEventListeners({
            filterOpened: this.onFilterOpened.bind(this)
        });
        eEditing.appendChild((0, $jIDNV._createIcon)("filterCardEditing", beans, null));
    }
    refresh(newState) {
        const { eExpand: eExpand, eEditing: eEditing, state: oldState, beans: beans } = this;
        this.state = newState;
        const { name: name, expanded: expanded, isEditing: isEditing } = newState;
        this.eTitle.textContent = name;
        (0, $jIDNV._setDisplayed)(eEditing, isEditing);
        if (!oldState || expanded !== oldState.expanded) this.toggleExpand(newState);
        let ariaLabel = expanded ? null : `${name} ${newState.summary}`;
        if (isEditing) ariaLabel = `${ariaLabel ?? name}. ${$5b7ccabde48fae90$var$translateForFilterPanel(this, "ariaLabelFilterCardHasEdits")}`;
        (0, $jIDNV._setAriaLabel)(eExpand, ariaLabel);
        const removeComp = (comp)=>{
            if (!comp) return;
            (0, $jIDNV._removeFromParent)(comp.getGui());
            return this.destroyBean(comp);
        };
        const createOrRefreshComp = (comp, FilterComp5, postCreateFunc)=>{
            if (!comp) {
                comp = this.createBean(new FilterComp5());
                postCreateFunc?.(comp);
                this.appendChild(comp.getGui());
            }
            comp.refresh(newState);
            return comp;
        };
        if (newState.expanded) {
            this.summaryComp = removeComp(this.summaryComp);
            const detailComp = createOrRefreshComp(this.detailComp, $5b7ccabde48fae90$var$FilterDetailComp, (comp)=>comp.addManagedListeners(comp, {
                    filterTypeChanged: ({ filterDef: filterDef })=>beans.filterPanelSvc.updateType(this.id, filterDef)
                }));
            this.detailComp = detailComp;
            const detailId = `ag-${this.getCompId()}-filter`;
            detailComp.getGui().id = detailId;
            (0, $jIDNV._setAriaControls)(eExpand, detailId);
        } else {
            this.detailComp = removeComp(this.detailComp);
            this.summaryComp = createOrRefreshComp(this.summaryComp, $5b7ccabde48fae90$var$FilterSummaryComp);
            (0, $jIDNV._setAriaControls)(eExpand, null);
        }
    }
    toggleExpand(state) {
        const expanded = !!state.expanded;
        const { eExpandIcon: eExpandIcon, eExpand: eExpand, beans: beans } = this;
        (0, $jIDNV._clearElement)(eExpandIcon);
        eExpandIcon.appendChild((0, $jIDNV._createIcon)(expanded ? "filterCardCollapse" : "filterCardExpand", beans, null));
        (0, $jIDNV._setAriaExpanded)(eExpand, expanded);
    }
    onFilterOpened(event) {
        const { state: state, beans: beans, id: id } = this;
        if (event.source === "COLUMN_MENU" && event.column === state?.column && state?.expanded) beans.filterPanelSvc.expand(id, false);
    }
    destroy() {
        this.detailComp = this.destroyBean(this.detailComp);
        this.summaryComp = this.destroyBean(this.summaryComp);
        this.state = void 0;
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/filterToolPanel/newFilterToolPanel/filterPanel.ts
function $5b7ccabde48fae90$var$isSingleRefresh(params) {
    return !!params?.id;
}
function $5b7ccabde48fae90$var$isActionRefresh(params) {
    return !!params?.action;
}
var $5b7ccabde48fae90$var$FilterPanelElement = {
    tag: "div",
    cls: "ag-filter-panel",
    children: [
        {
            tag: "div",
            cls: "ag-filter-panel-container",
            ref: "eContainer"
        }
    ]
};
var $5b7ccabde48fae90$var$FilterPanel = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$FilterPanelElement);
        this.eContainer = (0, $jIDNV.RefPlaceholder);
        this.filters = /* @__PURE__ */ new Map();
    }
    refresh(params) {
        if ($5b7ccabde48fae90$var$isActionRefresh(params)) {
            this.refreshActions();
            return;
        }
        if ($5b7ccabde48fae90$var$isSingleRefresh(params)) {
            this.filters.get(params.id)?.refresh(params.state);
            return;
        }
        const { eContainer: eContainer, filters: existingFilters, beans: beans } = this;
        const filterPanelSvc = beans.filterPanelSvc;
        const filterIds = filterPanelSvc.getIds();
        const newFilters = /* @__PURE__ */ new Map();
        const somethingIsFocused = !(0, $jIDNV._isNothingFocused)(beans);
        const activeElement = somethingIsFocused ? (0, $jIDNV._getActiveDomElement)(beans) : void 0;
        const containerHasFocus = somethingIsFocused && eContainer.contains(activeElement);
        const ePrevItems = [];
        const eNewItems = [];
        for (const id of filterIds){
            const newFilter = existingFilters.get(id) ?? this.createBean(new $5b7ccabde48fae90$var$FilterCardComp(id));
            newFilter.refresh(filterPanelSvc.getState(id));
            newFilters.set(id, newFilter);
            eNewItems.push(newFilter.getGui());
        }
        this.filters = newFilters;
        const compsToDestroy = [];
        existingFilters.forEach((existingFilter, id)=>{
            ePrevItems.push(existingFilter.getGui());
            if (!newFilters.has(id)) compsToDestroy.push(existingFilter);
        });
        let addFilterComp = this.addFilterComp;
        if (addFilterComp) ePrevItems.push(addFilterComp.getGui());
        const addFilterOptions = filterPanelSvc.getAvailable();
        if (addFilterOptions.length) {
            if (!addFilterComp) {
                addFilterComp = this.createBean(new $5b7ccabde48fae90$var$AddFilterComp(addFilterOptions));
                addFilterComp.addManagedListeners(addFilterComp, {
                    filterSelected: ({ id: id })=>filterPanelSvc.add(id)
                });
            }
            addFilterComp.refresh(addFilterOptions);
            eNewItems.push(addFilterComp.getGui());
        } else addFilterComp = this.destroyBean(addFilterComp);
        this.addFilterComp = addFilterComp;
        $5b7ccabde48fae90$var$compareAndUpdateListsInDom(eContainer, eNewItems, ePrevItems);
        compsToDestroy.forEach((comp)=>this.destroyBean(comp));
        const activeId = params?.activeId;
        const activeItemToFocus = activeId && newFilters.get(activeId)?.getGui();
        if (activeItemToFocus) (0, $jIDNV._focusInto)(activeItemToFocus);
        else if (containerHasFocus && (0, $jIDNV._isNothingFocused)(beans)) (0, $jIDNV._focusInto)(eNewItems[eNewItems.length - 1] ?? eContainer);
        this.refreshActions();
    }
    refreshActions() {
        const filterPanelSvc = this.beans.filterPanelSvc;
        const { actions: actions, canApply: canApply } = filterPanelSvc.getActions() ?? {};
        let buttonComp = this.buttonComp;
        if (actions?.length) {
            const buttons = actions.map((type)=>({
                    type: type,
                    label: (0, $jIDNV._translateForFilter)(this, `${type}Filter`)
                }));
            if (!buttonComp) {
                buttonComp = this.createBean(new (0, $jIDNV.FilterButtonComp)({
                    className: "ag-filter-panel-buttons"
                }));
                this.getGui().appendChild(buttonComp.getGui());
                const listeners = {};
                [
                    "apply",
                    "clear",
                    "reset",
                    "cancel"
                ].forEach((action)=>{
                    listeners[action] = ()=>filterPanelSvc.doAction(action);
                });
                buttonComp.addManagedListeners(buttonComp, listeners);
            }
            buttonComp.updateButtons(buttons);
            buttonComp.updateValidity(canApply !== false);
        } else if (buttonComp) {
            (0, $jIDNV._removeFromParent)(buttonComp.getGui());
            buttonComp = this.destroyBean(buttonComp);
        }
        this.buttonComp = buttonComp;
    }
    destroy() {
        this.addFilterComp = this.destroyBean(this.addFilterComp);
        this.buttonComp = this.destroyBean(this.buttonComp);
        const filters = this.filters;
        filters.forEach((filter)=>this.destroyBean(filter));
        filters.clear();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/filterToolPanel/newFilterToolPanel/newFiltersToolPanel.css-GENERATED.ts
var $5b7ccabde48fae90$var$newFiltersToolPanelCSS = /*css*/ `.ag-filter-panel{display:flex;flex-direction:column;width:100%;:where(.ag-standard-button){transition:background-color .25s ease-in-out,color .25s ease-in-out}}.ag-filter-panel .ag-simple-filter-body-wrapper{padding:var(--ag-widget-vertical-spacing) var(--ag-widget-container-horizontal-padding) 0}.ag-filter-panel .ag-mini-filter{margin-left:var(--ag-widget-container-horizontal-padding);margin-right:var(--ag-widget-container-horizontal-padding);margin-top:var(--ag-widget-vertical-spacing)}.ag-filter-panel-container{flex:1;overflow:auto;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding) 0}.ag-filter-panel-container>:where(:not(:last-child)){margin-bottom:var(--ag-widget-container-vertical-padding)}.ag-filter-card{background-color:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:var(--ag-border-radius)}.ag-filter-card-header{align-items:center;display:flex;flex-direction:row;padding-top:var(--ag-widget-vertical-spacing)}:where(.ag-ltr) .ag-filter-card-header{&>:where(:not(:last-child)){padding-right:var(--ag-spacing)}}:where(.ag-rtl) .ag-filter-card-header{&>:where(:not(:last-child)){padding-left:var(--ag-spacing)}}.ag-filter-card-heading{flex:1;overflow:hidden;padding-bottom:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));padding-top:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing))}:where(.ag-ltr) .ag-filter-card-heading{padding-left:var(--ag-widget-horizontal-spacing)}:where(.ag-rtl) .ag-filter-card-heading{padding-right:var(--ag-widget-horizontal-spacing)}.ag-filter-card-expand{align-items:center;display:flex;flex-direction:row;width:100%}.ag-filter-card-title{font-weight:var(--ag-header-font-weight);overflow:hidden;text-overflow:ellipsis}.ag-filter-card-expand-icon{display:flex;flex:1;justify-content:end}.ag-filter-card-editing-icon{margin:0 var(--ag-spacing)}.ag-filter-card-delete-icon,.ag-filter-card-editing-icon,.ag-filter-card-expand-icon,.ag-filter-card-summary{color:var(--ag-filter-panel-card-subtle-color)}.ag-filter-card-delete-icon,.ag-filter-card-expand-icon{transition:color .25s ease-in-out}.ag-filter-card-delete-icon:hover,.ag-filter-card-expand-icon:hover,.ag-filter-card-heading:hover .ag-filter-card-expand-icon{color:var(--ag-filter-panel-card-subtle-hover-color)}.ag-filter-add-button,.ag-filter-card-delete,.ag-filter-card-expand{border-radius:var(--ag-button-border-radius)}.ag-filter-card-summary,.ag-filter-type-select{margin-left:var(--ag-widget-container-horizontal-padding);margin-right:var(--ag-widget-container-horizontal-padding)}:where(.ag-ltr) .ag-filter-card-delete{margin-right:var(--ag-widget-horizontal-spacing)}:where(.ag-rtl) .ag-filter-card-delete{margin-left:var(--ag-widget-horizontal-spacing)}.ag-filter-card-summary{margin-bottom:var(--ag-widget-container-vertical-padding)}.ag-filter-type-select{padding-top:var(--ag-widget-vertical-spacing)}.ag-filter-card-add{border:0;padding:0}.ag-filter-add-button{align-items:center;display:flex;flex-direction:row;line-height:1.5;width:100%}:where(.ag-ltr) .ag-filter-add-button-label{margin-left:var(--ag-spacing)}:where(.ag-rtl) .ag-filter-add-button-label{margin-right:var(--ag-spacing)}.ag-filter-add-select{border:0;.ag-rich-select-value{border:0;padding:calc(((1.5*var(--ag-font-size) + 2*var(--ag-button-vertical-padding)) - var(--ag-input-height))/2) var(--ag-spacing)}}:where(.ag-ltr) .ag-filter-add-select{.ag-text-field-input{padding-left:calc(var(--ag-spacing)*1.5 + 12px)!important}}:where(.ag-rtl) .ag-filter-add-select{.ag-text-field-input{padding-right:calc(var(--ag-spacing)*1.5 + 12px)!important}}.ag-filter-panel-buttons{display:flex;flex-wrap:wrap;gap:var(--ag-widget-vertical-spacing) var(--ag-widget-horizontal-spacing);justify-content:flex-end;overflow:hidden;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding) 0}.ag-filter-panel-buttons-button{line-height:1.5}.ag-filter-panel .ag-filter-panel-buttons-apply-button{background-color:var(--ag-filter-panel-apply-button-background-color);color:var(--ag-filter-panel-apply-button-color)}.ag-filter-panel>:where(:last-child){padding-bottom:var(--ag-widget-container-vertical-padding)}.ag-filter-panel .ag-set-filter-body-wrapper,.ag-filter-panel .ag-simple-filter-body-wrapper>:last-child{margin-bottom:var(--ag-widget-container-vertical-padding)}`;
// packages/ag-grid-enterprise/src/filterToolPanel/newFilterToolPanel/wrapperToolPanel.ts
var $5b7ccabde48fae90$var$WrapperToolPanel = class extends (0, $jIDNV.Component) {
    constructor(){
        super();
        this.registerCSS($5b7ccabde48fae90$var$newFiltersToolPanelCSS);
    }
    init(params) {
        if (!this.gos.get("enableFilterHandlers")) {
            (0, $jIDNV._warn)(282);
            return;
        }
        const filterPanelSvc = this.beans.filterPanelSvc;
        filterPanelSvc.isActive = true;
        this.addDestroyFunc(()=>{
            filterPanelSvc.isActive = false;
        });
        this.updateParams(params, params.initialState);
        const filterPanel = this.createManagedBean(new $5b7ccabde48fae90$var$FilterPanel());
        this.filterPanel = filterPanel;
        const refresh = (event)=>{
            filterPanel.refresh(event);
            params.onStateUpdated();
        };
        refresh();
        this.addManagedListeners(filterPanelSvc, {
            filterPanelStatesChanged: refresh,
            filterPanelStateChanged: refresh
        });
    }
    getGui() {
        return this.filterPanel?.getGui();
    }
    refresh(params) {
        this.updateParams(params);
        return true;
    }
    updateParams(params, initialState) {
        this.beans.filterPanelSvc?.updateParams(params, initialState);
    }
    getState() {
        return this.beans.filterPanelSvc?.getGridState() ?? {};
    }
};
// packages/ag-grid-enterprise/src/filterToolPanel/filtersToolPanelModule.ts
var $5b7ccabde48fae90$export$783953a68616c0a2 = {
    moduleName: "FiltersToolPanel",
    version: $5b7ccabde48fae90$var$VERSION,
    userComponents: {
        agFiltersToolPanel: $5b7ccabde48fae90$var$FiltersToolPanel
    },
    icons: {
        // filter tool panel tab
        filtersToolPanel: "filter"
    },
    dependsOn: [
        $5b7ccabde48fae90$export$707a9bd30915b7fe,
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $jIDNV._ColumnFilterModule)
    ]
};
var $5b7ccabde48fae90$export$5d9e175412b51985 = {
    moduleName: "NewFiltersToolPanel",
    version: $5b7ccabde48fae90$var$VERSION,
    userComponents: {
        agNewFiltersToolPanel: $5b7ccabde48fae90$var$WrapperToolPanel
    },
    beans: [
        $5b7ccabde48fae90$var$FilterPanelService,
        $5b7ccabde48fae90$var$SelectableFilterService
    ],
    icons: {
        // filter add button in new filter tool panel
        filterAdd: "filter-add",
        // filter tool panel tab
        filtersToolPanel: "filter",
        // open icon for rich select
        richSelectOpen: "small-down",
        // remove for rich select editor pills
        richSelectRemove: "cancel",
        // button to expand filter card in new filter tool panel
        filterCardExpand: "chevron-down",
        // button to collapse filter card in new filter tool panel
        filterCardCollapse: "chevron-up",
        // indicates filter card in new filter tool panel has edits
        filterCardEditing: "edit"
    },
    dependsOn: [
        $5b7ccabde48fae90$export$707a9bd30915b7fe,
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $jIDNV._ColumnFilterModule)
    ]
};
var $5b7ccabde48fae90$var$DetailCellRendererCtrl = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.loadRowDataVersion = 0;
    }
    wireBeans(beans) {
        this.environment = beans.environment;
    }
    init(comp, params) {
        this.params = params;
        this.comp = comp;
        const doNothingBecauseInsidePinnedSection = params.pinned != null;
        if (doNothingBecauseInsidePinnedSection) return;
        this.setAutoHeightClasses();
        this.setupRefreshStrategy();
        this.createDetailGrid();
        this.loadRowData();
        this.addManagedEventListeners({
            fullWidthRowFocused: this.onFullWidthRowFocused.bind(this)
        });
    }
    onFullWidthRowFocused(e) {
        const params = this.params;
        const row = {
            rowIndex: params.node.rowIndex,
            rowPinned: params.node.rowPinned
        };
        const eventRow = {
            rowIndex: e.rowIndex,
            rowPinned: e.rowPinned
        };
        const isSameRow = (0, $jIDNV._isSameRow)(row, eventRow);
        if (!isSameRow) return;
        (0, $jIDNV._focusInto)(this.comp.getGui(), e.fromBelow);
    }
    setAutoHeightClasses() {
        const autoHeight = this.gos.get("detailRowAutoHeight");
        const parentClass = autoHeight ? "ag-details-row-auto-height" : "ag-details-row-fixed-height";
        const detailClass = autoHeight ? "ag-details-grid-auto-height" : "ag-details-grid-fixed-height";
        const comp = this.comp;
        comp.toggleCss(parentClass, true);
        comp.toggleDetailGridCss(detailClass, true);
    }
    setupRefreshStrategy() {
        const providedStrategy = this.params.refreshStrategy;
        const validSelection = providedStrategy == "everything" || providedStrategy == "nothing" || providedStrategy == "rows";
        if (validSelection) {
            this.refreshStrategy = providedStrategy;
            return;
        }
        if (providedStrategy != null) (0, $jIDNV._warn)(170, {
            providedStrategy: providedStrategy
        });
        this.refreshStrategy = "rows";
    }
    createDetailGrid() {
        const { params: params, gos: gos } = this;
        if ((0, $jIDNV._missing)(params.detailGridOptions)) {
            (0, $jIDNV._warn)(171);
            return;
        }
        const masterTheme = gos.get("theme");
        const detailTheme = params.detailGridOptions.theme;
        if (detailTheme && detailTheme !== masterTheme) (0, $jIDNV._warn)(267);
        const gridOptions = {
            themeStyleContainer: this.environment.eStyleContainer,
            ...params.detailGridOptions,
            theme: masterTheme
        };
        const autoHeight = gos.get("detailRowAutoHeight");
        if (autoHeight) gridOptions.domLayout = "autoHeight";
        this.comp.setDetailGrid(gridOptions);
    }
    registerDetailWithMaster(api) {
        const { params: params, beans: { selectionSvc: selectionSvc, findSvc: findSvc } } = this;
        const rowId = params.node.id;
        const masterGridApi = params.api;
        const gridInfo = {
            id: rowId,
            api: api
        };
        const rowNode = params.node;
        if (masterGridApi.isDestroyed()) return;
        masterGridApi.addDetailGridInfo(rowId, gridInfo);
        rowNode.detailGridInfo = gridInfo;
        const masterNode = rowNode.parent;
        findSvc?.registerDetailGrid(rowNode, api);
        function onDetailSelectionChanged() {
            if (masterNode) selectionSvc?.refreshMasterNodeState(masterNode);
        }
        function onMasterRowSelected({ node: node, source: source }) {
            if (node !== masterNode || source === "masterDetail" || api.isDestroyed()) return;
            selectionSvc?.setDetailSelectionState(masterNode, params.detailGridOptions, api);
        }
        api.addEventListener("firstDataRendered", ()=>{
            if (api.isDestroyed() || masterGridApi.isDestroyed()) return;
            selectionSvc?.setDetailSelectionState(masterNode, params.detailGridOptions, api);
            api.addEventListener("selectionChanged", onDetailSelectionChanged);
            masterGridApi.addEventListener("rowSelected", onMasterRowSelected);
        });
        this.addDestroyFunc(()=>{
            if (rowNode.detailGridInfo !== gridInfo) return;
            if (!masterGridApi.isDestroyed()) masterGridApi.removeDetailGridInfo(rowId);
            rowNode.detailGridInfo = null;
        });
    }
    loadRowData() {
        this.loadRowDataVersion++;
        const versionThisCall = this.loadRowDataVersion;
        const params = this.params;
        if (params.detailGridOptions?.rowModelType === "serverSide") {
            const node = params.node;
            node.detailGridInfo?.api?.refreshServerSide({
                purge: true
            });
            return;
        }
        const userFunc = params.getDetailRowData;
        if (!userFunc) {
            (0, $jIDNV._warn)(172);
            return;
        }
        const successCallback = (rowData)=>{
            const mostRecentCall = this.loadRowDataVersion === versionThisCall;
            if (mostRecentCall) this.comp.setRowData(rowData);
        };
        const funcParams = {
            node: params.node,
            // we take data from node, rather than params.data
            // as the data could have been updated with new instance
            data: params.node.data,
            successCallback: successCallback,
            context: (0, $jIDNV._addGridCommonParams)(this.gos, {}).context
        };
        userFunc(funcParams);
    }
    refresh() {
        const GET_GRID_TO_REFRESH = false;
        const GET_GRID_TO_DO_NOTHING = true;
        switch(this.refreshStrategy){
            case "nothing":
                return GET_GRID_TO_DO_NOTHING;
            case "everything":
                return GET_GRID_TO_REFRESH;
        }
        this.loadRowData();
        return GET_GRID_TO_DO_NOTHING;
    }
};
// packages/ag-grid-enterprise/src/masterDetail/detailFrameworkComponentWrapper.ts
var $5b7ccabde48fae90$var$DetailFrameworkComponentWrapper = class {
    constructor(parentWrapper){
        this.parentWrapper = parentWrapper;
    }
    wrap(frameworkComponent, mandatoryMethods, optionalMethods, componentType) {
        return this.parentWrapper.wrap(frameworkComponent, mandatoryMethods, optionalMethods, componentType);
    }
};
// packages/ag-grid-enterprise/src/masterDetail/detailCellRenderer.ts
var $5b7ccabde48fae90$var$PinnedDetailCellRendererElement = {
    tag: "div",
    cls: "ag-details-row"
};
var $5b7ccabde48fae90$var$DetailCellRendererElement = {
    tag: "div",
    cls: "ag-details-row",
    role: "gridcell",
    children: [
        {
            tag: "div",
            ref: "eDetailGrid",
            cls: "ag-details-grid",
            role: "presentation"
        }
    ]
};
var $5b7ccabde48fae90$var$DetailCellRenderer = class extends (0, $jIDNV.Component) {
    constructor(){
        super(...arguments);
        this.eDetailGrid = (0, $jIDNV.RefPlaceholder);
    }
    wireBeans(beans) {
        this.context = beans.context;
    }
    init(params) {
        this.params = params;
        this.selectAndSetTemplate();
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            toggleDetailGridCss: (cssClassName, on)=>this.eDetailGrid.classList.toggle(cssClassName, on),
            setDetailGrid: (gridOptions)=>this.setDetailGrid(gridOptions),
            setRowData: (rowData)=>this.setRowData(rowData),
            getGui: ()=>this.eDetailGrid
        };
        this.ctrl = this.createManagedBean(new $5b7ccabde48fae90$var$DetailCellRendererCtrl());
        this.ctrl.init(compProxy, params);
    }
    refresh() {
        return this.ctrl?.refresh() ?? false;
    }
    selectAndSetTemplate() {
        const params = this.params;
        if (params.pinned) {
            this.setTemplate($5b7ccabde48fae90$var$PinnedDetailCellRendererElement);
            return;
        }
        const setDefaultTemplate = ()=>{
            this.setTemplate($5b7ccabde48fae90$var$DetailCellRendererElement);
        };
        if ((0, $jIDNV._missing)(params.template)) setDefaultTemplate();
        else {
            if (typeof params.template === "string") this.setTemplate(params.template, []);
            else if (typeof params.template === "function") {
                const templateFunc = params.template;
                const template = templateFunc(params);
                this.setTemplate(template, []);
            } else {
                (0, $jIDNV._warn)(168);
                setDefaultTemplate();
            }
        }
        if (this.eDetailGrid == null) (0, $jIDNV._warn)(169);
    }
    setDetailGrid(gridOptions) {
        if (!this.eDetailGrid) return;
        const parentFrameworkComponentWrapper = this.context.getBean("frameworkCompWrapper");
        const frameworkCompWrapper = new $5b7ccabde48fae90$var$DetailFrameworkComponentWrapper(parentFrameworkComponentWrapper);
        const { frameworkOverrides: frameworkOverrides } = this.beans;
        const api = (0, $jIDNV.createGrid)(this.eDetailGrid, gridOptions, {
            frameworkOverrides: frameworkOverrides,
            providedBeanInstances: {
                frameworkCompWrapper: frameworkCompWrapper
            },
            modules: (0, $jIDNV._getGridRegisteredModules)(this.params.api.getGridId(), gridOptions.rowModelType ?? "clientSide")
        });
        this.detailApi = api;
        this.ctrl?.registerDetailWithMaster(api);
        this.addDestroyFunc(()=>{
            api.destroy();
        });
    }
    setRowData(rowData) {
        this.detailApi?.setGridOption("rowData", rowData);
    }
};
// packages/ag-grid-enterprise/src/masterDetail/masterDetailApi.ts
function $5b7ccabde48fae90$var$operateOnStore(beans, callback) {
    const store = beans.masterDetailSvc?.store;
    return store ? callback(store) : void 0;
}
function $5b7ccabde48fae90$var$addDetailGridInfo(beans, id, gridInfo) {
    $5b7ccabde48fae90$var$operateOnStore(beans, (store)=>{
        store[id] = gridInfo;
    });
}
function $5b7ccabde48fae90$var$removeDetailGridInfo(beans, id) {
    $5b7ccabde48fae90$var$operateOnStore(beans, (store)=>{
        delete store[id];
    });
}
function $5b7ccabde48fae90$var$getDetailGridInfo(beans, id) {
    return $5b7ccabde48fae90$var$operateOnStore(beans, (store)=>store[id]);
}
function $5b7ccabde48fae90$var$forEachDetailGridInfo(beans, callback) {
    $5b7ccabde48fae90$var$operateOnStore(beans, (store)=>{
        let index = 0;
        Object.values(store).forEach((gridInfo)=>{
            if (gridInfo) callback(gridInfo, index++);
        });
    });
}
// packages/ag-grid-enterprise/src/masterDetail/masterDetailModule.css-GENERATED.ts
var $5b7ccabde48fae90$var$masterDetailModuleCSS = /*css*/ `.ag-details-row{width:100%}.ag-details-row-fixed-height{height:100%}.ag-details-grid{width:100%}.ag-details-grid-fixed-height{height:100%}`;
var $5b7ccabde48fae90$var$MasterDetailService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "masterDetailSvc";
        this.store = {};
    }
    isEnabled() {
        return !!this.gos.get("masterDetail");
    }
    postConstruct() {
        if ((0, $jIDNV._isClientSideRowModel)(this.gos)) this.enabled = this.isEnabled();
    }
    refreshModel(params) {
        if (params.changedProps) {
            const enabled = this.isEnabled();
            if (this.enabled !== enabled) {
                this.setMasters(null);
                return;
            }
        }
        if (params.rowDataUpdated) this.setMasters(params.changedRowNodes);
    }
    setMasters(changedRowNodes) {
        const enabled = this.isEnabled();
        this.enabled = enabled;
        const gos = this.gos;
        const isRowMaster = gos.get("isRowMaster");
        const treeData = gos.get("treeData");
        const setMaster = (row, created, updated)=>{
            const oldMaster = row.master;
            let newMaster = enabled;
            if (enabled) {
                if (created || updated) {
                    if (isRowMaster) {
                        const data = row.data;
                        newMaster = !!data && !!isRowMaster(data);
                    }
                } else newMaster = oldMaster;
            }
            if (!treeData) {
                if (newMaster && created) {
                    const level = this.beans.rowGroupColsSvc?.columns.length ?? 0;
                    row.expanded = $5b7ccabde48fae90$var$_getRowDefaultExpanded(this.beans, row, level, false);
                } else if (!newMaster && oldMaster) row.expanded = false;
            }
            if (newMaster !== oldMaster) {
                row.master = newMaster;
                row.dispatchRowEvent("masterChanged");
            }
        };
        if (changedRowNodes) {
            for (const node of changedRowNodes.updates)setMaster(node, false, true);
            for (const node of changedRowNodes.adds)setMaster(node, true, false);
        } else {
            const allLeafChildren = (0, $jIDNV._getClientSideRowModel)(this.beans)?.rootNode?.allLeafChildren;
            if (allLeafChildren) for(let i = 0, len = allLeafChildren.length; i < len; ++i)setMaster(allLeafChildren[i], true, false);
        }
    }
    /** Used by flatten stage to get or create a detail node from a master node */ getDetail(masterNode) {
        if (!masterNode.master || !masterNode.expanded) return null;
        let detailNode = masterNode.detailNode;
        if (detailNode) return detailNode;
        detailNode = new (0, $jIDNV.RowNode)(this.beans);
        detailNode.detail = true;
        detailNode.selectable = false;
        detailNode.parent = masterNode;
        if ((0, $jIDNV._exists)(masterNode.id)) detailNode.id = "detail_" + masterNode.id;
        detailNode.data = masterNode.data;
        detailNode.level = masterNode.level + 1;
        masterNode.detailNode = detailNode;
        return detailNode;
    }
    setupDetailRowAutoHeight(rowCtrl, eDetailGui) {
        const { gos: gos, beans: beans } = this;
        if (!gos.get("detailRowAutoHeight")) return;
        const checkRowSizeFunc = ()=>{
            const clientHeight = eDetailGui.clientHeight;
            if (clientHeight != null && clientHeight > 0) {
                const updateRowHeightFunc = ()=>{
                    const { rowModel: rowModel } = this.beans;
                    const { rowNode: rowNode } = rowCtrl;
                    rowNode.setRowHeight(clientHeight);
                    if ((0, $jIDNV._isClientSideRowModel)(gos, rowModel) || (0, $jIDNV._isServerSideRowModel)(gos, rowModel)) rowModel.onRowHeightChanged();
                };
                window.setTimeout(updateRowHeightFunc, 0);
            }
        };
        const resizeObserverDestroyFunc = (0, $jIDNV._observeResize)(beans, eDetailGui, checkRowSizeFunc);
        rowCtrl.addDestroyFunc(resizeObserverDestroyFunc);
        checkRowSizeFunc();
    }
    destroy() {
        this.store = {};
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/masterDetail/masterDetailModule.ts
var $5b7ccabde48fae90$var$SharedMasterDetailModule = {
    moduleName: "SharedMasterDetail",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$MasterDetailService
    ],
    userComponents: {
        agDetailCellRenderer: $5b7ccabde48fae90$var$DetailCellRenderer
    },
    dynamicBeans: {
        detailCellRendererCtrl: $5b7ccabde48fae90$var$DetailCellRendererCtrl
    },
    apiFunctions: {
        addDetailGridInfo: $5b7ccabde48fae90$var$addDetailGridInfo,
        removeDetailGridInfo: $5b7ccabde48fae90$var$removeDetailGridInfo,
        getDetailGridInfo: $5b7ccabde48fae90$var$getDetailGridInfo,
        forEachDetailGridInfo: $5b7ccabde48fae90$var$forEachDetailGridInfo
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        $5b7ccabde48fae90$var$GroupCellRendererModule,
        $5b7ccabde48fae90$var$StickyRowModule
    ],
    css: [
        $5b7ccabde48fae90$var$masterDetailModuleCSS
    ]
};
var $5b7ccabde48fae90$export$656cedc46227f6d2 = {
    moduleName: "MasterDetail",
    version: $5b7ccabde48fae90$var$VERSION,
    dependsOn: [
        $5b7ccabde48fae90$var$SharedMasterDetailModule,
        $5b7ccabde48fae90$var$ClientSideRowModelHierarchyModule,
        (0, $jIDNV.EventApiModule)
    ]
};
var $5b7ccabde48fae90$var$AbstractSelectionHandle = class extends (0, $jIDNV.Component) {
    constructor(){
        super(...arguments);
        this.changedCalculatedValues = false;
        this.dragging = false;
        this.shouldDestroyOnEndDragging = false;
    }
    postConstruct() {
        const { dragSvc: dragSvc, rangeSvc: rangeSvc } = this.beans;
        dragSvc.addDragSource({
            dragStartPixels: 0,
            eElement: this.getGui(),
            onDragStart: this.onDragStart.bind(this),
            onDragging: (e)=>{
                this.dragging = true;
                rangeSvc.autoScrollService.check(e);
                if (this.changedCalculatedValues) {
                    this.onDrag(e);
                    this.changedCalculatedValues = false;
                }
            },
            onDragStop: (e)=>{
                this.dragging = false;
                this.onDragEnd(e);
                this.clearDragProperties();
                if (this.shouldDestroyOnEndDragging) this.destroy();
            },
            onDragCancel: ()=>{
                this.dragging = false;
                this.onDragCancel();
                this.clearDragProperties();
            }
        });
        this.addManagedElementListeners(this.getGui(), {
            mousedown: this.preventRangeExtension.bind(this)
        });
    }
    getLastCellHovered() {
        return this.lastCellHovered;
    }
    preventRangeExtension(e) {
        e.stopPropagation();
    }
    onDragStart(_) {
        [this.cellHoverListener] = this.addManagedElementListeners(this.beans.ctrlsSvc.get("gridCtrl").getGui(), {
            mousemove: this.updateValuesOnMove.bind(this)
        });
        document.body.classList.add(this.getDraggingCssClass());
    }
    getDraggingCssClass() {
        return `ag-dragging-${this.type === 0 /* FILL */  ? "fill" : "range"}-handle`;
    }
    updateValuesOnMove(e) {
        const cell = (0, $jIDNV._getCellPositionForEvent)(this.gos, e);
        if (!cell || this.shouldSkipCell(cell) || this.lastCellHovered && (0, $jIDNV._areCellsEqual)(cell, this.lastCellHovered)) return;
        this.lastCellHovered = cell;
        this.changedCalculatedValues = true;
    }
    clearDragProperties() {
        this.clearValues();
        this.beans.rangeSvc.autoScrollService.ensureCleared();
        document.body.classList.remove(this.getDraggingCssClass());
    }
    getType() {
        return this.type;
    }
    refresh(cellCtrl) {
        const oldCellComp = this.cellCtrl;
        const eGui = this.getGui();
        const cellRange = (0, $jIDNV._last)(this.beans.rangeSvc.getCellRanges());
        const start = cellRange.startRow;
        const end = cellRange.endRow;
        if (start && end) {
            const isBefore = (0, $jIDNV._isRowBefore)(end, start);
            if (isBefore) {
                this.rangeStartRow = end;
                this.rangeEndRow = start;
            } else {
                this.rangeStartRow = start;
                this.rangeEndRow = end;
            }
        }
        if (oldCellComp !== cellCtrl || !(0, $jIDNV._isVisible)(eGui)) {
            this.cellCtrl = cellCtrl;
            const eParentOfValue = cellCtrl.comp.getParentOfValue();
            if (eParentOfValue) eParentOfValue.appendChild(eGui);
        }
        this.cellRange = cellRange;
    }
    clearValues() {
        this.lastCellHovered = void 0;
        this.removeListeners();
    }
    removeListeners() {
        const cellHoverListener = this.cellHoverListener;
        if (cellHoverListener) {
            cellHoverListener();
            this.cellHoverListener = void 0;
        }
    }
    destroy() {
        if (!this.shouldDestroyOnEndDragging && this.dragging) {
            (0, $jIDNV._setDisplayed)(this.getGui(), false);
            this.shouldDestroyOnEndDragging = true;
            return;
        }
        this.shouldDestroyOnEndDragging = false;
        super.destroy();
        this.removeListeners();
        const eGui = this.getGui();
        eGui.parentElement?.removeChild(eGui);
    }
};
// packages/ag-grid-enterprise/src/rangeSelection/utils.ts
function $5b7ccabde48fae90$var$findLineByLeastSquares(values) {
    const len = values.length;
    let maxDecimals = 0;
    if (len <= 1) return values;
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        const splitExponent = value.toString().split("e-");
        if (splitExponent.length > 1) {
            maxDecimals = Math.max(maxDecimals, parseInt(splitExponent[1], 10));
            continue;
        }
        if (Math.floor(value) === value) continue;
        maxDecimals = Math.max(maxDecimals, value.toString().split(".")[1].length);
    }
    let sum_x = 0;
    let sum_y = 0;
    let sum_xy = 0;
    let sum_xx = 0;
    let y = 0;
    for(let x = 0; x < len; x++){
        y = values[x];
        sum_x += x;
        sum_y += y;
        sum_xx += x * x;
        sum_xy += x * y;
    }
    const m = (len * sum_xy - sum_x * sum_y) / (len * sum_xx - sum_x * sum_x);
    const b = sum_y / len - m * sum_x / len;
    const result = [];
    for(let x = 0; x <= len; x++)result.push(parseFloat((x * m + b).toFixed(maxDecimals)));
    return result;
}
// packages/ag-grid-enterprise/src/rangeSelection/agFillHandle.ts
var $5b7ccabde48fae90$var$FillHandleElement = {
    tag: "div",
    cls: "ag-fill-handle"
};
var $5b7ccabde48fae90$var$AgFillHandle = class extends $5b7ccabde48fae90$var$AbstractSelectionHandle {
    constructor(){
        super($5b7ccabde48fae90$var$FillHandleElement);
        this.markedCells = [];
        this.cellValues = [];
        this.isUp = false;
        this.isLeft = false;
        this.isReduce = false;
        this.type = 0 /* FILL */ ;
    }
    postConstruct() {
        super.postConstruct();
        this.addManagedElementListeners(this.getGui(), {
            dblclick: this.onDblClick.bind(this)
        });
    }
    onDblClick(e) {
        (0, $jIDNV._stopPropagationForAgGrid)(e);
        const { cellRange: initialRange, rangeStartRow: rangeStartRow, beans: beans } = this;
        const { rangeSvc: rangeSvc } = beans;
        const lastRow = (0, $jIDNV._getLastRow)(beans);
        if (!lastRow) return;
        const finalRange = rangeSvc?.createCellRangeFromCellRangeParams({
            rowStartIndex: rangeStartRow.rowIndex,
            rowStartPinned: rangeStartRow.rowPinned,
            columnStart: initialRange.columns[0],
            rowEndIndex: lastRow.rowIndex,
            rowEndPinned: lastRow.rowPinned,
            columnEnd: (0, $jIDNV._last)(initialRange.columns)
        });
        this.dragAxis = "y";
        this.isUp = false;
        this.isLeft = false;
        if (finalRange) this.performFill({
            event: e,
            initialRange: initialRange,
            finalRange: finalRange
        });
        this.dragAxis = void 0;
    }
    updateValuesOnMove(e) {
        super.updateValuesOnMove(e);
        if (!this.initialXY) this.initialXY = (0, $jIDNV._getNormalisedMousePosition)(this.beans, e);
        const { x: x, y: y } = this.initialXY;
        const { x: newX, y: newY } = (0, $jIDNV._getNormalisedMousePosition)(this.beans, e);
        const diffX = Math.abs(x - newX);
        const diffY = Math.abs(y - newY);
        const allowedDirection = this.getFillHandleDirection();
        let direction;
        if (allowedDirection === "xy") direction = diffX > diffY ? "x" : "y";
        else direction = allowedDirection;
        if (direction !== this.dragAxis) {
            this.dragAxis = direction;
            this.changedCalculatedValues = true;
        }
    }
    shouldSkipCell(cell) {
        return (0, $jIDNV.isRowNumberCol)(cell.column);
    }
    onDrag(_) {
        if (!this.initialPosition) {
            const cellCtrl = this.cellCtrl;
            if (!cellCtrl) return;
            this.initialPosition = cellCtrl.cellPosition;
        }
        const lastCellHovered = this.getLastCellHovered();
        if (lastCellHovered) this.markPathFrom(this.initialPosition, lastCellHovered);
    }
    onDragEnd(e) {
        this.initialXY = null;
        if (!this.markedCells.length) return;
        const isX = this.dragAxis === "x";
        const { cellRange: initialRange, rangeStartRow: rangeStartRow, rangeEndRow: rangeEndRow, beans: { rangeSvc: rangeSvc } } = this;
        const colLen = initialRange.columns.length;
        let finalRange;
        if (!this.isUp && !this.isLeft) finalRange = rangeSvc.createCellRangeFromCellRangeParams({
            rowStartIndex: rangeStartRow.rowIndex,
            rowStartPinned: rangeStartRow.rowPinned,
            columnStart: initialRange.columns[0],
            rowEndIndex: isX ? rangeEndRow.rowIndex : this.lastCellMarked.rowIndex,
            rowEndPinned: isX ? rangeEndRow.rowPinned : this.lastCellMarked.rowPinned,
            columnEnd: isX ? this.lastCellMarked.column : initialRange.columns[colLen - 1]
        });
        else {
            const startRow = isX ? rangeStartRow : this.lastCellMarked;
            finalRange = rangeSvc.createCellRangeFromCellRangeParams({
                rowStartIndex: startRow.rowIndex,
                rowStartPinned: startRow.rowPinned,
                columnStart: isX ? this.lastCellMarked.column : initialRange.columns[0],
                rowEndIndex: rangeEndRow.rowIndex,
                rowEndPinned: rangeEndRow.rowPinned,
                columnEnd: initialRange.columns[colLen - 1]
            });
        }
        if (finalRange) this.performFill({
            event: e,
            initialRange: initialRange,
            finalRange: finalRange,
            shouldUpdateRange: true
        });
    }
    onDragCancel() {
        this.initialXY = null;
        if (!this.markedCells.length) return;
        this.clearMarkedPath();
    }
    performFill({ event: event, initialRange: initialRange, finalRange: finalRange, shouldUpdateRange: shouldUpdateRange }) {
        const { eventSvc: eventSvc, rangeSvc: rangeSvc } = this.beans;
        eventSvc.dispatchEvent({
            type: "fillStart"
        });
        this.handleValueChanged(initialRange, finalRange, event);
        if (shouldUpdateRange) rangeSvc.setCellRanges([
            finalRange
        ]);
        eventSvc.dispatchEvent({
            type: "fillEnd",
            initialRange: initialRange,
            finalRange: finalRange
        });
    }
    getFillHandleDirection() {
        const direction = (0, $jIDNV._getFillHandle)(this.gos)?.direction;
        if (!direction) return "xy";
        if (direction !== "x" && direction !== "y" && direction !== "xy") {
            (0, $jIDNV._warn)(177);
            return "xy";
        }
        return direction;
    }
    handleValueChanged(initialRange, finalRange, e) {
        const { beans: beans } = this;
        const { rangeSvc: rangeSvc, gos: gos, valueSvc: valueSvc } = beans;
        const initialRangeEndRow = rangeSvc.getRangeEndRow(initialRange);
        const initialRangeStartRow = rangeSvc.getRangeStartRow(initialRange);
        const finalRangeEndRow = rangeSvc.getRangeEndRow(finalRange);
        const finalRangeStartRow = rangeSvc.getRangeStartRow(finalRange);
        const isVertical = this.dragAxis === "y";
        if (this.isReduce && !(0, $jIDNV._getFillHandle)(gos)?.suppressClearOnFillReduction) {
            const columns = isVertical ? initialRange.columns : initialRange.columns.filter((col)=>finalRange.columns.indexOf(col) < 0);
            const startRow = isVertical ? (0, $jIDNV._getRowBelow)(beans, finalRangeEndRow) : finalRangeStartRow;
            if (startRow) this.clearCellsInRange(startRow, initialRangeEndRow, columns);
            return;
        }
        const values = [];
        const initialValues = [];
        const initialNonAggregatedValues = [];
        const initialFormattedValues = [];
        let withinInitialRange = true;
        let idx = 0;
        const resetValues = ()=>{
            values.length = 0;
            initialValues.length = 0;
            initialNonAggregatedValues.length = 0;
            initialFormattedValues.length = 0;
            idx = 0;
        };
        const iterateAcrossCells = (column, columns)=>{
            let currentRow = this.isUp ? initialRangeEndRow : initialRangeStartRow;
            let finished = false;
            if (isVertical) {
                withinInitialRange = true;
                resetValues();
            }
            while(!finished && currentRow){
                const rowNode = (0, $jIDNV._getRowNode)(beans, currentRow);
                if (!rowNode) break;
                if (isVertical && column) fillValues(values, column, rowNode, ()=>!(0, $jIDNV._isSameRow)(currentRow, this.isUp ? initialRangeStartRow : initialRangeEndRow));
                else if (columns) {
                    withinInitialRange = true;
                    resetValues();
                    columns.forEach((col)=>fillValues(values, col, rowNode, ()=>col !== (this.isLeft ? initialRange.columns[0] : (0, $jIDNV._last)(initialRange.columns))));
                }
                finished = (0, $jIDNV._isSameRow)(currentRow, this.isUp ? finalRangeStartRow : finalRangeEndRow);
                currentRow = this.isUp ? (0, $jIDNV._getRowAbove)(this.beans, currentRow) : (0, $jIDNV._getRowBelow)(beans, currentRow);
            }
        };
        const fillValues = (currentValues, col, rowNode, updateInitialSet)=>{
            let currentValue;
            let skipValue = false;
            if (withinInitialRange) {
                currentValue = valueSvc.getValue(col, rowNode);
                initialValues.push(currentValue);
                initialNonAggregatedValues.push(valueSvc.getValue(col, rowNode, true));
                initialFormattedValues.push(valueSvc.formatValue(col, rowNode, currentValue));
                withinInitialRange = updateInitialSet();
            } else {
                const { value: value, fromUserFunction: fromUserFunction, sourceCol: sourceCol, sourceRowNode: sourceRowNode } = this.processValues({
                    event: e,
                    values: currentValues,
                    initialValues: initialValues,
                    initialNonAggregatedValues: initialNonAggregatedValues,
                    initialFormattedValues: initialFormattedValues,
                    col: col,
                    rowNode: rowNode,
                    idx: idx++
                });
                currentValue = value;
                if (col.isCellEditable(rowNode)) {
                    const cellValue = valueSvc.getValue(col, rowNode);
                    if (!fromUserFunction) {
                        if (sourceCol) {
                            const sourceColDef = sourceCol.getColDef();
                            if (sourceColDef.useValueFormatterForExport !== false && sourceColDef.valueFormatter) {
                                const formattedValue = valueSvc.formatValue(sourceCol, sourceRowNode, currentValue);
                                if (formattedValue != null) currentValue = formattedValue;
                            }
                        }
                        if (col.getColDef().useValueParserForImport !== false) currentValue = valueSvc.parseValue(col, rowNode, // if no sourceCol, then currentValue is a number
                        sourceCol ? currentValue : (0, $jIDNV._toStringOrNull)(currentValue), cellValue);
                    }
                    if (!fromUserFunction || cellValue !== currentValue) rowNode.setDataValue(col, currentValue, "rangeSvc");
                    else skipValue = true;
                }
            }
            if (!skipValue) currentValues.push({
                value: currentValue,
                column: col,
                rowNode: rowNode
            });
        };
        if (isVertical) initialRange.columns.forEach((col)=>{
            iterateAcrossCells(col);
        });
        else {
            const columns = this.isLeft ? [
                ...finalRange.columns
            ].reverse() : finalRange.columns;
            iterateAcrossCells(void 0, columns);
        }
        this.beans.editSvc?.stopEditing(void 0, {
            source: "fillHandle"
        });
    }
    clearCellsInRange(startRow, endRow, columns) {
        const cellRange = {
            startRow: startRow,
            endRow: endRow,
            columns: columns,
            startColumn: columns[0]
        };
        this.beans.rangeSvc.clearCellRangeCellValues({
            cellRanges: [
                cellRange
            ]
        });
    }
    processValues(params) {
        const { event: event, values: values, initialValues: initialValues, initialNonAggregatedValues: initialNonAggregatedValues, initialFormattedValues: initialFormattedValues, col: col, rowNode: rowNode, idx: idx } = params;
        const userFillOperation = (0, $jIDNV._getFillHandle)(this.gos)?.setFillValue;
        const isVertical = this.dragAxis === "y";
        let direction;
        if (isVertical) direction = this.isUp ? "up" : "down";
        else direction = this.isLeft ? "left" : "right";
        if (userFillOperation) {
            const params2 = (0, $jIDNV._addGridCommonParams)(this.gos, {
                event: event,
                values: values.map(({ value: value })=>value),
                initialValues: initialValues,
                initialNonAggregatedValues: initialNonAggregatedValues,
                initialFormattedValues: initialFormattedValues,
                currentIndex: idx,
                currentCellValue: this.beans.valueSvc.getValue(col, rowNode),
                direction: direction,
                column: col,
                rowNode: rowNode
            });
            const userResult = userFillOperation(params2);
            if (userResult !== false) return {
                value: userResult,
                fromUserFunction: true
            };
        }
        const allNumbers = !values.some(({ value: value })=>{
            const asFloat = parseFloat(value);
            return isNaN(asFloat) || asFloat.toString() !== value.toString();
        });
        if (event.altKey || !allNumbers) {
            if (allNumbers && initialValues.length === 1) {
                const multiplier = this.isUp || this.isLeft ? -1 : 1;
                return {
                    value: parseFloat((0, $jIDNV._last)(values).value) + 1 * multiplier,
                    fromUserFunction: false
                };
            }
            const { value: value, column: sourceCol, rowNode: sourceRowNode } = values[idx % values.length];
            return {
                value: value,
                fromUserFunction: false,
                sourceCol: sourceCol,
                sourceRowNode: sourceRowNode
            };
        }
        return {
            value: (0, $jIDNV._last)($5b7ccabde48fae90$var$findLineByLeastSquares(values.map(({ value: value })=>Number(value)))),
            fromUserFunction: false
        };
    }
    clearValues() {
        this.clearMarkedPath();
        this.clearCellValues();
        this.lastCellMarked = void 0;
        super.clearValues();
    }
    clearMarkedPath() {
        this.markedCells.forEach((cell)=>{
            if (!cell.isAlive()) return;
            const { comp: comp } = cell;
            comp.toggleCss("ag-selection-fill-top", false);
            comp.toggleCss("ag-selection-fill-right", false);
            comp.toggleCss("ag-selection-fill-bottom", false);
            comp.toggleCss("ag-selection-fill-left", false);
        });
        this.markedCells.length = 0;
        this.isUp = false;
        this.isLeft = false;
        this.isReduce = false;
    }
    clearCellValues() {
        this.cellValues.length = 0;
    }
    markPathFrom(initialPosition, currentPosition) {
        this.clearMarkedPath();
        this.clearCellValues();
        if (this.dragAxis === "y") {
            if ((0, $jIDNV._isSameRow)(currentPosition, initialPosition)) return;
            const isBefore = (0, $jIDNV._isRowBefore)(currentPosition, initialPosition);
            const { rangeStartRow: rangeStartRow, rangeEndRow: rangeEndRow } = this;
            if (isBefore && (currentPosition.rowPinned == rangeStartRow.rowPinned && currentPosition.rowIndex >= rangeStartRow.rowIndex || rangeStartRow.rowPinned != rangeEndRow.rowPinned && currentPosition.rowPinned == rangeEndRow.rowPinned && currentPosition.rowIndex <= rangeEndRow.rowIndex)) {
                this.reduceVertical(initialPosition, currentPosition);
                this.isReduce = true;
            } else {
                this.extendVertical(initialPosition, currentPosition, isBefore);
                this.isReduce = false;
            }
        } else {
            const initialColumn = initialPosition.column;
            const currentColumn = currentPosition.column;
            if (initialColumn === currentColumn) return;
            const displayedColumns = this.beans.visibleCols.allCols;
            const initialIndex = displayedColumns.indexOf(initialColumn);
            const currentIndex = displayedColumns.indexOf(currentColumn);
            if (currentIndex <= initialIndex && currentIndex >= displayedColumns.indexOf(this.cellRange.columns[0])) {
                this.reduceHorizontal(initialPosition, currentPosition);
                this.isReduce = true;
            } else {
                this.extendHorizontal(initialPosition, currentPosition, currentIndex < initialIndex);
                this.isReduce = false;
            }
        }
        this.lastCellMarked = currentPosition;
    }
    extendVertical(initialPosition, endPosition, isMovingUp) {
        const beans = this.beans;
        const { rangeSvc: rangeSvc } = beans;
        let row = initialPosition;
        do {
            const cellRange = this.cellRange;
            const colLen = cellRange.columns.length;
            for(let i = 0; i < colLen; i++){
                const column = cellRange.columns[i];
                const rowPos = {
                    rowIndex: row.rowIndex,
                    rowPinned: row.rowPinned
                };
                const cellPos = {
                    ...rowPos,
                    column: column
                };
                const cellInRange = rangeSvc.isCellInSpecificRange(cellPos, cellRange);
                const isInitialRow = (0, $jIDNV._isSameRow)(row, initialPosition);
                if (isMovingUp) this.isUp = true;
                if (!isInitialRow) {
                    const cell = (0, $jIDNV._getCellByPosition)(beans, cellPos);
                    if (cell) {
                        this.markedCells.push(cell);
                        const cellComp = cell.comp;
                        if (!cellInRange) {
                            cellComp.toggleCss("ag-selection-fill-left", i === 0);
                            cellComp.toggleCss("ag-selection-fill-right", i === colLen - 1);
                        }
                        cellComp.toggleCss(isMovingUp ? "ag-selection-fill-top" : "ag-selection-fill-bottom", (0, $jIDNV._isSameRow)(row, endPosition));
                    }
                }
            }
            if ((0, $jIDNV._isSameRow)(row, endPosition)) break;
        }while (// tslint:disable-next-line
        row = isMovingUp ? (0, $jIDNV._getRowAbove)(this.beans, row) : (0, $jIDNV._getRowBelow)(beans, row));
    }
    reduceVertical(initialPosition, endPosition) {
        let row = initialPosition;
        const beans = this.beans;
        do {
            const cellRange = this.cellRange;
            const colLen = cellRange.columns.length;
            const isLastRow = (0, $jIDNV._isSameRow)(row, endPosition);
            for(let i = 0; i < colLen; i++){
                const rowPos = {
                    rowIndex: row.rowIndex,
                    rowPinned: row.rowPinned
                };
                const celPos = {
                    ...rowPos,
                    column: cellRange.columns[i]
                };
                const cell = (0, $jIDNV._getCellByPosition)(beans, celPos);
                if (cell) {
                    this.markedCells.push(cell);
                    cell.comp.toggleCss("ag-selection-fill-bottom", (0, $jIDNV._isSameRow)(row, endPosition));
                }
            }
            if (isLastRow) break;
        }while (row = (0, $jIDNV._getRowAbove)(beans, row));
    }
    extendHorizontal(initialPosition, endPosition, isMovingLeft) {
        const beans = this.beans;
        const { visibleCols: visibleCols } = beans;
        const allCols = visibleCols.allCols;
        const startCol = allCols.indexOf(isMovingLeft ? endPosition.column : initialPosition.column);
        const endCol = allCols.indexOf(isMovingLeft ? this.cellRange.columns[0] : endPosition.column);
        const offset = isMovingLeft ? 0 : 1;
        const colsToMark = allCols.slice(startCol + offset, endCol + offset);
        const { rangeStartRow: rangeStartRow, rangeEndRow: rangeEndRow } = this;
        colsToMark.forEach((column)=>{
            let row = rangeStartRow;
            let isLastRow = false;
            do {
                isLastRow = (0, $jIDNV._isSameRow)(row, rangeEndRow);
                const cell = (0, $jIDNV._getCellByPosition)(beans, {
                    rowIndex: row.rowIndex,
                    rowPinned: row.rowPinned,
                    column: column
                });
                if (cell) {
                    this.markedCells.push(cell);
                    const cellComp = cell.comp;
                    cellComp.toggleCss("ag-selection-fill-top", (0, $jIDNV._isSameRow)(row, rangeStartRow));
                    cellComp.toggleCss("ag-selection-fill-bottom", (0, $jIDNV._isSameRow)(row, rangeEndRow));
                    if (isMovingLeft) {
                        this.isLeft = true;
                        cellComp.toggleCss("ag-selection-fill-left", column === colsToMark[0]);
                    } else cellComp.toggleCss("ag-selection-fill-right", column === (0, $jIDNV._last)(colsToMark));
                }
                row = (0, $jIDNV._getRowBelow)(beans, row);
            }while (!isLastRow);
        });
    }
    reduceHorizontal(initialPosition, endPosition) {
        const beans = this.beans;
        const { visibleCols: visibleCols } = beans;
        const allCols = visibleCols.allCols;
        const startCol = allCols.indexOf(endPosition.column);
        const endCol = allCols.indexOf(initialPosition.column);
        const colsToMark = allCols.slice(startCol, endCol);
        const { rangeStartRow: rangeStartRow, rangeEndRow: rangeEndRow } = this;
        colsToMark.forEach((column)=>{
            let row = rangeStartRow;
            let isLastRow = false;
            do {
                isLastRow = (0, $jIDNV._isSameRow)(row, rangeEndRow);
                const cell = (0, $jIDNV._getCellByPosition)(this.beans, {
                    rowIndex: row.rowIndex,
                    rowPinned: row.rowPinned,
                    column: column
                });
                if (cell) {
                    this.markedCells.push(cell);
                    cell.comp.toggleCss("ag-selection-fill-right", column === colsToMark[0]);
                }
                row = (0, $jIDNV._getRowBelow)(beans, row);
            }while (!isLastRow);
        });
    }
    refresh(cellCtrl) {
        const cellRange = this.beans.rangeSvc.getCellRanges()[0];
        const isColumnRange = !cellRange.startRow || !cellRange.endRow;
        if (isColumnRange) {
            this.destroy();
            return;
        }
        super.refresh(cellCtrl);
    }
};
var $5b7ccabde48fae90$var$AgRangeHandle = class extends $5b7ccabde48fae90$var$AbstractSelectionHandle {
    constructor(){
        super({
            tag: "div",
            cls: "ag-range-handle"
        });
        this.type = 1 /* RANGE */ ;
        this.rangeFixed = false;
    }
    onDrag(_) {
        const lastCellHovered = this.getLastCellHovered();
        if (!lastCellHovered) return;
        const rangeSvc = this.beans.rangeSvc;
        const cellRanges = rangeSvc.getCellRanges();
        const lastRange = (0, $jIDNV._last)(cellRanges);
        if (!this.rangeFixed) {
            this.fixRangeStartEnd(lastRange);
            this.rangeFixed = true;
        }
        this.endPosition = {
            rowIndex: lastCellHovered.rowIndex,
            rowPinned: lastCellHovered.rowPinned,
            column: lastCellHovered.column
        };
        if (cellRanges.length === 2 && cellRanges[0].type === (0, $jIDNV.CellRangeType).DIMENSION && lastRange.type === (0, $jIDNV.CellRangeType).VALUE) {
            const rowChanged = !(0, $jIDNV._isSameRow)(this.endPosition, rangeSvc.getRangeEndRow(lastRange));
            if (rowChanged) rangeSvc.updateRangeEnd(cellRanges[0], {
                ...this.endPosition,
                column: cellRanges[0].columns[0]
            }, true);
        }
        rangeSvc.extendLatestRangeToCell(this.endPosition);
    }
    shouldSkipCell(_) {
        return false;
    }
    onDragEnd(_) {
        const cellRange = (0, $jIDNV._last)(this.beans.rangeSvc.getCellRanges());
        this.fixRangeStartEnd(cellRange);
        this.rangeFixed = false;
    }
    onDragCancel() {
        this.rangeFixed = false;
    }
    fixRangeStartEnd(cellRange) {
        const rangeSvc = this.beans.rangeSvc;
        const startRow = rangeSvc.getRangeStartRow(cellRange);
        const endRow = rangeSvc.getRangeEndRow(cellRange);
        const column = cellRange.columns[0];
        cellRange.startRow = startRow;
        cellRange.endRow = endRow;
        cellRange.startColumn = column;
    }
};
// packages/ag-grid-enterprise/src/rangeSelection/rangeSelection.css-GENERATED.ts
var $5b7ccabde48fae90$var$rangeSelectionCSS = /*css*/ `.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing),.ag-cell-range-selected.ag-cell-range-chart,.ag-cell-range-selected:not(.ag-cell-focus){background-color:var(--ag-range-selection-background-color);&.ag-cell-range-chart{background-color:var(--ag-range-selection-chart-background-color)!important;&.ag-cell-range-chart-category{background-color:var(--ag-range-selection-chart-category-background-color)!important}}}.ag-cell-range-selected-1.ag-cell-range-chart,.ag-cell-range-selected-1:not(.ag-cell-focus),.ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing){background-color:var(--ag-range-selection-background-color)}.ag-cell-range-selected-2.ag-cell-range-chart,.ag-cell-range-selected-2:not(.ag-cell-focus){background-image:linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color))}.ag-cell-range-selected-3.ag-cell-range-chart,.ag-cell-range-selected-3:not(.ag-cell-focus){background-image:linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color)),linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color))}.ag-cell-range-selected-4.ag-cell-range-chart,.ag-cell-range-selected-4:not(.ag-cell-focus){background-image:linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color)),linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color)),linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color))}.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell){&.ag-cell-range-top{border-top-color:var(--ag-range-selection-border-color);border-top-style:var(--ag-range-selection-border-style)}&.ag-cell-range-right{border-right-color:var(--ag-range-selection-border-color);border-right-style:var(--ag-range-selection-border-style)}&.ag-cell-range-bottom{border-bottom-color:var(--ag-range-selection-border-color);border-bottom-style:var(--ag-range-selection-border-style)}&.ag-cell-range-left{border-left-color:var(--ag-range-selection-border-color);border-left-style:var(--ag-range-selection-border-style)}}.ag-cell.ag-selection-fill-top,.ag-cell.ag-selection-fill-top.ag-cell-range-selected{border-top:1px dashed;border-top-color:var(--ag-range-selection-border-color)}:where(.ag-ltr) .ag-cell.ag-selection-fill-right,:where(.ag-ltr) .ag-cell.ag-selection-fill-right.ag-cell-range-selected{border-right:1px dashed var(--ag-range-selection-border-color)!important}:where(.ag-rtl) .ag-cell.ag-selection-fill-right,:where(.ag-rtl) .ag-cell.ag-selection-fill-right.ag-cell-range-selected{border-left:1px dashed var(--ag-range-selection-border-color)!important}.ag-cell.ag-selection-fill-bottom,.ag-cell.ag-selection-fill-bottom.ag-cell-range-selected{border-bottom:1px dashed;border-bottom-color:var(--ag-range-selection-border-color)}:where(.ag-ltr) .ag-cell.ag-selection-fill-left,:where(.ag-ltr) .ag-cell.ag-selection-fill-left.ag-cell-range-selected{border-left:1px dashed var(--ag-range-selection-border-color)!important}:where(.ag-rtl) .ag-cell.ag-selection-fill-left,:where(.ag-rtl) .ag-cell.ag-selection-fill-left.ag-cell-range-selected{border-right:1px dashed var(--ag-range-selection-border-color)!important}.ag-fill-handle,.ag-range-handle{background-color:var(--ag-range-selection-border-color);bottom:-1px;height:6px;position:absolute;width:6px}:where(.ag-ltr) .ag-fill-handle,:where(.ag-ltr) .ag-range-handle{right:-1px}:where(.ag-rtl) .ag-fill-handle,:where(.ag-rtl) .ag-range-handle{left:-1px}.ag-fill-handle{cursor:crosshair}:where(.ag-ltr) .ag-range-handle{cursor:nwse-resize}:where(.ag-rtl) .ag-range-handle{cursor:nesw-resize}`;
// packages/ag-grid-enterprise/src/rangeSelection/rangeSelectionApi.ts
function $5b7ccabde48fae90$var$getCellRanges(beans) {
    return beans.rangeSvc?.getCellRanges() ?? null;
}
function $5b7ccabde48fae90$var$addCellRange(beans, params) {
    beans.rangeSvc?.addCellRange(params);
}
function $5b7ccabde48fae90$var$clearRangeSelection(beans) {
    beans.rangeSvc?.removeAllCellRanges();
}
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_SELECTED = "ag-cell-range-selected";
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_CHART = "ag-cell-range-chart";
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_SINGLE_CELL = "ag-cell-range-single-cell";
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_CHART_CATEGORY = "ag-cell-range-chart-category";
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_HANDLE = "ag-cell-range-handle";
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_TOP = "ag-cell-range-top";
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_RIGHT = "ag-cell-range-right";
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_BOTTOM = "ag-cell-range-bottom";
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_LEFT = "ag-cell-range-left";
function $5b7ccabde48fae90$var$_isRangeHandleEnabled(gos) {
    const selection = gos.get("cellSelection");
    const useNewAPI = selection !== void 0;
    if (!useNewAPI) return gos.get("enableRangeHandle");
    return typeof selection !== "boolean" ? selection.handle?.mode === "range" : false;
}
function $5b7ccabde48fae90$var$_isFillHandleEnabled(gos) {
    const selection = gos.get("cellSelection");
    const useNewAPI = selection !== void 0;
    if (!useNewAPI) return gos.get("enableFillHandle");
    return typeof selection !== "boolean" ? selection.handle?.mode === "fill" : false;
}
var $5b7ccabde48fae90$var$CellRangeFeature = class {
    constructor(beans, cellCtrl){
        this.beans = beans;
        this.cellCtrl = cellCtrl;
        this.rangeSvc = beans.rangeSvc;
    }
    setComp(cellComp) {
        this.cellComp = cellComp;
        this.eGui = this.cellCtrl.eGui;
        this.onCellSelectionChanged();
    }
    onCellSelectionChanged() {
        const cellComp = this.cellComp;
        if (!cellComp) return;
        const { rangeSvc: rangeSvc, cellCtrl: cellCtrl, eGui: eGui } = this;
        const rangeCount = rangeSvc.getCellRangeCount(cellCtrl.cellPosition);
        this.rangeCount = rangeCount;
        const hasChartRange = this.getHasChartRange();
        this.hasChartRange = hasChartRange;
        cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_SELECTED, rangeCount !== 0);
        cellComp.toggleCss(`${$5b7ccabde48fae90$var$CSS_CELL_RANGE_SELECTED}-1`, rangeCount === 1);
        cellComp.toggleCss(`${$5b7ccabde48fae90$var$CSS_CELL_RANGE_SELECTED}-2`, rangeCount === 2);
        cellComp.toggleCss(`${$5b7ccabde48fae90$var$CSS_CELL_RANGE_SELECTED}-3`, rangeCount === 3);
        cellComp.toggleCss(`${$5b7ccabde48fae90$var$CSS_CELL_RANGE_SELECTED}-4`, rangeCount >= 4);
        cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_CHART, hasChartRange);
        (0, $jIDNV._setAriaSelected)(eGui, rangeCount > 0 ? true : void 0);
        cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_SINGLE_CELL, this.isSingleCell());
        this.updateRangeBorders();
        this.refreshHandle();
    }
    updateRangeBorders() {
        const rangeBorders = this.getRangeBorders();
        const isSingleCell = this.isSingleCell();
        const isTop = !isSingleCell && rangeBorders.top;
        const isRight = !isSingleCell && rangeBorders.right;
        const isBottom = !isSingleCell && rangeBorders.bottom;
        const isLeft = !isSingleCell && rangeBorders.left;
        const cellComp = this.cellComp;
        cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_TOP, isTop);
        cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_RIGHT, isRight);
        cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_BOTTOM, isBottom);
        cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_LEFT, isLeft);
    }
    isSingleCell() {
        const { rangeSvc: rangeSvc } = this;
        return this.rangeCount === 1 && !!rangeSvc && !rangeSvc.isMoreThanOneCell();
    }
    getHasChartRange() {
        const { rangeSvc: rangeSvc } = this;
        if (!this.rangeCount || !rangeSvc) return false;
        const cellRanges = rangeSvc.getCellRanges();
        return cellRanges.length > 0 && cellRanges.every((range)=>[
                (0, $jIDNV.CellRangeType).DIMENSION,
                (0, $jIDNV.CellRangeType).VALUE
            ].includes(range.type));
    }
    updateRangeBordersIfRangeCount() {
        if (this.rangeCount > 0) {
            this.updateRangeBorders();
            this.refreshHandle();
        }
    }
    getRangeBorders() {
        const isRtl = this.beans.gos.get("enableRtl");
        let top = false;
        let right = false;
        let bottom = false;
        let left = false;
        const { rangeSvc: rangeSvc, beans: { visibleCols: visibleCols }, cellCtrl: { cellPosition: cellPosition } } = this;
        const thisCol = cellPosition.column;
        const ranges = rangeSvc.getCellRanges().filter((range)=>rangeSvc.isCellInSpecificRange(cellPosition, range));
        if (!ranges.length) return {
            top: top,
            right: right,
            bottom: bottom,
            left: left
        };
        let leftCol;
        let rightCol;
        if (isRtl) {
            leftCol = visibleCols.getColAfter(thisCol);
            rightCol = visibleCols.getColBefore(thisCol);
        } else {
            leftCol = visibleCols.getColBefore(thisCol);
            rightCol = visibleCols.getColAfter(thisCol);
        }
        if (!leftCol) left = true;
        if (!rightCol) right = true;
        for(let i = 0; i < ranges.length; i++){
            if (top && right && bottom && left) break;
            const range = ranges[i];
            const startRow = rangeSvc.getRangeStartRow(range);
            const endRow = rangeSvc.getRangeEndRow(range);
            if (!top && (0, $jIDNV._isSameRow)(startRow, cellPosition)) top = true;
            if (!bottom && (0, $jIDNV._isSameRow)(endRow, cellPosition)) bottom = true;
            if (!left && leftCol && range.columns.indexOf(leftCol) < 0) left = true;
            if (!right && rightCol && range.columns.indexOf(rightCol) < 0) right = true;
        }
        return {
            top: top,
            right: right,
            bottom: bottom,
            left: left
        };
    }
    refreshHandle() {
        if (this.beans.context.isDestroyed()) return;
        const shouldHaveSelectionHandle = this.shouldHaveSelectionHandle();
        if (this.selectionHandle && !shouldHaveSelectionHandle) this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle);
        if (shouldHaveSelectionHandle) this.addSelectionHandle();
        this.cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_HANDLE, !!this.selectionHandle);
    }
    shouldHaveSelectionHandle() {
        const { gos: gos, editSvc: editSvc } = this.beans;
        const rangeSvc = this.rangeSvc;
        const cellRanges = rangeSvc.getCellRanges();
        const rangesLen = cellRanges.length;
        if (this.rangeCount < 1 || rangesLen < 1) return false;
        const cellRange = (0, $jIDNV._last)(cellRanges);
        const { cellPosition: cellPosition, column: column } = this.cellCtrl;
        const isFillHandleAvailable = $5b7ccabde48fae90$var$_isFillHandleEnabled(gos) && !column.isSuppressFillHandle();
        const isRangeHandleAvailable = $5b7ccabde48fae90$var$_isRangeHandleEnabled(gos);
        const isCellEditing = editSvc?.isEditing(this.cellCtrl, {
            withOpenEditor: true
        });
        let handleIsAvailable = rangesLen === 1 && !isCellEditing && (isFillHandleAvailable || isRangeHandleAvailable);
        if (this.hasChartRange) {
            const hasCategoryRange = cellRanges[0].type === (0, $jIDNV.CellRangeType).DIMENSION;
            const isCategoryCell = hasCategoryRange && rangeSvc.isCellInSpecificRange(cellPosition, cellRanges[0]);
            this.cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_CHART_CATEGORY, isCategoryCell);
            handleIsAvailable = cellRange.type === (0, $jIDNV.CellRangeType).VALUE;
        }
        return handleIsAvailable && cellRange.endRow != null && rangeSvc.isContiguousRange(cellRange) && rangeSvc.isBottomRightCell(cellRange, cellPosition);
    }
    addSelectionHandle() {
        const { beans: beans, rangeSvc: rangeSvc } = this;
        const cellRangeType = (0, $jIDNV._last)(rangeSvc.getCellRanges()).type;
        const selectionHandleFill = $5b7ccabde48fae90$var$_isFillHandleEnabled(beans.gos) && (0, $jIDNV._missing)(cellRangeType);
        const type = selectionHandleFill ? 0 /* FILL */  : 1 /* RANGE */ ;
        if (this.selectionHandle && this.selectionHandle.getType() !== type) this.selectionHandle = beans.context.destroyBean(this.selectionHandle);
        if (!this.selectionHandle) {
            const selectionHandle = beans.registry.createDynamicBean(type === 0 /* FILL */  ? "fillHandle" : "rangeHandle", false);
            if (selectionHandle) this.selectionHandle = beans.context.createBean(selectionHandle);
        }
        this.selectionHandle?.refresh(this.cellCtrl);
    }
    destroy() {
        this.beans.context.destroyBean(this.selectionHandle);
    }
};
var $5b7ccabde48fae90$var$DragListenerFeature = class extends (0, $jIDNV.BeanStub) {
    constructor(eContainer){
        super();
        this.eContainer = eContainer;
    }
    postConstruct() {
        const { beans: beans, gos: gos, eContainer: eContainer } = this;
        const rangeSvc = beans.rangeSvc;
        const params = {
            eElement: eContainer,
            onDragStart: rangeSvc.onDragStart.bind(rangeSvc),
            onDragStop: rangeSvc.onDragStop.bind(rangeSvc),
            onDragging: rangeSvc.onDragging.bind(rangeSvc)
        };
        const dragSvc = beans.dragSvc;
        const enableFeature = dragSvc.addDragSource.bind(dragSvc, params);
        const disableFeature = dragSvc.removeDragSource.bind(dragSvc, params);
        this.addManagedPropertyListeners([
            "enableRangeSelection",
            "cellSelection"
        ], ()=>{
            if ((0, $jIDNV._isCellSelectionEnabled)(gos)) enableFeature();
            else disableFeature();
        });
        this.addDestroyFunc(disableFeature);
        if ((0, $jIDNV._isCellSelectionEnabled)(gos)) enableFeature();
    }
};
var $5b7ccabde48fae90$var$RangeHeaderHighlightFeature = class extends (0, $jIDNV.BeanStub) {
    constructor(column, comp){
        super();
        this.column = column;
        this.comp = comp;
        this.columnMap = /* @__PURE__ */ new Map();
        this.isActive = false;
        this.resetColumnMap();
    }
    postConstruct() {
        this.addManagedPropertyListener("cellSelection", ()=>{
            this.refreshActive();
        });
        this.refreshActive();
        this.setupRangeHeaderHighlight();
    }
    resetColumnMap() {
        this.columnMap.clear();
        let columns;
        if (this.column.isColumn) columns = [
            this.column
        ];
        else columns = this.column.getDisplayedLeafColumns();
        for (const column of columns)this.columnMap.set(column, false);
    }
    refreshActive() {
        const { gos: gos, rangeSvc: rangeSvc } = this.beans;
        const selection = gos.get("cellSelection");
        this.isActive = !!(selection && rangeSvc && typeof selection === "object" && selection.enableHeaderHighlight);
    }
    setupRangeHeaderHighlight() {
        const listener = this.onRangeSelectionChanged.bind(this);
        this.addManagedEventListeners({
            rangeSelectionChanged: listener,
            columnPinned: listener,
            columnMoved: listener,
            columnGroupOpened: listener
        });
        listener();
    }
    onRangeSelectionChanged() {
        if (!this.isActive) return;
        this.resetColumnMap();
        const ranges = this.beans.rangeSvc.getCellRanges();
        let hasRange = false;
        let isAllColumnRange = true;
        for (const range of ranges){
            if (hasRange) break;
            for (const column of range.columns)if (this.columnMap.has(column)) {
                this.columnMap.set(column, true);
                hasRange || (hasRange = true);
            }
        }
        for (const value of Array.from(this.columnMap.values()))if (value === false) {
            isAllColumnRange = false;
            break;
        }
        this.comp.toggleCss("ag-header-range-highlight", hasRange && isAllColumnRange);
    }
    destroy() {
        super.destroy();
        this.comp = null;
        this.column = null;
    }
};
// packages/ag-grid-enterprise/src/rangeSelection/rangeService.ts
var $5b7ccabde48fae90$var$RangeService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "rangeSvc";
        this.cellRanges = [];
        this.bodyScrollListener = this.onBodyScroll.bind(this);
        this.dragging = false;
        this.intersectionRange = false;
    }
    wireBeans(beans) {
        this.rowModel = beans.rowModel;
        this.dragSvc = beans.dragSvc;
        this.colModel = beans.colModel;
        this.visibleCols = beans.visibleCols;
        this.cellNavigation = beans.cellNavigation;
        this.ctrlsSvc = beans.ctrlsSvc;
        this.valueSvc = beans.valueSvc;
    }
    postConstruct() {
        const onColumnsChanged = this.onColumnsChanged.bind(this);
        const removeAllCellRanges = ()=>this.removeAllCellRanges();
        const refreshLastRangeStart = this.refreshLastRangeStart.bind(this);
        this.addManagedEventListeners({
            newColumnsLoaded: onColumnsChanged,
            columnVisible: onColumnsChanged,
            columnValueChanged: onColumnsChanged,
            columnPivotModeChanged: removeAllCellRanges,
            columnRowGroupChanged: removeAllCellRanges,
            columnPivotChanged: removeAllCellRanges,
            columnGroupOpened: refreshLastRangeStart,
            columnMoved: refreshLastRangeStart,
            columnPinned: refreshLastRangeStart
        });
        this.ctrlsSvc.whenReady(this, (p)=>{
            const gridBodyCtrl = p.gridBodyCtrl;
            this.autoScrollService = new (0, $jIDNV.AutoScrollService)({
                scrollContainer: gridBodyCtrl.eBodyViewport,
                scrollAxis: "xy",
                getVerticalPosition: ()=>gridBodyCtrl.scrollFeature.getVScrollPosition().top,
                setVerticalPosition: (position)=>gridBodyCtrl.scrollFeature.setVerticalScrollPosition(position),
                getHorizontalPosition: ()=>gridBodyCtrl.scrollFeature.getHScrollPosition().left,
                setHorizontalPosition: (position)=>gridBodyCtrl.scrollFeature.setHorizontalScrollPosition(position),
                shouldSkipVerticalScroll: ()=>!(0, $jIDNV._isDomLayout)(this.gos, "normal"),
                shouldSkipHorizontalScroll: ()=>!gridBodyCtrl.scrollFeature.isHorizontalScrollShowing()
            });
        });
    }
    // Drag And Drop Target Methods
    onDragStart(mouseEvent) {
        if (!(0, $jIDNV._isCellSelectionEnabled)(this.gos)) return;
        const { ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = mouseEvent;
        const isMultiKey = ctrlKey || metaKey;
        const allowMulti = !(0, $jIDNV._getSuppressMultiRanges)(this.gos);
        const isMultiSelect = allowMulti ? isMultiKey : false;
        const extendRange = shiftKey && !!this.cellRanges?.length;
        if (!isMultiSelect && (!extendRange || (0, $jIDNV._exists)((0, $jIDNV._last)(this.cellRanges).type))) this.removeAllCellRanges(true);
        const startTarget = this.dragSvc.startTarget;
        if (startTarget) this.updateValuesOnMove(startTarget);
        if (!this.lastCellHovered) return;
        this.dragging = true;
        this.lastMouseEvent = mouseEvent;
        this.intersectionRange = isMultiSelect && this.getCellRangeCount(this.lastCellHovered) > 1;
        if (!extendRange) this.setNewestRangeStartCell(this.lastCellHovered);
        if (this.cellRanges.length > 0) this.draggingRange = (0, $jIDNV._last)(this.cellRanges);
        else {
            const mouseRowPosition = {
                rowIndex: this.lastCellHovered.rowIndex,
                rowPinned: this.lastCellHovered.rowPinned
            };
            const columns = this.getColumnsFromModel([
                this.lastCellHovered.column
            ]);
            if (!columns || !columns.length) return;
            this.draggingRange = {
                startRow: mouseRowPosition,
                endRow: mouseRowPosition,
                columns: columns,
                startColumn: this.newestRangeStartCell.column
            };
            this.cellRanges.push(this.draggingRange);
        }
        this.ctrlsSvc.getGridBodyCtrl().eBodyViewport.addEventListener("scroll", this.bodyScrollListener, {
            passive: true
        });
        this.dispatchChangedEvent(true, false, this.draggingRange.id);
    }
    onDragging(mouseEvent) {
        const { dragging: dragging, lastCellHovered: lastCellHovered, newestRangeStartCell: newestRangeStartCell, autoScrollService: autoScrollService, cellHasChanged: cellHasChanged } = this;
        if (!dragging || !mouseEvent) return;
        this.updateValuesOnMove(mouseEvent.target);
        this.lastMouseEvent = mouseEvent;
        const isMouseAndStartInPinned = (position)=>lastCellHovered && lastCellHovered.rowPinned === position && newestRangeStartCell.rowPinned === position;
        const skipVerticalScroll = isMouseAndStartInPinned("top") || isMouseAndStartInPinned("bottom");
        autoScrollService.check(mouseEvent, skipVerticalScroll);
        if (!cellHasChanged || !lastCellHovered) return;
        const startColumn = newestRangeStartCell?.column;
        const currentColumn = lastCellHovered?.column;
        const columns = this.calculateColumnsBetween(startColumn, currentColumn);
        if (!columns) return;
        const { rowIndex: rowIndex, rowPinned: rowPinned } = lastCellHovered;
        this.draggingRange.endRow = {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        };
        this.draggingRange.columns = columns;
        this.dispatchChangedEvent(false, false, this.draggingRange.id);
    }
    onDragStop() {
        if (!this.dragging) return;
        const { id: id } = this.draggingRange;
        this.autoScrollService.ensureCleared();
        this.ctrlsSvc.getGridBodyCtrl().eBodyViewport.removeEventListener("scroll", this.bodyScrollListener);
        this.lastMouseEvent = null;
        this.dragging = false;
        this.draggingRange = void 0;
        this.lastCellHovered = void 0;
        if (this.intersectionRange) {
            this.intersectionRange = false;
            this.intersectLastRange();
        }
        this.dispatchChangedEvent(false, true, id);
    }
    // Called for both columns loaded & column visibility events
    onColumnsChanged() {
        this.refreshLastRangeStart();
        const allColumns = this.visibleCols.allCols;
        this.cellRanges.forEach((cellRange)=>{
            const beforeCols = cellRange.columns;
            cellRange.columns = cellRange.columns.filter((col)=>col.isVisible() && allColumns.indexOf(col) !== -1);
            const colsInRangeChanged = !(0, $jIDNV._areEqual)(beforeCols, cellRange.columns);
            if (colsInRangeChanged) this.dispatchChangedEvent(false, true, cellRange.id);
        });
        const countBefore = this.cellRanges.length;
        this.cellRanges = this.cellRanges.filter((range)=>range.columns.length > 0);
        if (countBefore > this.cellRanges.length) this.dispatchChangedEvent(false, true);
    }
    refreshLastRangeStart() {
        const lastRange = (0, $jIDNV._last)(this.cellRanges);
        if (!lastRange) return;
        this.refreshRangeStart(lastRange);
    }
    isContiguousRange(cellRange) {
        const rangeColumns = cellRange.columns;
        if (!rangeColumns.length) return false;
        const allColumns = this.visibleCols.allCols;
        const allPositions = rangeColumns.map((c)=>allColumns.indexOf(c)).sort((a, b)=>a - b);
        return (0, $jIDNV._last)(allPositions) - allPositions[0] + 1 === rangeColumns.length;
    }
    getRangeStartRow(cellRange) {
        if (cellRange.startRow && cellRange.endRow) return (0, $jIDNV._isRowBefore)(cellRange.startRow, cellRange.endRow) ? cellRange.startRow : cellRange.endRow;
        const pinnedTopRowCount = this.beans.pinnedRowModel?.getPinnedTopRowCount() ?? 0;
        const rowPinned = pinnedTopRowCount > 0 ? "top" : null;
        return {
            rowIndex: 0,
            rowPinned: rowPinned
        };
    }
    getRangeEndRow(cellRange) {
        if (cellRange.startRow && cellRange.endRow) return (0, $jIDNV._isRowBefore)(cellRange.startRow, cellRange.endRow) ? cellRange.endRow : cellRange.startRow;
        const pinnedBottomRowCount = this.beans.pinnedRowModel?.getPinnedBottomRowCount() ?? 0;
        const pinnedBottom = pinnedBottomRowCount > 0;
        if (pinnedBottom) return {
            rowIndex: pinnedBottomRowCount - 1,
            rowPinned: "bottom"
        };
        return {
            rowIndex: this.rowModel.getRowCount() - 1,
            rowPinned: null
        };
    }
    setRangeToCell(cell, appendRange = false) {
        const { gos: gos } = this;
        if (!(0, $jIDNV._isCellSelectionEnabled)(gos)) return;
        const isRowNumbersEnabled = gos.get("rowNumbers");
        const allColumnsRange = (0, $jIDNV.isRowNumberCol)(cell.column);
        if (isRowNumbersEnabled) this.setSelectionMode(allColumnsRange);
        const columns = this.calculateColumnsBetween(cell.column, cell.column);
        if (!columns) return;
        const suppressMultiRangeSelections = (0, $jIDNV._getSuppressMultiRanges)(this.gos);
        if (suppressMultiRangeSelections || !appendRange || (0, $jIDNV._missing)(this.cellRanges)) this.removeAllCellRanges(true);
        const rowForCell = {
            rowIndex: cell.rowIndex,
            rowPinned: cell.rowPinned
        };
        const cellRange = {
            startRow: rowForCell,
            endRow: rowForCell,
            columns: columns,
            startColumn: cell.column
        };
        this.cellRanges.push(cellRange);
        this.setNewestRangeStartCell(cell);
        this.onDragStop();
        this.dispatchChangedEvent(true, true);
    }
    extendLatestRangeToCell(cellPosition) {
        if (this.isEmpty() || !this.newestRangeStartCell) return;
        const cellRange = (0, $jIDNV._last)(this.cellRanges);
        this.setSelectionMode((0, $jIDNV.isRowNumberCol)(cellPosition.column));
        this.updateRangeEnd(cellRange, cellPosition);
    }
    updateRangeEnd(cellRange, cellPosition, silent = false) {
        const endColumn = cellPosition.column;
        const colsToAdd = this.calculateColumnsBetween(cellRange.startColumn, endColumn);
        if (!colsToAdd || this.isLastCellOfRange(cellRange, cellPosition)) return;
        cellRange.columns = colsToAdd;
        cellRange.endRow = {
            rowIndex: cellPosition.rowIndex,
            rowPinned: cellPosition.rowPinned
        };
        if (!silent) this.dispatchChangedEvent(true, true, cellRange.id);
    }
    getRangeEdgeColumns(cellRange) {
        const allColumns = this.visibleCols.allCols;
        const allIndices = cellRange.columns.map((c)=>allColumns.indexOf(c)).filter((i)=>i > -1).sort((a, b)=>a - b);
        return {
            left: allColumns[allIndices[0]],
            right: allColumns[(0, $jIDNV._last)(allIndices)]
        };
    }
    // returns true if successful, false if not successful
    extendLatestRangeInDirection(event) {
        if (this.isEmpty() || !this.newestRangeStartCell) return;
        const key = event.key;
        const ctrlKey = event.ctrlKey || event.metaKey;
        const lastRange = (0, $jIDNV._last)(this.cellRanges);
        const startCell = this.newestRangeStartCell;
        const firstCol = lastRange.columns[0];
        const lastCol = (0, $jIDNV._last)(lastRange.columns);
        const endCellIndex = lastRange.endRow.rowIndex;
        const endCellFloating = lastRange.endRow.rowPinned;
        const endCellColumn = startCell.column === firstCol ? lastCol : firstCol;
        const endCell = {
            column: endCellColumn,
            rowIndex: endCellIndex,
            rowPinned: endCellFloating
        };
        const newEndCell = this.cellNavigation.getNextCellToFocus(key, endCell, ctrlKey);
        if (!newEndCell) return;
        this.setCellRange({
            rowStartIndex: startCell.rowIndex,
            rowStartPinned: startCell.rowPinned,
            rowEndIndex: newEndCell.rowIndex,
            rowEndPinned: newEndCell.rowPinned,
            columnStart: startCell.column,
            columnEnd: newEndCell.column
        });
        return newEndCell;
    }
    setCellRange(params) {
        if (!(0, $jIDNV._isCellSelectionEnabled)(this.gos)) return;
        this.removeAllCellRanges(true);
        this.addCellRange(params);
    }
    setCellRanges(cellRanges) {
        if ((0, $jIDNV._areEqual)(this.cellRanges, cellRanges)) return;
        if (!this.verifyCellRanges(this.gos)) return;
        this.removeAllCellRanges(true);
        for (const cellRange of cellRanges){
            if (cellRange.columns && cellRange.startRow) {
                const columns = this.getColumnsFromModel(cellRange.columns);
                if (!columns || columns.length === 0) continue;
                cellRange.columns = columns;
                const { startRow: startRow } = cellRange;
                this.setNewestRangeStartCell({
                    rowIndex: startRow.rowIndex,
                    rowPinned: startRow.rowPinned,
                    column: cellRange.columns[0]
                });
            }
            this.cellRanges.push(cellRange);
        }
        this.dispatchChangedEvent(false, true);
    }
    clearCellRangeCellValues(params) {
        const { beans: beans, valueSvc: valueSvc, eventSvc: eventSvc } = this;
        const { cellEventSource: cellEventSource = "rangeSvc", dispatchWrapperEvents: dispatchWrapperEvents, wrapperEventSource: wrapperEventSource = "deleteKey" } = params;
        let { cellRanges: cellRanges } = params;
        if (dispatchWrapperEvents) {
            eventSvc.dispatchEvent({
                type: "cellSelectionDeleteStart",
                source: wrapperEventSource
            });
            eventSvc.dispatchEvent({
                type: "rangeDeleteStart",
                source: wrapperEventSource
            });
        }
        if (!cellRanges) cellRanges = this.cellRanges;
        cellRanges.forEach((cellRange)=>{
            this.forEachRowInRange(cellRange, (rowPosition)=>{
                const rowNode = (0, $jIDNV._getRowNode)(beans, rowPosition);
                if (!rowNode) return;
                for(let i = 0; i < cellRange.columns.length; i++){
                    const column = this.getColumnFromModel(cellRange.columns[i]);
                    if (!column || !column.isCellEditable(rowNode)) continue;
                    const emptyValue = valueSvc.getDeleteValue(column, rowNode);
                    rowNode.setDataValue(column, emptyValue, cellEventSource);
                }
            });
        });
        if (dispatchWrapperEvents) {
            eventSvc.dispatchEvent({
                type: "cellSelectionDeleteEnd",
                source: wrapperEventSource
            });
            eventSvc.dispatchEvent({
                type: "rangeDeleteEnd",
                source: wrapperEventSource
            });
        }
    }
    createCellRangeFromCellRangeParams(params) {
        return this.createPartialCellRangeFromRangeParams(params, false);
    }
    // Range service can't normally support a range without columns, but charts can
    createPartialCellRangeFromRangeParams(params, allowEmptyColumns) {
        const { columns: paramColumns, columnStart: columnStart, columnEnd: columnEnd, rowStartIndex: rowStartIndex, rowStartPinned: rowStartPinned, rowEndIndex: rowEndIndex, rowEndPinned: rowEndPinned } = params;
        const columnInfo = this.getColumnsFromParams(paramColumns, columnStart, columnEnd);
        if (!columnInfo || !allowEmptyColumns && columnInfo.columns.length === 0) return;
        const { columns: columns, startsOnTheRight: startsOnTheRight } = columnInfo;
        const startRow = this.createRowPosition(rowStartIndex, rowStartPinned);
        const endRow = this.createRowPosition(rowEndIndex, rowEndPinned);
        return {
            startRow: startRow,
            endRow: endRow,
            columns: columns,
            startColumn: this.getColumnFromModel(columnStart) ?? (startsOnTheRight ? (0, $jIDNV._last)(columns) : columns[0])
        };
    }
    addCellRange(params) {
        const gos = this.gos;
        if (!(0, $jIDNV._isCellSelectionEnabled)(gos) || !this.verifyCellRanges(gos)) return;
        this.setSelectionMode(false);
        const newRange = this.createCellRangeFromCellRangeParams(params);
        if (newRange) {
            if (newRange.startRow) this.setNewestRangeStartCell({
                rowIndex: newRange.startRow.rowIndex,
                rowPinned: newRange.startRow.rowPinned,
                column: newRange.startColumn
            });
            this.cellRanges.push(newRange);
            this.dispatchChangedEvent(false, true, newRange.id);
        }
    }
    getCellRanges() {
        return this.cellRanges;
    }
    isEmpty() {
        return this.cellRanges.length === 0;
    }
    isMoreThanOneCell() {
        const len = this.cellRanges.length;
        if (len === 0) return false;
        if (len > 1) return true;
        const range = this.cellRanges[0];
        const startRow = this.getRangeStartRow(range);
        const endRow = this.getRangeEndRow(range);
        return startRow.rowPinned !== endRow.rowPinned || startRow.rowIndex !== endRow.rowIndex || range.columns.length !== 1;
    }
    areAllRangesAbleToMerge() {
        const rowToColumnMap = /* @__PURE__ */ new Map();
        const len = this.cellRanges.length;
        if (len <= 1) return true;
        this.cellRanges.forEach((range)=>{
            this.forEachRowInRange(range, (row)=>{
                const rowName = `${row.rowPinned || "normal"}_${row.rowIndex}`;
                const columns = rowToColumnMap.get(rowName);
                const currentRangeColIds = range.columns.map((col)=>col.getId());
                if (columns) {
                    const filteredColumns = currentRangeColIds.filter((col)=>columns.indexOf(col) === -1);
                    columns.push(...filteredColumns);
                } else rowToColumnMap.set(rowName, currentRangeColIds);
            });
        });
        let columnsString;
        for (const val of rowToColumnMap.values()){
            const currentValString = val.sort().join();
            if (columnsString === void 0) {
                columnsString = currentValString;
                continue;
            }
            if (columnsString !== currentValString) return false;
        }
        return true;
    }
    removeAllCellRanges(silent) {
        if (this.isEmpty()) return;
        this.onDragStop();
        this.cellRanges.length = 0;
        if (!silent) this.dispatchChangedEvent(false, true);
    }
    isCellInAnyRange(cell) {
        return this.getCellRangeCount(cell) > 0;
    }
    isCellInSpecificRange(cell, range) {
        const columnInRange = range.columns !== null && range.columns.includes(cell.column);
        const rowInRange = this.isRowInRange(cell.rowIndex, cell.rowPinned, range);
        return columnInRange && rowInRange;
    }
    isBottomRightCell(cellRange, cell) {
        const allColumns = this.visibleCols.allCols;
        const allPositions = cellRange.columns.map((c)=>allColumns.indexOf(c)).sort((a, b)=>a - b);
        const { startRow: startRow, endRow: endRow } = cellRange;
        const lastRow = (0, $jIDNV._isRowBefore)(startRow, endRow) ? endRow : startRow;
        const isRightColumn = allColumns.indexOf(cell.column) === (0, $jIDNV._last)(allPositions);
        const isLastRow = cell.rowIndex === lastRow.rowIndex && (0, $jIDNV._makeNull)(cell.rowPinned) === (0, $jIDNV._makeNull)(lastRow.rowPinned);
        return isRightColumn && isLastRow;
    }
    // returns the number of ranges this cell is in
    getCellRangeCount(cell) {
        if (this.isEmpty()) return 0;
        return this.cellRanges.filter((cellRange)=>this.isCellInSpecificRange(cell, cellRange)).length;
    }
    isRowInRange(rowIndex, rowPinned, cellRange) {
        const firstRow = this.getRangeStartRow(cellRange);
        const lastRow = this.getRangeEndRow(cellRange);
        const thisRow = {
            rowIndex: rowIndex,
            rowPinned: rowPinned || null
        };
        const equalsFirstRow = thisRow.rowIndex === firstRow.rowIndex && thisRow.rowPinned == firstRow.rowPinned;
        const equalsLastRow = thisRow.rowIndex === lastRow.rowIndex && thisRow.rowPinned == lastRow.rowPinned;
        if (equalsFirstRow || equalsLastRow) return true;
        const afterFirstRow = !(0, $jIDNV._isRowBefore)(thisRow, firstRow);
        const beforeLastRow = (0, $jIDNV._isRowBefore)(thisRow, lastRow);
        return afterFirstRow && beforeLastRow;
    }
    intersectLastRange(fromMouseClick) {
        if (fromMouseClick && this.dragging) return;
        if ((0, $jIDNV._getSuppressMultiRanges)(this.gos)) return;
        if (this.isEmpty()) return;
        const lastRange = (0, $jIDNV._last)(this.cellRanges);
        const intersectionStartRow = this.getRangeStartRow(lastRange);
        const intersectionEndRow = this.getRangeEndRow(lastRange);
        const newRanges = [];
        this.cellRanges.slice(0, -1).forEach((range)=>{
            const startRow = this.getRangeStartRow(range);
            const endRow = this.getRangeEndRow(range);
            const cols = range.columns;
            const intersectCols = cols.filter((col)=>lastRange.columns.indexOf(col) === -1);
            if (intersectCols.length === cols.length) {
                newRanges.push(range);
                return;
            }
            if ((0, $jIDNV._isRowBefore)(intersectionEndRow, startRow) || (0, $jIDNV._isRowBefore)(endRow, intersectionStartRow)) {
                newRanges.push(range);
                return;
            }
            const rangeCountBefore = newRanges.length;
            if ((0, $jIDNV._isRowBefore)(startRow, intersectionStartRow)) {
                const top = {
                    columns: [
                        ...cols
                    ],
                    startColumn: lastRange.startColumn,
                    startRow: {
                        ...startRow
                    },
                    endRow: (0, $jIDNV._getRowAbove)(this.beans, intersectionStartRow)
                };
                newRanges.push(top);
            }
            if (intersectCols.length > 0) {
                const middle = {
                    columns: intersectCols,
                    startColumn: intersectCols.includes(lastRange.startColumn) ? lastRange.startColumn : intersectCols[0],
                    startRow: this.rowMax([
                        {
                            ...intersectionStartRow
                        },
                        {
                            ...startRow
                        }
                    ]),
                    endRow: this.rowMin([
                        {
                            ...intersectionEndRow
                        },
                        {
                            ...endRow
                        }
                    ])
                };
                newRanges.push(middle);
            }
            if ((0, $jIDNV._isRowBefore)(intersectionEndRow, endRow)) newRanges.push({
                columns: [
                    ...cols
                ],
                startColumn: lastRange.startColumn,
                startRow: (0, $jIDNV._getRowBelow)(this.beans, intersectionEndRow),
                endRow: {
                    ...endRow
                }
            });
            if (newRanges.length - rangeCountBefore === 1) newRanges[newRanges.length - 1].id = range.id;
        });
        this.cellRanges = newRanges;
        if (fromMouseClick) this.dispatchChangedEvent(false, true);
    }
    createRangeHighlightFeature(compBean, column, headerComp) {
        compBean.createManagedBean(new $5b7ccabde48fae90$var$RangeHeaderHighlightFeature(column, headerComp));
    }
    setSelectionMode(allColumns) {
        this.selectionMode = allColumns ? 1 /* ALL_COLUMNS */  : 0 /* NORMAL */ ;
    }
    refreshRangeStart(cellRange) {
        const { startColumn: startColumn, columns: columns } = cellRange;
        const moveColInCellRange = (colToMove, moveToFront)=>{
            const otherCols = cellRange.columns.filter((col)=>col !== colToMove);
            if (colToMove) {
                cellRange.startColumn = colToMove;
                cellRange.columns = moveToFront ? [
                    colToMove,
                    ...otherCols
                ] : [
                    ...otherCols,
                    colToMove
                ];
            } else cellRange.columns = otherCols;
        };
        const { left: left, right: right } = this.getRangeEdgeColumns(cellRange);
        const shouldMoveLeftCol = startColumn === columns[0] && startColumn !== left;
        if (shouldMoveLeftCol) {
            moveColInCellRange(left, true);
            return;
        }
        const shouldMoveRightCol = startColumn === (0, $jIDNV._last)(columns) && startColumn === right;
        if (shouldMoveRightCol) {
            moveColInCellRange(right, false);
            return;
        }
    }
    setNewestRangeStartCell(position) {
        this.newestRangeStartCell = position;
    }
    getColumnsFromParams(columns, columnA, columnB) {
        const noColsInfo = !columns && !columnA && !columnB;
        let processedColumns;
        let startsOnTheRight = false;
        if (noColsInfo || columns) processedColumns = this.getColumnsFromModel(noColsInfo ? void 0 : columns);
        else if (columnA && columnB) {
            processedColumns = this.calculateColumnsBetween(columnA, columnB);
            if (processedColumns && processedColumns.length) startsOnTheRight = processedColumns[0] !== this.getColumnFromModel(columnA);
        }
        return processedColumns ? {
            columns: processedColumns,
            startsOnTheRight: startsOnTheRight
        } : void 0;
    }
    createRowPosition(rowIndex, rowPinned) {
        return rowIndex != null ? {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        } : void 0;
    }
    verifyCellRanges(gos) {
        const invalid = (0, $jIDNV._isUsingNewCellSelectionAPI)(gos) && (0, $jIDNV._getSuppressMultiRanges)(gos) && this.cellRanges.length > 1;
        if (invalid) (0, $jIDNV._warn)(93);
        return !invalid;
    }
    forEachRowInRange(cellRange, callback) {
        const topRow = this.getRangeStartRow(cellRange);
        const bottomRow = this.getRangeEndRow(cellRange);
        let currentRow = topRow;
        while(currentRow){
            callback(currentRow);
            if ((0, $jIDNV._isSameRow)(currentRow, bottomRow)) break;
            currentRow = (0, $jIDNV._getRowBelow)(this.beans, currentRow);
        }
    }
    // as the user is dragging outside of the panel, the div starts to scroll, which in turn
    // means we are selection more (or less) cells, but the mouse isn't moving, so we recalculate
    // the selection my mimicking a new mouse event
    onBodyScroll() {
        if (this.dragging && this.lastMouseEvent) this.onDragging(this.lastMouseEvent);
    }
    isLastCellOfRange(cellRange, cell) {
        const { startRow: startRow, endRow: endRow } = cellRange;
        const lastRow = (0, $jIDNV._isRowBefore)(startRow, endRow) ? endRow : startRow;
        const isLastRow = cell.rowIndex === lastRow.rowIndex && cell.rowPinned === lastRow.rowPinned;
        const rangeFirstIndexColumn = cellRange.columns[0];
        const rangeLastIndexColumn = (0, $jIDNV._last)(cellRange.columns);
        const lastRangeColumn = cellRange.startColumn === rangeFirstIndexColumn ? rangeLastIndexColumn : rangeFirstIndexColumn;
        const isLastColumn = cell.column === lastRangeColumn;
        return isLastColumn && isLastRow;
    }
    rowMax(rows) {
        let max;
        rows.forEach((row)=>{
            if (max === void 0 || (0, $jIDNV._isRowBefore)(max, row)) max = row;
        });
        return max;
    }
    rowMin(rows) {
        let min;
        rows.forEach((row)=>{
            if (min === void 0 || (0, $jIDNV._isRowBefore)(row, min)) min = row;
        });
        return min;
    }
    updateValuesOnMove(eventTarget) {
        const cellCtrl = (0, $jIDNV._getCellCtrlForEventTarget)(this.gos, eventTarget);
        const cell = cellCtrl?.cellPosition;
        this.cellHasChanged = false;
        if (!cell || this.lastCellHovered && (0, $jIDNV._areCellsEqual)(cell, this.lastCellHovered)) return;
        const editing = this.beans.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        });
        if (editing) {
            this.dragSvc.cancelDrag(eventTarget);
            return;
        }
        if (this.lastCellHovered) this.cellHasChanged = true;
        this.lastCellHovered = cell;
    }
    shouldSkipCurrentColumn(currentColumn) {
        return (0, $jIDNV.isRowNumberCol)(currentColumn);
    }
    dispatchChangedEvent(started, finished, id) {
        this.eventSvc.dispatchEvent({
            type: "cellSelectionChanged",
            started: started,
            finished: finished,
            id: id
        });
        this.eventSvc.dispatchEvent({
            type: "rangeSelectionChanged",
            started: started,
            finished: finished,
            id: id
        });
    }
    getColumnFromModel(col) {
        return typeof col === "string" ? this.colModel.getCol(col) : col;
    }
    getColumnsFromModel(cols) {
        const { gos: gos, visibleCols: visibleCols } = this;
        const isRowHeaderActive = gos.get("rowNumbers");
        if (!cols || this.selectionMode === 1 /* ALL_COLUMNS */ ) cols = visibleCols.allCols;
        const columns = [];
        for (const col of cols){
            const column = this.getColumnFromModel(col);
            if (!column || isRowHeaderActive && this.shouldSkipCurrentColumn(column)) continue;
            columns.push(column);
        }
        return columns.length ? columns : void 0;
    }
    calculateColumnsBetween(columnA, columnB) {
        const allColumns = this.visibleCols.allCols;
        const fromColumn = this.getColumnFromModel(columnA);
        const toColumn = this.getColumnFromModel(columnB);
        const isSameColumn = fromColumn === toColumn;
        const fromIndex = allColumns.indexOf(fromColumn);
        if (fromIndex < 0) {
            (0, $jIDNV._warn)(178, {
                colId: fromColumn.getId()
            });
            return;
        }
        const toIndex = isSameColumn ? fromIndex : allColumns.indexOf(toColumn);
        if (toIndex < 0) {
            (0, $jIDNV._warn)(178, {
                colId: toColumn.getId()
            });
            return;
        }
        if (isSameColumn || this.selectionMode === 1 /* ALL_COLUMNS */ ) return this.getColumnsFromModel([
            fromColumn
        ]);
        const firstIndex = Math.min(fromIndex, toIndex);
        const lastIndex = firstIndex === fromIndex ? toIndex : fromIndex;
        const columns = [];
        for(let i = firstIndex; i <= lastIndex; i++)columns.push(allColumns[i]);
        return this.getColumnsFromModel(columns);
    }
    createDragListenerFeature(eContainer) {
        return new $5b7ccabde48fae90$var$DragListenerFeature(eContainer);
    }
    createCellRangeFeature(beans, ctrl) {
        return new $5b7ccabde48fae90$var$CellRangeFeature(beans, ctrl);
    }
};
// packages/ag-grid-enterprise/src/rangeSelection/rangeSelectionModule.ts
var $5b7ccabde48fae90$export$6f4ee80b1242642d = {
    moduleName: "CellSelection",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$RangeService
    ],
    dynamicBeans: {
        fillHandle: $5b7ccabde48fae90$var$AgFillHandle,
        rangeHandle: $5b7ccabde48fae90$var$AgRangeHandle
    },
    apiFunctions: {
        getCellRanges: $5b7ccabde48fae90$var$getCellRanges,
        addCellRange: $5b7ccabde48fae90$var$addCellRange,
        clearRangeSelection: $5b7ccabde48fae90$var$clearRangeSelection,
        clearCellSelection: $5b7ccabde48fae90$var$clearRangeSelection
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $jIDNV._KeyboardNavigationModule),
        (0, $jIDNV._DragModule)
    ],
    css: [
        $5b7ccabde48fae90$var$rangeSelectionCSS
    ]
};
var $5b7ccabde48fae90$export$5e5c8269d4d7ed2e = {
    moduleName: "RangeSelection",
    version: $5b7ccabde48fae90$var$VERSION,
    dependsOn: [
        $5b7ccabde48fae90$export$6f4ee80b1242642d
    ]
};
var $5b7ccabde48fae90$var$LoadingCellRendererElement = {
    tag: "div",
    cls: "ag-loading",
    children: [
        {
            tag: "span",
            ref: "eLoadingIcon",
            cls: "ag-loading-icon"
        },
        {
            tag: "span",
            ref: "eLoadingText",
            cls: "ag-loading-text"
        }
    ]
};
var $5b7ccabde48fae90$var$LoadingCellRenderer = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$LoadingCellRendererElement);
        this.eLoadingIcon = (0, $jIDNV.RefPlaceholder);
        this.eLoadingText = (0, $jIDNV.RefPlaceholder);
    }
    init(params) {
        params.node.failedLoad ? this.setupFailed() : this.setupLoading();
    }
    setupFailed() {
        this.eLoadingText.textContent = this.getLocaleTextFunc()("loadingError", "ERR");
    }
    setupLoading() {
        const eLoadingIcon = (0, $jIDNV._createIconNoSpan)("groupLoading", this.beans, null);
        if (eLoadingIcon) this.eLoadingIcon.appendChild(eLoadingIcon);
        this.eLoadingText.textContent = this.getLocaleTextFunc()("loadingOoo", "Loading");
    }
    refresh(_params) {
        return false;
    }
};
// packages/ag-grid-enterprise/src/cellRenderers/enterpriseCellRendererModule.ts
var $5b7ccabde48fae90$var$LoadingCellRendererModule = {
    moduleName: "LoadingCellRenderer",
    version: $5b7ccabde48fae90$var$VERSION,
    userComponents: {
        agLoadingCellRenderer: $5b7ccabde48fae90$var$LoadingCellRenderer
    },
    icons: {
        // rotating spinner shown by the loading cell renderer
        groupLoading: "loading"
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule
    ]
};
// packages/ag-grid-enterprise/src/pivot/pivotApi.ts
function $5b7ccabde48fae90$var$isPivotMode(beans) {
    return beans.colModel.isPivotMode();
}
function $5b7ccabde48fae90$var$getPivotResultColumn(beans, pivotKeys, valueColKey) {
    return beans.pivotResultCols?.lookupPivotResultCol(pivotKeys, valueColKey) ?? null;
}
function $5b7ccabde48fae90$var$setValueColumns(beans, colKeys) {
    beans.valueColsSvc?.setColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$getValueColumns(beans) {
    return beans.valueColsSvc?.columns ?? [];
}
function $5b7ccabde48fae90$var$removeValueColumns(beans, colKeys) {
    beans.valueColsSvc?.removeColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$addValueColumns(beans, colKeys) {
    beans.valueColsSvc?.addColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$setPivotColumns(beans, colKeys) {
    beans.pivotColsSvc?.setColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$removePivotColumns(beans, colKeys) {
    beans.pivotColsSvc?.removeColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$addPivotColumns(beans, colKeys) {
    beans.pivotColsSvc?.addColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$getPivotColumns(beans) {
    return beans.pivotColsSvc?.columns ?? [];
}
function $5b7ccabde48fae90$var$setPivotResultColumns(beans, colDefs) {
    beans.pivotResultCols?.setPivotResultCols(colDefs, "api");
}
function $5b7ccabde48fae90$var$getPivotResultColumns(beans) {
    const pivotResultCols = beans.pivotResultCols?.getPivotResultCols();
    return pivotResultCols ? pivotResultCols.list : null;
}
var $5b7ccabde48fae90$var$PIVOT_ROW_TOTAL_PREFIX = "PivotRowTotal_";
var $5b7ccabde48fae90$var$headerNameComparator = ({ headerName: a }, { headerName: b })=>{
    if (a && !b) return 1;
    else if (!a && b) return -1;
    else if (!a && !b) return 0;
    if (a < b) return -1;
    else if (a > b) return 1;
    else return 0;
};
var $5b7ccabde48fae90$var$convertToHeaderNameComparator = (comparator)=>(a, b)=>comparator(a.headerName, b.headerName);
var $5b7ccabde48fae90$var$PivotColDefService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "pivotColDefSvc";
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.pivotColsSvc = beans.pivotColsSvc;
        this.valueColsSvc = beans.valueColsSvc;
        this.colNames = beans.colNames;
    }
    postConstruct() {
        const getFieldSeparator = ()=>this.gos.get("serverSidePivotResultFieldSeparator") ?? "_";
        this.fieldSeparator = getFieldSeparator();
        this.addManagedPropertyListener("serverSidePivotResultFieldSeparator", ()=>{
            this.fieldSeparator = getFieldSeparator();
        });
        const getPivotDefaultExpanded = ()=>this.gos.get("pivotDefaultExpanded");
        this.pivotDefaultExpanded = getPivotDefaultExpanded();
        this.addManagedPropertyListener("pivotDefaultExpanded", ()=>{
            this.pivotDefaultExpanded = getPivotDefaultExpanded();
        });
    }
    createPivotColumnDefs(uniqueValues) {
        const pivotColumnGroupDefs = this.createPivotColumnsFromUniqueValues(uniqueValues);
        function extractColDefs(input, arr = []) {
            input.forEach((def)=>{
                if (def.children !== void 0) extractColDefs(def.children, arr);
                else arr.push(def);
            });
            return arr;
        }
        const pivotColumnDefs = extractColDefs(pivotColumnGroupDefs);
        this.addRowGroupTotals(pivotColumnGroupDefs, pivotColumnDefs);
        this.addExpandablePivotGroups(pivotColumnGroupDefs, pivotColumnDefs);
        this.addPivotTotalsToGroups(pivotColumnGroupDefs, pivotColumnDefs);
        return pivotColumnGroupDefs;
    }
    createPivotColumnsFromUniqueValues(uniqueValues) {
        const pivotColumns = this.pivotColsSvc?.columns ?? [];
        const maxDepth = pivotColumns.length;
        const pivotColumnGroupDefs = this.recursivelyBuildGroup(0, uniqueValues, [], maxDepth, pivotColumns);
        return pivotColumnGroupDefs;
    }
    recursivelyBuildGroup(index, uniqueValue, pivotKeys, maxDepth, primaryPivotColumns) {
        if (index >= maxDepth) return this.buildMeasureCols(pivotKeys);
        const { pivotComparator: pivotComparator } = primaryPivotColumns[index].getColDef();
        const comparator = pivotComparator ? $5b7ccabde48fae90$var$convertToHeaderNameComparator(pivotComparator) : $5b7ccabde48fae90$var$headerNameComparator;
        const measureColumns = this.valueColsSvc?.columns;
        if (measureColumns?.length === 1 && this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && index === maxDepth - 1) {
            const leafCols = [];
            for (const key of uniqueValue.keys()){
                const newPivotKeys = [
                    ...pivotKeys,
                    key
                ];
                const colDef = this.createColDef(measureColumns[0], key, newPivotKeys);
                colDef.columnGroupShow = "open";
                leafCols.push(colDef);
            }
            leafCols.sort(comparator);
            return leafCols;
        }
        const groups = [];
        for (const key of uniqueValue.keys()){
            const openByDefault = this.pivotDefaultExpanded === -1 || index < this.pivotDefaultExpanded;
            const newPivotKeys = [
                ...pivotKeys,
                key
            ];
            groups.push({
                children: this.recursivelyBuildGroup(index + 1, uniqueValue.get(key), newPivotKeys, maxDepth, primaryPivotColumns),
                headerName: key,
                pivotKeys: newPivotKeys,
                columnGroupShow: "open",
                openByDefault: openByDefault,
                groupId: this.generateColumnGroupId(newPivotKeys)
            });
        }
        groups.sort(comparator);
        return groups;
    }
    buildMeasureCols(pivotKeys) {
        const measureColumns = this.valueColsSvc?.columns ?? [];
        if (measureColumns.length === 0) return [
            this.createColDef(null, "-", pivotKeys)
        ];
        return measureColumns.map((measureCol)=>{
            const columnName = this.colNames.getDisplayNameForColumn(measureCol, "header");
            const colDef = this.createColDef(measureCol, columnName, pivotKeys);
            colDef.columnGroupShow = "open";
            return colDef;
        });
    }
    addExpandablePivotGroups(pivotColumnGroupDefs, pivotColumnDefs) {
        const isSuppressExpand = this.gos.get("suppressExpandablePivotGroups");
        if (isSuppressExpand || this.gos.get("pivotColumnGroupTotals")) return;
        const recursivelyAddSubTotals = (def, currentPivotColumnDefs, acc)=>{
            if ("children" in def) {
                const { valueColsSvc: valueColsSvc } = this;
                const { columns: valueCols = [] } = valueColsSvc ?? {};
                const childAcc = /* @__PURE__ */ new Map();
                def.children.forEach((grp)=>{
                    recursivelyAddSubTotals(grp, currentPivotColumnDefs, childAcc);
                });
                const leafGroup = !def.children.some((child)=>child.children);
                const hasCollapsedLeafGroup = leafGroup && valueCols.length === 1 && this.gos.get("removePivotHeaderRowWhenSingleValueColumn");
                valueCols.forEach((valueColumn)=>{
                    const columnName = this.colNames.getDisplayNameForColumn(valueColumn, "header");
                    const totalColDef = this.createColDef(valueColumn, columnName, def.pivotKeys);
                    totalColDef.pivotTotalColumnIds = childAcc.get(valueColumn.getColId());
                    totalColDef.columnGroupShow = !isSuppressExpand ? "closed" : "open";
                    totalColDef.aggFunc = valueColumn.getAggFunc();
                    if (!leafGroup || hasCollapsedLeafGroup) {
                        const children = def.children;
                        children.push(totalColDef);
                        currentPivotColumnDefs.push(totalColDef);
                    }
                });
                this.merge(acc, childAcc);
                return;
            }
            if (!def.pivotValueColumn) return;
            const pivotValueColId = def.pivotValueColumn.getColId();
            const exists = acc.has(pivotValueColId);
            if (exists) {
                const arr = acc.get(pivotValueColId);
                arr.push(def.colId);
            } else acc.set(pivotValueColId, [
                def.colId
            ]);
        };
        pivotColumnGroupDefs.forEach((groupDef)=>{
            recursivelyAddSubTotals(groupDef, pivotColumnDefs, /* @__PURE__ */ new Map());
        });
    }
    addPivotTotalsToGroups(pivotColumnGroupDefs, pivotColumnDefs) {
        if (!this.gos.get("pivotColumnGroupTotals")) return;
        const insertAfter = this.gos.get("pivotColumnGroupTotals") === "after";
        const valueCols = this.valueColsSvc?.columns;
        const aggFuncs = valueCols?.map((valueCol)=>valueCol.getAggFunc());
        if (!aggFuncs || aggFuncs.length < 1 || !this.sameAggFuncs(aggFuncs)) return;
        if (valueCols) {
            const valueColumn = valueCols[0];
            pivotColumnGroupDefs.forEach((groupDef)=>{
                this.recursivelyAddPivotTotal(groupDef, pivotColumnDefs, valueColumn, insertAfter);
            });
        }
    }
    recursivelyAddPivotTotal(groupDef, pivotColumnDefs, valueColumn, insertAfter) {
        const group = groupDef;
        if (!group.children) {
            const def = groupDef;
            return def.colId ? [
                def.colId
            ] : null;
        }
        let colIds = [];
        group.children.forEach((grp)=>{
            const childColIds = this.recursivelyAddPivotTotal(grp, pivotColumnDefs, valueColumn, insertAfter);
            if (childColIds) colIds = colIds.concat(childColIds);
        });
        if (group.children.length > 1) {
            const localeTextFunc = this.getLocaleTextFunc();
            const headerName = localeTextFunc("pivotColumnGroupTotals", "Total");
            const totalColDef = this.createColDef(valueColumn, headerName, groupDef.pivotKeys, true);
            totalColDef.pivotTotalColumnIds = colIds;
            totalColDef.aggFunc = valueColumn.getAggFunc();
            totalColDef.columnGroupShow = this.gos.get("suppressExpandablePivotGroups") ? "open" : void 0;
            const children = groupDef.children;
            insertAfter ? children.push(totalColDef) : children.unshift(totalColDef);
            pivotColumnDefs.push(totalColDef);
        }
        return colIds;
    }
    addRowGroupTotals(pivotColumnGroupDefs, pivotColumnDefs) {
        if (!this.gos.get("pivotRowTotals")) return;
        const insertAtEnd = this.gos.get("pivotRowTotals") === "after";
        const valueColumns = this.valueColsSvc?.columns ?? [];
        const valueCols = valueColumns.slice();
        if (!insertAtEnd) valueCols.reverse();
        const isCreateTotalGroups = valueCols.length > 1 || !this.gos.get("removePivotHeaderRowWhenSingleValueColumn");
        for(let i = 0; i < valueCols.length; i++){
            const valueCol = valueCols[i];
            const columnName = this.colNames.getDisplayNameForColumn(valueCol, "header");
            const colDef = this.createColDef(valueCol, columnName, []);
            const colIds = [];
            for(let i2 = 0; i2 < pivotColumnDefs.length; i2++){
                const colDef2 = pivotColumnDefs[i2];
                if (colDef2.pivotValueColumn === valueCol) colIds.push(colDef2.colId);
            }
            colDef.pivotTotalColumnIds = colIds;
            colDef.colId = $5b7ccabde48fae90$var$PIVOT_ROW_TOTAL_PREFIX + colDef.colId;
            const valueGroup = isCreateTotalGroups ? {
                children: [
                    colDef
                ],
                pivotKeys: [],
                groupId: `${$5b7ccabde48fae90$var$PIVOT_ROW_TOTAL_PREFIX}_pivotGroup_${valueCol.getColId()}`
            } : colDef;
            pivotColumnDefs.push(colDef);
            insertAtEnd ? pivotColumnGroupDefs.push(valueGroup) : pivotColumnGroupDefs.unshift(valueGroup);
        }
    }
    /**
   * Recreate a pivot colDef to update from a changed valueColumn colDef
   */ recreateColDef(colDef) {
        const { pivotValueColumn: pivotValueColumn, headerName: headerName, pivotKeys: pivotKeys, pivotTotalColumnIds: pivotTotalColumnIds, columnGroupShow: columnGroupShow, colId: colId, valueGetter: valueGetter, aggFunc: aggFunc } = colDef;
        if (!pivotValueColumn) return colDef;
        const newColDef = this.createColDef(pivotValueColumn, headerName, pivotKeys, !!pivotTotalColumnIds);
        newColDef.columnGroupShow = columnGroupShow;
        newColDef.colId = colId;
        newColDef.valueGetter = valueGetter;
        newColDef.aggFunc = aggFunc;
        newColDef.pivotTotalColumnIds = pivotTotalColumnIds;
        this.gos.get("processPivotResultColDef")?.(newColDef);
        return newColDef;
    }
    createColDef(valueColumn, headerName, pivotKeys, totalColumn = false) {
        const colDef = {};
        if (valueColumn) {
            const colDefToCopy = valueColumn.getColDef();
            Object.assign(colDef, colDefToCopy);
            colDef.hide = false;
        }
        colDef.headerName = headerName;
        colDef.colId = this.generateColumnId(pivotKeys || [], valueColumn && !totalColumn ? valueColumn.getColId() : "");
        colDef.field = colDef.colId;
        colDef.valueGetter = (params)=>params.data?.[params.colDef.field];
        colDef.pivotKeys = pivotKeys;
        colDef.pivotValueColumn = valueColumn;
        if (colDef.filter === true) colDef.filter = "agNumberColumnFilter";
        return colDef;
    }
    sameAggFuncs(aggFuncs) {
        if (aggFuncs.length == 1) return true;
        for(let i = 1; i < aggFuncs.length; i++){
            if (aggFuncs[i] !== aggFuncs[0]) return false;
        }
        return true;
    }
    merge(m1, m2) {
        m2.forEach((value, key)=>{
            const existingList = m1.has(key) ? m1.get(key) : [];
            const updatedList = [
                ...existingList,
                ...value
            ];
            m1.set(key, updatedList);
        });
    }
    generateColumnGroupId(pivotKeys) {
        const pivotCols = (this.pivotColsSvc?.columns ?? []).map((col)=>col.getColId());
        return `pivotGroup_${pivotCols.join("-")}_${pivotKeys.join("-")}`;
    }
    generateColumnId(pivotKeys, measureColumnId) {
        const pivotCols = (this.pivotColsSvc?.columns ?? []).map((col)=>col.getColId());
        return `pivot_${pivotCols.join("-")}_${pivotKeys.join("-")}_${measureColumnId}`;
    }
    /**
   * Used by the SSRM to create secondary columns from provided fields
   * @param fields
   */ createColDefsFromFields(fields) {
        const uniqueValues = /* @__PURE__ */ new Map();
        for(let i = 0; i < fields.length; i++){
            const field = fields[i];
            const parts = field.split(this.fieldSeparator);
            let level = uniqueValues;
            for(let p = 0; p < parts.length; p++){
                const part = parts[p];
                let map = level.get(part);
                if (!map) {
                    map = /* @__PURE__ */ new Map();
                    level.set(part, map);
                }
                level = map;
            }
        }
        const uniqueValuesToGroups = (id, key, uniqueValues2, depth)=>{
            const children = [];
            for (const [key2, item] of uniqueValues2){
                const child = uniqueValuesToGroups(`${id}${this.fieldSeparator}${key2}`, key2, item, depth + 1);
                children.push(child);
            }
            if (children.length === 0) {
                const potentialAggCol = this.colModel.getColDefCol(key);
                if (potentialAggCol) {
                    const headerName = this.colNames.getDisplayNameForColumn(potentialAggCol, "header") ?? key;
                    const colDef = this.createColDef(potentialAggCol, headerName, void 0, false);
                    colDef.colId = id;
                    colDef.aggFunc = potentialAggCol.getAggFunc();
                    colDef.valueGetter = (params)=>params.data?.[id];
                    return colDef;
                }
                const col = {
                    colId: id,
                    headerName: key,
                    // this is to support using pinned rows, normally the data will be extracted from the aggData object using the colId
                    // however pinned rows still access the data object by field, this prevents values with dots from being treated as complex objects
                    valueGetter: (params)=>params.data?.[id]
                };
                return col;
            }
            const collapseSingleChildren = this.gos.get("removePivotHeaderRowWhenSingleValueColumn");
            if (collapseSingleChildren && children.length === 1 && "colId" in children[0]) {
                children[0].headerName = key;
                return children[0];
            }
            const group = {
                openByDefault: this.pivotDefaultExpanded === -1 || depth < this.pivotDefaultExpanded,
                groupId: id,
                headerName: key,
                children: children
            };
            return group;
        };
        const res = [];
        for (const [key, item] of uniqueValues){
            const col = uniqueValuesToGroups(key, key, item, 0);
            res.push(col);
        }
        return res;
    }
};
var $5b7ccabde48fae90$var$PivotResultColsService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "pivotResultCols";
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.visibleCols = beans.visibleCols;
    }
    destroy() {
        (0, $jIDNV._destroyColumnTree)(this.beans, this.pivotResultCols?.tree);
        super.destroy();
    }
    isPivotResultColsPresent() {
        return this.pivotResultCols != null;
    }
    lookupPivotResultCol(pivotKeys, valueColKey) {
        if (this.pivotResultCols == null) return null;
        const valueColumnToFind = this.colModel.getColDefCol(valueColKey);
        let foundColumn = null;
        this.pivotResultCols.list.forEach((column)=>{
            const thisPivotKeys = column.getColDef().pivotKeys;
            const pivotValueColumn = column.getColDef().pivotValueColumn;
            const pivotKeyMatches = (0, $jIDNV._areEqual)(thisPivotKeys, pivotKeys);
            const pivotValueMatches = pivotValueColumn === valueColumnToFind;
            if (pivotKeyMatches && pivotValueMatches) foundColumn = column;
        });
        return foundColumn;
    }
    getPivotResultCols() {
        return this.pivotResultCols;
    }
    getPivotResultCol(key) {
        if (!this.pivotResultCols) return null;
        return this.colModel.getColFromCollection(key, this.pivotResultCols);
    }
    setPivotResultCols(colDefs, source) {
        if (!this.colModel.ready) return;
        if (colDefs == null && this.pivotResultCols == null) return;
        if (colDefs) {
            this.processPivotResultColDef(colDefs);
            const createColTreeFunc = source === "api" ? (0, $jIDNV._createColumnTree) : (0, $jIDNV._createColumnTreeWithIds);
            const balancedTreeResult = createColTreeFunc(this.beans, colDefs, false, this.pivotResultCols?.tree || this.previousPivotResultCols || void 0, source);
            (0, $jIDNV._destroyColumnTree)(this.beans, this.pivotResultCols?.tree, balancedTreeResult.columnTree);
            const tree = balancedTreeResult.columnTree;
            const treeDepth = balancedTreeResult.treeDepth;
            const list = (0, $jIDNV._getColumnsFromTree)(tree);
            const map = {};
            this.pivotResultCols = {
                tree: tree,
                treeDepth: treeDepth,
                list: list,
                map: map
            };
            this.pivotResultCols.list.forEach((col)=>this.pivotResultCols.map[col.getId()] = col);
            const hasPreviousCols = !!this.previousPivotResultCols;
            this.previousPivotResultCols = null;
            this.colModel.refreshCols(!hasPreviousCols);
        } else {
            this.previousPivotResultCols = this.pivotResultCols ? this.pivotResultCols.tree : null;
            this.pivotResultCols = null;
            this.colModel.refreshCols(false);
        }
        this.visibleCols.refresh(source);
    }
    processPivotResultColDef(colDefs) {
        const columnCallback = this.gos.get("processPivotResultColDef");
        const groupCallback = this.gos.get("processPivotResultColGroupDef");
        if (!columnCallback && !groupCallback) return void 0;
        const searchForColDefs = (colDefs2)=>{
            colDefs2.forEach((abstractColDef)=>{
                const isGroup = (0, $jIDNV._exists)(abstractColDef.children);
                if (isGroup) {
                    const colGroupDef = abstractColDef;
                    if (groupCallback) groupCallback(colGroupDef);
                    searchForColDefs(colGroupDef.children);
                } else {
                    const colDef = abstractColDef;
                    if (columnCallback) columnCallback(colDef);
                }
            });
        };
        if (colDefs) searchForColDefs(colDefs);
    }
};
var $5b7ccabde48fae90$var$EXCEEDED_MAX_UNIQUE_VALUES = "Exceeded maximum allowed pivot column count.";
var $5b7ccabde48fae90$var$mapToObject = (map)=>{
    const obj = {};
    map.forEach((value, key)=>obj[key] = value instanceof Map ? $5b7ccabde48fae90$var$mapToObject(value) : value);
    return obj;
};
var $5b7ccabde48fae90$var$PivotStage = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "pivotStage";
        this.refreshProps = /* @__PURE__ */ new Set([
            "removePivotHeaderRowWhenSingleValueColumn",
            "pivotRowTotals",
            "pivotColumnGroupTotals",
            "suppressExpandablePivotGroups"
        ]);
        this.step = "pivot";
        this.uniqueValues = /* @__PURE__ */ new Map();
        this.lastTimeFailed = false;
        this.maxUniqueValues = -1;
        this.currentUniqueCount = 0;
    }
    wireBeans(beans) {
        this.valueSvc = beans.valueSvc;
        this.colModel = beans.colModel;
        this.pivotResultCols = beans.pivotResultCols;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
        this.valueColsSvc = beans.valueColsSvc;
        this.pivotColsSvc = beans.pivotColsSvc;
        this.pivotColDefSvc = beans.pivotColDefSvc;
    }
    execute(params) {
        const changedPath = params.changedPath;
        if (this.colModel.isPivotActive()) this.executePivotOn(changedPath);
        else this.executePivotOff(changedPath);
    }
    executePivotOff(changedPath) {
        this.aggregationColumnsHashLastTime = null;
        this.uniqueValues = /* @__PURE__ */ new Map();
        if (this.pivotResultCols.isPivotResultColsPresent()) {
            this.pivotResultCols.setPivotResultCols(null, "rowModelUpdated");
            if (changedPath) changedPath.active = false;
        }
    }
    executePivotOn(changedPath) {
        const numberOfAggregationColumns = this.valueColsSvc?.columns.length ?? 1;
        const configuredMaxCols = this.gos.get("pivotMaxGeneratedColumns");
        this.maxUniqueValues = configuredMaxCols === -1 ? -1 : configuredMaxCols / numberOfAggregationColumns;
        let uniqueValues;
        try {
            uniqueValues = this.bucketUpRowNodes(changedPath);
        } catch (e) {
            if (e.message === $5b7ccabde48fae90$var$EXCEEDED_MAX_UNIQUE_VALUES) {
                this.pivotResultCols.setPivotResultCols([], "rowModelUpdated");
                this.eventSvc.dispatchEvent({
                    type: "pivotMaxColumnsExceeded",
                    message: e.message
                });
                this.lastTimeFailed = true;
                return;
            }
            throw e;
        }
        const uniqueValuesChanged = this.setUniqueValues(uniqueValues);
        const aggregationColumns = this.valueColsSvc?.columns ?? [];
        const aggregationColumnsHash = aggregationColumns.map((column)=>`${column.getId()}-${column.getColDef().headerName}`).join("#");
        const aggregationFuncsHash = aggregationColumns.map((column)=>column.getAggFunc().toString()).join("#");
        const aggregationColumnsChanged = this.aggregationColumnsHashLastTime !== aggregationColumnsHash;
        const aggregationFuncsChanged = this.aggregationFuncsHashLastTime !== aggregationFuncsHash;
        this.aggregationColumnsHashLastTime = aggregationColumnsHash;
        this.aggregationFuncsHashLastTime = aggregationFuncsHash;
        const groupColumnsHash = (this.rowGroupColsSvc?.columns ?? []).map((column)=>column.getId()).join("#");
        const groupColumnsChanged2 = groupColumnsHash !== this.groupColumnsHashLastTime;
        this.groupColumnsHashLastTime = groupColumnsHash;
        const pivotRowTotals = this.gos.get("pivotRowTotals");
        const pivotColumnGroupTotals = this.gos.get("pivotColumnGroupTotals");
        const suppressExpandablePivotGroups = this.gos.get("suppressExpandablePivotGroups");
        const removePivotHeaderRowWhenSingleValueColumn = this.gos.get("removePivotHeaderRowWhenSingleValueColumn");
        const anyGridOptionsChanged = pivotRowTotals !== this.pivotRowTotalsLastTime || pivotColumnGroupTotals !== this.pivotColumnGroupTotalsLastTime || suppressExpandablePivotGroups !== this.suppressExpandablePivotGroupsLastTime || removePivotHeaderRowWhenSingleValueColumn !== this.removePivotHeaderRowWhenSingleValueColumnLastTime;
        this.pivotRowTotalsLastTime = pivotRowTotals;
        this.pivotColumnGroupTotalsLastTime = pivotColumnGroupTotals;
        this.suppressExpandablePivotGroupsLastTime = suppressExpandablePivotGroups;
        this.removePivotHeaderRowWhenSingleValueColumnLastTime = removePivotHeaderRowWhenSingleValueColumn;
        if (this.lastTimeFailed || uniqueValuesChanged || aggregationColumnsChanged || groupColumnsChanged2 || aggregationFuncsChanged || anyGridOptionsChanged) {
            const pivotColumnGroupDefs = this.pivotColDefSvc.createPivotColumnDefs(this.uniqueValues);
            this.pivotResultCols.setPivotResultCols(pivotColumnGroupDefs, "rowModelUpdated");
            if (changedPath) changedPath.active = false;
        }
        this.lastTimeFailed = false;
    }
    setUniqueValues(newValues) {
        const json1 = JSON.stringify($5b7ccabde48fae90$var$mapToObject(this.uniqueValues));
        const json2 = JSON.stringify($5b7ccabde48fae90$var$mapToObject(newValues));
        const uniqueValuesChanged = json1 !== json2;
        if (uniqueValuesChanged) {
            this.uniqueValues = newValues;
            return true;
        } else return false;
    }
    bucketUpRowNodes(changedPath) {
        this.currentUniqueCount = 0;
        const uniqueValues = /* @__PURE__ */ new Map();
        changedPath.forEachChangedNodeDepthFirst((node)=>{
            if (node.leafGroup) node.childrenMapped = null;
        });
        const recursivelyBucketFilteredChildren = (node)=>{
            if (node.leafGroup) this.bucketRowNode(node, uniqueValues);
            else node.childrenAfterFilter?.forEach(recursivelyBucketFilteredChildren);
        };
        changedPath.executeFromRootNode(recursivelyBucketFilteredChildren);
        return uniqueValues;
    }
    bucketRowNode(rowNode, uniqueValues) {
        const pivotColumns = this.pivotColsSvc?.columns;
        if (pivotColumns?.length === 0) rowNode.childrenMapped = null;
        else rowNode.childrenMapped = $5b7ccabde48fae90$var$mapToObject(this.bucketChildren(rowNode.childrenAfterFilter, pivotColumns, 0, uniqueValues));
        if (rowNode.sibling) rowNode.sibling.childrenMapped = rowNode.childrenMapped;
    }
    bucketChildren(children, pivotColumns = [], pivotIndex, uniqueValues) {
        const mappedChildren = /* @__PURE__ */ new Map();
        const pivotColumn = pivotColumns[pivotIndex];
        children.forEach((child)=>{
            let key = this.valueSvc.getKeyForNode(pivotColumn, child);
            if ((0, $jIDNV._missing)(key)) key = "";
            if (!uniqueValues.get(key)) {
                this.currentUniqueCount += 1;
                uniqueValues.set(key, /* @__PURE__ */ new Map());
                const doesGeneratedColMaxExist = this.maxUniqueValues !== -1;
                const hasExceededColMax = this.currentUniqueCount > this.maxUniqueValues;
                if (doesGeneratedColMaxExist && hasExceededColMax) throw Error($5b7ccabde48fae90$var$EXCEEDED_MAX_UNIQUE_VALUES);
            }
            if (!mappedChildren.has(key)) mappedChildren.set(key, []);
            mappedChildren.get(key).push(child);
        });
        if (pivotIndex === pivotColumns.length - 1) return mappedChildren;
        const result = /* @__PURE__ */ new Map();
        for (const key of mappedChildren.keys())result.set(key, this.bucketChildren(mappedChildren.get(key), pivotColumns, pivotIndex + 1, uniqueValues.get(key)));
        return result;
    }
};
// packages/ag-grid-enterprise/src/pivot/pivotModule.ts
var $5b7ccabde48fae90$var$SharedPivotModule = {
    moduleName: "SharedPivot",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$PivotResultColsService,
        $5b7ccabde48fae90$var$PivotColDefService,
        $5b7ccabde48fae90$var$PivotColsSvc
    ],
    apiFunctions: {
        isPivotMode: $5b7ccabde48fae90$var$isPivotMode,
        getPivotResultColumn: $5b7ccabde48fae90$var$getPivotResultColumn,
        setValueColumns: $5b7ccabde48fae90$var$setValueColumns,
        getValueColumns: $5b7ccabde48fae90$var$getValueColumns,
        removeValueColumns: $5b7ccabde48fae90$var$removeValueColumns,
        addValueColumns: $5b7ccabde48fae90$var$addValueColumns,
        setPivotColumns: $5b7ccabde48fae90$var$setPivotColumns,
        removePivotColumns: $5b7ccabde48fae90$var$removePivotColumns,
        addPivotColumns: $5b7ccabde48fae90$var$addPivotColumns,
        getPivotColumns: $5b7ccabde48fae90$var$getPivotColumns,
        setPivotResultColumns: $5b7ccabde48fae90$var$setPivotResultColumns,
        getPivotResultColumns: $5b7ccabde48fae90$var$getPivotResultColumns
    },
    dependsOn: [
        $5b7ccabde48fae90$var$SharedRowGroupingModule,
        (0, $jIDNV._ColumnGroupModule)
    ]
};
var $5b7ccabde48fae90$export$4fc40ce1b35c05e1 = {
    moduleName: "Pivot",
    version: $5b7ccabde48fae90$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $5b7ccabde48fae90$var$PivotStage
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$SharedPivotModule,
        $5b7ccabde48fae90$export$e67935bd41653107,
        $5b7ccabde48fae90$var$ClientSideRowModelHierarchyModule
    ]
};
// packages/ag-grid-enterprise/src/treeData/fieldAccess.ts
var $5b7ccabde48fae90$var$parseFieldPath = (fieldPath)=>{
    if (typeof fieldPath !== "string" || !fieldPath.length) return [];
    const segments = fieldPath.split(".");
    if (segments.includes("__proto__")) return [];
    return segments;
};
var $5b7ccabde48fae90$var$makeFieldPathGetter = (fieldPath)=>{
    const splitPath = $5b7ccabde48fae90$var$parseFieldPath(fieldPath);
    let result = null;
    const last = splitPath.length - 1;
    if (last === 0) result = (data)=>data?.[fieldPath];
    else if (last > 0) result = (data)=>{
        let value = data;
        for(let i = 0; i <= last && value !== null && value !== void 0; ++i){
            value = value[splitPath[i]];
            if (i < last && typeof value !== "object" && value !== void 0) return null;
        }
        return value;
    };
    else result = ()=>void 0;
    result.path = fieldPath;
    return result;
};
// packages/ag-grid-enterprise/src/treeData/clientSideChildrenTreeNodeManager.ts
var $5b7ccabde48fae90$var$ClientSideChildrenTreeNodeManager = class extends (0, $jIDNV.AbstractClientSideNodeManager) {
    constructor(){
        super(...arguments);
        this.beanName = "csrmChildrenTreeNodeSvc";
        this.childrenGetter = null;
    }
    destroy() {
        super.destroy();
        this.childrenGetter = null;
    }
    extractRowData() {
        return this.rootNode?.childrenAfterGroup?.map(({ data: data })=>data);
    }
    activate(rootNode) {
        const oldChildrenGetter = this.childrenGetter;
        const childrenField = this.gos.get("treeDataChildrenField") ?? null;
        if (!oldChildrenGetter || oldChildrenGetter.path !== childrenField) this.childrenGetter = $5b7ccabde48fae90$var$makeFieldPathGetter(childrenField);
        super.activate(rootNode);
    }
    deactivate() {
        this.childrenGetter = null;
        super.deactivate();
    }
    updateRowData(_rowDataTran, changedRowNodes) {
        (0, $jIDNV._warn)(268);
        return {
            changedRowNodes: changedRowNodes,
            rowNodeTransaction: {
                add: [],
                remove: [],
                update: []
            },
            rowsInserted: false
        };
    }
    loadNewRowData(rowData) {
        const rootNode = this.rootNode;
        const childrenGetter = this.childrenGetter;
        const processedData = /* @__PURE__ */ new Map();
        const allLeafChildren = [];
        rootNode.allLeafChildren = allLeafChildren;
        const processChild = (parent, data)=>{
            let row = processedData.get(data);
            if (row !== void 0) {
                (0, $jIDNV._error)(2, {
                    nodeId: row.id
                });
                return;
            }
            row = this.createRowNode(data, allLeafChildren.length);
            row.treeParent = parent;
            processedData.set(data, row);
            allLeafChildren.push(row);
            const children = childrenGetter?.(data);
            if (children) for(let i = 0, len = children.length; i < len; ++i)processChild(row, children[i]);
        };
        for(let i = 0, len = rowData.length; i < len; ++i)processChild(rootNode, rowData[i]);
    }
    setImmutableRowData(params, rowData) {
        this.dispatchRowDataUpdateStartedEvent(rowData);
        const gos = this.gos;
        const rootNode = this.rootNode;
        const childrenGetter = this.childrenGetter;
        const getRowIdFunc = (0, $jIDNV._getRowIdCallback)(gos);
        const canReorder = !gos.get("suppressMaintainUnsortedOrder");
        const processedData = /* @__PURE__ */ new Map();
        const changedPath = new (0, $jIDNV.ChangedPath)(false, rootNode);
        params.changedPath = changedPath;
        const changedRowNodes = params.changedRowNodes;
        const oldAllLeafChildren = rootNode.allLeafChildren;
        const allLeafChildren = [];
        const nodesToUnselect = [];
        let orderChanged = false;
        let rowsChanged = false;
        const processChildren = (parent, children, childrenLevel)=>{
            const childrenLen = children?.length;
            let inOrder = true;
            let prevIndex = -1;
            for(let i = 0; i < childrenLen; ++i){
                const oldSourceRowIndex = processChild(parent, children[i], childrenLevel);
                if (canReorder && oldSourceRowIndex >= 0) {
                    if (oldSourceRowIndex < prevIndex) inOrder = false;
                    prevIndex = oldSourceRowIndex;
                }
            }
            if (!inOrder) orderChanged = true;
        };
        const processChild = (parent, data, level)=>{
            let row = processedData.get(data);
            if (row !== void 0) {
                (0, $jIDNV._warn)(2, {
                    nodeId: row.id
                });
                return -1;
            }
            const id = getRowIdFunc({
                data: data,
                level: level
            });
            row = this.getRowNode(id);
            if (row) {
                let rowChanged = false;
                if (row.data !== data) {
                    rowChanged = true;
                    row.updateData(data);
                    if (!row.selectable && row.isSelected()) nodesToUnselect.push(row);
                }
                if (row.treeParent !== parent) {
                    row.treeParent = parent;
                    rowChanged = true;
                }
                if (rowChanged) {
                    rowsChanged = true;
                    changedRowNodes.update(row);
                }
            } else {
                row = this.createRowNode(data, -1);
                row.treeParent = parent;
                rowsChanged = true;
                changedRowNodes.add(row);
            }
            processedData.set(data, row);
            let oldSourceRowIndex;
            if (canReorder) {
                oldSourceRowIndex = row.sourceRowIndex;
                row.sourceRowIndex = allLeafChildren.push(row) - 1;
            } else oldSourceRowIndex = -1;
            const children = childrenGetter?.(data);
            if (children) processChildren(row, children, level + 1);
            return oldSourceRowIndex;
        };
        processChildren(rootNode, rowData, 0);
        if (oldAllLeafChildren) {
            const pinnedRowModel = this.beans.pinnedRowModel;
            for(let i = 0, len = oldAllLeafChildren.length; i < len; ++i){
                const row = oldAllLeafChildren[i];
                if (!processedData.has(row.data)) {
                    row.treeParent = null;
                    row.treeNodeFlags = 0;
                    const pinnedSibling = row.pinnedSibling;
                    if (pinnedSibling) pinnedRowModel?.pinRow(pinnedSibling, null);
                    row.clearRowTopAndRowIndex();
                    this.rowNodeDeleted(row);
                    if (row.isSelected()) nodesToUnselect.push(row);
                    changedRowNodes.remove(row);
                }
            }
        }
        if (!canReorder) {
            if (oldAllLeafChildren) {
                const removals = changedRowNodes.removals;
                for(let i = 0, len = oldAllLeafChildren.length; i < len; ++i){
                    const row = oldAllLeafChildren[i];
                    if (!removals.has(row)) row.sourceRowIndex = allLeafChildren.push(row) - 1;
                }
            }
            for (const row of changedRowNodes.adds)row.sourceRowIndex = allLeafChildren.push(row) - 1;
        }
        rootNode.allLeafChildren = allLeafChildren;
        if (nodesToUnselect.length) this.deselectNodes(nodesToUnselect);
        const sibling = rootNode.sibling;
        if (sibling) sibling.allLeafChildren = allLeafChildren;
        if (rowsChanged || orderChanged) {
            params.rowDataUpdated = true;
            params.rowNodesOrderChanged || (params.rowNodesOrderChanged = orderChanged);
        }
    }
};
var $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED = 2147483648;
var $5b7ccabde48fae90$var$FLAG_CHANGED = 1073741824;
var $5b7ccabde48fae90$var$FLAG_MARKED_FILLER = 536870912;
var $5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED = 268435456;
var $5b7ccabde48fae90$var$MASK_CHILDREN_LEN = 268435455;
var $5b7ccabde48fae90$var$PATH_KEY_SEPARATOR = String.fromCharCode(31, 4096 + Math.random() * 61440, 4096 + Math.random() * 61440, 8291);
var $5b7ccabde48fae90$var$TreeGroupStrategy = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.groupColsIds = "";
        this.groupColsChanged = true;
        this.parentIdGetter = null;
        this.fillerNodesById = null;
        this.nodesToUnselect = null;
    }
    destroy() {
        super.destroy();
        this.groupColsIds = "";
        this.parentIdGetter = null;
        this.fillerNodesById = null;
        this.nodesToUnselect = null;
    }
    reset() {
        this.destroyFillerRows();
        this.deselectHiddenNodes(false);
        this.groupColsIds = "";
        this.groupColsChanged = true;
        this.parentIdGetter = null;
    }
    getNode(id) {
        return this.fillerNodesById?.get(id);
    }
    execute(params, approach) {
        const { changedRowNodes: changedRowNodes, changedPath: changedPath, afterColumnsChanged: afterColumnsChanged } = params;
        this.checkGroupColsUpdated(afterColumnsChanged);
        const rootNode = params.rowNode;
        const activeChangedPath = changedPath?.active ? changedPath : void 0;
        const fullReload = !changedRowNodes && !activeChangedPath;
        const hasUpdates = !!changedRowNodes && this.flagUpdatedNodes(changedRowNodes);
        if (fullReload || hasUpdates) {
            if (approach === "treeNested") this.loadNested(params, fullReload);
            else if (approach === "treeSelfRef") this.loadSelfRef(params, fullReload);
            else this.loadDataPath(params, fullReload);
        }
        const parentsChanged = this.initRowsParents(rootNode);
        this.destroyFillerRows();
        this.initRowsChildrenSize(rootNode);
        let preprocessedCount = this.preprocessRows(rootNode);
        const treeChanged = parentsChanged || (preprocessedCount & $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED) !== 0;
        preprocessedCount &= ~$5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED;
        const traverseCount = this.traverseRoot(rootNode, activeChangedPath);
        if (preprocessedCount > 0 && preprocessedCount !== traverseCount) {
            this.handleCycles(rootNode);
            this.traverseRoot(rootNode, activeChangedPath);
        }
        rootNode.treeNodeFlags = 0;
        this.deselectHiddenNodes(parentsChanged || fullReload);
        return treeChanged;
    }
    flagUpdatedNodes(changedRowNodes) {
        const { adds: adds, updates: updates, removals: removals } = changedRowNodes;
        let hasUpdates = removals.size > 0;
        if (adds.size > 0) {
            hasUpdates = true;
            for (const node of adds)node.treeNodeFlags |= $5b7ccabde48fae90$var$FLAG_CHANGED;
        }
        if (updates.size > 0) {
            hasUpdates = true;
            for (const node of updates)node.treeNodeFlags |= $5b7ccabde48fae90$var$FLAG_CHANGED;
        }
        return hasUpdates;
    }
    initRowsParents(rootNode) {
        const rootAllLeafChildren = rootNode.allLeafChildren;
        const allLeafChildrenLen = rootAllLeafChildren.length;
        let treeChanged = false;
        for(let i = 0; i < allLeafChildrenLen; ++i){
            let current = rootAllLeafChildren[i];
            while(true){
                const oldParent = current.parent;
                const parent = current.treeParent;
                if (parent === null) {
                    if (oldParent) {
                        treeChanged = true;
                        this.hideRow(current);
                    }
                    break;
                }
                let parentFlags = parent.treeNodeFlags + 1;
                if (oldParent !== parent) {
                    treeChanged = true;
                    parentFlags |= $5b7ccabde48fae90$var$FLAG_CHANGED;
                    current.parent = parent;
                    if (oldParent) {
                        const oldParentFlags = oldParent.treeNodeFlags;
                        if ((oldParentFlags & $5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED) !== 0 && (parentFlags & $5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED) === 0 && parent.treeParent !== null && !parent.data) {
                            parent.expanded = oldParent.expanded;
                            parentFlags |= $5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED;
                        }
                        oldParent.treeNodeFlags = oldParentFlags | $5b7ccabde48fae90$var$FLAG_CHANGED;
                    }
                }
                if (parent.data || (parent.treeNodeFlags & $5b7ccabde48fae90$var$FLAG_MARKED_FILLER) !== 0 || parent.treeParent === null) {
                    parent.treeNodeFlags = parentFlags;
                    break;
                }
                parent.treeNodeFlags = parentFlags | $5b7ccabde48fae90$var$FLAG_MARKED_FILLER | current.treeNodeFlags & $5b7ccabde48fae90$var$FLAG_CHANGED;
                current = parent;
            }
        }
        return treeChanged;
    }
    destroyFillerRows() {
        const fillerNodesById = this.fillerNodesById;
        if (fillerNodesById) {
            for (const node of fillerNodesById.values())if (node.treeParent === null || (node.treeNodeFlags & $5b7ccabde48fae90$var$MASK_CHILDREN_LEN) === 0) {
                fillerNodesById.delete(node.id);
                this.hideRow(node);
            }
            if (fillerNodesById.size === 0) this.fillerNodesById = null;
        }
    }
    initRowsChildrenSize(rootNode) {
        this.initRowChildrenSize(rootNode);
        const rootAllLeafChildren = rootNode.allLeafChildren;
        const allLeafChildrenLen = rootAllLeafChildren.length;
        for(let i = 0; i < allLeafChildrenLen; ++i)this.initRowChildrenSize(rootAllLeafChildren[i]);
        const fillerNodesById = this.fillerNodesById;
        if (fillerNodesById !== null) for (const filler of fillerNodesById.values())this.initRowChildrenSize(filler);
    }
    initRowChildrenSize(row) {
        let { childrenAfterGroup: childrenAfterGroup, allLeafChildren: allLeafChildren, treeNodeFlags: treeNodeFlags } = row;
        const oldLen = childrenAfterGroup?.length;
        const len = treeNodeFlags & $5b7ccabde48fae90$var$MASK_CHILDREN_LEN;
        row.treeNodeFlags = treeNodeFlags & ~$5b7ccabde48fae90$var$MASK_CHILDREN_LEN | ((oldLen || 0) !== len ? $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED : 0);
        if (len === 0 && row.level >= 0) {
            if (childrenAfterGroup !== (0, $jIDNV._EmptyArray)) {
                row.childrenAfterGroup = (0, $jIDNV._EmptyArray);
                const sibling = row.sibling;
                if (sibling) sibling.childrenAfterGroup = (0, $jIDNV._EmptyArray);
            }
        } else if (oldLen !== len || childrenAfterGroup === allLeafChildren) {
            if (!childrenAfterGroup || childrenAfterGroup === (0, $jIDNV._EmptyArray) || childrenAfterGroup === allLeafChildren) {
                row.childrenAfterGroup = childrenAfterGroup = new Array(len);
                const sibling = row.sibling;
                if (sibling) sibling.childrenAfterGroup = childrenAfterGroup;
            } else childrenAfterGroup.length = len;
        }
    }
    preprocessRows(rootNode) {
        const rootAllLeafChildren = rootNode.allLeafChildren;
        const allLeafChildrenLen = rootAllLeafChildren.length;
        const groupColsChanged = this.groupColsChanged;
        let preprocessedCount = 0;
        let treeChanged = false;
        for(let i = 0; i < allLeafChildrenLen; ++i){
            let current = rootAllLeafChildren[i];
            while(true){
                const parent = current.treeParent;
                if (parent === null) break;
                ++preprocessedCount;
                let parentFlags = parent.treeNodeFlags;
                const parentChildren = parent.childrenAfterGroup;
                const indexInParent = parentFlags & $5b7ccabde48fae90$var$MASK_CHILDREN_LEN;
                parentFlags = parentFlags & ~$5b7ccabde48fae90$var$MASK_CHILDREN_LEN | indexInParent + 1;
                if (parentFlags & $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED || parentChildren[indexInParent] !== current) {
                    parentFlags |= $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED;
                    parentChildren[indexInParent] = current;
                    treeChanged = true;
                }
                parent.treeNodeFlags = parentFlags;
                if (!current.groupData || groupColsChanged) {
                    current.treeNodeFlags |= $5b7ccabde48fae90$var$FLAG_CHANGED;
                    this.setGroupData(current, current.key);
                }
                if (parent.data || (parent.treeNodeFlags & $5b7ccabde48fae90$var$FLAG_MARKED_FILLER) === 0 || parent.treeParent === null) break;
                parent.treeNodeFlags = parentFlags & ~$5b7ccabde48fae90$var$FLAG_MARKED_FILLER | current.treeNodeFlags & $5b7ccabde48fae90$var$FLAG_CHANGED;
                current = parent;
            }
        }
        return preprocessedCount | (treeChanged ? $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED : 0);
    }
    traverseRoot(rootNode, activeChangedPath) {
        let traverseCount = 0;
        const rootChildrenAfterGroup = rootNode.childrenAfterGroup;
        for(let i = 0, len = rootChildrenAfterGroup.length; i < len; ++i)traverseCount += this.traverse(rootChildrenAfterGroup[i], 0, false, activeChangedPath);
        return traverseCount & ~$5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED;
    }
    /**
   * After all the rows are initialized and treeParent is set and childrenAfterGroup is filled,
   * we traverse the tree to finalize it
   * @returns the number of leaf nodes processed, which is used to detect cycles in the tree, and a flag set if leaf children were changed.
   */ traverse(row, level, collapsed, activeChangedPath) {
        const children = row.childrenAfterGroup;
        const len = children.length;
        let flags = row.treeNodeFlags;
        row.treeNodeFlags = flags & $5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED;
        row.level = level;
        if (row.group !== !!len) {
            $5b7ccabde48fae90$var$setRowNodeGroup(row, this.beans, !!len);
            flags |= $5b7ccabde48fae90$var$FLAG_CHANGED;
        } else if (row.hasChildren() !== !!len) {
            row.updateHasChildren();
            flags |= $5b7ccabde48fae90$var$FLAG_CHANGED;
        }
        if ((flags & ($5b7ccabde48fae90$var$FLAG_CHANGED | $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED)) !== 0) activeChangedPath?.addParentNode(row);
        const canBeExpanded = len !== 0 || row.master;
        if (!canBeExpanded) {
            if (row.expanded) row.expanded = false;
            if ((flags & $5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED) !== 0) row.treeNodeFlags &= ~$5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED;
        } else if ((flags & $5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED) === 0) {
            row.treeNodeFlags |= $5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED;
            row.expanded = $5b7ccabde48fae90$var$_getRowDefaultExpanded(this.beans, row, level);
        }
        if (collapsed && row.rowIndex !== null) row.clearRowTopAndRowIndex();
        collapsed || (collapsed = row.expanded === false);
        ++level;
        flags &= $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED;
        let leafsLen = 0;
        for(let i = 0; i < len; ++i){
            const child = children[i];
            const childFlags = this.traverse(child, level, collapsed, activeChangedPath);
            flags = flags + (childFlags & ~$5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED) | childFlags & $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED;
            leafsLen += (child.allLeafChildren?.length || 0) + (child.data ? 1 : 0);
        }
        if (this.updateAllLeafChildren(row, leafsLen, (flags & $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED) !== 0)) return (flags | $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED) + 1;
        return (flags & ~$5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED) + 1;
    }
    updateAllLeafChildren(row, len, maybeChanged) {
        let leafs = row.allLeafChildren;
        let trulyChanged = (leafs?.length || 0) !== len;
        if (len === 0) {
            if (leafs !== null) {
                row.allLeafChildren = null;
                const sibling = row.sibling;
                if (sibling) sibling.allLeafChildren = null;
            }
        } else if (trulyChanged || maybeChanged) {
            if (!leafs) {
                row.allLeafChildren = leafs = new Array(len);
                const sibling = row.sibling;
                if (sibling) sibling.allLeafChildren = leafs;
            } else if (trulyChanged) leafs.length = len;
            const rows = row.childrenAfterGroup;
            for(let i = 0, writeIdx = 0, childrenLen = rows.length; i < childrenLen; ++i){
                const child = rows[i];
                if (child.data) {
                    if (trulyChanged || (trulyChanged = leafs[writeIdx] !== child)) leafs[writeIdx] = child;
                    ++writeIdx;
                }
                const childLeafs = child.allLeafChildren;
                if (childLeafs) for(let j = 0, len2 = childLeafs.length; j < len2; ++j, ++writeIdx){
                    const leaf = childLeafs[j];
                    if (trulyChanged || (trulyChanged = leafs[writeIdx] !== leaf)) leafs[writeIdx] = leaf;
                }
            }
        }
        return trulyChanged;
    }
    /** Handle cycles in a tree. Is not optimal for performance but this is an edge case that shouldn't happen as is a warning. */ handleCycles(rootNode) {
        const marked = /* @__PURE__ */ new Set();
        const mark = (row)=>{
            if (marked.has(row)) return false;
            marked.add(row);
            row.childrenAfterGroup.forEach(mark);
            return true;
        };
        mark(rootNode);
        const rootChildrenAfterGroup = rootNode.childrenAfterGroup;
        rootChildrenAfterGroup.length = 0;
        for (const row of rootNode.allLeafChildren){
            const parent = row.treeParent;
            if (parent && mark(row)) {
                parent.treeNodeFlags |= $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED | $5b7ccabde48fae90$var$FLAG_CHANGED;
                row.parent = rootNode;
                (0, $jIDNV._removeFromArray)(parent.childrenAfterGroup, row);
                rootChildrenAfterGroup.push(row);
                (0, $jIDNV._warn)(270, {
                    id: row.id,
                    parentId: parent?.id ?? ""
                });
            } else if (parent === rootNode) rootChildrenAfterGroup.push(row);
        }
    }
    setGroupData(row, key) {
        const groupData = {};
        const groupDisplayCols = this.beans.showRowGroupCols?.getShowRowGroupCols();
        row.groupData = groupData;
        if (groupDisplayCols) for (const col of groupDisplayCols)groupData[col.getColId()] = key;
    }
    /** Load the tree structure for nested groups, aka children property */ loadNested({ rowNode: rootNode, changedRowNodes: changedRowNodes }, fullReload) {
        if (!fullReload && changedRowNodes) {
            for (const row of changedRowNodes.adds)row.key = row.id;
            return;
        }
        const rootAllLeafChildren = rootNode.allLeafChildren;
        for(let i = 0, len = rootAllLeafChildren.length; i < len; ++i){
            const row = rootAllLeafChildren[i];
            const id = row.id;
            if (row.key !== id) {
                row.key = id;
                row.groupData = null;
            }
        }
    }
    /** Load the tree structure for self-referencing data, aka parentId field */ loadSelfRef({ rowNode: rootNode, changedRowNodes: changedRowNodes }, fullReload) {
        const rootAllLeafChildren = rootNode.allLeafChildren;
        const gos = this.gos;
        if (!gos.get("getRowId")) {
            for(let i = 0, len = rootAllLeafChildren.length; i < len; ++i)rootAllLeafChildren[i].treeParent = null;
            return;
        }
        const rowModel = this.beans.rowModel;
        const removals = changedRowNodes?.removals;
        let parentIdGetter = this.parentIdGetter;
        const parentIdField = gos.get("treeDataParentIdField") || null;
        if (parentIdGetter?.path !== parentIdField) {
            this.parentIdGetter = parentIdGetter = $5b7ccabde48fae90$var$makeFieldPathGetter(parentIdField);
            fullReload = true;
        }
        for(let i = 0, len = rootAllLeafChildren.length; i < len; ++i){
            const row = rootAllLeafChildren[i];
            if (fullReload || row.treeNodeFlags & $5b7ccabde48fae90$var$FLAG_CHANGED || removals?.has(row.treeParent)) {
                let newParent;
                const parentId = parentIdGetter(row.data);
                if (parentId !== null && parentId !== void 0) {
                    newParent = rowModel.getRowNode(parentId);
                    if (!newParent) (0, $jIDNV._warn)(271, {
                        id: row.id,
                        parentId: parentId
                    });
                }
                row.treeParent = newParent ?? rootNode;
                const id = row.id;
                if (row.key !== id) {
                    row.key = id;
                    row.groupData = null;
                }
            } else row.treeParent ?? (row.treeParent = rootNode);
        }
    }
    loadFlattened(rootNode) {
        const allLeafChildren = rootNode.allLeafChildren;
        for(let i = 0, len = allLeafChildren.length; i < len; ++i){
            const row = allLeafChildren[i];
            row.treeParent = rootNode;
            const id = row.id;
            if (row.key !== id) {
                row.key = id;
                row.groupData = null;
            }
        }
    }
    /** Load the tree structure for data paths, aka getDataPath callback */ loadDataPath({ rowNode: rootNode }, fullReload) {
        const getDataPath = this.gos.get("getDataPath");
        if (!getDataPath) {
            this.loadFlattened(rootNode);
            return;
        }
        const nodesByPath = /* @__PURE__ */ new Map();
        const paths = /* @__PURE__ */ new Map();
        let dupPaths;
        if (!fullReload) dupPaths = this.loadExistingDataPath(rootNode, nodesByPath, paths);
        const allLeafChildren = rootNode.allLeafChildren;
        for(let i = 0, len = allLeafChildren.length; i < len; ++i){
            const node = allLeafChildren[i];
            if (!fullReload && node.treeParent !== null && (node.treeNodeFlags & $5b7ccabde48fae90$var$FLAG_CHANGED) === 0) continue;
            const path = getDataPath(node.data);
            const pathLen = path?.length;
            if (!pathLen) {
                (0, $jIDNV._warn)(185, {
                    data: node.data
                });
                continue;
            }
            const key = path[pathLen - 1];
            if (node.key !== key) {
                node.key = key;
                node.groupData = null;
            }
            const pathKey = path.join($5b7ccabde48fae90$var$PATH_KEY_SEPARATOR);
            paths.set(node, pathKey);
            const existing = nodesByPath.get(pathKey);
            if (existing === void 0) nodesByPath.set(pathKey, node);
            else if (existing !== node) dupPaths = this.duplicatedPath(nodesByPath, dupPaths, existing, node, pathKey);
        }
        if (dupPaths) this.processDuplicatePaths(dupPaths, paths);
        this.buildFromPaths(rootNode, nodesByPath, paths);
    }
    loadExistingDataPath(rootNode, nodesByPath, paths) {
        let dupPaths;
        const allLeafChildren = rootNode.allLeafChildren;
        for(let i = 0, len = allLeafChildren.length; i < len; ++i){
            const node = allLeafChildren[i];
            const treeParent = node.treeParent;
            if (treeParent === null || (node.treeNodeFlags & $5b7ccabde48fae90$var$FLAG_CHANGED) !== 0) continue;
            let pathKey = node.key;
            let current = treeParent;
            while(current && current !== rootNode && current !== node){
                pathKey = $5b7ccabde48fae90$var$PATH_KEY_SEPARATOR + pathKey;
                const existingPathKey = paths.get(current);
                if (existingPathKey !== void 0) {
                    pathKey = existingPathKey + pathKey;
                    break;
                }
                pathKey = current.key + pathKey;
                current = current.treeParent;
            }
            if (current !== node) {
                paths.set(node, pathKey);
                const existing = nodesByPath.get(pathKey);
                if (existing === void 0) nodesByPath.set(pathKey, node);
                else if (existing !== node) dupPaths = this.duplicatedPath(nodesByPath, dupPaths, existing, node, pathKey);
            }
        }
        return dupPaths;
    }
    duplicatedPath(nodesByPath, dupPaths, existing, node, pathKey) {
        if (node.sourceRowIndex < existing.sourceRowIndex) nodesByPath.set(pathKey, node);
        const duplicates = (dupPaths ?? (dupPaths = /* @__PURE__ */ new Map())).get(pathKey);
        if (duplicates === void 0) dupPaths.set(pathKey, [
            existing,
            node
        ]);
        else duplicates.push(node);
        return dupPaths;
    }
    buildFromPaths(rootNode, nodesByPath, paths) {
        const SEP = $5b7ccabde48fae90$var$PATH_KEY_SEPARATOR;
        const SEP_LEN = $5b7ccabde48fae90$var$PATH_KEY_SEPARATOR.length;
        const segments = new Array(32);
        const allLeafChildren = rootNode.allLeafChildren;
        for(let i = 0, len = allLeafChildren.length; i < len; ++i){
            const node = allLeafChildren[i];
            const pathKey = paths.get(node);
            if (pathKey === void 0) continue;
            let segmentsLen = 0;
            let scanPos = 0;
            while(scanPos < pathKey.length){
                const sepPos = pathKey.indexOf(SEP, scanPos);
                if (sepPos === -1) break;
                segments[segmentsLen++] = sepPos;
                scanPos = sepPos + SEP_LEN;
            }
            let startLevel = 0;
            let treeParent = rootNode;
            for(let level = segmentsLen - 1; level >= 0; --level){
                const existing = nodesByPath.get(pathKey.slice(0, segments[level]));
                if (existing) {
                    treeParent = existing;
                    startLevel = level + 1;
                    break;
                }
            }
            for(let level = startLevel; level < segmentsLen; ++level){
                const end = segments[level];
                const start = level === 0 ? 0 : segments[level - 1] + SEP_LEN;
                const subPath = pathKey.slice(0, end);
                let current = nodesByPath.get(subPath);
                if (current === void 0) {
                    current = this.getOrCreateFiller(treeParent, pathKey.slice(start, end), level);
                    nodesByPath.set(subPath, current);
                } else current.treeParent = treeParent;
                treeParent = current;
            }
            node.treeParent = treeParent;
        }
    }
    processDuplicatePaths(duplicatePaths, paths) {
        for (const duplicates of duplicatePaths.values()){
            duplicates.sort($5b7ccabde48fae90$var$compareSourceRowIndex);
            const len = duplicates.length;
            const duplicateRowsData = new Array(len - 1);
            for(let i = 1; i < len; ++i){
                const node = duplicates[i];
                paths.delete(node);
                node.treeParent = null;
                duplicateRowsData[i - 1] = node.data;
            }
            const first = duplicates[0];
            (0, $jIDNV._warn)(186, {
                rowId: first.id,
                rowData: first.data,
                duplicateRowsData: duplicateRowsData
            });
        }
    }
    getOrCreateFiller(treeParent, key, level) {
        let id = level + "-" + key;
        let current = treeParent;
        while(--level >= 0){
            id = level + "-" + current.key + "-" + id;
            current = current.treeParent;
        }
        id = (0, $jIDNV._ROW_ID_PREFIX_ROW_GROUP) + id;
        const fillerNodesById = this.fillerNodesById ?? (this.fillerNodesById = /* @__PURE__ */ new Map());
        let node = fillerNodesById.get(id);
        if (node === void 0) {
            node = new (0, $jIDNV.RowNode)(this.beans);
            node.id = id;
            node.key = key;
            node.group = true;
            node.leafGroup = false;
            node.rowGroupIndex = null;
            node.treeParent = treeParent;
            fillerNodesById.set(id, node);
        }
        return node;
    }
    deselectHiddenNodes(updated) {
        const selectionSvc = this.beans.selectionSvc;
        const nodes = this.nodesToUnselect;
        const source = "rowDataChanged";
        if (nodes) {
            this.nodesToUnselect = null;
            selectionSvc?.setNodesSelected({
                newValue: false,
                nodes: nodes,
                suppressFinishActions: true,
                source: source
            });
        }
        if (nodes || updated) selectionSvc?.updateGroupsFromChildrenSelections?.(source);
        if (nodes) {
            const selectedNodes = selectionSvc?.getSelectedNodes() ?? null;
            this.eventSvc.dispatchEvent({
                type: "selectionChanged",
                source: source,
                selectedNodes: selectedNodes,
                serverSideState: null
            });
        }
    }
    hideRow(row) {
        if (row.isSelected()) (this.nodesToUnselect ?? (this.nodesToUnselect = [])).push(row);
        row.parent = null;
        row.group = false;
        row.groupData = null;
        row.treeParent = null;
        row.treeNodeFlags = 0;
        row.allLeafChildren = null;
        row.childrenAfterGroup = (0, $jIDNV._EmptyArray);
        const sibling = row.sibling;
        if (sibling) {
            sibling.allLeafChildren = null;
            sibling.childrenAfterGroup = (0, $jIDNV._EmptyArray);
        }
        row.updateHasChildren();
        if (row.rowIndex !== null) row.clearRowTopAndRowIndex();
    }
    checkGroupColsUpdated(afterColumnsChanged) {
        this.groupColsChanged = false;
        if (afterColumnsChanged || !this.groupColsIds) {
            const cols = this.beans.showRowGroupCols?.getShowRowGroupCols() ?? (0, $jIDNV._EmptyArray);
            let groupColsIds = "";
            for(let i = 0, len = cols.length; i < len; ++i)groupColsIds += cols[i].getId() + $5b7ccabde48fae90$var$PATH_KEY_SEPARATOR;
            if (this.groupColsIds !== groupColsIds) {
                this.groupColsIds = groupColsIds;
                this.groupColsChanged = true;
            }
        }
    }
};
var $5b7ccabde48fae90$var$compareSourceRowIndex = (a, b)=>a.sourceRowIndex - b.sourceRowIndex;
// packages/ag-grid-enterprise/src/treeData/treeDataModule.ts
var $5b7ccabde48fae90$var$SharedTreeDataModule = {
    moduleName: "SharedTreeData",
    version: $5b7ccabde48fae90$var$VERSION,
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        $5b7ccabde48fae90$var$SharedAggregationModule,
        $5b7ccabde48fae90$var$GroupColumnModule,
        $5b7ccabde48fae90$var$StickyRowModule
    ]
};
var $5b7ccabde48fae90$export$3460d687131d67ba = {
    moduleName: "TreeData",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$ClientSideChildrenTreeNodeManager
    ],
    dynamicBeans: {
        treeGroupStrategy: $5b7ccabde48fae90$var$TreeGroupStrategy
    },
    rowModels: [
        "clientSide"
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$SharedTreeDataModule,
        $5b7ccabde48fae90$export$b53def5458540436,
        $5b7ccabde48fae90$var$ClientSideRowModelHierarchyModule
    ]
};
var $5b7ccabde48fae90$var$GROUP_MISSING_KEY_ID = "ag-Grid-MissingKey";
var $5b7ccabde48fae90$var$BlockUtils = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmBlockUtils";
    }
    wireBeans(beans) {
        this.valueSvc = beans.valueSvc;
        this.showRowGroupCols = beans.showRowGroupCols;
        this.nodeManager = beans.ssrmNodeManager;
        this.expansionSvc = beans.expansionSvc;
        this.serverSideRowModel = beans.rowModel;
        this.storeFactory = beans.ssrmStoreFactory;
    }
    createRowNode(params) {
        const rowNode = new (0, $jIDNV.RowNode)(this.beans);
        const rowHeight = params.rowHeight != null ? params.rowHeight : (0, $jIDNV._getRowHeightAsNumber)(this.beans);
        rowNode.setRowHeight(rowHeight);
        rowNode.group = params.group;
        rowNode.leafGroup = params.leafGroup;
        rowNode.level = params.level;
        rowNode.uiLevel = params.level;
        rowNode.parent = params.parent;
        rowNode.stub = true;
        rowNode.__needsRefreshWhenVisible = false;
        if (rowNode.group) {
            rowNode.expanded = false;
            rowNode.field = params.field;
            rowNode.rowGroupColumn = params.rowGroupColumn;
            rowNode.rowGroupIndex = params.level;
        }
        return rowNode;
    }
    destroyRowNode(rowNode, preserveStore = false) {
        if (rowNode.childStore && !preserveStore) {
            this.destroyBean(rowNode.childStore);
            rowNode.childStore = null;
        }
        if (rowNode.sibling && !rowNode.footer) this.destroyRowNode(rowNode.sibling, false);
        rowNode.clearRowTopAndRowIndex();
        if (rowNode.id != null) this.nodeManager.removeNode(rowNode);
    }
    setTreeGroupInfo(rowNode) {
        rowNode.updateHasChildren();
        const getKeyFunc = this.gos.get("getServerSideGroupKey");
        const hasChildren = rowNode.hasChildren();
        if (hasChildren && getKeyFunc != null) rowNode.key = getKeyFunc(rowNode.data);
        if (!hasChildren && rowNode.childStore != null) {
            this.destroyBean(rowNode.childStore);
            rowNode.childStore = null;
            if (!rowNode.master) rowNode.expanded = false;
        }
    }
    setRowGroupInfo(rowNode) {
        rowNode.key = this.valueSvc.getValue(rowNode.rowGroupColumn, rowNode);
        if (rowNode.key === null || rowNode.key === void 0) (0, $jIDNV._doOnce)(()=>{
            (0, $jIDNV._warn)(190, {
                rowGroupId: rowNode.rowGroupColumn?.getId(),
                data: rowNode.data
            });
        }, "SSBlock-BadKey");
        const isUnbalancedGroup = this.gos.get("groupAllowUnbalanced") && rowNode.key === "";
        if (isUnbalancedGroup) {
            const storeParams = this.serverSideRowModel.getParams();
            rowNode.childStore = this.createBean(this.storeFactory.createStore(storeParams, rowNode));
        }
        const getGroupIncludeFooter = (0, $jIDNV._getGroupTotalRowCallback)(this.beans.gos);
        const doesRowShowFooter = getGroupIncludeFooter({
            node: rowNode
        });
        if (doesRowShowFooter) {
            $5b7ccabde48fae90$var$_createRowNodeFooter(rowNode, this.beans);
            if (rowNode.sibling) rowNode.sibling.uiLevel = rowNode.uiLevel + 1;
        }
    }
    setMasterDetailInfo(rowNode) {
        const isMasterFunc = this.gos.get("isRowMaster");
        if (isMasterFunc != null) rowNode.master = isMasterFunc(rowNode.data);
        else rowNode.master = true;
    }
    updateDataIntoRowNode(rowNode, data) {
        rowNode.updateData(data);
        if (this.gos.get("treeData")) {
            this.setTreeGroupInfo(rowNode);
            this.setChildCountIntoRowNode(rowNode);
            this.updateRowFooter(rowNode);
        } else if (rowNode.group) {
            this.setChildCountIntoRowNode(rowNode);
            this.updateRowFooter(rowNode);
        } else this.gos.get("masterDetail");
    }
    updateRowFooter(rowNode) {
        if (rowNode.footer) return;
        if (rowNode.group) {
            const getGroupIncludeFooter = (0, $jIDNV._getGroupTotalRowCallback)(this.beans.gos);
            const shouldRowShowFooter = getGroupIncludeFooter({
                node: rowNode
            });
            if (shouldRowShowFooter && !rowNode.sibling) {
                $5b7ccabde48fae90$var$_createRowNodeFooter(rowNode, this.beans);
                return;
            }
        }
        if (rowNode.sibling) $5b7ccabde48fae90$var$_destroyRowNodeFooter(rowNode);
    }
    setDataIntoRowNode(rowNode, data, defaultId, cachedRowHeight) {
        rowNode.stub = false;
        const treeData = this.gos.get("treeData");
        rowNode.setDataAndId(data, defaultId);
        const group = rowNode.group;
        if ((treeData || !group) && this.gos.get("masterDetail")) this.setMasterDetailInfo(rowNode);
        if (treeData) this.setTreeGroupInfo(rowNode);
        else if (group) this.setRowGroupInfo(rowNode);
        if (treeData || group) {
            this.setGroupDataIntoRowNode(rowNode);
            this.setChildCountIntoRowNode(rowNode);
        }
        if ((0, $jIDNV._exists)(data)) {
            rowNode.setRowHeight((0, $jIDNV._getRowHeightForNode)(this.beans, rowNode, false, cachedRowHeight).height);
            rowNode.sibling?.setRowHeight((0, $jIDNV._getRowHeightForNode)(this.beans, rowNode.sibling, false, cachedRowHeight).height);
        }
    }
    setChildCountIntoRowNode(rowNode) {
        const getChildCount = this.gos.get("getChildCount");
        if (getChildCount) rowNode.setAllChildrenCount(getChildCount(rowNode.data));
    }
    setGroupDataIntoRowNode(rowNode) {
        rowNode.groupValue = rowNode.key;
        const groupDisplayCols = this.showRowGroupCols?.getShowRowGroupCols() ?? [];
        const usingTreeData = this.gos.get("treeData");
        groupDisplayCols.forEach((col)=>{
            if (rowNode.groupData == null) rowNode.groupData = {};
            if (usingTreeData) rowNode.groupData[col.getColId()] = rowNode.key;
            else if (col.isRowGroupDisplayed(rowNode.rowGroupColumn.getId())) {
                const groupValue = this.valueSvc.getValue(rowNode.rowGroupColumn, rowNode);
                rowNode.groupData[col.getColId()] = groupValue;
            }
        });
    }
    clearDisplayIndex(rowNode) {
        rowNode.clearRowTopAndRowIndex();
        const hasChildStore = rowNode.hasChildren() && !!rowNode.childStore;
        if (hasChildStore) rowNode.childStore?.clearDisplayIndexes();
        const hasDetailNode = rowNode.master && rowNode.detailNode;
        if (hasDetailNode) rowNode.detailNode?.clearRowTopAndRowIndex();
    }
    setDisplayIndex(rowNode, displayIndexSeq, nextRowTop, uiLevel) {
        const isUnbalancedGroup = this.gos.get("groupAllowUnbalanced") && rowNode.group && rowNode.key === "";
        const isHiddenOpenGroup = this.gos.get("groupHideOpenParents") && rowNode.group && rowNode.expanded;
        if (isHiddenOpenGroup || isUnbalancedGroup) {
            rowNode.setRowIndex(null);
            rowNode.setRowTop(null);
        } else {
            rowNode.setRowIndex(displayIndexSeq.value++);
            rowNode.setRowTop(nextRowTop.value);
            nextRowTop.value += rowNode.rowHeight;
        }
        rowNode.setUiLevel(uiLevel);
        if (rowNode.footer) return;
        const hasDetailRow = rowNode.master;
        if (hasDetailRow) {
            if (rowNode.expanded && rowNode.detailNode) {
                rowNode.detailNode.setRowIndex(displayIndexSeq.value++);
                rowNode.detailNode.setRowTop(nextRowTop.value);
                nextRowTop.value += rowNode.detailNode.rowHeight;
            } else if (rowNode.detailNode) rowNode.detailNode.clearRowTopAndRowIndex();
        }
        const hasChildStore = rowNode.hasChildren() && !!rowNode.childStore;
        if (hasChildStore) {
            const childStore = rowNode.childStore;
            if (rowNode.expanded || isUnbalancedGroup) childStore.setDisplayIndexes(displayIndexSeq, nextRowTop, isUnbalancedGroup ? uiLevel : uiLevel + 1);
            else childStore.clearDisplayIndexes();
        }
    }
    extractRowBounds(rowNode, index) {
        const extractRowBounds = (currentRowNode)=>({
                rowHeight: currentRowNode.rowHeight,
                rowTop: currentRowNode.rowTop
            });
        if (rowNode.rowIndex === index) return extractRowBounds(rowNode);
        if (rowNode.hasChildren() && rowNode.expanded && !!rowNode.childStore) {
            const childStore = rowNode.childStore;
            if (childStore.isDisplayIndexInStore(index)) return childStore.getRowBounds(index);
        } else if (rowNode.master && rowNode.expanded && rowNode.detailNode) {
            if (rowNode.detailNode.rowIndex === index) return extractRowBounds(rowNode.detailNode);
        }
    }
    isPixelInNodeRange(node, pixel) {
        if (!(0, $jIDNV._exists)(node.rowTop) || !(0, $jIDNV._exists)(node.rowHeight)) return false;
        return pixel >= node.rowTop && pixel < node.rowTop + node.rowHeight;
    }
    getIndexAtPixel(rowNode, pixel) {
        if (this.isPixelInNodeRange(rowNode, pixel)) return rowNode.rowIndex;
        const expandedMasterRow = rowNode.master && rowNode.expanded;
        const detailNode = rowNode.detailNode;
        if (expandedMasterRow && detailNode && this.isPixelInNodeRange(detailNode, pixel)) return detailNode.rowIndex;
        if (rowNode.hasChildren() && rowNode.expanded && !!rowNode.childStore) {
            const childStore = rowNode.childStore;
            if (childStore.isPixelInRange(pixel)) return childStore.getRowIndexAtPixel(pixel);
        }
        return null;
    }
    createNodeIdPrefix(parentRowNode) {
        const parts = [];
        let rowNode = parentRowNode;
        while(rowNode && rowNode.level >= 0){
            if (rowNode.key === "") parts.push($5b7ccabde48fae90$var$GROUP_MISSING_KEY_ID);
            else parts.push(rowNode.key);
            rowNode = rowNode.parent;
        }
        if (parts.length > 0) return parts.reverse().join("-");
        return void 0;
    }
    checkOpenByDefault(rowNode) {
        return this.expansionSvc?.checkOpenByDefault(rowNode);
    }
};
var $5b7ccabde48fae90$var$ExpandListener = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmExpandListener";
    }
    wireBeans(beans) {
        this.serverSideRowModel = beans.rowModel;
        this.storeFactory = beans.ssrmStoreFactory;
    }
    postConstruct() {
        if (!(0, $jIDNV._isServerSideRowModel)(this.gos)) return;
        this.addManagedEventListeners({
            rowGroupOpened: this.onRowGroupOpened.bind(this)
        });
    }
    onRowGroupOpened(event) {
        const rowNode = event.node;
        if (rowNode.expanded) {
            if (rowNode.master) this.createDetailNode(rowNode);
            if ((0, $jIDNV._missing)(rowNode.childStore) && rowNode.hasChildren()) {
                const storeParams = this.serverSideRowModel.getParams();
                rowNode.childStore = this.createBean(this.storeFactory.createStore(storeParams, rowNode));
            }
        } else if (this.gos.get("purgeClosedRowNodes") && (0, $jIDNV._exists)(rowNode.childStore)) rowNode.childStore = this.destroyBean(rowNode.childStore);
        this.eventSvc.dispatchEvent({
            type: "storeUpdated"
        });
    }
    createDetailNode(masterNode) {
        if ((0, $jIDNV._exists)(masterNode.detailNode)) return masterNode.detailNode;
        const detailNode = new (0, $jIDNV.RowNode)(this.beans);
        detailNode.detail = true;
        detailNode.selectable = false;
        detailNode.parent = masterNode;
        if ((0, $jIDNV._exists)(masterNode.id)) detailNode.id = "detail_" + masterNode.id;
        detailNode.data = masterNode.data;
        detailNode.level = masterNode.level + 1;
        const defaultDetailRowHeight = 200;
        const rowHeight = (0, $jIDNV._getRowHeightForNode)(this.beans, detailNode).height;
        detailNode.rowHeight = rowHeight ? rowHeight : defaultDetailRowHeight;
        masterNode.detailNode = detailNode;
        return detailNode;
    }
};
var $5b7ccabde48fae90$var$FilterListener = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmFilterListener";
    }
    wireBeans(beans) {
        this.serverSideRowModel = beans.rowModel;
        this.filterManager = beans.filterManager;
        this.listenerUtils = beans.ssrmListenerUtils;
    }
    postConstruct() {
        if (!(0, $jIDNV._isServerSideRowModel)(this.gos)) return;
        this.addManagedEventListeners({
            advancedFilterEnabledChanged: ()=>this.onFilterChanged(true),
            filterChanged: ()=>this.onFilterChanged()
        });
    }
    onFilterChanged(advancedFilterEnabledChanged) {
        const storeParams = this.serverSideRowModel.getParams();
        if (!storeParams) return;
        const oldModel = storeParams.filterModel;
        let newModel;
        let changedColumns;
        if (this.filterManager?.isAdvFilterEnabled()) {
            newModel = this.filterManager.getAdvFilterModel();
            const oldColumns = advancedFilterEnabledChanged ? Object.keys(oldModel ?? {}) : this.getAdvancedFilterColumns(oldModel);
            const newColumns = this.getAdvancedFilterColumns(newModel);
            oldColumns.forEach((column)=>newColumns.add(column));
            changedColumns = Array.from(newColumns);
        } else {
            newModel = this.filterManager?.getFilterModel() ?? {};
            if (advancedFilterEnabledChanged) {
                const oldColumns = this.getAdvancedFilterColumns(oldModel);
                Object.keys(newModel).forEach((column)=>oldColumns.add(column));
                changedColumns = Array.from(oldColumns);
            } else changedColumns = this.findChangedColumns(oldModel, newModel);
        }
        const valueColChanged = this.listenerUtils.isSortingWithValueColumn(changedColumns);
        const secondaryColChanged = this.listenerUtils.isSortingWithSecondaryColumn(changedColumns);
        const params = {
            valueColChanged: valueColChanged,
            secondaryColChanged: secondaryColChanged,
            changedColumns: changedColumns
        };
        this.serverSideRowModel.refreshAfterFilter(newModel, params);
    }
    findChangedColumns(oldModel, newModel) {
        const allColKeysMap = {};
        Object.keys(oldModel).forEach((key)=>allColKeysMap[key] = true);
        Object.keys(newModel).forEach((key)=>allColKeysMap[key] = true);
        const res = [];
        Object.keys(allColKeysMap).forEach((key)=>{
            const oldJson = JSON.stringify(oldModel[key]);
            const newJson = JSON.stringify(newModel[key]);
            const filterChanged = oldJson != newJson;
            if (filterChanged) res.push(key);
        });
        return res;
    }
    getAdvancedFilterColumns(model) {
        const columns = /* @__PURE__ */ new Set();
        if (!model) return columns;
        const processAdvancedFilterModel = (filterModel)=>{
            if (filterModel.filterType === "join") filterModel.conditions.forEach((condition)=>processAdvancedFilterModel(condition));
            else columns.add(filterModel.colId);
        };
        processAdvancedFilterModel(model);
        return columns;
    }
};
var $5b7ccabde48fae90$var$ListenerUtils = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmListenerUtils";
    }
    wireBeans(beans) {
        this.pivotResultCols = beans.pivotResultCols;
        this.valueColsSvc = beans.valueColsSvc;
    }
    isSortingWithValueColumn(changedColumnsInSort) {
        const valueColIds = (this.valueColsSvc?.columns ?? []).map((col)=>col.getColId());
        for(let i = 0; i < changedColumnsInSort.length; i++){
            if (valueColIds.indexOf(changedColumnsInSort[i]) > -1) return true;
        }
        return false;
    }
    isSortingWithSecondaryColumn(changedColumnsInSort) {
        const pivotResultCols = this.pivotResultCols?.getPivotResultCols();
        if (!pivotResultCols) return false;
        const secondaryColIds = pivotResultCols.list.map((col)=>col.getColId());
        for(let i = 0; i < changedColumnsInSort.length; i++){
            if (secondaryColIds.indexOf(changedColumnsInSort[i]) > -1) return true;
        }
        return false;
    }
};
var $5b7ccabde48fae90$var$SortListener = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmSortSvc";
    }
    wireBeans(beans) {
        this.sortSvc = beans.sortSvc;
        this.serverSideRowModel = beans.rowModel;
        this.listenerUtils = beans.ssrmListenerUtils;
    }
    postConstruct() {
        if (!(0, $jIDNV._isServerSideRowModel)(this.gos)) return;
        this.addManagedEventListeners({
            sortChanged: this.onSortChanged.bind(this)
        });
    }
    onSortChanged() {
        const storeParams = this.serverSideRowModel.getParams();
        if (!storeParams) return;
        const newSortModel = this.sortSvc.getSortModel();
        const oldSortModel = storeParams.sortModel;
        const changedColumns = this.findChangedColumnsInSort(newSortModel, oldSortModel);
        const valueColChanged = this.listenerUtils.isSortingWithValueColumn(changedColumns);
        const secondaryColChanged = this.listenerUtils.isSortingWithSecondaryColumn(changedColumns);
        const params = {
            valueColChanged: valueColChanged,
            secondaryColChanged: secondaryColChanged,
            changedColumns: changedColumns
        };
        this.serverSideRowModel.refreshAfterSort(newSortModel, params);
    }
    // returns back all the cols that were effected by the sorting. eg if we were sorting by col A,
    // and now we are sorting by col B, the list of impacted cols should be A and B. so if a cache
    // is impacted by sorting on A or B then it needs to be refreshed. this includes where the cache
    // was previously sorted by A and then the A sort now needs to be cleared.
    findChangedColumnsInSort(newSortModel, oldSortModel) {
        let allColsInBothSorts = [];
        [
            newSortModel,
            oldSortModel
        ].forEach((sortModel)=>{
            if (sortModel) {
                const ids = sortModel.map((sm)=>sm.colId);
                allColsInBothSorts = allColsInBothSorts.concat(ids);
            }
        });
        const differentSorts = (oldSortItem, newSortItem)=>{
            const oldSort = oldSortItem ? oldSortItem.sort : null;
            const newSort = newSortItem ? newSortItem.sort : null;
            return oldSort !== newSort;
        };
        const differentIndexes = (oldSortItem, newSortItem)=>{
            const oldIndex = oldSortItem ? oldSortModel.indexOf(oldSortItem) : -1;
            const newIndex = newSortItem ? newSortModel.indexOf(newSortItem) : -1;
            return oldIndex !== newIndex;
        };
        return allColsInBothSorts.filter((colId)=>{
            const oldSortItem = oldSortModel.find((sm)=>sm.colId === colId);
            const newSortItem = newSortModel.find((sm)=>sm.colId === colId);
            return differentSorts(oldSortItem, newSortItem) || differentIndexes(oldSortItem, newSortItem);
        });
    }
};
var $5b7ccabde48fae90$var$NodeManager = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmNodeManager";
        this.rowNodes = /* @__PURE__ */ new Map();
    }
    addRowNode(rowNode) {
        const id = rowNode.id;
        if (this.rowNodes.has(id)) (0, $jIDNV._warn)(187, {
            rowId: id,
            firstData: this.rowNodes.get(id).data,
            secondData: rowNode.data
        });
        this.rowNodes.set(id, rowNode);
    }
    removeNode(rowNode) {
        const id = rowNode.id;
        this.rowNodes.delete(id);
    }
    destroy() {
        this.clear();
        super.destroy();
    }
    clear() {
        this.rowNodes.clear();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$ServerSideRowModel = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "rowModel";
        this.pauseStoreUpdateListening = false;
        this.started = false;
        this.managingPivotResultColumns = false;
        this.onRowHeightChanged_debounced = (0, $jIDNV._debounce)(this, this.onRowHeightChanged.bind(this), 100);
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.colNames = beans.colNames;
        this.pivotResultCols = beans.pivotResultCols;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
        this.pivotColsSvc = beans.pivotColsSvc;
        this.valueColsSvc = beans.valueColsSvc;
        this.filterManager = beans.filterManager;
        this.sortSvc = beans.sortSvc;
        this.rowRenderer = beans.rowRenderer;
        this.nodeManager = beans.ssrmNodeManager;
        this.storeFactory = beans.ssrmStoreFactory;
        this.pivotColDefSvc = beans.pivotColDefSvc;
    }
    // we don't implement as lazy row heights is not supported in this row model
    ensureRowHeightsValid() {
        return false;
    }
    start() {
        this.started = true;
        this.updateDatasource();
    }
    destroyDatasource() {
        if (!this.datasource) return;
        if (this.datasource.destroy) this.datasource.destroy();
        this.rowRenderer.datasourceChanged();
        this.datasource = void 0;
    }
    postConstruct() {
        const resetListener = this.resetRootStore.bind(this);
        this.addManagedEventListeners({
            newColumnsLoaded: this.onColumnEverything.bind(this),
            storeUpdated: this.onStoreUpdated.bind(this),
            columnValueChanged: resetListener,
            columnPivotChanged: resetListener,
            columnRowGroupChanged: resetListener,
            columnPivotModeChanged: resetListener
        });
        this.addManagedPropertyListeners([
            /**
         * Following properties omitted as they are likely to come with undesired  side effects.
         * 'getRowId', 'isRowMaster', 'getRowHeight', 'isServerSideGroup', 'getServerSideGroupKey',
         * */ "masterDetail",
            "treeData",
            "removePivotHeaderRowWhenSingleValueColumn",
            "cacheBlockSize"
        ], resetListener);
        this.addManagedPropertyListeners([
            "groupAllowUnbalanced",
            "groupTotalRow"
        ], ()=>this.onStoreUpdated());
        this.addManagedPropertyListener("rowHeight", ()=>this.resetRowHeights());
        this.verifyProps();
        this.addManagedPropertyListener("serverSideDatasource", ()=>this.updateDatasource());
    }
    updateDatasource() {
        const datasource = this.gos.get("serverSideDatasource");
        if (datasource) this.setDatasource(datasource);
    }
    verifyProps() {
        if ((0, $jIDNV._isRowSelection)(this.gos) && !this.gos.exists("getRowId")) (0, $jIDNV._warn)(188);
    }
    setDatasource(datasource) {
        if (!this.started) return;
        this.destroyDatasource();
        this.datasource = datasource;
        this.resetRootStore();
    }
    applyRowData(rowDataParams, startRow, route) {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        const storeToExecuteOn = rootStore.getChildStore(route);
        if (!storeToExecuteOn) return;
        storeToExecuteOn.applyRowData(rowDataParams, startRow, rowDataParams.rowData.length);
    }
    isLastRowIndexKnown() {
        const cache = this.getRootStore();
        if (!cache) return false;
        return cache.isLastRowIndexKnown();
    }
    onColumnEverything() {
        if (!this.storeParams) {
            this.resetRootStore();
            return;
        }
        const rowGroupColumnVos = this.columnsToValueObjects(this.rowGroupColsSvc?.columns);
        const valueColumnVos = this.columnsToValueObjects(this.valueColsSvc?.columns);
        const pivotColumnVos = this.columnsToValueObjects(this.pivotColsSvc?.columns);
        const areColsSame = (params)=>{
            const oldColsMap = {};
            params.oldCols.forEach((col)=>oldColsMap[col.id] = col);
            const allColsUnchanged = params.newCols.every((col)=>{
                const equivalentCol = oldColsMap[col.id];
                if (equivalentCol) delete oldColsMap[col.id];
                return equivalentCol && equivalentCol.field === col.field && equivalentCol.aggFunc === col.aggFunc;
            });
            const missingCols = !params.allowRemovedColumns && !!Object.values(oldColsMap).length;
            return allColsUnchanged && !missingCols;
        };
        const sortModelDifferent = !(0, $jIDNV._jsonEquals)(this.storeParams.sortModel, this.sortSvc?.getSortModel() ?? []);
        const rowGroupDifferent = !areColsSame({
            oldCols: this.storeParams.rowGroupCols,
            newCols: rowGroupColumnVos
        });
        const pivotDifferent = !areColsSame({
            oldCols: this.storeParams.pivotCols,
            newCols: pivotColumnVos
        });
        const valuesDifferent = !!rowGroupColumnVos?.length && !areColsSame({
            oldCols: this.storeParams.valueCols,
            newCols: valueColumnVos,
            allowRemovedColumns: true
        });
        const resetRequired = sortModelDifferent || rowGroupDifferent || pivotDifferent || valuesDifferent;
        if (resetRequired) this.resetRootStore();
        else {
            const newParams = this.createStoreParams();
            this.storeParams.rowGroupCols = newParams.rowGroupCols;
            this.storeParams.pivotCols = newParams.pivotCols;
            this.storeParams.valueCols = newParams.valueCols;
        }
    }
    destroyRootStore() {
        if (!this.rootNode || !this.rootNode.childStore) return;
        this.rootNode.childStore = this.destroyBean(this.rootNode.childStore);
        this.nodeManager.clear();
    }
    refreshAfterSort(newSortModel, params) {
        if (this.storeParams) this.storeParams.sortModel = newSortModel;
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.refreshAfterSort(params);
        this.onStoreUpdated();
    }
    generateSecondaryColumns(pivotFields) {
        if (!this.pivotColDefSvc) {
            this.gos.assertModuleRegistered("SharedPivot", 2);
            return;
        }
        const pivotColumnGroupDefs = this.pivotColDefSvc.createColDefsFromFields(pivotFields);
        this.managingPivotResultColumns = true;
        this.pivotResultCols?.setPivotResultCols(pivotColumnGroupDefs, "rowModelUpdated");
    }
    resetRowHeights() {
        const atLeastOne = this.resetRowHeightsForAllRowNodes();
        const rootNodeHeight = (0, $jIDNV._getRowHeightForNode)(this.beans, this.rootNode);
        this.rootNode.setRowHeight(rootNodeHeight.height, rootNodeHeight.estimated);
        if (this.rootNode.sibling) {
            const rootNodeSibling = (0, $jIDNV._getRowHeightForNode)(this.beans, this.rootNode.sibling);
            this.rootNode.sibling.setRowHeight(rootNodeSibling.height, rootNodeSibling.estimated);
        }
        if (atLeastOne) this.onRowHeightChanged();
    }
    resetRowHeightsForAllRowNodes() {
        let atLeastOne = false;
        this.forEachNode((rowNode)=>{
            const rowHeightForNode = (0, $jIDNV._getRowHeightForNode)(this.beans, rowNode);
            rowNode.setRowHeight(rowHeightForNode.height, rowHeightForNode.estimated);
            const detailNode = rowNode.detailNode;
            if (detailNode) {
                const detailRowHeight = (0, $jIDNV._getRowHeightForNode)(this.beans, detailNode);
                detailNode.setRowHeight(detailRowHeight.height, detailRowHeight.estimated);
            }
            if (rowNode.sibling) {
                const siblingRowHeight = (0, $jIDNV._getRowHeightForNode)(this.beans, rowNode.sibling);
                detailNode?.setRowHeight(siblingRowHeight.height, siblingRowHeight.estimated);
            }
            atLeastOne = true;
        });
        return atLeastOne;
    }
    resetRootStore() {
        this.destroyRootStore();
        this.rootNode = new (0, $jIDNV.RowNode)(this.beans);
        this.rootNode.group = true;
        this.rootNode.level = -1;
        if (this.datasource) {
            this.storeParams = this.createStoreParams();
            this.rootNode.childStore = this.createBean(this.storeFactory.createStore(this.storeParams, this.rootNode));
            this.updateRowIndexesAndBounds();
        }
        if (this.managingPivotResultColumns) {
            this.pivotResultCols?.setPivotResultCols(null, "api");
            this.managingPivotResultColumns = false;
        }
        this.dispatchModelUpdated(true);
    }
    columnsToValueObjects(columns = []) {
        return columns.map((col)=>({
                id: col.getId(),
                aggFunc: col.getAggFunc(),
                displayName: this.colNames.getDisplayNameForColumn(col, "model"),
                field: col.getColDef().field
            }));
    }
    createStoreParams() {
        const rowGroupColumnVos = this.columnsToValueObjects(this.rowGroupColsSvc?.columns);
        const valueColumnVos = this.columnsToValueObjects(this.valueColsSvc?.columns);
        const pivotColumnVos = this.columnsToValueObjects(this.pivotColsSvc?.columns);
        const dynamicRowHeight = (0, $jIDNV._isGetRowHeightFunction)(this.gos);
        const params = {
            // the columns the user has grouped and aggregated by
            valueCols: valueColumnVos,
            rowGroupCols: rowGroupColumnVos,
            pivotCols: pivotColumnVos,
            pivotMode: this.colModel.isPivotMode(),
            // sort and filter model
            filterModel: this.filterManager?.isAdvFilterEnabled() ? this.filterManager?.getAdvFilterModel() : this.filterManager?.getFilterModel() ?? {},
            sortModel: this.sortSvc?.getSortModel() ?? [],
            datasource: this.datasource,
            lastAccessedSequence: {
                value: 0
            },
            dynamicRowHeight: // blockSize: blockSize == null ? 100 : blockSize,
            dynamicRowHeight
        };
        return params;
    }
    getParams() {
        return this.storeParams;
    }
    dispatchModelUpdated(reset = false) {
        this.eventSvc.dispatchEvent({
            type: "modelUpdated",
            animate: !reset,
            keepRenderedRows: !reset,
            newPage: false,
            newData: false
        });
    }
    onStoreUpdated() {
        if (this.pauseStoreUpdateListening) return;
        this.updateRowIndexesAndBounds();
        this.dispatchModelUpdated();
    }
    onRowHeightChanged() {
        this.updateRowIndexesAndBounds();
        this.dispatchModelUpdated();
    }
    updateRowIndexesAndBounds() {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.setDisplayIndexes({
            value: 0
        }, {
            value: 0
        }, 0);
    }
    retryLoads() {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.retryLoads();
        this.onStoreUpdated();
    }
    getRow(index) {
        const rootStore = this.getRootStore();
        if (!rootStore) return void 0;
        return rootStore.getRowUsingDisplayIndex(index);
    }
    /**
   * Pauses the store, to prevent it updating the UI. This is used when doing batch updates to the store.
   */ setPaused(paused) {
        this.pauseStoreUpdateListening = paused;
    }
    expandAll(value) {
        this.pauseStoreUpdateListening = true;
        this.forEachNode((node)=>{
            if (node.stub) return;
            if (node.hasChildren()) node.setExpanded(value);
        });
        this.pauseStoreUpdateListening = false;
        this.onStoreUpdated();
    }
    refreshAfterFilter(newFilterModel, params) {
        if (this.storeParams) this.storeParams.filterModel = newFilterModel;
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.refreshAfterFilter(params);
        this.onStoreUpdated();
    }
    getRootStore() {
        return this.rootNode?.childStore;
    }
    getRowCount() {
        const rootStore = this.getRootStore();
        if (!rootStore) return 0;
        return rootStore.getDisplayIndexEnd();
    }
    getTopLevelRowCount() {
        const rootStore = this.getRootStore();
        if (!rootStore) return 1;
        return rootStore.getRowCount();
    }
    getTopLevelRowDisplayedIndex(topLevelIndex) {
        const rootStore = this.getRootStore();
        if (!rootStore) return topLevelIndex;
        return rootStore.getTopLevelRowDisplayedIndex(topLevelIndex);
    }
    getRowBounds(index) {
        const rootStore = this.getRootStore();
        if (!rootStore) {
            const rowHeight = (0, $jIDNV._getRowHeightAsNumber)(this.beans);
            return {
                rowTop: 0,
                rowHeight: rowHeight
            };
        }
        return rootStore.getRowBounds(index);
    }
    getBlockStates() {
        const root = this.getRootStore();
        if (!root) return void 0;
        const states = {};
        root.forEachStoreDeep((store)=>{
            const blockStates = store.getBlockStates();
            for (const block of Object.keys(blockStates))states[block] = blockStates[block];
        });
        return states;
    }
    getRowIndexAtPixel(pixel) {
        const rootStore = this.getRootStore();
        if (pixel <= 0 || !rootStore) return 0;
        return rootStore.getRowIndexAtPixel(pixel);
    }
    isEmpty() {
        return false;
    }
    isRowsToRender() {
        return this.getRootStore() != null && this.getRowCount() > 0;
    }
    getType() {
        return "serverSide";
    }
    forEachNode(callback) {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.forEachNodeDeep(callback);
    }
    forEachDisplayedNode(callback) {
        const wrappedCallback = (node, index)=>{
            if (node.stub || !node.displayed) return;
            callback(node, index);
        };
        this.forEachNode(wrappedCallback);
    }
    forEachNodeAfterFilterAndSort(callback, includeFooterNodes = false) {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.forEachNodeDeepAfterFilterAndSort(callback, void 0, includeFooterNodes);
    }
    /** @returns false if store hasn't started */ executeOnStore(route, callback) {
        if (!this.started) return false;
        const rootStore = this.getRootStore();
        if (!rootStore) return true;
        const storeToExecuteOn = rootStore.getChildStore(route);
        if (storeToExecuteOn) callback(storeToExecuteOn);
        return true;
    }
    refreshStore(params = {}) {
        const route = params.route ? params.route : [];
        this.executeOnStore(route, (store)=>store.refreshStore(params.purge == true));
    }
    getStoreState() {
        const res = [];
        const rootStore = this.getRootStore();
        if (rootStore) rootStore.addStoreStates(res);
        return res;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        const startIndex = firstInRange.rowIndex;
        const endIndex = lastInRange.rowIndex;
        if (startIndex === null && endIndex === null) return [];
        if (endIndex === null) return firstInRange ? [
            firstInRange
        ] : [];
        if (startIndex === null) return [
            lastInRange
        ];
        const nodeRange = [];
        const [firstIndex, lastIndex] = [
            startIndex,
            endIndex
        ].sort((a, b)=>a - b);
        this.forEachNode((node)=>{
            const thisRowIndex = node.rowIndex;
            if (thisRowIndex == null || node.stub) return;
            if (thisRowIndex >= firstIndex && thisRowIndex <= lastIndex) nodeRange.push(node);
        });
        if (nodeRange.length !== lastIndex - firstIndex + 1) return null;
        return nodeRange;
    }
    getRowNode(id) {
        let result;
        this.forEachNode((rowNode)=>{
            if (rowNode.id === id) result = rowNode;
            if (rowNode.detailNode && rowNode.detailNode.id === id) result = rowNode.detailNode;
        });
        return result;
    }
    isRowPresent(rowNode) {
        const foundRowNode = this.getRowNode(rowNode.id);
        return !!foundRowNode;
    }
    setRowCount(rowCount, lastRowIndexKnown) {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.setRowCount(rowCount, lastRowIndexKnown);
    }
    destroy() {
        this.destroyDatasource();
        this.destroyRootStore();
        super.destroy();
    }
    /**
   * @deprecated v33.1
   */ onRowHeightChangedDebounced() {
        this.onRowHeightChanged_debounced();
    }
};
function $5b7ccabde48fae90$var$getServerSideSelectionState(beans) {
    return beans.selectionSvc?.getSelectionState() ?? null;
}
function $5b7ccabde48fae90$var$setServerSideSelectionState(beans, state) {
    beans.selectionSvc?.setSelectionState(state, "api");
}
function $5b7ccabde48fae90$var$applyServerSideTransaction(beans, transaction) {
    return beans.ssrmTxnManager?.applyTransaction(transaction);
}
function $5b7ccabde48fae90$var$applyServerSideRowData(beans, params) {
    const startRow = params.startRow ?? 0;
    const route = params.route ?? [];
    if (startRow < 0) {
        (0, $jIDNV._warn)(189, {
            startRow: startRow
        });
        return;
    }
    (0, $jIDNV._getServerSideRowModel)(beans)?.applyRowData(params.successParams, startRow, route);
}
function $5b7ccabde48fae90$var$applyServerSideTransactionAsync(beans, transaction, callback) {
    return beans.ssrmTxnManager?.applyTransactionAsync(transaction, callback);
}
function $5b7ccabde48fae90$var$retryServerSideLoads(beans) {
    (0, $jIDNV._getServerSideRowModel)(beans)?.retryLoads();
}
function $5b7ccabde48fae90$var$flushServerSideAsyncTransactions(beans) {
    return beans.ssrmTxnManager?.flushAsyncTransactions();
}
function $5b7ccabde48fae90$var$refreshServerSide(beans, params) {
    (0, $jIDNV._getServerSideRowModel)(beans)?.refreshStore(params);
}
function $5b7ccabde48fae90$var$getServerSideGroupLevelState(beans) {
    return (0, $jIDNV._getServerSideRowModel)(beans)?.getStoreState() ?? [];
}
// packages/ag-grid-enterprise/src/serverSideRowModel/services/serverSideExpansionService.ts
var $5b7ccabde48fae90$var$ServerSideExpansionService = class extends $5b7ccabde48fae90$var$BaseExpansionService {
    constructor(){
        super(...arguments);
        this.beanName = "expansionSvc";
        this.queuedRowIds = /* @__PURE__ */ new Set();
    }
    wireBeans(beans) {
        this.serverSideRowModel = beans.rowModel;
    }
    postConstruct() {
        this.addManagedEventListeners({
            columnRowGroupChanged: ()=>{
                this.queuedRowIds.clear();
            }
        });
    }
    checkOpenByDefault(rowNode) {
        if (!rowNode.isExpandable()) return;
        if (this.queuedRowIds.has(rowNode.id)) {
            this.queuedRowIds.delete(rowNode.id);
            rowNode.setExpanded(true);
            return;
        }
        const userFunc = this.gos.getCallback("isServerSideGroupOpenByDefault");
        if (!userFunc) return;
        const params = {
            data: rowNode.data,
            rowNode: rowNode
        };
        const userFuncRes = userFunc(params);
        if (userFuncRes) rowNode.setExpanded(true);
    }
    expandRows(rowIdsToExpand, rowIdsToCollapse) {
        const { serverSideRowModel: serverSideRowModel, queuedRowIds: queuedRowIds } = this;
        const processNodes = (rowIds, expanded)=>{
            for (const rowId of rowIds){
                const rowNode = serverSideRowModel.getRowNode(rowId);
                if (rowNode) rowNode.setExpanded(expanded);
                else if (expanded) queuedRowIds.add(rowId);
                else queuedRowIds.delete(rowId);
            }
        };
        processNodes(rowIdsToExpand, true);
        if (!rowIdsToCollapse) return;
        processNodes(rowIdsToCollapse, false);
    }
    expandAll(value) {
        this.serverSideRowModel.expandAll(value);
        this.beans.eventSvc.dispatchEvent({
            type: "expandOrCollapseAll",
            source: value ? "expandAll" : "collapseAll"
        });
    }
    onGroupExpandedOrCollapsed() {}
    dispatchExpandedEvent(event) {
        this.eventSvc.dispatchEvent(event);
        this.beans.rowRenderer.refreshCells({
            rowNodes: [
                event.node
            ]
        });
    }
};
var $5b7ccabde48fae90$var$DefaultStrategy = class extends (0, $jIDNV.BeanStub) {
    constructor(selectionCtx){
        super();
        this.selectionCtx = selectionCtx;
        this.selectedState = {
            selectAll: false,
            toggledNodes: /* @__PURE__ */ new Set()
        };
        /**
     * Whether select-all functionality has ever been used. Used only to print warnings in `getSelectedNodes` for users.
     * We print a warning even if not currently selecting all because we want users to be aware of the potential
     * for unexpected behaviour when these two features are used together.
     */ this.selectAllUsed = false;
        /** This is to prevent regressions, default selectionSvc retains reference of selected nodes. */ this.selectedNodes = {};
    }
    getSelectedState() {
        return {
            selectAll: this.selectedState.selectAll,
            toggledNodes: [
                ...this.selectedState.toggledNodes
            ]
        };
    }
    setSelectedState(state) {
        if (typeof state !== "object") {
            (0, $jIDNV._error)(116);
            return;
        }
        if (!("selectAll" in state)) {
            (0, $jIDNV._error)(116);
            return;
        }
        if (typeof state.selectAll !== "boolean") {
            (0, $jIDNV._error)(117);
            return;
        }
        if (!("toggledNodes" in state) || !Array.isArray(state.toggledNodes)) return (0, $jIDNV._warn)(197);
        const newState = {
            selectAll: state.selectAll,
            toggledNodes: /* @__PURE__ */ new Set()
        };
        state.toggledNodes.forEach((key)=>{
            if (typeof key === "string") newState.toggledNodes.add(key);
            else (0, $jIDNV._warn)(196, {
                key: key
            });
        });
        const isSelectingMultipleRows = newState.selectAll || newState.toggledNodes.size > 1;
        if ((0, $jIDNV._isUsingNewRowSelectionAPI)(this.gos) && !(0, $jIDNV._isMultiRowSelection)(this.gos) && isSelectingMultipleRows) {
            (0, $jIDNV._warn)(130);
            return;
        }
        this.selectedState = newState;
    }
    deleteSelectionStateFromParent(parentPath, removedNodeIds) {
        if (this.selectedState.toggledNodes.size === 0) return false;
        let anyNodesToggled = false;
        removedNodeIds.forEach((id)=>{
            if (this.selectedState.toggledNodes.delete(id)) anyNodesToggled = true;
        });
        return anyNodesToggled;
    }
    setNodesSelected(params) {
        const { nodes: nodes, clearSelection: clearSelection, newValue: newValue, source: source } = params;
        if (nodes.length === 0) return 0;
        const onlyThisNode = clearSelection && newValue;
        if (!(0, $jIDNV._isMultiRowSelection)(this.gos) || onlyThisNode) {
            if (nodes.length > 1) {
                (0, $jIDNV._error)(130);
                return 0;
            }
            const rowNode = nodes[0];
            const node = rowNode.footer ? rowNode.sibling : rowNode;
            if (newValue && node.selectable) {
                this.selectedNodes = {
                    [node.id]: node
                };
                this.selectedState = {
                    selectAll: false,
                    toggledNodes: /* @__PURE__ */ new Set([
                        node.id
                    ])
                };
            } else {
                this.selectedNodes = {};
                this.selectedState = {
                    selectAll: false,
                    toggledNodes: /* @__PURE__ */ new Set()
                };
            }
            return 1;
        }
        const updateNodeState = (rowNode, value = newValue)=>{
            const node = rowNode.footer ? rowNode.sibling : rowNode;
            if (value && node.selectable) this.selectedNodes[node.id] = node;
            else delete this.selectedNodes[node.id];
            const doesNodeConform = value === this.selectedState.selectAll;
            if (doesNodeConform || !node.selectable) this.selectedState.toggledNodes.delete(node.id);
            else this.selectedState.toggledNodes.add(node.id);
        };
        nodes.forEach((node)=>updateNodeState(node));
        if (nodes.length === 1 && source === "api") this.selectionCtx.setRoot(nodes[0].footer ? nodes[0].sibling : nodes[0]);
        return 1;
    }
    processNewRow(node) {
        if (this.selectedNodes[node.id]) this.selectedNodes[node.id] = node;
    }
    isNodeSelected(node) {
        const isToggled = this.selectedState.toggledNodes.has(node.id);
        return this.selectedState.selectAll ? !isToggled : isToggled;
    }
    getSelectedNodes(nullWhenSelectAll = false, warnWhenSelectAll = true) {
        const { selectedState: { selectAll: selectAll }, selectedNodes: selectedNodes, selectAllUsed: selectAllUsed } = this;
        if (warnWhenSelectAll && selectAllUsed) (0, $jIDNV._warn)(199);
        return nullWhenSelectAll && selectAll ? null : Object.values(selectedNodes);
    }
    getSelectedRows() {
        return (this.getSelectedNodes() ?? []).map((node)=>node.data);
    }
    getSelectionCount() {
        if (this.selectedState.selectAll) return -1;
        return this.selectedState.toggledNodes.size;
    }
    isEmpty() {
        return !this.selectedState.selectAll && !this.selectedState.toggledNodes?.size;
    }
    selectAllRowNodes() {
        this.reset(true);
    }
    deselectAllRowNodes() {
        this.reset(false);
    }
    reset(selectAll) {
        this.selectedState = {
            selectAll: selectAll,
            toggledNodes: /* @__PURE__ */ new Set()
        };
        this.selectedNodes = {};
        this.selectAllUsed || (this.selectAllUsed = selectAll);
    }
    getSelectAllState() {
        if (this.selectedState.selectAll) {
            if (this.selectedState.toggledNodes.size > 0) return null;
            return true;
        }
        if (this.selectedState.toggledNodes.size > 0) return null;
        return false;
    }
};
var $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy = class extends (0, $jIDNV.BeanStub) {
    constructor(selectionCtx){
        super();
        this.selectionCtx = selectionCtx;
        this.selectedState = {
            selectAllChildren: false,
            toggledNodes: /* @__PURE__ */ new Map()
        };
    }
    wireBeans(beans) {
        this.rowModel = beans.rowModel;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
        this.filterManager = beans.filterManager;
        this.selectionSvc = beans.selectionSvc;
    }
    postConstruct() {
        this.addManagedEventListeners({
            // if model has updated, a store may now be fully loaded to clean up indeterminate states
            modelUpdated: ()=>this.removeRedundantState(),
            // when the grouping changes, the state no longer makes sense, so reset the state.
            columnRowGroupChanged: ()=>this.selectionSvc.reset("rowGroupChanged")
        });
    }
    getSelectedState() {
        const { gos: gos, rowGroupColsSvc: rowGroupColsSvc, selectedState: selectedState } = this;
        const treeData = gos.get("treeData");
        const recursivelySerializeState = (state, level, nodeId)=>{
            const normalisedState = {
                nodeId: nodeId
            };
            if (treeData || rowGroupColsSvc && level <= rowGroupColsSvc.columns.length) normalisedState.selectAllChildren = state.selectAllChildren;
            if (state.toggledNodes.size) {
                const toggledNodes = [];
                state.toggledNodes.forEach((value, key)=>{
                    const newState = recursivelySerializeState(value, level + 1, key);
                    toggledNodes.push(newState);
                });
                normalisedState.toggledNodes = toggledNodes;
            }
            return normalisedState;
        };
        return recursivelySerializeState(selectedState, 0);
    }
    setSelectedState(state) {
        if ("selectAll" in state) {
            (0, $jIDNV._error)(111);
            return;
        }
        const recursivelyDeserializeState = (normalisedState, parentSelected)=>{
            if (typeof normalisedState !== "object") {
                (0, $jIDNV._error)(243);
                throw new Error();
            }
            if ("selectAllChildren" in normalisedState && typeof normalisedState.selectAllChildren !== "boolean") {
                (0, $jIDNV._error)(244);
                throw new Error();
            }
            if ("toggledNodes" in normalisedState) {
                if (!Array.isArray(normalisedState.toggledNodes)) {
                    (0, $jIDNV._error)(245);
                    throw new Error();
                }
                const allHaveIds = normalisedState.toggledNodes.every((innerState)=>typeof innerState === "object" && "nodeId" in innerState && typeof innerState.nodeId === "string");
                if (!allHaveIds) {
                    (0, $jIDNV._error)(246);
                    throw new Error();
                }
            }
            const isThisNodeSelected = normalisedState.selectAllChildren ?? !parentSelected;
            const convertedChildren = normalisedState.toggledNodes?.map((innerState)=>[
                    innerState.nodeId,
                    recursivelyDeserializeState(innerState, isThisNodeSelected)
                ]);
            const doesRedundantStateExist = convertedChildren?.some(([, innerState])=>isThisNodeSelected === innerState.selectAllChildren && innerState.toggledNodes.size === 0);
            if (doesRedundantStateExist) {
                (0, $jIDNV._error)(247);
                throw new Error();
            }
            return {
                selectAllChildren: isThisNodeSelected,
                toggledNodes: new Map(convertedChildren)
            };
        };
        try {
            this.selectedState = recursivelyDeserializeState(state, !!state.selectAllChildren);
        } catch (e) {}
    }
    deleteSelectionStateFromParent(parentRoute, removedNodeIds) {
        let parentState = this.selectedState;
        const remainingRoute = [
            ...parentRoute
        ];
        while(parentState && remainingRoute.length)parentState = parentState.toggledNodes.get(remainingRoute.pop());
        if (!parentState) return false;
        let anyStateChanged = false;
        removedNodeIds.forEach((id)=>{
            if (parentState?.toggledNodes.delete(id)) anyStateChanged = true;
        });
        if (anyStateChanged) this.removeRedundantState();
        return anyStateChanged;
    }
    setNodesSelected({ nodes: nodes, newValue: newValue, clearSelection: clearSelection, source: source }) {
        if (nodes.length === 0) return 0;
        const onlyThisNode = clearSelection && newValue;
        if (!(0, $jIDNV._isMultiRowSelection)(this.gos) || onlyThisNode) {
            if (nodes.length > 1) {
                (0, $jIDNV._error)(130);
                return 0;
            }
            this.deselectAllRowNodes();
        }
        nodes.forEach((rowNode)=>{
            const node = rowNode.footer ? rowNode.sibling : rowNode;
            const idPathToNode = this.getRouteToNode(node);
            this.recursivelySelectNode(idPathToNode, this.selectedState, newValue);
        });
        this.removeRedundantState();
        if (nodes.length === 1 && source === "api") this.selectionCtx.setRoot(nodes[0].footer ? nodes[0].sibling : nodes[0]);
        return 1;
    }
    isNodeSelected(node) {
        const path = this.getRouteToNode(node);
        return this.isNodePathSelected(path, this.selectedState);
    }
    isNodePathSelected([nextNode, ...nodes], state) {
        if (nodes.length === 0) {
            const isToggled = state.toggledNodes.has(nextNode.id);
            if (nextNode.hasChildren()) {
                const groupState = state.toggledNodes.get(nextNode.id);
                if (groupState && groupState.toggledNodes.size) return void 0;
            }
            return state.selectAllChildren ? !isToggled : isToggled;
        }
        if (state.toggledNodes.has(nextNode.id)) {
            const nextState = state.toggledNodes.get(nextNode.id);
            if (nextState) return this.isNodePathSelected(nodes, nextState);
        }
        return state.selectAllChildren;
    }
    getRouteToNode(node) {
        const pathToNode = [];
        let tempNode = node;
        while(tempNode.parent){
            pathToNode.push(tempNode);
            tempNode = tempNode.parent;
        }
        return pathToNode.reverse();
    }
    removeRedundantState() {
        if (this.filterManager?.isAnyFilterPresent()) return;
        const forEachNodeStateDepthFirst = (state = this.selectedState, thisKey, parentState)=>{
            state.toggledNodes.forEach((value, key)=>{
                forEachNodeStateDepthFirst(value, key, state);
            });
            if (thisKey) {
                const thisRow = this.rowModel.getRowNode(thisKey);
                const thisRowStore = thisRow?.childStore;
                const isStoreSizeKnown = thisRowStore?.isLastRowIndexKnown();
                if (isStoreSizeKnown) {
                    const possibleAllNodesToggled = state.toggledNodes.size >= thisRowStore.getRowCount();
                    if (possibleAllNodesToggled) {
                        for (const childState of state.toggledNodes.entries()){
                            const [key, value] = childState;
                            if (value.toggledNodes.size > 0) return;
                            const rowDoesNotExist = !this.rowModel.getRowNode(key);
                            if (rowDoesNotExist) return;
                        }
                        state.selectAllChildren = !state.selectAllChildren;
                        state.toggledNodes.clear();
                    }
                }
            }
            const hasNoToggledRows = state.toggledNodes.size === 0;
            const isIdenticalToParent = parentState?.selectAllChildren === state.selectAllChildren;
            if (hasNoToggledRows && isIdenticalToParent) parentState?.toggledNodes.delete(thisKey);
        };
        forEachNodeStateDepthFirst();
    }
    recursivelySelectNode([nextNode, ...nodes], selectedState, newValue) {
        if (!nextNode) return;
        const isLastNode = !nodes.length;
        if (isLastNode) {
            const isNodeSelectable = nextNode.selectable;
            const doesNodeConform = selectedState.selectAllChildren === newValue;
            if (doesNodeConform || !isNodeSelectable) {
                selectedState.toggledNodes.delete(nextNode.id);
                return;
            }
            const newState = {
                selectAllChildren: newValue,
                toggledNodes: /* @__PURE__ */ new Map()
            };
            selectedState.toggledNodes.set(nextNode.id, newState);
            return;
        }
        const doesStateAlreadyExist = selectedState.toggledNodes.has(nextNode.id);
        const childState = selectedState.toggledNodes.get(nextNode.id) ?? {
            selectAllChildren: selectedState.selectAllChildren,
            toggledNodes: /* @__PURE__ */ new Map()
        };
        if (!doesStateAlreadyExist) selectedState.toggledNodes.set(nextNode.id, childState);
        this.recursivelySelectNode(nodes, childState, newValue);
        if (selectedState.selectAllChildren === childState.selectAllChildren && childState.toggledNodes.size === 0) selectedState.toggledNodes.delete(nextNode.id);
    }
    getSelectedNodes(nullWhenSelectAll = false) {
        (0, $jIDNV._warn)(202);
        if (this.selectedState.selectAllChildren && nullWhenSelectAll) return null;
        const selectedNodes = [];
        this.rowModel.forEachNode((node)=>{
            if (node.isSelected()) selectedNodes.push(node);
        });
        return selectedNodes;
    }
    processNewRow() {}
    getSelectedRows() {
        return this.getSelectedNodes()?.map((node)=>node.data) ?? [];
    }
    getSelectionCount() {
        return -1;
    }
    isEmpty() {
        return !this.selectedState.selectAllChildren && !this.selectedState.toggledNodes?.size;
    }
    selectAllRowNodes() {
        this.reset(true);
    }
    deselectAllRowNodes() {
        this.reset(false);
    }
    reset(selectAllChildren2) {
        this.selectedState = {
            selectAllChildren: selectAllChildren2,
            toggledNodes: /* @__PURE__ */ new Map()
        };
    }
    getSelectAllState() {
        if (this.selectedState.selectAllChildren) {
            if (this.selectedState.toggledNodes.size > 0) return null;
            return true;
        }
        if (this.selectedState.toggledNodes.size > 0) return null;
        return false;
    }
};
// packages/ag-grid-enterprise/src/serverSideRowModel/services/serverSideSelectionService.ts
var $5b7ccabde48fae90$var$ServerSideSelectionService = class extends (0, $jIDNV.BaseSelectionService) {
    constructor(){
        super(...arguments);
        this.beanName = "selectionSvc";
    }
    postConstruct() {
        super.postConstruct();
        this.addManagedPropertyListeners([
            "groupSelectsChildren",
            "rowSelection"
        ], ()=>{
            const groupSelectsChildren2 = (0, $jIDNV._getGroupSelectsDescendants)(this.gos);
            const Strategy2 = groupSelectsChildren2 && this.selectionStrategy instanceof $5b7ccabde48fae90$var$DefaultStrategy ? $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy : !groupSelectsChildren2 && this.selectionStrategy instanceof $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy ? $5b7ccabde48fae90$var$DefaultStrategy : void 0;
            if (Strategy2) {
                this.destroyBean(this.selectionStrategy);
                this.selectionStrategy = this.createManagedBean(new Strategy2(this.selectionCtx));
                this.shotgunResetNodeSelectionState();
                this.dispatchSelectionChanged("api");
            }
        });
        this.addManagedPropertyListeners([
            "rowSelection"
        ], ()=>{
            const rowSelection = (0, $jIDNV._getRowSelectionMode)(this.gos);
            if (rowSelection !== this.selectionMode) {
                this.selectionMode = rowSelection;
                this.deselectAllRowNodes({
                    source: "api"
                });
            }
        });
        this.selectionMode = (0, $jIDNV._getRowSelectionMode)(this.gos);
        const groupSelectsChildren = (0, $jIDNV._getGroupSelectsDescendants)(this.gos);
        const Strategy = !groupSelectsChildren ? $5b7ccabde48fae90$var$DefaultStrategy : $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy;
        this.selectionStrategy = this.createManagedBean(new Strategy(this.selectionCtx));
    }
    handleSelectionEvent(event, rowNode, source) {
        if (this.isRowSelectionBlocked(rowNode)) return 0;
        let updatedRows = 0;
        const selection = this.inferNodeSelections(rowNode, event.shiftKey, event.metaKey || event.ctrlKey, source);
        if (selection == null) return 0;
        this.selectionCtx.selectAll = false;
        if ("select" in selection) {
            if (selection.reset) this.selectionStrategy.deselectAllRowNodes({
                source: "api"
            });
            else this.selectionStrategy.setNodesSelected({
                nodes: selection.deselect,
                newValue: false,
                source: source
            });
            updatedRows = this.selectionStrategy.setNodesSelected({
                nodes: selection.select,
                newValue: true,
                source: source
            });
        } else updatedRows = this.selectionStrategy.setNodesSelected({
            nodes: [
                selection.node
            ],
            newValue: selection.newValue,
            clearSelection: selection.clearSelection,
            event: event,
            source: source
        });
        this.shotgunResetNodeSelectionState(source);
        this.dispatchSelectionChanged(source);
        return updatedRows;
    }
    getSelectionState() {
        return this.selectionStrategy.getSelectedState();
    }
    setSelectionState(state, source) {
        if (!(0, $jIDNV._isRowSelection)(this.gos)) {
            if (state) (0, $jIDNV._warn)(132);
            return;
        }
        if (Array.isArray(state)) return;
        if (state) {
            this.selectionStrategy.setSelectedState(state);
            this.shotgunResetNodeSelectionState();
            this.dispatchSelectionChanged(source);
        } else this.deselectAllRowNodes({
            source: source
        });
    }
    setNodesSelected(params) {
        if (!(0, $jIDNV._isRowSelection)(this.gos) && params.newValue) {
            (0, $jIDNV._warn)(132);
            return 0;
        }
        const { nodes: nodes, ...otherParams } = params;
        if (nodes.length > 1 && this.selectionMode !== "multiRow") {
            (0, $jIDNV._warn)(130);
            return 0;
        }
        const adjustedParams = {
            nodes: nodes.filter((node)=>node.selectable),
            ...otherParams
        };
        if (!adjustedParams.nodes.length) return 0;
        const changedNodes = this.selectionStrategy.setNodesSelected(adjustedParams);
        this.shotgunResetNodeSelectionState(adjustedParams.source);
        this.dispatchSelectionChanged(adjustedParams.source);
        return changedNodes;
    }
    /**
   * Deletes the selection state for a set of nodes, for use after deleting nodes via
   * transaction. As this is designed for transactions, all nodes should belong to the same group.
   */ deleteSelectionStateFromParent(storeRoute, removedNodeIds) {
        const stateChanged = this.selectionStrategy.deleteSelectionStateFromParent(storeRoute, removedNodeIds);
        if (!stateChanged) return;
        this.shotgunResetNodeSelectionState();
        this.dispatchSelectionChanged("api");
    }
    shotgunResetNodeSelectionState(source) {
        this.beans.rowModel.forEachNode((node)=>{
            if (node.stub) return;
            const isNodeSelected = this.selectionStrategy.isNodeSelected(node);
            if (isNodeSelected !== node.isSelected()) this.selectRowNode(node, isNodeSelected, void 0, source);
        });
    }
    getSelectedNodes() {
        return this.selectionStrategy.getSelectedNodes() ?? [];
    }
    getSelectedRows() {
        return this.selectionStrategy.getSelectedRows();
    }
    getSelectionCount() {
        return this.selectionStrategy.getSelectionCount();
    }
    syncInRowNode(rowNode) {
        this.selectionStrategy.processNewRow(rowNode);
        const isNodeSelected = this.selectionStrategy.isNodeSelected(rowNode);
        if (isNodeSelected != false && !rowNode.selectable) {
            this.selectionStrategy.setNodesSelected({
                nodes: [
                    rowNode
                ],
                newValue: false,
                source: "api"
            });
            this.shotgunResetNodeSelectionState();
            this.dispatchSelectionChanged("api");
            return;
        }
        rowNode.__selected = isNodeSelected;
    }
    reset() {
        this.selectionStrategy.deselectAllRowNodes({
            source: "api"
        });
        this.selectionCtx.reset();
    }
    isEmpty() {
        return this.selectionStrategy.isEmpty();
    }
    hasNodesToSelect() {
        return true;
    }
    selectAllRowNodes(params) {
        if (!(0, $jIDNV._isRowSelection)(this.gos)) {
            (0, $jIDNV._warn)(132);
            return;
        }
        $5b7ccabde48fae90$var$validateSelectionParameters(params);
        if ((0, $jIDNV._isUsingNewRowSelectionAPI)(this.gos) && !(0, $jIDNV._isMultiRowSelection)(this.gos)) return (0, $jIDNV._warn)(130);
        this.selectionStrategy.selectAllRowNodes(params);
        this.selectionCtx.selectAll = true;
        this.beans.rowModel.forEachNode((node)=>{
            if (node.stub) return;
            this.selectRowNode(node, true, void 0, params.source);
        });
        this.dispatchSelectionChanged(params.source);
    }
    deselectAllRowNodes(params) {
        $5b7ccabde48fae90$var$validateSelectionParameters(params);
        this.selectionStrategy.deselectAllRowNodes(params);
        this.selectionCtx.selectAll = false;
        this.beans.rowModel.forEachNode((node)=>{
            if (node.stub) return;
            this.selectRowNode(node, false, void 0, params.source);
        });
        this.dispatchSelectionChanged(params.source);
    }
    getSelectAllState(selectAll) {
        return this.selectionStrategy.getSelectAllState(selectAll);
    }
    // used by CSRM
    getBestCostNodeSelection() {
        return (0, $jIDNV._warn)(194, {
            method: "getBestCostNodeSelection"
        });
    }
    /**
   * Updates the selectable state for a node by invoking isRowSelectable callback.
   * If the node is not selectable, it will be deselected.
   *
   * Callers:
   *  - property isRowSelectable changed
   *  - after grouping / treeData
   */ updateSelectable() {
        if (!(0, $jIDNV._isRowSelection)(this.gos)) return;
        const nodesToDeselect = [];
        this.beans.rowModel.forEachNode((node)=>{
            const rowSelectable = this.updateRowSelectable(node, true);
            if (!rowSelectable && node.isSelected()) nodesToDeselect.push(node);
        });
        if (nodesToDeselect.length) this.setNodesSelected({
            nodes: nodesToDeselect,
            newValue: false,
            source: "selectableChanged"
        });
    }
    dispatchSelectionChanged(source) {
        this.eventSvc.dispatchEvent({
            type: "selectionChanged",
            source: source,
            selectedNodes: this.selectionStrategy instanceof $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy ? null : this.selectionStrategy.getSelectedNodes(true, false),
            serverSideState: this.getSelectionState()
        });
    }
    updateSelectableAfterGrouping() {
        return (0, $jIDNV._error)(194, {
            method: "updateSelectableAfterGrouping"
        });
    }
    refreshMasterNodeState() {}
    setDetailSelectionState() {
        return;
    }
};
function $5b7ccabde48fae90$var$validateSelectionParameters({ selectAll: selectAll }) {
    if (selectAll === "filtered" || selectAll === "currentPage") (0, $jIDNV._warn)(195, {
        justCurrentPage: selectAll === "currentPage"
    });
}
var $5b7ccabde48fae90$var$SsrmRowChildrenService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "rowChildrenSvc";
    }
    getHasChildrenValue(rowNode) {
        const isTreeData = this.gos.get("treeData");
        const isGroupFunc = this.gos.get("isServerSideGroup");
        return !rowNode.stub && !rowNode.footer && (isTreeData ? !!isGroupFunc && isGroupFunc(rowNode.data) : !!rowNode.group);
    }
};
var $5b7ccabde48fae90$var$LazyBlockLoadingService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "lazyBlockLoadingSvc";
        this.outboundRequests = 0;
        // a map of caches to loading nodes
        this.cacheLoadingNodesMap = /* @__PURE__ */ new Map();
        // if a check is queued to happen this cycle
        this.isCheckQueued = false;
        // this is cached for blockLoadDebounce
        this.nextBlockToLoad = void 0;
    }
    wireBeans(beans) {
        this.rowRenderer = beans.rowRenderer;
        this.rowModel = beans.rowModel;
    }
    postConstruct() {
        this.maxOutboundRequests = (0, $jIDNV._getMaxConcurrentDatasourceRequests)(this.gos);
    }
    subscribe(cache) {
        this.cacheLoadingNodesMap.set(cache, /* @__PURE__ */ new Set());
    }
    unsubscribe(cache) {
        this.cacheLoadingNodesMap.delete(cache);
    }
    /**
   * Queues a microtask to check if any blocks need to be loaded.
   */ queueLoadCheck() {
        if (this.isCheckQueued) return;
        this.isCheckQueued = true;
        setTimeout(()=>{
            this.queueLoadAction();
            this.isCheckQueued = false;
        });
    }
    onLoadComplete() {
        this.outboundRequests -= 1;
        this.queueLoadCheck();
    }
    hasAvailableLoadBandwidth() {
        if (this.maxOutboundRequests === void 0) return true;
        return this.outboundRequests < this.maxOutboundRequests;
    }
    queueLoadAction() {
        const nextBlockToLoad = this.getBlockToLoad();
        if (!nextBlockToLoad) return;
        const isSameBlock = this.nextBlockToLoad && this.nextBlockToLoad.cache === nextBlockToLoad.cache && this.nextBlockToLoad.index === nextBlockToLoad.index;
        if (isSameBlock) return;
        if (!this.nextBlockToLoad || !isSameBlock) {
            this.nextBlockToLoad = nextBlockToLoad;
            window.clearTimeout(this.loaderTimeout);
            const startRow = Number(this.nextBlockToLoad.index);
            const cache = this.nextBlockToLoad.cache;
            const endRow = nextBlockToLoad.index + nextBlockToLoad.cache.getBlockSize();
            this.loaderTimeout = window.setTimeout(()=>{
                if (!cache.isAlive()) return;
                this.loaderTimeout = void 0;
                this.attemptLoad(cache, startRow, endRow);
                this.nextBlockToLoad = void 0;
            }, this.gos.get("blockLoadDebounceMillis"));
        }
    }
    attemptLoad(cache, start, end) {
        const hasBandwidth = this.hasAvailableLoadBandwidth();
        if (!hasBandwidth) return;
        this.executeLoad(cache, start, end);
        this.queueLoadCheck();
    }
    executeLoad(cache, startRow, endRow) {
        const ssrmParams = cache.getSsrmParams();
        const request = {
            startRow: startRow,
            endRow: endRow,
            rowGroupCols: ssrmParams.rowGroupCols,
            valueCols: ssrmParams.valueCols,
            pivotCols: ssrmParams.pivotCols,
            pivotMode: ssrmParams.pivotMode,
            groupKeys: cache.store.getParentNode().getRoute() ?? [],
            filterModel: ssrmParams.filterModel,
            sortModel: ssrmParams.sortModel
        };
        const loadingNodes = this.cacheLoadingNodesMap.get(cache);
        const removeNodesFromLoadingMap = ()=>{
            for(let i = 0; i < endRow - startRow; i++)loadingNodes.delete(startRow + i);
        };
        const addNodesToLoadingMap = ()=>{
            for(let i = 0; i < endRow - startRow; i++)loadingNodes.add(startRow + i);
        };
        const success = (params2)=>{
            this.onLoadComplete();
            cache.onLoadSuccess(startRow, endRow - startRow, params2);
            removeNodesFromLoadingMap();
        };
        const fail = ()=>{
            this.onLoadComplete();
            cache.onLoadFailed(startRow, endRow - startRow);
            removeNodesFromLoadingMap();
        };
        const params = (0, $jIDNV._addGridCommonParams)(this.gos, {
            request: request,
            success: success,
            fail: fail,
            parentNode: cache.store.getParentNode()
        });
        addNodesToLoadingMap();
        this.outboundRequests += 1;
        cache.getSsrmParams().datasource?.getRows(params);
    }
    getBlockToLoad() {
        const firstRowInViewport = this.rowRenderer.firstRenderedRow;
        const lastRowInViewport = this.rowRenderer.lastRenderedRow;
        for(let i = firstRowInViewport; i <= lastRowInViewport; i++){
            const row = this.rowModel.getRow(i);
            if (!row) continue;
            const store = row.parent?.childStore;
            if (!store) continue;
            const cache = store.getCache();
            const lazyNode = cache.getNodes().getBy("node", row);
            if (!lazyNode) continue;
            const loadingNodes = this.cacheLoadingNodesMap.get(cache);
            if (loadingNodes?.has(lazyNode.index)) continue;
            if (row.__needsRefreshWhenVisible || row.stub && !row.failedLoad) return {
                cache: cache,
                index: cache.getBlockStartIndex(lazyNode.index)
            };
        }
        let cacheToRefresh = null;
        let nodeToRefresh = null;
        let nodeToRefreshDist = Number.MAX_SAFE_INTEGER;
        for (const cache of this.cacheLoadingNodesMap.keys()){
            const nodesToRefresh = cache.getNodesToRefresh();
            nodesToRefresh.forEach((node)=>{
                if (node.rowIndex == null) {
                    nodeToRefresh = node;
                    cacheToRefresh = cache;
                    return;
                }
                const lazyNode = cache.getNodes().getBy("node", node);
                if (!lazyNode) return;
                const loadingNodes = this.cacheLoadingNodesMap.get(cache);
                if (loadingNodes?.has(lazyNode.index)) return;
                const distToViewportTop = Math.abs(firstRowInViewport - node.rowIndex);
                const distToViewportBottom = Math.abs(node.rowIndex - lastRowInViewport);
                if (distToViewportTop < nodeToRefreshDist) {
                    nodeToRefresh = node;
                    nodeToRefreshDist = distToViewportTop;
                    cacheToRefresh = cache;
                }
                if (distToViewportBottom < nodeToRefreshDist) {
                    nodeToRefresh = node;
                    nodeToRefreshDist = distToViewportBottom;
                    cacheToRefresh = cache;
                }
            });
        }
        if (!cacheToRefresh) return void 0;
        const lazyCache = cacheToRefresh;
        const lazyIndex = lazyCache.getNodes().getBy("node", nodeToRefresh)?.index;
        return lazyIndex == null ? void 0 : {
            cache: lazyCache,
            index: lazyCache.getBlockStartIndex(lazyIndex)
        };
    }
    isRowLoading(cache, index) {
        return this.cacheLoadingNodesMap.get(cache)?.has(index) ?? false;
    }
};
// packages/ag-grid-enterprise/src/serverSideRowModel/stores/lazy/multiIndexMap.ts
var $5b7ccabde48fae90$var$MultiIndexMap = class {
    constructor(...indexes){
        this.indexes = indexes;
        this.maps = new Map(this.indexes.map((index)=>[
                index,
                /* @__PURE__ */ new Map()
            ]));
    }
    getSize() {
        return this.maps.get(this.indexes[0]).size;
    }
    getBy(index, key) {
        const map = this.maps.get(index);
        return map.get(key);
    }
    set(item) {
        this.indexes.forEach((index)=>{
            const map = this.maps.get(index);
            map.set(item[index], item);
        });
    }
    delete(item) {
        this.indexes.forEach((index)=>{
            const map = this.maps.get(index);
            map.delete(item[index]);
        });
    }
    clear() {
        this.maps.forEach((map)=>map.clear());
    }
    getIterator(index) {
        const map = this.maps.get(index);
        return map.values();
    }
    forEach(callback) {
        const iterator = this.getIterator(this.indexes[0]);
        let pointer;
        while(pointer = iterator.next()){
            if (pointer.done) break;
            callback(pointer.value);
        }
    }
    find(callback) {
        const iterator = this.getIterator(this.indexes[0]);
        let pointer;
        while(pointer = iterator.next()){
            if (pointer.done) break;
            if (callback(pointer.value)) return pointer.value;
        }
    }
    filter(predicate) {
        const iterator = this.getIterator(this.indexes[0]);
        let pointer;
        const result = [];
        while(pointer = iterator.next()){
            if (pointer.done) break;
            if (predicate(pointer.value)) result.push(pointer.value);
        }
        return result;
    }
};
// packages/ag-grid-enterprise/src/serverSideRowModel/stores/lazy/lazyCache.ts
var $5b7ccabde48fae90$var$DEFAULT_BLOCK_SIZE = 100;
var $5b7ccabde48fae90$var$LazyCache = class extends (0, $jIDNV.BeanStub) {
    constructor(store, numberOfRows, isLastRowKnown, storeParams){
        super();
        /**
     * Indicates whether this is still the live dataset for this store (used for ignoring old requests after purge)
     */ this.live = true;
        /**
     * A cache of removed group nodes, this is retained for preserving group
     * state when the node moves in and out of the cache. Generally caused by
     * rows moving blocks.
     */ this.removedNodeCache = /* @__PURE__ */ new Map();
        this.store = store;
        this.numberOfRows = numberOfRows;
        this.isLastRowKnown = isLastRowKnown;
        this.storeParams = storeParams;
    }
    wireBeans(beans) {
        this.rowRenderer = beans.rowRenderer;
        this.blockUtils = beans.ssrmBlockUtils;
        this.focusSvc = beans.focusSvc;
        this.nodeManager = beans.ssrmNodeManager;
        this.serverSideRowModel = beans.rowModel;
        this.rowNodeSorter = beans.rowNodeSorter;
        this.sortSvc = beans.sortSvc;
        this.lazyBlockLoadingSvc = beans.lazyBlockLoadingSvc;
        this.colModel = beans.colModel;
    }
    postConstruct() {
        this.lazyBlockLoadingSvc.subscribe(this);
        this.nodeMap = new $5b7ccabde48fae90$var$MultiIndexMap("index", "id", "node");
        this.nodeDisplayIndexMap = /* @__PURE__ */ new Map();
        this.nodesToRefresh = /* @__PURE__ */ new Set();
        this.defaultNodeIdPrefix = this.blockUtils.createNodeIdPrefix(this.store.getParentNode());
        this.getRowIdFunc = (0, $jIDNV._getRowIdCallback)(this.gos);
        this.isMasterDetail = this.gos.get("masterDetail");
    }
    destroy() {
        this.lazyBlockLoadingSvc.unsubscribe(this);
        this.numberOfRows = 0;
        this.nodeMap.forEach((node)=>this.blockUtils.destroyRowNode(node.node));
        this.nodeMap.clear();
        this.nodeDisplayIndexMap.clear();
        this.nodesToRefresh.clear();
        this.live = false;
        super.destroy();
    }
    /**
   * Get the row node for a specific display index from this store
   * @param displayIndex the display index of the node to find
   * @returns undefined if the node is not in the store bounds, otherwise will always return a node
   */ getRowByDisplayIndex(displayIndex) {
        if (!this.store.isDisplayIndexInStore(displayIndex)) return void 0;
        const node = this.nodeDisplayIndexMap.get(displayIndex);
        if (node) {
            if (node.stub || node.__needsRefreshWhenVisible) this.lazyBlockLoadingSvc.queueLoadCheck();
            return node;
        }
        const hideOpenGroups = this.gos.get("groupHideOpenParents") || this.gos.get("groupAllowUnbalanced");
        if (hideOpenGroups) {
            const nextParent = this.nodeMap.find((lazyNode)=>!!lazyNode.node.childStore?.isDisplayIndexInStore(displayIndex));
            if (nextParent) return nextParent.node.childStore?.getRowUsingDisplayIndex(displayIndex);
        }
        if (displayIndex === this.store.getDisplayIndexStart()) return this.createStubNode(0, displayIndex);
        const contiguouslyPreviousNode = this.nodeDisplayIndexMap.get(displayIndex - 1);
        if (contiguouslyPreviousNode) {
            if (this.isMasterDetail && contiguouslyPreviousNode.master && contiguouslyPreviousNode.expanded) return contiguouslyPreviousNode.detailNode;
            if (contiguouslyPreviousNode.expanded && contiguouslyPreviousNode.childStore?.isDisplayIndexInStore(displayIndex)) return contiguouslyPreviousNode.childStore?.getRowUsingDisplayIndex(displayIndex);
            const lazyCacheNode = this.nodeMap.getBy("node", contiguouslyPreviousNode);
            return this.createStubNode(lazyCacheNode.index + 1, displayIndex);
        }
        const adjacentNodes = this.getSurroundingNodesByDisplayIndex(displayIndex);
        if (adjacentNodes == null) {
            const storeIndexFromEndIndex2 = this.store.getRowCount() - (this.store.getDisplayIndexEnd() - displayIndex);
            return this.createStubNode(storeIndexFromEndIndex2, displayIndex);
        }
        const { previousNode: previousNode, nextNode: nextNode } = adjacentNodes;
        if (previousNode && previousNode.node.expanded && previousNode.node.childStore?.isDisplayIndexInStore(displayIndex)) return previousNode.node.childStore?.getRowUsingDisplayIndex(displayIndex);
        if (nextNode) {
            const displayIndexDiff = nextNode.node.rowIndex - displayIndex;
            const newStoreIndex = nextNode.index - displayIndexDiff;
            return this.createStubNode(newStoreIndex, displayIndex);
        }
        const storeIndexFromEndIndex = this.store.getRowCount() - (this.store.getDisplayIndexEnd() - displayIndex);
        return this.createStubNode(storeIndexFromEndIndex, displayIndex);
    }
    /**
   * Used for creating and positioning a stub node without firing a store updated event
   */ createStubNode(storeIndex, displayIndex) {
        const rowBounds = this.store.getRowBounds(displayIndex);
        const newNode = this.createRowAtIndex(storeIndex, null, (node)=>{
            node.setRowIndex(displayIndex);
            node.setRowTop(rowBounds.rowTop);
            this.nodeDisplayIndexMap.set(displayIndex, node);
        });
        if (storeIndex === 0 && this.gos.get("groupHideOpenParents")) {
            const parentGroupData = this.store.getParentNode().groupData;
            if (parentGroupData) for (const key of Object.keys(parentGroupData))$5b7ccabde48fae90$var$setRowNodeGroupValue(newNode, this.colModel, key, parentGroupData[key]);
        }
        this.lazyBlockLoadingSvc.queueLoadCheck();
        return newNode;
    }
    /**
   * @param index The row index relative to this store
   * @returns A rowNode at the given store index
   */ getRowByStoreIndex(index) {
        return this.nodeMap.getBy("index", index)?.node;
    }
    /**
   * Given a number of rows, skips through the given sequence & row top reference (using default row height)
   * @param numberOfRowsToSkip number of rows to skip over in the given sequence
   * @param displayIndexSeq the sequence in which to skip
   * @param nextRowTop the row top reference in which to skip
   */ skipDisplayIndexes(numberOfRowsToSkip, displayIndexSeq, nextRowTop) {
        if (numberOfRowsToSkip === 0) return;
        const defaultRowHeight = (0, $jIDNV._getRowHeightAsNumber)(this.beans);
        displayIndexSeq.value += numberOfRowsToSkip;
        nextRowTop.value += numberOfRowsToSkip * defaultRowHeight;
    }
    /**
   * @param displayIndexSeq the number sequence for generating the display index of each row
   * @param nextRowTop an object containing the next row top value intended to be modified by ref per row
   */ setDisplayIndexes(displayIndexSeq, nextRowTop, uiLevel) {
        this.nodeDisplayIndexMap.clear();
        const orderedMap = {};
        this.nodeMap.forEach((lazyNode)=>{
            orderedMap[lazyNode.index] = lazyNode.node;
        });
        let lastIndex = -1;
        for (const stringIndex of Object.keys(orderedMap)){
            const node = orderedMap[stringIndex];
            const numericIndex = Number(stringIndex);
            const numberOfRowsToSkip2 = numericIndex - 1 - lastIndex;
            this.skipDisplayIndexes(numberOfRowsToSkip2, displayIndexSeq, nextRowTop);
            const isFirstChild = numericIndex === 0;
            node.setFirstChild(isFirstChild);
            if (isFirstChild && this.gos.get("groupHideOpenParents")) {
                const parentGroupData = this.store.getParentNode().groupData;
                if (parentGroupData) for (const key of Object.keys(parentGroupData))$5b7ccabde48fae90$var$setRowNodeGroupValue(node, this.colModel, key, isFirstChild ? parentGroupData[key] : void 0);
            }
            this.blockUtils.setDisplayIndex(node, displayIndexSeq, nextRowTop, uiLevel);
            if (node.rowIndex != null) this.nodeDisplayIndexMap.set(node.rowIndex, node);
            lastIndex = numericIndex;
        }
        const numberOfRowsToSkip = this.numberOfRows - 1 - lastIndex;
        this.skipDisplayIndexes(numberOfRowsToSkip, displayIndexSeq, nextRowTop);
        this.purgeExcessRows();
    }
    getRowCount() {
        return this.numberOfRows;
    }
    setRowCount(rowCount, isLastRowIndexKnown) {
        this.numberOfRows = rowCount;
        if (isLastRowIndexKnown != null) {
            this.isLastRowKnown = isLastRowIndexKnown;
            if (isLastRowIndexKnown === false) this.numberOfRows += 1;
        }
        this.fireStoreUpdatedEvent();
    }
    getNodes() {
        return this.nodeMap;
    }
    getNodeCachedByDisplayIndex(displayIndex) {
        return this.nodeDisplayIndexMap.get(displayIndex) ?? null;
    }
    getNodesToRefresh() {
        return this.nodesToRefresh;
    }
    /**
   * @returns the previous and next loaded row nodes surrounding the given display index
   */ getSurroundingNodesByDisplayIndex(displayIndex) {
        let nextNode;
        let previousNode;
        this.nodeMap.forEach((lazyNode)=>{
            if (displayIndex > lazyNode.node.rowIndex) {
                if (previousNode == null || previousNode.node.rowIndex < lazyNode.node.rowIndex) previousNode = lazyNode;
                return;
            }
            if (nextNode == null || nextNode.node.rowIndex > lazyNode.node.rowIndex) {
                nextNode = lazyNode;
                return;
            }
        });
        if (!previousNode && !nextNode) return null;
        return {
            previousNode: previousNode,
            nextNode: nextNode
        };
    }
    /**
   * Get or calculate the display index for a given store index
   * @param storeIndex the rows index within this store
   * @returns the rows visible display index relative to the grid
   */ getDisplayIndexFromStoreIndex(storeIndex) {
        const nodeAtIndex = this.nodeMap.getBy("index", storeIndex);
        if (nodeAtIndex) return nodeAtIndex.node.rowIndex;
        let nextNode;
        let previousNode;
        this.nodeMap.forEach((lazyNode)=>{
            if (storeIndex > lazyNode.index) {
                if (previousNode == null || previousNode.index < lazyNode.index) previousNode = lazyNode;
                return;
            }
            if (nextNode == null || nextNode.index > lazyNode.index) {
                nextNode = lazyNode;
                return;
            }
        });
        if (!nextNode) return this.store.getDisplayIndexEnd() - (this.numberOfRows - storeIndex);
        if (!previousNode) return this.store.getDisplayIndexStart() + storeIndex;
        const storeIndexDiff = storeIndex - previousNode.index;
        const previousDisplayIndex = previousNode.node.childStore?.getDisplayIndexEnd() ?? previousNode.node.rowIndex;
        return previousDisplayIndex + storeIndexDiff;
    }
    /**
   * Creates a new row and inserts it at the given index
   * @param atStoreIndex the node index relative to this store
   * @param data the data object to populate the node with
   * @returns the new row node
   */ createRowAtIndex(atStoreIndex, data, createNodeCallback) {
        const lazyNode = this.nodeMap.getBy("index", atStoreIndex);
        if (lazyNode) {
            const { node: node } = lazyNode;
            node.__needsRefreshWhenVisible = false;
            if (this.doesNodeMatch(data, node)) {
                this.blockUtils.updateDataIntoRowNode(node, data);
                this.nodesToRefresh.delete(node);
                return node;
            }
            if (this.getRowIdFunc == null && node.hasChildren() && node.expanded) {
                this.nodesToRefresh.delete(node);
                return node;
            }
            this.destroyRowAtIndex(atStoreIndex);
        }
        if (data && this.getRowIdFunc != null) {
            const id = this.getRowId(data);
            const deletedNode = id && this.removedNodeCache?.get(id);
            if (deletedNode) {
                this.removedNodeCache?.delete(id);
                this.blockUtils.updateDataIntoRowNode(deletedNode, data);
                this.nodeMap.set({
                    id: deletedNode.id,
                    node: deletedNode,
                    index: atStoreIndex
                });
                this.nodesToRefresh.delete(deletedNode);
                deletedNode.__needsRefreshWhenVisible = false;
                return deletedNode;
            }
            const lazyNode2 = this.nodeMap.getBy("id", id);
            if (lazyNode2) {
                this.nodeMap.delete(lazyNode2);
                const { node: node, index: index } = lazyNode2;
                this.blockUtils.updateDataIntoRowNode(node, data);
                this.nodeMap.set({
                    id: node.id,
                    node: node,
                    index: atStoreIndex
                });
                this.nodesToRefresh.delete(node);
                node.__needsRefreshWhenVisible = false;
                if (this.getBlockStartIndex(index) === this.getBlockStartIndex(atStoreIndex)) return node;
                this.markBlockForVerify(index);
                return node;
            }
        }
        const newNode = this.blockUtils.createRowNode(this.store.getRowDetails());
        if (data != null) {
            const defaultId = this.getPrefixedId(this.store.getIdSequence().value++);
            this.blockUtils.setDataIntoRowNode(newNode, data, defaultId, void 0);
            this.serverSideRowModel.setPaused(true);
            this.blockUtils.checkOpenByDefault(newNode);
            this.serverSideRowModel.setPaused(false);
            this.nodeManager.addRowNode(newNode);
        }
        this.nodeMap.set({
            id: newNode.id,
            node: newNode,
            index: atStoreIndex
        });
        if (createNodeCallback) createNodeCallback(newNode);
        return newNode;
    }
    getBlockStates() {
        const blockCounts = {};
        const blockStates = {};
        this.nodeMap.forEach(({ node: node, index: index })=>{
            const blockStart = this.getBlockStartIndex(index);
            if (!node.stub && !node.failedLoad) blockCounts[blockStart] = (blockCounts[blockStart] ?? 0) + 1;
            let rowState = "loaded";
            if (node.failedLoad) rowState = "failed";
            else if (this.lazyBlockLoadingSvc.isRowLoading(this, blockStart)) rowState = "loading";
            else if (this.nodesToRefresh.has(node) || node.stub) rowState = "needsLoading";
            if (!blockStates[blockStart]) blockStates[blockStart] = /* @__PURE__ */ new Set();
            blockStates[blockStart].add(rowState);
        });
        const statePriorityMap = {
            loading: 4,
            failed: 3,
            needsLoading: 2,
            loaded: 1
        };
        const blockPrefix = this.blockUtils.createNodeIdPrefix(this.store.getParentNode());
        const results = {};
        for (const blockStart of Object.keys(blockStates)){
            const sortedStates = [
                ...blockStates[blockStart]
            ].sort((a, b)=>(statePriorityMap[a] ?? 0) - (statePriorityMap[b] ?? 0));
            const priorityState = sortedStates[0];
            const blockNumber = Number(blockStart) / this.getBlockSize();
            const blockId = blockPrefix ? `${blockPrefix}-${blockNumber}` : String(blockNumber);
            results[blockId] = {
                blockNumber: blockNumber,
                startRow: Number(blockStart),
                endRow: Number(blockStart) + this.getBlockSize(),
                pageStatus: priorityState,
                loadedRowCount: blockCounts[blockStart] ?? 0
            };
        }
        return results;
    }
    destroyRowAtIndex(atStoreIndex) {
        const lazyNode = this.nodeMap.getBy("index", atStoreIndex);
        if (!lazyNode) return;
        this.nodeMap.delete(lazyNode);
        this.nodeDisplayIndexMap.delete(lazyNode.node.rowIndex);
        if (this.nodesToRefresh.size > 0) this.removedNodeCache.set(lazyNode.node.id, lazyNode.node);
        else this.blockUtils.destroyRowNode(lazyNode.node);
        this.nodesToRefresh.delete(lazyNode.node);
    }
    getSsrmParams() {
        return this.store.getSsrmParams();
    }
    /**
   * @param id the base id to be prefixed
   * @returns a node id with prefix if required
   */ getPrefixedId(id) {
        if (this.defaultNodeIdPrefix) return this.defaultNodeIdPrefix + "-" + id;
        else return id.toString();
    }
    markBlockForVerify(rowIndex) {
        const [start, end] = this.getBlockBounds(rowIndex);
        const lazyNodesInRange = this.nodeMap.filter((lazyNode)=>lazyNode.index >= start && lazyNode.index < end);
        lazyNodesInRange.forEach(({ node: node })=>{
            node.__needsRefreshWhenVisible = true;
        });
    }
    doesNodeMatch(data, node) {
        if (node.stub) return false;
        const id = this.getRowId(data);
        return id === null ? node.data === data : node.id === id;
    }
    /**
   * Deletes any stub nodes not within the given range
   */ purgeStubsOutsideOfViewport() {
        const { firstRenderedRow: firstRenderedRow, lastRenderedRow: lastRenderedRow } = this.rowRenderer;
        const firstRowBlockStart = this.getBlockStartIndex(firstRenderedRow);
        const [, lastRowBlockEnd] = this.getBlockBounds(lastRenderedRow);
        this.nodeMap.forEach((lazyNode)=>{
            if (this.lazyBlockLoadingSvc.isRowLoading(this, lazyNode.index) || lazyNode.node.failedLoad) return;
            if (lazyNode.node.stub && (lazyNode.index < firstRowBlockStart || lazyNode.index > lastRowBlockEnd)) this.destroyRowAtIndex(lazyNode.index);
        });
    }
    getBlocksDistanceFromRow(nodes, otherDisplayIndex) {
        const blockDistanceToMiddle = {};
        nodes.forEach(({ node: node, index: index })=>{
            const [blockStart, blockEnd] = this.getBlockBounds(index);
            if (blockStart in blockDistanceToMiddle) return;
            const distStart = Math.abs(node.rowIndex - otherDisplayIndex);
            let distEnd;
            const lastLazyNode = this.nodeMap.getBy("index", [
                blockEnd - 1
            ]);
            if (lastLazyNode) distEnd = Math.abs(lastLazyNode.node.rowIndex - otherDisplayIndex);
            const farthest = distEnd == null || distStart < distEnd ? distStart : distEnd;
            blockDistanceToMiddle[blockStart] = farthest;
        });
        return Object.entries(blockDistanceToMiddle);
    }
    purgeExcessRows() {
        this.purgeStubsOutsideOfViewport();
        if (this.store.getDisplayIndexEnd() == null || this.storeParams.maxBlocksInCache == null) return;
        const { firstRenderedRow: firstRenderedRow, lastRenderedRow: lastRenderedRow } = this.rowRenderer;
        const allLoadedBlocks = /* @__PURE__ */ new Set();
        const blocksInViewport = /* @__PURE__ */ new Set();
        this.nodeMap.forEach(({ index: index, node: node })=>{
            const blockStart = this.getBlockStartIndex(index);
            allLoadedBlocks.add(blockStart);
            const isInViewport = node.rowIndex >= firstRenderedRow && node.rowIndex <= lastRenderedRow;
            if (isInViewport) blocksInViewport.add(blockStart);
        });
        const numberOfBlocksToRetain = Math.max(blocksInViewport.size, this.storeParams.maxBlocksInCache ?? 0);
        const loadedBlockCount = allLoadedBlocks.size;
        const blocksToRemove = loadedBlockCount - numberOfBlocksToRetain;
        if (blocksToRemove <= 0) return;
        let firstRowBlockStart = Number.MAX_SAFE_INTEGER;
        let lastRowBlockStart = Number.MIN_SAFE_INTEGER;
        blocksInViewport.forEach((blockStart)=>{
            if (firstRowBlockStart > blockStart) firstRowBlockStart = blockStart;
            if (lastRowBlockStart < blockStart) lastRowBlockStart = blockStart;
        });
        const disposableNodes = this.nodeMap.filter(({ node: node, index: index })=>{
            const rowBlockStart = this.getBlockStartIndex(index);
            const rowBlockInViewport = rowBlockStart >= firstRowBlockStart && rowBlockStart <= lastRowBlockStart;
            return !rowBlockInViewport && !this.isNodeCached(node);
        });
        if (disposableNodes.length === 0) return;
        const midViewportRow = firstRenderedRow + (lastRenderedRow - firstRenderedRow) / 2;
        const blockDistanceArray = this.getBlocksDistanceFromRow(disposableNodes, midViewportRow);
        const blockSize = this.getBlockSize();
        blockDistanceArray.sort((a, b)=>Math.sign(b[1] - a[1]));
        for(let i = 0; i < Math.min(blocksToRemove, blockDistanceArray.length); i++){
            const blockStart = Number(blockDistanceArray[i][0]);
            for(let x = blockStart; x < blockStart + blockSize; x++){
                const lazyNode = this.nodeMap.getBy("index", x);
                if (!lazyNode || this.isNodeCached(lazyNode.node)) continue;
                this.destroyRowAtIndex(x);
            }
        }
    }
    isNodeFocused(node) {
        const focusedCell = this.focusSvc.getFocusCellToUseAfterRefresh();
        if (!focusedCell) return false;
        if (focusedCell.rowPinned != null) return false;
        const hasFocus = focusedCell.rowIndex === node.rowIndex;
        return hasFocus;
    }
    isNodeCached(node) {
        const isUnbalancedNode = this.gos.get("groupAllowUnbalanced") && node.key === "";
        return node.isExpandable() && node.expanded || this.isNodeFocused(node) || isUnbalancedNode;
    }
    extractDuplicateIds(rows) {
        if (this.getRowIdFunc == null) return [];
        const newIds = /* @__PURE__ */ new Set();
        const duplicates = /* @__PURE__ */ new Set();
        rows.forEach((data)=>{
            const id = this.getRowId(data);
            if (newIds.has(id)) {
                duplicates.add(id);
                return;
            }
            newIds.add(id);
        });
        return [
            ...duplicates
        ];
    }
    onLoadSuccess(firstRowIndex, numberOfRowsExpected, response) {
        if (!this.live) return;
        const info = response.groupLevelInfo;
        this.store.setStoreInfo(info);
        if (this.getRowIdFunc != null) {
            const duplicates = this.extractDuplicateIds(response.rowData);
            if (duplicates.length > 0) {
                const duplicateIdText = duplicates.join(", ");
                (0, $jIDNV._warn)(205, {
                    duplicateIdText: duplicateIdText
                });
                this.onLoadFailed(firstRowIndex, numberOfRowsExpected);
                return;
            }
        }
        if (response.pivotResultFields) this.serverSideRowModel.generateSecondaryColumns(response.pivotResultFields);
        const wasRefreshing = this.nodesToRefresh.size > 0;
        response.rowData.forEach((data, responseRowIndex)=>{
            const rowIndex = firstRowIndex + responseRowIndex;
            const nodeFromCache = this.nodeMap.getBy("index", rowIndex);
            if (nodeFromCache?.node?.stub) {
                this.createRowAtIndex(rowIndex, data);
                return;
            }
            if (nodeFromCache && this.doesNodeMatch(data, nodeFromCache.node)) {
                this.blockUtils.updateDataIntoRowNode(nodeFromCache.node, data);
                this.nodesToRefresh.delete(nodeFromCache.node);
                nodeFromCache.node.__needsRefreshWhenVisible = false;
                return;
            }
            this.createRowAtIndex(rowIndex, data);
        });
        if (response.rowCount != void 0 && response.rowCount !== -1) {
            this.numberOfRows = response.rowCount;
            this.isLastRowKnown = true;
        } else if (numberOfRowsExpected > response.rowData.length) {
            this.numberOfRows = firstRowIndex + response.rowData.length;
            this.isLastRowKnown = true;
        } else if (!this.isLastRowKnown) {
            const lastInferredRow = firstRowIndex + response.rowData.length + 1;
            if (lastInferredRow > this.numberOfRows) this.numberOfRows = lastInferredRow;
        }
        if (this.isLastRowKnown) {
            const lazyNodesAfterStoreEnd = this.nodeMap.filter((lazyNode)=>lazyNode.index >= this.numberOfRows);
            lazyNodesAfterStoreEnd.forEach((lazyNode)=>this.destroyRowAtIndex(lazyNode.index));
        }
        this.fireStoreUpdatedEvent();
        const finishedRefreshing = this.nodesToRefresh.size === 0;
        if (wasRefreshing && finishedRefreshing) this.fireRefreshFinishedEvent();
    }
    fireRefreshFinishedEvent() {
        const finishedRefreshing = this.nodesToRefresh.size === 0;
        if (!finishedRefreshing) return;
        this.removedNodeCache.forEach((node)=>{
            this.blockUtils.destroyRowNode(node);
        });
        this.removedNodeCache = /* @__PURE__ */ new Map();
        this.store.fireRefreshFinishedEvent();
    }
    /**
   * @returns true if all rows are loaded
   */ isStoreFullyLoaded() {
        const knowsSize = this.isLastRowKnown;
        const hasCorrectRowCount = this.nodeMap.getSize() === this.numberOfRows;
        if (!knowsSize || !hasCorrectRowCount) return;
        if (this.nodesToRefresh.size > 0) return;
        let index = -1;
        const firstOutOfPlaceNode = this.nodeMap.find((lazyNode)=>{
            index += 1;
            if (lazyNode.index !== index) return true;
            if (lazyNode.node.__needsRefreshWhenVisible) return true;
            if (lazyNode.node.stub) return true;
            return false;
        });
        return firstOutOfPlaceNode == null;
    }
    isLastRowIndexKnown() {
        return this.isLastRowKnown;
    }
    onLoadFailed(firstRowIndex, numberOfRowsExpected) {
        if (!this.live) return;
        const wasRefreshing = this.nodesToRefresh.size > 0;
        for(let i = firstRowIndex; i < firstRowIndex + numberOfRowsExpected && i < this.getRowCount(); i++){
            let { node: node } = this.nodeMap.getBy("index", i) ?? {};
            if (node) this.nodesToRefresh.delete(node);
            if (!node || !node.stub) {
                if (node && !node.stub) this.destroyRowAtIndex(i);
                node = this.createRowAtIndex(i);
            }
            node.__needsRefreshWhenVisible = false;
            node.failedLoad = true;
        }
        const finishedRefreshing = this.nodesToRefresh.size === 0;
        if (wasRefreshing && finishedRefreshing) this.fireRefreshFinishedEvent();
        this.fireStoreUpdatedEvent();
    }
    markNodesForRefresh() {
        this.nodeMap.forEach((lazyNode)=>{
            if (lazyNode.node.stub && !lazyNode.node.failedLoad) return;
            this.nodesToRefresh.add(lazyNode.node);
        });
        this.lazyBlockLoadingSvc.queueLoadCheck();
        if (this.isLastRowKnown && this.numberOfRows === 0) {
            this.numberOfRows = 1;
            this.isLastRowKnown = false;
            this.fireStoreUpdatedEvent();
        }
    }
    isNodeInCache(id) {
        return !!this.nodeMap.getBy("id", id);
    }
    // gets called 1) row count changed 2) cache purged 3) items inserted
    fireStoreUpdatedEvent() {
        if (!this.live) return;
        this.store.fireStoreUpdatedEvent();
    }
    getRowId(data) {
        if (this.getRowIdFunc == null) return null;
        const { level: level } = this.store.getRowDetails();
        const parentKeys = this.store.getParentNode().getRoute() ?? [];
        return this.getRowIdFunc({
            data: data,
            parentKeys: parentKeys.length > 0 ? parentKeys : void 0,
            level: level
        });
    }
    getOrderedNodeMap() {
        const obj = {};
        this.nodeMap.forEach((node)=>obj[node.index] = node);
        return obj;
    }
    clearDisplayIndexes() {
        this.nodeDisplayIndexMap.clear();
    }
    /**
   * Client side sorting
   */ clientSideSortRows() {
        const sortOptions = this.sortSvc?.getSortOptions() ?? [];
        const isAnySort = sortOptions.some((opt)=>opt.sort != null);
        if (!isAnySort || !this.rowNodeSorter) return;
        const allNodes = new Array(this.nodeMap.getSize());
        this.nodeMap.forEach((lazyNode)=>allNodes[lazyNode.index] = lazyNode.node);
        this.nodeMap.clear();
        const sortedNodes = this.rowNodeSorter.doFullSort(allNodes, sortOptions);
        sortedNodes.forEach((node, index)=>{
            this.nodeMap.set({
                id: node.id,
                node: node,
                index: index
            });
        });
    }
    /**
   * Transaction Support here
   */ updateRowNodes(updates) {
        const updatedNodes = [];
        updates.forEach((data)=>{
            const id = this.getRowId(data);
            const lazyNode = this.nodeMap.getBy("id", id);
            if (lazyNode) {
                this.blockUtils.updateDataIntoRowNode(lazyNode.node, data);
                updatedNodes.push(lazyNode.node);
            }
        });
        return updatedNodes;
    }
    insertRowNodes(inserts, indexToAdd) {
        const realRowCount = this.store.getRowCount() - (this.store.getParentNode().sibling ? 1 : 0);
        const addIndex = indexToAdd == null && this.isLastRowKnown ? realRowCount : indexToAdd;
        if (addIndex == null || realRowCount < addIndex) return [];
        const uniqueInsertsMap = {};
        inserts.forEach((data)=>{
            const dataId = this.getRowId(data);
            if (dataId && this.isNodeInCache(dataId)) return;
            uniqueInsertsMap[dataId] = data;
        });
        const uniqueInserts = Object.values(uniqueInsertsMap);
        const numberOfInserts = uniqueInserts.length;
        if (numberOfInserts === 0) return [];
        const nodesToMove = this.nodeMap.filter((node)=>node.index >= addIndex);
        nodesToMove.forEach((lazyNode)=>this.nodeMap.delete(lazyNode));
        nodesToMove.forEach((lazyNode)=>{
            this.nodeMap.set({
                node: lazyNode.node,
                index: lazyNode.index + numberOfInserts,
                id: lazyNode.id
            });
        });
        this.numberOfRows += numberOfInserts;
        return uniqueInserts.map((data, uniqueInsertOffset)=>this.createRowAtIndex(addIndex + uniqueInsertOffset, data));
    }
    removeRowNodes(idsToRemove) {
        const removedNodes = [];
        const nodesToVerify = [];
        let deletedNodeCount = 0;
        const remainingIdsToRemove = [
            ...idsToRemove
        ];
        const allNodes = this.getOrderedNodeMap();
        let contiguousIndex = -1;
        for (const stringIndex of Object.keys(allNodes)){
            contiguousIndex += 1;
            const node = allNodes[stringIndex];
            const matchIndex = remainingIdsToRemove.findIndex((idToRemove)=>idToRemove === node.id);
            if (matchIndex !== -1) {
                remainingIdsToRemove.splice(matchIndex, 1);
                this.destroyRowAtIndex(Number(stringIndex));
                removedNodes.push(node.node);
                deletedNodeCount += 1;
                continue;
            }
            if (deletedNodeCount === 0) continue;
            const numericStoreIndex = Number(stringIndex);
            if (contiguousIndex !== numericStoreIndex) nodesToVerify.push(node.node);
            this.nodeMap.delete(node);
            this.nodeMap.set({
                id: node.id,
                node: node.node,
                index: numericStoreIndex - deletedNodeCount
            });
        }
        this.numberOfRows -= this.isLastRowIndexKnown() ? idsToRemove.length : deletedNodeCount;
        if (remainingIdsToRemove.length > 0 && nodesToVerify.length > 0) {
            nodesToVerify.forEach((node)=>node.__needsRefreshWhenVisible = true);
            this.lazyBlockLoadingSvc.queueLoadCheck();
        }
        return removedNodes;
    }
    /**
   * Return the block size configured for this cache
   */ getBlockSize() {
        return this.storeParams.cacheBlockSize || $5b7ccabde48fae90$var$DEFAULT_BLOCK_SIZE;
    }
    /**
   * Get the start index of the loading block for a given index
   */ getBlockStartIndex(storeIndex) {
        const blockSize = this.getBlockSize();
        return storeIndex - storeIndex % blockSize;
    }
    /**
   * Get the start and end index of a block, given a row store index
   */ getBlockBounds(storeIndex) {
        const startOfBlock = this.getBlockStartIndex(storeIndex);
        const blockSize = this.getBlockSize();
        return [
            startOfBlock,
            startOfBlock + blockSize
        ];
    }
};
// packages/ag-grid-enterprise/src/serverSideRowModel/stores/lazy/lazyStore.ts
var $5b7ccabde48fae90$var$LazyStore = class extends (0, $jIDNV.BeanStub) {
    constructor(ssrmParams, storeParams, parentRowNode){
        super();
        this.idSequence = {
            value: 0
        };
        this.ssrmParams = ssrmParams;
        this.parentRowNode = parentRowNode;
        this.storeParams = storeParams;
        this.level = parentRowNode.level + 1;
        this.group = ssrmParams.rowGroupCols ? this.level < ssrmParams.rowGroupCols.length : false;
        this.leafGroup = ssrmParams.rowGroupCols ? this.level === ssrmParams.rowGroupCols.length - 1 : false;
        this.info = {};
    }
    wireBeans(beans) {
        this.blockUtils = beans.ssrmBlockUtils;
        this.storeUtils = beans.ssrmStoreUtils;
        this.selectionSvc = beans.selectionSvc;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
    }
    postConstruct() {
        let numberOfRows = 1;
        if (this.level === 0) {
            numberOfRows = this.storeUtils.getServerSideInitialRowCount() ?? 1;
            this.eventSvc.dispatchEventOnce({
                type: "rowCountReady"
            });
        }
        this.cache = this.createManagedBean(new $5b7ccabde48fae90$var$LazyCache(this, numberOfRows, false, this.storeParams));
        const usingTreeData = this.gos.get("treeData");
        if (!usingTreeData && this.group && this.rowGroupColsSvc) {
            const groupColVo = this.ssrmParams.rowGroupCols[this.level];
            this.groupField = groupColVo.field;
            this.rowGroupColumn = this.rowGroupColsSvc.columns[this.level];
        }
    }
    destroy() {
        this.displayIndexStart = void 0;
        this.displayIndexEnd = void 0;
        this.destroyBean(this.cache);
        super.destroy();
    }
    /**
   * Given a server response, ingest the rows outside of the data source lifecycle.
   *
   * @param rowDataParams the server response containing the rows to ingest
   * @param startRow the index to start ingesting rows
   * @param expectedRows the expected number of rows in the response (used to determine if the last row index is known)
   */ applyRowData(rowDataParams, startRow, expectedRows) {
        this.cache.onLoadSuccess(startRow, expectedRows, rowDataParams);
    }
    /**
   * Applies a given transaction to the data set within this store
   *
   * @param transaction an object containing delta instructions determining the changes to apply to this store
   * @returns an object determining the status of this transaction and effected nodes
   */ applyTransaction(transaction) {
        const idFunc = (0, $jIDNV._getRowIdCallback)(this.gos);
        if (!idFunc) {
            (0, $jIDNV._warn)(206);
            return {
                status: (0, $jIDNV.ServerSideTransactionResultStatus).Cancelled
            };
        }
        const applyCallback = this.gos.getCallback("isApplyServerSideTransaction");
        if (applyCallback) {
            const params = {
                transaction: transaction,
                parentNode: this.parentRowNode,
                groupLevelInfo: this.info
            };
            const apply = applyCallback(params);
            if (!apply) return {
                status: (0, $jIDNV.ServerSideTransactionResultStatus).Cancelled
            };
        }
        const allRowsLoaded = this.cache.isStoreFullyLoaded();
        let updatedNodes = void 0;
        if (transaction.update?.length) updatedNodes = this.cache.updateRowNodes(transaction.update);
        let insertedNodes = void 0;
        if (transaction.add?.length) {
            let addIndex = transaction.addIndex;
            if (addIndex != null && addIndex < 0) addIndex = void 0;
            insertedNodes = this.cache.insertRowNodes(transaction.add, addIndex);
        }
        let removedNodes = void 0;
        if (transaction.remove?.length) {
            const allIdsToRemove = transaction.remove.map((data)=>idFunc({
                    level: this.level,
                    parentKeys: this.parentRowNode.getRoute() ?? [],
                    data: data
                }));
            const allUniqueIdsToRemove = [
                ...new Set(allIdsToRemove)
            ];
            removedNodes = this.cache.removeRowNodes(allUniqueIdsToRemove);
        }
        const isClientSideSortingEnabled = this.gos.get("serverSideEnableClientSideSort");
        const isUpdateOrAdd = updatedNodes?.length || insertedNodes?.length;
        const isClientSideSort = allRowsLoaded && isClientSideSortingEnabled;
        if (isClientSideSort && isUpdateOrAdd) this.cache.clientSideSortRows();
        this.updateSelectionAfterTransaction(updatedNodes, removedNodes);
        return {
            status: (0, $jIDNV.ServerSideTransactionResultStatus).Applied,
            update: updatedNodes,
            add: insertedNodes,
            remove: removedNodes
        };
    }
    updateSelectionAfterTransaction(updatedNodes, removedNodes) {
        if (!this.selectionSvc) return;
        const nodesToDeselect = [];
        updatedNodes?.forEach((node)=>{
            if (node.isSelected() && !node.selectable) nodesToDeselect.push(node);
        });
        removedNodes?.forEach((node)=>{
            if (node.isSelected()) nodesToDeselect.push(node);
        });
        if (nodesToDeselect.length) this.selectionSvc.setNodesSelected({
            newValue: false,
            clearSelection: false,
            nodes: nodesToDeselect,
            source: "rowDataChanged"
        });
    }
    /**
   * Clear the display indexes, used for fading rows out when stores are not being destroyed
   */ clearDisplayIndexes() {
        this.displayIndexStart = void 0;
        this.displayIndexEnd = void 0;
        this.cache.getNodes().forEach((lazyNode)=>this.blockUtils.clearDisplayIndex(lazyNode.node));
        if (this.parentRowNode.sibling) this.blockUtils.clearDisplayIndex(this.parentRowNode.sibling);
        this.cache.clearDisplayIndexes();
    }
    /**
   * @returns an index representing the last sequentially displayed row in the grid for this store
   */ getDisplayIndexStart() {
        return this.displayIndexStart;
    }
    /**
   * @returns the index representing one after the last sequentially displayed row in the grid for this store
   */ getDisplayIndexEnd() {
        return this.displayIndexEnd;
    }
    /**
   * @returns the virtual size of this store
   */ getRowCount() {
        if (this.parentRowNode.sibling) return this.cache.getRowCount() + 1;
        return this.cache.getRowCount();
    }
    /**
   * Sets the current row count of the store, and whether the last row index is known
   */ setRowCount(rowCount, isLastRowIndexKnown) {
        this.cache.setRowCount(rowCount, isLastRowIndexKnown);
    }
    /**
   * Given a display index, returns whether that row is within this store or a child store of this store
   *
   * @param displayIndex the visible index of a row
   * @returns whether or not the row exists within this store
   */ isDisplayIndexInStore(displayIndex) {
        if (this.cache.getRowCount() === 0) return false;
        return this.displayIndexStart <= displayIndex && displayIndex < this.getDisplayIndexEnd();
    }
    /**
   * Recursively sets up the display indexes and top position of every node belonging to this store.
   *
   * Called after a row height changes, or a store updated event.
   *
   * @param displayIndexSeq the number sequence for generating the display index of each row
   * @param nextRowTop an object containing the next row top value intended to be modified by ref per row
   */ setDisplayIndexes(displayIndexSeq, nextRowTop, uiLevel) {
        this.displayIndexStart = displayIndexSeq.value;
        this.topPx = nextRowTop.value;
        const footerNode = this.parentRowNode.level > -1 && (0, $jIDNV._getGroupTotalRowCallback)(this.gos)({
            node: this.parentRowNode
        });
        if (!footerNode) $5b7ccabde48fae90$var$_destroyRowNodeFooter(this.parentRowNode);
        if (footerNode === "top") {
            $5b7ccabde48fae90$var$_createRowNodeFooter(this.parentRowNode, this.beans);
            this.blockUtils.setDisplayIndex(this.parentRowNode.sibling, displayIndexSeq, nextRowTop, uiLevel);
        }
        this.cache.setDisplayIndexes(displayIndexSeq, nextRowTop, uiLevel);
        if (footerNode === "bottom") {
            $5b7ccabde48fae90$var$_createRowNodeFooter(this.parentRowNode, this.beans);
            this.blockUtils.setDisplayIndex(this.parentRowNode.sibling, displayIndexSeq, nextRowTop, uiLevel);
        }
        this.displayIndexEnd = displayIndexSeq.value;
        this.heightPx = nextRowTop.value - this.topPx;
    }
    /**
   * Recursively applies a provided function to every node
   *
   * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeepAfterFilterAndSort
   */ forEachStoreDeep(callback, sequence = {
        value: 0
    }) {
        callback(this, sequence.value++);
        this.cache.getNodes().forEach((lazyNode)=>{
            const childCache = lazyNode.node.childStore;
            if (childCache) childCache.forEachStoreDeep(callback, sequence);
        });
    }
    /**
   * Recursively applies a provided function to every node
   *
   * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeepAfterFilterAndSort
   */ forEachNodeDeep(callback, sequence = {
        value: 0
    }) {
        this.cache.getNodes().forEach((lazyNode)=>{
            callback(lazyNode.node, sequence.value++);
            const childCache = lazyNode.node.childStore;
            if (childCache) childCache.forEachNodeDeep(callback, sequence);
        });
    }
    /**
   * Recursively applies a provided function to every node
   *
   * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeep
   */ forEachNodeDeepAfterFilterAndSort(callback, sequence = {
        value: 0
    }, includeFooterNodes = false) {
        const footerNode = this.parentRowNode.level > -1 && (0, $jIDNV._getGroupTotalRowCallback)(this.gos)({
            node: this.parentRowNode
        });
        if (footerNode === "top") callback(this.parentRowNode.sibling, sequence.value++);
        const orderedNodes = this.cache.getOrderedNodeMap();
        for (const lazyNode of Object.values(orderedNodes)){
            callback(lazyNode.node, sequence.value++);
            const childCache = lazyNode.node.childStore;
            if (childCache) childCache.forEachNodeDeepAfterFilterAndSort(callback, sequence, includeFooterNodes);
        }
        if (footerNode === "bottom") callback(this.parentRowNode.sibling, sequence.value++);
    }
    /**
   * Removes the failed status from all nodes, and marks them as stub to encourage reloading
   */ retryLoads() {
        this.cache.getNodes().forEach(({ node: node })=>{
            if (node.failedLoad) {
                node.failedLoad = false;
                node.__needsRefreshWhenVisible = true;
                node.stub = true;
            }
        });
        this.forEachChildStoreShallow((store)=>store.retryLoads());
        this.fireStoreUpdatedEvent();
    }
    /**
   * Given a display index, returns the row at that location.
   *
   * @param displayRowIndex the displayed index within the grid to search for
   * @returns the row node if the display index falls within the store, if it didn't exist this will create a new stub to return
   */ getRowUsingDisplayIndex(displayRowIndex) {
        if (this.parentRowNode.sibling && displayRowIndex === this.parentRowNode.sibling.rowIndex) return this.parentRowNode.sibling;
        return this.cache.getRowByDisplayIndex(displayRowIndex);
    }
    /**
   * Given a display index, returns the row top and height for the row at that index.
   *
   * @param displayIndex the display index of the node
   * @returns an object containing the rowTop and rowHeight of the node at the given displayIndex
   */ getRowBounds(displayIndex) {
        if (!this.isDisplayIndexInStore(displayIndex)) return null;
        const thisNode = this.cache.getNodeCachedByDisplayIndex(displayIndex);
        if (thisNode) {
            const boundsFromRow = this.blockUtils.extractRowBounds(thisNode, displayIndex);
            if (boundsFromRow) return boundsFromRow;
        }
        const { previousNode: previousNode, nextNode: nextNode } = this.cache.getSurroundingNodesByDisplayIndex(displayIndex) ?? {};
        if (previousNode) {
            const boundsFromRow = this.blockUtils.extractRowBounds(previousNode.node, displayIndex);
            if (boundsFromRow != null) return boundsFromRow;
        }
        const defaultRowHeight = (0, $jIDNV._getRowHeightAsNumber)(this.beans);
        if (nextNode) {
            const numberOfRowDiff2 = (nextNode.node.rowIndex - displayIndex) * defaultRowHeight;
            return {
                rowTop: nextNode.node.rowTop - numberOfRowDiff2,
                rowHeight: defaultRowHeight
            };
        }
        const lastTop = this.topPx + this.heightPx;
        const numberOfRowDiff = (this.getDisplayIndexEnd() - displayIndex) * defaultRowHeight;
        return {
            rowTop: lastTop - numberOfRowDiff,
            rowHeight: defaultRowHeight
        };
    }
    /**
   * Given a vertical pixel, determines whether this store contains a row at that pixel
   *
   * @param pixel a vertical pixel position from the grid
   * @returns whether that pixel points to a virtual space belonging to this store
   */ isPixelInRange(pixel) {
        return pixel >= this.topPx && pixel < this.topPx + this.heightPx;
    }
    /**
   * Given a vertical pixel, returns the row existing at that pixel location
   *
   * @param pixel a vertical pixel position from the grid
   * @returns the display index at the given pixel location
   */ getRowIndexAtPixel(pixel) {
        if (pixel < this.topPx) return this.getDisplayIndexStart();
        if (pixel >= this.topPx + this.heightPx) return this.getDisplayIndexEnd() - 1;
        if (this.parentRowNode.sibling && pixel > this.parentRowNode.sibling.rowTop && pixel < this.parentRowNode.sibling.rowTop + this.parentRowNode.sibling.rowHeight) return this.parentRowNode.sibling.rowIndex;
        let distToPreviousNodeTop = Number.MAX_SAFE_INTEGER;
        let previousNode = null;
        let distToNextNodeTop = Number.MAX_SAFE_INTEGER;
        let nextNode = null;
        this.cache.getNodes().forEach(({ node: node })=>{
            const distBetween = Math.abs(pixel - node.rowTop);
            if (node.rowTop < pixel) {
                if (distBetween < distToPreviousNodeTop) {
                    distToPreviousNodeTop = distBetween;
                    previousNode = node;
                }
                return;
            }
            if (distBetween < distToNextNodeTop) {
                distToNextNodeTop = distBetween;
                nextNode = node;
            }
        });
        previousNode;
        nextNode;
        if (previousNode) {
            const indexOfRow = this.blockUtils.getIndexAtPixel(previousNode, pixel);
            if (indexOfRow != null) return indexOfRow;
        }
        const defaultRowHeight = (0, $jIDNV._getRowHeightAsNumber)(this.beans);
        if (nextNode) {
            const nextTop2 = nextNode.rowTop;
            const numberOfRowDiff2 = Math.ceil((nextTop2 - pixel) / defaultRowHeight);
            return nextNode.rowIndex - numberOfRowDiff2;
        }
        const nextTop = this.topPx + this.heightPx;
        const numberOfRowDiff = Math.floor((nextTop - pixel) / defaultRowHeight);
        return this.getDisplayIndexEnd() - numberOfRowDiff;
    }
    /**
   * Given a path of group keys, returns the child store for that group.
   *
   * @param keys the grouping path to the desired store
   * @returns the child store for the given keys, or null if not found
   */ getChildStore(keys) {
        return this.storeUtils.getChildStore(keys, this, (key)=>{
            const lazyNode = this.cache.getNodes().find((lazyNode2)=>lazyNode2.node.key == key);
            if (!lazyNode) return null;
            return lazyNode.node;
        });
    }
    /**
   * Executes a provided callback on each child store belonging to this store
   *
   * @param cb the callback to execute
   */ forEachChildStoreShallow(cb) {
        this.cache.getNodes().forEach(({ node: node })=>{
            if (node.childStore) cb(node.childStore);
        });
    }
    /**
   * Executes after a change to sorting, determines recursively whether this store or a child requires refreshed.
   *
   * If a purge refresh occurs, the row count is preserved.
   *
   * @param params a set of properties pertaining to the sort changes
   */ refreshAfterSort(params) {
        const serverSortsAllLevels = this.storeUtils.isServerSideSortAllLevels();
        if (serverSortsAllLevels || this.storeUtils.isServerRefreshNeeded(this.parentRowNode, this.ssrmParams.rowGroupCols, params)) {
            const allRowsLoaded = this.cache.isStoreFullyLoaded();
            const isClientSideSortingEnabled = this.gos.get("serverSideEnableClientSideSort");
            const isClientSideSort = allRowsLoaded && isClientSideSortingEnabled;
            if (!isClientSideSort) {
                const oldCount = this.cache.getRowCount();
                const lastKnown = this.cache.isLastRowIndexKnown();
                this.destroyBean(this.cache);
                this.cache = this.createManagedBean(new $5b7ccabde48fae90$var$LazyCache(this, oldCount, lastKnown, this.storeParams));
                return;
            }
            this.cache.clientSideSortRows();
        }
        this.forEachChildStoreShallow((store)=>store.refreshAfterSort(params));
    }
    /**
   * Executes after a change to filtering, determines recursively whether this store or a child requires refreshed.
   *
   * If a refresh occurs, the row count is reset.
   *
   * @param params a set of properties pertaining to the filter changes
   */ refreshAfterFilter(params) {
        const serverFiltersAllLevels = !this.storeUtils.isServerSideOnlyRefreshFilteredGroups();
        if (serverFiltersAllLevels || this.storeUtils.isServerRefreshNeeded(this.parentRowNode, this.ssrmParams.rowGroupCols, params)) {
            this.refreshStore(true);
            return;
        }
        this.forEachChildStoreShallow((store)=>store.refreshAfterFilter(params));
    }
    /**
   * Marks all existing nodes as requiring reloaded, and triggers a load check
   *
   * @param purge whether to remove all nodes and data in favour of stub nodes
   */ refreshStore(purge) {
        if (purge) {
            this.destroyBean(this.cache);
            this.cache = this.createManagedBean(new $5b7ccabde48fae90$var$LazyCache(this, 1, false, this.storeParams));
            this.fireStoreUpdatedEvent();
            return;
        }
        this.cache.markNodesForRefresh();
    }
    /**
   * Used for pagination, given a local/store index, returns the display index of that row
   *
   * @param topLevelIndex the store index of a row
   * @returns the display index for the given store index
   */ getTopLevelRowDisplayedIndex(topLevelIndex) {
        const displayIndex = this.cache.getDisplayIndexFromStoreIndex(topLevelIndex);
        return displayIndex ?? topLevelIndex;
    }
    /**
   * Used for pagination to determine if the last page is known, and for aria to determine if the last grid row is known
   *
   * @returns whether the last index of this store is known, or if lazy loading still required
   */ isLastRowIndexKnown() {
        return this.cache.isLastRowIndexKnown();
    }
    /**
   * Used by the selection service to select a range of nodes
   *
   * @param firstInRange the first node in the range to find
   * @param lastInRange the last node in the range to find
   * @returns a range of nodes between firstInRange and lastInRange inclusive
   */ getRowNodesInRange(firstInRange, lastInRange) {
        return this.cache.getNodes().filter(({ node: node })=>{
            return node.rowIndex >= firstInRange.rowIndex && node.rowIndex <= lastInRange.rowIndex;
        }).map(({ node: node })=>node);
    }
    /**
   * Mutates a given array to add this stores state, and recursively add all the children store states.
   *
   * @param result a mutable results array
   */ addStoreStates(result) {
        result.push({
            route: this.parentRowNode.getRoute() ?? [],
            rowCount: this.getRowCount(),
            lastRowIndexKnown: this.isLastRowIndexKnown(),
            info: this.info,
            maxBlocksInCache: this.storeParams.maxBlocksInCache,
            cacheBlockSize: this.storeParams.cacheBlockSize
        });
        this.forEachChildStoreShallow((childStore)=>childStore.addStoreStates(result));
    }
    getIdSequence() {
        return this.idSequence;
    }
    getParentNode() {
        return this.parentRowNode;
    }
    getRowDetails() {
        return {
            field: this.groupField,
            group: this.group,
            leafGroup: this.leafGroup,
            level: this.level,
            parent: this.parentRowNode,
            rowGroupColumn: this.rowGroupColumn
        };
    }
    getSsrmParams() {
        return this.ssrmParams;
    }
    setStoreInfo(info) {
        if (info) Object.assign(this.info, info);
    }
    // gets called 1) row count changed 2) cache purged
    fireStoreUpdatedEvent() {
        this.eventSvc.dispatchEvent({
            type: "storeUpdated"
        });
    }
    // gets called when row data updated, and no more refreshing needed
    fireRefreshFinishedEvent() {
        this.eventSvc.dispatchEvent({
            type: "storeRefreshed",
            route: this.parentRowNode.getRoute()
        });
    }
    getBlockStates() {
        return this.cache.getBlockStates();
    }
    getStoreBounds() {
        return {
            topPx: this.topPx,
            heightPx: this.heightPx
        };
    }
    getCache() {
        return this.cache;
    }
    getFirstNode() {
        const firstNode = this.cache.getNodes().getBy("index", 0);
        return firstNode?.node ?? null;
    }
};
// packages/ag-grid-enterprise/src/serverSideRowModel/stores/storeFactory.ts
var $5b7ccabde48fae90$var$StoreFactory = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmStoreFactory";
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
        this.pivotColsSvc = beans.pivotColsSvc;
        this.rowAutoHeight = beans.rowAutoHeight;
    }
    createStore(ssrmParams, parentNode) {
        const storeParams = this.getStoreParams(ssrmParams, parentNode);
        return new $5b7ccabde48fae90$var$LazyStore(ssrmParams, storeParams, parentNode);
    }
    getStoreParams(ssrmParams, parentNode) {
        const userStoreParams = this.getLevelSpecificParams(parentNode);
        const cacheBlockSize = this.getBlockSize(userStoreParams);
        const maxBlocksInCache = this.getMaxBlocksInCache(ssrmParams, userStoreParams);
        const storeParams = {
            cacheBlockSize: cacheBlockSize,
            maxBlocksInCache: maxBlocksInCache
        };
        return storeParams;
    }
    getMaxBlocksInCache(ssrmParams, userStoreParams) {
        const maxBlocksInCache = userStoreParams && userStoreParams.maxBlocksInCache != null ? userStoreParams.maxBlocksInCache : this.gos.get("maxBlocksInCache");
        const maxBlocksActive = maxBlocksInCache != null && maxBlocksInCache >= 0;
        if (!maxBlocksActive) return;
        if (ssrmParams.dynamicRowHeight) {
            (0, $jIDNV._warn)(203);
            return;
        }
        if (this.rowAutoHeight?.active) {
            (0, $jIDNV._warn)(204);
            return void 0;
        }
        return maxBlocksInCache;
    }
    getBlockSize(userStoreParams) {
        const blockSize = userStoreParams && userStoreParams.cacheBlockSize != null ? userStoreParams.cacheBlockSize : this.gos.get("cacheBlockSize");
        if (blockSize != null && blockSize > 0) return blockSize;
        else return 100;
    }
    getLevelSpecificParams(parentNode) {
        const callback = this.gos.getCallback("getServerSideGroupLevelParams");
        if (!callback) return void 0;
        const params = {
            level: parentNode.level + 1,
            parentRowNode: parentNode.level >= 0 ? parentNode : void 0,
            rowGroupColumns: this.rowGroupColsSvc?.columns ?? [],
            pivotColumns: this.pivotColsSvc?.columns ?? [],
            pivotMode: this.colModel.isPivotMode()
        };
        const res = callback(params);
        return res;
    }
};
var $5b7ccabde48fae90$var$StoreUtils = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmStoreUtils";
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.serverSideRowModel = beans.rowModel;
        this.storeFactory = beans.ssrmStoreFactory;
    }
    getChildStore(keys, currentCache, findNodeFunc) {
        if (!keys?.length) return currentCache;
        const nextKey = keys[0];
        const nextNode = findNodeFunc(nextKey);
        if (nextNode) {
            if (keys.length === 1 && !nextNode.childStore) {
                const storeParams = this.serverSideRowModel.getParams();
                nextNode.childStore = this.createBean(this.storeFactory.createStore(storeParams, nextNode));
            }
            const keyListForNextLevel = keys.slice(1, keys.length);
            const nextStore = nextNode.childStore;
            return nextStore ? nextStore.getChildStore(keyListForNextLevel) : null;
        }
        return null;
    }
    isServerRefreshNeeded(parentRowNode, rowGroupCols, params) {
        if (params.valueColChanged || params.secondaryColChanged) return true;
        const level = parentRowNode.level + 1;
        const grouping = level < rowGroupCols.length;
        const leafNodes = !grouping;
        if (leafNodes) return true;
        const colIdThisGroup = rowGroupCols[level].id;
        const actionOnThisGroup = params.changedColumns.indexOf(colIdThisGroup) > -1;
        if (actionOnThisGroup) return true;
        const allCols = this.colModel.getCols();
        const affectedGroupCols = allCols.filter((col)=>col.getColDef().showRowGroup && params.changedColumns.includes(col.getId())).map((col)=>col.getColDef().showRowGroup).some((group)=>group === true || group === colIdThisGroup);
        return affectedGroupCols;
    }
    getServerSideInitialRowCount() {
        return this.gos.get("serverSideInitialRowCount");
    }
    isServerSideSortAllLevels() {
        return this.gos.get("serverSideSortAllLevels") && (0, $jIDNV._isServerSideRowModel)(this.gos);
    }
    isServerSideOnlyRefreshFilteredGroups() {
        return this.gos.get("serverSideOnlyRefreshFilteredGroups") && (0, $jIDNV._isServerSideRowModel)(this.gos);
    }
};
var $5b7ccabde48fae90$var$TransactionManager = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmTxnManager";
        this.asyncTransactions = [];
    }
    wireBeans(beans) {
        this.valueCache = beans.valueCache;
        this.serverSideRowModel = beans.rowModel;
        this.selectionSvc = beans.selectionSvc;
    }
    postConstruct() {
        if (!(0, $jIDNV._isServerSideRowModel)(this.gos)) return;
    }
    applyTransactionAsync(transaction, callback) {
        if (this.asyncTransactionsTimeout == null) this.scheduleExecuteAsync();
        this.asyncTransactions.push({
            transaction: transaction,
            callback: callback
        });
    }
    scheduleExecuteAsync() {
        const waitMillis = this.gos.get("asyncTransactionWaitMillis");
        this.asyncTransactionsTimeout = window.setTimeout(()=>{
            this.executeAsyncTransactions();
        }, waitMillis);
    }
    executeAsyncTransactions() {
        if (!this.asyncTransactions) return;
        const resultFuncs = [];
        const resultsForEvent = [];
        const transactionsToRetry = [];
        let atLeastOneTransactionApplied = false;
        this.asyncTransactions.forEach((txWrapper)=>{
            let result;
            const hasStarted = this.serverSideRowModel.executeOnStore(txWrapper.transaction.route, (cache)=>{
                result = cache.applyTransaction(txWrapper.transaction);
            });
            if (!hasStarted) result = {
                status: (0, $jIDNV.ServerSideTransactionResultStatus).StoreNotStarted
            };
            else if (result == void 0) result = {
                status: (0, $jIDNV.ServerSideTransactionResultStatus).StoreNotFound
            };
            resultsForEvent.push(result);
            const retryTransaction = result.status == (0, $jIDNV.ServerSideTransactionResultStatus).StoreLoading;
            if (retryTransaction) {
                transactionsToRetry.push(txWrapper);
                return;
            }
            if (txWrapper.callback) resultFuncs.push(()=>txWrapper.callback(result));
            if (result.status === (0, $jIDNV.ServerSideTransactionResultStatus).Applied) atLeastOneTransactionApplied = true;
        });
        if (resultFuncs.length > 0) window.setTimeout(()=>{
            resultFuncs.forEach((func)=>func());
        }, 0);
        this.asyncTransactionsTimeout = void 0;
        this.asyncTransactions = transactionsToRetry;
        if (atLeastOneTransactionApplied) {
            this.valueCache?.onDataChanged();
            this.eventSvc.dispatchEvent({
                type: "storeUpdated"
            });
        }
        if (resultsForEvent.length > 0) this.eventSvc.dispatchEvent({
            type: "asyncTransactionsFlushed",
            results: resultsForEvent
        });
    }
    flushAsyncTransactions() {
        if (this.asyncTransactionsTimeout != null) clearTimeout(this.asyncTransactionsTimeout);
        this.executeAsyncTransactions();
    }
    applyTransaction(transaction) {
        let res;
        const hasStarted = this.serverSideRowModel.executeOnStore(transaction.route, (store)=>{
            res = store.applyTransaction(transaction);
        });
        if (!hasStarted) return {
            status: (0, $jIDNV.ServerSideTransactionResultStatus).StoreNotStarted
        };
        else if (res) {
            this.valueCache?.onDataChanged();
            if (res.remove && this.selectionSvc) {
                const removedRowIds = res.remove.map((row)=>row.id);
                this.selectionSvc.deleteSelectionStateFromParent(transaction.route || [], removedRowIds);
            }
            this.eventSvc.dispatchEvent({
                type: "storeUpdated"
            });
            return res;
        } else return {
            status: (0, $jIDNV.ServerSideTransactionResultStatus).StoreNotFound
        };
    }
};
// packages/ag-grid-enterprise/src/serverSideRowModel/serverSideRowModelModule.ts
var $5b7ccabde48fae90$export$5c0e9f044c5e2dce = {
    moduleName: "ServerSideRowModel",
    version: $5b7ccabde48fae90$var$VERSION,
    rowModels: [
        "serverSide"
    ],
    beans: [
        $5b7ccabde48fae90$var$ServerSideRowModel,
        $5b7ccabde48fae90$var$ExpandListener,
        $5b7ccabde48fae90$var$StoreUtils,
        $5b7ccabde48fae90$var$BlockUtils,
        $5b7ccabde48fae90$var$NodeManager,
        $5b7ccabde48fae90$var$TransactionManager,
        $5b7ccabde48fae90$var$FilterListener,
        $5b7ccabde48fae90$var$StoreFactory,
        $5b7ccabde48fae90$var$ListenerUtils,
        $5b7ccabde48fae90$var$ServerSideSelectionService,
        $5b7ccabde48fae90$var$LazyBlockLoadingService,
        $5b7ccabde48fae90$var$SsrmRowChildrenService,
        $5b7ccabde48fae90$var$ServerSideExpansionService,
        $5b7ccabde48fae90$var$SortListener
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $jIDNV._SortModule),
        (0, $jIDNV._SharedRowSelectionModule),
        $5b7ccabde48fae90$var$SharedPivotModule,
        $5b7ccabde48fae90$var$SharedTreeDataModule,
        $5b7ccabde48fae90$var$LoadingCellRendererModule
    ]
};
var $5b7ccabde48fae90$export$208b04021c462957 = {
    moduleName: "ServerSideRowModelApi",
    version: $5b7ccabde48fae90$var$VERSION,
    apiFunctions: {
        getServerSideSelectionState: $5b7ccabde48fae90$var$getServerSideSelectionState,
        setServerSideSelectionState: $5b7ccabde48fae90$var$setServerSideSelectionState,
        applyServerSideTransaction: $5b7ccabde48fae90$var$applyServerSideTransaction,
        applyServerSideTransactionAsync: $5b7ccabde48fae90$var$applyServerSideTransactionAsync,
        applyServerSideRowData: $5b7ccabde48fae90$var$applyServerSideRowData,
        retryServerSideLoads: $5b7ccabde48fae90$var$retryServerSideLoads,
        flushServerSideAsyncTransactions: $5b7ccabde48fae90$var$flushServerSideAsyncTransactions,
        refreshServerSide: $5b7ccabde48fae90$var$refreshServerSide,
        getServerSideGroupLevelState: $5b7ccabde48fae90$var$getServerSideGroupLevelState
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $jIDNV._CsrmSsrmSharedApiModule),
        (0, $jIDNV._SsrmInfiniteSharedApiModule)
    ]
};
// packages/ag-grid-enterprise/src/sparkline/sparkline.css-GENERATED.ts
var $5b7ccabde48fae90$var$sparklineCSS = /*css*/ `.ag-sparkline-wrapper{height:100%;line-height:normal;position:absolute;top:0;width:100%}`;
// packages/ag-grid-enterprise/src/sparkline/sparklinesUtils.ts
var $5b7ccabde48fae90$var$WrappedFunctionMarker = Symbol("WrappedFunctionMarker");
var $5b7ccabde48fae90$var$wrapFn = (fn, wrapperFn)=>{
    if (fn[$5b7ccabde48fae90$var$WrappedFunctionMarker]) return fn;
    const wrapped = (...args)=>wrapperFn(fn, ...args);
    wrapped[$5b7ccabde48fae90$var$WrappedFunctionMarker] = $5b7ccabde48fae90$var$WrappedFunctionMarker;
    return wrapped;
};
// packages/ag-grid-enterprise/src/sparkline/sparklineCellRenderer.ts
function $5b7ccabde48fae90$var$tooltipRendererWithXValue(params) {
    return {
        content: `${params.xValue} ${params.yValue}`
    };
}
function $5b7ccabde48fae90$var$tooltipRenderer(params) {
    return {
        content: `${params.yValue}`
    };
}
var $5b7ccabde48fae90$var$SparklineCellRenderer = class extends (0, $jIDNV.Component) {
    constructor(){
        super({
            tag: "div",
            cls: "ag-sparkline-wrapper",
            children: [
                {
                    tag: "span",
                    ref: "eSparkline"
                }
            ]
        });
        this.eSparkline = (0, $jIDNV.RefPlaceholder);
        this.cachedWidth = 0;
        this.cachedHeight = 0;
        this.dataRef = [];
        this.processedData = [];
    }
    postConstruct() {
        this.env = this.beans.environment;
        this.addManagedPropertyListeners([
            "chartThemeOverrides",
            "chartThemes",
            "styleNonce"
        ], ()=>this.refresh(this.params));
    }
    createListener(batch = true) {
        return ()=>this.updateSize(this.params?.column?.getActualWidth() ?? 0, (this.params?.node.rowHeight ?? 0) - 2, batch);
    }
    initGridObserver() {
        const batchListener = this.createListener();
        const listener = this.createListener(false);
        const column = this.params?.column;
        const rowNode = this.params?.node;
        column.__addEventListener("columnStateUpdated", batchListener);
        rowNode.__addEventListener("heightChanged", batchListener);
        this.addDestroyFunc(()=>{
            column.__removeEventListener("columnStateUpdated", batchListener);
            rowNode.__removeEventListener("heightChanged", batchListener);
        });
        listener();
    }
    updateSize(newWidth, newHeight, batch = true) {
        newWidth -= this.env.getCellPadding();
        if (newWidth !== this.cachedWidth || newHeight !== this.cachedHeight) {
            this.cachedWidth = newWidth;
            this.cachedHeight = newHeight;
            const refresh = this.refresh.bind(this);
            if (batch) (0, $jIDNV._batchCall)(()=>this.isAlive() && refresh());
            else refresh();
        }
    }
    init(params) {
        this.params = params;
        this.initGridObserver();
    }
    refresh(params = this.params) {
        var _a;
        this.params = params;
        const width = this.cachedWidth;
        const height = this.cachedHeight;
        const styleNonce = this.gos.get("styleNonce");
        if (!this.sparklineInstance && params && width > 0 && height > 0) {
            this.sparklineOptions = {
                container: this.eSparkline,
                width: width,
                height: height,
                ...params.sparklineOptions,
                ...styleNonce ? {
                    styleNonce: styleNonce
                } : {},
                data: this.processData(params.value)
            };
            (_a = this.sparklineOptions).type ?? (_a.type = "line");
            if (this.sparklineOptions.tooltip?.renderer) this.wrapTooltipRenderer();
            else {
                const renderer = this.getDefaultTooltipRenderer();
                this.sparklineOptions.tooltip = {
                    ...this.sparklineOptions.tooltip,
                    renderer: renderer
                };
            }
            const theme = this.sparklineOptions?.theme;
            if (this.sparklineOptions.type === "bar" && this.sparklineOptions.itemStyler) this.wrapItemStyler(this.sparklineOptions);
            else if (theme?.overrides?.bar?.series?.itemStyler) this.wrapItemStyler(theme.overrides.bar.series);
            this.sparklineInstance = params.createSparkline(this.sparklineOptions);
            return true;
        } else if (this.sparklineInstance) {
            this.sparklineInstance.update({
                ...this.sparklineOptions,
                data: this.processData(params?.value),
                width: width,
                height: height,
                ...styleNonce ? {
                    styleNonce: styleNonce
                } : {}
            });
            return true;
        }
        return false;
    }
    processData(data = []) {
        if (data.length === 0) return data;
        if (this.dataRef !== data) {
            this.dataRef = data;
            this.processedData = Array.isArray(data[0]) ? data.filter((item)=>item != null) : data;
        }
        return this.processedData;
    }
    createContext() {
        return {
            data: this.params?.data,
            cellData: this.params?.value
        };
    }
    getDefaultTooltipRenderer(userRendererResult) {
        const userTitle = userRendererResult?.title;
        const xKeyProvided = this.sparklineOptions.xKey;
        const tupleData = Array.isArray(this.sparklineOptions.data?.[0]);
        const showXValue = !userTitle && (xKeyProvided || tupleData);
        return showXValue ? $5b7ccabde48fae90$var$tooltipRendererWithXValue : $5b7ccabde48fae90$var$tooltipRenderer;
    }
    wrapItemStyler(container) {
        container.itemStyler = $5b7ccabde48fae90$var$wrapFn(container.itemStyler, (fn, stylerParams)=>{
            return fn({
                ...stylerParams,
                context: this.createContext()
            });
        });
    }
    wrapTooltipRenderer() {
        this.sparklineOptions.tooltip = {
            ...this.sparklineOptions.tooltip,
            renderer: $5b7ccabde48fae90$var$wrapFn(this.sparklineOptions.tooltip.renderer, (fn, tooltipParams)=>{
                const userRendererResult = fn({
                    ...tooltipParams,
                    context: this.createContext()
                });
                if (typeof userRendererResult === "string") return userRendererResult;
                return {
                    ...this.getDefaultTooltipRenderer(userRendererResult)(tooltipParams),
                    ...userRendererResult
                };
            })
        };
    }
    destroy() {
        super.destroy();
        this.sparklineInstance?.destroy();
    }
};
// packages/ag-grid-enterprise/src/sparkline/sparklinesModule.ts
var $5b7ccabde48fae90$var$moduleName = "Sparklines";
var $5b7ccabde48fae90$export$4e5a2f3bfb2b8795 = {
    moduleName: $5b7ccabde48fae90$var$moduleName,
    version: $5b7ccabde48fae90$var$VERSION,
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule
    ],
    validate: ()=>{
        return {
            isValid: false,
            message: (0, $jIDNV._preInitErrMsg)(258)
        };
    },
    with: (params)=>{
        params.setup();
        return {
            moduleName: $5b7ccabde48fae90$var$moduleName,
            version: $5b7ccabde48fae90$var$VERSION,
            dependsOn: [
                $5b7ccabde48fae90$var$EnterpriseCoreModule
            ],
            css: [
                $5b7ccabde48fae90$var$sparklineCSS
            ],
            userComponents: {
                agSparklineCellRenderer: {
                    classImp: $5b7ccabde48fae90$var$SparklineCellRenderer,
                    /** Default params for provided components */ params: {
                        createSparkline: params.createSparkline
                    }
                }
            },
            validate: ()=>{
                return {
                    isValid: true
                };
            }
        };
    }
};
// packages/ag-grid-enterprise/src/find/find.css-GENERATED.ts
var $5b7ccabde48fae90$var$findCSS = /*css*/ `.ag-find-cell{display:block;overflow:hidden;text-overflow:ellipsis}.ag-find-match{background-color:var(--ag-find-match-background-color);color:var(--ag-find-match-color)}.ag-find-active-match{background-color:var(--ag-find-active-match-background-color);color:var(--ag-find-active-match-color)}`;
// packages/ag-grid-enterprise/src/find/findApi.ts
function $5b7ccabde48fae90$var$findNext(beans) {
    beans.findSvc?.next();
}
function $5b7ccabde48fae90$var$findPrevious(beans) {
    beans.findSvc?.previous();
}
function $5b7ccabde48fae90$var$findGetTotalMatches(beans) {
    return beans.findSvc?.totalMatches ?? 0;
}
function $5b7ccabde48fae90$var$findGoTo(beans, match, force) {
    beans.findSvc?.goTo(match, force);
}
function $5b7ccabde48fae90$var$findClearActive(beans) {
    beans.findSvc?.clearActive();
}
function $5b7ccabde48fae90$var$findGetActiveMatch(beans) {
    return beans.findSvc?.activeMatch;
}
function $5b7ccabde48fae90$var$findGetNumMatches(beans, params) {
    const { node: node, column: column } = params;
    return beans.findSvc?.getNumMatches(node, column) ?? 0;
}
function $5b7ccabde48fae90$var$findGetParts(beans, params) {
    return beans.findSvc?.getParts(params) ?? [];
}
function $5b7ccabde48fae90$var$findRefresh(beans) {
    return beans.findSvc?.refresh(true);
}
var $5b7ccabde48fae90$var$FindCellRendererElement = {
    tag: "span",
    cls: "ag-find-cell"
};
var $5b7ccabde48fae90$var$FindCellRenderer = class extends (0, $jIDNV.Component) {
    constructor(){
        super($5b7ccabde48fae90$var$FindCellRendererElement);
    }
    init(params) {
        this.refresh(params);
    }
    refresh(params) {
        const { node: node, column: column } = params;
        const { findSvc: findSvc, valueSvc: valueSvc } = this.beans;
        const { value: value, valueFormatted: valueFormatted } = valueSvc.getValueForDisplay(column, node, true);
        const displayValue = valueFormatted ?? value ?? "";
        const eGui = this.getGui();
        (0, $jIDNV._clearElement)(eGui);
        const parts = findSvc?.getParts({
            value: displayValue,
            node: node,
            column: column ?? null
        });
        if (!parts) {
            eGui.textContent = (0, $jIDNV._toString)(displayValue) ?? "";
            eGui.classList.remove("ag-find-cell-active-match");
            return true;
        }
        let hasActiveMatch = false;
        for (const { value: value2, match: match, activeMatch: activeMatch } of parts){
            const content = (0, $jIDNV._toString)(value2) ?? "";
            if (match) {
                const element = (0, $jIDNV._createElement)({
                    tag: "mark",
                    cls: "ag-find-match"
                });
                element.textContent = content;
                if (activeMatch) {
                    element.classList.add("ag-find-active-match");
                    hasActiveMatch = true;
                }
                eGui.appendChild(element);
            } else eGui.appendChild(document.createTextNode(content));
        }
        eGui.classList.toggle("ag-find-cell-active-match", hasActiveMatch);
        return true;
    }
};
function $5b7ccabde48fae90$var$defaultCaseFormat(value) {
    return value?.toLocaleLowerCase();
}
function $5b7ccabde48fae90$var$getMatchesForValue(findSearchValue, caseFormat, valueToFind) {
    const finalValue = caseFormat((0, $jIDNV._toString)(valueToFind));
    let numMatches = 0;
    if (finalValue?.length) {
        let index = -1;
        while(true){
            index = finalValue.indexOf(findSearchValue, index + 1);
            if (index != -1) numMatches++;
            else break;
        }
    }
    return numMatches;
}
var $5b7ccabde48fae90$var$FindService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "findSvc";
        /**
     * Is find currently active (e.g. non-empty search value).
     * Used for performance when checking matches (part of cell rendering)
     */ this.active = false;
        /** pinned top matches */ this.topMatches = /* @__PURE__ */ new Map();
        /** same nodes as keys in `topMatches`, but kept separate for performance when moving backwards and forwards through the matches */ this.topNodes = [];
        /** total number of matches in pinned top */ this.topNumMatches = 0;
        this.centerMatches = /* @__PURE__ */ new Map();
        this.centerNodes = [];
        this.centerNumMatches = 0;
        this.bottomMatches = /* @__PURE__ */ new Map();
        this.bottomNodes = [];
        /** switches based on grid options */ this.caseFormat = $5b7ccabde48fae90$var$defaultCaseFormat;
        /** whether to scroll to active match after a refresh */ this.scrollOnRefresh = false;
        this.totalMatches = 0;
    }
    postConstruct() {
        if (!(0, $jIDNV._isClientSideRowModel)(this.gos)) return;
        const refreshAndWipeActive = this.refresh.bind(this, false);
        const refreshAndKeepActive = this.refresh.bind(this, true);
        const refreshAndKeepActiveDebounced = (0, $jIDNV._debounce)(this, ()=>{
            if (this.isAlive()) refreshAndKeepActive();
        }, 0);
        this.refreshDebounced = refreshAndKeepActiveDebounced;
        this.addManagedPropertyListener("findSearchValue", refreshAndWipeActive);
        this.addManagedPropertyListener("findOptions", ({ currentValue: currentValue, previousValue: previousValue })=>{
            if (!(0, $jIDNV._jsonEquals)(currentValue, previousValue)) refreshAndWipeActive();
        });
        this.addManagedPropertyListeners([
            "groupSuppressBlankHeader",
            "showOpenedGroup"
        ], refreshAndKeepActive);
        this.addManagedEventListeners({
            modelUpdated: refreshAndKeepActive,
            displayedColumnsChanged: refreshAndKeepActive,
            pinnedRowDataChanged: refreshAndKeepActive,
            cellValueChanged: refreshAndKeepActiveDebounced,
            rowNodeDataChanged: refreshAndKeepActiveDebounced
        });
        const rowSpanSvc = this.beans.rowSpanSvc;
        if (rowSpanSvc) this.addManagedListeners(rowSpanSvc, {
            spannedCellsUpdated: refreshAndKeepActiveDebounced
        });
        refreshAndWipeActive();
    }
    next() {
        this.findAcrossContainers(false, [
            "top",
            null,
            "bottom"
        ], 1, 1);
    }
    previous() {
        this.findAcrossContainers(true, [
            "bottom",
            null,
            "top"
        ], this.totalMatches, -1);
    }
    goTo(match, force) {
        if (!force && match === this.activeMatch?.numOverall) return;
        const { topMatches: topMatches, topNumMatches: topNumMatches, centerMatches: centerMatches, centerNumMatches: centerNumMatches, bottomMatches: bottomMatches } = this;
        if (match <= topNumMatches) {
            this.goToInContainer(topMatches, match, 0);
            return;
        }
        if (match <= centerNumMatches) {
            this.goToInContainer(centerMatches, match, topNumMatches);
            return;
        }
        this.goToInContainer(bottomMatches, match, topNumMatches + centerNumMatches);
    }
    clearActive() {
        if (this.activeMatch) this.setActive(void 0);
    }
    // called by cell ctrl, so needs to be performant
    isMatch(node, column) {
        return this.active && !!this.getMatches(node.rowPinned).get(node)?.some(([colToCheck])=>colToCheck === column);
    }
    getNumMatches(node, column) {
        return this.getMatches(node.rowPinned).get(node)?.find(([colToCheck])=>colToCheck === column)?.[1] ?? 0;
    }
    /**
   * Get detail for cell renderer. Splits up the cell value into strings depending on
   * whether they don't match, match, or are the active match
   */ getParts(params) {
        const { value: value, node: node, column: column, precedingNumMatches: precedingNumMatches } = params;
        const findSearchValue = this.findSearchValue;
        const stringValue = (0, $jIDNV._toString)(value) ?? "";
        if ((0, $jIDNV._missing)(findSearchValue)) return [
            {
                value: stringValue
            }
        ];
        const valueToFind = this.caseFormat(stringValue) ?? "";
        const activeMatchNum = this.getActiveMatchNum(node, column) - (precedingNumMatches ?? 0);
        let lastIndex = 0;
        let currentMatchNum = 0;
        const findTextLength = findSearchValue.length;
        const parts = [];
        while(true){
            const index = valueToFind.indexOf(findSearchValue, lastIndex);
            if (index != -1) {
                currentMatchNum++;
                if (index > lastIndex) parts.push({
                    value: stringValue.slice(lastIndex, index)
                });
                const endIndex = index + findTextLength;
                parts.push({
                    value: stringValue.slice(index, endIndex),
                    match: true,
                    activeMatch: currentMatchNum === activeMatchNum
                });
                lastIndex = endIndex;
            } else {
                if (lastIndex < stringValue.length) parts.push({
                    value: stringValue.slice(lastIndex)
                });
                return parts;
            }
        }
    }
    // when a detail grid is created, we need to sync the matches
    registerDetailGrid(node, api) {
        const gos = this.gos;
        if (!(0, $jIDNV._isClientSideRowModel)(gos)) return;
        const isSearchDetail = ()=>gos.get("findOptions")?.searchDetail;
        const compareMatchesAndRefresh = (newNumMatches)=>{
            const nodeMatch = this.centerMatches.get(node)?.[0];
            const oldNumMatches = nodeMatch?.[1] ?? 0;
            if (newNumMatches !== oldNumMatches) this.refreshDebounced();
        };
        api.addEventListener("findChanged", (event)=>{
            if (api.isDestroyed() || !this.isAlive() || !this.active || !isSearchDetail()) return;
            compareMatchesAndRefresh(event.totalMatches);
        });
        api.addEventListener("gridPreDestroyed", ()=>{
            if (!this.isAlive() || !this.active || !isSearchDetail()) return;
            const masterNode = node.parent;
            const findSearchValue = this.findSearchValue;
            if (!masterNode || !findSearchValue) return;
            const numMatches = gos.get("detailCellRendererParams")?.getFindMatches?.({
                node: masterNode,
                data: masterNode.data,
                findSearchValue: gos.get("findSearchValue"),
                updateMatches: this.refreshDebounced,
                getMatchesForValue: (value)=>$5b7ccabde48fae90$var$getMatchesForValue(findSearchValue, this.caseFormat, value)
            }) ?? 0;
            compareMatchesAndRefresh(numMatches);
        });
        if (isSearchDetail()) api.setGridOption("findSearchValue", gos.get("findSearchValue"));
    }
    // updates all the matches
    refresh(maintainActive) {
        const rowNodesToRefresh = /* @__PURE__ */ new Set([
            ...this.topNodes,
            ...this.centerNodes,
            ...this.bottomNodes
        ]);
        this.topNodes = [];
        this.centerNodes = [];
        this.bottomNodes = [];
        const { topNodes: topNodes, topMatches: topMatches, centerMatches: centerMatches, centerNodes: centerNodes, bottomNodes: bottomNodes, bottomMatches: bottomMatches, beans: { gos: gos, visibleCols: visibleCols, rowModel: rowModel, valueSvc: valueSvc, pinnedRowModel: pinnedRowModel, pagination: pagination, rowSpanSvc: rowSpanSvc, masterDetailSvc: masterDetailSvc, colModel: colModel }, findSearchValue: oldFindSearchValue } = this;
        const findOptions = gos.get("findOptions");
        const caseFormat = findOptions?.caseSensitive ? (value)=>value ?? void 0 : $5b7ccabde48fae90$var$defaultCaseFormat;
        this.caseFormat = caseFormat;
        const providedFindSearchValue = gos.get("findSearchValue");
        const findSearchValue = caseFormat(providedFindSearchValue?.trim());
        this.findSearchValue = findSearchValue;
        topMatches.clear();
        centerMatches.clear();
        bottomMatches.clear();
        const oldActiveMatch = maintainActive ? this.activeMatch : void 0;
        this.activeMatch = void 0;
        const checkMasterDetail = gos.get("masterDetail") && findOptions?.searchDetail && masterDetailSvc;
        if ((0, $jIDNV._missing)(findSearchValue)) {
            this.active = false;
            this.topNumMatches = 0;
            this.centerNumMatches = 0;
            this.totalMatches = 0;
            this.refreshRows(rowNodesToRefresh);
            if (checkMasterDetail) {
                const store = masterDetailSvc.store;
                for (const detailId of Object.keys(store))store[detailId]?.api?.findClearActive();
            }
            if (!(0, $jIDNV._missing)(oldFindSearchValue)) this.dispatchFindChanged();
            return;
        }
        const allCols = visibleCols.allCols;
        const isFullWidthCellFunc = gos.getCallback("isFullWidthRow");
        const detailCellRendererParams = gos.get("detailCellRendererParams");
        const fullWidthCellRendererParams = gos.get("fullWidthCellRendererParams");
        const groupRowRendererParams = gos.get("groupRowRendererParams");
        const flattenDetails = $5b7ccabde48fae90$var$_getFlattenDetails(gos);
        const pivotMode = colModel.isPivotMode();
        let containerNumMatches = 0;
        let matches;
        let rowNodes;
        let checkCurrentPage = false;
        const addMatches = (node, column, numMatches, skipRefresh)=>{
            if (!numMatches) return;
            let rowMatches = matches.get(node);
            if (!rowMatches) {
                rowMatches = [];
                matches.set(node, rowMatches);
                rowNodes.push(node);
                if (!skipRefresh) rowNodesToRefresh.add(node);
            }
            rowMatches.push([
                column,
                numMatches
            ]);
            containerNumMatches += numMatches;
        };
        const findMatchesForRow = (node)=>{
            if (checkCurrentPage) {
                let rowIndex = node.rowIndex;
                let nodeToCheck = node.parent;
                while(rowIndex == null && nodeToCheck){
                    rowIndex = nodeToCheck.rowIndex;
                    nodeToCheck = nodeToCheck.parent;
                }
                if (rowIndex == null || !pagination.isRowInPage(rowIndex)) return;
            }
            const isParent = node.hasChildren();
            if (!$5b7ccabde48fae90$var$_shouldRowBeRendered(flattenDetails, node, isParent, pivotMode, $5b7ccabde48fae90$var$_isRemovedSingleChildrenGroup(flattenDetails, node, isParent), $5b7ccabde48fae90$var$_isRemovedLowestSingleChildrenGroup(flattenDetails, node, isParent))) return;
            const data = node.data;
            if (isFullWidthCellFunc?.({
                rowNode: node
            })) {
                if (fullWidthCellRendererParams) {
                    const numMatches = fullWidthCellRendererParams.getFindMatches?.({
                        node: node,
                        data: data,
                        findSearchValue: providedFindSearchValue,
                        updateMatches: this.refreshDebounced,
                        getMatchesForValue: (value)=>$5b7ccabde48fae90$var$getMatchesForValue(findSearchValue, caseFormat, value)
                    }) ?? 0;
                    addMatches(node, null, numMatches);
                }
                return;
            }
            if ((0, $jIDNV._isFullWidthGroupRow)(gos, node, pivotMode)) {
                let valueToFind;
                const getFindText = groupRowRendererParams?.getFindText;
                if (getFindText) {
                    const value = valueSvc.getValueForDisplay(void 0, node).value;
                    valueToFind = getFindText((0, $jIDNV._addGridCommonParams)(gos, {
                        value: value,
                        node: node,
                        data: data,
                        column: null,
                        colDef: null,
                        getValueFormatted: ()=>{
                            const { valueFormatted: valueFormatted } = valueSvc.getValueForDisplay(void 0, node, true);
                            return valueFormatted;
                        }
                    }));
                } else {
                    const { value: value, valueFormatted: valueFormatted } = valueSvc.getValueForDisplay(void 0, node, true);
                    valueToFind = valueFormatted ?? value;
                }
                const numMatches = $5b7ccabde48fae90$var$getMatchesForValue(findSearchValue, caseFormat, valueToFind);
                addMatches(node, null, numMatches);
                return;
            }
            const nodeWillBeHiddenByOpenParent = node.level > 0 && gos.get("groupHideOpenParents") && node.parent?.getFirstChild() === node && !node.parent?.expanded;
            for (const column of allCols){
                if ((0, $jIDNV.isSpecialCol)(column)) continue;
                const cellSpan = rowSpanSvc?.getCellSpan(column, node);
                if (cellSpan && cellSpan.firstNode !== node) continue;
                if (column.colDef.showRowGroup && nodeWillBeHiddenByOpenParent) continue;
                let valueToFind;
                const colDef = column.colDef;
                const getFindText = colDef.getFindText;
                if (getFindText) {
                    const value = valueSvc.getValueForDisplay(column, node).value;
                    valueToFind = getFindText((0, $jIDNV._addGridCommonParams)(gos, {
                        value: value,
                        node: node,
                        data: data,
                        column: column,
                        colDef: colDef,
                        getValueFormatted: ()=>{
                            const { valueFormatted: valueFormatted } = valueSvc.getValueForDisplay(column, node, true);
                            return valueFormatted;
                        }
                    }));
                } else {
                    const { value: value, valueFormatted: valueFormatted } = valueSvc.getValueForDisplay(column, node, true);
                    valueToFind = valueFormatted ?? value;
                }
                const numMatches = $5b7ccabde48fae90$var$getMatchesForValue(findSearchValue, caseFormat, valueToFind);
                addMatches(node, column, numMatches);
            }
            if (node.master && checkMasterDetail) {
                const detailNode = node.detailNode;
                if (detailNode) {
                    const detailApi = detailNode.detailGridInfo?.api;
                    if (detailApi) {
                        detailApi.setGridOption("findSearchValue", providedFindSearchValue);
                        const numMatches = detailApi.findGetTotalMatches();
                        addMatches(detailNode, null, numMatches);
                        return;
                    }
                }
                if (detailCellRendererParams) {
                    const numMatches = detailCellRendererParams.getFindMatches?.({
                        node: node,
                        data: data,
                        findSearchValue: providedFindSearchValue,
                        updateMatches: this.refreshDebounced,
                        getMatchesForValue: (value)=>$5b7ccabde48fae90$var$getMatchesForValue(findSearchValue, caseFormat, value)
                    }) ?? 0;
                    addMatches(detailNode ?? {
                        parent: node,
                        dummy: true
                    }, null, numMatches, !detailNode);
                }
            }
        };
        matches = topMatches;
        rowNodes = topNodes;
        pinnedRowModel?.forEachPinnedRow("top", findMatchesForRow);
        this.topNumMatches = containerNumMatches;
        let totalMatches = containerNumMatches;
        matches = centerMatches;
        rowNodes = centerNodes;
        containerNumMatches = 0;
        checkCurrentPage = !!pagination && !!findOptions?.currentPageOnly;
        rowModel.forEachNodeAfterFilterAndSort(findMatchesForRow, true);
        this.centerNumMatches = containerNumMatches;
        totalMatches += containerNumMatches;
        matches = bottomMatches;
        rowNodes = bottomNodes;
        containerNumMatches = 0;
        checkCurrentPage = false;
        pinnedRowModel?.forEachPinnedRow("bottom", findMatchesForRow);
        totalMatches += containerNumMatches;
        this.totalMatches = totalMatches;
        this.active = true;
        this.refreshRows(rowNodesToRefresh);
        if (oldActiveMatch) this.resetActiveMatch(oldActiveMatch);
        this.dispatchFindChanged();
    }
    // update the active match back to what it was previously if possible. e.g. row index might have changed
    resetActiveMatch(oldActiveMatch) {
        const { column: column, numInMatch: numInMatch } = oldActiveMatch;
        let node = oldActiveMatch.node;
        if (node.dummy) {
            const detailNode = node.parent?.detailNode;
            if (!detailNode) return;
            node = detailNode;
        }
        const rowPinned = node.rowPinned ?? null;
        const stillValid = this.getMatches(rowPinned)?.get(node)?.some(([columnToCheck, numMatches])=>columnToCheck === column && numMatches >= numInMatch);
        if (!stillValid) return;
        let numOverall = 0;
        if (rowPinned == null) numOverall = this.topNumMatches;
        else if (rowPinned === "bottom") numOverall = this.topNumMatches + this.centerNumMatches;
        const updateNumInMatches = ()=>{
            const matches = this.getMatches(rowPinned);
            for (const nodeToCheck of matches.keys()){
                const matchingNode = nodeToCheck === node;
                const cols = matches.get(nodeToCheck);
                for (const [columnToCheck, numMatches] of cols){
                    if (matchingNode && columnToCheck === column) {
                        numOverall += numInMatch;
                        return;
                    }
                    numOverall += numMatches;
                }
            }
        };
        updateNumInMatches();
        const activeMatch = {
            ...oldActiveMatch,
            node: node,
            numOverall: numOverall
        };
        this.activeMatch = activeMatch;
        this.refreshRows(/* @__PURE__ */ new Set([
            node
        ]), column == null ? void 0 : /* @__PURE__ */ new Set([
            column
        ]));
        if (this.scrollOnRefresh) {
            this.scrollOnRefresh = false;
            this.scrollToActive(activeMatch);
        }
        this.setDetailActive(activeMatch);
    }
    refreshRows(rowNodes, columns) {
        if (!rowNodes.size) return;
        this.beans.rowRenderer.refreshCells({
            rowNodes: [
                ...rowNodes
            ],
            columns: columns ? [
                ...columns
            ] : void 0,
            force: true,
            suppressFlash: true
        });
    }
    // go to the next/previous match across all containers
    findAcrossContainers(backwards, containers, startNum, increment) {
        if (!this.totalMatches) {
            this.setActive();
            return;
        }
        const activeMatch = this.activeMatch;
        let containersToFind = containers;
        if (activeMatch) {
            const { column: column, node: node, numInMatch: numInMatch, numOverall: numOverall } = activeMatch;
            const rowPinned = node.rowPinned ?? null;
            const nextOverallNum = numOverall + increment;
            const matchInContainer = this.findInContainer(rowPinned, backwards, nextOverallNum, node, column, numInMatch);
            if (matchInContainer) return;
            const activeContainerIndex = containers.indexOf(rowPinned);
            const containerLength = containers.length;
            const containersAfter = containers.slice(activeContainerIndex + 1, containerLength);
            if (containersAfter.some((containerRowPinned)=>this.findInContainer(containerRowPinned, backwards, nextOverallNum))) return;
            containersToFind = containers.slice(0, activeContainerIndex + 1);
        }
        containersToFind.some((containerRowPinned)=>this.findInContainer(containerRowPinned, backwards, startNum));
    }
    // go to the next/previous match within a container
    findInContainer(rowPinned, backwards, nextOverallNum, currentNode, currentColumn, currentNumInMatch) {
        const matches = this.getMatches(rowPinned);
        const rowNodes = this.getRowNodes(rowPinned);
        const direction = backwards ? -1 : 1;
        if (currentNode != null) {
            const currentIndexRowMatches = matches.get(currentNode);
            const colArrayIndex = currentIndexRowMatches?.findIndex(([column])=>column === currentColumn);
            if (colArrayIndex != null && colArrayIndex != -1) {
                const [column, numMatches] = currentIndexRowMatches[colArrayIndex];
                if (backwards ? currentNumInMatch > 1 : currentNumInMatch < numMatches) {
                    this.setActive({
                        column: column,
                        node: currentNode,
                        numInMatch: currentNumInMatch + direction,
                        numOverall: nextOverallNum
                    });
                    return true;
                }
            }
            const nextMatch2 = colArrayIndex != null && colArrayIndex != -1 ? currentIndexRowMatches?.[colArrayIndex + direction] : void 0;
            if (nextMatch2) {
                const [column, numMatches] = nextMatch2;
                this.setActive({
                    column: column,
                    node: currentNode,
                    numInMatch: backwards ? numMatches : 1,
                    numOverall: nextOverallNum
                });
                return true;
            }
        }
        let nextNode;
        if (currentNode == null) nextNode = rowNodes[backwards ? rowNodes.length - 1 : 0];
        else {
            const rowArrayIndex = rowNodes.findIndex((node)=>node === currentNode);
            nextNode = rowNodes[rowArrayIndex + direction];
        }
        if (nextNode == null) return false;
        const nextIndexRowMatches = matches.get(nextNode);
        const nextMatch = nextIndexRowMatches?.[backwards ? nextIndexRowMatches.length - 1 : 0];
        if (nextMatch) {
            const [column, numMatches] = nextMatch;
            this.setActive({
                column: column,
                node: nextNode,
                numInMatch: backwards ? numMatches : 1,
                numOverall: nextOverallNum
            });
            return true;
        }
        return false;
    }
    dispatchFindChanged() {
        const { eventSvc: eventSvc, activeMatch: activeMatch, totalMatches: totalMatches, findSearchValue: findSearchValue } = this;
        eventSvc.dispatchEvent({
            type: "findChanged",
            activeMatch: activeMatch,
            totalMatches: totalMatches,
            findSearchValue: findSearchValue
        });
    }
    setActive(activeMatch) {
        if (activeMatch && activeMatch.node.rowIndex == null) {
            const node = activeMatch.node;
            let parent = node.footer ? node.sibling : node.parent;
            while(parent && parent.level !== -1){
                parent.expanded = true;
                parent = parent.parent;
            }
            this.activeMatch = activeMatch;
            this.scrollOnRefresh = true;
            this.beans.expansionSvc?.onGroupExpandedOrCollapsed();
            return;
        }
        const oldActiveMatch = this.activeMatch;
        this.activeMatch = activeMatch;
        this.refreshAndScrollToActive(activeMatch, oldActiveMatch);
        if (activeMatch) this.setDetailActive(activeMatch);
        this.dispatchFindChanged();
    }
    setDetailActive({ node: node, numInMatch: numInMatch }) {
        if (node.detail) node.detailGridInfo?.api?.findGoTo(numInMatch);
    }
    refreshAndScrollToActive(activeMatch, oldActiveMatch) {
        if (activeMatch || oldActiveMatch) {
            const nodes = /* @__PURE__ */ new Set();
            const columns = /* @__PURE__ */ new Set();
            let skipColumns = false;
            const addMatch = (match)=>{
                if (!match) return;
                const { node: node, column: column } = match;
                nodes.add(node);
                if (column == null) skipColumns = true;
                else columns.add(column);
            };
            addMatch(activeMatch);
            addMatch(oldActiveMatch);
            this.refreshRows(nodes, skipColumns ? void 0 : columns);
        }
        if (activeMatch) this.scrollToActive(activeMatch);
    }
    scrollToActive({ node: { rowPinned: rowPinned, rowIndex: rowIndex }, column: column }) {
        const { ctrlsSvc: ctrlsSvc, pagination: pagination, gos: gos } = this.beans;
        const scrollFeature = ctrlsSvc.getScrollFeature();
        if (rowPinned == null && rowIndex != null) {
            if (pagination && !gos.get("findOptions")?.currentPageOnly && !pagination.isRowInPage(rowIndex)) pagination.goToPageWithIndex(rowIndex);
            scrollFeature.ensureIndexVisible(rowIndex);
        }
        scrollFeature.ensureColumnVisible(column);
    }
    // search for the specified overall `match` number with the provided container, and set it to be active
    goToInContainer(matches, match, startNum) {
        let currentMatch = startNum;
        for (const node of matches.keys()){
            const cols = matches.get(node);
            for (const [column, numMatches] of cols){
                if (match <= currentMatch + numMatches) {
                    this.setActive({
                        column: column,
                        node: node,
                        numInMatch: match - currentMatch,
                        numOverall: match
                    });
                    return;
                }
                currentMatch += numMatches;
            }
        }
    }
    getMatches(rowPinned) {
        if (rowPinned === "top") return this.topMatches;
        else if (rowPinned === "bottom") return this.bottomMatches;
        else return this.centerMatches;
    }
    getRowNodes(rowPinned) {
        if (rowPinned === "top") return this.topNodes;
        else if (rowPinned === "bottom") return this.bottomNodes;
        else return this.centerNodes;
    }
    getActiveMatchNum(node, column) {
        const activeMatch = this.activeMatch;
        return activeMatch != null && activeMatch.node === node && activeMatch.column === column ? activeMatch.numInMatch : 0;
    }
    destroy() {
        this.topMatches.clear();
        this.topNodes.length = 0;
        this.centerMatches.clear();
        this.centerNodes.length = 0;
        this.bottomMatches.clear();
        this.bottomNodes.length = 0;
        this.activeMatch = void 0;
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/find/findModule.ts
var $5b7ccabde48fae90$var$FindCoreModule = {
    moduleName: "FindCore",
    version: $5b7ccabde48fae90$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $5b7ccabde48fae90$var$FindService
    ],
    userComponents: {
        agFindCellRenderer: $5b7ccabde48fae90$var$FindCellRenderer
    },
    css: [
        $5b7ccabde48fae90$var$findCSS
    ]
};
var $5b7ccabde48fae90$export$3b7f0581dcb7e440 = {
    moduleName: "Find",
    version: $5b7ccabde48fae90$var$VERSION,
    apiFunctions: {
        findGetTotalMatches: $5b7ccabde48fae90$var$findGetTotalMatches,
        findGoTo: $5b7ccabde48fae90$var$findGoTo,
        findNext: $5b7ccabde48fae90$var$findNext,
        findPrevious: $5b7ccabde48fae90$var$findPrevious,
        findGetActiveMatch: $5b7ccabde48fae90$var$findGetActiveMatch,
        findGetNumMatches: $5b7ccabde48fae90$var$findGetNumMatches,
        findGetParts: $5b7ccabde48fae90$var$findGetParts,
        findClearActive: $5b7ccabde48fae90$var$findClearActive,
        findRefresh: $5b7ccabde48fae90$var$findRefresh
    },
    dependsOn: [
        $5b7ccabde48fae90$var$FindCoreModule
    ]
};
function $5b7ccabde48fae90$var$startBatchEdit({ editSvc: editSvc, gos: gos, rowModel: rowModel }) {
    if (!editSvc?.isBatchEditing()) {
        if (!(0, $jIDNV._isClientSideRowModel)(gos, rowModel)) {
            (0, $jIDNV._warn)(289, {
                rowModelType: gos.get("rowModelType")
            });
            return;
        }
        editSvc?.setBatchEditing(true);
    }
}
function $5b7ccabde48fae90$var$cancelBatchEdit({ editSvc: editSvc }) {
    if (!editSvc?.isBatchEditing()) return;
    editSvc?.stopEditing(void 0, {
        cancel: true,
        source: "api"
    });
    editSvc?.setBatchEditing(false);
}
function $5b7ccabde48fae90$var$commitBatchEdit({ editSvc: editSvc }) {
    if (!editSvc?.isBatchEditing()) return;
    editSvc?.stopEditing(void 0, {
        source: "api"
    });
    editSvc?.setBatchEditing(false);
}
function $5b7ccabde48fae90$var$isBatchEditing(beans) {
    return beans.editSvc?.isBatchEditing() ?? false;
}
// packages/ag-grid-enterprise/src/batch-edit/batchEditModule.ts
var $5b7ccabde48fae90$export$3b8008724bbc4e9f = {
    moduleName: "BatchEdit",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [],
    apiFunctions: {
        isBatchEditing: $5b7ccabde48fae90$var$isBatchEditing,
        startBatchEdit: $5b7ccabde48fae90$var$startBatchEdit,
        cancelBatchEdit: $5b7ccabde48fae90$var$cancelBatchEdit,
        commitBatchEdit: $5b7ccabde48fae90$var$commitBatchEdit
    },
    dependsOn: [
        (0, $jIDNV._EditCoreModule),
        $5b7ccabde48fae90$var$EnterpriseCoreModule
    ],
    css: []
};
var $5b7ccabde48fae90$var$AgChartsExports = class extends (0, $jIDNV.BeanStub) {
    constructor(params){
        super();
        this.beanName = "agChartsExports";
        this.isEnterprise = false;
        this.create = params.create;
        this._Theme = params._Theme;
        this._Scene = params._Scene;
        this.isEnterprise = params.isEnterprise;
        this._Util = params._Util;
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/utils/integration.ts
function $5b7ccabde48fae90$var$deproxy(chartOrProxy) {
    if (chartOrProxy.chart != null) return chartOrProxy.chart;
    return chartOrProxy;
}
// packages/ag-grid-enterprise/src/charts/chartComp/utils/object.ts
var $5b7ccabde48fae90$var$SKIP_JS_BUILTINS = /* @__PURE__ */ new Set([
    "__proto__",
    "constructor",
    "prototype"
]);
function $5b7ccabde48fae90$var$get(source, expression, defaultValue) {
    if (source == null) return defaultValue;
    const keys = expression.split(".");
    let objectToRead = source;
    while(keys.length > 1){
        objectToRead = objectToRead[keys.shift()];
        if (objectToRead == null) return defaultValue;
    }
    const value = objectToRead[keys[0]];
    return value != null ? value : defaultValue;
}
function $5b7ccabde48fae90$var$set(target, expression, value) {
    if (target == null) return;
    const keys = expression.split(".");
    let objectToUpdate = target;
    keys.filter((key)=>!$5b7ccabde48fae90$var$SKIP_JS_BUILTINS.has(key)).forEach((key, i)=>{
        if (!objectToUpdate[key]) objectToUpdate[key] = {};
        if (i < keys.length - 1) objectToUpdate = objectToUpdate[key];
    });
    objectToUpdate[keys[keys.length - 1]] = value;
}
// packages/ag-grid-enterprise/src/charts/chartComp/utils/seriesTypeMapper.ts
var $5b7ccabde48fae90$var$CHART_TYPE_TO_SERIES_TYPE = {
    column: "bar",
    groupedColumn: "bar",
    stackedColumn: "bar",
    normalizedColumn: "bar",
    bar: "bar",
    groupedBar: "bar",
    stackedBar: "bar",
    normalizedBar: "bar",
    line: "line",
    stackedLine: "line",
    normalizedLine: "line",
    scatter: "scatter",
    bubble: "bubble",
    pie: "pie",
    donut: "donut",
    doughnut: "donut",
    area: "area",
    stackedArea: "area",
    normalizedArea: "area",
    histogram: "histogram",
    radarLine: "radar-line",
    radarArea: "radar-area",
    nightingale: "nightingale",
    radialColumn: "radial-column",
    radialBar: "radial-bar",
    sunburst: "sunburst",
    rangeBar: "range-bar",
    rangeArea: "range-area",
    boxPlot: "box-plot",
    treemap: "treemap",
    heatmap: "heatmap",
    waterfall: "waterfall",
    funnel: "funnel",
    coneFunnel: "cone-funnel",
    pyramid: "pyramid"
};
var $5b7ccabde48fae90$var$COMBO_CHART_TYPES = /* @__PURE__ */ new Set([
    "columnLineCombo",
    "areaColumnCombo",
    "customCombo"
]);
var $5b7ccabde48fae90$var$SERIES_GROUP_TYPES = [
    "grouped",
    "stacked",
    "normalized"
];
var $5b7ccabde48fae90$var$SERIES_TYPES = {
    area: {
        isCartesian: true,
        canInvert: true
    },
    bar: {
        isCartesian: true,
        canInvert: true
    },
    histogram: {
        isCartesian: true
    },
    line: {
        isCartesian: true,
        canInvert: true
    },
    pie: {
        isPie: true
    },
    donut: {
        isPie: true,
        canInvert: true
    },
    scatter: {
        isCartesian: true
    },
    bubble: {
        isCartesian: true
    },
    "radial-column": {
        isPolar: true,
        isEnterprise: true,
        isRadial: true,
        canInvert: true
    },
    "radial-bar": {
        isPolar: true,
        isEnterprise: true,
        isRadial: true,
        canInvert: true
    },
    "radar-line": {
        isPolar: true,
        isEnterprise: true,
        canInvert: true
    },
    "radar-area": {
        isPolar: true,
        isEnterprise: true,
        canInvert: true
    },
    nightingale: {
        isPolar: true,
        isEnterprise: true,
        canInvert: true
    },
    "range-bar": {
        isCartesian: true,
        isEnterprise: true,
        canSwitchDirection: true
    },
    "range-area": {
        isCartesian: true,
        isEnterprise: true
    },
    "box-plot": {
        isCartesian: true,
        isEnterprise: true,
        canSwitchDirection: true
    },
    treemap: {
        isEnterprise: true,
        isHierarchical: true
    },
    sunburst: {
        isEnterprise: true,
        isHierarchical: true
    },
    heatmap: {
        isCartesian: true,
        isEnterprise: true
    },
    waterfall: {
        isCartesian: true,
        isEnterprise: true,
        canSwitchDirection: true
    },
    funnel: {
        isCartesian: true,
        isEnterprise: true,
        canSwitchDirection: true
    },
    "cone-funnel": {
        isCartesian: true,
        isEnterprise: true,
        canSwitchDirection: true
    },
    pyramid: {
        isCartesian: true,
        isEnterprise: true,
        canSwitchDirection: true
    }
};
function $5b7ccabde48fae90$var$isSeriesType(seriesType) {
    return !!$5b7ccabde48fae90$var$SERIES_TYPES[seriesType];
}
function $5b7ccabde48fae90$var$isComboChart(chartType) {
    return $5b7ccabde48fae90$var$COMBO_CHART_TYPES.has(chartType);
}
function $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, prop) {
    return !!$5b7ccabde48fae90$var$SERIES_TYPES[seriesType]?.[prop];
}
function $5b7ccabde48fae90$var$isEnterpriseChartType(chartType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty($5b7ccabde48fae90$var$getSeriesType(chartType), "isEnterprise");
}
var $5b7ccabde48fae90$var$stackedChartTypes = /* @__PURE__ */ new Set([
    "stackedColumn",
    "normalizedColumn",
    "stackedBar",
    "normalizedBar"
]);
function $5b7ccabde48fae90$var$isStacked(chartType) {
    return $5b7ccabde48fae90$var$stackedChartTypes.has(chartType);
}
function $5b7ccabde48fae90$var$isCartesian(seriesType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, "isCartesian");
}
function $5b7ccabde48fae90$var$isFunnel(seriesType) {
    return seriesType === "funnel" || seriesType === "cone-funnel" || seriesType === "pyramid";
}
function $5b7ccabde48fae90$var$isPolar(seriesType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, "isPolar");
}
function $5b7ccabde48fae90$var$isRadial(seriesType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, "isRadial");
}
function $5b7ccabde48fae90$var$isHierarchical(seriesType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, "isHierarchical");
}
function $5b7ccabde48fae90$var$getCanonicalChartType(chartType) {
    return chartType === "doughnut" ? "donut" : chartType;
}
function $5b7ccabde48fae90$var$getSeriesTypeIfExists(chartType) {
    return $5b7ccabde48fae90$var$CHART_TYPE_TO_SERIES_TYPE[chartType];
}
function $5b7ccabde48fae90$var$getSeriesType(chartType) {
    return $5b7ccabde48fae90$var$getSeriesTypeIfExists(chartType) ?? "line";
}
function $5b7ccabde48fae90$var$isPieChartSeries(seriesType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, "isPie");
}
function $5b7ccabde48fae90$var$canOnlyHaveSingleSeries(chartType) {
    return chartType === "pie" || chartType === "waterfall" || chartType === "histogram" || chartType === "funnel" || chartType === "coneFunnel" || chartType === "pyramid";
}
function $5b7ccabde48fae90$var$getMaxNumCategories(chartType) {
    return $5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(chartType)) ? void 0 : 1;
}
function $5b7ccabde48fae90$var$getMaxNumSeries(chartType) {
    if ($5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(chartType))) return 2;
    else if ($5b7ccabde48fae90$var$canOnlyHaveSingleSeries(chartType)) return 1;
    else return void 0;
}
function $5b7ccabde48fae90$var$supportsInvertedCategorySeries(chartType) {
    return !$5b7ccabde48fae90$var$isComboChart(chartType) && $5b7ccabde48fae90$var$doesSeriesHaveProperty($5b7ccabde48fae90$var$getSeriesType(chartType), "canInvert");
}
function $5b7ccabde48fae90$var$canSwitchDirection(chartType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty($5b7ccabde48fae90$var$getSeriesType(chartType), "canSwitchDirection");
}
function $5b7ccabde48fae90$var$getFullChartNameTranslationKey(chartType) {
    switch(chartType){
        case "groupedColumn":
        case "stackedColumn":
        case "normalizedColumn":
        case "groupedBar":
        case "stackedBar":
        case "normalizedBar":
        case "stackedLine":
        case "normalizedLine":
        case "stackedArea":
        case "normalizedArea":
            return `${chartType}Full`;
        case "doughnut":
            return "donut";
        case "areaColumnCombo":
            return "AreaColumnCombo";
        default:
            return chartType;
    }
}
// packages/ag-grid-enterprise/src/charts/chartComp/utils/axisTypeMapper.ts
var $5b7ccabde48fae90$var$ALL_AXIS_TYPES = [
    "number",
    "category",
    "grouped-category",
    "log",
    "time"
];
function $5b7ccabde48fae90$var$getLegacyAxisType(chartType) {
    switch(chartType){
        case "bar":
        case "stackedBar":
        case "normalizedBar":
            return [
                "number",
                "category"
            ];
        case "groupedBar":
            return [
                "number",
                "grouped-category"
            ];
        case "column":
        case "stackedColumn":
        case "normalizedColumn":
        case "line":
        case "stackedLine":
        case "normalizedLine":
        case "area":
        case "stackedArea":
        case "normalizedArea":
        case "histogram":
            return [
                "category",
                "number"
            ];
        case "groupedColumn":
            return [
                "grouped-category",
                "number"
            ];
        case "scatter":
        case "bubble":
            return [
                "number",
                "number"
            ];
        default:
            return void 0;
    }
}
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/chartTheme.ts
function $5b7ccabde48fae90$var$createAgChartTheme(chartProxyParams, proxy, isEnterprise, chartThemeDefaults, updatedOverrides) {
    const { chartOptionsToRestore: chartOptionsToRestore, chartPaletteToRestore: chartPaletteToRestore, chartThemeToRestore: chartThemeToRestore, agChartsExports: agChartsExports } = chartProxyParams;
    const themeName = $5b7ccabde48fae90$var$getSelectedTheme(chartProxyParams);
    const stockTheme = $5b7ccabde48fae90$var$isStockTheme(themeName, agChartsExports._Theme);
    const rootTheme = stockTheme ? {
        baseTheme: themeName
    } : $5b7ccabde48fae90$var$lookupCustomChartTheme(chartProxyParams, themeName) ?? {};
    const gridOptionsThemeOverrides = chartProxyParams.getGridOptionsChartThemeOverrides();
    const apiThemeOverrides = chartProxyParams.apiChartThemeOverrides;
    const standaloneChartType = $5b7ccabde48fae90$var$getSeriesType(chartProxyParams.chartType);
    const crossFilteringOverrides = chartProxyParams.crossFiltering ? $5b7ccabde48fae90$var$createCrossFilterThemeOverrides(proxy, chartProxyParams, standaloneChartType) : void 0;
    const isTitleEnabled = ()=>{
        const isTitleEnabled2 = (obj)=>{
            if (!obj) return false;
            return Object.keys(obj).some((key)=>$5b7ccabde48fae90$var$get(obj[key], "title.enabled", false));
        };
        return isTitleEnabled2(gridOptionsThemeOverrides) || isTitleEnabled2(apiThemeOverrides);
    };
    const overrides = [
        stockTheme ? $5b7ccabde48fae90$var$inbuiltStockThemeOverrides(chartProxyParams, isEnterprise, isTitleEnabled()) : void 0,
        $5b7ccabde48fae90$var$pieAndDonutOverrides(),
        chartThemeDefaults,
        crossFilteringOverrides,
        gridOptionsThemeOverrides,
        apiThemeOverrides,
        {
            ...chartOptionsToRestore ?? {}
        },
        updatedOverrides
    ];
    const theme = overrides.filter((v)=>!!v).reduce((r, n)=>({
            baseTheme: r,
            overrides: n
        }), rootTheme);
    if (chartPaletteToRestore && themeName === chartThemeToRestore) {
        const rootThemePalette = chartProxyParams.agChartsExports._Theme.getChartTheme(rootTheme).palette;
        if (!$5b7ccabde48fae90$var$isIdenticalPalette(chartPaletteToRestore, rootThemePalette)) theme.palette = chartPaletteToRestore;
    }
    return theme;
}
function $5b7ccabde48fae90$var$isIdenticalPalette(paletteA, paletteB) {
    const arrayCompare = (arrA, arrB)=>{
        if (arrA === arrB) return true;
        if (arrA?.length !== arrB?.length) return false;
        return arrA?.every((v, i)=>v === arrB?.[i]) ?? false;
    };
    return arrayCompare(paletteA.fills, paletteB.fills) && arrayCompare(paletteA.strokes, paletteB.strokes);
}
function $5b7ccabde48fae90$var$isStockTheme(themeName, theme) {
    return Object.keys(theme.themes).includes(themeName);
}
function $5b7ccabde48fae90$var$createCrossFilterThemeOverrides(proxy, chartProxyParams, seriesType) {
    const legend = {
        listeners: {
            legendItemClick: (e)=>{
                const chart = proxy.getChart();
                const eligibleSeriesIds = [
                    e.seriesId,
                    `${e.seriesId}-filtered-out`
                ];
                chart.series.filter((s)=>eligibleSeriesIds.includes(s.id)).forEach((s)=>s.toggleSeriesItem(void 0, "category", e.itemId, void 0));
            }
        }
    };
    const common = {
        tooltip: {
            delay: 500
        },
        legend: legend,
        listeners: {
            click: (e)=>chartProxyParams.crossFilterCallback(e, true)
        }
    };
    if (seriesType === "pie" || seriesType === "donut") return {
        [seriesType]: {
            series: {
                fills: {
                    $if: [
                        {
                            $eq: [
                                {
                                    $value: "$index"
                                },
                                0
                            ]
                        },
                        {
                            $map: [
                                {
                                    $mix: [
                                        {
                                            $value: "$1"
                                        },
                                        {
                                            $ref: "backgroundColor"
                                        },
                                        0.7
                                    ]
                                },
                                {
                                    $palette: "fills"
                                }
                            ]
                        },
                        {
                            $palette: "fills"
                        }
                    ]
                },
                strokes: {
                    $if: [
                        {
                            $eq: [
                                {
                                    $value: "$index"
                                },
                                0
                            ]
                        },
                        {
                            $map: [
                                {
                                    $mix: [
                                        {
                                            $value: "$1"
                                        },
                                        {
                                            $ref: "backgroundColor"
                                        },
                                        0.7
                                    ]
                                },
                                {
                                    $palette: "strokes"
                                }
                            ]
                        },
                        {
                            $palette: "strokes"
                        }
                    ]
                }
            },
            ...common
        }
    };
    const fill = {};
    if (seriesType !== "line") fill.fill = {
        $if: [
            {
                $isEven: [
                    {
                        $value: "$index"
                    }
                ]
            },
            {
                $palette: "fill"
            },
            {
                $mix: [
                    {
                        $path: [
                            "../$prevIndex/fill",
                            {
                                $palette: "fill"
                            }
                        ]
                    },
                    {
                        $ref: "backgroundColor"
                    },
                    0.7
                ]
            }
        ]
    };
    return {
        [seriesType]: {
            series: {
                stroke: {
                    $if: [
                        {
                            $isEven: [
                                {
                                    $value: "$index"
                                }
                            ]
                        },
                        {
                            $palette: "stroke"
                        },
                        {
                            $mix: [
                                {
                                    $path: [
                                        "../$prevIndex/fill",
                                        {
                                            $palette: "stroke"
                                        }
                                    ]
                                },
                                {
                                    $ref: "backgroundColor"
                                },
                                0.7
                            ]
                        }
                    ]
                },
                ...fill
            },
            ...common
        }
    };
}
var $5b7ccabde48fae90$var$STATIC_INBUILT_STOCK_THEME_AXES_OVERRIDES = $5b7ccabde48fae90$var$ALL_AXIS_TYPES.reduce((r, n)=>({
        ...r,
        [n]: {
            title: {
                _enabledFromTheme: true
            }
        }
    }), {});
function $5b7ccabde48fae90$var$inbuiltStockThemeOverrides(params, isEnterprise, titleEnabled) {
    const extraPadding = params.getExtraPaddingDirections();
    return {
        common: {
            ...isEnterprise ? {
                animation: {
                    duration: 500
                }
            } : void 0,
            axes: $5b7ccabde48fae90$var$STATIC_INBUILT_STOCK_THEME_AXES_OVERRIDES,
            padding: {
                // don't add extra padding when a title is present!
                top: !titleEnabled && extraPadding.includes("top") ? 40 : 20,
                right: extraPadding.includes("right") ? 30 : 20,
                bottom: extraPadding.includes("bottom") ? 40 : 20,
                left: extraPadding.includes("left") ? 30 : 20
            }
        }
    };
}
function $5b7ccabde48fae90$var$pieAndDonutOverrides() {
    return {
        pie: {
            series: {
                title: {
                    _enabledFromTheme: true
                },
                calloutLabel: {
                    _enabledFromTheme: true
                },
                sectorLabel: {
                    enabled: false,
                    _enabledFromTheme: true
                }
            }
        },
        donut: {
            series: {
                title: {
                    _enabledFromTheme: true
                },
                calloutLabel: {
                    _enabledFromTheme: true
                },
                sectorLabel: {
                    enabled: false,
                    _enabledFromTheme: true
                }
            }
        }
    };
}
function $5b7ccabde48fae90$var$getSelectedTheme(chartProxyParams) {
    let chartThemeName = chartProxyParams.getChartThemeName();
    const availableThemes = chartProxyParams.getChartThemes();
    if (!availableThemes.includes(chartThemeName)) chartThemeName = availableThemes[0];
    return chartThemeName;
}
function $5b7ccabde48fae90$var$lookupCustomChartTheme(chartProxyParams, name) {
    const { customChartThemes: customChartThemes } = chartProxyParams;
    const customChartTheme = customChartThemes && customChartThemes[name];
    if (!customChartTheme) (0, $jIDNV._warn)(140, {
        name: name
    });
    return customChartTheme;
}
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/chartProxy.ts
var $5b7ccabde48fae90$var$ChartProxy = class {
    constructor(chartProxyParams){
        this.chartProxyParams = chartProxyParams;
        this.clearThemeOverrides = false;
        this.agChartsExports = chartProxyParams.agChartsExports;
        this.chart = chartProxyParams.chartInstance;
        this.chartType = chartProxyParams.chartType;
        this.crossFiltering = chartProxyParams.crossFiltering;
        this.crossFilterCallback = chartProxyParams.crossFilterCallback;
        this.standaloneChartType = $5b7ccabde48fae90$var$getSeriesType(this.chartType);
        if (this.chart == null) this.chart = chartProxyParams.agChartsExports.create(this.getCommonChartOptions());
        else this.clearThemeOverrides = true;
    }
    crossFilteringReset() {}
    update(params) {
        this.getChartRef().update(this.getUpdateOptions(params, this.getCommonChartOptions(params.updatedOverrides)));
    }
    updateThemeOverrides(themeOverrides) {
        this.getChartRef().updateDelta({
            theme: {
                overrides: themeOverrides
            }
        });
    }
    getChart() {
        return $5b7ccabde48fae90$var$deproxy(this.chart);
    }
    getChartRef() {
        return this.chart;
    }
    downloadChart(dimensions, fileName, fileFormat) {
        const { chart: chart } = this;
        const rawChart = $5b7ccabde48fae90$var$deproxy(chart);
        const imageFileName = fileName || rawChart.title.node.getPlainText();
        const { width: width, height: height } = dimensions || {};
        chart.download({
            width: width,
            height: height,
            fileName: imageFileName,
            fileFormat: fileFormat
        });
    }
    getChartImageDataURL(type) {
        return this.getChart().getCanvasDataURL(type);
    }
    getChartOptions() {
        return this.chart.getOptions();
    }
    getChartThemeOverrides() {
        const chartOptionsTheme = this.getChartOptions().theme;
        return chartOptionsTheme.overrides ?? {};
    }
    getChartPalette() {
        return this.agChartsExports._Theme.getChartTheme(this.getChartOptions().theme).palette;
    }
    setPaired(paired) {
        const seriesType = $5b7ccabde48fae90$var$getSeriesType(this.chartProxyParams.chartType);
        this.chart.updateDelta({
            theme: {
                overrides: {
                    [seriesType]: {
                        paired: paired
                    }
                }
            }
        });
    }
    isPaired() {
        const seriesType = $5b7ccabde48fae90$var$getSeriesType(this.chartProxyParams.chartType);
        return $5b7ccabde48fae90$var$get(this.getChartThemeOverrides(), `${seriesType}.paired`, true);
    }
    lookupCustomChartTheme(themeName) {
        return $5b7ccabde48fae90$var$lookupCustomChartTheme(this.chartProxyParams, themeName);
    }
    getSeriesGroupType() {
        return void 0;
    }
    transformCategoryData(data, categoryKey) {
        return data.map((d, index)=>{
            const value = d[categoryKey];
            const valueString = value && value.toString ? value.toString() : "";
            const datum = {
                ...d
            };
            datum[categoryKey] = {
                id: index,
                value: value,
                toString: ()=>valueString
            };
            return datum;
        });
    }
    getCommonChartOptions(updatedOverrides) {
        const existingOptions = this.clearThemeOverrides ? {} : this.chart?.getOptions() ?? {};
        const formattingPanelOverrides = this.chart != null ? this.getActiveFormattingPanelOverrides() : void 0;
        this.clearThemeOverrides = false;
        const styleNonce = this.chartProxyParams.styleNonce;
        const theme = $5b7ccabde48fae90$var$createAgChartTheme(this.chartProxyParams, this, this.agChartsExports.isEnterprise, this.getChartThemeDefaults(), updatedOverrides ?? formattingPanelOverrides);
        const newOptions = {
            ...existingOptions,
            mode: "integrated",
            ...styleNonce ? {
                styleNonce: styleNonce
            } : {}
        };
        if (this.chartProxyParams.suppressFieldDotNotation !== void 0) newOptions.suppressFieldDotNotation = this.chartProxyParams.suppressFieldDotNotation;
        newOptions.theme = theme;
        newOptions.container = this.chartProxyParams.parentElement;
        return newOptions;
    }
    getChartThemeDefaults() {
        const seriesOverrides = this.getSeriesChartThemeDefaults();
        const seriesChartOptions = seriesOverrides ? {
            [this.standaloneChartType]: seriesOverrides
        } : {};
        const crosshair = {
            enabled: true,
            snap: true,
            label: {
                enabled: false
            }
        };
        const common = this.agChartsExports.isEnterprise ? {
            zoom: {
                enabled: true
            },
            animation: {
                enabled: true,
                duration: 500
            },
            axes: {
                number: {
                    crosshair: crosshair
                },
                category: {
                    crosshair: crosshair
                },
                log: {
                    crosshair: crosshair
                },
                time: {
                    crosshair: crosshair
                }
            }
        } : {};
        common.minHeight = 0;
        common.minWidth = 0;
        common.navigator = {
            enabled: false,
            height: 18
        };
        common.context = this.chartProxyParams.context;
        return {
            common: common,
            ...seriesChartOptions
        };
    }
    getSeriesChartThemeDefaults() {
        return void 0;
    }
    getActiveFormattingPanelOverrides() {
        if (this.clearThemeOverrides) return {};
        const inUseTheme = this.chart?.getOptions().theme;
        return inUseTheme?.overrides ?? {};
    }
    destroy({ keepChartInstance: keepChartInstance = false } = {}) {
        if (keepChartInstance) {
            this.chart.resetAnimations();
            return this.chart;
        }
        this.destroyChart();
    }
    destroyChart() {
        if (this.chart) {
            this.chart.destroy();
            this.chart = void 0;
        }
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/cartesian/cartesianChartProxy.ts
var $5b7ccabde48fae90$var$CartesianChartProxy = class extends $5b7ccabde48fae90$var$ChartProxy {
    constructor(){
        super(...arguments);
        this.crossFilteringAllPoints = /* @__PURE__ */ new Set();
        this.crossFilteringSelectedPoints = [];
    }
    getUpdateOptions(params, commonChartOptions) {
        const axes = this.getAxes(params, commonChartOptions);
        return {
            ...commonChartOptions,
            data: this.getData(params, axes),
            axes: axes,
            series: this.getSeries(params)
        };
    }
    getData(params, axes) {
        const supportsCrossFiltering = [
            "area",
            "line"
        ].includes(this.standaloneChartType);
        return this.crossFiltering && supportsCrossFiltering ? this.getCrossFilterData(params) : this.getDataTransformedData(params, axes);
    }
    getDataTransformedData(params, axes) {
        const xAxisType = axes[0].type;
        const { categories: categories, data: data } = params;
        const [category] = categories;
        switch(xAxisType){
            case "category":
                return this.transformCategoryData(data, category.id);
            case "time":
                return this.transformTimeData(data, category.id);
            default:
                return data;
        }
    }
    getXAxisType(params) {
        if (params.grouping) return "grouped-category";
        else if (this.isXAxisOfType(params, "time", (value)=>value instanceof Date)) return "time";
        else if (this.isXAxisOfType(params, "number")) return "number";
        return "category";
    }
    isXAxisOfType(params, type, isInstance) {
        const [category] = params.categories;
        if (category?.chartDataType) return category.chartDataType === type;
        if (!isInstance) return false;
        const testDatum = params.data[0];
        if (!testDatum) return false;
        return isInstance(testDatum[category.id]);
    }
    transformTimeData(data, categoryKey) {
        const firstValue = data[0]?.[categoryKey];
        if (firstValue instanceof Date) return data;
        return data.map((datum)=>{
            const value = datum[categoryKey];
            return typeof value === "string" ? {
                ...datum,
                [categoryKey]: new Date(value)
            } : datum;
        });
    }
    crossFilteringReset() {
        this.crossFilteringSelectedPoints = [];
        this.crossFilteringAllPoints.clear();
    }
    crossFilteringPointSelected(point) {
        return this.crossFilteringSelectedPoints.length == 0 || this.crossFilteringSelectedPoints.includes(point);
    }
    crossFilteringDeselectedPoints() {
        return this.crossFilteringSelectedPoints.length > 0 && this.crossFilteringAllPoints.size !== this.crossFilteringSelectedPoints.length;
    }
    extractLineAreaCrossFilterSeries(series, params) {
        const [category] = params.categories;
        const getYKey = (yKey)=>{
            if (this.standaloneChartType === "area") {
                const lastSelectedChartId = params.getCrossFilteringContext().lastSelectedChartId;
                return lastSelectedChartId === params.chartId ? yKey + "-total" : yKey;
            }
            return yKey + "-total";
        };
        return series.map((s)=>{
            s.yKey = getYKey(s.yKey);
            s.listeners = {
                seriesNodeClick: (e)=>{
                    const value = e.datum[s.xKey];
                    const multiSelection = e.event.metaKey || e.event.ctrlKey;
                    this.crossFilteringAddSelectedPoint(multiSelection, value);
                    this.crossFilterCallback(e);
                }
            };
            s.marker = {
                itemStyler: (p)=>{
                    const value = p.datum[category.id];
                    return {
                        fill: p.highlighted ? "yellow" : p.fill,
                        size: p.highlighted ? 14 : this.crossFilteringPointSelected(value) ? 8 : 0
                    };
                }
            };
            if (this.standaloneChartType === "area") s.fillOpacity = this.crossFilteringDeselectedPoints() ? 0.3 : 1;
            if (this.standaloneChartType === "line") s.strokeOpacity = this.crossFilteringDeselectedPoints() ? 0.3 : 1;
            return s;
        });
    }
    getCrossFilterData(params) {
        this.crossFilteringAllPoints.clear();
        const [category] = params.categories;
        const colId = params.fields[0].colId;
        const filteredOutColId = `${colId}-filtered-out`;
        const lastSelectedChartId = params.getCrossFilteringContext().lastSelectedChartId;
        return params.data.map((d)=>{
            const value = d[category.id];
            this.crossFilteringAllPoints.add(value);
            const pointSelected = this.crossFilteringPointSelected(value);
            if (this.standaloneChartType === "area" && lastSelectedChartId === params.chartId) d[`${colId}-total`] = pointSelected ? d[colId] : d[colId] + d[filteredOutColId];
            if (this.standaloneChartType === "line") d[`${colId}-total`] = pointSelected ? d[colId] : d[colId] + d[filteredOutColId];
            return d;
        });
    }
    crossFilteringAddSelectedPoint(multiSelection, value) {
        multiSelection ? this.crossFilteringSelectedPoints.push(value) : this.crossFilteringSelectedPoints = [
            value
        ];
    }
    isHorizontal(commonChartOptions) {
        const seriesType = this.standaloneChartType;
        if (seriesType !== "waterfall" && seriesType !== "box-plot" && seriesType !== "range-bar") return false;
        const theme = commonChartOptions.theme;
        const isHorizontal = (theme2)=>{
            const direction = theme2?.overrides?.[seriesType]?.series?.direction;
            if (direction != null) return direction === "horizontal";
            if (typeof theme2?.baseTheme === "object") return isHorizontal(theme2.baseTheme);
            return false;
        };
        return isHorizontal(theme);
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/cartesian/histogramChartProxy.ts
var $5b7ccabde48fae90$var$HistogramChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    getSeries(params) {
        const firstField = params.fields[0];
        return [
            {
                type: this.standaloneChartType,
                xKey: firstField.colId,
                xName: firstField.displayName,
                yName: this.chartProxyParams.translate("histogramFrequency"),
                areaPlot: false
            }
        ];
    }
    getAxes(_params) {
        return [
            {
                type: "number",
                position: "bottom"
            },
            {
                type: "number",
                position: "left"
            }
        ];
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/cartesian/waterfallChartProxy.ts
var $5b7ccabde48fae90$var$WaterfallChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    getAxes(params, commonChartOptions) {
        return [
            {
                type: this.getXAxisType(params),
                position: this.isHorizontal(commonChartOptions) ? "left" : "bottom"
            },
            {
                type: "number",
                position: this.isHorizontal(commonChartOptions) ? "bottom" : "left"
            }
        ];
    }
    getSeries(params) {
        const [category] = params.categories;
        const [firstField] = params.fields;
        const firstSeries = {
            type: this.standaloneChartType,
            xKey: category.id,
            xName: category.name,
            yKey: firstField.colId,
            yName: firstField.displayName ?? void 0
        };
        return [
            firstSeries
        ];
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/funnel/funnelChartProxy.ts
var $5b7ccabde48fae90$var$FunnelChartProxy = class extends $5b7ccabde48fae90$var$ChartProxy {
    getUpdateOptions(params, commonChartOptions) {
        return {
            ...commonChartOptions,
            data: this.transformFunnelCategories(params),
            series: this.getSeries(params)
        };
    }
    transformFunnelCategories(params) {
        const { data: data } = params;
        const [{ id: id }] = params.categories;
        return data.map((d, index)=>({
                ...d,
                [id]: {
                    name: d[id],
                    id: index,
                    toString: ()=>d[id]
                }
            }));
    }
    getSeriesChartThemeDefaults() {
        const config = {
            crosshair: {
                enabled: false
            }
        };
        return {
            zoom: {
                enabled: false
            },
            ...this.chartType !== "pyramid" && {
                axes: {
                    category: config,
                    number: config
                }
            }
        };
    }
    getSeries(params) {
        const [{ id: id }] = params.categories;
        const [{ colId: colId }] = params.fields;
        const series = {
            type: this.standaloneChartType,
            stageKey: id,
            valueKey: colId
        };
        return [
            series
        ];
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/hierarchical/hierarchicalChartUtils.ts
var $5b7ccabde48fae90$var$CATEGORY_LABEL_KEY = "AG-GRID-DEFAULT-LABEL-KEY";
function $5b7ccabde48fae90$var$createCategoryHierarchy(data, categoryKeys) {
    const hierarchy = $5b7ccabde48fae90$var$buildNestedHierarchy(data, getItemDepth, getItemCategoryLabel);
    return $5b7ccabde48fae90$var$formatCategoryHierarchy(hierarchy);
    function getItemDepth(_item) {
        return categoryKeys.length;
    }
    function getItemCategoryLabel(item, categoryIndex) {
        const categoryKey = categoryKeys[categoryIndex];
        const categoryValue = item[categoryKey];
        return getCategoryLabel(categoryValue);
    }
    function getCategoryLabel(value) {
        if (value == null) return null;
        return String(value);
    }
}
function $5b7ccabde48fae90$var$createAutoGroupHierarchy(data, getItemLabels) {
    const hierarchy = $5b7ccabde48fae90$var$buildNestedHierarchy(data, getItemDepth, getItemGroupLabel);
    return $5b7ccabde48fae90$var$formatCategoryHierarchy(hierarchy);
    function getItemDepth(item) {
        return getItemLabels(item)?.length ?? 0;
    }
    function getItemGroupLabel(item, groupIndex) {
        const labels2 = getItemLabels(item);
        if (!labels2) return null;
        const labelIndex = labels2.length - 1 - groupIndex;
        return labels2[labelIndex];
    }
}
function $5b7ccabde48fae90$var$formatCategoryHierarchy(hierarchy, key = null, isChild) {
    const { depth: depth, rootValues: rootValues, value: value, children: inputChildren } = hierarchy;
    if (rootValues) return rootValues.map((item)=>({
            [$5b7ccabde48fae90$var$CATEGORY_LABEL_KEY]: key,
            ...item
        }));
    else if (depth === 0) return [
        {
            [$5b7ccabde48fae90$var$CATEGORY_LABEL_KEY]: key,
            ...value
        }
    ];
    const children = [];
    for (const [childKey, childHierarchy] of inputChildren.entries())children.push(...$5b7ccabde48fae90$var$formatCategoryHierarchy(childHierarchy, childKey, true));
    return isChild ? [
        {
            [$5b7ccabde48fae90$var$CATEGORY_LABEL_KEY]: key,
            children: children,
            ...value ?? {}
        }
    ] : children;
}
function $5b7ccabde48fae90$var$buildNestedHierarchy(data, getItemDepth, getItemGroupKey) {
    const hierarchy = {
        depth: 0,
        children: /* @__PURE__ */ new Map()
    };
    data.forEach((item)=>{
        const itemDepth = getItemDepth(item);
        createNestedItemHierarchy(item, itemDepth, getItemGroupKey, 0, hierarchy);
    });
    return hierarchy;
    function createNestedItemHierarchy(item, itemDepth, getItemGroupKey2, currentDepth, hierarchy2) {
        if (currentDepth === itemDepth) {
            if (currentDepth === 0) {
                if (!hierarchy2.rootValues) hierarchy2.rootValues = [];
                hierarchy2.rootValues.push(item);
            } else hierarchy2.value = item;
            return hierarchy2;
        } else {
            const key = getItemGroupKey2(item, currentDepth);
            const existingChildHierarchy = hierarchy2.children.get(key);
            const childHierarchy = createNestedItemHierarchy(item, itemDepth, getItemGroupKey2, currentDepth + 1, existingChildHierarchy || {
                depth: 0,
                children: /* @__PURE__ */ new Map()
            });
            hierarchy2.children.set(key, childHierarchy);
            hierarchy2.depth = Math.max(1 + childHierarchy.depth, hierarchy2.depth);
            return hierarchy2;
        }
    }
}
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/hierarchical/hierarchicalChartProxy.ts
var $5b7ccabde48fae90$var$HierarchicalChartProxy = class extends $5b7ccabde48fae90$var$ChartProxy {
    getUpdateOptions(params, commonChartOptions) {
        const { fields: fields } = params;
        const [sizeField, colorField] = fields;
        return {
            ...commonChartOptions,
            series: this.getSeries(sizeField, colorField),
            data: this.getData(params, sizeField, colorField)
        };
    }
    getSeriesChartThemeDefaults() {
        return {
            gradientLegend: {
                gradient: {
                    preferredLength: 200
                },
                position: "right"
            }
        };
    }
    getSeries(sizeField, colorField) {
        return [
            {
                type: this.standaloneChartType,
                labelKey: $5b7ccabde48fae90$var$CATEGORY_LABEL_KEY,
                // Size and color fields are inferred from the range data
                sizeKey: sizeField?.colId,
                sizeName: sizeField?.displayName ?? void 0,
                colorKey: colorField?.colId,
                colorName: colorField?.displayName ?? void 0
            }
        ];
    }
    getData(params, sizeField, colorField) {
        const { categories: categories, data: data, groupData: groupData, grouping: isGrouped } = params;
        if (isGrouped) {
            const processedData = colorField ? data.concat(groupData?.map((groupDatum)=>{
                const newDatum = {
                    ...groupDatum
                };
                delete newDatum[sizeField.colId];
                return newDatum;
            }) ?? []) : data;
            return $5b7ccabde48fae90$var$createAutoGroupHierarchy(processedData, (item)=>item[0, $jIDNV.GROUP_AUTO_COLUMN_ID]?.labels ?? null);
        } else {
            const categoryKeys = categories.map(({ id: id })=>id);
            return $5b7ccabde48fae90$var$createCategoryHierarchy(data, categoryKeys);
        }
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/polar/polarChartProxy.ts
var $5b7ccabde48fae90$var$PolarChartProxy = class extends $5b7ccabde48fae90$var$ChartProxy {
    getAxes(_) {
        const radialBar = this.standaloneChartType === "radial-bar";
        return [
            {
                type: radialBar ? "angle-number" : "angle-category"
            },
            {
                type: radialBar ? "radius-category" : "radius-number"
            }
        ];
    }
    getSeries(params) {
        const { fields: fields, categories: categories, seriesGroupType: seriesGroupType } = params;
        const [category] = categories;
        const radialBar = this.standaloneChartType === "radial-bar";
        const seriesGroupTypeOptions = this.getSeriesGroupTypeOptions(seriesGroupType);
        return fields.map((f)=>({
                type: this.standaloneChartType,
                angleKey: radialBar ? f.colId : category.id,
                angleName: radialBar ? f.displayName ?? void 0 : category.name,
                radiusKey: radialBar ? category.id : f.colId,
                radiusName: radialBar ? category.name : f.displayName ?? void 0,
                ...seriesGroupTypeOptions
            }));
    }
    getSeriesGroupType() {
        const standaloneChartType = this.standaloneChartType;
        if (![
            "nightingale",
            "radial-bar",
            "radial-column"
        ].includes(standaloneChartType)) return void 0;
        const firstSeriesProperties = this.getChart().series?.[0]?.properties.toJson();
        const getStackedValue = ()=>firstSeriesProperties.normalizedTo ? "normalized" : "stacked";
        if (standaloneChartType === "nightingale") return firstSeriesProperties.grouped ? "grouped" : getStackedValue();
        else return firstSeriesProperties.stacked ? getStackedValue() : "grouped";
    }
    getUpdateOptions(params, commonChartOptions) {
        const axes = this.getAxes(params);
        return {
            ...commonChartOptions,
            data: this.getData(params, axes),
            axes: axes,
            series: this.getSeries(params)
        };
    }
    getData(params, axes) {
        const isCategoryAxis = axes.some((axis)=>axis.type === "angle-category" || axis.type === "radius-category");
        if (isCategoryAxis) {
            const [category] = params.categories;
            return this.transformCategoryData(params.data, category.id);
        } else return params.data;
    }
    getSeriesGroupTypeOptions(seriesGroupType) {
        if (!seriesGroupType) return {};
        return {
            grouped: seriesGroupType === "grouped" || void 0,
            stacked: seriesGroupType !== "grouped" || void 0,
            normalizedTo: seriesGroupType === "normalized" ? 100 : void 0
        };
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/specialized/heatmapChartProxy.ts
var $5b7ccabde48fae90$var$HEATMAP_CATEGORY_KEY = "AG-GRID-DEFAULT-HEATMAP-CATEGORY-KEY";
var $5b7ccabde48fae90$var$HEATMAP_SERIES_KEY = "AG-GRID-DEFAULT-HEATMAP-SERIES-KEY";
var $5b7ccabde48fae90$var$HEATMAP_VALUE_KEY = "AG-GRID-DEFAULT-HEATMAP-VALUE-KEY";
function $5b7ccabde48fae90$var$flatMap(items, iteratee) {
    return items.reduce((acc, item, index, array)=>acc.concat(iteratee(item, index, array)), new Array());
}
var $5b7ccabde48fae90$var$HeatmapChartProxy = class extends $5b7ccabde48fae90$var$ChartProxy {
    getUpdateOptions(params, commonChartOptions) {
        const xSeriesKey = $5b7ccabde48fae90$var$HEATMAP_SERIES_KEY;
        const xValueKey = $5b7ccabde48fae90$var$HEATMAP_VALUE_KEY;
        const yKey = $5b7ccabde48fae90$var$HEATMAP_CATEGORY_KEY;
        return {
            ...commonChartOptions,
            series: this.getSeries(params, xSeriesKey, xValueKey, yKey),
            data: this.getData(params, xSeriesKey, xValueKey, yKey)
        };
    }
    getSeries(params, xSeriesKey, xValueKey, yKey) {
        const [category] = params.categories;
        return [
            {
                type: this.standaloneChartType,
                yKey: // The axis keys reference synthetic fields based on the category values and series column names
                yKey,
                xKey: xSeriesKey,
                // The color key references a synthetic field based on the series column value for a specific cell
                colorKey: xValueKey,
                yName: category.name,
                // We don't know how to label the 'x' series, as it is a synthetic series created from the set of all input columns
                // In future releases we may want to consider inferring the series label from column groupings etc
                xName: void 0,
                colorName: void 0
            }
        ];
    }
    getData(params, xSeriesKey, xValueKey, yKey) {
        const [category] = params.categories;
        return $5b7ccabde48fae90$var$flatMap(params.data, (datum, index)=>{
            const value = datum[category.id];
            const valueString = value == null ? "" : String(value);
            const yValue = {
                id: index,
                value: value,
                toString: ()=>valueString
            };
            return params.fields.map(({ colId: colId, displayName: displayName })=>({
                    ...datum,
                    [xSeriesKey]: displayName,
                    [xValueKey]: datum[colId],
                    [yKey]: yValue
                }));
        });
    }
    getSeriesChartThemeDefaults() {
        return {
            gradientLegend: {
                gradient: {
                    preferredLength: 200
                },
                position: "right"
            },
            series: {
                tooltip: {
                    renderer: $5b7ccabde48fae90$var$renderHeatmapTooltip
                }
            }
        };
    }
};
function $5b7ccabde48fae90$var$renderHeatmapTooltip(params) {
    const { xKey: xKey, yKey: yKey, colorKey: colorKey, yName: yName, datum: datum } = params;
    const table = [
        {
            label: yName,
            value: datum[yKey]
        },
        {
            label: datum[xKey],
            value: colorKey && datum[colorKey]
        }
    ];
    return {
        title: "",
        data: table.map(({ label: label, value: value })=>({
                label: String(label),
                value: String(value)
            }))
    };
}
var $5b7ccabde48fae90$var$ChartDatasource = class extends (0, $jIDNV.BeanStub) {
    wireBeans(beans) {
        this.sortSvc = beans.sortSvc;
        this.gridRowModel = beans.rowModel;
        this.colModel = beans.colModel;
        this.valueSvc = beans.valueSvc;
        this.pivotResultCols = beans.pivotResultCols;
        this.rowNodeSorter = beans.rowNodeSorter;
    }
    getData(params) {
        if (params.crossFiltering) {
            if (params.grouping) {
                (0, $jIDNV._warn)(141);
                return {
                    chartData: [],
                    colNames: {}
                };
            }
            if (!(0, $jIDNV._isClientSideRowModel)(this.gos)) {
                (0, $jIDNV._warn)(142);
                return {
                    chartData: [],
                    colNames: {}
                };
            }
        }
        const isServerSide = (0, $jIDNV._isServerSideRowModel)(this.gos);
        if (isServerSide && params.pivoting) this.updatePivotKeysForSSRM();
        const result = this.extractRowsFromGridRowModel(params);
        result.chartData = this.aggregateRowsByDimension(params, result.chartData);
        return result;
    }
    extractRowsFromGridRowModel(params) {
        const { crossFiltering: crossFiltering, startRow: startRow, endRow: endRow, valueCols: valueCols, dimensionCols: dimensionCols, grouping: grouping } = params;
        let extractedRowData = [];
        const colNames = {};
        const groupNodeIndexes = {};
        const groupsToRemove = {};
        let filteredNodes = {};
        let allRowNodes = [];
        let numRows;
        if (crossFiltering) {
            filteredNodes = this.getFilteredRowNodes();
            allRowNodes = this.getAllRowNodes();
            numRows = allRowNodes.length;
        } else {
            const modelLastRow = this.gridRowModel.getRowCount() - 1;
            const hasNoRange = startRow === endRow && startRow === 0 && dimensionCols.length === 0 && valueCols.length === 0;
            if (hasNoRange) numRows = 0;
            else {
                const rangeLastRow = endRow >= 0 ? Math.min(endRow, modelLastRow) : modelLastRow;
                numRows = rangeLastRow - startRow + 1;
            }
        }
        if (numRows > 0) valueCols.forEach((col)=>{
            let colNamesArr = [];
            const pivotKeys = col.getColDef().pivotKeys;
            if (pivotKeys) colNamesArr = pivotKeys.slice();
            const headerName = col.getColDef().headerName;
            if (headerName) colNamesArr.push(headerName);
            if (colNamesArr.length > 0) colNames[col.getId()] = colNamesArr;
        });
        let numRemovedNodes = 0;
        let id = 0;
        const groupingCache = {};
        for(let i = 0; i < numRows; i++){
            const rowNode = crossFiltering ? allRowNodes[i] : this.gridRowModel.getRow(i + startRow);
            if (rowNode.footer || rowNode.detail) {
                numRemovedNodes++;
                continue;
            }
            const data = {
                node: rowNode
            };
            dimensionCols.forEach((col)=>{
                const colId = col.colId;
                const column = this.colModel.getCol(colId);
                if (column) {
                    const valueObject = this.valueSvc.getValue(column, rowNode);
                    if (grouping) {
                        const valueString = valueObject?.toString ? String(valueObject.toString()) : " ";
                        const labels2 = this.getGroupLabels(rowNode, valueString);
                        const value = labels2.slice().reverse();
                        const groupingValue = {
                            value: value,
                            // this is needed so that standalone can handle animations properly when data updates
                            id: id++,
                            toString: ()=>value.filter(Boolean).join(" - ")
                        };
                        const groupingKey = groupingValue.toString();
                        const cachedGroupingValue = groupingCache[groupingKey];
                        data[colId] = cachedGroupingValue ? cachedGroupingValue : groupingCache[groupingKey] = groupingValue;
                        if (rowNode.group) groupNodeIndexes[labels2.toString()] = i - numRemovedNodes;
                        const groupKey = labels2.slice(1, labels2.length).toString();
                        if (groupKey) groupsToRemove[groupKey] = groupNodeIndexes[groupKey];
                    } else data[colId] = valueObject;
                } else data[$5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY] = i + 1;
            });
            valueCols.forEach((col)=>{
                const colId = col.getColId();
                if (crossFiltering) {
                    const filteredOutColId = colId + "-filtered-out";
                    const value = this.valueSvc.getValue(col, rowNode);
                    let actualValue = value;
                    if (value != null) {
                        if (typeof value.toNumber === "function") actualValue = value.toNumber();
                        else if (typeof value.value === "number") actualValue = value.value;
                    }
                    if (filteredNodes[rowNode.id]) {
                        data[colId] = actualValue;
                        data[filteredOutColId] = params.aggFunc || params.isScatter ? void 0 : 0;
                    } else {
                        data[colId] = params.aggFunc || params.isScatter ? void 0 : 0;
                        data[filteredOutColId] = actualValue;
                    }
                } else {
                    let value = this.valueSvc.getValue(col, rowNode);
                    if (value && typeof value.value === "number") value = value.value;
                    if (value && Object.prototype.hasOwnProperty.call(value, "toString")) value = parseFloat(value.toString());
                    data[colId] = value != null && typeof value.toNumber === "function" ? value.toNumber() : value;
                }
            });
            extractedRowData.push(data);
        }
        let groupChartData;
        if (grouping) {
            const groupIndexesToRemove = Object.values(groupsToRemove);
            const allData = extractedRowData;
            extractedRowData = [];
            groupChartData = [];
            for(let i = 0; i < allData.length; i++)(groupIndexesToRemove.includes(i) ? groupChartData : extractedRowData).push(allData[i]);
        }
        return {
            chartData: extractedRowData,
            colNames: colNames,
            groupChartData: groupChartData
        };
    }
    aggregateRowsByDimension(params, dataFromGrid) {
        const dimensionCols = params.dimensionCols;
        if (!params.aggFunc || dimensionCols.length === 0) return dataFromGrid;
        const lastCol = (0, $jIDNV._last)(dimensionCols);
        const lastColId = lastCol && lastCol.colId;
        const map = {};
        const dataAggregated = [];
        dataFromGrid.forEach((data)=>{
            let currentMap = map;
            dimensionCols.forEach((col)=>{
                const colId = col.colId;
                const key = data[colId];
                if (colId === lastColId) {
                    let groupItem = currentMap[key];
                    if (!groupItem) {
                        groupItem = {
                            __children: []
                        };
                        dimensionCols.forEach((dimCol)=>{
                            const dimColId = dimCol.colId;
                            groupItem[dimColId] = data[dimColId];
                        });
                        currentMap[key] = groupItem;
                        dataAggregated.push(groupItem);
                    }
                    groupItem.__children.push(data);
                } else {
                    if (!currentMap[key]) currentMap[key] = {};
                    currentMap = currentMap[key];
                }
            });
        });
        if (this.gos.assertModuleRegistered("SharedAggregation", 1)) dataAggregated.forEach((groupItem)=>params.valueCols.forEach((col)=>{
                const colId = col.getColId();
                if (params.crossFiltering) {
                    const dataToAgg = groupItem.__children.filter((child)=>typeof child[colId] !== "undefined").map((child)=>child[colId]);
                    const aggResult = $5b7ccabde48fae90$var$_aggregateValues(this.beans, dataToAgg, params.aggFunc, col);
                    groupItem[colId] = aggResult && typeof aggResult.value !== "undefined" ? aggResult.value : aggResult;
                    const filteredOutColId = `${colId}-filtered-out`;
                    const dataToAggFiltered = groupItem.__children.filter((child)=>typeof child[filteredOutColId] !== "undefined").map((child)=>child[filteredOutColId]);
                    const aggResultFiltered = $5b7ccabde48fae90$var$_aggregateValues(this.beans, dataToAggFiltered, params.aggFunc, col);
                    groupItem[filteredOutColId] = aggResultFiltered && typeof aggResultFiltered.value !== "undefined" ? aggResultFiltered.value : aggResultFiltered;
                } else {
                    const dataToAgg = groupItem.__children.map((child)=>child[colId]);
                    const aggResult = $5b7ccabde48fae90$var$_aggregateValues(this.beans, dataToAgg, params.aggFunc, col);
                    groupItem[colId] = aggResult && typeof aggResult.value !== "undefined" ? aggResult.value : aggResult;
                }
            }));
        return dataAggregated;
    }
    updatePivotKeysForSSRM() {
        const secondaryColumns = this.pivotResultCols?.getPivotResultCols()?.list;
        if (!secondaryColumns) return;
        const pivotKeySeparator = this.extractPivotKeySeparator(secondaryColumns);
        secondaryColumns.forEach((col)=>{
            if (pivotKeySeparator === "") col.getColDef().pivotKeys = [];
            else {
                const keys = col.getColId().split(pivotKeySeparator);
                col.getColDef().pivotKeys = keys.slice(0, keys.length - 1);
            }
        });
    }
    extractPivotKeySeparator(secondaryColumns) {
        if (secondaryColumns.length === 0) return "";
        const extractSeparator = (columnGroup, childId)=>{
            const groupId = columnGroup.getGroupId();
            if (!columnGroup.getParent()) return childId.split(groupId)[1][0];
            return extractSeparator(columnGroup.getParent(), groupId);
        };
        const firstSecondaryCol = secondaryColumns[0];
        if (firstSecondaryCol.getParent() == null) return "";
        return extractSeparator(firstSecondaryCol.getParent(), firstSecondaryCol.getColId());
    }
    getGroupLabels(rowNode, initialLabel) {
        const labels2 = [
            initialLabel
        ];
        while(rowNode && rowNode.level !== 0){
            rowNode = rowNode.parent;
            if (rowNode) {
                if (rowNode.group) {
                    const groupColumn = this.colModel.getCol((0, $jIDNV.GROUP_AUTO_COLUMN_ID));
                    if (groupColumn) {
                        const valueObject = this.valueSvc.getValue(groupColumn, rowNode);
                        const valueString = valueObject?.toString ? String(valueObject.toString()) : " ";
                        labels2.push(valueString);
                    }
                } else labels2.push(rowNode.key);
            }
        }
        return labels2;
    }
    getFilteredRowNodes() {
        const filteredNodes = {};
        this.gridRowModel.forEachNodeAfterFilterAndSort((rowNode)=>{
            filteredNodes[rowNode.id] = rowNode;
        });
        return filteredNodes;
    }
    getAllRowNodes() {
        const allRowNodes = [];
        this.gridRowModel.forEachNode((rowNode)=>{
            allRowNodes.push(rowNode);
        });
        return this.sortRowNodes(allRowNodes);
    }
    sortRowNodes(rowNodes) {
        const sortOptions = this.sortSvc?.getSortOptions();
        if (!sortOptions || sortOptions.length == 0 || !this.rowNodeSorter) return rowNodes;
        return this.rowNodeSorter.doFullSort(rowNodes, sortOptions);
    }
};
var $5b7ccabde48fae90$var$ChartColumnService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "chartColSvc";
        this.valueColsWithoutSeriesType = /* @__PURE__ */ new Set();
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.colNames = beans.colNames;
        this.valueSvc = beans.valueSvc;
    }
    postConstruct() {
        const clearValueCols = ()=>this.valueColsWithoutSeriesType.clear();
        this.addManagedEventListeners({
            newColumnsLoaded: clearValueCols,
            rowDataUpdated: clearValueCols
        });
    }
    getColumn(colId) {
        return this.colModel.getColDefCol(colId);
    }
    getAllDisplayedColumns() {
        return this.beans.visibleCols.allCols;
    }
    getColDisplayName(col, includePath) {
        const headerLocation = "chart";
        const columnDisplayName = this.colNames.getDisplayNameForColumn(col, headerLocation);
        if (includePath) {
            const displayNames = [
                columnDisplayName
            ];
            const getDisplayName2 = (colGroup)=>{
                if (!colGroup) return;
                const colGroupName = this.colNames.getDisplayNameForColumnGroup(colGroup, headerLocation);
                if (colGroupName?.length) {
                    displayNames.unshift(colGroupName);
                    getDisplayName2(colGroup.getParent());
                }
            };
            getDisplayName2(col.getParent());
            return displayNames.join(" - ");
        }
        return columnDisplayName;
    }
    getRowGroupColumns() {
        return this.beans.rowGroupColsSvc?.columns ?? [];
    }
    getGroupDisplayColumns() {
        return this.beans.showRowGroupCols?.getShowRowGroupCols() ?? [];
    }
    isPivotMode() {
        return this.colModel.isPivotMode();
    }
    isPivotActive() {
        return this.colModel.isPivotActive();
    }
    getChartColumns() {
        const gridCols = this.colModel.getCols();
        const dimensionCols = /* @__PURE__ */ new Set();
        const valueCols = /* @__PURE__ */ new Set();
        gridCols.forEach((col)=>{
            const colDef = col.getColDef();
            const chartDataType = colDef.chartDataType;
            if (chartDataType) switch(chartDataType){
                case "category":
                case "time":
                    dimensionCols.add(col);
                    return;
                case "series":
                    valueCols.add(col);
                    return;
                case "excluded":
                    return;
                default:
                    (0, $jIDNV._warn)(153, {
                        chartDataType: chartDataType
                    });
                    break;
            }
            if (colDef.colId === "ag-Grid-AutoColumn") {
                dimensionCols.add(col);
                return;
            }
            if (!col.isPrimary()) {
                valueCols.add(col);
                return;
            }
            (this.isInferredValueCol(col) ? valueCols : dimensionCols).add(col);
        });
        return {
            dimensionCols: dimensionCols,
            valueCols: valueCols
        };
    }
    isInferredValueCol(col) {
        const colId = col.getColId();
        if (colId === "ag-Grid-AutoColumn") return false;
        const row = (0, $jIDNV._getRowNode)(this.beans, {
            rowIndex: 0,
            rowPinned: null
        });
        if (!row) return this.valueColsWithoutSeriesType.has(colId);
        let cellValue = this.valueSvc.getValue(col, row);
        if (cellValue == null) cellValue = this.extractLeafData(row, col);
        if (cellValue != null) {
            if (typeof cellValue.toNumber === "function") cellValue = cellValue.toNumber();
            else if (typeof cellValue.value === "number") cellValue = cellValue.value;
        }
        const isNumber = typeof cellValue === "number" || col.colDef.cellDataType === "number" || [
            "series",
            "time"
        ].includes(col.colDef.chartDataType);
        if (isNumber) this.valueColsWithoutSeriesType.add(colId);
        else if (cellValue == null && col.colDef.cellDataType !== "number") (0, $jIDNV._warn)(265, {
            colId: colId
        });
        return isNumber;
    }
    extractLeafData(row, col) {
        if (!row.allLeafChildren) return null;
        for(let i = 0; i < row.allLeafChildren.length; i++){
            const childRow = row.allLeafChildren[i];
            const value = this.valueSvc.getValue(col, childRow);
            if (value != null) return value;
        }
        return null;
    }
    destroy() {
        this.valueColsWithoutSeriesType.clear();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$SUPPORTED_COMBO_CHART_TYPES = /* @__PURE__ */ new Set([
    "line",
    "groupedColumn",
    "stackedColumn",
    "area",
    "stackedArea"
]);
var $5b7ccabde48fae90$var$ComboChartModel = class extends (0, $jIDNV.BeanStub) {
    constructor(chartDataModel){
        super();
        // this control flag is used to only log warning for the initial user config
        this.suppressComboChartWarnings = false;
        this.chartDataModel = chartDataModel;
        this.seriesChartTypes = chartDataModel.params.seriesChartTypes ?? [];
    }
    postConstruct() {
        this.initComboCharts();
    }
    update(seriesChartTypes) {
        this.seriesChartTypes = seriesChartTypes ?? this.seriesChartTypes;
        this.initComboCharts();
        this.updateSeriesChartTypes();
    }
    initComboCharts() {
        const seriesChartTypesExist = this.seriesChartTypes && this.seriesChartTypes.length > 0;
        const customCombo = this.chartDataModel.chartType === "customCombo" || seriesChartTypesExist;
        if (customCombo) {
            this.chartDataModel.chartType = "customCombo";
            this.savedCustomSeriesChartTypes = this.seriesChartTypes || [];
        }
    }
    updateSeriesChartTypes() {
        if (!this.chartDataModel.isComboChart()) return;
        this.seriesChartTypes = this.seriesChartTypes.map((seriesChartType)=>{
            const primaryOnly = [
                "groupedColumn",
                "stackedColumn",
                "stackedArea"
            ].includes(seriesChartType.chartType);
            seriesChartType.secondaryAxis = primaryOnly ? false : seriesChartType.secondaryAxis;
            return seriesChartType;
        });
        if (this.chartDataModel.chartType === "customCombo") {
            this.updateSeriesChartTypesForCustomCombo();
            return;
        }
        this.updateChartSeriesTypesForBuiltInCombos();
    }
    updateSeriesChartTypesForCustomCombo() {
        const seriesChartTypesSupplied = this.seriesChartTypes && this.seriesChartTypes.length > 0;
        if (!seriesChartTypesSupplied && !this.suppressComboChartWarnings) (0, $jIDNV._warn)(150);
        this.seriesChartTypes = this.seriesChartTypes.map((s)=>{
            if (!$5b7ccabde48fae90$var$SUPPORTED_COMBO_CHART_TYPES.has(s.chartType)) {
                (0, $jIDNV._warn)(151, {
                    chartType: s.chartType
                });
                s.chartType = "line";
            }
            return s;
        });
        const getSeriesChartType = (valueCol)=>{
            if (!this.savedCustomSeriesChartTypes || this.savedCustomSeriesChartTypes.length === 0) this.savedCustomSeriesChartTypes = this.seriesChartTypes;
            const providedSeriesChartType = this.savedCustomSeriesChartTypes.find((s)=>s.colId === valueCol.colId);
            if (!providedSeriesChartType) {
                if (valueCol.selected && !this.suppressComboChartWarnings) (0, $jIDNV._warn)(152, {
                    colId: valueCol.colId
                });
                return {
                    colId: valueCol.colId,
                    chartType: "line",
                    secondaryAxis: false
                };
            }
            return providedSeriesChartType;
        };
        const updatedSeriesChartTypes = this.chartDataModel.valueColState.map(getSeriesChartType);
        this.seriesChartTypes = updatedSeriesChartTypes;
        this.savedCustomSeriesChartTypes = updatedSeriesChartTypes;
        this.suppressComboChartWarnings = true;
    }
    updateChartSeriesTypesForBuiltInCombos() {
        const { chartType: chartType, valueColState: valueColState } = this.chartDataModel;
        const primaryChartType = chartType === "columnLineCombo" ? "groupedColumn" : "stackedArea";
        const secondaryChartType = chartType === "columnLineCombo" ? "line" : "groupedColumn";
        const selectedCols = valueColState.filter((cs)=>cs.selected);
        const lineIndex = Math.ceil(selectedCols.length / 2);
        this.seriesChartTypes = selectedCols.map((valueCol, i)=>{
            const seriesType = i >= lineIndex ? secondaryChartType : primaryChartType;
            return {
                colId: valueCol.colId,
                chartType: seriesType,
                secondaryAxis: false
            };
        });
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/model/chartDataModel.ts
var $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY = "AG-GRID-DEFAULT-CATEGORY";
var $5b7ccabde48fae90$var$ChartDataModel = class extends (0, $jIDNV.BeanStub) {
    constructor(params){
        super();
        this.unlinked = false;
        this.chartData = [];
        this.valueColState = [];
        this.dimensionColState = [];
        this.colNames = {};
        this.crossFiltering = false;
        this.grouping = false;
        this.params = params;
        this.chartId = params.chartId;
        this.setParams(params);
    }
    wireBeans(beans) {
        this.rangeSvc = beans.rangeSvc;
        this.chartTranslation = beans.chartTranslation;
    }
    setParams(params) {
        const { chartType: chartType, pivotChart: pivotChart, chartThemeName: chartThemeName, switchCategorySeries: switchCategorySeries, aggFunc: aggFunc, cellRange: cellRange, suppressChartRanges: suppressChartRanges, unlinkChart: unlinkChart, crossFiltering: crossFiltering, seriesGroupType: seriesGroupType } = params;
        this.chartType = chartType;
        this.pivotChart = pivotChart ?? false;
        this.chartThemeName = chartThemeName;
        this.switchCategorySeries = !!switchCategorySeries;
        this.aggFunc = aggFunc;
        this.referenceCellRange = cellRange;
        this.suppliedCellRange = cellRange;
        this.suppressChartRanges = suppressChartRanges ?? false;
        this.unlinked = !!unlinkChart;
        this.crossFiltering = !!crossFiltering;
        this.seriesGroupType = seriesGroupType;
    }
    postConstruct() {
        this.datasource = this.createManagedBean(new $5b7ccabde48fae90$var$ChartDatasource());
        this.chartColSvc = this.createManagedBean(new $5b7ccabde48fae90$var$ChartColumnService());
        this.comboChartModel = this.createManagedBean(new $5b7ccabde48fae90$var$ComboChartModel(this));
        this.updateCellRanges({
            setColsFromRange: true
        });
        this.updateData();
    }
    updateModel(params) {
        const { cellRange: cellRange, seriesChartTypes: seriesChartTypes } = params;
        if (cellRange !== this.suppliedCellRange) {
            this.dimensionCellRange = void 0;
            this.valueCellRange = void 0;
        }
        this.setParams(params);
        this.updateSelectedDimensions(cellRange?.columns);
        this.updateCellRanges({
            setColsFromRange: true
        });
        const shouldUpdateComboModel = this.isComboChart() || seriesChartTypes;
        if (shouldUpdateComboModel) this.comboChartModel.update(seriesChartTypes);
        if (!this.unlinked) this.updateData();
    }
    updateCellRanges(params) {
        const { updatedColState: updatedColState, resetOrder: resetOrder, maintainColState: maintainColState, setColsFromRange: setColsFromRange } = params ?? {};
        if (this.valueCellRange) this.referenceCellRange = this.valueCellRange;
        const { dimensionCols: dimensionCols, valueCols: valueCols } = this.chartColSvc.getChartColumns();
        const allColsFromRanges = this.getAllColumnsFromRanges();
        if (updatedColState) this.updateColumnState(updatedColState, resetOrder);
        this.setDimensionCellRange(dimensionCols, allColsFromRanges, updatedColState);
        this.setValueCellRange(valueCols, allColsFromRanges, setColsFromRange);
        if (!updatedColState && !maintainColState) {
            this.resetColumnState();
            this.syncDimensionCellRange();
        }
        this.comboChartModel.updateSeriesChartTypes();
    }
    updateData() {
        const { startRow: startRow, endRow: endRow } = this.getRowIndexes();
        if (this.pivotChart) this.resetColumnState();
        this.grouping = this.isGrouping();
        const params = {
            aggFunc: this.aggFunc,
            dimensionCols: this.getSelectedDimensions(),
            grouping: this.grouping,
            pivoting: this.isPivotActive(),
            crossFiltering: this.crossFiltering,
            valueCols: this.getSelectedValueCols(),
            startRow: startRow,
            endRow: endRow,
            isScatter: [
                "scatter",
                "bubble"
            ].includes(this.chartType)
        };
        const { chartData: chartData, colNames: colNames, groupChartData: groupChartData } = this.datasource.getData(params);
        this.chartData = chartData;
        this.groupChartData = groupChartData;
        this.colNames = colNames;
        this.categoryAxisType = void 0;
    }
    isGrouping() {
        const usingTreeData = this.gos.get("treeData");
        const groupedCols = usingTreeData ? null : this.chartColSvc.getRowGroupColumns();
        const isGroupActive = usingTreeData || groupedCols && groupedCols.length > 0;
        const colIds = this.getSelectedDimensions().map(({ colId: colId })=>colId);
        const displayedGroupCols = this.chartColSvc.getGroupDisplayColumns();
        const groupDimensionSelected = displayedGroupCols.map((col)=>col.getColId()).some((id)=>colIds.includes(id));
        return !!isGroupActive && groupDimensionSelected;
    }
    getSelectedValueCols() {
        return this.valueColState.filter((cs)=>cs.selected).map((cs)=>cs.column);
    }
    getSelectedDimensions() {
        return this.dimensionColState.filter((cs)=>cs.selected);
    }
    getColDisplayName(col, includePath) {
        return this.chartColSvc.getColDisplayName(col, includePath);
    }
    isPivotMode() {
        return this.chartColSvc.isPivotMode();
    }
    getChartDataType(colId) {
        const column = this.chartColSvc.getColumn(colId);
        return column ? column.getColDef().chartDataType : void 0;
    }
    isPivotActive() {
        return this.chartColSvc.isPivotActive();
    }
    createCellRange(type, ...columns) {
        return {
            id: this.chartId,
            // set range ID to match chart ID so we can identify changes to the ranges for this chart
            startRow: this.referenceCellRange.startRow,
            endRow: this.referenceCellRange.endRow,
            columns: columns,
            startColumn: type === (0, $jIDNV.CellRangeType).DIMENSION || this.referenceCellRange.startColumn == null ? columns[0] : this.referenceCellRange.startColumn,
            type: type
        };
    }
    getAllColumnsFromRanges() {
        if (this.pivotChart) return new Set(this.chartColSvc.getAllDisplayedColumns());
        const columns = this.dimensionCellRange || this.valueCellRange ? [] : this.referenceCellRange.columns;
        if (this.dimensionCellRange) columns.push(...this.dimensionCellRange.columns);
        if (this.valueCellRange) columns.push(...this.valueCellRange.columns);
        return new Set(columns);
    }
    getRowIndexes() {
        let startRow = 0, endRow = 0;
        const { rangeSvc: rangeSvc, valueCellRange: valueCellRange, dimensionCellRange: dimensionCellRange } = this;
        const cellRange = valueCellRange || dimensionCellRange;
        if (rangeSvc && cellRange) {
            startRow = rangeSvc.getRangeStartRow(cellRange).rowIndex;
            const endRowPosition = rangeSvc.getRangeEndRow(cellRange);
            endRow = endRowPosition.rowPinned === "bottom" ? -1 : endRowPosition.rowIndex;
        }
        return {
            startRow: startRow,
            endRow: endRow
        };
    }
    resetColumnState() {
        const { dimensionCols: dimensionCols, valueCols: valueCols } = this.chartColSvc.getChartColumns();
        const allCols = this.getAllColumnsFromRanges();
        const isInitialising = this.valueColState.length < 1;
        this.dimensionColState = [];
        this.valueColState = [];
        const supportsMultipleDimensions = $5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(this.chartType));
        let hasSelectedDimension = false;
        let order = 1;
        const aggFuncDimension = this.suppliedCellRange.columns[0];
        dimensionCols.forEach((column)=>{
            const isAutoGroupCol = column.getColId() === "ag-Grid-AutoColumn";
            let selected = false;
            if (this.crossFiltering && this.aggFunc) {
                if (aggFuncDimension.getColId() === column.getColId()) selected = true;
            } else selected = isAutoGroupCol ? true : (!hasSelectedDimension || supportsMultipleDimensions) && allCols.has(column);
            this.dimensionColState.push({
                column: column,
                colId: column.getColId(),
                displayName: this.getColDisplayName(column),
                selected: selected,
                order: order++
            });
            if (selected) hasSelectedDimension = true;
        });
        const defaultCategory = {
            colId: $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY,
            displayName: this.chartTranslation.translate("defaultCategory"),
            selected: !hasSelectedDimension,
            // if no dimensions in range select the default
            order: 0
        };
        this.dimensionColState.unshift(defaultCategory);
        const valueColumnsFromReferenceRange = this.referenceCellRange.columns.filter((c)=>valueCols.has(c));
        valueCols.forEach((column)=>{
            if (isInitialising && this.referenceCellRange.columns.includes(column)) column = valueColumnsFromReferenceRange.shift();
            this.valueColState.push({
                column: column,
                colId: column.getColId(),
                displayName: this.getColDisplayName(column),
                selected: allCols.has(column),
                order: order++
            });
        });
    }
    updateColumnState(updatedCol, resetOrder) {
        const idsMatch = (cs)=>cs.colId === updatedCol.colId;
        const { dimensionColState: dimensionColState, valueColState: valueColState } = this;
        const matchedDimensionColState = dimensionColState.find(idsMatch);
        const matchedValueColState = valueColState.find(idsMatch);
        if (matchedDimensionColState) {
            const supportsMultipleDimensions = $5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(this.chartType));
            if (!supportsMultipleDimensions) {
                const selectedColumnState = updatedCol.selected ? matchedDimensionColState : dimensionColState.filter((cs)=>cs !== matchedDimensionColState).find(({ selected: selected })=>selected);
                dimensionColState.forEach((cs)=>cs.selected = cs === selectedColumnState);
            } else matchedDimensionColState.selected = updatedCol.selected;
        } else if (matchedValueColState) matchedValueColState.selected = updatedCol.selected;
        const allColumns = [
            ...dimensionColState,
            ...valueColState
        ];
        const orderedColIds = [];
        if (!resetOrder) {
            allColumns.forEach((col, i)=>{
                if (i === updatedCol.order) orderedColIds.push(updatedCol.colId);
                if (col.colId !== updatedCol.colId) orderedColIds.push(col.colId);
            });
            allColumns.forEach((col)=>{
                const order = orderedColIds.indexOf(col.colId);
                col.order = order >= 0 ? orderedColIds.indexOf(col.colId) : allColumns.length - 1;
            });
        }
        this.reorderColState();
    }
    reorderColState() {
        const ascColStateOrder = (a, b)=>a.order - b.order;
        this.dimensionColState.sort(ascColStateOrder);
        this.valueColState.sort(ascColStateOrder);
    }
    setDimensionCellRange(dimensionCols, colsInRange, updatedColState) {
        this.dimensionCellRange = void 0;
        const supportsMultipleDimensions = $5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(this.chartType));
        if (!updatedColState && !this.dimensionColState.length) {
            const selectedCols = new Array();
            dimensionCols.forEach((col)=>{
                if (selectedCols.length > 0 && !supportsMultipleDimensions || !colsInRange.has(col)) return;
                selectedCols.push(col);
            });
            if (selectedCols.length > 0) this.dimensionCellRange = this.createCellRange((0, $jIDNV.CellRangeType).DIMENSION, ...selectedCols);
            return;
        }
        let selectedDimensionColStates = updatedColState ? [
            updatedColState
        ] : [];
        if (this.crossFiltering && this.aggFunc) {
            const aggFuncDimension = this.suppliedCellRange.columns[0];
            selectedDimensionColStates = this.dimensionColState.filter((cs)=>cs.colId === aggFuncDimension.getColId());
        } else if (supportsMultipleDimensions || selectedDimensionColStates.length === 0 || selectedDimensionColStates.some(({ column: column })=>!column || !dimensionCols.has(column))) selectedDimensionColStates = this.dimensionColState.filter((cs)=>cs.selected);
        const isDefaultCategory = selectedDimensionColStates.length === 1 ? selectedDimensionColStates[0].colId === $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY : false;
        const selectedColumns = selectedDimensionColStates.map(({ column: column })=>column).filter((value)=>value != null);
        if (selectedColumns.length > 0 && !isDefaultCategory) this.dimensionCellRange = this.createCellRange((0, $jIDNV.CellRangeType).DIMENSION, ...selectedColumns);
    }
    setValueCellRange(valueCols, colsInRange, setColsFromRange) {
        this.valueCellRange = void 0;
        const selectedValueCols = [];
        const maxSelection = $5b7ccabde48fae90$var$getMaxNumSeries(this.chartType);
        let numSelected = 0;
        valueCols.forEach((col)=>{
            if (setColsFromRange) {
                if ((maxSelection == null || numSelected < maxSelection) && colsInRange.has(col)) {
                    selectedValueCols.push(col);
                    numSelected++;
                }
            } else if (this.valueColState.some((colState)=>colState.selected && colState.colId === col.getColId())) selectedValueCols.push(col);
        });
        if (selectedValueCols.length > 0) {
            let orderedColIds = [];
            if (this.valueColState.length > 0) orderedColIds = this.valueColState.map((c)=>c.colId);
            else colsInRange.forEach((c)=>orderedColIds.push(c.getColId()));
            selectedValueCols.sort((a, b)=>orderedColIds.indexOf(a.getColId()) - orderedColIds.indexOf(b.getColId()));
            this.valueCellRange = this.createCellRange((0, $jIDNV.CellRangeType).VALUE, ...selectedValueCols);
        }
    }
    resetCellRanges(dimension, value) {
        if (!dimension && !value) return;
        const { dimensionCols: dimensionCols, valueCols: valueCols } = this.chartColSvc.getChartColumns();
        const allColsFromRanges = this.getAllColumnsFromRanges();
        if (dimension) this.setDimensionCellRange(dimensionCols, allColsFromRanges);
        if (value) this.setValueCellRange(valueCols, allColsFromRanges);
    }
    updateSelectedDimensions(columns) {
        const colIdSet = new Set(columns.map((column)=>column.getColId()));
        const supportsMultipleDimensions = $5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(this.chartType));
        if (!supportsMultipleDimensions) {
            const foundColState = this.dimensionColState.find((colState)=>colIdSet.has(colState.colId)) || this.dimensionColState[0];
            const selectedColumnId = foundColState.colId;
            this.dimensionColState = this.dimensionColState.map((colState)=>({
                    ...colState,
                    selected: colState.colId === selectedColumnId
                }));
        } else {
            const foundColStates = this.dimensionColState.filter((colState)=>colIdSet.has(colState.colId));
            const selectedColumnIds = new Set(foundColStates.map((colState)=>colState.colId));
            this.dimensionColState = this.dimensionColState.map((colState)=>({
                    ...colState,
                    selected: selectedColumnIds.has(colState.colId)
                }));
        }
    }
    syncDimensionCellRange() {
        const selectedDimensions = this.getSelectedDimensions();
        if (selectedDimensions.length === 0) return;
        const selectedCols = selectedDimensions.map(({ column: column })=>column).filter((value)=>value != null);
        if (selectedCols.length > 0) this.dimensionCellRange = this.createCellRange((0, $jIDNV.CellRangeType).DIMENSION, ...selectedCols);
    }
    isComboChart(chartType) {
        return $5b7ccabde48fae90$var$isComboChart(chartType ?? this.chartType);
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/statistical/statisticalChartProxy.ts
var $5b7ccabde48fae90$var$StatisticalChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    getAxes(params, commonChartOptions) {
        return [
            {
                type: this.getXAxisType(params),
                position: this.isHorizontal(commonChartOptions) ? "left" : "bottom"
            },
            {
                type: "number",
                position: this.isHorizontal(commonChartOptions) ? "bottom" : "left"
            }
        ];
    }
    computeSeriesStatistics(params, computeStatsFn) {
        const { data: data, fields: fields } = params;
        const [category] = params.categories;
        const categoryKey = category.id || $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY;
        const groupedData = this.groupDataByCategory(categoryKey, data);
        return Array.from(groupedData).map(([categoryValue, categoryData])=>{
            const categoryResult = {
                [category.id]: categoryValue
            };
            fields.forEach((field, seriesIndex)=>{
                const seriesValues = categoryData.map((datum)=>datum[field.colId]).filter((value)=>typeof value === "number" && !isNaN(value));
                const computed = computeStatsFn(seriesValues);
                for (const statKey of Object.keys(computed)){
                    const propertyKey = `${statKey}:${seriesIndex}`;
                    categoryResult[propertyKey] = seriesValues.length > 0 ? computed[statKey] : null;
                }
            });
            return categoryResult;
        });
    }
    groupDataByCategory(categoryKey, data) {
        const getCategory = (datum)=>{
            if (categoryKey === $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY) return 1;
            const categoryValue = datum[categoryKey];
            if (categoryValue === null || categoryValue === void 0) return "";
            return categoryValue instanceof Date ? categoryValue.getTime() : categoryValue;
        };
        return data.reduce((acc, datum)=>{
            const category = getCategory(datum);
            const existingCategoryData = acc.get(category);
            if (existingCategoryData) existingCategoryData.push(datum);
            else acc.set(category, [
                datum
            ]);
            return acc;
        }, /* @__PURE__ */ new Map());
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/statistical/boxPlotChartProxy.ts
var $5b7ccabde48fae90$var$BoxPlotChartProxy = class extends $5b7ccabde48fae90$var$StatisticalChartProxy {
    getSeries(params) {
        const [category] = params.categories;
        return params.fields.map((field, seriesIndex)=>({
                type: this.standaloneChartType,
                // xKey/xName refer to category buckets
                xKey: category.id,
                xName: category.name,
                // yName is used to label the series
                yName: field.displayName ?? void 0,
                // custom field labels shown in the tooltip
                minName: "Min",
                q1Name: "Q1",
                medianName: "Median",
                q3Name: "Q3",
                maxName: "Max",
                // generated 'synthetic fields' from getData()
                minKey: `min:${seriesIndex}`,
                q1Key: `q1:${seriesIndex}`,
                medianKey: `median:${seriesIndex}`,
                q3Key: `q3:${seriesIndex}`,
                maxKey: `max:${seriesIndex}`
            }));
    }
    getData(params) {
        return this.computeSeriesStatistics(params, (seriesValues)=>{
            const sortedValues = seriesValues.sort((a, b)=>a - b);
            return {
                min: sortedValues[0],
                q1: this.quantile(sortedValues, 0.25),
                median: this.quantile(sortedValues, 0.5),
                q3: this.quantile(sortedValues, 0.75),
                max: sortedValues[sortedValues.length - 1]
            };
        });
    }
    quantile(sortedValues, q) {
        const position = (sortedValues.length - 1) * q;
        const indexBelow = Math.floor(position);
        const aboveValue = position - indexBelow;
        if (sortedValues[indexBelow + 1] !== void 0) return sortedValues[indexBelow] + aboveValue * (sortedValues[indexBelow + 1] - sortedValues[indexBelow]);
        return sortedValues[indexBelow];
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/statistical/rangeChartProxy.ts
var $5b7ccabde48fae90$var$RangeChartProxy = class extends $5b7ccabde48fae90$var$StatisticalChartProxy {
    getSeries(params) {
        const [category] = params.categories;
        return params.fields.map((field, seriesIndex)=>({
                type: this.standaloneChartType,
                // xKey/xName refer to category buckets
                xKey: category.id,
                xName: category.name,
                // yName is used to label the series
                yName: field.displayName ?? void 0,
                // custom field labels shown in the tooltip
                yLowName: "Min",
                yHighName: "Max",
                // generated 'synthetic fields' from getData()
                yLowKey: `min:${seriesIndex}`,
                yHighKey: `max:${seriesIndex}`
            }));
    }
    getData(params) {
        return this.computeSeriesStatistics(params, (seriesValues)=>{
            return {
                min: Math.min(...seriesValues),
                max: Math.max(...seriesValues)
            };
        });
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/enterpriseChartProxyFactory.ts
var $5b7ccabde48fae90$var$EnterpriseChartProxyFactory = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "enterpriseChartProxyFactory";
    }
    createChartProxy(chartProxyParams) {
        switch(chartProxyParams.chartType){
            case "histogram":
                return new $5b7ccabde48fae90$var$HistogramChartProxy(chartProxyParams);
            case "radarLine":
            case "radarArea":
            case "nightingale":
            case "radialColumn":
            case "radialBar":
                return new $5b7ccabde48fae90$var$PolarChartProxy(chartProxyParams);
            case "rangeBar":
            case "rangeArea":
                return new $5b7ccabde48fae90$var$RangeChartProxy(chartProxyParams);
            case "boxPlot":
                return new $5b7ccabde48fae90$var$BoxPlotChartProxy(chartProxyParams);
            case "treemap":
            case "sunburst":
                return new $5b7ccabde48fae90$var$HierarchicalChartProxy(chartProxyParams);
            case "heatmap":
                return new $5b7ccabde48fae90$var$HeatmapChartProxy(chartProxyParams);
            case "waterfall":
                return new $5b7ccabde48fae90$var$WaterfallChartProxy(chartProxyParams);
            case "funnel":
            case "coneFunnel":
            case "pyramid":
                return new $5b7ccabde48fae90$var$FunnelChartProxy(chartProxyParams);
        }
        return void 0;
    }
};
var $5b7ccabde48fae90$var$ChartPanelFeature = class extends (0, $jIDNV.BeanStub) {
    constructor(chartController, eGui, cssClass, createPanels){
        super();
        this.chartController = chartController;
        this.eGui = eGui;
        this.cssClass = cssClass;
        this.createPanels = createPanels;
        this.panels = [];
    }
    postConstruct() {
        this.addManagedListeners(this.chartController, {
            chartUpdated: ()=>this.refreshPanels(true),
            chartApiUpdate: ()=>this.refreshPanels(false)
        });
    }
    addComponent(component) {
        this.createBean(component);
        this.panels.push(component);
        component.addCss(this.cssClass);
        this.eGui.appendChild(component.getGui());
    }
    refreshPanels(reuse) {
        const chartType = this.chartController.getChartType();
        const isGrouping = this.chartController.isGrouping();
        const seriesType = $5b7ccabde48fae90$var$getSeriesType(chartType);
        if (reuse && chartType === this.chartType && isGrouping === this.isGrouping) return;
        this.destroyPanels();
        this.createPanels(chartType, seriesType);
        this.chartType = chartType;
        this.isGrouping = isGrouping;
    }
    destroyPanels() {
        this.panels.forEach((panel)=>{
            (0, $jIDNV._removeFromParent)(panel.getGui());
            this.destroyBean(panel);
        });
        this.panels = [];
    }
    destroy() {
        this.destroyPanels();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$AnimationPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuParamsFactory){
        super();
        this.chartMenuParamsFactory = chartMenuParamsFactory;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const animationGroupParams = this.chartMenuParamsFactory.addEnableParams("animation.enabled", {
            cssIdentifier: "charts-advanced-settings-top-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("animation"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const animationHeightInputParams = this.chartMenuParamsFactory.getDefaultNumberInputParams("animation.duration", "durationMillis", {
            min: 0
        });
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="animationGroup">
                <ag-input-number-field data-ref="animationHeightInput"></ag-input>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            (0, $jIDNV.AgInputNumberFieldSelector)
        ], {
            animationGroup: animationGroupParams,
            animationHeightInput: animationHeightInputParams
        });
    }
};
var $5b7ccabde48fae90$var$AgColorInputElement = {
    tag: "div",
    cls: "ag-color-input",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eLabel",
            cls: "ag-input-field-label"
        },
        {
            tag: "div",
            ref: "eWrapper",
            cls: "ag-wrapper ag-input-wrapper",
            role: "presentation",
            children: [
                {
                    tag: "input",
                    ref: "eInput",
                    cls: "ag-input-field-input"
                },
                {
                    tag: "div",
                    ref: "eColor",
                    cls: "ag-color-input-color"
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$AgColorInput = class extends (0, $jIDNV.AgInputTextField) {
    constructor(){
        super({
            template: $5b7ccabde48fae90$var$AgColorInputElement
        });
        this.eColor = (0, $jIDNV.RefPlaceholder);
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
        this.color = beans.agChartsExports._Util.Color;
    }
    setColor(color) {
        const rgbaColor = color.toRgbaString();
        this.setValue(this.color.fromString(rgbaColor).toHexString().toUpperCase(), true);
        this.eColor.style.backgroundColor = rgbaColor;
    }
    setValue(value, silent) {
        const isValid = this.color.validColorString(value ?? "");
        this.eInput.setCustomValidity(isValid ? "" : this.chartTranslation.translate("invalidColor"));
        super.setValue(value, silent);
        if (isValid && !silent) this.dispatchLocalEvent({
            type: "colorChanged"
        });
        return this;
    }
    onColorChanged(callback) {
        this.addManagedListeners(this, {
            colorChanged: ()=>callback(this.color.fromString(this.value))
        });
    }
};
var $5b7ccabde48fae90$var$AgColorInputSelector = {
    selector: "AG-COLOR-INPUT",
    component: $5b7ccabde48fae90$var$AgColorInput
};
// packages/ag-grid-enterprise/src/charts/widgets/agColorPanel.ts
var $5b7ccabde48fae90$var$maxRecentColors = 8;
var $5b7ccabde48fae90$var$sharedRecentColors = [];
var $5b7ccabde48fae90$var$AgColorPanel = class extends (0, $jIDNV.Component) {
    constructor(config){
        super(/* html */ `<div class="ag-color-panel" tabindex="-1">
            <div data-ref="spectrumColor" class="ag-spectrum-color">
                <div class="ag-spectrum-sat ag-spectrum-fill">
                    <div data-ref="spectrumVal" class="ag-spectrum-val ag-spectrum-fill">
                        <div data-ref="spectrumDragger" class="ag-spectrum-dragger"></div>
                    </div>
                </div>
            </div>
            <div class="ag-spectrum-tools">
                <div data-ref="spectrumHue" class="ag-spectrum-hue ag-spectrum-tool">
                    <div class="ag-spectrum-hue-background"></div>
                    <div data-ref="spectrumHueSlider" class="ag-spectrum-slider"></div>
                </div>
                <div data-ref="spectrumAlpha" class="ag-spectrum-alpha ag-spectrum-tool">
                    <div class="ag-spectrum-alpha-background"></div>
                    <div data-ref="spectrumAlphaSlider" class="ag-spectrum-slider"></div>
                </div>
                <ag-color-input data-ref="colorInput"></ag-color-input>
                <div data-ref="recentColors" class="ag-recent-colors"></div>
            </div>
        </div>`, [
            $5b7ccabde48fae90$var$AgColorInputSelector
        ]);
        this.H = 1;
        // in the [0, 1] range
        this.S = 1;
        // in the [0, 1] range
        this.B = 1;
        // in the [0, 1] range
        this.A = 1;
        this.isSpectrumDragging = false;
        this.isSpectrumHueDragging = false;
        this.isSpectrumAlphaDragging = false;
        this.colorChanged = false;
        this.spectrumColor = (0, $jIDNV.RefPlaceholder);
        this.spectrumVal = (0, $jIDNV.RefPlaceholder);
        this.spectrumDragger = (0, $jIDNV.RefPlaceholder);
        this.spectrumHue = (0, $jIDNV.RefPlaceholder);
        this.spectrumHueSlider = (0, $jIDNV.RefPlaceholder);
        this.spectrumAlpha = (0, $jIDNV.RefPlaceholder);
        this.spectrumAlphaSlider = (0, $jIDNV.RefPlaceholder);
        this.colorInput = (0, $jIDNV.RefPlaceholder);
        this.recentColors = (0, $jIDNV.RefPlaceholder);
        this.picker = config.picker;
    }
    wireBeans(beans) {
        this._Color = beans.agChartsExports._Util.Color;
    }
    postConstruct() {
        this.initTabIndex();
        this.initRecentColors();
        this.addGuiEventListener("focus", ()=>this.spectrumColor.focus());
        this.addGuiEventListener("keydown", (e)=>{
            if (e.key === (0, $jIDNV.KeyCode).ENTER && !e.defaultPrevented) this.destroy();
        });
        this.addManagedListeners(this.spectrumColor, {
            keydown: (e)=>this.moveDragger(e)
        });
        this.addManagedListeners(this.spectrumAlphaSlider, {
            keydown: (e)=>this.moveAlphaSlider(e)
        });
        this.addManagedListeners(this.spectrumHueSlider, {
            keydown: (e)=>this.moveHueSlider(e)
        });
        this.addManagedListeners(this.spectrumVal, {
            mousedown: this.onSpectrumDraggerDown.bind(this)
        });
        this.addManagedListeners(this.spectrumHue, {
            mousedown: this.onSpectrumHueDown.bind(this)
        });
        this.addManagedListeners(this.spectrumAlpha, {
            mousedown: this.onSpectrumAlphaDown.bind(this)
        });
        this.addGuiEventListener("mousemove", (e)=>{
            this.onSpectrumDraggerMove(e);
            this.onSpectrumHueMove(e);
            this.onSpectrumAlphaMove(e);
        });
        this.addManagedListeners(document, {
            mouseup: this.onMouseUp.bind(this)
        });
        this.colorInput.onColorChanged(this.setColor.bind(this));
        this.addManagedListeners(this.recentColors, {
            click: this.onRecentColorClick.bind(this),
            keydown: (e)=>{
                if (e.key === (0, $jIDNV.KeyCode).ENTER || e.key === (0, $jIDNV.KeyCode).SPACE) {
                    e.preventDefault();
                    this.onRecentColorClick(e);
                }
            }
        });
    }
    initTabIndex() {
        const tabIndex = this.tabIndex = this.gos.get("tabIndex").toString();
        this.spectrumColor.setAttribute("tabindex", tabIndex);
        this.spectrumHueSlider.setAttribute("tabindex", tabIndex);
        this.spectrumAlphaSlider.setAttribute("tabindex", tabIndex);
    }
    refreshSpectrumRect() {
        return this.spectrumValRect = this.spectrumVal.getBoundingClientRect();
    }
    refreshHueRect() {
        return this.spectrumHueRect = this.spectrumHue.getBoundingClientRect();
    }
    refreshAlphaRect() {
        return this.spectrumAlphaRect = this.spectrumAlpha.getBoundingClientRect();
    }
    onSpectrumDraggerDown(e) {
        e.preventDefault();
        this.refreshSpectrumRect();
        this.isSpectrumDragging = true;
        this.moveDragger(e);
    }
    onSpectrumDraggerMove(e) {
        if (this.isSpectrumDragging) this.moveDragger(e);
    }
    onSpectrumHueDown(e) {
        this.refreshHueRect();
        this.isSpectrumHueDragging = true;
        this.moveHueSlider(e);
    }
    onSpectrumHueMove(e) {
        if (this.isSpectrumHueDragging) this.moveHueSlider(e);
    }
    onSpectrumAlphaDown(e) {
        this.refreshAlphaRect();
        this.isSpectrumAlphaDragging = true;
        this.moveAlphaSlider(e);
    }
    onSpectrumAlphaMove(e) {
        if (this.isSpectrumAlphaDragging) this.moveAlphaSlider(e);
    }
    onMouseUp() {
        this.isSpectrumDragging = false;
        this.isSpectrumHueDragging = false;
        this.isSpectrumAlphaDragging = false;
    }
    moveDragger(e) {
        const valRect = this.spectrumValRect;
        if (!valRect) return;
        let x;
        let y;
        if (e instanceof MouseEvent) {
            x = e.clientX - valRect.left;
            y = e.clientY - valRect.top;
        } else {
            const isLeft = e.key === (0, $jIDNV.KeyCode).LEFT;
            const isRight = e.key === (0, $jIDNV.KeyCode).RIGHT;
            const isUp = e.key === (0, $jIDNV.KeyCode).UP;
            const isDown = e.key === (0, $jIDNV.KeyCode).DOWN;
            const isVertical = isUp || isDown;
            const isHorizontal = isLeft || isRight;
            if (!isVertical && !isHorizontal) return;
            e.preventDefault();
            const { x: currentX, y: currentY } = this.getSpectrumValue();
            x = currentX + (isHorizontal ? isLeft ? -5 : 5 : 0);
            y = currentY + (isVertical ? isUp ? -5 : 5 : 0);
        }
        x = Math.max(x, 0);
        x = Math.min(x, valRect.width);
        y = Math.max(y, 0);
        y = Math.min(y, valRect.height);
        this.setSpectrumValue(x / valRect.width, 1 - y / valRect.height);
    }
    moveHueSlider(e) {
        const rect = this.spectrumHueRect;
        if (!rect) return;
        const x = this.moveSlider(this.spectrumHueSlider, e);
        if (x == null) return;
        this.H = 1 - x / rect.width;
        this.update();
    }
    moveAlphaSlider(e) {
        const rect = this.spectrumAlphaRect;
        if (!rect) return;
        const x = this.moveSlider(this.spectrumAlphaSlider, e);
        if (x == null) return;
        this.A = x / rect.width;
        this.update();
    }
    moveSlider(slider, e) {
        const sliderRect = slider.getBoundingClientRect();
        const parentRect = slider.parentElement?.getBoundingClientRect();
        if (!slider || !parentRect) return null;
        const offset = sliderRect.width / 2;
        let x;
        if (e instanceof MouseEvent) x = Math.floor(e.clientX - parentRect.left);
        else {
            const isLeft = e.key === (0, $jIDNV.KeyCode).LEFT;
            const isRight = e.key === (0, $jIDNV.KeyCode).RIGHT;
            if (!isLeft && !isRight) return null;
            e.preventDefault();
            const diff = isLeft ? -5 : 5;
            x = parseFloat(slider.style.left) + offset + diff;
        }
        x = Math.max(x, 0);
        x = Math.min(x, parentRect.width);
        slider.style.left = x - offset + "px";
        return x;
    }
    update(suppressColorInputUpdate) {
        const { A: A, S: S, B: B, H: H, _Color: _Color } = this;
        const hue = H * 360;
        const color = _Color.fromHSB(hue, S, B, A);
        const rgbaColor = color.toRgbaString();
        const colorWithoutAlpha = _Color.fromHSB(hue, S, B);
        const rgbaColorWithoutAlpha = colorWithoutAlpha.toRgbaString();
        const spectrumColor = _Color.fromHSB(hue, 1, 1);
        const spectrumRgbaColor = spectrumColor.toRgbaString();
        const colorPicker = this.picker;
        const existingColor = _Color.fromString(colorPicker.getValue());
        if (existingColor.toRgbaString() !== rgbaColor) this.colorChanged = true;
        colorPicker.setValue(rgbaColor);
        this.spectrumColor.style.backgroundColor = spectrumRgbaColor;
        this.spectrumDragger.style.backgroundColor = rgbaColorWithoutAlpha;
        this.spectrumHueSlider.style.backgroundColor = spectrumRgbaColor;
        this.spectrumAlpha.style.setProperty("--ag-internal-spectrum-alpha-color-from", _Color.fromHSB(hue, S, B, 0).toRgbaString());
        this.spectrumAlpha.style.setProperty("--ag-internal-spectrum-alpha-color-to", rgbaColorWithoutAlpha);
        this.spectrumAlpha.style.setProperty("--ag-internal-spectrum-alpha-color", rgbaColor);
        if (!suppressColorInputUpdate) this.colorInput.setColor(color);
    }
    /**
   * @param saturation In the [0, 1] interval.
   * @param brightness In the [0, 1] interval.
   */ setSpectrumValue(saturation, brightness, suppressColorInputUpdate) {
        const valRect = this.spectrumValRect || this.refreshSpectrumRect();
        if (valRect == null) return;
        const dragger = this.spectrumDragger;
        const draggerRect = dragger.getBoundingClientRect();
        saturation = Math.max(0, saturation);
        saturation = Math.min(1, saturation);
        brightness = Math.max(0, brightness);
        brightness = Math.min(1, brightness);
        this.S = saturation;
        this.B = brightness;
        dragger.style.left = saturation * valRect.width - draggerRect.width / 2 + "px";
        dragger.style.top = (1 - brightness) * valRect.height - draggerRect.height / 2 + "px";
        this.update(suppressColorInputUpdate);
    }
    getSpectrumValue() {
        const dragger = this.spectrumDragger;
        const draggerRect = dragger.getBoundingClientRect();
        const x = parseFloat(dragger.style.left) + draggerRect.width / 2;
        const y = parseFloat(dragger.style.top) + draggerRect.height / 2;
        return {
            x: x,
            y: y
        };
    }
    initRecentColors() {
        const recentColors = $5b7ccabde48fae90$var$sharedRecentColors;
        const colorsHtmlStr = recentColors.map((color, index)=>{
            return /* html */ `<div class="ag-recent-color" id=${index} style="background-color: ${color}; width: 15px; height: 15px;" recent-color="${color}" tabIndex="${this.tabIndex}"></div>`;
        });
        this.recentColors.innerHTML = colorsHtmlStr.join("");
        (0, $jIDNV._setDisplayed)(this.recentColors, !!recentColors.length);
    }
    setValue(val) {
        const color = this._Color.fromString(val);
        this.setColor(color, true);
    }
    setColor(color, updateColorInput) {
        const [h, s, b] = color.toHSB();
        this.H = (isNaN(h) ? 0 : h) / 360;
        this.A = color.a;
        const spectrumHueRect = this.spectrumHueRect || this.refreshHueRect();
        const spectrumAlphaRect = this.spectrumAlphaRect || this.refreshAlphaRect();
        this.spectrumHueSlider.style.left = `${(this.H - 1) * -spectrumHueRect.width - this.spectrumHueSlider.getBoundingClientRect().width / 2}px`;
        this.spectrumAlphaSlider.style.left = `${this.A * spectrumAlphaRect.width - this.spectrumAlphaSlider.getBoundingClientRect().width / 2}px`;
        this.setSpectrumValue(s, b, !updateColorInput);
    }
    onRecentColorClick(e) {
        const target = e.target;
        if (!(0, $jIDNV._exists)(target.id)) return;
        const id = parseInt(target.id, 10);
        this.setValue($5b7ccabde48fae90$var$sharedRecentColors[id]);
        this.destroy();
    }
    addRecentColor() {
        const color = this._Color.fromHSB(this.H * 360, this.S, this.B, this.A);
        const rgbaColor = color.toRgbaString();
        let recentColors = $5b7ccabde48fae90$var$sharedRecentColors;
        if (!this.colorChanged || recentColors[0] === rgbaColor) return;
        recentColors = recentColors.filter((currentColor)=>currentColor != rgbaColor);
        recentColors = [
            rgbaColor
        ].concat(recentColors);
        if (recentColors.length > $5b7ccabde48fae90$var$maxRecentColors) recentColors = recentColors.slice(0, $5b7ccabde48fae90$var$maxRecentColors);
        $5b7ccabde48fae90$var$sharedRecentColors = recentColors;
    }
    destroy() {
        this.addRecentColor();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/charts/widgets/agColorPicker.ts
var $5b7ccabde48fae90$var$AgColorPicker = class extends (0, $jIDNV.AgPickerField) {
    constructor(config){
        super({
            pickerAriaLabelKey: "ariaLabelColorPicker",
            pickerAriaLabelValue: "Color Picker",
            pickerType: "ag-list",
            className: "ag-color-picker",
            pickerIcon: "chartsColorPicker",
            ...config
        });
    }
    postConstruct() {
        this.eDisplayFieldColor = (0, $jIDNV._createElement)({
            tag: "span",
            cls: "ag-color-picker-color"
        });
        this.eDisplayFieldText = (0, $jIDNV._createElement)({
            tag: "span",
            cls: "ag-color-picker-value"
        });
        this.eDisplayField.append(this.eDisplayFieldColor, this.eDisplayFieldText);
        super.postConstruct();
        if (this.value) this.setValue(this.value);
    }
    createPickerComponent() {
        const eGuiRect = this.eWrapper.getBoundingClientRect();
        const parentRect = this.beans.popupSvc.getParentRect();
        const colorDialog = this.createBean(new $5b7ccabde48fae90$var$AgDialog({
            closable: false,
            modal: true,
            hideTitleBar: true,
            minWidth: 190,
            width: 190,
            height: 250,
            x: eGuiRect.right - parentRect.left - 190,
            y: eGuiRect.top - parentRect.top - 250 - (this.config.pickerGap ?? 0),
            postProcessPopupParams: {
                type: "colorPicker",
                eventSource: this.eWrapper
            }
        }));
        return colorDialog;
    }
    renderAndPositionPicker() {
        const pickerComponent = this.pickerComponent;
        const colorPanel = this.createBean(new $5b7ccabde48fae90$var$AgColorPanel({
            picker: this
        }));
        pickerComponent.addCss("ag-color-dialog");
        colorPanel.addDestroyFunc(()=>{
            if (pickerComponent.isAlive()) this.destroyBean(pickerComponent);
        });
        pickerComponent.setParentComponent(this);
        pickerComponent.setBodyComponent(colorPanel);
        colorPanel.setValue(this.getValue());
        colorPanel.getGui().focus();
        pickerComponent.addDestroyFunc(()=>{
            if (!this.isDestroyingPicker) {
                this.beforeHidePicker();
                this.isDestroyingPicker = true;
                if (colorPanel.isAlive()) this.destroyBean(colorPanel);
                if (this.isAlive()) this.getFocusableElement().focus();
            } else this.isDestroyingPicker = false;
        });
        return ()=>this.pickerComponent?.close();
    }
    setValue(color) {
        if (this.value === color) return this;
        this.eDisplayFieldColor.style.backgroundColor = color;
        this.eDisplayFieldText.textContent = this.beans.agChartsExports._Util.Color.fromString(color).toHexString().toUpperCase();
        return super.setValue(color);
    }
    getValue() {
        return this.value;
    }
};
var $5b7ccabde48fae90$var$AgColorPickerSelector = {
    selector: "AG-COLOR-PICKER",
    component: $5b7ccabde48fae90$var$AgColorPicker
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/advancedSettings/interactivity/crosshairPanel.ts
var $5b7ccabde48fae90$var$CrosshairPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuParamsFactory){
        super();
        this.chartMenuParamsFactory = chartMenuParamsFactory;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const crosshairGroupParams = this.chartMenuParamsFactory.addEnableParams("crosshair.enabled", {
            cssIdentifier: "charts-advanced-settings-top-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("crosshair"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const crosshairLabelCheckboxParams = this.chartMenuParamsFactory.getDefaultCheckboxParams("crosshair.label.enabled", "crosshairLabel");
        const crosshairSnapCheckboxParams = this.chartMenuParamsFactory.getDefaultCheckboxParams("crosshair.snap", "crosshairSnap");
        const crosshairStrokeColorPickerParams = this.chartMenuParamsFactory.getDefaultColorPickerParams("crosshair.stroke", "color");
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="crosshairGroup">
                <ag-checkbox data-ref="crosshairLabelCheckbox"></ag-checkbox>
                <ag-checkbox data-ref="crosshairSnapCheckbox"></ag-checkbox>
                <ag-color-picker data-ref="crosshairStrokeColorPicker"></ag-color-picker>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            (0, $jIDNV.AgCheckboxSelector),
            $5b7ccabde48fae90$var$AgColorPickerSelector
        ], {
            crosshairGroup: crosshairGroupParams,
            crosshairLabelCheckbox: crosshairLabelCheckboxParams,
            crosshairSnapCheckbox: crosshairSnapCheckboxParams,
            crosshairStrokeColorPicker: crosshairStrokeColorPickerParams
        });
    }
};
var $5b7ccabde48fae90$var$AgInputRange = class extends (0, $jIDNV.AgAbstractInputField) {
    constructor(config){
        super(config, "ag-range-field", "range");
    }
    postConstruct() {
        super.postConstruct();
        const { min: min, max: max, step: step } = this.config;
        if (min != null) this.setMinValue(min);
        if (max != null) this.setMaxValue(max);
        this.setStep(step || 1);
    }
    addInputListeners() {
        this.addManagedElementListeners(this.eInput, {
            input: (e)=>{
                const value = e.target.value;
                this.setValue(value);
            }
        });
    }
    setMinValue(value) {
        this.min = value;
        this.eInput.setAttribute("min", value.toString());
        return this;
    }
    setMaxValue(value) {
        this.max = value;
        this.eInput.setAttribute("max", value.toString());
        return this;
    }
    setStep(value) {
        this.eInput.setAttribute("step", value.toString());
        return this;
    }
    setValue(value, silent) {
        if (this.min != null) value = Math.max(parseFloat(value), this.min).toString();
        if (this.max != null) value = Math.min(parseFloat(value), this.max).toString();
        const ret = super.setValue(value, silent);
        this.eInput.value = value;
        return ret;
    }
};
var $5b7ccabde48fae90$var$AgInputRangeSelector = {
    selector: "AG-INPUT-RANGE",
    component: $5b7ccabde48fae90$var$AgInputRange
};
// packages/ag-grid-enterprise/src/charts/widgets/agSlider.ts
var $5b7ccabde48fae90$var$AgSlider = class extends (0, $jIDNV.AgAbstractLabel) {
    constructor(config){
        super(config, /* html */ `<div class="ag-slider">
            <label data-ref="eLabel"></label>
            <div class="ag-wrapper ag-slider-wrapper">
                <ag-input-range data-ref="eSlider"></ag-input-range>
                <ag-input-number-field data-ref="eText"></ag-input-number-field>
            </div>
        </div>`, [
            $5b7ccabde48fae90$var$AgInputRangeSelector,
            (0, $jIDNV.AgInputNumberFieldSelector)
        ]);
        this.eLabel = (0, $jIDNV.RefPlaceholder);
        this.eSlider = (0, $jIDNV.RefPlaceholder);
        this.eText = (0, $jIDNV.RefPlaceholder);
        this.labelAlignment = "top";
    }
    postConstruct() {
        super.postConstruct();
        this.eSlider.addCss("ag-slider-field");
        const { minValue: minValue, maxValue: maxValue, textFieldWidth: textFieldWidth, step: step, value: value, onValueChange: onValueChange } = this.config;
        if (minValue != null) this.setMinValue(minValue);
        if (maxValue != null) this.setMaxValue(maxValue);
        if (textFieldWidth != null) this.setTextFieldWidth(textFieldWidth);
        if (step != null) this.setStep(step);
        if (value != null) this.setValue(value);
        if (onValueChange != null) this.onValueChange(onValueChange);
    }
    onValueChange(callbackFn) {
        this.addManagedListeners(this.eText, {
            fieldValueChanged: ()=>{
                const textValue = parseFloat(this.eText.getValue());
                this.eSlider.setValue(textValue.toString(), true);
                callbackFn(textValue || 0);
            }
        });
        this.addManagedListeners(this.eSlider, {
            fieldValueChanged: ()=>{
                const sliderValue = this.eSlider.getValue();
                this.eText.setValue(sliderValue, true);
                callbackFn(parseFloat(sliderValue));
            }
        });
        return this;
    }
    setSliderWidth(width) {
        this.eSlider.setWidth(width);
        return this;
    }
    setTextFieldWidth(width) {
        this.eText.setWidth(width);
        return this;
    }
    setMinValue(minValue) {
        this.eSlider.setMinValue(minValue);
        this.eText.setMin(minValue);
        return this;
    }
    setMaxValue(maxValue) {
        this.eSlider.setMaxValue(maxValue);
        this.eText.setMax(maxValue);
        return this;
    }
    getValue() {
        return this.eText.getValue();
    }
    setValue(value, silent) {
        if (this.getValue() === value) return this;
        this.eText.setValue(value, true);
        this.eSlider.setValue(value, true);
        if (!silent) this.dispatchLocalEvent({
            type: "fieldValueChanged"
        });
        return this;
    }
    setStep(step) {
        this.eSlider.setStep(step);
        this.eText.setStep(step);
        return this;
    }
};
var $5b7ccabde48fae90$var$AgSliderSelector = {
    selector: "AG-SLIDER",
    component: $5b7ccabde48fae90$var$AgSlider
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/advancedSettings/interactivity/navigatorPanel.ts
var $5b7ccabde48fae90$var$NavigatorPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuParamsFactory){
        super();
        this.chartMenuParamsFactory = chartMenuParamsFactory;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const navigatorGroupParams = this.chartMenuParamsFactory.addEnableParams("navigator.enabled", {
            cssIdentifier: "charts-advanced-settings-top-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("navigator"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const navigatorHeightSliderParams = this.chartMenuParamsFactory.getDefaultSliderParams("navigator.height", "height", 60);
        navigatorHeightSliderParams.minValue = 10;
        const navigatorMiniChartCheckboxParams = this.chartMenuParamsFactory.getDefaultCheckboxParams("navigator.miniChart.enabled", "miniChart");
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="navigatorGroup">
                <ag-slider data-ref="navigatorHeightSlider"></ag-slider>
                <ag-checkbox data-ref="navigatorMiniChartCheckbox"></ag-checkbox>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            $5b7ccabde48fae90$var$AgSliderSelector,
            (0, $jIDNV.AgCheckboxSelector)
        ], {
            navigatorGroup: navigatorGroupParams,
            navigatorHeightSlider: navigatorHeightSliderParams,
            navigatorMiniChartCheckbox: navigatorMiniChartCheckboxParams
        });
    }
};
var $5b7ccabde48fae90$var$ZoomPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuParamsFactory){
        super();
        this.chartMenuParamsFactory = chartMenuParamsFactory;
        this.zoomScrollingStepInput = (0, $jIDNV.RefPlaceholder);
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const zoomGroupParams = this.chartMenuParamsFactory.addEnableParams("zoom.enabled", {
            cssIdentifier: "charts-advanced-settings-top-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("zoom"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const zoomScrollingCheckboxParams = this.chartMenuParamsFactory.getDefaultCheckboxParams("zoom.enableScrolling", "scrollingZoom");
        const zoomScrollingStepSliderParams = this.chartMenuParamsFactory.getDefaultSliderParams("zoom.scrollingStep", "scrollingStep", 1);
        zoomScrollingStepSliderParams.step = 0.01;
        zoomScrollingStepSliderParams.minValue = zoomScrollingStepSliderParams.step;
        const zoomSelectingCheckboxParams = this.chartMenuParamsFactory.getDefaultCheckboxParams("zoom.enableSelecting", "selectingZoom");
        zoomScrollingCheckboxParams.onValueChange = /* @__PURE__ */ ((onValueChange)=>(value)=>{
                if (!onValueChange) return;
                onValueChange(value);
                this.zoomScrollingStepInput.setDisabled(!value);
            })(zoomScrollingCheckboxParams.onValueChange);
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="zoomGroup">
                <ag-checkbox data-ref="zoomSelectingCheckbox"></ag-checkbox>
                <ag-checkbox data-ref="zoomScrollingCheckbox"></ag-checkbox>
                <ag-slider data-ref="zoomScrollingStepInput"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            (0, $jIDNV.AgCheckboxSelector),
            $5b7ccabde48fae90$var$AgSliderSelector
        ], {
            zoomGroup: zoomGroupParams,
            zoomScrollingCheckbox: zoomScrollingCheckboxParams,
            zoomScrollingStepInput: zoomScrollingStepSliderParams,
            zoomSelectingCheckbox: zoomSelectingCheckboxParams
        });
        this.zoomScrollingStepInput.setDisabled(!zoomScrollingCheckboxParams.value);
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/advancedSettings/advancedSettingsPanel.ts
var $5b7ccabde48fae90$var$INTERACTIVITY_GROUPS = [
    "navigator",
    "zoom",
    "animation",
    "crosshair"
];
var $5b7ccabde48fae90$var$AdvancedSettingsPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuContext){
        super(/* html */ `<div class="ag-chart-advanced-settings-wrapper"></div>`);
        this.chartMenuContext = chartMenuContext;
    }
    postConstruct() {
        this.chartPanelFeature = this.createManagedBean(new $5b7ccabde48fae90$var$ChartPanelFeature(this.chartMenuContext.chartController, this.getGui(), "ag-chart-advanced-settings-section", (chartType, seriesType)=>this.createPanels(chartType, seriesType)));
        this.chartPanelFeature.refreshPanels();
    }
    createPanels(chartType, seriesType) {
        $5b7ccabde48fae90$var$INTERACTIVITY_GROUPS.forEach((group)=>{
            if (!this.isGroupPanelShownForSeries(group, seriesType)) return;
            const comp = this.createPanel(group);
            this.chartPanelFeature.addComponent(comp);
        });
    }
    isGroupPanelShownForSeries(group, seriesType) {
        return group === "animation" || $5b7ccabde48fae90$var$isCartesian(seriesType) && !$5b7ccabde48fae90$var$isFunnel(seriesType);
    }
    createPanel(group) {
        const { chartMenuParamsFactory: chartMenuParamsFactory, chartAxisMenuParamsFactory: chartAxisMenuParamsFactory } = this.chartMenuContext;
        switch(group){
            case "navigator":
                return new $5b7ccabde48fae90$var$NavigatorPanel(chartMenuParamsFactory);
            case "zoom":
                return new $5b7ccabde48fae90$var$ZoomPanel(chartMenuParamsFactory);
            case "animation":
                return new $5b7ccabde48fae90$var$AnimationPanel(chartMenuParamsFactory);
            case "crosshair":
                return new $5b7ccabde48fae90$var$CrosshairPanel(chartAxisMenuParamsFactory);
        }
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/advancedSettings/advancedSettingsMenuFactory.ts
var $5b7ccabde48fae90$var$AdvancedSettingsMenuFactory = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "advSettingsMenuFactory";
    }
    showMenu(chartMenuContext, eventSource) {
        this.hideMenu();
        const menu = this.createBean(new $5b7ccabde48fae90$var$AdvancedSettingsMenu(chartMenuContext));
        this.activeDialog = this.createBean(new $5b7ccabde48fae90$var$AgDialog({
            title: this.beans.chartTranslation.translate("advancedSettings"),
            component: menu,
            width: 300,
            height: 400,
            resizable: true,
            movable: true,
            centered: true,
            closable: true,
            afterGuiAttached: ()=>{
                (0, $jIDNV._findFocusableElements)(menu.getGui())[0]?.focus();
            },
            closedCallback: ()=>{
                this.activeMenu = this.destroyBean(this.activeMenu);
                this.activeDialog = void 0;
                eventSource?.focus({
                    preventScroll: true
                });
            }
        }));
        this.activeMenu = menu;
    }
    hideMenu() {
        if (this.activeDialog) this.destroyBean(this.activeDialog);
    }
    destroy() {
        this.activeMenu = this.destroyBean(this.activeMenu);
        this.activeDialog = this.destroyBean(this.activeDialog);
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$AdvancedSettingsMenu = class extends (0, $jIDNV.TabGuardComp) {
    constructor(chartMenuContext){
        super(/* html */ `<div class="ag-chart-advanced-settings"></div>`);
        this.chartMenuContext = chartMenuContext;
    }
    postConstruct() {
        this.advancedSettingsPanel = this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedSettingsPanel(this.chartMenuContext));
        this.getGui().appendChild(this.advancedSettingsPanel.getGui());
        this.initialiseTabGuard({
            onTabKeyDown: this.onTabKeyDown.bind(this),
            focusTrapActive: true
        });
    }
    onTabKeyDown(e) {
        if (e.defaultPrevented) return;
        e.preventDefault();
        const backwards = e.shiftKey;
        const panelGui = this.advancedSettingsPanel.getGui();
        const nextEl = (0, $jIDNV._findNextFocusableElement)(this.beans, panelGui, false, backwards);
        if (nextEl) nextEl.focus();
        else {
            const focusableElements = (0, $jIDNV._findFocusableElements)(panelGui);
            if (focusableElements.length) focusableElements[backwards ? focusableElements.length - 1 : 0].focus();
        }
    }
};
var $5b7ccabde48fae90$var$ChartMenuListFactory = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "chartMenuListFactory";
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
        this.chartMenuSvc = beans.chartMenuSvc;
        this.chartTranslation = beans.chartTranslation;
    }
    showMenuList(params) {
        const { eventSource: eventSource, showMenu: showMenu, chartMenuContext: chartMenuContext } = params;
        const areChartToolPanelsEnabled = this.chartMenuSvc.doChartToolPanelsExist(chartMenuContext.chartController);
        const menuItems = this.mapWithStockItems(this.getMenuItems(chartMenuContext.chartController, areChartToolPanelsEnabled), chartMenuContext, showMenu, eventSource, areChartToolPanelsEnabled);
        if (!menuItems.length) return;
        const chartMenuList = this.createBean(new $5b7ccabde48fae90$var$ChartMenuList(menuItems));
        this.activeChartMenuList = chartMenuList;
        let multiplier = -1;
        let alignSide = "left";
        if (this.gos.get("enableRtl")) {
            multiplier = 1;
            alignSide = "right";
        }
        const eGui = chartMenuList.getGui();
        this.popupSvc.addPopup({
            modal: true,
            eChild: eGui,
            closeOnEsc: true,
            closedCallback: ()=>{
                this.destroyBean(chartMenuList);
                this.activeChartMenuList = void 0;
                if ((0, $jIDNV._isNothingFocused)(this.beans)) eventSource.focus({
                    preventScroll: true
                });
            },
            afterGuiAttached: (params2)=>chartMenuList.afterGuiAttached(params2),
            positionCallback: ()=>{
                this.popupSvc.positionPopupByComponent({
                    type: "chartMenu",
                    eventSource: eventSource,
                    ePopup: eGui,
                    alignSide: alignSide,
                    nudgeX: 4 * multiplier,
                    nudgeY: 4,
                    position: "under",
                    keepWithinBounds: true
                });
            },
            ariaLabel: "Chart Menu"
        });
    }
    getMenuItems(chartController, areChartToolPanelsEnabled) {
        const defaultItems = [
            ...areChartToolPanelsEnabled ? [
                "chartEdit"
            ] : [],
            ...chartController.isEnterprise() ? [
                "chartAdvancedSettings"
            ] : [],
            chartController.isChartLinked() ? "chartUnlink" : "chartLink",
            "chartDownload"
        ];
        const chartMenuItems = this.gos.get("chartMenuItems");
        if (!chartMenuItems) return defaultItems;
        else if (Array.isArray(chartMenuItems)) return chartMenuItems;
        else return chartMenuItems((0, $jIDNV._addGridCommonParams)(this.gos, {
            defaultItems: defaultItems,
            chartId: chartController.getChartId()
        }));
    }
    mapWithStockItems(originalList, chartMenuContext, showMenu, eventSource, areChartToolPanelsEnabled) {
        if (!originalList) return [];
        const resultList = [];
        originalList.forEach((menuItemOrString)=>{
            let result;
            if (typeof menuItemOrString === "string") result = this.getStockMenuItem(menuItemOrString, chartMenuContext, showMenu, eventSource, areChartToolPanelsEnabled);
            else result = {
                ...menuItemOrString
            };
            if (!result) return;
            const { subMenu: subMenu } = result;
            if (Array.isArray(subMenu)) result.subMenu = this.mapWithStockItems(subMenu, chartMenuContext, showMenu, eventSource, areChartToolPanelsEnabled);
            resultList.push(result);
        });
        return resultList;
    }
    getStockMenuItem(key, chartMenuContext, showMenu, eventSource, areChartToolPanelsEnabled) {
        switch(key){
            case "chartEdit":
                return areChartToolPanelsEnabled ? this.createMenuItem(this.chartTranslation.translate("chartEdit"), "chartsMenuEdit", showMenu) : null;
            case "chartAdvancedSettings":
                return this.createMenuItem(this.chartTranslation.translate("chartAdvancedSettings"), "chartsMenuAdvancedSettings", ()=>this.chartMenuSvc.openAdvancedSettings(chartMenuContext, eventSource));
            case "chartUnlink":
                return chartMenuContext.chartController.isChartLinked() ? this.createMenuItem(this.chartTranslation.translate("chartUnlink"), "unlinked", ()=>this.chartMenuSvc.toggleLinked(chartMenuContext)) : null;
            case "chartLink":
                return !chartMenuContext.chartController.isChartLinked() ? this.createMenuItem(this.chartTranslation.translate("chartLink"), "linked", ()=>this.chartMenuSvc.toggleLinked(chartMenuContext)) : null;
            case "chartDownload":
                return this.createMenuItem(this.chartTranslation.translate("chartDownload"), "chartsDownload", ()=>this.chartMenuSvc.downloadChart(chartMenuContext));
        }
        return null;
    }
    createMenuItem(name, iconName, action) {
        return {
            name: name,
            icon: (0, $jIDNV._createIconNoSpan)(iconName, this.beans, null),
            action: action
        };
    }
    destroy() {
        this.destroyBean(this.activeChartMenuList);
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$ChartMenuList = class extends (0, $jIDNV.Component) {
    constructor(menuItems){
        super(/* html */ `
            <div data-ref="eChartsMenu" role="presentation" class="ag-menu ag-chart-menu-popup"></div>
        `);
        this.menuItems = menuItems;
        this.eChartsMenu = (0, $jIDNV.RefPlaceholder);
    }
    postConstruct() {
        this.mainMenuList = this.createManagedBean(new $5b7ccabde48fae90$var$AgMenuList(0));
        this.mainMenuList.addMenuItems(this.menuItems);
        this.mainMenuList.addEventListener("closeMenu", this.onHidePopup.bind(this));
        this.eChartsMenu.appendChild(this.mainMenuList.getGui());
    }
    onHidePopup() {
        this.hidePopupFunc?.();
    }
    afterGuiAttached({ hidePopup: hidePopup }) {
        if (hidePopup) {
            this.hidePopupFunc = hidePopup;
            this.addDestroyFunc(hidePopup);
        }
        (0, $jIDNV._focusInto)(this.mainMenuList.getGui());
    }
};
var $5b7ccabde48fae90$var$ChartCrossFilterService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "chartCrossFilterSvc";
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.valueSvc = beans.valueSvc;
        this.filterManager = beans.filterManager;
        if ((0, $jIDNV._isClientSideRowModel)(this.gos, beans.rowModel)) this.clientSideRowModel = beans.rowModel;
    }
    filter(event, reset = false) {
        const filterModel = this.filterManager?.getFilterModel() ?? {};
        if (reset) {
            this.resetFilters(filterModel);
            return;
        }
        const colId = this.extractFilterColId(event);
        if (this.isValidColumnFilter(colId)) this.updateFilters(filterModel, event, colId);
        else (0, $jIDNV._warn)(154, {
            colId: colId
        });
    }
    resetFilters(filterModel) {
        const filtersExist = Object.keys(filterModel).length > 0;
        if (filtersExist) {
            this.filterManager?.setFilterModel(null);
            this.filterManager?.onFilterChanged({
                source: "api"
            });
        }
    }
    updateFilters(filterModel, event, colId) {
        const dataKey = this.extractFilterColId(event);
        const rawValue = event.datum[dataKey];
        if (rawValue === void 0) return;
        const selectedValue = rawValue.toString();
        if (event.event.metaKey || event.event.ctrlKey) {
            const existingGridValues = this.getCurrentGridValuesForCategory(colId);
            const valueAlreadyExists = existingGridValues.includes(selectedValue);
            let updatedValues;
            if (valueAlreadyExists) updatedValues = existingGridValues.filter((v)=>v !== selectedValue);
            else {
                updatedValues = existingGridValues;
                updatedValues.push(selectedValue);
            }
            filterModel[colId] = this.getUpdatedFilterModel(colId, updatedValues);
        } else {
            const updatedValues = [
                selectedValue
            ];
            filterModel = {
                [colId]: this.getUpdatedFilterModel(colId, updatedValues)
            };
        }
        this.filterManager?.setFilterModel(filterModel);
    }
    getUpdatedFilterModel(colId, updatedValues) {
        const columnFilterType = this.getColumnFilterType(colId);
        if (columnFilterType === "agMultiColumnFilter") return {
            filterType: "multi",
            filterModels: [
                null,
                {
                    filterType: "set",
                    values: updatedValues
                }
            ]
        };
        return {
            filterType: "set",
            values: updatedValues
        };
    }
    getCurrentGridValuesForCategory(colId) {
        const filteredValues = [];
        const column = this.getColumnById(colId);
        this.clientSideRowModel?.forEachNodeAfterFilter((rowNode)=>{
            if (column && !rowNode.group) {
                const value = this.valueSvc.getValue(column, rowNode) + "";
                if (!filteredValues.includes(value)) filteredValues.push(value);
            }
        });
        return filteredValues;
    }
    extractFilterColId(event) {
        return event.xKey || event.calloutLabelKey;
    }
    isValidColumnFilter(colId) {
        if (colId.indexOf("-filtered-out")) colId = colId.replace("-filtered-out", "");
        const filterType = this.getColumnFilterType(colId);
        if (typeof filterType === "boolean") return filterType;
        return [
            "agSetColumnFilter",
            "agMultiColumnFilter"
        ].includes(filterType);
    }
    getColumnFilterType(colId) {
        const gridColumn = this.getColumnById(colId);
        if (gridColumn) {
            const colDef = gridColumn.getColDef();
            return colDef.filter;
        }
    }
    getColumnById(colId) {
        return this.colModel.getCol(colId);
    }
};
var $5b7ccabde48fae90$var$CHART_TOOLBAR_ALLOW_LIST = [
    "chartUnlink",
    "chartLink",
    "chartDownload",
    "chartMenu"
];
var $5b7ccabde48fae90$var$CHART_TOOL_PANEL_MENU_OPTIONS = {
    settings: "chartSettings",
    data: "chartData",
    format: "chartFormat"
};
var $5b7ccabde48fae90$var$ChartMenuService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "chartMenuSvc";
    }
    wireBeans(beans) {
        this.advSettingsMenuFactory = beans.advSettingsMenuFactory;
    }
    downloadChart(chartMenuContext, dimensions, fileName, fileFormat) {
        chartMenuContext.chartController.getChartProxy().downloadChart(dimensions, fileName, fileFormat);
    }
    toggleLinked(chartMenuContext) {
        chartMenuContext.chartController.detachChartRange();
    }
    openAdvancedSettings(chartMenuContext, eventSource) {
        this.advSettingsMenuFactory?.showMenu(chartMenuContext, eventSource);
    }
    hideAdvancedSettings() {
        this.advSettingsMenuFactory?.hideMenu();
    }
    getChartToolbarOptions() {
        const defaultChartToolbarOptions = [
            "chartMenu"
        ];
        const toolbarItemsFunc = this.gos.getCallback("getChartToolbarItems");
        const params = {
            defaultItems: defaultChartToolbarOptions
        };
        return toolbarItemsFunc ? toolbarItemsFunc(params).filter((option)=>{
            if (!$5b7ccabde48fae90$var$CHART_TOOLBAR_ALLOW_LIST.includes(option)) {
                (0, $jIDNV._warn)(155, {
                    option: option
                });
                return false;
            }
            return true;
        }) : defaultChartToolbarOptions;
    }
    getChartToolPanels(chartController) {
        const chartToolPanelsDef = this.gos.get("chartToolPanelsDef");
        const panelsOverride = chartToolPanelsDef?.panels?.map((panel)=>{
            const menuOption = $5b7ccabde48fae90$var$CHART_TOOL_PANEL_MENU_OPTIONS[panel];
            if (!menuOption) (0, $jIDNV._warn)(156, {
                panel: panel
            });
            return menuOption;
        }).filter((panel)=>Boolean(panel));
        let panels = panelsOverride ?? Object.values($5b7ccabde48fae90$var$CHART_TOOL_PANEL_MENU_OPTIONS);
        if (chartController.isPivotChart()) panels = panels.filter((panel)=>panel !== "chartData");
        const defaultToolPanel = chartToolPanelsDef?.defaultToolPanel;
        const defaultPanel = defaultToolPanel && $5b7ccabde48fae90$var$CHART_TOOL_PANEL_MENU_OPTIONS[defaultToolPanel] || panels[0];
        return {
            panels: panels,
            defaultPanel: defaultPanel
        };
    }
    doesChartToolbarExist() {
        const chartToolbarOptions = this.getChartToolbarOptions();
        return chartToolbarOptions.length > 0;
    }
    doChartToolPanelsExist(chartController) {
        const { panels: panels } = this.getChartToolPanels(chartController);
        return panels.length > 0;
    }
};
var $5b7ccabde48fae90$var$DEFAULT_CHART_TRANSLATIONS = {
    pivotChartTitle: "Pivot Chart",
    rangeChartTitle: "Range Chart",
    settings: "Chart",
    data: "Set Up",
    format: "Customize",
    categories: "Categories",
    defaultCategory: "(None)",
    series: "Series",
    switchCategorySeries: "Switch Category / Series",
    categoryValues: "Category Values",
    seriesLabels: "Series Labels",
    aggregate: "Aggregate",
    xyValues: "X Y Values",
    paired: "Paired Mode",
    axis: "Axis",
    xAxis: "Horizontal Axis",
    yAxis: "Vertical Axis",
    polarAxis: "Polar Axis",
    radiusAxis: "Radius Axis",
    navigator: "Navigator",
    zoom: "Zoom",
    animation: "Animation",
    crosshair: "Crosshair",
    color: "Color",
    thickness: "Thickness",
    preferredLength: "Preferred Length",
    xType: "X Type",
    axisType: "Axis Type",
    automatic: "Automatic",
    category: "Category",
    number: "Number",
    time: "Time",
    timeFormat: "Time Format",
    autoRotate: "Auto Rotate",
    labelRotation: "Rotation",
    circle: "Circle",
    polygon: "Polygon",
    square: "Square",
    cross: "Cross",
    diamond: "Diamond",
    plus: "Plus",
    triangle: "Triangle",
    heart: "Heart",
    orientation: "Orientation",
    fixed: "Fixed",
    parallel: "Parallel",
    perpendicular: "Perpendicular",
    radiusAxisPosition: "Position",
    ticks: "Ticks",
    gridLines: "Grid Lines",
    width: "Width",
    height: "Height",
    length: "Length",
    padding: "Padding",
    spacing: "Spacing",
    chartStyle: "Chart Style",
    title: "Title",
    chartTitles: "Titles",
    chartTitle: "Chart Title",
    chartSubtitle: "Subtitle",
    horizontalAxisTitle: "Horizontal Axis Title",
    verticalAxisTitle: "Vertical Axis Title",
    polarAxisTitle: "Polar Axis Title",
    titlePlaceholder: "Chart Title",
    background: "Background",
    font: "Font",
    weight: "Weight",
    top: "Top",
    right: "Right",
    bottom: "Bottom",
    left: "Left",
    labels: "Labels",
    calloutLabels: "Callout Labels",
    sectorLabels: "Sector Labels",
    positionRatio: "Position Ratio",
    size: "Size",
    shape: "Shape",
    minSize: "Minimum Size",
    maxSize: "Maximum Size",
    legend: "Legend",
    position: "Position",
    markerSize: "Marker Size",
    markerStroke: "Marker Stroke",
    markerPadding: "Marker Padding",
    itemSpacing: "Item Spacing",
    itemPaddingX: "Item Padding X",
    itemPaddingY: "Item Padding Y",
    layoutHorizontalSpacing: "Horizontal Spacing",
    layoutVerticalSpacing: "Vertical Spacing",
    strokeWidth: "Stroke Width",
    offset: "Offset",
    offsets: "Offsets",
    tooltips: "Tooltips",
    callout: "Callout",
    markers: "Markers",
    shadow: "Shadow",
    blur: "Blur",
    xOffset: "X Offset",
    yOffset: "Y Offset",
    lineWidth: "Line Width",
    lineDash: "Line Dash",
    lineDashOffset: "Dash Offset",
    scrollingZoom: "Scrolling",
    scrollingStep: "Scrolling Step",
    selectingZoom: "Selecting",
    durationMillis: "Duration (ms)",
    crosshairLabel: "Label",
    crosshairSnap: "Snap to Node",
    normal: "Normal",
    bold: "Bold",
    italic: "Italic",
    boldItalic: "Bold Italic",
    predefined: "Predefined",
    fillOpacity: "Fill Opacity",
    strokeColor: "Line Color",
    strokeOpacity: "Line Opacity",
    miniChart: "Mini-Chart",
    histogramBinCount: "Bin count",
    connectorLine: "Connector Line",
    seriesItems: "Series Items",
    seriesItemType: "Item Type",
    seriesItemPositive: "Positive",
    seriesItemNegative: "Negative",
    seriesItemLabels: "Item Labels",
    columnGroup: "Column",
    barGroup: "Bar",
    pieGroup: "Pie",
    lineGroup: "Line",
    scatterGroup: "X Y (Scatter)",
    areaGroup: "Area",
    polarGroup: "Polar",
    statisticalGroup: "Statistical",
    hierarchicalGroup: "Hierarchical",
    specializedGroup: "Specialized",
    combinationGroup: "Combination",
    groupedColumnTooltip: "Grouped",
    stackedColumnTooltip: "Stacked",
    normalizedColumnTooltip: "100% Stacked",
    groupedBarTooltip: "Grouped",
    stackedBarTooltip: "Stacked",
    normalizedBarTooltip: "100% Stacked",
    pieTooltip: "Pie",
    donutTooltip: "Donut",
    lineTooltip: "Line",
    stackedLineTooltip: "Stacked",
    normalizedLineTooltip: "100% Stacked",
    groupedAreaTooltip: "Area",
    stackedAreaTooltip: "Stacked",
    normalizedAreaTooltip: "100% Stacked",
    scatterTooltip: "Scatter",
    bubbleTooltip: "Bubble",
    histogramTooltip: "Histogram",
    radialColumnTooltip: "Radial Column",
    radialBarTooltip: "Radial Bar",
    radarLineTooltip: "Radar Line",
    radarAreaTooltip: "Radar Area",
    nightingaleTooltip: "Nightingale",
    rangeBarTooltip: "Range Bar",
    rangeAreaTooltip: "Range Area",
    boxPlotTooltip: "Box Plot",
    treemapTooltip: "Treemap",
    sunburstTooltip: "Sunburst",
    waterfallTooltip: "Waterfall",
    heatmapTooltip: "Heatmap",
    columnLineComboTooltip: "Column & Line",
    areaColumnComboTooltip: "Area & Column",
    customComboTooltip: "Custom Combination",
    innerRadius: "Inner Radius",
    startAngle: "Start Angle",
    endAngle: "End Angle",
    reverseDirection: "Reverse Direction",
    groupPadding: "Group Padding",
    seriesPadding: "Series Padding",
    tile: "Tile",
    whisker: "Whisker",
    cap: "Cap",
    capLengthRatio: "Length Ratio",
    labelPlacement: "Placement",
    inside: "Inside",
    outside: "Outside",
    noDataToChart: "No data available to be charted.",
    pivotChartRequiresPivotMode: "Pivot Chart requires Pivot Mode enabled.",
    chartSettingsToolbarTooltip: "Menu",
    chartLinkToolbarTooltip: "Linked to Grid",
    chartUnlinkToolbarTooltip: "Unlinked from Grid",
    chartDownloadToolbarTooltip: "Download Chart",
    chartMenuToolbarTooltip: "Menu",
    chartEdit: "Edit Chart",
    chartAdvancedSettings: "Advanced Settings",
    chartLink: "Link to Grid",
    chartUnlink: "Unlink from Grid",
    chartDownload: "Download Chart",
    histogramFrequency: "Frequency",
    seriesChartType: "Series Chart Type",
    seriesType: "Series Type",
    secondaryAxis: "Secondary Axis",
    seriesAdd: "Add a series",
    categoryAdd: "Add a category",
    bar: "Bar",
    column: "Column",
    histogram: "Histogram",
    advancedSettings: "Advanced Settings",
    direction: "Direction",
    horizontal: "Horizontal",
    vertical: "Vertical",
    seriesGroupType: "Group Type",
    groupedSeriesGroupType: "Grouped",
    stackedSeriesGroupType: "Stacked",
    normalizedSeriesGroupType: "100% Stacked",
    legendEnabled: "Enabled",
    invalidColor: "Color value is invalid",
    groupedColumnFull: "Grouped Column",
    stackedColumnFull: "Stacked Column",
    normalizedColumnFull: "100% Stacked Column",
    groupedBarFull: "Grouped Bar",
    stackedBarFull: "Stacked Bar",
    normalizedBarFull: "100% Stacked Bar",
    stackedAreaFull: "Stacked Area",
    normalizedAreaFull: "100% Stacked Area",
    stackedLineFull: "Stacked Line",
    normalizedLineFull: "100% Stacked Line",
    customCombo: "Custom Combination",
    funnel: "Funnel",
    coneFunnel: "Cone Funnel",
    pyramid: "Pyramid",
    funnelGroup: "Funnel",
    funnelTooltip: "Funnel",
    coneFunnelTooltip: "Cone Funnel",
    pyramidTooltip: "Pyramid",
    dropOff: "Drop-Off",
    stageLabels: "Stage Labels",
    reverse: "Reverse",
    tooltipMode: "Tooltip Mode",
    tooltipModeSingle: "Single",
    tooltipModeShared: "Multiple",
    tooltipModeCompact: "Compact",
    // menu items
    groupedColumn: "Grouped",
    stackedColumn: "Stacked",
    pie: "Pie",
    donut: "Donut",
    line: "Line",
    scatter: "Scatter",
    bubble: "Bubble",
    area: "Area",
    stackedArea: "Stacked",
    radarLine: "Radar Line",
    radarArea: "Radar Area",
    nightingale: "Nightingale",
    radialColumn: "Radial Column",
    radialBar: "Radial Bar",
    boxPlot: "Box Plot",
    rangeBar: "Range Bar",
    rangeArea: "Range Area",
    treemap: "Treemap",
    sunburst: "Sunburst",
    waterfall: "Waterfall",
    heatmap: "Heatmap",
    columnLineCombo: "Column & Line",
    AreaColumnCombo: "Area & Column",
    // aria
    ariaChartMenuClose: "Close Chart Edit Menu",
    ariaChartSelected: "Selected",
    // group
    group: "Group",
    // time formats
    timeFormatSlashesDDMMYYYY: "DD/MM/YYYY",
    timeFormatSlashesMMDDYYYY: "MM/DD/YYYY",
    timeFormatSlashesDDMMYY: "DD/MM/YY",
    timeFormatSlashesMMDDYY: "MM/DD/YY",
    timeFormatDotsDDMYY: "DD.M.YY",
    timeFormatDotsMDDYY: "M.DD.YY",
    timeFormatDashesYYYYMMDD: "YYYY-MM-DD",
    timeFormatSpacesDDMMMMYYYY: "DD MMMM YYYY",
    timeFormatHHMMSS: "HH:MM:SS",
    timeFormatHHMMSSAmPm: "HH:MM:SS AM/PM",
    // agg funcs
    sum: "Sum",
    first: "First",
    last: "Last",
    min: "Min",
    max: "Max",
    count: "Count",
    avg: "Average"
};
var $5b7ccabde48fae90$var$ChartTranslationService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "chartTranslation";
    }
    translate(toTranslate) {
        const translate = this.getLocaleTextFunc();
        const defaultTranslation = $5b7ccabde48fae90$var$DEFAULT_CHART_TRANSLATIONS[toTranslate];
        return translate(toTranslate, defaultTranslation);
    }
};
var $5b7ccabde48fae90$var$validateIfDefined = (validationFn)=>{
    return (value)=>{
        if (value == void 0) return true;
        return validationFn(value);
    };
};
var $5b7ccabde48fae90$var$isString = (value)=>typeof value === "string";
var $5b7ccabde48fae90$var$isBoolean = (value)=>typeof value === "boolean";
var $5b7ccabde48fae90$var$isValidSeriesChartType = (value)=>typeof value === "object";
var $5b7ccabde48fae90$var$createWarnMessage = (property, expectedType)=>(value)=>`AG Grid - unable to update chart as invalid params supplied:  \`${property}: ${value}\`, expected ${expectedType}.`;
var $5b7ccabde48fae90$var$createEnterpriseMessage = (feature)=>{
    const url = "https://www.ag-grid.com/javascript-data-grid/integrated-charts-installation/";
    return `${feature} is not supported in AG Charts Community ('ag-charts-enterprise' hasn't been loaded). See ${url} for more details.`;
};
var $5b7ccabde48fae90$var$legacyChartTypes = [
    "doughnut"
];
var $5b7ccabde48fae90$var$baseUpdateChartParams = [
    "type",
    "chartId",
    "chartType",
    "chartThemeName",
    "chartThemeOverrides",
    "unlinkChart"
];
function $5b7ccabde48fae90$var$isValidChartType(value) {
    return !!$5b7ccabde48fae90$var$getSeriesTypeIfExists(value) || $5b7ccabde48fae90$var$isComboChart(value);
}
function $5b7ccabde48fae90$var$isLegacyChartType(value) {
    return $5b7ccabde48fae90$var$legacyChartTypes.includes(value);
}
var $5b7ccabde48fae90$var$validateChartType = $5b7ccabde48fae90$var$validateIfDefined((chartType)=>{
    if ($5b7ccabde48fae90$var$isValidChartType(chartType)) return true;
    if ($5b7ccabde48fae90$var$isLegacyChartType(chartType)) {
        const renamedChartType = $5b7ccabde48fae90$var$getCanonicalChartType(chartType);
        (0, $jIDNV._warnOnce)(`The chart type '${chartType}' has been deprecated. Please use '${renamedChartType}' instead.`);
        return renamedChartType;
    }
    return false;
});
var $5b7ccabde48fae90$var$validateAgChartThemeOverrides = $5b7ccabde48fae90$var$validateIfDefined((themeOverrides)=>{
    return typeof themeOverrides === "object";
});
var $5b7ccabde48fae90$var$validateChartParamsCellRange = $5b7ccabde48fae90$var$validateIfDefined((cellRange)=>{
    return typeof cellRange === "object";
});
var $5b7ccabde48fae90$var$validateAggFunc = $5b7ccabde48fae90$var$validateIfDefined((aggFunc)=>{
    return typeof aggFunc === "string" || typeof aggFunc === "function";
});
var $5b7ccabde48fae90$var$enterpriseChartTypeValidation = (isEnterprise)=>({
        property: "chartType",
        validationFn: $5b7ccabde48fae90$var$validateIfDefined((chartType)=>isEnterprise || !chartType || !$5b7ccabde48fae90$var$isEnterpriseChartType(chartType)),
        warnMessage: (chartType)=>$5b7ccabde48fae90$var$createEnterpriseMessage(`The '${chartType}' chart type`)
    });
var $5b7ccabde48fae90$var$switchCategorySeriesValidation = (isEnterprise)=>({
        property: "switchCategorySeries",
        validationFn: $5b7ccabde48fae90$var$validateIfDefined((switchCategorySeries)=>{
            if (!switchCategorySeries || isEnterprise) return true;
            return void 0;
        }),
        warnMessage: ()=>$5b7ccabde48fae90$var$createEnterpriseMessage(`'switchCategorySeries' has been ignored as it`),
        warnIfFixed: true
    });
var $5b7ccabde48fae90$var$commonUpdateValidations = ()=>[
        {
            property: "chartId",
            validationFn: $5b7ccabde48fae90$var$isString,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("chartId", "string")
        },
        {
            property: "chartType",
            validationFn: $5b7ccabde48fae90$var$validateChartType,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("chartType", "ChartType")
        },
        {
            property: "chartThemeName",
            validationFn: $5b7ccabde48fae90$var$isString,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("chartThemeName", "string")
        },
        {
            property: "chartThemeOverrides",
            validationFn: $5b7ccabde48fae90$var$validateAgChartThemeOverrides,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("chartThemeOverrides", "AgChartThemeOverrides")
        },
        {
            property: "unlinkChart",
            validationFn: $5b7ccabde48fae90$var$isBoolean,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("unlinkChart", "boolean")
        }
    ];
var $5b7ccabde48fae90$var$cellRangeValidations = (isEnterprise)=>[
        {
            property: "cellRange",
            validationFn: $5b7ccabde48fae90$var$validateChartParamsCellRange,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("cellRange", "ChartParamsCellRange")
        },
        {
            property: "suppressChartRanges",
            validationFn: $5b7ccabde48fae90$var$isBoolean,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("suppressChartRanges", "boolean")
        },
        {
            property: "aggFunc",
            validationFn: $5b7ccabde48fae90$var$validateAggFunc,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("aggFunc", "string or IAggFunc")
        },
        $5b7ccabde48fae90$var$switchCategorySeriesValidation(isEnterprise)
    ];
function $5b7ccabde48fae90$var$validateUpdateParams(params, isEnterprise) {
    const paramsToValidate = params;
    switch(paramsToValidate.type){
        case "rangeChartUpdate":
            return $5b7ccabde48fae90$var$validateUpdateRangeChartParams(params, isEnterprise);
        case "pivotChartUpdate":
            return $5b7ccabde48fae90$var$validateUpdatePivotChartParams(params);
        case "crossFilterChartUpdate":
            return $5b7ccabde48fae90$var$validateUpdateCrossFilterChartParams(params, isEnterprise);
        default:
            (0, $jIDNV._warnOnce)(`Invalid value supplied for 'type': ${params.type}. It must be either 'rangeChartUpdate', 'pivotChartUpdate', or 'crossFilterChartUpdate'.`);
            return false;
    }
}
function $5b7ccabde48fae90$var$validateCreateParams(params, isEnterprise) {
    return $5b7ccabde48fae90$var$validateProperties(params, [
        $5b7ccabde48fae90$var$enterpriseChartTypeValidation(isEnterprise),
        $5b7ccabde48fae90$var$switchCategorySeriesValidation(isEnterprise)
    ]);
}
function $5b7ccabde48fae90$var$validateUpdateRangeChartParams(params, isEnterprise) {
    const validations = [
        ...$5b7ccabde48fae90$var$commonUpdateValidations(),
        $5b7ccabde48fae90$var$enterpriseChartTypeValidation(isEnterprise),
        ...$5b7ccabde48fae90$var$cellRangeValidations(isEnterprise),
        {
            property: "seriesChartTypes",
            validationFn: (value)=>value === void 0 || Array.isArray(value) && value.every($5b7ccabde48fae90$var$isValidSeriesChartType),
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("seriesChartTypes", "Array of SeriesChartType")
        }
    ];
    return $5b7ccabde48fae90$var$validateProperties(params, validations, [
        ...$5b7ccabde48fae90$var$baseUpdateChartParams,
        "cellRange",
        "suppressChartRanges",
        "switchCategorySeries",
        "aggFunc",
        "seriesChartTypes",
        "seriesGroupType"
    ], "UpdateRangeChartParams");
}
function $5b7ccabde48fae90$var$validateUpdatePivotChartParams(params) {
    const validations = [
        ...$5b7ccabde48fae90$var$commonUpdateValidations()
    ];
    return $5b7ccabde48fae90$var$validateProperties(params, validations, [
        ...$5b7ccabde48fae90$var$baseUpdateChartParams
    ], "UpdatePivotChartParams");
}
function $5b7ccabde48fae90$var$validateUpdateCrossFilterChartParams(params, isEnterprise) {
    const validations = [
        ...$5b7ccabde48fae90$var$commonUpdateValidations(),
        ...$5b7ccabde48fae90$var$cellRangeValidations(isEnterprise)
    ];
    return $5b7ccabde48fae90$var$validateProperties(params, validations, [
        ...$5b7ccabde48fae90$var$baseUpdateChartParams,
        "cellRange",
        "suppressChartRanges",
        "aggFunc"
    ], "UpdateCrossFilterChartParams");
}
function $5b7ccabde48fae90$var$validateProperties(params, validations, validPropertyNames, paramsType) {
    let validatedProperties = void 0;
    for (const validation of validations){
        const { property: property, validationFn: validationFn, warnMessage: warnMessage, warnIfFixed: warnIfFixed } = validation;
        if (property in params) {
            const value = params[property];
            const validationResult = validationFn(value);
            if (validationResult === true) continue;
            if (validationResult === false) {
                (0, $jIDNV._warnOnce)(warnMessage(value));
                return false;
            }
            validatedProperties = validatedProperties || {
                ...params
            };
            validatedProperties[property] = validationResult;
            if (warnIfFixed) (0, $jIDNV._warnOnce)(warnMessage(value));
        }
    }
    if (validPropertyNames) {
        for (const property of Object.keys(params))if (!validPropertyNames.includes(property)) {
            (0, $jIDNV._warnOnce)(`Unexpected property supplied. ${paramsType} does not contain: \`${property}\`.`);
            return false;
        }
    }
    if (validatedProperties) return validatedProperties;
    return true;
}
// packages/ag-grid-enterprise/src/charts/chartComp/chartController.ts
var $5b7ccabde48fae90$var$DEFAULT_THEMES = [
    "ag-default",
    "ag-material",
    "ag-sheets",
    "ag-polychroma",
    "ag-vivid"
];
var $5b7ccabde48fae90$var$ChartController = class extends (0, $jIDNV.BeanStub) {
    constructor(model){
        super();
        this.model = model;
        this.isEnterprise = ()=>this.agChartsExports.isEnterprise;
    }
    wireBeans(beans) {
        this.rangeSvc = beans.rangeSvc;
        this.agChartsExports = beans.agChartsExports;
    }
    postConstruct() {
        this.setChartRange();
        if (this.model.unlinked) {
            if (this.rangeSvc) this.rangeSvc.setCellRanges([]);
        }
        const listener = this.updateForGridChange.bind(this, {});
        this.addManagedEventListeners({
            cellSelectionChanged: (event)=>{
                if (event.id && event.id === this.model.chartId) this.updateForRangeChange();
            },
            columnMoved: listener,
            columnPinned: listener,
            columnVisible: listener,
            columnRowGroupChanged: listener,
            modelUpdated: listener,
            cellValueChanged: this.updateForDataChange.bind(this),
            cellEditValuesChanged: this.updateForDataChange.bind(this)
        });
    }
    update(params) {
        if (!this.validUpdateType(params)) return false;
        const validationResult = $5b7ccabde48fae90$var$validateUpdateParams(params, this.agChartsExports.isEnterprise);
        if (!validationResult) return false;
        const validParams = validationResult === true ? params : validationResult;
        this.applyValidatedChartParams(validParams);
        return true;
    }
    applyValidatedChartParams(params) {
        const { chartId: chartId, chartType: chartType, chartThemeName: chartThemeName, unlinkChart: unlinkChart } = params;
        const common = {
            chartId: chartId,
            pivotChart: this.model.pivotChart,
            chartType: chartType ?? this.model.chartType,
            chartThemeName: chartThemeName ?? this.model.chartThemeName,
            unlinkChart: unlinkChart ?? this.model.unlinked,
            cellRange: this.model.suppliedCellRange,
            switchCategorySeries: this.model.switchCategorySeries,
            aggFunc: this.model.aggFunc,
            seriesChartTypes: void 0,
            suppressChartRanges: false,
            crossFiltering: false
        };
        const chartModelParams = {
            ...common
        };
        switch(params.type){
            case "rangeChartUpdate":
                chartModelParams.cellRange = this.createCellRange(params) ?? this.model.suppliedCellRange;
                chartModelParams.switchCategorySeries = params.switchCategorySeries ?? this.model.switchCategorySeries;
                chartModelParams.aggFunc = params.aggFunc ?? this.model.aggFunc;
                chartModelParams.seriesChartTypes = params.seriesChartTypes;
                chartModelParams.suppressChartRanges = params.suppressChartRanges ?? this.model.suppressChartRanges;
                chartModelParams.seriesGroupType = params.seriesGroupType ?? this.model.seriesGroupType;
                break;
            case "crossFilterChartUpdate":
                chartModelParams.cellRange = this.createCellRange(params) ?? this.model.suppliedCellRange;
                chartModelParams.switchCategorySeries = false;
                chartModelParams.aggFunc = params.aggFunc ?? this.model.aggFunc;
                chartModelParams.crossFiltering = true;
                chartModelParams.suppressChartRanges = params.suppressChartRanges ?? this.model.suppressChartRanges;
                break;
            case "pivotChartUpdate":
                chartModelParams.switchCategorySeries = false;
                break;
        }
        this.model.updateModel(chartModelParams);
        const removeChartCellRanges = chartModelParams.unlinkChart || chartModelParams.suppressChartRanges;
        removeChartCellRanges ? this.rangeSvc?.setCellRanges([]) : this.setChartRange();
    }
    updateForGridChange(params) {
        if (this.model.unlinked) return;
        const { maintainColState: maintainColState, setColsFromRange: setColsFromRange } = params ?? {};
        this.model.updateCellRanges({
            maintainColState: maintainColState,
            setColsFromRange: setColsFromRange
        });
        this.model.updateData();
        this.setChartRange();
    }
    updateForDataChange() {
        if (this.model.unlinked) return;
        this.model.updateData();
        this.raiseChartModelUpdateEvent();
    }
    updateForRangeChange() {
        this.updateForGridChange({
            setColsFromRange: true
        });
        this.raiseChartRangeSelectionChangedEvent();
    }
    updateForPanelChange(params) {
        this.model.updateCellRanges(params);
        this.model.updateData();
        if (params.skipAnimation) this.getChartProxy().getChartRef().skipAnimations();
        this.setChartRange();
        this.raiseChartRangeSelectionChangedEvent();
    }
    updateThemeOverrides(updatedOverrides) {
        this.chartProxy.updateThemeOverrides(updatedOverrides);
    }
    getChartUpdateParams(updatedOverrides) {
        const selectedCols = this.getSelectedValueColState();
        const fields = selectedCols.map((c)=>({
                colId: c.colId,
                displayName: c.displayName
            }));
        const data = this.getChartData();
        const selectedDimensions = this.getSelectedDimensions();
        const params = {
            data: data,
            groupData: this.model.groupChartData,
            grouping: this.isGrouping(),
            categories: selectedDimensions.map((selectedDimension)=>({
                    id: selectedDimension.colId,
                    name: selectedDimension.displayName,
                    chartDataType: this.model.categoryAxisType ?? this.model.getChartDataType(selectedDimension.colId)
                })),
            fields: fields,
            chartId: this.getChartId(),
            getCrossFilteringContext: ()=>({
                    lastSelectedChartId: "xxx"
                }),
            //this.params.crossFilteringContext, //TODO
            seriesChartTypes: this.getSeriesChartTypes(),
            updatedOverrides: updatedOverrides,
            seriesGroupType: this.model.seriesGroupType
        };
        return this.isCategorySeriesSwitched() ? this.invertCategorySeriesParams(params) : params;
    }
    invertCategorySeriesParams(params) {
        const [category] = params.categories;
        const categories = [
            {
                id: $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY,
                name: ""
            }
        ];
        const fields = params.data.map((value, index)=>{
            const categoryKey = `${category.id}:${index}`;
            const categoryValue = value[category.id];
            const seriesLabel = categoryValue == null ? "" : String(categoryValue);
            return {
                colId: categoryKey,
                displayName: seriesLabel
            };
        });
        const data = params.fields.map((field)=>{
            const row = {
                [$5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY]: field.displayName
            };
            for (const [index, value] of params.data.entries()){
                const categoryKey = `${category.id}:${index}`;
                const seriesLabelValue = value[field.colId];
                row[categoryKey] = seriesLabelValue;
            }
            return row;
        });
        return {
            ...params,
            categories: categories,
            fields: fields,
            data: data
        };
    }
    getChartModel() {
        const modelType = this.model.pivotChart ? "pivot" : "range";
        const seriesChartTypes = this.isComboChart() ? this.model.comboChartModel.seriesChartTypes : void 0;
        return {
            modelType: modelType,
            chartId: this.model.chartId,
            chartType: this.model.chartType,
            chartThemeName: this.getChartThemeName(),
            chartOptions: this.chartProxy?.getChartThemeOverrides(),
            chartPalette: this.chartProxy?.getChartPalette(),
            cellRange: this.getCellRangeParams(),
            switchCategorySeries: this.model.switchCategorySeries,
            suppressChartRanges: this.model.suppressChartRanges,
            aggFunc: this.model.aggFunc,
            unlinkChart: this.model.unlinked,
            seriesChartTypes: seriesChartTypes,
            seriesGroupType: this.model.seriesGroupType
        };
    }
    getChartId() {
        return this.model.chartId;
    }
    getChartData() {
        return this.model.chartData;
    }
    getChartType() {
        return this.model.chartType;
    }
    setChartType(chartType) {
        this.updateMultiSeriesAndCategory(this.model.chartType, chartType);
        this.model.chartType = chartType;
        this.model.comboChartModel.updateSeriesChartTypes();
        this.model.switchCategorySeries = false;
        this.model.categoryAxisType = void 0;
        this.model.seriesGroupType = void 0;
        this.raiseChartModelUpdateEvent();
    }
    isCategorySeriesSwitched() {
        return this.model.switchCategorySeries && !this.model.isGrouping();
    }
    switchCategorySeries(inverted) {
        if (!$5b7ccabde48fae90$var$supportsInvertedCategorySeries(this.getChartType())) return;
        this.model.switchCategorySeries = inverted;
        this.raiseChartModelUpdateEvent();
    }
    getAggFunc() {
        return this.model.aggFunc;
    }
    setAggFunc(value, silent) {
        if (this.model.aggFunc === value) return;
        this.model.aggFunc = value;
        if (silent) return;
        this.model.updateData();
        this.raiseChartModelUpdateEvent();
    }
    updateMultiSeriesAndCategory(previousChartType, chartType) {
        const updateForMax = (columns, maxNum)=>{
            let numSelected = 0;
            for (const colState of columns){
                if (!colState.selected) continue;
                if (numSelected >= maxNum) colState.selected = false;
                else numSelected++;
            }
            if (numSelected === 0) columns[0].selected = true;
        };
        const maxNumDimensions = $5b7ccabde48fae90$var$getMaxNumCategories(chartType);
        const maxNumSeries = $5b7ccabde48fae90$var$getMaxNumSeries(chartType);
        const updateDimensionColState = maxNumDimensions != null && ($5b7ccabde48fae90$var$getMaxNumCategories(previousChartType) ?? 100) > (maxNumDimensions ?? 100);
        const updateValueColState = maxNumSeries != null && ($5b7ccabde48fae90$var$getMaxNumSeries(previousChartType) ?? 100) > (maxNumSeries ?? 100);
        if (updateDimensionColState) updateForMax(this.model.dimensionColState, maxNumDimensions);
        if (updateValueColState) updateForMax(this.model.valueColState, maxNumSeries);
        if (updateDimensionColState || updateValueColState) {
            this.model.resetCellRanges(updateDimensionColState, updateValueColState);
            this.setChartRange(true);
        }
    }
    setChartThemeName(chartThemeName, silent) {
        this.model.chartThemeName = chartThemeName;
        if (!silent) this.raiseChartModelUpdateEvent();
    }
    getChartThemeName() {
        return this.model.chartThemeName;
    }
    isPivotChart() {
        return this.model.pivotChart;
    }
    isPivotMode() {
        return this.model.isPivotMode();
    }
    isGrouping() {
        return this.model.isGrouping();
    }
    isCrossFilterChart() {
        return this.model.crossFiltering;
    }
    getThemeNames() {
        return this.gos.get("chartThemes") || $5b7ccabde48fae90$var$DEFAULT_THEMES;
    }
    getThemes() {
        const themeNames = this.getThemeNames();
        return themeNames.map((themeName)=>{
            const stockTheme = $5b7ccabde48fae90$var$isStockTheme(themeName, this.agChartsExports._Theme);
            const theme = stockTheme ? themeName : this.chartProxy.lookupCustomChartTheme(themeName);
            return this.agChartsExports._Theme.getChartTheme(theme);
        });
    }
    getPalettes() {
        const themes = this.getThemes();
        return themes.map((theme)=>{
            return theme.palette;
        });
    }
    getValueColState() {
        return this.model.valueColState.map(this.displayNameMapper.bind(this));
    }
    getSelectedValueColState() {
        return this.getValueColState().filter((cs)=>cs.selected);
    }
    getSelectedDimensions() {
        return this.model.getSelectedDimensions();
    }
    displayNameMapper(col) {
        const { column: column } = col;
        if (column) col.displayName = this.model.getColDisplayName(column, this.model.isPivotMode());
        else {
            const colNames = this.model.colNames[col.colId];
            col.displayName = colNames ? colNames.join(" - ") : this.model.getColDisplayName(column);
        }
        return col;
    }
    getColStateForMenu() {
        return {
            dimensionCols: this.model.dimensionColState,
            valueCols: this.getValueColState()
        };
    }
    setChartRange(silent = false) {
        if (this.rangeSvc && !this.model.suppressChartRanges && !this.model.unlinked) this.rangeSvc.setCellRanges(this.getCellRanges());
        if (!silent) this.raiseChartModelUpdateEvent();
    }
    detachChartRange() {
        this.model.unlinked = !this.model.unlinked;
        if (this.model.unlinked) {
            if (this.rangeSvc) this.rangeSvc.setCellRanges([]);
        } else this.updateForGridChange();
        this.dispatchLocalEvent({
            type: "chartLinkedChanged"
        });
    }
    setChartProxy(chartProxy) {
        this.chartProxy = chartProxy;
    }
    getChartProxy() {
        return this.chartProxy;
    }
    isActiveXYChart() {
        return [
            "scatter",
            "bubble"
        ].includes(this.getChartType());
    }
    isChartLinked() {
        return !this.model.unlinked;
    }
    customComboExists() {
        const savedCustomSeriesChartTypes = this.model.comboChartModel.savedCustomSeriesChartTypes;
        return savedCustomSeriesChartTypes && savedCustomSeriesChartTypes.length > 0;
    }
    getSeriesChartTypes() {
        return this.model.comboChartModel.seriesChartTypes;
    }
    isComboChart(chartType) {
        return this.model.isComboChart(chartType);
    }
    updateSeriesChartType(colId, chartType, secondaryAxis) {
        const seriesChartType = this.model.comboChartModel.seriesChartTypes.find((s)=>s.colId === colId);
        if (seriesChartType) {
            const updateChartType = this.model.chartType !== "customCombo";
            if (updateChartType) this.model.chartType = "customCombo";
            const prevSeriesChartType = seriesChartType.chartType;
            if (chartType != null) seriesChartType.chartType = chartType;
            if (secondaryAxis != null) seriesChartType.secondaryAxis = secondaryAxis;
            this.model.comboChartModel.savedCustomSeriesChartTypes = this.model.comboChartModel.seriesChartTypes;
            this.model.comboChartModel.updateSeriesChartTypes();
            this.updateForDataChange();
            if (updateChartType) this.dispatchLocalEvent({
                type: "chartTypeChanged"
            });
            if (prevSeriesChartType !== chartType) this.dispatchLocalEvent({
                type: "chartSeriesChartTypeChanged"
            });
            this.raiseChartOptionsChangedEvent();
        }
    }
    getActiveSeriesChartTypes() {
        const selectedColIds = this.getSelectedValueColState().map((c)=>c.colId);
        return this.getSeriesChartTypes().filter((s)=>selectedColIds.includes(s.colId));
    }
    getChartSeriesTypes(chartType) {
        const targetChartType = chartType ?? this.getChartType();
        return this.isComboChart(targetChartType) ? [
            "line",
            "bar",
            "area"
        ] : [
            $5b7ccabde48fae90$var$getSeriesType(targetChartType)
        ];
    }
    getChartSeriesType() {
        const seriesChartTypes = this.getSeriesChartTypes();
        if (seriesChartTypes.length === 0) return "bar";
        const ct = seriesChartTypes[0].chartType;
        if (ct === "columnLineCombo") return "bar";
        if (ct === "areaColumnCombo") return "area";
        return $5b7ccabde48fae90$var$getSeriesType(ct);
    }
    getCellRanges() {
        return [
            this.model.dimensionCellRange,
            this.model.valueCellRange
        ].filter((r)=>r);
    }
    createCellRange(params) {
        return params.cellRange && this.rangeSvc?.createPartialCellRangeFromRangeParams(params.cellRange, true);
    }
    validUpdateType(params) {
        if (!params.type) {
            (0, $jIDNV._warn)(136);
            return false;
        }
        const chartTypeMap = {
            "Range Chart": ()=>!this.isPivotChart() && !this.isCrossFilterChart(),
            "Pivot Chart": ()=>this.isPivotChart(),
            "Cross Filter Chart": ()=>this.isCrossFilterChart()
        };
        const currentChartType = Object.keys(chartTypeMap).find((type)=>chartTypeMap[type]()) ?? "Range Chart";
        const valid = params.type === `${currentChartType[0].toLowerCase()}${currentChartType.slice(1).replace(/ /g, "")}Update`;
        if (!valid) (0, $jIDNV._warn)(137, {
            currentChartType: currentChartType,
            type: params.type
        });
        return valid;
    }
    getCellRangeParams() {
        const cellRanges = this.getCellRanges();
        const firstCellRange = cellRanges[0];
        const startRow = firstCellRange && firstCellRange.startRow || null;
        const endRow = firstCellRange && firstCellRange.endRow || null;
        return {
            rowStartIndex: startRow && startRow.rowIndex,
            rowStartPinned: startRow && startRow.rowPinned,
            rowEndIndex: endRow && endRow.rowIndex,
            rowEndPinned: endRow && endRow.rowPinned,
            columns: cellRanges.reduce((columns, value)=>columns.concat(value.columns.map((c)=>c.getId())), [])
        };
    }
    setCategoryAxisType(categoryAxisType) {
        this.model.categoryAxisType = categoryAxisType;
        this.raiseChartModelUpdateEvent();
    }
    getSeriesGroupType() {
        return this.model.seriesGroupType ?? this.chartProxy.getSeriesGroupType();
    }
    setSeriesGroupType(seriesGroupType) {
        this.model.seriesGroupType = seriesGroupType;
        this.raiseChartModelUpdateEvent();
    }
    raiseChartModelUpdateEvent() {
        this.dispatchLocalEvent({
            type: "chartModelUpdate"
        });
        this.raiseChartOptionsChangedEvent();
    }
    raiseChartUpdatedEvent() {
        this.dispatchLocalEvent({
            type: "chartUpdated"
        });
    }
    raiseChartApiUpdateEvent() {
        this.dispatchLocalEvent({
            type: "chartApiUpdate"
        });
    }
    raiseChartOptionsChangedEvent() {
        const { chartId: chartId, chartType: chartType } = this.getChartModel();
        this.eventSvc.dispatchEvent({
            type: "chartOptionsChanged",
            chartId: chartId,
            chartType: chartType,
            chartThemeName: this.getChartThemeName(),
            chartOptions: this.chartProxy?.getChartThemeOverrides()
        });
    }
    raiseChartRangeSelectionChangedEvent() {
        this.eventSvc.dispatchEvent({
            type: "chartRangeSelectionChanged",
            id: this.model.chartId,
            chartId: this.model.chartId,
            cellRange: this.getCellRangeParams()
        });
    }
    destroy() {
        super.destroy();
        if (this.rangeSvc) this.rangeSvc.setCellRanges([]);
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/cartesian/areaChartProxy.ts
var $5b7ccabde48fae90$var$AreaChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    getAxes(params) {
        const axes = [
            {
                type: this.getXAxisType(params),
                position: "bottom"
            },
            {
                type: "number",
                position: "left"
            }
        ];
        if (this.isNormalised()) {
            const numberAxis = axes[1];
            numberAxis.label = {
                ...numberAxis.label,
                formatter: (params2)=>Math.round(params2.value) + "%"
            };
        }
        return axes;
    }
    getSeries(params) {
        const [category] = params.categories;
        const series = params.fields.map((f)=>({
                type: this.standaloneChartType,
                xKey: category.id,
                xName: category.name,
                yKey: f.colId,
                yName: f.displayName,
                normalizedTo: this.chartType === "normalizedArea" ? 100 : void 0,
                stacked: [
                    "normalizedArea",
                    "stackedArea"
                ].includes(this.chartType)
            }));
        return this.crossFiltering ? this.extractLineAreaCrossFilterSeries(series, params) : series;
    }
    isNormalised() {
        return !this.crossFiltering && this.chartType === "normalizedArea";
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/cartesian/barChartProxy.ts
var $5b7ccabde48fae90$var$HORIZONTAL_CHART_TYPES = /* @__PURE__ */ new Set([
    "bar",
    "groupedBar",
    "stackedBar",
    "normalizedBar"
]);
var $5b7ccabde48fae90$var$BarChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    getAxes(params) {
        const axes = [
            {
                type: this.getXAxisType(params),
                position: this.isHorizontal() ? "left" : "bottom"
            },
            {
                type: "number",
                position: this.isHorizontal() ? "bottom" : "left"
            }
        ];
        if (this.isNormalised()) {
            const numberAxis = axes[1];
            numberAxis.label = {
                ...numberAxis.label,
                formatter: (params2)=>Math.round(params2.value) + "%"
            };
        }
        return axes;
    }
    getSeries(params) {
        const [category] = params.categories;
        const series = params.fields.map((f)=>({
                type: this.standaloneChartType,
                direction: this.isHorizontal() ? "horizontal" : "vertical",
                stacked: this.crossFiltering || $5b7ccabde48fae90$var$isStacked(this.chartType),
                normalizedTo: this.isNormalised() ? 100 : void 0,
                xKey: category.id,
                xName: category.name,
                yKey: f.colId,
                yName: f.displayName
            }));
        return this.crossFiltering ? this.extractCrossFilterSeries(series) : series;
    }
    extractCrossFilterSeries(series) {
        const allSeries = [];
        for(let i = 0; i < series.length; i++){
            const commonSeries = series[i];
            const primarySeries = {
                ...commonSeries,
                listeners: {
                    seriesNodeClick: this.crossFilterCallback
                }
            };
            const filteredOutSeries = {
                ...primarySeries,
                yKey: `${primarySeries.yKey}-filtered-out`,
                showInLegend: false
            };
            allSeries.push(primarySeries);
            allSeries.push(filteredOutSeries);
        }
        return allSeries;
    }
    isNormalised() {
        const normalisedCharts = [
            "normalizedColumn",
            "normalizedBar"
        ];
        return !this.crossFiltering && normalisedCharts.includes(this.chartType);
    }
    isHorizontal() {
        return $5b7ccabde48fae90$var$HORIZONTAL_CHART_TYPES.has(this.chartType);
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/cartesian/lineChartProxy.ts
var $5b7ccabde48fae90$var$LineChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    getAxes(params) {
        const axes = [
            {
                type: this.getXAxisType(params),
                position: "bottom"
            },
            {
                type: "number",
                position: "left"
            }
        ];
        if (this.isNormalised()) {
            const numberAxis = axes[1];
            numberAxis.label = {
                ...numberAxis.label,
                formatter: (params2)=>Math.round(params2.value) + "%"
            };
        }
        return axes;
    }
    getSeries(params) {
        const [category] = params.categories;
        const stacked = [
            "normalizedLine",
            "stackedLine"
        ].includes(this.chartType);
        const series = params.fields.map((f)=>({
                type: this.standaloneChartType,
                xKey: category.id,
                xName: category.name,
                yKey: f.colId,
                yName: f.displayName,
                normalizedTo: stacked && this.isNormalised() ? 100 : void 0,
                stacked: stacked
            }));
        return this.crossFiltering ? this.extractLineAreaCrossFilterSeries(series, params) : series;
    }
    isNormalised() {
        const normalisedCharts = [
            "normalizedLine"
        ];
        return !this.crossFiltering && normalisedCharts.includes(this.chartType);
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/cartesian/scatterChartProxy.ts
var $5b7ccabde48fae90$var$ScatterChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    getAxes(_params) {
        return [
            {
                type: "number",
                position: "bottom"
            },
            {
                type: "number",
                position: "left"
            }
        ];
    }
    getSeries(params) {
        const [category] = params.categories;
        const paired = this.isPaired();
        const seriesDefinitions = this.getSeriesDefinitions(params.fields, paired);
        const labelFieldDefinition = category.id === $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY ? void 0 : category;
        const series = seriesDefinitions.map((seriesDefinition)=>{
            if (seriesDefinition?.sizeField) {
                const opts2 = {
                    type: "bubble",
                    xKey: seriesDefinition.xField.colId,
                    xName: seriesDefinition.xField.displayName ?? void 0,
                    yKey: seriesDefinition.yField.colId,
                    yName: seriesDefinition.yField.displayName ?? void 0,
                    title: `${seriesDefinition.yField.displayName} vs ${seriesDefinition.xField.displayName}`,
                    sizeKey: seriesDefinition.sizeField.colId,
                    sizeName: seriesDefinition.sizeField.displayName ?? "",
                    labelKey: labelFieldDefinition ? labelFieldDefinition.id : seriesDefinition.yField.colId,
                    labelName: labelFieldDefinition ? labelFieldDefinition.name : void 0
                };
                return opts2;
            }
            const opts = {
                type: "scatter",
                xKey: seriesDefinition.xField.colId,
                xName: seriesDefinition.xField.displayName ?? void 0,
                yKey: seriesDefinition.yField.colId,
                yName: seriesDefinition.yField.displayName ?? void 0,
                title: `${seriesDefinition.yField.displayName} vs ${seriesDefinition.xField.displayName}`,
                labelKey: labelFieldDefinition ? labelFieldDefinition.id : seriesDefinition.yField.colId,
                labelName: labelFieldDefinition ? labelFieldDefinition.name : void 0
            };
            return opts;
        });
        return this.crossFiltering ? this.extractCrossFilterSeries(series, params) : series;
    }
    extractCrossFilterSeries(series, params) {
        const { data: data } = params;
        const filteredOutKey = (key)=>`${key}-filtered-out`;
        const calcMarkerDomain = (data2, sizeKey)=>{
            const markerDomain = [
                Infinity,
                -Infinity
            ];
            if (sizeKey != null) for (const datum of data2){
                const value = datum[sizeKey] ?? datum[filteredOutKey(sizeKey)];
                if (value < markerDomain[0]) markerDomain[0] = value;
                if (value > markerDomain[1]) markerDomain[1] = value;
            }
            if (markerDomain[0] <= markerDomain[1]) return markerDomain;
            return void 0;
        };
        const updatePrimarySeries = (series2)=>{
            let markerDomain = void 0;
            if (series2.type === "bubble") {
                const { sizeKey: sizeKey } = series2;
                markerDomain = calcMarkerDomain(data, sizeKey);
            }
            return {
                ...series2,
                domain: markerDomain,
                highlight: {
                    highlightedItem: {
                        fill: "yellow"
                    }
                },
                listeners: {
                    ...series2.listeners,
                    seriesNodeClick: this.crossFilterCallback
                }
            };
        };
        const updateFilteredOutSeries = (series2)=>{
            const { yKey: yKey, xKey: xKey } = series2;
            let alteredSizeKey = {};
            if (series2.type === "bubble") alteredSizeKey = {
                sizeKey: filteredOutKey(series2.sizeKey)
            };
            return {
                ...series2,
                ...alteredSizeKey,
                yKey: filteredOutKey(yKey),
                xKey: filteredOutKey(xKey),
                showInLegend: false,
                listeners: {
                    ...series2.listeners,
                    seriesNodeClick: (e)=>{
                        const value = e.datum[filteredOutKey(xKey)];
                        const filterableEvent = {
                            ...e,
                            xKey: xKey,
                            datum: {
                                ...e.datum,
                                [xKey]: value
                            }
                        };
                        this.crossFilterCallback(filterableEvent);
                    }
                }
            };
        };
        const updatedSeries = series.map(updatePrimarySeries);
        return [
            ...updatedSeries,
            ...updatedSeries.map(updateFilteredOutSeries)
        ];
    }
    getSeriesDefinitions(fields, paired) {
        if (fields.length < 2) return [];
        const isBubbleChart = this.chartType === "bubble";
        if (paired) {
            if (isBubbleChart) return fields.map((currentXField, i)=>i % 3 === 0 ? {
                    xField: currentXField,
                    yField: fields[i + 1],
                    sizeField: fields[i + 2]
                } : null).filter((x)=>x && x.yField && x.sizeField);
            return fields.map((currentXField, i)=>i % 2 === 0 ? {
                    xField: currentXField,
                    yField: fields[i + 1]
                } : null).filter((x)=>x && x.yField);
        }
        const xField = fields[0];
        if (isBubbleChart) return fields.map((yField, i)=>i % 2 === 1 ? {
                xField: xField,
                yField: yField,
                sizeField: fields[i + 1]
            } : null).filter((x)=>x && x.sizeField);
        return fields.filter((value, i)=>i > 0).map((yField)=>({
                xField: xField,
                yField: yField
            }));
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/combo/comboChartProxy.ts
var $5b7ccabde48fae90$var$ComboChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    getAxes(params) {
        const fields = params ? params.fields : [];
        const fieldsMap = new Map(fields.map((f)=>[
                f.colId,
                f
            ]));
        const { primaryYKeys: primaryYKeys, secondaryYKeys: secondaryYKeys } = this.getYKeys(fields, params.seriesChartTypes);
        const axes = [
            {
                type: this.getXAxisType(params),
                position: "bottom"
            }
        ];
        if (primaryYKeys.length > 0) axes.push({
            type: "number",
            keys: primaryYKeys,
            position: "left"
        });
        if (secondaryYKeys.length > 0) secondaryYKeys.forEach((secondaryYKey)=>{
            const field = fieldsMap.get(secondaryYKey);
            const secondaryAxisIsVisible = field && field.colId === secondaryYKey;
            if (!secondaryAxisIsVisible) return;
            const secondaryAxisOptions = {
                type: "number",
                keys: [
                    secondaryYKey
                ],
                position: "right"
            };
            axes.push(secondaryAxisOptions);
        });
        return axes;
    }
    getSeries(params) {
        const { fields: fields, seriesChartTypes: seriesChartTypes } = params;
        const [category] = params.categories;
        return fields.map((field)=>{
            const seriesChartType = seriesChartTypes.find((s)=>s.colId === field.colId);
            if (seriesChartType) {
                const chartType = seriesChartType.chartType;
                const grouped = [
                    "groupedColumn",
                    "groupedBar"
                ].includes(chartType);
                const groupedOpts = grouped ? {
                    grouped: true
                } : {};
                return {
                    type: $5b7ccabde48fae90$var$getSeriesType(chartType),
                    xKey: category.id,
                    yKey: field.colId,
                    yName: field.displayName,
                    stacked: [
                        "stackedArea",
                        "stackedColumn"
                    ].includes(chartType),
                    ...groupedOpts
                };
            }
        });
    }
    getYKeys(fields, seriesChartTypes) {
        const primaryYKeys = [];
        const secondaryYKeys = [];
        fields.forEach((field)=>{
            const colId = field.colId;
            const seriesChartType = seriesChartTypes.find((s)=>s.colId === colId);
            if (seriesChartType) seriesChartType.secondaryAxis ? secondaryYKeys.push(colId) : primaryYKeys.push(colId);
        });
        return {
            primaryYKeys: primaryYKeys,
            secondaryYKeys: secondaryYKeys
        };
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/pie/pieChartProxy.ts
function $5b7ccabde48fae90$var$calculateOffsets(offset) {
    const outerRadiusOffset = offset.currentOffset;
    offset.currentOffset -= offset.offsetAmount;
    const innerRadiusOffset = offset.currentOffset;
    offset.currentOffset -= offset.offsetAmount;
    return {
        outerRadiusOffset: outerRadiusOffset,
        innerRadiusOffset: innerRadiusOffset
    };
}
var $5b7ccabde48fae90$var$PieChartProxy = class extends $5b7ccabde48fae90$var$ChartProxy {
    getUpdateOptions(params, commonChartOptions) {
        return {
            ...commonChartOptions,
            data: this.crossFiltering ? this.getCrossFilterData(params) : params.data,
            series: this.getSeries(params)
        };
    }
    getSeries(params) {
        const [category] = params.categories;
        const numFields = params.fields.length;
        const offset = {
            currentOffset: 0,
            offsetAmount: numFields > 1 ? 20 : 40
        };
        const series = this.getFields(params).map((f)=>{
            const options = {
                type: this.standaloneChartType,
                angleKey: f.colId,
                angleName: f.displayName,
                sectorLabelKey: f.colId,
                calloutLabelName: category.name,
                calloutLabelKey: category.id
            };
            if (this.chartType === "donut" || this.chartType === "doughnut") {
                const { outerRadiusOffset: outerRadiusOffset, innerRadiusOffset: innerRadiusOffset } = $5b7ccabde48fae90$var$calculateOffsets(offset);
                const title = f.displayName ? {
                    title: {
                        text: f.displayName,
                        showInLegend: numFields > 1
                    }
                } : void 0;
                return {
                    ...options,
                    type: "donut",
                    outerRadiusOffset: outerRadiusOffset,
                    innerRadiusOffset: innerRadiusOffset,
                    ...title
                };
            }
            return options;
        });
        return this.crossFiltering ? this.extractCrossFilterSeries(series) : series;
    }
    getCrossFilterData(params) {
        const colId = params.fields[0].colId;
        const filteredOutColId = `${colId}-filtered-out`;
        return params.data.map((d)=>{
            const total = d[colId] + d[filteredOutColId];
            d[`${colId}-total`] = total;
            d[filteredOutColId] = 1;
            d[colId] = d[colId] / total;
            return d;
        });
    }
    extractCrossFilterSeries(series) {
        const primarySeries = series[0];
        const angleKey = primarySeries.angleKey;
        const commonOptions = {
            ...primarySeries,
            radiusMin: 0,
            radiusMax: 1,
            listeners: {
                seriesNodeClick: this.crossFilterCallback
            },
            legendItemKey: primarySeries.calloutLabelKey,
            angleKey: `${angleKey}-total`
        };
        const primaryOptions = {
            ...commonOptions,
            radiusKey: angleKey,
            sectorLabelKey: `${angleKey}-total`
        };
        const filteredOutOptions = {
            ...commonOptions,
            radiusKey: `${angleKey}-filtered-out`,
            showInLegend: false
        };
        return [
            filteredOutOptions,
            primaryOptions
        ];
    }
    getFields(params) {
        return this.chartType === "pie" ? params.fields.slice(0, 1) : params.fields;
    }
};
var $5b7ccabde48fae90$var$ChartToolbar = class extends (0, $jIDNV.Component) {
    constructor(){
        super(/* html */ `<div class="ag-chart-menu" data-ref="eMenu"></div>`);
        this.eMenu = (0, $jIDNV.RefPlaceholder);
        this.buttonListenersDestroyFuncs = [];
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    updateParams(params) {
        const { buttons: buttons } = params;
        this.createButtons(buttons);
    }
    createButtons(buttons) {
        this.buttonListenersDestroyFuncs.forEach((func)=>func?.());
        this.buttonListenersDestroyFuncs = [];
        const menuEl = this.eMenu;
        (0, $jIDNV._clearElement)(menuEl);
        buttons.forEach((buttonConfig)=>{
            const { buttonName: buttonName, iconName: iconName, callback: callback } = buttonConfig;
            const buttonEl = this.createButton(iconName);
            const tooltipTitle = this.chartTranslation.translate(buttonName + "ToolbarTooltip");
            if (tooltipTitle && buttonEl instanceof HTMLElement) buttonEl.title = tooltipTitle;
            this.buttonListenersDestroyFuncs.push(...this.addManagedElementListeners(buttonEl, {
                click: (event)=>callback(event.currentTarget)
            }));
            menuEl.appendChild(buttonEl);
        });
    }
    createButton(iconName) {
        const buttonEl = (0, $jIDNV._createIconNoSpan)(iconName, this.beans);
        buttonEl.classList.add("ag-chart-menu-icon");
        const wrapperEl = (0, $jIDNV._createElement)({
            tag: "button",
            attrs: {
                type: "button"
            },
            cls: "ag-chart-menu-toolbar-button"
        });
        wrapperEl.appendChild(buttonEl);
        return wrapperEl;
    }
    destroy() {
        this.buttonListenersDestroyFuncs = [];
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/charts/widgets/agPillSelect.css-GENERATED.ts
var $5b7ccabde48fae90$var$agPillSelectCSS = /*css*/ `.ag-pill-select{display:flex;flex-direction:column}:where(.ag-pill-select){.ag-column-drop-list{padding:0}.ag-select{padding-top:var(--ag-spacing)}.ag-picker-field-wrapper{background-color:transparent;border:0}.ag-picker-field-display{cursor:pointer;font-weight:500}.ag-picker-field-display,.ag-picker-field-icon{color:var(--ag-chart-menu-label-color)}}`;
// packages/ag-grid-enterprise/src/charts/widgets/agPillSelect.ts
var $5b7ccabde48fae90$var$AgPillSelect = class extends (0, $jIDNV.Component) {
    constructor(config){
        super(/* html */ `<div class="ag-pill-select" role="presentation"></div>`);
        this.config = config ?? {};
        const { selectedValueList: selectedValueList, valueFormatter: valueFormatter, valueList: valueList } = this.config;
        this.selectedValues = selectedValueList ?? [];
        this.valueList = valueList ?? [];
        this.valueFormatter = valueFormatter ?? ((value)=>(0, $jIDNV._escapeString)(value));
        this.registerCSS($5b7ccabde48fae90$var$agPillSelectCSS);
    }
    postConstruct() {
        const { ariaLabel: ariaLabel, onValuesChange: onValuesChange, dragSourceId: dragSourceId } = this.config;
        this.dropZonePanel = this.createManagedBean(new $5b7ccabde48fae90$var$PillSelectDropZonePanel({
            getValues: ()=>this.selectedValues,
            setValues: (values)=>this.updateValues(values),
            isDraggable: ()=>this.selectedValues.length > 1
        }, (value)=>this.valueFormatter(value), ariaLabel, dragSourceId));
        const eGui = this.getGui();
        eGui.appendChild(this.dropZonePanel.getGui());
        this.initSelect();
        if (onValuesChange != null) this.onValuesChange = onValuesChange;
    }
    setValues(valueList, selectedValues) {
        const { added: added, removed: removed, updated: updated } = this.getChanges(this.valueList, valueList);
        let refreshSelect = false;
        if (added.length || removed.length || updated.length) refreshSelect = true;
        this.valueList = valueList;
        this.updateValues(selectedValues, refreshSelect, true);
        return this;
    }
    setValueFormatter(valueFormatter) {
        this.valueFormatter = valueFormatter;
        return this;
    }
    initSelect() {
        const options = this.createSelectOptions();
        if (!options.length) return false;
        const { selectPlaceholder: placeholder } = this.config;
        this.eSelect = this.createBean(new (0, $jIDNV.AgSelect)({
            options: options,
            placeholder: placeholder,
            onValueChange: (value)=>this.addValue(value),
            pickerIcon: "chartsMenuAdd"
        }));
        this.getGui().appendChild(this.eSelect.getGui());
        return true;
    }
    createSelectOptions() {
        const options = [];
        const { maxSelection: maxSelection } = this.config;
        if (maxSelection && this.selectedValues.length >= maxSelection) return options;
        this.valueList.forEach((value)=>{
            if (!this.selectedValues.includes(value)) options.push({
                value: value,
                text: this.valueFormatter(value)
            });
        });
        return options;
    }
    addValue(value) {
        this.dropZonePanel.addItem(value);
    }
    updateValues(values, forceRefreshSelect, silent) {
        const previousSelectedValues = this.selectedValues;
        this.selectedValues = values;
        const changes = this.getChanges(previousSelectedValues, values);
        const refreshSelect = forceRefreshSelect || changes.added.length || changes.removed.length;
        const activeElement = (0, $jIDNV._getActiveDomElement)(this.beans);
        const selectHasFocus = this.eSelect?.getGui().contains(activeElement);
        const dropZoneHasFocus = this.dropZonePanel?.getGui().contains(activeElement);
        if (!silent) this.onValuesChange?.(changes);
        const emptyRefreshedSelect = refreshSelect ? !this.refreshSelect() : false;
        this.dropZonePanel.refreshGui();
        if (refreshSelect && selectHasFocus) {
            if (emptyRefreshedSelect) this.dropZonePanel.focusList(true);
            else this.eSelect?.getFocusableElement().focus();
        }
        if (dropZoneHasFocus && !values.length) this.eSelect?.getFocusableElement().focus();
    }
    getChanges(previousSelectedValues, newSelectedValues) {
        const added = newSelectedValues.filter((value)=>!previousSelectedValues.includes(value));
        const removed = previousSelectedValues.filter((value)=>!newSelectedValues.includes(value));
        const updated = newSelectedValues.filter((value, index)=>previousSelectedValues[index] !== value);
        return {
            added: added,
            removed: removed,
            updated: updated,
            selected: newSelectedValues
        };
    }
    refreshSelect() {
        if (!this.eSelect) return this.initSelect();
        const options = this.createSelectOptions();
        if (!options.length) {
            (0, $jIDNV._removeFromParent)(this.eSelect.getGui());
            this.eSelect = this.destroyBean(this.eSelect);
            return false;
        }
        this.eSelect.clearOptions().addOptions(options).setValue(void 0, true);
        return true;
    }
    destroy() {
        this.destroyBean(this.eSelect);
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$PillSelectDragComp = class extends $5b7ccabde48fae90$var$PillDragComp {
    constructor(value, dragSourceDropTarget, ghost, valueFormatter, draggable, sourceId){
        super(dragSourceDropTarget, ghost, false);
        this.value = value;
        this.valueFormatter = valueFormatter;
        this.draggable = draggable;
        this.sourceId = sourceId;
    }
    getItem() {
        return this.value;
    }
    getDisplayName() {
        return this.valueFormatter(this.value);
    }
    getAriaDisplayName() {
        return this.getDisplayName();
    }
    getTooltip() {
        return void 0;
    }
    createGetDragItem() {
        return ()=>({
                value: this.value
            });
    }
    getDragSourceType() {
        return (0, $jIDNV.DragSourceType).ChartPanel;
    }
    getDragSourceId() {
        return this.sourceId;
    }
    isMovable() {
        return this.isDraggable();
    }
    isDraggable() {
        return this.draggable;
    }
};
var $5b7ccabde48fae90$var$PillSelectDropZonePanel = class extends $5b7ccabde48fae90$var$PillDropZonePanel {
    constructor(model, valueFormatter, ariaLabel, sourceId){
        super(false);
        this.model = model;
        this.valueFormatter = valueFormatter;
        this.ariaLabel = ariaLabel;
        this.sourceId = sourceId;
    }
    postConstruct() {
        super.init();
    }
    isItemDroppable(item, draggingEvent) {
        return this.isSourceEventFromTarget(draggingEvent) || this.sourceId != null && this.sourceId === draggingEvent.dragSource.sourceId;
    }
    updateItems(items) {
        this.model.setValues(items);
    }
    getExistingItems() {
        return this.model.getValues();
    }
    getIconName() {
        return this.isPotentialDndItems() ? "move" : "notAllowed";
    }
    getAriaLabel() {
        return this.ariaLabel;
    }
    createPillComponent(item, dropTarget, ghost) {
        return new $5b7ccabde48fae90$var$PillSelectDragComp(item, dropTarget, ghost, this.valueFormatter, this.model.isDraggable(), this.sourceId);
    }
    getItems(dragItem) {
        return [
            dragItem.value
        ];
    }
    isInterestedIn(type) {
        return type === (0, $jIDNV.DragSourceType).ChartPanel;
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/data/dragDataPanel.ts
var $5b7ccabde48fae90$var$DragDataPanel = class extends (0, $jIDNV.Component) {
    constructor(chartController, allowMultipleSelection, maxSelection, template){
        super(template);
        this.chartController = chartController;
        this.allowMultipleSelection = allowMultipleSelection;
        this.maxSelection = maxSelection;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    addItem(eItem) {
        this.groupComp.addItem(eItem);
    }
    createGroup(columns, valueFormatter, selectLabelKey, dragSourceId, skipAnimation) {
        if (this.allowMultipleSelection) {
            const selectedValueList = columns.filter((col)=>col.selected);
            this.valuePillSelect = this.groupComp.createManagedBean(new $5b7ccabde48fae90$var$AgPillSelect({
                valueList: columns,
                selectedValueList: selectedValueList,
                valueFormatter: valueFormatter,
                selectPlaceholder: this.chartTranslation.translate(selectLabelKey),
                dragSourceId: dragSourceId,
                onValuesChange: (params)=>this.onValueChange(params),
                maxSelection: this.maxSelection
            }));
            this.groupComp.addItem(this.valuePillSelect);
        } else {
            const params = this.createValueSelectParams(columns);
            params.onValueChange = (updatedColState)=>{
                columns.forEach((col)=>{
                    col.selected = false;
                });
                updatedColState.selected = true;
                if (updatedColState.colId === $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY) this.chartController.setAggFunc(void 0, true);
                this.chartController.updateForPanelChange({
                    updatedColState: updatedColState,
                    skipAnimation: skipAnimation?.()
                });
            };
            this.valueSelect = this.groupComp.createManagedBean(new (0, $jIDNV.AgSelect)(params));
            this.groupComp.addItem(this.valueSelect);
        }
    }
    refreshValueSelect(columns) {
        if (!this.valueSelect) return;
        const { options: options, value: value } = this.createValueSelectParams(columns);
        this.valueSelect.clearOptions().addOptions(options).setValue(value, true);
    }
    createValueSelectParams(columns) {
        let selectedValue;
        const options = columns.map((value)=>{
            const text = value.displayName ?? "";
            if (value.selected) selectedValue = value;
            return {
                value: value,
                text: text
            };
        });
        return {
            options: options,
            value: selectedValue
        };
    }
    onValueChange({ added: added, updated: updated, removed: removed, selected: selected }) {
        let updatedColState;
        let resetOrder;
        const updateOrder = ()=>{
            selected.forEach((col, index)=>{
                col.order = index;
            });
            resetOrder = true;
        };
        if (added.length) {
            updatedColState = added[0];
            updatedColState.selected = true;
            updateOrder();
        } else if (removed.length) {
            updatedColState = removed[0];
            updatedColState.selected = false;
        } else if (updated.length) {
            updateOrder();
            updatedColState = updated[0];
        }
        if (updatedColState) this.chartController.updateForPanelChange({
            updatedColState: updatedColState,
            resetOrder: resetOrder
        });
    }
    destroy() {
        this.valuePillSelect = void 0;
        this.valueSelect = void 0;
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/data/categoriesDataPanel.ts
var $5b7ccabde48fae90$var$DEFAULT_AGG_FUNC = "sum";
var $5b7ccabde48fae90$var$CategoriesDataPanel = class extends $5b7ccabde48fae90$var$DragDataPanel {
    constructor(chartController, title, allowMultipleSelection, dimensionCols, isOpen){
        const maxSelection = void 0;
        super(chartController, allowMultipleSelection, maxSelection, /* html */ `<div id="categoriesGroup"></div>`);
        this.title = title;
        this.dimensionCols = dimensionCols;
        this.isOpen = isOpen;
    }
    postConstruct() {
        this.groupComp = this.createBean(new $5b7ccabde48fae90$var$AgGroupComponent({
            title: this.title,
            enabled: true,
            suppressEnabledCheckbox: true,
            suppressOpenCloseIcons: false,
            cssIdentifier: "charts-data",
            expanded: this.isOpen
        }));
        this.createGroup(this.dimensionCols, (col)=>col.displayName ?? "", "categoryAdd", "categorySelect", ()=>!this.chartController.getAggFunc());
        this.createAggFuncControls(this.dimensionCols);
        this.getGui().appendChild(this.groupComp.getGui());
    }
    refresh(dimensionCols) {
        this.valuePillSelect?.setValues(dimensionCols, dimensionCols.filter((col)=>col.selected));
        this.refreshValueSelect(dimensionCols);
        this.refreshAggFuncControls(dimensionCols, this.chartController.getAggFunc());
    }
    createAggFuncControls(dimensionCols) {
        const aggFunc = this.chartController.getAggFunc();
        this.groupComp.addItem(this.aggFuncToggle = this.createBean(new (0, $jIDNV.AgToggleButton)({
            label: this.chartTranslation.translate("aggregate"),
            labelAlignment: "left",
            labelWidth: "flex",
            inputWidth: "flex",
            value: aggFunc != void 0,
            onValueChange: (value)=>{
                const aggFunc2 = value ? $5b7ccabde48fae90$var$DEFAULT_AGG_FUNC : void 0;
                this.chartController.setAggFunc(aggFunc2);
                this.aggFuncSelect?.setValue(aggFunc2, true);
                this.aggFuncSelect?.setDisplayed(aggFunc2 != void 0);
            }
        })));
        this.groupComp.addItem(this.aggFuncSelect = this.createBean(new (0, $jIDNV.AgSelect)({
            options: [
                {
                    value: "sum",
                    text: this.chartTranslation.translate("sum")
                },
                {
                    value: "first",
                    text: this.chartTranslation.translate("first")
                },
                {
                    value: "last",
                    text: this.chartTranslation.translate("last")
                },
                {
                    value: "min",
                    text: this.chartTranslation.translate("min")
                },
                {
                    value: "max",
                    text: this.chartTranslation.translate("max")
                },
                {
                    value: "count",
                    text: this.chartTranslation.translate("count")
                },
                {
                    value: "avg",
                    text: this.chartTranslation.translate("avg")
                }
            ],
            value: typeof aggFunc === "string" ? aggFunc : void 0,
            onValueChange: (value)=>{
                this.chartController.setAggFunc(value);
            }
        })));
        this.refreshAggFuncControls(dimensionCols, aggFunc);
    }
    refreshAggFuncControls(dimensionCols, aggFunc) {
        const selectedDimensions = dimensionCols.filter((col)=>col.selected);
        const supportsAggregation = selectedDimensions.some((col)=>col.colId !== $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY);
        this.aggFuncToggle?.setValue(aggFunc != void 0);
        this.aggFuncSelect?.setValue(typeof aggFunc === "string" ? aggFunc : void 0, true);
        this.aggFuncToggle?.setDisplayed(supportsAggregation);
        this.aggFuncSelect?.setDisplayed(supportsAggregation && aggFunc != void 0);
    }
    clearAggFuncControls() {
        this.aggFuncToggle = this.destroyBean(this.aggFuncToggle);
        this.aggFuncSelect = this.destroyBean(this.aggFuncSelect);
    }
    destroy() {
        this.clearAggFuncControls();
        this.groupComp = this.destroyBean(this.groupComp);
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$ChartMenuParamsFactory = class extends (0, $jIDNV.BeanStub) {
    constructor(chartOptionsProxy){
        super();
        this.chartOptionsProxy = chartOptionsProxy;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    getDefaultColorPickerParams(expression, labelKey, options) {
        return this.addValueParams(expression, {
            label: this.chartTranslation.translate(labelKey ?? "color"),
            labelWidth: "flex",
            inputWidth: "flex",
            labelAlignment: "top",
            pickerGap: 6
        }, options);
    }
    getDefaultNumberInputParams(expression, labelKey, options) {
        return this.addValueParams(expression, {
            label: this.chartTranslation.translate(labelKey),
            labelAlignment: "top",
            labelWidth: "flex",
            inputWidth: "flex",
            precision: options?.precision,
            step: options?.step,
            min: options?.min,
            max: options?.max
        }, {
            parseInputValue: (value)=>{
                const numberValue = Number(value);
                return isNaN(numberValue) ? void 0 : numberValue;
            },
            formatInputValue: (value)=>{
                return value == null ? "" : `${value}`;
            }
        });
    }
    getDefaultSliderParams(expression, labelKey, defaultMaxValue, isArray) {
        let value = this.chartOptionsProxy.getValue(expression) ?? 0;
        if (isArray && Array.isArray(value)) value = value[0];
        const params = this.getDefaultSliderParamsWithoutValueParams(value, labelKey, defaultMaxValue);
        params.onValueChange = (value2)=>this.chartOptionsProxy.setValue(expression, isArray ? [
                value2
            ] : value2);
        return params;
    }
    getDefaultSliderParamsWithoutValueParams(value, labelKey, defaultMaxValue) {
        return {
            label: this.chartTranslation.translate(labelKey),
            minValue: 0,
            maxValue: Math.max(value, defaultMaxValue),
            textFieldWidth: 45,
            value: `${value}`
        };
    }
    getDefaultCheckboxParams(expression, labelKey, options) {
        const value = this.chartOptionsProxy.getValue(expression);
        const params = {
            label: this.chartTranslation.translate(labelKey),
            value: value,
            readOnly: options?.readOnly,
            passive: options?.passive
        };
        params.onValueChange = (value2)=>{
            this.chartOptionsProxy.setValue(expression, typeof value2 === "boolean" ? value2 : void 0);
        };
        return params;
    }
    getDefaultToggleParams(expression, labelKey, options) {
        const value = this.chartOptionsProxy.getValue(expression);
        const params = {
            label: this.chartTranslation.translate(labelKey),
            labelAlignment: "left",
            labelWidth: "flex",
            inputWidth: "flex",
            value: value,
            readOnly: options?.readOnly,
            passive: options?.passive
        };
        params.onValueChange = (value2)=>{
            this.chartOptionsProxy.setValue(expression, typeof value2 === "boolean" ? value2 : void 0);
        };
        return params;
    }
    getDefaultSelectParams(expression, labelKey, dropdownOptions) {
        return this.getDefaultSelectParamsWithoutValueParams(labelKey, dropdownOptions, this.chartOptionsProxy.getValue(expression), (value)=>{
            this.chartOptionsProxy.setValue(expression, value);
        });
    }
    getDefaultSelectParamsWithoutValueParams(labelKey, options, value, onValueChange) {
        return {
            label: this.chartTranslation.translate(labelKey),
            labelAlignment: "top",
            options: options,
            pickerGap: 6,
            value: value,
            onValueChange: onValueChange
        };
    }
    getDefaultFontPanelParams(expression, labelKey) {
        const keyMapper = (key)=>`${expression}.${key}`;
        return this.addEnableParams(keyMapper("enabled"), {
            name: this.chartTranslation.translate(labelKey),
            suppressEnabledCheckbox: false,
            chartMenuParamsFactory: this,
            keyMapper: keyMapper
        });
    }
    addValueParams(expression, params, options) {
        const optionsValue = this.chartOptionsProxy.getValue(expression);
        params.value = options?.formatInputValue ? options.formatInputValue(optionsValue) : optionsValue;
        params.onValueChange = (value)=>{
            const optionsValue2 = options?.parseInputValue ? options.parseInputValue(value) : value;
            this.chartOptionsProxy.setValue(expression, optionsValue2);
        };
        return params;
    }
    addEnableParams(expression, params) {
        params.enabled = this.chartOptionsProxy.getValue(expression) ?? false;
        params.onEnableChange = (value)=>this.chartOptionsProxy.setValue(expression, value);
        return params;
    }
    getChartOptions() {
        return this.chartOptionsProxy;
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/data/chartSpecificDataPanel.ts
var $5b7ccabde48fae90$var$ChartSpecificDataPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuContext, isOpen){
        super();
        this.chartMenuContext = chartMenuContext;
        this.isOpen = isOpen;
        this.chartSpecificGroup = (0, $jIDNV.RefPlaceholder);
        this.hasContent = false;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
        this.chartSvc = beans.chartSvc;
    }
    postConstruct() {
        const title = this.getTitle();
        const chartSpecificGroupParams = {
            title: title,
            enabled: true,
            suppressEnabledCheckbox: true,
            suppressOpenCloseIcons: false,
            cssIdentifier: "charts-data",
            expanded: this.isOpen,
            items: [
                ...this.createDirectionSelect(),
                this.createReverseSelect(),
                this.createGroupTypeSelect()
            ]
        };
        this.setTemplate(/* html */ `
            <div id="chartSpecificGroup">
                <ag-group-component data-ref="chartSpecificGroup"></ag-group-component>
            </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector
        ], {
            chartSpecificGroup: chartSpecificGroupParams
        });
        this.setDisplayed(this.hasContent);
    }
    refresh() {
        this.hasContent = false;
        this.chartSpecificGroup.setTitle(this.getTitle());
        this.updateDirectionSelect();
        this.updateReverseSelect();
        this.updateGroupTypeSelect();
        this.setDisplayed(this.hasContent);
    }
    getTitle() {
        const chartType = this.chartMenuContext.chartController.getChartType();
        return this.chartTranslation.translate($5b7ccabde48fae90$var$getFullChartNameTranslationKey(chartType));
    }
    createDirectionSelect() {
        if (!this.chartSvc.isEnterprise()) return [];
        const { chartOptionsService: chartOptionsService, chartController: chartController } = this.chartMenuContext;
        const chartOptionsSeriesProxy = chartOptionsService.getSeriesOptionsProxy(()=>$5b7ccabde48fae90$var$getSeriesType(chartController.getChartType()));
        const chartSeriesMenuParamsFactory = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(chartOptionsSeriesProxy));
        const options = [
            "horizontal",
            "vertical"
        ].map((value)=>({
                value: value,
                text: this.chartTranslation.translate(value)
            }));
        const params = chartSeriesMenuParamsFactory.getDefaultSelectParams("direction", "direction", options);
        const onValueChange = params.onValueChange;
        params.onValueChange = (value)=>{
            onValueChange(value);
            chartController.raiseChartModelUpdateEvent();
        };
        this.directionSelect = this.createManagedBean(new (0, $jIDNV.AgSelect)(params));
        this.updateDirectionSelect();
        return [
            this.directionSelect
        ];
    }
    createReverseSelect() {
        const { chartMenuParamsFactory: chartMenuParamsFactory } = this.chartMenuContext;
        const params = chartMenuParamsFactory.getDefaultToggleParams("series.reverse", "reverse");
        this.reverseToggle = this.createManagedBean(new (0, $jIDNV.AgToggleButton)(params));
        this.updateReverseSelect();
        return this.reverseToggle;
    }
    updateReverseSelect() {
        const isDisplayed = this.chartMenuContext.chartController.getChartType() === "pyramid";
        this.updateDisplayed(this.reverseToggle, isDisplayed);
    }
    updateDirectionSelect() {
        const isDisplayed = $5b7ccabde48fae90$var$canSwitchDirection(this.chartMenuContext.chartController.getChartType());
        this.updateDisplayed(this.directionSelect, isDisplayed);
    }
    createGroupTypeSelect() {
        const { chartController: chartController, chartMenuParamsFactory: chartMenuParamsFactory } = this.chartMenuContext;
        this.groupTypeSelect = this.createManagedBean(new (0, $jIDNV.AgSelect)(chartMenuParamsFactory.getDefaultSelectParamsWithoutValueParams("seriesGroupType", $5b7ccabde48fae90$var$SERIES_GROUP_TYPES.map((value)=>({
                value: value,
                text: this.chartTranslation.translate(`${value}SeriesGroupType`)
            })), chartController.getSeriesGroupType(), (value)=>chartController.setSeriesGroupType(value))));
        this.updateGroupTypeSelect();
        return this.groupTypeSelect;
    }
    updateGroupTypeSelect() {
        const isDisplayed = [
            "radialColumn",
            "radialBar",
            "nightingale"
        ].includes(this.chartMenuContext.chartController.getChartType());
        this.updateDisplayed(this.groupTypeSelect, isDisplayed);
    }
    updateDisplayed(select, isDisplayed) {
        select?.setDisplayed(isDisplayed);
        if (select) this.hasContent = this.hasContent || isDisplayed;
    }
};
var $5b7ccabde48fae90$var$SeriesChartTypePanel = class extends (0, $jIDNV.Component) {
    constructor(chartController, columns, isOpen){
        super(/* html */ `<div id="seriesChartTypeGroup"></div>`);
        this.chartController = chartController;
        this.columns = columns;
        this.isOpen = isOpen;
        this.selectedColIds = [];
        this.chartTypeComps = /* @__PURE__ */ new Map();
        this.secondaryAxisComps = /* @__PURE__ */ new Map();
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        this.createSeriesChartTypeGroup(this.columns);
    }
    refresh(columns) {
        if (!(0, $jIDNV._areEqual)(this.getValidColIds(columns), this.selectedColIds)) this.recreate(columns);
        else this.refreshComps();
    }
    recreate(columns) {
        this.isOpen = this.seriesChartTypeGroupComp.isExpanded();
        (0, $jIDNV._clearElement)(this.getGui());
        this.destroyBean(this.seriesChartTypeGroupComp);
        this.columns = columns;
        this.selectedColIds = [];
        this.clearComps();
        this.postConstruct();
    }
    getValidColIds(columns) {
        const seriesChartTypes = this.chartController.getSeriesChartTypes();
        return columns.filter((col)=>col.selected && !!seriesChartTypes.filter((s)=>s.colId === col.colId)[0]).map(({ colId: colId })=>colId);
    }
    createSeriesChartTypeGroup(columns) {
        this.seriesChartTypeGroupComp = this.createBean(new $5b7ccabde48fae90$var$AgGroupComponent({
            title: this.chartTranslation.translate("seriesChartType"),
            enabled: true,
            suppressEnabledCheckbox: true,
            suppressOpenCloseIcons: false,
            cssIdentifier: "charts-data",
            expanded: this.isOpen
        }));
        const seriesChartTypes = this.chartController.getSeriesChartTypes();
        columns.forEach((col)=>{
            if (!col.selected) return;
            const seriesChartType = seriesChartTypes.filter((s)=>s.colId === col.colId)[0];
            if (!seriesChartType) return;
            this.selectedColIds.push(col.colId);
            const seriesItemGroup = this.seriesChartTypeGroupComp.createManagedBean(new $5b7ccabde48fae90$var$AgGroupComponent({
                title: col.displayName,
                enabled: true,
                suppressEnabledCheckbox: true,
                suppressOpenCloseIcons: true,
                cssIdentifier: "charts-format-sub-level"
            }));
            const isSecondaryAxisDisabled = (chartType)=>[
                    "groupedColumn",
                    "stackedColumn",
                    "stackedArea"
                ].includes(chartType);
            const secondaryAxisComp = this.seriesChartTypeGroupComp.createManagedBean(new (0, $jIDNV.AgCheckbox)({
                label: this.chartTranslation.translate("secondaryAxis"),
                labelWidth: "flex",
                disabled: isSecondaryAxisDisabled(seriesChartType.chartType),
                value: !!seriesChartType.secondaryAxis,
                onValueChange: (enabled)=>this.chartController.updateSeriesChartType(col.colId, void 0, enabled)
            }));
            seriesItemGroup.addItem(secondaryAxisComp);
            const options = [
                "line",
                "area",
                "stackedArea",
                "groupedColumn",
                "stackedColumn"
            ].map((value)=>({
                    value: value,
                    text: this.chartTranslation.translate($5b7ccabde48fae90$var$getFullChartNameTranslationKey(value))
                }));
            const chartTypeComp = seriesItemGroup.createManagedBean(new (0, $jIDNV.AgSelect)({
                options: options,
                value: seriesChartType.chartType,
                onValueChange: (chartType)=>this.chartController.updateSeriesChartType(col.colId, chartType)
            }));
            seriesItemGroup.addItem(chartTypeComp);
            this.seriesChartTypeGroupComp.addItem(seriesItemGroup);
            this.chartTypeComps.set(col.colId, chartTypeComp);
            this.secondaryAxisComps.set(col.colId, secondaryAxisComp);
        });
        this.getGui().appendChild(this.seriesChartTypeGroupComp.getGui());
    }
    refreshComps() {
        const seriesChartTypes = this.chartController.getSeriesChartTypes();
        this.selectedColIds.forEach((colId)=>{
            const seriesChartType = seriesChartTypes.find((chartType)=>chartType.colId === colId);
            if (!seriesChartType) return;
            const chartTypeComp = this.chartTypeComps.get(colId);
            const secondaryAxisComp = this.secondaryAxisComps.get(colId);
            chartTypeComp?.setValue(seriesChartType.chartType);
            secondaryAxisComp?.setValue(!!seriesChartType.secondaryAxis);
            secondaryAxisComp?.setDisabled(this.isSecondaryAxisDisabled(seriesChartType.chartType));
        });
    }
    clearComps() {
        this.chartTypeComps.clear();
        this.secondaryAxisComps.clear();
    }
    isSecondaryAxisDisabled(chartType) {
        return [
            "groupedColumn",
            "stackedColumn",
            "stackedArea"
        ].includes(chartType);
    }
    destroy() {
        this.clearComps();
        this.seriesChartTypeGroupComp = this.destroyBean(this.seriesChartTypeGroupComp);
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$SeriesDataPanel = class extends $5b7ccabde48fae90$var$DragDataPanel {
    constructor(chartController, chartOptionsService, title, allowMultipleSelect, maxSelection, valueCols, isOpen){
        super(chartController, allowMultipleSelect, maxSelection, /* html */ `<div id="seriesGroup"></div>`);
        this.chartOptionsService = chartOptionsService;
        this.title = title;
        this.valueCols = valueCols;
        this.isOpen = isOpen;
    }
    postConstruct() {
        this.groupComp = this.createBean(new $5b7ccabde48fae90$var$AgGroupComponent({
            title: this.title,
            enabled: true,
            suppressEnabledCheckbox: true,
            suppressOpenCloseIcons: false,
            cssIdentifier: "charts-data",
            expanded: this.isOpen
        }));
        if (this.chartController.isActiveXYChart()) {
            const pairedModeToggle = this.groupComp.createManagedBean(new (0, $jIDNV.AgToggleButton)({
                label: this.chartTranslation.translate("paired"),
                labelAlignment: "left",
                labelWidth: "flex",
                inputWidth: "flex",
                value: this.chartOptionsService.getPairedMode(),
                onValueChange: (newValue)=>{
                    this.chartOptionsService.setPairedMode(!!newValue);
                    this.chartController.updateForGridChange({
                        maintainColState: true
                    });
                }
            }));
            this.groupComp.addItem(pairedModeToggle);
        }
        this.createGroup(this.valueCols, this.generateGetSeriesLabel(this.valueCols), "seriesAdd", "seriesSelect");
        this.getGui().appendChild(this.groupComp.getGui());
    }
    refresh(valueCols) {
        this.valuePillSelect?.setValueFormatter(this.generateGetSeriesLabel(valueCols));
        this.valuePillSelect?.setValues(valueCols, valueCols.filter((col)=>col.selected));
        this.refreshValueSelect(valueCols);
    }
    generateGetSeriesLabel(valueCols) {
        if (!this.chartController.isActiveXYChart()) return (col)=>col.displayName ?? "";
        const selectedCols = valueCols.filter((col)=>col.selected);
        const isBubble = this.chartController.getChartType() === "bubble";
        const isInPairedMode = this.chartOptionsService.getPairedMode();
        const indexToAxisLabel = /* @__PURE__ */ new Map();
        indexToAxisLabel.set(0, "X");
        indexToAxisLabel.set(1, "Y");
        indexToAxisLabel.set(2, "size");
        return (col)=>{
            const escapedLabel = col.displayName ?? "";
            if (!col.selected) return escapedLabel;
            const index = selectedCols.indexOf(col);
            if (index === -1) return escapedLabel;
            let axisLabel;
            if (isInPairedMode) axisLabel = indexToAxisLabel.get(index % (isBubble ? 3 : 2));
            else if (index === 0) axisLabel = "X";
            else axisLabel = isBubble && index % 2 === 0 ? "size" : "Y";
            return `${escapedLabel} (${axisLabel})`;
        };
    }
    destroy() {
        this.groupComp = this.destroyBean(this.groupComp);
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/data/chartDataPanel.ts
var $5b7ccabde48fae90$var$DefaultDataPanelDef = {
    groups: [
        {
            type: "categories",
            isOpen: true
        },
        {
            type: "series",
            isOpen: true
        },
        {
            type: "seriesChartType",
            isOpen: true
        },
        {
            type: "chartSpecific",
            isOpen: true
        }
    ]
};
var $5b7ccabde48fae90$var$ChartDataPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuContext){
        super(/* html */ `<div class="ag-chart-data-wrapper ag-scrollable-container"></div>`);
        this.chartMenuContext = chartMenuContext;
        this.isSwitchCategorySeriesToggled = false;
        this.restoreSwitchCategorySeriesToggleFocus = false;
        this.panels = [];
        this.chartController = chartMenuContext.chartController;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
        this.chartSvc = beans.chartSvc;
    }
    postConstruct() {
        this.createSwitchCategorySeriesToggle();
        this.isSwitchCategorySeriesToggled = this.chartController.isCategorySeriesSwitched();
        this.updatePanels();
        const listener = this.updatePanels.bind(this);
        this.addManagedListeners(this.chartController, {
            chartModelUpdate: listener,
            chartApiUpdate: listener
        });
    }
    destroy() {
        this.clearPanelComponents();
        super.destroy();
    }
    updatePanels() {
        const currentChartType = this.chartType;
        const isSwitchCategorySeriesToggledCurrent = this.isSwitchCategorySeriesToggled;
        const { dimensionCols: dimensionCols, valueCols: valueCols } = this.chartController.getColStateForMenu();
        this.chartType = this.chartController.getChartType();
        this.isSwitchCategorySeriesToggled = this.chartController.isCategorySeriesSwitched();
        const hasChangedSwitchCategorySeries = this.isSwitchCategorySeriesToggled !== isSwitchCategorySeriesToggledCurrent;
        if (this.canRefresh(currentChartType, this.chartType) && !hasChangedSwitchCategorySeries) {
            this.categoriesDataPanel?.refresh(dimensionCols);
            this.seriesDataPanel?.refresh(valueCols);
            this.seriesChartTypePanel?.refresh(valueCols);
            this.chartSpecificPanel?.refresh();
        } else this.recreatePanels(dimensionCols, valueCols);
        const isSwitchCategorySeriesDisplayed = $5b7ccabde48fae90$var$supportsInvertedCategorySeries(this.chartType) && this.chartSvc.isEnterprise() && !this.chartController.isGrouping();
        (0, $jIDNV._setDisplayed)(this.switchCategorySeriesToggle.getGui(), isSwitchCategorySeriesDisplayed);
        if (hasChangedSwitchCategorySeries) this.switchCategorySeriesToggle?.setValue(this.chartController.isCategorySeriesSwitched());
        if (this.restoreSwitchCategorySeriesToggleFocus) {
            this.restoreSwitchCategorySeriesToggleFocus = false;
            if (isSwitchCategorySeriesDisplayed) this.switchCategorySeriesToggle.getFocusableElement().focus();
        }
    }
    canRefresh(oldChartType, newChartType) {
        if (oldChartType === void 0) return false;
        if (oldChartType === newChartType) return true;
        const isCombo = (chartType)=>[
                "columnLineCombo",
                "areaColumnCombo",
                "customCombo"
            ].includes(chartType);
        if (isCombo(oldChartType) && isCombo(newChartType)) return true;
        return false;
    }
    recreatePanels(dimensionCols, valueCols) {
        this.clearPanelComponents();
        const { chartType: chartType } = this;
        if (!chartType) return;
        const isCategorySeriesSwitched = this.chartController.isCategorySeriesSwitched();
        this.getDataPanelDef().groups?.forEach(({ type: type, isOpen: isOpen })=>{
            if (type === (isCategorySeriesSwitched ? "series" : "categories")) {
                this.categoriesDataPanel = this.createBean(new $5b7ccabde48fae90$var$CategoriesDataPanel(this.chartController, this.getCategoryGroupTitle(isCategorySeriesSwitched), this.getCategoryGroupMultipleSelect(chartType, isCategorySeriesSwitched), dimensionCols, isOpen));
                this.panels.push(this.categoriesDataPanel);
            } else if (type === (isCategorySeriesSwitched ? "categories" : "series")) {
                this.seriesDataPanel = this.createBean(new $5b7ccabde48fae90$var$SeriesDataPanel(this.chartController, this.chartMenuContext.chartOptionsService, this.getSeriesGroupTitle(isCategorySeriesSwitched), this.getSeriesGroupMultipleSelect(chartType, isCategorySeriesSwitched), this.getSeriesGroupMaxSelection(chartType, isCategorySeriesSwitched), valueCols, isOpen));
                this.panels.push(this.seriesDataPanel);
            } else if (type === "seriesChartType") {
                if (this.chartController.isComboChart()) {
                    this.seriesChartTypePanel = this.createBean(new $5b7ccabde48fae90$var$SeriesChartTypePanel(this.chartController, valueCols, isOpen));
                    this.panels.push(this.seriesChartTypePanel);
                }
            } else if (type === "chartSpecific") {
                this.chartSpecificPanel = this.createBean(new $5b7ccabde48fae90$var$ChartSpecificDataPanel(this.chartMenuContext, isOpen));
                this.panels.push(this.chartSpecificPanel);
            } else (0, $jIDNV._warn)(144, {
                type: type
            });
        });
        (isCategorySeriesSwitched ? this.categoriesDataPanel : this.seriesDataPanel)?.addItem(this.switchCategorySeriesToggle.getGui());
        this.addPanelComponents();
    }
    addPanelComponents() {
        if (!this.panels.length) return;
        const eDocument = (0, $jIDNV._getDocument)(this.beans);
        const fragment = eDocument.createDocumentFragment();
        for (const panel of this.panels){
            panel.addCss("ag-chart-data-section");
            fragment.appendChild(panel.getGui());
        }
        this.getGui().appendChild(fragment);
    }
    clearPanelComponents() {
        const eGui = this.getGui();
        this.panels.forEach((panel)=>{
            eGui.removeChild(panel.getGui());
            this.destroyBean(panel);
        });
        this.panels = [];
    }
    getDataPanelDef() {
        return this.gos.get("chartToolPanelsDef")?.dataPanel ?? $5b7ccabde48fae90$var$DefaultDataPanelDef;
    }
    getCategoryGroupTitle(isCategorySeriesSwitched) {
        if (isCategorySeriesSwitched) return this.chartTranslation.translate("seriesLabels");
        return this.chartTranslation.translate(this.chartController.isActiveXYChart() ? "labels" : "categories");
    }
    getCategoryGroupMultipleSelect(chartType, isCategorySeriesSwitched) {
        if (isCategorySeriesSwitched) return false;
        return $5b7ccabde48fae90$var$getMaxNumCategories(chartType) !== 1;
    }
    getSeriesGroupTitle(isCategorySeriesSwitched) {
        if (isCategorySeriesSwitched) return this.chartTranslation.translate("categoryValues");
        return this.chartTranslation.translate(this.chartController.isActiveXYChart() ? "xyValues" : "series");
    }
    getSeriesGroupMultipleSelect(chartType, isCategorySeriesSwitched) {
        return this.getSeriesGroupMaxSelection(chartType, isCategorySeriesSwitched) !== 1;
    }
    getSeriesGroupMaxSelection(chartType, isCategorySeriesSwitched) {
        if (isCategorySeriesSwitched) return void 0;
        return $5b7ccabde48fae90$var$getMaxNumSeries(chartType);
    }
    createSwitchCategorySeriesToggle() {
        this.switchCategorySeriesToggle = this.createManagedBean(new (0, $jIDNV.AgToggleButton)({
            label: this.chartTranslation.translate("switchCategorySeries"),
            labelAlignment: "left",
            labelWidth: "flex",
            inputWidth: "flex",
            value: this.chartController.isCategorySeriesSwitched(),
            onValueChange: (value)=>{
                this.restoreSwitchCategorySeriesToggleFocus = true;
                this.chartController.switchCategorySeries(value);
            }
        }));
    }
};
var $5b7ccabde48fae90$var$AgAngleSelect = class extends (0, $jIDNV.AgAbstractLabel) {
    constructor(config){
        super(config, /* html */ `<div class="ag-angle-select">
            <div data-ref="eLabel"></div>
            <div class="ag-wrapper ag-angle-select-wrapper">
                <div class="ag-angle-select-field">
                    <div data-ref="eParentCircle" class="ag-angle-select-parent-circle">
                        <div data-ref="eChildCircle" class="ag-angle-select-child-circle"></div>
                    </div>
                </div>
                <ag-input-number-field data-ref="eAngleValue"></ag-input-number-field>
            </div>
        </div>`, [
            (0, $jIDNV.AgInputNumberFieldSelector)
        ]);
        this.eLabel = (0, $jIDNV.RefPlaceholder);
        this.eParentCircle = (0, $jIDNV.RefPlaceholder);
        this.eChildCircle = (0, $jIDNV.RefPlaceholder);
        this.eAngleValue = (0, $jIDNV.RefPlaceholder);
        this.radius = 0;
        this.offsetX = 0;
        this.offsetY = 0;
    }
    wireBeans(beans) {
        this.dragSvc = beans.dragSvc;
    }
    postConstruct() {
        super.postConstruct();
        const { value: value, onValueChange: onValueChange } = this.config;
        if (value != null) this.setValue(value, void 0, true);
        if (onValueChange != null) this.onValueChange(onValueChange);
        this.dragListener = {
            eElement: this.eParentCircle,
            dragStartPixels: 0,
            onDragStart: ()=>{
                this.parentCircleRect = this.eParentCircle.getBoundingClientRect();
            },
            onDragging: (e)=>this.calculateAngleDrag(e),
            onDragStop: ()=>{}
        };
        this.dragSvc?.addDragSource(this.dragListener);
        this.eAngleValue.setLabel("").setLabelWidth(5).setInputWidth(45).setMin(0).setMax(360).setValue(`${this.degrees}`).onValueChange((value2)=>{
            if (value2 == null || value2 === "") value2 = "0";
            value2 = this.eAngleValue.normalizeValue(value2);
            let floatValue = parseFloat(value2);
            if (floatValue > 180) floatValue = floatValue - 360;
            this.setValue(floatValue);
        });
        this.updateNumberInput();
        if ((0, $jIDNV._exists)(this.getValue())) this.eAngleValue.setValue(this.normalizeNegativeValue(this.getValue()).toString());
        this.addManagedListeners(this, {
            fieldValueChanged: ()=>{
                if (this.eAngleValue.getInputElement().contains((0, $jIDNV._getActiveDomElement)(this.beans))) return;
                this.updateNumberInput();
            }
        });
    }
    updateNumberInput() {
        const normalizedValue = this.normalizeNegativeValue(this.getValue());
        this.eAngleValue.setValue(normalizedValue.toString());
    }
    positionChildCircle(radians) {
        const rect = this.parentCircleRect || {
            width: 24,
            height: 24
        };
        const eChildCircle = this.eChildCircle;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        eChildCircle.style.left = `${centerX + Math.cos(radians) * 8}px`;
        eChildCircle.style.top = `${centerY + Math.sin(radians) * 8}px`;
    }
    calculatePolar() {
        const x = this.offsetX;
        const y = this.offsetY;
        const radians = Math.atan2(y, x);
        this.degrees = this.toDegrees(radians);
        this.radius = Math.sqrt(x * x + y * y);
        this.positionChildCircle(radians);
    }
    calculateCartesian() {
        const radians = this.toRadians(this.getValue());
        const radius = this.getRadius();
        this.setOffsetX(Math.cos(radians) * radius).setOffsetY(Math.sin(radians) * radius);
    }
    setOffsetX(offset) {
        if (this.offsetX !== offset) {
            this.offsetX = offset;
            this.calculatePolar();
        }
        return this;
    }
    setOffsetY(offset) {
        if (this.offsetY !== offset) {
            this.offsetY = offset;
            this.calculatePolar();
        }
        return this;
    }
    calculateAngleDrag(e) {
        const rect = this.parentCircleRect;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const dx = x - centerX;
        const dy = y - centerY;
        const radians = Math.atan2(dy, dx);
        this.setValue(radians, true);
    }
    toDegrees(radians) {
        return radians / Math.PI * 180;
    }
    toRadians(degrees) {
        return degrees / 180 * Math.PI;
    }
    normalizeNegativeValue(degrees) {
        return degrees < 0 ? 360 + degrees : degrees;
    }
    normalizeAngle180(radians) {
        radians %= Math.PI * 2;
        if (radians < -Math.PI) radians += Math.PI * 2;
        else if (radians >= Math.PI) radians -= Math.PI * 2;
        return radians;
    }
    getRadius() {
        return this.radius;
    }
    setRadius(r) {
        if (this.radius === r) return this;
        this.radius = r;
        this.calculateCartesian();
        return this;
    }
    onValueChange(callbackFn) {
        this.addManagedListeners(this, {
            fieldValueChanged: ()=>{
                callbackFn(this.degrees);
            }
        });
        return this;
    }
    getValue(radians) {
        return radians ? this.toRadians(this.degrees) : this.degrees;
    }
    setValue(degrees, radians, silent) {
        let radiansValue;
        if (!radians) radiansValue = this.normalizeAngle180(this.toRadians(degrees));
        else radiansValue = degrees;
        degrees = this.toDegrees(radiansValue);
        if (this.degrees !== degrees) {
            this.degrees = Math.floor(degrees);
            this.calculateCartesian();
            this.positionChildCircle(radiansValue);
            if (!silent) this.dispatchLocalEvent({
                type: "fieldValueChanged"
            });
        }
        return this;
    }
    setWidth(width) {
        (0, $jIDNV._setFixedWidth)(this.getGui(), width);
        return this;
    }
    setDisabled(disabled) {
        super.setDisabled(disabled);
        this.eAngleValue.setDisabled(disabled);
        return this;
    }
    destroy() {
        this.dragSvc?.removeDragSource(this.dragListener);
        super.destroy();
    }
};
function $5b7ccabde48fae90$var$_capitalise(str) {
    return str[0].toUpperCase() + str.substring(1).toLowerCase();
}
var $5b7ccabde48fae90$var$FontPanel = class extends (0, $jIDNV.Component) {
    constructor(params){
        super();
        this.params = params;
        this.fontGroup = (0, $jIDNV.RefPlaceholder);
        this.activeComps = [];
        this.chartOptions = params.chartMenuParamsFactory.getChartOptions();
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const { cssIdentifier: cssIdentifier = "charts-format-sub-level", name: title, enabled: enabled, onEnableChange: onEnableChange, suppressEnabledCheckbox: suppressEnabledCheckbox, chartMenuParamsFactory: chartMenuParamsFactory, keyMapper: keyMapper } = this.params;
        const fontGroupParams = {
            cssIdentifier: cssIdentifier,
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: title,
            enabled: enabled,
            suppressEnabledCheckbox: true,
            onEnableChange: (enabled2)=>{
                if (onEnableChange) onEnableChange(enabled2);
            },
            useToggle: !suppressEnabledCheckbox
        };
        this.setTemplate(/* html */ `<div class="ag-font-panel">
        <ag-group-component data-ref="fontGroup">
            <ag-select data-ref="familySelect"></ag-select>
            <ag-select data-ref="weightStyleSelect"></ag-select>
            <div class="ag-charts-font-size-color">
                <ag-select data-ref="sizeSelect"></ag-select>
                <ag-color-picker data-ref="colorPicker"></ag-color-picker>
            </div>
        </ag-group-component>
    </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            (0, $jIDNV.AgSelectSelector),
            $5b7ccabde48fae90$var$AgColorPickerSelector
        ], {
            fontGroup: fontGroupParams,
            familySelect: this.getFamilySelectParams(),
            weightStyleSelect: this.getWeightStyleSelectParams(),
            sizeSelect: this.getSizeSelectParams(),
            colorPicker: chartMenuParamsFactory.getDefaultColorPickerParams(keyMapper("color"))
        });
        this.toggleCss("ag-font-panel-no-header", !title);
    }
    addItem(comp, prepend) {
        if (prepend) this.fontGroup.prependItem(comp);
        else this.fontGroup.addItem(comp);
        this.activeComps.push(comp);
    }
    setEnabled(enabled) {
        this.fontGroup.setEnabled(enabled);
    }
    getFamilySelectParams() {
        const families = [
            "Arial, sans-serif",
            "Aria Black, sans-serif",
            "Book Antiqua,  serif",
            "Charcoal, sans-serif",
            "Comic Sans MS, cursive",
            "Courier, monospace",
            "Courier New, monospace",
            "Gadget, sans-serif",
            "Geneva, sans-serif",
            "Helvetica, sans-serif",
            "Impact, sans-serif",
            "Lucida Console, monospace",
            "Lucida Grande, sans-serif",
            "Lucida Sans Unicode,  sans-serif",
            "Monaco, monospace",
            "Palatino Linotype, serif",
            "Palatino, serif",
            "Times New Roman, serif",
            "Times, serif",
            "Verdana, sans-serif"
        ];
        const family = this.getInitialFontValue("fontFamily");
        let initialValue = families[0];
        if (family) {
            const lowerCaseValues = families.map((f)=>f.toLowerCase());
            const valueIndex = lowerCaseValues.indexOf(family.toLowerCase());
            if (valueIndex >= 0) initialValue = families[valueIndex];
            else {
                const capitalisedFontValue = $5b7ccabde48fae90$var$_capitalise(family);
                families.push(capitalisedFontValue);
                initialValue = capitalisedFontValue;
            }
        }
        const options = families.sort().map((value)=>({
                value: value,
                text: value
            }));
        return this.params.chartMenuParamsFactory.getDefaultSelectParamsWithoutValueParams("font", options, `${initialValue}`, (newValue)=>this.setFont({
                fontFamily: newValue
            }));
    }
    getSizeSelectParams() {
        const sizes = [
            8,
            10,
            12,
            14,
            16,
            18,
            20,
            22,
            24,
            26,
            28,
            30,
            32,
            34,
            36
        ];
        const size = this.getInitialFontValue("fontSize");
        if (!sizes.includes(size)) sizes.push(size);
        const options = sizes.sort((a, b)=>a - b).map((value)=>({
                value: `${value}`,
                text: `${value}`
            }));
        return this.params.chartMenuParamsFactory.getDefaultSelectParamsWithoutValueParams("size", options, `${size}`, (newValue)=>this.setFont({
                fontSize: parseInt(newValue, 10)
            }));
    }
    getWeightStyleSelectParams() {
        const weight = this.getInitialFontValue("fontWeight") ?? "normal";
        const style = this.getInitialFontValue("fontStyle") ?? "normal";
        const weightStyles = [
            {
                name: "normal",
                weight: "normal",
                style: "normal"
            },
            {
                name: "bold",
                weight: "bold",
                style: "normal"
            },
            {
                name: "italic",
                weight: "normal",
                style: "italic"
            },
            {
                name: "boldItalic",
                weight: "bold",
                style: "italic"
            }
        ];
        let selectedOption = weightStyles.find((x)=>x.weight === weight && x.style === style);
        if (!selectedOption) {
            selectedOption = {
                name: "predefined",
                weight: weight,
                style: style
            };
            weightStyles.unshift(selectedOption);
        }
        const options = weightStyles.map((ws)=>({
                value: ws.name,
                text: this.chartTranslation.translate(ws.name)
            }));
        return this.params.chartMenuParamsFactory.getDefaultSelectParamsWithoutValueParams("weight", options, selectedOption.name, (newValue)=>{
            const selectedWeightStyle = weightStyles.find((x)=>x.name === newValue);
            this.setFont({
                fontWeight: selectedWeightStyle.weight,
                fontStyle: selectedWeightStyle.style
            });
        });
    }
    destroyActiveComps() {
        this.activeComps.forEach((comp)=>{
            (0, $jIDNV._removeFromParent)(comp.getGui());
            this.destroyBean(comp);
        });
    }
    destroy() {
        this.destroyActiveComps();
        super.destroy();
    }
    setFont(font) {
        const { keyMapper: keyMapper } = this.params;
        for (const fontKey of Object.keys(font)){
            const value = font[fontKey];
            if (value) this.chartOptions.setValue(keyMapper(fontKey), value);
        }
    }
    getInitialFontValue(fontKey) {
        const { keyMapper: keyMapper } = this.params;
        return this.chartOptions.getValue(keyMapper(fontKey));
    }
};
var $5b7ccabde48fae90$var$AxisTicksPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.axisTicksSizeSlider = (0, $jIDNV.RefPlaceholder);
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const { chartMenuUtils: chartMenuUtils } = this;
        const axisTicksGroupParams = chartMenuUtils.addEnableParams("tick.enabled", {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("ticks"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const axisTicksColorPickerParams = chartMenuUtils.getDefaultColorPickerParams("tick.stroke");
        const axisTicksWidthSliderParams = chartMenuUtils.getDefaultSliderParams("tick.width", "width", 10);
        const axisTicksSizeSliderParams = chartMenuUtils.getDefaultSliderParams("tick.size", "length", 30);
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="axisTicksGroup">
                <ag-color-picker data-ref="axisTicksColorPicker"></ag-color-picker>
                <ag-slider data-ref="axisTicksWidthSlider"></ag-slider>
                <ag-slider data-ref="axisTicksSizeSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            $5b7ccabde48fae90$var$AgColorPickerSelector,
            $5b7ccabde48fae90$var$AgSliderSelector
        ], {
            axisTicksGroup: axisTicksGroupParams,
            axisTicksColorPicker: axisTicksColorPickerParams,
            axisTicksWidthSlider: axisTicksWidthSliderParams,
            axisTicksSizeSlider: axisTicksSizeSliderParams
        });
    }
    setTickSizeSliderDisplayed(displayed) {
        this.axisTicksSizeSlider.setDisplayed(displayed);
    }
};
var $5b7ccabde48fae90$var$GridLinePanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.chartOptions = chartMenuUtils.getChartOptions();
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const gridLineGroupParams = this.chartMenuUtils.addEnableParams("gridLine.enabled", {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("gridLines"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const gridLineColorPickerParams = this.getGridLineColorPickerParams("color");
        const gridLineWidthSliderParams = this.getGridLineWidthSliderParams("thickness");
        const gridLineLineDashSliderParams = this.getGridLineDashSliderParams("lineDash");
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="gridLineGroup">
                <ag-color-picker data-ref="gridLineColorPicker"></ag-color-picker>
                <ag-slider data-ref="gridLineWidthSlider"></ag-slider>
                <ag-slider data-ref="gridLineLineDashSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            $5b7ccabde48fae90$var$AgColorPickerSelector,
            $5b7ccabde48fae90$var$AgSliderSelector
        ], {
            gridLineGroup: gridLineGroupParams,
            gridLineColorPicker: gridLineColorPickerParams,
            gridLineWidthSlider: gridLineWidthSliderParams,
            gridLineLineDashSlider: gridLineLineDashSliderParams
        });
    }
    getGridLineColorPickerParams(labelKey) {
        return this.chartMenuUtils.getDefaultColorPickerParams("gridLine.style", labelKey, {
            formatInputValue: (value)=>{
                return value?.[0]?.stroke;
            },
            parseInputValue: (value)=>{
                const styles = this.chartOptions.getValue("gridLine.style") ?? [];
                if (styles.length === 0) return [
                    {
                        stroke: value,
                        lineDash: []
                    }
                ];
                return [
                    {
                        ...styles[0],
                        stroke: value
                    }
                ];
            }
        });
    }
    getGridLineWidthSliderParams(labelKey) {
        return this.chartMenuUtils.getDefaultSliderParams("gridLine.width", labelKey, 10);
    }
    getGridLineDashSliderParams(labelKey) {
        const initialStyles = this.chartOptions.getValue("gridLine.style");
        const initialValue = initialStyles?.[0]?.lineDash?.[0];
        const params = this.chartMenuUtils.getDefaultSliderParamsWithoutValueParams(initialValue ?? 0, labelKey, 30);
        params.onValueChange = (value)=>{
            const stroke = this.chartOptions.getValue("gridLine.style.0.stroke");
            this.chartOptions.setValue("gridLine.style", [
                {
                    lineDash: [
                        value
                    ],
                    stroke: stroke
                }
            ]);
        };
        return params;
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/format/axis/cartesianAxisPanel.ts
var $5b7ccabde48fae90$var$DEFAULT_TIME_AXIS_FORMAT = "%d %B %Y";
var $5b7ccabde48fae90$var$CartesianAxisPanel = class extends (0, $jIDNV.Component) {
    constructor(axisType, options){
        super();
        this.axisType = axisType;
        this.options = options;
        this.axisGroup = (0, $jIDNV.RefPlaceholder);
        this.axisTypeSelect = (0, $jIDNV.RefPlaceholder);
        this.axisPositionSelect = (0, $jIDNV.RefPlaceholder);
        this.axisTimeFormatSelect = (0, $jIDNV.RefPlaceholder);
        this.activePanels = [];
        this.updateFuncs = [];
        const { chartOptionsService: chartOptionsService, seriesType: seriesType, chartController: chartController } = options;
        this.chartOptionsService = chartOptionsService;
        this.chartController = chartController;
        this.chartOptionsSeriesProxy = chartOptionsService.getSeriesOptionsProxy(()=>seriesType);
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const { isExpandedOnInit: expanded, chartOptionsService: chartOptionsService, registerGroupComponent: registerGroupComponent } = this.options;
        const labelKey = this.axisType;
        const axisGroupParams = {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.translate(labelKey),
            expanded: expanded,
            suppressEnabledCheckbox: true
        };
        const chartAxisOptionsProxy = chartOptionsService.getCartesianAxisOptionsProxy(this.axisType);
        const chartAxisOptions = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(chartAxisOptionsProxy));
        const chartAxisThemeOverrides = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(chartOptionsService.getCartesianAxisThemeOverridesProxy(this.axisType)));
        const axisTypeSelectParams = this.getAxisTypeSelectParams(chartAxisOptions, chartOptionsService.getCartesianAxisAppliedThemeOverridesProxy(this.axisType));
        const axisPositionSelectParams = this.getAxisPositionSelectParams(chartAxisOptions);
        const axisTimeFormatSelectParams = this.getAxisTimeFormatSelectParams(chartAxisOptions);
        const axisColorInputParams = this.getAxisColorInputParams(chartAxisThemeOverrides);
        const axisLineWidthSliderParams = this.getAxisLineWidthSliderParams(chartAxisThemeOverrides);
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="axisGroup">
                <ag-select data-ref="axisTypeSelect"></ag-select>
                <ag-select data-ref="axisTimeFormatSelect"></ag-select>
                <ag-select data-ref="axisPositionSelect"></ag-select>
                <ag-color-picker data-ref="axisColorInput"></ag-color-picker>
                <ag-slider data-ref="axisLineWidthSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            (0, $jIDNV.AgSelectSelector),
            $5b7ccabde48fae90$var$AgColorPickerSelector,
            $5b7ccabde48fae90$var$AgSliderSelector
        ], {
            axisGroup: axisGroupParams,
            axisTypeSelect: axisTypeSelectParams ?? void 0,
            axisPositionSelect: axisPositionSelectParams ?? void 0,
            axisTimeFormatSelect: axisTimeFormatSelectParams ?? void 0,
            axisColorInput: axisColorInputParams,
            axisLineWidthSlider: axisLineWidthSliderParams
        });
        registerGroupComponent(this.axisGroup);
        this.axisTypeSelect.setDisplayed(!!axisTypeSelectParams.options?.length);
        if (!axisPositionSelectParams) this.removeTemplateComponent(this.axisPositionSelect);
        const updateTimeFormatVisibility = ()=>{
            const isTimeAxis = chartAxisOptionsProxy.getValue("type") === "time";
            (0, $jIDNV._setDisplayed)(this.axisTimeFormatSelect.getGui(), isTimeAxis);
        };
        if (!axisTimeFormatSelectParams) this.removeTemplateComponent(this.axisTimeFormatSelect);
        else {
            updateTimeFormatVisibility();
            this.addManagedEventListeners({
                chartOptionsChanged: ()=>{
                    updateTimeFormatVisibility();
                }
            });
        }
        this.initGridLines(chartAxisThemeOverrides);
        this.initAxisTicks(chartAxisThemeOverrides);
        this.initAxisLabels(chartAxisThemeOverrides);
        const updateFns = ()=>this.updateFuncs.forEach((func)=>func());
        this.addManagedListeners(this.chartController, {
            chartUpdated: updateFns,
            chartModelUpdate: ()=>setTimeout(()=>{
                    if (!this.isAlive()) return;
                    this.refreshAxisTypeSelect(chartAxisOptions);
                    updateTimeFormatVisibility();
                })
        });
    }
    getAxisTypeSelectParams(chartAxisOptions, chartAxisAppliedThemeOverrides) {
        const chartOptions = chartAxisOptions.getChartOptions();
        const axisTypeSelectOptions = this.getAxisTypeSelectOptions();
        const params = chartAxisOptions.getDefaultSelectParams("type", "axisType", axisTypeSelectOptions);
        params.onValueChange = (value)=>{
            const previousAxisType = chartOptions.getValue("type");
            if (value === previousAxisType) return;
            const previousAxisThemeOverrides = chartAxisAppliedThemeOverrides.getValue("*");
            const previousAxisIsTimeAxis = previousAxisType === "time";
            const updatedAxisIsTimeAxis = value === "time";
            const updatedLabelFormat = previousAxisIsTimeAxis !== updatedAxisIsTimeAxis ? updatedAxisIsTimeAxis ? $5b7ccabde48fae90$var$DEFAULT_TIME_AXIS_FORMAT : void 0 : null;
            this.chartOptionsService.setCartesianCategoryAxisType(this.axisType, value);
            if (updatedLabelFormat !== null) {
                const existingLabel = chartOptions.getValue("label") ?? {};
                chartOptions.setValue("label", {
                    ...existingLabel,
                    format: updatedLabelFormat
                });
            }
            chartAxisAppliedThemeOverrides.setValue("*", previousAxisThemeOverrides);
        };
        return params;
    }
    refreshAxisTypeSelect(chartAxisOptions) {
        const options = this.getAxisTypeSelectOptions();
        const hasOptions = !!options.length;
        this.axisTypeSelect.setDisplayed(hasOptions);
        if (!hasOptions) return;
        this.axisTypeSelect.clearOptions().addOptions(options).setValue(chartAxisOptions.getChartOptions().getValue("type"));
    }
    getAxisTypeSelectOptions() {
        const controller = this.chartController;
        const chartType = controller.getChartType();
        const supportsNumericalAxis = ()=>{
            const testDatum = controller.getChartData()[0];
            if (!testDatum) return false;
            return controller.getSelectedDimensions().every((col)=>!isNaN(parseFloat(testDatum[col.colId])));
        };
        if ([
            "heatmap",
            "histogram",
            "boxPlot",
            "rangeBar",
            "scatter",
            "bubble"
        ].includes(chartType) || controller.isGrouping() || !this.isCategoryAxis() || controller.isCategorySeriesSwitched() || !supportsNumericalAxis()) return [];
        return [
            "category",
            "number",
            "time"
        ].map((value)=>({
                value: value,
                text: this.translate(value)
            }));
    }
    isCategoryAxis() {
        const isHorizontal = this.chartOptionsSeriesProxy.getValue("direction") === "horizontal";
        return isHorizontal && this.axisType === "yAxis" || !isHorizontal && this.axisType === "xAxis";
    }
    getAxisPositionSelectParams(chartAxisOptions) {
        const axisPositionSelectOptions = ((chartType, axisType)=>{
            switch(chartType){
                case "heatmap":
                    return null;
                default:
                    switch(axisType){
                        case "xAxis":
                            return [
                                {
                                    value: "top",
                                    text: this.translate("top")
                                },
                                {
                                    value: "bottom",
                                    text: this.translate("bottom")
                                }
                            ];
                        case "yAxis":
                            return [
                                {
                                    value: "left",
                                    text: this.translate("left")
                                },
                                {
                                    value: "right",
                                    text: this.translate("right")
                                }
                            ];
                    }
            }
        })(this.chartController.getChartType(), this.axisType);
        if (!axisPositionSelectOptions) return null;
        return chartAxisOptions.getDefaultSelectParams("position", "position", axisPositionSelectOptions);
    }
    getAxisTimeFormatSelectParams(chartAxisOptions) {
        if (!this.isCategoryAxis()) return null;
        const axisTimeFormatSelectOptions = [
            {
                value: "%d/%m/%Y",
                text: this.translate("timeFormatSlashesDDMMYYYY")
            },
            {
                value: "%m/%d/%Y",
                text: this.translate("timeFormatSlashesMMDDYYYY")
            },
            {
                value: "%d/%m/%y",
                text: this.translate("timeFormatSlashesDDMMYY")
            },
            {
                value: "%m/%d/%y",
                text: this.translate("timeFormatSlashesMMDDYY")
            },
            {
                value: "%d.%e.%y",
                text: this.translate("timeFormatDotsDDMYY")
            },
            {
                value: "%e.%d.%y",
                text: this.translate("timeFormatDotsMDDYY")
            },
            {
                value: "%Y-%m-%d",
                text: this.translate("timeFormatDashesYYYYMMDD")
            },
            {
                value: "%d %B %Y",
                text: this.translate("timeFormatSpacesDDMMMMYYYY")
            },
            {
                value: "%H:%M:%S",
                text: this.translate("timeFormatHHMMSS")
            },
            {
                value: "%I:%M:%S %p",
                text: this.translate("timeFormatHHMMSSAmPm")
            }
        ];
        return chartAxisOptions.getDefaultSelectParams("label.format", "timeFormat", axisTimeFormatSelectOptions);
    }
    getAxisColorInputParams(chartAxisThemeOverrides) {
        return chartAxisThemeOverrides.getDefaultColorPickerParams("line.stroke");
    }
    getAxisLineWidthSliderParams(chartAxisThemeOverrides) {
        const chartOptions = chartAxisThemeOverrides.getChartOptions();
        const getAxisLineWidth = ()=>{
            const isAxisLineEnabled = chartOptions.getValue("line.enabled");
            if (!isAxisLineEnabled) return null;
            return chartOptions.getValue("line.width");
        };
        const setAxisLineWidth = (value)=>{
            chartOptions.setValues([
                {
                    expression: "line.enabled",
                    value: value != null
                },
                {
                    expression: "line.width",
                    value: value ?? 0
                }
            ]);
        };
        const axisLineWidthSliderParams = chartAxisThemeOverrides.getDefaultSliderParamsWithoutValueParams(getAxisLineWidth() ?? 0, "thickness", 10);
        axisLineWidthSliderParams.onValueChange = (newValue)=>{
            setAxisLineWidth(newValue === 0 ? null : newValue);
        };
        return axisLineWidthSliderParams;
    }
    initGridLines(chartAxisThemeOverrides) {
        const chartType = this.chartController.getChartType();
        if (chartType === "heatmap") return;
        const gridLineComp = this.createBean(new $5b7ccabde48fae90$var$GridLinePanel(chartAxisThemeOverrides));
        this.axisGroup.addItem(gridLineComp);
        this.activePanels.push(gridLineComp);
    }
    initAxisTicks(chartAxisThemeOverrides) {
        if (!this.hasConfigurableAxisTicks()) return;
        const axisTicksComp = this.createBean(new $5b7ccabde48fae90$var$AxisTicksPanel(chartAxisThemeOverrides));
        this.axisGroup.addItem(axisTicksComp);
        this.activePanels.push(axisTicksComp);
        const updateTickFn = ()=>axisTicksComp.setTickSizeSliderDisplayed(this.isGroupedCategoryAxis());
        this.updateFuncs.push(updateTickFn);
        updateTickFn();
    }
    hasConfigurableAxisTicks() {
        const chartType = this.chartController.getChartType();
        switch(chartType){
            case "radarLine":
            case "radarArea":
            case "rangeBar":
            case "boxPlot":
            case "waterfall":
                return false;
            default:
                return true;
        }
    }
    initAxisLabels(chartAxisThemeOverrides) {
        const params = {
            name: this.translate("labels"),
            enabled: true,
            suppressEnabledCheckbox: true,
            chartMenuParamsFactory: chartAxisThemeOverrides,
            keyMapper: (key)=>`label.${key}`
        };
        const labelPanelComp = this.createBean(new $5b7ccabde48fae90$var$FontPanel(params));
        this.axisGroup.addItem(labelPanelComp);
        this.activePanels.push(labelPanelComp);
        this.addAdditionalLabelComps(labelPanelComp, chartAxisThemeOverrides);
    }
    addAdditionalLabelComps(labelPanelComp, chartAxisThemeOverrides) {
        this.addLabelPadding(labelPanelComp, chartAxisThemeOverrides);
        const rotationComp = this.createRotationWidget("labelRotation", chartAxisThemeOverrides);
        const autoRotateCb = this.initLabelRotation(rotationComp, chartAxisThemeOverrides);
        labelPanelComp.addItem(autoRotateCb);
        labelPanelComp.addItem(rotationComp);
    }
    initLabelRotation(rotationComp, chartAxisThemeOverrides) {
        const chartOptions = chartAxisThemeOverrides.getChartOptions();
        const getLabelRotationValue = ()=>{
            return chartOptions.getValue("label.rotation");
        };
        const getLabelAutoRotateValue = ()=>{
            return chartOptions.getValue("label.autoRotate");
        };
        const updateAutoRotate = (autoRotate2)=>{
            if (autoRotate2) this.prevRotation = getLabelRotationValue();
            chartOptions.setValues([
                {
                    expression: "label.autoRotate",
                    value: autoRotate2
                },
                // Clear the rotation option when activating auto-rotate, reinstate the previous value when deactivating
                {
                    expression: "label.rotation",
                    value: autoRotate2 ? void 0 : this.prevRotation
                }
            ]);
            rotationComp.setDisplayed(!autoRotate2);
        };
        const rotation = getLabelRotationValue();
        const autoRotate = typeof rotation === "number" ? false : getLabelAutoRotateValue();
        const autoRotateCheckbox = this.createBean(new (0, $jIDNV.AgCheckbox)({
            label: this.translate("autoRotate"),
            value: autoRotate,
            onValueChange: updateAutoRotate
        }));
        rotationComp.setDisplayed(!autoRotate);
        const autoRotateUpdateFn = ()=>autoRotateCheckbox.setDisplayed(this.isGroupedCategoryAxis());
        this.updateFuncs.push(autoRotateUpdateFn);
        autoRotateUpdateFn();
        return autoRotateCheckbox;
    }
    createRotationWidget(labelKey, chartAxisThemeOverrides) {
        const chartOptions = chartAxisThemeOverrides.getChartOptions();
        const getLabelRotationValue = ()=>{
            return chartOptions.getValue("label.rotation");
        };
        const setLabelRotationValue = (value)=>{
            return chartOptions.setValue("label.rotation", value);
        };
        const degreesSymbol = String.fromCharCode(176);
        const label = `${this.chartTranslation.translate(labelKey)} ${degreesSymbol}`;
        const angleSelect = new $5b7ccabde48fae90$var$AgAngleSelect({
            label: label,
            labelWidth: "flex",
            value: getLabelRotationValue() ?? 0,
            onValueChange: setLabelRotationValue
        });
        this.updateFuncs.push(()=>{
            angleSelect.setValue(getLabelRotationValue() ?? 0);
        });
        return this.createBean(angleSelect);
    }
    isGroupedCategoryAxis() {
        const axisOptionsType = this.chartOptionsService.getCartesianAxisOptionsProxy(this.axisType).getValue("type");
        if (axisOptionsType === "grouped-category") return !this.isCategoryAxis();
        return true;
    }
    addLabelPadding(labelPanelComp, chartAxisThemeOverrides) {
        const labelPaddingSlider = this.createBean(new $5b7ccabde48fae90$var$AgSlider(chartAxisThemeOverrides.getDefaultSliderParams("label.spacing", "padding", 30)));
        labelPanelComp.addItem(labelPaddingSlider);
    }
    translate(key) {
        return this.chartTranslation.translate(key);
    }
    removeTemplateComponent(component) {
        (0, $jIDNV._removeFromParent)(component.getGui());
        this.destroyBean(component);
    }
    destroyActivePanels() {
        this.activePanels.forEach((panel)=>{
            (0, $jIDNV._removeFromParent)(panel.getGui());
            this.destroyBean(panel);
        });
    }
    destroy() {
        this.destroyActivePanels();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$PolarAxisPanel = class extends (0, $jIDNV.Component) {
    constructor(options){
        super();
        this.options = options;
        this.axisGroup = (0, $jIDNV.RefPlaceholder);
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const { isExpandedOnInit: expanded, chartAxisMenuParamsFactory: chartAxisMenuParamsFactory, registerGroupComponent: registerGroupComponent } = this.options;
        const axisGroupParams = {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.translate("polarAxis"),
            expanded: expanded,
            suppressEnabledCheckbox: true
        };
        const axisColorInputParams = chartAxisMenuParamsFactory.getDefaultColorPickerParams("line.stroke");
        const axisLineWidthSliderParams = chartAxisMenuParamsFactory.getDefaultSliderParams("line.width", "thickness", 10);
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="axisGroup">
                <ag-color-picker data-ref="axisColorInput"></ag-color-picker>
                <ag-slider data-ref="axisLineWidthSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            $5b7ccabde48fae90$var$AgColorPickerSelector,
            $5b7ccabde48fae90$var$AgSliderSelector
        ], {
            axisGroup: axisGroupParams,
            axisColorInput: axisColorInputParams,
            axisLineWidthSlider: axisLineWidthSliderParams
        });
        registerGroupComponent(this.axisGroup);
        this.initAxis();
        this.initAxisLabels();
        this.initRadiusAxis();
    }
    initAxis() {
        const chartType = this.options.chartController.getChartType();
        const hasConfigurableAxisShape = [
            "radarLine",
            "radarArea"
        ].includes(chartType);
        if (hasConfigurableAxisShape) {
            const options = [
                {
                    value: "circle",
                    text: this.translate("circle")
                },
                {
                    value: "polygon",
                    text: this.translate("polygon")
                }
            ];
            this.axisGroup.addItem(this.createSelect({
                labelKey: "shape",
                options: options,
                property: "shape"
            }));
        }
        if (chartType !== "pie") this.axisGroup.addItem(this.createSlider({
            labelKey: "innerRadius",
            defaultMaxValue: 1,
            property: "innerRadiusRatio"
        }));
    }
    initAxisLabels() {
        const params = {
            name: this.translate("labels"),
            enabled: true,
            suppressEnabledCheckbox: true,
            chartMenuParamsFactory: this.options.chartAxisMenuParamsFactory,
            keyMapper: (key)=>`label.${key}`
        };
        const labelPanelComp = this.createManagedBean(new $5b7ccabde48fae90$var$FontPanel(params));
        const labelOrientationComp = this.createOrientationWidget();
        labelPanelComp.addItem(labelOrientationComp);
        this.axisGroup.addItem(labelPanelComp);
    }
    createOrientationWidget() {
        const options = [
            {
                value: "fixed",
                text: this.translate("fixed")
            },
            {
                value: "parallel",
                text: this.translate("parallel")
            },
            {
                value: "perpendicular",
                text: this.translate("perpendicular")
            }
        ];
        return this.createSelect({
            labelKey: "orientation",
            options: options,
            property: "label.orientation"
        });
    }
    initRadiusAxis() {
        const chartSeriesType = $5b7ccabde48fae90$var$getSeriesType(this.options.chartController.getChartType());
        if (!$5b7ccabde48fae90$var$isRadial(chartSeriesType)) return;
        const items = [
            this.createSlider({
                labelKey: "groupPadding",
                defaultMaxValue: 1,
                property: "paddingInner"
            }),
            this.createSlider({
                labelKey: "seriesPadding",
                defaultMaxValue: 1,
                property: "groupPaddingInner"
            })
        ];
        const paddingPanelComp = this.createManagedBean(new $5b7ccabde48fae90$var$AgGroupComponent({
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            enabled: true,
            suppressEnabledCheckbox: true,
            title: this.translate("padding"),
            items: items
        })).hideEnabledCheckbox(true).hideOpenCloseIcons(true);
        this.axisGroup.addItem(paddingPanelComp);
    }
    createSlider(config) {
        const { labelKey: labelKey, defaultMaxValue: defaultMaxValue, step: step = 0.05, property: property } = config;
        const params = this.options.chartAxisMenuParamsFactory.getDefaultSliderParams(property, labelKey, defaultMaxValue);
        params.step = step;
        return this.createManagedBean(new $5b7ccabde48fae90$var$AgSlider(params));
    }
    createSelect(config) {
        const { labelKey: labelKey, options: options, property: property } = config;
        return this.createManagedBean(new (0, $jIDNV.AgSelect)(this.options.chartAxisMenuParamsFactory.getDefaultSelectParams(property, labelKey, options)));
    }
    translate(key) {
        return this.chartTranslation.translate(key);
    }
};
var $5b7ccabde48fae90$var$BackgroundPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const chartBackgroundGroupParams = this.chartMenuUtils.addEnableParams("background.visible", {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("background"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const colorPickerParams = this.chartMenuUtils.getDefaultColorPickerParams("background.fill");
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="chartBackgroundGroup">
                <ag-color-picker data-ref="colorPicker"></ag-color-picker>
            </ag-group-component>
        <div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            $5b7ccabde48fae90$var$AgColorPickerSelector
        ], {
            chartBackgroundGroup: chartBackgroundGroupParams,
            colorPicker: colorPickerParams
        });
    }
};
var $5b7ccabde48fae90$var$PaddingPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils, chartController){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.chartController = chartController;
        this.paddingTopSlider = (0, $jIDNV.RefPlaceholder);
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const chartPaddingGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("padding"),
            suppressEnabledCheckbox: true
        };
        const getSliderParams = (property)=>this.chartMenuUtils.getDefaultSliderParams("padding." + property, property, 200);
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="chartPaddingGroup">
                <ag-slider data-ref="paddingTopSlider"></ag-slider>
                <ag-slider data-ref="paddingRightSlider"></ag-slider>
                <ag-slider data-ref="paddingBottomSlider"></ag-slider>
                <ag-slider data-ref="paddingLeftSlider"></ag-slider>
            </ag-group-component>
        <div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            $5b7ccabde48fae90$var$AgSliderSelector
        ], {
            chartPaddingGroup: chartPaddingGroupParams,
            paddingTopSlider: getSliderParams("top"),
            paddingRightSlider: getSliderParams("right"),
            paddingBottomSlider: getSliderParams("bottom"),
            paddingLeftSlider: getSliderParams("left")
        });
        this.addManagedEventListeners({
            chartOptionsChanged: (e)=>{
                this.updateTopPadding(e.chartOptions);
            }
        });
    }
    updateTopPadding(chartOptions) {
        const topPadding = [
            ...this.chartController.getChartSeriesTypes(),
            "common"
        ].map((seriesType)=>chartOptions?.[seriesType]?.padding?.top).find((value)=>value != null);
        if (topPadding != null) this.paddingTopSlider.setValue(`${topPadding}`);
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/format/chart/chartPanel.ts
var $5b7ccabde48fae90$var$ChartPanel = class extends (0, $jIDNV.Component) {
    constructor(options){
        super();
        this.options = options;
        this.chartGroup = (0, $jIDNV.RefPlaceholder);
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const { chartController: chartController, chartMenuParamsFactory: chartMenuParamsFactory, isExpandedOnInit: expanded, registerGroupComponent: registerGroupComponent } = this.options;
        const chartGroupParams = {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.chartTranslation.translate("chartStyle"),
            expanded: expanded,
            suppressEnabledCheckbox: true,
            items: [
                this.createManagedBean(new $5b7ccabde48fae90$var$PaddingPanel(chartMenuParamsFactory, chartController)),
                this.createManagedBean(new $5b7ccabde48fae90$var$BackgroundPanel(chartMenuParamsFactory))
            ]
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="chartGroup"></ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector
        ], {
            chartGroup: chartGroupParams
        });
        registerGroupComponent(this.chartGroup);
    }
};
var $5b7ccabde48fae90$var$GroupExpansionFeature = class extends (0, $jIDNV.BeanStub) {
    constructor(groupContainer){
        super();
        this.groupContainer = groupContainer;
        this.id = 0;
        this.groupComponents = /* @__PURE__ */ new Map();
    }
    addGroupComponent(groupComponent) {
        const id = this.id++;
        this.groupComponents.set(id, groupComponent);
        if (groupComponent.isExpanded()) this.expandedGroupComponent = id;
        groupComponent.onExpandedChange((expanded)=>{
            if (expanded) {
                const previouslyExpandedGroupComponent = this.expandedGroupComponent;
                this.expandedGroupComponent = id;
                if (previouslyExpandedGroupComponent != null) {
                    const groupComponentGui = groupComponent.getGui();
                    const groupPositionInViewport = groupComponentGui.offsetTop - this.groupContainer.parentElement.scrollTop;
                    this.groupComponents.get(previouslyExpandedGroupComponent)?.toggleGroupExpand(false, true);
                    let newScrollTop = groupComponentGui.offsetTop - groupPositionInViewport;
                    if (newScrollTop < 0) newScrollTop = 0;
                    if (newScrollTop !== this.groupContainer.parentElement.scrollTop) this.groupContainer.parentElement.scrollTop = newScrollTop;
                }
            } else this.expandedGroupComponent = void 0;
        });
    }
    destroy() {
        this.groupComponents.clear();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$LegendPanel = class extends (0, $jIDNV.Component) {
    constructor(options, chartMenuContext){
        super();
        this.options = options;
        this.chartMenuContext = chartMenuContext;
        this.legendGroup = (0, $jIDNV.RefPlaceholder);
        this.enabledGroup = (0, $jIDNV.RefPlaceholder);
        this.isGradient = [
            "treemap",
            "sunburst",
            "heatmap"
        ].includes(options.seriesType);
        this.key = this.isGradient ? "gradientLegend" : "legend";
        this.chartController = chartMenuContext.chartController;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const { chartMenuParamsFactory: chartMenuParamsFactory, isExpandedOnInit: expanded, registerGroupComponent: registerGroupComponent } = this.options;
        const positionSelect = this.createManagedBean(new (0, $jIDNV.AgSelect)(chartMenuParamsFactory.getDefaultSelectParams(`${this.key}.position`, "position", [
            "top",
            "right",
            "bottom",
            "left"
        ].map((position)=>({
                value: position,
                text: this.chartTranslation.translate(position)
            })))));
        this.enabledGroup = this.createManagedBean(new $5b7ccabde48fae90$var$AgGroupComponent(chartMenuParamsFactory.addEnableParams(`${this.key}.enabled`, {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("legendEnabled"),
            suppressEnabledCheckbox: true,
            useToggle: true,
            items: [
                this.createLabelPanel(chartMenuParamsFactory),
                positionSelect,
                ...this.getItems(chartMenuParamsFactory)
            ]
        })));
        const legendGroupParams = {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.chartTranslation.translate("legend"),
            suppressEnabledCheckbox: true,
            expanded: expanded,
            items: [
                this.enabledGroup
            ]
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="legendGroup">
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector
        ], {
            legendGroup: legendGroupParams
        });
        registerGroupComponent(this.legendGroup);
        const listener = this.updateLegendEnabledState.bind(this);
        this.addManagedListeners(this.chartController, {
            chartModelUpdate: listener,
            chartApiUpdate: listener
        });
    }
    updateLegendEnabledState() {
        const { valueCols: valueCols } = this.chartController.getColStateForMenu();
        this.enabledGroup.setEnabled(valueCols.filter((vc)=>vc.selected).length > 1);
    }
    getItems(chartMenuParamsFactory) {
        const createSlider = (expression, labelKey, defaultMaxValue)=>this.createManagedBean(new $5b7ccabde48fae90$var$AgSlider(chartMenuParamsFactory.getDefaultSliderParams(`${this.key}.${expression}`, labelKey, defaultMaxValue)));
        if (this.isGradient) return [
            this.createManagedBean(new (0, $jIDNV.AgCheckbox)(chartMenuParamsFactory.addValueParams("gradientLegend.reverseOrder", {
                label: this.chartTranslation.translate("reverseDirection"),
                labelWidth: "flex"
            }))),
            createSlider("gradient.thickness", "thickness", 40),
            createSlider("gradient.preferredLength", "preferredLength", 300),
            createSlider("spacing", "spacing", 200)
        ];
        return [
            createSlider("spacing", "spacing", 200),
            createSlider("item.marker.size", "markerSize", 40),
            createSlider("item.marker.strokeWidth", "markerStroke", 10),
            createSlider("item.marker.padding", "itemSpacing", 20),
            createSlider("item.paddingX", "layoutHorizontalSpacing", 50),
            createSlider("item.paddingY", "layoutVerticalSpacing", 50)
        ];
    }
    createLabelPanel(chartMenuParamsFactory) {
        const rootKey = this.isGradient ? "gradientLegend.scale.label" : "legend.item.label";
        const params = {
            enabled: true,
            suppressEnabledCheckbox: true,
            chartMenuParamsFactory: chartMenuParamsFactory,
            keyMapper: (key)=>`${rootKey}.${key}`,
            cssIdentifier: "charts-format-sub-level-no-header"
        };
        return this.createManagedBean(new $5b7ccabde48fae90$var$FontPanel(params));
    }
};
var $5b7ccabde48fae90$var$ToggleablePanel = class extends (0, $jIDNV.Component) {
    constructor(params){
        super();
        this.params = params;
        this.toggleableGroup = (0, $jIDNV.RefPlaceholder);
        this.activeComps = [];
        this.chartOptions = params.chartMenuParamsFactory.getChartOptions();
    }
    postConstruct() {
        const { tag: tag, cssIdentifier: cssIdentifier = "charts-format-sub-level", title: title, suppressEnabledCheckbox: suppressEnabledCheckbox } = this.params;
        const groupParams = this.params.chartMenuParamsFactory.addEnableParams(`${tag}.enabled`, {
            cssIdentifier: cssIdentifier,
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: title,
            suppressEnabledCheckbox: true,
            useToggle: !suppressEnabledCheckbox
        });
        this.setTemplate(/* html */ `<div class="ag-toggleable-group-panel">
                <ag-group-component data-ref="toggleableGroup">
                </ag-group-component>
            </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector
        ], {
            toggleableGroup: groupParams
        });
        this.toggleCss(`ag-toggleable-group-panel-no-header`, !title);
    }
    addItem(comp, prepend) {
        if (prepend) this.toggleableGroup.prependItem(comp);
        else this.toggleableGroup.addItem(comp);
        this.activeComps.push(comp);
    }
    setEnabled(enabled) {
        this.toggleableGroup.setEnabled(enabled);
    }
    destroyActiveComps() {
        this.activeComps.forEach((comp)=>{
            (0, $jIDNV._removeFromParent)(comp.getGui());
            this.destroyBean(comp);
        });
    }
    destroy() {
        this.destroyActiveComps();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$CalloutPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const calloutGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslation.translate("callout"),
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="calloutGroup">
                <ag-slider data-ref="calloutLengthSlider"></ag-slider>
                <ag-slider data-ref="calloutStrokeWidthSlider"></ag-slider>
                <ag-slider data-ref="labelOffsetSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            $5b7ccabde48fae90$var$AgSliderSelector
        ], {
            calloutGroup: calloutGroupParams,
            calloutLengthSlider: this.chartMenuUtils.getDefaultSliderParams("calloutLine.length", "length", 40),
            calloutStrokeWidthSlider: this.chartMenuUtils.getDefaultSliderParams("calloutLine.strokeWidth", "strokeWidth", 10),
            labelOffsetSlider: this.chartMenuUtils.getDefaultSliderParams("calloutLabel.offset", "offset", 30)
        });
    }
};
var $5b7ccabde48fae90$var$CapsPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const capsGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslation.translate("cap"),
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        const capLengthRatioSliderParams = this.chartMenuUtils.getDefaultSliderParams("cap.lengthRatio", "capLengthRatio", 1);
        capLengthRatioSliderParams.step = 0.05;
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="capsGroup">
                <ag-slider data-ref="capLengthRatioSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            $5b7ccabde48fae90$var$AgSliderSelector
        ], {
            capsGroup: capsGroupParams,
            capLengthRatioSlider: capLengthRatioSliderParams
        });
    }
};
var $5b7ccabde48fae90$var$ConnectorLinePanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const lineGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslation.translate("connectorLine"),
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="lineGroup">
                <ag-color-picker data-ref="lineColorPicker"></ag-color-picker>
                <ag-slider data-ref="lineStrokeWidthSlider"></ag-slider>
                <ag-slider data-ref="lineOpacitySlider"></ag-slider>
                <ag-slider data-ref="lineDashSlider"></ag-slider>                
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            $5b7ccabde48fae90$var$AgColorPickerSelector,
            $5b7ccabde48fae90$var$AgSliderSelector
        ], {
            lineGroup: lineGroupParams,
            lineColorPicker: this.chartMenuUtils.getDefaultColorPickerParams("line.stroke"),
            lineStrokeWidthSlider: this.getSliderParams("strokeWidth", 10, "line.strokeWidth"),
            lineDashSlider: this.getSliderParams("lineDash", 30, "line.lineDash", 1, true),
            lineOpacitySlider: this.getSliderParams("strokeOpacity", 1, "line.strokeOpacity", 0.05)
        });
    }
    getSliderParams(labelKey, maxValue, seriesOptionKey, step = 1, isArray = false) {
        const params = this.chartMenuUtils.getDefaultSliderParams(seriesOptionKey, labelKey, maxValue, isArray);
        params.step = step;
        return params;
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/format/series/seriesUtils.ts
function $5b7ccabde48fae90$var$getShapeSelectOptions(chartTranslation) {
    return [
        "square",
        "circle",
        "cross",
        "diamond",
        "plus",
        "triangle",
        "heart"
    ].map((value)=>({
            value: value,
            text: chartTranslation.translate(value)
        }));
}
// packages/ag-grid-enterprise/src/charts/chartComp/menu/format/series/markersPanel.ts
var $5b7ccabde48fae90$var$MarkersPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const seriesMarkersGroupParams = this.chartMenuUtils.addEnableParams("marker.enabled", {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslation.translate("markers"),
            suppressEnabledCheckbox: true,
            useToggle: true,
            suppressOpenCloseIcons: true
        });
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="seriesMarkersGroup">
                <ag-select data-ref="seriesMarkerShapeSelect"></ag-select>
                <ag-slider data-ref="seriesMarkerSizeSlider"></ag-slider>
                <ag-slider data-ref="seriesMarkerStrokeWidthSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            (0, $jIDNV.AgSelectSelector),
            $5b7ccabde48fae90$var$AgSliderSelector
        ], {
            seriesMarkersGroup: seriesMarkersGroupParams,
            seriesMarkerShapeSelect: this.chartMenuUtils.getDefaultSelectParams("marker.shape", "shape", $5b7ccabde48fae90$var$getShapeSelectOptions(this.chartTranslation)),
            seriesMarkerSizeSlider: this.chartMenuUtils.getDefaultSliderParams("marker.size", "size", 60),
            seriesMarkerStrokeWidthSlider: this.chartMenuUtils.getDefaultSliderParams("marker.strokeWidth", "strokeWidth", 10)
        });
    }
};
var $5b7ccabde48fae90$var$SeriesItemsPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.seriesItemsGroup = (0, $jIDNV.RefPlaceholder);
        this.activePanels = [];
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const seriesItemsGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslation.translate("seriesItems"),
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="seriesItemsGroup">
                <ag-select data-ref="seriesItemSelect"></ag-select>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            (0, $jIDNV.AgSelectSelector)
        ], {
            seriesItemsGroup: seriesItemsGroupParams,
            seriesItemSelect: this.getSeriesItemsParams()
        });
        this.initSeriesControls();
    }
    getSeriesItemsParams() {
        const options = [
            {
                value: "positive",
                text: this.chartTranslation.translate("seriesItemPositive")
            },
            {
                value: "negative",
                text: this.chartTranslation.translate("seriesItemNegative")
            }
        ];
        const seriesItemChangedCallback = (newValue)=>{
            this.destroyActivePanels();
            this.initSeriesControls(newValue);
        };
        return this.chartMenuUtils.getDefaultSelectParamsWithoutValueParams("seriesItemType", options, "positive", seriesItemChangedCallback);
    }
    initSeriesControls(itemType = "positive") {
        this.initSlider("strokeWidth", 10, `item.${itemType}.strokeWidth`);
        this.initSlider("lineDash", 30, `item.${itemType}.lineDash`, 1, true);
        this.initSlider("strokeOpacity", 1, `item.${itemType}.strokeOpacity`, 0.05, false);
        this.initSlider("fillOpacity", 1, `item.${itemType}.fillOpacity`, 0.05, false);
        this.initItemLabels(itemType);
    }
    initSlider(labelKey, maxValue, seriesOptionKey, step = 1, isArray = false) {
        const params = this.chartMenuUtils.getDefaultSliderParams(seriesOptionKey, labelKey, maxValue, isArray);
        params.step = step;
        const itemSlider = this.seriesItemsGroup.createManagedBean(new $5b7ccabde48fae90$var$AgSlider(params));
        this.seriesItemsGroup.addItem(itemSlider);
        this.activePanels.push(itemSlider);
    }
    initItemLabels(itemType) {
        const sectorParams = this.chartMenuUtils.getDefaultFontPanelParams(`item.${itemType}.label`, "seriesItemLabels");
        const labelPanelComp = this.createBean(new $5b7ccabde48fae90$var$FontPanel(sectorParams));
        this.seriesItemsGroup.addItem(labelPanelComp);
        this.activePanels.push(labelPanelComp);
    }
    destroyActivePanels() {
        this.activePanels.forEach((panel)=>{
            (0, $jIDNV._removeFromParent)(panel.getGui());
            this.destroyBean(panel);
        });
    }
    destroy() {
        this.destroyActivePanels();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$ShadowPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils, propertyKey = "shadow"){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.propertyKey = propertyKey;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const propertyNamespace = this.propertyKey;
        const shadowGroupParams = this.chartMenuUtils.addEnableParams(`${propertyNamespace}.enabled`, {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("shadow"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const shadowColorPickerParams = this.chartMenuUtils.getDefaultColorPickerParams(`${propertyNamespace}.color`);
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="shadowGroup">
                <ag-color-picker data-ref="shadowColorPicker"></ag-color-picker>
                <ag-slider data-ref="shadowBlurSlider"></ag-slider>
                <ag-slider data-ref="shadowXOffsetSlider"></ag-slider>
                <ag-slider data-ref="shadowYOffsetSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            $5b7ccabde48fae90$var$AgColorPickerSelector,
            $5b7ccabde48fae90$var$AgSliderSelector
        ], {
            shadowGroup: shadowGroupParams,
            shadowColorPicker: shadowColorPickerParams,
            shadowBlurSlider: this.getSliderParams("blur", 0, 20),
            shadowXOffsetSlider: this.getSliderParams("xOffset", -10, 10),
            shadowYOffsetSlider: this.getSliderParams("yOffset", -10, 10)
        });
    }
    getSliderParams(property, minValue, defaultMaxValue) {
        const expression = `${this.propertyKey}.${property}`;
        const params = this.chartMenuUtils.getDefaultSliderParams(expression, property, defaultMaxValue);
        params.minValue = minValue;
        return params;
    }
};
var $5b7ccabde48fae90$var$TileSpacingPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const groupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="groupSpacing">
                <ag-slider data-ref="groupPaddingSlider"></ag-slider>
                <ag-slider data-ref="groupSpacingSlider"></ag-slider>
            </ag-group-component>
            <ag-group-component data-ref="tileSpacing">
                <ag-slider data-ref="tilePaddingSlider"></ag-slider>
                <ag-slider data-ref="tileSpacingSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            $5b7ccabde48fae90$var$AgSliderSelector
        ], {
            groupSpacing: {
                ...groupParams,
                title: this.chartTranslation.translate("group")
            },
            tileSpacing: {
                ...groupParams,
                title: this.chartTranslation.translate("tile")
            },
            groupPaddingSlider: this.getSliderParams("padding", "group.padding"),
            groupSpacingSlider: this.getSliderParams("spacing", "group.gap"),
            tilePaddingSlider: this.getSliderParams("padding", "tile.padding"),
            tileSpacingSlider: this.getSliderParams("spacing", "tile.gap")
        });
    }
    getSliderParams(labelKey, key) {
        return this.chartMenuUtils.getDefaultSliderParams(key, labelKey, 10);
    }
};
function $5b7ccabde48fae90$var$_capitalise2(str) {
    return str[0].toUpperCase() + str.substring(1);
}
var $5b7ccabde48fae90$var$TooltipPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.tooltipMode = (0, $jIDNV.RefPlaceholder);
    }
    postConstruct() {
        const { chartMenuUtils: chartMenuUtils, beans: beans } = this;
        const propertyKey = "tooltip";
        const chartTranslation = beans.chartTranslation;
        const tooltipGroupParams = chartMenuUtils.addEnableParams(`${propertyKey}.enabled`, {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: chartTranslation.translate("tooltips"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const tooltipModeLocaleKey = "tooltipMode";
        const tooltipModeSelectionOptions = [
            "single",
            "shared",
            "compact"
        ].map((value)=>({
                value: value,
                text: chartTranslation.translate(`${tooltipModeLocaleKey}${$5b7ccabde48fae90$var$_capitalise2(value)}`)
            }));
        const tooltipModeExpression = `${propertyKey}.mode`;
        const tooltipModeSelectParams = chartMenuUtils.getDefaultSelectParams(tooltipModeExpression, tooltipModeLocaleKey, tooltipModeSelectionOptions);
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="tooltipGroup">
                <ag-select data-ref="tooltipMode"></ag-select>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            (0, $jIDNV.AgSelectSelector)
        ], {
            tooltipGroup: tooltipGroupParams,
            tooltipMode: tooltipModeSelectParams
        });
        this.addManagedEventListeners({
            chartOptionsChanged: ()=>{
                const tooltipModeValue = chartMenuUtils.getChartOptions().getValue(tooltipModeExpression);
                this.tooltipMode.setValue(tooltipModeValue, true);
            }
        });
    }
};
var $5b7ccabde48fae90$var$WhiskersPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const whiskersGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslation.translate("whisker"),
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="whiskersGroup">
                <ag-color-picker data-ref="whiskerColorPicker"></ag-color-picker>
                <ag-slider data-ref="whiskerThicknessSlider"></ag-slider>
                <ag-slider data-ref="whiskerOpacitySlider"></ag-slider>
                <ag-slider data-ref="whiskerLineDashSlider"></ag-slider>
                <ag-slider data-ref="whiskerLineDashOffsetSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector,
            $5b7ccabde48fae90$var$AgColorPickerSelector,
            $5b7ccabde48fae90$var$AgSliderSelector
        ], {
            whiskersGroup: whiskersGroupParams,
            whiskerColorPicker: this.chartMenuUtils.getDefaultColorPickerParams("whisker.stroke"),
            whiskerThicknessSlider: this.chartMenuUtils.getDefaultSliderParams("whisker.strokeWidth", "strokeWidth", 10),
            whiskerOpacitySlider: this.chartMenuUtils.getDefaultSliderParams("whisker.strokeOpacity", "strokeOpacity", 1),
            whiskerLineDashSlider: this.chartMenuUtils.getDefaultSliderParams("whisker.lineDash", "lineDash", 30, true),
            whiskerLineDashOffsetSlider: this.chartMenuUtils.getDefaultSliderParams("whisker.lineDashOffset", "lineDashOffset", 30)
        });
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/format/series/seriesPanel.ts
var $5b7ccabde48fae90$var$tooltips = "tooltips";
var $5b7ccabde48fae90$var$strokeWidth = "strokeWidth";
var $5b7ccabde48fae90$var$lineWidth = "lineWidth";
var $5b7ccabde48fae90$var$lineDash = "lineDash";
var $5b7ccabde48fae90$var$lineOpacity = "lineOpacity";
var $5b7ccabde48fae90$var$fillOpacity = "fillOpacity";
var $5b7ccabde48fae90$var$labels = "labels";
var $5b7ccabde48fae90$var$shadow = "shadow";
var $5b7ccabde48fae90$var$stageLabels = "stageLabels";
var $5b7ccabde48fae90$var$markers = "markers";
var $5b7ccabde48fae90$var$SeriesPanel = class extends (0, $jIDNV.Component) {
    constructor(options){
        super();
        this.options = options;
        this.seriesGroup = (0, $jIDNV.RefPlaceholder);
        this.activePanels = [];
        this.widgetFuncs = {
            lineWidth: ()=>this.initStrokeWidth($5b7ccabde48fae90$var$lineWidth),
            [$5b7ccabde48fae90$var$strokeWidth]: ()=>this.initStrokeWidth("strokeWidth"),
            lineColor: ()=>this.initLineColor(),
            [$5b7ccabde48fae90$var$lineDash]: ()=>this.initLineDash(),
            [$5b7ccabde48fae90$var$lineOpacity]: ()=>this.initOpacity("strokeOpacity"),
            [$5b7ccabde48fae90$var$fillOpacity]: ()=>this.initOpacity("fillOpacity"),
            markers: ()=>new $5b7ccabde48fae90$var$MarkersPanel(this.chartMenuUtils),
            [$5b7ccabde48fae90$var$labels]: ()=>this.initLabels(),
            sectorLabels: ()=>this.initSectorLabels(),
            [$5b7ccabde48fae90$var$shadow]: ()=>new $5b7ccabde48fae90$var$ShadowPanel(this.chartMenuUtils),
            [$5b7ccabde48fae90$var$tooltips]: ()=>new $5b7ccabde48fae90$var$TooltipPanel(this.options.chartMenuParamsFactory),
            bins: ()=>this.initBins(),
            whiskers: ()=>new $5b7ccabde48fae90$var$WhiskersPanel(this.chartMenuUtils),
            caps: ()=>new $5b7ccabde48fae90$var$CapsPanel(this.chartMenuUtils),
            connectorLine: ()=>new $5b7ccabde48fae90$var$ConnectorLinePanel(this.chartMenuUtils),
            seriesItems: ()=>new $5b7ccabde48fae90$var$SeriesItemsPanel(this.chartMenuUtils),
            tileSpacing: ()=>new $5b7ccabde48fae90$var$TileSpacingPanel(this.chartMenuUtils),
            shape: ()=>this.initShape(),
            size: ()=>this.initSize("size", "size"),
            minSize: ()=>this.initSize("size", "minSize"),
            maxSize: ()=>this.initSize("maxSize", "maxSize"),
            dropoff: ()=>this.initDropOff(),
            stageLabels: ()=>this.initStageLabels()
        };
        this.seriesWidgetMappings = {
            bar: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels,
                $5b7ccabde48fae90$var$shadow
            ],
            pie: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels,
                "sectorLabels",
                $5b7ccabde48fae90$var$shadow
            ],
            donut: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels,
                "sectorLabels",
                $5b7ccabde48fae90$var$shadow
            ],
            line: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$lineWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$markers,
                $5b7ccabde48fae90$var$labels
            ],
            scatter: [
                $5b7ccabde48fae90$var$tooltips,
                "shape",
                "size",
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$labels
            ],
            bubble: [
                $5b7ccabde48fae90$var$tooltips,
                "shape",
                "minSize",
                "maxSize",
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$labels
            ],
            area: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$lineWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$markers,
                $5b7ccabde48fae90$var$labels,
                $5b7ccabde48fae90$var$shadow
            ],
            histogram: [
                $5b7ccabde48fae90$var$tooltips,
                "bins",
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels,
                $5b7ccabde48fae90$var$shadow
            ],
            "radial-column": [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels
            ],
            "radial-bar": [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels
            ],
            "radar-line": [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$markers,
                $5b7ccabde48fae90$var$labels
            ],
            "radar-area": [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$markers,
                $5b7ccabde48fae90$var$labels
            ],
            nightingale: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels
            ],
            "box-plot": [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                "whiskers",
                "caps"
            ],
            "range-bar": [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels
            ],
            "range-area": [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$lineWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$markers,
                $5b7ccabde48fae90$var$labels,
                $5b7ccabde48fae90$var$shadow
            ],
            treemap: [
                $5b7ccabde48fae90$var$tooltips,
                "tileSpacing"
            ],
            sunburst: [
                $5b7ccabde48fae90$var$tooltips
            ],
            heatmap: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$labels,
                "lineColor",
                $5b7ccabde48fae90$var$lineWidth,
                $5b7ccabde48fae90$var$lineOpacity
            ],
            waterfall: [
                $5b7ccabde48fae90$var$tooltips,
                "connectorLine",
                "seriesItems"
            ],
            funnel: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels,
                "dropoff",
                $5b7ccabde48fae90$var$stageLabels,
                $5b7ccabde48fae90$var$shadow
            ],
            "cone-funnel": [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels,
                $5b7ccabde48fae90$var$stageLabels
            ],
            pyramid: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels,
                $5b7ccabde48fae90$var$stageLabels,
                $5b7ccabde48fae90$var$shadow
            ]
        };
        this.seriesType = options.seriesType;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const { isExpandedOnInit: expanded, chartOptionsService: chartOptionsService, chartController: chartController, registerGroupComponent: registerGroupComponent } = this.options;
        const seriesGroupParams = {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.translate("series"),
            expanded: expanded,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="seriesGroup">
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector
        ], {
            seriesGroup: seriesGroupParams
        });
        registerGroupComponent(this.seriesGroup);
        this.chartMenuUtils = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(chartOptionsService.getSeriesOptionsProxy(()=>this.seriesType)));
        this.addManagedListeners(chartController, {
            chartSeriesChartTypeChanged: this.refreshWidgets.bind(this)
        });
        this.refreshWidgets();
    }
    refreshWidgets() {
        const { chartController: chartController } = this.options;
        this.destroyActivePanels();
        const chart = chartController.getChartProxy().getChart();
        chart.waitForUpdate().then(()=>{
            const componentWasRemoved = !this.isAlive();
            if (componentWasRemoved) return;
            if (chartController.isComboChart()) {
                this.updateSeriesType();
                this.initSeriesSelect();
            }
            (this.seriesWidgetMappings[this.seriesType] ?? []).forEach((w)=>{
                const widgetFuncResult = this.widgetFuncs[w]();
                let widget;
                if (Array.isArray(widgetFuncResult)) {
                    const comp = this.createBean(widgetFuncResult[0]);
                    widget = comp;
                    widgetFuncResult[1](comp);
                } else widget = this.createBean(widgetFuncResult);
                this.seriesGroup.addItem(widget);
                this.activePanels.push(widget);
            });
        }).catch((e)=>(0, $jIDNV._error)(105, {
                e: e
            }));
    }
    initSeriesSelect() {
        const seriesSelect = this.createBean(new (0, $jIDNV.AgSelect)(this.chartMenuUtils.getDefaultSelectParamsWithoutValueParams("seriesType", this.getSeriesSelectOptions(), `${this.seriesType}`, (newValue)=>{
            this.seriesType = newValue;
            this.refreshWidgets();
        })));
        this.seriesGroup.addItem(seriesSelect);
        this.activePanels.push(seriesSelect);
    }
    initLineColor() {
        return new $5b7ccabde48fae90$var$AgColorPicker(this.chartMenuUtils.getDefaultColorPickerParams("stroke", "strokeColor"));
    }
    initStrokeWidth(labelKey, expression) {
        return new $5b7ccabde48fae90$var$AgSlider(this.chartMenuUtils.getDefaultSliderParams(expression ? `${expression}.${labelKey}` : "strokeWidth", labelKey, 10));
    }
    initLineDash(expression) {
        return new $5b7ccabde48fae90$var$AgSlider(this.chartMenuUtils.getDefaultSliderParams(expression ? `${expression}.lineDash` : "lineDash", "lineDash", 30, true));
    }
    initOpacity(type, expression) {
        const params = this.chartMenuUtils.getDefaultSliderParams(expression ? `${expression}.${type}` : type, type, 1);
        params.step = 0.05;
        return new $5b7ccabde48fae90$var$AgSlider(params);
    }
    initDropOff() {
        const dropOffGroup = new $5b7ccabde48fae90$var$ToggleablePanel({
            tag: "dropOff",
            cssIdentifier: "charts-format-sub-level",
            title: this.translate("dropOff"),
            suppressEnabledCheckbox: false,
            chartMenuParamsFactory: this.chartMenuUtils
        });
        const addItems = (groupComponent)=>{
            [
                this.initStrokeWidth("strokeWidth", "dropOff"),
                this.initLineDash("dropOff"),
                this.initOpacity("strokeOpacity", "dropOff"),
                this.initOpacity("fillOpacity", "dropOff")
            ].forEach((comp)=>{
                const managed = groupComponent.createManagedBean(comp);
                groupComponent.addItem(managed);
                this.activePanels.push(managed);
            });
        };
        return [
            dropOffGroup,
            addItems
        ];
    }
    initLabels() {
        const isPieChart = $5b7ccabde48fae90$var$isPieChartSeries(this.seriesType);
        const seriesOptionLabelProperty = isPieChart ? "calloutLabel" : "label";
        const labelKey = isPieChart ? "calloutLabels" : "labels";
        const labelParams = this.chartMenuUtils.getDefaultFontPanelParams(seriesOptionLabelProperty, labelKey);
        const fontPanel = new $5b7ccabde48fae90$var$FontPanel(labelParams);
        const addItems = (labelPanelComp)=>{
            if (isPieChart) {
                const calloutPanelComp = labelPanelComp.createManagedBean(new $5b7ccabde48fae90$var$CalloutPanel(this.chartMenuUtils));
                labelPanelComp.addItem(calloutPanelComp);
                this.activePanels.push(calloutPanelComp);
            }
            if (this.seriesType === "range-bar") {
                const options = [
                    {
                        value: "inside",
                        text: this.translate("inside")
                    },
                    {
                        value: "outside",
                        text: this.translate("outside")
                    }
                ];
                const placementSelect = labelPanelComp.createManagedBean(new (0, $jIDNV.AgSelect)(this.chartMenuUtils.getDefaultSelectParams("label.placement", "labelPlacement", options)));
                labelPanelComp.addItem(placementSelect);
                this.activePanels.push(placementSelect);
                const paddingSlider = labelPanelComp.createManagedBean(new $5b7ccabde48fae90$var$AgSlider(this.chartMenuUtils.getDefaultSliderParams("label.padding", "padding", 200)));
                labelPanelComp.addItem(paddingSlider);
                this.activePanels.push(paddingSlider);
            }
        };
        return [
            fontPanel,
            addItems
        ];
    }
    initSectorLabels() {
        const sectorParams = this.chartMenuUtils.getDefaultFontPanelParams("sectorLabel", "sectorLabels");
        const fontPanel = new $5b7ccabde48fae90$var$FontPanel(sectorParams);
        const addItems = (sectorPanelComp)=>{
            const positionRatioParams = this.chartMenuUtils.getDefaultSliderParams("sectorLabel.positionRatio", "positionRatio", 1);
            positionRatioParams.step = 0.05;
            const positionRatioComp = sectorPanelComp.createManagedBean(new $5b7ccabde48fae90$var$AgSlider(positionRatioParams));
            sectorPanelComp.addItem(positionRatioComp);
        };
        return [
            fontPanel,
            addItems
        ];
    }
    initStageLabels() {
        return new $5b7ccabde48fae90$var$FontPanel(this.chartMenuUtils.getDefaultFontPanelParams("stageLabel", $5b7ccabde48fae90$var$stageLabels));
    }
    initBins() {
        const params = this.chartMenuUtils.getDefaultSliderParams("binCount", "histogramBinCount", 20);
        const chartOptions = this.chartMenuUtils.getChartOptions();
        const value = (chartOptions.getValue("bins") ?? chartOptions.getValue("calculatedBins", true)).length;
        params.value = `${value}`;
        params.maxValue = Math.max(value, 20);
        return new $5b7ccabde48fae90$var$AgSlider(params);
    }
    initShape() {
        return new (0, $jIDNV.AgSelect)(this.chartMenuUtils.getDefaultSelectParams("shape", "shape", $5b7ccabde48fae90$var$getShapeSelectOptions(this.chartTranslation)));
    }
    initSize(expression, labelKey) {
        return new $5b7ccabde48fae90$var$AgSlider(this.chartMenuUtils.getDefaultSliderParams(expression, labelKey, 60));
    }
    getSeriesSelectOptions() {
        const activeSeriesTypes = this.getActiveSeriesTypes();
        return [
            "area",
            "bar",
            "line"
        ].filter((seriesType)=>activeSeriesTypes.includes(seriesType)).map((value)=>({
                value: value,
                text: this.translate(value)
            }));
    }
    updateSeriesType() {
        const activeSeriesTypes = this.getActiveSeriesTypes();
        const invalidSeriesType = !activeSeriesTypes.includes(this.seriesType);
        if (invalidSeriesType && activeSeriesTypes.length > 0) this.seriesType = activeSeriesTypes[0];
    }
    getActiveSeriesTypes() {
        return this.options.chartController.getActiveSeriesChartTypes().map((s)=>$5b7ccabde48fae90$var$getSeriesType(s.chartType));
    }
    translate(key) {
        return this.chartTranslation.translate(key);
    }
    destroyActivePanels() {
        this.activePanels.forEach((panel)=>{
            (0, $jIDNV._removeFromParent)(panel.getGui());
            this.destroyBean(panel);
        });
    }
    destroy() {
        this.destroyActivePanels();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$TitlePanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils, name, key){
        super(/* html */ `<div></div>`);
        this.chartMenuUtils = chartMenuUtils;
        this.name = name;
        this.key = key;
        this.chartOptions = chartMenuUtils.getChartOptions();
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        this.initFontPanel();
    }
    hasTitle() {
        const title = this.chartOptions.getValue(this.key);
        return title && title.enabled && title.text && title.text.length > 0;
    }
    initFontPanel() {
        const hasTitle = this.hasTitle();
        const fontPanelParams = {
            name: this.chartTranslation.translate(this.name),
            enabled: hasTitle,
            suppressEnabledCheckbox: false,
            chartMenuParamsFactory: this.chartMenuUtils,
            keyMapper: (key)=>`${this.key}.${key}`,
            onEnableChange: (enabled)=>this.onEnableChange(enabled)
        };
        this.fontPanel = this.createManagedBean(new $5b7ccabde48fae90$var$FontPanel(fontPanelParams));
        this.fontPanel.addItem(this.createBean(new (0, $jIDNV.AgInputTextField)(this.getTextInputParams())), true);
        this.fontPanel.addItem(this.createBean(new $5b7ccabde48fae90$var$AgSlider(this.getSpacingSliderParams())));
        this.getGui().appendChild(this.fontPanel.getGui());
    }
    getTextInputParams() {
        return this.chartMenuUtils.addValueParams(`${this.key}.text`, {
            label: this.chartTranslation.translate("title"),
            labelAlignment: "top"
        });
    }
    getSpacingSliderParams() {
        return this.chartMenuUtils.getDefaultSliderParams(`${this.key}.spacing`, "spacing", 100);
    }
    onEnableChange(enabled) {
        this.chartOptions.setValue(`${this.key}.enabled`, enabled);
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/format/titles/chartTitlePanel.ts
var $5b7ccabde48fae90$var$ChartTitlePanel = class extends $5b7ccabde48fae90$var$TitlePanel {
    wireBeans(beans) {
        super.wireBeans(beans);
        this.chartMenuSvc = beans.chartMenuSvc;
    }
    postConstruct() {
        this.titlePlaceholder = this.chartTranslation.translate("titlePlaceholder");
        super.postConstruct();
        this.addManagedEventListeners({
            chartTitleEdit: ()=>{
                this.fontPanel.setEnabled(this.hasTitle());
            }
        });
    }
    getTextInputParams() {
        const params = super.getTextInputParams();
        if (this.shouldOverrideTextWithPlaceholder(params.value)) params.value = this.titlePlaceholder;
        return params;
    }
    getSpacingSliderParams() {
        const params = super.getSpacingSliderParams();
        params.value = "10";
        return params;
    }
    onEnableChange(enabled) {
        if (this.chartMenuSvc.doesChartToolbarExist()) {
            const topPadding = this.chartOptions.getValue("padding.top");
            this.chartOptions.setValue("padding.top", enabled ? topPadding - 20 : topPadding + 20);
        }
        this.chartOptions.setValue(`${this.key}.enabled`, enabled);
        const currentTitleText = this.chartOptions.getValue(`${this.key}.text`);
        if (enabled && this.shouldOverrideTextWithPlaceholder(currentTitleText)) this.chartOptions.setValue(`${this.key}.text`, this.titlePlaceholder);
    }
    shouldOverrideTextWithPlaceholder(currentTitleText) {
        return currentTitleText === "Title" || currentTitleText?.trim().length === 0;
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/format/titles/titlesPanel.ts
var $5b7ccabde48fae90$var$TitlesPanel = class extends (0, $jIDNV.Component) {
    constructor(options){
        super();
        this.options = options;
        this.titleGroup = (0, $jIDNV.RefPlaceholder);
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const { chartMenuParamsFactory: chartMenuParamsFactory, chartAxisMenuParamsFactory: chartAxisMenuParamsFactory, chartOptionsService: chartOptionsService, seriesType: seriesType, isExpandedOnInit: expanded = false, registerGroupComponent: registerGroupComponent } = this.options;
        const axisTitlePanels = [];
        if ($5b7ccabde48fae90$var$isCartesian(seriesType) && seriesType !== "pyramid") {
            const createAxisParamsFactory = (axisType)=>this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(chartOptionsService.getCartesianAxisThemeOverridesProxy(axisType)));
            axisTitlePanels.push(this.createManagedBean(new $5b7ccabde48fae90$var$TitlePanel(createAxisParamsFactory("xAxis"), "horizontalAxisTitle", "title")));
            axisTitlePanels.push(this.createManagedBean(new $5b7ccabde48fae90$var$TitlePanel(createAxisParamsFactory("yAxis"), "verticalAxisTitle", "title")));
        } else if ($5b7ccabde48fae90$var$isPolar(seriesType)) axisTitlePanels.push(this.createManagedBean(new $5b7ccabde48fae90$var$TitlePanel(chartAxisMenuParamsFactory, "polarAxisTitle", "title")));
        const titleGroupParams = {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.chartTranslation.translate("chartTitles"),
            expanded: expanded,
            suppressEnabledCheckbox: true,
            items: [
                this.createManagedBean(new $5b7ccabde48fae90$var$ChartTitlePanel(chartMenuParamsFactory, "chartTitle", "title")),
                this.createManagedBean(new $5b7ccabde48fae90$var$TitlePanel(chartMenuParamsFactory, "chartSubtitle", "subtitle")),
                ...axisTitlePanels
            ]
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="titleGroup"></ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$var$AgGroupComponentSelector
        ], {
            titleGroup: titleGroupParams
        });
        registerGroupComponent(this.titleGroup);
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/format/formatPanel.ts
var $5b7ccabde48fae90$var$DefaultFormatPanelDef = {
    groups: [
        {
            type: "chart"
        },
        {
            type: "titles"
        },
        {
            type: "legend"
        },
        {
            type: "series"
        },
        {
            type: "axis"
        }
    ]
};
var $5b7ccabde48fae90$var$AXIS_KEYS = [
    "axis",
    "horizontalAxis",
    "verticalAxis"
];
var $5b7ccabde48fae90$var$FormatPanel = class extends (0, $jIDNV.Component) {
    constructor(chartMenuContext){
        super(/* html */ `<div class="ag-chart-format-wrapper"></div>`);
        this.chartMenuContext = chartMenuContext;
    }
    postConstruct() {
        this.groupExpansionFeature = this.createManagedBean(new $5b7ccabde48fae90$var$GroupExpansionFeature(this.getGui()));
        this.chartPanelFeature = this.createManagedBean(new $5b7ccabde48fae90$var$ChartPanelFeature(this.chartMenuContext.chartController, this.getGui(), "ag-chart-format-section", (_chartType, seriesType)=>this.createPanels(seriesType)));
        this.chartPanelFeature.refreshPanels();
    }
    createPanels(seriesType) {
        let panelExpandedOnInit = false;
        this.getFormatPanelDef().groups?.forEach(({ type: group, isOpen: isExpandedOnInit = false })=>{
            if (!this.isGroupPanelShownInSeries(group, seriesType)) return;
            if (isExpandedOnInit) {
                if (panelExpandedOnInit) (0, $jIDNV._warn)(145, {
                    group: group
                });
                panelExpandedOnInit = true;
            }
            const registerGroupComponent = (groupComponent)=>this.groupExpansionFeature.addGroupComponent(groupComponent);
            const opts = {
                ...this.chartMenuContext,
                isExpandedOnInit: isExpandedOnInit,
                seriesType: seriesType,
                registerGroupComponent: registerGroupComponent
            };
            switch(group){
                case "chart":
                    this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$ChartPanel(opts));
                    break;
                case "titles":
                    this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$TitlesPanel(opts));
                    break;
                case "legend":
                    this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$LegendPanel(opts, this.chartMenuContext));
                    break;
                case "axis":
                    if ($5b7ccabde48fae90$var$isPolar(seriesType)) this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$PolarAxisPanel(opts));
                    else if ($5b7ccabde48fae90$var$isCartesian(seriesType)) {
                        this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$CartesianAxisPanel("xAxis", opts));
                        this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$CartesianAxisPanel("yAxis", opts));
                    }
                    break;
                case "horizontalAxis":
                    this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$CartesianAxisPanel("xAxis", opts));
                    break;
                case "verticalAxis":
                    this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$CartesianAxisPanel("yAxis", opts));
                    break;
                case "series":
                    this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$SeriesPanel(opts));
                    break;
                default:
                    (0, $jIDNV._warn)(147, {
                        group: group
                    });
            }
        });
    }
    getFormatPanelDef() {
        const userProvidedFormatPanelDef = this.gos.get("chartToolPanelsDef")?.formatPanel;
        return userProvidedFormatPanelDef ? userProvidedFormatPanelDef : $5b7ccabde48fae90$var$DefaultFormatPanelDef;
    }
    isGroupPanelShownInSeries(group, seriesType) {
        const enable = [
            "chart",
            "titles",
            "legend",
            "series"
        ].includes(group) || $5b7ccabde48fae90$var$isCartesian(seriesType) && $5b7ccabde48fae90$var$AXIS_KEYS.includes(group) || $5b7ccabde48fae90$var$isPolar(seriesType) && group === "axis";
        const disable = $5b7ccabde48fae90$var$isFunnel(seriesType) && group === "legend" || $5b7ccabde48fae90$var$isFunnel(seriesType) && $5b7ccabde48fae90$var$AXIS_KEYS.includes(group);
        return enable && !disable;
    }
};
var $5b7ccabde48fae90$var$CANVAS_CLASS = "ag-chart-mini-thumbnail-canvas";
var $5b7ccabde48fae90$var$MiniChart = class extends (0, $jIDNV.Component) {
    constructor(container, agChartsExports, tooltipName){
        super();
        this.agChartsExports = agChartsExports;
        this.tooltipName = tooltipName;
        this.size = 58;
        this.padding = 5;
        const { _Scene: _Scene } = agChartsExports;
        this.root = new _Scene.Group();
        const scene = new _Scene.Scene({
            width: this.size,
            height: this.size
        });
        scene.canvas.element.classList.add($5b7ccabde48fae90$var$CANVAS_CLASS);
        scene.setRoot(this.root);
        scene.setContainer(container);
        this.scene = scene;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        this.scene.canvas.element.title = this.chartTranslation.translate(this.tooltipName);
        try {
            this.scene.render();
        } catch (e) {
            (0, $jIDNV._error)(108, {
                e: e
            });
        }
    }
};
function $5b7ccabde48fae90$var$createColumnRects(params) {
    const { stacked: stacked, size: size, padding: padding, xScalePadding: xScalePadding, xScaleDomain: xScaleDomain, yScaleDomain: yScaleDomain, agChartsExports: { _Scene: _Scene } } = params;
    const xScale = new _Scene.CategoryScale();
    xScale.domain = xScaleDomain;
    xScale.range = [
        padding,
        size - padding
    ];
    xScale.paddingInner = xScalePadding;
    xScale.paddingOuter = xScalePadding;
    const yScale = new _Scene.LinearScale();
    yScale.domain = yScaleDomain;
    yScale.range = [
        size - padding,
        padding
    ];
    const createBars = (series, xScale2, yScale2)=>{
        return series.map((datum, i)=>{
            const top = yScale2.convert(datum);
            const rect = new _Scene.Rect();
            rect.x = xScale2.convert(i);
            rect.y = top;
            rect.width = xScale2.bandwidth;
            rect.height = yScale2.convert(0) - top;
            rect.strokeWidth = 0;
            rect.crisp = true;
            return rect;
        });
    };
    if (stacked) return params.data.map((d)=>createBars(d, xScale, yScale));
    return createBars(params.data, xScale, yScale);
}
function $5b7ccabde48fae90$var$prepareXYScales(_Scene, data, size, padding) {
    const xDomain = [];
    const yDomain = [];
    data.forEach((item)=>{
        item.forEach(([x, y])=>{
            xDomain.push(x);
            yDomain.push(y);
        });
    });
    const xScale = new _Scene.LinearScale();
    xScale.domain = [
        Math.min(...xDomain),
        Math.max(...xDomain)
    ];
    xScale.range = [
        padding,
        size - padding
    ];
    const yScale = new _Scene.LinearScale();
    yScale.domain = [
        Math.min(...yDomain),
        Math.max(...yDomain)
    ];
    yScale.range = [
        size - padding,
        padding
    ];
    return {
        xScale: xScale,
        yScale: yScale
    };
}
function $5b7ccabde48fae90$var$prepareLinearScene(_Scene, data, size, padding) {
    const xDomain = [
        0,
        data[0].length - 1
    ];
    const yDomain = data.reduce((acc, curr)=>{
        curr.forEach((datum)=>{
            if (datum < acc[0]) acc[0] = datum;
            if (datum > acc[1]) acc[1] = datum;
        });
        return acc;
    }, [
        Infinity,
        -Infinity
    ]);
    yDomain[0]--;
    yDomain[yDomain.length - 1]++;
    const xScale = new _Scene.LinearScale();
    xScale.domain = xDomain;
    xScale.range = [
        padding,
        size - padding
    ];
    const yScale = new _Scene.LinearScale();
    yScale.domain = yDomain;
    yScale.range = [
        size - padding,
        padding
    ];
    return {
        xScale: xScale,
        yScale: yScale
    };
}
function $5b7ccabde48fae90$var$createXPathCommands(data, xScale, yScale) {
    return data.map((series)=>series.map((datum, i)=>[
                i > 0 ? "lineTo" : "moveTo",
                xScale.convert(i),
                yScale.convert(datum)
            ]));
}
function $5b7ccabde48fae90$var$createXYPathCommands(shape, xScale, yScale) {
    return shape.map(([x, y], i)=>[
            i > 0 ? "lineTo" : "moveTo",
            xScale.convert(x),
            yScale.convert(y)
        ]);
}
function $5b7ccabde48fae90$var$closePath(commandSegments) {
    const closingCommand = commandSegments[0];
    const first = commandSegments[1];
    const last = (0, $jIDNV._last)(commandSegments);
    if (first[1] !== last[1] || first[2] !== last[2]) commandSegments.push([
        closingCommand[0],
        first[1],
        first[2]
    ]);
    return commandSegments;
}
function $5b7ccabde48fae90$var$createPath(_Scene, commands) {
    const path = new _Scene.Path();
    commands.forEach(([command, x, y])=>path.path[command](x, y));
    return path;
}
function $5b7ccabde48fae90$var$createAreaPathCommands(commands, yScale, stacked) {
    return commands.map((pathCommands, index, all)=>{
        const closingPath = stacked ? $5b7ccabde48fae90$var$closePathViaPreviousSeries(all, index, yScale) : $5b7ccabde48fae90$var$closePathViaOrigin(pathCommands, yScale);
        const closingPathCommands = [
            ...closingPath
        ].reverse().map(([_, x, y])=>[
                "lineTo",
                x,
                y
            ]);
        const first = pathCommands[0];
        const last = (0, $jIDNV._last)(closingPathCommands);
        if (first[1] !== last[1] || first[2] !== last[2]) closingPathCommands.push([
            "lineTo",
            first[1],
            first[2]
        ]);
        return [
            ...pathCommands,
            ...closingPathCommands
        ];
    });
}
function $5b7ccabde48fae90$var$closePathViaPreviousSeries(all, index, yScale) {
    if (index === 0) return $5b7ccabde48fae90$var$closePathViaOrigin(all[index], yScale);
    return [
        ...all[index - 1]
    ];
}
function $5b7ccabde48fae90$var$closePathViaOrigin(pathCommands, yScale) {
    return pathCommands.map(([c, x])=>[
            c,
            x,
            yScale.convert(0)
        ]);
}
function $5b7ccabde48fae90$var$commandsToPath(_Scene, commands) {
    const path = $5b7ccabde48fae90$var$createPath(_Scene, commands);
    path.fill = void 0;
    path.lineCap = "round";
    path.strokeWidth = 3;
    return path;
}
function $5b7ccabde48fae90$var$createShapePaths({ _Scene: _Scene }, root, shapes, size, padding) {
    const { xScale: xScale, yScale: yScale } = $5b7ccabde48fae90$var$prepareXYScales(_Scene, shapes, size, padding);
    const openPathsCommands = shapes.map((shape)=>$5b7ccabde48fae90$var$createXYPathCommands(shape, xScale, yScale));
    const shapesCommands = openPathsCommands.map((path)=>$5b7ccabde48fae90$var$closePath(path));
    const shapePaths = shapesCommands.map((shapeCommands)=>$5b7ccabde48fae90$var$commandsToPath(_Scene, shapeCommands));
    const paths = shapePaths.reduce((acc, curr)=>acc.concat(curr), []);
    const pathsGroup = new _Scene.Group();
    pathsGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding * 2, size - padding * 2));
    pathsGroup.append(paths);
    root.append(pathsGroup);
    return paths;
}
function $5b7ccabde48fae90$var$createLinePaths({ _Scene: _Scene }, root, data, size, padding) {
    const { xScale: xScale, yScale: yScale } = $5b7ccabde48fae90$var$prepareLinearScene(_Scene, data, size, padding);
    const pathCommands = $5b7ccabde48fae90$var$createXPathCommands(data, xScale, yScale);
    const paths = pathCommands.map((commands)=>$5b7ccabde48fae90$var$commandsToPath(_Scene, commands));
    const pathsGroup = new _Scene.Group();
    pathsGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding * 2, size - padding * 2));
    pathsGroup.append(paths);
    root.append(pathsGroup);
    return paths;
}
function $5b7ccabde48fae90$var$createAreaPaths(_Scene, root, data, size, padding, stacked = false) {
    const { xScale: xScale, yScale: yScale } = $5b7ccabde48fae90$var$prepareLinearScene(_Scene, data, size, padding);
    const pathCommands = $5b7ccabde48fae90$var$createAreaPathCommands($5b7ccabde48fae90$var$createXPathCommands(data, xScale, yScale), yScale, stacked);
    const areasGroup = new _Scene.Group();
    areasGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding * 2, size - padding * 2));
    const paths = pathCommands.map((commands)=>$5b7ccabde48fae90$var$createPath(_Scene, commands));
    areasGroup.append(paths);
    root.append(areasGroup);
    return paths;
}
function $5b7ccabde48fae90$var$stackData(data) {
    return data.map((stack, sindex, array)=>stack.map((_y, i)=>array.slice(0, sindex + 1).reduce((p, c)=>p + c[i], 0)));
}
function $5b7ccabde48fae90$var$normalizeStackData(data) {
    const colSum = data.map((_, index)=>data.reduce((acc, cur)=>Math.max(acc, cur[index]), 0));
    return data.map((stack)=>stack.map((y, index)=>y / colSum[index] * 19));
}
function $5b7ccabde48fae90$var$createPolarPaths(agChartsExports, root, data, size, radius, innerRadius, markerSize = 0) {
    const { _Scene: _Scene } = agChartsExports;
    const angleScale = new _Scene.LinearScale();
    angleScale.domain = [
        0,
        7
    ];
    angleScale.range = [
        -Math.PI,
        Math.PI
    ].map((angle)=>angle + Math.PI / 2);
    const radiusScale = new _Scene.LinearScale();
    radiusScale.domain = [
        0,
        10
    ];
    radiusScale.range = [
        radius,
        innerRadius
    ];
    const markers2 = [];
    const center = size / 2;
    const paths = data.map((series)=>{
        const path = new _Scene.Path();
        path.strokeWidth = 1;
        path.strokeOpacity = 0.5;
        path.lineCap = "round";
        path.fill = void 0;
        path.fillOpacity = 0.8;
        series.forEach((datum, i)=>{
            const angle = angleScale.convert(i);
            const r = radius + innerRadius - radiusScale.convert(datum);
            const x = r * Math.cos(angle) + center;
            const y = r * Math.sin(angle) + center;
            path.path[i > 0 ? "lineTo" : "moveTo"](x, y);
            if (markerSize > 0) {
                const marker = new _Scene.Marker({
                    shape: "circle"
                });
                marker.x = x;
                marker.y = y;
                marker.size = markerSize;
                markers2.push(marker);
            }
        });
        path.path.closePath();
        return path;
    });
    const group = new _Scene.Group();
    group.append([
        ...paths,
        ...markers2
    ]);
    root.append(group);
    return {
        paths: paths,
        markers: markers2
    };
}
function $5b7ccabde48fae90$var$accumulateData(data) {
    let [min, max] = [
        Infinity,
        -Infinity
    ];
    const processedData = data.reduce((acc, curr, currIndex)=>{
        const previous = currIndex > 0 ? acc[currIndex - 1] : void 0;
        acc[currIndex] ?? (acc[currIndex] = []);
        const current = acc[currIndex];
        curr.forEach((datum, datumIndex)=>{
            if (previous) datum += previous[datumIndex];
            current[datumIndex] = datum;
            if (current[datumIndex] < min) min = current[datumIndex];
            if (current[datumIndex] > max) max = current[datumIndex];
        });
        return acc;
    }, []);
    return {
        processedData: processedData,
        min: min,
        max: max
    };
}
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/funnel/miniFunnel.ts
var $5b7ccabde48fae90$var$FUNNEL_SHAPES = [
    [
        [
            13,
            16
        ],
        [
            13,
            12
        ],
        [
            3,
            12
        ],
        [
            3,
            16
        ]
    ],
    [
        [
            12,
            11
        ],
        [
            12,
            7
        ],
        [
            4,
            7
        ],
        [
            4,
            11
        ]
    ],
    [
        [
            10.125,
            6
        ],
        [
            10.125,
            1.5
        ],
        [
            5.875,
            1.5
        ],
        [
            5.875,
            6
        ]
    ]
];
var $5b7ccabde48fae90$var$MiniFunnelClass = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, tooltipName = "funnelTooltip", data = $5b7ccabde48fae90$var$FUNNEL_SHAPES){
        super(container, agChartsExports, tooltipName);
        this.shapes = $5b7ccabde48fae90$var$createShapePaths(agChartsExports, this.root, data, this.size, this.padding);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.shapes.forEach((bar)=>{
            bar.fill = fills[0];
            bar.stroke = strokes[0];
            bar.strokeWidth = 0;
        });
    }
};
var $5b7ccabde48fae90$var$MiniFunnel = {
    chartType: "funnel",
    miniChart: $5b7ccabde48fae90$var$MiniFunnelClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/funnel/miniConeFunnel.ts
var $5b7ccabde48fae90$var$CONE_FUNNEL_SHAPES = [
    [
        [
            13,
            16
        ],
        [
            10.75,
            11.5
        ],
        [
            5.25,
            11.5
        ],
        [
            3,
            16
        ]
    ],
    [
        [
            10.75,
            11.5
        ],
        [
            8.875,
            6
        ],
        [
            7.125,
            6
        ],
        [
            5.25,
            11.5
        ]
    ],
    [
        [
            8.875,
            6
        ],
        [
            8.875,
            1.5
        ],
        [
            7.125,
            1.5
        ],
        [
            7.125,
            6
        ]
    ]
];
var $5b7ccabde48fae90$var$MiniConeFunnelClass = class extends $5b7ccabde48fae90$var$MiniFunnelClass {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, tooltipName = "coneFunnelTooltip"){
        super(container, agChartsExports, fills, strokes, _isCustomTheme, tooltipName, $5b7ccabde48fae90$var$CONE_FUNNEL_SHAPES);
    }
    updateColors(fills, strokes) {
        this.shapes.forEach((bar, i)=>{
            bar.fill = fills[0];
            bar.fillOpacity = 1 - i * 0.2;
            bar.stroke = strokes[0];
            bar.strokeWidth = 0;
        });
    }
};
var $5b7ccabde48fae90$var$MiniConeFunnel = {
    chartType: "coneFunnel",
    miniChart: $5b7ccabde48fae90$var$MiniConeFunnelClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/funnel/miniPyramid.ts
var $5b7ccabde48fae90$var$PYRAMID_SHAPES = [
    [
        [
            8,
            16
        ],
        [
            10,
            12
        ],
        [
            6,
            12
        ]
    ],
    [
        [
            10.5,
            11
        ],
        [
            12.5,
            7
        ],
        [
            3.5,
            7
        ],
        [
            5.5,
            11
        ]
    ],
    [
        [
            13,
            6
        ],
        [
            15.5,
            1.5
        ],
        [
            0.5,
            1.5
        ],
        [
            3,
            6
        ]
    ]
];
var $5b7ccabde48fae90$var$MiniPyramidClass = class extends $5b7ccabde48fae90$var$MiniFunnelClass {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, tooltipName = "pyramidTooltip"){
        super(container, agChartsExports, fills, strokes, _isCustomTheme, tooltipName, $5b7ccabde48fae90$var$PYRAMID_SHAPES);
    }
    updateColors(fills, strokes) {
        this.shapes.forEach((bar, i)=>{
            bar.fill = fills[i];
            bar.stroke = strokes[i];
            bar.strokeWidth = 0;
        });
    }
};
var $5b7ccabde48fae90$var$MiniPyramid = {
    chartType: "pyramid",
    miniChart: $5b7ccabde48fae90$var$MiniPyramidClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/miniChartWithAxes.ts
var $5b7ccabde48fae90$var$MiniChartWithAxes = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, agChartsExports, tooltipName){
        super(container, agChartsExports, tooltipName);
        this.stroke = "gray";
        this.axisOvershoot = 3;
    }
    postConstruct() {
        const { _Scene: _Scene } = this.agChartsExports;
        const size = this.size;
        const padding = this.padding;
        const leftAxis = new _Scene.Line();
        leftAxis.x1 = padding;
        leftAxis.y1 = padding;
        leftAxis.x2 = padding;
        leftAxis.y2 = size - padding + this.axisOvershoot;
        leftAxis.stroke = this.stroke;
        const bottomAxis = new _Scene.Line();
        bottomAxis.x1 = padding - this.axisOvershoot + 1;
        bottomAxis.y1 = size - padding;
        bottomAxis.x2 = size - padding + 1;
        bottomAxis.y2 = size - padding;
        bottomAxis.stroke = this.stroke;
        const root = this.root;
        root.append(leftAxis);
        root.append(bottomAxis);
        super.postConstruct();
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/column/miniColumn.ts
var $5b7ccabde48fae90$var$MiniColumnClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "groupedColumnTooltip");
        this.columnData = [
            2,
            3,
            4
        ];
        const { root: root, columnData: columnData, size: size, padding: padding } = this;
        this.columns = $5b7ccabde48fae90$var$createColumnRects({
            stacked: false,
            root: root,
            data: columnData,
            size: size,
            padding: padding,
            xScaleDomain: [
                0,
                1,
                2
            ],
            yScaleDomain: [
                0,
                4
            ],
            xScalePadding: 0.3,
            agChartsExports: agChartsExports
        });
        root.append(this.columns);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.columns.forEach((column, i)=>{
            column.fill = fills[i];
            column.stroke = strokes[i];
        });
    }
};
var $5b7ccabde48fae90$var$MiniColumn = {
    chartType: "groupedColumn",
    miniChart: $5b7ccabde48fae90$var$MiniColumnClass
};
var $5b7ccabde48fae90$var$miniStackedColumnData = [
    [
        8,
        12,
        16
    ],
    [
        6,
        9,
        12
    ],
    [
        2,
        3,
        4
    ]
];
var $5b7ccabde48fae90$var$MiniStackedColumnClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, data = $5b7ccabde48fae90$var$miniStackedColumnData, yScaleDomain = [
        0,
        16
    ], tooltipName = "stackedColumnTooltip"){
        super(container, agChartsExports, tooltipName);
        const { root: root, size: size, padding: padding } = this;
        this.stackedColumns = $5b7ccabde48fae90$var$createColumnRects({
            stacked: true,
            root: root,
            data: data,
            size: size,
            padding: padding,
            xScaleDomain: [
                0,
                1,
                2
            ],
            yScaleDomain: yScaleDomain,
            xScalePadding: 0.3,
            agChartsExports: agChartsExports
        });
        root.append((0, $jIDNV._flatten)(this.stackedColumns));
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.stackedColumns.forEach((series, i)=>series.forEach((column)=>{
                column.fill = fills[i];
                column.stroke = strokes[i];
            }));
    }
};
var $5b7ccabde48fae90$var$MiniStackedColumn = {
    chartType: "stackedColumn",
    miniChart: $5b7ccabde48fae90$var$MiniStackedColumnClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/column/miniNormalizedColumn.ts
var $5b7ccabde48fae90$var$miniNormalizedColumnData = [
    [
        10,
        10,
        10
    ],
    [
        6,
        7,
        8
    ],
    [
        2,
        4,
        6
    ]
];
var $5b7ccabde48fae90$var$MiniNormalizedColumnClass = class extends $5b7ccabde48fae90$var$MiniStackedColumnClass {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme){
        super(container, agChartsExports, fills, strokes, isCustomTheme, $5b7ccabde48fae90$var$miniNormalizedColumnData, [
            0,
            10
        ], "normalizedColumnTooltip");
    }
};
var $5b7ccabde48fae90$var$MiniNormalizedColumn = {
    chartType: "normalizedColumn",
    miniChart: $5b7ccabde48fae90$var$MiniNormalizedColumnClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/bar/miniBar.ts
var $5b7ccabde48fae90$var$MiniBarClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "groupedBarTooltip");
        const { _Scene: _Scene } = agChartsExports;
        const padding = this.padding;
        const size = this.size;
        const data = [
            2,
            3,
            4
        ];
        const yScale = new _Scene.CategoryScale();
        yScale.domain = [
            0,
            1,
            2
        ];
        yScale.range = [
            padding,
            size - padding
        ];
        yScale.paddingInner = 0.3;
        yScale.paddingOuter = 0.3;
        const xScale = new _Scene.LinearScale();
        xScale.domain = [
            0,
            4
        ];
        xScale.range = [
            size - padding,
            padding
        ];
        const bottom = xScale.convert(0);
        const height = yScale.bandwidth;
        this.bars = data.map((datum, i)=>{
            const rect = new _Scene.Rect();
            rect.x = padding;
            rect.y = yScale.convert(i);
            rect.width = bottom - xScale.convert(datum);
            rect.height = height;
            rect.strokeWidth = 0;
            rect.crisp = true;
            return rect;
        });
        this.updateColors(fills, strokes);
        this.root.append(this.bars);
    }
    updateColors(fills, strokes) {
        this.bars.forEach((bar, i)=>{
            bar.fill = fills[i];
            bar.stroke = strokes[i];
        });
    }
};
var $5b7ccabde48fae90$var$MiniBar = {
    chartType: "groupedBar",
    miniChart: $5b7ccabde48fae90$var$MiniBarClass
};
var $5b7ccabde48fae90$var$miniStackedBarData = [
    [
        8,
        12,
        16
    ],
    [
        6,
        9,
        12
    ],
    [
        2,
        3,
        4
    ]
];
var $5b7ccabde48fae90$var$MiniStackedBarClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, data = $5b7ccabde48fae90$var$miniStackedBarData, xScaleDomain = [
        0,
        16
    ], tooltipName = "stackedBarTooltip"){
        super(container, agChartsExports, tooltipName);
        const { _Scene: _Scene } = agChartsExports;
        const size = this.size;
        const padding = this.padding;
        const yScale = new _Scene.CategoryScale();
        yScale.domain = [
            0,
            1,
            2
        ];
        yScale.range = [
            padding,
            size - padding
        ];
        yScale.paddingInner = 0.3;
        yScale.paddingOuter = 0.3;
        const xScale = new _Scene.LinearScale();
        xScale.domain = xScaleDomain;
        xScale.range = [
            size - padding,
            padding
        ];
        const bottom = xScale.convert(0);
        const height = yScale.bandwidth;
        this.bars = data.map((series)=>series.map((datum, i)=>{
                const rect = new _Scene.Rect();
                rect.x = padding;
                rect.y = yScale.convert(i);
                rect.width = bottom - xScale.convert(datum);
                rect.height = height;
                rect.strokeWidth = 0;
                rect.crisp = true;
                return rect;
            }));
        this.updateColors(fills, strokes);
        this.root.append((0, $jIDNV._flatten)(this.bars));
    }
    updateColors(fills, strokes) {
        this.bars.forEach((series, i)=>series.forEach((bar)=>{
                bar.fill = fills[i];
                bar.stroke = strokes[i];
            }));
    }
};
var $5b7ccabde48fae90$var$MiniStackedBar = {
    chartType: "stackedBar",
    miniChart: $5b7ccabde48fae90$var$MiniStackedBarClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/bar/miniNormalizedBar.ts
var $5b7ccabde48fae90$var$miniNormalizedBarData = [
    [
        10,
        10,
        10
    ],
    [
        6,
        7,
        8
    ],
    [
        2,
        4,
        6
    ]
];
var $5b7ccabde48fae90$var$MiniNormalizedBarClass = class extends $5b7ccabde48fae90$var$MiniStackedBarClass {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme){
        super(container, agChartsExports, fills, strokes, isCustomTheme, $5b7ccabde48fae90$var$miniNormalizedBarData, [
            0,
            10
        ], "normalizedBarTooltip");
    }
};
var $5b7ccabde48fae90$var$MiniNormalizedBar = {
    chartType: "normalizedBar",
    miniChart: $5b7ccabde48fae90$var$MiniNormalizedBarClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/pie/miniDonut.ts
var $5b7ccabde48fae90$var$MiniDonutClass = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, centerRadiusScaler = 0.6, tooltipName = "donutTooltip"){
        super(container, agChartsExports, tooltipName);
        const { size: size, padding: padding, agChartsExports: { _Scene: _Scene } } = this;
        const radius = (size - padding * 2) / 2;
        const center = radius + padding;
        const toRadians = _Scene.toRadians;
        const angles = [
            [
                toRadians(-90),
                toRadians(30)
            ],
            [
                toRadians(30),
                toRadians(120)
            ],
            [
                toRadians(120),
                toRadians(180)
            ],
            [
                toRadians(180),
                toRadians(210)
            ],
            [
                toRadians(210),
                toRadians(240)
            ],
            [
                toRadians(240),
                toRadians(270)
            ]
        ];
        this.sectors = angles.map(([startAngle, endAngle])=>{
            const sector = new _Scene.Sector();
            sector.centerX = center;
            sector.centerY = center;
            sector.innerRadius = radius * centerRadiusScaler;
            sector.outerRadius = radius;
            sector.startAngle = startAngle;
            sector.endAngle = endAngle;
            sector.stroke = void 0;
            sector.strokeWidth = 0;
            sector.inset = 0.75;
            return sector;
        });
        this.updateColors(fills, strokes);
        this.root.append(this.sectors);
    }
    updateColors(fills, strokes) {
        this.sectors.forEach((sector, i)=>{
            sector.fill = fills[i % fills.length];
            sector.stroke = strokes[i % strokes.length];
        });
    }
};
var $5b7ccabde48fae90$var$MiniDonut = {
    chartType: "donut",
    miniChart: $5b7ccabde48fae90$var$MiniDonutClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/pie/miniPie.ts
var $5b7ccabde48fae90$var$MiniPieClass = class extends $5b7ccabde48fae90$var$MiniDonutClass {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme){
        super(container, agChartsExports, fills, strokes, isCustomTheme, 0, "pieTooltip");
    }
};
var $5b7ccabde48fae90$var$MiniPie = {
    chartType: "pie",
    miniChart: $5b7ccabde48fae90$var$MiniPieClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/line/miniLine.ts
var $5b7ccabde48fae90$var$miniLineData = [
    [
        1,
        3,
        5
    ],
    [
        2,
        6,
        4
    ],
    [
        5,
        3,
        1
    ]
];
var $5b7ccabde48fae90$var$MiniLineClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, data = $5b7ccabde48fae90$var$miniLineData, tooltipName = "lineTooltip"){
        super(container, agChartsExports, tooltipName);
        const { size: size, padding: padding, root: root } = this;
        this.lines = $5b7ccabde48fae90$var$createLinePaths(agChartsExports, root, data, size, padding);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, _strokes) {
        this.lines.forEach((line, i)=>{
            line.stroke = fills[i];
        });
    }
};
var $5b7ccabde48fae90$var$MiniLine = {
    chartType: "line",
    miniChart: $5b7ccabde48fae90$var$MiniLineClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/line/miniStackedLine.ts
var $5b7ccabde48fae90$var$miniStackedLineData = $5b7ccabde48fae90$var$stackData($5b7ccabde48fae90$var$miniLineData);
var $5b7ccabde48fae90$var$MiniStackedLineClass = class extends $5b7ccabde48fae90$var$MiniLineClass {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, data = $5b7ccabde48fae90$var$miniStackedLineData, tooltipName = "stackedLineTooltip"){
        super(container, agChartsExports, fills, strokes, _isCustomTheme, data, tooltipName);
    }
};
var $5b7ccabde48fae90$var$MiniStackedLine = {
    chartType: "stackedLine",
    miniChart: $5b7ccabde48fae90$var$MiniStackedLineClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/line/miniNormalizedLine.ts
var $5b7ccabde48fae90$var$miniNormalizedLineData = $5b7ccabde48fae90$var$normalizeStackData($5b7ccabde48fae90$var$miniStackedLineData);
var $5b7ccabde48fae90$var$MiniNormalizedLineClass = class extends $5b7ccabde48fae90$var$MiniLineClass {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme, data = $5b7ccabde48fae90$var$miniNormalizedLineData, tooltipName = "normalizedLineTooltip"){
        super(container, agChartsExports, fills, strokes, isCustomTheme, data, tooltipName);
    }
};
var $5b7ccabde48fae90$var$MiniNormalizedLine = {
    chartType: "normalizedLine",
    miniChart: $5b7ccabde48fae90$var$MiniNormalizedLineClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/scatter/miniScatter.ts
var $5b7ccabde48fae90$var$MiniScatterClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "scatterTooltip");
        const { size: size, padding: padding, agChartsExports: { _Scene: _Scene } } = this;
        const data = [
            [
                [
                    0.3,
                    3
                ],
                [
                    1.1,
                    0.9
                ],
                [
                    2,
                    0.4
                ],
                [
                    3.4,
                    2.4
                ]
            ],
            [
                [
                    0,
                    0.3
                ],
                [
                    1,
                    2
                ],
                [
                    2.4,
                    1.4
                ],
                [
                    3,
                    0
                ]
            ]
        ];
        const xScale = new _Scene.LinearScale();
        xScale.domain = [
            -0.5,
            4
        ];
        xScale.range = [
            padding * 2,
            size - padding
        ];
        const yScale = new _Scene.LinearScale();
        yScale.domain = [
            -0.5,
            3.5
        ];
        yScale.range = [
            size - padding,
            padding
        ];
        const points = [];
        data.forEach((series)=>{
            series.forEach(([x, y])=>{
                const arc = new _Scene.Arc();
                arc.strokeWidth = 0;
                arc.centerX = xScale.convert(x);
                arc.centerY = yScale.convert(y);
                arc.radius = 2.5;
                points.push(arc);
            });
        });
        this.points = points;
        this.updateColors(fills, strokes);
        const pointsGroup = new _Scene.Group();
        pointsGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding * 2, size - padding * 2));
        pointsGroup.append(this.points);
        this.root.append(pointsGroup);
    }
    updateColors(fills, strokes) {
        this.points.forEach((line, i)=>{
            line.stroke = strokes[i % strokes.length];
            line.fill = fills[i % fills.length];
        });
    }
};
var $5b7ccabde48fae90$var$MiniScatter = {
    chartType: "scatter",
    miniChart: $5b7ccabde48fae90$var$MiniScatterClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/scatter/miniBubble.ts
var $5b7ccabde48fae90$var$MiniBubbleClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "bubbleTooltip");
        const { size: size, padding: padding, agChartsExports: { _Scene: _Scene } } = this;
        const data = [
            [
                [
                    0.1,
                    0.3,
                    5
                ],
                [
                    0.5,
                    0.4,
                    7
                ],
                [
                    0.2,
                    0.8,
                    7
                ]
            ],
            [
                [
                    0.8,
                    0.7,
                    5
                ],
                [
                    0.7,
                    0.3,
                    9
                ]
            ]
        ];
        const xScale = new _Scene.LinearScale();
        xScale.domain = [
            0,
            1
        ];
        xScale.range = [
            padding * 2,
            size - padding
        ];
        const yScale = new _Scene.LinearScale();
        yScale.domain = [
            0,
            1
        ];
        yScale.range = [
            size - padding,
            padding
        ];
        const points = [];
        data.forEach((series)=>{
            series.forEach(([x, y, radius])=>{
                const arc = new _Scene.Arc();
                arc.strokeWidth = 0;
                arc.centerX = xScale.convert(x);
                arc.centerY = yScale.convert(y);
                arc.radius = radius;
                arc.fillOpacity = 0.7;
                points.push(arc);
            });
        });
        this.points = points;
        this.updateColors(fills, strokes);
        const pointsGroup = new _Scene.Group();
        pointsGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding * 2, size - padding * 2));
        pointsGroup.append(this.points);
        this.root.append(pointsGroup);
    }
    updateColors(fills, strokes) {
        this.points.forEach((line, i)=>{
            line.stroke = strokes[i % strokes.length];
            line.fill = fills[i % fills.length];
        });
    }
};
var $5b7ccabde48fae90$var$MiniBubble = {
    chartType: "bubble",
    miniChart: $5b7ccabde48fae90$var$MiniBubbleClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/area/miniArea.ts
var $5b7ccabde48fae90$var$miniAreaData = $5b7ccabde48fae90$var$miniLineData;
var $5b7ccabde48fae90$var$MiniAreaClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, data = $5b7ccabde48fae90$var$miniAreaData, tooltipName = "groupedAreaTooltip", stacked = false){
        super(container, agChartsExports, tooltipName);
        this.areas = $5b7ccabde48fae90$var$createAreaPaths(agChartsExports._Scene, this.root, data, this.size, this.padding, stacked);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.areas.forEach((area, i)=>{
            area.fill = fills[i];
            area.stroke = strokes[i];
            area.strokeWidth = 1;
            area.strokeOpacity = 0.75;
            area.fillOpacity = 0.7;
        });
    }
};
var $5b7ccabde48fae90$var$MiniArea = {
    chartType: "area",
    miniChart: $5b7ccabde48fae90$var$MiniAreaClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/area/miniStackedArea.ts
var $5b7ccabde48fae90$var$miniStackedAreaData = $5b7ccabde48fae90$var$stackData($5b7ccabde48fae90$var$miniAreaData);
var $5b7ccabde48fae90$var$MiniStackedAreaClass = class extends $5b7ccabde48fae90$var$MiniAreaClass {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, data = $5b7ccabde48fae90$var$miniStackedAreaData, tooltipName = "stackedAreaTooltip"){
        super(container, agChartsExports, fills, strokes, _isCustomTheme, data, tooltipName, true);
    }
    updateColors(fills, strokes) {
        this.areas.forEach((area, i)=>{
            area.fill = fills[i];
            area.stroke = strokes[i];
        });
    }
};
var $5b7ccabde48fae90$var$MiniStackedArea = {
    chartType: "stackedArea",
    miniChart: $5b7ccabde48fae90$var$MiniStackedAreaClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/area/miniNormalizedArea.ts
var $5b7ccabde48fae90$var$miniNormalizedAreaData = $5b7ccabde48fae90$var$normalizeStackData($5b7ccabde48fae90$var$miniStackedAreaData);
var $5b7ccabde48fae90$var$MiniNormalizedAreaClass = class extends $5b7ccabde48fae90$var$MiniStackedAreaClass {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme, data = $5b7ccabde48fae90$var$miniNormalizedAreaData, tooltipName = "normalizedAreaTooltip"){
        super(container, agChartsExports, fills, strokes, isCustomTheme, data, tooltipName);
    }
};
var $5b7ccabde48fae90$var$MiniNormalizedArea = {
    chartType: "normalizedArea",
    miniChart: $5b7ccabde48fae90$var$MiniNormalizedAreaClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/histogram/miniHistogram.ts
var $5b7ccabde48fae90$var$MiniHistogramClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "histogramTooltip");
        const { padding: padding, size: size, agChartsExports: { _Scene: _Scene } } = this;
        const data = [
            2,
            5,
            11,
            13,
            10,
            6,
            1
        ];
        const xScale = new _Scene.LinearScale();
        xScale.domain = [
            0,
            data.length
        ];
        xScale.range = [
            padding,
            size - padding
        ];
        const yScale = new _Scene.LinearScale();
        yScale.domain = [
            0,
            data.reduce((a, b)=>Math.max(a, b), 0)
        ];
        yScale.range = [
            size - padding,
            padding
        ];
        const bottom = yScale.convert(0);
        this.bars = data.map((datum, i)=>{
            const top = yScale.convert(datum);
            const left = xScale.convert(i);
            const right = xScale.convert(i + 1);
            const rect = new _Scene.Rect();
            rect.x = left;
            rect.y = top;
            rect.width = right - left;
            rect.height = bottom - top;
            rect.strokeWidth = 1;
            rect.strokeOpacity = 0.75;
            rect.crisp = true;
            return rect;
        });
        this.updateColors(fills, strokes);
        this.root.append(this.bars);
    }
    updateColors([fill], [stroke]) {
        this.bars.forEach((bar)=>{
            bar.fill = fill;
            bar.stroke = stroke;
        });
    }
};
var $5b7ccabde48fae90$var$MiniHistogram = {
    chartType: "histogram",
    miniChart: $5b7ccabde48fae90$var$MiniHistogramClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/miniChartWithPolarAxes.ts
var $5b7ccabde48fae90$var$MiniChartWithPolarAxes = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, agChartsExports, tooltipName){
        super(container, agChartsExports, tooltipName);
        this.stroke = "gray";
        this.showRadiusAxisLine = true;
        this.showAngleAxisLines = true;
    }
    postConstruct() {
        const { _Scene: _Scene } = this.agChartsExports;
        const size = this.size;
        const padding = this.padding;
        const combinedPadding = padding * 2;
        const axisLineRadius = (size - combinedPadding) / 2;
        const gridRadii = this.showAngleAxisLines ? [
            axisLineRadius,
            axisLineRadius * 0.8,
            axisLineRadius * 0.6,
            axisLineRadius * 0.4
        ] : [];
        const radiusAxisLine = new _Scene.Line();
        radiusAxisLine.x1 = size / 2;
        radiusAxisLine.y1 = padding;
        radiusAxisLine.x2 = size / 2;
        radiusAxisLine.y2 = size - padding - axisLineRadius - gridRadii[gridRadii.length - 1];
        radiusAxisLine.stroke = this.stroke;
        radiusAxisLine.strokeOpacity = 0.5;
        radiusAxisLine.fill = void 0;
        radiusAxisLine.visible = this.showRadiusAxisLine;
        const x = padding + axisLineRadius;
        this.gridLines = gridRadii.map((radius, index)=>{
            const gridLine = new _Scene.Path();
            gridLine.path.arc(x, x, radius, 0, 2 * Math.PI);
            gridLine.strokeWidth = 1;
            gridLine.stroke = this.stroke;
            gridLine.strokeOpacity = index === 0 ? 0.5 : 0.2;
            gridLine.fill = void 0;
            return gridLine;
        });
        const root = this.root;
        root.append(radiusAxisLine);
        if (this.gridLines.length > 0) root.append(this.gridLines);
        super.postConstruct();
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/polar/miniRadialColumn.ts
var $5b7ccabde48fae90$var$MiniRadialColumnClass = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "radialColumnTooltip");
        this.data = [
            [
                6,
                8,
                10,
                2,
                6,
                5
            ],
            [
                4,
                4,
                3,
                6,
                4,
                4
            ],
            [
                5,
                4,
                2,
                9,
                8,
                9
            ]
        ];
        this.showRadiusAxisLine = false;
        const { padding: padding, size: size, data: data, agChartsExports: { _Scene: _Scene } } = this;
        const radius = (size - padding * 2) / 2;
        const innerRadiusRatio = 0.4;
        const axisInnerRadius = radius * innerRadiusRatio;
        const angleScale = new _Scene.CategoryScale();
        angleScale.domain = data[0].map((_, index)=>index);
        angleScale.range = [
            0,
            2 * Math.PI
        ];
        angleScale.paddingInner = 0;
        angleScale.paddingOuter = 0;
        const bandwidth = angleScale.bandwidth * 0.7;
        const { processedData: processedData, max: max } = $5b7ccabde48fae90$var$accumulateData(data);
        const radiusScale = new _Scene.LinearScale();
        radiusScale.domain = [
            0,
            max
        ];
        radiusScale.range = [
            axisInnerRadius,
            radius
        ];
        const center = this.size / 2;
        this.series = processedData.map((series, seriesIndex)=>{
            const firstSeries = seriesIndex === 0;
            const previousSeries = firstSeries ? void 0 : processedData[seriesIndex - 1];
            const seriesGroup = new _Scene.TranslatableGroup({
                zIndex: 1e6
            });
            const seriesColumns = series.map((datum, i)=>{
                const previousDatum = previousSeries?.[i];
                const outerRadius = radiusScale.convert(datum);
                const innerRadius = radiusScale.convert(previousDatum ?? 0);
                const startAngle = angleScale.convert(i);
                const endAngle = startAngle + bandwidth;
                const columnWidth = _Scene.getRadialColumnWidth(startAngle, endAngle, radius, 0.5, 0.5);
                const column = new _Scene.RadialColumnShape();
                column.columnWidth = columnWidth;
                column.innerRadius = innerRadius;
                column.outerRadius = outerRadius;
                column.startAngle = startAngle;
                column.endAngle = endAngle;
                column.isBeveled = true;
                column.axisInnerRadius = axisInnerRadius;
                column.axisOuterRadius = radius;
                column.stroke = void 0;
                column.strokeWidth = 0;
                return column;
            });
            seriesGroup.append(seriesColumns);
            seriesGroup.translationX = center;
            seriesGroup.translationY = center;
            return seriesGroup;
        });
        this.root.append(this.series);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.series.forEach((group, i)=>{
            for (const sector of group.children()){
                sector.fill = fills[i % fills.length];
                sector.stroke = strokes[i % strokes.length];
            }
        });
    }
};
var $5b7ccabde48fae90$var$MiniRadialColumn = {
    chartType: "radialColumn",
    miniChart: $5b7ccabde48fae90$var$MiniRadialColumnClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/polar/miniRadialBar.ts
var $5b7ccabde48fae90$var$MiniRadialBarClass = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "radialBarTooltip");
        this.data = [
            [
                6,
                8,
                10
            ],
            [
                4,
                4,
                3
            ],
            [
                5,
                4,
                2
            ]
        ];
        this.showRadiusAxisLine = false;
        const { size: size, padding: padding, data: data, agChartsExports: { _Scene: _Scene } } = this;
        const radius = (size - padding) / 2;
        const innerRadiusRatio = 0.4;
        const innerRadius = radius * innerRadiusRatio;
        const radiusScale = new _Scene.CategoryScale();
        radiusScale.domain = data[0].map((_, index)=>index);
        radiusScale.range = [
            innerRadius,
            radius
        ];
        radiusScale.paddingInner = 0.5;
        radiusScale.paddingOuter = 0;
        const bandwidth = radiusScale.bandwidth;
        const { processedData: processedData, max: max } = $5b7ccabde48fae90$var$accumulateData(data);
        const angleScale = new _Scene.LinearScale();
        angleScale.domain = [
            0,
            Math.ceil(max * 1.5)
        ];
        const start = 1.5 * Math.PI;
        const end = start + 2 * Math.PI;
        angleScale.range = [
            start,
            end
        ];
        const center = size / 2;
        this.series = processedData.map((series, index)=>{
            const previousSeries = index < 0 ? void 0 : processedData[index - 1];
            const seriesGroup = new _Scene.Group({
                zIndex: 1e6
            });
            const seriesSectors = series.map((datum, i)=>{
                const previousDatum = previousSeries?.[i] ?? 0;
                const outerRadius = radiusScale.convert(i);
                const innerRadius2 = outerRadius - bandwidth;
                const startAngle = angleScale.convert(previousDatum);
                const endAngle = angleScale.convert(datum);
                const sector = new _Scene.Sector();
                sector.centerX = center;
                sector.centerY = center;
                sector.innerRadius = innerRadius2;
                sector.outerRadius = outerRadius;
                sector.startAngle = startAngle;
                sector.endAngle = endAngle;
                sector.stroke = void 0;
                sector.strokeWidth = 0;
                return sector;
            });
            seriesGroup.append(seriesSectors);
            return seriesGroup;
        });
        this.root.append(this.series);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.series.forEach((group, i)=>{
            for (const sector of group.children()){
                sector.fill = fills[i % fills.length];
                sector.stroke = strokes[i % strokes.length];
            }
        });
    }
};
var $5b7ccabde48fae90$var$MiniRadialBar = {
    chartType: "radialBar",
    miniChart: $5b7ccabde48fae90$var$MiniRadialBarClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/polar/miniRadarLine.ts
var $5b7ccabde48fae90$var$MiniRadarLineClass = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "radarLineTooltip");
        this.markerSize = 4;
        this.data = [
            [
                8,
                7,
                8,
                7,
                8,
                8,
                7,
                8
            ],
            [
                6,
                8,
                5,
                10,
                6,
                7,
                4,
                6
            ],
            [
                0,
                3,
                3,
                5,
                4,
                4,
                2,
                0
            ]
        ];
        this.showRadiusAxisLine = false;
        const { size: size, padding: padding, root: root, data: data } = this;
        const radius = (size - padding * 2) / 2;
        const innerRadius = 0;
        const { paths: paths, markers: markers2 } = $5b7ccabde48fae90$var$createPolarPaths(agChartsExports, root, data, size, radius, innerRadius, this.markerSize);
        this.lines = paths;
        this.markers = markers2;
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.lines.forEach((line, i)=>{
            const n = this.data[i].length;
            line.stroke = fills[i];
            const startIdx = i * n;
            const endIdx = startIdx + n;
            const markers2 = this.markers.slice(startIdx, endIdx);
            markers2.forEach((marker)=>{
                marker.stroke = strokes[i];
                marker.fill = fills[i];
            });
        });
    }
};
var $5b7ccabde48fae90$var$MiniRadarLine = {
    chartType: "radarLine",
    miniChart: $5b7ccabde48fae90$var$MiniRadarLineClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/polar/miniRadarArea.ts
var $5b7ccabde48fae90$var$MiniRadarAreaClass = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "radarAreaTooltip");
        this.data = [
            [
                8,
                10,
                5,
                7,
                4,
                1,
                5,
                8
            ],
            [
                1,
                1,
                2,
                7,
                7,
                8,
                10,
                1
            ],
            [
                4,
                5,
                9,
                9,
                4,
                2,
                3,
                4
            ]
        ];
        const { size: size, padding: padding, root: root, data: data } = this;
        this.showRadiusAxisLine = false;
        const radius = (size - padding * 2) / 2;
        const innerRadius = radius - size * 0.3;
        this.areas = $5b7ccabde48fae90$var$createPolarPaths(agChartsExports, root, data, size, radius, innerRadius).paths;
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.areas.forEach((area, i)=>{
            area.fill = fills[i];
            area.stroke = strokes[i];
        });
    }
};
var $5b7ccabde48fae90$var$MiniRadarArea = {
    chartType: "radarArea",
    miniChart: $5b7ccabde48fae90$var$MiniRadarAreaClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/polar/miniNightingale.ts
var $5b7ccabde48fae90$var$MiniNightingaleClass = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "nightingaleTooltip");
        this.data = [
            [
                6,
                10,
                9,
                8,
                7,
                8
            ],
            [
                4,
                6,
                5,
                4,
                5,
                5
            ],
            [
                3,
                5,
                4,
                3,
                4,
                7
            ]
        ];
        this.showRadiusAxisLine = false;
        const { size: size, padding: padding, data: data, agChartsExports: { _Scene: _Scene } } = this;
        const radius = (size - padding * 2) / 2;
        const angleScale = new _Scene.CategoryScale();
        angleScale.domain = data[0].map((_, index)=>index);
        angleScale.range = [
            -Math.PI,
            Math.PI
        ];
        angleScale.paddingInner = 0;
        angleScale.paddingOuter = 0;
        const bandwidth = angleScale.bandwidth * 0.7;
        const { processedData: processedData, max: max } = $5b7ccabde48fae90$var$accumulateData(data);
        const radiusScale = new _Scene.LinearScale();
        radiusScale.domain = [
            0,
            max
        ];
        radiusScale.range = [
            0,
            radius
        ];
        const center = size / 2;
        this.series = processedData.map((series, index)=>{
            const previousSeries = index < 0 ? void 0 : processedData[index - 1];
            const seriesGroup = new _Scene.Group({
                zIndex: 1e6
            });
            const seriesSectors = series.map((datum, i)=>{
                const previousDatum = previousSeries?.[i];
                const outerRadius = radiusScale.convert(datum);
                const innerRadius = radiusScale.convert(previousDatum ?? 0);
                const startAngle = angleScale.convert(i);
                const endAngle = startAngle + bandwidth;
                const sector = new _Scene.Sector();
                sector.centerX = center;
                sector.centerY = center;
                sector.innerRadius = innerRadius;
                sector.outerRadius = outerRadius;
                sector.startAngle = startAngle;
                sector.endAngle = endAngle;
                sector.stroke = void 0;
                sector.strokeWidth = 0;
                return sector;
            });
            seriesGroup.append(seriesSectors);
            return seriesGroup;
        });
        this.root.append(this.series);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.series.forEach((group, i)=>{
            for (const sector of group.children()){
                sector.fill = fills[i % fills.length];
                sector.stroke = strokes[i % strokes.length];
            }
        });
    }
};
var $5b7ccabde48fae90$var$MiniNightingale = {
    chartType: "nightingale",
    miniChart: $5b7ccabde48fae90$var$MiniNightingaleClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/statistical/miniRangeBar.ts
var $5b7ccabde48fae90$var$MiniRangeBarClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "rangeBarTooltip");
        const data = [
            3,
            3.5,
            3
        ];
        this.bars = this.createRangeBar(this.root, data, this.size, this.padding, "vertical");
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.bars.forEach((bar, i)=>{
            bar.fill = fills[i];
            bar.stroke = strokes[i];
        });
    }
    createRangeBar(root, data, size, padding, direction) {
        const barAlongX = direction === "horizontal";
        const scalePadding = 2 * padding;
        const { _Scene: _Scene } = this.agChartsExports;
        const xScale = new _Scene.CategoryScale();
        xScale.domain = data.map((_, index)=>index);
        xScale.range = [
            padding,
            size - padding
        ];
        xScale.paddingInner = 0.3;
        xScale.paddingOuter = 0.3;
        const lowRatio = 0.7;
        const highRatio = 1.3;
        const yScale = new _Scene.LinearScale();
        yScale.domain = [
            data.reduce((a, b)=>Math.min(a, b), Infinity) * lowRatio,
            data.reduce((a, b)=>Math.max(a, b), 0) * highRatio
        ];
        yScale.range = [
            scalePadding,
            size - scalePadding
        ];
        const width = xScale.bandwidth;
        const bars = data.map((datum, i)=>{
            const [low, high] = [
                datum * lowRatio,
                datum * highRatio
            ];
            const x = xScale.convert(i);
            const y = yScale.convert(low);
            const height = yScale.convert(high) - y;
            const rect = new _Scene.Rect();
            rect.x = barAlongX ? y : x;
            rect.y = barAlongX ? x : y;
            rect.width = barAlongX ? height : width;
            rect.height = barAlongX ? width : height;
            rect.strokeWidth = 0;
            rect.crisp = true;
            return rect;
        });
        root.append(bars);
        return bars;
    }
};
var $5b7ccabde48fae90$var$MiniRangeBar = {
    chartType: "rangeBar",
    miniChart: $5b7ccabde48fae90$var$MiniRangeBarClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/statistical/miniRangeArea.ts
var $5b7ccabde48fae90$var$MiniRangeAreaClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "rangeAreaTooltip");
        const period = 4;
        const dataSeriesMidpoints = [
            $5b7ccabde48fae90$var$zigzag({
                offset: 0.375 * period,
                length: period,
                pattern: {
                    low: 3,
                    high: 5,
                    period: period
                }
            }),
            $5b7ccabde48fae90$var$zigzag({
                offset: 0.375 * period,
                length: period,
                pattern: {
                    low: 2.25,
                    high: 4.25,
                    period: period
                }
            }),
            $5b7ccabde48fae90$var$zigzag({
                offset: 0.75 * period,
                length: period,
                pattern: {
                    low: 2.5,
                    high: 4.5,
                    period: period
                }
            })
        ];
        const dataSeriesWidth = 1.75;
        const data = dataSeriesMidpoints.map((series)=>series.map(([x, y])=>({
                    x: x,
                    low: y - 0.5 * dataSeriesWidth,
                    high: y + 0.5 * dataSeriesWidth
                })));
        const { lines: lines, areas: areas } = this.createRangeArea(this.root, data, this.size, this.padding);
        this.lines = lines;
        this.areas = areas;
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        fills = $5b7ccabde48fae90$var$swapArrayItems(fills, 1, 2);
        strokes = $5b7ccabde48fae90$var$swapArrayItems(strokes, 1, 2);
        this.lines.forEach(([highLine, lowLine], i)=>{
            highLine.fill = void 0;
            highLine.stroke = strokes[i];
            lowLine.fill = void 0;
            lowLine.stroke = strokes[i];
        });
        this.areas.forEach((area, i)=>{
            area.fill = fills[i];
        });
    }
    createRangeArea(root, data, size, padding) {
        const xMin = data.reduce((acc, series)=>series.reduce((acc2, { x: x })=>Math.min(acc2, x), acc), Infinity);
        const xMax = data.reduce((acc, series)=>series.reduce((acc2, { x: x })=>Math.max(acc2, x), acc), -Infinity);
        const yMin = data.reduce((acc, series)=>series.reduce((acc2, { low: low })=>Math.min(acc2, low), acc), Infinity);
        const yMax = data.reduce((acc, series)=>series.reduce((acc2, { high: high })=>Math.max(acc2, high), acc), -Infinity);
        const { _Scene: _Scene } = this.agChartsExports;
        const xScale = new _Scene.LinearScale();
        xScale.domain = [
            xMin,
            xMax
        ];
        xScale.range = [
            padding,
            size - padding
        ];
        const scalePadding = 2 * padding;
        const yScale = new _Scene.LinearScale();
        yScale.domain = [
            yMin,
            yMax
        ];
        yScale.range = [
            size - scalePadding,
            scalePadding
        ];
        const lines = [];
        const areas = [];
        const lowPoints = data.map((series)=>{
            const highLine = new _Scene.Path();
            const lowLine = new _Scene.Path();
            const area = new _Scene.Path();
            lines.push([
                highLine,
                lowLine
            ]);
            areas.push(area);
            highLine.strokeWidth = 0;
            lowLine.strokeWidth = 0;
            area.strokeWidth = 0;
            area.fillOpacity = 0.8;
            highLine.path.clear();
            lowLine.path.clear();
            area.path.clear();
            return series.map((datum, datumIndex)=>{
                const { x: x, low: low, high: high } = datum;
                const scaledX = xScale.convert(x);
                const yLow = yScale.convert(low);
                const yHigh = yScale.convert(high);
                const command = datumIndex > 0 ? "lineTo" : "moveTo";
                highLine.path[command](scaledX, yHigh);
                lowLine.path[command](scaledX, yLow);
                area.path[command](scaledX, yHigh);
                return [
                    scaledX,
                    yLow
                ];
            });
        });
        lowPoints.forEach((seriesLowPoints, seriesIndex)=>{
            const n = seriesLowPoints.length - 1;
            const area = areas[seriesIndex];
            for(let datumIndex = n; datumIndex >= 0; datumIndex--){
                const [x, y] = seriesLowPoints[datumIndex];
                area.path["lineTo"](x, y);
            }
        });
        root.append(areas.concat(...lines));
        return {
            lines: lines,
            areas: areas
        };
    }
};
function $5b7ccabde48fae90$var$zigzag(options) {
    const { offset: offset, length: length, pattern: pattern } = options;
    const points = getZigzagInflectionPoints(offset, length, pattern);
    const xMin = 0;
    const xMax = length;
    if (points.length === 0 || points[0][0] !== xMin) points.unshift(getZigzagPoint(xMin, offset, pattern));
    if (points[points.length - 1][0] !== xMax) points.push(getZigzagPoint(xMax, offset, pattern));
    return points;
    function getZigzagInflectionPoints(offset2, length2, pattern2) {
        const { period: period } = pattern2;
        const scaledOffset = offset2 / period;
        const patternInflectionPoints = [
            0,
            0.5
        ];
        const inflectionPoints = patternInflectionPoints.map((x)=>x - scaledOffset).map($5b7ccabde48fae90$var$getRemainderAbs).sort((a, b)=>a - b);
        const repeatedPoints = Array.from({
            length: Math.floor(inflectionPoints.length * (period / length2))
        }, (_, i)=>inflectionPoints[i % inflectionPoints.length] + Math.floor(i / inflectionPoints.length));
        return repeatedPoints.map((x)=>x * period).map((x)=>getZigzagPoint(x, offset2, pattern2));
    }
    function getZigzagPoint(x, offset2, pattern2) {
        return [
            x,
            getZigzagValue(offset2 + x, pattern2)
        ];
    }
    function getZigzagValue(x, pattern2) {
        const { low: low, high: high, period: period } = pattern2;
        const scaledX = $5b7ccabde48fae90$var$getRemainderAbs(x / period);
        const y = scaledX > 0.5 ? 1 - 2 * (scaledX - 0.5) : 2 * scaledX;
        return low + (high - low) * y;
    }
}
function $5b7ccabde48fae90$var$getRemainderAbs(value) {
    const remainder = value % 1;
    return remainder < 0 ? remainder + 1 : remainder;
}
function $5b7ccabde48fae90$var$swapArrayItems(items, leftIndex, rightIndex) {
    const results = [
        ...items
    ];
    const temp = results[leftIndex];
    results[leftIndex] = results[rightIndex];
    results[rightIndex] = temp;
    return results;
}
var $5b7ccabde48fae90$var$MiniRangeArea = {
    chartType: "rangeArea",
    miniChart: $5b7ccabde48fae90$var$MiniRangeAreaClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/statistical/miniBoxPlot.ts
var $5b7ccabde48fae90$var$MiniBoxPlotClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme){
        super(container, agChartsExports, "boxPlotTooltip");
        const { size: size, padding: padding, agChartsExports: { _Scene: _Scene } } = this;
        const data = [
            11,
            11.5,
            10.5
        ];
        const maxRatio = 1.2;
        const q3Ratio = 1.1;
        const q1Ratio = 0.9;
        const minRatio = 0.8;
        const yScale = new _Scene.LinearScale();
        yScale.domain = [
            data.reduce((a, b)=>Math.min(a, b), Infinity) * minRatio,
            data.reduce((a, b)=>Math.max(a, b), 0) * maxRatio
        ];
        yScale.range = [
            size - 1.5 * padding,
            padding
        ];
        const xScale = new _Scene.CategoryScale();
        xScale.domain = data.map((_, index)=>index);
        xScale.range = [
            padding,
            size - padding
        ];
        xScale.paddingInner = 0.4;
        xScale.paddingOuter = 0.2;
        const bandwidth = Math.round(xScale.bandwidth);
        const halfBandWidth = Math.round(xScale.bandwidth / 2);
        this.boxPlotGroups = data.map((datum, i)=>{
            const [minValue, q1Value, q3Value, maxValue] = [
                datum * minRatio,
                datum * q1Ratio,
                datum * q3Ratio,
                datum * maxRatio
            ];
            const top = Math.round(yScale.convert(q3Value));
            const left = Math.round(xScale.convert(i));
            const right = Math.round(left + bandwidth);
            const bottom = Math.round(yScale.convert(q1Value));
            const min = Math.round(yScale.convert(minValue));
            const mid = Math.round(yScale.convert(datum));
            const max = Math.round(yScale.convert(maxValue));
            const whiskerX = left + halfBandWidth;
            const boxPlotGroup = new _Scene.Group();
            const box = new _Scene.Rect();
            const median = new _Scene.Line();
            const topWhisker = new _Scene.Line();
            const bottomWhisker = new _Scene.Line();
            const topCap = new _Scene.Line();
            const bottomCap = new _Scene.Line();
            box.x = left;
            box.y = top;
            box.width = bandwidth;
            box.height = bottom - top;
            box.strokeWidth = 1;
            box.strokeOpacity = 0.75;
            box.crisp = true;
            this.setLineProperties(median, left, right, mid, mid);
            this.setLineProperties(topWhisker, whiskerX, whiskerX, max, top);
            this.setLineProperties(bottomWhisker, whiskerX, whiskerX, min, bottom);
            this.setLineProperties(topCap, left, right, max, max);
            this.setLineProperties(bottomCap, left, right, min, min);
            boxPlotGroup.append([
                box,
                median,
                topWhisker,
                bottomWhisker,
                topCap,
                bottomCap
            ]);
            return boxPlotGroup;
        });
        this.updateColors(fills, strokes, isCustomTheme);
        this.root.append(this.boxPlotGroups);
    }
    updateColors(fills, strokes, isCustomTheme) {
        const { _Theme: _Theme } = this.agChartsExports;
        this.boxPlotGroups.forEach((group, i)=>{
            for (const node of group.children()){
                const fill = fills[i % fills.length];
                node.fill = isCustomTheme ? fill : _Theme.resolveOperation({
                    $mix: [
                        fill,
                        {
                            $ref: "backgroundColor"
                        },
                        0.7
                    ]
                });
                node.stroke = strokes[i % strokes.length];
            }
        });
    }
    setLineProperties(line, x1, x2, y1, y2) {
        line.x1 = x1;
        line.x2 = x2;
        line.y1 = y1;
        line.y2 = y2;
        line.strokeOpacity = 0.75;
    }
};
var $5b7ccabde48fae90$var$MiniBoxPlot = {
    chartType: "boxPlot",
    miniChart: $5b7ccabde48fae90$var$MiniBoxPlotClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/hierarchical/miniTreemap.ts
var $5b7ccabde48fae90$var$MiniTreemapClass = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme){
        super(container, agChartsExports, "treemapTooltip");
        const { size: size, padding: padding, agChartsExports: { _Scene: _Scene } } = this;
        const data = [
            [
                1,
                1
            ],
            [
                3,
                2,
                1
            ]
        ];
        const treeSize = data.length;
        const treePadding = treeSize % 2 === 0 ? 0.3 : 0.2;
        const range = [
            padding,
            size - padding
        ];
        const columns = data.length;
        const columnParts = columns * (columns + 1) / 2;
        const columnPadding = treePadding / (columns - 1);
        const availableRange = range[1] - range[0];
        const availableWidth = availableRange - treePadding;
        let previousX = range[0];
        this.rects = data.reduce((rects, d, columnIndex)=>{
            rects ?? (rects = []);
            const widthRatio = (columns - columnIndex) / columnParts;
            const width = availableWidth * widthRatio;
            const rows = d.length;
            const rowParts = d.reduce((parts, ratio)=>parts += ratio, 0);
            const rowPadding = treePadding / (rows - 1 || 1);
            const availableHeight = rows > 1 ? availableRange - treePadding : availableRange;
            let previousY = range[0];
            const xRects = d.map((ratio)=>{
                const rect = new _Scene.Rect();
                const height = availableHeight * ratio / rowParts;
                rect.x = previousX;
                rect.y = previousY;
                rect.width = width;
                rect.height = height;
                rect.strokeWidth = 0.75;
                rect.crisp = true;
                previousY += height + rowPadding;
                return rect;
            });
            previousX += width + columnPadding;
            rects.push(...xRects);
            return rects;
        }, []);
        this.updateColors(fills, strokes, isCustomTheme);
        const rectGroup = new _Scene.Group();
        rectGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding, size - padding));
        rectGroup.append(this.rects);
        this.root.append(rectGroup);
    }
    updateColors(fills, strokes, isCustomTheme) {
        const { _Theme: _Theme } = this.agChartsExports;
        this.rects.forEach((rect, i)=>{
            rect.fill = fills[i % strokes.length];
            rect.stroke = isCustomTheme ? strokes[i % strokes.length] : _Theme.resolveOperation({
                $ref: "backgroundColor"
            });
        });
    }
};
var $5b7ccabde48fae90$var$MiniTreemap = {
    chartType: "treemap",
    miniChart: $5b7ccabde48fae90$var$MiniTreemapClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/hierarchical/miniSunburst.ts
var $5b7ccabde48fae90$var$MiniSunburstClass = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "sunburstTooltip");
        // Hierarchical data using multidimensional array
        this.data = [
            [
                [],
                []
            ],
            [
                [],
                []
            ],
            [
                [],
                []
            ]
        ];
        // Rotate the chart by the given angle (-90 degrees)
        this.angleOffset = -Math.PI / 2;
        this.innerRadiusRatio = 0;
        this.showRadiusAxisLine = false;
        this.showAngleAxisLines = false;
        const { data: data, size: size, padding: padding, angleOffset: angleOffset, innerRadiusRatio: innerRadiusRatio, agChartsExports: { _Scene: _Scene } } = this;
        const radius = (size - padding * 2) / 2;
        const angleRange = [
            angleOffset + 0,
            angleOffset + 2 * Math.PI
        ];
        const angleExtent = Math.abs(angleRange[1] - angleRange[0]);
        const radiusRange = [
            radius * innerRadiusRatio,
            radius
        ];
        const radiusExtent = Math.abs(radiusRange[1] - radiusRange[0]);
        let maxDepth = 0;
        const findMaxDepth = (data2, parentDepth)=>{
            data2.forEach((child)=>{
                const depth = parentDepth + 1;
                maxDepth = Math.max(maxDepth, depth);
                findMaxDepth(child, depth);
            });
        };
        findMaxDepth(data, 0);
        const radiusRatio = radiusExtent / maxDepth;
        const center = this.size / 2;
        const startAngle = angleRange[0];
        this.series = [];
        const createSectors = (data2, depth, startAngle2, availableAngle, group)=>{
            const isArray = Array.isArray(data2);
            if (!isArray) return;
            const childDepth = depth + 1;
            let previousAngle = startAngle2;
            data2.forEach((child, childIndex, children)=>{
                let childGroup = group;
                if (!childGroup) {
                    childGroup = new _Scene.Group();
                    this.series.push(childGroup);
                }
                const innerRadius = radiusRange[0] + depth * radiusRatio;
                const outerRadius = radiusRange[0] + childDepth * radiusRatio;
                const angleRatio = 1 / children.length;
                const start = previousAngle;
                const end = start + availableAngle * angleRatio;
                const sector = new _Scene.Sector();
                sector.centerX = center;
                sector.centerY = center;
                sector.innerRadius = innerRadius;
                sector.outerRadius = outerRadius;
                sector.startAngle = start;
                sector.endAngle = end;
                sector.stroke = void 0;
                sector.strokeWidth = 0;
                sector.inset = 0.75;
                previousAngle = end;
                childGroup.append(sector);
                createSectors(child, childDepth, start, Math.abs(end - start), childGroup);
            });
        };
        createSectors(data, 0, startAngle, angleExtent);
        this.root.append(this.series);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.series.forEach((group, i)=>{
            for (const sector of group.children()){
                sector.fill = fills[i % fills.length];
                sector.stroke = strokes[i % strokes.length];
            }
        });
    }
};
var $5b7ccabde48fae90$var$MiniSunburst = {
    chartType: "sunburst",
    miniChart: $5b7ccabde48fae90$var$MiniSunburstClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/specialized/miniHeatmap.ts
var $5b7ccabde48fae90$var$MiniHeatmapClass = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme){
        super(container, agChartsExports, "heatmapTooltip");
        const { size: size, padding: padding, agChartsExports: { _Scene: _Scene } } = this;
        const heatmapSize = 3;
        const data = Array.from({
            length: heatmapSize
        }, (_, __)=>Array.from({
                length: heatmapSize
            }, (_2, yIndex)=>yIndex));
        const domain = data.map((_, index)=>index);
        const xScale = new _Scene.CategoryScale();
        xScale.domain = domain;
        xScale.range = [
            padding,
            size - padding
        ];
        xScale.paddingInner = 0.01;
        xScale.paddingOuter = 0.1;
        const yScale = new _Scene.CategoryScale();
        yScale.domain = domain;
        yScale.range = [
            padding,
            size - padding
        ];
        yScale.paddingInner = 0.01;
        yScale.paddingOuter = 0.1;
        const width = xScale.bandwidth ?? 0;
        const height = yScale.bandwidth ?? 0;
        this.rects = data.reduce((rects, d, index)=>{
            rects ?? (rects = []);
            const xRects = d.map((_, yIndex)=>{
                const rect = new _Scene.Rect();
                rect.x = xScale.convert(index);
                rect.y = yScale.convert(yIndex);
                rect.width = width;
                rect.height = height;
                rect.strokeWidth = 0;
                rect.crisp = true;
                return rect;
            });
            rects.push(...xRects);
            return rects;
        }, []);
        this.updateColors(fills, strokes, isCustomTheme);
        const rectGroup = new _Scene.Group();
        rectGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding, size - padding));
        rectGroup.append(this.rects);
        this.root.append(rectGroup);
    }
    updateColors(fills, strokes, isCustomTheme) {
        const { _Theme: _Theme, _Util: _Util } = this.agChartsExports;
        const colorRange = isCustomTheme ? [
            fills[0],
            fills[1]
        ] : _Theme.resolveOperation({
            $palette: "divergingColors"
        });
        const stroke = isCustomTheme ? strokes[0] : _Theme.resolveOperation({
            $ref: "backgroundColor"
        });
        const fillFn = _Util.interpolateColor(colorRange[0], colorRange[1]);
        this.rects.forEach((rect, i)=>{
            rect.fill = fillFn(i * 0.2);
            rect.stroke = stroke;
        });
    }
};
var $5b7ccabde48fae90$var$MiniHeatmap = {
    chartType: "heatmap",
    miniChart: $5b7ccabde48fae90$var$MiniHeatmapClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/specialized/miniWaterfall.ts
var $5b7ccabde48fae90$var$MiniWaterfallClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme){
        super(container, agChartsExports, "waterfallTooltip");
        this.data = [
            4,
            3,
            -3,
            6,
            -3
        ];
        this.bars = this.createWaterfall(this.root, this.data, this.size, this.padding, "vertical").bars;
        this.updateColors(fills, strokes, isCustomTheme);
    }
    updateColors(fills, strokes, isCustomTheme) {
        const { data: data, agChartsExports: { _Theme: _Theme } } = this;
        const positive = {
            fill: isCustomTheme ? fills[0] : _Theme.resolveOperation({
                $palette: "altUp.fill"
            }),
            stroke: isCustomTheme ? strokes[0] : _Theme.resolveOperation({
                $palette: "altUp.stroke"
            })
        };
        const negative = {
            fill: isCustomTheme ? fills[1] : _Theme.resolveOperation({
                $palette: "altDown.fill"
            }),
            stroke: isCustomTheme ? strokes[1] : _Theme.resolveOperation({
                $palette: "altDown.stroke"
            })
        };
        this.bars.forEach((bar, i)=>{
            const isPositive = data[i] >= 0;
            bar.fill = isPositive ? positive.fill : negative.fill;
            bar.stroke = isPositive ? positive.stroke : negative.stroke;
        });
    }
    createWaterfall(root, data, size, padding, direction) {
        const scalePadding = 2 * padding;
        const { processedData: processedData, min: min, max: max } = $5b7ccabde48fae90$var$accumulateData(data.map((d)=>[
                d
            ]));
        const flatData = processedData.reduce((flat, d)=>flat.concat(d), []);
        const { _Scene: _Scene } = this.agChartsExports;
        const yScale = new _Scene.LinearScale();
        yScale.domain = [
            Math.min(min, 0),
            max
        ];
        yScale.range = [
            size - scalePadding,
            scalePadding
        ];
        const xScale = new _Scene.CategoryScale();
        xScale.domain = data.map((_, index)=>index);
        xScale.range = [
            padding,
            size - padding
        ];
        xScale.paddingInner = 0.2;
        xScale.paddingOuter = 0.3;
        const width = xScale.bandwidth;
        const connectorLine = new _Scene.Path();
        connectorLine.stroke = "#575757";
        connectorLine.strokeWidth = 0;
        const pixelAlignmentOffset = Math.floor(connectorLine.strokeWidth) % 2 / 2;
        const connectorPath = connectorLine.path;
        connectorPath.clear();
        const barAlongX = direction === "horizontal";
        const bars = flatData.map((datum, i)=>{
            const previousDatum = i > 0 ? flatData[i - 1] : 0;
            const rawValue = data[i];
            const isPositive = rawValue > 0;
            const currY = Math.round(yScale.convert(datum));
            const trailY = Math.round(yScale.convert(previousDatum));
            const y = (isPositive ? currY : trailY) - pixelAlignmentOffset;
            const bottomY = (isPositive ? trailY : currY) + pixelAlignmentOffset;
            const height = Math.abs(bottomY - y);
            const x = xScale.convert(i);
            const rect = new _Scene.Rect();
            rect.x = barAlongX ? y : x;
            rect.y = barAlongX ? x : y;
            rect.width = barAlongX ? height : width;
            rect.height = barAlongX ? width : height;
            rect.strokeWidth = 0;
            rect.crisp = true;
            const moveTo = currY + pixelAlignmentOffset;
            const lineTo = trailY + pixelAlignmentOffset;
            if (i > 0) {
                const lineToX = barAlongX ? lineTo : rect.x;
                const lineToY = barAlongX ? rect.y : lineTo;
                connectorPath.lineTo(lineToX, lineToY);
            }
            const moveToX = barAlongX ? moveTo : rect.x;
            const moveToY = barAlongX ? rect.y : moveTo;
            connectorPath.moveTo(moveToX, moveToY);
            return rect;
        });
        root.append([
            connectorLine,
            ...bars
        ]);
        return {
            bars: bars
        };
    }
};
var $5b7ccabde48fae90$var$MiniWaterfall = {
    chartType: "waterfall",
    miniChart: $5b7ccabde48fae90$var$MiniWaterfallClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/combo/miniColumnLineCombo.ts
var $5b7ccabde48fae90$var$MiniColumnLineComboClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "columnLineComboTooltip");
        this.columnData = [
            3,
            4
        ];
        this.lineData = [
            [
                5,
                4,
                6,
                5,
                4
            ]
        ];
        const { root: root, columnData: columnData, lineData: lineData, size: size, padding: padding } = this;
        this.columns = $5b7ccabde48fae90$var$createColumnRects({
            stacked: false,
            root: root,
            data: columnData,
            size: size,
            padding: padding,
            xScaleDomain: [
                0,
                1
            ],
            yScaleDomain: [
                0,
                4
            ],
            xScalePadding: 0.5,
            agChartsExports: agChartsExports
        });
        root.append(this.columns);
        this.lines = $5b7ccabde48fae90$var$createLinePaths(agChartsExports, root, lineData, size, padding);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.columns.forEach((bar, i)=>{
            bar.fill = fills[i];
            bar.stroke = strokes[i];
        });
        this.lines.forEach((line, i)=>{
            line.stroke = fills[i + 2];
        });
    }
};
var $5b7ccabde48fae90$var$MiniColumnLineCombo = {
    chartType: "columnLineCombo",
    miniChart: $5b7ccabde48fae90$var$MiniColumnLineComboClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/combo/miniAreaColumnCombo.ts
var $5b7ccabde48fae90$var$MiniAreaColumnComboClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "areaColumnComboTooltip");
        this.columnData = [
            3,
            4.5
        ];
        this.areaData = [
            [
                5,
                4,
                6,
                5,
                4
            ]
        ];
        const { root: root, columnData: columnData, areaData: areaData, size: size, padding: padding, agChartsExports: { _Scene: _Scene } } = this;
        this.columns = $5b7ccabde48fae90$var$createColumnRects({
            stacked: false,
            root: root,
            data: columnData,
            size: size,
            padding: padding,
            xScaleDomain: [
                0,
                1
            ],
            yScaleDomain: [
                0,
                6
            ],
            xScalePadding: 0.5,
            agChartsExports: agChartsExports
        });
        const xScale = new _Scene.CategoryScale();
        xScale.range = [
            padding,
            size - padding
        ];
        xScale.domain = [
            0,
            1,
            2,
            3,
            4
        ];
        xScale.paddingInner = 1;
        xScale.paddingOuter = 0;
        const yScale = new _Scene.LinearScale();
        yScale.range = [
            size - padding,
            padding
        ];
        yScale.domain = [
            0,
            6
        ];
        const pathData = [];
        const yZero = yScale.convert(0);
        const firstX = xScale.convert(0);
        areaData.forEach((series, i)=>{
            const points = pathData[i] || (pathData[i] = []);
            series.forEach((data, j)=>{
                const yDatum = data;
                const xDatum = j;
                const x = xScale.convert(xDatum);
                const y = yScale.convert(yDatum);
                points[j] = {
                    x: x,
                    y: y
                };
            });
            const lastX = xScale.convert(series.length - 1);
            pathData[i].push({
                x: lastX,
                y: yZero
            }, {
                x: firstX,
                y: yZero
            });
        });
        this.areas = pathData.map((points)=>{
            const area = new _Scene.Path();
            area.strokeWidth = 0;
            area.fillOpacity = 0.8;
            const path = area.path;
            points.forEach((point, i)=>path[i > 0 ? "lineTo" : "moveTo"](point.x, point.y));
            return area;
        });
        const areaGroup = new _Scene.Group();
        areaGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding * 2, size - padding * 2));
        const columnGroup = new _Scene.Group();
        columnGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding * 2, size - padding * 2));
        areaGroup.append(this.areas);
        columnGroup.append(this.columns);
        root.append(areaGroup);
        root.append(columnGroup);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.areas.forEach((area, i)=>{
            area.fill = fills[i];
            area.stroke = strokes[i];
        });
        this.columns.forEach((bar, i)=>{
            bar.fill = fills[i + 1];
            bar.stroke = strokes[i + 1];
        });
    }
};
var $5b7ccabde48fae90$var$MiniAreaColumnCombo = {
    chartType: "areaColumnCombo",
    miniChart: $5b7ccabde48fae90$var$MiniAreaColumnComboClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/combo/miniCustomCombo.ts
var $5b7ccabde48fae90$var$MiniCustomComboClass = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "customComboTooltip");
        this.columnData = [
            3,
            4
        ];
        this.lineData = [
            [
                5,
                4,
                6,
                5,
                4
            ]
        ];
        const { root: root, columnData: columnData, lineData: lineData, size: size, padding: padding, agChartsExports: { _Scene: _Scene } } = this;
        this.columns = $5b7ccabde48fae90$var$createColumnRects({
            stacked: false,
            root: root,
            data: columnData,
            size: size,
            padding: padding,
            xScaleDomain: [
                0,
                1
            ],
            yScaleDomain: [
                0,
                4
            ],
            xScalePadding: 0.5,
            agChartsExports: agChartsExports
        });
        root.append(this.columns);
        this.lines = $5b7ccabde48fae90$var$createLinePaths(this.agChartsExports, root, lineData, size, padding);
        const axisStroke = "grey";
        const axisOvershoot = 3;
        const leftAxis = new _Scene.Line();
        leftAxis.x1 = padding;
        leftAxis.y1 = padding;
        leftAxis.x2 = padding;
        leftAxis.y2 = size - padding + axisOvershoot;
        leftAxis.stroke = axisStroke;
        const bottomAxis = new _Scene.Line();
        bottomAxis.x1 = padding - axisOvershoot + 1;
        bottomAxis.y1 = size - padding;
        bottomAxis.x2 = size - padding + 1;
        bottomAxis.y2 = size - padding;
        bottomAxis.stroke = axisStroke;
        const penIcon = new _Scene.Path();
        this.buildPenIconPath(penIcon);
        penIcon.fill = "whitesmoke";
        penIcon.stroke = "darkslategrey";
        penIcon.strokeWidth = 1;
        root.append([
            bottomAxis,
            leftAxis,
            penIcon
        ]);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.columns.forEach((bar, i)=>{
            bar.fill = fills[i];
            bar.stroke = strokes[i];
        });
        this.lines.forEach((line, i)=>{
            line.stroke = fills[i + 2];
        });
    }
    buildPenIconPath(penIcon) {
        const { path: path } = penIcon;
        path.moveTo(25.76, 43.46);
        path.lineTo(31.27, 48.53);
        path.moveTo(49.86, 22);
        path.lineTo(49.86, 22);
        path.cubicCurveTo(49.01994659053345, 21.317514933510974, 47.89593834348529, 21.09645997825817, 46.86, 21.41);
        path.lineTo(46.86, 21.41);
        path.cubicCurveTo(45.55460035985361, 21.77260167850787, 44.38777081121966, 22.517979360321792, 43.51, 23.55);
        path.lineTo(25.51, 43.8);
        path.lineTo(25.43, 43.89);
        path.lineTo(23.01, 51.89);
        path.lineTo(22.83, 52.46);
        path.lineTo(31.02, 48.86);
        path.lineTo(49.02, 28.52);
        path.lineTo(49.02, 28.52);
        path.cubicCurveTo(49.940716461596224, 27.521914221246085, 50.54302631059587, 26.2720342455763, 50.75, 24.93);
        path.lineTo(50.75, 24.93);
        path.cubicCurveTo(50.95363374988308, 23.866379846512814, 50.62080640232334, 22.77066734274871, 49.86, 22);
        path.closePath();
        path.moveTo(41.76, 25.5);
        path.lineTo(47.34, 30.5);
        path.moveTo(40.74, 26.65);
        path.lineTo(46.25, 31.71);
    }
};
var $5b7ccabde48fae90$var$MiniCustomCombo = {
    chartType: "customCombo",
    miniChart: $5b7ccabde48fae90$var$MiniCustomComboClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniChartsContainer.ts
var $5b7ccabde48fae90$var$miniChartMapping = {
    columnGroup: {
        column: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniColumn
        },
        stackedColumn: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniStackedColumn
        },
        normalizedColumn: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniNormalizedColumn
        }
    },
    barGroup: {
        bar: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniBar
        },
        stackedBar: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniStackedBar
        },
        normalizedBar: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniNormalizedBar
        }
    },
    pieGroup: {
        pie: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniPie
        },
        donut: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniDonut
        },
        doughnut: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniDonut
        }
    },
    lineGroup: {
        line: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniLine
        },
        stackedLine: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniStackedLine
        },
        normalizedLine: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniNormalizedLine
        }
    },
    scatterGroup: {
        scatter: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniScatter
        },
        bubble: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniBubble
        }
    },
    areaGroup: {
        area: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniArea
        },
        stackedArea: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniStackedArea
        },
        normalizedArea: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniNormalizedArea
        }
    },
    polarGroup: {
        radarLine: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRadarLine
        },
        radarArea: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRadarArea
        },
        nightingale: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniNightingale
        },
        radialColumn: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRadialColumn
        },
        radialBar: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRadialBar
        }
    },
    statisticalGroup: {
        boxPlot: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniBoxPlot
        },
        histogram: {
            range: true,
            pivot: false,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniHistogram
        },
        rangeBar: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRangeBar
        },
        rangeArea: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRangeArea
        }
    },
    hierarchicalGroup: {
        treemap: {
            range: true,
            pivot: true,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniTreemap
        },
        sunburst: {
            range: true,
            pivot: true,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniSunburst
        }
    },
    specializedGroup: {
        heatmap: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniHeatmap
        },
        waterfall: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniWaterfall
        }
    },
    combinationGroup: {
        columnLineCombo: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniColumnLineCombo
        },
        areaColumnCombo: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniAreaColumnCombo
        },
        customCombo: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniCustomCombo
        }
    },
    funnelGroup: {
        funnel: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniFunnel
        },
        coneFunnel: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniConeFunnel
        },
        pyramid: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniPyramid
        }
    }
};
var $5b7ccabde48fae90$var$DEFAULT_CHART_GROUPS = {
    columnGroup: [
        "column",
        "stackedColumn",
        "normalizedColumn"
    ],
    barGroup: [
        "bar",
        "stackedBar",
        "normalizedBar"
    ],
    pieGroup: [
        "pie",
        "donut"
    ],
    lineGroup: [
        "line",
        "stackedLine",
        "normalizedLine"
    ],
    areaGroup: [
        "area",
        "stackedArea",
        "normalizedArea"
    ],
    scatterGroup: [
        "scatter",
        "bubble"
    ],
    polarGroup: [
        "radarLine",
        "radarArea",
        "nightingale",
        "radialColumn",
        "radialBar"
    ],
    statisticalGroup: [
        "boxPlot",
        "histogram",
        "rangeBar",
        "rangeArea"
    ],
    hierarchicalGroup: [
        "treemap",
        "sunburst"
    ],
    specializedGroup: [
        "heatmap",
        "waterfall"
    ],
    funnelGroup: [
        "funnel",
        "coneFunnel",
        "pyramid"
    ],
    combinationGroup: [
        "columnLineCombo",
        "areaColumnCombo",
        "customCombo"
    ]
};
var $5b7ccabde48fae90$var$MiniChartsContainer = class extends (0, $jIDNV.Component) {
    constructor(chartController, fills, strokes, isCustomTheme, chartGroups = $5b7ccabde48fae90$var$DEFAULT_CHART_GROUPS){
        super(/* html */ `<div class="ag-chart-settings-mini-wrapper"></div>`);
        this.wrappers = /* @__PURE__ */ new Map();
        this.chartController = chartController;
        this.fills = fills;
        this.strokes = strokes;
        this.isCustomTheme = isCustomTheme;
        this.chartGroups = {
            ...chartGroups
        };
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        if (!this.chartController.customComboExists() && this.chartGroups.combinationGroup) this.chartGroups.combinationGroup = this.chartGroups.combinationGroup.filter((chartType)=>chartType !== "customCombo");
        const eGui = this.getGui();
        const isEnterprise = this.chartController.isEnterprise();
        const isPivotChart = this.chartController.isPivotChart();
        const isRangeChart = !isPivotChart;
        const displayedMenuGroups = Object.keys(this.chartGroups).map((group)=>{
            const menuGroup = group in $5b7ccabde48fae90$var$miniChartMapping ? $5b7ccabde48fae90$var$miniChartMapping[group] : void 0;
            if (!menuGroup) {
                (0, $jIDNV._warn)(148, {
                    group: group
                });
                return null;
            }
            const chartGroupValues = this.chartGroups[group] ?? [];
            const menuItems = chartGroupValues.map((chartType)=>{
                const menuItem = chartType in menuGroup ? menuGroup[chartType] : void 0;
                if (!menuItem) {
                    (0, $jIDNV._warn)(149, {
                        group: group,
                        chartType: chartType
                    });
                    return null;
                }
                if (!isEnterprise && menuItem.enterprise) return null;
                if (isRangeChart && menuItem.range) return menuItem;
                if (isPivotChart && menuItem.pivot) return menuItem;
                return null;
            }).filter((menuItem)=>menuItem != null);
            if (menuItems.length === 0) return null;
            return {
                label: this.chartTranslation.translate(group),
                items: menuItems
            };
        }).filter((menuGroup)=>menuGroup != null);
        for (const { label: label, items: items } of displayedMenuGroups){
            const groupComponent = this.createBean(new $5b7ccabde48fae90$var$AgGroupComponent({
                title: label,
                suppressEnabledCheckbox: true,
                enabled: true,
                suppressOpenCloseIcons: true,
                cssIdentifier: "charts-settings",
                direction: "horizontal",
                suppressKeyboardNavigation: true
            }));
            for (const menuItem of items){
                const { miniChart: MiniClass, chartType: chartType } = menuItem.icon;
                const miniWrapper = document.createElement("div");
                miniWrapper.classList.add("ag-chart-mini-thumbnail");
                miniWrapper.setAttribute("tabindex", "0");
                miniWrapper.setAttribute("role", "button");
                const miniClassChartType = chartType;
                const listener = ()=>{
                    this.chartController.setChartType(miniClassChartType);
                    this.updateSelectedMiniChart();
                };
                this.addManagedListeners(miniWrapper, {
                    click: listener,
                    keydown: (event)=>{
                        if (event.key == (0, $jIDNV.KeyCode).ENTER || event.key === (0, $jIDNV.KeyCode).SPACE) {
                            event.preventDefault();
                            listener();
                        }
                    }
                });
                this.wrappers.set(miniClassChartType, miniWrapper);
                this.createBean(new MiniClass(miniWrapper, this.beans.agChartsExports, this.fills, this.strokes, this.isCustomTheme));
                groupComponent.addItem(miniWrapper);
            }
            eGui.appendChild(groupComponent.getGui());
        }
        this.updateSelectedMiniChart();
    }
    updateSelectedMiniChart() {
        const selectedChartType = this.chartController.getChartType();
        this.wrappers.forEach((miniChart, miniChartType)=>{
            const selected = miniChartType === selectedChartType;
            miniChart.classList.toggle("ag-selected", selected);
            const chartName = this.chartTranslation.translate($5b7ccabde48fae90$var$getFullChartNameTranslationKey(miniChartType));
            const ariaLabel = selected ? `${chartName}. ${this.chartTranslation.translate("ariaChartSelected")}` : chartName;
            (0, $jIDNV._setAriaLabel)(miniChart, ariaLabel);
        });
    }
    destroy() {
        this.wrappers.clear();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/chartSettingsPanel.ts
var $5b7ccabde48fae90$var$ChartSettingsPanel = class extends (0, $jIDNV.Component) {
    constructor(chartController){
        super(/* html */ `<div class="ag-chart-settings-wrapper">
            <div data-ref="eMiniChartsContainer" class="ag-chart-settings-mini-charts-container ag-scrollable-container"></div>
            <div data-ref="eNavBar" class="ag-chart-settings-nav-bar">
                <div data-ref="ePrevBtn" class="ag-chart-settings-prev">
                    <button type="button" class="ag-button ag-chart-settings-prev-button"></button>
                </div>
                <div data-ref="eCardSelector" class="ag-chart-settings-card-selector"></div>
                <div data-ref="eNextBtn" class="ag-chart-settings-next">
                    <button type="button" class="ag-button ag-chart-settings-next-button"></button>
                </div>
            </div>
        </div>`);
        this.chartController = chartController;
        this.eMiniChartsContainer = (0, $jIDNV.RefPlaceholder);
        this.eNavBar = (0, $jIDNV.RefPlaceholder);
        this.eCardSelector = (0, $jIDNV.RefPlaceholder);
        this.ePrevBtn = (0, $jIDNV.RefPlaceholder);
        this.eNextBtn = (0, $jIDNV.RefPlaceholder);
        this.miniChartsContainers = [];
        this.cardItems = [];
        this.activePaletteIndex = 0;
        this.palettes = [];
        this.themes = [];
    }
    postConstruct() {
        this.resetPalettes();
        this.ePrevBtn.insertAdjacentElement("afterbegin", (0, $jIDNV._createIconNoSpan)("chartsThemePrevious", this.beans));
        this.eNextBtn.insertAdjacentElement("afterbegin", (0, $jIDNV._createIconNoSpan)("chartsThemeNext", this.beans));
        this.addManagedElementListeners(this.ePrevBtn, {
            click: ()=>this.setActivePalette(this.getPrev(), "left")
        });
        this.addManagedElementListeners(this.eNextBtn, {
            click: ()=>this.setActivePalette(this.getNext(), "right")
        });
        const reset = ()=>this.resetPalettes(true);
        this.addManagedListeners(this.chartController, {
            chartTypeChanged: reset,
            chartApiUpdate: reset
        });
        this.scrollSelectedIntoView();
    }
    scrollSelectedIntoView() {
        setTimeout(()=>{
            const isMiniChartsContainerVisible = (miniChartsContainers)=>{
                return !miniChartsContainers.getGui().classList.contains("ag-hidden");
            };
            const currentMiniChartContainer = this.miniChartsContainers.find(isMiniChartsContainerVisible);
            const currentChart = currentMiniChartContainer.getGui().querySelector(".ag-selected");
            if (currentChart) {
                const parent = currentChart.offsetParent;
                if (parent) this.eMiniChartsContainer.scrollTo(0, parent.offsetTop);
            }
        }, 250);
    }
    resetPalettes(forceReset) {
        const palettes = this.chartController.getPalettes();
        const chartGroups = this.gos.get("chartToolPanelsDef")?.settingsPanel?.chartGroupsDef;
        if ((0, $jIDNV._areEqual)(palettes, this.palettes) && !forceReset || this.isAnimating) return;
        this.palettes = palettes;
        this.themes = this.chartController.getThemeNames();
        this.activePaletteIndex = this.themes.findIndex((name)=>name === this.chartController.getChartThemeName());
        this.cardItems = [];
        (0, $jIDNV._clearElement)(this.eCardSelector);
        this.destroyMiniCharts();
        const { themes: themes } = this;
        this.palettes.forEach((palette, index)=>{
            const isActivePalette = this.activePaletteIndex === index;
            const { fills: fills = [], strokes: strokes = [] } = palette;
            const themeName = themes[index];
            const isCustomTheme = !$5b7ccabde48fae90$var$isStockTheme(themeName, this.beans.agChartsExports._Theme);
            const miniChartsContainer = this.createBean(new $5b7ccabde48fae90$var$MiniChartsContainer(this.chartController, fills, strokes, isCustomTheme, chartGroups));
            this.miniChartsContainers.push(miniChartsContainer);
            this.eMiniChartsContainer.appendChild(miniChartsContainer.getGui());
            this.addCardLink(index);
            if (isActivePalette) miniChartsContainer.updateSelectedMiniChart();
            else miniChartsContainer.setDisplayed(false);
        });
        (0, $jIDNV._setDisplayed)(this.eNavBar, this.palettes.length > 1);
        (0, $jIDNV._radioCssClass)(this.cardItems[this.activePaletteIndex], "ag-selected", "ag-not-selected");
    }
    addCardLink(index) {
        const link = document.createElement("div");
        link.classList.add("ag-chart-settings-card-item");
        this.addManagedElementListeners(link, {
            click: ()=>{
                this.setActivePalette(index, index < this.activePaletteIndex ? "left" : "right");
            }
        });
        this.eCardSelector.appendChild(link);
        this.cardItems.push(link);
    }
    getPrev() {
        let prev = this.activePaletteIndex - 1;
        if (prev < 0) prev = this.palettes.length - 1;
        return prev;
    }
    getNext() {
        let next = this.activePaletteIndex + 1;
        if (next >= this.palettes.length) next = 0;
        return next;
    }
    setActivePalette(index, animationDirection) {
        if (this.isAnimating || this.activePaletteIndex === index) return;
        (0, $jIDNV._radioCssClass)(this.cardItems[index], "ag-selected", "ag-not-selected");
        const currentPalette = this.miniChartsContainers[this.activePaletteIndex];
        const currentGui = currentPalette.getGui();
        const futurePalette = this.miniChartsContainers[index];
        const nextGui = futurePalette.getGui();
        currentPalette.updateSelectedMiniChart();
        futurePalette.updateSelectedMiniChart();
        const multiplier = animationDirection === "left" ? -1 : 1;
        const final = nextGui.style.left = `${(0, $jIDNV._getAbsoluteWidth)(this.getGui()) * multiplier}px`;
        this.activePaletteIndex = index;
        this.isAnimating = true;
        const animatingClass = "ag-animating";
        futurePalette.setDisplayed(true);
        currentPalette.addCss(animatingClass);
        futurePalette.addCss(animatingClass);
        this.chartController.setChartThemeName(this.themes[index]);
        window.setTimeout(()=>{
            currentGui.style.left = `${-parseFloat(final)}px`;
            nextGui.style.left = "0px";
        }, 0);
        window.setTimeout(()=>{
            this.isAnimating = false;
            currentPalette.removeCss(animatingClass);
            futurePalette.removeCss(animatingClass);
            currentPalette.setDisplayed(false);
        }, 300);
    }
    destroyMiniCharts() {
        (0, $jIDNV._clearElement)(this.eMiniChartsContainer);
        this.miniChartsContainers = this.destroyBeans(this.miniChartsContainers);
    }
    destroy() {
        this.destroyMiniCharts();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/tabbedChartMenu.ts
var $5b7ccabde48fae90$var$TAB_DATA = "data";
var $5b7ccabde48fae90$var$TAB_FORMAT = "format";
var $5b7ccabde48fae90$var$TabbedChartMenu = class extends (0, $jIDNV.Component) {
    constructor(panels, chartMenuContext){
        super();
        this.panels = panels;
        this.chartMenuContext = chartMenuContext;
        this.tabs = [];
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        this.panels.forEach((panel)=>{
            const panelType = panel.replace("chart", "").toLowerCase();
            const panelComp = this.createPanel(panelType);
            const tabItem = this.createTab(panel, panelType, panelComp);
            this.tabs.push(tabItem);
            this.addDestroyFunc(()=>this.destroyBean(panelComp));
        });
        this.tabbedLayout = new $5b7ccabde48fae90$var$TabbedLayout({
            items: this.tabs,
            cssClass: "ag-chart-tabbed-menu",
            keepScrollPosition: true,
            suppressFocusBodyOnOpen: true,
            suppressTrapFocus: true,
            enableCloseButton: true,
            closeButtonAriaLabel: this.chartTranslation.translate("ariaChartMenuClose"),
            onCloseClicked: ()=>{
                this.eventSource?.focus({
                    preventScroll: true
                });
                this.dispatchLocalEvent({
                    type: "closed"
                });
            }
        });
        this.createBean(this.tabbedLayout);
    }
    createTab(name, title, panelComp) {
        const eWrapperDiv = (0, $jIDNV._createElement)({
            tag: "div",
            cls: `ag-chart-tab ag-chart-${title}`
        });
        this.createBean(panelComp);
        eWrapperDiv.appendChild(panelComp.getGui());
        const translatedTitle = this.chartTranslation.translate(title);
        const titleEl = (0, $jIDNV._createElement)({
            tag: "div",
            children: translatedTitle
        });
        return {
            title: titleEl,
            titleLabel: translatedTitle,
            bodyPromise: (0, $jIDNV.AgPromise).resolve(eWrapperDiv),
            getScrollableContainer: ()=>{
                const scrollableContainer = eWrapperDiv.querySelector(".ag-scrollable-container");
                return scrollableContainer || eWrapperDiv;
            },
            name: name
        };
    }
    showTab(tab) {
        const tabItem = this.tabs[tab];
        this.tabbedLayout.showItem(tabItem);
    }
    getGui() {
        return this.tabbedLayout && this.tabbedLayout.getGui();
    }
    showMenu(eventSource, suppressFocus) {
        this.eventSource = eventSource;
        if (!suppressFocus) this.tabbedLayout?.focusHeader(true);
    }
    destroy() {
        if (this.parentComponent && this.parentComponent.isAlive()) this.destroyBean(this.parentComponent);
        super.destroy();
    }
    createPanel(panelType) {
        switch(panelType){
            case $5b7ccabde48fae90$var$TAB_DATA:
                return new $5b7ccabde48fae90$var$ChartDataPanel(this.chartMenuContext);
            case $5b7ccabde48fae90$var$TAB_FORMAT:
                return new $5b7ccabde48fae90$var$FormatPanel(this.chartMenuContext);
            default:
                return new $5b7ccabde48fae90$var$ChartSettingsPanel(this.chartMenuContext.chartController);
        }
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/chartMenu.ts
var $5b7ccabde48fae90$var$ChartMenu = class extends (0, $jIDNV.Component) {
    constructor(eChartContainer, eMenuPanelContainer, chartMenuContext){
        super(/* html */ `<div class="ag-chart-menu-wrapper"></div>`);
        this.eChartContainer = eChartContainer;
        this.eMenuPanelContainer = eMenuPanelContainer;
        this.chartMenuContext = chartMenuContext;
        this.buttons = {
            chartLink: {
                iconName: "linked",
                callback: ()=>this.chartMenuSvc.toggleLinked(this.chartMenuContext)
            },
            chartUnlink: {
                iconName: "unlinked",
                callback: ()=>this.chartMenuSvc.toggleLinked(this.chartMenuContext)
            },
            chartDownload: {
                iconName: "chartsDownload",
                callback: ()=>this.chartMenuSvc.downloadChart(this.chartMenuContext)
            },
            chartMenu: {
                iconName: "chartsMenu",
                callback: (eventSource)=>this.showMenuList(eventSource)
            }
        };
        this.panels = [];
        this.menuVisible = false;
        this.chartController = chartMenuContext.chartController;
    }
    wireBeans(beans) {
        this.chartMenuSvc = beans.chartMenuSvc;
        this.chartMenuListFactory = beans.chartMenuListFactory;
        this.environment = beans.environment;
    }
    postConstruct() {
        this.chartToolbar = this.createManagedBean(new $5b7ccabde48fae90$var$ChartToolbar());
        this.getGui().appendChild(this.chartToolbar.getGui());
        this.refreshToolbarAndPanels();
        this.addManagedEventListeners({
            chartCreated: (e)=>{
                if (e.chartId === this.chartController.getChartId()) {
                    const showDefaultToolPanel = Boolean(this.gos.get("chartToolPanelsDef")?.defaultToolPanel);
                    if (showDefaultToolPanel) this.showMenu({
                        panel: this.defaultPanel,
                        suppressFocus: true
                    });
                }
            }
        });
        this.addManagedListeners(this.chartController, {
            chartLinkedChanged: this.refreshToolbarAndPanels.bind(this)
        });
        this.refreshMenuClasses();
        this.addManagedListeners(this.chartController, {
            chartApiUpdate: this.refreshToolbarAndPanels.bind(this)
        });
    }
    isVisible() {
        return this.menuVisible;
    }
    getExtraPaddingDirections() {
        return [
            "chartMenu",
            "chartLink",
            "chartUnlink",
            "chartDownload"
        ].some((v)=>this.chartToolbarOptions.includes(v)) ? [
            "top"
        ] : [];
    }
    refreshToolbarAndPanels() {
        this.initToolbarOptionsAndPanels();
        this.updateToolbar();
    }
    initToolbarOptionsAndPanels() {
        const { panels: panels, defaultPanel: defaultPanel } = this.chartMenuSvc.getChartToolPanels(this.chartController);
        this.panels = panels;
        this.defaultPanel = defaultPanel;
        this.chartToolbarOptions = this.chartMenuSvc.getChartToolbarOptions();
    }
    updateToolbar() {
        const buttons = this.chartToolbarOptions.map((buttonName)=>{
            const { iconName: iconName, callback: callback } = this.buttons[buttonName];
            return {
                buttonName: buttonName,
                iconName: iconName,
                callback: callback
            };
        });
        this.chartToolbar.updateParams({
            buttons: buttons
        });
    }
    createMenuPanel(defaultTab) {
        const menuPanel = this.menuPanel = this.createBean(new $5b7ccabde48fae90$var$AgPanel({
            height: "100%",
            closable: true,
            hideTitleBar: true,
            cssIdentifier: "chart-menu"
        }));
        menuPanel.setParentComponent(this);
        this.eMenuPanelContainer.appendChild(menuPanel.getGui());
        this.tabbedMenu = this.createBean(new $5b7ccabde48fae90$var$TabbedChartMenu(this.panels, this.chartMenuContext));
        this.addManagedListeners(this.tabbedMenu, {
            closed: ()=>{
                this.hideMenu();
            }
        });
        this.addManagedListeners(menuPanel, {
            destroyed: ()=>this.destroyBean(this.tabbedMenu)
        });
        return new (0, $jIDNV.AgPromise)((res)=>{
            window.setTimeout(()=>{
                menuPanel.setBodyComponent(this.tabbedMenu);
                this.tabbedMenu.showTab(defaultTab);
                res(menuPanel);
            }, 100);
        });
    }
    showContainer(eventSource, suppressFocus) {
        if (!this.menuPanel) return;
        this.menuVisible = true;
        this.refreshMenuClasses();
        this.tabbedMenu.showMenu(eventSource, suppressFocus);
    }
    showMenu(params) {
        const { panel: panel, eventSource: eventSource, suppressFocus: suppressFocus } = params ?? {};
        if (this.menuPanel && !panel) this.showContainer(eventSource, suppressFocus);
        else {
            const menuPanel = panel || this.defaultPanel;
            let tab = this.panels.indexOf(menuPanel);
            if (tab < 0) {
                (0, $jIDNV._warn)(143, {
                    panel: panel
                });
                tab = this.panels.indexOf(this.defaultPanel);
            }
            if (this.menuPanel) {
                this.tabbedMenu.showTab(tab);
                this.showContainer(eventSource, suppressFocus);
            } else this.createMenuPanel(tab).then(()=>this.showContainer(eventSource, suppressFocus));
        }
    }
    hideMenu() {
        this.menuVisible = false;
        this.refreshMenuClasses();
    }
    refreshMenuClasses() {
        this.eChartContainer.classList.toggle("ag-chart-menu-visible", this.menuVisible);
        this.eChartContainer.classList.toggle("ag-chart-menu-hidden", !this.menuVisible);
    }
    showMenuList(eventSource) {
        this.chartMenuListFactory.showMenuList({
            eventSource: eventSource,
            showMenu: ()=>this.showMenu({
                    eventSource: eventSource
                }),
            chartMenuContext: this.chartMenuContext
        });
    }
    destroy() {
        super.destroy();
        if (this.menuPanel && this.menuPanel.isAlive()) this.destroyBean(this.menuPanel);
        if (this.tabbedMenu && this.tabbedMenu.isAlive()) this.destroyBean(this.tabbedMenu);
    }
};
var $5b7ccabde48fae90$var$CARTESIAN_AXIS_TYPES = [
    "number",
    "category",
    "time",
    "grouped-category"
];
var $5b7ccabde48fae90$var$POLAR_AXIS_TYPES = [
    "angle-category",
    "angle-number",
    "radius-category",
    "radius-number"
];
var $5b7ccabde48fae90$var$VALID_AXIS_TYPES = [
    ...$5b7ccabde48fae90$var$CARTESIAN_AXIS_TYPES,
    ...$5b7ccabde48fae90$var$POLAR_AXIS_TYPES
];
var $5b7ccabde48fae90$var$ChartOptionsService = class extends (0, $jIDNV.BeanStub) {
    constructor(chartController){
        super();
        this.chartController = chartController;
    }
    getChartThemeOverridesProxy() {
        return {
            getValue: (expression)=>this.getChartOption(expression),
            setValue: (expression, value)=>this.setChartThemeOverrides([
                    {
                        expression: expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setChartThemeOverrides(properties)
        };
    }
    getAxisThemeOverridesProxy() {
        return {
            getValue: (expression)=>this.getAxisProperty(expression),
            setValue: (expression, value)=>this.setAxisThemeOverrides([
                    {
                        expression: expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setAxisThemeOverrides(properties)
        };
    }
    getCartesianAxisOptionsProxy(axisType) {
        return {
            getValue: (expression)=>this.getCartesianAxisProperty(axisType, expression),
            setValue: (expression, value)=>this.setCartesianAxisOptions(axisType, [
                    {
                        expression: expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setCartesianAxisOptions(axisType, properties)
        };
    }
    getCartesianAxisThemeOverridesProxy(axisType) {
        return {
            getValue: (expression)=>this.getCartesianAxisProperty(axisType, expression),
            setValue: (expression, value)=>this.setCartesianAxisThemeOverrides(axisType, [
                    {
                        expression: expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setCartesianAxisThemeOverrides(axisType, properties)
        };
    }
    getCartesianAxisAppliedThemeOverridesProxy(axisType) {
        return {
            getValue: (expression)=>this.getCartesianAxisThemeOverride(axisType, // Allow the caller to specify a wildcard expression to retrieve the whole set of overrides
                expression === "*" ? null : expression),
            setValue: (expression, value)=>this.setCartesianAxisThemeOverrides(axisType, // Allow the caller to specify a wildcard expression to set the whole set of overrides
                [
                    {
                        expression: expression === "*" ? null : expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setCartesianAxisThemeOverrides(axisType, properties)
        };
    }
    getSeriesOptionsProxy(getSelectedSeries) {
        return {
            getValue: (expression, calculated)=>this.getSeriesOption(getSelectedSeries(), expression, calculated),
            setValue: (expression, value)=>this.setSeriesOptions(getSelectedSeries(), [
                    {
                        expression: expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setSeriesOptions(getSelectedSeries(), properties)
        };
    }
    /**
   * Determine the set of theme overrides that should be retained when transitioning from one chart type to another.
   */ getPersistedChartThemeOverrides(existingChartOptions, existingAxes, existingChartType, targetChartType) {
        const retainedThemeOverrideKeys = this.getRetainedChartThemeOverrideKeys(existingChartType, targetChartType);
        const retainedChartAxisThemeOverrideKeys = this.getRetainedChartAxisThemeOverrideKeys(null, existingChartType, targetChartType);
        const targetChartOptions = this.createChartOptions();
        for (const expression of retainedThemeOverrideKeys){
            const value = this.retrieveChartOptionsThemeOverride(existingChartOptions, existingChartType, expression);
            if (value !== void 0) this.assignChartOptionsThemeOverride(targetChartOptions, targetChartType, expression, value);
        }
        if (existingAxes) this.assignPersistedAxisOverrides({
            existingAxes: existingAxes,
            retainedChartAxisThemeOverrideKeys: retainedChartAxisThemeOverrideKeys,
            existingChartOptions: existingChartOptions,
            targetChartOptions: targetChartOptions,
            existingChartType: existingChartType,
            targetChartType: targetChartType
        });
        return targetChartOptions.theme.overrides;
    }
    assignPersistedAxisOverrides(params) {
        const { existingAxes: existingAxes, retainedChartAxisThemeOverrideKeys: retainedChartAxisThemeOverrideKeys, existingChartOptions: existingChartOptions, targetChartOptions: targetChartOptions, existingChartType: existingChartType, targetChartType: targetChartType } = params;
        for (const { expression: expression, targetAxisTypes: targetAxisTypes } of retainedChartAxisThemeOverrideKeys)for (const existingAxisType of existingAxes.map((axis)=>axis.type)){
            const value = this.retrieveChartOptionsThemeOverride(existingChartOptions, existingChartType, [
                "axes",
                existingAxisType,
                expression
            ].join("."));
            if (value !== void 0) for (const targetAxisType of targetAxisTypes)this.assignChartOptionsThemeOverride(targetChartOptions, targetChartType, [
                "axes",
                targetAxisType,
                expression
            ].join("."), value);
        }
    }
    getRetainedChartThemeOverrideKeys(existingChartType, targetChartType) {
        const UNIVERSAL_PERSISTED_THEME_OVERRIDES = [
            "animation"
        ];
        const PERSISTED_CARTESIAN_CHART_THEME_OVERRIDES = [
            "zoom",
            "navigator"
        ];
        const chartSpecificThemeOverrideKeys = ((previousChartType, updatedChartType)=>{
            const expressions = new Array();
            if ($5b7ccabde48fae90$var$isCartesian($5b7ccabde48fae90$var$getSeriesType(previousChartType)) && $5b7ccabde48fae90$var$isCartesian($5b7ccabde48fae90$var$getSeriesType(updatedChartType))) expressions.push(...PERSISTED_CARTESIAN_CHART_THEME_OVERRIDES);
            return expressions;
        })(existingChartType, targetChartType);
        return [
            ...UNIVERSAL_PERSISTED_THEME_OVERRIDES,
            ...chartSpecificThemeOverrideKeys
        ];
    }
    getRetainedChartAxisThemeOverrideKeys(axisType, existingChartType, targetChartType) {
        if ($5b7ccabde48fae90$var$isCartesian($5b7ccabde48fae90$var$getSeriesType(existingChartType)) && $5b7ccabde48fae90$var$isCartesian($5b7ccabde48fae90$var$getSeriesType(targetChartType))) {
            const retainedKeys = this.getRetainedCartesianAxisThemeOverrideKeys(axisType);
            return retainedKeys.map((expression)=>({
                    expression: expression,
                    targetAxisTypes: $5b7ccabde48fae90$var$CARTESIAN_AXIS_TYPES
                }));
        }
        return [];
    }
    getRetainedCartesianAxisThemeOverrideKeys(axisType) {
        const axisPositionSuffixes = axisType === "xAxis" ? [
            "",
            ".top",
            ".bottom"
        ] : axisType === "yAxis" ? [
            "",
            ".left",
            ".right"
        ] : [
            "",
            ".left",
            ".right",
            ".top",
            ".bottom"
        ];
        const PERSISTED_CARTESIAN_AXIS_THEME_OVERRIDES = [
            "crosshair"
        ];
        const expressions = new Array();
        for (const expression of PERSISTED_CARTESIAN_AXIS_THEME_OVERRIDES)for (const axisPositionSuffix of axisPositionSuffixes)expressions.push(`${expression}${axisPositionSuffix}`);
        return expressions;
    }
    getChartOption(expression) {
        return $5b7ccabde48fae90$var$get(this.getChart(), expression, void 0);
    }
    setChartThemeOverrides(properties) {
        const chartType = this.getChartType();
        const chartOptions = this.createChartOptions();
        for (const { expression: expression, value: value } of properties)this.assignChartOptionsThemeOverride(chartOptions, chartType, expression, value);
        this.applyChartOptions(chartOptions);
    }
    applyChartOptions(chartOptions, options) {
        if (Object.keys(chartOptions).length === 0) return;
        this.updateChart(chartOptions);
        const shouldRaiseEvent = !options?.silent;
        if (shouldRaiseEvent) this.raiseChartOptionsChangedEvent();
    }
    awaitChartOptionUpdate(func) {
        const chart = this.chartController.getChartProxy().getChart();
        chart.waitForUpdate().then(()=>func()).catch((e)=>(0, $jIDNV._error)(108, {
                e: e
            }));
    }
    getAxisProperty(expression) {
        return $5b7ccabde48fae90$var$get(this.getChart().axes?.[0], expression, void 0);
    }
    setAxisThemeOverrides(properties) {
        const chart = this.getChart();
        const chartType = this.getChartType();
        const chartOptions = this.createChartOptions();
        for (const { expression: expression, value: value } of properties){
            const relevantAxes = chart.axes?.filter((axis)=>{
                const parts = expression.split(".");
                let current = axis;
                for (const part of parts){
                    if (!(part in current)) return false;
                    current = current[part];
                }
                return true;
            });
            if (!relevantAxes) continue;
            for (const axis of relevantAxes){
                if (!this.isValidAxisType(axis)) continue;
                this.assignChartAxisThemeOverride(chartOptions, chartType, axis.type, null, expression, value);
            }
        }
        this.applyChartOptions(chartOptions);
    }
    getCartesianAxisProperty(axisType, expression) {
        const axes = this.getChartAxes();
        const axis = this.getCartesianAxis(axes, axisType);
        return $5b7ccabde48fae90$var$get(axis, expression, void 0);
    }
    getCartesianAxisThemeOverride(axisType, expression) {
        const axes = this.getChartAxes();
        const chartAxis = this.getCartesianAxis(axes, axisType);
        if (!chartAxis || !this.isValidAxisType(chartAxis)) return void 0;
        const chartType = this.getChartType();
        const chartOptions = this.getChart().getOptions();
        return this.retrieveChartAxisThemeOverride(chartOptions, chartType, chartAxis.type, axisType === "yAxis" ? [
            "left",
            "right"
        ] : [
            "bottom",
            "top"
        ], expression);
    }
    setCartesianAxisThemeOverrides(axisType, properties) {
        const axes = this.getChartAxes();
        const chartAxis = this.getCartesianAxis(axes, axisType);
        if (!chartAxis || !this.isValidAxisType(chartAxis)) return;
        const chartType = this.getChartType();
        const chartOptions = this.createChartOptions();
        for (const { expression: expression, value: value } of properties)this.assignChartAxisThemeOverride(chartOptions, chartType, chartAxis.type, axisType === "yAxis" ? [
            "left",
            "right"
        ] : [
            "bottom",
            "top"
        ], expression, value);
        this.applyChartOptions(chartOptions);
    }
    setCartesianAxisOptions(axisType, properties) {
        this.updateCartesianAxisOptions(axisType, (chartOptions, axes, chartAxis)=>{
            const axisIndex = axes.indexOf(chartAxis);
            for (const { expression: expression, value: value } of properties)this.assignChartOption(chartOptions, `axes.${axisIndex}.${expression}`, value);
        });
    }
    updateCartesianAxisOptions(axisType, updateFunc) {
        const existingChartOptions = this.getChart().getOptions();
        const axisOptions = "axes" in existingChartOptions ? existingChartOptions.axes : void 0;
        if (!existingChartOptions || !axisOptions) return;
        const axes = this.getChartAxes();
        const chartAxis = this.getCartesianAxis(axes, axisType);
        if (!chartAxis) return;
        const chartOptions = this.createChartOptions();
        chartOptions.axes = axisOptions;
        updateFunc(chartOptions, axes, chartAxis, existingChartOptions);
        this.applyChartOptions(chartOptions);
    }
    setCartesianCategoryAxisType(axisType, value) {
        this.updateCartesianAxisOptions(axisType, (chartOptions, _axes, chartAxis, existingChartOptions)=>{
            const chartType = this.getChartType();
            this.assignPersistedAxisOverrides({
                existingAxes: [
                    chartAxis
                ],
                retainedChartAxisThemeOverrideKeys: this.getRetainedChartAxisThemeOverrideKeys(axisType, chartType, chartType),
                existingChartOptions: existingChartOptions,
                targetChartOptions: chartOptions,
                existingChartType: chartType,
                targetChartType: chartType
            });
            this.assignChartOption(chartOptions, `axes.0.type`, value);
            this.chartController.setCategoryAxisType(value);
        });
    }
    getCartesianAxis(axes, axisType) {
        if (axes.length < 2) return void 0;
        switch(axisType){
            case "xAxis":
                return axes[0].direction === "x" ? axes[0] : axes[1];
            case "yAxis":
                return axes[1].direction === "y" ? axes[1] : axes[0];
        }
    }
    getSeriesOption(seriesType, expression, calculated) {
        const series = this.getChart().series.find((s)=>$5b7ccabde48fae90$var$isMatchingSeries(seriesType, s));
        return $5b7ccabde48fae90$var$get(calculated ? series : series?.properties.toJson(), expression, void 0);
    }
    setSeriesOptions(seriesType, properties) {
        const chartOptions = this.createChartOptions();
        for (const { expression: expression, value: value } of properties)this.assignChartOptionsSeriesThemeOverride(chartOptions, seriesType, `series.${expression}`, value);
        this.applyChartOptions(chartOptions);
    }
    getPairedMode() {
        return this.chartController.getChartProxy().isPaired();
    }
    setPairedMode(paired) {
        this.chartController.getChartProxy().setPaired(paired);
    }
    getChartAxes() {
        const chart = this.getChart();
        return chart.axes ?? [];
    }
    retrieveChartAxisThemeOverride(chartOptions, chartType, axisType, axisPositions, expression) {
        if (axisPositions) for (const axisPosition of axisPositions){
            const value = this.retrieveChartOptionsThemeOverride(chartOptions, chartType, [
                "axes",
                axisType,
                axisPosition,
                ...expression ? [
                    expression
                ] : []
            ].join("."));
            if (value === void 0) continue;
            return value;
        }
        else return this.retrieveChartOptionsThemeOverride(chartOptions, chartType, [
            "axes",
            axisType,
            ...expression ? [
                expression
            ] : []
        ].join("."));
    }
    assignChartAxisThemeOverride(chartOptions, chartType, axisType, axisPositions, expression, value) {
        if (axisPositions) for (const axisPosition of axisPositions)this.assignChartOptionsThemeOverride(chartOptions, chartType, [
            "axes",
            axisType,
            axisPosition,
            ...expression ? [
                expression
            ] : []
        ].join("."), value);
        else this.assignChartOptionsThemeOverride(chartOptions, chartType, [
            "axes",
            axisType,
            ...expression ? [
                expression
            ] : []
        ].join("."), value);
    }
    isValidAxisType(chartAxis) {
        return $5b7ccabde48fae90$var$VALID_AXIS_TYPES.includes(chartAxis.type);
    }
    getChartType() {
        return this.chartController.getChartType();
    }
    getChart() {
        return this.chartController.getChartProxy().getChart();
    }
    updateChart(chartOptions) {
        const chartRef = this.chartController.getChartProxy().getChartRef();
        chartRef.skipAnimations();
        chartRef.updateDelta(chartOptions);
    }
    createChartOptions() {
        const chartOptions = {
            theme: {
                overrides: {}
            }
        };
        return chartOptions;
    }
    retrieveChartOptionsThemeOverride(chartOptions, chartType, expression) {
        const chartSeriesTypes = this.getChartThemeOverridesSeriesTypeKeys(chartType);
        for (const seriesType of chartSeriesTypes){
            const value = this.retrieveChartOptionsSeriesThemeOverride(chartOptions, seriesType, expression);
            if (value === void 0) continue;
            return value;
        }
        return void 0;
    }
    assignChartOptionsThemeOverride(chartOptions, chartType, expression, value) {
        const chartSeriesTypes = this.getChartThemeOverridesSeriesTypeKeys(chartType);
        for (const seriesType of chartSeriesTypes)this.assignChartOptionsSeriesThemeOverride(chartOptions, seriesType, expression, value);
    }
    retrieveChartOptionsSeriesThemeOverride(chartOptions, seriesType, expression) {
        return this.retrieveChartOption(chartOptions, [
            "theme",
            "overrides",
            seriesType,
            ...expression ? [
                expression
            ] : []
        ].join("."));
    }
    assignChartOptionsSeriesThemeOverride(chartOptions, seriesType, expression, value) {
        this.assignChartOption(chartOptions, [
            "theme",
            "overrides",
            seriesType,
            ...expression ? [
                expression
            ] : []
        ].join("."), value);
    }
    getChartThemeOverridesSeriesTypeKeys(chartType) {
        const chartSeriesTypes = this.chartController.getChartSeriesTypes(chartType);
        if (this.chartController.isComboChart()) chartSeriesTypes.push("common");
        return chartSeriesTypes;
    }
    retrieveChartOption(chartOptions, expression) {
        return $5b7ccabde48fae90$var$get(chartOptions, expression, void 0);
    }
    assignChartOption(chartOptions, expression, value) {
        $5b7ccabde48fae90$var$set(chartOptions, expression, value);
    }
    raiseChartOptionsChangedEvent() {
        const chartModel = this.chartController.getChartModel();
        this.eventSvc.dispatchEvent({
            type: "chartOptionsChanged",
            chartId: chartModel.chartId,
            chartType: chartModel.chartType,
            chartThemeName: this.chartController.getChartThemeName(),
            chartOptions: chartModel.chartOptions
        });
    }
};
function $5b7ccabde48fae90$var$isMatchingSeries(seriesType, series) {
    return $5b7ccabde48fae90$var$isSeriesType(seriesType) && series.type === seriesType;
}
// packages/ag-grid-enterprise/src/charts/chartComp/gridChartComp.ts
var $5b7ccabde48fae90$var$GridChartComp = class extends (0, $jIDNV.Component) {
    constructor(params){
        super(/* html */ `
            <div style="height: 100%; width: 100%;">
                <div class="ag-chart" data-ref="eWrapper">
                    <div data-ref="eChartContainer" class="ag-chart-components-wrapper ag-chart-menu-hidden">
                        <div data-ref="eChart" class="ag-chart-canvas-wrapper"></div>
                        <div data-ref="eEmpty" class="ag-chart-empty-text ag-unselectable"></div>
                    </div>
                    <div data-ref="eMenuContainer" class="ag-chart-docked-container"></div>
                </div>
            </div>
            `);
        this.eChart = (0, $jIDNV.RefPlaceholder);
        this.eWrapper = (0, $jIDNV.RefPlaceholder);
        this.eChartContainer = (0, $jIDNV.RefPlaceholder);
        this.eMenuContainer = (0, $jIDNV.RefPlaceholder);
        this.eEmpty = (0, $jIDNV.RefPlaceholder);
        this.params = params;
    }
    wireBeans(beans) {
        this.crossFilterService = beans.chartCrossFilterSvc;
        this.chartTranslation = beans.chartTranslation;
        this.chartMenuSvc = beans.chartMenuSvc;
        this.focusSvc = beans.focusSvc;
        this.popupSvc = beans.popupSvc;
        this.enterpriseChartProxyFactory = beans.enterpriseChartProxyFactory;
        this.environment = beans.environment;
    }
    postConstruct() {
        const modelParams = {
            ...this.params,
            chartType: $5b7ccabde48fae90$var$getCanonicalChartType(this.params.chartType),
            chartThemeName: this.getThemeName()
        };
        const isRtl = this.gos.get("enableRtl");
        this.eWrapper.classList.add(isRtl ? "ag-rtl" : "ag-ltr");
        const model = this.createBean(new $5b7ccabde48fae90$var$ChartDataModel(modelParams));
        this.chartController = this.createManagedBean(new $5b7ccabde48fae90$var$ChartController(model));
        this.chartOptionsService = this.createManagedBean(new $5b7ccabde48fae90$var$ChartOptionsService(this.chartController));
        this.validateCustomThemes();
        this.createChart();
        if (this.params.insideDialog) this.addDialog();
        else {
            this.addManagedEventListeners({
                gridStylesChanged: this.updateTheme.bind(this)
            });
            this.updateTheme();
        }
        this.addMenu();
        this.addManagedElementListeners(this.getGui(), {
            focusin: this.setActiveChartCellRange.bind(this)
        });
        this.addManagedListeners(this.chartController, {
            chartModelUpdate: this.update.bind(this)
        });
        this.addManagedPropertyListeners([
            "chartThemeOverrides",
            "chartThemes"
        ], this.reactivePropertyUpdate.bind(this));
        this.update();
        this.raiseChartCreatedEvent();
    }
    updateTheme() {
        this.environment.applyThemeClasses(this.getGui());
    }
    createChart() {
        let chartInstance = void 0;
        if (this.chartProxy) chartInstance = this.chartProxy.destroy({
            keepChartInstance: true
        });
        const crossFilterCallback = (event, reset)=>{
            const ctx = this.params.crossFilteringContext;
            ctx.lastSelectedChartId = reset ? "" : this.chartController.getChartId();
            if (reset) this.params.crossFilteringResetCallback();
            this.crossFilterService.filter(event, reset);
        };
        const chartType = this.chartController.getChartType();
        const chartProxyParams = {
            agChartsExports: this.beans.agChartsExports,
            chartType: chartType,
            chartInstance: chartInstance,
            getChartThemeName: this.getChartThemeName.bind(this),
            getChartThemes: this.getChartThemes.bind(this),
            customChartThemes: this.gos.get("customChartThemes"),
            styleNonce: this.gos.get("styleNonce"),
            getGridOptionsChartThemeOverrides: ()=>this.getGridOptionsChartThemeOverrides(),
            getExtraPaddingDirections: ()=>this.chartMenu?.getExtraPaddingDirections() ?? [],
            apiChartThemeOverrides: this.params.chartThemeOverrides,
            crossFiltering: this.params.crossFiltering ?? false,
            crossFilterCallback: crossFilterCallback,
            parentElement: this.eChart,
            grouping: this.chartController.isGrouping(),
            chartThemeToRestore: this.params.chartThemeName,
            chartOptionsToRestore: this.params.chartOptionsToRestore,
            chartPaletteToRestore: this.params.chartPaletteToRestore,
            seriesChartTypes: this.chartController.getSeriesChartTypes(),
            suppressFieldDotNotation: this.gos.get("suppressFieldDotNotation"),
            translate: (toTranslate)=>this.chartTranslation.translate(toTranslate),
            context: (0, $jIDNV._addGridCommonParams)(this.gos, {})
        };
        this.params.chartOptionsToRestore = void 0;
        this.chartType = chartType;
        this.chartProxy = this.createChartProxy(chartProxyParams);
        if (!this.chartProxy) {
            (0, $jIDNV._warn)(138, {
                chartType: chartProxyParams.chartType
            });
            return;
        }
        this.chartController.setChartProxy(this.chartProxy);
        this.createMenuContext();
    }
    createMenuContext() {
        if (this.chartMenuContext) return;
        const chartMenuParamsFactory = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(this.chartOptionsService.getChartThemeOverridesProxy()));
        const chartAxisMenuParamsFactory = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(this.chartOptionsService.getAxisThemeOverridesProxy()));
        this.chartMenuContext = {
            chartController: this.chartController,
            chartOptionsService: this.chartOptionsService,
            chartMenuParamsFactory: chartMenuParamsFactory,
            chartAxisMenuParamsFactory: chartAxisMenuParamsFactory
        };
    }
    getChartThemeName() {
        return this.chartController.getChartThemeName();
    }
    getChartThemes() {
        return this.chartController.getThemeNames();
    }
    getGridOptionsChartThemeOverrides() {
        return this.gos.get("chartThemeOverrides");
    }
    createChartProxy(chartProxyParams) {
        const { chartType: chartType } = chartProxyParams;
        switch(chartType){
            case "column":
            case "bar":
            case "groupedColumn":
            case "stackedColumn":
            case "normalizedColumn":
            case "groupedBar":
            case "stackedBar":
            case "normalizedBar":
                return new $5b7ccabde48fae90$var$BarChartProxy(chartProxyParams);
            case "pie":
            case "donut":
            case "doughnut":
                return new $5b7ccabde48fae90$var$PieChartProxy(chartProxyParams);
            case "area":
            case "stackedArea":
            case "normalizedArea":
                return new $5b7ccabde48fae90$var$AreaChartProxy(chartProxyParams);
            case "line":
            case "stackedLine":
            case "normalizedLine":
                return new $5b7ccabde48fae90$var$LineChartProxy(chartProxyParams);
            case "scatter":
            case "bubble":
                return new $5b7ccabde48fae90$var$ScatterChartProxy(chartProxyParams);
            case "columnLineCombo":
            case "areaColumnCombo":
            case "customCombo":
                return new $5b7ccabde48fae90$var$ComboChartProxy(chartProxyParams);
        }
        const enterpriseChartProxy = this.enterpriseChartProxyFactory?.createChartProxy(chartProxyParams);
        if (!enterpriseChartProxy) throw (0, $jIDNV._errMsg)(251, {
            chartType: chartType
        });
        return enterpriseChartProxy;
    }
    addDialog() {
        const title = this.chartTranslation.translate(this.params.pivotChart ? "pivotChartTitle" : "rangeChartTitle");
        const { width: width, height: height } = this.getBestDialogSize();
        const afterGuiAttached = this.params.focusDialogOnOpen ? ()=>setTimeout(()=>(0, $jIDNV._focusInto)(this.getGui())) : void 0;
        this.chartDialog = new $5b7ccabde48fae90$var$AgDialog({
            resizable: true,
            movable: true,
            maximizable: true,
            title: title,
            width: width,
            height: height,
            component: this,
            centered: true,
            closable: true,
            afterGuiAttached: afterGuiAttached,
            postProcessPopupParams: {
                type: "chart"
            }
        });
        this.createBean(this.chartDialog);
        this.chartDialog.addEventListener("destroyed", ()=>{
            this.destroy();
            this.chartMenuSvc.hideAdvancedSettings();
            const lastFocusedCell = this.focusSvc.getFocusedCell();
            setTimeout(()=>{
                if (this.focusSvc.isAlive()) {
                    if (lastFocusedCell) this.focusSvc.setFocusedCell({
                        ...lastFocusedCell,
                        forceBrowserFocus: true
                    });
                    else (0, $jIDNV._focusGridInnerElement)(this.beans);
                }
            });
        });
    }
    getBestDialogSize() {
        const popupParent = this.popupSvc.getPopupParent();
        const maxWidth = (0, $jIDNV._getAbsoluteWidth)(popupParent) * 0.75;
        const maxHeight = (0, $jIDNV._getAbsoluteHeight)(popupParent) * 0.75;
        const ratio = 0.553;
        const chart = this.chartProxy.getChart();
        let width = this.params.insideDialog ? 850 : chart.width;
        let height = this.params.insideDialog ? 470 : chart.height;
        if (width > maxWidth || height > maxHeight) {
            width = Math.min(width, maxWidth);
            height = Math.round(width * ratio);
            if (height > maxHeight) {
                height = maxHeight;
                width = Math.min(width, Math.round(height / ratio));
            }
        }
        return {
            width: width,
            height: height
        };
    }
    addMenu() {
        if (!this.params.crossFiltering) {
            this.chartMenu = this.createBean(new $5b7ccabde48fae90$var$ChartMenu(this.eChartContainer, this.eMenuContainer, this.chartMenuContext));
            this.eChartContainer.appendChild(this.chartMenu.getGui());
        }
    }
    update(params) {
        if (params?.chartId) {
            const validUpdate = this.chartController.update(params);
            if (!validUpdate) return;
        }
        const updatedChartType = this.chartTypeChanged(params);
        const persistedThemeOverrides = updatedChartType || this.chartEmpty ? ((updatedChartType2)=>{
            const currentChartType = this.chartType;
            const targetChartType = updatedChartType2;
            const existingChartInstance = this.chartProxy.getChart();
            const existingChartOptions = existingChartInstance?.getOptions();
            const existingAxes = existingChartInstance?.axes;
            return this.chartOptionsService.getPersistedChartThemeOverrides(existingChartOptions, existingAxes, currentChartType, targetChartType ?? currentChartType);
        })(updatedChartType) : void 0;
        if (updatedChartType) this.createChart();
        if (persistedThemeOverrides && params?.chartThemeOverrides) (0, $jIDNV._mergeDeep)(persistedThemeOverrides, params.chartThemeOverrides);
        const updatedThemeOverrides = persistedThemeOverrides ?? params?.chartThemeOverrides;
        this.updateChart(updatedThemeOverrides);
        if (params?.chartId) this.chartProxy.getChart().waitForUpdate().then(()=>{
            this.chartController.raiseChartApiUpdateEvent();
        });
    }
    updateChart(updatedOverrides) {
        const { chartProxy: chartProxy } = this;
        const selectedCols = this.chartController.getSelectedValueColState();
        const data = this.chartController.getChartData();
        const chartEmpty = this.handleEmptyChart(data, selectedCols.length);
        this.chartEmpty = chartEmpty;
        if (chartEmpty) {
            if (updatedOverrides) this.chartController.updateThemeOverrides(updatedOverrides);
            return;
        }
        const chartUpdateParams = this.chartController.getChartUpdateParams(updatedOverrides);
        chartProxy.update(chartUpdateParams);
        this.chartProxy.getChart().waitForUpdate().then(()=>{
            this.chartController.raiseChartUpdatedEvent();
        });
    }
    chartTypeChanged(updateParams) {
        const [currentType, updatedChartType] = [
            this.chartController.getChartType(),
            updateParams?.chartType
        ];
        const targetChartType = updatedChartType ? $5b7ccabde48fae90$var$getCanonicalChartType(updatedChartType) : void 0;
        if (this.chartType !== currentType) return targetChartType ?? currentType;
        if (targetChartType && currentType !== targetChartType) return targetChartType;
        return null;
    }
    getChartModel() {
        return this.chartController.getChartModel();
    }
    getChartImageDataURL(fileFormat) {
        return this.chartProxy.getChartImageDataURL(fileFormat);
    }
    handleEmptyChart(data, numFields) {
        const pivotModeDisabled = this.chartController.isPivotChart() && !this.chartController.isPivotMode();
        const chartType = this.chartController.getChartType();
        let minFieldsRequired = 1;
        if (this.chartController.isActiveXYChart()) minFieldsRequired = chartType === "bubble" ? 3 : 2;
        else if ($5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(chartType))) minFieldsRequired = 0;
        const isEmptyChart = numFields < minFieldsRequired || data.length === 0;
        if (this.eChart) {
            const isEmpty = pivotModeDisabled || isEmptyChart;
            (0, $jIDNV._setDisplayed)(this.eChart, !isEmpty);
            (0, $jIDNV._setDisplayed)(this.eEmpty, isEmpty);
        }
        if (pivotModeDisabled) {
            this.eEmpty.textContent = this.chartTranslation.translate("pivotChartRequiresPivotMode");
            return true;
        }
        if (isEmptyChart) {
            this.eEmpty.textContent = this.chartTranslation.translate("noDataToChart");
            return true;
        }
        return false;
    }
    downloadChart(dimensions, fileName, fileFormat) {
        this.chartProxy.downloadChart(dimensions, fileName, fileFormat);
    }
    openChartToolPanel(panel) {
        const menuPanel = panel ? $5b7ccabde48fae90$var$CHART_TOOL_PANEL_MENU_OPTIONS[panel] : panel;
        this.chartMenu.showMenu({
            panel: menuPanel
        });
    }
    closeChartToolPanel() {
        this.chartMenu.hideMenu();
    }
    getChartId() {
        return this.chartController.getChartId();
    }
    getUnderlyingChart() {
        return this.chartProxy.getChartRef();
    }
    crossFilteringReset() {
        this.chartProxy.crossFilteringReset();
    }
    setMaximized(maximized) {
        this.chartDialog?.setMaximized(maximized);
    }
    setActiveChartCellRange(focusEvent) {
        if (this.getGui().contains(focusEvent.relatedTarget)) return;
        this.chartController.setChartRange(true);
    }
    getThemeName() {
        const availableChartThemes = this.gos.get("chartThemes") || $5b7ccabde48fae90$var$DEFAULT_THEMES;
        if (availableChartThemes.length === 0) throw new Error((0, $jIDNV._errMsg)(254));
        const { chartThemeName: chartThemeName } = this.params;
        return availableChartThemes.includes(chartThemeName) ? chartThemeName : availableChartThemes[0];
    }
    getAllKeysInObjects(objects) {
        const allValues = {};
        objects.filter((obj)=>obj != null).forEach((obj)=>{
            Object.keys(obj).forEach((key)=>allValues[key] = null);
        });
        return Object.keys(allValues);
    }
    validateCustomThemes() {
        const suppliedThemes = this.getChartThemes();
        const customChartThemes = this.gos.get("customChartThemes");
        if (customChartThemes) this.getAllKeysInObjects([
            customChartThemes
        ]).forEach((customThemeName)=>{
            if (!suppliedThemes.includes(customThemeName)) (0, $jIDNV._warn)(139, {
                customThemeName: customThemeName
            });
        });
    }
    reactivePropertyUpdate() {
        this.chartController.setChartThemeName(this.getThemeName(), true);
        const chartId = this.getChartId();
        const modelType = this.chartController.isCrossFilterChart() ? "crossFilter" : this.getChartModel().modelType;
        const chartThemeOverrides = this.gos.get("chartThemeOverrides") || {};
        this.update({
            type: `${modelType}ChartUpdate`,
            chartId: chartId,
            chartThemeOverrides: chartThemeOverrides
        });
    }
    raiseChartCreatedEvent() {
        this.chartProxy.getChart().waitForUpdate().then(()=>{
            this.eventSvc.dispatchEvent({
                type: "chartCreated",
                chartId: this.chartController.getChartId()
            });
        });
    }
    raiseChartDestroyedEvent() {
        this.eventSvc.dispatchEvent({
            type: "chartDestroyed",
            chartId: this.chartController.getChartId()
        });
    }
    destroy() {
        super.destroy();
        if (this.chartProxy) this.chartProxy.destroy();
        this.destroyBean(this.chartMenu);
        if (this.chartDialog && this.chartDialog.isAlive()) this.destroyBean(this.chartDialog);
        this.onDestroyColorSchemeChangeListener?.();
        const eGui = this.getGui();
        (0, $jIDNV._clearElement)(eGui);
        (0, $jIDNV._removeFromParent)(eGui);
        this.raiseChartDestroyedEvent();
    }
};
var $5b7ccabde48fae90$var$DEBUG = false;
function $5b7ccabde48fae90$var$upgradeChartModel(model) {
    const originalVersion = model.version;
    if (model.version == null) model.version = $5b7ccabde48fae90$var$heuristicVersionDetection(model);
    model = $5b7ccabde48fae90$var$migrateIfBefore("23.0.0", model, $5b7ccabde48fae90$var$migrateV23);
    model = $5b7ccabde48fae90$var$migrateIfBefore("24.0.0", model, $5b7ccabde48fae90$var$migrateV24);
    model = $5b7ccabde48fae90$var$migrateIfBefore("25.1.0", model, $5b7ccabde48fae90$var$migrateV25_1);
    model = $5b7ccabde48fae90$var$migrateIfBefore("26.0.0", model, $5b7ccabde48fae90$var$migrateV26);
    model = $5b7ccabde48fae90$var$migrateIfBefore("26.1.0", model, $5b7ccabde48fae90$var$migrateV26_1);
    model = $5b7ccabde48fae90$var$migrateIfBefore("26.2.0", model, $5b7ccabde48fae90$var$migrateV26_2);
    model = $5b7ccabde48fae90$var$migrateIfBefore("28.0.0", model, $5b7ccabde48fae90$var$migrateV28);
    model = $5b7ccabde48fae90$var$migrateIfBefore("28.2.0", model, $5b7ccabde48fae90$var$migrateV28_2);
    model = $5b7ccabde48fae90$var$migrateIfBefore("29.0.0", model, $5b7ccabde48fae90$var$migrateV29);
    model = $5b7ccabde48fae90$var$migrateIfBefore("29.1.0", model, $5b7ccabde48fae90$var$migrateV29_1);
    model = $5b7ccabde48fae90$var$migrateIfBefore("29.2.0", model, $5b7ccabde48fae90$var$migrateV29_2);
    model = $5b7ccabde48fae90$var$migrateIfBefore("30.0.0", model, $5b7ccabde48fae90$var$migrateV30);
    model = $5b7ccabde48fae90$var$migrateIfBefore("31.0.0", model, $5b7ccabde48fae90$var$migrateV31);
    model = $5b7ccabde48fae90$var$migrateIfBefore("32.0.0", model, $5b7ccabde48fae90$var$migrateV32);
    model = $5b7ccabde48fae90$var$migrateIfBefore("33.0.0", model, $5b7ccabde48fae90$var$migrateV33);
    model = $5b7ccabde48fae90$var$migrateIfBefore("34.0.0", model, $5b7ccabde48fae90$var$migrateV34);
    model = $5b7ccabde48fae90$var$cleanup(model);
    model = $5b7ccabde48fae90$var$migrateIfBefore($5b7ccabde48fae90$var$VERSION, model, (m)=>m);
    if ($5b7ccabde48fae90$var$DEBUG && originalVersion !== model.version) console.log("AG Grid: ChartModel migration complete", {
        model: model
    });
    return model;
}
function $5b7ccabde48fae90$var$migrateV23(model) {
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.legend.item.marker.type", "shape", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.seriesDefaults.marker.type", "shape", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.legend.padding", "spacing", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV24(model) {
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.marker.minSize", model);
    const { chartType: chartType, chartPalette: chartPalette, // Migrate.
    chartOptions: { xAxis: xAxis, yAxis: yAxis, ...chartOptions }, ...chartModel } = model;
    const axesTypes = $5b7ccabde48fae90$var$getLegacyAxisType(chartType);
    const axes = axesTypes?.map((type, i)=>({
            type: type,
            ...i === 0 ? xAxis : yAxis
        }));
    const LEGACY_PALETTES = {
        borneo: "ag-default",
        material: "ag-material",
        bright: "ag-vivid"
    };
    return {
        chartType: chartType,
        chartThemeName: LEGACY_PALETTES[chartPalette] ?? "ag-default",
        chartOptions: {
            ...chartOptions,
            axes: axes,
            xAxis: xAxis,
            yAxis: yAxis
        },
        ...chartModel
    };
}
function $5b7ccabde48fae90$var$migrateV25_1(model) {
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.seriesDefaults.label.minRequiredAngle", "minAngle", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV26(model) {
    const highlightOptUpdate = ({ dimOpacity: dimOpacity, ...opts })=>({
            ...opts,
            ...dimOpacity != null ? {
                series: {
                    dimOpacity: dimOpacity
                }
            } : {}
        });
    model = $5b7ccabde48fae90$var$jsonMutate("chartOptions.seriesDefaults.highlightStyle", model, highlightOptUpdate);
    model = $5b7ccabde48fae90$var$jsonDelete("chart", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.tooltipClass", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.tooltipTracking", model);
    model = $5b7ccabde48fae90$var$jsonDeleteDefault("chartOptions.axes[].label.rotation", 0, model);
    model = $5b7ccabde48fae90$var$jsonDeleteDefault("chartOptions.axes[].label.rotation", 335, model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV26_1(model) {
    const highlightOptUpdate = ({ item: item, series: series, ...opts })=>({
            item: {
                ...opts,
                ...item
            },
            ...series ? {
                series: series
            } : {}
        });
    model = $5b7ccabde48fae90$var$jsonMutate("chartOptions.seriesDefaults.highlightStyle", model, highlightOptUpdate);
    model = $5b7ccabde48fae90$var$jsonMutate("chartOptions.series[].highlightStyle", model, highlightOptUpdate);
    return model;
}
function $5b7ccabde48fae90$var$migrateV26_2(model) {
    model = $5b7ccabde48fae90$var$jsonMove("chartOptions.seriesDefaults.fill.opacity", "chartOptions.seriesDefaults.fillOpacity", model);
    model = $5b7ccabde48fae90$var$jsonMove("chartOptions.seriesDefaults.stroke.opacity", "chartOptions.seriesDefaults.strokeOpacity", model);
    model = $5b7ccabde48fae90$var$jsonMove("chartOptions.seriesDefaults.stroke.width", "chartOptions.seriesDefaults.strokeWidth", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.fill", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.stroke", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.callout.colors", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.xAxis", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.yAxis", model);
    const { chartType: providedChartType, // disable no-unused-vars because `series` is required here, even though
    // unused, because it serves to take the `series` key out of otherChartOptions
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    chartOptions: { axes: axes, series: series, seriesDefaults: seriesDefaults, ...otherChartOptions }, ...otherModelProps } = model;
    const chartType = $5b7ccabde48fae90$var$getCanonicalChartType(providedChartType);
    const seriesType = $5b7ccabde48fae90$var$getSeriesType(chartType);
    const seriesTypes = [
        seriesType
    ];
    const chartTypeMixin = {};
    if (!$5b7ccabde48fae90$var$isPieChartSeries(seriesType)) {
        const minimalAxis = {
            top: {},
            bottom: {},
            left: {},
            right: {}
        };
        const updatedAxes = axes.map(({ type: type, ...axisProps })=>({
                [type]: {
                    ...minimalAxis,
                    ...axisProps
                }
            })).reduce($5b7ccabde48fae90$var$merge, {});
        $5b7ccabde48fae90$var$ALL_AXIS_TYPES.filter((v)=>updatedAxes[v] == null).forEach((v)=>{
            updatedAxes[v] = {
                ...minimalAxis
            };
        });
        chartTypeMixin.axes = updatedAxes;
    }
    const updatedChartOptions = seriesTypes.map((t)=>({
            [t]: {
                ...chartTypeMixin,
                series: seriesDefaults,
                ...otherChartOptions
            }
        })).reduce($5b7ccabde48fae90$var$merge, {});
    model = {
        ...otherModelProps,
        chartType: chartType,
        chartOptions: updatedChartOptions
    };
    return model;
}
function $5b7ccabde48fae90$var$migrateV28(model) {
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.title.padding", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.subtitle.padding", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.axes.*.title.padding", model);
    model = $5b7ccabde48fae90$var$jsonBackfill("chartOptions.*.axes.*.title.enabled", false, model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV28_2(model) {
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.callout", "calloutLine", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.label", "calloutLabel", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.labelKey", "sectorLabelKey", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.labelName", "sectorLabelName", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.donut.series.callout", "calloutLine", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.donut.series.label", "calloutLabel", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.donut.series.labelKey", "sectorLabelKey", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.donut.series.labelName", "sectorLabelName", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV29(model) {
    model = $5b7ccabde48fae90$var$jsonMoveIfMissing("chartOptions.scatter.series.fill", "chartOptions.scatter.series.marker.fill", model);
    model = $5b7ccabde48fae90$var$jsonMoveIfMissing("chartOptions.scatter.series.fillOpacity", "chartOptions.scatter.series.marker.fillOpacity", model);
    model = $5b7ccabde48fae90$var$jsonMoveIfMissing("chartOptions.scatter.series.stroke", "chartOptions.scatter.series.marker.stroke", model);
    model = $5b7ccabde48fae90$var$jsonMoveIfMissing("chartOptions.scatter.series.strokeOpacity", "chartOptions.scatter.series.marker.strokeOpacity", model);
    model = $5b7ccabde48fae90$var$jsonMoveIfMissing("chartOptions.scatter.series.strokeWidth", "chartOptions.scatter.series.marker.strokeWidth", model);
    model = $5b7ccabde48fae90$var$jsonMove("chartOptions.scatter.series.paired", "chartOptions.scatter.paired", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV29_1(model) {
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.axes[].tick.count", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV29_2(model) {
    const tooltipOptUpdate = ({ tracking: tracking, ...opts })=>{
        const output = {
            ...opts
        };
        if (tracking === false) {
            output.position ?? (output.position = {
                type: "pointer"
            });
            output.range ?? (output.range = "nearest");
        } else if (tracking === true) {
            output.position ?? (output.position = {
                type: "node"
            });
            output.range ?? (output.range = "nearest");
        }
        return output;
    };
    model = $5b7ccabde48fae90$var$jsonMutate("chartOptions.*.tooltip", model, tooltipOptUpdate);
    return model;
}
function $5b7ccabde48fae90$var$migrateV30(model) {
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.labelKey", "sectorLabelKey", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.labelName", "sectorLabelName", model);
    model = $5b7ccabde48fae90$var$migrateV29_1(model);
    model = $5b7ccabde48fae90$var$migrateV29_2(model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.series.flipXY", model);
    model = $5b7ccabde48fae90$var$jsonAdd("chartOptions.common.legend.enabled", true, model);
    model = $5b7ccabde48fae90$var$jsonBackfill("chartOptions.common.legend.position", "right", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV31(model) {
    const V30_LEGACY_PALETTES = {
        "ag-pastel": "ag-sheets",
        "ag-solar": "ag-polychroma"
    };
    const updatedModel = $5b7ccabde48fae90$var$jsonRename("chartOptions.column", "bar", model);
    const chartThemeName = V30_LEGACY_PALETTES[updatedModel.chartThemeName] || updatedModel.chartThemeName;
    return {
        ...updatedModel,
        chartThemeName: chartThemeName
    };
}
function $5b7ccabde48fae90$var$migrateV32(model) {
    model = $5b7ccabde48fae90$var$jsonMutateProperty("chartOptions.*.autoSize", true, model, (parent, targetProp)=>{
        if (parent[targetProp] === true) ;
        else if (parent[targetProp] === false) {
            parent["minHeight"] = 600;
            parent["minWidth"] = 300;
        }
        delete parent[targetProp];
    });
    return model;
}
function $5b7ccabde48fae90$var$migrateV33(model) {
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.axes.category.label.format", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.axes.category.crosshair.label.format", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.axes.angle-category.label.format", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.axes.radius-category.label.format", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.*.axes.*.label.padding", "spacing", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.*.navigator.miniChart.label.padding", "spacing", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.axes.*.crossLines.label.className", model);
    model = $5b7ccabde48fae90$var$jsonMutateProperty("chartOptions.*.axes.*.crossLines.label.position", true, model, (parent, targetProp)=>{
        if (typeof parent[targetProp] === "string") parent[targetProp] = parent[targetProp].replace(/([A-Z])/, "-$1").toLowerCase();
    });
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.bullet", model);
    model = $5b7ccabde48fae90$var$jsonRenameEnumValues("chartOptions.bar.series.label.placement", model, {
        inside: "inside-center",
        outside: "inside-end"
    });
    model = $5b7ccabde48fae90$var$jsonRenameEnumValues("chartOptions.waterfall.series.item.*.label.placement", model, {
        inside: "inside-center",
        start: "outside-start",
        end: "outside-end"
    });
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.navigator.min", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.navigator.max", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.zoom.ratioX", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.zoom.ratioY", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.zoom.rangeX", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.zoom.rangeY", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV34(model) {
    const highlightUpdate = (parent, targetProp)=>{
        const highlightStyle = parent[targetProp];
        if (highlightStyle == null) return;
        const highlight = {};
        if (highlightStyle.item) highlight.highlightedItem = highlightStyle.item;
        if (highlightStyle.series) {
            const { dimOpacity: dimOpacity, ...seriesOpts } = highlightStyle.series;
            if (dimOpacity != null) highlight.unhighlightedSeries = {
                opacity: dimOpacity
            };
            if (Object.keys(seriesOpts).length > 0) highlight.highlightedSeries = seriesOpts;
        }
        delete parent[targetProp];
        parent.highlight = highlight;
    };
    $5b7ccabde48fae90$var$jsonMutateProperty("chartOptions.series[].highlightStyle", true, model, highlightUpdate);
    return model;
}
function $5b7ccabde48fae90$var$cleanup(model) {
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.width", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.height", model);
    model = $5b7ccabde48fae90$var$jsonBackfill("chartOptions.*.axes.category.label.autoRotate", true, model);
    return model;
}
function $5b7ccabde48fae90$var$heuristicVersionDetection(model) {
    const modelAny = model;
    if (model.version != null) return model.version;
    const hasKey = (obj, ...keys)=>{
        return Object.keys(obj || {}).some((k)=>keys.includes(k));
    };
    const chartOptions = modelAny.chartOptions;
    const seriesOptions = hasKey(chartOptions, "seriesDefaults") ? chartOptions?.seriesDefaults : chartOptions?.[Object.keys(chartOptions)[0]];
    const hints = {
        "27.0.0": hasKey(modelAny, "seriesChartTypes"),
        "26.2.0": !hasKey(chartOptions, "seriesDefaults"),
        "26.1.0": hasKey(seriesOptions?.highlightStyle, "item"),
        "26.0.0": hasKey(seriesOptions?.highlightStyle, "series"),
        // '26.0.0': modelAny.chart === undefined,
        "25.1.0": hasKey(seriesOptions?.label, "minAngle"),
        "25.0.0": hasKey(modelAny, "modelType", "aggFunc", "unlinkChart", "suppressChartRanges") || hasKey(seriesOptions, "lineDash", "lineDashOffset"),
        "24.0.0": hasKey(modelAny, "chartThemeName", "chart") || hasKey(chartOptions, "series"),
        "23.2.0": hasKey(chartOptions, "navigator"),
        "23.0.0": hasKey(chartOptions?.legend?.item?.marker, "shape"),
        "22.1.0": hasKey(modelAny, "chartPalette", "chartType")
    };
    const defaultVersion = "27.1.0";
    const matchingHints = Object.entries(hints).filter(([_, match])=>match);
    if ($5b7ccabde48fae90$var$DEBUG) console.log("AG Grid: ChartModel migration", {
        heuristicVersionCandidates: matchingHints
    });
    const [heuristicVersion = defaultVersion] = matchingHints[0];
    if ($5b7ccabde48fae90$var$DEBUG) console.log("AG Grid: ChartModel migration", {
        heuristicVersion: heuristicVersion
    });
    return heuristicVersion;
}
function $5b7ccabde48fae90$var$migrateIfBefore(maxVersion, model, migration) {
    if ($5b7ccabde48fae90$var$versionNumber(maxVersion) > $5b7ccabde48fae90$var$versionNumber(model.version)) {
        if ($5b7ccabde48fae90$var$DEBUG) console.log("AG Grid: ChartModel migration", {
            migratingTo: maxVersion
        });
        const result = migration(model);
        result.version = maxVersion;
        if ($5b7ccabde48fae90$var$DEBUG) console.log("AG Grid: ChartModel migration", {
            migratedTo: maxVersion,
            result: result
        });
        return result;
    }
    return model;
}
function $5b7ccabde48fae90$var$versionParts(versionRaw) {
    const version = versionRaw.includes("-beta") ? versionRaw.replace(/-beta.*/, "") : versionRaw;
    const split = typeof version === "string" ? version.split(".").map((v)=>Number(v)) : [];
    if (split.length !== 3 || split.some((v)=>isNaN(v))) throw new Error((0, $jIDNV._errMsg)(253, {
        version: version
    }));
    return {
        major: split[0],
        minor: split[1],
        patch: split[2]
    };
}
function $5b7ccabde48fae90$var$versionNumber(version) {
    const { major: major, minor: minor, patch: patch } = $5b7ccabde48fae90$var$versionParts(version);
    return major * 1e4 + minor * 100 + patch;
}
function $5b7ccabde48fae90$var$jsonDeleteDefault(path, defaultValue, json) {
    return $5b7ccabde48fae90$var$jsonMutateProperty(path, true, json, (parent, prop)=>{
        if (parent[prop] === defaultValue) delete parent[prop];
    });
}
function $5b7ccabde48fae90$var$jsonBackfill(path, defaultValue, json) {
    return $5b7ccabde48fae90$var$jsonMutateProperty(path, false, json, (parent, prop)=>{
        if (parent[prop] == null) parent[prop] = defaultValue;
    });
}
function $5b7ccabde48fae90$var$jsonAdd(path, value, json) {
    if (typeof path === "string") path = path.split(".");
    const nextPath = path[0];
    if (path.length > 1) json[nextPath] = $5b7ccabde48fae90$var$jsonAdd(path.slice(1), value, json[nextPath] ?? {});
    const hasProperty = Object.keys(json).includes(nextPath);
    if (!hasProperty) json[nextPath] = value;
    return json;
}
function $5b7ccabde48fae90$var$jsonMove(from, to, json) {
    let valueToMove = void 0;
    let valueFound = false;
    json = $5b7ccabde48fae90$var$jsonMutateProperty(from, true, json, (parent, prop)=>{
        valueFound = true;
        valueToMove = parent[prop];
        delete parent[prop];
    });
    if (!valueFound) return json;
    return $5b7ccabde48fae90$var$jsonMutateProperty(to, false, json, (parent, prop)=>{
        parent[prop] = valueToMove;
    });
}
function $5b7ccabde48fae90$var$jsonMoveIfMissing(from, to, json) {
    let valueToMove = void 0;
    let valueFound = false;
    json = $5b7ccabde48fae90$var$jsonMutateProperty(from, true, json, (parent, prop)=>{
        valueFound = true;
        valueToMove = parent[prop];
        delete parent[prop];
    });
    if (!valueFound) return json;
    return $5b7ccabde48fae90$var$jsonMutateProperty(to, false, json, (parent, prop)=>{
        if (parent[prop] === void 0) parent[prop] = valueToMove;
    });
}
function $5b7ccabde48fae90$var$jsonRename(path, renameTo, json) {
    return $5b7ccabde48fae90$var$jsonMutateProperty(path, true, json, (parent, prop)=>{
        parent[renameTo] = parent[prop];
        delete parent[prop];
    });
}
function $5b7ccabde48fae90$var$jsonDelete(path, json) {
    return $5b7ccabde48fae90$var$jsonMutateProperty(path, true, json, (parent, prop)=>delete parent[prop]);
}
function $5b7ccabde48fae90$var$jsonMutateProperty(path, skipMissing, json, mutator) {
    const pathElements = path instanceof Array ? path : path.split(".");
    const parentPathElements = pathElements.slice(0, pathElements.length - 1);
    const targetName = pathElements[pathElements.length - 1];
    return $5b7ccabde48fae90$var$jsonMutate(parentPathElements, json, (parent)=>{
        const hasProperty = Object.keys(parent).includes(targetName);
        if (skipMissing && !hasProperty) return parent;
        const result = {
            ...parent
        };
        mutator(result, targetName);
        return result;
    });
}
function $5b7ccabde48fae90$var$jsonMutate(path, json, mutator) {
    const pathElements = path instanceof Array ? path : path.split(".");
    json = {
        ...json
    };
    if (pathElements.length === 0) return mutator(json);
    else if (pathElements[0].startsWith("{")) {
        const pathOptions = pathElements[0].substring(1, pathElements[0].lastIndexOf("}")).split(",");
        for (const pathOption of pathOptions)if (json[pathOption] != null) json[pathOption] = $5b7ccabde48fae90$var$jsonMutate(pathElements.slice(1), json[pathOption], mutator);
    } else if (pathElements[0].endsWith("[]")) {
        const arrayName = pathElements[0].substring(0, path[0].indexOf("["));
        if (json[arrayName] instanceof Array) json[arrayName] = json[arrayName].map((v)=>$5b7ccabde48fae90$var$jsonMutate(pathElements.slice(1), v, mutator));
    } else if (pathElements[0] === "*") for (const jsonProp of Object.keys(json))json[jsonProp] = $5b7ccabde48fae90$var$jsonMutate(pathElements.slice(1), json[jsonProp], mutator);
    else if (json[pathElements[0]] != null) json[pathElements[0]] = $5b7ccabde48fae90$var$jsonMutate(pathElements.slice(1), json[pathElements[0]], mutator);
    return json;
}
function $5b7ccabde48fae90$var$jsonRenameEnumValues(path, json, values) {
    return $5b7ccabde48fae90$var$jsonMutateProperty(path, true, json, (parent, targetProp)=>{
        if (typeof parent[targetProp] === "string") parent[targetProp] = values[targetProp] ?? targetProp;
    });
}
var $5b7ccabde48fae90$var$merge = (r, n)=>({
        ...r,
        ...n
    });
// packages/ag-grid-enterprise/src/charts/chartService.ts
var $5b7ccabde48fae90$var$ChartService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.beanName = "chartSvc";
        // we destroy all charts bound to this grid when grid is destroyed. activeCharts contains all charts, including
        // those in developer provided containers.
        this.activeCharts = /* @__PURE__ */ new Set();
        this.activeChartComps = /* @__PURE__ */ new Set();
        // this shared (singleton) context is used by cross filtering in line and area charts
        this.crossFilteringContext = {
            lastSelectedChartId: ""
        };
        this.isEnterprise = ()=>this.agChartsExports.isEnterprise;
    }
    wireBeans(beans) {
        this.visibleCols = beans.visibleCols;
        this.rangeSvc = beans.rangeSvc;
        this.agChartsExports = beans.agChartsExports;
    }
    updateChart(params) {
        if (this.activeChartComps.size === 0) {
            (0, $jIDNV._warn)(124);
            return;
        }
        const chartComp = [
            ...this.activeChartComps
        ].find((chartComp2)=>chartComp2.getChartId() === params.chartId);
        if (!chartComp) {
            (0, $jIDNV._warn)(125, {
                chartId: params.chartId
            });
            return;
        }
        chartComp.update(params);
    }
    getChartModels() {
        const models = [];
        const versionedModel = (c)=>{
            return {
                ...c,
                version: $5b7ccabde48fae90$var$VERSION
            };
        };
        this.activeChartComps.forEach((c)=>models.push(versionedModel(c.getChartModel())));
        return models;
    }
    getChartRef(chartId) {
        let chartRef;
        this.activeCharts.forEach((cr)=>{
            if (cr.chartId === chartId) chartRef = cr;
        });
        return chartRef;
    }
    getChartComp(chartId) {
        let chartComp;
        this.activeChartComps.forEach((comp)=>{
            if (comp.getChartId() === chartId) chartComp = comp;
        });
        return chartComp;
    }
    getChartImageDataURL(params) {
        let url;
        this.activeChartComps.forEach((c)=>{
            if (c.getChartId() === params.chartId) url = c.getChartImageDataURL(params.fileFormat);
        });
        return url;
    }
    downloadChart(params) {
        const chartComp = Array.from(this.activeChartComps).find((c)=>c.getChartId() === params.chartId);
        chartComp?.downloadChart(params.dimensions, params.fileName, params.fileFormat);
    }
    openChartToolPanel(params) {
        const chartComp = Array.from(this.activeChartComps).find((c)=>c.getChartId() === params.chartId);
        chartComp?.openChartToolPanel(params.panel);
    }
    closeChartToolPanel(chartId) {
        const chartComp = Array.from(this.activeChartComps).find((c)=>c.getChartId() === chartId);
        chartComp?.closeChartToolPanel();
    }
    createChartFromCurrentRange(chartType = "groupedColumn", fromApi) {
        const cellRange = this.getSelectedRange();
        return this.createChart({
            cellRange: cellRange,
            chartType: chartType,
            focusDialogOnOpen: !fromApi
        });
    }
    restoreChart(model, chartContainer) {
        if (!model) {
            (0, $jIDNV._warn)(126);
            return;
        }
        if (model.version !== $5b7ccabde48fae90$var$VERSION) model = $5b7ccabde48fae90$var$upgradeChartModel(model);
        let cellRange;
        let pivotChart;
        let suppressChartRanges;
        let chartPaletteToRestore;
        if (model.modelType === "pivot") {
            this.gos.updateGridOptions({
                options: {
                    pivotMode: true
                },
                source: "pivotChart"
            });
            cellRange = this.createCellRange(void 0, true);
            pivotChart = true;
            suppressChartRanges = true;
        } else {
            cellRange = this.createCellRange(model.cellRange);
            chartPaletteToRestore = model.chartPalette;
            suppressChartRanges = model.suppressChartRanges;
        }
        if (!cellRange) return;
        return this.createChart({
            ...model,
            cellRange: cellRange,
            pivotChart: pivotChart,
            suppressChartRanges: suppressChartRanges,
            chartContainer: chartContainer,
            chartOptionsToRestore: model.chartOptions,
            chartPaletteToRestore: chartPaletteToRestore
        });
    }
    createRangeChart(params, fromApi) {
        const cellRange = this.createCellRange(params.cellRange);
        if (!cellRange) return;
        return this.createChart({
            ...params,
            cellRange: cellRange,
            focusDialogOnOpen: !fromApi
        });
    }
    createPivotChart(params, fromApi) {
        this.gos.updateGridOptions({
            options: {
                pivotMode: true
            },
            source: "pivotChart"
        });
        const cellRange = this.createCellRange(void 0, true);
        if (!cellRange) return;
        return this.createChart({
            ...params,
            cellRange: cellRange,
            pivotChart: true,
            suppressChartRanges: true,
            focusDialogOnOpen: !fromApi
        });
    }
    createCrossFilterChart(params, fromApi) {
        const cellRange = this.createCellRange(params.cellRange);
        if (!cellRange) return;
        const suppressChartRangesSupplied = typeof params.suppressChartRanges !== "undefined" && params.suppressChartRanges !== null;
        const suppressChartRanges = suppressChartRangesSupplied ? params.suppressChartRanges : true;
        return this.createChart({
            ...params,
            cellRange: cellRange,
            suppressChartRanges: suppressChartRanges,
            crossFiltering: true,
            focusDialogOnOpen: !fromApi
        });
    }
    createChart(params) {
        const validationResult = $5b7ccabde48fae90$var$validateCreateParams(params, this.agChartsExports.isEnterprise);
        if (!validationResult) return void 0;
        params = validationResult === true ? params : validationResult;
        const { chartType: chartType, chartContainer: chartContainer } = params;
        const createChartContainerFunc = this.gos.getCallback("createChartContainer");
        const gridChartParams = {
            ...params,
            chartId: this.generateId(),
            chartType: $5b7ccabde48fae90$var$getCanonicalChartType(chartType),
            insideDialog: !(chartContainer || createChartContainerFunc),
            crossFilteringContext: this.crossFilteringContext,
            crossFilteringResetCallback: ()=>this.activeChartComps.forEach((c)=>c.crossFilteringReset())
        };
        const chartComp = new $5b7ccabde48fae90$var$GridChartComp(gridChartParams);
        this.createBean(chartComp);
        const chartRef = this.createChartRef(chartComp);
        if (chartContainer) chartContainer.appendChild(chartRef.chartElement);
        else if (createChartContainerFunc) createChartContainerFunc(chartRef);
        else chartComp.addEventListener("destroyed", ()=>{
            this.activeChartComps.delete(chartComp);
            this.activeCharts.delete(chartRef);
        });
        return chartRef;
    }
    createChartRef(chartComp) {
        const chartRef = {
            destroyChart: ()=>{
                if (this.activeCharts.has(chartRef)) {
                    this.destroyBean(chartComp);
                    this.activeChartComps.delete(chartComp);
                    this.activeCharts.delete(chartRef);
                }
            },
            focusChart: ()=>{
                (0, $jIDNV._focusInto)(chartComp.getGui());
            },
            chartElement: chartComp.getGui(),
            chart: chartComp.getUnderlyingChart(),
            chartId: chartComp.getChartModel().chartId,
            setMaximized: chartComp.setMaximized.bind(chartComp)
        };
        this.activeCharts.add(chartRef);
        this.activeChartComps.add(chartComp);
        return chartRef;
    }
    getSelectedRange() {
        const ranges = this.rangeSvc?.getCellRanges();
        if (!ranges || ranges.length === 0) return {
            columns: []
        };
        const uCols = /* @__PURE__ */ new Set();
        let startRowIndex = Number.MAX_VALUE;
        let endRowIndex = -Number.MAX_VALUE;
        ranges.forEach(({ startRow: sr, endRow: er, columns: cols })=>{
            if (!(sr && er)) return;
            cols.forEach((col)=>uCols.add(col));
            let { rowIndex: sRowIndex, rowPinned: startRowPinned } = sr;
            let { rowIndex: eRowIndex, rowPinned: endRowPinned } = er;
            if (startRowPinned === "top") {
                if (endRowPinned === "top") return;
                sRowIndex = 0;
            }
            if (endRowPinned === "bottom") {
                if (startRowPinned === "bottom") return;
                eRowIndex = this.beans.pageBounds.getLastRow();
            }
            if (sRowIndex !== void 0) startRowIndex = Math.min(startRowIndex, sRowIndex);
            if (eRowIndex !== void 0) endRowIndex = Math.max(endRowIndex, eRowIndex);
        });
        if (startRowIndex === Number.MAX_VALUE || endRowIndex === -Number.MAX_VALUE) return {
            columns: []
        };
        const columns = Array.from(uCols);
        return {
            columns: // Don't specify id here, as it should be chart-specific
            // but we don't have that context yet
            columns,
            startColumn: columns[0],
            startRow: {
                rowIndex: startRowIndex,
                rowPinned: void 0
            },
            endRow: {
                rowIndex: endRowIndex,
                rowPinned: void 0
            }
        };
    }
    generateId() {
        return `id-${Math.random().toString(36).substring(2, 18)}`;
    }
    createCellRange(cellRangeParams, allRange) {
        const rangeParams = allRange ? {
            rowStartIndex: null,
            rowStartPinned: void 0,
            rowEndIndex: null,
            rowEndPinned: void 0,
            columns: this.visibleCols.allCols.map((col)=>col.getColId())
        } : cellRangeParams;
        const cellRange = rangeParams && this.rangeSvc?.createPartialCellRangeFromRangeParams(rangeParams, true);
        if (!cellRange) (0, $jIDNV._warn)(127, {
            allRange: allRange
        });
        return cellRange;
    }
    destroy() {
        this.activeCharts.forEach((chart)=>chart.destroyChart());
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/charts/chartsApi.ts
function $5b7ccabde48fae90$var$getChartModels(beans) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.getChartModels());
}
function $5b7ccabde48fae90$var$getChartRef(beans, chartId) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.getChartRef(chartId));
}
function $5b7ccabde48fae90$var$getChartImageDataURL(beans, params) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.getChartImageDataURL(params));
}
function $5b7ccabde48fae90$var$downloadChart(beans, params) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.downloadChart(params));
}
function $5b7ccabde48fae90$var$openChartToolPanel(beans, params) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.openChartToolPanel(params));
}
function $5b7ccabde48fae90$var$closeChartToolPanel(beans, params) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.closeChartToolPanel(params.chartId));
}
function $5b7ccabde48fae90$var$createRangeChart(beans, params) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.createRangeChart(params, true));
}
function $5b7ccabde48fae90$var$createPivotChart(beans, params) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.createPivotChart(params, true));
}
function $5b7ccabde48fae90$var$createCrossFilterChart(beans, params) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.createCrossFilterChart(params, true));
}
function $5b7ccabde48fae90$var$updateChart(beans, params) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.updateChart(params));
}
function $5b7ccabde48fae90$var$restoreChart(beans, chartModel, chartContainer) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.restoreChart(chartModel, chartContainer));
}
// packages/ag-grid-enterprise/src/charts/integratedChartsModule.css-GENERATED.ts
var $5b7ccabde48fae90$var$integratedChartsModuleCSS = /*css*/ `.ag-chart{display:flex;height:100%;position:relative;width:100%}.ag-chart-components-wrapper{display:flex}.ag-chart-canvas-wrapper,.ag-chart-components-wrapper{flex:1 1 auto;position:relative}.ag-chart-menu{background:var(--ag-background-color);background-color:color-mix(in srgb,transparent,var(--ag-background-color) 30%);border-radius:var(--ag-border-radius);display:flex;flex-direction:row;gap:20px;padding:4px 2px;position:absolute;top:8px;width:auto;--ag-icon-size:20px}:where(.ag-ltr) .ag-chart-menu{justify-content:right;right:calc(var(--ag-cell-horizontal-padding) + var(--ag-spacing) - 4px)}:where(.ag-rtl) .ag-chart-menu{justify-content:left;left:calc(var(--ag-cell-horizontal-padding) + var(--ag-spacing) - 4px)}.ag-chart-docked-container{min-width:var(--ag-chart-menu-panel-width);position:relative}:where(.ag-chart-menu-hidden)~.ag-chart-docked-container{display:none}.ag-chart-tabbed-menu{display:flex;flex-direction:column;height:100%;overflow:hidden;width:100%}.ag-chart-tabbed-menu-header{cursor:default;flex:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-chart-tabbed-menu-body{align-items:stretch;display:flex;flex:1 1 auto;overflow:hidden;position:relative;&:after{background:linear-gradient(var(--ag-background-color),transparent);content:"";display:block;height:16px;left:0;position:absolute;right:0;top:0}}.ag-chart-tab{overflow:hidden;overflow-y:auto;width:100%}.ag-chart-settings{overflow-x:hidden}.ag-chart-settings-wrapper{display:flex;flex-direction:column;height:100%;overflow:hidden;position:relative;width:100%}.ag-chart-settings-nav-bar{align-items:center;border-top:solid var(--ag-border-width) var(--ag-border-color);display:flex;height:30px;padding:0 10px;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:100%}.ag-chart-settings-card-selector{align-items:center;display:flex;flex:1 1 auto;height:100%;justify-content:space-around;padding:0 10px}.ag-chart-settings-card-item{background-color:var(--ag-foreground-color);border-radius:4px;cursor:pointer;height:8px;position:relative;width:8px;&.ag-not-selected{opacity:.2}&:before{background-color:transparent;content:" ";display:block;height:20px;left:50%;margin-left:-10px;margin-top:-10px;position:absolute;top:50%;width:20px}&.ag-selected{background-color:var(--ag-accent-color)}}.ag-chart-settings-next,.ag-chart-settings-prev{flex:none;position:relative;&:focus-within{border-radius:1px;box-shadow:var(--ag-focus-shadow)}}.ag-chart-settings-next-button,.ag-chart-settings-prev-button{cursor:pointer;height:100%;left:0;opacity:0;position:absolute;top:0;width:100%}.ag-chart-settings-mini-charts-container{flex:1 1 auto;overflow:hidden auto;position:relative}.ag-chart-settings-mini-wrapper{display:flex;flex-direction:column;left:0;min-height:100%;overflow:hidden;padding-bottom:var(--ag-widget-container-vertical-padding);position:absolute;top:0;width:100%;&.ag-animating{transition:left .3s;transition-timing-function:ease-in-out}}.ag-chart-mini-thumbnail{border:solid var(--ag-border-width) var(--ag-border-color);border-radius:5px;cursor:pointer;padding:1px;&.ag-selected{border-color:var(--ag-accent-color);border-width:calc(var(--ag-border-width) + 1px);padding:unset}&:focus-visible{border-color:var(--ag-accent-color);box-shadow:var(--ag-focus-shadow)}}.ag-chart-mini-thumbnail-canvas{display:block}.ag-chart-advanced-settings-wrapper,.ag-chart-data-wrapper,.ag-chart-format-wrapper{display:flex;flex-direction:column;padding-bottom:16px;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-chart-advanced-settings-wrapper,.ag-chart-data-wrapper{height:100%;overflow-y:auto}.ag-chart-advanced-settings{background-color:var(--ag-chrome-background-color)}.ag-chart-advanced-settings,.ag-chart-advanced-settings-wrapper{width:100%}.ag-chart-advanced-settings-wrapper{padding-bottom:0}.ag-chart-advanced-settings-section{border-bottom:solid var(--ag-border-width) var(--ag-border-color);display:flex;margin:0;padding-bottom:var(--ag-widget-container-vertical-padding);padding-top:var(--ag-widget-container-vertical-padding)}.ag-chart-empty-text{align-items:center;background-color:var(--ag-background-color);display:flex;height:100%;justify-content:center;top:0;width:100%}.ag-charts-font-size-color{align-self:stretch;display:flex;justify-content:space-between}.ag-charts-data-group-item{padding-bottom:var(--ag-widget-container-vertical-padding);position:relative}.ag-charts-data-group-item:where(:not(:last-child)){margin-bottom:var(--ag-spacing)}.ag-chart-menu-icon{border-radius:var(--ag-border-radius);cursor:pointer;margin:2px 0;opacity:.8;&:hover{opacity:1}}.ag-chart-menu-toolbar-button{background-color:unset;border:0;border-radius:1px;padding:0 2px}.ag-chart-data-column-drag-handle{margin-left:var(--ag-spacing)}.ag-charts-advanced-settings-top-level-group-title-bar{background-color:unset;position:relative}.ag-charts-data-group-container{padding:calc(var(--ag-widget-container-vertical-padding)*.5) var(--ag-widget-container-horizontal-padding)}.ag-charts-data-group-item:where(:not(.ag-charts-format-sub-level-group,.ag-pill-select,.ag-select)){height:var(--ag-list-item-height)}.ag-charts-data-group-item:where(.ag-picker-field){margin-top:var(--ag-spacing)}.ag-charts-advanced-settings-top-level-group-container,.ag-charts-format-top-level-group-container{margin-left:calc(var(--ag-spacing)*2);padding:var(--ag-spacing)}.ag-charts-advanced-settings-top-level-group-item,.ag-charts-format-top-level-group-item{margin:var(--ag-spacing) 0}.ag-charts-format-sub-level-group-container{display:flex;flex-direction:column;padding:var(--ag-widget-vertical-spacing) 0}.ag-charts-settings-group-container{display:grid;grid-template-columns:60px 1fr 60px 1fr 60px;padding:var(--ag-spacing);row-gap:8px;:where(.ag-chart-mini-thumbnail:nth-child(3n+1)){grid-column:1}:where(.ag-chart-mini-thumbnail:nth-child(3n+2)){grid-column:3}:where(.ag-chart-mini-thumbnail:nth-child(3n+3)){grid-column:5}}.ag-chart-data-section,.ag-chart-format-section{display:flex;margin:0;:where(.ag-label:not(.ag-group-title-bar)){color:var(--ag-chart-menu-label-color)}:where(.ag-label-align-top .ag-label){margin-bottom:var(--ag-widget-vertical-spacing);margin-top:calc(var(--ag-widget-vertical-spacing)*.5)}:where(.ag-slider.ag-label-align-top .ag-label){margin-bottom:0}:where(label){display:inline-block}}.ag-chart-menu-panel{--ag-panel-background-color:var(--ag-chrome-background-color)}:where(.ag-ltr) .ag-chart-menu-panel{border-left:solid var(--ag-border-width) var(--ag-border-color)}:where(.ag-rtl) .ag-chart-menu-panel{border-right:solid var(--ag-border-width) var(--ag-border-color)}.ag-charts-data-group-title-bar,.ag-charts-format-top-level-group-title-bar,.ag-charts-settings-group-container,.ag-charts-settings-group-title-bar{border-top:none;font-weight:500;padding:0 calc(var(--ag-spacing)*1.5)}.ag-charts-format-sub-level-group-title-bar{background:none;font-weight:500;padding:var(--ag-widget-vertical-spacing) 0}.ag-chart-data-wrapper,.ag-chart-format-wrapper,.ag-charts-data-group-container,.ag-charts-data-group-title-bar,.ag-charts-format-sub-level-group,.ag-charts-format-sub-level-group-container>*,.ag-charts-format-sub-level-group-item:last-child,.ag-charts-format-top-level-group,.ag-charts-format-top-level-group-item,.ag-charts-format-top-level-group-title-bar,.ag-charts-settings-group-container,.ag-charts-settings-group-title-bar,:where(.ag-charts-format-top-level-group) .ag-charts-format-top-level-group-container{margin:0;padding:0}.ag-charts-data-group-title-bar,.ag-charts-format-top-level-group-title-bar,.ag-charts-settings-group-title-bar{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:relative}.ag-charts-data-group,.ag-charts-format-top-level-group{border-top:solid var(--ag-border-width) var(--ag-border-color)}:where(.ag-charts-data-group) .ag-charts-data-group-container,:where(.ag-charts-format-top-level-group) .ag-charts-format-top-level-group-container,:where(.ag-charts-settings-group) .ag-charts-settings-group-container{padding:0 var(--ag-widget-container-horizontal-padding)}.ag-charts-format-sub-level-group-container>*,.ag-charts-format-sub-level-no-header-group-container>*,.ag-charts-format-top-level-group-container>*{margin-bottom:var(--ag-widget-vertical-spacing)}.ag-charts-advanced-settings-top-level-group-container{margin:0}:where(.ag-charts-advanced-settings-top-level-group){.ag-charts-advanced-settings-top-level-group-container,.ag-charts-advanced-settings-top-level-group-title-bar{padding:0 var(--ag-widget-container-horizontal-padding)}}.ag-charts-advanced-settings-top-level-group-item{margin-bottom:0;margin-top:calc(var(--ag-widget-vertical-spacing)*2)}.ag-chart-settings-card-item.ag-not-selected:hover{opacity:.35}.ag-angle-select{align-items:center;display:flex}.ag-angle-select-wrapper{display:flex}.ag-angle-select-parent-circle{background-color:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:12px;display:block;height:24px;position:relative;width:24px}.ag-angle-select-child-circle{background-color:var(--ag-foreground-color);border-radius:3px;height:6px;left:12px;margin-left:-3px;margin-top:-4px;position:absolute;top:4px;width:6px}.ag-slider-wrapper{display:flex;:where(.ag-input-field){flex:1 1 auto}}.ag-color-panel{display:flex;flex-direction:column;padding:var(--ag-spacing);text-align:center;width:100%}.ag-spectrum-color{cursor:default;flex:1 1 auto;overflow:visible;position:relative}.ag-spectrum-color,.ag-spectrum-fill{border-radius:var(--ag-border-radius)}.ag-spectrum-fill{inset:0;position:absolute}.ag-spectrum-val{background-image:linear-gradient(0deg,#000,hsla(20,42%,65%,0));cursor:pointer}.ag-spectrum-dragger{background:#000;border:var(--ag-color-picker-thumb-border-width) solid #fff;border-radius:var(--ag-color-picker-thumb-size);box-shadow:0 0 2px 0 rgba(0,0,0,.24);cursor:pointer;height:var(--ag-color-picker-thumb-size);pointer-events:none;position:absolute;width:var(--ag-color-picker-thumb-size)}.ag-spectrum-alpha,.ag-spectrum-hue{cursor:default}.ag-spectrum-hue-background{background:linear-gradient(270deg,red 3%,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red);height:100%;width:100%}.ag-spectrum-alpha-background{background:linear-gradient(to right,var(--ag-internal-spectrum-alpha-color-from),var(--ag-internal-spectrum-alpha-color-to)),url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="4" height="4"><rect x="0" y="0" width="4" height="4" fill="%23fff"/><path d="M0 0H2V4H4V2H0Z" fill="%23b2b2b2"/></svg>') 0 0 /4px 4px;height:100%;width:100%}.ag-spectrum-tool{cursor:pointer;height:var(--ag-color-picker-track-size);margin-bottom:10px;position:relative}.ag-spectrum-slider,.ag-spectrum-tool{border-radius:var(--ag-color-picker-thumb-size)}.ag-spectrum-slider{border:var(--ag-color-picker-thumb-border-width) solid #fff;box-shadow:0 1px 4px 0 rgba(0,0,0,.37);height:var(--ag-color-picker-thumb-size);margin-top:calc(var(--ag-color-picker-track-size)/2*-1 + var(--ag-color-picker-thumb-size)/2*-1);pointer-events:none;position:absolute;width:var(--ag-color-picker-thumb-size)}:where(.ag-spectrum-alpha) .ag-spectrum-slider{background:linear-gradient(to bottom,var(--ag-internal-spectrum-alpha-color),var(--ag-internal-spectrum-alpha-color)) var(--ag-background-color)}.ag-recent-colors{display:flex;gap:6px;margin:10px var(--ag-spacing) 2px}.ag-recent-color{border:solid var(--ag-border-width) var(--ag-border-color);cursor:pointer}.ag-angle-select[disabled]{opacity:.5;pointer-events:none}:where(.ag-ltr) .ag-angle-select-field,:where(.ag-ltr) .ag-slider-field{margin-right:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-angle-select-field,:where(.ag-rtl) .ag-slider-field{margin-left:calc(var(--ag-spacing)*2)}.ag-color-dialog{border-radius:5px}:where(.ag-color-picker){.ag-picker-field-wrapper{padding-left:var(--ag-spacing);padding-right:var(--ag-spacing)}.ag-picker-field-display{align-items:center;display:flex;flex-direction:row;min-height:var(--ag-list-item-height)}}:where(.ag-ltr) .ag-color-picker-color,:where(.ag-ltr) .ag-color-picker-value{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-color-picker-color,:where(.ag-rtl) .ag-color-picker-value{margin-left:var(--ag-spacing)}.ag-spectrum-tools{padding:10px 0 0}.ag-spectrum-alpha-background,.ag-spectrum-hue-background{border-radius:var(--ag-color-picker-track-border-radius)}.ag-color-input-color,.ag-color-picker-color,.ag-recent-color{border-radius:var(--ag-color-picker-color-border-radius)}.ag-spectrum-sat{background-image:linear-gradient(90deg,#fff,hsla(20,42%,65%,0))}.ag-recent-color,.ag-spectrum-color,.ag-spectrum-slider{&:where(:not(:disabled,[readonly])):focus-visible{box-shadow:var(--ag-focus-shadow)}}.ag-color-input-color,.ag-color-picker-color{border:solid var(--ag-border-width) var(--ag-border-color);height:var(--ag-icon-size);width:var(--ag-icon-size)}:where(.ag-ltr) .ag-color-input .ag-input-field-input{padding-left:calc(var(--ag-icon-size) + var(--ag-spacing)*2)}:where(.ag-rtl) .ag-color-input .ag-input-field-input{padding-right:calc(var(--ag-icon-size) + var(--ag-spacing)*2)}:where(.ag-color-input) .ag-color-input-color{position:absolute}:where(.ag-ltr) :where(.ag-color-input) .ag-color-input-color{margin-left:var(--ag-spacing)}:where(.ag-rtl) :where(.ag-color-input) .ag-color-input-color{margin-right:var(--ag-spacing)}.ag-range-field{align-items:center;display:flex;:where(.ag-input-wrapper){height:100%}}.ag-range-field-input{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;height:100%;overflow:visible;padding:0;width:100%;&:disabled{opacity:.5}}.ag-range-field-input{&::-webkit-slider-runnable-track{background-color:var(--ag-border-color);border-radius:1.5px;height:3px;margin:0;padding:0;width:100%}&::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;background-color:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:100%;height:var(--ag-icon-size);margin:0;padding:0;transform:translateY(calc(var(--ag-icon-size)*-.5 + 1.5px));width:var(--ag-icon-size)}&:focus::-webkit-slider-thumb{border-color:var(--ag-accent-color);box-shadow:var(--ag-focus-shadow)}&:active::-webkit-slider-runnable-track{background-color:var(--ag-accent-color)}}.ag-range-field-input{&::-moz-range-track{background-color:var(--ag-border-color);border-radius:1.5px;height:3px;margin:0;padding:0;width:100%}&::-moz-ag-range-thumb{-moz-appearance:none;appearance:none;background-color:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:100%;height:var(--ag-icon-size);margin:0;padding:0;transform:translateY(calc(var(--ag-icon-size)*-.5 + 1.5px));width:var(--ag-icon-size)}&:focus::-moz-ag-range-thumb{border-color:var(--ag-accent-color);box-shadow:var(--ag-focus-shadow)}&:active::-moz-ag-range-track{background-color:var(--ag-accent-color)}}`;
// packages/ag-grid-enterprise/src/charts/utils/validGridChartsVersion.ts
var $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_GRID_MAJOR_VERSION = 28;
var $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_CHARTS_MAJOR_VERSION = 6;
function $5b7ccabde48fae90$var$isValidVersion(version) {
    return version && version.match(/\d+\.\d+\.\d+/);
}
function $5b7ccabde48fae90$var$isValidMajorVersion({ gridMajorVersion: gridMajorVersion, chartsMajorVersion: chartsMajorVersion }) {
    const gridMajor = parseInt(gridMajorVersion, 10);
    const chartsMajor = parseInt(chartsMajorVersion, 10);
    const gridMajorDifference = gridMajor - $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_GRID_MAJOR_VERSION;
    const chartsMajorDifference = chartsMajor - $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_CHARTS_MAJOR_VERSION;
    const isFirstOrAfterVersion = gridMajorDifference >= 0;
    return gridMajorDifference === chartsMajorDifference && isFirstOrAfterVersion;
}
function $5b7ccabde48fae90$var$gridChartVersion(gridVersion) {
    if (!gridVersion || !$5b7ccabde48fae90$var$isValidVersion(gridVersion)) return void 0;
    const [gridMajor, gridMinor] = gridVersion.split(".") || [];
    const gridMajorMinor = `${gridMajor}.${gridMinor}.x`;
    const gridMajorNumber = parseInt(gridMajor, 10);
    const chartsMajor = gridMajorNumber - $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_GRID_MAJOR_VERSION + $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_CHARTS_MAJOR_VERSION;
    if (chartsMajor < 0) return void 0;
    const chartsMinor = gridMinor;
    const chartsMajorMinor = `${chartsMajor}.${chartsMinor}.x`;
    return {
        gridMajorMinor: gridMajorMinor,
        chartsMajorMinor: chartsMajorMinor
    };
}
function $5b7ccabde48fae90$var$validGridChartsVersionErrorMessage({ type: type, gridVersion: gridVersion, chartsVersion: chartsVersion }) {
    const invalidMessage = "AG Grid: AG Grid version is incompatible. Please see https://www.ag-grid.com/javascript-data-grid/modules/ for more information.";
    if (!gridVersion) return invalidMessage;
    const version = $5b7ccabde48fae90$var$gridChartVersion(gridVersion);
    if (!version) return invalidMessage;
    const { gridMajorMinor: gridMajorMinor, chartsMajorMinor: chartsMajorMinor } = version;
    if (type === "incompatible") return `AG Grid version ${gridVersion} and AG Charts version ${chartsVersion} is not supported. AG Grid version ${gridMajorMinor} should be used with AG Chart ${chartsMajorMinor}. Please see https://www.ag-grid.com/javascript-data-grid/modules/ for more information.`;
    else if (type === "invalidCharts") return `AG Grid version ${gridMajorMinor} should be used with AG Chart ${chartsMajorMinor} not ${chartsVersion}. Please see https://www.ag-grid.com/javascript-data-grid/modules/ for more information.`;
    return invalidMessage;
}
function $5b7ccabde48fae90$var$validGridChartsVersion({ gridVersion: gridVersion, chartsVersion: chartsVersion }) {
    if (!$5b7ccabde48fae90$var$isValidVersion(chartsVersion)) return {
        isValid: false,
        message: $5b7ccabde48fae90$var$validGridChartsVersionErrorMessage({
            type: "invalidCharts",
            gridVersion: gridVersion,
            chartsVersion: chartsVersion
        })
    };
    if (!$5b7ccabde48fae90$var$isValidVersion(gridVersion)) return {
        isValid: false,
        message: $5b7ccabde48fae90$var$validGridChartsVersionErrorMessage({
            type: "invalidGrid",
            gridVersion: gridVersion,
            chartsVersion: chartsVersion
        })
    };
    const [gridMajor, gridMinor] = gridVersion.split(".") || [];
    const [chartsMajor, chartsMinor, chartsPatch] = chartsVersion.split(".") || [];
    const isValidMajor = $5b7ccabde48fae90$var$isValidMajorVersion({
        gridMajorVersion: gridMajor,
        chartsMajorVersion: chartsMajor
    });
    if (isValidMajor && gridMinor === chartsMinor || chartsPatch.includes("beta")) return {
        isValid: true
    };
    else if (!isValidMajor || gridMinor !== chartsMinor) return {
        isValid: false,
        message: $5b7ccabde48fae90$var$validGridChartsVersionErrorMessage({
            type: "incompatible",
            gridVersion: gridVersion,
            chartsVersion: chartsVersion
        })
    };
    return {
        isValid: false,
        message: $5b7ccabde48fae90$var$validGridChartsVersionErrorMessage({
            type: "invalid",
            gridVersion: gridVersion,
            chartsVersion: chartsVersion
        })
    };
}
// packages/ag-grid-enterprise/src/charts/integratedChartsModule.ts
var $5b7ccabde48fae90$var$icons = {
    // shown on top right of chart when chart is linked to range data (click to unlink)
    linked: "linked",
    // shown on top right of chart when chart is not linked to range data (click to link)
    unlinked: "unlinked",
    // icon to open charts menu
    chartsMenu: "menu-alt",
    // download chart
    chartsDownload: "save",
    // Edit Chart menu item shown in Integrated Charts menu
    chartsMenuEdit: "chart",
    // Advanced Settings menu item shown in Integrated Charts menu
    chartsMenuAdvancedSettings: "settings",
    // shown in Integrated Charts menu add fields
    chartsMenuAdd: "plus",
    // shown in Integrated Charts tool panel color picker
    chartsColorPicker: "small-down",
    // previous in Integrated Charts settings tool panel theme switcher
    chartsThemePrevious: "previous",
    // next in Integrated Charts settings tool panel theme switcher
    chartsThemeNext: "next"
};
var $5b7ccabde48fae90$var$apiFunctions = {
    getChartModels: $5b7ccabde48fae90$var$getChartModels,
    getChartRef: $5b7ccabde48fae90$var$getChartRef,
    getChartImageDataURL: $5b7ccabde48fae90$var$getChartImageDataURL,
    downloadChart: $5b7ccabde48fae90$var$downloadChart,
    openChartToolPanel: $5b7ccabde48fae90$var$openChartToolPanel,
    closeChartToolPanel: $5b7ccabde48fae90$var$closeChartToolPanel,
    createRangeChart: $5b7ccabde48fae90$var$createRangeChart,
    createPivotChart: $5b7ccabde48fae90$var$createPivotChart,
    createCrossFilterChart: $5b7ccabde48fae90$var$createCrossFilterChart,
    updateChart: $5b7ccabde48fae90$var$updateChart,
    restoreChart: $5b7ccabde48fae90$var$restoreChart
};
var $5b7ccabde48fae90$var$dependsOn = [
    $5b7ccabde48fae90$export$6f4ee80b1242642d,
    $5b7ccabde48fae90$var$EnterpriseCoreModule,
    (0, $jIDNV._SharedDragAndDropModule),
    (0, $jIDNV._PopupModule),
    $5b7ccabde48fae90$var$MenuItemModule
];
var $5b7ccabde48fae90$var$moduleName2 = "IntegratedCharts";
var $5b7ccabde48fae90$export$6248c9e5743f8c49 = {
    moduleName: "GridCharts",
    version: $5b7ccabde48fae90$var$VERSION,
    dependsOn: $5b7ccabde48fae90$var$dependsOn,
    // included to avoid other false positive warnings about missing modules
    validate: ()=>{
        return {
            isValid: false,
            message: `AG Grid: As of v33, the "GridChartsModule" has been deprecated. Please use "IntegratedChartsModule.with(...)" instead.
 ${(0, $jIDNV._preInitErrMsg)(257)}`
        };
    }
};
var $5b7ccabde48fae90$export$31b991579b5608cb = {
    moduleName: $5b7ccabde48fae90$var$moduleName2,
    version: $5b7ccabde48fae90$var$VERSION,
    dependsOn: $5b7ccabde48fae90$var$dependsOn,
    // included to avoid other false positive warnings about missing modules
    validate: ()=>{
        return {
            isValid: false,
            message: (0, $jIDNV._preInitErrMsg)(257)
        };
    },
    with: (params)=>{
        params.setup();
        params.setGridContext?.(true);
        if (params.isEnterprise && params.setLicenseKey) {
            const chartsManager = {
                setLicenseKey: params.setLicenseKey
            };
            $5b7ccabde48fae90$var$LicenseManager.setChartsLicenseManager(chartsManager);
        }
        return {
            moduleName: $5b7ccabde48fae90$var$moduleName2,
            version: $5b7ccabde48fae90$var$VERSION,
            icons: $5b7ccabde48fae90$var$icons,
            apiFunctions: $5b7ccabde48fae90$var$apiFunctions,
            dependsOn: $5b7ccabde48fae90$var$dependsOn,
            css: [
                $5b7ccabde48fae90$var$integratedChartsModuleCSS
            ],
            validate: ()=>{
                return $5b7ccabde48fae90$var$validGridChartsVersion({
                    gridVersion: $5b7ccabde48fae90$var$VERSION,
                    chartsVersion: params.VERSION
                });
            },
            beans: [
                // bind the params to the constructor to avoid the need for static properties
                $5b7ccabde48fae90$var$AgChartsExports.bind(null, params),
                $5b7ccabde48fae90$var$ChartService,
                $5b7ccabde48fae90$var$ChartTranslationService,
                $5b7ccabde48fae90$var$ChartCrossFilterService,
                $5b7ccabde48fae90$var$ChartMenuListFactory,
                $5b7ccabde48fae90$var$ChartMenuService,
                // Include enterprise beans for now for all users as tiny compared to charts bundle size
                $5b7ccabde48fae90$var$EnterpriseChartProxyFactory,
                $5b7ccabde48fae90$var$AdvancedSettingsMenuFactory
            ]
        };
    }
};
var $5b7ccabde48fae90$var$dependsOn2 = [
    (0, $jIDNV.AllCommunityModule),
    $5b7ccabde48fae90$export$3a36bd45ca02edda,
    $5b7ccabde48fae90$export$8ff0dc87b3f8200e,
    $5b7ccabde48fae90$export$98f0c53ca0379def,
    $5b7ccabde48fae90$export$783953a68616c0a2,
    $5b7ccabde48fae90$export$5d9e175412b51985,
    $5b7ccabde48fae90$export$656cedc46227f6d2,
    $5b7ccabde48fae90$export$af7cdc2b9a7c9c3,
    $5b7ccabde48fae90$export$30ae2785d49a9f03,
    $5b7ccabde48fae90$export$6f4ee80b1242642d,
    $5b7ccabde48fae90$export$9bd93207561bb9c,
    $5b7ccabde48fae90$export$f0e5f58d7c17c748,
    $5b7ccabde48fae90$export$e67935bd41653107,
    $5b7ccabde48fae90$export$60c70655af65b0f1,
    $5b7ccabde48fae90$export$aca1637eb4e24373,
    $5b7ccabde48fae90$export$5c0e9f044c5e2dce,
    $5b7ccabde48fae90$export$208b04021c462957,
    $5b7ccabde48fae90$export$4ab172eba3fdda9e,
    $5b7ccabde48fae90$export$8897e17f4dd9d13a,
    $5b7ccabde48fae90$export$5f40a5e44930bd02,
    $5b7ccabde48fae90$export$707a9bd30915b7fe,
    $5b7ccabde48fae90$export$76a316c8c2f3bc28,
    $5b7ccabde48fae90$export$5afa3276c0fcf76,
    $5b7ccabde48fae90$export$4fc40ce1b35c05e1,
    $5b7ccabde48fae90$export$3460d687131d67ba,
    $5b7ccabde48fae90$export$3b7f0581dcb7e440,
    $5b7ccabde48fae90$export$3b8008724bbc4e9f
];
var $5b7ccabde48fae90$var$moduleName3 = "AllEnterprise";
var $5b7ccabde48fae90$export$22e6f186b688d81b = {
    with: (params)=>({
            moduleName: $5b7ccabde48fae90$var$moduleName3,
            version: $5b7ccabde48fae90$var$VERSION,
            dependsOn: [
                ...$5b7ccabde48fae90$var$dependsOn2,
                $5b7ccabde48fae90$export$31b991579b5608cb.with(params),
                $5b7ccabde48fae90$export$4e5a2f3bfb2b8795.with(params)
            ]
        }),
    moduleName: $5b7ccabde48fae90$var$moduleName3,
    version: $5b7ccabde48fae90$var$VERSION,
    dependsOn: $5b7ccabde48fae90$var$dependsOn2
};



var $9QePP = parcelRequire("9QePP");



var $r2uF6 = parcelRequire("r2uF6");
parcelRequire("UXGeS");
var $7Y7Q4 = parcelRequire("7Y7Q4");

var $9ohvd = parcelRequire("9ohvd");

var $dKUtl = parcelRequire("dKUtl");

var $lgOhz = parcelRequire("lgOhz");


(0, $5b7ccabde48fae90$export$91e2bbffdbb3852c).setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-090325}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Hum_Capital}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{hum-service}_only_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{hum-service}_need_to_be_licensed___{hum-service}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{19_June_2026}____[v3]_[0102]_MTc4MTgyMzYwMDAwMA==5aab76dc07cc09b0c8e7eab9ba75a314");
(0, $jIDNV.ModuleRegistry).registerModules([
    (0, $jIDNV.AllCommunityModule),
    (0, $5b7ccabde48fae90$export$656cedc46227f6d2)
]);
const $e8732a26985c5f38$var$ScoreCellRenderer = (props)=>{
    const score = props.data?.score;
    const maxScore = props.data?.maxScore;
    if (maxScore === null || maxScore === undefined) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: "-"
    });
    const actualScore = score ?? 0;
    const totalBars = Math.abs(Math.round(maxScore));
    const filledBars = Math.round(actualScore);
    const percentage = maxScore > 0 ? actualScore / maxScore * 100 : 0;
    const getColorClass = ()=>{
        if (actualScore < 0) {
            if (percentage <= -80) return "bg-red-500";
            if (percentage <= -60) return "bg-red-300";
            if (percentage <= -40) return "bg-red-200";
            if (percentage <= -20) return "bg-red-100";
            return "bg-red-50";
        }
        if (percentage >= 80) return "bg-emerald-500";
        if (percentage >= 60) return "bg-emerald-400";
        if (percentage >= 40) return "bg-emerald-300";
        if (percentage >= 20) return "bg-emerald-200";
        if (actualScore > 0) return "bg-emerald-100";
        return "bg-slate-700";
    };
    const colorClass = getColorClass();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("flex w-full items-center px-4 py-3", actualScore === null || actualScore === undefined || actualScore === 0 ? "justify-start" : actualScore > 0 ? "justify-start" : "justify-end"),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex items-center gap-0.5",
            children: [
                actualScore > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "h-5 w-px bg-white"
                }),
                Array.from({
                    length: totalBars
                }).map((_, i)=>{
                    const isBarFilled = filledBars >= 0 ? i < filledBars : i < Math.abs(filledBars);
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, $9QePP.default)("h-4 w-0.5", isBarFilled ? colorClass : "bg-slate-700")
                    }, i);
                }),
                actualScore < 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "h-5 w-px bg-white"
                })
            ]
        })
    });
};
const $e8732a26985c5f38$var$ValueBadgeCellRenderer = (props)=>{
    const value = props.value;
    if (!value) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: "-"
    });
    const valueColors = {
        [(0, $dKUtl.CreditBoxResult).PASS]: "bg-green-200",
        [(0, $dKUtl.CreditBoxResult).FAIL]: "bg-red-200"
    };
    const colorClass = valueColors[value] || "bg-gray-200";
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("lozenge w-max rounded-xl px-2 py-1 text-brand-900", colorClass),
        children: value
    });
};
const $e8732a26985c5f38$var$useInnerTableParams = ()=>{
    return (0, $acw62.useMemo)(()=>({
            detailGridOptions: {
                theme: (0, $a2756431b51c61a4$export$c0aca059b20b3008),
                columnDefs: [
                    {
                        field: "description",
                        headerName: "Description",
                        flex: 2,
                        minWidth: 200,
                        wrapText: true,
                        autoHeight: true,
                        cellStyle: {
                            display: "flex",
                            alignItems: "center",
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            lineHeight: "1.4",
                            paddingTop: "12px",
                            paddingBottom: "12px"
                        }
                    },
                    {
                        field: "opportunity",
                        headerName: "Opportunity",
                        flex: 1.5,
                        minWidth: 150,
                        wrapText: true,
                        autoHeight: true,
                        cellStyle: {
                            display: "flex",
                            alignItems: "center",
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            lineHeight: "1.4",
                            paddingTop: "12px",
                            paddingBottom: "12px"
                        }
                    },
                    {
                        field: "criteria",
                        headerName: "Criteria",
                        flex: 1.5,
                        minWidth: 150,
                        wrapText: true,
                        autoHeight: true,
                        cellStyle: {
                            display: "flex",
                            alignItems: "center",
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            lineHeight: "1.4",
                            paddingTop: "12px",
                            paddingBottom: "12px"
                        }
                    },
                    {
                        field: "score",
                        headerName: "Score",
                        resizable: false,
                        flex: 1,
                        minWidth: 120,
                        cellRenderer: $e8732a26985c5f38$var$ScoreCellRenderer,
                        wrapText: true,
                        autoHeight: true
                    }
                ],
                defaultColDef: {
                    flex: 1,
                    wrapText: true,
                    autoHeight: true,
                    wrapHeaderText: true,
                    autoHeaderHeight: true,
                    cellStyle: {
                        paddingTop: "12px",
                        paddingBottom: "12px"
                    }
                }
            },
            getDetailRowData: (params)=>{
                const criteria = params.data?.criteria || [];
                params.successCallback(criteria);
            }
        }), []);
};
const $e8732a26985c5f38$var$onFirstDataRendered = (params)=>{
    const firstRow = params.api.getRowNode("0");
    if (firstRow && firstRow.data?.hasValidFormat) firstRow.setExpanded(true);
};
const $e8732a26985c5f38$var$formatValue = (value, featureName)=>{
    if (value === null || value === undefined) return "-";
    if (typeof value === "string") {
        if (value === "None") return "None";
        return value;
    }
    if (typeof value === "number") {
        if (value === 0 && (featureName === "Software Only" || featureName === "Has Recent Equity Raise")) return "0";
        if (featureName === "Equity Sponsorship") return (0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)(value, (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY);
        if (featureName === "Self-Reported Annualized EBITDA") return (0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)(value, (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY);
        if (featureName === "Pro Forma debt to Revenue" || featureName === "Pro Forma debt to EBITDA") return (0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)(value, (0, $eb67e7ba0742cb25$export$b570835b381015d3).MULTIPLE);
        if (value >= 1000) return (0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)(value, (0, $eb67e7ba0742cb25$export$b570835b381015d3).CURRENCY);
        if (featureName === "Annual Revenue Growth %") return (0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)(value, (0, $eb67e7ba0742cb25$export$b570835b381015d3).PERCENTAGE);
        if (value < 1 && value > -1) return (0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)(value, (0, $eb67e7ba0742cb25$export$b570835b381015d3).PERCENTAGE);
        return (0, $a2eab1b4aea8a761$export$3a080a70bebaaf4c)(value, (0, $eb67e7ba0742cb25$export$b570835b381015d3).INTEGER);
    }
    return String(value);
};
const $e8732a26985c5f38$var$hasValidDetailFormat = (detail)=>{
    return "featureName" in detail && "operator" in detail && "opportunityValue" in detail && "creditBoxValue" in detail;
};
function $e8732a26985c5f38$export$6d6c9a84013d9898() {
    const setAIMContextView = (0, $r2uF6.useSetAtom)((0, $57f1ca4385a7301a$export$c65e5de3b3a2e247));
    const sfdcData = (0, $7Y7Q4.useApiQuery)((0, $lgOhz.getSFDCData));
    const sfdcOpportunityId = sfdcData.data?.[0]?.id;
    const { data: funds } = (0, $7Y7Q4.useApiQuery)((0, $9ohvd.getFunds));
    const fundCreditBoxIds = (funds || []).map((fund)=>fund.id);
    const { data: criteriaData, isLoading: isLoading } = (0, $7Y7Q4.useApiQuery)((0, $9ohvd.getInvestmentCriteria), {
        params: {
            sfdcOpportunityId: sfdcOpportunityId || "",
            creditBoxIds: fundCreditBoxIds
        },
        enabled: fundCreditBoxIds.length > 0
    });
    const tableData = (0, $acw62.useMemo)(()=>{
        if (!criteriaData?.creditBoxResultDetails) return [];
        return criteriaData.creditBoxResultDetails.map((result)=>{
            const criteriaDetails = result.details[0]?.details || [];
            const hasValidFormat = criteriaDetails.length > 0 && $e8732a26985c5f38$var$hasValidDetailFormat(criteriaDetails[0]);
            const capitalProductCriteria = criteriaDetails.find((d)=>d.featureName === "Capital Product Type");
            const criteria = hasValidFormat ? criteriaDetails.map((detail)=>{
                return {
                    description: detail.featureName,
                    opportunity: $e8732a26985c5f38$var$formatValue(detail.opportunityValue, detail.featureName),
                    criteria: `${detail.operator} ${$e8732a26985c5f38$var$formatValue(detail.creditBoxValue, detail.featureName)}`,
                    score: detail.creditBoxScore,
                    maxScore: detail.creditBoxBestPossibleScore
                };
            }) : [];
            return {
                creditBoxName: result.creditBoxName,
                capitalProductType: capitalProductCriteria?.creditBoxValue || null,
                score: result.score,
                value: result.score > 0 ? (0, $dKUtl.CreditBoxResult).PASS : (0, $dKUtl.CreditBoxResult).FAIL,
                lastPull: result.updatedAt,
                criteria: criteria,
                hasValidFormat: hasValidFormat
            };
        }).sort((a, b)=>{
            if (a.value === (0, $dKUtl.CreditBoxResult).PASS && b.value === (0, $dKUtl.CreditBoxResult).FAIL) return -1;
            if (a.value === (0, $dKUtl.CreditBoxResult).FAIL && b.value === (0, $dKUtl.CreditBoxResult).PASS) return 1;
            return 0;
        });
    }, [
        criteriaData
    ]);
    const InnerTableParams = $e8732a26985c5f38$var$useInnerTableParams();
    const handleClose = ()=>{
        setAIMContextView(null);
    };
    const columnDefs = (0, $acw62.useMemo)(()=>[
            {
                field: "creditBoxName",
                headerName: "Strategy Name",
                resizable: false,
                flex: 2,
                minWidth: 200,
                wrapText: true,
                autoHeight: true,
                cellStyle: {
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.4",
                    paddingTop: "12px",
                    paddingBottom: "12px"
                }
            },
            {
                field: "capitalProductType",
                headerName: "Capital Product Type",
                resizable: false,
                flex: 1.5,
                minWidth: 180,
                wrapText: true,
                autoHeight: true,
                cellStyle: {
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.4",
                    paddingTop: "12px",
                    paddingBottom: "12px"
                }
            },
            {
                field: "score",
                headerName: "Score",
                resizable: false,
                flex: 0.8,
                minWidth: 100,
                wrapText: true,
                autoHeight: true,
                valueFormatter: ({ value: value })=>{
                    return value?.toFixed(1) || "-";
                },
                cellStyle: {
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.4",
                    paddingTop: "12px",
                    paddingBottom: "12px"
                }
            },
            {
                field: "value",
                headerName: "Value",
                resizable: false,
                flex: 1,
                minWidth: 120,
                cellRenderer: $e8732a26985c5f38$var$ValueBadgeCellRenderer,
                wrapText: true,
                autoHeight: true,
                cellStyle: {
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.4",
                    paddingTop: "12px",
                    paddingBottom: "12px"
                }
            },
            {
                field: "lastPull",
                headerName: "Last Pull",
                resizable: false,
                flex: 1,
                minWidth: 140,
                wrapText: true,
                autoHeight: true,
                valueFormatter: ({ value: value })=>{
                    if (!value) return "-";
                    const date = new Date(value);
                    return date.toLocaleDateString("en-US", {
                        day: "numeric",
                        month: "short",
                        year: "numeric"
                    });
                },
                cellStyle: {
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.4",
                    paddingTop: "12px",
                    paddingBottom: "12px"
                }
            },
            {
                field: "expand",
                headerName: "",
                cellRendererSelector: (params)=>{
                    if (params.data?.hasValidFormat) return {
                        component: "agGroupCellRenderer",
                        params: {
                            suppressCount: true,
                            innerRenderer: ()=>""
                        }
                    };
                    return undefined;
                },
                resizable: false,
                flex: 0.3,
                minWidth: 50,
                maxWidth: 80,
                pinned: "right",
                lockPinned: true
            }
        ], []);
    const defaultColDef = (0, $acw62.useMemo)(()=>({
            flex: 1,
            wrapText: true,
            autoHeight: true,
            wrapHeaderText: true,
            autoHeaderHeight: true,
            cellStyle: {
                paddingTop: "12px",
                paddingBottom: "12px"
            }
        }), []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("bg-default", "flex size-full flex-col gap-4"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "pt-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3398e3e074fa037e$export$2e2bcd8739ae039), {
                    label: "Close",
                    iconDirection: "right",
                    onClick: handleClose
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "size-full",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "pageheading mb-1",
                        children: "Investment Criteria"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "subdued body-s mb-6",
                        children: [
                            "Drill down by strategy to see how this opportunity scores against each investment criteria and its associated importance in the matching schema. The score column shows how well an opportunity matches your criteria. More color means a stronger match; more bars indicate higher importance.",
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: "https://info.humcapital.com/hum-help-center/investment-criteria-match-scores",
                                target: "_blank",
                                rel: "noreferrer",
                                className: "text-link",
                                children: "Read more."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt-6 size-full",
                        children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "h-64 animate-pulse rounded-xl bg-slate-800"
                        }) : tableData && tableData.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gxPgh.AgGridReact), {
                            theme: (0, $a2756431b51c61a4$export$c0aca059b20b3008),
                            rowData: tableData,
                            columnDefs: columnDefs,
                            defaultColDef: defaultColDef,
                            masterDetail: true,
                            isRowMaster: (dataItem)=>dataItem.hasValidFormat,
                            detailCellRendererParams: InnerTableParams,
                            onFirstDataRendered: $e8732a26985c5f38$var$onFirstDataRendered,
                            detailRowAutoHeight: true,
                            onRowGroupOpened: (params)=>{
                                const api = params.api;
                                const currentRowNode = params.node;
                                api.forEachNode((node)=>{
                                    if (node.id !== currentRowNode.id) node.setExpanded(false);
                                });
                            },
                            domLayout: "autoHeight"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex items-center justify-center py-12",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "subdued body-s",
                                children: "No data available"
                            })
                        })
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $r2uF6 = parcelRequire("r2uF6");


var $9QePP = parcelRequire("9QePP");


var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
parcelRequire("acw62");
const $389baf3585bd1c84$export$59ab17f6e6d50c83 = ({ metric: metric, onValueClick: onValueClick, selectedRef: selectedRef })=>{
    const parts = [];
    let lastIndex = 0;
    console.log(metric.formula);
    const regex = /\$(\d+)/g;
    let match;
    const formatNumber = (num)=>{
        return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(num);
    };
    const formatText = (text)=>{
        const textParts = [];
        let textIdx = 0;
        for(let i = 0; i < text.length; i++){
            if (text[i] === "(") {
                if (i > textIdx) textParts.push(text.slice(textIdx, i));
                textParts.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "mr-1",
                    children: "("
                }, `open-${parts.length}-${i}`));
                textIdx = i + 1;
            } else if (text[i] === ")") {
                if (i > textIdx) textParts.push(text.slice(textIdx, i));
                textParts.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "ml-1",
                    children: ")"
                }, `close-${parts.length}-${i}`));
                textIdx = i + 1;
            }
        }
        if (textIdx < text.length) textParts.push(text.slice(textIdx));
        return textParts;
    };
    while((match = regex.exec(metric.formula)) !== null){
        const beforeMatch = metric.formula.slice(lastIndex, match.index);
        if (beforeMatch) parts.push(...formatText(beforeMatch));
        const valueIndex = parseInt(match[1], 10);
        const value = metric.values[valueIndex];
        if (value && value.meta) {
            const formattedValue = formatNumber(value.value);
            parts.push(/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                className: (0, $9QePP.default)("text-default px-2 py-1", "border-default rounded-lg border", "quiet", "hover:bg-selected text-subdued", selectedRef === value.ref && "bg-selected"),
                style: {
                    color: "white"
                },
                onClick: ()=>onValueClick?.(value, valueIndex),
                children: formattedValue
            }, `value-${valueIndex}`));
        } else if (value) parts.push(formatNumber(value.value));
        else parts.push(match[0]);
        lastIndex = regex.lastIndex;
    }
    if (lastIndex < metric.formula.length) parts.push(...formatText(metric.formula.slice(lastIndex)));
    parts.push(" = ");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "formula-display leading-loose",
                children: parts
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                className: "ml-1",
                children: new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD"
                }).format(metric.result)
            }, "result")
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("lhALd");
var $7Y7Q4 = parcelRequire("7Y7Q4");

/* eslint-disable hum/restrict-constants-imports */ /* eslint-disable hum/require-constants-import */ var $361aa3de286372f2$export$6d6abaf64a6e5602;
(function(ISLabel) {
    ISLabel["REVENUES_COHORT"] = "revenues.cohort";
    ISLabel["REVENUES_NON_COHORT"] = "revenues.non_cohort";
    ISLabel["REVENUES_NON_COHORT_SEPARATE_COGS"] = "revenues.non_cohort_separate_cogs";
    ISLabel["REVENUES_NON_COHORT_NO_COGS"] = "revenues.non_cohort_no_cogs";
    ISLabel["REVENUES_NON_RECURRING"] = "revenues.non_recurring";
    ISLabel["EXPENSES_D_AND_A"] = "expenses.D_and_A";
    ISLabel["EXPENSES_GROSS_CASHFLOW_RELATED"] = "expenses.gross_cashflow_related";
    ISLabel["EXPENSES_NON_CASH_EXPENSES"] = "expenses.non_cash_expenses";
    ISLabel["EXPENSES_NON_RECURRING"] = "expenses.non_recurring";
    ISLabel["EXPENSES_OPEX_RELATED"] = "expenses.opex_related";
    ISLabel["EXPENSES_R_AND_D_RELATED"] = "expenses.r_and_d_related";
    ISLabel["EXPENSES_REVENUE_RELATED_FINANCIAL_PRINCIPAL_RECOUPMENT"] = "expenses.revenue_related.financial_principal_recoupment";
    ISLabel["EXPENSES_REVENUE_RELATED_INVENTORY_RECOUPMENT"] = "expenses.revenue_related.inventory_recoupment";
    ISLabel["EXPENSES_REVENUE_RELATED_INVENTORY_RECOUPMENT_NON_COHORT"] = "expenses.revenue_related.inventory_recoupment_non_cohort";
    ISLabel["EXPENSES_REVENUE_RELATED_NON_INVENTORY_COGS"] = "expenses.revenue_related.non_inventory_cogs";
    ISLabel["EXPENSES_REVENUE_RELATED_NON_INVENTORY_COGS_NON_COHORT"] = "expenses.revenue_related.non_inventory_cogs_non_cohort";
    ISLabel["INVESTMENTS_SALES_AND_MARKETING"] = "investments.sales_and_marketing";
    ISLabel["INVESTMENTS_EQUITY"] = "investments.equity";
    ISLabel["INVESTMENTS_INVENTORY"] = "investments.inventory";
    ISLabel["INVESTMENTS_LOAN"] = "investments.loan";
    ISLabel["INVESTMENTS_OTHER"] = "investments.other";
    ISLabel["BOOKINGS_COHORT"] = "bookings.cohort";
    ISLabel["BOOKINGS_NON_COHORT"] = "bookings.non_cohort";
    ISLabel["FINANCING_DEBT_RAISED"] = "financing.debt_raised";
    ISLabel["FINANCING_DEBT_SERVICES_PRINCIPAL"] = "financing.debt_services.principal";
    ISLabel["FINANCING_DEBT_SERVICES_INTEREST"] = "financing.debt_services.interest";
    ISLabel["FINANCING_DEBT_SERVICES_FEES"] = "financing.debt_services.fees";
    ISLabel["FINANCING_EQUITY_RAISED"] = "financing.equity_raised";
    ISLabel["FINANCING_EQUITY_SERVICES_PRINCIPAL"] = "financing.equity_services.principal";
    ISLabel["FINANCING_EQUITY_SERVICES_INCOME"] = "financing.equity_services.income";
    ISLabel["GROSS_CASHFLOWS_COHORT"] = "gross_cashflows.cohort";
    ISLabel["GROSS_CASHFLOWS_NON_COHORT"] = "gross_cashflows.non_cohort";
    ISLabel["GROSS_CASHFLOWS_NON_RECURRING"] = "gross_cashflows.non_recurring";
    ISLabel["OTHER_INCOME_EXPENSE_NET_OTHER_INCOME"] = "Other_income/expense_net.Other_income";
    ISLabel["OTHER_INCOME_EXPENSE_NET_OTHER_INCOME_NEGATIVE"] = "Other_income/expense_net.Other_income_negative";
    ISLabel["OTHER_INCOME_EXPENSE_NET_OTHER_EXPENSE"] = "Other_income/expense_net.Other_expense";
    ISLabel["OTHER_INCOME_EXPENSE_NET_OTHER_EXPENSE_NEGATIVE"] = "Other_income/expense_net.Other_expense_negative";
    ISLabel["REPORTED_NET_INCOME"] = "reported.net_income";
    ISLabel["REPORTED_COST_OF_GOODS_SOLD"] = "reported.cost_of_goods_sold";
    ISLabel["REPORTED_GROSS_MARGIN"] = "reported.gross_margin";
    ISLabel["REPORTED_TOTAL_OPERATING_EXPENSES"] = "reported.total_operating_expenses";
    ISLabel["REPORTED_EBITDA"] = "reported.ebitda";
})($361aa3de286372f2$export$6d6abaf64a6e5602 || ($361aa3de286372f2$export$6d6abaf64a6e5602 = {}));
var $361aa3de286372f2$export$844fca46adfd5a0a;
(function(BSLabel) {
    BSLabel["CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS"] = "current_assets.cash_and_cash_equivalents";
    BSLabel["CURRENT_ASSETS_DEFERRED_EXPENSES"] = "current_assets.deferred_expenses";
    BSLabel["CURRENT_ASSETS_DERIVATIVES_AND_HEDGES"] = "current_assets.derivatives_and_hedges";
    BSLabel["CURRENT_ASSETS_NET_CONTRACTS_WITH_CUSTOMERS"] = "current_assets.net_contracts_with_customers";
    BSLabel["CURRENT_ASSETS_NET_INVENTORY"] = "current_assets.net_inventory";
    BSLabel["CURRENT_ASSETS_NET_RECEIVABLES"] = "current_assets.net_receivables";
    BSLabel["CURRENT_ASSETS_OTHER_CURRENT_ASSETS"] = "current_assets.other_current_assets";
    BSLabel["CURRENT_ASSETS_PREPAID_EXPENSES"] = "current_assets.prepaid_expenses";
    BSLabel["NONCURRENT_ASSETS_DEFERRED_EXPENSES"] = "noncurrent_assets.deferred_expenses";
    BSLabel["NONCURRENT_ASSETS_DERIVATIVES_AND_HEDGES"] = "noncurrent_assets.derivatives_and_hedges";
    BSLabel["NONCURRENT_ASSETS_INVENTORY"] = "noncurrent_assets.inventory";
    BSLabel["NONCURRENT_ASSETS_LONGTERM_INVESTMENTS_AND_RECEIVABLES"] = "noncurrent_assets.longterm_investments_and_receivables";
    BSLabel["NONCURRENT_ASSETS_NET_CONTRACTS_WITH_CUSTOMERS"] = "noncurrent_assets.net_contracts_with_customers";
    BSLabel["NONCURRENT_ASSETS_NET_INTANGIBLE_ASSETS_AND_GOODWILL"] = "noncurrent_assets.net_intangible_assets_and_goodwill";
    BSLabel["NONCURRENT_ASSETS_OTHER_ASSETS"] = "noncurrent_assets.other_assets";
    BSLabel["NONCURRENT_ASSETS_PREPAID_EXPENSES"] = "noncurrent_assets.prepaid_expenses";
    BSLabel["NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT"] = "noncurrent_assets.property_plant_and_equipment";
    BSLabel["NONCURRENT_ASSETS_RESTRICTED_CASH_AND_CASH_EQUIVALENTS"] = "noncurrent_assets.restricted_cash_and_cash_equivalents";
    BSLabel["CURRENT_LIABILITIES_ACCOUNTS_PAYABLE"] = "current_liabilities.accounts_payable";
    BSLabel["CURRENT_LIABILITIES_DEBT"] = "current_liabilities.debt";
    BSLabel["CURRENT_LIABILITIES_DEFERRED_REVENUE"] = "current_liabilities.deferred_revenue";
    BSLabel["CURRENT_LIABILITIES_DERIVATIVES_AND_HEDGES"] = "current_liabilities.derivatives_and_hedges";
    BSLabel["CURRENT_LIABILITIES_OTHER_LIABILITIES"] = "current_liabilities.other_liabilities";
    BSLabel["CURRENT_LIABILITIES_PROVISION_AND_ACCRUALS"] = "current_liabilities.provision_and_accruals";
    BSLabel["CURRENT_LIABILITIES_PROVISION_FOR_LOSSES_ON_CONTRACTS"] = "current_liabilities.provision_for_losses_on_contracts";
    BSLabel["CURRENT_LIABILITIES_PROVISION_FOR_REFUNDS"] = "current_liabilities.provision_for_refunds";
    BSLabel["NONCURRENT_LIABILITIES_ACCOUNTS_PAYABLE"] = "noncurrent_liabilities.accounts_payable";
    BSLabel["NONCURRENT_LIABILITIES_DEFERRED_REVENUE"] = "noncurrent_liabilities.deferred_revenue";
    BSLabel["NONCURRENT_LIABILITIES_DERIVATIVES_HEDGES"] = "noncurrent_liabilities.derivatives_hedges";
    BSLabel["NONCURRENT_LIABILITIES_LONGTERM_DEBT"] = "noncurrent_liabilities.longterm_debt";
    BSLabel["NONCURRENT_LIABILITIES_OTHER_LIABILITIES"] = "noncurrent_liabilities.other_liabilities";
    BSLabel["NONCURRENT_LIABILITIES_PROVISION_AND_ACCRUALS"] = "noncurrent_liabilities.provision_and_accruals";
    BSLabel["NONCURRENT_LIABILITIES_PROVISION_FOR_LOSSES_ON_CONTRACTS"] = "noncurrent_liabilities.provision_for_losses_on_contracts";
    BSLabel["NONCURRENT_LIABILITIES_PROVISION_FOR_REFUNDS"] = "noncurrent_liabilities.provision_for_refunds";
    BSLabel["EQUITY_PAID_IN_CAPITAL"] = "equity.paid_in_capital";
    BSLabel["EQUITY_RETAINED_EARNINGS"] = "equity.retained_earnings";
    BSLabel["REPORTED_CURRENT_ASSETS"] = "reported.current_assets";
    BSLabel["REPORTED_NONCURRENT_ASSETS"] = "reported.noncurrent_assets";
    BSLabel["REPORTED_CURRENT_LIABILITIES"] = "reported.current_liabilities";
    BSLabel["REPORTED_NONCURRENT_LIABILITIES"] = "reported.noncurrent_liabilities";
    BSLabel["REPORTED_TOTAL_EQUITY"] = "reported.total_equity";
})($361aa3de286372f2$export$844fca46adfd5a0a || ($361aa3de286372f2$export$844fca46adfd5a0a = {}));
var $361aa3de286372f2$export$addb672d3ff905f7;
(function(ExcludedLabel) {
    ExcludedLabel["EXCLUDED_BLANK"] = "excluded.blank";
    ExcludedLabel["EXCLUDED_SUM"] = "excluded.sum";
    ExcludedLabel["EXCLUDED_DIFFERENCE"] = "excluded.difference";
    ExcludedLabel["EXCLUDED_UNKNOWN"] = "excluded.unknown";
})($361aa3de286372f2$export$addb672d3ff905f7 || ($361aa3de286372f2$export$addb672d3ff905f7 = {}));
const $361aa3de286372f2$export$2160950bfd2fb6de = {
    ...$361aa3de286372f2$export$6d6abaf64a6e5602,
    ...$361aa3de286372f2$export$844fca46adfd5a0a,
    ...$361aa3de286372f2$export$addb672d3ff905f7
};
var $361aa3de286372f2$export$b084e5bf607d8178;
(function(BalanceSheetCategory) {
    BalanceSheetCategory["ASSETS"] = "assets";
    BalanceSheetCategory["LIABILITIES"] = "liabilities";
    BalanceSheetCategory["EQUITY"] = "equity";
})($361aa3de286372f2$export$b084e5bf607d8178 || ($361aa3de286372f2$export$b084e5bf607d8178 = {}));
var $361aa3de286372f2$export$a88a0750c5292665;
(function(IncomeStatementCategory) {
    IncomeStatementCategory["REVENUES"] = "revenues";
    IncomeStatementCategory["EXPENSES"] = "expenses";
    IncomeStatementCategory["INVESTMENTS"] = "investments";
    IncomeStatementCategory["BOOKINGS"] = "bookings";
    IncomeStatementCategory["FINANCING"] = "financing";
    IncomeStatementCategory["GROSS_CASHFLOWS"] = "GROSS_CASHFLOWS";
    IncomeStatementCategory["OTHER_INCOME_EXPENSE_NET"] = "OTHER_INCOME_EXPENSE_NET";
})($361aa3de286372f2$export$a88a0750c5292665 || ($361aa3de286372f2$export$a88a0750c5292665 = {}));
var $361aa3de286372f2$export$b62f1bc6ce6ce89d;
(function(OtherCategory) {
    OtherCategory["IS_REPORTED"] = "is_reported";
    OtherCategory["BS_REPORTED"] = "bs_reported";
    OtherCategory["EXCLUDED"] = "excluded";
})($361aa3de286372f2$export$b62f1bc6ce6ce89d || ($361aa3de286372f2$export$b62f1bc6ce6ce89d = {}));



const $af64889d1af19aba$export$680cd113e2939fb5 = {
    current: "Currently viewing",
    mostRecent: "Most Recent",
    historical: "Historical"
};
const $af64889d1af19aba$export$2d24c055ca23de42 = [
    (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
    (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET
];
const $af64889d1af19aba$export$89985bf7de36f667 = [
    "mostRecent",
    "historical"
];
const $af64889d1af19aba$export$eb904f93b8d08cc1 = {
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).REVENUES_COHORT]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Cohort-able Revenue",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).REVENUES,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).REVENUES_COHORT
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).REVENUES_NON_COHORT]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Non Cohort-able Revenue with Shared COGS",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).REVENUES,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).REVENUES_NON_COHORT
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).REVENUES_NON_COHORT_SEPARATE_COGS]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Non Cohort-able Revenue with Separate COGS",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).REVENUES,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).REVENUES_NON_COHORT_SEPARATE_COGS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).REVENUES_NON_COHORT_NO_COGS]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Non Cohort-able Revenue without COGS",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).REVENUES,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).REVENUES_NON_COHORT_NO_COGS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).REVENUES_NON_RECURRING]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Non Recurring Revenue",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).REVENUES,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).REVENUES_NON_RECURRING
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_D_AND_A]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Depreciation & Amortization",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).EXPENSES,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_D_AND_A
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_GROSS_CASHFLOW_RELATED]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "GMV Deductions",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).EXPENSES,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_GROSS_CASHFLOW_RELATED
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_NON_CASH_EXPENSES]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Non-Cash Expenses",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).EXPENSES,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_NON_CASH_EXPENSES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_NON_RECURRING]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Non-Recurring Expenses",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).EXPENSES,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_NON_RECURRING
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_OPEX_RELATED]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Operating Expenses",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).EXPENSES,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_OPEX_RELATED
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_R_AND_D_RELATED]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Research & Development Expenses",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).EXPENSES,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_R_AND_D_RELATED
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_REVENUE_RELATED_FINANCIAL_PRINCIPAL_RECOUPMENT]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Financial Principal Recoupment",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).EXPENSES,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_REVENUE_RELATED_FINANCIAL_PRINCIPAL_RECOUPMENT
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_REVENUE_RELATED_INVENTORY_RECOUPMENT]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Inventory COGS",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).EXPENSES,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_REVENUE_RELATED_INVENTORY_RECOUPMENT
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_REVENUE_RELATED_INVENTORY_RECOUPMENT_NON_COHORT]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Non-Cohort-able Inventory COGS",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).EXPENSES,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_REVENUE_RELATED_INVENTORY_RECOUPMENT_NON_COHORT
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_REVENUE_RELATED_NON_INVENTORY_COGS]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Non-Inventory COGS",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).EXPENSES,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_REVENUE_RELATED_NON_INVENTORY_COGS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_REVENUE_RELATED_NON_INVENTORY_COGS_NON_COHORT]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Non-Cohort-able Non-Inventory COGS",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).EXPENSES,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EXPENSES_REVENUE_RELATED_NON_INVENTORY_COGS_NON_COHORT
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).INVESTMENTS_SALES_AND_MARKETING]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Sales & Marketing Expense",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).INVESTMENTS,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).INVESTMENTS_SALES_AND_MARKETING
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).INVESTMENTS_EQUITY]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Equity Investments",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).INVESTMENTS,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).INVESTMENTS_EQUITY
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).INVESTMENTS_INVENTORY]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Inventory Purchases",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).INVESTMENTS,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).INVESTMENTS_INVENTORY
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).INVESTMENTS_LOAN]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Loan Originations",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).INVESTMENTS,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).INVESTMENTS_LOAN
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).INVESTMENTS_OTHER]: {
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Other Investments",
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).INVESTMENTS,
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).INVESTMENTS_OTHER
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).BOOKINGS_COHORT]: {
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).BOOKINGS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Cohort-able Bookings",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).BOOKINGS_COHORT
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).BOOKINGS_NON_COHORT]: {
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).BOOKINGS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Non Cohort-able Bookings",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).BOOKINGS_NON_COHORT
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).FINANCING_DEBT_RAISED]: {
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).FINANCING,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Debt Raised",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).FINANCING_DEBT_RAISED
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).FINANCING_DEBT_SERVICES_PRINCIPAL]: {
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).FINANCING,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Repayment of Principal",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).FINANCING_DEBT_SERVICES_PRINCIPAL
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).FINANCING_DEBT_SERVICES_INTEREST]: {
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).FINANCING,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Interest Expense",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).FINANCING_DEBT_SERVICES_INTEREST
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).FINANCING_DEBT_SERVICES_FEES]: {
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).FINANCING,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Fees related to Debt Services",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).FINANCING_DEBT_SERVICES_FEES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).FINANCING_EQUITY_RAISED]: {
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).FINANCING,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Equity Raised",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).FINANCING_EQUITY_RAISED
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).FINANCING_EQUITY_SERVICES_PRINCIPAL]: {
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).FINANCING,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Return of Equity Capital",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).FINANCING_EQUITY_SERVICES_PRINCIPAL
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).FINANCING_EQUITY_SERVICES_INCOME]: {
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).FINANCING,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Dividends",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).FINANCING_EQUITY_SERVICES_INCOME
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).GROSS_CASHFLOWS_COHORT]: {
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).GROSS_CASHFLOWS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Cohort-able Gross Merchandise Value",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).GROSS_CASHFLOWS_COHORT
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).GROSS_CASHFLOWS_NON_COHORT]: {
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).GROSS_CASHFLOWS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Non Cohort-able Gross Merchandise Value",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).GROSS_CASHFLOWS_NON_COHORT
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).GROSS_CASHFLOWS_NON_RECURRING]: {
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).GROSS_CASHFLOWS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Non-Recurring Gross Merchandise Value",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).GROSS_CASHFLOWS_NON_RECURRING
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).OTHER_INCOME_EXPENSE_NET_OTHER_INCOME]: {
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).OTHER_INCOME_EXPENSE_NET,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Other Income (Positive)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).OTHER_INCOME_EXPENSE_NET_OTHER_INCOME
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).OTHER_INCOME_EXPENSE_NET_OTHER_INCOME_NEGATIVE]: {
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).OTHER_INCOME_EXPENSE_NET,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Other Income (Negative)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).OTHER_INCOME_EXPENSE_NET_OTHER_INCOME_NEGATIVE
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).OTHER_INCOME_EXPENSE_NET_OTHER_EXPENSE]: {
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).OTHER_INCOME_EXPENSE_NET,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Other Expense (Positive)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).OTHER_INCOME_EXPENSE_NET_OTHER_EXPENSE
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).OTHER_INCOME_EXPENSE_NET_OTHER_EXPENSE_NEGATIVE]: {
        category: (0, $361aa3de286372f2$export$a88a0750c5292665).OTHER_INCOME_EXPENSE_NET,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Other Expense (Negative)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).OTHER_INCOME_EXPENSE_NET_OTHER_EXPENSE_NEGATIVE
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_NET_INCOME]: {
        category: (0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).IS_REPORTED,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Net Income (As Reported)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_NET_INCOME
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Cash and Cash Equivalents",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_ASSETS_DEFERRED_EXPENSES]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Deferred Expenses (Current Assets)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_ASSETS_DEFERRED_EXPENSES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_ASSETS_DERIVATIVES_AND_HEDGES]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Derivatives and Hedges (Current Assets)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_ASSETS_DERIVATIVES_AND_HEDGES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_ASSETS_NET_CONTRACTS_WITH_CUSTOMERS]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Net Contracts with Customers (Current Assets)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_ASSETS_NET_CONTRACTS_WITH_CUSTOMERS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_ASSETS_NET_INVENTORY]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Net Inventory (Current Assets)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_ASSETS_NET_INVENTORY
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_ASSETS_NET_RECEIVABLES]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Accounts Receivables (Current Assets)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_ASSETS_NET_RECEIVABLES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_ASSETS_OTHER_CURRENT_ASSETS]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Other Current Assets (Current Assets)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_ASSETS_OTHER_CURRENT_ASSETS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_ASSETS_PREPAID_EXPENSES]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Prepaid Expenses (Current Assets)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_ASSETS_PREPAID_EXPENSES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_DEFERRED_EXPENSES]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Deferred Expenses (Non-Current)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_DEFERRED_EXPENSES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_DERIVATIVES_AND_HEDGES]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Derivatives and Hedges (Non-Current)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_DERIVATIVES_AND_HEDGES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_INVENTORY]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Inventory (Non-Current)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_INVENTORY
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_LONGTERM_INVESTMENTS_AND_RECEIVABLES]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Long-Term Investments and Receivables",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_LONGTERM_INVESTMENTS_AND_RECEIVABLES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_NET_CONTRACTS_WITH_CUSTOMERS]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Net Contracts with Customers (Non-Current)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_NET_CONTRACTS_WITH_CUSTOMERS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_NET_INTANGIBLE_ASSETS_AND_GOODWILL]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Net Intangible Assets and Goodwill",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_NET_INTANGIBLE_ASSETS_AND_GOODWILL
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_OTHER_ASSETS]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Other Non-Current Assets",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_OTHER_ASSETS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_PREPAID_EXPENSES]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Prepaid Expenses (Non-Current)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_PREPAID_EXPENSES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Property, Plant and Equipment (PP&E)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_RESTRICTED_CASH_AND_CASH_EQUIVALENTS]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Restricted Cash and Cash Equivalents",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_ASSETS_RESTRICTED_CASH_AND_CASH_EQUIVALENTS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_LIABILITIES_ACCOUNTS_PAYABLE]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Accounts Payable",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_LIABILITIES_ACCOUNTS_PAYABLE
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_LIABILITIES_DEBT]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Current Debt",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_LIABILITIES_DEBT
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_LIABILITIES_DEFERRED_REVENUE]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Deferred Revenue",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_LIABILITIES_DEFERRED_REVENUE
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_LIABILITIES_DERIVATIVES_AND_HEDGES]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Derivatives and Hedges (Current)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_LIABILITIES_DERIVATIVES_AND_HEDGES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_LIABILITIES_OTHER_LIABILITIES]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Other Current Liabilities",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_LIABILITIES_OTHER_LIABILITIES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_LIABILITIES_PROVISION_AND_ACCRUALS]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Provision and Accruals (Current)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_LIABILITIES_PROVISION_AND_ACCRUALS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_LIABILITIES_PROVISION_FOR_LOSSES_ON_CONTRACTS]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Provision for Losses on Contracts (Current)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_LIABILITIES_PROVISION_FOR_LOSSES_ON_CONTRACTS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_LIABILITIES_PROVISION_FOR_REFUNDS]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Provision for Refunds (Current)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).CURRENT_LIABILITIES_PROVISION_FOR_REFUNDS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_LIABILITIES_ACCOUNTS_PAYABLE]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Accounts Payable (Non-Current)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_LIABILITIES_ACCOUNTS_PAYABLE
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_LIABILITIES_DEFERRED_REVENUE]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Deferred Revenue (Non-Current)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_LIABILITIES_DEFERRED_REVENUE
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_LIABILITIES_DERIVATIVES_HEDGES]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Derivatives and Hedges (Non-Current)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_LIABILITIES_DERIVATIVES_HEDGES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_LIABILITIES_LONGTERM_DEBT]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Long-Term Debt",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_LIABILITIES_LONGTERM_DEBT
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_LIABILITIES_OTHER_LIABILITIES]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Other Non-Current Liabilities",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_LIABILITIES_OTHER_LIABILITIES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_LIABILITIES_PROVISION_AND_ACCRUALS]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Provision and Accruals (Non-Current)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_LIABILITIES_PROVISION_AND_ACCRUALS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_LIABILITIES_PROVISION_FOR_LOSSES_ON_CONTRACTS]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Provision for Losses on Contracts (Non-Current)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_LIABILITIES_PROVISION_FOR_LOSSES_ON_CONTRACTS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_LIABILITIES_PROVISION_FOR_REFUNDS]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Provision for Refunds (Non-Current)",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).NONCURRENT_LIABILITIES_PROVISION_FOR_REFUNDS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EQUITY_PAID_IN_CAPITAL]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).EQUITY,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Paid-In Capital",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EQUITY_PAID_IN_CAPITAL
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EQUITY_RETAINED_EARNINGS]: {
        category: (0, $361aa3de286372f2$export$b084e5bf607d8178).EQUITY,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Retained Earnings",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EQUITY_RETAINED_EARNINGS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EXCLUDED_BLANK]: {
        category: (0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).EXCLUDED,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).MIXED,
        name: "Excluded Blank",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EXCLUDED_BLANK
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EXCLUDED_DIFFERENCE]: {
        category: (0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).EXCLUDED,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).MIXED,
        name: "Excluded Difference",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EXCLUDED_DIFFERENCE
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EXCLUDED_SUM]: {
        category: (0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).EXCLUDED,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).MIXED,
        name: "Excluded Sum",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EXCLUDED_SUM
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_CURRENT_ASSETS]: {
        category: (0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).BS_REPORTED,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Reported Current Assets",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_CURRENT_ASSETS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_NONCURRENT_ASSETS]: {
        category: (0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).BS_REPORTED,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Reported Non-Current Assets",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_NONCURRENT_ASSETS
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_CURRENT_LIABILITIES]: {
        category: (0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).BS_REPORTED,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Reported Current Liabilities",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_CURRENT_LIABILITIES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_NONCURRENT_LIABILITIES]: {
        category: (0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).BS_REPORTED,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Reported Non-Current Liabilities",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_NONCURRENT_LIABILITIES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_TOTAL_EQUITY]: {
        category: (0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).BS_REPORTED,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Reported Total Equity",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_TOTAL_EQUITY
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_COST_OF_GOODS_SOLD]: {
        category: (0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).BS_REPORTED,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Reported Cost of Goods Sold",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_COST_OF_GOODS_SOLD
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_GROSS_MARGIN]: {
        category: (0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).BS_REPORTED,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Reported Gross Margin",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_GROSS_MARGIN
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_TOTAL_OPERATING_EXPENSES]: {
        category: (0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).IS_REPORTED,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Reported Total Operating Expenses",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_TOTAL_OPERATING_EXPENSES
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_EBITDA]: {
        category: (0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).IS_REPORTED,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
        name: "Reported EBITDA",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).REPORTED_EBITDA
    },
    [(0, $361aa3de286372f2$export$2160950bfd2fb6de).EXCLUDED_UNKNOWN]: {
        category: (0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).EXCLUDED,
        statementType: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET,
        name: "Excluded Unknown",
        code: (0, $361aa3de286372f2$export$2160950bfd2fb6de).EXCLUDED_UNKNOWN
    }
};
const $af64889d1af19aba$export$621b6c979bc09b48 = "#FF6B6B";
const $af64889d1af19aba$export$2cfe553ad05937fe = "#FFFFFF";
const $af64889d1af19aba$export$bacd5e8afbc6aa95 = "#08BDBA";
const $af64889d1af19aba$export$5bb7312784dcaccc = "#DFBF03";
const $af64889d1af19aba$export$dc7ec77a97e8f158 = "#4A66F4";
const $af64889d1af19aba$export$8d746a82844776bd = "#AEC3FC";
const $af64889d1af19aba$export$fb74f092e278e5ba = "#FBBF24";
const $af64889d1af19aba$export$79bedfc8ee400457 = "#10B981";
const $af64889d1af19aba$export$4f2679fcccfcea6f = "#DA348F";
const $af64889d1af19aba$export$e3b37d562bc003da = "#28A138";
const $af64889d1af19aba$export$878d0665e7548ed6 = "#F9a43f";
const $af64889d1af19aba$export$f4e61a459c669983 = "#B215DA";
const $af64889d1af19aba$export$c40eb1dced6d2957 = {
    [(0, $361aa3de286372f2$export$a88a0750c5292665).REVENUES]: {
        color: $af64889d1af19aba$export$bacd5e8afbc6aa95,
        name: "Revenues"
    },
    [(0, $361aa3de286372f2$export$a88a0750c5292665).EXPENSES]: {
        color: $af64889d1af19aba$export$5bb7312784dcaccc,
        name: "Expenses"
    },
    [(0, $361aa3de286372f2$export$a88a0750c5292665).INVESTMENTS]: {
        color: $af64889d1af19aba$export$dc7ec77a97e8f158,
        name: "Investments"
    },
    [(0, $361aa3de286372f2$export$a88a0750c5292665).BOOKINGS]: {
        color: $af64889d1af19aba$export$8d746a82844776bd,
        name: "Bookings"
    },
    [(0, $361aa3de286372f2$export$a88a0750c5292665).GROSS_CASHFLOWS]: {
        color: $af64889d1af19aba$export$fb74f092e278e5ba,
        name: "Gross Cashflows"
    },
    [(0, $361aa3de286372f2$export$a88a0750c5292665).OTHER_INCOME_EXPENSE_NET]: {
        color: $af64889d1af19aba$export$79bedfc8ee400457,
        name: "Other Income & Expense"
    },
    [(0, $361aa3de286372f2$export$a88a0750c5292665).FINANCING]: {
        color: $af64889d1af19aba$export$4f2679fcccfcea6f,
        name: "Financing"
    },
    [(0, $361aa3de286372f2$export$b084e5bf607d8178).EQUITY]: {
        color: $af64889d1af19aba$export$e3b37d562bc003da,
        name: "Equity"
    },
    [(0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS]: {
        color: $af64889d1af19aba$export$878d0665e7548ed6,
        name: "Assets"
    },
    [(0, $361aa3de286372f2$export$b084e5bf607d8178).LIABILITIES]: {
        color: $af64889d1af19aba$export$f4e61a459c669983,
        name: "Liabilities"
    },
    [(0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).IS_REPORTED]: {
        color: $af64889d1af19aba$export$2cfe553ad05937fe,
        name: "Reported (IS)"
    },
    [(0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).BS_REPORTED]: {
        color: $af64889d1af19aba$export$2cfe553ad05937fe,
        name: "Reported (BS)"
    },
    [(0, $361aa3de286372f2$export$b62f1bc6ce6ce89d).EXCLUDED]: {
        color: $af64889d1af19aba$export$621b6c979bc09b48,
        name: "Excluded"
    }
};



var $9QePP = parcelRequire("9QePP");
function $5c7a40c8699246d7$export$a6969ac3a09996f1({ accountId: accountId }) {
    const { data: account, isLoading: isLoading } = (0, $7Y7Q4.useApiQuery)((0, $75f146eb90ff0682$export$4f9234baf34abd0), {
        params: {
            accountId: accountId
        }
    });
    if (!account && isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("h-10 w-full animate-pulse rounded-xl bg-slate-800")
    });
    if (!account) return null;
    const taxonomy = (0, $af64889d1af19aba$export$eb904f93b8d08cc1)[account.label];
    const color = taxonomy?.color || "#10B981";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "heading-m mb-1 mt-3",
                children: "Account"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("text-color body-s", "flex  items-center gap-3 rounded-lg", " bg-transparent"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "size-2 shrink-0 rounded-full",
                        style: {
                            backgroundColor: color
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "body-s text-left",
                        children: [
                            account.name,
                            " - ",
                            taxonomy?.name || account.label
                        ]
                    })
                ]
            })
        ]
    });
}




var $r2uF6 = parcelRequire("r2uF6");
var $032deecb0f4a84f7$export$e9d9376124133876;
(function(LocalStorageKey) {
    LocalStorageKey["Labeling"] = "hum-labeling";
    LocalStorageKey["MetricLab"] = "hum-metric-lab";
})($032deecb0f4a84f7$export$e9d9376124133876 || ($032deecb0f4a84f7$export$e9d9376124133876 = {}));
const $032deecb0f4a84f7$export$d3720feff416e85b = (key)=>{
    const item = localStorage.getItem(key + "-" + "production");
    if (!item) return null;
    try {
        return JSON.parse(item);
    } catch  {
        return null;
    }
};
const $032deecb0f4a84f7$export$1f73f60bdb811cb1 = (key, value)=>{
    localStorage.setItem(key + "-" + "production", JSON.stringify(value));
};
const $032deecb0f4a84f7$export$c12b7b0e1d99a309 = (key)=>{
    localStorage.removeItem(key + "-" + "production");
};


const $fa5d3143bb23a04a$export$81f196b73601ea1 = (0, $r2uF6.atom)((0, $032deecb0f4a84f7$export$d3720feff416e85b)((0, $032deecb0f4a84f7$export$e9d9376124133876).MetricLab)?.metricStack || []);
const $fa5d3143bb23a04a$export$e0d905d9710176e8 = (0, $r2uF6.atom)(null);



var $r2uF6 = parcelRequire("r2uF6");

function $a8ddf7c96ebce2a1$export$ea5f24ed7caf9655({ metric: metric }) {
    const setRightDrawerOpen = (0, $r2uF6.useSetAtom)((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae));
    const setSelectedPeriod = (0, $r2uF6.useSetAtom)((0, $fa5d3143bb23a04a$export$e0d905d9710176e8));
    // Find the first value with metadata (clickable value)
    const firstClickableRef = (0, $acw62.useMemo)(()=>{
        const firstWithMeta = metric.values.find((v)=>v.meta);
        return firstWithMeta?.ref || "$0";
    }, [
        metric.values
    ]);
    const [selectedRef, setSelectedRef] = (0, $acw62.useState)(firstClickableRef);
    // Reset selection to first value when metric changes
    (0, $acw62.useEffect)(()=>{
        setSelectedRef(firstClickableRef);
    }, [
        metric,
        firstClickableRef
    ]);
    const selectedValue = metric.values.find((value)=>value.ref === selectedRef);
    const fileId = selectedValue?.meta?.dataAssetId;
    const accountId = selectedValue?.meta?.accountId;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mt-1 flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $389baf3585bd1c84$export$59ab17f6e6d50c83), {
                metric: metric,
                onValueClick: (value)=>{
                    console.log(value);
                    setSelectedRef(value.ref);
                },
                selectedRef: selectedRef
            }),
            accountId && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5c7a40c8699246d7$export$a6969ac3a09996f1), {
                accountId: accountId
            }),
            fileId && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd649a13364bf2d5$export$185e80fa08dae04b), {
                fileId: fileId,
                onSelect: ()=>{
                    setSelectedPeriod(null);
                    setRightDrawerOpen(false);
                }
            })
        ]
    });
}



var $gngdn = parcelRequire("gngdn");

function $7b64416fd850403b$var$formatPeriodForLineage(period) {
    const quarterMatch = period.match(/(\d{4})-Q(\d)/);
    if (quarterMatch) {
        const year = quarterMatch[1];
        const quarter = quarterMatch[2];
        return `Q${quarter}-${year}`;
    }
    if (period.includes("<")) return period.split(/<\d+>/).map((date)=>date.split("-").reverse().join("-")).join(" - ");
    const monthMatch = period.match(/^(\d{4})-(\d{2})$/);
    if (monthMatch) {
        const year = monthMatch[1];
        const month = monthMatch[2];
        return `${month}-${year}`;
    }
    const date = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(period);
    if (date.isValid()) return date.format("MM-YYYY");
    return period;
}
function $7b64416fd850403b$var$EmptyStateCard({ heading: heading, body: body }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("p-4", "flex flex-col", "gap-4 rounded"),
        style: {
            backgroundColor: "#2E3849"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "heading-s",
                children: heading
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "body-s",
                children: body
            })
        ]
    });
}
function $7b64416fd850403b$export$fa58e0cac4d5a84c({ metric: metric, period: period, title: title }) {
    const setAIMContextView = (0, $r2uF6.useSetAtom)((0, $57f1ca4385a7301a$export$c65e5de3b3a2e247));
    const parsedMetric = (0, $acw62.useMemo)(()=>{
        if (!metric?.lineagedValues) return null;
        const lineagedValues = metric.lineagedValues;
        if (lineagedValues.length === 0) return null;
        const matchedPeriod = lineagedValues.find((pm)=>pm.period === period);
        return matchedPeriod || null;
    }, [
        metric,
        period
    ]);
    if (!metric) return null;
    const hasLineageData = metric?.lineagedValues && Array.isArray(metric.lineagedValues) && metric.lineagedValues.length > 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("px-6", "custom-scrollbar absolute inset-0 flex min-h-0 flex-col overflow-hidden"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "sticky my-4 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3398e3e074fa037e$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            setAIMContextView(null);
                        }
                    }),
                    !hasLineageData && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: (0, $9QePP.default)("ui-label", "mb-2 w-fit rounded-full px-3 py-1"),
                        style: {
                            backgroundColor: "#E2E8F0",
                            color: "#0F172A"
                        },
                        children: "Coming soon"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        className: "pageheading ",
                        children: [
                            title,
                            ` \u{2014} `,
                            period === "popChange" ? "% Change" : null,
                            period !== "popChange" && $7b64416fd850403b$var$formatPeriodForLineage(parsedMetric?.period || period)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "custom-scrollbar hide-scrollbar overflow-y-scroll",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col gap-4",
                    children: [
                        metric && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a82edfdfe4a6d1b$export$7a39fc3f811ab806), {
                            metric: metric
                        }),
                        hasLineageData && parsedMetric ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8ddf7c96ebce2a1$export$ea5f24ed7caf9655), {
                            metric: parsedMetric
                        }) : !hasLineageData ? /*#__PURE__*/ (0, $ayMG0.jsx)($7b64416fd850403b$var$EmptyStateCard, {
                            heading: "The lineage view feature is not supported in the current version.",
                            body: "We're still working on this, check back soon for the full experience!"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)($7b64416fd850403b$var$EmptyStateCard, {
                            heading: "Data for this field is missing or unavailable.",
                            body: "Please contact your admin or company representative for more information"
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $gxPgh = parcelRequire("gxPgh");

var $acw62 = parcelRequire("acw62");

var $jIDNV = parcelRequire("jIDNV");


var $9QePP = parcelRequire("9QePP");




var $gngdn = parcelRequire("gngdn");

var $r2uF6 = parcelRequire("r2uF6");

(0, $5b7ccabde48fae90$export$91e2bbffdbb3852c).setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-090325}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Hum_Capital}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{hum-service}_only_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{hum-service}_need_to_be_licensed___{hum-service}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{19_June_2026}____[v3]_[0102]_MTc4MTgyMzYwMDAwMA==5aab76dc07cc09b0c8e7eab9ba75a314");
(0, $jIDNV.ModuleRegistry).registerModules([
    (0, $jIDNV.AllCommunityModule),
    (0, $5b7ccabde48fae90$export$76a316c8c2f3bc28)
]);
function $bb30498a6607c065$export$ce1fb739a2eec5b9({ metric: metric, title: title }) {
    const showDataSources = (0, $r2uF6.useAtomValue)((0, $e8aa26b1ef42f359$export$4bba709a6a23ef4d));
    const label = (0, $acw62.useMemo)(()=>{
        return metric?.info?.derived?.label || null;
    }, [
        metric?.info
    ]);
    const isRecurringPayment = (0, $acw62.useMemo)(()=>{
        return label === (0, $eb67e7ba0742cb25$export$c5b1d99d27e4978d).DEAL_RECURRING_PAYMENT;
    }, [
        label
    ]);
    const currentPeriodRecurringPayment = metric?.values?.find((item)=>item.period === (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(new Date()).format("YYYY-MM"));
    const gridRef = (0, $acw62.useRef)(null);
    const currentPeriodRecurringPaymentRef = (0, $acw62.useRef)(null);
    const drawerContainerRef = (0, $acw62.useRef)(null);
    const columnDefs = (0, $acw62.useMemo)(()=>{
        return [
            {
                field: "period",
                resizable: false,
                flex: 0,
                wrapText: true,
                autoHeight: true,
                cellRenderer: ({ data: data })=>{
                    return isRecurringPayment && data?.period === currentPeriodRecurringPayment?.period ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "body-s font-bold",
                        ref: currentPeriodRecurringPaymentRef,
                        children: data?.period || ""
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "body-s",
                        children: data?.period || ""
                    });
                }
            },
            {
                field: "value",
                resizable: false,
                pinned: "right",
                flex: 1,
                wrapText: true,
                autoHeight: true,
                cellRenderer: ({ data: data })=>{
                    const displayValue = data?.formattedValue ?? data?.value ?? "";
                    return isRecurringPayment ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "body-s",
                        dangerouslySetInnerHTML: {
                            __html: displayValue
                        }
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "body-s",
                        children: displayValue
                    });
                }
            }
        ];
    }, []);
    const statusBar = (0, $acw62.useMemo)(()=>{
        return {
            statusPanels: [
                {
                    statusPanel: "agAggregationComponent",
                    statusPanelParams: {
                        aggFuncs: [
                            "avg",
                            "sum"
                        ]
                    },
                    align: "right"
                }
            ]
        };
    }, []);
    const rowData = (0, $acw62.useMemo)(()=>{
        if (!metric?.values) return [];
        const filteredData = metric.values.filter((item)=>item.value !== null && item.value !== undefined).sort((a, b)=>a.period.localeCompare(b.period)).reverse();
        if (isRecurringPayment) return filteredData.map((item)=>{
            const formattedValue = item.formattedValue || "";
            if (typeof formattedValue === "string" && formattedValue.includes("(")) {
                const parts = formattedValue.split("(");
                const mainValue = parts[0].trim();
                const detailValue = `(${parts.slice(1).join("(")}`;
                return {
                    ...item,
                    formattedValue: `${mainValue} 
                        <br />${detailValue}`
                };
            }
            return item;
        });
        return filteredData;
    }, [
        metric,
        isRecurringPayment
    ]);
    const descriptionText = (0, $acw62.useMemo)(()=>{
        return metric?.description?.description || null;
    }, [
        metric?.description
    ]);
    const metricName = (0, $acw62.useMemo)(()=>{
        return metric?.description?.name || null;
    }, [
        metric?.description
    ]);
    const resamplingMethod = (0, $acw62.useMemo)(()=>{
        return metric?.description?.resamplingMethod || null;
    }, [
        metric?.description
    ]);
    const fieldType = (0, $acw62.useMemo)(()=>{
        return metric?.description?.fieldType || null;
    }, [
        metric?.description
    ]);
    const localLabel = (0, $acw62.useMemo)(()=>{
        return metric?.info?.derived?.localLabel || null;
    }, [
        metric?.info
    ]);
    const asOfDate = (0, $acw62.useMemo)(()=>{
        const dateString = metric?.info?.derived?.asOfDate;
        if (!dateString) return null;
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric"
            });
        } catch  {
            return null;
        }
    }, [
        metric?.info
    ]);
    const hasData = rowData.length > 0;
    const scrollToCurrentPeriod = ()=>{
        if (isRecurringPayment && currentPeriodRecurringPayment) setTimeout(()=>{
            const rowIndex = rowData.findIndex((item)=>item.period === currentPeriodRecurringPayment.period);
            if (rowIndex !== -1 && currentPeriodRecurringPaymentRef.current) currentPeriodRecurringPaymentRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }, 200);
        else setTimeout(()=>{
            drawerContainerRef.current?.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }, 200);
    };
    const handleFirstDataRendered = ()=>{
        scrollToCurrentPeriod();
    };
    const handleModelUpdated = ()=>{
        scrollToCurrentPeriod();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("bg-default", "flex size-full flex-col gap-4 overflow-auto"),
        ref: drawerContainerRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "pt-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3398e3e074fa037e$export$2e2bcd8739ae039), {
                    label: "Close",
                    iconDirection: "right"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "size-full",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "pageheading mb-1",
                        children: title
                    }),
                    metricName && metricName !== title && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "subdued body-micro mb-2",
                        children: metricName
                    }),
                    asOfDate && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "subdued body-micro mb-1",
                        children: [
                            "As of ",
                            asOfDate
                        ]
                    }),
                    showDataSources && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            resamplingMethod && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "subdued body-micro mb-1",
                                children: [
                                    "Resampling: ",
                                    resamplingMethod
                                ]
                            }),
                            fieldType && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "subdued body-micro mb-1",
                                children: [
                                    "Field type: ",
                                    fieldType
                                ]
                            }),
                            label && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "subdued body-micro mb-1",
                                children: [
                                    "Label: ",
                                    label
                                ]
                            }),
                            localLabel && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "subdued body-micro mb-1",
                                children: [
                                    "Local label: ",
                                    localLabel
                                ]
                            })
                        ]
                    }),
                    descriptionText && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "subdued mb-2 font-[300] italic",
                        children: descriptionText
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt-6 size-full",
                        children: hasData ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gxPgh.AgGridReact), {
                            ref: gridRef,
                            theme: (0, $a2756431b51c61a4$export$c0aca059b20b3008),
                            rowData: rowData,
                            columnDefs: columnDefs,
                            statusBar: statusBar,
                            domLayout: "autoHeight",
                            onFirstDataRendered: handleFirstDataRendered,
                            onModelUpdated: handleModelUpdated
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex items-center justify-center py-12",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "subdued body-s",
                                children: "Data not available"
                            })
                        })
                    })
                ]
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $r2uF6 = parcelRequire("r2uF6");


var $3djtJ = parcelRequire("3djtJ");



const $2ba58771a847c237$var$DATA_SOURCES = [
    {
        key: (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_API,
        label: "Finance API",
        color: "bg-blue-500",
        textColor: "text-blue-500"
    },
    {
        key: (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).LEGACY_BACKEND,
        label: "Legacy Backend",
        color: "bg-cyan-500",
        textColor: "text-cyan-500"
    },
    {
        key: (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).SFDC,
        label: "SFDC",
        color: "bg-green-500",
        textColor: "text-green-500"
    },
    {
        key: (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).FINANCE_LAB,
        label: "Finance Lab",
        color: "bg-purple-500",
        textColor: "text-purple-500"
    },
    {
        key: (0, $3ed9e5cde76bd4e1$export$accd73d198d77d2f).MEMO_TEXT,
        label: "LLM Web API",
        color: "bg-orange-500",
        textColor: "text-orange-500"
    }
];
function $2ba58771a847c237$export$290806b1b4f6cb0e() {
    const [showDataSources, setShowDataSources] = (0, $r2uF6.useAtom)((0, $e8aa26b1ef42f359$export$4bba709a6a23ef4d));
    const setAIMContextView = (0, $r2uF6.useSetAtom)((0, $57f1ca4385a7301a$export$c65e5de3b3a2e247));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("bg-default", "flex size-full flex-col gap-6 overflow-auto p-4"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "pt-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3398e3e074fa037e$export$2e2bcd8739ae039), {
                    label: "Close",
                    iconDirection: "right",
                    onClick: ()=>{
                        setAIMContextView(null);
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "size-full",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: (0, $9QePP.default)("pageheading mb-4"),
                        children: "Data Sources"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: (0, $9QePP.default)("mb-6 flex items-center justify-between"),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: (0, $9QePP.default)("flex flex-col gap-1"),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: (0, $9QePP.default)("text-sm font-semibold tracking-wide"),
                                        children: "Show Data Sources"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: (0, $9QePP.default)("subdued text-xs"),
                                        children: "Display colored indicators on metrics"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3djtJ.Toggle), {
                                checked: showDataSources,
                                onChange: setShowDataSources
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: (0, $9QePP.default)("flex flex-col gap-3"),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: (0, $9QePP.default)("text-sm font-semibold"),
                                children: "Available Sources"
                            }),
                            $2ba58771a847c237$var$DATA_SOURCES.map((source)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: (0, $9QePP.default)("flex items-center gap-3 rounded-lg p-3", "bg-slate-800"),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: (0, $9QePP.default)("size-4 rounded-full", source.color)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: (0, $9QePP.default)("body-s font-medium"),
                                            children: source.label
                                        })
                                    ]
                                }, source.key))
                        ]
                    })
                ]
            })
        ]
    });
}


function $f5093540fb5e627d$export$79184c6d9267fa41() {
    const AIMContextView = (0, $r2uF6.useAtomValue)((0, $57f1ca4385a7301a$export$c65e5de3b3a2e247));
    if (AIMContextView?.type === (0, $0e9c1faaf8e0eb7e$export$88fa5c7cfbd4d210).DATA_SOURCES_SETTINGS) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ba58771a847c237$export$290806b1b4f6cb0e), {});
    if (AIMContextView?.type === (0, $0e9c1faaf8e0eb7e$export$88fa5c7cfbd4d210).DELTA_LINEAGE) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22a552b8c722c3a2$export$4b65d6703406e4c0), {
        ...AIMContextView.props
    });
    if (AIMContextView?.type === (0, $0e9c1faaf8e0eb7e$export$88fa5c7cfbd4d210).INVESTMENT_CRITERIA) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8732a26985c5f38$export$6d6c9a84013d9898), {});
    if (AIMContextView?.type === (0, $0e9c1faaf8e0eb7e$export$88fa5c7cfbd4d210).VALUE_LINEAGE) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7b64416fd850403b$export$fa58e0cac4d5a84c), {
        ...AIMContextView
    });
    if (AIMContextView?.type === (0, $0e9c1faaf8e0eb7e$export$88fa5c7cfbd4d210).LABS_LINEAGE) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb30498a6607c065$export$ce1fb739a2eec5b9), {
        ...AIMContextView
    });
    return null;
}


function $1307b7c533badf54$export$2e2bcd8739ae039() {
    const [showCompanyList] = (0, $r2uF6.useAtom)((0, $9b7b211c4c2184d7$export$2627579a5e93fc70));
    const drawerIsOpen = (0, $r2uF6.useAtomValue)((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae));
    const rightDrawerSize = (0, $r2uF6.useAtomValue)((0, $30c17e6838b1ddb3$export$77306c2481da7c28));
    const company = (0, $cMZ0q.useCompany)();
    if (!company.company) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
        fullScreen: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex size-full",
        children: [
            !showCompanyList && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d137961520e2401$export$26c4ec9456bef7c4), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $676dc7524d193e04$export$36b59815eb65b3eb), {})
            }),
            drawerIsOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fff2b4a85aca8f0e$export$40e2914dc29c2bf9), {
                size: rightDrawerSize,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5093540fb5e627d$export$79184c6d9267fa41), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8bf6d8656b8823a4$export$2e2bcd8739ae039), {})
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $5mL0X = parcelRequire("5mL0X");

var $aphAM = parcelRequire("aphAM");


var $r2uF6 = parcelRequire("r2uF6");
const $bb1652d8df8d60e6$export$c1163e0d32f18182 = (0, $r2uF6.atom)(true);
function $bb1652d8df8d60e6$export$8f4d5fd934d52710() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5mL0X.LayoutGroup), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d137961520e2401$export$26c4ec9456bef7c4), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "deal list here"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Outlet), {})
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");



var $r2uF6 = parcelRequire("r2uF6");



var $lgOhz = parcelRequire("lgOhz");
parcelRequire("UXGeS");
var $7Y7Q4 = parcelRequire("7Y7Q4");

var $9QePP = parcelRequire("9QePP");
parcelRequire("2bFYF");
var $fp4OM = parcelRequire("fp4OM");

var $iIDkB = parcelRequire("iIDkB");
const $448b5d6ea569459c$var$showOpportunitiesListAtom = (0, $r2uF6.atom)(true);
function $448b5d6ea569459c$export$63a20aa6918bbd3e() {
    const [showCompanyList] = (0, $r2uF6.useAtom)((0, $9b7b211c4c2184d7$export$2627579a5e93fc70));
    const [showOpportunitiesList, setShowOpportunitiesList] = (0, $r2uF6.useAtom)($448b5d6ea569459c$var$showOpportunitiesListAtom);
    const sfdcDataV2 = (0, $7Y7Q4.useApiQuery)((0, $lgOhz.getSFDCDataV2));
    const router = (0, $fp4OM.useRouter)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            !showCompanyList && showOpportunitiesList && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d137961520e2401$export$26c4ec9456bef7c4), {
                children: sfdcDataV2.data?.sfdcOpportunities?.map((opportunity)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, $9QePP.default)("w-full cursor-pointer select-none rounded-md p-4", "body-s text-left", router.params.opportunityId === opportunity.sfdcOpportunityId ? "text-default bg-slate-700" : "subdued hover:bg-slate-700 hover:text-slate-200", "transition-colors duration-150 ease-in-out"),
                        onClick: ()=>{
                            router.navigate(`/beta/companies/${router.params.companyId}/opportunities/${opportunity.sfdcOpportunityId}`);
                            setShowOpportunitiesList(false);
                        },
                        role: "button",
                        tabIndex: 0,
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                router.navigate(`/beta/companies/${router.params.companyId}/opportunities/${opportunity.sfdcOpportunityId}`);
                                setShowOpportunitiesList(false);
                            }
                        },
                        children: opportunity.sfdcOpportunityName
                    }, opportunity.sfdcOpportunityId))
            }),
            !showCompanyList && !showOpportunitiesList && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d137961520e2401$export$26c4ec9456bef7c4), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-6 flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iIDkB.default), {
                                    className: "size-4 text-gray-400"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "ui-element subdued cursor-pointer",
                                    onClick: ()=>setShowOpportunitiesList(true),
                                    children: "Opportunities"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $676dc7524d193e04$export$36b59815eb65b3eb), {})
                    ]
                })
            }),
            router.params.opportunityId && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8bf6d8656b8823a4$export$2e2bcd8739ae039), {
                opportunityId: router.params.opportunityId
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");



var $r2uF6 = parcelRequire("r2uF6");

var $9QePP = parcelRequire("9QePP");

var $fRJCp = parcelRequire("fRJCp");


var $ayMG0 = parcelRequire("ayMG0");

var $jIDNV = parcelRequire("jIDNV");


var $gxPgh = parcelRequire("gxPgh");

var $acw62 = parcelRequire("acw62");

var $r2uF6 = parcelRequire("r2uF6");

var $r2uF6 = parcelRequire("r2uF6");
const $175863902df2ee1a$export$4d2c75fe8b80fe70 = (0, $r2uF6.atom)({});
const $175863902df2ee1a$export$a96d76569fa61ec4 = (0, $r2uF6.atom)((get)=>{
    const { selectedDraftId: selectedDraftId } = get($175863902df2ee1a$export$4d2c75fe8b80fe70);
    return !selectedDraftId;
});
const $175863902df2ee1a$export$380f8a5d1313e761 = (0, $r2uF6.atom)({
    isLoading: true,
    isError: false,
    data: null
});



var $r2uF6 = parcelRequire("r2uF6");

const $3e16d0e17c6c7886$export$987c78fb3f57ee82 = (0, $r2uF6.atom)(null);
const $3e16d0e17c6c7886$export$5f8d21c57c3fb992 = (0, $r2uF6.atom)((get)=>get($3e16d0e17c6c7886$export$987c78fb3f57ee82), (get, set, newValue)=>{
    if (!newValue) {
        set((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae), false);
        set($3e16d0e17c6c7886$export$987c78fb3f57ee82, newValue);
    } else {
        set($3e16d0e17c6c7886$export$987c78fb3f57ee82, newValue);
        set((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae), true);
    }
});



var $r2uF6 = parcelRequire("r2uF6");
var $156754416c8f457d$export$ad9db10db9173ca8;
(function(DraftStatus) {
    DraftStatus["COMMITTED"] = "committed";
    DraftStatus["IN_PROGRESS"] = "in_progress";
})($156754416c8f457d$export$ad9db10db9173ca8 || ($156754416c8f457d$export$ad9db10db9173ca8 = {}));
var $156754416c8f457d$export$a16002ff4149470e;
(function(AccountHintType) {
    AccountHintType["EXISTING"] = "existing";
    AccountHintType["NEW"] = "new";
})($156754416c8f457d$export$a16002ff4149470e || ($156754416c8f457d$export$a16002ff4149470e = {}));
var $156754416c8f457d$export$96abc37e495202c4;
(function(ValidationFormula) {
    ValidationFormula["COST_OF_GOODS_SOLD"] = "cost_of_goods_sold";
    ValidationFormula["TOTAL_OP_EX"] = "total_operating_expenses";
    ValidationFormula["EBITDA"] = "ebitda";
    ValidationFormula["REVENUE"] = "revenue";
    ValidationFormula["CURRENT_ASSETS"] = "current_assets";
    ValidationFormula["NONCURRENT_ASSETS"] = "noncurrent_assets";
    ValidationFormula["CURRENT_LIABILITIES"] = "current_liabilities";
    ValidationFormula["NONCURRENT_LIABILITIES"] = "noncurrent_liabilities";
    ValidationFormula["TOTAL_ASSETS"] = "total_assets";
    ValidationFormula["TOTAL_LIABILITIES"] = "total_liabilities";
    ValidationFormula["TOTAL_EQUITY"] = "total_equity";
    ValidationFormula["BALANCE_SHEET_BALANCE"] = "balance_sheet_balance";
    ValidationFormula["INCOME_STATEMENT_BALANCE"] = "income_statement_balance";
})($156754416c8f457d$export$96abc37e495202c4 || ($156754416c8f457d$export$96abc37e495202c4 = {}));





var $r2uF6 = parcelRequire("r2uF6");

var $a9fafe23bcb6020a$export$1e3fd12e446214f5;
(function(AccountAppearanceState) {
    AccountAppearanceState["DISABLED"] = "disabled";
    AccountAppearanceState["TENTATIVE"] = "tentative";
    AccountAppearanceState["DEFAULT"] = "default";
})($a9fafe23bcb6020a$export$1e3fd12e446214f5 || ($a9fafe23bcb6020a$export$1e3fd12e446214f5 = {}));
var $a9fafe23bcb6020a$export$23ce6754e6e099fa;
(function(FileStatusOptions) {
    FileStatusOptions["UNLABELED"] = "unlabeled";
    FileStatusOptions["LABELED"] = "labeled";
    FileStatusOptions["CLEANED"] = "cleaned";
    FileStatusOptions["ALL"] = "all";
})($a9fafe23bcb6020a$export$23ce6754e6e099fa || ($a9fafe23bcb6020a$export$23ce6754e6e099fa = {}));
const $a9fafe23bcb6020a$export$775afd4b12f86320 = {
    [(0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET]: "Balance sheet",
    [(0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT]: "Income statement",
    [(0, $f19d5eec019b83cc$export$41e58614ac70f6e0).MIXED]: "Mixed",
    all: "All statements"
};





function $e6bca67f7602658c$export$aa6f478c8118b808(isCodat, codatAccountId) {
    return isCodat && !codatAccountId;
}
function $e6bca67f7602658c$export$b465da9283c98d42(statementTypes) {
    if (statementTypes.includes((0, $f19d5eec019b83cc$export$41e58614ac70f6e0).MIXED)) return Object.values((0, $af64889d1af19aba$export$eb904f93b8d08cc1)).map((account)=>account.category);
    return Object.values((0, $af64889d1af19aba$export$eb904f93b8d08cc1)).filter((account)=>statementTypes.includes(account.statementType)).map((account)=>account.category);
}
function $e6bca67f7602658c$export$3dd21c4e644d75ee(name) {
    const match = name.match(/raw_\d{14}_(.+)$/);
    return match ? match[1] : name;
}



var $r2uF6 = parcelRequire("r2uF6");






const $540fa3f25212c24e$export$224f20c309c1f113 = (0, $r2uF6.atom)({
    isLoading: false,
    isError: false,
    data: null
});
const $540fa3f25212c24e$export$b0cbc03b849c7b1f = (0, $r2uF6.atom)({
    isLoading: false,
    isError: false,
    data: null
});
const $540fa3f25212c24e$export$a501548c14b6cdc7 = (0, $r2uF6.atom)({
    isLoading: false,
    isError: false,
    data: []
});
const $540fa3f25212c24e$export$4a2c69def00f1863 = (0, $r2uF6.atom)({
    isLoading: false,
    isError: false,
    data: []
});
const $540fa3f25212c24e$var$baseAccountApplicationAtom = (0, $r2uF6.atom)({});
const $540fa3f25212c24e$export$af3bfe24cf5eb5a6 = (0, $r2uF6.atom)((get)=>get($540fa3f25212c24e$var$baseAccountApplicationAtom), (get, set, value)=>{
    if (value === null) set($540fa3f25212c24e$var$baseAccountApplicationAtom, {});
    else set($540fa3f25212c24e$var$baseAccountApplicationAtom, (prev)=>({
            ...prev,
            [value.rowHeader]: value.accountId
        }));
});
const $540fa3f25212c24e$export$f98cfc4f0fa57dd0 = (0, $r2uF6.atom)((get)=>{
    const draft = get($540fa3f25212c24e$export$b0cbc03b849c7b1f);
    const accounts = get((0, $9bf0cfccc28125c5$export$eb049f2950249542));
    const accountApplication = get($540fa3f25212c24e$export$af3bfe24cf5eb5a6);
    if (!draft.data) return null;
    if (!accountApplication) return draft.data;
    const rows = {};
    Object.entries(draft.data.rows).forEach(([rowId, row])=>{
        if (accountApplication[rowId]) {
            const appliedAccount = accounts[accountApplication[rowId]];
            if (!appliedAccount) {
                rows[rowId] = row;
                return;
            }
            rows[rowId] = {
                ...row,
                account: {
                    type: appliedAccount.type,
                    accountId: appliedAccount.type === (0, $156754416c8f457d$export$a16002ff4149470e).EXISTING ? appliedAccount.id : undefined,
                    label: appliedAccount.label,
                    accountName: appliedAccount.name,
                    meta: row.account?.meta
                }
            };
        } else rows[rowId] = row;
    });
    return {
        ...draft.data,
        rows: rows
    };
});
const $540fa3f25212c24e$export$6f6480b3b0a87b58 = (0, $r2uF6.atom)((get)=>{
    const draftPreview = get($540fa3f25212c24e$export$224f20c309c1f113);
    const draft = get($540fa3f25212c24e$export$b0cbc03b849c7b1f);
    const updatedDraft = get($540fa3f25212c24e$export$f98cfc4f0fa57dd0);
    const isReadonly = get((0, $175863902df2ee1a$export$a96d76569fa61ec4));
    return isReadonly ? {
        ...draftPreview,
        isLoading: !draft && draftPreview.isLoading
    } : {
        isLoading: !draftPreview && draft.isLoading,
        data: updatedDraft || draft.data || null,
        isError: draft.isError
    };
});
const $540fa3f25212c24e$export$81ce44c05a7605ed = (0, $r2uF6.atom)((get)=>{
    const draft = get($540fa3f25212c24e$export$b0cbc03b849c7b1f);
    const accounts = get((0, $9bf0cfccc28125c5$export$eb049f2950249542));
    const accountApplication = get($540fa3f25212c24e$export$af3bfe24cf5eb5a6);
    if (!draft.data) return null;
    if (!accountApplication) return draft.data;
    const rows = {};
    Object.entries(draft.data.rows).forEach(([rowId, row])=>{
        if (accountApplication[rowId]) {
            const appliedAccount = accounts[accountApplication[rowId]];
            if (appliedAccount) {
                rows[rowId] = rows[rowId] = {
                    ...row,
                    account: {
                        type: appliedAccount.type,
                        accountId: appliedAccount.type === (0, $156754416c8f457d$export$a16002ff4149470e).EXISTING ? appliedAccount.id : undefined,
                        label: appliedAccount.label,
                        accountName: appliedAccount.name,
                        meta: row.account?.meta
                    }
                };
                return;
            }
        }
        rows[rowId] = {
            ...row,
            account: null
        };
    });
    return {
        ...draft.data,
        rows: rows
    };
});
const $540fa3f25212c24e$export$df1af0fca7923243 = (0, $r2uF6.atom)(null, (get, set)=>{
    const draft = get($540fa3f25212c24e$export$b0cbc03b849c7b1f);
    const accountApplication = get($540fa3f25212c24e$export$af3bfe24cf5eb5a6);
    if (!draft.data?.rows) return;
    Object.entries(draft.data.rows).forEach(([rowId, row])=>{
        const isDisabled = (0, $e6bca67f7602658c$export$aa6f478c8118b808)(draft.data?.isCodat ?? false, row.account?.meta?.codatAccountId);
        if (accountApplication[rowId] || isDisabled) return;
        if (row.account?.type !== (0, $156754416c8f457d$export$a16002ff4149470e).EXISTING) return;
        if (!row.account.accountId) return;
        set($540fa3f25212c24e$export$af3bfe24cf5eb5a6, {
            rowHeader: rowId,
            accountId: row.account.accountId
        });
    });
});
const $540fa3f25212c24e$export$79ff6a44530bd375 = (0, $r2uF6.atom)((get)=>{
    const currentDraft = get($540fa3f25212c24e$export$6f6480b3b0a87b58);
    if (!currentDraft.data?.rows) return [];
    const statementTypes = new Set();
    Object.values(currentDraft.data.rows).forEach((row)=>{
        if (!row.account?.label) return;
        const label = row.account.label;
        if (Object.values((0, $361aa3de286372f2$export$6d6abaf64a6e5602)).includes(label)) statementTypes.add((0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT);
        else if (Object.values((0, $361aa3de286372f2$export$844fca46adfd5a0a)).includes(label)) statementTypes.add((0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET);
    });
    return Array.from(statementTypes);
});




const $ebd8595742de66c3$var$baseSelectedRowAtom = (0, $r2uF6.atom)(null);
const $ebd8595742de66c3$export$7770f7cfbd1735b = (0, $r2uF6.atom)((get)=>{
    const selectedRow = get($ebd8595742de66c3$var$baseSelectedRowAtom);
    if (!selectedRow) return null;
    const accountApplication = get((0, $540fa3f25212c24e$export$af3bfe24cf5eb5a6));
    const hasAppliedAccount = !!accountApplication[selectedRow.rowIndex];
    return {
        ...selectedRow,
        hasAppliedAccount: hasAppliedAccount
    };
}, (get, set, newValue)=>{
    set($ebd8595742de66c3$var$baseSelectedRowAtom, newValue);
    if (!newValue) {
        set((0, $3e16d0e17c6c7886$export$5f8d21c57c3fb992), null);
        return;
    }
    if (newValue?.account?.type === (0, $156754416c8f457d$export$a16002ff4149470e).EXISTING) set((0, $3e16d0e17c6c7886$export$5f8d21c57c3fb992), {
        type: "ACCOUNT_SELECTION_LIST"
    });
    else set((0, $3e16d0e17c6c7886$export$5f8d21c57c3fb992), {
        type: "ACCOUNT_SELECTION_NEW"
    });
});
const $ebd8595742de66c3$export$25081f6903755e40 = (0, $r2uF6.atom)(true);
const $ebd8595742de66c3$export$2996d442cf0b1b74 = (0, $r2uF6.atom)(true);
const $ebd8595742de66c3$export$5423b5318b16b3b5 = (0, $r2uF6.atom)(null, (get, set, data)=>{
    const isReadonly = get((0, $175863902df2ee1a$export$a96d76569fa61ec4));
    console.log("rowClicked", data);
    if (isReadonly || data.isDisabled) return;
    if (data.colId !== "accountName" && data.colId !== "label" && data.colId !== "rowHeader") return;
    set($ebd8595742de66c3$export$7770f7cfbd1735b, {
        rowIndex: data.rowIndex,
        account: data.account,
        rowHeader: data.rowHeader
    });
});
const $ebd8595742de66c3$export$f92f0adb5e3b8dfe = (0, $r2uF6.atom)((get)=>{
    const { data: currentDraft } = get((0, $540fa3f25212c24e$export$6f6480b3b0a87b58));
    const accountApplication = get((0, $540fa3f25212c24e$export$af3bfe24cf5eb5a6));
    const selectedRow = get($ebd8595742de66c3$export$7770f7cfbd1735b);
    if (!currentDraft) return [];
    const { isCodat: isCodat, isCleaned: isCleaned } = currentDraft;
    const rowData = Object.entries(currentDraft.rows).map(([rowIndex, row])=>{
        let accountAppearanceState = (0, $a9fafe23bcb6020a$export$1e3fd12e446214f5).DEFAULT;
        const isDisabled = (0, $e6bca67f7602658c$export$aa6f478c8118b808)(isCodat, row.account?.meta?.codatAccountId);
        const userConfirmed = accountApplication[rowIndex];
        if (!userConfirmed) {
            if (isDisabled) accountAppearanceState = (0, $a9fafe23bcb6020a$export$1e3fd12e446214f5).DISABLED;
            else if (isCleaned) accountAppearanceState = (0, $a9fafe23bcb6020a$export$1e3fd12e446214f5).TENTATIVE;
        }
        return {
            ...row,
            rowIndex: rowIndex,
            isHidden: !userConfirmed && !get($ebd8595742de66c3$export$2996d442cf0b1b74),
            isDisabled: accountAppearanceState === (0, $a9fafe23bcb6020a$export$1e3fd12e446214f5).DISABLED,
            isTentative: accountAppearanceState === (0, $a9fafe23bcb6020a$export$1e3fd12e446214f5).TENTATIVE,
            accountAppearanceState: accountAppearanceState,
            isSelected: selectedRow?.rowIndex === rowIndex,
            userConfirmed: userConfirmed
        };
    });
    return rowData;
});




const $9bf0cfccc28125c5$export$3ecbaf68d811c501 = (0, $r2uF6.atom)({
    isLoading: true,
    isError: false,
    data: []
});
const $9bf0cfccc28125c5$export$e51d62da234c4ca7 = (0, $r2uF6.atom)({});
const $9bf0cfccc28125c5$export$ad01cd78faf722c9 = (0, $r2uF6.atom)({});
const $9bf0cfccc28125c5$export$eb049f2950249542 = (0, $r2uF6.atom)((get)=>{
    const accountResponse = get($9bf0cfccc28125c5$export$3ecbaf68d811c501);
    const accountEdits = get($9bf0cfccc28125c5$export$e51d62da234c4ca7);
    const newAccounts = Object.values(get($9bf0cfccc28125c5$export$ad01cd78faf722c9));
    const accounts = (accountResponse.data || []).reduce((acc, account)=>{
        acc[account.id] = {
            id: account.id,
            name: account.accountName,
            label: account.label,
            type: (0, $156754416c8f457d$export$a16002ff4149470e).EXISTING
        };
        return acc;
    }, {});
    Object.values(accounts).forEach((account)=>{
        accounts[account.id] = {
            ...accounts[account.id],
            ...accountEdits[account.id]
        };
    });
    newAccounts.forEach((account)=>{
        accounts[account.id] = account;
    });
    return accounts;
}, (get, set, value)=>{
    if (value.type === (0, $156754416c8f457d$export$a16002ff4149470e).EXISTING) set($9bf0cfccc28125c5$export$e51d62da234c4ca7, (prev)=>({
            ...prev,
            [value.id]: value
        }));
    else set($9bf0cfccc28125c5$export$ad01cd78faf722c9, (prev)=>({
            ...prev,
            [value.id]: value
        }));
});
const $9bf0cfccc28125c5$export$e3f5f7e7495a58c9 = (0, $r2uF6.atom)((get)=>{
    const accounts = get($9bf0cfccc28125c5$export$eb049f2950249542);
    const selectedRow = get((0, $ebd8595742de66c3$export$7770f7cfbd1735b));
    const derivedStatementTypes = get((0, $540fa3f25212c24e$export$79ff6a44530bd375));
    const fn = function(searchTerm) {
        return Object.values(accounts).filter((account)=>{
            const metadata = (0, $af64889d1af19aba$export$eb904f93b8d08cc1)[account.label];
            const term = searchTerm.toLowerCase();
            if (selectedRow?.account?.accountId === account.id) return false;
            return metadata.category.toLowerCase().includes(term) || account.name.toLowerCase().includes(term) || account.label.toLowerCase().includes(term) || metadata.code.toLowerCase().includes(term) || metadata.statementType.toLowerCase().includes(term);
        }).sort((a, b)=>{
            let firstCategory = derivedStatementTypes.includes((0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT) ? (0, $361aa3de286372f2$export$a88a0750c5292665).REVENUES : (0, $361aa3de286372f2$export$b084e5bf607d8178).ASSETS;
            if (selectedRow?.account?.label) firstCategory = (0, $af64889d1af19aba$export$eb904f93b8d08cc1)[selectedRow?.account?.label]?.category;
            const metadataA = (0, $af64889d1af19aba$export$eb904f93b8d08cc1)[a.label];
            const metadataB = (0, $af64889d1af19aba$export$eb904f93b8d08cc1)[b.label];
            const aMatchesFirst = metadataA.category === firstCategory;
            const bMatchesFirst = metadataB.category === firstCategory;
            if (aMatchesFirst && !bMatchesFirst) return -1;
            if (bMatchesFirst && !aMatchesFirst) return 1;
            return metadataA.category.localeCompare(metadataB.category) || metadataA.code.localeCompare(metadataB.code) || metadataA.name.localeCompare(metadataB.name);
        });
    };
    return fn;
});





var $r2uF6 = parcelRequire("r2uF6");



const $c02997182c8770ac$export$49c18d539f773e3 = (0, $r2uF6.atom)((get)=>{
    const accounts = get((0, $9bf0cfccc28125c5$export$eb049f2950249542));
    const tableRows = get((0, $ebd8595742de66c3$export$f92f0adb5e3b8dfe));
    const existingAccounts = Object.values(accounts).filter((account)=>account.type === (0, $156754416c8f457d$export$a16002ff4149470e).EXISTING);
    const fn = (name)=>{
        const rowsWithName = tableRows.filter((row)=>row.userConfirmed && row.account?.accountName === name && row.account?.type === (0, $156754416c8f457d$export$a16002ff4149470e).NEW && !/excluded|reported/.test(row.account?.label || "")).map((row)=>row.rowIndex);
        const existingAccountMatches = existingAccounts.filter((account)=>account.name === name);
        return [
            existingAccountMatches.length > 0 || rowsWithName.length > 0,
            rowsWithName,
            existingAccountMatches.map((account)=>account.id)
        ];
    };
    return fn;
});
const $c02997182c8770ac$export$fd1c089d2a3107a9 = (0, $r2uF6.atom)((get)=>{
    const isNameInUse = get($c02997182c8770ac$export$49c18d539f773e3);
    const fn = (name, ignore)=>{
        const [isInUse, rowsInUse, existingAccountIds] = isNameInUse(name);
        if (!isInUse) return null;
        if (isInUse && existingAccountIds.filter((id)=>id !== ignore?.currentAccountId).length > 0) return "Account name already used in an existing account.";
        const filteredRows = rowsInUse.filter((row)=>row !== ignore?.currentRowIndex);
        if (filteredRows.length > 0) return `Account name already in use in row${filteredRows.length !== 1 ? "s" : ""} ${filteredRows.join(", ")}`;
        return null;
    };
    return fn;
});



var $r2uF6 = parcelRequire("r2uF6");

const $da6866c58be47883$export$c413f16854e508b7 = (0, $r2uF6.atom)((0, $a9fafe23bcb6020a$export$23ce6754e6e099fa).UNLABELED);
const $da6866c58be47883$export$7dbd57354a14102d = (0, $r2uF6.atom)("all");
const $da6866c58be47883$export$44d966b2a77e4b26 = (0, $r2uF6.atom)("connectors");





var $jIDNV = parcelRequire("jIDNV");
const $0356cd652e233c9b$export$e023de5353971026 = (0, $jIDNV.themeQuartz).withPart((0, $jIDNV.colorSchemeDark)).withParams({
    accentColor: "#6B7280",
    backgroundColor: "#1E293B",
    borderColor: "#334155",
    browserColorScheme: "dark",
    fontFamily: {
        googleFont: "Inter"
    },
    foregroundColor: "#FFFFFF",
    headerFontSize: 14,
    headerVerticalPaddingScale: 1,
    rowHoverColor: "#334155",
    rowBorder: {
        color: "#0F172A"
    },
    headerColumnResizeHandleColor: "#475569",
    rowHeight: 42
});



var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $40624589281897c7$var$ArrowUpIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
    }));
}
const $40624589281897c7$var$ForwardRef = $acw62.forwardRef($40624589281897c7$var$ArrowUpIcon);
var $40624589281897c7$export$2e2bcd8739ae039 = $40624589281897c7$var$ForwardRef;



var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");
function $1ea8767bb5f5825a$export$eede428b6aead603(sortFn) {
    const [sort, setSort] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        sortFn(sort);
    }, [
        sort
    ]);
    const progressSort = (0, $acw62.useCallback)(()=>{
        if (sort === "asc") setSort("desc");
        else if (sort === "desc") setSort(null);
        else setSort("asc");
    }, [
        sort
    ]);
    return {
        sort: sort,
        setSort: setSort,
        progressSort: progressSort
    };
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");
function $dd88e2148a16500e$var$EllipsisVerticalIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
    }));
}
const $dd88e2148a16500e$var$ForwardRef = $acw62.forwardRef($dd88e2148a16500e$var$EllipsisVerticalIcon);
var $dd88e2148a16500e$export$2e2bcd8739ae039 = $dd88e2148a16500e$var$ForwardRef;



var $9QePP = parcelRequire("9QePP");
function $725264d17544a9a4$export$869e79d3adc61c17({ children: children }) {
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [menuPosition, setMenuPosition] = (0, $acw62.useState)({
        top: 0,
        left: 0
    });
    const menuRef = (0, $acw62.useRef)(null);
    const buttonRef = (0, $acw62.useRef)(null);
    const toggleMenu = ()=>{
        if (!isOpen && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setMenuPosition({
                top: rect.bottom + 4,
                left: window.innerWidth - rect.right
            });
        }
        setIsOpen(!isOpen);
    };
    (0, $acw62.useEffect)(()=>{
        if (!children) return;
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) setIsOpen(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen,
        children
    ]);
    const dropdownMenu = children && isOpen ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: menuRef,
        className: (0, $9QePP.default)("bg-slate-800", "rounded-lg shadow-400", "custom-scrollbar max-h-[400px] overflow-auto p-2", "fixed z-[10000] mt-1", "min-w-[160px]", "flex flex-col gap-1"),
        style: {
            top: `${menuPosition.top}px`,
            right: `${menuPosition.left}px`
        },
        children: children
    }) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                onClick: toggleMenu,
                ref: buttonRef,
                className: "cursor-pointer",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dd88e2148a16500e$export$2e2bcd8739ae039), {
                    className: "size-5"
                })
            }),
            dropdownMenu && /*#__PURE__*/ (0, $1u0KT.createPortal)(dropdownMenu, document.body)
        ]
    });
}


function $9c5b03f173414fc7$export$efcbfab786023e1a({ children: children, ...props }) {
    const { sort: sort, progressSort: progressSort } = (0, $1ea8767bb5f5825a$export$eede428b6aead603)(props.setSort);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, $9QePP.default)("w-full cursor-pointer", "flex items-center justify-between gap-2"),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    onClick: progressSort,
                    className: "flex-1",
                    children: props.displayName
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap-1",
                    children: [
                        children && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $725264d17544a9a4$export$869e79d3adc61c17), {
                            ...props,
                            children: children
                        }),
                        sort === "asc" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $40624589281897c7$export$2e2bcd8739ae039), {
                            className: "size-4"
                        }),
                        sort === "desc" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f64a4ef9514b684d$export$2e2bcd8739ae039), {
                            className: "size-4"
                        })
                    ]
                })
            ]
        })
    });
}





var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $3d6b28b55b4a30af$export$310d33ba7a8ae542({ onClick: onClick, label: label }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        type: "button",
        onClick: onClick,
        className: (0, $9QePP.default)("flex h-[36px] w-full items-center gap-2 rounded-md px-2 py-1.5", "menu-item cursor-pointer hover:bg-slate-600"),
        role: "menuitem",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "body-micro cursor-pointer",
            children: label
        })
    });
}



var $r2uF6 = parcelRequire("r2uF6");

function $3dc32682e6bca5a7$export$2c94b1bed9b28dd4(props) {
    const [showReadableLabel, setShowReadableLabel] = (0, $r2uF6.useAtom)((0, $ebd8595742de66c3$export$25081f6903755e40));
    const [showLabelHints, setShowLabelHints] = (0, $r2uF6.useAtom)((0, $ebd8595742de66c3$export$2996d442cf0b1b74));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9c5b03f173414fc7$export$efcbfab786023e1a), {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d6b28b55b4a30af$export$310d33ba7a8ae542), {
                onClick: ()=>setShowReadableLabel(!showReadableLabel),
                label: showReadableLabel ? "Show system labels" : "Show readable labels"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d6b28b55b4a30af$export$310d33ba7a8ae542), {
                onClick: ()=>setShowLabelHints(!showLabelHints),
                label: showLabelHints ? "Hide hints" : "Show hints"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
function $15ce03ce9f0f854c$export$31008ffe97c96a49({ dot: dot = false, text: text, color: color, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("flex cursor-pointer items-center gap-2", className),
        children: [
            dot && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    backgroundColor: color
                },
                className: (0, $9QePP.default)("size-2 shrink-0 rounded-full", !color && "bg-gray-400")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "body-s cursor-pointer break-all pr-1",
                children: text
            })
        ]
    });
}



var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");
function $fc1405939c84d0e6$var$SparklesIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
    }));
}
const $fc1405939c84d0e6$var$ForwardRef = $acw62.forwardRef($fc1405939c84d0e6$var$SparklesIcon);
var $fc1405939c84d0e6$export$2e2bcd8739ae039 = $fc1405939c84d0e6$var$ForwardRef;



var $5lq00 = parcelRequire("5lq00");
function $504c29a55da928b3$export$dcfb49240088e87f({ label: label, onClick: onClick, prettify: prettify = true, dot: dot = false, listItem: listItem = false, className: className, recommended: recommended = false, hotkeyNumber: hotkeyNumber }) {
    const command = (0, $acw62.useMemo)(()=>{
        if (!hotkeyNumber || !onClick) return undefined;
        return {
            label: label.name,
            shortcut: {
                key: String(hotkeyNumber),
                mac: `\u{2318}${hotkeyNumber}`,
                windows: `Ctrl+${hotkeyNumber}`
            },
            onClick: ()=>onClick(label.code)
        };
    }, [
        hotkeyNumber,
        label.name,
        label.code,
        onClick
    ]);
    (0, $5lq00.useHotkey)({
        command: command
    });
    const text = prettify ? label.name : label.code;
    const color = label.category ? (0, $af64889d1af19aba$export$c40eb1dced6d2957)[label.category].color : undefined;
    const hotkeyLabel = command ? (0, $5lq00.getShortcutDisplay)(command.shortcut) : null;
    if (listItem) return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
        className: (0, $9QePP.default)("card flex items-start justify-between gap-2", recommended && "border-default mb-2 border", className),
        onClick: ()=>{
            onClick?.(label.code);
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $15ce03ce9f0f854c$export$31008ffe97c96a49), {
                text: text,
                color: color,
                dot: dot
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    recommended && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fc1405939c84d0e6$export$2e2bcd8739ae039), {
                        className: "text-subdued size-4"
                    }),
                    hotkeyLabel && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: (0, $9QePP.default)("bg-gray-500 px-1 py-0.5", "text-bg-default text-slate-800", "body-micro rounded-md"),
                        children: hotkeyLabel
                    })
                ]
            })
        ]
    }, label.name);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        onClick: ()=>onClick?.(label.code),
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $15ce03ce9f0f854c$export$31008ffe97c96a49), {
            text: text,
            color: color,
            dot: dot
        })
    });
}



const $b63413fa6f559e31$export$181cfdc21e4d422 = {
    headerName: "Account Label",
    colId: "label",
    pinned: "left",
    width: 300,
    suppressSizeToFit: true,
    suppressHeaderMenuButton: true,
    sortable: false,
    headerComponentParams: {
        innerHeaderComponent: (0, $3dc32682e6bca5a7$export$2c94b1bed9b28dd4)
    },
    valueGetter: (params)=>{
        return params.data.account?.label || params.data.rowHeader;
    }
};
const $b63413fa6f559e31$export$47a2dc0a2e0ed747 = ({ label: label, showReadableLabel: showReadableLabel, isDisabled: isDisabled, isTentative: isTentative })=>{
    if (!label || isDisabled) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("size-full", isDisabled ? "cursor-default" : "cursor-pointer")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("flex  size-full items-center justify-between", isTentative ? "opacity-50" : "opacity-100"),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $504c29a55da928b3$export$dcfb49240088e87f), {
            className: "w-full",
            label: (0, $af64889d1af19aba$export$eb904f93b8d08cc1)[label],
            prettify: showReadableLabel,
            dot: true
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

const $26ddc59a4e2ea790$export$8ec38466a0f34b95 = {
    headerName: "Account Name",
    colId: "accountName",
    editable: true,
    pinned: "left",
    width: 260,
    suppressSizeToFit: true,
    headerComponentParams: {
        innerHeaderComponent: (0, $9c5b03f173414fc7$export$efcbfab786023e1a)
    },
    suppressHeaderMenuButton: true,
    sortable: false,
    valueGetter: (params)=>{
        return params.data.account?.accountName;
    }
};
const $26ddc59a4e2ea790$export$8776ea034f07c9bb = ({ accountName: accountName, isTentative: isTentative, isDisabled: isDisabled })=>{
    if (!accountName || isDisabled) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("size-full", isDisabled ? "cursor-default" : "cursor-pointer")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("flex  size-full items-center justify-between", isTentative ? "opacity-50" : "opacity-100"),
        children: accountName
    });
};


const $a03a549e3b132929$export$702891ed33000c52 = ({ period: period })=>({
        colId: period,
        field: period,
        valueGetter: (params)=>{
            return params.data.values.find((value)=>value.period === period)?.value;
        },
        valueFormatter: ({ value: value })=>{
            return value ? new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD"
            }).format(value) : "";
        },
        resizable: false,
        sortable: false,
        minWidth: 116,
        suppressHeaderMenuButton: true
    });



var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
const $f26df3d63da95747$export$8040672d6befcaf1 = {
    field: "rowHeader",
    headerName: "Original Line Item",
    colId: "rowHeader",
    minWidth: 260,
    suppressHeaderMenuButton: true,
    sortable: false,
    resizable: false,
    valueGetter: (params)=>{
        return params.data.rowHeader;
    }
};
const $f26df3d63da95747$export$70448c8fc9b547ef = ({ rowHeader: rowHeader, isDisabled: isDisabled })=>{
    if (!rowHeader) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("size-full", isDisabled ? "cursor-default" : "cursor-pointer")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("size-full", !isDisabled ? "opacity-100" : "opacity-50", isDisabled ? "cursor-default" : "cursor-pointer"),
        children: rowHeader
    });
};





(0, $jIDNV.ModuleRegistry).registerModules([
    (0, $jIDNV.AllCommunityModule),
    (0, $5b7ccabde48fae90$export$af7cdc2b9a7c9c3)
]);
function $644b92e8a76d3ba6$export$72e4c5c1c0102f6d() {
    const { selectedFileId: selectedFileId } = (0, $r2uF6.useAtomValue)((0, $175863902df2ee1a$export$4d2c75fe8b80fe70));
    const isReadonly = (0, $r2uF6.useAtomValue)((0, $175863902df2ee1a$export$a96d76569fa61ec4));
    const { isLoading: isLoading, data: draft } = (0, $r2uF6.useAtomValue)((0, $540fa3f25212c24e$export$6f6480b3b0a87b58));
    const gridRef = (0, $acw62.useRef)(null);
    const showReadableLabel = (0, $r2uF6.useAtomValue)((0, $ebd8595742de66c3$export$25081f6903755e40));
    const rowData = (0, $r2uF6.useAtomValue)((0, $ebd8595742de66c3$export$f92f0adb5e3b8dfe));
    const onRowAccountEdit = (0, $r2uF6.useSetAtom)((0, $ebd8595742de66c3$export$5423b5318b16b3b5));
    (0, $0f2dbfb231b2e001$export$74639c356da413e0)();
    const windowSize = (0, $0f2dbfb231b2e001$export$42c02f33970a2afa)();
    const isLargeScreen = windowSize.width > 1400;
    const prevFocusedRowIndex = (0, $acw62.useRef)(null);
    const handleCellFocused = (0, $acw62.useCallback)((event)=>{
        if (event.rowIndex === prevFocusedRowIndex.current) return;
        const container = document.getElementById("labeling-grid");
        if (!container) return;
        if (prevFocusedRowIndex.current !== null) {
            const prevRows = container.querySelectorAll(`[row-index="${prevFocusedRowIndex.current}"]`);
            prevRows.forEach((row)=>row.classList.remove("ag-row-focused"));
        }
        if (event.rowIndex !== null) {
            const newRows = container.querySelectorAll(`[row-index="${event.rowIndex}"]`);
            newRows.forEach((row)=>row.classList.add("ag-row-focused"));
        }
        prevFocusedRowIndex.current = event.rowIndex;
    }, []);
    const columnDefs = (0, $acw62.useMemo)(()=>[
            {
                ...(0, $b63413fa6f559e31$export$181cfdc21e4d422),
                cellRenderer: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b63413fa6f559e31$export$47a2dc0a2e0ed747), {
                        label: params.data.account?.label,
                        showReadableLabel: showReadableLabel,
                        isDisabled: params.data.isDisabled,
                        isTentative: params.data.isTentative
                    })
            },
            {
                ...(0, $26ddc59a4e2ea790$export$8ec38466a0f34b95),
                cellRenderer: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $26ddc59a4e2ea790$export$8776ea034f07c9bb), {
                        accountName: params.data.account?.accountName,
                        isDisabled: params.data.isDisabled,
                        isTentative: params.data.isTentative
                    }),
                editable: false
            },
            {
                ...(0, $f26df3d63da95747$export$8040672d6befcaf1),
                pinned: isLargeScreen ? "left" : undefined
            },
            ...draft?.periods?.map((period)=>(0, $a03a549e3b132929$export$702891ed33000c52)({
                    period: period
                })) || []
        ], [
        draft?.periods,
        showReadableLabel,
        isLargeScreen
    ]);
    const handleFirstDataRendered = (0, $acw62.useCallback)((event)=>{
        const columns = event.api.getAllDisplayedColumns();
        const firstCol = columns?.[0];
        if (firstCol) event.api.setFocusedCell(0, firstCol);
    }, []);
    const containerRef = (0, $acw62.useRef)(null);
    const handleCellKeyDown = (0, $acw62.useCallback)((event)=>{
        const keyboardEvent = event.event;
        if (keyboardEvent.key === "Enter" && event.data) onRowAccountEdit({
            colId: event.colDef.colId,
            rowIndex: event.data.rowIndex,
            account: event.data.account,
            rowHeader: event.data.rowHeader,
            isDisabled: event.data.isDisabled
        });
    }, [
        onRowAccountEdit
    ]);
    if (!selectedFileId) return null;
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "size-full",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg-selected size-full animate-pulse rounded-xl"
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        id: "labeling-grid",
        ref: containerRef,
        tabIndex: 0,
        className: "size-full outline-none",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gxPgh.AgGridReact), {
            ref: gridRef,
            theme: (0, $0356cd652e233c9b$export$e023de5353971026),
            rowData: rowData,
            getRowId: (params)=>params.data.rowIndex,
            onFirstDataRendered: handleFirstDataRendered,
            onCellKeyDown: handleCellKeyDown,
            onCellFocused: handleCellFocused,
            onCellClicked: (event)=>onRowAccountEdit({
                    colId: event.colDef.colId,
                    rowIndex: event.data.rowIndex,
                    account: event.data.account,
                    rowHeader: event.data.rowHeader,
                    isDisabled: event.data.isDisabled
                }),
            columnDefs: columnDefs,
            defaultColDef: {
                flex: 1,
                cellClass: "no-focus-border"
            },
            suppressHeaderFocus: true,
            rowClassRules: {
                "ag-row-disabled": (params)=>params.data.isDisabled,
                "ag-row-selected-border": (params)=>params.data.isSelected
            },
            rowSelection: {
                mode: "multiRow",
                checkboxes: false,
                headerCheckbox: false,
                enableClickSelection: true
            }
        }, `${selectedFileId}-${isReadonly}-${isLargeScreen}-${draft?.id}`)
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $ce87dd83611a24b5$var$TagIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 6h.008v.008H6V6Z"
    }));
}
const $ce87dd83611a24b5$var$ForwardRef = $acw62.forwardRef($ce87dd83611a24b5$var$TagIcon);
var $ce87dd83611a24b5$export$2e2bcd8739ae039 = $ce87dd83611a24b5$var$ForwardRef;



var $r2uF6 = parcelRequire("r2uF6");

parcelRequire("j4C8j");
var $dkTlU = parcelRequire("dkTlU");
parcelRequire("gCemA");
var $kdwja = parcelRequire("kdwja");
var $fp4OM = parcelRequire("fp4OM");

var $ayMG0 = parcelRequire("ayMG0");


var $ayMG0 = parcelRequire("ayMG0");
const $b4aeb005b0126a6d$export$b1ecdf8748e39236 = ({ condensed: condensed = false, large: large })=>{
    if (condensed) return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "72",
        height: "15",
        viewBox: "0 0 72 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                clipPath: "url(#clip0_1348_5138)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M7.56851 14.5H5.41837V10.5163H5.3897C5.14123 10.8483 4.82111 11.0854 4.4293 11.2276C4.04706 11.3605 3.63136 11.4268 3.18222 11.4268C2.6853 11.4268 2.24093 11.3272 1.84913 11.128C1.45732 10.9194 1.12286 10.6443 0.845724 10.3028C0.578154 9.96138 0.367914 9.57249 0.215015 9.13618C0.0716715 8.69038 0 8.22561 0 7.74187C0 7.22019 0.0812274 6.74119 0.243683 6.30488C0.406139 5.86857 0.635491 5.4939 0.93173 5.18089C1.23753 4.85841 1.60066 4.61179 2.02114 4.44106C2.44161 4.26084 2.90986 4.17073 3.4259 4.17073C3.6648 4.17073 3.89415 4.20393 4.11395 4.27033C4.34329 4.33672 4.54876 4.42208 4.73032 4.52642C4.92145 4.63076 5.0839 4.74932 5.21769 4.88212C5.36103 5.00542 5.47571 5.12873 5.56171 5.25203H5.59038V4.34146H7.56851V14.5ZM5.59038 7.79878C5.59038 7.2771 5.43748 6.85501 5.13168 6.53252C4.83544 6.21003 4.41497 6.04878 3.87026 6.04878C3.32556 6.04878 2.90031 6.21003 2.59451 6.53252C2.29827 6.85501 2.15015 7.2771 2.15015 7.79878C2.15015 8.32046 2.29827 8.74255 2.59451 9.06504C2.90031 9.38753 3.32556 9.54878 3.87026 9.54878C4.41497 9.54878 4.83544 9.38753 5.13168 9.06504C5.43748 8.74255 5.59038 8.32046 5.59038 7.79878ZM15.5347 11.2561H13.4706V10.3171H13.4419C13.3654 10.4499 13.2651 10.5826 13.1409 10.7154C13.0262 10.8483 12.8829 10.9668 12.7108 11.0711C12.5388 11.1755 12.3429 11.2609 12.1231 11.3272C11.9033 11.3936 11.6644 11.4268 11.4064 11.4268C10.8617 11.4268 10.4174 11.3462 10.0733 11.185C9.73883 11.0142 9.47603 10.7818 9.2849 10.4878C9.10334 10.1938 8.9791 9.84756 8.91221 9.44919C8.85488 9.05081 8.82621 8.61924 8.82621 8.15447V4.34146H10.9764V7.72764C10.9764 7.92683 10.9811 8.1355 10.9907 8.35366C11.0098 8.56233 11.0528 8.75678 11.1197 8.93699C11.1961 9.11721 11.3061 9.26423 11.4494 9.37805C11.6023 9.49187 11.8173 9.54878 12.0945 9.54878C12.3715 9.54878 12.5962 9.50135 12.7682 9.4065C12.9402 9.30217 13.0692 9.16938 13.1552 9.00813C13.2507 8.8374 13.3129 8.64769 13.3416 8.43903C13.3702 8.23036 13.3846 8.0122 13.3846 7.78455V4.34146H15.5347V11.2561ZM16.6251 4.34146H18.7753V11.2561H16.6251V4.34146ZM24.5752 6.5752C24.4702 6.42345 24.322 6.30013 24.1309 6.20529C23.9398 6.10095 23.7343 6.04878 23.5145 6.04878C22.9698 6.04878 22.5446 6.21003 22.2388 6.53252C21.9425 6.85501 21.7944 7.2771 21.7944 7.79878C21.7944 8.32046 21.9425 8.74255 22.2388 9.06504C22.5446 9.38753 22.9698 9.54878 23.5145 9.54878C23.7535 9.54878 23.9589 9.49662 24.1309 9.39228C24.3029 9.28794 24.4511 9.16463 24.5752 9.02236L25.9943 10.502C25.6599 10.8435 25.2633 11.0854 24.8046 11.2276C24.3555 11.3605 23.9255 11.4268 23.5145 11.4268C22.9794 11.4268 22.4729 11.3415 21.9951 11.1707C21.5269 11 21.116 10.7581 20.7623 10.4451C20.4183 10.1226 20.1459 9.73849 19.9453 9.29268C19.7446 8.84688 19.6442 8.34891 19.6442 7.79878C19.6442 7.24865 19.7446 6.75068 19.9453 6.30488C20.1459 5.85908 20.4183 5.47968 20.7623 5.16667C21.116 4.84418 21.5269 4.59756 21.9951 4.42683C22.4729 4.2561 22.9794 4.17073 23.5145 4.17073C23.9255 4.17073 24.3555 4.24187 24.8046 4.38415C25.2633 4.51694 25.6599 4.75407 25.9943 5.09553L24.5752 6.5752ZM26.3137 0.5H28.4638V7.07317L30.8433 4.34146H33.4808L30.7143 7.45732L33.5525 11.2561H30.8433L28.4925 7.7561H28.4638V11.2561H26.3137V0.5ZM34.0187 0.5H36.1688V5.0813H36.1975C36.446 4.74932 36.7614 4.51694 37.1436 4.38415C37.5354 4.24187 37.9559 4.17073 38.405 4.17073C38.902 4.17073 39.3463 4.27507 39.7381 4.48374C40.1299 4.68293 40.4596 4.95325 40.7271 5.29472C41.0043 5.63618 41.2145 6.02981 41.3579 6.47561C41.5108 6.91192 41.5872 7.37195 41.5872 7.85569C41.5872 8.37737 41.506 8.85637 41.3435 9.29268C41.1811 9.72899 40.947 10.1084 40.6411 10.4309C40.3449 10.7439 39.9866 10.9905 39.5661 11.1707C39.1457 11.3415 38.6773 11.4268 38.1613 11.4268C37.9129 11.4268 37.6787 11.3936 37.4589 11.3272C37.2392 11.2609 37.0337 11.1755 36.8425 11.0711C36.661 10.9668 36.4985 10.8529 36.3552 10.7297C36.2215 10.5968 36.1115 10.4688 36.0255 10.3455H35.9968V11.2561H34.0187V0.5ZM35.9968 7.79878C35.9968 8.32046 36.145 8.74255 36.4412 9.06504C36.747 9.38753 37.1722 9.54878 37.7169 9.54878C38.2616 9.54878 38.6821 9.38753 38.9784 9.06504C39.2842 8.74255 39.4371 8.32046 39.4371 7.79878C39.4371 7.2771 39.2842 6.85501 38.9784 6.53252C38.6821 6.21003 38.2616 6.04878 37.7169 6.04878C37.1722 6.04878 36.747 6.21003 36.4412 6.53252C36.145 6.85501 35.9968 7.2771 35.9968 7.79878ZM42.1282 7.79878C42.1282 7.24865 42.2286 6.75068 42.4292 6.30488C42.6299 5.85908 42.9023 5.47968 43.2463 5.16667C43.5998 4.84418 44.0108 4.59756 44.479 4.42683C44.9569 4.2561 45.4633 4.17073 45.9985 4.17073C46.5337 4.17073 47.0354 4.2561 47.5036 4.42683C47.9814 4.59756 48.3923 4.84418 48.7363 5.16667C49.0899 5.47968 49.367 5.85908 49.5677 6.30488C49.7684 6.75068 49.8687 7.24865 49.8687 7.79878C49.8687 8.34891 49.7684 8.84688 49.5677 9.29268C49.367 9.73849 49.0899 10.1226 48.7363 10.4451C48.3923 10.7581 47.9814 11 47.5036 11.1707C47.0354 11.3415 46.5337 11.4268 45.9985 11.4268C45.4633 11.4268 44.9569 11.3415 44.479 11.1707C44.0108 11 43.5998 10.7581 43.2463 10.4451C42.9023 10.1226 42.6299 9.73849 42.4292 9.29268C42.2286 8.84688 42.1282 8.34891 42.1282 7.79878ZM44.2784 7.79878C44.2784 8.32046 44.4265 8.74255 44.7227 9.06504C45.0286 9.38753 45.4538 9.54878 45.9985 9.54878C46.5432 9.54878 46.9637 9.38753 47.2599 9.06504C47.5657 8.74255 47.7186 8.32046 47.7186 7.79878C47.7186 7.2771 47.5657 6.85501 47.2599 6.53252C46.9637 6.21003 46.5432 6.04878 45.9985 6.04878C45.4538 6.04878 45.0286 6.21003 44.7227 6.53252C44.4265 6.85501 44.2784 7.2771 44.2784 7.79878ZM50.4164 7.79878C50.4164 7.24865 50.5168 6.75068 50.7174 6.30488C50.9181 5.85908 51.1905 5.47968 51.5345 5.16667C51.8881 4.84418 52.299 4.59756 52.7672 4.42683C53.2451 4.2561 53.7516 4.17073 54.2867 4.17073C54.8219 4.17073 55.3236 4.2561 55.7918 4.42683C56.2696 4.59756 56.6805 4.84418 57.0245 5.16667C57.3782 5.47968 57.6552 5.85908 57.8559 6.30488C58.0566 6.75068 58.1569 7.24865 58.1569 7.79878C58.1569 8.34891 58.0566 8.84688 57.8559 9.29268C57.6552 9.73849 57.3782 10.1226 57.0245 10.4451C56.6805 10.7581 56.2696 11 55.7918 11.1707C55.3236 11.3415 54.8219 11.4268 54.2867 11.4268C53.7516 11.4268 53.2451 11.3415 52.7672 11.1707C52.299 11 51.8881 10.7581 51.5345 10.4451C51.1905 10.1226 50.9181 9.73849 50.7174 9.29268C50.5168 8.84688 50.4164 8.34891 50.4164 7.79878ZM52.5666 7.79878C52.5666 8.32046 52.7147 8.74255 53.0109 9.06504C53.3168 9.38753 53.742 9.54878 54.2867 9.54878C54.8314 9.54878 55.2519 9.38753 55.5481 9.06504C55.8539 8.74255 56.0068 8.32046 56.0068 7.79878C56.0068 7.2771 55.8539 6.85501 55.5481 6.53252C55.2519 6.21003 54.8314 6.04878 54.2867 6.04878C53.742 6.04878 53.3168 6.21003 53.0109 6.53252C52.7147 6.85501 52.5666 7.2771 52.5666 7.79878ZM58.9626 0.5H61.1128V7.07317L63.4923 4.34146H66.1298L63.3633 7.45732L66.2015 11.2561H63.4923L61.1415 7.7561H61.1128V11.2561H58.9626V0.5ZM70.4089 6.37602C70.0935 5.98712 69.6778 5.79268 69.1618 5.79268C68.9803 5.79268 68.8034 5.83537 68.6314 5.92073C68.4594 6.0061 68.3734 6.15312 68.3734 6.36179C68.3734 6.53252 68.4594 6.66057 68.6314 6.74594C68.8131 6.82182 69.0376 6.89296 69.3052 6.95935C69.5823 7.01626 69.8738 7.08265 70.1795 7.15854C70.4949 7.22493 70.7864 7.33402 71.0539 7.48577C71.3311 7.63753 71.5556 7.84621 71.7276 8.11179C71.9093 8.36789 72 8.7141 72 9.15041C72 9.59621 71.8997 9.96613 71.699 10.2602C71.5079 10.5447 71.2594 10.7771 70.9536 10.9573C70.6479 11.128 70.3038 11.2466 69.9215 11.313C69.5393 11.3889 69.1618 11.4268 68.7891 11.4268C68.3017 11.4268 67.8097 11.3605 67.3127 11.2276C66.8158 11.0854 66.3953 10.8387 66.0513 10.4878L67.3557 9.05081C67.5564 9.29743 67.7762 9.48712 68.0151 9.61992C68.2636 9.74322 68.5502 9.80488 68.8751 9.80488C69.1236 9.80488 69.3482 9.77168 69.5488 9.70528C69.7495 9.6294 69.8499 9.49662 69.8499 9.30691C69.8499 9.1267 69.7591 8.9939 69.5775 8.90854C69.4055 8.81369 69.1809 8.7378 68.9038 8.68089C68.6362 8.6145 68.3447 8.5481 68.0294 8.48171C67.7237 8.40582 67.4322 8.29675 67.155 8.15447C66.8875 8.0122 66.6629 7.81301 66.4813 7.55691C66.3093 7.29133 66.2233 6.94038 66.2233 6.50407C66.2233 6.09621 66.3046 5.74526 66.467 5.45122C66.639 5.15719 66.8588 4.91532 67.1263 4.72561C67.4035 4.53591 67.7189 4.39837 68.0724 4.31301C68.426 4.21816 68.7844 4.17073 69.1475 4.17073C69.6062 4.17073 70.0697 4.23712 70.5379 4.36992C71.0062 4.50271 71.4028 4.73984 71.7276 5.0813L70.4089 6.37602Z",
                    fill: "#2DA44A"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0_1348_5138",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "72",
                        height: "14.5",
                        fill: "white"
                    })
                })
            })
        ]
    });
    if (large) return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "106",
        height: "21",
        viewBox: "0 0 106 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                clipPath: "url(#clip0_1861_11590)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M11.1425 20.6829H7.97704V14.7975H7.93484C7.56904 15.288 7.09774 15.6383 6.52092 15.8485C5.95817 16.0447 5.34617 16.1428 4.68493 16.1428C3.95335 16.1428 3.29915 15.9956 2.72232 15.7014C2.1455 15.3931 1.6531 14.9867 1.24509 14.4823C0.851171 13.9778 0.54165 13.4033 0.316549 12.7587C0.105516 12.1001 0 11.4134 0 10.6988C0 9.92809 0.119585 9.22043 0.358756 8.57585C0.597927 7.93126 0.935584 7.37775 1.37171 6.91533C1.82192 6.4389 2.35653 6.07456 2.97556 5.82233C3.5946 5.55609 4.28397 5.42296 5.04369 5.42296C5.3954 5.42296 5.73305 5.47201 6.05664 5.5701C6.39429 5.66818 6.69678 5.7943 6.96408 5.94844C7.24547 6.10259 7.48463 6.27774 7.6816 6.47393C7.89263 6.65609 8.06146 6.83826 8.18807 7.02043H8.23028V5.67519H11.1425V20.6829ZM8.23028 10.7829C8.23028 10.0122 8.00518 9.38859 7.55498 8.91216C7.11885 8.43573 6.49981 8.1975 5.69789 8.1975C4.89596 8.1975 4.2699 8.43573 3.81969 8.91216C3.38356 9.38859 3.16549 10.0122 3.16549 10.7829C3.16549 11.5536 3.38356 12.1771 3.81969 12.6536C4.2699 13.13 4.89596 13.3682 5.69789 13.3682C6.49981 13.3682 7.11885 13.13 7.55498 12.6536C8.00518 12.1771 8.23028 11.5536 8.23028 10.7829ZM22.8705 15.8905H19.8317V14.5033H19.7895C19.6769 14.6995 19.5291 14.8956 19.3463 15.0918C19.1775 15.288 18.9664 15.4631 18.7132 15.6173C18.4599 15.7715 18.1714 15.8976 17.848 15.9956C17.5243 16.0937 17.1726 16.1428 16.7928 16.1428C15.9909 16.1428 15.3367 16.0237 14.8302 15.7854C14.3377 15.5332 13.9508 15.1899 13.6694 14.7555C13.4021 14.3211 13.2192 13.8096 13.1208 13.2211C13.0363 12.6326 12.9941 11.995 12.9941 11.3083V5.67519H16.1597V10.6778C16.1597 10.972 16.1666 11.2803 16.1808 11.6026C16.2088 11.9109 16.2721 12.1982 16.3707 12.4644C16.4832 12.7306 16.6451 12.9478 16.8561 13.116C17.0812 13.2842 17.3977 13.3682 17.8057 13.3682C18.2136 13.3682 18.5444 13.2982 18.7976 13.158C19.0508 13.0039 19.2408 12.8077 19.3674 12.5695C19.508 12.3173 19.5995 12.037 19.6417 11.7287C19.6839 11.4205 19.705 11.0982 19.705 10.7618V5.67519H22.8705V15.8905ZM24.4759 5.67519H27.6414V15.8905H24.4759V5.67519ZM36.1802 8.97521C36.0256 8.75101 35.8075 8.56884 35.526 8.42871C35.2447 8.27457 34.9422 8.1975 34.6186 8.1975C33.8167 8.1975 33.1906 8.43573 32.7404 8.91216C32.3043 9.38859 32.0862 10.0122 32.0862 10.7829C32.0862 11.5536 32.3043 12.1771 32.7404 12.6536C33.1906 13.13 33.8167 13.3682 34.6186 13.3682C34.9704 13.3682 35.2728 13.2912 35.526 13.137C35.7793 12.9829 35.9974 12.8007 36.1802 12.5905L38.2694 14.7765C37.7771 15.281 37.1932 15.6383 36.5179 15.8485C35.8567 16.0447 35.2236 16.1428 34.6186 16.1428C33.8308 16.1428 33.0851 16.0167 32.3816 15.7644C31.6923 15.5122 31.0874 15.1549 30.5668 14.6924C30.0603 14.216 29.6593 13.6485 29.3639 12.9899C29.0684 12.3313 28.9207 11.5956 28.9207 10.7829C28.9207 9.97013 29.0684 9.23446 29.3639 8.57585C29.6593 7.91724 30.0603 7.35673 30.5668 6.89431C31.0874 6.41788 31.6923 6.05354 32.3816 5.80131C33.0851 5.54908 33.8308 5.42296 34.6186 5.42296C35.2236 5.42296 35.8567 5.52806 36.5179 5.73825C37.1932 5.93444 37.7771 6.28475 38.2694 6.78921L36.1802 8.97521ZM38.7396 0H41.9051V9.71089L45.4082 5.67519H49.2912L45.2183 10.2784L49.3968 15.8905H45.4082L41.9473 10.7198H41.9051V15.8905H38.7396V0ZM50.0831 0H53.2486V6.76819H53.2908C53.6566 6.27774 54.1209 5.93444 54.6836 5.73825C55.2605 5.52806 55.8795 5.42296 56.5407 5.42296C57.2724 5.42296 57.9266 5.57711 58.5033 5.88539C59.0802 6.17966 59.5655 6.57902 59.9594 7.08348C60.3674 7.58794 60.6769 8.16947 60.888 8.82808C61.1132 9.47266 61.2256 10.1523 61.2256 10.8669C61.2256 11.6376 61.1061 12.3453 60.8668 12.9899C60.6278 13.6345 60.283 14.195 59.8328 14.6714C59.3967 15.1338 58.8691 15.4982 58.25 15.7644C57.6311 16.0167 56.9416 16.1428 56.1819 16.1428C55.8162 16.1428 55.4715 16.0937 55.1479 15.9956C54.8244 15.8976 54.5218 15.7715 54.2404 15.6173C53.9732 15.4631 53.7339 15.2949 53.5229 15.1128C53.326 14.9166 53.1641 14.7274 53.0375 14.5453H52.9953V15.8905H50.0831V0ZM52.9953 10.7829C52.9953 11.5536 53.2134 12.1771 53.6495 12.6536C54.0998 13.13 54.7258 13.3682 55.5277 13.3682C56.3296 13.3682 56.9487 13.13 57.3848 12.6536C57.8351 12.1771 58.0601 11.5536 58.0601 10.7829C58.0601 10.0122 57.8351 9.38859 57.3848 8.91216C56.9487 8.43573 56.3296 8.1975 55.5277 8.1975C54.7258 8.1975 54.0998 8.43573 53.6495 8.91216C53.2134 9.38859 52.9953 10.0122 52.9953 10.7829ZM62.0221 10.7829C62.0221 9.97013 62.1698 9.23446 62.4653 8.57585C62.7607 7.91724 63.1617 7.35673 63.6682 6.89431C64.1887 6.41788 64.7937 6.05354 65.483 5.80131C66.1865 5.54908 66.9321 5.42296 67.72 5.42296C68.5079 5.42296 69.2465 5.54908 69.9358 5.80131C70.6393 6.05354 71.2442 6.41788 71.7507 6.89431C72.2712 7.35673 72.6793 7.91724 72.9747 8.57585C73.2702 9.23446 73.4179 9.97013 73.4179 10.7829C73.4179 11.5956 73.2702 12.3313 72.9747 12.9899C72.6793 13.6485 72.2712 14.216 71.7507 14.6924C71.2442 15.1549 70.6393 15.5122 69.9358 15.7644C69.2465 16.0167 68.5079 16.1428 67.72 16.1428C66.9321 16.1428 66.1865 16.0167 65.483 15.7644C64.7937 15.5122 64.1887 15.1549 63.6682 14.6924C63.1617 14.216 62.7607 13.6485 62.4653 12.9899C62.1698 12.3313 62.0221 11.5956 62.0221 10.7829ZM65.1876 10.7829C65.1876 11.5536 65.4057 12.1771 65.8418 12.6536C66.292 13.13 66.9181 13.3682 67.72 13.3682C68.5219 13.3682 69.141 13.13 69.5771 12.6536C70.0273 12.1771 70.2524 11.5536 70.2524 10.7829C70.2524 10.0122 70.0273 9.38859 69.5771 8.91216C69.141 8.43573 68.5219 8.1975 67.72 8.1975C66.9181 8.1975 66.292 8.43573 65.8418 8.91216C65.4057 9.38859 65.1876 10.0122 65.1876 10.7829ZM74.2242 10.7829C74.2242 9.97013 74.3719 9.23446 74.6673 8.57585C74.9628 7.91724 75.3638 7.35673 75.8702 6.89431C76.3909 6.41788 76.9958 6.05354 77.6851 5.80131C78.3886 5.54908 79.1343 5.42296 79.9221 5.42296C80.71 5.42296 81.4486 5.54908 82.1379 5.80131C82.8414 6.05354 83.4463 6.41788 83.9528 6.89431C84.4734 7.35673 84.8813 7.91724 85.1768 8.57585C85.4722 9.23446 85.6199 9.97013 85.6199 10.7829C85.6199 11.5956 85.4722 12.3313 85.1768 12.9899C84.8813 13.6485 84.4734 14.216 83.9528 14.6924C83.4463 15.1549 82.8414 15.5122 82.1379 15.7644C81.4486 16.0167 80.71 16.1428 79.9221 16.1428C79.1343 16.1428 78.3886 16.0167 77.6851 15.7644C76.9958 15.5122 76.3909 15.1549 75.8702 14.6924C75.3638 14.216 74.9628 13.6485 74.6673 12.9899C74.3719 12.3313 74.2242 11.5956 74.2242 10.7829ZM77.3897 10.7829C77.3897 11.5536 77.6078 12.1771 78.0439 12.6536C78.4941 13.13 79.1201 13.3682 79.9221 13.3682C80.724 13.3682 81.3431 13.13 81.7791 12.6536C82.2294 12.1771 82.4545 11.5536 82.4545 10.7829C82.4545 10.0122 82.2294 9.38859 81.7791 8.91216C81.3431 8.43573 80.724 8.1975 79.9221 8.1975C79.1201 8.1975 78.4941 8.43573 78.0439 8.91216C77.6078 9.38859 77.3897 10.0122 77.3897 10.7829ZM86.8061 0H89.9716V9.71089L93.4747 5.67519H97.3577L93.2848 10.2784L97.4633 15.8905H93.4747L90.0138 10.7198H89.9716V15.8905H86.8061V0ZM103.658 8.68094C103.193 8.10641 102.581 7.81916 101.822 7.81916C101.554 7.81916 101.294 7.88221 101.041 8.00833C100.787 8.13444 100.661 8.35165 100.661 8.65993C100.661 8.91216 100.787 9.10133 101.041 9.22744C101.308 9.33955 101.639 9.44465 102.033 9.54273C102.441 9.62681 102.87 9.72489 103.32 9.837C103.784 9.93509 104.213 10.0962 104.607 10.3204C105.015 10.5446 105.346 10.8529 105.599 11.2453C105.866 11.6236 106 12.1351 106 12.7797C106 13.4383 105.852 13.9848 105.557 14.4192C105.276 14.8396 104.91 15.1829 104.459 15.4491C104.009 15.7014 103.503 15.8766 102.94 15.9746C102.377 16.0868 101.822 16.1428 101.273 16.1428C100.555 16.1428 99.8309 16.0447 99.0992 15.8485C98.3677 15.6383 97.7486 15.2739 97.2421 14.7555L99.1625 12.6326C99.458 12.9969 99.7816 13.2771 100.133 13.4733C100.499 13.6555 100.921 13.7466 101.399 13.7466C101.765 13.7466 102.096 13.6975 102.391 13.5994C102.687 13.4873 102.835 13.2912 102.835 13.0109C102.835 12.7447 102.701 12.5485 102.434 12.4224C102.18 12.2822 101.85 12.1701 101.442 12.0861C101.048 11.988 100.619 11.8899 100.154 11.7918C99.7043 11.6797 99.2751 11.5185 98.8671 11.3083C98.4732 11.0982 98.1426 10.8039 97.8752 10.4255C97.622 10.0332 97.4954 9.5147 97.4954 8.87012C97.4954 8.26757 97.6151 7.74909 97.8541 7.3147C98.1074 6.8803 98.431 6.52298 98.8249 6.24271C99.2329 5.96245 99.6972 5.75927 100.218 5.63316C100.738 5.49303 101.266 5.42296 101.8 5.42296C102.476 5.42296 103.158 5.52105 103.847 5.71723C104.537 5.91342 105.121 6.26373 105.599 6.76819L103.658 8.68094Z",
                    fill: "#2DA44A"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0_1861_11590",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "106",
                        height: "20.6829",
                        fill: "white"
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "82",
        height: "17",
        viewBox: "0 0 82 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                clipPath: "url(#clip0_1340_5096)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M8.6197 16.5H6.17092V11.9472H6.13827C5.8553 12.3266 5.49071 12.5976 5.04448 12.7602C4.60915 12.912 4.13572 12.9878 3.62419 12.9878C3.05826 12.9878 2.55217 12.874 2.10595 12.6463C1.65972 12.4079 1.27881 12.0935 0.963186 11.7033C0.658453 11.313 0.419013 10.8686 0.244878 10.3699C0.0816259 9.86043 0 9.32927 0 8.77642C0 8.18022 0.0925089 7.63279 0.277528 7.13415C0.462547 6.63551 0.723754 6.20732 1.06114 5.84959C1.40941 5.48103 1.82297 5.19919 2.30185 5.00407C2.78073 4.79811 3.31401 4.69512 3.90172 4.69512C4.1738 4.69512 4.435 4.73307 4.68533 4.80894C4.94653 4.88482 5.18053 4.98238 5.38731 5.10163C5.60498 5.22087 5.78999 5.35637 5.94237 5.50813C6.10562 5.64905 6.23622 5.78998 6.33417 5.9309H6.36682V4.89024H8.6197V16.5ZM6.36682 8.84146C6.36682 8.24526 6.19269 7.76287 5.84442 7.39431C5.50703 7.02575 5.02816 6.84146 4.4078 6.84146C3.78744 6.84146 3.30313 7.02575 2.95486 7.39431C2.61747 7.76287 2.44878 8.24526 2.44878 8.84146C2.44878 9.43767 2.61747 9.92006 2.95486 10.2886C3.30313 10.6572 3.78744 10.8415 4.4078 10.8415C5.02816 10.8415 5.50703 10.6572 5.84442 10.2886C6.19269 9.92006 6.36682 9.43767 6.36682 8.84146ZM17.6923 12.7927H15.3415V11.7195H15.3088C15.2217 11.8713 15.1074 12.023 14.966 12.1748C14.8354 12.3266 14.6721 12.462 14.4762 12.5813C14.2803 12.7006 14.0571 12.7981 13.8069 12.874C13.5565 12.9498 13.2845 12.9878 12.9906 12.9878C12.3703 12.9878 11.8642 12.8957 11.4724 12.7114C11.0914 12.5163 10.7921 12.2506 10.5745 11.9146C10.3677 11.5786 10.2262 11.1829 10.15 10.7276C10.0847 10.2724 10.0521 9.77913 10.0521 9.24797V4.89024H12.5009V8.76016C12.5009 8.98781 12.5063 9.22628 12.5172 9.47561C12.5389 9.71409 12.5879 9.93632 12.6641 10.1423C12.7511 10.3482 12.8764 10.5163 13.0396 10.6463C13.2137 10.7764 13.4586 10.8415 13.7743 10.8415C14.0898 10.8415 14.3456 10.7873 14.5415 10.6789C14.7374 10.5596 14.8844 10.4079 14.9823 10.2236C15.0911 10.0285 15.1619 9.81165 15.1945 9.57317C15.2272 9.33469 15.2435 9.08537 15.2435 8.8252V4.89024H17.6923V12.7927ZM18.9342 4.89024H21.383V12.7927H18.9342V4.89024ZM27.9885 7.44309C27.8688 7.26965 27.7001 7.12872 27.4824 7.02033C27.2648 6.90108 27.0308 6.84146 26.7804 6.84146C26.1601 6.84146 25.6758 7.02575 25.3275 7.39431C24.9901 7.76287 24.8214 8.24526 24.8214 8.84146C24.8214 9.43767 24.9901 9.92006 25.3275 10.2886C25.6758 10.6572 26.1601 10.8415 26.7804 10.8415C27.0526 10.8415 27.2865 10.7818 27.4824 10.6626C27.6783 10.5434 27.847 10.4024 27.9885 10.2398L29.6047 11.9309C29.2238 12.3211 28.7721 12.5976 28.2497 12.7602C27.7382 12.912 27.2485 12.9878 26.7804 12.9878C26.171 12.9878 25.5942 12.8902 25.0499 12.6951C24.5167 12.5 24.0487 12.2236 23.646 11.8659C23.2542 11.4973 22.944 11.0583 22.7154 10.5488C22.4869 10.0393 22.3726 9.47019 22.3726 8.84146C22.3726 8.21274 22.4869 7.64364 22.7154 7.13415C22.944 6.62466 23.2542 6.19106 23.646 5.83333C24.0487 5.46477 24.5167 5.18293 25.0499 4.98781C25.5942 4.79268 26.171 4.69512 26.7804 4.69512C27.2485 4.69512 27.7382 4.77642 28.2497 4.93903C28.7721 5.09079 29.2238 5.36179 29.6047 5.75203L27.9885 7.44309ZM29.9684 0.5H32.4172V8.0122L35.1271 4.89024H38.131L34.9802 8.45122L38.2126 12.7927H35.1271L32.4498 8.79268H32.4172V12.7927H29.9684V0.5ZM38.7435 0.5H41.1923V5.73577H41.2249C41.5079 5.35637 41.8671 5.09079 42.3024 4.93903C42.7487 4.77642 43.2276 4.69512 43.739 4.69512C44.305 4.69512 44.8111 4.81437 45.2573 5.05285C45.7035 5.28049 46.079 5.58943 46.3837 5.97968C46.6993 6.36992 46.9387 6.81978 47.102 7.32927C47.2762 7.82791 47.3632 8.35366 47.3632 8.9065C47.3632 9.50271 47.2707 10.0501 47.0857 10.5488C46.9007 11.0474 46.634 11.481 46.2857 11.8496C45.9484 12.2073 45.5403 12.4892 45.0614 12.6951C44.5826 12.8902 44.0492 12.9878 43.4615 12.9878C43.1786 12.9878 42.9119 12.9498 42.6615 12.874C42.4113 12.7981 42.1773 12.7006 41.9596 12.5813C41.7528 12.462 41.5678 12.3319 41.4045 12.1911C41.2522 12.0393 41.127 11.8929 41.029 11.752H40.9964V12.7927H38.7435V0.5ZM40.9964 8.84146C40.9964 9.43767 41.1651 9.92006 41.5025 10.2886C41.8508 10.6572 42.335 10.8415 42.9554 10.8415C43.5758 10.8415 44.0547 10.6572 44.392 10.2886C44.7403 9.92006 44.9144 9.43767 44.9144 8.84146C44.9144 8.24526 44.7403 7.76287 44.392 7.39431C44.0547 7.02575 43.5758 6.84146 42.9554 6.84146C42.335 6.84146 41.8508 7.02575 41.5025 7.39431C41.1651 7.76287 40.9964 8.24526 40.9964 8.84146ZM47.9794 8.84146C47.9794 8.21274 48.0936 7.64364 48.3222 7.13415C48.5507 6.62466 48.8609 6.19106 49.2527 5.83333C49.6554 5.46477 50.1234 5.18293 50.6567 4.98781C51.2009 4.79268 51.7776 4.69512 52.3872 4.69512C52.9967 4.69512 53.5681 4.79268 54.1013 4.98781C54.6455 5.18293 55.1135 5.46477 55.5053 5.83333C55.9079 6.19106 56.2236 6.62466 56.4521 7.13415C56.6807 7.64364 56.795 8.21274 56.795 8.84146C56.795 9.47019 56.6807 10.0393 56.4521 10.5488C56.2236 11.0583 55.9079 11.4973 55.5053 11.8659C55.1135 12.2236 54.6455 12.5 54.1013 12.6951C53.5681 12.8902 52.9967 12.9878 52.3872 12.9878C51.7776 12.9878 51.2009 12.8902 50.6567 12.6951C50.1234 12.5 49.6554 12.2236 49.2527 11.8659C48.8609 11.4973 48.5507 11.0583 48.3222 10.5488C48.0936 10.0393 47.9794 9.47019 47.9794 8.84146ZM50.4281 8.84146C50.4281 9.43767 50.5969 9.92006 50.9342 10.2886C51.2825 10.6572 51.7668 10.8415 52.3872 10.8415C53.0075 10.8415 53.4864 10.6572 53.8238 10.2886C54.1721 9.92006 54.3462 9.43767 54.3462 8.84146C54.3462 8.24526 54.1721 7.76287 53.8238 7.39431C53.4864 7.02575 53.0075 6.84146 52.3872 6.84146C51.7668 6.84146 51.2825 7.02575 50.9342 7.39431C50.5969 7.76287 50.4281 8.24526 50.4281 8.84146ZM57.4187 8.84146C57.4187 8.21274 57.533 7.64364 57.7615 7.13415C57.9901 6.62466 58.3003 6.19106 58.6921 5.83333C59.0948 5.46477 59.5628 5.18293 60.096 4.98781C60.6402 4.79268 61.2171 4.69512 61.8265 4.69512C62.436 4.69512 63.0074 4.79268 63.5406 4.98781C64.0849 5.18293 64.5528 5.46477 64.9446 5.83333C65.3474 6.19106 65.6629 6.62466 65.8915 7.13415C66.12 7.64364 66.2343 8.21274 66.2343 8.84146C66.2343 9.47019 66.12 10.0393 65.8915 10.5488C65.6629 11.0583 65.3474 11.4973 64.9446 11.8659C64.5528 12.2236 64.0849 12.5 63.5406 12.6951C63.0074 12.8902 62.436 12.9878 61.8265 12.9878C61.2171 12.9878 60.6402 12.8902 60.096 12.6951C59.5628 12.5 59.0948 12.2236 58.6921 11.8659C58.3003 11.4973 57.9901 11.0583 57.7615 10.5488C57.533 10.0393 57.4187 9.47019 57.4187 8.84146ZM59.8675 8.84146C59.8675 9.43767 60.0362 9.92006 60.3736 10.2886C60.7219 10.6572 61.2061 10.8415 61.8265 10.8415C62.4469 10.8415 62.9258 10.6572 63.2631 10.2886C63.6114 9.92006 63.7855 9.43767 63.7855 8.84146C63.7855 8.24526 63.6114 7.76287 63.2631 7.39431C62.9258 7.02575 62.4469 6.84146 61.8265 6.84146C61.2061 6.84146 60.7219 7.02575 60.3736 7.39431C60.0362 7.76287 59.8675 8.24526 59.8675 8.84146ZM67.1519 0.5H69.6007V8.0122L72.3106 4.89024H75.3145L72.1637 8.45122L75.3961 12.7927H72.3106L69.6333 8.79268H69.6007V12.7927H67.1519V0.5ZM80.1879 7.21545C79.8288 6.771 79.3553 6.54878 78.7676 6.54878C78.5609 6.54878 78.3595 6.59756 78.1636 6.69512C77.9677 6.79268 77.8697 6.96071 77.8697 7.19919C77.8697 7.39431 77.9677 7.54065 78.1636 7.63821C78.3704 7.72494 78.6262 7.80624 78.9309 7.88211C79.2465 7.94716 79.5785 8.02303 79.9267 8.10976C80.2859 8.18563 80.6178 8.3103 80.9225 8.48374C81.2382 8.65718 81.4939 8.89567 81.6898 9.19919C81.8967 9.49187 82 9.88754 82 10.3862C82 10.8957 81.8857 11.3184 81.6572 11.6545C81.4396 11.9797 81.1566 12.2453 80.8083 12.4512C80.4601 12.6463 80.0683 12.7819 79.6329 12.8577C79.1976 12.9445 78.7676 12.9878 78.3432 12.9878C77.7881 12.9878 77.2277 12.912 76.6617 12.7602C76.0958 12.5976 75.6169 12.3157 75.2251 11.9146L76.7106 10.2724C76.9392 10.5542 77.1896 10.771 77.4616 10.9228C77.7446 11.0637 78.0711 11.1341 78.4411 11.1341C78.7241 11.1341 78.9798 11.0962 79.2084 11.0203C79.4369 10.9336 79.5512 10.7818 79.5512 10.565C79.5512 10.3591 79.4479 10.2073 79.241 10.1098C79.0451 10.0014 78.7894 9.91463 78.4738 9.84959C78.1691 9.77372 77.8371 9.69783 77.4779 9.62195C77.1297 9.53523 76.7977 9.41057 76.4821 9.24797C76.1774 9.08537 75.9217 8.85772 75.7148 8.56504C75.5189 8.26152 75.421 7.86043 75.421 7.36179C75.421 6.89567 75.5135 6.49458 75.6985 6.15854C75.8944 5.8225 76.1447 5.54608 76.4494 5.32927C76.7651 5.11246 77.1243 4.95529 77.5269 4.85772C77.9297 4.74933 78.3378 4.69512 78.7513 4.69512C79.2737 4.69512 79.8016 4.771 80.3348 4.92277C80.8682 5.07453 81.3198 5.34553 81.6898 5.73577L80.1879 7.21545Z",
                    fill: "#2DA44A"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0_1340_5096",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "82",
                        height: "16.5",
                        fill: "white"
                    })
                })
            })
        ]
    });
};



var $acw62 = parcelRequire("acw62");
function $9e73f507bb05d0c8$var$ShareIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
    }));
}
const $9e73f507bb05d0c8$var$ForwardRef = $acw62.forwardRef($9e73f507bb05d0c8$var$ShareIcon);
var $9e73f507bb05d0c8$export$2e2bcd8739ae039 = $9e73f507bb05d0c8$var$ForwardRef;



var $ayMG0 = parcelRequire("ayMG0");
function $bb911d9650c221d5$export$a2aa015c05602446({ condensed: condensed = false, large: large = false }) {
    if (condensed) return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: "29",
        height: "9",
        viewBox: "0 0 29 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M24.4284 8.14443C22.2313 8.14443 20.4485 6.36012 20.4485 4.16598C20.4485 1.96888 22.2343 0.18457 24.4284 0.18457C26.6255 0.18457 28.4084 1.97036 28.4084 4.16598C28.4084 6.3616 26.6226 8.14443 24.4284 8.14443ZM8.07227 8.12816C7.92579 8.12816 7.7882 8.0675 7.67723 7.95653L4.65456 4.93829L1.61857 7.96689C1.51648 8.0675 1.38184 8.12668 1.23685 8.12668C0.937984 8.12668 0.692383 7.88107 0.692383 7.58221C0.692383 7.43574 0.751564 7.29962 0.85661 7.1931L3.87485 4.16006L0.859569 1.13147C0.748605 1.02938 0.692383 0.891786 0.692383 0.745313C0.692383 0.444969 0.937984 0.203805 1.23685 0.203805C1.38184 0.203805 1.515 0.258547 1.61857 0.359155L4.659 3.38923L7.68907 0.363593C7.79116 0.258547 7.92875 0.203805 8.07375 0.203805C8.38593 0.203805 8.62857 0.447928 8.62857 0.745313C8.62857 0.890307 8.58566 1.02346 8.4747 1.12703L5.43279 4.16746L8.47322 7.20197C8.57383 7.30406 8.62709 7.4387 8.62709 7.58369C8.62709 7.88256 8.38297 8.12816 8.08706 8.12816H8.07227ZM19.9336 1.33564C18.7559 1.48508 18.6287 2.0399 18.6287 3.4129V7.53635C18.6287 7.83521 18.3846 8.07785 18.0872 8.07785C17.7868 8.07785 17.5442 7.83373 17.5427 7.53635V0.834084C17.5427 0.53226 17.7795 0.292576 18.0783 0.292576C18.3239 0.292576 18.5458 0.477517 18.5902 0.72016C18.9897 0.410939 19.4779 0.251149 19.9662 0.251149H20.1215C20.4101 0.251149 20.6527 0.495272 20.6527 0.795616C20.6527 1.093 20.41 1.31641 20.0979 1.32677C20.0979 1.32677 19.9647 1.32677 19.8552 1.3386L19.9336 1.33564ZM15.3604 4.598H9.69235C9.69235 4.62611 9.69679 4.65275 9.70123 4.68234C9.73082 4.83769 9.76781 4.99452 9.82403 5.14099C10.1111 5.92662 10.9559 7.02739 12.5301 7.04958C13.0183 7.04514 13.4637 6.92234 13.8617 6.71077C14.1724 6.53322 14.4402 6.30982 14.6384 6.07753C14.705 5.99172 14.7716 5.91182 14.816 5.82897C15.0823 5.49016 15.4152 5.55378 15.6149 5.70617C15.8575 5.90591 15.8812 6.28466 15.6815 6.5495L15.6578 6.57317C15.3471 6.97265 15.0142 7.30554 14.6384 7.54966C14.2611 7.7923 13.8617 7.96985 13.4385 8.0601C12.9503 8.19325 12.4842 8.21397 11.996 8.14887C10.3759 7.94913 9.02212 6.77291 8.62265 5.17502C8.53388 4.86432 8.48949 4.55362 8.48949 4.22072C8.48949 2.95573 9.11238 1.71292 10.154 0.958365C11.4633 0.0484554 13.2388 -0.0181249 14.5925 0.847399C15.5246 1.44661 16.1239 2.358 16.3458 3.46764C16.4568 4.08757 16.1357 4.57433 15.3604 4.598ZM24.4284 1.30901C22.8542 1.30901 21.5715 2.5888 21.5715 4.16598C21.5715 5.7402 22.8527 7.02295 24.4284 7.02295C26.0041 7.02295 27.2854 5.7402 27.2854 4.16598C27.2854 2.59028 26.0041 1.30605 24.4284 1.30605V1.30901ZM24.4284 5.14839C23.8855 5.14839 23.4431 4.70897 23.4431 4.16302C23.4431 3.62003 23.8869 3.17914 24.4284 3.17914C24.9714 3.17914 25.4153 3.62151 25.4153 4.16302C25.4153 4.70897 24.9714 5.14987 24.4284 5.14839ZM12.533 1.29718C11.1867 1.29718 10.0593 2.21892 9.74265 3.46616V3.51055H15.3294C15.029 2.24555 13.8898 1.30014 12.5316 1.30014V1.29718H12.533Z",
            fill: "#13B5EA"
        })
    });
    if (large) return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: "52",
        height: "14",
        viewBox: "0 0 55 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M47.1022 15.9197C42.7422 15.9197 39.2043 12.3511 39.2043 7.96282C39.2043 3.56862 42.7481 0 47.1022 0C51.4621 0 55 3.57158 55 7.96282C55 12.3541 51.4563 15.9197 47.1022 15.9197ZM14.6447 15.8872C14.3541 15.8872 14.081 15.7659 13.8608 15.5439L7.8626 9.50745L1.83793 15.5646C1.63535 15.7658 1.36817 15.8842 1.08045 15.8842C0.487375 15.8842 0 15.393 0 14.7953C0 14.5023 0.11744 14.2301 0.325895 14.017L6.31533 7.95098L0.331767 1.8938C0.111567 1.68962 0 1.41443 0 1.12149C0 0.520797 0.487375 0.0384692 1.08045 0.0384692C1.36817 0.0384692 1.63241 0.147953 1.83793 0.349169L7.8714 6.40932L13.8843 0.358046C14.0869 0.147953 14.36 0.0384692 14.6477 0.0384692C15.2672 0.0384692 15.7487 0.526715 15.7487 1.12149C15.7487 1.41147 15.6635 1.67779 15.4433 1.88492L9.40693 7.96578L15.4404 14.0348C15.64 14.239 15.7457 14.5083 15.7457 14.7982C15.7457 15.396 15.2613 15.8872 14.6741 15.8872H14.6447ZM38.1826 2.30215C35.8456 2.60101 35.5931 3.71066 35.5931 6.45666V14.7036C35.5931 15.3013 35.1086 15.7866 34.5185 15.7866C33.9225 15.7866 33.441 15.2983 33.4381 14.7036V1.29903C33.4381 0.69538 33.9078 0.216011 34.5009 0.216011C34.9883 0.216011 35.4287 0.585894 35.5167 1.07118C36.3095 0.452737 37.2783 0.133157 38.2472 0.133157H38.5555C39.128 0.133157 39.6095 0.621403 39.6095 1.22209C39.6095 1.81686 39.128 2.26368 38.5085 2.28439C38.5085 2.28439 38.2443 2.28439 38.027 2.30807L38.1826 2.30215ZM29.1075 8.82687H17.8597C17.8597 8.88309 17.8685 8.93635 17.8773 8.99553C17.936 9.30623 18.0094 9.61989 18.121 9.91284C18.6905 11.4841 20.367 13.6856 23.4909 13.73C24.4598 13.7211 25.3435 13.4755 26.1333 13.0524C26.7499 12.6973 27.2813 12.2505 27.6747 11.7859C27.8068 11.6143 27.9389 11.4545 28.027 11.2888C28.5555 10.6112 29.2161 10.7384 29.6124 11.0432C30.094 11.4427 30.1409 12.2002 29.7446 12.7299L29.6976 12.7772C29.081 13.5762 28.4204 14.2419 27.6747 14.7302C26.926 15.2155 26.1333 15.5706 25.2936 15.7511C24.3247 16.0174 23.3999 16.0588 22.431 15.9286C19.2161 15.5291 16.5297 13.1767 15.7369 9.9809C15.5608 9.3595 15.4727 8.7381 15.4727 8.07231C15.4727 5.54231 16.7087 3.05671 18.7757 1.54759C21.374 -0.27223 24.8972 -0.40539 27.5837 1.32566C29.4334 2.52407 30.6224 4.34686 31.0628 6.56615C31.283 7.80599 30.6459 8.77952 29.1075 8.82687ZM47.1022 2.24888C43.9783 2.24888 41.4328 4.80847 41.4328 7.96282C41.4328 11.1113 43.9753 13.6768 47.1022 13.6768C50.229 13.6768 52.7716 11.1113 52.7716 7.96282C52.7716 4.81142 50.229 2.24297 47.1022 2.24297V2.24888ZM47.1022 9.92763C46.0247 9.92763 45.1468 9.04879 45.1468 7.9569C45.1468 6.87093 46.0276 5.98913 47.1022 5.98913C48.1797 5.98913 49.0605 6.87389 49.0605 7.9569C49.0605 9.04879 48.1797 9.93059 47.1022 9.92763ZM23.4968 2.22521C20.825 2.22521 18.5878 4.0687 17.9595 6.56319V6.65196H29.0458C28.4498 4.12197 26.1891 2.23113 23.4938 2.23113V2.22521H23.4968Z",
            fill: "#13B5EA"
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: 40,
        height: 12,
        viewBox: "0 0 56 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M48.1645 16.1043C43.7703 16.1043 40.2047 12.5357 40.2047 8.14739C40.2047 3.75319 43.7762 0.18457 48.1645 0.18457C52.5587 0.18457 56.1244 3.75615 56.1244 8.14739C56.1244 12.5386 52.5528 16.1043 48.1645 16.1043ZM15.4522 16.0717C15.1592 16.0717 14.884 15.9504 14.6621 15.7285L8.61673 9.69202L2.54475 15.7492C2.34058 15.9504 2.0713 16.0688 1.78132 16.0688C1.18359 16.0688 0.692383 15.5776 0.692383 14.9798C0.692383 14.6869 0.810745 14.4147 1.02084 14.2016L7.05731 8.13555L1.02676 2.07837C0.804826 1.87419 0.692383 1.599 0.692383 1.30606C0.692383 0.705367 1.18359 0.223039 1.78132 0.223039C2.0713 0.223039 2.33762 0.332523 2.54475 0.533739L8.62561 6.59389L14.6858 0.542616C14.8899 0.332524 15.1651 0.223039 15.4551 0.223039C16.0795 0.223039 16.5648 0.711285 16.5648 1.30606C16.5648 1.59604 16.4789 1.86236 16.257 2.06949L10.1732 8.15035L16.2541 14.2194C16.4553 14.4235 16.5618 14.6928 16.5618 14.9828C16.5618 15.5805 16.0736 16.0717 15.4817 16.0717H15.4522ZM39.1749 2.48672C36.8195 2.78558 36.565 3.89523 36.565 6.64123V14.8881C36.565 15.4858 36.0768 15.9711 35.482 15.9711C34.8813 15.9711 34.396 15.4829 34.3931 14.8881V1.4836C34.3931 0.87995 34.8665 0.400582 35.4642 0.400582C35.9555 0.400582 36.3993 0.770464 36.4881 1.25575C37.287 0.637307 38.2635 0.317728 39.24 0.317728H39.5507C40.1277 0.317728 40.613 0.805974 40.613 1.40666C40.613 2.00143 40.1277 2.44825 39.5034 2.46896C39.5034 2.46896 39.237 2.46896 39.0181 2.49264L39.1749 2.48672ZM30.0285 9.01144H18.6923C18.6923 9.06766 18.7012 9.12092 18.7101 9.1801C18.7693 9.4908 18.8432 9.80446 18.9557 10.0974C19.5297 11.6687 21.2194 13.8702 24.3678 13.9146C25.3443 13.9057 26.235 13.6601 27.0309 13.237C27.6523 12.8819 28.1879 12.4351 28.5844 11.9705C28.7176 11.7989 28.8508 11.6391 28.9395 11.4734C29.4722 10.7957 30.1379 10.923 30.5374 11.2278C31.0227 11.6272 31.07 12.3848 30.6706 12.9144L30.6232 12.9618C30.0018 13.7607 29.336 14.4265 28.5844 14.9148C27.8299 15.4 27.0309 15.7551 26.1846 15.9356C25.2082 16.2019 24.2761 16.2434 23.2996 16.1132C20.0594 15.7137 17.3519 13.3612 16.5529 10.1655C16.3754 9.54407 16.2866 8.92267 16.2866 8.25688C16.2866 5.72689 17.5324 3.24128 19.6155 1.73216C22.2343 -0.0876595 25.7852 -0.22082 28.4927 1.51023C30.3569 2.70865 31.5553 4.53143 31.9992 6.75072C32.2211 7.99056 31.579 8.96409 30.0285 9.01144ZM48.1645 2.43345C45.0161 2.43345 42.4506 4.99304 42.4506 8.14739C42.4506 11.2958 45.0131 13.8613 48.1645 13.8613C51.3159 13.8613 53.8785 11.2958 53.8785 8.14739C53.8785 4.99599 51.3159 2.42754 48.1645 2.42754V2.43345ZM48.1645 10.1122C47.0785 10.1122 46.1938 9.23336 46.1938 8.14147C46.1938 7.0555 47.0815 6.1737 48.1645 6.1737C49.2505 6.1737 50.1382 7.05846 50.1382 8.14147C50.1382 9.23336 49.2505 10.1152 48.1645 10.1122ZM24.3737 2.40978C21.681 2.40978 19.4262 4.25327 18.7929 6.74776V6.83653H29.9663C29.3656 4.30654 27.0872 2.4157 24.3707 2.4157V2.40978H24.3737Z",
            fill: "#13B5EA"
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");
const $be67a57742d670b1$export$415ecc9b126d13ca = ({ condensed: condensed = false })=>{
    if (condensed) return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "55",
        height: "11",
        viewBox: "0 0 55 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M6.85841 8.28046L1.41665 0.208553L1.39227 0.17334H0V10.8266H1.48707V2.71951L6.92883 10.7914L6.95321 10.8266H8.34277V0.17334H6.85841V8.28046Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M20.8731 9.58658C20.7702 9.59742 20.6592 9.60013 20.5481 9.60013C19.8818 9.60013 19.5594 9.22091 19.5594 8.4381V4.3588H21.1901V3.13177H19.5594V1.0542H18.6385L18.1157 3.12093L16.8047 3.55703V4.3561H18.1049V8.44893C18.1049 9.27508 18.2863 9.89537 18.6439 10.2935C19.015 10.6944 19.5892 10.8949 20.3477 10.8949C20.5021 10.8949 20.651 10.8895 20.7865 10.8813C20.9327 10.8705 21.0763 10.8515 21.2171 10.8217L21.2794 10.8082V9.5297L21.1928 9.53782C21.0953 9.54866 20.9869 9.5622 20.8759 9.58116L20.8731 9.58658Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M36.0582 8.10451C35.8605 8.60291 35.5652 9.00921 35.1779 9.31258C34.7987 9.60783 34.3896 9.75952 33.9563 9.75952C33.4443 9.75952 33.0515 9.59429 32.7915 9.26924C32.5261 8.93878 32.3906 8.45393 32.3906 7.83093V3.13135H30.9333V7.87427C30.9333 8.87107 31.169 9.64575 31.6322 10.1794C32.1089 10.713 32.7834 10.9866 33.6393 10.9866C34.1973 10.9866 34.7201 10.8565 35.1914 10.6019C35.6167 10.3771 35.9824 10.0602 36.2803 9.66471L36.4889 10.8295H37.5155V3.13677H36.0582V8.10992V8.10451Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M38.9238 3.78929L39.6741 4.26602V10.8265H41.1314V3.13379H38.9238V3.78929Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M41.118 0.636719H39.3708V1.96398H41.118V0.636719Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M46.3107 9.58658C46.2077 9.59742 46.0967 9.60013 45.9856 9.60013C45.3193 9.60013 44.9969 9.22091 44.9969 8.4381V4.3588H46.6276V3.13177H44.9969V1.0542H44.076L43.5532 3.12093L42.2395 3.55703V4.3561H43.5397V8.44893C43.5397 9.27508 43.7212 9.89537 44.0814 10.2935C44.4525 10.6944 45.0267 10.8949 45.7852 10.8949C45.9396 10.8949 46.0886 10.8895 46.224 10.8813C46.3703 10.8705 46.5138 10.8515 46.6547 10.8217L46.717 10.8082V9.5297L46.6303 9.53782C46.5328 9.54866 46.4244 9.5622 46.3134 9.58116L46.3107 9.58658Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M54.1794 6.53334C54.1794 4.17136 53.0932 2.97412 50.9534 2.97412C49.8482 2.97412 48.9841 3.31271 48.3828 3.98176C47.7788 4.66705 47.4971 5.59614 47.4971 6.90714C47.4971 8.21815 47.8086 9.25287 48.4261 9.94901C49.0546 10.637 49.9864 10.9864 51.1971 10.9864C51.728 10.9864 52.2237 10.9377 52.6734 10.8402C53.1339 10.7427 53.5049 10.6072 53.7812 10.4393L53.8192 10.4149V9.14994L53.7081 9.20141C53.3126 9.38018 52.9199 9.51561 52.5407 9.59958C52.1614 9.68355 51.7551 9.72689 51.3299 9.72689C50.5741 9.72689 49.9999 9.53999 49.6234 9.17161C49.2577 8.80594 49.0383 8.22357 48.9733 7.44346H54.1794V6.52793V6.53334ZM48.9733 6.26518C49.0194 5.60697 49.2063 5.09774 49.5232 4.75102C49.8618 4.38535 50.3439 4.19845 50.9534 4.19845C51.6007 4.19845 52.0639 4.36368 52.3375 4.69143C52.6111 5.01106 52.7546 5.53925 52.7655 6.26518H48.9733Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M13.0559 2.97417C11.9508 2.97417 11.0867 3.31275 10.4854 3.9818C9.88131 4.6671 9.59961 5.59618 9.59961 6.90719C9.59961 8.2182 9.91111 9.25292 10.5314 9.94905C11.1598 10.6371 12.0916 10.9865 13.3024 10.9865C13.8333 10.9865 14.329 10.9377 14.7786 10.8402C15.2391 10.7427 15.6102 10.6073 15.8865 10.4393L15.9244 10.4149V9.14999L15.8134 9.20145C15.4179 9.38023 15.0251 9.51566 14.6459 9.59963C14.2667 9.6836 13.8604 9.72694 13.4351 9.72694C12.6794 9.72694 12.1051 9.54004 11.7286 9.17166C11.363 8.80598 11.1436 8.22361 11.0786 7.44351H16.2847V6.52797C16.2847 4.16599 15.1985 2.96875 13.0586 2.96875L13.0559 2.97417ZM11.0758 6.26523C11.1219 5.60702 11.3088 5.09778 11.6257 4.75107C11.9643 4.3854 12.4464 4.1985 13.0559 4.1985C13.7033 4.1985 14.1665 4.36373 14.44 4.69148C14.7136 5.0111 14.8572 5.5393 14.868 6.26523H11.0758Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M29.1862 6.20561C28.7772 5.72618 28.0756 5.29278 27.1059 4.91357L25.9954 4.48018C25.3046 4.20389 24.8171 3.94386 24.5462 3.70007C24.2808 3.46442 24.1534 3.18542 24.1534 2.84954C24.1534 1.82566 24.8983 1.32726 26.4287 1.32726C27.2414 1.32726 28.1434 1.53854 29.1104 1.95568L29.2214 2.00443V0.652795L29.1808 0.631126C28.8205 0.4361 28.3817 0.281704 27.8752 0.176065C27.3714 0.0595916 26.8757 0 26.399 0C25.2505 0 24.3322 0.257326 23.6659 0.76656C22.9941 1.28121 22.6528 1.99089 22.6528 2.87934C22.6528 3.50234 22.8641 4.05491 23.2812 4.52081C23.7011 4.97045 24.3918 5.38488 25.3317 5.75326L26.445 6.18665C27.1628 6.46294 27.6639 6.73381 27.9348 6.99384C28.1975 7.24575 28.3303 7.57079 28.3303 7.96085C28.3303 8.49717 28.1136 8.90618 27.672 9.20955C27.2359 9.51564 26.6129 9.67274 25.8274 9.67274C24.8794 9.67274 23.869 9.45605 22.8262 9.02807L22.7178 8.98473V10.3364L22.7612 10.358C23.0077 10.4772 23.3083 10.5856 23.655 10.6804C24.0045 10.7779 24.381 10.8564 24.7764 10.9133C25.18 10.9702 25.5728 11 25.9412 11C27.1574 11 28.1163 10.7318 28.7907 10.2036C29.4814 9.6619 29.8309 8.89535 29.8309 7.93105C29.8309 7.25929 29.6142 6.67964 29.1916 6.20561H29.1862Z",
                fill: "white"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "69",
        height: "14",
        viewBox: "0 0 69 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M8.72888 10.5389L1.803 0.26552L1.77198 0.220703H0V13.7794H1.89264V3.46128L8.81852 13.7346L8.84954 13.7794H10.6181V0.220703H8.72888V10.5389Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M26.566 12.2007C26.435 12.2145 26.2936 12.2179 26.1523 12.2179C25.3042 12.2179 24.894 11.7353 24.894 10.739V5.54717H26.9693V3.98549H24.894V1.34131H23.7218L23.0565 3.9717L21.3879 4.52673V5.54372H23.0427V10.7528C23.0427 11.8042 23.2737 12.5937 23.7287 13.1005C24.201 13.6107 24.9319 13.8658 25.8972 13.8658C26.0937 13.8658 26.2833 13.8589 26.4557 13.8486C26.6418 13.8348 26.8245 13.8106 27.0038 13.7727L27.0831 13.7555V12.1283L26.9728 12.1386C26.8487 12.1524 26.7108 12.1697 26.5694 12.1938L26.566 12.2007Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M45.8922 10.3148C45.6405 10.9492 45.2647 11.4663 44.7717 11.8524C44.2891 12.2281 43.7685 12.4212 43.217 12.4212C42.5654 12.4212 42.0655 12.2109 41.7346 11.7972C41.3967 11.3766 41.2243 10.7595 41.2243 9.96664V3.98535H39.3696V10.0218C39.3696 11.2904 39.6696 12.2764 40.2591 12.9556C40.8658 13.6347 41.7242 13.9829 42.8136 13.9829C43.5238 13.9829 44.1891 13.8174 44.789 13.4934C45.3302 13.2072 45.7956 12.8039 46.1749 12.3005L46.4403 13.7829H47.7469V3.99225H45.8922V10.3217V10.3148Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M49.5396 4.82305L50.4945 5.42979V13.7795H52.3492V3.98877H49.5396V4.82305Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M52.332 0.810059H50.1084V2.4993H52.332V0.810059Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M58.9408 12.2007C58.8098 12.2145 58.6684 12.2179 58.5271 12.2179C57.679 12.2179 57.2688 11.7353 57.2688 10.739V5.54717H59.3441V3.98549H57.2688V1.34131H56.0966L55.4313 3.9717L53.7593 4.52673V5.54372H55.414V10.7528C55.414 11.8042 55.645 12.5937 56.1035 13.1005C56.5758 13.6107 57.3067 13.8658 58.272 13.8658C58.4685 13.8658 58.6581 13.8589 58.8304 13.8486C59.0166 13.8348 59.1993 13.8106 59.3786 13.7727L59.4579 13.7555V12.1283L59.3476 12.1386C59.2234 12.1524 59.0855 12.1697 58.9442 12.1938L58.9408 12.2007Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M68.9555 8.31507C68.9555 5.30892 67.5731 3.78516 64.8496 3.78516C63.443 3.78516 62.3433 4.21609 61.578 5.0676C60.8092 5.9398 60.4507 7.12227 60.4507 8.79082C60.4507 10.4594 60.8471 11.7763 61.6331 12.6623C62.433 13.5379 63.6189 13.9826 65.1599 13.9826C65.8356 13.9826 66.4664 13.9206 67.0387 13.7965C67.6248 13.6724 68.0971 13.5 68.4487 13.2863L68.497 13.2552V11.6453L68.3556 11.7108C67.8523 11.9383 67.3524 12.1107 66.8698 12.2176C66.3872 12.3244 65.87 12.3796 65.3288 12.3796C64.367 12.3796 63.6361 12.1417 63.1569 11.6729C62.6915 11.2075 62.4123 10.4663 62.3295 9.47341H68.9555V8.30818V8.31507ZM62.3295 7.97378C62.3881 7.13606 62.626 6.48794 63.0294 6.04667C63.4603 5.58127 64.0739 5.34339 64.8496 5.34339C65.6735 5.34339 66.263 5.55369 66.6112 5.97082C66.9594 6.37762 67.1421 7.04987 67.1559 7.97378H62.3295Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M16.6164 3.78522C15.2099 3.78522 14.1102 4.21614 13.3448 5.06766C12.5761 5.93986 12.2175 7.12232 12.2175 8.79088C12.2175 10.4594 12.614 11.7764 13.4034 12.6623C14.2032 13.538 15.3892 13.9827 16.9302 13.9827C17.6059 13.9827 18.2367 13.9206 18.809 13.7965C19.3951 13.6724 19.8674 13.5001 20.219 13.2863L20.2673 13.2553V11.6453L20.1259 11.7108C19.6226 11.9384 19.1227 12.1108 18.6401 12.2176C18.1574 12.3245 17.6403 12.3797 17.0991 12.3797C16.1373 12.3797 15.4064 12.1418 14.9272 11.6729C14.4618 11.2075 14.1826 10.4663 14.0998 9.47347H20.7258V8.30824C20.7258 5.30208 19.3434 3.77832 16.6199 3.77832L16.6164 3.78522ZM14.0964 7.97384C14.155 7.13611 14.3929 6.488 14.7962 6.04673C15.2271 5.58133 15.8408 5.34345 16.6164 5.34345C17.4404 5.34345 18.0299 5.55375 18.3781 5.97088C18.7263 6.37768 18.909 7.04993 18.9228 7.97384H14.0964Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M37.146 7.89805C36.6254 7.28786 35.7326 6.73627 34.4984 6.25363L33.0849 5.70204C32.2058 5.35041 31.5853 5.01945 31.2406 4.70918C30.9027 4.40926 30.7407 4.05417 30.7407 3.62669C30.7407 2.32357 31.6887 1.68924 33.6365 1.68924C34.6708 1.68924 35.8187 1.95814 37.0495 2.48904L37.1908 2.5511V0.83083L37.1391 0.803251C36.6806 0.555036 36.1221 0.358533 35.4775 0.224083C34.8362 0.0758439 34.2053 0 33.5986 0C32.1369 0 30.9682 0.327506 30.1201 0.975622C29.2652 1.63063 28.8308 2.53386 28.8308 3.66461C28.8308 4.45752 29.0997 5.1608 29.6306 5.75375C30.165 6.32603 31.0441 6.85348 32.2403 7.32233L33.6572 7.87392C34.5708 8.22556 35.2085 8.5703 35.5533 8.90126C35.8877 9.22187 36.0566 9.63556 36.0566 10.132C36.0566 10.8146 35.7808 11.3351 35.2189 11.7213C34.6639 12.1108 33.8709 12.3108 32.8712 12.3108C31.6646 12.3108 30.3787 12.035 29.0514 11.4903L28.9136 11.4351V13.1554L28.9687 13.183C29.2824 13.3346 29.6651 13.4725 30.1064 13.5932C30.5511 13.7173 31.0303 13.8173 31.5336 13.8897C32.0473 13.9621 32.5471 14 33.016 14C34.5639 14 35.7843 13.6587 36.6427 12.9865C37.5218 12.297 37.9665 11.3213 37.9665 10.0941C37.9665 9.2391 37.6907 8.50135 37.1529 7.89805H37.146Z",
                fill: "white"
            })
        ]
    });
};


const $9566eba0569deebe$export$b853f99e0a417737 = ({ connectorType: connectorType, condensed: condensed = false, large: large = false })=>{
    switch(connectorType){
        case (0, $f19d5eec019b83cc$export$18dbf40ba8d1d9db).QUICKBOOKS:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4aeb005b0126a6d$export$b1ecdf8748e39236), {
                condensed: condensed,
                large: large
            });
        case (0, $f19d5eec019b83cc$export$18dbf40ba8d1d9db).QUICKBOOKS_DESKTOP:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4aeb005b0126a6d$export$b1ecdf8748e39236), {
                condensed: condensed,
                large: large
            });
        case (0, $f19d5eec019b83cc$export$18dbf40ba8d1d9db).QUICKBOOKS_SANDBOX:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4aeb005b0126a6d$export$b1ecdf8748e39236), {
                condensed: condensed,
                large: large
            });
        case (0, $f19d5eec019b83cc$export$18dbf40ba8d1d9db).XERO:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb911d9650c221d5$export$a2aa015c05602446), {
                condensed: condensed,
                large: large
            });
        case (0, $f19d5eec019b83cc$export$18dbf40ba8d1d9db).NETSUITE:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be67a57742d670b1$export$415ecc9b126d13ca), {
                condensed: condensed,
                large: large
            });
        default:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9e73f507bb05d0c8$export$2e2bcd8739ae039), {
                width: 16
            });
    }
};




var $r2uF6 = parcelRequire("r2uF6");

const $b010adf4533db8e7$export$1c5ebe55f48780cb = (0, $r2uF6.atom)({
    isLoading: false,
    isError: false,
    data: null
});
const $b010adf4533db8e7$export$a617251a29004011 = (0, $r2uF6.atom)({
    isLoading: false,
    isError: false,
    data: null
});
const $b010adf4533db8e7$export$7ab360575ca3dbe = (0, $r2uF6.atom)({
    isLoading: false,
    isError: false,
    data: null
});
const $b010adf4533db8e7$export$b0056b5eb48ed0b0 = (0, $r2uF6.atom)((get)=>{
    const connectorFiles = get($b010adf4533db8e7$export$7ab360575ca3dbe);
    const draftList = get((0, $540fa3f25212c24e$export$4a2c69def00f1863));
    console.log("connectorTreeListAtom recomputing:", {
        draftsLength: draftList.data?.length,
        connectorFilesLength: connectorFiles.data?.length
    });
    const toFileTree = (file)=>{
        const draft = draftList.data?.find((d)=>d.fileId === file.id);
        return {
            name: file.name,
            documentKind: file.documentKind,
            date: file.createdAt,
            id: file.id,
            draft: draft ? {
                id: draft.id,
                status: draft.status === "committed" ? "committed" : "uncommitted",
                date: draft.createdAt
            } : null,
            labeledFiles: file.labeledFiles.map((lf)=>({
                    id: lf.id,
                    date: lf.name
                }))
        };
    };
    if (!connectorFiles.data) return {
        isLoading: connectorFiles.isLoading,
        isError: connectorFiles.isError,
        data: null
    };
    const data = connectorFiles.data.map((connector)=>{
        const allFiles = [
            connector.mostRecent.income_statement,
            connector.mostRecent.balance_sheet,
            connector.historical.income_statement,
            connector.historical.balance_sheet,
            connector.current
        ].filter((f)=>f !== null);
        const hasUnlabeledFiles = allFiles.some((file)=>file.labeledFiles.length === 0);
        return {
            sourceConnectorId: connector.sourceConnectorId,
            sourceConnectorType: connector.sourceConnectorType,
            hasUnlabeledFiles: hasUnlabeledFiles,
            mostRecent: {
                income_statement: connector.mostRecent.income_statement ? toFileTree(connector.mostRecent.income_statement) : null,
                balance_sheet: connector.mostRecent.balance_sheet ? toFileTree(connector.mostRecent.balance_sheet) : null
            },
            historical: {
                income_statement: connector.historical.income_statement ? toFileTree(connector.historical.income_statement) : null,
                balance_sheet: connector.historical.balance_sheet ? toFileTree(connector.historical.balance_sheet) : null
            },
            current: connector.current ? toFileTree(connector.current) : null
        };
    });
    return {
        isLoading: connectorFiles.isLoading,
        isError: connectorFiles.isError,
        data: data
    };
});





function $e81a3bbc6dc2e118$var$isFileInTree(tree, fileId) {
    if (!tree) return false;
    if (tree.id === fileId) return true;
    return tree.labeledFiles?.some((lf)=>lf.id === fileId) ?? false;
}
function $e81a3bbc6dc2e118$var$findFileCategoryKey(data, fileId) {
    for (const connector of data){
        if ($e81a3bbc6dc2e118$var$isFileInTree(connector.current, fileId)) return "current";
        for (const statementType of (0, $af64889d1af19aba$export$2d24c055ca23de42)){
            if ($e81a3bbc6dc2e118$var$isFileInTree(connector.mostRecent[statementType], fileId)) return "mostRecent";
            if ($e81a3bbc6dc2e118$var$isFileInTree(connector.historical[statementType], fileId)) return "historical";
        }
    }
    return null;
}
function $e81a3bbc6dc2e118$export$39286f238df50487() {
    const { data: selectedFile, isLoading: isLoading } = (0, $r2uF6.useAtomValue)((0, $175863902df2ee1a$export$380f8a5d1313e761));
    const { data: connectorTreeList, isLoading: isConnectorTreeListLoading } = (0, $r2uF6.useAtomValue)((0, $b010adf4533db8e7$export$b0056b5eb48ed0b0));
    const { selectedFileId: selectedFileId, selectedDraftId: selectedDraftId } = (0, $r2uF6.useAtomValue)((0, $175863902df2ee1a$export$4d2c75fe8b80fe70));
    const router = (0, $fp4OM.useRouter)();
    const isReadonly = !router.params.draftId;
    const isDraft = !!selectedDraftId;
    const draft = (0, $r2uF6.useAtomValue)((0, $540fa3f25212c24e$export$b0cbc03b849c7b1f));
    const setLabelingContextView = (0, $r2uF6.useSetAtom)((0, $3e16d0e17c6c7886$export$5f8d21c57c3fb992));
    const applyExistingAccounts = (0, $r2uF6.useSetAtom)((0, $540fa3f25212c24e$export$df1af0fca7923243));
    const categoryKey = (0, $acw62.useMemo)(()=>{
        if (!connectorTreeList || !selectedFileId) return null;
        return $e81a3bbc6dc2e118$var$findFileCategoryKey(connectorTreeList, selectedFileId);
    }, [
        connectorTreeList,
        selectedFileId
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("bg-selected h-[56px] w-full", "animate-pulse rounded")
    });
    if (!selectedFile) return null;
    const connector = selectedFile.meta?.rawConnector;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex flex-col gap-5",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, $9QePP.default)("w-full", "flex items-start justify-between gap-10"),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex w-full flex-col gap-1",
                    children: [
                        !!connector && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9566eba0569deebe$export$b853f99e0a417737), {
                                    connectorType: selectedFile.meta?.rawConnector?.kind,
                                    large: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex items-baseline gap-2",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        className: "pageheading ml-1 break-all",
                                        children: (0, $a9fafe23bcb6020a$export$775afd4b12f86320)[selectedFile.documentKind || ""] || "Unknown Statement Type"
                                    })
                                })
                            ]
                        }),
                        !connector && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex flex-col gap-1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pageheading cursor-default",
                                children: selectedFile.name
                            })
                        }),
                        isDraft && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "body-s cursor-default text-slate-500",
                                    children: [
                                        "Draft ",
                                        selectedDraftId.slice(-6)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "h-4 w-px bg-slate-600"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "body-s cursor-default text-slate-500",
                                    children: draft.data?.status === (0, $156754416c8f457d$export$ad9db10db9173ca8).COMMITTED ? "Commited" : "In Progress"
                                })
                            ]
                        }),
                        !isDraft && !isConnectorTreeListLoading && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                categoryKey && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "body-s cursor-default text-slate-500",
                                            children: (0, $af64889d1af19aba$export$680cd113e2939fb5)[categoryKey]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "h-4 w-px bg-slate-600"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "body-s cursor-default text-slate-500",
                                    children: [
                                        "Created on",
                                        " ",
                                        (0, $kdwja.formatDate)(selectedFile.createdAt, {
                                            outputFormat: "MMM DD, YYYY"
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isDraft && isConnectorTreeListLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: (0, $9QePP.default)("h-5 w-20 animate-pulse rounded-full bg-slate-600")
                        })
                    ]
                }),
                isDraft && !isReadonly && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dkTlU.FloatingMenu), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dkTlU.FloatingMenuCommand), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce87dd83611a24b5$export$2e2bcd8739ae039), {
                                className: "size-5 cursor-pointer"
                            }),
                            command: {
                                label: "Account management (\u2318E)",
                                shortcut: {
                                    key: "e",
                                    mac: "\u2318E",
                                    windows: "Ctrl+E"
                                },
                                onClick: ()=>{
                                    setLabelingContextView({
                                        type: "ACCOUNT_LIST_EDIT"
                                    });
                                }
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dkTlU.FloatingMenuCommand), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fc1405939c84d0e6$export$2e2bcd8739ae039), {
                                className: "size-5 cursor-pointer"
                            }),
                            command: {
                                label: "Accept account hints (\u2318L)",
                                shortcut: {
                                    key: "l",
                                    mac: "\u2318L",
                                    windows: "Ctrl+L"
                                },
                                onClick: applyExistingAccounts
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dkTlU.FloatingMenuCommand), {
                            text: "Commit",
                            command: {
                                label: "Commit draft (\u2318S)",
                                shortcut: {
                                    key: "s",
                                    mac: "\u2318S",
                                    windows: "Ctrl+S"
                                },
                                onClick: ()=>{
                                    setLabelingContextView({
                                        type: "DRAFT_COMMIT"
                                    });
                                }
                            }
                        })
                    ]
                })
            ]
        })
    });
}





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("8OvTp");
var $bCrQI = parcelRequire("bCrQI");


var $acw62 = parcelRequire("acw62");

var $gngdn = parcelRequire("gngdn");


parcelRequire("UXGeS");
var $7Y7Q4 = parcelRequire("7Y7Q4");

var $acw62 = parcelRequire("acw62");

var $r2uF6 = parcelRequire("r2uF6");


function $f56fb6d3f0e73a3a$export$2fe5716a36628a75() {
    const res = (0, $7Y7Q4.useApiQuery)((0, $d467c533cc3c7dc1$export$d964e69f1fd5fd4c));
    const status = (0, $r2uF6.useAtomValue)((0, $da6866c58be47883$export$c413f16854e508b7));
    const statementType = (0, $r2uF6.useAtomValue)((0, $da6866c58be47883$export$7dbd57354a14102d));
    const cleanedFiles = (0, $acw62.useMemo)(()=>{
        if (!res.data) return [];
        return res.data.filter((file)=>file.documentType === (0, $f19d5eec019b83cc$export$d1d99cf900472499).CLEANED);
    }, [
        res.data
    ]);
    const labeledFiles = (0, $acw62.useMemo)(()=>{
        if (!res.data) return [];
        return res.data.filter((file)=>file.documentType === (0, $f19d5eec019b83cc$export$d1d99cf900472499).LABELED);
    }, [
        res.data
    ]);
    const unlabeledFiles = (0, $acw62.useMemo)(()=>{
        if (!cleanedFiles.length) return [];
        return cleanedFiles.filter((file)=>!labeledFiles.find((labeledFile)=>labeledFile.producedFromFile === file.id));
    }, [
        cleanedFiles,
        labeledFiles
    ]);
    const files = (0, $acw62.useMemo)(()=>{
        if (status === (0, $a9fafe23bcb6020a$export$23ce6754e6e099fa).CLEANED) return cleanedFiles;
        else if (status === (0, $a9fafe23bcb6020a$export$23ce6754e6e099fa).UNLABELED) return unlabeledFiles;
        else if (status === (0, $a9fafe23bcb6020a$export$23ce6754e6e099fa).LABELED) return labeledFiles;
        else if (status === (0, $a9fafe23bcb6020a$export$23ce6754e6e099fa).ALL) return res.data;
        else return [];
    }, [
        cleanedFiles,
        labeledFiles,
        unlabeledFiles,
        res.data,
        status
    ]);
    const filteredFiles = (0, $acw62.useMemo)(()=>{
        if (!files) return [];
        if (statementType === "all") return files;
        return files.filter((file)=>file.documentKind === statementType);
    }, [
        files,
        statementType
    ]);
    return {
        files: filteredFiles,
        unlabeledFiles: unlabeledFiles,
        labeledFiles: labeledFiles,
        cleanedFiles: cleanedFiles,
        allFiles: files,
        isLoading: res.isLoading,
        isError: res.isError
    };
}



var $r2uF6 = parcelRequire("r2uF6");

function $0004c81bac9d4e37$export$981909ff1de7cf37() {
    const localStorageData = (0, $032deecb0f4a84f7$export$d3720feff416e85b)((0, $032deecb0f4a84f7$export$e9d9376124133876).Labeling);
    const [recentlyViewed, setRecentlyViewed] = (0, $acw62.useState)(localStorageData?.recentlyViewed || []);
    const { data: selectedFile } = (0, $r2uF6.useAtomValue)((0, $175863902df2ee1a$export$380f8a5d1313e761));
    const { data: currentDraft } = (0, $r2uF6.useAtomValue)((0, $540fa3f25212c24e$export$6f6480b3b0a87b58));
    const { unlabeledFiles: unlabeledFiles, cleanedFiles: cleanedFiles, isLoading: isLoading } = (0, $f56fb6d3f0e73a3a$export$2fe5716a36628a75)();
    const pushRecentlyViewed = (0, $acw62.useCallback)((item)=>{
        setRecentlyViewed((prev)=>{
            const newItem = {
                ...item,
                viewedAt: (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))().format("YYYY-MM-DDTHH:mm:ss.SSSSSS[Z]")
            };
            const filtered = prev.filter((existing)=>existing.fileSnapshot.id !== item.fileSnapshot.id).sort((a, b)=>new Date(b.viewedAt).getTime() - new Date(a.viewedAt).getTime());
            const updated = [
                newItem,
                ...filtered
            ];
            return updated.slice(0, 3);
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        (0, $032deecb0f4a84f7$export$1f73f60bdb811cb1)((0, $032deecb0f4a84f7$export$e9d9376124133876).Labeling, {
            recentlyViewed: recentlyViewed
        });
    }, [
        recentlyViewed
    ]);
    (0, $acw62.useEffect)(()=>{
        if (selectedFile) {
            const recentlyViewedItem = {
                fileSnapshot: selectedFile,
                viewedAt: (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))().format("YYYY-MM-DDTHH:mm:ss.SSSSSS[Z]")
            };
            if (currentDraft) recentlyViewedItem.draft = {
                id: currentDraft.id,
                status: currentDraft.status,
                fileId: currentDraft.fileId,
                createdBy: currentDraft.ownerId,
                createdAt: currentDraft.createdAt,
                committedAt: null
            };
            pushRecentlyViewed(recentlyViewedItem);
        }
    }, [
        selectedFile,
        currentDraft,
        pushRecentlyViewed
    ]);
    const parsedRecentlyViewed = (0, $acw62.useMemo)(()=>{
        return recentlyViewed.map((item)=>({
                href: `/beta/companies/${item.fileSnapshot.companyId}/labeling/files/${item.fileSnapshot.id}${item.draft ? `/drafts/${item.draft.id}` : ""}`,
                ...item
            })).sort((a, b)=>new Date(b.viewedAt).getTime() - new Date(a.viewedAt).getTime());
    }, [
        recentlyViewed
    ]);
    const quickActions = (0, $acw62.useMemo)(()=>{
        const mostRecentUnlabeledFile = [
            ...unlabeledFiles
        ].sort((a, b)=>new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())[0];
        const actions = [];
        if (recentlyViewed.length > 0) {
            const mostRecentlyViewed = parsedRecentlyViewed[0];
            actions.push({
                label: `Open most recently viewed file`,
                href: mostRecentlyViewed.href,
                isLoading: false
            });
        }
        if (mostRecentUnlabeledFile) actions.push({
            label: `Open most recently created unlabeled file`,
            href: `/beta/companies/${mostRecentUnlabeledFile.companyId}/labeling/files/${mostRecentUnlabeledFile.id}`,
            isLoading: false
        });
        else if (cleanedFiles.length > 0) actions.push({
            label: `Open most recently created file`,
            href: `/beta/companies/${cleanedFiles[0].companyId}/labeling/files/${cleanedFiles[0].id}`,
            isLoading: false
        });
        return actions;
    }, [
        unlabeledFiles,
        cleanedFiles,
        isLoading,
        parsedRecentlyViewed
    ]);
    return {
        recentlyViewed: parsedRecentlyViewed,
        quickActions: quickActions,
        pushRecentlyViewed: pushRecentlyViewed
    };
}



parcelRequire("18L7n");
var $5Ttm9 = parcelRequire("5Ttm9");
function $be0b2fec5eb99e3a$export$3f12d05be03333e() {
    const { quickActions: quickActions } = (0, $0004c81bac9d4e37$export$981909ff1de7cf37)();
    const { files: files, isLoading: isLoading } = (0, $f56fb6d3f0e73a3a$export$2fe5716a36628a75)();
    if (files.length === 0 && isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
        fullScreen: true
    });
    let description = "User has no files available. When data is connected or files uploaded, files will appear here.";
    if (files.length > 0) description = "Search for a file on the left or use one of the quick actions below.";
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bCrQI.default).Container, {
        title: "Labeling",
        description: description,
        children: quickActions.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bCrQI.default).QuickActionList, {
            children: quickActions.map((action)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bCrQI.default).QuickActionItem, {
                    href: action.href,
                    label: action.label,
                    isLoading: action.isLoading
                }, action.label))
        })
    });
}





var $ayMG0 = parcelRequire("ayMG0");


var $r2uF6 = parcelRequire("r2uF6");

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $r2uF6 = parcelRequire("r2uF6");


parcelRequire("18L7n");
var $a6Thc = parcelRequire("a6Thc");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $25054b32cfb77fe5$var$XCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $25054b32cfb77fe5$var$ForwardRef = $acw62.forwardRef($25054b32cfb77fe5$var$XCircleIcon);
var $25054b32cfb77fe5$export$2e2bcd8739ae039 = $25054b32cfb77fe5$var$ForwardRef;



var $bhkIv = parcelRequire("bhkIv");



var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");


function $c8abbd23382ff19c$export$835fcf23ab7bf88({ labels: labels, selectedLabel: selectedLabel, onLabelSelection: onLabelSelection, recommendedLabels: recommendedLabels = [], className: className }) {
    const { groupedLabels: groupedLabels, categories: categories, hotkeyMap: hotkeyMap } = (0, $acw62.useMemo)(()=>{
        const groups = {};
        labels.forEach((label)=>{
            const category = label.category;
            if (!category) return;
            if (!groups[category]) groups[category] = [];
            groups[category].push(label);
        });
        const cats = Object.keys(groups);
        const hotkeys = {};
        let globalIndex = 0;
        for (const cat of cats)for (const label of groups[cat]){
            if (globalIndex < 3) hotkeys[label.code] = globalIndex + 1;
            globalIndex++;
        }
        return {
            groupedLabels: groups,
            categories: cats,
            hotkeyMap: hotkeys
        };
    }, [
        labels
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("pb-4", "hide-scrollbar flex flex-1 flex-col gap-4 overflow-y-auto", className),
        children: categories.map((category)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, $9QePP.default)("lozenge", "flex items-center gap-4 px-3 py-4 font-medium"),
                        children: (0, $af64889d1af19aba$export$c40eb1dced6d2957)[category]?.name || category
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        role: "list",
                        className: "flex flex-col gap-1",
                        children: groupedLabels[category].map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $504c29a55da928b3$export$dcfb49240088e87f), {
                                dot: true,
                                listItem: true,
                                label: item,
                                className: (0, $9QePP.default)(selectedLabel === item.code && "selected"),
                                onClick: ()=>{
                                    onLabelSelection(item.code);
                                },
                                recommended: recommendedLabels.includes(item.code),
                                hotkeyNumber: hotkeyMap[item.code]
                            }, item.code))
                    })
                ]
            }, category))
    });
}



var $7qKRb = parcelRequire("7qKRb");

var $2uohp = parcelRequire("2uohp");
const $0142a71e53ea6743$var$_state = {};
function $0142a71e53ea6743$var$v7(options, buf, offset) {
    let bytes;
    if (options) bytes = $0142a71e53ea6743$var$v7Bytes(options.random ?? options.rng?.() ?? (0, $7qKRb.default)(), options.msecs, options.seq, buf, offset);
    else {
        const now = Date.now();
        const rnds = (0, $7qKRb.default)();
        $0142a71e53ea6743$export$4d3b2225f783356f($0142a71e53ea6743$var$_state, now, rnds);
        bytes = $0142a71e53ea6743$var$v7Bytes(rnds, $0142a71e53ea6743$var$_state.msecs, $0142a71e53ea6743$var$_state.seq, buf, offset);
    }
    return buf ?? (0, $2uohp.unsafeStringify)(bytes);
}
function $0142a71e53ea6743$export$4d3b2225f783356f(state, now, rnds) {
    state.msecs ??= -Infinity;
    state.seq ??= 0;
    if (now > state.msecs) {
        state.seq = rnds[6] << 23 | rnds[7] << 16 | rnds[8] << 8 | rnds[9];
        state.msecs = now;
    } else {
        state.seq = state.seq + 1 | 0;
        if (state.seq === 0) state.msecs++;
    }
    return state;
}
function $0142a71e53ea6743$var$v7Bytes(rnds, msecs, seq, buf, offset = 0) {
    if (rnds.length < 16) throw new Error("Random bytes length must be >= 16");
    if (!buf) {
        buf = new Uint8Array(16);
        offset = 0;
    } else {
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
    }
    msecs ??= Date.now();
    seq ??= rnds[6] * 0x7f << 24 | rnds[7] << 16 | rnds[8] << 8 | rnds[9];
    buf[offset++] = msecs / 0x10000000000 & 0xff;
    buf[offset++] = msecs / 0x100000000 & 0xff;
    buf[offset++] = msecs / 0x1000000 & 0xff;
    buf[offset++] = msecs / 0x10000 & 0xff;
    buf[offset++] = msecs / 0x100 & 0xff;
    buf[offset++] = msecs & 0xff;
    buf[offset++] = 0x70 | seq >>> 28 & 0x0f;
    buf[offset++] = seq >>> 20 & 0xff;
    buf[offset++] = 0x80 | seq >>> 14 & 0x3f;
    buf[offset++] = seq >>> 6 & 0xff;
    buf[offset++] = seq << 2 & 0xff | rnds[10] & 0x03;
    buf[offset++] = rnds[11];
    buf[offset++] = rnds[12];
    buf[offset++] = rnds[13];
    buf[offset++] = rnds[14];
    buf[offset++] = rnds[15];
    return buf;
}
var $0142a71e53ea6743$export$2e2bcd8739ae039 = $0142a71e53ea6743$var$v7;



var $acw62 = parcelRequire("acw62");
function $d0f12e2fde4c3577$export$71df7237f99e303a(callback, options) {
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (e.key === "Enter" && e.shiftKey === !!options?.shiftKey) {
                e.preventDefault();
                callback();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>window.removeEventListener("keydown", handleKeyDown);
    }, [
        callback,
        options?.shiftKey
    ]);
}


function $c9c37778111ae541$export$b841b541bc741e79() {
    const setContextView = (0, $r2uF6.useSetAtom)((0, $3e16d0e17c6c7886$export$5f8d21c57c3fb992));
    const setSelectedRow = (0, $r2uF6.useSetAtom)((0, $ebd8595742de66c3$export$7770f7cfbd1735b));
    const setAccountApplication = (0, $r2uF6.useSetAtom)((0, $540fa3f25212c24e$export$af3bfe24cf5eb5a6));
    const selectedRow = (0, $r2uF6.useAtomValue)((0, $ebd8595742de66c3$export$7770f7cfbd1735b));
    const initial = selectedRow?.account;
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const [accountName, setAccountName] = (0, $acw62.useState)(selectedRow?.rowHeader || null);
    const [selectedLabel, setAccountLabel] = (0, $acw62.useState)(selectedRow?.account?.label ?? null);
    const getErrorMessage = (0, $r2uF6.useAtomValue)((0, $c02997182c8770ac$export$fd1c089d2a3107a9));
    const errorMessage = accountName ? getErrorMessage(accountName, {
        currentRowIndex: selectedRow?.rowIndex
    }) : null;
    const setAccounts = (0, $r2uF6.useSetAtom)((0, $9bf0cfccc28125c5$export$eb049f2950249542));
    (0, $acw62.useEffect)(()=>{
        if (selectedRow?.account?.label && selectedRow?.account?.accountName) {
            setAccountLabel(selectedRow?.account?.label);
            setAccountName(selectedRow?.account?.accountName);
        }
    }, [
        selectedRow?.account?.label,
        selectedRow?.account?.accountName,
        setAccountLabel,
        setAccountName
    ]);
    const handleSubmit = (0, $acw62.useCallback)(()=>{
        if (accountName && selectedLabel && !errorMessage && selectedRow) {
            const localAccountId = (0, $0142a71e53ea6743$export$2e2bcd8739ae039)();
            setAccounts({
                id: localAccountId,
                type: (0, $156754416c8f457d$export$a16002ff4149470e).NEW,
                name: accountName,
                label: selectedLabel
            });
            setAccountApplication({
                rowHeader: selectedRow.rowIndex,
                accountId: localAccountId
            });
            setSelectedRow(null);
        }
    }, [
        accountName,
        selectedLabel,
        errorMessage,
        selectedRow,
        setAccounts,
        setAccountApplication,
        setSelectedRow
    ]);
    (0, $d0f12e2fde4c3577$export$71df7237f99e303a)(handleSubmit, {
        shiftKey: true
    });
    if (!selectedRow) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("absolute inset-0 flex min-h-0 flex-col overflow-hidden"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("mb-3 mt-6 px-6", "flex flex-col", "sticky"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-start justify-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3398e3e074fa037e$export$2e2bcd8739ae039), {
                                onClick: ()=>setSelectedRow(null),
                                useEscapeToClose: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "quiet -mt-1 p-0",
                                onClick: ()=>setContextView({
                                        type: "ACCOUNT_SELECTION_LIST"
                                    }),
                                children: "See existing accounts"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "pageheading",
                        children: selectedRow?.rowHeader || "List of Accounts"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-s subdued mb-4",
                        children: "Please choose an account name and label to create a new account for this row."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bhkIv.Label), {
                        name: "name",
                        label: "Account Name"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6Thc.RawInput), {
                        name: "accountName",
                        label: "Account Name",
                        showLabel: false,
                        value: accountName || "",
                        showErrorRing: !!errorMessage,
                        onChange: (e)=>setAccountName(e.target.value)
                    }),
                    errorMessage && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "ui-element mt-1 text-red-600",
                        children: errorMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col gap-2 px-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center justify-between gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bhkIv.Label), {
                                name: "label",
                                label: "Label"
                            }),
                            selectedLabel && selectedLabel !== initial?.label && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                className: "quiet subdued ui-label p-0",
                                onClick: ()=>setAccountLabel(initial?.label || null),
                                children: [
                                    "Clear",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25054b32cfb77fe5$export$2e2bcd8739ae039), {
                                        className: "size-4"
                                    })
                                ]
                            })
                        ]
                    }),
                    initial?.label && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $504c29a55da928b3$export$dcfb49240088e87f), {
                        dot: true,
                        listItem: true,
                        label: (0, $af64889d1af19aba$export$eb904f93b8d08cc1)[selectedLabel || initial.label],
                        className: (0, $9QePP.default)("selected", "mb-2"),
                        recommended: !selectedRow?.hasAppliedAccount && selectedLabel === initial?.label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cfefb25babf4c58$export$2e2bcd8739ae039), {
                        value: searchTerm,
                        onChange: setSearchTerm,
                        placeholder: "Search labels..."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "custom-scrollbar overflow-y-auto px-6",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c8abbd23382ff19c$export$835fcf23ab7bf88), {
                    className: "mt-0 pb-24",
                    labels: Object.values((0, $af64889d1af19aba$export$eb904f93b8d08cc1)).filter((label)=>{
                        if (label.code === initial?.label) return false;
                        if (!searchTerm) return true;
                        const term = searchTerm.toLowerCase();
                        return label.category.toLowerCase().includes(term) || label.name.toLowerCase().includes(term) || label.code.toLowerCase().includes(term) || label.statementType.toLowerCase().includes(term);
                    }).sort((a, b)=>{
                        if (initial?.label) {
                            if (a.code === initial.label) return -1;
                            if (b.code === initial.label) return 1;
                        }
                        return (0, $af64889d1af19aba$export$eb904f93b8d08cc1)[a.code].category.localeCompare((0, $af64889d1af19aba$export$eb904f93b8d08cc1)[b.code].category) || a.name.localeCompare(b.name);
                    }),
                    onLabelSelection: setAccountLabel,
                    selectedLabel: selectedLabel
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("bg-default w-full p-6", "absolute inset-x-0 bottom-0"),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "primary xl w-full",
                    disabled: !selectedLabel || !accountName || !!errorMessage,
                    onClick: handleSubmit,
                    children: "Create account"
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("8y7qB");
var $4CoXh = parcelRequire("4CoXh");

var $gBHSi = parcelRequire("gBHSi");


const $aa67f9404de0eccb$export$3c3214997190395f = (0, $gBHSi.createMutation)(async ({ api: api, router: router, queryClient: queryClient, payload: payload })=>{
    const response = await api.post(`/data-association/files/${payload.fileId}/draft`).then((0, $51001a49088f04a5$export$33262deb61669587));
    queryClient.setQueryData([
        `/data-association/drafts?company_id=in.("${router.params.companyId}")`
    ], (old)=>{
        const newDraft = {
            id: response.id,
            status: (0, $156754416c8f457d$export$ad9db10db9173ca8).IN_PROGRESS,
            fileId: response.fileId,
            createdBy: response.ownerId || "",
            createdAt: response.createdAt
        };
        return [
            ...old,
            newDraft
        ];
    });
    return response;
}, {
    invalidates: [
        "/data-association",
        "/file"
    ]
});
const $aa67f9404de0eccb$export$23bb27c41a7ad236 = (0, $gBHSi.createMutation)(async ({ api: api, router: router, payload: payload })=>{
    return api.post(`/data-association/files/${router.params.fileId}/drafts/${router.params.draftId}/commit/validate`, payload.draft);
});
const $aa67f9404de0eccb$export$87bc6c7260ceb84e = (0, $gBHSi.createMutation)(async ({ api: api, router: router, payload: payload, queryClient: queryClient })=>{
    const response = await api.post(`/data-association/files/${router.params.fileId}/drafts/${router.params.draftId}/commit`, payload.draft).then((0, $51001a49088f04a5$export$33262deb61669587));
    queryClient.setQueryData([
        `/data-association/drafts?company_id=in.("${router.params.companyId}")`
    ], (old)=>{
        return old.map((draft)=>{
            if (draft.id === response.id) return {
                ...draft,
                status: (0, $156754416c8f457d$export$ad9db10db9173ca8).COMMITTED
            };
            return draft;
        });
    });
    return response;
}, {
    invalidates: [
        "/data-association",
        "/file"
    ],
    errorToast: {
        message: "Commit failed",
        options: {
            description: "Something went wrong while committing the draft"
        }
    }
});



var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5R0Xk");
var $5Ttm9 = parcelRequire("5Ttm9");

var $1oBsS = parcelRequire("1oBsS");

var $9QePP = parcelRequire("9QePP");
function $cc7f099227b14c77$export$2e2bcd8739ae039({ title: title, description: description, status: status }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("bg-default-overlay-7 px-5 py-4", "flex items-center gap-4 rounded-lg"),
        children: [
            status !== "loading" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("flex h-6 w-7 items-center justify-center rounded", status === "neutral" && "border border-slate-400", status === "fail" && "border border-red-400", status === "pass" && "bg-blue-400", status === "warning" && "border border-yellow-400"),
                children: status === "pass" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1oBsS.default), {
                    className: "size-4 fill-slate-800"
                })
            }),
            status === "loading" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
                className: "size-6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex w-full flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "lozenge",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: (0, $9QePP.default)("body-micro subdued", status === "fail" && "text-red-400", status === "warning" && "text-yellow-400"),
                        children: description
                    })
                ]
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");



var $r2uF6 = parcelRequire("r2uF6");
parcelRequire("5R0Xk");
var $5Ttm9 = parcelRequire("5Ttm9");


function $c1c8f0e78a4be5aa$export$e55f6fb25d0db877() {
    const setContextView = (0, $r2uF6.useSetAtom)((0, $3e16d0e17c6c7886$export$5f8d21c57c3fb992));
    const derivedStatementTypes = (0, $r2uF6.useAtomValue)((0, $540fa3f25212c24e$export$79ff6a44530bd375));
    const [validations, setValidations] = (0, $acw62.useState)({
        completeness: {
            status: "loading",
            messages: []
        },
        accountNaming: {
            status: "loading",
            messages: []
        },
        formulas: {
            status: "loading",
            messages: []
        }
    });
    const isValid = !Object.values(validations).some((validation)=>validation.status === "fail" || validation.status === "loading");
    const { mutate: validate, isError: isError, isPending: isValidatePending } = (0, $4CoXh.useApiMutation)((0, $aa67f9404de0eccb$export$23bb27c41a7ad236), {
        mutationKey: [
            "validateDraft"
        ],
        onSuccess: (response)=>{
            setValidations(response);
        }
    });
    const { mutate: commit, isPending: isPending } = (0, $4CoXh.useApiMutation)((0, $aa67f9404de0eccb$export$87bc6c7260ceb84e), {
        mutationKey: [
            "commitDraft"
        ],
        onSuccess: ()=>{
            setContextView(null);
        }
    });
    const draftSubmission = (0, $r2uF6.useAtomValue)((0, $540fa3f25212c24e$export$81ce44c05a7605ed));
    (0, $acw62.useEffect)(()=>{
        validate({
            draft: {
                rows: draftSubmission?.rows
            }
        });
    }, []);
    const onEnter = (0, $acw62.useCallback)(()=>{
        if (isError) {
            validate({
                draft: {
                    rows: draftSubmission?.rows
                }
            });
            return;
        }
        if (!isValid || isPending || isValidatePending) return;
        commit({
            draft: {
                rows: draftSubmission?.rows
            }
        });
    }, [
        commit,
        draftSubmission,
        validate,
        isError,
        isValid,
        isPending,
        isValidatePending
    ]);
    (0, $d0f12e2fde4c3577$export$71df7237f99e303a)(onEnter);
    const defaultStatus = isValidatePending ? "loading" : isError ? "neutral" : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("px-6", "absolute inset-0 flex min-h-0 flex-col overflow-hidden"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "sticky my-6 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3398e3e074fa037e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "pageheading",
                        children: "Labeling Checklist"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "body-s subdued",
                        children: [
                            "The following checks must pass before the file can be marked as labeled.",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: (0, $9QePP.default)("body-micro subdued mt-1 text-red-400", !isError && "invisible"),
                        children: "Something went wrong while validating the draft."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: (0, $9QePP.default)("pb-30", "flex flex-col", "custom-scrollbar hide-scrollbar gap-4 overflow-y-auto"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cc7f099227b14c77$export$2e2bcd8739ae039), {
                            title: "Completeness",
                            description: "All rows must have an account name and label.",
                            status: defaultStatus || validations.completeness.status
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cc7f099227b14c77$export$2e2bcd8739ae039), {
                            title: "Account Naming",
                            description: "All account names must be unique.",
                            status: defaultStatus || validations.accountNaming.status
                        })
                    }),
                    derivedStatementTypes.includes((0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cc7f099227b14c77$export$2e2bcd8739ae039), {
                                title: "Balance Sheet Balance",
                                description: "Assets, Liabilities, and Equity must balance.",
                                status: defaultStatus || (validations.formulas.messages.find((message)=>message.formula === (0, $156754416c8f457d$export$96abc37e495202c4).BALANCE_SHEET_BALANCE) ? "fail" : validations.formulas.status === "loading" ? "loading" : "pass")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("bg-default w-full p-6", "absolute inset-x-0 bottom-0"),
                children: [
                    !isError && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "primary xl w-full",
                        disabled: !isValid || isPending,
                        onClick: ()=>commit({
                                draft: {
                                    rows: draftSubmission?.rows
                                }
                            }),
                        children: [
                            "Commit draft ",
                            isPending && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {})
                        ]
                    }),
                    isError && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "primary xl w-full",
                        onClick: ()=>validate({
                                draft: {
                                    rows: draftSubmission?.rows
                                }
                            }),
                        disabled: isValidatePending,
                        children: [
                            "Retry validation ",
                            isValidatePending && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {})
                        ]
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $r2uF6 = parcelRequire("r2uF6");


var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");




var $5lq00 = parcelRequire("5lq00");
function $e825244e2e16a561$export$6488d7b96f884b18({ account: account, recommended: recommended = false, selected: selected = false, onAccountSelection: onAccountSelection = ()=>{}, hotkeyNumber: hotkeyNumber }) {
    const command = (0, $acw62.useMemo)(()=>{
        if (!hotkeyNumber) return undefined;
        return {
            label: account.name,
            shortcut: {
                key: String(hotkeyNumber),
                mac: `\u{2318}${hotkeyNumber}`,
                windows: `Ctrl+${hotkeyNumber}`
            },
            onClick: ()=>onAccountSelection(account)
        };
    }, [
        hotkeyNumber,
        account,
        onAccountSelection
    ]);
    (0, $5lq00.useHotkey)({
        command: command
    });
    const hotkeyLabel = command ? (0, $5lq00.getShortcutDisplay)(command.shortcut) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
        className: (0, $9QePP.default)("card relative flex flex-col gap-2", recommended && "border-default mb-2 border", selected && "selected"),
        onClick: ()=>onAccountSelection(account),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-start justify-between font-semibold",
                children: [
                    account.name,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            recommended && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fc1405939c84d0e6$export$2e2bcd8739ae039), {
                                className: "text-subdued size-4"
                            }),
                            hotkeyLabel && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: (0, $9QePP.default)("bg-gray-500 px-1 py-0.5", "text-bg-default text-slate-800", "body-micro rounded-md"),
                                children: hotkeyLabel
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $504c29a55da928b3$export$dcfb49240088e87f), {
                listItem: false,
                label: (0, $af64889d1af19aba$export$eb904f93b8d08cc1)[account.label],
                dot: true
            })
        ]
    }, account.id);
}



function $62d47febbcad0875$export$fe248f600fa897e6({ accounts: accounts, recommendedIds: recommendedIds = [], selectedId: selectedId, onAccountSelection: onAccountSelection }) {
    const { groupedAccounts: groupedAccounts, categories: categories, hotkeyMap: hotkeyMap } = (0, $acw62.useMemo)(()=>{
        const groups = {};
        accounts.forEach((account)=>{
            const category = (0, $af64889d1af19aba$export$eb904f93b8d08cc1)[account.label]?.category;
            if (!category) return;
            if (!groups[category]) groups[category] = [];
            groups[category].push(account);
        });
        const cats = Object.keys(groups);
        const hotkeys = {};
        let globalIndex = 0;
        for (const cat of cats)for (const account of groups[cat]){
            if (globalIndex < 3) hotkeys[account.id] = globalIndex + 1;
            globalIndex++;
        }
        return {
            groupedAccounts: groups,
            categories: cats,
            hotkeyMap: hotkeys
        };
    }, [
        accounts
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("pb-4", "hide-scrollbar flex flex-1 flex-col gap-4 overflow-y-auto"),
        children: [
            categories.map((category)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: (0, $9QePP.default)("lozenge", "flex items-center gap-4 px-3 py-4 font-medium"),
                            children: (0, $af64889d1af19aba$export$c40eb1dced6d2957)[category]?.name || category
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                            role: "list",
                            className: "flex flex-col gap-1",
                            children: groupedAccounts[category].map((account)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $e825244e2e16a561$export$6488d7b96f884b18), {
                                    account: account,
                                    recommended: recommendedIds.includes(account.id),
                                    selected: selectedId === account.id,
                                    onAccountSelection: onAccountSelection,
                                    hotkeyNumber: hotkeyMap[account.id]
                                }, account.id))
                        })
                    ]
                }, category)),
            accounts.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-subdued body-s text-center",
                children: "No accounts exist for this category."
            })
        ]
    });
}




var $ggKhH = parcelRequire("ggKhH");
function $58aba3e1ce2cab5a$export$fe248f600fa897e6() {
    const getAccountDisplayList = (0, $r2uF6.useAtomValue)((0, $9bf0cfccc28125c5$export$e3f5f7e7495a58c9));
    const [contextView, setContextView] = (0, $r2uF6.useAtom)((0, $3e16d0e17c6c7886$export$5f8d21c57c3fb992));
    const [selectedRow, setSelectedRow] = (0, $r2uF6.useAtom)((0, $ebd8595742de66c3$export$7770f7cfbd1735b));
    const setAccountApplication = (0, $r2uF6.useSetAtom)((0, $540fa3f25212c24e$export$af3bfe24cf5eb5a6));
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const isRowSelection = selectedRow && contextView?.type === "ACCOUNT_SELECTION_LIST";
    const description = isRowSelection ? "Select an account for this row" : "Select an account to edit";
    const applyRow = (0, $acw62.useCallback)((account)=>{
        if (selectedRow) {
            setAccountApplication({
                rowHeader: selectedRow.rowIndex,
                accountId: account.id
            });
            setSelectedRow(null);
        }
    }, [
        selectedRow,
        setAccountApplication,
        setSelectedRow
    ]);
    const handleClose = (0, $acw62.useCallback)(()=>{
        setContextView(null);
    // setSelectedRow(null);
    }, [
        setContextView
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("absolute inset-0 flex min-h-0 flex-col overflow-hidden"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("mb-3 mt-6 px-6", "flex flex-col", "sticky"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-start justify-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3398e3e074fa037e$export$2e2bcd8739ae039), {
                                onClick: handleClose,
                                useEscapeToClose: true
                            }),
                            isRowSelection && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                className: "quiet -mt-1 p-0",
                                onClick: ()=>setContextView({
                                        type: "ACCOUNT_SELECTION_NEW"
                                    }),
                                children: [
                                    "New Account ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ggKhH.default), {
                                        className: "size-4"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "pageheading",
                        children: selectedRow?.rowHeader || "List of Accounts"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-s subdued mb-6",
                        children: description
                    }),
                    isRowSelection && selectedRow?.account?.accountId && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62d47febbcad0875$export$fe248f600fa897e6), {
                        selectedId: selectedRow?.hasAppliedAccount ? selectedRow?.account?.accountId : undefined,
                        accounts: [
                            {
                                id: selectedRow?.account?.accountId,
                                name: selectedRow?.account?.accountName,
                                label: selectedRow?.account?.label,
                                type: selectedRow?.account?.type,
                                meta: selectedRow?.account?.meta
                            }
                        ],
                        recommendedIds: !selectedRow?.hasAppliedAccount ? [
                            selectedRow?.account?.accountId
                        ] : [],
                        onAccountSelection: applyRow
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cfefb25babf4c58$export$2e2bcd8739ae039), {
                        value: searchTerm,
                        onChange: setSearchTerm,
                        placeholder: "Search accounts..."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "custom-scrollbar overflow-y-auto px-3 pr-6",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62d47febbcad0875$export$fe248f600fa897e6), {
                    recommendedIds: selectedRow?.account?.accountId ? [
                        selectedRow?.account?.accountId
                    ] : [],
                    accounts: getAccountDisplayList(searchTerm),
                    onAccountSelection: (account)=>{
                        if (isRowSelection) applyRow(account);
                        else setContextView({
                            type: "ACCOUNT_EDIT",
                            initial: account
                        });
                    }
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("18L7n");
var $a6Thc = parcelRequire("a6Thc");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $r2uF6 = parcelRequire("r2uF6");




var $bhkIv = parcelRequire("bhkIv");


function $ad40db9b99075693$export$9863503f0fc20bc4({ initial: initial }) {
    const setContextView = (0, $r2uF6.useSetAtom)((0, $3e16d0e17c6c7886$export$5f8d21c57c3fb992));
    const setAccounts = (0, $r2uF6.useSetAtom)((0, $9bf0cfccc28125c5$export$eb049f2950249542));
    const [accountName, setAccountName] = (0, $acw62.useState)(initial.name || null);
    const [selectedLabel, setAccountLabel] = (0, $acw62.useState)(initial.label);
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const getErrorMessage = (0, $r2uF6.useAtomValue)((0, $c02997182c8770ac$export$fd1c089d2a3107a9));
    const errorMessage = accountName ? getErrorMessage(accountName, {
        currentAccountId: initial.id || undefined
    }) : undefined;
    const hasChanges = accountName !== initial.name || selectedLabel !== initial.label;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("absolute inset-0 flex min-h-0 flex-col overflow-hidden"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("mb-3 mt-6 px-6", "flex flex-col", "sticky"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3398e3e074fa037e$export$2e2bcd8739ae039), {
                        label: "Accounts",
                        iconDirection: "left",
                        onClick: ()=>setContextView({
                                type: "ACCOUNT_LIST_EDIT"
                            }),
                        useEscapeToClose: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "pageheading",
                        children: "Edit Account"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-s subdued mb-6",
                        children: "Changes will be applied to this account across all files upon commit of the draft."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6Thc.RawInput), {
                        name: "accountName",
                        label: "Account Name",
                        value: accountName || "",
                        showErrorRing: !!errorMessage,
                        onChange: (e)=>setAccountName(e.target.value)
                    }),
                    errorMessage && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "ui-element mt-1 text-red-600",
                        children: errorMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col gap-2 px-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center justify-between gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bhkIv.Label), {
                                name: "label",
                                label: "Label"
                            }),
                            selectedLabel !== initial.label && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                className: "quiet subdued ui-label p-0",
                                onClick: ()=>setAccountLabel(initial.label),
                                children: [
                                    "Clear",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25054b32cfb77fe5$export$2e2bcd8739ae039), {
                                        className: "size-4"
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $af64889d1af19aba$export$eb904f93b8d08cc1)[selectedLabel || initial.label] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $504c29a55da928b3$export$dcfb49240088e87f), {
                        dot: true,
                        listItem: true,
                        label: (0, $af64889d1af19aba$export$eb904f93b8d08cc1)[selectedLabel || initial.label],
                        className: (0, $9QePP.default)("selected", "mb-2")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cfefb25babf4c58$export$2e2bcd8739ae039), {
                        value: searchTerm,
                        onChange: setSearchTerm,
                        placeholder: "Search labels..."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "custom-scrollbar overflow-y-auto px-6",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c8abbd23382ff19c$export$835fcf23ab7bf88), {
                    className: "mt-0 pb-24",
                    labels: Object.values((0, $af64889d1af19aba$export$eb904f93b8d08cc1)).filter((label)=>{
                        if (label.code === initial.label) return false;
                        if (!searchTerm) return true;
                        const term = searchTerm.toLowerCase();
                        return label.category.toLowerCase().includes(term) || label.name.toLowerCase().includes(term) || label.code.toLowerCase().includes(term) || label.statementType.toLowerCase().includes(term);
                    }).sort((a, b)=>{
                        if (initial?.label) {
                            if (a.code === initial.label) return -1;
                            if (b.code === initial.label) return 1;
                        }
                        return (0, $af64889d1af19aba$export$eb904f93b8d08cc1)[a.code].category.localeCompare((0, $af64889d1af19aba$export$eb904f93b8d08cc1)[b.code].category) || a.name.localeCompare(b.name);
                    }),
                    onLabelSelection: setAccountLabel,
                    selectedLabel: selectedLabel
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("bg-default w-full p-6", "absolute inset-x-0 bottom-0"),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "primary xl w-full",
                    disabled: !!errorMessage || !hasChanges,
                    onClick: ()=>{
                        setAccounts({
                            ...initial,
                            label: selectedLabel || initial.label,
                            name: accountName || initial.name
                        });
                        setContextView({
                            type: "ACCOUNT_LIST_EDIT"
                        });
                    },
                    children: "Update account"
                })
            })
        ]
    });
}


function $8e2948124cb679e4$export$31b0b10a5d06f0c1() {
    const labelingContextView = (0, $r2uF6.useAtomValue)((0, $3e16d0e17c6c7886$export$5f8d21c57c3fb992));
    if (labelingContextView?.type === "ACCOUNT_SELECTION_LIST" || labelingContextView?.type === "ACCOUNT_LIST_EDIT") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $58aba3e1ce2cab5a$export$fe248f600fa897e6), {});
    if (labelingContextView?.type === "ACCOUNT_SELECTION_NEW") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9c37778111ae541$export$b841b541bc741e79), {});
    if (labelingContextView?.type === "DRAFT_COMMIT") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1c8f0e78a4be5aa$export$e55f6fb25d0db877), {});
    if (labelingContextView?.type === "ACCOUNT_EDIT") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ad40db9b99075693$export$9863503f0fc20bc4), {
        initial: labelingContextView.initial
    });
    return null;
}




var $acw62 = parcelRequire("acw62");
parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");



var $r2uF6 = parcelRequire("r2uF6");


var $kkxkw = parcelRequire("kkxkw");

parcelRequire("gCemA");
var $9O2q1 = parcelRequire("9O2q1");
const $a1c2ba8c8468fa75$var$STATEMENT_TYPES = [
    (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).INCOME_STATEMENT,
    (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).BALANCE_SHEET
];
const $a1c2ba8c8468fa75$var$flattenDescendants = (tree)=>{
    const result = [];
    if (tree.descendants) for (const d of tree.descendants){
        result.push({
            id: d.id,
            name: d.name
        });
        result.push(...$a1c2ba8c8468fa75$var$flattenDescendants(d));
    }
    return result;
};
async function $a1c2ba8c8468fa75$export$c0f409937085c8c8(api, companyId) {
    const query = new (0, $9O2q1.QueryStringBuilder)().equals("company_id", companyId).equals("source", "codat").equals("document_type", "raw").add("max_page_size", "999").build();
    const response = await api.get(`/file/files?${query}`).then((response)=>response.items.filter((f)=>f.meta?.isHistoricalPull));
    return response;
}
async function $a1c2ba8c8468fa75$export$32657a58c9a1d38c(api, companyId) {
    const query = new (0, $9O2q1.QueryStringBuilder)().equals("company_id", companyId).equals("source_type", "connector").equals("document_type", "cleaned").add("max_page_size", "999").build();
    const response = await api.get(`/data-association/files?${query}`);
    return response.items;
}
async function $a1c2ba8c8468fa75$export$11883a48d77d8501(api, companyId) {
    const query = new (0, $9O2q1.QueryStringBuilder)().equals("company_id", companyId).equals("source_type", "uploaded_file").add("max_page_size", "999").build();
    const response = await api.get(`/data-association/files?${query}`);
    return response.items;
}
function $a1c2ba8c8468fa75$export$a270321b3d726d24(files) {
    return files.sort((a, b)=>new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())[0];
}
function $a1c2ba8c8468fa75$export$cf82bad483bd46b2(files) {
    const result = {
        income_statement: null,
        balance_sheet: null
    };
    for (const statementType of $a1c2ba8c8468fa75$var$STATEMENT_TYPES){
        console.log("statementType", statementType, files);
        const filtered = files.filter((file)=>file.documentKind === statementType).sort((a, b)=>{
            console.log("a", new Date(a.createdAt).getTime(), new Date(b.createdAt).getTime());
            return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
        });
        result[statementType] = filtered[0] ?? null;
    }
    return result;
}
async function $a1c2ba8c8468fa75$export$980577e10d21fe34(file, api) {
    if (!file) return null;
    const labeledFiles = await api.get(`/file/files/${file.id}/descendants`).then($a1c2ba8c8468fa75$var$flattenDescendants).then((nodes)=>nodes.filter((node)=>node.name.startsWith("labeled-")).map((node)=>({
                id: node.id,
                name: node.name
            })));
    return {
        ...file,
        labeledFiles: labeledFiles
    };
}
const $a1c2ba8c8468fa75$export$a548b27ddc2558f6 = (0, $kkxkw.createQuery)(async ({ api: api, router: router })=>{
    if (!router.params.companyId) return [];
    const cleanedFiles = await $a1c2ba8c8468fa75$export$32657a58c9a1d38c(api, router.params.companyId);
    const connectors = [
        ...new Map(cleanedFiles.filter((f)=>f.meta.rawConnector?.kind && f.meta.rawConnector?.id || f.sourceConnectorId).map((f)=>{
            const connectorId = f.meta.rawConnector?.id || f.sourceConnectorId;
            const connectorType = f.meta.rawConnector?.kind || "unknown";
            return [
                `${connectorType}:${connectorId}`,
                {
                    sourceConnectorType: connectorType,
                    sourceConnectorId: connectorId
                }
            ];
        })).values()
    ];
    const currentId = router.params.fileId;
    const results = await Promise.all(connectors.map(async (connector)=>{
        const connectorCleanedFiles = cleanedFiles.filter((f)=>f.meta.rawConnector?.kind === connector.sourceConnectorType && f.meta.rawConnector?.id === connector.sourceConnectorId || f.sourceConnectorId === connector.sourceConnectorId);
        const rawHistoricalFiles = await $a1c2ba8c8468fa75$export$c0f409937085c8c8(api, router.params.companyId || "");
        console.log("rawHistoricalFiles", rawHistoricalFiles);
        const historicalFiles = $a1c2ba8c8468fa75$export$cf82bad483bd46b2((await rawHistoricalFiles).map((f)=>connectorCleanedFiles.find((cf)=>cf.producedFromFile === f.id)).filter((f)=>f !== undefined) ?? []);
        const mostRecent = $a1c2ba8c8468fa75$export$cf82bad483bd46b2(connectorCleanedFiles.filter((f)=>!Object.values(historicalFiles).some((h)=>h?.id === f.id)));
        const hasCurrent = !Object.values(mostRecent).some((f)=>f?.id === currentId) && !Object.values(historicalFiles).some((f)=>f?.id === currentId);
        const current = hasCurrent ? connectorCleanedFiles.find((f)=>f.id === currentId) ?? null : null;
        const [mostRecentIS, mostRecentBS, historicalIS, historicalBS, currentHydrated] = await Promise.all([
            $a1c2ba8c8468fa75$export$980577e10d21fe34(mostRecent.income_statement, api),
            $a1c2ba8c8468fa75$export$980577e10d21fe34(mostRecent.balance_sheet, api),
            $a1c2ba8c8468fa75$export$980577e10d21fe34(historicalFiles.income_statement, api),
            $a1c2ba8c8468fa75$export$980577e10d21fe34(historicalFiles.balance_sheet, api),
            $a1c2ba8c8468fa75$export$980577e10d21fe34(current, api)
        ]);
        return {
            sourceConnectorId: connector.sourceConnectorId,
            sourceConnectorType: connector.sourceConnectorType,
            mostRecent: {
                income_statement: mostRecentIS,
                balance_sheet: mostRecentBS
            },
            historical: {
                income_statement: historicalIS,
                balance_sheet: historicalBS
            },
            current: currentHydrated
        };
    }));
    console.log("results", results);
    return results;
});
const $a1c2ba8c8468fa75$var$extractCleanedWithLabeled = (tree)=>{
    const result = [];
    const traverse = (node)=>{
        if (node.name.startsWith("cl-")) {
            const labeledFiles = (node.descendants ?? []).filter((d)=>d.name.startsWith("labeled-")).map((d)=>({
                    id: d.id,
                    name: d.name
                }));
            result.push({
                id: node.id,
                name: node.name,
                labeledFiles: labeledFiles
            });
        }
        node.descendants?.forEach(traverse);
    };
    tree.descendants?.forEach(traverse);
    return result;
};
const $a1c2ba8c8468fa75$export$58ba4cc3b29094c1 = (0, $kkxkw.createQuery)(async ({ api: api, router: router })=>{
    const query = new (0, $9O2q1.QueryStringBuilder)().equals("company_id", router.params.companyId || "").equals("source", "user_uploaded").equals("document_type", "raw").add("max_page_size", "999").build();
    const response = await api.get(`/file/files?${query}`);
    const rawFiles = response.items;
    const associatedUploads = await $a1c2ba8c8468fa75$export$11883a48d77d8501(api, router.params.companyId || "");
    const uploadsWithChildren = await Promise.all(rawFiles.map(async (file)=>{
        const descendants = await api.get(`/file/files/${file.id}/descendants`);
        const cleanedChildren = $a1c2ba8c8468fa75$var$extractCleanedWithLabeled(descendants);
        return {
            ...file,
            cleanedChildren: cleanedChildren
        };
    }));
    const labeled = uploadsWithChildren.filter((u)=>u.cleanedChildren.some((c)=>c.labeledFiles.length > 0)).map((u)=>({
            ...u,
            associatedUpload: associatedUploads.find((a)=>a.id === u.id)
        }));
    const unlabeled = uploadsWithChildren.filter((u)=>!u.cleanedChildren.some((c)=>c.labeledFiles.length > 0)).map((u)=>({
            ...u,
            associatedUpload: associatedUploads.find((a)=>a.id === u.id)
        }));
    return {
        labeled: labeled,
        unlabeled: unlabeled
    };
});


function $0c4fa35549255e3a$export$8a6f2c88fdcd2ba7() {
    const router = (0, $fp4OM.useRouter)();
    const [labelingParams, setLabelingParams] = (0, $r2uF6.useAtom)((0, $175863902df2ee1a$export$4d2c75fe8b80fe70));
    const isReadonly = (0, $r2uF6.useAtomValue)((0, $175863902df2ee1a$export$a96d76569fa61ec4));
    const { selectedFileId: selectedFileId, selectedDraftId: selectedDraftId } = labelingParams;
    (0, $35ccd0e0f94b0171$export$fdf798407d60fdf)((0, $d467c533cc3c7dc1$export$df6ee07eb0d78049), (0, $540fa3f25212c24e$export$224f20c309c1f113), {
        enabled: !!selectedFileId && isReadonly
    });
    (0, $35ccd0e0f94b0171$export$fdf798407d60fdf)((0, $d467c533cc3c7dc1$export$1a473231c51c1d5b), (0, $540fa3f25212c24e$export$b0cbc03b849c7b1f), {
        enabled: !!selectedFileId && !isReadonly && !!selectedDraftId
    });
    (0, $35ccd0e0f94b0171$export$fdf798407d60fdf)((0, $d467c533cc3c7dc1$export$d5d451a14adbc067), (0, $9bf0cfccc28125c5$export$3ecbaf68d811c501));
    (0, $35ccd0e0f94b0171$export$fdf798407d60fdf)((0, $d467c533cc3c7dc1$export$7d94143c01232fd3), (0, $540fa3f25212c24e$export$a501548c14b6cdc7), {
        enabled: !!selectedDraftId
    });
    (0, $35ccd0e0f94b0171$export$fdf798407d60fdf)((0, $d467c533cc3c7dc1$export$8b3ca78f81ec578c), (0, $175863902df2ee1a$export$380f8a5d1313e761), {
        enabled: !!selectedFileId
    });
    (0, $35ccd0e0f94b0171$export$fdf798407d60fdf)((0, $a1c2ba8c8468fa75$export$58ba4cc3b29094c1), (0, $b010adf4533db8e7$export$1c5ebe55f48780cb), {
        enabled: !!router.params.companyId,
        key: [
            "/file/data-association/file-list/uploads",
            router.params.companyId || ""
        ]
    });
    (0, $35ccd0e0f94b0171$export$fdf798407d60fdf)((0, $a1c2ba8c8468fa75$export$a548b27ddc2558f6), (0, $b010adf4533db8e7$export$7ab360575ca3dbe), {
        enabled: !!router.params.companyId,
        key: [
            "/file/data-association/file-list/connectors",
            router.params.companyId || ""
        ]
    });
    // useApiQueryWithAtom(getConnectors, connectorsAtom, {
    //     enabled: !!router.params.companyId,
    // });
    (0, $35ccd0e0f94b0171$export$fdf798407d60fdf)((0, $d467c533cc3c7dc1$export$d705ef743e424c06), (0, $540fa3f25212c24e$export$4a2c69def00f1863), {
        enabled: !!router.params.companyId
    });
    (0, $acw62.useEffect)(()=>{
        setLabelingParams({
            selectedDraftId: router.params.draftId,
            selectedFileId: router.params.fileId
        });
    }, [
        router.params.draftId,
        router.params.fileId,
        setLabelingParams
    ]);
}



var $507e2ddca1927e0b$export$61db76a97f26b7e1;
(function(TaskStatus) {
    TaskStatus["NotStarted"] = "not_started";
    TaskStatus["Pending"] = "pending";
    TaskStatus["Processing"] = "processing";
    TaskStatus["Completed"] = "completed";
    TaskStatus["Failed"] = "failed";
})($507e2ddca1927e0b$export$61db76a97f26b7e1 || ($507e2ddca1927e0b$export$61db76a97f26b7e1 = {}));



var $acw62 = parcelRequire("acw62");
parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");

var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $r2uF6 = parcelRequire("r2uF6");


var $9QePP = parcelRequire("9QePP");

var $2hw4u = parcelRequire("2hw4u");
var $fRJCp = parcelRequire("fRJCp");




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");


var $r2uF6 = parcelRequire("r2uF6");

var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5R0Xk");
var $5Ttm9 = parcelRequire("5Ttm9");
parcelRequire("gCemA");
var $kdwja = parcelRequire("kdwja");

var $acw62 = parcelRequire("acw62");
function $898ede00ff16e210$var$CheckCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $898ede00ff16e210$var$ForwardRef = $acw62.forwardRef($898ede00ff16e210$var$CheckCircleIcon);
var $898ede00ff16e210$export$2e2bcd8739ae039 = $898ede00ff16e210$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $1588c2c6b0d47cd8$var$PlusCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $1588c2c6b0d47cd8$var$ForwardRef = $acw62.forwardRef($1588c2c6b0d47cd8$var$PlusCircleIcon);
var $1588c2c6b0d47cd8$export$2e2bcd8739ae039 = $1588c2c6b0d47cd8$var$ForwardRef;



var $9QePP = parcelRequire("9QePP");

var $lzNIT = parcelRequire("lzNIT");
function $60ad6d64bf5eeb07$export$2e2d3c4ca1b17148({ icon: icon, label: label, id: id, date: date, to: to, onClick: onClick, isSelected: isSelected = false, lineElement: lineElement, subdued: subdued = false, bold: bold = false }) {
    const content = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("flex cursor-pointer items-center gap-2 rounded-lg px-2 py-1", to && "hover:bg-hover", isSelected && "bg-selected"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                className: (0, $9QePP.default)("body-s cursor-pointer", bold && "font-semibold", subdued && "font-normal text-slate-400 group-hover:text-white"),
                children: label
            }),
            id && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: (0, $9QePP.default)("body-s cursor-pointer text-slate-500"),
                children: id.slice(-6)
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("group relative flex items-center justify-between gap-4"),
        children: [
            lineElement,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, $9QePP.default)("flex items-center gap-3"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "relative z-10",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: (0, $9QePP.default)("flex size-4 items-center justify-center"),
                            children: [
                                icon === "check" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $898ede00ff16e210$export$2e2bcd8739ae039), {
                                    className: "size-4"
                                }),
                                icon === "ring" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: (0, $9QePP.default)("size-2.5 rounded-full ring-1 ring-slate-700")
                                }),
                                icon === "plus" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1588c2c6b0d47cd8$export$2e2bcd8739ae039), {
                                    className: (0, $9QePP.default)("size-4 stroke-slate-400 group-hover:stroke-white")
                                }),
                                icon === "spinner" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
                                    className: "size-4 text-slate-400"
                                })
                            ]
                        })
                    }),
                    to ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                        to: to,
                        className: "cursor-pointer",
                        children: content
                    }) : onClick ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: onClick,
                        className: "no-styles cursor-pointer",
                        children: content
                    }) : content
                ]
            }),
            date && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: (0, $9QePP.default)("body-micro mt-px text-gray-500"),
                children: (0, $kdwja.formatDate)(date, {
                    outputFormat: "MM/DD/YY"
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $r2uF6 = parcelRequire("r2uF6");
parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");

var $9QePP = parcelRequire("9QePP");


function $487bdc4c1c574d85$export$ae0b3676782c04ec({ id: id, date: date, showCircle: showCircle = true }) {
    const router = (0, $fp4OM.useRouter)();
    const companyId = router.params.companyId;
    const { selectedFileId: selectedFileId, selectedDraftId: selectedDraftId } = (0, $r2uF6.useAtomValue)((0, $175863902df2ee1a$export$4d2c75fe8b80fe70));
    const isSelected = selectedFileId === id && !selectedDraftId;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: (0, $9QePP.clsx)("py-0.5"),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60ad6d64bf5eeb07$export$2e2d3c4ca1b17148), {
            icon: showCircle ? "check" : "none",
            label: "Labeled file",
            id: id,
            date: date,
            to: `/beta/companies/${companyId}/labeling/files/${id}`,
            isSelected: isSelected
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");

var $r2uF6 = parcelRequire("r2uF6");


var $9QePP = parcelRequire("9QePP");

function $dbb370ed32be420d$export$6bb21cac78f3144e({ draft: draft, hasLabeledFiles: hasLabeledFiles, parentId: parentId }) {
    const router = (0, $fp4OM.useRouter)();
    const companyId = router.params.companyId;
    const { selectedFileId: selectedFileId, selectedDraftId: selectedDraftId } = (0, $r2uF6.useAtomValue)((0, $175863902df2ee1a$export$4d2c75fe8b80fe70));
    const isSelected = selectedFileId === parentId && selectedDraftId === draft.id;
    const lineElement = hasLabeledFiles ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.clsx)("absolute -bottom-8 left-[7px] top-0 w-px border-l-2 border-dashed border-slate-700", "mb-[14px] mt-6")
    }) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: (0, $9QePP.clsx)("relative flex flex-col gap-1"),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60ad6d64bf5eeb07$export$2e2d3c4ca1b17148), {
            icon: "ring",
            label: draft.status === "uncommitted" ? "Uncommitted Draft" : "Committed Draft",
            id: draft.id,
            date: draft.date,
            to: `/beta/companies/${companyId}/labeling/files/${parentId}/drafts/${draft.id}`,
            lineElement: lineElement,
            isSelected: isSelected
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");

var $9QePP = parcelRequire("9QePP");

parcelRequire("8y7qB");
var $4CoXh = parcelRequire("4CoXh");

function $ed72c056c5fd15b1$export$6a21ecc9487f7cd6({ hasLabeledFiles: hasLabeledFiles, parentId: parentId }) {
    const router = (0, $fp4OM.useRouter)();
    const companyId = router.params.companyId;
    const { mutate: createDraft, isPending: isPending } = (0, $4CoXh.useApiMutation)((0, $aa67f9404de0eccb$export$3c3214997190395f), {
        onSuccess: (response)=>{
            router.navigate(`/beta/companies/${companyId}/labeling/files/${response.fileId}/drafts/${response.id}`);
        }
    });
    const lineElement = hasLabeledFiles ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.clsx)("absolute -bottom-8 left-[7px] top-0 w-px border-l-2 border-dashed border-slate-700", "mb-[14px] mt-6")
    }) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: (0, $9QePP.clsx)("relative flex flex-col gap-1"),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60ad6d64bf5eeb07$export$2e2d3c4ca1b17148), {
            icon: isPending ? "spinner" : "plus",
            label: isPending ? "Creating a new draft..." : "Create a new labeling draft",
            onClick: ()=>createDraft({
                    fileId: parentId
                }),
            lineElement: lineElement,
            subdued: true
        })
    });
}


function $e158c25a634ed406$export$e4952a4933b3ab85({ name: name, draft: draft, labeledFiles: labeledFiles, date: date, id: id }) {
    const router = (0, $fp4OM.useRouter)();
    const companyId = router.params.companyId;
    const { selectedFileId: selectedFileId, selectedDraftId: selectedDraftId } = (0, $r2uF6.useAtomValue)((0, $175863902df2ee1a$export$4d2c75fe8b80fe70));
    const hasDraft = draft !== null;
    const hasLabeledFiles = labeledFiles.length > 0;
    const isSelected = selectedFileId === id && !selectedDraftId;
    const lineElement = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.clsx)("absolute -bottom-10 left-[7px] top-0 w-px border-l-2 border-slate-700", !hasDraft ? "mb-[14px] mt-6 border-dashed" : "mb-4 mt-[1.65rem] rounded")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
        className: (0, $9QePP.clsx)("relative flex flex-col gap-1"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60ad6d64bf5eeb07$export$2e2d3c4ca1b17148), {
                icon: "check",
                label: name,
                id: id,
                lineElement: lineElement,
                date: date,
                to: `/beta/companies/${companyId}/labeling/files/${id}`,
                isSelected: isSelected,
                bold: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: (0, $9QePP.clsx)("relative flex flex-col gap-4 pt-4"),
                children: [
                    hasDraft ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbb370ed32be420d$export$6bb21cac78f3144e), {
                        draft: draft,
                        hasLabeledFiles: hasLabeledFiles,
                        parentId: id
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed72c056c5fd15b1$export$6a21ecc9487f7cd6), {
                        hasLabeledFiles: hasLabeledFiles,
                        parentId: id
                    }),
                    hasLabeledFiles && /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        className: "relative flex flex-col",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                            className: (0, $9QePP.clsx)("flex flex-col gap-1"),
                            children: labeledFiles.map((file, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $487bdc4c1c574d85$export$ae0b3676782c04ec), {
                                    showCircle: index === 0,
                                    ...file
                                }, file.id))
                        })
                    })
                ]
            })
        ]
    });
}






function $05dda706cd89d80b$var$ConnectorTreeItem({ connector: connector, isOpen: isOpen, onToggle: onToggle }) {
    const groupedItems = (0, $acw62.useMemo)(()=>{
        const result = [];
        for (const category of (0, $af64889d1af19aba$export$89985bf7de36f667)){
            const files = [];
            for (const statementType of (0, $af64889d1af19aba$export$2d24c055ca23de42)){
                const file = connector[category][statementType];
                if (file) files.push({
                    file: file,
                    statementType: (0, $a9fafe23bcb6020a$export$775afd4b12f86320)[statementType]
                });
            }
            if (files.length > 0) result.push({
                category: category,
                label: (0, $af64889d1af19aba$export$680cd113e2939fb5)[category],
                files: files
            });
        }
        return result;
    }, [
        connector
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-start justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9566eba0569deebe$export$b853f99e0a417737), {
                                connectorType: connector.sourceConnectorType,
                                large: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: (0, $9QePP.default)("body-s cursor-pointer pt-0.5 text-slate-500"),
                                children: connector.sourceConnectorId.slice(-6)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-micro text-slate-500",
                        children: connector.hasUnlabeledFiles ? "Has unlabeled files" : "Labeled"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: (0, $9QePP.default)("py-1", "flex items-center gap-3"),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    onClick: onToggle,
                    className: (0, $9QePP.default)("no-styles", "text-button subdued flex items-center gap-1 font-light", "hover:text-white"),
                    children: [
                        isOpen ? "Hide details" : "See details",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).span, {
                            animate: {
                                rotate: isOpen ? 180 : 0
                            },
                            transition: {
                                type: "spring",
                                bounce: 0,
                                duration: 0.4
                            },
                            className: "flex",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f64a4ef9514b684d$export$2e2bcd8739ae039), {
                                className: "size-3 text-gray-500"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2hw4u.AnimatePresence), {
                initial: false,
                children: isOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                    initial: {
                        height: 0
                    },
                    animate: {
                        height: "auto"
                    },
                    exit: {
                        height: 0
                    },
                    transition: {
                        type: "spring",
                        bounce: 0,
                        duration: 0.4
                    },
                    className: "overflow-hidden",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                        className: (0, $9QePP.default)("flex flex-col gap-7", " pt-3"),
                        children: [
                            connector.current && /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "heading-s mb-3 text-slate-500",
                                        children: (0, $af64889d1af19aba$export$680cd113e2939fb5).current
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                        className: "flex flex-col gap-6",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e158c25a634ed406$export$e4952a4933b3ab85), {
                                            ...connector.current,
                                            name: connector.current.documentKind ? (0, $a9fafe23bcb6020a$export$775afd4b12f86320)[connector.current.documentKind] : "Cleaned File"
                                        })
                                    })
                                ]
                            }),
                            groupedItems.map(({ category: category, label: label, files: files })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "heading-s mb-3 text-slate-500",
                                            children: label
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: "flex flex-col gap-6",
                                            children: files.map(({ file: file, statementType: statementType })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $e158c25a634ed406$export$e4952a4933b3ab85), {
                                                    ...file,
                                                    name: statementType
                                                }, file.id))
                                        })
                                    ]
                                }, category))
                        ]
                    })
                })
            })
        ]
    });
}
function $05dda706cd89d80b$var$findConnectorWithFile(data, fileId) {
    for (const connector of data){
        const allFiles = [
            connector.current,
            connector.mostRecent.income_statement,
            connector.mostRecent.balance_sheet,
            connector.historical.income_statement,
            connector.historical.balance_sheet
        ].filter((f)=>f !== null);
        for (const file of allFiles){
            if (file.id === fileId) return `${connector.sourceConnectorType}:${connector.sourceConnectorId}`;
            if (file.labeledFiles?.some((lf)=>lf.id === fileId)) return `${connector.sourceConnectorType}:${connector.sourceConnectorId}`;
        }
    }
    return null;
}
function $05dda706cd89d80b$export$1bd8ce924a3972ad() {
    const { data: data, isLoading: isLoading } = (0, $r2uF6.useAtomValue)((0, $b010adf4533db8e7$export$b0056b5eb48ed0b0));
    const { selectedFileId: selectedFileId } = (0, $r2uF6.useAtomValue)((0, $175863902df2ee1a$export$4d2c75fe8b80fe70));
    const [openConnectorId, setOpenConnectorId] = (0, $acw62.useState)(null);
    const hasInitialized = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (data && data.length > 0 && !hasInitialized.current) {
            hasInitialized.current = true;
            const found = selectedFileId ? $05dda706cd89d80b$var$findConnectorWithFile(data, selectedFileId) : null;
            const firstConnectorId = `${data[0].sourceConnectorType}:${data[0].sourceConnectorId}`;
            setOpenConnectorId(found ?? firstConnectorId);
        }
    }, [
        data,
        selectedFileId
    ]);
    if (isLoading && !data) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "Loading..."
    });
    if (!data || data.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex flex-col gap-8",
        children: data.map((connector)=>{
            const connectorId = `${connector.sourceConnectorType}:${connector.sourceConnectorId}`;
            return /*#__PURE__*/ (0, $ayMG0.jsx)($05dda706cd89d80b$var$ConnectorTreeItem, {
                connector: connector,
                isOpen: openConnectorId === connectorId,
                onToggle: ()=>setOpenConnectorId((prev)=>prev === connectorId ? null : connectorId)
            }, connectorId);
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $r2uF6 = parcelRequire("r2uF6");


var $9QePP = parcelRequire("9QePP");

var $2hw4u = parcelRequire("2hw4u");
var $fRJCp = parcelRequire("fRJCp");



parcelRequire("UXGeS");
var $7Y7Q4 = parcelRequire("7Y7Q4");




var $kdwja = parcelRequire("kdwja");

function $ee677b98b877eade$var$parseDateFromFilename(filename) {
    const match = filename.match(/(?:cl|labeled)-(\d{14})/);
    if (!match) return "";
    const dateStr = match[1];
    const year = dateStr.slice(0, 4);
    const month = dateStr.slice(4, 6);
    const day = dateStr.slice(6, 8);
    const hour = dateStr.slice(8, 10);
    const min = dateStr.slice(10, 12);
    const sec = dateStr.slice(12, 14);
    return `${year}-${month}-${day} ${hour}:${min}:${sec}.00000`;
}
function $ee677b98b877eade$var$findUploadWithFile(data, fileId) {
    const allUploads = [
        ...data.unlabeled,
        ...data.labeled
    ];
    for (const upload of allUploads){
        if (upload.id === fileId) return upload.id;
        for (const cleaned of upload.cleanedChildren){
            if (cleaned.id === fileId) return upload.id;
            if (cleaned.labeledFiles.some((lf)=>lf.id === fileId)) return upload.id;
        }
    }
    return null;
}
function $ee677b98b877eade$export$6ed18db89b51abeb() {
    const { data: data, isLoading: isLoading } = (0, $r2uF6.useAtomValue)((0, $b010adf4533db8e7$export$1c5ebe55f48780cb));
    const { selectedFileId: selectedFileId } = (0, $r2uF6.useAtomValue)((0, $175863902df2ee1a$export$4d2c75fe8b80fe70));
    const [openId, setOpenId] = (0, $acw62.useState)(null);
    const hasInitialized = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (data && !hasInitialized.current) {
            hasInitialized.current = true;
            const found = selectedFileId ? $ee677b98b877eade$var$findUploadWithFile(data, selectedFileId) : null;
            setOpenId(found);
        }
    }, [
        data,
        selectedFileId
    ]);
    if (isLoading && !data) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "Loading..."
    });
    if (!data) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col gap-8",
        children: [
            data.unlabeled.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "heading-s mb-3 text-slate-500",
                        children: "Unlabeled"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex flex-col gap-6",
                        children: data.unlabeled.map((upload)=>/*#__PURE__*/ (0, $ayMG0.jsx)($ee677b98b877eade$export$4ad1bd65ea72303b, {
                                upload: upload,
                                isOpen: openId === upload.id,
                                onToggle: ()=>setOpenId(openId === upload.id ? null : upload.id)
                            }, upload.id))
                    })
                ]
            }),
            data.labeled.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "heading-s mb-3 text-slate-500",
                        children: "Labeled"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex flex-col gap-6",
                        children: data.labeled.map((upload)=>/*#__PURE__*/ (0, $ayMG0.jsx)($ee677b98b877eade$export$4ad1bd65ea72303b, {
                                upload: upload,
                                isOpen: openId === upload.id,
                                onToggle: ()=>setOpenId(openId === upload.id ? null : upload.id)
                            }, upload.id))
                    })
                ]
            })
        ]
    });
}
function $ee677b98b877eade$export$4ad1bd65ea72303b({ upload: upload, isOpen: isOpen, onToggle: onToggle }) {
    const draftList = (0, $7Y7Q4.useApiQuery)((0, $d467c533cc3c7dc1$export$d705ef743e424c06));
    const fileTrees = (0, $acw62.useMemo)(()=>{
        return upload.cleanedChildren.map((cleaned)=>{
            const fileDraft = draftList.data?.find((d)=>d.fileId === cleaned.id);
            return {
                name: "Cleaned file",
                date: $ee677b98b877eade$var$parseDateFromFilename(cleaned.name),
                id: cleaned.id,
                documentKind: (0, $f19d5eec019b83cc$export$41e58614ac70f6e0).MIXED,
                draft: fileDraft ? {
                    id: fileDraft.id,
                    status: fileDraft.status === (0, $156754416c8f457d$export$ad9db10db9173ca8).COMMITTED ? "committed" : "uncommitted",
                    date: (0, $kdwja.formatDate)(fileDraft.createdAt, {
                        outputFormat: "MM/DD/YY",
                        dateFormat: undefined
                    })
                } : null,
                labeledFiles: cleaned.labeledFiles.map((lf)=>({
                        id: lf.id,
                        date: $ee677b98b877eade$var$parseDateFromFilename(lf.name)
                    }))
            };
        });
    }, [
        upload,
        draftList.data
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex items-center justify-between",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "body-small font-medium text-white",
                    children: (0, $e6bca67f7602658c$export$3dd21c4e644d75ee)(upload.name).replace(".arvo", "")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: (0, $9QePP.default)("py-1", "flex items-center gap-3"),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    onClick: onToggle,
                    className: (0, $9QePP.default)("no-styles pl-0.5", "text-button subdued flex items-center gap-1", "hover:text-white"),
                    children: [
                        isOpen ? "Hide details" : "See details",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).span, {
                            animate: {
                                rotate: isOpen ? 180 : 0
                            },
                            transition: {
                                type: "spring",
                                bounce: 0,
                                duration: 0.4
                            },
                            className: "flex",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f64a4ef9514b684d$export$2e2bcd8739ae039), {
                                className: "size-3 text-gray-500"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2hw4u.AnimatePresence), {
                initial: false,
                children: isOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                    initial: {
                        height: 0
                    },
                    animate: {
                        height: "auto"
                    },
                    exit: {
                        height: 0
                    },
                    transition: {
                        type: "spring",
                        bounce: 0,
                        duration: 0.4
                    },
                    className: "overflow-hidden",
                    children: fileTrees.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        className: (0, $9QePP.default)("flex flex-col gap-7", "pl-0.5 pt-5"),
                        children: fileTrees.map((tree)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $e158c25a634ed406$export$e4952a4933b3ab85), {
                                ...tree
                            }, tree.id))
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "pt-3 text-sm text-slate-500",
                        children: "No cleaned files yet"
                    })
                })
            })
        ]
    });
}





var $r2uF6 = parcelRequire("r2uF6");

function $dd9bf394b97c48da$export$671ecf45f89262a6() {
    const [fileType, setFileType] = (0, $r2uF6.useAtom)((0, $da6866c58be47883$export$44d966b2a77e4b26));
    const { data: selectedFile } = (0, $r2uF6.useAtomValue)((0, $175863902df2ee1a$export$380f8a5d1313e761));
    const hasInitialized = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (selectedFile && !hasInitialized.current) {
            hasInitialized.current = true;
            if (selectedFile.sourceType === (0, $f19d5eec019b83cc$export$d95e7684b6658cc2).UploadedFile) setFileType("uploads");
        }
    }, [
        selectedFile,
        setFileType
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)("flex h-full flex-col", "overflow-hidden px-2.5 pt-4"),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex h-full flex-col",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "shrink-0 pb-6",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: (0, $9QePP.default)("no-styles body-micro w-full cursor-pointer rounded py-2", fileType === "connectors" ? "bg-selected" : "bg-slate-900/20"),
                                onClick: ()=>setFileType("connectors"),
                                children: "Connectors"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: (0, $9QePP.default)("no-styles body-micro w-full cursor-pointer rounded py-2", fileType === "uploads" ? "bg-selected" : "bg-slate-900/20"),
                                onClick: ()=>setFileType("uploads"),
                                children: "Uploads"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: (0, $9QePP.default)("custom-scrollbar hide-scrollbar min-h-0 flex-1 overflow-y-auto"),
                    children: [
                        fileType === "connectors" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05dda706cd89d80b$export$1bd8ce924a3972ad), {}),
                        fileType === "uploads" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee677b98b877eade$export$6ed18db89b51abeb), {})
                    ]
                })
            ]
        })
    });
}



var $f19YE = parcelRequire("f19YE");
function $f0edf059f8c58615$export$2e2bcd8739ae039() {
    (0, $0c4fa35549255e3a$export$8a6f2c88fdcd2ba7)();
    (0, $0004c81bac9d4e37$export$981909ff1de7cf37)();
    const showCompanyList = (0, $r2uF6.useAtomValue)((0, $9b7b211c4c2184d7$export$2627579a5e93fc70));
    const { selectedFileId: selectedFileId } = (0, $r2uF6.useAtomValue)((0, $175863902df2ee1a$export$4d2c75fe8b80fe70));
    const drawerIsOpen = (0, $r2uF6.useAtomValue)((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae));
    const tasks = (0, $r2uF6.useAtomValue)((0, $540fa3f25212c24e$export$a501548c14b6cdc7));
    const draft = (0, $r2uF6.useAtomValue)((0, $540fa3f25212c24e$export$b0cbc03b849c7b1f));
    const router = (0, $fp4OM.useRouter)();
    const isReadonly = !router.params.draftId;
    const queryClient = (0, $f19YE.useQueryClient)();
    (0, $acw62.useEffect)(()=>{
        const finishedTask = tasks.data?.find((task)=>task.status === (0, $507e2ddca1927e0b$export$61db76a97f26b7e1).Completed);
        if (finishedTask) queryClient.refetchQueries({
            predicate: (query)=>typeof query.queryKey[0] === "string" && query.queryKey[0].startsWith("/file/data-association/file-list")
        }).then(()=>{
            router.navigate(`/beta/companies/${router.params.companyId}/labeling/files/${finishedTask.resultFileId}`);
        });
    }, [
        tasks.data,
        router.params.companyId,
        router.navigate
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    !showCompanyList && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d137961520e2401$export$26c4ec9456bef7c4), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dd9bf394b97c48da$export$671ecf45f89262a6), {})
                    }),
                    drawerIsOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fff2b4a85aca8f0e$export$40e2914dc29c2bf9), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e2948124cb679e4$export$31b0b10a5d06f0c1), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                className: "flex size-full",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: (0, $9QePP.default)("size-full px-6", "flex flex-col", "gap-3"),
                    children: [
                        !selectedFileId && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be0b2fec5eb99e3a$export$3f12d05be03333e), {}),
                        !isReadonly && !draft.data && draft.isError && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: "Draft 404 - Check if draft was converted to a labeled file"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e81a3bbc6dc2e118$export$39286f238df50487), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $644b92e8a76d3ba6$export$72e4c5c1c0102f6d), {})
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $fRJCp = parcelRequire("fRJCp");
parcelRequire("UXGeS");
var $7Y7Q4 = parcelRequire("7Y7Q4");

var $kkxkw = parcelRequire("kkxkw");
var $57632793987daaea$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType["RAW"] = "raw";
    DocumentType["CLEANED"] = "cleaned";
    DocumentType["LABELED"] = "labeled";
    DocumentType["OTHER"] = "other";
})($57632793987daaea$export$d1d99cf900472499 || ($57632793987daaea$export$d1d99cf900472499 = {}));
var $57632793987daaea$export$5cbac04c48369a25;
(function(CreatedByType) {
    CreatedByType["USER"] = "user";
    CreatedByType["SERVICE"] = "service";
})($57632793987daaea$export$5cbac04c48369a25 || ($57632793987daaea$export$5cbac04c48369a25 = {}));
var $57632793987daaea$export$27a4864e1e35718c;
(function(FileSource) {
    FileSource["CODAT"] = "codat";
    FileSource["SYSTEM_UPLOADED"] = "system_uploaded";
    FileSource["USER_UPLOADED"] = "user_uploaded";
})($57632793987daaea$export$27a4864e1e35718c || ($57632793987daaea$export$27a4864e1e35718c = {}));
var $57632793987daaea$export$12285701b2de51a4;
(function(UserReportedUploadType) {
    UserReportedUploadType["BALANCE_SHEET"] = "balance_sheet";
    UserReportedUploadType["INCOME_STATEMENT"] = "income_statement";
    UserReportedUploadType["FINANCIAL_SUMMARY"] = "financial_summary";
    UserReportedUploadType["COMPANY_DECK"] = "company_deck";
    UserReportedUploadType["CAP_TABLE"] = "cap_table";
    UserReportedUploadType["TRANSACTION_DATA"] = "transaction_data";
    UserReportedUploadType["OTHER"] = "other";
    UserReportedUploadType["UNKNOWN"] = "unknown";
})($57632793987daaea$export$12285701b2de51a4 || ($57632793987daaea$export$12285701b2de51a4 = {}));


parcelRequire("gCemA");
var $9O2q1 = parcelRequire("9O2q1");
const $0b46c1ccb92584b0$export$8b3ca78f81ec578c = (0, $kkxkw.createQuery)(async ({ api: api, router: router })=>{
    const response = await api.get(`/file/files/${router.params.fileId}`);
    return response;
});
const $0b46c1ccb92584b0$export$d964e69f1fd5fd4c = (0, $kkxkw.createQuery)(async ({ api: api, router: router, params: params })=>{
    const response = await api.get(`/file/files?max_page_size=999&company_id=in.("${router.params.companyId}")${params.source ? `&source=eq.${params.source}` : ""}`);
    return response.items;
});
const $0b46c1ccb92584b0$export$58ba4cc3b29094c1 = (0, $kkxkw.createQuery)(async ({ api: api, router: router })=>{
    const query = new (0, $9O2q1.QueryStringBuilder)().equals("company_id", router.params.companyId || "").equals("source", (0, $57632793987daaea$export$27a4864e1e35718c).USER_UPLOADED).equals("document_type", "raw").add("max_page_size", "999").build();
    const response = await api.get(`/file/files?${query}`);
    return response.items;
});
const $0b46c1ccb92584b0$var$flattenFileTree = (tree)=>{
    const result = [
        {
            id: tree.id,
            name: tree.name
        }
    ];
    if (tree.ancestors && tree.ancestors.length > 0) tree.ancestors.forEach((ancestor)=>{
        result.push(...$0b46c1ccb92584b0$var$flattenFileTree(ancestor));
    });
    return result;
};
const $0b46c1ccb92584b0$export$c6fd3ab3f44300d0 = (0, $kkxkw.createQuery)(async ({ api: api, params: params })=>{
    const response = await api.get(`/file/files/${params.fileId}/ancestors`);
    const flattened = $0b46c1ccb92584b0$var$flattenFileTree(response).reverse();
    const root = flattened[0];
    const fileData = await api.get(`/file/files/${root.id}`);
    return {
        root: fileData,
        children: flattened.slice(1)
    };
});
const $0b46c1ccb92584b0$var$flattenLineageTree = (tree)=>{
    const result = [];
    if (tree.descendants && tree.descendants.length > 0) tree.descendants.forEach((descendant)=>{
        result.push({
            id: descendant.id,
            name: descendant.name
        });
        result.push(...$0b46c1ccb92584b0$var$flattenLineageTree(descendant));
    });
    return result.slice(1);
};
const $0b46c1ccb92584b0$export$d607bcb6675e3e03 = (0, $kkxkw.createQuery)(async ({ api: api, params: params })=>{
    const response = await api.get(`/file/files/${params.fileId}/descendants`);
    if (params.flattened) return $0b46c1ccb92584b0$var$flattenLineageTree(response);
    return response;
});



var $gxPgh = parcelRequire("gxPgh");

var $acw62 = parcelRequire("acw62");

var $jIDNV = parcelRequire("jIDNV");
const $eaa0bf5428ed45d5$export$d668b1a522cebf24 = (0, $jIDNV.themeQuartz).withPart((0, $jIDNV.colorSchemeDark)).withParams({
    accentColor: "#6B7280",
    backgroundColor: "#1E293B",
    borderColor: "#334155",
    browserColorScheme: "dark",
    fontFamily: {
        googleFont: "Inter"
    },
    foregroundColor: "#FFFFFF",
    headerFontSize: 14,
    headerVerticalPaddingScale: 1,
    rowHoverColor: "#334155",
    rowBorder: {
        color: "#0f172a"
    },
    headerColumnResizeHandleColor: "#475569",
    rowHeight: 48
});




var $kdwja = parcelRequire("kdwja");

var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("UXGeS");
var $7Y7Q4 = parcelRequire("7Y7Q4");

parcelRequire("i5Lss");
var $kkxkw = parcelRequire("kkxkw");
const $385acc50caa4c21d$export$7cbf767827cd68ba = (0, $kkxkw.createQuery)(async ({ params: params, api: api })=>{
    return api.get(`/identity/users/${params.userId}`);
});


function $5fc430caefd70d83$export$3854efb64e2f2baa({ createdByType: createdByType, createdByUserId: createdByUserId }) {
    if (createdByType === (0, $57632793987daaea$export$5cbac04c48369a25).USER) return /*#__PURE__*/ (0, $ayMG0.jsx)($5fc430caefd70d83$export$2335e219cd472981, {
        userId: createdByUserId
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex h-full items-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "body-s",
            children: "System"
        })
    });
}
function $5fc430caefd70d83$export$2335e219cd472981({ userId: userId }) {
    const { data: user, isLoading: isLoading } = (0, $7Y7Q4.useApiQuery)((0, $385acc50caa4c21d$export$7cbf767827cd68ba), {
        params: {
            userId: userId
        }
    });
    console.log("user", user);
    if (!user && isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "h-4 w-24 animate-pulse rounded"
    });
    if (!user) return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        children: "-"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex h-full items-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
            className: "body-s",
            children: [
                user.firstName,
                " ",
                user.lastName
            ]
        })
    });
}




var $ggKhH = parcelRequire("ggKhH");

var $r2uF6 = parcelRequire("r2uF6");
const $49943a6a658e17a3$export$fef02d1c38dd46 = (0, $r2uF6.atom)(null);
const $49943a6a658e17a3$export$b02ed3dce3787ad2 = (0, $r2uF6.atom)(false);



var $r2uF6 = parcelRequire("r2uF6");



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("5rtdy");
var $bVQej = parcelRequire("bVQej");

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");
parcelRequire("ii2jZ");
var $hQ0nj = parcelRequire("hQ0nj");
var $97C3K = parcelRequire("97C3K");

var $hEJWZ = parcelRequire("hEJWZ");

var $98Yiq = parcelRequire("98Yiq");
parcelRequire("i5Lss");
var $2mq6B = parcelRequire("2mq6B");
var $gBHSi = parcelRequire("gBHSi");

const $3b8e62912a79c21c$export$3fc4c720d891513c = (0, $gBHSi.createMutation)(async ({ api: api, payload: payload })=>{
    const response = await api.post(`/file/files/${payload.fileId}/download`);
    console.log(response, "download response");
    return response;
});
const $3b8e62912a79c21c$export$9b52de716ff76436 = (0, $gBHSi.createMutation)(async ({ api: api, payload: payload })=>{
    if (!payload.file) throw new Error("File is required");
    const response = await api.post(`/file/uploads`, {
        name: payload.name,
        ancestorFileId: null,
        mimeType: payload.mimeType,
        documentType: "raw",
        source: (0, $57632793987daaea$export$27a4864e1e35718c).USER_UPLOADED,
        meta: {
            userReportedUploadType: payload.contentType
        }
    });
    const presignedUrl = response.presignedUrl;
    const s3 = (0, $2mq6B.createApiClient)({
        withCredentials: false
    });
    const fileContent = await payload.file.arrayBuffer();
    return s3.put(presignedUrl, fileContent, {
        headers: {
            "Content-Type": payload.mimeType
        }
    });
}, {
    errorToast: {
        message: "Failed to upload file"
    },
    successToast: {
        message: "File uploaded successfully"
    },
    invalidates: [
        "/files"
    ]
});


parcelRequire("lhALd");
var $4CoXh = parcelRequire("4CoXh");
var $3b3cb8ececfb0c74$var$FileContentType;
(function(FileContentType) {
    FileContentType["BALANCE_SHEET"] = "balance_sheet";
    FileContentType["INCOME_STATEMENT"] = "income_statement";
    FileContentType["FINANCIAL_SUMMARY"] = "financial_summary";
    FileContentType["COMPANY_DECK"] = "company_deck";
    FileContentType["CAP_TABLE"] = "cap_table";
    FileContentType["TRANSACTION_DATA"] = "transaction_data";
    FileContentType["MIXED"] = "mixed";
    FileContentType["OTHER"] = "other";
    FileContentType["UNKNOWN"] = "unknown";
})($3b3cb8ececfb0c74$var$FileContentType || ($3b3cb8ececfb0c74$var$FileContentType = {}));
const $3b3cb8ececfb0c74$var$FILE_CONTENT_TYPE_LABELS = {
    ["balance_sheet"]: "Balance sheet",
    ["income_statement"]: "Income statement",
    ["financial_summary"]: "Financial summary",
    ["company_deck"]: "Company deck",
    ["cap_table"]: "Cap table",
    ["transaction_data"]: "Transaction data",
    ["mixed"]: "Mixed",
    ["other"]: "Other",
    ["unknown"]: "Unknown"
};
function $3b3cb8ececfb0c74$export$bb2f1d13e60d26b7() {
    const [file, setFile] = (0, $acw62.useState)(null);
    const { mutate: uploadFile } = (0, $4CoXh.useApiMutation)((0, $3b8e62912a79c21c$export$9b52de716ff76436));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("px-6", "absolute inset-0 flex min-h-0 flex-col overflow-hidden"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "sticky my-6 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3398e3e074fa037e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "pageheading",
                        children: "Upload a new file"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "ui-element",
                children: "Selected file"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bVQej.DropZone), {
                file: file || undefined,
                onRemove: ()=>{
                    setFile(null);
                },
                onFileUpload: (file)=>{
                    console.log(file);
                    setFile(file);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hQ0nj.Form), {
                id: "upload:form",
                schema: $hEJWZ.object({
                    contentType: $hEJWZ.mixed().required()
                }).required(),
                onSubmit: (data)=>{
                    console.log(data);
                    if (!file) return;
                    uploadFile({
                        name: file.name,
                        mimeType: file.type,
                        contentType: data.contentType,
                        file: file
                    });
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt-6 grid grid-cols-1 gap-6",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97C3K.Select), {
                            name: "contentType",
                            label: "What type of content is in this file?",
                            placeholder: "Select content type",
                            options: (0, $98Yiq.selectOptionsFromMap)($3b3cb8ececfb0c74$var$FILE_CONTENT_TYPE_LABELS)
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "submit",
                        form: "upload:form",
                        className: "xl mt-6 w-full",
                        disabled: !file,
                        children: "Upload file"
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $1zFjz = parcelRequire("1zFjz");

var $9QePP = parcelRequire("9QePP");

var $4CoXh = parcelRequire("4CoXh");


var $acw62 = parcelRequire("acw62");
function $10e4c9ac84efc26e$var$ArrowDownTrayIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
    }));
}
const $10e4c9ac84efc26e$var$ForwardRef = $acw62.forwardRef($10e4c9ac84efc26e$var$ArrowDownTrayIcon);
var $10e4c9ac84efc26e$export$2e2bcd8739ae039 = $10e4c9ac84efc26e$var$ForwardRef;


parcelRequire("UXGeS");
var $7Y7Q4 = parcelRequire("7Y7Q4");


var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");


var $9QePP = parcelRequire("9QePP");

var $2hw4u = parcelRequire("2hw4u");
var $fRJCp = parcelRequire("fRJCp");

var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");


var $9QePP = parcelRequire("9QePP");

var $lzNIT = parcelRequire("lzNIT");
function $905e624c3ced9360$export$290050a4541704d8({ node: node, children: children, isLast: isLast = false, level: level = 0 }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
        className: (0, $9QePP.default)("relative flex flex-col gap-1", isLast && "pb-4"),
        children: [
            !isLast && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("w-0.5", "absolute  rounded", level === 0 ? "-bottom-6 left-[0.45rem] top-6 bg-slate-600" : `-bottom-6 left-[7px] top-6 bg-slate-400`)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-start justify-between gap-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-start gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "relative z-10 mt-1",
                                children: [
                                    node.status === "completed" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $898ede00ff16e210$export$2e2bcd8739ae039), {
                                        className: "size-4"
                                    }),
                                    node.status === "in-progress" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: (0, $9QePP.default)("mt-1", "ring-2 ", "ml-1 size-2 rounded-full", level === 0 ? "ring-slate-600" : "ring-slate-500")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "subdued",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        className: "text-default",
                                        children: node.emphasizedText
                                    }),
                                    node.emphasizedText && " ",
                                    node.text
                                ]
                            })
                        ]
                    }),
                    node.date && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "body-s mt-px text-gray-500",
                        children: node.date
                    })
                ]
            }),
            node.link && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                to: node.link.href,
                className: "ml-7",
                children: node.link.label
            }),
            children
        ]
    }, node.id);
}


function $7f9a01c678350996$export$976248da9533a822({ node: node }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $905e624c3ced9360$export$290050a4541704d8), {
                node: node,
                isLast: false,
                level: 1,
                frontDash: true
            }),
            node.nodes && node.nodes.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                className: "flex flex-col gap-6",
                children: node.nodes?.map((childNode)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $905e624c3ced9360$export$290050a4541704d8), {
                        node: childNode,
                        level: 2,
                        isLast: true
                    }, childNode.id))
            })
        ]
    });
}



function $49c9493585d92783$export$24eb92f0123c1674({ node: node, isLast: isLast = false, level: level = 0, isOpen: isOpen = false, setIsOpen: setIsOpen }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $905e624c3ced9360$export$290050a4541704d8), {
        node: node,
        level: level,
        isLast: isLast,
        children: [
            node.nodes && node.nodes.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: (0, $9QePP.default)("ml-7 py-1", "flex items-center gap-3"),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "h-0.5 w-3 rounded bg-slate-600"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            onClick: ()=>setIsOpen?.(!isOpen),
                            className: "quiet -m-1 p-1",
                            children: [
                                isOpen ? "See less" : "See more",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).span, {
                                    animate: {
                                        rotate: isOpen ? 180 : 0
                                    },
                                    transition: {
                                        type: "spring",
                                        bounce: 0,
                                        duration: 0.4
                                    },
                                    className: "flex",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f64a4ef9514b684d$export$2e2bcd8739ae039), {
                                        className: "size-4 text-gray-500"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2hw4u.AnimatePresence), {
                initial: false,
                children: isOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                    initial: {
                        height: 0
                    },
                    animate: {
                        height: "auto"
                    },
                    exit: {
                        height: 0
                    },
                    transition: {
                        type: "spring",
                        bounce: 0,
                        duration: 0.4
                    },
                    className: "overflow-hidden",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        className: (0, $9QePP.default)("ml-6 pl-1", "flex flex-col gap-6", node.nodes?.length === 1 ? "pt-2" : "pt-5"),
                        children: node.nodes?.map((childNode)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f9a01c678350996$export$976248da9533a822), {
                                node: childNode
                            }, childNode.id))
                    })
                })
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
function $d8a5960c8a556fbd$export$57ede23f90ec25e2({ nodes: nodes }) {
    const [openIndex, setOpenIndex] = (0, $acw62.useState)([
        0,
        -1
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        className: (0, $9QePP.default)("flex flex-col gap-6"),
        children: nodes.map((node, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $49c9493585d92783$export$24eb92f0123c1674), {
                node: node,
                isLast: index === nodes.length - 1,
                isOpen: openIndex[0] === 0 && openIndex[1] === index,
                setIsOpen: (isOpen)=>{
                    setOpenIndex([
                        0,
                        isOpen ? index : -1
                    ]);
                }
            }, node.id))
    });
}
const $d8a5960c8a556fbd$export$695720b7e7a61533 = [
    {
        id: "1",
        emphasizedText: "File created",
        text: "from Codat pull",
        status: "completed",
        date: "10/10/2025",
        link: {
            label: "View file in labeling",
            href: "/beta/companies/123/labeling/files/123"
        }
    },
    {
        id: "2",
        emphasizedText: "File cleaned",
        text: "",
        status: "completed",
        date: "10/10/2025",
        link: {
            label: "View file in labeling",
            href: "/beta/companies/123/labeling/files/123"
        },
        nodes: [
            {
                id: "3",
                emphasizedText: "Michael Foster",
                text: "labeled this file",
                status: "completed",
                date: "10/10/2025",
                link: {
                    label: "View file in labeling",
                    href: "/beta/companies/123/labeling/files/123"
                },
                nodes: [
                    {
                        id: "5",
                        emphasizedText: "Data ingested",
                        text: "for metrics",
                        status: "completed",
                        date: "10/12/2025"
                    }
                ]
            },
            {
                id: "10",
                emphasizedText: "Blair Silververg",
                text: "labeled this file",
                status: "completed",
                date: "10/10/2025",
                link: {
                    label: "View file in labeling",
                    href: "/beta/companies/123/labeling/files/123"
                },
                nodes: [
                    {
                        id: "88",
                        text: "Data not yet ingested for metrics",
                        status: "in-progress"
                    }
                ]
            }
        ]
    },
    {
        id: "5",
        emphasizedText: "File cleaned",
        text: "",
        status: "completed",
        date: "10/10/2025",
        nodes: [
            {
                id: "6",
                emphasizedText: "Michael Foster",
                text: "labeled this file",
                status: "completed",
                nodes: [
                    {
                        id: "7",
                        text: "Data not yet ingested for metrics",
                        status: "in-progress"
                    }
                ]
            }
        ]
    }
];



function $b7982573fdbfd13c$var$getFileType(name) {
    if (name.startsWith("raw-")) return "raw";
    if (name.startsWith("cl-")) return "cleaned";
    if (name.startsWith("labeled-")) return "labeled";
    return "raw";
}
function $b7982573fdbfd13c$var$formatDate(dateString) {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
}
function $b7982573fdbfd13c$var$extractDateFromFilename(filename) {
    const match = filename.match(/^(?:cl|labeled)-(\d{8})/);
    if (!match) return null;
    const dateStr = match[1];
    const year = dateStr.substring(0, 4);
    const month = dateStr.substring(4, 6);
    const day = dateStr.substring(6, 8);
    return `${month}/${day}/${year}`;
}
function $b7982573fdbfd13c$var$convertFileToLineageNode(file, companyId, meta) {
    const fileType = $b7982573fdbfd13c$var$getFileType(file.name);
    let emphasizedText = "";
    let text = "";
    switch(fileType){
        case "raw":
            if (meta?.source === (0, $57632793987daaea$export$27a4864e1e35718c).USER_UPLOADED || meta?.source === (0, $57632793987daaea$export$27a4864e1e35718c).SYSTEM_UPLOADED) {
                emphasizedText = "File uploaded";
                text = "";
            } else {
                emphasizedText = "File created";
                text = "from Codat pull";
            }
            break;
        case "cleaned":
            emphasizedText = "File cleaned";
            text = "";
            break;
        case "labeled":
            emphasizedText = "File labeled";
            text = "";
            break;
    }
    const lineageNode = {
        id: file.id,
        emphasizedText: emphasizedText,
        text: text,
        status: "completed"
    };
    if (fileType === "raw" && meta?.createdAt) lineageNode.date = $b7982573fdbfd13c$var$formatDate(meta.createdAt);
    if (fileType === "cleaned" || fileType === "labeled") {
        const extractedDate = $b7982573fdbfd13c$var$extractDateFromFilename(file.name);
        if (extractedDate) lineageNode.date = extractedDate;
        lineageNode.link = {
            label: "View file in labeling",
            href: `/beta/companies/${companyId}/labeling/files/${file.id}`
        };
    }
    if (file.descendants && file.descendants.length > 0) lineageNode.nodes = file.descendants.map((descendant)=>$b7982573fdbfd13c$var$convertFileToLineageNode(descendant, companyId));
    if (fileType === "labeled") {
        const dataIngestionNode = {
            id: `${file.id}-ingestion`,
            text: "Data ingestion status coming soon",
            status: "in-progress"
        };
        lineageNode.nodes = lineageNode.nodes ? [
            ...lineageNode.nodes,
            dataIngestionNode
        ] : [
            dataIngestionNode
        ];
    }
    return lineageNode;
}
function $b7982573fdbfd13c$export$566f65d6e3c7a91f(fileTree, meta) {
    const rootNode = $b7982573fdbfd13c$var$convertFileToLineageNode(fileTree, meta.companyId, {
        source: meta.source,
        createdAt: meta.createdAt,
        createdBy: meta.createdBy
    });
    const cleanedNodes = rootNode.nodes || [];
    delete rootNode.nodes;
    if (cleanedNodes.length === 1) {
        const singleCleanedNode = cleanedNodes[0];
        const labeledNodes = singleCleanedNode.nodes || [];
        delete singleCleanedNode.nodes;
        const flattenedNodes = [
            rootNode,
            singleCleanedNode
        ];
        labeledNodes.forEach((labeledNode)=>{
            const ingestionNodes = labeledNode.nodes || [];
            delete labeledNode.nodes;
            flattenedNodes.push(labeledNode);
            flattenedNodes.push(...ingestionNodes);
        });
        return flattenedNodes;
    }
    return [
        rootNode,
        ...cleanedNodes
    ];
}



var $fp4OM = parcelRequire("fp4OM");
function $f4b604b960ad37e8$export$f82f46d3a77e3ab5({ selectedUpload: selectedUpload }) {
    const router = (0, $fp4OM.useRouter)();
    const companyId = router.params.companyId;
    const { mutate: download } = (0, $4CoXh.useApiMutation)((0, $3b8e62912a79c21c$export$3fc4c720d891513c), {
        onSuccess: (data)=>{
            console.log(data, "download success");
            (0, $1zFjz.downloadFile)(data.presignedUrl);
        }
    });
    const { data: descendants, isLoading: isLoading } = (0, $7Y7Q4.useApiQuery)((0, $0b46c1ccb92584b0$export$d607bcb6675e3e03), {
        params: {
            fileId: selectedUpload.id
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("px-6", "absolute inset-0 flex min-h-0 flex-col overflow-hidden"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "sticky my-6 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3398e3e074fa037e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "pageheading",
                        children: selectedUpload.name
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        className: "quiet w-fit",
                        onClick: ()=>{
                            console.log(selectedUpload, "download");
                            download({
                                fileId: selectedUpload.id
                            });
                        },
                        children: [
                            "Download ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10e4c9ac84efc26e$export$2e2bcd8739ae039), {
                                className: "size-4"
                            })
                        ]
                    })
                ]
            }),
            !descendants && isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: [
                    ...Array(3)
                ].map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, $9QePP.default)("bg-selected mb-2 h-10 w-full animate-pulse self-center rounded")
                    }, i))
            }),
            descendants && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "custom-scrollbar hide-scrollbar overflow-y-scroll pb-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "heading-l pb-4",
                        children: "File lineage"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8a5960c8a556fbd$export$57ede23f90ec25e2), {
                        nodes: (0, $b7982573fdbfd13c$export$566f65d6e3c7a91f)(descendants, {
                            source: selectedUpload.source,
                            createdAt: selectedUpload.createdAt,
                            createdBy: selectedUpload.createdByUserId,
                            companyId: companyId
                        })
                    })
                ]
            })
        ]
    });
}


function $1d01434f5f4f741a$export$2e2bcd8739ae039() {
    const { data: files } = (0, $7Y7Q4.useApiQuery)((0, $0b46c1ccb92584b0$export$d964e69f1fd5fd4c), {
        params: {
            source: (0, $57632793987daaea$export$27a4864e1e35718c).USER_UPLOADED
        }
    });
    const gridRef = (0, $acw62.useRef)(null);
    const [selectedUpload, setSelectedUpload] = (0, $r2uF6.useAtom)((0, $49943a6a658e17a3$export$fef02d1c38dd46));
    const [showUploadForm, setShowUploadForm] = (0, $r2uF6.useAtom)((0, $49943a6a658e17a3$export$b02ed3dce3787ad2));
    const setRightDrawerOpen = (0, $r2uF6.useSetAtom)((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae));
    if (!files) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d137961520e2401$export$26c4ec9456bef7c4), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mt-6 px-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "lozenge mb-4",
                                    children: "Quick Actions"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                    className: "flex flex-col gap-2",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            type: "button",
                                            className: "quiet",
                                            onClick: ()=>{
                                                setShowUploadForm(true);
                                                setRightDrawerOpen(true);
                                                setSelectedUpload(null);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ggKhH.default), {
                                                    className: "size-4"
                                                }),
                                                "Upload a new file"
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    selectedUpload && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fff2b4a85aca8f0e$export$40e2914dc29c2bf9), {
                        onClose: ()=>setSelectedUpload(null),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4b604b960ad37e8$export$f82f46d3a77e3ab5), {
                            selectedUpload: selectedUpload
                        })
                    }),
                    showUploadForm && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fff2b4a85aca8f0e$export$40e2914dc29c2bf9), {
                        onClose: ()=>setShowUploadForm(false),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3b3cb8ececfb0c74$export$bb2f1d13e60d26b7), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                className: "flex size-full",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: (0, $9QePP.default)("size-full px-6", "flex flex-col", "gap-3"),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        id: "labeling-grid",
                        className: "size-full",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gxPgh.AgGridReact), {
                            ref: gridRef,
                            theme: (0, $eaa0bf5428ed45d5$export$d668b1a522cebf24),
                            rowData: files.filter((file)=>file.source === (0, $57632793987daaea$export$27a4864e1e35718c).USER_UPLOADED),
                            // getRowId={(params) => params.data.id}
                            // onCellClicked={onRowClicked}
                            columnDefs: [
                                {
                                    headerName: "Name",
                                    colId: "name",
                                    field: "name",
                                    pinned: "left",
                                    suppressHeaderMenuButton: true,
                                    sortable: false,
                                    width: 600,
                                    // autoHeight: true,
                                    cellRenderer: (params)=>{
                                        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "flex h-full items-center",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "body-s text-wrap",
                                                children: params.data?.name
                                            })
                                        });
                                    }
                                },
                                // {
                                //     headerName: "Content Type",
                                //     colId: "contentType",
                                //     suppressHeaderMenuButton: true,
                                //     sortable: false,
                                //     sort: "asc",
                                //     valueGetter: (params) => {
                                //         console.log(params.data);
                                //         if (!params.data) return "unknown";
                                //         const data = params.data;
                                //         return (
                                //             associatedFiles.find(
                                //                 (file) => file.id === data.id,
                                //             )?.documentKind ||
                                //             data.meta?.codatDataType ||
                                //             data.meta?.userReportedUploadType ||
                                //             "unknown"
                                //         );
                                //     },
                                //     cellRenderer: (params) => {
                                //         console.log(params);
                                //         return (
                                //             <ContentTypeCell
                                //                 type={params.value}
                                //             />
                                //         );
                                //     },
                                // },
                                {
                                    headerName: "Date created",
                                    colId: "createdAt",
                                    suppressHeaderMenuButton: true,
                                    sortable: false,
                                    valueGetter: (params)=>{
                                        if (!params.data) return "";
                                        return (0, $kdwja.formatDate)(params.data.createdAt, {
                                            hideTime: true,
                                            dateFormat: "YYYY-MM-DDTHH:mm:ssZ"
                                        });
                                    }
                                },
                                {
                                    headerName: "Creator",
                                    colId: "creator",
                                    suppressHeaderMenuButton: true,
                                    sortable: false,
                                    cellRenderer: (params)=>{
                                        if (!params.data) return null;
                                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5fc430caefd70d83$export$3854efb64e2f2baa), {
                                            createdByType: params.data.createdByType,
                                            createdByUserId: params.data.createdByUserId
                                        });
                                    }
                                }
                            ],
                            defaultColDef: {
                                flex: 1
                            },
                            rowSelection: {
                                mode: "multiRow",
                                checkboxes: false,
                                headerCheckbox: false,
                                enableClickSelection: true
                            },
                            onRowClicked: (params)=>{
                                setSelectedUpload(params.data);
                                setRightDrawerOpen(true);
                                setShowUploadForm(false);
                            }
                        })
                    })
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");

var $fRJCp = parcelRequire("fRJCp");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("i5Lss");
var $2mq6B = parcelRequire("2mq6B");
var $gBHSi = parcelRequire("gBHSi");
const $cdd36b0a35996d12$export$c1b9374d33a8c73b = (0, $gBHSi.createMutation)(async ({ router: router, payload: payload, session: session, queryClient: queryClient })=>{
    const response = await (0, $2mq6B.createApiClient)({
        token: session.token.data || undefined,
        convert: false
    }).get(`${"https://finance.humcapital.com"}/api/beta/companies/${router.params.companyId}/metric-query?value_kind=lineage&m=${payload.metricQuery}`);
    queryClient.setQueryData([
        payload.metricQuery
    ], ()=>response);
    console.log("Response received:", response);
    return response;
});


parcelRequire("8y7qB");
var $4CoXh = parcelRequire("4CoXh");

var $acw62 = parcelRequire("acw62");
parcelRequire("2bFYF");
var $fp4OM = parcelRequire("fp4OM");

var $eQbhf = parcelRequire("eQbhf");
var $510530300011b746$export$56bac1c8ab171501;
(function(WindowOperation) {
    WindowOperation["AVERAGE"] = "a";
    WindowOperation["SUM"] = "s";
    WindowOperation["LATEST"] = "l";
    WindowOperation["DELTA"] = "d";
    WindowOperation["COMPLETE_AVERAGE"] = "ca";
    WindowOperation["COMPLETE_SUM"] = "cs";
})($510530300011b746$export$56bac1c8ab171501 || ($510530300011b746$export$56bac1c8ab171501 = {}));
const $510530300011b746$export$da0fe96ab73ea9bc = {
    ["a"]: "Average",
    ["s"]: "Sum",
    ["l"]: "Latest",
    ["d"]: "Delta",
    ["ca"]: "Complete Average",
    ["cs"]: "Complete Sum"
};


function $8925dee771df3f1c$export$641df5f5430d6889(query) {
    let metricQueryString = `${query.metric}-${query.periodResolution}`;
    if (query.window && query.window.size >= 1 && query.window.size <= 255) {
        const windowPrefix = query.window.applyLast ? "W" : "w";
        metricQueryString += `-${windowPrefix}${query.window.size}${query.window.operation}`;
    }
    return metricQueryString;
}
function $8925dee771df3f1c$export$7600411ded78bf59(queryString) {
    const defaultQuery = {
        metric: (0, $eQbhf.AccountLabel).REVENUES,
        periodResolution: "y",
        metricQuery: `${(0, $eQbhf.AccountLabel).REVENUES}-y`
    };
    if (!queryString) return defaultQuery;
    const parts = queryString.split("-");
    if (parts.length < 2) return defaultQuery;
    const metric = parts[0];
    const periodResolution = parts[1];
    if (!Object.values((0, $eQbhf.AccountLabel)).includes(metric)) return defaultQuery;
    if (![
        "m",
        "q",
        "y"
    ].includes(periodResolution)) return defaultQuery;
    const result = {
        metric: metric,
        periodResolution: periodResolution,
        metricQuery: queryString
    };
    if (parts.length >= 3) {
        const windowPart = parts[2];
        const applyLast = windowPart.startsWith("W");
        const windowContent = applyLast ? windowPart.slice(1) : windowPart.slice(1);
        const operationMatch = windowContent.match(/^(\d+)(.+)$/);
        if (operationMatch) {
            const size = parseInt(operationMatch[1], 10);
            const operation = operationMatch[2];
            if (size >= 1 && size <= 255 && Object.values((0, $510530300011b746$export$56bac1c8ab171501)).includes(operation)) result.window = {
                size: size,
                applyLast: applyLast,
                operation: operation
            };
        }
    }
    return result;
}




var $acw62 = parcelRequire("acw62");


var $r2uF6 = parcelRequire("r2uF6");
function $236cf33bdfc7dc8d$export$92ed10736eb52fbc() {
    const [stack, setStack] = (0, $r2uF6.useAtom)((0, $fa5d3143bb23a04a$export$81f196b73601ea1));
    (0, $acw62.useEffect)(()=>{
        (0, $032deecb0f4a84f7$export$1f73f60bdb811cb1)((0, $032deecb0f4a84f7$export$e9d9376124133876).MetricLab, {
            metricStack: stack
        });
    }, [
        stack
    ]);
    const appendToStack = (0, $acw62.useCallback)((query)=>{
        const filteredStack = stack.filter((item)=>item.metricQuery !== query.metricQuery);
        setStack([
            query,
            ...filteredStack
        ]);
    }, [
        setStack,
        stack
    ]);
    return {
        stack: stack,
        appendToStack: appendToStack,
        setStack: setStack
    };
}


function $613dc6711a035719$export$5dc3a4447d4ec301() {
    const router = (0, $fp4OM.useRouter)();
    const queryString = router.search["metric-query"];
    const { appendToStack: appendToStack, stack: stack } = (0, $236cf33bdfc7dc8d$export$92ed10736eb52fbc)();
    const currentMetricQuery = (0, $acw62.useMemo)(()=>(0, $8925dee771df3f1c$export$7600411ded78bf59)(queryString), [
        queryString
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!stack[0] || queryString !== (0, $8925dee771df3f1c$export$641df5f5430d6889)(stack[0])) appendToStack(currentMetricQuery);
    }, [
        queryString,
        appendToStack,
        stack
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!queryString) router.updateSearch("metric-query", "revenues-y");
    }, [
        currentMetricQuery,
        router,
        queryString
    ]);
    const updateQuery = (0, $acw62.useCallback)((update)=>{
        const updated = {
            ...currentMetricQuery,
            ...update
        };
        const serialized = (0, $8925dee771df3f1c$export$641df5f5430d6889)(updated);
        router.updateSearch("metric-query", serialized);
    }, [
        currentMetricQuery,
        router
    ]);
    const addWindow = (0, $acw62.useCallback)((window)=>{
        updateQuery({
            window: window
        });
    }, [
        updateQuery
    ]);
    const setWindowSize = (0, $acw62.useCallback)((size)=>{
        if (!currentMetricQuery.window) return;
        updateQuery({
            window: {
                ...currentMetricQuery.window,
                size: size
            }
        });
    }, [
        currentMetricQuery.window,
        updateQuery
    ]);
    const setWindowApplyLast = (0, $acw62.useCallback)((applyLast)=>{
        if (!currentMetricQuery.window) return;
        updateQuery({
            window: {
                ...currentMetricQuery.window,
                applyLast: applyLast
            }
        });
    }, [
        currentMetricQuery.window,
        updateQuery
    ]);
    const setWindowOperation = (0, $acw62.useCallback)((operation)=>{
        if (!currentMetricQuery.window) return;
        updateQuery({
            window: {
                ...currentMetricQuery.window,
                operation: operation
            }
        });
    }, [
        currentMetricQuery.window,
        updateQuery
    ]);
    const removeWindow = (0, $acw62.useCallback)(()=>{
        updateQuery({
            window: undefined
        });
    }, [
        updateQuery
    ]);
    const setMetric = (0, $acw62.useCallback)((metric)=>{
        updateQuery({
            metric: metric
        });
    }, [
        updateQuery
    ]);
    const setPeriodResolution = (0, $acw62.useCallback)((periodResolution)=>{
        updateQuery({
            periodResolution: periodResolution
        });
    }, [
        updateQuery
    ]);
    const setWindow = (0, $acw62.useCallback)((window)=>{
        updateQuery({
            window: window
        });
    }, [
        updateQuery
    ]);
    const setCurrentMetricQuery = (0, $acw62.useCallback)((query)=>{
        const serialized = (0, $8925dee771df3f1c$export$641df5f5430d6889)(query);
        router.updateSearch("metric-query", serialized);
    }, [
        router
    ]);
    return {
        addWindow: addWindow,
        removeWindow: removeWindow,
        setMetric: setMetric,
        setPeriodResolution: setPeriodResolution,
        setWindow: setWindow,
        setWindowSize: setWindowSize,
        setWindowApplyLast: setWindowApplyLast,
        setWindowOperation: setWindowOperation,
        setCurrentMetricQuery: setCurrentMetricQuery,
        currentMetricQuery: currentMetricQuery
    };
}




var $bxdbx = parcelRequire("bxdbx");

var $acw62 = parcelRequire("acw62");

function $4ca6d6066b12a274$export$4acb05f97f6950c8(metricQuery) {
    if (!metricQuery.window) return "";
    const { size: size, applyLast: applyLast, operation: operation } = metricQuery.window;
    const operationLabel = (0, $510530300011b746$export$da0fe96ab73ea9bc)[operation].toLowerCase();
    const timing = applyLast ? "last" : "first";
    const periodLabel = metricQuery.periodResolution === "m" ? "month" : metricQuery.periodResolution === "q" ? "quarter" : "year";
    return `${size}-${periodLabel} rolling ${operationLabel}, applied ${timing}`;
}


function $0c97b01758cee583$export$bb03892c63012023(metric) {
    const parts = metric.split(".");
    const formatPart = (part)=>{
        return part.split("_").map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    };
    if (parts.length === 1) return formatPart(parts[0]);
    return parts.map(formatPart).join(" - ");
}


function $f7d4ce8b70c18ebe$export$d80176c9cd82f2bd(metricQuery) {
    const resolution = metricQuery.periodResolution === "m" ? "Monthly" : metricQuery.periodResolution === "q" ? "Quarterly" : "Annual";
    return resolution + " " + (0, $0c97b01758cee583$export$bb03892c63012023)(metricQuery.metric);
}


parcelRequire("lhALd");
var $7Y7Q4 = parcelRequire("7Y7Q4");

function $b0aae4bf566b20d7$export$c0f636ec10f87565() {
    const { currentMetricQuery: currentMetricQuery } = (0, $613dc6711a035719$export$5dc3a4447d4ec301)();
    const { data: data, isLoading: isLoading } = (0, $7Y7Q4.useApiQuery)((0, $75f146eb90ff0682$export$c1b9374d33a8c73b), {
        params: {
            metricQuery: currentMetricQuery?.metricQuery
        },
        key: [
            currentMetricQuery?.metricQuery
        ],
        enabled: !!currentMetricQuery?.metricQuery
    });
    const tablePeriods = (0, $acw62.useMemo)(()=>data?.metrics[currentMetricQuery.metricQuery]?.[0].lineaged_values.map((value)=>({
                period: value.period,
                value: value.value
            })), [
        data,
        currentMetricQuery.metricQuery
    ]);
    const parsed = (0, $acw62.useMemo)(()=>data ? (0, $816da3fb2055a0ef$export$fab482abed15876e)((0, $bxdbx.camelCased)(data)) : undefined, [
        data
    ]);
    const description = (0, $acw62.useMemo)(()=>{
        const fullDescription = data?.metrics[currentMetricQuery.metricQuery]?.[0]?.description?.description;
        if (!fullDescription) return undefined;
        const parts = fullDescription.split("\n\n");
        const out = parts.length >= 3 ? parts[1] : fullDescription;
        return out;
    }, [
        data,
        currentMetricQuery.metricQuery
    ]);
    const windowDescription = (0, $acw62.useMemo)(()=>(0, $4ca6d6066b12a274$export$4acb05f97f6950c8)(currentMetricQuery), [
        currentMetricQuery
    ]);
    const name = (0, $acw62.useMemo)(()=>(0, $f7d4ce8b70c18ebe$export$d80176c9cd82f2bd)(currentMetricQuery), [
        currentMetricQuery
    ]);
    const formula = (0, $acw62.useMemo)(()=>{
        const fullDescription = data?.metrics[currentMetricQuery.metricQuery]?.[0]?.description.description;
        if (!fullDescription) return [];
        const afterExpression = fullDescription.split("With the expression:\n")[1];
        if (!afterExpression) return [];
        const codeBlockMatch = afterExpression.match(/```text\n([\s\S]*?)```/);
        if (!codeBlockMatch) return [];
        const formulaString = codeBlockMatch[1];
        const functionMatch = formulaString.match(/(\w+)\s*\(([\s\S]*)\)/);
        if (!functionMatch) return [];
        const [, , innerContent] = functionMatch;
        return innerContent.split(",").map((operand)=>operand.trim()).filter((operand)=>operand && operand !== "");
    }, [
        data,
        currentMetricQuery.metricQuery
    ]);
    return {
        parsed: parsed,
        tablePeriods: tablePeriods,
        description: description,
        name: name,
        windowDescription: windowDescription,
        formula: formula,
        isLoading: isLoading
    };
}




parcelRequire("5R0Xk");
var $5Ttm9 = parcelRequire("5Ttm9");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

function $afadd0e9b9bf217b$export$34e2dcd4c832fa13() {
    const { name: name, description: description, windowDescription: windowDescription, parsed: parsed, formula: formula } = (0, $b0aae4bf566b20d7$export$c0f636ec10f87565)();
    const { mutate: getMetrics, isPending: isPending } = (0, $4CoXh.useApiMutation)((0, $cdd36b0a35996d12$export$c1b9374d33a8c73b), {
        onError: (error)=>{
            console.log(error);
        }
    });
    const { appendToStack: appendToStack } = (0, $236cf33bdfc7dc8d$export$92ed10736eb52fbc)();
    const { currentMetricQuery: currentMetricQuery } = (0, $613dc6711a035719$export$5dc3a4447d4ec301)();
    const noChanges = currentMetricQuery?.metricQuery === currentMetricQuery?.metricQuery && !!parsed;
    const [showFormula, setShowFormula] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                children: name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "body-m subdued pt-1",
                                children: [
                                    "(",
                                    windowDescription || "All periods",
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        disabled: noChanges || isPending,
                        className: "secondary xl",
                        onClick: ()=>{
                            if (noChanges) return;
                            appendToStack(currentMetricQuery);
                            getMetrics({
                                metricQuery: currentMetricQuery?.metricQuery
                            });
                        },
                        children: [
                            isPending && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
                                className: "size-4"
                            }),
                            isPending ? "Calculating..." : "Calculate metric"
                        ]
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: description
                    }),
                    formula && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: (0, $9QePP.default)("body-micro subdued flex cursor-pointer items-center gap-1"),
                        onClick: ()=>setShowFormula(!showFormula),
                        children: [
                            showFormula ? "Hide formula" : "Show formula",
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0682b19766de6cfd$export$2e2bcd8739ae039), {
                                className: "size-4",
                                color: "#E5E7EB"
                            })
                        ]
                    })
                ]
            }),
            showFormula && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)(" bg-[#263142] p-5", "flex flex-wrap", "gap-2 rounded"),
                children: formula?.map((line)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "py-1 font-[300]",
                        children: line + (line === formula[formula.length - 1] ? "" : " +")
                    }, line);
                })
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");




const $211a4bb4be2385bd$export$f80cd730a4e87579 = ()=>{
    const { stack: stack } = (0, $236cf33bdfc7dc8d$export$92ed10736eb52fbc)();
    const { setCurrentMetricQuery: setCurrentMetricQuery, currentMetricQuery: currentMetricQuery, removeWindow: removeWindow } = (0, $613dc6711a035719$export$5dc3a4447d4ec301)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)(" h-full", "flex flex-col", "min-h-0 overflow-hidden"),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            className: (0, $9QePP.default)("flex flex-1 flex-col", "hide-scrollbar min-h-0 gap-2 overflow-y-auto"),
            children: stack.map((metricQuery)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    className: (0, $9QePP.default)("card flex flex-col gap-2", metricQuery.metricQuery === currentMetricQuery.metricQuery && "selected"),
                    onClick: ()=>{
                        if (currentMetricQuery.window) removeWindow();
                        setCurrentMetricQuery(metricQuery);
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "subdued cursor-pointer",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex cursor-pointer flex-col gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "body-s cursor-pointer break-all pr-1",
                                    children: (0, $f7d4ce8b70c18ebe$export$d80176c9cd82f2bd)(metricQuery)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "body-m subdued cursor-pointer pt-1",
                                    children: (0, $4ca6d6066b12a274$export$4acb05f97f6950c8)(metricQuery) || "All periods"
                                })
                            ]
                        })
                    })
                }, metricQuery.metricQuery))
        })
    });
};




var $r2uF6 = parcelRequire("r2uF6");



var $ayMG0 = parcelRequire("ayMG0");

var $r2uF6 = parcelRequire("r2uF6");




var $9QePP = parcelRequire("9QePP");


function $e878ca691a23d8a3$export$ff1e6a06bde21239() {
    const [selectedPeriod, setSelectedPeriod] = (0, $r2uF6.useAtom)((0, $fa5d3143bb23a04a$export$e0d905d9710176e8));
    const setRightDrawerOpen = (0, $r2uF6.useSetAtom)((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae));
    const { parsed: parsed } = (0, $b0aae4bf566b20d7$export$c0f636ec10f87565)();
    const metric = parsed?.find((metric)=>metric.period === selectedPeriod);
    if (!selectedPeriod || !metric) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("px-6", "custom-scrollbar absolute inset-0 flex min-h-0 flex-col overflow-hidden"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "sticky my-4 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3398e3e074fa037e$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            setRightDrawerOpen(false);
                            setSelectedPeriod(null);
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "pageheading ",
                                children: selectedPeriod.split(/<\d+>/).map((date)=>date.split("-").reverse().join("/")).join(" - ")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "body-s subdued mb-4",
                                children: "Select a value to see the files that went into this calculation."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "custom-scrollbar hide-scrollbar overflow-y-scroll",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8ddf7c96ebce2a1$export$ea5f24ed7caf9655), {
                    metric: metric
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $gxPgh = parcelRequire("gxPgh");

var $acw62 = parcelRequire("acw62");



var $r2uF6 = parcelRequire("r2uF6");




var $Bq2gZ = parcelRequire("Bq2gZ");

var $cjWtv = parcelRequire("cjWtv");

var $9QePP = parcelRequire("9QePP");
function $d74d6c6cb716aa5f$export$2496d758aa88df47() {
    const { tablePeriods: tablePeriods } = (0, $b0aae4bf566b20d7$export$c0f636ec10f87565)();
    const { currentMetricQuery: currentMetricQuery } = (0, $613dc6711a035719$export$5dc3a4447d4ec301)();
    const gridRef = (0, $acw62.useRef)(null);
    const setSelectedPeriod = (0, $r2uF6.useSetAtom)((0, $fa5d3143bb23a04a$export$e0d905d9710176e8));
    const setRightDrawerOpen = (0, $r2uF6.useSetAtom)((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae));
    if (!tablePeriods) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("flex min-h-0 w-full flex-1 flex-col gap-5 pt-4"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex h-[92px] flex-col gap-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gxPgh.AgGridReact), {
                    ref: gridRef,
                    theme: (0, $0356cd652e233c9b$export$e023de5353971026),
                    rowData: [
                        {}
                    ],
                    columnDefs: tablePeriods.map(({ period: period, value: value })=>{
                        const formattedPeriod = period.split(/<\d+>/).map((date)=>date.split("-").reverse().join("/")).join(" - ");
                        return {
                            field: period,
                            headerName: formattedPeriod,
                            valueGetter: ()=>{
                                return value;
                            },
                            valueFormatter: ()=>{
                                return value ? new Intl.NumberFormat("en-US", {
                                    style: "currency",
                                    currency: "USD"
                                }).format(value) : "";
                            },
                            resizable: true,
                            sortable: false,
                            minWidth: Math.max(100, formattedPeriod.length * 10),
                            suppressHeaderMenuButton: true
                        };
                    }) || [],
                    onCellClicked: (params)=>{
                        console.log(params);
                        setRightDrawerOpen(true);
                        setSelectedPeriod(params.colDef.field);
                    },
                    defaultColDef: {
                        flex: 1
                    },
                    rowSelection: {
                        mode: "multiRow",
                        checkboxes: false,
                        headerCheckbox: false,
                        enableClickSelection: true
                    },
                    domLayout: "autoHeight"
                }, currentMetricQuery.metricQuery)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "min-h-0 flex-1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "size-full [&>div>div]:!pb-8 [&>div]:!h-full",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Bq2gZ.Chart), {
                        title: "",
                        description: "",
                        isCondensed: false,
                        options: {
                            data: tablePeriods.map(({ period: period, value: value })=>({
                                    period: period.split(/<\d+>/).map((date)=>date.split("-").reverse().join("/")).join(" - "),
                                    realPeriod: period,
                                    value: value
                                })),
                            series: [
                                {
                                    type: "bar",
                                    xKey: "period",
                                    yKey: "value",
                                    yName: "EBITDA"
                                }
                            ],
                            axes: [
                                (0, $cjWtv.Axis).Category({
                                    position: "bottom",
                                    label: {
                                        rotation: tablePeriods[0]?.period.length > 8 || tablePeriods.length > 12 ? 60 : 0,
                                        avoidCollisions: true
                                    }
                                }),
                                (0, $cjWtv.Axis).Money({
                                    keys: [
                                        "value"
                                    ]
                                })
                            ],
                            listeners: {
                                seriesNodeClick: ({ datum: datum, yKey: yKey, seriesId: seriesId })=>{
                                    console.log(datum, yKey, seriesId);
                                    setSelectedPeriod(datum.realPeriod);
                                    setRightDrawerOpen(true);
                                }
                            }
                        }
                    })
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("8OvTp");
var $bZayu = parcelRequire("bZayu");

var $eQbhf = parcelRequire("eQbhf");


var $9QePP = parcelRequire("9QePP");

var $ggKhH = parcelRequire("ggKhH");
var $cVodR = parcelRequire("cVodR");

function $bc4842c89308b02a$export$c2b2c3224f32fa8() {
    const { currentMetricQuery: currentMetricQuery, setMetric: setMetric, setPeriodResolution: setPeriodResolution, removeWindow: removeWindow, addWindow: addWindow, setWindowSize: setWindowSize, setWindowApplyLast: setWindowApplyLast, setWindowOperation: setWindowOperation } = (0, $613dc6711a035719$export$5dc3a4447d4ec301)();
    const { metric: metric, periodResolution: periodResolution, window: window } = currentMetricQuery;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "px-3",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, $9QePP.default)("mt-4 w-full", "flex flex-col", "gap-2"),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bZayu.DropdownMenu), {
                            className: "body-s text-default",
                            items: Object.values([
                                "m",
                                "q",
                                "y"
                            ]).map((label)=>({
                                    type: "item",
                                    id: label,
                                    label: label === "m" ? "Monthly" : label === "q" ? "Quarterly" : "Yearly",
                                    onClick: ()=>setPeriodResolution(label)
                                })),
                            selectedOptionId: periodResolution
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bZayu.DropdownMenu), {
                            className: "body-s text-default",
                            items: Object.values((0, $eQbhf.AccountLabel)).map((label)=>({
                                    type: "item",
                                    id: label,
                                    label: (0, $0c97b01758cee583$export$bb03892c63012023)(label),
                                    onClick: ()=>setMetric(label)
                                })),
                            selectedOptionId: metric
                        })
                    ]
                }),
                !window && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "quiet body-s p-0",
                        onClick: ()=>addWindow({
                                size: 12,
                                applyLast: false,
                                operation: (0, $510530300011b746$export$56bac1c8ab171501).AVERAGE
                            }),
                        children: [
                            "Add window",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ggKhH.default), {
                                className: "size-4"
                            })
                        ]
                    })
                }),
                window && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: (0, $9QePP.default)("mb-3 mt-2 w-full", "flex flex-col", "gap-2"),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "body-s text-default",
                                    children: "Window settings"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVodR.default), {
                                    className: "size-4 cursor-pointer stroke-red-400",
                                    onClick: ()=>removeWindow()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: (0, $9QePP.default)("px-2", "flex items-center justify-between gap-2"),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bZayu.DropdownMenu), {
                                    className: "body-micro text-default",
                                    items: Object.values((0, $510530300011b746$export$56bac1c8ab171501)).map((label)=>({
                                            type: "item",
                                            id: label,
                                            label: (0, $510530300011b746$export$da0fe96ab73ea9bc)[label],
                                            onClick: ()=>setWindowOperation(label)
                                        })),
                                    selectedOptionId: window.operation.toString()
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bZayu.DropdownMenu), {
                                    className: "body-micro text-default",
                                    items: Object.values([
                                        true,
                                        false
                                    ]).map((label)=>({
                                            type: "item",
                                            id: label.toString(),
                                            label: label ? "Apply window first" : "Apply window last",
                                            onClick: ()=>setWindowApplyLast(!label)
                                        })),
                                    selectedOptionId: (!window.applyLast).toString()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-2 px-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "body-micro text-default",
                                    children: "Window Size"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "number",
                                    value: window.size?.toString() || "",
                                    min: 1,
                                    max: 255,
                                    onChange: (e)=>setWindowSize(Number(e.target.value)),
                                    className: (0, $9QePP.default)("bg-secondary body-s w-[60px] rounded border-none p-1 px-2 outline-none", "placeholder:text-slate-500", "focus:ring-transparent focus:placeholder:text-transparent", (window.size === null || window.size < 1 || window.size > 255) && "ml-px ring-1 ring-red-600")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


function $eeba3b2fb47c65a5$export$2e2bcd8739ae039() {
    const [showCompanyList] = (0, $r2uF6.useAtom)((0, $9b7b211c4c2184d7$export$2627579a5e93fc70));
    const [rightDrawerOpen, setRightDrawerOpen] = (0, $r2uF6.useAtom)((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae));
    const [selectedPeriod, setSelectedPeriod] = (0, $r2uF6.useAtom)((0, $fa5d3143bb23a04a$export$e0d905d9710176e8));
    (0, $acw62.useEffect)(()=>{
        if (rightDrawerOpen && !selectedPeriod) setRightDrawerOpen(false);
    }, [
        rightDrawerOpen,
        selectedPeriod,
        setRightDrawerOpen
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    !showCompanyList && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6d137961520e2401$export$26c4ec9456bef7c4), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bc4842c89308b02a$export$c2b2c3224f32fa8), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $211a4bb4be2385bd$export$f80cd730a4e87579), {})
                        ]
                    }),
                    selectedPeriod && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fff2b4a85aca8f0e$export$40e2914dc29c2bf9), {
                        onClose: ()=>setSelectedPeriod(null),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e878ca691a23d8a3$export$ff1e6a06bde21239), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                className: "flex size-full",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: (0, $9QePP.default)("size-full px-6", "flex flex-col", "gap-3"),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $afadd0e9b9bf217b$export$34e2dcd4c832fa13), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d74d6c6cb716aa5f$export$2496d758aa88df47), {})
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");



var $r2uF6 = parcelRequire("r2uF6");

var $9QePP = parcelRequire("9QePP");


var $ayMG0 = parcelRequire("ayMG0");

var $9QePP = parcelRequire("9QePP");
parcelRequire("lhALd");
var $7Y7Q4 = parcelRequire("7Y7Q4");

var $aphAM = parcelRequire("aphAM");
parcelRequire("agk6G");
var $kTlwO = parcelRequire("kTlwO");
var $eRTY4 = parcelRequire("eRTY4");

var $r2uF6 = parcelRequire("r2uF6");
parcelRequire("agk6G");
var $eRTY4 = parcelRequire("eRTY4");
const $91307512a6bbc832$export$4b878da9eabdb39d = (0, $r2uF6.atom)((0, $eRTY4.PlatformType).ACCOUTING);



var $r2uF6 = parcelRequire("r2uF6");
parcelRequire("agk6G");
var $eRTY4 = parcelRequire("eRTY4");
const $228858c6ab1d36be$export$6f50946f33353213 = {
    [(0, $eRTY4.PlatformType).BANK]: "Bank",
    [(0, $eRTY4.PlatformType).ACCOUTING]: "Accounting",
    [(0, $eRTY4.PlatformType).PAYMENTS]: "Payments"
};


const $fd0565ff2283b09d$export$48969933f6366fef = ()=>{
    const { companyId: companyId } = (0, $aphAM.useParams)();
    const { data: connectors, isLoading: isLoading } = (0, $7Y7Q4.useApiQuery)((0, $kTlwO.getCompanyConnectors), {
        params: {
            uuid: companyId
        }
    });
    const [selectedPlatformType, setSelectedPlatformType] = (0, $r2uF6.useAtom)((0, $91307512a6bbc832$export$4b878da9eabdb39d));
    const selectedConnectorId = "1";
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: [
            ...Array(10)
        ].map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $9QePP.default)("bg-selected h-20 w-full animate-pulse self-center rounded")
            }, i))
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("mt-4 h-full", "flex flex-col", "min-h-0 overflow-hidden"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-4 flex justify-between",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                    className: (0, $9QePP.default)("w-full p-1", "lozenge flex justify-between gap-2"),
                    children: Object.values((0, $eRTY4.PlatformType)).sort().map((platformType)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: (0, $9QePP.default)("cursor-pointer rounded p-2 px-2.5", "hover:bg-hover", selectedPlatformType === platformType && "bg-selected"),
                            onClick: ()=>{
                                setSelectedPlatformType(platformType);
                            },
                            children: (0, $228858c6ab1d36be$export$6f50946f33353213)[platformType]
                        }, platformType))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                className: (0, $9QePP.default)("flex flex-1 flex-col", "hide-scrollbar min-h-0 gap-2 overflow-y-auto"),
                children: connectors?.filter((connector)=>!!connector.config && connector.config.platformType === selectedPlatformType).map((connector)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        className: (0, $9QePP.default)("card flex flex-col gap-2", selectedConnectorId === connector.config?.uuid && "selected"),
                        onClick: ()=>{
                        // router.navigate(
                        //     `/beta/companies/${router.params.companyId}/labeling/files/${file.id}`,
                        // );
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "subdued",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex cursor-pointer flex-col gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "body-s cursor-pointer break-all pr-1",
                                        children: connector.connectorType
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: connector.config?.uuid
                                    })
                                ]
                            })
                        })
                    }, connector.config?.uuid))
            })
        ]
    });
};



var $fRJCp = parcelRequire("fRJCp");


var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");



var $9QePP = parcelRequire("9QePP");




function $13276900450e6fc9$export$98b962aab51a7185() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)("px-6", "absolute inset-0 flex min-h-0 flex-col overflow-hidden"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "sticky my-6 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3398e3e074fa037e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "pageheading break-all",
                        children: "raw_20251028154810_xero_balance_sheet_json.avro"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: (0, $9QePP.default)("w-fit", "link quiet flex items-center gap-1"),
                        onClick: ()=>{},
                        children: [
                            "Download ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10e4c9ac84efc26e$export$2e2bcd8739ae039), {
                                className: "size-4"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "custom-scrollbar hide-scrollbar overflow-y-scroll pb-6",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8a5960c8a556fbd$export$57ede23f90ec25e2), {
                    nodes: (0, $d8a5960c8a556fbd$export$695720b7e7a61533)
                })
            })
        ]
    });
}


function $3556c899e12823e3$export$2e2bcd8739ae039() {
    const [showCompanyList] = (0, $r2uF6.useAtom)((0, $9b7b211c4c2184d7$export$2627579a5e93fc70));
    const selectedConnectorId = "1";
    const setRightDrawerOpen = (0, $r2uF6.useSetAtom)((0, $30c17e6838b1ddb3$export$7f94ead4211bc7ae));
    (0, $acw62.useEffect)(()=>{
        setRightDrawerOpen(true);
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    !showCompanyList && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d137961520e2401$export$26c4ec9456bef7c4), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fd0565ff2283b09d$export$48969933f6366fef), {})
                    }),
                    selectedConnectorId && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fff2b4a85aca8f0e$export$40e2914dc29c2bf9), {
                        onClose: ()=>{},
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13276900450e6fc9$export$98b962aab51a7185), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fRJCp.motion).div, {
                className: "flex size-full",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: (0, $9QePP.default)("size-full px-6", "flex flex-col", "gap-3")
                })
            })
        ]
    });
}


// import CompanyProfilePage from "./sections/deals/CompanyProfile/CompanyProfilePage";
// import DealDetailPage from "./sections/deals/DealDetail/DealDetailPage";
// import { CreditBoxesPage } from "./sections/creditBoxes/CreditBoxesPage";
const $72eb9a37a421b392$var$EmptyPage = ({ text: text = "This page" })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: `${text} is not yet available in beta`
    });
function $72eb9a37a421b392$var$AdminBetaApp() {
    const flags = (0, $7gcOJ.useFlags)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7JXNE.NavigationProvider), {
        showLogout: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Routes), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Route), {
                    path: `/beta`,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $80c92d026b832583$export$5d146e06dd3b3225), {}),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                            path: "/beta",
                            index: true,
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                                to: "/beta/companies"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Route), {
                            path: `/beta/companies`,
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b7b211c4c2184d7$export$fcc5ff4e66800788), {}),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: "/beta/companies",
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)($72eb9a37a421b392$var$EmptyPage, {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: "/beta/companies/:companyId",
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)($72eb9a37a421b392$var$EmptyPage, {
                                        text: "Company Overview"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: "/beta/companies/:companyId/investment-memo",
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1307b7c533badf54$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: `/beta/companies/:companyId/opportunities`,
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $448b5d6ea569459c$export$63a20aa6918bbd3e), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: `/beta/companies/:companyId/opportunities/:opportunityId`,
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $448b5d6ea569459c$export$63a20aa6918bbd3e), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: `/beta/companies/:companyId/labeling`,
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0edf059f8c58615$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: `/beta/companies/:companyId/labeling/files/:fileId`,
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0edf059f8c58615$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: `/beta/companies/:companyId/labeling/files/:fileId/drafts/:draftId`,
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0edf059f8c58615$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: `/beta/companies/:companyId/uploads`,
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d01434f5f4f741a$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: `/beta/companies/:companyId/metrics`,
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eeba3b2fb47c65a5$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: `/beta/companies/:companyId/connectors`,
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3556c899e12823e3$export$2e2bcd8739ae039), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Route), {
                            path: `/beta/deals`,
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb1652d8df8d60e6$export$8f4d5fd934d52710), {}),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: "/beta/deals",
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)($72eb9a37a421b392$var$EmptyPage, {
                                        text: "Deals"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: "/beta/deals/:dealId",
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)($72eb9a37a421b392$var$EmptyPage, {
                                        text: "Deal Detail"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                    path: "/beta/deals/:dealId/company-profile",
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)($72eb9a37a421b392$var$EmptyPage, {
                                        text: "Company Profile"
                                    })
                                })
                            ]
                        }),
                        flags.enabled("enable-credit-boxes") && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                            path: "/beta/credit-boxes",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)($72eb9a37a421b392$var$EmptyPage, {
                                text: "Credit Boxes"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/beta/*",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4oMrS.NotFoundPage), {})
                })
            ]
        })
    });
}
var $72eb9a37a421b392$export$2e2bcd8739ae039 = $72eb9a37a421b392$var$AdminBetaApp;





const $af16c0f287ecb989$var$AdminApp = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("5dpz5")));

const $af16c0f287ecb989$var$CompanyApp = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("6nQVO")));

const $af16c0f287ecb989$var$FundApp = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("hmQAE")));

const $af16c0f287ecb989$var$CreditAnalystDemo = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("g3x7b")));

const $af16c0f287ecb989$var$CompanyDemo = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("02Jdy")));

const $af16c0f287ecb989$var$PortfolioInvestorDemo = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("kkjLa")));
const $af16c0f287ecb989$export$bbaba1d428ab2e6e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function({ user: user, flags: flags }) {
    const router = (0, $fp4OM.useRouter)();
    const returnTo = localStorage.getItem("returnTo");
    (0, $acw62.useEffect)(()=>{
        if (user && returnTo) {
            localStorage.removeItem("returnTo");
            if (returnTo.startsWith("/v1")) window.location.assign(returnTo.replace("/v1", "https://icm.humcapital.com/legacy"));
            else router.navigate(returnTo);
        }
    }, [
        router.navigate,
        returnTo,
        user
    ]);
    const isAdmin = (0, $acw62.useMemo)(()=>user?.isAdmin, [
        user?.isAdmin
    ]);
    const isCompany = (0, $acw62.useMemo)(()=>user?.isCompany, [
        user?.isCompany
    ]);
    const isFund = (0, $acw62.useMemo)(()=>user?.isFund, [
        user?.isFund
    ]);
    const isCreditAnalystDemo = flags.enabled("demo:credit-analyst");
    const isCompanyDemo = flags.enabled("demo:company");
    const isPortfolioInvestorDemo = flags.enabled("demo:portfolio-investor");
    const isInvestmentMemoDemo = flags.enabled("demo:investment-memo");
    const isDemo = isCreditAnalystDemo || isCompanyDemo || isPortfolioInvestorDemo || isInvestmentMemoDemo;
    if (isDemo) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Suspense), {
        fallback: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
            fullScreen: true,
            testId: "fallback-spinner"
        }),
        children: [
            isCreditAnalystDemo && /*#__PURE__*/ (0, $ayMG0.jsx)($af16c0f287ecb989$var$CreditAnalystDemo, {}),
            isCompanyDemo && /*#__PURE__*/ (0, $ayMG0.jsx)($af16c0f287ecb989$var$CompanyDemo, {}),
            isPortfolioInvestorDemo && /*#__PURE__*/ (0, $ayMG0.jsx)($af16c0f287ecb989$var$PortfolioInvestorDemo, {}),
            isInvestmentMemoDemo && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2xY7I.default), {})
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Suspense), {
        fallback: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
            fullScreen: true,
            testId: "fallback-spinner"
        }),
        children: [
            isAdmin && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $72eb9a37a421b392$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($af16c0f287ecb989$var$AdminApp, {})
                ]
            }),
            isCompany && /*#__PURE__*/ (0, $ayMG0.jsx)($af16c0f287ecb989$var$CompanyApp, {}),
            isFund && /*#__PURE__*/ (0, $ayMG0.jsx)($af16c0f287ecb989$var$FundApp, {})
        ]
    });
}, (prev, next)=>{
    return prev.user?.isAdmin === next.user?.isAdmin && prev.user?.isCompany === next.user?.isCompany && prev.user?.isFund === next.user?.isFund && prev.flags.enabled("demo:credit-analyst") === next.flags.enabled("demo:credit-analyst") && prev.flags.enabled("demo:company") === next.flags.enabled("demo:company") && prev.flags.enabled("demo:portfolio-investor") === next.flags.enabled("demo:portfolio-investor") && prev.flags.enabled("demo:investment-memo") === next.flags.enabled("demo:investment-memo") && prev.flags.enabled("admin-beta") === next.flags.enabled("admin-beta");
});



var $jsVqW = parcelRequire("jsVqW");
parcelRequire("hb9Mc");
var $1jzUO = parcelRequire("1jzUO");

var $acw62 = parcelRequire("acw62");

var $cMZ0q = parcelRequire("cMZ0q");
parcelRequire("tL0U5");
var $4CoXh = parcelRequire("4CoXh");
parcelRequire("agk6G");
var $hovjT = parcelRequire("hovjT");
function $5e409635bd55b90a$export$8a2bf06fbae4dde() {
    const router = (0, $fp4OM.useRouter)();
    const flagsmith = (0, $jsVqW.useFlagsmith)();
    const flags = (0, $7gcOJ.useFlags)();
    const session = (0, $edg5W.useSession)();
    const { mutate: acceptAgreements } = (0, $4CoXh.useApiMutation)((0, $hovjT.acceptCompanyAgreements));
    const { company: company } = (0, $cMZ0q.useCompany)();
    const companyAcceptedAgreements = company?.acceptedTos || company?.acceptedPrivacyPolicy;
    (0, $acw62.useEffect)(()=>{
        if (flags.ready) (0, $1jzUO.trackUserIdentity)(company, session.user, flagsmith);
    }, [
        session.user,
        flagsmith,
        flags
    ]);
    (0, $acw62.useEffect)(()=>{
        if (company?.uuid && !companyAcceptedAgreements) acceptAgreements({
            organizationId: company?.uuid
        });
    }, [
        company?.uuid,
        companyAcceptedAgreements
    ]);
    if (flags.error) console.error("Flagsmith failed to load");
    if (!flags.ready && !flags.error || session.isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
        fullScreen: true,
        testId: "session-spinner"
    });
    if (session.isHumError) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: "/error?type=auth"
    });
    if (!session.user || !session.isAuthenticated || session.isError) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: `/login?returnTo=${router.search.returnTo || router.asPath}`
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af16c0f287ecb989$export$bbaba1d428ab2e6e), {
        user: session.user,
        flags: flags
    });
}



var $cNbKI = parcelRequire("cNbKI");
var $91137b2f1e15c24d$exports = {};
!function(t, e) {
    e($91137b2f1e15c24d$exports);
}($91137b2f1e15c24d$exports, function(t) {
    "use strict";
    var e = {
        getItemSync: function(t) {
            try {
                return localStorage.getItem(t) || null;
            } catch (t) {
                return null;
            }
        },
        getItem: function(t, e) {
            var n = this;
            return new Promise(function(i, a) {
                try {
                    var r = n.getItemSync(t);
                    null == e || e(null, r), i(r);
                } catch (t) {
                    e && e(t, null), a(t);
                }
            });
        },
        setItem: function(t, e, n) {
            return new Promise(function(i, a) {
                try {
                    localStorage.setItem(t, e), n && n(null, e), i(e);
                } catch (t) {
                    n && n(t, null), a(t);
                }
            });
        }
    }, n = function() {
        return n = Object.assign || function(t) {
            for(var e, n = 1, i = arguments.length; n < i; n++)for(var a in e = arguments[n])Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
            return t;
        }, n.apply(this, arguments);
    };
    function i(t, e, n) {
        if (n || 2 === arguments.length) for(var i, a = 0, r = e.length; a < r; a++)!i && a in e || (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
        return t.concat(i || Array.prototype.slice.call(e));
    }
    var a, r, o = function t(e, n) {
        if (e === n) return !0;
        if (e && n && "object" == typeof e && "object" == typeof n) {
            if (e.constructor !== n.constructor) return !1;
            var i, a, r;
            if (Array.isArray(e)) {
                if ((i = e.length) != n.length) return !1;
                for(a = i; 0 != a--;)if (!t(e[a], n[a])) return !1;
                return !0;
            }
            if (e.constructor === RegExp) return e.source === n.source && e.flags === n.flags;
            if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === n.valueOf();
            if (e.toString !== Object.prototype.toString) return e.toString() === n.toString();
            if ((i = (r = Object.keys(e)).length) !== Object.keys(n).length) return !1;
            for(a = i; 0 != a--;)if (!Object.prototype.hasOwnProperty.call(n, r[a])) return !1;
            for(a = i; 0 != a--;){
                var o = r[a];
                if (!t(e[o], n[o])) return !1;
            }
            return !0;
        }
        return e != e && n != n;
    };
    !function(t) {
        t.NONE = "NONE", t.DEFAULT_FLAGS = "DEFAULT_FLAGS", t.CACHE = "CACHE", t.SERVER = "SERVER";
    }(a || (a = {}));
    var s, l = null, u = "BULLET_TRAIN_DB", c = "BULLET_TRAIN_EVENT", g = "https://edge.api.flagsmith.com/api/v1/", h = function(t) {
        return "Attempted to " + t + " a user before calling flagsmith.init. Call flagsmith.init first, if you wish to prevent it sending a request for flags, call init with preventFetch:true.";
    }, d = "flagsmith_value_", f = "flagsmith_enabled_", v = "flagsmith_trait_", p = function() {
        function t(t) {
            var e = this;
            this._trigger = null, this._triggerLoadingState = null, this.timestamp = null, this.isLoading = !1, this.eventSource = null, this.getJSON = function(t, n, i) {
                var a = e, o = a.environmentID, s = a.headers, l = {
                    method: n || "GET",
                    body: i,
                    cache: "no-cache",
                    headers: {
                        "x-environment-key": "".concat(o)
                    }
                };
                n && "GET" !== n && (l.headers["Content-Type"] = "application/json; charset=utf-8"), s && Object.assign(l.headers, s), r || console.error("Flagsmith: fetch is undefined, please specify a fetch implementation into flagsmith.init to support SSR.");
                var u = "".concat(e.identity);
                return r(t, l).then(function(i) {
                    var a, r = "".concat(e.identity);
                    if (u === r) {
                        var o = null === (a = i.headers) || void 0 === a ? void 0 : a.get("x-flagsmith-document-updated-at");
                        if (o) try {
                            var s = parseFloat(o);
                            if (isNaN(s)) throw "Failed to parse x-flagsmith-document-updated-at";
                            e.timestamp = s;
                        } catch (t) {
                            e.log(t, "Failed to parse x-flagsmith-document-updated-at", o);
                        }
                        return e.log("Fetch response: " + i.status + " " + (n || "GET") + 0 + t), i.text().then(function(t) {
                            var e = t;
                            try {
                                e = JSON.parse(t);
                            } catch (t) {}
                            return i.status && i.status >= 200 && i.status < 300 ? e : Promise.reject(e);
                        });
                    }
                    e.log("Received response with identity miss-match, ignoring response. Requested: ".concat(u, ", Current: ").concat(r));
                }).catch(function(t) {
                    throw console.error("Flagsmith: Fetch error: " + t), new Error("Flagsmith: Fetch error:" + t);
                });
            }, this._onChange = function(t, n, i) {
                e.setLoadingState(i), e.onChange && e.onChange(t, n, e.loadingState), e._trigger && (e.log("trigger called"), e._trigger());
            }, this.getFlags = function(t, i) {
                var r = e;
                r.onChange;
                var s = r.onError, l = r.identity, u = r.api, c = !1;
                e.log("Get Flags"), e.isLoading = !0, e.loadingState.isFetching || e.setLoadingState(n(n({}, e.loadingState), {
                    isFetching: !0
                }));
                var g = function(t) {
                    var i = t.flags, r = t.traits;
                    e.isLoading = !1, l && (e.withTraits = null);
                    var s = {}, u = {};
                    r = r || [], (i = i || []).forEach(function(t) {
                        s[t.feature.name.toLowerCase().replace(/ /g, "_")] = {
                            id: t.feature.id,
                            enabled: t.enabled,
                            value: t.feature_state_value
                        };
                    }), r.forEach(function(t) {
                        u[t.trait_key.toLowerCase().replace(/ /g, "_")] = t.trait_value;
                    }), e.oldFlags = n({}, e.flags);
                    var c = o(e.flags, s), g = o(e.traits, u);
                    if (e.flags = s, e.traits = u, e.updateStorage(), e.datadogRum) try {
                        if (e.datadogRum.trackTraits) {
                            var h = {};
                            Object.keys(e.traits).map(function(t) {
                                h[v + t] = e.getTrait(t);
                            });
                            var p = n(n(n({}, e.datadogRum.client.getUser()), {
                                id: e.datadogRum.client.getUser().id || e.identity
                            }), h);
                            e.log("Setting Datadog user", p), e.datadogRum.client.setUser(p);
                        }
                    } catch (t) {
                        console.error(t);
                    }
                    if (e.dtrum) try {
                        var y = {
                            javaDouble: {},
                            date: {},
                            shortString: {},
                            javaLongOrObject: {}
                        };
                        Object.keys(e.flags).map(function(t) {
                            S(y, d + t, e.getValue(t, {}, !0)), S(y, f + t, e.hasFeature(t, !0));
                        }), Object.keys(e.traits).map(function(t) {
                            S(y, v + t, e.getTrait(t));
                        }), e.log("Sending javaLongOrObject traits to dynatrace", y.javaLongOrObject), e.log("Sending date traits to dynatrace", y.date), e.log("Sending shortString traits to dynatrace", y.shortString), e.log("Sending javaDouble to dynatrace", y.javaDouble), e.dtrum.sendSessionProperties(y.javaLongOrObject, y.date, y.shortString, y.javaDouble);
                    } catch (t) {
                        console.error(t);
                    }
                    e._onChange(e.oldFlags, {
                        isFromServer: !0,
                        flagsChanged: !c,
                        traitsChanged: !g
                    }, e._loadedState(null, a.SERVER));
                };
                return l ? Promise.all([
                    e.withTraits ? e.getJSON(u + "identities/", "POST", JSON.stringify({
                        identifier: l,
                        traits: Object.keys(e.withTraits).map(function(t) {
                            return {
                                trait_key: t,
                                trait_value: e.withTraits[t]
                            };
                        }).filter(function(t) {
                            return void 0 !== t.trait_value || (e.log("Warning - attempted to set an undefined trait value for key", t.trait_key), !1);
                        })
                    })) : e.getJSON(u + "identities/?identifier=" + encodeURIComponent(l))
                ]).then(function(n) {
                    e.withTraits = null, g(n[0]), t && !c && (c = !0, t());
                }).catch(function(t) {
                    var e = t.message;
                    s && s(new Error(e));
                }) : Promise.all([
                    e.getJSON(u + "flags/")
                ]).then(function(e) {
                    g({
                        flags: e[0],
                        traits: void 0
                    }), t && !c && (c = !0, t());
                }).catch(function(t) {
                    i && !c && (c = !0, i(t)), s && s(t);
                });
            }, this.analyticsFlags = function() {
                var t = e.api;
                if (e.evaluationEvent && e.evaluationEvent[e.environmentID]) return e.evaluationEvent && 0 !== Object.getOwnPropertyNames(e.evaluationEvent).length && 0 !== Object.getOwnPropertyNames(e.evaluationEvent[e.environmentID]).length ? e.getJSON(t + "analytics/flags/", "POST", JSON.stringify(e.evaluationEvent[e.environmentID])).then(function(t) {
                    var i = e.getState();
                    e.evaluationEvent || (e.evaluationEvent = {}), e.evaluationEvent[e.environmentID] = {}, e.setState(n(n({}, i), {
                        evaluationEvent: e.evaluationEvent
                    })), e.updateEventStorage();
                }).catch(function(t) {
                    e.log("Exception fetching evaluationEvent", t);
                }) : void 0;
            }, this.datadogRum = null, this.loadingState = {
                isLoading: !0,
                isFetching: !0,
                error: null,
                source: a.NONE
            }, this.canUseStorage = !1, this.analyticsInterval = null, this.api = null, this.cacheFlags = !1, this.ts = null, this.enableAnalytics = !1, this.enableLogs = !1, this.environmentID = "", this.evaluationEvent = null, this.flags = null, this.getFlagInterval = null, this.headers = null, this.initialised = !1, this.oldFlags = null, this.onChange = null, this.onError = null, this.identity = null, this.ticks = null, this.timer = null, this.traits = null, this.dtrum = null, this.withTraits = null, this.cacheOptions = {
                ttl: 0,
                skipAPI: !1
            }, this.evaluateFlag = function(t, n) {
                if (e.datadogRum && (e.datadogRum.client.addFeatureFlagEvaluation ? "VALUE" === n ? e.datadogRum.client.addFeatureFlagEvaluation(d + t, e.getValue(t, {}, !0)) : e.datadogRum.client.addFeatureFlagEvaluation(f + t, e.hasFeature(t, !0)) : console.error("Flagsmith: Your datadog RUM client does not support the function addFeatureFlagEvaluation, please update it.")), e.enableAnalytics) {
                    if (!e.evaluationEvent) return;
                    e.evaluationEvent[e.environmentID] || (e.evaluationEvent[e.environmentID] = {}), void 0 === e.evaluationEvent[e.environmentID][t] && (e.evaluationEvent[e.environmentID][t] = 0), e.evaluationEvent[e.environmentID][t] += 1;
                }
                e.updateEventStorage();
            }, this.getValue = function(t, n, i) {
                var a = e.flags && e.flags[t.toLowerCase().replace(/ /g, "_")], r = null;
                if (a && (r = a.value), i || e.evaluateFlag(t, "VALUE"), null === r && void 0 !== (null == n ? void 0 : n.fallback)) return n.fallback;
                if (null == n ? void 0 : n.json) try {
                    return null === r ? (e.log("Tried to parse null flag as JSON: " + t), null) : JSON.parse(r);
                } catch (t) {
                    return n.fallback;
                }
                return r;
            }, this.getTrait = function(t) {
                return e.traits && e.traits[t.toLowerCase().replace(/ /g, "_")];
            }, this.getAllTraits = function() {
                return e.traits;
            }, this.setTrait = function(t, n) {
                if (e.api) {
                    var i = {};
                    return i[t] = n, e.setTraits(i);
                }
                console.error(h("setTrait"));
            }, this.setTraits = function(t) {
                if (e.api) {
                    if (t && "object" == typeof t || console.error("Expected object for flagsmith.setTraits"), e.withTraits = n(n({}, e.withTraits || {}), t), e.identity) return e.initialised ? e.getFlags() : void 0;
                    e.log("Set traits prior to identifying", e.withTraits);
                } else console.error(h("setTraits"));
            }, this.hasFeature = function(t, n) {
                var i = e.flags && e.flags[t.toLowerCase().replace(/ /g, "_")], a = !1;
                return i && i.enabled && (a = !0), n || e.evaluateFlag(t, "ENABLED"), a;
            }, r = t.fetch ? t.fetch : "undefined" != typeof fetch ? fetch : null === $parcel$global || void 0 === $parcel$global ? void 0 : $parcel$global.fetch, this.canUseStorage = "undefined" != typeof window || !!t.browserlessStorage, this.log("Constructing flagsmith instance " + t), t.eventSource && (s = t.eventSource), t.AsyncStorage && (l = t.AsyncStorage);
        }
        return t.prototype.init = function(t) {
            var e = this, i = t.environmentID, o = t.api, h = void 0 === o ? g : o, d = t.headers, f = t.onChange, v = t.cacheFlags, p = t.datadogRum, y = t.onError, m = t.defaultFlags, S = t.fetch, _ = t.preventFetch, E = t.enableLogs, b = t.enableDynatrace, F = t.enableAnalytics, O = t.realtime, I = t.eventSourceUrl, w = void 0 === I ? "https://realtime.flagsmith.com/" : I, C = t.AsyncStorage, L = t.identity, T = t.traits, A = t.state, j = t.cacheOptions, D = t.angularHttpClient, k = t._trigger, P = t._triggerLoadingState;
            return new Promise(function(t, o) {
                var g, I;
                e.environmentID = i, e.api = h, e.headers = d, e.getFlagInterval = null, e.analyticsInterval = null, e.onChange = f;
                var N = "Wrong Flagsmith Configuration: preventFetch is true and no defaulFlags provided";
                if (e._trigger = k || e._trigger, e._triggerLoadingState = P || e._triggerLoadingState, e.onError = function(t) {
                    e.setLoadingState(n(n({}, e.loadingState), {
                        isFetching: !1,
                        isLoading: !1,
                        error: t
                    })), y && (t instanceof Error ? y(t) : y(new Error(t)));
                }, e.identity = L, e.withTraits = T, e.enableLogs = E || !1, e.cacheOptions = j ? {
                    skipAPI: !!j.skipAPI,
                    ttl: j.ttl || 0
                } : e.cacheOptions, !e.cacheOptions.ttl && e.cacheOptions.skipAPI && console.warn("Flagsmith: you have set a cache ttl of 0 and are skipping API calls, this means the API will not be hit unless you clear local storage."), S && (r = S), e.enableAnalytics = F || !1, e.flags = Object.assign({}, m) || {}, e.traits = Object.assign({}, T) || {}, e.initialised = !0, e.ticks = 1e4, Object.keys(e.flags).length && (e.loadingState = n(n({}, e.loadingState), {
                    isLoading: !1,
                    source: a.DEFAULT_FLAGS
                })), O && "undefined" != typeof window) {
                    var R = w + "sse/environments/" + i + "/stream";
                    s ? e.eventSource || (e.log("Creating event source with url " + R), e.eventSource = new s(R), e.eventSource.addEventListener("environment_updated", function(t) {
                        var n;
                        try {
                            n = JSON.parse(t.data).updated_at;
                        } catch (t) {
                            e.log("Could not parse sse event", t);
                        }
                        n ? !e.timestamp || n > e.timestamp ? e.isLoading ? e.log("updated_at is new, but flags are loading", t.data, e.timestamp) : (e.log("updated_at is new, fetching flags", t.data, e.timestamp), e.getFlags()) : e.log("updated_at is outdated, skipping get flags", t.data, e.timestamp) : e.log("No updated_at received, fetching flags", t);
                    })) : e.log("Error, EventSource is undefined");
                }
                if (e.log("Initialising with properties", {
                    environmentID: i,
                    api: h,
                    headers: d,
                    onChange: f,
                    cacheFlags: v,
                    onError: y,
                    defaultFlags: m,
                    preventFetch: _,
                    enableLogs: E,
                    enableAnalytics: F,
                    AsyncStorage: l,
                    identity: L,
                    traits: T,
                    _trigger: k,
                    state: A,
                    angularHttpClient: D
                }, e), e.timer = e.enableLogs ? (new Date).valueOf() : null, C && (l = C), e.cacheFlags = void 0 !== l && !!v, e.setState(A), !i) throw o("Please specify a environment id"), "Please specify a environment id";
                if (p && (e.datadogRum = p), b && ("undefined" == typeof dtrum ? console.error("You have attempted to enable dynatrace but dtrum is undefined, please check you have the Dynatrace RUM JavaScript API installed.") : e.dtrum = dtrum), D && (r = function(t, e) {
                    var n = e.headers, i = e.method, a = e.body;
                    return new Promise(function(e) {
                        switch(i){
                            case "GET":
                                return D.get(t, {
                                    headers: n
                                }).subscribe(function(t) {
                                    e({
                                        ok: !0,
                                        text: function() {
                                            return Promise.resolve(t);
                                        }
                                    });
                                });
                            case "POST":
                            case "PUT":
                                return D.post(t, a, {
                                    headers: n
                                }).subscribe(function(t) {
                                    e({
                                        ok: !0,
                                        text: function() {
                                            return Promise.resolve(t);
                                        }
                                    });
                                });
                        }
                    });
                }), l && e.canUseStorage && l.getItem(c).then(function(t) {
                    if (t) try {
                        e.evaluationEvent = JSON.parse(t);
                    } catch (t) {
                        e.evaluationEvent = {};
                    }
                    else e.evaluationEvent = {};
                    return e.analyticsInterval = setInterval(e.analyticsFlags, e.ticks), !0;
                }), e.enableAnalytics && (e.analyticsInterval && clearInterval(e.analyticsInterval), l && e.canUseStorage && l.getItem(c, function(t, i) {
                    if (i) {
                        var a = JSON.parse(i);
                        a[e.environmentID] && (A = e.getState(), e.log("Retrieved events from cache", i), e.setState(n(n({}, A), {
                            evaluationEvent: a[e.environmentID]
                        })));
                    }
                    return !0;
                })), v) {
                    if (l && e.canUseStorage) {
                        var x = function(n, i) {
                            var r, s;
                            if (i) try {
                                var l = JSON.parse(i), u = !1;
                                if (l && l.api === e.api && l.environmentID === e.environmentID) {
                                    var c = !0;
                                    e.identity && l.identity !== e.identity && (e.log("Ignoring cache,  identity has changed from " + l.identity + " to " + e.identity), c = !1), e.cacheOptions.ttl && (!l.ts || (new Date).valueOf() - l.ts > e.cacheOptions.ttl) && l.ts && (e.log("Ignoring cache, timestamp is too old ts:" + l.ts + " ttl: " + e.cacheOptions.ttl + " time elapsed since cache: " + ((new Date).valueOf() - l.ts) + "ms"), c = !1), c && (u = !0, e.setState(l), e.log("Retrieved flags from cache", l));
                                }
                                if (u) {
                                    var g = !(_ || e.cacheOptions.skipAPI && u);
                                    e._onChange(null, {
                                        isFromServer: !1,
                                        flagsChanged: !0,
                                        traitsChanged: !!e.traits && !!Object.keys(e.traits).length
                                    }, e._loadedState(null, a.CACHE, g)), e.oldFlags = e.flags, t(!0), e.cacheOptions.skipAPI && u && e.log("Skipping API, using cache"), g && e.getFlags();
                                } else _ ? t(!0) : e.getFlags(t, o);
                            } catch (t) {
                                e.log("Exception fetching cached logs", t);
                            }
                            else _ ? (m ? e._onChange(null, {
                                isFromServer: !1,
                                flagsChanged: !0,
                                traitsChanged: !!e.traits && !!Object.keys(e.traits).length
                            }, e._loadedState(null, a.DEFAULT_FLAGS)) : e.flags ? null === (r = e._onChange) || void 0 === r || r.call(e, null, {
                                isFromServer: !1,
                                flagsChanged: !0,
                                traitsChanged: !!e.traits && !!Object.keys(e.traits).length
                            }, e._loadedState(null, a.DEFAULT_FLAGS)) : null === (s = e.onError) || void 0 === s || s.call(e, new Error(N)), t(!0)) : e.getFlags(t, o);
                            return !0;
                        };
                        if (l.getItemSync) try {
                            x(0, l.getItemSync(u));
                        } catch (t) {}
                        else l.getItem(u, x);
                    }
                } else if (_) {
                    if (m) null === (g = e._onChange) || void 0 === g || g.call(e, null, {
                        isFromServer: !1,
                        flagsChanged: !0,
                        traitsChanged: !!e.traits && !!Object.keys(e.traits).length
                    }, e._loadedState(null, a.DEFAULT_FLAGS));
                    else if (e.flags) {
                        var U = null;
                        0 === Object.keys(e.flags).length && (U = N), null === (I = e._onChange) || void 0 === I || I.call(e, null, {
                            isFromServer: !1,
                            flagsChanged: !0,
                            traitsChanged: !!e.traits && !!Object.keys(e.traits).length
                        }, e._loadedState(U, a.DEFAULT_FLAGS));
                    }
                    t(!0);
                } else e.getFlags(t, o);
            }).catch(function(t) {
                e.log("Error during initialisation ", t), y && y(t);
            });
        }, t.prototype._loadedState = function(t, e, n) {
            return void 0 === t && (t = null), void 0 === n && (n = !1), {
                error: t,
                isFetching: n,
                isLoading: !1,
                source: e
            };
        }, t.prototype.getAllFlags = function() {
            return this.flags;
        }, t.prototype.identify = function(t, e) {
            return this.identity = t, this.log("Identify: " + this.identity), e && (this.withTraits = n(n({}, this.withTraits || {}), e)), this.initialised ? this.getFlags() : Promise.resolve();
        }, t.prototype.getState = function() {
            return {
                api: this.api,
                environmentID: this.environmentID,
                flags: this.flags,
                identity: this.identity,
                ts: this.ts,
                traits: this.traits,
                evaluationEvent: this.evaluationEvent
            };
        }, t.prototype.setState = function(t) {
            t && (this.initialised = !0, this.api = t.api || this.api || g, this.environmentID = t.environmentID || this.environmentID, this.flags = t.flags || this.flags, this.identity = t.identity || this.identity, this.traits = t.traits || this.traits, this.withTraits = n(n({}, this.withTraits || {}), this.traits), this.evaluationEvent = t.evaluationEvent || this.evaluationEvent, this.log("setState called", this));
        }, t.prototype.log = function() {
            for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
            this.enableLogs && console.log.apply(this, i([
                "FLAGSMITH:",
                (new Date).valueOf() - (this.timer || 0),
                "ms"
            ], t, !0));
        }, t.prototype.updateStorage = function() {
            if (this.cacheFlags) {
                this.ts = (new Date).valueOf();
                var t = JSON.stringify(this.getState());
                this.log("Setting storage", t), l.setItem(u, t);
            }
        }, t.prototype.updateEventStorage = function() {
            if (this.enableAnalytics) {
                var t = JSON.stringify(this.getState().evaluationEvent);
                l.setItem(c, t);
            }
        }, t.prototype.setLoadingState = function(t) {
            var e;
            o(t, this.loadingState) || (this.loadingState = n({}, t), this.log("Loading state changed", t), null === (e = this._triggerLoadingState) || void 0 === e || e.call(this));
        }, t.prototype.logout = function() {
            return this.identity = null, this.traits = {}, this.initialised ? this.getFlags() : Promise.resolve();
        }, t.prototype.startListening = function(t) {
            void 0 === t && (t = 1e3), this.getFlagInterval && clearInterval(this.getFlagInterval), this.getFlagInterval = setInterval(this.getFlags, t);
        }, t.prototype.stopListening = function() {
            this.getFlagInterval && (clearInterval(this.getFlagInterval), this.getFlagInterval = null);
        }, t.prototype.getSegments = function() {}, t;
    }();
    function y(t) {
        var e = t.fetch, n = t.AsyncStorage, i = t.eventSource;
        return new p({
            fetch: e,
            AsyncStorage: n,
            eventSource: i
        });
    }
    var m, S = function(t, e, n) {
        var i = "shortString", a = !0;
        "number" == typeof n && (i = "javaDouble", a = !1), t[i] = t[i] || {}, t[i][e] = a ? n + "" : n;
    }, _ = (m = function(t, e) {
        return m = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }, m(t, e);
    }, function(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
        function n() {
            this.constructor = t;
        }
        m(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n);
    }), E = function(t) {
        var e = "function" == typeof Symbol && Symbol.iterator, n = e && t[e], i = 0;
        if (n) return n.call(t);
        if (t && "number" == typeof t.length) return {
            next: function() {
                return t && i >= t.length && (t = void 0), {
                    value: t && t[i++],
                    done: !t
                };
            }
        };
        throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }, b = function(t, e) {
        var n = "function" == typeof Symbol && t[Symbol.iterator];
        if (!n) return t;
        var i, a, r = n.call(t), o = [];
        try {
            for(; (void 0 === e || e-- > 0) && !(i = r.next()).done;)o.push(i.value);
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (n = r.return) && n.call(r);
            } finally{
                if (a) throw a.error;
            }
        }
        return o;
    }, F = function(t, e, n) {
        if (n || 2 === arguments.length) for(var i, a = 0, r = e.length; a < r; a++)!i && a in e || (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
        return t.concat(i || Array.prototype.slice.call(e));
    }, O = function(t) {
        function e() {
            return t.call(this, "EventSource not available.\nConsider loading an EventSource polyfill and making it available globally as EventSource, or passing one in as eventSourceClass to the ReconnectingEventSource constructor.") || this;
        }
        return _(e, t), e;
    }(Error), I = function() {
        function t(t, e) {
            var n = this;
            if (this.CONNECTING = 0, this.OPEN = 1, this.CLOSED = 2, this._configuration = null != e ? Object.assign({}, e) : void 0, this.withCredentials = !1, this._eventSource = null, this._lastEventId = null, this._timer = null, this._listeners = {
                open: [],
                error: [],
                message: []
            }, this.url = t.toString(), this.readyState = this.CONNECTING, this.max_retry_time = 3e3, this.eventSourceClass = globalThis.FlagsmithEventSource, null != this._configuration && (this._configuration.lastEventId && (this._lastEventId = this._configuration.lastEventId, delete this._configuration.lastEventId), this._configuration.max_retry_time && (this.max_retry_time = this._configuration.max_retry_time, delete this._configuration.max_retry_time), this._configuration.eventSourceClass && (this.eventSourceClass = this._configuration.eventSourceClass, delete this._configuration.eventSourceClass)), null == this.eventSourceClass || "function" != typeof this.eventSourceClass) throw new O;
            this._onevent_wrapped = function(t) {
                n._onevent(t);
            }, this._start();
        }
        return t.prototype.dispatchEvent = function(t) {
            throw new Error("Method not implemented.");
        }, t.prototype._start = function() {
            var t, e, n = this, i = this.url;
            this._lastEventId && (-1 === i.indexOf("?") ? i += "?" : i += "&", i += "lastEventId=" + encodeURIComponent(this._lastEventId)), this._eventSource = new this.eventSourceClass(i, this._configuration), this._eventSource.onopen = function(t) {
                n._onopen(t);
            }, this._eventSource.onerror = function(t) {
                n._onerror(t);
            }, this._eventSource.onmessage = function(t) {
                n.onmessage(t);
            };
            try {
                for(var a = E(Object.keys(this._listeners)), r = a.next(); !r.done; r = a.next()){
                    var o = r.value;
                    this._eventSource.addEventListener(o, this._onevent_wrapped);
                }
            } catch (e) {
                t = {
                    error: e
                };
            } finally{
                try {
                    r && !r.done && (e = a.return) && e.call(a);
                } finally{
                    if (t) throw t.error;
                }
            }
        }, t.prototype._onopen = function(t) {
            0 === this.readyState && (this.readyState = 1, this.onopen(t));
        }, t.prototype._onerror = function(t) {
            var e = this;
            if (1 === this.readyState && (this.readyState = 0, this.onerror(t)), this._eventSource) {
                this._eventSource.close(), this._eventSource = null;
                var n = Math.round(this.max_retry_time * Math.random());
                this._timer = setTimeout(function() {
                    return e._start();
                }, n);
            }
        }, t.prototype._onevent = function(t) {
            var e, n;
            t && t.lastEventId && (this._lastEventId = t.lastEventId);
            var i = this._listeners[t.type];
            if (null != i) try {
                for(var a = E(F([], b(i), !1)), r = a.next(); !r.done; r = a.next())r.value.call(this, t);
            } catch (t) {
                e = {
                    error: t
                };
            } finally{
                try {
                    r && !r.done && (n = a.return) && n.call(a);
                } finally{
                    if (e) throw e.error;
                }
            }
            "message" === t.type && this.onmessage(t);
        }, t.prototype.onopen = function(t) {}, t.prototype.onerror = function(t) {}, t.prototype.onmessage = function(t) {}, t.prototype.close = function() {
            this._timer && (clearTimeout(this._timer), this._timer = null), this._eventSource && (this._eventSource.close(), this._eventSource = null), this.readyState = 2;
        }, t.prototype.addEventListener = function(t, e, n) {
            null == this._listeners[t] && (this._listeners[t] = [], null != this._eventSource && this._eventSource.addEventListener(t, this._onevent_wrapped));
            var i = this._listeners[t];
            i.includes(e) || (this._listeners[t] = F(F([], b(i), !1), [
                e
            ], !1));
        }, t.prototype.removeEventListener = function(t, e, n) {
            var i = this._listeners[t];
            this._listeners[t] = i.filter(function(t) {
                return t !== e;
            });
        }, t;
    }();
    globalThis.FlagsmithEventSource = "undefined" != typeof EventSource ? EventSource : null;
    var w = function(t, e) {
        return e = e || {}, new Promise(function(n, i) {
            var a = new XMLHttpRequest, r = [], o = [], s = {}, l = function() {
                return {
                    ok: 2 == (a.status / 100 | 0),
                    statusText: a.statusText,
                    status: a.status,
                    url: a.responseURL,
                    text: function() {
                        return Promise.resolve(a.responseText);
                    },
                    json: function() {
                        return Promise.resolve(a.responseText).then(JSON.parse);
                    },
                    blob: function() {
                        return Promise.resolve(new Blob([
                            a.response
                        ]));
                    },
                    clone: l,
                    headers: {
                        keys: function() {
                            return r;
                        },
                        entries: function() {
                            return o;
                        },
                        get: function(t) {
                            return s[t.toLowerCase()];
                        },
                        has: function(t) {
                            return t.toLowerCase() in s;
                        }
                    }
                };
            };
            for(var u in a.open(e.method || "get", t, !0), a.onload = function() {
                a.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(t, e, n) {
                    r.push(e = e.toLowerCase()), o.push([
                        e,
                        n
                    ]), s[e] = s[e] ? s[e] + "," + n : n;
                }), n(l());
            }, a.onerror = i, a.withCredentials = "include" == e.credentials, e.headers)a.setRequestHeader(u, e.headers[u]);
            a.send(e.body || null);
        });
    }, C = y({
        AsyncStorage: e,
        fetch: w,
        eventSource: I
    });
    "undefined" != typeof window && (window.flagsmith = C);
    t.createFlagsmithInstance = function() {
        return y({
            AsyncStorage: e,
            fetch: w,
            eventSource: I
        });
    }, t.default = C, Object.defineProperty(t, "__esModule", {
        value: !0
    });
});



var $jsVqW = parcelRequire("jsVqW");

"use client";
var $2b128a2eefa7ab64$export$fd1469cb3147d866 = function() {
    return null;
};



var $r2uF6 = parcelRequire("r2uF6");

var $bCeTl = parcelRequire("bCeTl");
parcelRequire("gCemA");
var $7gcOJ = parcelRequire("7gcOJ");
var $fp4OM = parcelRequire("fp4OM");
var $fuEBT = parcelRequire("fuEBT");

var $ayMG0 = parcelRequire("ayMG0");

var $8LEhm = parcelRequire("8LEhm");
parcelRequire("18L7n");
var $5Ttm9 = parcelRequire("5Ttm9");
parcelRequire("gCemA");
var $fp4OM = parcelRequire("fp4OM");

var $bCeTl = parcelRequire("bCeTl");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");
function $4852138d3358a29b$var$SignupRedirect() {
    const { loginWithRedirect: loginWithRedirect } = (0, $bCeTl.useAuth0)();
    const { params: params } = (0, $fp4OM.useRouter)();
    (0, $acw62.useEffect)(()=>{
        if (params.role === "company") loginWithRedirect({
            authorizationParams: {
                redirect_uri: "https://icm.humcapital.com" + `/post-signup/${(0, $8LEhm.UserRole).COMPANY}`,
                screen_hint: "signup"
            }
        });
        else if (params.role === "fund") loginWithRedirect({
            authorizationParams: {
                redirect_uri: "https://icm.humcapital.com" + `/post-signup/${(0, $8LEhm.UserRole).FUND}`,
                screen_hint: "signup"
            }
        });
    }, [
        params.role,
        loginWithRedirect
    ]);
    if (!params.role || ![
        "company",
        "fund"
    ].includes(params.role)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: "/raise-or-invest"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {
        fullScreen: true
    });
}
var $4852138d3358a29b$export$2e2bcd8739ae039 = $4852138d3358a29b$var$SignupRedirect;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("tL0U5");
var $4CoXh = parcelRequire("4CoXh");
parcelRequire("hb9Mc");
var $bxDk4 = parcelRequire("bxDk4");

var $YHMTU = parcelRequire("YHMTU");
parcelRequire("18L7n");
var $ddmfx = parcelRequire("ddmfx");
var $5Ttm9 = parcelRequire("5Ttm9");
parcelRequire("ct56T");
var $edg5W = parcelRequire("edg5W");

var $aphAM = parcelRequire("aphAM");

var $acw62 = parcelRequire("acw62");

var $1ii2J = parcelRequire("1ii2J");

var $6kDFU = parcelRequire("6kDFU");
function $18d2414bb50b9c4b$export$2e2bcd8739ae039() {
    const [emailSent, setEmailSent] = (0, $1ii2J.useAtom)((0, $6kDFU.emailSentAtom));
    const { mutate: resendInvitationMail, isPending: isPending } = (0, $4CoXh.useApiMutation)((0, $bxDk4.resendInvite));
    const session = (0, $edg5W.useSession)();
    const email = session.user?.email;
    (0, $acw62.useEffect)(()=>{
        if (!emailSent) {
            resendInvitationMail();
            setEmailSent(true);
        }
    }, [
        emailSent
    ]);
    if (!session.user) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: "/login"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $YHMTU.Onboarding).Layout, {
        centered: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex max-w-xl flex-col gap-10",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddmfx.Illustration).VerifyEmail, {
                    className: "mx-auto mt-0 size-48"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-center",
                    children: "Activate your account"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "subdued text-center",
                    children: [
                        "We\u2019ve sent an activation email to ",
                        email,
                        ". Click the link inside to continue."
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    className: "xl w-full",
                    onClick: ()=>resendInvitationMail(),
                    disabled: isPending,
                    children: [
                        isPending ? "Sending" : "Resend Email",
                        isPending && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ttm9.Spinner), {})
                    ]
                })
            ]
        })
    });
}



var $cM7aN = parcelRequire("cM7aN");
(0, $cM7aN.LicenseManager).setLicenseKey("");
const $2f3aa70b333861bb$var$flagsmithOptions = {
    environmentID: "GcUDZxo8iKpuUZpEajso2i",
    api: "https://flagsmith-edge-proxy.humcapital.com/api/v1/",
    datadogRum: {
        client: (0, $cNbKI.datadogRum),
        trackTraits: true
    },
    headers: {
        "x-environment-key": "GcUDZxo8iKpuUZpEajso2i"
    }
};
let $2f3aa70b333861bb$var$cookieDomain = ".localhost";
$2f3aa70b333861bb$var$cookieDomain = ".humcapital.com";
function $2f3aa70b333861bb$var$MainApp() {
    const router = (0, $fp4OM.useRouter)();
    const flags = (0, $7gcOJ.useFlags)();
    const banner = flags.enabled("maintenance-banner") ? flags.value("maintenance-banner") : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bCeTl.Auth0Provider), {
                domain: "auth.humcapital.com",
                clientId: "tA6HmbsuvMev4QUru5KiWPGjcUSHLxFw",
                authorizationParams: {
                    audience: "https://api2.humcapital.com"
                },
                useRefreshTokensFallback: true,
                useRefreshTokens: true,
                cookieDomain: $2f3aa70b333861bb$var$cookieDomain,
                onRedirectCallback: ()=>{
                    router.navigate(router.asPath);
                },
                children: [
                    flags.enabled("maintenance-banner") && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jg6kN.MaintenanceBanner), {
                        title: banner?.title,
                        message: banner?.message
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Routes), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/login",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $au8D6.default), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/raise-or-invest",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7vE2c.default), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/signup/:role",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4852138d3358a29b$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/post-signup/:role",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1bRue.default), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/signup-complete",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7EKKo.default), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/complete-invitation",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18d2414bb50b9c4b$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/error",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gMxRY.default), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/logout",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bBFEN.default), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/public/:token",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gXZ39.default), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/reset-password",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $GnB8W.default), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "/legacy",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fuEBT.V1RedirectWithPath), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                path: "*",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5e409635bd55b90a$export$8a2bf06fbae4dde), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3oOMC.ToastProvider), {})
        ]
    });
}
function $2f3aa70b333861bb$export$35b4f62b8f8d707c() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f19YE.QueryClientProvider), {
        client: (0, $eX6Sv.queryClient),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $r2uF6.Provider), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jsVqW.FlagsmithProvider), {
                    options: $2f3aa70b333861bb$var$flagsmithOptions,
                    flagsmith: (0, (/*@__PURE__*/$parcel$interopDefault($91137b2f1e15c24d$exports))),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($2f3aa70b333861bb$var$MainApp, {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b128a2eefa7ab64$export$fd1469cb3147d866), {
                    initialIsOpen: false
                })
            ]
        })
    });
}


parcelRequire("gCemA");
var $hytaM = parcelRequire("hytaM");

var $lzNIT = parcelRequire("lzNIT");
var $630dda8d81b1b9e8$exports = {};

$parcel$export($630dda8d81b1b9e8$exports, "config", () => $630dda8d81b1b9e8$export$e506a1d27d1eaa20, (v) => $630dda8d81b1b9e8$export$e506a1d27d1eaa20 = v);
$parcel$export($630dda8d81b1b9e8$exports, "parse", () => $630dda8d81b1b9e8$export$98e6a39c04603d36, (v) => $630dda8d81b1b9e8$export$98e6a39c04603d36 = v);
/* @flow */ /*::

type DotenvParseOptions = {
  debug?: boolean
}

// keys and values from src
type DotenvParseOutput = { [string]: string }

type DotenvConfigOptions = {
  path?: string, // path to .env file
  encoding?: string, // encoding of .env file
  debug?: string // turn on logging for debugging purposes
}

type DotenvConfigOutput = {
  parsed?: DotenvParseOutput,
  error?: Error
}

*/ var $630dda8d81b1b9e8$export$e506a1d27d1eaa20;
var $630dda8d81b1b9e8$export$98e6a39c04603d36;

var $hPtJY = parcelRequire("hPtJY");
var $eca075ad100d834d$exports = {};
"use strict";



var $59kwG = parcelRequire("59kwG");
function $630dda8d81b1b9e8$var$log(message /*: string */ ) {
    console.log(`[dotenv][DEBUG] ${message}`);
}
const $630dda8d81b1b9e8$var$NEWLINE = "\n";
const $630dda8d81b1b9e8$var$RE_INI_KEY_VAL = /^\s*([\w.-]+)\s*=\s*(.*)?\s*$/;
const $630dda8d81b1b9e8$var$RE_NEWLINES = /\\n/g;
// Parses src into an Object
function $630dda8d81b1b9e8$var$parse(src /*: string | Buffer */ , options /*: ?DotenvParseOptions */ ) /*: DotenvParseOutput */ {
    const debug = Boolean(options && options.debug);
    const obj = {};
    // convert Buffers before splitting into lines and processing
    src.toString().split($630dda8d81b1b9e8$var$NEWLINE).forEach(function(line, idx) {
        // matching "KEY' and 'VAL' in 'KEY=VAL'
        const keyValueArr = line.match($630dda8d81b1b9e8$var$RE_INI_KEY_VAL);
        // matched?
        if (keyValueArr != null) {
            const key = keyValueArr[1];
            // default undefined or missing values to empty string
            let val = keyValueArr[2] || "";
            const end = val.length - 1;
            const isDoubleQuoted = val[0] === '"' && val[end] === '"';
            const isSingleQuoted = val[0] === "'" && val[end] === "'";
            // if single or double quoted, remove quotes
            if (isSingleQuoted || isDoubleQuoted) {
                val = val.substring(1, end);
                // if double quoted, expand newlines
                if (isDoubleQuoted) val = val.replace($630dda8d81b1b9e8$var$RE_NEWLINES, $630dda8d81b1b9e8$var$NEWLINE);
            } else // remove surrounding whitespace
            val = val.trim();
            obj[key] = val;
        } else if (debug) $630dda8d81b1b9e8$var$log(`did not match key and value when parsing line ${idx + 1}: ${line}`);
    });
    return obj;
}
// Populates process.env from .env file
function $630dda8d81b1b9e8$var$config(options /*: ?DotenvConfigOptions */ ) /*: DotenvConfigOutput */ {
    let dotenvPath = $59kwG.resolve($hPtJY.cwd(), ".env");
    let encoding /*: string */  = "utf8";
    let debug = false;
    if (options) {
        if (options.path != null) dotenvPath = options.path;
        if (options.encoding != null) encoding = options.encoding;
        if (options.debug != null) debug = true;
    }
    try {
        // specifying an encoding returns a string instead of a buffer
        const parsed = $630dda8d81b1b9e8$var$parse($eca075ad100d834d$exports.readFileSync(dotenvPath, {
            encoding: encoding
        }), {
            debug: debug
        });
        Object.keys(parsed).forEach(function(key) {
            if (!$hPtJY.env.hasOwnProperty(key)) parsed[key];
            else if (debug) $630dda8d81b1b9e8$var$log(`"${key}" is already defined in \`process.env\` and will not be overwritten`);
        });
        return {
            parsed: parsed
        };
    } catch (e) {
        return {
            error: e
        };
    }
}
$630dda8d81b1b9e8$export$e506a1d27d1eaa20 = $630dda8d81b1b9e8$var$config;
$630dda8d81b1b9e8$export$98e6a39c04603d36 = $630dda8d81b1b9e8$var$parse;



(0, (/*@__PURE__*/$parcel$interopDefault($630dda8d81b1b9e8$exports))).config();
(0, $hytaM.initDataDog)();
const $f0ac962085336ba4$var$container = document.getElementById("app");
if ($f0ac962085336ba4$var$container) {
    const root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($f0ac962085336ba4$var$container);
    root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.BrowserRouter), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f3aa70b333861bb$export$35b4f62b8f8d707c), {})
    }));
}


//# sourceMappingURL=index.db00ea9e.js.map
